
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireabba"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireabba"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("1b2ls", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $0db8a335f84591c1$export$ffb0004e005737fa, (v) => $0db8a335f84591c1$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $0db8a335f84591c1$export$34b9dba7ce09269b, (v) => $0db8a335f84591c1$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $0db8a335f84591c1$export$25062201e9e25d76, (v) => $0db8a335f84591c1$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0db8a335f84591c1$export$ffb0004e005737fa;
var $0db8a335f84591c1$export$34b9dba7ce09269b;
var $0db8a335f84591c1$export$25062201e9e25d76;
"use strict";

var $acw62 = parcelRequire("acw62");
var $0db8a335f84591c1$var$k = Symbol.for("react.element"), $0db8a335f84591c1$var$l = Symbol.for("react.fragment"), $0db8a335f84591c1$var$m = Object.prototype.hasOwnProperty, $0db8a335f84591c1$var$n = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $0db8a335f84591c1$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $0db8a335f84591c1$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$0db8a335f84591c1$var$m.call(a, b) && !$0db8a335f84591c1$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $0db8a335f84591c1$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $0db8a335f84591c1$var$n.current
    };
}
$0db8a335f84591c1$export$ffb0004e005737fa = $0db8a335f84591c1$var$l;
$0db8a335f84591c1$export$34b9dba7ce09269b = $0db8a335f84591c1$var$q;
$0db8a335f84591c1$export$25062201e9e25d76 = $0db8a335f84591c1$var$q;

});
parcelRegister("acw62", function(module, exports) {
"use strict";

module.exports = (parcelRequire("2pUnB"));

});
parcelRegister("2pUnB", function(module, exports) {

$parcel$export(module.exports, "Children", () => $1c29a66706a62afd$export$dca3b0875bd9a954, (v) => $1c29a66706a62afd$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $1c29a66706a62afd$export$16fa2f45be04daa8, (v) => $1c29a66706a62afd$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $1c29a66706a62afd$export$ffb0004e005737fa, (v) => $1c29a66706a62afd$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $1c29a66706a62afd$export$e2c29f18771995cb, (v) => $1c29a66706a62afd$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $1c29a66706a62afd$export$221d75b3f55bb0bd, (v) => $1c29a66706a62afd$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $1c29a66706a62afd$export$5f8d39834fd61797, (v) => $1c29a66706a62afd$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $1c29a66706a62afd$export$74bf444e3cd11ea5, (v) => $1c29a66706a62afd$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $1c29a66706a62afd$export$ae55be85d98224ed, (v) => $1c29a66706a62afd$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "cloneElement", () => $1c29a66706a62afd$export$e530037191fcd5d7, (v) => $1c29a66706a62afd$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $1c29a66706a62afd$export$fd42f52fd3ae1109, (v) => $1c29a66706a62afd$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $1c29a66706a62afd$export$c8a8987d4410bf2d, (v) => $1c29a66706a62afd$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $1c29a66706a62afd$export$d38cd72104c1f0e9, (v) => $1c29a66706a62afd$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $1c29a66706a62afd$export$7d1e3a5e95ceca43, (v) => $1c29a66706a62afd$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $1c29a66706a62afd$export$257a8862b851cb5b, (v) => $1c29a66706a62afd$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $1c29a66706a62afd$export$a8257692ac88316c, (v) => $1c29a66706a62afd$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $1c29a66706a62afd$export$488013bae63b21da, (v) => $1c29a66706a62afd$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $1c29a66706a62afd$export$7c73462e0d25e514, (v) => $1c29a66706a62afd$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $1c29a66706a62afd$export$7568632d0d33d16d, (v) => $1c29a66706a62afd$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $1c29a66706a62afd$export$88948ce120ea2619, (v) => $1c29a66706a62afd$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $1c29a66706a62afd$export$35808ee640e87ca7, (v) => $1c29a66706a62afd$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $1c29a66706a62afd$export$fae74005e78b1a27, (v) => $1c29a66706a62afd$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $1c29a66706a62afd$export$dc8fbce3eb94dc1e, (v) => $1c29a66706a62afd$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $1c29a66706a62afd$export$6a7bc4e911dc01cf, (v) => $1c29a66706a62afd$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $1c29a66706a62afd$export$6d9c69b0de29b591, (v) => $1c29a66706a62afd$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $1c29a66706a62afd$export$f680877a34711e37, (v) => $1c29a66706a62afd$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $1c29a66706a62afd$export$d5a552a76deda3c2, (v) => $1c29a66706a62afd$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $1c29a66706a62afd$export$aaabe4eda9ed9969, (v) => $1c29a66706a62afd$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $1c29a66706a62afd$export$e5c5a5f917a5871c, (v) => $1c29a66706a62afd$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $1c29a66706a62afd$export$1538c33de8887b59, (v) => $1c29a66706a62afd$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $1c29a66706a62afd$export$13e3392192263954, (v) => $1c29a66706a62afd$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $1c29a66706a62afd$export$b8f5890fc79d6aca, (v) => $1c29a66706a62afd$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $1c29a66706a62afd$export$60241385465d0a34, (v) => $1c29a66706a62afd$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $1c29a66706a62afd$export$306c0aa65ff9ec16, (v) => $1c29a66706a62afd$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $1c29a66706a62afd$export$7b286972b8d8ccbf, (v) => $1c29a66706a62afd$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $1c29a66706a62afd$export$83d89fbfd8236492, (v) => $1c29a66706a62afd$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1c29a66706a62afd$export$dca3b0875bd9a954;
var $1c29a66706a62afd$export$16fa2f45be04daa8;
var $1c29a66706a62afd$export$ffb0004e005737fa;
var $1c29a66706a62afd$export$e2c29f18771995cb;
var $1c29a66706a62afd$export$221d75b3f55bb0bd;
var $1c29a66706a62afd$export$5f8d39834fd61797;
var $1c29a66706a62afd$export$74bf444e3cd11ea5;
var $1c29a66706a62afd$export$ae55be85d98224ed;
var $1c29a66706a62afd$export$e530037191fcd5d7;
var $1c29a66706a62afd$export$fd42f52fd3ae1109;
var $1c29a66706a62afd$export$c8a8987d4410bf2d;
var $1c29a66706a62afd$export$d38cd72104c1f0e9;
var $1c29a66706a62afd$export$7d1e3a5e95ceca43;
var $1c29a66706a62afd$export$257a8862b851cb5b;
var $1c29a66706a62afd$export$a8257692ac88316c;
var $1c29a66706a62afd$export$488013bae63b21da;
var $1c29a66706a62afd$export$7c73462e0d25e514;
var $1c29a66706a62afd$export$7568632d0d33d16d;
var $1c29a66706a62afd$export$88948ce120ea2619;
var $1c29a66706a62afd$export$35808ee640e87ca7;
var $1c29a66706a62afd$export$fae74005e78b1a27;
var $1c29a66706a62afd$export$dc8fbce3eb94dc1e;
var $1c29a66706a62afd$export$6a7bc4e911dc01cf;
var $1c29a66706a62afd$export$6d9c69b0de29b591;
var $1c29a66706a62afd$export$f680877a34711e37;
var $1c29a66706a62afd$export$d5a552a76deda3c2;
var $1c29a66706a62afd$export$aaabe4eda9ed9969;
var $1c29a66706a62afd$export$e5c5a5f917a5871c;
var $1c29a66706a62afd$export$1538c33de8887b59;
var $1c29a66706a62afd$export$13e3392192263954;
var $1c29a66706a62afd$export$b8f5890fc79d6aca;
var $1c29a66706a62afd$export$60241385465d0a34;
var $1c29a66706a62afd$export$306c0aa65ff9ec16;
var $1c29a66706a62afd$export$7b286972b8d8ccbf;
var $1c29a66706a62afd$export$83d89fbfd8236492;
"use strict";
var $1c29a66706a62afd$var$l = Symbol.for("react.element"), $1c29a66706a62afd$var$n = Symbol.for("react.portal"), $1c29a66706a62afd$var$p = Symbol.for("react.fragment"), $1c29a66706a62afd$var$q = Symbol.for("react.strict_mode"), $1c29a66706a62afd$var$r = Symbol.for("react.profiler"), $1c29a66706a62afd$var$t = Symbol.for("react.provider"), $1c29a66706a62afd$var$u = Symbol.for("react.context"), $1c29a66706a62afd$var$v = Symbol.for("react.forward_ref"), $1c29a66706a62afd$var$w = Symbol.for("react.suspense"), $1c29a66706a62afd$var$x = Symbol.for("react.memo"), $1c29a66706a62afd$var$y = Symbol.for("react.lazy"), $1c29a66706a62afd$var$z = Symbol.iterator;
function $1c29a66706a62afd$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $1c29a66706a62afd$var$z && a[$1c29a66706a62afd$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $1c29a66706a62afd$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $1c29a66706a62afd$var$C = Object.assign, $1c29a66706a62afd$var$D = {};
function $1c29a66706a62afd$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
$1c29a66706a62afd$var$E.prototype.isReactComponent = {};
$1c29a66706a62afd$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$1c29a66706a62afd$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $1c29a66706a62afd$var$F() {}
$1c29a66706a62afd$var$F.prototype = $1c29a66706a62afd$var$E.prototype;
function $1c29a66706a62afd$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
var $1c29a66706a62afd$var$H = $1c29a66706a62afd$var$G.prototype = new $1c29a66706a62afd$var$F;
$1c29a66706a62afd$var$H.constructor = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$var$C($1c29a66706a62afd$var$H, $1c29a66706a62afd$var$E.prototype);
$1c29a66706a62afd$var$H.isPureReactComponent = !0;
var $1c29a66706a62afd$var$I = Array.isArray, $1c29a66706a62afd$var$J = Object.prototype.hasOwnProperty, $1c29a66706a62afd$var$K = {
    current: null
}, $1c29a66706a62afd$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $1c29a66706a62afd$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$1c29a66706a62afd$var$J.call(b, d) && !$1c29a66706a62afd$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $1c29a66706a62afd$var$K.current
    };
}
function $1c29a66706a62afd$var$N(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $1c29a66706a62afd$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $1c29a66706a62afd$var$l;
}
function $1c29a66706a62afd$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $1c29a66706a62afd$var$P = /\/+/g;
function $1c29a66706a62afd$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $1c29a66706a62afd$var$escape("" + a.key) : b.toString(36);
}
function $1c29a66706a62afd$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $1c29a66706a62afd$var$l:
                case $1c29a66706a62afd$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $1c29a66706a62afd$var$Q(h, 0) : d, $1c29a66706a62afd$var$I(c) ? (e = "", null != a && (e = a.replace($1c29a66706a62afd$var$P, "$&/") + "/"), $1c29a66706a62afd$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($1c29a66706a62afd$var$O(c) && (c = $1c29a66706a62afd$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($1c29a66706a62afd$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($1c29a66706a62afd$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $1c29a66706a62afd$var$Q(k, g);
        h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    }
    else if (f = $1c29a66706a62afd$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $1c29a66706a62afd$var$Q(k, g++), h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $1c29a66706a62afd$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $1c29a66706a62afd$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $1c29a66706a62afd$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $1c29a66706a62afd$var$U = {
    current: null
}, $1c29a66706a62afd$var$V = {
    transition: null
}, $1c29a66706a62afd$var$W = {
    ReactCurrentDispatcher: $1c29a66706a62afd$var$U,
    ReactCurrentBatchConfig: $1c29a66706a62afd$var$V,
    ReactCurrentOwner: $1c29a66706a62afd$var$K
};
$1c29a66706a62afd$export$dca3b0875bd9a954 = {
    map: $1c29a66706a62afd$var$S,
    forEach: function(a, b, e) {
        $1c29a66706a62afd$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $1c29a66706a62afd$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $1c29a66706a62afd$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$1c29a66706a62afd$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$1c29a66706a62afd$export$16fa2f45be04daa8 = $1c29a66706a62afd$var$E;
$1c29a66706a62afd$export$ffb0004e005737fa = $1c29a66706a62afd$var$p;
$1c29a66706a62afd$export$e2c29f18771995cb = $1c29a66706a62afd$var$r;
$1c29a66706a62afd$export$221d75b3f55bb0bd = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$export$5f8d39834fd61797 = $1c29a66706a62afd$var$q;
$1c29a66706a62afd$export$74bf444e3cd11ea5 = $1c29a66706a62afd$var$w;
$1c29a66706a62afd$export$ae55be85d98224ed = $1c29a66706a62afd$var$W;
$1c29a66706a62afd$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $1c29a66706a62afd$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $1c29a66706a62afd$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$1c29a66706a62afd$var$J.call(b, f) && !$1c29a66706a62afd$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$1c29a66706a62afd$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $1c29a66706a62afd$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $1c29a66706a62afd$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$1c29a66706a62afd$export$c8a8987d4410bf2d = $1c29a66706a62afd$var$M;
$1c29a66706a62afd$export$d38cd72104c1f0e9 = function(a) {
    var b = $1c29a66706a62afd$var$M.bind(null, a);
    b.type = a;
    return b;
};
$1c29a66706a62afd$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$1c29a66706a62afd$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$v,
        render: a
    };
};
$1c29a66706a62afd$export$a8257692ac88316c = $1c29a66706a62afd$var$O;
$1c29a66706a62afd$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $1c29a66706a62afd$var$T
    };
};
$1c29a66706a62afd$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$1c29a66706a62afd$export$7568632d0d33d16d = function(a) {
    var b = $1c29a66706a62afd$var$V.transition;
    $1c29a66706a62afd$var$V.transition = {};
    try {
        a();
    } finally{
        $1c29a66706a62afd$var$V.transition = b;
    }
};
$1c29a66706a62afd$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$1c29a66706a62afd$export$35808ee640e87ca7 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useCallback(a, b);
};
$1c29a66706a62afd$export$fae74005e78b1a27 = function(a) {
    return $1c29a66706a62afd$var$U.current.useContext(a);
};
$1c29a66706a62afd$export$dc8fbce3eb94dc1e = function() {};
$1c29a66706a62afd$export$6a7bc4e911dc01cf = function(a) {
    return $1c29a66706a62afd$var$U.current.useDeferredValue(a);
};
$1c29a66706a62afd$export$6d9c69b0de29b591 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useEffect(a, b);
};
$1c29a66706a62afd$export$f680877a34711e37 = function() {
    return $1c29a66706a62afd$var$U.current.useId();
};
$1c29a66706a62afd$export$d5a552a76deda3c2 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useImperativeHandle(a, b, e);
};
$1c29a66706a62afd$export$aaabe4eda9ed9969 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useInsertionEffect(a, b);
};
$1c29a66706a62afd$export$e5c5a5f917a5871c = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useLayoutEffect(a, b);
};
$1c29a66706a62afd$export$1538c33de8887b59 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useMemo(a, b);
};
$1c29a66706a62afd$export$13e3392192263954 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useReducer(a, b, e);
};
$1c29a66706a62afd$export$b8f5890fc79d6aca = function(a) {
    return $1c29a66706a62afd$var$U.current.useRef(a);
};
$1c29a66706a62afd$export$60241385465d0a34 = function(a) {
    return $1c29a66706a62afd$var$U.current.useState(a);
};
$1c29a66706a62afd$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useSyncExternalStore(a, b, e);
};
$1c29a66706a62afd$export$7b286972b8d8ccbf = function() {
    return $1c29a66706a62afd$var$U.current.useTransition();
};
$1c29a66706a62afd$export$83d89fbfd8236492 = "18.2.0";

});



parcelRegister("Xw6Mv", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $0b2e6adb871a3b94$export$ae55be85d98224ed, (v) => $0b2e6adb871a3b94$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $0b2e6adb871a3b94$export$d39a5bbd09211389, (v) => $0b2e6adb871a3b94$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $0b2e6adb871a3b94$export$882461b6382ed46c, (v) => $0b2e6adb871a3b94$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $0b2e6adb871a3b94$export$466bfc07425424d5, (v) => $0b2e6adb871a3b94$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4, (v) => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $0b2e6adb871a3b94$export$fa8d919ba61d84db, (v) => $0b2e6adb871a3b94$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $0b2e6adb871a3b94$export$757ceba2d55c277e, (v) => $0b2e6adb871a3b94$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $0b2e6adb871a3b94$export$b3890eb0ae9dca99, (v) => $0b2e6adb871a3b94$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $0b2e6adb871a3b94$export$502457920280e6be, (v) => $0b2e6adb871a3b94$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $0b2e6adb871a3b94$export$c78a37762a8d58e1, (v) => $0b2e6adb871a3b94$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $0b2e6adb871a3b94$export$dc54d992c10e8a18, (v) => $0b2e6adb871a3b94$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $0b2e6adb871a3b94$export$83d89fbfd8236492, (v) => $0b2e6adb871a3b94$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $0b2e6adb871a3b94$export$ae55be85d98224ed;
var $0b2e6adb871a3b94$export$d39a5bbd09211389;
var $0b2e6adb871a3b94$export$882461b6382ed46c;
var $0b2e6adb871a3b94$export$466bfc07425424d5;
var $0b2e6adb871a3b94$export$cd75ccfd720a3cd4;
var $0b2e6adb871a3b94$export$fa8d919ba61d84db;
var $0b2e6adb871a3b94$export$757ceba2d55c277e;
var $0b2e6adb871a3b94$export$b3890eb0ae9dca99;
var $0b2e6adb871a3b94$export$502457920280e6be;
var $0b2e6adb871a3b94$export$c78a37762a8d58e1;
var $0b2e6adb871a3b94$export$dc54d992c10e8a18;
var $0b2e6adb871a3b94$export$83d89fbfd8236492;
"use strict";

var $acw62 = parcelRequire("acw62");

var $fO90s = parcelRequire("fO90s");
function $0b2e6adb871a3b94$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $0b2e6adb871a3b94$var$da = new Set, $0b2e6adb871a3b94$var$ea = {};
function $0b2e6adb871a3b94$var$fa(a, b) {
    $0b2e6adb871a3b94$var$ha(a, b);
    $0b2e6adb871a3b94$var$ha(a + "Capture", b);
}
function $0b2e6adb871a3b94$var$ha(a, b) {
    $0b2e6adb871a3b94$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$da.add(b[a]);
}
var $0b2e6adb871a3b94$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $0b2e6adb871a3b94$var$ja = Object.prototype.hasOwnProperty, $0b2e6adb871a3b94$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $0b2e6adb871a3b94$var$la = {}, $0b2e6adb871a3b94$var$ma = {};
function $0b2e6adb871a3b94$var$oa(a) {
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$ma, a)) return !0;
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$la, a)) return !1;
    if ($0b2e6adb871a3b94$var$ka.test(a)) return $0b2e6adb871a3b94$var$ma[a] = !0;
    $0b2e6adb871a3b94$var$la[a] = !0;
    return !1;
}
function $0b2e6adb871a3b94$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $0b2e6adb871a3b94$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $0b2e6adb871a3b94$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $0b2e6adb871a3b94$var$ra = /[\-:]([a-z])/g;
function $0b2e6adb871a3b94$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$0b2e6adb871a3b94$var$z.xlinkHref = new $0b2e6adb871a3b94$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $0b2e6adb871a3b94$var$ta(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$z.hasOwnProperty(b) ? $0b2e6adb871a3b94$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $0b2e6adb871a3b94$var$qa(b, c, e, d) && (c = null), d || null === e ? $0b2e6adb871a3b94$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $0b2e6adb871a3b94$var$ua = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $0b2e6adb871a3b94$var$va = Symbol.for("react.element"), $0b2e6adb871a3b94$var$wa = Symbol.for("react.portal"), $0b2e6adb871a3b94$var$ya = Symbol.for("react.fragment"), $0b2e6adb871a3b94$var$za = Symbol.for("react.strict_mode"), $0b2e6adb871a3b94$var$Aa = Symbol.for("react.profiler"), $0b2e6adb871a3b94$var$Ba = Symbol.for("react.provider"), $0b2e6adb871a3b94$var$Ca = Symbol.for("react.context"), $0b2e6adb871a3b94$var$Da = Symbol.for("react.forward_ref"), $0b2e6adb871a3b94$var$Ea = Symbol.for("react.suspense"), $0b2e6adb871a3b94$var$Fa = Symbol.for("react.suspense_list"), $0b2e6adb871a3b94$var$Ga = Symbol.for("react.memo"), $0b2e6adb871a3b94$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $0b2e6adb871a3b94$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $0b2e6adb871a3b94$var$Ja = Symbol.iterator;
function $0b2e6adb871a3b94$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $0b2e6adb871a3b94$var$Ja && a[$0b2e6adb871a3b94$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $0b2e6adb871a3b94$var$A = Object.assign, $0b2e6adb871a3b94$var$La;
function $0b2e6adb871a3b94$var$Ma(a) {
    if (void 0 === $0b2e6adb871a3b94$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $0b2e6adb871a3b94$var$La = b && b[1] || "";
    }
    return "\n" + $0b2e6adb871a3b94$var$La + a;
}
var $0b2e6adb871a3b94$var$Na = !1;
function $0b2e6adb871a3b94$var$Oa(a, b) {
    if (!a || $0b2e6adb871a3b94$var$Na) return "";
    $0b2e6adb871a3b94$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $0b2e6adb871a3b94$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $0b2e6adb871a3b94$var$Ma(a) : "";
}
function $0b2e6adb871a3b94$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $0b2e6adb871a3b94$var$Ma(a.type);
        case 16:
            return $0b2e6adb871a3b94$var$Ma("Lazy");
        case 13:
            return $0b2e6adb871a3b94$var$Ma("Suspense");
        case 19:
            return $0b2e6adb871a3b94$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !1), a;
        case 11:
            return a = $0b2e6adb871a3b94$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return "Fragment";
        case $0b2e6adb871a3b94$var$wa:
            return "Portal";
        case $0b2e6adb871a3b94$var$Aa:
            return "Profiler";
        case $0b2e6adb871a3b94$var$za:
            return "StrictMode";
        case $0b2e6adb871a3b94$var$Ea:
            return "Suspense";
        case $0b2e6adb871a3b94$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $0b2e6adb871a3b94$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $0b2e6adb871a3b94$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $0b2e6adb871a3b94$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $0b2e6adb871a3b94$var$Ga:
            return b = a.displayName || null, null !== b ? b : $0b2e6adb871a3b94$var$Qa(a.type) || "Memo";
        case $0b2e6adb871a3b94$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $0b2e6adb871a3b94$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $0b2e6adb871a3b94$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $0b2e6adb871a3b94$var$Qa(b);
        case 8:
            return b === $0b2e6adb871a3b94$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $0b2e6adb871a3b94$var$Ua(a) {
    var b = $0b2e6adb871a3b94$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $0b2e6adb871a3b94$var$Va(a) {
    a._valueTracker || (a._valueTracker = $0b2e6adb871a3b94$var$Ua(a));
}
function $0b2e6adb871a3b94$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $0b2e6adb871a3b94$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $0b2e6adb871a3b94$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $0b2e6adb871a3b94$var$Ya(a, b) {
    var c = b.checked;
    return $0b2e6adb871a3b94$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $0b2e6adb871a3b94$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $0b2e6adb871a3b94$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $0b2e6adb871a3b94$var$ab(a, b) {
    b = b.checked;
    null != b && $0b2e6adb871a3b94$var$ta(a, "checked", b, !1);
}
function $0b2e6adb871a3b94$var$bb(a, b) {
    $0b2e6adb871a3b94$var$ab(a, b);
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $0b2e6adb871a3b94$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $0b2e6adb871a3b94$var$cb(a, b.type, $0b2e6adb871a3b94$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $0b2e6adb871a3b94$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $0b2e6adb871a3b94$var$cb(a, b, c) {
    if ("number" !== b || $0b2e6adb871a3b94$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $0b2e6adb871a3b94$var$eb = Array.isArray;
function $0b2e6adb871a3b94$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $0b2e6adb871a3b94$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $0b2e6adb871a3b94$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($0b2e6adb871a3b94$var$p(91));
    return $0b2e6adb871a3b94$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $0b2e6adb871a3b94$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($0b2e6adb871a3b94$var$p(92));
            if ($0b2e6adb871a3b94$var$eb(c)) {
                if (1 < c.length) throw Error($0b2e6adb871a3b94$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $0b2e6adb871a3b94$var$Sa(c)
    };
}
function $0b2e6adb871a3b94$var$ib(a, b) {
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = $0b2e6adb871a3b94$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $0b2e6adb871a3b94$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $0b2e6adb871a3b94$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $0b2e6adb871a3b94$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $0b2e6adb871a3b94$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $0b2e6adb871a3b94$var$mb, $0b2e6adb871a3b94$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $0b2e6adb871a3b94$var$mb = $0b2e6adb871a3b94$var$mb || document.createElement("div");
        $0b2e6adb871a3b94$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $0b2e6adb871a3b94$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $0b2e6adb871a3b94$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $0b2e6adb871a3b94$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $0b2e6adb871a3b94$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($0b2e6adb871a3b94$var$pb).forEach(function(a) {
    $0b2e6adb871a3b94$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $0b2e6adb871a3b94$var$pb[b] = $0b2e6adb871a3b94$var$pb[a];
    });
});
function $0b2e6adb871a3b94$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $0b2e6adb871a3b94$var$pb.hasOwnProperty(a) && $0b2e6adb871a3b94$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $0b2e6adb871a3b94$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $0b2e6adb871a3b94$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $0b2e6adb871a3b94$var$tb = $0b2e6adb871a3b94$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $0b2e6adb871a3b94$var$ub(a, b) {
    if (b) {
        if ($0b2e6adb871a3b94$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($0b2e6adb871a3b94$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($0b2e6adb871a3b94$var$p(62));
    }
}
function $0b2e6adb871a3b94$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $0b2e6adb871a3b94$var$wb = null;
function $0b2e6adb871a3b94$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $0b2e6adb871a3b94$var$yb = null, $0b2e6adb871a3b94$var$zb = null, $0b2e6adb871a3b94$var$Ab = null;
function $0b2e6adb871a3b94$var$Bb(a) {
    if (a = $0b2e6adb871a3b94$var$Cb(a)) {
        if ("function" !== typeof $0b2e6adb871a3b94$var$yb) throw Error($0b2e6adb871a3b94$var$p(280));
        var b = a.stateNode;
        b && (b = $0b2e6adb871a3b94$var$Db(b), $0b2e6adb871a3b94$var$yb(a.stateNode, a.type, b));
    }
}
function $0b2e6adb871a3b94$var$Eb(a) {
    $0b2e6adb871a3b94$var$zb ? $0b2e6adb871a3b94$var$Ab ? $0b2e6adb871a3b94$var$Ab.push(a) : $0b2e6adb871a3b94$var$Ab = [
        a
    ] : $0b2e6adb871a3b94$var$zb = a;
}
function $0b2e6adb871a3b94$var$Fb() {
    if ($0b2e6adb871a3b94$var$zb) {
        var a = $0b2e6adb871a3b94$var$zb, b = $0b2e6adb871a3b94$var$Ab;
        $0b2e6adb871a3b94$var$Ab = $0b2e6adb871a3b94$var$zb = null;
        $0b2e6adb871a3b94$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$Bb(b[a]);
    }
}
function $0b2e6adb871a3b94$var$Gb(a, b) {
    return a(b);
}
function $0b2e6adb871a3b94$var$Hb() {}
var $0b2e6adb871a3b94$var$Ib = !1;
function $0b2e6adb871a3b94$var$Jb(a, b, c) {
    if ($0b2e6adb871a3b94$var$Ib) return a(b, c);
    $0b2e6adb871a3b94$var$Ib = !0;
    try {
        return $0b2e6adb871a3b94$var$Gb(a, b, c);
    } finally{
        if ($0b2e6adb871a3b94$var$Ib = !1, null !== $0b2e6adb871a3b94$var$zb || null !== $0b2e6adb871a3b94$var$Ab) $0b2e6adb871a3b94$var$Hb(), $0b2e6adb871a3b94$var$Fb();
    }
}
function $0b2e6adb871a3b94$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $0b2e6adb871a3b94$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($0b2e6adb871a3b94$var$p(231, b, typeof c));
    return c;
}
var $0b2e6adb871a3b94$var$Lb = !1;
if ($0b2e6adb871a3b94$var$ia) try {
    var $0b2e6adb871a3b94$var$Mb = {};
    Object.defineProperty($0b2e6adb871a3b94$var$Mb, "passive", {
        get: function() {
            $0b2e6adb871a3b94$var$Lb = !0;
        }
    });
    window.addEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
    window.removeEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
} catch (a) {
    $0b2e6adb871a3b94$var$Lb = !1;
}
function $0b2e6adb871a3b94$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $0b2e6adb871a3b94$var$Ob = !1, $0b2e6adb871a3b94$var$Pb = null, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, $0b2e6adb871a3b94$var$Sb = {
    onError: function(a) {
        $0b2e6adb871a3b94$var$Ob = !0;
        $0b2e6adb871a3b94$var$Pb = a;
    }
};
function $0b2e6adb871a3b94$var$Tb(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Ob = !1;
    $0b2e6adb871a3b94$var$Pb = null;
    $0b2e6adb871a3b94$var$Nb.apply($0b2e6adb871a3b94$var$Sb, arguments);
}
function $0b2e6adb871a3b94$var$Ub(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Tb.apply(this, arguments);
    if ($0b2e6adb871a3b94$var$Ob) {
        if ($0b2e6adb871a3b94$var$Ob) {
            var l = $0b2e6adb871a3b94$var$Pb;
            $0b2e6adb871a3b94$var$Ob = !1;
            $0b2e6adb871a3b94$var$Pb = null;
        } else throw Error($0b2e6adb871a3b94$var$p(198));
        $0b2e6adb871a3b94$var$Qb || ($0b2e6adb871a3b94$var$Qb = !0, $0b2e6adb871a3b94$var$Rb = l);
    }
}
function $0b2e6adb871a3b94$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $0b2e6adb871a3b94$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Xb(a) {
    if ($0b2e6adb871a3b94$var$Vb(a) !== a) throw Error($0b2e6adb871a3b94$var$p(188));
}
function $0b2e6adb871a3b94$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $0b2e6adb871a3b94$var$Vb(a);
        if (null === b) throw Error($0b2e6adb871a3b94$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $0b2e6adb871a3b94$var$Xb(e), a;
                if (f === d) return $0b2e6adb871a3b94$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($0b2e6adb871a3b94$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($0b2e6adb871a3b94$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($0b2e6adb871a3b94$var$p(190));
    }
    if (3 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $0b2e6adb871a3b94$var$Zb(a) {
    a = $0b2e6adb871a3b94$var$Yb(a);
    return null !== a ? $0b2e6adb871a3b94$var$$b(a) : null;
}
function $0b2e6adb871a3b94$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $0b2e6adb871a3b94$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$ac = $fO90s.unstable_scheduleCallback, $0b2e6adb871a3b94$var$bc = $fO90s.unstable_cancelCallback, $0b2e6adb871a3b94$var$cc = $fO90s.unstable_shouldYield, $0b2e6adb871a3b94$var$dc = $fO90s.unstable_requestPaint, $0b2e6adb871a3b94$var$B = $fO90s.unstable_now, $0b2e6adb871a3b94$var$ec = $fO90s.unstable_getCurrentPriorityLevel, $0b2e6adb871a3b94$var$fc = $fO90s.unstable_ImmediatePriority, $0b2e6adb871a3b94$var$gc = $fO90s.unstable_UserBlockingPriority, $0b2e6adb871a3b94$var$hc = $fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$ic = $fO90s.unstable_LowPriority, $0b2e6adb871a3b94$var$jc = $fO90s.unstable_IdlePriority, $0b2e6adb871a3b94$var$kc = null, $0b2e6adb871a3b94$var$lc = null;
function $0b2e6adb871a3b94$var$mc(a) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberRoot) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberRoot($0b2e6adb871a3b94$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $0b2e6adb871a3b94$var$oc = Math.clz32 ? Math.clz32 : $0b2e6adb871a3b94$var$nc, $0b2e6adb871a3b94$var$pc = Math.log, $0b2e6adb871a3b94$var$qc = Math.LN2;
function $0b2e6adb871a3b94$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($0b2e6adb871a3b94$var$pc(a) / $0b2e6adb871a3b94$var$qc | 0) | 0;
}
var $0b2e6adb871a3b94$var$rc = 64, $0b2e6adb871a3b94$var$sc = 4194304;
function $0b2e6adb871a3b94$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $0b2e6adb871a3b94$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $0b2e6adb871a3b94$var$tc(h) : (f &= g, 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $0b2e6adb871a3b94$var$tc(g) : 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $0b2e6adb871a3b94$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $0b2e6adb871a3b94$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $0b2e6adb871a3b94$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $0b2e6adb871a3b94$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $0b2e6adb871a3b94$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $0b2e6adb871a3b94$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $0b2e6adb871a3b94$var$yc() {
    var a = $0b2e6adb871a3b94$var$rc;
    $0b2e6adb871a3b94$var$rc <<= 1;
    0 === ($0b2e6adb871a3b94$var$rc & 4194240) && ($0b2e6adb871a3b94$var$rc = 64);
    return a;
}
function $0b2e6adb871a3b94$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $0b2e6adb871a3b94$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $0b2e6adb871a3b94$var$oc(b);
    a[b] = c;
}
function $0b2e6adb871a3b94$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $0b2e6adb871a3b94$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $0b2e6adb871a3b94$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $0b2e6adb871a3b94$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $0b2e6adb871a3b94$var$C = 0;
function $0b2e6adb871a3b94$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $0b2e6adb871a3b94$var$Ec, $0b2e6adb871a3b94$var$Fc, $0b2e6adb871a3b94$var$Gc, $0b2e6adb871a3b94$var$Hc, $0b2e6adb871a3b94$var$Ic, $0b2e6adb871a3b94$var$Jc = !1, $0b2e6adb871a3b94$var$Kc = [], $0b2e6adb871a3b94$var$Lc = null, $0b2e6adb871a3b94$var$Mc = null, $0b2e6adb871a3b94$var$Nc = null, $0b2e6adb871a3b94$var$Oc = new Map, $0b2e6adb871a3b94$var$Pc = new Map, $0b2e6adb871a3b94$var$Qc = [], $0b2e6adb871a3b94$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $0b2e6adb871a3b94$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $0b2e6adb871a3b94$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $0b2e6adb871a3b94$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $0b2e6adb871a3b94$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $0b2e6adb871a3b94$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $0b2e6adb871a3b94$var$Pc.delete(b.pointerId);
    }
}
function $0b2e6adb871a3b94$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $0b2e6adb871a3b94$var$Cb(b), null !== b && $0b2e6adb871a3b94$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $0b2e6adb871a3b94$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $0b2e6adb871a3b94$var$Lc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $0b2e6adb871a3b94$var$Mc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $0b2e6adb871a3b94$var$Nc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $0b2e6adb871a3b94$var$Oc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $0b2e6adb871a3b94$var$Pc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Vc(a) {
    var b = $0b2e6adb871a3b94$var$Wc(a.target);
    if (null !== b) {
        var c = $0b2e6adb871a3b94$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $0b2e6adb871a3b94$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $0b2e6adb871a3b94$var$Ic(a.priority, function() {
                        $0b2e6adb871a3b94$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $0b2e6adb871a3b94$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $0b2e6adb871a3b94$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $0b2e6adb871a3b94$var$wb = d;
            c.target.dispatchEvent(d);
            $0b2e6adb871a3b94$var$wb = null;
        } else return b = $0b2e6adb871a3b94$var$Cb(c), null !== b && $0b2e6adb871a3b94$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Zc(a, b, c) {
    $0b2e6adb871a3b94$var$Xc(a) && c.delete(b);
}
function $0b2e6adb871a3b94$var$$c() {
    $0b2e6adb871a3b94$var$Jc = !1;
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Lc) && ($0b2e6adb871a3b94$var$Lc = null);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Mc) && ($0b2e6adb871a3b94$var$Mc = null);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Nc) && ($0b2e6adb871a3b94$var$Nc = null);
    $0b2e6adb871a3b94$var$Oc.forEach($0b2e6adb871a3b94$var$Zc);
    $0b2e6adb871a3b94$var$Pc.forEach($0b2e6adb871a3b94$var$Zc);
}
function $0b2e6adb871a3b94$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $0b2e6adb871a3b94$var$Jc || ($0b2e6adb871a3b94$var$Jc = !0, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$$c)));
}
function $0b2e6adb871a3b94$var$bd(a) {
    function b(b) {
        return $0b2e6adb871a3b94$var$ad(b, a);
    }
    if (0 < $0b2e6adb871a3b94$var$Kc.length) {
        $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Kc[0], a);
        for(var c = 1; c < $0b2e6adb871a3b94$var$Kc.length; c++){
            var d = $0b2e6adb871a3b94$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Lc, a);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Mc, a);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Nc, a);
    $0b2e6adb871a3b94$var$Oc.forEach(b);
    $0b2e6adb871a3b94$var$Pc.forEach(b);
    for(c = 0; c < $0b2e6adb871a3b94$var$Qc.length; c++)d = $0b2e6adb871a3b94$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $0b2e6adb871a3b94$var$Qc.length && (c = $0b2e6adb871a3b94$var$Qc[0], null === c.blockedOn);)$0b2e6adb871a3b94$var$Vc(c), null === c.blockedOn && $0b2e6adb871a3b94$var$Qc.shift();
}
var $0b2e6adb871a3b94$var$cd = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$dd = !0;
function $0b2e6adb871a3b94$var$ed(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$gd(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 4, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$fd(a, b, c, d) {
    if ($0b2e6adb871a3b94$var$dd) {
        var e = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
        if (null === e) $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c), $0b2e6adb871a3b94$var$Sc(a, d);
        else if ($0b2e6adb871a3b94$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($0b2e6adb871a3b94$var$Sc(a, d), b & 4 && -1 < $0b2e6adb871a3b94$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $0b2e6adb871a3b94$var$Cb(e);
                null !== f && $0b2e6adb871a3b94$var$Ec(f);
                f = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
                null === f && $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $0b2e6adb871a3b94$var$hd(a, b, d, null, c);
    }
}
var $0b2e6adb871a3b94$var$id = null;
function $0b2e6adb871a3b94$var$Yc(a, b, c, d) {
    $0b2e6adb871a3b94$var$id = null;
    a = $0b2e6adb871a3b94$var$xb(d);
    a = $0b2e6adb871a3b94$var$Wc(a);
    if (null !== a) {
        if (b = $0b2e6adb871a3b94$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $0b2e6adb871a3b94$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $0b2e6adb871a3b94$var$id = a;
    return null;
}
function $0b2e6adb871a3b94$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($0b2e6adb871a3b94$var$ec()){
                case $0b2e6adb871a3b94$var$fc:
                    return 1;
                case $0b2e6adb871a3b94$var$gc:
                    return 4;
                case $0b2e6adb871a3b94$var$hc:
                case $0b2e6adb871a3b94$var$ic:
                    return 16;
                case $0b2e6adb871a3b94$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ld = null, $0b2e6adb871a3b94$var$md = null;
function $0b2e6adb871a3b94$var$nd() {
    if ($0b2e6adb871a3b94$var$md) return $0b2e6adb871a3b94$var$md;
    var a, b = $0b2e6adb871a3b94$var$ld, c = b.length, d, e = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $0b2e6adb871a3b94$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $0b2e6adb871a3b94$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $0b2e6adb871a3b94$var$pd() {
    return !0;
}
function $0b2e6adb871a3b94$var$qd() {
    return !1;
}
function $0b2e6adb871a3b94$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $0b2e6adb871a3b94$var$pd : $0b2e6adb871a3b94$var$qd;
        this.isPropagationStopped = $0b2e6adb871a3b94$var$qd;
        return this;
    }
    $0b2e6adb871a3b94$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $0b2e6adb871a3b94$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $0b2e6adb871a3b94$var$pd);
        },
        persist: function() {},
        isPersistent: $0b2e6adb871a3b94$var$pd
    });
    return b;
}
var $0b2e6adb871a3b94$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $0b2e6adb871a3b94$var$td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$sd), $0b2e6adb871a3b94$var$ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    view: 0,
    detail: 0
}), $0b2e6adb871a3b94$var$vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$ud), $0b2e6adb871a3b94$var$wd, $0b2e6adb871a3b94$var$xd, $0b2e6adb871a3b94$var$yd, $0b2e6adb871a3b94$var$Ad = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $0b2e6adb871a3b94$var$yd && ($0b2e6adb871a3b94$var$yd && "mousemove" === a.type ? ($0b2e6adb871a3b94$var$wd = a.screenX - $0b2e6adb871a3b94$var$yd.screenX, $0b2e6adb871a3b94$var$xd = a.screenY - $0b2e6adb871a3b94$var$yd.screenY) : $0b2e6adb871a3b94$var$xd = $0b2e6adb871a3b94$var$wd = 0, $0b2e6adb871a3b94$var$yd = a);
        return $0b2e6adb871a3b94$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $0b2e6adb871a3b94$var$xd;
    }
}), $0b2e6adb871a3b94$var$Bd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ad), $0b2e6adb871a3b94$var$Cd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    dataTransfer: 0
}), $0b2e6adb871a3b94$var$Dd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Cd), $0b2e6adb871a3b94$var$Ed = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    relatedTarget: 0
}), $0b2e6adb871a3b94$var$Fd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ed), $0b2e6adb871a3b94$var$Gd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Hd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Gd), $0b2e6adb871a3b94$var$Id = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $0b2e6adb871a3b94$var$Jd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Id), $0b2e6adb871a3b94$var$Kd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    data: 0
}), $0b2e6adb871a3b94$var$Ld = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Kd), $0b2e6adb871a3b94$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $0b2e6adb871a3b94$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $0b2e6adb871a3b94$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $0b2e6adb871a3b94$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $0b2e6adb871a3b94$var$Od[a]) ? !!b[a] : !1;
}
function $0b2e6adb871a3b94$var$zd() {
    return $0b2e6adb871a3b94$var$Pd;
}
var $0b2e6adb871a3b94$var$Qd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $0b2e6adb871a3b94$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $0b2e6adb871a3b94$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $0b2e6adb871a3b94$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $0b2e6adb871a3b94$var$Rd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Qd), $0b2e6adb871a3b94$var$Sd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $0b2e6adb871a3b94$var$Td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Sd), $0b2e6adb871a3b94$var$Ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd
}), $0b2e6adb871a3b94$var$Vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ud), $0b2e6adb871a3b94$var$Wd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Xd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Wd), $0b2e6adb871a3b94$var$Yd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $0b2e6adb871a3b94$var$Zd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Yd), $0b2e6adb871a3b94$var$$d = [
    9,
    13,
    27,
    32
], $0b2e6adb871a3b94$var$ae = $0b2e6adb871a3b94$var$ia && "CompositionEvent" in window, $0b2e6adb871a3b94$var$be = null;
$0b2e6adb871a3b94$var$ia && "documentMode" in document && ($0b2e6adb871a3b94$var$be = document.documentMode);
var $0b2e6adb871a3b94$var$ce = $0b2e6adb871a3b94$var$ia && "TextEvent" in window && !$0b2e6adb871a3b94$var$be, $0b2e6adb871a3b94$var$de = $0b2e6adb871a3b94$var$ia && (!$0b2e6adb871a3b94$var$ae || $0b2e6adb871a3b94$var$be && 8 < $0b2e6adb871a3b94$var$be && 11 >= $0b2e6adb871a3b94$var$be), $0b2e6adb871a3b94$var$ee = String.fromCharCode(32), $0b2e6adb871a3b94$var$fe = !1;
function $0b2e6adb871a3b94$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $0b2e6adb871a3b94$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $0b2e6adb871a3b94$var$ie = !1;
function $0b2e6adb871a3b94$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $0b2e6adb871a3b94$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $0b2e6adb871a3b94$var$fe = !0;
            return $0b2e6adb871a3b94$var$ee;
        case "textInput":
            return a = b.data, a === $0b2e6adb871a3b94$var$ee && $0b2e6adb871a3b94$var$fe ? null : a;
        default:
            return null;
    }
}
function $0b2e6adb871a3b94$var$ke(a, b) {
    if ($0b2e6adb871a3b94$var$ie) return "compositionend" === a || !$0b2e6adb871a3b94$var$ae && $0b2e6adb871a3b94$var$ge(a, b) ? (a = $0b2e6adb871a3b94$var$nd(), $0b2e6adb871a3b94$var$md = $0b2e6adb871a3b94$var$ld = $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $0b2e6adb871a3b94$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $0b2e6adb871a3b94$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$0b2e6adb871a3b94$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $0b2e6adb871a3b94$var$ne(a, b, c, d) {
    $0b2e6adb871a3b94$var$Eb(d);
    b = $0b2e6adb871a3b94$var$oe(b, "onChange");
    0 < b.length && (c = new $0b2e6adb871a3b94$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $0b2e6adb871a3b94$var$pe = null, $0b2e6adb871a3b94$var$qe = null;
function $0b2e6adb871a3b94$var$re(a) {
    $0b2e6adb871a3b94$var$se(a, 0);
}
function $0b2e6adb871a3b94$var$te(a) {
    var b = $0b2e6adb871a3b94$var$ue(a);
    if ($0b2e6adb871a3b94$var$Wa(b)) return a;
}
function $0b2e6adb871a3b94$var$ve(a, b) {
    if ("change" === a) return b;
}
var $0b2e6adb871a3b94$var$we = !1;
if ($0b2e6adb871a3b94$var$ia) {
    var $0b2e6adb871a3b94$var$xe;
    if ($0b2e6adb871a3b94$var$ia) {
        var $0b2e6adb871a3b94$var$ye = "oninput" in document;
        if (!$0b2e6adb871a3b94$var$ye) {
            var $0b2e6adb871a3b94$var$ze = document.createElement("div");
            $0b2e6adb871a3b94$var$ze.setAttribute("oninput", "return;");
            $0b2e6adb871a3b94$var$ye = "function" === typeof $0b2e6adb871a3b94$var$ze.oninput;
        }
        $0b2e6adb871a3b94$var$xe = $0b2e6adb871a3b94$var$ye;
    } else $0b2e6adb871a3b94$var$xe = !1;
    $0b2e6adb871a3b94$var$we = $0b2e6adb871a3b94$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $0b2e6adb871a3b94$var$Ae() {
    $0b2e6adb871a3b94$var$pe && ($0b2e6adb871a3b94$var$pe.detachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be), $0b2e6adb871a3b94$var$qe = $0b2e6adb871a3b94$var$pe = null);
}
function $0b2e6adb871a3b94$var$Be(a) {
    if ("value" === a.propertyName && $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe)) {
        var b = [];
        $0b2e6adb871a3b94$var$ne(b, $0b2e6adb871a3b94$var$qe, a, $0b2e6adb871a3b94$var$xb(a));
        $0b2e6adb871a3b94$var$Jb($0b2e6adb871a3b94$var$re, b);
    }
}
function $0b2e6adb871a3b94$var$Ce(a, b, c) {
    "focusin" === a ? ($0b2e6adb871a3b94$var$Ae(), $0b2e6adb871a3b94$var$pe = b, $0b2e6adb871a3b94$var$qe = c, $0b2e6adb871a3b94$var$pe.attachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be)) : "focusout" === a && $0b2e6adb871a3b94$var$Ae();
}
function $0b2e6adb871a3b94$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe);
}
function $0b2e6adb871a3b94$var$Ee(a, b) {
    if ("click" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $0b2e6adb871a3b94$var$He = "function" === typeof Object.is ? Object.is : $0b2e6adb871a3b94$var$Ge;
function $0b2e6adb871a3b94$var$Ie(a, b) {
    if ($0b2e6adb871a3b94$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$0b2e6adb871a3b94$var$ja.call(b, e) || !$0b2e6adb871a3b94$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $0b2e6adb871a3b94$var$Ke(a, b) {
    var c = $0b2e6adb871a3b94$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $0b2e6adb871a3b94$var$Je(c);
    }
}
function $0b2e6adb871a3b94$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $0b2e6adb871a3b94$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $0b2e6adb871a3b94$var$Me() {
    for(var a = window, b = $0b2e6adb871a3b94$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $0b2e6adb871a3b94$var$Xa(a.document);
    }
    return b;
}
function $0b2e6adb871a3b94$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $0b2e6adb871a3b94$var$Oe(a) {
    var b = $0b2e6adb871a3b94$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $0b2e6adb871a3b94$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $0b2e6adb871a3b94$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $0b2e6adb871a3b94$var$Ke(c, f);
                var g = $0b2e6adb871a3b94$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $0b2e6adb871a3b94$var$Pe = $0b2e6adb871a3b94$var$ia && "documentMode" in document && 11 >= document.documentMode, $0b2e6adb871a3b94$var$Qe = null, $0b2e6adb871a3b94$var$Re = null, $0b2e6adb871a3b94$var$Se = null, $0b2e6adb871a3b94$var$Te = !1;
function $0b2e6adb871a3b94$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $0b2e6adb871a3b94$var$Te || null == $0b2e6adb871a3b94$var$Qe || $0b2e6adb871a3b94$var$Qe !== $0b2e6adb871a3b94$var$Xa(d) || (d = $0b2e6adb871a3b94$var$Qe, "selectionStart" in d && $0b2e6adb871a3b94$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $0b2e6adb871a3b94$var$Se && $0b2e6adb871a3b94$var$Ie($0b2e6adb871a3b94$var$Se, d) || ($0b2e6adb871a3b94$var$Se = d, d = $0b2e6adb871a3b94$var$oe($0b2e6adb871a3b94$var$Re, "onSelect"), 0 < d.length && (b = new $0b2e6adb871a3b94$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $0b2e6adb871a3b94$var$Qe)));
}
function $0b2e6adb871a3b94$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $0b2e6adb871a3b94$var$We = {
    animationend: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationIteration"),
    animationstart: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationStart"),
    transitionend: $0b2e6adb871a3b94$var$Ve("Transition", "TransitionEnd")
}, $0b2e6adb871a3b94$var$Xe = {}, $0b2e6adb871a3b94$var$Ye = {};
$0b2e6adb871a3b94$var$ia && ($0b2e6adb871a3b94$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $0b2e6adb871a3b94$var$We.animationend.animation, delete $0b2e6adb871a3b94$var$We.animationiteration.animation, delete $0b2e6adb871a3b94$var$We.animationstart.animation), "TransitionEvent" in window || delete $0b2e6adb871a3b94$var$We.transitionend.transition);
function $0b2e6adb871a3b94$var$Ze(a) {
    if ($0b2e6adb871a3b94$var$Xe[a]) return $0b2e6adb871a3b94$var$Xe[a];
    if (!$0b2e6adb871a3b94$var$We[a]) return a;
    var b = $0b2e6adb871a3b94$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $0b2e6adb871a3b94$var$Ye) return $0b2e6adb871a3b94$var$Xe[a] = b[c];
    return a;
}
var $0b2e6adb871a3b94$var$$e = $0b2e6adb871a3b94$var$Ze("animationend"), $0b2e6adb871a3b94$var$af = $0b2e6adb871a3b94$var$Ze("animationiteration"), $0b2e6adb871a3b94$var$bf = $0b2e6adb871a3b94$var$Ze("animationstart"), $0b2e6adb871a3b94$var$cf = $0b2e6adb871a3b94$var$Ze("transitionend"), $0b2e6adb871a3b94$var$df = new Map, $0b2e6adb871a3b94$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $0b2e6adb871a3b94$var$ff(a, b) {
    $0b2e6adb871a3b94$var$df.set(a, b);
    $0b2e6adb871a3b94$var$fa(b, [
        a
    ]);
}
for(var $0b2e6adb871a3b94$var$gf = 0; $0b2e6adb871a3b94$var$gf < $0b2e6adb871a3b94$var$ef.length; $0b2e6adb871a3b94$var$gf++){
    var $0b2e6adb871a3b94$var$hf = $0b2e6adb871a3b94$var$ef[$0b2e6adb871a3b94$var$gf], $0b2e6adb871a3b94$var$jf = $0b2e6adb871a3b94$var$hf.toLowerCase(), $0b2e6adb871a3b94$var$kf = $0b2e6adb871a3b94$var$hf[0].toUpperCase() + $0b2e6adb871a3b94$var$hf.slice(1);
    $0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$jf, "on" + $0b2e6adb871a3b94$var$kf);
}
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$$e, "onAnimationEnd");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$af, "onAnimationIteration");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$bf, "onAnimationStart");
$0b2e6adb871a3b94$var$ff("dblclick", "onDoubleClick");
$0b2e6adb871a3b94$var$ff("focusin", "onFocus");
$0b2e6adb871a3b94$var$ff("focusout", "onBlur");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$cf, "onTransitionEnd");
$0b2e6adb871a3b94$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$0b2e6adb871a3b94$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $0b2e6adb871a3b94$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $0b2e6adb871a3b94$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($0b2e6adb871a3b94$var$lf));
function $0b2e6adb871a3b94$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $0b2e6adb871a3b94$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $0b2e6adb871a3b94$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($0b2e6adb871a3b94$var$Qb) throw a = $0b2e6adb871a3b94$var$Rb, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, a;
}
function $0b2e6adb871a3b94$var$D(a, b) {
    var c = b[$0b2e6adb871a3b94$var$of];
    void 0 === c && (c = b[$0b2e6adb871a3b94$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($0b2e6adb871a3b94$var$pf(b, a, 2, !1), c.add(d));
}
function $0b2e6adb871a3b94$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $0b2e6adb871a3b94$var$pf(c, a, d, b);
}
var $0b2e6adb871a3b94$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $0b2e6adb871a3b94$var$sf(a) {
    if (!a[$0b2e6adb871a3b94$var$rf]) {
        a[$0b2e6adb871a3b94$var$rf] = !0;
        $0b2e6adb871a3b94$var$da.forEach(function(b) {
            "selectionchange" !== b && ($0b2e6adb871a3b94$var$mf.has(b) || $0b2e6adb871a3b94$var$qf(b, !1, a), $0b2e6adb871a3b94$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$0b2e6adb871a3b94$var$rf] || (b[$0b2e6adb871a3b94$var$rf] = !0, $0b2e6adb871a3b94$var$qf("selectionchange", !1, b));
    }
}
function $0b2e6adb871a3b94$var$pf(a, b, c, d) {
    switch($0b2e6adb871a3b94$var$jd(b)){
        case 1:
            var e = $0b2e6adb871a3b94$var$ed;
            break;
        case 4:
            e = $0b2e6adb871a3b94$var$gd;
            break;
        default:
            e = $0b2e6adb871a3b94$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$0b2e6adb871a3b94$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $0b2e6adb871a3b94$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $0b2e6adb871a3b94$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $0b2e6adb871a3b94$var$Jb(function() {
        var d = f, e = $0b2e6adb871a3b94$var$xb(c), g = [];
        a: {
            var h = $0b2e6adb871a3b94$var$df.get(a);
            if (void 0 !== h) {
                var k = $0b2e6adb871a3b94$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $0b2e6adb871a3b94$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $0b2e6adb871a3b94$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $0b2e6adb871a3b94$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $0b2e6adb871a3b94$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $0b2e6adb871a3b94$var$Vd;
                        break;
                    case $0b2e6adb871a3b94$var$$e:
                    case $0b2e6adb871a3b94$var$af:
                    case $0b2e6adb871a3b94$var$bf:
                        k = $0b2e6adb871a3b94$var$Hd;
                        break;
                    case $0b2e6adb871a3b94$var$cf:
                        k = $0b2e6adb871a3b94$var$Xd;
                        break;
                    case "scroll":
                        k = $0b2e6adb871a3b94$var$vd;
                        break;
                    case "wheel":
                        k = $0b2e6adb871a3b94$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $0b2e6adb871a3b94$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $0b2e6adb871a3b94$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $0b2e6adb871a3b94$var$Kb(w, x), null != F && t.push($0b2e6adb871a3b94$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $0b2e6adb871a3b94$var$wb && (n = c.relatedTarget || c.fromElement) && ($0b2e6adb871a3b94$var$Wc(n) || n[$0b2e6adb871a3b94$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $0b2e6adb871a3b94$var$Wc(n) : null, null !== n && (J = $0b2e6adb871a3b94$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $0b2e6adb871a3b94$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $0b2e6adb871a3b94$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $0b2e6adb871a3b94$var$ue(k);
                        u = null == n ? h : $0b2e6adb871a3b94$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $0b2e6adb871a3b94$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $0b2e6adb871a3b94$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $0b2e6adb871a3b94$var$vf(F))u++;
                            for(; 0 < w - u;)t = $0b2e6adb871a3b94$var$vf(t), w--;
                            for(; 0 < u - w;)x = $0b2e6adb871a3b94$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $0b2e6adb871a3b94$var$vf(t);
                                x = $0b2e6adb871a3b94$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $0b2e6adb871a3b94$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $0b2e6adb871a3b94$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $0b2e6adb871a3b94$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $0b2e6adb871a3b94$var$ve;
                else if ($0b2e6adb871a3b94$var$me(h)) {
                    if ($0b2e6adb871a3b94$var$we) na = $0b2e6adb871a3b94$var$Fe;
                    else {
                        na = $0b2e6adb871a3b94$var$De;
                        var xa = $0b2e6adb871a3b94$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $0b2e6adb871a3b94$var$Ee);
                if (na && (na = na(a, d))) {
                    $0b2e6adb871a3b94$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $0b2e6adb871a3b94$var$cb(h, "number", h.value);
            }
            xa = d ? $0b2e6adb871a3b94$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($0b2e6adb871a3b94$var$me(xa) || "true" === xa.contentEditable) $0b2e6adb871a3b94$var$Qe = xa, $0b2e6adb871a3b94$var$Re = d, $0b2e6adb871a3b94$var$Se = null;
                    break;
                case "focusout":
                    $0b2e6adb871a3b94$var$Se = $0b2e6adb871a3b94$var$Re = $0b2e6adb871a3b94$var$Qe = null;
                    break;
                case "mousedown":
                    $0b2e6adb871a3b94$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $0b2e6adb871a3b94$var$Te = !1;
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($0b2e6adb871a3b94$var$Pe) break;
                case "keydown":
                case "keyup":
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
            }
            var $a;
            if ($0b2e6adb871a3b94$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $0b2e6adb871a3b94$var$ie ? $0b2e6adb871a3b94$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($0b2e6adb871a3b94$var$de && "ko" !== c.locale && ($0b2e6adb871a3b94$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $0b2e6adb871a3b94$var$ie && ($a = $0b2e6adb871a3b94$var$nd()) : ($0b2e6adb871a3b94$var$kd = e, $0b2e6adb871a3b94$var$ld = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, $0b2e6adb871a3b94$var$ie = !0)), xa = $0b2e6adb871a3b94$var$oe(d, ba), 0 < xa.length && (ba = new $0b2e6adb871a3b94$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $0b2e6adb871a3b94$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $0b2e6adb871a3b94$var$ce ? $0b2e6adb871a3b94$var$je(a, c) : $0b2e6adb871a3b94$var$ke(a, c)) d = $0b2e6adb871a3b94$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $0b2e6adb871a3b94$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $0b2e6adb871a3b94$var$se(g, b);
    });
}
function $0b2e6adb871a3b94$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $0b2e6adb871a3b94$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $0b2e6adb871a3b94$var$Kb(a, c), null != f && d.unshift($0b2e6adb871a3b94$var$tf(a, f, e)), f = $0b2e6adb871a3b94$var$Kb(a, b), null != f && d.push($0b2e6adb871a3b94$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $0b2e6adb871a3b94$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $0b2e6adb871a3b94$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.unshift($0b2e6adb871a3b94$var$tf(c, k, h))) : e || (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.push($0b2e6adb871a3b94$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $0b2e6adb871a3b94$var$xf = /\r\n?/g, $0b2e6adb871a3b94$var$yf = /\u0000|\uFFFD/g;
function $0b2e6adb871a3b94$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($0b2e6adb871a3b94$var$xf, "\n").replace($0b2e6adb871a3b94$var$yf, "");
}
function $0b2e6adb871a3b94$var$Af(a, b, c) {
    b = $0b2e6adb871a3b94$var$zf(b);
    if ($0b2e6adb871a3b94$var$zf(a) !== b && c) throw Error($0b2e6adb871a3b94$var$p(425));
}
function $0b2e6adb871a3b94$var$Bf() {}
var $0b2e6adb871a3b94$var$Cf = null, $0b2e6adb871a3b94$var$Df = null;
function $0b2e6adb871a3b94$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $0b2e6adb871a3b94$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $0b2e6adb871a3b94$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $0b2e6adb871a3b94$var$Hf = "function" === typeof Promise ? Promise : void 0, $0b2e6adb871a3b94$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $0b2e6adb871a3b94$var$Hf ? function(a) {
    return $0b2e6adb871a3b94$var$Hf.resolve(null).then(a).catch($0b2e6adb871a3b94$var$If);
} : $0b2e6adb871a3b94$var$Ff;
function $0b2e6adb871a3b94$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $0b2e6adb871a3b94$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $0b2e6adb871a3b94$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $0b2e6adb871a3b94$var$bd(b);
}
function $0b2e6adb871a3b94$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Nf = Math.random().toString(36).slice(2), $0b2e6adb871a3b94$var$Of = "__reactFiber$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Pf = "__reactProps$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$uf = "__reactContainer$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$of = "__reactEvents$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Qf = "__reactListeners$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Rf = "__reactHandles$" + $0b2e6adb871a3b94$var$Nf;
function $0b2e6adb871a3b94$var$Wc(a) {
    var b = a[$0b2e6adb871a3b94$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$0b2e6adb871a3b94$var$uf] || c[$0b2e6adb871a3b94$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $0b2e6adb871a3b94$var$Mf(a); null !== a;){
                if (c = a[$0b2e6adb871a3b94$var$Of]) return c;
                a = $0b2e6adb871a3b94$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Cb(a) {
    a = a[$0b2e6adb871a3b94$var$Of] || a[$0b2e6adb871a3b94$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $0b2e6adb871a3b94$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($0b2e6adb871a3b94$var$p(33));
}
function $0b2e6adb871a3b94$var$Db(a) {
    return a[$0b2e6adb871a3b94$var$Pf] || null;
}
var $0b2e6adb871a3b94$var$Sf = [], $0b2e6adb871a3b94$var$Tf = -1;
function $0b2e6adb871a3b94$var$Uf(a) {
    return {
        current: a
    };
}
function $0b2e6adb871a3b94$var$E(a) {
    0 > $0b2e6adb871a3b94$var$Tf || (a.current = $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf], $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = null, $0b2e6adb871a3b94$var$Tf--);
}
function $0b2e6adb871a3b94$var$G(a, b) {
    $0b2e6adb871a3b94$var$Tf++;
    $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = a.current;
    a.current = b;
}
var $0b2e6adb871a3b94$var$Vf = {}, $0b2e6adb871a3b94$var$H = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Vf), $0b2e6adb871a3b94$var$Wf = $0b2e6adb871a3b94$var$Uf(!1), $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$Vf;
function $0b2e6adb871a3b94$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $0b2e6adb871a3b94$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $0b2e6adb871a3b94$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $0b2e6adb871a3b94$var$$f() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
}
function $0b2e6adb871a3b94$var$ag(a, b, c) {
    if ($0b2e6adb871a3b94$var$H.current !== $0b2e6adb871a3b94$var$Vf) throw Error($0b2e6adb871a3b94$var$p(168));
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
function $0b2e6adb871a3b94$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($0b2e6adb871a3b94$var$p(108, $0b2e6adb871a3b94$var$Ra(a) || "Unknown", e));
    return $0b2e6adb871a3b94$var$A({}, c, d);
}
function $0b2e6adb871a3b94$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $0b2e6adb871a3b94$var$Vf;
    $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$H.current;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, $0b2e6adb871a3b94$var$Wf.current);
    return !0;
}
function $0b2e6adb871a3b94$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($0b2e6adb871a3b94$var$p(169));
    c ? (a = $0b2e6adb871a3b94$var$bg(a, b, $0b2e6adb871a3b94$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a)) : $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
var $0b2e6adb871a3b94$var$eg = null, $0b2e6adb871a3b94$var$fg = !1, $0b2e6adb871a3b94$var$gg = !1;
function $0b2e6adb871a3b94$var$hg(a) {
    null === $0b2e6adb871a3b94$var$eg ? $0b2e6adb871a3b94$var$eg = [
        a
    ] : $0b2e6adb871a3b94$var$eg.push(a);
}
function $0b2e6adb871a3b94$var$ig(a) {
    $0b2e6adb871a3b94$var$fg = !0;
    $0b2e6adb871a3b94$var$hg(a);
}
function $0b2e6adb871a3b94$var$jg() {
    if (!$0b2e6adb871a3b94$var$gg && null !== $0b2e6adb871a3b94$var$eg) {
        $0b2e6adb871a3b94$var$gg = !0;
        var a = 0, b = $0b2e6adb871a3b94$var$C;
        try {
            var c = $0b2e6adb871a3b94$var$eg;
            for($0b2e6adb871a3b94$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $0b2e6adb871a3b94$var$eg = null;
            $0b2e6adb871a3b94$var$fg = !1;
        } catch (e) {
            throw null !== $0b2e6adb871a3b94$var$eg && ($0b2e6adb871a3b94$var$eg = $0b2e6adb871a3b94$var$eg.slice(a + 1)), $0b2e6adb871a3b94$var$ac($0b2e6adb871a3b94$var$fc, $0b2e6adb871a3b94$var$jg), e;
        } finally{
            $0b2e6adb871a3b94$var$C = b, $0b2e6adb871a3b94$var$gg = !1;
        }
    }
    return null;
}
var $0b2e6adb871a3b94$var$kg = [], $0b2e6adb871a3b94$var$lg = 0, $0b2e6adb871a3b94$var$mg = null, $0b2e6adb871a3b94$var$ng = 0, $0b2e6adb871a3b94$var$og = [], $0b2e6adb871a3b94$var$pg = 0, $0b2e6adb871a3b94$var$qg = null, $0b2e6adb871a3b94$var$rg = 1, $0b2e6adb871a3b94$var$sg = "";
function $0b2e6adb871a3b94$var$tg(a, b) {
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$ng;
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$mg;
    $0b2e6adb871a3b94$var$mg = a;
    $0b2e6adb871a3b94$var$ng = b;
}
function $0b2e6adb871a3b94$var$ug(a, b, c) {
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg;
    $0b2e6adb871a3b94$var$qg = a;
    var d = $0b2e6adb871a3b94$var$rg;
    a = $0b2e6adb871a3b94$var$sg;
    var e = 32 - $0b2e6adb871a3b94$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $0b2e6adb871a3b94$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $0b2e6adb871a3b94$var$rg = 1 << 32 - $0b2e6adb871a3b94$var$oc(b) + e | c << e | d;
        $0b2e6adb871a3b94$var$sg = f + a;
    } else $0b2e6adb871a3b94$var$rg = 1 << f | c << e | d, $0b2e6adb871a3b94$var$sg = a;
}
function $0b2e6adb871a3b94$var$vg(a) {
    null !== a.return && ($0b2e6adb871a3b94$var$tg(a, 1), $0b2e6adb871a3b94$var$ug(a, 1, 0));
}
function $0b2e6adb871a3b94$var$wg(a) {
    for(; a === $0b2e6adb871a3b94$var$mg;)$0b2e6adb871a3b94$var$mg = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null, $0b2e6adb871a3b94$var$ng = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null;
    for(; a === $0b2e6adb871a3b94$var$qg;)$0b2e6adb871a3b94$var$qg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$sg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$rg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null;
}
var $0b2e6adb871a3b94$var$xg = null, $0b2e6adb871a3b94$var$yg = null, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$zg = null;
function $0b2e6adb871a3b94$var$Ag(a, b) {
    var c = $0b2e6adb871a3b94$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $0b2e6adb871a3b94$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $0b2e6adb871a3b94$var$qg ? {
                id: $0b2e6adb871a3b94$var$rg,
                overflow: $0b2e6adb871a3b94$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $0b2e6adb871a3b94$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $0b2e6adb871a3b94$var$Eg(a) {
    if ($0b2e6adb871a3b94$var$I) {
        var b = $0b2e6adb871a3b94$var$yg;
        if (b) {
            var c = b;
            if (!$0b2e6adb871a3b94$var$Cg(a, b)) {
                if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
                b = $0b2e6adb871a3b94$var$Lf(c.nextSibling);
                var d = $0b2e6adb871a3b94$var$xg;
                b && $0b2e6adb871a3b94$var$Cg(a, b) ? $0b2e6adb871a3b94$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$xg = a);
            }
        } else {
            if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $0b2e6adb871a3b94$var$I = !1;
            $0b2e6adb871a3b94$var$xg = a;
        }
    }
}
function $0b2e6adb871a3b94$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $0b2e6adb871a3b94$var$xg = a;
}
function $0b2e6adb871a3b94$var$Gg(a) {
    if (a !== $0b2e6adb871a3b94$var$xg) return !1;
    if (!$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$Fg(a), $0b2e6adb871a3b94$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$0b2e6adb871a3b94$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $0b2e6adb871a3b94$var$yg)) {
        if ($0b2e6adb871a3b94$var$Dg(a)) throw $0b2e6adb871a3b94$var$Hg(), Error($0b2e6adb871a3b94$var$p(418));
        for(; b;)$0b2e6adb871a3b94$var$Ag(a, b), b = $0b2e6adb871a3b94$var$Lf(b.nextSibling);
    }
    $0b2e6adb871a3b94$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($0b2e6adb871a3b94$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $0b2e6adb871a3b94$var$yg = null;
        }
    } else $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg ? $0b2e6adb871a3b94$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $0b2e6adb871a3b94$var$Hg() {
    for(var a = $0b2e6adb871a3b94$var$yg; a;)a = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
}
function $0b2e6adb871a3b94$var$Ig() {
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg = null;
    $0b2e6adb871a3b94$var$I = !1;
}
function $0b2e6adb871a3b94$var$Jg(a) {
    null === $0b2e6adb871a3b94$var$zg ? $0b2e6adb871a3b94$var$zg = [
        a
    ] : $0b2e6adb871a3b94$var$zg.push(a);
}
var $0b2e6adb871a3b94$var$Kg = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig;
function $0b2e6adb871a3b94$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $0b2e6adb871a3b94$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $0b2e6adb871a3b94$var$Mg = $0b2e6adb871a3b94$var$Uf(null), $0b2e6adb871a3b94$var$Ng = null, $0b2e6adb871a3b94$var$Og = null, $0b2e6adb871a3b94$var$Pg = null;
function $0b2e6adb871a3b94$var$Qg() {
    $0b2e6adb871a3b94$var$Pg = $0b2e6adb871a3b94$var$Og = $0b2e6adb871a3b94$var$Ng = null;
}
function $0b2e6adb871a3b94$var$Rg(a) {
    var b = $0b2e6adb871a3b94$var$Mg.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Mg);
    a._currentValue = b;
}
function $0b2e6adb871a3b94$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $0b2e6adb871a3b94$var$Tg(a, b) {
    $0b2e6adb871a3b94$var$Ng = a;
    $0b2e6adb871a3b94$var$Pg = $0b2e6adb871a3b94$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($0b2e6adb871a3b94$var$Ug = !0), a.firstContext = null);
}
function $0b2e6adb871a3b94$var$Vg(a) {
    var b = a._currentValue;
    if ($0b2e6adb871a3b94$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $0b2e6adb871a3b94$var$Og) {
            if (null === $0b2e6adb871a3b94$var$Ng) throw Error($0b2e6adb871a3b94$var$p(308));
            $0b2e6adb871a3b94$var$Og = a;
            $0b2e6adb871a3b94$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $0b2e6adb871a3b94$var$Og = $0b2e6adb871a3b94$var$Og.next = a;
    }
    return b;
}
var $0b2e6adb871a3b94$var$Wg = null;
function $0b2e6adb871a3b94$var$Xg(a) {
    null === $0b2e6adb871a3b94$var$Wg ? $0b2e6adb871a3b94$var$Wg = [
        a
    ] : $0b2e6adb871a3b94$var$Wg.push(a);
}
function $0b2e6adb871a3b94$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $0b2e6adb871a3b94$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $0b2e6adb871a3b94$var$Zg(a, d);
}
function $0b2e6adb871a3b94$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $0b2e6adb871a3b94$var$$g = !1;
function $0b2e6adb871a3b94$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $0b2e6adb871a3b94$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $0b2e6adb871a3b94$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $0b2e6adb871a3b94$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $0b2e6adb871a3b94$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $0b2e6adb871a3b94$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $0b2e6adb871a3b94$var$Zg(a, c);
}
function $0b2e6adb871a3b94$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
function $0b2e6adb871a3b94$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $0b2e6adb871a3b94$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $0b2e6adb871a3b94$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $0b2e6adb871a3b94$var$A({}, q, r);
                            break a;
                        case 2:
                            $0b2e6adb871a3b94$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $0b2e6adb871a3b94$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $0b2e6adb871a3b94$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($0b2e6adb871a3b94$var$p(191, e));
            e.call(d);
        }
    }
}
var $0b2e6adb871a3b94$var$jh = (new $acw62.Component).refs;
function $0b2e6adb871a3b94$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $0b2e6adb871a3b94$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $0b2e6adb871a3b94$var$nh = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $0b2e6adb871a3b94$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$L(), e = $0b2e6adb871a3b94$var$lh(a), f = $0b2e6adb871a3b94$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$dh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$mh(b, a, e, d), $0b2e6adb871a3b94$var$eh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$L(), e = $0b2e6adb871a3b94$var$lh(a), f = $0b2e6adb871a3b94$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$dh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$mh(b, a, e, d), $0b2e6adb871a3b94$var$eh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $0b2e6adb871a3b94$var$L(), d = $0b2e6adb871a3b94$var$lh(a), e = $0b2e6adb871a3b94$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $0b2e6adb871a3b94$var$dh(a, e, d);
        null !== b && ($0b2e6adb871a3b94$var$mh(b, a, d, c), $0b2e6adb871a3b94$var$eh(b, a, d));
    }
};
function $0b2e6adb871a3b94$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$0b2e6adb871a3b94$var$Ie(c, d) || !$0b2e6adb871a3b94$var$Ie(e, f) : !0;
}
function $0b2e6adb871a3b94$var$ph(a, b, c) {
    var d = !1, e = $0b2e6adb871a3b94$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $0b2e6adb871a3b94$var$Vg(f) : (e = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $0b2e6adb871a3b94$var$Yf(a, e) : $0b2e6adb871a3b94$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $0b2e6adb871a3b94$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $0b2e6adb871a3b94$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $0b2e6adb871a3b94$var$nh.enqueueReplaceState(b, b.state, null);
}
function $0b2e6adb871a3b94$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $0b2e6adb871a3b94$var$jh;
    $0b2e6adb871a3b94$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $0b2e6adb871a3b94$var$Vg(f) : (f = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, e.context = $0b2e6adb871a3b94$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($0b2e6adb871a3b94$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $0b2e6adb871a3b94$var$nh.enqueueReplaceState(e, e.state, null), $0b2e6adb871a3b94$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $0b2e6adb871a3b94$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($0b2e6adb871a3b94$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === $0b2e6adb871a3b94$var$jh && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($0b2e6adb871a3b94$var$p(284));
        if (!c._owner) throw Error($0b2e6adb871a3b94$var$p(290, a));
    }
    return a;
}
function $0b2e6adb871a3b94$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($0b2e6adb871a3b94$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $0b2e6adb871a3b94$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $0b2e6adb871a3b94$var$vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $0b2e6adb871a3b94$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $0b2e6adb871a3b94$var$xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $0b2e6adb871a3b94$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $0b2e6adb871a3b94$var$sh(a, b, c), d.return = a, d;
        d = $0b2e6adb871a3b94$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $0b2e6adb871a3b94$var$sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $0b2e6adb871a3b94$var$zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $0b2e6adb871a3b94$var$Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $0b2e6adb871a3b94$var$xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c = $0b2e6adb871a3b94$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $0b2e6adb871a3b94$var$sh(a, null, b), c.return = a, c;
                case $0b2e6adb871a3b94$var$wa:
                    return b = $0b2e6adb871a3b94$var$zh(b, a.mode, c), b.return = a, b;
                case $0b2e6adb871a3b94$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($0b2e6adb871a3b94$var$eb(b) || $0b2e6adb871a3b94$var$Ka(b)) return b = $0b2e6adb871a3b94$var$Ah(b, a.mode, c, null), b.return = a, b;
            $0b2e6adb871a3b94$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($0b2e6adb871a3b94$var$eb(c) || $0b2e6adb871a3b94$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $0b2e6adb871a3b94$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $0b2e6adb871a3b94$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $0b2e6adb871a3b94$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($0b2e6adb871a3b94$var$eb(d) || $0b2e6adb871a3b94$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $0b2e6adb871a3b94$var$th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $0b2e6adb871a3b94$var$Ka(h);
        if ("function" !== typeof l) throw Error($0b2e6adb871a3b94$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($0b2e6adb871a3b94$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $0b2e6adb871a3b94$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $0b2e6adb871a3b94$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $0b2e6adb871a3b94$var$sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $0b2e6adb871a3b94$var$ya ? (d = $0b2e6adb871a3b94$var$Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $0b2e6adb871a3b94$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $0b2e6adb871a3b94$var$sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $0b2e6adb871a3b94$var$zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($0b2e6adb871a3b94$var$eb(f)) return n(a, d, f, h);
            if ($0b2e6adb871a3b94$var$Ka(f)) return t(a, d, f, h);
            $0b2e6adb871a3b94$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $0b2e6adb871a3b94$var$xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $0b2e6adb871a3b94$var$Bh = $0b2e6adb871a3b94$var$vh(!0), $0b2e6adb871a3b94$var$Ch = $0b2e6adb871a3b94$var$vh(!1), $0b2e6adb871a3b94$var$Dh = {}, $0b2e6adb871a3b94$var$Eh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Dh), $0b2e6adb871a3b94$var$Fh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Dh), $0b2e6adb871a3b94$var$Gh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Dh);
function $0b2e6adb871a3b94$var$Hh(a) {
    if (a === $0b2e6adb871a3b94$var$Dh) throw Error($0b2e6adb871a3b94$var$p(174));
    return a;
}
function $0b2e6adb871a3b94$var$Ih(a, b) {
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Gh, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Fh, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Eh, $0b2e6adb871a3b94$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $0b2e6adb871a3b94$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $0b2e6adb871a3b94$var$lb(b, a);
    }
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Eh);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Eh, b);
}
function $0b2e6adb871a3b94$var$Jh() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Eh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Fh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Gh);
}
function $0b2e6adb871a3b94$var$Kh(a) {
    $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Gh.current);
    var b = $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Eh.current);
    var c = $0b2e6adb871a3b94$var$lb(b, a.type);
    b !== c && ($0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Fh, a), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Eh, c));
}
function $0b2e6adb871a3b94$var$Lh(a) {
    $0b2e6adb871a3b94$var$Fh.current === a && ($0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Eh), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Fh));
}
var $0b2e6adb871a3b94$var$M = $0b2e6adb871a3b94$var$Uf(0);
function $0b2e6adb871a3b94$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Nh = [];
function $0b2e6adb871a3b94$var$Oh() {
    for(var a = 0; a < $0b2e6adb871a3b94$var$Nh.length; a++)$0b2e6adb871a3b94$var$Nh[a]._workInProgressVersionPrimary = null;
    $0b2e6adb871a3b94$var$Nh.length = 0;
}
var $0b2e6adb871a3b94$var$Ph = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$Qh = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$Rh = 0, $0b2e6adb871a3b94$var$N = null, $0b2e6adb871a3b94$var$O = null, $0b2e6adb871a3b94$var$P = null, $0b2e6adb871a3b94$var$Sh = !1, $0b2e6adb871a3b94$var$Th = !1, $0b2e6adb871a3b94$var$Uh = 0, $0b2e6adb871a3b94$var$Vh = 0;
function $0b2e6adb871a3b94$var$Q() {
    throw Error($0b2e6adb871a3b94$var$p(321));
}
function $0b2e6adb871a3b94$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$0b2e6adb871a3b94$var$He(a[c], b[c])) return !1;
    return !0;
}
function $0b2e6adb871a3b94$var$Xh(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$Rh = f;
    $0b2e6adb871a3b94$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $0b2e6adb871a3b94$var$Ph.current = null === a || null === a.memoizedState ? $0b2e6adb871a3b94$var$Yh : $0b2e6adb871a3b94$var$Zh;
    a = c(d, e);
    if ($0b2e6adb871a3b94$var$Th) {
        f = 0;
        do {
            $0b2e6adb871a3b94$var$Th = !1;
            $0b2e6adb871a3b94$var$Uh = 0;
            if (25 <= f) throw Error($0b2e6adb871a3b94$var$p(301));
            f += 1;
            $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$O = null;
            b.updateQueue = null;
            $0b2e6adb871a3b94$var$Ph.current = $0b2e6adb871a3b94$var$$h;
            a = c(d, e);
        }while ($0b2e6adb871a3b94$var$Th);
    }
    $0b2e6adb871a3b94$var$Ph.current = $0b2e6adb871a3b94$var$ai;
    b = null !== $0b2e6adb871a3b94$var$O && null !== $0b2e6adb871a3b94$var$O.next;
    $0b2e6adb871a3b94$var$Rh = 0;
    $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = null;
    $0b2e6adb871a3b94$var$Sh = !1;
    if (b) throw Error($0b2e6adb871a3b94$var$p(300));
    return a;
}
function $0b2e6adb871a3b94$var$bi() {
    var a = 0 !== $0b2e6adb871a3b94$var$Uh;
    $0b2e6adb871a3b94$var$Uh = 0;
    return a;
}
function $0b2e6adb871a3b94$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $0b2e6adb871a3b94$var$P ? $0b2e6adb871a3b94$var$N.memoizedState = $0b2e6adb871a3b94$var$P = a : $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$P.next = a;
    return $0b2e6adb871a3b94$var$P;
}
function $0b2e6adb871a3b94$var$di() {
    if (null === $0b2e6adb871a3b94$var$O) {
        var a = $0b2e6adb871a3b94$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $0b2e6adb871a3b94$var$O.next;
    var b = null === $0b2e6adb871a3b94$var$P ? $0b2e6adb871a3b94$var$N.memoizedState : $0b2e6adb871a3b94$var$P.next;
    if (null !== b) $0b2e6adb871a3b94$var$P = b, $0b2e6adb871a3b94$var$O = a;
    else {
        if (null === a) throw Error($0b2e6adb871a3b94$var$p(310));
        $0b2e6adb871a3b94$var$O = a;
        a = {
            memoizedState: $0b2e6adb871a3b94$var$O.memoizedState,
            baseState: $0b2e6adb871a3b94$var$O.baseState,
            baseQueue: $0b2e6adb871a3b94$var$O.baseQueue,
            queue: $0b2e6adb871a3b94$var$O.queue,
            next: null
        };
        null === $0b2e6adb871a3b94$var$P ? $0b2e6adb871a3b94$var$N.memoizedState = $0b2e6adb871a3b94$var$P = a : $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$P.next = a;
    }
    return $0b2e6adb871a3b94$var$P;
}
function $0b2e6adb871a3b94$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $0b2e6adb871a3b94$var$fi(a) {
    var b = $0b2e6adb871a3b94$var$di(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = $0b2e6adb871a3b94$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($0b2e6adb871a3b94$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $0b2e6adb871a3b94$var$N.lanes |= m;
                $0b2e6adb871a3b94$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $0b2e6adb871a3b94$var$He(d, b.memoizedState) || ($0b2e6adb871a3b94$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $0b2e6adb871a3b94$var$N.lanes |= f, $0b2e6adb871a3b94$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $0b2e6adb871a3b94$var$gi(a) {
    var b = $0b2e6adb871a3b94$var$di(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $0b2e6adb871a3b94$var$He(f, b.memoizedState) || ($0b2e6adb871a3b94$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $0b2e6adb871a3b94$var$hi() {}
function $0b2e6adb871a3b94$var$ii(a, b) {
    var c = $0b2e6adb871a3b94$var$N, d = $0b2e6adb871a3b94$var$di(), e = b(), f = !$0b2e6adb871a3b94$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $0b2e6adb871a3b94$var$Ug = !0);
    d = d.queue;
    $0b2e6adb871a3b94$var$ji($0b2e6adb871a3b94$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $0b2e6adb871a3b94$var$P && $0b2e6adb871a3b94$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $0b2e6adb871a3b94$var$li(9, $0b2e6adb871a3b94$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $0b2e6adb871a3b94$var$R) throw Error($0b2e6adb871a3b94$var$p(349));
        0 !== ($0b2e6adb871a3b94$var$Rh & 30) || $0b2e6adb871a3b94$var$ni(c, b, e);
    }
    return e;
}
function $0b2e6adb871a3b94$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $0b2e6adb871a3b94$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $0b2e6adb871a3b94$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $0b2e6adb871a3b94$var$oi(b) && $0b2e6adb871a3b94$var$pi(a);
}
function $0b2e6adb871a3b94$var$ki(a, b, c) {
    return c(function() {
        $0b2e6adb871a3b94$var$oi(b) && $0b2e6adb871a3b94$var$pi(a);
    });
}
function $0b2e6adb871a3b94$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$0b2e6adb871a3b94$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $0b2e6adb871a3b94$var$pi(a) {
    var b = $0b2e6adb871a3b94$var$Zg(a, 1);
    null !== b && $0b2e6adb871a3b94$var$mh(b, a, 1, -1);
}
function $0b2e6adb871a3b94$var$qi(a) {
    var b = $0b2e6adb871a3b94$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $0b2e6adb871a3b94$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $0b2e6adb871a3b94$var$ri.bind(null, $0b2e6adb871a3b94$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $0b2e6adb871a3b94$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $0b2e6adb871a3b94$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $0b2e6adb871a3b94$var$si() {
    return $0b2e6adb871a3b94$var$di().memoizedState;
}
function $0b2e6adb871a3b94$var$ti(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$ci();
    $0b2e6adb871a3b94$var$N.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $0b2e6adb871a3b94$var$ui(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $0b2e6adb871a3b94$var$O) {
        var g = $0b2e6adb871a3b94$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $0b2e6adb871a3b94$var$Wh(d, g.deps)) {
            e.memoizedState = $0b2e6adb871a3b94$var$li(b, c, f, d);
            return;
        }
    }
    $0b2e6adb871a3b94$var$N.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$li(1 | b, c, f, d);
}
function $0b2e6adb871a3b94$var$vi(a, b) {
    return $0b2e6adb871a3b94$var$ti(8390656, 8, a, b);
}
function $0b2e6adb871a3b94$var$ji(a, b) {
    return $0b2e6adb871a3b94$var$ui(2048, 8, a, b);
}
function $0b2e6adb871a3b94$var$wi(a, b) {
    return $0b2e6adb871a3b94$var$ui(4, 2, a, b);
}
function $0b2e6adb871a3b94$var$xi(a, b) {
    return $0b2e6adb871a3b94$var$ui(4, 4, a, b);
}
function $0b2e6adb871a3b94$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $0b2e6adb871a3b94$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $0b2e6adb871a3b94$var$ui(4, 4, $0b2e6adb871a3b94$var$yi.bind(null, b, a), c);
}
function $0b2e6adb871a3b94$var$Ai() {}
function $0b2e6adb871a3b94$var$Bi(a, b) {
    var c = $0b2e6adb871a3b94$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$Ci(a, b) {
    var c = $0b2e6adb871a3b94$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$Di(a, b, c) {
    if (0 === ($0b2e6adb871a3b94$var$Rh & 21)) return a.baseState && (a.baseState = !1, $0b2e6adb871a3b94$var$Ug = !0), a.memoizedState = c;
    $0b2e6adb871a3b94$var$He(c, b) || (c = $0b2e6adb871a3b94$var$yc(), $0b2e6adb871a3b94$var$N.lanes |= c, $0b2e6adb871a3b94$var$hh |= c, a.baseState = !0);
    return b;
}
function $0b2e6adb871a3b94$var$Ei(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    $0b2e6adb871a3b94$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $0b2e6adb871a3b94$var$Qh.transition;
    $0b2e6adb871a3b94$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$Qh.transition = d;
    }
}
function $0b2e6adb871a3b94$var$Fi() {
    return $0b2e6adb871a3b94$var$di().memoizedState;
}
function $0b2e6adb871a3b94$var$Gi(a, b, c) {
    var d = $0b2e6adb871a3b94$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$Hi(a)) $0b2e6adb871a3b94$var$Ii(b, c);
    else if (c = $0b2e6adb871a3b94$var$Yg(a, b, c, d), null !== c) {
        var e = $0b2e6adb871a3b94$var$L();
        $0b2e6adb871a3b94$var$mh(c, a, d, e);
        $0b2e6adb871a3b94$var$Ji(c, b, d);
    }
}
function $0b2e6adb871a3b94$var$ri(a, b, c) {
    var d = $0b2e6adb871a3b94$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$Hi(a)) $0b2e6adb871a3b94$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($0b2e6adb871a3b94$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $0b2e6adb871a3b94$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $0b2e6adb871a3b94$var$Yg(a, b, e, d);
        null !== c && (e = $0b2e6adb871a3b94$var$L(), $0b2e6adb871a3b94$var$mh(c, a, d, e), $0b2e6adb871a3b94$var$Ji(c, b, d));
    }
}
function $0b2e6adb871a3b94$var$Hi(a) {
    var b = a.alternate;
    return a === $0b2e6adb871a3b94$var$N || null !== b && b === $0b2e6adb871a3b94$var$N;
}
function $0b2e6adb871a3b94$var$Ii(a, b) {
    $0b2e6adb871a3b94$var$Th = $0b2e6adb871a3b94$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $0b2e6adb871a3b94$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
var $0b2e6adb871a3b94$var$ai = {
    readContext: $0b2e6adb871a3b94$var$Vg,
    useCallback: $0b2e6adb871a3b94$var$Q,
    useContext: $0b2e6adb871a3b94$var$Q,
    useEffect: $0b2e6adb871a3b94$var$Q,
    useImperativeHandle: $0b2e6adb871a3b94$var$Q,
    useInsertionEffect: $0b2e6adb871a3b94$var$Q,
    useLayoutEffect: $0b2e6adb871a3b94$var$Q,
    useMemo: $0b2e6adb871a3b94$var$Q,
    useReducer: $0b2e6adb871a3b94$var$Q,
    useRef: $0b2e6adb871a3b94$var$Q,
    useState: $0b2e6adb871a3b94$var$Q,
    useDebugValue: $0b2e6adb871a3b94$var$Q,
    useDeferredValue: $0b2e6adb871a3b94$var$Q,
    useTransition: $0b2e6adb871a3b94$var$Q,
    useMutableSource: $0b2e6adb871a3b94$var$Q,
    useSyncExternalStore: $0b2e6adb871a3b94$var$Q,
    useId: $0b2e6adb871a3b94$var$Q,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Yh = {
    readContext: $0b2e6adb871a3b94$var$Vg,
    useCallback: function(a, b) {
        $0b2e6adb871a3b94$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $0b2e6adb871a3b94$var$Vg,
    useEffect: $0b2e6adb871a3b94$var$vi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $0b2e6adb871a3b94$var$ti(4194308, 4, $0b2e6adb871a3b94$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ti(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $0b2e6adb871a3b94$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $0b2e6adb871a3b94$var$Gi.bind(null, $0b2e6adb871a3b94$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $0b2e6adb871a3b94$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $0b2e6adb871a3b94$var$qi,
    useDebugValue: $0b2e6adb871a3b94$var$Ai,
    useDeferredValue: function(a) {
        return $0b2e6adb871a3b94$var$ci().memoizedState = a;
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$qi(!1), b = a[0];
        a = $0b2e6adb871a3b94$var$Ei.bind(null, a[1]);
        $0b2e6adb871a3b94$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$N, e = $0b2e6adb871a3b94$var$ci();
        if ($0b2e6adb871a3b94$var$I) {
            if (void 0 === c) throw Error($0b2e6adb871a3b94$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $0b2e6adb871a3b94$var$R) throw Error($0b2e6adb871a3b94$var$p(349));
            0 !== ($0b2e6adb871a3b94$var$Rh & 30) || $0b2e6adb871a3b94$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $0b2e6adb871a3b94$var$vi($0b2e6adb871a3b94$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $0b2e6adb871a3b94$var$li(9, $0b2e6adb871a3b94$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $0b2e6adb871a3b94$var$ci(), b = $0b2e6adb871a3b94$var$R.identifierPrefix;
        if ($0b2e6adb871a3b94$var$I) {
            var c = $0b2e6adb871a3b94$var$sg;
            var d = $0b2e6adb871a3b94$var$rg;
            c = (d & ~(1 << 32 - $0b2e6adb871a3b94$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $0b2e6adb871a3b94$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $0b2e6adb871a3b94$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Zh = {
    readContext: $0b2e6adb871a3b94$var$Vg,
    useCallback: $0b2e6adb871a3b94$var$Bi,
    useContext: $0b2e6adb871a3b94$var$Vg,
    useEffect: $0b2e6adb871a3b94$var$ji,
    useImperativeHandle: $0b2e6adb871a3b94$var$zi,
    useInsertionEffect: $0b2e6adb871a3b94$var$wi,
    useLayoutEffect: $0b2e6adb871a3b94$var$xi,
    useMemo: $0b2e6adb871a3b94$var$Ci,
    useReducer: $0b2e6adb871a3b94$var$fi,
    useRef: $0b2e6adb871a3b94$var$si,
    useState: function() {
        return $0b2e6adb871a3b94$var$fi($0b2e6adb871a3b94$var$ei);
    },
    useDebugValue: $0b2e6adb871a3b94$var$Ai,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$di();
        return $0b2e6adb871a3b94$var$Di(b, $0b2e6adb871a3b94$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$fi($0b2e6adb871a3b94$var$ei)[0], b = $0b2e6adb871a3b94$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$hi,
    useSyncExternalStore: $0b2e6adb871a3b94$var$ii,
    useId: $0b2e6adb871a3b94$var$Fi,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$$h = {
    readContext: $0b2e6adb871a3b94$var$Vg,
    useCallback: $0b2e6adb871a3b94$var$Bi,
    useContext: $0b2e6adb871a3b94$var$Vg,
    useEffect: $0b2e6adb871a3b94$var$ji,
    useImperativeHandle: $0b2e6adb871a3b94$var$zi,
    useInsertionEffect: $0b2e6adb871a3b94$var$wi,
    useLayoutEffect: $0b2e6adb871a3b94$var$xi,
    useMemo: $0b2e6adb871a3b94$var$Ci,
    useReducer: $0b2e6adb871a3b94$var$gi,
    useRef: $0b2e6adb871a3b94$var$si,
    useState: function() {
        return $0b2e6adb871a3b94$var$gi($0b2e6adb871a3b94$var$ei);
    },
    useDebugValue: $0b2e6adb871a3b94$var$Ai,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$di();
        return null === $0b2e6adb871a3b94$var$O ? b.memoizedState = a : $0b2e6adb871a3b94$var$Di(b, $0b2e6adb871a3b94$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$gi($0b2e6adb871a3b94$var$ei)[0], b = $0b2e6adb871a3b94$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$hi,
    useSyncExternalStore: $0b2e6adb871a3b94$var$ii,
    useId: $0b2e6adb871a3b94$var$Fi,
    unstable_isNewReconciler: !1
};
function $0b2e6adb871a3b94$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $0b2e6adb871a3b94$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $0b2e6adb871a3b94$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $0b2e6adb871a3b94$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $0b2e6adb871a3b94$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $0b2e6adb871a3b94$var$Oi(a, b, c) {
    c = $0b2e6adb871a3b94$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $0b2e6adb871a3b94$var$Pi || ($0b2e6adb871a3b94$var$Pi = !0, $0b2e6adb871a3b94$var$Qi = d);
        $0b2e6adb871a3b94$var$Mi(a, b);
    };
    return c;
}
function $0b2e6adb871a3b94$var$Ri(a, b, c) {
    c = $0b2e6adb871a3b94$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $0b2e6adb871a3b94$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $0b2e6adb871a3b94$var$Mi(a, b);
        "function" !== typeof d && (null === $0b2e6adb871a3b94$var$Si ? $0b2e6adb871a3b94$var$Si = new Set([
            this
        ]) : $0b2e6adb871a3b94$var$Si.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $0b2e6adb871a3b94$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $0b2e6adb871a3b94$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $0b2e6adb871a3b94$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $0b2e6adb871a3b94$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $0b2e6adb871a3b94$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $0b2e6adb871a3b94$var$ch(-1, 1), b.tag = 2, $0b2e6adb871a3b94$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $0b2e6adb871a3b94$var$Xi = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$Ug = !1;
function $0b2e6adb871a3b94$var$Yi(a, b, c, d) {
    b.child = null === a ? $0b2e6adb871a3b94$var$Ch(b, null, c, d) : $0b2e6adb871a3b94$var$Bh(b, a.child, c, d);
}
function $0b2e6adb871a3b94$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $0b2e6adb871a3b94$var$Tg(b, e);
    d = $0b2e6adb871a3b94$var$Xh(a, b, c, d, f, e);
    c = $0b2e6adb871a3b94$var$bi();
    if (null !== a && !$0b2e6adb871a3b94$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$$i(a, b, e);
    $0b2e6adb871a3b94$var$I && c && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Yi(a, b, d, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$0b2e6adb871a3b94$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $0b2e6adb871a3b94$var$cj(a, b, f, d, e);
        a = $0b2e6adb871a3b94$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $0b2e6adb871a3b94$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $0b2e6adb871a3b94$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $0b2e6adb871a3b94$var$wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $0b2e6adb871a3b94$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($0b2e6adb871a3b94$var$Ie(f, d) && a.ref === b.ref) {
            if ($0b2e6adb871a3b94$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($0b2e6adb871a3b94$var$Ug = !0);
            else return b.lanes = a.lanes, $0b2e6adb871a3b94$var$$i(a, b, e);
        }
    }
    return $0b2e6adb871a3b94$var$dj(a, b, c, d, e);
}
function $0b2e6adb871a3b94$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$fj, $0b2e6adb871a3b94$var$gj), $0b2e6adb871a3b94$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$fj, $0b2e6adb871a3b94$var$gj), $0b2e6adb871a3b94$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$fj, $0b2e6adb871a3b94$var$gj);
            $0b2e6adb871a3b94$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$fj, $0b2e6adb871a3b94$var$gj), $0b2e6adb871a3b94$var$gj |= d;
    $0b2e6adb871a3b94$var$Yi(a, b, e, c);
    return b.child;
}
function $0b2e6adb871a3b94$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $0b2e6adb871a3b94$var$dj(a, b, c, d, e) {
    var f = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current;
    f = $0b2e6adb871a3b94$var$Yf(b, f);
    $0b2e6adb871a3b94$var$Tg(b, e);
    c = $0b2e6adb871a3b94$var$Xh(a, b, c, d, f, e);
    d = $0b2e6adb871a3b94$var$bi();
    if (null !== a && !$0b2e6adb871a3b94$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$$i(a, b, e);
    $0b2e6adb871a3b94$var$I && d && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Yi(a, b, c, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$ij(a, b, c, d, e) {
    if ($0b2e6adb871a3b94$var$Zf(c)) {
        var f = !0;
        $0b2e6adb871a3b94$var$cg(b);
    } else f = !1;
    $0b2e6adb871a3b94$var$Tg(b, e);
    if (null === b.stateNode) $0b2e6adb871a3b94$var$jj(a, b), $0b2e6adb871a3b94$var$ph(b, c, d), $0b2e6adb871a3b94$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $0b2e6adb871a3b94$var$Vg(l) : (l = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, l = $0b2e6adb871a3b94$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $0b2e6adb871a3b94$var$qh(b, g, d, l);
        $0b2e6adb871a3b94$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$$g ? ("function" === typeof m && ($0b2e6adb871a3b94$var$kh(b, c, m, d), k = b.memoizedState), (h = $0b2e6adb871a3b94$var$$g || $0b2e6adb871a3b94$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $0b2e6adb871a3b94$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $0b2e6adb871a3b94$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $0b2e6adb871a3b94$var$Vg(k) : (k = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, k = $0b2e6adb871a3b94$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $0b2e6adb871a3b94$var$qh(b, g, d, k);
        $0b2e6adb871a3b94$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$$g ? ("function" === typeof y && ($0b2e6adb871a3b94$var$kh(b, c, y, d), n = b.memoizedState), (l = $0b2e6adb871a3b94$var$$g || $0b2e6adb871a3b94$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $0b2e6adb871a3b94$var$kj(a, b, c, d, f, e);
}
function $0b2e6adb871a3b94$var$kj(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $0b2e6adb871a3b94$var$dg(b, c, !1), $0b2e6adb871a3b94$var$$i(a, b, f);
    d = b.stateNode;
    $0b2e6adb871a3b94$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $0b2e6adb871a3b94$var$Bh(b, a.child, null, f), b.child = $0b2e6adb871a3b94$var$Bh(b, null, h, f)) : $0b2e6adb871a3b94$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $0b2e6adb871a3b94$var$dg(b, c, !0);
    return b.child;
}
function $0b2e6adb871a3b94$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $0b2e6adb871a3b94$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $0b2e6adb871a3b94$var$ag(a, b.context, !1);
    $0b2e6adb871a3b94$var$Ih(a, b.containerInfo);
}
function $0b2e6adb871a3b94$var$mj(a, b, c, d, e) {
    $0b2e6adb871a3b94$var$Ig();
    $0b2e6adb871a3b94$var$Jg(e);
    b.flags |= 256;
    $0b2e6adb871a3b94$var$Yi(a, b, c, d);
    return b.child;
}
var $0b2e6adb871a3b94$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $0b2e6adb871a3b94$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $0b2e6adb871a3b94$var$pj(a, b, c) {
    var d = b.pendingProps, e = $0b2e6adb871a3b94$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, e & 1);
    if (null === a) {
        $0b2e6adb871a3b94$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $0b2e6adb871a3b94$var$qj(g, d, 0, null), a = $0b2e6adb871a3b94$var$Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $0b2e6adb871a3b94$var$oj(c), b.memoizedState = $0b2e6adb871a3b94$var$nj, a) : $0b2e6adb871a3b94$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $0b2e6adb871a3b94$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $0b2e6adb871a3b94$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $0b2e6adb871a3b94$var$wh(h, f) : (f = $0b2e6adb871a3b94$var$Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $0b2e6adb871a3b94$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $0b2e6adb871a3b94$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $0b2e6adb871a3b94$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $0b2e6adb871a3b94$var$rj(a, b) {
    b = $0b2e6adb871a3b94$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $0b2e6adb871a3b94$var$tj(a, b, c, d) {
    null !== d && $0b2e6adb871a3b94$var$Jg(d);
    $0b2e6adb871a3b94$var$Bh(b, a.child, null, c);
    a = $0b2e6adb871a3b94$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $0b2e6adb871a3b94$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $0b2e6adb871a3b94$var$Li(Error($0b2e6adb871a3b94$var$p(422))), $0b2e6adb871a3b94$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $0b2e6adb871a3b94$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $0b2e6adb871a3b94$var$Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $0b2e6adb871a3b94$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $0b2e6adb871a3b94$var$oj(g);
        b.memoizedState = $0b2e6adb871a3b94$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $0b2e6adb871a3b94$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($0b2e6adb871a3b94$var$p(419));
        d = $0b2e6adb871a3b94$var$Li(f, d, void 0);
        return $0b2e6adb871a3b94$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($0b2e6adb871a3b94$var$Ug || h) {
        d = $0b2e6adb871a3b94$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $0b2e6adb871a3b94$var$Zg(a, e), $0b2e6adb871a3b94$var$mh(d, a, e, -1));
        }
        $0b2e6adb871a3b94$var$uj();
        d = $0b2e6adb871a3b94$var$Li(Error($0b2e6adb871a3b94$var$p(421)));
        return $0b2e6adb871a3b94$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $0b2e6adb871a3b94$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(e.nextSibling);
    $0b2e6adb871a3b94$var$xg = b;
    $0b2e6adb871a3b94$var$I = !0;
    $0b2e6adb871a3b94$var$zg = null;
    null !== a && ($0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg, $0b2e6adb871a3b94$var$rg = a.id, $0b2e6adb871a3b94$var$sg = a.overflow, $0b2e6adb871a3b94$var$qg = b);
    b = $0b2e6adb871a3b94$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $0b2e6adb871a3b94$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $0b2e6adb871a3b94$var$Sg(a.return, b, c);
}
function $0b2e6adb871a3b94$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $0b2e6adb871a3b94$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $0b2e6adb871a3b94$var$Yi(a, b, d.children, c);
    d = $0b2e6adb871a3b94$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $0b2e6adb871a3b94$var$wj(a, c, b);
            else if (19 === a.tag) $0b2e6adb871a3b94$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $0b2e6adb871a3b94$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $0b2e6adb871a3b94$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $0b2e6adb871a3b94$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $0b2e6adb871a3b94$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $0b2e6adb871a3b94$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $0b2e6adb871a3b94$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $0b2e6adb871a3b94$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($0b2e6adb871a3b94$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $0b2e6adb871a3b94$var$wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $0b2e6adb871a3b94$var$wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $0b2e6adb871a3b94$var$lj(b);
            $0b2e6adb871a3b94$var$Ig();
            break;
        case 5:
            $0b2e6adb871a3b94$var$Kh(b);
            break;
        case 1:
            $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$cg(b);
            break;
        case 4:
            $0b2e6adb871a3b94$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, $0b2e6adb871a3b94$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $0b2e6adb871a3b94$var$pj(a, b, c);
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, $0b2e6adb871a3b94$var$M.current & 1);
                a = $0b2e6adb871a3b94$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, $0b2e6adb871a3b94$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $0b2e6adb871a3b94$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, $0b2e6adb871a3b94$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $0b2e6adb871a3b94$var$ej(a, b, c);
    }
    return $0b2e6adb871a3b94$var$$i(a, b, c);
}
var $0b2e6adb871a3b94$var$Aj, $0b2e6adb871a3b94$var$Bj, $0b2e6adb871a3b94$var$Cj, $0b2e6adb871a3b94$var$Dj;
$0b2e6adb871a3b94$var$Aj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$0b2e6adb871a3b94$var$Bj = function() {};
$0b2e6adb871a3b94$var$Cj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $0b2e6adb871a3b94$var$Ya(a, e);
                d = $0b2e6adb871a3b94$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $0b2e6adb871a3b94$var$A({}, e, {
                    value: void 0
                });
                d = $0b2e6adb871a3b94$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $0b2e6adb871a3b94$var$gb(a, e);
                d = $0b2e6adb871a3b94$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
        }
        $0b2e6adb871a3b94$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $0b2e6adb871a3b94$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$0b2e6adb871a3b94$var$Dj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $0b2e6adb871a3b94$var$Ej(a, b) {
    if (!$0b2e6adb871a3b94$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $0b2e6adb871a3b94$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $0b2e6adb871a3b94$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $0b2e6adb871a3b94$var$S(b), null;
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 3:
            d = b.stateNode;
            $0b2e6adb871a3b94$var$Jh();
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
            $0b2e6adb871a3b94$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $0b2e6adb871a3b94$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Gj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null));
            $0b2e6adb871a3b94$var$Bj(a, b);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 5:
            $0b2e6adb871a3b94$var$Lh(b);
            var e = $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $0b2e6adb871a3b94$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                    $0b2e6adb871a3b94$var$S(b);
                    return null;
                }
                a = $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Eh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    d[$0b2e6adb871a3b94$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $0b2e6adb871a3b94$var$D("cancel", d);
                            $0b2e6adb871a3b94$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], d);
                            break;
                        case "source":
                            $0b2e6adb871a3b94$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $0b2e6adb871a3b94$var$D("error", d);
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "details":
                            $0b2e6adb871a3b94$var$D("toggle", d);
                            break;
                        case "input":
                            $0b2e6adb871a3b94$var$Za(d, f);
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$hb(d, f), $0b2e6adb871a3b94$var$D("invalid", d);
                    }
                    $0b2e6adb871a3b94$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $0b2e6adb871a3b94$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $0b2e6adb871a3b94$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $0b2e6adb871a3b94$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $0b2e6adb871a3b94$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$0b2e6adb871a3b94$var$Of] = b;
                    a[$0b2e6adb871a3b94$var$Pf] = d;
                    $0b2e6adb871a3b94$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $0b2e6adb871a3b94$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $0b2e6adb871a3b94$var$D("cancel", a);
                                $0b2e6adb871a3b94$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $0b2e6adb871a3b94$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $0b2e6adb871a3b94$var$D("error", a);
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $0b2e6adb871a3b94$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $0b2e6adb871a3b94$var$Za(a, d);
                                e = $0b2e6adb871a3b94$var$Ya(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $0b2e6adb871a3b94$var$A({}, d, {
                                    value: void 0
                                });
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$hb(a, d);
                                e = $0b2e6adb871a3b94$var$gb(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $0b2e6adb871a3b94$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $0b2e6adb871a3b94$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $0b2e6adb871a3b94$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $0b2e6adb871a3b94$var$ob(a, k) : "number" === typeof k && $0b2e6adb871a3b94$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $0b2e6adb871a3b94$var$D("scroll", a) : null != k && $0b2e6adb871a3b94$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $0b2e6adb871a3b94$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $0b2e6adb871a3b94$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $0b2e6adb871a3b94$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $0b2e6adb871a3b94$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                c = $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Gh.current);
                $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Eh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $0b2e6adb871a3b94$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$0b2e6adb871a3b94$var$Of] = b, b.stateNode = d;
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($0b2e6adb871a3b94$var$I && null !== $0b2e6adb871a3b94$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $0b2e6adb871a3b94$var$Hg(), $0b2e6adb871a3b94$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $0b2e6adb871a3b94$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(317));
                        f[$0b2e6adb871a3b94$var$Of] = b;
                    } else $0b2e6adb871a3b94$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $0b2e6adb871a3b94$var$S(b);
                    f = !1;
                } else null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Gj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($0b2e6adb871a3b94$var$M.current & 1) ? 0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 3) : $0b2e6adb871a3b94$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 4:
            return $0b2e6adb871a3b94$var$Jh(), $0b2e6adb871a3b94$var$Bj(a, b), null === a && $0b2e6adb871a3b94$var$sf(b.stateNode.containerInfo), $0b2e6adb871a3b94$var$S(b), null;
        case 10:
            return $0b2e6adb871a3b94$var$Rg(b.type._context), $0b2e6adb871a3b94$var$S(b), null;
        case 17:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 19:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M);
            f = b.memoizedState;
            if (null === f) return $0b2e6adb871a3b94$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $0b2e6adb871a3b94$var$Ej(f, !1);
                else {
                    if (0 !== $0b2e6adb871a3b94$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $0b2e6adb871a3b94$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $0b2e6adb871a3b94$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, $0b2e6adb871a3b94$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $0b2e6adb871a3b94$var$B() > $0b2e6adb871a3b94$var$Hj && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $0b2e6adb871a3b94$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $0b2e6adb871a3b94$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$S(b), null;
                    } else 2 * $0b2e6adb871a3b94$var$B() - f.renderingStartTime > $0b2e6adb871a3b94$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $0b2e6adb871a3b94$var$B(), b.sibling = null, c = $0b2e6adb871a3b94$var$M.current, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, d ? c & 1 | 2 : c & 1), b;
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($0b2e6adb871a3b94$var$gj & 1073741824) && ($0b2e6adb871a3b94$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $0b2e6adb871a3b94$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
}
function $0b2e6adb871a3b94$var$Jj(a, b) {
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $0b2e6adb871a3b94$var$Jh(), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $0b2e6adb871a3b94$var$Lh(b), null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($0b2e6adb871a3b94$var$p(340));
                $0b2e6adb871a3b94$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M), null;
        case 4:
            return $0b2e6adb871a3b94$var$Jh(), null;
        case 10:
            return $0b2e6adb871a3b94$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$Kj = !1, $0b2e6adb871a3b94$var$U = !1, $0b2e6adb871a3b94$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $0b2e6adb871a3b94$var$V = null;
function $0b2e6adb871a3b94$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $0b2e6adb871a3b94$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $0b2e6adb871a3b94$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $0b2e6adb871a3b94$var$W(a, b, d);
    }
}
var $0b2e6adb871a3b94$var$Oj = !1;
function $0b2e6adb871a3b94$var$Pj(a, b) {
    $0b2e6adb871a3b94$var$Cf = $0b2e6adb871a3b94$var$dd;
    a = $0b2e6adb871a3b94$var$Me();
    if ($0b2e6adb871a3b94$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $0b2e6adb871a3b94$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $0b2e6adb871a3b94$var$dd = !1;
    for($0b2e6adb871a3b94$var$V = b; null !== $0b2e6adb871a3b94$var$V;)if (b = $0b2e6adb871a3b94$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $0b2e6adb871a3b94$var$V = a;
    else for(; null !== $0b2e6adb871a3b94$var$V;){
        b = $0b2e6adb871a3b94$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $0b2e6adb871a3b94$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(163));
            }
        } catch (F) {
            $0b2e6adb871a3b94$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $0b2e6adb871a3b94$var$V = a;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
    n = $0b2e6adb871a3b94$var$Oj;
    $0b2e6adb871a3b94$var$Oj = !1;
    return n;
}
function $0b2e6adb871a3b94$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $0b2e6adb871a3b94$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $0b2e6adb871a3b94$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $0b2e6adb871a3b94$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $0b2e6adb871a3b94$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $0b2e6adb871a3b94$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$0b2e6adb871a3b94$var$Of], delete b[$0b2e6adb871a3b94$var$Pf], delete b[$0b2e6adb871a3b94$var$of], delete b[$0b2e6adb871a3b94$var$Qf], delete b[$0b2e6adb871a3b94$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $0b2e6adb871a3b94$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $0b2e6adb871a3b94$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $0b2e6adb871a3b94$var$Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $0b2e6adb871a3b94$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $0b2e6adb871a3b94$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling;
}
function $0b2e6adb871a3b94$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Xj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Xj(a, b, c), a = a.sibling;
}
var $0b2e6adb871a3b94$var$X = null, $0b2e6adb871a3b94$var$Yj = !1;
function $0b2e6adb871a3b94$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$0b2e6adb871a3b94$var$ak(a, b, c), c = c.sibling;
}
function $0b2e6adb871a3b94$var$ak(a, b, c) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount($0b2e6adb871a3b94$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Mj(c, b);
        case 6:
            var d = $0b2e6adb871a3b94$var$X, e = $0b2e6adb871a3b94$var$Yj;
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Zj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Yj = e;
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Yj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $0b2e6adb871a3b94$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Yj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? $0b2e6adb871a3b94$var$Kf(a.parentNode, c) : 1 === a.nodeType && $0b2e6adb871a3b94$var$Kf(a, c), $0b2e6adb871a3b94$var$bd(a)) : $0b2e6adb871a3b94$var$Kf($0b2e6adb871a3b94$var$X, c.stateNode));
            break;
        case 4:
            d = $0b2e6adb871a3b94$var$X;
            e = $0b2e6adb871a3b94$var$Yj;
            $0b2e6adb871a3b94$var$X = c.stateNode.containerInfo;
            $0b2e6adb871a3b94$var$Yj = !0;
            $0b2e6adb871a3b94$var$Zj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$0b2e6adb871a3b94$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $0b2e6adb871a3b94$var$Nj(c, b, g) : 0 !== (f & 4) && $0b2e6adb871a3b94$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $0b2e6adb871a3b94$var$Zj(a, b, c);
            break;
        case 1:
            if (!$0b2e6adb871a3b94$var$U && ($0b2e6adb871a3b94$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $0b2e6adb871a3b94$var$W(c, b, h);
            }
            $0b2e6adb871a3b94$var$Zj(a, b, c);
            break;
        case 21:
            $0b2e6adb871a3b94$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($0b2e6adb871a3b94$var$U = (d = $0b2e6adb871a3b94$var$U) || null !== c.memoizedState, $0b2e6adb871a3b94$var$Zj(a, b, c), $0b2e6adb871a3b94$var$U = d) : $0b2e6adb871a3b94$var$Zj(a, b, c);
            break;
        default:
            $0b2e6adb871a3b94$var$Zj(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $0b2e6adb871a3b94$var$Lj);
        b.forEach(function(b) {
            var d = $0b2e6adb871a3b94$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $0b2e6adb871a3b94$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $0b2e6adb871a3b94$var$X = h.stateNode;
                        $0b2e6adb871a3b94$var$Yj = !1;
                        break a;
                    case 3:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Yj = !0;
                        break a;
                    case 4:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $0b2e6adb871a3b94$var$X) throw Error($0b2e6adb871a3b94$var$p(160));
            $0b2e6adb871a3b94$var$ak(f, g, e);
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $0b2e6adb871a3b94$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$0b2e6adb871a3b94$var$ek(b, a), b = b.sibling;
}
function $0b2e6adb871a3b94$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            if (d & 4) {
                try {
                    $0b2e6adb871a3b94$var$Qj(3, a, a.return), $0b2e6adb871a3b94$var$Rj(3, a);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
                try {
                    $0b2e6adb871a3b94$var$Qj(5, a, a.return);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Mj(c, c.return);
            break;
        case 5:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $0b2e6adb871a3b94$var$ob(e, "");
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $0b2e6adb871a3b94$var$ab(e, f);
                    $0b2e6adb871a3b94$var$vb(h, g);
                    var l = $0b2e6adb871a3b94$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $0b2e6adb871a3b94$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $0b2e6adb871a3b94$var$nb(e, q) : "children" === m ? $0b2e6adb871a3b94$var$ob(e, q) : $0b2e6adb871a3b94$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $0b2e6adb871a3b94$var$bb(e, f);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.defaultValue, !0) : $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$0b2e6adb871a3b94$var$Pf] = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($0b2e6adb871a3b94$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $0b2e6adb871a3b94$var$bd(b.containerInfo);
            } catch (t) {
                $0b2e6adb871a3b94$var$W(a, a.return, t);
            }
            break;
        case 4:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            break;
        case 13:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($0b2e6adb871a3b94$var$gk = $0b2e6adb871a3b94$var$B()));
            d & 4 && $0b2e6adb871a3b94$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($0b2e6adb871a3b94$var$U = (l = $0b2e6adb871a3b94$var$U) || m, $0b2e6adb871a3b94$var$dk(b, a), $0b2e6adb871a3b94$var$U = l) : $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($0b2e6adb871a3b94$var$V = a, m = a.child; null !== m;){
                    for(q = $0b2e6adb871a3b94$var$V = m; null !== $0b2e6adb871a3b94$var$V;){
                        r = $0b2e6adb871a3b94$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $0b2e6adb871a3b94$var$Qj(4, r, r.return);
                                break;
                            case 1:
                                $0b2e6adb871a3b94$var$Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $0b2e6adb871a3b94$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $0b2e6adb871a3b94$var$Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $0b2e6adb871a3b94$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $0b2e6adb871a3b94$var$V = y) : $0b2e6adb871a3b94$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $0b2e6adb871a3b94$var$rb("display", g));
                            } catch (t) {
                                $0b2e6adb871a3b94$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $0b2e6adb871a3b94$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            d & 4 && $0b2e6adb871a3b94$var$bk(a);
            break;
        case 21:
            break;
        default:
            $0b2e6adb871a3b94$var$dk(b, a), $0b2e6adb871a3b94$var$fk(a);
    }
}
function $0b2e6adb871a3b94$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($0b2e6adb871a3b94$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($0b2e6adb871a3b94$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($0b2e6adb871a3b94$var$ob(e, ""), d.flags &= -33);
                    var f = $0b2e6adb871a3b94$var$Vj(a);
                    $0b2e6adb871a3b94$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $0b2e6adb871a3b94$var$Vj(a);
                    $0b2e6adb871a3b94$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(161));
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $0b2e6adb871a3b94$var$ik(a, b, c) {
    $0b2e6adb871a3b94$var$V = a;
    $0b2e6adb871a3b94$var$jk(a, b, c);
}
function $0b2e6adb871a3b94$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $0b2e6adb871a3b94$var$V;){
        var e = $0b2e6adb871a3b94$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $0b2e6adb871a3b94$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $0b2e6adb871a3b94$var$U;
                h = $0b2e6adb871a3b94$var$Kj;
                var l = $0b2e6adb871a3b94$var$U;
                $0b2e6adb871a3b94$var$Kj = g;
                if (($0b2e6adb871a3b94$var$U = k) && !l) for($0b2e6adb871a3b94$var$V = e; null !== $0b2e6adb871a3b94$var$V;)g = $0b2e6adb871a3b94$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $0b2e6adb871a3b94$var$kk(e) : null !== k ? (k.return = g, $0b2e6adb871a3b94$var$V = k) : $0b2e6adb871a3b94$var$kk(e);
                for(; null !== f;)$0b2e6adb871a3b94$var$V = f, $0b2e6adb871a3b94$var$jk(f, b, c), f = f.sibling;
                $0b2e6adb871a3b94$var$V = e;
                $0b2e6adb871a3b94$var$Kj = h;
                $0b2e6adb871a3b94$var$U = l;
            }
            $0b2e6adb871a3b94$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $0b2e6adb871a3b94$var$V = f) : $0b2e6adb871a3b94$var$lk(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$lk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$0b2e6adb871a3b94$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $0b2e6adb871a3b94$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $0b2e6adb871a3b94$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $0b2e6adb871a3b94$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $0b2e6adb871a3b94$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($0b2e6adb871a3b94$var$p(163));
                }
                $0b2e6adb871a3b94$var$U || b.flags & 512 && $0b2e6adb871a3b94$var$Sj(b);
            } catch (r) {
                $0b2e6adb871a3b94$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$hk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$kk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Rj(4, b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $0b2e6adb871a3b94$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Sj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Sj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(b, b.return, k);
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $0b2e6adb871a3b94$var$V = h;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
var $0b2e6adb871a3b94$var$mk = Math.ceil, $0b2e6adb871a3b94$var$nk = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$ok = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$pk = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$K = 0, $0b2e6adb871a3b94$var$R = null, $0b2e6adb871a3b94$var$Y = null, $0b2e6adb871a3b94$var$Z = 0, $0b2e6adb871a3b94$var$gj = 0, $0b2e6adb871a3b94$var$fj = $0b2e6adb871a3b94$var$Uf(0), $0b2e6adb871a3b94$var$T = 0, $0b2e6adb871a3b94$var$qk = null, $0b2e6adb871a3b94$var$hh = 0, $0b2e6adb871a3b94$var$rk = 0, $0b2e6adb871a3b94$var$sk = 0, $0b2e6adb871a3b94$var$tk = null, $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$gk = 0, $0b2e6adb871a3b94$var$Hj = Infinity, $0b2e6adb871a3b94$var$vk = null, $0b2e6adb871a3b94$var$Pi = !1, $0b2e6adb871a3b94$var$Qi = null, $0b2e6adb871a3b94$var$Si = null, $0b2e6adb871a3b94$var$wk = !1, $0b2e6adb871a3b94$var$xk = null, $0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = 0, $0b2e6adb871a3b94$var$Ak = null, $0b2e6adb871a3b94$var$Bk = -1, $0b2e6adb871a3b94$var$Ck = 0;
function $0b2e6adb871a3b94$var$L() {
    return 0 !== ($0b2e6adb871a3b94$var$K & 6) ? $0b2e6adb871a3b94$var$B() : -1 !== $0b2e6adb871a3b94$var$Bk ? $0b2e6adb871a3b94$var$Bk : $0b2e6adb871a3b94$var$Bk = $0b2e6adb871a3b94$var$B();
}
function $0b2e6adb871a3b94$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2) && 0 !== $0b2e6adb871a3b94$var$Z) return $0b2e6adb871a3b94$var$Z & -$0b2e6adb871a3b94$var$Z;
    if (null !== $0b2e6adb871a3b94$var$Kg.transition) return 0 === $0b2e6adb871a3b94$var$Ck && ($0b2e6adb871a3b94$var$Ck = $0b2e6adb871a3b94$var$yc()), $0b2e6adb871a3b94$var$Ck;
    a = $0b2e6adb871a3b94$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $0b2e6adb871a3b94$var$jd(a.type);
    return a;
}
function $0b2e6adb871a3b94$var$mh(a, b, c, d) {
    if (50 < $0b2e6adb871a3b94$var$zk) throw $0b2e6adb871a3b94$var$zk = 0, $0b2e6adb871a3b94$var$Ak = null, Error($0b2e6adb871a3b94$var$p(185));
    $0b2e6adb871a3b94$var$Ac(a, c, d);
    if (0 === ($0b2e6adb871a3b94$var$K & 2) || a !== $0b2e6adb871a3b94$var$R) a === $0b2e6adb871a3b94$var$R && (0 === ($0b2e6adb871a3b94$var$K & 2) && ($0b2e6adb871a3b94$var$rk |= c), 4 === $0b2e6adb871a3b94$var$T && $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$Z)), $0b2e6adb871a3b94$var$Ek(a, d), 1 === c && 0 === $0b2e6adb871a3b94$var$K && 0 === (b.mode & 1) && ($0b2e6adb871a3b94$var$Hj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
}
function $0b2e6adb871a3b94$var$Ek(a, b) {
    var c = a.callbackNode;
    $0b2e6adb871a3b94$var$wc(a, b);
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$R ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) null !== c && $0b2e6adb871a3b94$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $0b2e6adb871a3b94$var$bc(c);
        if (1 === b) 0 === a.tag ? $0b2e6adb871a3b94$var$ig($0b2e6adb871a3b94$var$Fk.bind(null, a)) : $0b2e6adb871a3b94$var$hg($0b2e6adb871a3b94$var$Fk.bind(null, a)), $0b2e6adb871a3b94$var$Jf(function() {
            0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
        }), c = null;
        else {
            switch($0b2e6adb871a3b94$var$Dc(d)){
                case 1:
                    c = $0b2e6adb871a3b94$var$fc;
                    break;
                case 4:
                    c = $0b2e6adb871a3b94$var$gc;
                    break;
                case 16:
                    c = $0b2e6adb871a3b94$var$hc;
                    break;
                case 536870912:
                    c = $0b2e6adb871a3b94$var$jc;
                    break;
                default:
                    c = $0b2e6adb871a3b94$var$hc;
            }
            c = $0b2e6adb871a3b94$var$Gk(c, $0b2e6adb871a3b94$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $0b2e6adb871a3b94$var$Hk(a, b) {
    $0b2e6adb871a3b94$var$Bk = -1;
    $0b2e6adb871a3b94$var$Ck = 0;
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    var c = a.callbackNode;
    if ($0b2e6adb871a3b94$var$Ik() && a.callbackNode !== c) return null;
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$R ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $0b2e6adb871a3b94$var$Jk(a, d);
    else {
        b = d;
        var e = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 2;
        var f = $0b2e6adb871a3b94$var$Kk();
        if ($0b2e6adb871a3b94$var$R !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$vk = null, $0b2e6adb871a3b94$var$Hj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$Lk(a, b);
        for(;;)try {
            $0b2e6adb871a3b94$var$Mk();
            break;
        } catch (h) {
            $0b2e6adb871a3b94$var$Nk(a, h);
        }
        $0b2e6adb871a3b94$var$Qg();
        $0b2e6adb871a3b94$var$nk.current = f;
        $0b2e6adb871a3b94$var$K = e;
        null !== $0b2e6adb871a3b94$var$Y ? b = 0 : ($0b2e6adb871a3b94$var$R = null, $0b2e6adb871a3b94$var$Z = 0, b = $0b2e6adb871a3b94$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $0b2e6adb871a3b94$var$xc(a), 0 !== e && (d = e, b = $0b2e6adb871a3b94$var$Ok(a, e)));
        if (1 === b) throw c = $0b2e6adb871a3b94$var$qk, $0b2e6adb871a3b94$var$Lk(a, 0), $0b2e6adb871a3b94$var$Dk(a, d), $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B()), c;
        if (6 === b) $0b2e6adb871a3b94$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$0b2e6adb871a3b94$var$Pk(e) && (b = $0b2e6adb871a3b94$var$Jk(a, d), 2 === b && (f = $0b2e6adb871a3b94$var$xc(a), 0 !== f && (d = f, b = $0b2e6adb871a3b94$var$Ok(a, f))), 1 === b)) throw c = $0b2e6adb871a3b94$var$qk, $0b2e6adb871a3b94$var$Lk(a, 0), $0b2e6adb871a3b94$var$Dk(a, d), $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($0b2e6adb871a3b94$var$p(345));
                case 2:
                    $0b2e6adb871a3b94$var$Qk(a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk);
                    break;
                case 3:
                    $0b2e6adb871a3b94$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $0b2e6adb871a3b94$var$gk + 500 - $0b2e6adb871a3b94$var$B(), 10 < b)) {
                        if (0 !== $0b2e6adb871a3b94$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $0b2e6adb871a3b94$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Qk.bind(null, a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk), b);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Qk(a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk);
                    break;
                case 4:
                    $0b2e6adb871a3b94$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $0b2e6adb871a3b94$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $0b2e6adb871a3b94$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $0b2e6adb871a3b94$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Qk.bind(null, a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk), d);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Qk(a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk);
                    break;
                case 5:
                    $0b2e6adb871a3b94$var$Qk(a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(329));
            }
        }
    }
    $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B());
    return a.callbackNode === c ? $0b2e6adb871a3b94$var$Hk.bind(null, a) : null;
}
function $0b2e6adb871a3b94$var$Ok(a, b) {
    var c = $0b2e6adb871a3b94$var$tk;
    a.current.memoizedState.isDehydrated && ($0b2e6adb871a3b94$var$Lk(a, b).flags |= 256);
    a = $0b2e6adb871a3b94$var$Jk(a, b);
    2 !== a && (b = $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$uk = c, null !== b && $0b2e6adb871a3b94$var$Gj(b));
    return a;
}
function $0b2e6adb871a3b94$var$Gj(a) {
    null === $0b2e6adb871a3b94$var$uk ? $0b2e6adb871a3b94$var$uk = a : $0b2e6adb871a3b94$var$uk.push.apply($0b2e6adb871a3b94$var$uk, a);
}
function $0b2e6adb871a3b94$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$0b2e6adb871a3b94$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Dk(a, b) {
    b &= ~$0b2e6adb871a3b94$var$sk;
    b &= ~$0b2e6adb871a3b94$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $0b2e6adb871a3b94$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $0b2e6adb871a3b94$var$Fk(a) {
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    $0b2e6adb871a3b94$var$Ik();
    var b = $0b2e6adb871a3b94$var$uc(a, 0);
    if (0 === (b & 1)) return $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B()), null;
    var c = $0b2e6adb871a3b94$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $0b2e6adb871a3b94$var$xc(a);
        0 !== d && (b = d, c = $0b2e6adb871a3b94$var$Ok(a, d));
    }
    if (1 === c) throw c = $0b2e6adb871a3b94$var$qk, $0b2e6adb871a3b94$var$Lk(a, 0), $0b2e6adb871a3b94$var$Dk(a, b), $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B()), c;
    if (6 === c) throw Error($0b2e6adb871a3b94$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $0b2e6adb871a3b94$var$Qk(a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk);
    $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B());
    return null;
}
function $0b2e6adb871a3b94$var$Rk(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    try {
        return a(b);
    } finally{
        $0b2e6adb871a3b94$var$K = c, 0 === $0b2e6adb871a3b94$var$K && ($0b2e6adb871a3b94$var$Hj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
    }
}
function $0b2e6adb871a3b94$var$Sk(a) {
    null !== $0b2e6adb871a3b94$var$xk && 0 === $0b2e6adb871a3b94$var$xk.tag && 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$Ik();
    var b = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    var c = $0b2e6adb871a3b94$var$pk.transition, d = $0b2e6adb871a3b94$var$C;
    try {
        if ($0b2e6adb871a3b94$var$pk.transition = null, $0b2e6adb871a3b94$var$C = 1, a) return a();
    } finally{
        $0b2e6adb871a3b94$var$C = d, $0b2e6adb871a3b94$var$pk.transition = c, $0b2e6adb871a3b94$var$K = b, 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
    }
}
function $0b2e6adb871a3b94$var$Ij() {
    $0b2e6adb871a3b94$var$gj = $0b2e6adb871a3b94$var$fj.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$fj);
}
function $0b2e6adb871a3b94$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $0b2e6adb871a3b94$var$Gf(c));
    if (null !== $0b2e6adb871a3b94$var$Y) for(c = $0b2e6adb871a3b94$var$Y.return; null !== c;){
        var d = c;
        $0b2e6adb871a3b94$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $0b2e6adb871a3b94$var$$f();
                break;
            case 3:
                $0b2e6adb871a3b94$var$Jh();
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
                $0b2e6adb871a3b94$var$Oh();
                break;
            case 5:
                $0b2e6adb871a3b94$var$Lh(d);
                break;
            case 4:
                $0b2e6adb871a3b94$var$Jh();
                break;
            case 13:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M);
                break;
            case 19:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M);
                break;
            case 10:
                $0b2e6adb871a3b94$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $0b2e6adb871a3b94$var$Ij();
        }
        c = c.return;
    }
    $0b2e6adb871a3b94$var$R = a;
    $0b2e6adb871a3b94$var$Y = a = $0b2e6adb871a3b94$var$wh(a.current, null);
    $0b2e6adb871a3b94$var$Z = $0b2e6adb871a3b94$var$gj = b;
    $0b2e6adb871a3b94$var$T = 0;
    $0b2e6adb871a3b94$var$qk = null;
    $0b2e6adb871a3b94$var$sk = $0b2e6adb871a3b94$var$rk = $0b2e6adb871a3b94$var$hh = 0;
    $0b2e6adb871a3b94$var$uk = $0b2e6adb871a3b94$var$tk = null;
    if (null !== $0b2e6adb871a3b94$var$Wg) {
        for(b = 0; b < $0b2e6adb871a3b94$var$Wg.length; b++)if (c = $0b2e6adb871a3b94$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $0b2e6adb871a3b94$var$Wg = null;
    }
    return a;
}
function $0b2e6adb871a3b94$var$Nk(a, b) {
    do {
        var c = $0b2e6adb871a3b94$var$Y;
        try {
            $0b2e6adb871a3b94$var$Qg();
            $0b2e6adb871a3b94$var$Ph.current = $0b2e6adb871a3b94$var$ai;
            if ($0b2e6adb871a3b94$var$Sh) {
                for(var d = $0b2e6adb871a3b94$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $0b2e6adb871a3b94$var$Sh = !1;
            }
            $0b2e6adb871a3b94$var$Rh = 0;
            $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = null;
            $0b2e6adb871a3b94$var$Th = !1;
            $0b2e6adb871a3b94$var$Uh = 0;
            $0b2e6adb871a3b94$var$ok.current = null;
            if (null === c || null === c.return) {
                $0b2e6adb871a3b94$var$T = 1;
                $0b2e6adb871a3b94$var$qk = b;
                $0b2e6adb871a3b94$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $0b2e6adb871a3b94$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $0b2e6adb871a3b94$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $0b2e6adb871a3b94$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $0b2e6adb871a3b94$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $0b2e6adb871a3b94$var$Ti(f, l, b);
                            $0b2e6adb871a3b94$var$uj();
                            break a;
                        }
                        k = Error($0b2e6adb871a3b94$var$p(426));
                    }
                } else if ($0b2e6adb871a3b94$var$I && h.mode & 1) {
                    var J = $0b2e6adb871a3b94$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $0b2e6adb871a3b94$var$Wi(J, g, h, f, b);
                        $0b2e6adb871a3b94$var$Jg($0b2e6adb871a3b94$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $0b2e6adb871a3b94$var$Ki(k, h);
                4 !== $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 2);
                null === $0b2e6adb871a3b94$var$tk ? $0b2e6adb871a3b94$var$tk = [
                    f
                ] : $0b2e6adb871a3b94$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $0b2e6adb871a3b94$var$Oi(f, k, b);
                            $0b2e6adb871a3b94$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $0b2e6adb871a3b94$var$Si || !$0b2e6adb871a3b94$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $0b2e6adb871a3b94$var$Ri(f, h, b);
                                $0b2e6adb871a3b94$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $0b2e6adb871a3b94$var$Tk(c);
        } catch (na) {
            b = na;
            $0b2e6adb871a3b94$var$Y === c && null !== c && ($0b2e6adb871a3b94$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $0b2e6adb871a3b94$var$Kk() {
    var a = $0b2e6adb871a3b94$var$nk.current;
    $0b2e6adb871a3b94$var$nk.current = $0b2e6adb871a3b94$var$ai;
    return null === a ? $0b2e6adb871a3b94$var$ai : a;
}
function $0b2e6adb871a3b94$var$uj() {
    if (0 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T || 2 === $0b2e6adb871a3b94$var$T) $0b2e6adb871a3b94$var$T = 4;
    null === $0b2e6adb871a3b94$var$R || 0 === ($0b2e6adb871a3b94$var$hh & 268435455) && 0 === ($0b2e6adb871a3b94$var$rk & 268435455) || $0b2e6adb871a3b94$var$Dk($0b2e6adb871a3b94$var$R, $0b2e6adb871a3b94$var$Z);
}
function $0b2e6adb871a3b94$var$Jk(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 2;
    var d = $0b2e6adb871a3b94$var$Kk();
    if ($0b2e6adb871a3b94$var$R !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$vk = null, $0b2e6adb871a3b94$var$Lk(a, b);
    for(;;)try {
        $0b2e6adb871a3b94$var$Uk();
        break;
    } catch (e) {
        $0b2e6adb871a3b94$var$Nk(a, e);
    }
    $0b2e6adb871a3b94$var$Qg();
    $0b2e6adb871a3b94$var$K = c;
    $0b2e6adb871a3b94$var$nk.current = d;
    if (null !== $0b2e6adb871a3b94$var$Y) throw Error($0b2e6adb871a3b94$var$p(261));
    $0b2e6adb871a3b94$var$R = null;
    $0b2e6adb871a3b94$var$Z = 0;
    return $0b2e6adb871a3b94$var$T;
}
function $0b2e6adb871a3b94$var$Uk() {
    for(; null !== $0b2e6adb871a3b94$var$Y;)$0b2e6adb871a3b94$var$Vk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Mk() {
    for(; null !== $0b2e6adb871a3b94$var$Y && !$0b2e6adb871a3b94$var$cc();)$0b2e6adb871a3b94$var$Vk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Vk(a) {
    var b = $0b2e6adb871a3b94$var$Wk(a.alternate, a, $0b2e6adb871a3b94$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $0b2e6adb871a3b94$var$Tk(a) : $0b2e6adb871a3b94$var$Y = b;
    $0b2e6adb871a3b94$var$ok.current = null;
}
function $0b2e6adb871a3b94$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $0b2e6adb871a3b94$var$Fj(c, b, $0b2e6adb871a3b94$var$gj), null !== c) {
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
        } else {
            c = $0b2e6adb871a3b94$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $0b2e6adb871a3b94$var$T = 6;
                $0b2e6adb871a3b94$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $0b2e6adb871a3b94$var$Y = b;
            return;
        }
        $0b2e6adb871a3b94$var$Y = b = a;
    }while (null !== b);
    0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 5);
}
function $0b2e6adb871a3b94$var$Qk(a, b, c) {
    var d = $0b2e6adb871a3b94$var$C, e = $0b2e6adb871a3b94$var$pk.transition;
    try {
        $0b2e6adb871a3b94$var$pk.transition = null, $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$Xk(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$pk.transition = e, $0b2e6adb871a3b94$var$C = d;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Xk(a, b, c, d) {
    do $0b2e6adb871a3b94$var$Ik();
    while (null !== $0b2e6adb871a3b94$var$xk);
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($0b2e6adb871a3b94$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $0b2e6adb871a3b94$var$Bc(a, f);
    a === $0b2e6adb871a3b94$var$R && ($0b2e6adb871a3b94$var$Y = $0b2e6adb871a3b94$var$R = null, $0b2e6adb871a3b94$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $0b2e6adb871a3b94$var$wk || ($0b2e6adb871a3b94$var$wk = !0, $0b2e6adb871a3b94$var$Gk($0b2e6adb871a3b94$var$hc, function() {
        $0b2e6adb871a3b94$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $0b2e6adb871a3b94$var$pk.transition;
        $0b2e6adb871a3b94$var$pk.transition = null;
        var g = $0b2e6adb871a3b94$var$C;
        $0b2e6adb871a3b94$var$C = 1;
        var h = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 4;
        $0b2e6adb871a3b94$var$ok.current = null;
        $0b2e6adb871a3b94$var$Pj(a, c);
        $0b2e6adb871a3b94$var$ek(c, a);
        $0b2e6adb871a3b94$var$Oe($0b2e6adb871a3b94$var$Df);
        $0b2e6adb871a3b94$var$dd = !!$0b2e6adb871a3b94$var$Cf;
        $0b2e6adb871a3b94$var$Df = $0b2e6adb871a3b94$var$Cf = null;
        a.current = c;
        $0b2e6adb871a3b94$var$ik(c, a, e);
        $0b2e6adb871a3b94$var$dc();
        $0b2e6adb871a3b94$var$K = h;
        $0b2e6adb871a3b94$var$C = g;
        $0b2e6adb871a3b94$var$pk.transition = f;
    } else a.current = c;
    $0b2e6adb871a3b94$var$wk && ($0b2e6adb871a3b94$var$wk = !1, $0b2e6adb871a3b94$var$xk = a, $0b2e6adb871a3b94$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($0b2e6adb871a3b94$var$Si = null);
    $0b2e6adb871a3b94$var$mc(c.stateNode, d);
    $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($0b2e6adb871a3b94$var$Pi) throw $0b2e6adb871a3b94$var$Pi = !1, a = $0b2e6adb871a3b94$var$Qi, $0b2e6adb871a3b94$var$Qi = null, a;
    0 !== ($0b2e6adb871a3b94$var$yk & 1) && 0 !== a.tag && $0b2e6adb871a3b94$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $0b2e6adb871a3b94$var$Ak ? $0b2e6adb871a3b94$var$zk++ : ($0b2e6adb871a3b94$var$zk = 0, $0b2e6adb871a3b94$var$Ak = a) : $0b2e6adb871a3b94$var$zk = 0;
    $0b2e6adb871a3b94$var$jg();
    return null;
}
function $0b2e6adb871a3b94$var$Ik() {
    if (null !== $0b2e6adb871a3b94$var$xk) {
        var a = $0b2e6adb871a3b94$var$Dc($0b2e6adb871a3b94$var$yk), b = $0b2e6adb871a3b94$var$pk.transition, c = $0b2e6adb871a3b94$var$C;
        try {
            $0b2e6adb871a3b94$var$pk.transition = null;
            $0b2e6adb871a3b94$var$C = 16 > a ? 16 : a;
            if (null === $0b2e6adb871a3b94$var$xk) var d = !1;
            else {
                a = $0b2e6adb871a3b94$var$xk;
                $0b2e6adb871a3b94$var$xk = null;
                $0b2e6adb871a3b94$var$yk = 0;
                if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(331));
                var e = $0b2e6adb871a3b94$var$K;
                $0b2e6adb871a3b94$var$K |= 4;
                for($0b2e6adb871a3b94$var$V = a.current; null !== $0b2e6adb871a3b94$var$V;){
                    var f = $0b2e6adb871a3b94$var$V, g = f.child;
                    if (0 !== ($0b2e6adb871a3b94$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($0b2e6adb871a3b94$var$V = l; null !== $0b2e6adb871a3b94$var$V;){
                                    var m = $0b2e6adb871a3b94$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $0b2e6adb871a3b94$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $0b2e6adb871a3b94$var$V = q;
                                    else for(; null !== $0b2e6adb871a3b94$var$V;){
                                        m = $0b2e6adb871a3b94$var$V;
                                        var r = m.sibling, y = m.return;
                                        $0b2e6adb871a3b94$var$Tj(m);
                                        if (m === l) {
                                            $0b2e6adb871a3b94$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $0b2e6adb871a3b94$var$V = r;
                                            break;
                                        }
                                        $0b2e6adb871a3b94$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $0b2e6adb871a3b94$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $0b2e6adb871a3b94$var$V = g;
                    else b: for(; null !== $0b2e6adb871a3b94$var$V;){
                        f = $0b2e6adb871a3b94$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $0b2e6adb871a3b94$var$Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $0b2e6adb871a3b94$var$V = x;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = f.return;
                    }
                }
                var w = a.current;
                for($0b2e6adb871a3b94$var$V = w; null !== $0b2e6adb871a3b94$var$V;){
                    g = $0b2e6adb871a3b94$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $0b2e6adb871a3b94$var$V = u;
                    else b: for(g = w; null !== $0b2e6adb871a3b94$var$V;){
                        h = $0b2e6adb871a3b94$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $0b2e6adb871a3b94$var$Rj(9, h);
                            }
                        } catch (na) {
                            $0b2e6adb871a3b94$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $0b2e6adb871a3b94$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $0b2e6adb871a3b94$var$V = F;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = h.return;
                    }
                }
                $0b2e6adb871a3b94$var$K = e;
                $0b2e6adb871a3b94$var$jg();
                if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot) try {
                    $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot($0b2e6adb871a3b94$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$pk.transition = b;
        }
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Yk(a, b, c) {
    b = $0b2e6adb871a3b94$var$Ki(c, b);
    b = $0b2e6adb871a3b94$var$Oi(a, b, 1);
    a = $0b2e6adb871a3b94$var$dh(a, b, 1);
    b = $0b2e6adb871a3b94$var$L();
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, 1, b), $0b2e6adb871a3b94$var$Ek(a, b));
}
function $0b2e6adb871a3b94$var$W(a, b, c) {
    if (3 === a.tag) $0b2e6adb871a3b94$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $0b2e6adb871a3b94$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $0b2e6adb871a3b94$var$Si || !$0b2e6adb871a3b94$var$Si.has(d))) {
                a = $0b2e6adb871a3b94$var$Ki(c, a);
                a = $0b2e6adb871a3b94$var$Ri(b, a, 1);
                b = $0b2e6adb871a3b94$var$dh(b, a, 1);
                a = $0b2e6adb871a3b94$var$L();
                null !== b && ($0b2e6adb871a3b94$var$Ac(b, 1, a), $0b2e6adb871a3b94$var$Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $0b2e6adb871a3b94$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $0b2e6adb871a3b94$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $0b2e6adb871a3b94$var$R === a && ($0b2e6adb871a3b94$var$Z & c) === c && (4 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$Z & 130023424) === $0b2e6adb871a3b94$var$Z && 500 > $0b2e6adb871a3b94$var$B() - $0b2e6adb871a3b94$var$gk ? $0b2e6adb871a3b94$var$Lk(a, 0) : $0b2e6adb871a3b94$var$sk |= c);
    $0b2e6adb871a3b94$var$Ek(a, b);
}
function $0b2e6adb871a3b94$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $0b2e6adb871a3b94$var$sc, $0b2e6adb871a3b94$var$sc <<= 1, 0 === ($0b2e6adb871a3b94$var$sc & 130023424) && ($0b2e6adb871a3b94$var$sc = 4194304)));
    var c = $0b2e6adb871a3b94$var$L();
    a = $0b2e6adb871a3b94$var$Zg(a, b);
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, b, c), $0b2e6adb871a3b94$var$Ek(a, c));
}
function $0b2e6adb871a3b94$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $0b2e6adb871a3b94$var$Zk(a, c);
}
function $0b2e6adb871a3b94$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($0b2e6adb871a3b94$var$p(314));
    }
    null !== d && d.delete(b);
    $0b2e6adb871a3b94$var$Zk(a, c);
}
var $0b2e6adb871a3b94$var$Wk;
$0b2e6adb871a3b94$var$Wk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $0b2e6adb871a3b94$var$Wf.current) $0b2e6adb871a3b94$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $0b2e6adb871a3b94$var$Ug = !1, $0b2e6adb871a3b94$var$zj(a, b, c);
            $0b2e6adb871a3b94$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $0b2e6adb871a3b94$var$Ug = !1, $0b2e6adb871a3b94$var$I && 0 !== (b.flags & 1048576) && $0b2e6adb871a3b94$var$ug(b, $0b2e6adb871a3b94$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $0b2e6adb871a3b94$var$jj(a, b);
            a = b.pendingProps;
            var e = $0b2e6adb871a3b94$var$Yf(b, $0b2e6adb871a3b94$var$H.current);
            $0b2e6adb871a3b94$var$Tg(b, c);
            e = $0b2e6adb871a3b94$var$Xh(null, b, d, a, e, c);
            var f = $0b2e6adb871a3b94$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $0b2e6adb871a3b94$var$Zf(d) ? (f = !0, $0b2e6adb871a3b94$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $0b2e6adb871a3b94$var$ah(b), e.updater = $0b2e6adb871a3b94$var$nh, b.stateNode = e, e._reactInternals = b, $0b2e6adb871a3b94$var$rh(b, d, a, c), b = $0b2e6adb871a3b94$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $0b2e6adb871a3b94$var$I && f && $0b2e6adb871a3b94$var$vg(b), $0b2e6adb871a3b94$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $0b2e6adb871a3b94$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $0b2e6adb871a3b94$var$$k(d);
                a = $0b2e6adb871a3b94$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $0b2e6adb871a3b94$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $0b2e6adb871a3b94$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $0b2e6adb871a3b94$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $0b2e6adb871a3b94$var$aj(null, b, d, $0b2e6adb871a3b94$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($0b2e6adb871a3b94$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Lg(d, e), $0b2e6adb871a3b94$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Lg(d, e), $0b2e6adb871a3b94$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $0b2e6adb871a3b94$var$lj(b);
                if (null === a) throw Error($0b2e6adb871a3b94$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $0b2e6adb871a3b94$var$bh(a, b);
                $0b2e6adb871a3b94$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(423)), b);
                        b = $0b2e6adb871a3b94$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(424)), b);
                        b = $0b2e6adb871a3b94$var$mj(a, b, d, c, e);
                        break a;
                    } else for($0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.stateNode.containerInfo.firstChild), $0b2e6adb871a3b94$var$xg = b, $0b2e6adb871a3b94$var$I = !0, $0b2e6adb871a3b94$var$zg = null, c = $0b2e6adb871a3b94$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $0b2e6adb871a3b94$var$Ig();
                    if (d === e) {
                        b = $0b2e6adb871a3b94$var$$i(a, b, c);
                        break a;
                    }
                    $0b2e6adb871a3b94$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $0b2e6adb871a3b94$var$Kh(b), null === a && $0b2e6adb871a3b94$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $0b2e6adb871a3b94$var$Ef(d, e) ? g = null : null !== f && $0b2e6adb871a3b94$var$Ef(d, f) && (b.flags |= 32), $0b2e6adb871a3b94$var$hj(a, b), $0b2e6adb871a3b94$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $0b2e6adb871a3b94$var$Eg(b), null;
        case 13:
            return $0b2e6adb871a3b94$var$pj(a, b, c);
        case 4:
            return $0b2e6adb871a3b94$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $0b2e6adb871a3b94$var$Bh(b, null, d, c) : $0b2e6adb871a3b94$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Lg(d, e), $0b2e6adb871a3b94$var$Zi(a, b, d, e, c);
        case 7:
            return $0b2e6adb871a3b94$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $0b2e6adb871a3b94$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $0b2e6adb871a3b94$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($0b2e6adb871a3b94$var$He(f.value, g)) {
                        if (f.children === e.children && !$0b2e6adb871a3b94$var$Wf.current) {
                            b = $0b2e6adb871a3b94$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $0b2e6adb871a3b94$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $0b2e6adb871a3b94$var$Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($0b2e6adb871a3b94$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $0b2e6adb871a3b94$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $0b2e6adb871a3b94$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $0b2e6adb871a3b94$var$Tg(b, c), e = $0b2e6adb871a3b94$var$Vg(e), d = d(e), b.flags |= 1, $0b2e6adb871a3b94$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $0b2e6adb871a3b94$var$Lg(d, b.pendingProps), e = $0b2e6adb871a3b94$var$Lg(d.type, e), $0b2e6adb871a3b94$var$aj(a, b, d, e, c);
        case 15:
            return $0b2e6adb871a3b94$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Lg(d, e), $0b2e6adb871a3b94$var$jj(a, b), b.tag = 1, $0b2e6adb871a3b94$var$Zf(d) ? (a = !0, $0b2e6adb871a3b94$var$cg(b)) : a = !1, $0b2e6adb871a3b94$var$Tg(b, c), $0b2e6adb871a3b94$var$ph(b, d, e), $0b2e6adb871a3b94$var$rh(b, d, e, c), $0b2e6adb871a3b94$var$kj(null, b, d, !0, a, c);
        case 19:
            return $0b2e6adb871a3b94$var$yj(a, b, c);
        case 22:
            return $0b2e6adb871a3b94$var$ej(a, b, c);
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
};
function $0b2e6adb871a3b94$var$Gk(a, b) {
    return $0b2e6adb871a3b94$var$ac(a, b);
}
function $0b2e6adb871a3b94$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $0b2e6adb871a3b94$var$Bg(a, b, c, d) {
    return new $0b2e6adb871a3b94$var$al(a, b, c, d);
}
function $0b2e6adb871a3b94$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $0b2e6adb871a3b94$var$$k(a) {
    if ("function" === typeof a) return $0b2e6adb871a3b94$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $0b2e6adb871a3b94$var$Da) return 11;
        if (a === $0b2e6adb871a3b94$var$Ga) return 14;
    }
    return 2;
}
function $0b2e6adb871a3b94$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $0b2e6adb871a3b94$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $0b2e6adb871a3b94$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $0b2e6adb871a3b94$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return $0b2e6adb871a3b94$var$Ah(c.children, e, f, b);
        case $0b2e6adb871a3b94$var$za:
            g = 8;
            e |= 8;
            break;
        case $0b2e6adb871a3b94$var$Aa:
            return a = $0b2e6adb871a3b94$var$Bg(12, c, b, e | 2), a.elementType = $0b2e6adb871a3b94$var$Aa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ea:
            return a = $0b2e6adb871a3b94$var$Bg(13, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Ea, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Fa:
            return a = $0b2e6adb871a3b94$var$Bg(19, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Fa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ia:
            return $0b2e6adb871a3b94$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $0b2e6adb871a3b94$var$Ba:
                    g = 10;
                    break a;
                case $0b2e6adb871a3b94$var$Ca:
                    g = 9;
                    break a;
                case $0b2e6adb871a3b94$var$Da:
                    g = 11;
                    break a;
                case $0b2e6adb871a3b94$var$Ga:
                    g = 14;
                    break a;
                case $0b2e6adb871a3b94$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($0b2e6adb871a3b94$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $0b2e6adb871a3b94$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $0b2e6adb871a3b94$var$Ah(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$qj(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(22, a, d, b);
    a.elementType = $0b2e6adb871a3b94$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $0b2e6adb871a3b94$var$xh(a, b, c) {
    a = $0b2e6adb871a3b94$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$zh(a, b, c) {
    b = $0b2e6adb871a3b94$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $0b2e6adb871a3b94$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $0b2e6adb871a3b94$var$zc(0);
    this.expirationTimes = $0b2e6adb871a3b94$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $0b2e6adb871a3b94$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $0b2e6adb871a3b94$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $0b2e6adb871a3b94$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $0b2e6adb871a3b94$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $0b2e6adb871a3b94$var$ah(f);
    return a;
}
function $0b2e6adb871a3b94$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $0b2e6adb871a3b94$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $0b2e6adb871a3b94$var$el(a) {
    if (!a) return $0b2e6adb871a3b94$var$Vf;
    a = a._reactInternals;
    a: {
        if ($0b2e6adb871a3b94$var$Vb(a) !== a || 1 !== a.tag) throw Error($0b2e6adb871a3b94$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($0b2e6adb871a3b94$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($0b2e6adb871a3b94$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($0b2e6adb871a3b94$var$Zf(c)) return $0b2e6adb871a3b94$var$bg(a, c, b);
    }
    return b;
}
function $0b2e6adb871a3b94$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $0b2e6adb871a3b94$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $0b2e6adb871a3b94$var$el(null);
    c = a.current;
    d = $0b2e6adb871a3b94$var$L();
    e = $0b2e6adb871a3b94$var$lh(c);
    f = $0b2e6adb871a3b94$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $0b2e6adb871a3b94$var$dh(c, f, e);
    a.current.lanes = e;
    $0b2e6adb871a3b94$var$Ac(a, e, d);
    $0b2e6adb871a3b94$var$Ek(a, d);
    return a;
}
function $0b2e6adb871a3b94$var$gl(a, b, c, d) {
    var e = b.current, f = $0b2e6adb871a3b94$var$L(), g = $0b2e6adb871a3b94$var$lh(e);
    c = $0b2e6adb871a3b94$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $0b2e6adb871a3b94$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $0b2e6adb871a3b94$var$dh(e, b, g);
    null !== a && ($0b2e6adb871a3b94$var$mh(a, e, g, f), $0b2e6adb871a3b94$var$eh(a, e, g));
    return g;
}
function $0b2e6adb871a3b94$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $0b2e6adb871a3b94$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $0b2e6adb871a3b94$var$jl(a, b) {
    $0b2e6adb871a3b94$var$il(a, b);
    (a = a.alternate) && $0b2e6adb871a3b94$var$il(a, b);
}
function $0b2e6adb871a3b94$var$kl() {
    return null;
}
var $0b2e6adb871a3b94$var$ll = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $0b2e6adb871a3b94$var$ml(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$nl.prototype.render = $0b2e6adb871a3b94$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($0b2e6adb871a3b94$var$p(409));
    $0b2e6adb871a3b94$var$gl(a, b, null, null);
};
$0b2e6adb871a3b94$var$nl.prototype.unmount = $0b2e6adb871a3b94$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $0b2e6adb871a3b94$var$Sk(function() {
            $0b2e6adb871a3b94$var$gl(null, a, null, null);
        });
        b[$0b2e6adb871a3b94$var$uf] = null;
    }
};
function $0b2e6adb871a3b94$var$nl(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $0b2e6adb871a3b94$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $0b2e6adb871a3b94$var$Qc.length && 0 !== b && b < $0b2e6adb871a3b94$var$Qc[c].priority; c++);
        $0b2e6adb871a3b94$var$Qc.splice(c, 0, a);
        0 === c && $0b2e6adb871a3b94$var$Vc(a);
    }
};
function $0b2e6adb871a3b94$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $0b2e6adb871a3b94$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $0b2e6adb871a3b94$var$ql() {}
function $0b2e6adb871a3b94$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $0b2e6adb871a3b94$var$hl(g);
                f.call(a);
            };
        }
        var g = $0b2e6adb871a3b94$var$fl(b, d, a, 0, null, !1, !1, "", $0b2e6adb871a3b94$var$ql);
        a._reactRootContainer = g;
        a[$0b2e6adb871a3b94$var$uf] = g.current;
        $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
        $0b2e6adb871a3b94$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $0b2e6adb871a3b94$var$hl(k);
            h.call(a);
        };
    }
    var k = $0b2e6adb871a3b94$var$cl(a, 0, !1, null, null, !1, !1, "", $0b2e6adb871a3b94$var$ql);
    a._reactRootContainer = k;
    a[$0b2e6adb871a3b94$var$uf] = k.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    $0b2e6adb871a3b94$var$Sk(function() {
        $0b2e6adb871a3b94$var$gl(b, k, c, d);
    });
    return k;
}
function $0b2e6adb871a3b94$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $0b2e6adb871a3b94$var$hl(g);
                h.call(a);
            };
        }
        $0b2e6adb871a3b94$var$gl(b, g, a, e);
    } else g = $0b2e6adb871a3b94$var$rl(c, b, a, e, d);
    return $0b2e6adb871a3b94$var$hl(g);
}
$0b2e6adb871a3b94$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $0b2e6adb871a3b94$var$tc(b.pendingLanes);
                0 !== c && ($0b2e6adb871a3b94$var$Cc(b, c | 1), $0b2e6adb871a3b94$var$Ek(b, $0b2e6adb871a3b94$var$B()), 0 === ($0b2e6adb871a3b94$var$K & 6) && ($0b2e6adb871a3b94$var$Hj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$jg()));
            }
            break;
        case 13:
            $0b2e6adb871a3b94$var$Sk(function() {
                var b = $0b2e6adb871a3b94$var$Zg(a, 1);
                if (null !== b) {
                    var c = $0b2e6adb871a3b94$var$L();
                    $0b2e6adb871a3b94$var$mh(b, a, 1, c);
                }
            }), $0b2e6adb871a3b94$var$jl(a, 1);
    }
};
$0b2e6adb871a3b94$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $0b2e6adb871a3b94$var$L();
            $0b2e6adb871a3b94$var$mh(b, a, 134217728, c);
        }
        $0b2e6adb871a3b94$var$jl(a, 134217728);
    }
};
$0b2e6adb871a3b94$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$lh(a), c = $0b2e6adb871a3b94$var$Zg(a, b);
        if (null !== c) {
            var d = $0b2e6adb871a3b94$var$L();
            $0b2e6adb871a3b94$var$mh(c, a, b, d);
        }
        $0b2e6adb871a3b94$var$jl(a, b);
    }
};
$0b2e6adb871a3b94$var$Hc = function() {
    return $0b2e6adb871a3b94$var$C;
};
$0b2e6adb871a3b94$var$Ic = function(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    try {
        return $0b2e6adb871a3b94$var$C = a, b();
    } finally{
        $0b2e6adb871a3b94$var$C = c;
    }
};
$0b2e6adb871a3b94$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $0b2e6adb871a3b94$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $0b2e6adb871a3b94$var$Db(d);
                        if (!e) throw Error($0b2e6adb871a3b94$var$p(90));
                        $0b2e6adb871a3b94$var$Wa(d);
                        $0b2e6adb871a3b94$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $0b2e6adb871a3b94$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $0b2e6adb871a3b94$var$fb(a, !!c.multiple, b, !1);
    }
};
$0b2e6adb871a3b94$var$Gb = $0b2e6adb871a3b94$var$Rk;
$0b2e6adb871a3b94$var$Hb = $0b2e6adb871a3b94$var$Sk;
var $0b2e6adb871a3b94$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $0b2e6adb871a3b94$var$Cb,
        $0b2e6adb871a3b94$var$ue,
        $0b2e6adb871a3b94$var$Db,
        $0b2e6adb871a3b94$var$Eb,
        $0b2e6adb871a3b94$var$Fb,
        $0b2e6adb871a3b94$var$Rk
    ]
}, $0b2e6adb871a3b94$var$ul = {
    findFiberByHostInstance: $0b2e6adb871a3b94$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $0b2e6adb871a3b94$var$vl = {
    bundleType: $0b2e6adb871a3b94$var$ul.bundleType,
    version: $0b2e6adb871a3b94$var$ul.version,
    rendererPackageName: $0b2e6adb871a3b94$var$ul.rendererPackageName,
    rendererConfig: $0b2e6adb871a3b94$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $0b2e6adb871a3b94$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $0b2e6adb871a3b94$var$ul.findFiberByHostInstance || $0b2e6adb871a3b94$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $0b2e6adb871a3b94$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$0b2e6adb871a3b94$var$wl.isDisabled && $0b2e6adb871a3b94$var$wl.supportsFiber) try {
        $0b2e6adb871a3b94$var$kc = $0b2e6adb871a3b94$var$wl.inject($0b2e6adb871a3b94$var$vl), $0b2e6adb871a3b94$var$lc = $0b2e6adb871a3b94$var$wl;
    } catch (a) {}
}
$0b2e6adb871a3b94$export$ae55be85d98224ed = $0b2e6adb871a3b94$var$tl;
$0b2e6adb871a3b94$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$0b2e6adb871a3b94$var$ol(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$dl(a, b, null, c);
};
$0b2e6adb871a3b94$export$882461b6382ed46c = function(a, b) {
    if (!$0b2e6adb871a3b94$var$ol(a)) throw Error($0b2e6adb871a3b94$var$p(299));
    var c = !1, d = "", e = $0b2e6adb871a3b94$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $0b2e6adb871a3b94$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $0b2e6adb871a3b94$var$ml(b);
};
$0b2e6adb871a3b94$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($0b2e6adb871a3b94$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($0b2e6adb871a3b94$var$p(268, a));
    }
    a = $0b2e6adb871a3b94$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = function(a) {
    return $0b2e6adb871a3b94$var$Sk(a);
};
$0b2e6adb871a3b94$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$pl(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$sl(null, a, b, !0, c);
};
$0b2e6adb871a3b94$export$757ceba2d55c277e = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$ol(a)) throw Error($0b2e6adb871a3b94$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $0b2e6adb871a3b94$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $0b2e6adb871a3b94$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $0b2e6adb871a3b94$var$nl(b);
};
$0b2e6adb871a3b94$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$pl(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$sl(null, a, b, !1, c);
};
$0b2e6adb871a3b94$export$502457920280e6be = function(a) {
    if (!$0b2e6adb871a3b94$var$pl(a)) throw Error($0b2e6adb871a3b94$var$p(40));
    return a._reactRootContainer ? ($0b2e6adb871a3b94$var$Sk(function() {
        $0b2e6adb871a3b94$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$0b2e6adb871a3b94$var$uf] = null;
        });
    }), !0) : !1;
};
$0b2e6adb871a3b94$export$c78a37762a8d58e1 = $0b2e6adb871a3b94$var$Rk;
$0b2e6adb871a3b94$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$0b2e6adb871a3b94$var$pl(c)) throw Error($0b2e6adb871a3b94$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($0b2e6adb871a3b94$var$p(38));
    return $0b2e6adb871a3b94$var$sl(a, b, c, !1, d);
};
$0b2e6adb871a3b94$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRegister("fO90s", function(module, exports) {
"use strict";

module.exports = (parcelRequire("gcnCG"));

});
parcelRegister("gcnCG", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $bcb017604639e9d7$export$c4744153514ff05d, (v) => $bcb017604639e9d7$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $bcb017604639e9d7$export$3e506c1ccc9cc1a7, (v) => $bcb017604639e9d7$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $bcb017604639e9d7$export$e26fe2ed2fa76875, (v) => $bcb017604639e9d7$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $bcb017604639e9d7$export$502329bbf4b505b1, (v) => $bcb017604639e9d7$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $bcb017604639e9d7$export$6e3807111c4874c4, (v) => $bcb017604639e9d7$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $bcb017604639e9d7$export$c27134553091fb3a, (v) => $bcb017604639e9d7$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $bcb017604639e9d7$export$33ee1acdc04fd2a2, (v) => $bcb017604639e9d7$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $bcb017604639e9d7$export$b00a404bbd5edef2, (v) => $bcb017604639e9d7$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $bcb017604639e9d7$export$8352ce38b91d0c62, (v) => $bcb017604639e9d7$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $bcb017604639e9d7$export$d66a1c1c77bd778b, (v) => $bcb017604639e9d7$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $bcb017604639e9d7$export$d3dfb8e4810cb555, (v) => $bcb017604639e9d7$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $bcb017604639e9d7$export$839f9183b0465a69, (v) => $bcb017604639e9d7$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $bcb017604639e9d7$export$72fdf0e06517287b, (v) => $bcb017604639e9d7$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $bcb017604639e9d7$export$4b844e58a3e414b4, (v) => $bcb017604639e9d7$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $bcb017604639e9d7$export$816d2913ae6b83b1, (v) => $bcb017604639e9d7$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $bcb017604639e9d7$export$61bcfe829111a1d0, (v) => $bcb017604639e9d7$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $bcb017604639e9d7$export$7ee8c9beb337bc3f, (v) => $bcb017604639e9d7$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $bcb017604639e9d7$export$b5836b71941fa3ed, (v) => $bcb017604639e9d7$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $bcb017604639e9d7$export$cf845f2c119da08a, (v) => $bcb017604639e9d7$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bcb017604639e9d7$export$c4744153514ff05d;
var $bcb017604639e9d7$export$3e506c1ccc9cc1a7;
var $bcb017604639e9d7$export$e26fe2ed2fa76875;
var $bcb017604639e9d7$export$502329bbf4b505b1;
var $bcb017604639e9d7$export$6e3807111c4874c4;
var $bcb017604639e9d7$export$c27134553091fb3a;
var $bcb017604639e9d7$export$33ee1acdc04fd2a2;
var $bcb017604639e9d7$export$b00a404bbd5edef2;
var $bcb017604639e9d7$export$8352ce38b91d0c62;
var $bcb017604639e9d7$export$d66a1c1c77bd778b;
var $bcb017604639e9d7$export$d3dfb8e4810cb555;
var $bcb017604639e9d7$export$839f9183b0465a69;
var $bcb017604639e9d7$export$72fdf0e06517287b;
var $bcb017604639e9d7$export$4b844e58a3e414b4;
var $bcb017604639e9d7$export$816d2913ae6b83b1;
var $bcb017604639e9d7$export$61bcfe829111a1d0;
var $bcb017604639e9d7$export$7ee8c9beb337bc3f;
var $bcb017604639e9d7$export$b5836b71941fa3ed;
var $bcb017604639e9d7$export$cf845f2c119da08a;
"use strict";
function $bcb017604639e9d7$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $bcb017604639e9d7$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $bcb017604639e9d7$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $bcb017604639e9d7$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $bcb017604639e9d7$var$g(C, c)) n < e && 0 > $bcb017604639e9d7$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $bcb017604639e9d7$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $bcb017604639e9d7$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $bcb017604639e9d7$var$l = performance;
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$l.now();
    };
} else {
    var $bcb017604639e9d7$var$p = Date, $bcb017604639e9d7$var$q = $bcb017604639e9d7$var$p.now();
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$p.now() - $bcb017604639e9d7$var$q;
    };
}
var $bcb017604639e9d7$var$r = [], $bcb017604639e9d7$var$t = [], $bcb017604639e9d7$var$u = 1, $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = 3, $bcb017604639e9d7$var$z = !1, $bcb017604639e9d7$var$A = !1, $bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$D = "function" === typeof setTimeout ? setTimeout : null, $bcb017604639e9d7$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $bcb017604639e9d7$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $bcb017604639e9d7$var$G(a) {
    for(var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t); null !== b;){
        if (null === b.callback) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t);
        else if (b.startTime <= a) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t), b.sortIndex = b.expirationTime, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, b);
        else break;
        b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
    }
}
function $bcb017604639e9d7$var$H(a) {
    $bcb017604639e9d7$var$B = !1;
    $bcb017604639e9d7$var$G(a);
    if (!$bcb017604639e9d7$var$A) {
        if (null !== $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r)) $bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J);
        else {
            var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== b && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, b.startTime - a);
        }
    }
}
function $bcb017604639e9d7$var$J(a, b) {
    $bcb017604639e9d7$var$A = !1;
    $bcb017604639e9d7$var$B && ($bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1);
    $bcb017604639e9d7$var$z = !0;
    var c = $bcb017604639e9d7$var$y;
    try {
        $bcb017604639e9d7$var$G(b);
        for($bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r); null !== $bcb017604639e9d7$var$v && (!($bcb017604639e9d7$var$v.expirationTime > b) || a && !$bcb017604639e9d7$var$M());){
            var d = $bcb017604639e9d7$var$v.callback;
            if ("function" === typeof d) {
                $bcb017604639e9d7$var$v.callback = null;
                $bcb017604639e9d7$var$y = $bcb017604639e9d7$var$v.priorityLevel;
                var e = d($bcb017604639e9d7$var$v.expirationTime <= b);
                b = $bcb017604639e9d7$export$c4744153514ff05d();
                "function" === typeof e ? $bcb017604639e9d7$var$v.callback = e : $bcb017604639e9d7$var$v === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
                $bcb017604639e9d7$var$G(b);
            } else $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
            $bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
        }
        if (null !== $bcb017604639e9d7$var$v) var w = !0;
        else {
            var m = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== m && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = c, $bcb017604639e9d7$var$z = !1;
    }
}
var $bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null, $bcb017604639e9d7$var$L = -1, $bcb017604639e9d7$var$P = 5, $bcb017604639e9d7$var$Q = -1;
function $bcb017604639e9d7$var$M() {
    return $bcb017604639e9d7$export$c4744153514ff05d() - $bcb017604639e9d7$var$Q < $bcb017604639e9d7$var$P ? !1 : !0;
}
function $bcb017604639e9d7$var$R() {
    if (null !== $bcb017604639e9d7$var$O) {
        var a = $bcb017604639e9d7$export$c4744153514ff05d();
        $bcb017604639e9d7$var$Q = a;
        var b = !0;
        try {
            b = $bcb017604639e9d7$var$O(!0, a);
        } finally{
            b ? $bcb017604639e9d7$var$S() : ($bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null);
        }
    } else $bcb017604639e9d7$var$N = !1;
}
var $bcb017604639e9d7$var$S;
if ("function" === typeof $bcb017604639e9d7$var$F) $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$F($bcb017604639e9d7$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $bcb017604639e9d7$var$T = new MessageChannel, $bcb017604639e9d7$var$U = $bcb017604639e9d7$var$T.port2;
    $bcb017604639e9d7$var$T.port1.onmessage = $bcb017604639e9d7$var$R;
    $bcb017604639e9d7$var$S = function() {
        $bcb017604639e9d7$var$U.postMessage(null);
    };
} else $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$D($bcb017604639e9d7$var$R, 0);
};
function $bcb017604639e9d7$var$I(a) {
    $bcb017604639e9d7$var$O = a;
    $bcb017604639e9d7$var$N || ($bcb017604639e9d7$var$N = !0, $bcb017604639e9d7$var$S());
}
function $bcb017604639e9d7$var$K(a, b) {
    $bcb017604639e9d7$var$L = $bcb017604639e9d7$var$D(function() {
        a($bcb017604639e9d7$export$c4744153514ff05d());
    }, b);
}
$bcb017604639e9d7$export$3e506c1ccc9cc1a7 = 5;
$bcb017604639e9d7$export$e26fe2ed2fa76875 = 1;
$bcb017604639e9d7$export$502329bbf4b505b1 = 4;
$bcb017604639e9d7$export$6e3807111c4874c4 = 3;
$bcb017604639e9d7$export$c27134553091fb3a = null;
$bcb017604639e9d7$export$33ee1acdc04fd2a2 = 2;
$bcb017604639e9d7$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$bcb017604639e9d7$export$8352ce38b91d0c62 = function() {
    $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J));
};
$bcb017604639e9d7$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $bcb017604639e9d7$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$bcb017604639e9d7$export$d3dfb8e4810cb555 = function() {
    return $bcb017604639e9d7$var$y;
};
$bcb017604639e9d7$export$839f9183b0465a69 = function() {
    return $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
};
$bcb017604639e9d7$export$72fdf0e06517287b = function(a) {
    switch($bcb017604639e9d7$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $bcb017604639e9d7$var$y;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = b;
    try {
        return a();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$4b844e58a3e414b4 = function() {};
$bcb017604639e9d7$export$816d2913ae6b83b1 = function() {};
$bcb017604639e9d7$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = a;
    try {
        return b();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $bcb017604639e9d7$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $bcb017604639e9d7$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$t, a), null === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && a === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t) && ($bcb017604639e9d7$var$B ? ($bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1) : $bcb017604639e9d7$var$B = !0, $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, c - d))) : (a.sortIndex = e, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, a), $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J)));
    return a;
};
$bcb017604639e9d7$export$b5836b71941fa3ed = $bcb017604639e9d7$var$M;
$bcb017604639e9d7$export$cf845f2c119da08a = function(a) {
    var b = $bcb017604639e9d7$var$y;
    return function() {
        var c = $bcb017604639e9d7$var$y;
        $bcb017604639e9d7$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $bcb017604639e9d7$var$y = c;
        }
    };
};

});



parcelRegister("hOzOt", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $kZO5c = parcelRequire("kZO5c");
function $cf82e2ef667d5788$var$emptyFunction() {}
function $cf82e2ef667d5788$var$emptyFunctionWithReset() {}
$cf82e2ef667d5788$var$emptyFunctionWithReset.resetWarningCache = $cf82e2ef667d5788$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $kZO5c) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $cf82e2ef667d5788$var$emptyFunctionWithReset,
        resetWarningCache: $cf82e2ef667d5788$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("kZO5c", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $f4905a8b274aa381$var$ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = $f4905a8b274aa381$var$ReactPropTypesSecret;

});


parcelRegister("f1q41", function(module, exports) {
(function() {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */ var undefined;
    /** Used as the semantic version number. */ var VERSION = "4.17.21";
    /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Error message constants. */ var CORE_ERROR_TEXT = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", FUNC_ERROR_TEXT = "Expected a function", INVALID_TEMPL_VAR_ERROR_TEXT = "Invalid `variable` option passed into `_.template`";
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
    /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
    /** Used as the internal argument placeholder. */ var PLACEHOLDER = "__lodash_placeholder__";
    /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    /** Used as default options for `_.truncate`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = "...";
    /** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
    /** Used to indicate the type of lazy iteratees. */ var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
    /** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    /** Used to associate wrap methods with their bit flags. */ var wrapFlags = [
        [
            "ary",
            WRAP_ARY_FLAG
        ],
        [
            "bind",
            WRAP_BIND_FLAG
        ],
        [
            "bindKey",
            WRAP_BIND_KEY_FLAG
        ],
        [
            "curry",
            WRAP_CURRY_FLAG
        ],
        [
            "curryRight",
            WRAP_CURRY_RIGHT_FLAG
        ],
        [
            "flip",
            WRAP_FLIP_FLAG
        ],
        [
            "partial",
            WRAP_PARTIAL_FLAG
        ],
        [
            "partialRight",
            WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            "rearg",
            WRAP_REARG_FLAG
        ]
    ];
    /** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", domExcTag = "[object DOMException]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", promiseTag = "[object Promise]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]", weakSetTag = "[object WeakSet]";
    var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
    /** Used to match empty string literals in compiled template source. */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /** Used to match HTML entities and HTML characters. */ var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    /** Used to match template delimiters. */ var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    /** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
    /** Used to match a single whitespace character. */ var reWhitespace = /\s/;
    /** Used to match wrap detail comments. */ var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    /** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */ var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    /** Used to ensure capturing order of template delimiters. */ var reNoMatch = /($^)/;
    /** Used to match unescaped characters in compiled string literals. */ var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    /** Used to compose unicode character classes. */ var rsAstralRange = "\ud800-\udfff", rsComboMarksRange = "\\u0300-\\u036f", reComboHalfMarksRange = "\\ufe20-\\ufe2f", rsComboSymbolsRange = "\\u20d0-\\u20ff", rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = "\\u2700-\\u27bf", rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff", rsMathOpRange = "\\xac\\xb1\\xd7\\xf7", rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", rsPunctuationRange = "\\u2000-\\u206f", rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde", rsVarRange = "\\ufe0e\\ufe0f", rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    /** Used to compose unicode capture groups. */ var rsApos = "['\u2019]", rsAstral = "[" + rsAstralRange + "]", rsBreak = "[" + rsBreakRange + "]", rsCombo = "[" + rsComboRange + "]", rsDigits = "\\d+", rsDingbat = "[" + rsDingbatRange + "]", rsLower = "[" + rsLowerRange + "]", rsMisc = "[^" + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + "]", rsFitz = "\ud83c[\udffb-\udfff]", rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")", rsNonAstral = "[^" + rsAstralRange + "]", rsRegional = "(?:\ud83c[\udde6-\uddff]){2}", rsSurrPair = "[\ud800-\udbff][\udc00-\udfff]", rsUpper = "[" + rsUpperRange + "]", rsZWJ = "\\u200d";
    /** Used to compose unicode regexes. */ var rsMiscLower = "(?:" + rsLower + "|" + rsMisc + ")", rsMiscUpper = "(?:" + rsUpper + "|" + rsMisc + ")", rsOptContrLower = "(?:" + rsApos + "(?:d|ll|m|re|s|t|ve))?", rsOptContrUpper = "(?:" + rsApos + "(?:D|LL|M|RE|S|T|VE))?", reOptMod = rsModifier + "?", rsOptVar = "[" + rsVarRange + "]?", rsOptJoin = "(?:" + rsZWJ + "(?:" + [
        rsNonAstral,
        rsRegional,
        rsSurrPair
    ].join("|") + ")" + rsOptVar + reOptMod + ")*", rsOrdLower = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", rsOrdUpper = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = "(?:" + [
        rsDingbat,
        rsRegional,
        rsSurrPair
    ].join("|") + ")" + rsSeq, rsSymbol = "(?:" + [
        rsNonAstral + rsCombo + "?",
        rsCombo,
        rsRegional,
        rsSurrPair,
        rsAstral
    ].join("|") + ")";
    /** Used to match apostrophes. */ var reApos = RegExp(rsApos, "g");
    /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, "g");
    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + "(?=" + rsFitz + ")|" + rsSymbol + rsSeq, "g");
    /** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
        rsUpper + "?" + rsLower + "+" + rsOptContrLower + "(?=" + [
            rsBreak,
            rsUpper,
            "$"
        ].join("|") + ")",
        rsMiscUpper + "+" + rsOptContrUpper + "(?=" + [
            rsBreak,
            rsUpper + rsMiscLower,
            "$"
        ].join("|") + ")",
        rsUpper + "?" + rsMiscLower + "+" + rsOptContrLower,
        rsUpper + "+" + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
    ].join("|"), "g");
    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp("[" + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + "]");
    /** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    /** Used to assign default `context` object properties. */ var contextProps = [
        "Array",
        "Buffer",
        "DataView",
        "Date",
        "Error",
        "Float32Array",
        "Float64Array",
        "Function",
        "Int8Array",
        "Int16Array",
        "Int32Array",
        "Map",
        "Math",
        "Object",
        "Promise",
        "RegExp",
        "Set",
        "String",
        "Symbol",
        "TypeError",
        "Uint8Array",
        "Uint8ClampedArray",
        "Uint16Array",
        "Uint32Array",
        "WeakMap",
        "_",
        "clearTimeout",
        "isFinite",
        "parseInt",
        "setTimeout"
    ];
    /** Used to make template sourceURLs easier to identify. */ var templateCounter = -1;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
        // Latin-1 Supplement block.
        "\xc0": "A",
        "\xc1": "A",
        "\xc2": "A",
        "\xc3": "A",
        "\xc4": "A",
        "\xc5": "A",
        "\xe0": "a",
        "\xe1": "a",
        "\xe2": "a",
        "\xe3": "a",
        "\xe4": "a",
        "\xe5": "a",
        "\xc7": "C",
        "\xe7": "c",
        "\xd0": "D",
        "\xf0": "d",
        "\xc8": "E",
        "\xc9": "E",
        "\xca": "E",
        "\xcb": "E",
        "\xe8": "e",
        "\xe9": "e",
        "\xea": "e",
        "\xeb": "e",
        "\xcc": "I",
        "\xcd": "I",
        "\xce": "I",
        "\xcf": "I",
        "\xec": "i",
        "\xed": "i",
        "\xee": "i",
        "\xef": "i",
        "\xd1": "N",
        "\xf1": "n",
        "\xd2": "O",
        "\xd3": "O",
        "\xd4": "O",
        "\xd5": "O",
        "\xd6": "O",
        "\xd8": "O",
        "\xf2": "o",
        "\xf3": "o",
        "\xf4": "o",
        "\xf5": "o",
        "\xf6": "o",
        "\xf8": "o",
        "\xd9": "U",
        "\xda": "U",
        "\xdb": "U",
        "\xdc": "U",
        "\xf9": "u",
        "\xfa": "u",
        "\xfb": "u",
        "\xfc": "u",
        "\xdd": "Y",
        "\xfd": "y",
        "\xff": "y",
        "\xc6": "Ae",
        "\xe6": "ae",
        "\xde": "Th",
        "\xfe": "th",
        "\xdf": "ss",
        // Latin Extended-A block.
        "\u0100": "A",
        "\u0102": "A",
        "\u0104": "A",
        "\u0101": "a",
        "\u0103": "a",
        "\u0105": "a",
        "\u0106": "C",
        "\u0108": "C",
        "\u010A": "C",
        "\u010C": "C",
        "\u0107": "c",
        "\u0109": "c",
        "\u010B": "c",
        "\u010D": "c",
        "\u010E": "D",
        "\u0110": "D",
        "\u010F": "d",
        "\u0111": "d",
        "\u0112": "E",
        "\u0114": "E",
        "\u0116": "E",
        "\u0118": "E",
        "\u011A": "E",
        "\u0113": "e",
        "\u0115": "e",
        "\u0117": "e",
        "\u0119": "e",
        "\u011B": "e",
        "\u011C": "G",
        "\u011E": "G",
        "\u0120": "G",
        "\u0122": "G",
        "\u011D": "g",
        "\u011F": "g",
        "\u0121": "g",
        "\u0123": "g",
        "\u0124": "H",
        "\u0126": "H",
        "\u0125": "h",
        "\u0127": "h",
        "\u0128": "I",
        "\u012A": "I",
        "\u012C": "I",
        "\u012E": "I",
        "\u0130": "I",
        "\u0129": "i",
        "\u012B": "i",
        "\u012D": "i",
        "\u012F": "i",
        "\u0131": "i",
        "\u0134": "J",
        "\u0135": "j",
        "\u0136": "K",
        "\u0137": "k",
        "\u0138": "k",
        "\u0139": "L",
        "\u013B": "L",
        "\u013D": "L",
        "\u013F": "L",
        "\u0141": "L",
        "\u013A": "l",
        "\u013C": "l",
        "\u013E": "l",
        "\u0140": "l",
        "\u0142": "l",
        "\u0143": "N",
        "\u0145": "N",
        "\u0147": "N",
        "\u014A": "N",
        "\u0144": "n",
        "\u0146": "n",
        "\u0148": "n",
        "\u014B": "n",
        "\u014C": "O",
        "\u014E": "O",
        "\u0150": "O",
        "\u014D": "o",
        "\u014F": "o",
        "\u0151": "o",
        "\u0154": "R",
        "\u0156": "R",
        "\u0158": "R",
        "\u0155": "r",
        "\u0157": "r",
        "\u0159": "r",
        "\u015A": "S",
        "\u015C": "S",
        "\u015E": "S",
        "\u0160": "S",
        "\u015B": "s",
        "\u015D": "s",
        "\u015F": "s",
        "\u0161": "s",
        "\u0162": "T",
        "\u0164": "T",
        "\u0166": "T",
        "\u0163": "t",
        "\u0165": "t",
        "\u0167": "t",
        "\u0168": "U",
        "\u016A": "U",
        "\u016C": "U",
        "\u016E": "U",
        "\u0170": "U",
        "\u0172": "U",
        "\u0169": "u",
        "\u016B": "u",
        "\u016D": "u",
        "\u016F": "u",
        "\u0171": "u",
        "\u0173": "u",
        "\u0174": "W",
        "\u0175": "w",
        "\u0176": "Y",
        "\u0177": "y",
        "\u0178": "Y",
        "\u0179": "Z",
        "\u017B": "Z",
        "\u017D": "Z",
        "\u017A": "z",
        "\u017C": "z",
        "\u017E": "z",
        "\u0132": "IJ",
        "\u0133": "ij",
        "\u0152": "Oe",
        "\u0153": "oe",
        "\u0149": "'n",
        "\u017F": "s"
    };
    /** Used to map characters to HTML entities. */ var htmlEscapes = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
    };
    /** Used to map HTML entities to characters. */ var htmlUnescapes = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'"
    };
    /** Used to escape characters for inclusion in compiled string literals. */ var stringEscapes = {
        "\\": "\\",
        "'": "'",
        "\n": "n",
        "\r": "r",
        "\u2028": "u2028",
        "\u2029": "u2029"
    };
    /** Built-in method references without a dependency on `root`. */ var freeParseFloat = parseFloat, freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
    /** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
        try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require("util").types;
            if (types) return types;
            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding("util");
        } catch (e) {}
    }();
    /* Node.js helper references. */ var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */ function apply(func, thisArg, args) {
        switch(args.length){
            case 0:
                return func.call(thisArg);
            case 1:
                return func.call(thisArg, args[0]);
            case 2:
                return func.call(thisArg, args[0], args[1]);
            case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
    }
    /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */ function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
    }
    /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (iteratee(array[index], index, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while(length--){
            if (iteratee(array[length], length, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */ function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (!predicate(array[index], index, array)) return false;
        }
        return true;
    }
    /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */ function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (predicate(value, index, array)) result[resIndex++] = value;
        }
        return result;
    }
    /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (comparator(value, array[index])) return true;
        }
        return false;
    }
    /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */ function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while(++index < length)result[index] = iteratee(array[index], index, array);
        return result;
    }
    /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */ function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while(++index < length)array[offset + index] = values[index];
        return array;
    }
    /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[++index];
        while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[--length];
        while(length--)accumulator = iteratee(accumulator, array[length], length, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */ function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (predicate(array[index], index, array)) return true;
        }
        return false;
    }
    /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ var asciiSize = baseProperty("length");
    /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function asciiToArray(string) {
        return string.split("");
    }
    /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function asciiWords(string) {
        return string.match(reAsciiWord) || [];
    }
    /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */ function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection) {
            if (predicate(value, key, collection)) {
                result = key;
                return false;
            }
        });
        return result;
    }
    /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while(fromRight ? index-- : ++index < length){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (comparator(array[index], value)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */ function baseIsNaN(value) {
        return value !== value;
    }
    /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */ function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
    }
    /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */ function baseProperty(key) {
        return function(object) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */ function basePropertyOf(object) {
        return function(key) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    }
    /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */ function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while(length--)array[length] = array[length].value;
        return array;
    }
    /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */ function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined) result = result === undefined ? current : result + current;
        }
        return result;
    }
    /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */ function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while(++index < n)result[index] = iteratee(index);
        return result;
    }
    /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */ function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
            return [
                key,
                object[key]
            ];
        });
    }
    /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */ function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, "") : string;
    }
    /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */ function baseUnary(func) {
        return function(value) {
            return func(value);
        };
    }
    /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */ function baseValues(object, props) {
        return arrayMap(props, function(key) {
            return object[key];
        });
    }
    /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */ function cacheHas(cache, key) {
        return cache.has(key);
    }
    /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */ function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */ function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */ function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    }
    /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */ var deburrLetter = basePropertyOf(deburredLetters);
    /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ var escapeHtmlChar = basePropertyOf(htmlEscapes);
    /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(chr) {
        return "\\" + stringEscapes[chr];
    }
    /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */ function getValue(object, key) {
        return object == null ? undefined : object[key];
    }
    /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */ function hasUnicode(string) {
        return reHasUnicode.test(string);
    }
    /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */ function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
    }
    /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */ function iteratorToArray(iterator) {
        var data, result = [];
        while(!(data = iterator.next()).done)result.push(data.value);
        return result;
    }
    /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */ function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
            result[++index] = [
                key,
                value
            ];
        });
        return result;
    }
    /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    }
    /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */ function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === PLACEHOLDER) {
                array[index] = PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */ function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = value;
        });
        return result;
    }
    /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */ function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = [
                value,
                value
            ];
        });
        return result;
    }
    /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    }
    /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while(index--){
            if (array[index] === value) return index;
        }
        return index;
    }
    /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */ function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */ function trimmedEndIndex(string) {
        var index = string.length;
        while(index-- && reWhitespace.test(string.charAt(index)));
        return index;
    }
    /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */ var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while(reUnicode.test(string))++result;
        return result;
    }
    /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function unicodeToArray(string) {
        return string.match(reUnicode) || [];
    }
    /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
    }
    /*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */ var runInContext = function runInContext(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        /** Built-in constructor references. */ var Array1 = context.Array, Date = context.Date, Error = context.Error, Function1 = context.Function, Math = context.Math, Object1 = context.Object, RegExp1 = context.RegExp, String = context.String, TypeError = context.TypeError;
        /** Used for built-in method references. */ var arrayProto = Array1.prototype, funcProto = Function1.prototype, objectProto = Object1.prototype;
        /** Used to detect overreaching core-js shims. */ var coreJsData = context["__core-js_shared__"];
        /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */ var idCounter = 0;
        /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
            return uid ? "Symbol(src)_1." + uid : "";
        }();
        /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */ var nativeObjectToString = objectProto.toString;
        /** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object1);
        /** Used to restore the original `_` reference in `_.noConflict`. */ var oldDash = root._;
        /** Used to detect if a method is native. */ var reIsNative = RegExp1("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
        /** Built-in value references. */ var Buffer = moduleExports ? context.Buffer : undefined, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object1.getPrototypeOf, Object1), objectCreate = Object1.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined, symIterator = Symbol ? Symbol.iterator : undefined, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
        var defineProperty = function() {
            try {
                var func = getNative(Object1, "defineProperty");
                func({}, "", {});
                return func;
            } catch (e) {}
        }();
        /** Mocked built-ins. */ var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = Object1.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object1.keys, Object1), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
        /* Built-in method references that are verified to be native. */ var DataView = getNative(context, "DataView"), Map = getNative(context, "Map"), Promise = getNative(context, "Promise"), Set = getNative(context, "Set"), WeakMap = getNative(context, "WeakMap"), nativeCreate = getNative(Object1, "create");
        /** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
        /** Used to lookup unminified function names. */ var realNames = {};
        /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) return value;
                if (hasOwnProperty.call(value, "__wrapped__")) return wrapperClone(value);
            }
            return new LodashWrapper(value);
        }
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */ var baseCreate = function() {
            function object() {}
            return function(proto) {
                if (!isObject(proto)) return {};
                if (objectCreate) return objectCreate(proto);
                object.prototype = proto;
                var result = new object;
                object.prototype = undefined;
                return result;
            };
        }();
        /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */ function baseLodash() {
        // No operation performed.
        }
        /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */ function LodashWrapper(value, chainAll) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__chain__ = !!chainAll;
            this.__index__ = 0;
            this.__values__ = undefined;
        }
        /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "escape": reEscape,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "evaluate": reEvaluate,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "interpolate": reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */ "variable": "",
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */ "imports": {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */ "_": lodash
            }
        };
        // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */ function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = MAX_ARRAY_LENGTH;
            this.__views__ = [];
        }
        /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */ function lazyClone() {
            var result = new LazyWrapper(this.__wrapped__);
            result.__actions__ = copyArray(this.__actions__);
            result.__dir__ = this.__dir__;
            result.__filtered__ = this.__filtered__;
            result.__iteratees__ = copyArray(this.__iteratees__);
            result.__takeCount__ = this.__takeCount__;
            result.__views__ = copyArray(this.__views__);
            return result;
        }
        /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */ function lazyReverse() {
            if (this.__filtered__) {
                var result = new LazyWrapper(this);
                result.__dir__ = -1;
                result.__filtered__ = true;
            } else {
                result = this.clone();
                result.__dir__ *= -1;
            }
            return result;
        }
        /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */ function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
            var result = [];
            outer: while(length-- && resIndex < takeCount){
                index += dir;
                var iterIndex = -1, value = array[index];
                while(++iterIndex < iterLength){
                    var data = iteratees[iterIndex], iteratee = data.iteratee, type = data.type, computed = iteratee(value);
                    if (type == LAZY_MAP_FLAG) value = computed;
                    else if (!computed) {
                        if (type == LAZY_FILTER_FLAG) continue outer;
                        else break outer;
                    }
                }
                result[resIndex++] = value;
            }
            return result;
        }
        // Ensure `LazyWrapper` is an instance of `baseLodash`.
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Hash(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function hashDelete(key) {
            var result = this.has(key) && delete this.__data__[key];
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var result = data[key];
                return result === HASH_UNDEFINED ? undefined : result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined;
        }
        /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
        }
        /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */ function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
            return this;
        }
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype["delete"] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function ListCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */ function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) return false;
            var lastIndex = data.length - 1;
            if (index == lastIndex) data.pop();
            else splice.call(data, index, 1);
            --this.size;
            return true;
        }
        /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined : data[index][1];
        }
        /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        }
        /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */ function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
                ++this.size;
                data.push([
                    key,
                    value
                ]);
            } else data[index][1] = value;
            return this;
        }
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype["delete"] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function MapCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */ function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
                "hash": new Hash,
                "map": new (Map || ListCache),
                "string": new Hash
            };
        }
        /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function mapCacheDelete(key) {
            var result = getMapData(this, key)["delete"](key);
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        }
        /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        }
        /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */ function mapCacheSet(key, value) {
            var data = getMapData(this, key), size = data.size;
            data.set(key, value);
            this.size += data.size == size ? 0 : 1;
            return this;
        }
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype["delete"] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */ function SetCache(values) {
            var index = -1, length = values == null ? 0 : values.length;
            this.__data__ = new MapCache;
            while(++index < length)this.add(values[index]);
        }
        /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        }
        /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */ function setCacheHas(value) {
            return this.__data__.has(value);
        }
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Stack(entries) {
            var data = this.__data__ = new ListCache(entries);
            this.size = data.size;
        }
        /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */ function stackClear() {
            this.__data__ = new ListCache;
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function stackDelete(key) {
            var data = this.__data__, result = data["delete"](key);
            this.size = data.size;
            return result;
        }
        /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function stackGet(key) {
            return this.__data__.get(key);
        }
        /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function stackHas(key) {
            return this.__data__.has(key);
        }
        /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */ function stackSet(key, value) {
            var data = this.__data__;
            if (data instanceof ListCache) {
                var pairs = data.__data__;
                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([
                        key,
                        value
                    ]);
                    this.size = ++data.size;
                    return this;
                }
                data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
        }
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype["delete"] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */ function arrayLikeKeys(value, inherited) {
            var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
            for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
            isIndex(key, length)))) result.push(key);
            return result;
        }
        /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */ function arraySample(array) {
            var length = array.length;
            return length ? array[baseRandom(0, length - 1)] : undefined;
        }
        /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function arraySampleSize(array, n) {
            return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function arrayShuffle(array) {
            return shuffleSelf(copyArray(array));
        }
        /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignMergeValue(object, key, value) {
            if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignValue(object, key, value) {
            var objValue = object[key];
            if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */ function assocIndexOf(array, key) {
            var length = array.length;
            while(length--){
                if (eq(array[length][0], key)) return length;
            }
            return -1;
        }
        /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */ function baseAggregator(collection, setter, iteratee, accumulator) {
            baseEach(collection, function(value, key, collection) {
                setter(accumulator, value, iteratee(value), collection);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssign(object, source) {
            return object && copyObject(source, keys(source), object);
        }
        /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssignIn(object, source) {
            return object && copyObject(source, keysIn(source), object);
        }
        /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function baseAssignValue(object, key, value) {
            if (key == "__proto__" && defineProperty) defineProperty(object, key, {
                "configurable": true,
                "enumerable": true,
                "value": value,
                "writable": true
            });
            else object[key] = value;
        }
        /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */ function baseAt(object, paths) {
            var index = -1, length = paths.length, result = Array1(length), skip = object == null;
            while(++index < length)result[index] = skip ? undefined : get(object, paths[index]);
            return result;
        }
        /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */ function baseClamp(number, lower, upper) {
            if (number === number) {
                if (upper !== undefined) number = number <= upper ? number : upper;
                if (lower !== undefined) number = number >= lower ? number : lower;
            }
            return number;
        }
        /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, bitmask, customizer, key, object, stack) {
            var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
            if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
            if (result !== undefined) return result;
            if (!isObject(value)) return value;
            var isArr = isArray(value);
            if (isArr) {
                result = initCloneArray(value);
                if (!isDeep) return copyArray(value, result);
            } else {
                var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                if (isBuffer(value)) return cloneBuffer(value, isDeep);
                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                    result = isFlat || isFunc ? {} : initCloneObject(value);
                    if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
                } else {
                    if (!cloneableTags[tag]) return object ? value : {};
                    result = initCloneByTag(value, tag, isDeep);
                }
            }
            // Check for circular references and return its corresponding clone.
            stack || (stack = new Stack);
            var stacked = stack.get(value);
            if (stacked) return stacked;
            stack.set(value, result);
            if (isSet(value)) value.forEach(function(subValue) {
                result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
            else if (isMap(value)) value.forEach(function(subValue, key) {
                result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
            var props = isArr ? undefined : keysFunc(value);
            arrayEach(props || value, function(subValue, key) {
                if (props) {
                    key = subValue;
                    subValue = value[key];
                }
                // Recursively populate clone (susceptible to call stack limits).
                assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            return result;
        }
        /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */ function baseConforms(source) {
            var props = keys(source);
            return function(object) {
                return baseConformsTo(object, source, props);
            };
        }
        /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */ function baseConformsTo(object, source, props) {
            var length = props.length;
            if (object == null) return !length;
            object = Object1(object);
            while(length--){
                var key = props[length], predicate = source[key], value = object[key];
                if (value === undefined && !(key in object) || !predicate(value)) return false;
            }
            return true;
        }
        /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ function baseDelay(func, wait, args) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            return setTimeout(function() {
                func.apply(undefined, args);
            }, wait);
        }
        /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */ function baseDifference(array, values, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
            if (!length) return result;
            if (iteratee) values = arrayMap(values, baseUnary(iteratee));
            if (comparator) {
                includes = arrayIncludesWith;
                isCommon = false;
            } else if (values.length >= LARGE_ARRAY_SIZE) {
                includes = cacheHas;
                isCommon = false;
                values = new SetCache(values);
            }
            outer: while(++index < length){
                var value = array[index], computed = iteratee == null ? value : iteratee(value);
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var valuesIndex = valuesLength;
                    while(valuesIndex--){
                        if (values[valuesIndex] === computed) continue outer;
                    }
                    result.push(value);
                } else if (!includes(values, computed, comparator)) result.push(value);
            }
            return result;
        }
        /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEach = createBaseEach(baseForOwn);
        /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */ function baseEvery(collection, predicate) {
            var result = true;
            baseEach(collection, function(value, index, collection) {
                result = !!predicate(value, index, collection);
                return result;
            });
            return result;
        }
        /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */ function baseExtremum(array, iteratee, comparator) {
            var index = -1, length = array.length;
            while(++index < length){
                var value = array[index], current = iteratee(value);
                if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, result = value;
            }
            return result;
        }
        /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */ function baseFill(array, value, start, end) {
            var length = array.length;
            start = toInteger(start);
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined || end > length ? length : toInteger(end);
            if (end < 0) end += length;
            end = start > end ? 0 : toLength(end);
            while(start < end)array[start++] = value;
            return array;
        }
        /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function baseFilter(collection, predicate) {
            var result = [];
            baseEach(collection, function(value, index, collection) {
                if (predicate(value, index, collection)) result.push(value);
            });
            return result;
        }
        /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */ function baseFlatten(array, depth, predicate, isStrict, result) {
            var index = -1, length = array.length;
            predicate || (predicate = isFlattenable);
            result || (result = []);
            while(++index < length){
                var value = array[index];
                if (depth > 0 && predicate(value)) {
                    if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, depth - 1, predicate, isStrict, result);
                    else arrayPush(result, value);
                } else if (!isStrict) result[result.length] = value;
            }
            return result;
        }
        /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseFor = createBaseFor();
        /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseForRight = createBaseFor(true);
        /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwnRight(object, iteratee) {
            return object && baseForRight(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */ function baseFunctions(object, props) {
            return arrayFilter(props, function(key) {
                return isFunction(object[key]);
            });
        }
        /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */ function baseGet(object, path) {
            path = castPath(path, object);
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[toKey(path[index++])];
            return index && index == length ? object : undefined;
        }
        /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var result = keysFunc(object);
            return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
        }
        /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ function baseGetTag(value) {
            if (value == null) return value === undefined ? undefinedTag : nullTag;
            return symToStringTag && symToStringTag in Object1(value) ? getRawTag(value) : objectToString(value);
        }
        /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */ function baseGt(value, other) {
            return value > other;
        }
        /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHas(object, key) {
            return object != null && hasOwnProperty.call(object, key);
        }
        /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHasIn(object, key) {
            return object != null && key in Object1(object);
        }
        /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */ function baseInRange(number, start, end) {
            return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */ function baseIntersection(arrays, iteratee, comparator) {
            var includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, result = [];
            while(othIndex--){
                var array = arrays[othIndex];
                if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                maxLength = nativeMin(array.length, maxLength);
                caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
            }
            array = arrays[0];
            var index = -1, seen = caches[0];
            outer: while(++index < length && result.length < maxLength){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
                    othIndex = othLength;
                    while(--othIndex){
                        var cache = caches[othIndex];
                        if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
                    }
                    if (seen) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */ function baseInverter(object, setter, iteratee, accumulator) {
            baseForOwn(object, function(value, key, object) {
                setter(accumulator, iteratee(value), key, object);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */ function baseInvoke(object, path, args) {
            path = castPath(path, object);
            object = parent(object, path);
            var func = object == null ? object : object[toKey(last(path))];
            return func == null ? undefined : apply(func, object, args);
        }
        /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */ function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */ function baseIsArrayBuffer(value) {
            return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */ function baseIsDate(value) {
            return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) return true;
            if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && isBuffer(object)) {
                if (!isBuffer(other)) return false;
                objIsArr = true;
                objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                }
            }
            if (!isSameTag) return false;
            stack || (stack = new Stack);
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */ function baseIsMap(value) {
            return isObjectLike(value) && getTag(value) == mapTag;
        }
        /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */ function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) return !length;
            object = Object1(object);
            while(index--){
                var data = matchData[index];
                if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (noCustomizer && data[2]) {
                    if (objValue === undefined && !(key in object)) return false;
                } else {
                    var stack = new Stack;
                    if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
                    if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
                }
            }
            return true;
        }
        /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */ function baseIsRegExp(value) {
            return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */ function baseIsSet(value) {
            return isObjectLike(value) && getTag(value) == setTag;
        }
        /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */ function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */ function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == "function") return value;
            if (value == null) return identity;
            if (typeof value == "object") return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            return property(value);
        }
        /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var result = [];
            for(var key in Object1(object))if (hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeysIn(object) {
            if (!isObject(object)) return nativeKeysIn(object);
            var isProto = isPrototype(object), result = [];
            for(var key in object)if (!(key == "constructor" && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */ function baseLt(value, other) {
            return value < other;
        }
        /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function baseMap(collection, iteratee) {
            var index = -1, result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value, key, collection) {
                result[++index] = iteratee(value, key, collection);
            });
            return result;
        }
        /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            return function(object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        }
        /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
            return function(object) {
                var objValue = get(object, path);
                return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
        }
        /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMerge(object, source, srcIndex, customizer, stack) {
            if (object === source) return;
            baseFor(source, function(srcValue, key) {
                stack || (stack = new Stack);
                if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                else {
                    var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + "", object, source, stack) : undefined;
                    if (newValue === undefined) newValue = srcValue;
                    assignMergeValue(object, key, newValue);
                }
            }, keysIn);
        }
        /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
            if (stacked) {
                assignMergeValue(object, key, stacked);
                return;
            }
            var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined;
            var isCommon = newValue === undefined;
            if (isCommon) {
                var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                newValue = srcValue;
                if (isArr || isBuff || isTyped) {
                    if (isArray(objValue)) newValue = objValue;
                    else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                    else if (isBuff) {
                        isCommon = false;
                        newValue = cloneBuffer(srcValue, true);
                    } else if (isTyped) {
                        isCommon = false;
                        newValue = cloneTypedArray(srcValue, true);
                    } else newValue = [];
                } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                    newValue = objValue;
                    if (isArguments(objValue)) newValue = toPlainObject(objValue);
                    else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                } else isCommon = false;
            }
            if (isCommon) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, newValue);
                mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                stack["delete"](srcValue);
            }
            assignMergeValue(object, key, newValue);
        }
        /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */ function baseNth(array, n) {
            var length = array.length;
            if (!length) return;
            n += n < 0 ? length : 0;
            return isIndex(n, length) ? array[n] : undefined;
        }
        /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */ function baseOrderBy(collection, iteratees, orders) {
            if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
                if (isArray(iteratee)) return function(value) {
                    return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                };
                return iteratee;
            });
            else iteratees = [
                identity
            ];
            var index = -1;
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            var result = baseMap(collection, function(value, key, collection) {
                var criteria = arrayMap(iteratees, function(iteratee) {
                    return iteratee(value);
                });
                return {
                    "criteria": criteria,
                    "index": ++index,
                    "value": value
                };
            });
            return baseSortBy(result, function(object, other) {
                return compareMultiple(object, other, orders);
            });
        }
        /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */ function basePick(object, paths) {
            return basePickBy(object, paths, function(value, path) {
                return hasIn(object, path);
            });
        }
        /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */ function basePickBy(object, paths, predicate) {
            var index = -1, length = paths.length, result = {};
            while(++index < length){
                var path = paths[index], value = baseGet(object, path);
                if (predicate(value, path)) baseSet(result, castPath(path, object), value);
            }
            return result;
        }
        /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */ function basePropertyDeep(path) {
            return function(object) {
                return baseGet(object, path);
            };
        }
        /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */ function basePullAll(array, values, iteratee, comparator) {
            var indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
            if (array === values) values = copyArray(values);
            if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
            while(++index < length){
                var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
                    if (seen !== array) splice.call(seen, fromIndex, 1);
                    splice.call(array, fromIndex, 1);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */ function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0, lastIndex = length - 1;
            while(length--){
                var index = indexes[length];
                if (length == lastIndex || index !== previous) {
                    var previous = index;
                    if (isIndex(index)) splice.call(array, index, 1);
                    else baseUnset(array, index);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */ function baseRandom(lower, upper) {
            return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */ function baseRange(start, end, step, fromRight) {
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array1(length);
            while(length--){
                result[fromRight ? length : ++index] = start;
                start += step;
            }
            return result;
        }
        /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */ function baseRepeat(string, n) {
            var result = "";
            if (!string || n < 1 || n > MAX_SAFE_INTEGER) return result;
            // Leverage the exponentiation by squaring algorithm for a faster repeat.
            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
            do {
                if (n % 2) result += string;
                n = nativeFloor(n / 2);
                if (n) string += string;
            }while (n);
            return result;
        }
        /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */ function baseRest(func, start) {
            return setToString(overRest(func, start, identity), func + "");
        }
        /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */ function baseSample(collection) {
            return arraySample(values(collection));
        }
        /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function baseSampleSize(collection, n) {
            var array = values(collection);
            return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseSet(object, path, value, customizer) {
            if (!isObject(object)) return object;
            path = castPath(path, object);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while(nested != null && ++index < length){
                var key = toKey(path[index]), newValue = value;
                if (key === "__proto__" || key === "constructor" || key === "prototype") return object;
                if (index != lastIndex) {
                    var objValue = nested[key];
                    newValue = customizer ? customizer(objValue, key, nested) : undefined;
                    if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                }
                assignValue(nested, key, newValue);
                nested = nested[key];
            }
            return object;
        }
        /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var baseSetData = !metaMap ? identity : function(func, data) {
            metaMap.set(func, data);
            return func;
        };
        /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var baseSetToString = !defineProperty ? identity : function(func, string) {
            return defineProperty(func, "toString", {
                "configurable": true,
                "enumerable": false,
                "value": constant(string),
                "writable": true
            });
        };
        /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function baseShuffle(collection) {
            return shuffleSelf(values(collection));
        }
        /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end > length ? length : end;
            if (end < 0) end += length;
            length = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var result = Array1(length);
            while(++index < length)result[index] = array[index + start];
            return result;
        }
        /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function baseSome(collection, predicate) {
            var result;
            baseEach(collection, function(value, index, collection) {
                result = predicate(value, index, collection);
                return !result;
            });
            return !!result;
        }
        /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndex(array, value, retHighest) {
            var low = 0, high = array == null ? low : array.length;
            if (typeof value == "number" && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while(low < high){
                    var mid = low + high >>> 1, computed = array[mid];
                    if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                    else high = mid;
                }
                return high;
            }
            return baseSortedIndexBy(array, value, identity, retHighest);
        }
        /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndexBy(array, value, iteratee, retHighest) {
            var low = 0, high = array == null ? 0 : array.length;
            if (high === 0) return 0;
            value = iteratee(value);
            var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined;
            while(low < high){
                var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                if (valIsNaN) var setLow = retHighest || othIsReflexive;
                else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                else if (othIsNull || othIsSymbol) setLow = false;
                else setLow = retHighest ? computed <= value : computed < value;
                if (setLow) low = mid + 1;
                else high = mid;
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
        }
        /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseSortedUniq(array, iteratee) {
            var index = -1, length = array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                if (!index || !eq(computed, seen)) {
                    var seen = computed;
                    result[resIndex++] = value === 0 ? 0 : value;
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */ function baseToNumber(value) {
            if (typeof value == "number") return value;
            if (isSymbol(value)) return NAN;
            return +value;
        }
        /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */ function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == "string") return value;
            if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + "";
            if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : "";
            var result = value + "";
            return result == "0" && 1 / value == -INFINITY ? "-0" : result;
        }
        /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseUniq(array, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
            if (comparator) {
                isCommon = false;
                includes = arrayIncludesWith;
            } else if (length >= LARGE_ARRAY_SIZE) {
                var set = iteratee ? null : createSet(array);
                if (set) return setToArray(set);
                isCommon = false;
                includes = cacheHas;
                seen = new SetCache;
            } else seen = iteratee ? [] : result;
            outer: while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var seenIndex = seen.length;
                    while(seenIndex--){
                        if (seen[seenIndex] === computed) continue outer;
                    }
                    if (iteratee) seen.push(computed);
                    result.push(value);
                } else if (!includes(seen, computed, comparator)) {
                    if (seen !== result) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */ function baseUnset(object, path) {
            path = castPath(path, object);
            object = parent(object, path);
            return object == null || delete object[toKey(last(path))];
        }
        /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseUpdate(object, path, updater, customizer) {
            return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */ function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
            return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */ function baseWrapperValue(value, actions) {
            var result = value;
            if (result instanceof LazyWrapper) result = result.value();
            return arrayReduce(actions, function(result, action) {
                return action.func.apply(action.thisArg, arrayPush([
                    result
                ], action.args));
            }, result);
        }
        /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */ function baseXor(arrays, iteratee, comparator) {
            var length = arrays.length;
            if (length < 2) return length ? baseUniq(arrays[0]) : [];
            var index = -1, result = Array1(length);
            while(++index < length){
                var array = arrays[index], othIndex = -1;
                while(++othIndex < length)if (othIndex != index) result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
            }
            return baseUniq(baseFlatten(result, 1), iteratee, comparator);
        }
        /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */ function baseZipObject(props, values, assignFunc) {
            var index = -1, length = props.length, valsLength = values.length, result = {};
            while(++index < length){
                var value = index < valsLength ? values[index] : undefined;
                assignFunc(result, props[index], value);
            }
            return result;
        }
        /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */ function castArrayLikeObject(value) {
            return isArrayLikeObject(value) ? value : [];
        }
        /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */ function castFunction(value) {
            return typeof value == "function" ? value : identity;
        }
        /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */ function castPath(value, object) {
            if (isArray(value)) return value;
            return isKey(value, object) ? [
                value
            ] : stringToPath(toString(value));
        }
        /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ var castRest = baseRest;
        /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */ function castSlice(array, start, end) {
            var length = array.length;
            end = end === undefined ? length : end;
            return !start && end >= length ? array : baseSlice(array, start, end);
        }
        /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */ var clearTimeout = ctxClearTimeout || function(id) {
            return root.clearTimeout(id);
        };
        /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */ function cloneBuffer(buffer, isDeep) {
            if (isDeep) return buffer.slice();
            var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
            buffer.copy(result);
            return result;
        }
        /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */ function cloneArrayBuffer(arrayBuffer) {
            var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
            new Uint8Array(result).set(new Uint8Array(arrayBuffer));
            return result;
        }
        /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */ function cloneDataView(dataView, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
            return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */ function cloneRegExp(regexp) {
            var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
            result.lastIndex = regexp.lastIndex;
            return result;
        }
        /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */ function cloneSymbol(symbol) {
            return symbolValueOf ? Object1(symbolValueOf.call(symbol)) : {};
        }
        /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */ function cloneTypedArray(typedArray, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
            return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */ function compareAscending(value, other) {
            if (value !== other) {
                var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
            }
            return 0;
        }
        /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */ function compareMultiple(object, other, orders) {
            var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
            while(++index < length){
                var result = compareAscending(objCriteria[index], othCriteria[index]);
                if (result) {
                    if (index >= ordersLength) return result;
                    var order = orders[index];
                    return result * (order == "desc" ? -1 : 1);
                }
            }
            // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
            // that causes it, under certain circumstances, to provide the same value for
            // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
            // for more details.
            //
            // This also ensures a stable sort in V8 and other engines.
            // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
            return object.index - other.index;
        }
        /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgs(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
            while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
            while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
            while(rangeLength--)result[leftIndex++] = args[argsIndex++];
            return result;
        }
        /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgsRight(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
            while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
            var offset = argsIndex;
            while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
            while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
            return result;
        }
        /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */ function copyArray(source, array) {
            var index = -1, length = source.length;
            array || (array = Array1(length));
            while(++index < length)array[index] = source[index];
            return array;
        }
        /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */ function copyObject(source, props, object, customizer) {
            var isNew = !object;
            object || (object = {});
            var index = -1, length = props.length;
            while(++index < length){
                var key = props[index];
                var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
                if (newValue === undefined) newValue = source[key];
                if (isNew) baseAssignValue(object, key, newValue);
                else assignValue(object, key, newValue);
            }
            return object;
        }
        /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbols(source, object) {
            return copyObject(source, getSymbols(source), object);
        }
        /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbolsIn(source, object) {
            return copyObject(source, getSymbolsIn(source), object);
        }
        /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter, initializer) {
            return function(collection, iteratee) {
                var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                return func(collection, setter, getIteratee(iteratee, 2), accumulator);
            };
        }
        /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */ function createAssigner(assigner) {
            return baseRest(function(object, sources) {
                var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
                customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined : customizer;
                    length = 1;
                }
                object = Object1(object);
                while(++index < length){
                    var source = sources[index];
                    if (source) assigner(object, source, index, customizer);
                }
                return object;
            });
        }
        /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee) {
                if (collection == null) return collection;
                if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                var length = collection.length, index = fromRight ? length : -1, iterable = Object1(collection);
                while(fromRight ? index-- : ++index < length){
                    if (iteratee(iterable[index], index, iterable) === false) break;
                }
                return collection;
            };
        }
        /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var index = -1, iterable = Object1(object), props = keysFunc(object), length = props.length;
                while(length--){
                    var key = props[fromRight ? length : ++index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createBind(func, bitmask, thisArg) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, arguments);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */ function createCaseFirst(methodName) {
            return function(string) {
                string = toString(string);
                var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
                var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                var trailing = strSymbols ? castSlice(strSymbols, 1).join("") : string.slice(1);
                return chr[methodName]() + trailing;
            };
        }
        /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */ function createCompounder(callback) {
            return function(string) {
                return arrayReduce(words(deburr(string).replace(reApos, "")), callback, "");
            };
        }
        /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */ function createCtor(Ctor) {
            return function() {
                // Use a `switch` statement to work with class constructors. See
                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                switch(args.length){
                    case 0:
                        return new Ctor;
                    case 1:
                        return new Ctor(args[0]);
                    case 2:
                        return new Ctor(args[0], args[1]);
                    case 3:
                        return new Ctor(args[0], args[1], args[2]);
                    case 4:
                        return new Ctor(args[0], args[1], args[2], args[3]);
                    case 5:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                    case 6:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                    case 7:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }
                var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(result) ? result : thisBinding;
            };
        }
        /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createCurry(func, bitmask, arity) {
            var Ctor = createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                while(index--)args[index] = arguments[index];
                var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                length -= holders.length;
                if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return apply(fn, this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */ function createFind(findIndexFunc) {
            return function(collection, predicate, fromIndex) {
                var iterable = Object1(collection);
                if (!isArrayLike(collection)) {
                    var iteratee = getIteratee(predicate, 3);
                    collection = keys(collection);
                    predicate = function(key) {
                        return iteratee(iterable[key], key, iterable);
                    };
                }
                var index = findIndexFunc(collection, predicate, fromIndex);
                return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
            };
        }
        /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */ function createFlow(fromRight) {
            return flatRest(function(funcs) {
                var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                if (fromRight) funcs.reverse();
                while(index--){
                    var func = funcs[index];
                    if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
                    if (prereq && !wrapper && getFuncName(func) == "wrapper") var wrapper = new LodashWrapper([], true);
                }
                index = wrapper ? index : length;
                while(++index < length){
                    func = funcs[index];
                    var funcName = getFuncName(func), data = funcName == "wrapper" ? getData(func) : undefined;
                    if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
                return function() {
                    var args = arguments, value = args[0];
                    if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                    var index = 0, result = length ? funcs[index].apply(this, args) : value;
                    while(++index < length)result = funcs[index].call(this, result);
                    return result;
                };
            });
        }
        /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
            var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length;
                while(index--)args[index] = arguments[index];
                if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                if (partials) args = composeArgs(args, partials, holders, isCurried);
                if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                length -= holdersCount;
                if (isCurried && length < arity) {
                    var newHolders = replaceHolders(args, placeholder);
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                }
                var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                length = args.length;
                if (argPos) args = reorder(args, argPos);
                else if (isFlip && length > 1) args.reverse();
                if (isAry && ary < length) args.length = ary;
                if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                return fn.apply(thisBinding, args);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */ function createInverter(setter, toIteratee) {
            return function(object, iteratee) {
                return baseInverter(object, setter, toIteratee(iteratee), {});
            };
        }
        /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */ function createMathOperation(operator, defaultValue) {
            return function(value, other) {
                var result;
                if (value === undefined && other === undefined) return defaultValue;
                if (value !== undefined) result = value;
                if (other !== undefined) {
                    if (result === undefined) return other;
                    if (typeof value == "string" || typeof other == "string") {
                        value = baseToString(value);
                        other = baseToString(other);
                    } else {
                        value = baseToNumber(value);
                        other = baseToNumber(other);
                    }
                    result = operator(value, other);
                }
                return result;
            };
        }
        /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */ function createOver(arrayFunc) {
            return flatRest(function(iteratees) {
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                return baseRest(function(args) {
                    var thisArg = this;
                    return arrayFunc(iteratees, function(iteratee) {
                        return apply(iteratee, thisArg, args);
                    });
                });
            });
        }
        /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */ function createPadding(length, chars) {
            chars = chars === undefined ? " " : baseToString(chars);
            var charsLength = chars.length;
            if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
            var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
            return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join("") : result.slice(0, length);
        }
        /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */ function createPartial(func, bitmask, thisArg, partials) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                return apply(fn, isBind ? thisArg : this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */ function createRange(fromRight) {
            return function(start, end, step) {
                if (step && typeof step != "number" && isIterateeCall(start, end, step)) end = step = undefined;
                // Ensure the sign of `-0` is preserved.
                start = toFinite(start);
                if (end === undefined) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
                return baseRange(start, end, step, fromRight);
            };
        }
        /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */ function createRelationalOperation(operator) {
            return function(value, other) {
                if (!(typeof value == "string" && typeof other == "string")) {
                    value = toNumber(value);
                    other = toNumber(other);
                }
                return operator(value, other);
            };
        }
        /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
            var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
            bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
            bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
            if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
            var newData = [
                func,
                bitmask,
                thisArg,
                newPartials,
                newHolders,
                newPartialsRight,
                newHoldersRight,
                argPos,
                ary,
                arity
            ];
            var result = wrapFunc.apply(undefined, newData);
            if (isLaziable(func)) setData(result, newData);
            result.placeholder = placeholder;
            return setWrapToString(result, func, bitmask);
        }
        /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */ function createRound(methodName) {
            var func = Math[methodName];
            return function(number, precision) {
                number = toNumber(number);
                precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                if (precision && nativeIsFinite(number)) {
                    // Shift with exponential notation to avoid floating-point issues.
                    // See [MDN](https://mdn.io/round#Examples) for more details.
                    var pair = (toString(number) + "e").split("e"), value = func(pair[0] + "e" + (+pair[1] + precision));
                    pair = (toString(value) + "e").split("e");
                    return +(pair[0] + "e" + (+pair[1] - precision));
                }
                return func(number);
            };
        }
        /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */ var createSet = !(Set && 1 / setToArray(new Set([
            ,
            -0
        ]))[1] == INFINITY) ? noop : function(values) {
            return new Set(values);
        };
        /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */ function createToPairs(keysFunc) {
            return function(object) {
                var tag = getTag(object);
                if (tag == mapTag) return mapToArray(object);
                if (tag == setTag) return setToPairs(object);
                return baseToPairs(object, keysFunc(object));
            };
        }
        /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
            var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
            if (!isBindKey && typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            var length = partials ? partials.length : 0;
            if (!length) {
                bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                partials = holders = undefined;
            }
            ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
            arity = arity === undefined ? arity : toInteger(arity);
            length -= holders ? holders.length : 0;
            if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials, holdersRight = holders;
                partials = holders = undefined;
            }
            var data = isBindKey ? undefined : getData(func);
            var newData = [
                func,
                bitmask,
                thisArg,
                partials,
                holders,
                partialsRight,
                holdersRight,
                argPos,
                ary,
                arity
            ];
            if (data) mergeData(newData, data);
            func = newData[0];
            bitmask = newData[1];
            thisArg = newData[2];
            partials = newData[3];
            holders = newData[4];
            arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
            if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
            if (!bitmask || bitmask == WRAP_BIND_FLAG) var result = createBind(func, bitmask, thisArg);
            else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) result = createCurry(func, bitmask, arity);
            else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) result = createPartial(func, bitmask, thisArg, partials);
            else result = createHybrid.apply(undefined, newData);
            var setter = data ? baseSetData : setData;
            return setWrapToString(setter(result, newData), func, bitmask);
        }
        /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsAssignIn(objValue, srcValue, key, object) {
            if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
            return objValue;
        }
        /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
            if (isObject(objValue) && isObject(srcValue)) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, objValue);
                baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
                stack["delete"](srcValue);
            }
            return objValue;
        }
        /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */ function customOmitClone(value) {
            return isPlainObject(value) ? undefined : value;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
            // Check that cyclic values are equal.
            var arrStacked = stack.get(array);
            var othStacked = stack.get(other);
            if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
            var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index];
                if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                if (compared !== undefined) {
                    if (compared) continue;
                    result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function(othValue, othIndex) {
                        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                    })) {
                        result = false;
                        break;
                    }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    result = false;
                    break;
                }
            }
            stack["delete"](array);
            stack["delete"](other);
            return result;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
            switch(tag){
                case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + "";
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) return false;
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) return stacked == other;
                    bitmask |= COMPARE_UNORDERED_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                    stack["delete"](object);
                    return result;
                case symbolTag:
                    if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
            return false;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            // Check that cyclic values are equal.
            var objStacked = stack.get(object);
            var othStacked = stack.get(other);
            if (objStacked && othStacked) return objStacked == other && othStacked == object;
            var result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                    result = false;
                    break;
                }
                skipCtor || (skipCtor = key == "constructor");
            }
            if (result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
            }
            stack["delete"](object);
            stack["delete"](other);
            return result;
        }
        /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ function flatRest(func) {
            return setToString(overRest(func, undefined, flatten), func + "");
        }
        /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
        }
        /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeysIn(object) {
            return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */ var getData = !metaMap ? noop : function(func) {
            return metaMap.get(func);
        };
        /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */ function getFuncName(func) {
            var result = func.name + "", array = realNames[result], length = hasOwnProperty.call(realNames, result) ? array.length : 0;
            while(length--){
                var data = array[length], otherFunc = data.func;
                if (otherFunc == null || otherFunc == func) return data.name;
            }
            return result;
        }
        /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */ function getHolder(func) {
            var object = hasOwnProperty.call(lodash, "placeholder") ? lodash : func;
            return object.placeholder;
        }
        /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */ function getIteratee() {
            var result = lodash.iteratee || iteratee;
            result = result === iteratee ? baseIteratee : result;
            return arguments.length ? result(arguments[0], arguments[1]) : result;
        }
        /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
        }
        /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */ function getMatchData(object) {
            var result = keys(object), length = result.length;
            while(length--){
                var key = result[length], value = object[key];
                result[length] = [
                    key,
                    value,
                    isStrictComparable(value)
                ];
            }
            return result;
        }
        /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined;
        }
        /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */ function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = undefined;
                var unmasked = true;
            } catch (e) {}
            var result = nativeObjectToString.call(value);
            if (unmasked) {
                if (isOwn) value[symToStringTag] = tag;
                else delete value[symToStringTag];
            }
            return result;
        }
        /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
            if (object == null) return [];
            object = Object1(object);
            return arrayFilter(nativeGetSymbols(object), function(symbol) {
                return propertyIsEnumerable.call(object, symbol);
            });
        };
        /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
            var result = [];
            while(object){
                arrayPush(result, getSymbols(object));
                object = getPrototype(object);
            }
            return result;
        };
        /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
            var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : "";
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return result;
        };
        /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */ function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while(++index < length){
                var data = transforms[index], size = data.size;
                switch(data.type){
                    case "drop":
                        start += size;
                        break;
                    case "dropRight":
                        end -= size;
                        break;
                    case "take":
                        end = nativeMin(end, start + size);
                        break;
                    case "takeRight":
                        start = nativeMax(start, end - size);
                        break;
                }
            }
            return {
                "start": start,
                "end": end
            };
        }
        /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */ function getWrapDetails(source) {
            var match = source.match(reWrapDetails);
            return match ? match[1].split(reSplitDetails) : [];
        }
        /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */ function hasPath(object, path, hasFunc) {
            path = castPath(path, object);
            var index = -1, length = path.length, result = false;
            while(++index < length){
                var key = toKey(path[index]);
                if (!(result = object != null && hasFunc(object, key))) break;
                object = object[key];
            }
            if (result || ++index != length) return result;
            length = object == null ? 0 : object.length;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */ function initCloneArray(array) {
            var length = array.length, result = new array.constructor(length);
            // Add properties assigned by `RegExp#exec`.
            if (length && typeof array[0] == "string" && hasOwnProperty.call(array, "index")) {
                result.index = array.index;
                result.input = array.input;
            }
            return result;
        }
        /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneObject(object) {
            return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch(tag){
                case arrayBufferTag:
                    return cloneArrayBuffer(object);
                case boolTag:
                case dateTag:
                    return new Ctor(+object);
                case dataViewTag:
                    return cloneDataView(object, isDeep);
                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                    return cloneTypedArray(object, isDeep);
                case mapTag:
                    return new Ctor;
                case numberTag:
                case stringTag:
                    return new Ctor(object);
                case regexpTag:
                    return cloneRegExp(object);
                case setTag:
                    return new Ctor;
                case symbolTag:
                    return cloneSymbol(object);
            }
        }
        /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */ function insertWrapDetails(source, details) {
            var length = details.length;
            if (!length) return source;
            var lastIndex = length - 1;
            details[lastIndex] = (length > 1 ? "& " : "") + details[lastIndex];
            details = details.join(length > 2 ? ", " : " ");
            return source.replace(reWrapComment, "{\n/* [wrapped with " + details + "] */\n");
        }
        /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */ function isFlattenable(value) {
            return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */ function isIndex(value, length) {
            var type = typeof value;
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */ function isIterateeCall(value, index, object) {
            if (!isObject(object)) return false;
            var type = typeof index;
            if (type == "number" ? isArrayLike(object) && isIndex(index, object.length) : type == "string" && index in object) return eq(object[index], value);
            return false;
        }
        /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */ function isKey(value, object) {
            if (isArray(value)) return false;
            var type = typeof value;
            if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) return true;
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object1(object);
        }
        /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */ function isKeyable(value) {
            var type = typeof value;
            return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
        }
        /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */ function isLaziable(func) {
            var funcName = getFuncName(func), other = lodash[funcName];
            if (typeof other != "function" || !(funcName in LazyWrapper.prototype)) return false;
            if (func === other) return true;
            var data = getData(other);
            return !!data && func === data[0];
        }
        /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */ var isMaskable = coreJsData ? isFunction : stubFalse;
        /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */ function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
            return value === proto;
        }
        /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function matchesStrictComparable(key, srcValue) {
            return function(object) {
                if (object == null) return false;
                return object[key] === srcValue && (srcValue !== undefined || key in Object1(object));
            };
        }
        /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */ function memoizeCapped(func) {
            var result = memoize(func, function(key) {
                if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                return key;
            });
            var cache = result.cache;
            return result;
        }
        /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */ function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
            var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
            // Exit early if metadata can't be merged.
            if (!(isCommon || isCombo)) return data;
            // Use source `thisArg` if available.
            if (srcBitmask & WRAP_BIND_FLAG) {
                data[2] = source[2];
                // Set when currying a bound function.
                newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
            }
            // Compose partial arguments.
            var value = source[3];
            if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
            }
            // Compose partial right arguments.
            value = source[5];
            if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
            }
            // Use source `argPos` if available.
            value = source[7];
            if (value) data[7] = value;
            // Use source `ary` if it's smaller.
            if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            // Use source `arity` if one is not provided.
            if (data[9] == null) data[9] = source[9];
            // Use source `func` and merge bitmasks.
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
        }
        /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function nativeKeysIn(object) {
            var result = [];
            if (object != null) for(var key in Object1(object))result.push(key);
            return result;
        }
        /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */ function objectToString(value) {
            return nativeObjectToString.call(value);
        }
        /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */ function overRest(func, start, transform) {
            start = nativeMax(start === undefined ? func.length - 1 : start, 0);
            return function() {
                var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                while(++index < length)array[index] = args[start + index];
                index = -1;
                var otherArgs = Array1(start + 1);
                while(++index < start)otherArgs[index] = args[index];
                otherArgs[start] = transform(array);
                return apply(func, this, otherArgs);
            };
        }
        /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */ function parent(object, path) {
            return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */ function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
            while(length--){
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
            }
            return array;
        }
        /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */ function safeGet(object, key) {
            if (key === "constructor" && typeof object[key] === "function") return;
            if (key == "__proto__") return;
            return object[key];
        }
        /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var setData = shortOut(baseSetData);
        /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ var setTimeout = ctxSetTimeout || function(func, wait) {
            return root.setTimeout(func, wait);
        };
        /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var setToString = shortOut(baseSetToString);
        /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */ function setWrapToString(wrapper, reference, bitmask) {
            var source = reference + "";
            return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */ function shortOut(func) {
            var count = 0, lastCalled = 0;
            return function() {
                var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;
                if (remaining > 0) {
                    if (++count >= HOT_COUNT) return arguments[0];
                } else count = 0;
                return func.apply(undefined, arguments);
            };
        }
        /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */ function shuffleSelf(array, size) {
            var index = -1, length = array.length, lastIndex = length - 1;
            size = size === undefined ? length : size;
            while(++index < size){
                var rand = baseRandom(index, lastIndex), value = array[rand];
                array[rand] = array[index];
                array[index] = value;
            }
            array.length = size;
            return array;
        }
        /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */ var stringToPath = memoizeCapped(function(string) {
            var result = [];
            if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
            string.replace(rePropName, function(match, number, quote, subString) {
                result.push(quote ? subString.replace(reEscapeChar, "$1") : number || match);
            });
            return result;
        });
        /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */ function toKey(value) {
            if (typeof value == "string" || isSymbol(value)) return value;
            var result = value + "";
            return result == "0" && 1 / value == -INFINITY ? "-0" : result;
        }
        /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */ function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + "";
                } catch (e) {}
            }
            return "";
        }
        /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */ function updateWrapDetails(details, bitmask) {
            arrayEach(wrapFlags, function(pair) {
                var value = "_." + pair[0];
                if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
            });
            return details.sort();
        }
        /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */ function wrapperClone(wrapper) {
            if (wrapper instanceof LazyWrapper) return wrapper.clone();
            var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
            result.__actions__ = copyArray(wrapper.__actions__);
            result.__index__ = wrapper.__index__;
            result.__values__ = wrapper.__values__;
            return result;
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */ function chunk(array, size, guard) {
            if (guard ? isIterateeCall(array, size, guard) : size === undefined) size = 1;
            else size = nativeMax(toInteger(size), 0);
            var length = array == null ? 0 : array.length;
            if (!length || size < 1) return [];
            var index = 0, resIndex = 0, result = Array1(nativeCeil(length / size));
            while(index < length)result[resIndex++] = baseSlice(array, index, index += size);
            return result;
        }
        /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index];
                if (value) result[resIndex++] = value;
            }
            return result;
        }
        /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */ function concat() {
            var length = arguments.length;
            if (!length) return [];
            var args = Array1(length - 1), array = arguments[0], index = length;
            while(index--)args[index - 1] = arguments[index];
            return arrayPush(isArray(array) ? copyArray(array) : [
                array
            ], baseFlatten(args, 1));
        }
        /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */ var difference = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var differenceBy = baseRest(function(array, values) {
            var iteratee = last(values);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */ var differenceWith = baseRest(function(array, values) {
            var comparator = last(values);
            if (isArrayLikeObject(comparator)) comparator = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator) : [];
        });
        /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function drop(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function dropRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */ function fill(array, value, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (start && typeof start != "number" && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
            }
            return baseFill(array, value, start, end);
        }
        /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */ function findIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */ function findLastIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length - 1;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */ function flatten(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, 1) : [];
        }
        /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */ function flattenDeep(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, INFINITY) : [];
        }
        /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */ function flattenDepth(array, depth) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(array, depth);
        }
        /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */ function fromPairs(pairs) {
            var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
            while(++index < length){
                var pair = pairs[index];
                result[pair[0]] = pair[1];
            }
            return result;
        }
        /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */ function head(array) {
            return array && array.length ? array[0] : undefined;
        }
        /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */ function indexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseIndexOf(array, value, index);
        }
        /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */ function initial(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 0, -1) : [];
        }
        /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */ var intersection = baseRest(function(arrays) {
            var mapped = arrayMap(arrays, castArrayLikeObject);
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */ var intersectionBy = baseRest(function(arrays) {
            var iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            if (iteratee === last(mapped)) iteratee = undefined;
            else mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */ var intersectionWith = baseRest(function(arrays) {
            var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            comparator = typeof comparator == "function" ? comparator : undefined;
            if (comparator) mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined, comparator) : [];
        });
        /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */ function join(array, separator) {
            return array == null ? "" : nativeJoin.call(array, separator);
        }
        /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */ function last(array) {
            var length = array == null ? 0 : array.length;
            return length ? array[length - 1] : undefined;
        }
        /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */ function lastIndexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */ function nth(array, n) {
            return array && array.length ? baseNth(array, toInteger(n)) : undefined;
        }
        /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */ var pull = baseRest(pullAll);
        /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */ function pullAll(array, values) {
            return array && array.length && values && values.length ? basePullAll(array, values) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */ function pullAllBy(array, values, iteratee) {
            return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */ function pullAllWith(array, values, comparator) {
            return array && array.length && values && values.length ? basePullAll(array, values, undefined, comparator) : array;
        }
        /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */ var pullAt = flatRest(function(array, indexes) {
            var length = array == null ? 0 : array.length, result = baseAt(array, indexes);
            basePullAt(array, arrayMap(indexes, function(index) {
                return isIndex(index, length) ? +index : index;
            }).sort(compareAscending));
            return result;
        });
        /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */ function remove(array, predicate) {
            var result = [];
            if (!(array && array.length)) return result;
            var index = -1, indexes = [], length = array.length;
            predicate = getIteratee(predicate, 3);
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) {
                    result.push(value);
                    indexes.push(index);
                }
            }
            basePullAt(array, indexes);
            return result;
        }
        /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function reverse(array) {
            return array == null ? array : nativeReverse.call(array);
        }
        /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function slice(array, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (end && typeof end != "number" && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
            } else {
                start = start == null ? 0 : toInteger(start);
                end = end === undefined ? length : toInteger(end);
            }
            return baseSlice(array, start, end);
        }
        /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */ function sortedIndex(array, value) {
            return baseSortedIndex(array, value);
        }
        /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */ function sortedIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
        }
        /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */ function sortedIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value);
                if (index < length && eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */ function sortedLastIndex(array, value) {
            return baseSortedIndex(array, value, true);
        }
        /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */ function sortedLastIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
        }
        /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */ function sortedLastIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value, true) - 1;
                if (eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */ function sortedUniq(array) {
            return array && array.length ? baseSortedUniq(array) : [];
        }
        /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */ function sortedUniqBy(array, iteratee) {
            return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */ function tail(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 1, length) : [];
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */ function take(array, n, guard) {
            if (!(array && array.length)) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */ function takeRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */ function takeRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */ function takeWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */ var union = baseRest(function(arrays) {
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ var unionBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var unionWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == "function" ? comparator : undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
        });
        /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */ function uniq(array) {
            return array && array.length ? baseUniq(array) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniqBy(array, iteratee) {
            return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */ function uniqWith(array, comparator) {
            comparator = typeof comparator == "function" ? comparator : undefined;
            return array && array.length ? baseUniq(array, undefined, comparator) : [];
        }
        /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */ function unzip(array) {
            if (!(array && array.length)) return [];
            var length = 0;
            array = arrayFilter(array, function(group) {
                if (isArrayLikeObject(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                }
            });
            return baseTimes(length, function(index) {
                return arrayMap(array, baseProperty(index));
            });
        }
        /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */ function unzipWith(array, iteratee) {
            if (!(array && array.length)) return [];
            var result = unzip(array);
            if (iteratee == null) return result;
            return arrayMap(result, function(group) {
                return apply(iteratee, undefined, group);
            });
        }
        /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */ var without = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });
        /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */ var xor = baseRest(function(arrays) {
            return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var xorBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var xorWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == "function" ? comparator : undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
        });
        /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */ var zip = baseRest(unzip);
        /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */ function zipObject(props, values) {
            return baseZipObject(props || [], values || [], assignValue);
        }
        /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */ function zipObjectDeep(props, values) {
            return baseZipObject(props || [], values || [], baseSet);
        }
        /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */ var zipWith = baseRest(function(arrays) {
            var length = arrays.length, iteratee = length > 1 ? arrays[length - 1] : undefined;
            iteratee = typeof iteratee == "function" ? (arrays.pop(), iteratee) : undefined;
            return unzipWith(arrays, iteratee);
        });
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            var result = lodash(value);
            result.__chain__ = true;
            return result;
        }
        /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */ function tap(value, interceptor) {
            interceptor(value);
            return value;
        }
        /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */ function thru(value, interceptor) {
            return interceptor(value);
        }
        /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */ var wrapperAt = flatRest(function(paths) {
            var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
                return baseAt(object, paths);
            };
            if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
            value = value.slice(start, +start + (length ? 1 : 0));
            value.__actions__.push({
                "func": thru,
                "args": [
                    interceptor
                ],
                "thisArg": undefined
            });
            return new LodashWrapper(value, this.__chain__).thru(function(array) {
                if (length && !array.length) array.push(undefined);
                return array;
            });
        });
        /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */ function wrapperChain() {
            return chain(this);
        }
        /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */ function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
        }
        /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */ function wrapperNext() {
            if (this.__values__ === undefined) this.__values__ = toArray(this.value());
            var done = this.__index__ >= this.__values__.length, value = done ? undefined : this.__values__[this.__index__++];
            return {
                "done": done,
                "value": value
            };
        }
        /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */ function wrapperToIterator() {
            return this;
        }
        /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */ function wrapperPlant(value) {
            var result, parent = this;
            while(parent instanceof baseLodash){
                var clone = wrapperClone(parent);
                clone.__index__ = 0;
                clone.__values__ = undefined;
                if (result) previous.__wrapped__ = clone;
                else result = clone;
                var previous = clone;
                parent = parent.__wrapped__;
            }
            previous.__wrapped__ = value;
            return result;
        }
        /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function wrapperReverse() {
            var value = this.__wrapped__;
            if (value instanceof LazyWrapper) {
                var wrapped = value;
                if (this.__actions__.length) wrapped = new LazyWrapper(this);
                wrapped = wrapped.reverse();
                wrapped.__actions__.push({
                    "func": thru,
                    "args": [
                        reverse
                    ],
                    "thisArg": undefined
                });
                return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(reverse);
        }
        /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */ function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) ++result[key];
            else baseAssignValue(result, key, 1);
        });
        /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */ function every(collection, predicate, guard) {
            var func = isArray(collection) ? arrayEvery : baseEvery;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */ function filter(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */ var find = createFind(findIndex);
        /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */ var findLast = createFind(findLastIndex);
        /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMap(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), 1);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMapDeep(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), INFINITY);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */ function flatMapDepth(collection, iteratee, depth) {
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(map(collection, iteratee), depth);
        }
        /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forEach(collection, iteratee) {
            var func = isArray(collection) ? arrayEach : baseEach;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */ function forEachRight(collection, iteratee) {
            var func = isArray(collection) ? arrayEachRight : baseEachRight;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) result[key].push(value);
            else baseAssignValue(result, key, [
                value
            ]);
        });
        /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */ function includes(collection, value, fromIndex, guard) {
            collection = isArrayLike(collection) ? collection : values(collection);
            fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
            var length = collection.length;
            if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
            return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ var invokeMap = baseRest(function(collection, path, args) {
            var index = -1, isFunc = typeof path == "function", result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value) {
                result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
            });
            return result;
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */ var keyBy = createAggregator(function(result, value, key) {
            baseAssignValue(result, key, value);
        });
        /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */ function map(collection, iteratee) {
            var func = isArray(collection) ? arrayMap : baseMap;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */ function orderBy(collection, iteratees, orders, guard) {
            if (collection == null) return [];
            if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                iteratees
            ];
            orders = guard ? undefined : orders;
            if (!isArray(orders)) orders = orders == null ? [] : [
                orders
            ];
            return baseOrderBy(collection, iteratees, orders);
        }
        /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */ var partition = createAggregator(function(result, value, key) {
            result[key ? 0 : 1].push(value);
        }, function() {
            return [
                [],
                []
            ];
        });
        /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */ function reduce(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
        }
        /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ function reduceRight(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
        }
        /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */ function reject(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, negate(getIteratee(predicate, 3)));
        }
        /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */ function sample(collection) {
            var func = isArray(collection) ? arraySample : baseSample;
            return func(collection);
        }
        /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */ function sampleSize(collection, n, guard) {
            if (guard ? isIterateeCall(collection, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            var func = isArray(collection) ? arraySampleSize : baseSampleSize;
            return func(collection, n);
        }
        /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */ function shuffle(collection) {
            var func = isArray(collection) ? arrayShuffle : baseShuffle;
            return func(collection);
        }
        /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            if (collection == null) return 0;
            if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
            var tag = getTag(collection);
            if (tag == mapTag || tag == setTag) return collection.size;
            return baseKeys(collection).length;
        }
        /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */ function some(collection, predicate, guard) {
            var func = isArray(collection) ? arraySome : baseSome;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */ var sortBy = baseRest(function(collection, iteratees) {
            if (collection == null) return [];
            var length = iteratees.length;
            if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
            else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                iteratees[0]
            ];
            return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        /*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */ var now = ctxNow || function() {
            return root.Date.now();
        };
        /*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */ function after(n, func) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        }
        /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */ function ary(func, n, guard) {
            n = guard ? undefined : n;
            n = func && n == null ? func.length : n;
            return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
        }
        /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */ function before(n, func) {
            var result;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n > 0) result = func.apply(this, arguments);
                if (n <= 1) func = undefined;
                return result;
            };
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */ var bind = baseRest(function(func, thisArg, partials) {
            var bitmask = WRAP_BIND_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bind));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(func, bitmask, thisArg, partials, holders);
        });
        /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */ var bindKey = baseRest(function(object, key, partials) {
            var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bindKey));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(key, bitmask, object, partials, holders);
        });
        /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */ function curry(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curry.placeholder;
            return result;
        }
        /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */ function curryRight(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curryRight.placeholder;
            return result;
        }
        /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */ function debounce(func, wait, options) {
            var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            wait = toNumber(wait) || 0;
            if (isObject(options)) {
                leading = !!options.leading;
                maxing = "maxWait" in options;
                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                trailing = "trailing" in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
                var args = lastArgs, thisArg = lastThis;
                lastArgs = lastThis = undefined;
                lastInvokeTime = time;
                result = func.apply(thisArg, args);
                return result;
            }
            function leadingEdge(time) {
                // Reset any `maxWait` timer.
                lastInvokeTime = time;
                // Start the timer for the trailing edge.
                timerId = setTimeout(timerExpired, wait);
                // Invoke the leading edge.
                return leading ? invokeFunc(time) : result;
            }
            function remainingWait(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            }
            function shouldInvoke(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                // Either this is the first call, activity has stopped and we're at the
                // trailing edge, the system time has gone backwards and we're treating
                // it as the trailing edge, or we've hit the `maxWait` limit.
                return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }
            function timerExpired() {
                var time = now();
                if (shouldInvoke(time)) return trailingEdge(time);
                // Restart the timer.
                timerId = setTimeout(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
                timerId = undefined;
                // Only invoke if we have `lastArgs` which means `func` has been
                // debounced at least once.
                if (trailing && lastArgs) return invokeFunc(time);
                lastArgs = lastThis = undefined;
                return result;
            }
            function cancel() {
                if (timerId !== undefined) clearTimeout(timerId);
                lastInvokeTime = 0;
                lastArgs = lastCallTime = lastThis = timerId = undefined;
            }
            function flush() {
                return timerId === undefined ? result : trailingEdge(now());
            }
            function debounced() {
                var time = now(), isInvoking = shouldInvoke(time);
                lastArgs = arguments;
                lastThis = this;
                lastCallTime = time;
                if (isInvoking) {
                    if (timerId === undefined) return leadingEdge(lastCallTime);
                    if (maxing) {
                        // Handle invocations in a tight loop.
                        clearTimeout(timerId);
                        timerId = setTimeout(timerExpired, wait);
                        return invokeFunc(lastCallTime);
                    }
                }
                if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
                return result;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
        }
        /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */ var defer = baseRest(function(func, args) {
            return baseDelay(func, 1, args);
        });
        /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */ var delay = baseRest(function(func, wait, args) {
            return baseDelay(func, toNumber(wait) || 0, args);
        });
        /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */ function flip(func) {
            return createWrap(func, WRAP_FLIP_FLAG);
        }
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */ function memoize(func, resolver) {
            if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var result = func.apply(this, args);
                memoized.cache = cache.set(key, result) || cache;
                return result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Expose `MapCache`.
        memoize.Cache = MapCache;
        /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */ function negate(predicate) {
            if (typeof predicate != "function") throw new TypeError(FUNC_ERROR_TEXT);
            return function() {
                var args = arguments;
                switch(args.length){
                    case 0:
                        return !predicate.call(this);
                    case 1:
                        return !predicate.call(this, args[0]);
                    case 2:
                        return !predicate.call(this, args[0], args[1]);
                    case 3:
                        return !predicate.call(this, args[0], args[1], args[2]);
                }
                return !predicate.apply(this, args);
            };
        }
        /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */ function once(func) {
            return before(2, func);
        }
        /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */ var overArgs = castRest(function(func, transforms) {
            transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
            var funcsLength = transforms.length;
            return baseRest(function(args) {
                var index = -1, length = nativeMin(args.length, funcsLength);
                while(++index < length)args[index] = transforms[index].call(this, args[index]);
                return apply(func, this, args);
            });
        });
        /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */ var partial = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partial));
            return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
        });
        /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */ var partialRight = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partialRight));
            return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
        });
        /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */ var rearg = flatRest(function(func, indexes) {
            return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
        });
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */ function rest(func, start) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            start = start === undefined ? start : toInteger(start);
            return baseRest(func, start);
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */ function spread(func, start) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            start = start == null ? 0 : nativeMax(toInteger(start), 0);
            return baseRest(function(args) {
                var array = args[start], otherArgs = castSlice(args, 0, start);
                if (array) arrayPush(otherArgs, array);
                return apply(func, this, otherArgs);
            });
        }
        /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            if (isObject(options)) {
                leading = "leading" in options ? !!options.leading : leading;
                trailing = "trailing" in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
                "leading": leading,
                "maxWait": wait,
                "trailing": trailing
            });
        }
        /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */ function unary(func) {
            return ary(func, 1);
        }
        /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */ function wrap(value, wrapper) {
            return partial(castFunction(wrapper), value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */ function castArray() {
            if (!arguments.length) return [];
            var value = arguments[0];
            return isArray(value) ? value : [
                value
            ];
        }
        /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */ function clone(value) {
            return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */ function cloneWith(value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */ function cloneDeep(value) {
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */ function cloneDeepWith(value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */ function conformsTo(object, source) {
            return source == null || baseConformsTo(object, source, keys(source));
        }
        /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */ function eq(value, other) {
            return value === other || value !== value && other !== other;
        }
        /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */ var gt = createRelationalOperation(baseGt);
        /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */ var gte = createRelationalOperation(function(value, other) {
            return value >= other;
        });
        /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ var isArguments = baseIsArguments(function() {
            return arguments;
        }()) ? baseIsArguments : function(value) {
            return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
        };
        /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */ var isArray = Array1.isArray;
        /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */ var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */ function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        }
        /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */ var isBuffer = nativeIsBuffer || stubFalse;
        /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */ var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */ function isElement(value) {
            return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */ function isEmpty(value) {
            if (value == null) return true;
            if (isArrayLike(value) && (isArray(value) || typeof value == "string" || typeof value.splice == "function" || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) return !value.size;
            if (isPrototype(value)) return !baseKeys(value).length;
            for(var key in value){
                if (hasOwnProperty.call(value, key)) return false;
            }
            return true;
        }
        /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */ function isEqual(value, other) {
            return baseIsEqual(value, other);
        }
        /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */ function isEqualWith(value, other, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            var result = customizer ? customizer(value, other) : undefined;
            return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
        }
        /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */ function isError(value) {
            if (!isObjectLike(value)) return false;
            var tag = baseGetTag(value);
            return tag == errorTag || tag == domExcTag || typeof value.message == "string" && typeof value.name == "string" && !isPlainObject(value);
        }
        /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */ function isFinite(value) {
            return typeof value == "number" && nativeIsFinite(value);
        }
        /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */ function isFunction(value) {
            if (!isObject(value)) return false;
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 9 which returns 'object' for typed arrays and other constructors.
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */ function isInteger(value) {
            return typeof value == "number" && value == toInteger(value);
        }
        /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */ function isLength(value) {
            return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */ function isObject(value) {
            var type = typeof value;
            return value != null && (type == "object" || type == "function");
        }
        /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */ function isObjectLike(value) {
            return value != null && typeof value == "object";
        }
        /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */ function isMatch(object, source) {
            return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */ function isMatchWith(object, source, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // An `NaN` primitive is the only value that is not equal to itself.
            // Perform the `toStringTag` check first to avoid errors with some
            // ActiveX objects in IE.
            return isNumber(value) && value != +value;
        }
        /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */ function isNative(value) {
            if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
            return baseIsNative(value);
        }
        /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */ function isNull(value) {
            return value === null;
        }
        /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */ function isNil(value) {
            return value == null;
        }
        /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */ function isNumber(value) {
            return typeof value == "number" || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */ function isPlainObject(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
            var proto = getPrototype(value);
            if (proto === null) return true;
            var Ctor = hasOwnProperty.call(proto, "constructor") && proto.constructor;
            return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */ var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */ function isSafeInteger(value) {
            return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */ function isString(value) {
            return typeof value == "string" || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */ function isSymbol(value) {
            return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */ function isUndefined(value) {
            return value === undefined;
        }
        /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */ function isWeakMap(value) {
            return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */ function isWeakSet(value) {
            return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */ var lt = createRelationalOperation(baseLt);
        /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */ var lte = createRelationalOperation(function(value, other) {
            return value <= other;
        });
        /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */ function toArray(value) {
            if (!value) return [];
            if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
            if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
            var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
            return func(value);
        }
        /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */ function toFinite(value) {
            if (!value) return value === 0 ? value : 0;
            value = toNumber(value);
            if (value === INFINITY || value === -INFINITY) {
                var sign = value < 0 ? -1 : 1;
                return sign * MAX_INTEGER;
            }
            return value === value ? value : 0;
        }
        /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */ function toInteger(value) {
            var result = toFinite(value), remainder = result % 1;
            return result === result ? remainder ? result - remainder : result : 0;
        }
        /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */ function toLength(value) {
            return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */ function toNumber(value) {
            if (typeof value == "number") return value;
            if (isSymbol(value)) return NAN;
            if (isObject(value)) {
                var other = typeof value.valueOf == "function" ? value.valueOf() : value;
                value = isObject(other) ? other + "" : other;
            }
            if (typeof value != "string") return value === 0 ? value : +value;
            value = baseTrim(value);
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */ function toPlainObject(value) {
            return copyObject(value, keysIn(value));
        }
        /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */ function toSafeInteger(value) {
            return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */ function toString(value) {
            return value == null ? "" : baseToString(value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */ var assign = createAssigner(function(object, source) {
            if (isPrototype(source) || isArrayLike(source)) {
                copyObject(source, keys(source), object);
                return;
            }
            for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
        });
        /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */ var assignIn = createAssigner(function(object, source) {
            copyObject(source, keysIn(source), object);
        });
        /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keysIn(source), object, customizer);
        });
        /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keys(source), object, customizer);
        });
        /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */ var at = flatRest(baseAt);
        /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties) {
            var result = baseCreate(prototype);
            return properties == null ? result : baseAssign(result, properties);
        }
        /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var defaults = baseRest(function(object, sources) {
            object = Object1(object);
            var index = -1;
            var length = sources.length;
            var guard = length > 2 ? sources[2] : undefined;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
            while(++index < length){
                var source = sources[index];
                var props = keysIn(source);
                var propsIndex = -1;
                var propsLength = props.length;
                while(++propsIndex < propsLength){
                    var key = props[propsIndex];
                    var value = object[key];
                    if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                }
            }
            return object;
        });
        /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */ var defaultsDeep = baseRest(function(args) {
            args.push(undefined, customDefaultsMerge);
            return apply(mergeWith, undefined, args);
        });
        /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */ function findKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */ function findLastKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */ function forIn(object, iteratee) {
            return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */ function forInRight(object, iteratee) {
            return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forOwn(object, iteratee) {
            return object && baseForOwn(object, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */ function forOwnRight(object, iteratee) {
            return object && baseForOwnRight(object, getIteratee(iteratee, 3));
        }
        /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */ function functions(object) {
            return object == null ? [] : baseFunctions(object, keys(object));
        }
        /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */ function functionsIn(object) {
            return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */ function get(object, path, defaultValue) {
            var result = object == null ? undefined : baseGet(object, path);
            return result === undefined ? defaultValue : result;
        }
        /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */ function has(object, path) {
            return object != null && hasPath(object, path, baseHas);
        }
        /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */ function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        }
        /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */ var invert = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != "function") value = nativeObjectToString.call(value);
            result[value] = key;
        }, constant(identity));
        /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */ var invertBy = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != "function") value = nativeObjectToString.call(value);
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }, getIteratee);
        /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */ var invoke = baseRest(baseInvoke);
        /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */ function keysIn(object) {
            return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */ function mapKeys(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, iteratee(value, key, object), value);
            });
            return result;
        }
        /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */ function mapValues(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, key, iteratee(value, key, object));
            });
            return result;
        }
        /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */ var merge = createAssigner(function(object, source, srcIndex) {
            baseMerge(object, source, srcIndex);
        });
        /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
            baseMerge(object, source, srcIndex, customizer);
        });
        /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */ var omit = flatRest(function(object, paths) {
            var result = {};
            if (object == null) return result;
            var isDeep = false;
            paths = arrayMap(paths, function(path) {
                path = castPath(path, object);
                isDeep || (isDeep = path.length > 1);
                return path;
            });
            copyObject(object, getAllKeysIn(object), result);
            if (isDeep) result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
            var length = paths.length;
            while(length--)baseUnset(result, paths[length]);
            return result;
        });
        /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */ function omitBy(object, predicate) {
            return pickBy(object, negate(getIteratee(predicate)));
        }
        /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */ var pick = flatRest(function(object, paths) {
            return object == null ? {} : basePick(object, paths);
        });
        /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */ function pickBy(object, predicate) {
            if (object == null) return {};
            var props = arrayMap(getAllKeysIn(object), function(prop) {
                return [
                    prop
                ];
            });
            predicate = getIteratee(predicate);
            return basePickBy(object, props, function(value, path) {
                return predicate(value, path[0]);
            });
        }
        /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */ function result(object, path, defaultValue) {
            path = castPath(path, object);
            var index = -1, length = path.length;
            // Ensure the loop is entered when path is empty.
            if (!length) {
                length = 1;
                object = undefined;
            }
            while(++index < length){
                var value = object == null ? undefined : object[toKey(path[index])];
                if (value === undefined) {
                    index = length;
                    value = defaultValue;
                }
                object = isFunction(value) ? value.call(object) : value;
            }
            return object;
        }
        /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */ function set(object, path, value) {
            return object == null ? object : baseSet(object, path, value);
        }
        /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */ function setWith(object, path, value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return object == null ? object : baseSet(object, path, value, customizer);
        }
        /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */ var toPairs = createToPairs(keys);
        /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */ var toPairsIn = createToPairs(keysIn);
        /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */ function transform(object, iteratee, accumulator) {
            var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
            iteratee = getIteratee(iteratee, 4);
            if (accumulator == null) {
                var Ctor = object && object.constructor;
                if (isArrLike) accumulator = isArr ? new Ctor : [];
                else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                else accumulator = {};
            }
            (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */ function unset(object, path) {
            return object == null ? true : baseUnset(object, path);
        }
        /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */ function update(object, path, updater) {
            return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */ function updateWith(object, path, updater, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */ function values(object) {
            return object == null ? [] : baseValues(object, keys(object));
        }
        /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */ function valuesIn(object) {
            return object == null ? [] : baseValues(object, keysIn(object));
        }
        /*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */ function clamp(number, lower, upper) {
            if (upper === undefined) {
                upper = lower;
                lower = undefined;
            }
            if (upper !== undefined) {
                upper = toNumber(upper);
                upper = upper === upper ? upper : 0;
            }
            if (lower !== undefined) {
                lower = toNumber(lower);
                lower = lower === lower ? lower : 0;
            }
            return baseClamp(toNumber(number), lower, upper);
        }
        /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */ function inRange(number, start, end) {
            start = toFinite(start);
            if (end === undefined) {
                end = start;
                start = 0;
            } else end = toFinite(end);
            number = toNumber(number);
            return baseInRange(number, start, end);
        }
        /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(lower, upper, floating) {
            if (floating && typeof floating != "boolean" && isIterateeCall(lower, upper, floating)) upper = floating = undefined;
            if (floating === undefined) {
                if (typeof upper == "boolean") {
                    floating = upper;
                    upper = undefined;
                } else if (typeof lower == "boolean") {
                    floating = lower;
                    lower = undefined;
                }
            }
            if (lower === undefined && upper === undefined) {
                lower = 0;
                upper = 1;
            } else {
                lower = toFinite(lower);
                if (upper === undefined) {
                    upper = lower;
                    lower = 0;
                } else upper = toFinite(upper);
            }
            if (lower > upper) {
                var temp = lower;
                lower = upper;
                upper = temp;
            }
            if (floating || lower % 1 || upper % 1) {
                var rand = nativeRandom();
                return nativeMin(lower + rand * (upper - lower + freeParseFloat("1e-" + ((rand + "").length - 1))), upper);
            }
            return baseRandom(lower, upper);
        }
        /*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */ var camelCase = createCompounder(function(result, word, index) {
            word = word.toLowerCase();
            return result + (index ? capitalize(word) : word);
        });
        /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */ function capitalize(string) {
            return upperFirst(toString(string).toLowerCase());
        }
        /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */ function deburr(string) {
            string = toString(string);
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, "");
        }
        /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */ function endsWith(string, target, position) {
            string = toString(string);
            target = baseToString(target);
            var length = string.length;
            position = position === undefined ? length : baseClamp(toInteger(position), 0, length);
            var end = position;
            position -= target.length;
            return position >= 0 && string.slice(position, end) == target;
        }
        /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */ function escape(string) {
            string = toString(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */ function escapeRegExp(string) {
            string = toString(string);
            return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, "\\$&") : string;
        }
        /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */ var kebabCase = createCompounder(function(result, word, index) {
            return result + (index ? "-" : "") + word.toLowerCase();
        });
        /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */ var lowerCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + word.toLowerCase();
        });
        /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */ var lowerFirst = createCaseFirst("toLowerCase");
        /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */ function pad(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            if (!length || strLength >= length) return string;
            var mid = (length - strLength) / 2;
            return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */ function padEnd(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */ function padStart(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */ function parseInt1(string, radix, guard) {
            if (guard || radix == null) radix = 0;
            else if (radix) radix = +radix;
            return nativeParseInt(toString(string).replace(reTrimStart, ""), radix || 0);
        }
        /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */ function repeat(string, n, guard) {
            if (guard ? isIterateeCall(string, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            return baseRepeat(toString(string), n);
        }
        /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */ function replace() {
            var args = arguments, string = toString(args[0]);
            return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */ var snakeCase = createCompounder(function(result, word, index) {
            return result + (index ? "_" : "") + word.toLowerCase();
        });
        /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */ function split(string, separator, limit) {
            if (limit && typeof limit != "number" && isIterateeCall(string, separator, limit)) separator = limit = undefined;
            limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
            if (!limit) return [];
            string = toString(string);
            if (string && (typeof separator == "string" || separator != null && !isRegExp(separator))) {
                separator = baseToString(separator);
                if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
            }
            return string.split(separator, limit);
        }
        /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */ var startCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + upperFirst(word);
        });
        /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */ function startsWith(string, target, position) {
            string = toString(string);
            position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
            target = baseToString(target);
            return string.slice(position, position + target.length) == target;
        }
        /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(string, options, guard) {
            // Based on John Resig's `tmpl` implementation
            // (http://ejohn.org/blog/javascript-micro-templating/)
            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
            var settings = lodash.templateSettings;
            if (guard && isIterateeCall(string, options, guard)) options = undefined;
            string = toString(string);
            options = assignInWith({}, options, settings, customDefaultsAssignIn);
            var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // Compile the regexp to match each delimiter.
            var reDelimiters = RegExp1((options.escape || reNoMatch).source + "|" + interpolate.source + "|" + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + "|" + (options.evaluate || reNoMatch).source + "|$", "g");
            // Use a sourceURL for easier debugging.
            // The sourceURL gets injected into the source that's eval-ed, so be careful
            // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
            // and escape the comment, thus injecting code that gets evaled.
            var sourceURL = "//# sourceURL=" + (hasOwnProperty.call(options, "sourceURL") ? (options.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++templateCounter + "]") + "\n";
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // Escape characters that can't be included in string literals.
                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // Replace delimiters with snippets.
                if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                }
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // The JS engine embedded in Adobe products needs `match` returned in
                // order to produce the correct `offset` value.
                return match;
            });
            source += "';\n";
            // If `variable` is not specified wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain.
            var variable = hasOwnProperty.call(options, "variable") && options.variable;
            if (!variable) source = "with (obj) {\n" + source + "\n}\n";
            else if (reForbiddenIdentifierChars.test(variable)) throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
            // Cleanup code by stripping empty strings.
            source = (isEvaluating ? source.replace(reEmptyStringLeading, "") : source).replace(reEmptyStringMiddle, "$1").replace(reEmptyStringTrailing, "$1;");
            // Frame code as the function body.
            source = "function(" + (variable || "obj") + ") {\n" + (variable ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (isEscaping ? ", __e = _.escape" : "") + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + source + "return __p\n}";
            var result = attempt(function() {
                return Function1(importsKeys, sourceURL + "return " + source).apply(undefined, importsValues);
            });
            // Provide the compiled function's source by its `toString` method or
            // the `source` property as a convenience for inlining compiled templates.
            result.source = source;
            if (isError(result)) throw result;
            return result;
        }
        /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */ function toLower(value) {
            return toString(value).toLowerCase();
        }
        /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */ function toUpper(value) {
            return toString(value).toUpperCase();
        }
        /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */ function trim(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return baseTrim(string);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
            return castSlice(strSymbols, start, end).join("");
        }
        /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */ function trimEnd(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.slice(0, trimmedEndIndex(string) + 1);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
            return castSlice(strSymbols, 0, end).join("");
        }
        /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */ function trimStart(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.replace(reTrimStart, "");
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
            return castSlice(strSymbols, start).join("");
        }
        /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */ function truncate(string, options) {
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (isObject(options)) {
                var separator = "separator" in options ? options.separator : separator;
                length = "length" in options ? toInteger(options.length) : length;
                omission = "omission" in options ? baseToString(options.omission) : omission;
            }
            string = toString(string);
            var strLength = string.length;
            if (hasUnicode(string)) {
                var strSymbols = stringToArray(string);
                strLength = strSymbols.length;
            }
            if (length >= strLength) return string;
            var end = length - stringSize(omission);
            if (end < 1) return omission;
            var result = strSymbols ? castSlice(strSymbols, 0, end).join("") : string.slice(0, end);
            if (separator === undefined) return result + omission;
            if (strSymbols) end += result.length - end;
            if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                    var match, substring = result;
                    if (!separator.global) separator = RegExp1(separator.source, toString(reFlags.exec(separator)) + "g");
                    separator.lastIndex = 0;
                    while(match = separator.exec(substring))var newEnd = match.index;
                    result = result.slice(0, newEnd === undefined ? end : newEnd);
                }
            } else if (string.indexOf(baseToString(separator), end) != end) {
                var index = result.lastIndexOf(separator);
                if (index > -1) result = result.slice(0, index);
            }
            return result + omission;
        }
        /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */ function unescape(string) {
            string = toString(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */ var upperCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + word.toUpperCase();
        });
        /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */ var upperFirst = createCaseFirst("toUpperCase");
        /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */ function words(string, pattern, guard) {
            string = toString(string);
            pattern = guard ? undefined : pattern;
            if (pattern === undefined) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
            return string.match(pattern) || [];
        }
        /*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */ var attempt = baseRest(function(func, args) {
            try {
                return apply(func, undefined, args);
            } catch (e) {
                return isError(e) ? e : new Error(e);
            }
        });
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */ var bindAll = flatRest(function(object, methodNames) {
            arrayEach(methodNames, function(key) {
                key = toKey(key);
                baseAssignValue(object, key, bind(object[key], object));
            });
            return object;
        });
        /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */ function cond(pairs) {
            var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
            pairs = !length ? [] : arrayMap(pairs, function(pair) {
                if (typeof pair[1] != "function") throw new TypeError(FUNC_ERROR_TEXT);
                return [
                    toIteratee(pair[0]),
                    pair[1]
                ];
            });
            return baseRest(function(args) {
                var index = -1;
                while(++index < length){
                    var pair = pairs[index];
                    if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                }
            });
        }
        /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */ function conforms(source) {
            return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        }
        /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */ function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
        }
        /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */ var flow = createFlow();
        /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */ var flowRight = createFlow(true);
        /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */ function identity(value) {
            return value;
        }
        /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */ function iteratee(func) {
            return baseIteratee(typeof func == "function" ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matches(source) {
            return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */ var method = baseRest(function(path, args) {
            return function(object) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */ var methodOf = baseRest(function(object, args) {
            return function(path) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */ function mixin(object, source, options) {
            var props = keys(source), methodNames = baseFunctions(source, props);
            if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                options = source;
                source = object;
                object = this;
                methodNames = baseFunctions(source, keys(source));
            }
            var chain = !(isObject(options) && "chain" in options) || !!options.chain, isFunc = isFunction(object);
            arrayEach(methodNames, function(methodName) {
                var func = source[methodName];
                object[methodName] = func;
                if (isFunc) object.prototype[methodName] = function() {
                    var chainAll = this.__chain__;
                    if (chain || chainAll) {
                        var result = object(this.__wrapped__), actions = result.__actions__ = copyArray(this.__actions__);
                        actions.push({
                            "func": func,
                            "args": arguments,
                            "thisArg": object
                        });
                        result.__chain__ = chainAll;
                        return result;
                    }
                    return func.apply(object, arrayPush([
                        this.value()
                    ], arguments));
                };
            });
            return object;
        }
        /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            if (root._ === this) root._ = oldDash;
            return this;
        }
        /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */ function noop() {
        // No operation performed.
        }
        /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */ function nthArg(n) {
            n = toInteger(n);
            return baseRest(function(args) {
                return baseNth(args, n);
            });
        }
        /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */ var over = createOver(arrayMap);
        /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */ var overEvery = createOver(arrayEvery);
        /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */ var overSome = createOver(arraySome);
        /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */ function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */ function propertyOf(object) {
            return function(path) {
                return object == null ? undefined : baseGet(object, path);
            };
        }
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ var range = createRange();
        /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */ var rangeRight = createRange(true);
        /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */ function stubArray() {
            return [];
        }
        /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */ function stubFalse() {
            return false;
        }
        /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */ function stubObject() {
            return {};
        }
        /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */ function stubString() {
            return "";
        }
        /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */ function stubTrue() {
            return true;
        }
        /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */ function times(n, iteratee) {
            n = toInteger(n);
            if (n < 1 || n > MAX_SAFE_INTEGER) return [];
            var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
            iteratee = getIteratee(iteratee);
            n -= MAX_ARRAY_LENGTH;
            var result = baseTimes(length, iteratee);
            while(++index < n)iteratee(index);
            return result;
        }
        /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */ function toPath(value) {
            if (isArray(value)) return arrayMap(value, toKey);
            return isSymbol(value) ? [
                value
            ] : copyArray(stringToPath(toString(value)));
        }
        /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return toString(prefix) + id;
        }
        /*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */ var add = createMathOperation(function(augend, addend) {
            return augend + addend;
        }, 0);
        /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */ var ceil = createRound("ceil");
        /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */ var divide = createMathOperation(function(dividend, divisor) {
            return dividend / divisor;
        }, 1);
        /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */ var floor = createRound("floor");
        /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */ function max(array) {
            return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
        }
        /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */ function maxBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined;
        }
        /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */ function mean(array) {
            return baseMean(array, identity);
        }
        /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */ function meanBy(array, iteratee) {
            return baseMean(array, getIteratee(iteratee, 2));
        }
        /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */ function min(array) {
            return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
        }
        /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */ function minBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined;
        }
        /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */ var multiply = createMathOperation(function(multiplier, multiplicand) {
            return multiplier * multiplicand;
        }, 1);
        /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */ var round = createRound("round");
        /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */ var subtract = createMathOperation(function(minuend, subtrahend) {
            return minuend - subtrahend;
        }, 0);
        /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */ function sum(array) {
            return array && array.length ? baseSum(array, identity) : 0;
        }
        /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */ function sumBy(array, iteratee) {
            return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
        }
        /*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        // Add aliases.
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        // Add methods to `lodash.prototype`.
        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt1;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        // Add aliases.
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
                if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
            });
            return source;
        }(), {
            "chain": false
        });
        /*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */ lodash.VERSION = VERSION;
        // Assign default placeholders.
        arrayEach([
            "bind",
            "bindKey",
            "curry",
            "curryRight",
            "partial",
            "partialRight"
        ], function(methodName) {
            lodash[methodName].placeholder = lodash;
        });
        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach([
            "drop",
            "take"
        ], function(methodName, index) {
            LazyWrapper.prototype[methodName] = function(n) {
                n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
                var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                if (result.__filtered__) result.__takeCount__ = nativeMin(n, result.__takeCount__);
                else result.__views__.push({
                    "size": nativeMin(n, MAX_ARRAY_LENGTH),
                    "type": methodName + (result.__dir__ < 0 ? "Right" : "")
                });
                return result;
            };
            LazyWrapper.prototype[methodName + "Right"] = function(n) {
                return this.reverse()[methodName](n).reverse();
            };
        });
        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach([
            "filter",
            "map",
            "takeWhile"
        ], function(methodName, index) {
            var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee) {
                var result = this.clone();
                result.__iteratees__.push({
                    "iteratee": getIteratee(iteratee, 3),
                    "type": type
                });
                result.__filtered__ = result.__filtered__ || isFilter;
                return result;
            };
        });
        // Add `LazyWrapper` methods for `_.head` and `_.last`.
        arrayEach([
            "head",
            "last"
        ], function(methodName, index) {
            var takeName = "take" + (index ? "Right" : "");
            LazyWrapper.prototype[methodName] = function() {
                return this[takeName](1).value()[0];
            };
        });
        // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
        arrayEach([
            "initial",
            "tail"
        ], function(methodName, index) {
            var dropName = "drop" + (index ? "" : "Right");
            LazyWrapper.prototype[methodName] = function() {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
        });
        LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
            return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
            return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
            if (typeof path == "function") return new LazyWrapper(this);
            return this.map(function(value) {
                return baseInvoke(value, path, args);
            });
        });
        LazyWrapper.prototype.reject = function(predicate) {
            return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
            start = toInteger(start);
            var result = this;
            if (result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(result);
            if (start < 0) result = result.takeRight(-start);
            else if (start) result = result.drop(start);
            if (end !== undefined) {
                end = toInteger(end);
                result = end < 0 ? result.dropRight(-end) : result.take(end - start);
            }
            return result;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
            return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
            return this.take(MAX_ARRAY_LENGTH);
        };
        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? "take" + (methodName == "last" ? "Right" : "") : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
            if (!lodashFunc) return;
            lodash.prototype[methodName] = function() {
                var value = this.__wrapped__, args = isTaker ? [
                    1
                ] : arguments, isLazy = value instanceof LazyWrapper, iteratee = args[0], useLazy = isLazy || isArray(value);
                var interceptor = function(value) {
                    var result = lodashFunc.apply(lodash, arrayPush([
                        value
                    ], args));
                    return isTaker && chainAll ? result[0] : result;
                };
                if (useLazy && checkIteratee && typeof iteratee == "function" && iteratee.length != 1) // Avoid lazy use if the iteratee has a "length" value other than `1`.
                isLazy = useLazy = false;
                var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var result = func.apply(value, args);
                    result.__actions__.push({
                        "func": thru,
                        "args": [
                            interceptor
                        ],
                        "thisArg": undefined
                    });
                    return new LodashWrapper(result, chainAll);
                }
                if (isUnwrapped && onlyLazy) return func.apply(this, args);
                result = this.thru(interceptor);
                return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
            };
        });
        // Add `Array` methods to `lodash.prototype`.
        arrayEach([
            "pop",
            "push",
            "shift",
            "sort",
            "splice",
            "unshift"
        ], function(methodName) {
            var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? "tap" : "thru", retUnwrapped = /^(?:pop|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) {
                    var value = this.value();
                    return func.apply(isArray(value) ? value : [], args);
                }
                return this[chainName](function(value) {
                    return func.apply(isArray(value) ? value : [], args);
                });
            };
        });
        // Map minified method names to their real names.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
                var key = lodashFunc.name + "";
                if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                realNames[key].push({
                    "name": methodName,
                    "func": lodashFunc
                });
            }
        });
        realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [
            {
                "name": "wrapper",
                "func": undefined
            }
        ];
        // Add methods to `LazyWrapper`.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        // Add chain sequence methods to the `lodash` wrapper.
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        // Add lazy aliases.
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
        return lodash;
    };
    /*--------------------------------------------------------------------------*/ // Export lodash.
    var _ = runInContext();
    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (typeof define == "function" && typeof define.amd == "object" && define.amd) {
        // Expose Lodash on the global object to prevent errors when Lodash is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        // Use `_.noConflict` to remove Lodash from the global object.
        root._ = _;
        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        define(function() {
            return _;
        });
    } else if (freeModule) {
        // Export for Node.js.
        (freeModule.exports = _)._ = _;
        // Export for CommonJS support.
        freeExports._ = _;
    } else // Export to the global object.
    root._ = _;
}).call(this);

});

parcelRegister("fuTml", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $b48499974d50e8d0$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
class $b48499974d50e8d0$var$Position {
    constructor(line, col, index){
        this.line = void 0;
        this.column = void 0;
        this.index = void 0;
        this.line = line;
        this.column = col;
        this.index = index;
    }
}
class $b48499974d50e8d0$var$SourceLocation {
    constructor(start, end){
        this.start = void 0;
        this.end = void 0;
        this.filename = void 0;
        this.identifierName = void 0;
        this.start = start;
        this.end = end;
    }
}
function $b48499974d50e8d0$var$createPositionWithColumnOffset(position, columnOffset) {
    const { line: line, column: column, index: index } = position;
    return new $b48499974d50e8d0$var$Position(line, column + columnOffset, index + columnOffset);
}
const $b48499974d50e8d0$var$code = "BABEL_PARSER_SOURCETYPE_MODULE_REQUIRED";
var $b48499974d50e8d0$var$ModuleErrors = {
    ImportMetaOutsideModule: {
        message: `import.meta may appear only with 'sourceType: "module"'`,
        code: $b48499974d50e8d0$var$code
    },
    ImportOutsideModule: {
        message: `'import' and 'export' may appear only with 'sourceType: "module"'`,
        code: $b48499974d50e8d0$var$code
    }
};
const $b48499974d50e8d0$var$NodeDescriptions = {
    ArrayPattern: "array destructuring pattern",
    AssignmentExpression: "assignment expression",
    AssignmentPattern: "assignment expression",
    ArrowFunctionExpression: "arrow function expression",
    ConditionalExpression: "conditional expression",
    CatchClause: "catch clause",
    ForOfStatement: "for-of statement",
    ForInStatement: "for-in statement",
    ForStatement: "for-loop",
    FormalParameters: "function parameter list",
    Identifier: "identifier",
    ImportSpecifier: "import specifier",
    ImportDefaultSpecifier: "import default specifier",
    ImportNamespaceSpecifier: "import namespace specifier",
    ObjectPattern: "object destructuring pattern",
    ParenthesizedExpression: "parenthesized expression",
    RestElement: "rest element",
    UpdateExpression: {
        true: "prefix operation",
        false: "postfix operation"
    },
    VariableDeclarator: "variable declaration",
    YieldExpression: "yield expression"
};
const $b48499974d50e8d0$var$toNodeDescription = ({ type: type, prefix: prefix })=>type === "UpdateExpression" ? $b48499974d50e8d0$var$NodeDescriptions.UpdateExpression[String(prefix)] : $b48499974d50e8d0$var$NodeDescriptions[type];
var $b48499974d50e8d0$var$StandardErrors = {
    AccessorIsGenerator: ({ kind: kind })=>`A ${kind}ter cannot be a generator.`,
    ArgumentsInClass: "'arguments' is only allowed in functions and class methods.",
    AsyncFunctionInSingleStatementContext: "Async functions can only be declared at the top level or inside a block.",
    AwaitBindingIdentifier: "Can not use 'await' as identifier inside an async function.",
    AwaitBindingIdentifierInStaticBlock: "Can not use 'await' as identifier inside a static block.",
    AwaitExpressionFormalParameter: "'await' is not allowed in async function parameters.",
    AwaitUsingNotInAsyncContext: "'await using' is only allowed within async functions and at the top levels of modules.",
    AwaitNotInAsyncContext: "'await' is only allowed within async functions and at the top levels of modules.",
    AwaitNotInAsyncFunction: "'await' is only allowed within async functions.",
    BadGetterArity: "A 'get' accessor must not have any formal parameters.",
    BadSetterArity: "A 'set' accessor must have exactly one formal parameter.",
    BadSetterRestParameter: "A 'set' accessor function argument must not be a rest parameter.",
    ConstructorClassField: "Classes may not have a field named 'constructor'.",
    ConstructorClassPrivateField: "Classes may not have a private field named '#constructor'.",
    ConstructorIsAccessor: "Class constructor may not be an accessor.",
    ConstructorIsAsync: "Constructor can't be an async function.",
    ConstructorIsGenerator: "Constructor can't be a generator.",
    DeclarationMissingInitializer: ({ kind: kind })=>`Missing initializer in ${kind} declaration.`,
    DecoratorArgumentsOutsideParentheses: "Decorator arguments must be moved inside parentheses: use '@(decorator(args))' instead of '@(decorator)(args)'.",
    DecoratorBeforeExport: "Decorators must be placed *before* the 'export' keyword. Remove the 'decoratorsBeforeExport: true' option to use the 'export @decorator class {}' syntax.",
    DecoratorsBeforeAfterExport: "Decorators can be placed *either* before or after the 'export' keyword, but not in both locations at the same time.",
    DecoratorConstructor: "Decorators can't be used with a constructor. Did you mean '@dec class { ... }'?",
    DecoratorExportClass: "Decorators must be placed *after* the 'export' keyword. Remove the 'decoratorsBeforeExport: false' option to use the '@decorator export class {}' syntax.",
    DecoratorSemicolon: "Decorators must not be followed by a semicolon.",
    DecoratorStaticBlock: "Decorators can't be used with a static block.",
    DeferImportRequiresNamespace: 'Only `import defer * as x from "./module"` is valid.',
    DeletePrivateField: "Deleting a private field is not allowed.",
    DestructureNamedImport: "ES2015 named imports do not destructure. Use another statement for destructuring after the import.",
    DuplicateConstructor: "Duplicate constructor in the same class.",
    DuplicateDefaultExport: "Only one default export allowed per module.",
    DuplicateExport: ({ exportName: exportName })=>`\`${exportName}\` has already been exported. Exported identifiers must be unique.`,
    DuplicateProto: "Redefinition of __proto__ property.",
    DuplicateRegExpFlags: "Duplicate regular expression flag.",
    DynamicImportPhaseRequiresImportExpressions: ({ phase: phase })=>`'import.${phase}(...)' can only be parsed when using the 'createImportExpressions' option.`,
    ElementAfterRest: "Rest element must be last element.",
    EscapedCharNotAnIdentifier: "Invalid Unicode escape.",
    ExportBindingIsString: ({ localName: localName, exportName: exportName })=>`A string literal cannot be used as an exported binding without \`from\`.\n- Did you mean \`export { '${localName}' as '${exportName}' } from 'some-module'\`?`,
    ExportDefaultFromAsIdentifier: "'from' is not allowed as an identifier after 'export default'.",
    ForInOfLoopInitializer: ({ type: type })=>`'${type === "ForInStatement" ? "for-in" : "for-of"}' loop variable declaration may not have an initializer.`,
    ForInUsing: "For-in loop may not start with 'using' declaration.",
    ForOfAsync: "The left-hand side of a for-of loop may not be 'async'.",
    ForOfLet: "The left-hand side of a for-of loop may not start with 'let'.",
    GeneratorInSingleStatementContext: "Generators can only be declared at the top level or inside a block.",
    IllegalBreakContinue: ({ type: type })=>`Unsyntactic ${type === "BreakStatement" ? "break" : "continue"}.`,
    IllegalLanguageModeDirective: "Illegal 'use strict' directive in function with non-simple parameter list.",
    IllegalReturn: "'return' outside of function.",
    ImportAttributesUseAssert: "The `assert` keyword in import attributes is deprecated and it has been replaced by the `with` keyword. You can enable the `deprecatedAssertSyntax: true` option in the import attributes plugin to suppress this error.",
    ImportBindingIsString: ({ importName: importName })=>`A string literal cannot be used as an imported binding.\n- Did you mean \`import { "${importName}" as foo }\`?`,
    ImportCallArgumentTrailingComma: "Trailing comma is disallowed inside import(...) arguments.",
    ImportCallArity: ({ maxArgumentCount: maxArgumentCount })=>`\`import()\` requires exactly ${maxArgumentCount === 1 ? "one argument" : "one or two arguments"}.`,
    ImportCallNotNewExpression: "Cannot use new with import(...).",
    ImportCallSpreadArgument: "`...` is not allowed in `import()`.",
    ImportJSONBindingNotDefault: "A JSON module can only be imported with `default`.",
    ImportReflectionHasAssertion: "`import module x` cannot have assertions.",
    ImportReflectionNotBinding: 'Only `import module x from "./module"` is valid.',
    IncompatibleRegExpUVFlags: "The 'u' and 'v' regular expression flags cannot be enabled at the same time.",
    InvalidBigIntLiteral: "Invalid BigIntLiteral.",
    InvalidCodePoint: "Code point out of bounds.",
    InvalidCoverInitializedName: "Invalid shorthand property initializer.",
    InvalidDecimal: "Invalid decimal.",
    InvalidDigit: ({ radix: radix })=>`Expected number in radix ${radix}.`,
    InvalidEscapeSequence: "Bad character escape sequence.",
    InvalidEscapeSequenceTemplate: "Invalid escape sequence in template.",
    InvalidEscapedReservedWord: ({ reservedWord: reservedWord })=>`Escape sequence in keyword ${reservedWord}.`,
    InvalidIdentifier: ({ identifierName: identifierName })=>`Invalid identifier ${identifierName}.`,
    InvalidLhs: ({ ancestor: ancestor })=>`Invalid left-hand side in ${$b48499974d50e8d0$var$toNodeDescription(ancestor)}.`,
    InvalidLhsBinding: ({ ancestor: ancestor })=>`Binding invalid left-hand side in ${$b48499974d50e8d0$var$toNodeDescription(ancestor)}.`,
    InvalidLhsOptionalChaining: ({ ancestor: ancestor })=>`Invalid optional chaining in the left-hand side of ${$b48499974d50e8d0$var$toNodeDescription(ancestor)}.`,
    InvalidNumber: "Invalid number.",
    InvalidOrMissingExponent: "Floating-point numbers require a valid exponent after the 'e'.",
    InvalidOrUnexpectedToken: ({ unexpected: unexpected })=>`Unexpected character '${unexpected}'.`,
    InvalidParenthesizedAssignment: "Invalid parenthesized assignment pattern.",
    InvalidPrivateFieldResolution: ({ identifierName: identifierName })=>`Private name #${identifierName} is not defined.`,
    InvalidPropertyBindingPattern: "Binding member expression.",
    InvalidRecordProperty: "Only properties and spread elements are allowed in record definitions.",
    InvalidRestAssignmentPattern: "Invalid rest operator's argument.",
    LabelRedeclaration: ({ labelName: labelName })=>`Label '${labelName}' is already declared.`,
    LetInLexicalBinding: "'let' is disallowed as a lexically bound name.",
    LineTerminatorBeforeArrow: "No line break is allowed before '=>'.",
    MalformedRegExpFlags: "Invalid regular expression flag.",
    MissingClassName: "A class name is required.",
    MissingEqInAssignment: "Only '=' operator can be used for specifying default value.",
    MissingSemicolon: "Missing semicolon.",
    MissingPlugin: ({ missingPlugin: missingPlugin })=>`This experimental syntax requires enabling the parser plugin: ${missingPlugin.map((name)=>JSON.stringify(name)).join(", ")}.`,
    MissingOneOfPlugins: ({ missingPlugin: missingPlugin })=>`This experimental syntax requires enabling one of the following parser plugin(s): ${missingPlugin.map((name)=>JSON.stringify(name)).join(", ")}.`,
    MissingUnicodeEscape: "Expecting Unicode escape sequence \\uXXXX.",
    MixingCoalesceWithLogical: "Nullish coalescing operator(??) requires parens when mixing with logical operators.",
    ModuleAttributeDifferentFromType: "The only accepted module attribute is `type`.",
    ModuleAttributeInvalidValue: "Only string literals are allowed as module attribute values.",
    ModuleAttributesWithDuplicateKeys: ({ key: key })=>`Duplicate key "${key}" is not allowed in module attributes.`,
    ModuleExportNameHasLoneSurrogate: ({ surrogateCharCode: surrogateCharCode })=>`An export name cannot include a lone surrogate, found '\\u${surrogateCharCode.toString(16)}'.`,
    ModuleExportUndefined: ({ localName: localName })=>`Export '${localName}' is not defined.`,
    MultipleDefaultsInSwitch: "Multiple default clauses.",
    NewlineAfterThrow: "Illegal newline after throw.",
    NoCatchOrFinally: "Missing catch or finally clause.",
    NumberIdentifier: "Identifier directly after number.",
    NumericSeparatorInEscapeSequence: "Numeric separators are not allowed inside unicode escape sequences or hex escape sequences.",
    ObsoleteAwaitStar: "'await*' has been removed from the async functions proposal. Use Promise.all() instead.",
    OptionalChainingNoNew: "Constructors in/after an Optional Chain are not allowed.",
    OptionalChainingNoTemplate: "Tagged Template Literals are not allowed in optionalChain.",
    OverrideOnConstructor: "'override' modifier cannot appear on a constructor declaration.",
    ParamDupe: "Argument name clash.",
    PatternHasAccessor: "Object pattern can't contain getter or setter.",
    PatternHasMethod: "Object pattern can't contain methods.",
    PrivateInExpectedIn: ({ identifierName: identifierName })=>`Private names are only allowed in property accesses (\`obj.#${identifierName}\`) or in \`in\` expressions (\`#${identifierName} in obj\`).`,
    PrivateNameRedeclaration: ({ identifierName: identifierName })=>`Duplicate private name #${identifierName}.`,
    RecordExpressionBarIncorrectEndSyntaxType: "Record expressions ending with '|}' are only allowed when the 'syntaxType' option of the 'recordAndTuple' plugin is set to 'bar'.",
    RecordExpressionBarIncorrectStartSyntaxType: "Record expressions starting with '{|' are only allowed when the 'syntaxType' option of the 'recordAndTuple' plugin is set to 'bar'.",
    RecordExpressionHashIncorrectStartSyntaxType: "Record expressions starting with '#{' are only allowed when the 'syntaxType' option of the 'recordAndTuple' plugin is set to 'hash'.",
    RecordNoProto: "'__proto__' is not allowed in Record expressions.",
    RestTrailingComma: "Unexpected trailing comma after rest element.",
    SloppyFunction: "In non-strict mode code, functions can only be declared at top level or inside a block.",
    SloppyFunctionAnnexB: "In non-strict mode code, functions can only be declared at top level, inside a block, or as the body of an if statement.",
    SourcePhaseImportRequiresDefault: 'Only `import source x from "./module"` is valid.',
    StaticPrototype: "Classes may not have static property named prototype.",
    SuperNotAllowed: "`super()` is only valid inside a class constructor of a subclass. Maybe a typo in the method name ('constructor') or not extending another class?",
    SuperPrivateField: "Private fields can't be accessed on super.",
    TrailingDecorator: "Decorators must be attached to a class element.",
    TupleExpressionBarIncorrectEndSyntaxType: "Tuple expressions ending with '|]' are only allowed when the 'syntaxType' option of the 'recordAndTuple' plugin is set to 'bar'.",
    TupleExpressionBarIncorrectStartSyntaxType: "Tuple expressions starting with '[|' are only allowed when the 'syntaxType' option of the 'recordAndTuple' plugin is set to 'bar'.",
    TupleExpressionHashIncorrectStartSyntaxType: "Tuple expressions starting with '#[' are only allowed when the 'syntaxType' option of the 'recordAndTuple' plugin is set to 'hash'.",
    UnexpectedArgumentPlaceholder: "Unexpected argument placeholder.",
    UnexpectedAwaitAfterPipelineBody: 'Unexpected "await" after pipeline body; await must have parentheses in minimal proposal.',
    UnexpectedDigitAfterHash: "Unexpected digit after hash token.",
    UnexpectedImportExport: "'import' and 'export' may only appear at the top level.",
    UnexpectedKeyword: ({ keyword: keyword })=>`Unexpected keyword '${keyword}'.`,
    UnexpectedLeadingDecorator: "Leading decorators must be attached to a class declaration.",
    UnexpectedLexicalDeclaration: "Lexical declaration cannot appear in a single-statement context.",
    UnexpectedNewTarget: "`new.target` can only be used in functions or class properties.",
    UnexpectedNumericSeparator: "A numeric separator is only allowed between two digits.",
    UnexpectedPrivateField: "Unexpected private name.",
    UnexpectedReservedWord: ({ reservedWord: reservedWord })=>`Unexpected reserved word '${reservedWord}'.`,
    UnexpectedSuper: "'super' is only allowed in object methods and classes.",
    UnexpectedToken: ({ expected: expected, unexpected: unexpected })=>`Unexpected token${unexpected ? ` '${unexpected}'.` : ""}${expected ? `, expected "${expected}"` : ""}`,
    UnexpectedTokenUnaryExponentiation: "Illegal expression. Wrap left hand side or entire exponentiation in parentheses.",
    UnexpectedUsingDeclaration: "Using declaration cannot appear in the top level when source type is `script`.",
    UnsupportedBind: "Binding should be performed on object property.",
    UnsupportedDecoratorExport: "A decorated export must export a class declaration.",
    UnsupportedDefaultExport: "Only expressions, functions or classes are allowed as the `default` export.",
    UnsupportedImport: "`import` can only be used in `import()` or `import.meta`.",
    UnsupportedMetaProperty: ({ target: target, onlyValidPropertyName: onlyValidPropertyName })=>`The only valid meta property for ${target} is ${target}.${onlyValidPropertyName}.`,
    UnsupportedParameterDecorator: "Decorators cannot be used to decorate parameters.",
    UnsupportedPropertyDecorator: "Decorators cannot be used to decorate object literal properties.",
    UnsupportedSuper: "'super' can only be used with function calls (i.e. super()) or in property accesses (i.e. super.prop or super[prop]).",
    UnterminatedComment: "Unterminated comment.",
    UnterminatedRegExp: "Unterminated regular expression.",
    UnterminatedString: "Unterminated string constant.",
    UnterminatedTemplate: "Unterminated template.",
    UsingDeclarationHasBindingPattern: "Using declaration cannot have destructuring patterns.",
    VarRedeclaration: ({ identifierName: identifierName })=>`Identifier '${identifierName}' has already been declared.`,
    YieldBindingIdentifier: "Can not use 'yield' as identifier inside a generator.",
    YieldInParameter: "Yield expression is not allowed in formal parameters.",
    ZeroDigitNumericSeparator: "Numeric separator can not be used after leading 0."
};
var $b48499974d50e8d0$var$StrictModeErrors = {
    StrictDelete: "Deleting local variable in strict mode.",
    StrictEvalArguments: ({ referenceName: referenceName })=>`Assigning to '${referenceName}' in strict mode.`,
    StrictEvalArgumentsBinding: ({ bindingName: bindingName })=>`Binding '${bindingName}' in strict mode.`,
    StrictFunction: "In strict mode code, functions can only be declared at top level or inside a block.",
    StrictNumericEscape: "The only valid numeric escape in strict mode is '\\0'.",
    StrictOctalLiteral: "Legacy octal literals are not allowed in strict mode.",
    StrictWith: "'with' in strict mode."
};
const $b48499974d50e8d0$var$UnparenthesizedPipeBodyDescriptions = new Set([
    "ArrowFunctionExpression",
    "AssignmentExpression",
    "ConditionalExpression",
    "YieldExpression"
]);
var $b48499974d50e8d0$var$PipelineOperatorErrors = {
    PipeBodyIsTighter: "Unexpected yield after pipeline body; any yield expression acting as Hack-style pipe body must be parenthesized due to its loose operator precedence.",
    PipeTopicRequiresHackPipes: 'Topic reference is used, but the pipelineOperator plugin was not passed a "proposal": "hack" or "smart" option.',
    PipeTopicUnbound: "Topic reference is unbound; it must be inside a pipe body.",
    PipeTopicUnconfiguredToken: ({ token: token })=>`Invalid topic token ${token}. In order to use ${token} as a topic reference, the pipelineOperator plugin must be configured with { "proposal": "hack", "topicToken": "${token}" }.`,
    PipeTopicUnused: "Hack-style pipe body does not contain a topic reference; Hack-style pipes must use topic at least once.",
    PipeUnparenthesizedBody: ({ type: type })=>`Hack-style pipe body cannot be an unparenthesized ${$b48499974d50e8d0$var$toNodeDescription({
            type: type
        })}; please wrap it in parentheses.`,
    PipelineBodyNoArrow: 'Unexpected arrow "=>" after pipeline body; arrow function in pipeline body must be parenthesized.',
    PipelineBodySequenceExpression: "Pipeline body may not be a comma-separated sequence expression.",
    PipelineHeadSequenceExpression: "Pipeline head should not be a comma-separated sequence expression.",
    PipelineTopicUnused: "Pipeline is in topic style but does not use topic reference.",
    PrimaryTopicNotAllowed: "Topic reference was used in a lexical context without topic binding.",
    PrimaryTopicRequiresSmartPipeline: 'Topic reference is used, but the pipelineOperator plugin was not passed a "proposal": "hack" or "smart" option.'
};
const $b48499974d50e8d0$var$_excluded = [
    "toMessage"
], $b48499974d50e8d0$var$_excluded2 = [
    "message"
];
function $b48499974d50e8d0$var$defineHidden(obj, key, value) {
    Object.defineProperty(obj, key, {
        enumerable: false,
        configurable: true,
        value: value
    });
}
function $b48499974d50e8d0$var$toParseErrorConstructor(_ref) {
    let { toMessage: toMessage } = _ref, properties = $b48499974d50e8d0$var$_objectWithoutPropertiesLoose(_ref, $b48499974d50e8d0$var$_excluded);
    return function constructor(loc, details) {
        const error = new SyntaxError();
        Object.assign(error, properties, {
            loc: loc,
            pos: loc.index
        });
        if ("missingPlugin" in details) Object.assign(error, {
            missingPlugin: details.missingPlugin
        });
        $b48499974d50e8d0$var$defineHidden(error, "clone", function clone(overrides = {}) {
            var _overrides$loc;
            const { line: line, column: column, index: index } = (_overrides$loc = overrides.loc) != null ? _overrides$loc : loc;
            return constructor(new $b48499974d50e8d0$var$Position(line, column, index), Object.assign({}, details, overrides.details));
        });
        $b48499974d50e8d0$var$defineHidden(error, "details", details);
        Object.defineProperty(error, "message", {
            configurable: true,
            get () {
                const message = `${toMessage(details)} (${loc.line}:${loc.column})`;
                this.message = message;
                return message;
            },
            set (value) {
                Object.defineProperty(this, "message", {
                    value: value,
                    writable: true
                });
            }
        });
        return error;
    };
}
function $b48499974d50e8d0$var$ParseErrorEnum(argument, syntaxPlugin) {
    if (Array.isArray(argument)) return (parseErrorTemplates)=>$b48499974d50e8d0$var$ParseErrorEnum(parseErrorTemplates, argument[0]);
    const ParseErrorConstructors = {};
    for (const reasonCode of Object.keys(argument)){
        const template = argument[reasonCode];
        const _ref2 = typeof template === "string" ? {
            message: ()=>template
        } : typeof template === "function" ? {
            message: template
        } : template, { message: message } = _ref2, rest = $b48499974d50e8d0$var$_objectWithoutPropertiesLoose(_ref2, $b48499974d50e8d0$var$_excluded2);
        const toMessage = typeof message === "string" ? ()=>message : message;
        ParseErrorConstructors[reasonCode] = $b48499974d50e8d0$var$toParseErrorConstructor(Object.assign({
            code: "BABEL_PARSER_SYNTAX_ERROR",
            reasonCode: reasonCode,
            toMessage: toMessage
        }, syntaxPlugin ? {
            syntaxPlugin: syntaxPlugin
        } : {}, rest));
    }
    return ParseErrorConstructors;
}
const $b48499974d50e8d0$var$Errors = Object.assign({}, $b48499974d50e8d0$var$ParseErrorEnum($b48499974d50e8d0$var$ModuleErrors), $b48499974d50e8d0$var$ParseErrorEnum($b48499974d50e8d0$var$StandardErrors), $b48499974d50e8d0$var$ParseErrorEnum($b48499974d50e8d0$var$StrictModeErrors), $b48499974d50e8d0$var$ParseErrorEnum`pipelineOperator`($b48499974d50e8d0$var$PipelineOperatorErrors));
const { defineProperty: $b48499974d50e8d0$var$defineProperty } = Object;
const $b48499974d50e8d0$var$toUnenumerable = (object, key)=>$b48499974d50e8d0$var$defineProperty(object, key, {
        enumerable: false,
        value: object[key]
    });
function $b48499974d50e8d0$var$toESTreeLocation(node) {
    node.loc.start && $b48499974d50e8d0$var$toUnenumerable(node.loc.start, "index");
    node.loc.end && $b48499974d50e8d0$var$toUnenumerable(node.loc.end, "index");
    return node;
}
var $b48499974d50e8d0$var$estree = (superClass)=>class ESTreeParserMixin extends superClass {
        parse() {
            const file = $b48499974d50e8d0$var$toESTreeLocation(super.parse());
            if (this.options.tokens) file.tokens = file.tokens.map($b48499974d50e8d0$var$toESTreeLocation);
            return file;
        }
        parseRegExpLiteral({ pattern: pattern, flags: flags }) {
            let regex = null;
            try {
                regex = new RegExp(pattern, flags);
            } catch (e) {}
            const node = this.estreeParseLiteral(regex);
            node.regex = {
                pattern: pattern,
                flags: flags
            };
            return node;
        }
        parseBigIntLiteral(value) {
            let bigInt;
            try {
                bigInt = BigInt(value);
            } catch (_unused) {
                bigInt = null;
            }
            const node = this.estreeParseLiteral(bigInt);
            node.bigint = String(node.value || value);
            return node;
        }
        parseDecimalLiteral(value) {
            const decimal = null;
            const node = this.estreeParseLiteral(decimal);
            node.decimal = String(node.value || value);
            return node;
        }
        estreeParseLiteral(value) {
            return this.parseLiteral(value, "Literal");
        }
        parseStringLiteral(value) {
            return this.estreeParseLiteral(value);
        }
        parseNumericLiteral(value) {
            return this.estreeParseLiteral(value);
        }
        parseNullLiteral() {
            return this.estreeParseLiteral(null);
        }
        parseBooleanLiteral(value) {
            return this.estreeParseLiteral(value);
        }
        directiveToStmt(directive) {
            const expression = directive.value;
            delete directive.value;
            expression.type = "Literal";
            expression.raw = expression.extra.raw;
            expression.value = expression.extra.expressionValue;
            const stmt = directive;
            stmt.type = "ExpressionStatement";
            stmt.expression = expression;
            stmt.directive = expression.extra.rawValue;
            delete expression.extra;
            return stmt;
        }
        initFunction(node, isAsync) {
            super.initFunction(node, isAsync);
            node.expression = false;
        }
        checkDeclaration(node) {
            if (node != null && this.isObjectProperty(node)) this.checkDeclaration(node.value);
            else super.checkDeclaration(node);
        }
        getObjectOrClassMethodParams(method) {
            return method.value.params;
        }
        isValidDirective(stmt) {
            var _stmt$expression$extr;
            return stmt.type === "ExpressionStatement" && stmt.expression.type === "Literal" && typeof stmt.expression.value === "string" && !((_stmt$expression$extr = stmt.expression.extra) != null && _stmt$expression$extr.parenthesized);
        }
        parseBlockBody(node, allowDirectives, topLevel, end, afterBlockParse) {
            super.parseBlockBody(node, allowDirectives, topLevel, end, afterBlockParse);
            const directiveStatements = node.directives.map((d)=>this.directiveToStmt(d));
            node.body = directiveStatements.concat(node.body);
            delete node.directives;
        }
        pushClassMethod(classBody, method, isGenerator, isAsync, isConstructor, allowsDirectSuper) {
            this.parseMethod(method, isGenerator, isAsync, isConstructor, allowsDirectSuper, "ClassMethod", true);
            if (method.typeParameters) {
                method.value.typeParameters = method.typeParameters;
                delete method.typeParameters;
            }
            classBody.body.push(method);
        }
        parsePrivateName() {
            const node = super.parsePrivateName();
            if (!this.getPluginOption("estree", "classFeatures")) return node;
            return this.convertPrivateNameToPrivateIdentifier(node);
        }
        convertPrivateNameToPrivateIdentifier(node) {
            const name = super.getPrivateNameSV(node);
            node;
            delete node.id;
            node.name = name;
            node.type = "PrivateIdentifier";
            return node;
        }
        isPrivateName(node) {
            if (!this.getPluginOption("estree", "classFeatures")) return super.isPrivateName(node);
            return node.type === "PrivateIdentifier";
        }
        getPrivateNameSV(node) {
            if (!this.getPluginOption("estree", "classFeatures")) return super.getPrivateNameSV(node);
            return node.name;
        }
        parseLiteral(value, type) {
            const node = super.parseLiteral(value, type);
            node.raw = node.extra.raw;
            delete node.extra;
            return node;
        }
        parseFunctionBody(node, allowExpression, isMethod = false) {
            super.parseFunctionBody(node, allowExpression, isMethod);
            node.expression = node.body.type !== "BlockStatement";
        }
        parseMethod(node, isGenerator, isAsync, isConstructor, allowDirectSuper, type, inClassScope = false) {
            let funcNode = this.startNode();
            funcNode.kind = node.kind;
            funcNode = super.parseMethod(funcNode, isGenerator, isAsync, isConstructor, allowDirectSuper, type, inClassScope);
            funcNode.type = "FunctionExpression";
            delete funcNode.kind;
            node.value = funcNode;
            if (type === "ClassPrivateMethod") node.computed = false;
            return this.finishNode(node, "MethodDefinition");
        }
        parseClassProperty(...args) {
            const propertyNode = super.parseClassProperty(...args);
            if (!this.getPluginOption("estree", "classFeatures")) return propertyNode;
            propertyNode.type = "PropertyDefinition";
            return propertyNode;
        }
        parseClassPrivateProperty(...args) {
            const propertyNode = super.parseClassPrivateProperty(...args);
            if (!this.getPluginOption("estree", "classFeatures")) return propertyNode;
            propertyNode.type = "PropertyDefinition";
            propertyNode.computed = false;
            return propertyNode;
        }
        parseObjectMethod(prop, isGenerator, isAsync, isPattern, isAccessor) {
            const node = super.parseObjectMethod(prop, isGenerator, isAsync, isPattern, isAccessor);
            if (node) {
                node.type = "Property";
                if (node.kind === "method") node.kind = "init";
                node.shorthand = false;
            }
            return node;
        }
        parseObjectProperty(prop, startLoc, isPattern, refExpressionErrors) {
            const node = super.parseObjectProperty(prop, startLoc, isPattern, refExpressionErrors);
            if (node) {
                node.kind = "init";
                node.type = "Property";
            }
            return node;
        }
        isValidLVal(type, isUnparenthesizedInAssign, binding) {
            return type === "Property" ? "value" : super.isValidLVal(type, isUnparenthesizedInAssign, binding);
        }
        isAssignable(node, isBinding) {
            if (node != null && this.isObjectProperty(node)) return this.isAssignable(node.value, isBinding);
            return super.isAssignable(node, isBinding);
        }
        toAssignable(node, isLHS = false) {
            if (node != null && this.isObjectProperty(node)) {
                const { key: key, value: value } = node;
                if (this.isPrivateName(key)) this.classScope.usePrivateName(this.getPrivateNameSV(key), key.loc.start);
                this.toAssignable(value, isLHS);
            } else super.toAssignable(node, isLHS);
        }
        toAssignableObjectExpressionProp(prop, isLast, isLHS) {
            if (prop.kind === "get" || prop.kind === "set") this.raise($b48499974d50e8d0$var$Errors.PatternHasAccessor, prop.key);
            else if (prop.method) this.raise($b48499974d50e8d0$var$Errors.PatternHasMethod, prop.key);
            else super.toAssignableObjectExpressionProp(prop, isLast, isLHS);
        }
        finishCallExpression(unfinished, optional) {
            const node = super.finishCallExpression(unfinished, optional);
            if (node.callee.type === "Import") {
                node.type = "ImportExpression";
                node.source = node.arguments[0];
                if (this.hasPlugin("importAttributes") || this.hasPlugin("importAssertions")) {
                    var _node$arguments$, _node$arguments$2;
                    node.options = (_node$arguments$ = node.arguments[1]) != null ? _node$arguments$ : null;
                    node.attributes = (_node$arguments$2 = node.arguments[1]) != null ? _node$arguments$2 : null;
                }
                delete node.arguments;
                delete node.callee;
            }
            return node;
        }
        toReferencedArguments(node) {
            if (node.type === "ImportExpression") return;
            super.toReferencedArguments(node);
        }
        parseExport(unfinished, decorators) {
            const exportStartLoc = this.state.lastTokStartLoc;
            const node = super.parseExport(unfinished, decorators);
            switch(node.type){
                case "ExportAllDeclaration":
                    node.exported = null;
                    break;
                case "ExportNamedDeclaration":
                    if (node.specifiers.length === 1 && node.specifiers[0].type === "ExportNamespaceSpecifier") {
                        node.type = "ExportAllDeclaration";
                        node.exported = node.specifiers[0].exported;
                        delete node.specifiers;
                    }
                case "ExportDefaultDeclaration":
                    {
                        var _declaration$decorato;
                        const { declaration: declaration } = node;
                        if ((declaration == null ? void 0 : declaration.type) === "ClassDeclaration" && ((_declaration$decorato = declaration.decorators) == null ? void 0 : _declaration$decorato.length) > 0 && declaration.start === node.start) this.resetStartLocation(node, exportStartLoc);
                    }
                    break;
            }
            return node;
        }
        parseSubscript(base, startLoc, noCalls, state) {
            const node = super.parseSubscript(base, startLoc, noCalls, state);
            if (state.optionalChainMember) {
                if (node.type === "OptionalMemberExpression" || node.type === "OptionalCallExpression") node.type = node.type.substring(8);
                if (state.stop) {
                    const chain = this.startNodeAtNode(node);
                    chain.expression = node;
                    return this.finishNode(chain, "ChainExpression");
                }
            } else if (node.type === "MemberExpression" || node.type === "CallExpression") node.optional = false;
            return node;
        }
        isOptionalMemberExpression(node) {
            if (node.type === "ChainExpression") return node.expression.type === "MemberExpression";
            return super.isOptionalMemberExpression(node);
        }
        hasPropertyAsPrivateName(node) {
            if (node.type === "ChainExpression") node = node.expression;
            return super.hasPropertyAsPrivateName(node);
        }
        isObjectProperty(node) {
            return node.type === "Property" && node.kind === "init" && !node.method;
        }
        isObjectMethod(node) {
            return node.method || node.kind === "get" || node.kind === "set";
        }
        finishNodeAt(node, type, endLoc) {
            return $b48499974d50e8d0$var$toESTreeLocation(super.finishNodeAt(node, type, endLoc));
        }
        resetStartLocation(node, startLoc) {
            super.resetStartLocation(node, startLoc);
            $b48499974d50e8d0$var$toESTreeLocation(node);
        }
        resetEndLocation(node, endLoc = this.state.lastTokEndLoc) {
            super.resetEndLocation(node, endLoc);
            $b48499974d50e8d0$var$toESTreeLocation(node);
        }
    };
class $b48499974d50e8d0$var$TokContext {
    constructor(token, preserveSpace){
        this.token = void 0;
        this.preserveSpace = void 0;
        this.token = token;
        this.preserveSpace = !!preserveSpace;
    }
}
const $b48499974d50e8d0$var$types = {
    brace: new $b48499974d50e8d0$var$TokContext("{"),
    j_oTag: new $b48499974d50e8d0$var$TokContext("<tag"),
    j_cTag: new $b48499974d50e8d0$var$TokContext("</tag"),
    j_expr: new $b48499974d50e8d0$var$TokContext("<tag>...</tag>", true)
};
$b48499974d50e8d0$var$types.template = new $b48499974d50e8d0$var$TokContext("`", true);
const $b48499974d50e8d0$var$beforeExpr = true;
const $b48499974d50e8d0$var$startsExpr = true;
const $b48499974d50e8d0$var$isLoop = true;
const $b48499974d50e8d0$var$isAssign = true;
const $b48499974d50e8d0$var$prefix = true;
const $b48499974d50e8d0$var$postfix = true;
class $b48499974d50e8d0$var$ExportedTokenType {
    constructor(label, conf = {}){
        this.label = void 0;
        this.keyword = void 0;
        this.beforeExpr = void 0;
        this.startsExpr = void 0;
        this.rightAssociative = void 0;
        this.isLoop = void 0;
        this.isAssign = void 0;
        this.prefix = void 0;
        this.postfix = void 0;
        this.binop = void 0;
        this.label = label;
        this.keyword = conf.keyword;
        this.beforeExpr = !!conf.beforeExpr;
        this.startsExpr = !!conf.startsExpr;
        this.rightAssociative = !!conf.rightAssociative;
        this.isLoop = !!conf.isLoop;
        this.isAssign = !!conf.isAssign;
        this.prefix = !!conf.prefix;
        this.postfix = !!conf.postfix;
        this.binop = conf.binop != null ? conf.binop : null;
        this.updateContext = null;
    }
}
const $b48499974d50e8d0$var$keywords$1 = new Map();
function $b48499974d50e8d0$var$createKeyword(name, options = {}) {
    options.keyword = name;
    const token = $b48499974d50e8d0$var$createToken(name, options);
    $b48499974d50e8d0$var$keywords$1.set(name, token);
    return token;
}
function $b48499974d50e8d0$var$createBinop(name, binop) {
    return $b48499974d50e8d0$var$createToken(name, {
        beforeExpr: $b48499974d50e8d0$var$beforeExpr,
        binop: binop
    });
}
let $b48499974d50e8d0$var$tokenTypeCounter = -1;
const $b48499974d50e8d0$var$tokenTypes = [];
const $b48499974d50e8d0$var$tokenLabels = [];
const $b48499974d50e8d0$var$tokenBinops = [];
const $b48499974d50e8d0$var$tokenBeforeExprs = [];
const $b48499974d50e8d0$var$tokenStartsExprs = [];
const $b48499974d50e8d0$var$tokenPrefixes = [];
function $b48499974d50e8d0$var$createToken(name, options = {}) {
    var _options$binop, _options$beforeExpr, _options$startsExpr, _options$prefix;
    ++$b48499974d50e8d0$var$tokenTypeCounter;
    $b48499974d50e8d0$var$tokenLabels.push(name);
    $b48499974d50e8d0$var$tokenBinops.push((_options$binop = options.binop) != null ? _options$binop : -1);
    $b48499974d50e8d0$var$tokenBeforeExprs.push((_options$beforeExpr = options.beforeExpr) != null ? _options$beforeExpr : false);
    $b48499974d50e8d0$var$tokenStartsExprs.push((_options$startsExpr = options.startsExpr) != null ? _options$startsExpr : false);
    $b48499974d50e8d0$var$tokenPrefixes.push((_options$prefix = options.prefix) != null ? _options$prefix : false);
    $b48499974d50e8d0$var$tokenTypes.push(new $b48499974d50e8d0$var$ExportedTokenType(name, options));
    return $b48499974d50e8d0$var$tokenTypeCounter;
}
function $b48499974d50e8d0$var$createKeywordLike(name, options = {}) {
    var _options$binop2, _options$beforeExpr2, _options$startsExpr2, _options$prefix2;
    ++$b48499974d50e8d0$var$tokenTypeCounter;
    $b48499974d50e8d0$var$keywords$1.set(name, $b48499974d50e8d0$var$tokenTypeCounter);
    $b48499974d50e8d0$var$tokenLabels.push(name);
    $b48499974d50e8d0$var$tokenBinops.push((_options$binop2 = options.binop) != null ? _options$binop2 : -1);
    $b48499974d50e8d0$var$tokenBeforeExprs.push((_options$beforeExpr2 = options.beforeExpr) != null ? _options$beforeExpr2 : false);
    $b48499974d50e8d0$var$tokenStartsExprs.push((_options$startsExpr2 = options.startsExpr) != null ? _options$startsExpr2 : false);
    $b48499974d50e8d0$var$tokenPrefixes.push((_options$prefix2 = options.prefix) != null ? _options$prefix2 : false);
    $b48499974d50e8d0$var$tokenTypes.push(new $b48499974d50e8d0$var$ExportedTokenType("name", options));
    return $b48499974d50e8d0$var$tokenTypeCounter;
}
const $b48499974d50e8d0$var$tt = {
    bracketL: $b48499974d50e8d0$var$createToken("[", {
        beforeExpr: $b48499974d50e8d0$var$beforeExpr,
        startsExpr: $b48499974d50e8d0$var$startsExpr
    }),
    bracketHashL: $b48499974d50e8d0$var$createToken("#[", {
        beforeExpr: $b48499974d50e8d0$var$beforeExpr,
        startsExpr: $b48499974d50e8d0$var$startsExpr
    }),
    bracketBarL: $b48499974d50e8d0$var$createToken("[|", {
        beforeExpr: $b48499974d50e8d0$var$beforeExpr,
        startsExpr: $b48499974d50e8d0$var$startsExpr
    }),
    bracketR: $b48499974d50e8d0$var$createToken("]"),
    bracketBarR: $b48499974d50e8d0$var$createToken("|]"),
    braceL: $b48499974d50e8d0$var$createToken("{", {
        beforeExpr: $b48499974d50e8d0$var$beforeExpr,
        startsExpr: $b48499974d50e8d0$var$startsExpr
    }),
    braceBarL: $b48499974d50e8d0$var$createToken("{|", {
        beforeExpr: $b48499974d50e8d0$var$beforeExpr,
        startsExpr: $b48499974d50e8d0$var$startsExpr
    }),
    braceHashL: $b48499974d50e8d0$var$createToken("#{", {
        beforeExpr: $b48499974d50e8d0$var$beforeExpr,
        startsExpr: $b48499974d50e8d0$var$startsExpr
    }),
    braceR: $b48499974d50e8d0$var$createToken("}"),
    braceBarR: $b48499974d50e8d0$var$createToken("|}"),
    parenL: $b48499974d50e8d0$var$createToken("(", {
        beforeExpr: $b48499974d50e8d0$var$beforeExpr,
        startsExpr: $b48499974d50e8d0$var$startsExpr
    }),
    parenR: $b48499974d50e8d0$var$createToken(")"),
    comma: $b48499974d50e8d0$var$createToken(",", {
        beforeExpr: $b48499974d50e8d0$var$beforeExpr
    }),
    semi: $b48499974d50e8d0$var$createToken(";", {
        beforeExpr: $b48499974d50e8d0$var$beforeExpr
    }),
    colon: $b48499974d50e8d0$var$createToken(":", {
        beforeExpr: $b48499974d50e8d0$var$beforeExpr
    }),
    doubleColon: $b48499974d50e8d0$var$createToken("::", {
        beforeExpr: $b48499974d50e8d0$var$beforeExpr
    }),
    dot: $b48499974d50e8d0$var$createToken("."),
    question: $b48499974d50e8d0$var$createToken("?", {
        beforeExpr: $b48499974d50e8d0$var$beforeExpr
    }),
    questionDot: $b48499974d50e8d0$var$createToken("?."),
    arrow: $b48499974d50e8d0$var$createToken("=>", {
        beforeExpr: $b48499974d50e8d0$var$beforeExpr
    }),
    template: $b48499974d50e8d0$var$createToken("template"),
    ellipsis: $b48499974d50e8d0$var$createToken("...", {
        beforeExpr: $b48499974d50e8d0$var$beforeExpr
    }),
    backQuote: $b48499974d50e8d0$var$createToken("`", {
        startsExpr: $b48499974d50e8d0$var$startsExpr
    }),
    dollarBraceL: $b48499974d50e8d0$var$createToken("${", {
        beforeExpr: $b48499974d50e8d0$var$beforeExpr,
        startsExpr: $b48499974d50e8d0$var$startsExpr
    }),
    templateTail: $b48499974d50e8d0$var$createToken("...`", {
        startsExpr: $b48499974d50e8d0$var$startsExpr
    }),
    templateNonTail: $b48499974d50e8d0$var$createToken("...${", {
        beforeExpr: $b48499974d50e8d0$var$beforeExpr,
        startsExpr: $b48499974d50e8d0$var$startsExpr
    }),
    at: $b48499974d50e8d0$var$createToken("@"),
    hash: $b48499974d50e8d0$var$createToken("#", {
        startsExpr: $b48499974d50e8d0$var$startsExpr
    }),
    interpreterDirective: $b48499974d50e8d0$var$createToken("#!..."),
    eq: $b48499974d50e8d0$var$createToken("=", {
        beforeExpr: $b48499974d50e8d0$var$beforeExpr,
        isAssign: $b48499974d50e8d0$var$isAssign
    }),
    assign: $b48499974d50e8d0$var$createToken("_=", {
        beforeExpr: $b48499974d50e8d0$var$beforeExpr,
        isAssign: $b48499974d50e8d0$var$isAssign
    }),
    slashAssign: $b48499974d50e8d0$var$createToken("_=", {
        beforeExpr: $b48499974d50e8d0$var$beforeExpr,
        isAssign: $b48499974d50e8d0$var$isAssign
    }),
    xorAssign: $b48499974d50e8d0$var$createToken("_=", {
        beforeExpr: $b48499974d50e8d0$var$beforeExpr,
        isAssign: $b48499974d50e8d0$var$isAssign
    }),
    moduloAssign: $b48499974d50e8d0$var$createToken("_=", {
        beforeExpr: $b48499974d50e8d0$var$beforeExpr,
        isAssign: $b48499974d50e8d0$var$isAssign
    }),
    incDec: $b48499974d50e8d0$var$createToken("++/--", {
        prefix: $b48499974d50e8d0$var$prefix,
        postfix: $b48499974d50e8d0$var$postfix,
        startsExpr: $b48499974d50e8d0$var$startsExpr
    }),
    bang: $b48499974d50e8d0$var$createToken("!", {
        beforeExpr: $b48499974d50e8d0$var$beforeExpr,
        prefix: $b48499974d50e8d0$var$prefix,
        startsExpr: $b48499974d50e8d0$var$startsExpr
    }),
    tilde: $b48499974d50e8d0$var$createToken("~", {
        beforeExpr: $b48499974d50e8d0$var$beforeExpr,
        prefix: $b48499974d50e8d0$var$prefix,
        startsExpr: $b48499974d50e8d0$var$startsExpr
    }),
    doubleCaret: $b48499974d50e8d0$var$createToken("^^", {
        startsExpr: $b48499974d50e8d0$var$startsExpr
    }),
    doubleAt: $b48499974d50e8d0$var$createToken("@@", {
        startsExpr: $b48499974d50e8d0$var$startsExpr
    }),
    pipeline: $b48499974d50e8d0$var$createBinop("|>", 0),
    nullishCoalescing: $b48499974d50e8d0$var$createBinop("??", 1),
    logicalOR: $b48499974d50e8d0$var$createBinop("||", 1),
    logicalAND: $b48499974d50e8d0$var$createBinop("&&", 2),
    bitwiseOR: $b48499974d50e8d0$var$createBinop("|", 3),
    bitwiseXOR: $b48499974d50e8d0$var$createBinop("^", 4),
    bitwiseAND: $b48499974d50e8d0$var$createBinop("&", 5),
    equality: $b48499974d50e8d0$var$createBinop("==/!=/===/!==", 6),
    lt: $b48499974d50e8d0$var$createBinop("</>/<=/>=", 7),
    gt: $b48499974d50e8d0$var$createBinop("</>/<=/>=", 7),
    relational: $b48499974d50e8d0$var$createBinop("</>/<=/>=", 7),
    bitShift: $b48499974d50e8d0$var$createBinop("<</>>/>>>", 8),
    bitShiftL: $b48499974d50e8d0$var$createBinop("<</>>/>>>", 8),
    bitShiftR: $b48499974d50e8d0$var$createBinop("<</>>/>>>", 8),
    plusMin: $b48499974d50e8d0$var$createToken("+/-", {
        beforeExpr: $b48499974d50e8d0$var$beforeExpr,
        binop: 9,
        prefix: $b48499974d50e8d0$var$prefix,
        startsExpr: $b48499974d50e8d0$var$startsExpr
    }),
    modulo: $b48499974d50e8d0$var$createToken("%", {
        binop: 10,
        startsExpr: $b48499974d50e8d0$var$startsExpr
    }),
    star: $b48499974d50e8d0$var$createToken("*", {
        binop: 10
    }),
    slash: $b48499974d50e8d0$var$createBinop("/", 10),
    exponent: $b48499974d50e8d0$var$createToken("**", {
        beforeExpr: $b48499974d50e8d0$var$beforeExpr,
        binop: 11,
        rightAssociative: true
    }),
    _in: $b48499974d50e8d0$var$createKeyword("in", {
        beforeExpr: $b48499974d50e8d0$var$beforeExpr,
        binop: 7
    }),
    _instanceof: $b48499974d50e8d0$var$createKeyword("instanceof", {
        beforeExpr: $b48499974d50e8d0$var$beforeExpr,
        binop: 7
    }),
    _break: $b48499974d50e8d0$var$createKeyword("break"),
    _case: $b48499974d50e8d0$var$createKeyword("case", {
        beforeExpr: $b48499974d50e8d0$var$beforeExpr
    }),
    _catch: $b48499974d50e8d0$var$createKeyword("catch"),
    _continue: $b48499974d50e8d0$var$createKeyword("continue"),
    _debugger: $b48499974d50e8d0$var$createKeyword("debugger"),
    _default: $b48499974d50e8d0$var$createKeyword("default", {
        beforeExpr: $b48499974d50e8d0$var$beforeExpr
    }),
    _else: $b48499974d50e8d0$var$createKeyword("else", {
        beforeExpr: $b48499974d50e8d0$var$beforeExpr
    }),
    _finally: $b48499974d50e8d0$var$createKeyword("finally"),
    _function: $b48499974d50e8d0$var$createKeyword("function", {
        startsExpr: $b48499974d50e8d0$var$startsExpr
    }),
    _if: $b48499974d50e8d0$var$createKeyword("if"),
    _return: $b48499974d50e8d0$var$createKeyword("return", {
        beforeExpr: $b48499974d50e8d0$var$beforeExpr
    }),
    _switch: $b48499974d50e8d0$var$createKeyword("switch"),
    _throw: $b48499974d50e8d0$var$createKeyword("throw", {
        beforeExpr: $b48499974d50e8d0$var$beforeExpr,
        prefix: $b48499974d50e8d0$var$prefix,
        startsExpr: $b48499974d50e8d0$var$startsExpr
    }),
    _try: $b48499974d50e8d0$var$createKeyword("try"),
    _var: $b48499974d50e8d0$var$createKeyword("var"),
    _const: $b48499974d50e8d0$var$createKeyword("const"),
    _with: $b48499974d50e8d0$var$createKeyword("with"),
    _new: $b48499974d50e8d0$var$createKeyword("new", {
        beforeExpr: $b48499974d50e8d0$var$beforeExpr,
        startsExpr: $b48499974d50e8d0$var$startsExpr
    }),
    _this: $b48499974d50e8d0$var$createKeyword("this", {
        startsExpr: $b48499974d50e8d0$var$startsExpr
    }),
    _super: $b48499974d50e8d0$var$createKeyword("super", {
        startsExpr: $b48499974d50e8d0$var$startsExpr
    }),
    _class: $b48499974d50e8d0$var$createKeyword("class", {
        startsExpr: $b48499974d50e8d0$var$startsExpr
    }),
    _extends: $b48499974d50e8d0$var$createKeyword("extends", {
        beforeExpr: $b48499974d50e8d0$var$beforeExpr
    }),
    _export: $b48499974d50e8d0$var$createKeyword("export"),
    _import: $b48499974d50e8d0$var$createKeyword("import", {
        startsExpr: $b48499974d50e8d0$var$startsExpr
    }),
    _null: $b48499974d50e8d0$var$createKeyword("null", {
        startsExpr: $b48499974d50e8d0$var$startsExpr
    }),
    _true: $b48499974d50e8d0$var$createKeyword("true", {
        startsExpr: $b48499974d50e8d0$var$startsExpr
    }),
    _false: $b48499974d50e8d0$var$createKeyword("false", {
        startsExpr: $b48499974d50e8d0$var$startsExpr
    }),
    _typeof: $b48499974d50e8d0$var$createKeyword("typeof", {
        beforeExpr: $b48499974d50e8d0$var$beforeExpr,
        prefix: $b48499974d50e8d0$var$prefix,
        startsExpr: $b48499974d50e8d0$var$startsExpr
    }),
    _void: $b48499974d50e8d0$var$createKeyword("void", {
        beforeExpr: $b48499974d50e8d0$var$beforeExpr,
        prefix: $b48499974d50e8d0$var$prefix,
        startsExpr: $b48499974d50e8d0$var$startsExpr
    }),
    _delete: $b48499974d50e8d0$var$createKeyword("delete", {
        beforeExpr: $b48499974d50e8d0$var$beforeExpr,
        prefix: $b48499974d50e8d0$var$prefix,
        startsExpr: $b48499974d50e8d0$var$startsExpr
    }),
    _do: $b48499974d50e8d0$var$createKeyword("do", {
        isLoop: $b48499974d50e8d0$var$isLoop,
        beforeExpr: $b48499974d50e8d0$var$beforeExpr
    }),
    _for: $b48499974d50e8d0$var$createKeyword("for", {
        isLoop: $b48499974d50e8d0$var$isLoop
    }),
    _while: $b48499974d50e8d0$var$createKeyword("while", {
        isLoop: $b48499974d50e8d0$var$isLoop
    }),
    _as: $b48499974d50e8d0$var$createKeywordLike("as", {
        startsExpr: $b48499974d50e8d0$var$startsExpr
    }),
    _assert: $b48499974d50e8d0$var$createKeywordLike("assert", {
        startsExpr: $b48499974d50e8d0$var$startsExpr
    }),
    _async: $b48499974d50e8d0$var$createKeywordLike("async", {
        startsExpr: $b48499974d50e8d0$var$startsExpr
    }),
    _await: $b48499974d50e8d0$var$createKeywordLike("await", {
        startsExpr: $b48499974d50e8d0$var$startsExpr
    }),
    _defer: $b48499974d50e8d0$var$createKeywordLike("defer", {
        startsExpr: $b48499974d50e8d0$var$startsExpr
    }),
    _from: $b48499974d50e8d0$var$createKeywordLike("from", {
        startsExpr: $b48499974d50e8d0$var$startsExpr
    }),
    _get: $b48499974d50e8d0$var$createKeywordLike("get", {
        startsExpr: $b48499974d50e8d0$var$startsExpr
    }),
    _let: $b48499974d50e8d0$var$createKeywordLike("let", {
        startsExpr: $b48499974d50e8d0$var$startsExpr
    }),
    _meta: $b48499974d50e8d0$var$createKeywordLike("meta", {
        startsExpr: $b48499974d50e8d0$var$startsExpr
    }),
    _of: $b48499974d50e8d0$var$createKeywordLike("of", {
        startsExpr: $b48499974d50e8d0$var$startsExpr
    }),
    _sent: $b48499974d50e8d0$var$createKeywordLike("sent", {
        startsExpr: $b48499974d50e8d0$var$startsExpr
    }),
    _set: $b48499974d50e8d0$var$createKeywordLike("set", {
        startsExpr: $b48499974d50e8d0$var$startsExpr
    }),
    _source: $b48499974d50e8d0$var$createKeywordLike("source", {
        startsExpr: $b48499974d50e8d0$var$startsExpr
    }),
    _static: $b48499974d50e8d0$var$createKeywordLike("static", {
        startsExpr: $b48499974d50e8d0$var$startsExpr
    }),
    _using: $b48499974d50e8d0$var$createKeywordLike("using", {
        startsExpr: $b48499974d50e8d0$var$startsExpr
    }),
    _yield: $b48499974d50e8d0$var$createKeywordLike("yield", {
        startsExpr: $b48499974d50e8d0$var$startsExpr
    }),
    _asserts: $b48499974d50e8d0$var$createKeywordLike("asserts", {
        startsExpr: $b48499974d50e8d0$var$startsExpr
    }),
    _checks: $b48499974d50e8d0$var$createKeywordLike("checks", {
        startsExpr: $b48499974d50e8d0$var$startsExpr
    }),
    _exports: $b48499974d50e8d0$var$createKeywordLike("exports", {
        startsExpr: $b48499974d50e8d0$var$startsExpr
    }),
    _global: $b48499974d50e8d0$var$createKeywordLike("global", {
        startsExpr: $b48499974d50e8d0$var$startsExpr
    }),
    _implements: $b48499974d50e8d0$var$createKeywordLike("implements", {
        startsExpr: $b48499974d50e8d0$var$startsExpr
    }),
    _intrinsic: $b48499974d50e8d0$var$createKeywordLike("intrinsic", {
        startsExpr: $b48499974d50e8d0$var$startsExpr
    }),
    _infer: $b48499974d50e8d0$var$createKeywordLike("infer", {
        startsExpr: $b48499974d50e8d0$var$startsExpr
    }),
    _is: $b48499974d50e8d0$var$createKeywordLike("is", {
        startsExpr: $b48499974d50e8d0$var$startsExpr
    }),
    _mixins: $b48499974d50e8d0$var$createKeywordLike("mixins", {
        startsExpr: $b48499974d50e8d0$var$startsExpr
    }),
    _proto: $b48499974d50e8d0$var$createKeywordLike("proto", {
        startsExpr: $b48499974d50e8d0$var$startsExpr
    }),
    _require: $b48499974d50e8d0$var$createKeywordLike("require", {
        startsExpr: $b48499974d50e8d0$var$startsExpr
    }),
    _satisfies: $b48499974d50e8d0$var$createKeywordLike("satisfies", {
        startsExpr: $b48499974d50e8d0$var$startsExpr
    }),
    _keyof: $b48499974d50e8d0$var$createKeywordLike("keyof", {
        startsExpr: $b48499974d50e8d0$var$startsExpr
    }),
    _readonly: $b48499974d50e8d0$var$createKeywordLike("readonly", {
        startsExpr: $b48499974d50e8d0$var$startsExpr
    }),
    _unique: $b48499974d50e8d0$var$createKeywordLike("unique", {
        startsExpr: $b48499974d50e8d0$var$startsExpr
    }),
    _abstract: $b48499974d50e8d0$var$createKeywordLike("abstract", {
        startsExpr: $b48499974d50e8d0$var$startsExpr
    }),
    _declare: $b48499974d50e8d0$var$createKeywordLike("declare", {
        startsExpr: $b48499974d50e8d0$var$startsExpr
    }),
    _enum: $b48499974d50e8d0$var$createKeywordLike("enum", {
        startsExpr: $b48499974d50e8d0$var$startsExpr
    }),
    _module: $b48499974d50e8d0$var$createKeywordLike("module", {
        startsExpr: $b48499974d50e8d0$var$startsExpr
    }),
    _namespace: $b48499974d50e8d0$var$createKeywordLike("namespace", {
        startsExpr: $b48499974d50e8d0$var$startsExpr
    }),
    _interface: $b48499974d50e8d0$var$createKeywordLike("interface", {
        startsExpr: $b48499974d50e8d0$var$startsExpr
    }),
    _type: $b48499974d50e8d0$var$createKeywordLike("type", {
        startsExpr: $b48499974d50e8d0$var$startsExpr
    }),
    _opaque: $b48499974d50e8d0$var$createKeywordLike("opaque", {
        startsExpr: $b48499974d50e8d0$var$startsExpr
    }),
    name: $b48499974d50e8d0$var$createToken("name", {
        startsExpr: $b48499974d50e8d0$var$startsExpr
    }),
    string: $b48499974d50e8d0$var$createToken("string", {
        startsExpr: $b48499974d50e8d0$var$startsExpr
    }),
    num: $b48499974d50e8d0$var$createToken("num", {
        startsExpr: $b48499974d50e8d0$var$startsExpr
    }),
    bigint: $b48499974d50e8d0$var$createToken("bigint", {
        startsExpr: $b48499974d50e8d0$var$startsExpr
    }),
    decimal: $b48499974d50e8d0$var$createToken("decimal", {
        startsExpr: $b48499974d50e8d0$var$startsExpr
    }),
    regexp: $b48499974d50e8d0$var$createToken("regexp", {
        startsExpr: $b48499974d50e8d0$var$startsExpr
    }),
    privateName: $b48499974d50e8d0$var$createToken("#name", {
        startsExpr: $b48499974d50e8d0$var$startsExpr
    }),
    eof: $b48499974d50e8d0$var$createToken("eof"),
    jsxName: $b48499974d50e8d0$var$createToken("jsxName"),
    jsxText: $b48499974d50e8d0$var$createToken("jsxText", {
        beforeExpr: true
    }),
    jsxTagStart: $b48499974d50e8d0$var$createToken("jsxTagStart", {
        startsExpr: true
    }),
    jsxTagEnd: $b48499974d50e8d0$var$createToken("jsxTagEnd"),
    placeholder: $b48499974d50e8d0$var$createToken("%%", {
        startsExpr: true
    })
};
function $b48499974d50e8d0$var$tokenIsIdentifier(token) {
    return token >= 93 && token <= 132;
}
function $b48499974d50e8d0$var$tokenKeywordOrIdentifierIsKeyword(token) {
    return token <= 92;
}
function $b48499974d50e8d0$var$tokenIsKeywordOrIdentifier(token) {
    return token >= 58 && token <= 132;
}
function $b48499974d50e8d0$var$tokenIsLiteralPropertyName(token) {
    return token >= 58 && token <= 136;
}
function $b48499974d50e8d0$var$tokenComesBeforeExpression(token) {
    return $b48499974d50e8d0$var$tokenBeforeExprs[token];
}
function $b48499974d50e8d0$var$tokenCanStartExpression(token) {
    return $b48499974d50e8d0$var$tokenStartsExprs[token];
}
function $b48499974d50e8d0$var$tokenIsAssignment(token) {
    return token >= 29 && token <= 33;
}
function $b48499974d50e8d0$var$tokenIsFlowInterfaceOrTypeOrOpaque(token) {
    return token >= 129 && token <= 131;
}
function $b48499974d50e8d0$var$tokenIsLoop(token) {
    return token >= 90 && token <= 92;
}
function $b48499974d50e8d0$var$tokenIsKeyword(token) {
    return token >= 58 && token <= 92;
}
function $b48499974d50e8d0$var$tokenIsOperator(token) {
    return token >= 39 && token <= 59;
}
function $b48499974d50e8d0$var$tokenIsPostfix(token) {
    return token === 34;
}
function $b48499974d50e8d0$var$tokenIsPrefix(token) {
    return $b48499974d50e8d0$var$tokenPrefixes[token];
}
function $b48499974d50e8d0$var$tokenIsTSTypeOperator(token) {
    return token >= 121 && token <= 123;
}
function $b48499974d50e8d0$var$tokenIsTSDeclarationStart(token) {
    return token >= 124 && token <= 130;
}
function $b48499974d50e8d0$var$tokenLabelName(token) {
    return $b48499974d50e8d0$var$tokenLabels[token];
}
function $b48499974d50e8d0$var$tokenOperatorPrecedence(token) {
    return $b48499974d50e8d0$var$tokenBinops[token];
}
function $b48499974d50e8d0$var$tokenIsRightAssociative(token) {
    return token === 57;
}
function $b48499974d50e8d0$var$tokenIsTemplate(token) {
    return token >= 24 && token <= 25;
}
function $b48499974d50e8d0$var$getExportedToken(token) {
    return $b48499974d50e8d0$var$tokenTypes[token];
}
$b48499974d50e8d0$var$tokenTypes[8].updateContext = (context)=>{
    context.pop();
};
$b48499974d50e8d0$var$tokenTypes[5].updateContext = $b48499974d50e8d0$var$tokenTypes[7].updateContext = $b48499974d50e8d0$var$tokenTypes[23].updateContext = (context)=>{
    context.push($b48499974d50e8d0$var$types.brace);
};
$b48499974d50e8d0$var$tokenTypes[22].updateContext = (context)=>{
    if (context[context.length - 1] === $b48499974d50e8d0$var$types.template) context.pop();
    else context.push($b48499974d50e8d0$var$types.template);
};
$b48499974d50e8d0$var$tokenTypes[142].updateContext = (context)=>{
    context.push($b48499974d50e8d0$var$types.j_expr, $b48499974d50e8d0$var$types.j_oTag);
};
let $b48499974d50e8d0$var$nonASCIIidentifierStartChars = "\xaa\xb5\xba\xc0-\xd6\xd8-\xf6\xf8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u0870-\u0887\u0889-\u088E\u08A0-\u08C9\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C5D\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D04-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E86-\u0E8A\u0E8C-\u0EA3\u0EA5\u0EA7-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u1711\u171F-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1878\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4C\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF3\u1CF5\u1CF6\u1CFA\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2118-\u211D\u2124\u2126\u2128\u212A-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309B-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u31A0-\u31BF\u31F0-\u31FF\u3400-\u4DBF\u4E00-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6EF\uA717-\uA71F\uA722-\uA788\uA78B-\uA7CA\uA7D0\uA7D1\uA7D3\uA7D5-\uA7D9\uA7F2-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB69\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC";
let $b48499974d50e8d0$var$nonASCIIidentifierChars = "\u200C\u200D\xb7\u0300-\u036F\u0387\u0483-\u0487\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u0669\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u06F0-\u06F9\u0711\u0730-\u074A\u07A6-\u07B0\u07C0-\u07C9\u07EB-\u07F3\u07FD\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u0898-\u089F\u08CA-\u08E1\u08E3-\u0903\u093A-\u093C\u093E-\u094F\u0951-\u0957\u0962\u0963\u0966-\u096F\u0981-\u0983\u09BC\u09BE-\u09C4\u09C7\u09C8\u09CB-\u09CD\u09D7\u09E2\u09E3\u09E6-\u09EF\u09FE\u0A01-\u0A03\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A66-\u0A71\u0A75\u0A81-\u0A83\u0ABC\u0ABE-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AE2\u0AE3\u0AE6-\u0AEF\u0AFA-\u0AFF\u0B01-\u0B03\u0B3C\u0B3E-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B55-\u0B57\u0B62\u0B63\u0B66-\u0B6F\u0B82\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD7\u0BE6-\u0BEF\u0C00-\u0C04\u0C3C\u0C3E-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C66-\u0C6F\u0C81-\u0C83\u0CBC\u0CBE-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CE2\u0CE3\u0CE6-\u0CEF\u0CF3\u0D00-\u0D03\u0D3B\u0D3C\u0D3E-\u0D44\u0D46-\u0D48\u0D4A-\u0D4D\u0D57\u0D62\u0D63\u0D66-\u0D6F\u0D81-\u0D83\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DE6-\u0DEF\u0DF2\u0DF3\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0E50-\u0E59\u0EB1\u0EB4-\u0EBC\u0EC8-\u0ECE\u0ED0-\u0ED9\u0F18\u0F19\u0F20-\u0F29\u0F35\u0F37\u0F39\u0F3E\u0F3F\u0F71-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102B-\u103E\u1040-\u1049\u1056-\u1059\u105E-\u1060\u1062-\u1064\u1067-\u106D\u1071-\u1074\u1082-\u108D\u108F-\u109D\u135D-\u135F\u1369-\u1371\u1712-\u1715\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4-\u17D3\u17DD\u17E0-\u17E9\u180B-\u180D\u180F-\u1819\u18A9\u1920-\u192B\u1930-\u193B\u1946-\u194F\u19D0-\u19DA\u1A17-\u1A1B\u1A55-\u1A5E\u1A60-\u1A7C\u1A7F-\u1A89\u1A90-\u1A99\u1AB0-\u1ABD\u1ABF-\u1ACE\u1B00-\u1B04\u1B34-\u1B44\u1B50-\u1B59\u1B6B-\u1B73\u1B80-\u1B82\u1BA1-\u1BAD\u1BB0-\u1BB9\u1BE6-\u1BF3\u1C24-\u1C37\u1C40-\u1C49\u1C50-\u1C59\u1CD0-\u1CD2\u1CD4-\u1CE8\u1CED\u1CF4\u1CF7-\u1CF9\u1DC0-\u1DFF\u200C\u200D\u203F\u2040\u2054\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302F\u3099\u309A\u30FB\uA620-\uA629\uA66F\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA823-\uA827\uA82C\uA880\uA881\uA8B4-\uA8C5\uA8D0-\uA8D9\uA8E0-\uA8F1\uA8FF-\uA909\uA926-\uA92D\uA947-\uA953\uA980-\uA983\uA9B3-\uA9C0\uA9D0-\uA9D9\uA9E5\uA9F0-\uA9F9\uAA29-\uAA36\uAA43\uAA4C\uAA4D\uAA50-\uAA59\uAA7B-\uAA7D\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEB-\uAAEF\uAAF5\uAAF6\uABE3-\uABEA\uABEC\uABED\uABF0-\uABF9\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F\uFE33\uFE34\uFE4D-\uFE4F\uFF10-\uFF19\uFF3F\uFF65";
const $b48499974d50e8d0$var$nonASCIIidentifierStart = new RegExp("[" + $b48499974d50e8d0$var$nonASCIIidentifierStartChars + "]");
const $b48499974d50e8d0$var$nonASCIIidentifier = new RegExp("[" + $b48499974d50e8d0$var$nonASCIIidentifierStartChars + $b48499974d50e8d0$var$nonASCIIidentifierChars + "]");
$b48499974d50e8d0$var$nonASCIIidentifierStartChars = $b48499974d50e8d0$var$nonASCIIidentifierChars = null;
const $b48499974d50e8d0$var$astralIdentifierStartCodes = [
    0,
    11,
    2,
    25,
    2,
    18,
    2,
    1,
    2,
    14,
    3,
    13,
    35,
    122,
    70,
    52,
    268,
    28,
    4,
    48,
    48,
    31,
    14,
    29,
    6,
    37,
    11,
    29,
    3,
    35,
    5,
    7,
    2,
    4,
    43,
    157,
    19,
    35,
    5,
    35,
    5,
    39,
    9,
    51,
    13,
    10,
    2,
    14,
    2,
    6,
    2,
    1,
    2,
    10,
    2,
    14,
    2,
    6,
    2,
    1,
    68,
    310,
    10,
    21,
    11,
    7,
    25,
    5,
    2,
    41,
    2,
    8,
    70,
    5,
    3,
    0,
    2,
    43,
    2,
    1,
    4,
    0,
    3,
    22,
    11,
    22,
    10,
    30,
    66,
    18,
    2,
    1,
    11,
    21,
    11,
    25,
    71,
    55,
    7,
    1,
    65,
    0,
    16,
    3,
    2,
    2,
    2,
    28,
    43,
    28,
    4,
    28,
    36,
    7,
    2,
    27,
    28,
    53,
    11,
    21,
    11,
    18,
    14,
    17,
    111,
    72,
    56,
    50,
    14,
    50,
    14,
    35,
    349,
    41,
    7,
    1,
    79,
    28,
    11,
    0,
    9,
    21,
    43,
    17,
    47,
    20,
    28,
    22,
    13,
    52,
    58,
    1,
    3,
    0,
    14,
    44,
    33,
    24,
    27,
    35,
    30,
    0,
    3,
    0,
    9,
    34,
    4,
    0,
    13,
    47,
    15,
    3,
    22,
    0,
    2,
    0,
    36,
    17,
    2,
    24,
    20,
    1,
    64,
    6,
    2,
    0,
    2,
    3,
    2,
    14,
    2,
    9,
    8,
    46,
    39,
    7,
    3,
    1,
    3,
    21,
    2,
    6,
    2,
    1,
    2,
    4,
    4,
    0,
    19,
    0,
    13,
    4,
    159,
    52,
    19,
    3,
    21,
    2,
    31,
    47,
    21,
    1,
    2,
    0,
    185,
    46,
    42,
    3,
    37,
    47,
    21,
    0,
    60,
    42,
    14,
    0,
    72,
    26,
    38,
    6,
    186,
    43,
    117,
    63,
    32,
    7,
    3,
    0,
    3,
    7,
    2,
    1,
    2,
    23,
    16,
    0,
    2,
    0,
    95,
    7,
    3,
    38,
    17,
    0,
    2,
    0,
    29,
    0,
    11,
    39,
    8,
    0,
    22,
    0,
    12,
    45,
    20,
    0,
    19,
    72,
    264,
    8,
    2,
    36,
    18,
    0,
    50,
    29,
    113,
    6,
    2,
    1,
    2,
    37,
    22,
    0,
    26,
    5,
    2,
    1,
    2,
    31,
    15,
    0,
    328,
    18,
    16,
    0,
    2,
    12,
    2,
    33,
    125,
    0,
    80,
    921,
    103,
    110,
    18,
    195,
    2637,
    96,
    16,
    1071,
    18,
    5,
    4026,
    582,
    8634,
    568,
    8,
    30,
    18,
    78,
    18,
    29,
    19,
    47,
    17,
    3,
    32,
    20,
    6,
    18,
    689,
    63,
    129,
    74,
    6,
    0,
    67,
    12,
    65,
    1,
    2,
    0,
    29,
    6135,
    9,
    1237,
    43,
    8,
    8936,
    3,
    2,
    6,
    2,
    1,
    2,
    290,
    16,
    0,
    30,
    2,
    3,
    0,
    15,
    3,
    9,
    395,
    2309,
    106,
    6,
    12,
    4,
    8,
    8,
    9,
    5991,
    84,
    2,
    70,
    2,
    1,
    3,
    0,
    3,
    1,
    3,
    3,
    2,
    11,
    2,
    0,
    2,
    6,
    2,
    64,
    2,
    3,
    3,
    7,
    2,
    6,
    2,
    27,
    2,
    3,
    2,
    4,
    2,
    0,
    4,
    6,
    2,
    339,
    3,
    24,
    2,
    24,
    2,
    30,
    2,
    24,
    2,
    30,
    2,
    24,
    2,
    30,
    2,
    24,
    2,
    30,
    2,
    24,
    2,
    7,
    1845,
    30,
    7,
    5,
    262,
    61,
    147,
    44,
    11,
    6,
    17,
    0,
    322,
    29,
    19,
    43,
    485,
    27,
    757,
    6,
    2,
    3,
    2,
    1,
    2,
    14,
    2,
    196,
    60,
    67,
    8,
    0,
    1205,
    3,
    2,
    26,
    2,
    1,
    2,
    0,
    3,
    0,
    2,
    9,
    2,
    3,
    2,
    0,
    2,
    0,
    7,
    0,
    5,
    0,
    2,
    0,
    2,
    0,
    2,
    2,
    2,
    1,
    2,
    0,
    3,
    0,
    2,
    0,
    2,
    0,
    2,
    0,
    2,
    0,
    2,
    1,
    2,
    0,
    3,
    3,
    2,
    6,
    2,
    3,
    2,
    3,
    2,
    0,
    2,
    9,
    2,
    16,
    6,
    2,
    2,
    4,
    2,
    16,
    4421,
    42719,
    33,
    4153,
    7,
    221,
    3,
    5761,
    15,
    7472,
    16,
    621,
    2467,
    541,
    1507,
    4938,
    6,
    4191
];
const $b48499974d50e8d0$var$astralIdentifierCodes = [
    509,
    0,
    227,
    0,
    150,
    4,
    294,
    9,
    1368,
    2,
    2,
    1,
    6,
    3,
    41,
    2,
    5,
    0,
    166,
    1,
    574,
    3,
    9,
    9,
    370,
    1,
    81,
    2,
    71,
    10,
    50,
    3,
    123,
    2,
    54,
    14,
    32,
    10,
    3,
    1,
    11,
    3,
    46,
    10,
    8,
    0,
    46,
    9,
    7,
    2,
    37,
    13,
    2,
    9,
    6,
    1,
    45,
    0,
    13,
    2,
    49,
    13,
    9,
    3,
    2,
    11,
    83,
    11,
    7,
    0,
    3,
    0,
    158,
    11,
    6,
    9,
    7,
    3,
    56,
    1,
    2,
    6,
    3,
    1,
    3,
    2,
    10,
    0,
    11,
    1,
    3,
    6,
    4,
    4,
    193,
    17,
    10,
    9,
    5,
    0,
    82,
    19,
    13,
    9,
    214,
    6,
    3,
    8,
    28,
    1,
    83,
    16,
    16,
    9,
    82,
    12,
    9,
    9,
    84,
    14,
    5,
    9,
    243,
    14,
    166,
    9,
    71,
    5,
    2,
    1,
    3,
    3,
    2,
    0,
    2,
    1,
    13,
    9,
    120,
    6,
    3,
    6,
    4,
    0,
    29,
    9,
    41,
    6,
    2,
    3,
    9,
    0,
    10,
    10,
    47,
    15,
    406,
    7,
    2,
    7,
    17,
    9,
    57,
    21,
    2,
    13,
    123,
    5,
    4,
    0,
    2,
    1,
    2,
    6,
    2,
    0,
    9,
    9,
    49,
    4,
    2,
    1,
    2,
    4,
    9,
    9,
    330,
    3,
    10,
    1,
    2,
    0,
    49,
    6,
    4,
    4,
    14,
    9,
    5351,
    0,
    7,
    14,
    13835,
    9,
    87,
    9,
    39,
    4,
    60,
    6,
    26,
    9,
    1014,
    0,
    2,
    54,
    8,
    3,
    82,
    0,
    12,
    1,
    19628,
    1,
    4706,
    45,
    3,
    22,
    543,
    4,
    4,
    5,
    9,
    7,
    3,
    6,
    31,
    3,
    149,
    2,
    1418,
    49,
    513,
    54,
    5,
    49,
    9,
    0,
    15,
    0,
    23,
    4,
    2,
    14,
    1361,
    6,
    2,
    16,
    3,
    6,
    2,
    1,
    2,
    4,
    101,
    0,
    161,
    6,
    10,
    9,
    357,
    0,
    62,
    13,
    499,
    13,
    983,
    6,
    110,
    6,
    6,
    9,
    4759,
    9,
    787719,
    239
];
function $b48499974d50e8d0$var$isInAstralSet(code, set) {
    let pos = 0x10000;
    for(let i = 0, length = set.length; i < length; i += 2){
        pos += set[i];
        if (pos > code) return false;
        pos += set[i + 1];
        if (pos >= code) return true;
    }
    return false;
}
function $b48499974d50e8d0$var$isIdentifierStart(code) {
    if (code < 65) return code === 36;
    if (code <= 90) return true;
    if (code < 97) return code === 95;
    if (code <= 122) return true;
    if (code <= 0xffff) return code >= 0xaa && $b48499974d50e8d0$var$nonASCIIidentifierStart.test(String.fromCharCode(code));
    return $b48499974d50e8d0$var$isInAstralSet(code, $b48499974d50e8d0$var$astralIdentifierStartCodes);
}
function $b48499974d50e8d0$var$isIdentifierChar(code) {
    if (code < 48) return code === 36;
    if (code < 58) return true;
    if (code < 65) return false;
    if (code <= 90) return true;
    if (code < 97) return code === 95;
    if (code <= 122) return true;
    if (code <= 0xffff) return code >= 0xaa && $b48499974d50e8d0$var$nonASCIIidentifier.test(String.fromCharCode(code));
    return $b48499974d50e8d0$var$isInAstralSet(code, $b48499974d50e8d0$var$astralIdentifierStartCodes) || $b48499974d50e8d0$var$isInAstralSet(code, $b48499974d50e8d0$var$astralIdentifierCodes);
}
const $b48499974d50e8d0$var$reservedWords = {
    keyword: [
        "break",
        "case",
        "catch",
        "continue",
        "debugger",
        "default",
        "do",
        "else",
        "finally",
        "for",
        "function",
        "if",
        "return",
        "switch",
        "throw",
        "try",
        "var",
        "const",
        "while",
        "with",
        "new",
        "this",
        "super",
        "class",
        "extends",
        "export",
        "import",
        "null",
        "true",
        "false",
        "in",
        "instanceof",
        "typeof",
        "void",
        "delete"
    ],
    strict: [
        "implements",
        "interface",
        "let",
        "package",
        "private",
        "protected",
        "public",
        "static",
        "yield"
    ],
    strictBind: [
        "eval",
        "arguments"
    ]
};
const $b48499974d50e8d0$var$keywords = new Set($b48499974d50e8d0$var$reservedWords.keyword);
const $b48499974d50e8d0$var$reservedWordsStrictSet = new Set($b48499974d50e8d0$var$reservedWords.strict);
const $b48499974d50e8d0$var$reservedWordsStrictBindSet = new Set($b48499974d50e8d0$var$reservedWords.strictBind);
function $b48499974d50e8d0$var$isReservedWord(word, inModule) {
    return inModule && word === "await" || word === "enum";
}
function $b48499974d50e8d0$var$isStrictReservedWord(word, inModule) {
    return $b48499974d50e8d0$var$isReservedWord(word, inModule) || $b48499974d50e8d0$var$reservedWordsStrictSet.has(word);
}
function $b48499974d50e8d0$var$isStrictBindOnlyReservedWord(word) {
    return $b48499974d50e8d0$var$reservedWordsStrictBindSet.has(word);
}
function $b48499974d50e8d0$var$isStrictBindReservedWord(word, inModule) {
    return $b48499974d50e8d0$var$isStrictReservedWord(word, inModule) || $b48499974d50e8d0$var$isStrictBindOnlyReservedWord(word);
}
function $b48499974d50e8d0$var$isKeyword(word) {
    return $b48499974d50e8d0$var$keywords.has(word);
}
function $b48499974d50e8d0$var$isIteratorStart(current, next, next2) {
    return current === 64 && next === 64 && $b48499974d50e8d0$var$isIdentifierStart(next2);
}
const $b48499974d50e8d0$var$reservedWordLikeSet = new Set([
    "break",
    "case",
    "catch",
    "continue",
    "debugger",
    "default",
    "do",
    "else",
    "finally",
    "for",
    "function",
    "if",
    "return",
    "switch",
    "throw",
    "try",
    "var",
    "const",
    "while",
    "with",
    "new",
    "this",
    "super",
    "class",
    "extends",
    "export",
    "import",
    "null",
    "true",
    "false",
    "in",
    "instanceof",
    "typeof",
    "void",
    "delete",
    "implements",
    "interface",
    "let",
    "package",
    "private",
    "protected",
    "public",
    "static",
    "yield",
    "eval",
    "arguments",
    "enum",
    "await"
]);
function $b48499974d50e8d0$var$canBeReservedWord(word) {
    return $b48499974d50e8d0$var$reservedWordLikeSet.has(word);
}
class $b48499974d50e8d0$var$Scope {
    constructor(flags){
        this.flags = 0;
        this.names = new Map();
        this.firstLexicalName = "";
        this.flags = flags;
    }
}
class $b48499974d50e8d0$var$ScopeHandler {
    constructor(parser, inModule){
        this.parser = void 0;
        this.scopeStack = [];
        this.inModule = void 0;
        this.undefinedExports = new Map();
        this.parser = parser;
        this.inModule = inModule;
    }
    get inTopLevel() {
        return (this.currentScope().flags & 1) > 0;
    }
    get inFunction() {
        return (this.currentVarScopeFlags() & 2) > 0;
    }
    get allowSuper() {
        return (this.currentThisScopeFlags() & 16) > 0;
    }
    get allowDirectSuper() {
        return (this.currentThisScopeFlags() & 32) > 0;
    }
    get inClass() {
        return (this.currentThisScopeFlags() & 64) > 0;
    }
    get inClassAndNotInNonArrowFunction() {
        const flags = this.currentThisScopeFlags();
        return (flags & 64) > 0 && (flags & 2) === 0;
    }
    get inStaticBlock() {
        for(let i = this.scopeStack.length - 1;; i--){
            const { flags: flags } = this.scopeStack[i];
            if (flags & 128) return true;
            if (flags & 451) return false;
        }
    }
    get inNonArrowFunction() {
        return (this.currentThisScopeFlags() & 2) > 0;
    }
    get treatFunctionsAsVar() {
        return this.treatFunctionsAsVarInScope(this.currentScope());
    }
    createScope(flags) {
        return new $b48499974d50e8d0$var$Scope(flags);
    }
    enter(flags) {
        this.scopeStack.push(this.createScope(flags));
    }
    exit() {
        const scope = this.scopeStack.pop();
        return scope.flags;
    }
    treatFunctionsAsVarInScope(scope) {
        return !!(scope.flags & 130 || !this.parser.inModule && scope.flags & 1);
    }
    declareName(name, bindingType, loc) {
        let scope = this.currentScope();
        if (bindingType & 8 || bindingType & 16) {
            this.checkRedeclarationInScope(scope, name, bindingType, loc);
            let type = scope.names.get(name) || 0;
            if (bindingType & 16) type = type | 4;
            else {
                if (!scope.firstLexicalName) scope.firstLexicalName = name;
                type = type | 2;
            }
            scope.names.set(name, type);
            if (bindingType & 8) this.maybeExportDefined(scope, name);
        } else if (bindingType & 4) for(let i = this.scopeStack.length - 1; i >= 0; --i){
            scope = this.scopeStack[i];
            this.checkRedeclarationInScope(scope, name, bindingType, loc);
            scope.names.set(name, (scope.names.get(name) || 0) | 1);
            this.maybeExportDefined(scope, name);
            if (scope.flags & 387) break;
        }
        if (this.parser.inModule && scope.flags & 1) this.undefinedExports.delete(name);
    }
    maybeExportDefined(scope, name) {
        if (this.parser.inModule && scope.flags & 1) this.undefinedExports.delete(name);
    }
    checkRedeclarationInScope(scope, name, bindingType, loc) {
        if (this.isRedeclaredInScope(scope, name, bindingType)) this.parser.raise($b48499974d50e8d0$var$Errors.VarRedeclaration, loc, {
            identifierName: name
        });
    }
    isRedeclaredInScope(scope, name, bindingType) {
        if (!(bindingType & 1)) return false;
        if (bindingType & 8) return scope.names.has(name);
        const type = scope.names.get(name);
        if (bindingType & 16) return (type & 2) > 0 || !this.treatFunctionsAsVarInScope(scope) && (type & 1) > 0;
        return (type & 2) > 0 && !(scope.flags & 8 && scope.firstLexicalName === name) || !this.treatFunctionsAsVarInScope(scope) && (type & 4) > 0;
    }
    checkLocalExport(id) {
        const { name: name } = id;
        const topLevelScope = this.scopeStack[0];
        if (!topLevelScope.names.has(name)) this.undefinedExports.set(name, id.loc.start);
    }
    currentScope() {
        return this.scopeStack[this.scopeStack.length - 1];
    }
    currentVarScopeFlags() {
        for(let i = this.scopeStack.length - 1;; i--){
            const { flags: flags } = this.scopeStack[i];
            if (flags & 387) return flags;
        }
    }
    currentThisScopeFlags() {
        for(let i = this.scopeStack.length - 1;; i--){
            const { flags: flags } = this.scopeStack[i];
            if (flags & 451 && !(flags & 4)) return flags;
        }
    }
}
class $b48499974d50e8d0$var$FlowScope extends $b48499974d50e8d0$var$Scope {
    constructor(...args){
        super(...args);
        this.declareFunctions = new Set();
    }
}
class $b48499974d50e8d0$var$FlowScopeHandler extends $b48499974d50e8d0$var$ScopeHandler {
    createScope(flags) {
        return new $b48499974d50e8d0$var$FlowScope(flags);
    }
    declareName(name, bindingType, loc) {
        const scope = this.currentScope();
        if (bindingType & 2048) {
            this.checkRedeclarationInScope(scope, name, bindingType, loc);
            this.maybeExportDefined(scope, name);
            scope.declareFunctions.add(name);
            return;
        }
        super.declareName(name, bindingType, loc);
    }
    isRedeclaredInScope(scope, name, bindingType) {
        if (super.isRedeclaredInScope(scope, name, bindingType)) return true;
        if (bindingType & 2048 && !scope.declareFunctions.has(name)) {
            const type = scope.names.get(name);
            return (type & 4) > 0 || (type & 2) > 0;
        }
        return false;
    }
    checkLocalExport(id) {
        if (!this.scopeStack[0].declareFunctions.has(id.name)) super.checkLocalExport(id);
    }
}
class $b48499974d50e8d0$var$BaseParser {
    constructor(){
        this.sawUnambiguousESM = false;
        this.ambiguousScriptDifferentAst = false;
    }
    hasPlugin(pluginConfig) {
        if (typeof pluginConfig === "string") return this.plugins.has(pluginConfig);
        else {
            const [pluginName, pluginOptions] = pluginConfig;
            if (!this.hasPlugin(pluginName)) return false;
            const actualOptions = this.plugins.get(pluginName);
            for (const key of Object.keys(pluginOptions)){
                if ((actualOptions == null ? void 0 : actualOptions[key]) !== pluginOptions[key]) return false;
            }
            return true;
        }
    }
    getPluginOption(plugin, name) {
        var _this$plugins$get;
        return (_this$plugins$get = this.plugins.get(plugin)) == null ? void 0 : _this$plugins$get[name];
    }
}
function $b48499974d50e8d0$var$setTrailingComments(node, comments) {
    if (node.trailingComments === undefined) node.trailingComments = comments;
    else node.trailingComments.unshift(...comments);
}
function $b48499974d50e8d0$var$setLeadingComments(node, comments) {
    if (node.leadingComments === undefined) node.leadingComments = comments;
    else node.leadingComments.unshift(...comments);
}
function $b48499974d50e8d0$var$setInnerComments(node, comments) {
    if (node.innerComments === undefined) node.innerComments = comments;
    else node.innerComments.unshift(...comments);
}
function $b48499974d50e8d0$var$adjustInnerComments(node, elements, commentWS) {
    let lastElement = null;
    let i = elements.length;
    while(lastElement === null && i > 0)lastElement = elements[--i];
    if (lastElement === null || lastElement.start > commentWS.start) $b48499974d50e8d0$var$setInnerComments(node, commentWS.comments);
    else $b48499974d50e8d0$var$setTrailingComments(lastElement, commentWS.comments);
}
class $b48499974d50e8d0$var$CommentsParser extends $b48499974d50e8d0$var$BaseParser {
    addComment(comment) {
        if (this.filename) comment.loc.filename = this.filename;
        const { commentsLen: commentsLen } = this.state;
        if (this.comments.length != commentsLen) this.comments.length = commentsLen;
        this.comments.push(comment);
        this.state.commentsLen++;
    }
    processComment(node) {
        const { commentStack: commentStack } = this.state;
        const commentStackLength = commentStack.length;
        if (commentStackLength === 0) return;
        let i = commentStackLength - 1;
        const lastCommentWS = commentStack[i];
        if (lastCommentWS.start === node.end) {
            lastCommentWS.leadingNode = node;
            i--;
        }
        const { start: nodeStart } = node;
        for(; i >= 0; i--){
            const commentWS = commentStack[i];
            const commentEnd = commentWS.end;
            if (commentEnd > nodeStart) {
                commentWS.containingNode = node;
                this.finalizeComment(commentWS);
                commentStack.splice(i, 1);
            } else {
                if (commentEnd === nodeStart) commentWS.trailingNode = node;
                break;
            }
        }
    }
    finalizeComment(commentWS) {
        const { comments: comments } = commentWS;
        if (commentWS.leadingNode !== null || commentWS.trailingNode !== null) {
            if (commentWS.leadingNode !== null) $b48499974d50e8d0$var$setTrailingComments(commentWS.leadingNode, comments);
            if (commentWS.trailingNode !== null) $b48499974d50e8d0$var$setLeadingComments(commentWS.trailingNode, comments);
        } else {
            const { containingNode: node, start: commentStart } = commentWS;
            if (this.input.charCodeAt(commentStart - 1) === 44) switch(node.type){
                case "ObjectExpression":
                case "ObjectPattern":
                case "RecordExpression":
                    $b48499974d50e8d0$var$adjustInnerComments(node, node.properties, commentWS);
                    break;
                case "CallExpression":
                case "OptionalCallExpression":
                    $b48499974d50e8d0$var$adjustInnerComments(node, node.arguments, commentWS);
                    break;
                case "FunctionDeclaration":
                case "FunctionExpression":
                case "ArrowFunctionExpression":
                case "ObjectMethod":
                case "ClassMethod":
                case "ClassPrivateMethod":
                    $b48499974d50e8d0$var$adjustInnerComments(node, node.params, commentWS);
                    break;
                case "ArrayExpression":
                case "ArrayPattern":
                case "TupleExpression":
                    $b48499974d50e8d0$var$adjustInnerComments(node, node.elements, commentWS);
                    break;
                case "ExportNamedDeclaration":
                case "ImportDeclaration":
                    $b48499974d50e8d0$var$adjustInnerComments(node, node.specifiers, commentWS);
                    break;
                default:
                    $b48499974d50e8d0$var$setInnerComments(node, comments);
            }
            else $b48499974d50e8d0$var$setInnerComments(node, comments);
        }
    }
    finalizeRemainingComments() {
        const { commentStack: commentStack } = this.state;
        for(let i = commentStack.length - 1; i >= 0; i--)this.finalizeComment(commentStack[i]);
        this.state.commentStack = [];
    }
    resetPreviousNodeTrailingComments(node) {
        const { commentStack: commentStack } = this.state;
        const { length: length } = commentStack;
        if (length === 0) return;
        const commentWS = commentStack[length - 1];
        if (commentWS.leadingNode === node) commentWS.leadingNode = null;
    }
    resetPreviousIdentifierLeadingComments(node) {
        const { commentStack: commentStack } = this.state;
        const { length: length } = commentStack;
        if (length === 0) return;
        if (commentStack[length - 1].trailingNode === node) commentStack[length - 1].trailingNode = null;
        else if (length >= 2 && commentStack[length - 2].trailingNode === node) commentStack[length - 2].trailingNode = null;
    }
    takeSurroundingComments(node, start, end) {
        const { commentStack: commentStack } = this.state;
        const commentStackLength = commentStack.length;
        if (commentStackLength === 0) return;
        let i = commentStackLength - 1;
        for(; i >= 0; i--){
            const commentWS = commentStack[i];
            const commentEnd = commentWS.end;
            const commentStart = commentWS.start;
            if (commentStart === end) commentWS.leadingNode = node;
            else if (commentEnd === start) commentWS.trailingNode = node;
            else if (commentEnd < start) break;
        }
    }
}
const $b48499974d50e8d0$var$lineBreak = /\r\n?|[\n\u2028\u2029]/;
const $b48499974d50e8d0$var$lineBreakG = new RegExp($b48499974d50e8d0$var$lineBreak.source, "g");
function $b48499974d50e8d0$var$isNewLine(code) {
    switch(code){
        case 10:
        case 13:
        case 8232:
        case 8233:
            return true;
        default:
            return false;
    }
}
const $b48499974d50e8d0$var$skipWhiteSpace = /(?:\s|\/\/.*|\/\*[^]*?\*\/)*/g;
const $b48499974d50e8d0$var$skipWhiteSpaceInLine = /(?:[^\S\n\r\u2028\u2029]|\/\/.*|\/\*.*?\*\/)*/g;
const $b48499974d50e8d0$var$skipWhiteSpaceToLineBreak = new RegExp("(?=(" + $b48499974d50e8d0$var$skipWhiteSpaceInLine.source + "))\\1" + /(?=[\n\r\u2028\u2029]|\/\*(?!.*?\*\/)|$)/.source, "y");
function $b48499974d50e8d0$var$isWhitespace(code) {
    switch(code){
        case 0x0009:
        case 0x000b:
        case 0x000c:
        case 32:
        case 160:
        case 5760:
        case 0x2000:
        case 0x2001:
        case 0x2002:
        case 0x2003:
        case 0x2004:
        case 0x2005:
        case 0x2006:
        case 0x2007:
        case 0x2008:
        case 0x2009:
        case 0x200a:
        case 0x202f:
        case 0x205f:
        case 0x3000:
        case 0xfeff:
            return true;
        default:
            return false;
    }
}
class $b48499974d50e8d0$var$State {
    constructor(){
        this.flags = 1024;
        this.curLine = void 0;
        this.lineStart = void 0;
        this.startLoc = void 0;
        this.endLoc = void 0;
        this.errors = [];
        this.potentialArrowAt = -1;
        this.noArrowAt = [];
        this.noArrowParamsConversionAt = [];
        this.topicContext = {
            maxNumOfResolvableTopics: 0,
            maxTopicIndex: null
        };
        this.labels = [];
        this.commentsLen = 0;
        this.commentStack = [];
        this.pos = 0;
        this.type = 139;
        this.value = null;
        this.start = 0;
        this.end = 0;
        this.lastTokEndLoc = null;
        this.lastTokStartLoc = null;
        this.context = [
            $b48499974d50e8d0$var$types.brace
        ];
        this.firstInvalidTemplateEscapePos = null;
        this.strictErrors = new Map();
        this.tokensLength = 0;
    }
    get strict() {
        return (this.flags & 1) > 0;
    }
    set strict(value) {
        if (value) this.flags |= 1;
        else this.flags &= -2;
    }
    init({ strictMode: strictMode, sourceType: sourceType, startLine: startLine, startColumn: startColumn }) {
        this.strict = strictMode === false ? false : strictMode === true ? true : sourceType === "module";
        this.curLine = startLine;
        this.lineStart = -startColumn;
        this.startLoc = this.endLoc = new $b48499974d50e8d0$var$Position(startLine, startColumn, 0);
    }
    get maybeInArrowParameters() {
        return (this.flags & 2) > 0;
    }
    set maybeInArrowParameters(value) {
        if (value) this.flags |= 2;
        else this.flags &= -3;
    }
    get inType() {
        return (this.flags & 4) > 0;
    }
    set inType(value) {
        if (value) this.flags |= 4;
        else this.flags &= -5;
    }
    get noAnonFunctionType() {
        return (this.flags & 8) > 0;
    }
    set noAnonFunctionType(value) {
        if (value) this.flags |= 8;
        else this.flags &= -9;
    }
    get hasFlowComment() {
        return (this.flags & 16) > 0;
    }
    set hasFlowComment(value) {
        if (value) this.flags |= 16;
        else this.flags &= -17;
    }
    get isAmbientContext() {
        return (this.flags & 32) > 0;
    }
    set isAmbientContext(value) {
        if (value) this.flags |= 32;
        else this.flags &= -33;
    }
    get inAbstractClass() {
        return (this.flags & 64) > 0;
    }
    set inAbstractClass(value) {
        if (value) this.flags |= 64;
        else this.flags &= -65;
    }
    get inDisallowConditionalTypesContext() {
        return (this.flags & 128) > 0;
    }
    set inDisallowConditionalTypesContext(value) {
        if (value) this.flags |= 128;
        else this.flags &= -129;
    }
    get soloAwait() {
        return (this.flags & 256) > 0;
    }
    set soloAwait(value) {
        if (value) this.flags |= 256;
        else this.flags &= -257;
    }
    get inFSharpPipelineDirectBody() {
        return (this.flags & 512) > 0;
    }
    set inFSharpPipelineDirectBody(value) {
        if (value) this.flags |= 512;
        else this.flags &= -513;
    }
    get canStartJSXElement() {
        return (this.flags & 1024) > 0;
    }
    set canStartJSXElement(value) {
        if (value) this.flags |= 1024;
        else this.flags &= -1025;
    }
    get containsEsc() {
        return (this.flags & 2048) > 0;
    }
    set containsEsc(value) {
        if (value) this.flags |= 2048;
        else this.flags &= -2049;
    }
    curPosition() {
        return new $b48499974d50e8d0$var$Position(this.curLine, this.pos - this.lineStart, this.pos);
    }
    clone() {
        const state = new $b48499974d50e8d0$var$State();
        state.flags = this.flags;
        state.curLine = this.curLine;
        state.lineStart = this.lineStart;
        state.startLoc = this.startLoc;
        state.endLoc = this.endLoc;
        state.errors = this.errors.slice();
        state.potentialArrowAt = this.potentialArrowAt;
        state.noArrowAt = this.noArrowAt.slice();
        state.noArrowParamsConversionAt = this.noArrowParamsConversionAt.slice();
        state.topicContext = this.topicContext;
        state.labels = this.labels.slice();
        state.commentsLen = this.commentsLen;
        state.commentStack = this.commentStack.slice();
        state.pos = this.pos;
        state.type = this.type;
        state.value = this.value;
        state.start = this.start;
        state.end = this.end;
        state.lastTokEndLoc = this.lastTokEndLoc;
        state.lastTokStartLoc = this.lastTokStartLoc;
        state.context = this.context.slice();
        state.firstInvalidTemplateEscapePos = this.firstInvalidTemplateEscapePos;
        state.strictErrors = this.strictErrors;
        state.tokensLength = this.tokensLength;
        return state;
    }
}
var $b48499974d50e8d0$var$_isDigit = function isDigit(code) {
    return code >= 48 && code <= 57;
};
const $b48499974d50e8d0$var$forbiddenNumericSeparatorSiblings = {
    decBinOct: new Set([
        46,
        66,
        69,
        79,
        95,
        98,
        101,
        111
    ]),
    hex: new Set([
        46,
        88,
        95,
        120
    ])
};
const $b48499974d50e8d0$var$isAllowedNumericSeparatorSibling = {
    bin: (ch)=>ch === 48 || ch === 49,
    oct: (ch)=>ch >= 48 && ch <= 55,
    dec: (ch)=>ch >= 48 && ch <= 57,
    hex: (ch)=>ch >= 48 && ch <= 57 || ch >= 65 && ch <= 70 || ch >= 97 && ch <= 102
};
function $b48499974d50e8d0$var$readStringContents(type, input, pos, lineStart, curLine, errors) {
    const initialPos = pos;
    const initialLineStart = lineStart;
    const initialCurLine = curLine;
    let out = "";
    let firstInvalidLoc = null;
    let chunkStart = pos;
    const { length: length } = input;
    for(;;){
        if (pos >= length) {
            errors.unterminated(initialPos, initialLineStart, initialCurLine);
            out += input.slice(chunkStart, pos);
            break;
        }
        const ch = input.charCodeAt(pos);
        if ($b48499974d50e8d0$var$isStringEnd(type, ch, input, pos)) {
            out += input.slice(chunkStart, pos);
            break;
        }
        if (ch === 92) {
            out += input.slice(chunkStart, pos);
            const res = $b48499974d50e8d0$var$readEscapedChar(input, pos, lineStart, curLine, type === "template", errors);
            if (res.ch === null && !firstInvalidLoc) firstInvalidLoc = {
                pos: pos,
                lineStart: lineStart,
                curLine: curLine
            };
            else out += res.ch;
            ({ pos: pos, lineStart: lineStart, curLine: curLine } = res);
            chunkStart = pos;
        } else if (ch === 8232 || ch === 8233) {
            ++pos;
            ++curLine;
            lineStart = pos;
        } else if (ch === 10 || ch === 13) {
            if (type === "template") {
                out += input.slice(chunkStart, pos) + "\n";
                ++pos;
                if (ch === 13 && input.charCodeAt(pos) === 10) ++pos;
                ++curLine;
                chunkStart = lineStart = pos;
            } else errors.unterminated(initialPos, initialLineStart, initialCurLine);
        } else ++pos;
    }
    return {
        pos: pos,
        str: out,
        firstInvalidLoc: firstInvalidLoc,
        lineStart: lineStart,
        curLine: curLine,
        containsInvalid: !!firstInvalidLoc
    };
}
function $b48499974d50e8d0$var$isStringEnd(type, ch, input, pos) {
    if (type === "template") return ch === 96 || ch === 36 && input.charCodeAt(pos + 1) === 123;
    return ch === (type === "double" ? 34 : 39);
}
function $b48499974d50e8d0$var$readEscapedChar(input, pos, lineStart, curLine, inTemplate, errors) {
    const throwOnInvalid = !inTemplate;
    pos++;
    const res = (ch)=>({
            pos: pos,
            ch: ch,
            lineStart: lineStart,
            curLine: curLine
        });
    const ch = input.charCodeAt(pos++);
    switch(ch){
        case 110:
            return res("\n");
        case 114:
            return res("\r");
        case 120:
            {
                let code;
                ({ code: code, pos: pos } = $b48499974d50e8d0$var$readHexChar(input, pos, lineStart, curLine, 2, false, throwOnInvalid, errors));
                return res(code === null ? null : String.fromCharCode(code));
            }
        case 117:
            {
                let code;
                ({ code: code, pos: pos } = $b48499974d50e8d0$var$readCodePoint(input, pos, lineStart, curLine, throwOnInvalid, errors));
                return res(code === null ? null : String.fromCodePoint(code));
            }
        case 116:
            return res("	");
        case 98:
            return res("\b");
        case 118:
            return res("\v");
        case 102:
            return res("\f");
        case 13:
            if (input.charCodeAt(pos) === 10) ++pos;
        case 10:
            lineStart = pos;
            ++curLine;
        case 8232:
        case 8233:
            return res("");
        case 56:
        case 57:
            if (inTemplate) return res(null);
            else errors.strictNumericEscape(pos - 1, lineStart, curLine);
        default:
            if (ch >= 48 && ch <= 55) {
                const startPos = pos - 1;
                const match = input.slice(startPos, pos + 2).match(/^[0-7]+/);
                let octalStr = match[0];
                let octal = parseInt(octalStr, 8);
                if (octal > 255) {
                    octalStr = octalStr.slice(0, -1);
                    octal = parseInt(octalStr, 8);
                }
                pos += octalStr.length - 1;
                const next = input.charCodeAt(pos);
                if (octalStr !== "0" || next === 56 || next === 57) {
                    if (inTemplate) return res(null);
                    else errors.strictNumericEscape(startPos, lineStart, curLine);
                }
                return res(String.fromCharCode(octal));
            }
            return res(String.fromCharCode(ch));
    }
}
function $b48499974d50e8d0$var$readHexChar(input, pos, lineStart, curLine, len, forceLen, throwOnInvalid, errors) {
    const initialPos = pos;
    let n;
    ({ n: n, pos: pos } = $b48499974d50e8d0$var$readInt(input, pos, lineStart, curLine, 16, len, forceLen, false, errors, !throwOnInvalid));
    if (n === null) {
        if (throwOnInvalid) errors.invalidEscapeSequence(initialPos, lineStart, curLine);
        else pos = initialPos - 1;
    }
    return {
        code: n,
        pos: pos
    };
}
function $b48499974d50e8d0$var$readInt(input, pos, lineStart, curLine, radix, len, forceLen, allowNumSeparator, errors, bailOnError) {
    const start = pos;
    const forbiddenSiblings = radix === 16 ? $b48499974d50e8d0$var$forbiddenNumericSeparatorSiblings.hex : $b48499974d50e8d0$var$forbiddenNumericSeparatorSiblings.decBinOct;
    const isAllowedSibling = radix === 16 ? $b48499974d50e8d0$var$isAllowedNumericSeparatorSibling.hex : radix === 10 ? $b48499974d50e8d0$var$isAllowedNumericSeparatorSibling.dec : radix === 8 ? $b48499974d50e8d0$var$isAllowedNumericSeparatorSibling.oct : $b48499974d50e8d0$var$isAllowedNumericSeparatorSibling.bin;
    let invalid = false;
    let total = 0;
    for(let i = 0, e = len == null ? Infinity : len; i < e; ++i){
        const code = input.charCodeAt(pos);
        let val;
        if (code === 95 && allowNumSeparator !== "bail") {
            const prev = input.charCodeAt(pos - 1);
            const next = input.charCodeAt(pos + 1);
            if (!allowNumSeparator) {
                if (bailOnError) return {
                    n: null,
                    pos: pos
                };
                errors.numericSeparatorInEscapeSequence(pos, lineStart, curLine);
            } else if (Number.isNaN(next) || !isAllowedSibling(next) || forbiddenSiblings.has(prev) || forbiddenSiblings.has(next)) {
                if (bailOnError) return {
                    n: null,
                    pos: pos
                };
                errors.unexpectedNumericSeparator(pos, lineStart, curLine);
            }
            ++pos;
            continue;
        }
        if (code >= 97) val = code - 97 + 10;
        else if (code >= 65) val = code - 65 + 10;
        else if ($b48499974d50e8d0$var$_isDigit(code)) val = code - 48;
        else val = Infinity;
        if (val >= radix) {
            if (val <= 9 && bailOnError) return {
                n: null,
                pos: pos
            };
            else if (val <= 9 && errors.invalidDigit(pos, lineStart, curLine, radix)) val = 0;
            else if (forceLen) {
                val = 0;
                invalid = true;
            } else break;
        }
        ++pos;
        total = total * radix + val;
    }
    if (pos === start || len != null && pos - start !== len || invalid) return {
        n: null,
        pos: pos
    };
    return {
        n: total,
        pos: pos
    };
}
function $b48499974d50e8d0$var$readCodePoint(input, pos, lineStart, curLine, throwOnInvalid, errors) {
    const ch = input.charCodeAt(pos);
    let code;
    if (ch === 123) {
        ++pos;
        ({ code: code, pos: pos } = $b48499974d50e8d0$var$readHexChar(input, pos, lineStart, curLine, input.indexOf("}", pos) - pos, true, throwOnInvalid, errors));
        ++pos;
        if (code !== null && code > 0x10ffff) {
            if (throwOnInvalid) errors.invalidCodePoint(pos, lineStart, curLine);
            else return {
                code: null,
                pos: pos
            };
        }
    } else ({ code: code, pos: pos } = $b48499974d50e8d0$var$readHexChar(input, pos, lineStart, curLine, 4, false, throwOnInvalid, errors));
    return {
        code: code,
        pos: pos
    };
}
function $b48499974d50e8d0$var$buildPosition(pos, lineStart, curLine) {
    return new $b48499974d50e8d0$var$Position(curLine, pos - lineStart, pos);
}
const $b48499974d50e8d0$var$VALID_REGEX_FLAGS = new Set([
    103,
    109,
    115,
    105,
    121,
    117,
    100,
    118
]);
class $b48499974d50e8d0$var$Token {
    constructor(state){
        this.type = state.type;
        this.value = state.value;
        this.start = state.start;
        this.end = state.end;
        this.loc = new $b48499974d50e8d0$var$SourceLocation(state.startLoc, state.endLoc);
    }
}
class $b48499974d50e8d0$var$Tokenizer extends $b48499974d50e8d0$var$CommentsParser {
    constructor(options, input){
        super();
        this.isLookahead = void 0;
        this.tokens = [];
        this.errorHandlers_readInt = {
            invalidDigit: (pos, lineStart, curLine, radix)=>{
                if (!this.options.errorRecovery) return false;
                this.raise($b48499974d50e8d0$var$Errors.InvalidDigit, $b48499974d50e8d0$var$buildPosition(pos, lineStart, curLine), {
                    radix: radix
                });
                return true;
            },
            numericSeparatorInEscapeSequence: this.errorBuilder($b48499974d50e8d0$var$Errors.NumericSeparatorInEscapeSequence),
            unexpectedNumericSeparator: this.errorBuilder($b48499974d50e8d0$var$Errors.UnexpectedNumericSeparator)
        };
        this.errorHandlers_readCodePoint = Object.assign({}, this.errorHandlers_readInt, {
            invalidEscapeSequence: this.errorBuilder($b48499974d50e8d0$var$Errors.InvalidEscapeSequence),
            invalidCodePoint: this.errorBuilder($b48499974d50e8d0$var$Errors.InvalidCodePoint)
        });
        this.errorHandlers_readStringContents_string = Object.assign({}, this.errorHandlers_readCodePoint, {
            strictNumericEscape: (pos, lineStart, curLine)=>{
                this.recordStrictModeErrors($b48499974d50e8d0$var$Errors.StrictNumericEscape, $b48499974d50e8d0$var$buildPosition(pos, lineStart, curLine));
            },
            unterminated: (pos, lineStart, curLine)=>{
                throw this.raise($b48499974d50e8d0$var$Errors.UnterminatedString, $b48499974d50e8d0$var$buildPosition(pos - 1, lineStart, curLine));
            }
        });
        this.errorHandlers_readStringContents_template = Object.assign({}, this.errorHandlers_readCodePoint, {
            strictNumericEscape: this.errorBuilder($b48499974d50e8d0$var$Errors.StrictNumericEscape),
            unterminated: (pos, lineStart, curLine)=>{
                throw this.raise($b48499974d50e8d0$var$Errors.UnterminatedTemplate, $b48499974d50e8d0$var$buildPosition(pos, lineStart, curLine));
            }
        });
        this.state = new $b48499974d50e8d0$var$State();
        this.state.init(options);
        this.input = input;
        this.length = input.length;
        this.comments = [];
        this.isLookahead = false;
    }
    pushToken(token) {
        this.tokens.length = this.state.tokensLength;
        this.tokens.push(token);
        ++this.state.tokensLength;
    }
    next() {
        this.checkKeywordEscapes();
        if (this.options.tokens) this.pushToken(new $b48499974d50e8d0$var$Token(this.state));
        this.state.lastTokEndLoc = this.state.endLoc;
        this.state.lastTokStartLoc = this.state.startLoc;
        this.nextToken();
    }
    eat(type) {
        if (this.match(type)) {
            this.next();
            return true;
        } else return false;
    }
    match(type) {
        return this.state.type === type;
    }
    createLookaheadState(state) {
        return {
            pos: state.pos,
            value: null,
            type: state.type,
            start: state.start,
            end: state.end,
            context: [
                this.curContext()
            ],
            inType: state.inType,
            startLoc: state.startLoc,
            lastTokEndLoc: state.lastTokEndLoc,
            curLine: state.curLine,
            lineStart: state.lineStart,
            curPosition: state.curPosition
        };
    }
    lookahead() {
        const old = this.state;
        this.state = this.createLookaheadState(old);
        this.isLookahead = true;
        this.nextToken();
        this.isLookahead = false;
        const curr = this.state;
        this.state = old;
        return curr;
    }
    nextTokenStart() {
        return this.nextTokenStartSince(this.state.pos);
    }
    nextTokenStartSince(pos) {
        $b48499974d50e8d0$var$skipWhiteSpace.lastIndex = pos;
        return $b48499974d50e8d0$var$skipWhiteSpace.test(this.input) ? $b48499974d50e8d0$var$skipWhiteSpace.lastIndex : pos;
    }
    lookaheadCharCode() {
        return this.input.charCodeAt(this.nextTokenStart());
    }
    nextTokenInLineStart() {
        return this.nextTokenInLineStartSince(this.state.pos);
    }
    nextTokenInLineStartSince(pos) {
        $b48499974d50e8d0$var$skipWhiteSpaceInLine.lastIndex = pos;
        return $b48499974d50e8d0$var$skipWhiteSpaceInLine.test(this.input) ? $b48499974d50e8d0$var$skipWhiteSpaceInLine.lastIndex : pos;
    }
    lookaheadInLineCharCode() {
        return this.input.charCodeAt(this.nextTokenInLineStart());
    }
    codePointAtPos(pos) {
        let cp = this.input.charCodeAt(pos);
        if ((cp & 0xfc00) === 0xd800 && ++pos < this.input.length) {
            const trail = this.input.charCodeAt(pos);
            if ((trail & 0xfc00) === 0xdc00) cp = 0x10000 + ((cp & 0x3ff) << 10) + (trail & 0x3ff);
        }
        return cp;
    }
    setStrict(strict) {
        this.state.strict = strict;
        if (strict) {
            this.state.strictErrors.forEach(([toParseError, at])=>this.raise(toParseError, at));
            this.state.strictErrors.clear();
        }
    }
    curContext() {
        return this.state.context[this.state.context.length - 1];
    }
    nextToken() {
        this.skipSpace();
        this.state.start = this.state.pos;
        if (!this.isLookahead) this.state.startLoc = this.state.curPosition();
        if (this.state.pos >= this.length) {
            this.finishToken(139);
            return;
        }
        this.getTokenFromCode(this.codePointAtPos(this.state.pos));
    }
    skipBlockComment(commentEnd) {
        let startLoc;
        if (!this.isLookahead) startLoc = this.state.curPosition();
        const start = this.state.pos;
        const end = this.input.indexOf(commentEnd, start + 2);
        if (end === -1) throw this.raise($b48499974d50e8d0$var$Errors.UnterminatedComment, this.state.curPosition());
        this.state.pos = end + commentEnd.length;
        $b48499974d50e8d0$var$lineBreakG.lastIndex = start + 2;
        while($b48499974d50e8d0$var$lineBreakG.test(this.input) && $b48499974d50e8d0$var$lineBreakG.lastIndex <= end){
            ++this.state.curLine;
            this.state.lineStart = $b48499974d50e8d0$var$lineBreakG.lastIndex;
        }
        if (this.isLookahead) return;
        const comment = {
            type: "CommentBlock",
            value: this.input.slice(start + 2, end),
            start: start,
            end: end + commentEnd.length,
            loc: new $b48499974d50e8d0$var$SourceLocation(startLoc, this.state.curPosition())
        };
        if (this.options.tokens) this.pushToken(comment);
        return comment;
    }
    skipLineComment(startSkip) {
        const start = this.state.pos;
        let startLoc;
        if (!this.isLookahead) startLoc = this.state.curPosition();
        let ch = this.input.charCodeAt(this.state.pos += startSkip);
        if (this.state.pos < this.length) while(!$b48499974d50e8d0$var$isNewLine(ch) && ++this.state.pos < this.length)ch = this.input.charCodeAt(this.state.pos);
        if (this.isLookahead) return;
        const end = this.state.pos;
        const value = this.input.slice(start + startSkip, end);
        const comment = {
            type: "CommentLine",
            value: value,
            start: start,
            end: end,
            loc: new $b48499974d50e8d0$var$SourceLocation(startLoc, this.state.curPosition())
        };
        if (this.options.tokens) this.pushToken(comment);
        return comment;
    }
    skipSpace() {
        const spaceStart = this.state.pos;
        const comments = [];
        loop: while(this.state.pos < this.length){
            const ch = this.input.charCodeAt(this.state.pos);
            switch(ch){
                case 32:
                case 160:
                case 9:
                    ++this.state.pos;
                    break;
                case 13:
                    if (this.input.charCodeAt(this.state.pos + 1) === 10) ++this.state.pos;
                case 10:
                case 8232:
                case 8233:
                    ++this.state.pos;
                    ++this.state.curLine;
                    this.state.lineStart = this.state.pos;
                    break;
                case 47:
                    switch(this.input.charCodeAt(this.state.pos + 1)){
                        case 42:
                            {
                                const comment = this.skipBlockComment("*/");
                                if (comment !== undefined) {
                                    this.addComment(comment);
                                    if (this.options.attachComment) comments.push(comment);
                                }
                                break;
                            }
                        case 47:
                            {
                                const comment = this.skipLineComment(2);
                                if (comment !== undefined) {
                                    this.addComment(comment);
                                    if (this.options.attachComment) comments.push(comment);
                                }
                                break;
                            }
                        default:
                            break loop;
                    }
                    break;
                default:
                    if ($b48499974d50e8d0$var$isWhitespace(ch)) ++this.state.pos;
                    else if (ch === 45 && !this.inModule && this.options.annexB) {
                        const pos = this.state.pos;
                        if (this.input.charCodeAt(pos + 1) === 45 && this.input.charCodeAt(pos + 2) === 62 && (spaceStart === 0 || this.state.lineStart > spaceStart)) {
                            const comment = this.skipLineComment(3);
                            if (comment !== undefined) {
                                this.addComment(comment);
                                if (this.options.attachComment) comments.push(comment);
                            }
                        } else break loop;
                    } else if (ch === 60 && !this.inModule && this.options.annexB) {
                        const pos = this.state.pos;
                        if (this.input.charCodeAt(pos + 1) === 33 && this.input.charCodeAt(pos + 2) === 45 && this.input.charCodeAt(pos + 3) === 45) {
                            const comment = this.skipLineComment(4);
                            if (comment !== undefined) {
                                this.addComment(comment);
                                if (this.options.attachComment) comments.push(comment);
                            }
                        } else break loop;
                    } else break loop;
            }
        }
        if (comments.length > 0) {
            const end = this.state.pos;
            const commentWhitespace = {
                start: spaceStart,
                end: end,
                comments: comments,
                leadingNode: null,
                trailingNode: null,
                containingNode: null
            };
            this.state.commentStack.push(commentWhitespace);
        }
    }
    finishToken(type, val) {
        this.state.end = this.state.pos;
        this.state.endLoc = this.state.curPosition();
        const prevType = this.state.type;
        this.state.type = type;
        this.state.value = val;
        if (!this.isLookahead) this.updateContext(prevType);
    }
    replaceToken(type) {
        this.state.type = type;
        this.updateContext();
    }
    readToken_numberSign() {
        if (this.state.pos === 0 && this.readToken_interpreter()) return;
        const nextPos = this.state.pos + 1;
        const next = this.codePointAtPos(nextPos);
        if (next >= 48 && next <= 57) throw this.raise($b48499974d50e8d0$var$Errors.UnexpectedDigitAfterHash, this.state.curPosition());
        if (next === 123 || next === 91 && this.hasPlugin("recordAndTuple")) {
            this.expectPlugin("recordAndTuple");
            if (this.getPluginOption("recordAndTuple", "syntaxType") === "bar") throw this.raise(next === 123 ? $b48499974d50e8d0$var$Errors.RecordExpressionHashIncorrectStartSyntaxType : $b48499974d50e8d0$var$Errors.TupleExpressionHashIncorrectStartSyntaxType, this.state.curPosition());
            this.state.pos += 2;
            if (next === 123) this.finishToken(7);
            else this.finishToken(1);
        } else if ($b48499974d50e8d0$var$isIdentifierStart(next)) {
            ++this.state.pos;
            this.finishToken(138, this.readWord1(next));
        } else if (next === 92) {
            ++this.state.pos;
            this.finishToken(138, this.readWord1());
        } else this.finishOp(27, 1);
    }
    readToken_dot() {
        const next = this.input.charCodeAt(this.state.pos + 1);
        if (next >= 48 && next <= 57) {
            this.readNumber(true);
            return;
        }
        if (next === 46 && this.input.charCodeAt(this.state.pos + 2) === 46) {
            this.state.pos += 3;
            this.finishToken(21);
        } else {
            ++this.state.pos;
            this.finishToken(16);
        }
    }
    readToken_slash() {
        const next = this.input.charCodeAt(this.state.pos + 1);
        if (next === 61) this.finishOp(31, 2);
        else this.finishOp(56, 1);
    }
    readToken_interpreter() {
        if (this.state.pos !== 0 || this.length < 2) return false;
        let ch = this.input.charCodeAt(this.state.pos + 1);
        if (ch !== 33) return false;
        const start = this.state.pos;
        this.state.pos += 1;
        while(!$b48499974d50e8d0$var$isNewLine(ch) && ++this.state.pos < this.length)ch = this.input.charCodeAt(this.state.pos);
        const value = this.input.slice(start + 2, this.state.pos);
        this.finishToken(28, value);
        return true;
    }
    readToken_mult_modulo(code) {
        let type = code === 42 ? 55 : 54;
        let width = 1;
        let next = this.input.charCodeAt(this.state.pos + 1);
        if (code === 42 && next === 42) {
            width++;
            next = this.input.charCodeAt(this.state.pos + 2);
            type = 57;
        }
        if (next === 61 && !this.state.inType) {
            width++;
            type = code === 37 ? 33 : 30;
        }
        this.finishOp(type, width);
    }
    readToken_pipe_amp(code) {
        const next = this.input.charCodeAt(this.state.pos + 1);
        if (next === code) {
            if (this.input.charCodeAt(this.state.pos + 2) === 61) this.finishOp(30, 3);
            else this.finishOp(code === 124 ? 41 : 42, 2);
            return;
        }
        if (code === 124) {
            if (next === 62) {
                this.finishOp(39, 2);
                return;
            }
            if (this.hasPlugin("recordAndTuple") && next === 125) {
                if (this.getPluginOption("recordAndTuple", "syntaxType") !== "bar") throw this.raise($b48499974d50e8d0$var$Errors.RecordExpressionBarIncorrectEndSyntaxType, this.state.curPosition());
                this.state.pos += 2;
                this.finishToken(9);
                return;
            }
            if (this.hasPlugin("recordAndTuple") && next === 93) {
                if (this.getPluginOption("recordAndTuple", "syntaxType") !== "bar") throw this.raise($b48499974d50e8d0$var$Errors.TupleExpressionBarIncorrectEndSyntaxType, this.state.curPosition());
                this.state.pos += 2;
                this.finishToken(4);
                return;
            }
        }
        if (next === 61) {
            this.finishOp(30, 2);
            return;
        }
        this.finishOp(code === 124 ? 43 : 45, 1);
    }
    readToken_caret() {
        const next = this.input.charCodeAt(this.state.pos + 1);
        if (next === 61 && !this.state.inType) this.finishOp(32, 2);
        else if (next === 94 && this.hasPlugin([
            "pipelineOperator",
            {
                proposal: "hack",
                topicToken: "^^"
            }
        ])) {
            this.finishOp(37, 2);
            const lookaheadCh = this.input.codePointAt(this.state.pos);
            if (lookaheadCh === 94) this.unexpected();
        } else this.finishOp(44, 1);
    }
    readToken_atSign() {
        const next = this.input.charCodeAt(this.state.pos + 1);
        if (next === 64 && this.hasPlugin([
            "pipelineOperator",
            {
                proposal: "hack",
                topicToken: "@@"
            }
        ])) this.finishOp(38, 2);
        else this.finishOp(26, 1);
    }
    readToken_plus_min(code) {
        const next = this.input.charCodeAt(this.state.pos + 1);
        if (next === code) {
            this.finishOp(34, 2);
            return;
        }
        if (next === 61) this.finishOp(30, 2);
        else this.finishOp(53, 1);
    }
    readToken_lt() {
        const { pos: pos } = this.state;
        const next = this.input.charCodeAt(pos + 1);
        if (next === 60) {
            if (this.input.charCodeAt(pos + 2) === 61) {
                this.finishOp(30, 3);
                return;
            }
            this.finishOp(51, 2);
            return;
        }
        if (next === 61) {
            this.finishOp(49, 2);
            return;
        }
        this.finishOp(47, 1);
    }
    readToken_gt() {
        const { pos: pos } = this.state;
        const next = this.input.charCodeAt(pos + 1);
        if (next === 62) {
            const size = this.input.charCodeAt(pos + 2) === 62 ? 3 : 2;
            if (this.input.charCodeAt(pos + size) === 61) {
                this.finishOp(30, size + 1);
                return;
            }
            this.finishOp(52, size);
            return;
        }
        if (next === 61) {
            this.finishOp(49, 2);
            return;
        }
        this.finishOp(48, 1);
    }
    readToken_eq_excl(code) {
        const next = this.input.charCodeAt(this.state.pos + 1);
        if (next === 61) {
            this.finishOp(46, this.input.charCodeAt(this.state.pos + 2) === 61 ? 3 : 2);
            return;
        }
        if (code === 61 && next === 62) {
            this.state.pos += 2;
            this.finishToken(19);
            return;
        }
        this.finishOp(code === 61 ? 29 : 35, 1);
    }
    readToken_question() {
        const next = this.input.charCodeAt(this.state.pos + 1);
        const next2 = this.input.charCodeAt(this.state.pos + 2);
        if (next === 63) {
            if (next2 === 61) this.finishOp(30, 3);
            else this.finishOp(40, 2);
        } else if (next === 46 && !(next2 >= 48 && next2 <= 57)) {
            this.state.pos += 2;
            this.finishToken(18);
        } else {
            ++this.state.pos;
            this.finishToken(17);
        }
    }
    getTokenFromCode(code) {
        switch(code){
            case 46:
                this.readToken_dot();
                return;
            case 40:
                ++this.state.pos;
                this.finishToken(10);
                return;
            case 41:
                ++this.state.pos;
                this.finishToken(11);
                return;
            case 59:
                ++this.state.pos;
                this.finishToken(13);
                return;
            case 44:
                ++this.state.pos;
                this.finishToken(12);
                return;
            case 91:
                if (this.hasPlugin("recordAndTuple") && this.input.charCodeAt(this.state.pos + 1) === 124) {
                    if (this.getPluginOption("recordAndTuple", "syntaxType") !== "bar") throw this.raise($b48499974d50e8d0$var$Errors.TupleExpressionBarIncorrectStartSyntaxType, this.state.curPosition());
                    this.state.pos += 2;
                    this.finishToken(2);
                } else {
                    ++this.state.pos;
                    this.finishToken(0);
                }
                return;
            case 93:
                ++this.state.pos;
                this.finishToken(3);
                return;
            case 123:
                if (this.hasPlugin("recordAndTuple") && this.input.charCodeAt(this.state.pos + 1) === 124) {
                    if (this.getPluginOption("recordAndTuple", "syntaxType") !== "bar") throw this.raise($b48499974d50e8d0$var$Errors.RecordExpressionBarIncorrectStartSyntaxType, this.state.curPosition());
                    this.state.pos += 2;
                    this.finishToken(6);
                } else {
                    ++this.state.pos;
                    this.finishToken(5);
                }
                return;
            case 125:
                ++this.state.pos;
                this.finishToken(8);
                return;
            case 58:
                if (this.hasPlugin("functionBind") && this.input.charCodeAt(this.state.pos + 1) === 58) this.finishOp(15, 2);
                else {
                    ++this.state.pos;
                    this.finishToken(14);
                }
                return;
            case 63:
                this.readToken_question();
                return;
            case 96:
                this.readTemplateToken();
                return;
            case 48:
                {
                    const next = this.input.charCodeAt(this.state.pos + 1);
                    if (next === 120 || next === 88) {
                        this.readRadixNumber(16);
                        return;
                    }
                    if (next === 111 || next === 79) {
                        this.readRadixNumber(8);
                        return;
                    }
                    if (next === 98 || next === 66) {
                        this.readRadixNumber(2);
                        return;
                    }
                }
            case 49:
            case 50:
            case 51:
            case 52:
            case 53:
            case 54:
            case 55:
            case 56:
            case 57:
                this.readNumber(false);
                return;
            case 34:
            case 39:
                this.readString(code);
                return;
            case 47:
                this.readToken_slash();
                return;
            case 37:
            case 42:
                this.readToken_mult_modulo(code);
                return;
            case 124:
            case 38:
                this.readToken_pipe_amp(code);
                return;
            case 94:
                this.readToken_caret();
                return;
            case 43:
            case 45:
                this.readToken_plus_min(code);
                return;
            case 60:
                this.readToken_lt();
                return;
            case 62:
                this.readToken_gt();
                return;
            case 61:
            case 33:
                this.readToken_eq_excl(code);
                return;
            case 126:
                this.finishOp(36, 1);
                return;
            case 64:
                this.readToken_atSign();
                return;
            case 35:
                this.readToken_numberSign();
                return;
            case 92:
                this.readWord();
                return;
            default:
                if ($b48499974d50e8d0$var$isIdentifierStart(code)) {
                    this.readWord(code);
                    return;
                }
        }
        throw this.raise($b48499974d50e8d0$var$Errors.InvalidOrUnexpectedToken, this.state.curPosition(), {
            unexpected: String.fromCodePoint(code)
        });
    }
    finishOp(type, size) {
        const str = this.input.slice(this.state.pos, this.state.pos + size);
        this.state.pos += size;
        this.finishToken(type, str);
    }
    readRegexp() {
        const startLoc = this.state.startLoc;
        const start = this.state.start + 1;
        let escaped, inClass;
        let { pos: pos } = this.state;
        for(;; ++pos){
            if (pos >= this.length) throw this.raise($b48499974d50e8d0$var$Errors.UnterminatedRegExp, $b48499974d50e8d0$var$createPositionWithColumnOffset(startLoc, 1));
            const ch = this.input.charCodeAt(pos);
            if ($b48499974d50e8d0$var$isNewLine(ch)) throw this.raise($b48499974d50e8d0$var$Errors.UnterminatedRegExp, $b48499974d50e8d0$var$createPositionWithColumnOffset(startLoc, 1));
            if (escaped) escaped = false;
            else {
                if (ch === 91) inClass = true;
                else if (ch === 93 && inClass) inClass = false;
                else if (ch === 47 && !inClass) break;
                escaped = ch === 92;
            }
        }
        const content = this.input.slice(start, pos);
        ++pos;
        let mods = "";
        const nextPos = ()=>$b48499974d50e8d0$var$createPositionWithColumnOffset(startLoc, pos + 2 - start);
        while(pos < this.length){
            const cp = this.codePointAtPos(pos);
            const char = String.fromCharCode(cp);
            if ($b48499974d50e8d0$var$VALID_REGEX_FLAGS.has(cp)) {
                if (cp === 118) {
                    if (mods.includes("u")) this.raise($b48499974d50e8d0$var$Errors.IncompatibleRegExpUVFlags, nextPos());
                } else if (cp === 117) {
                    if (mods.includes("v")) this.raise($b48499974d50e8d0$var$Errors.IncompatibleRegExpUVFlags, nextPos());
                }
                if (mods.includes(char)) this.raise($b48499974d50e8d0$var$Errors.DuplicateRegExpFlags, nextPos());
            } else if ($b48499974d50e8d0$var$isIdentifierChar(cp) || cp === 92) this.raise($b48499974d50e8d0$var$Errors.MalformedRegExpFlags, nextPos());
            else break;
            ++pos;
            mods += char;
        }
        this.state.pos = pos;
        this.finishToken(137, {
            pattern: content,
            flags: mods
        });
    }
    readInt(radix, len, forceLen = false, allowNumSeparator = true) {
        const { n: n, pos: pos } = $b48499974d50e8d0$var$readInt(this.input, this.state.pos, this.state.lineStart, this.state.curLine, radix, len, forceLen, allowNumSeparator, this.errorHandlers_readInt, false);
        this.state.pos = pos;
        return n;
    }
    readRadixNumber(radix) {
        const startLoc = this.state.curPosition();
        let isBigInt = false;
        this.state.pos += 2;
        const val = this.readInt(radix);
        if (val == null) this.raise($b48499974d50e8d0$var$Errors.InvalidDigit, $b48499974d50e8d0$var$createPositionWithColumnOffset(startLoc, 2), {
            radix: radix
        });
        const next = this.input.charCodeAt(this.state.pos);
        if (next === 110) {
            ++this.state.pos;
            isBigInt = true;
        } else if (next === 109) throw this.raise($b48499974d50e8d0$var$Errors.InvalidDecimal, startLoc);
        if ($b48499974d50e8d0$var$isIdentifierStart(this.codePointAtPos(this.state.pos))) throw this.raise($b48499974d50e8d0$var$Errors.NumberIdentifier, this.state.curPosition());
        if (isBigInt) {
            const str = this.input.slice(startLoc.index, this.state.pos).replace(/[_n]/g, "");
            this.finishToken(135, str);
            return;
        }
        this.finishToken(134, val);
    }
    readNumber(startsWithDot) {
        const start = this.state.pos;
        const startLoc = this.state.curPosition();
        let isFloat = false;
        let isBigInt = false;
        let isDecimal = false;
        let hasExponent = false;
        let isOctal = false;
        if (!startsWithDot && this.readInt(10) === null) this.raise($b48499974d50e8d0$var$Errors.InvalidNumber, this.state.curPosition());
        const hasLeadingZero = this.state.pos - start >= 2 && this.input.charCodeAt(start) === 48;
        if (hasLeadingZero) {
            const integer = this.input.slice(start, this.state.pos);
            this.recordStrictModeErrors($b48499974d50e8d0$var$Errors.StrictOctalLiteral, startLoc);
            if (!this.state.strict) {
                const underscorePos = integer.indexOf("_");
                if (underscorePos > 0) this.raise($b48499974d50e8d0$var$Errors.ZeroDigitNumericSeparator, $b48499974d50e8d0$var$createPositionWithColumnOffset(startLoc, underscorePos));
            }
            isOctal = hasLeadingZero && !/[89]/.test(integer);
        }
        let next = this.input.charCodeAt(this.state.pos);
        if (next === 46 && !isOctal) {
            ++this.state.pos;
            this.readInt(10);
            isFloat = true;
            next = this.input.charCodeAt(this.state.pos);
        }
        if ((next === 69 || next === 101) && !isOctal) {
            next = this.input.charCodeAt(++this.state.pos);
            if (next === 43 || next === 45) ++this.state.pos;
            if (this.readInt(10) === null) this.raise($b48499974d50e8d0$var$Errors.InvalidOrMissingExponent, startLoc);
            isFloat = true;
            hasExponent = true;
            next = this.input.charCodeAt(this.state.pos);
        }
        if (next === 110) {
            if (isFloat || hasLeadingZero) this.raise($b48499974d50e8d0$var$Errors.InvalidBigIntLiteral, startLoc);
            ++this.state.pos;
            isBigInt = true;
        }
        if (next === 109) {
            this.expectPlugin("decimal", this.state.curPosition());
            if (hasExponent || hasLeadingZero) this.raise($b48499974d50e8d0$var$Errors.InvalidDecimal, startLoc);
            ++this.state.pos;
            isDecimal = true;
        }
        if ($b48499974d50e8d0$var$isIdentifierStart(this.codePointAtPos(this.state.pos))) throw this.raise($b48499974d50e8d0$var$Errors.NumberIdentifier, this.state.curPosition());
        const str = this.input.slice(start, this.state.pos).replace(/[_mn]/g, "");
        if (isBigInt) {
            this.finishToken(135, str);
            return;
        }
        if (isDecimal) {
            this.finishToken(136, str);
            return;
        }
        const val = isOctal ? parseInt(str, 8) : parseFloat(str);
        this.finishToken(134, val);
    }
    readCodePoint(throwOnInvalid) {
        const { code: code, pos: pos } = $b48499974d50e8d0$var$readCodePoint(this.input, this.state.pos, this.state.lineStart, this.state.curLine, throwOnInvalid, this.errorHandlers_readCodePoint);
        this.state.pos = pos;
        return code;
    }
    readString(quote) {
        const { str: str, pos: pos, curLine: curLine, lineStart: lineStart } = $b48499974d50e8d0$var$readStringContents(quote === 34 ? "double" : "single", this.input, this.state.pos + 1, this.state.lineStart, this.state.curLine, this.errorHandlers_readStringContents_string);
        this.state.pos = pos + 1;
        this.state.lineStart = lineStart;
        this.state.curLine = curLine;
        this.finishToken(133, str);
    }
    readTemplateContinuation() {
        if (!this.match(8)) this.unexpected(null, 8);
        this.state.pos--;
        this.readTemplateToken();
    }
    readTemplateToken() {
        const opening = this.input[this.state.pos];
        const { str: str, firstInvalidLoc: firstInvalidLoc, pos: pos, curLine: curLine, lineStart: lineStart } = $b48499974d50e8d0$var$readStringContents("template", this.input, this.state.pos + 1, this.state.lineStart, this.state.curLine, this.errorHandlers_readStringContents_template);
        this.state.pos = pos + 1;
        this.state.lineStart = lineStart;
        this.state.curLine = curLine;
        if (firstInvalidLoc) this.state.firstInvalidTemplateEscapePos = new $b48499974d50e8d0$var$Position(firstInvalidLoc.curLine, firstInvalidLoc.pos - firstInvalidLoc.lineStart, firstInvalidLoc.pos);
        if (this.input.codePointAt(pos) === 96) this.finishToken(24, firstInvalidLoc ? null : opening + str + "`");
        else {
            this.state.pos++;
            this.finishToken(25, firstInvalidLoc ? null : opening + str + "${");
        }
    }
    recordStrictModeErrors(toParseError, at) {
        const index = at.index;
        if (this.state.strict && !this.state.strictErrors.has(index)) this.raise(toParseError, at);
        else this.state.strictErrors.set(index, [
            toParseError,
            at
        ]);
    }
    readWord1(firstCode) {
        this.state.containsEsc = false;
        let word = "";
        const start = this.state.pos;
        let chunkStart = this.state.pos;
        if (firstCode !== undefined) this.state.pos += firstCode <= 0xffff ? 1 : 2;
        while(this.state.pos < this.length){
            const ch = this.codePointAtPos(this.state.pos);
            if ($b48499974d50e8d0$var$isIdentifierChar(ch)) this.state.pos += ch <= 0xffff ? 1 : 2;
            else if (ch === 92) {
                this.state.containsEsc = true;
                word += this.input.slice(chunkStart, this.state.pos);
                const escStart = this.state.curPosition();
                const identifierCheck = this.state.pos === start ? $b48499974d50e8d0$var$isIdentifierStart : $b48499974d50e8d0$var$isIdentifierChar;
                if (this.input.charCodeAt(++this.state.pos) !== 117) {
                    this.raise($b48499974d50e8d0$var$Errors.MissingUnicodeEscape, this.state.curPosition());
                    chunkStart = this.state.pos - 1;
                    continue;
                }
                ++this.state.pos;
                const esc = this.readCodePoint(true);
                if (esc !== null) {
                    if (!identifierCheck(esc)) this.raise($b48499974d50e8d0$var$Errors.EscapedCharNotAnIdentifier, escStart);
                    word += String.fromCodePoint(esc);
                }
                chunkStart = this.state.pos;
            } else break;
        }
        return word + this.input.slice(chunkStart, this.state.pos);
    }
    readWord(firstCode) {
        const word = this.readWord1(firstCode);
        const type = $b48499974d50e8d0$var$keywords$1.get(word);
        if (type !== undefined) this.finishToken(type, $b48499974d50e8d0$var$tokenLabelName(type));
        else this.finishToken(132, word);
    }
    checkKeywordEscapes() {
        const { type: type } = this.state;
        if ($b48499974d50e8d0$var$tokenIsKeyword(type) && this.state.containsEsc) this.raise($b48499974d50e8d0$var$Errors.InvalidEscapedReservedWord, this.state.startLoc, {
            reservedWord: $b48499974d50e8d0$var$tokenLabelName(type)
        });
    }
    raise(toParseError, at, details = {}) {
        const loc = at instanceof $b48499974d50e8d0$var$Position ? at : at.loc.start;
        const error = toParseError(loc, details);
        if (!this.options.errorRecovery) throw error;
        if (!this.isLookahead) this.state.errors.push(error);
        return error;
    }
    raiseOverwrite(toParseError, at, details = {}) {
        const loc = at instanceof $b48499974d50e8d0$var$Position ? at : at.loc.start;
        const pos = loc.index;
        const errors = this.state.errors;
        for(let i = errors.length - 1; i >= 0; i--){
            const error = errors[i];
            if (error.loc.index === pos) return errors[i] = toParseError(loc, details);
            if (error.loc.index < pos) break;
        }
        return this.raise(toParseError, at, details);
    }
    updateContext(prevType) {}
    unexpected(loc, type) {
        throw this.raise($b48499974d50e8d0$var$Errors.UnexpectedToken, loc != null ? loc : this.state.startLoc, {
            expected: type ? $b48499974d50e8d0$var$tokenLabelName(type) : null
        });
    }
    expectPlugin(pluginName, loc) {
        if (this.hasPlugin(pluginName)) return true;
        throw this.raise($b48499974d50e8d0$var$Errors.MissingPlugin, loc != null ? loc : this.state.startLoc, {
            missingPlugin: [
                pluginName
            ]
        });
    }
    expectOnePlugin(pluginNames) {
        if (!pluginNames.some((name)=>this.hasPlugin(name))) throw this.raise($b48499974d50e8d0$var$Errors.MissingOneOfPlugins, this.state.startLoc, {
            missingPlugin: pluginNames
        });
    }
    errorBuilder(error) {
        return (pos, lineStart, curLine)=>{
            this.raise(error, $b48499974d50e8d0$var$buildPosition(pos, lineStart, curLine));
        };
    }
}
class $b48499974d50e8d0$var$ClassScope {
    constructor(){
        this.privateNames = new Set();
        this.loneAccessors = new Map();
        this.undefinedPrivateNames = new Map();
    }
}
class $b48499974d50e8d0$var$ClassScopeHandler {
    constructor(parser){
        this.parser = void 0;
        this.stack = [];
        this.undefinedPrivateNames = new Map();
        this.parser = parser;
    }
    current() {
        return this.stack[this.stack.length - 1];
    }
    enter() {
        this.stack.push(new $b48499974d50e8d0$var$ClassScope());
    }
    exit() {
        const oldClassScope = this.stack.pop();
        const current = this.current();
        for (const [name, loc] of Array.from(oldClassScope.undefinedPrivateNames)){
            if (current) {
                if (!current.undefinedPrivateNames.has(name)) current.undefinedPrivateNames.set(name, loc);
            } else this.parser.raise($b48499974d50e8d0$var$Errors.InvalidPrivateFieldResolution, loc, {
                identifierName: name
            });
        }
    }
    declarePrivateName(name, elementType, loc) {
        const { privateNames: privateNames, loneAccessors: loneAccessors, undefinedPrivateNames: undefinedPrivateNames } = this.current();
        let redefined = privateNames.has(name);
        if (elementType & 3) {
            const accessor = redefined && loneAccessors.get(name);
            if (accessor) {
                const oldStatic = accessor & 4;
                const newStatic = elementType & 4;
                const oldKind = accessor & 3;
                const newKind = elementType & 3;
                redefined = oldKind === newKind || oldStatic !== newStatic;
                if (!redefined) loneAccessors.delete(name);
            } else if (!redefined) loneAccessors.set(name, elementType);
        }
        if (redefined) this.parser.raise($b48499974d50e8d0$var$Errors.PrivateNameRedeclaration, loc, {
            identifierName: name
        });
        privateNames.add(name);
        undefinedPrivateNames.delete(name);
    }
    usePrivateName(name, loc) {
        let classScope;
        for (classScope of this.stack){
            if (classScope.privateNames.has(name)) return;
        }
        if (classScope) classScope.undefinedPrivateNames.set(name, loc);
        else this.parser.raise($b48499974d50e8d0$var$Errors.InvalidPrivateFieldResolution, loc, {
            identifierName: name
        });
    }
}
class $b48499974d50e8d0$var$ExpressionScope {
    constructor(type = 0){
        this.type = type;
    }
    canBeArrowParameterDeclaration() {
        return this.type === 2 || this.type === 1;
    }
    isCertainlyParameterDeclaration() {
        return this.type === 3;
    }
}
class $b48499974d50e8d0$var$ArrowHeadParsingScope extends $b48499974d50e8d0$var$ExpressionScope {
    constructor(type){
        super(type);
        this.declarationErrors = new Map();
    }
    recordDeclarationError(ParsingErrorClass, at) {
        const index = at.index;
        this.declarationErrors.set(index, [
            ParsingErrorClass,
            at
        ]);
    }
    clearDeclarationError(index) {
        this.declarationErrors.delete(index);
    }
    iterateErrors(iterator) {
        this.declarationErrors.forEach(iterator);
    }
}
class $b48499974d50e8d0$var$ExpressionScopeHandler {
    constructor(parser){
        this.parser = void 0;
        this.stack = [
            new $b48499974d50e8d0$var$ExpressionScope()
        ];
        this.parser = parser;
    }
    enter(scope) {
        this.stack.push(scope);
    }
    exit() {
        this.stack.pop();
    }
    recordParameterInitializerError(toParseError, node) {
        const origin = node.loc.start;
        const { stack: stack } = this;
        let i = stack.length - 1;
        let scope = stack[i];
        while(!scope.isCertainlyParameterDeclaration()){
            if (scope.canBeArrowParameterDeclaration()) scope.recordDeclarationError(toParseError, origin);
            else return;
            scope = stack[--i];
        }
        this.parser.raise(toParseError, origin);
    }
    recordArrowParameterBindingError(error, node) {
        const { stack: stack } = this;
        const scope = stack[stack.length - 1];
        const origin = node.loc.start;
        if (scope.isCertainlyParameterDeclaration()) this.parser.raise(error, origin);
        else if (scope.canBeArrowParameterDeclaration()) scope.recordDeclarationError(error, origin);
        else return;
    }
    recordAsyncArrowParametersError(at) {
        const { stack: stack } = this;
        let i = stack.length - 1;
        let scope = stack[i];
        while(scope.canBeArrowParameterDeclaration()){
            if (scope.type === 2) scope.recordDeclarationError($b48499974d50e8d0$var$Errors.AwaitBindingIdentifier, at);
            scope = stack[--i];
        }
    }
    validateAsPattern() {
        const { stack: stack } = this;
        const currentScope = stack[stack.length - 1];
        if (!currentScope.canBeArrowParameterDeclaration()) return;
        currentScope.iterateErrors(([toParseError, loc])=>{
            this.parser.raise(toParseError, loc);
            let i = stack.length - 2;
            let scope = stack[i];
            while(scope.canBeArrowParameterDeclaration()){
                scope.clearDeclarationError(loc.index);
                scope = stack[--i];
            }
        });
    }
}
function $b48499974d50e8d0$var$newParameterDeclarationScope() {
    return new $b48499974d50e8d0$var$ExpressionScope(3);
}
function $b48499974d50e8d0$var$newArrowHeadScope() {
    return new $b48499974d50e8d0$var$ArrowHeadParsingScope(1);
}
function $b48499974d50e8d0$var$newAsyncArrowScope() {
    return new $b48499974d50e8d0$var$ArrowHeadParsingScope(2);
}
function $b48499974d50e8d0$var$newExpressionScope() {
    return new $b48499974d50e8d0$var$ExpressionScope();
}
class $b48499974d50e8d0$var$ProductionParameterHandler {
    constructor(){
        this.stacks = [];
    }
    enter(flags) {
        this.stacks.push(flags);
    }
    exit() {
        this.stacks.pop();
    }
    currentFlags() {
        return this.stacks[this.stacks.length - 1];
    }
    get hasAwait() {
        return (this.currentFlags() & 2) > 0;
    }
    get hasYield() {
        return (this.currentFlags() & 1) > 0;
    }
    get hasReturn() {
        return (this.currentFlags() & 4) > 0;
    }
    get hasIn() {
        return (this.currentFlags() & 8) > 0;
    }
}
function $b48499974d50e8d0$var$functionFlags(isAsync, isGenerator) {
    return (isAsync ? 2 : 0) | (isGenerator ? 1 : 0);
}
class $b48499974d50e8d0$var$UtilParser extends $b48499974d50e8d0$var$Tokenizer {
    addExtra(node, key, value, enumerable = true) {
        if (!node) return;
        const extra = node.extra = node.extra || {};
        if (enumerable) extra[key] = value;
        else Object.defineProperty(extra, key, {
            enumerable: enumerable,
            value: value
        });
    }
    isContextual(token) {
        return this.state.type === token && !this.state.containsEsc;
    }
    isUnparsedContextual(nameStart, name) {
        const nameEnd = nameStart + name.length;
        if (this.input.slice(nameStart, nameEnd) === name) {
            const nextCh = this.input.charCodeAt(nameEnd);
            return !($b48499974d50e8d0$var$isIdentifierChar(nextCh) || (nextCh & 0xfc00) === 0xd800);
        }
        return false;
    }
    isLookaheadContextual(name) {
        const next = this.nextTokenStart();
        return this.isUnparsedContextual(next, name);
    }
    eatContextual(token) {
        if (this.isContextual(token)) {
            this.next();
            return true;
        }
        return false;
    }
    expectContextual(token, toParseError) {
        if (!this.eatContextual(token)) {
            if (toParseError != null) throw this.raise(toParseError, this.state.startLoc);
            this.unexpected(null, token);
        }
    }
    canInsertSemicolon() {
        return this.match(139) || this.match(8) || this.hasPrecedingLineBreak();
    }
    hasPrecedingLineBreak() {
        return $b48499974d50e8d0$var$lineBreak.test(this.input.slice(this.state.lastTokEndLoc.index, this.state.start));
    }
    hasFollowingLineBreak() {
        $b48499974d50e8d0$var$skipWhiteSpaceToLineBreak.lastIndex = this.state.end;
        return $b48499974d50e8d0$var$skipWhiteSpaceToLineBreak.test(this.input);
    }
    isLineTerminator() {
        return this.eat(13) || this.canInsertSemicolon();
    }
    semicolon(allowAsi = true) {
        if (allowAsi ? this.isLineTerminator() : this.eat(13)) return;
        this.raise($b48499974d50e8d0$var$Errors.MissingSemicolon, this.state.lastTokEndLoc);
    }
    expect(type, loc) {
        this.eat(type) || this.unexpected(loc, type);
    }
    tryParse(fn, oldState = this.state.clone()) {
        const abortSignal = {
            node: null
        };
        try {
            const node = fn((node = null)=>{
                abortSignal.node = node;
                throw abortSignal;
            });
            if (this.state.errors.length > oldState.errors.length) {
                const failState = this.state;
                this.state = oldState;
                this.state.tokensLength = failState.tokensLength;
                return {
                    node: node,
                    error: failState.errors[oldState.errors.length],
                    thrown: false,
                    aborted: false,
                    failState: failState
                };
            }
            return {
                node: node,
                error: null,
                thrown: false,
                aborted: false,
                failState: null
            };
        } catch (error) {
            const failState = this.state;
            this.state = oldState;
            if (error instanceof SyntaxError) return {
                node: null,
                error: error,
                thrown: true,
                aborted: false,
                failState: failState
            };
            if (error === abortSignal) return {
                node: abortSignal.node,
                error: null,
                thrown: false,
                aborted: true,
                failState: failState
            };
            throw error;
        }
    }
    checkExpressionErrors(refExpressionErrors, andThrow) {
        if (!refExpressionErrors) return false;
        const { shorthandAssignLoc: shorthandAssignLoc, doubleProtoLoc: doubleProtoLoc, privateKeyLoc: privateKeyLoc, optionalParametersLoc: optionalParametersLoc } = refExpressionErrors;
        const hasErrors = !!shorthandAssignLoc || !!doubleProtoLoc || !!optionalParametersLoc || !!privateKeyLoc;
        if (!andThrow) return hasErrors;
        if (shorthandAssignLoc != null) this.raise($b48499974d50e8d0$var$Errors.InvalidCoverInitializedName, shorthandAssignLoc);
        if (doubleProtoLoc != null) this.raise($b48499974d50e8d0$var$Errors.DuplicateProto, doubleProtoLoc);
        if (privateKeyLoc != null) this.raise($b48499974d50e8d0$var$Errors.UnexpectedPrivateField, privateKeyLoc);
        if (optionalParametersLoc != null) this.unexpected(optionalParametersLoc);
    }
    isLiteralPropertyName() {
        return $b48499974d50e8d0$var$tokenIsLiteralPropertyName(this.state.type);
    }
    isPrivateName(node) {
        return node.type === "PrivateName";
    }
    getPrivateNameSV(node) {
        return node.id.name;
    }
    hasPropertyAsPrivateName(node) {
        return (node.type === "MemberExpression" || node.type === "OptionalMemberExpression") && this.isPrivateName(node.property);
    }
    isObjectProperty(node) {
        return node.type === "ObjectProperty";
    }
    isObjectMethod(node) {
        return node.type === "ObjectMethod";
    }
    initializeScopes(inModule = this.options.sourceType === "module") {
        const oldLabels = this.state.labels;
        this.state.labels = [];
        const oldExportedIdentifiers = this.exportedIdentifiers;
        this.exportedIdentifiers = new Set();
        const oldInModule = this.inModule;
        this.inModule = inModule;
        const oldScope = this.scope;
        const ScopeHandler = this.getScopeHandler();
        this.scope = new ScopeHandler(this, inModule);
        const oldProdParam = this.prodParam;
        this.prodParam = new $b48499974d50e8d0$var$ProductionParameterHandler();
        const oldClassScope = this.classScope;
        this.classScope = new $b48499974d50e8d0$var$ClassScopeHandler(this);
        const oldExpressionScope = this.expressionScope;
        this.expressionScope = new $b48499974d50e8d0$var$ExpressionScopeHandler(this);
        return ()=>{
            this.state.labels = oldLabels;
            this.exportedIdentifiers = oldExportedIdentifiers;
            this.inModule = oldInModule;
            this.scope = oldScope;
            this.prodParam = oldProdParam;
            this.classScope = oldClassScope;
            this.expressionScope = oldExpressionScope;
        };
    }
    enterInitialScopes() {
        let paramFlags = 0;
        if (this.inModule) paramFlags |= 2;
        this.scope.enter(1);
        this.prodParam.enter(paramFlags);
    }
    checkDestructuringPrivate(refExpressionErrors) {
        const { privateKeyLoc: privateKeyLoc } = refExpressionErrors;
        if (privateKeyLoc !== null) this.expectPlugin("destructuringPrivate", privateKeyLoc);
    }
}
class $b48499974d50e8d0$var$ExpressionErrors {
    constructor(){
        this.shorthandAssignLoc = null;
        this.doubleProtoLoc = null;
        this.privateKeyLoc = null;
        this.optionalParametersLoc = null;
    }
}
class $b48499974d50e8d0$var$Node {
    constructor(parser, pos, loc){
        this.type = "";
        this.start = pos;
        this.end = 0;
        this.loc = new $b48499974d50e8d0$var$SourceLocation(loc);
        if (parser != null && parser.options.ranges) this.range = [
            pos,
            0
        ];
        if (parser != null && parser.filename) this.loc.filename = parser.filename;
    }
}
const $b48499974d50e8d0$var$NodePrototype = $b48499974d50e8d0$var$Node.prototype;
$b48499974d50e8d0$var$NodePrototype.__clone = function() {
    const newNode = new $b48499974d50e8d0$var$Node(undefined, this.start, this.loc.start);
    const keys = Object.keys(this);
    for(let i = 0, length = keys.length; i < length; i++){
        const key = keys[i];
        if (key !== "leadingComments" && key !== "trailingComments" && key !== "innerComments") newNode[key] = this[key];
    }
    return newNode;
};
function $b48499974d50e8d0$var$clonePlaceholder(node) {
    return $b48499974d50e8d0$var$cloneIdentifier(node);
}
function $b48499974d50e8d0$var$cloneIdentifier(node) {
    const { type: type, start: start, end: end, loc: loc, range: range, extra: extra, name: name } = node;
    const cloned = Object.create($b48499974d50e8d0$var$NodePrototype);
    cloned.type = type;
    cloned.start = start;
    cloned.end = end;
    cloned.loc = loc;
    cloned.range = range;
    cloned.extra = extra;
    cloned.name = name;
    if (type === "Placeholder") cloned.expectedNode = node.expectedNode;
    return cloned;
}
function $b48499974d50e8d0$var$cloneStringLiteral(node) {
    const { type: type, start: start, end: end, loc: loc, range: range, extra: extra } = node;
    if (type === "Placeholder") return $b48499974d50e8d0$var$clonePlaceholder(node);
    const cloned = Object.create($b48499974d50e8d0$var$NodePrototype);
    cloned.type = type;
    cloned.start = start;
    cloned.end = end;
    cloned.loc = loc;
    cloned.range = range;
    if (node.raw !== undefined) cloned.raw = node.raw;
    else cloned.extra = extra;
    cloned.value = node.value;
    return cloned;
}
class $b48499974d50e8d0$var$NodeUtils extends $b48499974d50e8d0$var$UtilParser {
    startNode() {
        const loc = this.state.startLoc;
        return new $b48499974d50e8d0$var$Node(this, loc.index, loc);
    }
    startNodeAt(loc) {
        return new $b48499974d50e8d0$var$Node(this, loc.index, loc);
    }
    startNodeAtNode(type) {
        return this.startNodeAt(type.loc.start);
    }
    finishNode(node, type) {
        return this.finishNodeAt(node, type, this.state.lastTokEndLoc);
    }
    finishNodeAt(node, type, endLoc) {
        node.type = type;
        node.end = endLoc.index;
        node.loc.end = endLoc;
        if (this.options.ranges) node.range[1] = endLoc.index;
        if (this.options.attachComment) this.processComment(node);
        return node;
    }
    resetStartLocation(node, startLoc) {
        node.start = startLoc.index;
        node.loc.start = startLoc;
        if (this.options.ranges) node.range[0] = startLoc.index;
    }
    resetEndLocation(node, endLoc = this.state.lastTokEndLoc) {
        node.end = endLoc.index;
        node.loc.end = endLoc;
        if (this.options.ranges) node.range[1] = endLoc.index;
    }
    resetStartLocationFromNode(node, locationNode) {
        this.resetStartLocation(node, locationNode.loc.start);
    }
}
const $b48499974d50e8d0$var$reservedTypes = new Set([
    "_",
    "any",
    "bool",
    "boolean",
    "empty",
    "extends",
    "false",
    "interface",
    "mixed",
    "null",
    "number",
    "static",
    "string",
    "true",
    "typeof",
    "void"
]);
const $b48499974d50e8d0$var$FlowErrors = $b48499974d50e8d0$var$ParseErrorEnum`flow`({
    AmbiguousConditionalArrow: "Ambiguous expression: wrap the arrow functions in parentheses to disambiguate.",
    AmbiguousDeclareModuleKind: "Found both `declare module.exports` and `declare export` in the same module. Modules can only have 1 since they are either an ES module or they are a CommonJS module.",
    AssignReservedType: ({ reservedType: reservedType })=>`Cannot overwrite reserved type ${reservedType}.`,
    DeclareClassElement: "The `declare` modifier can only appear on class fields.",
    DeclareClassFieldInitializer: "Initializers are not allowed in fields with the `declare` modifier.",
    DuplicateDeclareModuleExports: "Duplicate `declare module.exports` statement.",
    EnumBooleanMemberNotInitialized: ({ memberName: memberName, enumName: enumName })=>`Boolean enum members need to be initialized. Use either \`${memberName} = true,\` or \`${memberName} = false,\` in enum \`${enumName}\`.`,
    EnumDuplicateMemberName: ({ memberName: memberName, enumName: enumName })=>`Enum member names need to be unique, but the name \`${memberName}\` has already been used before in enum \`${enumName}\`.`,
    EnumInconsistentMemberValues: ({ enumName: enumName })=>`Enum \`${enumName}\` has inconsistent member initializers. Either use no initializers, or consistently use literals (either booleans, numbers, or strings) for all member initializers.`,
    EnumInvalidExplicitType: ({ invalidEnumType: invalidEnumType, enumName: enumName })=>`Enum type \`${invalidEnumType}\` is not valid. Use one of \`boolean\`, \`number\`, \`string\`, or \`symbol\` in enum \`${enumName}\`.`,
    EnumInvalidExplicitTypeUnknownSupplied: ({ enumName: enumName })=>`Supplied enum type is not valid. Use one of \`boolean\`, \`number\`, \`string\`, or \`symbol\` in enum \`${enumName}\`.`,
    EnumInvalidMemberInitializerPrimaryType: ({ enumName: enumName, memberName: memberName, explicitType: explicitType })=>`Enum \`${enumName}\` has type \`${explicitType}\`, so the initializer of \`${memberName}\` needs to be a ${explicitType} literal.`,
    EnumInvalidMemberInitializerSymbolType: ({ enumName: enumName, memberName: memberName })=>`Symbol enum members cannot be initialized. Use \`${memberName},\` in enum \`${enumName}\`.`,
    EnumInvalidMemberInitializerUnknownType: ({ enumName: enumName, memberName: memberName })=>`The enum member initializer for \`${memberName}\` needs to be a literal (either a boolean, number, or string) in enum \`${enumName}\`.`,
    EnumInvalidMemberName: ({ enumName: enumName, memberName: memberName, suggestion: suggestion })=>`Enum member names cannot start with lowercase 'a' through 'z'. Instead of using \`${memberName}\`, consider using \`${suggestion}\`, in enum \`${enumName}\`.`,
    EnumNumberMemberNotInitialized: ({ enumName: enumName, memberName: memberName })=>`Number enum members need to be initialized, e.g. \`${memberName} = 1\` in enum \`${enumName}\`.`,
    EnumStringMemberInconsistentlyInitialized: ({ enumName: enumName })=>`String enum members need to consistently either all use initializers, or use no initializers, in enum \`${enumName}\`.`,
    GetterMayNotHaveThisParam: "A getter cannot have a `this` parameter.",
    ImportReflectionHasImportType: "An `import module` declaration can not use `type` or `typeof` keyword.",
    ImportTypeShorthandOnlyInPureImport: "The `type` and `typeof` keywords on named imports can only be used on regular `import` statements. It cannot be used with `import type` or `import typeof` statements.",
    InexactInsideExact: "Explicit inexact syntax cannot appear inside an explicit exact object type.",
    InexactInsideNonObject: "Explicit inexact syntax cannot appear in class or interface definitions.",
    InexactVariance: "Explicit inexact syntax cannot have variance.",
    InvalidNonTypeImportInDeclareModule: "Imports within a `declare module` body must always be `import type` or `import typeof`.",
    MissingTypeParamDefault: "Type parameter declaration needs a default, since a preceding type parameter declaration has a default.",
    NestedDeclareModule: "`declare module` cannot be used inside another `declare module`.",
    NestedFlowComment: "Cannot have a flow comment inside another flow comment.",
    PatternIsOptional: Object.assign({
        message: "A binding pattern parameter cannot be optional in an implementation signature."
    }, {
        reasonCode: "OptionalBindingPattern"
    }),
    SetterMayNotHaveThisParam: "A setter cannot have a `this` parameter.",
    SpreadVariance: "Spread properties cannot have variance.",
    ThisParamAnnotationRequired: "A type annotation is required for the `this` parameter.",
    ThisParamBannedInConstructor: "Constructors cannot have a `this` parameter; constructors don't bind `this` like other functions.",
    ThisParamMayNotBeOptional: "The `this` parameter cannot be optional.",
    ThisParamMustBeFirst: "The `this` parameter must be the first function parameter.",
    ThisParamNoDefault: "The `this` parameter may not have a default value.",
    TypeBeforeInitializer: "Type annotations must come before default assignments, e.g. instead of `age = 25: number` use `age: number = 25`.",
    TypeCastInPattern: "The type cast expression is expected to be wrapped with parenthesis.",
    UnexpectedExplicitInexactInObject: "Explicit inexact syntax must appear at the end of an inexact object.",
    UnexpectedReservedType: ({ reservedType: reservedType })=>`Unexpected reserved type ${reservedType}.`,
    UnexpectedReservedUnderscore: "`_` is only allowed as a type argument to call or new.",
    UnexpectedSpaceBetweenModuloChecks: "Spaces between `%` and `checks` are not allowed here.",
    UnexpectedSpreadType: "Spread operator cannot appear in class or interface definitions.",
    UnexpectedSubtractionOperand: 'Unexpected token, expected "number" or "bigint".',
    UnexpectedTokenAfterTypeParameter: "Expected an arrow function after this type parameter declaration.",
    UnexpectedTypeParameterBeforeAsyncArrowFunction: "Type parameters must come after the async keyword, e.g. instead of `<T> async () => {}`, use `async <T>() => {}`.",
    UnsupportedDeclareExportKind: ({ unsupportedExportKind: unsupportedExportKind, suggestion: suggestion })=>`\`declare export ${unsupportedExportKind}\` is not supported. Use \`${suggestion}\` instead.`,
    UnsupportedStatementInDeclareModule: "Only declares and type imports are allowed inside declare module.",
    UnterminatedFlowComment: "Unterminated flow-comment."
});
function $b48499974d50e8d0$var$isEsModuleType(bodyElement) {
    return bodyElement.type === "DeclareExportAllDeclaration" || bodyElement.type === "DeclareExportDeclaration" && (!bodyElement.declaration || bodyElement.declaration.type !== "TypeAlias" && bodyElement.declaration.type !== "InterfaceDeclaration");
}
function $b48499974d50e8d0$var$hasTypeImportKind(node) {
    return node.importKind === "type" || node.importKind === "typeof";
}
const $b48499974d50e8d0$var$exportSuggestions = {
    const: "declare export var",
    let: "declare export var",
    type: "export type",
    interface: "export interface"
};
function $b48499974d50e8d0$var$partition(list, test) {
    const list1 = [];
    const list2 = [];
    for(let i = 0; i < list.length; i++)(test(list[i], i, list) ? list1 : list2).push(list[i]);
    return [
        list1,
        list2
    ];
}
const $b48499974d50e8d0$var$FLOW_PRAGMA_REGEX = /\*?\s*@((?:no)?flow)\b/;
var $b48499974d50e8d0$var$flow = (superClass)=>class FlowParserMixin extends superClass {
        constructor(...args){
            super(...args);
            this.flowPragma = undefined;
        }
        getScopeHandler() {
            return $b48499974d50e8d0$var$FlowScopeHandler;
        }
        shouldParseTypes() {
            return this.getPluginOption("flow", "all") || this.flowPragma === "flow";
        }
        shouldParseEnums() {
            return !!this.getPluginOption("flow", "enums");
        }
        finishToken(type, val) {
            if (type !== 133 && type !== 13 && type !== 28) {
                if (this.flowPragma === undefined) this.flowPragma = null;
            }
            super.finishToken(type, val);
        }
        addComment(comment) {
            if (this.flowPragma === undefined) {
                const matches = $b48499974d50e8d0$var$FLOW_PRAGMA_REGEX.exec(comment.value);
                if (!matches) ;
                else if (matches[1] === "flow") this.flowPragma = "flow";
                else if (matches[1] === "noflow") this.flowPragma = "noflow";
                else throw new Error("Unexpected flow pragma");
            }
            super.addComment(comment);
        }
        flowParseTypeInitialiser(tok) {
            const oldInType = this.state.inType;
            this.state.inType = true;
            this.expect(tok || 14);
            const type = this.flowParseType();
            this.state.inType = oldInType;
            return type;
        }
        flowParsePredicate() {
            const node = this.startNode();
            const moduloLoc = this.state.startLoc;
            this.next();
            this.expectContextual(110);
            if (this.state.lastTokStartLoc.index > moduloLoc.index + 1) this.raise($b48499974d50e8d0$var$FlowErrors.UnexpectedSpaceBetweenModuloChecks, moduloLoc);
            if (this.eat(10)) {
                node.value = super.parseExpression();
                this.expect(11);
                return this.finishNode(node, "DeclaredPredicate");
            } else return this.finishNode(node, "InferredPredicate");
        }
        flowParseTypeAndPredicateInitialiser() {
            const oldInType = this.state.inType;
            this.state.inType = true;
            this.expect(14);
            let type = null;
            let predicate = null;
            if (this.match(54)) {
                this.state.inType = oldInType;
                predicate = this.flowParsePredicate();
            } else {
                type = this.flowParseType();
                this.state.inType = oldInType;
                if (this.match(54)) predicate = this.flowParsePredicate();
            }
            return [
                type,
                predicate
            ];
        }
        flowParseDeclareClass(node) {
            this.next();
            this.flowParseInterfaceish(node, true);
            return this.finishNode(node, "DeclareClass");
        }
        flowParseDeclareFunction(node) {
            this.next();
            const id = node.id = this.parseIdentifier();
            const typeNode = this.startNode();
            const typeContainer = this.startNode();
            if (this.match(47)) typeNode.typeParameters = this.flowParseTypeParameterDeclaration();
            else typeNode.typeParameters = null;
            this.expect(10);
            const tmp = this.flowParseFunctionTypeParams();
            typeNode.params = tmp.params;
            typeNode.rest = tmp.rest;
            typeNode.this = tmp._this;
            this.expect(11);
            [typeNode.returnType, node.predicate] = this.flowParseTypeAndPredicateInitialiser();
            typeContainer.typeAnnotation = this.finishNode(typeNode, "FunctionTypeAnnotation");
            id.typeAnnotation = this.finishNode(typeContainer, "TypeAnnotation");
            this.resetEndLocation(id);
            this.semicolon();
            this.scope.declareName(node.id.name, 2048, node.id.loc.start);
            return this.finishNode(node, "DeclareFunction");
        }
        flowParseDeclare(node, insideModule) {
            if (this.match(80)) return this.flowParseDeclareClass(node);
            else if (this.match(68)) return this.flowParseDeclareFunction(node);
            else if (this.match(74)) return this.flowParseDeclareVariable(node);
            else if (this.eatContextual(127)) {
                if (this.match(16)) return this.flowParseDeclareModuleExports(node);
                else {
                    if (insideModule) this.raise($b48499974d50e8d0$var$FlowErrors.NestedDeclareModule, this.state.lastTokStartLoc);
                    return this.flowParseDeclareModule(node);
                }
            } else if (this.isContextual(130)) return this.flowParseDeclareTypeAlias(node);
            else if (this.isContextual(131)) return this.flowParseDeclareOpaqueType(node);
            else if (this.isContextual(129)) return this.flowParseDeclareInterface(node);
            else if (this.match(82)) return this.flowParseDeclareExportDeclaration(node, insideModule);
            else this.unexpected();
        }
        flowParseDeclareVariable(node) {
            this.next();
            node.id = this.flowParseTypeAnnotatableIdentifier(true);
            this.scope.declareName(node.id.name, 5, node.id.loc.start);
            this.semicolon();
            return this.finishNode(node, "DeclareVariable");
        }
        flowParseDeclareModule(node) {
            this.scope.enter(0);
            if (this.match(133)) node.id = super.parseExprAtom();
            else node.id = this.parseIdentifier();
            const bodyNode = node.body = this.startNode();
            const body = bodyNode.body = [];
            this.expect(5);
            while(!this.match(8)){
                let bodyNode = this.startNode();
                if (this.match(83)) {
                    this.next();
                    if (!this.isContextual(130) && !this.match(87)) this.raise($b48499974d50e8d0$var$FlowErrors.InvalidNonTypeImportInDeclareModule, this.state.lastTokStartLoc);
                    super.parseImport(bodyNode);
                } else {
                    this.expectContextual(125, $b48499974d50e8d0$var$FlowErrors.UnsupportedStatementInDeclareModule);
                    bodyNode = this.flowParseDeclare(bodyNode, true);
                }
                body.push(bodyNode);
            }
            this.scope.exit();
            this.expect(8);
            this.finishNode(bodyNode, "BlockStatement");
            let kind = null;
            let hasModuleExport = false;
            body.forEach((bodyElement)=>{
                if ($b48499974d50e8d0$var$isEsModuleType(bodyElement)) {
                    if (kind === "CommonJS") this.raise($b48499974d50e8d0$var$FlowErrors.AmbiguousDeclareModuleKind, bodyElement);
                    kind = "ES";
                } else if (bodyElement.type === "DeclareModuleExports") {
                    if (hasModuleExport) this.raise($b48499974d50e8d0$var$FlowErrors.DuplicateDeclareModuleExports, bodyElement);
                    if (kind === "ES") this.raise($b48499974d50e8d0$var$FlowErrors.AmbiguousDeclareModuleKind, bodyElement);
                    kind = "CommonJS";
                    hasModuleExport = true;
                }
            });
            node.kind = kind || "CommonJS";
            return this.finishNode(node, "DeclareModule");
        }
        flowParseDeclareExportDeclaration(node, insideModule) {
            this.expect(82);
            if (this.eat(65)) {
                if (this.match(68) || this.match(80)) node.declaration = this.flowParseDeclare(this.startNode());
                else {
                    node.declaration = this.flowParseType();
                    this.semicolon();
                }
                node.default = true;
                return this.finishNode(node, "DeclareExportDeclaration");
            } else {
                if (this.match(75) || this.isLet() || (this.isContextual(130) || this.isContextual(129)) && !insideModule) {
                    const label = this.state.value;
                    throw this.raise($b48499974d50e8d0$var$FlowErrors.UnsupportedDeclareExportKind, this.state.startLoc, {
                        unsupportedExportKind: label,
                        suggestion: $b48499974d50e8d0$var$exportSuggestions[label]
                    });
                }
                if (this.match(74) || this.match(68) || this.match(80) || this.isContextual(131)) {
                    node.declaration = this.flowParseDeclare(this.startNode());
                    node.default = false;
                    return this.finishNode(node, "DeclareExportDeclaration");
                } else if (this.match(55) || this.match(5) || this.isContextual(129) || this.isContextual(130) || this.isContextual(131)) {
                    node = this.parseExport(node, null);
                    if (node.type === "ExportNamedDeclaration") {
                        node.type = "ExportDeclaration";
                        node.default = false;
                        delete node.exportKind;
                    }
                    node.type = "Declare" + node.type;
                    return node;
                }
            }
            this.unexpected();
        }
        flowParseDeclareModuleExports(node) {
            this.next();
            this.expectContextual(111);
            node.typeAnnotation = this.flowParseTypeAnnotation();
            this.semicolon();
            return this.finishNode(node, "DeclareModuleExports");
        }
        flowParseDeclareTypeAlias(node) {
            this.next();
            const finished = this.flowParseTypeAlias(node);
            finished.type = "DeclareTypeAlias";
            return finished;
        }
        flowParseDeclareOpaqueType(node) {
            this.next();
            const finished = this.flowParseOpaqueType(node, true);
            finished.type = "DeclareOpaqueType";
            return finished;
        }
        flowParseDeclareInterface(node) {
            this.next();
            this.flowParseInterfaceish(node, false);
            return this.finishNode(node, "DeclareInterface");
        }
        flowParseInterfaceish(node, isClass) {
            node.id = this.flowParseRestrictedIdentifier(!isClass, true);
            this.scope.declareName(node.id.name, isClass ? 17 : 8201, node.id.loc.start);
            if (this.match(47)) node.typeParameters = this.flowParseTypeParameterDeclaration();
            else node.typeParameters = null;
            node.extends = [];
            if (this.eat(81)) do node.extends.push(this.flowParseInterfaceExtends());
            while (!isClass && this.eat(12));
            if (isClass) {
                node.implements = [];
                node.mixins = [];
                if (this.eatContextual(117)) do node.mixins.push(this.flowParseInterfaceExtends());
                while (this.eat(12));
                if (this.eatContextual(113)) do node.implements.push(this.flowParseInterfaceExtends());
                while (this.eat(12));
            }
            node.body = this.flowParseObjectType({
                allowStatic: isClass,
                allowExact: false,
                allowSpread: false,
                allowProto: isClass,
                allowInexact: false
            });
        }
        flowParseInterfaceExtends() {
            const node = this.startNode();
            node.id = this.flowParseQualifiedTypeIdentifier();
            if (this.match(47)) node.typeParameters = this.flowParseTypeParameterInstantiation();
            else node.typeParameters = null;
            return this.finishNode(node, "InterfaceExtends");
        }
        flowParseInterface(node) {
            this.flowParseInterfaceish(node, false);
            return this.finishNode(node, "InterfaceDeclaration");
        }
        checkNotUnderscore(word) {
            if (word === "_") this.raise($b48499974d50e8d0$var$FlowErrors.UnexpectedReservedUnderscore, this.state.startLoc);
        }
        checkReservedType(word, startLoc, declaration) {
            if (!$b48499974d50e8d0$var$reservedTypes.has(word)) return;
            this.raise(declaration ? $b48499974d50e8d0$var$FlowErrors.AssignReservedType : $b48499974d50e8d0$var$FlowErrors.UnexpectedReservedType, startLoc, {
                reservedType: word
            });
        }
        flowParseRestrictedIdentifier(liberal, declaration) {
            this.checkReservedType(this.state.value, this.state.startLoc, declaration);
            return this.parseIdentifier(liberal);
        }
        flowParseTypeAlias(node) {
            node.id = this.flowParseRestrictedIdentifier(false, true);
            this.scope.declareName(node.id.name, 8201, node.id.loc.start);
            if (this.match(47)) node.typeParameters = this.flowParseTypeParameterDeclaration();
            else node.typeParameters = null;
            node.right = this.flowParseTypeInitialiser(29);
            this.semicolon();
            return this.finishNode(node, "TypeAlias");
        }
        flowParseOpaqueType(node, declare) {
            this.expectContextual(130);
            node.id = this.flowParseRestrictedIdentifier(true, true);
            this.scope.declareName(node.id.name, 8201, node.id.loc.start);
            if (this.match(47)) node.typeParameters = this.flowParseTypeParameterDeclaration();
            else node.typeParameters = null;
            node.supertype = null;
            if (this.match(14)) node.supertype = this.flowParseTypeInitialiser(14);
            node.impltype = null;
            if (!declare) node.impltype = this.flowParseTypeInitialiser(29);
            this.semicolon();
            return this.finishNode(node, "OpaqueType");
        }
        flowParseTypeParameter(requireDefault = false) {
            const nodeStartLoc = this.state.startLoc;
            const node = this.startNode();
            const variance = this.flowParseVariance();
            const ident = this.flowParseTypeAnnotatableIdentifier();
            node.name = ident.name;
            node.variance = variance;
            node.bound = ident.typeAnnotation;
            if (this.match(29)) {
                this.eat(29);
                node.default = this.flowParseType();
            } else if (requireDefault) this.raise($b48499974d50e8d0$var$FlowErrors.MissingTypeParamDefault, nodeStartLoc);
            return this.finishNode(node, "TypeParameter");
        }
        flowParseTypeParameterDeclaration() {
            const oldInType = this.state.inType;
            const node = this.startNode();
            node.params = [];
            this.state.inType = true;
            if (this.match(47) || this.match(142)) this.next();
            else this.unexpected();
            let defaultRequired = false;
            do {
                const typeParameter = this.flowParseTypeParameter(defaultRequired);
                node.params.push(typeParameter);
                if (typeParameter.default) defaultRequired = true;
                if (!this.match(48)) this.expect(12);
            }while (!this.match(48));
            this.expect(48);
            this.state.inType = oldInType;
            return this.finishNode(node, "TypeParameterDeclaration");
        }
        flowParseTypeParameterInstantiation() {
            const node = this.startNode();
            const oldInType = this.state.inType;
            node.params = [];
            this.state.inType = true;
            this.expect(47);
            const oldNoAnonFunctionType = this.state.noAnonFunctionType;
            this.state.noAnonFunctionType = false;
            while(!this.match(48)){
                node.params.push(this.flowParseType());
                if (!this.match(48)) this.expect(12);
            }
            this.state.noAnonFunctionType = oldNoAnonFunctionType;
            this.expect(48);
            this.state.inType = oldInType;
            return this.finishNode(node, "TypeParameterInstantiation");
        }
        flowParseTypeParameterInstantiationCallOrNew() {
            const node = this.startNode();
            const oldInType = this.state.inType;
            node.params = [];
            this.state.inType = true;
            this.expect(47);
            while(!this.match(48)){
                node.params.push(this.flowParseTypeOrImplicitInstantiation());
                if (!this.match(48)) this.expect(12);
            }
            this.expect(48);
            this.state.inType = oldInType;
            return this.finishNode(node, "TypeParameterInstantiation");
        }
        flowParseInterfaceType() {
            const node = this.startNode();
            this.expectContextual(129);
            node.extends = [];
            if (this.eat(81)) do node.extends.push(this.flowParseInterfaceExtends());
            while (this.eat(12));
            node.body = this.flowParseObjectType({
                allowStatic: false,
                allowExact: false,
                allowSpread: false,
                allowProto: false,
                allowInexact: false
            });
            return this.finishNode(node, "InterfaceTypeAnnotation");
        }
        flowParseObjectPropertyKey() {
            return this.match(134) || this.match(133) ? super.parseExprAtom() : this.parseIdentifier(true);
        }
        flowParseObjectTypeIndexer(node, isStatic, variance) {
            node.static = isStatic;
            if (this.lookahead().type === 14) {
                node.id = this.flowParseObjectPropertyKey();
                node.key = this.flowParseTypeInitialiser();
            } else {
                node.id = null;
                node.key = this.flowParseType();
            }
            this.expect(3);
            node.value = this.flowParseTypeInitialiser();
            node.variance = variance;
            return this.finishNode(node, "ObjectTypeIndexer");
        }
        flowParseObjectTypeInternalSlot(node, isStatic) {
            node.static = isStatic;
            node.id = this.flowParseObjectPropertyKey();
            this.expect(3);
            this.expect(3);
            if (this.match(47) || this.match(10)) {
                node.method = true;
                node.optional = false;
                node.value = this.flowParseObjectTypeMethodish(this.startNodeAt(node.loc.start));
            } else {
                node.method = false;
                if (this.eat(17)) node.optional = true;
                node.value = this.flowParseTypeInitialiser();
            }
            return this.finishNode(node, "ObjectTypeInternalSlot");
        }
        flowParseObjectTypeMethodish(node) {
            node.params = [];
            node.rest = null;
            node.typeParameters = null;
            node.this = null;
            if (this.match(47)) node.typeParameters = this.flowParseTypeParameterDeclaration();
            this.expect(10);
            if (this.match(78)) {
                node.this = this.flowParseFunctionTypeParam(true);
                node.this.name = null;
                if (!this.match(11)) this.expect(12);
            }
            while(!this.match(11) && !this.match(21)){
                node.params.push(this.flowParseFunctionTypeParam(false));
                if (!this.match(11)) this.expect(12);
            }
            if (this.eat(21)) node.rest = this.flowParseFunctionTypeParam(false);
            this.expect(11);
            node.returnType = this.flowParseTypeInitialiser();
            return this.finishNode(node, "FunctionTypeAnnotation");
        }
        flowParseObjectTypeCallProperty(node, isStatic) {
            const valueNode = this.startNode();
            node.static = isStatic;
            node.value = this.flowParseObjectTypeMethodish(valueNode);
            return this.finishNode(node, "ObjectTypeCallProperty");
        }
        flowParseObjectType({ allowStatic: allowStatic, allowExact: allowExact, allowSpread: allowSpread, allowProto: allowProto, allowInexact: allowInexact }) {
            const oldInType = this.state.inType;
            this.state.inType = true;
            const nodeStart = this.startNode();
            nodeStart.callProperties = [];
            nodeStart.properties = [];
            nodeStart.indexers = [];
            nodeStart.internalSlots = [];
            let endDelim;
            let exact;
            let inexact = false;
            if (allowExact && this.match(6)) {
                this.expect(6);
                endDelim = 9;
                exact = true;
            } else {
                this.expect(5);
                endDelim = 8;
                exact = false;
            }
            nodeStart.exact = exact;
            while(!this.match(endDelim)){
                let isStatic = false;
                let protoStartLoc = null;
                let inexactStartLoc = null;
                const node = this.startNode();
                if (allowProto && this.isContextual(118)) {
                    const lookahead = this.lookahead();
                    if (lookahead.type !== 14 && lookahead.type !== 17) {
                        this.next();
                        protoStartLoc = this.state.startLoc;
                        allowStatic = false;
                    }
                }
                if (allowStatic && this.isContextual(106)) {
                    const lookahead = this.lookahead();
                    if (lookahead.type !== 14 && lookahead.type !== 17) {
                        this.next();
                        isStatic = true;
                    }
                }
                const variance = this.flowParseVariance();
                if (this.eat(0)) {
                    if (protoStartLoc != null) this.unexpected(protoStartLoc);
                    if (this.eat(0)) {
                        if (variance) this.unexpected(variance.loc.start);
                        nodeStart.internalSlots.push(this.flowParseObjectTypeInternalSlot(node, isStatic));
                    } else nodeStart.indexers.push(this.flowParseObjectTypeIndexer(node, isStatic, variance));
                } else if (this.match(10) || this.match(47)) {
                    if (protoStartLoc != null) this.unexpected(protoStartLoc);
                    if (variance) this.unexpected(variance.loc.start);
                    nodeStart.callProperties.push(this.flowParseObjectTypeCallProperty(node, isStatic));
                } else {
                    let kind = "init";
                    if (this.isContextual(99) || this.isContextual(104)) {
                        const lookahead = this.lookahead();
                        if ($b48499974d50e8d0$var$tokenIsLiteralPropertyName(lookahead.type)) {
                            kind = this.state.value;
                            this.next();
                        }
                    }
                    const propOrInexact = this.flowParseObjectTypeProperty(node, isStatic, protoStartLoc, variance, kind, allowSpread, allowInexact != null ? allowInexact : !exact);
                    if (propOrInexact === null) {
                        inexact = true;
                        inexactStartLoc = this.state.lastTokStartLoc;
                    } else nodeStart.properties.push(propOrInexact);
                }
                this.flowObjectTypeSemicolon();
                if (inexactStartLoc && !this.match(8) && !this.match(9)) this.raise($b48499974d50e8d0$var$FlowErrors.UnexpectedExplicitInexactInObject, inexactStartLoc);
            }
            this.expect(endDelim);
            if (allowSpread) nodeStart.inexact = inexact;
            const out = this.finishNode(nodeStart, "ObjectTypeAnnotation");
            this.state.inType = oldInType;
            return out;
        }
        flowParseObjectTypeProperty(node, isStatic, protoStartLoc, variance, kind, allowSpread, allowInexact) {
            if (this.eat(21)) {
                const isInexactToken = this.match(12) || this.match(13) || this.match(8) || this.match(9);
                if (isInexactToken) {
                    if (!allowSpread) this.raise($b48499974d50e8d0$var$FlowErrors.InexactInsideNonObject, this.state.lastTokStartLoc);
                    else if (!allowInexact) this.raise($b48499974d50e8d0$var$FlowErrors.InexactInsideExact, this.state.lastTokStartLoc);
                    if (variance) this.raise($b48499974d50e8d0$var$FlowErrors.InexactVariance, variance);
                    return null;
                }
                if (!allowSpread) this.raise($b48499974d50e8d0$var$FlowErrors.UnexpectedSpreadType, this.state.lastTokStartLoc);
                if (protoStartLoc != null) this.unexpected(protoStartLoc);
                if (variance) this.raise($b48499974d50e8d0$var$FlowErrors.SpreadVariance, variance);
                node.argument = this.flowParseType();
                return this.finishNode(node, "ObjectTypeSpreadProperty");
            } else {
                node.key = this.flowParseObjectPropertyKey();
                node.static = isStatic;
                node.proto = protoStartLoc != null;
                node.kind = kind;
                let optional = false;
                if (this.match(47) || this.match(10)) {
                    node.method = true;
                    if (protoStartLoc != null) this.unexpected(protoStartLoc);
                    if (variance) this.unexpected(variance.loc.start);
                    node.value = this.flowParseObjectTypeMethodish(this.startNodeAt(node.loc.start));
                    if (kind === "get" || kind === "set") this.flowCheckGetterSetterParams(node);
                    if (!allowSpread && node.key.name === "constructor" && node.value.this) this.raise($b48499974d50e8d0$var$FlowErrors.ThisParamBannedInConstructor, node.value.this);
                } else {
                    if (kind !== "init") this.unexpected();
                    node.method = false;
                    if (this.eat(17)) optional = true;
                    node.value = this.flowParseTypeInitialiser();
                    node.variance = variance;
                }
                node.optional = optional;
                return this.finishNode(node, "ObjectTypeProperty");
            }
        }
        flowCheckGetterSetterParams(property) {
            const paramCount = property.kind === "get" ? 0 : 1;
            const length = property.value.params.length + (property.value.rest ? 1 : 0);
            if (property.value.this) this.raise(property.kind === "get" ? $b48499974d50e8d0$var$FlowErrors.GetterMayNotHaveThisParam : $b48499974d50e8d0$var$FlowErrors.SetterMayNotHaveThisParam, property.value.this);
            if (length !== paramCount) this.raise(property.kind === "get" ? $b48499974d50e8d0$var$Errors.BadGetterArity : $b48499974d50e8d0$var$Errors.BadSetterArity, property);
            if (property.kind === "set" && property.value.rest) this.raise($b48499974d50e8d0$var$Errors.BadSetterRestParameter, property);
        }
        flowObjectTypeSemicolon() {
            if (!this.eat(13) && !this.eat(12) && !this.match(8) && !this.match(9)) this.unexpected();
        }
        flowParseQualifiedTypeIdentifier(startLoc, id) {
            var _startLoc;
            (_startLoc = startLoc) != null ? _startLoc : startLoc = this.state.startLoc;
            let node = id || this.flowParseRestrictedIdentifier(true);
            while(this.eat(16)){
                const node2 = this.startNodeAt(startLoc);
                node2.qualification = node;
                node2.id = this.flowParseRestrictedIdentifier(true);
                node = this.finishNode(node2, "QualifiedTypeIdentifier");
            }
            return node;
        }
        flowParseGenericType(startLoc, id) {
            const node = this.startNodeAt(startLoc);
            node.typeParameters = null;
            node.id = this.flowParseQualifiedTypeIdentifier(startLoc, id);
            if (this.match(47)) node.typeParameters = this.flowParseTypeParameterInstantiation();
            return this.finishNode(node, "GenericTypeAnnotation");
        }
        flowParseTypeofType() {
            const node = this.startNode();
            this.expect(87);
            node.argument = this.flowParsePrimaryType();
            return this.finishNode(node, "TypeofTypeAnnotation");
        }
        flowParseTupleType() {
            const node = this.startNode();
            node.types = [];
            this.expect(0);
            while(this.state.pos < this.length && !this.match(3)){
                node.types.push(this.flowParseType());
                if (this.match(3)) break;
                this.expect(12);
            }
            this.expect(3);
            return this.finishNode(node, "TupleTypeAnnotation");
        }
        flowParseFunctionTypeParam(first) {
            let name = null;
            let optional = false;
            let typeAnnotation = null;
            const node = this.startNode();
            const lh = this.lookahead();
            const isThis = this.state.type === 78;
            if (lh.type === 14 || lh.type === 17) {
                if (isThis && !first) this.raise($b48499974d50e8d0$var$FlowErrors.ThisParamMustBeFirst, node);
                name = this.parseIdentifier(isThis);
                if (this.eat(17)) {
                    optional = true;
                    if (isThis) this.raise($b48499974d50e8d0$var$FlowErrors.ThisParamMayNotBeOptional, node);
                }
                typeAnnotation = this.flowParseTypeInitialiser();
            } else typeAnnotation = this.flowParseType();
            node.name = name;
            node.optional = optional;
            node.typeAnnotation = typeAnnotation;
            return this.finishNode(node, "FunctionTypeParam");
        }
        reinterpretTypeAsFunctionTypeParam(type) {
            const node = this.startNodeAt(type.loc.start);
            node.name = null;
            node.optional = false;
            node.typeAnnotation = type;
            return this.finishNode(node, "FunctionTypeParam");
        }
        flowParseFunctionTypeParams(params = []) {
            let rest = null;
            let _this = null;
            if (this.match(78)) {
                _this = this.flowParseFunctionTypeParam(true);
                _this.name = null;
                if (!this.match(11)) this.expect(12);
            }
            while(!this.match(11) && !this.match(21)){
                params.push(this.flowParseFunctionTypeParam(false));
                if (!this.match(11)) this.expect(12);
            }
            if (this.eat(21)) rest = this.flowParseFunctionTypeParam(false);
            return {
                params: params,
                rest: rest,
                _this: _this
            };
        }
        flowIdentToTypeAnnotation(startLoc, node, id) {
            switch(id.name){
                case "any":
                    return this.finishNode(node, "AnyTypeAnnotation");
                case "bool":
                case "boolean":
                    return this.finishNode(node, "BooleanTypeAnnotation");
                case "mixed":
                    return this.finishNode(node, "MixedTypeAnnotation");
                case "empty":
                    return this.finishNode(node, "EmptyTypeAnnotation");
                case "number":
                    return this.finishNode(node, "NumberTypeAnnotation");
                case "string":
                    return this.finishNode(node, "StringTypeAnnotation");
                case "symbol":
                    return this.finishNode(node, "SymbolTypeAnnotation");
                default:
                    this.checkNotUnderscore(id.name);
                    return this.flowParseGenericType(startLoc, id);
            }
        }
        flowParsePrimaryType() {
            const startLoc = this.state.startLoc;
            const node = this.startNode();
            let tmp;
            let type;
            let isGroupedType = false;
            const oldNoAnonFunctionType = this.state.noAnonFunctionType;
            switch(this.state.type){
                case 5:
                    return this.flowParseObjectType({
                        allowStatic: false,
                        allowExact: false,
                        allowSpread: true,
                        allowProto: false,
                        allowInexact: true
                    });
                case 6:
                    return this.flowParseObjectType({
                        allowStatic: false,
                        allowExact: true,
                        allowSpread: true,
                        allowProto: false,
                        allowInexact: false
                    });
                case 0:
                    this.state.noAnonFunctionType = false;
                    type = this.flowParseTupleType();
                    this.state.noAnonFunctionType = oldNoAnonFunctionType;
                    return type;
                case 47:
                    node.typeParameters = this.flowParseTypeParameterDeclaration();
                    this.expect(10);
                    tmp = this.flowParseFunctionTypeParams();
                    node.params = tmp.params;
                    node.rest = tmp.rest;
                    node.this = tmp._this;
                    this.expect(11);
                    this.expect(19);
                    node.returnType = this.flowParseType();
                    return this.finishNode(node, "FunctionTypeAnnotation");
                case 10:
                    this.next();
                    if (!this.match(11) && !this.match(21)) {
                        if ($b48499974d50e8d0$var$tokenIsIdentifier(this.state.type) || this.match(78)) {
                            const token = this.lookahead().type;
                            isGroupedType = token !== 17 && token !== 14;
                        } else isGroupedType = true;
                    }
                    if (isGroupedType) {
                        this.state.noAnonFunctionType = false;
                        type = this.flowParseType();
                        this.state.noAnonFunctionType = oldNoAnonFunctionType;
                        if (this.state.noAnonFunctionType || !(this.match(12) || this.match(11) && this.lookahead().type === 19)) {
                            this.expect(11);
                            return type;
                        } else this.eat(12);
                    }
                    if (type) tmp = this.flowParseFunctionTypeParams([
                        this.reinterpretTypeAsFunctionTypeParam(type)
                    ]);
                    else tmp = this.flowParseFunctionTypeParams();
                    node.params = tmp.params;
                    node.rest = tmp.rest;
                    node.this = tmp._this;
                    this.expect(11);
                    this.expect(19);
                    node.returnType = this.flowParseType();
                    node.typeParameters = null;
                    return this.finishNode(node, "FunctionTypeAnnotation");
                case 133:
                    return this.parseLiteral(this.state.value, "StringLiteralTypeAnnotation");
                case 85:
                case 86:
                    node.value = this.match(85);
                    this.next();
                    return this.finishNode(node, "BooleanLiteralTypeAnnotation");
                case 53:
                    if (this.state.value === "-") {
                        this.next();
                        if (this.match(134)) return this.parseLiteralAtNode(-this.state.value, "NumberLiteralTypeAnnotation", node);
                        if (this.match(135)) return this.parseLiteralAtNode(-this.state.value, "BigIntLiteralTypeAnnotation", node);
                        throw this.raise($b48499974d50e8d0$var$FlowErrors.UnexpectedSubtractionOperand, this.state.startLoc);
                    }
                    this.unexpected();
                    return;
                case 134:
                    return this.parseLiteral(this.state.value, "NumberLiteralTypeAnnotation");
                case 135:
                    return this.parseLiteral(this.state.value, "BigIntLiteralTypeAnnotation");
                case 88:
                    this.next();
                    return this.finishNode(node, "VoidTypeAnnotation");
                case 84:
                    this.next();
                    return this.finishNode(node, "NullLiteralTypeAnnotation");
                case 78:
                    this.next();
                    return this.finishNode(node, "ThisTypeAnnotation");
                case 55:
                    this.next();
                    return this.finishNode(node, "ExistsTypeAnnotation");
                case 87:
                    return this.flowParseTypeofType();
                default:
                    if ($b48499974d50e8d0$var$tokenIsKeyword(this.state.type)) {
                        const label = $b48499974d50e8d0$var$tokenLabelName(this.state.type);
                        this.next();
                        return super.createIdentifier(node, label);
                    } else if ($b48499974d50e8d0$var$tokenIsIdentifier(this.state.type)) {
                        if (this.isContextual(129)) return this.flowParseInterfaceType();
                        return this.flowIdentToTypeAnnotation(startLoc, node, this.parseIdentifier());
                    }
            }
            this.unexpected();
        }
        flowParsePostfixType() {
            const startLoc = this.state.startLoc;
            let type = this.flowParsePrimaryType();
            let seenOptionalIndexedAccess = false;
            while((this.match(0) || this.match(18)) && !this.canInsertSemicolon()){
                const node = this.startNodeAt(startLoc);
                const optional = this.eat(18);
                seenOptionalIndexedAccess = seenOptionalIndexedAccess || optional;
                this.expect(0);
                if (!optional && this.match(3)) {
                    node.elementType = type;
                    this.next();
                    type = this.finishNode(node, "ArrayTypeAnnotation");
                } else {
                    node.objectType = type;
                    node.indexType = this.flowParseType();
                    this.expect(3);
                    if (seenOptionalIndexedAccess) {
                        node.optional = optional;
                        type = this.finishNode(node, "OptionalIndexedAccessType");
                    } else type = this.finishNode(node, "IndexedAccessType");
                }
            }
            return type;
        }
        flowParsePrefixType() {
            const node = this.startNode();
            if (this.eat(17)) {
                node.typeAnnotation = this.flowParsePrefixType();
                return this.finishNode(node, "NullableTypeAnnotation");
            } else return this.flowParsePostfixType();
        }
        flowParseAnonFunctionWithoutParens() {
            const param = this.flowParsePrefixType();
            if (!this.state.noAnonFunctionType && this.eat(19)) {
                const node = this.startNodeAt(param.loc.start);
                node.params = [
                    this.reinterpretTypeAsFunctionTypeParam(param)
                ];
                node.rest = null;
                node.this = null;
                node.returnType = this.flowParseType();
                node.typeParameters = null;
                return this.finishNode(node, "FunctionTypeAnnotation");
            }
            return param;
        }
        flowParseIntersectionType() {
            const node = this.startNode();
            this.eat(45);
            const type = this.flowParseAnonFunctionWithoutParens();
            node.types = [
                type
            ];
            while(this.eat(45))node.types.push(this.flowParseAnonFunctionWithoutParens());
            return node.types.length === 1 ? type : this.finishNode(node, "IntersectionTypeAnnotation");
        }
        flowParseUnionType() {
            const node = this.startNode();
            this.eat(43);
            const type = this.flowParseIntersectionType();
            node.types = [
                type
            ];
            while(this.eat(43))node.types.push(this.flowParseIntersectionType());
            return node.types.length === 1 ? type : this.finishNode(node, "UnionTypeAnnotation");
        }
        flowParseType() {
            const oldInType = this.state.inType;
            this.state.inType = true;
            const type = this.flowParseUnionType();
            this.state.inType = oldInType;
            return type;
        }
        flowParseTypeOrImplicitInstantiation() {
            if (this.state.type === 132 && this.state.value === "_") {
                const startLoc = this.state.startLoc;
                const node = this.parseIdentifier();
                return this.flowParseGenericType(startLoc, node);
            } else return this.flowParseType();
        }
        flowParseTypeAnnotation() {
            const node = this.startNode();
            node.typeAnnotation = this.flowParseTypeInitialiser();
            return this.finishNode(node, "TypeAnnotation");
        }
        flowParseTypeAnnotatableIdentifier(allowPrimitiveOverride) {
            const ident = allowPrimitiveOverride ? this.parseIdentifier() : this.flowParseRestrictedIdentifier();
            if (this.match(14)) {
                ident.typeAnnotation = this.flowParseTypeAnnotation();
                this.resetEndLocation(ident);
            }
            return ident;
        }
        typeCastToParameter(node) {
            node.expression.typeAnnotation = node.typeAnnotation;
            this.resetEndLocation(node.expression, node.typeAnnotation.loc.end);
            return node.expression;
        }
        flowParseVariance() {
            let variance = null;
            if (this.match(53)) {
                variance = this.startNode();
                if (this.state.value === "+") variance.kind = "plus";
                else variance.kind = "minus";
                this.next();
                return this.finishNode(variance, "Variance");
            }
            return variance;
        }
        parseFunctionBody(node, allowExpressionBody, isMethod = false) {
            if (allowExpressionBody) {
                this.forwardNoArrowParamsConversionAt(node, ()=>super.parseFunctionBody(node, true, isMethod));
                return;
            }
            super.parseFunctionBody(node, false, isMethod);
        }
        parseFunctionBodyAndFinish(node, type, isMethod = false) {
            if (this.match(14)) {
                const typeNode = this.startNode();
                [typeNode.typeAnnotation, node.predicate] = this.flowParseTypeAndPredicateInitialiser();
                node.returnType = typeNode.typeAnnotation ? this.finishNode(typeNode, "TypeAnnotation") : null;
            }
            return super.parseFunctionBodyAndFinish(node, type, isMethod);
        }
        parseStatementLike(flags) {
            if (this.state.strict && this.isContextual(129)) {
                const lookahead = this.lookahead();
                if ($b48499974d50e8d0$var$tokenIsKeywordOrIdentifier(lookahead.type)) {
                    const node = this.startNode();
                    this.next();
                    return this.flowParseInterface(node);
                }
            } else if (this.shouldParseEnums() && this.isContextual(126)) {
                const node = this.startNode();
                this.next();
                return this.flowParseEnumDeclaration(node);
            }
            const stmt = super.parseStatementLike(flags);
            if (this.flowPragma === undefined && !this.isValidDirective(stmt)) this.flowPragma = null;
            return stmt;
        }
        parseExpressionStatement(node, expr, decorators) {
            if (expr.type === "Identifier") {
                if (expr.name === "declare") {
                    if (this.match(80) || $b48499974d50e8d0$var$tokenIsIdentifier(this.state.type) || this.match(68) || this.match(74) || this.match(82)) return this.flowParseDeclare(node);
                } else if ($b48499974d50e8d0$var$tokenIsIdentifier(this.state.type)) {
                    if (expr.name === "interface") return this.flowParseInterface(node);
                    else if (expr.name === "type") return this.flowParseTypeAlias(node);
                    else if (expr.name === "opaque") return this.flowParseOpaqueType(node, false);
                }
            }
            return super.parseExpressionStatement(node, expr, decorators);
        }
        shouldParseExportDeclaration() {
            const { type: type } = this.state;
            if ($b48499974d50e8d0$var$tokenIsFlowInterfaceOrTypeOrOpaque(type) || this.shouldParseEnums() && type === 126) return !this.state.containsEsc;
            return super.shouldParseExportDeclaration();
        }
        isExportDefaultSpecifier() {
            const { type: type } = this.state;
            if ($b48499974d50e8d0$var$tokenIsFlowInterfaceOrTypeOrOpaque(type) || this.shouldParseEnums() && type === 126) return this.state.containsEsc;
            return super.isExportDefaultSpecifier();
        }
        parseExportDefaultExpression() {
            if (this.shouldParseEnums() && this.isContextual(126)) {
                const node = this.startNode();
                this.next();
                return this.flowParseEnumDeclaration(node);
            }
            return super.parseExportDefaultExpression();
        }
        parseConditional(expr, startLoc, refExpressionErrors) {
            if (!this.match(17)) return expr;
            if (this.state.maybeInArrowParameters) {
                const nextCh = this.lookaheadCharCode();
                if (nextCh === 44 || nextCh === 61 || nextCh === 58 || nextCh === 41) {
                    this.setOptionalParametersError(refExpressionErrors);
                    return expr;
                }
            }
            this.expect(17);
            const state = this.state.clone();
            const originalNoArrowAt = this.state.noArrowAt;
            const node = this.startNodeAt(startLoc);
            let { consequent: consequent, failed: failed } = this.tryParseConditionalConsequent();
            let [valid, invalid] = this.getArrowLikeExpressions(consequent);
            if (failed || invalid.length > 0) {
                const noArrowAt = [
                    ...originalNoArrowAt
                ];
                if (invalid.length > 0) {
                    this.state = state;
                    this.state.noArrowAt = noArrowAt;
                    for(let i = 0; i < invalid.length; i++)noArrowAt.push(invalid[i].start);
                    ({ consequent: consequent, failed: failed } = this.tryParseConditionalConsequent());
                    [valid, invalid] = this.getArrowLikeExpressions(consequent);
                }
                if (failed && valid.length > 1) this.raise($b48499974d50e8d0$var$FlowErrors.AmbiguousConditionalArrow, state.startLoc);
                if (failed && valid.length === 1) {
                    this.state = state;
                    noArrowAt.push(valid[0].start);
                    this.state.noArrowAt = noArrowAt;
                    ({ consequent: consequent, failed: failed } = this.tryParseConditionalConsequent());
                }
            }
            this.getArrowLikeExpressions(consequent, true);
            this.state.noArrowAt = originalNoArrowAt;
            this.expect(14);
            node.test = expr;
            node.consequent = consequent;
            node.alternate = this.forwardNoArrowParamsConversionAt(node, ()=>this.parseMaybeAssign(undefined, undefined));
            return this.finishNode(node, "ConditionalExpression");
        }
        tryParseConditionalConsequent() {
            this.state.noArrowParamsConversionAt.push(this.state.start);
            const consequent = this.parseMaybeAssignAllowIn();
            const failed = !this.match(14);
            this.state.noArrowParamsConversionAt.pop();
            return {
                consequent: consequent,
                failed: failed
            };
        }
        getArrowLikeExpressions(node, disallowInvalid) {
            const stack = [
                node
            ];
            const arrows = [];
            while(stack.length !== 0){
                const node = stack.pop();
                if (node.type === "ArrowFunctionExpression") {
                    if (node.typeParameters || !node.returnType) this.finishArrowValidation(node);
                    else arrows.push(node);
                    stack.push(node.body);
                } else if (node.type === "ConditionalExpression") {
                    stack.push(node.consequent);
                    stack.push(node.alternate);
                }
            }
            if (disallowInvalid) {
                arrows.forEach((node)=>this.finishArrowValidation(node));
                return [
                    arrows,
                    []
                ];
            }
            return $b48499974d50e8d0$var$partition(arrows, (node)=>node.params.every((param)=>this.isAssignable(param, true)));
        }
        finishArrowValidation(node) {
            var _node$extra;
            this.toAssignableList(node.params, (_node$extra = node.extra) == null ? void 0 : _node$extra.trailingCommaLoc, false);
            this.scope.enter(6);
            super.checkParams(node, false, true);
            this.scope.exit();
        }
        forwardNoArrowParamsConversionAt(node, parse) {
            let result;
            if (this.state.noArrowParamsConversionAt.indexOf(node.start) !== -1) {
                this.state.noArrowParamsConversionAt.push(this.state.start);
                result = parse();
                this.state.noArrowParamsConversionAt.pop();
            } else result = parse();
            return result;
        }
        parseParenItem(node, startLoc) {
            node = super.parseParenItem(node, startLoc);
            if (this.eat(17)) {
                node.optional = true;
                this.resetEndLocation(node);
            }
            if (this.match(14)) {
                const typeCastNode = this.startNodeAt(startLoc);
                typeCastNode.expression = node;
                typeCastNode.typeAnnotation = this.flowParseTypeAnnotation();
                return this.finishNode(typeCastNode, "TypeCastExpression");
            }
            return node;
        }
        assertModuleNodeAllowed(node) {
            if (node.type === "ImportDeclaration" && (node.importKind === "type" || node.importKind === "typeof") || node.type === "ExportNamedDeclaration" && node.exportKind === "type" || node.type === "ExportAllDeclaration" && node.exportKind === "type") return;
            super.assertModuleNodeAllowed(node);
        }
        parseExportDeclaration(node) {
            if (this.isContextual(130)) {
                node.exportKind = "type";
                const declarationNode = this.startNode();
                this.next();
                if (this.match(5)) {
                    node.specifiers = this.parseExportSpecifiers(true);
                    super.parseExportFrom(node);
                    return null;
                } else return this.flowParseTypeAlias(declarationNode);
            } else if (this.isContextual(131)) {
                node.exportKind = "type";
                const declarationNode = this.startNode();
                this.next();
                return this.flowParseOpaqueType(declarationNode, false);
            } else if (this.isContextual(129)) {
                node.exportKind = "type";
                const declarationNode = this.startNode();
                this.next();
                return this.flowParseInterface(declarationNode);
            } else if (this.shouldParseEnums() && this.isContextual(126)) {
                node.exportKind = "value";
                const declarationNode = this.startNode();
                this.next();
                return this.flowParseEnumDeclaration(declarationNode);
            } else return super.parseExportDeclaration(node);
        }
        eatExportStar(node) {
            if (super.eatExportStar(node)) return true;
            if (this.isContextual(130) && this.lookahead().type === 55) {
                node.exportKind = "type";
                this.next();
                this.next();
                return true;
            }
            return false;
        }
        maybeParseExportNamespaceSpecifier(node) {
            const { startLoc: startLoc } = this.state;
            const hasNamespace = super.maybeParseExportNamespaceSpecifier(node);
            if (hasNamespace && node.exportKind === "type") this.unexpected(startLoc);
            return hasNamespace;
        }
        parseClassId(node, isStatement, optionalId) {
            super.parseClassId(node, isStatement, optionalId);
            if (this.match(47)) node.typeParameters = this.flowParseTypeParameterDeclaration();
        }
        parseClassMember(classBody, member, state) {
            const { startLoc: startLoc } = this.state;
            if (this.isContextual(125)) {
                if (super.parseClassMemberFromModifier(classBody, member)) return;
                member.declare = true;
            }
            super.parseClassMember(classBody, member, state);
            if (member.declare) {
                if (member.type !== "ClassProperty" && member.type !== "ClassPrivateProperty" && member.type !== "PropertyDefinition") this.raise($b48499974d50e8d0$var$FlowErrors.DeclareClassElement, startLoc);
                else if (member.value) this.raise($b48499974d50e8d0$var$FlowErrors.DeclareClassFieldInitializer, member.value);
            }
        }
        isIterator(word) {
            return word === "iterator" || word === "asyncIterator";
        }
        readIterator() {
            const word = super.readWord1();
            const fullWord = "@@" + word;
            if (!this.isIterator(word) || !this.state.inType) this.raise($b48499974d50e8d0$var$Errors.InvalidIdentifier, this.state.curPosition(), {
                identifierName: fullWord
            });
            this.finishToken(132, fullWord);
        }
        getTokenFromCode(code) {
            const next = this.input.charCodeAt(this.state.pos + 1);
            if (code === 123 && next === 124) this.finishOp(6, 2);
            else if (this.state.inType && (code === 62 || code === 60)) this.finishOp(code === 62 ? 48 : 47, 1);
            else if (this.state.inType && code === 63) {
                if (next === 46) this.finishOp(18, 2);
                else this.finishOp(17, 1);
            } else if ($b48499974d50e8d0$var$isIteratorStart(code, next, this.input.charCodeAt(this.state.pos + 2))) {
                this.state.pos += 2;
                this.readIterator();
            } else super.getTokenFromCode(code);
        }
        isAssignable(node, isBinding) {
            if (node.type === "TypeCastExpression") return this.isAssignable(node.expression, isBinding);
            else return super.isAssignable(node, isBinding);
        }
        toAssignable(node, isLHS = false) {
            if (!isLHS && node.type === "AssignmentExpression" && node.left.type === "TypeCastExpression") node.left = this.typeCastToParameter(node.left);
            super.toAssignable(node, isLHS);
        }
        toAssignableList(exprList, trailingCommaLoc, isLHS) {
            for(let i = 0; i < exprList.length; i++){
                const expr = exprList[i];
                if ((expr == null ? void 0 : expr.type) === "TypeCastExpression") exprList[i] = this.typeCastToParameter(expr);
            }
            super.toAssignableList(exprList, trailingCommaLoc, isLHS);
        }
        toReferencedList(exprList, isParenthesizedExpr) {
            for(let i = 0; i < exprList.length; i++){
                var _expr$extra;
                const expr = exprList[i];
                if (expr && expr.type === "TypeCastExpression" && !((_expr$extra = expr.extra) != null && _expr$extra.parenthesized) && (exprList.length > 1 || !isParenthesizedExpr)) this.raise($b48499974d50e8d0$var$FlowErrors.TypeCastInPattern, expr.typeAnnotation);
            }
            return exprList;
        }
        parseArrayLike(close, canBePattern, isTuple, refExpressionErrors) {
            const node = super.parseArrayLike(close, canBePattern, isTuple, refExpressionErrors);
            if (canBePattern && !this.state.maybeInArrowParameters) this.toReferencedList(node.elements);
            return node;
        }
        isValidLVal(type, isParenthesized, binding) {
            return type === "TypeCastExpression" || super.isValidLVal(type, isParenthesized, binding);
        }
        parseClassProperty(node) {
            if (this.match(14)) node.typeAnnotation = this.flowParseTypeAnnotation();
            return super.parseClassProperty(node);
        }
        parseClassPrivateProperty(node) {
            if (this.match(14)) node.typeAnnotation = this.flowParseTypeAnnotation();
            return super.parseClassPrivateProperty(node);
        }
        isClassMethod() {
            return this.match(47) || super.isClassMethod();
        }
        isClassProperty() {
            return this.match(14) || super.isClassProperty();
        }
        isNonstaticConstructor(method) {
            return !this.match(14) && super.isNonstaticConstructor(method);
        }
        pushClassMethod(classBody, method, isGenerator, isAsync, isConstructor, allowsDirectSuper) {
            if (method.variance) this.unexpected(method.variance.loc.start);
            delete method.variance;
            if (this.match(47)) method.typeParameters = this.flowParseTypeParameterDeclaration();
            super.pushClassMethod(classBody, method, isGenerator, isAsync, isConstructor, allowsDirectSuper);
            if (method.params && isConstructor) {
                const params = method.params;
                if (params.length > 0 && this.isThisParam(params[0])) this.raise($b48499974d50e8d0$var$FlowErrors.ThisParamBannedInConstructor, method);
            } else if (method.type === "MethodDefinition" && isConstructor && method.value.params) {
                const params = method.value.params;
                if (params.length > 0 && this.isThisParam(params[0])) this.raise($b48499974d50e8d0$var$FlowErrors.ThisParamBannedInConstructor, method);
            }
        }
        pushClassPrivateMethod(classBody, method, isGenerator, isAsync) {
            if (method.variance) this.unexpected(method.variance.loc.start);
            delete method.variance;
            if (this.match(47)) method.typeParameters = this.flowParseTypeParameterDeclaration();
            super.pushClassPrivateMethod(classBody, method, isGenerator, isAsync);
        }
        parseClassSuper(node) {
            super.parseClassSuper(node);
            if (node.superClass && this.match(47)) node.superTypeParameters = this.flowParseTypeParameterInstantiation();
            if (this.isContextual(113)) {
                this.next();
                const implemented = node.implements = [];
                do {
                    const node = this.startNode();
                    node.id = this.flowParseRestrictedIdentifier(true);
                    if (this.match(47)) node.typeParameters = this.flowParseTypeParameterInstantiation();
                    else node.typeParameters = null;
                    implemented.push(this.finishNode(node, "ClassImplements"));
                }while (this.eat(12));
            }
        }
        checkGetterSetterParams(method) {
            super.checkGetterSetterParams(method);
            const params = this.getObjectOrClassMethodParams(method);
            if (params.length > 0) {
                const param = params[0];
                if (this.isThisParam(param) && method.kind === "get") this.raise($b48499974d50e8d0$var$FlowErrors.GetterMayNotHaveThisParam, param);
                else if (this.isThisParam(param)) this.raise($b48499974d50e8d0$var$FlowErrors.SetterMayNotHaveThisParam, param);
            }
        }
        parsePropertyNamePrefixOperator(node) {
            node.variance = this.flowParseVariance();
        }
        parseObjPropValue(prop, startLoc, isGenerator, isAsync, isPattern, isAccessor, refExpressionErrors) {
            if (prop.variance) this.unexpected(prop.variance.loc.start);
            delete prop.variance;
            let typeParameters;
            if (this.match(47) && !isAccessor) {
                typeParameters = this.flowParseTypeParameterDeclaration();
                if (!this.match(10)) this.unexpected();
            }
            const result = super.parseObjPropValue(prop, startLoc, isGenerator, isAsync, isPattern, isAccessor, refExpressionErrors);
            if (typeParameters) (result.value || result).typeParameters = typeParameters;
            return result;
        }
        parseAssignableListItemTypes(param) {
            if (this.eat(17)) {
                if (param.type !== "Identifier") this.raise($b48499974d50e8d0$var$FlowErrors.PatternIsOptional, param);
                if (this.isThisParam(param)) this.raise($b48499974d50e8d0$var$FlowErrors.ThisParamMayNotBeOptional, param);
                param.optional = true;
            }
            if (this.match(14)) param.typeAnnotation = this.flowParseTypeAnnotation();
            else if (this.isThisParam(param)) this.raise($b48499974d50e8d0$var$FlowErrors.ThisParamAnnotationRequired, param);
            if (this.match(29) && this.isThisParam(param)) this.raise($b48499974d50e8d0$var$FlowErrors.ThisParamNoDefault, param);
            this.resetEndLocation(param);
            return param;
        }
        parseMaybeDefault(startLoc, left) {
            const node = super.parseMaybeDefault(startLoc, left);
            if (node.type === "AssignmentPattern" && node.typeAnnotation && node.right.start < node.typeAnnotation.start) this.raise($b48499974d50e8d0$var$FlowErrors.TypeBeforeInitializer, node.typeAnnotation);
            return node;
        }
        checkImportReflection(node) {
            super.checkImportReflection(node);
            if (node.module && node.importKind !== "value") this.raise($b48499974d50e8d0$var$FlowErrors.ImportReflectionHasImportType, node.specifiers[0].loc.start);
        }
        parseImportSpecifierLocal(node, specifier, type) {
            specifier.local = $b48499974d50e8d0$var$hasTypeImportKind(node) ? this.flowParseRestrictedIdentifier(true, true) : this.parseIdentifier();
            node.specifiers.push(this.finishImportSpecifier(specifier, type));
        }
        isPotentialImportPhase(isExport) {
            if (super.isPotentialImportPhase(isExport)) return true;
            if (this.isContextual(130)) {
                if (!isExport) return true;
                const ch = this.lookaheadCharCode();
                return ch === 123 || ch === 42;
            }
            return !isExport && this.isContextual(87);
        }
        applyImportPhase(node, isExport, phase, loc) {
            super.applyImportPhase(node, isExport, phase, loc);
            if (isExport) {
                if (!phase && this.match(65)) return;
                node.exportKind = phase === "type" ? phase : "value";
            } else {
                if (phase === "type" && this.match(55)) this.unexpected();
                node.importKind = phase === "type" || phase === "typeof" ? phase : "value";
            }
        }
        parseImportSpecifier(specifier, importedIsString, isInTypeOnlyImport, isMaybeTypeOnly, bindingType) {
            const firstIdent = specifier.imported;
            let specifierTypeKind = null;
            if (firstIdent.type === "Identifier") {
                if (firstIdent.name === "type") specifierTypeKind = "type";
                else if (firstIdent.name === "typeof") specifierTypeKind = "typeof";
            }
            let isBinding = false;
            if (this.isContextual(93) && !this.isLookaheadContextual("as")) {
                const as_ident = this.parseIdentifier(true);
                if (specifierTypeKind !== null && !$b48499974d50e8d0$var$tokenIsKeywordOrIdentifier(this.state.type)) {
                    specifier.imported = as_ident;
                    specifier.importKind = specifierTypeKind;
                    specifier.local = $b48499974d50e8d0$var$cloneIdentifier(as_ident);
                } else {
                    specifier.imported = firstIdent;
                    specifier.importKind = null;
                    specifier.local = this.parseIdentifier();
                }
            } else {
                if (specifierTypeKind !== null && $b48499974d50e8d0$var$tokenIsKeywordOrIdentifier(this.state.type)) {
                    specifier.imported = this.parseIdentifier(true);
                    specifier.importKind = specifierTypeKind;
                } else {
                    if (importedIsString) throw this.raise($b48499974d50e8d0$var$Errors.ImportBindingIsString, specifier, {
                        importName: firstIdent.value
                    });
                    specifier.imported = firstIdent;
                    specifier.importKind = null;
                }
                if (this.eatContextual(93)) specifier.local = this.parseIdentifier();
                else {
                    isBinding = true;
                    specifier.local = $b48499974d50e8d0$var$cloneIdentifier(specifier.imported);
                }
            }
            const specifierIsTypeImport = $b48499974d50e8d0$var$hasTypeImportKind(specifier);
            if (isInTypeOnlyImport && specifierIsTypeImport) this.raise($b48499974d50e8d0$var$FlowErrors.ImportTypeShorthandOnlyInPureImport, specifier);
            if (isInTypeOnlyImport || specifierIsTypeImport) this.checkReservedType(specifier.local.name, specifier.local.loc.start, true);
            if (isBinding && !isInTypeOnlyImport && !specifierIsTypeImport) this.checkReservedWord(specifier.local.name, specifier.loc.start, true, true);
            return this.finishImportSpecifier(specifier, "ImportSpecifier");
        }
        parseBindingAtom() {
            switch(this.state.type){
                case 78:
                    return this.parseIdentifier(true);
                default:
                    return super.parseBindingAtom();
            }
        }
        parseFunctionParams(node, isConstructor) {
            const kind = node.kind;
            if (kind !== "get" && kind !== "set" && this.match(47)) node.typeParameters = this.flowParseTypeParameterDeclaration();
            super.parseFunctionParams(node, isConstructor);
        }
        parseVarId(decl, kind) {
            super.parseVarId(decl, kind);
            if (this.match(14)) {
                decl.id.typeAnnotation = this.flowParseTypeAnnotation();
                this.resetEndLocation(decl.id);
            }
        }
        parseAsyncArrowFromCallExpression(node, call) {
            if (this.match(14)) {
                const oldNoAnonFunctionType = this.state.noAnonFunctionType;
                this.state.noAnonFunctionType = true;
                node.returnType = this.flowParseTypeAnnotation();
                this.state.noAnonFunctionType = oldNoAnonFunctionType;
            }
            return super.parseAsyncArrowFromCallExpression(node, call);
        }
        shouldParseAsyncArrow() {
            return this.match(14) || super.shouldParseAsyncArrow();
        }
        parseMaybeAssign(refExpressionErrors, afterLeftParse) {
            var _jsx;
            let state = null;
            let jsx;
            if (this.hasPlugin("jsx") && (this.match(142) || this.match(47))) {
                state = this.state.clone();
                jsx = this.tryParse(()=>super.parseMaybeAssign(refExpressionErrors, afterLeftParse), state);
                if (!jsx.error) return jsx.node;
                const { context: context } = this.state;
                const currentContext = context[context.length - 1];
                if (currentContext === $b48499974d50e8d0$var$types.j_oTag || currentContext === $b48499974d50e8d0$var$types.j_expr) context.pop();
            }
            if ((_jsx = jsx) != null && _jsx.error || this.match(47)) {
                var _jsx2, _jsx3;
                state = state || this.state.clone();
                let typeParameters;
                const arrow = this.tryParse((abort)=>{
                    var _arrowExpression$extr;
                    typeParameters = this.flowParseTypeParameterDeclaration();
                    const arrowExpression = this.forwardNoArrowParamsConversionAt(typeParameters, ()=>{
                        const result = super.parseMaybeAssign(refExpressionErrors, afterLeftParse);
                        this.resetStartLocationFromNode(result, typeParameters);
                        return result;
                    });
                    if ((_arrowExpression$extr = arrowExpression.extra) != null && _arrowExpression$extr.parenthesized) abort();
                    const expr = this.maybeUnwrapTypeCastExpression(arrowExpression);
                    if (expr.type !== "ArrowFunctionExpression") abort();
                    expr.typeParameters = typeParameters;
                    this.resetStartLocationFromNode(expr, typeParameters);
                    return arrowExpression;
                }, state);
                let arrowExpression = null;
                if (arrow.node && this.maybeUnwrapTypeCastExpression(arrow.node).type === "ArrowFunctionExpression") {
                    if (!arrow.error && !arrow.aborted) {
                        if (arrow.node.async) this.raise($b48499974d50e8d0$var$FlowErrors.UnexpectedTypeParameterBeforeAsyncArrowFunction, typeParameters);
                        return arrow.node;
                    }
                    arrowExpression = arrow.node;
                }
                if ((_jsx2 = jsx) != null && _jsx2.node) {
                    this.state = jsx.failState;
                    return jsx.node;
                }
                if (arrowExpression) {
                    this.state = arrow.failState;
                    return arrowExpression;
                }
                if ((_jsx3 = jsx) != null && _jsx3.thrown) throw jsx.error;
                if (arrow.thrown) throw arrow.error;
                throw this.raise($b48499974d50e8d0$var$FlowErrors.UnexpectedTokenAfterTypeParameter, typeParameters);
            }
            return super.parseMaybeAssign(refExpressionErrors, afterLeftParse);
        }
        parseArrow(node) {
            if (this.match(14)) {
                const result = this.tryParse(()=>{
                    const oldNoAnonFunctionType = this.state.noAnonFunctionType;
                    this.state.noAnonFunctionType = true;
                    const typeNode = this.startNode();
                    [typeNode.typeAnnotation, node.predicate] = this.flowParseTypeAndPredicateInitialiser();
                    this.state.noAnonFunctionType = oldNoAnonFunctionType;
                    if (this.canInsertSemicolon()) this.unexpected();
                    if (!this.match(19)) this.unexpected();
                    return typeNode;
                });
                if (result.thrown) return null;
                if (result.error) this.state = result.failState;
                node.returnType = result.node.typeAnnotation ? this.finishNode(result.node, "TypeAnnotation") : null;
            }
            return super.parseArrow(node);
        }
        shouldParseArrow(params) {
            return this.match(14) || super.shouldParseArrow(params);
        }
        setArrowFunctionParameters(node, params) {
            if (this.state.noArrowParamsConversionAt.indexOf(node.start) !== -1) node.params = params;
            else super.setArrowFunctionParameters(node, params);
        }
        checkParams(node, allowDuplicates, isArrowFunction, strictModeChanged = true) {
            if (isArrowFunction && this.state.noArrowParamsConversionAt.indexOf(node.start) !== -1) return;
            for(let i = 0; i < node.params.length; i++)if (this.isThisParam(node.params[i]) && i > 0) this.raise($b48499974d50e8d0$var$FlowErrors.ThisParamMustBeFirst, node.params[i]);
            super.checkParams(node, allowDuplicates, isArrowFunction, strictModeChanged);
        }
        parseParenAndDistinguishExpression(canBeArrow) {
            return super.parseParenAndDistinguishExpression(canBeArrow && this.state.noArrowAt.indexOf(this.state.start) === -1);
        }
        parseSubscripts(base, startLoc, noCalls) {
            if (base.type === "Identifier" && base.name === "async" && this.state.noArrowAt.indexOf(startLoc.index) !== -1) {
                this.next();
                const node = this.startNodeAt(startLoc);
                node.callee = base;
                node.arguments = super.parseCallExpressionArguments(11, false);
                base = this.finishNode(node, "CallExpression");
            } else if (base.type === "Identifier" && base.name === "async" && this.match(47)) {
                const state = this.state.clone();
                const arrow = this.tryParse((abort)=>this.parseAsyncArrowWithTypeParameters(startLoc) || abort(), state);
                if (!arrow.error && !arrow.aborted) return arrow.node;
                const result = this.tryParse(()=>super.parseSubscripts(base, startLoc, noCalls), state);
                if (result.node && !result.error) return result.node;
                if (arrow.node) {
                    this.state = arrow.failState;
                    return arrow.node;
                }
                if (result.node) {
                    this.state = result.failState;
                    return result.node;
                }
                throw arrow.error || result.error;
            }
            return super.parseSubscripts(base, startLoc, noCalls);
        }
        parseSubscript(base, startLoc, noCalls, subscriptState) {
            if (this.match(18) && this.isLookaheadToken_lt()) {
                subscriptState.optionalChainMember = true;
                if (noCalls) {
                    subscriptState.stop = true;
                    return base;
                }
                this.next();
                const node = this.startNodeAt(startLoc);
                node.callee = base;
                node.typeArguments = this.flowParseTypeParameterInstantiation();
                this.expect(10);
                node.arguments = this.parseCallExpressionArguments(11, false);
                node.optional = true;
                return this.finishCallExpression(node, true);
            } else if (!noCalls && this.shouldParseTypes() && this.match(47)) {
                const node = this.startNodeAt(startLoc);
                node.callee = base;
                const result = this.tryParse(()=>{
                    node.typeArguments = this.flowParseTypeParameterInstantiationCallOrNew();
                    this.expect(10);
                    node.arguments = super.parseCallExpressionArguments(11, false);
                    if (subscriptState.optionalChainMember) node.optional = false;
                    return this.finishCallExpression(node, subscriptState.optionalChainMember);
                });
                if (result.node) {
                    if (result.error) this.state = result.failState;
                    return result.node;
                }
            }
            return super.parseSubscript(base, startLoc, noCalls, subscriptState);
        }
        parseNewCallee(node) {
            super.parseNewCallee(node);
            let targs = null;
            if (this.shouldParseTypes() && this.match(47)) targs = this.tryParse(()=>this.flowParseTypeParameterInstantiationCallOrNew()).node;
            node.typeArguments = targs;
        }
        parseAsyncArrowWithTypeParameters(startLoc) {
            const node = this.startNodeAt(startLoc);
            this.parseFunctionParams(node, false);
            if (!this.parseArrow(node)) return;
            return super.parseArrowExpression(node, undefined, true);
        }
        readToken_mult_modulo(code) {
            const next = this.input.charCodeAt(this.state.pos + 1);
            if (code === 42 && next === 47 && this.state.hasFlowComment) {
                this.state.hasFlowComment = false;
                this.state.pos += 2;
                this.nextToken();
                return;
            }
            super.readToken_mult_modulo(code);
        }
        readToken_pipe_amp(code) {
            const next = this.input.charCodeAt(this.state.pos + 1);
            if (code === 124 && next === 125) {
                this.finishOp(9, 2);
                return;
            }
            super.readToken_pipe_amp(code);
        }
        parseTopLevel(file, program) {
            const fileNode = super.parseTopLevel(file, program);
            if (this.state.hasFlowComment) this.raise($b48499974d50e8d0$var$FlowErrors.UnterminatedFlowComment, this.state.curPosition());
            return fileNode;
        }
        skipBlockComment() {
            if (this.hasPlugin("flowComments") && this.skipFlowComment()) {
                if (this.state.hasFlowComment) throw this.raise($b48499974d50e8d0$var$FlowErrors.NestedFlowComment, this.state.startLoc);
                this.hasFlowCommentCompletion();
                const commentSkip = this.skipFlowComment();
                if (commentSkip) {
                    this.state.pos += commentSkip;
                    this.state.hasFlowComment = true;
                }
                return;
            }
            return super.skipBlockComment(this.state.hasFlowComment ? "*-/" : "*/");
        }
        skipFlowComment() {
            const { pos: pos } = this.state;
            let shiftToFirstNonWhiteSpace = 2;
            while([
                32,
                9
            ].includes(this.input.charCodeAt(pos + shiftToFirstNonWhiteSpace)))shiftToFirstNonWhiteSpace++;
            const ch2 = this.input.charCodeAt(shiftToFirstNonWhiteSpace + pos);
            const ch3 = this.input.charCodeAt(shiftToFirstNonWhiteSpace + pos + 1);
            if (ch2 === 58 && ch3 === 58) return shiftToFirstNonWhiteSpace + 2;
            if (this.input.slice(shiftToFirstNonWhiteSpace + pos, shiftToFirstNonWhiteSpace + pos + 12) === "flow-include") return shiftToFirstNonWhiteSpace + 12;
            if (ch2 === 58 && ch3 !== 58) return shiftToFirstNonWhiteSpace;
            return false;
        }
        hasFlowCommentCompletion() {
            const end = this.input.indexOf("*/", this.state.pos);
            if (end === -1) throw this.raise($b48499974d50e8d0$var$Errors.UnterminatedComment, this.state.curPosition());
        }
        flowEnumErrorBooleanMemberNotInitialized(loc, { enumName: enumName, memberName: memberName }) {
            this.raise($b48499974d50e8d0$var$FlowErrors.EnumBooleanMemberNotInitialized, loc, {
                memberName: memberName,
                enumName: enumName
            });
        }
        flowEnumErrorInvalidMemberInitializer(loc, enumContext) {
            return this.raise(!enumContext.explicitType ? $b48499974d50e8d0$var$FlowErrors.EnumInvalidMemberInitializerUnknownType : enumContext.explicitType === "symbol" ? $b48499974d50e8d0$var$FlowErrors.EnumInvalidMemberInitializerSymbolType : $b48499974d50e8d0$var$FlowErrors.EnumInvalidMemberInitializerPrimaryType, loc, enumContext);
        }
        flowEnumErrorNumberMemberNotInitialized(loc, details) {
            this.raise($b48499974d50e8d0$var$FlowErrors.EnumNumberMemberNotInitialized, loc, details);
        }
        flowEnumErrorStringMemberInconsistentlyInitialized(node, details) {
            this.raise($b48499974d50e8d0$var$FlowErrors.EnumStringMemberInconsistentlyInitialized, node, details);
        }
        flowEnumMemberInit() {
            const startLoc = this.state.startLoc;
            const endOfInit = ()=>this.match(12) || this.match(8);
            switch(this.state.type){
                case 134:
                    {
                        const literal = this.parseNumericLiteral(this.state.value);
                        if (endOfInit()) return {
                            type: "number",
                            loc: literal.loc.start,
                            value: literal
                        };
                        return {
                            type: "invalid",
                            loc: startLoc
                        };
                    }
                case 133:
                    {
                        const literal = this.parseStringLiteral(this.state.value);
                        if (endOfInit()) return {
                            type: "string",
                            loc: literal.loc.start,
                            value: literal
                        };
                        return {
                            type: "invalid",
                            loc: startLoc
                        };
                    }
                case 85:
                case 86:
                    {
                        const literal = this.parseBooleanLiteral(this.match(85));
                        if (endOfInit()) return {
                            type: "boolean",
                            loc: literal.loc.start,
                            value: literal
                        };
                        return {
                            type: "invalid",
                            loc: startLoc
                        };
                    }
                default:
                    return {
                        type: "invalid",
                        loc: startLoc
                    };
            }
        }
        flowEnumMemberRaw() {
            const loc = this.state.startLoc;
            const id = this.parseIdentifier(true);
            const init = this.eat(29) ? this.flowEnumMemberInit() : {
                type: "none",
                loc: loc
            };
            return {
                id: id,
                init: init
            };
        }
        flowEnumCheckExplicitTypeMismatch(loc, context, expectedType) {
            const { explicitType: explicitType } = context;
            if (explicitType === null) return;
            if (explicitType !== expectedType) this.flowEnumErrorInvalidMemberInitializer(loc, context);
        }
        flowEnumMembers({ enumName: enumName, explicitType: explicitType }) {
            const seenNames = new Set();
            const members = {
                booleanMembers: [],
                numberMembers: [],
                stringMembers: [],
                defaultedMembers: []
            };
            let hasUnknownMembers = false;
            while(!this.match(8)){
                if (this.eat(21)) {
                    hasUnknownMembers = true;
                    break;
                }
                const memberNode = this.startNode();
                const { id: id, init: init } = this.flowEnumMemberRaw();
                const memberName = id.name;
                if (memberName === "") continue;
                if (/^[a-z]/.test(memberName)) this.raise($b48499974d50e8d0$var$FlowErrors.EnumInvalidMemberName, id, {
                    memberName: memberName,
                    suggestion: memberName[0].toUpperCase() + memberName.slice(1),
                    enumName: enumName
                });
                if (seenNames.has(memberName)) this.raise($b48499974d50e8d0$var$FlowErrors.EnumDuplicateMemberName, id, {
                    memberName: memberName,
                    enumName: enumName
                });
                seenNames.add(memberName);
                const context = {
                    enumName: enumName,
                    explicitType: explicitType,
                    memberName: memberName
                };
                memberNode.id = id;
                switch(init.type){
                    case "boolean":
                        this.flowEnumCheckExplicitTypeMismatch(init.loc, context, "boolean");
                        memberNode.init = init.value;
                        members.booleanMembers.push(this.finishNode(memberNode, "EnumBooleanMember"));
                        break;
                    case "number":
                        this.flowEnumCheckExplicitTypeMismatch(init.loc, context, "number");
                        memberNode.init = init.value;
                        members.numberMembers.push(this.finishNode(memberNode, "EnumNumberMember"));
                        break;
                    case "string":
                        this.flowEnumCheckExplicitTypeMismatch(init.loc, context, "string");
                        memberNode.init = init.value;
                        members.stringMembers.push(this.finishNode(memberNode, "EnumStringMember"));
                        break;
                    case "invalid":
                        throw this.flowEnumErrorInvalidMemberInitializer(init.loc, context);
                    case "none":
                        switch(explicitType){
                            case "boolean":
                                this.flowEnumErrorBooleanMemberNotInitialized(init.loc, context);
                                break;
                            case "number":
                                this.flowEnumErrorNumberMemberNotInitialized(init.loc, context);
                                break;
                            default:
                                members.defaultedMembers.push(this.finishNode(memberNode, "EnumDefaultedMember"));
                        }
                }
                if (!this.match(8)) this.expect(12);
            }
            return {
                members: members,
                hasUnknownMembers: hasUnknownMembers
            };
        }
        flowEnumStringMembers(initializedMembers, defaultedMembers, { enumName: enumName }) {
            if (initializedMembers.length === 0) return defaultedMembers;
            else if (defaultedMembers.length === 0) return initializedMembers;
            else if (defaultedMembers.length > initializedMembers.length) {
                for (const member of initializedMembers)this.flowEnumErrorStringMemberInconsistentlyInitialized(member, {
                    enumName: enumName
                });
                return defaultedMembers;
            } else {
                for (const member of defaultedMembers)this.flowEnumErrorStringMemberInconsistentlyInitialized(member, {
                    enumName: enumName
                });
                return initializedMembers;
            }
        }
        flowEnumParseExplicitType({ enumName: enumName }) {
            if (!this.eatContextual(102)) return null;
            if (!$b48499974d50e8d0$var$tokenIsIdentifier(this.state.type)) throw this.raise($b48499974d50e8d0$var$FlowErrors.EnumInvalidExplicitTypeUnknownSupplied, this.state.startLoc, {
                enumName: enumName
            });
            const { value: value } = this.state;
            this.next();
            if (value !== "boolean" && value !== "number" && value !== "string" && value !== "symbol") this.raise($b48499974d50e8d0$var$FlowErrors.EnumInvalidExplicitType, this.state.startLoc, {
                enumName: enumName,
                invalidEnumType: value
            });
            return value;
        }
        flowEnumBody(node, id) {
            const enumName = id.name;
            const nameLoc = id.loc.start;
            const explicitType = this.flowEnumParseExplicitType({
                enumName: enumName
            });
            this.expect(5);
            const { members: members, hasUnknownMembers: hasUnknownMembers } = this.flowEnumMembers({
                enumName: enumName,
                explicitType: explicitType
            });
            node.hasUnknownMembers = hasUnknownMembers;
            switch(explicitType){
                case "boolean":
                    node.explicitType = true;
                    node.members = members.booleanMembers;
                    this.expect(8);
                    return this.finishNode(node, "EnumBooleanBody");
                case "number":
                    node.explicitType = true;
                    node.members = members.numberMembers;
                    this.expect(8);
                    return this.finishNode(node, "EnumNumberBody");
                case "string":
                    node.explicitType = true;
                    node.members = this.flowEnumStringMembers(members.stringMembers, members.defaultedMembers, {
                        enumName: enumName
                    });
                    this.expect(8);
                    return this.finishNode(node, "EnumStringBody");
                case "symbol":
                    node.members = members.defaultedMembers;
                    this.expect(8);
                    return this.finishNode(node, "EnumSymbolBody");
                default:
                    {
                        const empty = ()=>{
                            node.members = [];
                            this.expect(8);
                            return this.finishNode(node, "EnumStringBody");
                        };
                        node.explicitType = false;
                        const boolsLen = members.booleanMembers.length;
                        const numsLen = members.numberMembers.length;
                        const strsLen = members.stringMembers.length;
                        const defaultedLen = members.defaultedMembers.length;
                        if (!boolsLen && !numsLen && !strsLen && !defaultedLen) return empty();
                        else if (!boolsLen && !numsLen) {
                            node.members = this.flowEnumStringMembers(members.stringMembers, members.defaultedMembers, {
                                enumName: enumName
                            });
                            this.expect(8);
                            return this.finishNode(node, "EnumStringBody");
                        } else if (!numsLen && !strsLen && boolsLen >= defaultedLen) {
                            for (const member of members.defaultedMembers)this.flowEnumErrorBooleanMemberNotInitialized(member.loc.start, {
                                enumName: enumName,
                                memberName: member.id.name
                            });
                            node.members = members.booleanMembers;
                            this.expect(8);
                            return this.finishNode(node, "EnumBooleanBody");
                        } else if (!boolsLen && !strsLen && numsLen >= defaultedLen) {
                            for (const member of members.defaultedMembers)this.flowEnumErrorNumberMemberNotInitialized(member.loc.start, {
                                enumName: enumName,
                                memberName: member.id.name
                            });
                            node.members = members.numberMembers;
                            this.expect(8);
                            return this.finishNode(node, "EnumNumberBody");
                        } else {
                            this.raise($b48499974d50e8d0$var$FlowErrors.EnumInconsistentMemberValues, nameLoc, {
                                enumName: enumName
                            });
                            return empty();
                        }
                    }
            }
        }
        flowParseEnumDeclaration(node) {
            const id = this.parseIdentifier();
            node.id = id;
            node.body = this.flowEnumBody(this.startNode(), id);
            return this.finishNode(node, "EnumDeclaration");
        }
        isLookaheadToken_lt() {
            const next = this.nextTokenStart();
            if (this.input.charCodeAt(next) === 60) {
                const afterNext = this.input.charCodeAt(next + 1);
                return afterNext !== 60 && afterNext !== 61;
            }
            return false;
        }
        maybeUnwrapTypeCastExpression(node) {
            return node.type === "TypeCastExpression" ? node.expression : node;
        }
    };
const $b48499974d50e8d0$var$entities = {
    __proto__: null,
    quot: '"',
    amp: "&",
    apos: "'",
    lt: "<",
    gt: ">",
    nbsp: "\xa0",
    iexcl: "\xa1",
    cent: "\xa2",
    pound: "\xa3",
    curren: "\xa4",
    yen: "\xa5",
    brvbar: "\xa6",
    sect: "\xa7",
    uml: "\xa8",
    copy: "\xa9",
    ordf: "\xaa",
    laquo: "\xab",
    not: "\xac",
    shy: "\xad",
    reg: "\xae",
    macr: "\xaf",
    deg: "\xb0",
    plusmn: "\xb1",
    sup2: "\xb2",
    sup3: "\xb3",
    acute: "\xb4",
    micro: "\xb5",
    para: "\xb6",
    middot: "\xb7",
    cedil: "\xb8",
    sup1: "\xb9",
    ordm: "\xba",
    raquo: "\xbb",
    frac14: "\xbc",
    frac12: "\xbd",
    frac34: "\xbe",
    iquest: "\xbf",
    Agrave: "\xc0",
    Aacute: "\xc1",
    Acirc: "\xc2",
    Atilde: "\xc3",
    Auml: "\xc4",
    Aring: "\xc5",
    AElig: "\xc6",
    Ccedil: "\xc7",
    Egrave: "\xc8",
    Eacute: "\xc9",
    Ecirc: "\xca",
    Euml: "\xcb",
    Igrave: "\xcc",
    Iacute: "\xcd",
    Icirc: "\xce",
    Iuml: "\xcf",
    ETH: "\xd0",
    Ntilde: "\xd1",
    Ograve: "\xd2",
    Oacute: "\xd3",
    Ocirc: "\xd4",
    Otilde: "\xd5",
    Ouml: "\xd6",
    times: "\xd7",
    Oslash: "\xd8",
    Ugrave: "\xd9",
    Uacute: "\xda",
    Ucirc: "\xdb",
    Uuml: "\xdc",
    Yacute: "\xdd",
    THORN: "\xde",
    szlig: "\xdf",
    agrave: "\xe0",
    aacute: "\xe1",
    acirc: "\xe2",
    atilde: "\xe3",
    auml: "\xe4",
    aring: "\xe5",
    aelig: "\xe6",
    ccedil: "\xe7",
    egrave: "\xe8",
    eacute: "\xe9",
    ecirc: "\xea",
    euml: "\xeb",
    igrave: "\xec",
    iacute: "\xed",
    icirc: "\xee",
    iuml: "\xef",
    eth: "\xf0",
    ntilde: "\xf1",
    ograve: "\xf2",
    oacute: "\xf3",
    ocirc: "\xf4",
    otilde: "\xf5",
    ouml: "\xf6",
    divide: "\xf7",
    oslash: "\xf8",
    ugrave: "\xf9",
    uacute: "\xfa",
    ucirc: "\xfb",
    uuml: "\xfc",
    yacute: "\xfd",
    thorn: "\xfe",
    yuml: "\xff",
    OElig: "\u0152",
    oelig: "\u0153",
    Scaron: "\u0160",
    scaron: "\u0161",
    Yuml: "\u0178",
    fnof: "\u0192",
    circ: "\u02C6",
    tilde: "\u02DC",
    Alpha: "\u0391",
    Beta: "\u0392",
    Gamma: "\u0393",
    Delta: "\u0394",
    Epsilon: "\u0395",
    Zeta: "\u0396",
    Eta: "\u0397",
    Theta: "\u0398",
    Iota: "\u0399",
    Kappa: "\u039A",
    Lambda: "\u039B",
    Mu: "\u039C",
    Nu: "\u039D",
    Xi: "\u039E",
    Omicron: "\u039F",
    Pi: "\u03A0",
    Rho: "\u03A1",
    Sigma: "\u03A3",
    Tau: "\u03A4",
    Upsilon: "\u03A5",
    Phi: "\u03A6",
    Chi: "\u03A7",
    Psi: "\u03A8",
    Omega: "\u03A9",
    alpha: "\u03B1",
    beta: "\u03B2",
    gamma: "\u03B3",
    delta: "\u03B4",
    epsilon: "\u03B5",
    zeta: "\u03B6",
    eta: "\u03B7",
    theta: "\u03B8",
    iota: "\u03B9",
    kappa: "\u03BA",
    lambda: "\u03BB",
    mu: "\u03BC",
    nu: "\u03BD",
    xi: "\u03BE",
    omicron: "\u03BF",
    pi: "\u03C0",
    rho: "\u03C1",
    sigmaf: "\u03C2",
    sigma: "\u03C3",
    tau: "\u03C4",
    upsilon: "\u03C5",
    phi: "\u03C6",
    chi: "\u03C7",
    psi: "\u03C8",
    omega: "\u03C9",
    thetasym: "\u03D1",
    upsih: "\u03D2",
    piv: "\u03D6",
    ensp: "\u2002",
    emsp: "\u2003",
    thinsp: "\u2009",
    zwnj: "\u200C",
    zwj: "\u200D",
    lrm: "\u200E",
    rlm: "\u200F",
    ndash: "\u2013",
    mdash: "\u2014",
    lsquo: "\u2018",
    rsquo: "\u2019",
    sbquo: "\u201A",
    ldquo: "\u201C",
    rdquo: "\u201D",
    bdquo: "\u201E",
    dagger: "\u2020",
    Dagger: "\u2021",
    bull: "\u2022",
    hellip: "\u2026",
    permil: "\u2030",
    prime: "\u2032",
    Prime: "\u2033",
    lsaquo: "\u2039",
    rsaquo: "\u203A",
    oline: "\u203E",
    frasl: "\u2044",
    euro: "\u20AC",
    image: "\u2111",
    weierp: "\u2118",
    real: "\u211C",
    trade: "\u2122",
    alefsym: "\u2135",
    larr: "\u2190",
    uarr: "\u2191",
    rarr: "\u2192",
    darr: "\u2193",
    harr: "\u2194",
    crarr: "\u21B5",
    lArr: "\u21D0",
    uArr: "\u21D1",
    rArr: "\u21D2",
    dArr: "\u21D3",
    hArr: "\u21D4",
    forall: "\u2200",
    part: "\u2202",
    exist: "\u2203",
    empty: "\u2205",
    nabla: "\u2207",
    isin: "\u2208",
    notin: "\u2209",
    ni: "\u220B",
    prod: "\u220F",
    sum: "\u2211",
    minus: "\u2212",
    lowast: "\u2217",
    radic: "\u221A",
    prop: "\u221D",
    infin: "\u221E",
    ang: "\u2220",
    and: "\u2227",
    or: "\u2228",
    cap: "\u2229",
    cup: "\u222A",
    int: "\u222B",
    there4: "\u2234",
    sim: "\u223C",
    cong: "\u2245",
    asymp: "\u2248",
    ne: "\u2260",
    equiv: "\u2261",
    le: "\u2264",
    ge: "\u2265",
    sub: "\u2282",
    sup: "\u2283",
    nsub: "\u2284",
    sube: "\u2286",
    supe: "\u2287",
    oplus: "\u2295",
    otimes: "\u2297",
    perp: "\u22A5",
    sdot: "\u22C5",
    lceil: "\u2308",
    rceil: "\u2309",
    lfloor: "\u230A",
    rfloor: "\u230B",
    lang: "\u2329",
    rang: "\u232A",
    loz: "\u25CA",
    spades: "\u2660",
    clubs: "\u2663",
    hearts: "\u2665",
    diams: "\u2666"
};
const $b48499974d50e8d0$var$JsxErrors = $b48499974d50e8d0$var$ParseErrorEnum`jsx`({
    AttributeIsEmpty: "JSX attributes must only be assigned a non-empty expression.",
    MissingClosingTagElement: ({ openingTagName: openingTagName })=>`Expected corresponding JSX closing tag for <${openingTagName}>.`,
    MissingClosingTagFragment: "Expected corresponding JSX closing tag for <>.",
    UnexpectedSequenceExpression: "Sequence expressions cannot be directly nested inside JSX. Did you mean to wrap it in parentheses (...)?",
    UnexpectedToken: ({ unexpected: unexpected, HTMLEntity: HTMLEntity })=>`Unexpected token \`${unexpected}\`. Did you mean \`${HTMLEntity}\` or \`{'${unexpected}'}\`?`,
    UnsupportedJsxValue: "JSX value should be either an expression or a quoted JSX text.",
    UnterminatedJsxContent: "Unterminated JSX contents.",
    UnwrappedAdjacentJSXElements: "Adjacent JSX elements must be wrapped in an enclosing tag. Did you want a JSX fragment <>...</>?"
});
function $b48499974d50e8d0$var$isFragment(object) {
    return object ? object.type === "JSXOpeningFragment" || object.type === "JSXClosingFragment" : false;
}
function $b48499974d50e8d0$var$getQualifiedJSXName(object) {
    if (object.type === "JSXIdentifier") return object.name;
    if (object.type === "JSXNamespacedName") return object.namespace.name + ":" + object.name.name;
    if (object.type === "JSXMemberExpression") return $b48499974d50e8d0$var$getQualifiedJSXName(object.object) + "." + $b48499974d50e8d0$var$getQualifiedJSXName(object.property);
    throw new Error("Node had unexpected type: " + object.type);
}
var $b48499974d50e8d0$var$jsx = (superClass)=>class JSXParserMixin extends superClass {
        jsxReadToken() {
            let out = "";
            let chunkStart = this.state.pos;
            for(;;){
                if (this.state.pos >= this.length) throw this.raise($b48499974d50e8d0$var$JsxErrors.UnterminatedJsxContent, this.state.startLoc);
                const ch = this.input.charCodeAt(this.state.pos);
                switch(ch){
                    case 60:
                    case 123:
                        if (this.state.pos === this.state.start) {
                            if (ch === 60 && this.state.canStartJSXElement) {
                                ++this.state.pos;
                                this.finishToken(142);
                            } else super.getTokenFromCode(ch);
                            return;
                        }
                        out += this.input.slice(chunkStart, this.state.pos);
                        this.finishToken(141, out);
                        return;
                    case 38:
                        out += this.input.slice(chunkStart, this.state.pos);
                        out += this.jsxReadEntity();
                        chunkStart = this.state.pos;
                        break;
                    case 62:
                    case 125:
                    default:
                        if ($b48499974d50e8d0$var$isNewLine(ch)) {
                            out += this.input.slice(chunkStart, this.state.pos);
                            out += this.jsxReadNewLine(true);
                            chunkStart = this.state.pos;
                        } else ++this.state.pos;
                }
            }
        }
        jsxReadNewLine(normalizeCRLF) {
            const ch = this.input.charCodeAt(this.state.pos);
            let out;
            ++this.state.pos;
            if (ch === 13 && this.input.charCodeAt(this.state.pos) === 10) {
                ++this.state.pos;
                out = normalizeCRLF ? "\n" : "\r\n";
            } else out = String.fromCharCode(ch);
            ++this.state.curLine;
            this.state.lineStart = this.state.pos;
            return out;
        }
        jsxReadString(quote) {
            let out = "";
            let chunkStart = ++this.state.pos;
            for(;;){
                if (this.state.pos >= this.length) throw this.raise($b48499974d50e8d0$var$Errors.UnterminatedString, this.state.startLoc);
                const ch = this.input.charCodeAt(this.state.pos);
                if (ch === quote) break;
                if (ch === 38) {
                    out += this.input.slice(chunkStart, this.state.pos);
                    out += this.jsxReadEntity();
                    chunkStart = this.state.pos;
                } else if ($b48499974d50e8d0$var$isNewLine(ch)) {
                    out += this.input.slice(chunkStart, this.state.pos);
                    out += this.jsxReadNewLine(false);
                    chunkStart = this.state.pos;
                } else ++this.state.pos;
            }
            out += this.input.slice(chunkStart, this.state.pos++);
            this.finishToken(133, out);
        }
        jsxReadEntity() {
            const startPos = ++this.state.pos;
            if (this.codePointAtPos(this.state.pos) === 35) {
                ++this.state.pos;
                let radix = 10;
                if (this.codePointAtPos(this.state.pos) === 120) {
                    radix = 16;
                    ++this.state.pos;
                }
                const codePoint = this.readInt(radix, undefined, false, "bail");
                if (codePoint !== null && this.codePointAtPos(this.state.pos) === 59) {
                    ++this.state.pos;
                    return String.fromCodePoint(codePoint);
                }
            } else {
                let count = 0;
                let semi = false;
                while(count++ < 10 && this.state.pos < this.length && !(semi = this.codePointAtPos(this.state.pos) == 59))++this.state.pos;
                if (semi) {
                    const desc = this.input.slice(startPos, this.state.pos);
                    const entity = $b48499974d50e8d0$var$entities[desc];
                    ++this.state.pos;
                    if (entity) return entity;
                }
            }
            this.state.pos = startPos;
            return "&";
        }
        jsxReadWord() {
            let ch;
            const start = this.state.pos;
            do ch = this.input.charCodeAt(++this.state.pos);
            while ($b48499974d50e8d0$var$isIdentifierChar(ch) || ch === 45);
            this.finishToken(140, this.input.slice(start, this.state.pos));
        }
        jsxParseIdentifier() {
            const node = this.startNode();
            if (this.match(140)) node.name = this.state.value;
            else if ($b48499974d50e8d0$var$tokenIsKeyword(this.state.type)) node.name = $b48499974d50e8d0$var$tokenLabelName(this.state.type);
            else this.unexpected();
            this.next();
            return this.finishNode(node, "JSXIdentifier");
        }
        jsxParseNamespacedName() {
            const startLoc = this.state.startLoc;
            const name = this.jsxParseIdentifier();
            if (!this.eat(14)) return name;
            const node = this.startNodeAt(startLoc);
            node.namespace = name;
            node.name = this.jsxParseIdentifier();
            return this.finishNode(node, "JSXNamespacedName");
        }
        jsxParseElementName() {
            const startLoc = this.state.startLoc;
            let node = this.jsxParseNamespacedName();
            if (node.type === "JSXNamespacedName") return node;
            while(this.eat(16)){
                const newNode = this.startNodeAt(startLoc);
                newNode.object = node;
                newNode.property = this.jsxParseIdentifier();
                node = this.finishNode(newNode, "JSXMemberExpression");
            }
            return node;
        }
        jsxParseAttributeValue() {
            let node;
            switch(this.state.type){
                case 5:
                    node = this.startNode();
                    this.setContext($b48499974d50e8d0$var$types.brace);
                    this.next();
                    node = this.jsxParseExpressionContainer(node, $b48499974d50e8d0$var$types.j_oTag);
                    if (node.expression.type === "JSXEmptyExpression") this.raise($b48499974d50e8d0$var$JsxErrors.AttributeIsEmpty, node);
                    return node;
                case 142:
                case 133:
                    return this.parseExprAtom();
                default:
                    throw this.raise($b48499974d50e8d0$var$JsxErrors.UnsupportedJsxValue, this.state.startLoc);
            }
        }
        jsxParseEmptyExpression() {
            const node = this.startNodeAt(this.state.lastTokEndLoc);
            return this.finishNodeAt(node, "JSXEmptyExpression", this.state.startLoc);
        }
        jsxParseSpreadChild(node) {
            this.next();
            node.expression = this.parseExpression();
            this.setContext($b48499974d50e8d0$var$types.j_expr);
            this.state.canStartJSXElement = true;
            this.expect(8);
            return this.finishNode(node, "JSXSpreadChild");
        }
        jsxParseExpressionContainer(node, previousContext) {
            if (this.match(8)) node.expression = this.jsxParseEmptyExpression();
            else {
                const expression = this.parseExpression();
                node.expression = expression;
            }
            this.setContext(previousContext);
            this.state.canStartJSXElement = true;
            this.expect(8);
            return this.finishNode(node, "JSXExpressionContainer");
        }
        jsxParseAttribute() {
            const node = this.startNode();
            if (this.match(5)) {
                this.setContext($b48499974d50e8d0$var$types.brace);
                this.next();
                this.expect(21);
                node.argument = this.parseMaybeAssignAllowIn();
                this.setContext($b48499974d50e8d0$var$types.j_oTag);
                this.state.canStartJSXElement = true;
                this.expect(8);
                return this.finishNode(node, "JSXSpreadAttribute");
            }
            node.name = this.jsxParseNamespacedName();
            node.value = this.eat(29) ? this.jsxParseAttributeValue() : null;
            return this.finishNode(node, "JSXAttribute");
        }
        jsxParseOpeningElementAt(startLoc) {
            const node = this.startNodeAt(startLoc);
            if (this.eat(143)) return this.finishNode(node, "JSXOpeningFragment");
            node.name = this.jsxParseElementName();
            return this.jsxParseOpeningElementAfterName(node);
        }
        jsxParseOpeningElementAfterName(node) {
            const attributes = [];
            while(!this.match(56) && !this.match(143))attributes.push(this.jsxParseAttribute());
            node.attributes = attributes;
            node.selfClosing = this.eat(56);
            this.expect(143);
            return this.finishNode(node, "JSXOpeningElement");
        }
        jsxParseClosingElementAt(startLoc) {
            const node = this.startNodeAt(startLoc);
            if (this.eat(143)) return this.finishNode(node, "JSXClosingFragment");
            node.name = this.jsxParseElementName();
            this.expect(143);
            return this.finishNode(node, "JSXClosingElement");
        }
        jsxParseElementAt(startLoc) {
            const node = this.startNodeAt(startLoc);
            const children = [];
            const openingElement = this.jsxParseOpeningElementAt(startLoc);
            let closingElement = null;
            if (!openingElement.selfClosing) {
                contents: for(;;)switch(this.state.type){
                    case 142:
                        startLoc = this.state.startLoc;
                        this.next();
                        if (this.eat(56)) {
                            closingElement = this.jsxParseClosingElementAt(startLoc);
                            break contents;
                        }
                        children.push(this.jsxParseElementAt(startLoc));
                        break;
                    case 141:
                        children.push(this.parseExprAtom());
                        break;
                    case 5:
                        {
                            const node = this.startNode();
                            this.setContext($b48499974d50e8d0$var$types.brace);
                            this.next();
                            if (this.match(21)) children.push(this.jsxParseSpreadChild(node));
                            else children.push(this.jsxParseExpressionContainer(node, $b48499974d50e8d0$var$types.j_expr));
                            break;
                        }
                    default:
                        this.unexpected();
                }
                if ($b48499974d50e8d0$var$isFragment(openingElement) && !$b48499974d50e8d0$var$isFragment(closingElement) && closingElement !== null) this.raise($b48499974d50e8d0$var$JsxErrors.MissingClosingTagFragment, closingElement);
                else if (!$b48499974d50e8d0$var$isFragment(openingElement) && $b48499974d50e8d0$var$isFragment(closingElement)) this.raise($b48499974d50e8d0$var$JsxErrors.MissingClosingTagElement, closingElement, {
                    openingTagName: $b48499974d50e8d0$var$getQualifiedJSXName(openingElement.name)
                });
                else if (!$b48499974d50e8d0$var$isFragment(openingElement) && !$b48499974d50e8d0$var$isFragment(closingElement)) {
                    if ($b48499974d50e8d0$var$getQualifiedJSXName(closingElement.name) !== $b48499974d50e8d0$var$getQualifiedJSXName(openingElement.name)) this.raise($b48499974d50e8d0$var$JsxErrors.MissingClosingTagElement, closingElement, {
                        openingTagName: $b48499974d50e8d0$var$getQualifiedJSXName(openingElement.name)
                    });
                }
            }
            if ($b48499974d50e8d0$var$isFragment(openingElement)) {
                node.openingFragment = openingElement;
                node.closingFragment = closingElement;
            } else {
                node.openingElement = openingElement;
                node.closingElement = closingElement;
            }
            node.children = children;
            if (this.match(47)) throw this.raise($b48499974d50e8d0$var$JsxErrors.UnwrappedAdjacentJSXElements, this.state.startLoc);
            return $b48499974d50e8d0$var$isFragment(openingElement) ? this.finishNode(node, "JSXFragment") : this.finishNode(node, "JSXElement");
        }
        jsxParseElement() {
            const startLoc = this.state.startLoc;
            this.next();
            return this.jsxParseElementAt(startLoc);
        }
        setContext(newContext) {
            const { context: context } = this.state;
            context[context.length - 1] = newContext;
        }
        parseExprAtom(refExpressionErrors) {
            if (this.match(141)) return this.parseLiteral(this.state.value, "JSXText");
            else if (this.match(142)) return this.jsxParseElement();
            else if (this.match(47) && this.input.charCodeAt(this.state.pos) !== 33) {
                this.replaceToken(142);
                return this.jsxParseElement();
            } else return super.parseExprAtom(refExpressionErrors);
        }
        skipSpace() {
            const curContext = this.curContext();
            if (!curContext.preserveSpace) super.skipSpace();
        }
        getTokenFromCode(code) {
            const context = this.curContext();
            if (context === $b48499974d50e8d0$var$types.j_expr) {
                this.jsxReadToken();
                return;
            }
            if (context === $b48499974d50e8d0$var$types.j_oTag || context === $b48499974d50e8d0$var$types.j_cTag) {
                if ($b48499974d50e8d0$var$isIdentifierStart(code)) {
                    this.jsxReadWord();
                    return;
                }
                if (code === 62) {
                    ++this.state.pos;
                    this.finishToken(143);
                    return;
                }
                if ((code === 34 || code === 39) && context === $b48499974d50e8d0$var$types.j_oTag) {
                    this.jsxReadString(code);
                    return;
                }
            }
            if (code === 60 && this.state.canStartJSXElement && this.input.charCodeAt(this.state.pos + 1) !== 33) {
                ++this.state.pos;
                this.finishToken(142);
                return;
            }
            super.getTokenFromCode(code);
        }
        updateContext(prevType) {
            const { context: context, type: type } = this.state;
            if (type === 56 && prevType === 142) {
                context.splice(-2, 2, $b48499974d50e8d0$var$types.j_cTag);
                this.state.canStartJSXElement = false;
            } else if (type === 142) context.push($b48499974d50e8d0$var$types.j_oTag);
            else if (type === 143) {
                const out = context[context.length - 1];
                if (out === $b48499974d50e8d0$var$types.j_oTag && prevType === 56 || out === $b48499974d50e8d0$var$types.j_cTag) {
                    context.pop();
                    this.state.canStartJSXElement = context[context.length - 1] === $b48499974d50e8d0$var$types.j_expr;
                } else {
                    this.setContext($b48499974d50e8d0$var$types.j_expr);
                    this.state.canStartJSXElement = true;
                }
            } else this.state.canStartJSXElement = $b48499974d50e8d0$var$tokenComesBeforeExpression(type);
        }
    };
class $b48499974d50e8d0$var$TypeScriptScope extends $b48499974d50e8d0$var$Scope {
    constructor(...args){
        super(...args);
        this.tsNames = new Map();
    }
}
class $b48499974d50e8d0$var$TypeScriptScopeHandler extends $b48499974d50e8d0$var$ScopeHandler {
    constructor(...args){
        super(...args);
        this.importsStack = [];
    }
    createScope(flags) {
        this.importsStack.push(new Set());
        return new $b48499974d50e8d0$var$TypeScriptScope(flags);
    }
    enter(flags) {
        if (flags == 256) this.importsStack.push(new Set());
        super.enter(flags);
    }
    exit() {
        const flags = super.exit();
        if (flags == 256) this.importsStack.pop();
        return flags;
    }
    hasImport(name, allowShadow) {
        const len = this.importsStack.length;
        if (this.importsStack[len - 1].has(name)) return true;
        if (!allowShadow && len > 1) for(let i = 0; i < len - 1; i++){
            if (this.importsStack[i].has(name)) return true;
        }
        return false;
    }
    declareName(name, bindingType, loc) {
        if (bindingType & 4096) {
            if (this.hasImport(name, true)) this.parser.raise($b48499974d50e8d0$var$Errors.VarRedeclaration, loc, {
                identifierName: name
            });
            this.importsStack[this.importsStack.length - 1].add(name);
            return;
        }
        const scope = this.currentScope();
        let type = scope.tsNames.get(name) || 0;
        if (bindingType & 1024) {
            this.maybeExportDefined(scope, name);
            scope.tsNames.set(name, type | 16);
            return;
        }
        super.declareName(name, bindingType, loc);
        if (bindingType & 2) {
            if (!(bindingType & 1)) {
                this.checkRedeclarationInScope(scope, name, bindingType, loc);
                this.maybeExportDefined(scope, name);
            }
            type = type | 1;
        }
        if (bindingType & 256) type = type | 2;
        if (bindingType & 512) type = type | 4;
        if (bindingType & 128) type = type | 8;
        if (type) scope.tsNames.set(name, type);
    }
    isRedeclaredInScope(scope, name, bindingType) {
        const type = scope.tsNames.get(name);
        if ((type & 2) > 0) {
            if (bindingType & 256) {
                const isConst = !!(bindingType & 512);
                const wasConst = (type & 4) > 0;
                return isConst !== wasConst;
            }
            return true;
        }
        if (bindingType & 128 && (type & 8) > 0) {
            if (scope.names.get(name) & 2) return !!(bindingType & 1);
            else return false;
        }
        if (bindingType & 2 && (type & 1) > 0) return true;
        return super.isRedeclaredInScope(scope, name, bindingType);
    }
    checkLocalExport(id) {
        const { name: name } = id;
        if (this.hasImport(name)) return;
        const len = this.scopeStack.length;
        for(let i = len - 1; i >= 0; i--){
            const scope = this.scopeStack[i];
            const type = scope.tsNames.get(name);
            if ((type & 1) > 0 || (type & 16) > 0) return;
        }
        super.checkLocalExport(id);
    }
}
const $b48499974d50e8d0$var$getOwn$1 = (object, key)=>hasOwnProperty.call(object, key) && object[key];
const $b48499974d50e8d0$var$unwrapParenthesizedExpression = (node)=>{
    return node.type === "ParenthesizedExpression" ? $b48499974d50e8d0$var$unwrapParenthesizedExpression(node.expression) : node;
};
class $b48499974d50e8d0$var$LValParser extends $b48499974d50e8d0$var$NodeUtils {
    toAssignable(node, isLHS = false) {
        var _node$extra, _node$extra3;
        let parenthesized = undefined;
        if (node.type === "ParenthesizedExpression" || (_node$extra = node.extra) != null && _node$extra.parenthesized) {
            parenthesized = $b48499974d50e8d0$var$unwrapParenthesizedExpression(node);
            if (isLHS) {
                if (parenthesized.type === "Identifier") this.expressionScope.recordArrowParameterBindingError($b48499974d50e8d0$var$Errors.InvalidParenthesizedAssignment, node);
                else if (parenthesized.type !== "MemberExpression" && !this.isOptionalMemberExpression(parenthesized)) this.raise($b48499974d50e8d0$var$Errors.InvalidParenthesizedAssignment, node);
            } else this.raise($b48499974d50e8d0$var$Errors.InvalidParenthesizedAssignment, node);
        }
        switch(node.type){
            case "Identifier":
            case "ObjectPattern":
            case "ArrayPattern":
            case "AssignmentPattern":
            case "RestElement":
                break;
            case "ObjectExpression":
                node.type = "ObjectPattern";
                for(let i = 0, length = node.properties.length, last = length - 1; i < length; i++){
                    var _node$extra2;
                    const prop = node.properties[i];
                    const isLast = i === last;
                    this.toAssignableObjectExpressionProp(prop, isLast, isLHS);
                    if (isLast && prop.type === "RestElement" && (_node$extra2 = node.extra) != null && _node$extra2.trailingCommaLoc) this.raise($b48499974d50e8d0$var$Errors.RestTrailingComma, node.extra.trailingCommaLoc);
                }
                break;
            case "ObjectProperty":
                {
                    const { key: key, value: value } = node;
                    if (this.isPrivateName(key)) this.classScope.usePrivateName(this.getPrivateNameSV(key), key.loc.start);
                    this.toAssignable(value, isLHS);
                    break;
                }
            case "SpreadElement":
                throw new Error("Internal @babel/parser error (this is a bug, please report it). SpreadElement should be converted by .toAssignable's caller.");
            case "ArrayExpression":
                node.type = "ArrayPattern";
                this.toAssignableList(node.elements, (_node$extra3 = node.extra) == null ? void 0 : _node$extra3.trailingCommaLoc, isLHS);
                break;
            case "AssignmentExpression":
                if (node.operator !== "=") this.raise($b48499974d50e8d0$var$Errors.MissingEqInAssignment, node.left.loc.end);
                node.type = "AssignmentPattern";
                delete node.operator;
                this.toAssignable(node.left, isLHS);
                break;
            case "ParenthesizedExpression":
                this.toAssignable(parenthesized, isLHS);
                break;
        }
    }
    toAssignableObjectExpressionProp(prop, isLast, isLHS) {
        if (prop.type === "ObjectMethod") this.raise(prop.kind === "get" || prop.kind === "set" ? $b48499974d50e8d0$var$Errors.PatternHasAccessor : $b48499974d50e8d0$var$Errors.PatternHasMethod, prop.key);
        else if (prop.type === "SpreadElement") {
            prop.type = "RestElement";
            const arg = prop.argument;
            this.checkToRestConversion(arg, false);
            this.toAssignable(arg, isLHS);
            if (!isLast) this.raise($b48499974d50e8d0$var$Errors.RestTrailingComma, prop);
        } else this.toAssignable(prop, isLHS);
    }
    toAssignableList(exprList, trailingCommaLoc, isLHS) {
        const end = exprList.length - 1;
        for(let i = 0; i <= end; i++){
            const elt = exprList[i];
            if (!elt) continue;
            if (elt.type === "SpreadElement") {
                elt.type = "RestElement";
                const arg = elt.argument;
                this.checkToRestConversion(arg, true);
                this.toAssignable(arg, isLHS);
            } else this.toAssignable(elt, isLHS);
            if (elt.type === "RestElement") {
                if (i < end) this.raise($b48499974d50e8d0$var$Errors.RestTrailingComma, elt);
                else if (trailingCommaLoc) this.raise($b48499974d50e8d0$var$Errors.RestTrailingComma, trailingCommaLoc);
            }
        }
    }
    isAssignable(node, isBinding) {
        switch(node.type){
            case "Identifier":
            case "ObjectPattern":
            case "ArrayPattern":
            case "AssignmentPattern":
            case "RestElement":
                return true;
            case "ObjectExpression":
                {
                    const last = node.properties.length - 1;
                    return node.properties.every((prop, i)=>{
                        return prop.type !== "ObjectMethod" && (i === last || prop.type !== "SpreadElement") && this.isAssignable(prop);
                    });
                }
            case "ObjectProperty":
                return this.isAssignable(node.value);
            case "SpreadElement":
                return this.isAssignable(node.argument);
            case "ArrayExpression":
                return node.elements.every((element)=>element === null || this.isAssignable(element));
            case "AssignmentExpression":
                return node.operator === "=";
            case "ParenthesizedExpression":
                return this.isAssignable(node.expression);
            case "MemberExpression":
            case "OptionalMemberExpression":
                return !isBinding;
            default:
                return false;
        }
    }
    toReferencedList(exprList, isParenthesizedExpr) {
        return exprList;
    }
    toReferencedListDeep(exprList, isParenthesizedExpr) {
        this.toReferencedList(exprList, isParenthesizedExpr);
        for (const expr of exprList)if ((expr == null ? void 0 : expr.type) === "ArrayExpression") this.toReferencedListDeep(expr.elements);
    }
    parseSpread(refExpressionErrors) {
        const node = this.startNode();
        this.next();
        node.argument = this.parseMaybeAssignAllowIn(refExpressionErrors, undefined);
        return this.finishNode(node, "SpreadElement");
    }
    parseRestBinding() {
        const node = this.startNode();
        this.next();
        node.argument = this.parseBindingAtom();
        return this.finishNode(node, "RestElement");
    }
    parseBindingAtom() {
        switch(this.state.type){
            case 0:
                {
                    const node = this.startNode();
                    this.next();
                    node.elements = this.parseBindingList(3, 93, 1);
                    return this.finishNode(node, "ArrayPattern");
                }
            case 5:
                return this.parseObjectLike(8, true);
        }
        return this.parseIdentifier();
    }
    parseBindingList(close, closeCharCode, flags) {
        const allowEmpty = flags & 1;
        const elts = [];
        let first = true;
        while(!this.eat(close)){
            if (first) first = false;
            else this.expect(12);
            if (allowEmpty && this.match(12)) elts.push(null);
            else if (this.eat(close)) break;
            else if (this.match(21)) {
                elts.push(this.parseAssignableListItemTypes(this.parseRestBinding(), flags));
                if (!this.checkCommaAfterRest(closeCharCode)) {
                    this.expect(close);
                    break;
                }
            } else {
                const decorators = [];
                if (this.match(26) && this.hasPlugin("decorators")) this.raise($b48499974d50e8d0$var$Errors.UnsupportedParameterDecorator, this.state.startLoc);
                while(this.match(26))decorators.push(this.parseDecorator());
                elts.push(this.parseAssignableListItem(flags, decorators));
            }
        }
        return elts;
    }
    parseBindingRestProperty(prop) {
        this.next();
        prop.argument = this.parseIdentifier();
        this.checkCommaAfterRest(125);
        return this.finishNode(prop, "RestElement");
    }
    parseBindingProperty() {
        const prop = this.startNode();
        const { type: type, startLoc: startLoc } = this.state;
        if (type === 21) return this.parseBindingRestProperty(prop);
        else if (type === 138) {
            this.expectPlugin("destructuringPrivate", startLoc);
            this.classScope.usePrivateName(this.state.value, startLoc);
            prop.key = this.parsePrivateName();
        } else this.parsePropertyName(prop);
        prop.method = false;
        return this.parseObjPropValue(prop, startLoc, false, false, true, false);
    }
    parseAssignableListItem(flags, decorators) {
        const left = this.parseMaybeDefault();
        this.parseAssignableListItemTypes(left, flags);
        const elt = this.parseMaybeDefault(left.loc.start, left);
        if (decorators.length) left.decorators = decorators;
        return elt;
    }
    parseAssignableListItemTypes(param, flags) {
        return param;
    }
    parseMaybeDefault(startLoc, left) {
        var _startLoc, _left;
        (_startLoc = startLoc) != null ? _startLoc : startLoc = this.state.startLoc;
        left = (_left = left) != null ? _left : this.parseBindingAtom();
        if (!this.eat(29)) return left;
        const node = this.startNodeAt(startLoc);
        node.left = left;
        node.right = this.parseMaybeAssignAllowIn();
        return this.finishNode(node, "AssignmentPattern");
    }
    isValidLVal(type, isUnparenthesizedInAssign, binding) {
        return $b48499974d50e8d0$var$getOwn$1({
            AssignmentPattern: "left",
            RestElement: "argument",
            ObjectProperty: "value",
            ParenthesizedExpression: "expression",
            ArrayPattern: "elements",
            ObjectPattern: "properties"
        }, type);
    }
    isOptionalMemberExpression(expression) {
        return expression.type === "OptionalMemberExpression";
    }
    checkLVal(expression, { in: ancestor, binding: binding = 64, checkClashes: checkClashes = false, strictModeChanged: strictModeChanged = false, hasParenthesizedAncestor: hasParenthesizedAncestor = false }) {
        var _expression$extra;
        const type = expression.type;
        if (this.isObjectMethod(expression)) return;
        const isOptionalMemberExpression = this.isOptionalMemberExpression(expression);
        if (isOptionalMemberExpression || type === "MemberExpression") {
            if (isOptionalMemberExpression) {
                this.expectPlugin("optionalChainingAssign", expression.loc.start);
                if (ancestor.type !== "AssignmentExpression") this.raise($b48499974d50e8d0$var$Errors.InvalidLhsOptionalChaining, expression, {
                    ancestor: ancestor
                });
            }
            if (binding !== 64) this.raise($b48499974d50e8d0$var$Errors.InvalidPropertyBindingPattern, expression);
            return;
        }
        if (type === "Identifier") {
            this.checkIdentifier(expression, binding, strictModeChanged);
            const { name: name } = expression;
            if (checkClashes) {
                if (checkClashes.has(name)) this.raise($b48499974d50e8d0$var$Errors.ParamDupe, expression);
                else checkClashes.add(name);
            }
            return;
        }
        const validity = this.isValidLVal(type, !(hasParenthesizedAncestor || (_expression$extra = expression.extra) != null && _expression$extra.parenthesized) && ancestor.type === "AssignmentExpression", binding);
        if (validity === true) return;
        if (validity === false) {
            const ParseErrorClass = binding === 64 ? $b48499974d50e8d0$var$Errors.InvalidLhs : $b48499974d50e8d0$var$Errors.InvalidLhsBinding;
            this.raise(ParseErrorClass, expression, {
                ancestor: ancestor
            });
            return;
        }
        const [key, isParenthesizedExpression] = Array.isArray(validity) ? validity : [
            validity,
            type === "ParenthesizedExpression"
        ];
        const nextAncestor = type === "ArrayPattern" || type === "ObjectPattern" ? {
            type: type
        } : ancestor;
        for (const child of [].concat(expression[key]))if (child) this.checkLVal(child, {
            in: nextAncestor,
            binding: binding,
            checkClashes: checkClashes,
            strictModeChanged: strictModeChanged,
            hasParenthesizedAncestor: isParenthesizedExpression
        });
    }
    checkIdentifier(at, bindingType, strictModeChanged = false) {
        if (this.state.strict && (strictModeChanged ? $b48499974d50e8d0$var$isStrictBindReservedWord(at.name, this.inModule) : $b48499974d50e8d0$var$isStrictBindOnlyReservedWord(at.name))) {
            if (bindingType === 64) this.raise($b48499974d50e8d0$var$Errors.StrictEvalArguments, at, {
                referenceName: at.name
            });
            else this.raise($b48499974d50e8d0$var$Errors.StrictEvalArgumentsBinding, at, {
                bindingName: at.name
            });
        }
        if (bindingType & 8192 && at.name === "let") this.raise($b48499974d50e8d0$var$Errors.LetInLexicalBinding, at);
        if (!(bindingType & 64)) this.declareNameFromIdentifier(at, bindingType);
    }
    declareNameFromIdentifier(identifier, binding) {
        this.scope.declareName(identifier.name, binding, identifier.loc.start);
    }
    checkToRestConversion(node, allowPattern) {
        switch(node.type){
            case "ParenthesizedExpression":
                this.checkToRestConversion(node.expression, allowPattern);
                break;
            case "Identifier":
            case "MemberExpression":
                break;
            case "ArrayExpression":
            case "ObjectExpression":
                if (allowPattern) break;
            default:
                this.raise($b48499974d50e8d0$var$Errors.InvalidRestAssignmentPattern, node);
        }
    }
    checkCommaAfterRest(close) {
        if (!this.match(12)) return false;
        this.raise(this.lookaheadCharCode() === close ? $b48499974d50e8d0$var$Errors.RestTrailingComma : $b48499974d50e8d0$var$Errors.ElementAfterRest, this.state.startLoc);
        return true;
    }
}
const $b48499974d50e8d0$var$getOwn = (object, key)=>hasOwnProperty.call(object, key) && object[key];
function $b48499974d50e8d0$var$nonNull(x) {
    if (x == null) throw new Error(`Unexpected ${x} value.`);
    return x;
}
function $b48499974d50e8d0$var$assert(x) {
    if (!x) throw new Error("Assert fail");
}
const $b48499974d50e8d0$var$TSErrors = $b48499974d50e8d0$var$ParseErrorEnum`typescript`({
    AbstractMethodHasImplementation: ({ methodName: methodName })=>`Method '${methodName}' cannot have an implementation because it is marked abstract.`,
    AbstractPropertyHasInitializer: ({ propertyName: propertyName })=>`Property '${propertyName}' cannot have an initializer because it is marked abstract.`,
    AccesorCannotDeclareThisParameter: "'get' and 'set' accessors cannot declare 'this' parameters.",
    AccesorCannotHaveTypeParameters: "An accessor cannot have type parameters.",
    AccessorCannotBeOptional: "An 'accessor' property cannot be declared optional.",
    ClassMethodHasDeclare: "Class methods cannot have the 'declare' modifier.",
    ClassMethodHasReadonly: "Class methods cannot have the 'readonly' modifier.",
    ConstInitiailizerMustBeStringOrNumericLiteralOrLiteralEnumReference: "A 'const' initializer in an ambient context must be a string or numeric literal or literal enum reference.",
    ConstructorHasTypeParameters: "Type parameters cannot appear on a constructor declaration.",
    DeclareAccessor: ({ kind: kind })=>`'declare' is not allowed in ${kind}ters.`,
    DeclareClassFieldHasInitializer: "Initializers are not allowed in ambient contexts.",
    DeclareFunctionHasImplementation: "An implementation cannot be declared in ambient contexts.",
    DuplicateAccessibilityModifier: ({ modifier: modifier })=>`Accessibility modifier already seen.`,
    DuplicateModifier: ({ modifier: modifier })=>`Duplicate modifier: '${modifier}'.`,
    EmptyHeritageClauseType: ({ token: token })=>`'${token}' list cannot be empty.`,
    EmptyTypeArguments: "Type argument list cannot be empty.",
    EmptyTypeParameters: "Type parameter list cannot be empty.",
    ExpectedAmbientAfterExportDeclare: "'export declare' must be followed by an ambient declaration.",
    ImportAliasHasImportType: "An import alias can not use 'import type'.",
    ImportReflectionHasImportType: "An `import module` declaration can not use `type` modifier",
    IncompatibleModifiers: ({ modifiers: modifiers })=>`'${modifiers[0]}' modifier cannot be used with '${modifiers[1]}' modifier.`,
    IndexSignatureHasAbstract: "Index signatures cannot have the 'abstract' modifier.",
    IndexSignatureHasAccessibility: ({ modifier: modifier })=>`Index signatures cannot have an accessibility modifier ('${modifier}').`,
    IndexSignatureHasDeclare: "Index signatures cannot have the 'declare' modifier.",
    IndexSignatureHasOverride: "'override' modifier cannot appear on an index signature.",
    IndexSignatureHasStatic: "Index signatures cannot have the 'static' modifier.",
    InitializerNotAllowedInAmbientContext: "Initializers are not allowed in ambient contexts.",
    InvalidModifierOnTypeMember: ({ modifier: modifier })=>`'${modifier}' modifier cannot appear on a type member.`,
    InvalidModifierOnTypeParameter: ({ modifier: modifier })=>`'${modifier}' modifier cannot appear on a type parameter.`,
    InvalidModifierOnTypeParameterPositions: ({ modifier: modifier })=>`'${modifier}' modifier can only appear on a type parameter of a class, interface or type alias.`,
    InvalidModifiersOrder: ({ orderedModifiers: orderedModifiers })=>`'${orderedModifiers[0]}' modifier must precede '${orderedModifiers[1]}' modifier.`,
    InvalidPropertyAccessAfterInstantiationExpression: "Invalid property access after an instantiation expression. You can either wrap the instantiation expression in parentheses, or delete the type arguments.",
    InvalidTupleMemberLabel: "Tuple members must be labeled with a simple identifier.",
    MissingInterfaceName: "'interface' declarations must be followed by an identifier.",
    NonAbstractClassHasAbstractMethod: "Abstract methods can only appear within an abstract class.",
    NonClassMethodPropertyHasAbstractModifer: "'abstract' modifier can only appear on a class, method, or property declaration.",
    OptionalTypeBeforeRequired: "A required element cannot follow an optional element.",
    OverrideNotInSubClass: "This member cannot have an 'override' modifier because its containing class does not extend another class.",
    PatternIsOptional: "A binding pattern parameter cannot be optional in an implementation signature.",
    PrivateElementHasAbstract: "Private elements cannot have the 'abstract' modifier.",
    PrivateElementHasAccessibility: ({ modifier: modifier })=>`Private elements cannot have an accessibility modifier ('${modifier}').`,
    ReadonlyForMethodSignature: "'readonly' modifier can only appear on a property declaration or index signature.",
    ReservedArrowTypeParam: "This syntax is reserved in files with the .mts or .cts extension. Add a trailing comma, as in `<T,>() => ...`.",
    ReservedTypeAssertion: "This syntax is reserved in files with the .mts or .cts extension. Use an `as` expression instead.",
    SetAccesorCannotHaveOptionalParameter: "A 'set' accessor cannot have an optional parameter.",
    SetAccesorCannotHaveRestParameter: "A 'set' accessor cannot have rest parameter.",
    SetAccesorCannotHaveReturnType: "A 'set' accessor cannot have a return type annotation.",
    SingleTypeParameterWithoutTrailingComma: ({ typeParameterName: typeParameterName })=>`Single type parameter ${typeParameterName} should have a trailing comma. Example usage: <${typeParameterName},>.`,
    StaticBlockCannotHaveModifier: "Static class blocks cannot have any modifier.",
    TupleOptionalAfterType: "A labeled tuple optional element must be declared using a question mark after the name and before the colon (`name?: type`), rather than after the type (`name: type?`).",
    TypeAnnotationAfterAssign: "Type annotations must come before default assignments, e.g. instead of `age = 25: number` use `age: number = 25`.",
    TypeImportCannotSpecifyDefaultAndNamed: "A type-only import can specify a default import or named bindings, but not both.",
    TypeModifierIsUsedInTypeExports: "The 'type' modifier cannot be used on a named export when 'export type' is used on its export statement.",
    TypeModifierIsUsedInTypeImports: "The 'type' modifier cannot be used on a named import when 'import type' is used on its import statement.",
    UnexpectedParameterModifier: "A parameter property is only allowed in a constructor implementation.",
    UnexpectedReadonly: "'readonly' type modifier is only permitted on array and tuple literal types.",
    UnexpectedTypeAnnotation: "Did not expect a type annotation here.",
    UnexpectedTypeCastInParameter: "Unexpected type cast in parameter position.",
    UnsupportedImportTypeArgument: "Argument in a type import must be a string literal.",
    UnsupportedParameterPropertyKind: "A parameter property may not be declared using a binding pattern.",
    UnsupportedSignatureParameterKind: ({ type: type })=>`Name in a signature must be an Identifier, ObjectPattern or ArrayPattern, instead got ${type}.`
});
function $b48499974d50e8d0$var$keywordTypeFromName(value) {
    switch(value){
        case "any":
            return "TSAnyKeyword";
        case "boolean":
            return "TSBooleanKeyword";
        case "bigint":
            return "TSBigIntKeyword";
        case "never":
            return "TSNeverKeyword";
        case "number":
            return "TSNumberKeyword";
        case "object":
            return "TSObjectKeyword";
        case "string":
            return "TSStringKeyword";
        case "symbol":
            return "TSSymbolKeyword";
        case "undefined":
            return "TSUndefinedKeyword";
        case "unknown":
            return "TSUnknownKeyword";
        default:
            return undefined;
    }
}
function $b48499974d50e8d0$var$tsIsAccessModifier(modifier) {
    return modifier === "private" || modifier === "public" || modifier === "protected";
}
function $b48499974d50e8d0$var$tsIsVarianceAnnotations(modifier) {
    return modifier === "in" || modifier === "out";
}
var $b48499974d50e8d0$var$typescript = (superClass)=>class TypeScriptParserMixin extends superClass {
        constructor(...args){
            super(...args);
            this.tsParseInOutModifiers = this.tsParseModifiers.bind(this, {
                allowedModifiers: [
                    "in",
                    "out"
                ],
                disallowedModifiers: [
                    "const",
                    "public",
                    "private",
                    "protected",
                    "readonly",
                    "declare",
                    "abstract",
                    "override"
                ],
                errorTemplate: $b48499974d50e8d0$var$TSErrors.InvalidModifierOnTypeParameter
            });
            this.tsParseConstModifier = this.tsParseModifiers.bind(this, {
                allowedModifiers: [
                    "const"
                ],
                disallowedModifiers: [
                    "in",
                    "out"
                ],
                errorTemplate: $b48499974d50e8d0$var$TSErrors.InvalidModifierOnTypeParameterPositions
            });
            this.tsParseInOutConstModifiers = this.tsParseModifiers.bind(this, {
                allowedModifiers: [
                    "in",
                    "out",
                    "const"
                ],
                disallowedModifiers: [
                    "public",
                    "private",
                    "protected",
                    "readonly",
                    "declare",
                    "abstract",
                    "override"
                ],
                errorTemplate: $b48499974d50e8d0$var$TSErrors.InvalidModifierOnTypeParameter
            });
        }
        getScopeHandler() {
            return $b48499974d50e8d0$var$TypeScriptScopeHandler;
        }
        tsIsIdentifier() {
            return $b48499974d50e8d0$var$tokenIsIdentifier(this.state.type);
        }
        tsTokenCanFollowModifier() {
            return (this.match(0) || this.match(5) || this.match(55) || this.match(21) || this.match(138) || this.isLiteralPropertyName()) && !this.hasPrecedingLineBreak();
        }
        tsNextTokenCanFollowModifier() {
            this.next();
            return this.tsTokenCanFollowModifier();
        }
        tsParseModifier(allowedModifiers, stopOnStartOfClassStaticBlock) {
            if (!$b48499974d50e8d0$var$tokenIsIdentifier(this.state.type) && this.state.type !== 58 && this.state.type !== 75) return undefined;
            const modifier = this.state.value;
            if (allowedModifiers.indexOf(modifier) !== -1) {
                if (stopOnStartOfClassStaticBlock && this.tsIsStartOfStaticBlocks()) return undefined;
                if (this.tsTryParse(this.tsNextTokenCanFollowModifier.bind(this))) return modifier;
            }
            return undefined;
        }
        tsParseModifiers({ allowedModifiers: allowedModifiers, disallowedModifiers: disallowedModifiers, stopOnStartOfClassStaticBlock: stopOnStartOfClassStaticBlock, errorTemplate: errorTemplate = $b48499974d50e8d0$var$TSErrors.InvalidModifierOnTypeMember }, modified) {
            const enforceOrder = (loc, modifier, before, after)=>{
                if (modifier === before && modified[after]) this.raise($b48499974d50e8d0$var$TSErrors.InvalidModifiersOrder, loc, {
                    orderedModifiers: [
                        before,
                        after
                    ]
                });
            };
            const incompatible = (loc, modifier, mod1, mod2)=>{
                if (modified[mod1] && modifier === mod2 || modified[mod2] && modifier === mod1) this.raise($b48499974d50e8d0$var$TSErrors.IncompatibleModifiers, loc, {
                    modifiers: [
                        mod1,
                        mod2
                    ]
                });
            };
            for(;;){
                const { startLoc: startLoc } = this.state;
                const modifier = this.tsParseModifier(allowedModifiers.concat(disallowedModifiers != null ? disallowedModifiers : []), stopOnStartOfClassStaticBlock);
                if (!modifier) break;
                if ($b48499974d50e8d0$var$tsIsAccessModifier(modifier)) {
                    if (modified.accessibility) this.raise($b48499974d50e8d0$var$TSErrors.DuplicateAccessibilityModifier, startLoc, {
                        modifier: modifier
                    });
                    else {
                        enforceOrder(startLoc, modifier, modifier, "override");
                        enforceOrder(startLoc, modifier, modifier, "static");
                        enforceOrder(startLoc, modifier, modifier, "readonly");
                        modified.accessibility = modifier;
                    }
                } else if ($b48499974d50e8d0$var$tsIsVarianceAnnotations(modifier)) {
                    if (modified[modifier]) this.raise($b48499974d50e8d0$var$TSErrors.DuplicateModifier, startLoc, {
                        modifier: modifier
                    });
                    modified[modifier] = true;
                    enforceOrder(startLoc, modifier, "in", "out");
                } else {
                    if (hasOwnProperty.call(modified, modifier)) this.raise($b48499974d50e8d0$var$TSErrors.DuplicateModifier, startLoc, {
                        modifier: modifier
                    });
                    else {
                        enforceOrder(startLoc, modifier, "static", "readonly");
                        enforceOrder(startLoc, modifier, "static", "override");
                        enforceOrder(startLoc, modifier, "override", "readonly");
                        enforceOrder(startLoc, modifier, "abstract", "override");
                        incompatible(startLoc, modifier, "declare", "override");
                        incompatible(startLoc, modifier, "static", "abstract");
                    }
                    modified[modifier] = true;
                }
                if (disallowedModifiers != null && disallowedModifiers.includes(modifier)) this.raise(errorTemplate, startLoc, {
                    modifier: modifier
                });
            }
        }
        tsIsListTerminator(kind) {
            switch(kind){
                case "EnumMembers":
                case "TypeMembers":
                    return this.match(8);
                case "HeritageClauseElement":
                    return this.match(5);
                case "TupleElementTypes":
                    return this.match(3);
                case "TypeParametersOrArguments":
                    return this.match(48);
            }
        }
        tsParseList(kind, parseElement) {
            const result = [];
            while(!this.tsIsListTerminator(kind))result.push(parseElement());
            return result;
        }
        tsParseDelimitedList(kind, parseElement, refTrailingCommaPos) {
            return $b48499974d50e8d0$var$nonNull(this.tsParseDelimitedListWorker(kind, parseElement, true, refTrailingCommaPos));
        }
        tsParseDelimitedListWorker(kind, parseElement, expectSuccess, refTrailingCommaPos) {
            const result = [];
            let trailingCommaPos = -1;
            for(;;){
                if (this.tsIsListTerminator(kind)) break;
                trailingCommaPos = -1;
                const element = parseElement();
                if (element == null) return undefined;
                result.push(element);
                if (this.eat(12)) {
                    trailingCommaPos = this.state.lastTokStartLoc.index;
                    continue;
                }
                if (this.tsIsListTerminator(kind)) break;
                if (expectSuccess) this.expect(12);
                return undefined;
            }
            if (refTrailingCommaPos) refTrailingCommaPos.value = trailingCommaPos;
            return result;
        }
        tsParseBracketedList(kind, parseElement, bracket, skipFirstToken, refTrailingCommaPos) {
            if (!skipFirstToken) {
                if (bracket) this.expect(0);
                else this.expect(47);
            }
            const result = this.tsParseDelimitedList(kind, parseElement, refTrailingCommaPos);
            if (bracket) this.expect(3);
            else this.expect(48);
            return result;
        }
        tsParseImportType() {
            const node = this.startNode();
            this.expect(83);
            this.expect(10);
            if (!this.match(133)) this.raise($b48499974d50e8d0$var$TSErrors.UnsupportedImportTypeArgument, this.state.startLoc);
            node.argument = super.parseExprAtom();
            if (this.hasPlugin("importAttributes") || this.hasPlugin("importAssertions")) node.options = null;
            if (this.eat(12)) {
                this.expectImportAttributesPlugin();
                if (!this.match(11)) {
                    node.options = super.parseMaybeAssignAllowIn();
                    this.eat(12);
                }
            }
            this.expect(11);
            if (this.eat(16)) node.qualifier = this.tsParseEntityName();
            if (this.match(47)) node.typeParameters = this.tsParseTypeArguments();
            return this.finishNode(node, "TSImportType");
        }
        tsParseEntityName(allowReservedWords = true) {
            let entity = this.parseIdentifier(allowReservedWords);
            while(this.eat(16)){
                const node = this.startNodeAtNode(entity);
                node.left = entity;
                node.right = this.parseIdentifier(allowReservedWords);
                entity = this.finishNode(node, "TSQualifiedName");
            }
            return entity;
        }
        tsParseTypeReference() {
            const node = this.startNode();
            node.typeName = this.tsParseEntityName();
            if (!this.hasPrecedingLineBreak() && this.match(47)) node.typeParameters = this.tsParseTypeArguments();
            return this.finishNode(node, "TSTypeReference");
        }
        tsParseThisTypePredicate(lhs) {
            this.next();
            const node = this.startNodeAtNode(lhs);
            node.parameterName = lhs;
            node.typeAnnotation = this.tsParseTypeAnnotation(false);
            node.asserts = false;
            return this.finishNode(node, "TSTypePredicate");
        }
        tsParseThisTypeNode() {
            const node = this.startNode();
            this.next();
            return this.finishNode(node, "TSThisType");
        }
        tsParseTypeQuery() {
            const node = this.startNode();
            this.expect(87);
            if (this.match(83)) node.exprName = this.tsParseImportType();
            else node.exprName = this.tsParseEntityName();
            if (!this.hasPrecedingLineBreak() && this.match(47)) node.typeParameters = this.tsParseTypeArguments();
            return this.finishNode(node, "TSTypeQuery");
        }
        tsParseTypeParameter(parseModifiers) {
            const node = this.startNode();
            parseModifiers(node);
            node.name = this.tsParseTypeParameterName();
            node.constraint = this.tsEatThenParseType(81);
            node.default = this.tsEatThenParseType(29);
            return this.finishNode(node, "TSTypeParameter");
        }
        tsTryParseTypeParameters(parseModifiers) {
            if (this.match(47)) return this.tsParseTypeParameters(parseModifiers);
        }
        tsParseTypeParameters(parseModifiers) {
            const node = this.startNode();
            if (this.match(47) || this.match(142)) this.next();
            else this.unexpected();
            const refTrailingCommaPos = {
                value: -1
            };
            node.params = this.tsParseBracketedList("TypeParametersOrArguments", this.tsParseTypeParameter.bind(this, parseModifiers), false, true, refTrailingCommaPos);
            if (node.params.length === 0) this.raise($b48499974d50e8d0$var$TSErrors.EmptyTypeParameters, node);
            if (refTrailingCommaPos.value !== -1) this.addExtra(node, "trailingComma", refTrailingCommaPos.value);
            return this.finishNode(node, "TSTypeParameterDeclaration");
        }
        tsFillSignature(returnToken, signature) {
            const returnTokenRequired = returnToken === 19;
            const paramsKey = "parameters";
            const returnTypeKey = "typeAnnotation";
            signature.typeParameters = this.tsTryParseTypeParameters(this.tsParseConstModifier);
            this.expect(10);
            signature[paramsKey] = this.tsParseBindingListForSignature();
            if (returnTokenRequired) signature[returnTypeKey] = this.tsParseTypeOrTypePredicateAnnotation(returnToken);
            else if (this.match(returnToken)) signature[returnTypeKey] = this.tsParseTypeOrTypePredicateAnnotation(returnToken);
        }
        tsParseBindingListForSignature() {
            const list = super.parseBindingList(11, 41, 2);
            for (const pattern of list){
                const { type: type } = pattern;
                if (type === "AssignmentPattern" || type === "TSParameterProperty") this.raise($b48499974d50e8d0$var$TSErrors.UnsupportedSignatureParameterKind, pattern, {
                    type: type
                });
            }
            return list;
        }
        tsParseTypeMemberSemicolon() {
            if (!this.eat(12) && !this.isLineTerminator()) this.expect(13);
        }
        tsParseSignatureMember(kind, node) {
            this.tsFillSignature(14, node);
            this.tsParseTypeMemberSemicolon();
            return this.finishNode(node, kind);
        }
        tsIsUnambiguouslyIndexSignature() {
            this.next();
            if ($b48499974d50e8d0$var$tokenIsIdentifier(this.state.type)) {
                this.next();
                return this.match(14);
            }
            return false;
        }
        tsTryParseIndexSignature(node) {
            if (!(this.match(0) && this.tsLookAhead(this.tsIsUnambiguouslyIndexSignature.bind(this)))) return;
            this.expect(0);
            const id = this.parseIdentifier();
            id.typeAnnotation = this.tsParseTypeAnnotation();
            this.resetEndLocation(id);
            this.expect(3);
            node.parameters = [
                id
            ];
            const type = this.tsTryParseTypeAnnotation();
            if (type) node.typeAnnotation = type;
            this.tsParseTypeMemberSemicolon();
            return this.finishNode(node, "TSIndexSignature");
        }
        tsParsePropertyOrMethodSignature(node, readonly) {
            if (this.eat(17)) node.optional = true;
            const nodeAny = node;
            if (this.match(10) || this.match(47)) {
                if (readonly) this.raise($b48499974d50e8d0$var$TSErrors.ReadonlyForMethodSignature, node);
                const method = nodeAny;
                if (method.kind && this.match(47)) this.raise($b48499974d50e8d0$var$TSErrors.AccesorCannotHaveTypeParameters, this.state.curPosition());
                this.tsFillSignature(14, method);
                this.tsParseTypeMemberSemicolon();
                const paramsKey = "parameters";
                const returnTypeKey = "typeAnnotation";
                if (method.kind === "get") {
                    if (method[paramsKey].length > 0) {
                        this.raise($b48499974d50e8d0$var$Errors.BadGetterArity, this.state.curPosition());
                        if (this.isThisParam(method[paramsKey][0])) this.raise($b48499974d50e8d0$var$TSErrors.AccesorCannotDeclareThisParameter, this.state.curPosition());
                    }
                } else if (method.kind === "set") {
                    if (method[paramsKey].length !== 1) this.raise($b48499974d50e8d0$var$Errors.BadSetterArity, this.state.curPosition());
                    else {
                        const firstParameter = method[paramsKey][0];
                        if (this.isThisParam(firstParameter)) this.raise($b48499974d50e8d0$var$TSErrors.AccesorCannotDeclareThisParameter, this.state.curPosition());
                        if (firstParameter.type === "Identifier" && firstParameter.optional) this.raise($b48499974d50e8d0$var$TSErrors.SetAccesorCannotHaveOptionalParameter, this.state.curPosition());
                        if (firstParameter.type === "RestElement") this.raise($b48499974d50e8d0$var$TSErrors.SetAccesorCannotHaveRestParameter, this.state.curPosition());
                    }
                    if (method[returnTypeKey]) this.raise($b48499974d50e8d0$var$TSErrors.SetAccesorCannotHaveReturnType, method[returnTypeKey]);
                } else method.kind = "method";
                return this.finishNode(method, "TSMethodSignature");
            } else {
                const property = nodeAny;
                if (readonly) property.readonly = true;
                const type = this.tsTryParseTypeAnnotation();
                if (type) property.typeAnnotation = type;
                this.tsParseTypeMemberSemicolon();
                return this.finishNode(property, "TSPropertySignature");
            }
        }
        tsParseTypeMember() {
            const node = this.startNode();
            if (this.match(10) || this.match(47)) return this.tsParseSignatureMember("TSCallSignatureDeclaration", node);
            if (this.match(77)) {
                const id = this.startNode();
                this.next();
                if (this.match(10) || this.match(47)) return this.tsParseSignatureMember("TSConstructSignatureDeclaration", node);
                else {
                    node.key = this.createIdentifier(id, "new");
                    return this.tsParsePropertyOrMethodSignature(node, false);
                }
            }
            this.tsParseModifiers({
                allowedModifiers: [
                    "readonly"
                ],
                disallowedModifiers: [
                    "declare",
                    "abstract",
                    "private",
                    "protected",
                    "public",
                    "static",
                    "override"
                ]
            }, node);
            const idx = this.tsTryParseIndexSignature(node);
            if (idx) return idx;
            super.parsePropertyName(node);
            if (!node.computed && node.key.type === "Identifier" && (node.key.name === "get" || node.key.name === "set") && this.tsTokenCanFollowModifier()) {
                node.kind = node.key.name;
                super.parsePropertyName(node);
            }
            return this.tsParsePropertyOrMethodSignature(node, !!node.readonly);
        }
        tsParseTypeLiteral() {
            const node = this.startNode();
            node.members = this.tsParseObjectTypeMembers();
            return this.finishNode(node, "TSTypeLiteral");
        }
        tsParseObjectTypeMembers() {
            this.expect(5);
            const members = this.tsParseList("TypeMembers", this.tsParseTypeMember.bind(this));
            this.expect(8);
            return members;
        }
        tsIsStartOfMappedType() {
            this.next();
            if (this.eat(53)) return this.isContextual(122);
            if (this.isContextual(122)) this.next();
            if (!this.match(0)) return false;
            this.next();
            if (!this.tsIsIdentifier()) return false;
            this.next();
            return this.match(58);
        }
        tsParseMappedTypeParameter() {
            const node = this.startNode();
            node.name = this.tsParseTypeParameterName();
            node.constraint = this.tsExpectThenParseType(58);
            return this.finishNode(node, "TSTypeParameter");
        }
        tsParseMappedType() {
            const node = this.startNode();
            this.expect(5);
            if (this.match(53)) {
                node.readonly = this.state.value;
                this.next();
                this.expectContextual(122);
            } else if (this.eatContextual(122)) node.readonly = true;
            this.expect(0);
            node.typeParameter = this.tsParseMappedTypeParameter();
            node.nameType = this.eatContextual(93) ? this.tsParseType() : null;
            this.expect(3);
            if (this.match(53)) {
                node.optional = this.state.value;
                this.next();
                this.expect(17);
            } else if (this.eat(17)) node.optional = true;
            node.typeAnnotation = this.tsTryParseType();
            this.semicolon();
            this.expect(8);
            return this.finishNode(node, "TSMappedType");
        }
        tsParseTupleType() {
            const node = this.startNode();
            node.elementTypes = this.tsParseBracketedList("TupleElementTypes", this.tsParseTupleElementType.bind(this), true, false);
            let seenOptionalElement = false;
            node.elementTypes.forEach((elementNode)=>{
                const { type: type } = elementNode;
                if (seenOptionalElement && type !== "TSRestType" && type !== "TSOptionalType" && !(type === "TSNamedTupleMember" && elementNode.optional)) this.raise($b48499974d50e8d0$var$TSErrors.OptionalTypeBeforeRequired, elementNode);
                seenOptionalElement || (seenOptionalElement = type === "TSNamedTupleMember" && elementNode.optional || type === "TSOptionalType");
            });
            return this.finishNode(node, "TSTupleType");
        }
        tsParseTupleElementType() {
            const { startLoc: startLoc } = this.state;
            const rest = this.eat(21);
            let labeled;
            let label;
            let optional;
            let type;
            const isWord = $b48499974d50e8d0$var$tokenIsKeywordOrIdentifier(this.state.type);
            const chAfterWord = isWord ? this.lookaheadCharCode() : null;
            if (chAfterWord === 58) {
                labeled = true;
                optional = false;
                label = this.parseIdentifier(true);
                this.expect(14);
                type = this.tsParseType();
            } else if (chAfterWord === 63) {
                optional = true;
                const startLoc = this.state.startLoc;
                const wordName = this.state.value;
                const typeOrLabel = this.tsParseNonArrayType();
                if (this.lookaheadCharCode() === 58) {
                    labeled = true;
                    label = this.createIdentifier(this.startNodeAt(startLoc), wordName);
                    this.expect(17);
                    this.expect(14);
                    type = this.tsParseType();
                } else {
                    labeled = false;
                    type = typeOrLabel;
                    this.expect(17);
                }
            } else {
                type = this.tsParseType();
                optional = this.eat(17);
                labeled = this.eat(14);
            }
            if (labeled) {
                let labeledNode;
                if (label) {
                    labeledNode = this.startNodeAtNode(label);
                    labeledNode.optional = optional;
                    labeledNode.label = label;
                    labeledNode.elementType = type;
                    if (this.eat(17)) {
                        labeledNode.optional = true;
                        this.raise($b48499974d50e8d0$var$TSErrors.TupleOptionalAfterType, this.state.lastTokStartLoc);
                    }
                } else {
                    labeledNode = this.startNodeAtNode(type);
                    labeledNode.optional = optional;
                    this.raise($b48499974d50e8d0$var$TSErrors.InvalidTupleMemberLabel, type);
                    labeledNode.label = type;
                    labeledNode.elementType = this.tsParseType();
                }
                type = this.finishNode(labeledNode, "TSNamedTupleMember");
            } else if (optional) {
                const optionalTypeNode = this.startNodeAtNode(type);
                optionalTypeNode.typeAnnotation = type;
                type = this.finishNode(optionalTypeNode, "TSOptionalType");
            }
            if (rest) {
                const restNode = this.startNodeAt(startLoc);
                restNode.typeAnnotation = type;
                type = this.finishNode(restNode, "TSRestType");
            }
            return type;
        }
        tsParseParenthesizedType() {
            const node = this.startNode();
            this.expect(10);
            node.typeAnnotation = this.tsParseType();
            this.expect(11);
            return this.finishNode(node, "TSParenthesizedType");
        }
        tsParseFunctionOrConstructorType(type, abstract) {
            const node = this.startNode();
            if (type === "TSConstructorType") {
                node.abstract = !!abstract;
                if (abstract) this.next();
                this.next();
            }
            this.tsInAllowConditionalTypesContext(()=>this.tsFillSignature(19, node));
            return this.finishNode(node, type);
        }
        tsParseLiteralTypeNode() {
            const node = this.startNode();
            switch(this.state.type){
                case 134:
                case 135:
                case 133:
                case 85:
                case 86:
                    node.literal = super.parseExprAtom();
                    break;
                default:
                    this.unexpected();
            }
            return this.finishNode(node, "TSLiteralType");
        }
        tsParseTemplateLiteralType() {
            const node = this.startNode();
            node.literal = super.parseTemplate(false);
            return this.finishNode(node, "TSLiteralType");
        }
        parseTemplateSubstitution() {
            if (this.state.inType) return this.tsParseType();
            return super.parseTemplateSubstitution();
        }
        tsParseThisTypeOrThisTypePredicate() {
            const thisKeyword = this.tsParseThisTypeNode();
            if (this.isContextual(116) && !this.hasPrecedingLineBreak()) return this.tsParseThisTypePredicate(thisKeyword);
            else return thisKeyword;
        }
        tsParseNonArrayType() {
            switch(this.state.type){
                case 133:
                case 134:
                case 135:
                case 85:
                case 86:
                    return this.tsParseLiteralTypeNode();
                case 53:
                    if (this.state.value === "-") {
                        const node = this.startNode();
                        const nextToken = this.lookahead();
                        if (nextToken.type !== 134 && nextToken.type !== 135) this.unexpected();
                        node.literal = this.parseMaybeUnary();
                        return this.finishNode(node, "TSLiteralType");
                    }
                    break;
                case 78:
                    return this.tsParseThisTypeOrThisTypePredicate();
                case 87:
                    return this.tsParseTypeQuery();
                case 83:
                    return this.tsParseImportType();
                case 5:
                    return this.tsLookAhead(this.tsIsStartOfMappedType.bind(this)) ? this.tsParseMappedType() : this.tsParseTypeLiteral();
                case 0:
                    return this.tsParseTupleType();
                case 10:
                    return this.tsParseParenthesizedType();
                case 25:
                case 24:
                    return this.tsParseTemplateLiteralType();
                default:
                    {
                        const { type: type } = this.state;
                        if ($b48499974d50e8d0$var$tokenIsIdentifier(type) || type === 88 || type === 84) {
                            const nodeType = type === 88 ? "TSVoidKeyword" : type === 84 ? "TSNullKeyword" : $b48499974d50e8d0$var$keywordTypeFromName(this.state.value);
                            if (nodeType !== undefined && this.lookaheadCharCode() !== 46) {
                                const node = this.startNode();
                                this.next();
                                return this.finishNode(node, nodeType);
                            }
                            return this.tsParseTypeReference();
                        }
                    }
            }
            this.unexpected();
        }
        tsParseArrayTypeOrHigher() {
            let type = this.tsParseNonArrayType();
            while(!this.hasPrecedingLineBreak() && this.eat(0))if (this.match(3)) {
                const node = this.startNodeAtNode(type);
                node.elementType = type;
                this.expect(3);
                type = this.finishNode(node, "TSArrayType");
            } else {
                const node = this.startNodeAtNode(type);
                node.objectType = type;
                node.indexType = this.tsParseType();
                this.expect(3);
                type = this.finishNode(node, "TSIndexedAccessType");
            }
            return type;
        }
        tsParseTypeOperator() {
            const node = this.startNode();
            const operator = this.state.value;
            this.next();
            node.operator = operator;
            node.typeAnnotation = this.tsParseTypeOperatorOrHigher();
            if (operator === "readonly") this.tsCheckTypeAnnotationForReadOnly(node);
            return this.finishNode(node, "TSTypeOperator");
        }
        tsCheckTypeAnnotationForReadOnly(node) {
            switch(node.typeAnnotation.type){
                case "TSTupleType":
                case "TSArrayType":
                    return;
                default:
                    this.raise($b48499974d50e8d0$var$TSErrors.UnexpectedReadonly, node);
            }
        }
        tsParseInferType() {
            const node = this.startNode();
            this.expectContextual(115);
            const typeParameter = this.startNode();
            typeParameter.name = this.tsParseTypeParameterName();
            typeParameter.constraint = this.tsTryParse(()=>this.tsParseConstraintForInferType());
            node.typeParameter = this.finishNode(typeParameter, "TSTypeParameter");
            return this.finishNode(node, "TSInferType");
        }
        tsParseConstraintForInferType() {
            if (this.eat(81)) {
                const constraint = this.tsInDisallowConditionalTypesContext(()=>this.tsParseType());
                if (this.state.inDisallowConditionalTypesContext || !this.match(17)) return constraint;
            }
        }
        tsParseTypeOperatorOrHigher() {
            const isTypeOperator = $b48499974d50e8d0$var$tokenIsTSTypeOperator(this.state.type) && !this.state.containsEsc;
            return isTypeOperator ? this.tsParseTypeOperator() : this.isContextual(115) ? this.tsParseInferType() : this.tsInAllowConditionalTypesContext(()=>this.tsParseArrayTypeOrHigher());
        }
        tsParseUnionOrIntersectionType(kind, parseConstituentType, operator) {
            const node = this.startNode();
            const hasLeadingOperator = this.eat(operator);
            const types = [];
            do types.push(parseConstituentType());
            while (this.eat(operator));
            if (types.length === 1 && !hasLeadingOperator) return types[0];
            node.types = types;
            return this.finishNode(node, kind);
        }
        tsParseIntersectionTypeOrHigher() {
            return this.tsParseUnionOrIntersectionType("TSIntersectionType", this.tsParseTypeOperatorOrHigher.bind(this), 45);
        }
        tsParseUnionTypeOrHigher() {
            return this.tsParseUnionOrIntersectionType("TSUnionType", this.tsParseIntersectionTypeOrHigher.bind(this), 43);
        }
        tsIsStartOfFunctionType() {
            if (this.match(47)) return true;
            return this.match(10) && this.tsLookAhead(this.tsIsUnambiguouslyStartOfFunctionType.bind(this));
        }
        tsSkipParameterStart() {
            if ($b48499974d50e8d0$var$tokenIsIdentifier(this.state.type) || this.match(78)) {
                this.next();
                return true;
            }
            if (this.match(5)) {
                const { errors: errors } = this.state;
                const previousErrorCount = errors.length;
                try {
                    this.parseObjectLike(8, true);
                    return errors.length === previousErrorCount;
                } catch (_unused) {
                    return false;
                }
            }
            if (this.match(0)) {
                this.next();
                const { errors: errors } = this.state;
                const previousErrorCount = errors.length;
                try {
                    super.parseBindingList(3, 93, 1);
                    return errors.length === previousErrorCount;
                } catch (_unused2) {
                    return false;
                }
            }
            return false;
        }
        tsIsUnambiguouslyStartOfFunctionType() {
            this.next();
            if (this.match(11) || this.match(21)) return true;
            if (this.tsSkipParameterStart()) {
                if (this.match(14) || this.match(12) || this.match(17) || this.match(29)) return true;
                if (this.match(11)) {
                    this.next();
                    if (this.match(19)) return true;
                }
            }
            return false;
        }
        tsParseTypeOrTypePredicateAnnotation(returnToken) {
            return this.tsInType(()=>{
                const t = this.startNode();
                this.expect(returnToken);
                const node = this.startNode();
                const asserts = !!this.tsTryParse(this.tsParseTypePredicateAsserts.bind(this));
                if (asserts && this.match(78)) {
                    let thisTypePredicate = this.tsParseThisTypeOrThisTypePredicate();
                    if (thisTypePredicate.type === "TSThisType") {
                        node.parameterName = thisTypePredicate;
                        node.asserts = true;
                        node.typeAnnotation = null;
                        thisTypePredicate = this.finishNode(node, "TSTypePredicate");
                    } else {
                        this.resetStartLocationFromNode(thisTypePredicate, node);
                        thisTypePredicate.asserts = true;
                    }
                    t.typeAnnotation = thisTypePredicate;
                    return this.finishNode(t, "TSTypeAnnotation");
                }
                const typePredicateVariable = this.tsIsIdentifier() && this.tsTryParse(this.tsParseTypePredicatePrefix.bind(this));
                if (!typePredicateVariable) {
                    if (!asserts) return this.tsParseTypeAnnotation(false, t);
                    node.parameterName = this.parseIdentifier();
                    node.asserts = asserts;
                    node.typeAnnotation = null;
                    t.typeAnnotation = this.finishNode(node, "TSTypePredicate");
                    return this.finishNode(t, "TSTypeAnnotation");
                }
                const type = this.tsParseTypeAnnotation(false);
                node.parameterName = typePredicateVariable;
                node.typeAnnotation = type;
                node.asserts = asserts;
                t.typeAnnotation = this.finishNode(node, "TSTypePredicate");
                return this.finishNode(t, "TSTypeAnnotation");
            });
        }
        tsTryParseTypeOrTypePredicateAnnotation() {
            if (this.match(14)) return this.tsParseTypeOrTypePredicateAnnotation(14);
        }
        tsTryParseTypeAnnotation() {
            if (this.match(14)) return this.tsParseTypeAnnotation();
        }
        tsTryParseType() {
            return this.tsEatThenParseType(14);
        }
        tsParseTypePredicatePrefix() {
            const id = this.parseIdentifier();
            if (this.isContextual(116) && !this.hasPrecedingLineBreak()) {
                this.next();
                return id;
            }
        }
        tsParseTypePredicateAsserts() {
            if (this.state.type !== 109) return false;
            const containsEsc = this.state.containsEsc;
            this.next();
            if (!$b48499974d50e8d0$var$tokenIsIdentifier(this.state.type) && !this.match(78)) return false;
            if (containsEsc) this.raise($b48499974d50e8d0$var$Errors.InvalidEscapedReservedWord, this.state.lastTokStartLoc, {
                reservedWord: "asserts"
            });
            return true;
        }
        tsParseTypeAnnotation(eatColon = true, t = this.startNode()) {
            this.tsInType(()=>{
                if (eatColon) this.expect(14);
                t.typeAnnotation = this.tsParseType();
            });
            return this.finishNode(t, "TSTypeAnnotation");
        }
        tsParseType() {
            $b48499974d50e8d0$var$assert(this.state.inType);
            const type = this.tsParseNonConditionalType();
            if (this.state.inDisallowConditionalTypesContext || this.hasPrecedingLineBreak() || !this.eat(81)) return type;
            const node = this.startNodeAtNode(type);
            node.checkType = type;
            node.extendsType = this.tsInDisallowConditionalTypesContext(()=>this.tsParseNonConditionalType());
            this.expect(17);
            node.trueType = this.tsInAllowConditionalTypesContext(()=>this.tsParseType());
            this.expect(14);
            node.falseType = this.tsInAllowConditionalTypesContext(()=>this.tsParseType());
            return this.finishNode(node, "TSConditionalType");
        }
        isAbstractConstructorSignature() {
            return this.isContextual(124) && this.lookahead().type === 77;
        }
        tsParseNonConditionalType() {
            if (this.tsIsStartOfFunctionType()) return this.tsParseFunctionOrConstructorType("TSFunctionType");
            if (this.match(77)) return this.tsParseFunctionOrConstructorType("TSConstructorType");
            else if (this.isAbstractConstructorSignature()) return this.tsParseFunctionOrConstructorType("TSConstructorType", true);
            return this.tsParseUnionTypeOrHigher();
        }
        tsParseTypeAssertion() {
            if (this.getPluginOption("typescript", "disallowAmbiguousJSXLike")) this.raise($b48499974d50e8d0$var$TSErrors.ReservedTypeAssertion, this.state.startLoc);
            const node = this.startNode();
            node.typeAnnotation = this.tsInType(()=>{
                this.next();
                return this.match(75) ? this.tsParseTypeReference() : this.tsParseType();
            });
            this.expect(48);
            node.expression = this.parseMaybeUnary();
            return this.finishNode(node, "TSTypeAssertion");
        }
        tsParseHeritageClause(token) {
            const originalStartLoc = this.state.startLoc;
            const delimitedList = this.tsParseDelimitedList("HeritageClauseElement", ()=>{
                const node = this.startNode();
                node.expression = this.tsParseEntityName();
                if (this.match(47)) node.typeParameters = this.tsParseTypeArguments();
                return this.finishNode(node, "TSExpressionWithTypeArguments");
            });
            if (!delimitedList.length) this.raise($b48499974d50e8d0$var$TSErrors.EmptyHeritageClauseType, originalStartLoc, {
                token: token
            });
            return delimitedList;
        }
        tsParseInterfaceDeclaration(node, properties = {}) {
            if (this.hasFollowingLineBreak()) return null;
            this.expectContextual(129);
            if (properties.declare) node.declare = true;
            if ($b48499974d50e8d0$var$tokenIsIdentifier(this.state.type)) {
                node.id = this.parseIdentifier();
                this.checkIdentifier(node.id, 130);
            } else {
                node.id = null;
                this.raise($b48499974d50e8d0$var$TSErrors.MissingInterfaceName, this.state.startLoc);
            }
            node.typeParameters = this.tsTryParseTypeParameters(this.tsParseInOutConstModifiers);
            if (this.eat(81)) node.extends = this.tsParseHeritageClause("extends");
            const body = this.startNode();
            body.body = this.tsInType(this.tsParseObjectTypeMembers.bind(this));
            node.body = this.finishNode(body, "TSInterfaceBody");
            return this.finishNode(node, "TSInterfaceDeclaration");
        }
        tsParseTypeAliasDeclaration(node) {
            node.id = this.parseIdentifier();
            this.checkIdentifier(node.id, 2);
            node.typeAnnotation = this.tsInType(()=>{
                node.typeParameters = this.tsTryParseTypeParameters(this.tsParseInOutModifiers);
                this.expect(29);
                if (this.isContextual(114) && this.lookahead().type !== 16) {
                    const node = this.startNode();
                    this.next();
                    return this.finishNode(node, "TSIntrinsicKeyword");
                }
                return this.tsParseType();
            });
            this.semicolon();
            return this.finishNode(node, "TSTypeAliasDeclaration");
        }
        tsInNoContext(cb) {
            const oldContext = this.state.context;
            this.state.context = [
                oldContext[0]
            ];
            try {
                return cb();
            } finally{
                this.state.context = oldContext;
            }
        }
        tsInType(cb) {
            const oldInType = this.state.inType;
            this.state.inType = true;
            try {
                return cb();
            } finally{
                this.state.inType = oldInType;
            }
        }
        tsInDisallowConditionalTypesContext(cb) {
            const oldInDisallowConditionalTypesContext = this.state.inDisallowConditionalTypesContext;
            this.state.inDisallowConditionalTypesContext = true;
            try {
                return cb();
            } finally{
                this.state.inDisallowConditionalTypesContext = oldInDisallowConditionalTypesContext;
            }
        }
        tsInAllowConditionalTypesContext(cb) {
            const oldInDisallowConditionalTypesContext = this.state.inDisallowConditionalTypesContext;
            this.state.inDisallowConditionalTypesContext = false;
            try {
                return cb();
            } finally{
                this.state.inDisallowConditionalTypesContext = oldInDisallowConditionalTypesContext;
            }
        }
        tsEatThenParseType(token) {
            if (this.match(token)) return this.tsNextThenParseType();
        }
        tsExpectThenParseType(token) {
            return this.tsInType(()=>{
                this.expect(token);
                return this.tsParseType();
            });
        }
        tsNextThenParseType() {
            return this.tsInType(()=>{
                this.next();
                return this.tsParseType();
            });
        }
        tsParseEnumMember() {
            const node = this.startNode();
            node.id = this.match(133) ? super.parseStringLiteral(this.state.value) : this.parseIdentifier(true);
            if (this.eat(29)) node.initializer = super.parseMaybeAssignAllowIn();
            return this.finishNode(node, "TSEnumMember");
        }
        tsParseEnumDeclaration(node, properties = {}) {
            if (properties.const) node.const = true;
            if (properties.declare) node.declare = true;
            this.expectContextual(126);
            node.id = this.parseIdentifier();
            this.checkIdentifier(node.id, node.const ? 8971 : 8459);
            this.expect(5);
            node.members = this.tsParseDelimitedList("EnumMembers", this.tsParseEnumMember.bind(this));
            this.expect(8);
            return this.finishNode(node, "TSEnumDeclaration");
        }
        tsParseModuleBlock() {
            const node = this.startNode();
            this.scope.enter(0);
            this.expect(5);
            super.parseBlockOrModuleBlockBody(node.body = [], undefined, true, 8);
            this.scope.exit();
            return this.finishNode(node, "TSModuleBlock");
        }
        tsParseModuleOrNamespaceDeclaration(node, nested = false) {
            node.id = this.parseIdentifier();
            if (!nested) this.checkIdentifier(node.id, 1024);
            if (this.eat(16)) {
                const inner = this.startNode();
                this.tsParseModuleOrNamespaceDeclaration(inner, true);
                node.body = inner;
            } else {
                this.scope.enter(256);
                this.prodParam.enter(0);
                node.body = this.tsParseModuleBlock();
                this.prodParam.exit();
                this.scope.exit();
            }
            return this.finishNode(node, "TSModuleDeclaration");
        }
        tsParseAmbientExternalModuleDeclaration(node) {
            if (this.isContextual(112)) {
                node.global = true;
                node.id = this.parseIdentifier();
            } else if (this.match(133)) node.id = super.parseStringLiteral(this.state.value);
            else this.unexpected();
            if (this.match(5)) {
                this.scope.enter(256);
                this.prodParam.enter(0);
                node.body = this.tsParseModuleBlock();
                this.prodParam.exit();
                this.scope.exit();
            } else this.semicolon();
            return this.finishNode(node, "TSModuleDeclaration");
        }
        tsParseImportEqualsDeclaration(node, maybeDefaultIdentifier, isExport) {
            node.isExport = isExport || false;
            node.id = maybeDefaultIdentifier || this.parseIdentifier();
            this.checkIdentifier(node.id, 4096);
            this.expect(29);
            const moduleReference = this.tsParseModuleReference();
            if (node.importKind === "type" && moduleReference.type !== "TSExternalModuleReference") this.raise($b48499974d50e8d0$var$TSErrors.ImportAliasHasImportType, moduleReference);
            node.moduleReference = moduleReference;
            this.semicolon();
            return this.finishNode(node, "TSImportEqualsDeclaration");
        }
        tsIsExternalModuleReference() {
            return this.isContextual(119) && this.lookaheadCharCode() === 40;
        }
        tsParseModuleReference() {
            return this.tsIsExternalModuleReference() ? this.tsParseExternalModuleReference() : this.tsParseEntityName(false);
        }
        tsParseExternalModuleReference() {
            const node = this.startNode();
            this.expectContextual(119);
            this.expect(10);
            if (!this.match(133)) this.unexpected();
            node.expression = super.parseExprAtom();
            this.expect(11);
            this.sawUnambiguousESM = true;
            return this.finishNode(node, "TSExternalModuleReference");
        }
        tsLookAhead(f) {
            const state = this.state.clone();
            const res = f();
            this.state = state;
            return res;
        }
        tsTryParseAndCatch(f) {
            const result = this.tryParse((abort)=>f() || abort());
            if (result.aborted || !result.node) return;
            if (result.error) this.state = result.failState;
            return result.node;
        }
        tsTryParse(f) {
            const state = this.state.clone();
            const result = f();
            if (result !== undefined && result !== false) return result;
            this.state = state;
        }
        tsTryParseDeclare(nany) {
            if (this.isLineTerminator()) return;
            let startType = this.state.type;
            let kind;
            if (this.isContextual(100)) {
                startType = 74;
                kind = "let";
            }
            return this.tsInAmbientContext(()=>{
                switch(startType){
                    case 68:
                        nany.declare = true;
                        return super.parseFunctionStatement(nany, false, false);
                    case 80:
                        nany.declare = true;
                        return this.parseClass(nany, true, false);
                    case 126:
                        return this.tsParseEnumDeclaration(nany, {
                            declare: true
                        });
                    case 112:
                        return this.tsParseAmbientExternalModuleDeclaration(nany);
                    case 75:
                    case 74:
                        if (!this.match(75) || !this.isLookaheadContextual("enum")) {
                            nany.declare = true;
                            return this.parseVarStatement(nany, kind || this.state.value, true);
                        }
                        this.expect(75);
                        return this.tsParseEnumDeclaration(nany, {
                            const: true,
                            declare: true
                        });
                    case 129:
                        {
                            const result = this.tsParseInterfaceDeclaration(nany, {
                                declare: true
                            });
                            if (result) return result;
                        }
                    default:
                        if ($b48499974d50e8d0$var$tokenIsIdentifier(startType)) return this.tsParseDeclaration(nany, this.state.value, true, null);
                }
            });
        }
        tsTryParseExportDeclaration() {
            return this.tsParseDeclaration(this.startNode(), this.state.value, true, null);
        }
        tsParseExpressionStatement(node, expr, decorators) {
            switch(expr.name){
                case "declare":
                    {
                        const declaration = this.tsTryParseDeclare(node);
                        if (declaration) declaration.declare = true;
                        return declaration;
                    }
                case "global":
                    if (this.match(5)) {
                        this.scope.enter(256);
                        this.prodParam.enter(0);
                        const mod = node;
                        mod.global = true;
                        mod.id = expr;
                        mod.body = this.tsParseModuleBlock();
                        this.scope.exit();
                        this.prodParam.exit();
                        return this.finishNode(mod, "TSModuleDeclaration");
                    }
                    break;
                default:
                    return this.tsParseDeclaration(node, expr.name, false, decorators);
            }
        }
        tsParseDeclaration(node, value, next, decorators) {
            switch(value){
                case "abstract":
                    if (this.tsCheckLineTerminator(next) && (this.match(80) || $b48499974d50e8d0$var$tokenIsIdentifier(this.state.type))) return this.tsParseAbstractDeclaration(node, decorators);
                    break;
                case "module":
                    if (this.tsCheckLineTerminator(next)) {
                        if (this.match(133)) return this.tsParseAmbientExternalModuleDeclaration(node);
                        else if ($b48499974d50e8d0$var$tokenIsIdentifier(this.state.type)) return this.tsParseModuleOrNamespaceDeclaration(node);
                    }
                    break;
                case "namespace":
                    if (this.tsCheckLineTerminator(next) && $b48499974d50e8d0$var$tokenIsIdentifier(this.state.type)) return this.tsParseModuleOrNamespaceDeclaration(node);
                    break;
                case "type":
                    if (this.tsCheckLineTerminator(next) && $b48499974d50e8d0$var$tokenIsIdentifier(this.state.type)) return this.tsParseTypeAliasDeclaration(node);
                    break;
            }
        }
        tsCheckLineTerminator(next) {
            if (next) {
                if (this.hasFollowingLineBreak()) return false;
                this.next();
                return true;
            }
            return !this.isLineTerminator();
        }
        tsTryParseGenericAsyncArrowFunction(startLoc) {
            if (!this.match(47)) return;
            const oldMaybeInArrowParameters = this.state.maybeInArrowParameters;
            this.state.maybeInArrowParameters = true;
            const res = this.tsTryParseAndCatch(()=>{
                const node = this.startNodeAt(startLoc);
                node.typeParameters = this.tsParseTypeParameters(this.tsParseConstModifier);
                super.parseFunctionParams(node);
                node.returnType = this.tsTryParseTypeOrTypePredicateAnnotation();
                this.expect(19);
                return node;
            });
            this.state.maybeInArrowParameters = oldMaybeInArrowParameters;
            if (!res) return;
            return super.parseArrowExpression(res, null, true);
        }
        tsParseTypeArgumentsInExpression() {
            if (this.reScan_lt() !== 47) return;
            return this.tsParseTypeArguments();
        }
        tsParseTypeArguments() {
            const node = this.startNode();
            node.params = this.tsInType(()=>this.tsInNoContext(()=>{
                    this.expect(47);
                    return this.tsParseDelimitedList("TypeParametersOrArguments", this.tsParseType.bind(this));
                }));
            if (node.params.length === 0) this.raise($b48499974d50e8d0$var$TSErrors.EmptyTypeArguments, node);
            else if (!this.state.inType && this.curContext() === $b48499974d50e8d0$var$types.brace) this.reScan_lt_gt();
            this.expect(48);
            return this.finishNode(node, "TSTypeParameterInstantiation");
        }
        tsIsDeclarationStart() {
            return $b48499974d50e8d0$var$tokenIsTSDeclarationStart(this.state.type);
        }
        isExportDefaultSpecifier() {
            if (this.tsIsDeclarationStart()) return false;
            return super.isExportDefaultSpecifier();
        }
        parseAssignableListItem(flags, decorators) {
            const startLoc = this.state.startLoc;
            const modified = {};
            this.tsParseModifiers({
                allowedModifiers: [
                    "public",
                    "private",
                    "protected",
                    "override",
                    "readonly"
                ]
            }, modified);
            const accessibility = modified.accessibility;
            const override = modified.override;
            const readonly = modified.readonly;
            if (!(flags & 4) && (accessibility || readonly || override)) this.raise($b48499974d50e8d0$var$TSErrors.UnexpectedParameterModifier, startLoc);
            const left = this.parseMaybeDefault();
            this.parseAssignableListItemTypes(left, flags);
            const elt = this.parseMaybeDefault(left.loc.start, left);
            if (accessibility || readonly || override) {
                const pp = this.startNodeAt(startLoc);
                if (decorators.length) pp.decorators = decorators;
                if (accessibility) pp.accessibility = accessibility;
                if (readonly) pp.readonly = readonly;
                if (override) pp.override = override;
                if (elt.type !== "Identifier" && elt.type !== "AssignmentPattern") this.raise($b48499974d50e8d0$var$TSErrors.UnsupportedParameterPropertyKind, pp);
                pp.parameter = elt;
                return this.finishNode(pp, "TSParameterProperty");
            }
            if (decorators.length) left.decorators = decorators;
            return elt;
        }
        isSimpleParameter(node) {
            return node.type === "TSParameterProperty" && super.isSimpleParameter(node.parameter) || super.isSimpleParameter(node);
        }
        tsDisallowOptionalPattern(node) {
            for (const param of node.params)if (param.type !== "Identifier" && param.optional && !this.state.isAmbientContext) this.raise($b48499974d50e8d0$var$TSErrors.PatternIsOptional, param);
        }
        setArrowFunctionParameters(node, params, trailingCommaLoc) {
            super.setArrowFunctionParameters(node, params, trailingCommaLoc);
            this.tsDisallowOptionalPattern(node);
        }
        parseFunctionBodyAndFinish(node, type, isMethod = false) {
            if (this.match(14)) node.returnType = this.tsParseTypeOrTypePredicateAnnotation(14);
            const bodilessType = type === "FunctionDeclaration" ? "TSDeclareFunction" : type === "ClassMethod" || type === "ClassPrivateMethod" ? "TSDeclareMethod" : undefined;
            if (bodilessType && !this.match(5) && this.isLineTerminator()) return this.finishNode(node, bodilessType);
            if (bodilessType === "TSDeclareFunction" && this.state.isAmbientContext) {
                this.raise($b48499974d50e8d0$var$TSErrors.DeclareFunctionHasImplementation, node);
                if (node.declare) return super.parseFunctionBodyAndFinish(node, bodilessType, isMethod);
            }
            this.tsDisallowOptionalPattern(node);
            return super.parseFunctionBodyAndFinish(node, type, isMethod);
        }
        registerFunctionStatementId(node) {
            if (!node.body && node.id) this.checkIdentifier(node.id, 1024);
            else super.registerFunctionStatementId(node);
        }
        tsCheckForInvalidTypeCasts(items) {
            items.forEach((node)=>{
                if ((node == null ? void 0 : node.type) === "TSTypeCastExpression") this.raise($b48499974d50e8d0$var$TSErrors.UnexpectedTypeAnnotation, node.typeAnnotation);
            });
        }
        toReferencedList(exprList, isInParens) {
            this.tsCheckForInvalidTypeCasts(exprList);
            return exprList;
        }
        parseArrayLike(close, canBePattern, isTuple, refExpressionErrors) {
            const node = super.parseArrayLike(close, canBePattern, isTuple, refExpressionErrors);
            if (node.type === "ArrayExpression") this.tsCheckForInvalidTypeCasts(node.elements);
            return node;
        }
        parseSubscript(base, startLoc, noCalls, state) {
            if (!this.hasPrecedingLineBreak() && this.match(35)) {
                this.state.canStartJSXElement = false;
                this.next();
                const nonNullExpression = this.startNodeAt(startLoc);
                nonNullExpression.expression = base;
                return this.finishNode(nonNullExpression, "TSNonNullExpression");
            }
            let isOptionalCall = false;
            if (this.match(18) && this.lookaheadCharCode() === 60) {
                if (noCalls) {
                    state.stop = true;
                    return base;
                }
                state.optionalChainMember = isOptionalCall = true;
                this.next();
            }
            if (this.match(47) || this.match(51)) {
                let missingParenErrorLoc;
                const result = this.tsTryParseAndCatch(()=>{
                    if (!noCalls && this.atPossibleAsyncArrow(base)) {
                        const asyncArrowFn = this.tsTryParseGenericAsyncArrowFunction(startLoc);
                        if (asyncArrowFn) return asyncArrowFn;
                    }
                    const typeArguments = this.tsParseTypeArgumentsInExpression();
                    if (!typeArguments) return;
                    if (isOptionalCall && !this.match(10)) {
                        missingParenErrorLoc = this.state.curPosition();
                        return;
                    }
                    if ($b48499974d50e8d0$var$tokenIsTemplate(this.state.type)) {
                        const result = super.parseTaggedTemplateExpression(base, startLoc, state);
                        result.typeParameters = typeArguments;
                        return result;
                    }
                    if (!noCalls && this.eat(10)) {
                        const node = this.startNodeAt(startLoc);
                        node.callee = base;
                        node.arguments = this.parseCallExpressionArguments(11, false);
                        this.tsCheckForInvalidTypeCasts(node.arguments);
                        node.typeParameters = typeArguments;
                        if (state.optionalChainMember) node.optional = isOptionalCall;
                        return this.finishCallExpression(node, state.optionalChainMember);
                    }
                    const tokenType = this.state.type;
                    if (tokenType === 48 || tokenType === 52 || tokenType !== 10 && $b48499974d50e8d0$var$tokenCanStartExpression(tokenType) && !this.hasPrecedingLineBreak()) return;
                    const node = this.startNodeAt(startLoc);
                    node.expression = base;
                    node.typeParameters = typeArguments;
                    return this.finishNode(node, "TSInstantiationExpression");
                });
                if (missingParenErrorLoc) this.unexpected(missingParenErrorLoc, 10);
                if (result) {
                    if (result.type === "TSInstantiationExpression" && (this.match(16) || this.match(18) && this.lookaheadCharCode() !== 40)) this.raise($b48499974d50e8d0$var$TSErrors.InvalidPropertyAccessAfterInstantiationExpression, this.state.startLoc);
                    return result;
                }
            }
            return super.parseSubscript(base, startLoc, noCalls, state);
        }
        parseNewCallee(node) {
            var _callee$extra;
            super.parseNewCallee(node);
            const { callee: callee } = node;
            if (callee.type === "TSInstantiationExpression" && !((_callee$extra = callee.extra) != null && _callee$extra.parenthesized)) {
                node.typeParameters = callee.typeParameters;
                node.callee = callee.expression;
            }
        }
        parseExprOp(left, leftStartLoc, minPrec) {
            let isSatisfies;
            if ($b48499974d50e8d0$var$tokenOperatorPrecedence(58) > minPrec && !this.hasPrecedingLineBreak() && (this.isContextual(93) || (isSatisfies = this.isContextual(120)))) {
                const node = this.startNodeAt(leftStartLoc);
                node.expression = left;
                node.typeAnnotation = this.tsInType(()=>{
                    this.next();
                    if (this.match(75)) {
                        if (isSatisfies) this.raise($b48499974d50e8d0$var$Errors.UnexpectedKeyword, this.state.startLoc, {
                            keyword: "const"
                        });
                        return this.tsParseTypeReference();
                    }
                    return this.tsParseType();
                });
                this.finishNode(node, isSatisfies ? "TSSatisfiesExpression" : "TSAsExpression");
                this.reScan_lt_gt();
                return this.parseExprOp(node, leftStartLoc, minPrec);
            }
            return super.parseExprOp(left, leftStartLoc, minPrec);
        }
        checkReservedWord(word, startLoc, checkKeywords, isBinding) {
            if (!this.state.isAmbientContext) super.checkReservedWord(word, startLoc, checkKeywords, isBinding);
        }
        checkImportReflection(node) {
            super.checkImportReflection(node);
            if (node.module && node.importKind !== "value") this.raise($b48499974d50e8d0$var$TSErrors.ImportReflectionHasImportType, node.specifiers[0].loc.start);
        }
        checkDuplicateExports() {}
        isPotentialImportPhase(isExport) {
            if (super.isPotentialImportPhase(isExport)) return true;
            if (this.isContextual(130)) {
                const ch = this.lookaheadCharCode();
                return isExport ? ch === 123 || ch === 42 : ch !== 61;
            }
            return !isExport && this.isContextual(87);
        }
        applyImportPhase(node, isExport, phase, loc) {
            super.applyImportPhase(node, isExport, phase, loc);
            if (isExport) node.exportKind = phase === "type" ? "type" : "value";
            else node.importKind = phase === "type" || phase === "typeof" ? phase : "value";
        }
        parseImport(node) {
            if (this.match(133)) {
                node.importKind = "value";
                return super.parseImport(node);
            }
            let importNode;
            if ($b48499974d50e8d0$var$tokenIsIdentifier(this.state.type) && this.lookaheadCharCode() === 61) {
                node.importKind = "value";
                return this.tsParseImportEqualsDeclaration(node);
            } else if (this.isContextual(130)) {
                const maybeDefaultIdentifier = this.parseMaybeImportPhase(node, false);
                if (this.lookaheadCharCode() === 61) return this.tsParseImportEqualsDeclaration(node, maybeDefaultIdentifier);
                else importNode = super.parseImportSpecifiersAndAfter(node, maybeDefaultIdentifier);
            } else importNode = super.parseImport(node);
            if (importNode.importKind === "type" && importNode.specifiers.length > 1 && importNode.specifiers[0].type === "ImportDefaultSpecifier") this.raise($b48499974d50e8d0$var$TSErrors.TypeImportCannotSpecifyDefaultAndNamed, importNode);
            return importNode;
        }
        parseExport(node, decorators) {
            if (this.match(83)) {
                this.next();
                let maybeDefaultIdentifier = null;
                if (this.isContextual(130) && this.isPotentialImportPhase(false)) maybeDefaultIdentifier = this.parseMaybeImportPhase(node, false);
                else node.importKind = "value";
                return this.tsParseImportEqualsDeclaration(node, maybeDefaultIdentifier, true);
            } else if (this.eat(29)) {
                const assign = node;
                assign.expression = super.parseExpression();
                this.semicolon();
                this.sawUnambiguousESM = true;
                return this.finishNode(assign, "TSExportAssignment");
            } else if (this.eatContextual(93)) {
                const decl = node;
                this.expectContextual(128);
                decl.id = this.parseIdentifier();
                this.semicolon();
                return this.finishNode(decl, "TSNamespaceExportDeclaration");
            } else return super.parseExport(node, decorators);
        }
        isAbstractClass() {
            return this.isContextual(124) && this.lookahead().type === 80;
        }
        parseExportDefaultExpression() {
            if (this.isAbstractClass()) {
                const cls = this.startNode();
                this.next();
                cls.abstract = true;
                return this.parseClass(cls, true, true);
            }
            if (this.match(129)) {
                const result = this.tsParseInterfaceDeclaration(this.startNode());
                if (result) return result;
            }
            return super.parseExportDefaultExpression();
        }
        parseVarStatement(node, kind, allowMissingInitializer = false) {
            const { isAmbientContext: isAmbientContext } = this.state;
            const declaration = super.parseVarStatement(node, kind, allowMissingInitializer || isAmbientContext);
            if (!isAmbientContext) return declaration;
            for (const { id: id, init: init } of declaration.declarations){
                if (!init) continue;
                if (kind !== "const" || !!id.typeAnnotation) this.raise($b48499974d50e8d0$var$TSErrors.InitializerNotAllowedInAmbientContext, init);
                else if (!$b48499974d50e8d0$var$isValidAmbientConstInitializer(init, this.hasPlugin("estree"))) this.raise($b48499974d50e8d0$var$TSErrors.ConstInitiailizerMustBeStringOrNumericLiteralOrLiteralEnumReference, init);
            }
            return declaration;
        }
        parseStatementContent(flags, decorators) {
            if (this.match(75) && this.isLookaheadContextual("enum")) {
                const node = this.startNode();
                this.expect(75);
                return this.tsParseEnumDeclaration(node, {
                    const: true
                });
            }
            if (this.isContextual(126)) return this.tsParseEnumDeclaration(this.startNode());
            if (this.isContextual(129)) {
                const result = this.tsParseInterfaceDeclaration(this.startNode());
                if (result) return result;
            }
            return super.parseStatementContent(flags, decorators);
        }
        parseAccessModifier() {
            return this.tsParseModifier([
                "public",
                "protected",
                "private"
            ]);
        }
        tsHasSomeModifiers(member, modifiers) {
            return modifiers.some((modifier)=>{
                if ($b48499974d50e8d0$var$tsIsAccessModifier(modifier)) return member.accessibility === modifier;
                return !!member[modifier];
            });
        }
        tsIsStartOfStaticBlocks() {
            return this.isContextual(106) && this.lookaheadCharCode() === 123;
        }
        parseClassMember(classBody, member, state) {
            const modifiers = [
                "declare",
                "private",
                "public",
                "protected",
                "override",
                "abstract",
                "readonly",
                "static"
            ];
            this.tsParseModifiers({
                allowedModifiers: modifiers,
                disallowedModifiers: [
                    "in",
                    "out"
                ],
                stopOnStartOfClassStaticBlock: true,
                errorTemplate: $b48499974d50e8d0$var$TSErrors.InvalidModifierOnTypeParameterPositions
            }, member);
            const callParseClassMemberWithIsStatic = ()=>{
                if (this.tsIsStartOfStaticBlocks()) {
                    this.next();
                    this.next();
                    if (this.tsHasSomeModifiers(member, modifiers)) this.raise($b48499974d50e8d0$var$TSErrors.StaticBlockCannotHaveModifier, this.state.curPosition());
                    super.parseClassStaticBlock(classBody, member);
                } else this.parseClassMemberWithIsStatic(classBody, member, state, !!member.static);
            };
            if (member.declare) this.tsInAmbientContext(callParseClassMemberWithIsStatic);
            else callParseClassMemberWithIsStatic();
        }
        parseClassMemberWithIsStatic(classBody, member, state, isStatic) {
            const idx = this.tsTryParseIndexSignature(member);
            if (idx) {
                classBody.body.push(idx);
                if (member.abstract) this.raise($b48499974d50e8d0$var$TSErrors.IndexSignatureHasAbstract, member);
                if (member.accessibility) this.raise($b48499974d50e8d0$var$TSErrors.IndexSignatureHasAccessibility, member, {
                    modifier: member.accessibility
                });
                if (member.declare) this.raise($b48499974d50e8d0$var$TSErrors.IndexSignatureHasDeclare, member);
                if (member.override) this.raise($b48499974d50e8d0$var$TSErrors.IndexSignatureHasOverride, member);
                return;
            }
            if (!this.state.inAbstractClass && member.abstract) this.raise($b48499974d50e8d0$var$TSErrors.NonAbstractClassHasAbstractMethod, member);
            if (member.override) {
                if (!state.hadSuperClass) this.raise($b48499974d50e8d0$var$TSErrors.OverrideNotInSubClass, member);
            }
            super.parseClassMemberWithIsStatic(classBody, member, state, isStatic);
        }
        parsePostMemberNameModifiers(methodOrProp) {
            const optional = this.eat(17);
            if (optional) methodOrProp.optional = true;
            if (methodOrProp.readonly && this.match(10)) this.raise($b48499974d50e8d0$var$TSErrors.ClassMethodHasReadonly, methodOrProp);
            if (methodOrProp.declare && this.match(10)) this.raise($b48499974d50e8d0$var$TSErrors.ClassMethodHasDeclare, methodOrProp);
        }
        parseExpressionStatement(node, expr, decorators) {
            const decl = expr.type === "Identifier" ? this.tsParseExpressionStatement(node, expr, decorators) : undefined;
            return decl || super.parseExpressionStatement(node, expr, decorators);
        }
        shouldParseExportDeclaration() {
            if (this.tsIsDeclarationStart()) return true;
            return super.shouldParseExportDeclaration();
        }
        parseConditional(expr, startLoc, refExpressionErrors) {
            if (!this.state.maybeInArrowParameters || !this.match(17)) return super.parseConditional(expr, startLoc, refExpressionErrors);
            const result = this.tryParse(()=>super.parseConditional(expr, startLoc));
            if (!result.node) {
                if (result.error) super.setOptionalParametersError(refExpressionErrors, result.error);
                return expr;
            }
            if (result.error) this.state = result.failState;
            return result.node;
        }
        parseParenItem(node, startLoc) {
            node = super.parseParenItem(node, startLoc);
            if (this.eat(17)) {
                node.optional = true;
                this.resetEndLocation(node);
            }
            if (this.match(14)) {
                const typeCastNode = this.startNodeAt(startLoc);
                typeCastNode.expression = node;
                typeCastNode.typeAnnotation = this.tsParseTypeAnnotation();
                return this.finishNode(typeCastNode, "TSTypeCastExpression");
            }
            return node;
        }
        parseExportDeclaration(node) {
            if (!this.state.isAmbientContext && this.isContextual(125)) return this.tsInAmbientContext(()=>this.parseExportDeclaration(node));
            const startLoc = this.state.startLoc;
            const isDeclare = this.eatContextual(125);
            if (isDeclare && (this.isContextual(125) || !this.shouldParseExportDeclaration())) throw this.raise($b48499974d50e8d0$var$TSErrors.ExpectedAmbientAfterExportDeclare, this.state.startLoc);
            const isIdentifier = $b48499974d50e8d0$var$tokenIsIdentifier(this.state.type);
            const declaration = isIdentifier && this.tsTryParseExportDeclaration() || super.parseExportDeclaration(node);
            if (!declaration) return null;
            if (declaration.type === "TSInterfaceDeclaration" || declaration.type === "TSTypeAliasDeclaration" || isDeclare) node.exportKind = "type";
            if (isDeclare) {
                this.resetStartLocation(declaration, startLoc);
                declaration.declare = true;
            }
            return declaration;
        }
        parseClassId(node, isStatement, optionalId, bindingType) {
            if ((!isStatement || optionalId) && this.isContextual(113)) return;
            super.parseClassId(node, isStatement, optionalId, node.declare ? 1024 : 8331);
            const typeParameters = this.tsTryParseTypeParameters(this.tsParseInOutConstModifiers);
            if (typeParameters) node.typeParameters = typeParameters;
        }
        parseClassPropertyAnnotation(node) {
            if (!node.optional) {
                if (this.eat(35)) node.definite = true;
                else if (this.eat(17)) node.optional = true;
            }
            const type = this.tsTryParseTypeAnnotation();
            if (type) node.typeAnnotation = type;
        }
        parseClassProperty(node) {
            this.parseClassPropertyAnnotation(node);
            if (this.state.isAmbientContext && !(node.readonly && !node.typeAnnotation) && this.match(29)) this.raise($b48499974d50e8d0$var$TSErrors.DeclareClassFieldHasInitializer, this.state.startLoc);
            if (node.abstract && this.match(29)) {
                const { key: key } = node;
                this.raise($b48499974d50e8d0$var$TSErrors.AbstractPropertyHasInitializer, this.state.startLoc, {
                    propertyName: key.type === "Identifier" && !node.computed ? key.name : `[${this.input.slice(key.start, key.end)}]`
                });
            }
            return super.parseClassProperty(node);
        }
        parseClassPrivateProperty(node) {
            if (node.abstract) this.raise($b48499974d50e8d0$var$TSErrors.PrivateElementHasAbstract, node);
            if (node.accessibility) this.raise($b48499974d50e8d0$var$TSErrors.PrivateElementHasAccessibility, node, {
                modifier: node.accessibility
            });
            this.parseClassPropertyAnnotation(node);
            return super.parseClassPrivateProperty(node);
        }
        parseClassAccessorProperty(node) {
            this.parseClassPropertyAnnotation(node);
            if (node.optional) this.raise($b48499974d50e8d0$var$TSErrors.AccessorCannotBeOptional, node);
            return super.parseClassAccessorProperty(node);
        }
        pushClassMethod(classBody, method, isGenerator, isAsync, isConstructor, allowsDirectSuper) {
            const typeParameters = this.tsTryParseTypeParameters(this.tsParseConstModifier);
            if (typeParameters && isConstructor) this.raise($b48499974d50e8d0$var$TSErrors.ConstructorHasTypeParameters, typeParameters);
            const { declare: declare = false, kind: kind } = method;
            if (declare && (kind === "get" || kind === "set")) this.raise($b48499974d50e8d0$var$TSErrors.DeclareAccessor, method, {
                kind: kind
            });
            if (typeParameters) method.typeParameters = typeParameters;
            super.pushClassMethod(classBody, method, isGenerator, isAsync, isConstructor, allowsDirectSuper);
        }
        pushClassPrivateMethod(classBody, method, isGenerator, isAsync) {
            const typeParameters = this.tsTryParseTypeParameters(this.tsParseConstModifier);
            if (typeParameters) method.typeParameters = typeParameters;
            super.pushClassPrivateMethod(classBody, method, isGenerator, isAsync);
        }
        declareClassPrivateMethodInScope(node, kind) {
            if (node.type === "TSDeclareMethod") return;
            if (node.type === "MethodDefinition" && !node.value.body) return;
            super.declareClassPrivateMethodInScope(node, kind);
        }
        parseClassSuper(node) {
            super.parseClassSuper(node);
            if (node.superClass && (this.match(47) || this.match(51))) node.superTypeParameters = this.tsParseTypeArgumentsInExpression();
            if (this.eatContextual(113)) node.implements = this.tsParseHeritageClause("implements");
        }
        parseObjPropValue(prop, startLoc, isGenerator, isAsync, isPattern, isAccessor, refExpressionErrors) {
            const typeParameters = this.tsTryParseTypeParameters(this.tsParseConstModifier);
            if (typeParameters) prop.typeParameters = typeParameters;
            return super.parseObjPropValue(prop, startLoc, isGenerator, isAsync, isPattern, isAccessor, refExpressionErrors);
        }
        parseFunctionParams(node, isConstructor) {
            const typeParameters = this.tsTryParseTypeParameters(this.tsParseConstModifier);
            if (typeParameters) node.typeParameters = typeParameters;
            super.parseFunctionParams(node, isConstructor);
        }
        parseVarId(decl, kind) {
            super.parseVarId(decl, kind);
            if (decl.id.type === "Identifier" && !this.hasPrecedingLineBreak() && this.eat(35)) decl.definite = true;
            const type = this.tsTryParseTypeAnnotation();
            if (type) {
                decl.id.typeAnnotation = type;
                this.resetEndLocation(decl.id);
            }
        }
        parseAsyncArrowFromCallExpression(node, call) {
            if (this.match(14)) node.returnType = this.tsParseTypeAnnotation();
            return super.parseAsyncArrowFromCallExpression(node, call);
        }
        parseMaybeAssign(refExpressionErrors, afterLeftParse) {
            var _jsx, _jsx2, _typeCast, _jsx3, _typeCast2;
            let state;
            let jsx;
            let typeCast;
            if (this.hasPlugin("jsx") && (this.match(142) || this.match(47))) {
                state = this.state.clone();
                jsx = this.tryParse(()=>super.parseMaybeAssign(refExpressionErrors, afterLeftParse), state);
                if (!jsx.error) return jsx.node;
                const { context: context } = this.state;
                const currentContext = context[context.length - 1];
                if (currentContext === $b48499974d50e8d0$var$types.j_oTag || currentContext === $b48499974d50e8d0$var$types.j_expr) context.pop();
            }
            if (!((_jsx = jsx) != null && _jsx.error) && !this.match(47)) return super.parseMaybeAssign(refExpressionErrors, afterLeftParse);
            if (!state || state === this.state) state = this.state.clone();
            let typeParameters;
            const arrow = this.tryParse((abort)=>{
                var _expr$extra, _typeParameters;
                typeParameters = this.tsParseTypeParameters(this.tsParseConstModifier);
                const expr = super.parseMaybeAssign(refExpressionErrors, afterLeftParse);
                if (expr.type !== "ArrowFunctionExpression" || (_expr$extra = expr.extra) != null && _expr$extra.parenthesized) abort();
                if (((_typeParameters = typeParameters) == null ? void 0 : _typeParameters.params.length) !== 0) this.resetStartLocationFromNode(expr, typeParameters);
                expr.typeParameters = typeParameters;
                return expr;
            }, state);
            if (!arrow.error && !arrow.aborted) {
                if (typeParameters) this.reportReservedArrowTypeParam(typeParameters);
                return arrow.node;
            }
            if (!jsx) {
                $b48499974d50e8d0$var$assert(!this.hasPlugin("jsx"));
                typeCast = this.tryParse(()=>super.parseMaybeAssign(refExpressionErrors, afterLeftParse), state);
                if (!typeCast.error) return typeCast.node;
            }
            if ((_jsx2 = jsx) != null && _jsx2.node) {
                this.state = jsx.failState;
                return jsx.node;
            }
            if (arrow.node) {
                this.state = arrow.failState;
                if (typeParameters) this.reportReservedArrowTypeParam(typeParameters);
                return arrow.node;
            }
            if ((_typeCast = typeCast) != null && _typeCast.node) {
                this.state = typeCast.failState;
                return typeCast.node;
            }
            throw ((_jsx3 = jsx) == null ? void 0 : _jsx3.error) || arrow.error || ((_typeCast2 = typeCast) == null ? void 0 : _typeCast2.error);
        }
        reportReservedArrowTypeParam(node) {
            var _node$extra;
            if (node.params.length === 1 && !node.params[0].constraint && !((_node$extra = node.extra) != null && _node$extra.trailingComma) && this.getPluginOption("typescript", "disallowAmbiguousJSXLike")) this.raise($b48499974d50e8d0$var$TSErrors.ReservedArrowTypeParam, node);
        }
        parseMaybeUnary(refExpressionErrors, sawUnary) {
            if (!this.hasPlugin("jsx") && this.match(47)) return this.tsParseTypeAssertion();
            return super.parseMaybeUnary(refExpressionErrors, sawUnary);
        }
        parseArrow(node) {
            if (this.match(14)) {
                const result = this.tryParse((abort)=>{
                    const returnType = this.tsParseTypeOrTypePredicateAnnotation(14);
                    if (this.canInsertSemicolon() || !this.match(19)) abort();
                    return returnType;
                });
                if (result.aborted) return;
                if (!result.thrown) {
                    if (result.error) this.state = result.failState;
                    node.returnType = result.node;
                }
            }
            return super.parseArrow(node);
        }
        parseAssignableListItemTypes(param, flags) {
            if (!(flags & 2)) return param;
            if (this.eat(17)) param.optional = true;
            const type = this.tsTryParseTypeAnnotation();
            if (type) param.typeAnnotation = type;
            this.resetEndLocation(param);
            return param;
        }
        isAssignable(node, isBinding) {
            switch(node.type){
                case "TSTypeCastExpression":
                    return this.isAssignable(node.expression, isBinding);
                case "TSParameterProperty":
                    return true;
                default:
                    return super.isAssignable(node, isBinding);
            }
        }
        toAssignable(node, isLHS = false) {
            switch(node.type){
                case "ParenthesizedExpression":
                    this.toAssignableParenthesizedExpression(node, isLHS);
                    break;
                case "TSAsExpression":
                case "TSSatisfiesExpression":
                case "TSNonNullExpression":
                case "TSTypeAssertion":
                    if (isLHS) this.expressionScope.recordArrowParameterBindingError($b48499974d50e8d0$var$TSErrors.UnexpectedTypeCastInParameter, node);
                    else this.raise($b48499974d50e8d0$var$TSErrors.UnexpectedTypeCastInParameter, node);
                    this.toAssignable(node.expression, isLHS);
                    break;
                case "AssignmentExpression":
                    if (!isLHS && node.left.type === "TSTypeCastExpression") node.left = this.typeCastToParameter(node.left);
                default:
                    super.toAssignable(node, isLHS);
            }
        }
        toAssignableParenthesizedExpression(node, isLHS) {
            switch(node.expression.type){
                case "TSAsExpression":
                case "TSSatisfiesExpression":
                case "TSNonNullExpression":
                case "TSTypeAssertion":
                case "ParenthesizedExpression":
                    this.toAssignable(node.expression, isLHS);
                    break;
                default:
                    super.toAssignable(node, isLHS);
            }
        }
        checkToRestConversion(node, allowPattern) {
            switch(node.type){
                case "TSAsExpression":
                case "TSSatisfiesExpression":
                case "TSTypeAssertion":
                case "TSNonNullExpression":
                    this.checkToRestConversion(node.expression, false);
                    break;
                default:
                    super.checkToRestConversion(node, allowPattern);
            }
        }
        isValidLVal(type, isUnparenthesizedInAssign, binding) {
            return $b48499974d50e8d0$var$getOwn({
                TSTypeCastExpression: true,
                TSParameterProperty: "parameter",
                TSNonNullExpression: "expression",
                TSAsExpression: (binding !== 64 || !isUnparenthesizedInAssign) && [
                    "expression",
                    true
                ],
                TSSatisfiesExpression: (binding !== 64 || !isUnparenthesizedInAssign) && [
                    "expression",
                    true
                ],
                TSTypeAssertion: (binding !== 64 || !isUnparenthesizedInAssign) && [
                    "expression",
                    true
                ]
            }, type) || super.isValidLVal(type, isUnparenthesizedInAssign, binding);
        }
        parseBindingAtom() {
            if (this.state.type === 78) return this.parseIdentifier(true);
            return super.parseBindingAtom();
        }
        parseMaybeDecoratorArguments(expr) {
            if (this.match(47) || this.match(51)) {
                const typeArguments = this.tsParseTypeArgumentsInExpression();
                if (this.match(10)) {
                    const call = super.parseMaybeDecoratorArguments(expr);
                    call.typeParameters = typeArguments;
                    return call;
                }
                this.unexpected(null, 10);
            }
            return super.parseMaybeDecoratorArguments(expr);
        }
        checkCommaAfterRest(close) {
            if (this.state.isAmbientContext && this.match(12) && this.lookaheadCharCode() === close) {
                this.next();
                return false;
            }
            return super.checkCommaAfterRest(close);
        }
        isClassMethod() {
            return this.match(47) || super.isClassMethod();
        }
        isClassProperty() {
            return this.match(35) || this.match(14) || super.isClassProperty();
        }
        parseMaybeDefault(startLoc, left) {
            const node = super.parseMaybeDefault(startLoc, left);
            if (node.type === "AssignmentPattern" && node.typeAnnotation && node.right.start < node.typeAnnotation.start) this.raise($b48499974d50e8d0$var$TSErrors.TypeAnnotationAfterAssign, node.typeAnnotation);
            return node;
        }
        getTokenFromCode(code) {
            if (this.state.inType) {
                if (code === 62) {
                    this.finishOp(48, 1);
                    return;
                }
                if (code === 60) {
                    this.finishOp(47, 1);
                    return;
                }
            }
            super.getTokenFromCode(code);
        }
        reScan_lt_gt() {
            const { type: type } = this.state;
            if (type === 47) {
                this.state.pos -= 1;
                this.readToken_lt();
            } else if (type === 48) {
                this.state.pos -= 1;
                this.readToken_gt();
            }
        }
        reScan_lt() {
            const { type: type } = this.state;
            if (type === 51) {
                this.state.pos -= 2;
                this.finishOp(47, 1);
                return 47;
            }
            return type;
        }
        toAssignableList(exprList, trailingCommaLoc, isLHS) {
            for(let i = 0; i < exprList.length; i++){
                const expr = exprList[i];
                if ((expr == null ? void 0 : expr.type) === "TSTypeCastExpression") exprList[i] = this.typeCastToParameter(expr);
            }
            super.toAssignableList(exprList, trailingCommaLoc, isLHS);
        }
        typeCastToParameter(node) {
            node.expression.typeAnnotation = node.typeAnnotation;
            this.resetEndLocation(node.expression, node.typeAnnotation.loc.end);
            return node.expression;
        }
        shouldParseArrow(params) {
            if (this.match(14)) return params.every((expr)=>this.isAssignable(expr, true));
            return super.shouldParseArrow(params);
        }
        shouldParseAsyncArrow() {
            return this.match(14) || super.shouldParseAsyncArrow();
        }
        canHaveLeadingDecorator() {
            return super.canHaveLeadingDecorator() || this.isAbstractClass();
        }
        jsxParseOpeningElementAfterName(node) {
            if (this.match(47) || this.match(51)) {
                const typeArguments = this.tsTryParseAndCatch(()=>this.tsParseTypeArgumentsInExpression());
                if (typeArguments) node.typeParameters = typeArguments;
            }
            return super.jsxParseOpeningElementAfterName(node);
        }
        getGetterSetterExpectedParamCount(method) {
            const baseCount = super.getGetterSetterExpectedParamCount(method);
            const params = this.getObjectOrClassMethodParams(method);
            const firstParam = params[0];
            const hasContextParam = firstParam && this.isThisParam(firstParam);
            return hasContextParam ? baseCount + 1 : baseCount;
        }
        parseCatchClauseParam() {
            const param = super.parseCatchClauseParam();
            const type = this.tsTryParseTypeAnnotation();
            if (type) {
                param.typeAnnotation = type;
                this.resetEndLocation(param);
            }
            return param;
        }
        tsInAmbientContext(cb) {
            const oldIsAmbientContext = this.state.isAmbientContext;
            this.state.isAmbientContext = true;
            try {
                return cb();
            } finally{
                this.state.isAmbientContext = oldIsAmbientContext;
            }
        }
        parseClass(node, isStatement, optionalId) {
            const oldInAbstractClass = this.state.inAbstractClass;
            this.state.inAbstractClass = !!node.abstract;
            try {
                return super.parseClass(node, isStatement, optionalId);
            } finally{
                this.state.inAbstractClass = oldInAbstractClass;
            }
        }
        tsParseAbstractDeclaration(node, decorators) {
            if (this.match(80)) {
                node.abstract = true;
                return this.maybeTakeDecorators(decorators, this.parseClass(node, true, false));
            } else if (this.isContextual(129)) {
                if (!this.hasFollowingLineBreak()) {
                    node.abstract = true;
                    this.raise($b48499974d50e8d0$var$TSErrors.NonClassMethodPropertyHasAbstractModifer, node);
                    return this.tsParseInterfaceDeclaration(node);
                }
            } else this.unexpected(null, 80);
        }
        parseMethod(node, isGenerator, isAsync, isConstructor, allowDirectSuper, type, inClassScope) {
            const method = super.parseMethod(node, isGenerator, isAsync, isConstructor, allowDirectSuper, type, inClassScope);
            if (method.abstract) {
                const hasBody = this.hasPlugin("estree") ? !!method.value.body : !!method.body;
                if (hasBody) {
                    const { key: key } = method;
                    this.raise($b48499974d50e8d0$var$TSErrors.AbstractMethodHasImplementation, method, {
                        methodName: key.type === "Identifier" && !method.computed ? key.name : `[${this.input.slice(key.start, key.end)}]`
                    });
                }
            }
            return method;
        }
        tsParseTypeParameterName() {
            const typeName = this.parseIdentifier();
            return typeName.name;
        }
        shouldParseAsAmbientContext() {
            return !!this.getPluginOption("typescript", "dts");
        }
        parse() {
            if (this.shouldParseAsAmbientContext()) this.state.isAmbientContext = true;
            return super.parse();
        }
        getExpression() {
            if (this.shouldParseAsAmbientContext()) this.state.isAmbientContext = true;
            return super.getExpression();
        }
        parseExportSpecifier(node, isString, isInTypeExport, isMaybeTypeOnly) {
            if (!isString && isMaybeTypeOnly) {
                this.parseTypeOnlyImportExportSpecifier(node, false, isInTypeExport);
                return this.finishNode(node, "ExportSpecifier");
            }
            node.exportKind = "value";
            return super.parseExportSpecifier(node, isString, isInTypeExport, isMaybeTypeOnly);
        }
        parseImportSpecifier(specifier, importedIsString, isInTypeOnlyImport, isMaybeTypeOnly, bindingType) {
            if (!importedIsString && isMaybeTypeOnly) {
                this.parseTypeOnlyImportExportSpecifier(specifier, true, isInTypeOnlyImport);
                return this.finishNode(specifier, "ImportSpecifier");
            }
            specifier.importKind = "value";
            return super.parseImportSpecifier(specifier, importedIsString, isInTypeOnlyImport, isMaybeTypeOnly, isInTypeOnlyImport ? 4098 : 4096);
        }
        parseTypeOnlyImportExportSpecifier(node, isImport, isInTypeOnlyImportExport) {
            const leftOfAsKey = isImport ? "imported" : "local";
            const rightOfAsKey = isImport ? "local" : "exported";
            let leftOfAs = node[leftOfAsKey];
            let rightOfAs;
            let hasTypeSpecifier = false;
            let canParseAsKeyword = true;
            const loc = leftOfAs.loc.start;
            if (this.isContextual(93)) {
                const firstAs = this.parseIdentifier();
                if (this.isContextual(93)) {
                    const secondAs = this.parseIdentifier();
                    if ($b48499974d50e8d0$var$tokenIsKeywordOrIdentifier(this.state.type)) {
                        hasTypeSpecifier = true;
                        leftOfAs = firstAs;
                        rightOfAs = isImport ? this.parseIdentifier() : this.parseModuleExportName();
                        canParseAsKeyword = false;
                    } else {
                        rightOfAs = secondAs;
                        canParseAsKeyword = false;
                    }
                } else if ($b48499974d50e8d0$var$tokenIsKeywordOrIdentifier(this.state.type)) {
                    canParseAsKeyword = false;
                    rightOfAs = isImport ? this.parseIdentifier() : this.parseModuleExportName();
                } else {
                    hasTypeSpecifier = true;
                    leftOfAs = firstAs;
                }
            } else if ($b48499974d50e8d0$var$tokenIsKeywordOrIdentifier(this.state.type)) {
                hasTypeSpecifier = true;
                if (isImport) {
                    leftOfAs = this.parseIdentifier(true);
                    if (!this.isContextual(93)) this.checkReservedWord(leftOfAs.name, leftOfAs.loc.start, true, true);
                } else leftOfAs = this.parseModuleExportName();
            }
            if (hasTypeSpecifier && isInTypeOnlyImportExport) this.raise(isImport ? $b48499974d50e8d0$var$TSErrors.TypeModifierIsUsedInTypeImports : $b48499974d50e8d0$var$TSErrors.TypeModifierIsUsedInTypeExports, loc);
            node[leftOfAsKey] = leftOfAs;
            node[rightOfAsKey] = rightOfAs;
            const kindKey = isImport ? "importKind" : "exportKind";
            node[kindKey] = hasTypeSpecifier ? "type" : "value";
            if (canParseAsKeyword && this.eatContextual(93)) node[rightOfAsKey] = isImport ? this.parseIdentifier() : this.parseModuleExportName();
            if (!node[rightOfAsKey]) node[rightOfAsKey] = $b48499974d50e8d0$var$cloneIdentifier(node[leftOfAsKey]);
            if (isImport) this.checkIdentifier(node[rightOfAsKey], hasTypeSpecifier ? 4098 : 4096);
        }
    };
function $b48499974d50e8d0$var$isPossiblyLiteralEnum(expression) {
    if (expression.type !== "MemberExpression") return false;
    const { computed: computed, property: property } = expression;
    if (computed && property.type !== "StringLiteral" && (property.type !== "TemplateLiteral" || property.expressions.length > 0)) return false;
    return $b48499974d50e8d0$var$isUncomputedMemberExpressionChain(expression.object);
}
function $b48499974d50e8d0$var$isValidAmbientConstInitializer(expression, estree) {
    var _expression$extra;
    const { type: type } = expression;
    if ((_expression$extra = expression.extra) != null && _expression$extra.parenthesized) return false;
    if (estree) {
        if (type === "Literal") {
            const { value: value } = expression;
            if (typeof value === "string" || typeof value === "boolean") return true;
        }
    } else {
        if (type === "StringLiteral" || type === "BooleanLiteral") return true;
    }
    if ($b48499974d50e8d0$var$isNumber(expression, estree) || $b48499974d50e8d0$var$isNegativeNumber(expression, estree)) return true;
    if (type === "TemplateLiteral" && expression.expressions.length === 0) return true;
    if ($b48499974d50e8d0$var$isPossiblyLiteralEnum(expression)) return true;
    return false;
}
function $b48499974d50e8d0$var$isNumber(expression, estree) {
    if (estree) return expression.type === "Literal" && (typeof expression.value === "number" || "bigint" in expression);
    return expression.type === "NumericLiteral" || expression.type === "BigIntLiteral";
}
function $b48499974d50e8d0$var$isNegativeNumber(expression, estree) {
    if (expression.type === "UnaryExpression") {
        const { operator: operator, argument: argument } = expression;
        if (operator === "-" && $b48499974d50e8d0$var$isNumber(argument, estree)) return true;
    }
    return false;
}
function $b48499974d50e8d0$var$isUncomputedMemberExpressionChain(expression) {
    if (expression.type === "Identifier") return true;
    if (expression.type !== "MemberExpression" || expression.computed) return false;
    return $b48499974d50e8d0$var$isUncomputedMemberExpressionChain(expression.object);
}
const $b48499974d50e8d0$var$PlaceholderErrors = $b48499974d50e8d0$var$ParseErrorEnum`placeholders`({
    ClassNameIsRequired: "A class name is required.",
    UnexpectedSpace: "Unexpected space in placeholder."
});
var $b48499974d50e8d0$var$placeholders = (superClass)=>class PlaceholdersParserMixin extends superClass {
        parsePlaceholder(expectedNode) {
            if (this.match(144)) {
                const node = this.startNode();
                this.next();
                this.assertNoSpace();
                node.name = super.parseIdentifier(true);
                this.assertNoSpace();
                this.expect(144);
                return this.finishPlaceholder(node, expectedNode);
            }
        }
        finishPlaceholder(node, expectedNode) {
            const isFinished = !!(node.expectedNode && node.type === "Placeholder");
            node.expectedNode = expectedNode;
            return isFinished ? node : this.finishNode(node, "Placeholder");
        }
        getTokenFromCode(code) {
            if (code === 37 && this.input.charCodeAt(this.state.pos + 1) === 37) this.finishOp(144, 2);
            else super.getTokenFromCode(code);
        }
        parseExprAtom(refExpressionErrors) {
            return this.parsePlaceholder("Expression") || super.parseExprAtom(refExpressionErrors);
        }
        parseIdentifier(liberal) {
            return this.parsePlaceholder("Identifier") || super.parseIdentifier(liberal);
        }
        checkReservedWord(word, startLoc, checkKeywords, isBinding) {
            if (word !== undefined) super.checkReservedWord(word, startLoc, checkKeywords, isBinding);
        }
        parseBindingAtom() {
            return this.parsePlaceholder("Pattern") || super.parseBindingAtom();
        }
        isValidLVal(type, isParenthesized, binding) {
            return type === "Placeholder" || super.isValidLVal(type, isParenthesized, binding);
        }
        toAssignable(node, isLHS) {
            if (node && node.type === "Placeholder" && node.expectedNode === "Expression") node.expectedNode = "Pattern";
            else super.toAssignable(node, isLHS);
        }
        chStartsBindingIdentifier(ch, pos) {
            if (super.chStartsBindingIdentifier(ch, pos)) return true;
            const nextToken = this.lookahead();
            if (nextToken.type === 144) return true;
            return false;
        }
        verifyBreakContinue(node, isBreak) {
            if (node.label && node.label.type === "Placeholder") return;
            super.verifyBreakContinue(node, isBreak);
        }
        parseExpressionStatement(node, expr) {
            var _expr$extra;
            if (expr.type !== "Placeholder" || (_expr$extra = expr.extra) != null && _expr$extra.parenthesized) return super.parseExpressionStatement(node, expr);
            if (this.match(14)) {
                const stmt = node;
                stmt.label = this.finishPlaceholder(expr, "Identifier");
                this.next();
                stmt.body = super.parseStatementOrSloppyAnnexBFunctionDeclaration();
                return this.finishNode(stmt, "LabeledStatement");
            }
            this.semicolon();
            node.name = expr.name;
            return this.finishPlaceholder(node, "Statement");
        }
        parseBlock(allowDirectives, createNewLexicalScope, afterBlockParse) {
            return this.parsePlaceholder("BlockStatement") || super.parseBlock(allowDirectives, createNewLexicalScope, afterBlockParse);
        }
        parseFunctionId(requireId) {
            return this.parsePlaceholder("Identifier") || super.parseFunctionId(requireId);
        }
        parseClass(node, isStatement, optionalId) {
            const type = isStatement ? "ClassDeclaration" : "ClassExpression";
            this.next();
            const oldStrict = this.state.strict;
            const placeholder = this.parsePlaceholder("Identifier");
            if (placeholder) {
                if (this.match(81) || this.match(144) || this.match(5)) node.id = placeholder;
                else if (optionalId || !isStatement) {
                    node.id = null;
                    node.body = this.finishPlaceholder(placeholder, "ClassBody");
                    return this.finishNode(node, type);
                } else throw this.raise($b48499974d50e8d0$var$PlaceholderErrors.ClassNameIsRequired, this.state.startLoc);
            } else this.parseClassId(node, isStatement, optionalId);
            super.parseClassSuper(node);
            node.body = this.parsePlaceholder("ClassBody") || super.parseClassBody(!!node.superClass, oldStrict);
            return this.finishNode(node, type);
        }
        parseExport(node, decorators) {
            const placeholder = this.parsePlaceholder("Identifier");
            if (!placeholder) return super.parseExport(node, decorators);
            if (!this.isContextual(98) && !this.match(12)) {
                node.specifiers = [];
                node.source = null;
                node.declaration = this.finishPlaceholder(placeholder, "Declaration");
                return this.finishNode(node, "ExportNamedDeclaration");
            }
            this.expectPlugin("exportDefaultFrom");
            const specifier = this.startNode();
            specifier.exported = placeholder;
            node.specifiers = [
                this.finishNode(specifier, "ExportDefaultSpecifier")
            ];
            return super.parseExport(node, decorators);
        }
        isExportDefaultSpecifier() {
            if (this.match(65)) {
                const next = this.nextTokenStart();
                if (this.isUnparsedContextual(next, "from")) {
                    if (this.input.startsWith($b48499974d50e8d0$var$tokenLabelName(144), this.nextTokenStartSince(next + 4))) return true;
                }
            }
            return super.isExportDefaultSpecifier();
        }
        maybeParseExportDefaultSpecifier(node, maybeDefaultIdentifier) {
            var _specifiers;
            if ((_specifiers = node.specifiers) != null && _specifiers.length) return true;
            return super.maybeParseExportDefaultSpecifier(node, maybeDefaultIdentifier);
        }
        checkExport(node) {
            const { specifiers: specifiers } = node;
            if (specifiers != null && specifiers.length) node.specifiers = specifiers.filter((node)=>node.exported.type === "Placeholder");
            super.checkExport(node);
            node.specifiers = specifiers;
        }
        parseImport(node) {
            const placeholder = this.parsePlaceholder("Identifier");
            if (!placeholder) return super.parseImport(node);
            node.specifiers = [];
            if (!this.isContextual(98) && !this.match(12)) {
                node.source = this.finishPlaceholder(placeholder, "StringLiteral");
                this.semicolon();
                return this.finishNode(node, "ImportDeclaration");
            }
            const specifier = this.startNodeAtNode(placeholder);
            specifier.local = placeholder;
            node.specifiers.push(this.finishNode(specifier, "ImportDefaultSpecifier"));
            if (this.eat(12)) {
                const hasStarImport = this.maybeParseStarImportSpecifier(node);
                if (!hasStarImport) this.parseNamedImportSpecifiers(node);
            }
            this.expectContextual(98);
            node.source = this.parseImportSource();
            this.semicolon();
            return this.finishNode(node, "ImportDeclaration");
        }
        parseImportSource() {
            return this.parsePlaceholder("StringLiteral") || super.parseImportSource();
        }
        assertNoSpace() {
            if (this.state.start > this.state.lastTokEndLoc.index) this.raise($b48499974d50e8d0$var$PlaceholderErrors.UnexpectedSpace, this.state.lastTokEndLoc);
        }
    };
var $b48499974d50e8d0$var$v8intrinsic = (superClass)=>class V8IntrinsicMixin extends superClass {
        parseV8Intrinsic() {
            if (this.match(54)) {
                const v8IntrinsicStartLoc = this.state.startLoc;
                const node = this.startNode();
                this.next();
                if ($b48499974d50e8d0$var$tokenIsIdentifier(this.state.type)) {
                    const name = this.parseIdentifierName();
                    const identifier = this.createIdentifier(node, name);
                    identifier.type = "V8IntrinsicIdentifier";
                    if (this.match(10)) return identifier;
                }
                this.unexpected(v8IntrinsicStartLoc);
            }
        }
        parseExprAtom(refExpressionErrors) {
            return this.parseV8Intrinsic() || super.parseExprAtom(refExpressionErrors);
        }
    };
function $b48499974d50e8d0$var$hasPlugin(plugins, expectedConfig) {
    const [expectedName, expectedOptions] = typeof expectedConfig === "string" ? [
        expectedConfig,
        {}
    ] : expectedConfig;
    const expectedKeys = Object.keys(expectedOptions);
    const expectedOptionsIsEmpty = expectedKeys.length === 0;
    return plugins.some((p)=>{
        if (typeof p === "string") return expectedOptionsIsEmpty && p === expectedName;
        else {
            const [pluginName, pluginOptions] = p;
            if (pluginName !== expectedName) return false;
            for (const key of expectedKeys){
                if (pluginOptions[key] !== expectedOptions[key]) return false;
            }
            return true;
        }
    });
}
function $b48499974d50e8d0$var$getPluginOption(plugins, name, option) {
    const plugin = plugins.find((plugin)=>{
        if (Array.isArray(plugin)) return plugin[0] === name;
        else return plugin === name;
    });
    if (plugin && Array.isArray(plugin) && plugin.length > 1) return plugin[1][option];
    return null;
}
const $b48499974d50e8d0$var$PIPELINE_PROPOSALS = [
    "minimal",
    "fsharp",
    "hack",
    "smart"
];
const $b48499974d50e8d0$var$TOPIC_TOKENS = [
    "^^",
    "@@",
    "^",
    "%",
    "#"
];
const $b48499974d50e8d0$var$RECORD_AND_TUPLE_SYNTAX_TYPES = [
    "hash",
    "bar"
];
function $b48499974d50e8d0$var$validatePlugins(plugins) {
    if ($b48499974d50e8d0$var$hasPlugin(plugins, "decorators")) {
        if ($b48499974d50e8d0$var$hasPlugin(plugins, "decorators-legacy")) throw new Error("Cannot use the decorators and decorators-legacy plugin together");
        const decoratorsBeforeExport = $b48499974d50e8d0$var$getPluginOption(plugins, "decorators", "decoratorsBeforeExport");
        if (decoratorsBeforeExport != null && typeof decoratorsBeforeExport !== "boolean") throw new Error("'decoratorsBeforeExport' must be a boolean, if specified.");
        const allowCallParenthesized = $b48499974d50e8d0$var$getPluginOption(plugins, "decorators", "allowCallParenthesized");
        if (allowCallParenthesized != null && typeof allowCallParenthesized !== "boolean") throw new Error("'allowCallParenthesized' must be a boolean.");
    }
    if ($b48499974d50e8d0$var$hasPlugin(plugins, "flow") && $b48499974d50e8d0$var$hasPlugin(plugins, "typescript")) throw new Error("Cannot combine flow and typescript plugins.");
    if ($b48499974d50e8d0$var$hasPlugin(plugins, "placeholders") && $b48499974d50e8d0$var$hasPlugin(plugins, "v8intrinsic")) throw new Error("Cannot combine placeholders and v8intrinsic plugins.");
    if ($b48499974d50e8d0$var$hasPlugin(plugins, "pipelineOperator")) {
        const proposal = $b48499974d50e8d0$var$getPluginOption(plugins, "pipelineOperator", "proposal");
        if (!$b48499974d50e8d0$var$PIPELINE_PROPOSALS.includes(proposal)) {
            const proposalList = $b48499974d50e8d0$var$PIPELINE_PROPOSALS.map((p)=>`"${p}"`).join(", ");
            throw new Error(`"pipelineOperator" requires "proposal" option whose value must be one of: ${proposalList}.`);
        }
        const tupleSyntaxIsHash = $b48499974d50e8d0$var$hasPlugin(plugins, [
            "recordAndTuple",
            {
                syntaxType: "hash"
            }
        ]);
        if (proposal === "hack") {
            if ($b48499974d50e8d0$var$hasPlugin(plugins, "placeholders")) throw new Error("Cannot combine placeholders plugin and Hack-style pipes.");
            if ($b48499974d50e8d0$var$hasPlugin(plugins, "v8intrinsic")) throw new Error("Cannot combine v8intrinsic plugin and Hack-style pipes.");
            const topicToken = $b48499974d50e8d0$var$getPluginOption(plugins, "pipelineOperator", "topicToken");
            if (!$b48499974d50e8d0$var$TOPIC_TOKENS.includes(topicToken)) {
                const tokenList = $b48499974d50e8d0$var$TOPIC_TOKENS.map((t)=>`"${t}"`).join(", ");
                throw new Error(`"pipelineOperator" in "proposal": "hack" mode also requires a "topicToken" option whose value must be one of: ${tokenList}.`);
            }
            if (topicToken === "#" && tupleSyntaxIsHash) throw new Error('Plugin conflict between `["pipelineOperator", { proposal: "hack", topicToken: "#" }]` and `["recordAndtuple", { syntaxType: "hash"}]`.');
        } else if (proposal === "smart" && tupleSyntaxIsHash) throw new Error('Plugin conflict between `["pipelineOperator", { proposal: "smart" }]` and `["recordAndtuple", { syntaxType: "hash"}]`.');
    }
    if ($b48499974d50e8d0$var$hasPlugin(plugins, "moduleAttributes")) {
        if ($b48499974d50e8d0$var$hasPlugin(plugins, "importAssertions") || $b48499974d50e8d0$var$hasPlugin(plugins, "importAttributes")) throw new Error("Cannot combine importAssertions, importAttributes and moduleAttributes plugins.");
        const moduleAttributesVersionPluginOption = $b48499974d50e8d0$var$getPluginOption(plugins, "moduleAttributes", "version");
        if (moduleAttributesVersionPluginOption !== "may-2020") throw new Error("The 'moduleAttributes' plugin requires a 'version' option, representing the last proposal update. Currently, the only supported value is 'may-2020'.");
    }
    if ($b48499974d50e8d0$var$hasPlugin(plugins, "importAssertions") && $b48499974d50e8d0$var$hasPlugin(plugins, "importAttributes")) throw new Error("Cannot combine importAssertions and importAttributes plugins.");
    if ($b48499974d50e8d0$var$hasPlugin(plugins, "recordAndTuple") && $b48499974d50e8d0$var$getPluginOption(plugins, "recordAndTuple", "syntaxType") != null && !$b48499974d50e8d0$var$RECORD_AND_TUPLE_SYNTAX_TYPES.includes($b48499974d50e8d0$var$getPluginOption(plugins, "recordAndTuple", "syntaxType"))) throw new Error("The 'syntaxType' option of the 'recordAndTuple' plugin must be one of: " + $b48499974d50e8d0$var$RECORD_AND_TUPLE_SYNTAX_TYPES.map((p)=>`'${p}'`).join(", "));
    if ($b48499974d50e8d0$var$hasPlugin(plugins, "asyncDoExpressions") && !$b48499974d50e8d0$var$hasPlugin(plugins, "doExpressions")) {
        const error = new Error("'asyncDoExpressions' requires 'doExpressions', please add 'doExpressions' to parser plugins.");
        error.missingPlugins = "doExpressions";
        throw error;
    }
    if ($b48499974d50e8d0$var$hasPlugin(plugins, "optionalChainingAssign") && $b48499974d50e8d0$var$getPluginOption(plugins, "optionalChainingAssign", "version") !== "2023-07") throw new Error("The 'optionalChainingAssign' plugin requires a 'version' option, representing the last proposal update. Currently, the only supported value is '2023-07'.");
}
const $b48499974d50e8d0$var$mixinPlugins = {
    estree: $b48499974d50e8d0$var$estree,
    jsx: $b48499974d50e8d0$var$jsx,
    flow: $b48499974d50e8d0$var$flow,
    typescript: $b48499974d50e8d0$var$typescript,
    v8intrinsic: $b48499974d50e8d0$var$v8intrinsic,
    placeholders: $b48499974d50e8d0$var$placeholders
};
const $b48499974d50e8d0$var$mixinPluginNames = Object.keys($b48499974d50e8d0$var$mixinPlugins);
const $b48499974d50e8d0$var$defaultOptions = {
    sourceType: "script",
    sourceFilename: undefined,
    startColumn: 0,
    startLine: 1,
    allowAwaitOutsideFunction: false,
    allowReturnOutsideFunction: false,
    allowNewTargetOutsideFunction: false,
    allowImportExportEverywhere: false,
    allowSuperOutsideMethod: false,
    allowUndeclaredExports: false,
    plugins: [],
    strictMode: null,
    ranges: false,
    tokens: false,
    createImportExpressions: false,
    createParenthesizedExpressions: false,
    errorRecovery: false,
    attachComment: true,
    annexB: true
};
function $b48499974d50e8d0$var$getOptions(opts) {
    if (opts == null) return Object.assign({}, $b48499974d50e8d0$var$defaultOptions);
    if (opts.annexB != null && opts.annexB !== false) throw new Error("The `annexB` option can only be set to `false`.");
    const options = {};
    for (const key of Object.keys($b48499974d50e8d0$var$defaultOptions)){
        var _opts$key;
        options[key] = (_opts$key = opts[key]) != null ? _opts$key : $b48499974d50e8d0$var$defaultOptions[key];
    }
    return options;
}
class $b48499974d50e8d0$var$ExpressionParser extends $b48499974d50e8d0$var$LValParser {
    checkProto(prop, isRecord, protoRef, refExpressionErrors) {
        if (prop.type === "SpreadElement" || this.isObjectMethod(prop) || prop.computed || prop.shorthand) return;
        const key = prop.key;
        const name = key.type === "Identifier" ? key.name : key.value;
        if (name === "__proto__") {
            if (isRecord) {
                this.raise($b48499974d50e8d0$var$Errors.RecordNoProto, key);
                return;
            }
            if (protoRef.used) {
                if (refExpressionErrors) {
                    if (refExpressionErrors.doubleProtoLoc === null) refExpressionErrors.doubleProtoLoc = key.loc.start;
                } else this.raise($b48499974d50e8d0$var$Errors.DuplicateProto, key);
            }
            protoRef.used = true;
        }
    }
    shouldExitDescending(expr, potentialArrowAt) {
        return expr.type === "ArrowFunctionExpression" && expr.start === potentialArrowAt;
    }
    getExpression() {
        this.enterInitialScopes();
        this.nextToken();
        const expr = this.parseExpression();
        if (!this.match(139)) this.unexpected();
        this.finalizeRemainingComments();
        expr.comments = this.comments;
        expr.errors = this.state.errors;
        if (this.options.tokens) expr.tokens = this.tokens;
        return expr;
    }
    parseExpression(disallowIn, refExpressionErrors) {
        if (disallowIn) return this.disallowInAnd(()=>this.parseExpressionBase(refExpressionErrors));
        return this.allowInAnd(()=>this.parseExpressionBase(refExpressionErrors));
    }
    parseExpressionBase(refExpressionErrors) {
        const startLoc = this.state.startLoc;
        const expr = this.parseMaybeAssign(refExpressionErrors);
        if (this.match(12)) {
            const node = this.startNodeAt(startLoc);
            node.expressions = [
                expr
            ];
            while(this.eat(12))node.expressions.push(this.parseMaybeAssign(refExpressionErrors));
            this.toReferencedList(node.expressions);
            return this.finishNode(node, "SequenceExpression");
        }
        return expr;
    }
    parseMaybeAssignDisallowIn(refExpressionErrors, afterLeftParse) {
        return this.disallowInAnd(()=>this.parseMaybeAssign(refExpressionErrors, afterLeftParse));
    }
    parseMaybeAssignAllowIn(refExpressionErrors, afterLeftParse) {
        return this.allowInAnd(()=>this.parseMaybeAssign(refExpressionErrors, afterLeftParse));
    }
    setOptionalParametersError(refExpressionErrors, resultError) {
        var _resultError$loc;
        refExpressionErrors.optionalParametersLoc = (_resultError$loc = resultError == null ? void 0 : resultError.loc) != null ? _resultError$loc : this.state.startLoc;
    }
    parseMaybeAssign(refExpressionErrors, afterLeftParse) {
        const startLoc = this.state.startLoc;
        if (this.isContextual(108)) {
            if (this.prodParam.hasYield) {
                let left = this.parseYield();
                if (afterLeftParse) left = afterLeftParse.call(this, left, startLoc);
                return left;
            }
        }
        let ownExpressionErrors;
        if (refExpressionErrors) ownExpressionErrors = false;
        else {
            refExpressionErrors = new $b48499974d50e8d0$var$ExpressionErrors();
            ownExpressionErrors = true;
        }
        const { type: type } = this.state;
        if (type === 10 || $b48499974d50e8d0$var$tokenIsIdentifier(type)) this.state.potentialArrowAt = this.state.start;
        let left = this.parseMaybeConditional(refExpressionErrors);
        if (afterLeftParse) left = afterLeftParse.call(this, left, startLoc);
        if ($b48499974d50e8d0$var$tokenIsAssignment(this.state.type)) {
            const node = this.startNodeAt(startLoc);
            const operator = this.state.value;
            node.operator = operator;
            if (this.match(29)) {
                this.toAssignable(left, true);
                node.left = left;
                const startIndex = startLoc.index;
                if (refExpressionErrors.doubleProtoLoc != null && refExpressionErrors.doubleProtoLoc.index >= startIndex) refExpressionErrors.doubleProtoLoc = null;
                if (refExpressionErrors.shorthandAssignLoc != null && refExpressionErrors.shorthandAssignLoc.index >= startIndex) refExpressionErrors.shorthandAssignLoc = null;
                if (refExpressionErrors.privateKeyLoc != null && refExpressionErrors.privateKeyLoc.index >= startIndex) {
                    this.checkDestructuringPrivate(refExpressionErrors);
                    refExpressionErrors.privateKeyLoc = null;
                }
            } else node.left = left;
            this.next();
            node.right = this.parseMaybeAssign();
            this.checkLVal(left, {
                in: this.finishNode(node, "AssignmentExpression")
            });
            return node;
        } else if (ownExpressionErrors) this.checkExpressionErrors(refExpressionErrors, true);
        return left;
    }
    parseMaybeConditional(refExpressionErrors) {
        const startLoc = this.state.startLoc;
        const potentialArrowAt = this.state.potentialArrowAt;
        const expr = this.parseExprOps(refExpressionErrors);
        if (this.shouldExitDescending(expr, potentialArrowAt)) return expr;
        return this.parseConditional(expr, startLoc, refExpressionErrors);
    }
    parseConditional(expr, startLoc, refExpressionErrors) {
        if (this.eat(17)) {
            const node = this.startNodeAt(startLoc);
            node.test = expr;
            node.consequent = this.parseMaybeAssignAllowIn();
            this.expect(14);
            node.alternate = this.parseMaybeAssign();
            return this.finishNode(node, "ConditionalExpression");
        }
        return expr;
    }
    parseMaybeUnaryOrPrivate(refExpressionErrors) {
        return this.match(138) ? this.parsePrivateName() : this.parseMaybeUnary(refExpressionErrors);
    }
    parseExprOps(refExpressionErrors) {
        const startLoc = this.state.startLoc;
        const potentialArrowAt = this.state.potentialArrowAt;
        const expr = this.parseMaybeUnaryOrPrivate(refExpressionErrors);
        if (this.shouldExitDescending(expr, potentialArrowAt)) return expr;
        return this.parseExprOp(expr, startLoc, -1);
    }
    parseExprOp(left, leftStartLoc, minPrec) {
        if (this.isPrivateName(left)) {
            const value = this.getPrivateNameSV(left);
            if (minPrec >= $b48499974d50e8d0$var$tokenOperatorPrecedence(58) || !this.prodParam.hasIn || !this.match(58)) this.raise($b48499974d50e8d0$var$Errors.PrivateInExpectedIn, left, {
                identifierName: value
            });
            this.classScope.usePrivateName(value, left.loc.start);
        }
        const op = this.state.type;
        if ($b48499974d50e8d0$var$tokenIsOperator(op) && (this.prodParam.hasIn || !this.match(58))) {
            let prec = $b48499974d50e8d0$var$tokenOperatorPrecedence(op);
            if (prec > minPrec) {
                if (op === 39) {
                    this.expectPlugin("pipelineOperator");
                    if (this.state.inFSharpPipelineDirectBody) return left;
                    this.checkPipelineAtInfixOperator(left, leftStartLoc);
                }
                const node = this.startNodeAt(leftStartLoc);
                node.left = left;
                node.operator = this.state.value;
                const logical = op === 41 || op === 42;
                const coalesce = op === 40;
                if (coalesce) prec = $b48499974d50e8d0$var$tokenOperatorPrecedence(42);
                this.next();
                if (op === 39 && this.hasPlugin([
                    "pipelineOperator",
                    {
                        proposal: "minimal"
                    }
                ])) {
                    if (this.state.type === 96 && this.prodParam.hasAwait) throw this.raise($b48499974d50e8d0$var$Errors.UnexpectedAwaitAfterPipelineBody, this.state.startLoc);
                }
                node.right = this.parseExprOpRightExpr(op, prec);
                const finishedNode = this.finishNode(node, logical || coalesce ? "LogicalExpression" : "BinaryExpression");
                const nextOp = this.state.type;
                if (coalesce && (nextOp === 41 || nextOp === 42) || logical && nextOp === 40) throw this.raise($b48499974d50e8d0$var$Errors.MixingCoalesceWithLogical, this.state.startLoc);
                return this.parseExprOp(finishedNode, leftStartLoc, minPrec);
            }
        }
        return left;
    }
    parseExprOpRightExpr(op, prec) {
        const startLoc = this.state.startLoc;
        switch(op){
            case 39:
                switch(this.getPluginOption("pipelineOperator", "proposal")){
                    case "hack":
                        return this.withTopicBindingContext(()=>{
                            return this.parseHackPipeBody();
                        });
                    case "smart":
                        return this.withTopicBindingContext(()=>{
                            if (this.prodParam.hasYield && this.isContextual(108)) throw this.raise($b48499974d50e8d0$var$Errors.PipeBodyIsTighter, this.state.startLoc);
                            return this.parseSmartPipelineBodyInStyle(this.parseExprOpBaseRightExpr(op, prec), startLoc);
                        });
                    case "fsharp":
                        return this.withSoloAwaitPermittingContext(()=>{
                            return this.parseFSharpPipelineBody(prec);
                        });
                }
            default:
                return this.parseExprOpBaseRightExpr(op, prec);
        }
    }
    parseExprOpBaseRightExpr(op, prec) {
        const startLoc = this.state.startLoc;
        return this.parseExprOp(this.parseMaybeUnaryOrPrivate(), startLoc, $b48499974d50e8d0$var$tokenIsRightAssociative(op) ? prec - 1 : prec);
    }
    parseHackPipeBody() {
        var _body$extra;
        const { startLoc: startLoc } = this.state;
        const body = this.parseMaybeAssign();
        const requiredParentheses = $b48499974d50e8d0$var$UnparenthesizedPipeBodyDescriptions.has(body.type);
        if (requiredParentheses && !((_body$extra = body.extra) != null && _body$extra.parenthesized)) this.raise($b48499974d50e8d0$var$Errors.PipeUnparenthesizedBody, startLoc, {
            type: body.type
        });
        if (!this.topicReferenceWasUsedInCurrentContext()) this.raise($b48499974d50e8d0$var$Errors.PipeTopicUnused, startLoc);
        return body;
    }
    checkExponentialAfterUnary(node) {
        if (this.match(57)) this.raise($b48499974d50e8d0$var$Errors.UnexpectedTokenUnaryExponentiation, node.argument);
    }
    parseMaybeUnary(refExpressionErrors, sawUnary) {
        const startLoc = this.state.startLoc;
        const isAwait = this.isContextual(96);
        if (isAwait && this.isAwaitAllowed()) {
            this.next();
            const expr = this.parseAwait(startLoc);
            if (!sawUnary) this.checkExponentialAfterUnary(expr);
            return expr;
        }
        const update = this.match(34);
        const node = this.startNode();
        if ($b48499974d50e8d0$var$tokenIsPrefix(this.state.type)) {
            node.operator = this.state.value;
            node.prefix = true;
            if (this.match(72)) this.expectPlugin("throwExpressions");
            const isDelete = this.match(89);
            this.next();
            node.argument = this.parseMaybeUnary(null, true);
            this.checkExpressionErrors(refExpressionErrors, true);
            if (this.state.strict && isDelete) {
                const arg = node.argument;
                if (arg.type === "Identifier") this.raise($b48499974d50e8d0$var$Errors.StrictDelete, node);
                else if (this.hasPropertyAsPrivateName(arg)) this.raise($b48499974d50e8d0$var$Errors.DeletePrivateField, node);
            }
            if (!update) {
                if (!sawUnary) this.checkExponentialAfterUnary(node);
                return this.finishNode(node, "UnaryExpression");
            }
        }
        const expr = this.parseUpdate(node, update, refExpressionErrors);
        if (isAwait) {
            const { type: type } = this.state;
            const startsExpr = this.hasPlugin("v8intrinsic") ? $b48499974d50e8d0$var$tokenCanStartExpression(type) : $b48499974d50e8d0$var$tokenCanStartExpression(type) && !this.match(54);
            if (startsExpr && !this.isAmbiguousAwait()) {
                this.raiseOverwrite($b48499974d50e8d0$var$Errors.AwaitNotInAsyncContext, startLoc);
                return this.parseAwait(startLoc);
            }
        }
        return expr;
    }
    parseUpdate(node, update, refExpressionErrors) {
        if (update) {
            const updateExpressionNode = node;
            this.checkLVal(updateExpressionNode.argument, {
                in: this.finishNode(updateExpressionNode, "UpdateExpression")
            });
            return node;
        }
        const startLoc = this.state.startLoc;
        let expr = this.parseExprSubscripts(refExpressionErrors);
        if (this.checkExpressionErrors(refExpressionErrors, false)) return expr;
        while($b48499974d50e8d0$var$tokenIsPostfix(this.state.type) && !this.canInsertSemicolon()){
            const node = this.startNodeAt(startLoc);
            node.operator = this.state.value;
            node.prefix = false;
            node.argument = expr;
            this.next();
            this.checkLVal(expr, {
                in: expr = this.finishNode(node, "UpdateExpression")
            });
        }
        return expr;
    }
    parseExprSubscripts(refExpressionErrors) {
        const startLoc = this.state.startLoc;
        const potentialArrowAt = this.state.potentialArrowAt;
        const expr = this.parseExprAtom(refExpressionErrors);
        if (this.shouldExitDescending(expr, potentialArrowAt)) return expr;
        return this.parseSubscripts(expr, startLoc);
    }
    parseSubscripts(base, startLoc, noCalls) {
        const state = {
            optionalChainMember: false,
            maybeAsyncArrow: this.atPossibleAsyncArrow(base),
            stop: false
        };
        do {
            base = this.parseSubscript(base, startLoc, noCalls, state);
            state.maybeAsyncArrow = false;
        }while (!state.stop);
        return base;
    }
    parseSubscript(base, startLoc, noCalls, state) {
        const { type: type } = this.state;
        if (!noCalls && type === 15) return this.parseBind(base, startLoc, noCalls, state);
        else if ($b48499974d50e8d0$var$tokenIsTemplate(type)) return this.parseTaggedTemplateExpression(base, startLoc, state);
        let optional = false;
        if (type === 18) {
            if (noCalls) {
                this.raise($b48499974d50e8d0$var$Errors.OptionalChainingNoNew, this.state.startLoc);
                if (this.lookaheadCharCode() === 40) {
                    state.stop = true;
                    return base;
                }
            }
            state.optionalChainMember = optional = true;
            this.next();
        }
        if (!noCalls && this.match(10)) return this.parseCoverCallAndAsyncArrowHead(base, startLoc, state, optional);
        else {
            const computed = this.eat(0);
            if (computed || optional || this.eat(16)) return this.parseMember(base, startLoc, state, computed, optional);
            else {
                state.stop = true;
                return base;
            }
        }
    }
    parseMember(base, startLoc, state, computed, optional) {
        const node = this.startNodeAt(startLoc);
        node.object = base;
        node.computed = computed;
        if (computed) {
            node.property = this.parseExpression();
            this.expect(3);
        } else if (this.match(138)) {
            if (base.type === "Super") this.raise($b48499974d50e8d0$var$Errors.SuperPrivateField, startLoc);
            this.classScope.usePrivateName(this.state.value, this.state.startLoc);
            node.property = this.parsePrivateName();
        } else node.property = this.parseIdentifier(true);
        if (state.optionalChainMember) {
            node.optional = optional;
            return this.finishNode(node, "OptionalMemberExpression");
        } else return this.finishNode(node, "MemberExpression");
    }
    parseBind(base, startLoc, noCalls, state) {
        const node = this.startNodeAt(startLoc);
        node.object = base;
        this.next();
        node.callee = this.parseNoCallExpr();
        state.stop = true;
        return this.parseSubscripts(this.finishNode(node, "BindExpression"), startLoc, noCalls);
    }
    parseCoverCallAndAsyncArrowHead(base, startLoc, state, optional) {
        const oldMaybeInArrowParameters = this.state.maybeInArrowParameters;
        let refExpressionErrors = null;
        this.state.maybeInArrowParameters = true;
        this.next();
        const node = this.startNodeAt(startLoc);
        node.callee = base;
        const { maybeAsyncArrow: maybeAsyncArrow, optionalChainMember: optionalChainMember } = state;
        if (maybeAsyncArrow) {
            this.expressionScope.enter($b48499974d50e8d0$var$newAsyncArrowScope());
            refExpressionErrors = new $b48499974d50e8d0$var$ExpressionErrors();
        }
        if (optionalChainMember) node.optional = optional;
        if (optional) node.arguments = this.parseCallExpressionArguments(11);
        else node.arguments = this.parseCallExpressionArguments(11, base.type === "Import", base.type !== "Super", node, refExpressionErrors);
        let finishedNode = this.finishCallExpression(node, optionalChainMember);
        if (maybeAsyncArrow && this.shouldParseAsyncArrow() && !optional) {
            state.stop = true;
            this.checkDestructuringPrivate(refExpressionErrors);
            this.expressionScope.validateAsPattern();
            this.expressionScope.exit();
            finishedNode = this.parseAsyncArrowFromCallExpression(this.startNodeAt(startLoc), finishedNode);
        } else {
            if (maybeAsyncArrow) {
                this.checkExpressionErrors(refExpressionErrors, true);
                this.expressionScope.exit();
            }
            this.toReferencedArguments(finishedNode);
        }
        this.state.maybeInArrowParameters = oldMaybeInArrowParameters;
        return finishedNode;
    }
    toReferencedArguments(node, isParenthesizedExpr) {
        this.toReferencedListDeep(node.arguments, isParenthesizedExpr);
    }
    parseTaggedTemplateExpression(base, startLoc, state) {
        const node = this.startNodeAt(startLoc);
        node.tag = base;
        node.quasi = this.parseTemplate(true);
        if (state.optionalChainMember) this.raise($b48499974d50e8d0$var$Errors.OptionalChainingNoTemplate, startLoc);
        return this.finishNode(node, "TaggedTemplateExpression");
    }
    atPossibleAsyncArrow(base) {
        return base.type === "Identifier" && base.name === "async" && this.state.lastTokEndLoc.index === base.end && !this.canInsertSemicolon() && base.end - base.start === 5 && base.start === this.state.potentialArrowAt;
    }
    expectImportAttributesPlugin() {
        if (!this.hasPlugin("importAssertions")) this.expectPlugin("importAttributes");
    }
    finishCallExpression(node, optional) {
        if (node.callee.type === "Import") {
            if (node.arguments.length === 2) {
                if (!this.hasPlugin("moduleAttributes")) this.expectImportAttributesPlugin();
            }
            if (node.arguments.length === 0 || node.arguments.length > 2) this.raise($b48499974d50e8d0$var$Errors.ImportCallArity, node, {
                maxArgumentCount: this.hasPlugin("importAttributes") || this.hasPlugin("importAssertions") || this.hasPlugin("moduleAttributes") ? 2 : 1
            });
            else {
                for (const arg of node.arguments)if (arg.type === "SpreadElement") this.raise($b48499974d50e8d0$var$Errors.ImportCallSpreadArgument, arg);
            }
        }
        return this.finishNode(node, optional ? "OptionalCallExpression" : "CallExpression");
    }
    parseCallExpressionArguments(close, dynamicImport, allowPlaceholder, nodeForExtra, refExpressionErrors) {
        const elts = [];
        let first = true;
        const oldInFSharpPipelineDirectBody = this.state.inFSharpPipelineDirectBody;
        this.state.inFSharpPipelineDirectBody = false;
        while(!this.eat(close)){
            if (first) first = false;
            else {
                this.expect(12);
                if (this.match(close)) {
                    if (dynamicImport && !this.hasPlugin("importAttributes") && !this.hasPlugin("importAssertions") && !this.hasPlugin("moduleAttributes")) this.raise($b48499974d50e8d0$var$Errors.ImportCallArgumentTrailingComma, this.state.lastTokStartLoc);
                    if (nodeForExtra) this.addTrailingCommaExtraToNode(nodeForExtra);
                    this.next();
                    break;
                }
            }
            elts.push(this.parseExprListItem(false, refExpressionErrors, allowPlaceholder));
        }
        this.state.inFSharpPipelineDirectBody = oldInFSharpPipelineDirectBody;
        return elts;
    }
    shouldParseAsyncArrow() {
        return this.match(19) && !this.canInsertSemicolon();
    }
    parseAsyncArrowFromCallExpression(node, call) {
        var _call$extra;
        this.resetPreviousNodeTrailingComments(call);
        this.expect(19);
        this.parseArrowExpression(node, call.arguments, true, (_call$extra = call.extra) == null ? void 0 : _call$extra.trailingCommaLoc);
        if (call.innerComments) $b48499974d50e8d0$var$setInnerComments(node, call.innerComments);
        if (call.callee.trailingComments) $b48499974d50e8d0$var$setInnerComments(node, call.callee.trailingComments);
        return node;
    }
    parseNoCallExpr() {
        const startLoc = this.state.startLoc;
        return this.parseSubscripts(this.parseExprAtom(), startLoc, true);
    }
    parseExprAtom(refExpressionErrors) {
        let node;
        let decorators = null;
        const { type: type } = this.state;
        switch(type){
            case 79:
                return this.parseSuper();
            case 83:
                node = this.startNode();
                this.next();
                if (this.match(16)) return this.parseImportMetaProperty(node);
                if (this.match(10)) {
                    if (this.options.createImportExpressions) return this.parseImportCall(node);
                    else return this.finishNode(node, "Import");
                } else {
                    this.raise($b48499974d50e8d0$var$Errors.UnsupportedImport, this.state.lastTokStartLoc);
                    return this.finishNode(node, "Import");
                }
            case 78:
                node = this.startNode();
                this.next();
                return this.finishNode(node, "ThisExpression");
            case 90:
                return this.parseDo(this.startNode(), false);
            case 56:
            case 31:
                this.readRegexp();
                return this.parseRegExpLiteral(this.state.value);
            case 134:
                return this.parseNumericLiteral(this.state.value);
            case 135:
                return this.parseBigIntLiteral(this.state.value);
            case 136:
                return this.parseDecimalLiteral(this.state.value);
            case 133:
                return this.parseStringLiteral(this.state.value);
            case 84:
                return this.parseNullLiteral();
            case 85:
                return this.parseBooleanLiteral(true);
            case 86:
                return this.parseBooleanLiteral(false);
            case 10:
                {
                    const canBeArrow = this.state.potentialArrowAt === this.state.start;
                    return this.parseParenAndDistinguishExpression(canBeArrow);
                }
            case 2:
            case 1:
                return this.parseArrayLike(this.state.type === 2 ? 4 : 3, false, true);
            case 0:
                return this.parseArrayLike(3, true, false, refExpressionErrors);
            case 6:
            case 7:
                return this.parseObjectLike(this.state.type === 6 ? 9 : 8, false, true);
            case 5:
                return this.parseObjectLike(8, false, false, refExpressionErrors);
            case 68:
                return this.parseFunctionOrFunctionSent();
            case 26:
                decorators = this.parseDecorators();
            case 80:
                return this.parseClass(this.maybeTakeDecorators(decorators, this.startNode()), false);
            case 77:
                return this.parseNewOrNewTarget();
            case 25:
            case 24:
                return this.parseTemplate(false);
            case 15:
                {
                    node = this.startNode();
                    this.next();
                    node.object = null;
                    const callee = node.callee = this.parseNoCallExpr();
                    if (callee.type === "MemberExpression") return this.finishNode(node, "BindExpression");
                    else throw this.raise($b48499974d50e8d0$var$Errors.UnsupportedBind, callee);
                }
            case 138:
                this.raise($b48499974d50e8d0$var$Errors.PrivateInExpectedIn, this.state.startLoc, {
                    identifierName: this.state.value
                });
                return this.parsePrivateName();
            case 33:
                return this.parseTopicReferenceThenEqualsSign(54, "%");
            case 32:
                return this.parseTopicReferenceThenEqualsSign(44, "^");
            case 37:
            case 38:
                return this.parseTopicReference("hack");
            case 44:
            case 54:
            case 27:
                {
                    const pipeProposal = this.getPluginOption("pipelineOperator", "proposal");
                    if (pipeProposal) return this.parseTopicReference(pipeProposal);
                    this.unexpected();
                    break;
                }
            case 47:
                {
                    const lookaheadCh = this.input.codePointAt(this.nextTokenStart());
                    if ($b48499974d50e8d0$var$isIdentifierStart(lookaheadCh) || lookaheadCh === 62) this.expectOnePlugin([
                        "jsx",
                        "flow",
                        "typescript"
                    ]);
                    else this.unexpected();
                    break;
                }
            default:
                if ($b48499974d50e8d0$var$tokenIsIdentifier(type)) {
                    if (this.isContextual(127) && this.lookaheadInLineCharCode() === 123) return this.parseModuleExpression();
                    const canBeArrow = this.state.potentialArrowAt === this.state.start;
                    const containsEsc = this.state.containsEsc;
                    const id = this.parseIdentifier();
                    if (!containsEsc && id.name === "async" && !this.canInsertSemicolon()) {
                        const { type: type } = this.state;
                        if (type === 68) {
                            this.resetPreviousNodeTrailingComments(id);
                            this.next();
                            return this.parseAsyncFunctionExpression(this.startNodeAtNode(id));
                        } else if ($b48499974d50e8d0$var$tokenIsIdentifier(type)) {
                            if (this.lookaheadCharCode() === 61) return this.parseAsyncArrowUnaryFunction(this.startNodeAtNode(id));
                            else return id;
                        } else if (type === 90) {
                            this.resetPreviousNodeTrailingComments(id);
                            return this.parseDo(this.startNodeAtNode(id), true);
                        }
                    }
                    if (canBeArrow && this.match(19) && !this.canInsertSemicolon()) {
                        this.next();
                        return this.parseArrowExpression(this.startNodeAtNode(id), [
                            id
                        ], false);
                    }
                    return id;
                } else this.unexpected();
        }
    }
    parseTopicReferenceThenEqualsSign(topicTokenType, topicTokenValue) {
        const pipeProposal = this.getPluginOption("pipelineOperator", "proposal");
        if (pipeProposal) {
            this.state.type = topicTokenType;
            this.state.value = topicTokenValue;
            this.state.pos--;
            this.state.end--;
            this.state.endLoc = $b48499974d50e8d0$var$createPositionWithColumnOffset(this.state.endLoc, -1);
            return this.parseTopicReference(pipeProposal);
        } else this.unexpected();
    }
    parseTopicReference(pipeProposal) {
        const node = this.startNode();
        const startLoc = this.state.startLoc;
        const tokenType = this.state.type;
        this.next();
        return this.finishTopicReference(node, startLoc, pipeProposal, tokenType);
    }
    finishTopicReference(node, startLoc, pipeProposal, tokenType) {
        if (this.testTopicReferenceConfiguration(pipeProposal, startLoc, tokenType)) {
            const nodeType = pipeProposal === "smart" ? "PipelinePrimaryTopicReference" : "TopicReference";
            if (!this.topicReferenceIsAllowedInCurrentContext()) this.raise(pipeProposal === "smart" ? $b48499974d50e8d0$var$Errors.PrimaryTopicNotAllowed : $b48499974d50e8d0$var$Errors.PipeTopicUnbound, startLoc);
            this.registerTopicReference();
            return this.finishNode(node, nodeType);
        } else throw this.raise($b48499974d50e8d0$var$Errors.PipeTopicUnconfiguredToken, startLoc, {
            token: $b48499974d50e8d0$var$tokenLabelName(tokenType)
        });
    }
    testTopicReferenceConfiguration(pipeProposal, startLoc, tokenType) {
        switch(pipeProposal){
            case "hack":
                return this.hasPlugin([
                    "pipelineOperator",
                    {
                        topicToken: $b48499974d50e8d0$var$tokenLabelName(tokenType)
                    }
                ]);
            case "smart":
                return tokenType === 27;
            default:
                throw this.raise($b48499974d50e8d0$var$Errors.PipeTopicRequiresHackPipes, startLoc);
        }
    }
    parseAsyncArrowUnaryFunction(node) {
        this.prodParam.enter($b48499974d50e8d0$var$functionFlags(true, this.prodParam.hasYield));
        const params = [
            this.parseIdentifier()
        ];
        this.prodParam.exit();
        if (this.hasPrecedingLineBreak()) this.raise($b48499974d50e8d0$var$Errors.LineTerminatorBeforeArrow, this.state.curPosition());
        this.expect(19);
        return this.parseArrowExpression(node, params, true);
    }
    parseDo(node, isAsync) {
        this.expectPlugin("doExpressions");
        if (isAsync) this.expectPlugin("asyncDoExpressions");
        node.async = isAsync;
        this.next();
        const oldLabels = this.state.labels;
        this.state.labels = [];
        if (isAsync) {
            this.prodParam.enter(2);
            node.body = this.parseBlock();
            this.prodParam.exit();
        } else node.body = this.parseBlock();
        this.state.labels = oldLabels;
        return this.finishNode(node, "DoExpression");
    }
    parseSuper() {
        const node = this.startNode();
        this.next();
        if (this.match(10) && !this.scope.allowDirectSuper && !this.options.allowSuperOutsideMethod) this.raise($b48499974d50e8d0$var$Errors.SuperNotAllowed, node);
        else if (!this.scope.allowSuper && !this.options.allowSuperOutsideMethod) this.raise($b48499974d50e8d0$var$Errors.UnexpectedSuper, node);
        if (!this.match(10) && !this.match(0) && !this.match(16)) this.raise($b48499974d50e8d0$var$Errors.UnsupportedSuper, node);
        return this.finishNode(node, "Super");
    }
    parsePrivateName() {
        const node = this.startNode();
        const id = this.startNodeAt($b48499974d50e8d0$var$createPositionWithColumnOffset(this.state.startLoc, 1));
        const name = this.state.value;
        this.next();
        node.id = this.createIdentifier(id, name);
        return this.finishNode(node, "PrivateName");
    }
    parseFunctionOrFunctionSent() {
        const node = this.startNode();
        this.next();
        if (this.prodParam.hasYield && this.match(16)) {
            const meta = this.createIdentifier(this.startNodeAtNode(node), "function");
            this.next();
            if (this.match(103)) this.expectPlugin("functionSent");
            else if (!this.hasPlugin("functionSent")) this.unexpected();
            return this.parseMetaProperty(node, meta, "sent");
        }
        return this.parseFunction(node);
    }
    parseMetaProperty(node, meta, propertyName) {
        node.meta = meta;
        const containsEsc = this.state.containsEsc;
        node.property = this.parseIdentifier(true);
        if (node.property.name !== propertyName || containsEsc) this.raise($b48499974d50e8d0$var$Errors.UnsupportedMetaProperty, node.property, {
            target: meta.name,
            onlyValidPropertyName: propertyName
        });
        return this.finishNode(node, "MetaProperty");
    }
    parseImportMetaProperty(node) {
        const id = this.createIdentifier(this.startNodeAtNode(node), "import");
        this.next();
        if (this.isContextual(101)) {
            if (!this.inModule) this.raise($b48499974d50e8d0$var$Errors.ImportMetaOutsideModule, id);
            this.sawUnambiguousESM = true;
        } else if (this.isContextual(105) || this.isContextual(97)) {
            const isSource = this.isContextual(105);
            if (!isSource) this.unexpected();
            this.expectPlugin(isSource ? "sourcePhaseImports" : "deferredImportEvaluation");
            if (!this.options.createImportExpressions) throw this.raise($b48499974d50e8d0$var$Errors.DynamicImportPhaseRequiresImportExpressions, this.state.startLoc, {
                phase: this.state.value
            });
            this.next();
            node.phase = isSource ? "source" : "defer";
            return this.parseImportCall(node);
        }
        return this.parseMetaProperty(node, id, "meta");
    }
    parseLiteralAtNode(value, type, node) {
        this.addExtra(node, "rawValue", value);
        this.addExtra(node, "raw", this.input.slice(node.start, this.state.end));
        node.value = value;
        this.next();
        return this.finishNode(node, type);
    }
    parseLiteral(value, type) {
        const node = this.startNode();
        return this.parseLiteralAtNode(value, type, node);
    }
    parseStringLiteral(value) {
        return this.parseLiteral(value, "StringLiteral");
    }
    parseNumericLiteral(value) {
        return this.parseLiteral(value, "NumericLiteral");
    }
    parseBigIntLiteral(value) {
        return this.parseLiteral(value, "BigIntLiteral");
    }
    parseDecimalLiteral(value) {
        return this.parseLiteral(value, "DecimalLiteral");
    }
    parseRegExpLiteral(value) {
        const node = this.parseLiteral(value.value, "RegExpLiteral");
        node.pattern = value.pattern;
        node.flags = value.flags;
        return node;
    }
    parseBooleanLiteral(value) {
        const node = this.startNode();
        node.value = value;
        this.next();
        return this.finishNode(node, "BooleanLiteral");
    }
    parseNullLiteral() {
        const node = this.startNode();
        this.next();
        return this.finishNode(node, "NullLiteral");
    }
    parseParenAndDistinguishExpression(canBeArrow) {
        const startLoc = this.state.startLoc;
        let val;
        this.next();
        this.expressionScope.enter($b48499974d50e8d0$var$newArrowHeadScope());
        const oldMaybeInArrowParameters = this.state.maybeInArrowParameters;
        const oldInFSharpPipelineDirectBody = this.state.inFSharpPipelineDirectBody;
        this.state.maybeInArrowParameters = true;
        this.state.inFSharpPipelineDirectBody = false;
        const innerStartLoc = this.state.startLoc;
        const exprList = [];
        const refExpressionErrors = new $b48499974d50e8d0$var$ExpressionErrors();
        let first = true;
        let spreadStartLoc;
        let optionalCommaStartLoc;
        while(!this.match(11)){
            if (first) first = false;
            else {
                this.expect(12, refExpressionErrors.optionalParametersLoc === null ? null : refExpressionErrors.optionalParametersLoc);
                if (this.match(11)) {
                    optionalCommaStartLoc = this.state.startLoc;
                    break;
                }
            }
            if (this.match(21)) {
                const spreadNodeStartLoc = this.state.startLoc;
                spreadStartLoc = this.state.startLoc;
                exprList.push(this.parseParenItem(this.parseRestBinding(), spreadNodeStartLoc));
                if (!this.checkCommaAfterRest(41)) break;
            } else exprList.push(this.parseMaybeAssignAllowIn(refExpressionErrors, this.parseParenItem));
        }
        const innerEndLoc = this.state.lastTokEndLoc;
        this.expect(11);
        this.state.maybeInArrowParameters = oldMaybeInArrowParameters;
        this.state.inFSharpPipelineDirectBody = oldInFSharpPipelineDirectBody;
        let arrowNode = this.startNodeAt(startLoc);
        if (canBeArrow && this.shouldParseArrow(exprList) && (arrowNode = this.parseArrow(arrowNode))) {
            this.checkDestructuringPrivate(refExpressionErrors);
            this.expressionScope.validateAsPattern();
            this.expressionScope.exit();
            this.parseArrowExpression(arrowNode, exprList, false);
            return arrowNode;
        }
        this.expressionScope.exit();
        if (!exprList.length) this.unexpected(this.state.lastTokStartLoc);
        if (optionalCommaStartLoc) this.unexpected(optionalCommaStartLoc);
        if (spreadStartLoc) this.unexpected(spreadStartLoc);
        this.checkExpressionErrors(refExpressionErrors, true);
        this.toReferencedListDeep(exprList, true);
        if (exprList.length > 1) {
            val = this.startNodeAt(innerStartLoc);
            val.expressions = exprList;
            this.finishNode(val, "SequenceExpression");
            this.resetEndLocation(val, innerEndLoc);
        } else val = exprList[0];
        return this.wrapParenthesis(startLoc, val);
    }
    wrapParenthesis(startLoc, expression) {
        if (!this.options.createParenthesizedExpressions) {
            this.addExtra(expression, "parenthesized", true);
            this.addExtra(expression, "parenStart", startLoc.index);
            this.takeSurroundingComments(expression, startLoc.index, this.state.lastTokEndLoc.index);
            return expression;
        }
        const parenExpression = this.startNodeAt(startLoc);
        parenExpression.expression = expression;
        return this.finishNode(parenExpression, "ParenthesizedExpression");
    }
    shouldParseArrow(params) {
        return !this.canInsertSemicolon();
    }
    parseArrow(node) {
        if (this.eat(19)) return node;
    }
    parseParenItem(node, startLoc) {
        return node;
    }
    parseNewOrNewTarget() {
        const node = this.startNode();
        this.next();
        if (this.match(16)) {
            const meta = this.createIdentifier(this.startNodeAtNode(node), "new");
            this.next();
            const metaProp = this.parseMetaProperty(node, meta, "target");
            if (!this.scope.inNonArrowFunction && !this.scope.inClass && !this.options.allowNewTargetOutsideFunction) this.raise($b48499974d50e8d0$var$Errors.UnexpectedNewTarget, metaProp);
            return metaProp;
        }
        return this.parseNew(node);
    }
    parseNew(node) {
        this.parseNewCallee(node);
        if (this.eat(10)) {
            const args = this.parseExprList(11);
            this.toReferencedList(args);
            node.arguments = args;
        } else node.arguments = [];
        return this.finishNode(node, "NewExpression");
    }
    parseNewCallee(node) {
        const isImport = this.match(83);
        const callee = this.parseNoCallExpr();
        node.callee = callee;
        if (isImport && (callee.type === "Import" || callee.type === "ImportExpression")) this.raise($b48499974d50e8d0$var$Errors.ImportCallNotNewExpression, callee);
    }
    parseTemplateElement(isTagged) {
        const { start: start, startLoc: startLoc, end: end, value: value } = this.state;
        const elemStart = start + 1;
        const elem = this.startNodeAt($b48499974d50e8d0$var$createPositionWithColumnOffset(startLoc, 1));
        if (value === null) {
            if (!isTagged) this.raise($b48499974d50e8d0$var$Errors.InvalidEscapeSequenceTemplate, $b48499974d50e8d0$var$createPositionWithColumnOffset(this.state.firstInvalidTemplateEscapePos, 1));
        }
        const isTail = this.match(24);
        const endOffset = isTail ? -1 : -2;
        const elemEnd = end + endOffset;
        elem.value = {
            raw: this.input.slice(elemStart, elemEnd).replace(/\r\n?/g, "\n"),
            cooked: value === null ? null : value.slice(1, endOffset)
        };
        elem.tail = isTail;
        this.next();
        const finishedNode = this.finishNode(elem, "TemplateElement");
        this.resetEndLocation(finishedNode, $b48499974d50e8d0$var$createPositionWithColumnOffset(this.state.lastTokEndLoc, endOffset));
        return finishedNode;
    }
    parseTemplate(isTagged) {
        const node = this.startNode();
        node.expressions = [];
        let curElt = this.parseTemplateElement(isTagged);
        node.quasis = [
            curElt
        ];
        while(!curElt.tail){
            node.expressions.push(this.parseTemplateSubstitution());
            this.readTemplateContinuation();
            node.quasis.push(curElt = this.parseTemplateElement(isTagged));
        }
        return this.finishNode(node, "TemplateLiteral");
    }
    parseTemplateSubstitution() {
        return this.parseExpression();
    }
    parseObjectLike(close, isPattern, isRecord, refExpressionErrors) {
        if (isRecord) this.expectPlugin("recordAndTuple");
        const oldInFSharpPipelineDirectBody = this.state.inFSharpPipelineDirectBody;
        this.state.inFSharpPipelineDirectBody = false;
        const propHash = Object.create(null);
        let first = true;
        const node = this.startNode();
        node.properties = [];
        this.next();
        while(!this.match(close)){
            if (first) first = false;
            else {
                this.expect(12);
                if (this.match(close)) {
                    this.addTrailingCommaExtraToNode(node);
                    break;
                }
            }
            let prop;
            if (isPattern) prop = this.parseBindingProperty();
            else {
                prop = this.parsePropertyDefinition(refExpressionErrors);
                this.checkProto(prop, isRecord, propHash, refExpressionErrors);
            }
            if (isRecord && !this.isObjectProperty(prop) && prop.type !== "SpreadElement") this.raise($b48499974d50e8d0$var$Errors.InvalidRecordProperty, prop);
            if (prop.shorthand) this.addExtra(prop, "shorthand", true);
            node.properties.push(prop);
        }
        this.next();
        this.state.inFSharpPipelineDirectBody = oldInFSharpPipelineDirectBody;
        let type = "ObjectExpression";
        if (isPattern) type = "ObjectPattern";
        else if (isRecord) type = "RecordExpression";
        return this.finishNode(node, type);
    }
    addTrailingCommaExtraToNode(node) {
        this.addExtra(node, "trailingComma", this.state.lastTokStartLoc.index);
        this.addExtra(node, "trailingCommaLoc", this.state.lastTokStartLoc, false);
    }
    maybeAsyncOrAccessorProp(prop) {
        return !prop.computed && prop.key.type === "Identifier" && (this.isLiteralPropertyName() || this.match(0) || this.match(55));
    }
    parsePropertyDefinition(refExpressionErrors) {
        let decorators = [];
        if (this.match(26)) {
            if (this.hasPlugin("decorators")) this.raise($b48499974d50e8d0$var$Errors.UnsupportedPropertyDecorator, this.state.startLoc);
            while(this.match(26))decorators.push(this.parseDecorator());
        }
        const prop = this.startNode();
        let isAsync = false;
        let isAccessor = false;
        let startLoc;
        if (this.match(21)) {
            if (decorators.length) this.unexpected();
            return this.parseSpread();
        }
        if (decorators.length) {
            prop.decorators = decorators;
            decorators = [];
        }
        prop.method = false;
        if (refExpressionErrors) startLoc = this.state.startLoc;
        let isGenerator = this.eat(55);
        this.parsePropertyNamePrefixOperator(prop);
        const containsEsc = this.state.containsEsc;
        const key = this.parsePropertyName(prop, refExpressionErrors);
        if (!isGenerator && !containsEsc && this.maybeAsyncOrAccessorProp(prop)) {
            const keyName = key.name;
            if (keyName === "async" && !this.hasPrecedingLineBreak()) {
                isAsync = true;
                this.resetPreviousNodeTrailingComments(key);
                isGenerator = this.eat(55);
                this.parsePropertyName(prop);
            }
            if (keyName === "get" || keyName === "set") {
                isAccessor = true;
                this.resetPreviousNodeTrailingComments(key);
                prop.kind = keyName;
                if (this.match(55)) {
                    isGenerator = true;
                    this.raise($b48499974d50e8d0$var$Errors.AccessorIsGenerator, this.state.curPosition(), {
                        kind: keyName
                    });
                    this.next();
                }
                this.parsePropertyName(prop);
            }
        }
        return this.parseObjPropValue(prop, startLoc, isGenerator, isAsync, false, isAccessor, refExpressionErrors);
    }
    getGetterSetterExpectedParamCount(method) {
        return method.kind === "get" ? 0 : 1;
    }
    getObjectOrClassMethodParams(method) {
        return method.params;
    }
    checkGetterSetterParams(method) {
        var _params;
        const paramCount = this.getGetterSetterExpectedParamCount(method);
        const params = this.getObjectOrClassMethodParams(method);
        if (params.length !== paramCount) this.raise(method.kind === "get" ? $b48499974d50e8d0$var$Errors.BadGetterArity : $b48499974d50e8d0$var$Errors.BadSetterArity, method);
        if (method.kind === "set" && ((_params = params[params.length - 1]) == null ? void 0 : _params.type) === "RestElement") this.raise($b48499974d50e8d0$var$Errors.BadSetterRestParameter, method);
    }
    parseObjectMethod(prop, isGenerator, isAsync, isPattern, isAccessor) {
        if (isAccessor) {
            const finishedProp = this.parseMethod(prop, isGenerator, false, false, false, "ObjectMethod");
            this.checkGetterSetterParams(finishedProp);
            return finishedProp;
        }
        if (isAsync || isGenerator || this.match(10)) {
            if (isPattern) this.unexpected();
            prop.kind = "method";
            prop.method = true;
            return this.parseMethod(prop, isGenerator, isAsync, false, false, "ObjectMethod");
        }
    }
    parseObjectProperty(prop, startLoc, isPattern, refExpressionErrors) {
        prop.shorthand = false;
        if (this.eat(14)) {
            prop.value = isPattern ? this.parseMaybeDefault(this.state.startLoc) : this.parseMaybeAssignAllowIn(refExpressionErrors);
            return this.finishNode(prop, "ObjectProperty");
        }
        if (!prop.computed && prop.key.type === "Identifier") {
            this.checkReservedWord(prop.key.name, prop.key.loc.start, true, false);
            if (isPattern) prop.value = this.parseMaybeDefault(startLoc, $b48499974d50e8d0$var$cloneIdentifier(prop.key));
            else if (this.match(29)) {
                const shorthandAssignLoc = this.state.startLoc;
                if (refExpressionErrors != null) {
                    if (refExpressionErrors.shorthandAssignLoc === null) refExpressionErrors.shorthandAssignLoc = shorthandAssignLoc;
                } else this.raise($b48499974d50e8d0$var$Errors.InvalidCoverInitializedName, shorthandAssignLoc);
                prop.value = this.parseMaybeDefault(startLoc, $b48499974d50e8d0$var$cloneIdentifier(prop.key));
            } else prop.value = $b48499974d50e8d0$var$cloneIdentifier(prop.key);
            prop.shorthand = true;
            return this.finishNode(prop, "ObjectProperty");
        }
    }
    parseObjPropValue(prop, startLoc, isGenerator, isAsync, isPattern, isAccessor, refExpressionErrors) {
        const node = this.parseObjectMethod(prop, isGenerator, isAsync, isPattern, isAccessor) || this.parseObjectProperty(prop, startLoc, isPattern, refExpressionErrors);
        if (!node) this.unexpected();
        return node;
    }
    parsePropertyName(prop, refExpressionErrors) {
        if (this.eat(0)) {
            prop.computed = true;
            prop.key = this.parseMaybeAssignAllowIn();
            this.expect(3);
        } else {
            const { type: type, value: value } = this.state;
            let key;
            if ($b48499974d50e8d0$var$tokenIsKeywordOrIdentifier(type)) key = this.parseIdentifier(true);
            else switch(type){
                case 134:
                    key = this.parseNumericLiteral(value);
                    break;
                case 133:
                    key = this.parseStringLiteral(value);
                    break;
                case 135:
                    key = this.parseBigIntLiteral(value);
                    break;
                case 136:
                    key = this.parseDecimalLiteral(value);
                    break;
                case 138:
                    {
                        const privateKeyLoc = this.state.startLoc;
                        if (refExpressionErrors != null) {
                            if (refExpressionErrors.privateKeyLoc === null) refExpressionErrors.privateKeyLoc = privateKeyLoc;
                        } else this.raise($b48499974d50e8d0$var$Errors.UnexpectedPrivateField, privateKeyLoc);
                        key = this.parsePrivateName();
                        break;
                    }
                default:
                    this.unexpected();
            }
            prop.key = key;
            if (type !== 138) prop.computed = false;
        }
        return prop.key;
    }
    initFunction(node, isAsync) {
        node.id = null;
        node.generator = false;
        node.async = isAsync;
    }
    parseMethod(node, isGenerator, isAsync, isConstructor, allowDirectSuper, type, inClassScope = false) {
        this.initFunction(node, isAsync);
        node.generator = isGenerator;
        this.scope.enter(18 | (inClassScope ? 64 : 0) | (allowDirectSuper ? 32 : 0));
        this.prodParam.enter($b48499974d50e8d0$var$functionFlags(isAsync, node.generator));
        this.parseFunctionParams(node, isConstructor);
        const finishedNode = this.parseFunctionBodyAndFinish(node, type, true);
        this.prodParam.exit();
        this.scope.exit();
        return finishedNode;
    }
    parseArrayLike(close, canBePattern, isTuple, refExpressionErrors) {
        if (isTuple) this.expectPlugin("recordAndTuple");
        const oldInFSharpPipelineDirectBody = this.state.inFSharpPipelineDirectBody;
        this.state.inFSharpPipelineDirectBody = false;
        const node = this.startNode();
        this.next();
        node.elements = this.parseExprList(close, !isTuple, refExpressionErrors, node);
        this.state.inFSharpPipelineDirectBody = oldInFSharpPipelineDirectBody;
        return this.finishNode(node, isTuple ? "TupleExpression" : "ArrayExpression");
    }
    parseArrowExpression(node, params, isAsync, trailingCommaLoc) {
        this.scope.enter(6);
        let flags = $b48499974d50e8d0$var$functionFlags(isAsync, false);
        if (!this.match(5) && this.prodParam.hasIn) flags |= 8;
        this.prodParam.enter(flags);
        this.initFunction(node, isAsync);
        const oldMaybeInArrowParameters = this.state.maybeInArrowParameters;
        if (params) {
            this.state.maybeInArrowParameters = true;
            this.setArrowFunctionParameters(node, params, trailingCommaLoc);
        }
        this.state.maybeInArrowParameters = false;
        this.parseFunctionBody(node, true);
        this.prodParam.exit();
        this.scope.exit();
        this.state.maybeInArrowParameters = oldMaybeInArrowParameters;
        return this.finishNode(node, "ArrowFunctionExpression");
    }
    setArrowFunctionParameters(node, params, trailingCommaLoc) {
        this.toAssignableList(params, trailingCommaLoc, false);
        node.params = params;
    }
    parseFunctionBodyAndFinish(node, type, isMethod = false) {
        this.parseFunctionBody(node, false, isMethod);
        return this.finishNode(node, type);
    }
    parseFunctionBody(node, allowExpression, isMethod = false) {
        const isExpression = allowExpression && !this.match(5);
        this.expressionScope.enter($b48499974d50e8d0$var$newExpressionScope());
        if (isExpression) {
            node.body = this.parseMaybeAssign();
            this.checkParams(node, false, allowExpression, false);
        } else {
            const oldStrict = this.state.strict;
            const oldLabels = this.state.labels;
            this.state.labels = [];
            this.prodParam.enter(this.prodParam.currentFlags() | 4);
            node.body = this.parseBlock(true, false, (hasStrictModeDirective)=>{
                const nonSimple = !this.isSimpleParamList(node.params);
                if (hasStrictModeDirective && nonSimple) this.raise($b48499974d50e8d0$var$Errors.IllegalLanguageModeDirective, (node.kind === "method" || node.kind === "constructor") && !!node.key ? node.key.loc.end : node);
                const strictModeChanged = !oldStrict && this.state.strict;
                this.checkParams(node, !this.state.strict && !allowExpression && !isMethod && !nonSimple, allowExpression, strictModeChanged);
                if (this.state.strict && node.id) this.checkIdentifier(node.id, 65, strictModeChanged);
            });
            this.prodParam.exit();
            this.state.labels = oldLabels;
        }
        this.expressionScope.exit();
    }
    isSimpleParameter(node) {
        return node.type === "Identifier";
    }
    isSimpleParamList(params) {
        for(let i = 0, len = params.length; i < len; i++){
            if (!this.isSimpleParameter(params[i])) return false;
        }
        return true;
    }
    checkParams(node, allowDuplicates, isArrowFunction, strictModeChanged = true) {
        const checkClashes = !allowDuplicates && new Set();
        const formalParameters = {
            type: "FormalParameters"
        };
        for (const param of node.params)this.checkLVal(param, {
            in: formalParameters,
            binding: 5,
            checkClashes: checkClashes,
            strictModeChanged: strictModeChanged
        });
    }
    parseExprList(close, allowEmpty, refExpressionErrors, nodeForExtra) {
        const elts = [];
        let first = true;
        while(!this.eat(close)){
            if (first) first = false;
            else {
                this.expect(12);
                if (this.match(close)) {
                    if (nodeForExtra) this.addTrailingCommaExtraToNode(nodeForExtra);
                    this.next();
                    break;
                }
            }
            elts.push(this.parseExprListItem(allowEmpty, refExpressionErrors));
        }
        return elts;
    }
    parseExprListItem(allowEmpty, refExpressionErrors, allowPlaceholder) {
        let elt;
        if (this.match(12)) {
            if (!allowEmpty) this.raise($b48499974d50e8d0$var$Errors.UnexpectedToken, this.state.curPosition(), {
                unexpected: ","
            });
            elt = null;
        } else if (this.match(21)) {
            const spreadNodeStartLoc = this.state.startLoc;
            elt = this.parseParenItem(this.parseSpread(refExpressionErrors), spreadNodeStartLoc);
        } else if (this.match(17)) {
            this.expectPlugin("partialApplication");
            if (!allowPlaceholder) this.raise($b48499974d50e8d0$var$Errors.UnexpectedArgumentPlaceholder, this.state.startLoc);
            const node = this.startNode();
            this.next();
            elt = this.finishNode(node, "ArgumentPlaceholder");
        } else elt = this.parseMaybeAssignAllowIn(refExpressionErrors, this.parseParenItem);
        return elt;
    }
    parseIdentifier(liberal) {
        const node = this.startNode();
        const name = this.parseIdentifierName(liberal);
        return this.createIdentifier(node, name);
    }
    createIdentifier(node, name) {
        node.name = name;
        node.loc.identifierName = name;
        return this.finishNode(node, "Identifier");
    }
    parseIdentifierName(liberal) {
        let name;
        const { startLoc: startLoc, type: type } = this.state;
        if ($b48499974d50e8d0$var$tokenIsKeywordOrIdentifier(type)) name = this.state.value;
        else this.unexpected();
        const tokenIsKeyword = $b48499974d50e8d0$var$tokenKeywordOrIdentifierIsKeyword(type);
        if (liberal) {
            if (tokenIsKeyword) this.replaceToken(132);
        } else this.checkReservedWord(name, startLoc, tokenIsKeyword, false);
        this.next();
        return name;
    }
    checkReservedWord(word, startLoc, checkKeywords, isBinding) {
        if (word.length > 10) return;
        if (!$b48499974d50e8d0$var$canBeReservedWord(word)) return;
        if (checkKeywords && $b48499974d50e8d0$var$isKeyword(word)) {
            this.raise($b48499974d50e8d0$var$Errors.UnexpectedKeyword, startLoc, {
                keyword: word
            });
            return;
        }
        const reservedTest = !this.state.strict ? $b48499974d50e8d0$var$isReservedWord : isBinding ? $b48499974d50e8d0$var$isStrictBindReservedWord : $b48499974d50e8d0$var$isStrictReservedWord;
        if (reservedTest(word, this.inModule)) {
            this.raise($b48499974d50e8d0$var$Errors.UnexpectedReservedWord, startLoc, {
                reservedWord: word
            });
            return;
        } else if (word === "yield") {
            if (this.prodParam.hasYield) {
                this.raise($b48499974d50e8d0$var$Errors.YieldBindingIdentifier, startLoc);
                return;
            }
        } else if (word === "await") {
            if (this.prodParam.hasAwait) {
                this.raise($b48499974d50e8d0$var$Errors.AwaitBindingIdentifier, startLoc);
                return;
            }
            if (this.scope.inStaticBlock) {
                this.raise($b48499974d50e8d0$var$Errors.AwaitBindingIdentifierInStaticBlock, startLoc);
                return;
            }
            this.expressionScope.recordAsyncArrowParametersError(startLoc);
        } else if (word === "arguments") {
            if (this.scope.inClassAndNotInNonArrowFunction) {
                this.raise($b48499974d50e8d0$var$Errors.ArgumentsInClass, startLoc);
                return;
            }
        }
    }
    isAwaitAllowed() {
        if (this.prodParam.hasAwait) return true;
        if (this.options.allowAwaitOutsideFunction && !this.scope.inFunction) return true;
        return false;
    }
    parseAwait(startLoc) {
        const node = this.startNodeAt(startLoc);
        this.expressionScope.recordParameterInitializerError($b48499974d50e8d0$var$Errors.AwaitExpressionFormalParameter, node);
        if (this.eat(55)) this.raise($b48499974d50e8d0$var$Errors.ObsoleteAwaitStar, node);
        if (!this.scope.inFunction && !this.options.allowAwaitOutsideFunction) {
            if (this.isAmbiguousAwait()) this.ambiguousScriptDifferentAst = true;
            else this.sawUnambiguousESM = true;
        }
        if (!this.state.soloAwait) node.argument = this.parseMaybeUnary(null, true);
        return this.finishNode(node, "AwaitExpression");
    }
    isAmbiguousAwait() {
        if (this.hasPrecedingLineBreak()) return true;
        const { type: type } = this.state;
        return type === 53 || type === 10 || type === 0 || $b48499974d50e8d0$var$tokenIsTemplate(type) || type === 102 && !this.state.containsEsc || type === 137 || type === 56 || this.hasPlugin("v8intrinsic") && type === 54;
    }
    parseYield() {
        const node = this.startNode();
        this.expressionScope.recordParameterInitializerError($b48499974d50e8d0$var$Errors.YieldInParameter, node);
        this.next();
        let delegating = false;
        let argument = null;
        if (!this.hasPrecedingLineBreak()) {
            delegating = this.eat(55);
            switch(this.state.type){
                case 13:
                case 139:
                case 8:
                case 11:
                case 3:
                case 9:
                case 14:
                case 12:
                    if (!delegating) break;
                default:
                    argument = this.parseMaybeAssign();
            }
        }
        node.delegate = delegating;
        node.argument = argument;
        return this.finishNode(node, "YieldExpression");
    }
    parseImportCall(node) {
        this.next();
        node.source = this.parseMaybeAssignAllowIn();
        if (this.hasPlugin("importAttributes") || this.hasPlugin("importAssertions")) node.options = null;
        if (this.eat(12)) {
            this.expectImportAttributesPlugin();
            if (!this.match(11)) {
                node.options = this.parseMaybeAssignAllowIn();
                this.eat(12);
            }
        }
        this.expect(11);
        return this.finishNode(node, "ImportExpression");
    }
    checkPipelineAtInfixOperator(left, leftStartLoc) {
        if (this.hasPlugin([
            "pipelineOperator",
            {
                proposal: "smart"
            }
        ])) {
            if (left.type === "SequenceExpression") this.raise($b48499974d50e8d0$var$Errors.PipelineHeadSequenceExpression, leftStartLoc);
        }
    }
    parseSmartPipelineBodyInStyle(childExpr, startLoc) {
        if (this.isSimpleReference(childExpr)) {
            const bodyNode = this.startNodeAt(startLoc);
            bodyNode.callee = childExpr;
            return this.finishNode(bodyNode, "PipelineBareFunction");
        } else {
            const bodyNode = this.startNodeAt(startLoc);
            this.checkSmartPipeTopicBodyEarlyErrors(startLoc);
            bodyNode.expression = childExpr;
            return this.finishNode(bodyNode, "PipelineTopicExpression");
        }
    }
    isSimpleReference(expression) {
        switch(expression.type){
            case "MemberExpression":
                return !expression.computed && this.isSimpleReference(expression.object);
            case "Identifier":
                return true;
            default:
                return false;
        }
    }
    checkSmartPipeTopicBodyEarlyErrors(startLoc) {
        if (this.match(19)) throw this.raise($b48499974d50e8d0$var$Errors.PipelineBodyNoArrow, this.state.startLoc);
        if (!this.topicReferenceWasUsedInCurrentContext()) this.raise($b48499974d50e8d0$var$Errors.PipelineTopicUnused, startLoc);
    }
    withTopicBindingContext(callback) {
        const outerContextTopicState = this.state.topicContext;
        this.state.topicContext = {
            maxNumOfResolvableTopics: 1,
            maxTopicIndex: null
        };
        try {
            return callback();
        } finally{
            this.state.topicContext = outerContextTopicState;
        }
    }
    withSmartMixTopicForbiddingContext(callback) {
        if (this.hasPlugin([
            "pipelineOperator",
            {
                proposal: "smart"
            }
        ])) {
            const outerContextTopicState = this.state.topicContext;
            this.state.topicContext = {
                maxNumOfResolvableTopics: 0,
                maxTopicIndex: null
            };
            try {
                return callback();
            } finally{
                this.state.topicContext = outerContextTopicState;
            }
        } else return callback();
    }
    withSoloAwaitPermittingContext(callback) {
        const outerContextSoloAwaitState = this.state.soloAwait;
        this.state.soloAwait = true;
        try {
            return callback();
        } finally{
            this.state.soloAwait = outerContextSoloAwaitState;
        }
    }
    allowInAnd(callback) {
        const flags = this.prodParam.currentFlags();
        const prodParamToSet = 8 & ~flags;
        if (prodParamToSet) {
            this.prodParam.enter(flags | 8);
            try {
                return callback();
            } finally{
                this.prodParam.exit();
            }
        }
        return callback();
    }
    disallowInAnd(callback) {
        const flags = this.prodParam.currentFlags();
        const prodParamToClear = 8 & flags;
        if (prodParamToClear) {
            this.prodParam.enter(flags & -9);
            try {
                return callback();
            } finally{
                this.prodParam.exit();
            }
        }
        return callback();
    }
    registerTopicReference() {
        this.state.topicContext.maxTopicIndex = 0;
    }
    topicReferenceIsAllowedInCurrentContext() {
        return this.state.topicContext.maxNumOfResolvableTopics >= 1;
    }
    topicReferenceWasUsedInCurrentContext() {
        return this.state.topicContext.maxTopicIndex != null && this.state.topicContext.maxTopicIndex >= 0;
    }
    parseFSharpPipelineBody(prec) {
        const startLoc = this.state.startLoc;
        this.state.potentialArrowAt = this.state.start;
        const oldInFSharpPipelineDirectBody = this.state.inFSharpPipelineDirectBody;
        this.state.inFSharpPipelineDirectBody = true;
        const ret = this.parseExprOp(this.parseMaybeUnaryOrPrivate(), startLoc, prec);
        this.state.inFSharpPipelineDirectBody = oldInFSharpPipelineDirectBody;
        return ret;
    }
    parseModuleExpression() {
        this.expectPlugin("moduleBlocks");
        const node = this.startNode();
        this.next();
        if (!this.match(5)) this.unexpected(null, 5);
        const program = this.startNodeAt(this.state.endLoc);
        this.next();
        const revertScopes = this.initializeScopes(true);
        this.enterInitialScopes();
        try {
            node.body = this.parseProgram(program, 8, "module");
        } finally{
            revertScopes();
        }
        return this.finishNode(node, "ModuleExpression");
    }
    parsePropertyNamePrefixOperator(prop) {}
}
const $b48499974d50e8d0$var$loopLabel = {
    kind: 1
}, $b48499974d50e8d0$var$switchLabel = {
    kind: 2
};
const $b48499974d50e8d0$var$loneSurrogate = /[\uD800-\uDFFF]/u;
const $b48499974d50e8d0$var$keywordRelationalOperator = /in(?:stanceof)?/y;
function $b48499974d50e8d0$var$babel7CompatTokens(tokens, input) {
    for(let i = 0; i < tokens.length; i++){
        const token = tokens[i];
        const { type: type } = token;
        if (typeof type === "number") {
            if (type === 138) {
                const { loc: loc, start: start, value: value, end: end } = token;
                const hashEndPos = start + 1;
                const hashEndLoc = $b48499974d50e8d0$var$createPositionWithColumnOffset(loc.start, 1);
                tokens.splice(i, 1, new $b48499974d50e8d0$var$Token({
                    type: $b48499974d50e8d0$var$getExportedToken(27),
                    value: "#",
                    start: start,
                    end: hashEndPos,
                    startLoc: loc.start,
                    endLoc: hashEndLoc
                }), new $b48499974d50e8d0$var$Token({
                    type: $b48499974d50e8d0$var$getExportedToken(132),
                    value: value,
                    start: hashEndPos,
                    end: end,
                    startLoc: hashEndLoc,
                    endLoc: loc.end
                }));
                i++;
                continue;
            }
            if ($b48499974d50e8d0$var$tokenIsTemplate(type)) {
                const { loc: loc, start: start, value: value, end: end } = token;
                const backquoteEnd = start + 1;
                const backquoteEndLoc = $b48499974d50e8d0$var$createPositionWithColumnOffset(loc.start, 1);
                let startToken;
                if (input.charCodeAt(start) === 96) startToken = new $b48499974d50e8d0$var$Token({
                    type: $b48499974d50e8d0$var$getExportedToken(22),
                    value: "`",
                    start: start,
                    end: backquoteEnd,
                    startLoc: loc.start,
                    endLoc: backquoteEndLoc
                });
                else startToken = new $b48499974d50e8d0$var$Token({
                    type: $b48499974d50e8d0$var$getExportedToken(8),
                    value: "}",
                    start: start,
                    end: backquoteEnd,
                    startLoc: loc.start,
                    endLoc: backquoteEndLoc
                });
                let templateValue, templateElementEnd, templateElementEndLoc, endToken;
                if (type === 24) {
                    templateElementEnd = end - 1;
                    templateElementEndLoc = $b48499974d50e8d0$var$createPositionWithColumnOffset(loc.end, -1);
                    templateValue = value === null ? null : value.slice(1, -1);
                    endToken = new $b48499974d50e8d0$var$Token({
                        type: $b48499974d50e8d0$var$getExportedToken(22),
                        value: "`",
                        start: templateElementEnd,
                        end: end,
                        startLoc: templateElementEndLoc,
                        endLoc: loc.end
                    });
                } else {
                    templateElementEnd = end - 2;
                    templateElementEndLoc = $b48499974d50e8d0$var$createPositionWithColumnOffset(loc.end, -2);
                    templateValue = value === null ? null : value.slice(1, -2);
                    endToken = new $b48499974d50e8d0$var$Token({
                        type: $b48499974d50e8d0$var$getExportedToken(23),
                        value: "${",
                        start: templateElementEnd,
                        end: end,
                        startLoc: templateElementEndLoc,
                        endLoc: loc.end
                    });
                }
                tokens.splice(i, 1, startToken, new $b48499974d50e8d0$var$Token({
                    type: $b48499974d50e8d0$var$getExportedToken(20),
                    value: templateValue,
                    start: backquoteEnd,
                    end: templateElementEnd,
                    startLoc: backquoteEndLoc,
                    endLoc: templateElementEndLoc
                }), endToken);
                i += 2;
                continue;
            }
            token.type = $b48499974d50e8d0$var$getExportedToken(type);
        }
    }
    return tokens;
}
class $b48499974d50e8d0$var$StatementParser extends $b48499974d50e8d0$var$ExpressionParser {
    parseTopLevel(file, program) {
        file.program = this.parseProgram(program);
        file.comments = this.comments;
        if (this.options.tokens) file.tokens = $b48499974d50e8d0$var$babel7CompatTokens(this.tokens, this.input);
        return this.finishNode(file, "File");
    }
    parseProgram(program, end = 139, sourceType = this.options.sourceType) {
        program.sourceType = sourceType;
        program.interpreter = this.parseInterpreterDirective();
        this.parseBlockBody(program, true, true, end);
        if (this.inModule && !this.options.allowUndeclaredExports && this.scope.undefinedExports.size > 0) for (const [localName, at] of Array.from(this.scope.undefinedExports))this.raise($b48499974d50e8d0$var$Errors.ModuleExportUndefined, at, {
            localName: localName
        });
        let finishedProgram;
        if (end === 139) finishedProgram = this.finishNode(program, "Program");
        else finishedProgram = this.finishNodeAt(program, "Program", $b48499974d50e8d0$var$createPositionWithColumnOffset(this.state.startLoc, -1));
        return finishedProgram;
    }
    stmtToDirective(stmt) {
        const directive = stmt;
        directive.type = "Directive";
        directive.value = directive.expression;
        delete directive.expression;
        const directiveLiteral = directive.value;
        const expressionValue = directiveLiteral.value;
        const raw = this.input.slice(directiveLiteral.start, directiveLiteral.end);
        const val = directiveLiteral.value = raw.slice(1, -1);
        this.addExtra(directiveLiteral, "raw", raw);
        this.addExtra(directiveLiteral, "rawValue", val);
        this.addExtra(directiveLiteral, "expressionValue", expressionValue);
        directiveLiteral.type = "DirectiveLiteral";
        return directive;
    }
    parseInterpreterDirective() {
        if (!this.match(28)) return null;
        const node = this.startNode();
        node.value = this.state.value;
        this.next();
        return this.finishNode(node, "InterpreterDirective");
    }
    isLet() {
        if (!this.isContextual(100)) return false;
        return this.hasFollowingBindingAtom();
    }
    chStartsBindingIdentifier(ch, pos) {
        if ($b48499974d50e8d0$var$isIdentifierStart(ch)) {
            $b48499974d50e8d0$var$keywordRelationalOperator.lastIndex = pos;
            if ($b48499974d50e8d0$var$keywordRelationalOperator.test(this.input)) {
                const endCh = this.codePointAtPos($b48499974d50e8d0$var$keywordRelationalOperator.lastIndex);
                if (!$b48499974d50e8d0$var$isIdentifierChar(endCh) && endCh !== 92) return false;
            }
            return true;
        } else if (ch === 92) return true;
        else return false;
    }
    chStartsBindingPattern(ch) {
        return ch === 91 || ch === 123;
    }
    hasFollowingBindingAtom() {
        const next = this.nextTokenStart();
        const nextCh = this.codePointAtPos(next);
        return this.chStartsBindingPattern(nextCh) || this.chStartsBindingIdentifier(nextCh, next);
    }
    hasInLineFollowingBindingIdentifier() {
        const next = this.nextTokenInLineStart();
        const nextCh = this.codePointAtPos(next);
        return this.chStartsBindingIdentifier(nextCh, next);
    }
    startsUsingForOf() {
        const { type: type, containsEsc: containsEsc } = this.lookahead();
        if (type === 102 && !containsEsc) return false;
        else if ($b48499974d50e8d0$var$tokenIsIdentifier(type) && !this.hasFollowingLineBreak()) {
            this.expectPlugin("explicitResourceManagement");
            return true;
        }
    }
    startsAwaitUsing() {
        let next = this.nextTokenInLineStart();
        if (this.isUnparsedContextual(next, "using")) {
            next = this.nextTokenInLineStartSince(next + 5);
            const nextCh = this.codePointAtPos(next);
            if (this.chStartsBindingIdentifier(nextCh, next)) {
                this.expectPlugin("explicitResourceManagement");
                return true;
            }
        }
        return false;
    }
    parseModuleItem() {
        return this.parseStatementLike(15);
    }
    parseStatementListItem() {
        return this.parseStatementLike(6 | (!this.options.annexB || this.state.strict ? 0 : 8));
    }
    parseStatementOrSloppyAnnexBFunctionDeclaration(allowLabeledFunction = false) {
        let flags = 0;
        if (this.options.annexB && !this.state.strict) {
            flags |= 4;
            if (allowLabeledFunction) flags |= 8;
        }
        return this.parseStatementLike(flags);
    }
    parseStatement() {
        return this.parseStatementLike(0);
    }
    parseStatementLike(flags) {
        let decorators = null;
        if (this.match(26)) decorators = this.parseDecorators(true);
        return this.parseStatementContent(flags, decorators);
    }
    parseStatementContent(flags, decorators) {
        const starttype = this.state.type;
        const node = this.startNode();
        const allowDeclaration = !!(flags & 2);
        const allowFunctionDeclaration = !!(flags & 4);
        const topLevel = flags & 1;
        switch(starttype){
            case 60:
                return this.parseBreakContinueStatement(node, true);
            case 63:
                return this.parseBreakContinueStatement(node, false);
            case 64:
                return this.parseDebuggerStatement(node);
            case 90:
                return this.parseDoWhileStatement(node);
            case 91:
                return this.parseForStatement(node);
            case 68:
                if (this.lookaheadCharCode() === 46) break;
                if (!allowFunctionDeclaration) this.raise(this.state.strict ? $b48499974d50e8d0$var$Errors.StrictFunction : this.options.annexB ? $b48499974d50e8d0$var$Errors.SloppyFunctionAnnexB : $b48499974d50e8d0$var$Errors.SloppyFunction, this.state.startLoc);
                return this.parseFunctionStatement(node, false, !allowDeclaration && allowFunctionDeclaration);
            case 80:
                if (!allowDeclaration) this.unexpected();
                return this.parseClass(this.maybeTakeDecorators(decorators, node), true);
            case 69:
                return this.parseIfStatement(node);
            case 70:
                return this.parseReturnStatement(node);
            case 71:
                return this.parseSwitchStatement(node);
            case 72:
                return this.parseThrowStatement(node);
            case 73:
                return this.parseTryStatement(node);
            case 96:
                if (!this.state.containsEsc && this.startsAwaitUsing()) {
                    if (!this.isAwaitAllowed()) this.raise($b48499974d50e8d0$var$Errors.AwaitUsingNotInAsyncContext, node);
                    else if (!allowDeclaration) this.raise($b48499974d50e8d0$var$Errors.UnexpectedLexicalDeclaration, node);
                    this.next();
                    return this.parseVarStatement(node, "await using");
                }
                break;
            case 107:
                if (this.state.containsEsc || !this.hasInLineFollowingBindingIdentifier()) break;
                this.expectPlugin("explicitResourceManagement");
                if (!this.scope.inModule && this.scope.inTopLevel) this.raise($b48499974d50e8d0$var$Errors.UnexpectedUsingDeclaration, this.state.startLoc);
                else if (!allowDeclaration) this.raise($b48499974d50e8d0$var$Errors.UnexpectedLexicalDeclaration, this.state.startLoc);
                return this.parseVarStatement(node, "using");
            case 100:
                {
                    if (this.state.containsEsc) break;
                    const next = this.nextTokenStart();
                    const nextCh = this.codePointAtPos(next);
                    if (nextCh !== 91) {
                        if (!allowDeclaration && this.hasFollowingLineBreak()) break;
                        if (!this.chStartsBindingIdentifier(nextCh, next) && nextCh !== 123) break;
                    }
                }
            case 75:
                if (!allowDeclaration) this.raise($b48499974d50e8d0$var$Errors.UnexpectedLexicalDeclaration, this.state.startLoc);
            case 74:
                {
                    const kind = this.state.value;
                    return this.parseVarStatement(node, kind);
                }
            case 92:
                return this.parseWhileStatement(node);
            case 76:
                return this.parseWithStatement(node);
            case 5:
                return this.parseBlock();
            case 13:
                return this.parseEmptyStatement(node);
            case 83:
                {
                    const nextTokenCharCode = this.lookaheadCharCode();
                    if (nextTokenCharCode === 40 || nextTokenCharCode === 46) break;
                }
            case 82:
                {
                    if (!this.options.allowImportExportEverywhere && !topLevel) this.raise($b48499974d50e8d0$var$Errors.UnexpectedImportExport, this.state.startLoc);
                    this.next();
                    let result;
                    if (starttype === 83) {
                        result = this.parseImport(node);
                        if (result.type === "ImportDeclaration" && (!result.importKind || result.importKind === "value")) this.sawUnambiguousESM = true;
                    } else {
                        result = this.parseExport(node, decorators);
                        if (result.type === "ExportNamedDeclaration" && (!result.exportKind || result.exportKind === "value") || result.type === "ExportAllDeclaration" && (!result.exportKind || result.exportKind === "value") || result.type === "ExportDefaultDeclaration") this.sawUnambiguousESM = true;
                    }
                    this.assertModuleNodeAllowed(result);
                    return result;
                }
            default:
                if (this.isAsyncFunction()) {
                    if (!allowDeclaration) this.raise($b48499974d50e8d0$var$Errors.AsyncFunctionInSingleStatementContext, this.state.startLoc);
                    this.next();
                    return this.parseFunctionStatement(node, true, !allowDeclaration && allowFunctionDeclaration);
                }
        }
        const maybeName = this.state.value;
        const expr = this.parseExpression();
        if ($b48499974d50e8d0$var$tokenIsIdentifier(starttype) && expr.type === "Identifier" && this.eat(14)) return this.parseLabeledStatement(node, maybeName, expr, flags);
        else return this.parseExpressionStatement(node, expr, decorators);
    }
    assertModuleNodeAllowed(node) {
        if (!this.options.allowImportExportEverywhere && !this.inModule) this.raise($b48499974d50e8d0$var$Errors.ImportOutsideModule, node);
    }
    decoratorsEnabledBeforeExport() {
        if (this.hasPlugin("decorators-legacy")) return true;
        return this.hasPlugin("decorators") && this.getPluginOption("decorators", "decoratorsBeforeExport") !== false;
    }
    maybeTakeDecorators(maybeDecorators, classNode, exportNode) {
        if (maybeDecorators) {
            if (classNode.decorators && classNode.decorators.length > 0) {
                if (typeof this.getPluginOption("decorators", "decoratorsBeforeExport") !== "boolean") this.raise($b48499974d50e8d0$var$Errors.DecoratorsBeforeAfterExport, classNode.decorators[0]);
                classNode.decorators.unshift(...maybeDecorators);
            } else classNode.decorators = maybeDecorators;
            this.resetStartLocationFromNode(classNode, maybeDecorators[0]);
            if (exportNode) this.resetStartLocationFromNode(exportNode, classNode);
        }
        return classNode;
    }
    canHaveLeadingDecorator() {
        return this.match(80);
    }
    parseDecorators(allowExport) {
        const decorators = [];
        do decorators.push(this.parseDecorator());
        while (this.match(26));
        if (this.match(82)) {
            if (!allowExport) this.unexpected();
            if (!this.decoratorsEnabledBeforeExport()) this.raise($b48499974d50e8d0$var$Errors.DecoratorExportClass, this.state.startLoc);
        } else if (!this.canHaveLeadingDecorator()) throw this.raise($b48499974d50e8d0$var$Errors.UnexpectedLeadingDecorator, this.state.startLoc);
        return decorators;
    }
    parseDecorator() {
        this.expectOnePlugin([
            "decorators",
            "decorators-legacy"
        ]);
        const node = this.startNode();
        this.next();
        if (this.hasPlugin("decorators")) {
            const startLoc = this.state.startLoc;
            let expr;
            if (this.match(10)) {
                const startLoc = this.state.startLoc;
                this.next();
                expr = this.parseExpression();
                this.expect(11);
                expr = this.wrapParenthesis(startLoc, expr);
                const paramsStartLoc = this.state.startLoc;
                node.expression = this.parseMaybeDecoratorArguments(expr);
                if (this.getPluginOption("decorators", "allowCallParenthesized") === false && node.expression !== expr) this.raise($b48499974d50e8d0$var$Errors.DecoratorArgumentsOutsideParentheses, paramsStartLoc);
            } else {
                expr = this.parseIdentifier(false);
                while(this.eat(16)){
                    const node = this.startNodeAt(startLoc);
                    node.object = expr;
                    if (this.match(138)) {
                        this.classScope.usePrivateName(this.state.value, this.state.startLoc);
                        node.property = this.parsePrivateName();
                    } else node.property = this.parseIdentifier(true);
                    node.computed = false;
                    expr = this.finishNode(node, "MemberExpression");
                }
                node.expression = this.parseMaybeDecoratorArguments(expr);
            }
        } else node.expression = this.parseExprSubscripts();
        return this.finishNode(node, "Decorator");
    }
    parseMaybeDecoratorArguments(expr) {
        if (this.eat(10)) {
            const node = this.startNodeAtNode(expr);
            node.callee = expr;
            node.arguments = this.parseCallExpressionArguments(11, false);
            this.toReferencedList(node.arguments);
            return this.finishNode(node, "CallExpression");
        }
        return expr;
    }
    parseBreakContinueStatement(node, isBreak) {
        this.next();
        if (this.isLineTerminator()) node.label = null;
        else {
            node.label = this.parseIdentifier();
            this.semicolon();
        }
        this.verifyBreakContinue(node, isBreak);
        return this.finishNode(node, isBreak ? "BreakStatement" : "ContinueStatement");
    }
    verifyBreakContinue(node, isBreak) {
        let i;
        for(i = 0; i < this.state.labels.length; ++i){
            const lab = this.state.labels[i];
            if (node.label == null || lab.name === node.label.name) {
                if (lab.kind != null && (isBreak || lab.kind === 1)) break;
                if (node.label && isBreak) break;
            }
        }
        if (i === this.state.labels.length) {
            const type = isBreak ? "BreakStatement" : "ContinueStatement";
            this.raise($b48499974d50e8d0$var$Errors.IllegalBreakContinue, node, {
                type: type
            });
        }
    }
    parseDebuggerStatement(node) {
        this.next();
        this.semicolon();
        return this.finishNode(node, "DebuggerStatement");
    }
    parseHeaderExpression() {
        this.expect(10);
        const val = this.parseExpression();
        this.expect(11);
        return val;
    }
    parseDoWhileStatement(node) {
        this.next();
        this.state.labels.push($b48499974d50e8d0$var$loopLabel);
        node.body = this.withSmartMixTopicForbiddingContext(()=>this.parseStatement());
        this.state.labels.pop();
        this.expect(92);
        node.test = this.parseHeaderExpression();
        this.eat(13);
        return this.finishNode(node, "DoWhileStatement");
    }
    parseForStatement(node) {
        this.next();
        this.state.labels.push($b48499974d50e8d0$var$loopLabel);
        let awaitAt = null;
        if (this.isAwaitAllowed() && this.eatContextual(96)) awaitAt = this.state.lastTokStartLoc;
        this.scope.enter(0);
        this.expect(10);
        if (this.match(13)) {
            if (awaitAt !== null) this.unexpected(awaitAt);
            return this.parseFor(node, null);
        }
        const startsWithLet = this.isContextual(100);
        {
            const startsWithAwaitUsing = this.isContextual(96) && this.startsAwaitUsing();
            const starsWithUsingDeclaration = startsWithAwaitUsing || this.isContextual(107) && this.startsUsingForOf();
            const isLetOrUsing = startsWithLet && this.hasFollowingBindingAtom() || starsWithUsingDeclaration;
            if (this.match(74) || this.match(75) || isLetOrUsing) {
                const initNode = this.startNode();
                let kind;
                if (startsWithAwaitUsing) {
                    kind = "await using";
                    if (!this.isAwaitAllowed()) this.raise($b48499974d50e8d0$var$Errors.AwaitUsingNotInAsyncContext, this.state.startLoc);
                    this.next();
                } else kind = this.state.value;
                this.next();
                this.parseVar(initNode, true, kind);
                const init = this.finishNode(initNode, "VariableDeclaration");
                const isForIn = this.match(58);
                if (isForIn && starsWithUsingDeclaration) this.raise($b48499974d50e8d0$var$Errors.ForInUsing, init);
                if ((isForIn || this.isContextual(102)) && init.declarations.length === 1) return this.parseForIn(node, init, awaitAt);
                if (awaitAt !== null) this.unexpected(awaitAt);
                return this.parseFor(node, init);
            }
        }
        const startsWithAsync = this.isContextual(95);
        const refExpressionErrors = new $b48499974d50e8d0$var$ExpressionErrors();
        const init = this.parseExpression(true, refExpressionErrors);
        const isForOf = this.isContextual(102);
        if (isForOf) {
            if (startsWithLet) this.raise($b48499974d50e8d0$var$Errors.ForOfLet, init);
            if (awaitAt === null && startsWithAsync && init.type === "Identifier") this.raise($b48499974d50e8d0$var$Errors.ForOfAsync, init);
        }
        if (isForOf || this.match(58)) {
            this.checkDestructuringPrivate(refExpressionErrors);
            this.toAssignable(init, true);
            const type = isForOf ? "ForOfStatement" : "ForInStatement";
            this.checkLVal(init, {
                in: {
                    type: type
                }
            });
            return this.parseForIn(node, init, awaitAt);
        } else this.checkExpressionErrors(refExpressionErrors, true);
        if (awaitAt !== null) this.unexpected(awaitAt);
        return this.parseFor(node, init);
    }
    parseFunctionStatement(node, isAsync, isHangingDeclaration) {
        this.next();
        return this.parseFunction(node, 1 | (isHangingDeclaration ? 2 : 0) | (isAsync ? 8 : 0));
    }
    parseIfStatement(node) {
        this.next();
        node.test = this.parseHeaderExpression();
        node.consequent = this.parseStatementOrSloppyAnnexBFunctionDeclaration();
        node.alternate = this.eat(66) ? this.parseStatementOrSloppyAnnexBFunctionDeclaration() : null;
        return this.finishNode(node, "IfStatement");
    }
    parseReturnStatement(node) {
        if (!this.prodParam.hasReturn && !this.options.allowReturnOutsideFunction) this.raise($b48499974d50e8d0$var$Errors.IllegalReturn, this.state.startLoc);
        this.next();
        if (this.isLineTerminator()) node.argument = null;
        else {
            node.argument = this.parseExpression();
            this.semicolon();
        }
        return this.finishNode(node, "ReturnStatement");
    }
    parseSwitchStatement(node) {
        this.next();
        node.discriminant = this.parseHeaderExpression();
        const cases = node.cases = [];
        this.expect(5);
        this.state.labels.push($b48499974d50e8d0$var$switchLabel);
        this.scope.enter(0);
        let cur;
        for(let sawDefault; !this.match(8);){
            if (this.match(61) || this.match(65)) {
                const isCase = this.match(61);
                if (cur) this.finishNode(cur, "SwitchCase");
                cases.push(cur = this.startNode());
                cur.consequent = [];
                this.next();
                if (isCase) cur.test = this.parseExpression();
                else {
                    if (sawDefault) this.raise($b48499974d50e8d0$var$Errors.MultipleDefaultsInSwitch, this.state.lastTokStartLoc);
                    sawDefault = true;
                    cur.test = null;
                }
                this.expect(14);
            } else if (cur) cur.consequent.push(this.parseStatementListItem());
            else this.unexpected();
        }
        this.scope.exit();
        if (cur) this.finishNode(cur, "SwitchCase");
        this.next();
        this.state.labels.pop();
        return this.finishNode(node, "SwitchStatement");
    }
    parseThrowStatement(node) {
        this.next();
        if (this.hasPrecedingLineBreak()) this.raise($b48499974d50e8d0$var$Errors.NewlineAfterThrow, this.state.lastTokEndLoc);
        node.argument = this.parseExpression();
        this.semicolon();
        return this.finishNode(node, "ThrowStatement");
    }
    parseCatchClauseParam() {
        const param = this.parseBindingAtom();
        this.scope.enter(this.options.annexB && param.type === "Identifier" ? 8 : 0);
        this.checkLVal(param, {
            in: {
                type: "CatchClause"
            },
            binding: 9
        });
        return param;
    }
    parseTryStatement(node) {
        this.next();
        node.block = this.parseBlock();
        node.handler = null;
        if (this.match(62)) {
            const clause = this.startNode();
            this.next();
            if (this.match(10)) {
                this.expect(10);
                clause.param = this.parseCatchClauseParam();
                this.expect(11);
            } else {
                clause.param = null;
                this.scope.enter(0);
            }
            clause.body = this.withSmartMixTopicForbiddingContext(()=>this.parseBlock(false, false));
            this.scope.exit();
            node.handler = this.finishNode(clause, "CatchClause");
        }
        node.finalizer = this.eat(67) ? this.parseBlock() : null;
        if (!node.handler && !node.finalizer) this.raise($b48499974d50e8d0$var$Errors.NoCatchOrFinally, node);
        return this.finishNode(node, "TryStatement");
    }
    parseVarStatement(node, kind, allowMissingInitializer = false) {
        this.next();
        this.parseVar(node, false, kind, allowMissingInitializer);
        this.semicolon();
        return this.finishNode(node, "VariableDeclaration");
    }
    parseWhileStatement(node) {
        this.next();
        node.test = this.parseHeaderExpression();
        this.state.labels.push($b48499974d50e8d0$var$loopLabel);
        node.body = this.withSmartMixTopicForbiddingContext(()=>this.parseStatement());
        this.state.labels.pop();
        return this.finishNode(node, "WhileStatement");
    }
    parseWithStatement(node) {
        if (this.state.strict) this.raise($b48499974d50e8d0$var$Errors.StrictWith, this.state.startLoc);
        this.next();
        node.object = this.parseHeaderExpression();
        node.body = this.withSmartMixTopicForbiddingContext(()=>this.parseStatement());
        return this.finishNode(node, "WithStatement");
    }
    parseEmptyStatement(node) {
        this.next();
        return this.finishNode(node, "EmptyStatement");
    }
    parseLabeledStatement(node, maybeName, expr, flags) {
        for (const label of this.state.labels)if (label.name === maybeName) this.raise($b48499974d50e8d0$var$Errors.LabelRedeclaration, expr, {
            labelName: maybeName
        });
        const kind = $b48499974d50e8d0$var$tokenIsLoop(this.state.type) ? 1 : this.match(71) ? 2 : null;
        for(let i = this.state.labels.length - 1; i >= 0; i--){
            const label = this.state.labels[i];
            if (label.statementStart === node.start) {
                label.statementStart = this.state.start;
                label.kind = kind;
            } else break;
        }
        this.state.labels.push({
            name: maybeName,
            kind: kind,
            statementStart: this.state.start
        });
        node.body = flags & 8 ? this.parseStatementOrSloppyAnnexBFunctionDeclaration(true) : this.parseStatement();
        this.state.labels.pop();
        node.label = expr;
        return this.finishNode(node, "LabeledStatement");
    }
    parseExpressionStatement(node, expr, decorators) {
        node.expression = expr;
        this.semicolon();
        return this.finishNode(node, "ExpressionStatement");
    }
    parseBlock(allowDirectives = false, createNewLexicalScope = true, afterBlockParse) {
        const node = this.startNode();
        if (allowDirectives) this.state.strictErrors.clear();
        this.expect(5);
        if (createNewLexicalScope) this.scope.enter(0);
        this.parseBlockBody(node, allowDirectives, false, 8, afterBlockParse);
        if (createNewLexicalScope) this.scope.exit();
        return this.finishNode(node, "BlockStatement");
    }
    isValidDirective(stmt) {
        return stmt.type === "ExpressionStatement" && stmt.expression.type === "StringLiteral" && !stmt.expression.extra.parenthesized;
    }
    parseBlockBody(node, allowDirectives, topLevel, end, afterBlockParse) {
        const body = node.body = [];
        const directives = node.directives = [];
        this.parseBlockOrModuleBlockBody(body, allowDirectives ? directives : undefined, topLevel, end, afterBlockParse);
    }
    parseBlockOrModuleBlockBody(body, directives, topLevel, end, afterBlockParse) {
        const oldStrict = this.state.strict;
        let hasStrictModeDirective = false;
        let parsedNonDirective = false;
        while(!this.match(end)){
            const stmt = topLevel ? this.parseModuleItem() : this.parseStatementListItem();
            if (directives && !parsedNonDirective) {
                if (this.isValidDirective(stmt)) {
                    const directive = this.stmtToDirective(stmt);
                    directives.push(directive);
                    if (!hasStrictModeDirective && directive.value.value === "use strict") {
                        hasStrictModeDirective = true;
                        this.setStrict(true);
                    }
                    continue;
                }
                parsedNonDirective = true;
                this.state.strictErrors.clear();
            }
            body.push(stmt);
        }
        afterBlockParse == null || afterBlockParse.call(this, hasStrictModeDirective);
        if (!oldStrict) this.setStrict(false);
        this.next();
    }
    parseFor(node, init) {
        node.init = init;
        this.semicolon(false);
        node.test = this.match(13) ? null : this.parseExpression();
        this.semicolon(false);
        node.update = this.match(11) ? null : this.parseExpression();
        this.expect(11);
        node.body = this.withSmartMixTopicForbiddingContext(()=>this.parseStatement());
        this.scope.exit();
        this.state.labels.pop();
        return this.finishNode(node, "ForStatement");
    }
    parseForIn(node, init, awaitAt) {
        const isForIn = this.match(58);
        this.next();
        if (isForIn) {
            if (awaitAt !== null) this.unexpected(awaitAt);
        } else node.await = awaitAt !== null;
        if (init.type === "VariableDeclaration" && init.declarations[0].init != null && (!isForIn || !this.options.annexB || this.state.strict || init.kind !== "var" || init.declarations[0].id.type !== "Identifier")) this.raise($b48499974d50e8d0$var$Errors.ForInOfLoopInitializer, init, {
            type: isForIn ? "ForInStatement" : "ForOfStatement"
        });
        if (init.type === "AssignmentPattern") this.raise($b48499974d50e8d0$var$Errors.InvalidLhs, init, {
            ancestor: {
                type: "ForStatement"
            }
        });
        node.left = init;
        node.right = isForIn ? this.parseExpression() : this.parseMaybeAssignAllowIn();
        this.expect(11);
        node.body = this.withSmartMixTopicForbiddingContext(()=>this.parseStatement());
        this.scope.exit();
        this.state.labels.pop();
        return this.finishNode(node, isForIn ? "ForInStatement" : "ForOfStatement");
    }
    parseVar(node, isFor, kind, allowMissingInitializer = false) {
        const declarations = node.declarations = [];
        node.kind = kind;
        for(;;){
            const decl = this.startNode();
            this.parseVarId(decl, kind);
            decl.init = !this.eat(29) ? null : isFor ? this.parseMaybeAssignDisallowIn() : this.parseMaybeAssignAllowIn();
            if (decl.init === null && !allowMissingInitializer) {
                if (decl.id.type !== "Identifier" && !(isFor && (this.match(58) || this.isContextual(102)))) this.raise($b48499974d50e8d0$var$Errors.DeclarationMissingInitializer, this.state.lastTokEndLoc, {
                    kind: "destructuring"
                });
                else if (kind === "const" && !(this.match(58) || this.isContextual(102))) this.raise($b48499974d50e8d0$var$Errors.DeclarationMissingInitializer, this.state.lastTokEndLoc, {
                    kind: "const"
                });
            }
            declarations.push(this.finishNode(decl, "VariableDeclarator"));
            if (!this.eat(12)) break;
        }
        return node;
    }
    parseVarId(decl, kind) {
        const id = this.parseBindingAtom();
        this.checkLVal(id, {
            in: {
                type: "VariableDeclarator"
            },
            binding: kind === "var" ? 5 : 8201
        });
        decl.id = id;
    }
    parseAsyncFunctionExpression(node) {
        return this.parseFunction(node, 8);
    }
    parseFunction(node, flags = 0) {
        const hangingDeclaration = flags & 2;
        const isDeclaration = !!(flags & 1);
        const requireId = isDeclaration && !(flags & 4);
        const isAsync = !!(flags & 8);
        this.initFunction(node, isAsync);
        if (this.match(55)) {
            if (hangingDeclaration) this.raise($b48499974d50e8d0$var$Errors.GeneratorInSingleStatementContext, this.state.startLoc);
            this.next();
            node.generator = true;
        }
        if (isDeclaration) node.id = this.parseFunctionId(requireId);
        const oldMaybeInArrowParameters = this.state.maybeInArrowParameters;
        this.state.maybeInArrowParameters = false;
        this.scope.enter(2);
        this.prodParam.enter($b48499974d50e8d0$var$functionFlags(isAsync, node.generator));
        if (!isDeclaration) node.id = this.parseFunctionId();
        this.parseFunctionParams(node, false);
        this.withSmartMixTopicForbiddingContext(()=>{
            this.parseFunctionBodyAndFinish(node, isDeclaration ? "FunctionDeclaration" : "FunctionExpression");
        });
        this.prodParam.exit();
        this.scope.exit();
        if (isDeclaration && !hangingDeclaration) this.registerFunctionStatementId(node);
        this.state.maybeInArrowParameters = oldMaybeInArrowParameters;
        return node;
    }
    parseFunctionId(requireId) {
        return requireId || $b48499974d50e8d0$var$tokenIsIdentifier(this.state.type) ? this.parseIdentifier() : null;
    }
    parseFunctionParams(node, isConstructor) {
        this.expect(10);
        this.expressionScope.enter($b48499974d50e8d0$var$newParameterDeclarationScope());
        node.params = this.parseBindingList(11, 41, 2 | (isConstructor ? 4 : 0));
        this.expressionScope.exit();
    }
    registerFunctionStatementId(node) {
        if (!node.id) return;
        this.scope.declareName(node.id.name, !this.options.annexB || this.state.strict || node.generator || node.async ? this.scope.treatFunctionsAsVar ? 5 : 8201 : 17, node.id.loc.start);
    }
    parseClass(node, isStatement, optionalId) {
        this.next();
        const oldStrict = this.state.strict;
        this.state.strict = true;
        this.parseClassId(node, isStatement, optionalId);
        this.parseClassSuper(node);
        node.body = this.parseClassBody(!!node.superClass, oldStrict);
        return this.finishNode(node, isStatement ? "ClassDeclaration" : "ClassExpression");
    }
    isClassProperty() {
        return this.match(29) || this.match(13) || this.match(8);
    }
    isClassMethod() {
        return this.match(10);
    }
    isNonstaticConstructor(method) {
        return !method.computed && !method.static && (method.key.name === "constructor" || method.key.value === "constructor");
    }
    parseClassBody(hadSuperClass, oldStrict) {
        this.classScope.enter();
        const state = {
            hadConstructor: false,
            hadSuperClass: hadSuperClass
        };
        let decorators = [];
        const classBody = this.startNode();
        classBody.body = [];
        this.expect(5);
        this.withSmartMixTopicForbiddingContext(()=>{
            while(!this.match(8)){
                if (this.eat(13)) {
                    if (decorators.length > 0) throw this.raise($b48499974d50e8d0$var$Errors.DecoratorSemicolon, this.state.lastTokEndLoc);
                    continue;
                }
                if (this.match(26)) {
                    decorators.push(this.parseDecorator());
                    continue;
                }
                const member = this.startNode();
                if (decorators.length) {
                    member.decorators = decorators;
                    this.resetStartLocationFromNode(member, decorators[0]);
                    decorators = [];
                }
                this.parseClassMember(classBody, member, state);
                if (member.kind === "constructor" && member.decorators && member.decorators.length > 0) this.raise($b48499974d50e8d0$var$Errors.DecoratorConstructor, member);
            }
        });
        this.state.strict = oldStrict;
        this.next();
        if (decorators.length) throw this.raise($b48499974d50e8d0$var$Errors.TrailingDecorator, this.state.startLoc);
        this.classScope.exit();
        return this.finishNode(classBody, "ClassBody");
    }
    parseClassMemberFromModifier(classBody, member) {
        const key = this.parseIdentifier(true);
        if (this.isClassMethod()) {
            const method = member;
            method.kind = "method";
            method.computed = false;
            method.key = key;
            method.static = false;
            this.pushClassMethod(classBody, method, false, false, false, false);
            return true;
        } else if (this.isClassProperty()) {
            const prop = member;
            prop.computed = false;
            prop.key = key;
            prop.static = false;
            classBody.body.push(this.parseClassProperty(prop));
            return true;
        }
        this.resetPreviousNodeTrailingComments(key);
        return false;
    }
    parseClassMember(classBody, member, state) {
        const isStatic = this.isContextual(106);
        if (isStatic) {
            if (this.parseClassMemberFromModifier(classBody, member)) return;
            if (this.eat(5)) {
                this.parseClassStaticBlock(classBody, member);
                return;
            }
        }
        this.parseClassMemberWithIsStatic(classBody, member, state, isStatic);
    }
    parseClassMemberWithIsStatic(classBody, member, state, isStatic) {
        const publicMethod = member;
        const privateMethod = member;
        const publicProp = member;
        const privateProp = member;
        const accessorProp = member;
        const method = publicMethod;
        const publicMember = publicMethod;
        member.static = isStatic;
        this.parsePropertyNamePrefixOperator(member);
        if (this.eat(55)) {
            method.kind = "method";
            const isPrivateName = this.match(138);
            this.parseClassElementName(method);
            if (isPrivateName) {
                this.pushClassPrivateMethod(classBody, privateMethod, true, false);
                return;
            }
            if (this.isNonstaticConstructor(publicMethod)) this.raise($b48499974d50e8d0$var$Errors.ConstructorIsGenerator, publicMethod.key);
            this.pushClassMethod(classBody, publicMethod, true, false, false, false);
            return;
        }
        const isContextual = $b48499974d50e8d0$var$tokenIsIdentifier(this.state.type) && !this.state.containsEsc;
        const isPrivate = this.match(138);
        const key = this.parseClassElementName(member);
        const maybeQuestionTokenStartLoc = this.state.startLoc;
        this.parsePostMemberNameModifiers(publicMember);
        if (this.isClassMethod()) {
            method.kind = "method";
            if (isPrivate) {
                this.pushClassPrivateMethod(classBody, privateMethod, false, false);
                return;
            }
            const isConstructor = this.isNonstaticConstructor(publicMethod);
            let allowsDirectSuper = false;
            if (isConstructor) {
                publicMethod.kind = "constructor";
                if (state.hadConstructor && !this.hasPlugin("typescript")) this.raise($b48499974d50e8d0$var$Errors.DuplicateConstructor, key);
                if (isConstructor && this.hasPlugin("typescript") && member.override) this.raise($b48499974d50e8d0$var$Errors.OverrideOnConstructor, key);
                state.hadConstructor = true;
                allowsDirectSuper = state.hadSuperClass;
            }
            this.pushClassMethod(classBody, publicMethod, false, false, isConstructor, allowsDirectSuper);
        } else if (this.isClassProperty()) {
            if (isPrivate) this.pushClassPrivateProperty(classBody, privateProp);
            else this.pushClassProperty(classBody, publicProp);
        } else if (isContextual && key.name === "async" && !this.isLineTerminator()) {
            this.resetPreviousNodeTrailingComments(key);
            const isGenerator = this.eat(55);
            if (publicMember.optional) this.unexpected(maybeQuestionTokenStartLoc);
            method.kind = "method";
            const isPrivate = this.match(138);
            this.parseClassElementName(method);
            this.parsePostMemberNameModifiers(publicMember);
            if (isPrivate) this.pushClassPrivateMethod(classBody, privateMethod, isGenerator, true);
            else {
                if (this.isNonstaticConstructor(publicMethod)) this.raise($b48499974d50e8d0$var$Errors.ConstructorIsAsync, publicMethod.key);
                this.pushClassMethod(classBody, publicMethod, isGenerator, true, false, false);
            }
        } else if (isContextual && (key.name === "get" || key.name === "set") && !(this.match(55) && this.isLineTerminator())) {
            this.resetPreviousNodeTrailingComments(key);
            method.kind = key.name;
            const isPrivate = this.match(138);
            this.parseClassElementName(publicMethod);
            if (isPrivate) this.pushClassPrivateMethod(classBody, privateMethod, false, false);
            else {
                if (this.isNonstaticConstructor(publicMethod)) this.raise($b48499974d50e8d0$var$Errors.ConstructorIsAccessor, publicMethod.key);
                this.pushClassMethod(classBody, publicMethod, false, false, false, false);
            }
            this.checkGetterSetterParams(publicMethod);
        } else if (isContextual && key.name === "accessor" && !this.isLineTerminator()) {
            this.expectPlugin("decoratorAutoAccessors");
            this.resetPreviousNodeTrailingComments(key);
            const isPrivate = this.match(138);
            this.parseClassElementName(publicProp);
            this.pushClassAccessorProperty(classBody, accessorProp, isPrivate);
        } else if (this.isLineTerminator()) {
            if (isPrivate) this.pushClassPrivateProperty(classBody, privateProp);
            else this.pushClassProperty(classBody, publicProp);
        } else this.unexpected();
    }
    parseClassElementName(member) {
        const { type: type, value: value } = this.state;
        if ((type === 132 || type === 133) && member.static && value === "prototype") this.raise($b48499974d50e8d0$var$Errors.StaticPrototype, this.state.startLoc);
        if (type === 138) {
            if (value === "constructor") this.raise($b48499974d50e8d0$var$Errors.ConstructorClassPrivateField, this.state.startLoc);
            const key = this.parsePrivateName();
            member.key = key;
            return key;
        }
        return this.parsePropertyName(member);
    }
    parseClassStaticBlock(classBody, member) {
        var _member$decorators;
        this.scope.enter(208);
        const oldLabels = this.state.labels;
        this.state.labels = [];
        this.prodParam.enter(0);
        const body = member.body = [];
        this.parseBlockOrModuleBlockBody(body, undefined, false, 8);
        this.prodParam.exit();
        this.scope.exit();
        this.state.labels = oldLabels;
        classBody.body.push(this.finishNode(member, "StaticBlock"));
        if ((_member$decorators = member.decorators) != null && _member$decorators.length) this.raise($b48499974d50e8d0$var$Errors.DecoratorStaticBlock, member);
    }
    pushClassProperty(classBody, prop) {
        if (!prop.computed && (prop.key.name === "constructor" || prop.key.value === "constructor")) this.raise($b48499974d50e8d0$var$Errors.ConstructorClassField, prop.key);
        classBody.body.push(this.parseClassProperty(prop));
    }
    pushClassPrivateProperty(classBody, prop) {
        const node = this.parseClassPrivateProperty(prop);
        classBody.body.push(node);
        this.classScope.declarePrivateName(this.getPrivateNameSV(node.key), 0, node.key.loc.start);
    }
    pushClassAccessorProperty(classBody, prop, isPrivate) {
        if (!isPrivate && !prop.computed) {
            const key = prop.key;
            if (key.name === "constructor" || key.value === "constructor") this.raise($b48499974d50e8d0$var$Errors.ConstructorClassField, key);
        }
        const node = this.parseClassAccessorProperty(prop);
        classBody.body.push(node);
        if (isPrivate) this.classScope.declarePrivateName(this.getPrivateNameSV(node.key), 0, node.key.loc.start);
    }
    pushClassMethod(classBody, method, isGenerator, isAsync, isConstructor, allowsDirectSuper) {
        classBody.body.push(this.parseMethod(method, isGenerator, isAsync, isConstructor, allowsDirectSuper, "ClassMethod", true));
    }
    pushClassPrivateMethod(classBody, method, isGenerator, isAsync) {
        const node = this.parseMethod(method, isGenerator, isAsync, false, false, "ClassPrivateMethod", true);
        classBody.body.push(node);
        const kind = node.kind === "get" ? node.static ? 6 : 2 : node.kind === "set" ? node.static ? 5 : 1 : 0;
        this.declareClassPrivateMethodInScope(node, kind);
    }
    declareClassPrivateMethodInScope(node, kind) {
        this.classScope.declarePrivateName(this.getPrivateNameSV(node.key), kind, node.key.loc.start);
    }
    parsePostMemberNameModifiers(methodOrProp) {}
    parseClassPrivateProperty(node) {
        this.parseInitializer(node);
        this.semicolon();
        return this.finishNode(node, "ClassPrivateProperty");
    }
    parseClassProperty(node) {
        this.parseInitializer(node);
        this.semicolon();
        return this.finishNode(node, "ClassProperty");
    }
    parseClassAccessorProperty(node) {
        this.parseInitializer(node);
        this.semicolon();
        return this.finishNode(node, "ClassAccessorProperty");
    }
    parseInitializer(node) {
        this.scope.enter(80);
        this.expressionScope.enter($b48499974d50e8d0$var$newExpressionScope());
        this.prodParam.enter(0);
        node.value = this.eat(29) ? this.parseMaybeAssignAllowIn() : null;
        this.expressionScope.exit();
        this.prodParam.exit();
        this.scope.exit();
    }
    parseClassId(node, isStatement, optionalId, bindingType = 8331) {
        if ($b48499974d50e8d0$var$tokenIsIdentifier(this.state.type)) {
            node.id = this.parseIdentifier();
            if (isStatement) this.declareNameFromIdentifier(node.id, bindingType);
        } else {
            if (optionalId || !isStatement) node.id = null;
            else throw this.raise($b48499974d50e8d0$var$Errors.MissingClassName, this.state.startLoc);
        }
    }
    parseClassSuper(node) {
        node.superClass = this.eat(81) ? this.parseExprSubscripts() : null;
    }
    parseExport(node, decorators) {
        const maybeDefaultIdentifier = this.parseMaybeImportPhase(node, true);
        const hasDefault = this.maybeParseExportDefaultSpecifier(node, maybeDefaultIdentifier);
        const parseAfterDefault = !hasDefault || this.eat(12);
        const hasStar = parseAfterDefault && this.eatExportStar(node);
        const hasNamespace = hasStar && this.maybeParseExportNamespaceSpecifier(node);
        const parseAfterNamespace = parseAfterDefault && (!hasNamespace || this.eat(12));
        const isFromRequired = hasDefault || hasStar;
        if (hasStar && !hasNamespace) {
            if (hasDefault) this.unexpected();
            if (decorators) throw this.raise($b48499974d50e8d0$var$Errors.UnsupportedDecoratorExport, node);
            this.parseExportFrom(node, true);
            return this.finishNode(node, "ExportAllDeclaration");
        }
        const hasSpecifiers = this.maybeParseExportNamedSpecifiers(node);
        if (hasDefault && parseAfterDefault && !hasStar && !hasSpecifiers) this.unexpected(null, 5);
        if (hasNamespace && parseAfterNamespace) this.unexpected(null, 98);
        let hasDeclaration;
        if (isFromRequired || hasSpecifiers) {
            hasDeclaration = false;
            if (decorators) throw this.raise($b48499974d50e8d0$var$Errors.UnsupportedDecoratorExport, node);
            this.parseExportFrom(node, isFromRequired);
        } else hasDeclaration = this.maybeParseExportDeclaration(node);
        if (isFromRequired || hasSpecifiers || hasDeclaration) {
            var _node2$declaration;
            const node2 = node;
            this.checkExport(node2, true, false, !!node2.source);
            if (((_node2$declaration = node2.declaration) == null ? void 0 : _node2$declaration.type) === "ClassDeclaration") this.maybeTakeDecorators(decorators, node2.declaration, node2);
            else if (decorators) throw this.raise($b48499974d50e8d0$var$Errors.UnsupportedDecoratorExport, node);
            return this.finishNode(node2, "ExportNamedDeclaration");
        }
        if (this.eat(65)) {
            const node2 = node;
            const decl = this.parseExportDefaultExpression();
            node2.declaration = decl;
            if (decl.type === "ClassDeclaration") this.maybeTakeDecorators(decorators, decl, node2);
            else if (decorators) throw this.raise($b48499974d50e8d0$var$Errors.UnsupportedDecoratorExport, node);
            this.checkExport(node2, true, true);
            return this.finishNode(node2, "ExportDefaultDeclaration");
        }
        this.unexpected(null, 5);
    }
    eatExportStar(node) {
        return this.eat(55);
    }
    maybeParseExportDefaultSpecifier(node, maybeDefaultIdentifier) {
        if (maybeDefaultIdentifier || this.isExportDefaultSpecifier()) {
            this.expectPlugin("exportDefaultFrom", maybeDefaultIdentifier == null ? void 0 : maybeDefaultIdentifier.loc.start);
            const id = maybeDefaultIdentifier || this.parseIdentifier(true);
            const specifier = this.startNodeAtNode(id);
            specifier.exported = id;
            node.specifiers = [
                this.finishNode(specifier, "ExportDefaultSpecifier")
            ];
            return true;
        }
        return false;
    }
    maybeParseExportNamespaceSpecifier(node) {
        if (this.isContextual(93)) {
            if (!node.specifiers) node.specifiers = [];
            const specifier = this.startNodeAt(this.state.lastTokStartLoc);
            this.next();
            specifier.exported = this.parseModuleExportName();
            node.specifiers.push(this.finishNode(specifier, "ExportNamespaceSpecifier"));
            return true;
        }
        return false;
    }
    maybeParseExportNamedSpecifiers(node) {
        if (this.match(5)) {
            if (!node.specifiers) node.specifiers = [];
            const isTypeExport = node.exportKind === "type";
            node.specifiers.push(...this.parseExportSpecifiers(isTypeExport));
            node.source = null;
            node.declaration = null;
            if (this.hasPlugin("importAssertions")) node.assertions = [];
            return true;
        }
        return false;
    }
    maybeParseExportDeclaration(node) {
        if (this.shouldParseExportDeclaration()) {
            node.specifiers = [];
            node.source = null;
            if (this.hasPlugin("importAssertions")) node.assertions = [];
            node.declaration = this.parseExportDeclaration(node);
            return true;
        }
        return false;
    }
    isAsyncFunction() {
        if (!this.isContextual(95)) return false;
        const next = this.nextTokenInLineStart();
        return this.isUnparsedContextual(next, "function");
    }
    parseExportDefaultExpression() {
        const expr = this.startNode();
        if (this.match(68)) {
            this.next();
            return this.parseFunction(expr, 5);
        } else if (this.isAsyncFunction()) {
            this.next();
            this.next();
            return this.parseFunction(expr, 13);
        }
        if (this.match(80)) return this.parseClass(expr, true, true);
        if (this.match(26)) {
            if (this.hasPlugin("decorators") && this.getPluginOption("decorators", "decoratorsBeforeExport") === true) this.raise($b48499974d50e8d0$var$Errors.DecoratorBeforeExport, this.state.startLoc);
            return this.parseClass(this.maybeTakeDecorators(this.parseDecorators(false), this.startNode()), true, true);
        }
        if (this.match(75) || this.match(74) || this.isLet()) throw this.raise($b48499974d50e8d0$var$Errors.UnsupportedDefaultExport, this.state.startLoc);
        const res = this.parseMaybeAssignAllowIn();
        this.semicolon();
        return res;
    }
    parseExportDeclaration(node) {
        if (this.match(80)) {
            const node = this.parseClass(this.startNode(), true, false);
            return node;
        }
        return this.parseStatementListItem();
    }
    isExportDefaultSpecifier() {
        const { type: type } = this.state;
        if ($b48499974d50e8d0$var$tokenIsIdentifier(type)) {
            if (type === 95 && !this.state.containsEsc || type === 100) return false;
            if ((type === 130 || type === 129) && !this.state.containsEsc) {
                const { type: nextType } = this.lookahead();
                if ($b48499974d50e8d0$var$tokenIsIdentifier(nextType) && nextType !== 98 || nextType === 5) {
                    this.expectOnePlugin([
                        "flow",
                        "typescript"
                    ]);
                    return false;
                }
            }
        } else if (!this.match(65)) return false;
        const next = this.nextTokenStart();
        const hasFrom = this.isUnparsedContextual(next, "from");
        if (this.input.charCodeAt(next) === 44 || $b48499974d50e8d0$var$tokenIsIdentifier(this.state.type) && hasFrom) return true;
        if (this.match(65) && hasFrom) {
            const nextAfterFrom = this.input.charCodeAt(this.nextTokenStartSince(next + 4));
            return nextAfterFrom === 34 || nextAfterFrom === 39;
        }
        return false;
    }
    parseExportFrom(node, expect) {
        if (this.eatContextual(98)) {
            node.source = this.parseImportSource();
            this.checkExport(node);
            this.maybeParseImportAttributes(node);
            this.checkJSONModuleImport(node);
        } else if (expect) this.unexpected();
        this.semicolon();
    }
    shouldParseExportDeclaration() {
        const { type: type } = this.state;
        if (type === 26) {
            this.expectOnePlugin([
                "decorators",
                "decorators-legacy"
            ]);
            if (this.hasPlugin("decorators")) {
                if (this.getPluginOption("decorators", "decoratorsBeforeExport") === true) this.raise($b48499974d50e8d0$var$Errors.DecoratorBeforeExport, this.state.startLoc);
                return true;
            }
        }
        return type === 74 || type === 75 || type === 68 || type === 80 || this.isLet() || this.isAsyncFunction();
    }
    checkExport(node, checkNames, isDefault, isFrom) {
        if (checkNames) {
            var _node$specifiers;
            if (isDefault) {
                this.checkDuplicateExports(node, "default");
                if (this.hasPlugin("exportDefaultFrom")) {
                    var _declaration$extra;
                    const declaration = node.declaration;
                    if (declaration.type === "Identifier" && declaration.name === "from" && declaration.end - declaration.start === 4 && !((_declaration$extra = declaration.extra) != null && _declaration$extra.parenthesized)) this.raise($b48499974d50e8d0$var$Errors.ExportDefaultFromAsIdentifier, declaration);
                }
            } else if ((_node$specifiers = node.specifiers) != null && _node$specifiers.length) for (const specifier of node.specifiers){
                const { exported: exported } = specifier;
                const exportName = exported.type === "Identifier" ? exported.name : exported.value;
                this.checkDuplicateExports(specifier, exportName);
                if (!isFrom && specifier.local) {
                    const { local: local } = specifier;
                    if (local.type !== "Identifier") this.raise($b48499974d50e8d0$var$Errors.ExportBindingIsString, specifier, {
                        localName: local.value,
                        exportName: exportName
                    });
                    else {
                        this.checkReservedWord(local.name, local.loc.start, true, false);
                        this.scope.checkLocalExport(local);
                    }
                }
            }
            else if (node.declaration) {
                if (node.declaration.type === "FunctionDeclaration" || node.declaration.type === "ClassDeclaration") {
                    const id = node.declaration.id;
                    if (!id) throw new Error("Assertion failure");
                    this.checkDuplicateExports(node, id.name);
                } else if (node.declaration.type === "VariableDeclaration") for (const declaration of node.declaration.declarations)this.checkDeclaration(declaration.id);
            }
        }
    }
    checkDeclaration(node) {
        if (node.type === "Identifier") this.checkDuplicateExports(node, node.name);
        else if (node.type === "ObjectPattern") for (const prop of node.properties)this.checkDeclaration(prop);
        else if (node.type === "ArrayPattern") {
            for (const elem of node.elements)if (elem) this.checkDeclaration(elem);
        } else if (node.type === "ObjectProperty") this.checkDeclaration(node.value);
        else if (node.type === "RestElement") this.checkDeclaration(node.argument);
        else if (node.type === "AssignmentPattern") this.checkDeclaration(node.left);
    }
    checkDuplicateExports(node, exportName) {
        if (this.exportedIdentifiers.has(exportName)) {
            if (exportName === "default") this.raise($b48499974d50e8d0$var$Errors.DuplicateDefaultExport, node);
            else this.raise($b48499974d50e8d0$var$Errors.DuplicateExport, node, {
                exportName: exportName
            });
        }
        this.exportedIdentifiers.add(exportName);
    }
    parseExportSpecifiers(isInTypeExport) {
        const nodes = [];
        let first = true;
        this.expect(5);
        while(!this.eat(8)){
            if (first) first = false;
            else {
                this.expect(12);
                if (this.eat(8)) break;
            }
            const isMaybeTypeOnly = this.isContextual(130);
            const isString = this.match(133);
            const node = this.startNode();
            node.local = this.parseModuleExportName();
            nodes.push(this.parseExportSpecifier(node, isString, isInTypeExport, isMaybeTypeOnly));
        }
        return nodes;
    }
    parseExportSpecifier(node, isString, isInTypeExport, isMaybeTypeOnly) {
        if (this.eatContextual(93)) node.exported = this.parseModuleExportName();
        else if (isString) node.exported = $b48499974d50e8d0$var$cloneStringLiteral(node.local);
        else if (!node.exported) node.exported = $b48499974d50e8d0$var$cloneIdentifier(node.local);
        return this.finishNode(node, "ExportSpecifier");
    }
    parseModuleExportName() {
        if (this.match(133)) {
            const result = this.parseStringLiteral(this.state.value);
            const surrogate = result.value.match($b48499974d50e8d0$var$loneSurrogate);
            if (surrogate) this.raise($b48499974d50e8d0$var$Errors.ModuleExportNameHasLoneSurrogate, result, {
                surrogateCharCode: surrogate[0].charCodeAt(0)
            });
            return result;
        }
        return this.parseIdentifier(true);
    }
    isJSONModuleImport(node) {
        if (node.assertions != null) return node.assertions.some(({ key: key, value: value })=>{
            return value.value === "json" && (key.type === "Identifier" ? key.name === "type" : key.value === "type");
        });
        return false;
    }
    checkImportReflection(node) {
        const { specifiers: specifiers } = node;
        const singleBindingType = specifiers.length === 1 ? specifiers[0].type : null;
        if (node.phase === "source") {
            if (singleBindingType !== "ImportDefaultSpecifier") this.raise($b48499974d50e8d0$var$Errors.SourcePhaseImportRequiresDefault, specifiers[0].loc.start);
        } else if (node.phase === "defer") {
            if (singleBindingType !== "ImportNamespaceSpecifier") this.raise($b48499974d50e8d0$var$Errors.DeferImportRequiresNamespace, specifiers[0].loc.start);
        } else if (node.module) {
            var _node$assertions;
            if (singleBindingType !== "ImportDefaultSpecifier") this.raise($b48499974d50e8d0$var$Errors.ImportReflectionNotBinding, specifiers[0].loc.start);
            if (((_node$assertions = node.assertions) == null ? void 0 : _node$assertions.length) > 0) this.raise($b48499974d50e8d0$var$Errors.ImportReflectionHasAssertion, specifiers[0].loc.start);
        }
    }
    checkJSONModuleImport(node) {
        if (this.isJSONModuleImport(node) && node.type !== "ExportAllDeclaration") {
            const { specifiers: specifiers } = node;
            if (specifiers != null) {
                const nonDefaultNamedSpecifier = specifiers.find((specifier)=>{
                    let imported;
                    if (specifier.type === "ExportSpecifier") imported = specifier.local;
                    else if (specifier.type === "ImportSpecifier") imported = specifier.imported;
                    if (imported !== undefined) return imported.type === "Identifier" ? imported.name !== "default" : imported.value !== "default";
                });
                if (nonDefaultNamedSpecifier !== undefined) this.raise($b48499974d50e8d0$var$Errors.ImportJSONBindingNotDefault, nonDefaultNamedSpecifier.loc.start);
            }
        }
    }
    isPotentialImportPhase(isExport) {
        if (isExport) return false;
        return this.isContextual(105) || this.isContextual(97) || this.isContextual(127);
    }
    applyImportPhase(node, isExport, phase, loc) {
        if (isExport) return;
        if (phase === "module") {
            this.expectPlugin("importReflection", loc);
            node.module = true;
        } else if (this.hasPlugin("importReflection")) node.module = false;
        if (phase === "source") {
            this.expectPlugin("sourcePhaseImports", loc);
            node.phase = "source";
        } else if (phase === "defer") {
            this.expectPlugin("deferredImportEvaluation", loc);
            node.phase = "defer";
        } else if (this.hasPlugin("sourcePhaseImports")) node.phase = null;
    }
    parseMaybeImportPhase(node, isExport) {
        if (!this.isPotentialImportPhase(isExport)) {
            this.applyImportPhase(node, isExport, null);
            return null;
        }
        const phaseIdentifier = this.parseIdentifier(true);
        const { type: type } = this.state;
        const isImportPhase = $b48499974d50e8d0$var$tokenIsKeywordOrIdentifier(type) ? type !== 98 || this.lookaheadCharCode() === 102 : type !== 12;
        if (isImportPhase) {
            this.resetPreviousIdentifierLeadingComments(phaseIdentifier);
            this.applyImportPhase(node, isExport, phaseIdentifier.name, phaseIdentifier.loc.start);
            return null;
        } else {
            this.applyImportPhase(node, isExport, null);
            return phaseIdentifier;
        }
    }
    isPrecedingIdImportPhase(phase) {
        const { type: type } = this.state;
        return $b48499974d50e8d0$var$tokenIsIdentifier(type) ? type !== 98 || this.lookaheadCharCode() === 102 : type !== 12;
    }
    parseImport(node) {
        if (this.match(133)) return this.parseImportSourceAndAttributes(node);
        return this.parseImportSpecifiersAndAfter(node, this.parseMaybeImportPhase(node, false));
    }
    parseImportSpecifiersAndAfter(node, maybeDefaultIdentifier) {
        node.specifiers = [];
        const hasDefault = this.maybeParseDefaultImportSpecifier(node, maybeDefaultIdentifier);
        const parseNext = !hasDefault || this.eat(12);
        const hasStar = parseNext && this.maybeParseStarImportSpecifier(node);
        if (parseNext && !hasStar) this.parseNamedImportSpecifiers(node);
        this.expectContextual(98);
        return this.parseImportSourceAndAttributes(node);
    }
    parseImportSourceAndAttributes(node) {
        var _node$specifiers2;
        (_node$specifiers2 = node.specifiers) != null ? _node$specifiers2 : node.specifiers = [];
        node.source = this.parseImportSource();
        this.maybeParseImportAttributes(node);
        this.checkImportReflection(node);
        this.checkJSONModuleImport(node);
        this.semicolon();
        return this.finishNode(node, "ImportDeclaration");
    }
    parseImportSource() {
        if (!this.match(133)) this.unexpected();
        return this.parseExprAtom();
    }
    parseImportSpecifierLocal(node, specifier, type) {
        specifier.local = this.parseIdentifier();
        node.specifiers.push(this.finishImportSpecifier(specifier, type));
    }
    finishImportSpecifier(specifier, type, bindingType = 8201) {
        this.checkLVal(specifier.local, {
            in: {
                type: type
            },
            binding: bindingType
        });
        return this.finishNode(specifier, type);
    }
    parseImportAttributes() {
        this.expect(5);
        const attrs = [];
        const attrNames = new Set();
        do {
            if (this.match(8)) break;
            const node = this.startNode();
            const keyName = this.state.value;
            if (attrNames.has(keyName)) this.raise($b48499974d50e8d0$var$Errors.ModuleAttributesWithDuplicateKeys, this.state.startLoc, {
                key: keyName
            });
            attrNames.add(keyName);
            if (this.match(133)) node.key = this.parseStringLiteral(keyName);
            else node.key = this.parseIdentifier(true);
            this.expect(14);
            if (!this.match(133)) throw this.raise($b48499974d50e8d0$var$Errors.ModuleAttributeInvalidValue, this.state.startLoc);
            node.value = this.parseStringLiteral(this.state.value);
            attrs.push(this.finishNode(node, "ImportAttribute"));
        }while (this.eat(12));
        this.expect(8);
        return attrs;
    }
    parseModuleAttributes() {
        const attrs = [];
        const attributes = new Set();
        do {
            const node = this.startNode();
            node.key = this.parseIdentifier(true);
            if (node.key.name !== "type") this.raise($b48499974d50e8d0$var$Errors.ModuleAttributeDifferentFromType, node.key);
            if (attributes.has(node.key.name)) this.raise($b48499974d50e8d0$var$Errors.ModuleAttributesWithDuplicateKeys, node.key, {
                key: node.key.name
            });
            attributes.add(node.key.name);
            this.expect(14);
            if (!this.match(133)) throw this.raise($b48499974d50e8d0$var$Errors.ModuleAttributeInvalidValue, this.state.startLoc);
            node.value = this.parseStringLiteral(this.state.value);
            attrs.push(this.finishNode(node, "ImportAttribute"));
        }while (this.eat(12));
        return attrs;
    }
    maybeParseImportAttributes(node) {
        let attributes;
        let useWith = false;
        if (this.match(76)) {
            if (this.hasPrecedingLineBreak() && this.lookaheadCharCode() === 40) return;
            this.next();
            if (this.hasPlugin("moduleAttributes")) attributes = this.parseModuleAttributes();
            else {
                this.expectImportAttributesPlugin();
                attributes = this.parseImportAttributes();
            }
            useWith = true;
        } else if (this.isContextual(94) && !this.hasPrecedingLineBreak()) {
            if (this.hasPlugin("importAttributes")) {
                if (this.getPluginOption("importAttributes", "deprecatedAssertSyntax") !== true) this.raise($b48499974d50e8d0$var$Errors.ImportAttributesUseAssert, this.state.startLoc);
                this.addExtra(node, "deprecatedAssertSyntax", true);
            } else this.expectOnePlugin([
                "importAttributes",
                "importAssertions"
            ]);
            this.next();
            attributes = this.parseImportAttributes();
        } else if (this.hasPlugin("importAttributes") || this.hasPlugin("importAssertions")) attributes = [];
        else {
            if (this.hasPlugin("moduleAttributes")) attributes = [];
            else return;
        }
        if (!useWith && this.hasPlugin("importAssertions")) node.assertions = attributes;
        else node.attributes = attributes;
    }
    maybeParseDefaultImportSpecifier(node, maybeDefaultIdentifier) {
        if (maybeDefaultIdentifier) {
            const specifier = this.startNodeAtNode(maybeDefaultIdentifier);
            specifier.local = maybeDefaultIdentifier;
            node.specifiers.push(this.finishImportSpecifier(specifier, "ImportDefaultSpecifier"));
            return true;
        } else if ($b48499974d50e8d0$var$tokenIsKeywordOrIdentifier(this.state.type)) {
            this.parseImportSpecifierLocal(node, this.startNode(), "ImportDefaultSpecifier");
            return true;
        }
        return false;
    }
    maybeParseStarImportSpecifier(node) {
        if (this.match(55)) {
            const specifier = this.startNode();
            this.next();
            this.expectContextual(93);
            this.parseImportSpecifierLocal(node, specifier, "ImportNamespaceSpecifier");
            return true;
        }
        return false;
    }
    parseNamedImportSpecifiers(node) {
        let first = true;
        this.expect(5);
        while(!this.eat(8)){
            if (first) first = false;
            else {
                if (this.eat(14)) throw this.raise($b48499974d50e8d0$var$Errors.DestructureNamedImport, this.state.startLoc);
                this.expect(12);
                if (this.eat(8)) break;
            }
            const specifier = this.startNode();
            const importedIsString = this.match(133);
            const isMaybeTypeOnly = this.isContextual(130);
            specifier.imported = this.parseModuleExportName();
            const importSpecifier = this.parseImportSpecifier(specifier, importedIsString, node.importKind === "type" || node.importKind === "typeof", isMaybeTypeOnly, undefined);
            node.specifiers.push(importSpecifier);
        }
    }
    parseImportSpecifier(specifier, importedIsString, isInTypeOnlyImport, isMaybeTypeOnly, bindingType) {
        if (this.eatContextual(93)) specifier.local = this.parseIdentifier();
        else {
            const { imported: imported } = specifier;
            if (importedIsString) throw this.raise($b48499974d50e8d0$var$Errors.ImportBindingIsString, specifier, {
                importName: imported.value
            });
            this.checkReservedWord(imported.name, specifier.loc.start, true, true);
            if (!specifier.local) specifier.local = $b48499974d50e8d0$var$cloneIdentifier(imported);
        }
        return this.finishImportSpecifier(specifier, "ImportSpecifier", bindingType);
    }
    isThisParam(param) {
        return param.type === "Identifier" && param.name === "this";
    }
}
class $b48499974d50e8d0$var$Parser extends $b48499974d50e8d0$var$StatementParser {
    constructor(options, input){
        options = $b48499974d50e8d0$var$getOptions(options);
        super(options, input);
        this.options = options;
        this.initializeScopes();
        this.plugins = $b48499974d50e8d0$var$pluginsMap(this.options.plugins);
        this.filename = options.sourceFilename;
    }
    getScopeHandler() {
        return $b48499974d50e8d0$var$ScopeHandler;
    }
    parse() {
        this.enterInitialScopes();
        const file = this.startNode();
        const program = this.startNode();
        this.nextToken();
        file.errors = null;
        this.parseTopLevel(file, program);
        file.errors = this.state.errors;
        file.comments.length = this.state.commentsLen;
        return file;
    }
}
function $b48499974d50e8d0$var$pluginsMap(plugins) {
    const pluginMap = new Map();
    for (const plugin of plugins){
        const [name, options] = Array.isArray(plugin) ? plugin : [
            plugin,
            {}
        ];
        if (!pluginMap.has(name)) pluginMap.set(name, options || {});
    }
    return pluginMap;
}
function $b48499974d50e8d0$var$parse(input, options) {
    var _options;
    if (((_options = options) == null ? void 0 : _options.sourceType) === "unambiguous") {
        options = Object.assign({}, options);
        try {
            options.sourceType = "module";
            const parser = $b48499974d50e8d0$var$getParser(options, input);
            const ast = parser.parse();
            if (parser.sawUnambiguousESM) return ast;
            if (parser.ambiguousScriptDifferentAst) try {
                options.sourceType = "script";
                return $b48499974d50e8d0$var$getParser(options, input).parse();
            } catch (_unused) {}
            else ast.program.sourceType = "script";
            return ast;
        } catch (moduleError) {
            try {
                options.sourceType = "script";
                return $b48499974d50e8d0$var$getParser(options, input).parse();
            } catch (_unused2) {}
            throw moduleError;
        }
    } else return $b48499974d50e8d0$var$getParser(options, input).parse();
}
function $b48499974d50e8d0$var$parseExpression(input, options) {
    const parser = $b48499974d50e8d0$var$getParser(options, input);
    if (parser.options.strictMode) parser.state.strict = true;
    return parser.getExpression();
}
function $b48499974d50e8d0$var$generateExportedTokenTypes(internalTokenTypes) {
    const tokenTypes = {};
    for (const typeName of Object.keys(internalTokenTypes))tokenTypes[typeName] = $b48499974d50e8d0$var$getExportedToken(internalTokenTypes[typeName]);
    return tokenTypes;
}
const $b48499974d50e8d0$var$tokTypes = $b48499974d50e8d0$var$generateExportedTokenTypes($b48499974d50e8d0$var$tt);
function $b48499974d50e8d0$var$getParser(options, input) {
    let cls = $b48499974d50e8d0$var$Parser;
    if (options != null && options.plugins) {
        $b48499974d50e8d0$var$validatePlugins(options.plugins);
        cls = $b48499974d50e8d0$var$getParserClass(options.plugins);
    }
    return new cls(options, input);
}
const $b48499974d50e8d0$var$parserClassCache = {};
function $b48499974d50e8d0$var$getParserClass(pluginsFromOptions) {
    const pluginList = $b48499974d50e8d0$var$mixinPluginNames.filter((name)=>$b48499974d50e8d0$var$hasPlugin(pluginsFromOptions, name));
    const key = pluginList.join("/");
    let cls = $b48499974d50e8d0$var$parserClassCache[key];
    if (!cls) {
        cls = $b48499974d50e8d0$var$Parser;
        for (const plugin of pluginList)cls = $b48499974d50e8d0$var$mixinPlugins[plugin](cls);
        $b48499974d50e8d0$var$parserClassCache[key] = cls;
    }
    return cls;
}
module.exports.parse = $b48499974d50e8d0$var$parse;
module.exports.parseExpression = $b48499974d50e8d0$var$parseExpression;
module.exports.tokTypes = $b48499974d50e8d0$var$tokTypes;

});

parcelRegister("iQrBP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $db827fe9eb33fed6$var$generate;

var $bpPZ8 = parcelRequire("bpPZ8");

var $iUjdt = parcelRequire("iUjdt");
function $db827fe9eb33fed6$var$normalizeOptions(code, opts) {
    var _opts$recordAndTupleS;
    const format = {
        auxiliaryCommentBefore: opts.auxiliaryCommentBefore,
        auxiliaryCommentAfter: opts.auxiliaryCommentAfter,
        shouldPrintComment: opts.shouldPrintComment,
        retainLines: opts.retainLines,
        retainFunctionParens: opts.retainFunctionParens,
        comments: opts.comments == null || opts.comments,
        compact: opts.compact,
        minified: opts.minified,
        concise: opts.concise,
        indent: {
            adjustMultilineComment: true,
            style: "  "
        },
        jsescOption: Object.assign({
            quotes: "double",
            wrap: true,
            minimal: false
        }, opts.jsescOption),
        recordAndTupleSyntaxType: (_opts$recordAndTupleS = opts.recordAndTupleSyntaxType) != null ? _opts$recordAndTupleS : "hash",
        topicToken: opts.topicToken,
        importAttributesKeyword: opts.importAttributesKeyword
    };
    format.decoratorsBeforeExport = opts.decoratorsBeforeExport;
    format.jsescOption.json = opts.jsonCompatibleStrings;
    if (format.minified) {
        format.compact = true;
        format.shouldPrintComment = format.shouldPrintComment || (()=>format.comments);
    } else format.shouldPrintComment = format.shouldPrintComment || ((value)=>format.comments || value.includes("@license") || value.includes("@preserve"));
    if (format.compact === "auto") {
        format.compact = typeof code === "string" && code.length > 500000;
        if (format.compact) console.error("[BABEL] Note: The code generator has deoptimised the styling of " + `${opts.filename} as it exceeds the max of ${"500KB"}.`);
    }
    if (format.compact) format.indent.adjustMultilineComment = false;
    const { auxiliaryCommentBefore: auxiliaryCommentBefore, auxiliaryCommentAfter: auxiliaryCommentAfter, shouldPrintComment: shouldPrintComment } = format;
    if (auxiliaryCommentBefore && !shouldPrintComment(auxiliaryCommentBefore)) format.auxiliaryCommentBefore = undefined;
    if (auxiliaryCommentAfter && !shouldPrintComment(auxiliaryCommentAfter)) format.auxiliaryCommentAfter = undefined;
    return format;
}
module.exports.CodeGenerator = class CodeGenerator {
    constructor(ast, opts = {}, code){
        this._ast = void 0;
        this._format = void 0;
        this._map = void 0;
        this._ast = ast;
        this._format = $db827fe9eb33fed6$var$normalizeOptions(code, opts);
        this._map = opts.sourceMaps ? new $bpPZ8.default(opts, code) : null;
    }
    generate() {
        const printer = new $iUjdt.default(this._format, this._map);
        return printer.generate(this._ast);
    }
};
function $db827fe9eb33fed6$var$generate(ast, opts = {}, code) {
    const format = $db827fe9eb33fed6$var$normalizeOptions(code, opts);
    const map = opts.sourceMaps ? new $bpPZ8.default(opts, code) : null;
    const printer = new $iUjdt.default(format, map);
    return printer.generate(ast);
}

});
parcelRegister("bpPZ8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1d5ib = parcelRequire("1d5ib");

var $5DzVE = parcelRequire("5DzVE");
class $84fa5aa619fb7548$var$SourceMap {
    constructor(opts, code){
        var _opts$sourceFileName;
        this._map = void 0;
        this._rawMappings = void 0;
        this._sourceFileName = void 0;
        this._lastGenLine = 0;
        this._lastSourceLine = 0;
        this._lastSourceColumn = 0;
        this._inputMap = void 0;
        const map = this._map = new $1d5ib.GenMapping({
            sourceRoot: opts.sourceRoot
        });
        this._sourceFileName = (_opts$sourceFileName = opts.sourceFileName) == null ? void 0 : _opts$sourceFileName.replace(/\\/g, "/");
        this._rawMappings = undefined;
        if (opts.inputSourceMap) {
            this._inputMap = new $5DzVE.TraceMap(opts.inputSourceMap);
            const resolvedSources = this._inputMap.resolvedSources;
            if (resolvedSources.length) for(let i = 0; i < resolvedSources.length; i++){
                var _this$_inputMap$sourc;
                (0, $1d5ib.setSourceContent)(map, resolvedSources[i], (_this$_inputMap$sourc = this._inputMap.sourcesContent) == null ? void 0 : _this$_inputMap$sourc[i]);
            }
        }
        if (typeof code === "string" && !opts.inputSourceMap) (0, $1d5ib.setSourceContent)(map, this._sourceFileName, code);
        else if (typeof code === "object") for (const sourceFileName of Object.keys(code))(0, $1d5ib.setSourceContent)(map, sourceFileName.replace(/\\/g, "/"), code[sourceFileName]);
    }
    get() {
        return (0, $1d5ib.toEncodedMap)(this._map);
    }
    getDecoded() {
        return (0, $1d5ib.toDecodedMap)(this._map);
    }
    getRawMappings() {
        return this._rawMappings || (this._rawMappings = (0, $1d5ib.allMappings)(this._map));
    }
    mark(generated, line, column, identifierName, identifierNamePos, filename) {
        var _originalMapping;
        this._rawMappings = undefined;
        let originalMapping;
        if (line != null) {
            if (this._inputMap) {
                originalMapping = (0, $5DzVE.originalPositionFor)(this._inputMap, {
                    line: line,
                    column: column
                });
                if (!originalMapping.name && identifierNamePos) {
                    const originalIdentifierMapping = (0, $5DzVE.originalPositionFor)(this._inputMap, identifierNamePos);
                    if (originalIdentifierMapping.name) identifierName = originalIdentifierMapping.name;
                }
            } else originalMapping = {
                source: (filename == null ? void 0 : filename.replace(/\\/g, "/")) || this._sourceFileName,
                line: line,
                column: column
            };
        }
        (0, $1d5ib.maybeAddMapping)(this._map, {
            name: identifierName,
            generated: generated,
            source: (_originalMapping = originalMapping) == null ? void 0 : _originalMapping.source,
            original: originalMapping
        });
    }
}
module.exports.default = $84fa5aa619fb7548$var$SourceMap;

});
parcelRegister("1d5ib", function(module, exports) {

$parcel$export(module.exports, "GenMapping", () => $ca65cba976c567a6$export$92fb4a3d57ca7ec);
$parcel$export(module.exports, "maybeAddSegment", () => $ca65cba976c567a6$export$bffbcf5bdbbd3679);
$parcel$export(module.exports, "maybeAddMapping", () => $ca65cba976c567a6$export$6623d26b0c62901b);
$parcel$export(module.exports, "setSourceContent", () => $ca65cba976c567a6$export$c6155c9e474ba16b);
$parcel$export(module.exports, "setIgnore", () => $ca65cba976c567a6$export$6db5baaf5ada6795);
$parcel$export(module.exports, "toDecodedMap", () => $ca65cba976c567a6$export$74ae13ad22f29c85);
$parcel$export(module.exports, "toEncodedMap", () => $ca65cba976c567a6$export$da8de8cfd71f671a);
$parcel$export(module.exports, "allMappings", () => $ca65cba976c567a6$export$f06617c6577f8fbd);

var $fd2B0 = parcelRequire("fd2B0");

var $6FvOA = parcelRequire("6FvOA");

var $5DzVE = parcelRequire("5DzVE");
const $ca65cba976c567a6$var$COLUMN = 0;
const $ca65cba976c567a6$var$SOURCES_INDEX = 1;
const $ca65cba976c567a6$var$SOURCE_LINE = 2;
const $ca65cba976c567a6$var$SOURCE_COLUMN = 3;
const $ca65cba976c567a6$var$NAMES_INDEX = 4;
const $ca65cba976c567a6$var$NO_NAME = -1;
/**
 * Provides the state to generate a sourcemap.
 */ class $ca65cba976c567a6$export$92fb4a3d57ca7ec {
    constructor({ file: file, sourceRoot: sourceRoot } = {}){
        this._names = new (0, $fd2B0.SetArray)();
        this._sources = new (0, $fd2B0.SetArray)();
        this._sourcesContent = [];
        this._mappings = [];
        this.file = file;
        this.sourceRoot = sourceRoot;
        this._ignoreList = new (0, $fd2B0.SetArray)();
    }
}
/**
 * Typescript doesn't allow friend access to private fields, so this just casts the map into a type
 * with public access modifiers.
 */ function $ca65cba976c567a6$var$cast(map) {
    return map;
}
function $ca65cba976c567a6$export$1c43f9ac826b6462(map, genLine, genColumn, source, sourceLine, sourceColumn, name, content) {
    return $ca65cba976c567a6$var$addSegmentInternal(false, map, genLine, genColumn, source, sourceLine, sourceColumn, name, content);
}
function $ca65cba976c567a6$export$2d9a54e47969bead(map, mapping) {
    return $ca65cba976c567a6$var$addMappingInternal(false, map, mapping);
}
/**
 * Same as `addSegment`, but will only add the segment if it generates useful information in the
 * resulting map. This only works correctly if segments are added **in order**, meaning you should
 * not add a segment with a lower generated line/column than one that came before.
 */ const $ca65cba976c567a6$export$bffbcf5bdbbd3679 = (map, genLine, genColumn, source, sourceLine, sourceColumn, name, content)=>{
    return $ca65cba976c567a6$var$addSegmentInternal(true, map, genLine, genColumn, source, sourceLine, sourceColumn, name, content);
};
/**
 * Same as `addMapping`, but will only add the mapping if it generates useful information in the
 * resulting map. This only works correctly if mappings are added **in order**, meaning you should
 * not add a mapping with a lower generated line/column than one that came before.
 */ const $ca65cba976c567a6$export$6623d26b0c62901b = (map, mapping)=>{
    return $ca65cba976c567a6$var$addMappingInternal(true, map, mapping);
};
/**
 * Adds/removes the content of the source file to the source map.
 */ function $ca65cba976c567a6$export$c6155c9e474ba16b(map, source, content) {
    const { _sources: sources, _sourcesContent: sourcesContent } = $ca65cba976c567a6$var$cast(map);
    const index = (0, $fd2B0.put)(sources, source);
    sourcesContent[index] = content;
}
function $ca65cba976c567a6$export$6db5baaf5ada6795(map, source, ignore = true) {
    const { _sources: sources, _sourcesContent: sourcesContent, _ignoreList: ignoreList } = $ca65cba976c567a6$var$cast(map);
    const index = (0, $fd2B0.put)(sources, source);
    if (index === sourcesContent.length) sourcesContent[index] = null;
    if (ignore) (0, $fd2B0.put)(ignoreList, index);
    else (0, $fd2B0.remove)(ignoreList, index);
}
/**
 * Returns a sourcemap object (with decoded mappings) suitable for passing to a library that expects
 * a sourcemap, or to JSON.stringify.
 */ function $ca65cba976c567a6$export$74ae13ad22f29c85(map) {
    const { _mappings: mappings, _sources: sources, _sourcesContent: sourcesContent, _names: names, _ignoreList: ignoreList } = $ca65cba976c567a6$var$cast(map);
    $ca65cba976c567a6$var$removeEmptyFinalLines(mappings);
    return {
        version: 3,
        file: map.file || undefined,
        names: names.array,
        sourceRoot: map.sourceRoot || undefined,
        sources: sources.array,
        sourcesContent: sourcesContent,
        mappings: mappings,
        ignoreList: ignoreList.array
    };
}
/**
 * Returns a sourcemap object (with encoded mappings) suitable for passing to a library that expects
 * a sourcemap, or to JSON.stringify.
 */ function $ca65cba976c567a6$export$da8de8cfd71f671a(map) {
    const decoded = $ca65cba976c567a6$export$74ae13ad22f29c85(map);
    return Object.assign(Object.assign({}, decoded), {
        mappings: (0, $6FvOA.encode)(decoded.mappings)
    });
}
/**
 * Constructs a new GenMapping, using the already present mappings of the input.
 */ function $ca65cba976c567a6$export$d81aa96f14f987cc(input) {
    const map = new (0, $5DzVE.TraceMap)(input);
    const gen = new $ca65cba976c567a6$export$92fb4a3d57ca7ec({
        file: map.file,
        sourceRoot: map.sourceRoot
    });
    $ca65cba976c567a6$var$putAll($ca65cba976c567a6$var$cast(gen)._names, map.names);
    $ca65cba976c567a6$var$putAll($ca65cba976c567a6$var$cast(gen)._sources, map.sources);
    $ca65cba976c567a6$var$cast(gen)._sourcesContent = map.sourcesContent || map.sources.map(()=>null);
    $ca65cba976c567a6$var$cast(gen)._mappings = (0, $5DzVE.decodedMappings)(map);
    if (map.ignoreList) $ca65cba976c567a6$var$putAll($ca65cba976c567a6$var$cast(gen)._ignoreList, map.ignoreList);
    return gen;
}
/**
 * Returns an array of high-level mapping objects for every recorded segment, which could then be
 * passed to the `source-map` library.
 */ function $ca65cba976c567a6$export$f06617c6577f8fbd(map) {
    const out = [];
    const { _mappings: mappings, _sources: sources, _names: names } = $ca65cba976c567a6$var$cast(map);
    for(let i = 0; i < mappings.length; i++){
        const line = mappings[i];
        for(let j = 0; j < line.length; j++){
            const seg = line[j];
            const generated = {
                line: i + 1,
                column: seg[$ca65cba976c567a6$var$COLUMN]
            };
            let source = undefined;
            let original = undefined;
            let name = undefined;
            if (seg.length !== 1) {
                source = sources.array[seg[$ca65cba976c567a6$var$SOURCES_INDEX]];
                original = {
                    line: seg[$ca65cba976c567a6$var$SOURCE_LINE] + 1,
                    column: seg[$ca65cba976c567a6$var$SOURCE_COLUMN]
                };
                if (seg.length === 5) name = names.array[seg[$ca65cba976c567a6$var$NAMES_INDEX]];
            }
            out.push({
                generated: generated,
                source: source,
                original: original,
                name: name
            });
        }
    }
    return out;
}
// This split declaration is only so that terser can elminiate the static initialization block.
function $ca65cba976c567a6$var$addSegmentInternal(skipable, map, genLine, genColumn, source, sourceLine, sourceColumn, name, content) {
    const { _mappings: mappings, _sources: sources, _sourcesContent: sourcesContent, _names: names } = $ca65cba976c567a6$var$cast(map);
    const line = $ca65cba976c567a6$var$getLine(mappings, genLine);
    const index = $ca65cba976c567a6$var$getColumnIndex(line, genColumn);
    if (!source) {
        if (skipable && $ca65cba976c567a6$var$skipSourceless(line, index)) return;
        return $ca65cba976c567a6$var$insert(line, index, [
            genColumn
        ]);
    }
    const sourcesIndex = (0, $fd2B0.put)(sources, source);
    const namesIndex = name ? (0, $fd2B0.put)(names, name) : $ca65cba976c567a6$var$NO_NAME;
    if (sourcesIndex === sourcesContent.length) sourcesContent[sourcesIndex] = content !== null && content !== void 0 ? content : null;
    if (skipable && $ca65cba976c567a6$var$skipSource(line, index, sourcesIndex, sourceLine, sourceColumn, namesIndex)) return;
    return $ca65cba976c567a6$var$insert(line, index, name ? [
        genColumn,
        sourcesIndex,
        sourceLine,
        sourceColumn,
        namesIndex
    ] : [
        genColumn,
        sourcesIndex,
        sourceLine,
        sourceColumn
    ]);
}
function $ca65cba976c567a6$var$getLine(mappings, index) {
    for(let i = mappings.length; i <= index; i++)mappings[i] = [];
    return mappings[index];
}
function $ca65cba976c567a6$var$getColumnIndex(line, genColumn) {
    let index = line.length;
    for(let i = index - 1; i >= 0; index = i--){
        const current = line[i];
        if (genColumn >= current[$ca65cba976c567a6$var$COLUMN]) break;
    }
    return index;
}
function $ca65cba976c567a6$var$insert(array, index, value) {
    for(let i = array.length; i > index; i--)array[i] = array[i - 1];
    array[index] = value;
}
function $ca65cba976c567a6$var$removeEmptyFinalLines(mappings) {
    const { length: length } = mappings;
    let len = length;
    for(let i = len - 1; i >= 0; len = i, i--){
        if (mappings[i].length > 0) break;
    }
    if (len < length) mappings.length = len;
}
function $ca65cba976c567a6$var$putAll(setarr, array) {
    for(let i = 0; i < array.length; i++)(0, $fd2B0.put)(setarr, array[i]);
}
function $ca65cba976c567a6$var$skipSourceless(line, index) {
    // The start of a line is already sourceless, so adding a sourceless segment to the beginning
    // doesn't generate any useful information.
    if (index === 0) return true;
    const prev = line[index - 1];
    // If the previous segment is also sourceless, then adding another sourceless segment doesn't
    // genrate any new information. Else, this segment will end the source/named segment and point to
    // a sourceless position, which is useful.
    return prev.length === 1;
}
function $ca65cba976c567a6$var$skipSource(line, index, sourcesIndex, sourceLine, sourceColumn, namesIndex) {
    // A source/named segment at the start of a line gives position at that genColumn
    if (index === 0) return false;
    const prev = line[index - 1];
    // If the previous segment is sourceless, then we're transitioning to a source.
    if (prev.length === 1) return false;
    // If the previous segment maps to the exact same source position, then this segment doesn't
    // provide any new position information.
    return sourcesIndex === prev[$ca65cba976c567a6$var$SOURCES_INDEX] && sourceLine === prev[$ca65cba976c567a6$var$SOURCE_LINE] && sourceColumn === prev[$ca65cba976c567a6$var$SOURCE_COLUMN] && namesIndex === (prev.length === 5 ? prev[$ca65cba976c567a6$var$NAMES_INDEX] : $ca65cba976c567a6$var$NO_NAME);
}
function $ca65cba976c567a6$var$addMappingInternal(skipable, map, mapping) {
    const { generated: generated, source: source, original: original, name: name, content: content } = mapping;
    if (!source) return $ca65cba976c567a6$var$addSegmentInternal(skipable, map, generated.line - 1, generated.column, null, null, null, null, null);
    return $ca65cba976c567a6$var$addSegmentInternal(skipable, map, generated.line - 1, generated.column, source, original.line - 1, original.column, name, content);
}

});
parcelRegister("fd2B0", function(module, exports) {

$parcel$export(module.exports, "SetArray", () => $d0b325644dd56bfd$export$937e64e16b05f14c);
$parcel$export(module.exports, "put", () => $d0b325644dd56bfd$export$327f7b26ebf455db);
$parcel$export(module.exports, "remove", () => $d0b325644dd56bfd$export$cd7f480d6b8286c3);
/**
 * SetArray acts like a `Set` (allowing only one occurrence of a string `key`), but provides the
 * index of the `key` in the backing array.
 *
 * This is designed to allow synchronizing a second array with the contents of the backing array,
 * like how in a sourcemap `sourcesContent[i]` is the source content associated with `source[i]`,
 * and there are never duplicates.
 */ class $d0b325644dd56bfd$export$937e64e16b05f14c {
    constructor(){
        this._indexes = {
            __proto__: null
        };
        this.array = [];
    }
}
/**
 * Typescript doesn't allow friend access to private fields, so this just casts the set into a type
 * with public access modifiers.
 */ function $d0b325644dd56bfd$var$cast(set) {
    return set;
}
/**
 * Gets the index associated with `key` in the backing array, if it is already present.
 */ function $d0b325644dd56bfd$export$3988ae62b71be9a3(setarr, key) {
    return $d0b325644dd56bfd$var$cast(setarr)._indexes[key];
}
/**
 * Puts `key` into the backing array, if it is not already present. Returns
 * the index of the `key` in the backing array.
 */ function $d0b325644dd56bfd$export$327f7b26ebf455db(setarr, key) {
    // The key may or may not be present. If it is present, it's a number.
    const index = $d0b325644dd56bfd$export$3988ae62b71be9a3(setarr, key);
    if (index !== undefined) return index;
    const { array: array, _indexes: indexes } = $d0b325644dd56bfd$var$cast(setarr);
    const length = array.push(key);
    return indexes[key] = length - 1;
}
/**
 * Pops the last added item out of the SetArray.
 */ function $d0b325644dd56bfd$export$3e41007ebfff0e64(setarr) {
    const { array: array, _indexes: indexes } = $d0b325644dd56bfd$var$cast(setarr);
    if (array.length === 0) return;
    const last = array.pop();
    indexes[last] = undefined;
}
/**
 * Removes the key, if it exists in the set.
 */ function $d0b325644dd56bfd$export$cd7f480d6b8286c3(setarr, key) {
    const index = $d0b325644dd56bfd$export$3988ae62b71be9a3(setarr, key);
    if (index === undefined) return;
    const { array: array, _indexes: indexes } = $d0b325644dd56bfd$var$cast(setarr);
    for(let i = index + 1; i < array.length; i++){
        const k = array[i];
        array[i - 1] = k;
        indexes[k]--;
    }
    indexes[key] = undefined;
    array.pop();
}

});

parcelRegister("6FvOA", function(module, exports) {

$parcel$export(module.exports, "decode", () => $bda7be916588d02b$export$2f872c0f2117be69);
$parcel$export(module.exports, "encode", () => $bda7be916588d02b$export$c564cdbbe6da493);

var $6ZWSX = parcelRequire("6ZWSX");
var $bda7be916588d02b$require$Buffer = $6ZWSX.Buffer;
const $bda7be916588d02b$var$comma = ",".charCodeAt(0);
const $bda7be916588d02b$var$semicolon = ";".charCodeAt(0);
const $bda7be916588d02b$var$chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
const $bda7be916588d02b$var$intToChar = new Uint8Array(64); // 64 possible chars.
const $bda7be916588d02b$var$charToInt = new Uint8Array(128); // z is 122 in ASCII
for(let i = 0; i < $bda7be916588d02b$var$chars.length; i++){
    const c = $bda7be916588d02b$var$chars.charCodeAt(i);
    $bda7be916588d02b$var$intToChar[i] = c;
    $bda7be916588d02b$var$charToInt[c] = i;
}
// Provide a fallback for older environments.
const $bda7be916588d02b$var$td = typeof TextDecoder !== "undefined" ? /* #__PURE__ */ new TextDecoder() : typeof $bda7be916588d02b$require$Buffer !== "undefined" ? {
    decode (buf) {
        const out = $bda7be916588d02b$require$Buffer.from(buf.buffer, buf.byteOffset, buf.byteLength);
        return out.toString();
    }
} : {
    decode (buf) {
        let out = "";
        for(let i = 0; i < buf.length; i++)out += String.fromCharCode(buf[i]);
        return out;
    }
};
function $bda7be916588d02b$export$2f872c0f2117be69(mappings) {
    const state = new Int32Array(5);
    const decoded = [];
    let index = 0;
    do {
        const semi = $bda7be916588d02b$var$indexOf(mappings, index);
        const line = [];
        let sorted = true;
        let lastCol = 0;
        state[0] = 0;
        for(let i = index; i < semi; i++){
            let seg;
            i = $bda7be916588d02b$var$decodeInteger(mappings, i, state, 0); // genColumn
            const col = state[0];
            if (col < lastCol) sorted = false;
            lastCol = col;
            if ($bda7be916588d02b$var$hasMoreVlq(mappings, i, semi)) {
                i = $bda7be916588d02b$var$decodeInteger(mappings, i, state, 1); // sourcesIndex
                i = $bda7be916588d02b$var$decodeInteger(mappings, i, state, 2); // sourceLine
                i = $bda7be916588d02b$var$decodeInteger(mappings, i, state, 3); // sourceColumn
                if ($bda7be916588d02b$var$hasMoreVlq(mappings, i, semi)) {
                    i = $bda7be916588d02b$var$decodeInteger(mappings, i, state, 4); // namesIndex
                    seg = [
                        col,
                        state[1],
                        state[2],
                        state[3],
                        state[4]
                    ];
                } else seg = [
                    col,
                    state[1],
                    state[2],
                    state[3]
                ];
            } else seg = [
                col
            ];
            line.push(seg);
        }
        if (!sorted) $bda7be916588d02b$var$sort(line);
        decoded.push(line);
        index = semi + 1;
    }while (index <= mappings.length);
    return decoded;
}
function $bda7be916588d02b$var$indexOf(mappings, index) {
    const idx = mappings.indexOf(";", index);
    return idx === -1 ? mappings.length : idx;
}
function $bda7be916588d02b$var$decodeInteger(mappings, pos, state, j) {
    let value = 0;
    let shift = 0;
    let integer = 0;
    do {
        const c = mappings.charCodeAt(pos++);
        integer = $bda7be916588d02b$var$charToInt[c];
        value |= (integer & 31) << shift;
        shift += 5;
    }while (integer & 32);
    const shouldNegate = value & 1;
    value >>>= 1;
    if (shouldNegate) value = -2147483648 | -value;
    state[j] += value;
    return pos;
}
function $bda7be916588d02b$var$hasMoreVlq(mappings, i, length) {
    if (i >= length) return false;
    return mappings.charCodeAt(i) !== $bda7be916588d02b$var$comma;
}
function $bda7be916588d02b$var$sort(line) {
    line.sort($bda7be916588d02b$var$sortComparator);
}
function $bda7be916588d02b$var$sortComparator(a, b) {
    return a[0] - b[0];
}
function $bda7be916588d02b$export$c564cdbbe6da493(decoded) {
    const state = new Int32Array(5);
    const bufLength = 16384;
    const subLength = bufLength - 36;
    const buf = new Uint8Array(bufLength);
    const sub = buf.subarray(0, subLength);
    let pos = 0;
    let out = "";
    for(let i = 0; i < decoded.length; i++){
        const line = decoded[i];
        if (i > 0) {
            if (pos === bufLength) {
                out += $bda7be916588d02b$var$td.decode(buf);
                pos = 0;
            }
            buf[pos++] = $bda7be916588d02b$var$semicolon;
        }
        if (line.length === 0) continue;
        state[0] = 0;
        for(let j = 0; j < line.length; j++){
            const segment = line[j];
            // We can push up to 5 ints, each int can take at most 7 chars, and we
            // may push a comma.
            if (pos > subLength) {
                out += $bda7be916588d02b$var$td.decode(sub);
                buf.copyWithin(0, subLength, pos);
                pos -= subLength;
            }
            if (j > 0) buf[pos++] = $bda7be916588d02b$var$comma;
            pos = $bda7be916588d02b$var$encodeInteger(buf, pos, state, segment, 0); // genColumn
            if (segment.length === 1) continue;
            pos = $bda7be916588d02b$var$encodeInteger(buf, pos, state, segment, 1); // sourcesIndex
            pos = $bda7be916588d02b$var$encodeInteger(buf, pos, state, segment, 2); // sourceLine
            pos = $bda7be916588d02b$var$encodeInteger(buf, pos, state, segment, 3); // sourceColumn
            if (segment.length === 4) continue;
            pos = $bda7be916588d02b$var$encodeInteger(buf, pos, state, segment, 4); // namesIndex
        }
    }
    return out + $bda7be916588d02b$var$td.decode(buf.subarray(0, pos));
}
function $bda7be916588d02b$var$encodeInteger(buf, pos, state, segment, j) {
    const next = segment[j];
    let num = next - state[j];
    state[j] = next;
    num = num < 0 ? -num << 1 | 1 : num << 1;
    do {
        let clamped = num & 31;
        num >>>= 5;
        if (num > 0) clamped |= 32;
        buf[pos++] = $bda7be916588d02b$var$intToChar[clamped];
    }while (num > 0);
    return pos;
}

});
parcelRegister("6ZWSX", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $51861dfc7ca9d588$export$a143d493d941bafc, (v) => $51861dfc7ca9d588$export$a143d493d941bafc = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $51861dfc7ca9d588$export$f99ded8fe4b79145, (v) => $51861dfc7ca9d588$export$f99ded8fe4b79145 = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $51861dfc7ca9d588$export$a143d493d941bafc;
var $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a;
var $51861dfc7ca9d588$export$f99ded8fe4b79145;
var $51861dfc7ca9d588$export$599f31c3813fae4d;
"use strict";

var $kuxul = parcelRequire("kuxul");

var $9NvM5 = parcelRequire("9NvM5");
const $51861dfc7ca9d588$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$51861dfc7ca9d588$export$a143d493d941bafc = $51861dfc7ca9d588$var$Buffer;
$51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = $51861dfc7ca9d588$var$SlowBuffer;
$51861dfc7ca9d588$export$f99ded8fe4b79145 = 50;
const $51861dfc7ca9d588$var$K_MAX_LENGTH = 0x7fffffff;
$51861dfc7ca9d588$export$599f31c3813fae4d = $51861dfc7ca9d588$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT = $51861dfc7ca9d588$var$typedArraySupport();
if (!$51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $51861dfc7ca9d588$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $51861dfc7ca9d588$var$createBuffer(length) {
    if (length > $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $51861dfc7ca9d588$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $51861dfc7ca9d588$var$allocUnsafe(arg);
    }
    return $51861dfc7ca9d588$var$from(arg, encodingOrOffset, length);
}
$51861dfc7ca9d588$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $51861dfc7ca9d588$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $51861dfc7ca9d588$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $51861dfc7ca9d588$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($51861dfc7ca9d588$var$isInstance(value, ArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, ArrayBuffer)) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($51861dfc7ca9d588$var$isInstance(value, SharedArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, SharedArrayBuffer))) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $51861dfc7ca9d588$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $51861dfc7ca9d588$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $51861dfc7ca9d588$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $51861dfc7ca9d588$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $51861dfc7ca9d588$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer, Uint8Array);
function $51861dfc7ca9d588$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $51861dfc7ca9d588$var$alloc(size, fill, encoding) {
    $51861dfc7ca9d588$var$assertSize(size);
    if (size <= 0) return $51861dfc7ca9d588$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $51861dfc7ca9d588$var$createBuffer(size).fill(fill, encoding) : $51861dfc7ca9d588$var$createBuffer(size).fill(fill);
    return $51861dfc7ca9d588$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $51861dfc7ca9d588$var$Buffer.alloc = function(size, fill, encoding) {
    return $51861dfc7ca9d588$var$alloc(size, fill, encoding);
};
function $51861dfc7ca9d588$var$allocUnsafe(size) {
    $51861dfc7ca9d588$var$assertSize(size);
    return $51861dfc7ca9d588$var$createBuffer(size < 0 ? 0 : $51861dfc7ca9d588$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $51861dfc7ca9d588$var$Buffer.allocUnsafe = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $51861dfc7ca9d588$var$Buffer.allocUnsafeSlow = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
function $51861dfc7ca9d588$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $51861dfc7ca9d588$var$byteLength(string, encoding) | 0;
    let buf = $51861dfc7ca9d588$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $51861dfc7ca9d588$var$checked(array.length) | 0;
    const buf = $51861dfc7ca9d588$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayView(arrayView) {
    if ($51861dfc7ca9d588$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $51861dfc7ca9d588$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $51861dfc7ca9d588$var$fromArrayLike(arrayView);
}
function $51861dfc7ca9d588$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
function $51861dfc7ca9d588$var$fromObject(obj) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(obj)) {
        const len = $51861dfc7ca9d588$var$checked(obj.length) | 0;
        const buf = $51861dfc7ca9d588$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $51861dfc7ca9d588$var$numberIsNaN(obj.length)) return $51861dfc7ca9d588$var$createBuffer(0);
        return $51861dfc7ca9d588$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $51861dfc7ca9d588$var$fromArrayLike(obj.data);
}
function $51861dfc7ca9d588$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $51861dfc7ca9d588$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $51861dfc7ca9d588$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $51861dfc7ca9d588$var$Buffer.alloc(+length);
}
$51861dfc7ca9d588$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $51861dfc7ca9d588$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$51861dfc7ca9d588$var$Buffer.compare = function compare(a, b) {
    if ($51861dfc7ca9d588$var$isInstance(a, Uint8Array)) a = $51861dfc7ca9d588$var$Buffer.from(a, a.offset, a.byteLength);
    if ($51861dfc7ca9d588$var$isInstance(b, Uint8Array)) b = $51861dfc7ca9d588$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(a) || !$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$51861dfc7ca9d588$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$51861dfc7ca9d588$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $51861dfc7ca9d588$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $51861dfc7ca9d588$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($51861dfc7ca9d588$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) buf = $51861dfc7ca9d588$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $51861dfc7ca9d588$var$byteLength(string, encoding) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $51861dfc7ca9d588$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $51861dfc7ca9d588$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $51861dfc7ca9d588$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$51861dfc7ca9d588$var$Buffer.byteLength = $51861dfc7ca9d588$var$byteLength;
function $51861dfc7ca9d588$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $51861dfc7ca9d588$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8Slice(this, start, end);
        case "ascii":
            return $51861dfc7ca9d588$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $51861dfc7ca9d588$var$latin1Slice(this, start, end);
        case "base64":
            return $51861dfc7ca9d588$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $51861dfc7ca9d588$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$51861dfc7ca9d588$var$Buffer.prototype._isBuffer = true;
function $51861dfc7ca9d588$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$51861dfc7ca9d588$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$51861dfc7ca9d588$var$swap(this, i, i + 1);
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $51861dfc7ca9d588$var$swap(this, i, i + 3);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $51861dfc7ca9d588$var$swap(this, i, i + 7);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 6);
        $51861dfc7ca9d588$var$swap(this, i + 2, i + 5);
        $51861dfc7ca9d588$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $51861dfc7ca9d588$var$utf8Slice(this, 0, length);
    return $51861dfc7ca9d588$var$slowToString.apply(this, arguments);
};
$51861dfc7ca9d588$var$Buffer.prototype.toLocaleString = $51861dfc7ca9d588$var$Buffer.prototype.toString;
$51861dfc7ca9d588$var$Buffer.prototype.equals = function equals(b) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $51861dfc7ca9d588$var$Buffer.compare(this, b) === 0;
};
$51861dfc7ca9d588$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $51861dfc7ca9d588$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($51861dfc7ca9d588$var$customInspectSymbol) $51861dfc7ca9d588$var$Buffer.prototype[$51861dfc7ca9d588$var$customInspectSymbol] = $51861dfc7ca9d588$var$Buffer.prototype.inspect;
$51861dfc7ca9d588$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($51861dfc7ca9d588$var$isInstance(target, Uint8Array)) target = $51861dfc7ca9d588$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $51861dfc7ca9d588$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($51861dfc7ca9d588$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $51861dfc7ca9d588$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $51861dfc7ca9d588$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$51861dfc7ca9d588$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$51861dfc7ca9d588$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $51861dfc7ca9d588$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($51861dfc7ca9d588$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $51861dfc7ca9d588$var$utf8Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $51861dfc7ca9d588$var$asciiWrite(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$asciiToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$base64Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$base64ToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$ucs2Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$51861dfc7ca9d588$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $51861dfc7ca9d588$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $51861dfc7ca9d588$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $51861dfc7ca9d588$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $51861dfc7ca9d588$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$51861dfc7ca9d588$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $51861dfc7ca9d588$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $kuxul.fromByteArray(buf);
    else return $kuxul.fromByteArray(buf.slice(start, end));
}
function $51861dfc7ca9d588$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $51861dfc7ca9d588$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $51861dfc7ca9d588$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $51861dfc7ca9d588$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $51861dfc7ca9d588$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $51861dfc7ca9d588$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $51861dfc7ca9d588$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $51861dfc7ca9d588$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$51861dfc7ca9d588$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $51861dfc7ca9d588$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $51861dfc7ca9d588$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$51861dfc7ca9d588$var$Buffer.prototype.readUintLE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUintBE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint8 = $51861dfc7ca9d588$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$51861dfc7ca9d588$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$51861dfc7ca9d588$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, true, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, false, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, true, 52, 8);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, false, 52, 8);
};
function $51861dfc7ca9d588$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$51861dfc7ca9d588$var$Buffer.prototype.writeUintLE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUintBE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint8 = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $51861dfc7ca9d588$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $51861dfc7ca9d588$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $51861dfc7ca9d588$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, false, noAssert);
};
function $51861dfc7ca9d588$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$51861dfc7ca9d588$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$51861dfc7ca9d588$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $51861dfc7ca9d588$var$Buffer.isBuffer(val) ? val : $51861dfc7ca9d588$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $51861dfc7ca9d588$var$errors = {};
function $51861dfc7ca9d588$var$E(sym, getMessage, Base) {
    $51861dfc7ca9d588$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$51861dfc7ca9d588$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$51861dfc7ca9d588$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$51861dfc7ca9d588$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $51861dfc7ca9d588$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $51861dfc7ca9d588$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $51861dfc7ca9d588$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength) {
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $51861dfc7ca9d588$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength);
}
function $51861dfc7ca9d588$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $51861dfc7ca9d588$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $51861dfc7ca9d588$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $51861dfc7ca9d588$var$validateNumber(value, type);
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $51861dfc7ca9d588$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $51861dfc7ca9d588$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $51861dfc7ca9d588$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($51861dfc7ca9d588$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $51861dfc7ca9d588$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $51861dfc7ca9d588$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $51861dfc7ca9d588$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $51861dfc7ca9d588$var$base64ToBytes(str) {
    return $kuxul.toByteArray($51861dfc7ca9d588$var$base64clean(str));
}
function $51861dfc7ca9d588$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $51861dfc7ca9d588$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $51861dfc7ca9d588$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $51861dfc7ca9d588$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $51861dfc7ca9d588$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $51861dfc7ca9d588$var$BufferBigIntNotDefined : fn;
}
function $51861dfc7ca9d588$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}

});
parcelRegister("kuxul", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $eeb0961446aae8e3$export$d622b2ad8d90c771, (v) => $eeb0961446aae8e3$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $eeb0961446aae8e3$export$6100ba28696e12de, (v) => $eeb0961446aae8e3$export$6100ba28696e12de = v);
var $eeb0961446aae8e3$export$a48f0734ac7c2329;
var $eeb0961446aae8e3$export$d622b2ad8d90c771;
var $eeb0961446aae8e3$export$6100ba28696e12de;
"use strict";
$eeb0961446aae8e3$export$a48f0734ac7c2329 = $eeb0961446aae8e3$var$byteLength;
$eeb0961446aae8e3$export$d622b2ad8d90c771 = $eeb0961446aae8e3$var$toByteArray;
$eeb0961446aae8e3$export$6100ba28696e12de = $eeb0961446aae8e3$var$fromByteArray;
var $eeb0961446aae8e3$var$lookup = [];
var $eeb0961446aae8e3$var$revLookup = [];
var $eeb0961446aae8e3$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $eeb0961446aae8e3$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $eeb0961446aae8e3$var$i = 0, $eeb0961446aae8e3$var$len = $eeb0961446aae8e3$var$code.length; $eeb0961446aae8e3$var$i < $eeb0961446aae8e3$var$len; ++$eeb0961446aae8e3$var$i){
    $eeb0961446aae8e3$var$lookup[$eeb0961446aae8e3$var$i] = $eeb0961446aae8e3$var$code[$eeb0961446aae8e3$var$i];
    $eeb0961446aae8e3$var$revLookup[$eeb0961446aae8e3$var$code.charCodeAt($eeb0961446aae8e3$var$i)] = $eeb0961446aae8e3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$eeb0961446aae8e3$var$revLookup["-".charCodeAt(0)] = 62;
$eeb0961446aae8e3$var$revLookup["_".charCodeAt(0)] = 63;
function $eeb0961446aae8e3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $eeb0961446aae8e3$var$byteLength(b64) {
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$toByteArray(b64) {
    var tmp;
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $eeb0961446aae8e3$var$Arr($eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 18 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 2 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 10 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $eeb0961446aae8e3$var$tripletToBase64(num) {
    return $eeb0961446aae8e3$var$lookup[num >> 18 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 12 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 6 & 0x3F] + $eeb0961446aae8e3$var$lookup[num & 0x3F];
}
function $eeb0961446aae8e3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($eeb0961446aae8e3$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $eeb0961446aae8e3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($eeb0961446aae8e3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 2] + $eeb0961446aae8e3$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 10] + $eeb0961446aae8e3$var$lookup[tmp >> 4 & 0x3F] + $eeb0961446aae8e3$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}

});

parcelRegister("9NvM5", function(module, exports) {

$parcel$export(module.exports, "read", () => $7221566bd4d49f44$export$aafa59e2e03f2942, (v) => $7221566bd4d49f44$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $7221566bd4d49f44$export$68d8715fc104d294, (v) => $7221566bd4d49f44$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $7221566bd4d49f44$export$aafa59e2e03f2942;
var $7221566bd4d49f44$export$68d8715fc104d294;
$7221566bd4d49f44$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$7221566bd4d49f44$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});



parcelRegister("5DzVE", function(module, exports) {

$parcel$export(module.exports, "TraceMap", () => $292c72ead4c7c1eb$export$6fc8edf86512ec85);
$parcel$export(module.exports, "decodedMappings", () => $292c72ead4c7c1eb$export$ecd113d4f34af700);
$parcel$export(module.exports, "traceSegment", () => $292c72ead4c7c1eb$export$6d863e58cd035563);
$parcel$export(module.exports, "originalPositionFor", () => $292c72ead4c7c1eb$export$56d62ac80d274c78);

var $6FvOA = parcelRequire("6FvOA");

var $edVDP = parcelRequire("edVDP");
function $292c72ead4c7c1eb$var$resolve(input, base) {
    // The base is always treated as a directory, if it's not empty.
    // https://github.com/mozilla/source-map/blob/8cb3ee57/lib/util.js#L327
    // https://github.com/chromium/chromium/blob/da4adbb3/third_party/blink/renderer/devtools/front_end/sdk/SourceMap.js#L400-L401
    if (base && !base.endsWith("/")) base += "/";
    return (0, $edVDP.default)(input, base);
}
/**
 * Removes everything after the last "/", but leaves the slash.
 */ function $292c72ead4c7c1eb$var$stripFilename(path) {
    if (!path) return "";
    const index = path.lastIndexOf("/");
    return path.slice(0, index + 1);
}
const $292c72ead4c7c1eb$var$COLUMN = 0;
const $292c72ead4c7c1eb$var$SOURCES_INDEX = 1;
const $292c72ead4c7c1eb$var$SOURCE_LINE = 2;
const $292c72ead4c7c1eb$var$SOURCE_COLUMN = 3;
const $292c72ead4c7c1eb$var$NAMES_INDEX = 4;
const $292c72ead4c7c1eb$var$REV_GENERATED_LINE = 1;
const $292c72ead4c7c1eb$var$REV_GENERATED_COLUMN = 2;
function $292c72ead4c7c1eb$var$maybeSort(mappings, owned) {
    const unsortedIndex = $292c72ead4c7c1eb$var$nextUnsortedSegmentLine(mappings, 0);
    if (unsortedIndex === mappings.length) return mappings;
    // If we own the array (meaning we parsed it from JSON), then we're free to directly mutate it. If
    // not, we do not want to modify the consumer's input array.
    if (!owned) mappings = mappings.slice();
    for(let i = unsortedIndex; i < mappings.length; i = $292c72ead4c7c1eb$var$nextUnsortedSegmentLine(mappings, i + 1))mappings[i] = $292c72ead4c7c1eb$var$sortSegments(mappings[i], owned);
    return mappings;
}
function $292c72ead4c7c1eb$var$nextUnsortedSegmentLine(mappings, start) {
    for(let i = start; i < mappings.length; i++){
        if (!$292c72ead4c7c1eb$var$isSorted(mappings[i])) return i;
    }
    return mappings.length;
}
function $292c72ead4c7c1eb$var$isSorted(line) {
    for(let j = 1; j < line.length; j++){
        if (line[j][$292c72ead4c7c1eb$var$COLUMN] < line[j - 1][$292c72ead4c7c1eb$var$COLUMN]) return false;
    }
    return true;
}
function $292c72ead4c7c1eb$var$sortSegments(line, owned) {
    if (!owned) line = line.slice();
    return line.sort($292c72ead4c7c1eb$var$sortComparator);
}
function $292c72ead4c7c1eb$var$sortComparator(a, b) {
    return a[$292c72ead4c7c1eb$var$COLUMN] - b[$292c72ead4c7c1eb$var$COLUMN];
}
let $292c72ead4c7c1eb$var$found = false;
/**
 * A binary search implementation that returns the index if a match is found.
 * If no match is found, then the left-index (the index associated with the item that comes just
 * before the desired index) is returned. To maintain proper sort order, a splice would happen at
 * the next index:
 *
 * ```js
 * const array = [1, 3];
 * const needle = 2;
 * const index = binarySearch(array, needle, (item, needle) => item - needle);
 *
 * assert.equal(index, 0);
 * array.splice(index + 1, 0, needle);
 * assert.deepEqual(array, [1, 2, 3]);
 * ```
 */ function $292c72ead4c7c1eb$var$binarySearch(haystack, needle, low, high) {
    while(low <= high){
        const mid = low + (high - low >> 1);
        const cmp = haystack[mid][$292c72ead4c7c1eb$var$COLUMN] - needle;
        if (cmp === 0) {
            $292c72ead4c7c1eb$var$found = true;
            return mid;
        }
        if (cmp < 0) low = mid + 1;
        else high = mid - 1;
    }
    $292c72ead4c7c1eb$var$found = false;
    return low - 1;
}
function $292c72ead4c7c1eb$var$upperBound(haystack, needle, index) {
    for(let i = index + 1; i < haystack.length; index = i++){
        if (haystack[i][$292c72ead4c7c1eb$var$COLUMN] !== needle) break;
    }
    return index;
}
function $292c72ead4c7c1eb$var$lowerBound(haystack, needle, index) {
    for(let i = index - 1; i >= 0; index = i--){
        if (haystack[i][$292c72ead4c7c1eb$var$COLUMN] !== needle) break;
    }
    return index;
}
function $292c72ead4c7c1eb$var$memoizedState() {
    return {
        lastKey: -1,
        lastNeedle: -1,
        lastIndex: -1
    };
}
/**
 * This overly complicated beast is just to record the last tested line/column and the resulting
 * index, allowing us to skip a few tests if mappings are monotonically increasing.
 */ function $292c72ead4c7c1eb$var$memoizedBinarySearch(haystack, needle, state, key) {
    const { lastKey: lastKey, lastNeedle: lastNeedle, lastIndex: lastIndex } = state;
    let low = 0;
    let high = haystack.length - 1;
    if (key === lastKey) {
        if (needle === lastNeedle) {
            $292c72ead4c7c1eb$var$found = lastIndex !== -1 && haystack[lastIndex][$292c72ead4c7c1eb$var$COLUMN] === needle;
            return lastIndex;
        }
        if (needle >= lastNeedle) // lastIndex may be -1 if the previous needle was not found.
        low = lastIndex === -1 ? 0 : lastIndex;
        else high = lastIndex;
    }
    state.lastKey = key;
    state.lastNeedle = needle;
    return state.lastIndex = $292c72ead4c7c1eb$var$binarySearch(haystack, needle, low, high);
}
// Rebuilds the original source files, with mappings that are ordered by source line/column instead
// of generated line/column.
function $292c72ead4c7c1eb$var$buildBySources(decoded, memos) {
    const sources = memos.map($292c72ead4c7c1eb$var$buildNullArray);
    for(let i = 0; i < decoded.length; i++){
        const line = decoded[i];
        for(let j = 0; j < line.length; j++){
            const seg = line[j];
            if (seg.length === 1) continue;
            const sourceIndex = seg[$292c72ead4c7c1eb$var$SOURCES_INDEX];
            const sourceLine = seg[$292c72ead4c7c1eb$var$SOURCE_LINE];
            const sourceColumn = seg[$292c72ead4c7c1eb$var$SOURCE_COLUMN];
            const originalSource = sources[sourceIndex];
            const originalLine = originalSource[sourceLine] || (originalSource[sourceLine] = []);
            const memo = memos[sourceIndex];
            // The binary search either found a match, or it found the left-index just before where the
            // segment should go. Either way, we want to insert after that. And there may be multiple
            // generated segments associated with an original location, so there may need to move several
            // indexes before we find where we need to insert.
            let index = $292c72ead4c7c1eb$var$upperBound(originalLine, sourceColumn, $292c72ead4c7c1eb$var$memoizedBinarySearch(originalLine, sourceColumn, memo, sourceLine));
            memo.lastIndex = ++index;
            $292c72ead4c7c1eb$var$insert(originalLine, index, [
                sourceColumn,
                i,
                seg[$292c72ead4c7c1eb$var$COLUMN]
            ]);
        }
    }
    return sources;
}
function $292c72ead4c7c1eb$var$insert(array, index, value) {
    for(let i = array.length; i > index; i--)array[i] = array[i - 1];
    array[index] = value;
}
// Null arrays allow us to use ordered index keys without actually allocating contiguous memory like
// a real array. We use a null-prototype object to avoid prototype pollution and deoptimizations.
// Numeric properties on objects are magically sorted in ascending order by the engine regardless of
// the insertion order. So, by setting any numeric keys, even out of order, we'll get ascending
// order when iterating with for-in.
function $292c72ead4c7c1eb$var$buildNullArray() {
    return {
        __proto__: null
    };
}
const $292c72ead4c7c1eb$export$cfb1ea40164567c5 = function(map, mapUrl) {
    const parsed = $292c72ead4c7c1eb$var$parse(map);
    if (!("sections" in parsed)) return new $292c72ead4c7c1eb$export$6fc8edf86512ec85(parsed, mapUrl);
    const mappings = [];
    const sources = [];
    const sourcesContent = [];
    const names = [];
    const ignoreList = [];
    $292c72ead4c7c1eb$var$recurse(parsed, mapUrl, mappings, sources, sourcesContent, names, ignoreList, 0, 0, Infinity, Infinity);
    const joined = {
        version: 3,
        file: parsed.file,
        names: names,
        sources: sources,
        sourcesContent: sourcesContent,
        mappings: mappings,
        ignoreList: ignoreList
    };
    return $292c72ead4c7c1eb$export$20ee0c4a5619bf3d(joined);
};
function $292c72ead4c7c1eb$var$parse(map) {
    return typeof map === "string" ? JSON.parse(map) : map;
}
function $292c72ead4c7c1eb$var$recurse(input, mapUrl, mappings, sources, sourcesContent, names, ignoreList, lineOffset, columnOffset, stopLine, stopColumn) {
    const { sections: sections } = input;
    for(let i = 0; i < sections.length; i++){
        const { map: map, offset: offset } = sections[i];
        let sl = stopLine;
        let sc = stopColumn;
        if (i + 1 < sections.length) {
            const nextOffset = sections[i + 1].offset;
            sl = Math.min(stopLine, lineOffset + nextOffset.line);
            if (sl === stopLine) sc = Math.min(stopColumn, columnOffset + nextOffset.column);
            else if (sl < stopLine) sc = columnOffset + nextOffset.column;
        }
        $292c72ead4c7c1eb$var$addSection(map, mapUrl, mappings, sources, sourcesContent, names, ignoreList, lineOffset + offset.line, columnOffset + offset.column, sl, sc);
    }
}
function $292c72ead4c7c1eb$var$addSection(input, mapUrl, mappings, sources, sourcesContent, names, ignoreList, lineOffset, columnOffset, stopLine, stopColumn) {
    const parsed = $292c72ead4c7c1eb$var$parse(input);
    if ("sections" in parsed) return $292c72ead4c7c1eb$var$recurse(...arguments);
    const map = new $292c72ead4c7c1eb$export$6fc8edf86512ec85(parsed, mapUrl);
    const sourcesOffset = sources.length;
    const namesOffset = names.length;
    const decoded = $292c72ead4c7c1eb$export$ecd113d4f34af700(map);
    const { resolvedSources: resolvedSources, sourcesContent: contents, ignoreList: ignores } = map;
    $292c72ead4c7c1eb$var$append(sources, resolvedSources);
    $292c72ead4c7c1eb$var$append(names, map.names);
    if (contents) $292c72ead4c7c1eb$var$append(sourcesContent, contents);
    else for(let i = 0; i < resolvedSources.length; i++)sourcesContent.push(null);
    if (ignores) for(let i = 0; i < ignores.length; i++)ignoreList.push(ignores[i] + sourcesOffset);
    for(let i = 0; i < decoded.length; i++){
        const lineI = lineOffset + i;
        // We can only add so many lines before we step into the range that the next section's map
        // controls. When we get to the last line, then we'll start checking the segments to see if
        // they've crossed into the column range. But it may not have any columns that overstep, so we
        // still need to check that we don't overstep lines, too.
        if (lineI > stopLine) return;
        // The out line may already exist in mappings (if we're continuing the line started by a
        // previous section). Or, we may have jumped ahead several lines to start this section.
        const out = $292c72ead4c7c1eb$var$getLine(mappings, lineI);
        // On the 0th loop, the section's column offset shifts us forward. On all other lines (since the
        // map can be multiple lines), it doesn't.
        const cOffset = i === 0 ? columnOffset : 0;
        const line = decoded[i];
        for(let j = 0; j < line.length; j++){
            const seg = line[j];
            const column = cOffset + seg[$292c72ead4c7c1eb$var$COLUMN];
            // If this segment steps into the column range that the next section's map controls, we need
            // to stop early.
            if (lineI === stopLine && column >= stopColumn) return;
            if (seg.length === 1) {
                out.push([
                    column
                ]);
                continue;
            }
            const sourcesIndex = sourcesOffset + seg[$292c72ead4c7c1eb$var$SOURCES_INDEX];
            const sourceLine = seg[$292c72ead4c7c1eb$var$SOURCE_LINE];
            const sourceColumn = seg[$292c72ead4c7c1eb$var$SOURCE_COLUMN];
            out.push(seg.length === 4 ? [
                column,
                sourcesIndex,
                sourceLine,
                sourceColumn
            ] : [
                column,
                sourcesIndex,
                sourceLine,
                sourceColumn,
                namesOffset + seg[$292c72ead4c7c1eb$var$NAMES_INDEX]
            ]);
        }
    }
}
function $292c72ead4c7c1eb$var$append(arr, other) {
    for(let i = 0; i < other.length; i++)arr.push(other[i]);
}
function $292c72ead4c7c1eb$var$getLine(arr, index) {
    for(let i = arr.length; i <= index; i++)arr[i] = [];
    return arr[index];
}
const $292c72ead4c7c1eb$var$LINE_GTR_ZERO = "`line` must be greater than 0 (lines start at line 1)";
const $292c72ead4c7c1eb$var$COL_GTR_EQ_ZERO = "`column` must be greater than or equal to 0 (columns start at column 0)";
const $292c72ead4c7c1eb$export$b99fbecff261243 = -1;
const $292c72ead4c7c1eb$export$4ecd616dce182dff = 1;
class $292c72ead4c7c1eb$export$6fc8edf86512ec85 {
    constructor(map, mapUrl){
        const isString = typeof map === "string";
        if (!isString && map._decodedMemo) return map;
        const parsed = isString ? JSON.parse(map) : map;
        const { version: version, file: file, names: names, sourceRoot: sourceRoot, sources: sources, sourcesContent: sourcesContent } = parsed;
        this.version = version;
        this.file = file;
        this.names = names || [];
        this.sourceRoot = sourceRoot;
        this.sources = sources;
        this.sourcesContent = sourcesContent;
        this.ignoreList = parsed.ignoreList || parsed.x_google_ignoreList || undefined;
        const from = $292c72ead4c7c1eb$var$resolve(sourceRoot || "", $292c72ead4c7c1eb$var$stripFilename(mapUrl));
        this.resolvedSources = sources.map((s)=>$292c72ead4c7c1eb$var$resolve(s || "", from));
        const { mappings: mappings } = parsed;
        if (typeof mappings === "string") {
            this._encoded = mappings;
            this._decoded = undefined;
        } else {
            this._encoded = undefined;
            this._decoded = $292c72ead4c7c1eb$var$maybeSort(mappings, isString);
        }
        this._decodedMemo = $292c72ead4c7c1eb$var$memoizedState();
        this._bySources = undefined;
        this._bySourceMemos = undefined;
    }
}
/**
 * Typescript doesn't allow friend access to private fields, so this just casts the map into a type
 * with public access modifiers.
 */ function $292c72ead4c7c1eb$var$cast(map) {
    return map;
}
/**
 * Returns the encoded (VLQ string) form of the SourceMap's mappings field.
 */ function $292c72ead4c7c1eb$export$59408758bba4b625(map) {
    var _a;
    var _b;
    return (_a = (_b = $292c72ead4c7c1eb$var$cast(map))._encoded) !== null && _a !== void 0 ? _a : _b._encoded = (0, $6FvOA.encode)($292c72ead4c7c1eb$var$cast(map)._decoded);
}
/**
 * Returns the decoded (array of lines of segments) form of the SourceMap's mappings field.
 */ function $292c72ead4c7c1eb$export$ecd113d4f34af700(map) {
    var _a;
    return (_a = $292c72ead4c7c1eb$var$cast(map))._decoded || (_a._decoded = (0, $6FvOA.decode)($292c72ead4c7c1eb$var$cast(map)._encoded));
}
/**
 * A low-level API to find the segment associated with a generated line/column (think, from a
 * stack trace). Line and column here are 0-based, unlike `originalPositionFor`.
 */ function $292c72ead4c7c1eb$export$6d863e58cd035563(map, line, column) {
    const decoded = $292c72ead4c7c1eb$export$ecd113d4f34af700(map);
    // It's common for parent source maps to have pointers to lines that have no
    // mapping (like a "//# sourceMappingURL=") at the end of the child file.
    if (line >= decoded.length) return null;
    const segments = decoded[line];
    const index = $292c72ead4c7c1eb$var$traceSegmentInternal(segments, $292c72ead4c7c1eb$var$cast(map)._decodedMemo, line, column, $292c72ead4c7c1eb$export$4ecd616dce182dff);
    return index === -1 ? null : segments[index];
}
/**
 * A higher-level API to find the source/line/column associated with a generated line/column
 * (think, from a stack trace). Line is 1-based, but column is 0-based, due to legacy behavior in
 * `source-map` library.
 */ function $292c72ead4c7c1eb$export$56d62ac80d274c78(map, needle) {
    let { line: line, column: column, bias: bias } = needle;
    line--;
    if (line < 0) throw new Error($292c72ead4c7c1eb$var$LINE_GTR_ZERO);
    if (column < 0) throw new Error($292c72ead4c7c1eb$var$COL_GTR_EQ_ZERO);
    const decoded = $292c72ead4c7c1eb$export$ecd113d4f34af700(map);
    // It's common for parent source maps to have pointers to lines that have no
    // mapping (like a "//# sourceMappingURL=") at the end of the child file.
    if (line >= decoded.length) return $292c72ead4c7c1eb$var$OMapping(null, null, null, null);
    const segments = decoded[line];
    const index = $292c72ead4c7c1eb$var$traceSegmentInternal(segments, $292c72ead4c7c1eb$var$cast(map)._decodedMemo, line, column, bias || $292c72ead4c7c1eb$export$4ecd616dce182dff);
    if (index === -1) return $292c72ead4c7c1eb$var$OMapping(null, null, null, null);
    const segment = segments[index];
    if (segment.length === 1) return $292c72ead4c7c1eb$var$OMapping(null, null, null, null);
    const { names: names, resolvedSources: resolvedSources } = map;
    return $292c72ead4c7c1eb$var$OMapping(resolvedSources[segment[$292c72ead4c7c1eb$var$SOURCES_INDEX]], segment[$292c72ead4c7c1eb$var$SOURCE_LINE] + 1, segment[$292c72ead4c7c1eb$var$SOURCE_COLUMN], segment.length === 5 ? names[segment[$292c72ead4c7c1eb$var$NAMES_INDEX]] : null);
}
/**
 * Finds the generated line/column position of the provided source/line/column source position.
 */ function $292c72ead4c7c1eb$export$5bf80d5312a8ff17(map, needle) {
    const { source: source, line: line, column: column, bias: bias } = needle;
    return $292c72ead4c7c1eb$var$generatedPosition(map, source, line, column, bias || $292c72ead4c7c1eb$export$4ecd616dce182dff, false);
}
/**
 * Finds all generated line/column positions of the provided source/line/column source position.
 */ function $292c72ead4c7c1eb$export$69d37f329d319dca(map, needle) {
    const { source: source, line: line, column: column, bias: bias } = needle;
    // SourceMapConsumer uses LEAST_UPPER_BOUND for some reason, so we follow suit.
    return $292c72ead4c7c1eb$var$generatedPosition(map, source, line, column, bias || $292c72ead4c7c1eb$export$b99fbecff261243, true);
}
/**
 * Iterates each mapping in generated position order.
 */ function $292c72ead4c7c1eb$export$78c99866f56beaa4(map, cb) {
    const decoded = $292c72ead4c7c1eb$export$ecd113d4f34af700(map);
    const { names: names, resolvedSources: resolvedSources } = map;
    for(let i = 0; i < decoded.length; i++){
        const line = decoded[i];
        for(let j = 0; j < line.length; j++){
            const seg = line[j];
            const generatedLine = i + 1;
            const generatedColumn = seg[0];
            let source = null;
            let originalLine = null;
            let originalColumn = null;
            let name = null;
            if (seg.length !== 1) {
                source = resolvedSources[seg[1]];
                originalLine = seg[2] + 1;
                originalColumn = seg[3];
            }
            if (seg.length === 5) name = names[seg[4]];
            cb({
                generatedLine: generatedLine,
                generatedColumn: generatedColumn,
                source: source,
                originalLine: originalLine,
                originalColumn: originalColumn,
                name: name
            });
        }
    }
}
function $292c72ead4c7c1eb$var$sourceIndex(map, source) {
    const { sources: sources, resolvedSources: resolvedSources } = map;
    let index = sources.indexOf(source);
    if (index === -1) index = resolvedSources.indexOf(source);
    return index;
}
/**
 * Retrieves the source content for a particular source, if its found. Returns null if not.
 */ function $292c72ead4c7c1eb$export$a685fd8184719fc9(map, source) {
    const { sourcesContent: sourcesContent } = map;
    if (sourcesContent == null) return null;
    const index = $292c72ead4c7c1eb$var$sourceIndex(map, source);
    return index === -1 ? null : sourcesContent[index];
}
/**
 * Determines if the source is marked to ignore by the source map.
 */ function $292c72ead4c7c1eb$export$ac3f691269cd6d9b(map, source) {
    const { ignoreList: ignoreList } = map;
    if (ignoreList == null) return false;
    const index = $292c72ead4c7c1eb$var$sourceIndex(map, source);
    return index === -1 ? false : ignoreList.includes(index);
}
/**
 * A helper that skips sorting of the input map's mappings array, which can be expensive for larger
 * maps.
 */ function $292c72ead4c7c1eb$export$20ee0c4a5619bf3d(map, mapUrl) {
    const tracer = new $292c72ead4c7c1eb$export$6fc8edf86512ec85($292c72ead4c7c1eb$var$clone(map, []), mapUrl);
    $292c72ead4c7c1eb$var$cast(tracer)._decoded = map.mappings;
    return tracer;
}
/**
 * Returns a sourcemap object (with decoded mappings) suitable for passing to a library that expects
 * a sourcemap, or to JSON.stringify.
 */ function $292c72ead4c7c1eb$export$f6477d963c19e792(map) {
    return $292c72ead4c7c1eb$var$clone(map, $292c72ead4c7c1eb$export$ecd113d4f34af700(map));
}
/**
 * Returns a sourcemap object (with encoded mappings) suitable for passing to a library that expects
 * a sourcemap, or to JSON.stringify.
 */ function $292c72ead4c7c1eb$export$f859692979919a94(map) {
    return $292c72ead4c7c1eb$var$clone(map, $292c72ead4c7c1eb$export$59408758bba4b625(map));
}
function $292c72ead4c7c1eb$var$clone(map, mappings) {
    return {
        version: map.version,
        file: map.file,
        names: map.names,
        sourceRoot: map.sourceRoot,
        sources: map.sources,
        sourcesContent: map.sourcesContent,
        mappings: mappings,
        ignoreList: map.ignoreList || map.x_google_ignoreList
    };
}
function $292c72ead4c7c1eb$var$OMapping(source, line, column, name) {
    return {
        source: source,
        line: line,
        column: column,
        name: name
    };
}
function $292c72ead4c7c1eb$var$GMapping(line, column) {
    return {
        line: line,
        column: column
    };
}
function $292c72ead4c7c1eb$var$traceSegmentInternal(segments, memo, line, column, bias) {
    let index = $292c72ead4c7c1eb$var$memoizedBinarySearch(segments, column, memo, line);
    if ($292c72ead4c7c1eb$var$found) index = (bias === $292c72ead4c7c1eb$export$b99fbecff261243 ? $292c72ead4c7c1eb$var$upperBound : $292c72ead4c7c1eb$var$lowerBound)(segments, column, index);
    else if (bias === $292c72ead4c7c1eb$export$b99fbecff261243) index++;
    if (index === -1 || index === segments.length) return -1;
    return index;
}
function $292c72ead4c7c1eb$var$sliceGeneratedPositions(segments, memo, line, column, bias) {
    let min = $292c72ead4c7c1eb$var$traceSegmentInternal(segments, memo, line, column, $292c72ead4c7c1eb$export$4ecd616dce182dff);
    // We ignored the bias when tracing the segment so that we're guarnateed to find the first (in
    // insertion order) segment that matched. Even if we did respect the bias when tracing, we would
    // still need to call `lowerBound()` to find the first segment, which is slower than just looking
    // for the GREATEST_LOWER_BOUND to begin with. The only difference that matters for us is when the
    // binary search didn't match, in which case GREATEST_LOWER_BOUND just needs to increment to
    // match LEAST_UPPER_BOUND.
    if (!$292c72ead4c7c1eb$var$found && bias === $292c72ead4c7c1eb$export$b99fbecff261243) min++;
    if (min === -1 || min === segments.length) return [];
    // We may have found the segment that started at an earlier column. If this is the case, then we
    // need to slice all generated segments that match _that_ column, because all such segments span
    // to our desired column.
    const matchedColumn = $292c72ead4c7c1eb$var$found ? column : segments[min][$292c72ead4c7c1eb$var$COLUMN];
    // The binary search is not guaranteed to find the lower bound when a match wasn't found.
    if (!$292c72ead4c7c1eb$var$found) min = $292c72ead4c7c1eb$var$lowerBound(segments, matchedColumn, min);
    const max = $292c72ead4c7c1eb$var$upperBound(segments, matchedColumn, min);
    const result = [];
    for(; min <= max; min++){
        const segment = segments[min];
        result.push($292c72ead4c7c1eb$var$GMapping(segment[$292c72ead4c7c1eb$var$REV_GENERATED_LINE] + 1, segment[$292c72ead4c7c1eb$var$REV_GENERATED_COLUMN]));
    }
    return result;
}
function $292c72ead4c7c1eb$var$generatedPosition(map, source, line, column, bias, all) {
    var _a;
    line--;
    if (line < 0) throw new Error($292c72ead4c7c1eb$var$LINE_GTR_ZERO);
    if (column < 0) throw new Error($292c72ead4c7c1eb$var$COL_GTR_EQ_ZERO);
    const { sources: sources, resolvedSources: resolvedSources } = map;
    let sourceIndex = sources.indexOf(source);
    if (sourceIndex === -1) sourceIndex = resolvedSources.indexOf(source);
    if (sourceIndex === -1) return all ? [] : $292c72ead4c7c1eb$var$GMapping(null, null);
    const generated = (_a = $292c72ead4c7c1eb$var$cast(map))._bySources || (_a._bySources = $292c72ead4c7c1eb$var$buildBySources($292c72ead4c7c1eb$export$ecd113d4f34af700(map), $292c72ead4c7c1eb$var$cast(map)._bySourceMemos = sources.map($292c72ead4c7c1eb$var$memoizedState)));
    const segments = generated[sourceIndex][line];
    if (segments == null) return all ? [] : $292c72ead4c7c1eb$var$GMapping(null, null);
    const memo = $292c72ead4c7c1eb$var$cast(map)._bySourceMemos[sourceIndex];
    if (all) return $292c72ead4c7c1eb$var$sliceGeneratedPositions(segments, memo, line, column, bias);
    const index = $292c72ead4c7c1eb$var$traceSegmentInternal(segments, memo, line, column, bias);
    if (index === -1) return $292c72ead4c7c1eb$var$GMapping(null, null);
    const segment = segments[index];
    return $292c72ead4c7c1eb$var$GMapping(segment[$292c72ead4c7c1eb$var$REV_GENERATED_LINE] + 1, segment[$292c72ead4c7c1eb$var$REV_GENERATED_COLUMN]);
}

});
parcelRegister("edVDP", function(module, exports) {

$parcel$export(module.exports, "default", () => $eda583aa08458a84$export$2e2bcd8739ae039);
// Matches the scheme of a URL, eg "http://"
const $eda583aa08458a84$var$schemeRegex = /^[\w+.-]+:\/\//;
/**
 * Matches the parts of a URL:
 * 1. Scheme, including ":", guaranteed.
 * 2. User/password, including "@", optional.
 * 3. Host, guaranteed.
 * 4. Port, including ":", optional.
 * 5. Path, including "/", optional.
 * 6. Query, including "?", optional.
 * 7. Hash, including "#", optional.
 */ const $eda583aa08458a84$var$urlRegex = /^([\w+.-]+:)\/\/([^@/#?]*@)?([^:/#?]*)(:\d+)?(\/[^#?]*)?(\?[^#]*)?(#.*)?/;
/**
 * File URLs are weird. They dont' need the regular `//` in the scheme, they may or may not start
 * with a leading `/`, they can have a domain (but only if they don't start with a Windows drive).
 *
 * 1. Host, optional.
 * 2. Path, which may include "/", guaranteed.
 * 3. Query, including "?", optional.
 * 4. Hash, including "#", optional.
 */ const $eda583aa08458a84$var$fileRegex = /^file:(?:\/\/((?![a-z]:)[^/#?]*)?)?(\/?[^#?]*)(\?[^#]*)?(#.*)?/i;
function $eda583aa08458a84$var$isAbsoluteUrl(input) {
    return $eda583aa08458a84$var$schemeRegex.test(input);
}
function $eda583aa08458a84$var$isSchemeRelativeUrl(input) {
    return input.startsWith("//");
}
function $eda583aa08458a84$var$isAbsolutePath(input) {
    return input.startsWith("/");
}
function $eda583aa08458a84$var$isFileUrl(input) {
    return input.startsWith("file:");
}
function $eda583aa08458a84$var$isRelative(input) {
    return /^[.?#]/.test(input);
}
function $eda583aa08458a84$var$parseAbsoluteUrl(input) {
    const match = $eda583aa08458a84$var$urlRegex.exec(input);
    return $eda583aa08458a84$var$makeUrl(match[1], match[2] || "", match[3], match[4] || "", match[5] || "/", match[6] || "", match[7] || "");
}
function $eda583aa08458a84$var$parseFileUrl(input) {
    const match = $eda583aa08458a84$var$fileRegex.exec(input);
    const path = match[2];
    return $eda583aa08458a84$var$makeUrl("file:", "", match[1] || "", "", $eda583aa08458a84$var$isAbsolutePath(path) ? path : "/" + path, match[3] || "", match[4] || "");
}
function $eda583aa08458a84$var$makeUrl(scheme, user, host, port, path, query, hash) {
    return {
        scheme: scheme,
        user: user,
        host: host,
        port: port,
        path: path,
        query: query,
        hash: hash,
        type: 7 /* Absolute */ 
    };
}
function $eda583aa08458a84$var$parseUrl(input) {
    if ($eda583aa08458a84$var$isSchemeRelativeUrl(input)) {
        const url = $eda583aa08458a84$var$parseAbsoluteUrl("http:" + input);
        url.scheme = "";
        url.type = 6 /* SchemeRelative */ ;
        return url;
    }
    if ($eda583aa08458a84$var$isAbsolutePath(input)) {
        const url = $eda583aa08458a84$var$parseAbsoluteUrl("http://foo.com" + input);
        url.scheme = "";
        url.host = "";
        url.type = 5 /* AbsolutePath */ ;
        return url;
    }
    if ($eda583aa08458a84$var$isFileUrl(input)) return $eda583aa08458a84$var$parseFileUrl(input);
    if ($eda583aa08458a84$var$isAbsoluteUrl(input)) return $eda583aa08458a84$var$parseAbsoluteUrl(input);
    const url = $eda583aa08458a84$var$parseAbsoluteUrl("http://foo.com/" + input);
    url.scheme = "";
    url.host = "";
    url.type = input ? input.startsWith("?") ? 3 /* Query */  : input.startsWith("#") ? 2 /* Hash */  : 4 /* RelativePath */  : 1 /* Empty */ ;
    return url;
}
function $eda583aa08458a84$var$stripPathFilename(path) {
    // If a path ends with a parent directory "..", then it's a relative path with excess parent
    // paths. It's not a file, so we can't strip it.
    if (path.endsWith("/..")) return path;
    const index = path.lastIndexOf("/");
    return path.slice(0, index + 1);
}
function $eda583aa08458a84$var$mergePaths(url, base) {
    $eda583aa08458a84$var$normalizePath(base, base.type);
    // If the path is just a "/", then it was an empty path to begin with (remember, we're a relative
    // path).
    if (url.path === "/") url.path = base.path;
    else // Resolution happens relative to the base path's directory, not the file.
    url.path = $eda583aa08458a84$var$stripPathFilename(base.path) + url.path;
}
/**
 * The path can have empty directories "//", unneeded parents "foo/..", or current directory
 * "foo/.". We need to normalize to a standard representation.
 */ function $eda583aa08458a84$var$normalizePath(url, type) {
    const rel = type <= 4 /* RelativePath */ ;
    const pieces = url.path.split("/");
    // We need to preserve the first piece always, so that we output a leading slash. The item at
    // pieces[0] is an empty string.
    let pointer = 1;
    // Positive is the number of real directories we've output, used for popping a parent directory.
    // Eg, "foo/bar/.." will have a positive 2, and we can decrement to be left with just "foo".
    let positive = 0;
    // We need to keep a trailing slash if we encounter an empty directory (eg, splitting "foo/" will
    // generate `["foo", ""]` pieces). And, if we pop a parent directory. But once we encounter a
    // real directory, we won't need to append, unless the other conditions happen again.
    let addTrailingSlash = false;
    for(let i = 1; i < pieces.length; i++){
        const piece = pieces[i];
        // An empty directory, could be a trailing slash, or just a double "//" in the path.
        if (!piece) {
            addTrailingSlash = true;
            continue;
        }
        // If we encounter a real directory, then we don't need to append anymore.
        addTrailingSlash = false;
        // A current directory, which we can always drop.
        if (piece === ".") continue;
        // A parent directory, we need to see if there are any real directories we can pop. Else, we
        // have an excess of parents, and we'll need to keep the "..".
        if (piece === "..") {
            if (positive) {
                addTrailingSlash = true;
                positive--;
                pointer--;
            } else if (rel) // If we're in a relativePath, then we need to keep the excess parents. Else, in an absolute
            // URL, protocol relative URL, or an absolute path, we don't need to keep excess.
            pieces[pointer++] = piece;
            continue;
        }
        // We've encountered a real directory. Move it to the next insertion pointer, which accounts for
        // any popped or dropped directories.
        pieces[pointer++] = piece;
        positive++;
    }
    let path = "";
    for(let i = 1; i < pointer; i++)path += "/" + pieces[i];
    if (!path || addTrailingSlash && !path.endsWith("/..")) path += "/";
    url.path = path;
}
/**
 * Attempts to resolve `input` URL/path relative to `base`.
 */ function $eda583aa08458a84$export$2e2bcd8739ae039(input, base) {
    if (!input && !base) return "";
    const url = $eda583aa08458a84$var$parseUrl(input);
    let inputType = url.type;
    if (base && inputType !== 7 /* Absolute */ ) {
        const baseUrl = $eda583aa08458a84$var$parseUrl(base);
        const baseType = baseUrl.type;
        switch(inputType){
            case 1 /* Empty */ :
                url.hash = baseUrl.hash;
            // fall through
            case 2 /* Hash */ :
                url.query = baseUrl.query;
            // fall through
            case 3 /* Query */ :
            case 4 /* RelativePath */ :
                $eda583aa08458a84$var$mergePaths(url, baseUrl);
            // fall through
            case 5 /* AbsolutePath */ :
                // The host, user, and port are joined, you can't copy one without the others.
                url.user = baseUrl.user;
                url.host = baseUrl.host;
                url.port = baseUrl.port;
            // fall through
            case 6 /* SchemeRelative */ :
                // The input doesn't have a schema at least, so we need to copy at least that over.
                url.scheme = baseUrl.scheme;
        }
        if (baseType > inputType) inputType = baseType;
    }
    $eda583aa08458a84$var$normalizePath(url, inputType);
    const queryHash = url.query + url.hash;
    switch(inputType){
        // This is impossible, because of the empty checks at the start of the function.
        // case UrlType.Empty:
        case 2 /* Hash */ :
        case 3 /* Query */ :
            return queryHash;
        case 4 /* RelativePath */ :
            {
                // The first char is always a "/", and we need it to be relative.
                const path = url.path.slice(1);
                if (!path) return queryHash || ".";
                if ($eda583aa08458a84$var$isRelative(base || input) && !$eda583aa08458a84$var$isRelative(path)) // If base started with a leading ".", or there is no base and input started with a ".",
                // then we need to ensure that the relative path starts with a ".". We don't know if
                // relative starts with a "..", though, so check before prepending.
                return "./" + path + queryHash;
                return path + queryHash;
            }
        case 5 /* AbsolutePath */ :
            return url.path + queryHash;
        default:
            return url.scheme + "//" + url.user + url.host + url.port + url.path + queryHash;
    }
}

});




parcelRegister("iUjdt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c1k0E = parcelRequire("c1k0E");

var $d5V7k = parcelRequire("d5V7k");

var $ardUq = parcelRequire("ardUq");

var $bGU9c = parcelRequire("bGU9c");
const { isFunction: $dc3c5ce6f3abbc7b$var$isFunction, isStatement: $dc3c5ce6f3abbc7b$var$isStatement, isClassBody: $dc3c5ce6f3abbc7b$var$isClassBody, isTSInterfaceBody: $dc3c5ce6f3abbc7b$var$isTSInterfaceBody, isTSEnumDeclaration: $dc3c5ce6f3abbc7b$var$isTSEnumDeclaration } = $ardUq;
const $dc3c5ce6f3abbc7b$var$SCIENTIFIC_NOTATION = /e/i;
const $dc3c5ce6f3abbc7b$var$ZERO_DECIMAL_INTEGER = /\.0+$/;
const $dc3c5ce6f3abbc7b$var$HAS_NEWLINE = /[\n\r\u2028\u2029]/;
const $dc3c5ce6f3abbc7b$var$HAS_NEWLINE_OR_BlOCK_COMMENT_END = /[\n\r\u2028\u2029]|\*\//;
const { needsParens: $dc3c5ce6f3abbc7b$var$needsParens } = $d5V7k;
class $dc3c5ce6f3abbc7b$var$Printer {
    constructor(format, map){
        this.inForStatementInitCounter = 0;
        this._printStack = [];
        this._indent = 0;
        this._indentRepeat = 0;
        this._insideAux = false;
        this._parenPushNewlineState = null;
        this._noLineTerminator = false;
        this._printAuxAfterOnNextUserNode = false;
        this._printedComments = new Set();
        this._endsWithInteger = false;
        this._endsWithWord = false;
        this._lastCommentLine = 0;
        this._endsWithInnerRaw = false;
        this._indentInnerComments = true;
        this.format = format;
        this._indentRepeat = format.indent.style.length;
        this._inputMap = map == null ? void 0 : map._inputMap;
        this._buf = new $c1k0E.default(map, format.indent.style[0]);
    }
    generate(ast) {
        this.print(ast);
        this._maybeAddAuxComment();
        return this._buf.get();
    }
    indent() {
        if (this.format.compact || this.format.concise) return;
        this._indent++;
    }
    dedent() {
        if (this.format.compact || this.format.concise) return;
        this._indent--;
    }
    semicolon(force = false) {
        this._maybeAddAuxComment();
        if (force) this._appendChar(59);
        else this._queue(59);
        this._noLineTerminator = false;
    }
    rightBrace(node) {
        if (this.format.minified) this._buf.removeLastSemicolon();
        this.sourceWithOffset("end", node.loc, -1);
        this.tokenChar(125);
    }
    rightParens(node) {
        this.sourceWithOffset("end", node.loc, -1);
        this.tokenChar(41);
    }
    space(force = false) {
        if (this.format.compact) return;
        if (force) this._space();
        else if (this._buf.hasContent()) {
            const lastCp = this.getLastChar();
            if (lastCp !== 32 && lastCp !== 10) this._space();
        }
    }
    word(str, noLineTerminatorAfter = false) {
        this._maybePrintInnerComments();
        if (this._endsWithWord || str.charCodeAt(0) === 47 && this.endsWith(47)) this._space();
        this._maybeAddAuxComment();
        this._append(str, false);
        this._endsWithWord = true;
        this._noLineTerminator = noLineTerminatorAfter;
    }
    number(str, number) {
        function isNonDecimalLiteral(str) {
            if (str.length > 2 && str.charCodeAt(0) === 48) {
                const secondChar = str.charCodeAt(1);
                return secondChar === 98 || secondChar === 111 || secondChar === 120;
            }
            return false;
        }
        this.word(str);
        this._endsWithInteger = Number.isInteger(number) && !isNonDecimalLiteral(str) && !$dc3c5ce6f3abbc7b$var$SCIENTIFIC_NOTATION.test(str) && !$dc3c5ce6f3abbc7b$var$ZERO_DECIMAL_INTEGER.test(str) && str.charCodeAt(str.length - 1) !== 46;
    }
    token(str, maybeNewline = false) {
        this._maybePrintInnerComments();
        const lastChar = this.getLastChar();
        const strFirst = str.charCodeAt(0);
        if (lastChar === 33 && (str === "--" || strFirst === 61) || strFirst === 43 && lastChar === 43 || strFirst === 45 && lastChar === 45 || strFirst === 46 && this._endsWithInteger) this._space();
        this._maybeAddAuxComment();
        this._append(str, maybeNewline);
        this._noLineTerminator = false;
    }
    tokenChar(char) {
        this._maybePrintInnerComments();
        const lastChar = this.getLastChar();
        if (char === 43 && lastChar === 43 || char === 45 && lastChar === 45 || char === 46 && this._endsWithInteger) this._space();
        this._maybeAddAuxComment();
        this._appendChar(char);
        this._noLineTerminator = false;
    }
    newline(i = 1, force) {
        if (i <= 0) return;
        if (!force) {
            if (this.format.retainLines || this.format.compact) return;
            if (this.format.concise) {
                this.space();
                return;
            }
        }
        if (i > 2) i = 2;
        i -= this._buf.getNewlineCount();
        for(let j = 0; j < i; j++)this._newline();
        return;
    }
    endsWith(char) {
        return this.getLastChar() === char;
    }
    getLastChar() {
        return this._buf.getLastChar();
    }
    endsWithCharAndNewline() {
        return this._buf.endsWithCharAndNewline();
    }
    removeTrailingNewline() {
        this._buf.removeTrailingNewline();
    }
    exactSource(loc, cb) {
        if (!loc) {
            cb();
            return;
        }
        this._catchUp("start", loc);
        this._buf.exactSource(loc, cb);
    }
    source(prop, loc) {
        if (!loc) return;
        this._catchUp(prop, loc);
        this._buf.source(prop, loc);
    }
    sourceWithOffset(prop, loc, columnOffset) {
        if (!loc) return;
        this._catchUp(prop, loc);
        this._buf.sourceWithOffset(prop, loc, columnOffset);
    }
    withSource(prop, loc, cb) {
        if (!loc) {
            cb();
            return;
        }
        this._catchUp(prop, loc);
        this._buf.withSource(prop, loc, cb);
    }
    sourceIdentifierName(identifierName, pos) {
        if (!this._buf._canMarkIdName) return;
        const sourcePosition = this._buf._sourcePosition;
        sourcePosition.identifierNamePos = pos;
        sourcePosition.identifierName = identifierName;
    }
    _space() {
        this._queue(32);
    }
    _newline() {
        this._queue(10);
    }
    _append(str, maybeNewline) {
        this._maybeAddParen(str);
        this._maybeIndent(str.charCodeAt(0));
        this._buf.append(str, maybeNewline);
        this._endsWithWord = false;
        this._endsWithInteger = false;
    }
    _appendChar(char) {
        this._maybeAddParenChar(char);
        this._maybeIndent(char);
        this._buf.appendChar(char);
        this._endsWithWord = false;
        this._endsWithInteger = false;
    }
    _queue(char) {
        this._maybeAddParenChar(char);
        this._maybeIndent(char);
        this._buf.queue(char);
        this._endsWithWord = false;
        this._endsWithInteger = false;
    }
    _maybeIndent(firstChar) {
        if (this._indent && firstChar !== 10 && this.endsWith(10)) this._buf.queueIndentation(this._getIndent());
    }
    _shouldIndent(firstChar) {
        if (this._indent && firstChar !== 10 && this.endsWith(10)) return true;
    }
    _maybeAddParenChar(char) {
        const parenPushNewlineState = this._parenPushNewlineState;
        if (!parenPushNewlineState) return;
        if (char === 32) return;
        if (char !== 10) {
            this._parenPushNewlineState = null;
            return;
        }
        this.tokenChar(40);
        this.indent();
        parenPushNewlineState.printed = true;
    }
    _maybeAddParen(str) {
        const parenPushNewlineState = this._parenPushNewlineState;
        if (!parenPushNewlineState) return;
        const len = str.length;
        let i;
        for(i = 0; i < len && str.charCodeAt(i) === 32; i++)continue;
        if (i === len) return;
        const cha = str.charCodeAt(i);
        if (cha !== 10) {
            if (cha !== 47 || i + 1 === len) {
                this._parenPushNewlineState = null;
                return;
            }
            const chaPost = str.charCodeAt(i + 1);
            if (chaPost === 42) return;
            else if (chaPost !== 47) {
                this._parenPushNewlineState = null;
                return;
            }
        }
        this.tokenChar(40);
        this.indent();
        parenPushNewlineState.printed = true;
    }
    catchUp(line) {
        if (!this.format.retainLines) return;
        const count = line - this._buf.getCurrentLine();
        for(let i = 0; i < count; i++)this._newline();
    }
    _catchUp(prop, loc) {
        var _loc$prop;
        if (!this.format.retainLines) return;
        const line = loc == null || (_loc$prop = loc[prop]) == null ? void 0 : _loc$prop.line;
        if (line != null) {
            const count = line - this._buf.getCurrentLine();
            for(let i = 0; i < count; i++)this._newline();
        }
    }
    _getIndent() {
        return this._indentRepeat * this._indent;
    }
    printTerminatorless(node, parent, isLabel) {
        if (isLabel) {
            this._noLineTerminator = true;
            this.print(node, parent);
        } else {
            const terminatorState = {
                printed: false
            };
            this._parenPushNewlineState = terminatorState;
            this.print(node, parent);
            if (terminatorState.printed) {
                this.dedent();
                this.newline();
                this.tokenChar(41);
            }
        }
    }
    print(node, parent, noLineTerminatorAfter, trailingCommentsLineOffset, forceParens) {
        var _node$extra, _node$leadingComments;
        if (!node) return;
        this._endsWithInnerRaw = false;
        const nodeType = node.type;
        const format = this.format;
        const oldConcise = format.concise;
        if (node._compact) format.concise = true;
        const printMethod = this[nodeType];
        if (printMethod === undefined) throw new ReferenceError(`unknown node of type ${JSON.stringify(nodeType)} with constructor ${JSON.stringify(node.constructor.name)}`);
        this._printStack.push(node);
        const oldInAux = this._insideAux;
        this._insideAux = node.loc == undefined;
        this._maybeAddAuxComment(this._insideAux && !oldInAux);
        const parenthesized = (_node$extra = node.extra) == null ? void 0 : _node$extra.parenthesized;
        let shouldPrintParens = forceParens || parenthesized && format.retainFunctionParens && nodeType === "FunctionExpression" || $dc3c5ce6f3abbc7b$var$needsParens(node, parent, this._printStack);
        if (!shouldPrintParens && parenthesized && (_node$leadingComments = node.leadingComments) != null && _node$leadingComments.length && node.leadingComments[0].type === "CommentBlock") {
            const parentType = parent == null ? void 0 : parent.type;
            switch(parentType){
                case "ExpressionStatement":
                case "VariableDeclarator":
                case "AssignmentExpression":
                case "ReturnStatement":
                    break;
                case "CallExpression":
                case "OptionalCallExpression":
                case "NewExpression":
                    if (parent.callee !== node) break;
                default:
                    shouldPrintParens = true;
            }
        }
        if (shouldPrintParens) {
            this.tokenChar(40);
            this._endsWithInnerRaw = false;
        }
        this._lastCommentLine = 0;
        this._printLeadingComments(node, parent);
        const loc = nodeType === "Program" || nodeType === "File" ? null : node.loc;
        this.exactSource(loc, printMethod.bind(this, node, parent));
        if (shouldPrintParens) {
            this._printTrailingComments(node, parent);
            this.tokenChar(41);
            this._noLineTerminator = noLineTerminatorAfter;
        } else if (noLineTerminatorAfter && !this._noLineTerminator) {
            this._noLineTerminator = true;
            this._printTrailingComments(node, parent);
        } else this._printTrailingComments(node, parent, trailingCommentsLineOffset);
        this._printStack.pop();
        format.concise = oldConcise;
        this._insideAux = oldInAux;
        this._endsWithInnerRaw = false;
    }
    _maybeAddAuxComment(enteredPositionlessNode) {
        if (enteredPositionlessNode) this._printAuxBeforeComment();
        if (!this._insideAux) this._printAuxAfterComment();
    }
    _printAuxBeforeComment() {
        if (this._printAuxAfterOnNextUserNode) return;
        this._printAuxAfterOnNextUserNode = true;
        const comment = this.format.auxiliaryCommentBefore;
        if (comment) this._printComment({
            type: "CommentBlock",
            value: comment
        }, 0);
    }
    _printAuxAfterComment() {
        if (!this._printAuxAfterOnNextUserNode) return;
        this._printAuxAfterOnNextUserNode = false;
        const comment = this.format.auxiliaryCommentAfter;
        if (comment) this._printComment({
            type: "CommentBlock",
            value: comment
        }, 0);
    }
    getPossibleRaw(node) {
        const extra = node.extra;
        if ((extra == null ? void 0 : extra.raw) != null && extra.rawValue != null && node.value === extra.rawValue) return extra.raw;
    }
    printJoin(nodes, parent, opts = {}) {
        if (!(nodes != null && nodes.length)) return;
        let { indent: indent } = opts;
        if (indent == null && this.format.retainLines) {
            var _nodes$0$loc;
            const startLine = (_nodes$0$loc = nodes[0].loc) == null ? void 0 : _nodes$0$loc.start.line;
            if (startLine != null && startLine !== this._buf.getCurrentLine()) indent = true;
        }
        if (indent) this.indent();
        const newlineOpts = {
            addNewlines: opts.addNewlines,
            nextNodeStartLine: 0
        };
        const separator = opts.separator ? opts.separator.bind(this) : null;
        const len = nodes.length;
        for(let i = 0; i < len; i++){
            const node = nodes[i];
            if (!node) continue;
            if (opts.statement) this._printNewline(i === 0, newlineOpts);
            this.print(node, parent, undefined, opts.trailingCommentsLineOffset || 0);
            opts.iterator == null || opts.iterator(node, i);
            if (i < len - 1) separator == null || separator();
            if (opts.statement) {
                var _node$trailingComment;
                if (!((_node$trailingComment = node.trailingComments) != null && _node$trailingComment.length)) this._lastCommentLine = 0;
                if (i + 1 === len) this.newline(1);
                else {
                    var _nextNode$loc;
                    const nextNode = nodes[i + 1];
                    newlineOpts.nextNodeStartLine = ((_nextNode$loc = nextNode.loc) == null ? void 0 : _nextNode$loc.start.line) || 0;
                    this._printNewline(true, newlineOpts);
                }
            }
        }
        if (indent) this.dedent();
    }
    printAndIndentOnComments(node, parent) {
        const indent = node.leadingComments && node.leadingComments.length > 0;
        if (indent) this.indent();
        this.print(node, parent);
        if (indent) this.dedent();
    }
    printBlock(parent) {
        const node = parent.body;
        if (node.type !== "EmptyStatement") this.space();
        this.print(node, parent);
    }
    _printTrailingComments(node, parent, lineOffset) {
        const { innerComments: innerComments, trailingComments: trailingComments } = node;
        if (innerComments != null && innerComments.length) this._printComments(2, innerComments, node, parent, lineOffset);
        if (trailingComments != null && trailingComments.length) this._printComments(2, trailingComments, node, parent, lineOffset);
    }
    _printLeadingComments(node, parent) {
        const comments = node.leadingComments;
        if (!(comments != null && comments.length)) return;
        this._printComments(0, comments, node, parent);
    }
    _maybePrintInnerComments() {
        if (this._endsWithInnerRaw) this.printInnerComments();
        this._endsWithInnerRaw = true;
        this._indentInnerComments = true;
    }
    printInnerComments() {
        const node = this._printStack[this._printStack.length - 1];
        const comments = node.innerComments;
        if (!(comments != null && comments.length)) return;
        const hasSpace = this.endsWith(32);
        const indent = this._indentInnerComments;
        const printedCommentsCount = this._printedComments.size;
        if (indent) this.indent();
        this._printComments(1, comments, node);
        if (hasSpace && printedCommentsCount !== this._printedComments.size) this.space();
        if (indent) this.dedent();
    }
    noIndentInnerCommentsHere() {
        this._indentInnerComments = false;
    }
    printSequence(nodes, parent, opts = {}) {
        var _opts$indent;
        opts.statement = true;
        (_opts$indent = opts.indent) != null ? _opts$indent : opts.indent = false;
        this.printJoin(nodes, parent, opts);
    }
    printList(items, parent, opts = {}) {
        if (opts.separator == null) opts.separator = $dc3c5ce6f3abbc7b$var$commaSeparator;
        this.printJoin(items, parent, opts);
    }
    _printNewline(newLine, opts) {
        const format = this.format;
        if (format.retainLines || format.compact) return;
        if (format.concise) {
            this.space();
            return;
        }
        if (!newLine) return;
        const startLine = opts.nextNodeStartLine;
        const lastCommentLine = this._lastCommentLine;
        if (startLine > 0 && lastCommentLine > 0) {
            const offset = startLine - lastCommentLine;
            if (offset >= 0) {
                this.newline(offset || 1);
                return;
            }
        }
        if (this._buf.hasContent()) this.newline(1);
    }
    _shouldPrintComment(comment) {
        if (comment.ignore) return 0;
        if (this._printedComments.has(comment)) return 0;
        if (this._noLineTerminator && $dc3c5ce6f3abbc7b$var$HAS_NEWLINE_OR_BlOCK_COMMENT_END.test(comment.value)) return 2;
        this._printedComments.add(comment);
        if (!this.format.shouldPrintComment(comment.value)) return 0;
        return 1;
    }
    _printComment(comment, skipNewLines) {
        const noLineTerminator = this._noLineTerminator;
        const isBlockComment = comment.type === "CommentBlock";
        const printNewLines = isBlockComment && skipNewLines !== 1 && !this._noLineTerminator;
        if (printNewLines && this._buf.hasContent() && skipNewLines !== 2) this.newline(1);
        const lastCharCode = this.getLastChar();
        if (lastCharCode !== 91 && lastCharCode !== 123) this.space();
        let val;
        if (isBlockComment) {
            const { _parenPushNewlineState: _parenPushNewlineState } = this;
            if ((_parenPushNewlineState == null ? void 0 : _parenPushNewlineState.printed) === false && $dc3c5ce6f3abbc7b$var$HAS_NEWLINE.test(comment.value)) {
                this.tokenChar(40);
                this.indent();
                _parenPushNewlineState.printed = true;
            }
            val = `/*${comment.value}*/`;
            if (this.format.indent.adjustMultilineComment) {
                var _comment$loc;
                const offset = (_comment$loc = comment.loc) == null ? void 0 : _comment$loc.start.column;
                if (offset) {
                    const newlineRegex = new RegExp("\\n\\s{1," + offset + "}", "g");
                    val = val.replace(newlineRegex, "\n");
                }
                if (this.format.concise) val = val.replace(/\n(?!$)/g, `\n`);
                else {
                    let indentSize = this.format.retainLines ? 0 : this._buf.getCurrentColumn();
                    if (this._shouldIndent(47) || this.format.retainLines) indentSize += this._getIndent();
                    val = val.replace(/\n(?!$)/g, `\n${" ".repeat(indentSize)}`);
                }
            }
        } else if (!noLineTerminator) val = `//${comment.value}`;
        else val = `/*${comment.value}*/`;
        if (this.endsWith(47)) this._space();
        this.source("start", comment.loc);
        this._append(val, isBlockComment);
        if (!isBlockComment && !noLineTerminator) this.newline(1, true);
        if (printNewLines && skipNewLines !== 3) this.newline(1);
    }
    _printComments(type, comments, node, parent, lineOffset = 0) {
        const nodeLoc = node.loc;
        const len = comments.length;
        let hasLoc = !!nodeLoc;
        const nodeStartLine = hasLoc ? nodeLoc.start.line : 0;
        const nodeEndLine = hasLoc ? nodeLoc.end.line : 0;
        let lastLine = 0;
        let leadingCommentNewline = 0;
        const maybeNewline = this._noLineTerminator ? function() {} : this.newline.bind(this);
        for(let i = 0; i < len; i++){
            const comment = comments[i];
            const shouldPrint = this._shouldPrintComment(comment);
            if (shouldPrint === 2) {
                hasLoc = false;
                break;
            }
            if (hasLoc && comment.loc && shouldPrint === 1) {
                const commentStartLine = comment.loc.start.line;
                const commentEndLine = comment.loc.end.line;
                if (type === 0) {
                    let offset = 0;
                    if (i === 0) {
                        if (this._buf.hasContent() && (comment.type === "CommentLine" || commentStartLine != commentEndLine)) offset = leadingCommentNewline = 1;
                    } else offset = commentStartLine - lastLine;
                    lastLine = commentEndLine;
                    maybeNewline(offset);
                    this._printComment(comment, 1);
                    if (i + 1 === len) {
                        maybeNewline(Math.max(nodeStartLine - lastLine, leadingCommentNewline));
                        lastLine = nodeStartLine;
                    }
                } else if (type === 1) {
                    const offset = commentStartLine - (i === 0 ? nodeStartLine : lastLine);
                    lastLine = commentEndLine;
                    maybeNewline(offset);
                    this._printComment(comment, 1);
                    if (i + 1 === len) {
                        maybeNewline(Math.min(1, nodeEndLine - lastLine));
                        lastLine = nodeEndLine;
                    }
                } else {
                    const offset = commentStartLine - (i === 0 ? nodeEndLine - lineOffset : lastLine);
                    lastLine = commentEndLine;
                    maybeNewline(offset);
                    this._printComment(comment, 1);
                }
            } else {
                hasLoc = false;
                if (shouldPrint !== 1) continue;
                if (len === 1) {
                    const singleLine = comment.loc ? comment.loc.start.line === comment.loc.end.line : !$dc3c5ce6f3abbc7b$var$HAS_NEWLINE.test(comment.value);
                    const shouldSkipNewline = singleLine && !$dc3c5ce6f3abbc7b$var$isStatement(node) && !$dc3c5ce6f3abbc7b$var$isClassBody(parent) && !$dc3c5ce6f3abbc7b$var$isTSInterfaceBody(parent) && !$dc3c5ce6f3abbc7b$var$isTSEnumDeclaration(parent);
                    if (type === 0) this._printComment(comment, shouldSkipNewline && node.type !== "ObjectExpression" || singleLine && $dc3c5ce6f3abbc7b$var$isFunction(parent, {
                        body: node
                    }) ? 1 : 0);
                    else if (shouldSkipNewline && type === 2) this._printComment(comment, 1);
                    else this._printComment(comment, 0);
                } else if (type === 1 && !(node.type === "ObjectExpression" && node.properties.length > 1) && node.type !== "ClassBody" && node.type !== "TSInterfaceBody") this._printComment(comment, i === 0 ? 2 : i === len - 1 ? 3 : 0);
                else this._printComment(comment, 0);
            }
        }
        if (type === 2 && hasLoc && lastLine) this._lastCommentLine = lastLine;
    }
}
Object.assign($dc3c5ce6f3abbc7b$var$Printer.prototype, $bGU9c);
$dc3c5ce6f3abbc7b$var$Printer.prototype.Noop = function Noop() {};
var $dc3c5ce6f3abbc7b$var$_default = module.exports.default = $dc3c5ce6f3abbc7b$var$Printer;
function $dc3c5ce6f3abbc7b$var$commaSeparator() {
    this.tokenChar(44);
    this.space();
}

});
parcelRegister("c1k0E", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
class $8c051981e8c4a98b$var$Buffer {
    constructor(map, indentChar){
        this._map = null;
        this._buf = "";
        this._str = "";
        this._appendCount = 0;
        this._last = 0;
        this._queue = [];
        this._queueCursor = 0;
        this._canMarkIdName = true;
        this._indentChar = "";
        this._fastIndentations = [];
        this._position = {
            line: 1,
            column: 0
        };
        this._sourcePosition = {
            identifierName: undefined,
            identifierNamePos: undefined,
            line: undefined,
            column: undefined,
            filename: undefined
        };
        this._map = map;
        this._indentChar = indentChar;
        for(let i = 0; i < 64; i++)this._fastIndentations.push(indentChar.repeat(i));
        this._allocQueue();
    }
    _allocQueue() {
        const queue = this._queue;
        for(let i = 0; i < 16; i++)queue.push({
            char: 0,
            repeat: 1,
            line: undefined,
            column: undefined,
            identifierName: undefined,
            identifierNamePos: undefined,
            filename: ""
        });
    }
    _pushQueue(char, repeat, line, column, filename) {
        const cursor = this._queueCursor;
        if (cursor === this._queue.length) this._allocQueue();
        const item = this._queue[cursor];
        item.char = char;
        item.repeat = repeat;
        item.line = line;
        item.column = column;
        item.filename = filename;
        this._queueCursor++;
    }
    _popQueue() {
        if (this._queueCursor === 0) throw new Error("Cannot pop from empty queue");
        return this._queue[--this._queueCursor];
    }
    get() {
        this._flush();
        const map = this._map;
        const result = {
            code: (this._buf + this._str).trimRight(),
            decodedMap: map == null ? void 0 : map.getDecoded(),
            get __mergedMap () {
                return this.map;
            },
            get map () {
                const resultMap = map ? map.get() : null;
                result.map = resultMap;
                return resultMap;
            },
            set map (value){
                Object.defineProperty(result, "map", {
                    value: value,
                    writable: true
                });
            },
            get rawMappings () {
                const mappings = map == null ? void 0 : map.getRawMappings();
                result.rawMappings = mappings;
                return mappings;
            },
            set rawMappings (value){
                Object.defineProperty(result, "rawMappings", {
                    value: value,
                    writable: true
                });
            }
        };
        return result;
    }
    append(str, maybeNewline) {
        this._flush();
        this._append(str, this._sourcePosition, maybeNewline);
    }
    appendChar(char) {
        this._flush();
        this._appendChar(char, 1, this._sourcePosition);
    }
    queue(char) {
        if (char === 10) while(this._queueCursor !== 0){
            const char = this._queue[this._queueCursor - 1].char;
            if (char !== 32 && char !== 9) break;
            this._queueCursor--;
        }
        const sourcePosition = this._sourcePosition;
        this._pushQueue(char, 1, sourcePosition.line, sourcePosition.column, sourcePosition.filename);
    }
    queueIndentation(repeat) {
        if (repeat === 0) return;
        this._pushQueue(-1, repeat, undefined, undefined, undefined);
    }
    _flush() {
        const queueCursor = this._queueCursor;
        const queue = this._queue;
        for(let i = 0; i < queueCursor; i++){
            const item = queue[i];
            this._appendChar(item.char, item.repeat, item);
        }
        this._queueCursor = 0;
    }
    _appendChar(char, repeat, sourcePos) {
        this._last = char;
        if (char === -1) {
            const fastIndentation = this._fastIndentations[repeat];
            if (fastIndentation !== undefined) this._str += fastIndentation;
            else this._str += repeat > 1 ? this._indentChar.repeat(repeat) : this._indentChar;
        } else this._str += repeat > 1 ? String.fromCharCode(char).repeat(repeat) : String.fromCharCode(char);
        if (char !== 10) {
            this._mark(sourcePos.line, sourcePos.column, sourcePos.identifierName, sourcePos.identifierNamePos, sourcePos.filename);
            this._position.column += repeat;
        } else {
            this._position.line++;
            this._position.column = 0;
        }
        if (this._canMarkIdName) {
            sourcePos.identifierName = undefined;
            sourcePos.identifierNamePos = undefined;
        }
    }
    _append(str, sourcePos, maybeNewline) {
        const len = str.length;
        const position = this._position;
        this._last = str.charCodeAt(len - 1);
        if (++this._appendCount > 4096) {
            this._str;
            this._buf += this._str;
            this._str = str;
            this._appendCount = 0;
        } else this._str += str;
        if (!maybeNewline && !this._map) {
            position.column += len;
            return;
        }
        const { column: column, identifierName: identifierName, identifierNamePos: identifierNamePos, filename: filename } = sourcePos;
        let line = sourcePos.line;
        if ((identifierName != null || identifierNamePos != null) && this._canMarkIdName) {
            sourcePos.identifierName = undefined;
            sourcePos.identifierNamePos = undefined;
        }
        let i = str.indexOf("\n");
        let last = 0;
        if (i !== 0) this._mark(line, column, identifierName, identifierNamePos, filename);
        while(i !== -1){
            position.line++;
            position.column = 0;
            last = i + 1;
            if (last < len && line !== undefined) this._mark(++line, 0, null, null, filename);
            i = str.indexOf("\n", last);
        }
        position.column += len - last;
    }
    _mark(line, column, identifierName, identifierNamePos, filename) {
        var _this$_map;
        (_this$_map = this._map) == null || _this$_map.mark(this._position, line, column, identifierName, identifierNamePos, filename);
    }
    removeTrailingNewline() {
        const queueCursor = this._queueCursor;
        if (queueCursor !== 0 && this._queue[queueCursor - 1].char === 10) this._queueCursor--;
    }
    removeLastSemicolon() {
        const queueCursor = this._queueCursor;
        if (queueCursor !== 0 && this._queue[queueCursor - 1].char === 59) this._queueCursor--;
    }
    getLastChar() {
        const queueCursor = this._queueCursor;
        return queueCursor !== 0 ? this._queue[queueCursor - 1].char : this._last;
    }
    getNewlineCount() {
        const queueCursor = this._queueCursor;
        let count = 0;
        if (queueCursor === 0) return this._last === 10 ? 1 : 0;
        for(let i = queueCursor - 1; i >= 0; i--){
            if (this._queue[i].char !== 10) break;
            count++;
        }
        return count === queueCursor && this._last === 10 ? count + 1 : count;
    }
    endsWithCharAndNewline() {
        const queue = this._queue;
        const queueCursor = this._queueCursor;
        if (queueCursor !== 0) {
            const lastCp = queue[queueCursor - 1].char;
            if (lastCp !== 10) return;
            if (queueCursor > 1) return queue[queueCursor - 2].char;
            else return this._last;
        }
    }
    hasContent() {
        return this._queueCursor !== 0 || !!this._last;
    }
    exactSource(loc, cb) {
        if (!this._map) {
            cb();
            return;
        }
        this.source("start", loc);
        const identifierName = loc.identifierName;
        const sourcePos = this._sourcePosition;
        if (identifierName) {
            this._canMarkIdName = false;
            sourcePos.identifierName = identifierName;
        }
        cb();
        if (identifierName) {
            this._canMarkIdName = true;
            sourcePos.identifierName = undefined;
            sourcePos.identifierNamePos = undefined;
        }
        this.source("end", loc);
    }
    source(prop, loc) {
        if (!this._map) return;
        this._normalizePosition(prop, loc, 0);
    }
    sourceWithOffset(prop, loc, columnOffset) {
        if (!this._map) return;
        this._normalizePosition(prop, loc, columnOffset);
    }
    withSource(prop, loc, cb) {
        if (this._map) this.source(prop, loc);
        cb();
    }
    _normalizePosition(prop, loc, columnOffset) {
        const pos = loc[prop];
        const target = this._sourcePosition;
        if (pos) {
            target.line = pos.line;
            target.column = Math.max(pos.column + columnOffset, 0);
            target.filename = loc.filename;
        }
    }
    getCurrentColumn() {
        const queue = this._queue;
        const queueCursor = this._queueCursor;
        let lastIndex = -1;
        let len = 0;
        for(let i = 0; i < queueCursor; i++){
            const item = queue[i];
            if (item.char === 10) lastIndex = len;
            len += item.repeat;
        }
        return lastIndex === -1 ? this._position.column + len : len - 1 - lastIndex;
    }
    getCurrentLine() {
        let count = 0;
        const queue = this._queue;
        for(let i = 0; i < this._queueCursor; i++)if (queue[i].char === 10) count++;
        return this._position.line + count;
    }
}
module.exports.default = $8c051981e8c4a98b$var$Buffer;

});

parcelRegister("d5V7k", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.needsParens = $98880c4a363e65df$var$needsParens;
module.exports.needsWhitespace = $98880c4a363e65df$var$needsWhitespace;
module.exports.needsWhitespaceAfter = $98880c4a363e65df$var$needsWhitespaceAfter;
module.exports.needsWhitespaceBefore = $98880c4a363e65df$var$needsWhitespaceBefore;

var $1o9cU = parcelRequire("1o9cU");

var $3krPT = parcelRequire("3krPT");

var $ardUq = parcelRequire("ardUq");
const { FLIPPED_ALIAS_KEYS: $98880c4a363e65df$var$FLIPPED_ALIAS_KEYS, isCallExpression: $98880c4a363e65df$var$isCallExpression, isExpressionStatement: $98880c4a363e65df$var$isExpressionStatement, isMemberExpression: $98880c4a363e65df$var$isMemberExpression, isNewExpression: $98880c4a363e65df$var$isNewExpression } = $ardUq;
function $98880c4a363e65df$var$expandAliases(obj) {
    const map = new Map();
    function add(type, func) {
        const fn = map.get(type);
        map.set(type, fn ? function(node, parent, stack) {
            var _fn;
            return (_fn = fn(node, parent, stack)) != null ? _fn : func(node, parent, stack);
        } : func);
    }
    for (const type of Object.keys(obj)){
        const aliases = $98880c4a363e65df$var$FLIPPED_ALIAS_KEYS[type];
        if (aliases) for (const alias of aliases)add(alias, obj[type]);
        else add(type, obj[type]);
    }
    return map;
}
const $98880c4a363e65df$var$expandedParens = $98880c4a363e65df$var$expandAliases($3krPT);
const $98880c4a363e65df$var$expandedWhitespaceNodes = $98880c4a363e65df$var$expandAliases($1o9cU.nodes);
function $98880c4a363e65df$var$isOrHasCallExpression(node) {
    if ($98880c4a363e65df$var$isCallExpression(node)) return true;
    return $98880c4a363e65df$var$isMemberExpression(node) && $98880c4a363e65df$var$isOrHasCallExpression(node.object);
}
function $98880c4a363e65df$var$needsWhitespace(node, parent, type) {
    var _expandedWhitespaceNo;
    if (!node) return false;
    if ($98880c4a363e65df$var$isExpressionStatement(node)) node = node.expression;
    const flag = (_expandedWhitespaceNo = $98880c4a363e65df$var$expandedWhitespaceNodes.get(node.type)) == null ? void 0 : _expandedWhitespaceNo(node, parent);
    if (typeof flag === "number") return (flag & type) !== 0;
    return false;
}
function $98880c4a363e65df$var$needsWhitespaceBefore(node, parent) {
    return $98880c4a363e65df$var$needsWhitespace(node, parent, 1);
}
function $98880c4a363e65df$var$needsWhitespaceAfter(node, parent) {
    return $98880c4a363e65df$var$needsWhitespace(node, parent, 2);
}
function $98880c4a363e65df$var$needsParens(node, parent, printStack) {
    var _expandedParens$get;
    if (!parent) return false;
    if ($98880c4a363e65df$var$isNewExpression(parent) && parent.callee === node) {
        if ($98880c4a363e65df$var$isOrHasCallExpression(node)) return true;
    }
    return (_expandedParens$get = $98880c4a363e65df$var$expandedParens.get(node.type)) == null ? void 0 : _expandedParens$get(node, parent, printStack);
}

});
parcelRegister("1o9cU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.nodes = void 0;

var $ardUq = parcelRequire("ardUq");
const { FLIPPED_ALIAS_KEYS: $102f2cb029ad5646$var$FLIPPED_ALIAS_KEYS, isArrayExpression: $102f2cb029ad5646$var$isArrayExpression, isAssignmentExpression: $102f2cb029ad5646$var$isAssignmentExpression, isBinary: $102f2cb029ad5646$var$isBinary, isBlockStatement: $102f2cb029ad5646$var$isBlockStatement, isCallExpression: $102f2cb029ad5646$var$isCallExpression, isFunction: $102f2cb029ad5646$var$isFunction, isIdentifier: $102f2cb029ad5646$var$isIdentifier, isLiteral: $102f2cb029ad5646$var$isLiteral, isMemberExpression: $102f2cb029ad5646$var$isMemberExpression, isObjectExpression: $102f2cb029ad5646$var$isObjectExpression, isOptionalCallExpression: $102f2cb029ad5646$var$isOptionalCallExpression, isOptionalMemberExpression: $102f2cb029ad5646$var$isOptionalMemberExpression, isStringLiteral: $102f2cb029ad5646$var$isStringLiteral } = $ardUq;
function $102f2cb029ad5646$var$crawlInternal(node, state) {
    if (!node) return state;
    if ($102f2cb029ad5646$var$isMemberExpression(node) || $102f2cb029ad5646$var$isOptionalMemberExpression(node)) {
        $102f2cb029ad5646$var$crawlInternal(node.object, state);
        if (node.computed) $102f2cb029ad5646$var$crawlInternal(node.property, state);
    } else if ($102f2cb029ad5646$var$isBinary(node) || $102f2cb029ad5646$var$isAssignmentExpression(node)) {
        $102f2cb029ad5646$var$crawlInternal(node.left, state);
        $102f2cb029ad5646$var$crawlInternal(node.right, state);
    } else if ($102f2cb029ad5646$var$isCallExpression(node) || $102f2cb029ad5646$var$isOptionalCallExpression(node)) {
        state.hasCall = true;
        $102f2cb029ad5646$var$crawlInternal(node.callee, state);
    } else if ($102f2cb029ad5646$var$isFunction(node)) state.hasFunction = true;
    else if ($102f2cb029ad5646$var$isIdentifier(node)) state.hasHelper = state.hasHelper || node.callee && $102f2cb029ad5646$var$isHelper(node.callee);
    return state;
}
function $102f2cb029ad5646$var$crawl(node) {
    return $102f2cb029ad5646$var$crawlInternal(node, {
        hasCall: false,
        hasFunction: false,
        hasHelper: false
    });
}
function $102f2cb029ad5646$var$isHelper(node) {
    if (!node) return false;
    if ($102f2cb029ad5646$var$isMemberExpression(node)) return $102f2cb029ad5646$var$isHelper(node.object) || $102f2cb029ad5646$var$isHelper(node.property);
    else if ($102f2cb029ad5646$var$isIdentifier(node)) return node.name === "require" || node.name.charCodeAt(0) === 95;
    else if ($102f2cb029ad5646$var$isCallExpression(node)) return $102f2cb029ad5646$var$isHelper(node.callee);
    else if ($102f2cb029ad5646$var$isBinary(node) || $102f2cb029ad5646$var$isAssignmentExpression(node)) return $102f2cb029ad5646$var$isIdentifier(node.left) && $102f2cb029ad5646$var$isHelper(node.left) || $102f2cb029ad5646$var$isHelper(node.right);
    else return false;
}
function $102f2cb029ad5646$var$isType(node) {
    return $102f2cb029ad5646$var$isLiteral(node) || $102f2cb029ad5646$var$isObjectExpression(node) || $102f2cb029ad5646$var$isArrayExpression(node) || $102f2cb029ad5646$var$isIdentifier(node) || $102f2cb029ad5646$var$isMemberExpression(node);
}
const $102f2cb029ad5646$var$nodes = module.exports.nodes = {
    AssignmentExpression (node) {
        const state = $102f2cb029ad5646$var$crawl(node.right);
        if (state.hasCall && state.hasHelper || state.hasFunction) return state.hasFunction ? 3 : 2;
    },
    SwitchCase (node, parent) {
        return (!!node.consequent.length || parent.cases[0] === node ? 1 : 0) | (!node.consequent.length && parent.cases[parent.cases.length - 1] === node ? 2 : 0);
    },
    LogicalExpression (node) {
        if ($102f2cb029ad5646$var$isFunction(node.left) || $102f2cb029ad5646$var$isFunction(node.right)) return 2;
    },
    Literal (node) {
        if ($102f2cb029ad5646$var$isStringLiteral(node) && node.value === "use strict") return 2;
    },
    CallExpression (node) {
        if ($102f2cb029ad5646$var$isFunction(node.callee) || $102f2cb029ad5646$var$isHelper(node)) return 3;
    },
    OptionalCallExpression (node) {
        if ($102f2cb029ad5646$var$isFunction(node.callee)) return 3;
    },
    VariableDeclaration (node) {
        for(let i = 0; i < node.declarations.length; i++){
            const declar = node.declarations[i];
            let enabled = $102f2cb029ad5646$var$isHelper(declar.id) && !$102f2cb029ad5646$var$isType(declar.init);
            if (!enabled && declar.init) {
                const state = $102f2cb029ad5646$var$crawl(declar.init);
                enabled = $102f2cb029ad5646$var$isHelper(declar.init) && state.hasCall || state.hasFunction;
            }
            if (enabled) return 3;
        }
    },
    IfStatement (node) {
        if ($102f2cb029ad5646$var$isBlockStatement(node.consequent)) return 3;
    }
};
$102f2cb029ad5646$var$nodes.ObjectProperty = $102f2cb029ad5646$var$nodes.ObjectTypeProperty = $102f2cb029ad5646$var$nodes.ObjectMethod = function(node, parent) {
    if (parent.properties[0] === node) return 1;
};
$102f2cb029ad5646$var$nodes.ObjectTypeCallProperty = function(node, parent) {
    var _parent$properties;
    if (parent.callProperties[0] === node && !((_parent$properties = parent.properties) != null && _parent$properties.length)) return 1;
};
$102f2cb029ad5646$var$nodes.ObjectTypeIndexer = function(node, parent) {
    var _parent$properties2, _parent$callPropertie;
    if (parent.indexers[0] === node && !((_parent$properties2 = parent.properties) != null && _parent$properties2.length) && !((_parent$callPropertie = parent.callProperties) != null && _parent$callPropertie.length)) return 1;
};
$102f2cb029ad5646$var$nodes.ObjectTypeInternalSlot = function(node, parent) {
    var _parent$properties3, _parent$callPropertie2, _parent$indexers;
    if (parent.internalSlots[0] === node && !((_parent$properties3 = parent.properties) != null && _parent$properties3.length) && !((_parent$callPropertie2 = parent.callProperties) != null && _parent$callPropertie2.length) && !((_parent$indexers = parent.indexers) != null && _parent$indexers.length)) return 1;
};
[
    [
        "Function",
        true
    ],
    [
        "Class",
        true
    ],
    [
        "Loop",
        true
    ],
    [
        "LabeledStatement",
        true
    ],
    [
        "SwitchStatement",
        true
    ],
    [
        "TryStatement",
        true
    ]
].forEach(function([type, amounts]) {
    [
        type
    ].concat($102f2cb029ad5646$var$FLIPPED_ALIAS_KEYS[type] || []).forEach(function(type) {
        const ret = amounts ? 3 : 0;
        $102f2cb029ad5646$var$nodes[type] = ()=>ret;
    });
});

});
parcelRegister("ardUq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $79973711480253d2$var$_exportNames = {
    react: true,
    assertNode: true,
    createTypeAnnotationBasedOnTypeof: true,
    createUnionTypeAnnotation: true,
    createFlowUnionType: true,
    createTSUnionType: true,
    cloneNode: true,
    clone: true,
    cloneDeep: true,
    cloneDeepWithoutLoc: true,
    cloneWithoutLoc: true,
    addComment: true,
    addComments: true,
    inheritInnerComments: true,
    inheritLeadingComments: true,
    inheritsComments: true,
    inheritTrailingComments: true,
    removeComments: true,
    ensureBlock: true,
    toBindingIdentifierName: true,
    toBlock: true,
    toComputedKey: true,
    toExpression: true,
    toIdentifier: true,
    toKeyAlias: true,
    toStatement: true,
    valueToNode: true,
    appendToMemberExpression: true,
    inherits: true,
    prependToMemberExpression: true,
    removeProperties: true,
    removePropertiesDeep: true,
    removeTypeDuplicates: true,
    getBindingIdentifiers: true,
    getOuterBindingIdentifiers: true,
    traverse: true,
    traverseFast: true,
    shallowEqual: true,
    is: true,
    isBinding: true,
    isBlockScoped: true,
    isImmutable: true,
    isLet: true,
    isNode: true,
    isNodesEquivalent: true,
    isPlaceholderType: true,
    isReferenced: true,
    isScope: true,
    isSpecifierDefault: true,
    isType: true,
    isValidES3Identifier: true,
    isValidIdentifier: true,
    isVar: true,
    matchesPattern: true,
    validate: true,
    buildMatchMemberExpression: true,
    __internal__deprecationWarning: true
};
Object.defineProperty(module.exports, "__internal__deprecationWarning", {
    enumerable: true,
    get: function() {
        return $7sVNt.default;
    }
});
Object.defineProperty(module.exports, "addComment", {
    enumerable: true,
    get: function() {
        return $le20m.default;
    }
});
Object.defineProperty(module.exports, "addComments", {
    enumerable: true,
    get: function() {
        return $7XyMa.default;
    }
});
Object.defineProperty(module.exports, "appendToMemberExpression", {
    enumerable: true,
    get: function() {
        return $eYiXa.default;
    }
});
Object.defineProperty(module.exports, "assertNode", {
    enumerable: true,
    get: function() {
        return $kUBOR.default;
    }
});
Object.defineProperty(module.exports, "buildMatchMemberExpression", {
    enumerable: true,
    get: function() {
        return $2oHJF.default;
    }
});
Object.defineProperty(module.exports, "clone", {
    enumerable: true,
    get: function() {
        return $2xseA.default;
    }
});
Object.defineProperty(module.exports, "cloneDeep", {
    enumerable: true,
    get: function() {
        return $9iQ12.default;
    }
});
Object.defineProperty(module.exports, "cloneDeepWithoutLoc", {
    enumerable: true,
    get: function() {
        return $ccfaL.default;
    }
});
Object.defineProperty(module.exports, "cloneNode", {
    enumerable: true,
    get: function() {
        return $k6qdD.default;
    }
});
Object.defineProperty(module.exports, "cloneWithoutLoc", {
    enumerable: true,
    get: function() {
        return $5T62d.default;
    }
});
Object.defineProperty(module.exports, "createFlowUnionType", {
    enumerable: true,
    get: function() {
        return $aUeS4.default;
    }
});
Object.defineProperty(module.exports, "createTSUnionType", {
    enumerable: true,
    get: function() {
        return $36R6x.default;
    }
});
Object.defineProperty(module.exports, "createTypeAnnotationBasedOnTypeof", {
    enumerable: true,
    get: function() {
        return $hLNUS.default;
    }
});
Object.defineProperty(module.exports, "createUnionTypeAnnotation", {
    enumerable: true,
    get: function() {
        return $aUeS4.default;
    }
});
Object.defineProperty(module.exports, "ensureBlock", {
    enumerable: true,
    get: function() {
        return $c7XVB.default;
    }
});
Object.defineProperty(module.exports, "getBindingIdentifiers", {
    enumerable: true,
    get: function() {
        return $3GTeN.default;
    }
});
Object.defineProperty(module.exports, "getOuterBindingIdentifiers", {
    enumerable: true,
    get: function() {
        return $6sXWW.default;
    }
});
Object.defineProperty(module.exports, "inheritInnerComments", {
    enumerable: true,
    get: function() {
        return $jiypm.default;
    }
});
Object.defineProperty(module.exports, "inheritLeadingComments", {
    enumerable: true,
    get: function() {
        return $3uEFY.default;
    }
});
Object.defineProperty(module.exports, "inheritTrailingComments", {
    enumerable: true,
    get: function() {
        return $1TriR.default;
    }
});
Object.defineProperty(module.exports, "inherits", {
    enumerable: true,
    get: function() {
        return $btfPV.default;
    }
});
Object.defineProperty(module.exports, "inheritsComments", {
    enumerable: true,
    get: function() {
        return $6Yd44.default;
    }
});
Object.defineProperty(module.exports, "is", {
    enumerable: true,
    get: function() {
        return $4XzLl.default;
    }
});
Object.defineProperty(module.exports, "isBinding", {
    enumerable: true,
    get: function() {
        return $2r8kv.default;
    }
});
Object.defineProperty(module.exports, "isBlockScoped", {
    enumerable: true,
    get: function() {
        return $4N0sk.default;
    }
});
Object.defineProperty(module.exports, "isImmutable", {
    enumerable: true,
    get: function() {
        return $fsv0I.default;
    }
});
Object.defineProperty(module.exports, "isLet", {
    enumerable: true,
    get: function() {
        return $8jAXP.default;
    }
});
Object.defineProperty(module.exports, "isNode", {
    enumerable: true,
    get: function() {
        return $2PW0u.default;
    }
});
Object.defineProperty(module.exports, "isNodesEquivalent", {
    enumerable: true,
    get: function() {
        return $lYDFZ.default;
    }
});
Object.defineProperty(module.exports, "isPlaceholderType", {
    enumerable: true,
    get: function() {
        return $2ccoB.default;
    }
});
Object.defineProperty(module.exports, "isReferenced", {
    enumerable: true,
    get: function() {
        return $ieqJ5.default;
    }
});
Object.defineProperty(module.exports, "isScope", {
    enumerable: true,
    get: function() {
        return $jCJrC.default;
    }
});
Object.defineProperty(module.exports, "isSpecifierDefault", {
    enumerable: true,
    get: function() {
        return $cfDjZ.default;
    }
});
Object.defineProperty(module.exports, "isType", {
    enumerable: true,
    get: function() {
        return $7sJfn.default;
    }
});
Object.defineProperty(module.exports, "isValidES3Identifier", {
    enumerable: true,
    get: function() {
        return $1sQw0.default;
    }
});
Object.defineProperty(module.exports, "isValidIdentifier", {
    enumerable: true,
    get: function() {
        return $9tPzx.default;
    }
});
Object.defineProperty(module.exports, "isVar", {
    enumerable: true,
    get: function() {
        return $5sU0b.default;
    }
});
Object.defineProperty(module.exports, "matchesPattern", {
    enumerable: true,
    get: function() {
        return $d8Dnf.default;
    }
});
Object.defineProperty(module.exports, "prependToMemberExpression", {
    enumerable: true,
    get: function() {
        return $eJjWG.default;
    }
});
module.exports.react = void 0;
Object.defineProperty(module.exports, "removeComments", {
    enumerable: true,
    get: function() {
        return $QLNL1.default;
    }
});
Object.defineProperty(module.exports, "removeProperties", {
    enumerable: true,
    get: function() {
        return $1sEUT.default;
    }
});
Object.defineProperty(module.exports, "removePropertiesDeep", {
    enumerable: true,
    get: function() {
        return $81cip.default;
    }
});
Object.defineProperty(module.exports, "removeTypeDuplicates", {
    enumerable: true,
    get: function() {
        return $iGdAf.default;
    }
});
Object.defineProperty(module.exports, "shallowEqual", {
    enumerable: true,
    get: function() {
        return $d5ioO.default;
    }
});
Object.defineProperty(module.exports, "toBindingIdentifierName", {
    enumerable: true,
    get: function() {
        return $kNGZd.default;
    }
});
Object.defineProperty(module.exports, "toBlock", {
    enumerable: true,
    get: function() {
        return $dxQZV.default;
    }
});
Object.defineProperty(module.exports, "toComputedKey", {
    enumerable: true,
    get: function() {
        return $eppYV.default;
    }
});
Object.defineProperty(module.exports, "toExpression", {
    enumerable: true,
    get: function() {
        return $P3Daq.default;
    }
});
Object.defineProperty(module.exports, "toIdentifier", {
    enumerable: true,
    get: function() {
        return $l7GKn.default;
    }
});
Object.defineProperty(module.exports, "toKeyAlias", {
    enumerable: true,
    get: function() {
        return $kUqjQ.default;
    }
});
Object.defineProperty(module.exports, "toStatement", {
    enumerable: true,
    get: function() {
        return $dh8ot.default;
    }
});
Object.defineProperty(module.exports, "traverse", {
    enumerable: true,
    get: function() {
        return $iolsE.default;
    }
});
Object.defineProperty(module.exports, "traverseFast", {
    enumerable: true,
    get: function() {
        return $5lkLS.default;
    }
});
Object.defineProperty(module.exports, "validate", {
    enumerable: true,
    get: function() {
        return $30dxP.default;
    }
});
Object.defineProperty(module.exports, "valueToNode", {
    enumerable: true,
    get: function() {
        return $gXTkY.default;
    }
});

var $lX7fR = parcelRequire("lX7fR");

var $euQYe = parcelRequire("euQYe");

var $lxuvp = parcelRequire("lxuvp");

var $kUBOR = parcelRequire("kUBOR");

var $3QfFw = parcelRequire("3QfFw");
Object.keys($3QfFw).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($79973711480253d2$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $3QfFw[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $3QfFw[key];
        }
    });
});

var $hLNUS = parcelRequire("hLNUS");

var $aUeS4 = parcelRequire("aUeS4");

var $36R6x = parcelRequire("36R6x");

var $7MfP7 = parcelRequire("7MfP7");
Object.keys($7MfP7).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($79973711480253d2$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $7MfP7[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $7MfP7[key];
        }
    });
});

var $2r3lq = parcelRequire("2r3lq");
Object.keys($2r3lq).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($79973711480253d2$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $2r3lq[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $2r3lq[key];
        }
    });
});

var $hURFO = parcelRequire("hURFO");
Object.keys($hURFO).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($79973711480253d2$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $hURFO[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $hURFO[key];
        }
    });
});

var $k6qdD = parcelRequire("k6qdD");

var $2xseA = parcelRequire("2xseA");

var $9iQ12 = parcelRequire("9iQ12");

var $ccfaL = parcelRequire("ccfaL");

var $5T62d = parcelRequire("5T62d");

var $le20m = parcelRequire("le20m");

var $7XyMa = parcelRequire("7XyMa");

var $jiypm = parcelRequire("jiypm");

var $3uEFY = parcelRequire("3uEFY");

var $6Yd44 = parcelRequire("6Yd44");

var $1TriR = parcelRequire("1TriR");

var $QLNL1 = parcelRequire("QLNL1");

var $anRaJ = parcelRequire("anRaJ");
Object.keys($anRaJ).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($79973711480253d2$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $anRaJ[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $anRaJ[key];
        }
    });
});

var $l7lSB = parcelRequire("l7lSB");
Object.keys($l7lSB).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($79973711480253d2$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $l7lSB[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $l7lSB[key];
        }
    });
});

var $c7XVB = parcelRequire("c7XVB");

var $kNGZd = parcelRequire("kNGZd");

var $dxQZV = parcelRequire("dxQZV");

var $eppYV = parcelRequire("eppYV");

var $P3Daq = parcelRequire("P3Daq");

var $l7GKn = parcelRequire("l7GKn");

var $kUqjQ = parcelRequire("kUqjQ");

var $dh8ot = parcelRequire("dh8ot");

var $gXTkY = parcelRequire("gXTkY");

var $7TNHg = parcelRequire("7TNHg");
Object.keys($7TNHg).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($79973711480253d2$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $7TNHg[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $7TNHg[key];
        }
    });
});

var $eYiXa = parcelRequire("eYiXa");

var $btfPV = parcelRequire("btfPV");

var $eJjWG = parcelRequire("eJjWG");

var $1sEUT = parcelRequire("1sEUT");

var $81cip = parcelRequire("81cip");

var $iGdAf = parcelRequire("iGdAf");

var $3GTeN = parcelRequire("3GTeN");

var $6sXWW = parcelRequire("6sXWW");

var $iolsE = parcelRequire("iolsE");
Object.keys($iolsE).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($79973711480253d2$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $iolsE[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $iolsE[key];
        }
    });
});

var $5lkLS = parcelRequire("5lkLS");

var $d5ioO = parcelRequire("d5ioO");

var $4XzLl = parcelRequire("4XzLl");

var $2r8kv = parcelRequire("2r8kv");

var $4N0sk = parcelRequire("4N0sk");

var $fsv0I = parcelRequire("fsv0I");

var $8jAXP = parcelRequire("8jAXP");

var $2PW0u = parcelRequire("2PW0u");

var $lYDFZ = parcelRequire("lYDFZ");

var $2ccoB = parcelRequire("2ccoB");

var $ieqJ5 = parcelRequire("ieqJ5");

var $jCJrC = parcelRequire("jCJrC");

var $cfDjZ = parcelRequire("cfDjZ");

var $7sJfn = parcelRequire("7sJfn");

var $1sQw0 = parcelRequire("1sQw0");

var $9tPzx = parcelRequire("9tPzx");

var $5sU0b = parcelRequire("5sU0b");

var $d8Dnf = parcelRequire("d8Dnf");

var $30dxP = parcelRequire("30dxP");

var $2oHJF = parcelRequire("2oHJF");

var $2G7FY = parcelRequire("2G7FY");
Object.keys($2G7FY).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($79973711480253d2$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $2G7FY[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $2G7FY[key];
        }
    });
});

var $7sVNt = parcelRequire("7sVNt");
const $79973711480253d2$var$react = module.exports.react = {
    isReactComponent: $lX7fR.default,
    isCompatTag: $euQYe.default,
    buildChildren: $lxuvp.default
};

module.exports.toSequenceExpression = (parcelRequire("lBOsQ")).default;

});
parcelRegister("lX7fR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2oHJF = parcelRequire("2oHJF");
const $ffb4bc55db0ad844$var$isReactComponent = (0, $2oHJF.default)("React.Component");
var $ffb4bc55db0ad844$var$_default = module.exports.default = $ffb4bc55db0ad844$var$isReactComponent;

});
parcelRegister("2oHJF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1befbfa2acc73d36$var$buildMatchMemberExpression;

var $d8Dnf = parcelRequire("d8Dnf");
function $1befbfa2acc73d36$var$buildMatchMemberExpression(match, allowPartial) {
    const parts = match.split(".");
    return (member)=>(0, $d8Dnf.default)(member, parts, allowPartial);
}

});
parcelRegister("d8Dnf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $990a908bf48f733d$var$matchesPattern;

var $2G7FY = parcelRequire("2G7FY");
function $990a908bf48f733d$var$matchesPattern(member, match, allowPartial) {
    if (!(0, $2G7FY.isMemberExpression)(member)) return false;
    const parts = Array.isArray(match) ? match : match.split(".");
    const nodes = [];
    let node;
    for(node = member; (0, $2G7FY.isMemberExpression)(node); node = node.object)nodes.push(node.property);
    nodes.push(node);
    if (nodes.length < parts.length) return false;
    if (!allowPartial && nodes.length > parts.length) return false;
    for(let i = 0, j = nodes.length - 1; i < parts.length; i++, j--){
        const node = nodes[j];
        let value;
        if ((0, $2G7FY.isIdentifier)(node)) value = node.name;
        else if ((0, $2G7FY.isStringLiteral)(node)) value = node.value;
        else if ((0, $2G7FY.isThisExpression)(node)) value = "this";
        else return false;
        if (parts[i] !== value) return false;
    }
    return true;
}

});
parcelRegister("2G7FY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isAccessor = $1f35754d885d6216$var$isAccessor;
module.exports.isAnyTypeAnnotation = $1f35754d885d6216$var$isAnyTypeAnnotation;
module.exports.isArgumentPlaceholder = $1f35754d885d6216$var$isArgumentPlaceholder;
module.exports.isArrayExpression = $1f35754d885d6216$var$isArrayExpression;
module.exports.isArrayPattern = $1f35754d885d6216$var$isArrayPattern;
module.exports.isArrayTypeAnnotation = $1f35754d885d6216$var$isArrayTypeAnnotation;
module.exports.isArrowFunctionExpression = $1f35754d885d6216$var$isArrowFunctionExpression;
module.exports.isAssignmentExpression = $1f35754d885d6216$var$isAssignmentExpression;
module.exports.isAssignmentPattern = $1f35754d885d6216$var$isAssignmentPattern;
module.exports.isAwaitExpression = $1f35754d885d6216$var$isAwaitExpression;
module.exports.isBigIntLiteral = $1f35754d885d6216$var$isBigIntLiteral;
module.exports.isBinary = $1f35754d885d6216$var$isBinary;
module.exports.isBinaryExpression = $1f35754d885d6216$var$isBinaryExpression;
module.exports.isBindExpression = $1f35754d885d6216$var$isBindExpression;
module.exports.isBlock = $1f35754d885d6216$var$isBlock;
module.exports.isBlockParent = $1f35754d885d6216$var$isBlockParent;
module.exports.isBlockStatement = $1f35754d885d6216$var$isBlockStatement;
module.exports.isBooleanLiteral = $1f35754d885d6216$var$isBooleanLiteral;
module.exports.isBooleanLiteralTypeAnnotation = $1f35754d885d6216$var$isBooleanLiteralTypeAnnotation;
module.exports.isBooleanTypeAnnotation = $1f35754d885d6216$var$isBooleanTypeAnnotation;
module.exports.isBreakStatement = $1f35754d885d6216$var$isBreakStatement;
module.exports.isCallExpression = $1f35754d885d6216$var$isCallExpression;
module.exports.isCatchClause = $1f35754d885d6216$var$isCatchClause;
module.exports.isClass = $1f35754d885d6216$var$isClass;
module.exports.isClassAccessorProperty = $1f35754d885d6216$var$isClassAccessorProperty;
module.exports.isClassBody = $1f35754d885d6216$var$isClassBody;
module.exports.isClassDeclaration = $1f35754d885d6216$var$isClassDeclaration;
module.exports.isClassExpression = $1f35754d885d6216$var$isClassExpression;
module.exports.isClassImplements = $1f35754d885d6216$var$isClassImplements;
module.exports.isClassMethod = $1f35754d885d6216$var$isClassMethod;
module.exports.isClassPrivateMethod = $1f35754d885d6216$var$isClassPrivateMethod;
module.exports.isClassPrivateProperty = $1f35754d885d6216$var$isClassPrivateProperty;
module.exports.isClassProperty = $1f35754d885d6216$var$isClassProperty;
module.exports.isCompletionStatement = $1f35754d885d6216$var$isCompletionStatement;
module.exports.isConditional = $1f35754d885d6216$var$isConditional;
module.exports.isConditionalExpression = $1f35754d885d6216$var$isConditionalExpression;
module.exports.isContinueStatement = $1f35754d885d6216$var$isContinueStatement;
module.exports.isDebuggerStatement = $1f35754d885d6216$var$isDebuggerStatement;
module.exports.isDecimalLiteral = $1f35754d885d6216$var$isDecimalLiteral;
module.exports.isDeclaration = $1f35754d885d6216$var$isDeclaration;
module.exports.isDeclareClass = $1f35754d885d6216$var$isDeclareClass;
module.exports.isDeclareExportAllDeclaration = $1f35754d885d6216$var$isDeclareExportAllDeclaration;
module.exports.isDeclareExportDeclaration = $1f35754d885d6216$var$isDeclareExportDeclaration;
module.exports.isDeclareFunction = $1f35754d885d6216$var$isDeclareFunction;
module.exports.isDeclareInterface = $1f35754d885d6216$var$isDeclareInterface;
module.exports.isDeclareModule = $1f35754d885d6216$var$isDeclareModule;
module.exports.isDeclareModuleExports = $1f35754d885d6216$var$isDeclareModuleExports;
module.exports.isDeclareOpaqueType = $1f35754d885d6216$var$isDeclareOpaqueType;
module.exports.isDeclareTypeAlias = $1f35754d885d6216$var$isDeclareTypeAlias;
module.exports.isDeclareVariable = $1f35754d885d6216$var$isDeclareVariable;
module.exports.isDeclaredPredicate = $1f35754d885d6216$var$isDeclaredPredicate;
module.exports.isDecorator = $1f35754d885d6216$var$isDecorator;
module.exports.isDirective = $1f35754d885d6216$var$isDirective;
module.exports.isDirectiveLiteral = $1f35754d885d6216$var$isDirectiveLiteral;
module.exports.isDoExpression = $1f35754d885d6216$var$isDoExpression;
module.exports.isDoWhileStatement = $1f35754d885d6216$var$isDoWhileStatement;
module.exports.isEmptyStatement = $1f35754d885d6216$var$isEmptyStatement;
module.exports.isEmptyTypeAnnotation = $1f35754d885d6216$var$isEmptyTypeAnnotation;
module.exports.isEnumBody = $1f35754d885d6216$var$isEnumBody;
module.exports.isEnumBooleanBody = $1f35754d885d6216$var$isEnumBooleanBody;
module.exports.isEnumBooleanMember = $1f35754d885d6216$var$isEnumBooleanMember;
module.exports.isEnumDeclaration = $1f35754d885d6216$var$isEnumDeclaration;
module.exports.isEnumDefaultedMember = $1f35754d885d6216$var$isEnumDefaultedMember;
module.exports.isEnumMember = $1f35754d885d6216$var$isEnumMember;
module.exports.isEnumNumberBody = $1f35754d885d6216$var$isEnumNumberBody;
module.exports.isEnumNumberMember = $1f35754d885d6216$var$isEnumNumberMember;
module.exports.isEnumStringBody = $1f35754d885d6216$var$isEnumStringBody;
module.exports.isEnumStringMember = $1f35754d885d6216$var$isEnumStringMember;
module.exports.isEnumSymbolBody = $1f35754d885d6216$var$isEnumSymbolBody;
module.exports.isExistsTypeAnnotation = $1f35754d885d6216$var$isExistsTypeAnnotation;
module.exports.isExportAllDeclaration = $1f35754d885d6216$var$isExportAllDeclaration;
module.exports.isExportDeclaration = $1f35754d885d6216$var$isExportDeclaration;
module.exports.isExportDefaultDeclaration = $1f35754d885d6216$var$isExportDefaultDeclaration;
module.exports.isExportDefaultSpecifier = $1f35754d885d6216$var$isExportDefaultSpecifier;
module.exports.isExportNamedDeclaration = $1f35754d885d6216$var$isExportNamedDeclaration;
module.exports.isExportNamespaceSpecifier = $1f35754d885d6216$var$isExportNamespaceSpecifier;
module.exports.isExportSpecifier = $1f35754d885d6216$var$isExportSpecifier;
module.exports.isExpression = $1f35754d885d6216$var$isExpression;
module.exports.isExpressionStatement = $1f35754d885d6216$var$isExpressionStatement;
module.exports.isExpressionWrapper = $1f35754d885d6216$var$isExpressionWrapper;
module.exports.isFile = $1f35754d885d6216$var$isFile;
module.exports.isFlow = $1f35754d885d6216$var$isFlow;
module.exports.isFlowBaseAnnotation = $1f35754d885d6216$var$isFlowBaseAnnotation;
module.exports.isFlowDeclaration = $1f35754d885d6216$var$isFlowDeclaration;
module.exports.isFlowPredicate = $1f35754d885d6216$var$isFlowPredicate;
module.exports.isFlowType = $1f35754d885d6216$var$isFlowType;
module.exports.isFor = $1f35754d885d6216$var$isFor;
module.exports.isForInStatement = $1f35754d885d6216$var$isForInStatement;
module.exports.isForOfStatement = $1f35754d885d6216$var$isForOfStatement;
module.exports.isForStatement = $1f35754d885d6216$var$isForStatement;
module.exports.isForXStatement = $1f35754d885d6216$var$isForXStatement;
module.exports.isFunction = $1f35754d885d6216$var$isFunction;
module.exports.isFunctionDeclaration = $1f35754d885d6216$var$isFunctionDeclaration;
module.exports.isFunctionExpression = $1f35754d885d6216$var$isFunctionExpression;
module.exports.isFunctionParent = $1f35754d885d6216$var$isFunctionParent;
module.exports.isFunctionTypeAnnotation = $1f35754d885d6216$var$isFunctionTypeAnnotation;
module.exports.isFunctionTypeParam = $1f35754d885d6216$var$isFunctionTypeParam;
module.exports.isGenericTypeAnnotation = $1f35754d885d6216$var$isGenericTypeAnnotation;
module.exports.isIdentifier = $1f35754d885d6216$var$isIdentifier;
module.exports.isIfStatement = $1f35754d885d6216$var$isIfStatement;
module.exports.isImmutable = $1f35754d885d6216$var$isImmutable;
module.exports.isImport = $1f35754d885d6216$var$isImport;
module.exports.isImportAttribute = $1f35754d885d6216$var$isImportAttribute;
module.exports.isImportDeclaration = $1f35754d885d6216$var$isImportDeclaration;
module.exports.isImportDefaultSpecifier = $1f35754d885d6216$var$isImportDefaultSpecifier;
module.exports.isImportExpression = $1f35754d885d6216$var$isImportExpression;
module.exports.isImportNamespaceSpecifier = $1f35754d885d6216$var$isImportNamespaceSpecifier;
module.exports.isImportOrExportDeclaration = $1f35754d885d6216$var$isImportOrExportDeclaration;
module.exports.isImportSpecifier = $1f35754d885d6216$var$isImportSpecifier;
module.exports.isIndexedAccessType = $1f35754d885d6216$var$isIndexedAccessType;
module.exports.isInferredPredicate = $1f35754d885d6216$var$isInferredPredicate;
module.exports.isInterfaceDeclaration = $1f35754d885d6216$var$isInterfaceDeclaration;
module.exports.isInterfaceExtends = $1f35754d885d6216$var$isInterfaceExtends;
module.exports.isInterfaceTypeAnnotation = $1f35754d885d6216$var$isInterfaceTypeAnnotation;
module.exports.isInterpreterDirective = $1f35754d885d6216$var$isInterpreterDirective;
module.exports.isIntersectionTypeAnnotation = $1f35754d885d6216$var$isIntersectionTypeAnnotation;
module.exports.isJSX = $1f35754d885d6216$var$isJSX;
module.exports.isJSXAttribute = $1f35754d885d6216$var$isJSXAttribute;
module.exports.isJSXClosingElement = $1f35754d885d6216$var$isJSXClosingElement;
module.exports.isJSXClosingFragment = $1f35754d885d6216$var$isJSXClosingFragment;
module.exports.isJSXElement = $1f35754d885d6216$var$isJSXElement;
module.exports.isJSXEmptyExpression = $1f35754d885d6216$var$isJSXEmptyExpression;
module.exports.isJSXExpressionContainer = $1f35754d885d6216$var$isJSXExpressionContainer;
module.exports.isJSXFragment = $1f35754d885d6216$var$isJSXFragment;
module.exports.isJSXIdentifier = $1f35754d885d6216$var$isJSXIdentifier;
module.exports.isJSXMemberExpression = $1f35754d885d6216$var$isJSXMemberExpression;
module.exports.isJSXNamespacedName = $1f35754d885d6216$var$isJSXNamespacedName;
module.exports.isJSXOpeningElement = $1f35754d885d6216$var$isJSXOpeningElement;
module.exports.isJSXOpeningFragment = $1f35754d885d6216$var$isJSXOpeningFragment;
module.exports.isJSXSpreadAttribute = $1f35754d885d6216$var$isJSXSpreadAttribute;
module.exports.isJSXSpreadChild = $1f35754d885d6216$var$isJSXSpreadChild;
module.exports.isJSXText = $1f35754d885d6216$var$isJSXText;
module.exports.isLVal = $1f35754d885d6216$var$isLVal;
module.exports.isLabeledStatement = $1f35754d885d6216$var$isLabeledStatement;
module.exports.isLiteral = $1f35754d885d6216$var$isLiteral;
module.exports.isLogicalExpression = $1f35754d885d6216$var$isLogicalExpression;
module.exports.isLoop = $1f35754d885d6216$var$isLoop;
module.exports.isMemberExpression = $1f35754d885d6216$var$isMemberExpression;
module.exports.isMetaProperty = $1f35754d885d6216$var$isMetaProperty;
module.exports.isMethod = $1f35754d885d6216$var$isMethod;
module.exports.isMiscellaneous = $1f35754d885d6216$var$isMiscellaneous;
module.exports.isMixedTypeAnnotation = $1f35754d885d6216$var$isMixedTypeAnnotation;
module.exports.isModuleDeclaration = $1f35754d885d6216$var$isModuleDeclaration;
module.exports.isModuleExpression = $1f35754d885d6216$var$isModuleExpression;
module.exports.isModuleSpecifier = $1f35754d885d6216$var$isModuleSpecifier;
module.exports.isNewExpression = $1f35754d885d6216$var$isNewExpression;
module.exports.isNoop = $1f35754d885d6216$var$isNoop;
module.exports.isNullLiteral = $1f35754d885d6216$var$isNullLiteral;
module.exports.isNullLiteralTypeAnnotation = $1f35754d885d6216$var$isNullLiteralTypeAnnotation;
module.exports.isNullableTypeAnnotation = $1f35754d885d6216$var$isNullableTypeAnnotation;
module.exports.isNumberLiteral = $1f35754d885d6216$var$isNumberLiteral;
module.exports.isNumberLiteralTypeAnnotation = $1f35754d885d6216$var$isNumberLiteralTypeAnnotation;
module.exports.isNumberTypeAnnotation = $1f35754d885d6216$var$isNumberTypeAnnotation;
module.exports.isNumericLiteral = $1f35754d885d6216$var$isNumericLiteral;
module.exports.isObjectExpression = $1f35754d885d6216$var$isObjectExpression;
module.exports.isObjectMember = $1f35754d885d6216$var$isObjectMember;
module.exports.isObjectMethod = $1f35754d885d6216$var$isObjectMethod;
module.exports.isObjectPattern = $1f35754d885d6216$var$isObjectPattern;
module.exports.isObjectProperty = $1f35754d885d6216$var$isObjectProperty;
module.exports.isObjectTypeAnnotation = $1f35754d885d6216$var$isObjectTypeAnnotation;
module.exports.isObjectTypeCallProperty = $1f35754d885d6216$var$isObjectTypeCallProperty;
module.exports.isObjectTypeIndexer = $1f35754d885d6216$var$isObjectTypeIndexer;
module.exports.isObjectTypeInternalSlot = $1f35754d885d6216$var$isObjectTypeInternalSlot;
module.exports.isObjectTypeProperty = $1f35754d885d6216$var$isObjectTypeProperty;
module.exports.isObjectTypeSpreadProperty = $1f35754d885d6216$var$isObjectTypeSpreadProperty;
module.exports.isOpaqueType = $1f35754d885d6216$var$isOpaqueType;
module.exports.isOptionalCallExpression = $1f35754d885d6216$var$isOptionalCallExpression;
module.exports.isOptionalIndexedAccessType = $1f35754d885d6216$var$isOptionalIndexedAccessType;
module.exports.isOptionalMemberExpression = $1f35754d885d6216$var$isOptionalMemberExpression;
module.exports.isParenthesizedExpression = $1f35754d885d6216$var$isParenthesizedExpression;
module.exports.isPattern = $1f35754d885d6216$var$isPattern;
module.exports.isPatternLike = $1f35754d885d6216$var$isPatternLike;
module.exports.isPipelineBareFunction = $1f35754d885d6216$var$isPipelineBareFunction;
module.exports.isPipelinePrimaryTopicReference = $1f35754d885d6216$var$isPipelinePrimaryTopicReference;
module.exports.isPipelineTopicExpression = $1f35754d885d6216$var$isPipelineTopicExpression;
module.exports.isPlaceholder = $1f35754d885d6216$var$isPlaceholder;
module.exports.isPrivate = $1f35754d885d6216$var$isPrivate;
module.exports.isPrivateName = $1f35754d885d6216$var$isPrivateName;
module.exports.isProgram = $1f35754d885d6216$var$isProgram;
module.exports.isProperty = $1f35754d885d6216$var$isProperty;
module.exports.isPureish = $1f35754d885d6216$var$isPureish;
module.exports.isQualifiedTypeIdentifier = $1f35754d885d6216$var$isQualifiedTypeIdentifier;
module.exports.isRecordExpression = $1f35754d885d6216$var$isRecordExpression;
module.exports.isRegExpLiteral = $1f35754d885d6216$var$isRegExpLiteral;
module.exports.isRegexLiteral = $1f35754d885d6216$var$isRegexLiteral;
module.exports.isRestElement = $1f35754d885d6216$var$isRestElement;
module.exports.isRestProperty = $1f35754d885d6216$var$isRestProperty;
module.exports.isReturnStatement = $1f35754d885d6216$var$isReturnStatement;
module.exports.isScopable = $1f35754d885d6216$var$isScopable;
module.exports.isSequenceExpression = $1f35754d885d6216$var$isSequenceExpression;
module.exports.isSpreadElement = $1f35754d885d6216$var$isSpreadElement;
module.exports.isSpreadProperty = $1f35754d885d6216$var$isSpreadProperty;
module.exports.isStandardized = $1f35754d885d6216$var$isStandardized;
module.exports.isStatement = $1f35754d885d6216$var$isStatement;
module.exports.isStaticBlock = $1f35754d885d6216$var$isStaticBlock;
module.exports.isStringLiteral = $1f35754d885d6216$var$isStringLiteral;
module.exports.isStringLiteralTypeAnnotation = $1f35754d885d6216$var$isStringLiteralTypeAnnotation;
module.exports.isStringTypeAnnotation = $1f35754d885d6216$var$isStringTypeAnnotation;
module.exports.isSuper = $1f35754d885d6216$var$isSuper;
module.exports.isSwitchCase = $1f35754d885d6216$var$isSwitchCase;
module.exports.isSwitchStatement = $1f35754d885d6216$var$isSwitchStatement;
module.exports.isSymbolTypeAnnotation = $1f35754d885d6216$var$isSymbolTypeAnnotation;
module.exports.isTSAnyKeyword = $1f35754d885d6216$var$isTSAnyKeyword;
module.exports.isTSArrayType = $1f35754d885d6216$var$isTSArrayType;
module.exports.isTSAsExpression = $1f35754d885d6216$var$isTSAsExpression;
module.exports.isTSBaseType = $1f35754d885d6216$var$isTSBaseType;
module.exports.isTSBigIntKeyword = $1f35754d885d6216$var$isTSBigIntKeyword;
module.exports.isTSBooleanKeyword = $1f35754d885d6216$var$isTSBooleanKeyword;
module.exports.isTSCallSignatureDeclaration = $1f35754d885d6216$var$isTSCallSignatureDeclaration;
module.exports.isTSConditionalType = $1f35754d885d6216$var$isTSConditionalType;
module.exports.isTSConstructSignatureDeclaration = $1f35754d885d6216$var$isTSConstructSignatureDeclaration;
module.exports.isTSConstructorType = $1f35754d885d6216$var$isTSConstructorType;
module.exports.isTSDeclareFunction = $1f35754d885d6216$var$isTSDeclareFunction;
module.exports.isTSDeclareMethod = $1f35754d885d6216$var$isTSDeclareMethod;
module.exports.isTSEntityName = $1f35754d885d6216$var$isTSEntityName;
module.exports.isTSEnumDeclaration = $1f35754d885d6216$var$isTSEnumDeclaration;
module.exports.isTSEnumMember = $1f35754d885d6216$var$isTSEnumMember;
module.exports.isTSExportAssignment = $1f35754d885d6216$var$isTSExportAssignment;
module.exports.isTSExpressionWithTypeArguments = $1f35754d885d6216$var$isTSExpressionWithTypeArguments;
module.exports.isTSExternalModuleReference = $1f35754d885d6216$var$isTSExternalModuleReference;
module.exports.isTSFunctionType = $1f35754d885d6216$var$isTSFunctionType;
module.exports.isTSImportEqualsDeclaration = $1f35754d885d6216$var$isTSImportEqualsDeclaration;
module.exports.isTSImportType = $1f35754d885d6216$var$isTSImportType;
module.exports.isTSIndexSignature = $1f35754d885d6216$var$isTSIndexSignature;
module.exports.isTSIndexedAccessType = $1f35754d885d6216$var$isTSIndexedAccessType;
module.exports.isTSInferType = $1f35754d885d6216$var$isTSInferType;
module.exports.isTSInstantiationExpression = $1f35754d885d6216$var$isTSInstantiationExpression;
module.exports.isTSInterfaceBody = $1f35754d885d6216$var$isTSInterfaceBody;
module.exports.isTSInterfaceDeclaration = $1f35754d885d6216$var$isTSInterfaceDeclaration;
module.exports.isTSIntersectionType = $1f35754d885d6216$var$isTSIntersectionType;
module.exports.isTSIntrinsicKeyword = $1f35754d885d6216$var$isTSIntrinsicKeyword;
module.exports.isTSLiteralType = $1f35754d885d6216$var$isTSLiteralType;
module.exports.isTSMappedType = $1f35754d885d6216$var$isTSMappedType;
module.exports.isTSMethodSignature = $1f35754d885d6216$var$isTSMethodSignature;
module.exports.isTSModuleBlock = $1f35754d885d6216$var$isTSModuleBlock;
module.exports.isTSModuleDeclaration = $1f35754d885d6216$var$isTSModuleDeclaration;
module.exports.isTSNamedTupleMember = $1f35754d885d6216$var$isTSNamedTupleMember;
module.exports.isTSNamespaceExportDeclaration = $1f35754d885d6216$var$isTSNamespaceExportDeclaration;
module.exports.isTSNeverKeyword = $1f35754d885d6216$var$isTSNeverKeyword;
module.exports.isTSNonNullExpression = $1f35754d885d6216$var$isTSNonNullExpression;
module.exports.isTSNullKeyword = $1f35754d885d6216$var$isTSNullKeyword;
module.exports.isTSNumberKeyword = $1f35754d885d6216$var$isTSNumberKeyword;
module.exports.isTSObjectKeyword = $1f35754d885d6216$var$isTSObjectKeyword;
module.exports.isTSOptionalType = $1f35754d885d6216$var$isTSOptionalType;
module.exports.isTSParameterProperty = $1f35754d885d6216$var$isTSParameterProperty;
module.exports.isTSParenthesizedType = $1f35754d885d6216$var$isTSParenthesizedType;
module.exports.isTSPropertySignature = $1f35754d885d6216$var$isTSPropertySignature;
module.exports.isTSQualifiedName = $1f35754d885d6216$var$isTSQualifiedName;
module.exports.isTSRestType = $1f35754d885d6216$var$isTSRestType;
module.exports.isTSSatisfiesExpression = $1f35754d885d6216$var$isTSSatisfiesExpression;
module.exports.isTSStringKeyword = $1f35754d885d6216$var$isTSStringKeyword;
module.exports.isTSSymbolKeyword = $1f35754d885d6216$var$isTSSymbolKeyword;
module.exports.isTSThisType = $1f35754d885d6216$var$isTSThisType;
module.exports.isTSTupleType = $1f35754d885d6216$var$isTSTupleType;
module.exports.isTSType = $1f35754d885d6216$var$isTSType;
module.exports.isTSTypeAliasDeclaration = $1f35754d885d6216$var$isTSTypeAliasDeclaration;
module.exports.isTSTypeAnnotation = $1f35754d885d6216$var$isTSTypeAnnotation;
module.exports.isTSTypeAssertion = $1f35754d885d6216$var$isTSTypeAssertion;
module.exports.isTSTypeElement = $1f35754d885d6216$var$isTSTypeElement;
module.exports.isTSTypeLiteral = $1f35754d885d6216$var$isTSTypeLiteral;
module.exports.isTSTypeOperator = $1f35754d885d6216$var$isTSTypeOperator;
module.exports.isTSTypeParameter = $1f35754d885d6216$var$isTSTypeParameter;
module.exports.isTSTypeParameterDeclaration = $1f35754d885d6216$var$isTSTypeParameterDeclaration;
module.exports.isTSTypeParameterInstantiation = $1f35754d885d6216$var$isTSTypeParameterInstantiation;
module.exports.isTSTypePredicate = $1f35754d885d6216$var$isTSTypePredicate;
module.exports.isTSTypeQuery = $1f35754d885d6216$var$isTSTypeQuery;
module.exports.isTSTypeReference = $1f35754d885d6216$var$isTSTypeReference;
module.exports.isTSUndefinedKeyword = $1f35754d885d6216$var$isTSUndefinedKeyword;
module.exports.isTSUnionType = $1f35754d885d6216$var$isTSUnionType;
module.exports.isTSUnknownKeyword = $1f35754d885d6216$var$isTSUnknownKeyword;
module.exports.isTSVoidKeyword = $1f35754d885d6216$var$isTSVoidKeyword;
module.exports.isTaggedTemplateExpression = $1f35754d885d6216$var$isTaggedTemplateExpression;
module.exports.isTemplateElement = $1f35754d885d6216$var$isTemplateElement;
module.exports.isTemplateLiteral = $1f35754d885d6216$var$isTemplateLiteral;
module.exports.isTerminatorless = $1f35754d885d6216$var$isTerminatorless;
module.exports.isThisExpression = $1f35754d885d6216$var$isThisExpression;
module.exports.isThisTypeAnnotation = $1f35754d885d6216$var$isThisTypeAnnotation;
module.exports.isThrowStatement = $1f35754d885d6216$var$isThrowStatement;
module.exports.isTopicReference = $1f35754d885d6216$var$isTopicReference;
module.exports.isTryStatement = $1f35754d885d6216$var$isTryStatement;
module.exports.isTupleExpression = $1f35754d885d6216$var$isTupleExpression;
module.exports.isTupleTypeAnnotation = $1f35754d885d6216$var$isTupleTypeAnnotation;
module.exports.isTypeAlias = $1f35754d885d6216$var$isTypeAlias;
module.exports.isTypeAnnotation = $1f35754d885d6216$var$isTypeAnnotation;
module.exports.isTypeCastExpression = $1f35754d885d6216$var$isTypeCastExpression;
module.exports.isTypeParameter = $1f35754d885d6216$var$isTypeParameter;
module.exports.isTypeParameterDeclaration = $1f35754d885d6216$var$isTypeParameterDeclaration;
module.exports.isTypeParameterInstantiation = $1f35754d885d6216$var$isTypeParameterInstantiation;
module.exports.isTypeScript = $1f35754d885d6216$var$isTypeScript;
module.exports.isTypeofTypeAnnotation = $1f35754d885d6216$var$isTypeofTypeAnnotation;
module.exports.isUnaryExpression = $1f35754d885d6216$var$isUnaryExpression;
module.exports.isUnaryLike = $1f35754d885d6216$var$isUnaryLike;
module.exports.isUnionTypeAnnotation = $1f35754d885d6216$var$isUnionTypeAnnotation;
module.exports.isUpdateExpression = $1f35754d885d6216$var$isUpdateExpression;
module.exports.isUserWhitespacable = $1f35754d885d6216$var$isUserWhitespacable;
module.exports.isV8IntrinsicIdentifier = $1f35754d885d6216$var$isV8IntrinsicIdentifier;
module.exports.isVariableDeclaration = $1f35754d885d6216$var$isVariableDeclaration;
module.exports.isVariableDeclarator = $1f35754d885d6216$var$isVariableDeclarator;
module.exports.isVariance = $1f35754d885d6216$var$isVariance;
module.exports.isVoidTypeAnnotation = $1f35754d885d6216$var$isVoidTypeAnnotation;
module.exports.isWhile = $1f35754d885d6216$var$isWhile;
module.exports.isWhileStatement = $1f35754d885d6216$var$isWhileStatement;
module.exports.isWithStatement = $1f35754d885d6216$var$isWithStatement;
module.exports.isYieldExpression = $1f35754d885d6216$var$isYieldExpression;

var $d5ioO = parcelRequire("d5ioO");

var $7sVNt = parcelRequire("7sVNt");
function $1f35754d885d6216$var$isArrayExpression(node, opts) {
    if (!node) return false;
    if (node.type !== "ArrayExpression") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isAssignmentExpression(node, opts) {
    if (!node) return false;
    if (node.type !== "AssignmentExpression") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isBinaryExpression(node, opts) {
    if (!node) return false;
    if (node.type !== "BinaryExpression") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isInterpreterDirective(node, opts) {
    if (!node) return false;
    if (node.type !== "InterpreterDirective") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isDirective(node, opts) {
    if (!node) return false;
    if (node.type !== "Directive") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isDirectiveLiteral(node, opts) {
    if (!node) return false;
    if (node.type !== "DirectiveLiteral") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isBlockStatement(node, opts) {
    if (!node) return false;
    if (node.type !== "BlockStatement") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isBreakStatement(node, opts) {
    if (!node) return false;
    if (node.type !== "BreakStatement") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isCallExpression(node, opts) {
    if (!node) return false;
    if (node.type !== "CallExpression") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isCatchClause(node, opts) {
    if (!node) return false;
    if (node.type !== "CatchClause") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isConditionalExpression(node, opts) {
    if (!node) return false;
    if (node.type !== "ConditionalExpression") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isContinueStatement(node, opts) {
    if (!node) return false;
    if (node.type !== "ContinueStatement") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isDebuggerStatement(node, opts) {
    if (!node) return false;
    if (node.type !== "DebuggerStatement") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isDoWhileStatement(node, opts) {
    if (!node) return false;
    if (node.type !== "DoWhileStatement") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isEmptyStatement(node, opts) {
    if (!node) return false;
    if (node.type !== "EmptyStatement") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isExpressionStatement(node, opts) {
    if (!node) return false;
    if (node.type !== "ExpressionStatement") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isFile(node, opts) {
    if (!node) return false;
    if (node.type !== "File") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isForInStatement(node, opts) {
    if (!node) return false;
    if (node.type !== "ForInStatement") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isForStatement(node, opts) {
    if (!node) return false;
    if (node.type !== "ForStatement") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isFunctionDeclaration(node, opts) {
    if (!node) return false;
    if (node.type !== "FunctionDeclaration") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isFunctionExpression(node, opts) {
    if (!node) return false;
    if (node.type !== "FunctionExpression") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isIdentifier(node, opts) {
    if (!node) return false;
    if (node.type !== "Identifier") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isIfStatement(node, opts) {
    if (!node) return false;
    if (node.type !== "IfStatement") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isLabeledStatement(node, opts) {
    if (!node) return false;
    if (node.type !== "LabeledStatement") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isStringLiteral(node, opts) {
    if (!node) return false;
    if (node.type !== "StringLiteral") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isNumericLiteral(node, opts) {
    if (!node) return false;
    if (node.type !== "NumericLiteral") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isNullLiteral(node, opts) {
    if (!node) return false;
    if (node.type !== "NullLiteral") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isBooleanLiteral(node, opts) {
    if (!node) return false;
    if (node.type !== "BooleanLiteral") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isRegExpLiteral(node, opts) {
    if (!node) return false;
    if (node.type !== "RegExpLiteral") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isLogicalExpression(node, opts) {
    if (!node) return false;
    if (node.type !== "LogicalExpression") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isMemberExpression(node, opts) {
    if (!node) return false;
    if (node.type !== "MemberExpression") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isNewExpression(node, opts) {
    if (!node) return false;
    if (node.type !== "NewExpression") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isProgram(node, opts) {
    if (!node) return false;
    if (node.type !== "Program") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isObjectExpression(node, opts) {
    if (!node) return false;
    if (node.type !== "ObjectExpression") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isObjectMethod(node, opts) {
    if (!node) return false;
    if (node.type !== "ObjectMethod") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isObjectProperty(node, opts) {
    if (!node) return false;
    if (node.type !== "ObjectProperty") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isRestElement(node, opts) {
    if (!node) return false;
    if (node.type !== "RestElement") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isReturnStatement(node, opts) {
    if (!node) return false;
    if (node.type !== "ReturnStatement") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isSequenceExpression(node, opts) {
    if (!node) return false;
    if (node.type !== "SequenceExpression") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isParenthesizedExpression(node, opts) {
    if (!node) return false;
    if (node.type !== "ParenthesizedExpression") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isSwitchCase(node, opts) {
    if (!node) return false;
    if (node.type !== "SwitchCase") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isSwitchStatement(node, opts) {
    if (!node) return false;
    if (node.type !== "SwitchStatement") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isThisExpression(node, opts) {
    if (!node) return false;
    if (node.type !== "ThisExpression") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isThrowStatement(node, opts) {
    if (!node) return false;
    if (node.type !== "ThrowStatement") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isTryStatement(node, opts) {
    if (!node) return false;
    if (node.type !== "TryStatement") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isUnaryExpression(node, opts) {
    if (!node) return false;
    if (node.type !== "UnaryExpression") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isUpdateExpression(node, opts) {
    if (!node) return false;
    if (node.type !== "UpdateExpression") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isVariableDeclaration(node, opts) {
    if (!node) return false;
    if (node.type !== "VariableDeclaration") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isVariableDeclarator(node, opts) {
    if (!node) return false;
    if (node.type !== "VariableDeclarator") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isWhileStatement(node, opts) {
    if (!node) return false;
    if (node.type !== "WhileStatement") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isWithStatement(node, opts) {
    if (!node) return false;
    if (node.type !== "WithStatement") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isAssignmentPattern(node, opts) {
    if (!node) return false;
    if (node.type !== "AssignmentPattern") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isArrayPattern(node, opts) {
    if (!node) return false;
    if (node.type !== "ArrayPattern") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isArrowFunctionExpression(node, opts) {
    if (!node) return false;
    if (node.type !== "ArrowFunctionExpression") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isClassBody(node, opts) {
    if (!node) return false;
    if (node.type !== "ClassBody") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isClassExpression(node, opts) {
    if (!node) return false;
    if (node.type !== "ClassExpression") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isClassDeclaration(node, opts) {
    if (!node) return false;
    if (node.type !== "ClassDeclaration") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isExportAllDeclaration(node, opts) {
    if (!node) return false;
    if (node.type !== "ExportAllDeclaration") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isExportDefaultDeclaration(node, opts) {
    if (!node) return false;
    if (node.type !== "ExportDefaultDeclaration") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isExportNamedDeclaration(node, opts) {
    if (!node) return false;
    if (node.type !== "ExportNamedDeclaration") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isExportSpecifier(node, opts) {
    if (!node) return false;
    if (node.type !== "ExportSpecifier") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isForOfStatement(node, opts) {
    if (!node) return false;
    if (node.type !== "ForOfStatement") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isImportDeclaration(node, opts) {
    if (!node) return false;
    if (node.type !== "ImportDeclaration") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isImportDefaultSpecifier(node, opts) {
    if (!node) return false;
    if (node.type !== "ImportDefaultSpecifier") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isImportNamespaceSpecifier(node, opts) {
    if (!node) return false;
    if (node.type !== "ImportNamespaceSpecifier") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isImportSpecifier(node, opts) {
    if (!node) return false;
    if (node.type !== "ImportSpecifier") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isImportExpression(node, opts) {
    if (!node) return false;
    if (node.type !== "ImportExpression") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isMetaProperty(node, opts) {
    if (!node) return false;
    if (node.type !== "MetaProperty") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isClassMethod(node, opts) {
    if (!node) return false;
    if (node.type !== "ClassMethod") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isObjectPattern(node, opts) {
    if (!node) return false;
    if (node.type !== "ObjectPattern") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isSpreadElement(node, opts) {
    if (!node) return false;
    if (node.type !== "SpreadElement") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isSuper(node, opts) {
    if (!node) return false;
    if (node.type !== "Super") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isTaggedTemplateExpression(node, opts) {
    if (!node) return false;
    if (node.type !== "TaggedTemplateExpression") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isTemplateElement(node, opts) {
    if (!node) return false;
    if (node.type !== "TemplateElement") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isTemplateLiteral(node, opts) {
    if (!node) return false;
    if (node.type !== "TemplateLiteral") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isYieldExpression(node, opts) {
    if (!node) return false;
    if (node.type !== "YieldExpression") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isAwaitExpression(node, opts) {
    if (!node) return false;
    if (node.type !== "AwaitExpression") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isImport(node, opts) {
    if (!node) return false;
    if (node.type !== "Import") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isBigIntLiteral(node, opts) {
    if (!node) return false;
    if (node.type !== "BigIntLiteral") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isExportNamespaceSpecifier(node, opts) {
    if (!node) return false;
    if (node.type !== "ExportNamespaceSpecifier") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isOptionalMemberExpression(node, opts) {
    if (!node) return false;
    if (node.type !== "OptionalMemberExpression") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isOptionalCallExpression(node, opts) {
    if (!node) return false;
    if (node.type !== "OptionalCallExpression") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isClassProperty(node, opts) {
    if (!node) return false;
    if (node.type !== "ClassProperty") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isClassAccessorProperty(node, opts) {
    if (!node) return false;
    if (node.type !== "ClassAccessorProperty") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isClassPrivateProperty(node, opts) {
    if (!node) return false;
    if (node.type !== "ClassPrivateProperty") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isClassPrivateMethod(node, opts) {
    if (!node) return false;
    if (node.type !== "ClassPrivateMethod") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isPrivateName(node, opts) {
    if (!node) return false;
    if (node.type !== "PrivateName") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isStaticBlock(node, opts) {
    if (!node) return false;
    if (node.type !== "StaticBlock") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isAnyTypeAnnotation(node, opts) {
    if (!node) return false;
    if (node.type !== "AnyTypeAnnotation") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isArrayTypeAnnotation(node, opts) {
    if (!node) return false;
    if (node.type !== "ArrayTypeAnnotation") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isBooleanTypeAnnotation(node, opts) {
    if (!node) return false;
    if (node.type !== "BooleanTypeAnnotation") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isBooleanLiteralTypeAnnotation(node, opts) {
    if (!node) return false;
    if (node.type !== "BooleanLiteralTypeAnnotation") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isNullLiteralTypeAnnotation(node, opts) {
    if (!node) return false;
    if (node.type !== "NullLiteralTypeAnnotation") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isClassImplements(node, opts) {
    if (!node) return false;
    if (node.type !== "ClassImplements") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isDeclareClass(node, opts) {
    if (!node) return false;
    if (node.type !== "DeclareClass") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isDeclareFunction(node, opts) {
    if (!node) return false;
    if (node.type !== "DeclareFunction") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isDeclareInterface(node, opts) {
    if (!node) return false;
    if (node.type !== "DeclareInterface") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isDeclareModule(node, opts) {
    if (!node) return false;
    if (node.type !== "DeclareModule") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isDeclareModuleExports(node, opts) {
    if (!node) return false;
    if (node.type !== "DeclareModuleExports") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isDeclareTypeAlias(node, opts) {
    if (!node) return false;
    if (node.type !== "DeclareTypeAlias") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isDeclareOpaqueType(node, opts) {
    if (!node) return false;
    if (node.type !== "DeclareOpaqueType") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isDeclareVariable(node, opts) {
    if (!node) return false;
    if (node.type !== "DeclareVariable") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isDeclareExportDeclaration(node, opts) {
    if (!node) return false;
    if (node.type !== "DeclareExportDeclaration") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isDeclareExportAllDeclaration(node, opts) {
    if (!node) return false;
    if (node.type !== "DeclareExportAllDeclaration") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isDeclaredPredicate(node, opts) {
    if (!node) return false;
    if (node.type !== "DeclaredPredicate") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isExistsTypeAnnotation(node, opts) {
    if (!node) return false;
    if (node.type !== "ExistsTypeAnnotation") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isFunctionTypeAnnotation(node, opts) {
    if (!node) return false;
    if (node.type !== "FunctionTypeAnnotation") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isFunctionTypeParam(node, opts) {
    if (!node) return false;
    if (node.type !== "FunctionTypeParam") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isGenericTypeAnnotation(node, opts) {
    if (!node) return false;
    if (node.type !== "GenericTypeAnnotation") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isInferredPredicate(node, opts) {
    if (!node) return false;
    if (node.type !== "InferredPredicate") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isInterfaceExtends(node, opts) {
    if (!node) return false;
    if (node.type !== "InterfaceExtends") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isInterfaceDeclaration(node, opts) {
    if (!node) return false;
    if (node.type !== "InterfaceDeclaration") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isInterfaceTypeAnnotation(node, opts) {
    if (!node) return false;
    if (node.type !== "InterfaceTypeAnnotation") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isIntersectionTypeAnnotation(node, opts) {
    if (!node) return false;
    if (node.type !== "IntersectionTypeAnnotation") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isMixedTypeAnnotation(node, opts) {
    if (!node) return false;
    if (node.type !== "MixedTypeAnnotation") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isEmptyTypeAnnotation(node, opts) {
    if (!node) return false;
    if (node.type !== "EmptyTypeAnnotation") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isNullableTypeAnnotation(node, opts) {
    if (!node) return false;
    if (node.type !== "NullableTypeAnnotation") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isNumberLiteralTypeAnnotation(node, opts) {
    if (!node) return false;
    if (node.type !== "NumberLiteralTypeAnnotation") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isNumberTypeAnnotation(node, opts) {
    if (!node) return false;
    if (node.type !== "NumberTypeAnnotation") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isObjectTypeAnnotation(node, opts) {
    if (!node) return false;
    if (node.type !== "ObjectTypeAnnotation") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isObjectTypeInternalSlot(node, opts) {
    if (!node) return false;
    if (node.type !== "ObjectTypeInternalSlot") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isObjectTypeCallProperty(node, opts) {
    if (!node) return false;
    if (node.type !== "ObjectTypeCallProperty") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isObjectTypeIndexer(node, opts) {
    if (!node) return false;
    if (node.type !== "ObjectTypeIndexer") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isObjectTypeProperty(node, opts) {
    if (!node) return false;
    if (node.type !== "ObjectTypeProperty") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isObjectTypeSpreadProperty(node, opts) {
    if (!node) return false;
    if (node.type !== "ObjectTypeSpreadProperty") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isOpaqueType(node, opts) {
    if (!node) return false;
    if (node.type !== "OpaqueType") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isQualifiedTypeIdentifier(node, opts) {
    if (!node) return false;
    if (node.type !== "QualifiedTypeIdentifier") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isStringLiteralTypeAnnotation(node, opts) {
    if (!node) return false;
    if (node.type !== "StringLiteralTypeAnnotation") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isStringTypeAnnotation(node, opts) {
    if (!node) return false;
    if (node.type !== "StringTypeAnnotation") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isSymbolTypeAnnotation(node, opts) {
    if (!node) return false;
    if (node.type !== "SymbolTypeAnnotation") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isThisTypeAnnotation(node, opts) {
    if (!node) return false;
    if (node.type !== "ThisTypeAnnotation") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isTupleTypeAnnotation(node, opts) {
    if (!node) return false;
    if (node.type !== "TupleTypeAnnotation") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isTypeofTypeAnnotation(node, opts) {
    if (!node) return false;
    if (node.type !== "TypeofTypeAnnotation") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isTypeAlias(node, opts) {
    if (!node) return false;
    if (node.type !== "TypeAlias") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isTypeAnnotation(node, opts) {
    if (!node) return false;
    if (node.type !== "TypeAnnotation") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isTypeCastExpression(node, opts) {
    if (!node) return false;
    if (node.type !== "TypeCastExpression") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isTypeParameter(node, opts) {
    if (!node) return false;
    if (node.type !== "TypeParameter") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isTypeParameterDeclaration(node, opts) {
    if (!node) return false;
    if (node.type !== "TypeParameterDeclaration") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isTypeParameterInstantiation(node, opts) {
    if (!node) return false;
    if (node.type !== "TypeParameterInstantiation") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isUnionTypeAnnotation(node, opts) {
    if (!node) return false;
    if (node.type !== "UnionTypeAnnotation") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isVariance(node, opts) {
    if (!node) return false;
    if (node.type !== "Variance") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isVoidTypeAnnotation(node, opts) {
    if (!node) return false;
    if (node.type !== "VoidTypeAnnotation") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isEnumDeclaration(node, opts) {
    if (!node) return false;
    if (node.type !== "EnumDeclaration") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isEnumBooleanBody(node, opts) {
    if (!node) return false;
    if (node.type !== "EnumBooleanBody") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isEnumNumberBody(node, opts) {
    if (!node) return false;
    if (node.type !== "EnumNumberBody") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isEnumStringBody(node, opts) {
    if (!node) return false;
    if (node.type !== "EnumStringBody") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isEnumSymbolBody(node, opts) {
    if (!node) return false;
    if (node.type !== "EnumSymbolBody") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isEnumBooleanMember(node, opts) {
    if (!node) return false;
    if (node.type !== "EnumBooleanMember") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isEnumNumberMember(node, opts) {
    if (!node) return false;
    if (node.type !== "EnumNumberMember") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isEnumStringMember(node, opts) {
    if (!node) return false;
    if (node.type !== "EnumStringMember") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isEnumDefaultedMember(node, opts) {
    if (!node) return false;
    if (node.type !== "EnumDefaultedMember") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isIndexedAccessType(node, opts) {
    if (!node) return false;
    if (node.type !== "IndexedAccessType") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isOptionalIndexedAccessType(node, opts) {
    if (!node) return false;
    if (node.type !== "OptionalIndexedAccessType") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isJSXAttribute(node, opts) {
    if (!node) return false;
    if (node.type !== "JSXAttribute") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isJSXClosingElement(node, opts) {
    if (!node) return false;
    if (node.type !== "JSXClosingElement") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isJSXElement(node, opts) {
    if (!node) return false;
    if (node.type !== "JSXElement") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isJSXEmptyExpression(node, opts) {
    if (!node) return false;
    if (node.type !== "JSXEmptyExpression") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isJSXExpressionContainer(node, opts) {
    if (!node) return false;
    if (node.type !== "JSXExpressionContainer") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isJSXSpreadChild(node, opts) {
    if (!node) return false;
    if (node.type !== "JSXSpreadChild") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isJSXIdentifier(node, opts) {
    if (!node) return false;
    if (node.type !== "JSXIdentifier") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isJSXMemberExpression(node, opts) {
    if (!node) return false;
    if (node.type !== "JSXMemberExpression") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isJSXNamespacedName(node, opts) {
    if (!node) return false;
    if (node.type !== "JSXNamespacedName") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isJSXOpeningElement(node, opts) {
    if (!node) return false;
    if (node.type !== "JSXOpeningElement") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isJSXSpreadAttribute(node, opts) {
    if (!node) return false;
    if (node.type !== "JSXSpreadAttribute") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isJSXText(node, opts) {
    if (!node) return false;
    if (node.type !== "JSXText") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isJSXFragment(node, opts) {
    if (!node) return false;
    if (node.type !== "JSXFragment") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isJSXOpeningFragment(node, opts) {
    if (!node) return false;
    if (node.type !== "JSXOpeningFragment") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isJSXClosingFragment(node, opts) {
    if (!node) return false;
    if (node.type !== "JSXClosingFragment") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isNoop(node, opts) {
    if (!node) return false;
    if (node.type !== "Noop") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isPlaceholder(node, opts) {
    if (!node) return false;
    if (node.type !== "Placeholder") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isV8IntrinsicIdentifier(node, opts) {
    if (!node) return false;
    if (node.type !== "V8IntrinsicIdentifier") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isArgumentPlaceholder(node, opts) {
    if (!node) return false;
    if (node.type !== "ArgumentPlaceholder") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isBindExpression(node, opts) {
    if (!node) return false;
    if (node.type !== "BindExpression") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isImportAttribute(node, opts) {
    if (!node) return false;
    if (node.type !== "ImportAttribute") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isDecorator(node, opts) {
    if (!node) return false;
    if (node.type !== "Decorator") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isDoExpression(node, opts) {
    if (!node) return false;
    if (node.type !== "DoExpression") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isExportDefaultSpecifier(node, opts) {
    if (!node) return false;
    if (node.type !== "ExportDefaultSpecifier") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isRecordExpression(node, opts) {
    if (!node) return false;
    if (node.type !== "RecordExpression") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isTupleExpression(node, opts) {
    if (!node) return false;
    if (node.type !== "TupleExpression") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isDecimalLiteral(node, opts) {
    if (!node) return false;
    if (node.type !== "DecimalLiteral") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isModuleExpression(node, opts) {
    if (!node) return false;
    if (node.type !== "ModuleExpression") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isTopicReference(node, opts) {
    if (!node) return false;
    if (node.type !== "TopicReference") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isPipelineTopicExpression(node, opts) {
    if (!node) return false;
    if (node.type !== "PipelineTopicExpression") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isPipelineBareFunction(node, opts) {
    if (!node) return false;
    if (node.type !== "PipelineBareFunction") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isPipelinePrimaryTopicReference(node, opts) {
    if (!node) return false;
    if (node.type !== "PipelinePrimaryTopicReference") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isTSParameterProperty(node, opts) {
    if (!node) return false;
    if (node.type !== "TSParameterProperty") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isTSDeclareFunction(node, opts) {
    if (!node) return false;
    if (node.type !== "TSDeclareFunction") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isTSDeclareMethod(node, opts) {
    if (!node) return false;
    if (node.type !== "TSDeclareMethod") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isTSQualifiedName(node, opts) {
    if (!node) return false;
    if (node.type !== "TSQualifiedName") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isTSCallSignatureDeclaration(node, opts) {
    if (!node) return false;
    if (node.type !== "TSCallSignatureDeclaration") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isTSConstructSignatureDeclaration(node, opts) {
    if (!node) return false;
    if (node.type !== "TSConstructSignatureDeclaration") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isTSPropertySignature(node, opts) {
    if (!node) return false;
    if (node.type !== "TSPropertySignature") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isTSMethodSignature(node, opts) {
    if (!node) return false;
    if (node.type !== "TSMethodSignature") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isTSIndexSignature(node, opts) {
    if (!node) return false;
    if (node.type !== "TSIndexSignature") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isTSAnyKeyword(node, opts) {
    if (!node) return false;
    if (node.type !== "TSAnyKeyword") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isTSBooleanKeyword(node, opts) {
    if (!node) return false;
    if (node.type !== "TSBooleanKeyword") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isTSBigIntKeyword(node, opts) {
    if (!node) return false;
    if (node.type !== "TSBigIntKeyword") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isTSIntrinsicKeyword(node, opts) {
    if (!node) return false;
    if (node.type !== "TSIntrinsicKeyword") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isTSNeverKeyword(node, opts) {
    if (!node) return false;
    if (node.type !== "TSNeverKeyword") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isTSNullKeyword(node, opts) {
    if (!node) return false;
    if (node.type !== "TSNullKeyword") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isTSNumberKeyword(node, opts) {
    if (!node) return false;
    if (node.type !== "TSNumberKeyword") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isTSObjectKeyword(node, opts) {
    if (!node) return false;
    if (node.type !== "TSObjectKeyword") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isTSStringKeyword(node, opts) {
    if (!node) return false;
    if (node.type !== "TSStringKeyword") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isTSSymbolKeyword(node, opts) {
    if (!node) return false;
    if (node.type !== "TSSymbolKeyword") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isTSUndefinedKeyword(node, opts) {
    if (!node) return false;
    if (node.type !== "TSUndefinedKeyword") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isTSUnknownKeyword(node, opts) {
    if (!node) return false;
    if (node.type !== "TSUnknownKeyword") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isTSVoidKeyword(node, opts) {
    if (!node) return false;
    if (node.type !== "TSVoidKeyword") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isTSThisType(node, opts) {
    if (!node) return false;
    if (node.type !== "TSThisType") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isTSFunctionType(node, opts) {
    if (!node) return false;
    if (node.type !== "TSFunctionType") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isTSConstructorType(node, opts) {
    if (!node) return false;
    if (node.type !== "TSConstructorType") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isTSTypeReference(node, opts) {
    if (!node) return false;
    if (node.type !== "TSTypeReference") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isTSTypePredicate(node, opts) {
    if (!node) return false;
    if (node.type !== "TSTypePredicate") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isTSTypeQuery(node, opts) {
    if (!node) return false;
    if (node.type !== "TSTypeQuery") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isTSTypeLiteral(node, opts) {
    if (!node) return false;
    if (node.type !== "TSTypeLiteral") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isTSArrayType(node, opts) {
    if (!node) return false;
    if (node.type !== "TSArrayType") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isTSTupleType(node, opts) {
    if (!node) return false;
    if (node.type !== "TSTupleType") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isTSOptionalType(node, opts) {
    if (!node) return false;
    if (node.type !== "TSOptionalType") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isTSRestType(node, opts) {
    if (!node) return false;
    if (node.type !== "TSRestType") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isTSNamedTupleMember(node, opts) {
    if (!node) return false;
    if (node.type !== "TSNamedTupleMember") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isTSUnionType(node, opts) {
    if (!node) return false;
    if (node.type !== "TSUnionType") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isTSIntersectionType(node, opts) {
    if (!node) return false;
    if (node.type !== "TSIntersectionType") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isTSConditionalType(node, opts) {
    if (!node) return false;
    if (node.type !== "TSConditionalType") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isTSInferType(node, opts) {
    if (!node) return false;
    if (node.type !== "TSInferType") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isTSParenthesizedType(node, opts) {
    if (!node) return false;
    if (node.type !== "TSParenthesizedType") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isTSTypeOperator(node, opts) {
    if (!node) return false;
    if (node.type !== "TSTypeOperator") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isTSIndexedAccessType(node, opts) {
    if (!node) return false;
    if (node.type !== "TSIndexedAccessType") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isTSMappedType(node, opts) {
    if (!node) return false;
    if (node.type !== "TSMappedType") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isTSLiteralType(node, opts) {
    if (!node) return false;
    if (node.type !== "TSLiteralType") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isTSExpressionWithTypeArguments(node, opts) {
    if (!node) return false;
    if (node.type !== "TSExpressionWithTypeArguments") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isTSInterfaceDeclaration(node, opts) {
    if (!node) return false;
    if (node.type !== "TSInterfaceDeclaration") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isTSInterfaceBody(node, opts) {
    if (!node) return false;
    if (node.type !== "TSInterfaceBody") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isTSTypeAliasDeclaration(node, opts) {
    if (!node) return false;
    if (node.type !== "TSTypeAliasDeclaration") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isTSInstantiationExpression(node, opts) {
    if (!node) return false;
    if (node.type !== "TSInstantiationExpression") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isTSAsExpression(node, opts) {
    if (!node) return false;
    if (node.type !== "TSAsExpression") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isTSSatisfiesExpression(node, opts) {
    if (!node) return false;
    if (node.type !== "TSSatisfiesExpression") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isTSTypeAssertion(node, opts) {
    if (!node) return false;
    if (node.type !== "TSTypeAssertion") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isTSEnumDeclaration(node, opts) {
    if (!node) return false;
    if (node.type !== "TSEnumDeclaration") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isTSEnumMember(node, opts) {
    if (!node) return false;
    if (node.type !== "TSEnumMember") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isTSModuleDeclaration(node, opts) {
    if (!node) return false;
    if (node.type !== "TSModuleDeclaration") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isTSModuleBlock(node, opts) {
    if (!node) return false;
    if (node.type !== "TSModuleBlock") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isTSImportType(node, opts) {
    if (!node) return false;
    if (node.type !== "TSImportType") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isTSImportEqualsDeclaration(node, opts) {
    if (!node) return false;
    if (node.type !== "TSImportEqualsDeclaration") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isTSExternalModuleReference(node, opts) {
    if (!node) return false;
    if (node.type !== "TSExternalModuleReference") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isTSNonNullExpression(node, opts) {
    if (!node) return false;
    if (node.type !== "TSNonNullExpression") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isTSExportAssignment(node, opts) {
    if (!node) return false;
    if (node.type !== "TSExportAssignment") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isTSNamespaceExportDeclaration(node, opts) {
    if (!node) return false;
    if (node.type !== "TSNamespaceExportDeclaration") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isTSTypeAnnotation(node, opts) {
    if (!node) return false;
    if (node.type !== "TSTypeAnnotation") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isTSTypeParameterInstantiation(node, opts) {
    if (!node) return false;
    if (node.type !== "TSTypeParameterInstantiation") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isTSTypeParameterDeclaration(node, opts) {
    if (!node) return false;
    if (node.type !== "TSTypeParameterDeclaration") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isTSTypeParameter(node, opts) {
    if (!node) return false;
    if (node.type !== "TSTypeParameter") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isStandardized(node, opts) {
    if (!node) return false;
    switch(node.type){
        case "ArrayExpression":
        case "AssignmentExpression":
        case "BinaryExpression":
        case "InterpreterDirective":
        case "Directive":
        case "DirectiveLiteral":
        case "BlockStatement":
        case "BreakStatement":
        case "CallExpression":
        case "CatchClause":
        case "ConditionalExpression":
        case "ContinueStatement":
        case "DebuggerStatement":
        case "DoWhileStatement":
        case "EmptyStatement":
        case "ExpressionStatement":
        case "File":
        case "ForInStatement":
        case "ForStatement":
        case "FunctionDeclaration":
        case "FunctionExpression":
        case "Identifier":
        case "IfStatement":
        case "LabeledStatement":
        case "StringLiteral":
        case "NumericLiteral":
        case "NullLiteral":
        case "BooleanLiteral":
        case "RegExpLiteral":
        case "LogicalExpression":
        case "MemberExpression":
        case "NewExpression":
        case "Program":
        case "ObjectExpression":
        case "ObjectMethod":
        case "ObjectProperty":
        case "RestElement":
        case "ReturnStatement":
        case "SequenceExpression":
        case "ParenthesizedExpression":
        case "SwitchCase":
        case "SwitchStatement":
        case "ThisExpression":
        case "ThrowStatement":
        case "TryStatement":
        case "UnaryExpression":
        case "UpdateExpression":
        case "VariableDeclaration":
        case "VariableDeclarator":
        case "WhileStatement":
        case "WithStatement":
        case "AssignmentPattern":
        case "ArrayPattern":
        case "ArrowFunctionExpression":
        case "ClassBody":
        case "ClassExpression":
        case "ClassDeclaration":
        case "ExportAllDeclaration":
        case "ExportDefaultDeclaration":
        case "ExportNamedDeclaration":
        case "ExportSpecifier":
        case "ForOfStatement":
        case "ImportDeclaration":
        case "ImportDefaultSpecifier":
        case "ImportNamespaceSpecifier":
        case "ImportSpecifier":
        case "ImportExpression":
        case "MetaProperty":
        case "ClassMethod":
        case "ObjectPattern":
        case "SpreadElement":
        case "Super":
        case "TaggedTemplateExpression":
        case "TemplateElement":
        case "TemplateLiteral":
        case "YieldExpression":
        case "AwaitExpression":
        case "Import":
        case "BigIntLiteral":
        case "ExportNamespaceSpecifier":
        case "OptionalMemberExpression":
        case "OptionalCallExpression":
        case "ClassProperty":
        case "ClassAccessorProperty":
        case "ClassPrivateProperty":
        case "ClassPrivateMethod":
        case "PrivateName":
        case "StaticBlock":
            break;
        case "Placeholder":
            switch(node.expectedNode){
                case "Identifier":
                case "StringLiteral":
                case "BlockStatement":
                case "ClassBody":
                    break;
                default:
                    return false;
            }
            break;
        default:
            return false;
    }
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isExpression(node, opts) {
    if (!node) return false;
    switch(node.type){
        case "ArrayExpression":
        case "AssignmentExpression":
        case "BinaryExpression":
        case "CallExpression":
        case "ConditionalExpression":
        case "FunctionExpression":
        case "Identifier":
        case "StringLiteral":
        case "NumericLiteral":
        case "NullLiteral":
        case "BooleanLiteral":
        case "RegExpLiteral":
        case "LogicalExpression":
        case "MemberExpression":
        case "NewExpression":
        case "ObjectExpression":
        case "SequenceExpression":
        case "ParenthesizedExpression":
        case "ThisExpression":
        case "UnaryExpression":
        case "UpdateExpression":
        case "ArrowFunctionExpression":
        case "ClassExpression":
        case "ImportExpression":
        case "MetaProperty":
        case "Super":
        case "TaggedTemplateExpression":
        case "TemplateLiteral":
        case "YieldExpression":
        case "AwaitExpression":
        case "Import":
        case "BigIntLiteral":
        case "OptionalMemberExpression":
        case "OptionalCallExpression":
        case "TypeCastExpression":
        case "JSXElement":
        case "JSXFragment":
        case "BindExpression":
        case "DoExpression":
        case "RecordExpression":
        case "TupleExpression":
        case "DecimalLiteral":
        case "ModuleExpression":
        case "TopicReference":
        case "PipelineTopicExpression":
        case "PipelineBareFunction":
        case "PipelinePrimaryTopicReference":
        case "TSInstantiationExpression":
        case "TSAsExpression":
        case "TSSatisfiesExpression":
        case "TSTypeAssertion":
        case "TSNonNullExpression":
            break;
        case "Placeholder":
            switch(node.expectedNode){
                case "Expression":
                case "Identifier":
                case "StringLiteral":
                    break;
                default:
                    return false;
            }
            break;
        default:
            return false;
    }
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isBinary(node, opts) {
    if (!node) return false;
    switch(node.type){
        case "BinaryExpression":
        case "LogicalExpression":
            break;
        default:
            return false;
    }
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isScopable(node, opts) {
    if (!node) return false;
    switch(node.type){
        case "BlockStatement":
        case "CatchClause":
        case "DoWhileStatement":
        case "ForInStatement":
        case "ForStatement":
        case "FunctionDeclaration":
        case "FunctionExpression":
        case "Program":
        case "ObjectMethod":
        case "SwitchStatement":
        case "WhileStatement":
        case "ArrowFunctionExpression":
        case "ClassExpression":
        case "ClassDeclaration":
        case "ForOfStatement":
        case "ClassMethod":
        case "ClassPrivateMethod":
        case "StaticBlock":
        case "TSModuleBlock":
            break;
        case "Placeholder":
            if (node.expectedNode === "BlockStatement") break;
        default:
            return false;
    }
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isBlockParent(node, opts) {
    if (!node) return false;
    switch(node.type){
        case "BlockStatement":
        case "CatchClause":
        case "DoWhileStatement":
        case "ForInStatement":
        case "ForStatement":
        case "FunctionDeclaration":
        case "FunctionExpression":
        case "Program":
        case "ObjectMethod":
        case "SwitchStatement":
        case "WhileStatement":
        case "ArrowFunctionExpression":
        case "ForOfStatement":
        case "ClassMethod":
        case "ClassPrivateMethod":
        case "StaticBlock":
        case "TSModuleBlock":
            break;
        case "Placeholder":
            if (node.expectedNode === "BlockStatement") break;
        default:
            return false;
    }
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isBlock(node, opts) {
    if (!node) return false;
    switch(node.type){
        case "BlockStatement":
        case "Program":
        case "TSModuleBlock":
            break;
        case "Placeholder":
            if (node.expectedNode === "BlockStatement") break;
        default:
            return false;
    }
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isStatement(node, opts) {
    if (!node) return false;
    switch(node.type){
        case "BlockStatement":
        case "BreakStatement":
        case "ContinueStatement":
        case "DebuggerStatement":
        case "DoWhileStatement":
        case "EmptyStatement":
        case "ExpressionStatement":
        case "ForInStatement":
        case "ForStatement":
        case "FunctionDeclaration":
        case "IfStatement":
        case "LabeledStatement":
        case "ReturnStatement":
        case "SwitchStatement":
        case "ThrowStatement":
        case "TryStatement":
        case "VariableDeclaration":
        case "WhileStatement":
        case "WithStatement":
        case "ClassDeclaration":
        case "ExportAllDeclaration":
        case "ExportDefaultDeclaration":
        case "ExportNamedDeclaration":
        case "ForOfStatement":
        case "ImportDeclaration":
        case "DeclareClass":
        case "DeclareFunction":
        case "DeclareInterface":
        case "DeclareModule":
        case "DeclareModuleExports":
        case "DeclareTypeAlias":
        case "DeclareOpaqueType":
        case "DeclareVariable":
        case "DeclareExportDeclaration":
        case "DeclareExportAllDeclaration":
        case "InterfaceDeclaration":
        case "OpaqueType":
        case "TypeAlias":
        case "EnumDeclaration":
        case "TSDeclareFunction":
        case "TSInterfaceDeclaration":
        case "TSTypeAliasDeclaration":
        case "TSEnumDeclaration":
        case "TSModuleDeclaration":
        case "TSImportEqualsDeclaration":
        case "TSExportAssignment":
        case "TSNamespaceExportDeclaration":
            break;
        case "Placeholder":
            switch(node.expectedNode){
                case "Statement":
                case "Declaration":
                case "BlockStatement":
                    break;
                default:
                    return false;
            }
            break;
        default:
            return false;
    }
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isTerminatorless(node, opts) {
    if (!node) return false;
    switch(node.type){
        case "BreakStatement":
        case "ContinueStatement":
        case "ReturnStatement":
        case "ThrowStatement":
        case "YieldExpression":
        case "AwaitExpression":
            break;
        default:
            return false;
    }
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isCompletionStatement(node, opts) {
    if (!node) return false;
    switch(node.type){
        case "BreakStatement":
        case "ContinueStatement":
        case "ReturnStatement":
        case "ThrowStatement":
            break;
        default:
            return false;
    }
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isConditional(node, opts) {
    if (!node) return false;
    switch(node.type){
        case "ConditionalExpression":
        case "IfStatement":
            break;
        default:
            return false;
    }
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isLoop(node, opts) {
    if (!node) return false;
    switch(node.type){
        case "DoWhileStatement":
        case "ForInStatement":
        case "ForStatement":
        case "WhileStatement":
        case "ForOfStatement":
            break;
        default:
            return false;
    }
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isWhile(node, opts) {
    if (!node) return false;
    switch(node.type){
        case "DoWhileStatement":
        case "WhileStatement":
            break;
        default:
            return false;
    }
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isExpressionWrapper(node, opts) {
    if (!node) return false;
    switch(node.type){
        case "ExpressionStatement":
        case "ParenthesizedExpression":
        case "TypeCastExpression":
            break;
        default:
            return false;
    }
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isFor(node, opts) {
    if (!node) return false;
    switch(node.type){
        case "ForInStatement":
        case "ForStatement":
        case "ForOfStatement":
            break;
        default:
            return false;
    }
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isForXStatement(node, opts) {
    if (!node) return false;
    switch(node.type){
        case "ForInStatement":
        case "ForOfStatement":
            break;
        default:
            return false;
    }
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isFunction(node, opts) {
    if (!node) return false;
    switch(node.type){
        case "FunctionDeclaration":
        case "FunctionExpression":
        case "ObjectMethod":
        case "ArrowFunctionExpression":
        case "ClassMethod":
        case "ClassPrivateMethod":
            break;
        default:
            return false;
    }
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isFunctionParent(node, opts) {
    if (!node) return false;
    switch(node.type){
        case "FunctionDeclaration":
        case "FunctionExpression":
        case "ObjectMethod":
        case "ArrowFunctionExpression":
        case "ClassMethod":
        case "ClassPrivateMethod":
        case "StaticBlock":
        case "TSModuleBlock":
            break;
        default:
            return false;
    }
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isPureish(node, opts) {
    if (!node) return false;
    switch(node.type){
        case "FunctionDeclaration":
        case "FunctionExpression":
        case "StringLiteral":
        case "NumericLiteral":
        case "NullLiteral":
        case "BooleanLiteral":
        case "RegExpLiteral":
        case "ArrowFunctionExpression":
        case "BigIntLiteral":
        case "DecimalLiteral":
            break;
        case "Placeholder":
            if (node.expectedNode === "StringLiteral") break;
        default:
            return false;
    }
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isDeclaration(node, opts) {
    if (!node) return false;
    switch(node.type){
        case "FunctionDeclaration":
        case "VariableDeclaration":
        case "ClassDeclaration":
        case "ExportAllDeclaration":
        case "ExportDefaultDeclaration":
        case "ExportNamedDeclaration":
        case "ImportDeclaration":
        case "DeclareClass":
        case "DeclareFunction":
        case "DeclareInterface":
        case "DeclareModule":
        case "DeclareModuleExports":
        case "DeclareTypeAlias":
        case "DeclareOpaqueType":
        case "DeclareVariable":
        case "DeclareExportDeclaration":
        case "DeclareExportAllDeclaration":
        case "InterfaceDeclaration":
        case "OpaqueType":
        case "TypeAlias":
        case "EnumDeclaration":
        case "TSDeclareFunction":
        case "TSInterfaceDeclaration":
        case "TSTypeAliasDeclaration":
        case "TSEnumDeclaration":
        case "TSModuleDeclaration":
            break;
        case "Placeholder":
            if (node.expectedNode === "Declaration") break;
        default:
            return false;
    }
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isPatternLike(node, opts) {
    if (!node) return false;
    switch(node.type){
        case "Identifier":
        case "RestElement":
        case "AssignmentPattern":
        case "ArrayPattern":
        case "ObjectPattern":
        case "TSAsExpression":
        case "TSSatisfiesExpression":
        case "TSTypeAssertion":
        case "TSNonNullExpression":
            break;
        case "Placeholder":
            switch(node.expectedNode){
                case "Pattern":
                case "Identifier":
                    break;
                default:
                    return false;
            }
            break;
        default:
            return false;
    }
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isLVal(node, opts) {
    if (!node) return false;
    switch(node.type){
        case "Identifier":
        case "MemberExpression":
        case "RestElement":
        case "AssignmentPattern":
        case "ArrayPattern":
        case "ObjectPattern":
        case "TSParameterProperty":
        case "TSAsExpression":
        case "TSSatisfiesExpression":
        case "TSTypeAssertion":
        case "TSNonNullExpression":
            break;
        case "Placeholder":
            switch(node.expectedNode){
                case "Pattern":
                case "Identifier":
                    break;
                default:
                    return false;
            }
            break;
        default:
            return false;
    }
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isTSEntityName(node, opts) {
    if (!node) return false;
    switch(node.type){
        case "Identifier":
        case "TSQualifiedName":
            break;
        case "Placeholder":
            if (node.expectedNode === "Identifier") break;
        default:
            return false;
    }
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isLiteral(node, opts) {
    if (!node) return false;
    switch(node.type){
        case "StringLiteral":
        case "NumericLiteral":
        case "NullLiteral":
        case "BooleanLiteral":
        case "RegExpLiteral":
        case "TemplateLiteral":
        case "BigIntLiteral":
        case "DecimalLiteral":
            break;
        case "Placeholder":
            if (node.expectedNode === "StringLiteral") break;
        default:
            return false;
    }
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isImmutable(node, opts) {
    if (!node) return false;
    switch(node.type){
        case "StringLiteral":
        case "NumericLiteral":
        case "NullLiteral":
        case "BooleanLiteral":
        case "BigIntLiteral":
        case "JSXAttribute":
        case "JSXClosingElement":
        case "JSXElement":
        case "JSXExpressionContainer":
        case "JSXSpreadChild":
        case "JSXOpeningElement":
        case "JSXText":
        case "JSXFragment":
        case "JSXOpeningFragment":
        case "JSXClosingFragment":
        case "DecimalLiteral":
            break;
        case "Placeholder":
            if (node.expectedNode === "StringLiteral") break;
        default:
            return false;
    }
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isUserWhitespacable(node, opts) {
    if (!node) return false;
    switch(node.type){
        case "ObjectMethod":
        case "ObjectProperty":
        case "ObjectTypeInternalSlot":
        case "ObjectTypeCallProperty":
        case "ObjectTypeIndexer":
        case "ObjectTypeProperty":
        case "ObjectTypeSpreadProperty":
            break;
        default:
            return false;
    }
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isMethod(node, opts) {
    if (!node) return false;
    switch(node.type){
        case "ObjectMethod":
        case "ClassMethod":
        case "ClassPrivateMethod":
            break;
        default:
            return false;
    }
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isObjectMember(node, opts) {
    if (!node) return false;
    switch(node.type){
        case "ObjectMethod":
        case "ObjectProperty":
            break;
        default:
            return false;
    }
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isProperty(node, opts) {
    if (!node) return false;
    switch(node.type){
        case "ObjectProperty":
        case "ClassProperty":
        case "ClassAccessorProperty":
        case "ClassPrivateProperty":
            break;
        default:
            return false;
    }
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isUnaryLike(node, opts) {
    if (!node) return false;
    switch(node.type){
        case "UnaryExpression":
        case "SpreadElement":
            break;
        default:
            return false;
    }
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isPattern(node, opts) {
    if (!node) return false;
    switch(node.type){
        case "AssignmentPattern":
        case "ArrayPattern":
        case "ObjectPattern":
            break;
        case "Placeholder":
            if (node.expectedNode === "Pattern") break;
        default:
            return false;
    }
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isClass(node, opts) {
    if (!node) return false;
    switch(node.type){
        case "ClassExpression":
        case "ClassDeclaration":
            break;
        default:
            return false;
    }
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isImportOrExportDeclaration(node, opts) {
    if (!node) return false;
    switch(node.type){
        case "ExportAllDeclaration":
        case "ExportDefaultDeclaration":
        case "ExportNamedDeclaration":
        case "ImportDeclaration":
            break;
        default:
            return false;
    }
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isExportDeclaration(node, opts) {
    if (!node) return false;
    switch(node.type){
        case "ExportAllDeclaration":
        case "ExportDefaultDeclaration":
        case "ExportNamedDeclaration":
            break;
        default:
            return false;
    }
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isModuleSpecifier(node, opts) {
    if (!node) return false;
    switch(node.type){
        case "ExportSpecifier":
        case "ImportDefaultSpecifier":
        case "ImportNamespaceSpecifier":
        case "ImportSpecifier":
        case "ExportNamespaceSpecifier":
        case "ExportDefaultSpecifier":
            break;
        default:
            return false;
    }
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isAccessor(node, opts) {
    if (!node) return false;
    switch(node.type){
        case "ClassAccessorProperty":
            break;
        default:
            return false;
    }
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isPrivate(node, opts) {
    if (!node) return false;
    switch(node.type){
        case "ClassPrivateProperty":
        case "ClassPrivateMethod":
        case "PrivateName":
            break;
        default:
            return false;
    }
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isFlow(node, opts) {
    if (!node) return false;
    switch(node.type){
        case "AnyTypeAnnotation":
        case "ArrayTypeAnnotation":
        case "BooleanTypeAnnotation":
        case "BooleanLiteralTypeAnnotation":
        case "NullLiteralTypeAnnotation":
        case "ClassImplements":
        case "DeclareClass":
        case "DeclareFunction":
        case "DeclareInterface":
        case "DeclareModule":
        case "DeclareModuleExports":
        case "DeclareTypeAlias":
        case "DeclareOpaqueType":
        case "DeclareVariable":
        case "DeclareExportDeclaration":
        case "DeclareExportAllDeclaration":
        case "DeclaredPredicate":
        case "ExistsTypeAnnotation":
        case "FunctionTypeAnnotation":
        case "FunctionTypeParam":
        case "GenericTypeAnnotation":
        case "InferredPredicate":
        case "InterfaceExtends":
        case "InterfaceDeclaration":
        case "InterfaceTypeAnnotation":
        case "IntersectionTypeAnnotation":
        case "MixedTypeAnnotation":
        case "EmptyTypeAnnotation":
        case "NullableTypeAnnotation":
        case "NumberLiteralTypeAnnotation":
        case "NumberTypeAnnotation":
        case "ObjectTypeAnnotation":
        case "ObjectTypeInternalSlot":
        case "ObjectTypeCallProperty":
        case "ObjectTypeIndexer":
        case "ObjectTypeProperty":
        case "ObjectTypeSpreadProperty":
        case "OpaqueType":
        case "QualifiedTypeIdentifier":
        case "StringLiteralTypeAnnotation":
        case "StringTypeAnnotation":
        case "SymbolTypeAnnotation":
        case "ThisTypeAnnotation":
        case "TupleTypeAnnotation":
        case "TypeofTypeAnnotation":
        case "TypeAlias":
        case "TypeAnnotation":
        case "TypeCastExpression":
        case "TypeParameter":
        case "TypeParameterDeclaration":
        case "TypeParameterInstantiation":
        case "UnionTypeAnnotation":
        case "Variance":
        case "VoidTypeAnnotation":
        case "EnumDeclaration":
        case "EnumBooleanBody":
        case "EnumNumberBody":
        case "EnumStringBody":
        case "EnumSymbolBody":
        case "EnumBooleanMember":
        case "EnumNumberMember":
        case "EnumStringMember":
        case "EnumDefaultedMember":
        case "IndexedAccessType":
        case "OptionalIndexedAccessType":
            break;
        default:
            return false;
    }
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isFlowType(node, opts) {
    if (!node) return false;
    switch(node.type){
        case "AnyTypeAnnotation":
        case "ArrayTypeAnnotation":
        case "BooleanTypeAnnotation":
        case "BooleanLiteralTypeAnnotation":
        case "NullLiteralTypeAnnotation":
        case "ExistsTypeAnnotation":
        case "FunctionTypeAnnotation":
        case "GenericTypeAnnotation":
        case "InterfaceTypeAnnotation":
        case "IntersectionTypeAnnotation":
        case "MixedTypeAnnotation":
        case "EmptyTypeAnnotation":
        case "NullableTypeAnnotation":
        case "NumberLiteralTypeAnnotation":
        case "NumberTypeAnnotation":
        case "ObjectTypeAnnotation":
        case "StringLiteralTypeAnnotation":
        case "StringTypeAnnotation":
        case "SymbolTypeAnnotation":
        case "ThisTypeAnnotation":
        case "TupleTypeAnnotation":
        case "TypeofTypeAnnotation":
        case "UnionTypeAnnotation":
        case "VoidTypeAnnotation":
        case "IndexedAccessType":
        case "OptionalIndexedAccessType":
            break;
        default:
            return false;
    }
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isFlowBaseAnnotation(node, opts) {
    if (!node) return false;
    switch(node.type){
        case "AnyTypeAnnotation":
        case "BooleanTypeAnnotation":
        case "NullLiteralTypeAnnotation":
        case "MixedTypeAnnotation":
        case "EmptyTypeAnnotation":
        case "NumberTypeAnnotation":
        case "StringTypeAnnotation":
        case "SymbolTypeAnnotation":
        case "ThisTypeAnnotation":
        case "VoidTypeAnnotation":
            break;
        default:
            return false;
    }
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isFlowDeclaration(node, opts) {
    if (!node) return false;
    switch(node.type){
        case "DeclareClass":
        case "DeclareFunction":
        case "DeclareInterface":
        case "DeclareModule":
        case "DeclareModuleExports":
        case "DeclareTypeAlias":
        case "DeclareOpaqueType":
        case "DeclareVariable":
        case "DeclareExportDeclaration":
        case "DeclareExportAllDeclaration":
        case "InterfaceDeclaration":
        case "OpaqueType":
        case "TypeAlias":
            break;
        default:
            return false;
    }
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isFlowPredicate(node, opts) {
    if (!node) return false;
    switch(node.type){
        case "DeclaredPredicate":
        case "InferredPredicate":
            break;
        default:
            return false;
    }
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isEnumBody(node, opts) {
    if (!node) return false;
    switch(node.type){
        case "EnumBooleanBody":
        case "EnumNumberBody":
        case "EnumStringBody":
        case "EnumSymbolBody":
            break;
        default:
            return false;
    }
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isEnumMember(node, opts) {
    if (!node) return false;
    switch(node.type){
        case "EnumBooleanMember":
        case "EnumNumberMember":
        case "EnumStringMember":
        case "EnumDefaultedMember":
            break;
        default:
            return false;
    }
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isJSX(node, opts) {
    if (!node) return false;
    switch(node.type){
        case "JSXAttribute":
        case "JSXClosingElement":
        case "JSXElement":
        case "JSXEmptyExpression":
        case "JSXExpressionContainer":
        case "JSXSpreadChild":
        case "JSXIdentifier":
        case "JSXMemberExpression":
        case "JSXNamespacedName":
        case "JSXOpeningElement":
        case "JSXSpreadAttribute":
        case "JSXText":
        case "JSXFragment":
        case "JSXOpeningFragment":
        case "JSXClosingFragment":
            break;
        default:
            return false;
    }
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isMiscellaneous(node, opts) {
    if (!node) return false;
    switch(node.type){
        case "Noop":
        case "Placeholder":
        case "V8IntrinsicIdentifier":
            break;
        default:
            return false;
    }
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isTypeScript(node, opts) {
    if (!node) return false;
    switch(node.type){
        case "TSParameterProperty":
        case "TSDeclareFunction":
        case "TSDeclareMethod":
        case "TSQualifiedName":
        case "TSCallSignatureDeclaration":
        case "TSConstructSignatureDeclaration":
        case "TSPropertySignature":
        case "TSMethodSignature":
        case "TSIndexSignature":
        case "TSAnyKeyword":
        case "TSBooleanKeyword":
        case "TSBigIntKeyword":
        case "TSIntrinsicKeyword":
        case "TSNeverKeyword":
        case "TSNullKeyword":
        case "TSNumberKeyword":
        case "TSObjectKeyword":
        case "TSStringKeyword":
        case "TSSymbolKeyword":
        case "TSUndefinedKeyword":
        case "TSUnknownKeyword":
        case "TSVoidKeyword":
        case "TSThisType":
        case "TSFunctionType":
        case "TSConstructorType":
        case "TSTypeReference":
        case "TSTypePredicate":
        case "TSTypeQuery":
        case "TSTypeLiteral":
        case "TSArrayType":
        case "TSTupleType":
        case "TSOptionalType":
        case "TSRestType":
        case "TSNamedTupleMember":
        case "TSUnionType":
        case "TSIntersectionType":
        case "TSConditionalType":
        case "TSInferType":
        case "TSParenthesizedType":
        case "TSTypeOperator":
        case "TSIndexedAccessType":
        case "TSMappedType":
        case "TSLiteralType":
        case "TSExpressionWithTypeArguments":
        case "TSInterfaceDeclaration":
        case "TSInterfaceBody":
        case "TSTypeAliasDeclaration":
        case "TSInstantiationExpression":
        case "TSAsExpression":
        case "TSSatisfiesExpression":
        case "TSTypeAssertion":
        case "TSEnumDeclaration":
        case "TSEnumMember":
        case "TSModuleDeclaration":
        case "TSModuleBlock":
        case "TSImportType":
        case "TSImportEqualsDeclaration":
        case "TSExternalModuleReference":
        case "TSNonNullExpression":
        case "TSExportAssignment":
        case "TSNamespaceExportDeclaration":
        case "TSTypeAnnotation":
        case "TSTypeParameterInstantiation":
        case "TSTypeParameterDeclaration":
        case "TSTypeParameter":
            break;
        default:
            return false;
    }
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isTSTypeElement(node, opts) {
    if (!node) return false;
    switch(node.type){
        case "TSCallSignatureDeclaration":
        case "TSConstructSignatureDeclaration":
        case "TSPropertySignature":
        case "TSMethodSignature":
        case "TSIndexSignature":
            break;
        default:
            return false;
    }
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isTSType(node, opts) {
    if (!node) return false;
    switch(node.type){
        case "TSAnyKeyword":
        case "TSBooleanKeyword":
        case "TSBigIntKeyword":
        case "TSIntrinsicKeyword":
        case "TSNeverKeyword":
        case "TSNullKeyword":
        case "TSNumberKeyword":
        case "TSObjectKeyword":
        case "TSStringKeyword":
        case "TSSymbolKeyword":
        case "TSUndefinedKeyword":
        case "TSUnknownKeyword":
        case "TSVoidKeyword":
        case "TSThisType":
        case "TSFunctionType":
        case "TSConstructorType":
        case "TSTypeReference":
        case "TSTypePredicate":
        case "TSTypeQuery":
        case "TSTypeLiteral":
        case "TSArrayType":
        case "TSTupleType":
        case "TSOptionalType":
        case "TSRestType":
        case "TSUnionType":
        case "TSIntersectionType":
        case "TSConditionalType":
        case "TSInferType":
        case "TSParenthesizedType":
        case "TSTypeOperator":
        case "TSIndexedAccessType":
        case "TSMappedType":
        case "TSLiteralType":
        case "TSExpressionWithTypeArguments":
        case "TSImportType":
            break;
        default:
            return false;
    }
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isTSBaseType(node, opts) {
    if (!node) return false;
    switch(node.type){
        case "TSAnyKeyword":
        case "TSBooleanKeyword":
        case "TSBigIntKeyword":
        case "TSIntrinsicKeyword":
        case "TSNeverKeyword":
        case "TSNullKeyword":
        case "TSNumberKeyword":
        case "TSObjectKeyword":
        case "TSStringKeyword":
        case "TSSymbolKeyword":
        case "TSUndefinedKeyword":
        case "TSUnknownKeyword":
        case "TSVoidKeyword":
        case "TSThisType":
        case "TSLiteralType":
            break;
        default:
            return false;
    }
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isNumberLiteral(node, opts) {
    (0, $7sVNt.default)("isNumberLiteral", "isNumericLiteral");
    if (!node) return false;
    if (node.type !== "NumberLiteral") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isRegexLiteral(node, opts) {
    (0, $7sVNt.default)("isRegexLiteral", "isRegExpLiteral");
    if (!node) return false;
    if (node.type !== "RegexLiteral") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isRestProperty(node, opts) {
    (0, $7sVNt.default)("isRestProperty", "isRestElement");
    if (!node) return false;
    if (node.type !== "RestProperty") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isSpreadProperty(node, opts) {
    (0, $7sVNt.default)("isSpreadProperty", "isSpreadElement");
    if (!node) return false;
    if (node.type !== "SpreadProperty") return false;
    return opts == null || (0, $d5ioO.default)(node, opts);
}
function $1f35754d885d6216$var$isModuleDeclaration(node, opts) {
    (0, $7sVNt.default)("isModuleDeclaration", "isImportOrExportDeclaration");
    return $1f35754d885d6216$var$isImportOrExportDeclaration(node, opts);
}

});
parcelRegister("d5ioO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $986a03ac66303b14$var$shallowEqual;
function $986a03ac66303b14$var$shallowEqual(actual, expected) {
    const keys = Object.keys(expected);
    for (const key of keys){
        if (actual[key] !== expected[key]) return false;
    }
    return true;
}

});

parcelRegister("7sVNt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $56f7fb374104eb80$var$deprecationWarning;
const $56f7fb374104eb80$var$warnings = new Set();
function $56f7fb374104eb80$var$deprecationWarning(oldName, newName, prefix = "") {
    if ($56f7fb374104eb80$var$warnings.has(oldName)) return;
    $56f7fb374104eb80$var$warnings.add(oldName);
    const { internal: internal, trace: trace } = $56f7fb374104eb80$var$captureShortStackTrace(1, 2);
    if (internal) return;
    console.warn(`${prefix}\`${oldName}\` has been deprecated, please migrate to \`${newName}\`\n${trace}`);
}
function $56f7fb374104eb80$var$captureShortStackTrace(skip, length) {
    const { stackTraceLimit: stackTraceLimit, prepareStackTrace: prepareStackTrace } = Error;
    let stackTrace;
    Error.stackTraceLimit = 1 + skip + length;
    Error.prepareStackTrace = function(err, stack) {
        stackTrace = stack;
    };
    new Error().stack;
    Error.stackTraceLimit = stackTraceLimit;
    Error.prepareStackTrace = prepareStackTrace;
    if (!stackTrace) return {
        internal: false,
        trace: ""
    };
    const shortStackTrace = stackTrace.slice(1 + skip, 1 + skip + length);
    return {
        internal: /[\\/]@babel[\\/]/.test(shortStackTrace[1].getFileName()),
        trace: shortStackTrace.map((frame)=>`    at ${frame}`).join("\n")
    };
}

});





parcelRegister("euQYe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a8dcf4d7f7051be4$var$isCompatTag;
function $a8dcf4d7f7051be4$var$isCompatTag(tagName) {
    return !!tagName && /^[a-z]/.test(tagName);
}

});

parcelRegister("lxuvp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $fae457ccd83d5192$var$buildChildren;

var $2G7FY = parcelRequire("2G7FY");

var $ieYmW = parcelRequire("ieYmW");
function $fae457ccd83d5192$var$buildChildren(node) {
    const elements = [];
    for(let i = 0; i < node.children.length; i++){
        let child = node.children[i];
        if ((0, $2G7FY.isJSXText)(child)) {
            (0, $ieYmW.default)(child, elements);
            continue;
        }
        if ((0, $2G7FY.isJSXExpressionContainer)(child)) child = child.expression;
        if ((0, $2G7FY.isJSXEmptyExpression)(child)) continue;
        elements.push(child);
    }
    return elements;
}

});
parcelRegister("ieYmW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d4785cd6cb5df612$var$cleanJSXElementLiteralChild;

var $7MfP7 = parcelRequire("7MfP7");

var $ardUq = parcelRequire("ardUq");
function $d4785cd6cb5df612$var$cleanJSXElementLiteralChild(child, args) {
    const lines = child.value.split(/\r\n|\n|\r/);
    let lastNonEmptyLine = 0;
    for(let i = 0; i < lines.length; i++)if (lines[i].match(/[^ \t]/)) lastNonEmptyLine = i;
    let str = "";
    for(let i = 0; i < lines.length; i++){
        const line = lines[i];
        const isFirstLine = i === 0;
        const isLastLine = i === lines.length - 1;
        const isLastNonEmptyLine = i === lastNonEmptyLine;
        let trimmedLine = line.replace(/\t/g, " ");
        if (!isFirstLine) trimmedLine = trimmedLine.replace(/^[ ]+/, "");
        if (!isLastLine) trimmedLine = trimmedLine.replace(/[ ]+$/, "");
        if (trimmedLine) {
            if (!isLastNonEmptyLine) trimmedLine += " ";
            str += trimmedLine;
        }
    }
    if (str) args.push((0, $ardUq.inherits)((0, $7MfP7.stringLiteral)(str), child));
}

});
parcelRegister("7MfP7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.anyTypeAnnotation = $5a994a4f6012c7eb$var$anyTypeAnnotation;
module.exports.argumentPlaceholder = $5a994a4f6012c7eb$var$argumentPlaceholder;
module.exports.arrayExpression = $5a994a4f6012c7eb$var$arrayExpression;
module.exports.arrayPattern = $5a994a4f6012c7eb$var$arrayPattern;
module.exports.arrayTypeAnnotation = $5a994a4f6012c7eb$var$arrayTypeAnnotation;
module.exports.arrowFunctionExpression = $5a994a4f6012c7eb$var$arrowFunctionExpression;
module.exports.assignmentExpression = $5a994a4f6012c7eb$var$assignmentExpression;
module.exports.assignmentPattern = $5a994a4f6012c7eb$var$assignmentPattern;
module.exports.awaitExpression = $5a994a4f6012c7eb$var$awaitExpression;
module.exports.bigIntLiteral = $5a994a4f6012c7eb$var$bigIntLiteral;
module.exports.binaryExpression = $5a994a4f6012c7eb$var$binaryExpression;
module.exports.bindExpression = $5a994a4f6012c7eb$var$bindExpression;
module.exports.blockStatement = $5a994a4f6012c7eb$var$blockStatement;
module.exports.booleanLiteral = $5a994a4f6012c7eb$var$booleanLiteral;
module.exports.booleanLiteralTypeAnnotation = $5a994a4f6012c7eb$var$booleanLiteralTypeAnnotation;
module.exports.booleanTypeAnnotation = $5a994a4f6012c7eb$var$booleanTypeAnnotation;
module.exports.breakStatement = $5a994a4f6012c7eb$var$breakStatement;
module.exports.callExpression = $5a994a4f6012c7eb$var$callExpression;
module.exports.catchClause = $5a994a4f6012c7eb$var$catchClause;
module.exports.classAccessorProperty = $5a994a4f6012c7eb$var$classAccessorProperty;
module.exports.classBody = $5a994a4f6012c7eb$var$classBody;
module.exports.classDeclaration = $5a994a4f6012c7eb$var$classDeclaration;
module.exports.classExpression = $5a994a4f6012c7eb$var$classExpression;
module.exports.classImplements = $5a994a4f6012c7eb$var$classImplements;
module.exports.classMethod = $5a994a4f6012c7eb$var$classMethod;
module.exports.classPrivateMethod = $5a994a4f6012c7eb$var$classPrivateMethod;
module.exports.classPrivateProperty = $5a994a4f6012c7eb$var$classPrivateProperty;
module.exports.classProperty = $5a994a4f6012c7eb$var$classProperty;
module.exports.conditionalExpression = $5a994a4f6012c7eb$var$conditionalExpression;
module.exports.continueStatement = $5a994a4f6012c7eb$var$continueStatement;
module.exports.debuggerStatement = $5a994a4f6012c7eb$var$debuggerStatement;
module.exports.decimalLiteral = $5a994a4f6012c7eb$var$decimalLiteral;
module.exports.declareClass = $5a994a4f6012c7eb$var$declareClass;
module.exports.declareExportAllDeclaration = $5a994a4f6012c7eb$var$declareExportAllDeclaration;
module.exports.declareExportDeclaration = $5a994a4f6012c7eb$var$declareExportDeclaration;
module.exports.declareFunction = $5a994a4f6012c7eb$var$declareFunction;
module.exports.declareInterface = $5a994a4f6012c7eb$var$declareInterface;
module.exports.declareModule = $5a994a4f6012c7eb$var$declareModule;
module.exports.declareModuleExports = $5a994a4f6012c7eb$var$declareModuleExports;
module.exports.declareOpaqueType = $5a994a4f6012c7eb$var$declareOpaqueType;
module.exports.declareTypeAlias = $5a994a4f6012c7eb$var$declareTypeAlias;
module.exports.declareVariable = $5a994a4f6012c7eb$var$declareVariable;
module.exports.declaredPredicate = $5a994a4f6012c7eb$var$declaredPredicate;
module.exports.decorator = $5a994a4f6012c7eb$var$decorator;
module.exports.directive = $5a994a4f6012c7eb$var$directive;
module.exports.directiveLiteral = $5a994a4f6012c7eb$var$directiveLiteral;
module.exports.doExpression = $5a994a4f6012c7eb$var$doExpression;
module.exports.doWhileStatement = $5a994a4f6012c7eb$var$doWhileStatement;
module.exports.emptyStatement = $5a994a4f6012c7eb$var$emptyStatement;
module.exports.emptyTypeAnnotation = $5a994a4f6012c7eb$var$emptyTypeAnnotation;
module.exports.enumBooleanBody = $5a994a4f6012c7eb$var$enumBooleanBody;
module.exports.enumBooleanMember = $5a994a4f6012c7eb$var$enumBooleanMember;
module.exports.enumDeclaration = $5a994a4f6012c7eb$var$enumDeclaration;
module.exports.enumDefaultedMember = $5a994a4f6012c7eb$var$enumDefaultedMember;
module.exports.enumNumberBody = $5a994a4f6012c7eb$var$enumNumberBody;
module.exports.enumNumberMember = $5a994a4f6012c7eb$var$enumNumberMember;
module.exports.enumStringBody = $5a994a4f6012c7eb$var$enumStringBody;
module.exports.enumStringMember = $5a994a4f6012c7eb$var$enumStringMember;
module.exports.enumSymbolBody = $5a994a4f6012c7eb$var$enumSymbolBody;
module.exports.existsTypeAnnotation = $5a994a4f6012c7eb$var$existsTypeAnnotation;
module.exports.exportAllDeclaration = $5a994a4f6012c7eb$var$exportAllDeclaration;
module.exports.exportDefaultDeclaration = $5a994a4f6012c7eb$var$exportDefaultDeclaration;
module.exports.exportDefaultSpecifier = $5a994a4f6012c7eb$var$exportDefaultSpecifier;
module.exports.exportNamedDeclaration = $5a994a4f6012c7eb$var$exportNamedDeclaration;
module.exports.exportNamespaceSpecifier = $5a994a4f6012c7eb$var$exportNamespaceSpecifier;
module.exports.exportSpecifier = $5a994a4f6012c7eb$var$exportSpecifier;
module.exports.expressionStatement = $5a994a4f6012c7eb$var$expressionStatement;
module.exports.file = $5a994a4f6012c7eb$var$file;
module.exports.forInStatement = $5a994a4f6012c7eb$var$forInStatement;
module.exports.forOfStatement = $5a994a4f6012c7eb$var$forOfStatement;
module.exports.forStatement = $5a994a4f6012c7eb$var$forStatement;
module.exports.functionDeclaration = $5a994a4f6012c7eb$var$functionDeclaration;
module.exports.functionExpression = $5a994a4f6012c7eb$var$functionExpression;
module.exports.functionTypeAnnotation = $5a994a4f6012c7eb$var$functionTypeAnnotation;
module.exports.functionTypeParam = $5a994a4f6012c7eb$var$functionTypeParam;
module.exports.genericTypeAnnotation = $5a994a4f6012c7eb$var$genericTypeAnnotation;
module.exports.identifier = $5a994a4f6012c7eb$var$identifier;
module.exports.ifStatement = $5a994a4f6012c7eb$var$ifStatement;
module.exports.import = $5a994a4f6012c7eb$var$_import;
module.exports.importAttribute = $5a994a4f6012c7eb$var$importAttribute;
module.exports.importDeclaration = $5a994a4f6012c7eb$var$importDeclaration;
module.exports.importDefaultSpecifier = $5a994a4f6012c7eb$var$importDefaultSpecifier;
module.exports.importExpression = $5a994a4f6012c7eb$var$importExpression;
module.exports.importNamespaceSpecifier = $5a994a4f6012c7eb$var$importNamespaceSpecifier;
module.exports.importSpecifier = $5a994a4f6012c7eb$var$importSpecifier;
module.exports.indexedAccessType = $5a994a4f6012c7eb$var$indexedAccessType;
module.exports.inferredPredicate = $5a994a4f6012c7eb$var$inferredPredicate;
module.exports.interfaceDeclaration = $5a994a4f6012c7eb$var$interfaceDeclaration;
module.exports.interfaceExtends = $5a994a4f6012c7eb$var$interfaceExtends;
module.exports.interfaceTypeAnnotation = $5a994a4f6012c7eb$var$interfaceTypeAnnotation;
module.exports.interpreterDirective = $5a994a4f6012c7eb$var$interpreterDirective;
module.exports.intersectionTypeAnnotation = $5a994a4f6012c7eb$var$intersectionTypeAnnotation;
module.exports.jSXAttribute = module.exports.jsxAttribute = $5a994a4f6012c7eb$var$jsxAttribute;
module.exports.jSXClosingElement = module.exports.jsxClosingElement = $5a994a4f6012c7eb$var$jsxClosingElement;
module.exports.jSXClosingFragment = module.exports.jsxClosingFragment = $5a994a4f6012c7eb$var$jsxClosingFragment;
module.exports.jSXElement = module.exports.jsxElement = $5a994a4f6012c7eb$var$jsxElement;
module.exports.jSXEmptyExpression = module.exports.jsxEmptyExpression = $5a994a4f6012c7eb$var$jsxEmptyExpression;
module.exports.jSXExpressionContainer = module.exports.jsxExpressionContainer = $5a994a4f6012c7eb$var$jsxExpressionContainer;
module.exports.jSXFragment = module.exports.jsxFragment = $5a994a4f6012c7eb$var$jsxFragment;
module.exports.jSXIdentifier = module.exports.jsxIdentifier = $5a994a4f6012c7eb$var$jsxIdentifier;
module.exports.jSXMemberExpression = module.exports.jsxMemberExpression = $5a994a4f6012c7eb$var$jsxMemberExpression;
module.exports.jSXNamespacedName = module.exports.jsxNamespacedName = $5a994a4f6012c7eb$var$jsxNamespacedName;
module.exports.jSXOpeningElement = module.exports.jsxOpeningElement = $5a994a4f6012c7eb$var$jsxOpeningElement;
module.exports.jSXOpeningFragment = module.exports.jsxOpeningFragment = $5a994a4f6012c7eb$var$jsxOpeningFragment;
module.exports.jSXSpreadAttribute = module.exports.jsxSpreadAttribute = $5a994a4f6012c7eb$var$jsxSpreadAttribute;
module.exports.jSXSpreadChild = module.exports.jsxSpreadChild = $5a994a4f6012c7eb$var$jsxSpreadChild;
module.exports.jSXText = module.exports.jsxText = $5a994a4f6012c7eb$var$jsxText;
module.exports.labeledStatement = $5a994a4f6012c7eb$var$labeledStatement;
module.exports.logicalExpression = $5a994a4f6012c7eb$var$logicalExpression;
module.exports.memberExpression = $5a994a4f6012c7eb$var$memberExpression;
module.exports.metaProperty = $5a994a4f6012c7eb$var$metaProperty;
module.exports.mixedTypeAnnotation = $5a994a4f6012c7eb$var$mixedTypeAnnotation;
module.exports.moduleExpression = $5a994a4f6012c7eb$var$moduleExpression;
module.exports.newExpression = $5a994a4f6012c7eb$var$newExpression;
module.exports.noop = $5a994a4f6012c7eb$var$noop;
module.exports.nullLiteral = $5a994a4f6012c7eb$var$nullLiteral;
module.exports.nullLiteralTypeAnnotation = $5a994a4f6012c7eb$var$nullLiteralTypeAnnotation;
module.exports.nullableTypeAnnotation = $5a994a4f6012c7eb$var$nullableTypeAnnotation;
module.exports.numberLiteral = $5a994a4f6012c7eb$var$NumberLiteral;
module.exports.numberLiteralTypeAnnotation = $5a994a4f6012c7eb$var$numberLiteralTypeAnnotation;
module.exports.numberTypeAnnotation = $5a994a4f6012c7eb$var$numberTypeAnnotation;
module.exports.numericLiteral = $5a994a4f6012c7eb$var$numericLiteral;
module.exports.objectExpression = $5a994a4f6012c7eb$var$objectExpression;
module.exports.objectMethod = $5a994a4f6012c7eb$var$objectMethod;
module.exports.objectPattern = $5a994a4f6012c7eb$var$objectPattern;
module.exports.objectProperty = $5a994a4f6012c7eb$var$objectProperty;
module.exports.objectTypeAnnotation = $5a994a4f6012c7eb$var$objectTypeAnnotation;
module.exports.objectTypeCallProperty = $5a994a4f6012c7eb$var$objectTypeCallProperty;
module.exports.objectTypeIndexer = $5a994a4f6012c7eb$var$objectTypeIndexer;
module.exports.objectTypeInternalSlot = $5a994a4f6012c7eb$var$objectTypeInternalSlot;
module.exports.objectTypeProperty = $5a994a4f6012c7eb$var$objectTypeProperty;
module.exports.objectTypeSpreadProperty = $5a994a4f6012c7eb$var$objectTypeSpreadProperty;
module.exports.opaqueType = $5a994a4f6012c7eb$var$opaqueType;
module.exports.optionalCallExpression = $5a994a4f6012c7eb$var$optionalCallExpression;
module.exports.optionalIndexedAccessType = $5a994a4f6012c7eb$var$optionalIndexedAccessType;
module.exports.optionalMemberExpression = $5a994a4f6012c7eb$var$optionalMemberExpression;
module.exports.parenthesizedExpression = $5a994a4f6012c7eb$var$parenthesizedExpression;
module.exports.pipelineBareFunction = $5a994a4f6012c7eb$var$pipelineBareFunction;
module.exports.pipelinePrimaryTopicReference = $5a994a4f6012c7eb$var$pipelinePrimaryTopicReference;
module.exports.pipelineTopicExpression = $5a994a4f6012c7eb$var$pipelineTopicExpression;
module.exports.placeholder = $5a994a4f6012c7eb$var$placeholder;
module.exports.privateName = $5a994a4f6012c7eb$var$privateName;
module.exports.program = $5a994a4f6012c7eb$var$program;
module.exports.qualifiedTypeIdentifier = $5a994a4f6012c7eb$var$qualifiedTypeIdentifier;
module.exports.recordExpression = $5a994a4f6012c7eb$var$recordExpression;
module.exports.regExpLiteral = $5a994a4f6012c7eb$var$regExpLiteral;
module.exports.regexLiteral = $5a994a4f6012c7eb$var$RegexLiteral;
module.exports.restElement = $5a994a4f6012c7eb$var$restElement;
module.exports.restProperty = $5a994a4f6012c7eb$var$RestProperty;
module.exports.returnStatement = $5a994a4f6012c7eb$var$returnStatement;
module.exports.sequenceExpression = $5a994a4f6012c7eb$var$sequenceExpression;
module.exports.spreadElement = $5a994a4f6012c7eb$var$spreadElement;
module.exports.spreadProperty = $5a994a4f6012c7eb$var$SpreadProperty;
module.exports.staticBlock = $5a994a4f6012c7eb$var$staticBlock;
module.exports.stringLiteral = $5a994a4f6012c7eb$var$stringLiteral;
module.exports.stringLiteralTypeAnnotation = $5a994a4f6012c7eb$var$stringLiteralTypeAnnotation;
module.exports.stringTypeAnnotation = $5a994a4f6012c7eb$var$stringTypeAnnotation;
module.exports.super = $5a994a4f6012c7eb$var$_super;
module.exports.switchCase = $5a994a4f6012c7eb$var$switchCase;
module.exports.switchStatement = $5a994a4f6012c7eb$var$switchStatement;
module.exports.symbolTypeAnnotation = $5a994a4f6012c7eb$var$symbolTypeAnnotation;
module.exports.taggedTemplateExpression = $5a994a4f6012c7eb$var$taggedTemplateExpression;
module.exports.templateElement = $5a994a4f6012c7eb$var$templateElement;
module.exports.templateLiteral = $5a994a4f6012c7eb$var$templateLiteral;
module.exports.thisExpression = $5a994a4f6012c7eb$var$thisExpression;
module.exports.thisTypeAnnotation = $5a994a4f6012c7eb$var$thisTypeAnnotation;
module.exports.throwStatement = $5a994a4f6012c7eb$var$throwStatement;
module.exports.topicReference = $5a994a4f6012c7eb$var$topicReference;
module.exports.tryStatement = $5a994a4f6012c7eb$var$tryStatement;
module.exports.tSAnyKeyword = module.exports.tsAnyKeyword = $5a994a4f6012c7eb$var$tsAnyKeyword;
module.exports.tSArrayType = module.exports.tsArrayType = $5a994a4f6012c7eb$var$tsArrayType;
module.exports.tSAsExpression = module.exports.tsAsExpression = $5a994a4f6012c7eb$var$tsAsExpression;
module.exports.tSBigIntKeyword = module.exports.tsBigIntKeyword = $5a994a4f6012c7eb$var$tsBigIntKeyword;
module.exports.tSBooleanKeyword = module.exports.tsBooleanKeyword = $5a994a4f6012c7eb$var$tsBooleanKeyword;
module.exports.tSCallSignatureDeclaration = module.exports.tsCallSignatureDeclaration = $5a994a4f6012c7eb$var$tsCallSignatureDeclaration;
module.exports.tSConditionalType = module.exports.tsConditionalType = $5a994a4f6012c7eb$var$tsConditionalType;
module.exports.tSConstructSignatureDeclaration = module.exports.tsConstructSignatureDeclaration = $5a994a4f6012c7eb$var$tsConstructSignatureDeclaration;
module.exports.tSConstructorType = module.exports.tsConstructorType = $5a994a4f6012c7eb$var$tsConstructorType;
module.exports.tSDeclareFunction = module.exports.tsDeclareFunction = $5a994a4f6012c7eb$var$tsDeclareFunction;
module.exports.tSDeclareMethod = module.exports.tsDeclareMethod = $5a994a4f6012c7eb$var$tsDeclareMethod;
module.exports.tSEnumDeclaration = module.exports.tsEnumDeclaration = $5a994a4f6012c7eb$var$tsEnumDeclaration;
module.exports.tSEnumMember = module.exports.tsEnumMember = $5a994a4f6012c7eb$var$tsEnumMember;
module.exports.tSExportAssignment = module.exports.tsExportAssignment = $5a994a4f6012c7eb$var$tsExportAssignment;
module.exports.tSExpressionWithTypeArguments = module.exports.tsExpressionWithTypeArguments = $5a994a4f6012c7eb$var$tsExpressionWithTypeArguments;
module.exports.tSExternalModuleReference = module.exports.tsExternalModuleReference = $5a994a4f6012c7eb$var$tsExternalModuleReference;
module.exports.tSFunctionType = module.exports.tsFunctionType = $5a994a4f6012c7eb$var$tsFunctionType;
module.exports.tSImportEqualsDeclaration = module.exports.tsImportEqualsDeclaration = $5a994a4f6012c7eb$var$tsImportEqualsDeclaration;
module.exports.tSImportType = module.exports.tsImportType = $5a994a4f6012c7eb$var$tsImportType;
module.exports.tSIndexSignature = module.exports.tsIndexSignature = $5a994a4f6012c7eb$var$tsIndexSignature;
module.exports.tSIndexedAccessType = module.exports.tsIndexedAccessType = $5a994a4f6012c7eb$var$tsIndexedAccessType;
module.exports.tSInferType = module.exports.tsInferType = $5a994a4f6012c7eb$var$tsInferType;
module.exports.tSInstantiationExpression = module.exports.tsInstantiationExpression = $5a994a4f6012c7eb$var$tsInstantiationExpression;
module.exports.tSInterfaceBody = module.exports.tsInterfaceBody = $5a994a4f6012c7eb$var$tsInterfaceBody;
module.exports.tSInterfaceDeclaration = module.exports.tsInterfaceDeclaration = $5a994a4f6012c7eb$var$tsInterfaceDeclaration;
module.exports.tSIntersectionType = module.exports.tsIntersectionType = $5a994a4f6012c7eb$var$tsIntersectionType;
module.exports.tSIntrinsicKeyword = module.exports.tsIntrinsicKeyword = $5a994a4f6012c7eb$var$tsIntrinsicKeyword;
module.exports.tSLiteralType = module.exports.tsLiteralType = $5a994a4f6012c7eb$var$tsLiteralType;
module.exports.tSMappedType = module.exports.tsMappedType = $5a994a4f6012c7eb$var$tsMappedType;
module.exports.tSMethodSignature = module.exports.tsMethodSignature = $5a994a4f6012c7eb$var$tsMethodSignature;
module.exports.tSModuleBlock = module.exports.tsModuleBlock = $5a994a4f6012c7eb$var$tsModuleBlock;
module.exports.tSModuleDeclaration = module.exports.tsModuleDeclaration = $5a994a4f6012c7eb$var$tsModuleDeclaration;
module.exports.tSNamedTupleMember = module.exports.tsNamedTupleMember = $5a994a4f6012c7eb$var$tsNamedTupleMember;
module.exports.tSNamespaceExportDeclaration = module.exports.tsNamespaceExportDeclaration = $5a994a4f6012c7eb$var$tsNamespaceExportDeclaration;
module.exports.tSNeverKeyword = module.exports.tsNeverKeyword = $5a994a4f6012c7eb$var$tsNeverKeyword;
module.exports.tSNonNullExpression = module.exports.tsNonNullExpression = $5a994a4f6012c7eb$var$tsNonNullExpression;
module.exports.tSNullKeyword = module.exports.tsNullKeyword = $5a994a4f6012c7eb$var$tsNullKeyword;
module.exports.tSNumberKeyword = module.exports.tsNumberKeyword = $5a994a4f6012c7eb$var$tsNumberKeyword;
module.exports.tSObjectKeyword = module.exports.tsObjectKeyword = $5a994a4f6012c7eb$var$tsObjectKeyword;
module.exports.tSOptionalType = module.exports.tsOptionalType = $5a994a4f6012c7eb$var$tsOptionalType;
module.exports.tSParameterProperty = module.exports.tsParameterProperty = $5a994a4f6012c7eb$var$tsParameterProperty;
module.exports.tSParenthesizedType = module.exports.tsParenthesizedType = $5a994a4f6012c7eb$var$tsParenthesizedType;
module.exports.tSPropertySignature = module.exports.tsPropertySignature = $5a994a4f6012c7eb$var$tsPropertySignature;
module.exports.tSQualifiedName = module.exports.tsQualifiedName = $5a994a4f6012c7eb$var$tsQualifiedName;
module.exports.tSRestType = module.exports.tsRestType = $5a994a4f6012c7eb$var$tsRestType;
module.exports.tSSatisfiesExpression = module.exports.tsSatisfiesExpression = $5a994a4f6012c7eb$var$tsSatisfiesExpression;
module.exports.tSStringKeyword = module.exports.tsStringKeyword = $5a994a4f6012c7eb$var$tsStringKeyword;
module.exports.tSSymbolKeyword = module.exports.tsSymbolKeyword = $5a994a4f6012c7eb$var$tsSymbolKeyword;
module.exports.tSThisType = module.exports.tsThisType = $5a994a4f6012c7eb$var$tsThisType;
module.exports.tSTupleType = module.exports.tsTupleType = $5a994a4f6012c7eb$var$tsTupleType;
module.exports.tSTypeAliasDeclaration = module.exports.tsTypeAliasDeclaration = $5a994a4f6012c7eb$var$tsTypeAliasDeclaration;
module.exports.tSTypeAnnotation = module.exports.tsTypeAnnotation = $5a994a4f6012c7eb$var$tsTypeAnnotation;
module.exports.tSTypeAssertion = module.exports.tsTypeAssertion = $5a994a4f6012c7eb$var$tsTypeAssertion;
module.exports.tSTypeLiteral = module.exports.tsTypeLiteral = $5a994a4f6012c7eb$var$tsTypeLiteral;
module.exports.tSTypeOperator = module.exports.tsTypeOperator = $5a994a4f6012c7eb$var$tsTypeOperator;
module.exports.tSTypeParameter = module.exports.tsTypeParameter = $5a994a4f6012c7eb$var$tsTypeParameter;
module.exports.tSTypeParameterDeclaration = module.exports.tsTypeParameterDeclaration = $5a994a4f6012c7eb$var$tsTypeParameterDeclaration;
module.exports.tSTypeParameterInstantiation = module.exports.tsTypeParameterInstantiation = $5a994a4f6012c7eb$var$tsTypeParameterInstantiation;
module.exports.tSTypePredicate = module.exports.tsTypePredicate = $5a994a4f6012c7eb$var$tsTypePredicate;
module.exports.tSTypeQuery = module.exports.tsTypeQuery = $5a994a4f6012c7eb$var$tsTypeQuery;
module.exports.tSTypeReference = module.exports.tsTypeReference = $5a994a4f6012c7eb$var$tsTypeReference;
module.exports.tSUndefinedKeyword = module.exports.tsUndefinedKeyword = $5a994a4f6012c7eb$var$tsUndefinedKeyword;
module.exports.tSUnionType = module.exports.tsUnionType = $5a994a4f6012c7eb$var$tsUnionType;
module.exports.tSUnknownKeyword = module.exports.tsUnknownKeyword = $5a994a4f6012c7eb$var$tsUnknownKeyword;
module.exports.tSVoidKeyword = module.exports.tsVoidKeyword = $5a994a4f6012c7eb$var$tsVoidKeyword;
module.exports.tupleExpression = $5a994a4f6012c7eb$var$tupleExpression;
module.exports.tupleTypeAnnotation = $5a994a4f6012c7eb$var$tupleTypeAnnotation;
module.exports.typeAlias = $5a994a4f6012c7eb$var$typeAlias;
module.exports.typeAnnotation = $5a994a4f6012c7eb$var$typeAnnotation;
module.exports.typeCastExpression = $5a994a4f6012c7eb$var$typeCastExpression;
module.exports.typeParameter = $5a994a4f6012c7eb$var$typeParameter;
module.exports.typeParameterDeclaration = $5a994a4f6012c7eb$var$typeParameterDeclaration;
module.exports.typeParameterInstantiation = $5a994a4f6012c7eb$var$typeParameterInstantiation;
module.exports.typeofTypeAnnotation = $5a994a4f6012c7eb$var$typeofTypeAnnotation;
module.exports.unaryExpression = $5a994a4f6012c7eb$var$unaryExpression;
module.exports.unionTypeAnnotation = $5a994a4f6012c7eb$var$unionTypeAnnotation;
module.exports.updateExpression = $5a994a4f6012c7eb$var$updateExpression;
module.exports.v8IntrinsicIdentifier = $5a994a4f6012c7eb$var$v8IntrinsicIdentifier;
module.exports.variableDeclaration = $5a994a4f6012c7eb$var$variableDeclaration;
module.exports.variableDeclarator = $5a994a4f6012c7eb$var$variableDeclarator;
module.exports.variance = $5a994a4f6012c7eb$var$variance;
module.exports.voidTypeAnnotation = $5a994a4f6012c7eb$var$voidTypeAnnotation;
module.exports.whileStatement = $5a994a4f6012c7eb$var$whileStatement;
module.exports.withStatement = $5a994a4f6012c7eb$var$withStatement;
module.exports.yieldExpression = $5a994a4f6012c7eb$var$yieldExpression;

var $70DJx = parcelRequire("70DJx");

var $7sVNt = parcelRequire("7sVNt");
function $5a994a4f6012c7eb$var$arrayExpression(elements = []) {
    return (0, $70DJx.default)({
        type: "ArrayExpression",
        elements: elements
    });
}
function $5a994a4f6012c7eb$var$assignmentExpression(operator, left, right) {
    return (0, $70DJx.default)({
        type: "AssignmentExpression",
        operator: operator,
        left: left,
        right: right
    });
}
function $5a994a4f6012c7eb$var$binaryExpression(operator, left, right) {
    return (0, $70DJx.default)({
        type: "BinaryExpression",
        operator: operator,
        left: left,
        right: right
    });
}
function $5a994a4f6012c7eb$var$interpreterDirective(value) {
    return (0, $70DJx.default)({
        type: "InterpreterDirective",
        value: value
    });
}
function $5a994a4f6012c7eb$var$directive(value) {
    return (0, $70DJx.default)({
        type: "Directive",
        value: value
    });
}
function $5a994a4f6012c7eb$var$directiveLiteral(value) {
    return (0, $70DJx.default)({
        type: "DirectiveLiteral",
        value: value
    });
}
function $5a994a4f6012c7eb$var$blockStatement(body, directives = []) {
    return (0, $70DJx.default)({
        type: "BlockStatement",
        body: body,
        directives: directives
    });
}
function $5a994a4f6012c7eb$var$breakStatement(label = null) {
    return (0, $70DJx.default)({
        type: "BreakStatement",
        label: label
    });
}
function $5a994a4f6012c7eb$var$callExpression(callee, _arguments) {
    return (0, $70DJx.default)({
        type: "CallExpression",
        callee: callee,
        arguments: _arguments
    });
}
function $5a994a4f6012c7eb$var$catchClause(param = null, body) {
    return (0, $70DJx.default)({
        type: "CatchClause",
        param: param,
        body: body
    });
}
function $5a994a4f6012c7eb$var$conditionalExpression(test, consequent, alternate) {
    return (0, $70DJx.default)({
        type: "ConditionalExpression",
        test: test,
        consequent: consequent,
        alternate: alternate
    });
}
function $5a994a4f6012c7eb$var$continueStatement(label = null) {
    return (0, $70DJx.default)({
        type: "ContinueStatement",
        label: label
    });
}
function $5a994a4f6012c7eb$var$debuggerStatement() {
    return {
        type: "DebuggerStatement"
    };
}
function $5a994a4f6012c7eb$var$doWhileStatement(test, body) {
    return (0, $70DJx.default)({
        type: "DoWhileStatement",
        test: test,
        body: body
    });
}
function $5a994a4f6012c7eb$var$emptyStatement() {
    return {
        type: "EmptyStatement"
    };
}
function $5a994a4f6012c7eb$var$expressionStatement(expression) {
    return (0, $70DJx.default)({
        type: "ExpressionStatement",
        expression: expression
    });
}
function $5a994a4f6012c7eb$var$file(program, comments = null, tokens = null) {
    return (0, $70DJx.default)({
        type: "File",
        program: program,
        comments: comments,
        tokens: tokens
    });
}
function $5a994a4f6012c7eb$var$forInStatement(left, right, body) {
    return (0, $70DJx.default)({
        type: "ForInStatement",
        left: left,
        right: right,
        body: body
    });
}
function $5a994a4f6012c7eb$var$forStatement(init = null, test = null, update = null, body) {
    return (0, $70DJx.default)({
        type: "ForStatement",
        init: init,
        test: test,
        update: update,
        body: body
    });
}
function $5a994a4f6012c7eb$var$functionDeclaration(id = null, params, body, generator = false, async = false) {
    return (0, $70DJx.default)({
        type: "FunctionDeclaration",
        id: id,
        params: params,
        body: body,
        generator: generator,
        async: async
    });
}
function $5a994a4f6012c7eb$var$functionExpression(id = null, params, body, generator = false, async = false) {
    return (0, $70DJx.default)({
        type: "FunctionExpression",
        id: id,
        params: params,
        body: body,
        generator: generator,
        async: async
    });
}
function $5a994a4f6012c7eb$var$identifier(name) {
    return (0, $70DJx.default)({
        type: "Identifier",
        name: name
    });
}
function $5a994a4f6012c7eb$var$ifStatement(test, consequent, alternate = null) {
    return (0, $70DJx.default)({
        type: "IfStatement",
        test: test,
        consequent: consequent,
        alternate: alternate
    });
}
function $5a994a4f6012c7eb$var$labeledStatement(label, body) {
    return (0, $70DJx.default)({
        type: "LabeledStatement",
        label: label,
        body: body
    });
}
function $5a994a4f6012c7eb$var$stringLiteral(value) {
    return (0, $70DJx.default)({
        type: "StringLiteral",
        value: value
    });
}
function $5a994a4f6012c7eb$var$numericLiteral(value) {
    return (0, $70DJx.default)({
        type: "NumericLiteral",
        value: value
    });
}
function $5a994a4f6012c7eb$var$nullLiteral() {
    return {
        type: "NullLiteral"
    };
}
function $5a994a4f6012c7eb$var$booleanLiteral(value) {
    return (0, $70DJx.default)({
        type: "BooleanLiteral",
        value: value
    });
}
function $5a994a4f6012c7eb$var$regExpLiteral(pattern, flags = "") {
    return (0, $70DJx.default)({
        type: "RegExpLiteral",
        pattern: pattern,
        flags: flags
    });
}
function $5a994a4f6012c7eb$var$logicalExpression(operator, left, right) {
    return (0, $70DJx.default)({
        type: "LogicalExpression",
        operator: operator,
        left: left,
        right: right
    });
}
function $5a994a4f6012c7eb$var$memberExpression(object, property, computed = false, optional = null) {
    return (0, $70DJx.default)({
        type: "MemberExpression",
        object: object,
        property: property,
        computed: computed,
        optional: optional
    });
}
function $5a994a4f6012c7eb$var$newExpression(callee, _arguments) {
    return (0, $70DJx.default)({
        type: "NewExpression",
        callee: callee,
        arguments: _arguments
    });
}
function $5a994a4f6012c7eb$var$program(body, directives = [], sourceType = "script", interpreter = null) {
    return (0, $70DJx.default)({
        type: "Program",
        body: body,
        directives: directives,
        sourceType: sourceType,
        interpreter: interpreter
    });
}
function $5a994a4f6012c7eb$var$objectExpression(properties) {
    return (0, $70DJx.default)({
        type: "ObjectExpression",
        properties: properties
    });
}
function $5a994a4f6012c7eb$var$objectMethod(kind = "method", key, params, body, computed = false, generator = false, async = false) {
    return (0, $70DJx.default)({
        type: "ObjectMethod",
        kind: kind,
        key: key,
        params: params,
        body: body,
        computed: computed,
        generator: generator,
        async: async
    });
}
function $5a994a4f6012c7eb$var$objectProperty(key, value, computed = false, shorthand = false, decorators = null) {
    return (0, $70DJx.default)({
        type: "ObjectProperty",
        key: key,
        value: value,
        computed: computed,
        shorthand: shorthand,
        decorators: decorators
    });
}
function $5a994a4f6012c7eb$var$restElement(argument) {
    return (0, $70DJx.default)({
        type: "RestElement",
        argument: argument
    });
}
function $5a994a4f6012c7eb$var$returnStatement(argument = null) {
    return (0, $70DJx.default)({
        type: "ReturnStatement",
        argument: argument
    });
}
function $5a994a4f6012c7eb$var$sequenceExpression(expressions) {
    return (0, $70DJx.default)({
        type: "SequenceExpression",
        expressions: expressions
    });
}
function $5a994a4f6012c7eb$var$parenthesizedExpression(expression) {
    return (0, $70DJx.default)({
        type: "ParenthesizedExpression",
        expression: expression
    });
}
function $5a994a4f6012c7eb$var$switchCase(test = null, consequent) {
    return (0, $70DJx.default)({
        type: "SwitchCase",
        test: test,
        consequent: consequent
    });
}
function $5a994a4f6012c7eb$var$switchStatement(discriminant, cases) {
    return (0, $70DJx.default)({
        type: "SwitchStatement",
        discriminant: discriminant,
        cases: cases
    });
}
function $5a994a4f6012c7eb$var$thisExpression() {
    return {
        type: "ThisExpression"
    };
}
function $5a994a4f6012c7eb$var$throwStatement(argument) {
    return (0, $70DJx.default)({
        type: "ThrowStatement",
        argument: argument
    });
}
function $5a994a4f6012c7eb$var$tryStatement(block, handler = null, finalizer = null) {
    return (0, $70DJx.default)({
        type: "TryStatement",
        block: block,
        handler: handler,
        finalizer: finalizer
    });
}
function $5a994a4f6012c7eb$var$unaryExpression(operator, argument, prefix = true) {
    return (0, $70DJx.default)({
        type: "UnaryExpression",
        operator: operator,
        argument: argument,
        prefix: prefix
    });
}
function $5a994a4f6012c7eb$var$updateExpression(operator, argument, prefix = false) {
    return (0, $70DJx.default)({
        type: "UpdateExpression",
        operator: operator,
        argument: argument,
        prefix: prefix
    });
}
function $5a994a4f6012c7eb$var$variableDeclaration(kind, declarations) {
    return (0, $70DJx.default)({
        type: "VariableDeclaration",
        kind: kind,
        declarations: declarations
    });
}
function $5a994a4f6012c7eb$var$variableDeclarator(id, init = null) {
    return (0, $70DJx.default)({
        type: "VariableDeclarator",
        id: id,
        init: init
    });
}
function $5a994a4f6012c7eb$var$whileStatement(test, body) {
    return (0, $70DJx.default)({
        type: "WhileStatement",
        test: test,
        body: body
    });
}
function $5a994a4f6012c7eb$var$withStatement(object, body) {
    return (0, $70DJx.default)({
        type: "WithStatement",
        object: object,
        body: body
    });
}
function $5a994a4f6012c7eb$var$assignmentPattern(left, right) {
    return (0, $70DJx.default)({
        type: "AssignmentPattern",
        left: left,
        right: right
    });
}
function $5a994a4f6012c7eb$var$arrayPattern(elements) {
    return (0, $70DJx.default)({
        type: "ArrayPattern",
        elements: elements
    });
}
function $5a994a4f6012c7eb$var$arrowFunctionExpression(params, body, async = false) {
    return (0, $70DJx.default)({
        type: "ArrowFunctionExpression",
        params: params,
        body: body,
        async: async,
        expression: null
    });
}
function $5a994a4f6012c7eb$var$classBody(body) {
    return (0, $70DJx.default)({
        type: "ClassBody",
        body: body
    });
}
function $5a994a4f6012c7eb$var$classExpression(id = null, superClass = null, body, decorators = null) {
    return (0, $70DJx.default)({
        type: "ClassExpression",
        id: id,
        superClass: superClass,
        body: body,
        decorators: decorators
    });
}
function $5a994a4f6012c7eb$var$classDeclaration(id = null, superClass = null, body, decorators = null) {
    return (0, $70DJx.default)({
        type: "ClassDeclaration",
        id: id,
        superClass: superClass,
        body: body,
        decorators: decorators
    });
}
function $5a994a4f6012c7eb$var$exportAllDeclaration(source) {
    return (0, $70DJx.default)({
        type: "ExportAllDeclaration",
        source: source
    });
}
function $5a994a4f6012c7eb$var$exportDefaultDeclaration(declaration) {
    return (0, $70DJx.default)({
        type: "ExportDefaultDeclaration",
        declaration: declaration
    });
}
function $5a994a4f6012c7eb$var$exportNamedDeclaration(declaration = null, specifiers = [], source = null) {
    return (0, $70DJx.default)({
        type: "ExportNamedDeclaration",
        declaration: declaration,
        specifiers: specifiers,
        source: source
    });
}
function $5a994a4f6012c7eb$var$exportSpecifier(local, exported) {
    return (0, $70DJx.default)({
        type: "ExportSpecifier",
        local: local,
        exported: exported
    });
}
function $5a994a4f6012c7eb$var$forOfStatement(left, right, body, _await = false) {
    return (0, $70DJx.default)({
        type: "ForOfStatement",
        left: left,
        right: right,
        body: body,
        await: _await
    });
}
function $5a994a4f6012c7eb$var$importDeclaration(specifiers, source) {
    return (0, $70DJx.default)({
        type: "ImportDeclaration",
        specifiers: specifiers,
        source: source
    });
}
function $5a994a4f6012c7eb$var$importDefaultSpecifier(local) {
    return (0, $70DJx.default)({
        type: "ImportDefaultSpecifier",
        local: local
    });
}
function $5a994a4f6012c7eb$var$importNamespaceSpecifier(local) {
    return (0, $70DJx.default)({
        type: "ImportNamespaceSpecifier",
        local: local
    });
}
function $5a994a4f6012c7eb$var$importSpecifier(local, imported) {
    return (0, $70DJx.default)({
        type: "ImportSpecifier",
        local: local,
        imported: imported
    });
}
function $5a994a4f6012c7eb$var$importExpression(source, options = null) {
    return (0, $70DJx.default)({
        type: "ImportExpression",
        source: source,
        options: options
    });
}
function $5a994a4f6012c7eb$var$metaProperty(meta, property) {
    return (0, $70DJx.default)({
        type: "MetaProperty",
        meta: meta,
        property: property
    });
}
function $5a994a4f6012c7eb$var$classMethod(kind = "method", key, params, body, computed = false, _static = false, generator = false, async = false) {
    return (0, $70DJx.default)({
        type: "ClassMethod",
        kind: kind,
        key: key,
        params: params,
        body: body,
        computed: computed,
        static: _static,
        generator: generator,
        async: async
    });
}
function $5a994a4f6012c7eb$var$objectPattern(properties) {
    return (0, $70DJx.default)({
        type: "ObjectPattern",
        properties: properties
    });
}
function $5a994a4f6012c7eb$var$spreadElement(argument) {
    return (0, $70DJx.default)({
        type: "SpreadElement",
        argument: argument
    });
}
function $5a994a4f6012c7eb$var$_super() {
    return {
        type: "Super"
    };
}
function $5a994a4f6012c7eb$var$taggedTemplateExpression(tag, quasi) {
    return (0, $70DJx.default)({
        type: "TaggedTemplateExpression",
        tag: tag,
        quasi: quasi
    });
}
function $5a994a4f6012c7eb$var$templateElement(value, tail = false) {
    return (0, $70DJx.default)({
        type: "TemplateElement",
        value: value,
        tail: tail
    });
}
function $5a994a4f6012c7eb$var$templateLiteral(quasis, expressions) {
    return (0, $70DJx.default)({
        type: "TemplateLiteral",
        quasis: quasis,
        expressions: expressions
    });
}
function $5a994a4f6012c7eb$var$yieldExpression(argument = null, delegate = false) {
    return (0, $70DJx.default)({
        type: "YieldExpression",
        argument: argument,
        delegate: delegate
    });
}
function $5a994a4f6012c7eb$var$awaitExpression(argument) {
    return (0, $70DJx.default)({
        type: "AwaitExpression",
        argument: argument
    });
}
function $5a994a4f6012c7eb$var$_import() {
    return {
        type: "Import"
    };
}
function $5a994a4f6012c7eb$var$bigIntLiteral(value) {
    return (0, $70DJx.default)({
        type: "BigIntLiteral",
        value: value
    });
}
function $5a994a4f6012c7eb$var$exportNamespaceSpecifier(exported) {
    return (0, $70DJx.default)({
        type: "ExportNamespaceSpecifier",
        exported: exported
    });
}
function $5a994a4f6012c7eb$var$optionalMemberExpression(object, property, computed = false, optional) {
    return (0, $70DJx.default)({
        type: "OptionalMemberExpression",
        object: object,
        property: property,
        computed: computed,
        optional: optional
    });
}
function $5a994a4f6012c7eb$var$optionalCallExpression(callee, _arguments, optional) {
    return (0, $70DJx.default)({
        type: "OptionalCallExpression",
        callee: callee,
        arguments: _arguments,
        optional: optional
    });
}
function $5a994a4f6012c7eb$var$classProperty(key, value = null, typeAnnotation = null, decorators = null, computed = false, _static = false) {
    return (0, $70DJx.default)({
        type: "ClassProperty",
        key: key,
        value: value,
        typeAnnotation: typeAnnotation,
        decorators: decorators,
        computed: computed,
        static: _static
    });
}
function $5a994a4f6012c7eb$var$classAccessorProperty(key, value = null, typeAnnotation = null, decorators = null, computed = false, _static = false) {
    return (0, $70DJx.default)({
        type: "ClassAccessorProperty",
        key: key,
        value: value,
        typeAnnotation: typeAnnotation,
        decorators: decorators,
        computed: computed,
        static: _static
    });
}
function $5a994a4f6012c7eb$var$classPrivateProperty(key, value = null, decorators = null, _static = false) {
    return (0, $70DJx.default)({
        type: "ClassPrivateProperty",
        key: key,
        value: value,
        decorators: decorators,
        static: _static
    });
}
function $5a994a4f6012c7eb$var$classPrivateMethod(kind = "method", key, params, body, _static = false) {
    return (0, $70DJx.default)({
        type: "ClassPrivateMethod",
        kind: kind,
        key: key,
        params: params,
        body: body,
        static: _static
    });
}
function $5a994a4f6012c7eb$var$privateName(id) {
    return (0, $70DJx.default)({
        type: "PrivateName",
        id: id
    });
}
function $5a994a4f6012c7eb$var$staticBlock(body) {
    return (0, $70DJx.default)({
        type: "StaticBlock",
        body: body
    });
}
function $5a994a4f6012c7eb$var$anyTypeAnnotation() {
    return {
        type: "AnyTypeAnnotation"
    };
}
function $5a994a4f6012c7eb$var$arrayTypeAnnotation(elementType) {
    return (0, $70DJx.default)({
        type: "ArrayTypeAnnotation",
        elementType: elementType
    });
}
function $5a994a4f6012c7eb$var$booleanTypeAnnotation() {
    return {
        type: "BooleanTypeAnnotation"
    };
}
function $5a994a4f6012c7eb$var$booleanLiteralTypeAnnotation(value) {
    return (0, $70DJx.default)({
        type: "BooleanLiteralTypeAnnotation",
        value: value
    });
}
function $5a994a4f6012c7eb$var$nullLiteralTypeAnnotation() {
    return {
        type: "NullLiteralTypeAnnotation"
    };
}
function $5a994a4f6012c7eb$var$classImplements(id, typeParameters = null) {
    return (0, $70DJx.default)({
        type: "ClassImplements",
        id: id,
        typeParameters: typeParameters
    });
}
function $5a994a4f6012c7eb$var$declareClass(id, typeParameters = null, _extends = null, body) {
    return (0, $70DJx.default)({
        type: "DeclareClass",
        id: id,
        typeParameters: typeParameters,
        extends: _extends,
        body: body
    });
}
function $5a994a4f6012c7eb$var$declareFunction(id) {
    return (0, $70DJx.default)({
        type: "DeclareFunction",
        id: id
    });
}
function $5a994a4f6012c7eb$var$declareInterface(id, typeParameters = null, _extends = null, body) {
    return (0, $70DJx.default)({
        type: "DeclareInterface",
        id: id,
        typeParameters: typeParameters,
        extends: _extends,
        body: body
    });
}
function $5a994a4f6012c7eb$var$declareModule(id, body, kind = null) {
    return (0, $70DJx.default)({
        type: "DeclareModule",
        id: id,
        body: body,
        kind: kind
    });
}
function $5a994a4f6012c7eb$var$declareModuleExports(typeAnnotation) {
    return (0, $70DJx.default)({
        type: "DeclareModuleExports",
        typeAnnotation: typeAnnotation
    });
}
function $5a994a4f6012c7eb$var$declareTypeAlias(id, typeParameters = null, right) {
    return (0, $70DJx.default)({
        type: "DeclareTypeAlias",
        id: id,
        typeParameters: typeParameters,
        right: right
    });
}
function $5a994a4f6012c7eb$var$declareOpaqueType(id, typeParameters = null, supertype = null) {
    return (0, $70DJx.default)({
        type: "DeclareOpaqueType",
        id: id,
        typeParameters: typeParameters,
        supertype: supertype
    });
}
function $5a994a4f6012c7eb$var$declareVariable(id) {
    return (0, $70DJx.default)({
        type: "DeclareVariable",
        id: id
    });
}
function $5a994a4f6012c7eb$var$declareExportDeclaration(declaration = null, specifiers = null, source = null) {
    return (0, $70DJx.default)({
        type: "DeclareExportDeclaration",
        declaration: declaration,
        specifiers: specifiers,
        source: source
    });
}
function $5a994a4f6012c7eb$var$declareExportAllDeclaration(source) {
    return (0, $70DJx.default)({
        type: "DeclareExportAllDeclaration",
        source: source
    });
}
function $5a994a4f6012c7eb$var$declaredPredicate(value) {
    return (0, $70DJx.default)({
        type: "DeclaredPredicate",
        value: value
    });
}
function $5a994a4f6012c7eb$var$existsTypeAnnotation() {
    return {
        type: "ExistsTypeAnnotation"
    };
}
function $5a994a4f6012c7eb$var$functionTypeAnnotation(typeParameters = null, params, rest = null, returnType) {
    return (0, $70DJx.default)({
        type: "FunctionTypeAnnotation",
        typeParameters: typeParameters,
        params: params,
        rest: rest,
        returnType: returnType
    });
}
function $5a994a4f6012c7eb$var$functionTypeParam(name = null, typeAnnotation) {
    return (0, $70DJx.default)({
        type: "FunctionTypeParam",
        name: name,
        typeAnnotation: typeAnnotation
    });
}
function $5a994a4f6012c7eb$var$genericTypeAnnotation(id, typeParameters = null) {
    return (0, $70DJx.default)({
        type: "GenericTypeAnnotation",
        id: id,
        typeParameters: typeParameters
    });
}
function $5a994a4f6012c7eb$var$inferredPredicate() {
    return {
        type: "InferredPredicate"
    };
}
function $5a994a4f6012c7eb$var$interfaceExtends(id, typeParameters = null) {
    return (0, $70DJx.default)({
        type: "InterfaceExtends",
        id: id,
        typeParameters: typeParameters
    });
}
function $5a994a4f6012c7eb$var$interfaceDeclaration(id, typeParameters = null, _extends = null, body) {
    return (0, $70DJx.default)({
        type: "InterfaceDeclaration",
        id: id,
        typeParameters: typeParameters,
        extends: _extends,
        body: body
    });
}
function $5a994a4f6012c7eb$var$interfaceTypeAnnotation(_extends = null, body) {
    return (0, $70DJx.default)({
        type: "InterfaceTypeAnnotation",
        extends: _extends,
        body: body
    });
}
function $5a994a4f6012c7eb$var$intersectionTypeAnnotation(types) {
    return (0, $70DJx.default)({
        type: "IntersectionTypeAnnotation",
        types: types
    });
}
function $5a994a4f6012c7eb$var$mixedTypeAnnotation() {
    return {
        type: "MixedTypeAnnotation"
    };
}
function $5a994a4f6012c7eb$var$emptyTypeAnnotation() {
    return {
        type: "EmptyTypeAnnotation"
    };
}
function $5a994a4f6012c7eb$var$nullableTypeAnnotation(typeAnnotation) {
    return (0, $70DJx.default)({
        type: "NullableTypeAnnotation",
        typeAnnotation: typeAnnotation
    });
}
function $5a994a4f6012c7eb$var$numberLiteralTypeAnnotation(value) {
    return (0, $70DJx.default)({
        type: "NumberLiteralTypeAnnotation",
        value: value
    });
}
function $5a994a4f6012c7eb$var$numberTypeAnnotation() {
    return {
        type: "NumberTypeAnnotation"
    };
}
function $5a994a4f6012c7eb$var$objectTypeAnnotation(properties, indexers = [], callProperties = [], internalSlots = [], exact = false) {
    return (0, $70DJx.default)({
        type: "ObjectTypeAnnotation",
        properties: properties,
        indexers: indexers,
        callProperties: callProperties,
        internalSlots: internalSlots,
        exact: exact
    });
}
function $5a994a4f6012c7eb$var$objectTypeInternalSlot(id, value, optional, _static, method) {
    return (0, $70DJx.default)({
        type: "ObjectTypeInternalSlot",
        id: id,
        value: value,
        optional: optional,
        static: _static,
        method: method
    });
}
function $5a994a4f6012c7eb$var$objectTypeCallProperty(value) {
    return (0, $70DJx.default)({
        type: "ObjectTypeCallProperty",
        value: value,
        static: null
    });
}
function $5a994a4f6012c7eb$var$objectTypeIndexer(id = null, key, value, variance = null) {
    return (0, $70DJx.default)({
        type: "ObjectTypeIndexer",
        id: id,
        key: key,
        value: value,
        variance: variance,
        static: null
    });
}
function $5a994a4f6012c7eb$var$objectTypeProperty(key, value, variance = null) {
    return (0, $70DJx.default)({
        type: "ObjectTypeProperty",
        key: key,
        value: value,
        variance: variance,
        kind: null,
        method: null,
        optional: null,
        proto: null,
        static: null
    });
}
function $5a994a4f6012c7eb$var$objectTypeSpreadProperty(argument) {
    return (0, $70DJx.default)({
        type: "ObjectTypeSpreadProperty",
        argument: argument
    });
}
function $5a994a4f6012c7eb$var$opaqueType(id, typeParameters = null, supertype = null, impltype) {
    return (0, $70DJx.default)({
        type: "OpaqueType",
        id: id,
        typeParameters: typeParameters,
        supertype: supertype,
        impltype: impltype
    });
}
function $5a994a4f6012c7eb$var$qualifiedTypeIdentifier(id, qualification) {
    return (0, $70DJx.default)({
        type: "QualifiedTypeIdentifier",
        id: id,
        qualification: qualification
    });
}
function $5a994a4f6012c7eb$var$stringLiteralTypeAnnotation(value) {
    return (0, $70DJx.default)({
        type: "StringLiteralTypeAnnotation",
        value: value
    });
}
function $5a994a4f6012c7eb$var$stringTypeAnnotation() {
    return {
        type: "StringTypeAnnotation"
    };
}
function $5a994a4f6012c7eb$var$symbolTypeAnnotation() {
    return {
        type: "SymbolTypeAnnotation"
    };
}
function $5a994a4f6012c7eb$var$thisTypeAnnotation() {
    return {
        type: "ThisTypeAnnotation"
    };
}
function $5a994a4f6012c7eb$var$tupleTypeAnnotation(types) {
    return (0, $70DJx.default)({
        type: "TupleTypeAnnotation",
        types: types
    });
}
function $5a994a4f6012c7eb$var$typeofTypeAnnotation(argument) {
    return (0, $70DJx.default)({
        type: "TypeofTypeAnnotation",
        argument: argument
    });
}
function $5a994a4f6012c7eb$var$typeAlias(id, typeParameters = null, right) {
    return (0, $70DJx.default)({
        type: "TypeAlias",
        id: id,
        typeParameters: typeParameters,
        right: right
    });
}
function $5a994a4f6012c7eb$var$typeAnnotation(typeAnnotation) {
    return (0, $70DJx.default)({
        type: "TypeAnnotation",
        typeAnnotation: typeAnnotation
    });
}
function $5a994a4f6012c7eb$var$typeCastExpression(expression, typeAnnotation) {
    return (0, $70DJx.default)({
        type: "TypeCastExpression",
        expression: expression,
        typeAnnotation: typeAnnotation
    });
}
function $5a994a4f6012c7eb$var$typeParameter(bound = null, _default = null, variance = null) {
    return (0, $70DJx.default)({
        type: "TypeParameter",
        bound: bound,
        default: _default,
        variance: variance,
        name: null
    });
}
function $5a994a4f6012c7eb$var$typeParameterDeclaration(params) {
    return (0, $70DJx.default)({
        type: "TypeParameterDeclaration",
        params: params
    });
}
function $5a994a4f6012c7eb$var$typeParameterInstantiation(params) {
    return (0, $70DJx.default)({
        type: "TypeParameterInstantiation",
        params: params
    });
}
function $5a994a4f6012c7eb$var$unionTypeAnnotation(types) {
    return (0, $70DJx.default)({
        type: "UnionTypeAnnotation",
        types: types
    });
}
function $5a994a4f6012c7eb$var$variance(kind) {
    return (0, $70DJx.default)({
        type: "Variance",
        kind: kind
    });
}
function $5a994a4f6012c7eb$var$voidTypeAnnotation() {
    return {
        type: "VoidTypeAnnotation"
    };
}
function $5a994a4f6012c7eb$var$enumDeclaration(id, body) {
    return (0, $70DJx.default)({
        type: "EnumDeclaration",
        id: id,
        body: body
    });
}
function $5a994a4f6012c7eb$var$enumBooleanBody(members) {
    return (0, $70DJx.default)({
        type: "EnumBooleanBody",
        members: members,
        explicitType: null,
        hasUnknownMembers: null
    });
}
function $5a994a4f6012c7eb$var$enumNumberBody(members) {
    return (0, $70DJx.default)({
        type: "EnumNumberBody",
        members: members,
        explicitType: null,
        hasUnknownMembers: null
    });
}
function $5a994a4f6012c7eb$var$enumStringBody(members) {
    return (0, $70DJx.default)({
        type: "EnumStringBody",
        members: members,
        explicitType: null,
        hasUnknownMembers: null
    });
}
function $5a994a4f6012c7eb$var$enumSymbolBody(members) {
    return (0, $70DJx.default)({
        type: "EnumSymbolBody",
        members: members,
        hasUnknownMembers: null
    });
}
function $5a994a4f6012c7eb$var$enumBooleanMember(id) {
    return (0, $70DJx.default)({
        type: "EnumBooleanMember",
        id: id,
        init: null
    });
}
function $5a994a4f6012c7eb$var$enumNumberMember(id, init) {
    return (0, $70DJx.default)({
        type: "EnumNumberMember",
        id: id,
        init: init
    });
}
function $5a994a4f6012c7eb$var$enumStringMember(id, init) {
    return (0, $70DJx.default)({
        type: "EnumStringMember",
        id: id,
        init: init
    });
}
function $5a994a4f6012c7eb$var$enumDefaultedMember(id) {
    return (0, $70DJx.default)({
        type: "EnumDefaultedMember",
        id: id
    });
}
function $5a994a4f6012c7eb$var$indexedAccessType(objectType, indexType) {
    return (0, $70DJx.default)({
        type: "IndexedAccessType",
        objectType: objectType,
        indexType: indexType
    });
}
function $5a994a4f6012c7eb$var$optionalIndexedAccessType(objectType, indexType) {
    return (0, $70DJx.default)({
        type: "OptionalIndexedAccessType",
        objectType: objectType,
        indexType: indexType,
        optional: null
    });
}
function $5a994a4f6012c7eb$var$jsxAttribute(name, value = null) {
    return (0, $70DJx.default)({
        type: "JSXAttribute",
        name: name,
        value: value
    });
}
function $5a994a4f6012c7eb$var$jsxClosingElement(name) {
    return (0, $70DJx.default)({
        type: "JSXClosingElement",
        name: name
    });
}
function $5a994a4f6012c7eb$var$jsxElement(openingElement, closingElement = null, children, selfClosing = null) {
    return (0, $70DJx.default)({
        type: "JSXElement",
        openingElement: openingElement,
        closingElement: closingElement,
        children: children,
        selfClosing: selfClosing
    });
}
function $5a994a4f6012c7eb$var$jsxEmptyExpression() {
    return {
        type: "JSXEmptyExpression"
    };
}
function $5a994a4f6012c7eb$var$jsxExpressionContainer(expression) {
    return (0, $70DJx.default)({
        type: "JSXExpressionContainer",
        expression: expression
    });
}
function $5a994a4f6012c7eb$var$jsxSpreadChild(expression) {
    return (0, $70DJx.default)({
        type: "JSXSpreadChild",
        expression: expression
    });
}
function $5a994a4f6012c7eb$var$jsxIdentifier(name) {
    return (0, $70DJx.default)({
        type: "JSXIdentifier",
        name: name
    });
}
function $5a994a4f6012c7eb$var$jsxMemberExpression(object, property) {
    return (0, $70DJx.default)({
        type: "JSXMemberExpression",
        object: object,
        property: property
    });
}
function $5a994a4f6012c7eb$var$jsxNamespacedName(namespace, name) {
    return (0, $70DJx.default)({
        type: "JSXNamespacedName",
        namespace: namespace,
        name: name
    });
}
function $5a994a4f6012c7eb$var$jsxOpeningElement(name, attributes, selfClosing = false) {
    return (0, $70DJx.default)({
        type: "JSXOpeningElement",
        name: name,
        attributes: attributes,
        selfClosing: selfClosing
    });
}
function $5a994a4f6012c7eb$var$jsxSpreadAttribute(argument) {
    return (0, $70DJx.default)({
        type: "JSXSpreadAttribute",
        argument: argument
    });
}
function $5a994a4f6012c7eb$var$jsxText(value) {
    return (0, $70DJx.default)({
        type: "JSXText",
        value: value
    });
}
function $5a994a4f6012c7eb$var$jsxFragment(openingFragment, closingFragment, children) {
    return (0, $70DJx.default)({
        type: "JSXFragment",
        openingFragment: openingFragment,
        closingFragment: closingFragment,
        children: children
    });
}
function $5a994a4f6012c7eb$var$jsxOpeningFragment() {
    return {
        type: "JSXOpeningFragment"
    };
}
function $5a994a4f6012c7eb$var$jsxClosingFragment() {
    return {
        type: "JSXClosingFragment"
    };
}
function $5a994a4f6012c7eb$var$noop() {
    return {
        type: "Noop"
    };
}
function $5a994a4f6012c7eb$var$placeholder(expectedNode, name) {
    return (0, $70DJx.default)({
        type: "Placeholder",
        expectedNode: expectedNode,
        name: name
    });
}
function $5a994a4f6012c7eb$var$v8IntrinsicIdentifier(name) {
    return (0, $70DJx.default)({
        type: "V8IntrinsicIdentifier",
        name: name
    });
}
function $5a994a4f6012c7eb$var$argumentPlaceholder() {
    return {
        type: "ArgumentPlaceholder"
    };
}
function $5a994a4f6012c7eb$var$bindExpression(object, callee) {
    return (0, $70DJx.default)({
        type: "BindExpression",
        object: object,
        callee: callee
    });
}
function $5a994a4f6012c7eb$var$importAttribute(key, value) {
    return (0, $70DJx.default)({
        type: "ImportAttribute",
        key: key,
        value: value
    });
}
function $5a994a4f6012c7eb$var$decorator(expression) {
    return (0, $70DJx.default)({
        type: "Decorator",
        expression: expression
    });
}
function $5a994a4f6012c7eb$var$doExpression(body, async = false) {
    return (0, $70DJx.default)({
        type: "DoExpression",
        body: body,
        async: async
    });
}
function $5a994a4f6012c7eb$var$exportDefaultSpecifier(exported) {
    return (0, $70DJx.default)({
        type: "ExportDefaultSpecifier",
        exported: exported
    });
}
function $5a994a4f6012c7eb$var$recordExpression(properties) {
    return (0, $70DJx.default)({
        type: "RecordExpression",
        properties: properties
    });
}
function $5a994a4f6012c7eb$var$tupleExpression(elements = []) {
    return (0, $70DJx.default)({
        type: "TupleExpression",
        elements: elements
    });
}
function $5a994a4f6012c7eb$var$decimalLiteral(value) {
    return (0, $70DJx.default)({
        type: "DecimalLiteral",
        value: value
    });
}
function $5a994a4f6012c7eb$var$moduleExpression(body) {
    return (0, $70DJx.default)({
        type: "ModuleExpression",
        body: body
    });
}
function $5a994a4f6012c7eb$var$topicReference() {
    return {
        type: "TopicReference"
    };
}
function $5a994a4f6012c7eb$var$pipelineTopicExpression(expression) {
    return (0, $70DJx.default)({
        type: "PipelineTopicExpression",
        expression: expression
    });
}
function $5a994a4f6012c7eb$var$pipelineBareFunction(callee) {
    return (0, $70DJx.default)({
        type: "PipelineBareFunction",
        callee: callee
    });
}
function $5a994a4f6012c7eb$var$pipelinePrimaryTopicReference() {
    return {
        type: "PipelinePrimaryTopicReference"
    };
}
function $5a994a4f6012c7eb$var$tsParameterProperty(parameter) {
    return (0, $70DJx.default)({
        type: "TSParameterProperty",
        parameter: parameter
    });
}
function $5a994a4f6012c7eb$var$tsDeclareFunction(id = null, typeParameters = null, params, returnType = null) {
    return (0, $70DJx.default)({
        type: "TSDeclareFunction",
        id: id,
        typeParameters: typeParameters,
        params: params,
        returnType: returnType
    });
}
function $5a994a4f6012c7eb$var$tsDeclareMethod(decorators = null, key, typeParameters = null, params, returnType = null) {
    return (0, $70DJx.default)({
        type: "TSDeclareMethod",
        decorators: decorators,
        key: key,
        typeParameters: typeParameters,
        params: params,
        returnType: returnType
    });
}
function $5a994a4f6012c7eb$var$tsQualifiedName(left, right) {
    return (0, $70DJx.default)({
        type: "TSQualifiedName",
        left: left,
        right: right
    });
}
function $5a994a4f6012c7eb$var$tsCallSignatureDeclaration(typeParameters = null, parameters, typeAnnotation = null) {
    return (0, $70DJx.default)({
        type: "TSCallSignatureDeclaration",
        typeParameters: typeParameters,
        parameters: parameters,
        typeAnnotation: typeAnnotation
    });
}
function $5a994a4f6012c7eb$var$tsConstructSignatureDeclaration(typeParameters = null, parameters, typeAnnotation = null) {
    return (0, $70DJx.default)({
        type: "TSConstructSignatureDeclaration",
        typeParameters: typeParameters,
        parameters: parameters,
        typeAnnotation: typeAnnotation
    });
}
function $5a994a4f6012c7eb$var$tsPropertySignature(key, typeAnnotation = null) {
    return (0, $70DJx.default)({
        type: "TSPropertySignature",
        key: key,
        typeAnnotation: typeAnnotation,
        kind: null
    });
}
function $5a994a4f6012c7eb$var$tsMethodSignature(key, typeParameters = null, parameters, typeAnnotation = null) {
    return (0, $70DJx.default)({
        type: "TSMethodSignature",
        key: key,
        typeParameters: typeParameters,
        parameters: parameters,
        typeAnnotation: typeAnnotation,
        kind: null
    });
}
function $5a994a4f6012c7eb$var$tsIndexSignature(parameters, typeAnnotation = null) {
    return (0, $70DJx.default)({
        type: "TSIndexSignature",
        parameters: parameters,
        typeAnnotation: typeAnnotation
    });
}
function $5a994a4f6012c7eb$var$tsAnyKeyword() {
    return {
        type: "TSAnyKeyword"
    };
}
function $5a994a4f6012c7eb$var$tsBooleanKeyword() {
    return {
        type: "TSBooleanKeyword"
    };
}
function $5a994a4f6012c7eb$var$tsBigIntKeyword() {
    return {
        type: "TSBigIntKeyword"
    };
}
function $5a994a4f6012c7eb$var$tsIntrinsicKeyword() {
    return {
        type: "TSIntrinsicKeyword"
    };
}
function $5a994a4f6012c7eb$var$tsNeverKeyword() {
    return {
        type: "TSNeverKeyword"
    };
}
function $5a994a4f6012c7eb$var$tsNullKeyword() {
    return {
        type: "TSNullKeyword"
    };
}
function $5a994a4f6012c7eb$var$tsNumberKeyword() {
    return {
        type: "TSNumberKeyword"
    };
}
function $5a994a4f6012c7eb$var$tsObjectKeyword() {
    return {
        type: "TSObjectKeyword"
    };
}
function $5a994a4f6012c7eb$var$tsStringKeyword() {
    return {
        type: "TSStringKeyword"
    };
}
function $5a994a4f6012c7eb$var$tsSymbolKeyword() {
    return {
        type: "TSSymbolKeyword"
    };
}
function $5a994a4f6012c7eb$var$tsUndefinedKeyword() {
    return {
        type: "TSUndefinedKeyword"
    };
}
function $5a994a4f6012c7eb$var$tsUnknownKeyword() {
    return {
        type: "TSUnknownKeyword"
    };
}
function $5a994a4f6012c7eb$var$tsVoidKeyword() {
    return {
        type: "TSVoidKeyword"
    };
}
function $5a994a4f6012c7eb$var$tsThisType() {
    return {
        type: "TSThisType"
    };
}
function $5a994a4f6012c7eb$var$tsFunctionType(typeParameters = null, parameters, typeAnnotation = null) {
    return (0, $70DJx.default)({
        type: "TSFunctionType",
        typeParameters: typeParameters,
        parameters: parameters,
        typeAnnotation: typeAnnotation
    });
}
function $5a994a4f6012c7eb$var$tsConstructorType(typeParameters = null, parameters, typeAnnotation = null) {
    return (0, $70DJx.default)({
        type: "TSConstructorType",
        typeParameters: typeParameters,
        parameters: parameters,
        typeAnnotation: typeAnnotation
    });
}
function $5a994a4f6012c7eb$var$tsTypeReference(typeName, typeParameters = null) {
    return (0, $70DJx.default)({
        type: "TSTypeReference",
        typeName: typeName,
        typeParameters: typeParameters
    });
}
function $5a994a4f6012c7eb$var$tsTypePredicate(parameterName, typeAnnotation = null, asserts = null) {
    return (0, $70DJx.default)({
        type: "TSTypePredicate",
        parameterName: parameterName,
        typeAnnotation: typeAnnotation,
        asserts: asserts
    });
}
function $5a994a4f6012c7eb$var$tsTypeQuery(exprName, typeParameters = null) {
    return (0, $70DJx.default)({
        type: "TSTypeQuery",
        exprName: exprName,
        typeParameters: typeParameters
    });
}
function $5a994a4f6012c7eb$var$tsTypeLiteral(members) {
    return (0, $70DJx.default)({
        type: "TSTypeLiteral",
        members: members
    });
}
function $5a994a4f6012c7eb$var$tsArrayType(elementType) {
    return (0, $70DJx.default)({
        type: "TSArrayType",
        elementType: elementType
    });
}
function $5a994a4f6012c7eb$var$tsTupleType(elementTypes) {
    return (0, $70DJx.default)({
        type: "TSTupleType",
        elementTypes: elementTypes
    });
}
function $5a994a4f6012c7eb$var$tsOptionalType(typeAnnotation) {
    return (0, $70DJx.default)({
        type: "TSOptionalType",
        typeAnnotation: typeAnnotation
    });
}
function $5a994a4f6012c7eb$var$tsRestType(typeAnnotation) {
    return (0, $70DJx.default)({
        type: "TSRestType",
        typeAnnotation: typeAnnotation
    });
}
function $5a994a4f6012c7eb$var$tsNamedTupleMember(label, elementType, optional = false) {
    return (0, $70DJx.default)({
        type: "TSNamedTupleMember",
        label: label,
        elementType: elementType,
        optional: optional
    });
}
function $5a994a4f6012c7eb$var$tsUnionType(types) {
    return (0, $70DJx.default)({
        type: "TSUnionType",
        types: types
    });
}
function $5a994a4f6012c7eb$var$tsIntersectionType(types) {
    return (0, $70DJx.default)({
        type: "TSIntersectionType",
        types: types
    });
}
function $5a994a4f6012c7eb$var$tsConditionalType(checkType, extendsType, trueType, falseType) {
    return (0, $70DJx.default)({
        type: "TSConditionalType",
        checkType: checkType,
        extendsType: extendsType,
        trueType: trueType,
        falseType: falseType
    });
}
function $5a994a4f6012c7eb$var$tsInferType(typeParameter) {
    return (0, $70DJx.default)({
        type: "TSInferType",
        typeParameter: typeParameter
    });
}
function $5a994a4f6012c7eb$var$tsParenthesizedType(typeAnnotation) {
    return (0, $70DJx.default)({
        type: "TSParenthesizedType",
        typeAnnotation: typeAnnotation
    });
}
function $5a994a4f6012c7eb$var$tsTypeOperator(typeAnnotation) {
    return (0, $70DJx.default)({
        type: "TSTypeOperator",
        typeAnnotation: typeAnnotation,
        operator: null
    });
}
function $5a994a4f6012c7eb$var$tsIndexedAccessType(objectType, indexType) {
    return (0, $70DJx.default)({
        type: "TSIndexedAccessType",
        objectType: objectType,
        indexType: indexType
    });
}
function $5a994a4f6012c7eb$var$tsMappedType(typeParameter, typeAnnotation = null, nameType = null) {
    return (0, $70DJx.default)({
        type: "TSMappedType",
        typeParameter: typeParameter,
        typeAnnotation: typeAnnotation,
        nameType: nameType
    });
}
function $5a994a4f6012c7eb$var$tsLiteralType(literal) {
    return (0, $70DJx.default)({
        type: "TSLiteralType",
        literal: literal
    });
}
function $5a994a4f6012c7eb$var$tsExpressionWithTypeArguments(expression, typeParameters = null) {
    return (0, $70DJx.default)({
        type: "TSExpressionWithTypeArguments",
        expression: expression,
        typeParameters: typeParameters
    });
}
function $5a994a4f6012c7eb$var$tsInterfaceDeclaration(id, typeParameters = null, _extends = null, body) {
    return (0, $70DJx.default)({
        type: "TSInterfaceDeclaration",
        id: id,
        typeParameters: typeParameters,
        extends: _extends,
        body: body
    });
}
function $5a994a4f6012c7eb$var$tsInterfaceBody(body) {
    return (0, $70DJx.default)({
        type: "TSInterfaceBody",
        body: body
    });
}
function $5a994a4f6012c7eb$var$tsTypeAliasDeclaration(id, typeParameters = null, typeAnnotation) {
    return (0, $70DJx.default)({
        type: "TSTypeAliasDeclaration",
        id: id,
        typeParameters: typeParameters,
        typeAnnotation: typeAnnotation
    });
}
function $5a994a4f6012c7eb$var$tsInstantiationExpression(expression, typeParameters = null) {
    return (0, $70DJx.default)({
        type: "TSInstantiationExpression",
        expression: expression,
        typeParameters: typeParameters
    });
}
function $5a994a4f6012c7eb$var$tsAsExpression(expression, typeAnnotation) {
    return (0, $70DJx.default)({
        type: "TSAsExpression",
        expression: expression,
        typeAnnotation: typeAnnotation
    });
}
function $5a994a4f6012c7eb$var$tsSatisfiesExpression(expression, typeAnnotation) {
    return (0, $70DJx.default)({
        type: "TSSatisfiesExpression",
        expression: expression,
        typeAnnotation: typeAnnotation
    });
}
function $5a994a4f6012c7eb$var$tsTypeAssertion(typeAnnotation, expression) {
    return (0, $70DJx.default)({
        type: "TSTypeAssertion",
        typeAnnotation: typeAnnotation,
        expression: expression
    });
}
function $5a994a4f6012c7eb$var$tsEnumDeclaration(id, members) {
    return (0, $70DJx.default)({
        type: "TSEnumDeclaration",
        id: id,
        members: members
    });
}
function $5a994a4f6012c7eb$var$tsEnumMember(id, initializer = null) {
    return (0, $70DJx.default)({
        type: "TSEnumMember",
        id: id,
        initializer: initializer
    });
}
function $5a994a4f6012c7eb$var$tsModuleDeclaration(id, body) {
    return (0, $70DJx.default)({
        type: "TSModuleDeclaration",
        id: id,
        body: body
    });
}
function $5a994a4f6012c7eb$var$tsModuleBlock(body) {
    return (0, $70DJx.default)({
        type: "TSModuleBlock",
        body: body
    });
}
function $5a994a4f6012c7eb$var$tsImportType(argument, qualifier = null, typeParameters = null) {
    return (0, $70DJx.default)({
        type: "TSImportType",
        argument: argument,
        qualifier: qualifier,
        typeParameters: typeParameters
    });
}
function $5a994a4f6012c7eb$var$tsImportEqualsDeclaration(id, moduleReference) {
    return (0, $70DJx.default)({
        type: "TSImportEqualsDeclaration",
        id: id,
        moduleReference: moduleReference,
        isExport: null
    });
}
function $5a994a4f6012c7eb$var$tsExternalModuleReference(expression) {
    return (0, $70DJx.default)({
        type: "TSExternalModuleReference",
        expression: expression
    });
}
function $5a994a4f6012c7eb$var$tsNonNullExpression(expression) {
    return (0, $70DJx.default)({
        type: "TSNonNullExpression",
        expression: expression
    });
}
function $5a994a4f6012c7eb$var$tsExportAssignment(expression) {
    return (0, $70DJx.default)({
        type: "TSExportAssignment",
        expression: expression
    });
}
function $5a994a4f6012c7eb$var$tsNamespaceExportDeclaration(id) {
    return (0, $70DJx.default)({
        type: "TSNamespaceExportDeclaration",
        id: id
    });
}
function $5a994a4f6012c7eb$var$tsTypeAnnotation(typeAnnotation) {
    return (0, $70DJx.default)({
        type: "TSTypeAnnotation",
        typeAnnotation: typeAnnotation
    });
}
function $5a994a4f6012c7eb$var$tsTypeParameterInstantiation(params) {
    return (0, $70DJx.default)({
        type: "TSTypeParameterInstantiation",
        params: params
    });
}
function $5a994a4f6012c7eb$var$tsTypeParameterDeclaration(params) {
    return (0, $70DJx.default)({
        type: "TSTypeParameterDeclaration",
        params: params
    });
}
function $5a994a4f6012c7eb$var$tsTypeParameter(constraint = null, _default = null, name) {
    return (0, $70DJx.default)({
        type: "TSTypeParameter",
        constraint: constraint,
        default: _default,
        name: name
    });
}
function $5a994a4f6012c7eb$var$NumberLiteral(value) {
    (0, $7sVNt.default)("NumberLiteral", "NumericLiteral", "The node type ");
    return $5a994a4f6012c7eb$var$numericLiteral(value);
}
function $5a994a4f6012c7eb$var$RegexLiteral(pattern, flags = "") {
    (0, $7sVNt.default)("RegexLiteral", "RegExpLiteral", "The node type ");
    return $5a994a4f6012c7eb$var$regExpLiteral(pattern, flags);
}
function $5a994a4f6012c7eb$var$RestProperty(argument) {
    (0, $7sVNt.default)("RestProperty", "RestElement", "The node type ");
    return $5a994a4f6012c7eb$var$restElement(argument);
}
function $5a994a4f6012c7eb$var$SpreadProperty(argument) {
    (0, $7sVNt.default)("SpreadProperty", "SpreadElement", "The node type ");
    return $5a994a4f6012c7eb$var$spreadElement(argument);
}

});
parcelRegister("70DJx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $51a75abad86b5d26$var$validateNode;

var $30dxP = parcelRequire("30dxP");

var $ardUq = parcelRequire("ardUq");
function $51a75abad86b5d26$var$validateNode(node) {
    const keys = $ardUq.BUILDER_KEYS[node.type];
    for (const key of keys)(0, $30dxP.default)(node, key, node[key]);
    return node;
}

});
parcelRegister("30dxP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $22fbe0e18b3cf805$var$validate;
module.exports.validateChild = $22fbe0e18b3cf805$var$validateChild;
module.exports.validateField = $22fbe0e18b3cf805$var$validateField;

var $7TNHg = parcelRequire("7TNHg");
function $22fbe0e18b3cf805$var$validate(node, key, val) {
    if (!node) return;
    const fields = $7TNHg.NODE_FIELDS[node.type];
    if (!fields) return;
    const field = fields[key];
    $22fbe0e18b3cf805$var$validateField(node, key, val, field);
    $22fbe0e18b3cf805$var$validateChild(node, key, val);
}
function $22fbe0e18b3cf805$var$validateField(node, key, val, field) {
    if (!(field != null && field.validate)) return;
    if (field.optional && val == null) return;
    field.validate(node, key, val);
}
function $22fbe0e18b3cf805$var$validateChild(node, key, val) {
    if (val == null) return;
    const validate = $7TNHg.NODE_PARENT_VALIDATIONS[val.type];
    if (!validate) return;
    validate(node, key, val);
}

});
parcelRegister("7TNHg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "ALIAS_KEYS", {
    enumerable: true,
    get: function() {
        return $geP65.ALIAS_KEYS;
    }
});
Object.defineProperty(module.exports, "BUILDER_KEYS", {
    enumerable: true,
    get: function() {
        return $geP65.BUILDER_KEYS;
    }
});
Object.defineProperty(module.exports, "DEPRECATED_ALIASES", {
    enumerable: true,
    get: function() {
        return $21Mfp.DEPRECATED_ALIASES;
    }
});
Object.defineProperty(module.exports, "DEPRECATED_KEYS", {
    enumerable: true,
    get: function() {
        return $geP65.DEPRECATED_KEYS;
    }
});
Object.defineProperty(module.exports, "FLIPPED_ALIAS_KEYS", {
    enumerable: true,
    get: function() {
        return $geP65.FLIPPED_ALIAS_KEYS;
    }
});
Object.defineProperty(module.exports, "NODE_FIELDS", {
    enumerable: true,
    get: function() {
        return $geP65.NODE_FIELDS;
    }
});
Object.defineProperty(module.exports, "NODE_PARENT_VALIDATIONS", {
    enumerable: true,
    get: function() {
        return $geP65.NODE_PARENT_VALIDATIONS;
    }
});
Object.defineProperty(module.exports, "PLACEHOLDERS", {
    enumerable: true,
    get: function() {
        return $bPvXC.PLACEHOLDERS;
    }
});
Object.defineProperty(module.exports, "PLACEHOLDERS_ALIAS", {
    enumerable: true,
    get: function() {
        return $bPvXC.PLACEHOLDERS_ALIAS;
    }
});
Object.defineProperty(module.exports, "PLACEHOLDERS_FLIPPED_ALIAS", {
    enumerable: true,
    get: function() {
        return $bPvXC.PLACEHOLDERS_FLIPPED_ALIAS;
    }
});
module.exports.TYPES = void 0;
Object.defineProperty(module.exports, "VISITOR_KEYS", {
    enumerable: true,
    get: function() {
        return $geP65.VISITOR_KEYS;
    }
});

var $cw7K4 = parcelRequire("cw7K4");
parcelRequire("03zc9");
parcelRequire("auUlq");
parcelRequire("58Nt7");
parcelRequire("6Dn2K");
parcelRequire("1Z26G");
parcelRequire("cqXfs");

var $geP65 = parcelRequire("geP65");

var $bPvXC = parcelRequire("bPvXC");

var $21Mfp = parcelRequire("21Mfp");
Object.keys($21Mfp.DEPRECATED_ALIASES).forEach((deprecatedAlias)=>{
    $geP65.FLIPPED_ALIAS_KEYS[deprecatedAlias] = $geP65.FLIPPED_ALIAS_KEYS[$21Mfp.DEPRECATED_ALIASES[deprecatedAlias]];
});
$cw7K4($geP65.VISITOR_KEYS);
$cw7K4($geP65.ALIAS_KEYS);
$cw7K4($geP65.FLIPPED_ALIAS_KEYS);
$cw7K4($geP65.NODE_FIELDS);
$cw7K4($geP65.BUILDER_KEYS);
$cw7K4($geP65.DEPRECATED_KEYS);
$cw7K4($bPvXC.PLACEHOLDERS_ALIAS);
$cw7K4($bPvXC.PLACEHOLDERS_FLIPPED_ALIAS);
const $5c04383655a5dc73$var$TYPES = module.exports.TYPES = [].concat(Object.keys($geP65.VISITOR_KEYS), Object.keys($geP65.FLIPPED_ALIAS_KEYS), Object.keys($geP65.DEPRECATED_KEYS));

});
parcelRegister("cw7K4", function(module, exports) {
"use strict";
let $91ce7a9e0ef20b64$var$fastProto = null;
// Creates an object with permanently fast properties in V8. See Toon Verwaest's
// post https://medium.com/@tverwaes/setting-up-prototypes-in-v8-ec9c9491dfe2#5f62
// for more details. Use %HasFastProperties(object) and the Node.js flag
// --allow-natives-syntax to check whether an object has fast properties.
function $91ce7a9e0ef20b64$var$FastObject(o) {
    // A prototype object will have "fast properties" enabled once it is checked
    // against the inline property cache of a function, e.g. fastProto.property:
    // https://github.com/v8/v8/blob/6.0.122/test/mjsunit/fast-prototype.js#L48-L63
    if ($91ce7a9e0ef20b64$var$fastProto !== null && typeof $91ce7a9e0ef20b64$var$fastProto.property) {
        const result = $91ce7a9e0ef20b64$var$fastProto;
        $91ce7a9e0ef20b64$var$fastProto = $91ce7a9e0ef20b64$var$FastObject.prototype = null;
        return result;
    }
    $91ce7a9e0ef20b64$var$fastProto = $91ce7a9e0ef20b64$var$FastObject.prototype = o == null ? Object.create(null) : o;
    return new $91ce7a9e0ef20b64$var$FastObject;
}
// Initialize the inline property cache of FastObject
$91ce7a9e0ef20b64$var$FastObject();
module.exports = function toFastproperties(o) {
    return $91ce7a9e0ef20b64$var$FastObject(o);
};

});

parcelRegister("03zc9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.patternLikeCommon = module.exports.functionTypeAnnotationCommon = module.exports.functionDeclarationCommon = module.exports.functionCommon = module.exports.classMethodOrPropertyCommon = module.exports.classMethodOrDeclareMethodCommon = void 0;
parcelRequire("4XzLl");
parcelRequire("9tPzx");
parcelRequire("2Ghih");

var $4Yp19 = parcelRequire("4Yp19");

var $l7lSB = parcelRequire("l7lSB");

var $geP65 = parcelRequire("geP65");
const $00ab94f1c167c340$var$defineType = (0, $geP65.defineAliasedType)("Standardized");
$00ab94f1c167c340$var$defineType("ArrayExpression", {
    fields: {
        elements: {
            validate: (0, $geP65.chain)((0, $geP65.assertValueType)("array"), (0, $geP65.assertEach)((0, $geP65.assertNodeOrValueType)("null", "Expression", "SpreadElement"))),
            default: []
        }
    },
    visitor: [
        "elements"
    ],
    aliases: [
        "Expression"
    ]
});
$00ab94f1c167c340$var$defineType("AssignmentExpression", {
    fields: {
        operator: {
            validate: function() {
                return (0, $geP65.assertValueType)("string");
            }()
        },
        left: {
            validate: (0, $geP65.assertNodeType)("LVal", "OptionalMemberExpression")
        },
        right: {
            validate: (0, $geP65.assertNodeType)("Expression")
        }
    },
    builder: [
        "operator",
        "left",
        "right"
    ],
    visitor: [
        "left",
        "right"
    ],
    aliases: [
        "Expression"
    ]
});
$00ab94f1c167c340$var$defineType("BinaryExpression", {
    builder: [
        "operator",
        "left",
        "right"
    ],
    fields: {
        operator: {
            validate: (0, $geP65.assertOneOf)(...$l7lSB.BINARY_OPERATORS)
        },
        left: {
            validate: function() {
                const expression = (0, $geP65.assertNodeType)("Expression");
                const inOp = (0, $geP65.assertNodeType)("Expression", "PrivateName");
                const validator = Object.assign(function(node, key, val) {
                    const validator = node.operator === "in" ? inOp : expression;
                    validator(node, key, val);
                }, {
                    oneOfNodeTypes: [
                        "Expression",
                        "PrivateName"
                    ]
                });
                return validator;
            }()
        },
        right: {
            validate: (0, $geP65.assertNodeType)("Expression")
        }
    },
    visitor: [
        "left",
        "right"
    ],
    aliases: [
        "Binary",
        "Expression"
    ]
});
$00ab94f1c167c340$var$defineType("InterpreterDirective", {
    builder: [
        "value"
    ],
    fields: {
        value: {
            validate: (0, $geP65.assertValueType)("string")
        }
    }
});
$00ab94f1c167c340$var$defineType("Directive", {
    visitor: [
        "value"
    ],
    fields: {
        value: {
            validate: (0, $geP65.assertNodeType)("DirectiveLiteral")
        }
    }
});
$00ab94f1c167c340$var$defineType("DirectiveLiteral", {
    builder: [
        "value"
    ],
    fields: {
        value: {
            validate: (0, $geP65.assertValueType)("string")
        }
    }
});
$00ab94f1c167c340$var$defineType("BlockStatement", {
    builder: [
        "body",
        "directives"
    ],
    visitor: [
        "directives",
        "body"
    ],
    fields: {
        directives: {
            validate: (0, $geP65.chain)((0, $geP65.assertValueType)("array"), (0, $geP65.assertEach)((0, $geP65.assertNodeType)("Directive"))),
            default: []
        },
        body: {
            validate: (0, $geP65.chain)((0, $geP65.assertValueType)("array"), (0, $geP65.assertEach)((0, $geP65.assertNodeType)("Statement")))
        }
    },
    aliases: [
        "Scopable",
        "BlockParent",
        "Block",
        "Statement"
    ]
});
$00ab94f1c167c340$var$defineType("BreakStatement", {
    visitor: [
        "label"
    ],
    fields: {
        label: {
            validate: (0, $geP65.assertNodeType)("Identifier"),
            optional: true
        }
    },
    aliases: [
        "Statement",
        "Terminatorless",
        "CompletionStatement"
    ]
});
$00ab94f1c167c340$var$defineType("CallExpression", {
    visitor: [
        "callee",
        "arguments",
        "typeParameters",
        "typeArguments"
    ],
    builder: [
        "callee",
        "arguments"
    ],
    aliases: [
        "Expression"
    ],
    fields: Object.assign({
        callee: {
            validate: (0, $geP65.assertNodeType)("Expression", "Super", "V8IntrinsicIdentifier")
        },
        arguments: {
            validate: (0, $geP65.chain)((0, $geP65.assertValueType)("array"), (0, $geP65.assertEach)((0, $geP65.assertNodeType)("Expression", "SpreadElement", "JSXNamespacedName", "ArgumentPlaceholder")))
        }
    }, {
        optional: {
            validate: (0, $geP65.assertOneOf)(true, false),
            optional: true
        }
    }, {
        typeArguments: {
            validate: (0, $geP65.assertNodeType)("TypeParameterInstantiation"),
            optional: true
        },
        typeParameters: {
            validate: (0, $geP65.assertNodeType)("TSTypeParameterInstantiation"),
            optional: true
        }
    })
});
$00ab94f1c167c340$var$defineType("CatchClause", {
    visitor: [
        "param",
        "body"
    ],
    fields: {
        param: {
            validate: (0, $geP65.assertNodeType)("Identifier", "ArrayPattern", "ObjectPattern"),
            optional: true
        },
        body: {
            validate: (0, $geP65.assertNodeType)("BlockStatement")
        }
    },
    aliases: [
        "Scopable",
        "BlockParent"
    ]
});
$00ab94f1c167c340$var$defineType("ConditionalExpression", {
    visitor: [
        "test",
        "consequent",
        "alternate"
    ],
    fields: {
        test: {
            validate: (0, $geP65.assertNodeType)("Expression")
        },
        consequent: {
            validate: (0, $geP65.assertNodeType)("Expression")
        },
        alternate: {
            validate: (0, $geP65.assertNodeType)("Expression")
        }
    },
    aliases: [
        "Expression",
        "Conditional"
    ]
});
$00ab94f1c167c340$var$defineType("ContinueStatement", {
    visitor: [
        "label"
    ],
    fields: {
        label: {
            validate: (0, $geP65.assertNodeType)("Identifier"),
            optional: true
        }
    },
    aliases: [
        "Statement",
        "Terminatorless",
        "CompletionStatement"
    ]
});
$00ab94f1c167c340$var$defineType("DebuggerStatement", {
    aliases: [
        "Statement"
    ]
});
$00ab94f1c167c340$var$defineType("DoWhileStatement", {
    visitor: [
        "test",
        "body"
    ],
    fields: {
        test: {
            validate: (0, $geP65.assertNodeType)("Expression")
        },
        body: {
            validate: (0, $geP65.assertNodeType)("Statement")
        }
    },
    aliases: [
        "Statement",
        "BlockParent",
        "Loop",
        "While",
        "Scopable"
    ]
});
$00ab94f1c167c340$var$defineType("EmptyStatement", {
    aliases: [
        "Statement"
    ]
});
$00ab94f1c167c340$var$defineType("ExpressionStatement", {
    visitor: [
        "expression"
    ],
    fields: {
        expression: {
            validate: (0, $geP65.assertNodeType)("Expression")
        }
    },
    aliases: [
        "Statement",
        "ExpressionWrapper"
    ]
});
$00ab94f1c167c340$var$defineType("File", {
    builder: [
        "program",
        "comments",
        "tokens"
    ],
    visitor: [
        "program"
    ],
    fields: {
        program: {
            validate: (0, $geP65.assertNodeType)("Program")
        },
        comments: {
            validate: Object.assign(()=>{}, {
                each: {
                    oneOfNodeTypes: [
                        "CommentBlock",
                        "CommentLine"
                    ]
                }
            }),
            optional: true
        },
        tokens: {
            validate: (0, $geP65.assertEach)(Object.assign(()=>{}, {
                type: "any"
            })),
            optional: true
        }
    }
});
$00ab94f1c167c340$var$defineType("ForInStatement", {
    visitor: [
        "left",
        "right",
        "body"
    ],
    aliases: [
        "Scopable",
        "Statement",
        "For",
        "BlockParent",
        "Loop",
        "ForXStatement"
    ],
    fields: {
        left: {
            validate: (0, $geP65.assertNodeType)("VariableDeclaration", "LVal")
        },
        right: {
            validate: (0, $geP65.assertNodeType)("Expression")
        },
        body: {
            validate: (0, $geP65.assertNodeType)("Statement")
        }
    }
});
$00ab94f1c167c340$var$defineType("ForStatement", {
    visitor: [
        "init",
        "test",
        "update",
        "body"
    ],
    aliases: [
        "Scopable",
        "Statement",
        "For",
        "BlockParent",
        "Loop"
    ],
    fields: {
        init: {
            validate: (0, $geP65.assertNodeType)("VariableDeclaration", "Expression"),
            optional: true
        },
        test: {
            validate: (0, $geP65.assertNodeType)("Expression"),
            optional: true
        },
        update: {
            validate: (0, $geP65.assertNodeType)("Expression"),
            optional: true
        },
        body: {
            validate: (0, $geP65.assertNodeType)("Statement")
        }
    }
});
const $00ab94f1c167c340$var$functionCommon = ()=>({
        params: {
            validate: (0, $geP65.chain)((0, $geP65.assertValueType)("array"), (0, $geP65.assertEach)((0, $geP65.assertNodeType)("Identifier", "Pattern", "RestElement")))
        },
        generator: {
            default: false
        },
        async: {
            default: false
        }
    });
module.exports.functionCommon = $00ab94f1c167c340$var$functionCommon;
const $00ab94f1c167c340$var$functionTypeAnnotationCommon = ()=>({
        returnType: {
            validate: (0, $geP65.assertNodeType)("TypeAnnotation", "TSTypeAnnotation", "Noop"),
            optional: true
        },
        typeParameters: {
            validate: (0, $geP65.assertNodeType)("TypeParameterDeclaration", "TSTypeParameterDeclaration", "Noop"),
            optional: true
        }
    });
module.exports.functionTypeAnnotationCommon = $00ab94f1c167c340$var$functionTypeAnnotationCommon;
const $00ab94f1c167c340$var$functionDeclarationCommon = ()=>Object.assign({}, $00ab94f1c167c340$var$functionCommon(), {
        declare: {
            validate: (0, $geP65.assertValueType)("boolean"),
            optional: true
        },
        id: {
            validate: (0, $geP65.assertNodeType)("Identifier"),
            optional: true
        }
    });
module.exports.functionDeclarationCommon = $00ab94f1c167c340$var$functionDeclarationCommon;
$00ab94f1c167c340$var$defineType("FunctionDeclaration", {
    builder: [
        "id",
        "params",
        "body",
        "generator",
        "async"
    ],
    visitor: [
        "id",
        "params",
        "body",
        "returnType",
        "typeParameters"
    ],
    fields: Object.assign({}, $00ab94f1c167c340$var$functionDeclarationCommon(), $00ab94f1c167c340$var$functionTypeAnnotationCommon(), {
        body: {
            validate: (0, $geP65.assertNodeType)("BlockStatement")
        },
        predicate: {
            validate: (0, $geP65.assertNodeType)("DeclaredPredicate", "InferredPredicate"),
            optional: true
        }
    }),
    aliases: [
        "Scopable",
        "Function",
        "BlockParent",
        "FunctionParent",
        "Statement",
        "Pureish",
        "Declaration"
    ],
    validate: function() {
        return ()=>{};
    }()
});
$00ab94f1c167c340$var$defineType("FunctionExpression", {
    inherits: "FunctionDeclaration",
    aliases: [
        "Scopable",
        "Function",
        "BlockParent",
        "FunctionParent",
        "Expression",
        "Pureish"
    ],
    fields: Object.assign({}, $00ab94f1c167c340$var$functionCommon(), $00ab94f1c167c340$var$functionTypeAnnotationCommon(), {
        id: {
            validate: (0, $geP65.assertNodeType)("Identifier"),
            optional: true
        },
        body: {
            validate: (0, $geP65.assertNodeType)("BlockStatement")
        },
        predicate: {
            validate: (0, $geP65.assertNodeType)("DeclaredPredicate", "InferredPredicate"),
            optional: true
        }
    })
});
const $00ab94f1c167c340$var$patternLikeCommon = ()=>({
        typeAnnotation: {
            validate: (0, $geP65.assertNodeType)("TypeAnnotation", "TSTypeAnnotation", "Noop"),
            optional: true
        },
        optional: {
            validate: (0, $geP65.assertValueType)("boolean"),
            optional: true
        },
        decorators: {
            validate: (0, $geP65.chain)((0, $geP65.assertValueType)("array"), (0, $geP65.assertEach)((0, $geP65.assertNodeType)("Decorator"))),
            optional: true
        }
    });
module.exports.patternLikeCommon = $00ab94f1c167c340$var$patternLikeCommon;
$00ab94f1c167c340$var$defineType("Identifier", {
    builder: [
        "name"
    ],
    visitor: [
        "typeAnnotation",
        "decorators"
    ],
    aliases: [
        "Expression",
        "PatternLike",
        "LVal",
        "TSEntityName"
    ],
    fields: Object.assign({}, $00ab94f1c167c340$var$patternLikeCommon(), {
        name: {
            validate: (0, $geP65.chain)((0, $geP65.assertValueType)("string"), Object.assign(function(node, key, val) {
                return;
            }, {
                type: "string"
            }))
        }
    }),
    validate (parent, key, node) {
        return;
    }
});
$00ab94f1c167c340$var$defineType("IfStatement", {
    visitor: [
        "test",
        "consequent",
        "alternate"
    ],
    aliases: [
        "Statement",
        "Conditional"
    ],
    fields: {
        test: {
            validate: (0, $geP65.assertNodeType)("Expression")
        },
        consequent: {
            validate: (0, $geP65.assertNodeType)("Statement")
        },
        alternate: {
            optional: true,
            validate: (0, $geP65.assertNodeType)("Statement")
        }
    }
});
$00ab94f1c167c340$var$defineType("LabeledStatement", {
    visitor: [
        "label",
        "body"
    ],
    aliases: [
        "Statement"
    ],
    fields: {
        label: {
            validate: (0, $geP65.assertNodeType)("Identifier")
        },
        body: {
            validate: (0, $geP65.assertNodeType)("Statement")
        }
    }
});
$00ab94f1c167c340$var$defineType("StringLiteral", {
    builder: [
        "value"
    ],
    fields: {
        value: {
            validate: (0, $geP65.assertValueType)("string")
        }
    },
    aliases: [
        "Expression",
        "Pureish",
        "Literal",
        "Immutable"
    ]
});
$00ab94f1c167c340$var$defineType("NumericLiteral", {
    builder: [
        "value"
    ],
    deprecatedAlias: "NumberLiteral",
    fields: {
        value: {
            validate: (0, $geP65.chain)((0, $geP65.assertValueType)("number"), Object.assign(function(node, key, val) {
                if (1 / val < 0 || !Number.isFinite(val)) {
                    const error = new Error("NumericLiterals must be non-negative finite numbers. " + `You can use t.valueToNode(${val}) instead.`);
                }
            }, {
                type: "number"
            }))
        }
    },
    aliases: [
        "Expression",
        "Pureish",
        "Literal",
        "Immutable"
    ]
});
$00ab94f1c167c340$var$defineType("NullLiteral", {
    aliases: [
        "Expression",
        "Pureish",
        "Literal",
        "Immutable"
    ]
});
$00ab94f1c167c340$var$defineType("BooleanLiteral", {
    builder: [
        "value"
    ],
    fields: {
        value: {
            validate: (0, $geP65.assertValueType)("boolean")
        }
    },
    aliases: [
        "Expression",
        "Pureish",
        "Literal",
        "Immutable"
    ]
});
$00ab94f1c167c340$var$defineType("RegExpLiteral", {
    builder: [
        "pattern",
        "flags"
    ],
    deprecatedAlias: "RegexLiteral",
    aliases: [
        "Expression",
        "Pureish",
        "Literal"
    ],
    fields: {
        pattern: {
            validate: (0, $geP65.assertValueType)("string")
        },
        flags: {
            validate: (0, $geP65.chain)((0, $geP65.assertValueType)("string"), Object.assign(function(node, key, val) {
                return;
            }, {
                type: "string"
            })),
            default: ""
        }
    }
});
$00ab94f1c167c340$var$defineType("LogicalExpression", {
    builder: [
        "operator",
        "left",
        "right"
    ],
    visitor: [
        "left",
        "right"
    ],
    aliases: [
        "Binary",
        "Expression"
    ],
    fields: {
        operator: {
            validate: (0, $geP65.assertOneOf)(...$l7lSB.LOGICAL_OPERATORS)
        },
        left: {
            validate: (0, $geP65.assertNodeType)("Expression")
        },
        right: {
            validate: (0, $geP65.assertNodeType)("Expression")
        }
    }
});
$00ab94f1c167c340$var$defineType("MemberExpression", {
    builder: [
        "object",
        "property",
        "computed",
        "optional"
    ],
    visitor: [
        "object",
        "property"
    ],
    aliases: [
        "Expression",
        "LVal"
    ],
    fields: Object.assign({
        object: {
            validate: (0, $geP65.assertNodeType)("Expression", "Super")
        },
        property: {
            validate: function() {
                const normal = (0, $geP65.assertNodeType)("Identifier", "PrivateName");
                const computed = (0, $geP65.assertNodeType)("Expression");
                const validator = function(node, key, val) {
                    const validator = node.computed ? computed : normal;
                    validator(node, key, val);
                };
                validator.oneOfNodeTypes = [
                    "Expression",
                    "Identifier",
                    "PrivateName"
                ];
                return validator;
            }()
        },
        computed: {
            default: false
        }
    }, {
        optional: {
            validate: (0, $geP65.assertOneOf)(true, false),
            optional: true
        }
    })
});
$00ab94f1c167c340$var$defineType("NewExpression", {
    inherits: "CallExpression"
});
$00ab94f1c167c340$var$defineType("Program", {
    visitor: [
        "directives",
        "body"
    ],
    builder: [
        "body",
        "directives",
        "sourceType",
        "interpreter"
    ],
    fields: {
        sourceType: {
            validate: (0, $geP65.assertOneOf)("script", "module"),
            default: "script"
        },
        interpreter: {
            validate: (0, $geP65.assertNodeType)("InterpreterDirective"),
            default: null,
            optional: true
        },
        directives: {
            validate: (0, $geP65.chain)((0, $geP65.assertValueType)("array"), (0, $geP65.assertEach)((0, $geP65.assertNodeType)("Directive"))),
            default: []
        },
        body: {
            validate: (0, $geP65.chain)((0, $geP65.assertValueType)("array"), (0, $geP65.assertEach)((0, $geP65.assertNodeType)("Statement")))
        }
    },
    aliases: [
        "Scopable",
        "BlockParent",
        "Block"
    ]
});
$00ab94f1c167c340$var$defineType("ObjectExpression", {
    visitor: [
        "properties"
    ],
    aliases: [
        "Expression"
    ],
    fields: {
        properties: {
            validate: (0, $geP65.chain)((0, $geP65.assertValueType)("array"), (0, $geP65.assertEach)((0, $geP65.assertNodeType)("ObjectMethod", "ObjectProperty", "SpreadElement")))
        }
    }
});
$00ab94f1c167c340$var$defineType("ObjectMethod", {
    builder: [
        "kind",
        "key",
        "params",
        "body",
        "computed",
        "generator",
        "async"
    ],
    fields: Object.assign({}, $00ab94f1c167c340$var$functionCommon(), $00ab94f1c167c340$var$functionTypeAnnotationCommon(), {
        kind: Object.assign({
            validate: (0, $geP65.assertOneOf)("method", "get", "set")
        }, {
            default: "method"
        }),
        computed: {
            default: false
        },
        key: {
            validate: function() {
                const normal = (0, $geP65.assertNodeType)("Identifier", "StringLiteral", "NumericLiteral", "BigIntLiteral");
                const computed = (0, $geP65.assertNodeType)("Expression");
                const validator = function(node, key, val) {
                    const validator = node.computed ? computed : normal;
                    validator(node, key, val);
                };
                validator.oneOfNodeTypes = [
                    "Expression",
                    "Identifier",
                    "StringLiteral",
                    "NumericLiteral",
                    "BigIntLiteral"
                ];
                return validator;
            }()
        },
        decorators: {
            validate: (0, $geP65.chain)((0, $geP65.assertValueType)("array"), (0, $geP65.assertEach)((0, $geP65.assertNodeType)("Decorator"))),
            optional: true
        },
        body: {
            validate: (0, $geP65.assertNodeType)("BlockStatement")
        }
    }),
    visitor: [
        "key",
        "params",
        "body",
        "decorators",
        "returnType",
        "typeParameters"
    ],
    aliases: [
        "UserWhitespacable",
        "Function",
        "Scopable",
        "BlockParent",
        "FunctionParent",
        "Method",
        "ObjectMember"
    ]
});
$00ab94f1c167c340$var$defineType("ObjectProperty", {
    builder: [
        "key",
        "value",
        "computed",
        "shorthand",
        "decorators"
    ],
    fields: {
        computed: {
            default: false
        },
        key: {
            validate: function() {
                const normal = (0, $geP65.assertNodeType)("Identifier", "StringLiteral", "NumericLiteral", "BigIntLiteral", "DecimalLiteral", "PrivateName");
                const computed = (0, $geP65.assertNodeType)("Expression");
                const validator = Object.assign(function(node, key, val) {
                    const validator = node.computed ? computed : normal;
                    validator(node, key, val);
                }, {
                    oneOfNodeTypes: [
                        "Expression",
                        "Identifier",
                        "StringLiteral",
                        "NumericLiteral",
                        "BigIntLiteral",
                        "DecimalLiteral",
                        "PrivateName"
                    ]
                });
                return validator;
            }()
        },
        value: {
            validate: (0, $geP65.assertNodeType)("Expression", "PatternLike")
        },
        shorthand: {
            validate: (0, $geP65.chain)((0, $geP65.assertValueType)("boolean"), Object.assign(function(node, key, val) {
                return;
            }, {
                type: "boolean"
            }), function(node, key, val) {
                return;
            }),
            default: false
        },
        decorators: {
            validate: (0, $geP65.chain)((0, $geP65.assertValueType)("array"), (0, $geP65.assertEach)((0, $geP65.assertNodeType)("Decorator"))),
            optional: true
        }
    },
    visitor: [
        "key",
        "value",
        "decorators"
    ],
    aliases: [
        "UserWhitespacable",
        "Property",
        "ObjectMember"
    ],
    validate: function() {
        const pattern = (0, $geP65.assertNodeType)("Identifier", "Pattern", "TSAsExpression", "TSSatisfiesExpression", "TSNonNullExpression", "TSTypeAssertion");
        const expression = (0, $geP65.assertNodeType)("Expression");
        return function(parent, key, node) {
            return;
        };
    }()
});
$00ab94f1c167c340$var$defineType("RestElement", {
    visitor: [
        "argument",
        "typeAnnotation"
    ],
    builder: [
        "argument"
    ],
    aliases: [
        "LVal",
        "PatternLike"
    ],
    deprecatedAlias: "RestProperty",
    fields: Object.assign({}, $00ab94f1c167c340$var$patternLikeCommon(), {
        argument: {
            validate: (0, $geP65.assertNodeType)("LVal")
        }
    }),
    validate (parent, key) {
        return;
    }
});
$00ab94f1c167c340$var$defineType("ReturnStatement", {
    visitor: [
        "argument"
    ],
    aliases: [
        "Statement",
        "Terminatorless",
        "CompletionStatement"
    ],
    fields: {
        argument: {
            validate: (0, $geP65.assertNodeType)("Expression"),
            optional: true
        }
    }
});
$00ab94f1c167c340$var$defineType("SequenceExpression", {
    visitor: [
        "expressions"
    ],
    fields: {
        expressions: {
            validate: (0, $geP65.chain)((0, $geP65.assertValueType)("array"), (0, $geP65.assertEach)((0, $geP65.assertNodeType)("Expression")))
        }
    },
    aliases: [
        "Expression"
    ]
});
$00ab94f1c167c340$var$defineType("ParenthesizedExpression", {
    visitor: [
        "expression"
    ],
    aliases: [
        "Expression",
        "ExpressionWrapper"
    ],
    fields: {
        expression: {
            validate: (0, $geP65.assertNodeType)("Expression")
        }
    }
});
$00ab94f1c167c340$var$defineType("SwitchCase", {
    visitor: [
        "test",
        "consequent"
    ],
    fields: {
        test: {
            validate: (0, $geP65.assertNodeType)("Expression"),
            optional: true
        },
        consequent: {
            validate: (0, $geP65.chain)((0, $geP65.assertValueType)("array"), (0, $geP65.assertEach)((0, $geP65.assertNodeType)("Statement")))
        }
    }
});
$00ab94f1c167c340$var$defineType("SwitchStatement", {
    visitor: [
        "discriminant",
        "cases"
    ],
    aliases: [
        "Statement",
        "BlockParent",
        "Scopable"
    ],
    fields: {
        discriminant: {
            validate: (0, $geP65.assertNodeType)("Expression")
        },
        cases: {
            validate: (0, $geP65.chain)((0, $geP65.assertValueType)("array"), (0, $geP65.assertEach)((0, $geP65.assertNodeType)("SwitchCase")))
        }
    }
});
$00ab94f1c167c340$var$defineType("ThisExpression", {
    aliases: [
        "Expression"
    ]
});
$00ab94f1c167c340$var$defineType("ThrowStatement", {
    visitor: [
        "argument"
    ],
    aliases: [
        "Statement",
        "Terminatorless",
        "CompletionStatement"
    ],
    fields: {
        argument: {
            validate: (0, $geP65.assertNodeType)("Expression")
        }
    }
});
$00ab94f1c167c340$var$defineType("TryStatement", {
    visitor: [
        "block",
        "handler",
        "finalizer"
    ],
    aliases: [
        "Statement"
    ],
    fields: {
        block: {
            validate: (0, $geP65.chain)((0, $geP65.assertNodeType)("BlockStatement"), Object.assign(function(node) {
                return;
            }, {
                oneOfNodeTypes: [
                    "BlockStatement"
                ]
            }))
        },
        handler: {
            optional: true,
            validate: (0, $geP65.assertNodeType)("CatchClause")
        },
        finalizer: {
            optional: true,
            validate: (0, $geP65.assertNodeType)("BlockStatement")
        }
    }
});
$00ab94f1c167c340$var$defineType("UnaryExpression", {
    builder: [
        "operator",
        "argument",
        "prefix"
    ],
    fields: {
        prefix: {
            default: true
        },
        argument: {
            validate: (0, $geP65.assertNodeType)("Expression")
        },
        operator: {
            validate: (0, $geP65.assertOneOf)(...$l7lSB.UNARY_OPERATORS)
        }
    },
    visitor: [
        "argument"
    ],
    aliases: [
        "UnaryLike",
        "Expression"
    ]
});
$00ab94f1c167c340$var$defineType("UpdateExpression", {
    builder: [
        "operator",
        "argument",
        "prefix"
    ],
    fields: {
        prefix: {
            default: false
        },
        argument: {
            validate: (0, $geP65.assertNodeType)("Expression")
        },
        operator: {
            validate: (0, $geP65.assertOneOf)(...$l7lSB.UPDATE_OPERATORS)
        }
    },
    visitor: [
        "argument"
    ],
    aliases: [
        "Expression"
    ]
});
$00ab94f1c167c340$var$defineType("VariableDeclaration", {
    builder: [
        "kind",
        "declarations"
    ],
    visitor: [
        "declarations"
    ],
    aliases: [
        "Statement",
        "Declaration"
    ],
    fields: {
        declare: {
            validate: (0, $geP65.assertValueType)("boolean"),
            optional: true
        },
        kind: {
            validate: (0, $geP65.assertOneOf)("var", "let", "const", "using", "await using")
        },
        declarations: {
            validate: (0, $geP65.chain)((0, $geP65.assertValueType)("array"), (0, $geP65.assertEach)((0, $geP65.assertNodeType)("VariableDeclarator")))
        }
    },
    validate (parent, key, node) {
        return;
    }
});
$00ab94f1c167c340$var$defineType("VariableDeclarator", {
    visitor: [
        "id",
        "init"
    ],
    fields: {
        id: {
            validate: function() {
                return (0, $geP65.assertNodeType)("LVal");
            }()
        },
        definite: {
            optional: true,
            validate: (0, $geP65.assertValueType)("boolean")
        },
        init: {
            optional: true,
            validate: (0, $geP65.assertNodeType)("Expression")
        }
    }
});
$00ab94f1c167c340$var$defineType("WhileStatement", {
    visitor: [
        "test",
        "body"
    ],
    aliases: [
        "Statement",
        "BlockParent",
        "Loop",
        "While",
        "Scopable"
    ],
    fields: {
        test: {
            validate: (0, $geP65.assertNodeType)("Expression")
        },
        body: {
            validate: (0, $geP65.assertNodeType)("Statement")
        }
    }
});
$00ab94f1c167c340$var$defineType("WithStatement", {
    visitor: [
        "object",
        "body"
    ],
    aliases: [
        "Statement"
    ],
    fields: {
        object: {
            validate: (0, $geP65.assertNodeType)("Expression")
        },
        body: {
            validate: (0, $geP65.assertNodeType)("Statement")
        }
    }
});
$00ab94f1c167c340$var$defineType("AssignmentPattern", {
    visitor: [
        "left",
        "right",
        "decorators"
    ],
    builder: [
        "left",
        "right"
    ],
    aliases: [
        "Pattern",
        "PatternLike",
        "LVal"
    ],
    fields: Object.assign({}, $00ab94f1c167c340$var$patternLikeCommon(), {
        left: {
            validate: (0, $geP65.assertNodeType)("Identifier", "ObjectPattern", "ArrayPattern", "MemberExpression", "TSAsExpression", "TSSatisfiesExpression", "TSTypeAssertion", "TSNonNullExpression")
        },
        right: {
            validate: (0, $geP65.assertNodeType)("Expression")
        },
        decorators: {
            validate: (0, $geP65.chain)((0, $geP65.assertValueType)("array"), (0, $geP65.assertEach)((0, $geP65.assertNodeType)("Decorator"))),
            optional: true
        }
    })
});
$00ab94f1c167c340$var$defineType("ArrayPattern", {
    visitor: [
        "elements",
        "typeAnnotation"
    ],
    builder: [
        "elements"
    ],
    aliases: [
        "Pattern",
        "PatternLike",
        "LVal"
    ],
    fields: Object.assign({}, $00ab94f1c167c340$var$patternLikeCommon(), {
        elements: {
            validate: (0, $geP65.chain)((0, $geP65.assertValueType)("array"), (0, $geP65.assertEach)((0, $geP65.assertNodeOrValueType)("null", "PatternLike", "LVal")))
        }
    })
});
$00ab94f1c167c340$var$defineType("ArrowFunctionExpression", {
    builder: [
        "params",
        "body",
        "async"
    ],
    visitor: [
        "params",
        "body",
        "returnType",
        "typeParameters"
    ],
    aliases: [
        "Scopable",
        "Function",
        "BlockParent",
        "FunctionParent",
        "Expression",
        "Pureish"
    ],
    fields: Object.assign({}, $00ab94f1c167c340$var$functionCommon(), $00ab94f1c167c340$var$functionTypeAnnotationCommon(), {
        expression: {
            validate: (0, $geP65.assertValueType)("boolean")
        },
        body: {
            validate: (0, $geP65.assertNodeType)("BlockStatement", "Expression")
        },
        predicate: {
            validate: (0, $geP65.assertNodeType)("DeclaredPredicate", "InferredPredicate"),
            optional: true
        }
    })
});
$00ab94f1c167c340$var$defineType("ClassBody", {
    visitor: [
        "body"
    ],
    fields: {
        body: {
            validate: (0, $geP65.chain)((0, $geP65.assertValueType)("array"), (0, $geP65.assertEach)((0, $geP65.assertNodeType)("ClassMethod", "ClassPrivateMethod", "ClassProperty", "ClassPrivateProperty", "ClassAccessorProperty", "TSDeclareMethod", "TSIndexSignature", "StaticBlock")))
        }
    }
});
$00ab94f1c167c340$var$defineType("ClassExpression", {
    builder: [
        "id",
        "superClass",
        "body",
        "decorators"
    ],
    visitor: [
        "id",
        "body",
        "superClass",
        "mixins",
        "typeParameters",
        "superTypeParameters",
        "implements",
        "decorators"
    ],
    aliases: [
        "Scopable",
        "Class",
        "Expression"
    ],
    fields: {
        id: {
            validate: (0, $geP65.assertNodeType)("Identifier"),
            optional: true
        },
        typeParameters: {
            validate: (0, $geP65.assertNodeType)("TypeParameterDeclaration", "TSTypeParameterDeclaration", "Noop"),
            optional: true
        },
        body: {
            validate: (0, $geP65.assertNodeType)("ClassBody")
        },
        superClass: {
            optional: true,
            validate: (0, $geP65.assertNodeType)("Expression")
        },
        superTypeParameters: {
            validate: (0, $geP65.assertNodeType)("TypeParameterInstantiation", "TSTypeParameterInstantiation"),
            optional: true
        },
        implements: {
            validate: (0, $geP65.chain)((0, $geP65.assertValueType)("array"), (0, $geP65.assertEach)((0, $geP65.assertNodeType)("TSExpressionWithTypeArguments", "ClassImplements"))),
            optional: true
        },
        decorators: {
            validate: (0, $geP65.chain)((0, $geP65.assertValueType)("array"), (0, $geP65.assertEach)((0, $geP65.assertNodeType)("Decorator"))),
            optional: true
        },
        mixins: {
            validate: (0, $geP65.assertNodeType)("InterfaceExtends"),
            optional: true
        }
    }
});
$00ab94f1c167c340$var$defineType("ClassDeclaration", {
    inherits: "ClassExpression",
    aliases: [
        "Scopable",
        "Class",
        "Statement",
        "Declaration"
    ],
    fields: {
        id: {
            validate: (0, $geP65.assertNodeType)("Identifier"),
            optional: true
        },
        typeParameters: {
            validate: (0, $geP65.assertNodeType)("TypeParameterDeclaration", "TSTypeParameterDeclaration", "Noop"),
            optional: true
        },
        body: {
            validate: (0, $geP65.assertNodeType)("ClassBody")
        },
        superClass: {
            optional: true,
            validate: (0, $geP65.assertNodeType)("Expression")
        },
        superTypeParameters: {
            validate: (0, $geP65.assertNodeType)("TypeParameterInstantiation", "TSTypeParameterInstantiation"),
            optional: true
        },
        implements: {
            validate: (0, $geP65.chain)((0, $geP65.assertValueType)("array"), (0, $geP65.assertEach)((0, $geP65.assertNodeType)("TSExpressionWithTypeArguments", "ClassImplements"))),
            optional: true
        },
        decorators: {
            validate: (0, $geP65.chain)((0, $geP65.assertValueType)("array"), (0, $geP65.assertEach)((0, $geP65.assertNodeType)("Decorator"))),
            optional: true
        },
        mixins: {
            validate: (0, $geP65.assertNodeType)("InterfaceExtends"),
            optional: true
        },
        declare: {
            validate: (0, $geP65.assertValueType)("boolean"),
            optional: true
        },
        abstract: {
            validate: (0, $geP65.assertValueType)("boolean"),
            optional: true
        }
    },
    validate: function() {
        const identifier = (0, $geP65.assertNodeType)("Identifier");
        return function(parent, key, node) {
            return;
        };
    }()
});
$00ab94f1c167c340$var$defineType("ExportAllDeclaration", {
    builder: [
        "source"
    ],
    visitor: [
        "source",
        "attributes",
        "assertions"
    ],
    aliases: [
        "Statement",
        "Declaration",
        "ImportOrExportDeclaration",
        "ExportDeclaration"
    ],
    fields: {
        source: {
            validate: (0, $geP65.assertNodeType)("StringLiteral")
        },
        exportKind: (0, $geP65.validateOptional)((0, $geP65.assertOneOf)("type", "value")),
        attributes: {
            optional: true,
            validate: (0, $geP65.chain)((0, $geP65.assertValueType)("array"), (0, $geP65.assertEach)((0, $geP65.assertNodeType)("ImportAttribute")))
        },
        assertions: {
            optional: true,
            validate: (0, $geP65.chain)((0, $geP65.assertValueType)("array"), (0, $geP65.assertEach)((0, $geP65.assertNodeType)("ImportAttribute")))
        }
    }
});
$00ab94f1c167c340$var$defineType("ExportDefaultDeclaration", {
    visitor: [
        "declaration"
    ],
    aliases: [
        "Statement",
        "Declaration",
        "ImportOrExportDeclaration",
        "ExportDeclaration"
    ],
    fields: {
        declaration: {
            validate: (0, $geP65.assertNodeType)("TSDeclareFunction", "FunctionDeclaration", "ClassDeclaration", "Expression")
        },
        exportKind: (0, $geP65.validateOptional)((0, $geP65.assertOneOf)("value"))
    }
});
$00ab94f1c167c340$var$defineType("ExportNamedDeclaration", {
    builder: [
        "declaration",
        "specifiers",
        "source"
    ],
    visitor: [
        "declaration",
        "specifiers",
        "source",
        "attributes",
        "assertions"
    ],
    aliases: [
        "Statement",
        "Declaration",
        "ImportOrExportDeclaration",
        "ExportDeclaration"
    ],
    fields: {
        declaration: {
            optional: true,
            validate: (0, $geP65.chain)((0, $geP65.assertNodeType)("Declaration"), Object.assign(function(node, key, val) {
                return;
            }, {
                oneOfNodeTypes: [
                    "Declaration"
                ]
            }), function(node, key, val) {
                return;
            })
        },
        attributes: {
            optional: true,
            validate: (0, $geP65.chain)((0, $geP65.assertValueType)("array"), (0, $geP65.assertEach)((0, $geP65.assertNodeType)("ImportAttribute")))
        },
        assertions: {
            optional: true,
            validate: (0, $geP65.chain)((0, $geP65.assertValueType)("array"), (0, $geP65.assertEach)((0, $geP65.assertNodeType)("ImportAttribute")))
        },
        specifiers: {
            default: [],
            validate: (0, $geP65.chain)((0, $geP65.assertValueType)("array"), (0, $geP65.assertEach)(function() {
                const sourced = (0, $geP65.assertNodeType)("ExportSpecifier", "ExportDefaultSpecifier", "ExportNamespaceSpecifier");
                const sourceless = (0, $geP65.assertNodeType)("ExportSpecifier");
                return sourced;
            }()))
        },
        source: {
            validate: (0, $geP65.assertNodeType)("StringLiteral"),
            optional: true
        },
        exportKind: (0, $geP65.validateOptional)((0, $geP65.assertOneOf)("type", "value"))
    }
});
$00ab94f1c167c340$var$defineType("ExportSpecifier", {
    visitor: [
        "local",
        "exported"
    ],
    aliases: [
        "ModuleSpecifier"
    ],
    fields: {
        local: {
            validate: (0, $geP65.assertNodeType)("Identifier")
        },
        exported: {
            validate: (0, $geP65.assertNodeType)("Identifier", "StringLiteral")
        },
        exportKind: {
            validate: (0, $geP65.assertOneOf)("type", "value"),
            optional: true
        }
    }
});
$00ab94f1c167c340$var$defineType("ForOfStatement", {
    visitor: [
        "left",
        "right",
        "body"
    ],
    builder: [
        "left",
        "right",
        "body",
        "await"
    ],
    aliases: [
        "Scopable",
        "Statement",
        "For",
        "BlockParent",
        "Loop",
        "ForXStatement"
    ],
    fields: {
        left: {
            validate: function() {
                return (0, $geP65.assertNodeType)("VariableDeclaration", "LVal");
            }()
        },
        right: {
            validate: (0, $geP65.assertNodeType)("Expression")
        },
        body: {
            validate: (0, $geP65.assertNodeType)("Statement")
        },
        await: {
            default: false
        }
    }
});
$00ab94f1c167c340$var$defineType("ImportDeclaration", {
    builder: [
        "specifiers",
        "source"
    ],
    visitor: [
        "specifiers",
        "source",
        "attributes",
        "assertions"
    ],
    aliases: [
        "Statement",
        "Declaration",
        "ImportOrExportDeclaration"
    ],
    fields: {
        attributes: {
            optional: true,
            validate: (0, $geP65.chain)((0, $geP65.assertValueType)("array"), (0, $geP65.assertEach)((0, $geP65.assertNodeType)("ImportAttribute")))
        },
        assertions: {
            optional: true,
            validate: (0, $geP65.chain)((0, $geP65.assertValueType)("array"), (0, $geP65.assertEach)((0, $geP65.assertNodeType)("ImportAttribute")))
        },
        module: {
            optional: true,
            validate: (0, $geP65.assertValueType)("boolean")
        },
        phase: {
            default: null,
            validate: (0, $geP65.assertOneOf)("source", "defer")
        },
        specifiers: {
            validate: (0, $geP65.chain)((0, $geP65.assertValueType)("array"), (0, $geP65.assertEach)((0, $geP65.assertNodeType)("ImportSpecifier", "ImportDefaultSpecifier", "ImportNamespaceSpecifier")))
        },
        source: {
            validate: (0, $geP65.assertNodeType)("StringLiteral")
        },
        importKind: {
            validate: (0, $geP65.assertOneOf)("type", "typeof", "value"),
            optional: true
        }
    }
});
$00ab94f1c167c340$var$defineType("ImportDefaultSpecifier", {
    visitor: [
        "local"
    ],
    aliases: [
        "ModuleSpecifier"
    ],
    fields: {
        local: {
            validate: (0, $geP65.assertNodeType)("Identifier")
        }
    }
});
$00ab94f1c167c340$var$defineType("ImportNamespaceSpecifier", {
    visitor: [
        "local"
    ],
    aliases: [
        "ModuleSpecifier"
    ],
    fields: {
        local: {
            validate: (0, $geP65.assertNodeType)("Identifier")
        }
    }
});
$00ab94f1c167c340$var$defineType("ImportSpecifier", {
    visitor: [
        "local",
        "imported"
    ],
    aliases: [
        "ModuleSpecifier"
    ],
    fields: {
        local: {
            validate: (0, $geP65.assertNodeType)("Identifier")
        },
        imported: {
            validate: (0, $geP65.assertNodeType)("Identifier", "StringLiteral")
        },
        importKind: {
            validate: (0, $geP65.assertOneOf)("type", "typeof", "value"),
            optional: true
        }
    }
});
$00ab94f1c167c340$var$defineType("ImportExpression", {
    visitor: [
        "source",
        "options"
    ],
    aliases: [
        "Expression"
    ],
    fields: {
        phase: {
            default: null,
            validate: (0, $geP65.assertOneOf)("source", "defer")
        },
        source: {
            validate: (0, $geP65.assertNodeType)("Expression")
        },
        options: {
            validate: (0, $geP65.assertNodeType)("Expression"),
            optional: true
        }
    }
});
$00ab94f1c167c340$var$defineType("MetaProperty", {
    visitor: [
        "meta",
        "property"
    ],
    aliases: [
        "Expression"
    ],
    fields: {
        meta: {
            validate: (0, $geP65.chain)((0, $geP65.assertNodeType)("Identifier"), Object.assign(function(node, key, val) {
                return;
            }, {
                oneOfNodeTypes: [
                    "Identifier"
                ]
            }))
        },
        property: {
            validate: (0, $geP65.assertNodeType)("Identifier")
        }
    }
});
const $00ab94f1c167c340$var$classMethodOrPropertyCommon = ()=>({
        abstract: {
            validate: (0, $geP65.assertValueType)("boolean"),
            optional: true
        },
        accessibility: {
            validate: (0, $geP65.assertOneOf)("public", "private", "protected"),
            optional: true
        },
        static: {
            default: false
        },
        override: {
            default: false
        },
        computed: {
            default: false
        },
        optional: {
            validate: (0, $geP65.assertValueType)("boolean"),
            optional: true
        },
        key: {
            validate: (0, $geP65.chain)(function() {
                const normal = (0, $geP65.assertNodeType)("Identifier", "StringLiteral", "NumericLiteral", "BigIntLiteral");
                const computed = (0, $geP65.assertNodeType)("Expression");
                return function(node, key, val) {
                    const validator = node.computed ? computed : normal;
                    validator(node, key, val);
                };
            }(), (0, $geP65.assertNodeType)("Identifier", "StringLiteral", "NumericLiteral", "BigIntLiteral", "Expression"))
        }
    });
module.exports.classMethodOrPropertyCommon = $00ab94f1c167c340$var$classMethodOrPropertyCommon;
const $00ab94f1c167c340$var$classMethodOrDeclareMethodCommon = ()=>Object.assign({}, $00ab94f1c167c340$var$functionCommon(), $00ab94f1c167c340$var$classMethodOrPropertyCommon(), {
        params: {
            validate: (0, $geP65.chain)((0, $geP65.assertValueType)("array"), (0, $geP65.assertEach)((0, $geP65.assertNodeType)("Identifier", "Pattern", "RestElement", "TSParameterProperty")))
        },
        kind: {
            validate: (0, $geP65.assertOneOf)("get", "set", "method", "constructor"),
            default: "method"
        },
        access: {
            validate: (0, $geP65.chain)((0, $geP65.assertValueType)("string"), (0, $geP65.assertOneOf)("public", "private", "protected")),
            optional: true
        },
        decorators: {
            validate: (0, $geP65.chain)((0, $geP65.assertValueType)("array"), (0, $geP65.assertEach)((0, $geP65.assertNodeType)("Decorator"))),
            optional: true
        }
    });
module.exports.classMethodOrDeclareMethodCommon = $00ab94f1c167c340$var$classMethodOrDeclareMethodCommon;
$00ab94f1c167c340$var$defineType("ClassMethod", {
    aliases: [
        "Function",
        "Scopable",
        "BlockParent",
        "FunctionParent",
        "Method"
    ],
    builder: [
        "kind",
        "key",
        "params",
        "body",
        "computed",
        "static",
        "generator",
        "async"
    ],
    visitor: [
        "key",
        "params",
        "body",
        "decorators",
        "returnType",
        "typeParameters"
    ],
    fields: Object.assign({}, $00ab94f1c167c340$var$classMethodOrDeclareMethodCommon(), $00ab94f1c167c340$var$functionTypeAnnotationCommon(), {
        body: {
            validate: (0, $geP65.assertNodeType)("BlockStatement")
        }
    })
});
$00ab94f1c167c340$var$defineType("ObjectPattern", {
    visitor: [
        "properties",
        "typeAnnotation",
        "decorators"
    ],
    builder: [
        "properties"
    ],
    aliases: [
        "Pattern",
        "PatternLike",
        "LVal"
    ],
    fields: Object.assign({}, $00ab94f1c167c340$var$patternLikeCommon(), {
        properties: {
            validate: (0, $geP65.chain)((0, $geP65.assertValueType)("array"), (0, $geP65.assertEach)((0, $geP65.assertNodeType)("RestElement", "ObjectProperty")))
        }
    })
});
$00ab94f1c167c340$var$defineType("SpreadElement", {
    visitor: [
        "argument"
    ],
    aliases: [
        "UnaryLike"
    ],
    deprecatedAlias: "SpreadProperty",
    fields: {
        argument: {
            validate: (0, $geP65.assertNodeType)("Expression")
        }
    }
});
$00ab94f1c167c340$var$defineType("Super", {
    aliases: [
        "Expression"
    ]
});
$00ab94f1c167c340$var$defineType("TaggedTemplateExpression", {
    visitor: [
        "tag",
        "quasi",
        "typeParameters"
    ],
    builder: [
        "tag",
        "quasi"
    ],
    aliases: [
        "Expression"
    ],
    fields: {
        tag: {
            validate: (0, $geP65.assertNodeType)("Expression")
        },
        quasi: {
            validate: (0, $geP65.assertNodeType)("TemplateLiteral")
        },
        typeParameters: {
            validate: (0, $geP65.assertNodeType)("TypeParameterInstantiation", "TSTypeParameterInstantiation"),
            optional: true
        }
    }
});
$00ab94f1c167c340$var$defineType("TemplateElement", {
    builder: [
        "value",
        "tail"
    ],
    fields: {
        value: {
            validate: (0, $geP65.chain)((0, $geP65.assertShape)({
                raw: {
                    validate: (0, $geP65.assertValueType)("string")
                },
                cooked: {
                    validate: (0, $geP65.assertValueType)("string"),
                    optional: true
                }
            }), function templateElementCookedValidator(node) {
                const raw = node.value.raw;
                let unterminatedCalled = false;
                const error = ()=>{
                    throw new Error("Internal @babel/types error.");
                };
                const { str: str, firstInvalidLoc: firstInvalidLoc } = (0, $4Yp19.readStringContents)("template", raw, 0, 0, 0, {
                    unterminated () {
                        unterminatedCalled = true;
                    },
                    strictNumericEscape: error,
                    invalidEscapeSequence: error,
                    numericSeparatorInEscapeSequence: error,
                    unexpectedNumericSeparator: error,
                    invalidDigit: error,
                    invalidCodePoint: error
                });
                if (!unterminatedCalled) throw new Error("Invalid raw");
                node.value.cooked = firstInvalidLoc ? null : str;
            })
        },
        tail: {
            default: false
        }
    }
});
$00ab94f1c167c340$var$defineType("TemplateLiteral", {
    visitor: [
        "quasis",
        "expressions"
    ],
    aliases: [
        "Expression",
        "Literal"
    ],
    fields: {
        quasis: {
            validate: (0, $geP65.chain)((0, $geP65.assertValueType)("array"), (0, $geP65.assertEach)((0, $geP65.assertNodeType)("TemplateElement")))
        },
        expressions: {
            validate: (0, $geP65.chain)((0, $geP65.assertValueType)("array"), (0, $geP65.assertEach)((0, $geP65.assertNodeType)("Expression", "TSType")), function(node, key, val) {
                if (node.quasis.length !== val.length + 1) throw new TypeError(`Number of ${node.type} quasis should be exactly one more than the number of expressions.\nExpected ${val.length + 1} quasis but got ${node.quasis.length}`);
            })
        }
    }
});
$00ab94f1c167c340$var$defineType("YieldExpression", {
    builder: [
        "argument",
        "delegate"
    ],
    visitor: [
        "argument"
    ],
    aliases: [
        "Expression",
        "Terminatorless"
    ],
    fields: {
        delegate: {
            validate: (0, $geP65.chain)((0, $geP65.assertValueType)("boolean"), Object.assign(function(node, key, val) {
                return;
            }, {
                type: "boolean"
            })),
            default: false
        },
        argument: {
            optional: true,
            validate: (0, $geP65.assertNodeType)("Expression")
        }
    }
});
$00ab94f1c167c340$var$defineType("AwaitExpression", {
    builder: [
        "argument"
    ],
    visitor: [
        "argument"
    ],
    aliases: [
        "Expression",
        "Terminatorless"
    ],
    fields: {
        argument: {
            validate: (0, $geP65.assertNodeType)("Expression")
        }
    }
});
$00ab94f1c167c340$var$defineType("Import", {
    aliases: [
        "Expression"
    ]
});
$00ab94f1c167c340$var$defineType("BigIntLiteral", {
    builder: [
        "value"
    ],
    fields: {
        value: {
            validate: (0, $geP65.assertValueType)("string")
        }
    },
    aliases: [
        "Expression",
        "Pureish",
        "Literal",
        "Immutable"
    ]
});
$00ab94f1c167c340$var$defineType("ExportNamespaceSpecifier", {
    visitor: [
        "exported"
    ],
    aliases: [
        "ModuleSpecifier"
    ],
    fields: {
        exported: {
            validate: (0, $geP65.assertNodeType)("Identifier")
        }
    }
});
$00ab94f1c167c340$var$defineType("OptionalMemberExpression", {
    builder: [
        "object",
        "property",
        "computed",
        "optional"
    ],
    visitor: [
        "object",
        "property"
    ],
    aliases: [
        "Expression"
    ],
    fields: {
        object: {
            validate: (0, $geP65.assertNodeType)("Expression")
        },
        property: {
            validate: function() {
                const normal = (0, $geP65.assertNodeType)("Identifier");
                const computed = (0, $geP65.assertNodeType)("Expression");
                const validator = Object.assign(function(node, key, val) {
                    const validator = node.computed ? computed : normal;
                    validator(node, key, val);
                }, {
                    oneOfNodeTypes: [
                        "Expression",
                        "Identifier"
                    ]
                });
                return validator;
            }()
        },
        computed: {
            default: false
        },
        optional: {
            validate: (0, $geP65.assertValueType)("boolean")
        }
    }
});
$00ab94f1c167c340$var$defineType("OptionalCallExpression", {
    visitor: [
        "callee",
        "arguments",
        "typeParameters",
        "typeArguments"
    ],
    builder: [
        "callee",
        "arguments",
        "optional"
    ],
    aliases: [
        "Expression"
    ],
    fields: {
        callee: {
            validate: (0, $geP65.assertNodeType)("Expression")
        },
        arguments: {
            validate: (0, $geP65.chain)((0, $geP65.assertValueType)("array"), (0, $geP65.assertEach)((0, $geP65.assertNodeType)("Expression", "SpreadElement", "JSXNamespacedName", "ArgumentPlaceholder")))
        },
        optional: {
            validate: (0, $geP65.assertValueType)("boolean")
        },
        typeArguments: {
            validate: (0, $geP65.assertNodeType)("TypeParameterInstantiation"),
            optional: true
        },
        typeParameters: {
            validate: (0, $geP65.assertNodeType)("TSTypeParameterInstantiation"),
            optional: true
        }
    }
});
$00ab94f1c167c340$var$defineType("ClassProperty", {
    visitor: [
        "key",
        "value",
        "typeAnnotation",
        "decorators"
    ],
    builder: [
        "key",
        "value",
        "typeAnnotation",
        "decorators",
        "computed",
        "static"
    ],
    aliases: [
        "Property"
    ],
    fields: Object.assign({}, $00ab94f1c167c340$var$classMethodOrPropertyCommon(), {
        value: {
            validate: (0, $geP65.assertNodeType)("Expression"),
            optional: true
        },
        definite: {
            validate: (0, $geP65.assertValueType)("boolean"),
            optional: true
        },
        typeAnnotation: {
            validate: (0, $geP65.assertNodeType)("TypeAnnotation", "TSTypeAnnotation", "Noop"),
            optional: true
        },
        decorators: {
            validate: (0, $geP65.chain)((0, $geP65.assertValueType)("array"), (0, $geP65.assertEach)((0, $geP65.assertNodeType)("Decorator"))),
            optional: true
        },
        readonly: {
            validate: (0, $geP65.assertValueType)("boolean"),
            optional: true
        },
        declare: {
            validate: (0, $geP65.assertValueType)("boolean"),
            optional: true
        },
        variance: {
            validate: (0, $geP65.assertNodeType)("Variance"),
            optional: true
        }
    })
});
$00ab94f1c167c340$var$defineType("ClassAccessorProperty", {
    visitor: [
        "key",
        "value",
        "typeAnnotation",
        "decorators"
    ],
    builder: [
        "key",
        "value",
        "typeAnnotation",
        "decorators",
        "computed",
        "static"
    ],
    aliases: [
        "Property",
        "Accessor"
    ],
    fields: Object.assign({}, $00ab94f1c167c340$var$classMethodOrPropertyCommon(), {
        key: {
            validate: (0, $geP65.chain)(function() {
                const normal = (0, $geP65.assertNodeType)("Identifier", "StringLiteral", "NumericLiteral", "BigIntLiteral", "PrivateName");
                const computed = (0, $geP65.assertNodeType)("Expression");
                return function(node, key, val) {
                    const validator = node.computed ? computed : normal;
                    validator(node, key, val);
                };
            }(), (0, $geP65.assertNodeType)("Identifier", "StringLiteral", "NumericLiteral", "BigIntLiteral", "Expression", "PrivateName"))
        },
        value: {
            validate: (0, $geP65.assertNodeType)("Expression"),
            optional: true
        },
        definite: {
            validate: (0, $geP65.assertValueType)("boolean"),
            optional: true
        },
        typeAnnotation: {
            validate: (0, $geP65.assertNodeType)("TypeAnnotation", "TSTypeAnnotation", "Noop"),
            optional: true
        },
        decorators: {
            validate: (0, $geP65.chain)((0, $geP65.assertValueType)("array"), (0, $geP65.assertEach)((0, $geP65.assertNodeType)("Decorator"))),
            optional: true
        },
        readonly: {
            validate: (0, $geP65.assertValueType)("boolean"),
            optional: true
        },
        declare: {
            validate: (0, $geP65.assertValueType)("boolean"),
            optional: true
        },
        variance: {
            validate: (0, $geP65.assertNodeType)("Variance"),
            optional: true
        }
    })
});
$00ab94f1c167c340$var$defineType("ClassPrivateProperty", {
    visitor: [
        "key",
        "value",
        "decorators",
        "typeAnnotation"
    ],
    builder: [
        "key",
        "value",
        "decorators",
        "static"
    ],
    aliases: [
        "Property",
        "Private"
    ],
    fields: {
        key: {
            validate: (0, $geP65.assertNodeType)("PrivateName")
        },
        value: {
            validate: (0, $geP65.assertNodeType)("Expression"),
            optional: true
        },
        typeAnnotation: {
            validate: (0, $geP65.assertNodeType)("TypeAnnotation", "TSTypeAnnotation", "Noop"),
            optional: true
        },
        decorators: {
            validate: (0, $geP65.chain)((0, $geP65.assertValueType)("array"), (0, $geP65.assertEach)((0, $geP65.assertNodeType)("Decorator"))),
            optional: true
        },
        static: {
            validate: (0, $geP65.assertValueType)("boolean"),
            default: false
        },
        readonly: {
            validate: (0, $geP65.assertValueType)("boolean"),
            optional: true
        },
        definite: {
            validate: (0, $geP65.assertValueType)("boolean"),
            optional: true
        },
        variance: {
            validate: (0, $geP65.assertNodeType)("Variance"),
            optional: true
        }
    }
});
$00ab94f1c167c340$var$defineType("ClassPrivateMethod", {
    builder: [
        "kind",
        "key",
        "params",
        "body",
        "static"
    ],
    visitor: [
        "key",
        "params",
        "body",
        "decorators",
        "returnType",
        "typeParameters"
    ],
    aliases: [
        "Function",
        "Scopable",
        "BlockParent",
        "FunctionParent",
        "Method",
        "Private"
    ],
    fields: Object.assign({}, $00ab94f1c167c340$var$classMethodOrDeclareMethodCommon(), $00ab94f1c167c340$var$functionTypeAnnotationCommon(), {
        kind: {
            validate: (0, $geP65.assertOneOf)("get", "set", "method"),
            default: "method"
        },
        key: {
            validate: (0, $geP65.assertNodeType)("PrivateName")
        },
        body: {
            validate: (0, $geP65.assertNodeType)("BlockStatement")
        }
    })
});
$00ab94f1c167c340$var$defineType("PrivateName", {
    visitor: [
        "id"
    ],
    aliases: [
        "Private"
    ],
    fields: {
        id: {
            validate: (0, $geP65.assertNodeType)("Identifier")
        }
    }
});
$00ab94f1c167c340$var$defineType("StaticBlock", {
    visitor: [
        "body"
    ],
    fields: {
        body: {
            validate: (0, $geP65.chain)((0, $geP65.assertValueType)("array"), (0, $geP65.assertEach)((0, $geP65.assertNodeType)("Statement")))
        }
    },
    aliases: [
        "Scopable",
        "BlockParent",
        "FunctionParent"
    ]
});

});
parcelRegister("4XzLl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $39c869d8872169ee$var$is;

var $d5ioO = parcelRequire("d5ioO");

var $7sJfn = parcelRequire("7sJfn");

var $2ccoB = parcelRequire("2ccoB");

var $7TNHg = parcelRequire("7TNHg");
function $39c869d8872169ee$var$is(type, node, opts) {
    if (!node) return false;
    const matches = (0, $7sJfn.default)(node.type, type);
    if (!matches) {
        if (!opts && node.type === "Placeholder" && type in $7TNHg.FLIPPED_ALIAS_KEYS) return (0, $2ccoB.default)(node.expectedNode, type);
        return false;
    }
    if (typeof opts === "undefined") return true;
    else return (0, $d5ioO.default)(node, opts);
}

});
parcelRegister("7sJfn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $56ee3f0833c3d317$var$isType;

var $7TNHg = parcelRequire("7TNHg");
function $56ee3f0833c3d317$var$isType(nodeType, targetType) {
    if (nodeType === targetType) return true;
    if (nodeType == null) return false;
    if ($7TNHg.ALIAS_KEYS[targetType]) return false;
    const aliases = $7TNHg.FLIPPED_ALIAS_KEYS[targetType];
    if (aliases) {
        if (aliases[0] === nodeType) return true;
        for (const alias of aliases){
            if (nodeType === alias) return true;
        }
    }
    return false;
}

});

parcelRegister("2ccoB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1996515406d52b6e$var$isPlaceholderType;

var $7TNHg = parcelRequire("7TNHg");
function $1996515406d52b6e$var$isPlaceholderType(placeholderType, targetType) {
    if (placeholderType === targetType) return true;
    const aliases = $7TNHg.PLACEHOLDERS_ALIAS[placeholderType];
    if (aliases) for (const alias of aliases){
        if (targetType === alias) return true;
    }
    return false;
}

});


parcelRegister("9tPzx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6e6ed3a9ea3d83d0$var$isValidIdentifier;

var $2Ghih = parcelRequire("2Ghih");
function $6e6ed3a9ea3d83d0$var$isValidIdentifier(name, reserved = true) {
    if (typeof name !== "string") return false;
    if (reserved) {
        if ((0, $2Ghih.isKeyword)(name) || (0, $2Ghih.isStrictReservedWord)(name, true)) return false;
    }
    return (0, $2Ghih.isIdentifierName)(name);
}

});
parcelRegister("2Ghih", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "isIdentifierChar", {
    enumerable: true,
    get: function() {
        return $hXHip.isIdentifierChar;
    }
});
Object.defineProperty(module.exports, "isIdentifierName", {
    enumerable: true,
    get: function() {
        return $hXHip.isIdentifierName;
    }
});
Object.defineProperty(module.exports, "isIdentifierStart", {
    enumerable: true,
    get: function() {
        return $hXHip.isIdentifierStart;
    }
});
Object.defineProperty(module.exports, "isKeyword", {
    enumerable: true,
    get: function() {
        return $21Gaf.isKeyword;
    }
});
Object.defineProperty(module.exports, "isReservedWord", {
    enumerable: true,
    get: function() {
        return $21Gaf.isReservedWord;
    }
});
Object.defineProperty(module.exports, "isStrictBindOnlyReservedWord", {
    enumerable: true,
    get: function() {
        return $21Gaf.isStrictBindOnlyReservedWord;
    }
});
Object.defineProperty(module.exports, "isStrictBindReservedWord", {
    enumerable: true,
    get: function() {
        return $21Gaf.isStrictBindReservedWord;
    }
});
Object.defineProperty(module.exports, "isStrictReservedWord", {
    enumerable: true,
    get: function() {
        return $21Gaf.isStrictReservedWord;
    }
});

var $hXHip = parcelRequire("hXHip");

var $21Gaf = parcelRequire("21Gaf");

});
parcelRegister("hXHip", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isIdentifierChar = $d1398804a068893e$var$isIdentifierChar;
module.exports.isIdentifierName = $d1398804a068893e$var$isIdentifierName;
module.exports.isIdentifierStart = $d1398804a068893e$var$isIdentifierStart;
let $d1398804a068893e$var$nonASCIIidentifierStartChars = "\xaa\xb5\xba\xc0-\xd6\xd8-\xf6\xf8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u0870-\u0887\u0889-\u088E\u08A0-\u08C9\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C5D\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D04-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E86-\u0E8A\u0E8C-\u0EA3\u0EA5\u0EA7-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u1711\u171F-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1878\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4C\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF3\u1CF5\u1CF6\u1CFA\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2118-\u211D\u2124\u2126\u2128\u212A-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309B-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u31A0-\u31BF\u31F0-\u31FF\u3400-\u4DBF\u4E00-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6EF\uA717-\uA71F\uA722-\uA788\uA78B-\uA7CA\uA7D0\uA7D1\uA7D3\uA7D5-\uA7D9\uA7F2-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB69\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC";
let $d1398804a068893e$var$nonASCIIidentifierChars = "\u200C\u200D\xb7\u0300-\u036F\u0387\u0483-\u0487\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u0669\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u06F0-\u06F9\u0711\u0730-\u074A\u07A6-\u07B0\u07C0-\u07C9\u07EB-\u07F3\u07FD\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u0898-\u089F\u08CA-\u08E1\u08E3-\u0903\u093A-\u093C\u093E-\u094F\u0951-\u0957\u0962\u0963\u0966-\u096F\u0981-\u0983\u09BC\u09BE-\u09C4\u09C7\u09C8\u09CB-\u09CD\u09D7\u09E2\u09E3\u09E6-\u09EF\u09FE\u0A01-\u0A03\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A66-\u0A71\u0A75\u0A81-\u0A83\u0ABC\u0ABE-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AE2\u0AE3\u0AE6-\u0AEF\u0AFA-\u0AFF\u0B01-\u0B03\u0B3C\u0B3E-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B55-\u0B57\u0B62\u0B63\u0B66-\u0B6F\u0B82\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD7\u0BE6-\u0BEF\u0C00-\u0C04\u0C3C\u0C3E-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C66-\u0C6F\u0C81-\u0C83\u0CBC\u0CBE-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CE2\u0CE3\u0CE6-\u0CEF\u0CF3\u0D00-\u0D03\u0D3B\u0D3C\u0D3E-\u0D44\u0D46-\u0D48\u0D4A-\u0D4D\u0D57\u0D62\u0D63\u0D66-\u0D6F\u0D81-\u0D83\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DE6-\u0DEF\u0DF2\u0DF3\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0E50-\u0E59\u0EB1\u0EB4-\u0EBC\u0EC8-\u0ECE\u0ED0-\u0ED9\u0F18\u0F19\u0F20-\u0F29\u0F35\u0F37\u0F39\u0F3E\u0F3F\u0F71-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102B-\u103E\u1040-\u1049\u1056-\u1059\u105E-\u1060\u1062-\u1064\u1067-\u106D\u1071-\u1074\u1082-\u108D\u108F-\u109D\u135D-\u135F\u1369-\u1371\u1712-\u1715\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4-\u17D3\u17DD\u17E0-\u17E9\u180B-\u180D\u180F-\u1819\u18A9\u1920-\u192B\u1930-\u193B\u1946-\u194F\u19D0-\u19DA\u1A17-\u1A1B\u1A55-\u1A5E\u1A60-\u1A7C\u1A7F-\u1A89\u1A90-\u1A99\u1AB0-\u1ABD\u1ABF-\u1ACE\u1B00-\u1B04\u1B34-\u1B44\u1B50-\u1B59\u1B6B-\u1B73\u1B80-\u1B82\u1BA1-\u1BAD\u1BB0-\u1BB9\u1BE6-\u1BF3\u1C24-\u1C37\u1C40-\u1C49\u1C50-\u1C59\u1CD0-\u1CD2\u1CD4-\u1CE8\u1CED\u1CF4\u1CF7-\u1CF9\u1DC0-\u1DFF\u200C\u200D\u203F\u2040\u2054\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302F\u3099\u309A\u30FB\uA620-\uA629\uA66F\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA823-\uA827\uA82C\uA880\uA881\uA8B4-\uA8C5\uA8D0-\uA8D9\uA8E0-\uA8F1\uA8FF-\uA909\uA926-\uA92D\uA947-\uA953\uA980-\uA983\uA9B3-\uA9C0\uA9D0-\uA9D9\uA9E5\uA9F0-\uA9F9\uAA29-\uAA36\uAA43\uAA4C\uAA4D\uAA50-\uAA59\uAA7B-\uAA7D\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEB-\uAAEF\uAAF5\uAAF6\uABE3-\uABEA\uABEC\uABED\uABF0-\uABF9\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F\uFE33\uFE34\uFE4D-\uFE4F\uFF10-\uFF19\uFF3F\uFF65";
const $d1398804a068893e$var$nonASCIIidentifierStart = new RegExp("[" + $d1398804a068893e$var$nonASCIIidentifierStartChars + "]");
const $d1398804a068893e$var$nonASCIIidentifier = new RegExp("[" + $d1398804a068893e$var$nonASCIIidentifierStartChars + $d1398804a068893e$var$nonASCIIidentifierChars + "]");
$d1398804a068893e$var$nonASCIIidentifierStartChars = $d1398804a068893e$var$nonASCIIidentifierChars = null;
const $d1398804a068893e$var$astralIdentifierStartCodes = [
    0,
    11,
    2,
    25,
    2,
    18,
    2,
    1,
    2,
    14,
    3,
    13,
    35,
    122,
    70,
    52,
    268,
    28,
    4,
    48,
    48,
    31,
    14,
    29,
    6,
    37,
    11,
    29,
    3,
    35,
    5,
    7,
    2,
    4,
    43,
    157,
    19,
    35,
    5,
    35,
    5,
    39,
    9,
    51,
    13,
    10,
    2,
    14,
    2,
    6,
    2,
    1,
    2,
    10,
    2,
    14,
    2,
    6,
    2,
    1,
    68,
    310,
    10,
    21,
    11,
    7,
    25,
    5,
    2,
    41,
    2,
    8,
    70,
    5,
    3,
    0,
    2,
    43,
    2,
    1,
    4,
    0,
    3,
    22,
    11,
    22,
    10,
    30,
    66,
    18,
    2,
    1,
    11,
    21,
    11,
    25,
    71,
    55,
    7,
    1,
    65,
    0,
    16,
    3,
    2,
    2,
    2,
    28,
    43,
    28,
    4,
    28,
    36,
    7,
    2,
    27,
    28,
    53,
    11,
    21,
    11,
    18,
    14,
    17,
    111,
    72,
    56,
    50,
    14,
    50,
    14,
    35,
    349,
    41,
    7,
    1,
    79,
    28,
    11,
    0,
    9,
    21,
    43,
    17,
    47,
    20,
    28,
    22,
    13,
    52,
    58,
    1,
    3,
    0,
    14,
    44,
    33,
    24,
    27,
    35,
    30,
    0,
    3,
    0,
    9,
    34,
    4,
    0,
    13,
    47,
    15,
    3,
    22,
    0,
    2,
    0,
    36,
    17,
    2,
    24,
    20,
    1,
    64,
    6,
    2,
    0,
    2,
    3,
    2,
    14,
    2,
    9,
    8,
    46,
    39,
    7,
    3,
    1,
    3,
    21,
    2,
    6,
    2,
    1,
    2,
    4,
    4,
    0,
    19,
    0,
    13,
    4,
    159,
    52,
    19,
    3,
    21,
    2,
    31,
    47,
    21,
    1,
    2,
    0,
    185,
    46,
    42,
    3,
    37,
    47,
    21,
    0,
    60,
    42,
    14,
    0,
    72,
    26,
    38,
    6,
    186,
    43,
    117,
    63,
    32,
    7,
    3,
    0,
    3,
    7,
    2,
    1,
    2,
    23,
    16,
    0,
    2,
    0,
    95,
    7,
    3,
    38,
    17,
    0,
    2,
    0,
    29,
    0,
    11,
    39,
    8,
    0,
    22,
    0,
    12,
    45,
    20,
    0,
    19,
    72,
    264,
    8,
    2,
    36,
    18,
    0,
    50,
    29,
    113,
    6,
    2,
    1,
    2,
    37,
    22,
    0,
    26,
    5,
    2,
    1,
    2,
    31,
    15,
    0,
    328,
    18,
    16,
    0,
    2,
    12,
    2,
    33,
    125,
    0,
    80,
    921,
    103,
    110,
    18,
    195,
    2637,
    96,
    16,
    1071,
    18,
    5,
    4026,
    582,
    8634,
    568,
    8,
    30,
    18,
    78,
    18,
    29,
    19,
    47,
    17,
    3,
    32,
    20,
    6,
    18,
    689,
    63,
    129,
    74,
    6,
    0,
    67,
    12,
    65,
    1,
    2,
    0,
    29,
    6135,
    9,
    1237,
    43,
    8,
    8936,
    3,
    2,
    6,
    2,
    1,
    2,
    290,
    16,
    0,
    30,
    2,
    3,
    0,
    15,
    3,
    9,
    395,
    2309,
    106,
    6,
    12,
    4,
    8,
    8,
    9,
    5991,
    84,
    2,
    70,
    2,
    1,
    3,
    0,
    3,
    1,
    3,
    3,
    2,
    11,
    2,
    0,
    2,
    6,
    2,
    64,
    2,
    3,
    3,
    7,
    2,
    6,
    2,
    27,
    2,
    3,
    2,
    4,
    2,
    0,
    4,
    6,
    2,
    339,
    3,
    24,
    2,
    24,
    2,
    30,
    2,
    24,
    2,
    30,
    2,
    24,
    2,
    30,
    2,
    24,
    2,
    30,
    2,
    24,
    2,
    7,
    1845,
    30,
    7,
    5,
    262,
    61,
    147,
    44,
    11,
    6,
    17,
    0,
    322,
    29,
    19,
    43,
    485,
    27,
    757,
    6,
    2,
    3,
    2,
    1,
    2,
    14,
    2,
    196,
    60,
    67,
    8,
    0,
    1205,
    3,
    2,
    26,
    2,
    1,
    2,
    0,
    3,
    0,
    2,
    9,
    2,
    3,
    2,
    0,
    2,
    0,
    7,
    0,
    5,
    0,
    2,
    0,
    2,
    0,
    2,
    2,
    2,
    1,
    2,
    0,
    3,
    0,
    2,
    0,
    2,
    0,
    2,
    0,
    2,
    0,
    2,
    1,
    2,
    0,
    3,
    3,
    2,
    6,
    2,
    3,
    2,
    3,
    2,
    0,
    2,
    9,
    2,
    16,
    6,
    2,
    2,
    4,
    2,
    16,
    4421,
    42719,
    33,
    4153,
    7,
    221,
    3,
    5761,
    15,
    7472,
    16,
    621,
    2467,
    541,
    1507,
    4938,
    6,
    4191
];
const $d1398804a068893e$var$astralIdentifierCodes = [
    509,
    0,
    227,
    0,
    150,
    4,
    294,
    9,
    1368,
    2,
    2,
    1,
    6,
    3,
    41,
    2,
    5,
    0,
    166,
    1,
    574,
    3,
    9,
    9,
    370,
    1,
    81,
    2,
    71,
    10,
    50,
    3,
    123,
    2,
    54,
    14,
    32,
    10,
    3,
    1,
    11,
    3,
    46,
    10,
    8,
    0,
    46,
    9,
    7,
    2,
    37,
    13,
    2,
    9,
    6,
    1,
    45,
    0,
    13,
    2,
    49,
    13,
    9,
    3,
    2,
    11,
    83,
    11,
    7,
    0,
    3,
    0,
    158,
    11,
    6,
    9,
    7,
    3,
    56,
    1,
    2,
    6,
    3,
    1,
    3,
    2,
    10,
    0,
    11,
    1,
    3,
    6,
    4,
    4,
    193,
    17,
    10,
    9,
    5,
    0,
    82,
    19,
    13,
    9,
    214,
    6,
    3,
    8,
    28,
    1,
    83,
    16,
    16,
    9,
    82,
    12,
    9,
    9,
    84,
    14,
    5,
    9,
    243,
    14,
    166,
    9,
    71,
    5,
    2,
    1,
    3,
    3,
    2,
    0,
    2,
    1,
    13,
    9,
    120,
    6,
    3,
    6,
    4,
    0,
    29,
    9,
    41,
    6,
    2,
    3,
    9,
    0,
    10,
    10,
    47,
    15,
    406,
    7,
    2,
    7,
    17,
    9,
    57,
    21,
    2,
    13,
    123,
    5,
    4,
    0,
    2,
    1,
    2,
    6,
    2,
    0,
    9,
    9,
    49,
    4,
    2,
    1,
    2,
    4,
    9,
    9,
    330,
    3,
    10,
    1,
    2,
    0,
    49,
    6,
    4,
    4,
    14,
    9,
    5351,
    0,
    7,
    14,
    13835,
    9,
    87,
    9,
    39,
    4,
    60,
    6,
    26,
    9,
    1014,
    0,
    2,
    54,
    8,
    3,
    82,
    0,
    12,
    1,
    19628,
    1,
    4706,
    45,
    3,
    22,
    543,
    4,
    4,
    5,
    9,
    7,
    3,
    6,
    31,
    3,
    149,
    2,
    1418,
    49,
    513,
    54,
    5,
    49,
    9,
    0,
    15,
    0,
    23,
    4,
    2,
    14,
    1361,
    6,
    2,
    16,
    3,
    6,
    2,
    1,
    2,
    4,
    101,
    0,
    161,
    6,
    10,
    9,
    357,
    0,
    62,
    13,
    499,
    13,
    983,
    6,
    110,
    6,
    6,
    9,
    4759,
    9,
    787719,
    239
];
function $d1398804a068893e$var$isInAstralSet(code, set) {
    let pos = 0x10000;
    for(let i = 0, length = set.length; i < length; i += 2){
        pos += set[i];
        if (pos > code) return false;
        pos += set[i + 1];
        if (pos >= code) return true;
    }
    return false;
}
function $d1398804a068893e$var$isIdentifierStart(code) {
    if (code < 65) return code === 36;
    if (code <= 90) return true;
    if (code < 97) return code === 95;
    if (code <= 122) return true;
    if (code <= 0xffff) return code >= 0xaa && $d1398804a068893e$var$nonASCIIidentifierStart.test(String.fromCharCode(code));
    return $d1398804a068893e$var$isInAstralSet(code, $d1398804a068893e$var$astralIdentifierStartCodes);
}
function $d1398804a068893e$var$isIdentifierChar(code) {
    if (code < 48) return code === 36;
    if (code < 58) return true;
    if (code < 65) return false;
    if (code <= 90) return true;
    if (code < 97) return code === 95;
    if (code <= 122) return true;
    if (code <= 0xffff) return code >= 0xaa && $d1398804a068893e$var$nonASCIIidentifier.test(String.fromCharCode(code));
    return $d1398804a068893e$var$isInAstralSet(code, $d1398804a068893e$var$astralIdentifierStartCodes) || $d1398804a068893e$var$isInAstralSet(code, $d1398804a068893e$var$astralIdentifierCodes);
}
function $d1398804a068893e$var$isIdentifierName(name) {
    let isFirst = true;
    for(let i = 0; i < name.length; i++){
        let cp = name.charCodeAt(i);
        if ((cp & 0xfc00) === 0xd800 && i + 1 < name.length) {
            const trail = name.charCodeAt(++i);
            if ((trail & 0xfc00) === 0xdc00) cp = 0x10000 + ((cp & 0x3ff) << 10) + (trail & 0x3ff);
        }
        if (isFirst) {
            isFirst = false;
            if (!$d1398804a068893e$var$isIdentifierStart(cp)) return false;
        } else if (!$d1398804a068893e$var$isIdentifierChar(cp)) return false;
    }
    return !isFirst;
}

});

parcelRegister("21Gaf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isKeyword = $179c61b5f24e4380$var$isKeyword;
module.exports.isReservedWord = $179c61b5f24e4380$var$isReservedWord;
module.exports.isStrictBindOnlyReservedWord = $179c61b5f24e4380$var$isStrictBindOnlyReservedWord;
module.exports.isStrictBindReservedWord = $179c61b5f24e4380$var$isStrictBindReservedWord;
module.exports.isStrictReservedWord = $179c61b5f24e4380$var$isStrictReservedWord;
const $179c61b5f24e4380$var$reservedWords = {
    keyword: [
        "break",
        "case",
        "catch",
        "continue",
        "debugger",
        "default",
        "do",
        "else",
        "finally",
        "for",
        "function",
        "if",
        "return",
        "switch",
        "throw",
        "try",
        "var",
        "const",
        "while",
        "with",
        "new",
        "this",
        "super",
        "class",
        "extends",
        "export",
        "import",
        "null",
        "true",
        "false",
        "in",
        "instanceof",
        "typeof",
        "void",
        "delete"
    ],
    strict: [
        "implements",
        "interface",
        "let",
        "package",
        "private",
        "protected",
        "public",
        "static",
        "yield"
    ],
    strictBind: [
        "eval",
        "arguments"
    ]
};
const $179c61b5f24e4380$var$keywords = new Set($179c61b5f24e4380$var$reservedWords.keyword);
const $179c61b5f24e4380$var$reservedWordsStrictSet = new Set($179c61b5f24e4380$var$reservedWords.strict);
const $179c61b5f24e4380$var$reservedWordsStrictBindSet = new Set($179c61b5f24e4380$var$reservedWords.strictBind);
function $179c61b5f24e4380$var$isReservedWord(word, inModule) {
    return inModule && word === "await" || word === "enum";
}
function $179c61b5f24e4380$var$isStrictReservedWord(word, inModule) {
    return $179c61b5f24e4380$var$isReservedWord(word, inModule) || $179c61b5f24e4380$var$reservedWordsStrictSet.has(word);
}
function $179c61b5f24e4380$var$isStrictBindOnlyReservedWord(word) {
    return $179c61b5f24e4380$var$reservedWordsStrictBindSet.has(word);
}
function $179c61b5f24e4380$var$isStrictBindReservedWord(word, inModule) {
    return $179c61b5f24e4380$var$isStrictReservedWord(word, inModule) || $179c61b5f24e4380$var$isStrictBindOnlyReservedWord(word);
}
function $179c61b5f24e4380$var$isKeyword(word) {
    return $179c61b5f24e4380$var$keywords.has(word);
}

});



parcelRegister("4Yp19", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.readCodePoint = $39f02bfa975de0ed$var$readCodePoint;
module.exports.readInt = $39f02bfa975de0ed$var$readInt;
module.exports.readStringContents = $39f02bfa975de0ed$var$readStringContents;
var $39f02bfa975de0ed$var$_isDigit = function isDigit(code) {
    return code >= 48 && code <= 57;
};
const $39f02bfa975de0ed$var$forbiddenNumericSeparatorSiblings = {
    decBinOct: new Set([
        46,
        66,
        69,
        79,
        95,
        98,
        101,
        111
    ]),
    hex: new Set([
        46,
        88,
        95,
        120
    ])
};
const $39f02bfa975de0ed$var$isAllowedNumericSeparatorSibling = {
    bin: (ch)=>ch === 48 || ch === 49,
    oct: (ch)=>ch >= 48 && ch <= 55,
    dec: (ch)=>ch >= 48 && ch <= 57,
    hex: (ch)=>ch >= 48 && ch <= 57 || ch >= 65 && ch <= 70 || ch >= 97 && ch <= 102
};
function $39f02bfa975de0ed$var$readStringContents(type, input, pos, lineStart, curLine, errors) {
    const initialPos = pos;
    const initialLineStart = lineStart;
    const initialCurLine = curLine;
    let out = "";
    let firstInvalidLoc = null;
    let chunkStart = pos;
    const { length: length } = input;
    for(;;){
        if (pos >= length) {
            errors.unterminated(initialPos, initialLineStart, initialCurLine);
            out += input.slice(chunkStart, pos);
            break;
        }
        const ch = input.charCodeAt(pos);
        if ($39f02bfa975de0ed$var$isStringEnd(type, ch, input, pos)) {
            out += input.slice(chunkStart, pos);
            break;
        }
        if (ch === 92) {
            out += input.slice(chunkStart, pos);
            const res = $39f02bfa975de0ed$var$readEscapedChar(input, pos, lineStart, curLine, type === "template", errors);
            if (res.ch === null && !firstInvalidLoc) firstInvalidLoc = {
                pos: pos,
                lineStart: lineStart,
                curLine: curLine
            };
            else out += res.ch;
            ({ pos: pos, lineStart: lineStart, curLine: curLine } = res);
            chunkStart = pos;
        } else if (ch === 8232 || ch === 8233) {
            ++pos;
            ++curLine;
            lineStart = pos;
        } else if (ch === 10 || ch === 13) {
            if (type === "template") {
                out += input.slice(chunkStart, pos) + "\n";
                ++pos;
                if (ch === 13 && input.charCodeAt(pos) === 10) ++pos;
                ++curLine;
                chunkStart = lineStart = pos;
            } else errors.unterminated(initialPos, initialLineStart, initialCurLine);
        } else ++pos;
    }
    return {
        pos: pos,
        str: out,
        firstInvalidLoc: firstInvalidLoc,
        lineStart: lineStart,
        curLine: curLine,
        containsInvalid: !!firstInvalidLoc
    };
}
function $39f02bfa975de0ed$var$isStringEnd(type, ch, input, pos) {
    if (type === "template") return ch === 96 || ch === 36 && input.charCodeAt(pos + 1) === 123;
    return ch === (type === "double" ? 34 : 39);
}
function $39f02bfa975de0ed$var$readEscapedChar(input, pos, lineStart, curLine, inTemplate, errors) {
    const throwOnInvalid = !inTemplate;
    pos++;
    const res = (ch)=>({
            pos: pos,
            ch: ch,
            lineStart: lineStart,
            curLine: curLine
        });
    const ch = input.charCodeAt(pos++);
    switch(ch){
        case 110:
            return res("\n");
        case 114:
            return res("\r");
        case 120:
            {
                let code;
                ({ code: code, pos: pos } = $39f02bfa975de0ed$var$readHexChar(input, pos, lineStart, curLine, 2, false, throwOnInvalid, errors));
                return res(code === null ? null : String.fromCharCode(code));
            }
        case 117:
            {
                let code;
                ({ code: code, pos: pos } = $39f02bfa975de0ed$var$readCodePoint(input, pos, lineStart, curLine, throwOnInvalid, errors));
                return res(code === null ? null : String.fromCodePoint(code));
            }
        case 116:
            return res("	");
        case 98:
            return res("\b");
        case 118:
            return res("\v");
        case 102:
            return res("\f");
        case 13:
            if (input.charCodeAt(pos) === 10) ++pos;
        case 10:
            lineStart = pos;
            ++curLine;
        case 8232:
        case 8233:
            return res("");
        case 56:
        case 57:
            if (inTemplate) return res(null);
            else errors.strictNumericEscape(pos - 1, lineStart, curLine);
        default:
            if (ch >= 48 && ch <= 55) {
                const startPos = pos - 1;
                const match = input.slice(startPos, pos + 2).match(/^[0-7]+/);
                let octalStr = match[0];
                let octal = parseInt(octalStr, 8);
                if (octal > 255) {
                    octalStr = octalStr.slice(0, -1);
                    octal = parseInt(octalStr, 8);
                }
                pos += octalStr.length - 1;
                const next = input.charCodeAt(pos);
                if (octalStr !== "0" || next === 56 || next === 57) {
                    if (inTemplate) return res(null);
                    else errors.strictNumericEscape(startPos, lineStart, curLine);
                }
                return res(String.fromCharCode(octal));
            }
            return res(String.fromCharCode(ch));
    }
}
function $39f02bfa975de0ed$var$readHexChar(input, pos, lineStart, curLine, len, forceLen, throwOnInvalid, errors) {
    const initialPos = pos;
    let n;
    ({ n: n, pos: pos } = $39f02bfa975de0ed$var$readInt(input, pos, lineStart, curLine, 16, len, forceLen, false, errors, !throwOnInvalid));
    if (n === null) {
        if (throwOnInvalid) errors.invalidEscapeSequence(initialPos, lineStart, curLine);
        else pos = initialPos - 1;
    }
    return {
        code: n,
        pos: pos
    };
}
function $39f02bfa975de0ed$var$readInt(input, pos, lineStart, curLine, radix, len, forceLen, allowNumSeparator, errors, bailOnError) {
    const start = pos;
    const forbiddenSiblings = radix === 16 ? $39f02bfa975de0ed$var$forbiddenNumericSeparatorSiblings.hex : $39f02bfa975de0ed$var$forbiddenNumericSeparatorSiblings.decBinOct;
    const isAllowedSibling = radix === 16 ? $39f02bfa975de0ed$var$isAllowedNumericSeparatorSibling.hex : radix === 10 ? $39f02bfa975de0ed$var$isAllowedNumericSeparatorSibling.dec : radix === 8 ? $39f02bfa975de0ed$var$isAllowedNumericSeparatorSibling.oct : $39f02bfa975de0ed$var$isAllowedNumericSeparatorSibling.bin;
    let invalid = false;
    let total = 0;
    for(let i = 0, e = len == null ? Infinity : len; i < e; ++i){
        const code = input.charCodeAt(pos);
        let val;
        if (code === 95 && allowNumSeparator !== "bail") {
            const prev = input.charCodeAt(pos - 1);
            const next = input.charCodeAt(pos + 1);
            if (!allowNumSeparator) {
                if (bailOnError) return {
                    n: null,
                    pos: pos
                };
                errors.numericSeparatorInEscapeSequence(pos, lineStart, curLine);
            } else if (Number.isNaN(next) || !isAllowedSibling(next) || forbiddenSiblings.has(prev) || forbiddenSiblings.has(next)) {
                if (bailOnError) return {
                    n: null,
                    pos: pos
                };
                errors.unexpectedNumericSeparator(pos, lineStart, curLine);
            }
            ++pos;
            continue;
        }
        if (code >= 97) val = code - 97 + 10;
        else if (code >= 65) val = code - 65 + 10;
        else if ($39f02bfa975de0ed$var$_isDigit(code)) val = code - 48;
        else val = Infinity;
        if (val >= radix) {
            if (val <= 9 && bailOnError) return {
                n: null,
                pos: pos
            };
            else if (val <= 9 && errors.invalidDigit(pos, lineStart, curLine, radix)) val = 0;
            else if (forceLen) {
                val = 0;
                invalid = true;
            } else break;
        }
        ++pos;
        total = total * radix + val;
    }
    if (pos === start || len != null && pos - start !== len || invalid) return {
        n: null,
        pos: pos
    };
    return {
        n: total,
        pos: pos
    };
}
function $39f02bfa975de0ed$var$readCodePoint(input, pos, lineStart, curLine, throwOnInvalid, errors) {
    const ch = input.charCodeAt(pos);
    let code;
    if (ch === 123) {
        ++pos;
        ({ code: code, pos: pos } = $39f02bfa975de0ed$var$readHexChar(input, pos, lineStart, curLine, input.indexOf("}", pos) - pos, true, throwOnInvalid, errors));
        ++pos;
        if (code !== null && code > 0x10ffff) {
            if (throwOnInvalid) errors.invalidCodePoint(pos, lineStart, curLine);
            else return {
                code: null,
                pos: pos
            };
        }
    } else ({ code: code, pos: pos } = $39f02bfa975de0ed$var$readHexChar(input, pos, lineStart, curLine, 4, false, throwOnInvalid, errors));
    return {
        code: code,
        pos: pos
    };
}

});

parcelRegister("l7lSB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UPDATE_OPERATORS = module.exports.UNARY_OPERATORS = module.exports.STRING_UNARY_OPERATORS = module.exports.STATEMENT_OR_BLOCK_KEYS = module.exports.NUMBER_UNARY_OPERATORS = module.exports.NUMBER_BINARY_OPERATORS = module.exports.NOT_LOCAL_BINDING = module.exports.LOGICAL_OPERATORS = module.exports.INHERIT_KEYS = module.exports.FOR_INIT_KEYS = module.exports.FLATTENABLE_KEYS = module.exports.EQUALITY_BINARY_OPERATORS = module.exports.COMPARISON_BINARY_OPERATORS = module.exports.COMMENT_KEYS = module.exports.BOOLEAN_UNARY_OPERATORS = module.exports.BOOLEAN_NUMBER_BINARY_OPERATORS = module.exports.BOOLEAN_BINARY_OPERATORS = module.exports.BLOCK_SCOPED_SYMBOL = module.exports.BINARY_OPERATORS = module.exports.ASSIGNMENT_OPERATORS = void 0;
const $f5fb3947afd367b8$var$STATEMENT_OR_BLOCK_KEYS = module.exports.STATEMENT_OR_BLOCK_KEYS = [
    "consequent",
    "body",
    "alternate"
];
const $f5fb3947afd367b8$var$FLATTENABLE_KEYS = module.exports.FLATTENABLE_KEYS = [
    "body",
    "expressions"
];
const $f5fb3947afd367b8$var$FOR_INIT_KEYS = module.exports.FOR_INIT_KEYS = [
    "left",
    "init"
];
const $f5fb3947afd367b8$var$COMMENT_KEYS = module.exports.COMMENT_KEYS = [
    "leadingComments",
    "trailingComments",
    "innerComments"
];
const $f5fb3947afd367b8$var$LOGICAL_OPERATORS = module.exports.LOGICAL_OPERATORS = [
    "||",
    "&&",
    "??"
];
const $f5fb3947afd367b8$var$UPDATE_OPERATORS = module.exports.UPDATE_OPERATORS = [
    "++",
    "--"
];
const $f5fb3947afd367b8$var$BOOLEAN_NUMBER_BINARY_OPERATORS = module.exports.BOOLEAN_NUMBER_BINARY_OPERATORS = [
    ">",
    "<",
    ">=",
    "<="
];
const $f5fb3947afd367b8$var$EQUALITY_BINARY_OPERATORS = module.exports.EQUALITY_BINARY_OPERATORS = [
    "==",
    "===",
    "!=",
    "!=="
];
const $f5fb3947afd367b8$var$COMPARISON_BINARY_OPERATORS = module.exports.COMPARISON_BINARY_OPERATORS = [
    ...$f5fb3947afd367b8$var$EQUALITY_BINARY_OPERATORS,
    "in",
    "instanceof"
];
const $f5fb3947afd367b8$var$BOOLEAN_BINARY_OPERATORS = module.exports.BOOLEAN_BINARY_OPERATORS = [
    ...$f5fb3947afd367b8$var$COMPARISON_BINARY_OPERATORS,
    ...$f5fb3947afd367b8$var$BOOLEAN_NUMBER_BINARY_OPERATORS
];
const $f5fb3947afd367b8$var$NUMBER_BINARY_OPERATORS = module.exports.NUMBER_BINARY_OPERATORS = [
    "-",
    "/",
    "%",
    "*",
    "**",
    "&",
    "|",
    ">>",
    ">>>",
    "<<",
    "^"
];
const $f5fb3947afd367b8$var$BINARY_OPERATORS = module.exports.BINARY_OPERATORS = [
    "+",
    ...$f5fb3947afd367b8$var$NUMBER_BINARY_OPERATORS,
    ...$f5fb3947afd367b8$var$BOOLEAN_BINARY_OPERATORS,
    "|>"
];
const $f5fb3947afd367b8$var$ASSIGNMENT_OPERATORS = module.exports.ASSIGNMENT_OPERATORS = [
    "=",
    "+=",
    ...$f5fb3947afd367b8$var$NUMBER_BINARY_OPERATORS.map((op)=>op + "="),
    ...$f5fb3947afd367b8$var$LOGICAL_OPERATORS.map((op)=>op + "=")
];
const $f5fb3947afd367b8$var$BOOLEAN_UNARY_OPERATORS = module.exports.BOOLEAN_UNARY_OPERATORS = [
    "delete",
    "!"
];
const $f5fb3947afd367b8$var$NUMBER_UNARY_OPERATORS = module.exports.NUMBER_UNARY_OPERATORS = [
    "+",
    "-",
    "~"
];
const $f5fb3947afd367b8$var$STRING_UNARY_OPERATORS = module.exports.STRING_UNARY_OPERATORS = [
    "typeof"
];
const $f5fb3947afd367b8$var$UNARY_OPERATORS = module.exports.UNARY_OPERATORS = [
    "void",
    "throw",
    ...$f5fb3947afd367b8$var$BOOLEAN_UNARY_OPERATORS,
    ...$f5fb3947afd367b8$var$NUMBER_UNARY_OPERATORS,
    ...$f5fb3947afd367b8$var$STRING_UNARY_OPERATORS
];
const $f5fb3947afd367b8$var$INHERIT_KEYS = module.exports.INHERIT_KEYS = {
    optional: [
        "typeAnnotation",
        "typeParameters",
        "returnType"
    ],
    force: [
        "start",
        "loc",
        "end"
    ]
};
const $f5fb3947afd367b8$var$BLOCK_SCOPED_SYMBOL = module.exports.BLOCK_SCOPED_SYMBOL = Symbol.for("var used to be block scoped");
const $f5fb3947afd367b8$var$NOT_LOCAL_BINDING = module.exports.NOT_LOCAL_BINDING = Symbol.for("should not be considered a local binding");

});

parcelRegister("geP65", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.VISITOR_KEYS = module.exports.NODE_PARENT_VALIDATIONS = module.exports.NODE_FIELDS = module.exports.FLIPPED_ALIAS_KEYS = module.exports.DEPRECATED_KEYS = module.exports.BUILDER_KEYS = module.exports.ALIAS_KEYS = void 0;
module.exports.arrayOf = $bd2596f9b7417687$var$arrayOf;
module.exports.arrayOfType = $bd2596f9b7417687$var$arrayOfType;
module.exports.assertEach = $bd2596f9b7417687$var$assertEach;
module.exports.assertNodeOrValueType = $bd2596f9b7417687$var$assertNodeOrValueType;
module.exports.assertNodeType = $bd2596f9b7417687$var$assertNodeType;
module.exports.assertOneOf = $bd2596f9b7417687$var$assertOneOf;
module.exports.assertOptionalChainStart = $bd2596f9b7417687$var$assertOptionalChainStart;
module.exports.assertShape = $bd2596f9b7417687$var$assertShape;
module.exports.assertValueType = $bd2596f9b7417687$var$assertValueType;
module.exports.chain = $bd2596f9b7417687$var$chain;
module.exports.default = $bd2596f9b7417687$var$defineType;
module.exports.defineAliasedType = $bd2596f9b7417687$var$defineAliasedType;
module.exports.typeIs = $bd2596f9b7417687$var$typeIs;
module.exports.validate = $bd2596f9b7417687$var$validate;
module.exports.validateArrayOfType = $bd2596f9b7417687$var$validateArrayOfType;
module.exports.validateOptional = $bd2596f9b7417687$var$validateOptional;
module.exports.validateOptionalType = $bd2596f9b7417687$var$validateOptionalType;
module.exports.validateType = $bd2596f9b7417687$var$validateType;

var $4XzLl = parcelRequire("4XzLl");

var $30dxP = parcelRequire("30dxP");
const $bd2596f9b7417687$var$VISITOR_KEYS = module.exports.VISITOR_KEYS = {};
const $bd2596f9b7417687$var$ALIAS_KEYS = module.exports.ALIAS_KEYS = {};
const $bd2596f9b7417687$var$FLIPPED_ALIAS_KEYS = module.exports.FLIPPED_ALIAS_KEYS = {};
const $bd2596f9b7417687$var$NODE_FIELDS = module.exports.NODE_FIELDS = {};
const $bd2596f9b7417687$var$BUILDER_KEYS = module.exports.BUILDER_KEYS = {};
const $bd2596f9b7417687$var$DEPRECATED_KEYS = module.exports.DEPRECATED_KEYS = {};
const $bd2596f9b7417687$var$NODE_PARENT_VALIDATIONS = module.exports.NODE_PARENT_VALIDATIONS = {};
function $bd2596f9b7417687$var$getType(val) {
    if (Array.isArray(val)) return "array";
    else if (val === null) return "null";
    else return typeof val;
}
function $bd2596f9b7417687$var$validate(validate) {
    return {
        validate: validate
    };
}
function $bd2596f9b7417687$var$typeIs(typeName) {
    return typeof typeName === "string" ? $bd2596f9b7417687$var$assertNodeType(typeName) : $bd2596f9b7417687$var$assertNodeType(...typeName);
}
function $bd2596f9b7417687$var$validateType(typeName) {
    return $bd2596f9b7417687$var$validate($bd2596f9b7417687$var$typeIs(typeName));
}
function $bd2596f9b7417687$var$validateOptional(validate) {
    return {
        validate: validate,
        optional: true
    };
}
function $bd2596f9b7417687$var$validateOptionalType(typeName) {
    return {
        validate: $bd2596f9b7417687$var$typeIs(typeName),
        optional: true
    };
}
function $bd2596f9b7417687$var$arrayOf(elementType) {
    return $bd2596f9b7417687$var$chain($bd2596f9b7417687$var$assertValueType("array"), $bd2596f9b7417687$var$assertEach(elementType));
}
function $bd2596f9b7417687$var$arrayOfType(typeName) {
    return $bd2596f9b7417687$var$arrayOf($bd2596f9b7417687$var$typeIs(typeName));
}
function $bd2596f9b7417687$var$validateArrayOfType(typeName) {
    return $bd2596f9b7417687$var$validate($bd2596f9b7417687$var$arrayOfType(typeName));
}
function $bd2596f9b7417687$var$assertEach(callback) {
    function validator(node, key, val) {
        if (!Array.isArray(val)) return;
        for(let i = 0; i < val.length; i++){
            const subkey = `${key}[${i}]`;
            const v = val[i];
            callback(node, subkey, v);
        }
    }
    validator.each = callback;
    return validator;
}
function $bd2596f9b7417687$var$assertOneOf(...values) {
    function validate(node, key, val) {
        if (values.indexOf(val) < 0) throw new TypeError(`Property ${key} expected value to be one of ${JSON.stringify(values)} but got ${JSON.stringify(val)}`);
    }
    validate.oneOf = values;
    return validate;
}
function $bd2596f9b7417687$var$assertNodeType(...types) {
    function validate(node, key, val) {
        for (const type of types)if ((0, $4XzLl.default)(type, val)) {
            (0, $30dxP.validateChild)(node, key, val);
            return;
        }
        throw new TypeError(`Property ${key} of ${node.type} expected node to be of a type ${JSON.stringify(types)} but instead got ${JSON.stringify(val == null ? void 0 : val.type)}`);
    }
    validate.oneOfNodeTypes = types;
    return validate;
}
function $bd2596f9b7417687$var$assertNodeOrValueType(...types) {
    function validate(node, key, val) {
        for (const type of types)if ($bd2596f9b7417687$var$getType(val) === type || (0, $4XzLl.default)(type, val)) {
            (0, $30dxP.validateChild)(node, key, val);
            return;
        }
        throw new TypeError(`Property ${key} of ${node.type} expected node to be of a type ${JSON.stringify(types)} but instead got ${JSON.stringify(val == null ? void 0 : val.type)}`);
    }
    validate.oneOfNodeOrValueTypes = types;
    return validate;
}
function $bd2596f9b7417687$var$assertValueType(type) {
    function validate(node, key, val) {
        const valid = $bd2596f9b7417687$var$getType(val) === type;
        if (!valid) throw new TypeError(`Property ${key} expected type of ${type} but got ${$bd2596f9b7417687$var$getType(val)}`);
    }
    validate.type = type;
    return validate;
}
function $bd2596f9b7417687$var$assertShape(shape) {
    function validate(node, key, val) {
        const errors = [];
        for (const property of Object.keys(shape))try {
            (0, $30dxP.validateField)(node, property, val[property], shape[property]);
        } catch (error) {
            if (error instanceof TypeError) {
                errors.push(error.message);
                continue;
            }
            throw error;
        }
        if (errors.length) throw new TypeError(`Property ${key} of ${node.type} expected to have the following:\n${errors.join("\n")}`);
    }
    validate.shapeOf = shape;
    return validate;
}
function $bd2596f9b7417687$var$assertOptionalChainStart() {
    function validate(node) {
        var _current;
        let current = node;
        while(node){
            const { type: type } = current;
            if (type === "OptionalCallExpression") {
                if (current.optional) return;
                current = current.callee;
                continue;
            }
            if (type === "OptionalMemberExpression") {
                if (current.optional) return;
                current = current.object;
                continue;
            }
            break;
        }
        throw new TypeError(`Non-optional ${node.type} must chain from an optional OptionalMemberExpression or OptionalCallExpression. Found chain from ${(_current = current) == null ? void 0 : _current.type}`);
    }
    return validate;
}
function $bd2596f9b7417687$var$chain(...fns) {
    function validate(...args) {
        for (const fn of fns)fn(...args);
    }
    validate.chainOf = fns;
    if (fns.length >= 2 && "type" in fns[0] && fns[0].type === "array" && !("each" in fns[1])) throw new Error(`An assertValueType("array") validator can only be followed by an assertEach(...) validator.`);
    return validate;
}
const $bd2596f9b7417687$var$validTypeOpts = [
    "aliases",
    "builder",
    "deprecatedAlias",
    "fields",
    "inherits",
    "visitor",
    "validate"
];
const $bd2596f9b7417687$var$validFieldKeys = [
    "default",
    "optional",
    "deprecated",
    "validate"
];
const $bd2596f9b7417687$var$store = {};
function $bd2596f9b7417687$var$defineAliasedType(...aliases) {
    return (type, opts = {})=>{
        let defined = opts.aliases;
        if (!defined) {
            var _store$opts$inherits$, _defined;
            if (opts.inherits) defined = (_store$opts$inherits$ = $bd2596f9b7417687$var$store[opts.inherits].aliases) == null ? void 0 : _store$opts$inherits$.slice();
            (_defined = defined) != null ? _defined : defined = [];
            opts.aliases = defined;
        }
        const additional = aliases.filter((a)=>!defined.includes(a));
        defined.unshift(...additional);
        $bd2596f9b7417687$var$defineType(type, opts);
    };
}
function $bd2596f9b7417687$var$defineType(type, opts = {}) {
    const inherits = opts.inherits && $bd2596f9b7417687$var$store[opts.inherits] || {};
    let fields = opts.fields;
    if (!fields) {
        fields = {};
        if (inherits.fields) {
            const keys = Object.getOwnPropertyNames(inherits.fields);
            for (const key of keys){
                const field = inherits.fields[key];
                const def = field.default;
                if (Array.isArray(def) ? def.length > 0 : def && typeof def === "object") throw new Error("field defaults can only be primitives or empty arrays currently");
                fields[key] = {
                    default: Array.isArray(def) ? [] : def,
                    optional: field.optional,
                    deprecated: field.deprecated,
                    validate: field.validate
                };
            }
        }
    }
    const visitor = opts.visitor || inherits.visitor || [];
    const aliases = opts.aliases || inherits.aliases || [];
    const builder = opts.builder || inherits.builder || opts.visitor || [];
    for (const k of Object.keys(opts)){
        if ($bd2596f9b7417687$var$validTypeOpts.indexOf(k) === -1) throw new Error(`Unknown type option "${k}" on ${type}`);
    }
    if (opts.deprecatedAlias) $bd2596f9b7417687$var$DEPRECATED_KEYS[opts.deprecatedAlias] = type;
    for (const key of visitor.concat(builder))fields[key] = fields[key] || {};
    for (const key of Object.keys(fields)){
        const field = fields[key];
        if (field.default !== undefined && builder.indexOf(key) === -1) field.optional = true;
        if (field.default === undefined) field.default = null;
        else if (!field.validate && field.default != null) field.validate = $bd2596f9b7417687$var$assertValueType($bd2596f9b7417687$var$getType(field.default));
        for (const k of Object.keys(field)){
            if ($bd2596f9b7417687$var$validFieldKeys.indexOf(k) === -1) throw new Error(`Unknown field key "${k}" on ${type}.${key}`);
        }
    }
    $bd2596f9b7417687$var$VISITOR_KEYS[type] = opts.visitor = visitor;
    $bd2596f9b7417687$var$BUILDER_KEYS[type] = opts.builder = builder;
    $bd2596f9b7417687$var$NODE_FIELDS[type] = opts.fields = fields;
    $bd2596f9b7417687$var$ALIAS_KEYS[type] = opts.aliases = aliases;
    aliases.forEach((alias)=>{
        $bd2596f9b7417687$var$FLIPPED_ALIAS_KEYS[alias] = $bd2596f9b7417687$var$FLIPPED_ALIAS_KEYS[alias] || [];
        $bd2596f9b7417687$var$FLIPPED_ALIAS_KEYS[alias].push(type);
    });
    if (opts.validate) $bd2596f9b7417687$var$NODE_PARENT_VALIDATIONS[type] = opts.validate;
    $bd2596f9b7417687$var$store[type] = opts;
}

});


parcelRegister("auUlq", function(module, exports) {
"use strict";

var $geP65 = parcelRequire("geP65");
const $7a48699368d2991e$var$defineType = (0, $geP65.defineAliasedType)("Flow");
const $7a48699368d2991e$var$defineInterfaceishType = (name)=>{
    const isDeclareClass = name === "DeclareClass";
    $7a48699368d2991e$var$defineType(name, {
        builder: [
            "id",
            "typeParameters",
            "extends",
            "body"
        ],
        visitor: [
            "id",
            "typeParameters",
            "extends",
            ...isDeclareClass ? [
                "mixins",
                "implements"
            ] : [],
            "body"
        ],
        aliases: [
            "FlowDeclaration",
            "Statement",
            "Declaration"
        ],
        fields: Object.assign({
            id: (0, $geP65.validateType)("Identifier"),
            typeParameters: (0, $geP65.validateOptionalType)("TypeParameterDeclaration"),
            extends: (0, $geP65.validateOptional)((0, $geP65.arrayOfType)("InterfaceExtends"))
        }, isDeclareClass ? {
            mixins: (0, $geP65.validateOptional)((0, $geP65.arrayOfType)("InterfaceExtends")),
            implements: (0, $geP65.validateOptional)((0, $geP65.arrayOfType)("ClassImplements"))
        } : {}, {
            body: (0, $geP65.validateType)("ObjectTypeAnnotation")
        })
    });
};
$7a48699368d2991e$var$defineType("AnyTypeAnnotation", {
    aliases: [
        "FlowType",
        "FlowBaseAnnotation"
    ]
});
$7a48699368d2991e$var$defineType("ArrayTypeAnnotation", {
    visitor: [
        "elementType"
    ],
    aliases: [
        "FlowType"
    ],
    fields: {
        elementType: (0, $geP65.validateType)("FlowType")
    }
});
$7a48699368d2991e$var$defineType("BooleanTypeAnnotation", {
    aliases: [
        "FlowType",
        "FlowBaseAnnotation"
    ]
});
$7a48699368d2991e$var$defineType("BooleanLiteralTypeAnnotation", {
    builder: [
        "value"
    ],
    aliases: [
        "FlowType"
    ],
    fields: {
        value: (0, $geP65.validate)((0, $geP65.assertValueType)("boolean"))
    }
});
$7a48699368d2991e$var$defineType("NullLiteralTypeAnnotation", {
    aliases: [
        "FlowType",
        "FlowBaseAnnotation"
    ]
});
$7a48699368d2991e$var$defineType("ClassImplements", {
    visitor: [
        "id",
        "typeParameters"
    ],
    fields: {
        id: (0, $geP65.validateType)("Identifier"),
        typeParameters: (0, $geP65.validateOptionalType)("TypeParameterInstantiation")
    }
});
$7a48699368d2991e$var$defineInterfaceishType("DeclareClass");
$7a48699368d2991e$var$defineType("DeclareFunction", {
    visitor: [
        "id"
    ],
    aliases: [
        "FlowDeclaration",
        "Statement",
        "Declaration"
    ],
    fields: {
        id: (0, $geP65.validateType)("Identifier"),
        predicate: (0, $geP65.validateOptionalType)("DeclaredPredicate")
    }
});
$7a48699368d2991e$var$defineInterfaceishType("DeclareInterface");
$7a48699368d2991e$var$defineType("DeclareModule", {
    builder: [
        "id",
        "body",
        "kind"
    ],
    visitor: [
        "id",
        "body"
    ],
    aliases: [
        "FlowDeclaration",
        "Statement",
        "Declaration"
    ],
    fields: {
        id: (0, $geP65.validateType)([
            "Identifier",
            "StringLiteral"
        ]),
        body: (0, $geP65.validateType)("BlockStatement"),
        kind: (0, $geP65.validateOptional)((0, $geP65.assertOneOf)("CommonJS", "ES"))
    }
});
$7a48699368d2991e$var$defineType("DeclareModuleExports", {
    visitor: [
        "typeAnnotation"
    ],
    aliases: [
        "FlowDeclaration",
        "Statement",
        "Declaration"
    ],
    fields: {
        typeAnnotation: (0, $geP65.validateType)("TypeAnnotation")
    }
});
$7a48699368d2991e$var$defineType("DeclareTypeAlias", {
    visitor: [
        "id",
        "typeParameters",
        "right"
    ],
    aliases: [
        "FlowDeclaration",
        "Statement",
        "Declaration"
    ],
    fields: {
        id: (0, $geP65.validateType)("Identifier"),
        typeParameters: (0, $geP65.validateOptionalType)("TypeParameterDeclaration"),
        right: (0, $geP65.validateType)("FlowType")
    }
});
$7a48699368d2991e$var$defineType("DeclareOpaqueType", {
    visitor: [
        "id",
        "typeParameters",
        "supertype"
    ],
    aliases: [
        "FlowDeclaration",
        "Statement",
        "Declaration"
    ],
    fields: {
        id: (0, $geP65.validateType)("Identifier"),
        typeParameters: (0, $geP65.validateOptionalType)("TypeParameterDeclaration"),
        supertype: (0, $geP65.validateOptionalType)("FlowType"),
        impltype: (0, $geP65.validateOptionalType)("FlowType")
    }
});
$7a48699368d2991e$var$defineType("DeclareVariable", {
    visitor: [
        "id"
    ],
    aliases: [
        "FlowDeclaration",
        "Statement",
        "Declaration"
    ],
    fields: {
        id: (0, $geP65.validateType)("Identifier")
    }
});
$7a48699368d2991e$var$defineType("DeclareExportDeclaration", {
    visitor: [
        "declaration",
        "specifiers",
        "source"
    ],
    aliases: [
        "FlowDeclaration",
        "Statement",
        "Declaration"
    ],
    fields: {
        declaration: (0, $geP65.validateOptionalType)("Flow"),
        specifiers: (0, $geP65.validateOptional)((0, $geP65.arrayOfType)([
            "ExportSpecifier",
            "ExportNamespaceSpecifier"
        ])),
        source: (0, $geP65.validateOptionalType)("StringLiteral"),
        default: (0, $geP65.validateOptional)((0, $geP65.assertValueType)("boolean"))
    }
});
$7a48699368d2991e$var$defineType("DeclareExportAllDeclaration", {
    visitor: [
        "source"
    ],
    aliases: [
        "FlowDeclaration",
        "Statement",
        "Declaration"
    ],
    fields: {
        source: (0, $geP65.validateType)("StringLiteral"),
        exportKind: (0, $geP65.validateOptional)((0, $geP65.assertOneOf)("type", "value"))
    }
});
$7a48699368d2991e$var$defineType("DeclaredPredicate", {
    visitor: [
        "value"
    ],
    aliases: [
        "FlowPredicate"
    ],
    fields: {
        value: (0, $geP65.validateType)("Flow")
    }
});
$7a48699368d2991e$var$defineType("ExistsTypeAnnotation", {
    aliases: [
        "FlowType"
    ]
});
$7a48699368d2991e$var$defineType("FunctionTypeAnnotation", {
    visitor: [
        "typeParameters",
        "params",
        "rest",
        "returnType"
    ],
    aliases: [
        "FlowType"
    ],
    fields: {
        typeParameters: (0, $geP65.validateOptionalType)("TypeParameterDeclaration"),
        params: (0, $geP65.validate)((0, $geP65.arrayOfType)("FunctionTypeParam")),
        rest: (0, $geP65.validateOptionalType)("FunctionTypeParam"),
        this: (0, $geP65.validateOptionalType)("FunctionTypeParam"),
        returnType: (0, $geP65.validateType)("FlowType")
    }
});
$7a48699368d2991e$var$defineType("FunctionTypeParam", {
    visitor: [
        "name",
        "typeAnnotation"
    ],
    fields: {
        name: (0, $geP65.validateOptionalType)("Identifier"),
        typeAnnotation: (0, $geP65.validateType)("FlowType"),
        optional: (0, $geP65.validateOptional)((0, $geP65.assertValueType)("boolean"))
    }
});
$7a48699368d2991e$var$defineType("GenericTypeAnnotation", {
    visitor: [
        "id",
        "typeParameters"
    ],
    aliases: [
        "FlowType"
    ],
    fields: {
        id: (0, $geP65.validateType)([
            "Identifier",
            "QualifiedTypeIdentifier"
        ]),
        typeParameters: (0, $geP65.validateOptionalType)("TypeParameterInstantiation")
    }
});
$7a48699368d2991e$var$defineType("InferredPredicate", {
    aliases: [
        "FlowPredicate"
    ]
});
$7a48699368d2991e$var$defineType("InterfaceExtends", {
    visitor: [
        "id",
        "typeParameters"
    ],
    fields: {
        id: (0, $geP65.validateType)([
            "Identifier",
            "QualifiedTypeIdentifier"
        ]),
        typeParameters: (0, $geP65.validateOptionalType)("TypeParameterInstantiation")
    }
});
$7a48699368d2991e$var$defineInterfaceishType("InterfaceDeclaration");
$7a48699368d2991e$var$defineType("InterfaceTypeAnnotation", {
    visitor: [
        "extends",
        "body"
    ],
    aliases: [
        "FlowType"
    ],
    fields: {
        extends: (0, $geP65.validateOptional)((0, $geP65.arrayOfType)("InterfaceExtends")),
        body: (0, $geP65.validateType)("ObjectTypeAnnotation")
    }
});
$7a48699368d2991e$var$defineType("IntersectionTypeAnnotation", {
    visitor: [
        "types"
    ],
    aliases: [
        "FlowType"
    ],
    fields: {
        types: (0, $geP65.validate)((0, $geP65.arrayOfType)("FlowType"))
    }
});
$7a48699368d2991e$var$defineType("MixedTypeAnnotation", {
    aliases: [
        "FlowType",
        "FlowBaseAnnotation"
    ]
});
$7a48699368d2991e$var$defineType("EmptyTypeAnnotation", {
    aliases: [
        "FlowType",
        "FlowBaseAnnotation"
    ]
});
$7a48699368d2991e$var$defineType("NullableTypeAnnotation", {
    visitor: [
        "typeAnnotation"
    ],
    aliases: [
        "FlowType"
    ],
    fields: {
        typeAnnotation: (0, $geP65.validateType)("FlowType")
    }
});
$7a48699368d2991e$var$defineType("NumberLiteralTypeAnnotation", {
    builder: [
        "value"
    ],
    aliases: [
        "FlowType"
    ],
    fields: {
        value: (0, $geP65.validate)((0, $geP65.assertValueType)("number"))
    }
});
$7a48699368d2991e$var$defineType("NumberTypeAnnotation", {
    aliases: [
        "FlowType",
        "FlowBaseAnnotation"
    ]
});
$7a48699368d2991e$var$defineType("ObjectTypeAnnotation", {
    visitor: [
        "properties",
        "indexers",
        "callProperties",
        "internalSlots"
    ],
    aliases: [
        "FlowType"
    ],
    builder: [
        "properties",
        "indexers",
        "callProperties",
        "internalSlots",
        "exact"
    ],
    fields: {
        properties: (0, $geP65.validate)((0, $geP65.arrayOfType)([
            "ObjectTypeProperty",
            "ObjectTypeSpreadProperty"
        ])),
        indexers: {
            validate: (0, $geP65.arrayOfType)("ObjectTypeIndexer"),
            optional: true,
            default: []
        },
        callProperties: {
            validate: (0, $geP65.arrayOfType)("ObjectTypeCallProperty"),
            optional: true,
            default: []
        },
        internalSlots: {
            validate: (0, $geP65.arrayOfType)("ObjectTypeInternalSlot"),
            optional: true,
            default: []
        },
        exact: {
            validate: (0, $geP65.assertValueType)("boolean"),
            default: false
        },
        inexact: (0, $geP65.validateOptional)((0, $geP65.assertValueType)("boolean"))
    }
});
$7a48699368d2991e$var$defineType("ObjectTypeInternalSlot", {
    visitor: [
        "id",
        "value",
        "optional",
        "static",
        "method"
    ],
    aliases: [
        "UserWhitespacable"
    ],
    fields: {
        id: (0, $geP65.validateType)("Identifier"),
        value: (0, $geP65.validateType)("FlowType"),
        optional: (0, $geP65.validate)((0, $geP65.assertValueType)("boolean")),
        static: (0, $geP65.validate)((0, $geP65.assertValueType)("boolean")),
        method: (0, $geP65.validate)((0, $geP65.assertValueType)("boolean"))
    }
});
$7a48699368d2991e$var$defineType("ObjectTypeCallProperty", {
    visitor: [
        "value"
    ],
    aliases: [
        "UserWhitespacable"
    ],
    fields: {
        value: (0, $geP65.validateType)("FlowType"),
        static: (0, $geP65.validate)((0, $geP65.assertValueType)("boolean"))
    }
});
$7a48699368d2991e$var$defineType("ObjectTypeIndexer", {
    visitor: [
        "id",
        "key",
        "value",
        "variance"
    ],
    aliases: [
        "UserWhitespacable"
    ],
    fields: {
        id: (0, $geP65.validateOptionalType)("Identifier"),
        key: (0, $geP65.validateType)("FlowType"),
        value: (0, $geP65.validateType)("FlowType"),
        static: (0, $geP65.validate)((0, $geP65.assertValueType)("boolean")),
        variance: (0, $geP65.validateOptionalType)("Variance")
    }
});
$7a48699368d2991e$var$defineType("ObjectTypeProperty", {
    visitor: [
        "key",
        "value",
        "variance"
    ],
    aliases: [
        "UserWhitespacable"
    ],
    fields: {
        key: (0, $geP65.validateType)([
            "Identifier",
            "StringLiteral"
        ]),
        value: (0, $geP65.validateType)("FlowType"),
        kind: (0, $geP65.validate)((0, $geP65.assertOneOf)("init", "get", "set")),
        static: (0, $geP65.validate)((0, $geP65.assertValueType)("boolean")),
        proto: (0, $geP65.validate)((0, $geP65.assertValueType)("boolean")),
        optional: (0, $geP65.validate)((0, $geP65.assertValueType)("boolean")),
        variance: (0, $geP65.validateOptionalType)("Variance"),
        method: (0, $geP65.validate)((0, $geP65.assertValueType)("boolean"))
    }
});
$7a48699368d2991e$var$defineType("ObjectTypeSpreadProperty", {
    visitor: [
        "argument"
    ],
    aliases: [
        "UserWhitespacable"
    ],
    fields: {
        argument: (0, $geP65.validateType)("FlowType")
    }
});
$7a48699368d2991e$var$defineType("OpaqueType", {
    visitor: [
        "id",
        "typeParameters",
        "supertype",
        "impltype"
    ],
    aliases: [
        "FlowDeclaration",
        "Statement",
        "Declaration"
    ],
    fields: {
        id: (0, $geP65.validateType)("Identifier"),
        typeParameters: (0, $geP65.validateOptionalType)("TypeParameterDeclaration"),
        supertype: (0, $geP65.validateOptionalType)("FlowType"),
        impltype: (0, $geP65.validateType)("FlowType")
    }
});
$7a48699368d2991e$var$defineType("QualifiedTypeIdentifier", {
    visitor: [
        "id",
        "qualification"
    ],
    fields: {
        id: (0, $geP65.validateType)("Identifier"),
        qualification: (0, $geP65.validateType)([
            "Identifier",
            "QualifiedTypeIdentifier"
        ])
    }
});
$7a48699368d2991e$var$defineType("StringLiteralTypeAnnotation", {
    builder: [
        "value"
    ],
    aliases: [
        "FlowType"
    ],
    fields: {
        value: (0, $geP65.validate)((0, $geP65.assertValueType)("string"))
    }
});
$7a48699368d2991e$var$defineType("StringTypeAnnotation", {
    aliases: [
        "FlowType",
        "FlowBaseAnnotation"
    ]
});
$7a48699368d2991e$var$defineType("SymbolTypeAnnotation", {
    aliases: [
        "FlowType",
        "FlowBaseAnnotation"
    ]
});
$7a48699368d2991e$var$defineType("ThisTypeAnnotation", {
    aliases: [
        "FlowType",
        "FlowBaseAnnotation"
    ]
});
$7a48699368d2991e$var$defineType("TupleTypeAnnotation", {
    visitor: [
        "types"
    ],
    aliases: [
        "FlowType"
    ],
    fields: {
        types: (0, $geP65.validate)((0, $geP65.arrayOfType)("FlowType"))
    }
});
$7a48699368d2991e$var$defineType("TypeofTypeAnnotation", {
    visitor: [
        "argument"
    ],
    aliases: [
        "FlowType"
    ],
    fields: {
        argument: (0, $geP65.validateType)("FlowType")
    }
});
$7a48699368d2991e$var$defineType("TypeAlias", {
    visitor: [
        "id",
        "typeParameters",
        "right"
    ],
    aliases: [
        "FlowDeclaration",
        "Statement",
        "Declaration"
    ],
    fields: {
        id: (0, $geP65.validateType)("Identifier"),
        typeParameters: (0, $geP65.validateOptionalType)("TypeParameterDeclaration"),
        right: (0, $geP65.validateType)("FlowType")
    }
});
$7a48699368d2991e$var$defineType("TypeAnnotation", {
    visitor: [
        "typeAnnotation"
    ],
    fields: {
        typeAnnotation: (0, $geP65.validateType)("FlowType")
    }
});
$7a48699368d2991e$var$defineType("TypeCastExpression", {
    visitor: [
        "expression",
        "typeAnnotation"
    ],
    aliases: [
        "ExpressionWrapper",
        "Expression"
    ],
    fields: {
        expression: (0, $geP65.validateType)("Expression"),
        typeAnnotation: (0, $geP65.validateType)("TypeAnnotation")
    }
});
$7a48699368d2991e$var$defineType("TypeParameter", {
    visitor: [
        "bound",
        "default",
        "variance"
    ],
    fields: {
        name: (0, $geP65.validate)((0, $geP65.assertValueType)("string")),
        bound: (0, $geP65.validateOptionalType)("TypeAnnotation"),
        default: (0, $geP65.validateOptionalType)("FlowType"),
        variance: (0, $geP65.validateOptionalType)("Variance")
    }
});
$7a48699368d2991e$var$defineType("TypeParameterDeclaration", {
    visitor: [
        "params"
    ],
    fields: {
        params: (0, $geP65.validate)((0, $geP65.arrayOfType)("TypeParameter"))
    }
});
$7a48699368d2991e$var$defineType("TypeParameterInstantiation", {
    visitor: [
        "params"
    ],
    fields: {
        params: (0, $geP65.validate)((0, $geP65.arrayOfType)("FlowType"))
    }
});
$7a48699368d2991e$var$defineType("UnionTypeAnnotation", {
    visitor: [
        "types"
    ],
    aliases: [
        "FlowType"
    ],
    fields: {
        types: (0, $geP65.validate)((0, $geP65.arrayOfType)("FlowType"))
    }
});
$7a48699368d2991e$var$defineType("Variance", {
    builder: [
        "kind"
    ],
    fields: {
        kind: (0, $geP65.validate)((0, $geP65.assertOneOf)("minus", "plus"))
    }
});
$7a48699368d2991e$var$defineType("VoidTypeAnnotation", {
    aliases: [
        "FlowType",
        "FlowBaseAnnotation"
    ]
});
$7a48699368d2991e$var$defineType("EnumDeclaration", {
    aliases: [
        "Statement",
        "Declaration"
    ],
    visitor: [
        "id",
        "body"
    ],
    fields: {
        id: (0, $geP65.validateType)("Identifier"),
        body: (0, $geP65.validateType)([
            "EnumBooleanBody",
            "EnumNumberBody",
            "EnumStringBody",
            "EnumSymbolBody"
        ])
    }
});
$7a48699368d2991e$var$defineType("EnumBooleanBody", {
    aliases: [
        "EnumBody"
    ],
    visitor: [
        "members"
    ],
    fields: {
        explicitType: (0, $geP65.validate)((0, $geP65.assertValueType)("boolean")),
        members: (0, $geP65.validateArrayOfType)("EnumBooleanMember"),
        hasUnknownMembers: (0, $geP65.validate)((0, $geP65.assertValueType)("boolean"))
    }
});
$7a48699368d2991e$var$defineType("EnumNumberBody", {
    aliases: [
        "EnumBody"
    ],
    visitor: [
        "members"
    ],
    fields: {
        explicitType: (0, $geP65.validate)((0, $geP65.assertValueType)("boolean")),
        members: (0, $geP65.validateArrayOfType)("EnumNumberMember"),
        hasUnknownMembers: (0, $geP65.validate)((0, $geP65.assertValueType)("boolean"))
    }
});
$7a48699368d2991e$var$defineType("EnumStringBody", {
    aliases: [
        "EnumBody"
    ],
    visitor: [
        "members"
    ],
    fields: {
        explicitType: (0, $geP65.validate)((0, $geP65.assertValueType)("boolean")),
        members: (0, $geP65.validateArrayOfType)([
            "EnumStringMember",
            "EnumDefaultedMember"
        ]),
        hasUnknownMembers: (0, $geP65.validate)((0, $geP65.assertValueType)("boolean"))
    }
});
$7a48699368d2991e$var$defineType("EnumSymbolBody", {
    aliases: [
        "EnumBody"
    ],
    visitor: [
        "members"
    ],
    fields: {
        members: (0, $geP65.validateArrayOfType)("EnumDefaultedMember"),
        hasUnknownMembers: (0, $geP65.validate)((0, $geP65.assertValueType)("boolean"))
    }
});
$7a48699368d2991e$var$defineType("EnumBooleanMember", {
    aliases: [
        "EnumMember"
    ],
    visitor: [
        "id"
    ],
    fields: {
        id: (0, $geP65.validateType)("Identifier"),
        init: (0, $geP65.validateType)("BooleanLiteral")
    }
});
$7a48699368d2991e$var$defineType("EnumNumberMember", {
    aliases: [
        "EnumMember"
    ],
    visitor: [
        "id",
        "init"
    ],
    fields: {
        id: (0, $geP65.validateType)("Identifier"),
        init: (0, $geP65.validateType)("NumericLiteral")
    }
});
$7a48699368d2991e$var$defineType("EnumStringMember", {
    aliases: [
        "EnumMember"
    ],
    visitor: [
        "id",
        "init"
    ],
    fields: {
        id: (0, $geP65.validateType)("Identifier"),
        init: (0, $geP65.validateType)("StringLiteral")
    }
});
$7a48699368d2991e$var$defineType("EnumDefaultedMember", {
    aliases: [
        "EnumMember"
    ],
    visitor: [
        "id"
    ],
    fields: {
        id: (0, $geP65.validateType)("Identifier")
    }
});
$7a48699368d2991e$var$defineType("IndexedAccessType", {
    visitor: [
        "objectType",
        "indexType"
    ],
    aliases: [
        "FlowType"
    ],
    fields: {
        objectType: (0, $geP65.validateType)("FlowType"),
        indexType: (0, $geP65.validateType)("FlowType")
    }
});
$7a48699368d2991e$var$defineType("OptionalIndexedAccessType", {
    visitor: [
        "objectType",
        "indexType"
    ],
    aliases: [
        "FlowType"
    ],
    fields: {
        objectType: (0, $geP65.validateType)("FlowType"),
        indexType: (0, $geP65.validateType)("FlowType"),
        optional: (0, $geP65.validate)((0, $geP65.assertValueType)("boolean"))
    }
});

});

parcelRegister("58Nt7", function(module, exports) {
"use strict";

var $geP65 = parcelRequire("geP65");
const $3be4128720dac00f$var$defineType = (0, $geP65.defineAliasedType)("JSX");
$3be4128720dac00f$var$defineType("JSXAttribute", {
    visitor: [
        "name",
        "value"
    ],
    aliases: [
        "Immutable"
    ],
    fields: {
        name: {
            validate: (0, $geP65.assertNodeType)("JSXIdentifier", "JSXNamespacedName")
        },
        value: {
            optional: true,
            validate: (0, $geP65.assertNodeType)("JSXElement", "JSXFragment", "StringLiteral", "JSXExpressionContainer")
        }
    }
});
$3be4128720dac00f$var$defineType("JSXClosingElement", {
    visitor: [
        "name"
    ],
    aliases: [
        "Immutable"
    ],
    fields: {
        name: {
            validate: (0, $geP65.assertNodeType)("JSXIdentifier", "JSXMemberExpression", "JSXNamespacedName")
        }
    }
});
$3be4128720dac00f$var$defineType("JSXElement", {
    builder: [
        "openingElement",
        "closingElement",
        "children",
        "selfClosing"
    ],
    visitor: [
        "openingElement",
        "children",
        "closingElement"
    ],
    aliases: [
        "Immutable",
        "Expression"
    ],
    fields: Object.assign({
        openingElement: {
            validate: (0, $geP65.assertNodeType)("JSXOpeningElement")
        },
        closingElement: {
            optional: true,
            validate: (0, $geP65.assertNodeType)("JSXClosingElement")
        },
        children: {
            validate: (0, $geP65.chain)((0, $geP65.assertValueType)("array"), (0, $geP65.assertEach)((0, $geP65.assertNodeType)("JSXText", "JSXExpressionContainer", "JSXSpreadChild", "JSXElement", "JSXFragment")))
        }
    }, {
        selfClosing: {
            validate: (0, $geP65.assertValueType)("boolean"),
            optional: true
        }
    })
});
$3be4128720dac00f$var$defineType("JSXEmptyExpression", {});
$3be4128720dac00f$var$defineType("JSXExpressionContainer", {
    visitor: [
        "expression"
    ],
    aliases: [
        "Immutable"
    ],
    fields: {
        expression: {
            validate: (0, $geP65.assertNodeType)("Expression", "JSXEmptyExpression")
        }
    }
});
$3be4128720dac00f$var$defineType("JSXSpreadChild", {
    visitor: [
        "expression"
    ],
    aliases: [
        "Immutable"
    ],
    fields: {
        expression: {
            validate: (0, $geP65.assertNodeType)("Expression")
        }
    }
});
$3be4128720dac00f$var$defineType("JSXIdentifier", {
    builder: [
        "name"
    ],
    fields: {
        name: {
            validate: (0, $geP65.assertValueType)("string")
        }
    }
});
$3be4128720dac00f$var$defineType("JSXMemberExpression", {
    visitor: [
        "object",
        "property"
    ],
    fields: {
        object: {
            validate: (0, $geP65.assertNodeType)("JSXMemberExpression", "JSXIdentifier")
        },
        property: {
            validate: (0, $geP65.assertNodeType)("JSXIdentifier")
        }
    }
});
$3be4128720dac00f$var$defineType("JSXNamespacedName", {
    visitor: [
        "namespace",
        "name"
    ],
    fields: {
        namespace: {
            validate: (0, $geP65.assertNodeType)("JSXIdentifier")
        },
        name: {
            validate: (0, $geP65.assertNodeType)("JSXIdentifier")
        }
    }
});
$3be4128720dac00f$var$defineType("JSXOpeningElement", {
    builder: [
        "name",
        "attributes",
        "selfClosing"
    ],
    visitor: [
        "name",
        "attributes"
    ],
    aliases: [
        "Immutable"
    ],
    fields: {
        name: {
            validate: (0, $geP65.assertNodeType)("JSXIdentifier", "JSXMemberExpression", "JSXNamespacedName")
        },
        selfClosing: {
            default: false
        },
        attributes: {
            validate: (0, $geP65.chain)((0, $geP65.assertValueType)("array"), (0, $geP65.assertEach)((0, $geP65.assertNodeType)("JSXAttribute", "JSXSpreadAttribute")))
        },
        typeParameters: {
            validate: (0, $geP65.assertNodeType)("TypeParameterInstantiation", "TSTypeParameterInstantiation"),
            optional: true
        }
    }
});
$3be4128720dac00f$var$defineType("JSXSpreadAttribute", {
    visitor: [
        "argument"
    ],
    fields: {
        argument: {
            validate: (0, $geP65.assertNodeType)("Expression")
        }
    }
});
$3be4128720dac00f$var$defineType("JSXText", {
    aliases: [
        "Immutable"
    ],
    builder: [
        "value"
    ],
    fields: {
        value: {
            validate: (0, $geP65.assertValueType)("string")
        }
    }
});
$3be4128720dac00f$var$defineType("JSXFragment", {
    builder: [
        "openingFragment",
        "closingFragment",
        "children"
    ],
    visitor: [
        "openingFragment",
        "children",
        "closingFragment"
    ],
    aliases: [
        "Immutable",
        "Expression"
    ],
    fields: {
        openingFragment: {
            validate: (0, $geP65.assertNodeType)("JSXOpeningFragment")
        },
        closingFragment: {
            validate: (0, $geP65.assertNodeType)("JSXClosingFragment")
        },
        children: {
            validate: (0, $geP65.chain)((0, $geP65.assertValueType)("array"), (0, $geP65.assertEach)((0, $geP65.assertNodeType)("JSXText", "JSXExpressionContainer", "JSXSpreadChild", "JSXElement", "JSXFragment")))
        }
    }
});
$3be4128720dac00f$var$defineType("JSXOpeningFragment", {
    aliases: [
        "Immutable"
    ]
});
$3be4128720dac00f$var$defineType("JSXClosingFragment", {
    aliases: [
        "Immutable"
    ]
});

});

parcelRegister("6Dn2K", function(module, exports) {
"use strict";

var $geP65 = parcelRequire("geP65");

var $bPvXC = parcelRequire("bPvXC");
const $4d4842861c26490e$var$defineType = (0, $geP65.defineAliasedType)("Miscellaneous");
$4d4842861c26490e$var$defineType("Noop", {
    visitor: []
});
$4d4842861c26490e$var$defineType("Placeholder", {
    visitor: [],
    builder: [
        "expectedNode",
        "name"
    ],
    fields: {
        name: {
            validate: (0, $geP65.assertNodeType)("Identifier")
        },
        expectedNode: {
            validate: (0, $geP65.assertOneOf)(...$bPvXC.PLACEHOLDERS)
        }
    }
});
$4d4842861c26490e$var$defineType("V8IntrinsicIdentifier", {
    builder: [
        "name"
    ],
    fields: {
        name: {
            validate: (0, $geP65.assertValueType)("string")
        }
    }
});

});
parcelRegister("bPvXC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PLACEHOLDERS_FLIPPED_ALIAS = module.exports.PLACEHOLDERS_ALIAS = module.exports.PLACEHOLDERS = void 0;

var $geP65 = parcelRequire("geP65");
const $89cd3fd5491c75b6$var$PLACEHOLDERS = module.exports.PLACEHOLDERS = [
    "Identifier",
    "StringLiteral",
    "Expression",
    "Statement",
    "Declaration",
    "BlockStatement",
    "ClassBody",
    "Pattern"
];
const $89cd3fd5491c75b6$var$PLACEHOLDERS_ALIAS = module.exports.PLACEHOLDERS_ALIAS = {
    Declaration: [
        "Statement"
    ],
    Pattern: [
        "PatternLike",
        "LVal"
    ]
};
for (const type of $89cd3fd5491c75b6$var$PLACEHOLDERS){
    const alias = $geP65.ALIAS_KEYS[type];
    if (alias != null && alias.length) $89cd3fd5491c75b6$var$PLACEHOLDERS_ALIAS[type] = alias;
}
const $89cd3fd5491c75b6$var$PLACEHOLDERS_FLIPPED_ALIAS = module.exports.PLACEHOLDERS_FLIPPED_ALIAS = {};
Object.keys($89cd3fd5491c75b6$var$PLACEHOLDERS_ALIAS).forEach((type)=>{
    $89cd3fd5491c75b6$var$PLACEHOLDERS_ALIAS[type].forEach((alias)=>{
        if (!hasOwnProperty.call($89cd3fd5491c75b6$var$PLACEHOLDERS_FLIPPED_ALIAS, alias)) $89cd3fd5491c75b6$var$PLACEHOLDERS_FLIPPED_ALIAS[alias] = [];
        $89cd3fd5491c75b6$var$PLACEHOLDERS_FLIPPED_ALIAS[alias].push(type);
    });
});

});


parcelRegister("1Z26G", function(module, exports) {
"use strict";

var $geP65 = parcelRequire("geP65");
(0, $geP65.default)("ArgumentPlaceholder", {});
(0, $geP65.default)("BindExpression", {
    visitor: [
        "object",
        "callee"
    ],
    aliases: [
        "Expression"
    ],
    fields: {
        object: {
            validate: Object.assign(()=>{}, {
                oneOfNodeTypes: [
                    "Expression"
                ]
            })
        },
        callee: {
            validate: Object.assign(()=>{}, {
                oneOfNodeTypes: [
                    "Expression"
                ]
            })
        }
    }
});
(0, $geP65.default)("ImportAttribute", {
    visitor: [
        "key",
        "value"
    ],
    fields: {
        key: {
            validate: (0, $geP65.assertNodeType)("Identifier", "StringLiteral")
        },
        value: {
            validate: (0, $geP65.assertNodeType)("StringLiteral")
        }
    }
});
(0, $geP65.default)("Decorator", {
    visitor: [
        "expression"
    ],
    fields: {
        expression: {
            validate: (0, $geP65.assertNodeType)("Expression")
        }
    }
});
(0, $geP65.default)("DoExpression", {
    visitor: [
        "body"
    ],
    builder: [
        "body",
        "async"
    ],
    aliases: [
        "Expression"
    ],
    fields: {
        body: {
            validate: (0, $geP65.assertNodeType)("BlockStatement")
        },
        async: {
            validate: (0, $geP65.assertValueType)("boolean"),
            default: false
        }
    }
});
(0, $geP65.default)("ExportDefaultSpecifier", {
    visitor: [
        "exported"
    ],
    aliases: [
        "ModuleSpecifier"
    ],
    fields: {
        exported: {
            validate: (0, $geP65.assertNodeType)("Identifier")
        }
    }
});
(0, $geP65.default)("RecordExpression", {
    visitor: [
        "properties"
    ],
    aliases: [
        "Expression"
    ],
    fields: {
        properties: {
            validate: (0, $geP65.chain)((0, $geP65.assertValueType)("array"), (0, $geP65.assertEach)((0, $geP65.assertNodeType)("ObjectProperty", "SpreadElement")))
        }
    }
});
(0, $geP65.default)("TupleExpression", {
    fields: {
        elements: {
            validate: (0, $geP65.chain)((0, $geP65.assertValueType)("array"), (0, $geP65.assertEach)((0, $geP65.assertNodeType)("Expression", "SpreadElement"))),
            default: []
        }
    },
    visitor: [
        "elements"
    ],
    aliases: [
        "Expression"
    ]
});
(0, $geP65.default)("DecimalLiteral", {
    builder: [
        "value"
    ],
    fields: {
        value: {
            validate: (0, $geP65.assertValueType)("string")
        }
    },
    aliases: [
        "Expression",
        "Pureish",
        "Literal",
        "Immutable"
    ]
});
(0, $geP65.default)("ModuleExpression", {
    visitor: [
        "body"
    ],
    fields: {
        body: {
            validate: (0, $geP65.assertNodeType)("Program")
        }
    },
    aliases: [
        "Expression"
    ]
});
(0, $geP65.default)("TopicReference", {
    aliases: [
        "Expression"
    ]
});
(0, $geP65.default)("PipelineTopicExpression", {
    builder: [
        "expression"
    ],
    visitor: [
        "expression"
    ],
    fields: {
        expression: {
            validate: (0, $geP65.assertNodeType)("Expression")
        }
    },
    aliases: [
        "Expression"
    ]
});
(0, $geP65.default)("PipelineBareFunction", {
    builder: [
        "callee"
    ],
    visitor: [
        "callee"
    ],
    fields: {
        callee: {
            validate: (0, $geP65.assertNodeType)("Expression")
        }
    },
    aliases: [
        "Expression"
    ]
});
(0, $geP65.default)("PipelinePrimaryTopicReference", {
    aliases: [
        "Expression"
    ]
});

});

parcelRegister("cqXfs", function(module, exports) {
"use strict";

var $geP65 = parcelRequire("geP65");

var $03zc9 = parcelRequire("03zc9");

var $4XzLl = parcelRequire("4XzLl");
const $90d5df33cd8cd7d3$var$defineType = (0, $geP65.defineAliasedType)("TypeScript");
const $90d5df33cd8cd7d3$var$bool = (0, $geP65.assertValueType)("boolean");
const $90d5df33cd8cd7d3$var$tSFunctionTypeAnnotationCommon = ()=>({
        returnType: {
            validate: (0, $geP65.assertNodeType)("TSTypeAnnotation", "Noop"),
            optional: true
        },
        typeParameters: {
            validate: (0, $geP65.assertNodeType)("TSTypeParameterDeclaration", "Noop"),
            optional: true
        }
    });
$90d5df33cd8cd7d3$var$defineType("TSParameterProperty", {
    aliases: [
        "LVal"
    ],
    visitor: [
        "parameter"
    ],
    fields: {
        accessibility: {
            validate: (0, $geP65.assertOneOf)("public", "private", "protected"),
            optional: true
        },
        readonly: {
            validate: (0, $geP65.assertValueType)("boolean"),
            optional: true
        },
        parameter: {
            validate: (0, $geP65.assertNodeType)("Identifier", "AssignmentPattern")
        },
        override: {
            validate: (0, $geP65.assertValueType)("boolean"),
            optional: true
        },
        decorators: {
            validate: (0, $geP65.chain)((0, $geP65.assertValueType)("array"), (0, $geP65.assertEach)((0, $geP65.assertNodeType)("Decorator"))),
            optional: true
        }
    }
});
$90d5df33cd8cd7d3$var$defineType("TSDeclareFunction", {
    aliases: [
        "Statement",
        "Declaration"
    ],
    visitor: [
        "id",
        "typeParameters",
        "params",
        "returnType"
    ],
    fields: Object.assign({}, (0, $03zc9.functionDeclarationCommon)(), $90d5df33cd8cd7d3$var$tSFunctionTypeAnnotationCommon())
});
$90d5df33cd8cd7d3$var$defineType("TSDeclareMethod", {
    visitor: [
        "decorators",
        "key",
        "typeParameters",
        "params",
        "returnType"
    ],
    fields: Object.assign({}, (0, $03zc9.classMethodOrDeclareMethodCommon)(), $90d5df33cd8cd7d3$var$tSFunctionTypeAnnotationCommon())
});
$90d5df33cd8cd7d3$var$defineType("TSQualifiedName", {
    aliases: [
        "TSEntityName"
    ],
    visitor: [
        "left",
        "right"
    ],
    fields: {
        left: (0, $geP65.validateType)("TSEntityName"),
        right: (0, $geP65.validateType)("Identifier")
    }
});
const $90d5df33cd8cd7d3$var$signatureDeclarationCommon = ()=>({
        typeParameters: (0, $geP65.validateOptionalType)("TSTypeParameterDeclaration"),
        ["parameters"]: (0, $geP65.validateArrayOfType)([
            "ArrayPattern",
            "Identifier",
            "ObjectPattern",
            "RestElement"
        ]),
        ["typeAnnotation"]: (0, $geP65.validateOptionalType)("TSTypeAnnotation")
    });
const $90d5df33cd8cd7d3$var$callConstructSignatureDeclaration = {
    aliases: [
        "TSTypeElement"
    ],
    visitor: [
        "typeParameters",
        "parameters",
        "typeAnnotation"
    ],
    fields: $90d5df33cd8cd7d3$var$signatureDeclarationCommon()
};
$90d5df33cd8cd7d3$var$defineType("TSCallSignatureDeclaration", $90d5df33cd8cd7d3$var$callConstructSignatureDeclaration);
$90d5df33cd8cd7d3$var$defineType("TSConstructSignatureDeclaration", $90d5df33cd8cd7d3$var$callConstructSignatureDeclaration);
const $90d5df33cd8cd7d3$var$namedTypeElementCommon = ()=>({
        key: (0, $geP65.validateType)("Expression"),
        computed: {
            default: false
        },
        optional: (0, $geP65.validateOptional)($90d5df33cd8cd7d3$var$bool)
    });
$90d5df33cd8cd7d3$var$defineType("TSPropertySignature", {
    aliases: [
        "TSTypeElement"
    ],
    visitor: [
        "key",
        "typeAnnotation"
    ],
    fields: Object.assign({}, $90d5df33cd8cd7d3$var$namedTypeElementCommon(), {
        readonly: (0, $geP65.validateOptional)($90d5df33cd8cd7d3$var$bool),
        typeAnnotation: (0, $geP65.validateOptionalType)("TSTypeAnnotation"),
        kind: {
            validate: (0, $geP65.assertOneOf)("get", "set")
        }
    })
});
$90d5df33cd8cd7d3$var$defineType("TSMethodSignature", {
    aliases: [
        "TSTypeElement"
    ],
    visitor: [
        "key",
        "typeParameters",
        "parameters",
        "typeAnnotation"
    ],
    fields: Object.assign({}, $90d5df33cd8cd7d3$var$signatureDeclarationCommon(), $90d5df33cd8cd7d3$var$namedTypeElementCommon(), {
        kind: {
            validate: (0, $geP65.assertOneOf)("method", "get", "set")
        }
    })
});
$90d5df33cd8cd7d3$var$defineType("TSIndexSignature", {
    aliases: [
        "TSTypeElement"
    ],
    visitor: [
        "parameters",
        "typeAnnotation"
    ],
    fields: {
        readonly: (0, $geP65.validateOptional)($90d5df33cd8cd7d3$var$bool),
        static: (0, $geP65.validateOptional)($90d5df33cd8cd7d3$var$bool),
        parameters: (0, $geP65.validateArrayOfType)("Identifier"),
        typeAnnotation: (0, $geP65.validateOptionalType)("TSTypeAnnotation")
    }
});
const $90d5df33cd8cd7d3$var$tsKeywordTypes = [
    "TSAnyKeyword",
    "TSBooleanKeyword",
    "TSBigIntKeyword",
    "TSIntrinsicKeyword",
    "TSNeverKeyword",
    "TSNullKeyword",
    "TSNumberKeyword",
    "TSObjectKeyword",
    "TSStringKeyword",
    "TSSymbolKeyword",
    "TSUndefinedKeyword",
    "TSUnknownKeyword",
    "TSVoidKeyword"
];
for (const type of $90d5df33cd8cd7d3$var$tsKeywordTypes)$90d5df33cd8cd7d3$var$defineType(type, {
    aliases: [
        "TSType",
        "TSBaseType"
    ],
    visitor: [],
    fields: {}
});
$90d5df33cd8cd7d3$var$defineType("TSThisType", {
    aliases: [
        "TSType",
        "TSBaseType"
    ],
    visitor: [],
    fields: {}
});
const $90d5df33cd8cd7d3$var$fnOrCtrBase = {
    aliases: [
        "TSType"
    ],
    visitor: [
        "typeParameters",
        "parameters",
        "typeAnnotation"
    ]
};
$90d5df33cd8cd7d3$var$defineType("TSFunctionType", Object.assign({}, $90d5df33cd8cd7d3$var$fnOrCtrBase, {
    fields: $90d5df33cd8cd7d3$var$signatureDeclarationCommon()
}));
$90d5df33cd8cd7d3$var$defineType("TSConstructorType", Object.assign({}, $90d5df33cd8cd7d3$var$fnOrCtrBase, {
    fields: Object.assign({}, $90d5df33cd8cd7d3$var$signatureDeclarationCommon(), {
        abstract: (0, $geP65.validateOptional)($90d5df33cd8cd7d3$var$bool)
    })
}));
$90d5df33cd8cd7d3$var$defineType("TSTypeReference", {
    aliases: [
        "TSType"
    ],
    visitor: [
        "typeName",
        "typeParameters"
    ],
    fields: {
        typeName: (0, $geP65.validateType)("TSEntityName"),
        typeParameters: (0, $geP65.validateOptionalType)("TSTypeParameterInstantiation")
    }
});
$90d5df33cd8cd7d3$var$defineType("TSTypePredicate", {
    aliases: [
        "TSType"
    ],
    visitor: [
        "parameterName",
        "typeAnnotation"
    ],
    builder: [
        "parameterName",
        "typeAnnotation",
        "asserts"
    ],
    fields: {
        parameterName: (0, $geP65.validateType)([
            "Identifier",
            "TSThisType"
        ]),
        typeAnnotation: (0, $geP65.validateOptionalType)("TSTypeAnnotation"),
        asserts: (0, $geP65.validateOptional)($90d5df33cd8cd7d3$var$bool)
    }
});
$90d5df33cd8cd7d3$var$defineType("TSTypeQuery", {
    aliases: [
        "TSType"
    ],
    visitor: [
        "exprName",
        "typeParameters"
    ],
    fields: {
        exprName: (0, $geP65.validateType)([
            "TSEntityName",
            "TSImportType"
        ]),
        typeParameters: (0, $geP65.validateOptionalType)("TSTypeParameterInstantiation")
    }
});
$90d5df33cd8cd7d3$var$defineType("TSTypeLiteral", {
    aliases: [
        "TSType"
    ],
    visitor: [
        "members"
    ],
    fields: {
        members: (0, $geP65.validateArrayOfType)("TSTypeElement")
    }
});
$90d5df33cd8cd7d3$var$defineType("TSArrayType", {
    aliases: [
        "TSType"
    ],
    visitor: [
        "elementType"
    ],
    fields: {
        elementType: (0, $geP65.validateType)("TSType")
    }
});
$90d5df33cd8cd7d3$var$defineType("TSTupleType", {
    aliases: [
        "TSType"
    ],
    visitor: [
        "elementTypes"
    ],
    fields: {
        elementTypes: (0, $geP65.validateArrayOfType)([
            "TSType",
            "TSNamedTupleMember"
        ])
    }
});
$90d5df33cd8cd7d3$var$defineType("TSOptionalType", {
    aliases: [
        "TSType"
    ],
    visitor: [
        "typeAnnotation"
    ],
    fields: {
        typeAnnotation: (0, $geP65.validateType)("TSType")
    }
});
$90d5df33cd8cd7d3$var$defineType("TSRestType", {
    aliases: [
        "TSType"
    ],
    visitor: [
        "typeAnnotation"
    ],
    fields: {
        typeAnnotation: (0, $geP65.validateType)("TSType")
    }
});
$90d5df33cd8cd7d3$var$defineType("TSNamedTupleMember", {
    visitor: [
        "label",
        "elementType"
    ],
    builder: [
        "label",
        "elementType",
        "optional"
    ],
    fields: {
        label: (0, $geP65.validateType)("Identifier"),
        optional: {
            validate: $90d5df33cd8cd7d3$var$bool,
            default: false
        },
        elementType: (0, $geP65.validateType)("TSType")
    }
});
const $90d5df33cd8cd7d3$var$unionOrIntersection = {
    aliases: [
        "TSType"
    ],
    visitor: [
        "types"
    ],
    fields: {
        types: (0, $geP65.validateArrayOfType)("TSType")
    }
};
$90d5df33cd8cd7d3$var$defineType("TSUnionType", $90d5df33cd8cd7d3$var$unionOrIntersection);
$90d5df33cd8cd7d3$var$defineType("TSIntersectionType", $90d5df33cd8cd7d3$var$unionOrIntersection);
$90d5df33cd8cd7d3$var$defineType("TSConditionalType", {
    aliases: [
        "TSType"
    ],
    visitor: [
        "checkType",
        "extendsType",
        "trueType",
        "falseType"
    ],
    fields: {
        checkType: (0, $geP65.validateType)("TSType"),
        extendsType: (0, $geP65.validateType)("TSType"),
        trueType: (0, $geP65.validateType)("TSType"),
        falseType: (0, $geP65.validateType)("TSType")
    }
});
$90d5df33cd8cd7d3$var$defineType("TSInferType", {
    aliases: [
        "TSType"
    ],
    visitor: [
        "typeParameter"
    ],
    fields: {
        typeParameter: (0, $geP65.validateType)("TSTypeParameter")
    }
});
$90d5df33cd8cd7d3$var$defineType("TSParenthesizedType", {
    aliases: [
        "TSType"
    ],
    visitor: [
        "typeAnnotation"
    ],
    fields: {
        typeAnnotation: (0, $geP65.validateType)("TSType")
    }
});
$90d5df33cd8cd7d3$var$defineType("TSTypeOperator", {
    aliases: [
        "TSType"
    ],
    visitor: [
        "typeAnnotation"
    ],
    fields: {
        operator: (0, $geP65.validate)((0, $geP65.assertValueType)("string")),
        typeAnnotation: (0, $geP65.validateType)("TSType")
    }
});
$90d5df33cd8cd7d3$var$defineType("TSIndexedAccessType", {
    aliases: [
        "TSType"
    ],
    visitor: [
        "objectType",
        "indexType"
    ],
    fields: {
        objectType: (0, $geP65.validateType)("TSType"),
        indexType: (0, $geP65.validateType)("TSType")
    }
});
$90d5df33cd8cd7d3$var$defineType("TSMappedType", {
    aliases: [
        "TSType"
    ],
    visitor: [
        "typeParameter",
        "typeAnnotation",
        "nameType"
    ],
    fields: {
        readonly: (0, $geP65.validateOptional)((0, $geP65.assertOneOf)(true, false, "+", "-")),
        typeParameter: (0, $geP65.validateType)("TSTypeParameter"),
        optional: (0, $geP65.validateOptional)((0, $geP65.assertOneOf)(true, false, "+", "-")),
        typeAnnotation: (0, $geP65.validateOptionalType)("TSType"),
        nameType: (0, $geP65.validateOptionalType)("TSType")
    }
});
$90d5df33cd8cd7d3$var$defineType("TSLiteralType", {
    aliases: [
        "TSType",
        "TSBaseType"
    ],
    visitor: [
        "literal"
    ],
    fields: {
        literal: {
            validate: function() {
                const unaryExpression = (0, $geP65.assertNodeType)("NumericLiteral", "BigIntLiteral");
                const unaryOperator = (0, $geP65.assertOneOf)("-");
                const literal = (0, $geP65.assertNodeType)("NumericLiteral", "StringLiteral", "BooleanLiteral", "BigIntLiteral", "TemplateLiteral");
                function validator(parent, key, node) {
                    if ((0, $4XzLl.default)("UnaryExpression", node)) {
                        unaryOperator(node, "operator", node.operator);
                        unaryExpression(node, "argument", node.argument);
                    } else literal(parent, key, node);
                }
                validator.oneOfNodeTypes = [
                    "NumericLiteral",
                    "StringLiteral",
                    "BooleanLiteral",
                    "BigIntLiteral",
                    "TemplateLiteral",
                    "UnaryExpression"
                ];
                return validator;
            }()
        }
    }
});
$90d5df33cd8cd7d3$var$defineType("TSExpressionWithTypeArguments", {
    aliases: [
        "TSType"
    ],
    visitor: [
        "expression",
        "typeParameters"
    ],
    fields: {
        expression: (0, $geP65.validateType)("TSEntityName"),
        typeParameters: (0, $geP65.validateOptionalType)("TSTypeParameterInstantiation")
    }
});
$90d5df33cd8cd7d3$var$defineType("TSInterfaceDeclaration", {
    aliases: [
        "Statement",
        "Declaration"
    ],
    visitor: [
        "id",
        "typeParameters",
        "extends",
        "body"
    ],
    fields: {
        declare: (0, $geP65.validateOptional)($90d5df33cd8cd7d3$var$bool),
        id: (0, $geP65.validateType)("Identifier"),
        typeParameters: (0, $geP65.validateOptionalType)("TSTypeParameterDeclaration"),
        extends: (0, $geP65.validateOptional)((0, $geP65.arrayOfType)("TSExpressionWithTypeArguments")),
        body: (0, $geP65.validateType)("TSInterfaceBody")
    }
});
$90d5df33cd8cd7d3$var$defineType("TSInterfaceBody", {
    visitor: [
        "body"
    ],
    fields: {
        body: (0, $geP65.validateArrayOfType)("TSTypeElement")
    }
});
$90d5df33cd8cd7d3$var$defineType("TSTypeAliasDeclaration", {
    aliases: [
        "Statement",
        "Declaration"
    ],
    visitor: [
        "id",
        "typeParameters",
        "typeAnnotation"
    ],
    fields: {
        declare: (0, $geP65.validateOptional)($90d5df33cd8cd7d3$var$bool),
        id: (0, $geP65.validateType)("Identifier"),
        typeParameters: (0, $geP65.validateOptionalType)("TSTypeParameterDeclaration"),
        typeAnnotation: (0, $geP65.validateType)("TSType")
    }
});
$90d5df33cd8cd7d3$var$defineType("TSInstantiationExpression", {
    aliases: [
        "Expression"
    ],
    visitor: [
        "expression",
        "typeParameters"
    ],
    fields: {
        expression: (0, $geP65.validateType)("Expression"),
        typeParameters: (0, $geP65.validateOptionalType)("TSTypeParameterInstantiation")
    }
});
const $90d5df33cd8cd7d3$var$TSTypeExpression = {
    aliases: [
        "Expression",
        "LVal",
        "PatternLike"
    ],
    visitor: [
        "expression",
        "typeAnnotation"
    ],
    fields: {
        expression: (0, $geP65.validateType)("Expression"),
        typeAnnotation: (0, $geP65.validateType)("TSType")
    }
};
$90d5df33cd8cd7d3$var$defineType("TSAsExpression", $90d5df33cd8cd7d3$var$TSTypeExpression);
$90d5df33cd8cd7d3$var$defineType("TSSatisfiesExpression", $90d5df33cd8cd7d3$var$TSTypeExpression);
$90d5df33cd8cd7d3$var$defineType("TSTypeAssertion", {
    aliases: [
        "Expression",
        "LVal",
        "PatternLike"
    ],
    visitor: [
        "typeAnnotation",
        "expression"
    ],
    fields: {
        typeAnnotation: (0, $geP65.validateType)("TSType"),
        expression: (0, $geP65.validateType)("Expression")
    }
});
$90d5df33cd8cd7d3$var$defineType("TSEnumDeclaration", {
    aliases: [
        "Statement",
        "Declaration"
    ],
    visitor: [
        "id",
        "members"
    ],
    fields: {
        declare: (0, $geP65.validateOptional)($90d5df33cd8cd7d3$var$bool),
        const: (0, $geP65.validateOptional)($90d5df33cd8cd7d3$var$bool),
        id: (0, $geP65.validateType)("Identifier"),
        members: (0, $geP65.validateArrayOfType)("TSEnumMember"),
        initializer: (0, $geP65.validateOptionalType)("Expression")
    }
});
$90d5df33cd8cd7d3$var$defineType("TSEnumMember", {
    visitor: [
        "id",
        "initializer"
    ],
    fields: {
        id: (0, $geP65.validateType)([
            "Identifier",
            "StringLiteral"
        ]),
        initializer: (0, $geP65.validateOptionalType)("Expression")
    }
});
$90d5df33cd8cd7d3$var$defineType("TSModuleDeclaration", {
    aliases: [
        "Statement",
        "Declaration"
    ],
    visitor: [
        "id",
        "body"
    ],
    fields: {
        declare: (0, $geP65.validateOptional)($90d5df33cd8cd7d3$var$bool),
        global: (0, $geP65.validateOptional)($90d5df33cd8cd7d3$var$bool),
        id: (0, $geP65.validateType)([
            "Identifier",
            "StringLiteral"
        ]),
        body: (0, $geP65.validateType)([
            "TSModuleBlock",
            "TSModuleDeclaration"
        ])
    }
});
$90d5df33cd8cd7d3$var$defineType("TSModuleBlock", {
    aliases: [
        "Scopable",
        "Block",
        "BlockParent",
        "FunctionParent"
    ],
    visitor: [
        "body"
    ],
    fields: {
        body: (0, $geP65.validateArrayOfType)("Statement")
    }
});
$90d5df33cd8cd7d3$var$defineType("TSImportType", {
    aliases: [
        "TSType"
    ],
    visitor: [
        "argument",
        "qualifier",
        "typeParameters"
    ],
    fields: {
        argument: (0, $geP65.validateType)("StringLiteral"),
        qualifier: (0, $geP65.validateOptionalType)("TSEntityName"),
        typeParameters: (0, $geP65.validateOptionalType)("TSTypeParameterInstantiation"),
        options: {
            validate: (0, $geP65.assertNodeType)("Expression"),
            optional: true
        }
    }
});
$90d5df33cd8cd7d3$var$defineType("TSImportEqualsDeclaration", {
    aliases: [
        "Statement"
    ],
    visitor: [
        "id",
        "moduleReference"
    ],
    fields: {
        isExport: (0, $geP65.validate)($90d5df33cd8cd7d3$var$bool),
        id: (0, $geP65.validateType)("Identifier"),
        moduleReference: (0, $geP65.validateType)([
            "TSEntityName",
            "TSExternalModuleReference"
        ]),
        importKind: {
            validate: (0, $geP65.assertOneOf)("type", "value"),
            optional: true
        }
    }
});
$90d5df33cd8cd7d3$var$defineType("TSExternalModuleReference", {
    visitor: [
        "expression"
    ],
    fields: {
        expression: (0, $geP65.validateType)("StringLiteral")
    }
});
$90d5df33cd8cd7d3$var$defineType("TSNonNullExpression", {
    aliases: [
        "Expression",
        "LVal",
        "PatternLike"
    ],
    visitor: [
        "expression"
    ],
    fields: {
        expression: (0, $geP65.validateType)("Expression")
    }
});
$90d5df33cd8cd7d3$var$defineType("TSExportAssignment", {
    aliases: [
        "Statement"
    ],
    visitor: [
        "expression"
    ],
    fields: {
        expression: (0, $geP65.validateType)("Expression")
    }
});
$90d5df33cd8cd7d3$var$defineType("TSNamespaceExportDeclaration", {
    aliases: [
        "Statement"
    ],
    visitor: [
        "id"
    ],
    fields: {
        id: (0, $geP65.validateType)("Identifier")
    }
});
$90d5df33cd8cd7d3$var$defineType("TSTypeAnnotation", {
    visitor: [
        "typeAnnotation"
    ],
    fields: {
        typeAnnotation: {
            validate: (0, $geP65.assertNodeType)("TSType")
        }
    }
});
$90d5df33cd8cd7d3$var$defineType("TSTypeParameterInstantiation", {
    visitor: [
        "params"
    ],
    fields: {
        params: {
            validate: (0, $geP65.chain)((0, $geP65.assertValueType)("array"), (0, $geP65.assertEach)((0, $geP65.assertNodeType)("TSType")))
        }
    }
});
$90d5df33cd8cd7d3$var$defineType("TSTypeParameterDeclaration", {
    visitor: [
        "params"
    ],
    fields: {
        params: {
            validate: (0, $geP65.chain)((0, $geP65.assertValueType)("array"), (0, $geP65.assertEach)((0, $geP65.assertNodeType)("TSTypeParameter")))
        }
    }
});
$90d5df33cd8cd7d3$var$defineType("TSTypeParameter", {
    builder: [
        "constraint",
        "default",
        "name"
    ],
    visitor: [
        "constraint",
        "default"
    ],
    fields: {
        name: {
            validate: (0, $geP65.assertValueType)("string")
        },
        in: {
            validate: (0, $geP65.assertValueType)("boolean"),
            optional: true
        },
        out: {
            validate: (0, $geP65.assertValueType)("boolean"),
            optional: true
        },
        const: {
            validate: (0, $geP65.assertValueType)("boolean"),
            optional: true
        },
        constraint: {
            validate: (0, $geP65.assertNodeType)("TSType"),
            optional: true
        },
        default: {
            validate: (0, $geP65.assertNodeType)("TSType"),
            optional: true
        }
    }
});

});

parcelRegister("21Mfp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DEPRECATED_ALIASES = void 0;
const $17a119b7e88e0088$var$DEPRECATED_ALIASES = module.exports.DEPRECATED_ALIASES = {
    ModuleDeclaration: "ImportOrExportDeclaration"
};

});







parcelRegister("kUBOR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f3965fc1bf08160f$var$assertNode;

var $2PW0u = parcelRequire("2PW0u");
function $f3965fc1bf08160f$var$assertNode(node) {
    if (!(0, $2PW0u.default)(node)) {
        var _node$type;
        const type = (_node$type = node == null ? void 0 : node.type) != null ? _node$type : JSON.stringify(node);
        throw new TypeError(`Not a valid node of type "${type}"`);
    }
}

});
parcelRegister("2PW0u", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $210d57244c41a03f$var$isNode;

var $7TNHg = parcelRequire("7TNHg");
function $210d57244c41a03f$var$isNode(node) {
    return !!(node && $7TNHg.VISITOR_KEYS[node.type]);
}

});


parcelRegister("3QfFw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.assertAccessor = $2cc261e9204aa0d7$var$assertAccessor;
module.exports.assertAnyTypeAnnotation = $2cc261e9204aa0d7$var$assertAnyTypeAnnotation;
module.exports.assertArgumentPlaceholder = $2cc261e9204aa0d7$var$assertArgumentPlaceholder;
module.exports.assertArrayExpression = $2cc261e9204aa0d7$var$assertArrayExpression;
module.exports.assertArrayPattern = $2cc261e9204aa0d7$var$assertArrayPattern;
module.exports.assertArrayTypeAnnotation = $2cc261e9204aa0d7$var$assertArrayTypeAnnotation;
module.exports.assertArrowFunctionExpression = $2cc261e9204aa0d7$var$assertArrowFunctionExpression;
module.exports.assertAssignmentExpression = $2cc261e9204aa0d7$var$assertAssignmentExpression;
module.exports.assertAssignmentPattern = $2cc261e9204aa0d7$var$assertAssignmentPattern;
module.exports.assertAwaitExpression = $2cc261e9204aa0d7$var$assertAwaitExpression;
module.exports.assertBigIntLiteral = $2cc261e9204aa0d7$var$assertBigIntLiteral;
module.exports.assertBinary = $2cc261e9204aa0d7$var$assertBinary;
module.exports.assertBinaryExpression = $2cc261e9204aa0d7$var$assertBinaryExpression;
module.exports.assertBindExpression = $2cc261e9204aa0d7$var$assertBindExpression;
module.exports.assertBlock = $2cc261e9204aa0d7$var$assertBlock;
module.exports.assertBlockParent = $2cc261e9204aa0d7$var$assertBlockParent;
module.exports.assertBlockStatement = $2cc261e9204aa0d7$var$assertBlockStatement;
module.exports.assertBooleanLiteral = $2cc261e9204aa0d7$var$assertBooleanLiteral;
module.exports.assertBooleanLiteralTypeAnnotation = $2cc261e9204aa0d7$var$assertBooleanLiteralTypeAnnotation;
module.exports.assertBooleanTypeAnnotation = $2cc261e9204aa0d7$var$assertBooleanTypeAnnotation;
module.exports.assertBreakStatement = $2cc261e9204aa0d7$var$assertBreakStatement;
module.exports.assertCallExpression = $2cc261e9204aa0d7$var$assertCallExpression;
module.exports.assertCatchClause = $2cc261e9204aa0d7$var$assertCatchClause;
module.exports.assertClass = $2cc261e9204aa0d7$var$assertClass;
module.exports.assertClassAccessorProperty = $2cc261e9204aa0d7$var$assertClassAccessorProperty;
module.exports.assertClassBody = $2cc261e9204aa0d7$var$assertClassBody;
module.exports.assertClassDeclaration = $2cc261e9204aa0d7$var$assertClassDeclaration;
module.exports.assertClassExpression = $2cc261e9204aa0d7$var$assertClassExpression;
module.exports.assertClassImplements = $2cc261e9204aa0d7$var$assertClassImplements;
module.exports.assertClassMethod = $2cc261e9204aa0d7$var$assertClassMethod;
module.exports.assertClassPrivateMethod = $2cc261e9204aa0d7$var$assertClassPrivateMethod;
module.exports.assertClassPrivateProperty = $2cc261e9204aa0d7$var$assertClassPrivateProperty;
module.exports.assertClassProperty = $2cc261e9204aa0d7$var$assertClassProperty;
module.exports.assertCompletionStatement = $2cc261e9204aa0d7$var$assertCompletionStatement;
module.exports.assertConditional = $2cc261e9204aa0d7$var$assertConditional;
module.exports.assertConditionalExpression = $2cc261e9204aa0d7$var$assertConditionalExpression;
module.exports.assertContinueStatement = $2cc261e9204aa0d7$var$assertContinueStatement;
module.exports.assertDebuggerStatement = $2cc261e9204aa0d7$var$assertDebuggerStatement;
module.exports.assertDecimalLiteral = $2cc261e9204aa0d7$var$assertDecimalLiteral;
module.exports.assertDeclaration = $2cc261e9204aa0d7$var$assertDeclaration;
module.exports.assertDeclareClass = $2cc261e9204aa0d7$var$assertDeclareClass;
module.exports.assertDeclareExportAllDeclaration = $2cc261e9204aa0d7$var$assertDeclareExportAllDeclaration;
module.exports.assertDeclareExportDeclaration = $2cc261e9204aa0d7$var$assertDeclareExportDeclaration;
module.exports.assertDeclareFunction = $2cc261e9204aa0d7$var$assertDeclareFunction;
module.exports.assertDeclareInterface = $2cc261e9204aa0d7$var$assertDeclareInterface;
module.exports.assertDeclareModule = $2cc261e9204aa0d7$var$assertDeclareModule;
module.exports.assertDeclareModuleExports = $2cc261e9204aa0d7$var$assertDeclareModuleExports;
module.exports.assertDeclareOpaqueType = $2cc261e9204aa0d7$var$assertDeclareOpaqueType;
module.exports.assertDeclareTypeAlias = $2cc261e9204aa0d7$var$assertDeclareTypeAlias;
module.exports.assertDeclareVariable = $2cc261e9204aa0d7$var$assertDeclareVariable;
module.exports.assertDeclaredPredicate = $2cc261e9204aa0d7$var$assertDeclaredPredicate;
module.exports.assertDecorator = $2cc261e9204aa0d7$var$assertDecorator;
module.exports.assertDirective = $2cc261e9204aa0d7$var$assertDirective;
module.exports.assertDirectiveLiteral = $2cc261e9204aa0d7$var$assertDirectiveLiteral;
module.exports.assertDoExpression = $2cc261e9204aa0d7$var$assertDoExpression;
module.exports.assertDoWhileStatement = $2cc261e9204aa0d7$var$assertDoWhileStatement;
module.exports.assertEmptyStatement = $2cc261e9204aa0d7$var$assertEmptyStatement;
module.exports.assertEmptyTypeAnnotation = $2cc261e9204aa0d7$var$assertEmptyTypeAnnotation;
module.exports.assertEnumBody = $2cc261e9204aa0d7$var$assertEnumBody;
module.exports.assertEnumBooleanBody = $2cc261e9204aa0d7$var$assertEnumBooleanBody;
module.exports.assertEnumBooleanMember = $2cc261e9204aa0d7$var$assertEnumBooleanMember;
module.exports.assertEnumDeclaration = $2cc261e9204aa0d7$var$assertEnumDeclaration;
module.exports.assertEnumDefaultedMember = $2cc261e9204aa0d7$var$assertEnumDefaultedMember;
module.exports.assertEnumMember = $2cc261e9204aa0d7$var$assertEnumMember;
module.exports.assertEnumNumberBody = $2cc261e9204aa0d7$var$assertEnumNumberBody;
module.exports.assertEnumNumberMember = $2cc261e9204aa0d7$var$assertEnumNumberMember;
module.exports.assertEnumStringBody = $2cc261e9204aa0d7$var$assertEnumStringBody;
module.exports.assertEnumStringMember = $2cc261e9204aa0d7$var$assertEnumStringMember;
module.exports.assertEnumSymbolBody = $2cc261e9204aa0d7$var$assertEnumSymbolBody;
module.exports.assertExistsTypeAnnotation = $2cc261e9204aa0d7$var$assertExistsTypeAnnotation;
module.exports.assertExportAllDeclaration = $2cc261e9204aa0d7$var$assertExportAllDeclaration;
module.exports.assertExportDeclaration = $2cc261e9204aa0d7$var$assertExportDeclaration;
module.exports.assertExportDefaultDeclaration = $2cc261e9204aa0d7$var$assertExportDefaultDeclaration;
module.exports.assertExportDefaultSpecifier = $2cc261e9204aa0d7$var$assertExportDefaultSpecifier;
module.exports.assertExportNamedDeclaration = $2cc261e9204aa0d7$var$assertExportNamedDeclaration;
module.exports.assertExportNamespaceSpecifier = $2cc261e9204aa0d7$var$assertExportNamespaceSpecifier;
module.exports.assertExportSpecifier = $2cc261e9204aa0d7$var$assertExportSpecifier;
module.exports.assertExpression = $2cc261e9204aa0d7$var$assertExpression;
module.exports.assertExpressionStatement = $2cc261e9204aa0d7$var$assertExpressionStatement;
module.exports.assertExpressionWrapper = $2cc261e9204aa0d7$var$assertExpressionWrapper;
module.exports.assertFile = $2cc261e9204aa0d7$var$assertFile;
module.exports.assertFlow = $2cc261e9204aa0d7$var$assertFlow;
module.exports.assertFlowBaseAnnotation = $2cc261e9204aa0d7$var$assertFlowBaseAnnotation;
module.exports.assertFlowDeclaration = $2cc261e9204aa0d7$var$assertFlowDeclaration;
module.exports.assertFlowPredicate = $2cc261e9204aa0d7$var$assertFlowPredicate;
module.exports.assertFlowType = $2cc261e9204aa0d7$var$assertFlowType;
module.exports.assertFor = $2cc261e9204aa0d7$var$assertFor;
module.exports.assertForInStatement = $2cc261e9204aa0d7$var$assertForInStatement;
module.exports.assertForOfStatement = $2cc261e9204aa0d7$var$assertForOfStatement;
module.exports.assertForStatement = $2cc261e9204aa0d7$var$assertForStatement;
module.exports.assertForXStatement = $2cc261e9204aa0d7$var$assertForXStatement;
module.exports.assertFunction = $2cc261e9204aa0d7$var$assertFunction;
module.exports.assertFunctionDeclaration = $2cc261e9204aa0d7$var$assertFunctionDeclaration;
module.exports.assertFunctionExpression = $2cc261e9204aa0d7$var$assertFunctionExpression;
module.exports.assertFunctionParent = $2cc261e9204aa0d7$var$assertFunctionParent;
module.exports.assertFunctionTypeAnnotation = $2cc261e9204aa0d7$var$assertFunctionTypeAnnotation;
module.exports.assertFunctionTypeParam = $2cc261e9204aa0d7$var$assertFunctionTypeParam;
module.exports.assertGenericTypeAnnotation = $2cc261e9204aa0d7$var$assertGenericTypeAnnotation;
module.exports.assertIdentifier = $2cc261e9204aa0d7$var$assertIdentifier;
module.exports.assertIfStatement = $2cc261e9204aa0d7$var$assertIfStatement;
module.exports.assertImmutable = $2cc261e9204aa0d7$var$assertImmutable;
module.exports.assertImport = $2cc261e9204aa0d7$var$assertImport;
module.exports.assertImportAttribute = $2cc261e9204aa0d7$var$assertImportAttribute;
module.exports.assertImportDeclaration = $2cc261e9204aa0d7$var$assertImportDeclaration;
module.exports.assertImportDefaultSpecifier = $2cc261e9204aa0d7$var$assertImportDefaultSpecifier;
module.exports.assertImportExpression = $2cc261e9204aa0d7$var$assertImportExpression;
module.exports.assertImportNamespaceSpecifier = $2cc261e9204aa0d7$var$assertImportNamespaceSpecifier;
module.exports.assertImportOrExportDeclaration = $2cc261e9204aa0d7$var$assertImportOrExportDeclaration;
module.exports.assertImportSpecifier = $2cc261e9204aa0d7$var$assertImportSpecifier;
module.exports.assertIndexedAccessType = $2cc261e9204aa0d7$var$assertIndexedAccessType;
module.exports.assertInferredPredicate = $2cc261e9204aa0d7$var$assertInferredPredicate;
module.exports.assertInterfaceDeclaration = $2cc261e9204aa0d7$var$assertInterfaceDeclaration;
module.exports.assertInterfaceExtends = $2cc261e9204aa0d7$var$assertInterfaceExtends;
module.exports.assertInterfaceTypeAnnotation = $2cc261e9204aa0d7$var$assertInterfaceTypeAnnotation;
module.exports.assertInterpreterDirective = $2cc261e9204aa0d7$var$assertInterpreterDirective;
module.exports.assertIntersectionTypeAnnotation = $2cc261e9204aa0d7$var$assertIntersectionTypeAnnotation;
module.exports.assertJSX = $2cc261e9204aa0d7$var$assertJSX;
module.exports.assertJSXAttribute = $2cc261e9204aa0d7$var$assertJSXAttribute;
module.exports.assertJSXClosingElement = $2cc261e9204aa0d7$var$assertJSXClosingElement;
module.exports.assertJSXClosingFragment = $2cc261e9204aa0d7$var$assertJSXClosingFragment;
module.exports.assertJSXElement = $2cc261e9204aa0d7$var$assertJSXElement;
module.exports.assertJSXEmptyExpression = $2cc261e9204aa0d7$var$assertJSXEmptyExpression;
module.exports.assertJSXExpressionContainer = $2cc261e9204aa0d7$var$assertJSXExpressionContainer;
module.exports.assertJSXFragment = $2cc261e9204aa0d7$var$assertJSXFragment;
module.exports.assertJSXIdentifier = $2cc261e9204aa0d7$var$assertJSXIdentifier;
module.exports.assertJSXMemberExpression = $2cc261e9204aa0d7$var$assertJSXMemberExpression;
module.exports.assertJSXNamespacedName = $2cc261e9204aa0d7$var$assertJSXNamespacedName;
module.exports.assertJSXOpeningElement = $2cc261e9204aa0d7$var$assertJSXOpeningElement;
module.exports.assertJSXOpeningFragment = $2cc261e9204aa0d7$var$assertJSXOpeningFragment;
module.exports.assertJSXSpreadAttribute = $2cc261e9204aa0d7$var$assertJSXSpreadAttribute;
module.exports.assertJSXSpreadChild = $2cc261e9204aa0d7$var$assertJSXSpreadChild;
module.exports.assertJSXText = $2cc261e9204aa0d7$var$assertJSXText;
module.exports.assertLVal = $2cc261e9204aa0d7$var$assertLVal;
module.exports.assertLabeledStatement = $2cc261e9204aa0d7$var$assertLabeledStatement;
module.exports.assertLiteral = $2cc261e9204aa0d7$var$assertLiteral;
module.exports.assertLogicalExpression = $2cc261e9204aa0d7$var$assertLogicalExpression;
module.exports.assertLoop = $2cc261e9204aa0d7$var$assertLoop;
module.exports.assertMemberExpression = $2cc261e9204aa0d7$var$assertMemberExpression;
module.exports.assertMetaProperty = $2cc261e9204aa0d7$var$assertMetaProperty;
module.exports.assertMethod = $2cc261e9204aa0d7$var$assertMethod;
module.exports.assertMiscellaneous = $2cc261e9204aa0d7$var$assertMiscellaneous;
module.exports.assertMixedTypeAnnotation = $2cc261e9204aa0d7$var$assertMixedTypeAnnotation;
module.exports.assertModuleDeclaration = $2cc261e9204aa0d7$var$assertModuleDeclaration;
module.exports.assertModuleExpression = $2cc261e9204aa0d7$var$assertModuleExpression;
module.exports.assertModuleSpecifier = $2cc261e9204aa0d7$var$assertModuleSpecifier;
module.exports.assertNewExpression = $2cc261e9204aa0d7$var$assertNewExpression;
module.exports.assertNoop = $2cc261e9204aa0d7$var$assertNoop;
module.exports.assertNullLiteral = $2cc261e9204aa0d7$var$assertNullLiteral;
module.exports.assertNullLiteralTypeAnnotation = $2cc261e9204aa0d7$var$assertNullLiteralTypeAnnotation;
module.exports.assertNullableTypeAnnotation = $2cc261e9204aa0d7$var$assertNullableTypeAnnotation;
module.exports.assertNumberLiteral = $2cc261e9204aa0d7$var$assertNumberLiteral;
module.exports.assertNumberLiteralTypeAnnotation = $2cc261e9204aa0d7$var$assertNumberLiteralTypeAnnotation;
module.exports.assertNumberTypeAnnotation = $2cc261e9204aa0d7$var$assertNumberTypeAnnotation;
module.exports.assertNumericLiteral = $2cc261e9204aa0d7$var$assertNumericLiteral;
module.exports.assertObjectExpression = $2cc261e9204aa0d7$var$assertObjectExpression;
module.exports.assertObjectMember = $2cc261e9204aa0d7$var$assertObjectMember;
module.exports.assertObjectMethod = $2cc261e9204aa0d7$var$assertObjectMethod;
module.exports.assertObjectPattern = $2cc261e9204aa0d7$var$assertObjectPattern;
module.exports.assertObjectProperty = $2cc261e9204aa0d7$var$assertObjectProperty;
module.exports.assertObjectTypeAnnotation = $2cc261e9204aa0d7$var$assertObjectTypeAnnotation;
module.exports.assertObjectTypeCallProperty = $2cc261e9204aa0d7$var$assertObjectTypeCallProperty;
module.exports.assertObjectTypeIndexer = $2cc261e9204aa0d7$var$assertObjectTypeIndexer;
module.exports.assertObjectTypeInternalSlot = $2cc261e9204aa0d7$var$assertObjectTypeInternalSlot;
module.exports.assertObjectTypeProperty = $2cc261e9204aa0d7$var$assertObjectTypeProperty;
module.exports.assertObjectTypeSpreadProperty = $2cc261e9204aa0d7$var$assertObjectTypeSpreadProperty;
module.exports.assertOpaqueType = $2cc261e9204aa0d7$var$assertOpaqueType;
module.exports.assertOptionalCallExpression = $2cc261e9204aa0d7$var$assertOptionalCallExpression;
module.exports.assertOptionalIndexedAccessType = $2cc261e9204aa0d7$var$assertOptionalIndexedAccessType;
module.exports.assertOptionalMemberExpression = $2cc261e9204aa0d7$var$assertOptionalMemberExpression;
module.exports.assertParenthesizedExpression = $2cc261e9204aa0d7$var$assertParenthesizedExpression;
module.exports.assertPattern = $2cc261e9204aa0d7$var$assertPattern;
module.exports.assertPatternLike = $2cc261e9204aa0d7$var$assertPatternLike;
module.exports.assertPipelineBareFunction = $2cc261e9204aa0d7$var$assertPipelineBareFunction;
module.exports.assertPipelinePrimaryTopicReference = $2cc261e9204aa0d7$var$assertPipelinePrimaryTopicReference;
module.exports.assertPipelineTopicExpression = $2cc261e9204aa0d7$var$assertPipelineTopicExpression;
module.exports.assertPlaceholder = $2cc261e9204aa0d7$var$assertPlaceholder;
module.exports.assertPrivate = $2cc261e9204aa0d7$var$assertPrivate;
module.exports.assertPrivateName = $2cc261e9204aa0d7$var$assertPrivateName;
module.exports.assertProgram = $2cc261e9204aa0d7$var$assertProgram;
module.exports.assertProperty = $2cc261e9204aa0d7$var$assertProperty;
module.exports.assertPureish = $2cc261e9204aa0d7$var$assertPureish;
module.exports.assertQualifiedTypeIdentifier = $2cc261e9204aa0d7$var$assertQualifiedTypeIdentifier;
module.exports.assertRecordExpression = $2cc261e9204aa0d7$var$assertRecordExpression;
module.exports.assertRegExpLiteral = $2cc261e9204aa0d7$var$assertRegExpLiteral;
module.exports.assertRegexLiteral = $2cc261e9204aa0d7$var$assertRegexLiteral;
module.exports.assertRestElement = $2cc261e9204aa0d7$var$assertRestElement;
module.exports.assertRestProperty = $2cc261e9204aa0d7$var$assertRestProperty;
module.exports.assertReturnStatement = $2cc261e9204aa0d7$var$assertReturnStatement;
module.exports.assertScopable = $2cc261e9204aa0d7$var$assertScopable;
module.exports.assertSequenceExpression = $2cc261e9204aa0d7$var$assertSequenceExpression;
module.exports.assertSpreadElement = $2cc261e9204aa0d7$var$assertSpreadElement;
module.exports.assertSpreadProperty = $2cc261e9204aa0d7$var$assertSpreadProperty;
module.exports.assertStandardized = $2cc261e9204aa0d7$var$assertStandardized;
module.exports.assertStatement = $2cc261e9204aa0d7$var$assertStatement;
module.exports.assertStaticBlock = $2cc261e9204aa0d7$var$assertStaticBlock;
module.exports.assertStringLiteral = $2cc261e9204aa0d7$var$assertStringLiteral;
module.exports.assertStringLiteralTypeAnnotation = $2cc261e9204aa0d7$var$assertStringLiteralTypeAnnotation;
module.exports.assertStringTypeAnnotation = $2cc261e9204aa0d7$var$assertStringTypeAnnotation;
module.exports.assertSuper = $2cc261e9204aa0d7$var$assertSuper;
module.exports.assertSwitchCase = $2cc261e9204aa0d7$var$assertSwitchCase;
module.exports.assertSwitchStatement = $2cc261e9204aa0d7$var$assertSwitchStatement;
module.exports.assertSymbolTypeAnnotation = $2cc261e9204aa0d7$var$assertSymbolTypeAnnotation;
module.exports.assertTSAnyKeyword = $2cc261e9204aa0d7$var$assertTSAnyKeyword;
module.exports.assertTSArrayType = $2cc261e9204aa0d7$var$assertTSArrayType;
module.exports.assertTSAsExpression = $2cc261e9204aa0d7$var$assertTSAsExpression;
module.exports.assertTSBaseType = $2cc261e9204aa0d7$var$assertTSBaseType;
module.exports.assertTSBigIntKeyword = $2cc261e9204aa0d7$var$assertTSBigIntKeyword;
module.exports.assertTSBooleanKeyword = $2cc261e9204aa0d7$var$assertTSBooleanKeyword;
module.exports.assertTSCallSignatureDeclaration = $2cc261e9204aa0d7$var$assertTSCallSignatureDeclaration;
module.exports.assertTSConditionalType = $2cc261e9204aa0d7$var$assertTSConditionalType;
module.exports.assertTSConstructSignatureDeclaration = $2cc261e9204aa0d7$var$assertTSConstructSignatureDeclaration;
module.exports.assertTSConstructorType = $2cc261e9204aa0d7$var$assertTSConstructorType;
module.exports.assertTSDeclareFunction = $2cc261e9204aa0d7$var$assertTSDeclareFunction;
module.exports.assertTSDeclareMethod = $2cc261e9204aa0d7$var$assertTSDeclareMethod;
module.exports.assertTSEntityName = $2cc261e9204aa0d7$var$assertTSEntityName;
module.exports.assertTSEnumDeclaration = $2cc261e9204aa0d7$var$assertTSEnumDeclaration;
module.exports.assertTSEnumMember = $2cc261e9204aa0d7$var$assertTSEnumMember;
module.exports.assertTSExportAssignment = $2cc261e9204aa0d7$var$assertTSExportAssignment;
module.exports.assertTSExpressionWithTypeArguments = $2cc261e9204aa0d7$var$assertTSExpressionWithTypeArguments;
module.exports.assertTSExternalModuleReference = $2cc261e9204aa0d7$var$assertTSExternalModuleReference;
module.exports.assertTSFunctionType = $2cc261e9204aa0d7$var$assertTSFunctionType;
module.exports.assertTSImportEqualsDeclaration = $2cc261e9204aa0d7$var$assertTSImportEqualsDeclaration;
module.exports.assertTSImportType = $2cc261e9204aa0d7$var$assertTSImportType;
module.exports.assertTSIndexSignature = $2cc261e9204aa0d7$var$assertTSIndexSignature;
module.exports.assertTSIndexedAccessType = $2cc261e9204aa0d7$var$assertTSIndexedAccessType;
module.exports.assertTSInferType = $2cc261e9204aa0d7$var$assertTSInferType;
module.exports.assertTSInstantiationExpression = $2cc261e9204aa0d7$var$assertTSInstantiationExpression;
module.exports.assertTSInterfaceBody = $2cc261e9204aa0d7$var$assertTSInterfaceBody;
module.exports.assertTSInterfaceDeclaration = $2cc261e9204aa0d7$var$assertTSInterfaceDeclaration;
module.exports.assertTSIntersectionType = $2cc261e9204aa0d7$var$assertTSIntersectionType;
module.exports.assertTSIntrinsicKeyword = $2cc261e9204aa0d7$var$assertTSIntrinsicKeyword;
module.exports.assertTSLiteralType = $2cc261e9204aa0d7$var$assertTSLiteralType;
module.exports.assertTSMappedType = $2cc261e9204aa0d7$var$assertTSMappedType;
module.exports.assertTSMethodSignature = $2cc261e9204aa0d7$var$assertTSMethodSignature;
module.exports.assertTSModuleBlock = $2cc261e9204aa0d7$var$assertTSModuleBlock;
module.exports.assertTSModuleDeclaration = $2cc261e9204aa0d7$var$assertTSModuleDeclaration;
module.exports.assertTSNamedTupleMember = $2cc261e9204aa0d7$var$assertTSNamedTupleMember;
module.exports.assertTSNamespaceExportDeclaration = $2cc261e9204aa0d7$var$assertTSNamespaceExportDeclaration;
module.exports.assertTSNeverKeyword = $2cc261e9204aa0d7$var$assertTSNeverKeyword;
module.exports.assertTSNonNullExpression = $2cc261e9204aa0d7$var$assertTSNonNullExpression;
module.exports.assertTSNullKeyword = $2cc261e9204aa0d7$var$assertTSNullKeyword;
module.exports.assertTSNumberKeyword = $2cc261e9204aa0d7$var$assertTSNumberKeyword;
module.exports.assertTSObjectKeyword = $2cc261e9204aa0d7$var$assertTSObjectKeyword;
module.exports.assertTSOptionalType = $2cc261e9204aa0d7$var$assertTSOptionalType;
module.exports.assertTSParameterProperty = $2cc261e9204aa0d7$var$assertTSParameterProperty;
module.exports.assertTSParenthesizedType = $2cc261e9204aa0d7$var$assertTSParenthesizedType;
module.exports.assertTSPropertySignature = $2cc261e9204aa0d7$var$assertTSPropertySignature;
module.exports.assertTSQualifiedName = $2cc261e9204aa0d7$var$assertTSQualifiedName;
module.exports.assertTSRestType = $2cc261e9204aa0d7$var$assertTSRestType;
module.exports.assertTSSatisfiesExpression = $2cc261e9204aa0d7$var$assertTSSatisfiesExpression;
module.exports.assertTSStringKeyword = $2cc261e9204aa0d7$var$assertTSStringKeyword;
module.exports.assertTSSymbolKeyword = $2cc261e9204aa0d7$var$assertTSSymbolKeyword;
module.exports.assertTSThisType = $2cc261e9204aa0d7$var$assertTSThisType;
module.exports.assertTSTupleType = $2cc261e9204aa0d7$var$assertTSTupleType;
module.exports.assertTSType = $2cc261e9204aa0d7$var$assertTSType;
module.exports.assertTSTypeAliasDeclaration = $2cc261e9204aa0d7$var$assertTSTypeAliasDeclaration;
module.exports.assertTSTypeAnnotation = $2cc261e9204aa0d7$var$assertTSTypeAnnotation;
module.exports.assertTSTypeAssertion = $2cc261e9204aa0d7$var$assertTSTypeAssertion;
module.exports.assertTSTypeElement = $2cc261e9204aa0d7$var$assertTSTypeElement;
module.exports.assertTSTypeLiteral = $2cc261e9204aa0d7$var$assertTSTypeLiteral;
module.exports.assertTSTypeOperator = $2cc261e9204aa0d7$var$assertTSTypeOperator;
module.exports.assertTSTypeParameter = $2cc261e9204aa0d7$var$assertTSTypeParameter;
module.exports.assertTSTypeParameterDeclaration = $2cc261e9204aa0d7$var$assertTSTypeParameterDeclaration;
module.exports.assertTSTypeParameterInstantiation = $2cc261e9204aa0d7$var$assertTSTypeParameterInstantiation;
module.exports.assertTSTypePredicate = $2cc261e9204aa0d7$var$assertTSTypePredicate;
module.exports.assertTSTypeQuery = $2cc261e9204aa0d7$var$assertTSTypeQuery;
module.exports.assertTSTypeReference = $2cc261e9204aa0d7$var$assertTSTypeReference;
module.exports.assertTSUndefinedKeyword = $2cc261e9204aa0d7$var$assertTSUndefinedKeyword;
module.exports.assertTSUnionType = $2cc261e9204aa0d7$var$assertTSUnionType;
module.exports.assertTSUnknownKeyword = $2cc261e9204aa0d7$var$assertTSUnknownKeyword;
module.exports.assertTSVoidKeyword = $2cc261e9204aa0d7$var$assertTSVoidKeyword;
module.exports.assertTaggedTemplateExpression = $2cc261e9204aa0d7$var$assertTaggedTemplateExpression;
module.exports.assertTemplateElement = $2cc261e9204aa0d7$var$assertTemplateElement;
module.exports.assertTemplateLiteral = $2cc261e9204aa0d7$var$assertTemplateLiteral;
module.exports.assertTerminatorless = $2cc261e9204aa0d7$var$assertTerminatorless;
module.exports.assertThisExpression = $2cc261e9204aa0d7$var$assertThisExpression;
module.exports.assertThisTypeAnnotation = $2cc261e9204aa0d7$var$assertThisTypeAnnotation;
module.exports.assertThrowStatement = $2cc261e9204aa0d7$var$assertThrowStatement;
module.exports.assertTopicReference = $2cc261e9204aa0d7$var$assertTopicReference;
module.exports.assertTryStatement = $2cc261e9204aa0d7$var$assertTryStatement;
module.exports.assertTupleExpression = $2cc261e9204aa0d7$var$assertTupleExpression;
module.exports.assertTupleTypeAnnotation = $2cc261e9204aa0d7$var$assertTupleTypeAnnotation;
module.exports.assertTypeAlias = $2cc261e9204aa0d7$var$assertTypeAlias;
module.exports.assertTypeAnnotation = $2cc261e9204aa0d7$var$assertTypeAnnotation;
module.exports.assertTypeCastExpression = $2cc261e9204aa0d7$var$assertTypeCastExpression;
module.exports.assertTypeParameter = $2cc261e9204aa0d7$var$assertTypeParameter;
module.exports.assertTypeParameterDeclaration = $2cc261e9204aa0d7$var$assertTypeParameterDeclaration;
module.exports.assertTypeParameterInstantiation = $2cc261e9204aa0d7$var$assertTypeParameterInstantiation;
module.exports.assertTypeScript = $2cc261e9204aa0d7$var$assertTypeScript;
module.exports.assertTypeofTypeAnnotation = $2cc261e9204aa0d7$var$assertTypeofTypeAnnotation;
module.exports.assertUnaryExpression = $2cc261e9204aa0d7$var$assertUnaryExpression;
module.exports.assertUnaryLike = $2cc261e9204aa0d7$var$assertUnaryLike;
module.exports.assertUnionTypeAnnotation = $2cc261e9204aa0d7$var$assertUnionTypeAnnotation;
module.exports.assertUpdateExpression = $2cc261e9204aa0d7$var$assertUpdateExpression;
module.exports.assertUserWhitespacable = $2cc261e9204aa0d7$var$assertUserWhitespacable;
module.exports.assertV8IntrinsicIdentifier = $2cc261e9204aa0d7$var$assertV8IntrinsicIdentifier;
module.exports.assertVariableDeclaration = $2cc261e9204aa0d7$var$assertVariableDeclaration;
module.exports.assertVariableDeclarator = $2cc261e9204aa0d7$var$assertVariableDeclarator;
module.exports.assertVariance = $2cc261e9204aa0d7$var$assertVariance;
module.exports.assertVoidTypeAnnotation = $2cc261e9204aa0d7$var$assertVoidTypeAnnotation;
module.exports.assertWhile = $2cc261e9204aa0d7$var$assertWhile;
module.exports.assertWhileStatement = $2cc261e9204aa0d7$var$assertWhileStatement;
module.exports.assertWithStatement = $2cc261e9204aa0d7$var$assertWithStatement;
module.exports.assertYieldExpression = $2cc261e9204aa0d7$var$assertYieldExpression;

var $4XzLl = parcelRequire("4XzLl");

var $7sVNt = parcelRequire("7sVNt");
function $2cc261e9204aa0d7$var$assert(type, node, opts) {
    if (!(0, $4XzLl.default)(type, node, opts)) throw new Error(`Expected type "${type}" with option ${JSON.stringify(opts)}, ` + `but instead got "${node.type}".`);
}
function $2cc261e9204aa0d7$var$assertArrayExpression(node, opts) {
    $2cc261e9204aa0d7$var$assert("ArrayExpression", node, opts);
}
function $2cc261e9204aa0d7$var$assertAssignmentExpression(node, opts) {
    $2cc261e9204aa0d7$var$assert("AssignmentExpression", node, opts);
}
function $2cc261e9204aa0d7$var$assertBinaryExpression(node, opts) {
    $2cc261e9204aa0d7$var$assert("BinaryExpression", node, opts);
}
function $2cc261e9204aa0d7$var$assertInterpreterDirective(node, opts) {
    $2cc261e9204aa0d7$var$assert("InterpreterDirective", node, opts);
}
function $2cc261e9204aa0d7$var$assertDirective(node, opts) {
    $2cc261e9204aa0d7$var$assert("Directive", node, opts);
}
function $2cc261e9204aa0d7$var$assertDirectiveLiteral(node, opts) {
    $2cc261e9204aa0d7$var$assert("DirectiveLiteral", node, opts);
}
function $2cc261e9204aa0d7$var$assertBlockStatement(node, opts) {
    $2cc261e9204aa0d7$var$assert("BlockStatement", node, opts);
}
function $2cc261e9204aa0d7$var$assertBreakStatement(node, opts) {
    $2cc261e9204aa0d7$var$assert("BreakStatement", node, opts);
}
function $2cc261e9204aa0d7$var$assertCallExpression(node, opts) {
    $2cc261e9204aa0d7$var$assert("CallExpression", node, opts);
}
function $2cc261e9204aa0d7$var$assertCatchClause(node, opts) {
    $2cc261e9204aa0d7$var$assert("CatchClause", node, opts);
}
function $2cc261e9204aa0d7$var$assertConditionalExpression(node, opts) {
    $2cc261e9204aa0d7$var$assert("ConditionalExpression", node, opts);
}
function $2cc261e9204aa0d7$var$assertContinueStatement(node, opts) {
    $2cc261e9204aa0d7$var$assert("ContinueStatement", node, opts);
}
function $2cc261e9204aa0d7$var$assertDebuggerStatement(node, opts) {
    $2cc261e9204aa0d7$var$assert("DebuggerStatement", node, opts);
}
function $2cc261e9204aa0d7$var$assertDoWhileStatement(node, opts) {
    $2cc261e9204aa0d7$var$assert("DoWhileStatement", node, opts);
}
function $2cc261e9204aa0d7$var$assertEmptyStatement(node, opts) {
    $2cc261e9204aa0d7$var$assert("EmptyStatement", node, opts);
}
function $2cc261e9204aa0d7$var$assertExpressionStatement(node, opts) {
    $2cc261e9204aa0d7$var$assert("ExpressionStatement", node, opts);
}
function $2cc261e9204aa0d7$var$assertFile(node, opts) {
    $2cc261e9204aa0d7$var$assert("File", node, opts);
}
function $2cc261e9204aa0d7$var$assertForInStatement(node, opts) {
    $2cc261e9204aa0d7$var$assert("ForInStatement", node, opts);
}
function $2cc261e9204aa0d7$var$assertForStatement(node, opts) {
    $2cc261e9204aa0d7$var$assert("ForStatement", node, opts);
}
function $2cc261e9204aa0d7$var$assertFunctionDeclaration(node, opts) {
    $2cc261e9204aa0d7$var$assert("FunctionDeclaration", node, opts);
}
function $2cc261e9204aa0d7$var$assertFunctionExpression(node, opts) {
    $2cc261e9204aa0d7$var$assert("FunctionExpression", node, opts);
}
function $2cc261e9204aa0d7$var$assertIdentifier(node, opts) {
    $2cc261e9204aa0d7$var$assert("Identifier", node, opts);
}
function $2cc261e9204aa0d7$var$assertIfStatement(node, opts) {
    $2cc261e9204aa0d7$var$assert("IfStatement", node, opts);
}
function $2cc261e9204aa0d7$var$assertLabeledStatement(node, opts) {
    $2cc261e9204aa0d7$var$assert("LabeledStatement", node, opts);
}
function $2cc261e9204aa0d7$var$assertStringLiteral(node, opts) {
    $2cc261e9204aa0d7$var$assert("StringLiteral", node, opts);
}
function $2cc261e9204aa0d7$var$assertNumericLiteral(node, opts) {
    $2cc261e9204aa0d7$var$assert("NumericLiteral", node, opts);
}
function $2cc261e9204aa0d7$var$assertNullLiteral(node, opts) {
    $2cc261e9204aa0d7$var$assert("NullLiteral", node, opts);
}
function $2cc261e9204aa0d7$var$assertBooleanLiteral(node, opts) {
    $2cc261e9204aa0d7$var$assert("BooleanLiteral", node, opts);
}
function $2cc261e9204aa0d7$var$assertRegExpLiteral(node, opts) {
    $2cc261e9204aa0d7$var$assert("RegExpLiteral", node, opts);
}
function $2cc261e9204aa0d7$var$assertLogicalExpression(node, opts) {
    $2cc261e9204aa0d7$var$assert("LogicalExpression", node, opts);
}
function $2cc261e9204aa0d7$var$assertMemberExpression(node, opts) {
    $2cc261e9204aa0d7$var$assert("MemberExpression", node, opts);
}
function $2cc261e9204aa0d7$var$assertNewExpression(node, opts) {
    $2cc261e9204aa0d7$var$assert("NewExpression", node, opts);
}
function $2cc261e9204aa0d7$var$assertProgram(node, opts) {
    $2cc261e9204aa0d7$var$assert("Program", node, opts);
}
function $2cc261e9204aa0d7$var$assertObjectExpression(node, opts) {
    $2cc261e9204aa0d7$var$assert("ObjectExpression", node, opts);
}
function $2cc261e9204aa0d7$var$assertObjectMethod(node, opts) {
    $2cc261e9204aa0d7$var$assert("ObjectMethod", node, opts);
}
function $2cc261e9204aa0d7$var$assertObjectProperty(node, opts) {
    $2cc261e9204aa0d7$var$assert("ObjectProperty", node, opts);
}
function $2cc261e9204aa0d7$var$assertRestElement(node, opts) {
    $2cc261e9204aa0d7$var$assert("RestElement", node, opts);
}
function $2cc261e9204aa0d7$var$assertReturnStatement(node, opts) {
    $2cc261e9204aa0d7$var$assert("ReturnStatement", node, opts);
}
function $2cc261e9204aa0d7$var$assertSequenceExpression(node, opts) {
    $2cc261e9204aa0d7$var$assert("SequenceExpression", node, opts);
}
function $2cc261e9204aa0d7$var$assertParenthesizedExpression(node, opts) {
    $2cc261e9204aa0d7$var$assert("ParenthesizedExpression", node, opts);
}
function $2cc261e9204aa0d7$var$assertSwitchCase(node, opts) {
    $2cc261e9204aa0d7$var$assert("SwitchCase", node, opts);
}
function $2cc261e9204aa0d7$var$assertSwitchStatement(node, opts) {
    $2cc261e9204aa0d7$var$assert("SwitchStatement", node, opts);
}
function $2cc261e9204aa0d7$var$assertThisExpression(node, opts) {
    $2cc261e9204aa0d7$var$assert("ThisExpression", node, opts);
}
function $2cc261e9204aa0d7$var$assertThrowStatement(node, opts) {
    $2cc261e9204aa0d7$var$assert("ThrowStatement", node, opts);
}
function $2cc261e9204aa0d7$var$assertTryStatement(node, opts) {
    $2cc261e9204aa0d7$var$assert("TryStatement", node, opts);
}
function $2cc261e9204aa0d7$var$assertUnaryExpression(node, opts) {
    $2cc261e9204aa0d7$var$assert("UnaryExpression", node, opts);
}
function $2cc261e9204aa0d7$var$assertUpdateExpression(node, opts) {
    $2cc261e9204aa0d7$var$assert("UpdateExpression", node, opts);
}
function $2cc261e9204aa0d7$var$assertVariableDeclaration(node, opts) {
    $2cc261e9204aa0d7$var$assert("VariableDeclaration", node, opts);
}
function $2cc261e9204aa0d7$var$assertVariableDeclarator(node, opts) {
    $2cc261e9204aa0d7$var$assert("VariableDeclarator", node, opts);
}
function $2cc261e9204aa0d7$var$assertWhileStatement(node, opts) {
    $2cc261e9204aa0d7$var$assert("WhileStatement", node, opts);
}
function $2cc261e9204aa0d7$var$assertWithStatement(node, opts) {
    $2cc261e9204aa0d7$var$assert("WithStatement", node, opts);
}
function $2cc261e9204aa0d7$var$assertAssignmentPattern(node, opts) {
    $2cc261e9204aa0d7$var$assert("AssignmentPattern", node, opts);
}
function $2cc261e9204aa0d7$var$assertArrayPattern(node, opts) {
    $2cc261e9204aa0d7$var$assert("ArrayPattern", node, opts);
}
function $2cc261e9204aa0d7$var$assertArrowFunctionExpression(node, opts) {
    $2cc261e9204aa0d7$var$assert("ArrowFunctionExpression", node, opts);
}
function $2cc261e9204aa0d7$var$assertClassBody(node, opts) {
    $2cc261e9204aa0d7$var$assert("ClassBody", node, opts);
}
function $2cc261e9204aa0d7$var$assertClassExpression(node, opts) {
    $2cc261e9204aa0d7$var$assert("ClassExpression", node, opts);
}
function $2cc261e9204aa0d7$var$assertClassDeclaration(node, opts) {
    $2cc261e9204aa0d7$var$assert("ClassDeclaration", node, opts);
}
function $2cc261e9204aa0d7$var$assertExportAllDeclaration(node, opts) {
    $2cc261e9204aa0d7$var$assert("ExportAllDeclaration", node, opts);
}
function $2cc261e9204aa0d7$var$assertExportDefaultDeclaration(node, opts) {
    $2cc261e9204aa0d7$var$assert("ExportDefaultDeclaration", node, opts);
}
function $2cc261e9204aa0d7$var$assertExportNamedDeclaration(node, opts) {
    $2cc261e9204aa0d7$var$assert("ExportNamedDeclaration", node, opts);
}
function $2cc261e9204aa0d7$var$assertExportSpecifier(node, opts) {
    $2cc261e9204aa0d7$var$assert("ExportSpecifier", node, opts);
}
function $2cc261e9204aa0d7$var$assertForOfStatement(node, opts) {
    $2cc261e9204aa0d7$var$assert("ForOfStatement", node, opts);
}
function $2cc261e9204aa0d7$var$assertImportDeclaration(node, opts) {
    $2cc261e9204aa0d7$var$assert("ImportDeclaration", node, opts);
}
function $2cc261e9204aa0d7$var$assertImportDefaultSpecifier(node, opts) {
    $2cc261e9204aa0d7$var$assert("ImportDefaultSpecifier", node, opts);
}
function $2cc261e9204aa0d7$var$assertImportNamespaceSpecifier(node, opts) {
    $2cc261e9204aa0d7$var$assert("ImportNamespaceSpecifier", node, opts);
}
function $2cc261e9204aa0d7$var$assertImportSpecifier(node, opts) {
    $2cc261e9204aa0d7$var$assert("ImportSpecifier", node, opts);
}
function $2cc261e9204aa0d7$var$assertImportExpression(node, opts) {
    $2cc261e9204aa0d7$var$assert("ImportExpression", node, opts);
}
function $2cc261e9204aa0d7$var$assertMetaProperty(node, opts) {
    $2cc261e9204aa0d7$var$assert("MetaProperty", node, opts);
}
function $2cc261e9204aa0d7$var$assertClassMethod(node, opts) {
    $2cc261e9204aa0d7$var$assert("ClassMethod", node, opts);
}
function $2cc261e9204aa0d7$var$assertObjectPattern(node, opts) {
    $2cc261e9204aa0d7$var$assert("ObjectPattern", node, opts);
}
function $2cc261e9204aa0d7$var$assertSpreadElement(node, opts) {
    $2cc261e9204aa0d7$var$assert("SpreadElement", node, opts);
}
function $2cc261e9204aa0d7$var$assertSuper(node, opts) {
    $2cc261e9204aa0d7$var$assert("Super", node, opts);
}
function $2cc261e9204aa0d7$var$assertTaggedTemplateExpression(node, opts) {
    $2cc261e9204aa0d7$var$assert("TaggedTemplateExpression", node, opts);
}
function $2cc261e9204aa0d7$var$assertTemplateElement(node, opts) {
    $2cc261e9204aa0d7$var$assert("TemplateElement", node, opts);
}
function $2cc261e9204aa0d7$var$assertTemplateLiteral(node, opts) {
    $2cc261e9204aa0d7$var$assert("TemplateLiteral", node, opts);
}
function $2cc261e9204aa0d7$var$assertYieldExpression(node, opts) {
    $2cc261e9204aa0d7$var$assert("YieldExpression", node, opts);
}
function $2cc261e9204aa0d7$var$assertAwaitExpression(node, opts) {
    $2cc261e9204aa0d7$var$assert("AwaitExpression", node, opts);
}
function $2cc261e9204aa0d7$var$assertImport(node, opts) {
    $2cc261e9204aa0d7$var$assert("Import", node, opts);
}
function $2cc261e9204aa0d7$var$assertBigIntLiteral(node, opts) {
    $2cc261e9204aa0d7$var$assert("BigIntLiteral", node, opts);
}
function $2cc261e9204aa0d7$var$assertExportNamespaceSpecifier(node, opts) {
    $2cc261e9204aa0d7$var$assert("ExportNamespaceSpecifier", node, opts);
}
function $2cc261e9204aa0d7$var$assertOptionalMemberExpression(node, opts) {
    $2cc261e9204aa0d7$var$assert("OptionalMemberExpression", node, opts);
}
function $2cc261e9204aa0d7$var$assertOptionalCallExpression(node, opts) {
    $2cc261e9204aa0d7$var$assert("OptionalCallExpression", node, opts);
}
function $2cc261e9204aa0d7$var$assertClassProperty(node, opts) {
    $2cc261e9204aa0d7$var$assert("ClassProperty", node, opts);
}
function $2cc261e9204aa0d7$var$assertClassAccessorProperty(node, opts) {
    $2cc261e9204aa0d7$var$assert("ClassAccessorProperty", node, opts);
}
function $2cc261e9204aa0d7$var$assertClassPrivateProperty(node, opts) {
    $2cc261e9204aa0d7$var$assert("ClassPrivateProperty", node, opts);
}
function $2cc261e9204aa0d7$var$assertClassPrivateMethod(node, opts) {
    $2cc261e9204aa0d7$var$assert("ClassPrivateMethod", node, opts);
}
function $2cc261e9204aa0d7$var$assertPrivateName(node, opts) {
    $2cc261e9204aa0d7$var$assert("PrivateName", node, opts);
}
function $2cc261e9204aa0d7$var$assertStaticBlock(node, opts) {
    $2cc261e9204aa0d7$var$assert("StaticBlock", node, opts);
}
function $2cc261e9204aa0d7$var$assertAnyTypeAnnotation(node, opts) {
    $2cc261e9204aa0d7$var$assert("AnyTypeAnnotation", node, opts);
}
function $2cc261e9204aa0d7$var$assertArrayTypeAnnotation(node, opts) {
    $2cc261e9204aa0d7$var$assert("ArrayTypeAnnotation", node, opts);
}
function $2cc261e9204aa0d7$var$assertBooleanTypeAnnotation(node, opts) {
    $2cc261e9204aa0d7$var$assert("BooleanTypeAnnotation", node, opts);
}
function $2cc261e9204aa0d7$var$assertBooleanLiteralTypeAnnotation(node, opts) {
    $2cc261e9204aa0d7$var$assert("BooleanLiteralTypeAnnotation", node, opts);
}
function $2cc261e9204aa0d7$var$assertNullLiteralTypeAnnotation(node, opts) {
    $2cc261e9204aa0d7$var$assert("NullLiteralTypeAnnotation", node, opts);
}
function $2cc261e9204aa0d7$var$assertClassImplements(node, opts) {
    $2cc261e9204aa0d7$var$assert("ClassImplements", node, opts);
}
function $2cc261e9204aa0d7$var$assertDeclareClass(node, opts) {
    $2cc261e9204aa0d7$var$assert("DeclareClass", node, opts);
}
function $2cc261e9204aa0d7$var$assertDeclareFunction(node, opts) {
    $2cc261e9204aa0d7$var$assert("DeclareFunction", node, opts);
}
function $2cc261e9204aa0d7$var$assertDeclareInterface(node, opts) {
    $2cc261e9204aa0d7$var$assert("DeclareInterface", node, opts);
}
function $2cc261e9204aa0d7$var$assertDeclareModule(node, opts) {
    $2cc261e9204aa0d7$var$assert("DeclareModule", node, opts);
}
function $2cc261e9204aa0d7$var$assertDeclareModuleExports(node, opts) {
    $2cc261e9204aa0d7$var$assert("DeclareModuleExports", node, opts);
}
function $2cc261e9204aa0d7$var$assertDeclareTypeAlias(node, opts) {
    $2cc261e9204aa0d7$var$assert("DeclareTypeAlias", node, opts);
}
function $2cc261e9204aa0d7$var$assertDeclareOpaqueType(node, opts) {
    $2cc261e9204aa0d7$var$assert("DeclareOpaqueType", node, opts);
}
function $2cc261e9204aa0d7$var$assertDeclareVariable(node, opts) {
    $2cc261e9204aa0d7$var$assert("DeclareVariable", node, opts);
}
function $2cc261e9204aa0d7$var$assertDeclareExportDeclaration(node, opts) {
    $2cc261e9204aa0d7$var$assert("DeclareExportDeclaration", node, opts);
}
function $2cc261e9204aa0d7$var$assertDeclareExportAllDeclaration(node, opts) {
    $2cc261e9204aa0d7$var$assert("DeclareExportAllDeclaration", node, opts);
}
function $2cc261e9204aa0d7$var$assertDeclaredPredicate(node, opts) {
    $2cc261e9204aa0d7$var$assert("DeclaredPredicate", node, opts);
}
function $2cc261e9204aa0d7$var$assertExistsTypeAnnotation(node, opts) {
    $2cc261e9204aa0d7$var$assert("ExistsTypeAnnotation", node, opts);
}
function $2cc261e9204aa0d7$var$assertFunctionTypeAnnotation(node, opts) {
    $2cc261e9204aa0d7$var$assert("FunctionTypeAnnotation", node, opts);
}
function $2cc261e9204aa0d7$var$assertFunctionTypeParam(node, opts) {
    $2cc261e9204aa0d7$var$assert("FunctionTypeParam", node, opts);
}
function $2cc261e9204aa0d7$var$assertGenericTypeAnnotation(node, opts) {
    $2cc261e9204aa0d7$var$assert("GenericTypeAnnotation", node, opts);
}
function $2cc261e9204aa0d7$var$assertInferredPredicate(node, opts) {
    $2cc261e9204aa0d7$var$assert("InferredPredicate", node, opts);
}
function $2cc261e9204aa0d7$var$assertInterfaceExtends(node, opts) {
    $2cc261e9204aa0d7$var$assert("InterfaceExtends", node, opts);
}
function $2cc261e9204aa0d7$var$assertInterfaceDeclaration(node, opts) {
    $2cc261e9204aa0d7$var$assert("InterfaceDeclaration", node, opts);
}
function $2cc261e9204aa0d7$var$assertInterfaceTypeAnnotation(node, opts) {
    $2cc261e9204aa0d7$var$assert("InterfaceTypeAnnotation", node, opts);
}
function $2cc261e9204aa0d7$var$assertIntersectionTypeAnnotation(node, opts) {
    $2cc261e9204aa0d7$var$assert("IntersectionTypeAnnotation", node, opts);
}
function $2cc261e9204aa0d7$var$assertMixedTypeAnnotation(node, opts) {
    $2cc261e9204aa0d7$var$assert("MixedTypeAnnotation", node, opts);
}
function $2cc261e9204aa0d7$var$assertEmptyTypeAnnotation(node, opts) {
    $2cc261e9204aa0d7$var$assert("EmptyTypeAnnotation", node, opts);
}
function $2cc261e9204aa0d7$var$assertNullableTypeAnnotation(node, opts) {
    $2cc261e9204aa0d7$var$assert("NullableTypeAnnotation", node, opts);
}
function $2cc261e9204aa0d7$var$assertNumberLiteralTypeAnnotation(node, opts) {
    $2cc261e9204aa0d7$var$assert("NumberLiteralTypeAnnotation", node, opts);
}
function $2cc261e9204aa0d7$var$assertNumberTypeAnnotation(node, opts) {
    $2cc261e9204aa0d7$var$assert("NumberTypeAnnotation", node, opts);
}
function $2cc261e9204aa0d7$var$assertObjectTypeAnnotation(node, opts) {
    $2cc261e9204aa0d7$var$assert("ObjectTypeAnnotation", node, opts);
}
function $2cc261e9204aa0d7$var$assertObjectTypeInternalSlot(node, opts) {
    $2cc261e9204aa0d7$var$assert("ObjectTypeInternalSlot", node, opts);
}
function $2cc261e9204aa0d7$var$assertObjectTypeCallProperty(node, opts) {
    $2cc261e9204aa0d7$var$assert("ObjectTypeCallProperty", node, opts);
}
function $2cc261e9204aa0d7$var$assertObjectTypeIndexer(node, opts) {
    $2cc261e9204aa0d7$var$assert("ObjectTypeIndexer", node, opts);
}
function $2cc261e9204aa0d7$var$assertObjectTypeProperty(node, opts) {
    $2cc261e9204aa0d7$var$assert("ObjectTypeProperty", node, opts);
}
function $2cc261e9204aa0d7$var$assertObjectTypeSpreadProperty(node, opts) {
    $2cc261e9204aa0d7$var$assert("ObjectTypeSpreadProperty", node, opts);
}
function $2cc261e9204aa0d7$var$assertOpaqueType(node, opts) {
    $2cc261e9204aa0d7$var$assert("OpaqueType", node, opts);
}
function $2cc261e9204aa0d7$var$assertQualifiedTypeIdentifier(node, opts) {
    $2cc261e9204aa0d7$var$assert("QualifiedTypeIdentifier", node, opts);
}
function $2cc261e9204aa0d7$var$assertStringLiteralTypeAnnotation(node, opts) {
    $2cc261e9204aa0d7$var$assert("StringLiteralTypeAnnotation", node, opts);
}
function $2cc261e9204aa0d7$var$assertStringTypeAnnotation(node, opts) {
    $2cc261e9204aa0d7$var$assert("StringTypeAnnotation", node, opts);
}
function $2cc261e9204aa0d7$var$assertSymbolTypeAnnotation(node, opts) {
    $2cc261e9204aa0d7$var$assert("SymbolTypeAnnotation", node, opts);
}
function $2cc261e9204aa0d7$var$assertThisTypeAnnotation(node, opts) {
    $2cc261e9204aa0d7$var$assert("ThisTypeAnnotation", node, opts);
}
function $2cc261e9204aa0d7$var$assertTupleTypeAnnotation(node, opts) {
    $2cc261e9204aa0d7$var$assert("TupleTypeAnnotation", node, opts);
}
function $2cc261e9204aa0d7$var$assertTypeofTypeAnnotation(node, opts) {
    $2cc261e9204aa0d7$var$assert("TypeofTypeAnnotation", node, opts);
}
function $2cc261e9204aa0d7$var$assertTypeAlias(node, opts) {
    $2cc261e9204aa0d7$var$assert("TypeAlias", node, opts);
}
function $2cc261e9204aa0d7$var$assertTypeAnnotation(node, opts) {
    $2cc261e9204aa0d7$var$assert("TypeAnnotation", node, opts);
}
function $2cc261e9204aa0d7$var$assertTypeCastExpression(node, opts) {
    $2cc261e9204aa0d7$var$assert("TypeCastExpression", node, opts);
}
function $2cc261e9204aa0d7$var$assertTypeParameter(node, opts) {
    $2cc261e9204aa0d7$var$assert("TypeParameter", node, opts);
}
function $2cc261e9204aa0d7$var$assertTypeParameterDeclaration(node, opts) {
    $2cc261e9204aa0d7$var$assert("TypeParameterDeclaration", node, opts);
}
function $2cc261e9204aa0d7$var$assertTypeParameterInstantiation(node, opts) {
    $2cc261e9204aa0d7$var$assert("TypeParameterInstantiation", node, opts);
}
function $2cc261e9204aa0d7$var$assertUnionTypeAnnotation(node, opts) {
    $2cc261e9204aa0d7$var$assert("UnionTypeAnnotation", node, opts);
}
function $2cc261e9204aa0d7$var$assertVariance(node, opts) {
    $2cc261e9204aa0d7$var$assert("Variance", node, opts);
}
function $2cc261e9204aa0d7$var$assertVoidTypeAnnotation(node, opts) {
    $2cc261e9204aa0d7$var$assert("VoidTypeAnnotation", node, opts);
}
function $2cc261e9204aa0d7$var$assertEnumDeclaration(node, opts) {
    $2cc261e9204aa0d7$var$assert("EnumDeclaration", node, opts);
}
function $2cc261e9204aa0d7$var$assertEnumBooleanBody(node, opts) {
    $2cc261e9204aa0d7$var$assert("EnumBooleanBody", node, opts);
}
function $2cc261e9204aa0d7$var$assertEnumNumberBody(node, opts) {
    $2cc261e9204aa0d7$var$assert("EnumNumberBody", node, opts);
}
function $2cc261e9204aa0d7$var$assertEnumStringBody(node, opts) {
    $2cc261e9204aa0d7$var$assert("EnumStringBody", node, opts);
}
function $2cc261e9204aa0d7$var$assertEnumSymbolBody(node, opts) {
    $2cc261e9204aa0d7$var$assert("EnumSymbolBody", node, opts);
}
function $2cc261e9204aa0d7$var$assertEnumBooleanMember(node, opts) {
    $2cc261e9204aa0d7$var$assert("EnumBooleanMember", node, opts);
}
function $2cc261e9204aa0d7$var$assertEnumNumberMember(node, opts) {
    $2cc261e9204aa0d7$var$assert("EnumNumberMember", node, opts);
}
function $2cc261e9204aa0d7$var$assertEnumStringMember(node, opts) {
    $2cc261e9204aa0d7$var$assert("EnumStringMember", node, opts);
}
function $2cc261e9204aa0d7$var$assertEnumDefaultedMember(node, opts) {
    $2cc261e9204aa0d7$var$assert("EnumDefaultedMember", node, opts);
}
function $2cc261e9204aa0d7$var$assertIndexedAccessType(node, opts) {
    $2cc261e9204aa0d7$var$assert("IndexedAccessType", node, opts);
}
function $2cc261e9204aa0d7$var$assertOptionalIndexedAccessType(node, opts) {
    $2cc261e9204aa0d7$var$assert("OptionalIndexedAccessType", node, opts);
}
function $2cc261e9204aa0d7$var$assertJSXAttribute(node, opts) {
    $2cc261e9204aa0d7$var$assert("JSXAttribute", node, opts);
}
function $2cc261e9204aa0d7$var$assertJSXClosingElement(node, opts) {
    $2cc261e9204aa0d7$var$assert("JSXClosingElement", node, opts);
}
function $2cc261e9204aa0d7$var$assertJSXElement(node, opts) {
    $2cc261e9204aa0d7$var$assert("JSXElement", node, opts);
}
function $2cc261e9204aa0d7$var$assertJSXEmptyExpression(node, opts) {
    $2cc261e9204aa0d7$var$assert("JSXEmptyExpression", node, opts);
}
function $2cc261e9204aa0d7$var$assertJSXExpressionContainer(node, opts) {
    $2cc261e9204aa0d7$var$assert("JSXExpressionContainer", node, opts);
}
function $2cc261e9204aa0d7$var$assertJSXSpreadChild(node, opts) {
    $2cc261e9204aa0d7$var$assert("JSXSpreadChild", node, opts);
}
function $2cc261e9204aa0d7$var$assertJSXIdentifier(node, opts) {
    $2cc261e9204aa0d7$var$assert("JSXIdentifier", node, opts);
}
function $2cc261e9204aa0d7$var$assertJSXMemberExpression(node, opts) {
    $2cc261e9204aa0d7$var$assert("JSXMemberExpression", node, opts);
}
function $2cc261e9204aa0d7$var$assertJSXNamespacedName(node, opts) {
    $2cc261e9204aa0d7$var$assert("JSXNamespacedName", node, opts);
}
function $2cc261e9204aa0d7$var$assertJSXOpeningElement(node, opts) {
    $2cc261e9204aa0d7$var$assert("JSXOpeningElement", node, opts);
}
function $2cc261e9204aa0d7$var$assertJSXSpreadAttribute(node, opts) {
    $2cc261e9204aa0d7$var$assert("JSXSpreadAttribute", node, opts);
}
function $2cc261e9204aa0d7$var$assertJSXText(node, opts) {
    $2cc261e9204aa0d7$var$assert("JSXText", node, opts);
}
function $2cc261e9204aa0d7$var$assertJSXFragment(node, opts) {
    $2cc261e9204aa0d7$var$assert("JSXFragment", node, opts);
}
function $2cc261e9204aa0d7$var$assertJSXOpeningFragment(node, opts) {
    $2cc261e9204aa0d7$var$assert("JSXOpeningFragment", node, opts);
}
function $2cc261e9204aa0d7$var$assertJSXClosingFragment(node, opts) {
    $2cc261e9204aa0d7$var$assert("JSXClosingFragment", node, opts);
}
function $2cc261e9204aa0d7$var$assertNoop(node, opts) {
    $2cc261e9204aa0d7$var$assert("Noop", node, opts);
}
function $2cc261e9204aa0d7$var$assertPlaceholder(node, opts) {
    $2cc261e9204aa0d7$var$assert("Placeholder", node, opts);
}
function $2cc261e9204aa0d7$var$assertV8IntrinsicIdentifier(node, opts) {
    $2cc261e9204aa0d7$var$assert("V8IntrinsicIdentifier", node, opts);
}
function $2cc261e9204aa0d7$var$assertArgumentPlaceholder(node, opts) {
    $2cc261e9204aa0d7$var$assert("ArgumentPlaceholder", node, opts);
}
function $2cc261e9204aa0d7$var$assertBindExpression(node, opts) {
    $2cc261e9204aa0d7$var$assert("BindExpression", node, opts);
}
function $2cc261e9204aa0d7$var$assertImportAttribute(node, opts) {
    $2cc261e9204aa0d7$var$assert("ImportAttribute", node, opts);
}
function $2cc261e9204aa0d7$var$assertDecorator(node, opts) {
    $2cc261e9204aa0d7$var$assert("Decorator", node, opts);
}
function $2cc261e9204aa0d7$var$assertDoExpression(node, opts) {
    $2cc261e9204aa0d7$var$assert("DoExpression", node, opts);
}
function $2cc261e9204aa0d7$var$assertExportDefaultSpecifier(node, opts) {
    $2cc261e9204aa0d7$var$assert("ExportDefaultSpecifier", node, opts);
}
function $2cc261e9204aa0d7$var$assertRecordExpression(node, opts) {
    $2cc261e9204aa0d7$var$assert("RecordExpression", node, opts);
}
function $2cc261e9204aa0d7$var$assertTupleExpression(node, opts) {
    $2cc261e9204aa0d7$var$assert("TupleExpression", node, opts);
}
function $2cc261e9204aa0d7$var$assertDecimalLiteral(node, opts) {
    $2cc261e9204aa0d7$var$assert("DecimalLiteral", node, opts);
}
function $2cc261e9204aa0d7$var$assertModuleExpression(node, opts) {
    $2cc261e9204aa0d7$var$assert("ModuleExpression", node, opts);
}
function $2cc261e9204aa0d7$var$assertTopicReference(node, opts) {
    $2cc261e9204aa0d7$var$assert("TopicReference", node, opts);
}
function $2cc261e9204aa0d7$var$assertPipelineTopicExpression(node, opts) {
    $2cc261e9204aa0d7$var$assert("PipelineTopicExpression", node, opts);
}
function $2cc261e9204aa0d7$var$assertPipelineBareFunction(node, opts) {
    $2cc261e9204aa0d7$var$assert("PipelineBareFunction", node, opts);
}
function $2cc261e9204aa0d7$var$assertPipelinePrimaryTopicReference(node, opts) {
    $2cc261e9204aa0d7$var$assert("PipelinePrimaryTopicReference", node, opts);
}
function $2cc261e9204aa0d7$var$assertTSParameterProperty(node, opts) {
    $2cc261e9204aa0d7$var$assert("TSParameterProperty", node, opts);
}
function $2cc261e9204aa0d7$var$assertTSDeclareFunction(node, opts) {
    $2cc261e9204aa0d7$var$assert("TSDeclareFunction", node, opts);
}
function $2cc261e9204aa0d7$var$assertTSDeclareMethod(node, opts) {
    $2cc261e9204aa0d7$var$assert("TSDeclareMethod", node, opts);
}
function $2cc261e9204aa0d7$var$assertTSQualifiedName(node, opts) {
    $2cc261e9204aa0d7$var$assert("TSQualifiedName", node, opts);
}
function $2cc261e9204aa0d7$var$assertTSCallSignatureDeclaration(node, opts) {
    $2cc261e9204aa0d7$var$assert("TSCallSignatureDeclaration", node, opts);
}
function $2cc261e9204aa0d7$var$assertTSConstructSignatureDeclaration(node, opts) {
    $2cc261e9204aa0d7$var$assert("TSConstructSignatureDeclaration", node, opts);
}
function $2cc261e9204aa0d7$var$assertTSPropertySignature(node, opts) {
    $2cc261e9204aa0d7$var$assert("TSPropertySignature", node, opts);
}
function $2cc261e9204aa0d7$var$assertTSMethodSignature(node, opts) {
    $2cc261e9204aa0d7$var$assert("TSMethodSignature", node, opts);
}
function $2cc261e9204aa0d7$var$assertTSIndexSignature(node, opts) {
    $2cc261e9204aa0d7$var$assert("TSIndexSignature", node, opts);
}
function $2cc261e9204aa0d7$var$assertTSAnyKeyword(node, opts) {
    $2cc261e9204aa0d7$var$assert("TSAnyKeyword", node, opts);
}
function $2cc261e9204aa0d7$var$assertTSBooleanKeyword(node, opts) {
    $2cc261e9204aa0d7$var$assert("TSBooleanKeyword", node, opts);
}
function $2cc261e9204aa0d7$var$assertTSBigIntKeyword(node, opts) {
    $2cc261e9204aa0d7$var$assert("TSBigIntKeyword", node, opts);
}
function $2cc261e9204aa0d7$var$assertTSIntrinsicKeyword(node, opts) {
    $2cc261e9204aa0d7$var$assert("TSIntrinsicKeyword", node, opts);
}
function $2cc261e9204aa0d7$var$assertTSNeverKeyword(node, opts) {
    $2cc261e9204aa0d7$var$assert("TSNeverKeyword", node, opts);
}
function $2cc261e9204aa0d7$var$assertTSNullKeyword(node, opts) {
    $2cc261e9204aa0d7$var$assert("TSNullKeyword", node, opts);
}
function $2cc261e9204aa0d7$var$assertTSNumberKeyword(node, opts) {
    $2cc261e9204aa0d7$var$assert("TSNumberKeyword", node, opts);
}
function $2cc261e9204aa0d7$var$assertTSObjectKeyword(node, opts) {
    $2cc261e9204aa0d7$var$assert("TSObjectKeyword", node, opts);
}
function $2cc261e9204aa0d7$var$assertTSStringKeyword(node, opts) {
    $2cc261e9204aa0d7$var$assert("TSStringKeyword", node, opts);
}
function $2cc261e9204aa0d7$var$assertTSSymbolKeyword(node, opts) {
    $2cc261e9204aa0d7$var$assert("TSSymbolKeyword", node, opts);
}
function $2cc261e9204aa0d7$var$assertTSUndefinedKeyword(node, opts) {
    $2cc261e9204aa0d7$var$assert("TSUndefinedKeyword", node, opts);
}
function $2cc261e9204aa0d7$var$assertTSUnknownKeyword(node, opts) {
    $2cc261e9204aa0d7$var$assert("TSUnknownKeyword", node, opts);
}
function $2cc261e9204aa0d7$var$assertTSVoidKeyword(node, opts) {
    $2cc261e9204aa0d7$var$assert("TSVoidKeyword", node, opts);
}
function $2cc261e9204aa0d7$var$assertTSThisType(node, opts) {
    $2cc261e9204aa0d7$var$assert("TSThisType", node, opts);
}
function $2cc261e9204aa0d7$var$assertTSFunctionType(node, opts) {
    $2cc261e9204aa0d7$var$assert("TSFunctionType", node, opts);
}
function $2cc261e9204aa0d7$var$assertTSConstructorType(node, opts) {
    $2cc261e9204aa0d7$var$assert("TSConstructorType", node, opts);
}
function $2cc261e9204aa0d7$var$assertTSTypeReference(node, opts) {
    $2cc261e9204aa0d7$var$assert("TSTypeReference", node, opts);
}
function $2cc261e9204aa0d7$var$assertTSTypePredicate(node, opts) {
    $2cc261e9204aa0d7$var$assert("TSTypePredicate", node, opts);
}
function $2cc261e9204aa0d7$var$assertTSTypeQuery(node, opts) {
    $2cc261e9204aa0d7$var$assert("TSTypeQuery", node, opts);
}
function $2cc261e9204aa0d7$var$assertTSTypeLiteral(node, opts) {
    $2cc261e9204aa0d7$var$assert("TSTypeLiteral", node, opts);
}
function $2cc261e9204aa0d7$var$assertTSArrayType(node, opts) {
    $2cc261e9204aa0d7$var$assert("TSArrayType", node, opts);
}
function $2cc261e9204aa0d7$var$assertTSTupleType(node, opts) {
    $2cc261e9204aa0d7$var$assert("TSTupleType", node, opts);
}
function $2cc261e9204aa0d7$var$assertTSOptionalType(node, opts) {
    $2cc261e9204aa0d7$var$assert("TSOptionalType", node, opts);
}
function $2cc261e9204aa0d7$var$assertTSRestType(node, opts) {
    $2cc261e9204aa0d7$var$assert("TSRestType", node, opts);
}
function $2cc261e9204aa0d7$var$assertTSNamedTupleMember(node, opts) {
    $2cc261e9204aa0d7$var$assert("TSNamedTupleMember", node, opts);
}
function $2cc261e9204aa0d7$var$assertTSUnionType(node, opts) {
    $2cc261e9204aa0d7$var$assert("TSUnionType", node, opts);
}
function $2cc261e9204aa0d7$var$assertTSIntersectionType(node, opts) {
    $2cc261e9204aa0d7$var$assert("TSIntersectionType", node, opts);
}
function $2cc261e9204aa0d7$var$assertTSConditionalType(node, opts) {
    $2cc261e9204aa0d7$var$assert("TSConditionalType", node, opts);
}
function $2cc261e9204aa0d7$var$assertTSInferType(node, opts) {
    $2cc261e9204aa0d7$var$assert("TSInferType", node, opts);
}
function $2cc261e9204aa0d7$var$assertTSParenthesizedType(node, opts) {
    $2cc261e9204aa0d7$var$assert("TSParenthesizedType", node, opts);
}
function $2cc261e9204aa0d7$var$assertTSTypeOperator(node, opts) {
    $2cc261e9204aa0d7$var$assert("TSTypeOperator", node, opts);
}
function $2cc261e9204aa0d7$var$assertTSIndexedAccessType(node, opts) {
    $2cc261e9204aa0d7$var$assert("TSIndexedAccessType", node, opts);
}
function $2cc261e9204aa0d7$var$assertTSMappedType(node, opts) {
    $2cc261e9204aa0d7$var$assert("TSMappedType", node, opts);
}
function $2cc261e9204aa0d7$var$assertTSLiteralType(node, opts) {
    $2cc261e9204aa0d7$var$assert("TSLiteralType", node, opts);
}
function $2cc261e9204aa0d7$var$assertTSExpressionWithTypeArguments(node, opts) {
    $2cc261e9204aa0d7$var$assert("TSExpressionWithTypeArguments", node, opts);
}
function $2cc261e9204aa0d7$var$assertTSInterfaceDeclaration(node, opts) {
    $2cc261e9204aa0d7$var$assert("TSInterfaceDeclaration", node, opts);
}
function $2cc261e9204aa0d7$var$assertTSInterfaceBody(node, opts) {
    $2cc261e9204aa0d7$var$assert("TSInterfaceBody", node, opts);
}
function $2cc261e9204aa0d7$var$assertTSTypeAliasDeclaration(node, opts) {
    $2cc261e9204aa0d7$var$assert("TSTypeAliasDeclaration", node, opts);
}
function $2cc261e9204aa0d7$var$assertTSInstantiationExpression(node, opts) {
    $2cc261e9204aa0d7$var$assert("TSInstantiationExpression", node, opts);
}
function $2cc261e9204aa0d7$var$assertTSAsExpression(node, opts) {
    $2cc261e9204aa0d7$var$assert("TSAsExpression", node, opts);
}
function $2cc261e9204aa0d7$var$assertTSSatisfiesExpression(node, opts) {
    $2cc261e9204aa0d7$var$assert("TSSatisfiesExpression", node, opts);
}
function $2cc261e9204aa0d7$var$assertTSTypeAssertion(node, opts) {
    $2cc261e9204aa0d7$var$assert("TSTypeAssertion", node, opts);
}
function $2cc261e9204aa0d7$var$assertTSEnumDeclaration(node, opts) {
    $2cc261e9204aa0d7$var$assert("TSEnumDeclaration", node, opts);
}
function $2cc261e9204aa0d7$var$assertTSEnumMember(node, opts) {
    $2cc261e9204aa0d7$var$assert("TSEnumMember", node, opts);
}
function $2cc261e9204aa0d7$var$assertTSModuleDeclaration(node, opts) {
    $2cc261e9204aa0d7$var$assert("TSModuleDeclaration", node, opts);
}
function $2cc261e9204aa0d7$var$assertTSModuleBlock(node, opts) {
    $2cc261e9204aa0d7$var$assert("TSModuleBlock", node, opts);
}
function $2cc261e9204aa0d7$var$assertTSImportType(node, opts) {
    $2cc261e9204aa0d7$var$assert("TSImportType", node, opts);
}
function $2cc261e9204aa0d7$var$assertTSImportEqualsDeclaration(node, opts) {
    $2cc261e9204aa0d7$var$assert("TSImportEqualsDeclaration", node, opts);
}
function $2cc261e9204aa0d7$var$assertTSExternalModuleReference(node, opts) {
    $2cc261e9204aa0d7$var$assert("TSExternalModuleReference", node, opts);
}
function $2cc261e9204aa0d7$var$assertTSNonNullExpression(node, opts) {
    $2cc261e9204aa0d7$var$assert("TSNonNullExpression", node, opts);
}
function $2cc261e9204aa0d7$var$assertTSExportAssignment(node, opts) {
    $2cc261e9204aa0d7$var$assert("TSExportAssignment", node, opts);
}
function $2cc261e9204aa0d7$var$assertTSNamespaceExportDeclaration(node, opts) {
    $2cc261e9204aa0d7$var$assert("TSNamespaceExportDeclaration", node, opts);
}
function $2cc261e9204aa0d7$var$assertTSTypeAnnotation(node, opts) {
    $2cc261e9204aa0d7$var$assert("TSTypeAnnotation", node, opts);
}
function $2cc261e9204aa0d7$var$assertTSTypeParameterInstantiation(node, opts) {
    $2cc261e9204aa0d7$var$assert("TSTypeParameterInstantiation", node, opts);
}
function $2cc261e9204aa0d7$var$assertTSTypeParameterDeclaration(node, opts) {
    $2cc261e9204aa0d7$var$assert("TSTypeParameterDeclaration", node, opts);
}
function $2cc261e9204aa0d7$var$assertTSTypeParameter(node, opts) {
    $2cc261e9204aa0d7$var$assert("TSTypeParameter", node, opts);
}
function $2cc261e9204aa0d7$var$assertStandardized(node, opts) {
    $2cc261e9204aa0d7$var$assert("Standardized", node, opts);
}
function $2cc261e9204aa0d7$var$assertExpression(node, opts) {
    $2cc261e9204aa0d7$var$assert("Expression", node, opts);
}
function $2cc261e9204aa0d7$var$assertBinary(node, opts) {
    $2cc261e9204aa0d7$var$assert("Binary", node, opts);
}
function $2cc261e9204aa0d7$var$assertScopable(node, opts) {
    $2cc261e9204aa0d7$var$assert("Scopable", node, opts);
}
function $2cc261e9204aa0d7$var$assertBlockParent(node, opts) {
    $2cc261e9204aa0d7$var$assert("BlockParent", node, opts);
}
function $2cc261e9204aa0d7$var$assertBlock(node, opts) {
    $2cc261e9204aa0d7$var$assert("Block", node, opts);
}
function $2cc261e9204aa0d7$var$assertStatement(node, opts) {
    $2cc261e9204aa0d7$var$assert("Statement", node, opts);
}
function $2cc261e9204aa0d7$var$assertTerminatorless(node, opts) {
    $2cc261e9204aa0d7$var$assert("Terminatorless", node, opts);
}
function $2cc261e9204aa0d7$var$assertCompletionStatement(node, opts) {
    $2cc261e9204aa0d7$var$assert("CompletionStatement", node, opts);
}
function $2cc261e9204aa0d7$var$assertConditional(node, opts) {
    $2cc261e9204aa0d7$var$assert("Conditional", node, opts);
}
function $2cc261e9204aa0d7$var$assertLoop(node, opts) {
    $2cc261e9204aa0d7$var$assert("Loop", node, opts);
}
function $2cc261e9204aa0d7$var$assertWhile(node, opts) {
    $2cc261e9204aa0d7$var$assert("While", node, opts);
}
function $2cc261e9204aa0d7$var$assertExpressionWrapper(node, opts) {
    $2cc261e9204aa0d7$var$assert("ExpressionWrapper", node, opts);
}
function $2cc261e9204aa0d7$var$assertFor(node, opts) {
    $2cc261e9204aa0d7$var$assert("For", node, opts);
}
function $2cc261e9204aa0d7$var$assertForXStatement(node, opts) {
    $2cc261e9204aa0d7$var$assert("ForXStatement", node, opts);
}
function $2cc261e9204aa0d7$var$assertFunction(node, opts) {
    $2cc261e9204aa0d7$var$assert("Function", node, opts);
}
function $2cc261e9204aa0d7$var$assertFunctionParent(node, opts) {
    $2cc261e9204aa0d7$var$assert("FunctionParent", node, opts);
}
function $2cc261e9204aa0d7$var$assertPureish(node, opts) {
    $2cc261e9204aa0d7$var$assert("Pureish", node, opts);
}
function $2cc261e9204aa0d7$var$assertDeclaration(node, opts) {
    $2cc261e9204aa0d7$var$assert("Declaration", node, opts);
}
function $2cc261e9204aa0d7$var$assertPatternLike(node, opts) {
    $2cc261e9204aa0d7$var$assert("PatternLike", node, opts);
}
function $2cc261e9204aa0d7$var$assertLVal(node, opts) {
    $2cc261e9204aa0d7$var$assert("LVal", node, opts);
}
function $2cc261e9204aa0d7$var$assertTSEntityName(node, opts) {
    $2cc261e9204aa0d7$var$assert("TSEntityName", node, opts);
}
function $2cc261e9204aa0d7$var$assertLiteral(node, opts) {
    $2cc261e9204aa0d7$var$assert("Literal", node, opts);
}
function $2cc261e9204aa0d7$var$assertImmutable(node, opts) {
    $2cc261e9204aa0d7$var$assert("Immutable", node, opts);
}
function $2cc261e9204aa0d7$var$assertUserWhitespacable(node, opts) {
    $2cc261e9204aa0d7$var$assert("UserWhitespacable", node, opts);
}
function $2cc261e9204aa0d7$var$assertMethod(node, opts) {
    $2cc261e9204aa0d7$var$assert("Method", node, opts);
}
function $2cc261e9204aa0d7$var$assertObjectMember(node, opts) {
    $2cc261e9204aa0d7$var$assert("ObjectMember", node, opts);
}
function $2cc261e9204aa0d7$var$assertProperty(node, opts) {
    $2cc261e9204aa0d7$var$assert("Property", node, opts);
}
function $2cc261e9204aa0d7$var$assertUnaryLike(node, opts) {
    $2cc261e9204aa0d7$var$assert("UnaryLike", node, opts);
}
function $2cc261e9204aa0d7$var$assertPattern(node, opts) {
    $2cc261e9204aa0d7$var$assert("Pattern", node, opts);
}
function $2cc261e9204aa0d7$var$assertClass(node, opts) {
    $2cc261e9204aa0d7$var$assert("Class", node, opts);
}
function $2cc261e9204aa0d7$var$assertImportOrExportDeclaration(node, opts) {
    $2cc261e9204aa0d7$var$assert("ImportOrExportDeclaration", node, opts);
}
function $2cc261e9204aa0d7$var$assertExportDeclaration(node, opts) {
    $2cc261e9204aa0d7$var$assert("ExportDeclaration", node, opts);
}
function $2cc261e9204aa0d7$var$assertModuleSpecifier(node, opts) {
    $2cc261e9204aa0d7$var$assert("ModuleSpecifier", node, opts);
}
function $2cc261e9204aa0d7$var$assertAccessor(node, opts) {
    $2cc261e9204aa0d7$var$assert("Accessor", node, opts);
}
function $2cc261e9204aa0d7$var$assertPrivate(node, opts) {
    $2cc261e9204aa0d7$var$assert("Private", node, opts);
}
function $2cc261e9204aa0d7$var$assertFlow(node, opts) {
    $2cc261e9204aa0d7$var$assert("Flow", node, opts);
}
function $2cc261e9204aa0d7$var$assertFlowType(node, opts) {
    $2cc261e9204aa0d7$var$assert("FlowType", node, opts);
}
function $2cc261e9204aa0d7$var$assertFlowBaseAnnotation(node, opts) {
    $2cc261e9204aa0d7$var$assert("FlowBaseAnnotation", node, opts);
}
function $2cc261e9204aa0d7$var$assertFlowDeclaration(node, opts) {
    $2cc261e9204aa0d7$var$assert("FlowDeclaration", node, opts);
}
function $2cc261e9204aa0d7$var$assertFlowPredicate(node, opts) {
    $2cc261e9204aa0d7$var$assert("FlowPredicate", node, opts);
}
function $2cc261e9204aa0d7$var$assertEnumBody(node, opts) {
    $2cc261e9204aa0d7$var$assert("EnumBody", node, opts);
}
function $2cc261e9204aa0d7$var$assertEnumMember(node, opts) {
    $2cc261e9204aa0d7$var$assert("EnumMember", node, opts);
}
function $2cc261e9204aa0d7$var$assertJSX(node, opts) {
    $2cc261e9204aa0d7$var$assert("JSX", node, opts);
}
function $2cc261e9204aa0d7$var$assertMiscellaneous(node, opts) {
    $2cc261e9204aa0d7$var$assert("Miscellaneous", node, opts);
}
function $2cc261e9204aa0d7$var$assertTypeScript(node, opts) {
    $2cc261e9204aa0d7$var$assert("TypeScript", node, opts);
}
function $2cc261e9204aa0d7$var$assertTSTypeElement(node, opts) {
    $2cc261e9204aa0d7$var$assert("TSTypeElement", node, opts);
}
function $2cc261e9204aa0d7$var$assertTSType(node, opts) {
    $2cc261e9204aa0d7$var$assert("TSType", node, opts);
}
function $2cc261e9204aa0d7$var$assertTSBaseType(node, opts) {
    $2cc261e9204aa0d7$var$assert("TSBaseType", node, opts);
}
function $2cc261e9204aa0d7$var$assertNumberLiteral(node, opts) {
    (0, $7sVNt.default)("assertNumberLiteral", "assertNumericLiteral");
    $2cc261e9204aa0d7$var$assert("NumberLiteral", node, opts);
}
function $2cc261e9204aa0d7$var$assertRegexLiteral(node, opts) {
    (0, $7sVNt.default)("assertRegexLiteral", "assertRegExpLiteral");
    $2cc261e9204aa0d7$var$assert("RegexLiteral", node, opts);
}
function $2cc261e9204aa0d7$var$assertRestProperty(node, opts) {
    (0, $7sVNt.default)("assertRestProperty", "assertRestElement");
    $2cc261e9204aa0d7$var$assert("RestProperty", node, opts);
}
function $2cc261e9204aa0d7$var$assertSpreadProperty(node, opts) {
    (0, $7sVNt.default)("assertSpreadProperty", "assertSpreadElement");
    $2cc261e9204aa0d7$var$assert("SpreadProperty", node, opts);
}
function $2cc261e9204aa0d7$var$assertModuleDeclaration(node, opts) {
    (0, $7sVNt.default)("assertModuleDeclaration", "assertImportOrExportDeclaration");
    $2cc261e9204aa0d7$var$assert("ModuleDeclaration", node, opts);
}

});

parcelRegister("hLNUS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7MfP7 = parcelRequire("7MfP7");
var $cefd8bd39128fdc0$var$_default = module.exports.default = $cefd8bd39128fdc0$var$createTypeAnnotationBasedOnTypeof;
function $cefd8bd39128fdc0$var$createTypeAnnotationBasedOnTypeof(type) {
    switch(type){
        case "string":
            return (0, $7MfP7.stringTypeAnnotation)();
        case "number":
            return (0, $7MfP7.numberTypeAnnotation)();
        case "undefined":
            return (0, $7MfP7.voidTypeAnnotation)();
        case "boolean":
            return (0, $7MfP7.booleanTypeAnnotation)();
        case "function":
            return (0, $7MfP7.genericTypeAnnotation)((0, $7MfP7.identifier)("Function"));
        case "object":
            return (0, $7MfP7.genericTypeAnnotation)((0, $7MfP7.identifier)("Object"));
        case "symbol":
            return (0, $7MfP7.genericTypeAnnotation)((0, $7MfP7.identifier)("Symbol"));
        case "bigint":
            return (0, $7MfP7.anyTypeAnnotation)();
    }
    throw new Error("Invalid typeof value: " + type);
}

});

parcelRegister("aUeS4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7f0aab69550d5814$var$createFlowUnionType;

var $7MfP7 = parcelRequire("7MfP7");

var $iGdAf = parcelRequire("iGdAf");
function $7f0aab69550d5814$var$createFlowUnionType(types) {
    const flattened = (0, $iGdAf.default)(types);
    if (flattened.length === 1) return flattened[0];
    else return (0, $7MfP7.unionTypeAnnotation)(flattened);
}

});
parcelRegister("iGdAf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d996afad68f1690b$var$removeTypeDuplicates;

var $2G7FY = parcelRequire("2G7FY");
function $d996afad68f1690b$var$getQualifiedName(node) {
    return (0, $2G7FY.isIdentifier)(node) ? node.name : `${node.id.name}.${$d996afad68f1690b$var$getQualifiedName(node.qualification)}`;
}
function $d996afad68f1690b$var$removeTypeDuplicates(nodesIn) {
    const nodes = Array.from(nodesIn);
    const generics = new Map();
    const bases = new Map();
    const typeGroups = new Set();
    const types = [];
    for(let i = 0; i < nodes.length; i++){
        const node = nodes[i];
        if (!node) continue;
        if (types.indexOf(node) >= 0) continue;
        if ((0, $2G7FY.isAnyTypeAnnotation)(node)) return [
            node
        ];
        if ((0, $2G7FY.isFlowBaseAnnotation)(node)) {
            bases.set(node.type, node);
            continue;
        }
        if ((0, $2G7FY.isUnionTypeAnnotation)(node)) {
            if (!typeGroups.has(node.types)) {
                nodes.push(...node.types);
                typeGroups.add(node.types);
            }
            continue;
        }
        if ((0, $2G7FY.isGenericTypeAnnotation)(node)) {
            const name = $d996afad68f1690b$var$getQualifiedName(node.id);
            if (generics.has(name)) {
                let existing = generics.get(name);
                if (existing.typeParameters) {
                    if (node.typeParameters) {
                        existing.typeParameters.params.push(...node.typeParameters.params);
                        existing.typeParameters.params = $d996afad68f1690b$var$removeTypeDuplicates(existing.typeParameters.params);
                    }
                } else existing = node.typeParameters;
            } else generics.set(name, node);
            continue;
        }
        types.push(node);
    }
    for (const [, baseType] of bases)types.push(baseType);
    for (const [, genericName] of generics)types.push(genericName);
    return types;
}

});


parcelRegister("36R6x", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $243b2015522a666a$var$createTSUnionType;

var $7MfP7 = parcelRequire("7MfP7");

var $8Lukz = parcelRequire("8Lukz");

var $2G7FY = parcelRequire("2G7FY");
function $243b2015522a666a$var$createTSUnionType(typeAnnotations) {
    const types = typeAnnotations.map((type)=>{
        return (0, $2G7FY.isTSTypeAnnotation)(type) ? type.typeAnnotation : type;
    });
    const flattened = (0, $8Lukz.default)(types);
    if (flattened.length === 1) return flattened[0];
    else return (0, $7MfP7.tsUnionType)(flattened);
}

});
parcelRegister("8Lukz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $661a3d9259d91601$var$removeTypeDuplicates;

var $2G7FY = parcelRequire("2G7FY");
function $661a3d9259d91601$var$getQualifiedName(node) {
    return (0, $2G7FY.isIdentifier)(node) ? node.name : `${node.right.name}.${$661a3d9259d91601$var$getQualifiedName(node.left)}`;
}
function $661a3d9259d91601$var$removeTypeDuplicates(nodesIn) {
    const nodes = Array.from(nodesIn);
    const generics = new Map();
    const bases = new Map();
    const typeGroups = new Set();
    const types = [];
    for(let i = 0; i < nodes.length; i++){
        const node = nodes[i];
        if (!node) continue;
        if (types.indexOf(node) >= 0) continue;
        if ((0, $2G7FY.isTSAnyKeyword)(node)) return [
            node
        ];
        if ((0, $2G7FY.isTSBaseType)(node)) {
            bases.set(node.type, node);
            continue;
        }
        if ((0, $2G7FY.isTSUnionType)(node)) {
            if (!typeGroups.has(node.types)) {
                nodes.push(...node.types);
                typeGroups.add(node.types);
            }
            continue;
        }
        if ((0, $2G7FY.isTSTypeReference)(node) && node.typeParameters) {
            const name = $661a3d9259d91601$var$getQualifiedName(node.typeName);
            if (generics.has(name)) {
                let existing = generics.get(name);
                if (existing.typeParameters) {
                    if (node.typeParameters) {
                        existing.typeParameters.params.push(...node.typeParameters.params);
                        existing.typeParameters.params = $661a3d9259d91601$var$removeTypeDuplicates(existing.typeParameters.params);
                    }
                } else existing = node.typeParameters;
            } else generics.set(name, node);
            continue;
        }
        types.push(node);
    }
    for (const [, baseType] of bases)types.push(baseType);
    for (const [, genericName] of generics)types.push(genericName);
    return types;
}

});


parcelRegister("2r3lq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "AnyTypeAnnotation", {
    enumerable: true,
    get: function() {
        return $7MfP7.anyTypeAnnotation;
    }
});
Object.defineProperty(module.exports, "ArgumentPlaceholder", {
    enumerable: true,
    get: function() {
        return $7MfP7.argumentPlaceholder;
    }
});
Object.defineProperty(module.exports, "ArrayExpression", {
    enumerable: true,
    get: function() {
        return $7MfP7.arrayExpression;
    }
});
Object.defineProperty(module.exports, "ArrayPattern", {
    enumerable: true,
    get: function() {
        return $7MfP7.arrayPattern;
    }
});
Object.defineProperty(module.exports, "ArrayTypeAnnotation", {
    enumerable: true,
    get: function() {
        return $7MfP7.arrayTypeAnnotation;
    }
});
Object.defineProperty(module.exports, "ArrowFunctionExpression", {
    enumerable: true,
    get: function() {
        return $7MfP7.arrowFunctionExpression;
    }
});
Object.defineProperty(module.exports, "AssignmentExpression", {
    enumerable: true,
    get: function() {
        return $7MfP7.assignmentExpression;
    }
});
Object.defineProperty(module.exports, "AssignmentPattern", {
    enumerable: true,
    get: function() {
        return $7MfP7.assignmentPattern;
    }
});
Object.defineProperty(module.exports, "AwaitExpression", {
    enumerable: true,
    get: function() {
        return $7MfP7.awaitExpression;
    }
});
Object.defineProperty(module.exports, "BigIntLiteral", {
    enumerable: true,
    get: function() {
        return $7MfP7.bigIntLiteral;
    }
});
Object.defineProperty(module.exports, "BinaryExpression", {
    enumerable: true,
    get: function() {
        return $7MfP7.binaryExpression;
    }
});
Object.defineProperty(module.exports, "BindExpression", {
    enumerable: true,
    get: function() {
        return $7MfP7.bindExpression;
    }
});
Object.defineProperty(module.exports, "BlockStatement", {
    enumerable: true,
    get: function() {
        return $7MfP7.blockStatement;
    }
});
Object.defineProperty(module.exports, "BooleanLiteral", {
    enumerable: true,
    get: function() {
        return $7MfP7.booleanLiteral;
    }
});
Object.defineProperty(module.exports, "BooleanLiteralTypeAnnotation", {
    enumerable: true,
    get: function() {
        return $7MfP7.booleanLiteralTypeAnnotation;
    }
});
Object.defineProperty(module.exports, "BooleanTypeAnnotation", {
    enumerable: true,
    get: function() {
        return $7MfP7.booleanTypeAnnotation;
    }
});
Object.defineProperty(module.exports, "BreakStatement", {
    enumerable: true,
    get: function() {
        return $7MfP7.breakStatement;
    }
});
Object.defineProperty(module.exports, "CallExpression", {
    enumerable: true,
    get: function() {
        return $7MfP7.callExpression;
    }
});
Object.defineProperty(module.exports, "CatchClause", {
    enumerable: true,
    get: function() {
        return $7MfP7.catchClause;
    }
});
Object.defineProperty(module.exports, "ClassAccessorProperty", {
    enumerable: true,
    get: function() {
        return $7MfP7.classAccessorProperty;
    }
});
Object.defineProperty(module.exports, "ClassBody", {
    enumerable: true,
    get: function() {
        return $7MfP7.classBody;
    }
});
Object.defineProperty(module.exports, "ClassDeclaration", {
    enumerable: true,
    get: function() {
        return $7MfP7.classDeclaration;
    }
});
Object.defineProperty(module.exports, "ClassExpression", {
    enumerable: true,
    get: function() {
        return $7MfP7.classExpression;
    }
});
Object.defineProperty(module.exports, "ClassImplements", {
    enumerable: true,
    get: function() {
        return $7MfP7.classImplements;
    }
});
Object.defineProperty(module.exports, "ClassMethod", {
    enumerable: true,
    get: function() {
        return $7MfP7.classMethod;
    }
});
Object.defineProperty(module.exports, "ClassPrivateMethod", {
    enumerable: true,
    get: function() {
        return $7MfP7.classPrivateMethod;
    }
});
Object.defineProperty(module.exports, "ClassPrivateProperty", {
    enumerable: true,
    get: function() {
        return $7MfP7.classPrivateProperty;
    }
});
Object.defineProperty(module.exports, "ClassProperty", {
    enumerable: true,
    get: function() {
        return $7MfP7.classProperty;
    }
});
Object.defineProperty(module.exports, "ConditionalExpression", {
    enumerable: true,
    get: function() {
        return $7MfP7.conditionalExpression;
    }
});
Object.defineProperty(module.exports, "ContinueStatement", {
    enumerable: true,
    get: function() {
        return $7MfP7.continueStatement;
    }
});
Object.defineProperty(module.exports, "DebuggerStatement", {
    enumerable: true,
    get: function() {
        return $7MfP7.debuggerStatement;
    }
});
Object.defineProperty(module.exports, "DecimalLiteral", {
    enumerable: true,
    get: function() {
        return $7MfP7.decimalLiteral;
    }
});
Object.defineProperty(module.exports, "DeclareClass", {
    enumerable: true,
    get: function() {
        return $7MfP7.declareClass;
    }
});
Object.defineProperty(module.exports, "DeclareExportAllDeclaration", {
    enumerable: true,
    get: function() {
        return $7MfP7.declareExportAllDeclaration;
    }
});
Object.defineProperty(module.exports, "DeclareExportDeclaration", {
    enumerable: true,
    get: function() {
        return $7MfP7.declareExportDeclaration;
    }
});
Object.defineProperty(module.exports, "DeclareFunction", {
    enumerable: true,
    get: function() {
        return $7MfP7.declareFunction;
    }
});
Object.defineProperty(module.exports, "DeclareInterface", {
    enumerable: true,
    get: function() {
        return $7MfP7.declareInterface;
    }
});
Object.defineProperty(module.exports, "DeclareModule", {
    enumerable: true,
    get: function() {
        return $7MfP7.declareModule;
    }
});
Object.defineProperty(module.exports, "DeclareModuleExports", {
    enumerable: true,
    get: function() {
        return $7MfP7.declareModuleExports;
    }
});
Object.defineProperty(module.exports, "DeclareOpaqueType", {
    enumerable: true,
    get: function() {
        return $7MfP7.declareOpaqueType;
    }
});
Object.defineProperty(module.exports, "DeclareTypeAlias", {
    enumerable: true,
    get: function() {
        return $7MfP7.declareTypeAlias;
    }
});
Object.defineProperty(module.exports, "DeclareVariable", {
    enumerable: true,
    get: function() {
        return $7MfP7.declareVariable;
    }
});
Object.defineProperty(module.exports, "DeclaredPredicate", {
    enumerable: true,
    get: function() {
        return $7MfP7.declaredPredicate;
    }
});
Object.defineProperty(module.exports, "Decorator", {
    enumerable: true,
    get: function() {
        return $7MfP7.decorator;
    }
});
Object.defineProperty(module.exports, "Directive", {
    enumerable: true,
    get: function() {
        return $7MfP7.directive;
    }
});
Object.defineProperty(module.exports, "DirectiveLiteral", {
    enumerable: true,
    get: function() {
        return $7MfP7.directiveLiteral;
    }
});
Object.defineProperty(module.exports, "DoExpression", {
    enumerable: true,
    get: function() {
        return $7MfP7.doExpression;
    }
});
Object.defineProperty(module.exports, "DoWhileStatement", {
    enumerable: true,
    get: function() {
        return $7MfP7.doWhileStatement;
    }
});
Object.defineProperty(module.exports, "EmptyStatement", {
    enumerable: true,
    get: function() {
        return $7MfP7.emptyStatement;
    }
});
Object.defineProperty(module.exports, "EmptyTypeAnnotation", {
    enumerable: true,
    get: function() {
        return $7MfP7.emptyTypeAnnotation;
    }
});
Object.defineProperty(module.exports, "EnumBooleanBody", {
    enumerable: true,
    get: function() {
        return $7MfP7.enumBooleanBody;
    }
});
Object.defineProperty(module.exports, "EnumBooleanMember", {
    enumerable: true,
    get: function() {
        return $7MfP7.enumBooleanMember;
    }
});
Object.defineProperty(module.exports, "EnumDeclaration", {
    enumerable: true,
    get: function() {
        return $7MfP7.enumDeclaration;
    }
});
Object.defineProperty(module.exports, "EnumDefaultedMember", {
    enumerable: true,
    get: function() {
        return $7MfP7.enumDefaultedMember;
    }
});
Object.defineProperty(module.exports, "EnumNumberBody", {
    enumerable: true,
    get: function() {
        return $7MfP7.enumNumberBody;
    }
});
Object.defineProperty(module.exports, "EnumNumberMember", {
    enumerable: true,
    get: function() {
        return $7MfP7.enumNumberMember;
    }
});
Object.defineProperty(module.exports, "EnumStringBody", {
    enumerable: true,
    get: function() {
        return $7MfP7.enumStringBody;
    }
});
Object.defineProperty(module.exports, "EnumStringMember", {
    enumerable: true,
    get: function() {
        return $7MfP7.enumStringMember;
    }
});
Object.defineProperty(module.exports, "EnumSymbolBody", {
    enumerable: true,
    get: function() {
        return $7MfP7.enumSymbolBody;
    }
});
Object.defineProperty(module.exports, "ExistsTypeAnnotation", {
    enumerable: true,
    get: function() {
        return $7MfP7.existsTypeAnnotation;
    }
});
Object.defineProperty(module.exports, "ExportAllDeclaration", {
    enumerable: true,
    get: function() {
        return $7MfP7.exportAllDeclaration;
    }
});
Object.defineProperty(module.exports, "ExportDefaultDeclaration", {
    enumerable: true,
    get: function() {
        return $7MfP7.exportDefaultDeclaration;
    }
});
Object.defineProperty(module.exports, "ExportDefaultSpecifier", {
    enumerable: true,
    get: function() {
        return $7MfP7.exportDefaultSpecifier;
    }
});
Object.defineProperty(module.exports, "ExportNamedDeclaration", {
    enumerable: true,
    get: function() {
        return $7MfP7.exportNamedDeclaration;
    }
});
Object.defineProperty(module.exports, "ExportNamespaceSpecifier", {
    enumerable: true,
    get: function() {
        return $7MfP7.exportNamespaceSpecifier;
    }
});
Object.defineProperty(module.exports, "ExportSpecifier", {
    enumerable: true,
    get: function() {
        return $7MfP7.exportSpecifier;
    }
});
Object.defineProperty(module.exports, "ExpressionStatement", {
    enumerable: true,
    get: function() {
        return $7MfP7.expressionStatement;
    }
});
Object.defineProperty(module.exports, "File", {
    enumerable: true,
    get: function() {
        return $7MfP7.file;
    }
});
Object.defineProperty(module.exports, "ForInStatement", {
    enumerable: true,
    get: function() {
        return $7MfP7.forInStatement;
    }
});
Object.defineProperty(module.exports, "ForOfStatement", {
    enumerable: true,
    get: function() {
        return $7MfP7.forOfStatement;
    }
});
Object.defineProperty(module.exports, "ForStatement", {
    enumerable: true,
    get: function() {
        return $7MfP7.forStatement;
    }
});
Object.defineProperty(module.exports, "FunctionDeclaration", {
    enumerable: true,
    get: function() {
        return $7MfP7.functionDeclaration;
    }
});
Object.defineProperty(module.exports, "FunctionExpression", {
    enumerable: true,
    get: function() {
        return $7MfP7.functionExpression;
    }
});
Object.defineProperty(module.exports, "FunctionTypeAnnotation", {
    enumerable: true,
    get: function() {
        return $7MfP7.functionTypeAnnotation;
    }
});
Object.defineProperty(module.exports, "FunctionTypeParam", {
    enumerable: true,
    get: function() {
        return $7MfP7.functionTypeParam;
    }
});
Object.defineProperty(module.exports, "GenericTypeAnnotation", {
    enumerable: true,
    get: function() {
        return $7MfP7.genericTypeAnnotation;
    }
});
Object.defineProperty(module.exports, "Identifier", {
    enumerable: true,
    get: function() {
        return $7MfP7.identifier;
    }
});
Object.defineProperty(module.exports, "IfStatement", {
    enumerable: true,
    get: function() {
        return $7MfP7.ifStatement;
    }
});
Object.defineProperty(module.exports, "Import", {
    enumerable: true,
    get: function() {
        return $7MfP7.import;
    }
});
Object.defineProperty(module.exports, "ImportAttribute", {
    enumerable: true,
    get: function() {
        return $7MfP7.importAttribute;
    }
});
Object.defineProperty(module.exports, "ImportDeclaration", {
    enumerable: true,
    get: function() {
        return $7MfP7.importDeclaration;
    }
});
Object.defineProperty(module.exports, "ImportDefaultSpecifier", {
    enumerable: true,
    get: function() {
        return $7MfP7.importDefaultSpecifier;
    }
});
Object.defineProperty(module.exports, "ImportExpression", {
    enumerable: true,
    get: function() {
        return $7MfP7.importExpression;
    }
});
Object.defineProperty(module.exports, "ImportNamespaceSpecifier", {
    enumerable: true,
    get: function() {
        return $7MfP7.importNamespaceSpecifier;
    }
});
Object.defineProperty(module.exports, "ImportSpecifier", {
    enumerable: true,
    get: function() {
        return $7MfP7.importSpecifier;
    }
});
Object.defineProperty(module.exports, "IndexedAccessType", {
    enumerable: true,
    get: function() {
        return $7MfP7.indexedAccessType;
    }
});
Object.defineProperty(module.exports, "InferredPredicate", {
    enumerable: true,
    get: function() {
        return $7MfP7.inferredPredicate;
    }
});
Object.defineProperty(module.exports, "InterfaceDeclaration", {
    enumerable: true,
    get: function() {
        return $7MfP7.interfaceDeclaration;
    }
});
Object.defineProperty(module.exports, "InterfaceExtends", {
    enumerable: true,
    get: function() {
        return $7MfP7.interfaceExtends;
    }
});
Object.defineProperty(module.exports, "InterfaceTypeAnnotation", {
    enumerable: true,
    get: function() {
        return $7MfP7.interfaceTypeAnnotation;
    }
});
Object.defineProperty(module.exports, "InterpreterDirective", {
    enumerable: true,
    get: function() {
        return $7MfP7.interpreterDirective;
    }
});
Object.defineProperty(module.exports, "IntersectionTypeAnnotation", {
    enumerable: true,
    get: function() {
        return $7MfP7.intersectionTypeAnnotation;
    }
});
Object.defineProperty(module.exports, "JSXAttribute", {
    enumerable: true,
    get: function() {
        return $7MfP7.jsxAttribute;
    }
});
Object.defineProperty(module.exports, "JSXClosingElement", {
    enumerable: true,
    get: function() {
        return $7MfP7.jsxClosingElement;
    }
});
Object.defineProperty(module.exports, "JSXClosingFragment", {
    enumerable: true,
    get: function() {
        return $7MfP7.jsxClosingFragment;
    }
});
Object.defineProperty(module.exports, "JSXElement", {
    enumerable: true,
    get: function() {
        return $7MfP7.jsxElement;
    }
});
Object.defineProperty(module.exports, "JSXEmptyExpression", {
    enumerable: true,
    get: function() {
        return $7MfP7.jsxEmptyExpression;
    }
});
Object.defineProperty(module.exports, "JSXExpressionContainer", {
    enumerable: true,
    get: function() {
        return $7MfP7.jsxExpressionContainer;
    }
});
Object.defineProperty(module.exports, "JSXFragment", {
    enumerable: true,
    get: function() {
        return $7MfP7.jsxFragment;
    }
});
Object.defineProperty(module.exports, "JSXIdentifier", {
    enumerable: true,
    get: function() {
        return $7MfP7.jsxIdentifier;
    }
});
Object.defineProperty(module.exports, "JSXMemberExpression", {
    enumerable: true,
    get: function() {
        return $7MfP7.jsxMemberExpression;
    }
});
Object.defineProperty(module.exports, "JSXNamespacedName", {
    enumerable: true,
    get: function() {
        return $7MfP7.jsxNamespacedName;
    }
});
Object.defineProperty(module.exports, "JSXOpeningElement", {
    enumerable: true,
    get: function() {
        return $7MfP7.jsxOpeningElement;
    }
});
Object.defineProperty(module.exports, "JSXOpeningFragment", {
    enumerable: true,
    get: function() {
        return $7MfP7.jsxOpeningFragment;
    }
});
Object.defineProperty(module.exports, "JSXSpreadAttribute", {
    enumerable: true,
    get: function() {
        return $7MfP7.jsxSpreadAttribute;
    }
});
Object.defineProperty(module.exports, "JSXSpreadChild", {
    enumerable: true,
    get: function() {
        return $7MfP7.jsxSpreadChild;
    }
});
Object.defineProperty(module.exports, "JSXText", {
    enumerable: true,
    get: function() {
        return $7MfP7.jsxText;
    }
});
Object.defineProperty(module.exports, "LabeledStatement", {
    enumerable: true,
    get: function() {
        return $7MfP7.labeledStatement;
    }
});
Object.defineProperty(module.exports, "LogicalExpression", {
    enumerable: true,
    get: function() {
        return $7MfP7.logicalExpression;
    }
});
Object.defineProperty(module.exports, "MemberExpression", {
    enumerable: true,
    get: function() {
        return $7MfP7.memberExpression;
    }
});
Object.defineProperty(module.exports, "MetaProperty", {
    enumerable: true,
    get: function() {
        return $7MfP7.metaProperty;
    }
});
Object.defineProperty(module.exports, "MixedTypeAnnotation", {
    enumerable: true,
    get: function() {
        return $7MfP7.mixedTypeAnnotation;
    }
});
Object.defineProperty(module.exports, "ModuleExpression", {
    enumerable: true,
    get: function() {
        return $7MfP7.moduleExpression;
    }
});
Object.defineProperty(module.exports, "NewExpression", {
    enumerable: true,
    get: function() {
        return $7MfP7.newExpression;
    }
});
Object.defineProperty(module.exports, "Noop", {
    enumerable: true,
    get: function() {
        return $7MfP7.noop;
    }
});
Object.defineProperty(module.exports, "NullLiteral", {
    enumerable: true,
    get: function() {
        return $7MfP7.nullLiteral;
    }
});
Object.defineProperty(module.exports, "NullLiteralTypeAnnotation", {
    enumerable: true,
    get: function() {
        return $7MfP7.nullLiteralTypeAnnotation;
    }
});
Object.defineProperty(module.exports, "NullableTypeAnnotation", {
    enumerable: true,
    get: function() {
        return $7MfP7.nullableTypeAnnotation;
    }
});
Object.defineProperty(module.exports, "NumberLiteral", {
    enumerable: true,
    get: function() {
        return $7MfP7.numberLiteral;
    }
});
Object.defineProperty(module.exports, "NumberLiteralTypeAnnotation", {
    enumerable: true,
    get: function() {
        return $7MfP7.numberLiteralTypeAnnotation;
    }
});
Object.defineProperty(module.exports, "NumberTypeAnnotation", {
    enumerable: true,
    get: function() {
        return $7MfP7.numberTypeAnnotation;
    }
});
Object.defineProperty(module.exports, "NumericLiteral", {
    enumerable: true,
    get: function() {
        return $7MfP7.numericLiteral;
    }
});
Object.defineProperty(module.exports, "ObjectExpression", {
    enumerable: true,
    get: function() {
        return $7MfP7.objectExpression;
    }
});
Object.defineProperty(module.exports, "ObjectMethod", {
    enumerable: true,
    get: function() {
        return $7MfP7.objectMethod;
    }
});
Object.defineProperty(module.exports, "ObjectPattern", {
    enumerable: true,
    get: function() {
        return $7MfP7.objectPattern;
    }
});
Object.defineProperty(module.exports, "ObjectProperty", {
    enumerable: true,
    get: function() {
        return $7MfP7.objectProperty;
    }
});
Object.defineProperty(module.exports, "ObjectTypeAnnotation", {
    enumerable: true,
    get: function() {
        return $7MfP7.objectTypeAnnotation;
    }
});
Object.defineProperty(module.exports, "ObjectTypeCallProperty", {
    enumerable: true,
    get: function() {
        return $7MfP7.objectTypeCallProperty;
    }
});
Object.defineProperty(module.exports, "ObjectTypeIndexer", {
    enumerable: true,
    get: function() {
        return $7MfP7.objectTypeIndexer;
    }
});
Object.defineProperty(module.exports, "ObjectTypeInternalSlot", {
    enumerable: true,
    get: function() {
        return $7MfP7.objectTypeInternalSlot;
    }
});
Object.defineProperty(module.exports, "ObjectTypeProperty", {
    enumerable: true,
    get: function() {
        return $7MfP7.objectTypeProperty;
    }
});
Object.defineProperty(module.exports, "ObjectTypeSpreadProperty", {
    enumerable: true,
    get: function() {
        return $7MfP7.objectTypeSpreadProperty;
    }
});
Object.defineProperty(module.exports, "OpaqueType", {
    enumerable: true,
    get: function() {
        return $7MfP7.opaqueType;
    }
});
Object.defineProperty(module.exports, "OptionalCallExpression", {
    enumerable: true,
    get: function() {
        return $7MfP7.optionalCallExpression;
    }
});
Object.defineProperty(module.exports, "OptionalIndexedAccessType", {
    enumerable: true,
    get: function() {
        return $7MfP7.optionalIndexedAccessType;
    }
});
Object.defineProperty(module.exports, "OptionalMemberExpression", {
    enumerable: true,
    get: function() {
        return $7MfP7.optionalMemberExpression;
    }
});
Object.defineProperty(module.exports, "ParenthesizedExpression", {
    enumerable: true,
    get: function() {
        return $7MfP7.parenthesizedExpression;
    }
});
Object.defineProperty(module.exports, "PipelineBareFunction", {
    enumerable: true,
    get: function() {
        return $7MfP7.pipelineBareFunction;
    }
});
Object.defineProperty(module.exports, "PipelinePrimaryTopicReference", {
    enumerable: true,
    get: function() {
        return $7MfP7.pipelinePrimaryTopicReference;
    }
});
Object.defineProperty(module.exports, "PipelineTopicExpression", {
    enumerable: true,
    get: function() {
        return $7MfP7.pipelineTopicExpression;
    }
});
Object.defineProperty(module.exports, "Placeholder", {
    enumerable: true,
    get: function() {
        return $7MfP7.placeholder;
    }
});
Object.defineProperty(module.exports, "PrivateName", {
    enumerable: true,
    get: function() {
        return $7MfP7.privateName;
    }
});
Object.defineProperty(module.exports, "Program", {
    enumerable: true,
    get: function() {
        return $7MfP7.program;
    }
});
Object.defineProperty(module.exports, "QualifiedTypeIdentifier", {
    enumerable: true,
    get: function() {
        return $7MfP7.qualifiedTypeIdentifier;
    }
});
Object.defineProperty(module.exports, "RecordExpression", {
    enumerable: true,
    get: function() {
        return $7MfP7.recordExpression;
    }
});
Object.defineProperty(module.exports, "RegExpLiteral", {
    enumerable: true,
    get: function() {
        return $7MfP7.regExpLiteral;
    }
});
Object.defineProperty(module.exports, "RegexLiteral", {
    enumerable: true,
    get: function() {
        return $7MfP7.regexLiteral;
    }
});
Object.defineProperty(module.exports, "RestElement", {
    enumerable: true,
    get: function() {
        return $7MfP7.restElement;
    }
});
Object.defineProperty(module.exports, "RestProperty", {
    enumerable: true,
    get: function() {
        return $7MfP7.restProperty;
    }
});
Object.defineProperty(module.exports, "ReturnStatement", {
    enumerable: true,
    get: function() {
        return $7MfP7.returnStatement;
    }
});
Object.defineProperty(module.exports, "SequenceExpression", {
    enumerable: true,
    get: function() {
        return $7MfP7.sequenceExpression;
    }
});
Object.defineProperty(module.exports, "SpreadElement", {
    enumerable: true,
    get: function() {
        return $7MfP7.spreadElement;
    }
});
Object.defineProperty(module.exports, "SpreadProperty", {
    enumerable: true,
    get: function() {
        return $7MfP7.spreadProperty;
    }
});
Object.defineProperty(module.exports, "StaticBlock", {
    enumerable: true,
    get: function() {
        return $7MfP7.staticBlock;
    }
});
Object.defineProperty(module.exports, "StringLiteral", {
    enumerable: true,
    get: function() {
        return $7MfP7.stringLiteral;
    }
});
Object.defineProperty(module.exports, "StringLiteralTypeAnnotation", {
    enumerable: true,
    get: function() {
        return $7MfP7.stringLiteralTypeAnnotation;
    }
});
Object.defineProperty(module.exports, "StringTypeAnnotation", {
    enumerable: true,
    get: function() {
        return $7MfP7.stringTypeAnnotation;
    }
});
Object.defineProperty(module.exports, "Super", {
    enumerable: true,
    get: function() {
        return $7MfP7.super;
    }
});
Object.defineProperty(module.exports, "SwitchCase", {
    enumerable: true,
    get: function() {
        return $7MfP7.switchCase;
    }
});
Object.defineProperty(module.exports, "SwitchStatement", {
    enumerable: true,
    get: function() {
        return $7MfP7.switchStatement;
    }
});
Object.defineProperty(module.exports, "SymbolTypeAnnotation", {
    enumerable: true,
    get: function() {
        return $7MfP7.symbolTypeAnnotation;
    }
});
Object.defineProperty(module.exports, "TSAnyKeyword", {
    enumerable: true,
    get: function() {
        return $7MfP7.tsAnyKeyword;
    }
});
Object.defineProperty(module.exports, "TSArrayType", {
    enumerable: true,
    get: function() {
        return $7MfP7.tsArrayType;
    }
});
Object.defineProperty(module.exports, "TSAsExpression", {
    enumerable: true,
    get: function() {
        return $7MfP7.tsAsExpression;
    }
});
Object.defineProperty(module.exports, "TSBigIntKeyword", {
    enumerable: true,
    get: function() {
        return $7MfP7.tsBigIntKeyword;
    }
});
Object.defineProperty(module.exports, "TSBooleanKeyword", {
    enumerable: true,
    get: function() {
        return $7MfP7.tsBooleanKeyword;
    }
});
Object.defineProperty(module.exports, "TSCallSignatureDeclaration", {
    enumerable: true,
    get: function() {
        return $7MfP7.tsCallSignatureDeclaration;
    }
});
Object.defineProperty(module.exports, "TSConditionalType", {
    enumerable: true,
    get: function() {
        return $7MfP7.tsConditionalType;
    }
});
Object.defineProperty(module.exports, "TSConstructSignatureDeclaration", {
    enumerable: true,
    get: function() {
        return $7MfP7.tsConstructSignatureDeclaration;
    }
});
Object.defineProperty(module.exports, "TSConstructorType", {
    enumerable: true,
    get: function() {
        return $7MfP7.tsConstructorType;
    }
});
Object.defineProperty(module.exports, "TSDeclareFunction", {
    enumerable: true,
    get: function() {
        return $7MfP7.tsDeclareFunction;
    }
});
Object.defineProperty(module.exports, "TSDeclareMethod", {
    enumerable: true,
    get: function() {
        return $7MfP7.tsDeclareMethod;
    }
});
Object.defineProperty(module.exports, "TSEnumDeclaration", {
    enumerable: true,
    get: function() {
        return $7MfP7.tsEnumDeclaration;
    }
});
Object.defineProperty(module.exports, "TSEnumMember", {
    enumerable: true,
    get: function() {
        return $7MfP7.tsEnumMember;
    }
});
Object.defineProperty(module.exports, "TSExportAssignment", {
    enumerable: true,
    get: function() {
        return $7MfP7.tsExportAssignment;
    }
});
Object.defineProperty(module.exports, "TSExpressionWithTypeArguments", {
    enumerable: true,
    get: function() {
        return $7MfP7.tsExpressionWithTypeArguments;
    }
});
Object.defineProperty(module.exports, "TSExternalModuleReference", {
    enumerable: true,
    get: function() {
        return $7MfP7.tsExternalModuleReference;
    }
});
Object.defineProperty(module.exports, "TSFunctionType", {
    enumerable: true,
    get: function() {
        return $7MfP7.tsFunctionType;
    }
});
Object.defineProperty(module.exports, "TSImportEqualsDeclaration", {
    enumerable: true,
    get: function() {
        return $7MfP7.tsImportEqualsDeclaration;
    }
});
Object.defineProperty(module.exports, "TSImportType", {
    enumerable: true,
    get: function() {
        return $7MfP7.tsImportType;
    }
});
Object.defineProperty(module.exports, "TSIndexSignature", {
    enumerable: true,
    get: function() {
        return $7MfP7.tsIndexSignature;
    }
});
Object.defineProperty(module.exports, "TSIndexedAccessType", {
    enumerable: true,
    get: function() {
        return $7MfP7.tsIndexedAccessType;
    }
});
Object.defineProperty(module.exports, "TSInferType", {
    enumerable: true,
    get: function() {
        return $7MfP7.tsInferType;
    }
});
Object.defineProperty(module.exports, "TSInstantiationExpression", {
    enumerable: true,
    get: function() {
        return $7MfP7.tsInstantiationExpression;
    }
});
Object.defineProperty(module.exports, "TSInterfaceBody", {
    enumerable: true,
    get: function() {
        return $7MfP7.tsInterfaceBody;
    }
});
Object.defineProperty(module.exports, "TSInterfaceDeclaration", {
    enumerable: true,
    get: function() {
        return $7MfP7.tsInterfaceDeclaration;
    }
});
Object.defineProperty(module.exports, "TSIntersectionType", {
    enumerable: true,
    get: function() {
        return $7MfP7.tsIntersectionType;
    }
});
Object.defineProperty(module.exports, "TSIntrinsicKeyword", {
    enumerable: true,
    get: function() {
        return $7MfP7.tsIntrinsicKeyword;
    }
});
Object.defineProperty(module.exports, "TSLiteralType", {
    enumerable: true,
    get: function() {
        return $7MfP7.tsLiteralType;
    }
});
Object.defineProperty(module.exports, "TSMappedType", {
    enumerable: true,
    get: function() {
        return $7MfP7.tsMappedType;
    }
});
Object.defineProperty(module.exports, "TSMethodSignature", {
    enumerable: true,
    get: function() {
        return $7MfP7.tsMethodSignature;
    }
});
Object.defineProperty(module.exports, "TSModuleBlock", {
    enumerable: true,
    get: function() {
        return $7MfP7.tsModuleBlock;
    }
});
Object.defineProperty(module.exports, "TSModuleDeclaration", {
    enumerable: true,
    get: function() {
        return $7MfP7.tsModuleDeclaration;
    }
});
Object.defineProperty(module.exports, "TSNamedTupleMember", {
    enumerable: true,
    get: function() {
        return $7MfP7.tsNamedTupleMember;
    }
});
Object.defineProperty(module.exports, "TSNamespaceExportDeclaration", {
    enumerable: true,
    get: function() {
        return $7MfP7.tsNamespaceExportDeclaration;
    }
});
Object.defineProperty(module.exports, "TSNeverKeyword", {
    enumerable: true,
    get: function() {
        return $7MfP7.tsNeverKeyword;
    }
});
Object.defineProperty(module.exports, "TSNonNullExpression", {
    enumerable: true,
    get: function() {
        return $7MfP7.tsNonNullExpression;
    }
});
Object.defineProperty(module.exports, "TSNullKeyword", {
    enumerable: true,
    get: function() {
        return $7MfP7.tsNullKeyword;
    }
});
Object.defineProperty(module.exports, "TSNumberKeyword", {
    enumerable: true,
    get: function() {
        return $7MfP7.tsNumberKeyword;
    }
});
Object.defineProperty(module.exports, "TSObjectKeyword", {
    enumerable: true,
    get: function() {
        return $7MfP7.tsObjectKeyword;
    }
});
Object.defineProperty(module.exports, "TSOptionalType", {
    enumerable: true,
    get: function() {
        return $7MfP7.tsOptionalType;
    }
});
Object.defineProperty(module.exports, "TSParameterProperty", {
    enumerable: true,
    get: function() {
        return $7MfP7.tsParameterProperty;
    }
});
Object.defineProperty(module.exports, "TSParenthesizedType", {
    enumerable: true,
    get: function() {
        return $7MfP7.tsParenthesizedType;
    }
});
Object.defineProperty(module.exports, "TSPropertySignature", {
    enumerable: true,
    get: function() {
        return $7MfP7.tsPropertySignature;
    }
});
Object.defineProperty(module.exports, "TSQualifiedName", {
    enumerable: true,
    get: function() {
        return $7MfP7.tsQualifiedName;
    }
});
Object.defineProperty(module.exports, "TSRestType", {
    enumerable: true,
    get: function() {
        return $7MfP7.tsRestType;
    }
});
Object.defineProperty(module.exports, "TSSatisfiesExpression", {
    enumerable: true,
    get: function() {
        return $7MfP7.tsSatisfiesExpression;
    }
});
Object.defineProperty(module.exports, "TSStringKeyword", {
    enumerable: true,
    get: function() {
        return $7MfP7.tsStringKeyword;
    }
});
Object.defineProperty(module.exports, "TSSymbolKeyword", {
    enumerable: true,
    get: function() {
        return $7MfP7.tsSymbolKeyword;
    }
});
Object.defineProperty(module.exports, "TSThisType", {
    enumerable: true,
    get: function() {
        return $7MfP7.tsThisType;
    }
});
Object.defineProperty(module.exports, "TSTupleType", {
    enumerable: true,
    get: function() {
        return $7MfP7.tsTupleType;
    }
});
Object.defineProperty(module.exports, "TSTypeAliasDeclaration", {
    enumerable: true,
    get: function() {
        return $7MfP7.tsTypeAliasDeclaration;
    }
});
Object.defineProperty(module.exports, "TSTypeAnnotation", {
    enumerable: true,
    get: function() {
        return $7MfP7.tsTypeAnnotation;
    }
});
Object.defineProperty(module.exports, "TSTypeAssertion", {
    enumerable: true,
    get: function() {
        return $7MfP7.tsTypeAssertion;
    }
});
Object.defineProperty(module.exports, "TSTypeLiteral", {
    enumerable: true,
    get: function() {
        return $7MfP7.tsTypeLiteral;
    }
});
Object.defineProperty(module.exports, "TSTypeOperator", {
    enumerable: true,
    get: function() {
        return $7MfP7.tsTypeOperator;
    }
});
Object.defineProperty(module.exports, "TSTypeParameter", {
    enumerable: true,
    get: function() {
        return $7MfP7.tsTypeParameter;
    }
});
Object.defineProperty(module.exports, "TSTypeParameterDeclaration", {
    enumerable: true,
    get: function() {
        return $7MfP7.tsTypeParameterDeclaration;
    }
});
Object.defineProperty(module.exports, "TSTypeParameterInstantiation", {
    enumerable: true,
    get: function() {
        return $7MfP7.tsTypeParameterInstantiation;
    }
});
Object.defineProperty(module.exports, "TSTypePredicate", {
    enumerable: true,
    get: function() {
        return $7MfP7.tsTypePredicate;
    }
});
Object.defineProperty(module.exports, "TSTypeQuery", {
    enumerable: true,
    get: function() {
        return $7MfP7.tsTypeQuery;
    }
});
Object.defineProperty(module.exports, "TSTypeReference", {
    enumerable: true,
    get: function() {
        return $7MfP7.tsTypeReference;
    }
});
Object.defineProperty(module.exports, "TSUndefinedKeyword", {
    enumerable: true,
    get: function() {
        return $7MfP7.tsUndefinedKeyword;
    }
});
Object.defineProperty(module.exports, "TSUnionType", {
    enumerable: true,
    get: function() {
        return $7MfP7.tsUnionType;
    }
});
Object.defineProperty(module.exports, "TSUnknownKeyword", {
    enumerable: true,
    get: function() {
        return $7MfP7.tsUnknownKeyword;
    }
});
Object.defineProperty(module.exports, "TSVoidKeyword", {
    enumerable: true,
    get: function() {
        return $7MfP7.tsVoidKeyword;
    }
});
Object.defineProperty(module.exports, "TaggedTemplateExpression", {
    enumerable: true,
    get: function() {
        return $7MfP7.taggedTemplateExpression;
    }
});
Object.defineProperty(module.exports, "TemplateElement", {
    enumerable: true,
    get: function() {
        return $7MfP7.templateElement;
    }
});
Object.defineProperty(module.exports, "TemplateLiteral", {
    enumerable: true,
    get: function() {
        return $7MfP7.templateLiteral;
    }
});
Object.defineProperty(module.exports, "ThisExpression", {
    enumerable: true,
    get: function() {
        return $7MfP7.thisExpression;
    }
});
Object.defineProperty(module.exports, "ThisTypeAnnotation", {
    enumerable: true,
    get: function() {
        return $7MfP7.thisTypeAnnotation;
    }
});
Object.defineProperty(module.exports, "ThrowStatement", {
    enumerable: true,
    get: function() {
        return $7MfP7.throwStatement;
    }
});
Object.defineProperty(module.exports, "TopicReference", {
    enumerable: true,
    get: function() {
        return $7MfP7.topicReference;
    }
});
Object.defineProperty(module.exports, "TryStatement", {
    enumerable: true,
    get: function() {
        return $7MfP7.tryStatement;
    }
});
Object.defineProperty(module.exports, "TupleExpression", {
    enumerable: true,
    get: function() {
        return $7MfP7.tupleExpression;
    }
});
Object.defineProperty(module.exports, "TupleTypeAnnotation", {
    enumerable: true,
    get: function() {
        return $7MfP7.tupleTypeAnnotation;
    }
});
Object.defineProperty(module.exports, "TypeAlias", {
    enumerable: true,
    get: function() {
        return $7MfP7.typeAlias;
    }
});
Object.defineProperty(module.exports, "TypeAnnotation", {
    enumerable: true,
    get: function() {
        return $7MfP7.typeAnnotation;
    }
});
Object.defineProperty(module.exports, "TypeCastExpression", {
    enumerable: true,
    get: function() {
        return $7MfP7.typeCastExpression;
    }
});
Object.defineProperty(module.exports, "TypeParameter", {
    enumerable: true,
    get: function() {
        return $7MfP7.typeParameter;
    }
});
Object.defineProperty(module.exports, "TypeParameterDeclaration", {
    enumerable: true,
    get: function() {
        return $7MfP7.typeParameterDeclaration;
    }
});
Object.defineProperty(module.exports, "TypeParameterInstantiation", {
    enumerable: true,
    get: function() {
        return $7MfP7.typeParameterInstantiation;
    }
});
Object.defineProperty(module.exports, "TypeofTypeAnnotation", {
    enumerable: true,
    get: function() {
        return $7MfP7.typeofTypeAnnotation;
    }
});
Object.defineProperty(module.exports, "UnaryExpression", {
    enumerable: true,
    get: function() {
        return $7MfP7.unaryExpression;
    }
});
Object.defineProperty(module.exports, "UnionTypeAnnotation", {
    enumerable: true,
    get: function() {
        return $7MfP7.unionTypeAnnotation;
    }
});
Object.defineProperty(module.exports, "UpdateExpression", {
    enumerable: true,
    get: function() {
        return $7MfP7.updateExpression;
    }
});
Object.defineProperty(module.exports, "V8IntrinsicIdentifier", {
    enumerable: true,
    get: function() {
        return $7MfP7.v8IntrinsicIdentifier;
    }
});
Object.defineProperty(module.exports, "VariableDeclaration", {
    enumerable: true,
    get: function() {
        return $7MfP7.variableDeclaration;
    }
});
Object.defineProperty(module.exports, "VariableDeclarator", {
    enumerable: true,
    get: function() {
        return $7MfP7.variableDeclarator;
    }
});
Object.defineProperty(module.exports, "Variance", {
    enumerable: true,
    get: function() {
        return $7MfP7.variance;
    }
});
Object.defineProperty(module.exports, "VoidTypeAnnotation", {
    enumerable: true,
    get: function() {
        return $7MfP7.voidTypeAnnotation;
    }
});
Object.defineProperty(module.exports, "WhileStatement", {
    enumerable: true,
    get: function() {
        return $7MfP7.whileStatement;
    }
});
Object.defineProperty(module.exports, "WithStatement", {
    enumerable: true,
    get: function() {
        return $7MfP7.withStatement;
    }
});
Object.defineProperty(module.exports, "YieldExpression", {
    enumerable: true,
    get: function() {
        return $7MfP7.yieldExpression;
    }
});

var $7MfP7 = parcelRequire("7MfP7");

});

parcelRegister("hURFO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.buildUndefinedNode = $d0b14d10d9c09939$var$buildUndefinedNode;

var $7MfP7 = parcelRequire("7MfP7");
function $d0b14d10d9c09939$var$buildUndefinedNode() {
    return (0, $7MfP7.unaryExpression)("void", (0, $7MfP7.numericLiteral)(0), true);
}

});

parcelRegister("k6qdD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ea28b4bc9d93b740$var$cloneNode;

var $7TNHg = parcelRequire("7TNHg");

var $2G7FY = parcelRequire("2G7FY");
const { hasOwn: $ea28b4bc9d93b740$var$hasOwn } = {
    hasOwn: Function.call.bind(Object.prototype.hasOwnProperty)
};
function $ea28b4bc9d93b740$var$cloneIfNode(obj, deep, withoutLoc, commentsCache) {
    if (obj && typeof obj.type === "string") return $ea28b4bc9d93b740$var$cloneNodeInternal(obj, deep, withoutLoc, commentsCache);
    return obj;
}
function $ea28b4bc9d93b740$var$cloneIfNodeOrArray(obj, deep, withoutLoc, commentsCache) {
    if (Array.isArray(obj)) return obj.map((node)=>$ea28b4bc9d93b740$var$cloneIfNode(node, deep, withoutLoc, commentsCache));
    return $ea28b4bc9d93b740$var$cloneIfNode(obj, deep, withoutLoc, commentsCache);
}
function $ea28b4bc9d93b740$var$cloneNode(node, deep = true, withoutLoc = false) {
    return $ea28b4bc9d93b740$var$cloneNodeInternal(node, deep, withoutLoc, new Map());
}
function $ea28b4bc9d93b740$var$cloneNodeInternal(node, deep = true, withoutLoc = false, commentsCache) {
    if (!node) return node;
    const { type: type } = node;
    const newNode = {
        type: node.type
    };
    if ((0, $2G7FY.isIdentifier)(node)) {
        newNode.name = node.name;
        if ($ea28b4bc9d93b740$var$hasOwn(node, "optional") && typeof node.optional === "boolean") newNode.optional = node.optional;
        if ($ea28b4bc9d93b740$var$hasOwn(node, "typeAnnotation")) newNode.typeAnnotation = deep ? $ea28b4bc9d93b740$var$cloneIfNodeOrArray(node.typeAnnotation, true, withoutLoc, commentsCache) : node.typeAnnotation;
    } else if (!$ea28b4bc9d93b740$var$hasOwn($7TNHg.NODE_FIELDS, type)) throw new Error(`Unknown node type: "${type}"`);
    else {
        for (const field of Object.keys($7TNHg.NODE_FIELDS[type]))if ($ea28b4bc9d93b740$var$hasOwn(node, field)) {
            if (deep) newNode[field] = (0, $2G7FY.isFile)(node) && field === "comments" ? $ea28b4bc9d93b740$var$maybeCloneComments(node.comments, deep, withoutLoc, commentsCache) : $ea28b4bc9d93b740$var$cloneIfNodeOrArray(node[field], true, withoutLoc, commentsCache);
            else newNode[field] = node[field];
        }
    }
    if ($ea28b4bc9d93b740$var$hasOwn(node, "loc")) {
        if (withoutLoc) newNode.loc = null;
        else newNode.loc = node.loc;
    }
    if ($ea28b4bc9d93b740$var$hasOwn(node, "leadingComments")) newNode.leadingComments = $ea28b4bc9d93b740$var$maybeCloneComments(node.leadingComments, deep, withoutLoc, commentsCache);
    if ($ea28b4bc9d93b740$var$hasOwn(node, "innerComments")) newNode.innerComments = $ea28b4bc9d93b740$var$maybeCloneComments(node.innerComments, deep, withoutLoc, commentsCache);
    if ($ea28b4bc9d93b740$var$hasOwn(node, "trailingComments")) newNode.trailingComments = $ea28b4bc9d93b740$var$maybeCloneComments(node.trailingComments, deep, withoutLoc, commentsCache);
    if ($ea28b4bc9d93b740$var$hasOwn(node, "extra")) newNode.extra = Object.assign({}, node.extra);
    return newNode;
}
function $ea28b4bc9d93b740$var$maybeCloneComments(comments, deep, withoutLoc, commentsCache) {
    if (!comments || !deep) return comments;
    return comments.map((comment)=>{
        const cache = commentsCache.get(comment);
        if (cache) return cache;
        const { type: type, value: value, loc: loc } = comment;
        const ret = {
            type: type,
            value: value,
            loc: loc
        };
        if (withoutLoc) ret.loc = null;
        commentsCache.set(comment, ret);
        return ret;
    });
}

});

parcelRegister("2xseA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1d94909438483674$var$clone;

var $k6qdD = parcelRequire("k6qdD");
function $1d94909438483674$var$clone(node) {
    return (0, $k6qdD.default)(node, false);
}

});

parcelRegister("9iQ12", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6c5e24c1184dcf0d$var$cloneDeep;

var $k6qdD = parcelRequire("k6qdD");
function $6c5e24c1184dcf0d$var$cloneDeep(node) {
    return (0, $k6qdD.default)(node);
}

});

parcelRegister("ccfaL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8e12600085448905$var$cloneDeepWithoutLoc;

var $k6qdD = parcelRequire("k6qdD");
function $8e12600085448905$var$cloneDeepWithoutLoc(node) {
    return (0, $k6qdD.default)(node, true, true);
}

});

parcelRegister("5T62d", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4496c52f2afe8ac9$var$cloneWithoutLoc;

var $k6qdD = parcelRequire("k6qdD");
function $4496c52f2afe8ac9$var$cloneWithoutLoc(node) {
    return (0, $k6qdD.default)(node, false, true);
}

});

parcelRegister("le20m", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f73c75e9a8a38441$var$addComment;

var $7XyMa = parcelRequire("7XyMa");
function $f73c75e9a8a38441$var$addComment(node, type, content, line) {
    return (0, $7XyMa.default)(node, type, [
        {
            type: line ? "CommentLine" : "CommentBlock",
            value: content
        }
    ]);
}

});
parcelRegister("7XyMa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5cb904de1ee50b41$var$addComments;
function $5cb904de1ee50b41$var$addComments(node, type, comments) {
    if (!comments || !node) return node;
    const key = `${type}Comments`;
    if (node[key]) {
        if (type === "leading") node[key] = comments.concat(node[key]);
        else node[key].push(...comments);
    } else node[key] = comments;
    return node;
}

});


parcelRegister("jiypm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e0ca637a3acc17ff$var$inheritInnerComments;

var $jIIa2 = parcelRequire("jIIa2");
function $e0ca637a3acc17ff$var$inheritInnerComments(child, parent) {
    (0, $jIIa2.default)("innerComments", child, parent);
}

});
parcelRegister("jIIa2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e5b461cd278e8bf2$var$inherit;
function $e5b461cd278e8bf2$var$inherit(key, child, parent) {
    if (child && parent) child[key] = Array.from(new Set([].concat(child[key], parent[key]).filter(Boolean)));
}

});


parcelRegister("3uEFY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $28b3b9d1e8d1455e$var$inheritLeadingComments;

var $jIIa2 = parcelRequire("jIIa2");
function $28b3b9d1e8d1455e$var$inheritLeadingComments(child, parent) {
    (0, $jIIa2.default)("leadingComments", child, parent);
}

});

parcelRegister("6Yd44", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $51327b0aa8f5ecd6$var$inheritsComments;

var $1TriR = parcelRequire("1TriR");

var $3uEFY = parcelRequire("3uEFY");

var $jiypm = parcelRequire("jiypm");
function $51327b0aa8f5ecd6$var$inheritsComments(child, parent) {
    (0, $1TriR.default)(child, parent);
    (0, $3uEFY.default)(child, parent);
    (0, $jiypm.default)(child, parent);
    return child;
}

});
parcelRegister("1TriR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $16101b5a3758e765$var$inheritTrailingComments;

var $jIIa2 = parcelRequire("jIIa2");
function $16101b5a3758e765$var$inheritTrailingComments(child, parent) {
    (0, $jIIa2.default)("trailingComments", child, parent);
}

});


parcelRegister("QLNL1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $09e9efd570548c5f$var$removeComments;

var $l7lSB = parcelRequire("l7lSB");
function $09e9efd570548c5f$var$removeComments(node) {
    $l7lSB.COMMENT_KEYS.forEach((key)=>{
        node[key] = null;
    });
    return node;
}

});

parcelRegister("anRaJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.WHILE_TYPES = module.exports.USERWHITESPACABLE_TYPES = module.exports.UNARYLIKE_TYPES = module.exports.TYPESCRIPT_TYPES = module.exports.TSTYPE_TYPES = module.exports.TSTYPEELEMENT_TYPES = module.exports.TSENTITYNAME_TYPES = module.exports.TSBASETYPE_TYPES = module.exports.TERMINATORLESS_TYPES = module.exports.STATEMENT_TYPES = module.exports.STANDARDIZED_TYPES = module.exports.SCOPABLE_TYPES = module.exports.PUREISH_TYPES = module.exports.PROPERTY_TYPES = module.exports.PRIVATE_TYPES = module.exports.PATTERN_TYPES = module.exports.PATTERNLIKE_TYPES = module.exports.OBJECTMEMBER_TYPES = module.exports.MODULESPECIFIER_TYPES = module.exports.MODULEDECLARATION_TYPES = module.exports.MISCELLANEOUS_TYPES = module.exports.METHOD_TYPES = module.exports.LVAL_TYPES = module.exports.LOOP_TYPES = module.exports.LITERAL_TYPES = module.exports.JSX_TYPES = module.exports.IMPORTOREXPORTDECLARATION_TYPES = module.exports.IMMUTABLE_TYPES = module.exports.FUNCTION_TYPES = module.exports.FUNCTIONPARENT_TYPES = module.exports.FOR_TYPES = module.exports.FORXSTATEMENT_TYPES = module.exports.FLOW_TYPES = module.exports.FLOWTYPE_TYPES = module.exports.FLOWPREDICATE_TYPES = module.exports.FLOWDECLARATION_TYPES = module.exports.FLOWBASEANNOTATION_TYPES = module.exports.EXPRESSION_TYPES = module.exports.EXPRESSIONWRAPPER_TYPES = module.exports.EXPORTDECLARATION_TYPES = module.exports.ENUMMEMBER_TYPES = module.exports.ENUMBODY_TYPES = module.exports.DECLARATION_TYPES = module.exports.CONDITIONAL_TYPES = module.exports.COMPLETIONSTATEMENT_TYPES = module.exports.CLASS_TYPES = module.exports.BLOCK_TYPES = module.exports.BLOCKPARENT_TYPES = module.exports.BINARY_TYPES = module.exports.ACCESSOR_TYPES = void 0;

var $7TNHg = parcelRequire("7TNHg");
const $78f54c3a809be9bc$var$STANDARDIZED_TYPES = module.exports.STANDARDIZED_TYPES = $7TNHg.FLIPPED_ALIAS_KEYS["Standardized"];
const $78f54c3a809be9bc$var$EXPRESSION_TYPES = module.exports.EXPRESSION_TYPES = $7TNHg.FLIPPED_ALIAS_KEYS["Expression"];
const $78f54c3a809be9bc$var$BINARY_TYPES = module.exports.BINARY_TYPES = $7TNHg.FLIPPED_ALIAS_KEYS["Binary"];
const $78f54c3a809be9bc$var$SCOPABLE_TYPES = module.exports.SCOPABLE_TYPES = $7TNHg.FLIPPED_ALIAS_KEYS["Scopable"];
const $78f54c3a809be9bc$var$BLOCKPARENT_TYPES = module.exports.BLOCKPARENT_TYPES = $7TNHg.FLIPPED_ALIAS_KEYS["BlockParent"];
const $78f54c3a809be9bc$var$BLOCK_TYPES = module.exports.BLOCK_TYPES = $7TNHg.FLIPPED_ALIAS_KEYS["Block"];
const $78f54c3a809be9bc$var$STATEMENT_TYPES = module.exports.STATEMENT_TYPES = $7TNHg.FLIPPED_ALIAS_KEYS["Statement"];
const $78f54c3a809be9bc$var$TERMINATORLESS_TYPES = module.exports.TERMINATORLESS_TYPES = $7TNHg.FLIPPED_ALIAS_KEYS["Terminatorless"];
const $78f54c3a809be9bc$var$COMPLETIONSTATEMENT_TYPES = module.exports.COMPLETIONSTATEMENT_TYPES = $7TNHg.FLIPPED_ALIAS_KEYS["CompletionStatement"];
const $78f54c3a809be9bc$var$CONDITIONAL_TYPES = module.exports.CONDITIONAL_TYPES = $7TNHg.FLIPPED_ALIAS_KEYS["Conditional"];
const $78f54c3a809be9bc$var$LOOP_TYPES = module.exports.LOOP_TYPES = $7TNHg.FLIPPED_ALIAS_KEYS["Loop"];
const $78f54c3a809be9bc$var$WHILE_TYPES = module.exports.WHILE_TYPES = $7TNHg.FLIPPED_ALIAS_KEYS["While"];
const $78f54c3a809be9bc$var$EXPRESSIONWRAPPER_TYPES = module.exports.EXPRESSIONWRAPPER_TYPES = $7TNHg.FLIPPED_ALIAS_KEYS["ExpressionWrapper"];
const $78f54c3a809be9bc$var$FOR_TYPES = module.exports.FOR_TYPES = $7TNHg.FLIPPED_ALIAS_KEYS["For"];
const $78f54c3a809be9bc$var$FORXSTATEMENT_TYPES = module.exports.FORXSTATEMENT_TYPES = $7TNHg.FLIPPED_ALIAS_KEYS["ForXStatement"];
const $78f54c3a809be9bc$var$FUNCTION_TYPES = module.exports.FUNCTION_TYPES = $7TNHg.FLIPPED_ALIAS_KEYS["Function"];
const $78f54c3a809be9bc$var$FUNCTIONPARENT_TYPES = module.exports.FUNCTIONPARENT_TYPES = $7TNHg.FLIPPED_ALIAS_KEYS["FunctionParent"];
const $78f54c3a809be9bc$var$PUREISH_TYPES = module.exports.PUREISH_TYPES = $7TNHg.FLIPPED_ALIAS_KEYS["Pureish"];
const $78f54c3a809be9bc$var$DECLARATION_TYPES = module.exports.DECLARATION_TYPES = $7TNHg.FLIPPED_ALIAS_KEYS["Declaration"];
const $78f54c3a809be9bc$var$PATTERNLIKE_TYPES = module.exports.PATTERNLIKE_TYPES = $7TNHg.FLIPPED_ALIAS_KEYS["PatternLike"];
const $78f54c3a809be9bc$var$LVAL_TYPES = module.exports.LVAL_TYPES = $7TNHg.FLIPPED_ALIAS_KEYS["LVal"];
const $78f54c3a809be9bc$var$TSENTITYNAME_TYPES = module.exports.TSENTITYNAME_TYPES = $7TNHg.FLIPPED_ALIAS_KEYS["TSEntityName"];
const $78f54c3a809be9bc$var$LITERAL_TYPES = module.exports.LITERAL_TYPES = $7TNHg.FLIPPED_ALIAS_KEYS["Literal"];
const $78f54c3a809be9bc$var$IMMUTABLE_TYPES = module.exports.IMMUTABLE_TYPES = $7TNHg.FLIPPED_ALIAS_KEYS["Immutable"];
const $78f54c3a809be9bc$var$USERWHITESPACABLE_TYPES = module.exports.USERWHITESPACABLE_TYPES = $7TNHg.FLIPPED_ALIAS_KEYS["UserWhitespacable"];
const $78f54c3a809be9bc$var$METHOD_TYPES = module.exports.METHOD_TYPES = $7TNHg.FLIPPED_ALIAS_KEYS["Method"];
const $78f54c3a809be9bc$var$OBJECTMEMBER_TYPES = module.exports.OBJECTMEMBER_TYPES = $7TNHg.FLIPPED_ALIAS_KEYS["ObjectMember"];
const $78f54c3a809be9bc$var$PROPERTY_TYPES = module.exports.PROPERTY_TYPES = $7TNHg.FLIPPED_ALIAS_KEYS["Property"];
const $78f54c3a809be9bc$var$UNARYLIKE_TYPES = module.exports.UNARYLIKE_TYPES = $7TNHg.FLIPPED_ALIAS_KEYS["UnaryLike"];
const $78f54c3a809be9bc$var$PATTERN_TYPES = module.exports.PATTERN_TYPES = $7TNHg.FLIPPED_ALIAS_KEYS["Pattern"];
const $78f54c3a809be9bc$var$CLASS_TYPES = module.exports.CLASS_TYPES = $7TNHg.FLIPPED_ALIAS_KEYS["Class"];
const $78f54c3a809be9bc$var$IMPORTOREXPORTDECLARATION_TYPES = module.exports.IMPORTOREXPORTDECLARATION_TYPES = $7TNHg.FLIPPED_ALIAS_KEYS["ImportOrExportDeclaration"];
const $78f54c3a809be9bc$var$EXPORTDECLARATION_TYPES = module.exports.EXPORTDECLARATION_TYPES = $7TNHg.FLIPPED_ALIAS_KEYS["ExportDeclaration"];
const $78f54c3a809be9bc$var$MODULESPECIFIER_TYPES = module.exports.MODULESPECIFIER_TYPES = $7TNHg.FLIPPED_ALIAS_KEYS["ModuleSpecifier"];
const $78f54c3a809be9bc$var$ACCESSOR_TYPES = module.exports.ACCESSOR_TYPES = $7TNHg.FLIPPED_ALIAS_KEYS["Accessor"];
const $78f54c3a809be9bc$var$PRIVATE_TYPES = module.exports.PRIVATE_TYPES = $7TNHg.FLIPPED_ALIAS_KEYS["Private"];
const $78f54c3a809be9bc$var$FLOW_TYPES = module.exports.FLOW_TYPES = $7TNHg.FLIPPED_ALIAS_KEYS["Flow"];
const $78f54c3a809be9bc$var$FLOWTYPE_TYPES = module.exports.FLOWTYPE_TYPES = $7TNHg.FLIPPED_ALIAS_KEYS["FlowType"];
const $78f54c3a809be9bc$var$FLOWBASEANNOTATION_TYPES = module.exports.FLOWBASEANNOTATION_TYPES = $7TNHg.FLIPPED_ALIAS_KEYS["FlowBaseAnnotation"];
const $78f54c3a809be9bc$var$FLOWDECLARATION_TYPES = module.exports.FLOWDECLARATION_TYPES = $7TNHg.FLIPPED_ALIAS_KEYS["FlowDeclaration"];
const $78f54c3a809be9bc$var$FLOWPREDICATE_TYPES = module.exports.FLOWPREDICATE_TYPES = $7TNHg.FLIPPED_ALIAS_KEYS["FlowPredicate"];
const $78f54c3a809be9bc$var$ENUMBODY_TYPES = module.exports.ENUMBODY_TYPES = $7TNHg.FLIPPED_ALIAS_KEYS["EnumBody"];
const $78f54c3a809be9bc$var$ENUMMEMBER_TYPES = module.exports.ENUMMEMBER_TYPES = $7TNHg.FLIPPED_ALIAS_KEYS["EnumMember"];
const $78f54c3a809be9bc$var$JSX_TYPES = module.exports.JSX_TYPES = $7TNHg.FLIPPED_ALIAS_KEYS["JSX"];
const $78f54c3a809be9bc$var$MISCELLANEOUS_TYPES = module.exports.MISCELLANEOUS_TYPES = $7TNHg.FLIPPED_ALIAS_KEYS["Miscellaneous"];
const $78f54c3a809be9bc$var$TYPESCRIPT_TYPES = module.exports.TYPESCRIPT_TYPES = $7TNHg.FLIPPED_ALIAS_KEYS["TypeScript"];
const $78f54c3a809be9bc$var$TSTYPEELEMENT_TYPES = module.exports.TSTYPEELEMENT_TYPES = $7TNHg.FLIPPED_ALIAS_KEYS["TSTypeElement"];
const $78f54c3a809be9bc$var$TSTYPE_TYPES = module.exports.TSTYPE_TYPES = $7TNHg.FLIPPED_ALIAS_KEYS["TSType"];
const $78f54c3a809be9bc$var$TSBASETYPE_TYPES = module.exports.TSBASETYPE_TYPES = $7TNHg.FLIPPED_ALIAS_KEYS["TSBaseType"];
const $78f54c3a809be9bc$var$MODULEDECLARATION_TYPES = module.exports.MODULEDECLARATION_TYPES = $78f54c3a809be9bc$var$IMPORTOREXPORTDECLARATION_TYPES;

});

parcelRegister("c7XVB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8d449ff89bd493eb$var$ensureBlock;

var $dxQZV = parcelRequire("dxQZV");
function $8d449ff89bd493eb$var$ensureBlock(node, key = "body") {
    const result = (0, $dxQZV.default)(node[key], node);
    node[key] = result;
    return result;
}

});
parcelRegister("dxQZV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9dc777ab24cfbd6d$var$toBlock;

var $2G7FY = parcelRequire("2G7FY");

var $7MfP7 = parcelRequire("7MfP7");
function $9dc777ab24cfbd6d$var$toBlock(node, parent) {
    if ((0, $2G7FY.isBlockStatement)(node)) return node;
    let blockNodes = [];
    if ((0, $2G7FY.isEmptyStatement)(node)) blockNodes = [];
    else {
        if (!(0, $2G7FY.isStatement)(node)) {
            if ((0, $2G7FY.isFunction)(parent)) node = (0, $7MfP7.returnStatement)(node);
            else node = (0, $7MfP7.expressionStatement)(node);
        }
        blockNodes = [
            node
        ];
    }
    return (0, $7MfP7.blockStatement)(blockNodes);
}

});


parcelRegister("kNGZd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f249ba6c9db030a2$var$toBindingIdentifierName;

var $l7GKn = parcelRequire("l7GKn");
function $f249ba6c9db030a2$var$toBindingIdentifierName(name) {
    name = (0, $l7GKn.default)(name);
    if (name === "eval" || name === "arguments") name = "_" + name;
    return name;
}

});
parcelRegister("l7GKn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f60b69112d553c3b$var$toIdentifier;

var $9tPzx = parcelRequire("9tPzx");

var $2Ghih = parcelRequire("2Ghih");
function $f60b69112d553c3b$var$toIdentifier(input) {
    input = input + "";
    let name = "";
    for (const c of input)name += (0, $2Ghih.isIdentifierChar)(c.codePointAt(0)) ? c : "-";
    name = name.replace(/^[-0-9]+/, "");
    name = name.replace(/[-\s]+(.)?/g, function(match, c) {
        return c ? c.toUpperCase() : "";
    });
    if (!(0, $9tPzx.default)(name)) name = `_${name}`;
    return name || "_";
}

});


parcelRegister("eppYV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a7d78deab1006029$var$toComputedKey;

var $2G7FY = parcelRequire("2G7FY");

var $7MfP7 = parcelRequire("7MfP7");
function $a7d78deab1006029$var$toComputedKey(node, key = node.key || node.property) {
    if (!node.computed && (0, $2G7FY.isIdentifier)(key)) key = (0, $7MfP7.stringLiteral)(key.name);
    return key;
}

});

parcelRegister("P3Daq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2G7FY = parcelRequire("2G7FY");
var $09979485a76b27a0$var$_default = module.exports.default = $09979485a76b27a0$var$toExpression;
function $09979485a76b27a0$var$toExpression(node) {
    if ((0, $2G7FY.isExpressionStatement)(node)) node = node.expression;
    if ((0, $2G7FY.isExpression)(node)) return node;
    if ((0, $2G7FY.isClass)(node)) node.type = "ClassExpression";
    else if ((0, $2G7FY.isFunction)(node)) node.type = "FunctionExpression";
    if (!(0, $2G7FY.isExpression)(node)) throw new Error(`cannot turn ${node.type} to an expression`);
    return node;
}

});

parcelRegister("kUqjQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f38d740c6640a977$var$toKeyAlias;

var $2G7FY = parcelRequire("2G7FY");

var $k6qdD = parcelRequire("k6qdD");

var $81cip = parcelRequire("81cip");
function $f38d740c6640a977$var$toKeyAlias(node, key = node.key) {
    let alias;
    if (node.kind === "method") return $f38d740c6640a977$var$toKeyAlias.increment() + "";
    else if ((0, $2G7FY.isIdentifier)(key)) alias = key.name;
    else if ((0, $2G7FY.isStringLiteral)(key)) alias = JSON.stringify(key.value);
    else alias = JSON.stringify((0, $81cip.default)((0, $k6qdD.default)(key)));
    if (node.computed) alias = `[${alias}]`;
    if (node.static) alias = `static:${alias}`;
    return alias;
}
$f38d740c6640a977$var$toKeyAlias.uid = 0;
$f38d740c6640a977$var$toKeyAlias.increment = function() {
    if ($f38d740c6640a977$var$toKeyAlias.uid >= Number.MAX_SAFE_INTEGER) return $f38d740c6640a977$var$toKeyAlias.uid = 0;
    else return $f38d740c6640a977$var$toKeyAlias.uid++;
};

});
parcelRegister("81cip", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5d67f4747c6d60b2$var$removePropertiesDeep;

var $5lkLS = parcelRequire("5lkLS");

var $1sEUT = parcelRequire("1sEUT");
function $5d67f4747c6d60b2$var$removePropertiesDeep(tree, opts) {
    (0, $5lkLS.default)(tree, $1sEUT.default, opts);
    return tree;
}

});
parcelRegister("5lkLS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3e3f06a5a5f25986$var$traverseFast;

var $7TNHg = parcelRequire("7TNHg");
function $3e3f06a5a5f25986$var$traverseFast(node, enter, opts) {
    if (!node) return;
    const keys = $7TNHg.VISITOR_KEYS[node.type];
    if (!keys) return;
    opts = opts || {};
    enter(node, opts);
    for (const key of keys){
        const subNode = node[key];
        if (Array.isArray(subNode)) for (const node of subNode)$3e3f06a5a5f25986$var$traverseFast(node, enter, opts);
        else $3e3f06a5a5f25986$var$traverseFast(subNode, enter, opts);
    }
}

});

parcelRegister("1sEUT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1108252261846108$var$removeProperties;

var $l7lSB = parcelRequire("l7lSB");
const $1108252261846108$var$CLEAR_KEYS = [
    "tokens",
    "start",
    "end",
    "loc",
    "raw",
    "rawValue"
];
const $1108252261846108$var$CLEAR_KEYS_PLUS_COMMENTS = [
    ...$l7lSB.COMMENT_KEYS,
    "comments",
    ...$1108252261846108$var$CLEAR_KEYS
];
function $1108252261846108$var$removeProperties(node, opts = {}) {
    const map = opts.preserveComments ? $1108252261846108$var$CLEAR_KEYS : $1108252261846108$var$CLEAR_KEYS_PLUS_COMMENTS;
    for (const key of map)if (node[key] != null) node[key] = undefined;
    for (const key of Object.keys(node))if (key[0] === "_" && node[key] != null) node[key] = undefined;
    const symbols = Object.getOwnPropertySymbols(node);
    for (const sym of symbols)node[sym] = null;
}

});



parcelRegister("dh8ot", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2G7FY = parcelRequire("2G7FY");

var $7MfP7 = parcelRequire("7MfP7");
var $9aa35fb2226fafde$var$_default = module.exports.default = $9aa35fb2226fafde$var$toStatement;
function $9aa35fb2226fafde$var$toStatement(node, ignore) {
    if ((0, $2G7FY.isStatement)(node)) return node;
    let mustHaveId = false;
    let newType;
    if ((0, $2G7FY.isClass)(node)) {
        mustHaveId = true;
        newType = "ClassDeclaration";
    } else if ((0, $2G7FY.isFunction)(node)) {
        mustHaveId = true;
        newType = "FunctionDeclaration";
    } else if ((0, $2G7FY.isAssignmentExpression)(node)) return (0, $7MfP7.expressionStatement)(node);
    if (mustHaveId && !node.id) newType = false;
    if (!newType) {
        if (ignore) return false;
        else throw new Error(`cannot turn ${node.type} to a statement`);
    }
    node.type = newType;
    return node;
}

});

parcelRegister("gXTkY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9tPzx = parcelRequire("9tPzx");

var $7MfP7 = parcelRequire("7MfP7");
var $c59d14d865803f17$var$_default = module.exports.default = $c59d14d865803f17$var$valueToNode;
const $c59d14d865803f17$var$objectToString = Function.call.bind(Object.prototype.toString);
function $c59d14d865803f17$var$isRegExp(value) {
    return $c59d14d865803f17$var$objectToString(value) === "[object RegExp]";
}
function $c59d14d865803f17$var$isPlainObject(value) {
    if (typeof value !== "object" || value === null || Object.prototype.toString.call(value) !== "[object Object]") return false;
    const proto = Object.getPrototypeOf(value);
    return proto === null || Object.getPrototypeOf(proto) === null;
}
function $c59d14d865803f17$var$valueToNode(value) {
    if (value === undefined) return (0, $7MfP7.identifier)("undefined");
    if (value === true || value === false) return (0, $7MfP7.booleanLiteral)(value);
    if (value === null) return (0, $7MfP7.nullLiteral)();
    if (typeof value === "string") return (0, $7MfP7.stringLiteral)(value);
    if (typeof value === "number") {
        let result;
        if (Number.isFinite(value)) result = (0, $7MfP7.numericLiteral)(Math.abs(value));
        else {
            let numerator;
            if (Number.isNaN(value)) numerator = (0, $7MfP7.numericLiteral)(0);
            else numerator = (0, $7MfP7.numericLiteral)(1);
            result = (0, $7MfP7.binaryExpression)("/", numerator, (0, $7MfP7.numericLiteral)(0));
        }
        if (value < 0 || Object.is(value, -0)) result = (0, $7MfP7.unaryExpression)("-", result);
        return result;
    }
    if ($c59d14d865803f17$var$isRegExp(value)) {
        const pattern = value.source;
        const flags = value.toString().match(/\/([a-z]+|)$/)[1];
        return (0, $7MfP7.regExpLiteral)(pattern, flags);
    }
    if (Array.isArray(value)) return (0, $7MfP7.arrayExpression)(value.map($c59d14d865803f17$var$valueToNode));
    if ($c59d14d865803f17$var$isPlainObject(value)) {
        const props = [];
        for (const key of Object.keys(value)){
            let nodeKey;
            if ((0, $9tPzx.default)(key)) nodeKey = (0, $7MfP7.identifier)(key);
            else nodeKey = (0, $7MfP7.stringLiteral)(key);
            props.push((0, $7MfP7.objectProperty)(nodeKey, $c59d14d865803f17$var$valueToNode(value[key])));
        }
        return (0, $7MfP7.objectExpression)(props);
    }
    throw new Error("don't know how to turn this value into a node");
}

});

parcelRegister("eYiXa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ae655f094cde9516$var$appendToMemberExpression;

var $7MfP7 = parcelRequire("7MfP7");
function $ae655f094cde9516$var$appendToMemberExpression(member, append, computed = false) {
    member.object = (0, $7MfP7.memberExpression)(member.object, member.property, member.computed);
    member.property = append;
    member.computed = !!computed;
    return member;
}

});

parcelRegister("btfPV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $859eafec4cd7e826$var$inherits;

var $l7lSB = parcelRequire("l7lSB");

var $6Yd44 = parcelRequire("6Yd44");
function $859eafec4cd7e826$var$inherits(child, parent) {
    if (!child || !parent) return child;
    for (const key of $l7lSB.INHERIT_KEYS.optional)if (child[key] == null) child[key] = parent[key];
    for (const key of Object.keys(parent))if (key[0] === "_" && key !== "__clone") child[key] = parent[key];
    for (const key of $l7lSB.INHERIT_KEYS.force)child[key] = parent[key];
    (0, $6Yd44.default)(child, parent);
    return child;
}

});

parcelRegister("eJjWG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ab94bd69837a2ed9$var$prependToMemberExpression;

var $7MfP7 = parcelRequire("7MfP7");

var $ardUq = parcelRequire("ardUq");
function $ab94bd69837a2ed9$var$prependToMemberExpression(member, prepend) {
    if ((0, $ardUq.isSuper)(member.object)) throw new Error("Cannot prepend node to super property access (`super.foo`).");
    member.object = (0, $7MfP7.memberExpression)(prepend, member.object);
    return member;
}

});

parcelRegister("3GTeN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2b0024650205911d$var$getBindingIdentifiers;

var $2G7FY = parcelRequire("2G7FY");
function $2b0024650205911d$var$getBindingIdentifiers(node, duplicates, outerOnly, newBindingsOnly) {
    const search = [].concat(node);
    const ids = Object.create(null);
    while(search.length){
        const id = search.shift();
        if (!id) continue;
        if (newBindingsOnly && ((0, $2G7FY.isAssignmentExpression)(id) || (0, $2G7FY.isUnaryExpression)(id))) continue;
        const keys = $2b0024650205911d$var$getBindingIdentifiers.keys[id.type];
        if ((0, $2G7FY.isIdentifier)(id)) {
            if (duplicates) {
                const _ids = ids[id.name] = ids[id.name] || [];
                _ids.push(id);
            } else ids[id.name] = id;
            continue;
        }
        if ((0, $2G7FY.isExportDeclaration)(id) && !(0, $2G7FY.isExportAllDeclaration)(id)) {
            if ((0, $2G7FY.isDeclaration)(id.declaration)) search.push(id.declaration);
            continue;
        }
        if (outerOnly) {
            if ((0, $2G7FY.isFunctionDeclaration)(id)) {
                search.push(id.id);
                continue;
            }
            if ((0, $2G7FY.isFunctionExpression)(id)) continue;
        }
        if (keys) for(let i = 0; i < keys.length; i++){
            const key = keys[i];
            const nodes = id[key];
            if (nodes) Array.isArray(nodes) ? search.push(...nodes) : search.push(nodes);
        }
    }
    return ids;
}
$2b0024650205911d$var$getBindingIdentifiers.keys = {
    DeclareClass: [
        "id"
    ],
    DeclareFunction: [
        "id"
    ],
    DeclareModule: [
        "id"
    ],
    DeclareVariable: [
        "id"
    ],
    DeclareInterface: [
        "id"
    ],
    DeclareTypeAlias: [
        "id"
    ],
    DeclareOpaqueType: [
        "id"
    ],
    InterfaceDeclaration: [
        "id"
    ],
    TypeAlias: [
        "id"
    ],
    OpaqueType: [
        "id"
    ],
    CatchClause: [
        "param"
    ],
    LabeledStatement: [
        "label"
    ],
    UnaryExpression: [
        "argument"
    ],
    AssignmentExpression: [
        "left"
    ],
    ImportSpecifier: [
        "local"
    ],
    ImportNamespaceSpecifier: [
        "local"
    ],
    ImportDefaultSpecifier: [
        "local"
    ],
    ImportDeclaration: [
        "specifiers"
    ],
    ExportSpecifier: [
        "exported"
    ],
    ExportNamespaceSpecifier: [
        "exported"
    ],
    ExportDefaultSpecifier: [
        "exported"
    ],
    FunctionDeclaration: [
        "id",
        "params"
    ],
    FunctionExpression: [
        "id",
        "params"
    ],
    ArrowFunctionExpression: [
        "params"
    ],
    ObjectMethod: [
        "params"
    ],
    ClassMethod: [
        "params"
    ],
    ClassPrivateMethod: [
        "params"
    ],
    ForInStatement: [
        "left"
    ],
    ForOfStatement: [
        "left"
    ],
    ClassDeclaration: [
        "id"
    ],
    ClassExpression: [
        "id"
    ],
    RestElement: [
        "argument"
    ],
    UpdateExpression: [
        "argument"
    ],
    ObjectProperty: [
        "value"
    ],
    AssignmentPattern: [
        "left"
    ],
    ArrayPattern: [
        "elements"
    ],
    ObjectPattern: [
        "properties"
    ],
    VariableDeclaration: [
        "declarations"
    ],
    VariableDeclarator: [
        "id"
    ]
};

});

parcelRegister("6sXWW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3GTeN = parcelRequire("3GTeN");
var $4b53dc5636a53103$var$_default = module.exports.default = $4b53dc5636a53103$var$getOuterBindingIdentifiers;
function $4b53dc5636a53103$var$getOuterBindingIdentifiers(node, duplicates) {
    return (0, $3GTeN.default)(node, duplicates, true);
}

});

parcelRegister("iolsE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d63b1d9d92176341$var$traverse;

var $7TNHg = parcelRequire("7TNHg");
function $d63b1d9d92176341$var$traverse(node, handlers, state) {
    if (typeof handlers === "function") handlers = {
        enter: handlers
    };
    const { enter: enter, exit: exit } = handlers;
    $d63b1d9d92176341$var$traverseSimpleImpl(node, enter, exit, state, []);
}
function $d63b1d9d92176341$var$traverseSimpleImpl(node, enter, exit, state, ancestors) {
    const keys = $7TNHg.VISITOR_KEYS[node.type];
    if (!keys) return;
    if (enter) enter(node, ancestors, state);
    for (const key of keys){
        const subNode = node[key];
        if (Array.isArray(subNode)) for(let i = 0; i < subNode.length; i++){
            const child = subNode[i];
            if (!child) continue;
            ancestors.push({
                node: node,
                key: key,
                index: i
            });
            $d63b1d9d92176341$var$traverseSimpleImpl(child, enter, exit, state, ancestors);
            ancestors.pop();
        }
        else if (subNode) {
            ancestors.push({
                node: node,
                key: key
            });
            $d63b1d9d92176341$var$traverseSimpleImpl(subNode, enter, exit, state, ancestors);
            ancestors.pop();
        }
    }
    if (exit) exit(node, ancestors, state);
}

});

parcelRegister("2r8kv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1c64907e5e6f5b4c$var$isBinding;

var $3GTeN = parcelRequire("3GTeN");
function $1c64907e5e6f5b4c$var$isBinding(node, parent, grandparent) {
    if (grandparent && node.type === "Identifier" && parent.type === "ObjectProperty" && grandparent.type === "ObjectExpression") return false;
    const keys = $3GTeN.default.keys[parent.type];
    if (keys) for(let i = 0; i < keys.length; i++){
        const key = keys[i];
        const val = parent[key];
        if (Array.isArray(val)) {
            if (val.indexOf(node) >= 0) return true;
        } else {
            if (val === node) return true;
        }
    }
    return false;
}

});

parcelRegister("4N0sk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $37cc1790f828627f$var$isBlockScoped;

var $2G7FY = parcelRequire("2G7FY");

var $8jAXP = parcelRequire("8jAXP");
function $37cc1790f828627f$var$isBlockScoped(node) {
    return (0, $2G7FY.isFunctionDeclaration)(node) || (0, $2G7FY.isClassDeclaration)(node) || (0, $8jAXP.default)(node);
}

});
parcelRegister("8jAXP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $60dcc55966039c11$var$isLet;

var $2G7FY = parcelRequire("2G7FY");

var $l7lSB = parcelRequire("l7lSB");
function $60dcc55966039c11$var$isLet(node) {
    return (0, $2G7FY.isVariableDeclaration)(node) && (node.kind !== "var" || node[$l7lSB.BLOCK_SCOPED_SYMBOL]);
}

});


parcelRegister("fsv0I", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b411868ff0ae5363$var$isImmutable;

var $7sJfn = parcelRequire("7sJfn");

var $2G7FY = parcelRequire("2G7FY");
function $b411868ff0ae5363$var$isImmutable(node) {
    if ((0, $7sJfn.default)(node.type, "Immutable")) return true;
    if ((0, $2G7FY.isIdentifier)(node)) {
        if (node.name === "undefined") return true;
        else return false;
    }
    return false;
}

});

parcelRegister("lYDFZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $fffdfa73cd5f8dcf$var$isNodesEquivalent;

var $7TNHg = parcelRequire("7TNHg");
function $fffdfa73cd5f8dcf$var$isNodesEquivalent(a, b) {
    if (typeof a !== "object" || typeof b !== "object" || a == null || b == null) return a === b;
    if (a.type !== b.type) return false;
    const fields = Object.keys($7TNHg.NODE_FIELDS[a.type] || a.type);
    const visitorKeys = $7TNHg.VISITOR_KEYS[a.type];
    for (const field of fields){
        const val_a = a[field];
        const val_b = b[field];
        if (typeof val_a !== typeof val_b) return false;
        if (val_a == null && val_b == null) continue;
        else if (val_a == null || val_b == null) return false;
        if (Array.isArray(val_a)) {
            if (!Array.isArray(val_b)) return false;
            if (val_a.length !== val_b.length) return false;
            for(let i = 0; i < val_a.length; i++){
                if (!$fffdfa73cd5f8dcf$var$isNodesEquivalent(val_a[i], val_b[i])) return false;
            }
            continue;
        }
        if (typeof val_a === "object" && !(visitorKeys != null && visitorKeys.includes(field))) {
            for (const key of Object.keys(val_a)){
                if (val_a[key] !== val_b[key]) return false;
            }
            continue;
        }
        if (!$fffdfa73cd5f8dcf$var$isNodesEquivalent(val_a, val_b)) return false;
    }
    return true;
}

});

parcelRegister("ieqJ5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d45e441120ae9850$var$isReferenced;
function $d45e441120ae9850$var$isReferenced(node, parent, grandparent) {
    switch(parent.type){
        case "MemberExpression":
        case "OptionalMemberExpression":
            if (parent.property === node) return !!parent.computed;
            return parent.object === node;
        case "JSXMemberExpression":
            return parent.object === node;
        case "VariableDeclarator":
            return parent.init === node;
        case "ArrowFunctionExpression":
            return parent.body === node;
        case "PrivateName":
            return false;
        case "ClassMethod":
        case "ClassPrivateMethod":
        case "ObjectMethod":
            if (parent.key === node) return !!parent.computed;
            return false;
        case "ObjectProperty":
            if (parent.key === node) return !!parent.computed;
            return !grandparent || grandparent.type !== "ObjectPattern";
        case "ClassProperty":
        case "ClassAccessorProperty":
            if (parent.key === node) return !!parent.computed;
            return true;
        case "ClassPrivateProperty":
            return parent.key !== node;
        case "ClassDeclaration":
        case "ClassExpression":
            return parent.superClass === node;
        case "AssignmentExpression":
            return parent.right === node;
        case "AssignmentPattern":
            return parent.right === node;
        case "LabeledStatement":
            return false;
        case "CatchClause":
            return false;
        case "RestElement":
            return false;
        case "BreakStatement":
        case "ContinueStatement":
            return false;
        case "FunctionDeclaration":
        case "FunctionExpression":
            return false;
        case "ExportNamespaceSpecifier":
        case "ExportDefaultSpecifier":
            return false;
        case "ExportSpecifier":
            if (grandparent != null && grandparent.source) return false;
            return parent.local === node;
        case "ImportDefaultSpecifier":
        case "ImportNamespaceSpecifier":
        case "ImportSpecifier":
            return false;
        case "ImportAttribute":
            return false;
        case "JSXAttribute":
            return false;
        case "ObjectPattern":
        case "ArrayPattern":
            return false;
        case "MetaProperty":
            return false;
        case "ObjectTypeProperty":
            return parent.key !== node;
        case "TSEnumMember":
            return parent.id !== node;
        case "TSPropertySignature":
            if (parent.key === node) return !!parent.computed;
            return true;
    }
    return true;
}

});

parcelRegister("jCJrC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e494d13d99746175$var$isScope;

var $2G7FY = parcelRequire("2G7FY");
function $e494d13d99746175$var$isScope(node, parent) {
    if ((0, $2G7FY.isBlockStatement)(node) && ((0, $2G7FY.isFunction)(parent) || (0, $2G7FY.isCatchClause)(parent))) return false;
    if ((0, $2G7FY.isPattern)(node) && ((0, $2G7FY.isFunction)(parent) || (0, $2G7FY.isCatchClause)(parent))) return true;
    return (0, $2G7FY.isScopable)(node);
}

});

parcelRegister("cfDjZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8eb5632f06fcd170$var$isSpecifierDefault;

var $2G7FY = parcelRequire("2G7FY");
function $8eb5632f06fcd170$var$isSpecifierDefault(specifier) {
    return (0, $2G7FY.isImportDefaultSpecifier)(specifier) || (0, $2G7FY.isIdentifier)(specifier.imported || specifier.exported, {
        name: "default"
    });
}

});

parcelRegister("1sQw0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $111124621d68be27$var$isValidES3Identifier;

var $9tPzx = parcelRequire("9tPzx");
const $111124621d68be27$var$RESERVED_WORDS_ES3_ONLY = new Set([
    "abstract",
    "boolean",
    "byte",
    "char",
    "double",
    "enum",
    "final",
    "float",
    "goto",
    "implements",
    "int",
    "interface",
    "long",
    "native",
    "package",
    "private",
    "protected",
    "public",
    "short",
    "static",
    "synchronized",
    "throws",
    "transient",
    "volatile"
]);
function $111124621d68be27$var$isValidES3Identifier(name) {
    return (0, $9tPzx.default)(name) && !$111124621d68be27$var$RESERVED_WORDS_ES3_ONLY.has(name);
}

});

parcelRegister("5sU0b", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3fab021627eaa509$var$isVar;

var $2G7FY = parcelRequire("2G7FY");

var $l7lSB = parcelRequire("l7lSB");
function $3fab021627eaa509$var$isVar(node) {
    return (0, $2G7FY.isVariableDeclaration)(node, {
        kind: "var"
    }) && !node[$l7lSB.BLOCK_SCOPED_SYMBOL];
}

});

parcelRegister("lBOsQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $fbb432cfbeba0fe3$var$toSequenceExpression;

var $dSI8Z = parcelRequire("dSI8Z");
function $fbb432cfbeba0fe3$var$toSequenceExpression(nodes, scope) {
    if (!(nodes != null && nodes.length)) return;
    const declars = [];
    const result = (0, $dSI8Z.default)(nodes, scope, declars);
    if (!result) return;
    for (const declar of declars)scope.push(declar);
    return result;
}

});
parcelRegister("dSI8Z", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a1b28f95107f334a$var$gatherSequenceExpressions;

var $3GTeN = parcelRequire("3GTeN");

var $2G7FY = parcelRequire("2G7FY");

var $7MfP7 = parcelRequire("7MfP7");

var $k6qdD = parcelRequire("k6qdD");
function $a1b28f95107f334a$var$gatherSequenceExpressions(nodes, scope, declars) {
    const exprs = [];
    let ensureLastUndefined = true;
    for (const node of nodes){
        if (!(0, $2G7FY.isEmptyStatement)(node)) ensureLastUndefined = false;
        if ((0, $2G7FY.isExpression)(node)) exprs.push(node);
        else if ((0, $2G7FY.isExpressionStatement)(node)) exprs.push(node.expression);
        else if ((0, $2G7FY.isVariableDeclaration)(node)) {
            if (node.kind !== "var") return;
            for (const declar of node.declarations){
                const bindings = (0, $3GTeN.default)(declar);
                for (const key of Object.keys(bindings))declars.push({
                    kind: node.kind,
                    id: (0, $k6qdD.default)(bindings[key])
                });
                if (declar.init) exprs.push((0, $7MfP7.assignmentExpression)("=", declar.id, declar.init));
            }
            ensureLastUndefined = true;
        } else if ((0, $2G7FY.isIfStatement)(node)) {
            const consequent = node.consequent ? $a1b28f95107f334a$var$gatherSequenceExpressions([
                node.consequent
            ], scope, declars) : scope.buildUndefinedNode();
            const alternate = node.alternate ? $a1b28f95107f334a$var$gatherSequenceExpressions([
                node.alternate
            ], scope, declars) : scope.buildUndefinedNode();
            if (!consequent || !alternate) return;
            exprs.push((0, $7MfP7.conditionalExpression)(node.test, consequent, alternate));
        } else if ((0, $2G7FY.isBlockStatement)(node)) {
            const body = $a1b28f95107f334a$var$gatherSequenceExpressions(node.body, scope, declars);
            if (!body) return;
            exprs.push(body);
        } else if ((0, $2G7FY.isEmptyStatement)(node)) {
            if (nodes.indexOf(node) === 0) ensureLastUndefined = true;
        } else return;
    }
    if (ensureLastUndefined) exprs.push(scope.buildUndefinedNode());
    if (exprs.length === 1) return exprs[0];
    else return (0, $7MfP7.sequenceExpression)(exprs);
}

});




parcelRegister("3krPT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ArrowFunctionExpression = $26c8d4fe8362db3a$var$ArrowFunctionExpression;
module.exports.AssignmentExpression = $26c8d4fe8362db3a$var$AssignmentExpression;
module.exports.Binary = $26c8d4fe8362db3a$var$Binary;
module.exports.BinaryExpression = $26c8d4fe8362db3a$var$BinaryExpression;
module.exports.ClassExpression = $26c8d4fe8362db3a$var$ClassExpression;
module.exports.ConditionalExpression = $26c8d4fe8362db3a$var$ConditionalExpression;
module.exports.DoExpression = $26c8d4fe8362db3a$var$DoExpression;
module.exports.FunctionExpression = $26c8d4fe8362db3a$var$FunctionExpression;
module.exports.FunctionTypeAnnotation = $26c8d4fe8362db3a$var$FunctionTypeAnnotation;
module.exports.Identifier = $26c8d4fe8362db3a$var$Identifier;
module.exports.LogicalExpression = $26c8d4fe8362db3a$var$LogicalExpression;
module.exports.NullableTypeAnnotation = $26c8d4fe8362db3a$var$NullableTypeAnnotation;
module.exports.ObjectExpression = $26c8d4fe8362db3a$var$ObjectExpression;
module.exports.OptionalIndexedAccessType = $26c8d4fe8362db3a$var$OptionalIndexedAccessType;
module.exports.OptionalCallExpression = module.exports.OptionalMemberExpression = $26c8d4fe8362db3a$var$OptionalMemberExpression;
module.exports.SequenceExpression = $26c8d4fe8362db3a$var$SequenceExpression;
module.exports.TSTypeAssertion = module.exports.TSSatisfiesExpression = module.exports.TSAsExpression = $26c8d4fe8362db3a$var$TSAsExpression;
module.exports.TSInferType = $26c8d4fe8362db3a$var$TSInferType;
module.exports.TSInstantiationExpression = $26c8d4fe8362db3a$var$TSInstantiationExpression;
module.exports.TSIntersectionType = module.exports.TSUnionType = $26c8d4fe8362db3a$var$TSUnionType;
module.exports.UnaryLike = $26c8d4fe8362db3a$var$UnaryLike;
module.exports.IntersectionTypeAnnotation = module.exports.UnionTypeAnnotation = $26c8d4fe8362db3a$var$UnionTypeAnnotation;
module.exports.UpdateExpression = $26c8d4fe8362db3a$var$UpdateExpression;
module.exports.AwaitExpression = module.exports.YieldExpression = $26c8d4fe8362db3a$var$YieldExpression;

var $ardUq = parcelRequire("ardUq");
const { isArrayTypeAnnotation: $26c8d4fe8362db3a$var$isArrayTypeAnnotation, isArrowFunctionExpression: $26c8d4fe8362db3a$var$isArrowFunctionExpression, isBinaryExpression: $26c8d4fe8362db3a$var$isBinaryExpression, isCallExpression: $26c8d4fe8362db3a$var$isCallExpression, isExportDeclaration: $26c8d4fe8362db3a$var$isExportDeclaration, isForOfStatement: $26c8d4fe8362db3a$var$isForOfStatement, isIndexedAccessType: $26c8d4fe8362db3a$var$isIndexedAccessType, isMemberExpression: $26c8d4fe8362db3a$var$isMemberExpression, isObjectPattern: $26c8d4fe8362db3a$var$isObjectPattern, isOptionalMemberExpression: $26c8d4fe8362db3a$var$isOptionalMemberExpression, isYieldExpression: $26c8d4fe8362db3a$var$isYieldExpression } = $ardUq;
const $26c8d4fe8362db3a$var$PRECEDENCE = new Map([
    [
        "||",
        0
    ],
    [
        "??",
        0
    ],
    [
        "|>",
        0
    ],
    [
        "&&",
        1
    ],
    [
        "|",
        2
    ],
    [
        "^",
        3
    ],
    [
        "&",
        4
    ],
    [
        "==",
        5
    ],
    [
        "===",
        5
    ],
    [
        "!=",
        5
    ],
    [
        "!==",
        5
    ],
    [
        "<",
        6
    ],
    [
        ">",
        6
    ],
    [
        "<=",
        6
    ],
    [
        ">=",
        6
    ],
    [
        "in",
        6
    ],
    [
        "instanceof",
        6
    ],
    [
        ">>",
        7
    ],
    [
        "<<",
        7
    ],
    [
        ">>>",
        7
    ],
    [
        "+",
        8
    ],
    [
        "-",
        8
    ],
    [
        "*",
        9
    ],
    [
        "/",
        9
    ],
    [
        "%",
        9
    ],
    [
        "**",
        10
    ]
]);
function $26c8d4fe8362db3a$var$isTSTypeExpression(nodeType) {
    return nodeType === "TSAsExpression" || nodeType === "TSSatisfiesExpression" || nodeType === "TSTypeAssertion";
}
const $26c8d4fe8362db3a$var$isClassExtendsClause = (node, parent)=>{
    const parentType = parent.type;
    return (parentType === "ClassDeclaration" || parentType === "ClassExpression") && parent.superClass === node;
};
const $26c8d4fe8362db3a$var$hasPostfixPart = (node, parent)=>{
    const parentType = parent.type;
    return (parentType === "MemberExpression" || parentType === "OptionalMemberExpression") && parent.object === node || (parentType === "CallExpression" || parentType === "OptionalCallExpression" || parentType === "NewExpression") && parent.callee === node || parentType === "TaggedTemplateExpression" && parent.tag === node || parentType === "TSNonNullExpression";
};
function $26c8d4fe8362db3a$var$NullableTypeAnnotation(node, parent) {
    return $26c8d4fe8362db3a$var$isArrayTypeAnnotation(parent);
}
function $26c8d4fe8362db3a$var$FunctionTypeAnnotation(node, parent, printStack) {
    if (printStack.length < 3) return;
    const parentType = parent.type;
    return parentType === "UnionTypeAnnotation" || parentType === "IntersectionTypeAnnotation" || parentType === "ArrayTypeAnnotation" || parentType === "TypeAnnotation" && $26c8d4fe8362db3a$var$isArrowFunctionExpression(printStack[printStack.length - 3]);
}
function $26c8d4fe8362db3a$var$UpdateExpression(node, parent) {
    return $26c8d4fe8362db3a$var$hasPostfixPart(node, parent) || $26c8d4fe8362db3a$var$isClassExtendsClause(node, parent);
}
function $26c8d4fe8362db3a$var$ObjectExpression(node, parent, printStack) {
    return $26c8d4fe8362db3a$var$isFirstInContext(printStack, 3);
}
function $26c8d4fe8362db3a$var$DoExpression(node, parent, printStack) {
    return !node.async && $26c8d4fe8362db3a$var$isFirstInContext(printStack, 1);
}
function $26c8d4fe8362db3a$var$Binary(node, parent) {
    const parentType = parent.type;
    if (node.operator === "**" && parentType === "BinaryExpression" && parent.operator === "**") return parent.left === node;
    if ($26c8d4fe8362db3a$var$isClassExtendsClause(node, parent)) return true;
    if ($26c8d4fe8362db3a$var$hasPostfixPart(node, parent) || parentType === "UnaryExpression" || parentType === "SpreadElement" || parentType === "AwaitExpression") return true;
    if (parentType === "BinaryExpression" || parentType === "LogicalExpression") {
        const parentPos = $26c8d4fe8362db3a$var$PRECEDENCE.get(parent.operator);
        const nodePos = $26c8d4fe8362db3a$var$PRECEDENCE.get(node.operator);
        if (parentPos === nodePos && parent.right === node && parentType !== "LogicalExpression" || parentPos > nodePos) return true;
    }
    return undefined;
}
function $26c8d4fe8362db3a$var$UnionTypeAnnotation(node, parent) {
    const parentType = parent.type;
    return parentType === "ArrayTypeAnnotation" || parentType === "NullableTypeAnnotation" || parentType === "IntersectionTypeAnnotation" || parentType === "UnionTypeAnnotation";
}
function $26c8d4fe8362db3a$var$OptionalIndexedAccessType(node, parent) {
    return $26c8d4fe8362db3a$var$isIndexedAccessType(parent) && parent.objectType === node;
}
function $26c8d4fe8362db3a$var$TSAsExpression() {
    return true;
}
function $26c8d4fe8362db3a$var$TSUnionType(node, parent) {
    const parentType = parent.type;
    return parentType === "TSArrayType" || parentType === "TSOptionalType" || parentType === "TSIntersectionType" || parentType === "TSUnionType" || parentType === "TSRestType";
}
function $26c8d4fe8362db3a$var$TSInferType(node, parent) {
    const parentType = parent.type;
    return parentType === "TSArrayType" || parentType === "TSOptionalType";
}
function $26c8d4fe8362db3a$var$TSInstantiationExpression(node, parent) {
    const parentType = parent.type;
    return (parentType === "CallExpression" || parentType === "OptionalCallExpression" || parentType === "NewExpression" || parentType === "TSInstantiationExpression") && !!parent.typeParameters;
}
function $26c8d4fe8362db3a$var$BinaryExpression(node, parent) {
    if (node.operator === "in") {
        const parentType = parent.type;
        return parentType === "VariableDeclarator" || parentType === "ForStatement" || parentType === "ForInStatement" || parentType === "ForOfStatement";
    }
    return false;
}
function $26c8d4fe8362db3a$var$SequenceExpression(node, parent) {
    const parentType = parent.type;
    if (parentType === "ForStatement" || parentType === "ThrowStatement" || parentType === "ReturnStatement" || parentType === "IfStatement" && parent.test === node || parentType === "WhileStatement" && parent.test === node || parentType === "ForInStatement" && parent.right === node || parentType === "SwitchStatement" && parent.discriminant === node || parentType === "ExpressionStatement" && parent.expression === node) return false;
    return true;
}
function $26c8d4fe8362db3a$var$YieldExpression(node, parent) {
    const parentType = parent.type;
    return parentType === "BinaryExpression" || parentType === "LogicalExpression" || parentType === "UnaryExpression" || parentType === "SpreadElement" || $26c8d4fe8362db3a$var$hasPostfixPart(node, parent) || parentType === "AwaitExpression" && $26c8d4fe8362db3a$var$isYieldExpression(node) || parentType === "ConditionalExpression" && node === parent.test || $26c8d4fe8362db3a$var$isClassExtendsClause(node, parent);
}
function $26c8d4fe8362db3a$var$ClassExpression(node, parent, printStack) {
    return $26c8d4fe8362db3a$var$isFirstInContext(printStack, 5);
}
function $26c8d4fe8362db3a$var$UnaryLike(node, parent) {
    return $26c8d4fe8362db3a$var$hasPostfixPart(node, parent) || $26c8d4fe8362db3a$var$isBinaryExpression(parent) && parent.operator === "**" && parent.left === node || $26c8d4fe8362db3a$var$isClassExtendsClause(node, parent);
}
function $26c8d4fe8362db3a$var$FunctionExpression(node, parent, printStack) {
    return $26c8d4fe8362db3a$var$isFirstInContext(printStack, 5);
}
function $26c8d4fe8362db3a$var$ArrowFunctionExpression(node, parent) {
    return $26c8d4fe8362db3a$var$isExportDeclaration(parent) || $26c8d4fe8362db3a$var$ConditionalExpression(node, parent);
}
function $26c8d4fe8362db3a$var$ConditionalExpression(node, parent) {
    const parentType = parent.type;
    if (parentType === "UnaryExpression" || parentType === "SpreadElement" || parentType === "BinaryExpression" || parentType === "LogicalExpression" || parentType === "ConditionalExpression" && parent.test === node || parentType === "AwaitExpression" || $26c8d4fe8362db3a$var$isTSTypeExpression(parentType)) return true;
    return $26c8d4fe8362db3a$var$UnaryLike(node, parent);
}
function $26c8d4fe8362db3a$var$OptionalMemberExpression(node, parent) {
    return $26c8d4fe8362db3a$var$isCallExpression(parent) && parent.callee === node || $26c8d4fe8362db3a$var$isMemberExpression(parent) && parent.object === node;
}
function $26c8d4fe8362db3a$var$AssignmentExpression(node, parent) {
    if ($26c8d4fe8362db3a$var$isObjectPattern(node.left)) return true;
    else return $26c8d4fe8362db3a$var$ConditionalExpression(node, parent);
}
function $26c8d4fe8362db3a$var$LogicalExpression(node, parent) {
    const parentType = parent.type;
    if ($26c8d4fe8362db3a$var$isTSTypeExpression(parentType)) return true;
    if (parentType !== "LogicalExpression") return false;
    switch(node.operator){
        case "||":
            return parent.operator === "??" || parent.operator === "&&";
        case "&&":
            return parent.operator === "??";
        case "??":
            return parent.operator !== "??";
    }
}
function $26c8d4fe8362db3a$var$Identifier(node, parent, printStack) {
    var _node$extra;
    const parentType = parent.type;
    if ((_node$extra = node.extra) != null && _node$extra.parenthesized && parentType === "AssignmentExpression" && parent.left === node) {
        const rightType = parent.right.type;
        if ((rightType === "FunctionExpression" || rightType === "ClassExpression") && parent.right.id == null) return true;
    }
    if (node.name === "let") {
        const isFollowedByBracket = $26c8d4fe8362db3a$var$isMemberExpression(parent, {
            object: node,
            computed: true
        }) || $26c8d4fe8362db3a$var$isOptionalMemberExpression(parent, {
            object: node,
            computed: true,
            optional: false
        });
        return $26c8d4fe8362db3a$var$isFirstInContext(printStack, isFollowedByBracket ? 57 : 32);
    }
    return node.name === "async" && $26c8d4fe8362db3a$var$isForOfStatement(parent) && node === parent.left;
}
function $26c8d4fe8362db3a$var$isFirstInContext(printStack, checkParam) {
    const expressionStatement = checkParam & 1;
    const arrowBody = checkParam & 2;
    const exportDefault = checkParam & 4;
    const forHead = checkParam & 8;
    const forInHead = checkParam & 16;
    const forOfHead = checkParam & 32;
    let i = printStack.length - 1;
    if (i <= 0) return;
    let node = printStack[i];
    i--;
    let parent = printStack[i];
    while(i >= 0){
        const parentType = parent.type;
        if (expressionStatement && parentType === "ExpressionStatement" && parent.expression === node || exportDefault && parentType === "ExportDefaultDeclaration" && node === parent.declaration || arrowBody && parentType === "ArrowFunctionExpression" && parent.body === node || forHead && parentType === "ForStatement" && parent.init === node || forInHead && parentType === "ForInStatement" && parent.left === node || forOfHead && parentType === "ForOfStatement" && parent.left === node) return true;
        if (i > 0 && ($26c8d4fe8362db3a$var$hasPostfixPart(node, parent) && parentType !== "NewExpression" || parentType === "SequenceExpression" && parent.expressions[0] === node || parentType === "UpdateExpression" && !parent.prefix || parentType === "ConditionalExpression" && parent.test === node || (parentType === "BinaryExpression" || parentType === "LogicalExpression") && parent.left === node || parentType === "AssignmentExpression" && parent.left === node)) {
            node = parent;
            i--;
            parent = printStack[i];
        } else return false;
    }
    return false;
}

});


parcelRegister("bGU9c", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $fYyt2 = parcelRequire("fYyt2");
Object.keys($fYyt2).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $fYyt2[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $fYyt2[key];
        }
    });
});

var $88P25 = parcelRequire("88P25");
Object.keys($88P25).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $88P25[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $88P25[key];
        }
    });
});

var $guMud = parcelRequire("guMud");
Object.keys($guMud).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $guMud[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $guMud[key];
        }
    });
});

var $ftdXE = parcelRequire("ftdXE");
Object.keys($ftdXE).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $ftdXE[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $ftdXE[key];
        }
    });
});

var $5lxzn = parcelRequire("5lxzn");
Object.keys($5lxzn).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $5lxzn[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $5lxzn[key];
        }
    });
});

var $aTtp5 = parcelRequire("aTtp5");
Object.keys($aTtp5).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $aTtp5[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $aTtp5[key];
        }
    });
});

var $fKIiT = parcelRequire("fKIiT");
Object.keys($fKIiT).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $fKIiT[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $fKIiT[key];
        }
    });
});

var $6OSqV = parcelRequire("6OSqV");
Object.keys($6OSqV).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $6OSqV[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $6OSqV[key];
        }
    });
});

var $4drJu = parcelRequire("4drJu");
Object.keys($4drJu).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $4drJu[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $4drJu[key];
        }
    });
});

var $p9IH2 = parcelRequire("p9IH2");
Object.keys($p9IH2).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $p9IH2[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $p9IH2[key];
        }
    });
});

var $bWZlM = parcelRequire("bWZlM");
Object.keys($bWZlM).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $bWZlM[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $bWZlM[key];
        }
    });
});

});
parcelRegister("fYyt2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TaggedTemplateExpression = $ba17321a9317ff74$var$TaggedTemplateExpression;
module.exports.TemplateElement = $ba17321a9317ff74$var$TemplateElement;
module.exports.TemplateLiteral = $ba17321a9317ff74$var$TemplateLiteral;
function $ba17321a9317ff74$var$TaggedTemplateExpression(node) {
    this.print(node.tag, node);
    this.print(node.typeParameters, node);
    this.print(node.quasi, node);
}
function $ba17321a9317ff74$var$TemplateElement(node, parent) {
    const isFirst = parent.quasis[0] === node;
    const isLast = parent.quasis[parent.quasis.length - 1] === node;
    const value = (isFirst ? "`" : "}") + node.value.raw + (isLast ? "`" : "${");
    this.token(value, true);
}
function $ba17321a9317ff74$var$TemplateLiteral(node) {
    const quasis = node.quasis;
    for(let i = 0; i < quasis.length; i++){
        this.print(quasis[i], node);
        if (i + 1 < quasis.length) this.print(node.expressions[i], node);
    }
}

});

parcelRegister("88P25", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LogicalExpression = module.exports.BinaryExpression = module.exports.AssignmentExpression = $5ed6a81b53800711$var$AssignmentExpression;
module.exports.AssignmentPattern = $5ed6a81b53800711$var$AssignmentPattern;
module.exports.AwaitExpression = $5ed6a81b53800711$var$AwaitExpression;
module.exports.BindExpression = $5ed6a81b53800711$var$BindExpression;
module.exports.CallExpression = $5ed6a81b53800711$var$CallExpression;
module.exports.ConditionalExpression = $5ed6a81b53800711$var$ConditionalExpression;
module.exports.Decorator = $5ed6a81b53800711$var$Decorator;
module.exports.DoExpression = $5ed6a81b53800711$var$DoExpression;
module.exports.EmptyStatement = $5ed6a81b53800711$var$EmptyStatement;
module.exports.ExpressionStatement = $5ed6a81b53800711$var$ExpressionStatement;
module.exports.Import = $5ed6a81b53800711$var$Import;
module.exports.MemberExpression = $5ed6a81b53800711$var$MemberExpression;
module.exports.MetaProperty = $5ed6a81b53800711$var$MetaProperty;
module.exports.ModuleExpression = $5ed6a81b53800711$var$ModuleExpression;
module.exports.NewExpression = $5ed6a81b53800711$var$NewExpression;
module.exports.OptionalCallExpression = $5ed6a81b53800711$var$OptionalCallExpression;
module.exports.OptionalMemberExpression = $5ed6a81b53800711$var$OptionalMemberExpression;
module.exports.ParenthesizedExpression = $5ed6a81b53800711$var$ParenthesizedExpression;
module.exports.PrivateName = $5ed6a81b53800711$var$PrivateName;
module.exports.SequenceExpression = $5ed6a81b53800711$var$SequenceExpression;
module.exports.Super = $5ed6a81b53800711$var$Super;
module.exports.ThisExpression = $5ed6a81b53800711$var$ThisExpression;
module.exports.UnaryExpression = $5ed6a81b53800711$var$UnaryExpression;
module.exports.UpdateExpression = $5ed6a81b53800711$var$UpdateExpression;
module.exports.V8IntrinsicIdentifier = $5ed6a81b53800711$var$V8IntrinsicIdentifier;
module.exports.YieldExpression = $5ed6a81b53800711$var$YieldExpression;
module.exports._shouldPrintDecoratorsBeforeExport = $5ed6a81b53800711$var$_shouldPrintDecoratorsBeforeExport;

var $ardUq = parcelRequire("ardUq");

var $d5V7k = parcelRequire("d5V7k");
const { isCallExpression: $5ed6a81b53800711$var$isCallExpression, isLiteral: $5ed6a81b53800711$var$isLiteral, isMemberExpression: $5ed6a81b53800711$var$isMemberExpression, isNewExpression: $5ed6a81b53800711$var$isNewExpression } = $ardUq;
function $5ed6a81b53800711$var$UnaryExpression(node) {
    const { operator: operator } = node;
    if (operator === "void" || operator === "delete" || operator === "typeof" || operator === "throw") {
        this.word(operator);
        this.space();
    } else this.token(operator);
    this.print(node.argument, node);
}
function $5ed6a81b53800711$var$DoExpression(node) {
    if (node.async) {
        this.word("async", true);
        this.space();
    }
    this.word("do");
    this.space();
    this.print(node.body, node);
}
function $5ed6a81b53800711$var$ParenthesizedExpression(node) {
    this.tokenChar(40);
    this.print(node.expression, node);
    this.rightParens(node);
}
function $5ed6a81b53800711$var$UpdateExpression(node) {
    if (node.prefix) {
        this.token(node.operator);
        this.print(node.argument, node);
    } else {
        this.printTerminatorless(node.argument, node, true);
        this.token(node.operator);
    }
}
function $5ed6a81b53800711$var$ConditionalExpression(node) {
    this.print(node.test, node);
    this.space();
    this.tokenChar(63);
    this.space();
    this.print(node.consequent, node);
    this.space();
    this.tokenChar(58);
    this.space();
    this.print(node.alternate, node);
}
function $5ed6a81b53800711$var$NewExpression(node, parent) {
    this.word("new");
    this.space();
    this.print(node.callee, node);
    if (this.format.minified && node.arguments.length === 0 && !node.optional && !$5ed6a81b53800711$var$isCallExpression(parent, {
        callee: node
    }) && !$5ed6a81b53800711$var$isMemberExpression(parent) && !$5ed6a81b53800711$var$isNewExpression(parent)) return;
    this.print(node.typeArguments, node);
    this.print(node.typeParameters, node);
    if (node.optional) this.token("?.");
    this.tokenChar(40);
    this.printList(node.arguments, node);
    this.rightParens(node);
}
function $5ed6a81b53800711$var$SequenceExpression(node) {
    this.printList(node.expressions, node);
}
function $5ed6a81b53800711$var$ThisExpression() {
    this.word("this");
}
function $5ed6a81b53800711$var$Super() {
    this.word("super");
}
function $5ed6a81b53800711$var$isDecoratorMemberExpression(node) {
    switch(node.type){
        case "Identifier":
            return true;
        case "MemberExpression":
            return !node.computed && node.property.type === "Identifier" && $5ed6a81b53800711$var$isDecoratorMemberExpression(node.object);
        default:
            return false;
    }
}
function $5ed6a81b53800711$var$shouldParenthesizeDecoratorExpression(node) {
    if (node.type === "ParenthesizedExpression") return false;
    return !$5ed6a81b53800711$var$isDecoratorMemberExpression(node.type === "CallExpression" ? node.callee : node);
}
function $5ed6a81b53800711$var$_shouldPrintDecoratorsBeforeExport(node) {
    if (typeof this.format.decoratorsBeforeExport === "boolean") return this.format.decoratorsBeforeExport;
    return typeof node.start === "number" && node.start === node.declaration.start;
}
function $5ed6a81b53800711$var$Decorator(node) {
    this.tokenChar(64);
    const { expression: expression } = node;
    if ($5ed6a81b53800711$var$shouldParenthesizeDecoratorExpression(expression)) {
        this.tokenChar(40);
        this.print(expression, node);
        this.tokenChar(41);
    } else this.print(expression, node);
    this.newline();
}
function $5ed6a81b53800711$var$OptionalMemberExpression(node) {
    let { computed: computed } = node;
    const { optional: optional, property: property } = node;
    this.print(node.object, node);
    if (!computed && $5ed6a81b53800711$var$isMemberExpression(property)) throw new TypeError("Got a MemberExpression for MemberExpression property");
    if ($5ed6a81b53800711$var$isLiteral(property) && typeof property.value === "number") computed = true;
    if (optional) this.token("?.");
    if (computed) {
        this.tokenChar(91);
        this.print(property, node);
        this.tokenChar(93);
    } else {
        if (!optional) this.tokenChar(46);
        this.print(property, node);
    }
}
function $5ed6a81b53800711$var$OptionalCallExpression(node) {
    this.print(node.callee, node);
    this.print(node.typeParameters, node);
    if (node.optional) this.token("?.");
    this.print(node.typeArguments, node);
    this.tokenChar(40);
    this.printList(node.arguments, node);
    this.rightParens(node);
}
function $5ed6a81b53800711$var$CallExpression(node) {
    this.print(node.callee, node);
    this.print(node.typeArguments, node);
    this.print(node.typeParameters, node);
    this.tokenChar(40);
    this.printList(node.arguments, node);
    this.rightParens(node);
}
function $5ed6a81b53800711$var$Import() {
    this.word("import");
}
function $5ed6a81b53800711$var$AwaitExpression(node) {
    this.word("await");
    if (node.argument) {
        this.space();
        this.printTerminatorless(node.argument, node, false);
    }
}
function $5ed6a81b53800711$var$YieldExpression(node) {
    this.word("yield", true);
    if (node.delegate) {
        this.tokenChar(42);
        if (node.argument) {
            this.space();
            this.print(node.argument, node);
        }
    } else if (node.argument) {
        this.space();
        this.printTerminatorless(node.argument, node, false);
    }
}
function $5ed6a81b53800711$var$EmptyStatement() {
    this.semicolon(true);
}
function $5ed6a81b53800711$var$ExpressionStatement(node) {
    this.print(node.expression, node);
    this.semicolon();
}
function $5ed6a81b53800711$var$AssignmentPattern(node) {
    this.print(node.left, node);
    if (node.left.optional) this.tokenChar(63);
    this.print(node.left.typeAnnotation, node);
    this.space();
    this.tokenChar(61);
    this.space();
    this.print(node.right, node);
}
function $5ed6a81b53800711$var$AssignmentExpression(node, parent) {
    const parens = this.inForStatementInitCounter && node.operator === "in" && !$d5V7k.needsParens(node, parent);
    if (parens) this.tokenChar(40);
    this.print(node.left, node);
    this.space();
    if (node.operator === "in" || node.operator === "instanceof") this.word(node.operator);
    else this.token(node.operator);
    this.space();
    this.print(node.right, node);
    if (parens) this.tokenChar(41);
}
function $5ed6a81b53800711$var$BindExpression(node) {
    this.print(node.object, node);
    this.token("::");
    this.print(node.callee, node);
}
function $5ed6a81b53800711$var$MemberExpression(node) {
    this.print(node.object, node);
    if (!node.computed && $5ed6a81b53800711$var$isMemberExpression(node.property)) throw new TypeError("Got a MemberExpression for MemberExpression property");
    let computed = node.computed;
    if ($5ed6a81b53800711$var$isLiteral(node.property) && typeof node.property.value === "number") computed = true;
    if (computed) {
        this.tokenChar(91);
        this.print(node.property, node);
        this.tokenChar(93);
    } else {
        this.tokenChar(46);
        this.print(node.property, node);
    }
}
function $5ed6a81b53800711$var$MetaProperty(node) {
    this.print(node.meta, node);
    this.tokenChar(46);
    this.print(node.property, node);
}
function $5ed6a81b53800711$var$PrivateName(node) {
    this.tokenChar(35);
    this.print(node.id, node);
}
function $5ed6a81b53800711$var$V8IntrinsicIdentifier(node) {
    this.tokenChar(37);
    this.word(node.name);
}
function $5ed6a81b53800711$var$ModuleExpression(node) {
    this.word("module", true);
    this.space();
    this.tokenChar(123);
    this.indent();
    const { body: body } = node;
    if (body.body.length || body.directives.length) this.newline();
    this.print(body, node);
    this.dedent();
    this.rightBrace(node);
}

});

parcelRegister("guMud", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BreakStatement = $c0250f110867871d$var$BreakStatement;
module.exports.CatchClause = $c0250f110867871d$var$CatchClause;
module.exports.ContinueStatement = $c0250f110867871d$var$ContinueStatement;
module.exports.DebuggerStatement = $c0250f110867871d$var$DebuggerStatement;
module.exports.DoWhileStatement = $c0250f110867871d$var$DoWhileStatement;
module.exports.ForOfStatement = module.exports.ForInStatement = void 0;
module.exports.ForStatement = $c0250f110867871d$var$ForStatement;
module.exports.IfStatement = $c0250f110867871d$var$IfStatement;
module.exports.LabeledStatement = $c0250f110867871d$var$LabeledStatement;
module.exports.ReturnStatement = $c0250f110867871d$var$ReturnStatement;
module.exports.SwitchCase = $c0250f110867871d$var$SwitchCase;
module.exports.SwitchStatement = $c0250f110867871d$var$SwitchStatement;
module.exports.ThrowStatement = $c0250f110867871d$var$ThrowStatement;
module.exports.TryStatement = $c0250f110867871d$var$TryStatement;
module.exports.VariableDeclaration = $c0250f110867871d$var$VariableDeclaration;
module.exports.VariableDeclarator = $c0250f110867871d$var$VariableDeclarator;
module.exports.WhileStatement = $c0250f110867871d$var$WhileStatement;
module.exports.WithStatement = $c0250f110867871d$var$WithStatement;

var $ardUq = parcelRequire("ardUq");
const { isFor: $c0250f110867871d$var$isFor, isForStatement: $c0250f110867871d$var$isForStatement, isIfStatement: $c0250f110867871d$var$isIfStatement, isStatement: $c0250f110867871d$var$isStatement } = $ardUq;
function $c0250f110867871d$var$WithStatement(node) {
    this.word("with");
    this.space();
    this.tokenChar(40);
    this.print(node.object, node);
    this.tokenChar(41);
    this.printBlock(node);
}
function $c0250f110867871d$var$IfStatement(node) {
    this.word("if");
    this.space();
    this.tokenChar(40);
    this.print(node.test, node);
    this.tokenChar(41);
    this.space();
    const needsBlock = node.alternate && $c0250f110867871d$var$isIfStatement($c0250f110867871d$var$getLastStatement(node.consequent));
    if (needsBlock) {
        this.tokenChar(123);
        this.newline();
        this.indent();
    }
    this.printAndIndentOnComments(node.consequent, node);
    if (needsBlock) {
        this.dedent();
        this.newline();
        this.tokenChar(125);
    }
    if (node.alternate) {
        if (this.endsWith(125)) this.space();
        this.word("else");
        this.space();
        this.printAndIndentOnComments(node.alternate, node);
    }
}
function $c0250f110867871d$var$getLastStatement(statement) {
    const { body: body } = statement;
    if ($c0250f110867871d$var$isStatement(body) === false) return statement;
    return $c0250f110867871d$var$getLastStatement(body);
}
function $c0250f110867871d$var$ForStatement(node) {
    this.word("for");
    this.space();
    this.tokenChar(40);
    this.inForStatementInitCounter++;
    this.print(node.init, node);
    this.inForStatementInitCounter--;
    this.tokenChar(59);
    if (node.test) {
        this.space();
        this.print(node.test, node);
    }
    this.tokenChar(59);
    if (node.update) {
        this.space();
        this.print(node.update, node);
    }
    this.tokenChar(41);
    this.printBlock(node);
}
function $c0250f110867871d$var$WhileStatement(node) {
    this.word("while");
    this.space();
    this.tokenChar(40);
    this.print(node.test, node);
    this.tokenChar(41);
    this.printBlock(node);
}
function $c0250f110867871d$var$ForXStatement(node) {
    this.word("for");
    this.space();
    const isForOf = node.type === "ForOfStatement";
    if (isForOf && node.await) {
        this.word("await");
        this.space();
    }
    this.noIndentInnerCommentsHere();
    this.tokenChar(40);
    this.print(node.left, node);
    this.space();
    this.word(isForOf ? "of" : "in");
    this.space();
    this.print(node.right, node);
    this.tokenChar(41);
    this.printBlock(node);
}
const $c0250f110867871d$var$ForInStatement = module.exports.ForInStatement = $c0250f110867871d$var$ForXStatement;
const $c0250f110867871d$var$ForOfStatement = module.exports.ForOfStatement = $c0250f110867871d$var$ForXStatement;
function $c0250f110867871d$var$DoWhileStatement(node) {
    this.word("do");
    this.space();
    this.print(node.body, node);
    this.space();
    this.word("while");
    this.space();
    this.tokenChar(40);
    this.print(node.test, node);
    this.tokenChar(41);
    this.semicolon();
}
function $c0250f110867871d$var$printStatementAfterKeyword(printer, node, parent, isLabel) {
    if (node) {
        printer.space();
        printer.printTerminatorless(node, parent, isLabel);
    }
    printer.semicolon();
}
function $c0250f110867871d$var$BreakStatement(node) {
    this.word("break");
    $c0250f110867871d$var$printStatementAfterKeyword(this, node.label, node, true);
}
function $c0250f110867871d$var$ContinueStatement(node) {
    this.word("continue");
    $c0250f110867871d$var$printStatementAfterKeyword(this, node.label, node, true);
}
function $c0250f110867871d$var$ReturnStatement(node) {
    this.word("return");
    $c0250f110867871d$var$printStatementAfterKeyword(this, node.argument, node, false);
}
function $c0250f110867871d$var$ThrowStatement(node) {
    this.word("throw");
    $c0250f110867871d$var$printStatementAfterKeyword(this, node.argument, node, false);
}
function $c0250f110867871d$var$LabeledStatement(node) {
    this.print(node.label, node);
    this.tokenChar(58);
    this.space();
    this.print(node.body, node);
}
function $c0250f110867871d$var$TryStatement(node) {
    this.word("try");
    this.space();
    this.print(node.block, node);
    this.space();
    if (node.handlers) this.print(node.handlers[0], node);
    else this.print(node.handler, node);
    if (node.finalizer) {
        this.space();
        this.word("finally");
        this.space();
        this.print(node.finalizer, node);
    }
}
function $c0250f110867871d$var$CatchClause(node) {
    this.word("catch");
    this.space();
    if (node.param) {
        this.tokenChar(40);
        this.print(node.param, node);
        this.print(node.param.typeAnnotation, node);
        this.tokenChar(41);
        this.space();
    }
    this.print(node.body, node);
}
function $c0250f110867871d$var$SwitchStatement(node) {
    this.word("switch");
    this.space();
    this.tokenChar(40);
    this.print(node.discriminant, node);
    this.tokenChar(41);
    this.space();
    this.tokenChar(123);
    this.printSequence(node.cases, node, {
        indent: true,
        addNewlines (leading, cas) {
            if (!leading && node.cases[node.cases.length - 1] === cas) return -1;
        }
    });
    this.rightBrace(node);
}
function $c0250f110867871d$var$SwitchCase(node) {
    if (node.test) {
        this.word("case");
        this.space();
        this.print(node.test, node);
        this.tokenChar(58);
    } else {
        this.word("default");
        this.tokenChar(58);
    }
    if (node.consequent.length) {
        this.newline();
        this.printSequence(node.consequent, node, {
            indent: true
        });
    }
}
function $c0250f110867871d$var$DebuggerStatement() {
    this.word("debugger");
    this.semicolon();
}
function $c0250f110867871d$var$VariableDeclaration(node, parent) {
    if (node.declare) {
        this.word("declare");
        this.space();
    }
    const { kind: kind } = node;
    this.word(kind, kind === "using" || kind === "await using");
    this.space();
    let hasInits = false;
    if (!$c0250f110867871d$var$isFor(parent)) {
        for (const declar of node.declarations)if (declar.init) hasInits = true;
    }
    this.printList(node.declarations, node, {
        separator: hasInits ? function() {
            this.tokenChar(44);
            this.newline();
        } : undefined,
        indent: node.declarations.length > 1 ? true : false
    });
    if ($c0250f110867871d$var$isFor(parent)) {
        if ($c0250f110867871d$var$isForStatement(parent)) {
            if (parent.init === node) return;
        } else {
            if (parent.left === node) return;
        }
    }
    this.semicolon();
}
function $c0250f110867871d$var$VariableDeclarator(node) {
    this.print(node.id, node);
    if (node.definite) this.tokenChar(33);
    this.print(node.id.typeAnnotation, node);
    if (node.init) {
        this.space();
        this.tokenChar(61);
        this.space();
        this.print(node.init, node);
    }
}

});

parcelRegister("ftdXE", function(module, exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ClassAccessorProperty = ClassAccessorProperty;
exports.ClassBody = ClassBody;
exports.ClassExpression = exports.ClassDeclaration = ClassDeclaration;
exports.ClassMethod = ClassMethod;
exports.ClassPrivateMethod = ClassPrivateMethod;
exports.ClassPrivateProperty = ClassPrivateProperty;
exports.ClassProperty = ClassProperty;
exports.StaticBlock = StaticBlock;
exports._classMethodHead = _classMethodHead;

var $ardUq = parcelRequire("ardUq");
const { isExportDefaultDeclaration, isExportNamedDeclaration } = $ardUq;
function ClassDeclaration(node, parent) {
    const inExport = isExportDefaultDeclaration(parent) || isExportNamedDeclaration(parent);
    if (!inExport || !this._shouldPrintDecoratorsBeforeExport(parent)) this.printJoin(node.decorators, node);
    if (node.declare) {
        this.word("declare");
        this.space();
    }
    if (node.abstract) {
        this.word("abstract");
        this.space();
    }
    this.word("class");
    if (node.id) {
        this.space();
        this.print(node.id, node);
    }
    this.print(node.typeParameters, node);
    if (node.superClass) {
        this.space();
        this.word("extends");
        this.space();
        this.print(node.superClass, node);
        this.print(node.superTypeParameters, node);
    }
    if (node.implements) {
        this.space();
        this.word("implements");
        this.space();
        this.printList(node.implements, node);
    }
    this.space();
    this.print(node.body, node);
}
function ClassBody(node) {
    this.tokenChar(123);
    if (node.body.length === 0) this.tokenChar(125);
    else {
        this.newline();
        this.printSequence(node.body, node, {
            indent: true
        });
        if (!this.endsWith(10)) this.newline();
        this.rightBrace(node);
    }
}
function ClassProperty(node) {
    var _node$key$loc;
    this.printJoin(node.decorators, node);
    const endLine = (_node$key$loc = node.key.loc) == null || (_node$key$loc = _node$key$loc.end) == null ? void 0 : _node$key$loc.line;
    if (endLine) this.catchUp(endLine);
    this.tsPrintClassMemberModifiers(node);
    if (node.computed) {
        this.tokenChar(91);
        this.print(node.key, node);
        this.tokenChar(93);
    } else {
        this._variance(node);
        this.print(node.key, node);
    }
    if (node.optional) this.tokenChar(63);
    if (node.definite) this.tokenChar(33);
    this.print(node.typeAnnotation, node);
    if (node.value) {
        this.space();
        this.tokenChar(61);
        this.space();
        this.print(node.value, node);
    }
    this.semicolon();
}
function ClassAccessorProperty(node) {
    var _node$key$loc2;
    this.printJoin(node.decorators, node);
    const endLine = (_node$key$loc2 = node.key.loc) == null || (_node$key$loc2 = _node$key$loc2.end) == null ? void 0 : _node$key$loc2.line;
    if (endLine) this.catchUp(endLine);
    this.tsPrintClassMemberModifiers(node);
    this.word("accessor", true);
    this.space();
    if (node.computed) {
        this.tokenChar(91);
        this.print(node.key, node);
        this.tokenChar(93);
    } else {
        this._variance(node);
        this.print(node.key, node);
    }
    if (node.optional) this.tokenChar(63);
    if (node.definite) this.tokenChar(33);
    this.print(node.typeAnnotation, node);
    if (node.value) {
        this.space();
        this.tokenChar(61);
        this.space();
        this.print(node.value, node);
    }
    this.semicolon();
}
function ClassPrivateProperty(node) {
    this.printJoin(node.decorators, node);
    if (node.static) {
        this.word("static");
        this.space();
    }
    this.print(node.key, node);
    this.print(node.typeAnnotation, node);
    if (node.value) {
        this.space();
        this.tokenChar(61);
        this.space();
        this.print(node.value, node);
    }
    this.semicolon();
}
function ClassMethod(node) {
    this._classMethodHead(node);
    this.space();
    this.print(node.body, node);
}
function ClassPrivateMethod(node) {
    this._classMethodHead(node);
    this.space();
    this.print(node.body, node);
}
function _classMethodHead(node) {
    var _node$key$loc3;
    this.printJoin(node.decorators, node);
    const endLine = (_node$key$loc3 = node.key.loc) == null || (_node$key$loc3 = _node$key$loc3.end) == null ? void 0 : _node$key$loc3.line;
    if (endLine) this.catchUp(endLine);
    this.tsPrintClassMemberModifiers(node);
    this._methodHead(node);
}
function StaticBlock(node) {
    this.word("static");
    this.space();
    this.tokenChar(123);
    if (node.body.length === 0) this.tokenChar(125);
    else {
        this.newline();
        this.printSequence(node.body, node, {
            indent: true
        });
        this.rightBrace(node);
    }
}

});

parcelRegister("5lxzn", function(module, exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ArrowFunctionExpression = ArrowFunctionExpression;
exports.FunctionDeclaration = exports.FunctionExpression = FunctionExpression;
exports._functionHead = _functionHead;
exports._methodHead = _methodHead;
exports._param = _param;
exports._parameters = _parameters;
exports._params = _params;
exports._predicate = _predicate;

var $ardUq = parcelRequire("ardUq");
const { isIdentifier } = $ardUq;
function _params(node, idNode, parentNode) {
    this.print(node.typeParameters, node);
    const nameInfo = _getFuncIdName.call(this, idNode, parentNode);
    if (nameInfo) this.sourceIdentifierName(nameInfo.name, nameInfo.pos);
    this.tokenChar(40);
    this._parameters(node.params, node);
    this.tokenChar(41);
    const noLineTerminator = node.type === "ArrowFunctionExpression";
    this.print(node.returnType, node, noLineTerminator);
    this._noLineTerminator = noLineTerminator;
}
function _parameters(parameters, parent) {
    const paramLength = parameters.length;
    for(let i = 0; i < paramLength; i++){
        this._param(parameters[i], parent);
        if (i < parameters.length - 1) {
            this.tokenChar(44);
            this.space();
        }
    }
}
function _param(parameter, parent) {
    this.printJoin(parameter.decorators, parameter);
    this.print(parameter, parent);
    if (parameter.optional) this.tokenChar(63);
    this.print(parameter.typeAnnotation, parameter);
}
function _methodHead(node) {
    const kind = node.kind;
    const key = node.key;
    if (kind === "get" || kind === "set") {
        this.word(kind);
        this.space();
    }
    if (node.async) {
        this.word("async", true);
        this.space();
    }
    if (kind === "method" || kind === "init") {
        if (node.generator) this.tokenChar(42);
    }
    if (node.computed) {
        this.tokenChar(91);
        this.print(key, node);
        this.tokenChar(93);
    } else this.print(key, node);
    if (node.optional) this.tokenChar(63);
    this._params(node, node.computed && node.key.type !== "StringLiteral" ? undefined : node.key, undefined);
}
function _predicate(node, noLineTerminatorAfter) {
    if (node.predicate) {
        if (!node.returnType) this.tokenChar(58);
        this.space();
        this.print(node.predicate, node, noLineTerminatorAfter);
    }
}
function _functionHead(node, parent) {
    if (node.async) {
        this.word("async");
        this._endsWithInnerRaw = false;
        this.space();
    }
    this.word("function");
    if (node.generator) {
        this._endsWithInnerRaw = false;
        this.tokenChar(42);
    }
    this.space();
    if (node.id) this.print(node.id, node);
    this._params(node, node.id, parent);
    if (node.type !== "TSDeclareFunction") this._predicate(node);
}
function FunctionExpression(node, parent) {
    this._functionHead(node, parent);
    this.space();
    this.print(node.body, node);
}
function ArrowFunctionExpression(node, parent) {
    if (node.async) {
        this.word("async", true);
        this.space();
    }
    let firstParam;
    if (!this.format.retainLines && node.params.length === 1 && isIdentifier(firstParam = node.params[0]) && !hasTypesOrComments(node, firstParam)) this.print(firstParam, node, true);
    else this._params(node, undefined, parent);
    this._predicate(node, true);
    this.space();
    this.printInnerComments();
    this.token("=>");
    this.space();
    this.print(node.body, node);
}
function hasTypesOrComments(node, param) {
    var _param$leadingComment, _param$trailingCommen;
    return !!(node.typeParameters || node.returnType || node.predicate || param.typeAnnotation || param.optional || (_param$leadingComment = param.leadingComments) != null && _param$leadingComment.length || (_param$trailingCommen = param.trailingComments) != null && _param$trailingCommen.length);
}
function _getFuncIdName(idNode, parent) {
    let id = idNode;
    if (!id && parent) {
        const parentType = parent.type;
        if (parentType === "VariableDeclarator") id = parent.id;
        else if (parentType === "AssignmentExpression" || parentType === "AssignmentPattern") id = parent.left;
        else if (parentType === "ObjectProperty" || parentType === "ClassProperty") {
            if (!parent.computed || parent.key.type === "StringLiteral") id = parent.key;
        } else if (parentType === "ClassPrivateProperty" || parentType === "ClassAccessorProperty") id = parent.key;
    }
    if (!id) return;
    let nameInfo;
    if (id.type === "Identifier") {
        var _id$loc, _id$loc2;
        nameInfo = {
            pos: (_id$loc = id.loc) == null ? void 0 : _id$loc.start,
            name: ((_id$loc2 = id.loc) == null ? void 0 : _id$loc2.identifierName) || id.name
        };
    } else if (id.type === "PrivateName") {
        var _id$loc3;
        nameInfo = {
            pos: (_id$loc3 = id.loc) == null ? void 0 : _id$loc3.start,
            name: "#" + id.id.name
        };
    } else if (id.type === "StringLiteral") {
        var _id$loc4;
        nameInfo = {
            pos: (_id$loc4 = id.loc) == null ? void 0 : _id$loc4.start,
            name: id.value
        };
    }
    return nameInfo;
}

});

parcelRegister("aTtp5", function(module, exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ExportAllDeclaration = ExportAllDeclaration;
exports.ExportDefaultDeclaration = ExportDefaultDeclaration;
exports.ExportDefaultSpecifier = ExportDefaultSpecifier;
exports.ExportNamedDeclaration = ExportNamedDeclaration;
exports.ExportNamespaceSpecifier = ExportNamespaceSpecifier;
exports.ExportSpecifier = ExportSpecifier;
exports.ImportAttribute = ImportAttribute;
exports.ImportDeclaration = ImportDeclaration;
exports.ImportDefaultSpecifier = ImportDefaultSpecifier;
exports.ImportExpression = ImportExpression;
exports.ImportNamespaceSpecifier = ImportNamespaceSpecifier;
exports.ImportSpecifier = ImportSpecifier;
exports._printAttributes = _printAttributes;

var $ardUq = parcelRequire("ardUq");
const { isClassDeclaration, isExportDefaultSpecifier, isExportNamespaceSpecifier, isImportDefaultSpecifier, isImportNamespaceSpecifier, isStatement } = $ardUq;
function ImportSpecifier(node) {
    if (node.importKind === "type" || node.importKind === "typeof") {
        this.word(node.importKind);
        this.space();
    }
    this.print(node.imported, node);
    if (node.local && node.local.name !== node.imported.name) {
        this.space();
        this.word("as");
        this.space();
        this.print(node.local, node);
    }
}
function ImportDefaultSpecifier(node) {
    this.print(node.local, node);
}
function ExportDefaultSpecifier(node) {
    this.print(node.exported, node);
}
function ExportSpecifier(node) {
    if (node.exportKind === "type") {
        this.word("type");
        this.space();
    }
    this.print(node.local, node);
    if (node.exported && node.local.name !== node.exported.name) {
        this.space();
        this.word("as");
        this.space();
        this.print(node.exported, node);
    }
}
function ExportNamespaceSpecifier(node) {
    this.tokenChar(42);
    this.space();
    this.word("as");
    this.space();
    this.print(node.exported, node);
}
let warningShown = false;
function _printAttributes(node) {
    const { importAttributesKeyword } = this.format;
    const { attributes, assertions } = node;
    if (attributes && !importAttributesKeyword && !warningShown) {
        warningShown = true;
        console.warn(`\
You are using import attributes, without specifying the desired output syntax.
Please specify the "importAttributesKeyword" generator option, whose value can be one of:
 - "with"        : \`import { a } from "b" with { type: "json" };\`
 - "assert"      : \`import { a } from "b" assert { type: "json" };\`
 - "with-legacy" : \`import { a } from "b" with type: "json";\`
`);
    }
    const useAssertKeyword = importAttributesKeyword === "assert" || !importAttributesKeyword && assertions;
    this.word(useAssertKeyword ? "assert" : "with");
    this.space();
    if (!useAssertKeyword && importAttributesKeyword !== "with") {
        this.printList(attributes || assertions, node);
        return;
    }
    this.tokenChar(123);
    this.space();
    this.printList(attributes || assertions, node);
    this.space();
    this.tokenChar(125);
}
function ExportAllDeclaration(node) {
    var _node$attributes, _node$assertions;
    this.word("export");
    this.space();
    if (node.exportKind === "type") {
        this.word("type");
        this.space();
    }
    this.tokenChar(42);
    this.space();
    this.word("from");
    this.space();
    if ((_node$attributes = node.attributes) != null && _node$attributes.length || (_node$assertions = node.assertions) != null && _node$assertions.length) {
        this.print(node.source, node, true);
        this.space();
        this._printAttributes(node);
    } else this.print(node.source, node);
    this.semicolon();
}
function maybePrintDecoratorsBeforeExport(printer, node) {
    if (isClassDeclaration(node.declaration) && printer._shouldPrintDecoratorsBeforeExport(node)) printer.printJoin(node.declaration.decorators, node);
}
function ExportNamedDeclaration(node) {
    maybePrintDecoratorsBeforeExport(this, node);
    this.word("export");
    this.space();
    if (node.declaration) {
        const declar = node.declaration;
        this.print(declar, node);
        if (!isStatement(declar)) this.semicolon();
    } else {
        if (node.exportKind === "type") {
            this.word("type");
            this.space();
        }
        const specifiers = node.specifiers.slice(0);
        let hasSpecial = false;
        for(;;){
            const first = specifiers[0];
            if (isExportDefaultSpecifier(first) || isExportNamespaceSpecifier(first)) {
                hasSpecial = true;
                this.print(specifiers.shift(), node);
                if (specifiers.length) {
                    this.tokenChar(44);
                    this.space();
                }
            } else break;
        }
        if (specifiers.length || !specifiers.length && !hasSpecial) {
            this.tokenChar(123);
            if (specifiers.length) {
                this.space();
                this.printList(specifiers, node);
                this.space();
            }
            this.tokenChar(125);
        }
        if (node.source) {
            var _node$attributes2, _node$assertions2;
            this.space();
            this.word("from");
            this.space();
            if ((_node$attributes2 = node.attributes) != null && _node$attributes2.length || (_node$assertions2 = node.assertions) != null && _node$assertions2.length) {
                this.print(node.source, node, true);
                this.space();
                this._printAttributes(node);
            } else this.print(node.source, node);
        }
        this.semicolon();
    }
}
function ExportDefaultDeclaration(node) {
    maybePrintDecoratorsBeforeExport(this, node);
    this.word("export");
    this.noIndentInnerCommentsHere();
    this.space();
    this.word("default");
    this.space();
    const declar = node.declaration;
    this.print(declar, node);
    if (!isStatement(declar)) this.semicolon();
}
function ImportDeclaration(node) {
    var _node$attributes3, _node$assertions3;
    this.word("import");
    this.space();
    const isTypeKind = node.importKind === "type" || node.importKind === "typeof";
    if (isTypeKind) {
        this.noIndentInnerCommentsHere();
        this.word(node.importKind);
        this.space();
    } else if (node.module) {
        this.noIndentInnerCommentsHere();
        this.word("module");
        this.space();
    } else if (node.phase) {
        this.noIndentInnerCommentsHere();
        this.word(node.phase);
        this.space();
    }
    const specifiers = node.specifiers.slice(0);
    const hasSpecifiers = !!specifiers.length;
    while(hasSpecifiers){
        const first = specifiers[0];
        if (isImportDefaultSpecifier(first) || isImportNamespaceSpecifier(first)) {
            this.print(specifiers.shift(), node);
            if (specifiers.length) {
                this.tokenChar(44);
                this.space();
            }
        } else break;
    }
    if (specifiers.length) {
        this.tokenChar(123);
        this.space();
        this.printList(specifiers, node);
        this.space();
        this.tokenChar(125);
    } else if (isTypeKind && !hasSpecifiers) {
        this.tokenChar(123);
        this.tokenChar(125);
    }
    if (hasSpecifiers || isTypeKind) {
        this.space();
        this.word("from");
        this.space();
    }
    if ((_node$attributes3 = node.attributes) != null && _node$attributes3.length || (_node$assertions3 = node.assertions) != null && _node$assertions3.length) {
        this.print(node.source, node, true);
        this.space();
        this._printAttributes(node);
    } else this.print(node.source, node);
    this.semicolon();
}
function ImportAttribute(node) {
    this.print(node.key);
    this.tokenChar(58);
    this.space();
    this.print(node.value);
}
function ImportNamespaceSpecifier(node) {
    this.tokenChar(42);
    this.space();
    this.word("as");
    this.space();
    this.print(node.local, node);
}
function ImportExpression(node) {
    this.word("import");
    if (node.phase) {
        this.tokenChar(46);
        this.word(node.phase);
    }
    this.tokenChar(40);
    this.print(node.source, node);
    if (node.options != null) {
        this.tokenChar(44);
        this.space();
        this.print(node.options, node);
    }
    this.tokenChar(41);
}

});

parcelRegister("fKIiT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ArgumentPlaceholder = $b77d84b5be372592$var$ArgumentPlaceholder;
module.exports.ArrayPattern = module.exports.ArrayExpression = $b77d84b5be372592$var$ArrayExpression;
module.exports.BigIntLiteral = $b77d84b5be372592$var$BigIntLiteral;
module.exports.BooleanLiteral = $b77d84b5be372592$var$BooleanLiteral;
module.exports.DecimalLiteral = $b77d84b5be372592$var$DecimalLiteral;
module.exports.Identifier = $b77d84b5be372592$var$Identifier;
module.exports.NullLiteral = $b77d84b5be372592$var$NullLiteral;
module.exports.NumericLiteral = $b77d84b5be372592$var$NumericLiteral;
module.exports.ObjectPattern = module.exports.ObjectExpression = $b77d84b5be372592$var$ObjectExpression;
module.exports.ObjectMethod = $b77d84b5be372592$var$ObjectMethod;
module.exports.ObjectProperty = $b77d84b5be372592$var$ObjectProperty;
module.exports.PipelineBareFunction = $b77d84b5be372592$var$PipelineBareFunction;
module.exports.PipelinePrimaryTopicReference = $b77d84b5be372592$var$PipelinePrimaryTopicReference;
module.exports.PipelineTopicExpression = $b77d84b5be372592$var$PipelineTopicExpression;
module.exports.RecordExpression = $b77d84b5be372592$var$RecordExpression;
module.exports.RegExpLiteral = $b77d84b5be372592$var$RegExpLiteral;
module.exports.SpreadElement = module.exports.RestElement = $b77d84b5be372592$var$RestElement;
module.exports.StringLiteral = $b77d84b5be372592$var$StringLiteral;
module.exports.TopicReference = $b77d84b5be372592$var$TopicReference;
module.exports.TupleExpression = $b77d84b5be372592$var$TupleExpression;

var $ardUq = parcelRequire("ardUq");

var $it5NA = parcelRequire("it5NA");
const { isAssignmentPattern: $b77d84b5be372592$var$isAssignmentPattern, isIdentifier: $b77d84b5be372592$var$isIdentifier } = $ardUq;
function $b77d84b5be372592$var$Identifier(node) {
    var _node$loc;
    this.sourceIdentifierName(((_node$loc = node.loc) == null ? void 0 : _node$loc.identifierName) || node.name);
    this.word(node.name);
}
function $b77d84b5be372592$var$ArgumentPlaceholder() {
    this.tokenChar(63);
}
function $b77d84b5be372592$var$RestElement(node) {
    this.token("...");
    this.print(node.argument, node);
}
function $b77d84b5be372592$var$ObjectExpression(node) {
    const props = node.properties;
    this.tokenChar(123);
    if (props.length) {
        this.space();
        this.printList(props, node, {
            indent: true,
            statement: true
        });
        this.space();
    }
    this.sourceWithOffset("end", node.loc, -1);
    this.tokenChar(125);
}
function $b77d84b5be372592$var$ObjectMethod(node) {
    this.printJoin(node.decorators, node);
    this._methodHead(node);
    this.space();
    this.print(node.body, node);
}
function $b77d84b5be372592$var$ObjectProperty(node) {
    this.printJoin(node.decorators, node);
    if (node.computed) {
        this.tokenChar(91);
        this.print(node.key, node);
        this.tokenChar(93);
    } else {
        if ($b77d84b5be372592$var$isAssignmentPattern(node.value) && $b77d84b5be372592$var$isIdentifier(node.key) && node.key.name === node.value.left.name) {
            this.print(node.value, node);
            return;
        }
        this.print(node.key, node);
        if (node.shorthand && $b77d84b5be372592$var$isIdentifier(node.key) && $b77d84b5be372592$var$isIdentifier(node.value) && node.key.name === node.value.name) return;
    }
    this.tokenChar(58);
    this.space();
    this.print(node.value, node);
}
function $b77d84b5be372592$var$ArrayExpression(node) {
    const elems = node.elements;
    const len = elems.length;
    this.tokenChar(91);
    for(let i = 0; i < elems.length; i++){
        const elem = elems[i];
        if (elem) {
            if (i > 0) this.space();
            this.print(elem, node);
            if (i < len - 1) this.tokenChar(44);
        } else this.tokenChar(44);
    }
    this.tokenChar(93);
}
function $b77d84b5be372592$var$RecordExpression(node) {
    const props = node.properties;
    let startToken;
    let endToken;
    if (this.format.recordAndTupleSyntaxType === "bar") {
        startToken = "{|";
        endToken = "|}";
    } else if (this.format.recordAndTupleSyntaxType !== "hash" && this.format.recordAndTupleSyntaxType != null) throw new Error(`The "recordAndTupleSyntaxType" generator option must be "bar" or "hash" (${JSON.stringify(this.format.recordAndTupleSyntaxType)} received).`);
    else {
        startToken = "#{";
        endToken = "}";
    }
    this.token(startToken);
    if (props.length) {
        this.space();
        this.printList(props, node, {
            indent: true,
            statement: true
        });
        this.space();
    }
    this.token(endToken);
}
function $b77d84b5be372592$var$TupleExpression(node) {
    const elems = node.elements;
    const len = elems.length;
    let startToken;
    let endToken;
    if (this.format.recordAndTupleSyntaxType === "bar") {
        startToken = "[|";
        endToken = "|]";
    } else if (this.format.recordAndTupleSyntaxType === "hash") {
        startToken = "#[";
        endToken = "]";
    } else throw new Error(`${this.format.recordAndTupleSyntaxType} is not a valid recordAndTuple syntax type`);
    this.token(startToken);
    for(let i = 0; i < elems.length; i++){
        const elem = elems[i];
        if (elem) {
            if (i > 0) this.space();
            this.print(elem, node);
            if (i < len - 1) this.tokenChar(44);
        }
    }
    this.token(endToken);
}
function $b77d84b5be372592$var$RegExpLiteral(node) {
    this.word(`/${node.pattern}/${node.flags}`);
}
function $b77d84b5be372592$var$BooleanLiteral(node) {
    this.word(node.value ? "true" : "false");
}
function $b77d84b5be372592$var$NullLiteral() {
    this.word("null");
}
function $b77d84b5be372592$var$NumericLiteral(node) {
    const raw = this.getPossibleRaw(node);
    const opts = this.format.jsescOption;
    const value = node.value;
    const str = value + "";
    if (opts.numbers) this.number($it5NA(value, opts), value);
    else if (raw == null) this.number(str, value);
    else if (this.format.minified) this.number(raw.length < str.length ? raw : str, value);
    else this.number(raw, value);
}
function $b77d84b5be372592$var$StringLiteral(node) {
    const raw = this.getPossibleRaw(node);
    if (!this.format.minified && raw !== undefined) {
        this.token(raw);
        return;
    }
    const val = $it5NA(node.value, this.format.jsescOption);
    this.token(val);
}
function $b77d84b5be372592$var$BigIntLiteral(node) {
    const raw = this.getPossibleRaw(node);
    if (!this.format.minified && raw !== undefined) {
        this.word(raw);
        return;
    }
    this.word(node.value + "n");
}
function $b77d84b5be372592$var$DecimalLiteral(node) {
    const raw = this.getPossibleRaw(node);
    if (!this.format.minified && raw !== undefined) {
        this.word(raw);
        return;
    }
    this.word(node.value + "m");
}
const $b77d84b5be372592$var$validTopicTokenSet = new Set([
    "^^",
    "@@",
    "^",
    "%",
    "#"
]);
function $b77d84b5be372592$var$TopicReference() {
    const { topicToken: topicToken } = this.format;
    if ($b77d84b5be372592$var$validTopicTokenSet.has(topicToken)) this.token(topicToken);
    else {
        const givenTopicTokenJSON = JSON.stringify(topicToken);
        const validTopics = Array.from($b77d84b5be372592$var$validTopicTokenSet, (v)=>JSON.stringify(v));
        throw new Error(`The "topicToken" generator option must be one of ` + `${validTopics.join(", ")} (${givenTopicTokenJSON} received instead).`);
    }
}
function $b77d84b5be372592$var$PipelineTopicExpression(node) {
    this.print(node.expression, node);
}
function $b77d84b5be372592$var$PipelineBareFunction(node) {
    this.print(node.callee, node);
}
function $b77d84b5be372592$var$PipelinePrimaryTopicReference() {
    this.tokenChar(35);
}

});
parcelRegister("it5NA", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $d71f6ef532c58a41$require$Buffer = $6ZWSX.Buffer;
"use strict";
const $d71f6ef532c58a41$var$object = {};
const $d71f6ef532c58a41$var$hasOwnProperty = $d71f6ef532c58a41$var$object.hasOwnProperty;
const $d71f6ef532c58a41$var$forOwn = (object, callback)=>{
    for(const key in object)if ($d71f6ef532c58a41$var$hasOwnProperty.call(object, key)) callback(key, object[key]);
};
const $d71f6ef532c58a41$var$extend = (destination, source)=>{
    if (!source) return destination;
    $d71f6ef532c58a41$var$forOwn(source, (key, value)=>{
        destination[key] = value;
    });
    return destination;
};
const $d71f6ef532c58a41$var$forEach = (array, callback)=>{
    const length = array.length;
    let index = -1;
    while(++index < length)callback(array[index]);
};
const $d71f6ef532c58a41$var$toString = $d71f6ef532c58a41$var$object.toString;
const $d71f6ef532c58a41$var$isArray = Array.isArray;
const $d71f6ef532c58a41$var$isBuffer = $d71f6ef532c58a41$require$Buffer.isBuffer;
const $d71f6ef532c58a41$var$isObject = (value)=>{
    // This is a very simple check, but it’s good enough for what we need.
    return $d71f6ef532c58a41$var$toString.call(value) == "[object Object]";
};
const $d71f6ef532c58a41$var$isString = (value)=>{
    return typeof value == "string" || $d71f6ef532c58a41$var$toString.call(value) == "[object String]";
};
const $d71f6ef532c58a41$var$isNumber = (value)=>{
    return typeof value == "number" || $d71f6ef532c58a41$var$toString.call(value) == "[object Number]";
};
const $d71f6ef532c58a41$var$isFunction = (value)=>{
    return typeof value == "function";
};
const $d71f6ef532c58a41$var$isMap = (value)=>{
    return $d71f6ef532c58a41$var$toString.call(value) == "[object Map]";
};
const $d71f6ef532c58a41$var$isSet = (value)=>{
    return $d71f6ef532c58a41$var$toString.call(value) == "[object Set]";
};
/*--------------------------------------------------------------------------*/ // https://mathiasbynens.be/notes/javascript-escapes#single
const $d71f6ef532c58a41$var$singleEscapes = {
    '"': '\\"',
    "'": "\\'",
    "\\": "\\\\",
    "\b": "\\b",
    "\f": "\\f",
    "\n": "\\n",
    "\r": "\\r",
    "	": "\\t"
};
const $d71f6ef532c58a41$var$regexSingleEscape = /["'\\\b\f\n\r\t]/;
const $d71f6ef532c58a41$var$regexDigit = /[0-9]/;
const $d71f6ef532c58a41$var$regexWhitelist = /[ !#-&\(-\[\]-_a-~]/;
const $d71f6ef532c58a41$var$jsesc = (argument, options)=>{
    const increaseIndentation = ()=>{
        oldIndent = indent;
        ++options.indentLevel;
        indent = options.indent.repeat(options.indentLevel);
    };
    // Handle options
    const defaults = {
        "escapeEverything": false,
        "minimal": false,
        "isScriptContext": false,
        "quotes": "single",
        "wrap": false,
        "es6": false,
        "json": false,
        "compact": true,
        "lowercaseHex": false,
        "numbers": "decimal",
        "indent": "	",
        "indentLevel": 0,
        "__inline1__": false,
        "__inline2__": false
    };
    const json = options && options.json;
    if (json) {
        defaults.quotes = "double";
        defaults.wrap = true;
    }
    options = $d71f6ef532c58a41$var$extend(defaults, options);
    if (options.quotes != "single" && options.quotes != "double" && options.quotes != "backtick") options.quotes = "single";
    const quote = options.quotes == "double" ? '"' : options.quotes == "backtick" ? "`" : "'";
    const compact = options.compact;
    const lowercaseHex = options.lowercaseHex;
    let indent = options.indent.repeat(options.indentLevel);
    let oldIndent = "";
    const inline1 = options.__inline1__;
    const inline2 = options.__inline2__;
    const newLine = compact ? "" : "\n";
    let result;
    let isEmpty = true;
    const useBinNumbers = options.numbers == "binary";
    const useOctNumbers = options.numbers == "octal";
    const useDecNumbers = options.numbers == "decimal";
    const useHexNumbers = options.numbers == "hexadecimal";
    if (json && argument && $d71f6ef532c58a41$var$isFunction(argument.toJSON)) argument = argument.toJSON();
    if (!$d71f6ef532c58a41$var$isString(argument)) {
        if ($d71f6ef532c58a41$var$isMap(argument)) {
            if (argument.size == 0) return "new Map()";
            if (!compact) {
                options.__inline1__ = true;
                options.__inline2__ = false;
            }
            return "new Map(" + $d71f6ef532c58a41$var$jsesc(Array.from(argument), options) + ")";
        }
        if ($d71f6ef532c58a41$var$isSet(argument)) {
            if (argument.size == 0) return "new Set()";
            return "new Set(" + $d71f6ef532c58a41$var$jsesc(Array.from(argument), options) + ")";
        }
        if ($d71f6ef532c58a41$var$isBuffer(argument)) {
            if (argument.length == 0) return "Buffer.from([])";
            return "Buffer.from(" + $d71f6ef532c58a41$var$jsesc(Array.from(argument), options) + ")";
        }
        if ($d71f6ef532c58a41$var$isArray(argument)) {
            result = [];
            options.wrap = true;
            if (inline1) {
                options.__inline1__ = false;
                options.__inline2__ = true;
            }
            if (!inline2) increaseIndentation();
            $d71f6ef532c58a41$var$forEach(argument, (value)=>{
                isEmpty = false;
                if (inline2) options.__inline2__ = false;
                result.push((compact || inline2 ? "" : indent) + $d71f6ef532c58a41$var$jsesc(value, options));
            });
            if (isEmpty) return "[]";
            if (inline2) return "[" + result.join(", ") + "]";
            return "[" + newLine + result.join("," + newLine) + newLine + (compact ? "" : oldIndent) + "]";
        } else if ($d71f6ef532c58a41$var$isNumber(argument)) {
            if (json) // Some number values (e.g. `Infinity`) cannot be represented in JSON.
            return JSON.stringify(argument);
            if (useDecNumbers) return String(argument);
            if (useHexNumbers) {
                let hexadecimal = argument.toString(16);
                if (!lowercaseHex) hexadecimal = hexadecimal.toUpperCase();
                return "0x" + hexadecimal;
            }
            if (useBinNumbers) return "0b" + argument.toString(2);
            if (useOctNumbers) return "0o" + argument.toString(8);
        } else if (!$d71f6ef532c58a41$var$isObject(argument)) {
            if (json) // For some values (e.g. `undefined`, `function` objects),
            // `JSON.stringify(value)` returns `undefined` (which isn’t valid
            // JSON) instead of `'null'`.
            return JSON.stringify(argument) || "null";
            return String(argument);
        } else {
            result = [];
            options.wrap = true;
            increaseIndentation();
            $d71f6ef532c58a41$var$forOwn(argument, (key, value)=>{
                isEmpty = false;
                result.push((compact ? "" : indent) + $d71f6ef532c58a41$var$jsesc(key, options) + ":" + (compact ? "" : " ") + $d71f6ef532c58a41$var$jsesc(value, options));
            });
            if (isEmpty) return "{}";
            return "{" + newLine + result.join("," + newLine) + newLine + (compact ? "" : oldIndent) + "}";
        }
    }
    const string = argument;
    // Loop over each code unit in the string and escape it
    let index = -1;
    const length = string.length;
    result = "";
    while(++index < length){
        const character = string.charAt(index);
        if (options.es6) {
            const first = string.charCodeAt(index);
            if (first >= 0xD800 && first <= 0xDBFF && // high surrogate
            length > index + 1 // there is a next code unit
            ) {
                const second = string.charCodeAt(index + 1);
                if (second >= 0xDC00 && second <= 0xDFFF) {
                    // https://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
                    const codePoint = (first - 0xD800) * 0x400 + second - 0xDC00 + 0x10000;
                    let hexadecimal = codePoint.toString(16);
                    if (!lowercaseHex) hexadecimal = hexadecimal.toUpperCase();
                    result += "\\u{" + hexadecimal + "}";
                    ++index;
                    continue;
                }
            }
        }
        if (!options.escapeEverything) {
            if ($d71f6ef532c58a41$var$regexWhitelist.test(character)) {
                // It’s a printable ASCII character that is not `"`, `'` or `\`,
                // so don’t escape it.
                result += character;
                continue;
            }
            if (character == '"') {
                result += quote == character ? '\\"' : character;
                continue;
            }
            if (character == "`") {
                result += quote == character ? "\\`" : character;
                continue;
            }
            if (character == "'") {
                result += quote == character ? "\\'" : character;
                continue;
            }
        }
        if (character == "\0" && !json && !$d71f6ef532c58a41$var$regexDigit.test(string.charAt(index + 1))) {
            result += "\\0";
            continue;
        }
        if ($d71f6ef532c58a41$var$regexSingleEscape.test(character)) {
            // no need for a `hasOwnProperty` check here
            result += $d71f6ef532c58a41$var$singleEscapes[character];
            continue;
        }
        const charCode = character.charCodeAt(0);
        if (options.minimal && charCode != 0x2028 && charCode != 0x2029) {
            result += character;
            continue;
        }
        let hexadecimal = charCode.toString(16);
        if (!lowercaseHex) hexadecimal = hexadecimal.toUpperCase();
        const longhand = hexadecimal.length > 2 || json;
        const escaped = "\\" + (longhand ? "u" : "x") + ("0000" + hexadecimal).slice(longhand ? -4 : -2);
        result += escaped;
        continue;
    }
    if (options.wrap) result = quote + result + quote;
    if (quote == "`") result = result.replace(/\$\{/g, "\\${");
    if (options.isScriptContext) // https://mathiasbynens.be/notes/etago
    return result.replace(/<\/(script|style)/gi, "<\\/$1").replace(/<!--/g, json ? "\\u003C!--" : "\\x3C!--");
    return result;
};
$d71f6ef532c58a41$var$jsesc.version = "2.5.2";
module.exports = $d71f6ef532c58a41$var$jsesc;

});


parcelRegister("6OSqV", function(module, exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.AnyTypeAnnotation = AnyTypeAnnotation;
exports.ArrayTypeAnnotation = ArrayTypeAnnotation;
exports.BooleanLiteralTypeAnnotation = BooleanLiteralTypeAnnotation;
exports.BooleanTypeAnnotation = BooleanTypeAnnotation;
exports.DeclareClass = DeclareClass;
exports.DeclareExportAllDeclaration = DeclareExportAllDeclaration;
exports.DeclareExportDeclaration = DeclareExportDeclaration;
exports.DeclareFunction = DeclareFunction;
exports.DeclareInterface = DeclareInterface;
exports.DeclareModule = DeclareModule;
exports.DeclareModuleExports = DeclareModuleExports;
exports.DeclareOpaqueType = DeclareOpaqueType;
exports.DeclareTypeAlias = DeclareTypeAlias;
exports.DeclareVariable = DeclareVariable;
exports.DeclaredPredicate = DeclaredPredicate;
exports.EmptyTypeAnnotation = EmptyTypeAnnotation;
exports.EnumBooleanBody = EnumBooleanBody;
exports.EnumBooleanMember = EnumBooleanMember;
exports.EnumDeclaration = EnumDeclaration;
exports.EnumDefaultedMember = EnumDefaultedMember;
exports.EnumNumberBody = EnumNumberBody;
exports.EnumNumberMember = EnumNumberMember;
exports.EnumStringBody = EnumStringBody;
exports.EnumStringMember = EnumStringMember;
exports.EnumSymbolBody = EnumSymbolBody;
exports.ExistsTypeAnnotation = ExistsTypeAnnotation;
exports.FunctionTypeAnnotation = FunctionTypeAnnotation;
exports.FunctionTypeParam = FunctionTypeParam;
exports.IndexedAccessType = IndexedAccessType;
exports.InferredPredicate = InferredPredicate;
exports.InterfaceDeclaration = InterfaceDeclaration;
exports.GenericTypeAnnotation = exports.ClassImplements = exports.InterfaceExtends = InterfaceExtends;
exports.InterfaceTypeAnnotation = InterfaceTypeAnnotation;
exports.IntersectionTypeAnnotation = IntersectionTypeAnnotation;
exports.MixedTypeAnnotation = MixedTypeAnnotation;
exports.NullLiteralTypeAnnotation = NullLiteralTypeAnnotation;
exports.NullableTypeAnnotation = NullableTypeAnnotation;
Object.defineProperty(exports, "NumberLiteralTypeAnnotation", {
    enumerable: true,
    get: function() {
        return $fKIiT.NumericLiteral;
    }
});
exports.NumberTypeAnnotation = NumberTypeAnnotation;
exports.ObjectTypeAnnotation = ObjectTypeAnnotation;
exports.ObjectTypeCallProperty = ObjectTypeCallProperty;
exports.ObjectTypeIndexer = ObjectTypeIndexer;
exports.ObjectTypeInternalSlot = ObjectTypeInternalSlot;
exports.ObjectTypeProperty = ObjectTypeProperty;
exports.ObjectTypeSpreadProperty = ObjectTypeSpreadProperty;
exports.OpaqueType = OpaqueType;
exports.OptionalIndexedAccessType = OptionalIndexedAccessType;
exports.QualifiedTypeIdentifier = QualifiedTypeIdentifier;
Object.defineProperty(exports, "StringLiteralTypeAnnotation", {
    enumerable: true,
    get: function() {
        return $fKIiT.StringLiteral;
    }
});
exports.StringTypeAnnotation = StringTypeAnnotation;
exports.SymbolTypeAnnotation = SymbolTypeAnnotation;
exports.ThisTypeAnnotation = ThisTypeAnnotation;
exports.TupleTypeAnnotation = TupleTypeAnnotation;
exports.TypeAlias = TypeAlias;
exports.TypeAnnotation = TypeAnnotation;
exports.TypeCastExpression = TypeCastExpression;
exports.TypeParameter = TypeParameter;
exports.TypeParameterDeclaration = exports.TypeParameterInstantiation = TypeParameterInstantiation;
exports.TypeofTypeAnnotation = TypeofTypeAnnotation;
exports.UnionTypeAnnotation = UnionTypeAnnotation;
exports.Variance = Variance;
exports.VoidTypeAnnotation = VoidTypeAnnotation;
exports._interfaceish = _interfaceish;
exports._variance = _variance;

var $ardUq = parcelRequire("ardUq");

var $aTtp5 = parcelRequire("aTtp5");

var $fKIiT = parcelRequire("fKIiT");
const { isDeclareExportDeclaration, isStatement } = $ardUq;
function AnyTypeAnnotation() {
    this.word("any");
}
function ArrayTypeAnnotation(node) {
    this.print(node.elementType, node, true);
    this.tokenChar(91);
    this.tokenChar(93);
}
function BooleanTypeAnnotation() {
    this.word("boolean");
}
function BooleanLiteralTypeAnnotation(node) {
    this.word(node.value ? "true" : "false");
}
function NullLiteralTypeAnnotation() {
    this.word("null");
}
function DeclareClass(node, parent) {
    if (!isDeclareExportDeclaration(parent)) {
        this.word("declare");
        this.space();
    }
    this.word("class");
    this.space();
    this._interfaceish(node);
}
function DeclareFunction(node, parent) {
    if (!isDeclareExportDeclaration(parent)) {
        this.word("declare");
        this.space();
    }
    this.word("function");
    this.space();
    this.print(node.id, node);
    this.print(node.id.typeAnnotation.typeAnnotation, node);
    if (node.predicate) {
        this.space();
        this.print(node.predicate, node);
    }
    this.semicolon();
}
function InferredPredicate() {
    this.tokenChar(37);
    this.word("checks");
}
function DeclaredPredicate(node) {
    this.tokenChar(37);
    this.word("checks");
    this.tokenChar(40);
    this.print(node.value, node);
    this.tokenChar(41);
}
function DeclareInterface(node) {
    this.word("declare");
    this.space();
    this.InterfaceDeclaration(node);
}
function DeclareModule(node) {
    this.word("declare");
    this.space();
    this.word("module");
    this.space();
    this.print(node.id, node);
    this.space();
    this.print(node.body, node);
}
function DeclareModuleExports(node) {
    this.word("declare");
    this.space();
    this.word("module");
    this.tokenChar(46);
    this.word("exports");
    this.print(node.typeAnnotation, node);
}
function DeclareTypeAlias(node) {
    this.word("declare");
    this.space();
    this.TypeAlias(node);
}
function DeclareOpaqueType(node, parent) {
    if (!isDeclareExportDeclaration(parent)) {
        this.word("declare");
        this.space();
    }
    this.OpaqueType(node);
}
function DeclareVariable(node, parent) {
    if (!isDeclareExportDeclaration(parent)) {
        this.word("declare");
        this.space();
    }
    this.word("var");
    this.space();
    this.print(node.id, node);
    this.print(node.id.typeAnnotation, node);
    this.semicolon();
}
function DeclareExportDeclaration(node) {
    this.word("declare");
    this.space();
    this.word("export");
    this.space();
    if (node.default) {
        this.word("default");
        this.space();
    }
    FlowExportDeclaration.call(this, node);
}
function DeclareExportAllDeclaration(node) {
    this.word("declare");
    this.space();
    $aTtp5.ExportAllDeclaration.call(this, node);
}
function EnumDeclaration(node) {
    const { id, body } = node;
    this.word("enum");
    this.space();
    this.print(id, node);
    this.print(body, node);
}
function enumExplicitType(context, name, hasExplicitType) {
    if (hasExplicitType) {
        context.space();
        context.word("of");
        context.space();
        context.word(name);
    }
    context.space();
}
function enumBody(context, node) {
    const { members } = node;
    context.token("{");
    context.indent();
    context.newline();
    for (const member of members){
        context.print(member, node);
        context.newline();
    }
    if (node.hasUnknownMembers) {
        context.token("...");
        context.newline();
    }
    context.dedent();
    context.token("}");
}
function EnumBooleanBody(node) {
    const { explicitType } = node;
    enumExplicitType(this, "boolean", explicitType);
    enumBody(this, node);
}
function EnumNumberBody(node) {
    const { explicitType } = node;
    enumExplicitType(this, "number", explicitType);
    enumBody(this, node);
}
function EnumStringBody(node) {
    const { explicitType } = node;
    enumExplicitType(this, "string", explicitType);
    enumBody(this, node);
}
function EnumSymbolBody(node) {
    enumExplicitType(this, "symbol", true);
    enumBody(this, node);
}
function EnumDefaultedMember(node) {
    const { id } = node;
    this.print(id, node);
    this.tokenChar(44);
}
function enumInitializedMember(context, node) {
    const { id, init } = node;
    context.print(id, node);
    context.space();
    context.token("=");
    context.space();
    context.print(init, node);
    context.token(",");
}
function EnumBooleanMember(node) {
    enumInitializedMember(this, node);
}
function EnumNumberMember(node) {
    enumInitializedMember(this, node);
}
function EnumStringMember(node) {
    enumInitializedMember(this, node);
}
function FlowExportDeclaration(node) {
    if (node.declaration) {
        const declar = node.declaration;
        this.print(declar, node);
        if (!isStatement(declar)) this.semicolon();
    } else {
        this.tokenChar(123);
        if (node.specifiers.length) {
            this.space();
            this.printList(node.specifiers, node);
            this.space();
        }
        this.tokenChar(125);
        if (node.source) {
            this.space();
            this.word("from");
            this.space();
            this.print(node.source, node);
        }
        this.semicolon();
    }
}
function ExistsTypeAnnotation() {
    this.tokenChar(42);
}
function FunctionTypeAnnotation(node, parent) {
    this.print(node.typeParameters, node);
    this.tokenChar(40);
    if (node.this) {
        this.word("this");
        this.tokenChar(58);
        this.space();
        this.print(node.this.typeAnnotation, node);
        if (node.params.length || node.rest) {
            this.tokenChar(44);
            this.space();
        }
    }
    this.printList(node.params, node);
    if (node.rest) {
        if (node.params.length) {
            this.tokenChar(44);
            this.space();
        }
        this.token("...");
        this.print(node.rest, node);
    }
    this.tokenChar(41);
    const type = parent == null ? void 0 : parent.type;
    if (type != null && (type === "ObjectTypeCallProperty" || type === "ObjectTypeInternalSlot" || type === "DeclareFunction" || type === "ObjectTypeProperty" && parent.method)) this.tokenChar(58);
    else {
        this.space();
        this.token("=>");
    }
    this.space();
    this.print(node.returnType, node);
}
function FunctionTypeParam(node) {
    this.print(node.name, node);
    if (node.optional) this.tokenChar(63);
    if (node.name) {
        this.tokenChar(58);
        this.space();
    }
    this.print(node.typeAnnotation, node);
}
function InterfaceExtends(node) {
    this.print(node.id, node);
    this.print(node.typeParameters, node, true);
}
function _interfaceish(node) {
    var _node$extends;
    this.print(node.id, node);
    this.print(node.typeParameters, node);
    if ((_node$extends = node.extends) != null && _node$extends.length) {
        this.space();
        this.word("extends");
        this.space();
        this.printList(node.extends, node);
    }
    if (node.type === "DeclareClass") {
        var _node$mixins, _node$implements;
        if ((_node$mixins = node.mixins) != null && _node$mixins.length) {
            this.space();
            this.word("mixins");
            this.space();
            this.printList(node.mixins, node);
        }
        if ((_node$implements = node.implements) != null && _node$implements.length) {
            this.space();
            this.word("implements");
            this.space();
            this.printList(node.implements, node);
        }
    }
    this.space();
    this.print(node.body, node);
}
function _variance(node) {
    var _node$variance;
    const kind = (_node$variance = node.variance) == null ? void 0 : _node$variance.kind;
    if (kind != null) {
        if (kind === "plus") this.tokenChar(43);
        else if (kind === "minus") this.tokenChar(45);
    }
}
function InterfaceDeclaration(node) {
    this.word("interface");
    this.space();
    this._interfaceish(node);
}
function andSeparator() {
    this.space();
    this.tokenChar(38);
    this.space();
}
function InterfaceTypeAnnotation(node) {
    var _node$extends2;
    this.word("interface");
    if ((_node$extends2 = node.extends) != null && _node$extends2.length) {
        this.space();
        this.word("extends");
        this.space();
        this.printList(node.extends, node);
    }
    this.space();
    this.print(node.body, node);
}
function IntersectionTypeAnnotation(node) {
    this.printJoin(node.types, node, {
        separator: andSeparator
    });
}
function MixedTypeAnnotation() {
    this.word("mixed");
}
function EmptyTypeAnnotation() {
    this.word("empty");
}
function NullableTypeAnnotation(node) {
    this.tokenChar(63);
    this.print(node.typeAnnotation, node);
}
function NumberTypeAnnotation() {
    this.word("number");
}
function StringTypeAnnotation() {
    this.word("string");
}
function ThisTypeAnnotation() {
    this.word("this");
}
function TupleTypeAnnotation(node) {
    this.tokenChar(91);
    this.printList(node.types, node);
    this.tokenChar(93);
}
function TypeofTypeAnnotation(node) {
    this.word("typeof");
    this.space();
    this.print(node.argument, node);
}
function TypeAlias(node) {
    this.word("type");
    this.space();
    this.print(node.id, node);
    this.print(node.typeParameters, node);
    this.space();
    this.tokenChar(61);
    this.space();
    this.print(node.right, node);
    this.semicolon();
}
function TypeAnnotation(node) {
    this.tokenChar(58);
    this.space();
    if (node.optional) this.tokenChar(63);
    this.print(node.typeAnnotation, node);
}
function TypeParameterInstantiation(node) {
    this.tokenChar(60);
    this.printList(node.params, node, {});
    this.tokenChar(62);
}
function TypeParameter(node) {
    this._variance(node);
    this.word(node.name);
    if (node.bound) this.print(node.bound, node);
    if (node.default) {
        this.space();
        this.tokenChar(61);
        this.space();
        this.print(node.default, node);
    }
}
function OpaqueType(node) {
    this.word("opaque");
    this.space();
    this.word("type");
    this.space();
    this.print(node.id, node);
    this.print(node.typeParameters, node);
    if (node.supertype) {
        this.tokenChar(58);
        this.space();
        this.print(node.supertype, node);
    }
    if (node.impltype) {
        this.space();
        this.tokenChar(61);
        this.space();
        this.print(node.impltype, node);
    }
    this.semicolon();
}
function ObjectTypeAnnotation(node) {
    if (node.exact) this.token("{|");
    else this.tokenChar(123);
    const props = [
        ...node.properties,
        ...node.callProperties || [],
        ...node.indexers || [],
        ...node.internalSlots || []
    ];
    if (props.length) {
        this.newline();
        this.space();
        this.printJoin(props, node, {
            addNewlines (leading) {
                if (leading && !props[0]) return 1;
            },
            indent: true,
            statement: true,
            iterator: ()=>{
                if (props.length !== 1 || node.inexact) {
                    this.tokenChar(44);
                    this.space();
                }
            }
        });
        this.space();
    }
    if (node.inexact) {
        this.indent();
        this.token("...");
        if (props.length) this.newline();
        this.dedent();
    }
    if (node.exact) this.token("|}");
    else this.tokenChar(125);
}
function ObjectTypeInternalSlot(node) {
    if (node.static) {
        this.word("static");
        this.space();
    }
    this.tokenChar(91);
    this.tokenChar(91);
    this.print(node.id, node);
    this.tokenChar(93);
    this.tokenChar(93);
    if (node.optional) this.tokenChar(63);
    if (!node.method) {
        this.tokenChar(58);
        this.space();
    }
    this.print(node.value, node);
}
function ObjectTypeCallProperty(node) {
    if (node.static) {
        this.word("static");
        this.space();
    }
    this.print(node.value, node);
}
function ObjectTypeIndexer(node) {
    if (node.static) {
        this.word("static");
        this.space();
    }
    this._variance(node);
    this.tokenChar(91);
    if (node.id) {
        this.print(node.id, node);
        this.tokenChar(58);
        this.space();
    }
    this.print(node.key, node);
    this.tokenChar(93);
    this.tokenChar(58);
    this.space();
    this.print(node.value, node);
}
function ObjectTypeProperty(node) {
    if (node.proto) {
        this.word("proto");
        this.space();
    }
    if (node.static) {
        this.word("static");
        this.space();
    }
    if (node.kind === "get" || node.kind === "set") {
        this.word(node.kind);
        this.space();
    }
    this._variance(node);
    this.print(node.key, node);
    if (node.optional) this.tokenChar(63);
    if (!node.method) {
        this.tokenChar(58);
        this.space();
    }
    this.print(node.value, node);
}
function ObjectTypeSpreadProperty(node) {
    this.token("...");
    this.print(node.argument, node);
}
function QualifiedTypeIdentifier(node) {
    this.print(node.qualification, node);
    this.tokenChar(46);
    this.print(node.id, node);
}
function SymbolTypeAnnotation() {
    this.word("symbol");
}
function orSeparator() {
    this.space();
    this.tokenChar(124);
    this.space();
}
function UnionTypeAnnotation(node) {
    this.printJoin(node.types, node, {
        separator: orSeparator
    });
}
function TypeCastExpression(node) {
    this.tokenChar(40);
    this.print(node.expression, node);
    this.print(node.typeAnnotation, node);
    this.tokenChar(41);
}
function Variance(node) {
    if (node.kind === "plus") this.tokenChar(43);
    else this.tokenChar(45);
}
function VoidTypeAnnotation() {
    this.word("void");
}
function IndexedAccessType(node) {
    this.print(node.objectType, node, true);
    this.tokenChar(91);
    this.print(node.indexType, node);
    this.tokenChar(93);
}
function OptionalIndexedAccessType(node) {
    this.print(node.objectType, node);
    if (node.optional) this.token("?.");
    this.tokenChar(91);
    this.print(node.indexType, node);
    this.tokenChar(93);
}

});

parcelRegister("4drJu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BlockStatement = $311de375cfe8ab23$var$BlockStatement;
module.exports.Directive = $311de375cfe8ab23$var$Directive;
module.exports.DirectiveLiteral = $311de375cfe8ab23$var$DirectiveLiteral;
module.exports.File = $311de375cfe8ab23$var$File;
module.exports.InterpreterDirective = $311de375cfe8ab23$var$InterpreterDirective;
module.exports.Placeholder = $311de375cfe8ab23$var$Placeholder;
module.exports.Program = $311de375cfe8ab23$var$Program;
function $311de375cfe8ab23$var$File(node) {
    if (node.program) this.print(node.program.interpreter, node);
    this.print(node.program, node);
}
function $311de375cfe8ab23$var$Program(node) {
    var _node$directives;
    this.noIndentInnerCommentsHere();
    this.printInnerComments();
    const directivesLen = (_node$directives = node.directives) == null ? void 0 : _node$directives.length;
    if (directivesLen) {
        var _node$directives$trai;
        const newline = node.body.length ? 2 : 1;
        this.printSequence(node.directives, node, {
            trailingCommentsLineOffset: newline
        });
        if (!((_node$directives$trai = node.directives[directivesLen - 1].trailingComments) != null && _node$directives$trai.length)) this.newline(newline);
    }
    this.printSequence(node.body, node);
}
function $311de375cfe8ab23$var$BlockStatement(node) {
    var _node$directives2;
    this.tokenChar(123);
    const directivesLen = (_node$directives2 = node.directives) == null ? void 0 : _node$directives2.length;
    if (directivesLen) {
        var _node$directives$trai2;
        const newline = node.body.length ? 2 : 1;
        this.printSequence(node.directives, node, {
            indent: true,
            trailingCommentsLineOffset: newline
        });
        if (!((_node$directives$trai2 = node.directives[directivesLen - 1].trailingComments) != null && _node$directives$trai2.length)) this.newline(newline);
    }
    this.printSequence(node.body, node, {
        indent: true
    });
    this.rightBrace(node);
}
function $311de375cfe8ab23$var$Directive(node) {
    this.print(node.value, node);
    this.semicolon();
}
const $311de375cfe8ab23$var$unescapedSingleQuoteRE = /(?:^|[^\\])(?:\\\\)*'/;
const $311de375cfe8ab23$var$unescapedDoubleQuoteRE = /(?:^|[^\\])(?:\\\\)*"/;
function $311de375cfe8ab23$var$DirectiveLiteral(node) {
    const raw = this.getPossibleRaw(node);
    if (!this.format.minified && raw !== undefined) {
        this.token(raw);
        return;
    }
    const { value: value } = node;
    if (!$311de375cfe8ab23$var$unescapedDoubleQuoteRE.test(value)) this.token(`"${value}"`);
    else if (!$311de375cfe8ab23$var$unescapedSingleQuoteRE.test(value)) this.token(`'${value}'`);
    else throw new Error("Malformed AST: it is not possible to print a directive containing both unescaped single and double quotes.");
}
function $311de375cfe8ab23$var$InterpreterDirective(node) {
    this.token(`#!${node.value}`);
    this.newline(1, true);
}
function $311de375cfe8ab23$var$Placeholder(node) {
    this.token("%%");
    this.print(node.name);
    this.token("%%");
    if (node.expectedNode === "Statement") this.semicolon();
}

});

parcelRegister("p9IH2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.JSXAttribute = $04b9e0133852740f$var$JSXAttribute;
module.exports.JSXClosingElement = $04b9e0133852740f$var$JSXClosingElement;
module.exports.JSXClosingFragment = $04b9e0133852740f$var$JSXClosingFragment;
module.exports.JSXElement = $04b9e0133852740f$var$JSXElement;
module.exports.JSXEmptyExpression = $04b9e0133852740f$var$JSXEmptyExpression;
module.exports.JSXExpressionContainer = $04b9e0133852740f$var$JSXExpressionContainer;
module.exports.JSXFragment = $04b9e0133852740f$var$JSXFragment;
module.exports.JSXIdentifier = $04b9e0133852740f$var$JSXIdentifier;
module.exports.JSXMemberExpression = $04b9e0133852740f$var$JSXMemberExpression;
module.exports.JSXNamespacedName = $04b9e0133852740f$var$JSXNamespacedName;
module.exports.JSXOpeningElement = $04b9e0133852740f$var$JSXOpeningElement;
module.exports.JSXOpeningFragment = $04b9e0133852740f$var$JSXOpeningFragment;
module.exports.JSXSpreadAttribute = $04b9e0133852740f$var$JSXSpreadAttribute;
module.exports.JSXSpreadChild = $04b9e0133852740f$var$JSXSpreadChild;
module.exports.JSXText = $04b9e0133852740f$var$JSXText;
function $04b9e0133852740f$var$JSXAttribute(node) {
    this.print(node.name, node);
    if (node.value) {
        this.tokenChar(61);
        this.print(node.value, node);
    }
}
function $04b9e0133852740f$var$JSXIdentifier(node) {
    this.word(node.name);
}
function $04b9e0133852740f$var$JSXNamespacedName(node) {
    this.print(node.namespace, node);
    this.tokenChar(58);
    this.print(node.name, node);
}
function $04b9e0133852740f$var$JSXMemberExpression(node) {
    this.print(node.object, node);
    this.tokenChar(46);
    this.print(node.property, node);
}
function $04b9e0133852740f$var$JSXSpreadAttribute(node) {
    this.tokenChar(123);
    this.token("...");
    this.print(node.argument, node);
    this.tokenChar(125);
}
function $04b9e0133852740f$var$JSXExpressionContainer(node) {
    this.tokenChar(123);
    this.print(node.expression, node);
    this.tokenChar(125);
}
function $04b9e0133852740f$var$JSXSpreadChild(node) {
    this.tokenChar(123);
    this.token("...");
    this.print(node.expression, node);
    this.tokenChar(125);
}
function $04b9e0133852740f$var$JSXText(node) {
    const raw = this.getPossibleRaw(node);
    if (raw !== undefined) this.token(raw, true);
    else this.token(node.value, true);
}
function $04b9e0133852740f$var$JSXElement(node) {
    const open = node.openingElement;
    this.print(open, node);
    if (open.selfClosing) return;
    this.indent();
    for (const child of node.children)this.print(child, node);
    this.dedent();
    this.print(node.closingElement, node);
}
function $04b9e0133852740f$var$spaceSeparator() {
    this.space();
}
function $04b9e0133852740f$var$JSXOpeningElement(node) {
    this.tokenChar(60);
    this.print(node.name, node);
    this.print(node.typeParameters, node);
    if (node.attributes.length > 0) {
        this.space();
        this.printJoin(node.attributes, node, {
            separator: $04b9e0133852740f$var$spaceSeparator
        });
    }
    if (node.selfClosing) {
        this.space();
        this.token("/>");
    } else this.tokenChar(62);
}
function $04b9e0133852740f$var$JSXClosingElement(node) {
    this.token("</");
    this.print(node.name, node);
    this.tokenChar(62);
}
function $04b9e0133852740f$var$JSXEmptyExpression() {
    this.printInnerComments();
}
function $04b9e0133852740f$var$JSXFragment(node) {
    this.print(node.openingFragment, node);
    this.indent();
    for (const child of node.children)this.print(child, node);
    this.dedent();
    this.print(node.closingFragment, node);
}
function $04b9e0133852740f$var$JSXOpeningFragment() {
    this.tokenChar(60);
    this.tokenChar(62);
}
function $04b9e0133852740f$var$JSXClosingFragment() {
    this.token("</");
    this.tokenChar(62);
}

});

parcelRegister("bWZlM", function(module, exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TSAnyKeyword = TSAnyKeyword;
exports.TSArrayType = TSArrayType;
exports.TSSatisfiesExpression = exports.TSAsExpression = TSTypeExpression;
exports.TSBigIntKeyword = TSBigIntKeyword;
exports.TSBooleanKeyword = TSBooleanKeyword;
exports.TSCallSignatureDeclaration = TSCallSignatureDeclaration;
exports.TSConditionalType = TSConditionalType;
exports.TSConstructSignatureDeclaration = TSConstructSignatureDeclaration;
exports.TSConstructorType = TSConstructorType;
exports.TSDeclareFunction = TSDeclareFunction;
exports.TSDeclareMethod = TSDeclareMethod;
exports.TSEnumDeclaration = TSEnumDeclaration;
exports.TSEnumMember = TSEnumMember;
exports.TSExportAssignment = TSExportAssignment;
exports.TSExpressionWithTypeArguments = TSExpressionWithTypeArguments;
exports.TSExternalModuleReference = TSExternalModuleReference;
exports.TSFunctionType = TSFunctionType;
exports.TSImportEqualsDeclaration = TSImportEqualsDeclaration;
exports.TSImportType = TSImportType;
exports.TSIndexSignature = TSIndexSignature;
exports.TSIndexedAccessType = TSIndexedAccessType;
exports.TSInferType = TSInferType;
exports.TSInstantiationExpression = TSInstantiationExpression;
exports.TSInterfaceBody = TSInterfaceBody;
exports.TSInterfaceDeclaration = TSInterfaceDeclaration;
exports.TSIntersectionType = TSIntersectionType;
exports.TSIntrinsicKeyword = TSIntrinsicKeyword;
exports.TSLiteralType = TSLiteralType;
exports.TSMappedType = TSMappedType;
exports.TSMethodSignature = TSMethodSignature;
exports.TSModuleBlock = TSModuleBlock;
exports.TSModuleDeclaration = TSModuleDeclaration;
exports.TSNamedTupleMember = TSNamedTupleMember;
exports.TSNamespaceExportDeclaration = TSNamespaceExportDeclaration;
exports.TSNeverKeyword = TSNeverKeyword;
exports.TSNonNullExpression = TSNonNullExpression;
exports.TSNullKeyword = TSNullKeyword;
exports.TSNumberKeyword = TSNumberKeyword;
exports.TSObjectKeyword = TSObjectKeyword;
exports.TSOptionalType = TSOptionalType;
exports.TSParameterProperty = TSParameterProperty;
exports.TSParenthesizedType = TSParenthesizedType;
exports.TSPropertySignature = TSPropertySignature;
exports.TSQualifiedName = TSQualifiedName;
exports.TSRestType = TSRestType;
exports.TSStringKeyword = TSStringKeyword;
exports.TSSymbolKeyword = TSSymbolKeyword;
exports.TSThisType = TSThisType;
exports.TSTupleType = TSTupleType;
exports.TSTypeAliasDeclaration = TSTypeAliasDeclaration;
exports.TSTypeAnnotation = TSTypeAnnotation;
exports.TSTypeAssertion = TSTypeAssertion;
exports.TSTypeLiteral = TSTypeLiteral;
exports.TSTypeOperator = TSTypeOperator;
exports.TSTypeParameter = TSTypeParameter;
exports.TSTypeParameterDeclaration = exports.TSTypeParameterInstantiation = TSTypeParameterInstantiation;
exports.TSTypePredicate = TSTypePredicate;
exports.TSTypeQuery = TSTypeQuery;
exports.TSTypeReference = TSTypeReference;
exports.TSUndefinedKeyword = TSUndefinedKeyword;
exports.TSUnionType = TSUnionType;
exports.TSUnknownKeyword = TSUnknownKeyword;
exports.TSVoidKeyword = TSVoidKeyword;
exports.tsPrintClassMemberModifiers = tsPrintClassMemberModifiers;
exports.tsPrintFunctionOrConstructorType = tsPrintFunctionOrConstructorType;
exports.tsPrintPropertyOrMethodName = tsPrintPropertyOrMethodName;
exports.tsPrintSignatureDeclarationBase = tsPrintSignatureDeclarationBase;
exports.tsPrintTypeLiteralOrInterfaceBody = tsPrintTypeLiteralOrInterfaceBody;
function TSTypeAnnotation(node) {
    this.tokenChar(58);
    this.space();
    if (node.optional) this.tokenChar(63);
    this.print(node.typeAnnotation, node);
}
function TSTypeParameterInstantiation(node, parent) {
    this.tokenChar(60);
    this.printList(node.params, node, {});
    if (parent.type === "ArrowFunctionExpression" && node.params.length === 1) this.tokenChar(44);
    this.tokenChar(62);
}
function TSTypeParameter(node) {
    if (node.in) {
        this.word("in");
        this.space();
    }
    if (node.out) {
        this.word("out");
        this.space();
    }
    this.word(node.name);
    if (node.constraint) {
        this.space();
        this.word("extends");
        this.space();
        this.print(node.constraint, node);
    }
    if (node.default) {
        this.space();
        this.tokenChar(61);
        this.space();
        this.print(node.default, node);
    }
}
function TSParameterProperty(node) {
    if (node.accessibility) {
        this.word(node.accessibility);
        this.space();
    }
    if (node.readonly) {
        this.word("readonly");
        this.space();
    }
    this._param(node.parameter);
}
function TSDeclareFunction(node, parent) {
    if (node.declare) {
        this.word("declare");
        this.space();
    }
    this._functionHead(node, parent);
    this.tokenChar(59);
}
function TSDeclareMethod(node) {
    this._classMethodHead(node);
    this.tokenChar(59);
}
function TSQualifiedName(node) {
    this.print(node.left, node);
    this.tokenChar(46);
    this.print(node.right, node);
}
function TSCallSignatureDeclaration(node) {
    this.tsPrintSignatureDeclarationBase(node);
    this.tokenChar(59);
}
function TSConstructSignatureDeclaration(node) {
    this.word("new");
    this.space();
    this.tsPrintSignatureDeclarationBase(node);
    this.tokenChar(59);
}
function TSPropertySignature(node) {
    const { readonly } = node;
    if (readonly) {
        this.word("readonly");
        this.space();
    }
    this.tsPrintPropertyOrMethodName(node);
    this.print(node.typeAnnotation, node);
    this.tokenChar(59);
}
function tsPrintPropertyOrMethodName(node) {
    if (node.computed) this.tokenChar(91);
    this.print(node.key, node);
    if (node.computed) this.tokenChar(93);
    if (node.optional) this.tokenChar(63);
}
function TSMethodSignature(node) {
    const { kind } = node;
    if (kind === "set" || kind === "get") {
        this.word(kind);
        this.space();
    }
    this.tsPrintPropertyOrMethodName(node);
    this.tsPrintSignatureDeclarationBase(node);
    this.tokenChar(59);
}
function TSIndexSignature(node) {
    const { readonly, static: isStatic } = node;
    if (isStatic) {
        this.word("static");
        this.space();
    }
    if (readonly) {
        this.word("readonly");
        this.space();
    }
    this.tokenChar(91);
    this._parameters(node.parameters, node);
    this.tokenChar(93);
    this.print(node.typeAnnotation, node);
    this.tokenChar(59);
}
function TSAnyKeyword() {
    this.word("any");
}
function TSBigIntKeyword() {
    this.word("bigint");
}
function TSUnknownKeyword() {
    this.word("unknown");
}
function TSNumberKeyword() {
    this.word("number");
}
function TSObjectKeyword() {
    this.word("object");
}
function TSBooleanKeyword() {
    this.word("boolean");
}
function TSStringKeyword() {
    this.word("string");
}
function TSSymbolKeyword() {
    this.word("symbol");
}
function TSVoidKeyword() {
    this.word("void");
}
function TSUndefinedKeyword() {
    this.word("undefined");
}
function TSNullKeyword() {
    this.word("null");
}
function TSNeverKeyword() {
    this.word("never");
}
function TSIntrinsicKeyword() {
    this.word("intrinsic");
}
function TSThisType() {
    this.word("this");
}
function TSFunctionType(node) {
    this.tsPrintFunctionOrConstructorType(node);
}
function TSConstructorType(node) {
    if (node.abstract) {
        this.word("abstract");
        this.space();
    }
    this.word("new");
    this.space();
    this.tsPrintFunctionOrConstructorType(node);
}
function tsPrintFunctionOrConstructorType(node) {
    const { typeParameters } = node;
    const parameters = node.parameters;
    this.print(typeParameters, node);
    this.tokenChar(40);
    this._parameters(parameters, node);
    this.tokenChar(41);
    this.space();
    this.token("=>");
    this.space();
    const returnType = node.typeAnnotation;
    this.print(returnType.typeAnnotation, node);
}
function TSTypeReference(node) {
    this.print(node.typeName, node, true);
    this.print(node.typeParameters, node, true);
}
function TSTypePredicate(node) {
    if (node.asserts) {
        this.word("asserts");
        this.space();
    }
    this.print(node.parameterName);
    if (node.typeAnnotation) {
        this.space();
        this.word("is");
        this.space();
        this.print(node.typeAnnotation.typeAnnotation);
    }
}
function TSTypeQuery(node) {
    this.word("typeof");
    this.space();
    this.print(node.exprName);
    if (node.typeParameters) this.print(node.typeParameters, node);
}
function TSTypeLiteral(node) {
    this.tsPrintTypeLiteralOrInterfaceBody(node.members, node);
}
function tsPrintTypeLiteralOrInterfaceBody(members, node) {
    tsPrintBraced(this, members, node);
}
function tsPrintBraced(printer, members, node) {
    printer.token("{");
    if (members.length) {
        printer.indent();
        printer.newline();
        for (const member of members){
            printer.print(member, node);
            printer.newline();
        }
        printer.dedent();
    }
    printer.rightBrace(node);
}
function TSArrayType(node) {
    this.print(node.elementType, node, true);
    this.token("[]");
}
function TSTupleType(node) {
    this.tokenChar(91);
    this.printList(node.elementTypes, node);
    this.tokenChar(93);
}
function TSOptionalType(node) {
    this.print(node.typeAnnotation, node);
    this.tokenChar(63);
}
function TSRestType(node) {
    this.token("...");
    this.print(node.typeAnnotation, node);
}
function TSNamedTupleMember(node) {
    this.print(node.label, node);
    if (node.optional) this.tokenChar(63);
    this.tokenChar(58);
    this.space();
    this.print(node.elementType, node);
}
function TSUnionType(node) {
    tsPrintUnionOrIntersectionType(this, node, "|");
}
function TSIntersectionType(node) {
    tsPrintUnionOrIntersectionType(this, node, "&");
}
function tsPrintUnionOrIntersectionType(printer, node, sep) {
    printer.printJoin(node.types, node, {
        separator () {
            this.space();
            this.token(sep);
            this.space();
        }
    });
}
function TSConditionalType(node) {
    this.print(node.checkType);
    this.space();
    this.word("extends");
    this.space();
    this.print(node.extendsType);
    this.space();
    this.tokenChar(63);
    this.space();
    this.print(node.trueType);
    this.space();
    this.tokenChar(58);
    this.space();
    this.print(node.falseType);
}
function TSInferType(node) {
    this.token("infer");
    this.space();
    this.print(node.typeParameter);
}
function TSParenthesizedType(node) {
    this.tokenChar(40);
    this.print(node.typeAnnotation, node);
    this.tokenChar(41);
}
function TSTypeOperator(node) {
    this.word(node.operator);
    this.space();
    this.print(node.typeAnnotation, node);
}
function TSIndexedAccessType(node) {
    this.print(node.objectType, node, true);
    this.tokenChar(91);
    this.print(node.indexType, node);
    this.tokenChar(93);
}
function TSMappedType(node) {
    const { nameType, optional, readonly, typeParameter } = node;
    this.tokenChar(123);
    this.space();
    if (readonly) {
        tokenIfPlusMinus(this, readonly);
        this.word("readonly");
        this.space();
    }
    this.tokenChar(91);
    this.word(typeParameter.name);
    this.space();
    this.word("in");
    this.space();
    this.print(typeParameter.constraint, typeParameter);
    if (nameType) {
        this.space();
        this.word("as");
        this.space();
        this.print(nameType, node);
    }
    this.tokenChar(93);
    if (optional) {
        tokenIfPlusMinus(this, optional);
        this.tokenChar(63);
    }
    this.tokenChar(58);
    this.space();
    this.print(node.typeAnnotation, node);
    this.space();
    this.tokenChar(125);
}
function tokenIfPlusMinus(self, tok) {
    if (tok !== true) self.token(tok);
}
function TSLiteralType(node) {
    this.print(node.literal, node);
}
function TSExpressionWithTypeArguments(node) {
    this.print(node.expression, node);
    this.print(node.typeParameters, node);
}
function TSInterfaceDeclaration(node) {
    const { declare, id, typeParameters, extends: extendz, body } = node;
    if (declare) {
        this.word("declare");
        this.space();
    }
    this.word("interface");
    this.space();
    this.print(id, node);
    this.print(typeParameters, node);
    if (extendz != null && extendz.length) {
        this.space();
        this.word("extends");
        this.space();
        this.printList(extendz, node);
    }
    this.space();
    this.print(body, node);
}
function TSInterfaceBody(node) {
    this.tsPrintTypeLiteralOrInterfaceBody(node.body, node);
}
function TSTypeAliasDeclaration(node) {
    const { declare, id, typeParameters, typeAnnotation } = node;
    if (declare) {
        this.word("declare");
        this.space();
    }
    this.word("type");
    this.space();
    this.print(id, node);
    this.print(typeParameters, node);
    this.space();
    this.tokenChar(61);
    this.space();
    this.print(typeAnnotation, node);
    this.tokenChar(59);
}
function TSTypeExpression(node) {
    var _expression$trailingC;
    const { type, expression, typeAnnotation } = node;
    const forceParens = !!((_expression$trailingC = expression.trailingComments) != null && _expression$trailingC.length);
    this.print(expression, node, true, undefined, forceParens);
    this.space();
    this.word(type === "TSAsExpression" ? "as" : "satisfies");
    this.space();
    this.print(typeAnnotation, node);
}
function TSTypeAssertion(node) {
    const { typeAnnotation, expression } = node;
    this.tokenChar(60);
    this.print(typeAnnotation, node);
    this.tokenChar(62);
    this.space();
    this.print(expression, node);
}
function TSInstantiationExpression(node) {
    this.print(node.expression, node);
    this.print(node.typeParameters, node);
}
function TSEnumDeclaration(node) {
    const { declare, const: isConst, id, members } = node;
    if (declare) {
        this.word("declare");
        this.space();
    }
    if (isConst) {
        this.word("const");
        this.space();
    }
    this.word("enum");
    this.space();
    this.print(id, node);
    this.space();
    tsPrintBraced(this, members, node);
}
function TSEnumMember(node) {
    const { id, initializer } = node;
    this.print(id, node);
    if (initializer) {
        this.space();
        this.tokenChar(61);
        this.space();
        this.print(initializer, node);
    }
    this.tokenChar(44);
}
function TSModuleDeclaration(node) {
    const { declare, id } = node;
    if (declare) {
        this.word("declare");
        this.space();
    }
    if (!node.global) {
        this.word(id.type === "Identifier" ? "namespace" : "module");
        this.space();
    }
    this.print(id, node);
    if (!node.body) {
        this.tokenChar(59);
        return;
    }
    let body = node.body;
    while(body.type === "TSModuleDeclaration"){
        this.tokenChar(46);
        this.print(body.id, body);
        body = body.body;
    }
    this.space();
    this.print(body, node);
}
function TSModuleBlock(node) {
    tsPrintBraced(this, node.body, node);
}
function TSImportType(node) {
    const { argument, qualifier, typeParameters } = node;
    this.word("import");
    this.tokenChar(40);
    this.print(argument, node);
    this.tokenChar(41);
    if (qualifier) {
        this.tokenChar(46);
        this.print(qualifier, node);
    }
    if (typeParameters) this.print(typeParameters, node);
}
function TSImportEqualsDeclaration(node) {
    const { isExport, id, moduleReference } = node;
    if (isExport) {
        this.word("export");
        this.space();
    }
    this.word("import");
    this.space();
    this.print(id, node);
    this.space();
    this.tokenChar(61);
    this.space();
    this.print(moduleReference, node);
    this.tokenChar(59);
}
function TSExternalModuleReference(node) {
    this.token("require(");
    this.print(node.expression, node);
    this.tokenChar(41);
}
function TSNonNullExpression(node) {
    this.print(node.expression, node);
    this.tokenChar(33);
}
function TSExportAssignment(node) {
    this.word("export");
    this.space();
    this.tokenChar(61);
    this.space();
    this.print(node.expression, node);
    this.tokenChar(59);
}
function TSNamespaceExportDeclaration(node) {
    this.word("export");
    this.space();
    this.word("as");
    this.space();
    this.word("namespace");
    this.space();
    this.print(node.id, node);
}
function tsPrintSignatureDeclarationBase(node) {
    const { typeParameters } = node;
    const parameters = node.parameters;
    this.print(typeParameters, node);
    this.tokenChar(40);
    this._parameters(parameters, node);
    this.tokenChar(41);
    const returnType = node.typeAnnotation;
    this.print(returnType, node);
}
function tsPrintClassMemberModifiers(node) {
    const isField = node.type === "ClassAccessorProperty" || node.type === "ClassProperty";
    if (isField && node.declare) {
        this.word("declare");
        this.space();
    }
    if (node.accessibility) {
        this.word(node.accessibility);
        this.space();
    }
    if (node.static) {
        this.word("static");
        this.space();
    }
    if (node.override) {
        this.word("override");
        this.space();
    }
    if (node.abstract) {
        this.word("abstract");
        this.space();
    }
    if (isField && node.readonly) {
        this.word("readonly");
        this.space();
    }
}

});




parcelRegister("8sOJt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.ensure = $62984aacb3eb1f34$var$ensure;
module.exports.get = $62984aacb3eb1f34$var$get;
module.exports.getDependencies = $62984aacb3eb1f34$var$getDependencies;
module.exports.list = void 0;
module.exports.minVersion = $62984aacb3eb1f34$var$minVersion;

var $aHxeO = parcelRequire("aHxeO");

var $ardUq = parcelRequire("ardUq");

var $1gHRj = parcelRequire("1gHRj");
const { assignmentExpression: $62984aacb3eb1f34$var$assignmentExpression, cloneNode: $62984aacb3eb1f34$var$cloneNode, expressionStatement: $62984aacb3eb1f34$var$expressionStatement, file: $62984aacb3eb1f34$var$file, identifier: $62984aacb3eb1f34$var$identifier } = $ardUq;
function $62984aacb3eb1f34$var$makePath(path) {
    const parts = [];
    for(; path.parentPath; path = path.parentPath){
        parts.push(path.key);
        if (path.inList) parts.push(path.listKey);
    }
    return parts.reverse().join(".");
}
let $62984aacb3eb1f34$var$FileClass = undefined;
function $62984aacb3eb1f34$var$getHelperMetadata(file) {
    const globals = new Set();
    const localBindingNames = new Set();
    const dependencies = new Map();
    let exportName;
    let exportPath;
    const exportBindingAssignments = [];
    const importPaths = [];
    const importBindingsReferences = [];
    const dependencyVisitor = {
        ImportDeclaration (child) {
            const name = child.node.source.value;
            if (!$1gHRj.default[name]) throw child.buildCodeFrameError(`Unknown helper ${name}`);
            if (child.get("specifiers").length !== 1 || !child.get("specifiers.0").isImportDefaultSpecifier()) throw child.buildCodeFrameError("Helpers can only import a default value");
            const bindingIdentifier = child.node.specifiers[0].local;
            dependencies.set(bindingIdentifier, name);
            importPaths.push($62984aacb3eb1f34$var$makePath(child));
        },
        ExportDefaultDeclaration (child) {
            const decl = child.get("declaration");
            if (!decl.isFunctionDeclaration() || !decl.node.id) throw decl.buildCodeFrameError("Helpers can only export named function declarations");
            exportName = decl.node.id.name;
            exportPath = $62984aacb3eb1f34$var$makePath(child);
        },
        ExportAllDeclaration (child) {
            throw child.buildCodeFrameError("Helpers can only export default");
        },
        ExportNamedDeclaration (child) {
            throw child.buildCodeFrameError("Helpers can only export default");
        },
        Statement (child) {
            if (child.isImportDeclaration() || child.isExportDeclaration()) return;
            child.skip();
        }
    };
    const referenceVisitor = {
        Program (path) {
            const bindings = path.scope.getAllBindings();
            Object.keys(bindings).forEach((name)=>{
                if (name === exportName) return;
                if (dependencies.has(bindings[name].identifier)) return;
                localBindingNames.add(name);
            });
        },
        ReferencedIdentifier (child) {
            const name = child.node.name;
            const binding = child.scope.getBinding(name);
            if (!binding) {
                if (name !== "arguments" || child.scope.path.isProgram()) globals.add(name);
            } else if (dependencies.has(binding.identifier)) importBindingsReferences.push($62984aacb3eb1f34$var$makePath(child));
        },
        AssignmentExpression (child) {
            const left = child.get("left");
            if (!(exportName in left.getBindingIdentifiers())) return;
            if (!left.isIdentifier()) throw left.buildCodeFrameError("Only simple assignments to exports are allowed in helpers");
            const binding = child.scope.getBinding(exportName);
            if (binding != null && binding.scope.path.isProgram()) exportBindingAssignments.push($62984aacb3eb1f34$var$makePath(child));
        }
    };
    (0, $aHxeO.default)(file.ast, dependencyVisitor, file.scope);
    (0, $aHxeO.default)(file.ast, referenceVisitor, file.scope);
    if (!exportPath) throw new Error("Helpers must have a default export.");
    exportBindingAssignments.reverse();
    return {
        globals: Array.from(globals),
        localBindingNames: Array.from(localBindingNames),
        dependencies: dependencies,
        exportBindingAssignments: exportBindingAssignments,
        exportPath: exportPath,
        exportName: exportName,
        importBindingsReferences: importBindingsReferences,
        importPaths: importPaths
    };
}
function $62984aacb3eb1f34$var$permuteHelperAST(file, metadata, id, localBindings, getDependency) {
    if (localBindings && !id) throw new Error("Unexpected local bindings for module-based helpers.");
    if (!id) return;
    const { localBindingNames: localBindingNames, dependencies: dependencies, exportBindingAssignments: exportBindingAssignments, exportPath: exportPath, exportName: exportName, importBindingsReferences: importBindingsReferences, importPaths: importPaths } = metadata;
    const dependenciesRefs = {};
    dependencies.forEach((name, id)=>{
        dependenciesRefs[id.name] = typeof getDependency === "function" && getDependency(name) || id;
    });
    const toRename = {};
    const bindings = new Set(localBindings || []);
    if (id.type === "Identifier") bindings.add(id.name);
    localBindingNames.forEach((name)=>{
        let newName = name;
        while(bindings.has(newName))newName = "_" + newName;
        if (newName !== name) toRename[name] = newName;
    });
    if (id.type === "Identifier" && exportName !== id.name) toRename[exportName] = id.name;
    const { path: path } = file;
    const exp = path.get(exportPath);
    const imps = importPaths.map((p)=>path.get(p));
    const impsBindingRefs = importBindingsReferences.map((p)=>path.get(p));
    const decl = exp.get("declaration");
    if (id.type === "Identifier") exp.replaceWith(decl);
    else if (id.type === "MemberExpression") {
        exportBindingAssignments.forEach((assignPath)=>{
            const assign = path.get(assignPath);
            assign.replaceWith($62984aacb3eb1f34$var$assignmentExpression("=", id, assign.node));
        });
        exp.replaceWith(decl);
        path.pushContainer("body", $62984aacb3eb1f34$var$expressionStatement($62984aacb3eb1f34$var$assignmentExpression("=", id, $62984aacb3eb1f34$var$identifier(exportName))));
    } else throw new Error("Unexpected helper format.");
    Object.keys(toRename).forEach((name)=>{
        path.scope.rename(name, toRename[name]);
    });
    for (const path of imps)path.remove();
    for (const path of impsBindingRefs){
        const node = $62984aacb3eb1f34$var$cloneNode(dependenciesRefs[path.node.name]);
        path.replaceWith(node);
    }
}
const $62984aacb3eb1f34$var$helperData = Object.create(null);
function $62984aacb3eb1f34$var$loadHelper(name) {
    if (!$62984aacb3eb1f34$var$helperData[name]) {
        const helper = $1gHRj.default[name];
        if (!helper) throw Object.assign(new ReferenceError(`Unknown helper ${name}`), {
            code: "BABEL_HELPER_UNKNOWN",
            helper: name
        });
        const fn = ()=>{
            if (!$62984aacb3eb1f34$var$FileClass) {
                const fakeFile = {
                    ast: $62984aacb3eb1f34$var$file(helper.ast()),
                    path: null
                };
                (0, $aHxeO.default)(fakeFile.ast, {
                    Program: (path)=>(fakeFile.path = path).stop()
                });
                return fakeFile;
            }
            return new $62984aacb3eb1f34$var$FileClass({
                filename: `babel-helper://${name}`
            }, {
                ast: $62984aacb3eb1f34$var$file(helper.ast()),
                code: "[internal Babel helper code]",
                inputMap: null
            });
        };
        let metadata = null;
        $62984aacb3eb1f34$var$helperData[name] = {
            minVersion: helper.minVersion,
            build (getDependency, id, localBindings) {
                const file = fn();
                metadata || (metadata = $62984aacb3eb1f34$var$getHelperMetadata(file));
                $62984aacb3eb1f34$var$permuteHelperAST(file, metadata, id, localBindings, getDependency);
                return {
                    nodes: file.ast.program.body,
                    globals: metadata.globals
                };
            },
            getDependencies () {
                metadata || (metadata = $62984aacb3eb1f34$var$getHelperMetadata(fn()));
                return Array.from(metadata.dependencies.values());
            }
        };
    }
    return $62984aacb3eb1f34$var$helperData[name];
}
function $62984aacb3eb1f34$var$get(name, getDependency, id, localBindings) {
    return $62984aacb3eb1f34$var$loadHelper(name).build(getDependency, id, localBindings);
}
function $62984aacb3eb1f34$var$minVersion(name) {
    return $62984aacb3eb1f34$var$loadHelper(name).minVersion;
}
function $62984aacb3eb1f34$var$getDependencies(name) {
    return $62984aacb3eb1f34$var$loadHelper(name).getDependencies();
}
function $62984aacb3eb1f34$var$ensure(name, newFileClass) {
    $62984aacb3eb1f34$var$FileClass || ($62984aacb3eb1f34$var$FileClass = newFileClass);
    $62984aacb3eb1f34$var$loadHelper(name);
}
const $62984aacb3eb1f34$var$list = module.exports.list = Object.keys($1gHRj.default).map((name)=>name.replace(/^_/, ""));
var $62984aacb3eb1f34$var$_default = module.exports.default = $62984aacb3eb1f34$var$get;

});
parcelRegister("aHxeO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "Hub", {
    enumerable: true,
    get: function() {
        return $8nPrS.default;
    }
});
Object.defineProperty(module.exports, "NodePath", {
    enumerable: true,
    get: function() {
        return $8zU9J.default;
    }
});
Object.defineProperty(module.exports, "Scope", {
    enumerable: true,
    get: function() {
        return $1XRCD.default;
    }
});
module.exports.visitors = module.exports.default = void 0;

var $9OeKS = parcelRequire("9OeKS");
module.exports.visitors = $9OeKS;

var $ardUq = parcelRequire("ardUq");

var $ClGPh = parcelRequire("ClGPh");

var $k33SJ = parcelRequire("k33SJ");

var $8zU9J = parcelRequire("8zU9J");

var $1XRCD = parcelRequire("1XRCD");

var $8nPrS = parcelRequire("8nPrS");
const { VISITOR_KEYS: $7ca7b3ea00be5c0e$var$VISITOR_KEYS, removeProperties: $7ca7b3ea00be5c0e$var$removeProperties, traverseFast: $7ca7b3ea00be5c0e$var$traverseFast } = $ardUq;
function $7ca7b3ea00be5c0e$var$traverse(parent, opts = {}, scope, state, parentPath, visitSelf) {
    if (!parent) return;
    if (!opts.noScope && !scope) {
        if (parent.type !== "Program" && parent.type !== "File") throw new Error("You must pass a scope and parentPath unless traversing a Program/File. " + `Instead of that you tried to traverse a ${parent.type} node without ` + "passing scope and parentPath.");
    }
    if (!parentPath && visitSelf) throw new Error("visitSelf can only be used when providing a NodePath.");
    if (!$7ca7b3ea00be5c0e$var$VISITOR_KEYS[parent.type]) return;
    $9OeKS.explode(opts);
    (0, $k33SJ.traverseNode)(parent, opts, scope, state, parentPath, null, visitSelf);
}
var $7ca7b3ea00be5c0e$var$_default = module.exports.default = $7ca7b3ea00be5c0e$var$traverse;
$7ca7b3ea00be5c0e$var$traverse.visitors = $9OeKS;
$7ca7b3ea00be5c0e$var$traverse.verify = $9OeKS.verify;
$7ca7b3ea00be5c0e$var$traverse.explode = $9OeKS.explode;
$7ca7b3ea00be5c0e$var$traverse.cheap = function(node, enter) {
    $7ca7b3ea00be5c0e$var$traverseFast(node, enter);
    return;
};
$7ca7b3ea00be5c0e$var$traverse.node = function(node, opts, scope, state, path, skipKeys) {
    (0, $k33SJ.traverseNode)(node, opts, scope, state, path, skipKeys);
};
$7ca7b3ea00be5c0e$var$traverse.clearNode = function(node, opts) {
    $7ca7b3ea00be5c0e$var$removeProperties(node, opts);
};
$7ca7b3ea00be5c0e$var$traverse.removeProperties = function(tree, opts) {
    $7ca7b3ea00be5c0e$var$traverseFast(tree, $7ca7b3ea00be5c0e$var$traverse.clearNode, opts);
    return tree;
};
function $7ca7b3ea00be5c0e$var$hasDenylistedType(path, state) {
    if (path.node.type === state.type) {
        state.has = true;
        path.stop();
    }
}
$7ca7b3ea00be5c0e$var$traverse.hasType = function(tree, type, denylistTypes) {
    if (denylistTypes != null && denylistTypes.includes(tree.type)) return false;
    if (tree.type === type) return true;
    const state = {
        has: false,
        type: type
    };
    $7ca7b3ea00be5c0e$var$traverse(tree, {
        noScope: true,
        denylist: denylistTypes,
        enter: $7ca7b3ea00be5c0e$var$hasDenylistedType
    }, null, state);
    return state.has;
};
$7ca7b3ea00be5c0e$var$traverse.cache = $ClGPh;

});
parcelRegister("9OeKS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.explode = $72443a9b02c83a23$var$explode;
module.exports.isExplodedVisitor = $72443a9b02c83a23$var$isExplodedVisitor;
module.exports.merge = $72443a9b02c83a23$var$merge;
module.exports.verify = $72443a9b02c83a23$var$verify;

var $chZS9 = parcelRequire("chZS9");

var $kL2Ze = parcelRequire("kL2Ze");

var $ardUq = parcelRequire("ardUq");
const { DEPRECATED_KEYS: $72443a9b02c83a23$var$DEPRECATED_KEYS, DEPRECATED_ALIASES: $72443a9b02c83a23$var$DEPRECATED_ALIASES, FLIPPED_ALIAS_KEYS: $72443a9b02c83a23$var$FLIPPED_ALIAS_KEYS, TYPES: $72443a9b02c83a23$var$TYPES, __internal__deprecationWarning: $72443a9b02c83a23$var$deprecationWarning } = $ardUq;
function $72443a9b02c83a23$var$isVirtualType(type) {
    return type in $chZS9;
}
function $72443a9b02c83a23$var$isExplodedVisitor(visitor) {
    return visitor == null ? void 0 : visitor._exploded;
}
function $72443a9b02c83a23$var$explode(visitor) {
    if ($72443a9b02c83a23$var$isExplodedVisitor(visitor)) return visitor;
    visitor._exploded = true;
    for (const nodeType of Object.keys(visitor)){
        if ($72443a9b02c83a23$var$shouldIgnoreKey(nodeType)) continue;
        const parts = nodeType.split("|");
        if (parts.length === 1) continue;
        const fns = visitor[nodeType];
        delete visitor[nodeType];
        for (const part of parts)visitor[part] = fns;
    }
    $72443a9b02c83a23$var$verify(visitor);
    delete visitor.__esModule;
    $72443a9b02c83a23$var$ensureEntranceObjects(visitor);
    $72443a9b02c83a23$var$ensureCallbackArrays(visitor);
    for (const nodeType of Object.keys(visitor)){
        if ($72443a9b02c83a23$var$shouldIgnoreKey(nodeType)) continue;
        if (!$72443a9b02c83a23$var$isVirtualType(nodeType)) continue;
        const fns = visitor[nodeType];
        for (const type of Object.keys(fns))fns[type] = $72443a9b02c83a23$var$wrapCheck(nodeType, fns[type]);
        delete visitor[nodeType];
        const types = $chZS9[nodeType];
        if (types !== null) {
            for (const type of types)if (visitor[type]) $72443a9b02c83a23$var$mergePair(visitor[type], fns);
            else visitor[type] = fns;
        } else $72443a9b02c83a23$var$mergePair(visitor, fns);
    }
    for (const nodeType of Object.keys(visitor)){
        if ($72443a9b02c83a23$var$shouldIgnoreKey(nodeType)) continue;
        let aliases = $72443a9b02c83a23$var$FLIPPED_ALIAS_KEYS[nodeType];
        if (nodeType in $72443a9b02c83a23$var$DEPRECATED_KEYS) {
            const deprecatedKey = $72443a9b02c83a23$var$DEPRECATED_KEYS[nodeType];
            $72443a9b02c83a23$var$deprecationWarning(nodeType, deprecatedKey, "Visitor ");
            aliases = [
                deprecatedKey
            ];
        } else if (nodeType in $72443a9b02c83a23$var$DEPRECATED_ALIASES) {
            const deprecatedAlias = $72443a9b02c83a23$var$DEPRECATED_ALIASES[nodeType];
            $72443a9b02c83a23$var$deprecationWarning(nodeType, deprecatedAlias, "Visitor ");
            aliases = $72443a9b02c83a23$var$FLIPPED_ALIAS_KEYS[deprecatedAlias];
        }
        if (!aliases) continue;
        const fns = visitor[nodeType];
        delete visitor[nodeType];
        for (const alias of aliases){
            const existing = visitor[alias];
            if (existing) $72443a9b02c83a23$var$mergePair(existing, fns);
            else visitor[alias] = Object.assign({}, fns);
        }
    }
    for (const nodeType of Object.keys(visitor)){
        if ($72443a9b02c83a23$var$shouldIgnoreKey(nodeType)) continue;
        $72443a9b02c83a23$var$ensureCallbackArrays(visitor[nodeType]);
    }
    return visitor;
}
function $72443a9b02c83a23$var$verify(visitor) {
    if (visitor._verified) return;
    if (typeof visitor === "function") throw new Error("You passed `traverse()` a function when it expected a visitor object, are you sure you didn't mean `{ enter: Function }`?");
    for (const nodeType of Object.keys(visitor)){
        if (nodeType === "enter" || nodeType === "exit") $72443a9b02c83a23$var$validateVisitorMethods(nodeType, visitor[nodeType]);
        if ($72443a9b02c83a23$var$shouldIgnoreKey(nodeType)) continue;
        if ($72443a9b02c83a23$var$TYPES.indexOf(nodeType) < 0) throw new Error(`You gave us a visitor for the node type ${nodeType} but it's not a valid type`);
        const visitors = visitor[nodeType];
        if (typeof visitors === "object") for (const visitorKey of Object.keys(visitors)){
            if (visitorKey === "enter" || visitorKey === "exit") $72443a9b02c83a23$var$validateVisitorMethods(`${nodeType}.${visitorKey}`, visitors[visitorKey]);
            else throw new Error("You passed `traverse()` a visitor object with the property " + `${nodeType} that has the invalid property ${visitorKey}`);
        }
    }
    visitor._verified = true;
}
function $72443a9b02c83a23$var$validateVisitorMethods(path, val) {
    const fns = [].concat(val);
    for (const fn of fns){
        if (typeof fn !== "function") throw new TypeError(`Non-function found defined in ${path} with type ${typeof fn}`);
    }
}
function $72443a9b02c83a23$var$merge(visitors, states = [], wrapper) {
    const mergedVisitor = {};
    for(let i = 0; i < visitors.length; i++){
        const visitor = $72443a9b02c83a23$var$explode(visitors[i]);
        const state = states[i];
        let topVisitor = visitor;
        if (state || wrapper) topVisitor = $72443a9b02c83a23$var$wrapWithStateOrWrapper(topVisitor, state, wrapper);
        $72443a9b02c83a23$var$mergePair(mergedVisitor, topVisitor);
        for (const key of Object.keys(visitor)){
            if ($72443a9b02c83a23$var$shouldIgnoreKey(key)) continue;
            let typeVisitor = visitor[key];
            if (state || wrapper) typeVisitor = $72443a9b02c83a23$var$wrapWithStateOrWrapper(typeVisitor, state, wrapper);
            const nodeVisitor = mergedVisitor[key] || (mergedVisitor[key] = {});
            $72443a9b02c83a23$var$mergePair(nodeVisitor, typeVisitor);
        }
    }
    return mergedVisitor;
}
function $72443a9b02c83a23$var$wrapWithStateOrWrapper(oldVisitor, state, wrapper) {
    const newVisitor = {};
    for (const phase of [
        "enter",
        "exit"
    ]){
        let fns = oldVisitor[phase];
        if (!Array.isArray(fns)) continue;
        fns = fns.map(function(fn) {
            let newFn = fn;
            if (state) newFn = function(path) {
                fn.call(state, path, state);
            };
            if (wrapper) newFn = wrapper(state == null ? void 0 : state.key, phase, newFn);
            if (newFn !== fn) newFn.toString = ()=>fn.toString();
            return newFn;
        });
        newVisitor[phase] = fns;
    }
    return newVisitor;
}
function $72443a9b02c83a23$var$ensureEntranceObjects(obj) {
    for (const key of Object.keys(obj)){
        if ($72443a9b02c83a23$var$shouldIgnoreKey(key)) continue;
        const fns = obj[key];
        if (typeof fns === "function") obj[key] = {
            enter: fns
        };
    }
}
function $72443a9b02c83a23$var$ensureCallbackArrays(obj) {
    if (obj.enter && !Array.isArray(obj.enter)) obj.enter = [
        obj.enter
    ];
    if (obj.exit && !Array.isArray(obj.exit)) obj.exit = [
        obj.exit
    ];
}
function $72443a9b02c83a23$var$wrapCheck(nodeType, fn) {
    const fnKey = `is${nodeType}`;
    const validator = $kL2Ze[fnKey];
    const newFn = function(path) {
        if (validator.call(path)) return fn.apply(this, arguments);
    };
    newFn.toString = ()=>fn.toString();
    return newFn;
}
function $72443a9b02c83a23$var$shouldIgnoreKey(key) {
    if (key[0] === "_") return true;
    if (key === "enter" || key === "exit" || key === "shouldSkip") return true;
    if (key === "denylist" || key === "noScope" || key === "skipKeys") return true;
    if (key === "blacklist") return true;
    return false;
}
function $72443a9b02c83a23$var$mergePair(dest, src) {
    for (const phase of [
        "enter",
        "exit"
    ]){
        if (!src[phase]) continue;
        dest[phase] = [].concat(dest[phase] || [], src[phase]);
    }
}

});
parcelRegister("chZS9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Var = module.exports.User = module.exports.Statement = module.exports.SpreadProperty = module.exports.Scope = module.exports.RestProperty = module.exports.ReferencedMemberExpression = module.exports.ReferencedIdentifier = module.exports.Referenced = module.exports.Pure = module.exports.NumericLiteralTypeAnnotation = module.exports.Generated = module.exports.ForAwaitStatement = module.exports.Flow = module.exports.Expression = module.exports.ExistentialTypeParam = module.exports.BlockScoped = module.exports.BindingIdentifier = void 0;
const $8f271127c47d9840$var$ReferencedIdentifier = module.exports.ReferencedIdentifier = [
    "Identifier",
    "JSXIdentifier"
];
const $8f271127c47d9840$var$ReferencedMemberExpression = module.exports.ReferencedMemberExpression = [
    "MemberExpression"
];
const $8f271127c47d9840$var$BindingIdentifier = module.exports.BindingIdentifier = [
    "Identifier"
];
const $8f271127c47d9840$var$Statement = module.exports.Statement = [
    "Statement"
];
const $8f271127c47d9840$var$Expression = module.exports.Expression = [
    "Expression"
];
const $8f271127c47d9840$var$Scope = module.exports.Scope = [
    "Scopable",
    "Pattern"
];
const $8f271127c47d9840$var$Referenced = module.exports.Referenced = null;
const $8f271127c47d9840$var$BlockScoped = module.exports.BlockScoped = null;
const $8f271127c47d9840$var$Var = module.exports.Var = [
    "VariableDeclaration"
];
const $8f271127c47d9840$var$User = module.exports.User = null;
const $8f271127c47d9840$var$Generated = module.exports.Generated = null;
const $8f271127c47d9840$var$Pure = module.exports.Pure = null;
const $8f271127c47d9840$var$Flow = module.exports.Flow = [
    "Flow",
    "ImportDeclaration",
    "ExportDeclaration",
    "ImportSpecifier"
];
const $8f271127c47d9840$var$RestProperty = module.exports.RestProperty = [
    "RestElement"
];
const $8f271127c47d9840$var$SpreadProperty = module.exports.SpreadProperty = [
    "RestElement"
];
const $8f271127c47d9840$var$ExistentialTypeParam = module.exports.ExistentialTypeParam = [
    "ExistsTypeAnnotation"
];
const $8f271127c47d9840$var$NumericLiteralTypeAnnotation = module.exports.NumericLiteralTypeAnnotation = [
    "NumberLiteralTypeAnnotation"
];
const $8f271127c47d9840$var$ForAwaitStatement = module.exports.ForAwaitStatement = [
    "ForOfStatement"
];

});

parcelRegister("kL2Ze", function(module, exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isBindingIdentifier = isBindingIdentifier;
exports.isBlockScoped = isBlockScoped;
exports.isExpression = isExpression;
exports.isFlow = isFlow;
exports.isForAwaitStatement = isForAwaitStatement;
exports.isGenerated = isGenerated;
exports.isPure = isPure;
exports.isReferenced = isReferenced;
exports.isReferencedIdentifier = isReferencedIdentifier;
exports.isReferencedMemberExpression = isReferencedMemberExpression;
exports.isRestProperty = isRestProperty;
exports.isScope = isScope;
exports.isSpreadProperty = isSpreadProperty;
exports.isStatement = isStatement;
exports.isUser = isUser;
exports.isVar = isVar;

var $ardUq = parcelRequire("ardUq");
const { isBinding, isBlockScoped: nodeIsBlockScoped, isExportDeclaration, isExpression: nodeIsExpression, isFlow: nodeIsFlow, isForStatement, isForXStatement, isIdentifier, isImportDeclaration, isImportSpecifier, isJSXIdentifier, isJSXMemberExpression, isMemberExpression, isRestElement: nodeIsRestElement, isReferenced: nodeIsReferenced, isScope: nodeIsScope, isStatement: nodeIsStatement, isVar: nodeIsVar, isVariableDeclaration, react, isForOfStatement } = $ardUq;
const { isCompatTag } = react;
function isReferencedIdentifier(opts) {
    const { node, parent } = this;
    if (!isIdentifier(node, opts) && !isJSXMemberExpression(parent, opts)) {
        if (isJSXIdentifier(node, opts)) {
            if (isCompatTag(node.name)) return false;
        } else return false;
    }
    return nodeIsReferenced(node, parent, this.parentPath.parent);
}
function isReferencedMemberExpression() {
    const { node, parent } = this;
    return isMemberExpression(node) && nodeIsReferenced(node, parent);
}
function isBindingIdentifier() {
    const { node, parent } = this;
    const grandparent = this.parentPath.parent;
    return isIdentifier(node) && isBinding(node, parent, grandparent);
}
function isStatement() {
    const { node, parent } = this;
    if (nodeIsStatement(node)) {
        if (isVariableDeclaration(node)) {
            if (isForXStatement(parent, {
                left: node
            })) return false;
            if (isForStatement(parent, {
                init: node
            })) return false;
        }
        return true;
    } else return false;
}
function isExpression() {
    if (this.isIdentifier()) return this.isReferencedIdentifier();
    else return nodeIsExpression(this.node);
}
function isScope() {
    return nodeIsScope(this.node, this.parent);
}
function isReferenced() {
    return nodeIsReferenced(this.node, this.parent);
}
function isBlockScoped() {
    return nodeIsBlockScoped(this.node);
}
function isVar() {
    return nodeIsVar(this.node);
}
function isUser() {
    return this.node && !!this.node.loc;
}
function isGenerated() {
    return !this.isUser();
}
function isPure(constantsOnly) {
    return this.scope.isPure(this.node, constantsOnly);
}
function isFlow() {
    const { node } = this;
    if (nodeIsFlow(node)) return true;
    else if (isImportDeclaration(node)) return node.importKind === "type" || node.importKind === "typeof";
    else if (isExportDeclaration(node)) return node.exportKind === "type";
    else if (isImportSpecifier(node)) return node.importKind === "type" || node.importKind === "typeof";
    else return false;
}
function isRestProperty() {
    return nodeIsRestElement(this.node) && this.parentPath && this.parentPath.isObjectPattern();
}
function isSpreadProperty() {
    return nodeIsRestElement(this.node) && this.parentPath && this.parentPath.isObjectExpression();
}
function isForAwaitStatement() {
    return isForOfStatement(this.node, {
        await: true
    });
}
exports.isExistentialTypeParam = function isExistentialTypeParam() {
    throw new Error("`path.isExistentialTypeParam` has been renamed to `path.isExistsTypeAnnotation()` in Babel 7.");
};
exports.isNumericLiteralTypeAnnotation = function isNumericLiteralTypeAnnotation() {
    throw new Error("`path.isNumericLiteralTypeAnnotation()` has been renamed to `path.isNumberLiteralTypeAnnotation()` in Babel 7.");
};

});


parcelRegister("ClGPh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.clear = $07345fdb1aad8e40$var$clear;
module.exports.clearPath = $07345fdb1aad8e40$var$clearPath;
module.exports.clearScope = $07345fdb1aad8e40$var$clearScope;
module.exports.getCachedPaths = $07345fdb1aad8e40$var$getCachedPaths;
module.exports.getOrCreateCachedPaths = $07345fdb1aad8e40$var$getOrCreateCachedPaths;
module.exports.scope = module.exports.path = void 0;
let $07345fdb1aad8e40$var$pathsCache = module.exports.path = new WeakMap();
let $07345fdb1aad8e40$var$scope = module.exports.scope = new WeakMap();
function $07345fdb1aad8e40$var$clear() {
    $07345fdb1aad8e40$var$clearPath();
    $07345fdb1aad8e40$var$clearScope();
}
function $07345fdb1aad8e40$var$clearPath() {
    module.exports.path = $07345fdb1aad8e40$var$pathsCache = new WeakMap();
}
function $07345fdb1aad8e40$var$clearScope() {
    module.exports.scope = $07345fdb1aad8e40$var$scope = new WeakMap();
}
const $07345fdb1aad8e40$var$nullHub = Object.freeze({});
function $07345fdb1aad8e40$var$getCachedPaths(hub, parent) {
    var _pathsCache$get, _hub;
    hub = null;
    return (_pathsCache$get = $07345fdb1aad8e40$var$pathsCache.get((_hub = hub) != null ? _hub : $07345fdb1aad8e40$var$nullHub)) == null ? void 0 : _pathsCache$get.get(parent);
}
function $07345fdb1aad8e40$var$getOrCreateCachedPaths(hub, parent) {
    var _hub2, _hub3;
    hub = null;
    let parents = $07345fdb1aad8e40$var$pathsCache.get((_hub2 = hub) != null ? _hub2 : $07345fdb1aad8e40$var$nullHub);
    if (!parents) $07345fdb1aad8e40$var$pathsCache.set((_hub3 = hub) != null ? _hub3 : $07345fdb1aad8e40$var$nullHub, parents = new WeakMap());
    let paths = parents.get(parent);
    if (!paths) parents.set(parent, paths = new Map());
    return paths;
}

});

parcelRegister("k33SJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.traverseNode = $03c43e57f2ac1da0$var$traverseNode;

var $h8sB3 = parcelRequire("h8sB3");

var $ardUq = parcelRequire("ardUq");
const { VISITOR_KEYS: $03c43e57f2ac1da0$var$VISITOR_KEYS } = $ardUq;
function $03c43e57f2ac1da0$var$traverseNode(node, opts, scope, state, path, skipKeys, visitSelf) {
    const keys = $03c43e57f2ac1da0$var$VISITOR_KEYS[node.type];
    if (!keys) return false;
    const context = new $h8sB3.default(scope, opts, state, path);
    if (visitSelf) {
        if (skipKeys != null && skipKeys[path.parentKey]) return false;
        return context.visitQueue([
            path
        ]);
    }
    for (const key of keys){
        if (skipKeys != null && skipKeys[key]) continue;
        if (context.visit(node, key)) return true;
    }
    return false;
}

});
parcelRegister("h8sB3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8zU9J = parcelRequire("8zU9J");

var $ardUq = parcelRequire("ardUq");
const { VISITOR_KEYS: $c7995db24e042f7f$var$VISITOR_KEYS } = $ardUq;
class $c7995db24e042f7f$var$TraversalContext {
    constructor(scope, opts, state, parentPath){
        this.queue = null;
        this.priorityQueue = null;
        this.parentPath = parentPath;
        this.scope = scope;
        this.state = state;
        this.opts = opts;
    }
    shouldVisit(node) {
        const opts = this.opts;
        if (opts.enter || opts.exit) return true;
        if (opts[node.type]) return true;
        const keys = $c7995db24e042f7f$var$VISITOR_KEYS[node.type];
        if (!(keys != null && keys.length)) return false;
        for (const key of keys){
            if (node[key]) return true;
        }
        return false;
    }
    create(node, container, key, listKey) {
        return $8zU9J.default.get({
            parentPath: this.parentPath,
            parent: node,
            container: container,
            key: key,
            listKey: listKey
        });
    }
    maybeQueue(path, notPriority) {
        if (this.queue) {
            if (notPriority) this.queue.push(path);
            else this.priorityQueue.push(path);
        }
    }
    visitMultiple(container, parent, listKey) {
        if (container.length === 0) return false;
        const queue = [];
        for(let key = 0; key < container.length; key++){
            const node = container[key];
            if (node && this.shouldVisit(node)) queue.push(this.create(parent, container, key, listKey));
        }
        return this.visitQueue(queue);
    }
    visitSingle(node, key) {
        if (this.shouldVisit(node[key])) return this.visitQueue([
            this.create(node, node, key)
        ]);
        else return false;
    }
    visitQueue(queue) {
        this.queue = queue;
        this.priorityQueue = [];
        const visited = new WeakSet();
        let stop = false;
        let visitIndex = 0;
        for(; visitIndex < queue.length;){
            const path = queue[visitIndex];
            visitIndex++;
            path.resync();
            if (path.contexts.length === 0 || path.contexts[path.contexts.length - 1] !== this) path.pushContext(this);
            if (path.key === null) continue;
            const { node: node } = path;
            if (visited.has(node)) continue;
            if (node) visited.add(node);
            if (path.visit()) {
                stop = true;
                break;
            }
            if (this.priorityQueue.length) {
                stop = this.visitQueue(this.priorityQueue);
                this.priorityQueue = [];
                this.queue = queue;
                if (stop) break;
            }
        }
        for(let i = 0; i < visitIndex; i++)queue[i].popContext();
        this.queue = null;
        return stop;
    }
    visit(node, key) {
        const nodes = node[key];
        if (!nodes) return false;
        if (Array.isArray(nodes)) return this.visitMultiple(nodes, node, key);
        else return this.visitSingle(node, key);
    }
}
module.exports.default = $c7995db24e042f7f$var$TraversalContext;

});
parcelRegister("8zU9J", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.SHOULD_STOP = module.exports.SHOULD_SKIP = module.exports.REMOVED = void 0;

var $chZS9 = parcelRequire("chZS9");

var $1SXIy = parcelRequire("1SXIy");

var $aHxeO = parcelRequire("aHxeO");

var $1XRCD = parcelRequire("1XRCD");

var $ardUq = parcelRequire("ardUq");
var $63ed270082c1c33d$var$t = $ardUq;

var $ClGPh = parcelRequire("ClGPh");

var $iQrBP = parcelRequire("iQrBP");

var $bLZPM = parcelRequire("bLZPM");

var $eyv53 = parcelRequire("eyv53");

var $6AeM2 = parcelRequire("6AeM2");

var $gaj2N = parcelRequire("gaj2N");

var $eCmWH = parcelRequire("eCmWH");

var $17YAB = parcelRequire("17YAB");

var $9OvWW = parcelRequire("9OvWW");

var $9UB0w = parcelRequire("9UB0w");

var $3y2Ti = parcelRequire("3y2Ti");

var $2DRRA = parcelRequire("2DRRA");

var $2TOyH = parcelRequire("2TOyH");

var $kL2Ze = parcelRequire("kL2Ze");
const { validate: $63ed270082c1c33d$var$validate } = $ardUq;
const $63ed270082c1c33d$var$debug = $1SXIy("babel");
const $63ed270082c1c33d$var$REMOVED = module.exports.REMOVED = 1;
const $63ed270082c1c33d$var$SHOULD_STOP = module.exports.SHOULD_STOP = 2;
const $63ed270082c1c33d$var$SHOULD_SKIP = module.exports.SHOULD_SKIP = 4;
class $63ed270082c1c33d$var$NodePath {
    constructor(hub, parent){
        this.contexts = [];
        this.state = null;
        this.opts = null;
        this._traverseFlags = 0;
        this.skipKeys = null;
        this.parentPath = null;
        this.container = null;
        this.listKey = null;
        this.key = null;
        this.node = null;
        this.type = null;
        this.parent = parent;
        this.hub = hub;
        this.data = null;
        this.context = null;
        this.scope = null;
    }
    static get({ hub: hub, parentPath: parentPath, parent: parent, container: container, listKey: listKey, key: key }) {
        if (!hub && parentPath) hub = parentPath.hub;
        if (!parent) throw new Error("To get a node path the parent needs to exist");
        const targetNode = container[key];
        const paths = $ClGPh.getOrCreateCachedPaths(hub, parent);
        let path = paths.get(targetNode);
        if (!path) {
            path = new $63ed270082c1c33d$var$NodePath(hub, parent);
            if (targetNode) paths.set(targetNode, path);
        }
        path.setup(parentPath, container, listKey, key);
        return path;
    }
    getScope(scope) {
        return this.isScope() ? new $1XRCD.default(this) : scope;
    }
    setData(key, val) {
        if (this.data == null) this.data = Object.create(null);
        return this.data[key] = val;
    }
    getData(key, def) {
        if (this.data == null) this.data = Object.create(null);
        let val = this.data[key];
        if (val === undefined && def !== undefined) val = this.data[key] = def;
        return val;
    }
    hasNode() {
        return this.node != null;
    }
    buildCodeFrameError(msg, Error1 = SyntaxError) {
        return this.hub.buildError(this.node, msg, Error1);
    }
    traverse(visitor, state) {
        (0, $aHxeO.default)(this.node, visitor, this.scope, state, this);
    }
    set(key, node) {
        $63ed270082c1c33d$var$validate(this.node, key, node);
        this.node[key] = node;
    }
    getPathLocation() {
        const parts = [];
        let path = this;
        do {
            let key = path.key;
            if (path.inList) key = `${path.listKey}[${key}]`;
            parts.unshift(key);
        }while (path = path.parentPath);
        return parts.join(".");
    }
    debug(message) {
        if (!$63ed270082c1c33d$var$debug.enabled) return;
        $63ed270082c1c33d$var$debug(`${this.getPathLocation()} ${this.type}: ${message}`);
    }
    toString() {
        return (0, $iQrBP.default)(this.node).code;
    }
    get inList() {
        return !!this.listKey;
    }
    set inList(inList) {
        if (!inList) this.listKey = null;
    }
    get parentKey() {
        return this.listKey || this.key;
    }
    get shouldSkip() {
        return !!(this._traverseFlags & $63ed270082c1c33d$var$SHOULD_SKIP);
    }
    set shouldSkip(v) {
        if (v) this._traverseFlags |= $63ed270082c1c33d$var$SHOULD_SKIP;
        else this._traverseFlags &= ~$63ed270082c1c33d$var$SHOULD_SKIP;
    }
    get shouldStop() {
        return !!(this._traverseFlags & $63ed270082c1c33d$var$SHOULD_STOP);
    }
    set shouldStop(v) {
        if (v) this._traverseFlags |= $63ed270082c1c33d$var$SHOULD_STOP;
        else this._traverseFlags &= ~$63ed270082c1c33d$var$SHOULD_STOP;
    }
    get removed() {
        return !!(this._traverseFlags & $63ed270082c1c33d$var$REMOVED);
    }
    set removed(v) {
        if (v) this._traverseFlags |= $63ed270082c1c33d$var$REMOVED;
        else this._traverseFlags &= ~$63ed270082c1c33d$var$REMOVED;
    }
}
Object.assign($63ed270082c1c33d$var$NodePath.prototype, $bLZPM, $eyv53, $6AeM2, $gaj2N, $eCmWH, $17YAB, $9OvWW, $9UB0w, $3y2Ti, $2DRRA, $2TOyH);
$63ed270082c1c33d$var$NodePath.prototype._guessExecutionStatusRelativeToDifferentFunctions = $17YAB._guessExecutionStatusRelativeTo;
for (const type of $63ed270082c1c33d$var$t.TYPES){
    const typeKey = `is${type}`;
    const fn = $63ed270082c1c33d$var$t[typeKey];
    $63ed270082c1c33d$var$NodePath.prototype[typeKey] = function(opts) {
        return fn(this.node, opts);
    };
    $63ed270082c1c33d$var$NodePath.prototype[`assert${type}`] = function(opts) {
        if (!fn(this.node, opts)) throw new TypeError(`Expected node path of type ${type}`);
    };
}
Object.assign($63ed270082c1c33d$var$NodePath.prototype, $kL2Ze);
for (const type of Object.keys($chZS9)){
    if (type[0] === "_") continue;
    if (!$63ed270082c1c33d$var$t.TYPES.includes(type)) $63ed270082c1c33d$var$t.TYPES.push(type);
}
var $63ed270082c1c33d$var$_default = module.exports.default = $63ed270082c1c33d$var$NodePath;

});
parcelRegister("1SXIy", function(module, exports) {
/* eslint-env browser */ /**
 * This is the web browser implementation of `debug()`.
 */ 
var $hPtJY = parcelRequire("hPtJY");
exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = localstorage();
exports.destroy = (()=>{
    let warned = false;
    return ()=>{
        if (!warned) {
            warned = true;
            console.warn("Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.");
        }
    };
})();
/**
 * Colors.
 */ exports.colors = [
    "#0000CC",
    "#0000FF",
    "#0033CC",
    "#0033FF",
    "#0066CC",
    "#0066FF",
    "#0099CC",
    "#0099FF",
    "#00CC00",
    "#00CC33",
    "#00CC66",
    "#00CC99",
    "#00CCCC",
    "#00CCFF",
    "#3300CC",
    "#3300FF",
    "#3333CC",
    "#3333FF",
    "#3366CC",
    "#3366FF",
    "#3399CC",
    "#3399FF",
    "#33CC00",
    "#33CC33",
    "#33CC66",
    "#33CC99",
    "#33CCCC",
    "#33CCFF",
    "#6600CC",
    "#6600FF",
    "#6633CC",
    "#6633FF",
    "#66CC00",
    "#66CC33",
    "#9900CC",
    "#9900FF",
    "#9933CC",
    "#9933FF",
    "#99CC00",
    "#99CC33",
    "#CC0000",
    "#CC0033",
    "#CC0066",
    "#CC0099",
    "#CC00CC",
    "#CC00FF",
    "#CC3300",
    "#CC3333",
    "#CC3366",
    "#CC3399",
    "#CC33CC",
    "#CC33FF",
    "#CC6600",
    "#CC6633",
    "#CC9900",
    "#CC9933",
    "#CCCC00",
    "#CCCC33",
    "#FF0000",
    "#FF0033",
    "#FF0066",
    "#FF0099",
    "#FF00CC",
    "#FF00FF",
    "#FF3300",
    "#FF3333",
    "#FF3366",
    "#FF3399",
    "#FF33CC",
    "#FF33FF",
    "#FF6600",
    "#FF6633",
    "#FF9900",
    "#FF9933",
    "#FFCC00",
    "#FFCC33"
];
/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */ // eslint-disable-next-line complexity
function useColors() {
    // NB: In an Electron preload script, document will be defined but not fully
    // initialized. Since we know we're in Chrome, we'll just detect this case
    // explicitly
    if (typeof window !== "undefined" && window.process && (window.process.type === "renderer" || window.process.__nwjs)) return true;
    // Internet Explorer and Edge do not support colors.
    if (typeof navigator !== "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) return false;
    // Is webkit? http://stackoverflow.com/a/16459606/376773
    // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
    return typeof document !== "undefined" && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || // Is firebug? http://stackoverflow.com/a/398120/376773
    typeof window !== "undefined" && window.console && (window.console.firebug || window.console.exception && window.console.table) || // Is firefox >= v31?
    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
    typeof navigator !== "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 || // Double check webkit in userAgent just in case we are in a worker
    typeof navigator !== "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
}
/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */ function formatArgs(args) {
    args[0] = (this.useColors ? "%c" : "") + this.namespace + (this.useColors ? " %c" : " ") + args[0] + (this.useColors ? "%c " : " ") + "+" + module.exports.humanize(this.diff);
    if (!this.useColors) return;
    const c = "color: " + this.color;
    args.splice(1, 0, c, "color: inherit");
    // The final "%c" is somewhat tricky, because there could be other
    // arguments passed either before or after the %c, so we need to
    // figure out the correct index to insert the CSS into
    let index = 0;
    let lastC = 0;
    args[0].replace(/%[a-zA-Z%]/g, (match)=>{
        if (match === "%%") return;
        index++;
        if (match === "%c") // We only are interested in the *last* %c
        // (the user may have provided their own)
        lastC = index;
    });
    args.splice(lastC, 0, c);
}
/**
 * Invokes `console.debug()` when available.
 * No-op when `console.debug` is not a "function".
 * If `console.debug` is not available, falls back
 * to `console.log`.
 *
 * @api public
 */ exports.log = console.debug || console.log || (()=>{});
/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */ function save(namespaces) {
    try {
        if (namespaces) exports.storage.setItem("debug", namespaces);
        else exports.storage.removeItem("debug");
    } catch (error) {
    // Swallow
    // XXX (@Qix-) should we be logging these?
    }
}
/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */ function load() {
    let r;
    try {
        r = exports.storage.getItem("debug");
    } catch (error) {
    // Swallow
    // XXX (@Qix-) should we be logging these?
    }
    // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
    if (!r && typeof $hPtJY !== "undefined" && "env" in $hPtJY) r = undefined;
    return r;
}
/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */ function localstorage() {
    try {
        // TVMLKit (Apple TV JS Runtime) does not have a window object, just localStorage in the global context
        // The Browser also has localStorage in the global context.
        return localStorage;
    } catch (error) {
    // Swallow
    // XXX (@Qix-) should we be logging these?
    }
}

module.exports = (parcelRequire("7kBR8"))(exports);
const { formatters } = module.exports;
/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */ formatters.j = function(v) {
    try {
        return JSON.stringify(v);
    } catch (error) {
        return "[UnexpectedJSONParseError]: " + error.message;
    }
};

});
parcelRegister("hPtJY", function(module, exports) {
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = "browser";
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ""; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return "/";
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};

});

parcelRegister("7kBR8", function(module, exports) {
/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 */ 
function $5567c417bf6247fd$var$setup(env) {
    createDebug.debug = createDebug;
    createDebug.default = createDebug;
    createDebug.coerce = coerce;
    createDebug.disable = disable;
    createDebug.enable = enable;
    createDebug.enabled = enabled;
    createDebug.humanize = (parcelRequire("3pRq5"));
    createDebug.destroy = destroy;
    Object.keys(env).forEach((key)=>{
        createDebug[key] = env[key];
    });
    /**
	* The currently active debug mode names, and names to skip.
	*/ createDebug.names = [];
    createDebug.skips = [];
    /**
	* Map of special "%n" handling functions, for the debug "format" argument.
	*
	* Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
	*/ createDebug.formatters = {};
    /**
	* Selects a color for a debug namespace
	* @param {String} namespace The namespace string for the debug instance to be colored
	* @return {Number|String} An ANSI color code for the given namespace
	* @api private
	*/ function selectColor(namespace) {
        let hash = 0;
        for(let i = 0; i < namespace.length; i++){
            hash = (hash << 5) - hash + namespace.charCodeAt(i);
            hash |= 0; // Convert to 32bit integer
        }
        return createDebug.colors[Math.abs(hash) % createDebug.colors.length];
    }
    createDebug.selectColor = selectColor;
    /**
	* Create a debugger with the given `namespace`.
	*
	* @param {String} namespace
	* @return {Function}
	* @api public
	*/ function createDebug(namespace) {
        let prevTime;
        let enableOverride = null;
        let namespacesCache;
        let enabledCache;
        function debug(...args) {
            // Disabled?
            if (!debug.enabled) return;
            const self = debug;
            // Set `diff` timestamp
            const curr = Number(new Date());
            const ms = curr - (prevTime || curr);
            self.diff = ms;
            self.prev = prevTime;
            self.curr = curr;
            prevTime = curr;
            args[0] = createDebug.coerce(args[0]);
            if (typeof args[0] !== "string") // Anything else let's inspect with %O
            args.unshift("%O");
            // Apply any `formatters` transformations
            let index = 0;
            args[0] = args[0].replace(/%([a-zA-Z%])/g, (match, format)=>{
                // If we encounter an escaped % then don't increase the array index
                if (match === "%%") return "%";
                index++;
                const formatter = createDebug.formatters[format];
                if (typeof formatter === "function") {
                    const val = args[index];
                    match = formatter.call(self, val);
                    // Now we need to remove `args[index]` since it's inlined in the `format`
                    args.splice(index, 1);
                    index--;
                }
                return match;
            });
            // Apply env-specific formatting (colors, etc.)
            createDebug.formatArgs.call(self, args);
            const logFn = self.log || createDebug.log;
            logFn.apply(self, args);
        }
        debug.namespace = namespace;
        debug.useColors = createDebug.useColors();
        debug.color = createDebug.selectColor(namespace);
        debug.extend = extend;
        debug.destroy = createDebug.destroy; // XXX Temporary. Will be removed in the next major release.
        Object.defineProperty(debug, "enabled", {
            enumerable: true,
            configurable: false,
            get: ()=>{
                if (enableOverride !== null) return enableOverride;
                if (namespacesCache !== createDebug.namespaces) {
                    namespacesCache = createDebug.namespaces;
                    enabledCache = createDebug.enabled(namespace);
                }
                return enabledCache;
            },
            set: (v)=>{
                enableOverride = v;
            }
        });
        // Env-specific initialization logic for debug instances
        if (typeof createDebug.init === "function") createDebug.init(debug);
        return debug;
    }
    function extend(namespace, delimiter) {
        const newDebug = createDebug(this.namespace + (typeof delimiter === "undefined" ? ":" : delimiter) + namespace);
        newDebug.log = this.log;
        return newDebug;
    }
    /**
	* Enables a debug mode by namespaces. This can include modes
	* separated by a colon and wildcards.
	*
	* @param {String} namespaces
	* @api public
	*/ function enable(namespaces) {
        createDebug.save(namespaces);
        createDebug.namespaces = namespaces;
        createDebug.names = [];
        createDebug.skips = [];
        let i;
        const split = (typeof namespaces === "string" ? namespaces : "").split(/[\s,]+/);
        const len = split.length;
        for(i = 0; i < len; i++){
            if (!split[i]) continue;
            namespaces = split[i].replace(/\*/g, ".*?");
            if (namespaces[0] === "-") createDebug.skips.push(new RegExp("^" + namespaces.slice(1) + "$"));
            else createDebug.names.push(new RegExp("^" + namespaces + "$"));
        }
    }
    /**
	* Disable debug output.
	*
	* @return {String} namespaces
	* @api public
	*/ function disable() {
        const namespaces = [
            ...createDebug.names.map(toNamespace),
            ...createDebug.skips.map(toNamespace).map((namespace)=>"-" + namespace)
        ].join(",");
        createDebug.enable("");
        return namespaces;
    }
    /**
	* Returns true if the given mode name is enabled, false otherwise.
	*
	* @param {String} name
	* @return {Boolean}
	* @api public
	*/ function enabled(name) {
        if (name[name.length - 1] === "*") return true;
        let i;
        let len;
        for(i = 0, len = createDebug.skips.length; i < len; i++){
            if (createDebug.skips[i].test(name)) return false;
        }
        for(i = 0, len = createDebug.names.length; i < len; i++){
            if (createDebug.names[i].test(name)) return true;
        }
        return false;
    }
    /**
	* Convert regexp to namespace
	*
	* @param {RegExp} regxep
	* @return {String} namespace
	* @api private
	*/ function toNamespace(regexp) {
        return regexp.toString().substring(2, regexp.toString().length - 2).replace(/\.\*\?$/, "*");
    }
    /**
	* Coerce `val`.
	*
	* @param {Mixed} val
	* @return {Mixed}
	* @api private
	*/ function coerce(val) {
        if (val instanceof Error) return val.stack || val.message;
        return val;
    }
    /**
	* XXX DO NOT USE. This is a temporary stub function.
	* XXX It WILL be removed in the next major release.
	*/ function destroy() {
        console.warn("Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.");
    }
    createDebug.enable(createDebug.load());
    return createDebug;
}
module.exports = $5567c417bf6247fd$var$setup;

});
parcelRegister("3pRq5", function(module, exports) {
/**
 * Helpers.
 */ var $27cd24efd2f930b8$var$s = 1000;
var $27cd24efd2f930b8$var$m = $27cd24efd2f930b8$var$s * 60;
var $27cd24efd2f930b8$var$h = $27cd24efd2f930b8$var$m * 60;
var $27cd24efd2f930b8$var$d = $27cd24efd2f930b8$var$h * 24;
var $27cd24efd2f930b8$var$w = $27cd24efd2f930b8$var$d * 7;
var $27cd24efd2f930b8$var$y = $27cd24efd2f930b8$var$d * 365.25;
/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */ module.exports = function(val, options) {
    options = options || {};
    var type = typeof val;
    if (type === "string" && val.length > 0) return $27cd24efd2f930b8$var$parse(val);
    else if (type === "number" && isFinite(val)) return options.long ? $27cd24efd2f930b8$var$fmtLong(val) : $27cd24efd2f930b8$var$fmtShort(val);
    throw new Error("val is not a non-empty string or a valid number. val=" + JSON.stringify(val));
};
/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */ function $27cd24efd2f930b8$var$parse(str) {
    str = String(str);
    if (str.length > 100) return;
    var match = /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(str);
    if (!match) return;
    var n = parseFloat(match[1]);
    var type = (match[2] || "ms").toLowerCase();
    switch(type){
        case "years":
        case "year":
        case "yrs":
        case "yr":
        case "y":
            return n * $27cd24efd2f930b8$var$y;
        case "weeks":
        case "week":
        case "w":
            return n * $27cd24efd2f930b8$var$w;
        case "days":
        case "day":
        case "d":
            return n * $27cd24efd2f930b8$var$d;
        case "hours":
        case "hour":
        case "hrs":
        case "hr":
        case "h":
            return n * $27cd24efd2f930b8$var$h;
        case "minutes":
        case "minute":
        case "mins":
        case "min":
        case "m":
            return n * $27cd24efd2f930b8$var$m;
        case "seconds":
        case "second":
        case "secs":
        case "sec":
        case "s":
            return n * $27cd24efd2f930b8$var$s;
        case "milliseconds":
        case "millisecond":
        case "msecs":
        case "msec":
        case "ms":
            return n;
        default:
            return undefined;
    }
}
/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */ function $27cd24efd2f930b8$var$fmtShort(ms) {
    var msAbs = Math.abs(ms);
    if (msAbs >= $27cd24efd2f930b8$var$d) return Math.round(ms / $27cd24efd2f930b8$var$d) + "d";
    if (msAbs >= $27cd24efd2f930b8$var$h) return Math.round(ms / $27cd24efd2f930b8$var$h) + "h";
    if (msAbs >= $27cd24efd2f930b8$var$m) return Math.round(ms / $27cd24efd2f930b8$var$m) + "m";
    if (msAbs >= $27cd24efd2f930b8$var$s) return Math.round(ms / $27cd24efd2f930b8$var$s) + "s";
    return ms + "ms";
}
/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */ function $27cd24efd2f930b8$var$fmtLong(ms) {
    var msAbs = Math.abs(ms);
    if (msAbs >= $27cd24efd2f930b8$var$d) return $27cd24efd2f930b8$var$plural(ms, msAbs, $27cd24efd2f930b8$var$d, "day");
    if (msAbs >= $27cd24efd2f930b8$var$h) return $27cd24efd2f930b8$var$plural(ms, msAbs, $27cd24efd2f930b8$var$h, "hour");
    if (msAbs >= $27cd24efd2f930b8$var$m) return $27cd24efd2f930b8$var$plural(ms, msAbs, $27cd24efd2f930b8$var$m, "minute");
    if (msAbs >= $27cd24efd2f930b8$var$s) return $27cd24efd2f930b8$var$plural(ms, msAbs, $27cd24efd2f930b8$var$s, "second");
    return ms + " ms";
}
/**
 * Pluralization helper.
 */ function $27cd24efd2f930b8$var$plural(ms, msAbs, n, name) {
    var isPlural = msAbs >= n * 1.5;
    return Math.round(ms / n) + " " + name + (isPlural ? "s" : "");
}

});



parcelRegister("1XRCD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1wTd0 = parcelRequire("1wTd0");

var $aHxeO = parcelRequire("aHxeO");

var $2n0Pa = parcelRequire("2n0Pa");

var $cca03 = parcelRequire("cca03");

var $ardUq = parcelRequire("ardUq");
var $16e4e55eb84231a9$var$t = $ardUq;

var $ClGPh = parcelRequire("ClGPh");

var $9OeKS = parcelRequire("9OeKS");
const { NOT_LOCAL_BINDING: $16e4e55eb84231a9$var$NOT_LOCAL_BINDING, callExpression: $16e4e55eb84231a9$var$callExpression, cloneNode: $16e4e55eb84231a9$var$cloneNode, getBindingIdentifiers: $16e4e55eb84231a9$var$getBindingIdentifiers, identifier: $16e4e55eb84231a9$var$identifier, isArrayExpression: $16e4e55eb84231a9$var$isArrayExpression, isBinary: $16e4e55eb84231a9$var$isBinary, isCallExpression: $16e4e55eb84231a9$var$isCallExpression, isClass: $16e4e55eb84231a9$var$isClass, isClassBody: $16e4e55eb84231a9$var$isClassBody, isClassDeclaration: $16e4e55eb84231a9$var$isClassDeclaration, isExportAllDeclaration: $16e4e55eb84231a9$var$isExportAllDeclaration, isExportDefaultDeclaration: $16e4e55eb84231a9$var$isExportDefaultDeclaration, isExportNamedDeclaration: $16e4e55eb84231a9$var$isExportNamedDeclaration, isFunctionDeclaration: $16e4e55eb84231a9$var$isFunctionDeclaration, isIdentifier: $16e4e55eb84231a9$var$isIdentifier, isImportDeclaration: $16e4e55eb84231a9$var$isImportDeclaration, isLiteral: $16e4e55eb84231a9$var$isLiteral, isMemberExpression: $16e4e55eb84231a9$var$isMemberExpression, isMethod: $16e4e55eb84231a9$var$isMethod, isModuleSpecifier: $16e4e55eb84231a9$var$isModuleSpecifier, isNullLiteral: $16e4e55eb84231a9$var$isNullLiteral, isObjectExpression: $16e4e55eb84231a9$var$isObjectExpression, isProperty: $16e4e55eb84231a9$var$isProperty, isPureish: $16e4e55eb84231a9$var$isPureish, isRegExpLiteral: $16e4e55eb84231a9$var$isRegExpLiteral, isSuper: $16e4e55eb84231a9$var$isSuper, isTaggedTemplateExpression: $16e4e55eb84231a9$var$isTaggedTemplateExpression, isTemplateLiteral: $16e4e55eb84231a9$var$isTemplateLiteral, isThisExpression: $16e4e55eb84231a9$var$isThisExpression, isUnaryExpression: $16e4e55eb84231a9$var$isUnaryExpression, isVariableDeclaration: $16e4e55eb84231a9$var$isVariableDeclaration, matchesPattern: $16e4e55eb84231a9$var$matchesPattern, memberExpression: $16e4e55eb84231a9$var$memberExpression, numericLiteral: $16e4e55eb84231a9$var$numericLiteral, toIdentifier: $16e4e55eb84231a9$var$toIdentifier, variableDeclaration: $16e4e55eb84231a9$var$variableDeclaration, variableDeclarator: $16e4e55eb84231a9$var$variableDeclarator, isRecordExpression: $16e4e55eb84231a9$var$isRecordExpression, isTupleExpression: $16e4e55eb84231a9$var$isTupleExpression, isObjectProperty: $16e4e55eb84231a9$var$isObjectProperty, isTopicReference: $16e4e55eb84231a9$var$isTopicReference, isMetaProperty: $16e4e55eb84231a9$var$isMetaProperty, isPrivateName: $16e4e55eb84231a9$var$isPrivateName, isExportDeclaration: $16e4e55eb84231a9$var$isExportDeclaration, buildUndefinedNode: $16e4e55eb84231a9$var$buildUndefinedNode } = $ardUq;
function $16e4e55eb84231a9$var$gatherNodeParts(node, parts) {
    switch(node == null ? void 0 : node.type){
        default:
            if ($16e4e55eb84231a9$var$isImportDeclaration(node) || $16e4e55eb84231a9$var$isExportDeclaration(node)) {
                var _node$specifiers;
                if (($16e4e55eb84231a9$var$isExportAllDeclaration(node) || $16e4e55eb84231a9$var$isExportNamedDeclaration(node) || $16e4e55eb84231a9$var$isImportDeclaration(node)) && node.source) $16e4e55eb84231a9$var$gatherNodeParts(node.source, parts);
                else if (($16e4e55eb84231a9$var$isExportNamedDeclaration(node) || $16e4e55eb84231a9$var$isImportDeclaration(node)) && (_node$specifiers = node.specifiers) != null && _node$specifiers.length) for (const e of node.specifiers)$16e4e55eb84231a9$var$gatherNodeParts(e, parts);
                else if (($16e4e55eb84231a9$var$isExportDefaultDeclaration(node) || $16e4e55eb84231a9$var$isExportNamedDeclaration(node)) && node.declaration) $16e4e55eb84231a9$var$gatherNodeParts(node.declaration, parts);
            } else if ($16e4e55eb84231a9$var$isModuleSpecifier(node)) $16e4e55eb84231a9$var$gatherNodeParts(node.local, parts);
            else if ($16e4e55eb84231a9$var$isLiteral(node) && !$16e4e55eb84231a9$var$isNullLiteral(node) && !$16e4e55eb84231a9$var$isRegExpLiteral(node) && !$16e4e55eb84231a9$var$isTemplateLiteral(node)) parts.push(node.value);
            break;
        case "MemberExpression":
        case "OptionalMemberExpression":
        case "JSXMemberExpression":
            $16e4e55eb84231a9$var$gatherNodeParts(node.object, parts);
            $16e4e55eb84231a9$var$gatherNodeParts(node.property, parts);
            break;
        case "Identifier":
        case "JSXIdentifier":
            parts.push(node.name);
            break;
        case "CallExpression":
        case "OptionalCallExpression":
        case "NewExpression":
            $16e4e55eb84231a9$var$gatherNodeParts(node.callee, parts);
            break;
        case "ObjectExpression":
        case "ObjectPattern":
            for (const e of node.properties)$16e4e55eb84231a9$var$gatherNodeParts(e, parts);
            break;
        case "SpreadElement":
        case "RestElement":
            $16e4e55eb84231a9$var$gatherNodeParts(node.argument, parts);
            break;
        case "ObjectProperty":
        case "ObjectMethod":
        case "ClassProperty":
        case "ClassMethod":
        case "ClassPrivateProperty":
        case "ClassPrivateMethod":
            $16e4e55eb84231a9$var$gatherNodeParts(node.key, parts);
            break;
        case "ThisExpression":
            parts.push("this");
            break;
        case "Super":
            parts.push("super");
            break;
        case "Import":
            parts.push("import");
            break;
        case "DoExpression":
            parts.push("do");
            break;
        case "YieldExpression":
            parts.push("yield");
            $16e4e55eb84231a9$var$gatherNodeParts(node.argument, parts);
            break;
        case "AwaitExpression":
            parts.push("await");
            $16e4e55eb84231a9$var$gatherNodeParts(node.argument, parts);
            break;
        case "AssignmentExpression":
            $16e4e55eb84231a9$var$gatherNodeParts(node.left, parts);
            break;
        case "VariableDeclarator":
            $16e4e55eb84231a9$var$gatherNodeParts(node.id, parts);
            break;
        case "FunctionExpression":
        case "FunctionDeclaration":
        case "ClassExpression":
        case "ClassDeclaration":
            $16e4e55eb84231a9$var$gatherNodeParts(node.id, parts);
            break;
        case "PrivateName":
            $16e4e55eb84231a9$var$gatherNodeParts(node.id, parts);
            break;
        case "ParenthesizedExpression":
            $16e4e55eb84231a9$var$gatherNodeParts(node.expression, parts);
            break;
        case "UnaryExpression":
        case "UpdateExpression":
            $16e4e55eb84231a9$var$gatherNodeParts(node.argument, parts);
            break;
        case "MetaProperty":
            $16e4e55eb84231a9$var$gatherNodeParts(node.meta, parts);
            $16e4e55eb84231a9$var$gatherNodeParts(node.property, parts);
            break;
        case "JSXElement":
            $16e4e55eb84231a9$var$gatherNodeParts(node.openingElement, parts);
            break;
        case "JSXOpeningElement":
            $16e4e55eb84231a9$var$gatherNodeParts(node.name, parts);
            break;
        case "JSXFragment":
            $16e4e55eb84231a9$var$gatherNodeParts(node.openingFragment, parts);
            break;
        case "JSXOpeningFragment":
            parts.push("Fragment");
            break;
        case "JSXNamespacedName":
            $16e4e55eb84231a9$var$gatherNodeParts(node.namespace, parts);
            $16e4e55eb84231a9$var$gatherNodeParts(node.name, parts);
            break;
    }
}
const $16e4e55eb84231a9$var$collectorVisitor = {
    ForStatement (path) {
        const declar = path.get("init");
        if (declar.isVar()) {
            const { scope: scope } = path;
            const parentScope = scope.getFunctionParent() || scope.getProgramParent();
            parentScope.registerBinding("var", declar);
        }
    },
    Declaration (path) {
        if (path.isBlockScoped()) return;
        if (path.isImportDeclaration()) return;
        if (path.isExportDeclaration()) return;
        const parent = path.scope.getFunctionParent() || path.scope.getProgramParent();
        parent.registerDeclaration(path);
    },
    ImportDeclaration (path) {
        const parent = path.scope.getBlockParent();
        parent.registerDeclaration(path);
    },
    ReferencedIdentifier (path, state) {
        state.references.push(path);
    },
    ForXStatement (path, state) {
        const left = path.get("left");
        if (left.isPattern() || left.isIdentifier()) state.constantViolations.push(path);
        else if (left.isVar()) {
            const { scope: scope } = path;
            const parentScope = scope.getFunctionParent() || scope.getProgramParent();
            parentScope.registerBinding("var", left);
        }
    },
    ExportDeclaration: {
        exit (path) {
            const { node: node, scope: scope } = path;
            if ($16e4e55eb84231a9$var$isExportAllDeclaration(node)) return;
            const declar = node.declaration;
            if ($16e4e55eb84231a9$var$isClassDeclaration(declar) || $16e4e55eb84231a9$var$isFunctionDeclaration(declar)) {
                const id = declar.id;
                if (!id) return;
                const binding = scope.getBinding(id.name);
                binding == null || binding.reference(path);
            } else if ($16e4e55eb84231a9$var$isVariableDeclaration(declar)) {
                for (const decl of declar.declarations)for (const name of Object.keys($16e4e55eb84231a9$var$getBindingIdentifiers(decl))){
                    const binding = scope.getBinding(name);
                    binding == null || binding.reference(path);
                }
            }
        }
    },
    LabeledStatement (path) {
        path.scope.getBlockParent().registerDeclaration(path);
    },
    AssignmentExpression (path, state) {
        state.assignments.push(path);
    },
    UpdateExpression (path, state) {
        state.constantViolations.push(path);
    },
    UnaryExpression (path, state) {
        if (path.node.operator === "delete") state.constantViolations.push(path);
    },
    BlockScoped (path) {
        let scope = path.scope;
        if (scope.path === path) scope = scope.parent;
        const parent = scope.getBlockParent();
        parent.registerDeclaration(path);
        if (path.isClassDeclaration() && path.node.id) {
            const id = path.node.id;
            const name = id.name;
            path.scope.bindings[name] = path.scope.parent.getBinding(name);
        }
    },
    CatchClause (path) {
        path.scope.registerBinding("let", path);
    },
    Function (path) {
        const params = path.get("params");
        for (const param of params)path.scope.registerBinding("param", param);
        if (path.isFunctionExpression() && path.has("id") && !path.get("id").node[$16e4e55eb84231a9$var$NOT_LOCAL_BINDING]) path.scope.registerBinding("local", path.get("id"), path);
    },
    ClassExpression (path) {
        if (path.has("id") && !path.get("id").node[$16e4e55eb84231a9$var$NOT_LOCAL_BINDING]) path.scope.registerBinding("local", path);
    }
};
let $16e4e55eb84231a9$var$uid = 0;
class $16e4e55eb84231a9$var$Scope {
    constructor(path){
        this.uid = void 0;
        this.path = void 0;
        this.block = void 0;
        this.labels = void 0;
        this.inited = void 0;
        this.bindings = void 0;
        this.references = void 0;
        this.globals = void 0;
        this.uids = void 0;
        this.data = void 0;
        this.crawling = void 0;
        const { node: node } = path;
        const cached = $ClGPh.scope.get(node);
        if ((cached == null ? void 0 : cached.path) === path) return cached;
        $ClGPh.scope.set(node, this);
        this.uid = $16e4e55eb84231a9$var$uid++;
        this.block = node;
        this.path = path;
        this.labels = new Map();
        this.inited = false;
    }
    get parent() {
        var _parent;
        let parent, path = this.path;
        do {
            const shouldSkip = path.key === "key" || path.listKey === "decorators";
            path = path.parentPath;
            if (shouldSkip && path.isMethod()) path = path.parentPath;
            if (path && path.isScope()) parent = path;
        }while (path && !parent);
        return (_parent = parent) == null ? void 0 : _parent.scope;
    }
    get parentBlock() {
        return this.path.parent;
    }
    get hub() {
        return this.path.hub;
    }
    traverse(node, opts, state) {
        (0, $aHxeO.default)(node, opts, this, state, this.path);
    }
    generateDeclaredUidIdentifier(name) {
        const id = this.generateUidIdentifier(name);
        this.push({
            id: id
        });
        return $16e4e55eb84231a9$var$cloneNode(id);
    }
    generateUidIdentifier(name) {
        return $16e4e55eb84231a9$var$identifier(this.generateUid(name));
    }
    generateUid(name = "temp") {
        name = $16e4e55eb84231a9$var$toIdentifier(name).replace(/^_+/, "").replace(/[0-9]+$/g, "");
        let uid;
        let i = 1;
        do {
            uid = this._generateUid(name, i);
            i++;
        }while (this.hasLabel(uid) || this.hasBinding(uid) || this.hasGlobal(uid) || this.hasReference(uid));
        const program = this.getProgramParent();
        program.references[uid] = true;
        program.uids[uid] = true;
        return uid;
    }
    _generateUid(name, i) {
        let id = name;
        if (i > 1) id += i;
        return `_${id}`;
    }
    generateUidBasedOnNode(node, defaultName) {
        const parts = [];
        $16e4e55eb84231a9$var$gatherNodeParts(node, parts);
        let id = parts.join("$");
        id = id.replace(/^_/, "") || defaultName || "ref";
        return this.generateUid(id.slice(0, 20));
    }
    generateUidIdentifierBasedOnNode(node, defaultName) {
        return $16e4e55eb84231a9$var$identifier(this.generateUidBasedOnNode(node, defaultName));
    }
    isStatic(node) {
        if ($16e4e55eb84231a9$var$isThisExpression(node) || $16e4e55eb84231a9$var$isSuper(node) || $16e4e55eb84231a9$var$isTopicReference(node)) return true;
        if ($16e4e55eb84231a9$var$isIdentifier(node)) {
            const binding = this.getBinding(node.name);
            if (binding) return binding.constant;
            else return this.hasBinding(node.name);
        }
        return false;
    }
    maybeGenerateMemoised(node, dontPush) {
        if (this.isStatic(node)) return null;
        else {
            const id = this.generateUidIdentifierBasedOnNode(node);
            if (!dontPush) {
                this.push({
                    id: id
                });
                return $16e4e55eb84231a9$var$cloneNode(id);
            }
            return id;
        }
    }
    checkBlockScopedCollisions(local, kind, name, id) {
        if (kind === "param") return;
        if (local.kind === "local") return;
        const duplicate = kind === "let" || local.kind === "let" || local.kind === "const" || local.kind === "module" || local.kind === "param" && kind === "const";
        if (duplicate) throw this.hub.buildError(id, `Duplicate declaration "${name}"`, TypeError);
    }
    rename(oldName, newName) {
        const binding = this.getBinding(oldName);
        if (binding) {
            newName || (newName = this.generateUidIdentifier(oldName).name);
            const renamer = new $1wTd0.default(binding, oldName, newName);
            renamer.rename(arguments[2]);
        }
    }
    _renameFromMap(map, oldName, newName, value) {
        if (map[oldName]) {
            map[newName] = value;
            map[oldName] = null;
        }
    }
    dump() {
        const sep = "-".repeat(60);
        console.log(sep);
        let scope = this;
        do {
            console.log("#", scope.block.type);
            for (const name of Object.keys(scope.bindings)){
                const binding = scope.bindings[name];
                console.log(" -", name, {
                    constant: binding.constant,
                    references: binding.references,
                    violations: binding.constantViolations.length,
                    kind: binding.kind
                });
            }
        }while (scope = scope.parent);
        console.log(sep);
    }
    toArray(node, i, arrayLikeIsIterable) {
        if ($16e4e55eb84231a9$var$isIdentifier(node)) {
            const binding = this.getBinding(node.name);
            if (binding != null && binding.constant && binding.path.isGenericType("Array")) return node;
        }
        if ($16e4e55eb84231a9$var$isArrayExpression(node)) return node;
        if ($16e4e55eb84231a9$var$isIdentifier(node, {
            name: "arguments"
        })) return $16e4e55eb84231a9$var$callExpression($16e4e55eb84231a9$var$memberExpression($16e4e55eb84231a9$var$memberExpression($16e4e55eb84231a9$var$memberExpression($16e4e55eb84231a9$var$identifier("Array"), $16e4e55eb84231a9$var$identifier("prototype")), $16e4e55eb84231a9$var$identifier("slice")), $16e4e55eb84231a9$var$identifier("call")), [
            node
        ]);
        let helperName;
        const args = [
            node
        ];
        if (i === true) helperName = "toConsumableArray";
        else if (typeof i === "number") {
            args.push($16e4e55eb84231a9$var$numericLiteral(i));
            helperName = "slicedToArray";
        } else helperName = "toArray";
        if (arrayLikeIsIterable) {
            args.unshift(this.hub.addHelper(helperName));
            helperName = "maybeArrayLike";
        }
        return $16e4e55eb84231a9$var$callExpression(this.hub.addHelper(helperName), args);
    }
    hasLabel(name) {
        return !!this.getLabel(name);
    }
    getLabel(name) {
        return this.labels.get(name);
    }
    registerLabel(path) {
        this.labels.set(path.node.label.name, path);
    }
    registerDeclaration(path) {
        if (path.isLabeledStatement()) this.registerLabel(path);
        else if (path.isFunctionDeclaration()) this.registerBinding("hoisted", path.get("id"), path);
        else if (path.isVariableDeclaration()) {
            const declarations = path.get("declarations");
            const { kind: kind } = path.node;
            for (const declar of declarations)this.registerBinding(kind === "using" || kind === "await using" ? "const" : kind, declar);
        } else if (path.isClassDeclaration()) {
            if (path.node.declare) return;
            this.registerBinding("let", path);
        } else if (path.isImportDeclaration()) {
            const isTypeDeclaration = path.node.importKind === "type" || path.node.importKind === "typeof";
            const specifiers = path.get("specifiers");
            for (const specifier of specifiers){
                const isTypeSpecifier = isTypeDeclaration || specifier.isImportSpecifier() && (specifier.node.importKind === "type" || specifier.node.importKind === "typeof");
                this.registerBinding(isTypeSpecifier ? "unknown" : "module", specifier);
            }
        } else if (path.isExportDeclaration()) {
            const declar = path.get("declaration");
            if (declar.isClassDeclaration() || declar.isFunctionDeclaration() || declar.isVariableDeclaration()) this.registerDeclaration(declar);
        } else this.registerBinding("unknown", path);
    }
    buildUndefinedNode() {
        return $16e4e55eb84231a9$var$buildUndefinedNode();
    }
    registerConstantViolation(path) {
        const ids = path.getBindingIdentifiers();
        for (const name of Object.keys(ids)){
            var _this$getBinding;
            (_this$getBinding = this.getBinding(name)) == null || _this$getBinding.reassign(path);
        }
    }
    registerBinding(kind, path, bindingPath = path) {
        if (!kind) throw new ReferenceError("no `kind`");
        if (path.isVariableDeclaration()) {
            const declarators = path.get("declarations");
            for (const declar of declarators)this.registerBinding(kind, declar);
            return;
        }
        const parent = this.getProgramParent();
        const ids = path.getOuterBindingIdentifiers(true);
        for (const name of Object.keys(ids)){
            parent.references[name] = true;
            for (const id of ids[name]){
                const local = this.getOwnBinding(name);
                if (local) {
                    if (local.identifier === id) continue;
                    this.checkBlockScopedCollisions(local, kind, name, id);
                }
                if (local) this.registerConstantViolation(bindingPath);
                else this.bindings[name] = new $2n0Pa.default({
                    identifier: id,
                    scope: this,
                    path: bindingPath,
                    kind: kind
                });
            }
        }
    }
    addGlobal(node) {
        this.globals[node.name] = node;
    }
    hasUid(name) {
        let scope = this;
        do {
            if (scope.uids[name]) return true;
        }while (scope = scope.parent);
        return false;
    }
    hasGlobal(name) {
        let scope = this;
        do {
            if (scope.globals[name]) return true;
        }while (scope = scope.parent);
        return false;
    }
    hasReference(name) {
        return !!this.getProgramParent().references[name];
    }
    isPure(node, constantsOnly) {
        if ($16e4e55eb84231a9$var$isIdentifier(node)) {
            const binding = this.getBinding(node.name);
            if (!binding) return false;
            if (constantsOnly) return binding.constant;
            return true;
        } else if ($16e4e55eb84231a9$var$isThisExpression(node) || $16e4e55eb84231a9$var$isMetaProperty(node) || $16e4e55eb84231a9$var$isTopicReference(node) || $16e4e55eb84231a9$var$isPrivateName(node)) return true;
        else if ($16e4e55eb84231a9$var$isClass(node)) {
            var _node$decorators;
            if (node.superClass && !this.isPure(node.superClass, constantsOnly)) return false;
            if (((_node$decorators = node.decorators) == null ? void 0 : _node$decorators.length) > 0) return false;
            return this.isPure(node.body, constantsOnly);
        } else if ($16e4e55eb84231a9$var$isClassBody(node)) {
            for (const method of node.body){
                if (!this.isPure(method, constantsOnly)) return false;
            }
            return true;
        } else if ($16e4e55eb84231a9$var$isBinary(node)) return this.isPure(node.left, constantsOnly) && this.isPure(node.right, constantsOnly);
        else if ($16e4e55eb84231a9$var$isArrayExpression(node) || $16e4e55eb84231a9$var$isTupleExpression(node)) {
            for (const elem of node.elements){
                if (elem !== null && !this.isPure(elem, constantsOnly)) return false;
            }
            return true;
        } else if ($16e4e55eb84231a9$var$isObjectExpression(node) || $16e4e55eb84231a9$var$isRecordExpression(node)) {
            for (const prop of node.properties){
                if (!this.isPure(prop, constantsOnly)) return false;
            }
            return true;
        } else if ($16e4e55eb84231a9$var$isMethod(node)) {
            var _node$decorators2;
            if (node.computed && !this.isPure(node.key, constantsOnly)) return false;
            if (((_node$decorators2 = node.decorators) == null ? void 0 : _node$decorators2.length) > 0) return false;
            return true;
        } else if ($16e4e55eb84231a9$var$isProperty(node)) {
            var _node$decorators3;
            if (node.computed && !this.isPure(node.key, constantsOnly)) return false;
            if (((_node$decorators3 = node.decorators) == null ? void 0 : _node$decorators3.length) > 0) return false;
            if ($16e4e55eb84231a9$var$isObjectProperty(node) || node.static) {
                if (node.value !== null && !this.isPure(node.value, constantsOnly)) return false;
            }
            return true;
        } else if ($16e4e55eb84231a9$var$isUnaryExpression(node)) return this.isPure(node.argument, constantsOnly);
        else if ($16e4e55eb84231a9$var$isTemplateLiteral(node)) {
            for (const expression of node.expressions){
                if (!this.isPure(expression, constantsOnly)) return false;
            }
            return true;
        } else if ($16e4e55eb84231a9$var$isTaggedTemplateExpression(node)) return $16e4e55eb84231a9$var$matchesPattern(node.tag, "String.raw") && !this.hasBinding("String", {
            noGlobals: true
        }) && this.isPure(node.quasi, constantsOnly);
        else if ($16e4e55eb84231a9$var$isMemberExpression(node)) return !node.computed && $16e4e55eb84231a9$var$isIdentifier(node.object) && node.object.name === "Symbol" && $16e4e55eb84231a9$var$isIdentifier(node.property) && node.property.name !== "for" && !this.hasBinding("Symbol", {
            noGlobals: true
        });
        else if ($16e4e55eb84231a9$var$isCallExpression(node)) return $16e4e55eb84231a9$var$matchesPattern(node.callee, "Symbol.for") && !this.hasBinding("Symbol", {
            noGlobals: true
        }) && node.arguments.length === 1 && $16e4e55eb84231a9$var$t.isStringLiteral(node.arguments[0]);
        else return $16e4e55eb84231a9$var$isPureish(node);
    }
    setData(key, val) {
        return this.data[key] = val;
    }
    getData(key) {
        let scope = this;
        do {
            const data = scope.data[key];
            if (data != null) return data;
        }while (scope = scope.parent);
    }
    removeData(key) {
        let scope = this;
        do {
            const data = scope.data[key];
            if (data != null) scope.data[key] = null;
        }while (scope = scope.parent);
    }
    init() {
        if (!this.inited) {
            this.inited = true;
            this.crawl();
        }
    }
    crawl() {
        const path = this.path;
        this.references = Object.create(null);
        this.bindings = Object.create(null);
        this.globals = Object.create(null);
        this.uids = Object.create(null);
        this.data = Object.create(null);
        const programParent = this.getProgramParent();
        if (programParent.crawling) return;
        const state = {
            references: [],
            constantViolations: [],
            assignments: []
        };
        this.crawling = true;
        if (path.type !== "Program" && (0, $9OeKS.isExplodedVisitor)($16e4e55eb84231a9$var$collectorVisitor)) {
            for (const visit of $16e4e55eb84231a9$var$collectorVisitor.enter)visit.call(state, path, state);
            const typeVisitors = $16e4e55eb84231a9$var$collectorVisitor[path.type];
            if (typeVisitors) for (const visit of typeVisitors.enter)visit.call(state, path, state);
        }
        path.traverse($16e4e55eb84231a9$var$collectorVisitor, state);
        this.crawling = false;
        for (const path of state.assignments){
            const ids = path.getBindingIdentifiers();
            for (const name of Object.keys(ids)){
                if (path.scope.getBinding(name)) continue;
                programParent.addGlobal(ids[name]);
            }
            path.scope.registerConstantViolation(path);
        }
        for (const ref of state.references){
            const binding = ref.scope.getBinding(ref.node.name);
            if (binding) binding.reference(ref);
            else programParent.addGlobal(ref.node);
        }
        for (const path of state.constantViolations)path.scope.registerConstantViolation(path);
    }
    push(opts) {
        let path = this.path;
        if (path.isPattern()) path = this.getPatternParent().path;
        else if (!path.isBlockStatement() && !path.isProgram()) path = this.getBlockParent().path;
        if (path.isSwitchStatement()) path = (this.getFunctionParent() || this.getProgramParent()).path;
        const { init: init, unique: unique, kind: kind = "var", id: id } = opts;
        if (!init && !unique && (kind === "var" || kind === "let") && path.isFunction() && !path.node.name && $16e4e55eb84231a9$var$isCallExpression(path.parent, {
            callee: path.node
        }) && path.parent.arguments.length <= path.node.params.length && $16e4e55eb84231a9$var$isIdentifier(id)) {
            path.pushContainer("params", id);
            path.scope.registerBinding("param", path.get("params")[path.node.params.length - 1]);
            return;
        }
        if (path.isLoop() || path.isCatchClause() || path.isFunction()) {
            path.ensureBlock();
            path = path.get("body");
        }
        const blockHoist = opts._blockHoist == null ? 2 : opts._blockHoist;
        const dataKey = `declaration:${kind}:${blockHoist}`;
        let declarPath = !unique && path.getData(dataKey);
        if (!declarPath) {
            const declar = $16e4e55eb84231a9$var$variableDeclaration(kind, []);
            declar._blockHoist = blockHoist;
            [declarPath] = path.unshiftContainer("body", [
                declar
            ]);
            if (!unique) path.setData(dataKey, declarPath);
        }
        const declarator = $16e4e55eb84231a9$var$variableDeclarator(id, init);
        const len = declarPath.node.declarations.push(declarator);
        path.scope.registerBinding(kind, declarPath.get("declarations")[len - 1]);
    }
    getProgramParent() {
        let scope = this;
        do {
            if (scope.path.isProgram()) return scope;
        }while (scope = scope.parent);
        throw new Error("Couldn't find a Program");
    }
    getFunctionParent() {
        let scope = this;
        do {
            if (scope.path.isFunctionParent()) return scope;
        }while (scope = scope.parent);
        return null;
    }
    getBlockParent() {
        let scope = this;
        do {
            if (scope.path.isBlockParent()) return scope;
        }while (scope = scope.parent);
        throw new Error("We couldn't find a BlockStatement, For, Switch, Function, Loop or Program...");
    }
    getPatternParent() {
        let scope = this;
        do {
            if (!scope.path.isPattern()) return scope.getBlockParent();
        }while (scope = scope.parent.parent);
        throw new Error("We couldn't find a BlockStatement, For, Switch, Function, Loop or Program...");
    }
    getAllBindings() {
        const ids = Object.create(null);
        let scope = this;
        do {
            for (const key of Object.keys(scope.bindings))if (key in ids === false) ids[key] = scope.bindings[key];
            scope = scope.parent;
        }while (scope);
        return ids;
    }
    getAllBindingsOfKind(...kinds) {
        const ids = Object.create(null);
        for (const kind of kinds){
            let scope = this;
            do {
                for (const name of Object.keys(scope.bindings)){
                    const binding = scope.bindings[name];
                    if (binding.kind === kind) ids[name] = binding;
                }
                scope = scope.parent;
            }while (scope);
        }
        return ids;
    }
    bindingIdentifierEquals(name, node) {
        return this.getBindingIdentifier(name) === node;
    }
    getBinding(name) {
        let scope = this;
        let previousPath;
        do {
            const binding = scope.getOwnBinding(name);
            if (binding) {
                var _previousPath;
                if ((_previousPath = previousPath) != null && _previousPath.isPattern() && binding.kind !== "param" && binding.kind !== "local") ;
                else return binding;
            } else if (!binding && name === "arguments" && scope.path.isFunction() && !scope.path.isArrowFunctionExpression()) break;
            previousPath = scope.path;
        }while (scope = scope.parent);
    }
    getOwnBinding(name) {
        return this.bindings[name];
    }
    getBindingIdentifier(name) {
        var _this$getBinding2;
        return (_this$getBinding2 = this.getBinding(name)) == null ? void 0 : _this$getBinding2.identifier;
    }
    getOwnBindingIdentifier(name) {
        const binding = this.bindings[name];
        return binding == null ? void 0 : binding.identifier;
    }
    hasOwnBinding(name) {
        return !!this.getOwnBinding(name);
    }
    hasBinding(name, opts) {
        var _opts, _opts2, _opts3;
        if (!name) return false;
        if (this.hasOwnBinding(name)) return true;
        if (typeof opts === "boolean") opts = {
            noGlobals: opts
        };
        if (this.parentHasBinding(name, opts)) return true;
        if (!((_opts = opts) != null && _opts.noUids) && this.hasUid(name)) return true;
        if (!((_opts2 = opts) != null && _opts2.noGlobals) && $16e4e55eb84231a9$var$Scope.globals.includes(name)) return true;
        if (!((_opts3 = opts) != null && _opts3.noGlobals) && $16e4e55eb84231a9$var$Scope.contextVariables.includes(name)) return true;
        return false;
    }
    parentHasBinding(name, opts) {
        var _this$parent;
        return (_this$parent = this.parent) == null ? void 0 : _this$parent.hasBinding(name, opts);
    }
    moveBindingTo(name, scope) {
        const info = this.getBinding(name);
        if (info) {
            info.scope.removeOwnBinding(name);
            info.scope = scope;
            scope.bindings[name] = info;
        }
    }
    removeOwnBinding(name) {
        delete this.bindings[name];
    }
    removeBinding(name) {
        var _this$getBinding3;
        (_this$getBinding3 = this.getBinding(name)) == null || _this$getBinding3.scope.removeOwnBinding(name);
        let scope = this;
        do if (scope.uids[name]) scope.uids[name] = false;
        while (scope = scope.parent);
    }
}
module.exports.default = $16e4e55eb84231a9$var$Scope;
$16e4e55eb84231a9$var$Scope.globals = Object.keys($cca03.builtin);
$16e4e55eb84231a9$var$Scope.contextVariables = [
    "arguments",
    "undefined",
    "Infinity",
    "NaN"
];

});
parcelRegister("1wTd0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $hBvI4 = parcelRequire("hBvI4");

var $ardUq = parcelRequire("ardUq");

var $elWuE = parcelRequire("elWuE");

var $k33SJ = parcelRequire("k33SJ");

var $9OeKS = parcelRequire("9OeKS");
const $11d39aed9843b4c4$var$renameVisitor = {
    ReferencedIdentifier ({ node: node }, state) {
        if (node.name === state.oldName) node.name = state.newName;
    },
    Scope (path, state) {
        if (!path.scope.bindingIdentifierEquals(state.oldName, state.binding.identifier)) {
            path.skip();
            if (path.isMethod()) (0, $elWuE.requeueComputedKeyAndDecorators)(path);
        }
    },
    ObjectProperty ({ node: node, scope: scope }, state) {
        const { name: name } = node.key;
        if (node.shorthand && (name === state.oldName || name === state.newName) && scope.getBindingIdentifier(name) === state.binding.identifier) {
            var _node$extra;
            node.shorthand = false;
            if ((_node$extra = node.extra) != null && _node$extra.shorthand) node.extra.shorthand = false;
        }
    },
    "AssignmentExpression|Declaration|VariableDeclarator" (path, state) {
        if (path.isVariableDeclaration()) return;
        const ids = path.getOuterBindingIdentifiers();
        for(const name in ids)if (name === state.oldName) ids[name].name = state.newName;
    }
};
class $11d39aed9843b4c4$var$Renamer {
    constructor(binding, oldName, newName){
        this.newName = newName;
        this.oldName = oldName;
        this.binding = binding;
    }
    maybeConvertFromExportDeclaration(parentDeclar) {
        const maybeExportDeclar = parentDeclar.parentPath;
        if (!maybeExportDeclar.isExportDeclaration()) return;
        if (maybeExportDeclar.isExportDefaultDeclaration()) {
            const { declaration: declaration } = maybeExportDeclar.node;
            if ($ardUq.isDeclaration(declaration) && !declaration.id) return;
        }
        if (maybeExportDeclar.isExportAllDeclaration()) return;
        (0, $hBvI4.default)(maybeExportDeclar);
    }
    maybeConvertFromClassFunctionDeclaration(path) {
        return path;
    }
    maybeConvertFromClassFunctionExpression(path) {
        return path;
    }
    rename() {
        const { binding: binding, oldName: oldName, newName: newName } = this;
        const { scope: scope, path: path } = binding;
        const parentDeclar = path.find((path)=>path.isDeclaration() || path.isFunctionExpression() || path.isClassExpression());
        if (parentDeclar) {
            const bindingIds = parentDeclar.getOuterBindingIdentifiers();
            if (bindingIds[oldName] === binding.identifier) this.maybeConvertFromExportDeclaration(parentDeclar);
        }
        const blockToTraverse = arguments[0] || scope.block;
        (0, $k33SJ.traverseNode)(blockToTraverse, (0, $9OeKS.explode)($11d39aed9843b4c4$var$renameVisitor), scope, this, scope.path, {
            discriminant: true
        });
        if (!arguments[0]) {
            scope.removeOwnBinding(oldName);
            scope.bindings[newName] = binding;
            this.binding.identifier.name = newName;
        }
        if (parentDeclar) {
            this.maybeConvertFromClassFunctionDeclaration(path);
            this.maybeConvertFromClassFunctionExpression(path);
        }
    }
}
module.exports.default = $11d39aed9843b4c4$var$Renamer;

});
parcelRegister("hBvI4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $cd0e7d4b66a3a3e2$var$splitExportDeclaration;

var $ardUq = parcelRequire("ardUq");
const { cloneNode: $cd0e7d4b66a3a3e2$var$cloneNode, exportNamedDeclaration: $cd0e7d4b66a3a3e2$var$exportNamedDeclaration, exportSpecifier: $cd0e7d4b66a3a3e2$var$exportSpecifier, identifier: $cd0e7d4b66a3a3e2$var$identifier, variableDeclaration: $cd0e7d4b66a3a3e2$var$variableDeclaration, variableDeclarator: $cd0e7d4b66a3a3e2$var$variableDeclarator } = $ardUq;
function $cd0e7d4b66a3a3e2$var$splitExportDeclaration(exportDeclaration) {
    if (!exportDeclaration.isExportDeclaration() || exportDeclaration.isExportAllDeclaration()) throw new Error("Only default and named export declarations can be split.");
    if (exportDeclaration.isExportDefaultDeclaration()) {
        const declaration = exportDeclaration.get("declaration");
        const standaloneDeclaration = declaration.isFunctionDeclaration() || declaration.isClassDeclaration();
        const exportExpr = declaration.isFunctionExpression() || declaration.isClassExpression();
        const scope = declaration.isScope() ? declaration.scope.parent : declaration.scope;
        let id = declaration.node.id;
        let needBindingRegistration = false;
        if (!id) {
            needBindingRegistration = true;
            id = scope.generateUidIdentifier("default");
            if (standaloneDeclaration || exportExpr) declaration.node.id = $cd0e7d4b66a3a3e2$var$cloneNode(id);
        } else if (exportExpr && scope.hasBinding(id.name)) {
            needBindingRegistration = true;
            id = scope.generateUidIdentifier(id.name);
        }
        const updatedDeclaration = standaloneDeclaration ? declaration.node : $cd0e7d4b66a3a3e2$var$variableDeclaration("var", [
            $cd0e7d4b66a3a3e2$var$variableDeclarator($cd0e7d4b66a3a3e2$var$cloneNode(id), declaration.node)
        ]);
        const updatedExportDeclaration = $cd0e7d4b66a3a3e2$var$exportNamedDeclaration(null, [
            $cd0e7d4b66a3a3e2$var$exportSpecifier($cd0e7d4b66a3a3e2$var$cloneNode(id), $cd0e7d4b66a3a3e2$var$identifier("default"))
        ]);
        exportDeclaration.insertAfter(updatedExportDeclaration);
        exportDeclaration.replaceWith(updatedDeclaration);
        if (needBindingRegistration) scope.registerDeclaration(exportDeclaration);
        return exportDeclaration;
    } else if (exportDeclaration.get("specifiers").length > 0) throw new Error("It doesn't make sense to split exported specifiers.");
    const declaration = exportDeclaration.get("declaration");
    const bindingIdentifiers = declaration.getOuterBindingIdentifiers();
    const specifiers = Object.keys(bindingIdentifiers).map((name)=>{
        return $cd0e7d4b66a3a3e2$var$exportSpecifier($cd0e7d4b66a3a3e2$var$identifier(name), $cd0e7d4b66a3a3e2$var$identifier(name));
    });
    const aliasDeclar = $cd0e7d4b66a3a3e2$var$exportNamedDeclaration(null, specifiers);
    exportDeclaration.insertAfter(aliasDeclar);
    exportDeclaration.replaceWith(declaration.node);
    return exportDeclaration;
}

});

parcelRegister("elWuE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.requeueComputedKeyAndDecorators = $a73066686a14a6d0$var$requeueComputedKeyAndDecorators;
module.exports.skipAllButComputedKey = function skipAllButComputedKey(path) {
    path.skip();
    if (path.node.computed) path.context.maybeQueue(path.get("key"));
};
function $a73066686a14a6d0$var$requeueComputedKeyAndDecorators(path) {
    const { context: context, node: node } = path;
    if (node.computed) context.maybeQueue(path.get("key"));
    if (node.decorators) for (const decorator of path.get("decorators"))context.maybeQueue(decorator);
}
const $a73066686a14a6d0$var$visitor = {
    FunctionParent (path) {
        if (path.isArrowFunctionExpression()) return;
        else {
            path.skip();
            if (path.isMethod()) $a73066686a14a6d0$var$requeueComputedKeyAndDecorators(path);
        }
    },
    Property (path) {
        if (path.isObjectProperty()) return;
        path.skip();
        $a73066686a14a6d0$var$requeueComputedKeyAndDecorators(path);
    }
};
var $a73066686a14a6d0$var$_default = $a73066686a14a6d0$var$visitor;
module.exports.default = $a73066686a14a6d0$var$_default;

});


parcelRegister("2n0Pa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
class $1b9e5e6ce9d39dfa$var$Binding {
    constructor({ identifier: identifier, scope: scope, path: path, kind: kind }){
        this.identifier = void 0;
        this.scope = void 0;
        this.path = void 0;
        this.kind = void 0;
        this.constantViolations = [];
        this.constant = true;
        this.referencePaths = [];
        this.referenced = false;
        this.references = 0;
        this.identifier = identifier;
        this.scope = scope;
        this.path = path;
        this.kind = kind;
        if ((kind === "var" || kind === "hoisted") && $1b9e5e6ce9d39dfa$var$isDeclaredInLoop(path)) this.reassign(path);
        this.clearValue();
    }
    deoptValue() {
        this.clearValue();
        this.hasDeoptedValue = true;
    }
    setValue(value) {
        if (this.hasDeoptedValue) return;
        this.hasValue = true;
        this.value = value;
    }
    clearValue() {
        this.hasDeoptedValue = false;
        this.hasValue = false;
        this.value = null;
    }
    reassign(path) {
        this.constant = false;
        if (this.constantViolations.indexOf(path) !== -1) return;
        this.constantViolations.push(path);
    }
    reference(path) {
        if (this.referencePaths.indexOf(path) !== -1) return;
        this.referenced = true;
        this.references++;
        this.referencePaths.push(path);
    }
    dereference() {
        this.references--;
        this.referenced = !!this.references;
    }
}
module.exports.default = $1b9e5e6ce9d39dfa$var$Binding;
function $1b9e5e6ce9d39dfa$var$isDeclaredInLoop(path) {
    for(let { parentPath: parentPath, key: key } = path; parentPath; { parentPath: parentPath, key: key } = parentPath){
        if (parentPath.isFunctionParent()) return false;
        if (parentPath.isWhile() || parentPath.isForXStatement() || parentPath.isForStatement() && key === "body") return true;
    }
    return false;
}

});

parcelRegister("cca03", function(module, exports) {
"use strict";

module.exports = (parcelRequire("lIX0f"));

});
parcelRegister("lIX0f", function(module, exports) {
module.exports = JSON.parse('{"builtin":{"Array":false,"ArrayBuffer":false,"Atomics":false,"BigInt":false,"BigInt64Array":false,"BigUint64Array":false,"Boolean":false,"constructor":false,"DataView":false,"Date":false,"decodeURI":false,"decodeURIComponent":false,"encodeURI":false,"encodeURIComponent":false,"Error":false,"escape":false,"eval":false,"EvalError":false,"Float32Array":false,"Float64Array":false,"Function":false,"globalThis":false,"hasOwnProperty":false,"Infinity":false,"Int16Array":false,"Int32Array":false,"Int8Array":false,"isFinite":false,"isNaN":false,"isPrototypeOf":false,"JSON":false,"Map":false,"Math":false,"NaN":false,"Number":false,"Object":false,"parseFloat":false,"parseInt":false,"Promise":false,"propertyIsEnumerable":false,"Proxy":false,"RangeError":false,"ReferenceError":false,"Reflect":false,"RegExp":false,"Set":false,"SharedArrayBuffer":false,"String":false,"Symbol":false,"SyntaxError":false,"toLocaleString":false,"toString":false,"TypeError":false,"Uint16Array":false,"Uint32Array":false,"Uint8Array":false,"Uint8ClampedArray":false,"undefined":false,"unescape":false,"URIError":false,"valueOf":false,"WeakMap":false,"WeakSet":false},"es5":{"Array":false,"Boolean":false,"constructor":false,"Date":false,"decodeURI":false,"decodeURIComponent":false,"encodeURI":false,"encodeURIComponent":false,"Error":false,"escape":false,"eval":false,"EvalError":false,"Function":false,"hasOwnProperty":false,"Infinity":false,"isFinite":false,"isNaN":false,"isPrototypeOf":false,"JSON":false,"Math":false,"NaN":false,"Number":false,"Object":false,"parseFloat":false,"parseInt":false,"propertyIsEnumerable":false,"RangeError":false,"ReferenceError":false,"RegExp":false,"String":false,"SyntaxError":false,"toLocaleString":false,"toString":false,"TypeError":false,"undefined":false,"unescape":false,"URIError":false,"valueOf":false},"es2015":{"Array":false,"ArrayBuffer":false,"Boolean":false,"constructor":false,"DataView":false,"Date":false,"decodeURI":false,"decodeURIComponent":false,"encodeURI":false,"encodeURIComponent":false,"Error":false,"escape":false,"eval":false,"EvalError":false,"Float32Array":false,"Float64Array":false,"Function":false,"hasOwnProperty":false,"Infinity":false,"Int16Array":false,"Int32Array":false,"Int8Array":false,"isFinite":false,"isNaN":false,"isPrototypeOf":false,"JSON":false,"Map":false,"Math":false,"NaN":false,"Number":false,"Object":false,"parseFloat":false,"parseInt":false,"Promise":false,"propertyIsEnumerable":false,"Proxy":false,"RangeError":false,"ReferenceError":false,"Reflect":false,"RegExp":false,"Set":false,"String":false,"Symbol":false,"SyntaxError":false,"toLocaleString":false,"toString":false,"TypeError":false,"Uint16Array":false,"Uint32Array":false,"Uint8Array":false,"Uint8ClampedArray":false,"undefined":false,"unescape":false,"URIError":false,"valueOf":false,"WeakMap":false,"WeakSet":false},"es2017":{"Array":false,"ArrayBuffer":false,"Atomics":false,"Boolean":false,"constructor":false,"DataView":false,"Date":false,"decodeURI":false,"decodeURIComponent":false,"encodeURI":false,"encodeURIComponent":false,"Error":false,"escape":false,"eval":false,"EvalError":false,"Float32Array":false,"Float64Array":false,"Function":false,"hasOwnProperty":false,"Infinity":false,"Int16Array":false,"Int32Array":false,"Int8Array":false,"isFinite":false,"isNaN":false,"isPrototypeOf":false,"JSON":false,"Map":false,"Math":false,"NaN":false,"Number":false,"Object":false,"parseFloat":false,"parseInt":false,"Promise":false,"propertyIsEnumerable":false,"Proxy":false,"RangeError":false,"ReferenceError":false,"Reflect":false,"RegExp":false,"Set":false,"SharedArrayBuffer":false,"String":false,"Symbol":false,"SyntaxError":false,"toLocaleString":false,"toString":false,"TypeError":false,"Uint16Array":false,"Uint32Array":false,"Uint8Array":false,"Uint8ClampedArray":false,"undefined":false,"unescape":false,"URIError":false,"valueOf":false,"WeakMap":false,"WeakSet":false},"browser":{"AbortController":false,"AbortSignal":false,"addEventListener":false,"alert":false,"AnalyserNode":false,"Animation":false,"AnimationEffectReadOnly":false,"AnimationEffectTiming":false,"AnimationEffectTimingReadOnly":false,"AnimationEvent":false,"AnimationPlaybackEvent":false,"AnimationTimeline":false,"applicationCache":false,"ApplicationCache":false,"ApplicationCacheErrorEvent":false,"atob":false,"Attr":false,"Audio":false,"AudioBuffer":false,"AudioBufferSourceNode":false,"AudioContext":false,"AudioDestinationNode":false,"AudioListener":false,"AudioNode":false,"AudioParam":false,"AudioProcessingEvent":false,"AudioScheduledSourceNode":false,"AudioWorkletGlobalScope ":false,"AudioWorkletNode":false,"AudioWorkletProcessor":false,"BarProp":false,"BaseAudioContext":false,"BatteryManager":false,"BeforeUnloadEvent":false,"BiquadFilterNode":false,"Blob":false,"BlobEvent":false,"blur":false,"BroadcastChannel":false,"btoa":false,"BudgetService":false,"ByteLengthQueuingStrategy":false,"Cache":false,"caches":false,"CacheStorage":false,"cancelAnimationFrame":false,"cancelIdleCallback":false,"CanvasCaptureMediaStreamTrack":false,"CanvasGradient":false,"CanvasPattern":false,"CanvasRenderingContext2D":false,"ChannelMergerNode":false,"ChannelSplitterNode":false,"CharacterData":false,"clearInterval":false,"clearTimeout":false,"clientInformation":false,"ClipboardEvent":false,"close":false,"closed":false,"CloseEvent":false,"Comment":false,"CompositionEvent":false,"confirm":false,"console":false,"ConstantSourceNode":false,"ConvolverNode":false,"CountQueuingStrategy":false,"createImageBitmap":false,"Credential":false,"CredentialsContainer":false,"crypto":false,"Crypto":false,"CryptoKey":false,"CSS":false,"CSSConditionRule":false,"CSSFontFaceRule":false,"CSSGroupingRule":false,"CSSImportRule":false,"CSSKeyframeRule":false,"CSSKeyframesRule":false,"CSSMediaRule":false,"CSSNamespaceRule":false,"CSSPageRule":false,"CSSRule":false,"CSSRuleList":false,"CSSStyleDeclaration":false,"CSSStyleRule":false,"CSSStyleSheet":false,"CSSSupportsRule":false,"CustomElementRegistry":false,"customElements":false,"CustomEvent":false,"DataTransfer":false,"DataTransferItem":false,"DataTransferItemList":false,"defaultstatus":false,"defaultStatus":false,"DelayNode":false,"DeviceMotionEvent":false,"DeviceOrientationEvent":false,"devicePixelRatio":false,"dispatchEvent":false,"document":false,"Document":false,"DocumentFragment":false,"DocumentType":false,"DOMError":false,"DOMException":false,"DOMImplementation":false,"DOMMatrix":false,"DOMMatrixReadOnly":false,"DOMParser":false,"DOMPoint":false,"DOMPointReadOnly":false,"DOMQuad":false,"DOMRect":false,"DOMRectReadOnly":false,"DOMStringList":false,"DOMStringMap":false,"DOMTokenList":false,"DragEvent":false,"DynamicsCompressorNode":false,"Element":false,"ErrorEvent":false,"event":false,"Event":false,"EventSource":false,"EventTarget":false,"external":false,"fetch":false,"File":false,"FileList":false,"FileReader":false,"find":false,"focus":false,"FocusEvent":false,"FontFace":false,"FontFaceSetLoadEvent":false,"FormData":false,"frameElement":false,"frames":false,"GainNode":false,"Gamepad":false,"GamepadButton":false,"GamepadEvent":false,"getComputedStyle":false,"getSelection":false,"HashChangeEvent":false,"Headers":false,"history":false,"History":false,"HTMLAllCollection":false,"HTMLAnchorElement":false,"HTMLAreaElement":false,"HTMLAudioElement":false,"HTMLBaseElement":false,"HTMLBodyElement":false,"HTMLBRElement":false,"HTMLButtonElement":false,"HTMLCanvasElement":false,"HTMLCollection":false,"HTMLContentElement":false,"HTMLDataElement":false,"HTMLDataListElement":false,"HTMLDetailsElement":false,"HTMLDialogElement":false,"HTMLDirectoryElement":false,"HTMLDivElement":false,"HTMLDListElement":false,"HTMLDocument":false,"HTMLElement":false,"HTMLEmbedElement":false,"HTMLFieldSetElement":false,"HTMLFontElement":false,"HTMLFormControlsCollection":false,"HTMLFormElement":false,"HTMLFrameElement":false,"HTMLFrameSetElement":false,"HTMLHeadElement":false,"HTMLHeadingElement":false,"HTMLHRElement":false,"HTMLHtmlElement":false,"HTMLIFrameElement":false,"HTMLImageElement":false,"HTMLInputElement":false,"HTMLLabelElement":false,"HTMLLegendElement":false,"HTMLLIElement":false,"HTMLLinkElement":false,"HTMLMapElement":false,"HTMLMarqueeElement":false,"HTMLMediaElement":false,"HTMLMenuElement":false,"HTMLMetaElement":false,"HTMLMeterElement":false,"HTMLModElement":false,"HTMLObjectElement":false,"HTMLOListElement":false,"HTMLOptGroupElement":false,"HTMLOptionElement":false,"HTMLOptionsCollection":false,"HTMLOutputElement":false,"HTMLParagraphElement":false,"HTMLParamElement":false,"HTMLPictureElement":false,"HTMLPreElement":false,"HTMLProgressElement":false,"HTMLQuoteElement":false,"HTMLScriptElement":false,"HTMLSelectElement":false,"HTMLShadowElement":false,"HTMLSlotElement":false,"HTMLSourceElement":false,"HTMLSpanElement":false,"HTMLStyleElement":false,"HTMLTableCaptionElement":false,"HTMLTableCellElement":false,"HTMLTableColElement":false,"HTMLTableElement":false,"HTMLTableRowElement":false,"HTMLTableSectionElement":false,"HTMLTemplateElement":false,"HTMLTextAreaElement":false,"HTMLTimeElement":false,"HTMLTitleElement":false,"HTMLTrackElement":false,"HTMLUListElement":false,"HTMLUnknownElement":false,"HTMLVideoElement":false,"IDBCursor":false,"IDBCursorWithValue":false,"IDBDatabase":false,"IDBFactory":false,"IDBIndex":false,"IDBKeyRange":false,"IDBObjectStore":false,"IDBOpenDBRequest":false,"IDBRequest":false,"IDBTransaction":false,"IDBVersionChangeEvent":false,"IdleDeadline":false,"IIRFilterNode":false,"Image":false,"ImageBitmap":false,"ImageBitmapRenderingContext":false,"ImageCapture":false,"ImageData":false,"indexedDB":false,"innerHeight":false,"innerWidth":false,"InputEvent":false,"IntersectionObserver":false,"IntersectionObserverEntry":false,"Intl":false,"isSecureContext":false,"KeyboardEvent":false,"KeyframeEffect":false,"KeyframeEffectReadOnly":false,"length":false,"localStorage":false,"location":true,"Location":false,"locationbar":false,"matchMedia":false,"MediaDeviceInfo":false,"MediaDevices":false,"MediaElementAudioSourceNode":false,"MediaEncryptedEvent":false,"MediaError":false,"MediaKeyMessageEvent":false,"MediaKeySession":false,"MediaKeyStatusMap":false,"MediaKeySystemAccess":false,"MediaList":false,"MediaQueryList":false,"MediaQueryListEvent":false,"MediaRecorder":false,"MediaSettingsRange":false,"MediaSource":false,"MediaStream":false,"MediaStreamAudioDestinationNode":false,"MediaStreamAudioSourceNode":false,"MediaStreamEvent":false,"MediaStreamTrack":false,"MediaStreamTrackEvent":false,"menubar":false,"MessageChannel":false,"MessageEvent":false,"MessagePort":false,"MIDIAccess":false,"MIDIConnectionEvent":false,"MIDIInput":false,"MIDIInputMap":false,"MIDIMessageEvent":false,"MIDIOutput":false,"MIDIOutputMap":false,"MIDIPort":false,"MimeType":false,"MimeTypeArray":false,"MouseEvent":false,"moveBy":false,"moveTo":false,"MutationEvent":false,"MutationObserver":false,"MutationRecord":false,"name":false,"NamedNodeMap":false,"NavigationPreloadManager":false,"navigator":false,"Navigator":false,"NetworkInformation":false,"Node":false,"NodeFilter":false,"NodeIterator":false,"NodeList":false,"Notification":false,"OfflineAudioCompletionEvent":false,"OfflineAudioContext":false,"offscreenBuffering":false,"OffscreenCanvas":true,"onabort":true,"onafterprint":true,"onanimationend":true,"onanimationiteration":true,"onanimationstart":true,"onappinstalled":true,"onauxclick":true,"onbeforeinstallprompt":true,"onbeforeprint":true,"onbeforeunload":true,"onblur":true,"oncancel":true,"oncanplay":true,"oncanplaythrough":true,"onchange":true,"onclick":true,"onclose":true,"oncontextmenu":true,"oncuechange":true,"ondblclick":true,"ondevicemotion":true,"ondeviceorientation":true,"ondeviceorientationabsolute":true,"ondrag":true,"ondragend":true,"ondragenter":true,"ondragleave":true,"ondragover":true,"ondragstart":true,"ondrop":true,"ondurationchange":true,"onemptied":true,"onended":true,"onerror":true,"onfocus":true,"ongotpointercapture":true,"onhashchange":true,"oninput":true,"oninvalid":true,"onkeydown":true,"onkeypress":true,"onkeyup":true,"onlanguagechange":true,"onload":true,"onloadeddata":true,"onloadedmetadata":true,"onloadstart":true,"onlostpointercapture":true,"onmessage":true,"onmessageerror":true,"onmousedown":true,"onmouseenter":true,"onmouseleave":true,"onmousemove":true,"onmouseout":true,"onmouseover":true,"onmouseup":true,"onmousewheel":true,"onoffline":true,"ononline":true,"onpagehide":true,"onpageshow":true,"onpause":true,"onplay":true,"onplaying":true,"onpointercancel":true,"onpointerdown":true,"onpointerenter":true,"onpointerleave":true,"onpointermove":true,"onpointerout":true,"onpointerover":true,"onpointerup":true,"onpopstate":true,"onprogress":true,"onratechange":true,"onrejectionhandled":true,"onreset":true,"onresize":true,"onscroll":true,"onsearch":true,"onseeked":true,"onseeking":true,"onselect":true,"onstalled":true,"onstorage":true,"onsubmit":true,"onsuspend":true,"ontimeupdate":true,"ontoggle":true,"ontransitionend":true,"onunhandledrejection":true,"onunload":true,"onvolumechange":true,"onwaiting":true,"onwheel":true,"open":false,"openDatabase":false,"opener":false,"Option":false,"origin":false,"OscillatorNode":false,"outerHeight":false,"outerWidth":false,"PageTransitionEvent":false,"pageXOffset":false,"pageYOffset":false,"PannerNode":false,"parent":false,"Path2D":false,"PaymentAddress":false,"PaymentRequest":false,"PaymentRequestUpdateEvent":false,"PaymentResponse":false,"performance":false,"Performance":false,"PerformanceEntry":false,"PerformanceLongTaskTiming":false,"PerformanceMark":false,"PerformanceMeasure":false,"PerformanceNavigation":false,"PerformanceNavigationTiming":false,"PerformanceObserver":false,"PerformanceObserverEntryList":false,"PerformancePaintTiming":false,"PerformanceResourceTiming":false,"PerformanceTiming":false,"PeriodicWave":false,"Permissions":false,"PermissionStatus":false,"personalbar":false,"PhotoCapabilities":false,"Plugin":false,"PluginArray":false,"PointerEvent":false,"PopStateEvent":false,"postMessage":false,"Presentation":false,"PresentationAvailability":false,"PresentationConnection":false,"PresentationConnectionAvailableEvent":false,"PresentationConnectionCloseEvent":false,"PresentationConnectionList":false,"PresentationReceiver":false,"PresentationRequest":false,"print":false,"ProcessingInstruction":false,"ProgressEvent":false,"PromiseRejectionEvent":false,"prompt":false,"PushManager":false,"PushSubscription":false,"PushSubscriptionOptions":false,"queueMicrotask":false,"RadioNodeList":false,"Range":false,"ReadableStream":false,"registerProcessor":false,"RemotePlayback":false,"removeEventListener":false,"Request":false,"requestAnimationFrame":false,"requestIdleCallback":false,"resizeBy":false,"ResizeObserver":false,"ResizeObserverEntry":false,"resizeTo":false,"Response":false,"RTCCertificate":false,"RTCDataChannel":false,"RTCDataChannelEvent":false,"RTCDtlsTransport":false,"RTCIceCandidate":false,"RTCIceGatherer":false,"RTCIceTransport":false,"RTCPeerConnection":false,"RTCPeerConnectionIceEvent":false,"RTCRtpContributingSource":false,"RTCRtpReceiver":false,"RTCRtpSender":false,"RTCSctpTransport":false,"RTCSessionDescription":false,"RTCStatsReport":false,"RTCTrackEvent":false,"screen":false,"Screen":false,"screenLeft":false,"ScreenOrientation":false,"screenTop":false,"screenX":false,"screenY":false,"ScriptProcessorNode":false,"scroll":false,"scrollbars":false,"scrollBy":false,"scrollTo":false,"scrollX":false,"scrollY":false,"SecurityPolicyViolationEvent":false,"Selection":false,"self":false,"ServiceWorker":false,"ServiceWorkerContainer":false,"ServiceWorkerRegistration":false,"sessionStorage":false,"setInterval":false,"setTimeout":false,"ShadowRoot":false,"SharedWorker":false,"SourceBuffer":false,"SourceBufferList":false,"speechSynthesis":false,"SpeechSynthesisEvent":false,"SpeechSynthesisUtterance":false,"StaticRange":false,"status":false,"statusbar":false,"StereoPannerNode":false,"stop":false,"Storage":false,"StorageEvent":false,"StorageManager":false,"styleMedia":false,"StyleSheet":false,"StyleSheetList":false,"SubtleCrypto":false,"SVGAElement":false,"SVGAngle":false,"SVGAnimatedAngle":false,"SVGAnimatedBoolean":false,"SVGAnimatedEnumeration":false,"SVGAnimatedInteger":false,"SVGAnimatedLength":false,"SVGAnimatedLengthList":false,"SVGAnimatedNumber":false,"SVGAnimatedNumberList":false,"SVGAnimatedPreserveAspectRatio":false,"SVGAnimatedRect":false,"SVGAnimatedString":false,"SVGAnimatedTransformList":false,"SVGAnimateElement":false,"SVGAnimateMotionElement":false,"SVGAnimateTransformElement":false,"SVGAnimationElement":false,"SVGCircleElement":false,"SVGClipPathElement":false,"SVGComponentTransferFunctionElement":false,"SVGDefsElement":false,"SVGDescElement":false,"SVGDiscardElement":false,"SVGElement":false,"SVGEllipseElement":false,"SVGFEBlendElement":false,"SVGFEColorMatrixElement":false,"SVGFEComponentTransferElement":false,"SVGFECompositeElement":false,"SVGFEConvolveMatrixElement":false,"SVGFEDiffuseLightingElement":false,"SVGFEDisplacementMapElement":false,"SVGFEDistantLightElement":false,"SVGFEDropShadowElement":false,"SVGFEFloodElement":false,"SVGFEFuncAElement":false,"SVGFEFuncBElement":false,"SVGFEFuncGElement":false,"SVGFEFuncRElement":false,"SVGFEGaussianBlurElement":false,"SVGFEImageElement":false,"SVGFEMergeElement":false,"SVGFEMergeNodeElement":false,"SVGFEMorphologyElement":false,"SVGFEOffsetElement":false,"SVGFEPointLightElement":false,"SVGFESpecularLightingElement":false,"SVGFESpotLightElement":false,"SVGFETileElement":false,"SVGFETurbulenceElement":false,"SVGFilterElement":false,"SVGForeignObjectElement":false,"SVGGElement":false,"SVGGeometryElement":false,"SVGGradientElement":false,"SVGGraphicsElement":false,"SVGImageElement":false,"SVGLength":false,"SVGLengthList":false,"SVGLinearGradientElement":false,"SVGLineElement":false,"SVGMarkerElement":false,"SVGMaskElement":false,"SVGMatrix":false,"SVGMetadataElement":false,"SVGMPathElement":false,"SVGNumber":false,"SVGNumberList":false,"SVGPathElement":false,"SVGPatternElement":false,"SVGPoint":false,"SVGPointList":false,"SVGPolygonElement":false,"SVGPolylineElement":false,"SVGPreserveAspectRatio":false,"SVGRadialGradientElement":false,"SVGRect":false,"SVGRectElement":false,"SVGScriptElement":false,"SVGSetElement":false,"SVGStopElement":false,"SVGStringList":false,"SVGStyleElement":false,"SVGSVGElement":false,"SVGSwitchElement":false,"SVGSymbolElement":false,"SVGTextContentElement":false,"SVGTextElement":false,"SVGTextPathElement":false,"SVGTextPositioningElement":false,"SVGTitleElement":false,"SVGTransform":false,"SVGTransformList":false,"SVGTSpanElement":false,"SVGUnitTypes":false,"SVGUseElement":false,"SVGViewElement":false,"TaskAttributionTiming":false,"Text":false,"TextDecoder":false,"TextEncoder":false,"TextEvent":false,"TextMetrics":false,"TextTrack":false,"TextTrackCue":false,"TextTrackCueList":false,"TextTrackList":false,"TimeRanges":false,"toolbar":false,"top":false,"Touch":false,"TouchEvent":false,"TouchList":false,"TrackEvent":false,"TransitionEvent":false,"TreeWalker":false,"UIEvent":false,"URL":false,"URLSearchParams":false,"ValidityState":false,"visualViewport":false,"VisualViewport":false,"VTTCue":false,"WaveShaperNode":false,"WebAssembly":false,"WebGL2RenderingContext":false,"WebGLActiveInfo":false,"WebGLBuffer":false,"WebGLContextEvent":false,"WebGLFramebuffer":false,"WebGLProgram":false,"WebGLQuery":false,"WebGLRenderbuffer":false,"WebGLRenderingContext":false,"WebGLSampler":false,"WebGLShader":false,"WebGLShaderPrecisionFormat":false,"WebGLSync":false,"WebGLTexture":false,"WebGLTransformFeedback":false,"WebGLUniformLocation":false,"WebGLVertexArrayObject":false,"WebSocket":false,"WheelEvent":false,"window":false,"Window":false,"Worker":false,"WritableStream":false,"XMLDocument":false,"XMLHttpRequest":false,"XMLHttpRequestEventTarget":false,"XMLHttpRequestUpload":false,"XMLSerializer":false,"XPathEvaluator":false,"XPathExpression":false,"XPathResult":false,"XSLTProcessor":false},"worker":{"addEventListener":false,"applicationCache":false,"atob":false,"Blob":false,"BroadcastChannel":false,"btoa":false,"Cache":false,"caches":false,"clearInterval":false,"clearTimeout":false,"close":true,"console":false,"fetch":false,"FileReaderSync":false,"FormData":false,"Headers":false,"IDBCursor":false,"IDBCursorWithValue":false,"IDBDatabase":false,"IDBFactory":false,"IDBIndex":false,"IDBKeyRange":false,"IDBObjectStore":false,"IDBOpenDBRequest":false,"IDBRequest":false,"IDBTransaction":false,"IDBVersionChangeEvent":false,"ImageData":false,"importScripts":true,"indexedDB":false,"location":false,"MessageChannel":false,"MessagePort":false,"name":false,"navigator":false,"Notification":false,"onclose":true,"onconnect":true,"onerror":true,"onlanguagechange":true,"onmessage":true,"onoffline":true,"ononline":true,"onrejectionhandled":true,"onunhandledrejection":true,"performance":false,"Performance":false,"PerformanceEntry":false,"PerformanceMark":false,"PerformanceMeasure":false,"PerformanceNavigation":false,"PerformanceResourceTiming":false,"PerformanceTiming":false,"postMessage":true,"Promise":false,"queueMicrotask":false,"removeEventListener":false,"Request":false,"Response":false,"self":true,"ServiceWorkerRegistration":false,"setInterval":false,"setTimeout":false,"TextDecoder":false,"TextEncoder":false,"URL":false,"URLSearchParams":false,"WebSocket":false,"Worker":false,"WorkerGlobalScope":false,"XMLHttpRequest":false},"node":{"__dirname":false,"__filename":false,"Buffer":false,"clearImmediate":false,"clearInterval":false,"clearTimeout":false,"console":false,"exports":true,"global":false,"Intl":false,"module":false,"process":false,"queueMicrotask":false,"require":false,"setImmediate":false,"setInterval":false,"setTimeout":false,"TextDecoder":false,"TextEncoder":false,"URL":false,"URLSearchParams":false},"commonjs":{"exports":true,"global":false,"module":false,"require":false},"amd":{"define":false,"require":false},"mocha":{"after":false,"afterEach":false,"before":false,"beforeEach":false,"context":false,"describe":false,"it":false,"mocha":false,"run":false,"setup":false,"specify":false,"suite":false,"suiteSetup":false,"suiteTeardown":false,"teardown":false,"test":false,"xcontext":false,"xdescribe":false,"xit":false,"xspecify":false},"jasmine":{"afterAll":false,"afterEach":false,"beforeAll":false,"beforeEach":false,"describe":false,"expect":false,"fail":false,"fdescribe":false,"fit":false,"it":false,"jasmine":false,"pending":false,"runs":false,"spyOn":false,"spyOnProperty":false,"waits":false,"waitsFor":false,"xdescribe":false,"xit":false},"jest":{"afterAll":false,"afterEach":false,"beforeAll":false,"beforeEach":false,"describe":false,"expect":false,"fdescribe":false,"fit":false,"it":false,"jest":false,"pit":false,"require":false,"test":false,"xdescribe":false,"xit":false,"xtest":false},"qunit":{"asyncTest":false,"deepEqual":false,"equal":false,"expect":false,"module":false,"notDeepEqual":false,"notEqual":false,"notOk":false,"notPropEqual":false,"notStrictEqual":false,"ok":false,"propEqual":false,"QUnit":false,"raises":false,"start":false,"stop":false,"strictEqual":false,"test":false,"throws":false},"phantomjs":{"console":true,"exports":true,"phantom":true,"require":true,"WebPage":true},"couch":{"emit":false,"exports":false,"getRow":false,"log":false,"module":false,"provides":false,"require":false,"respond":false,"send":false,"start":false,"sum":false},"rhino":{"defineClass":false,"deserialize":false,"gc":false,"help":false,"importClass":false,"importPackage":false,"java":false,"load":false,"loadClass":false,"Packages":false,"print":false,"quit":false,"readFile":false,"readUrl":false,"runCommand":false,"seal":false,"serialize":false,"spawn":false,"sync":false,"toint32":false,"version":false},"nashorn":{"__DIR__":false,"__FILE__":false,"__LINE__":false,"com":false,"edu":false,"exit":false,"java":false,"Java":false,"javafx":false,"JavaImporter":false,"javax":false,"JSAdapter":false,"load":false,"loadWithNewGlobal":false,"org":false,"Packages":false,"print":false,"quit":false},"wsh":{"ActiveXObject":true,"Enumerator":true,"GetObject":true,"ScriptEngine":true,"ScriptEngineBuildVersion":true,"ScriptEngineMajorVersion":true,"ScriptEngineMinorVersion":true,"VBArray":true,"WScript":true,"WSH":true,"XDomainRequest":true},"jquery":{"$":false,"jQuery":false},"yui":{"YAHOO":false,"YAHOO_config":false,"YUI":false,"YUI_config":false},"shelljs":{"cat":false,"cd":false,"chmod":false,"config":false,"cp":false,"dirs":false,"echo":false,"env":false,"error":false,"exec":false,"exit":false,"find":false,"grep":false,"ln":false,"ls":false,"mkdir":false,"mv":false,"popd":false,"pushd":false,"pwd":false,"rm":false,"sed":false,"set":false,"target":false,"tempdir":false,"test":false,"touch":false,"which":false},"prototypejs":{"$":false,"$$":false,"$A":false,"$break":false,"$continue":false,"$F":false,"$H":false,"$R":false,"$w":false,"Abstract":false,"Ajax":false,"Autocompleter":false,"Builder":false,"Class":false,"Control":false,"Draggable":false,"Draggables":false,"Droppables":false,"Effect":false,"Element":false,"Enumerable":false,"Event":false,"Field":false,"Form":false,"Hash":false,"Insertion":false,"ObjectRange":false,"PeriodicalExecuter":false,"Position":false,"Prototype":false,"Scriptaculous":false,"Selector":false,"Sortable":false,"SortableObserver":false,"Sound":false,"Template":false,"Toggle":false,"Try":false},"meteor":{"_":false,"$":false,"Accounts":false,"AccountsClient":false,"AccountsCommon":false,"AccountsServer":false,"App":false,"Assets":false,"Blaze":false,"check":false,"Cordova":false,"DDP":false,"DDPRateLimiter":false,"DDPServer":false,"Deps":false,"EJSON":false,"Email":false,"HTTP":false,"Log":false,"Match":false,"Meteor":false,"Mongo":false,"MongoInternals":false,"Npm":false,"Package":false,"Plugin":false,"process":false,"Random":false,"ReactiveDict":false,"ReactiveVar":false,"Router":false,"ServiceConfiguration":false,"Session":false,"share":false,"Spacebars":false,"Template":false,"Tinytest":false,"Tracker":false,"UI":false,"Utils":false,"WebApp":false,"WebAppInternals":false},"mongo":{"_isWindows":false,"_rand":false,"BulkWriteResult":false,"cat":false,"cd":false,"connect":false,"db":false,"getHostName":false,"getMemInfo":false,"hostname":false,"ISODate":false,"listFiles":false,"load":false,"ls":false,"md5sumFile":false,"mkdir":false,"Mongo":false,"NumberInt":false,"NumberLong":false,"ObjectId":false,"PlanCache":false,"print":false,"printjson":false,"pwd":false,"quit":false,"removeFile":false,"rs":false,"sh":false,"UUID":false,"version":false,"WriteResult":false},"applescript":{"$":false,"Application":false,"Automation":false,"console":false,"delay":false,"Library":false,"ObjC":false,"ObjectSpecifier":false,"Path":false,"Progress":false,"Ref":false},"serviceworker":{"addEventListener":false,"applicationCache":false,"atob":false,"Blob":false,"BroadcastChannel":false,"btoa":false,"Cache":false,"caches":false,"CacheStorage":false,"clearInterval":false,"clearTimeout":false,"Client":false,"clients":false,"Clients":false,"close":true,"console":false,"ExtendableEvent":false,"ExtendableMessageEvent":false,"fetch":false,"FetchEvent":false,"FileReaderSync":false,"FormData":false,"Headers":false,"IDBCursor":false,"IDBCursorWithValue":false,"IDBDatabase":false,"IDBFactory":false,"IDBIndex":false,"IDBKeyRange":false,"IDBObjectStore":false,"IDBOpenDBRequest":false,"IDBRequest":false,"IDBTransaction":false,"IDBVersionChangeEvent":false,"ImageData":false,"importScripts":false,"indexedDB":false,"location":false,"MessageChannel":false,"MessagePort":false,"name":false,"navigator":false,"Notification":false,"onclose":true,"onconnect":true,"onerror":true,"onfetch":true,"oninstall":true,"onlanguagechange":true,"onmessage":true,"onmessageerror":true,"onnotificationclick":true,"onnotificationclose":true,"onoffline":true,"ononline":true,"onpush":true,"onpushsubscriptionchange":true,"onrejectionhandled":true,"onsync":true,"onunhandledrejection":true,"performance":false,"Performance":false,"PerformanceEntry":false,"PerformanceMark":false,"PerformanceMeasure":false,"PerformanceNavigation":false,"PerformanceResourceTiming":false,"PerformanceTiming":false,"postMessage":true,"Promise":false,"queueMicrotask":false,"registration":false,"removeEventListener":false,"Request":false,"Response":false,"self":false,"ServiceWorker":false,"ServiceWorkerContainer":false,"ServiceWorkerGlobalScope":false,"ServiceWorkerMessageEvent":false,"ServiceWorkerRegistration":false,"setInterval":false,"setTimeout":false,"skipWaiting":false,"TextDecoder":false,"TextEncoder":false,"URL":false,"URLSearchParams":false,"WebSocket":false,"WindowClient":false,"Worker":false,"WorkerGlobalScope":false,"XMLHttpRequest":false},"atomtest":{"advanceClock":false,"fakeClearInterval":false,"fakeClearTimeout":false,"fakeSetInterval":false,"fakeSetTimeout":false,"resetTimeouts":false,"waitsForPromise":false},"embertest":{"andThen":false,"click":false,"currentPath":false,"currentRouteName":false,"currentURL":false,"fillIn":false,"find":false,"findAll":false,"findWithAssert":false,"keyEvent":false,"pauseTest":false,"resumeTest":false,"triggerEvent":false,"visit":false,"wait":false},"protractor":{"$":false,"$$":false,"browser":false,"by":false,"By":false,"DartObject":false,"element":false,"protractor":false},"shared-node-browser":{"clearInterval":false,"clearTimeout":false,"console":false,"setInterval":false,"setTimeout":false,"URL":false,"URLSearchParams":false},"webextensions":{"browser":false,"chrome":false,"opr":false},"greasemonkey":{"cloneInto":false,"createObjectIn":false,"exportFunction":false,"GM":false,"GM_addStyle":false,"GM_deleteValue":false,"GM_getResourceText":false,"GM_getResourceURL":false,"GM_getValue":false,"GM_info":false,"GM_listValues":false,"GM_log":false,"GM_openInTab":false,"GM_registerMenuCommand":false,"GM_setClipboard":false,"GM_setValue":false,"GM_xmlhttpRequest":false,"unsafeWindow":false},"devtools":{"$":false,"$_":false,"$$":false,"$0":false,"$1":false,"$2":false,"$3":false,"$4":false,"$x":false,"chrome":false,"clear":false,"copy":false,"debug":false,"dir":false,"dirxml":false,"getEventListeners":false,"inspect":false,"keys":false,"monitor":false,"monitorEvents":false,"profile":false,"profileEnd":false,"queryObjects":false,"table":false,"undebug":false,"unmonitor":false,"unmonitorEvents":false,"values":false}}');

});



parcelRegister("bLZPM", function(module, exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.find = find;
exports.findParent = findParent;
exports.getAncestry = getAncestry;
exports.getDeepestCommonAncestorFrom = getDeepestCommonAncestorFrom;
exports.getEarliestCommonAncestorFrom = getEarliestCommonAncestorFrom;
exports.getFunctionParent = getFunctionParent;
exports.getStatementParent = getStatementParent;
exports.inType = inType;
exports.isAncestor = isAncestor;
exports.isDescendant = isDescendant;

var $ardUq = parcelRequire("ardUq");
const { VISITOR_KEYS } = $ardUq;
function findParent(callback) {
    let path = this;
    while(path = path.parentPath){
        if (callback(path)) return path;
    }
    return null;
}
function find(callback) {
    let path = this;
    do {
        if (callback(path)) return path;
    }while (path = path.parentPath);
    return null;
}
function getFunctionParent() {
    return this.findParent((p)=>p.isFunction());
}
function getStatementParent() {
    let path = this;
    do {
        if (!path.parentPath || Array.isArray(path.container) && path.isStatement()) break;
        else path = path.parentPath;
    }while (path);
    if (path && (path.isProgram() || path.isFile())) throw new Error("File/Program node, we can't possibly find a statement parent to this");
    return path;
}
function getEarliestCommonAncestorFrom(paths) {
    return this.getDeepestCommonAncestorFrom(paths, function(deepest, i, ancestries) {
        let earliest;
        const keys = VISITOR_KEYS[deepest.type];
        for (const ancestry of ancestries){
            const path = ancestry[i + 1];
            if (!earliest) {
                earliest = path;
                continue;
            }
            if (path.listKey && earliest.listKey === path.listKey) {
                if (path.key < earliest.key) {
                    earliest = path;
                    continue;
                }
            }
            const earliestKeyIndex = keys.indexOf(earliest.parentKey);
            const currentKeyIndex = keys.indexOf(path.parentKey);
            if (earliestKeyIndex > currentKeyIndex) earliest = path;
        }
        return earliest;
    });
}
function getDeepestCommonAncestorFrom(paths, filter) {
    if (!paths.length) return this;
    if (paths.length === 1) return paths[0];
    let minDepth = Infinity;
    let lastCommonIndex, lastCommon;
    const ancestries = paths.map((path)=>{
        const ancestry = [];
        do ancestry.unshift(path);
        while ((path = path.parentPath) && path !== this);
        if (ancestry.length < minDepth) minDepth = ancestry.length;
        return ancestry;
    });
    const first = ancestries[0];
    depthLoop: for(let i = 0; i < minDepth; i++){
        const shouldMatch = first[i];
        for (const ancestry of ancestries){
            if (ancestry[i] !== shouldMatch) break depthLoop;
        }
        lastCommonIndex = i;
        lastCommon = shouldMatch;
    }
    if (lastCommon) {
        if (filter) return filter(lastCommon, lastCommonIndex, ancestries);
        else return lastCommon;
    } else throw new Error("Couldn't find intersection");
}
function getAncestry() {
    let path = this;
    const paths = [];
    do paths.push(path);
    while (path = path.parentPath);
    return paths;
}
function isAncestor(maybeDescendant) {
    return maybeDescendant.isDescendant(this);
}
function isDescendant(maybeAncestor) {
    return !!this.findParent((parent)=>parent === maybeAncestor);
}
function inType(...candidateTypes) {
    let path = this;
    while(path){
        for (const type of candidateTypes){
            if (path.node.type === type) return true;
        }
        path = path.parentPath;
    }
    return false;
}

});

parcelRegister("eyv53", function(module, exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports._getTypeAnnotation = _getTypeAnnotation;
exports.baseTypeStrictlyMatches = baseTypeStrictlyMatches;
exports.couldBeBaseType = couldBeBaseType;
exports.getTypeAnnotation = getTypeAnnotation;
exports.isBaseType = isBaseType;
exports.isGenericType = isGenericType;

var $5fPlY = parcelRequire("5fPlY");

var $ardUq = parcelRequire("ardUq");
const { anyTypeAnnotation, isAnyTypeAnnotation, isArrayTypeAnnotation, isBooleanTypeAnnotation, isEmptyTypeAnnotation, isFlowBaseAnnotation, isGenericTypeAnnotation, isIdentifier, isMixedTypeAnnotation, isNumberTypeAnnotation, isStringTypeAnnotation, isTSArrayType, isTSTypeAnnotation, isTSTypeReference, isTupleTypeAnnotation, isTypeAnnotation, isUnionTypeAnnotation, isVoidTypeAnnotation, stringTypeAnnotation, voidTypeAnnotation } = $ardUq;
function getTypeAnnotation() {
    let type = this.getData("typeAnnotation");
    if (type != null) return type;
    type = this._getTypeAnnotation() || anyTypeAnnotation();
    if (isTypeAnnotation(type) || isTSTypeAnnotation(type)) type = type.typeAnnotation;
    this.setData("typeAnnotation", type);
    return type;
}
const typeAnnotationInferringNodes = new WeakSet();
function _getTypeAnnotation() {
    const node = this.node;
    if (!node) {
        if (this.key === "init" && this.parentPath.isVariableDeclarator()) {
            const declar = this.parentPath.parentPath;
            const declarParent = declar.parentPath;
            if (declar.key === "left" && declarParent.isForInStatement()) return stringTypeAnnotation();
            if (declar.key === "left" && declarParent.isForOfStatement()) return anyTypeAnnotation();
            return voidTypeAnnotation();
        } else return;
    }
    if (node.typeAnnotation) return node.typeAnnotation;
    if (typeAnnotationInferringNodes.has(node)) return;
    typeAnnotationInferringNodes.add(node);
    try {
        var _inferer;
        let inferer = $5fPlY[node.type];
        if (inferer) return inferer.call(this, node);
        inferer = $5fPlY[this.parentPath.type];
        if ((_inferer = inferer) != null && _inferer.validParent) return this.parentPath.getTypeAnnotation();
    } finally{
        typeAnnotationInferringNodes.delete(node);
    }
}
function isBaseType(baseName, soft) {
    return _isBaseType(baseName, this.getTypeAnnotation(), soft);
}
function _isBaseType(baseName, type, soft) {
    if (baseName === "string") return isStringTypeAnnotation(type);
    else if (baseName === "number") return isNumberTypeAnnotation(type);
    else if (baseName === "boolean") return isBooleanTypeAnnotation(type);
    else if (baseName === "any") return isAnyTypeAnnotation(type);
    else if (baseName === "mixed") return isMixedTypeAnnotation(type);
    else if (baseName === "empty") return isEmptyTypeAnnotation(type);
    else if (baseName === "void") return isVoidTypeAnnotation(type);
    else {
        if (soft) return false;
        else throw new Error(`Unknown base type ${baseName}`);
    }
}
function couldBeBaseType(name) {
    const type = this.getTypeAnnotation();
    if (isAnyTypeAnnotation(type)) return true;
    if (isUnionTypeAnnotation(type)) {
        for (const type2 of type.types){
            if (isAnyTypeAnnotation(type2) || _isBaseType(name, type2, true)) return true;
        }
        return false;
    } else return _isBaseType(name, type, true);
}
function baseTypeStrictlyMatches(rightArg) {
    const left = this.getTypeAnnotation();
    const right = rightArg.getTypeAnnotation();
    if (!isAnyTypeAnnotation(left) && isFlowBaseAnnotation(left)) return right.type === left.type;
    return false;
}
function isGenericType(genericName) {
    const type = this.getTypeAnnotation();
    if (genericName === "Array") {
        if (isTSArrayType(type) || isArrayTypeAnnotation(type) || isTupleTypeAnnotation(type)) return true;
    }
    return isGenericTypeAnnotation(type) && isIdentifier(type.id, {
        name: genericName
    }) || isTSTypeReference(type) && isIdentifier(type.typeName, {
        name: genericName
    });
}

});
parcelRegister("5fPlY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ArrayExpression = $3d36302920c79526$var$ArrayExpression;
module.exports.AssignmentExpression = $3d36302920c79526$var$AssignmentExpression;
module.exports.BinaryExpression = $3d36302920c79526$var$BinaryExpression;
module.exports.BooleanLiteral = $3d36302920c79526$var$BooleanLiteral;
module.exports.CallExpression = $3d36302920c79526$var$CallExpression;
module.exports.ConditionalExpression = $3d36302920c79526$var$ConditionalExpression;
module.exports.ClassDeclaration = module.exports.ClassExpression = module.exports.FunctionDeclaration = module.exports.ArrowFunctionExpression = module.exports.FunctionExpression = $3d36302920c79526$var$Func;
Object.defineProperty(module.exports, "Identifier", {
    enumerable: true,
    get: function() {
        return $kVcXi.default;
    }
});
module.exports.LogicalExpression = $3d36302920c79526$var$LogicalExpression;
module.exports.NewExpression = $3d36302920c79526$var$NewExpression;
module.exports.NullLiteral = $3d36302920c79526$var$NullLiteral;
module.exports.NumericLiteral = $3d36302920c79526$var$NumericLiteral;
module.exports.ObjectExpression = $3d36302920c79526$var$ObjectExpression;
module.exports.ParenthesizedExpression = $3d36302920c79526$var$ParenthesizedExpression;
module.exports.RegExpLiteral = $3d36302920c79526$var$RegExpLiteral;
module.exports.RestElement = $3d36302920c79526$var$RestElement;
module.exports.SequenceExpression = $3d36302920c79526$var$SequenceExpression;
module.exports.StringLiteral = $3d36302920c79526$var$StringLiteral;
module.exports.TSAsExpression = $3d36302920c79526$var$TSAsExpression;
module.exports.TSNonNullExpression = $3d36302920c79526$var$TSNonNullExpression;
module.exports.TaggedTemplateExpression = $3d36302920c79526$var$TaggedTemplateExpression;
module.exports.TemplateLiteral = $3d36302920c79526$var$TemplateLiteral;
module.exports.TypeCastExpression = $3d36302920c79526$var$TypeCastExpression;
module.exports.UnaryExpression = $3d36302920c79526$var$UnaryExpression;
module.exports.UpdateExpression = $3d36302920c79526$var$UpdateExpression;
module.exports.VariableDeclarator = $3d36302920c79526$var$VariableDeclarator;

var $ardUq = parcelRequire("ardUq");

var $kVcXi = parcelRequire("kVcXi");

var $2Yaky = parcelRequire("2Yaky");
const { BOOLEAN_BINARY_OPERATORS: $3d36302920c79526$var$BOOLEAN_BINARY_OPERATORS, BOOLEAN_UNARY_OPERATORS: $3d36302920c79526$var$BOOLEAN_UNARY_OPERATORS, NUMBER_BINARY_OPERATORS: $3d36302920c79526$var$NUMBER_BINARY_OPERATORS, NUMBER_UNARY_OPERATORS: $3d36302920c79526$var$NUMBER_UNARY_OPERATORS, STRING_UNARY_OPERATORS: $3d36302920c79526$var$STRING_UNARY_OPERATORS, anyTypeAnnotation: $3d36302920c79526$var$anyTypeAnnotation, arrayTypeAnnotation: $3d36302920c79526$var$arrayTypeAnnotation, booleanTypeAnnotation: $3d36302920c79526$var$booleanTypeAnnotation, buildMatchMemberExpression: $3d36302920c79526$var$buildMatchMemberExpression, genericTypeAnnotation: $3d36302920c79526$var$genericTypeAnnotation, identifier: $3d36302920c79526$var$identifier, nullLiteralTypeAnnotation: $3d36302920c79526$var$nullLiteralTypeAnnotation, numberTypeAnnotation: $3d36302920c79526$var$numberTypeAnnotation, stringTypeAnnotation: $3d36302920c79526$var$stringTypeAnnotation, tupleTypeAnnotation: $3d36302920c79526$var$tupleTypeAnnotation, unionTypeAnnotation: $3d36302920c79526$var$unionTypeAnnotation, voidTypeAnnotation: $3d36302920c79526$var$voidTypeAnnotation, isIdentifier: $3d36302920c79526$var$isIdentifier } = $ardUq;
function $3d36302920c79526$var$VariableDeclarator() {
    if (!this.get("id").isIdentifier()) return;
    return this.get("init").getTypeAnnotation();
}
function $3d36302920c79526$var$TypeCastExpression(node) {
    return node.typeAnnotation;
}
$3d36302920c79526$var$TypeCastExpression.validParent = true;
function $3d36302920c79526$var$TSAsExpression(node) {
    return node.typeAnnotation;
}
$3d36302920c79526$var$TSAsExpression.validParent = true;
function $3d36302920c79526$var$TSNonNullExpression() {
    return this.get("expression").getTypeAnnotation();
}
function $3d36302920c79526$var$NewExpression(node) {
    if (node.callee.type === "Identifier") return $3d36302920c79526$var$genericTypeAnnotation(node.callee);
}
function $3d36302920c79526$var$TemplateLiteral() {
    return $3d36302920c79526$var$stringTypeAnnotation();
}
function $3d36302920c79526$var$UnaryExpression(node) {
    const operator = node.operator;
    if (operator === "void") return $3d36302920c79526$var$voidTypeAnnotation();
    else if ($3d36302920c79526$var$NUMBER_UNARY_OPERATORS.indexOf(operator) >= 0) return $3d36302920c79526$var$numberTypeAnnotation();
    else if ($3d36302920c79526$var$STRING_UNARY_OPERATORS.indexOf(operator) >= 0) return $3d36302920c79526$var$stringTypeAnnotation();
    else if ($3d36302920c79526$var$BOOLEAN_UNARY_OPERATORS.indexOf(operator) >= 0) return $3d36302920c79526$var$booleanTypeAnnotation();
}
function $3d36302920c79526$var$BinaryExpression(node) {
    const operator = node.operator;
    if ($3d36302920c79526$var$NUMBER_BINARY_OPERATORS.indexOf(operator) >= 0) return $3d36302920c79526$var$numberTypeAnnotation();
    else if ($3d36302920c79526$var$BOOLEAN_BINARY_OPERATORS.indexOf(operator) >= 0) return $3d36302920c79526$var$booleanTypeAnnotation();
    else if (operator === "+") {
        const right = this.get("right");
        const left = this.get("left");
        if (left.isBaseType("number") && right.isBaseType("number")) return $3d36302920c79526$var$numberTypeAnnotation();
        else if (left.isBaseType("string") || right.isBaseType("string")) return $3d36302920c79526$var$stringTypeAnnotation();
        return $3d36302920c79526$var$unionTypeAnnotation([
            $3d36302920c79526$var$stringTypeAnnotation(),
            $3d36302920c79526$var$numberTypeAnnotation()
        ]);
    }
}
function $3d36302920c79526$var$LogicalExpression() {
    const argumentTypes = [
        this.get("left").getTypeAnnotation(),
        this.get("right").getTypeAnnotation()
    ];
    return (0, $2Yaky.createUnionType)(argumentTypes);
}
function $3d36302920c79526$var$ConditionalExpression() {
    const argumentTypes = [
        this.get("consequent").getTypeAnnotation(),
        this.get("alternate").getTypeAnnotation()
    ];
    return (0, $2Yaky.createUnionType)(argumentTypes);
}
function $3d36302920c79526$var$SequenceExpression() {
    return this.get("expressions").pop().getTypeAnnotation();
}
function $3d36302920c79526$var$ParenthesizedExpression() {
    return this.get("expression").getTypeAnnotation();
}
function $3d36302920c79526$var$AssignmentExpression() {
    return this.get("right").getTypeAnnotation();
}
function $3d36302920c79526$var$UpdateExpression(node) {
    const operator = node.operator;
    if (operator === "++" || operator === "--") return $3d36302920c79526$var$numberTypeAnnotation();
}
function $3d36302920c79526$var$StringLiteral() {
    return $3d36302920c79526$var$stringTypeAnnotation();
}
function $3d36302920c79526$var$NumericLiteral() {
    return $3d36302920c79526$var$numberTypeAnnotation();
}
function $3d36302920c79526$var$BooleanLiteral() {
    return $3d36302920c79526$var$booleanTypeAnnotation();
}
function $3d36302920c79526$var$NullLiteral() {
    return $3d36302920c79526$var$nullLiteralTypeAnnotation();
}
function $3d36302920c79526$var$RegExpLiteral() {
    return $3d36302920c79526$var$genericTypeAnnotation($3d36302920c79526$var$identifier("RegExp"));
}
function $3d36302920c79526$var$ObjectExpression() {
    return $3d36302920c79526$var$genericTypeAnnotation($3d36302920c79526$var$identifier("Object"));
}
function $3d36302920c79526$var$ArrayExpression() {
    return $3d36302920c79526$var$genericTypeAnnotation($3d36302920c79526$var$identifier("Array"));
}
function $3d36302920c79526$var$RestElement() {
    return $3d36302920c79526$var$ArrayExpression();
}
$3d36302920c79526$var$RestElement.validParent = true;
function $3d36302920c79526$var$Func() {
    return $3d36302920c79526$var$genericTypeAnnotation($3d36302920c79526$var$identifier("Function"));
}
const $3d36302920c79526$var$isArrayFrom = $3d36302920c79526$var$buildMatchMemberExpression("Array.from");
const $3d36302920c79526$var$isObjectKeys = $3d36302920c79526$var$buildMatchMemberExpression("Object.keys");
const $3d36302920c79526$var$isObjectValues = $3d36302920c79526$var$buildMatchMemberExpression("Object.values");
const $3d36302920c79526$var$isObjectEntries = $3d36302920c79526$var$buildMatchMemberExpression("Object.entries");
function $3d36302920c79526$var$CallExpression() {
    const { callee: callee } = this.node;
    if ($3d36302920c79526$var$isObjectKeys(callee)) return $3d36302920c79526$var$arrayTypeAnnotation($3d36302920c79526$var$stringTypeAnnotation());
    else if ($3d36302920c79526$var$isArrayFrom(callee) || $3d36302920c79526$var$isObjectValues(callee) || $3d36302920c79526$var$isIdentifier(callee, {
        name: "Array"
    })) return $3d36302920c79526$var$arrayTypeAnnotation($3d36302920c79526$var$anyTypeAnnotation());
    else if ($3d36302920c79526$var$isObjectEntries(callee)) return $3d36302920c79526$var$arrayTypeAnnotation($3d36302920c79526$var$tupleTypeAnnotation([
        $3d36302920c79526$var$stringTypeAnnotation(),
        $3d36302920c79526$var$anyTypeAnnotation()
    ]));
    return $3d36302920c79526$var$resolveCall(this.get("callee"));
}
function $3d36302920c79526$var$TaggedTemplateExpression() {
    return $3d36302920c79526$var$resolveCall(this.get("tag"));
}
function $3d36302920c79526$var$resolveCall(callee) {
    callee = callee.resolve();
    if (callee.isFunction()) {
        const { node: node } = callee;
        if (node.async) {
            if (node.generator) return $3d36302920c79526$var$genericTypeAnnotation($3d36302920c79526$var$identifier("AsyncIterator"));
            else return $3d36302920c79526$var$genericTypeAnnotation($3d36302920c79526$var$identifier("Promise"));
        } else {
            if (node.generator) return $3d36302920c79526$var$genericTypeAnnotation($3d36302920c79526$var$identifier("Iterator"));
            else if (callee.node.returnType) return callee.node.returnType;
        }
    }
}

});
parcelRegister("kVcXi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f3b32e35ea4d9d6f$var$_default;

var $ardUq = parcelRequire("ardUq");

var $2Yaky = parcelRequire("2Yaky");
const { BOOLEAN_NUMBER_BINARY_OPERATORS: $f3b32e35ea4d9d6f$var$BOOLEAN_NUMBER_BINARY_OPERATORS, createTypeAnnotationBasedOnTypeof: $f3b32e35ea4d9d6f$var$createTypeAnnotationBasedOnTypeof, numberTypeAnnotation: $f3b32e35ea4d9d6f$var$numberTypeAnnotation, voidTypeAnnotation: $f3b32e35ea4d9d6f$var$voidTypeAnnotation } = $ardUq;
function $f3b32e35ea4d9d6f$var$_default(node) {
    if (!this.isReferenced()) return;
    const binding = this.scope.getBinding(node.name);
    if (binding) {
        if (binding.identifier.typeAnnotation) return binding.identifier.typeAnnotation;
        else return $f3b32e35ea4d9d6f$var$getTypeAnnotationBindingConstantViolations(binding, this, node.name);
    }
    if (node.name === "undefined") return $f3b32e35ea4d9d6f$var$voidTypeAnnotation();
    else if (node.name === "NaN" || node.name === "Infinity") return $f3b32e35ea4d9d6f$var$numberTypeAnnotation();
    else node.name;
}
function $f3b32e35ea4d9d6f$var$getTypeAnnotationBindingConstantViolations(binding, path, name) {
    const types = [];
    const functionConstantViolations = [];
    let constantViolations = $f3b32e35ea4d9d6f$var$getConstantViolationsBefore(binding, path, functionConstantViolations);
    const testType = $f3b32e35ea4d9d6f$var$getConditionalAnnotation(binding, path, name);
    if (testType) {
        const testConstantViolations = $f3b32e35ea4d9d6f$var$getConstantViolationsBefore(binding, testType.ifStatement);
        constantViolations = constantViolations.filter((path)=>testConstantViolations.indexOf(path) < 0);
        types.push(testType.typeAnnotation);
    }
    if (constantViolations.length) {
        constantViolations.push(...functionConstantViolations);
        for (const violation of constantViolations)types.push(violation.getTypeAnnotation());
    }
    if (!types.length) return;
    return (0, $2Yaky.createUnionType)(types);
}
function $f3b32e35ea4d9d6f$var$getConstantViolationsBefore(binding, path, functions) {
    const violations = binding.constantViolations.slice();
    violations.unshift(binding.path);
    return violations.filter((violation)=>{
        violation = violation.resolve();
        const status = violation._guessExecutionStatusRelativeTo(path);
        if (functions && status === "unknown") functions.push(violation);
        return status === "before";
    });
}
function $f3b32e35ea4d9d6f$var$inferAnnotationFromBinaryExpression(name, path) {
    const operator = path.node.operator;
    const right = path.get("right").resolve();
    const left = path.get("left").resolve();
    let target;
    if (left.isIdentifier({
        name: name
    })) target = right;
    else if (right.isIdentifier({
        name: name
    })) target = left;
    if (target) {
        if (operator === "===") return target.getTypeAnnotation();
        if ($f3b32e35ea4d9d6f$var$BOOLEAN_NUMBER_BINARY_OPERATORS.indexOf(operator) >= 0) return $f3b32e35ea4d9d6f$var$numberTypeAnnotation();
        return;
    }
    if (operator !== "===" && operator !== "==") return;
    let typeofPath;
    let typePath;
    if (left.isUnaryExpression({
        operator: "typeof"
    })) {
        typeofPath = left;
        typePath = right;
    } else if (right.isUnaryExpression({
        operator: "typeof"
    })) {
        typeofPath = right;
        typePath = left;
    }
    if (!typeofPath) return;
    if (!typeofPath.get("argument").isIdentifier({
        name: name
    })) return;
    typePath = typePath.resolve();
    if (!typePath.isLiteral()) return;
    const typeValue = typePath.node.value;
    if (typeof typeValue !== "string") return;
    return $f3b32e35ea4d9d6f$var$createTypeAnnotationBasedOnTypeof(typeValue);
}
function $f3b32e35ea4d9d6f$var$getParentConditionalPath(binding, path, name) {
    let parentPath;
    while(parentPath = path.parentPath){
        if (parentPath.isIfStatement() || parentPath.isConditionalExpression()) {
            if (path.key === "test") return;
            return parentPath;
        }
        if (parentPath.isFunction()) {
            if (parentPath.parentPath.scope.getBinding(name) !== binding) return;
        }
        path = parentPath;
    }
}
function $f3b32e35ea4d9d6f$var$getConditionalAnnotation(binding, path, name) {
    const ifStatement = $f3b32e35ea4d9d6f$var$getParentConditionalPath(binding, path, name);
    if (!ifStatement) return;
    const test = ifStatement.get("test");
    const paths = [
        test
    ];
    const types = [];
    for(let i = 0; i < paths.length; i++){
        const path = paths[i];
        if (path.isLogicalExpression()) {
            if (path.node.operator === "&&") {
                paths.push(path.get("left"));
                paths.push(path.get("right"));
            }
        } else if (path.isBinaryExpression()) {
            const type = $f3b32e35ea4d9d6f$var$inferAnnotationFromBinaryExpression(name, path);
            if (type) types.push(type);
        }
    }
    if (types.length) return {
        typeAnnotation: (0, $2Yaky.createUnionType)(types),
        ifStatement: ifStatement
    };
    return $f3b32e35ea4d9d6f$var$getConditionalAnnotation(binding, ifStatement, name);
}

});
parcelRegister("2Yaky", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createUnionType = $229932c80453f0ff$var$createUnionType;

var $ardUq = parcelRequire("ardUq");
const { createFlowUnionType: $229932c80453f0ff$var$createFlowUnionType, createTSUnionType: $229932c80453f0ff$var$createTSUnionType, createUnionTypeAnnotation: $229932c80453f0ff$var$createUnionTypeAnnotation, isFlowType: $229932c80453f0ff$var$isFlowType, isTSType: $229932c80453f0ff$var$isTSType } = $ardUq;
function $229932c80453f0ff$var$createUnionType(types) {
    if (types.every((v)=>$229932c80453f0ff$var$isFlowType(v))) {
        if ($229932c80453f0ff$var$createFlowUnionType) return $229932c80453f0ff$var$createFlowUnionType(types);
        return $229932c80453f0ff$var$createUnionTypeAnnotation(types);
    } else if (types.every((v)=>$229932c80453f0ff$var$isTSType(v))) {
        if ($229932c80453f0ff$var$createTSUnionType) return $229932c80453f0ff$var$createTSUnionType(types);
    }
}

});




parcelRegister("6AeM2", function(module, exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports._replaceWith = _replaceWith;
exports.replaceExpressionWithStatements = replaceExpressionWithStatements;
exports.replaceInline = replaceInline;
exports.replaceWith = replaceWith;
exports.replaceWithMultiple = replaceWithMultiple;
exports.replaceWithSourceString = replaceWithSourceString;

var $frkOe = parcelRequire("frkOe");

var $aHxeO = parcelRequire("aHxeO");

var $8zU9J = parcelRequire("8zU9J");

var $ClGPh = parcelRequire("ClGPh");

var $fuTml = parcelRequire("fuTml");

var $ardUq = parcelRequire("ardUq");

var $av6Qj = parcelRequire("av6Qj");
const { FUNCTION_TYPES, arrowFunctionExpression, assignmentExpression, awaitExpression, blockStatement, buildUndefinedNode, callExpression, cloneNode, conditionalExpression, expressionStatement, getBindingIdentifiers, identifier, inheritLeadingComments, inheritTrailingComments, inheritsComments, isBlockStatement, isEmptyStatement, isExpression, isExpressionStatement, isIfStatement, isProgram, isStatement, isVariableDeclaration, removeComments, returnStatement, sequenceExpression, validate, yieldExpression } = $ardUq;
function replaceWithMultiple(nodes) {
    var _getCachedPaths;
    this.resync();
    nodes = this._verifyNodeList(nodes);
    inheritLeadingComments(nodes[0], this.node);
    inheritTrailingComments(nodes[nodes.length - 1], this.node);
    (_getCachedPaths = (0, $ClGPh.getCachedPaths)(this.hub, this.parent)) == null || _getCachedPaths.delete(this.node);
    this.node = this.container[this.key] = null;
    const paths = this.insertAfter(nodes);
    if (this.node) this.requeue();
    else this.remove();
    return paths;
}
function replaceWithSourceString(replacement) {
    this.resync();
    let ast;
    try {
        replacement = `(${replacement})`;
        ast = (0, $fuTml.parse)(replacement);
    } catch (err) {
        const loc = err.loc;
        if (loc) {
            err.message += " - make sure this is an expression.\n" + (0, $frkOe.codeFrameColumns)(replacement, {
                start: {
                    line: loc.line,
                    column: loc.column + 1
                }
            });
            err.code = "BABEL_REPLACE_SOURCE_ERROR";
        }
        throw err;
    }
    const expressionAST = ast.program.body[0].expression;
    $aHxeO.default.removeProperties(expressionAST);
    return this.replaceWith(expressionAST);
}
function replaceWith(replacementPath) {
    this.resync();
    if (this.removed) throw new Error("You can't replace this node, we've already removed it");
    let replacement = replacementPath instanceof $8zU9J.default ? replacementPath.node : replacementPath;
    if (!replacement) throw new Error("You passed `path.replaceWith()` a falsy node, use `path.remove()` instead");
    if (this.node === replacement) return [
        this
    ];
    if (this.isProgram() && !isProgram(replacement)) throw new Error("You can only replace a Program root node with another Program node");
    if (Array.isArray(replacement)) throw new Error("Don't use `path.replaceWith()` with an array of nodes, use `path.replaceWithMultiple()`");
    if (typeof replacement === "string") throw new Error("Don't use `path.replaceWith()` with a source string, use `path.replaceWithSourceString()`");
    let nodePath = "";
    if (this.isNodeType("Statement") && isExpression(replacement)) {
        if (!this.canHaveVariableDeclarationOrExpression() && !this.canSwapBetweenExpressionAndStatement(replacement) && !this.parentPath.isExportDefaultDeclaration()) {
            replacement = expressionStatement(replacement);
            nodePath = "expression";
        }
    }
    if (this.isNodeType("Expression") && isStatement(replacement)) {
        if (!this.canHaveVariableDeclarationOrExpression() && !this.canSwapBetweenExpressionAndStatement(replacement)) return this.replaceExpressionWithStatements([
            replacement
        ]);
    }
    const oldNode = this.node;
    if (oldNode) {
        inheritsComments(replacement, oldNode);
        removeComments(oldNode);
    }
    this._replaceWith(replacement);
    this.type = replacement.type;
    this.setScope();
    this.requeue();
    return [
        nodePath ? this.get(nodePath) : this
    ];
}
function _replaceWith(node) {
    var _getCachedPaths2;
    if (!this.container) throw new ReferenceError("Container is falsy");
    if (this.inList) validate(this.parent, this.key, [
        node
    ]);
    else validate(this.parent, this.key, node);
    this.debug(`Replace with ${node == null ? void 0 : node.type}`);
    (_getCachedPaths2 = (0, $ClGPh.getCachedPaths)(this.hub, this.parent)) == null || _getCachedPaths2.set(node, this).delete(this.node);
    this.node = this.container[this.key] = node;
}
function replaceExpressionWithStatements(nodes) {
    this.resync();
    const declars = [];
    const nodesAsSingleExpression = gatherSequenceExpressions(nodes, declars);
    if (nodesAsSingleExpression) {
        for (const id of declars)this.scope.push({
            id: id
        });
        return this.replaceWith(nodesAsSingleExpression)[0].get("expressions");
    }
    const functionParent = this.getFunctionParent();
    const isParentAsync = functionParent == null ? void 0 : functionParent.is("async");
    const isParentGenerator = functionParent == null ? void 0 : functionParent.is("generator");
    const container = arrowFunctionExpression([], blockStatement(nodes));
    this.replaceWith(callExpression(container, []));
    const callee = this.get("callee");
    (0, $av6Qj.default)(callee.get("body"), (id)=>{
        this.scope.push({
            id: id
        });
    }, "var");
    const completionRecords = this.get("callee").getCompletionRecords();
    for (const path of completionRecords){
        if (!path.isExpressionStatement()) continue;
        const loop = path.findParent((path)=>path.isLoop());
        if (loop) {
            let uid = loop.getData("expressionReplacementReturnUid");
            if (!uid) {
                uid = callee.scope.generateDeclaredUidIdentifier("ret");
                callee.get("body").pushContainer("body", returnStatement(cloneNode(uid)));
                loop.setData("expressionReplacementReturnUid", uid);
            } else uid = identifier(uid.name);
            path.get("expression").replaceWith(assignmentExpression("=", cloneNode(uid), path.node.expression));
        } else path.replaceWith(returnStatement(path.node.expression));
    }
    callee.arrowFunctionToExpression();
    const newCallee = callee;
    const needToAwaitFunction = isParentAsync && $aHxeO.default.hasType(this.get("callee.body").node, "AwaitExpression", FUNCTION_TYPES);
    const needToYieldFunction = isParentGenerator && $aHxeO.default.hasType(this.get("callee.body").node, "YieldExpression", FUNCTION_TYPES);
    if (needToAwaitFunction) {
        newCallee.set("async", true);
        if (!needToYieldFunction) this.replaceWith(awaitExpression(this.node));
    }
    if (needToYieldFunction) {
        newCallee.set("generator", true);
        this.replaceWith(yieldExpression(this.node, true));
    }
    return newCallee.get("body.body");
}
function gatherSequenceExpressions(nodes, declars) {
    const exprs = [];
    let ensureLastUndefined = true;
    for (const node of nodes){
        if (!isEmptyStatement(node)) ensureLastUndefined = false;
        if (isExpression(node)) exprs.push(node);
        else if (isExpressionStatement(node)) exprs.push(node.expression);
        else if (isVariableDeclaration(node)) {
            if (node.kind !== "var") return;
            for (const declar of node.declarations){
                const bindings = getBindingIdentifiers(declar);
                for (const key of Object.keys(bindings))declars.push(cloneNode(bindings[key]));
                if (declar.init) exprs.push(assignmentExpression("=", declar.id, declar.init));
            }
            ensureLastUndefined = true;
        } else if (isIfStatement(node)) {
            const consequent = node.consequent ? gatherSequenceExpressions([
                node.consequent
            ], declars) : buildUndefinedNode();
            const alternate = node.alternate ? gatherSequenceExpressions([
                node.alternate
            ], declars) : buildUndefinedNode();
            if (!consequent || !alternate) return;
            exprs.push(conditionalExpression(node.test, consequent, alternate));
        } else if (isBlockStatement(node)) {
            const body = gatherSequenceExpressions(node.body, declars);
            if (!body) return;
            exprs.push(body);
        } else if (isEmptyStatement(node)) {
            if (nodes.indexOf(node) === 0) ensureLastUndefined = true;
        } else return;
    }
    if (ensureLastUndefined) exprs.push(buildUndefinedNode());
    if (exprs.length === 1) return exprs[0];
    else return sequenceExpression(exprs);
}
function replaceInline(nodes) {
    this.resync();
    if (Array.isArray(nodes)) {
        if (Array.isArray(this.container)) {
            nodes = this._verifyNodeList(nodes);
            const paths = this._containerInsertAfter(nodes);
            this.remove();
            return paths;
        } else return this.replaceWithMultiple(nodes);
    } else return this.replaceWith(nodes);
}

});
parcelRegister("frkOe", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.codeFrameColumns = $b3d984e10ce5df4d$var$codeFrameColumns;
module.exports.default = $b3d984e10ce5df4d$var$_default;

var $2AREh = parcelRequire("2AREh");

var $b3d984e10ce5df4d$var$_picocolors = $b3d984e10ce5df4d$var$_interopRequireWildcard((parcelRequire("lrcwG")), true);
function $b3d984e10ce5df4d$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($b3d984e10ce5df4d$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $b3d984e10ce5df4d$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $b3d984e10ce5df4d$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
const $b3d984e10ce5df4d$var$colors = (typeof $hPtJY === "object" && false, $b3d984e10ce5df4d$var$_picocolors.default);
const $b3d984e10ce5df4d$var$compose = (f, g)=>(v)=>f(g(v));
let $b3d984e10ce5df4d$var$pcWithForcedColor = undefined;
function $b3d984e10ce5df4d$var$getColors(forceColor) {
    if (forceColor) {
        var _pcWithForcedColor;
        (_pcWithForcedColor = $b3d984e10ce5df4d$var$pcWithForcedColor) != null ? _pcWithForcedColor : $b3d984e10ce5df4d$var$pcWithForcedColor = (0, $b3d984e10ce5df4d$var$_picocolors.createColors)(true);
        return $b3d984e10ce5df4d$var$pcWithForcedColor;
    }
    return $b3d984e10ce5df4d$var$colors;
}
let $b3d984e10ce5df4d$var$deprecationWarningShown = false;
function $b3d984e10ce5df4d$var$getDefs(colors) {
    return {
        gutter: colors.gray,
        marker: $b3d984e10ce5df4d$var$compose(colors.red, colors.bold),
        message: $b3d984e10ce5df4d$var$compose(colors.red, colors.bold)
    };
}
const $b3d984e10ce5df4d$var$NEWLINE = /\r\n|[\n\r\u2028\u2029]/;
function $b3d984e10ce5df4d$var$getMarkerLines(loc, source, opts) {
    const startLoc = Object.assign({
        column: 0,
        line: -1
    }, loc.start);
    const endLoc = Object.assign({}, startLoc, loc.end);
    const { linesAbove: linesAbove = 2, linesBelow: linesBelow = 3 } = opts || {};
    const startLine = startLoc.line;
    const startColumn = startLoc.column;
    const endLine = endLoc.line;
    const endColumn = endLoc.column;
    let start = Math.max(startLine - (linesAbove + 1), 0);
    let end = Math.min(source.length, endLine + linesBelow);
    if (startLine === -1) start = 0;
    if (endLine === -1) end = source.length;
    const lineDiff = endLine - startLine;
    const markerLines = {};
    if (lineDiff) for(let i = 0; i <= lineDiff; i++){
        const lineNumber = i + startLine;
        if (!startColumn) markerLines[lineNumber] = true;
        else if (i === 0) {
            const sourceLength = source[lineNumber - 1].length;
            markerLines[lineNumber] = [
                startColumn,
                sourceLength - startColumn + 1
            ];
        } else if (i === lineDiff) markerLines[lineNumber] = [
            0,
            endColumn
        ];
        else {
            const sourceLength = source[lineNumber - i].length;
            markerLines[lineNumber] = [
                0,
                sourceLength
            ];
        }
    }
    else if (startColumn === endColumn) {
        if (startColumn) markerLines[startLine] = [
            startColumn,
            0
        ];
        else markerLines[startLine] = true;
    } else markerLines[startLine] = [
        startColumn,
        endColumn - startColumn
    ];
    return {
        start: start,
        end: end,
        markerLines: markerLines
    };
}
function $b3d984e10ce5df4d$var$codeFrameColumns(rawLines, loc, opts = {}) {
    const highlighted = (opts.highlightCode || opts.forceColor) && (0, $2AREh.shouldHighlight)(opts);
    const colors = $b3d984e10ce5df4d$var$getColors(opts.forceColor);
    const defs = $b3d984e10ce5df4d$var$getDefs(colors);
    const maybeHighlight = (fmt, string)=>{
        return highlighted ? fmt(string) : string;
    };
    const lines = rawLines.split($b3d984e10ce5df4d$var$NEWLINE);
    const { start: start, end: end, markerLines: markerLines } = $b3d984e10ce5df4d$var$getMarkerLines(loc, lines, opts);
    const hasColumns = loc.start && typeof loc.start.column === "number";
    const numberMaxWidth = String(end).length;
    const highlightedLines = highlighted ? (0, $2AREh.default)(rawLines, opts) : rawLines;
    let frame = highlightedLines.split($b3d984e10ce5df4d$var$NEWLINE, end).slice(start, end).map((line, index)=>{
        const number = start + 1 + index;
        const paddedNumber = ` ${number}`.slice(-numberMaxWidth);
        const gutter = ` ${paddedNumber} |`;
        const hasMarker = markerLines[number];
        const lastMarkerLine = !markerLines[number + 1];
        if (hasMarker) {
            let markerLine = "";
            if (Array.isArray(hasMarker)) {
                const markerSpacing = line.slice(0, Math.max(hasMarker[0] - 1, 0)).replace(/[^\t]/g, " ");
                const numberOfMarkers = hasMarker[1] || 1;
                markerLine = [
                    "\n ",
                    maybeHighlight(defs.gutter, gutter.replace(/\d/g, " ")),
                    " ",
                    markerSpacing,
                    maybeHighlight(defs.marker, "^").repeat(numberOfMarkers)
                ].join("");
                if (lastMarkerLine && opts.message) markerLine += " " + maybeHighlight(defs.message, opts.message);
            }
            return [
                maybeHighlight(defs.marker, ">"),
                maybeHighlight(defs.gutter, gutter),
                line.length > 0 ? ` ${line}` : "",
                markerLine
            ].join("");
        } else return ` ${maybeHighlight(defs.gutter, gutter)}${line.length > 0 ? ` ${line}` : ""}`;
    }).join("\n");
    if (opts.message && !hasColumns) frame = `${" ".repeat(numberMaxWidth + 1)}${opts.message}\n${frame}`;
    if (highlighted) return colors.reset(frame);
    else return frame;
}
function $b3d984e10ce5df4d$var$_default(rawLines, lineNumber, colNumber, opts = {}) {
    if (!$b3d984e10ce5df4d$var$deprecationWarningShown) {
        $b3d984e10ce5df4d$var$deprecationWarningShown = true;
        const message = "Passing lineNumber and colNumber is deprecated to @babel/code-frame. Please use `codeFrameColumns`.";
        if ($hPtJY.emitWarning) $hPtJY.emitWarning(message, "DeprecationWarning");
        else {
            const deprecationError = new Error(message);
            deprecationError.name = "DeprecationWarning";
            console.warn(new Error(message));
        }
    }
    colNumber = Math.max(colNumber, 0);
    const location = {
        start: {
            column: colNumber,
            line: lineNumber
        }
    };
    return $b3d984e10ce5df4d$var$codeFrameColumns(rawLines, location, opts);
}

});
parcelRegister("2AREh", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1e388f16c55cdfac$var$highlight;
module.exports.shouldHighlight = $1e388f16c55cdfac$var$shouldHighlight;

var $fnhE6 = parcelRequire("fnhE6");

var $2Ghih = parcelRequire("2Ghih");

var $1e388f16c55cdfac$var$_picocolors = $1e388f16c55cdfac$var$_interopRequireWildcard((parcelRequire("lrcwG")), true);
function $1e388f16c55cdfac$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($1e388f16c55cdfac$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $1e388f16c55cdfac$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $1e388f16c55cdfac$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
const $1e388f16c55cdfac$var$colors = (typeof $hPtJY === "object" && false, $1e388f16c55cdfac$var$_picocolors.default);
const $1e388f16c55cdfac$var$compose = (f, g)=>(v)=>f(g(v));
const $1e388f16c55cdfac$var$sometimesKeywords = new Set([
    "as",
    "async",
    "from",
    "get",
    "of",
    "set"
]);
function $1e388f16c55cdfac$var$getDefs(colors) {
    return {
        keyword: colors.cyan,
        capitalized: colors.yellow,
        jsxIdentifier: colors.yellow,
        punctuator: colors.yellow,
        number: colors.magenta,
        string: colors.green,
        regex: colors.magenta,
        comment: colors.gray,
        invalid: $1e388f16c55cdfac$var$compose($1e388f16c55cdfac$var$compose(colors.white, colors.bgRed), colors.bold)
    };
}
const $1e388f16c55cdfac$var$NEWLINE = /\r\n|[\n\r\u2028\u2029]/;
const $1e388f16c55cdfac$var$BRACKET = /^[()[\]{}]$/;
let $1e388f16c55cdfac$var$tokenize;
{
    const JSX_TAG = /^[a-z][\w-]*$/i;
    const getTokenType = function(token, offset, text) {
        if (token.type === "name") {
            if ((0, $2Ghih.isKeyword)(token.value) || (0, $2Ghih.isStrictReservedWord)(token.value, true) || $1e388f16c55cdfac$var$sometimesKeywords.has(token.value)) return "keyword";
            if (JSX_TAG.test(token.value) && (text[offset - 1] === "<" || text.slice(offset - 2, offset) == "</")) return "jsxIdentifier";
            if (token.value[0] !== token.value[0].toLowerCase()) return "capitalized";
        }
        if (token.type === "punctuator" && $1e388f16c55cdfac$var$BRACKET.test(token.value)) return "bracket";
        if (token.type === "invalid" && (token.value === "@" || token.value === "#")) return "punctuator";
        return token.type;
    };
    $1e388f16c55cdfac$var$tokenize = function*(text) {
        let match;
        while(match = $fnhE6.default.exec(text)){
            const token = $fnhE6.matchToToken(match);
            yield {
                type: getTokenType(token, match.index, text),
                value: token.value
            };
        }
    };
}function $1e388f16c55cdfac$var$highlightTokens(defs, text) {
    let highlighted = "";
    for (const { type: type, value: value } of $1e388f16c55cdfac$var$tokenize(text)){
        const colorize = defs[type];
        if (colorize) highlighted += value.split($1e388f16c55cdfac$var$NEWLINE).map((str)=>colorize(str)).join("\n");
        else highlighted += value;
    }
    return highlighted;
}
function $1e388f16c55cdfac$var$shouldHighlight(options) {
    return $1e388f16c55cdfac$var$colors.isColorSupported || options.forceColor;
}
let $1e388f16c55cdfac$var$pcWithForcedColor = undefined;
function $1e388f16c55cdfac$var$getColors(forceColor) {
    if (forceColor) {
        var _pcWithForcedColor;
        (_pcWithForcedColor = $1e388f16c55cdfac$var$pcWithForcedColor) != null ? _pcWithForcedColor : $1e388f16c55cdfac$var$pcWithForcedColor = (0, $1e388f16c55cdfac$var$_picocolors.createColors)(true);
        return $1e388f16c55cdfac$var$pcWithForcedColor;
    }
    return $1e388f16c55cdfac$var$colors;
}
function $1e388f16c55cdfac$var$highlight(code, options = {}) {
    if (code !== "" && $1e388f16c55cdfac$var$shouldHighlight(options)) {
        const defs = $1e388f16c55cdfac$var$getDefs($1e388f16c55cdfac$var$getColors(options.forceColor));
        return $1e388f16c55cdfac$var$highlightTokens(defs, code);
    } else return code;
}

{
    let chalk, chalkWithForcedColor;
    module.exports.getChalk = ({ forceColor: forceColor })=>{
        var _chalk;
        (_chalk = chalk) != null ? _chalk : chalk = (parcelRequire("kyStk"));
        if (forceColor) {
            var _chalkWithForcedColor;
            (_chalkWithForcedColor = chalkWithForcedColor) != null ? _chalkWithForcedColor : chalkWithForcedColor = new chalk.constructor({
                enabled: true,
                level: 1
            });
            return chalkWithForcedColor;
        }
        return chalk;
    };
}
});
parcelRegister("fnhE6", function(module, exports) {
// Copyright 2014, 2015, 2016, 2017, 2018 Simon Lydell
// License: MIT. (See LICENSE.)
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
// This regex comes from regex.coffee, and is inserted here by generate-index.js
// (run `npm run build`).
module.exports.default = /((['"])(?:(?!\2|\\).|\\(?:\r\n|[\s\S]))*(\2)?|`(?:[^`\\$]|\\[\s\S]|\$(?!\{)|\$\{(?:[^{}]|\{[^}]*\}?)*\}?)*(`)?)|(\/\/.*)|(\/\*(?:[^*]|\*(?!\/))*(\*\/)?)|(\/(?!\*)(?:\[(?:(?![\]\\]).|\\.)*\]|(?![\/\]\\]).|\\.)+\/(?:(?!\s*(?:\b|[\u0080-\uFFFF$\\'"~({]|[+\-!](?!=)|\.?\d))|[gmiyus]{1,6}\b(?![\u0080-\uFFFF$\\]|\s*(?:[+\-*%&|^<>!=?({]|\/(?![\/*])))))|(0[xX][\da-fA-F]+|0[oO][0-7]+|0[bB][01]+|(?:\d*\.\d+|\d+\.?)(?:[eE][+-]?\d+)?)|((?!\d)(?:(?!\s)[$\w\u0080-\uFFFF]|\\u[\da-fA-F]{4}|\\u\{[\da-fA-F]+\})+)|(--|\+\+|&&|\|\||=>|\.{3}|(?:[+\-\/%&|^]|\*{1,2}|<{1,2}|>{1,3}|!=?|={1,2})=?|[?~.,:;[\](){}])|(\s+)|(^$|[\s\S])/g;
module.exports.matchToToken = function(match) {
    var token = {
        type: "invalid",
        value: match[0],
        closed: undefined
    };
    if (match[1]) token.type = "string", token.closed = !!(match[3] || match[4]);
    else if (match[5]) token.type = "comment";
    else if (match[6]) token.type = "comment", token.closed = !!match[7];
    else if (match[8]) token.type = "regex";
    else if (match[9]) token.type = "number";
    else if (match[10]) token.type = "name";
    else if (match[11]) token.type = "punctuator";
    else if (match[12]) token.type = "whitespace";
    return token;
};

});

parcelRegister("lrcwG", function(module, exports) {
var $f9b5d605f52d8009$var$x = String;
var $f9b5d605f52d8009$var$create = function() {
    return {
        isColorSupported: false,
        reset: $f9b5d605f52d8009$var$x,
        bold: $f9b5d605f52d8009$var$x,
        dim: $f9b5d605f52d8009$var$x,
        italic: $f9b5d605f52d8009$var$x,
        underline: $f9b5d605f52d8009$var$x,
        inverse: $f9b5d605f52d8009$var$x,
        hidden: $f9b5d605f52d8009$var$x,
        strikethrough: $f9b5d605f52d8009$var$x,
        black: $f9b5d605f52d8009$var$x,
        red: $f9b5d605f52d8009$var$x,
        green: $f9b5d605f52d8009$var$x,
        yellow: $f9b5d605f52d8009$var$x,
        blue: $f9b5d605f52d8009$var$x,
        magenta: $f9b5d605f52d8009$var$x,
        cyan: $f9b5d605f52d8009$var$x,
        white: $f9b5d605f52d8009$var$x,
        gray: $f9b5d605f52d8009$var$x,
        bgBlack: $f9b5d605f52d8009$var$x,
        bgRed: $f9b5d605f52d8009$var$x,
        bgGreen: $f9b5d605f52d8009$var$x,
        bgYellow: $f9b5d605f52d8009$var$x,
        bgBlue: $f9b5d605f52d8009$var$x,
        bgMagenta: $f9b5d605f52d8009$var$x,
        bgCyan: $f9b5d605f52d8009$var$x,
        bgWhite: $f9b5d605f52d8009$var$x
    };
};
module.exports = $f9b5d605f52d8009$var$create();
module.exports.createColors = $f9b5d605f52d8009$var$create;

});

parcelRegister("kyStk", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
"use strict";

var $jgDxg = parcelRequire("jgDxg");

var $1vr75 = parcelRequire("1vr75");

var $hE0mt = parcelRequire("hE0mt");
var $ef813c9c3140a730$require$stdoutColor = $hE0mt.stdout;

var $eKHuM = parcelRequire("eKHuM");
const $ef813c9c3140a730$var$isSimpleWindowsTerm = $hPtJY.platform === "win32" && !"".toLowerCase().startsWith("xterm");
// `supportsColor.level` → `ansiStyles.color[name]` mapping
const $ef813c9c3140a730$var$levelMapping = [
    "ansi",
    "ansi",
    "ansi256",
    "ansi16m"
];
// `color-convert` models to exclude from the Chalk API due to conflicts and such
const $ef813c9c3140a730$var$skipModels = new Set([
    "gray"
]);
const $ef813c9c3140a730$var$styles = Object.create(null);
function $ef813c9c3140a730$var$applyOptions(obj, options) {
    options = options || {};
    // Detect level if not set manually
    const scLevel = $ef813c9c3140a730$require$stdoutColor ? $ef813c9c3140a730$require$stdoutColor.level : 0;
    obj.level = options.level === undefined ? scLevel : options.level;
    obj.enabled = "enabled" in options ? options.enabled : obj.level > 0;
}
function $ef813c9c3140a730$var$Chalk(options) {
    // We check for this.template here since calling `chalk.constructor()`
    // by itself will have a `this` of a previously constructed chalk object
    if (!this || !(this instanceof $ef813c9c3140a730$var$Chalk) || this.template) {
        const chalk = {};
        $ef813c9c3140a730$var$applyOptions(chalk, options);
        chalk.template = function() {
            const args = [].slice.call(arguments);
            return $ef813c9c3140a730$var$chalkTag.apply(null, [
                chalk.template
            ].concat(args));
        };
        Object.setPrototypeOf(chalk, $ef813c9c3140a730$var$Chalk.prototype);
        Object.setPrototypeOf(chalk.template, chalk);
        chalk.template.constructor = $ef813c9c3140a730$var$Chalk;
        return chalk.template;
    }
    $ef813c9c3140a730$var$applyOptions(this, options);
}
// Use bright blue on Windows as the normal blue color is illegible
if ($ef813c9c3140a730$var$isSimpleWindowsTerm) $1vr75.blue.open = "\x1b[94m";
for (const key of Object.keys($1vr75)){
    $1vr75[key].closeRe = new RegExp($jgDxg($1vr75[key].close), "g");
    $ef813c9c3140a730$var$styles[key] = {
        get () {
            const codes = $1vr75[key];
            return $ef813c9c3140a730$var$build.call(this, this._styles ? this._styles.concat(codes) : [
                codes
            ], this._empty, key);
        }
    };
}
$ef813c9c3140a730$var$styles.visible = {
    get () {
        return $ef813c9c3140a730$var$build.call(this, this._styles || [], true, "visible");
    }
};
$1vr75.color.closeRe = new RegExp($jgDxg($1vr75.color.close), "g");
for (const model of Object.keys($1vr75.color.ansi)){
    if ($ef813c9c3140a730$var$skipModels.has(model)) continue;
    $ef813c9c3140a730$var$styles[model] = {
        get () {
            const level = this.level;
            return function() {
                const open = $1vr75.color[$ef813c9c3140a730$var$levelMapping[level]][model].apply(null, arguments);
                const codes = {
                    open: open,
                    close: $1vr75.color.close,
                    closeRe: $1vr75.color.closeRe
                };
                return $ef813c9c3140a730$var$build.call(this, this._styles ? this._styles.concat(codes) : [
                    codes
                ], this._empty, model);
            };
        }
    };
}
$1vr75.bgColor.closeRe = new RegExp($jgDxg($1vr75.bgColor.close), "g");
for (const model of Object.keys($1vr75.bgColor.ansi)){
    if ($ef813c9c3140a730$var$skipModels.has(model)) continue;
    const bgModel = "bg" + model[0].toUpperCase() + model.slice(1);
    $ef813c9c3140a730$var$styles[bgModel] = {
        get () {
            const level = this.level;
            return function() {
                const open = $1vr75.bgColor[$ef813c9c3140a730$var$levelMapping[level]][model].apply(null, arguments);
                const codes = {
                    open: open,
                    close: $1vr75.bgColor.close,
                    closeRe: $1vr75.bgColor.closeRe
                };
                return $ef813c9c3140a730$var$build.call(this, this._styles ? this._styles.concat(codes) : [
                    codes
                ], this._empty, model);
            };
        }
    };
}
const $ef813c9c3140a730$var$proto = Object.defineProperties(()=>{}, $ef813c9c3140a730$var$styles);
function $ef813c9c3140a730$var$build(_styles, _empty, key) {
    const builder = function() {
        return $ef813c9c3140a730$var$applyStyle.apply(builder, arguments);
    };
    builder._styles = _styles;
    builder._empty = _empty;
    const self = this;
    Object.defineProperty(builder, "level", {
        enumerable: true,
        get () {
            return self.level;
        },
        set (level) {
            self.level = level;
        }
    });
    Object.defineProperty(builder, "enabled", {
        enumerable: true,
        get () {
            return self.enabled;
        },
        set (enabled) {
            self.enabled = enabled;
        }
    });
    // See below for fix regarding invisible grey/dim combination on Windows
    builder.hasGrey = this.hasGrey || key === "gray" || key === "grey";
    // `__proto__` is used because we must return a function, but there is
    // no way to create a function with a different prototype
    builder.__proto__ = $ef813c9c3140a730$var$proto; // eslint-disable-line no-proto
    return builder;
}
function $ef813c9c3140a730$var$applyStyle() {
    // Support varags, but simply cast to string in case there's only one arg
    const args = arguments;
    const argsLen = args.length;
    let str = String(arguments[0]);
    if (argsLen === 0) return "";
    if (argsLen > 1) // Don't slice `arguments`, it prevents V8 optimizations
    for(let a = 1; a < argsLen; a++)str += " " + args[a];
    if (!this.enabled || this.level <= 0 || !str) return this._empty ? "" : str;
    // Turns out that on Windows dimmed gray text becomes invisible in cmd.exe,
    // see https://github.com/chalk/chalk/issues/58
    // If we're on Windows and we're dealing with a gray color, temporarily make 'dim' a noop.
    const originalDim = $1vr75.dim.open;
    if ($ef813c9c3140a730$var$isSimpleWindowsTerm && this.hasGrey) $1vr75.dim.open = "";
    for (const code of this._styles.slice().reverse()){
        // Replace any instances already present with a re-opening code
        // otherwise only the part of the string until said closing code
        // will be colored, and the rest will simply be 'plain'.
        str = code.open + str.replace(code.closeRe, code.open) + code.close;
        // Close the styling before a linebreak and reopen
        // after next line to fix a bleed issue on macOS
        // https://github.com/chalk/chalk/pull/92
        str = str.replace(/\r?\n/g, `${code.close}$&${code.open}`);
    }
    // Reset the original `dim` if we changed it to work around the Windows dimmed gray issue
    $1vr75.dim.open = originalDim;
    return str;
}
function $ef813c9c3140a730$var$chalkTag(chalk, strings) {
    if (!Array.isArray(strings)) // If chalk() was called by itself or with a string,
    // return the string itself as a string.
    return [].slice.call(arguments, 1).join(" ");
    const args = [].slice.call(arguments, 2);
    const parts = [
        strings.raw[0]
    ];
    for(let i = 1; i < strings.length; i++){
        parts.push(String(args[i - 1]).replace(/[{}\\]/g, "\\$&"));
        parts.push(String(strings.raw[i]));
    }
    return $eKHuM(chalk, parts.join(""));
}
Object.defineProperties($ef813c9c3140a730$var$Chalk.prototype, $ef813c9c3140a730$var$styles);
module.exports = $ef813c9c3140a730$var$Chalk(); // eslint-disable-line new-cap
module.exports.supportsColor = $ef813c9c3140a730$require$stdoutColor;
module.exports.default = module.exports; // For TypeScript

});
parcelRegister("jgDxg", function(module, exports) {
"use strict";
var $e06e2ddb395f4432$var$matchOperatorsRe = /[|\\{}()[\]^$+*?.]/g;
module.exports = function(str) {
    if (typeof str !== "string") throw new TypeError("Expected a string");
    return str.replace($e06e2ddb395f4432$var$matchOperatorsRe, "\\$&");
};

});

parcelRegister("1vr75", function(module, exports) {
"use strict";

var $cZxrT = parcelRequire("cZxrT");
const wrapAnsi16 = (fn, offset)=>function() {
        const code = fn.apply($cZxrT, arguments);
        return `\u001B[${code + offset}m`;
    };
const wrapAnsi256 = (fn, offset)=>function() {
        const code = fn.apply($cZxrT, arguments);
        return `\u001B[${38 + offset};5;${code}m`;
    };
const wrapAnsi16m = (fn, offset)=>function() {
        const rgb = fn.apply($cZxrT, arguments);
        return `\u001B[${38 + offset};2;${rgb[0]};${rgb[1]};${rgb[2]}m`;
    };
function assembleStyles() {
    const codes = new Map();
    const styles = {
        modifier: {
            reset: [
                0,
                0
            ],
            // 21 isn't widely supported and 22 does the same thing
            bold: [
                1,
                22
            ],
            dim: [
                2,
                22
            ],
            italic: [
                3,
                23
            ],
            underline: [
                4,
                24
            ],
            inverse: [
                7,
                27
            ],
            hidden: [
                8,
                28
            ],
            strikethrough: [
                9,
                29
            ]
        },
        color: {
            black: [
                30,
                39
            ],
            red: [
                31,
                39
            ],
            green: [
                32,
                39
            ],
            yellow: [
                33,
                39
            ],
            blue: [
                34,
                39
            ],
            magenta: [
                35,
                39
            ],
            cyan: [
                36,
                39
            ],
            white: [
                37,
                39
            ],
            gray: [
                90,
                39
            ],
            // Bright color
            redBright: [
                91,
                39
            ],
            greenBright: [
                92,
                39
            ],
            yellowBright: [
                93,
                39
            ],
            blueBright: [
                94,
                39
            ],
            magentaBright: [
                95,
                39
            ],
            cyanBright: [
                96,
                39
            ],
            whiteBright: [
                97,
                39
            ]
        },
        bgColor: {
            bgBlack: [
                40,
                49
            ],
            bgRed: [
                41,
                49
            ],
            bgGreen: [
                42,
                49
            ],
            bgYellow: [
                43,
                49
            ],
            bgBlue: [
                44,
                49
            ],
            bgMagenta: [
                45,
                49
            ],
            bgCyan: [
                46,
                49
            ],
            bgWhite: [
                47,
                49
            ],
            // Bright color
            bgBlackBright: [
                100,
                49
            ],
            bgRedBright: [
                101,
                49
            ],
            bgGreenBright: [
                102,
                49
            ],
            bgYellowBright: [
                103,
                49
            ],
            bgBlueBright: [
                104,
                49
            ],
            bgMagentaBright: [
                105,
                49
            ],
            bgCyanBright: [
                106,
                49
            ],
            bgWhiteBright: [
                107,
                49
            ]
        }
    };
    // Fix humans
    styles.color.grey = styles.color.gray;
    for (const groupName of Object.keys(styles)){
        const group = styles[groupName];
        for (const styleName of Object.keys(group)){
            const style = group[styleName];
            styles[styleName] = {
                open: `\u001B[${style[0]}m`,
                close: `\u001B[${style[1]}m`
            };
            group[styleName] = styles[styleName];
            codes.set(style[0], style[1]);
        }
        Object.defineProperty(styles, groupName, {
            value: group,
            enumerable: false
        });
        Object.defineProperty(styles, "codes", {
            value: codes,
            enumerable: false
        });
    }
    const ansi2ansi = (n)=>n;
    const rgb2rgb = (r, g, b)=>[
            r,
            g,
            b
        ];
    styles.color.close = "\x1b[39m";
    styles.bgColor.close = "\x1b[49m";
    styles.color.ansi = {
        ansi: wrapAnsi16(ansi2ansi, 0)
    };
    styles.color.ansi256 = {
        ansi256: wrapAnsi256(ansi2ansi, 0)
    };
    styles.color.ansi16m = {
        rgb: wrapAnsi16m(rgb2rgb, 0)
    };
    styles.bgColor.ansi = {
        ansi: wrapAnsi16(ansi2ansi, 10)
    };
    styles.bgColor.ansi256 = {
        ansi256: wrapAnsi256(ansi2ansi, 10)
    };
    styles.bgColor.ansi16m = {
        rgb: wrapAnsi16m(rgb2rgb, 10)
    };
    for (let key of Object.keys($cZxrT)){
        if (typeof $cZxrT[key] !== "object") continue;
        const suite = $cZxrT[key];
        if (key === "ansi16") key = "ansi";
        if ("ansi16" in suite) {
            styles.color.ansi[key] = wrapAnsi16(suite.ansi16, 0);
            styles.bgColor.ansi[key] = wrapAnsi16(suite.ansi16, 10);
        }
        if ("ansi256" in suite) {
            styles.color.ansi256[key] = wrapAnsi256(suite.ansi256, 0);
            styles.bgColor.ansi256[key] = wrapAnsi256(suite.ansi256, 10);
        }
        if ("rgb" in suite) {
            styles.color.ansi16m[key] = wrapAnsi16m(suite.rgb, 0);
            styles.bgColor.ansi16m[key] = wrapAnsi16m(suite.rgb, 10);
        }
    }
    return styles;
}
// Make the export immutable
Object.defineProperty(module, "exports", {
    enumerable: true,
    get: assembleStyles
});

});
parcelRegister("cZxrT", function(module, exports) {

var $gVgeS = parcelRequire("gVgeS");

var $35aRY = parcelRequire("35aRY");
var $975520d01f480c62$var$convert = {};
var $975520d01f480c62$var$models = Object.keys($gVgeS);
function $975520d01f480c62$var$wrapRaw(fn) {
    var wrappedFn = function(args) {
        if (args === undefined || args === null) return args;
        if (arguments.length > 1) args = Array.prototype.slice.call(arguments);
        return fn(args);
    };
    // preserve .conversion property if there is one
    if ("conversion" in fn) wrappedFn.conversion = fn.conversion;
    return wrappedFn;
}
function $975520d01f480c62$var$wrapRounded(fn) {
    var wrappedFn = function(args) {
        if (args === undefined || args === null) return args;
        if (arguments.length > 1) args = Array.prototype.slice.call(arguments);
        var result = fn(args);
        // we're assuming the result is an array here.
        // see notice in conversions.js; don't use box types
        // in conversion functions.
        if (typeof result === "object") for(var len = result.length, i = 0; i < len; i++)result[i] = Math.round(result[i]);
        return result;
    };
    // preserve .conversion property if there is one
    if ("conversion" in fn) wrappedFn.conversion = fn.conversion;
    return wrappedFn;
}
$975520d01f480c62$var$models.forEach(function(fromModel) {
    $975520d01f480c62$var$convert[fromModel] = {};
    Object.defineProperty($975520d01f480c62$var$convert[fromModel], "channels", {
        value: $gVgeS[fromModel].channels
    });
    Object.defineProperty($975520d01f480c62$var$convert[fromModel], "labels", {
        value: $gVgeS[fromModel].labels
    });
    var routes = $35aRY(fromModel);
    var routeModels = Object.keys(routes);
    routeModels.forEach(function(toModel) {
        var fn = routes[toModel];
        $975520d01f480c62$var$convert[fromModel][toModel] = $975520d01f480c62$var$wrapRounded(fn);
        $975520d01f480c62$var$convert[fromModel][toModel].raw = $975520d01f480c62$var$wrapRaw(fn);
    });
});
module.exports = $975520d01f480c62$var$convert;

});
parcelRegister("gVgeS", function(module, exports) {
/* MIT license */ 
var $3IExf = parcelRequire("3IExf");
// NOTE: conversions should only return primitive values (i.e. arrays, or
//       values that give correct `typeof` results).
//       do not use box values types (i.e. Number(), String(), etc.)
var $c51e90e78fa28e20$var$reverseKeywords = {};
for(var $c51e90e78fa28e20$var$key in $3IExf)if ($3IExf.hasOwnProperty($c51e90e78fa28e20$var$key)) $c51e90e78fa28e20$var$reverseKeywords[$3IExf[$c51e90e78fa28e20$var$key]] = $c51e90e78fa28e20$var$key;
var $c51e90e78fa28e20$var$convert = module.exports = {
    rgb: {
        channels: 3,
        labels: "rgb"
    },
    hsl: {
        channels: 3,
        labels: "hsl"
    },
    hsv: {
        channels: 3,
        labels: "hsv"
    },
    hwb: {
        channels: 3,
        labels: "hwb"
    },
    cmyk: {
        channels: 4,
        labels: "cmyk"
    },
    xyz: {
        channels: 3,
        labels: "xyz"
    },
    lab: {
        channels: 3,
        labels: "lab"
    },
    lch: {
        channels: 3,
        labels: "lch"
    },
    hex: {
        channels: 1,
        labels: [
            "hex"
        ]
    },
    keyword: {
        channels: 1,
        labels: [
            "keyword"
        ]
    },
    ansi16: {
        channels: 1,
        labels: [
            "ansi16"
        ]
    },
    ansi256: {
        channels: 1,
        labels: [
            "ansi256"
        ]
    },
    hcg: {
        channels: 3,
        labels: [
            "h",
            "c",
            "g"
        ]
    },
    apple: {
        channels: 3,
        labels: [
            "r16",
            "g16",
            "b16"
        ]
    },
    gray: {
        channels: 1,
        labels: [
            "gray"
        ]
    }
};
// hide .channels and .labels properties
for(var $c51e90e78fa28e20$var$model in $c51e90e78fa28e20$var$convert)if ($c51e90e78fa28e20$var$convert.hasOwnProperty($c51e90e78fa28e20$var$model)) {
    if (!("channels" in $c51e90e78fa28e20$var$convert[$c51e90e78fa28e20$var$model])) throw new Error("missing channels property: " + $c51e90e78fa28e20$var$model);
    if (!("labels" in $c51e90e78fa28e20$var$convert[$c51e90e78fa28e20$var$model])) throw new Error("missing channel labels property: " + $c51e90e78fa28e20$var$model);
    if ($c51e90e78fa28e20$var$convert[$c51e90e78fa28e20$var$model].labels.length !== $c51e90e78fa28e20$var$convert[$c51e90e78fa28e20$var$model].channels) throw new Error("channel and label counts mismatch: " + $c51e90e78fa28e20$var$model);
    var $c51e90e78fa28e20$var$channels = $c51e90e78fa28e20$var$convert[$c51e90e78fa28e20$var$model].channels;
    var $c51e90e78fa28e20$var$labels = $c51e90e78fa28e20$var$convert[$c51e90e78fa28e20$var$model].labels;
    delete $c51e90e78fa28e20$var$convert[$c51e90e78fa28e20$var$model].channels;
    delete $c51e90e78fa28e20$var$convert[$c51e90e78fa28e20$var$model].labels;
    Object.defineProperty($c51e90e78fa28e20$var$convert[$c51e90e78fa28e20$var$model], "channels", {
        value: $c51e90e78fa28e20$var$channels
    });
    Object.defineProperty($c51e90e78fa28e20$var$convert[$c51e90e78fa28e20$var$model], "labels", {
        value: $c51e90e78fa28e20$var$labels
    });
}
$c51e90e78fa28e20$var$convert.rgb.hsl = function(rgb) {
    var r = rgb[0] / 255;
    var g = rgb[1] / 255;
    var b = rgb[2] / 255;
    var min = Math.min(r, g, b);
    var max = Math.max(r, g, b);
    var delta = max - min;
    var h;
    var s;
    var l;
    if (max === min) h = 0;
    else if (r === max) h = (g - b) / delta;
    else if (g === max) h = 2 + (b - r) / delta;
    else if (b === max) h = 4 + (r - g) / delta;
    h = Math.min(h * 60, 360);
    if (h < 0) h += 360;
    l = (min + max) / 2;
    if (max === min) s = 0;
    else if (l <= 0.5) s = delta / (max + min);
    else s = delta / (2 - max - min);
    return [
        h,
        s * 100,
        l * 100
    ];
};
$c51e90e78fa28e20$var$convert.rgb.hsv = function(rgb) {
    var rdif;
    var gdif;
    var bdif;
    var h;
    var s;
    var r = rgb[0] / 255;
    var g = rgb[1] / 255;
    var b = rgb[2] / 255;
    var v = Math.max(r, g, b);
    var diff = v - Math.min(r, g, b);
    var diffc = function(c) {
        return (v - c) / 6 / diff + 0.5;
    };
    if (diff === 0) h = s = 0;
    else {
        s = diff / v;
        rdif = diffc(r);
        gdif = diffc(g);
        bdif = diffc(b);
        if (r === v) h = bdif - gdif;
        else if (g === v) h = 1 / 3 + rdif - bdif;
        else if (b === v) h = 2 / 3 + gdif - rdif;
        if (h < 0) h += 1;
        else if (h > 1) h -= 1;
    }
    return [
        h * 360,
        s * 100,
        v * 100
    ];
};
$c51e90e78fa28e20$var$convert.rgb.hwb = function(rgb) {
    var r = rgb[0];
    var g = rgb[1];
    var b = rgb[2];
    var h = $c51e90e78fa28e20$var$convert.rgb.hsl(rgb)[0];
    var w = 1 / 255 * Math.min(r, Math.min(g, b));
    b = 1 - 1 / 255 * Math.max(r, Math.max(g, b));
    return [
        h,
        w * 100,
        b * 100
    ];
};
$c51e90e78fa28e20$var$convert.rgb.cmyk = function(rgb) {
    var r = rgb[0] / 255;
    var g = rgb[1] / 255;
    var b = rgb[2] / 255;
    var c;
    var m;
    var y;
    var k;
    k = Math.min(1 - r, 1 - g, 1 - b);
    c = (1 - r - k) / (1 - k) || 0;
    m = (1 - g - k) / (1 - k) || 0;
    y = (1 - b - k) / (1 - k) || 0;
    return [
        c * 100,
        m * 100,
        y * 100,
        k * 100
    ];
};
/**
 * See https://en.m.wikipedia.org/wiki/Euclidean_distance#Squared_Euclidean_distance
 * */ function $c51e90e78fa28e20$var$comparativeDistance(x, y) {
    return Math.pow(x[0] - y[0], 2) + Math.pow(x[1] - y[1], 2) + Math.pow(x[2] - y[2], 2);
}
$c51e90e78fa28e20$var$convert.rgb.keyword = function(rgb) {
    var reversed = $c51e90e78fa28e20$var$reverseKeywords[rgb];
    if (reversed) return reversed;
    var currentClosestDistance = Infinity;
    var currentClosestKeyword;
    for(var keyword in $3IExf)if ($3IExf.hasOwnProperty(keyword)) {
        var value = $3IExf[keyword];
        // Compute comparative distance
        var distance = $c51e90e78fa28e20$var$comparativeDistance(rgb, value);
        // Check if its less, if so set as closest
        if (distance < currentClosestDistance) {
            currentClosestDistance = distance;
            currentClosestKeyword = keyword;
        }
    }
    return currentClosestKeyword;
};
$c51e90e78fa28e20$var$convert.keyword.rgb = function(keyword) {
    return $3IExf[keyword];
};
$c51e90e78fa28e20$var$convert.rgb.xyz = function(rgb) {
    var r = rgb[0] / 255;
    var g = rgb[1] / 255;
    var b = rgb[2] / 255;
    // assume sRGB
    r = r > 0.04045 ? Math.pow((r + 0.055) / 1.055, 2.4) : r / 12.92;
    g = g > 0.04045 ? Math.pow((g + 0.055) / 1.055, 2.4) : g / 12.92;
    b = b > 0.04045 ? Math.pow((b + 0.055) / 1.055, 2.4) : b / 12.92;
    var x = r * 0.4124 + g * 0.3576 + b * 0.1805;
    var y = r * 0.2126 + g * 0.7152 + b * 0.0722;
    var z = r * 0.0193 + g * 0.1192 + b * 0.9505;
    return [
        x * 100,
        y * 100,
        z * 100
    ];
};
$c51e90e78fa28e20$var$convert.rgb.lab = function(rgb) {
    var xyz = $c51e90e78fa28e20$var$convert.rgb.xyz(rgb);
    var x = xyz[0];
    var y = xyz[1];
    var z = xyz[2];
    var l;
    var a;
    var b;
    x /= 95.047;
    y /= 100;
    z /= 108.883;
    x = x > 0.008856 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
    y = y > 0.008856 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
    z = z > 0.008856 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;
    l = 116 * y - 16;
    a = 500 * (x - y);
    b = 200 * (y - z);
    return [
        l,
        a,
        b
    ];
};
$c51e90e78fa28e20$var$convert.hsl.rgb = function(hsl) {
    var h = hsl[0] / 360;
    var s = hsl[1] / 100;
    var l = hsl[2] / 100;
    var t1;
    var t2;
    var t3;
    var rgb;
    var val;
    if (s === 0) {
        val = l * 255;
        return [
            val,
            val,
            val
        ];
    }
    if (l < 0.5) t2 = l * (1 + s);
    else t2 = l + s - l * s;
    t1 = 2 * l - t2;
    rgb = [
        0,
        0,
        0
    ];
    for(var i = 0; i < 3; i++){
        t3 = h + 1 / 3 * -(i - 1);
        if (t3 < 0) t3++;
        if (t3 > 1) t3--;
        if (6 * t3 < 1) val = t1 + (t2 - t1) * 6 * t3;
        else if (2 * t3 < 1) val = t2;
        else if (3 * t3 < 2) val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
        else val = t1;
        rgb[i] = val * 255;
    }
    return rgb;
};
$c51e90e78fa28e20$var$convert.hsl.hsv = function(hsl) {
    var h = hsl[0];
    var s = hsl[1] / 100;
    var l = hsl[2] / 100;
    var smin = s;
    var lmin = Math.max(l, 0.01);
    var sv;
    var v;
    l *= 2;
    s *= l <= 1 ? l : 2 - l;
    smin *= lmin <= 1 ? lmin : 2 - lmin;
    v = (l + s) / 2;
    sv = l === 0 ? 2 * smin / (lmin + smin) : 2 * s / (l + s);
    return [
        h,
        sv * 100,
        v * 100
    ];
};
$c51e90e78fa28e20$var$convert.hsv.rgb = function(hsv) {
    var h = hsv[0] / 60;
    var s = hsv[1] / 100;
    var v = hsv[2] / 100;
    var hi = Math.floor(h) % 6;
    var f = h - Math.floor(h);
    var p = 255 * v * (1 - s);
    var q = 255 * v * (1 - s * f);
    var t = 255 * v * (1 - s * (1 - f));
    v *= 255;
    switch(hi){
        case 0:
            return [
                v,
                t,
                p
            ];
        case 1:
            return [
                q,
                v,
                p
            ];
        case 2:
            return [
                p,
                v,
                t
            ];
        case 3:
            return [
                p,
                q,
                v
            ];
        case 4:
            return [
                t,
                p,
                v
            ];
        case 5:
            return [
                v,
                p,
                q
            ];
    }
};
$c51e90e78fa28e20$var$convert.hsv.hsl = function(hsv) {
    var h = hsv[0];
    var s = hsv[1] / 100;
    var v = hsv[2] / 100;
    var vmin = Math.max(v, 0.01);
    var lmin;
    var sl;
    var l;
    l = (2 - s) * v;
    lmin = (2 - s) * vmin;
    sl = s * vmin;
    sl /= lmin <= 1 ? lmin : 2 - lmin;
    sl = sl || 0;
    l /= 2;
    return [
        h,
        sl * 100,
        l * 100
    ];
};
// http://dev.w3.org/csswg/css-color/#hwb-to-rgb
$c51e90e78fa28e20$var$convert.hwb.rgb = function(hwb) {
    var h = hwb[0] / 360;
    var wh = hwb[1] / 100;
    var bl = hwb[2] / 100;
    var ratio = wh + bl;
    var i;
    var v;
    var f;
    var n;
    // wh + bl cant be > 1
    if (ratio > 1) {
        wh /= ratio;
        bl /= ratio;
    }
    i = Math.floor(6 * h);
    v = 1 - bl;
    f = 6 * h - i;
    if ((i & 0x01) !== 0) f = 1 - f;
    n = wh + f * (v - wh); // linear interpolation
    var r;
    var g;
    var b;
    switch(i){
        default:
        case 6:
        case 0:
            r = v;
            g = n;
            b = wh;
            break;
        case 1:
            r = n;
            g = v;
            b = wh;
            break;
        case 2:
            r = wh;
            g = v;
            b = n;
            break;
        case 3:
            r = wh;
            g = n;
            b = v;
            break;
        case 4:
            r = n;
            g = wh;
            b = v;
            break;
        case 5:
            r = v;
            g = wh;
            b = n;
            break;
    }
    return [
        r * 255,
        g * 255,
        b * 255
    ];
};
$c51e90e78fa28e20$var$convert.cmyk.rgb = function(cmyk) {
    var c = cmyk[0] / 100;
    var m = cmyk[1] / 100;
    var y = cmyk[2] / 100;
    var k = cmyk[3] / 100;
    var r;
    var g;
    var b;
    r = 1 - Math.min(1, c * (1 - k) + k);
    g = 1 - Math.min(1, m * (1 - k) + k);
    b = 1 - Math.min(1, y * (1 - k) + k);
    return [
        r * 255,
        g * 255,
        b * 255
    ];
};
$c51e90e78fa28e20$var$convert.xyz.rgb = function(xyz) {
    var x = xyz[0] / 100;
    var y = xyz[1] / 100;
    var z = xyz[2] / 100;
    var r;
    var g;
    var b;
    r = x * 3.2406 + y * -1.5372 + z * -0.4986;
    g = x * -0.9689 + y * 1.8758 + z * 0.0415;
    b = x * 0.0557 + y * -0.204 + z * 1.0570;
    // assume sRGB
    r = r > 0.0031308 ? 1.055 * Math.pow(r, 1.0 / 2.4) - 0.055 : r * 12.92;
    g = g > 0.0031308 ? 1.055 * Math.pow(g, 1.0 / 2.4) - 0.055 : g * 12.92;
    b = b > 0.0031308 ? 1.055 * Math.pow(b, 1.0 / 2.4) - 0.055 : b * 12.92;
    r = Math.min(Math.max(0, r), 1);
    g = Math.min(Math.max(0, g), 1);
    b = Math.min(Math.max(0, b), 1);
    return [
        r * 255,
        g * 255,
        b * 255
    ];
};
$c51e90e78fa28e20$var$convert.xyz.lab = function(xyz) {
    var x = xyz[0];
    var y = xyz[1];
    var z = xyz[2];
    var l;
    var a;
    var b;
    x /= 95.047;
    y /= 100;
    z /= 108.883;
    x = x > 0.008856 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
    y = y > 0.008856 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
    z = z > 0.008856 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;
    l = 116 * y - 16;
    a = 500 * (x - y);
    b = 200 * (y - z);
    return [
        l,
        a,
        b
    ];
};
$c51e90e78fa28e20$var$convert.lab.xyz = function(lab) {
    var l = lab[0];
    var a = lab[1];
    var b = lab[2];
    var x;
    var y;
    var z;
    y = (l + 16) / 116;
    x = a / 500 + y;
    z = y - b / 200;
    var y2 = Math.pow(y, 3);
    var x2 = Math.pow(x, 3);
    var z2 = Math.pow(z, 3);
    y = y2 > 0.008856 ? y2 : (y - 16 / 116) / 7.787;
    x = x2 > 0.008856 ? x2 : (x - 16 / 116) / 7.787;
    z = z2 > 0.008856 ? z2 : (z - 16 / 116) / 7.787;
    x *= 95.047;
    y *= 100;
    z *= 108.883;
    return [
        x,
        y,
        z
    ];
};
$c51e90e78fa28e20$var$convert.lab.lch = function(lab) {
    var l = lab[0];
    var a = lab[1];
    var b = lab[2];
    var hr;
    var h;
    var c;
    hr = Math.atan2(b, a);
    h = hr * 360 / 2 / Math.PI;
    if (h < 0) h += 360;
    c = Math.sqrt(a * a + b * b);
    return [
        l,
        c,
        h
    ];
};
$c51e90e78fa28e20$var$convert.lch.lab = function(lch) {
    var l = lch[0];
    var c = lch[1];
    var h = lch[2];
    var a;
    var b;
    var hr;
    hr = h / 360 * 2 * Math.PI;
    a = c * Math.cos(hr);
    b = c * Math.sin(hr);
    return [
        l,
        a,
        b
    ];
};
$c51e90e78fa28e20$var$convert.rgb.ansi16 = function(args) {
    var r = args[0];
    var g = args[1];
    var b = args[2];
    var value = 1 in arguments ? arguments[1] : $c51e90e78fa28e20$var$convert.rgb.hsv(args)[2]; // hsv -> ansi16 optimization
    value = Math.round(value / 50);
    if (value === 0) return 30;
    var ansi = 30 + (Math.round(b / 255) << 2 | Math.round(g / 255) << 1 | Math.round(r / 255));
    if (value === 2) ansi += 60;
    return ansi;
};
$c51e90e78fa28e20$var$convert.hsv.ansi16 = function(args) {
    // optimization here; we already know the value and don't need to get
    // it converted for us.
    return $c51e90e78fa28e20$var$convert.rgb.ansi16($c51e90e78fa28e20$var$convert.hsv.rgb(args), args[2]);
};
$c51e90e78fa28e20$var$convert.rgb.ansi256 = function(args) {
    var r = args[0];
    var g = args[1];
    var b = args[2];
    // we use the extended greyscale palette here, with the exception of
    // black and white. normal palette only has 4 greyscale shades.
    if (r === g && g === b) {
        if (r < 8) return 16;
        if (r > 248) return 231;
        return Math.round((r - 8) / 247 * 24) + 232;
    }
    var ansi = 16 + 36 * Math.round(r / 255 * 5) + 6 * Math.round(g / 255 * 5) + Math.round(b / 255 * 5);
    return ansi;
};
$c51e90e78fa28e20$var$convert.ansi16.rgb = function(args) {
    var color = args % 10;
    // handle greyscale
    if (color === 0 || color === 7) {
        if (args > 50) color += 3.5;
        color = color / 10.5 * 255;
        return [
            color,
            color,
            color
        ];
    }
    var mult = (~~(args > 50) + 1) * 0.5;
    var r = (color & 1) * mult * 255;
    var g = (color >> 1 & 1) * mult * 255;
    var b = (color >> 2 & 1) * mult * 255;
    return [
        r,
        g,
        b
    ];
};
$c51e90e78fa28e20$var$convert.ansi256.rgb = function(args) {
    // handle greyscale
    if (args >= 232) {
        var c = (args - 232) * 10 + 8;
        return [
            c,
            c,
            c
        ];
    }
    args -= 16;
    var rem;
    var r = Math.floor(args / 36) / 5 * 255;
    var g = Math.floor((rem = args % 36) / 6) / 5 * 255;
    var b = rem % 6 / 5 * 255;
    return [
        r,
        g,
        b
    ];
};
$c51e90e78fa28e20$var$convert.rgb.hex = function(args) {
    var integer = ((Math.round(args[0]) & 0xFF) << 16) + ((Math.round(args[1]) & 0xFF) << 8) + (Math.round(args[2]) & 0xFF);
    var string = integer.toString(16).toUpperCase();
    return "000000".substring(string.length) + string;
};
$c51e90e78fa28e20$var$convert.hex.rgb = function(args) {
    var match = args.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
    if (!match) return [
        0,
        0,
        0
    ];
    var colorString = match[0];
    if (match[0].length === 3) colorString = colorString.split("").map(function(char) {
        return char + char;
    }).join("");
    var integer = parseInt(colorString, 16);
    var r = integer >> 16 & 0xFF;
    var g = integer >> 8 & 0xFF;
    var b = integer & 0xFF;
    return [
        r,
        g,
        b
    ];
};
$c51e90e78fa28e20$var$convert.rgb.hcg = function(rgb) {
    var r = rgb[0] / 255;
    var g = rgb[1] / 255;
    var b = rgb[2] / 255;
    var max = Math.max(Math.max(r, g), b);
    var min = Math.min(Math.min(r, g), b);
    var chroma = max - min;
    var grayscale;
    var hue;
    if (chroma < 1) grayscale = min / (1 - chroma);
    else grayscale = 0;
    if (chroma <= 0) hue = 0;
    else if (max === r) hue = (g - b) / chroma % 6;
    else if (max === g) hue = 2 + (b - r) / chroma;
    else hue = 4 + (r - g) / chroma + 4;
    hue /= 6;
    hue %= 1;
    return [
        hue * 360,
        chroma * 100,
        grayscale * 100
    ];
};
$c51e90e78fa28e20$var$convert.hsl.hcg = function(hsl) {
    var s = hsl[1] / 100;
    var l = hsl[2] / 100;
    var c = 1;
    var f = 0;
    if (l < 0.5) c = 2.0 * s * l;
    else c = 2.0 * s * (1.0 - l);
    if (c < 1.0) f = (l - 0.5 * c) / (1.0 - c);
    return [
        hsl[0],
        c * 100,
        f * 100
    ];
};
$c51e90e78fa28e20$var$convert.hsv.hcg = function(hsv) {
    var s = hsv[1] / 100;
    var v = hsv[2] / 100;
    var c = s * v;
    var f = 0;
    if (c < 1.0) f = (v - c) / (1 - c);
    return [
        hsv[0],
        c * 100,
        f * 100
    ];
};
$c51e90e78fa28e20$var$convert.hcg.rgb = function(hcg) {
    var h = hcg[0] / 360;
    var c = hcg[1] / 100;
    var g = hcg[2] / 100;
    if (c === 0.0) return [
        g * 255,
        g * 255,
        g * 255
    ];
    var pure = [
        0,
        0,
        0
    ];
    var hi = h % 1 * 6;
    var v = hi % 1;
    var w = 1 - v;
    var mg = 0;
    switch(Math.floor(hi)){
        case 0:
            pure[0] = 1;
            pure[1] = v;
            pure[2] = 0;
            break;
        case 1:
            pure[0] = w;
            pure[1] = 1;
            pure[2] = 0;
            break;
        case 2:
            pure[0] = 0;
            pure[1] = 1;
            pure[2] = v;
            break;
        case 3:
            pure[0] = 0;
            pure[1] = w;
            pure[2] = 1;
            break;
        case 4:
            pure[0] = v;
            pure[1] = 0;
            pure[2] = 1;
            break;
        default:
            pure[0] = 1;
            pure[1] = 0;
            pure[2] = w;
    }
    mg = (1.0 - c) * g;
    return [
        (c * pure[0] + mg) * 255,
        (c * pure[1] + mg) * 255,
        (c * pure[2] + mg) * 255
    ];
};
$c51e90e78fa28e20$var$convert.hcg.hsv = function(hcg) {
    var c = hcg[1] / 100;
    var g = hcg[2] / 100;
    var v = c + g * (1.0 - c);
    var f = 0;
    if (v > 0.0) f = c / v;
    return [
        hcg[0],
        f * 100,
        v * 100
    ];
};
$c51e90e78fa28e20$var$convert.hcg.hsl = function(hcg) {
    var c = hcg[1] / 100;
    var g = hcg[2] / 100;
    var l = g * (1.0 - c) + 0.5 * c;
    var s = 0;
    if (l > 0.0 && l < 0.5) s = c / (2 * l);
    else if (l >= 0.5 && l < 1.0) s = c / (2 * (1 - l));
    return [
        hcg[0],
        s * 100,
        l * 100
    ];
};
$c51e90e78fa28e20$var$convert.hcg.hwb = function(hcg) {
    var c = hcg[1] / 100;
    var g = hcg[2] / 100;
    var v = c + g * (1.0 - c);
    return [
        hcg[0],
        (v - c) * 100,
        (1 - v) * 100
    ];
};
$c51e90e78fa28e20$var$convert.hwb.hcg = function(hwb) {
    var w = hwb[1] / 100;
    var b = hwb[2] / 100;
    var v = 1 - b;
    var c = v - w;
    var g = 0;
    if (c < 1) g = (v - c) / (1 - c);
    return [
        hwb[0],
        c * 100,
        g * 100
    ];
};
$c51e90e78fa28e20$var$convert.apple.rgb = function(apple) {
    return [
        apple[0] / 65535 * 255,
        apple[1] / 65535 * 255,
        apple[2] / 65535 * 255
    ];
};
$c51e90e78fa28e20$var$convert.rgb.apple = function(rgb) {
    return [
        rgb[0] / 255 * 65535,
        rgb[1] / 255 * 65535,
        rgb[2] / 255 * 65535
    ];
};
$c51e90e78fa28e20$var$convert.gray.rgb = function(args) {
    return [
        args[0] / 100 * 255,
        args[0] / 100 * 255,
        args[0] / 100 * 255
    ];
};
$c51e90e78fa28e20$var$convert.gray.hsl = $c51e90e78fa28e20$var$convert.gray.hsv = function(args) {
    return [
        0,
        0,
        args[0]
    ];
};
$c51e90e78fa28e20$var$convert.gray.hwb = function(gray) {
    return [
        0,
        100,
        gray[0]
    ];
};
$c51e90e78fa28e20$var$convert.gray.cmyk = function(gray) {
    return [
        0,
        0,
        0,
        gray[0]
    ];
};
$c51e90e78fa28e20$var$convert.gray.lab = function(gray) {
    return [
        gray[0],
        0,
        0
    ];
};
$c51e90e78fa28e20$var$convert.gray.hex = function(gray) {
    var val = Math.round(gray[0] / 100 * 255) & 0xFF;
    var integer = (val << 16) + (val << 8) + val;
    var string = integer.toString(16).toUpperCase();
    return "000000".substring(string.length) + string;
};
$c51e90e78fa28e20$var$convert.rgb.gray = function(rgb) {
    var val = (rgb[0] + rgb[1] + rgb[2]) / 3;
    return [
        val / 255 * 100
    ];
};

});
parcelRegister("3IExf", function(module, exports) {
"use strict";
module.exports = {
    "aliceblue": [
        240,
        248,
        255
    ],
    "antiquewhite": [
        250,
        235,
        215
    ],
    "aqua": [
        0,
        255,
        255
    ],
    "aquamarine": [
        127,
        255,
        212
    ],
    "azure": [
        240,
        255,
        255
    ],
    "beige": [
        245,
        245,
        220
    ],
    "bisque": [
        255,
        228,
        196
    ],
    "black": [
        0,
        0,
        0
    ],
    "blanchedalmond": [
        255,
        235,
        205
    ],
    "blue": [
        0,
        0,
        255
    ],
    "blueviolet": [
        138,
        43,
        226
    ],
    "brown": [
        165,
        42,
        42
    ],
    "burlywood": [
        222,
        184,
        135
    ],
    "cadetblue": [
        95,
        158,
        160
    ],
    "chartreuse": [
        127,
        255,
        0
    ],
    "chocolate": [
        210,
        105,
        30
    ],
    "coral": [
        255,
        127,
        80
    ],
    "cornflowerblue": [
        100,
        149,
        237
    ],
    "cornsilk": [
        255,
        248,
        220
    ],
    "crimson": [
        220,
        20,
        60
    ],
    "cyan": [
        0,
        255,
        255
    ],
    "darkblue": [
        0,
        0,
        139
    ],
    "darkcyan": [
        0,
        139,
        139
    ],
    "darkgoldenrod": [
        184,
        134,
        11
    ],
    "darkgray": [
        169,
        169,
        169
    ],
    "darkgreen": [
        0,
        100,
        0
    ],
    "darkgrey": [
        169,
        169,
        169
    ],
    "darkkhaki": [
        189,
        183,
        107
    ],
    "darkmagenta": [
        139,
        0,
        139
    ],
    "darkolivegreen": [
        85,
        107,
        47
    ],
    "darkorange": [
        255,
        140,
        0
    ],
    "darkorchid": [
        153,
        50,
        204
    ],
    "darkred": [
        139,
        0,
        0
    ],
    "darksalmon": [
        233,
        150,
        122
    ],
    "darkseagreen": [
        143,
        188,
        143
    ],
    "darkslateblue": [
        72,
        61,
        139
    ],
    "darkslategray": [
        47,
        79,
        79
    ],
    "darkslategrey": [
        47,
        79,
        79
    ],
    "darkturquoise": [
        0,
        206,
        209
    ],
    "darkviolet": [
        148,
        0,
        211
    ],
    "deeppink": [
        255,
        20,
        147
    ],
    "deepskyblue": [
        0,
        191,
        255
    ],
    "dimgray": [
        105,
        105,
        105
    ],
    "dimgrey": [
        105,
        105,
        105
    ],
    "dodgerblue": [
        30,
        144,
        255
    ],
    "firebrick": [
        178,
        34,
        34
    ],
    "floralwhite": [
        255,
        250,
        240
    ],
    "forestgreen": [
        34,
        139,
        34
    ],
    "fuchsia": [
        255,
        0,
        255
    ],
    "gainsboro": [
        220,
        220,
        220
    ],
    "ghostwhite": [
        248,
        248,
        255
    ],
    "gold": [
        255,
        215,
        0
    ],
    "goldenrod": [
        218,
        165,
        32
    ],
    "gray": [
        128,
        128,
        128
    ],
    "green": [
        0,
        128,
        0
    ],
    "greenyellow": [
        173,
        255,
        47
    ],
    "grey": [
        128,
        128,
        128
    ],
    "honeydew": [
        240,
        255,
        240
    ],
    "hotpink": [
        255,
        105,
        180
    ],
    "indianred": [
        205,
        92,
        92
    ],
    "indigo": [
        75,
        0,
        130
    ],
    "ivory": [
        255,
        255,
        240
    ],
    "khaki": [
        240,
        230,
        140
    ],
    "lavender": [
        230,
        230,
        250
    ],
    "lavenderblush": [
        255,
        240,
        245
    ],
    "lawngreen": [
        124,
        252,
        0
    ],
    "lemonchiffon": [
        255,
        250,
        205
    ],
    "lightblue": [
        173,
        216,
        230
    ],
    "lightcoral": [
        240,
        128,
        128
    ],
    "lightcyan": [
        224,
        255,
        255
    ],
    "lightgoldenrodyellow": [
        250,
        250,
        210
    ],
    "lightgray": [
        211,
        211,
        211
    ],
    "lightgreen": [
        144,
        238,
        144
    ],
    "lightgrey": [
        211,
        211,
        211
    ],
    "lightpink": [
        255,
        182,
        193
    ],
    "lightsalmon": [
        255,
        160,
        122
    ],
    "lightseagreen": [
        32,
        178,
        170
    ],
    "lightskyblue": [
        135,
        206,
        250
    ],
    "lightslategray": [
        119,
        136,
        153
    ],
    "lightslategrey": [
        119,
        136,
        153
    ],
    "lightsteelblue": [
        176,
        196,
        222
    ],
    "lightyellow": [
        255,
        255,
        224
    ],
    "lime": [
        0,
        255,
        0
    ],
    "limegreen": [
        50,
        205,
        50
    ],
    "linen": [
        250,
        240,
        230
    ],
    "magenta": [
        255,
        0,
        255
    ],
    "maroon": [
        128,
        0,
        0
    ],
    "mediumaquamarine": [
        102,
        205,
        170
    ],
    "mediumblue": [
        0,
        0,
        205
    ],
    "mediumorchid": [
        186,
        85,
        211
    ],
    "mediumpurple": [
        147,
        112,
        219
    ],
    "mediumseagreen": [
        60,
        179,
        113
    ],
    "mediumslateblue": [
        123,
        104,
        238
    ],
    "mediumspringgreen": [
        0,
        250,
        154
    ],
    "mediumturquoise": [
        72,
        209,
        204
    ],
    "mediumvioletred": [
        199,
        21,
        133
    ],
    "midnightblue": [
        25,
        25,
        112
    ],
    "mintcream": [
        245,
        255,
        250
    ],
    "mistyrose": [
        255,
        228,
        225
    ],
    "moccasin": [
        255,
        228,
        181
    ],
    "navajowhite": [
        255,
        222,
        173
    ],
    "navy": [
        0,
        0,
        128
    ],
    "oldlace": [
        253,
        245,
        230
    ],
    "olive": [
        128,
        128,
        0
    ],
    "olivedrab": [
        107,
        142,
        35
    ],
    "orange": [
        255,
        165,
        0
    ],
    "orangered": [
        255,
        69,
        0
    ],
    "orchid": [
        218,
        112,
        214
    ],
    "palegoldenrod": [
        238,
        232,
        170
    ],
    "palegreen": [
        152,
        251,
        152
    ],
    "paleturquoise": [
        175,
        238,
        238
    ],
    "palevioletred": [
        219,
        112,
        147
    ],
    "papayawhip": [
        255,
        239,
        213
    ],
    "peachpuff": [
        255,
        218,
        185
    ],
    "peru": [
        205,
        133,
        63
    ],
    "pink": [
        255,
        192,
        203
    ],
    "plum": [
        221,
        160,
        221
    ],
    "powderblue": [
        176,
        224,
        230
    ],
    "purple": [
        128,
        0,
        128
    ],
    "rebeccapurple": [
        102,
        51,
        153
    ],
    "red": [
        255,
        0,
        0
    ],
    "rosybrown": [
        188,
        143,
        143
    ],
    "royalblue": [
        65,
        105,
        225
    ],
    "saddlebrown": [
        139,
        69,
        19
    ],
    "salmon": [
        250,
        128,
        114
    ],
    "sandybrown": [
        244,
        164,
        96
    ],
    "seagreen": [
        46,
        139,
        87
    ],
    "seashell": [
        255,
        245,
        238
    ],
    "sienna": [
        160,
        82,
        45
    ],
    "silver": [
        192,
        192,
        192
    ],
    "skyblue": [
        135,
        206,
        235
    ],
    "slateblue": [
        106,
        90,
        205
    ],
    "slategray": [
        112,
        128,
        144
    ],
    "slategrey": [
        112,
        128,
        144
    ],
    "snow": [
        255,
        250,
        250
    ],
    "springgreen": [
        0,
        255,
        127
    ],
    "steelblue": [
        70,
        130,
        180
    ],
    "tan": [
        210,
        180,
        140
    ],
    "teal": [
        0,
        128,
        128
    ],
    "thistle": [
        216,
        191,
        216
    ],
    "tomato": [
        255,
        99,
        71
    ],
    "turquoise": [
        64,
        224,
        208
    ],
    "violet": [
        238,
        130,
        238
    ],
    "wheat": [
        245,
        222,
        179
    ],
    "white": [
        255,
        255,
        255
    ],
    "whitesmoke": [
        245,
        245,
        245
    ],
    "yellow": [
        255,
        255,
        0
    ],
    "yellowgreen": [
        154,
        205,
        50
    ]
};

});


parcelRegister("35aRY", function(module, exports) {

var $gVgeS = parcelRequire("gVgeS");
/*
	this function routes a model to all other models.

	all functions that are routed have a property `.conversion` attached
	to the returned synthetic function. This property is an array
	of strings, each with the steps in between the 'from' and 'to'
	color models (inclusive).

	conversions that are not possible simply are not included.
*/ function $23ea45370eb935ca$var$buildGraph() {
    var graph = {};
    // https://jsperf.com/object-keys-vs-for-in-with-closure/3
    var models = Object.keys($gVgeS);
    for(var len = models.length, i = 0; i < len; i++)graph[models[i]] = {
        // http://jsperf.com/1-vs-infinity
        // micro-opt, but this is simple.
        distance: -1,
        parent: null
    };
    return graph;
}
// https://en.wikipedia.org/wiki/Breadth-first_search
function $23ea45370eb935ca$var$deriveBFS(fromModel) {
    var graph = $23ea45370eb935ca$var$buildGraph();
    var queue = [
        fromModel
    ]; // unshift -> queue -> pop
    graph[fromModel].distance = 0;
    while(queue.length){
        var current = queue.pop();
        var adjacents = Object.keys($gVgeS[current]);
        for(var len = adjacents.length, i = 0; i < len; i++){
            var adjacent = adjacents[i];
            var node = graph[adjacent];
            if (node.distance === -1) {
                node.distance = graph[current].distance + 1;
                node.parent = current;
                queue.unshift(adjacent);
            }
        }
    }
    return graph;
}
function $23ea45370eb935ca$var$link(from, to) {
    return function(args) {
        return to(from(args));
    };
}
function $23ea45370eb935ca$var$wrapConversion(toModel, graph) {
    var path = [
        graph[toModel].parent,
        toModel
    ];
    var fn = $gVgeS[graph[toModel].parent][toModel];
    var cur = graph[toModel].parent;
    while(graph[cur].parent){
        path.unshift(graph[cur].parent);
        fn = $23ea45370eb935ca$var$link($gVgeS[graph[cur].parent][cur], fn);
        cur = graph[cur].parent;
    }
    fn.conversion = path;
    return fn;
}
module.exports = function(fromModel) {
    var graph = $23ea45370eb935ca$var$deriveBFS(fromModel);
    var conversion = {};
    var models = Object.keys(graph);
    for(var len = models.length, i = 0; i < len; i++){
        var toModel = models[i];
        var node = graph[toModel];
        if (node.parent === null) continue;
        conversion[toModel] = $23ea45370eb935ca$var$wrapConversion(toModel, graph);
    }
    return conversion;
};

});



parcelRegister("hE0mt", function(module, exports) {
"use strict";
module.exports = {
    stdout: false,
    stderr: false
};

});

parcelRegister("eKHuM", function(module, exports) {
"use strict";
const $abd719dd58d9aa50$var$TEMPLATE_REGEX = /(?:\\(u[a-f\d]{4}|x[a-f\d]{2}|.))|(?:\{(~)?(\w+(?:\([^)]*\))?(?:\.\w+(?:\([^)]*\))?)*)(?:[ \t]|(?=\r?\n)))|(\})|((?:.|[\r\n\f])+?)/gi;
const $abd719dd58d9aa50$var$STYLE_REGEX = /(?:^|\.)(\w+)(?:\(([^)]*)\))?/g;
const $abd719dd58d9aa50$var$STRING_REGEX = /^(['"])((?:\\.|(?!\1)[^\\])*)\1$/;
const $abd719dd58d9aa50$var$ESCAPE_REGEX = /\\(u[a-f\d]{4}|x[a-f\d]{2}|.)|([^\\])/gi;
const $abd719dd58d9aa50$var$ESCAPES = new Map([
    [
        "n",
        "\n"
    ],
    [
        "r",
        "\r"
    ],
    [
        "t",
        "	"
    ],
    [
        "b",
        "\b"
    ],
    [
        "f",
        "\f"
    ],
    [
        "v",
        "\v"
    ],
    [
        "0",
        "\0"
    ],
    [
        "\\",
        "\\"
    ],
    [
        "e",
        "\x1b"
    ],
    [
        "a",
        "\x07"
    ]
]);
function $abd719dd58d9aa50$var$unescape(c) {
    if (c[0] === "u" && c.length === 5 || c[0] === "x" && c.length === 3) return String.fromCharCode(parseInt(c.slice(1), 16));
    return $abd719dd58d9aa50$var$ESCAPES.get(c) || c;
}
function $abd719dd58d9aa50$var$parseArguments(name, args) {
    const results = [];
    const chunks = args.trim().split(/\s*,\s*/g);
    let matches;
    for (const chunk of chunks){
        if (!isNaN(chunk)) results.push(Number(chunk));
        else if (matches = chunk.match($abd719dd58d9aa50$var$STRING_REGEX)) results.push(matches[2].replace($abd719dd58d9aa50$var$ESCAPE_REGEX, (m, escape, chr)=>escape ? $abd719dd58d9aa50$var$unescape(escape) : chr));
        else throw new Error(`Invalid Chalk template style argument: ${chunk} (in style '${name}')`);
    }
    return results;
}
function $abd719dd58d9aa50$var$parseStyle(style) {
    $abd719dd58d9aa50$var$STYLE_REGEX.lastIndex = 0;
    const results = [];
    let matches;
    while((matches = $abd719dd58d9aa50$var$STYLE_REGEX.exec(style)) !== null){
        const name = matches[1];
        if (matches[2]) {
            const args = $abd719dd58d9aa50$var$parseArguments(name, matches[2]);
            results.push([
                name
            ].concat(args));
        } else results.push([
            name
        ]);
    }
    return results;
}
function $abd719dd58d9aa50$var$buildStyle(chalk, styles) {
    const enabled = {};
    for (const layer of styles)for (const style of layer.styles)enabled[style[0]] = layer.inverse ? null : style.slice(1);
    let current = chalk;
    for (const styleName of Object.keys(enabled))if (Array.isArray(enabled[styleName])) {
        if (!(styleName in current)) throw new Error(`Unknown Chalk style: ${styleName}`);
        if (enabled[styleName].length > 0) current = current[styleName].apply(current, enabled[styleName]);
        else current = current[styleName];
    }
    return current;
}
module.exports = (chalk, tmp)=>{
    const styles = [];
    const chunks = [];
    let chunk = [];
    // eslint-disable-next-line max-params
    tmp.replace($abd719dd58d9aa50$var$TEMPLATE_REGEX, (m, escapeChar, inverse, style, close, chr)=>{
        if (escapeChar) chunk.push($abd719dd58d9aa50$var$unescape(escapeChar));
        else if (style) {
            const str = chunk.join("");
            chunk = [];
            chunks.push(styles.length === 0 ? str : $abd719dd58d9aa50$var$buildStyle(chalk, styles)(str));
            styles.push({
                inverse: inverse,
                styles: $abd719dd58d9aa50$var$parseStyle(style)
            });
        } else if (close) {
            if (styles.length === 0) throw new Error("Found extraneous } in Chalk template literal");
            chunks.push($abd719dd58d9aa50$var$buildStyle(chalk, styles)(chunk.join("")));
            chunk = [];
            styles.pop();
        } else chunk.push(chr);
    });
    chunks.push(chunk.join(""));
    if (styles.length > 0) {
        const errMsg = `Chalk template literal is missing ${styles.length} closing bracket${styles.length === 1 ? "" : "s"} (\`}\`)`;
        throw new Error(errMsg);
    }
    return chunks.join("");
};

});




parcelRegister("av6Qj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7a521b7213b7a6a9$var$hoistVariables;

var $ardUq = parcelRequire("ardUq");
const { assignmentExpression: $7a521b7213b7a6a9$var$assignmentExpression, expressionStatement: $7a521b7213b7a6a9$var$expressionStatement, identifier: $7a521b7213b7a6a9$var$identifier } = $ardUq;
const $7a521b7213b7a6a9$var$visitor = {
    Scope (path, state) {
        if (state.kind === "let") path.skip();
    },
    FunctionParent (path) {
        path.skip();
    },
    VariableDeclaration (path, state) {
        if (state.kind && path.node.kind !== state.kind) return;
        const nodes = [];
        const declarations = path.get("declarations");
        let firstId;
        for (const declar of declarations){
            firstId = declar.node.id;
            if (declar.node.init) nodes.push($7a521b7213b7a6a9$var$expressionStatement($7a521b7213b7a6a9$var$assignmentExpression("=", declar.node.id, declar.node.init)));
            for (const name of Object.keys(declar.getBindingIdentifiers()))state.emit($7a521b7213b7a6a9$var$identifier(name), name, declar.node.init !== null);
        }
        if (path.parentPath.isFor({
            left: path.node
        })) path.replaceWith(firstId);
        else path.replaceWithMultiple(nodes);
    }
};
function $7a521b7213b7a6a9$var$hoistVariables(path, emit, kind = "var") {
    path.traverse($7a521b7213b7a6a9$var$visitor, {
        kind: kind,
        emit: emit
    });
}

});


parcelRegister("gaj2N", function(module, exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.evaluate = evaluate;
exports.evaluateTruthy = evaluateTruthy;
const VALID_OBJECT_CALLEES = [
    "Number",
    "String",
    "Math"
];
const VALID_IDENTIFIER_CALLEES = [
    "isFinite",
    "isNaN",
    "parseFloat",
    "parseInt",
    "decodeURI",
    "decodeURIComponent",
    "encodeURI",
    "encodeURIComponent",
    null,
    null
];
const INVALID_METHODS = [
    "random"
];
function isValidObjectCallee(val) {
    return VALID_OBJECT_CALLEES.includes(val);
}
function isValidIdentifierCallee(val) {
    return VALID_IDENTIFIER_CALLEES.includes(val);
}
function isInvalidMethod(val) {
    return INVALID_METHODS.includes(val);
}
function evaluateTruthy() {
    const res = this.evaluate();
    if (res.confident) return !!res.value;
}
function deopt(path, state) {
    if (!state.confident) return;
    state.deoptPath = path;
    state.confident = false;
}
const Globals = new Map([
    [
        "undefined",
        undefined
    ],
    [
        "Infinity",
        Infinity
    ],
    [
        "NaN",
        NaN
    ]
]);
function evaluateCached(path, state) {
    const { node } = path;
    const { seen } = state;
    if (seen.has(node)) {
        const existing = seen.get(node);
        if (existing.resolved) return existing.value;
        else {
            deopt(path, state);
            return;
        }
    } else {
        const item = {
            resolved: false
        };
        seen.set(node, item);
        const val = _evaluate(path, state);
        if (state.confident) {
            item.resolved = true;
            item.value = val;
        }
        return val;
    }
}
function _evaluate(path, state) {
    if (!state.confident) return;
    if (path.isSequenceExpression()) {
        const exprs = path.get("expressions");
        return evaluateCached(exprs[exprs.length - 1], state);
    }
    if (path.isStringLiteral() || path.isNumericLiteral() || path.isBooleanLiteral()) return path.node.value;
    if (path.isNullLiteral()) return null;
    if (path.isTemplateLiteral()) return evaluateQuasis(path, path.node.quasis, state);
    if (path.isTaggedTemplateExpression() && path.get("tag").isMemberExpression()) {
        const object = path.get("tag.object");
        const { node: { name } } = object;
        const property = path.get("tag.property");
        if (object.isIdentifier() && name === "String" && !path.scope.getBinding(name) && property.isIdentifier() && property.node.name === "raw") return evaluateQuasis(path, path.node.quasi.quasis, state, true);
    }
    if (path.isConditionalExpression()) {
        const testResult = evaluateCached(path.get("test"), state);
        if (!state.confident) return;
        if (testResult) return evaluateCached(path.get("consequent"), state);
        else return evaluateCached(path.get("alternate"), state);
    }
    if (path.isExpressionWrapper()) return evaluateCached(path.get("expression"), state);
    if (path.isMemberExpression() && !path.parentPath.isCallExpression({
        callee: path.node
    })) {
        const property = path.get("property");
        const object = path.get("object");
        if (object.isLiteral()) {
            const value = object.node.value;
            const type = typeof value;
            let key = null;
            if (path.node.computed) {
                key = evaluateCached(property, state);
                if (!state.confident) return;
            } else if (property.isIdentifier()) key = property.node.name;
            if ((type === "number" || type === "string") && key != null && (typeof key === "number" || typeof key === "string")) return value[key];
        }
    }
    if (path.isReferencedIdentifier()) {
        const binding = path.scope.getBinding(path.node.name);
        if (binding) {
            if (binding.constantViolations.length > 0 || path.node.start < binding.path.node.end) {
                deopt(binding.path, state);
                return;
            }
            if (binding.hasValue) return binding.value;
        }
        const name = path.node.name;
        if (Globals.has(name)) {
            if (!binding) return Globals.get(name);
            deopt(binding.path, state);
            return;
        }
        const resolved = path.resolve();
        if (resolved === path) {
            deopt(path, state);
            return;
        } else return evaluateCached(resolved, state);
    }
    if (path.isUnaryExpression({
        prefix: true
    })) {
        if (path.node.operator === "void") return undefined;
        const argument = path.get("argument");
        if (path.node.operator === "typeof" && (argument.isFunction() || argument.isClass())) return "function";
        const arg = evaluateCached(argument, state);
        if (!state.confident) return;
        switch(path.node.operator){
            case "!":
                return !arg;
            case "+":
                return +arg;
            case "-":
                return -arg;
            case "~":
                return ~arg;
            case "typeof":
                return typeof arg;
        }
    }
    if (path.isArrayExpression()) {
        const arr = [];
        const elems = path.get("elements");
        for (const elem of elems){
            const elemValue = elem.evaluate();
            if (elemValue.confident) arr.push(elemValue.value);
            else {
                deopt(elemValue.deopt, state);
                return;
            }
        }
        return arr;
    }
    if (path.isObjectExpression()) {
        const obj = {};
        const props = path.get("properties");
        for (const prop of props){
            if (prop.isObjectMethod() || prop.isSpreadElement()) {
                deopt(prop, state);
                return;
            }
            const keyPath = prop.get("key");
            let key;
            if (prop.node.computed) {
                key = keyPath.evaluate();
                if (!key.confident) {
                    deopt(key.deopt, state);
                    return;
                }
                key = key.value;
            } else if (keyPath.isIdentifier()) key = keyPath.node.name;
            else key = keyPath.node.value;
            const valuePath = prop.get("value");
            let value = valuePath.evaluate();
            if (!value.confident) {
                deopt(value.deopt, state);
                return;
            }
            value = value.value;
            obj[key] = value;
        }
        return obj;
    }
    if (path.isLogicalExpression()) {
        const wasConfident = state.confident;
        const left = evaluateCached(path.get("left"), state);
        const leftConfident = state.confident;
        state.confident = wasConfident;
        const right = evaluateCached(path.get("right"), state);
        const rightConfident = state.confident;
        switch(path.node.operator){
            case "||":
                state.confident = leftConfident && (!!left || rightConfident);
                if (!state.confident) return;
                return left || right;
            case "&&":
                state.confident = leftConfident && (!left || rightConfident);
                if (!state.confident) return;
                return left && right;
            case "??":
                state.confident = leftConfident && (left != null || rightConfident);
                if (!state.confident) return;
                return left != null ? left : right;
        }
    }
    if (path.isBinaryExpression()) {
        const left = evaluateCached(path.get("left"), state);
        if (!state.confident) return;
        const right = evaluateCached(path.get("right"), state);
        if (!state.confident) return;
        switch(path.node.operator){
            case "-":
                return left - right;
            case "+":
                return left + right;
            case "/":
                return left / right;
            case "*":
                return left * right;
            case "%":
                return left % right;
            case "**":
                return Math.pow(left, right);
            case "<":
                return left < right;
            case ">":
                return left > right;
            case "<=":
                return left <= right;
            case ">=":
                return left >= right;
            case "==":
                return left == right;
            case "!=":
                return left != right;
            case "===":
                return left === right;
            case "!==":
                return left !== right;
            case "|":
                return left | right;
            case "&":
                return left & right;
            case "^":
                return left ^ right;
            case "<<":
                return left << right;
            case ">>":
                return left >> right;
            case ">>>":
                return left >>> right;
        }
    }
    if (path.isCallExpression()) {
        const callee = path.get("callee");
        let context;
        let func;
        if (callee.isIdentifier() && !path.scope.getBinding(callee.node.name) && (isValidObjectCallee(callee.node.name) || isValidIdentifierCallee(callee.node.name))) func = $parcel$global[callee.node.name];
        if (callee.isMemberExpression()) {
            const object = callee.get("object");
            const property = callee.get("property");
            if (object.isIdentifier() && property.isIdentifier() && isValidObjectCallee(object.node.name) && !isInvalidMethod(property.node.name)) {
                context = $parcel$global[object.node.name];
                const key = property.node.name;
                if (hasOwnProperty.call(context, key)) func = context[key];
            }
            if (object.isLiteral() && property.isIdentifier()) {
                const type = typeof object.node.value;
                if (type === "string" || type === "number") {
                    context = object.node.value;
                    func = context[property.node.name];
                }
            }
        }
        if (func) {
            const args = path.get("arguments").map((arg)=>evaluateCached(arg, state));
            if (!state.confident) return;
            return func.apply(context, args);
        }
    }
    deopt(path, state);
}
function evaluateQuasis(path, quasis, state, raw = false) {
    let str = "";
    let i = 0;
    const exprs = path.isTemplateLiteral() ? path.get("expressions") : path.get("quasi.expressions");
    for (const elem of quasis){
        if (!state.confident) break;
        str += raw ? elem.value.raw : elem.value.cooked;
        const expr = exprs[i++];
        if (expr) str += String(evaluateCached(expr, state));
    }
    if (!state.confident) return;
    return str;
}
function evaluate() {
    const state = {
        confident: true,
        deoptPath: null,
        seen: new Map()
    };
    let value = evaluateCached(this, state);
    if (!state.confident) value = undefined;
    return {
        confident: state.confident,
        deopt: state.deoptPath,
        value: value
    };
}

});

parcelRegister("eCmWH", function(module, exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.arrowFunctionToExpression = arrowFunctionToExpression;
exports.ensureBlock = ensureBlock;
exports.toComputedKey = toComputedKey;
exports.unwrapFunctionEnvironment = unwrapFunctionEnvironment;

var $ardUq = parcelRequire("ardUq");

var $elWuE = parcelRequire("elWuE");

var $aEMin = parcelRequire("aEMin");

var $9OeKS = parcelRequire("9OeKS");
const { arrowFunctionExpression, assignmentExpression, binaryExpression, blockStatement, callExpression, conditionalExpression, expressionStatement, identifier, isIdentifier, jsxIdentifier, logicalExpression, LOGICAL_OPERATORS, memberExpression, metaProperty, numericLiteral, objectExpression, restElement, returnStatement, sequenceExpression, spreadElement, stringLiteral, super: _super, thisExpression, toExpression, unaryExpression } = $ardUq;
function toComputedKey() {
    let key;
    if (this.isMemberExpression()) key = this.node.property;
    else if (this.isProperty() || this.isMethod()) key = this.node.key;
    else throw new ReferenceError("todo");
    if (!this.node.computed) {
        if (isIdentifier(key)) key = stringLiteral(key.name);
    }
    return key;
}
function ensureBlock() {
    const body = this.get("body");
    const bodyNode = body.node;
    if (Array.isArray(body)) throw new Error("Can't convert array path to a block statement");
    if (!bodyNode) throw new Error("Can't convert node without a body");
    if (body.isBlockStatement()) return bodyNode;
    const statements = [];
    let stringPath = "body";
    let key;
    let listKey;
    if (body.isStatement()) {
        listKey = "body";
        key = 0;
        statements.push(body.node);
    } else {
        stringPath += ".body.0";
        if (this.isFunction()) {
            key = "argument";
            statements.push(returnStatement(body.node));
        } else {
            key = "expression";
            statements.push(expressionStatement(body.node));
        }
    }
    this.node.body = blockStatement(statements);
    const parentPath = this.get(stringPath);
    body.setup(parentPath, listKey ? parentPath.node[listKey] : parentPath.node, listKey, key);
    return this.node;
}
exports.arrowFunctionToShadowed = function() {
    if (!this.isArrowFunctionExpression()) return;
    this.arrowFunctionToExpression();
};
function unwrapFunctionEnvironment() {
    if (!this.isArrowFunctionExpression() && !this.isFunctionExpression() && !this.isFunctionDeclaration()) throw this.buildCodeFrameError("Can only unwrap the environment of a function.");
    hoistFunctionEnvironment(this);
}
function setType(path, type) {
    path.node.type = type;
}
function arrowFunctionToExpression({ allowInsertArrow = true, allowInsertArrowWithRest = allowInsertArrow, noNewArrows = !((_arguments$)=>(_arguments$ = arguments[0]) == null ? void 0 : _arguments$.specCompliant)() } = {}) {
    if (!this.isArrowFunctionExpression()) throw this.buildCodeFrameError("Cannot convert non-arrow function to a function expression.");
    const { thisBinding, fnPath: fn } = hoistFunctionEnvironment(this, noNewArrows, allowInsertArrow, allowInsertArrowWithRest);
    fn.ensureBlock();
    setType(fn, "FunctionExpression");
    if (!noNewArrows) {
        const checkBinding = thisBinding ? null : fn.scope.generateUidIdentifier("arrowCheckId");
        if (checkBinding) fn.parentPath.scope.push({
            id: checkBinding,
            init: objectExpression([])
        });
        fn.get("body").unshiftContainer("body", expressionStatement(callExpression(this.hub.addHelper("newArrowCheck"), [
            thisExpression(),
            checkBinding ? identifier(checkBinding.name) : identifier(thisBinding)
        ])));
        fn.replaceWith(callExpression(memberExpression((0, $aEMin.default)(this, true) || fn.node, identifier("bind")), [
            checkBinding ? identifier(checkBinding.name) : thisExpression()
        ]));
        return fn.get("callee.object");
    }
    return fn;
}
const getSuperCallsVisitor = (0, $9OeKS.merge)([
    {
        CallExpression (child, { allSuperCalls }) {
            if (!child.get("callee").isSuper()) return;
            allSuperCalls.push(child);
        }
    },
    $elWuE.default
]);
function hoistFunctionEnvironment(fnPath, noNewArrows = true, allowInsertArrow = true, allowInsertArrowWithRest = true) {
    let arrowParent;
    let thisEnvFn = fnPath.findParent((p)=>{
        if (p.isArrowFunctionExpression()) {
            var _arrowParent;
            (_arrowParent = arrowParent) != null ? _arrowParent : arrowParent = p;
            return false;
        }
        return p.isFunction() || p.isProgram() || p.isClassProperty({
            static: false
        }) || p.isClassPrivateProperty({
            static: false
        });
    });
    const inConstructor = thisEnvFn.isClassMethod({
        kind: "constructor"
    });
    if (thisEnvFn.isClassProperty() || thisEnvFn.isClassPrivateProperty()) {
        if (arrowParent) thisEnvFn = arrowParent;
        else if (allowInsertArrow) {
            fnPath.replaceWith(callExpression(arrowFunctionExpression([], toExpression(fnPath.node)), []));
            thisEnvFn = fnPath.get("callee");
            fnPath = thisEnvFn.get("body");
        } else throw fnPath.buildCodeFrameError("Unable to transform arrow inside class property");
    }
    const { thisPaths, argumentsPaths, newTargetPaths, superProps, superCalls } = getScopeInformation(fnPath);
    if (inConstructor && superCalls.length > 0) {
        if (!allowInsertArrow) throw superCalls[0].buildCodeFrameError("When using '@babel/plugin-transform-arrow-functions', it's not possible to compile `super()` in an arrow function without compiling classes.\nPlease add '@babel/plugin-transform-classes' to your Babel configuration.");
        if (!allowInsertArrowWithRest) throw superCalls[0].buildCodeFrameError("When using '@babel/plugin-transform-parameters', it's not possible to compile `super()` in an arrow function with default or rest parameters without compiling classes.\nPlease add '@babel/plugin-transform-classes' to your Babel configuration.");
        const allSuperCalls = [];
        thisEnvFn.traverse(getSuperCallsVisitor, {
            allSuperCalls: allSuperCalls
        });
        const superBinding = getSuperBinding(thisEnvFn);
        allSuperCalls.forEach((superCall)=>{
            const callee = identifier(superBinding);
            callee.loc = superCall.node.callee.loc;
            superCall.get("callee").replaceWith(callee);
        });
    }
    if (argumentsPaths.length > 0) {
        const argumentsBinding = getBinding(thisEnvFn, "arguments", ()=>{
            const args = ()=>identifier("arguments");
            if (thisEnvFn.scope.path.isProgram()) return conditionalExpression(binaryExpression("===", unaryExpression("typeof", args()), stringLiteral("undefined")), thisEnvFn.scope.buildUndefinedNode(), args());
            else return args();
        });
        argumentsPaths.forEach((argumentsChild)=>{
            const argsRef = identifier(argumentsBinding);
            argsRef.loc = argumentsChild.node.loc;
            argumentsChild.replaceWith(argsRef);
        });
    }
    if (newTargetPaths.length > 0) {
        const newTargetBinding = getBinding(thisEnvFn, "newtarget", ()=>metaProperty(identifier("new"), identifier("target")));
        newTargetPaths.forEach((targetChild)=>{
            const targetRef = identifier(newTargetBinding);
            targetRef.loc = targetChild.node.loc;
            targetChild.replaceWith(targetRef);
        });
    }
    if (superProps.length > 0) {
        if (!allowInsertArrow) throw superProps[0].buildCodeFrameError("When using '@babel/plugin-transform-arrow-functions', it's not possible to compile `super.prop` in an arrow function without compiling classes.\nPlease add '@babel/plugin-transform-classes' to your Babel configuration.");
        const flatSuperProps = superProps.reduce((acc, superProp)=>acc.concat(standardizeSuperProperty(superProp)), []);
        flatSuperProps.forEach((superProp)=>{
            const key = superProp.node.computed ? "" : superProp.get("property").node.name;
            const superParentPath = superProp.parentPath;
            const isAssignment = superParentPath.isAssignmentExpression({
                left: superProp.node
            });
            const isCall = superParentPath.isCallExpression({
                callee: superProp.node
            });
            const isTaggedTemplate = superParentPath.isTaggedTemplateExpression({
                tag: superProp.node
            });
            const superBinding = getSuperPropBinding(thisEnvFn, isAssignment, key);
            const args = [];
            if (superProp.node.computed) args.push(superProp.get("property").node);
            if (isAssignment) {
                const value = superParentPath.node.right;
                args.push(value);
            }
            const call = callExpression(identifier(superBinding), args);
            if (isCall) {
                superParentPath.unshiftContainer("arguments", thisExpression());
                superProp.replaceWith(memberExpression(call, identifier("call")));
                thisPaths.push(superParentPath.get("arguments.0"));
            } else if (isAssignment) superParentPath.replaceWith(call);
            else if (isTaggedTemplate) {
                superProp.replaceWith(callExpression(memberExpression(call, identifier("bind"), false), [
                    thisExpression()
                ]));
                thisPaths.push(superProp.get("arguments.0"));
            } else superProp.replaceWith(call);
        });
    }
    let thisBinding;
    if (thisPaths.length > 0 || !noNewArrows) {
        thisBinding = getThisBinding(thisEnvFn, inConstructor);
        if (noNewArrows || inConstructor && hasSuperClass(thisEnvFn)) {
            thisPaths.forEach((thisChild)=>{
                const thisRef = thisChild.isJSX() ? jsxIdentifier(thisBinding) : identifier(thisBinding);
                thisRef.loc = thisChild.node.loc;
                thisChild.replaceWith(thisRef);
            });
            if (!noNewArrows) thisBinding = null;
        }
    }
    return {
        thisBinding: thisBinding,
        fnPath: fnPath
    };
}
function isLogicalOp(op) {
    return LOGICAL_OPERATORS.includes(op);
}
function standardizeSuperProperty(superProp) {
    if (superProp.parentPath.isAssignmentExpression() && superProp.parentPath.node.operator !== "=") {
        const assignmentPath = superProp.parentPath;
        const op = assignmentPath.node.operator.slice(0, -1);
        const value = assignmentPath.node.right;
        const isLogicalAssignment = isLogicalOp(op);
        if (superProp.node.computed) {
            const tmp = superProp.scope.generateDeclaredUidIdentifier("tmp");
            const object = superProp.node.object;
            const property = superProp.node.property;
            assignmentPath.get("left").replaceWith(memberExpression(object, assignmentExpression("=", tmp, property), true));
            assignmentPath.get("right").replaceWith(rightExpression(isLogicalAssignment ? "=" : op, memberExpression(object, identifier(tmp.name), true), value));
        } else {
            const object = superProp.node.object;
            const property = superProp.node.property;
            assignmentPath.get("left").replaceWith(memberExpression(object, property));
            assignmentPath.get("right").replaceWith(rightExpression(isLogicalAssignment ? "=" : op, memberExpression(object, identifier(property.name)), value));
        }
        if (isLogicalAssignment) assignmentPath.replaceWith(logicalExpression(op, assignmentPath.node.left, assignmentPath.node.right));
        else assignmentPath.node.operator = "=";
        return [
            assignmentPath.get("left"),
            assignmentPath.get("right").get("left")
        ];
    } else if (superProp.parentPath.isUpdateExpression()) {
        const updateExpr = superProp.parentPath;
        const tmp = superProp.scope.generateDeclaredUidIdentifier("tmp");
        const computedKey = superProp.node.computed ? superProp.scope.generateDeclaredUidIdentifier("prop") : null;
        const parts = [
            assignmentExpression("=", tmp, memberExpression(superProp.node.object, computedKey ? assignmentExpression("=", computedKey, superProp.node.property) : superProp.node.property, superProp.node.computed)),
            assignmentExpression("=", memberExpression(superProp.node.object, computedKey ? identifier(computedKey.name) : superProp.node.property, superProp.node.computed), binaryExpression(superProp.parentPath.node.operator[0], identifier(tmp.name), numericLiteral(1)))
        ];
        if (!superProp.parentPath.node.prefix) parts.push(identifier(tmp.name));
        updateExpr.replaceWith(sequenceExpression(parts));
        const left = updateExpr.get("expressions.0.right");
        const right = updateExpr.get("expressions.1.left");
        return [
            left,
            right
        ];
    }
    return [
        superProp
    ];
    function rightExpression(op, left, right) {
        if (op === "=") return assignmentExpression("=", left, right);
        else return binaryExpression(op, left, right);
    }
}
function hasSuperClass(thisEnvFn) {
    return thisEnvFn.isClassMethod() && !!thisEnvFn.parentPath.parentPath.node.superClass;
}
const assignSuperThisVisitor = (0, $9OeKS.merge)([
    {
        CallExpression (child, { supers, thisBinding }) {
            if (!child.get("callee").isSuper()) return;
            if (supers.has(child.node)) return;
            supers.add(child.node);
            child.replaceWithMultiple([
                child.node,
                assignmentExpression("=", identifier(thisBinding), identifier("this"))
            ]);
        }
    },
    $elWuE.default
]);
function getThisBinding(thisEnvFn, inConstructor) {
    return getBinding(thisEnvFn, "this", (thisBinding)=>{
        if (!inConstructor || !hasSuperClass(thisEnvFn)) return thisExpression();
        thisEnvFn.traverse(assignSuperThisVisitor, {
            supers: new WeakSet(),
            thisBinding: thisBinding
        });
    });
}
function getSuperBinding(thisEnvFn) {
    return getBinding(thisEnvFn, "supercall", ()=>{
        const argsBinding = thisEnvFn.scope.generateUidIdentifier("args");
        return arrowFunctionExpression([
            restElement(argsBinding)
        ], callExpression(_super(), [
            spreadElement(identifier(argsBinding.name))
        ]));
    });
}
function getSuperPropBinding(thisEnvFn, isAssignment, propName) {
    const op = isAssignment ? "set" : "get";
    return getBinding(thisEnvFn, `superprop_${op}:${propName || ""}`, ()=>{
        const argsList = [];
        let fnBody;
        if (propName) fnBody = memberExpression(_super(), identifier(propName));
        else {
            const method = thisEnvFn.scope.generateUidIdentifier("prop");
            argsList.unshift(method);
            fnBody = memberExpression(_super(), identifier(method.name), true);
        }
        if (isAssignment) {
            const valueIdent = thisEnvFn.scope.generateUidIdentifier("value");
            argsList.push(valueIdent);
            fnBody = assignmentExpression("=", fnBody, identifier(valueIdent.name));
        }
        return arrowFunctionExpression(argsList, fnBody);
    });
}
function getBinding(thisEnvFn, key, init) {
    const cacheKey = "binding:" + key;
    let data = thisEnvFn.getData(cacheKey);
    if (!data) {
        const id = thisEnvFn.scope.generateUidIdentifier(key);
        data = id.name;
        thisEnvFn.setData(cacheKey, data);
        thisEnvFn.scope.push({
            id: id,
            init: init(data)
        });
    }
    return data;
}
const getScopeInformationVisitor = (0, $9OeKS.merge)([
    {
        ThisExpression (child, { thisPaths }) {
            thisPaths.push(child);
        },
        JSXIdentifier (child, { thisPaths }) {
            if (child.node.name !== "this") return;
            if (!child.parentPath.isJSXMemberExpression({
                object: child.node
            }) && !child.parentPath.isJSXOpeningElement({
                name: child.node
            })) return;
            thisPaths.push(child);
        },
        CallExpression (child, { superCalls }) {
            if (child.get("callee").isSuper()) superCalls.push(child);
        },
        MemberExpression (child, { superProps }) {
            if (child.get("object").isSuper()) superProps.push(child);
        },
        Identifier (child, { argumentsPaths }) {
            if (!child.isReferencedIdentifier({
                name: "arguments"
            })) return;
            let curr = child.scope;
            do {
                if (curr.hasOwnBinding("arguments")) {
                    curr.rename("arguments");
                    return;
                }
                if (curr.path.isFunction() && !curr.path.isArrowFunctionExpression()) break;
            }while (curr = curr.parent);
            argumentsPaths.push(child);
        },
        MetaProperty (child, { newTargetPaths }) {
            if (!child.get("meta").isIdentifier({
                name: "new"
            })) return;
            if (!child.get("property").isIdentifier({
                name: "target"
            })) return;
            newTargetPaths.push(child);
        }
    },
    $elWuE.default
]);
function getScopeInformation(fnPath) {
    const thisPaths = [];
    const argumentsPaths = [];
    const newTargetPaths = [];
    const superProps = [];
    const superCalls = [];
    fnPath.traverse(getScopeInformationVisitor, {
        thisPaths: thisPaths,
        argumentsPaths: argumentsPaths,
        newTargetPaths: newTargetPaths,
        superProps: superProps,
        superCalls: superCalls
    });
    return {
        thisPaths: thisPaths,
        argumentsPaths: argumentsPaths,
        newTargetPaths: newTargetPaths,
        superProps: superProps,
        superCalls: superCalls
    };
}

});
parcelRegister("aEMin", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7c231a463370192e$var$_default;

var $gQ5sj = parcelRequire("gQ5sj");

var $ardUq = parcelRequire("ardUq");
const { NOT_LOCAL_BINDING: $7c231a463370192e$var$NOT_LOCAL_BINDING, cloneNode: $7c231a463370192e$var$cloneNode, identifier: $7c231a463370192e$var$identifier, isAssignmentExpression: $7c231a463370192e$var$isAssignmentExpression, isAssignmentPattern: $7c231a463370192e$var$isAssignmentPattern, isFunction: $7c231a463370192e$var$isFunction, isIdentifier: $7c231a463370192e$var$isIdentifier, isLiteral: $7c231a463370192e$var$isLiteral, isNullLiteral: $7c231a463370192e$var$isNullLiteral, isObjectMethod: $7c231a463370192e$var$isObjectMethod, isObjectProperty: $7c231a463370192e$var$isObjectProperty, isRegExpLiteral: $7c231a463370192e$var$isRegExpLiteral, isRestElement: $7c231a463370192e$var$isRestElement, isTemplateLiteral: $7c231a463370192e$var$isTemplateLiteral, isVariableDeclarator: $7c231a463370192e$var$isVariableDeclarator, toBindingIdentifierName: $7c231a463370192e$var$toBindingIdentifierName } = $ardUq;
function $7c231a463370192e$var$getFunctionArity(node) {
    const count = node.params.findIndex((param)=>$7c231a463370192e$var$isAssignmentPattern(param) || $7c231a463370192e$var$isRestElement(param));
    return count === -1 ? node.params.length : count;
}
const $7c231a463370192e$var$buildPropertyMethodAssignmentWrapper = $gQ5sj.default.statement(`
  (function (FUNCTION_KEY) {
    function FUNCTION_ID() {
      return FUNCTION_KEY.apply(this, arguments);
    }

    FUNCTION_ID.toString = function () {
      return FUNCTION_KEY.toString();
    }

    return FUNCTION_ID;
  })(FUNCTION)
`);
const $7c231a463370192e$var$buildGeneratorPropertyMethodAssignmentWrapper = $gQ5sj.default.statement(`
  (function (FUNCTION_KEY) {
    function* FUNCTION_ID() {
      return yield* FUNCTION_KEY.apply(this, arguments);
    }

    FUNCTION_ID.toString = function () {
      return FUNCTION_KEY.toString();
    };

    return FUNCTION_ID;
  })(FUNCTION)
`);
const $7c231a463370192e$var$visitor = {
    "ReferencedIdentifier|BindingIdentifier" (path, state) {
        if (path.node.name !== state.name) return;
        const localDeclar = path.scope.getBindingIdentifier(state.name);
        if (localDeclar !== state.outerDeclar) return;
        state.selfReference = true;
        path.stop();
    }
};
function $7c231a463370192e$var$getNameFromLiteralId(id) {
    if ($7c231a463370192e$var$isNullLiteral(id)) return "null";
    if ($7c231a463370192e$var$isRegExpLiteral(id)) return `_${id.pattern}_${id.flags}`;
    if ($7c231a463370192e$var$isTemplateLiteral(id)) return id.quasis.map((quasi)=>quasi.value.raw).join("");
    if (id.value !== undefined) return id.value + "";
    return "";
}
function $7c231a463370192e$var$wrap(state, method, id, scope) {
    if (state.selfReference) {
        if (scope.hasBinding(id.name) && !scope.hasGlobal(id.name)) scope.rename(id.name);
        else {
            if (!$7c231a463370192e$var$isFunction(method)) return;
            let build = $7c231a463370192e$var$buildPropertyMethodAssignmentWrapper;
            if (method.generator) build = $7c231a463370192e$var$buildGeneratorPropertyMethodAssignmentWrapper;
            const template = build({
                FUNCTION: method,
                FUNCTION_ID: id,
                FUNCTION_KEY: scope.generateUidIdentifier(id.name)
            }).expression;
            const params = template.callee.body.body[0].params;
            for(let i = 0, len = $7c231a463370192e$var$getFunctionArity(method); i < len; i++)params.push(scope.generateUidIdentifier("x"));
            return template;
        }
    }
    method.id = id;
    scope.getProgramParent().references[id.name] = true;
}
function $7c231a463370192e$var$visit(node, name, scope) {
    const state = {
        selfAssignment: false,
        selfReference: false,
        outerDeclar: scope.getBindingIdentifier(name),
        name: name
    };
    const binding = scope.getOwnBinding(name);
    if (binding) {
        if (binding.kind === "param") state.selfReference = true;
    } else if (state.outerDeclar || scope.hasGlobal(name)) scope.traverse(node, $7c231a463370192e$var$visitor, state);
    return state;
}
function $7c231a463370192e$var$_default({ node: node, parent: parent, scope: scope, id: id }, localBinding = false, supportUnicodeId = false) {
    if (node.id) return;
    if (($7c231a463370192e$var$isObjectProperty(parent) || $7c231a463370192e$var$isObjectMethod(parent, {
        kind: "method"
    })) && (!parent.computed || $7c231a463370192e$var$isLiteral(parent.key))) id = parent.key;
    else if ($7c231a463370192e$var$isVariableDeclarator(parent)) {
        id = parent.id;
        if ($7c231a463370192e$var$isIdentifier(id) && !localBinding) {
            const binding = scope.parent.getBinding(id.name);
            if (binding && binding.constant && scope.getBinding(id.name) === binding) {
                node.id = $7c231a463370192e$var$cloneNode(id);
                node.id[$7c231a463370192e$var$NOT_LOCAL_BINDING] = true;
                return;
            }
        }
    } else if ($7c231a463370192e$var$isAssignmentExpression(parent, {
        operator: "="
    })) id = parent.left;
    else if (!id) return;
    let name;
    if (id && $7c231a463370192e$var$isLiteral(id)) name = $7c231a463370192e$var$getNameFromLiteralId(id);
    else if (id && $7c231a463370192e$var$isIdentifier(id)) name = id.name;
    if (name === undefined) return;
    if (!supportUnicodeId && $7c231a463370192e$var$isFunction(node) && /[\uD800-\uDFFF]/.test(name)) return;
    name = $7c231a463370192e$var$toBindingIdentifierName(name);
    const newId = $7c231a463370192e$var$identifier(name);
    newId[$7c231a463370192e$var$NOT_LOCAL_BINDING] = true;
    const state = $7c231a463370192e$var$visit(node, name, scope);
    return $7c231a463370192e$var$wrap(state, node, newId, scope) || node;
}

});
parcelRegister("gQ5sj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.statements = module.exports.statement = module.exports.smart = module.exports.program = module.exports.expression = module.exports.default = void 0;

var $ixeJG = parcelRequire("ixeJG");

var $lkmfX = parcelRequire("lkmfX");
const $c425bc0ab2ffba65$var$smart = module.exports.smart = (0, $lkmfX.default)($ixeJG.smart);
const $c425bc0ab2ffba65$var$statement = module.exports.statement = (0, $lkmfX.default)($ixeJG.statement);
const $c425bc0ab2ffba65$var$statements = module.exports.statements = (0, $lkmfX.default)($ixeJG.statements);
const $c425bc0ab2ffba65$var$expression = module.exports.expression = (0, $lkmfX.default)($ixeJG.expression);
const $c425bc0ab2ffba65$var$program = module.exports.program = (0, $lkmfX.default)($ixeJG.program);
var $c425bc0ab2ffba65$var$_default = module.exports.default = Object.assign($c425bc0ab2ffba65$var$smart.bind(undefined), {
    smart: $c425bc0ab2ffba65$var$smart,
    statement: $c425bc0ab2ffba65$var$statement,
    statements: $c425bc0ab2ffba65$var$statements,
    expression: $c425bc0ab2ffba65$var$expression,
    program: $c425bc0ab2ffba65$var$program,
    ast: $c425bc0ab2ffba65$var$smart.ast
});

});
parcelRegister("ixeJG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.statements = module.exports.statement = module.exports.smart = module.exports.program = module.exports.expression = void 0;

var $ardUq = parcelRequire("ardUq");
const { assertExpressionStatement: $d7e6bd48634c2ad0$var$assertExpressionStatement } = $ardUq;
function $d7e6bd48634c2ad0$var$makeStatementFormatter(fn) {
    return {
        code: (str)=>`/* @babel/template */;\n${str}`,
        validate: ()=>{},
        unwrap: (ast)=>{
            return fn(ast.program.body.slice(1));
        }
    };
}
const $d7e6bd48634c2ad0$var$smart = module.exports.smart = $d7e6bd48634c2ad0$var$makeStatementFormatter((body)=>{
    if (body.length > 1) return body;
    else return body[0];
});
const $d7e6bd48634c2ad0$var$statements = module.exports.statements = $d7e6bd48634c2ad0$var$makeStatementFormatter((body)=>body);
const $d7e6bd48634c2ad0$var$statement = module.exports.statement = $d7e6bd48634c2ad0$var$makeStatementFormatter((body)=>{
    if (body.length === 0) throw new Error("Found nothing to return.");
    if (body.length > 1) throw new Error("Found multiple statements but wanted one");
    return body[0];
});
const $d7e6bd48634c2ad0$var$expression = module.exports.expression = {
    code: (str)=>`(\n${str}\n)`,
    validate: (ast)=>{
        if (ast.program.body.length > 1) throw new Error("Found multiple statements but wanted one");
        if ($d7e6bd48634c2ad0$var$expression.unwrap(ast).start === 0) throw new Error("Parse result included parens.");
    },
    unwrap: ({ program: program })=>{
        const [stmt] = program.body;
        $d7e6bd48634c2ad0$var$assertExpressionStatement(stmt);
        return stmt.expression;
    }
};
const $d7e6bd48634c2ad0$var$program = module.exports.program = {
    code: (str)=>str,
    validate: ()=>{},
    unwrap: (ast)=>ast.program
};

});

parcelRegister("lkmfX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f86cbae28bd02b59$var$createTemplateBuilder;

var $cCX4f = parcelRequire("cCX4f");

var $4W4N3 = parcelRequire("4W4N3");

var $1194c = parcelRequire("1194c");
const $f86cbae28bd02b59$var$NO_PLACEHOLDER = (0, $cCX4f.validate)({
    placeholderPattern: false
});
function $f86cbae28bd02b59$var$createTemplateBuilder(formatter, defaultOpts) {
    const templateFnCache = new WeakMap();
    const templateAstCache = new WeakMap();
    const cachedOpts = defaultOpts || (0, $cCX4f.validate)(null);
    return Object.assign((tpl, ...args)=>{
        if (typeof tpl === "string") {
            if (args.length > 1) throw new Error("Unexpected extra params.");
            return $f86cbae28bd02b59$var$extendedTrace((0, $4W4N3.default)(formatter, tpl, (0, $cCX4f.merge)(cachedOpts, (0, $cCX4f.validate)(args[0]))));
        } else if (Array.isArray(tpl)) {
            let builder = templateFnCache.get(tpl);
            if (!builder) {
                builder = (0, $1194c.default)(formatter, tpl, cachedOpts);
                templateFnCache.set(tpl, builder);
            }
            return $f86cbae28bd02b59$var$extendedTrace(builder(args));
        } else if (typeof tpl === "object" && tpl) {
            if (args.length > 0) throw new Error("Unexpected extra params.");
            return $f86cbae28bd02b59$var$createTemplateBuilder(formatter, (0, $cCX4f.merge)(cachedOpts, (0, $cCX4f.validate)(tpl)));
        }
        throw new Error(`Unexpected template param ${typeof tpl}`);
    }, {
        ast: (tpl, ...args)=>{
            if (typeof tpl === "string") {
                if (args.length > 1) throw new Error("Unexpected extra params.");
                return (0, $4W4N3.default)(formatter, tpl, (0, $cCX4f.merge)((0, $cCX4f.merge)(cachedOpts, (0, $cCX4f.validate)(args[0])), $f86cbae28bd02b59$var$NO_PLACEHOLDER))();
            } else if (Array.isArray(tpl)) {
                let builder = templateAstCache.get(tpl);
                if (!builder) {
                    builder = (0, $1194c.default)(formatter, tpl, (0, $cCX4f.merge)(cachedOpts, $f86cbae28bd02b59$var$NO_PLACEHOLDER));
                    templateAstCache.set(tpl, builder);
                }
                return builder(args)();
            }
            throw new Error(`Unexpected template param ${typeof tpl}`);
        }
    });
}
function $f86cbae28bd02b59$var$extendedTrace(fn) {
    let rootStack = "";
    try {
        throw new Error();
    } catch (error) {
        if (error.stack) rootStack = error.stack.split("\n").slice(3).join("\n");
    }
    return (arg)=>{
        try {
            return fn(arg);
        } catch (err) {
            err.stack += `\n    =============\n${rootStack}`;
            throw err;
        }
    };
}

});
parcelRegister("cCX4f", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.merge = $9316da3e624b2983$var$merge;
module.exports.normalizeReplacements = $9316da3e624b2983$var$normalizeReplacements;
module.exports.validate = $9316da3e624b2983$var$validate;
const $9316da3e624b2983$var$_excluded = [
    "placeholderWhitelist",
    "placeholderPattern",
    "preserveComments",
    "syntacticPlaceholders"
];
function $9316da3e624b2983$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $9316da3e624b2983$var$merge(a, b) {
    const { placeholderWhitelist: placeholderWhitelist = a.placeholderWhitelist, placeholderPattern: placeholderPattern = a.placeholderPattern, preserveComments: preserveComments = a.preserveComments, syntacticPlaceholders: syntacticPlaceholders = a.syntacticPlaceholders } = b;
    return {
        parser: Object.assign({}, a.parser, b.parser),
        placeholderWhitelist: placeholderWhitelist,
        placeholderPattern: placeholderPattern,
        preserveComments: preserveComments,
        syntacticPlaceholders: syntacticPlaceholders
    };
}
function $9316da3e624b2983$var$validate(opts) {
    if (opts != null && typeof opts !== "object") throw new Error("Unknown template options.");
    const _ref = opts || {}, { placeholderWhitelist: placeholderWhitelist, placeholderPattern: placeholderPattern, preserveComments: preserveComments, syntacticPlaceholders: syntacticPlaceholders } = _ref, parser = $9316da3e624b2983$var$_objectWithoutPropertiesLoose(_ref, $9316da3e624b2983$var$_excluded);
    if (placeholderWhitelist != null && !(placeholderWhitelist instanceof Set)) throw new Error("'.placeholderWhitelist' must be a Set, null, or undefined");
    if (placeholderPattern != null && !(placeholderPattern instanceof RegExp) && placeholderPattern !== false) throw new Error("'.placeholderPattern' must be a RegExp, false, null, or undefined");
    if (preserveComments != null && typeof preserveComments !== "boolean") throw new Error("'.preserveComments' must be a boolean, null, or undefined");
    if (syntacticPlaceholders != null && typeof syntacticPlaceholders !== "boolean") throw new Error("'.syntacticPlaceholders' must be a boolean, null, or undefined");
    if (syntacticPlaceholders === true && (placeholderWhitelist != null || placeholderPattern != null)) throw new Error("'.placeholderWhitelist' and '.placeholderPattern' aren't compatible with '.syntacticPlaceholders: true'");
    return {
        parser: parser,
        placeholderWhitelist: placeholderWhitelist || undefined,
        placeholderPattern: placeholderPattern == null ? undefined : placeholderPattern,
        preserveComments: preserveComments == null ? undefined : preserveComments,
        syntacticPlaceholders: syntacticPlaceholders == null ? undefined : syntacticPlaceholders
    };
}
function $9316da3e624b2983$var$normalizeReplacements(replacements) {
    if (Array.isArray(replacements)) return replacements.reduce((acc, replacement, i)=>{
        acc["$" + i] = replacement;
        return acc;
    }, {});
    else if (typeof replacements === "object" || replacements == null) return replacements || undefined;
    throw new Error("Template replacements must be an array, object, null, or undefined");
}

});

parcelRegister("4W4N3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $39804b6f6b312f52$var$stringTemplate;

var $cCX4f = parcelRequire("cCX4f");

var $5j6rS = parcelRequire("5j6rS");

var $fEw80 = parcelRequire("fEw80");
function $39804b6f6b312f52$var$stringTemplate(formatter, code, opts) {
    code = formatter.code(code);
    let metadata;
    return (arg)=>{
        const replacements = (0, $cCX4f.normalizeReplacements)(arg);
        if (!metadata) metadata = (0, $5j6rS.default)(formatter, code, opts);
        return formatter.unwrap((0, $fEw80.default)(metadata, replacements));
    };
}

});
parcelRegister("5j6rS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3dd3baae2a217c23$var$parseAndBuildMetadata;

var $ardUq = parcelRequire("ardUq");

var $fuTml = parcelRequire("fuTml");

var $frkOe = parcelRequire("frkOe");
const { isCallExpression: $3dd3baae2a217c23$var$isCallExpression, isExpressionStatement: $3dd3baae2a217c23$var$isExpressionStatement, isFunction: $3dd3baae2a217c23$var$isFunction, isIdentifier: $3dd3baae2a217c23$var$isIdentifier, isJSXIdentifier: $3dd3baae2a217c23$var$isJSXIdentifier, isNewExpression: $3dd3baae2a217c23$var$isNewExpression, isPlaceholder: $3dd3baae2a217c23$var$isPlaceholder, isStatement: $3dd3baae2a217c23$var$isStatement, isStringLiteral: $3dd3baae2a217c23$var$isStringLiteral, removePropertiesDeep: $3dd3baae2a217c23$var$removePropertiesDeep, traverse: $3dd3baae2a217c23$var$traverse } = $ardUq;
const $3dd3baae2a217c23$var$PATTERN = /^[_$A-Z0-9]+$/;
function $3dd3baae2a217c23$var$parseAndBuildMetadata(formatter, code, opts) {
    const { placeholderWhitelist: placeholderWhitelist, placeholderPattern: placeholderPattern, preserveComments: preserveComments, syntacticPlaceholders: syntacticPlaceholders } = opts;
    const ast = $3dd3baae2a217c23$var$parseWithCodeFrame(code, opts.parser, syntacticPlaceholders);
    $3dd3baae2a217c23$var$removePropertiesDeep(ast, {
        preserveComments: preserveComments
    });
    formatter.validate(ast);
    const state = {
        syntactic: {
            placeholders: [],
            placeholderNames: new Set()
        },
        legacy: {
            placeholders: [],
            placeholderNames: new Set()
        },
        placeholderWhitelist: placeholderWhitelist,
        placeholderPattern: placeholderPattern,
        syntacticPlaceholders: syntacticPlaceholders
    };
    $3dd3baae2a217c23$var$traverse(ast, $3dd3baae2a217c23$var$placeholderVisitorHandler, state);
    return Object.assign({
        ast: ast
    }, state.syntactic.placeholders.length ? state.syntactic : state.legacy);
}
function $3dd3baae2a217c23$var$placeholderVisitorHandler(node, ancestors, state) {
    var _state$placeholderWhi;
    let name;
    let hasSyntacticPlaceholders = state.syntactic.placeholders.length > 0;
    if ($3dd3baae2a217c23$var$isPlaceholder(node)) {
        if (state.syntacticPlaceholders === false) throw new Error("%%foo%%-style placeholders can't be used when '.syntacticPlaceholders' is false.");
        name = node.name.name;
        hasSyntacticPlaceholders = true;
    } else if (hasSyntacticPlaceholders || state.syntacticPlaceholders) return;
    else if ($3dd3baae2a217c23$var$isIdentifier(node) || $3dd3baae2a217c23$var$isJSXIdentifier(node)) name = node.name;
    else if ($3dd3baae2a217c23$var$isStringLiteral(node)) name = node.value;
    else return;
    if (hasSyntacticPlaceholders && (state.placeholderPattern != null || state.placeholderWhitelist != null)) throw new Error("'.placeholderWhitelist' and '.placeholderPattern' aren't compatible with '.syntacticPlaceholders: true'");
    if (!hasSyntacticPlaceholders && (state.placeholderPattern === false || !(state.placeholderPattern || $3dd3baae2a217c23$var$PATTERN).test(name)) && !((_state$placeholderWhi = state.placeholderWhitelist) != null && _state$placeholderWhi.has(name))) return;
    ancestors = ancestors.slice();
    const { node: parent, key: key } = ancestors[ancestors.length - 1];
    let type;
    if ($3dd3baae2a217c23$var$isStringLiteral(node) || $3dd3baae2a217c23$var$isPlaceholder(node, {
        expectedNode: "StringLiteral"
    })) type = "string";
    else if ($3dd3baae2a217c23$var$isNewExpression(parent) && key === "arguments" || $3dd3baae2a217c23$var$isCallExpression(parent) && key === "arguments" || $3dd3baae2a217c23$var$isFunction(parent) && key === "params") type = "param";
    else if ($3dd3baae2a217c23$var$isExpressionStatement(parent) && !$3dd3baae2a217c23$var$isPlaceholder(node)) {
        type = "statement";
        ancestors = ancestors.slice(0, -1);
    } else if ($3dd3baae2a217c23$var$isStatement(node) && $3dd3baae2a217c23$var$isPlaceholder(node)) type = "statement";
    else type = "other";
    const { placeholders: placeholders, placeholderNames: placeholderNames } = !hasSyntacticPlaceholders ? state.legacy : state.syntactic;
    placeholders.push({
        name: name,
        type: type,
        resolve: (ast)=>$3dd3baae2a217c23$var$resolveAncestors(ast, ancestors),
        isDuplicate: placeholderNames.has(name)
    });
    placeholderNames.add(name);
}
function $3dd3baae2a217c23$var$resolveAncestors(ast, ancestors) {
    let parent = ast;
    for(let i = 0; i < ancestors.length - 1; i++){
        const { key: key, index: index } = ancestors[i];
        if (index === undefined) parent = parent[key];
        else parent = parent[key][index];
    }
    const { key: key, index: index } = ancestors[ancestors.length - 1];
    return {
        parent: parent,
        key: key,
        index: index
    };
}
function $3dd3baae2a217c23$var$parseWithCodeFrame(code, parserOpts, syntacticPlaceholders) {
    const plugins = (parserOpts.plugins || []).slice();
    if (syntacticPlaceholders !== false) plugins.push("placeholders");
    parserOpts = Object.assign({
        allowReturnOutsideFunction: true,
        allowSuperOutsideMethod: true,
        sourceType: "module"
    }, parserOpts, {
        plugins: plugins
    });
    try {
        return (0, $fuTml.parse)(code, parserOpts);
    } catch (err) {
        const loc = err.loc;
        if (loc) {
            err.message += "\n" + (0, $frkOe.codeFrameColumns)(code, {
                start: loc
            });
            err.code = "BABEL_TEMPLATE_PARSE_ERROR";
        }
        throw err;
    }
}

});

parcelRegister("fEw80", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b6538370429637b4$var$populatePlaceholders;

var $ardUq = parcelRequire("ardUq");
const { blockStatement: $b6538370429637b4$var$blockStatement, cloneNode: $b6538370429637b4$var$cloneNode, emptyStatement: $b6538370429637b4$var$emptyStatement, expressionStatement: $b6538370429637b4$var$expressionStatement, identifier: $b6538370429637b4$var$identifier, isStatement: $b6538370429637b4$var$isStatement, isStringLiteral: $b6538370429637b4$var$isStringLiteral, stringLiteral: $b6538370429637b4$var$stringLiteral, validate: $b6538370429637b4$var$validate } = $ardUq;
function $b6538370429637b4$var$populatePlaceholders(metadata, replacements) {
    const ast = $b6538370429637b4$var$cloneNode(metadata.ast);
    if (replacements) {
        metadata.placeholders.forEach((placeholder)=>{
            if (!hasOwnProperty.call(replacements, placeholder.name)) {
                const placeholderName = placeholder.name;
                throw new Error(`Error: No substitution given for "${placeholderName}". If this is not meant to be a
            placeholder you may want to consider passing one of the following options to @babel/template:
            - { placeholderPattern: false, placeholderWhitelist: new Set(['${placeholderName}'])}
            - { placeholderPattern: /^${placeholderName}$/ }`);
            }
        });
        Object.keys(replacements).forEach((key)=>{
            if (!metadata.placeholderNames.has(key)) throw new Error(`Unknown substitution "${key}" given`);
        });
    }
    metadata.placeholders.slice().reverse().forEach((placeholder)=>{
        try {
            $b6538370429637b4$var$applyReplacement(placeholder, ast, replacements && replacements[placeholder.name] || null);
        } catch (e) {
            e.message = `@babel/template placeholder "${placeholder.name}": ${e.message}`;
            throw e;
        }
    });
    return ast;
}
function $b6538370429637b4$var$applyReplacement(placeholder, ast, replacement) {
    if (placeholder.isDuplicate) {
        if (Array.isArray(replacement)) replacement = replacement.map((node)=>$b6538370429637b4$var$cloneNode(node));
        else if (typeof replacement === "object") replacement = $b6538370429637b4$var$cloneNode(replacement);
    }
    const { parent: parent, key: key, index: index } = placeholder.resolve(ast);
    if (placeholder.type === "string") {
        if (typeof replacement === "string") replacement = $b6538370429637b4$var$stringLiteral(replacement);
        if (!replacement || !$b6538370429637b4$var$isStringLiteral(replacement)) throw new Error("Expected string substitution");
    } else if (placeholder.type === "statement") {
        if (index === undefined) {
            if (!replacement) replacement = $b6538370429637b4$var$emptyStatement();
            else if (Array.isArray(replacement)) replacement = $b6538370429637b4$var$blockStatement(replacement);
            else if (typeof replacement === "string") replacement = $b6538370429637b4$var$expressionStatement($b6538370429637b4$var$identifier(replacement));
            else if (!$b6538370429637b4$var$isStatement(replacement)) replacement = $b6538370429637b4$var$expressionStatement(replacement);
        } else if (replacement && !Array.isArray(replacement)) {
            if (typeof replacement === "string") replacement = $b6538370429637b4$var$identifier(replacement);
            if (!$b6538370429637b4$var$isStatement(replacement)) replacement = $b6538370429637b4$var$expressionStatement(replacement);
        }
    } else if (placeholder.type === "param") {
        if (typeof replacement === "string") replacement = $b6538370429637b4$var$identifier(replacement);
        if (index === undefined) throw new Error("Assertion failure.");
    } else {
        if (typeof replacement === "string") replacement = $b6538370429637b4$var$identifier(replacement);
        if (Array.isArray(replacement)) throw new Error("Cannot replace single expression with an array.");
    }
    if (index === undefined) {
        $b6538370429637b4$var$validate(parent, key, replacement);
        parent[key] = replacement;
    } else {
        const items = parent[key].slice();
        if (placeholder.type === "statement" || placeholder.type === "param") {
            if (replacement == null) items.splice(index, 1);
            else if (Array.isArray(replacement)) items.splice(index, 1, ...replacement);
            else items[index] = replacement;
        } else items[index] = replacement;
        $b6538370429637b4$var$validate(parent, key, items);
        parent[key] = items;
    }
}

});


parcelRegister("1194c", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0bdceaeb6b845013$var$literalTemplate;

var $cCX4f = parcelRequire("cCX4f");

var $5j6rS = parcelRequire("5j6rS");

var $fEw80 = parcelRequire("fEw80");
function $0bdceaeb6b845013$var$literalTemplate(formatter, tpl, opts) {
    const { metadata: metadata, names: names } = $0bdceaeb6b845013$var$buildLiteralData(formatter, tpl, opts);
    return (arg)=>{
        const defaultReplacements = {};
        arg.forEach((replacement, i)=>{
            defaultReplacements[names[i]] = replacement;
        });
        return (arg)=>{
            const replacements = (0, $cCX4f.normalizeReplacements)(arg);
            if (replacements) Object.keys(replacements).forEach((key)=>{
                if (hasOwnProperty.call(defaultReplacements, key)) throw new Error("Unexpected replacement overlap.");
            });
            return formatter.unwrap((0, $fEw80.default)(metadata, replacements ? Object.assign(replacements, defaultReplacements) : defaultReplacements));
        };
    };
}
function $0bdceaeb6b845013$var$buildLiteralData(formatter, tpl, opts) {
    let prefix = "BABEL_TPL$";
    const raw = tpl.join("");
    do prefix = "$$" + prefix;
    while (raw.includes(prefix));
    const { names: names, code: code } = $0bdceaeb6b845013$var$buildTemplateCode(tpl, prefix);
    const metadata = (0, $5j6rS.default)(formatter, formatter.code(code), {
        parser: opts.parser,
        placeholderWhitelist: new Set(names.concat(opts.placeholderWhitelist ? Array.from(opts.placeholderWhitelist) : [])),
        placeholderPattern: opts.placeholderPattern,
        preserveComments: opts.preserveComments,
        syntacticPlaceholders: opts.syntacticPlaceholders
    });
    return {
        metadata: metadata,
        names: names
    };
}
function $0bdceaeb6b845013$var$buildTemplateCode(tpl, prefix) {
    const names = [];
    let code = tpl[0];
    for(let i = 1; i < tpl.length; i++){
        const value = `${prefix}${i - 1}`;
        names.push(value);
        code += value + tpl[i];
    }
    return {
        names: names,
        code: code
    };
}

});





parcelRegister("17YAB", function(module, exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports._guessExecutionStatusRelativeTo = _guessExecutionStatusRelativeTo;
exports._resolve = _resolve;
exports.canHaveVariableDeclarationOrExpression = canHaveVariableDeclarationOrExpression;
exports.canSwapBetweenExpressionAndStatement = canSwapBetweenExpressionAndStatement;
exports.equals = equals;
exports.getSource = getSource;
exports.has = has;
exports.is = void 0;
exports.isCompletionRecord = isCompletionRecord;
exports.isConstantExpression = isConstantExpression;
exports.isInStrictMode = isInStrictMode;
exports.isNodeType = isNodeType;
exports.isStatementOrBlock = isStatementOrBlock;
exports.isStatic = isStatic;
exports.isnt = isnt;
exports.matchesPattern = matchesPattern;
exports.referencesImport = referencesImport;
exports.resolve = resolve;
exports.willIMaybeExecuteBefore = willIMaybeExecuteBefore;

var $ardUq = parcelRequire("ardUq");
const { STATEMENT_OR_BLOCK_KEYS, VISITOR_KEYS, isBlockStatement, isExpression, isIdentifier, isLiteral, isStringLiteral, isType, matchesPattern: _matchesPattern } = $ardUq;
function matchesPattern(pattern, allowPartial) {
    return _matchesPattern(this.node, pattern, allowPartial);
}
function has(key) {
    const val = this.node && this.node[key];
    if (val && Array.isArray(val)) return !!val.length;
    else return !!val;
}
function isStatic() {
    return this.scope.isStatic(this.node);
}
const is = exports.is = has;
function isnt(key) {
    return !this.has(key);
}
function equals(key, value) {
    return this.node[key] === value;
}
function isNodeType(type) {
    return isType(this.type, type);
}
function canHaveVariableDeclarationOrExpression() {
    return (this.key === "init" || this.key === "left") && this.parentPath.isFor();
}
function canSwapBetweenExpressionAndStatement(replacement) {
    if (this.key !== "body" || !this.parentPath.isArrowFunctionExpression()) return false;
    if (this.isExpression()) return isBlockStatement(replacement);
    else if (this.isBlockStatement()) return isExpression(replacement);
    return false;
}
function isCompletionRecord(allowInsideFunction) {
    let path = this;
    let first = true;
    do {
        const { type, container } = path;
        if (!first && (path.isFunction() || type === "StaticBlock")) return !!allowInsideFunction;
        first = false;
        if (Array.isArray(container) && path.key !== container.length - 1) return false;
    }while ((path = path.parentPath) && !path.isProgram() && !path.isDoExpression());
    return true;
}
function isStatementOrBlock() {
    if (this.parentPath.isLabeledStatement() || isBlockStatement(this.container)) return false;
    else return STATEMENT_OR_BLOCK_KEYS.includes(this.key);
}
function referencesImport(moduleSource, importName) {
    if (!this.isReferencedIdentifier()) {
        if (this.isJSXMemberExpression() && this.node.property.name === importName || (this.isMemberExpression() || this.isOptionalMemberExpression()) && (this.node.computed ? isStringLiteral(this.node.property, {
            value: importName
        }) : this.node.property.name === importName)) {
            const object = this.get("object");
            return object.isReferencedIdentifier() && object.referencesImport(moduleSource, "*");
        }
        return false;
    }
    const binding = this.scope.getBinding(this.node.name);
    if (!binding || binding.kind !== "module") return false;
    const path = binding.path;
    const parent = path.parentPath;
    if (!parent.isImportDeclaration()) return false;
    if (parent.node.source.value === moduleSource) {
        if (!importName) return true;
    } else return false;
    if (path.isImportDefaultSpecifier() && importName === "default") return true;
    if (path.isImportNamespaceSpecifier() && importName === "*") return true;
    if (path.isImportSpecifier() && isIdentifier(path.node.imported, {
        name: importName
    })) return true;
    return false;
}
function getSource() {
    const node = this.node;
    if (node.end) {
        const code = this.hub.getCode();
        if (code) return code.slice(node.start, node.end);
    }
    return "";
}
function willIMaybeExecuteBefore(target) {
    return this._guessExecutionStatusRelativeTo(target) !== "after";
}
function getOuterFunction(path) {
    return path.isProgram() ? path : (path.parentPath.scope.getFunctionParent() || path.parentPath.scope.getProgramParent()).path;
}
function isExecutionUncertain(type, key) {
    switch(type){
        case "LogicalExpression":
            return key === "right";
        case "ConditionalExpression":
        case "IfStatement":
            return key === "consequent" || key === "alternate";
        case "WhileStatement":
        case "DoWhileStatement":
        case "ForInStatement":
        case "ForOfStatement":
            return key === "body";
        case "ForStatement":
            return key === "body" || key === "update";
        case "SwitchStatement":
            return key === "cases";
        case "TryStatement":
            return key === "handler";
        case "AssignmentPattern":
            return key === "right";
        case "OptionalMemberExpression":
            return key === "property";
        case "OptionalCallExpression":
            return key === "arguments";
        default:
            return false;
    }
}
function isExecutionUncertainInList(paths, maxIndex) {
    for(let i = 0; i < maxIndex; i++){
        const path = paths[i];
        if (isExecutionUncertain(path.parent.type, path.parentKey)) return true;
    }
    return false;
}
const SYMBOL_CHECKING = Symbol();
function _guessExecutionStatusRelativeTo(target) {
    return _guessExecutionStatusRelativeToCached(this, target, new Map());
}
function _guessExecutionStatusRelativeToCached(base, target, cache) {
    const funcParent = {
        this: getOuterFunction(base),
        target: getOuterFunction(target)
    };
    if (funcParent.target.node !== funcParent.this.node) return _guessExecutionStatusRelativeToDifferentFunctionsCached(base, funcParent.target, cache);
    const paths = {
        target: target.getAncestry(),
        this: base.getAncestry()
    };
    if (paths.target.indexOf(base) >= 0) return "after";
    if (paths.this.indexOf(target) >= 0) return "before";
    let commonPath;
    const commonIndex = {
        target: 0,
        this: 0
    };
    while(!commonPath && commonIndex.this < paths.this.length){
        const path = paths.this[commonIndex.this];
        commonIndex.target = paths.target.indexOf(path);
        if (commonIndex.target >= 0) commonPath = path;
        else commonIndex.this++;
    }
    if (!commonPath) throw new Error("Internal Babel error - The two compared nodes don't appear to belong to the same program.");
    if (isExecutionUncertainInList(paths.this, commonIndex.this - 1) || isExecutionUncertainInList(paths.target, commonIndex.target - 1)) return "unknown";
    const divergence = {
        this: paths.this[commonIndex.this - 1],
        target: paths.target[commonIndex.target - 1]
    };
    if (divergence.target.listKey && divergence.this.listKey && divergence.target.container === divergence.this.container) return divergence.target.key > divergence.this.key ? "before" : "after";
    const keys = VISITOR_KEYS[commonPath.type];
    const keyPosition = {
        this: keys.indexOf(divergence.this.parentKey),
        target: keys.indexOf(divergence.target.parentKey)
    };
    return keyPosition.target > keyPosition.this ? "before" : "after";
}
function _guessExecutionStatusRelativeToDifferentFunctionsInternal(base, target, cache) {
    if (!target.isFunctionDeclaration()) {
        if (_guessExecutionStatusRelativeToCached(base, target, cache) === "before") return "before";
        return "unknown";
    } else if (target.parentPath.isExportDeclaration()) return "unknown";
    const binding = target.scope.getBinding(target.node.id.name);
    if (!binding.references) return "before";
    const referencePaths = binding.referencePaths;
    let allStatus;
    for (const path of referencePaths){
        const childOfFunction = !!path.find((path)=>path.node === target.node);
        if (childOfFunction) continue;
        if (path.key !== "callee" || !path.parentPath.isCallExpression()) return "unknown";
        const status = _guessExecutionStatusRelativeToCached(base, path, cache);
        if (allStatus && allStatus !== status) return "unknown";
        else allStatus = status;
    }
    return allStatus;
}
function _guessExecutionStatusRelativeToDifferentFunctionsCached(base, target, cache) {
    let nodeMap = cache.get(base.node);
    let cached;
    if (!nodeMap) cache.set(base.node, nodeMap = new Map());
    else if (cached = nodeMap.get(target.node)) {
        if (cached === SYMBOL_CHECKING) return "unknown";
        return cached;
    }
    nodeMap.set(target.node, SYMBOL_CHECKING);
    const result = _guessExecutionStatusRelativeToDifferentFunctionsInternal(base, target, cache);
    nodeMap.set(target.node, result);
    return result;
}
function resolve(dangerous, resolved) {
    return this._resolve(dangerous, resolved) || this;
}
function _resolve(dangerous, resolved) {
    if (resolved && resolved.indexOf(this) >= 0) return;
    resolved = resolved || [];
    resolved.push(this);
    if (this.isVariableDeclarator()) {
        if (this.get("id").isIdentifier()) return this.get("init").resolve(dangerous, resolved);
    } else if (this.isReferencedIdentifier()) {
        const binding = this.scope.getBinding(this.node.name);
        if (!binding) return;
        if (!binding.constant) return;
        if (binding.kind === "module") return;
        if (binding.path !== this) {
            const ret = binding.path.resolve(dangerous, resolved);
            if (this.find((parent)=>parent.node === ret.node)) return;
            return ret;
        }
    } else if (this.isTypeCastExpression()) return this.get("expression").resolve(dangerous, resolved);
    else if (dangerous && this.isMemberExpression()) {
        const targetKey = this.toComputedKey();
        if (!isLiteral(targetKey)) return;
        const targetName = targetKey.value;
        const target = this.get("object").resolve(dangerous, resolved);
        if (target.isObjectExpression()) {
            const props = target.get("properties");
            for (const prop of props){
                if (!prop.isProperty()) continue;
                const key = prop.get("key");
                let match = prop.isnt("computed") && key.isIdentifier({
                    name: targetName
                });
                match = match || key.isLiteral({
                    value: targetName
                });
                if (match) return prop.get("value").resolve(dangerous, resolved);
            }
        } else if (target.isArrayExpression() && !isNaN(+targetName)) {
            const elems = target.get("elements");
            const elem = elems[targetName];
            if (elem) return elem.resolve(dangerous, resolved);
        }
    }
}
function isConstantExpression() {
    if (this.isIdentifier()) {
        const binding = this.scope.getBinding(this.node.name);
        if (!binding) return false;
        return binding.constant;
    }
    if (this.isLiteral()) {
        if (this.isRegExpLiteral()) return false;
        if (this.isTemplateLiteral()) return this.get("expressions").every((expression)=>expression.isConstantExpression());
        return true;
    }
    if (this.isUnaryExpression()) {
        if (this.node.operator !== "void") return false;
        return this.get("argument").isConstantExpression();
    }
    if (this.isBinaryExpression()) {
        const { operator } = this.node;
        return operator !== "in" && operator !== "instanceof" && this.get("left").isConstantExpression() && this.get("right").isConstantExpression();
    }
    if (this.isMemberExpression()) return !this.node.computed && this.get("object").isIdentifier({
        name: "Symbol"
    }) && !this.scope.hasBinding("Symbol", {
        noGlobals: true
    });
    if (this.isCallExpression()) return this.node.arguments.length === 1 && this.get("callee").matchesPattern("Symbol.for") && !this.scope.hasBinding("Symbol", {
        noGlobals: true
    }) && this.get("arguments")[0].isStringLiteral();
    return false;
}
function isInStrictMode() {
    const start = this.isProgram() ? this : this.parentPath;
    const strictParent = start.find((path)=>{
        if (path.isProgram({
            sourceType: "module"
        })) return true;
        if (path.isClass()) return true;
        if (path.isArrowFunctionExpression() && !path.get("body").isBlockStatement()) return false;
        let body;
        if (path.isFunction()) body = path.node.body;
        else if (path.isProgram()) body = path.node;
        else return false;
        for (const directive of body.directives){
            if (directive.value.value === "use strict") return true;
        }
    });
    return !!strictParent;
}

});

parcelRegister("9OvWW", function(module, exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports._call = _call;
exports._getQueueContexts = _getQueueContexts;
exports._resyncKey = _resyncKey;
exports._resyncList = _resyncList;
exports._resyncParent = _resyncParent;
exports._resyncRemoved = _resyncRemoved;
exports.call = call;
exports.isBlacklisted = exports.isDenylisted = isDenylisted;
exports.popContext = popContext;
exports.pushContext = pushContext;
exports.requeue = requeue;
exports.resync = resync;
exports.setContext = setContext;
exports.setKey = setKey;
exports.setScope = setScope;
exports.setup = setup;
exports.skip = skip;
exports.skipKey = skipKey;
exports.stop = stop;
exports.visit = visit;

var $k33SJ = parcelRequire("k33SJ");

var $8zU9J = parcelRequire("8zU9J");
function call(key) {
    const opts = this.opts;
    this.debug(key);
    if (this.node) {
        if (this._call(opts[key])) return true;
    }
    if (this.node) {
        var _opts$this$node$type;
        return this._call((_opts$this$node$type = opts[this.node.type]) == null ? void 0 : _opts$this$node$type[key]);
    }
    return false;
}
function _call(fns) {
    if (!fns) return false;
    for (const fn of fns){
        if (!fn) continue;
        const node = this.node;
        if (!node) return true;
        const ret = fn.call(this.state, this, this.state);
        if (ret && typeof ret === "object" && typeof ret.then === "function") throw new Error(`You appear to be using a plugin with an async traversal visitor, ` + `which your current version of Babel does not support. ` + `If you're using a published plugin, you may need to upgrade ` + `your @babel/core version.`);
        if (ret) throw new Error(`Unexpected return value from visitor method ${fn}`);
        if (this.node !== node) return true;
        if (this._traverseFlags > 0) return true;
    }
    return false;
}
function isDenylisted() {
    var _this$opts$denylist;
    const denylist = (_this$opts$denylist = this.opts.denylist) != null ? _this$opts$denylist : this.opts.blacklist;
    return denylist && denylist.indexOf(this.node.type) > -1;
}
function restoreContext(path, context) {
    if (path.context !== context) {
        path.context = context;
        path.state = context.state;
        path.opts = context.opts;
    }
}
function visit() {
    var _this$opts$shouldSkip, _this$opts;
    if (!this.node) return false;
    if (this.isDenylisted()) return false;
    if ((_this$opts$shouldSkip = (_this$opts = this.opts).shouldSkip) != null && _this$opts$shouldSkip.call(_this$opts, this)) return false;
    const currentContext = this.context;
    if (this.shouldSkip || this.call("enter")) {
        this.debug("Skip...");
        return this.shouldStop;
    }
    restoreContext(this, currentContext);
    this.debug("Recursing into...");
    this.shouldStop = (0, $k33SJ.traverseNode)(this.node, this.opts, this.scope, this.state, this, this.skipKeys);
    restoreContext(this, currentContext);
    this.call("exit");
    return this.shouldStop;
}
function skip() {
    this.shouldSkip = true;
}
function skipKey(key) {
    if (this.skipKeys == null) this.skipKeys = {};
    this.skipKeys[key] = true;
}
function stop() {
    this._traverseFlags |= $8zU9J.SHOULD_SKIP | $8zU9J.SHOULD_STOP;
}
function setScope() {
    var _this$opts2, _this$scope;
    if ((_this$opts2 = this.opts) != null && _this$opts2.noScope) return;
    let path = this.parentPath;
    if ((this.key === "key" || this.listKey === "decorators") && path.isMethod() || this.key === "discriminant" && path.isSwitchStatement()) path = path.parentPath;
    let target;
    while(path && !target){
        var _path$opts;
        if ((_path$opts = path.opts) != null && _path$opts.noScope) return;
        target = path.scope;
        path = path.parentPath;
    }
    this.scope = this.getScope(target);
    (_this$scope = this.scope) == null || _this$scope.init();
}
function setContext(context) {
    if (this.skipKeys != null) this.skipKeys = {};
    this._traverseFlags = 0;
    if (context) {
        this.context = context;
        this.state = context.state;
        this.opts = context.opts;
    }
    this.setScope();
    return this;
}
function resync() {
    if (this.removed) return;
    this._resyncParent();
    this._resyncList();
    this._resyncKey();
}
function _resyncParent() {
    if (this.parentPath) this.parent = this.parentPath.node;
}
function _resyncKey() {
    if (!this.container) return;
    if (this.node === this.container[this.key]) return;
    if (Array.isArray(this.container)) {
        for(let i = 0; i < this.container.length; i++)if (this.container[i] === this.node) {
            this.setKey(i);
            return;
        }
    } else {
        for (const key of Object.keys(this.container))if (this.container[key] === this.node) {
            this.setKey(key);
            return;
        }
    }
    this.key = null;
}
function _resyncList() {
    if (!this.parent || !this.inList) return;
    const newContainer = this.parent[this.listKey];
    if (this.container === newContainer) return;
    this.container = newContainer || null;
}
function _resyncRemoved() {
    if (this.key == null || !this.container || this.container[this.key] !== this.node) this._markRemoved();
}
function popContext() {
    this.contexts.pop();
    if (this.contexts.length > 0) this.setContext(this.contexts[this.contexts.length - 1]);
    else this.setContext(undefined);
}
function pushContext(context) {
    this.contexts.push(context);
    this.setContext(context);
}
function setup(parentPath, container, listKey, key) {
    this.listKey = listKey;
    this.container = container;
    this.parentPath = parentPath || this.parentPath;
    this.setKey(key);
}
function setKey(key) {
    var _this$node;
    this.key = key;
    this.node = this.container[this.key];
    this.type = (_this$node = this.node) == null ? void 0 : _this$node.type;
}
function requeue(pathToQueue = this) {
    if (pathToQueue.removed) return;
    const contexts = this.contexts;
    for (const context of contexts)context.maybeQueue(pathToQueue);
}
function _getQueueContexts() {
    let path = this;
    let contexts = this.contexts;
    while(!contexts.length){
        path = path.parentPath;
        if (!path) break;
        contexts = path.contexts;
    }
    return contexts;
}

});

parcelRegister("9UB0w", function(module, exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports._assertUnremoved = _assertUnremoved;
exports._callRemovalHooks = _callRemovalHooks;
exports._markRemoved = _markRemoved;
exports._remove = _remove;
exports._removeFromScope = _removeFromScope;
exports.remove = remove;

var $iuiz2 = parcelRequire("iuiz2");

var $ClGPh = parcelRequire("ClGPh");

var $8zU9J = parcelRequire("8zU9J");

var $ardUq = parcelRequire("ardUq");
const { getBindingIdentifiers } = $ardUq;
function remove() {
    var _this$opts;
    this._assertUnremoved();
    this.resync();
    if (!((_this$opts = this.opts) != null && _this$opts.noScope)) this._removeFromScope();
    if (this._callRemovalHooks()) {
        this._markRemoved();
        return;
    }
    this.shareCommentsWithSiblings();
    this._remove();
    this._markRemoved();
}
function _removeFromScope() {
    const bindings = getBindingIdentifiers(this.node, false, false, true);
    Object.keys(bindings).forEach((name)=>this.scope.removeBinding(name));
}
function _callRemovalHooks() {
    if (this.parentPath) for (const fn of $iuiz2.hooks){
        if (fn(this, this.parentPath)) return true;
    }
}
function _remove() {
    if (Array.isArray(this.container)) {
        this.container.splice(this.key, 1);
        this.updateSiblingKeys(this.key, -1);
    } else this._replaceWith(null);
}
function _markRemoved() {
    this._traverseFlags |= $8zU9J.SHOULD_SKIP | $8zU9J.REMOVED;
    if (this.parent) (0, $ClGPh.getCachedPaths)(this.hub, this.parent).delete(this.node);
    this.node = null;
}
function _assertUnremoved() {
    if (this.removed) throw this.buildCodeFrameError("NodePath has been removed so is read-only.");
}

});
parcelRegister("iuiz2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hooks = void 0;
const $d7596dcef88d6f91$var$hooks = module.exports.hooks = [
    function(self, parent) {
        const removeParent = self.key === "test" && (parent.isWhile() || parent.isSwitchCase()) || self.key === "declaration" && parent.isExportDeclaration() || self.key === "body" && parent.isLabeledStatement() || self.listKey === "declarations" && parent.isVariableDeclaration() && parent.node.declarations.length === 1 || self.key === "expression" && parent.isExpressionStatement();
        if (removeParent) {
            parent.remove();
            return true;
        }
    },
    function(self, parent) {
        if (parent.isSequenceExpression() && parent.node.expressions.length === 1) {
            parent.replaceWith(parent.node.expressions[0]);
            return true;
        }
    },
    function(self, parent) {
        if (parent.isBinary()) {
            if (self.key === "left") parent.replaceWith(parent.node.right);
            else parent.replaceWith(parent.node.left);
            return true;
        }
    },
    function(self, parent) {
        if (parent.isIfStatement() && self.key === "consequent" || self.key === "body" && (parent.isLoop() || parent.isArrowFunctionExpression())) {
            self.replaceWith({
                type: "BlockStatement",
                body: []
            });
            return true;
        }
    }
];

});


parcelRegister("3y2Ti", function(module, exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports._containerInsert = _containerInsert;
exports._containerInsertAfter = _containerInsertAfter;
exports._containerInsertBefore = _containerInsertBefore;
exports._verifyNodeList = _verifyNodeList;
exports.hoist = hoist;
exports.insertAfter = insertAfter;
exports.insertBefore = insertBefore;
exports.pushContainer = pushContainer;
exports.unshiftContainer = unshiftContainer;
exports.updateSiblingKeys = updateSiblingKeys;

var $ClGPh = parcelRequire("ClGPh");

var $cKIw9 = parcelRequire("cKIw9");

var $8zU9J = parcelRequire("8zU9J");

var $ardUq = parcelRequire("ardUq");
const { arrowFunctionExpression, assertExpression, assignmentExpression, blockStatement, callExpression, cloneNode, expressionStatement, isAssignmentExpression, isCallExpression, isExportNamedDeclaration, isExpression, isIdentifier, isSequenceExpression, isSuper, thisExpression } = $ardUq;
function insertBefore(nodes_) {
    this._assertUnremoved();
    const nodes = this._verifyNodeList(nodes_);
    const { parentPath, parent } = this;
    if (parentPath.isExpressionStatement() || parentPath.isLabeledStatement() || isExportNamedDeclaration(parent) || parentPath.isExportDefaultDeclaration() && this.isDeclaration()) return parentPath.insertBefore(nodes);
    else if (this.isNodeType("Expression") && !this.isJSXElement() || parentPath.isForStatement() && this.key === "init") {
        if (this.node) nodes.push(this.node);
        return this.replaceExpressionWithStatements(nodes);
    } else if (Array.isArray(this.container)) return this._containerInsertBefore(nodes);
    else if (this.isStatementOrBlock()) {
        const node = this.node;
        const shouldInsertCurrentNode = node && (!this.isExpressionStatement() || node.expression != null);
        this.replaceWith(blockStatement(shouldInsertCurrentNode ? [
            node
        ] : []));
        return this.unshiftContainer("body", nodes);
    } else throw new Error("We don't know what to do with this node type. We were previously a Statement but we can't fit in here?");
}
function _containerInsert(from, nodes) {
    this.updateSiblingKeys(from, nodes.length);
    const paths = [];
    this.container.splice(from, 0, ...nodes);
    for(let i = 0; i < nodes.length; i++){
        var _this$context;
        const to = from + i;
        const path = this.getSibling(to);
        paths.push(path);
        if ((_this$context = this.context) != null && _this$context.queue) path.pushContext(this.context);
    }
    const contexts = this._getQueueContexts();
    for (const path of paths){
        path.setScope();
        path.debug("Inserted.");
        for (const context of contexts)context.maybeQueue(path, true);
    }
    return paths;
}
function _containerInsertBefore(nodes) {
    return this._containerInsert(this.key, nodes);
}
function _containerInsertAfter(nodes) {
    return this._containerInsert(this.key + 1, nodes);
}
const last = (arr)=>arr[arr.length - 1];
function isHiddenInSequenceExpression(path) {
    return isSequenceExpression(path.parent) && (last(path.parent.expressions) !== path.node || isHiddenInSequenceExpression(path.parentPath));
}
function isAlmostConstantAssignment(node, scope) {
    if (!isAssignmentExpression(node) || !isIdentifier(node.left)) return false;
    const blockScope = scope.getBlockParent();
    return blockScope.hasOwnBinding(node.left.name) && blockScope.getOwnBinding(node.left.name).constantViolations.length <= 1;
}
function insertAfter(nodes_) {
    this._assertUnremoved();
    if (this.isSequenceExpression()) return last(this.get("expressions")).insertAfter(nodes_);
    const nodes = this._verifyNodeList(nodes_);
    const { parentPath, parent } = this;
    if (parentPath.isExpressionStatement() || parentPath.isLabeledStatement() || isExportNamedDeclaration(parent) || parentPath.isExportDefaultDeclaration() && this.isDeclaration()) return parentPath.insertAfter(nodes.map((node)=>{
        return isExpression(node) ? expressionStatement(node) : node;
    }));
    else if (this.isNodeType("Expression") && !this.isJSXElement() && !parentPath.isJSXElement() || parentPath.isForStatement() && this.key === "init") {
        if (this.node) {
            const node = this.node;
            let { scope } = this;
            if (scope.path.isPattern()) {
                assertExpression(node);
                this.replaceWith(callExpression(arrowFunctionExpression([], node), []));
                this.get("callee.body").insertAfter(nodes);
                return [
                    this
                ];
            }
            if (isHiddenInSequenceExpression(this)) nodes.unshift(node);
            else if (isCallExpression(node) && isSuper(node.callee)) {
                nodes.unshift(node);
                nodes.push(thisExpression());
            } else if (isAlmostConstantAssignment(node, scope)) {
                nodes.unshift(node);
                nodes.push(cloneNode(node.left));
            } else if (scope.isPure(node, true)) nodes.push(node);
            else {
                if (parentPath.isMethod({
                    computed: true,
                    key: node
                })) scope = scope.parent;
                const temp = scope.generateDeclaredUidIdentifier();
                nodes.unshift(expressionStatement(assignmentExpression("=", cloneNode(temp), node)));
                nodes.push(expressionStatement(cloneNode(temp)));
            }
        }
        return this.replaceExpressionWithStatements(nodes);
    } else if (Array.isArray(this.container)) return this._containerInsertAfter(nodes);
    else if (this.isStatementOrBlock()) {
        const node = this.node;
        const shouldInsertCurrentNode = node && (!this.isExpressionStatement() || node.expression != null);
        this.replaceWith(blockStatement(shouldInsertCurrentNode ? [
            node
        ] : []));
        return this.pushContainer("body", nodes);
    } else throw new Error("We don't know what to do with this node type. We were previously a Statement but we can't fit in here?");
}
function updateSiblingKeys(fromIndex, incrementBy) {
    if (!this.parent) return;
    const paths = (0, $ClGPh.getCachedPaths)(this.hub, this.parent) || [];
    for (const [, path] of paths)if (typeof path.key === "number" && path.key >= fromIndex) path.key += incrementBy;
}
function _verifyNodeList(nodes) {
    if (!nodes) return [];
    if (!Array.isArray(nodes)) nodes = [
        nodes
    ];
    for(let i = 0; i < nodes.length; i++){
        const node = nodes[i];
        let msg;
        if (!node) msg = "has falsy node";
        else if (typeof node !== "object") msg = "contains a non-object node";
        else if (!node.type) msg = "without a type";
        else if (node instanceof $8zU9J.default) msg = "has a NodePath when it expected a raw object";
        if (msg) {
            const type = Array.isArray(node) ? "array" : typeof node;
            throw new Error(`Node list ${msg} with the index of ${i} and type of ${type}`);
        }
    }
    return nodes;
}
function unshiftContainer(listKey, nodes) {
    this._assertUnremoved();
    nodes = this._verifyNodeList(nodes);
    const path = $8zU9J.default.get({
        parentPath: this,
        parent: this.node,
        container: this.node[listKey],
        listKey: listKey,
        key: 0
    }).setContext(this.context);
    return path._containerInsertBefore(nodes);
}
function pushContainer(listKey, nodes) {
    this._assertUnremoved();
    const verifiedNodes = this._verifyNodeList(nodes);
    const container = this.node[listKey];
    const path = $8zU9J.default.get({
        parentPath: this,
        parent: this.node,
        container: container,
        listKey: listKey,
        key: container.length
    }).setContext(this.context);
    return path.replaceWithMultiple(verifiedNodes);
}
function hoist(scope = this.scope) {
    const hoister = new $cKIw9.default(this, scope);
    return hoister.run();
}

});
parcelRegister("cKIw9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ardUq = parcelRequire("ardUq");
var $02655c21c5119802$var$_t2 = $ardUq;
const { react: $02655c21c5119802$var$react } = $ardUq;
const { cloneNode: $02655c21c5119802$var$cloneNode, jsxExpressionContainer: $02655c21c5119802$var$jsxExpressionContainer, variableDeclaration: $02655c21c5119802$var$variableDeclaration, variableDeclarator: $02655c21c5119802$var$variableDeclarator } = $02655c21c5119802$var$_t2;
const $02655c21c5119802$var$referenceVisitor = {
    ReferencedIdentifier (path, state) {
        if (path.isJSXIdentifier() && $02655c21c5119802$var$react.isCompatTag(path.node.name) && !path.parentPath.isJSXMemberExpression()) return;
        if (path.node.name === "this") {
            let scope = path.scope;
            do {
                if (scope.path.isFunction() && !scope.path.isArrowFunctionExpression()) break;
            }while (scope = scope.parent);
            if (scope) state.breakOnScopePaths.push(scope.path);
        }
        const binding = path.scope.getBinding(path.node.name);
        if (!binding) return;
        for (const violation of binding.constantViolations)if (violation.scope !== binding.path.scope) {
            state.mutableBinding = true;
            path.stop();
            return;
        }
        if (binding !== state.scope.getBinding(path.node.name)) return;
        state.bindings[path.node.name] = binding;
    }
};
class $02655c21c5119802$var$PathHoister {
    constructor(path, scope){
        this.breakOnScopePaths = void 0;
        this.bindings = void 0;
        this.mutableBinding = void 0;
        this.scopes = void 0;
        this.scope = void 0;
        this.path = void 0;
        this.attachAfter = void 0;
        this.breakOnScopePaths = [];
        this.bindings = {};
        this.mutableBinding = false;
        this.scopes = [];
        this.scope = scope;
        this.path = path;
        this.attachAfter = false;
    }
    isCompatibleScope(scope) {
        for (const key of Object.keys(this.bindings)){
            const binding = this.bindings[key];
            if (!scope.bindingIdentifierEquals(key, binding.identifier)) return false;
        }
        return true;
    }
    getCompatibleScopes() {
        let scope = this.path.scope;
        do {
            if (this.isCompatibleScope(scope)) this.scopes.push(scope);
            else break;
            if (this.breakOnScopePaths.indexOf(scope.path) >= 0) break;
        }while (scope = scope.parent);
    }
    getAttachmentPath() {
        let path = this._getAttachmentPath();
        if (!path) return;
        let targetScope = path.scope;
        if (targetScope.path === path) targetScope = path.scope.parent;
        if (targetScope.path.isProgram() || targetScope.path.isFunction()) for (const name of Object.keys(this.bindings)){
            if (!targetScope.hasOwnBinding(name)) continue;
            const binding = this.bindings[name];
            if (binding.kind === "param" || binding.path.parentKey === "params") continue;
            const bindingParentPath = this.getAttachmentParentForPath(binding.path);
            if (bindingParentPath.key >= path.key) {
                this.attachAfter = true;
                path = binding.path;
                for (const violationPath of binding.constantViolations)if (this.getAttachmentParentForPath(violationPath).key > path.key) path = violationPath;
            }
        }
        return path;
    }
    _getAttachmentPath() {
        const scopes = this.scopes;
        const scope = scopes.pop();
        if (!scope) return;
        if (scope.path.isFunction()) {
            if (this.hasOwnParamBindings(scope)) {
                if (this.scope === scope) return;
                const bodies = scope.path.get("body").get("body");
                for(let i = 0; i < bodies.length; i++){
                    if (bodies[i].node._blockHoist) continue;
                    return bodies[i];
                }
            } else return this.getNextScopeAttachmentParent();
        } else if (scope.path.isProgram()) return this.getNextScopeAttachmentParent();
    }
    getNextScopeAttachmentParent() {
        const scope = this.scopes.pop();
        if (scope) return this.getAttachmentParentForPath(scope.path);
    }
    getAttachmentParentForPath(path) {
        do {
            if (!path.parentPath || Array.isArray(path.container) && path.isStatement()) return path;
        }while (path = path.parentPath);
    }
    hasOwnParamBindings(scope) {
        for (const name of Object.keys(this.bindings)){
            if (!scope.hasOwnBinding(name)) continue;
            const binding = this.bindings[name];
            if (binding.kind === "param" && binding.constant) return true;
        }
        return false;
    }
    run() {
        this.path.traverse($02655c21c5119802$var$referenceVisitor, this);
        if (this.mutableBinding) return;
        this.getCompatibleScopes();
        const attachTo = this.getAttachmentPath();
        if (!attachTo) return;
        if (attachTo.getFunctionParent() === this.path.getFunctionParent()) return;
        let uid = attachTo.scope.generateUidIdentifier("ref");
        const declarator = $02655c21c5119802$var$variableDeclarator(uid, this.path.node);
        const insertFn = this.attachAfter ? "insertAfter" : "insertBefore";
        const [attached] = attachTo[insertFn]([
            attachTo.isVariableDeclarator() ? declarator : $02655c21c5119802$var$variableDeclaration("var", [
                declarator
            ])
        ]);
        const parent = this.path.parentPath;
        if (parent.isJSXElement() && this.path.container === parent.node.children) uid = $02655c21c5119802$var$jsxExpressionContainer(uid);
        this.path.replaceWith($02655c21c5119802$var$cloneNode(uid));
        return attachTo.isVariableDeclarator() ? attached.get("init") : attached.get("declarations.0.init");
    }
}
module.exports.default = $02655c21c5119802$var$PathHoister;

});


parcelRegister("2DRRA", function(module, exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports._getKey = _getKey;
exports._getPattern = _getPattern;
exports.get = get;
exports.getAllNextSiblings = getAllNextSiblings;
exports.getAllPrevSiblings = getAllPrevSiblings;
exports.getBindingIdentifierPaths = getBindingIdentifierPaths;
exports.getBindingIdentifiers = getBindingIdentifiers;
exports.getCompletionRecords = getCompletionRecords;
exports.getNextSibling = getNextSibling;
exports.getOpposite = getOpposite;
exports.getOuterBindingIdentifierPaths = getOuterBindingIdentifierPaths;
exports.getOuterBindingIdentifiers = getOuterBindingIdentifiers;
exports.getPrevSibling = getPrevSibling;
exports.getSibling = getSibling;

var $8zU9J = parcelRequire("8zU9J");

var $ardUq = parcelRequire("ardUq");
const { getBindingIdentifiers: _getBindingIdentifiers, getOuterBindingIdentifiers: _getOuterBindingIdentifiers, isDeclaration, numericLiteral, unaryExpression } = $ardUq;
const NORMAL_COMPLETION = 0;
const BREAK_COMPLETION = 1;
function NormalCompletion(path) {
    return {
        type: NORMAL_COMPLETION,
        path: path
    };
}
function BreakCompletion(path) {
    return {
        type: BREAK_COMPLETION,
        path: path
    };
}
function getOpposite() {
    if (this.key === "left") return this.getSibling("right");
    else if (this.key === "right") return this.getSibling("left");
    return null;
}
function addCompletionRecords(path, records, context) {
    if (path) records.push(..._getCompletionRecords(path, context));
    return records;
}
function completionRecordForSwitch(cases, records, context) {
    let lastNormalCompletions = [];
    for(let i = 0; i < cases.length; i++){
        const casePath = cases[i];
        const caseCompletions = _getCompletionRecords(casePath, context);
        const normalCompletions = [];
        const breakCompletions = [];
        for (const c of caseCompletions){
            if (c.type === NORMAL_COMPLETION) normalCompletions.push(c);
            if (c.type === BREAK_COMPLETION) breakCompletions.push(c);
        }
        if (normalCompletions.length) lastNormalCompletions = normalCompletions;
        records.push(...breakCompletions);
    }
    records.push(...lastNormalCompletions);
    return records;
}
function normalCompletionToBreak(completions) {
    completions.forEach((c)=>{
        c.type = BREAK_COMPLETION;
    });
}
function replaceBreakStatementInBreakCompletion(completions, reachable) {
    completions.forEach((c)=>{
        if (c.path.isBreakStatement({
            label: null
        })) {
            if (reachable) c.path.replaceWith(unaryExpression("void", numericLiteral(0)));
            else c.path.remove();
        }
    });
}
function getStatementListCompletion(paths, context) {
    const completions = [];
    if (context.canHaveBreak) {
        let lastNormalCompletions = [];
        for(let i = 0; i < paths.length; i++){
            const path = paths[i];
            const newContext = Object.assign({}, context, {
                inCaseClause: false
            });
            if (path.isBlockStatement() && (context.inCaseClause || context.shouldPopulateBreak)) newContext.shouldPopulateBreak = true;
            else newContext.shouldPopulateBreak = false;
            const statementCompletions = _getCompletionRecords(path, newContext);
            if (statementCompletions.length > 0 && statementCompletions.every((c)=>c.type === BREAK_COMPLETION)) {
                if (lastNormalCompletions.length > 0 && statementCompletions.every((c)=>c.path.isBreakStatement({
                        label: null
                    }))) {
                    normalCompletionToBreak(lastNormalCompletions);
                    completions.push(...lastNormalCompletions);
                    if (lastNormalCompletions.some((c)=>c.path.isDeclaration())) {
                        completions.push(...statementCompletions);
                        replaceBreakStatementInBreakCompletion(statementCompletions, true);
                    }
                    replaceBreakStatementInBreakCompletion(statementCompletions, false);
                } else {
                    completions.push(...statementCompletions);
                    if (!context.shouldPopulateBreak) replaceBreakStatementInBreakCompletion(statementCompletions, true);
                }
                break;
            }
            if (i === paths.length - 1) completions.push(...statementCompletions);
            else {
                lastNormalCompletions = [];
                for(let i = 0; i < statementCompletions.length; i++){
                    const c = statementCompletions[i];
                    if (c.type === BREAK_COMPLETION) completions.push(c);
                    if (c.type === NORMAL_COMPLETION) lastNormalCompletions.push(c);
                }
            }
        }
    } else if (paths.length) for(let i = paths.length - 1; i >= 0; i--){
        const pathCompletions = _getCompletionRecords(paths[i], context);
        if (pathCompletions.length > 1 || pathCompletions.length === 1 && !pathCompletions[0].path.isVariableDeclaration()) {
            completions.push(...pathCompletions);
            break;
        }
    }
    return completions;
}
function _getCompletionRecords(path, context) {
    let records = [];
    if (path.isIfStatement()) {
        records = addCompletionRecords(path.get("consequent"), records, context);
        records = addCompletionRecords(path.get("alternate"), records, context);
    } else if (path.isDoExpression() || path.isFor() || path.isWhile() || path.isLabeledStatement()) return addCompletionRecords(path.get("body"), records, context);
    else if (path.isProgram() || path.isBlockStatement()) return getStatementListCompletion(path.get("body"), context);
    else if (path.isFunction()) return _getCompletionRecords(path.get("body"), context);
    else if (path.isTryStatement()) {
        records = addCompletionRecords(path.get("block"), records, context);
        records = addCompletionRecords(path.get("handler"), records, context);
    } else if (path.isCatchClause()) return addCompletionRecords(path.get("body"), records, context);
    else if (path.isSwitchStatement()) return completionRecordForSwitch(path.get("cases"), records, context);
    else if (path.isSwitchCase()) return getStatementListCompletion(path.get("consequent"), {
        canHaveBreak: true,
        shouldPopulateBreak: false,
        inCaseClause: true
    });
    else if (path.isBreakStatement()) records.push(BreakCompletion(path));
    else records.push(NormalCompletion(path));
    return records;
}
function getCompletionRecords() {
    const records = _getCompletionRecords(this, {
        canHaveBreak: false,
        shouldPopulateBreak: false,
        inCaseClause: false
    });
    return records.map((r)=>r.path);
}
function getSibling(key) {
    return $8zU9J.default.get({
        parentPath: this.parentPath,
        parent: this.parent,
        container: this.container,
        listKey: this.listKey,
        key: key
    }).setContext(this.context);
}
function getPrevSibling() {
    return this.getSibling(this.key - 1);
}
function getNextSibling() {
    return this.getSibling(this.key + 1);
}
function getAllNextSiblings() {
    let _key = this.key;
    let sibling = this.getSibling(++_key);
    const siblings = [];
    while(sibling.node){
        siblings.push(sibling);
        sibling = this.getSibling(++_key);
    }
    return siblings;
}
function getAllPrevSiblings() {
    let _key = this.key;
    let sibling = this.getSibling(--_key);
    const siblings = [];
    while(sibling.node){
        siblings.push(sibling);
        sibling = this.getSibling(--_key);
    }
    return siblings;
}
function get(key, context = true) {
    if (context === true) context = this.context;
    const parts = key.split(".");
    if (parts.length === 1) return this._getKey(key, context);
    else return this._getPattern(parts, context);
}
function _getKey(key, context) {
    const node = this.node;
    const container = node[key];
    if (Array.isArray(container)) return container.map((_, i)=>{
        return $8zU9J.default.get({
            listKey: key,
            parentPath: this,
            parent: node,
            container: container,
            key: i
        }).setContext(context);
    });
    else return $8zU9J.default.get({
        parentPath: this,
        parent: node,
        container: node,
        key: key
    }).setContext(context);
}
function _getPattern(parts, context) {
    let path = this;
    for (const part of parts){
        if (part === ".") path = path.parentPath;
        else if (Array.isArray(path)) path = path[part];
        else path = path.get(part, context);
    }
    return path;
}
function getBindingIdentifiers(duplicates) {
    return _getBindingIdentifiers(this.node, duplicates);
}
function getOuterBindingIdentifiers(duplicates) {
    return _getOuterBindingIdentifiers(this.node, duplicates);
}
function getBindingIdentifierPaths(duplicates = false, outerOnly = false) {
    const path = this;
    const search = [
        path
    ];
    const ids = Object.create(null);
    while(search.length){
        const id = search.shift();
        if (!id) continue;
        if (!id.node) continue;
        const keys = _getBindingIdentifiers.keys[id.node.type];
        if (id.isIdentifier()) {
            if (duplicates) {
                const _ids = ids[id.node.name] = ids[id.node.name] || [];
                _ids.push(id);
            } else ids[id.node.name] = id;
            continue;
        }
        if (id.isExportDeclaration()) {
            const declaration = id.get("declaration");
            if (isDeclaration(declaration)) search.push(declaration);
            continue;
        }
        if (outerOnly) {
            if (id.isFunctionDeclaration()) {
                search.push(id.get("id"));
                continue;
            }
            if (id.isFunctionExpression()) continue;
        }
        if (keys) for(let i = 0; i < keys.length; i++){
            const key = keys[i];
            const child = id.get(key);
            if (Array.isArray(child)) search.push(...child);
            else if (child.node) search.push(child);
        }
    }
    return ids;
}
function getOuterBindingIdentifierPaths(duplicates = false) {
    return this.getBindingIdentifierPaths(duplicates, true);
}

});

parcelRegister("2TOyH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.addComment = $21c7efb82cbeb4a0$var$addComment;
module.exports.addComments = $21c7efb82cbeb4a0$var$addComments;
module.exports.shareCommentsWithSiblings = $21c7efb82cbeb4a0$var$shareCommentsWithSiblings;

var $ardUq = parcelRequire("ardUq");
const { addComment: $21c7efb82cbeb4a0$var$_addComment, addComments: $21c7efb82cbeb4a0$var$_addComments } = $ardUq;
function $21c7efb82cbeb4a0$var$shareCommentsWithSiblings() {
    if (typeof this.key === "string") return;
    const node = this.node;
    if (!node) return;
    const trailing = node.trailingComments;
    const leading = node.leadingComments;
    if (!trailing && !leading) return;
    const prev = this.getSibling(this.key - 1);
    const next = this.getSibling(this.key + 1);
    const hasPrev = Boolean(prev.node);
    const hasNext = Boolean(next.node);
    if (hasPrev) {
        if (leading) prev.addComments("trailing", $21c7efb82cbeb4a0$var$removeIfExisting(leading, prev.node.trailingComments));
        if (trailing && !hasNext) prev.addComments("trailing", trailing);
    }
    if (hasNext) {
        if (trailing) next.addComments("leading", $21c7efb82cbeb4a0$var$removeIfExisting(trailing, next.node.leadingComments));
        if (leading && !hasPrev) next.addComments("leading", leading);
    }
}
function $21c7efb82cbeb4a0$var$removeIfExisting(list, toRemove) {
    if (!(toRemove != null && toRemove.length)) return list;
    const set = new Set(toRemove);
    return list.filter((el)=>{
        return !set.has(el);
    });
}
function $21c7efb82cbeb4a0$var$addComment(type, content, line) {
    $21c7efb82cbeb4a0$var$_addComment(this.node, type, content, line);
}
function $21c7efb82cbeb4a0$var$addComments(type, comments) {
    $21c7efb82cbeb4a0$var$_addComments(this.node, type, comments);
}

});




parcelRegister("8nPrS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
class $61a86154e77f73fe$var$Hub {
    getCode() {}
    getScope() {}
    addHelper() {
        throw new Error("Helpers are not supported by the default hub.");
    }
    buildError(node, msg, Error1 = TypeError) {
        return new Error1(msg);
    }
}
module.exports.default = $61a86154e77f73fe$var$Hub;

});


parcelRegister("1gHRj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $gQ5sj = parcelRequire("gQ5sj");

var $b9Mkk = parcelRequire("b9Mkk");
const $0ec94e8855d94d34$var$helpers = Object.assign({
    __proto__: null
}, $b9Mkk.default);
var $0ec94e8855d94d34$var$_default = module.exports.default = $0ec94e8855d94d34$var$helpers;
const $0ec94e8855d94d34$var$helper = (minVersion)=>(tpl)=>({
            minVersion: minVersion,
            ast: ()=>$gQ5sj.default.program.ast(tpl)
        });
$0ec94e8855d94d34$var$helpers.AwaitValue = $0ec94e8855d94d34$var$helper("7.0.0-beta.0")`
    export default function _AwaitValue(value) {
      this.wrapped = value;
    }
  `;
$0ec94e8855d94d34$var$helpers.wrapAsyncGenerator = $0ec94e8855d94d34$var$helper("7.0.0-beta.0")`
  import AsyncGenerator from "AsyncGenerator";

  export default function _wrapAsyncGenerator(fn) {
    return function () {
      return new AsyncGenerator(fn.apply(this, arguments));
    };
  }
`;
$0ec94e8855d94d34$var$helpers.asyncToGenerator = $0ec94e8855d94d34$var$helper("7.0.0-beta.0")`
  function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
      var info = gen[key](arg);
      var value = info.value;
    } catch (error) {
      reject(error);
      return;
    }

    if (info.done) {
      resolve(value);
    } else {
      Promise.resolve(value).then(_next, _throw);
    }
  }

  export default function _asyncToGenerator(fn) {
    return function () {
      var self = this, args = arguments;
      return new Promise(function (resolve, reject) {
        var gen = fn.apply(self, args);
        function _next(value) {
          asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
        }
        function _throw(err) {
          asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
        }

        _next(undefined);
      });
    };
  }
`;
$0ec94e8855d94d34$var$helpers.classCallCheck = $0ec94e8855d94d34$var$helper("7.0.0-beta.0")`
  export default function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
`;
$0ec94e8855d94d34$var$helpers.createClass = $0ec94e8855d94d34$var$helper("7.0.0-beta.0")`
  import toPropertyKey from "toPropertyKey";
  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i ++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, toPropertyKey(descriptor.key), descriptor);
    }
  }

  export default function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", { writable: false });
    return Constructor;
  }
`;
$0ec94e8855d94d34$var$helpers.defineEnumerableProperties = $0ec94e8855d94d34$var$helper("7.0.0-beta.0")`
    export default function _defineEnumerableProperties(obj, descs) {
      for (var key in descs) {
        var desc = descs[key];
        desc.configurable = desc.enumerable = true;
        if ("value" in desc) desc.writable = true;
        Object.defineProperty(obj, key, desc);
      }

      // Symbols are not enumerated over by for-in loops. If native
      // Symbols are available, fetch all of the descs object's own
      // symbol properties and define them on our target object too.
      if (Object.getOwnPropertySymbols) {
        var objectSymbols = Object.getOwnPropertySymbols(descs);
        for (var i = 0; i < objectSymbols.length; i++) {
          var sym = objectSymbols[i];
          var desc = descs[sym];
          desc.configurable = desc.enumerable = true;
          if ("value" in desc) desc.writable = true;
          Object.defineProperty(obj, sym, desc);
        }
      }
      return obj;
    }
`;
$0ec94e8855d94d34$var$helpers.defaults = $0ec94e8855d94d34$var$helper("7.0.0-beta.0")`
  export default function _defaults(obj, defaults) {
    var keys = Object.getOwnPropertyNames(defaults);
    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      var value = Object.getOwnPropertyDescriptor(defaults, key);
      if (value && value.configurable && obj[key] === undefined) {
        Object.defineProperty(obj, key, value);
      }
    }
    return obj;
  }
`;
$0ec94e8855d94d34$var$helpers.defineProperty = $0ec94e8855d94d34$var$helper("7.0.0-beta.0")`
  import toPropertyKey from "toPropertyKey";
  export default function _defineProperty(obj, key, value) {
    key = toPropertyKey(key);
    // Shortcircuit the slow defineProperty path when possible.
    // We are trying to avoid issues where setters defined on the
    // prototype cause side effects under the fast path of simple
    // assignment. By checking for existence of the property with
    // the in operator, we can optimize most of this overhead away.
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }
    return obj;
  }
`;
$0ec94e8855d94d34$var$helpers.extends = $0ec94e8855d94d34$var$helper("7.0.0-beta.0")`
  export default function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };

    return _extends.apply(this, arguments);
  }
`;
$0ec94e8855d94d34$var$helpers.objectSpread = $0ec94e8855d94d34$var$helper("7.0.0-beta.0")`
    import defineProperty from "defineProperty";

    export default function _objectSpread(target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = (arguments[i] != null) ? Object(arguments[i]) : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
          ownKeys.push.apply(ownKeys, Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
          }));
        }
        ownKeys.forEach(function(key) {
          defineProperty(target, key, source[key]);
        });
      }
      return target;
    }
  `;
$0ec94e8855d94d34$var$helpers.inherits = $0ec94e8855d94d34$var$helper("7.0.0-beta.0")`
  import setPrototypeOf from "setPrototypeOf";

  export default function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }
    // We can't use defineProperty to set the prototype in a single step because it
    // doesn't work in Chrome <= 36. https://github.com/babel/babel/issues/14056
    // V8 bug: https://bugs.chromium.org/p/v8/issues/detail?id=3334
    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    Object.defineProperty(subClass, "prototype", { writable: false });
    if (superClass) setPrototypeOf(subClass, superClass);
  }
`;
$0ec94e8855d94d34$var$helpers.inheritsLoose = $0ec94e8855d94d34$var$helper("7.0.0-beta.0")`
  import setPrototypeOf from "setPrototypeOf";

  export default function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    setPrototypeOf(subClass, superClass);
  }
`;
$0ec94e8855d94d34$var$helpers.getPrototypeOf = $0ec94e8855d94d34$var$helper("7.0.0-beta.0")`
  export default function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf
      ? Object.getPrototypeOf.bind()
      : function _getPrototypeOf(o) {
          return o.__proto__ || Object.getPrototypeOf(o);
        };
    return _getPrototypeOf(o);
  }
`;
$0ec94e8855d94d34$var$helpers.setPrototypeOf = $0ec94e8855d94d34$var$helper("7.0.0-beta.0")`
  export default function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf
      ? Object.setPrototypeOf.bind()
      : function _setPrototypeOf(o, p) {
          o.__proto__ = p;
          return o;
        };
    return _setPrototypeOf(o, p);
  }
`;
$0ec94e8855d94d34$var$helpers.isNativeFunction = $0ec94e8855d94d34$var$helper("7.0.0-beta.0")`
  export default function _isNativeFunction(fn) {
    // Note: This function returns "true" for core-js functions.
    try {
      return Function.toString.call(fn).indexOf("[native code]") !== -1;
    } catch (e) {
      // Firefox 31 throws when "toString" is applied to an HTMLElement
      return typeof fn === "function";
    }
  }
`;
$0ec94e8855d94d34$var$helpers.wrapNativeSuper = $0ec94e8855d94d34$var$helper("7.0.0-beta.0")`
  import getPrototypeOf from "getPrototypeOf";
  import setPrototypeOf from "setPrototypeOf";
  import isNativeFunction from "isNativeFunction";
  import construct from "construct";

  export default function _wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;

    _wrapNativeSuper = function _wrapNativeSuper(Class) {
      if (Class === null || !isNativeFunction(Class)) return Class;
      if (typeof Class !== "function") {
        throw new TypeError("Super expression must either be null or a function");
      }
      if (typeof _cache !== "undefined") {
        if (_cache.has(Class)) return _cache.get(Class);
        _cache.set(Class, Wrapper);
      }
      function Wrapper() {
        return construct(Class, arguments, getPrototypeOf(this).constructor)
      }
      Wrapper.prototype = Object.create(Class.prototype, {
        constructor: {
          value: Wrapper,
          enumerable: false,
          writable: true,
          configurable: true,
        }
      });

      return setPrototypeOf(Wrapper, Class);
    }

    return _wrapNativeSuper(Class)
  }
`;
$0ec94e8855d94d34$var$helpers.instanceof = $0ec94e8855d94d34$var$helper("7.0.0-beta.0")`
  export default function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
      return !!right[Symbol.hasInstance](left);
    } else {
      return left instanceof right;
    }
  }
`;
$0ec94e8855d94d34$var$helpers.interopRequireDefault = $0ec94e8855d94d34$var$helper("7.0.0-beta.0")`
  export default function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }
`;
$0ec94e8855d94d34$var$helpers.newArrowCheck = $0ec94e8855d94d34$var$helper("7.0.0-beta.0")`
  export default function _newArrowCheck(innerThis, boundThis) {
    if (innerThis !== boundThis) {
      throw new TypeError("Cannot instantiate an arrow function");
    }
  }
`;
$0ec94e8855d94d34$var$helpers.objectDestructuringEmpty = $0ec94e8855d94d34$var$helper("7.0.0-beta.0")`
  export default function _objectDestructuringEmpty(obj) {
    if (obj == null) throw new TypeError("Cannot destructure " + obj);
  }
`;
$0ec94e8855d94d34$var$helpers.objectWithoutPropertiesLoose = $0ec94e8855d94d34$var$helper("7.0.0-beta.0")`
  export default function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};

    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;

    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }

    return target;
  }
`;
$0ec94e8855d94d34$var$helpers.objectWithoutProperties = $0ec94e8855d94d34$var$helper("7.0.0-beta.0")`
  import objectWithoutPropertiesLoose from "objectWithoutPropertiesLoose";

  export default function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};

    var target = objectWithoutPropertiesLoose(source, excluded);
    var key, i;

    if (Object.getOwnPropertySymbols) {
      var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
      for (i = 0; i < sourceSymbolKeys.length; i++) {
        key = sourceSymbolKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
      }
    }

    return target;
  }
`;
$0ec94e8855d94d34$var$helpers.assertThisInitialized = $0ec94e8855d94d34$var$helper("7.0.0-beta.0")`
  export default function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
  }
`;
$0ec94e8855d94d34$var$helpers.possibleConstructorReturn = $0ec94e8855d94d34$var$helper("7.0.0-beta.0")`
  import assertThisInitialized from "assertThisInitialized";

  export default function _possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) {
      return call;
    } else if (call !== void 0) {
      throw new TypeError("Derived constructors may only return object or undefined");
    }

    return assertThisInitialized(self);
  }
`;
$0ec94e8855d94d34$var$helpers.createSuper = $0ec94e8855d94d34$var$helper("7.9.0")`
    import getPrototypeOf from "getPrototypeOf";
    import isNativeReflectConstruct from "isNativeReflectConstruct";
    import possibleConstructorReturn from "possibleConstructorReturn";

    export default function _createSuper(Derived) {
      var hasNativeReflectConstruct = isNativeReflectConstruct();

      return function _createSuperInternal() {
        var Super = getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
          // NOTE: This doesn't work if this.__proto__.constructor has been modified.
          var NewTarget = getPrototypeOf(this).constructor;
          result = Reflect.construct(Super, arguments, NewTarget);
        } else {
          result = Super.apply(this, arguments);
        }
        return possibleConstructorReturn(this, result);
      }
    }
`;
$0ec94e8855d94d34$var$helpers.superPropBase = $0ec94e8855d94d34$var$helper("7.0.0-beta.0")`
  import getPrototypeOf from "getPrototypeOf";

  export default function _superPropBase(object, property) {
    // Yes, this throws if object is null to being with, that's on purpose.
    while (!Object.prototype.hasOwnProperty.call(object, property)) {
      object = getPrototypeOf(object);
      if (object === null) break;
    }
    return object;
  }
`;
$0ec94e8855d94d34$var$helpers.get = $0ec94e8855d94d34$var$helper("7.0.0-beta.0")`
  import superPropBase from "superPropBase";

  export default function _get() {
    if (typeof Reflect !== "undefined" && Reflect.get) {
      _get = Reflect.get.bind();
    } else {
      _get = function _get(target, property, receiver) {
        var base = superPropBase(target, property);

        if (!base) return;

        var desc = Object.getOwnPropertyDescriptor(base, property);
        if (desc.get) {
          // STEP 3. If receiver is not present, then set receiver to target.
          return desc.get.call(arguments.length < 3 ? target : receiver);
        }

        return desc.value;
      };
    }
    return _get.apply(this, arguments);
  }
`;
$0ec94e8855d94d34$var$helpers.set = $0ec94e8855d94d34$var$helper("7.0.0-beta.0")`
  import superPropBase from "superPropBase";
  import defineProperty from "defineProperty";

  function set(target, property, value, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.set) {
      set = Reflect.set;
    } else {
      set = function set(target, property, value, receiver) {
        var base = superPropBase(target, property);
        var desc;

        if (base) {
          desc = Object.getOwnPropertyDescriptor(base, property);
          if (desc.set) {
            desc.set.call(receiver, value);
            return true;
          } else if (!desc.writable) {
            // Both getter and non-writable fall into this.
            return false;
          }
        }

        // Without a super that defines the property, spec boils down to
        // "define on receiver" for some reason.
        desc = Object.getOwnPropertyDescriptor(receiver, property);
        if (desc) {
          if (!desc.writable) {
            // Setter, getter, and non-writable fall into this.
            return false;
          }

          desc.value = value;
          Object.defineProperty(receiver, property, desc);
        } else {
          // Avoid setters that may be defined on Sub's prototype, but not on
          // the instance.
          defineProperty(receiver, property, value);
        }

        return true;
      };
    }

    return set(target, property, value, receiver);
  }

  export default function _set(target, property, value, receiver, isStrict) {
    var s = set(target, property, value, receiver || target);
    if (!s && isStrict) {
      throw new TypeError('failed to set property');
    }

    return value;
  }
`;
$0ec94e8855d94d34$var$helpers.taggedTemplateLiteral = $0ec94e8855d94d34$var$helper("7.0.0-beta.0")`
  export default function _taggedTemplateLiteral(strings, raw) {
    if (!raw) { raw = strings.slice(0); }
    return Object.freeze(Object.defineProperties(strings, {
        raw: { value: Object.freeze(raw) }
    }));
  }
`;
$0ec94e8855d94d34$var$helpers.taggedTemplateLiteralLoose = $0ec94e8855d94d34$var$helper("7.0.0-beta.0")`
  export default function _taggedTemplateLiteralLoose(strings, raw) {
    if (!raw) { raw = strings.slice(0); }
    strings.raw = raw;
    return strings;
  }
`;
$0ec94e8855d94d34$var$helpers.readOnlyError = $0ec94e8855d94d34$var$helper("7.0.0-beta.0")`
  export default function _readOnlyError(name) {
    throw new TypeError("\\"" + name + "\\" is read-only");
  }
`;
$0ec94e8855d94d34$var$helpers.writeOnlyError = $0ec94e8855d94d34$var$helper("7.12.13")`
  export default function _writeOnlyError(name) {
    throw new TypeError("\\"" + name + "\\" is write-only");
  }
`;
$0ec94e8855d94d34$var$helpers.classNameTDZError = $0ec94e8855d94d34$var$helper("7.0.0-beta.0")`
  export default function _classNameTDZError(name) {
    throw new ReferenceError("Class \\"" + name + "\\" cannot be referenced in computed property keys.");
  }
`;
$0ec94e8855d94d34$var$helpers.temporalUndefined = $0ec94e8855d94d34$var$helper("7.0.0-beta.0")`
  // This function isn't mean to be called, but to be used as a reference.
  // We can't use a normal object because it isn't hoisted.
  export default function _temporalUndefined() {}
`;
$0ec94e8855d94d34$var$helpers.tdz = $0ec94e8855d94d34$var$helper("7.5.5")`
  export default function _tdzError(name) {
    throw new ReferenceError(name + " is not defined - temporal dead zone");
  }
`;
$0ec94e8855d94d34$var$helpers.temporalRef = $0ec94e8855d94d34$var$helper("7.0.0-beta.0")`
  import undef from "temporalUndefined";
  import err from "tdz";

  export default function _temporalRef(val, name) {
    return val === undef ? err(name) : val;
  }
`;
$0ec94e8855d94d34$var$helpers.slicedToArray = $0ec94e8855d94d34$var$helper("7.0.0-beta.0")`
  import arrayWithHoles from "arrayWithHoles";
  import iterableToArrayLimit from "iterableToArrayLimit";
  import unsupportedIterableToArray from "unsupportedIterableToArray";
  import nonIterableRest from "nonIterableRest";

  export default function _slicedToArray(arr, i) {
    return (
      arrayWithHoles(arr) ||
      iterableToArrayLimit(arr, i) ||
      unsupportedIterableToArray(arr, i) ||
      nonIterableRest()
    );
  }
`;
$0ec94e8855d94d34$var$helpers.slicedToArrayLoose = $0ec94e8855d94d34$var$helper("7.0.0-beta.0")`
  import arrayWithHoles from "arrayWithHoles";
  import iterableToArrayLimitLoose from "iterableToArrayLimitLoose";
  import unsupportedIterableToArray from "unsupportedIterableToArray";
  import nonIterableRest from "nonIterableRest";

  export default function _slicedToArrayLoose(arr, i) {
    return (
      arrayWithHoles(arr) ||
      iterableToArrayLimitLoose(arr, i) ||
      unsupportedIterableToArray(arr, i) ||
      nonIterableRest()
    );
  }
`;
$0ec94e8855d94d34$var$helpers.toArray = $0ec94e8855d94d34$var$helper("7.0.0-beta.0")`
  import arrayWithHoles from "arrayWithHoles";
  import iterableToArray from "iterableToArray";
  import unsupportedIterableToArray from "unsupportedIterableToArray";
  import nonIterableRest from "nonIterableRest";

  export default function _toArray(arr) {
    return (
      arrayWithHoles(arr) ||
      iterableToArray(arr) ||
      unsupportedIterableToArray(arr) ||
      nonIterableRest()
    );
  }
`;
$0ec94e8855d94d34$var$helpers.toConsumableArray = $0ec94e8855d94d34$var$helper("7.0.0-beta.0")`
  import arrayWithoutHoles from "arrayWithoutHoles";
  import iterableToArray from "iterableToArray";
  import unsupportedIterableToArray from "unsupportedIterableToArray";
  import nonIterableSpread from "nonIterableSpread";

  export default function _toConsumableArray(arr) {
    return (
      arrayWithoutHoles(arr) ||
      iterableToArray(arr) ||
      unsupportedIterableToArray(arr) ||
      nonIterableSpread()
    );
  }
`;
$0ec94e8855d94d34$var$helpers.arrayWithoutHoles = $0ec94e8855d94d34$var$helper("7.0.0-beta.0")`
  import arrayLikeToArray from "arrayLikeToArray";

  export default function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return arrayLikeToArray(arr);
  }
`;
$0ec94e8855d94d34$var$helpers.arrayWithHoles = $0ec94e8855d94d34$var$helper("7.0.0-beta.0")`
  export default function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
  }
`;
$0ec94e8855d94d34$var$helpers.maybeArrayLike = $0ec94e8855d94d34$var$helper("7.9.0")`
  import arrayLikeToArray from "arrayLikeToArray";

  export default function _maybeArrayLike(next, arr, i) {
    if (arr && !Array.isArray(arr) && typeof arr.length === "number") {
      var len = arr.length;
      return arrayLikeToArray(arr, i !== void 0 && i < len ? i : len);
    }
    return next(arr, i);
  }
`;
$0ec94e8855d94d34$var$helpers.iterableToArray = $0ec94e8855d94d34$var$helper("7.0.0-beta.0")`
  export default function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
  }
`;
$0ec94e8855d94d34$var$helpers.unsupportedIterableToArray = $0ec94e8855d94d34$var$helper("7.9.0")`
  import arrayLikeToArray from "arrayLikeToArray";

  export default function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return arrayLikeToArray(o, minLen);
  }
`;
$0ec94e8855d94d34$var$helpers.arrayLikeToArray = $0ec94e8855d94d34$var$helper("7.9.0")`
  export default function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
    return arr2;
  }
`;
$0ec94e8855d94d34$var$helpers.nonIterableSpread = $0ec94e8855d94d34$var$helper("7.0.0-beta.0")`
  export default function _nonIterableSpread() {
    throw new TypeError(
      "Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
    );
  }
`;
$0ec94e8855d94d34$var$helpers.nonIterableRest = $0ec94e8855d94d34$var$helper("7.0.0-beta.0")`
  export default function _nonIterableRest() {
    throw new TypeError(
      "Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
    );
  }
`;
$0ec94e8855d94d34$var$helpers.createForOfIteratorHelper = $0ec94e8855d94d34$var$helper("7.9.0")`
  import unsupportedIterableToArray from "unsupportedIterableToArray";

  // s: start (create the iterator)
  // n: next
  // e: error (called whenever something throws)
  // f: finish (always called at the end)

  export default function _createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];

    if (!it) {
      // Fallback for engines without symbol support
      if (
        Array.isArray(o) ||
        (it = unsupportedIterableToArray(o)) ||
        (allowArrayLike && o && typeof o.length === "number")
      ) {
        if (it) o = it;
        var i = 0;
        var F = function(){};
        return {
          s: F,
          n: function() {
            if (i >= o.length) return { done: true };
            return { done: false, value: o[i++] };
          },
          e: function(e) { throw e; },
          f: F,
        };
      }

      throw new TypeError("Invalid attempt to iterate non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }

    var normalCompletion = true, didErr = false, err;

    return {
      s: function() {
        it = it.call(o);
      },
      n: function() {
        var step = it.next();
        normalCompletion = step.done;
        return step;
      },
      e: function(e) {
        didErr = true;
        err = e;
      },
      f: function() {
        try {
          if (!normalCompletion && it.return != null) it.return();
        } finally {
          if (didErr) throw err;
        }
      }
    };
  }
`;
$0ec94e8855d94d34$var$helpers.createForOfIteratorHelperLoose = $0ec94e8855d94d34$var$helper("7.9.0")`
  import unsupportedIterableToArray from "unsupportedIterableToArray";

  export default function _createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];

    if (it) return (it = it.call(o)).next.bind(it);

    // Fallback for engines without symbol support
    if (
      Array.isArray(o) ||
      (it = unsupportedIterableToArray(o)) ||
      (allowArrayLike && o && typeof o.length === "number")
    ) {
      if (it) o = it;
      var i = 0;
      return function() {
        if (i >= o.length) return { done: true };
        return { done: false, value: o[i++] };
      }
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
`;
$0ec94e8855d94d34$var$helpers.skipFirstGeneratorNext = $0ec94e8855d94d34$var$helper("7.0.0-beta.0")`
  export default function _skipFirstGeneratorNext(fn) {
    return function () {
      var it = fn.apply(this, arguments);
      it.next();
      return it;
    }
  }
`;
$0ec94e8855d94d34$var$helpers.initializerWarningHelper = $0ec94e8855d94d34$var$helper("7.0.0-beta.0")`
    export default function _initializerWarningHelper(descriptor, context){
        throw new Error(
          'Decorating class property failed. Please ensure that ' +
          'transform-class-properties is enabled and runs after the decorators transform.'
        );
    }
`;
$0ec94e8855d94d34$var$helpers.initializerDefineProperty = $0ec94e8855d94d34$var$helper("7.0.0-beta.0")`
    export default function _initializerDefineProperty(target, property, descriptor, context){
        if (!descriptor) return;

        Object.defineProperty(target, property, {
            enumerable: descriptor.enumerable,
            configurable: descriptor.configurable,
            writable: descriptor.writable,
            value: descriptor.initializer ? descriptor.initializer.call(context) : void 0,
        });
    }
`;
$0ec94e8855d94d34$var$helpers.applyDecoratedDescriptor = $0ec94e8855d94d34$var$helper("7.0.0-beta.0")`
    export default function _applyDecoratedDescriptor(target, property, decorators, descriptor, context){
        var desc = {};
        Object.keys(descriptor).forEach(function(key){
            desc[key] = descriptor[key];
        });
        desc.enumerable = !!desc.enumerable;
        desc.configurable = !!desc.configurable;
        if ('value' in desc || desc.initializer){
            desc.writable = true;
        }

        desc = decorators.slice().reverse().reduce(function(desc, decorator){
            return decorator(target, property, desc) || desc;
        }, desc);

        if (context && desc.initializer !== void 0){
            desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
            desc.initializer = undefined;
        }

        if (desc.initializer === void 0){
            Object.defineProperty(target, property, desc);
            desc = null;
        }

        return desc;
    }
`;
$0ec94e8855d94d34$var$helpers.classPrivateFieldLooseKey = $0ec94e8855d94d34$var$helper("7.0.0-beta.0")`
  var id = 0;
  export default function _classPrivateFieldKey(name) {
    return "__private_" + (id++) + "_" + name;
  }
`;
$0ec94e8855d94d34$var$helpers.classPrivateFieldLooseBase = $0ec94e8855d94d34$var$helper("7.0.0-beta.0")`
  export default function _classPrivateFieldBase(receiver, privateKey) {
    if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) {
      throw new TypeError("attempted to use private field on non-instance");
    }
    return receiver;
  }
`;
$0ec94e8855d94d34$var$helpers.classPrivateFieldGet = $0ec94e8855d94d34$var$helper("7.0.0-beta.0")`
  import classApplyDescriptorGet from "classApplyDescriptorGet";
  import classPrivateFieldGet2 from "classPrivateFieldGet2";
  export default function _classPrivateFieldGet(receiver, privateMap) {
    var descriptor = classPrivateFieldGet2(privateMap, receiver);
    return classApplyDescriptorGet(receiver, descriptor);
  }
`;
$0ec94e8855d94d34$var$helpers.classPrivateFieldSet = $0ec94e8855d94d34$var$helper("7.0.0-beta.0")`
  import classApplyDescriptorSet from "classApplyDescriptorSet";
  import classPrivateFieldGet2 from "classPrivateFieldGet2";
  export default function _classPrivateFieldSet(receiver, privateMap, value) {
    var descriptor = classPrivateFieldGet2(privateMap, receiver);
    classApplyDescriptorSet(receiver, descriptor, value);
    return value;
  }
`;
$0ec94e8855d94d34$var$helpers.classPrivateFieldDestructureSet = $0ec94e8855d94d34$var$helper("7.4.4")`
  import classApplyDescriptorDestructureSet from "classApplyDescriptorDestructureSet";
  import classPrivateFieldGet2 from "classPrivateFieldGet2";
  export default function _classPrivateFieldDestructureSet(receiver, privateMap) {
    var descriptor = classPrivateFieldGet2(privateMap, receiver);
    return classApplyDescriptorDestructureSet(receiver, descriptor);
  }
`;
$0ec94e8855d94d34$var$helpers.classExtractFieldDescriptor = $0ec94e8855d94d34$var$helper("7.13.10")`
  import classPrivateFieldGet2 from "classPrivateFieldGet2";

  export default function _classExtractFieldDescriptor(receiver, privateMap) {
    return classPrivateFieldGet2(privateMap, receiver);
  }
`;
$0ec94e8855d94d34$var$helpers.classStaticPrivateFieldSpecGet = $0ec94e8855d94d34$var$helper("7.0.2")`
  import classApplyDescriptorGet from "classApplyDescriptorGet";
  import assertClassBrand from "assertClassBrand";
  import classCheckPrivateStaticFieldDescriptor from "classCheckPrivateStaticFieldDescriptor";
  export default function _classStaticPrivateFieldSpecGet(receiver, classConstructor, descriptor) {
    assertClassBrand(classConstructor, receiver);
    classCheckPrivateStaticFieldDescriptor(descriptor, "get");
    return classApplyDescriptorGet(receiver, descriptor);
  }
`;
$0ec94e8855d94d34$var$helpers.classStaticPrivateFieldSpecSet = $0ec94e8855d94d34$var$helper("7.0.2")`
  import classApplyDescriptorSet from "classApplyDescriptorSet";
  import assertClassBrand from "assertClassBrand";
  import classCheckPrivateStaticFieldDescriptor from "classCheckPrivateStaticFieldDescriptor";
  export default function _classStaticPrivateFieldSpecSet(receiver, classConstructor, descriptor, value) {
    assertClassBrand(classConstructor, receiver);
    classCheckPrivateStaticFieldDescriptor(descriptor, "set");
    classApplyDescriptorSet(receiver, descriptor, value);
    return value;
  }
`;
$0ec94e8855d94d34$var$helpers.classStaticPrivateMethodGet = $0ec94e8855d94d34$var$helper("7.3.2")`
  import assertClassBrand from "assertClassBrand";
  export default function _classStaticPrivateMethodGet(receiver, classConstructor, method) {
    assertClassBrand(classConstructor, receiver);
    return method;
  }
`;
$0ec94e8855d94d34$var$helpers.classStaticPrivateMethodSet = $0ec94e8855d94d34$var$helper("7.3.2")`
  export default function _classStaticPrivateMethodSet() {
    throw new TypeError("attempted to set read only static private field");
  }
`;
$0ec94e8855d94d34$var$helpers.classApplyDescriptorGet = $0ec94e8855d94d34$var$helper("7.13.10")`
  export default function _classApplyDescriptorGet(receiver, descriptor) {
    if (descriptor.get) {
      return descriptor.get.call(receiver);
    }
    return descriptor.value;
  }
`;
$0ec94e8855d94d34$var$helpers.classApplyDescriptorSet = $0ec94e8855d94d34$var$helper("7.13.10")`
  export default function _classApplyDescriptorSet(receiver, descriptor, value) {
    if (descriptor.set) {
      descriptor.set.call(receiver, value);
    } else {
      if (!descriptor.writable) {
        // This should only throw in strict mode, but class bodies are
        // always strict and private fields can only be used inside
        // class bodies.
        throw new TypeError("attempted to set read only private field");
      }
      descriptor.value = value;
    }
  }
`;
$0ec94e8855d94d34$var$helpers.classApplyDescriptorDestructureSet = $0ec94e8855d94d34$var$helper("7.13.10")`
  export default function _classApplyDescriptorDestructureSet(receiver, descriptor) {
    if (descriptor.set) {
      if (!("__destrObj" in descriptor)) {
        descriptor.__destrObj = {
          set value(v) {
            descriptor.set.call(receiver, v)
          },
        };
      }
      return descriptor.__destrObj;
    } else {
      if (!descriptor.writable) {
        // This should only throw in strict mode, but class bodies are
        // always strict and private fields can only be used inside
        // class bodies.
        throw new TypeError("attempted to set read only private field");
      }

      return descriptor;
    }
  }
`;
$0ec94e8855d94d34$var$helpers.classStaticPrivateFieldDestructureSet = $0ec94e8855d94d34$var$helper("7.13.10")`
  import classApplyDescriptorDestructureSet from "classApplyDescriptorDestructureSet";
  import assertClassBrand from "assertClassBrand";
  import classCheckPrivateStaticFieldDescriptor from "classCheckPrivateStaticFieldDescriptor";
  export default function _classStaticPrivateFieldDestructureSet(receiver, classConstructor, descriptor) {
    assertClassBrand(classConstructor, receiver);
    classCheckPrivateStaticFieldDescriptor(descriptor, "set");
    return classApplyDescriptorDestructureSet(receiver, descriptor);
  }
`;
$0ec94e8855d94d34$var$helpers.classCheckPrivateStaticAccess = $0ec94e8855d94d34$var$helper("7.13.10")`
  import assertClassBrand from "assertClassBrand";
  export default function _classCheckPrivateStaticAccess(receiver, classConstructor, returnValue) {
    return assertClassBrand(classConstructor, receiver, returnValue);
  }
`;
$0ec94e8855d94d34$var$helpers.classCheckPrivateStaticFieldDescriptor = $0ec94e8855d94d34$var$helper("7.13.10")`
  export default function _classCheckPrivateStaticFieldDescriptor(descriptor, action) {
    if (descriptor === undefined) {
      throw new TypeError("attempted to " + action + " private static field before its declaration");
    }
  }
`;
$0ec94e8855d94d34$var$helpers.decorate = $0ec94e8855d94d34$var$helper("7.1.5")`
  import toArray from "toArray";
  import toPropertyKey from "toPropertyKey";

  // These comments are stripped by @babel/template
  /*::
  type PropertyDescriptor =
    | {
        value: any,
        writable: boolean,
        configurable: boolean,
        enumerable: boolean,
      }
    | {
        get?: () => any,
        set?: (v: any) => void,
        configurable: boolean,
        enumerable: boolean,
      };

  type FieldDescriptor ={
    writable: boolean,
    configurable: boolean,
    enumerable: boolean,
  };

  type Placement = "static" | "prototype" | "own";
  type Key = string | symbol; // PrivateName is not supported yet.

  type ElementDescriptor =
    | {
        kind: "method",
        key: Key,
        placement: Placement,
        descriptor: PropertyDescriptor
      }
    | {
        kind: "field",
        key: Key,
        placement: Placement,
        descriptor: FieldDescriptor,
        initializer?: () => any,
      };

  // This is exposed to the user code
  type ElementObjectInput = ElementDescriptor & {
    [@@toStringTag]?: "Descriptor"
  };

  // This is exposed to the user code
  type ElementObjectOutput = ElementDescriptor & {
    [@@toStringTag]?: "Descriptor"
    extras?: ElementDescriptor[],
    finisher?: ClassFinisher,
  };

  // This is exposed to the user code
  type ClassObject = {
    [@@toStringTag]?: "Descriptor",
    kind: "class",
    elements: ElementDescriptor[],
  };

  type ElementDecorator = (descriptor: ElementObjectInput) => ?ElementObjectOutput;
  type ClassDecorator = (descriptor: ClassObject) => ?ClassObject;
  type ClassFinisher = <A, B>(cl: Class<A>) => Class<B>;

  // Only used by Babel in the transform output, not part of the spec.
  type ElementDefinition =
    | {
        kind: "method",
        value: any,
        key: Key,
        static?: boolean,
        decorators?: ElementDecorator[],
      }
    | {
        kind: "field",
        value: () => any,
        key: Key,
        static?: boolean,
        decorators?: ElementDecorator[],
    };

  declare function ClassFactory<C>(initialize: (instance: C) => void): {
    F: Class<C>,
    d: ElementDefinition[]
  }

  */

  /*::
  // Various combinations with/without extras and with one or many finishers

  type ElementFinisherExtras = {
    element: ElementDescriptor,
    finisher?: ClassFinisher,
    extras?: ElementDescriptor[],
  };

  type ElementFinishersExtras = {
    element: ElementDescriptor,
    finishers: ClassFinisher[],
    extras: ElementDescriptor[],
  };

  type ElementsFinisher = {
    elements: ElementDescriptor[],
    finisher?: ClassFinisher,
  };

  type ElementsFinishers = {
    elements: ElementDescriptor[],
    finishers: ClassFinisher[],
  };

  */

  /*::

  type Placements = {
    static: Key[],
    prototype: Key[],
    own: Key[],
  };

  */

  // ClassDefinitionEvaluation (Steps 26-*)
  export default function _decorate(
    decorators /*: ClassDecorator[] */,
    factory /*: ClassFactory */,
    superClass /*: ?Class<*> */,
    mixins /*: ?Array<Function> */,
  ) /*: Class<*> */ {
    var api = _getDecoratorsApi();
    if (mixins) {
      for (var i = 0; i < mixins.length; i++) {
        api = mixins[i](api);
      }
    }

    var r = factory(function initialize(O) {
      api.initializeInstanceElements(O, decorated.elements);
    }, superClass);
    var decorated = api.decorateClass(
      _coalesceClassElements(r.d.map(_createElementDescriptor)),
      decorators,
    );

    api.initializeClassElements(r.F, decorated.elements);

    return api.runClassFinishers(r.F, decorated.finishers);
  }

  function _getDecoratorsApi() {
    _getDecoratorsApi = function() {
      return api;
    };

    var api = {
      elementsDefinitionOrder: [["method"], ["field"]],

      // InitializeInstanceElements
      initializeInstanceElements: function(
        /*::<C>*/ O /*: C */,
        elements /*: ElementDescriptor[] */,
      ) {
        ["method", "field"].forEach(function(kind) {
          elements.forEach(function(element /*: ElementDescriptor */) {
            if (element.kind === kind && element.placement === "own") {
              this.defineClassElement(O, element);
            }
          }, this);
        }, this);
      },

      // InitializeClassElements
      initializeClassElements: function(
        /*::<C>*/ F /*: Class<C> */,
        elements /*: ElementDescriptor[] */,
      ) {
        var proto = F.prototype;

        ["method", "field"].forEach(function(kind) {
          elements.forEach(function(element /*: ElementDescriptor */) {
            var placement = element.placement;
            if (
              element.kind === kind &&
              (placement === "static" || placement === "prototype")
            ) {
              var receiver = placement === "static" ? F : proto;
              this.defineClassElement(receiver, element);
            }
          }, this);
        }, this);
      },

      // DefineClassElement
      defineClassElement: function(
        /*::<C>*/ receiver /*: C | Class<C> */,
        element /*: ElementDescriptor */,
      ) {
        var descriptor /*: PropertyDescriptor */ = element.descriptor;
        if (element.kind === "field") {
          var initializer = element.initializer;
          descriptor = {
            enumerable: descriptor.enumerable,
            writable: descriptor.writable,
            configurable: descriptor.configurable,
            value: initializer === void 0 ? void 0 : initializer.call(receiver),
          };
        }
        Object.defineProperty(receiver, element.key, descriptor);
      },

      // DecorateClass
      decorateClass: function(
        elements /*: ElementDescriptor[] */,
        decorators /*: ClassDecorator[] */,
      ) /*: ElementsFinishers */ {
        var newElements /*: ElementDescriptor[] */ = [];
        var finishers /*: ClassFinisher[] */ = [];
        var placements /*: Placements */ = {
          static: [],
          prototype: [],
          own: [],
        };

        elements.forEach(function(element /*: ElementDescriptor */) {
          this.addElementPlacement(element, placements);
        }, this);

        elements.forEach(function(element /*: ElementDescriptor */) {
          if (!_hasDecorators(element)) return newElements.push(element);

          var elementFinishersExtras /*: ElementFinishersExtras */ = this.decorateElement(
            element,
            placements,
          );
          newElements.push(elementFinishersExtras.element);
          newElements.push.apply(newElements, elementFinishersExtras.extras);
          finishers.push.apply(finishers, elementFinishersExtras.finishers);
        }, this);

        if (!decorators) {
          return { elements: newElements, finishers: finishers };
        }

        var result /*: ElementsFinishers */ = this.decorateConstructor(
          newElements,
          decorators,
        );
        finishers.push.apply(finishers, result.finishers);
        result.finishers = finishers;

        return result;
      },

      // AddElementPlacement
      addElementPlacement: function(
        element /*: ElementDescriptor */,
        placements /*: Placements */,
        silent /*: boolean */,
      ) {
        var keys = placements[element.placement];
        if (!silent && keys.indexOf(element.key) !== -1) {
          throw new TypeError("Duplicated element (" + element.key + ")");
        }
        keys.push(element.key);
      },

      // DecorateElement
      decorateElement: function(
        element /*: ElementDescriptor */,
        placements /*: Placements */,
      ) /*: ElementFinishersExtras */ {
        var extras /*: ElementDescriptor[] */ = [];
        var finishers /*: ClassFinisher[] */ = [];

        for (
          var decorators = element.decorators, i = decorators.length - 1;
          i >= 0;
          i--
        ) {
          // (inlined) RemoveElementPlacement
          var keys = placements[element.placement];
          keys.splice(keys.indexOf(element.key), 1);

          var elementObject /*: ElementObjectInput */ = this.fromElementDescriptor(
            element,
          );
          var elementFinisherExtras /*: ElementFinisherExtras */ = this.toElementFinisherExtras(
            (0, decorators[i])(elementObject) /*: ElementObjectOutput */ ||
              elementObject,
          );

          element = elementFinisherExtras.element;
          this.addElementPlacement(element, placements);

          if (elementFinisherExtras.finisher) {
            finishers.push(elementFinisherExtras.finisher);
          }

          var newExtras /*: ElementDescriptor[] | void */ =
            elementFinisherExtras.extras;
          if (newExtras) {
            for (var j = 0; j < newExtras.length; j++) {
              this.addElementPlacement(newExtras[j], placements);
            }
            extras.push.apply(extras, newExtras);
          }
        }

        return { element: element, finishers: finishers, extras: extras };
      },

      // DecorateConstructor
      decorateConstructor: function(
        elements /*: ElementDescriptor[] */,
        decorators /*: ClassDecorator[] */,
      ) /*: ElementsFinishers */ {
        var finishers /*: ClassFinisher[] */ = [];

        for (var i = decorators.length - 1; i >= 0; i--) {
          var obj /*: ClassObject */ = this.fromClassDescriptor(elements);
          var elementsAndFinisher /*: ElementsFinisher */ = this.toClassDescriptor(
            (0, decorators[i])(obj) /*: ClassObject */ || obj,
          );

          if (elementsAndFinisher.finisher !== undefined) {
            finishers.push(elementsAndFinisher.finisher);
          }

          if (elementsAndFinisher.elements !== undefined) {
            elements = elementsAndFinisher.elements;

            for (var j = 0; j < elements.length - 1; j++) {
              for (var k = j + 1; k < elements.length; k++) {
                if (
                  elements[j].key === elements[k].key &&
                  elements[j].placement === elements[k].placement
                ) {
                  throw new TypeError(
                    "Duplicated element (" + elements[j].key + ")",
                  );
                }
              }
            }
          }
        }

        return { elements: elements, finishers: finishers };
      },

      // FromElementDescriptor
      fromElementDescriptor: function(
        element /*: ElementDescriptor */,
      ) /*: ElementObject */ {
        var obj /*: ElementObject */ = {
          kind: element.kind,
          key: element.key,
          placement: element.placement,
          descriptor: element.descriptor,
        };

        var desc = {
          value: "Descriptor",
          configurable: true,
        };
        Object.defineProperty(obj, Symbol.toStringTag, desc);

        if (element.kind === "field") obj.initializer = element.initializer;

        return obj;
      },

      // ToElementDescriptors
      toElementDescriptors: function(
        elementObjects /*: ElementObject[] */,
      ) /*: ElementDescriptor[] */ {
        if (elementObjects === undefined) return;
        return toArray(elementObjects).map(function(elementObject) {
          var element = this.toElementDescriptor(elementObject);
          this.disallowProperty(elementObject, "finisher", "An element descriptor");
          this.disallowProperty(elementObject, "extras", "An element descriptor");
          return element;
        }, this);
      },

      // ToElementDescriptor
      toElementDescriptor: function(
        elementObject /*: ElementObject */,
      ) /*: ElementDescriptor */ {
        var kind = String(elementObject.kind);
        if (kind !== "method" && kind !== "field") {
          throw new TypeError(
            'An element descriptor\\'s .kind property must be either "method" or' +
              ' "field", but a decorator created an element descriptor with' +
              ' .kind "' +
              kind +
              '"',
          );
        }

        var key = toPropertyKey(elementObject.key);

        var placement = String(elementObject.placement);
        if (
          placement !== "static" &&
          placement !== "prototype" &&
          placement !== "own"
        ) {
          throw new TypeError(
            'An element descriptor\\'s .placement property must be one of "static",' +
              ' "prototype" or "own", but a decorator created an element descriptor' +
              ' with .placement "' +
              placement +
              '"',
          );
        }

        var descriptor /*: PropertyDescriptor */ = elementObject.descriptor;

        this.disallowProperty(elementObject, "elements", "An element descriptor");

        var element /*: ElementDescriptor */ = {
          kind: kind,
          key: key,
          placement: placement,
          descriptor: Object.assign({}, descriptor),
        };

        if (kind !== "field") {
          this.disallowProperty(elementObject, "initializer", "A method descriptor");
        } else {
          this.disallowProperty(
            descriptor,
            "get",
            "The property descriptor of a field descriptor",
          );
          this.disallowProperty(
            descriptor,
            "set",
            "The property descriptor of a field descriptor",
          );
          this.disallowProperty(
            descriptor,
            "value",
            "The property descriptor of a field descriptor",
          );

          element.initializer = elementObject.initializer;
        }

        return element;
      },

      toElementFinisherExtras: function(
        elementObject /*: ElementObject */,
      ) /*: ElementFinisherExtras */ {
        var element /*: ElementDescriptor */ = this.toElementDescriptor(
          elementObject,
        );
        var finisher /*: ClassFinisher */ = _optionalCallableProperty(
          elementObject,
          "finisher",
        );
        var extras /*: ElementDescriptors[] */ = this.toElementDescriptors(
          elementObject.extras,
        );

        return { element: element, finisher: finisher, extras: extras };
      },

      // FromClassDescriptor
      fromClassDescriptor: function(
        elements /*: ElementDescriptor[] */,
      ) /*: ClassObject */ {
        var obj = {
          kind: "class",
          elements: elements.map(this.fromElementDescriptor, this),
        };

        var desc = { value: "Descriptor", configurable: true };
        Object.defineProperty(obj, Symbol.toStringTag, desc);

        return obj;
      },

      // ToClassDescriptor
      toClassDescriptor: function(
        obj /*: ClassObject */,
      ) /*: ElementsFinisher */ {
        var kind = String(obj.kind);
        if (kind !== "class") {
          throw new TypeError(
            'A class descriptor\\'s .kind property must be "class", but a decorator' +
              ' created a class descriptor with .kind "' +
              kind +
              '"',
          );
        }

        this.disallowProperty(obj, "key", "A class descriptor");
        this.disallowProperty(obj, "placement", "A class descriptor");
        this.disallowProperty(obj, "descriptor", "A class descriptor");
        this.disallowProperty(obj, "initializer", "A class descriptor");
        this.disallowProperty(obj, "extras", "A class descriptor");

        var finisher = _optionalCallableProperty(obj, "finisher");
        var elements = this.toElementDescriptors(obj.elements);

        return { elements: elements, finisher: finisher };
      },

      // RunClassFinishers
      runClassFinishers: function(
        constructor /*: Class<*> */,
        finishers /*: ClassFinisher[] */,
      ) /*: Class<*> */ {
        for (var i = 0; i < finishers.length; i++) {
          var newConstructor /*: ?Class<*> */ = (0, finishers[i])(constructor);
          if (newConstructor !== undefined) {
            // NOTE: This should check if IsConstructor(newConstructor) is false.
            if (typeof newConstructor !== "function") {
              throw new TypeError("Finishers must return a constructor.");
            }
            constructor = newConstructor;
          }
        }
        return constructor;
      },

      disallowProperty: function(obj, name, objectType) {
        if (obj[name] !== undefined) {
          throw new TypeError(objectType + " can't have a ." + name + " property.");
        }
      }
    };

    return api;
  }

  // ClassElementEvaluation
  function _createElementDescriptor(
    def /*: ElementDefinition */,
  ) /*: ElementDescriptor */ {
    var key = toPropertyKey(def.key);

    var descriptor /*: PropertyDescriptor */;
    if (def.kind === "method") {
      descriptor = {
        value: def.value,
        writable: true,
        configurable: true,
        enumerable: false,
      };
    } else if (def.kind === "get") {
      descriptor = { get: def.value, configurable: true, enumerable: false };
    } else if (def.kind === "set") {
      descriptor = { set: def.value, configurable: true, enumerable: false };
    } else if (def.kind === "field") {
      descriptor = { configurable: true, writable: true, enumerable: true };
    }

    var element /*: ElementDescriptor */ = {
      kind: def.kind === "field" ? "field" : "method",
      key: key,
      placement: def.static
        ? "static"
        : def.kind === "field"
        ? "own"
        : "prototype",
      descriptor: descriptor,
    };
    if (def.decorators) element.decorators = def.decorators;
    if (def.kind === "field") element.initializer = def.value;

    return element;
  }

  // CoalesceGetterSetter
  function _coalesceGetterSetter(
    element /*: ElementDescriptor */,
    other /*: ElementDescriptor */,
  ) {
    if (element.descriptor.get !== undefined) {
      other.descriptor.get = element.descriptor.get;
    } else {
      other.descriptor.set = element.descriptor.set;
    }
  }

  // CoalesceClassElements
  function _coalesceClassElements(
    elements /*: ElementDescriptor[] */,
  ) /*: ElementDescriptor[] */ {
    var newElements /*: ElementDescriptor[] */ = [];

    var isSameElement = function(
      other /*: ElementDescriptor */,
    ) /*: boolean */ {
      return (
        other.kind === "method" &&
        other.key === element.key &&
        other.placement === element.placement
      );
    };

    for (var i = 0; i < elements.length; i++) {
      var element /*: ElementDescriptor */ = elements[i];
      var other /*: ElementDescriptor */;

      if (
        element.kind === "method" &&
        (other = newElements.find(isSameElement))
      ) {
        if (
          _isDataDescriptor(element.descriptor) ||
          _isDataDescriptor(other.descriptor)
        ) {
          if (_hasDecorators(element) || _hasDecorators(other)) {
            throw new ReferenceError(
              "Duplicated methods (" + element.key + ") can't be decorated.",
            );
          }
          other.descriptor = element.descriptor;
        } else {
          if (_hasDecorators(element)) {
            if (_hasDecorators(other)) {
              throw new ReferenceError(
                "Decorators can't be placed on different accessors with for " +
                  "the same property (" +
                  element.key +
                  ").",
              );
            }
            other.decorators = element.decorators;
          }
          _coalesceGetterSetter(element, other);
        }
      } else {
        newElements.push(element);
      }
    }

    return newElements;
  }

  function _hasDecorators(element /*: ElementDescriptor */) /*: boolean */ {
    return element.decorators && element.decorators.length;
  }

  function _isDataDescriptor(desc /*: PropertyDescriptor */) /*: boolean */ {
    return (
      desc !== undefined &&
      !(desc.value === undefined && desc.writable === undefined)
    );
  }

  function _optionalCallableProperty /*::<T>*/(
    obj /*: T */,
    name /*: $Keys<T> */,
  ) /*: ?Function */ {
    var value = obj[name];
    if (value !== undefined && typeof value !== "function") {
      throw new TypeError("Expected '" + name + "' to be a function");
    }
    return value;
  }

`;
$0ec94e8855d94d34$var$helpers.classPrivateMethodGet = $0ec94e8855d94d34$var$helper("7.1.6")`
  import assertClassBrand from "assertClassBrand";
  export default function _classPrivateMethodGet(receiver, privateSet, fn) {
    assertClassBrand(privateSet, receiver);
    return fn;
  }
`;
$0ec94e8855d94d34$var$helpers.checkPrivateRedeclaration = $0ec94e8855d94d34$var$helper("7.14.1")`
  export default function _checkPrivateRedeclaration(obj, privateCollection) {
    if (privateCollection.has(obj)) {
      throw new TypeError("Cannot initialize the same private elements twice on an object");
    }
  }
`;
$0ec94e8855d94d34$var$helpers.classPrivateFieldInitSpec = $0ec94e8855d94d34$var$helper("7.14.1")`
  import checkPrivateRedeclaration from "checkPrivateRedeclaration";

  export default function _classPrivateFieldInitSpec(obj, privateMap, value) {
    checkPrivateRedeclaration(obj, privateMap);
    privateMap.set(obj, value);
  }
`;
$0ec94e8855d94d34$var$helpers.classPrivateMethodInitSpec = $0ec94e8855d94d34$var$helper("7.14.1")`
  import checkPrivateRedeclaration from "checkPrivateRedeclaration";

  export default function _classPrivateMethodInitSpec(obj, privateSet) {
    checkPrivateRedeclaration(obj, privateSet);
    privateSet.add(obj);
  }
`;
$0ec94e8855d94d34$var$helpers.classPrivateMethodSet = $0ec94e8855d94d34$var$helper("7.1.6")`
    export default function _classPrivateMethodSet() {
      throw new TypeError("attempted to reassign private method");
    }
  `;
$0ec94e8855d94d34$var$helpers.identity = $0ec94e8855d94d34$var$helper("7.17.0")`
  export default function _identity(x) {
    return x;
  }
`;
$0ec94e8855d94d34$var$helpers.nullishReceiverError = $0ec94e8855d94d34$var$helper("7.22.6")`
  export default function _nullishReceiverError(r) {
    throw new TypeError("Cannot set property of null or undefined.");
  }
`;

});
parcelRegister("b9Mkk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $gQ5sj = parcelRequire("gQ5sj");
function $81f605b366a4aa81$var$helper(minVersion, source) {
    return Object.freeze({
        minVersion: minVersion,
        ast: ()=>$gQ5sj.default.program.ast(source, {
                preserveComments: true
            })
    });
}
var $81f605b366a4aa81$var$_default = module.exports.default = Object.freeze({
    AsyncGenerator: $81f605b366a4aa81$var$helper("7.0.0-beta.0", 'import OverloadYield from"OverloadYield";export default function AsyncGenerator(e){var r,t;function resume(r,t){try{var n=e[r](t),o=n.value,u=o instanceof OverloadYield;Promise.resolve(u?o.v:o).then((function(t){if(u){var i="return"===r?"return":"next";if(!o.k||t.done)return resume(i,t);t=e[i](t).value}settle(n.done?"return":"normal",t)}),(function(e){resume("throw",e)}))}catch(e){settle("throw",e)}}function settle(e,n){switch(e){case"return":r.resolve({value:n,done:!0});break;case"throw":r.reject(n);break;default:r.resolve({value:n,done:!1})}(r=r.next)?resume(r.key,r.arg):t=null}this._invoke=function(e,n){return new Promise((function(o,u){var i={key:e,arg:n,resolve:o,reject:u,next:null};t?t=t.next=i:(r=t=i,resume(e,n))}))},"function"!=typeof e.return&&(this.return=void 0)}AsyncGenerator.prototype["function"==typeof Symbol&&Symbol.asyncIterator||"@@asyncIterator"]=function(){return this},AsyncGenerator.prototype.next=function(e){return this._invoke("next",e)},AsyncGenerator.prototype.throw=function(e){return this._invoke("throw",e)},AsyncGenerator.prototype.return=function(e){return this._invoke("return",e)};'),
    OverloadYield: $81f605b366a4aa81$var$helper("7.18.14", "export default function _OverloadYield(t,e){this.v=t,this.k=e}"),
    applyDecs: $81f605b366a4aa81$var$helper("7.17.8", 'import setFunctionName from"setFunctionName";import toPropertyKey from"toPropertyKey";function old_createMetadataMethodsForProperty(e,t,a,r){return{getMetadata:function(o){old_assertNotFinished(r,"getMetadata"),old_assertMetadataKey(o);var i=e[o];if(void 0!==i)if(1===t){var n=i.public;if(void 0!==n)return n[a]}else if(2===t){var l=i.private;if(void 0!==l)return l.get(a)}else if(Object.hasOwnProperty.call(i,"constructor"))return i.constructor},setMetadata:function(o,i){old_assertNotFinished(r,"setMetadata"),old_assertMetadataKey(o);var n=e[o];if(void 0===n&&(n=e[o]={}),1===t){var l=n.public;void 0===l&&(l=n.public={}),l[a]=i}else if(2===t){var s=n.priv;void 0===s&&(s=n.private=new Map),s.set(a,i)}else n.constructor=i}}}function old_convertMetadataMapToFinal(e,t){var a=e[Symbol.metadata||Symbol.for("Symbol.metadata")],r=Object.getOwnPropertySymbols(t);if(0!==r.length){for(var o=0;o<r.length;o++){var i=r[o],n=t[i],l=a?a[i]:null,s=n.public,c=l?l.public:null;s&&c&&Object.setPrototypeOf(s,c);var d=n.private;if(d){var u=Array.from(d.values()),f=l?l.private:null;f&&(u=u.concat(f)),n.private=u}l&&Object.setPrototypeOf(n,l)}a&&Object.setPrototypeOf(t,a),e[Symbol.metadata||Symbol.for("Symbol.metadata")]=t}}function old_createAddInitializerMethod(e,t){return function(a){old_assertNotFinished(t,"addInitializer"),old_assertCallable(a,"An initializer"),e.push(a)}}function old_memberDec(e,t,a,r,o,i,n,l,s){var c;switch(i){case 1:c="accessor";break;case 2:c="method";break;case 3:c="getter";break;case 4:c="setter";break;default:c="field"}var d,u,f={kind:c,name:l?"#"+t:toPropertyKey(t),isStatic:n,isPrivate:l},p={v:!1};if(0!==i&&(f.addInitializer=old_createAddInitializerMethod(o,p)),l){d=2,u=Symbol(t);var v={};0===i?(v.get=a.get,v.set=a.set):2===i?v.get=function(){return a.value}:(1!==i&&3!==i||(v.get=function(){return a.get.call(this)}),1!==i&&4!==i||(v.set=function(e){a.set.call(this,e)})),f.access=v}else d=1,u=t;try{return e(s,Object.assign(f,old_createMetadataMethodsForProperty(r,d,u,p)))}finally{p.v=!0}}function old_assertNotFinished(e,t){if(e.v)throw Error("attempted to call "+t+" after decoration was finished")}function old_assertMetadataKey(e){if("symbol"!=typeof e)throw new TypeError("Metadata keys must be symbols, received: "+e)}function old_assertCallable(e,t){if("function"!=typeof e)throw new TypeError(t+" must be a function")}function old_assertValidReturnValue(e,t){var a=typeof t;if(1===e){if("object"!==a||null===t)throw new TypeError("accessor decorators must return an object with get, set, or init properties or void 0");void 0!==t.get&&old_assertCallable(t.get,"accessor.get"),void 0!==t.set&&old_assertCallable(t.set,"accessor.set"),void 0!==t.init&&old_assertCallable(t.init,"accessor.init"),void 0!==t.initializer&&old_assertCallable(t.initializer,"accessor.initializer")}else if("function"!==a)throw new TypeError((0===e?"field":10===e?"class":"method")+" decorators must return a function or void 0")}function old_getInit(e){var t;return null==(t=e.init)&&(t=e.initializer)&&void 0!==console&&console.warn(".initializer has been renamed to .init as of March 2022"),t}function old_applyMemberDec(e,t,a,r,o,i,n,l,s){var c,d,u,f,p,v,y,h=a[0];if(n?(0===o||1===o?(c={get:a[3],set:a[4]},u="get"):3===o?(c={get:a[3]},u="get"):4===o?(c={set:a[3]},u="set"):c={value:a[3]},0!==o&&(1===o&&setFunctionName(a[4],"#"+r,"set"),setFunctionName(a[3],"#"+r,u))):0!==o&&(c=Object.getOwnPropertyDescriptor(t,r)),1===o?f={get:c.get,set:c.set}:2===o?f=c.value:3===o?f=c.get:4===o&&(f=c.set),"function"==typeof h)void 0!==(p=old_memberDec(h,r,c,l,s,o,i,n,f))&&(old_assertValidReturnValue(o,p),0===o?d=p:1===o?(d=old_getInit(p),v=p.get||f.get,y=p.set||f.set,f={get:v,set:y}):f=p);else for(var m=h.length-1;m>=0;m--){var b;void 0!==(p=old_memberDec(h[m],r,c,l,s,o,i,n,f))&&(old_assertValidReturnValue(o,p),0===o?b=p:1===o?(b=old_getInit(p),v=p.get||f.get,y=p.set||f.set,f={get:v,set:y}):f=p,void 0!==b&&(void 0===d?d=b:"function"==typeof d?d=[d,b]:d.push(b)))}if(0===o||1===o){if(void 0===d)d=function(e,t){return t};else if("function"!=typeof d){var g=d;d=function(e,t){for(var a=t,r=0;r<g.length;r++)a=g[r].call(e,a);return a}}else{var _=d;d=function(e,t){return _.call(e,t)}}e.push(d)}0!==o&&(1===o?(c.get=f.get,c.set=f.set):2===o?c.value=f:3===o?c.get=f:4===o&&(c.set=f),n?1===o?(e.push((function(e,t){return f.get.call(e,t)})),e.push((function(e,t){return f.set.call(e,t)}))):2===o?e.push(f):e.push((function(e,t){return f.call(e,t)})):Object.defineProperty(t,r,c))}function old_applyMemberDecs(e,t,a,r,o){for(var i,n,l=new Map,s=new Map,c=0;c<o.length;c++){var d=o[c];if(Array.isArray(d)){var u,f,p,v=d[1],y=d[2],h=d.length>3,m=v>=5;if(m?(u=t,f=r,0!=(v-=5)&&(p=n=n||[])):(u=t.prototype,f=a,0!==v&&(p=i=i||[])),0!==v&&!h){var b=m?s:l,g=b.get(y)||0;if(!0===g||3===g&&4!==v||4===g&&3!==v)throw Error("Attempted to decorate a public method/accessor that has the same name as a previously decorated public method/accessor. This is not currently supported by the decorators plugin. Property name was: "+y);!g&&v>2?b.set(y,v):b.set(y,!0)}old_applyMemberDec(e,u,d,y,v,m,h,f,p)}}old_pushInitializers(e,i),old_pushInitializers(e,n)}function old_pushInitializers(e,t){t&&e.push((function(e){for(var a=0;a<t.length;a++)t[a].call(e);return e}))}function old_applyClassDecs(e,t,a,r){if(r.length>0){for(var o=[],i=t,n=t.name,l=r.length-1;l>=0;l--){var s={v:!1};try{var c=Object.assign({kind:"class",name:n,addInitializer:old_createAddInitializerMethod(o,s)},old_createMetadataMethodsForProperty(a,0,n,s)),d=r[l](i,c)}finally{s.v=!0}void 0!==d&&(old_assertValidReturnValue(10,d),i=d)}e.push(i,(function(){for(var e=0;e<o.length;e++)o[e].call(i)}))}}export default function applyDecs(e,t,a){var r=[],o={},i={};return old_applyMemberDecs(r,e,i,o,t),old_convertMetadataMapToFinal(e.prototype,i),old_applyClassDecs(r,e,o,a),old_convertMetadataMapToFinal(e,o),r}'),
    applyDecs2203: $81f605b366a4aa81$var$helper("7.19.0", 'function applyDecs2203Factory(){function createAddInitializerMethod(e,t){return function(r){!function(e,t){if(e.v)throw Error("attempted to call addInitializer after decoration was finished")}(t),assertCallable(r,"An initializer"),e.push(r)}}function memberDec(e,t,r,a,n,i,s,o){var c;switch(n){case 1:c="accessor";break;case 2:c="method";break;case 3:c="getter";break;case 4:c="setter";break;default:c="field"}var l,u,f={kind:c,name:s?"#"+t:t,static:i,private:s},p={v:!1};0!==n&&(f.addInitializer=createAddInitializerMethod(a,p)),0===n?s?(l=r.get,u=r.set):(l=function(){return this[t]},u=function(e){this[t]=e}):2===n?l=function(){return r.value}:(1!==n&&3!==n||(l=function(){return r.get.call(this)}),1!==n&&4!==n||(u=function(e){r.set.call(this,e)})),f.access=l&&u?{get:l,set:u}:l?{get:l}:{set:u};try{return e(o,f)}finally{p.v=!0}}function assertCallable(e,t){if("function"!=typeof e)throw new TypeError(t+" must be a function")}function assertValidReturnValue(e,t){var r=typeof t;if(1===e){if("object"!==r||null===t)throw new TypeError("accessor decorators must return an object with get, set, or init properties or void 0");void 0!==t.get&&assertCallable(t.get,"accessor.get"),void 0!==t.set&&assertCallable(t.set,"accessor.set"),void 0!==t.init&&assertCallable(t.init,"accessor.init")}else if("function"!==r)throw new TypeError((0===e?"field":10===e?"class":"method")+" decorators must return a function or void 0")}function applyMemberDec(e,t,r,a,n,i,s,o){var c,l,u,f,p,d,h=r[0];if(s?c=0===n||1===n?{get:r[3],set:r[4]}:3===n?{get:r[3]}:4===n?{set:r[3]}:{value:r[3]}:0!==n&&(c=Object.getOwnPropertyDescriptor(t,a)),1===n?u={get:c.get,set:c.set}:2===n?u=c.value:3===n?u=c.get:4===n&&(u=c.set),"function"==typeof h)void 0!==(f=memberDec(h,a,c,o,n,i,s,u))&&(assertValidReturnValue(n,f),0===n?l=f:1===n?(l=f.init,p=f.get||u.get,d=f.set||u.set,u={get:p,set:d}):u=f);else for(var v=h.length-1;v>=0;v--){var g;void 0!==(f=memberDec(h[v],a,c,o,n,i,s,u))&&(assertValidReturnValue(n,f),0===n?g=f:1===n?(g=f.init,p=f.get||u.get,d=f.set||u.set,u={get:p,set:d}):u=f,void 0!==g&&(void 0===l?l=g:"function"==typeof l?l=[l,g]:l.push(g)))}if(0===n||1===n){if(void 0===l)l=function(e,t){return t};else if("function"!=typeof l){var y=l;l=function(e,t){for(var r=t,a=0;a<y.length;a++)r=y[a].call(e,r);return r}}else{var m=l;l=function(e,t){return m.call(e,t)}}e.push(l)}0!==n&&(1===n?(c.get=u.get,c.set=u.set):2===n?c.value=u:3===n?c.get=u:4===n&&(c.set=u),s?1===n?(e.push((function(e,t){return u.get.call(e,t)})),e.push((function(e,t){return u.set.call(e,t)}))):2===n?e.push(u):e.push((function(e,t){return u.call(e,t)})):Object.defineProperty(t,a,c))}function pushInitializers(e,t){t&&e.push((function(e){for(var r=0;r<t.length;r++)t[r].call(e);return e}))}return function(e,t,r){var a=[];return function(e,t,r){for(var a,n,i=new Map,s=new Map,o=0;o<r.length;o++){var c=r[o];if(Array.isArray(c)){var l,u,f=c[1],p=c[2],d=c.length>3,h=f>=5;if(h?(l=t,0!=(f-=5)&&(u=n=n||[])):(l=t.prototype,0!==f&&(u=a=a||[])),0!==f&&!d){var v=h?s:i,g=v.get(p)||0;if(!0===g||3===g&&4!==f||4===g&&3!==f)throw Error("Attempted to decorate a public method/accessor that has the same name as a previously decorated public method/accessor. This is not currently supported by the decorators plugin. Property name was: "+p);!g&&f>2?v.set(p,f):v.set(p,!0)}applyMemberDec(e,l,c,p,f,h,d,u)}}pushInitializers(e,a),pushInitializers(e,n)}(a,e,t),function(e,t,r){if(r.length>0){for(var a=[],n=t,i=t.name,s=r.length-1;s>=0;s--){var o={v:!1};try{var c=r[s](n,{kind:"class",name:i,addInitializer:createAddInitializerMethod(a,o)})}finally{o.v=!0}void 0!==c&&(assertValidReturnValue(10,c),n=c)}e.push(n,(function(){for(var e=0;e<a.length;e++)a[e].call(n)}))}}(a,e,r),a}}var applyDecs2203Impl;export default function applyDecs2203(e,t,r){return(applyDecs2203Impl=applyDecs2203Impl||applyDecs2203Factory())(e,t,r)}'),
    applyDecs2203R: $81f605b366a4aa81$var$helper("7.20.0", 'import setFunctionName from"setFunctionName";import toPropertyKey from"toPropertyKey";function applyDecs2203RFactory(){function createAddInitializerMethod(e,t){return function(r){!function(e,t){if(e.v)throw Error("attempted to call addInitializer after decoration was finished")}(t),assertCallable(r,"An initializer"),e.push(r)}}function memberDec(e,t,r,n,a,i,o,s){var c;switch(a){case 1:c="accessor";break;case 2:c="method";break;case 3:c="getter";break;case 4:c="setter";break;default:c="field"}var l,u,f={kind:c,name:o?"#"+t:toPropertyKey(t),static:i,private:o},p={v:!1};0!==a&&(f.addInitializer=createAddInitializerMethod(n,p)),0===a?o?(l=r.get,u=r.set):(l=function(){return this[t]},u=function(e){this[t]=e}):2===a?l=function(){return r.value}:(1!==a&&3!==a||(l=function(){return r.get.call(this)}),1!==a&&4!==a||(u=function(e){r.set.call(this,e)})),f.access=l&&u?{get:l,set:u}:l?{get:l}:{set:u};try{return e(s,f)}finally{p.v=!0}}function assertCallable(e,t){if("function"!=typeof e)throw new TypeError(t+" must be a function")}function assertValidReturnValue(e,t){var r=typeof t;if(1===e){if("object"!==r||null===t)throw new TypeError("accessor decorators must return an object with get, set, or init properties or void 0");void 0!==t.get&&assertCallable(t.get,"accessor.get"),void 0!==t.set&&assertCallable(t.set,"accessor.set"),void 0!==t.init&&assertCallable(t.init,"accessor.init")}else if("function"!==r)throw new TypeError((0===e?"field":10===e?"class":"method")+" decorators must return a function or void 0")}function applyMemberDec(e,t,r,n,a,i,o,s){var c,l,u,f,p,d,h,v=r[0];if(o?(0===a||1===a?(c={get:r[3],set:r[4]},u="get"):3===a?(c={get:r[3]},u="get"):4===a?(c={set:r[3]},u="set"):c={value:r[3]},0!==a&&(1===a&&setFunctionName(r[4],"#"+n,"set"),setFunctionName(r[3],"#"+n,u))):0!==a&&(c=Object.getOwnPropertyDescriptor(t,n)),1===a?f={get:c.get,set:c.set}:2===a?f=c.value:3===a?f=c.get:4===a&&(f=c.set),"function"==typeof v)void 0!==(p=memberDec(v,n,c,s,a,i,o,f))&&(assertValidReturnValue(a,p),0===a?l=p:1===a?(l=p.init,d=p.get||f.get,h=p.set||f.set,f={get:d,set:h}):f=p);else for(var g=v.length-1;g>=0;g--){var y;void 0!==(p=memberDec(v[g],n,c,s,a,i,o,f))&&(assertValidReturnValue(a,p),0===a?y=p:1===a?(y=p.init,d=p.get||f.get,h=p.set||f.set,f={get:d,set:h}):f=p,void 0!==y&&(void 0===l?l=y:"function"==typeof l?l=[l,y]:l.push(y)))}if(0===a||1===a){if(void 0===l)l=function(e,t){return t};else if("function"!=typeof l){var m=l;l=function(e,t){for(var r=t,n=0;n<m.length;n++)r=m[n].call(e,r);return r}}else{var b=l;l=function(e,t){return b.call(e,t)}}e.push(l)}0!==a&&(1===a?(c.get=f.get,c.set=f.set):2===a?c.value=f:3===a?c.get=f:4===a&&(c.set=f),o?1===a?(e.push((function(e,t){return f.get.call(e,t)})),e.push((function(e,t){return f.set.call(e,t)}))):2===a?e.push(f):e.push((function(e,t){return f.call(e,t)})):Object.defineProperty(t,n,c))}function applyMemberDecs(e,t){for(var r,n,a=[],i=new Map,o=new Map,s=0;s<t.length;s++){var c=t[s];if(Array.isArray(c)){var l,u,f=c[1],p=c[2],d=c.length>3,h=f>=5;if(h?(l=e,0!=(f-=5)&&(u=n=n||[])):(l=e.prototype,0!==f&&(u=r=r||[])),0!==f&&!d){var v=h?o:i,g=v.get(p)||0;if(!0===g||3===g&&4!==f||4===g&&3!==f)throw Error("Attempted to decorate a public method/accessor that has the same name as a previously decorated public method/accessor. This is not currently supported by the decorators plugin. Property name was: "+p);!g&&f>2?v.set(p,f):v.set(p,!0)}applyMemberDec(a,l,c,p,f,h,d,u)}}return pushInitializers(a,r),pushInitializers(a,n),a}function pushInitializers(e,t){t&&e.push((function(e){for(var r=0;r<t.length;r++)t[r].call(e);return e}))}return function(e,t,r){return{e:applyMemberDecs(e,t),get c(){return function(e,t){if(t.length>0){for(var r=[],n=e,a=e.name,i=t.length-1;i>=0;i--){var o={v:!1};try{var s=t[i](n,{kind:"class",name:a,addInitializer:createAddInitializerMethod(r,o)})}finally{o.v=!0}void 0!==s&&(assertValidReturnValue(10,s),n=s)}return[n,function(){for(var e=0;e<r.length;e++)r[e].call(n)}]}}(e,r)}}}}export default function applyDecs2203R(e,t,r){return(applyDecs2203R=applyDecs2203RFactory())(e,t,r)}'),
    applyDecs2301: $81f605b366a4aa81$var$helper("7.21.0", 'import checkInRHS from"checkInRHS";import setFunctionName from"setFunctionName";import toPropertyKey from"toPropertyKey";function applyDecs2301Factory(){function createAddInitializerMethod(e,t){return function(r){!function(e,t){if(e.v)throw Error("attempted to call addInitializer after decoration was finished")}(t),assertCallable(r,"An initializer"),e.push(r)}}function assertInstanceIfPrivate(e,t){if(!e(t))throw new TypeError("Attempted to access private element on non-instance")}function memberDec(e,t,r,n,a,i,s,o,c){var u;switch(a){case 1:u="accessor";break;case 2:u="method";break;case 3:u="getter";break;case 4:u="setter";break;default:u="field"}var l,f,p={kind:u,name:s?"#"+t:toPropertyKey(t),static:i,private:s},d={v:!1};if(0!==a&&(p.addInitializer=createAddInitializerMethod(n,d)),s||0!==a&&2!==a)if(2===a)l=function(e){return assertInstanceIfPrivate(c,e),r.value};else{var h=0===a||1===a;(h||3===a)&&(l=s?function(e){return assertInstanceIfPrivate(c,e),r.get.call(e)}:function(e){return r.get.call(e)}),(h||4===a)&&(f=s?function(e,t){assertInstanceIfPrivate(c,e),r.set.call(e,t)}:function(e,t){r.set.call(e,t)})}else l=function(e){return e[t]},0===a&&(f=function(e,r){e[t]=r});var v=s?c.bind():function(e){return t in e};p.access=l&&f?{get:l,set:f,has:v}:l?{get:l,has:v}:{set:f,has:v};try{return e(o,p)}finally{d.v=!0}}function assertCallable(e,t){if("function"!=typeof e)throw new TypeError(t+" must be a function")}function assertValidReturnValue(e,t){var r=typeof t;if(1===e){if("object"!==r||null===t)throw new TypeError("accessor decorators must return an object with get, set, or init properties or void 0");void 0!==t.get&&assertCallable(t.get,"accessor.get"),void 0!==t.set&&assertCallable(t.set,"accessor.set"),void 0!==t.init&&assertCallable(t.init,"accessor.init")}else if("function"!==r)throw new TypeError((0===e?"field":10===e?"class":"method")+" decorators must return a function or void 0")}function curryThis2(e){return function(t){e(this,t)}}function applyMemberDec(e,t,r,n,a,i,s,o,c){var u,l,f,p,d,h,v,y,g=r[0];if(s?(0===a||1===a?(u={get:(d=r[3],function(){return d(this)}),set:curryThis2(r[4])},f="get"):3===a?(u={get:r[3]},f="get"):4===a?(u={set:r[3]},f="set"):u={value:r[3]},0!==a&&(1===a&&setFunctionName(u.set,"#"+n,"set"),setFunctionName(u[f||"value"],"#"+n,f))):0!==a&&(u=Object.getOwnPropertyDescriptor(t,n)),1===a?p={get:u.get,set:u.set}:2===a?p=u.value:3===a?p=u.get:4===a&&(p=u.set),"function"==typeof g)void 0!==(h=memberDec(g,n,u,o,a,i,s,p,c))&&(assertValidReturnValue(a,h),0===a?l=h:1===a?(l=h.init,v=h.get||p.get,y=h.set||p.set,p={get:v,set:y}):p=h);else for(var m=g.length-1;m>=0;m--){var b;void 0!==(h=memberDec(g[m],n,u,o,a,i,s,p,c))&&(assertValidReturnValue(a,h),0===a?b=h:1===a?(b=h.init,v=h.get||p.get,y=h.set||p.set,p={get:v,set:y}):p=h,void 0!==b&&(void 0===l?l=b:"function"==typeof l?l=[l,b]:l.push(b)))}if(0===a||1===a){if(void 0===l)l=function(e,t){return t};else if("function"!=typeof l){var I=l;l=function(e,t){for(var r=t,n=0;n<I.length;n++)r=I[n].call(e,r);return r}}else{var w=l;l=function(e,t){return w.call(e,t)}}e.push(l)}0!==a&&(1===a?(u.get=p.get,u.set=p.set):2===a?u.value=p:3===a?u.get=p:4===a&&(u.set=p),s?1===a?(e.push((function(e,t){return p.get.call(e,t)})),e.push((function(e,t){return p.set.call(e,t)}))):2===a?e.push(p):e.push((function(e,t){return p.call(e,t)})):Object.defineProperty(t,n,u))}function applyMemberDecs(e,t,r){for(var n,a,i,s=[],o=new Map,c=new Map,u=0;u<t.length;u++){var l=t[u];if(Array.isArray(l)){var f,p,d=l[1],h=l[2],v=l.length>3,y=d>=5,g=r;if(y?(f=e,0!=(d-=5)&&(p=a=a||[]),v&&!i&&(i=function(t){return checkInRHS(t)===e}),g=i):(f=e.prototype,0!==d&&(p=n=n||[])),0!==d&&!v){var m=y?c:o,b=m.get(h)||0;if(!0===b||3===b&&4!==d||4===b&&3!==d)throw Error("Attempted to decorate a public method/accessor that has the same name as a previously decorated public method/accessor. This is not currently supported by the decorators plugin. Property name was: "+h);!b&&d>2?m.set(h,d):m.set(h,!0)}applyMemberDec(s,f,l,h,d,y,v,p,g)}}return pushInitializers(s,n),pushInitializers(s,a),s}function pushInitializers(e,t){t&&e.push((function(e){for(var r=0;r<t.length;r++)t[r].call(e);return e}))}return function(e,t,r,n){return{e:applyMemberDecs(e,t,n),get c(){return function(e,t){if(t.length>0){for(var r=[],n=e,a=e.name,i=t.length-1;i>=0;i--){var s={v:!1};try{var o=t[i](n,{kind:"class",name:a,addInitializer:createAddInitializerMethod(r,s)})}finally{s.v=!0}void 0!==o&&(assertValidReturnValue(10,o),n=o)}return[n,function(){for(var e=0;e<r.length;e++)r[e].call(n)}]}}(e,r)}}}}export default function applyDecs2301(e,t,r,n){return(applyDecs2301=applyDecs2301Factory())(e,t,r,n)}'),
    applyDecs2305: $81f605b366a4aa81$var$helper("7.21.0", 'import checkInRHS from"checkInRHS";import setFunctionName from"setFunctionName";import toPropertyKey from"toPropertyKey";export default function applyDecs2305(e,t,r,n,o,a){function i(e,t,r){return function(n,o){return r&&r(n),e[t].call(n,o)}}function c(e,t){for(var r=0;r<e.length;r++)e[r].call(t);return t}function s(e,t,r,n){if("function"!=typeof e&&(n||void 0!==e))throw new TypeError(t+" must "+(r||"be")+" a function"+(n?"":" or undefined"));return e}function applyDec(e,t,r,n,o,a,c,u,l,f,p,d,h){function m(e){if(!h(e))throw new TypeError("Attempted to access private element on non-instance")}var y,v=t[0],g=t[3],b=!u;if(!b){r||Array.isArray(v)||(v=[v]);var w={},S=[],A=3===o?"get":4===o||d?"set":"value";f?(p||d?w={get:setFunctionName((function(){return g(this)}),n,"get"),set:function(e){t[4](this,e)}}:w[A]=g,p||setFunctionName(w[A],n,2===o?"":A)):p||(w=Object.getOwnPropertyDescriptor(e,n))}for(var P=e,j=v.length-1;j>=0;j-=r?2:1){var D=v[j],E=r?v[j-1]:void 0,I={},O={kind:["field","accessor","method","getter","setter","class"][o],name:n,metadata:a,addInitializer:function(e,t){if(e.v)throw Error("attempted to call addInitializer after decoration was finished");s(t,"An initializer","be",!0),c.push(t)}.bind(null,I)};try{if(b)(y=s(D.call(E,P,O),"class decorators","return"))&&(P=y);else{var k,F;O.static=l,O.private=f,f?2===o?k=function(e){return m(e),w.value}:(o<4&&(k=i(w,"get",m)),3!==o&&(F=i(w,"set",m))):(k=function(e){return e[n]},(o<2||4===o)&&(F=function(e,t){e[n]=t}));var N=O.access={has:f?h.bind():function(e){return n in e}};if(k&&(N.get=k),F&&(N.set=F),P=D.call(E,d?{get:w.get,set:w.set}:w[A],O),d){if("object"==typeof P&&P)(y=s(P.get,"accessor.get"))&&(w.get=y),(y=s(P.set,"accessor.set"))&&(w.set=y),(y=s(P.init,"accessor.init"))&&S.push(y);else if(void 0!==P)throw new TypeError("accessor decorators must return an object with get, set, or init properties or void 0")}else s(P,(p?"field":"method")+" decorators","return")&&(p?S.push(P):w[A]=P)}}finally{I.v=!0}}return(p||d)&&u.push((function(e,t){for(var r=S.length-1;r>=0;r--)t=S[r].call(e,t);return t})),p||b||(f?d?u.push(i(w,"get"),i(w,"set")):u.push(2===o?w[A]:i.call.bind(w[A])):Object.defineProperty(e,n,w)),P}function u(e,t){return Object.defineProperty(e,Symbol.metadata||Symbol.for("Symbol.metadata"),{configurable:!0,enumerable:!0,value:t})}if(arguments.length>=6)var l=a[Symbol.metadata||Symbol.for("Symbol.metadata")];var f=Object.create(null==l?null:l),p=function(e,t,r,n){var o,a,i=[],s=function(t){return checkInRHS(t)===e},u=new Map;function l(e){e&&i.push(c.bind(null,e))}for(var f=0;f<t.length;f++){var p=t[f];if(Array.isArray(p)){var d=p[1],h=p[2],m=p.length>3,y=16&d,v=!!(8&d),g=0==(d&=7),b=h+"/"+v;if(!g&&!m){var w=u.get(b);if(!0===w||3===w&&4!==d||4===w&&3!==d)throw Error("Attempted to decorate a public method/accessor that has the same name as a previously decorated public method/accessor. This is not currently supported by the decorators plugin. Property name was: "+h);u.set(b,!(d>2)||d)}applyDec(v?e:e.prototype,p,y,m?"#"+h:toPropertyKey(h),d,n,v?a=a||[]:o=o||[],i,v,m,g,1===d,v&&m?s:r)}}return l(o),l(a),i}(e,t,o,f);return r.length||u(e,f),{e:p,get c(){var t=[];return r.length&&[u(applyDec(e,[r],n,e.name,5,f,t),f),c.bind(null,t,e)]}}}'),
    applyDecs2311: $81f605b366a4aa81$var$helper("7.24.0", 'import checkInRHS from"checkInRHS";import setFunctionName from"setFunctionName";import toPropertyKey from"toPropertyKey";export default function applyDecs2311(e,t,n,r,o,i){var a,c,u,s,f,l,p,d=Symbol.metadata||Symbol.for("Symbol.metadata"),m=Object.defineProperty,h=Object.create,y=[h(null),h(null)],v=t.length;function g(t,n,r){return function(o,i){n&&(i=o,o=e);for(var a=0;a<t.length;a++)i=t[a].apply(o,r?[i]:[]);return r?i:o}}function b(e,t,n,r){if("function"!=typeof e&&(r||void 0!==e))throw new TypeError(t+" must "+(n||"be")+" a function"+(r?"":" or undefined"));return e}function applyDec(e,t,n,r,o,i,u,s,f,l,p){function d(e){if(!p(e))throw new TypeError("Attempted to access private element on non-instance")}var h=[].concat(t[0]),v=t[3],w=!u,D=1===o,S=3===o,j=4===o,E=2===o;function I(t,n,r){return function(o,i){return n&&(i=o,o=e),r&&r(o),P[t].call(o,i)}}if(!w){var P={},k=[],F=S?"get":j||D?"set":"value";if(f?(l||D?P={get:setFunctionName((function(){return v(this)}),r,"get"),set:function(e){t[4](this,e)}}:P[F]=v,l||setFunctionName(P[F],r,E?"":F)):l||(P=Object.getOwnPropertyDescriptor(e,r)),!l&&!f){if((c=y[+s][r])&&7!=(c^o))throw Error("Decorating two elements with the same name ("+P[F].name+") is not supported yet");y[+s][r]=o<3?1:o}}for(var N=e,O=h.length-1;O>=0;O-=n?2:1){var z=h[O],H=n?h[O-1]:void 0,K={},R={kind:["field","accessor","method","getter","setter","class"][o],name:r,metadata:a,addInitializer:function(e,t){if(e.v)throw Error("attempted to call addInitializer after decoration was finished");b(t,"An initializer","be",!0),i.push(t)}.bind(null,K)};if(w)c=z.call(H,N,R),K.v=1,b(c,"class decorators","return")&&(N=c);else if(R.static=s,R.private=f,c=R.access={has:f?p.bind():function(e){return r in e}},j||(c.get=f?E?function(e){return d(e),P.value}:I("get",0,d):function(e){return e[r]}),E||S||(c.set=f?I("set",0,d):function(e,t){e[r]=t}),N=z.call(H,D?{get:P.get,set:P.set}:P[F],R),K.v=1,D){if("object"==typeof N&&N)(c=b(N.get,"accessor.get"))&&(P.get=c),(c=b(N.set,"accessor.set"))&&(P.set=c),(c=b(N.init,"accessor.init"))&&k.unshift(c);else if(void 0!==N)throw new TypeError("accessor decorators must return an object with get, set, or init properties or undefined")}else b(N,(l?"field":"method")+" decorators","return")&&(l?k.unshift(N):P[F]=N)}return o<2&&u.push(g(k,s,1),g(i,s,0)),l||w||(f?D?u.splice(-1,0,I("get",s),I("set",s)):u.push(E?P[F]:b.call.bind(P[F])):m(e,r,P)),N}function w(e){return m(e,d,{configurable:!0,enumerable:!0,value:a})}return void 0!==i&&(a=i[d]),a=h(null==a?null:a),f=[],l=function(e){e&&f.push(g(e))},p=function(t,r){for(var i=0;i<n.length;i++){var a=n[i],c=a[1],l=7&c;if((8&c)==t&&!l==r){var p=a[2],d=!!a[3],m=16&c;applyDec(t?e:e.prototype,a,m,d?"#"+p:toPropertyKey(p),l,l<2?[]:t?s=s||[]:u=u||[],f,!!t,d,r,t&&d?function(t){return checkInRHS(t)===e}:o)}}},p(8,0),p(0,0),p(8,1),p(0,1),l(u),l(s),c=f,v||w(e),{e:c,get c(){var n=[];return v&&[w(e=applyDec(e,[t],r,e.name,5,n)),g(n,1)]}}}'),
    assertClassBrand: $81f605b366a4aa81$var$helper("7.24.0", 'export default function _assertClassBrand(e,t,n){if("function"==typeof e?e===t:e.has(t))return arguments.length<3?t:n;throw new TypeError("Private element is not present on this object")}'),
    asyncGeneratorDelegate: $81f605b366a4aa81$var$helper("7.0.0-beta.0", 'import OverloadYield from"OverloadYield";export default function _asyncGeneratorDelegate(t){var e={},n=!1;function pump(e,r){return n=!0,r=new Promise((function(n){n(t[e](r))})),{done:!1,value:new OverloadYield(r,1)}}return e["undefined"!=typeof Symbol&&Symbol.iterator||"@@iterator"]=function(){return this},e.next=function(t){return n?(n=!1,t):pump("next",t)},"function"==typeof t.throw&&(e.throw=function(t){if(n)throw n=!1,t;return pump("throw",t)}),"function"==typeof t.return&&(e.return=function(t){return n?(n=!1,t):pump("return",t)}),e}'),
    asyncIterator: $81f605b366a4aa81$var$helper("7.15.9", 'export default function _asyncIterator(r){var n,t,o,e=2;for("undefined"!=typeof Symbol&&(t=Symbol.asyncIterator,o=Symbol.iterator);e--;){if(t&&null!=(n=r[t]))return n.call(r);if(o&&null!=(n=r[o]))return new AsyncFromSyncIterator(n.call(r));t="@@asyncIterator",o="@@iterator"}throw new TypeError("Object is not async iterable")}function AsyncFromSyncIterator(r){function AsyncFromSyncIteratorContinuation(r){if(Object(r)!==r)return Promise.reject(new TypeError(r+" is not an object."));var n=r.done;return Promise.resolve(r.value).then((function(r){return{value:r,done:n}}))}return AsyncFromSyncIterator=function(r){this.s=r,this.n=r.next},AsyncFromSyncIterator.prototype={s:null,n:null,next:function(){return AsyncFromSyncIteratorContinuation(this.n.apply(this.s,arguments))},return:function(r){var n=this.s.return;return void 0===n?Promise.resolve({value:r,done:!0}):AsyncFromSyncIteratorContinuation(n.apply(this.s,arguments))},throw:function(r){var n=this.s.return;return void 0===n?Promise.reject(r):AsyncFromSyncIteratorContinuation(n.apply(this.s,arguments))}},new AsyncFromSyncIterator(r)}'),
    awaitAsyncGenerator: $81f605b366a4aa81$var$helper("7.0.0-beta.0", 'import OverloadYield from"OverloadYield";export default function _awaitAsyncGenerator(e){return new OverloadYield(e,0)}'),
    callSuper: $81f605b366a4aa81$var$helper("7.23.8", 'import getPrototypeOf from"getPrototypeOf";import isNativeReflectConstruct from"isNativeReflectConstruct";import possibleConstructorReturn from"possibleConstructorReturn";export default function _callSuper(t,o,e){return o=getPrototypeOf(o),possibleConstructorReturn(t,isNativeReflectConstruct()?Reflect.construct(o,e||[],getPrototypeOf(t).constructor):o.apply(t,e))}'),
    checkInRHS: $81f605b366a4aa81$var$helper("7.20.5", 'export default function _checkInRHS(e){if(Object(e)!==e)throw TypeError("right-hand side of \'in\' should be an object, got "+(null!==e?typeof e:"null"));return e}'),
    classPrivateFieldGet2: $81f605b366a4aa81$var$helper("7.24.0", 'import assertClassBrand from"assertClassBrand";export default function _classPrivateFieldGet2(s,a){return s.get(assertClassBrand(s,a))}'),
    classPrivateFieldSet2: $81f605b366a4aa81$var$helper("7.24.0", 'import assertClassBrand from"assertClassBrand";export default function _classPrivateFieldSet2(s,a,r){return s.set(assertClassBrand(s,a),r),r}'),
    classPrivateGetter: $81f605b366a4aa81$var$helper("7.24.0", 'import assertClassBrand from"assertClassBrand";export default function _classPrivateGetter(s,r,a){return a(assertClassBrand(s,r))}'),
    classPrivateSetter: $81f605b366a4aa81$var$helper("7.24.0", 'import assertClassBrand from"assertClassBrand";export default function _classPrivateSetter(s,r,a,t){return r(assertClassBrand(s,a),t),t}'),
    construct: $81f605b366a4aa81$var$helper("7.0.0-beta.0", 'import setPrototypeOf from"setPrototypeOf";import isNativeReflectConstruct from"isNativeReflectConstruct";export default function _construct(t,e,r){if(isNativeReflectConstruct())return Reflect.construct.apply(null,arguments);var o=[null];o.push.apply(o,e);var p=new(t.bind.apply(t,o));return r&&setPrototypeOf(p,r.prototype),p}'),
    defineAccessor: $81f605b366a4aa81$var$helper("7.20.7", "export default function _defineAccessor(e,r,n,t){var c={configurable:!0,enumerable:!0};return c[e]=t,Object.defineProperty(r,n,c)}"),
    dispose: $81f605b366a4aa81$var$helper("7.22.0", 'function dispose_SuppressedError(r,e){return"undefined"!=typeof SuppressedError?dispose_SuppressedError=SuppressedError:(dispose_SuppressedError=function(r,e){this.suppressed=e,this.error=r,this.stack=Error().stack},dispose_SuppressedError.prototype=Object.create(Error.prototype,{constructor:{value:dispose_SuppressedError,writable:!0,configurable:!0}})),new dispose_SuppressedError(r,e)}export default function _dispose(r,e,s){function next(){for(;r.length>0;)try{var o=r.pop(),p=o.d.call(o.v);if(o.a)return Promise.resolve(p).then(next,err)}catch(r){return err(r)}if(s)throw e}function err(r){return e=s?new dispose_SuppressedError(e,r):r,s=!0,next()}return next()}'),
    importDeferProxy: $81f605b366a4aa81$var$helper("7.23.0", "export default function _importDeferProxy(e){var t=null,constValue=function(e){return function(){return e}},proxy=function(r){return function(n,o,f){return null===t&&(t=e()),r(t,o,f)}};return new Proxy({},{defineProperty:constValue(!1),deleteProperty:constValue(!1),get:proxy(Reflect.get),getOwnPropertyDescriptor:proxy(Reflect.getOwnPropertyDescriptor),getPrototypeOf:constValue(null),isExtensible:constValue(!1),has:proxy(Reflect.has),ownKeys:proxy(Reflect.ownKeys),preventExtensions:constValue(!0),set:constValue(!1),setPrototypeOf:constValue(!1)})}"),
    interopRequireWildcard: $81f605b366a4aa81$var$helper("7.14.0", 'function _getRequireWildcardCache(e){if("function"!=typeof WeakMap)return null;var r=new WeakMap,t=new WeakMap;return(_getRequireWildcardCache=function(e){return e?t:r})(e)}export default function _interopRequireWildcard(e,r){if(!r&&e&&e.__esModule)return e;if(null===e||"object"!=typeof e&&"function"!=typeof e)return{default:e};var t=_getRequireWildcardCache(r);if(t&&t.has(e))return t.get(e);var n={__proto__:null},a=Object.defineProperty&&Object.getOwnPropertyDescriptor;for(var u in e)if("default"!==u&&{}.hasOwnProperty.call(e,u)){var i=a?Object.getOwnPropertyDescriptor(e,u):null;i&&(i.get||i.set)?Object.defineProperty(n,u,i):n[u]=e[u]}return n.default=e,t&&t.set(e,n),n}'),
    isNativeReflectConstruct: $81f605b366a4aa81$var$helper("7.9.0", "export default function _isNativeReflectConstruct(){try{var t=!Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){})))}catch(t){}return(_isNativeReflectConstruct=function(){return!!t})()}"),
    iterableToArrayLimit: $81f605b366a4aa81$var$helper("7.0.0-beta.0", 'export default function _iterableToArrayLimit(r,l){var t=null==r?null:"undefined"!=typeof Symbol&&r[Symbol.iterator]||r["@@iterator"];if(null!=t){var e,n,i,u,a=[],f=!0,o=!1;try{if(i=(t=t.call(r)).next,0===l){if(Object(t)!==t)return;f=!1}else for(;!(f=(e=i.call(t)).done)&&(a.push(e.value),a.length!==l);f=!0);}catch(r){o=!0,n=r}finally{try{if(!f&&null!=t.return&&(u=t.return(),Object(u)!==u))return}finally{if(o)throw n}}return a}}'),
    iterableToArrayLimitLoose: $81f605b366a4aa81$var$helper("7.0.0-beta.0", 'export default function _iterableToArrayLimitLoose(e,r){var t=e&&("undefined"!=typeof Symbol&&e[Symbol.iterator]||e["@@iterator"]);if(null!=t){var o,l=[];for(t=t.call(e);e.length<r&&!(o=t.next()).done;)l.push(o.value);return l}}'),
    jsx: $81f605b366a4aa81$var$helper("7.0.0-beta.0", 'var REACT_ELEMENT_TYPE;export default function _createRawReactElement(e,r,E,l){REACT_ELEMENT_TYPE||(REACT_ELEMENT_TYPE="function"==typeof Symbol&&Symbol.for&&Symbol.for("react.element")||60103);var o=e&&e.defaultProps,n=arguments.length-3;if(r||0===n||(r={children:void 0}),1===n)r.children=l;else if(n>1){for(var t=Array(n),f=0;f<n;f++)t[f]=arguments[f+3];r.children=t}if(r&&o)for(var i in o)void 0===r[i]&&(r[i]=o[i]);else r||(r=o||{});return{$$typeof:REACT_ELEMENT_TYPE,type:e,key:void 0===E?null:""+E,ref:null,props:r,_owner:null}}'),
    objectSpread2: $81f605b366a4aa81$var$helper("7.5.0", 'import defineProperty from"defineProperty";function ownKeys(e,r){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var o=Object.getOwnPropertySymbols(e);r&&(o=o.filter((function(r){return Object.getOwnPropertyDescriptor(e,r).enumerable}))),t.push.apply(t,o)}return t}export default function _objectSpread2(e){for(var r=1;r<arguments.length;r++){var t=null!=arguments[r]?arguments[r]:{};r%2?ownKeys(Object(t),!0).forEach((function(r){defineProperty(e,r,t[r])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):ownKeys(Object(t)).forEach((function(r){Object.defineProperty(e,r,Object.getOwnPropertyDescriptor(t,r))}))}return e}'),
    regeneratorRuntime: $81f605b366a4aa81$var$helper("7.18.0", 'export default function _regeneratorRuntime(){"use strict";\n/*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */_regeneratorRuntime=function(){return e};var t,e={},r=Object.prototype,n=r.hasOwnProperty,o=Object.defineProperty||function(t,e,r){t[e]=r.value},i="function"==typeof Symbol?Symbol:{},a=i.iterator||"@@iterator",c=i.asyncIterator||"@@asyncIterator",u=i.toStringTag||"@@toStringTag";function define(t,e,r){return Object.defineProperty(t,e,{value:r,enumerable:!0,configurable:!0,writable:!0}),t[e]}try{define({},"")}catch(t){define=function(t,e,r){return t[e]=r}}function wrap(t,e,r,n){var i=e&&e.prototype instanceof Generator?e:Generator,a=Object.create(i.prototype),c=new Context(n||[]);return o(a,"_invoke",{value:makeInvokeMethod(t,r,c)}),a}function tryCatch(t,e,r){try{return{type:"normal",arg:t.call(e,r)}}catch(t){return{type:"throw",arg:t}}}e.wrap=wrap;var h="suspendedStart",l="suspendedYield",f="executing",s="completed",y={};function Generator(){}function GeneratorFunction(){}function GeneratorFunctionPrototype(){}var p={};define(p,a,(function(){return this}));var d=Object.getPrototypeOf,v=d&&d(d(values([])));v&&v!==r&&n.call(v,a)&&(p=v);var g=GeneratorFunctionPrototype.prototype=Generator.prototype=Object.create(p);function defineIteratorMethods(t){["next","throw","return"].forEach((function(e){define(t,e,(function(t){return this._invoke(e,t)}))}))}function AsyncIterator(t,e){function invoke(r,o,i,a){var c=tryCatch(t[r],t,o);if("throw"!==c.type){var u=c.arg,h=u.value;return h&&"object"==typeof h&&n.call(h,"__await")?e.resolve(h.__await).then((function(t){invoke("next",t,i,a)}),(function(t){invoke("throw",t,i,a)})):e.resolve(h).then((function(t){u.value=t,i(u)}),(function(t){return invoke("throw",t,i,a)}))}a(c.arg)}var r;o(this,"_invoke",{value:function(t,n){function callInvokeWithMethodAndArg(){return new e((function(e,r){invoke(t,n,e,r)}))}return r=r?r.then(callInvokeWithMethodAndArg,callInvokeWithMethodAndArg):callInvokeWithMethodAndArg()}})}function makeInvokeMethod(e,r,n){var o=h;return function(i,a){if(o===f)throw Error("Generator is already running");if(o===s){if("throw"===i)throw a;return{value:t,done:!0}}for(n.method=i,n.arg=a;;){var c=n.delegate;if(c){var u=maybeInvokeDelegate(c,n);if(u){if(u===y)continue;return u}}if("next"===n.method)n.sent=n._sent=n.arg;else if("throw"===n.method){if(o===h)throw o=s,n.arg;n.dispatchException(n.arg)}else"return"===n.method&&n.abrupt("return",n.arg);o=f;var p=tryCatch(e,r,n);if("normal"===p.type){if(o=n.done?s:l,p.arg===y)continue;return{value:p.arg,done:n.done}}"throw"===p.type&&(o=s,n.method="throw",n.arg=p.arg)}}}function maybeInvokeDelegate(e,r){var n=r.method,o=e.iterator[n];if(o===t)return r.delegate=null,"throw"===n&&e.iterator.return&&(r.method="return",r.arg=t,maybeInvokeDelegate(e,r),"throw"===r.method)||"return"!==n&&(r.method="throw",r.arg=new TypeError("The iterator does not provide a \'"+n+"\' method")),y;var i=tryCatch(o,e.iterator,r.arg);if("throw"===i.type)return r.method="throw",r.arg=i.arg,r.delegate=null,y;var a=i.arg;return a?a.done?(r[e.resultName]=a.value,r.next=e.nextLoc,"return"!==r.method&&(r.method="next",r.arg=t),r.delegate=null,y):a:(r.method="throw",r.arg=new TypeError("iterator result is not an object"),r.delegate=null,y)}function pushTryEntry(t){var e={tryLoc:t[0]};1 in t&&(e.catchLoc=t[1]),2 in t&&(e.finallyLoc=t[2],e.afterLoc=t[3]),this.tryEntries.push(e)}function resetTryEntry(t){var e=t.completion||{};e.type="normal",delete e.arg,t.completion=e}function Context(t){this.tryEntries=[{tryLoc:"root"}],t.forEach(pushTryEntry,this),this.reset(!0)}function values(e){if(e||""===e){var r=e[a];if(r)return r.call(e);if("function"==typeof e.next)return e;if(!isNaN(e.length)){var o=-1,i=function next(){for(;++o<e.length;)if(n.call(e,o))return next.value=e[o],next.done=!1,next;return next.value=t,next.done=!0,next};return i.next=i}}throw new TypeError(typeof e+" is not iterable")}return GeneratorFunction.prototype=GeneratorFunctionPrototype,o(g,"constructor",{value:GeneratorFunctionPrototype,configurable:!0}),o(GeneratorFunctionPrototype,"constructor",{value:GeneratorFunction,configurable:!0}),GeneratorFunction.displayName=define(GeneratorFunctionPrototype,u,"GeneratorFunction"),e.isGeneratorFunction=function(t){var e="function"==typeof t&&t.constructor;return!!e&&(e===GeneratorFunction||"GeneratorFunction"===(e.displayName||e.name))},e.mark=function(t){return Object.setPrototypeOf?Object.setPrototypeOf(t,GeneratorFunctionPrototype):(t.__proto__=GeneratorFunctionPrototype,define(t,u,"GeneratorFunction")),t.prototype=Object.create(g),t},e.awrap=function(t){return{__await:t}},defineIteratorMethods(AsyncIterator.prototype),define(AsyncIterator.prototype,c,(function(){return this})),e.AsyncIterator=AsyncIterator,e.async=function(t,r,n,o,i){void 0===i&&(i=Promise);var a=new AsyncIterator(wrap(t,r,n,o),i);return e.isGeneratorFunction(r)?a:a.next().then((function(t){return t.done?t.value:a.next()}))},defineIteratorMethods(g),define(g,u,"Generator"),define(g,a,(function(){return this})),define(g,"toString",(function(){return"[object Generator]"})),e.keys=function(t){var e=Object(t),r=[];for(var n in e)r.push(n);return r.reverse(),function next(){for(;r.length;){var t=r.pop();if(t in e)return next.value=t,next.done=!1,next}return next.done=!0,next}},e.values=values,Context.prototype={constructor:Context,reset:function(e){if(this.prev=0,this.next=0,this.sent=this._sent=t,this.done=!1,this.delegate=null,this.method="next",this.arg=t,this.tryEntries.forEach(resetTryEntry),!e)for(var r in this)"t"===r.charAt(0)&&n.call(this,r)&&!isNaN(+r.slice(1))&&(this[r]=t)},stop:function(){this.done=!0;var t=this.tryEntries[0].completion;if("throw"===t.type)throw t.arg;return this.rval},dispatchException:function(e){if(this.done)throw e;var r=this;function handle(n,o){return a.type="throw",a.arg=e,r.next=n,o&&(r.method="next",r.arg=t),!!o}for(var o=this.tryEntries.length-1;o>=0;--o){var i=this.tryEntries[o],a=i.completion;if("root"===i.tryLoc)return handle("end");if(i.tryLoc<=this.prev){var c=n.call(i,"catchLoc"),u=n.call(i,"finallyLoc");if(c&&u){if(this.prev<i.catchLoc)return handle(i.catchLoc,!0);if(this.prev<i.finallyLoc)return handle(i.finallyLoc)}else if(c){if(this.prev<i.catchLoc)return handle(i.catchLoc,!0)}else{if(!u)throw Error("try statement without catch or finally");if(this.prev<i.finallyLoc)return handle(i.finallyLoc)}}}},abrupt:function(t,e){for(var r=this.tryEntries.length-1;r>=0;--r){var o=this.tryEntries[r];if(o.tryLoc<=this.prev&&n.call(o,"finallyLoc")&&this.prev<o.finallyLoc){var i=o;break}}i&&("break"===t||"continue"===t)&&i.tryLoc<=e&&e<=i.finallyLoc&&(i=null);var a=i?i.completion:{};return a.type=t,a.arg=e,i?(this.method="next",this.next=i.finallyLoc,y):this.complete(a)},complete:function(t,e){if("throw"===t.type)throw t.arg;return"break"===t.type||"continue"===t.type?this.next=t.arg:"return"===t.type?(this.rval=this.arg=t.arg,this.method="return",this.next="end"):"normal"===t.type&&e&&(this.next=e),y},finish:function(t){for(var e=this.tryEntries.length-1;e>=0;--e){var r=this.tryEntries[e];if(r.finallyLoc===t)return this.complete(r.completion,r.afterLoc),resetTryEntry(r),y}},catch:function(t){for(var e=this.tryEntries.length-1;e>=0;--e){var r=this.tryEntries[e];if(r.tryLoc===t){var n=r.completion;if("throw"===n.type){var o=n.arg;resetTryEntry(r)}return o}}throw Error("illegal catch attempt")},delegateYield:function(e,r,n){return this.delegate={iterator:values(e),resultName:r,nextLoc:n},"next"===this.method&&(this.arg=t),y}},e}'),
    setFunctionName: $81f605b366a4aa81$var$helper("7.23.6", 'export default function setFunctionName(e,t,n){"symbol"==typeof t&&(t=(t=t.description)?"["+t+"]":"");try{Object.defineProperty(e,"name",{configurable:!0,value:n?n+" "+t:t})}catch(e){}return e}'),
    toPrimitive: $81f605b366a4aa81$var$helper("7.1.5", 'export default function toPrimitive(t,r){if("object"!=typeof t||!t)return t;var e=t[Symbol.toPrimitive];if(void 0!==e){var i=e.call(t,r||"default");if("object"!=typeof i)return i;throw new TypeError("@@toPrimitive must return a primitive value.")}return("string"===r?String:Number)(t)}'),
    toPropertyKey: $81f605b366a4aa81$var$helper("7.1.5", 'import toPrimitive from"toPrimitive";export default function toPropertyKey(t){var i=toPrimitive(t,"string");return"symbol"==typeof i?i:i+""}'),
    toSetter: $81f605b366a4aa81$var$helper("7.24.0", 'export default function _toSetter(t,e,n){e||(e=[]);var r=e.length++;return Object.defineProperty({},"_",{set:function(o){e[r]=o,t.apply(n,e)}})}'),
    typeof: $81f605b366a4aa81$var$helper("7.0.0-beta.0", 'export default function _typeof(o){"@babel/helpers - typeof";return _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(o){return typeof o}:function(o){return o&&"function"==typeof Symbol&&o.constructor===Symbol&&o!==Symbol.prototype?"symbol":typeof o},_typeof(o)}'),
    using: $81f605b366a4aa81$var$helper("7.22.0", 'export default function _using(o,n,e){if(null==n)return n;if(Object(n)!==n)throw new TypeError("using declarations can only be used with objects, functions, null, or undefined.");if(e)var r=n[Symbol.asyncDispose||Symbol.for("Symbol.asyncDispose")];if(null==r&&(r=n[Symbol.dispose||Symbol.for("Symbol.dispose")]),"function"!=typeof r)throw new TypeError("Property [Symbol.dispose] is not a function.");return o.push({v:n,d:r,a:e}),n}'),
    usingCtx: $81f605b366a4aa81$var$helper("7.23.9", 'export default function _usingCtx(){var r="function"==typeof SuppressedError?SuppressedError:function(r,n){var e=Error();return e.name="SuppressedError",e.suppressed=n,e.error=r,e},n={},e=[];function using(r,n){if(null!=n){if(Object(n)!==n)throw new TypeError("using declarations can only be used with objects, functions, null, or undefined.");if(r)var o=n[Symbol.asyncDispose||Symbol.for("Symbol.asyncDispose")];if(null==o&&(o=n[Symbol.dispose||Symbol.for("Symbol.dispose")]),"function"!=typeof o)throw new TypeError("Property [Symbol.dispose] is not a function.");e.push({v:n,d:o,a:r})}return n}return{e:n,u:using.bind(null,!1),a:using.bind(null,!0),d:function(){var o=this.e;function next(){for(;r=e.pop();)try{var r,t=r.d.call(r.v);if(r.a)return Promise.resolve(t).then(next,err)}catch(r){return err(r)}if(o!==n)throw o}function err(e){return o=o!==n?new r(o,e):e,next()}return next()}}}'),
    wrapRegExp: $81f605b366a4aa81$var$helper("7.19.0", 'import setPrototypeOf from"setPrototypeOf";import inherits from"inherits";export default function _wrapRegExp(){_wrapRegExp=function(e,r){return new BabelRegExp(e,void 0,r)};var e=RegExp.prototype,r=new WeakMap;function BabelRegExp(e,t,p){var o=RegExp(e,t);return r.set(o,p||r.get(e)),setPrototypeOf(o,BabelRegExp.prototype)}function buildGroups(e,t){var p=r.get(t);return Object.keys(p).reduce((function(r,t){var o=p[t];if("number"==typeof o)r[t]=e[o];else{for(var i=0;void 0===e[o[i]]&&i+1<o.length;)i++;r[t]=e[o[i]]}return r}),Object.create(null))}return inherits(BabelRegExp,RegExp),BabelRegExp.prototype.exec=function(r){var t=e.exec.call(this,r);if(t){t.groups=buildGroups(t,this);var p=t.indices;p&&(p.groups=buildGroups(p,this))}return t},BabelRegExp.prototype[Symbol.replace]=function(t,p){if("string"==typeof p){var o=r.get(this);return e[Symbol.replace].call(this,t,p.replace(/\\$<([^>]+)>/g,(function(e,r){var t=o[r];return"$"+(Array.isArray(t)?t.join("$"):t)})))}if("function"==typeof p){var i=this;return e[Symbol.replace].call(this,t,(function(){var e=arguments;return"object"!=typeof e[e.length-1]&&(e=[].slice.call(e)).push(buildGroups(e,i)),p.apply(this,e)}))}return e[Symbol.replace].call(this,t,p)},_wrapRegExp.apply(this,arguments)}')
});

});



parcelRegister("dRFU1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "buildDynamicImport", {
    enumerable: true,
    get: function() {
        return $fJot2.buildDynamicImport;
    }
});
module.exports.buildNamespaceInitStatements = $a180ba9626c4cfa2$var$buildNamespaceInitStatements;
module.exports.ensureStatementsHoisted = $a180ba9626c4cfa2$var$ensureStatementsHoisted;
Object.defineProperty(module.exports, "getModuleName", {
    enumerable: true,
    get: function() {
        return $hEMlx.default;
    }
});
Object.defineProperty(module.exports, "hasExports", {
    enumerable: true,
    get: function() {
        return $7DKf9.hasExports;
    }
});
Object.defineProperty(module.exports, "isModule", {
    enumerable: true,
    get: function() {
        return $ePJIL.isModule;
    }
});
Object.defineProperty(module.exports, "isSideEffectImport", {
    enumerable: true,
    get: function() {
        return $7DKf9.isSideEffectImport;
    }
});
module.exports.rewriteModuleStatementsAndPrepareHeader = $a180ba9626c4cfa2$var$rewriteModuleStatementsAndPrepareHeader;
Object.defineProperty(module.exports, "rewriteThis", {
    enumerable: true,
    get: function() {
        return $hnZgL.default;
    }
});
module.exports.wrapInterop = $a180ba9626c4cfa2$var$wrapInterop;

var $aLUwE = parcelRequire("aLUwE");

var $7Ockm = parcelRequire("7Ockm");

var $ePJIL = parcelRequire("ePJIL");

var $hnZgL = parcelRequire("hnZgL");

var $hNWIx = parcelRequire("hNWIx");

var $7DKf9 = parcelRequire("7DKf9");

var $d4P5f = parcelRequire("d4P5f");

var $fJot2 = parcelRequire("fJot2");

var $hEMlx = parcelRequire("hEMlx");
const { booleanLiteral: $a180ba9626c4cfa2$var$booleanLiteral, callExpression: $a180ba9626c4cfa2$var$callExpression, cloneNode: $a180ba9626c4cfa2$var$cloneNode, directive: $a180ba9626c4cfa2$var$directive, directiveLiteral: $a180ba9626c4cfa2$var$directiveLiteral, expressionStatement: $a180ba9626c4cfa2$var$expressionStatement, identifier: $a180ba9626c4cfa2$var$identifier, isIdentifier: $a180ba9626c4cfa2$var$isIdentifier, memberExpression: $a180ba9626c4cfa2$var$memberExpression, stringLiteral: $a180ba9626c4cfa2$var$stringLiteral, valueToNode: $a180ba9626c4cfa2$var$valueToNode, variableDeclaration: $a180ba9626c4cfa2$var$variableDeclaration, variableDeclarator: $a180ba9626c4cfa2$var$variableDeclarator } = $7Ockm.types;

module.exports.getDynamicImportSource = (parcelRequire("fJot2")).getDynamicImportSource;
function $a180ba9626c4cfa2$var$rewriteModuleStatementsAndPrepareHeader(path, { exportName: exportName, strict: strict, allowTopLevelThis: allowTopLevelThis, strictMode: strictMode, noInterop: noInterop, importInterop: importInterop = noInterop ? "none" : "babel", lazy: lazy, getWrapperPayload: getWrapperPayload = $d4P5f.toGetWrapperPayload(lazy != null ? lazy : false), wrapReference: wrapReference = $d4P5f.wrapReference, esNamespaceOnly: esNamespaceOnly, filename: filename, constantReexports: constantReexports = arguments[1].loose, enumerableModuleMeta: enumerableModuleMeta = arguments[1].loose, noIncompleteNsImportDetection: noIncompleteNsImportDetection }) {
    (0, $7DKf9.validateImportInteropOption)(importInterop);
    $aLUwE((0, $ePJIL.isModule)(path), "Cannot process module statements in a script");
    path.node.sourceType = "script";
    const meta = (0, $7DKf9.default)(path, exportName, {
        importInterop: importInterop,
        initializeReexports: constantReexports,
        getWrapperPayload: getWrapperPayload,
        esNamespaceOnly: esNamespaceOnly,
        filename: filename
    });
    if (!allowTopLevelThis) (0, $hnZgL.default)(path);
    (0, $hNWIx.default)(path, meta, wrapReference);
    if (strictMode !== false) {
        const hasStrict = path.node.directives.some((directive)=>{
            return directive.value.value === "use strict";
        });
        if (!hasStrict) path.unshiftContainer("directives", $a180ba9626c4cfa2$var$directive($a180ba9626c4cfa2$var$directiveLiteral("use strict")));
    }
    const headers = [];
    if ((0, $7DKf9.hasExports)(meta) && !strict) headers.push($a180ba9626c4cfa2$var$buildESModuleHeader(meta, enumerableModuleMeta));
    const nameList = $a180ba9626c4cfa2$var$buildExportNameListDeclaration(path, meta);
    if (nameList) {
        meta.exportNameListName = nameList.name;
        headers.push(nameList.statement);
    }
    headers.push(...$a180ba9626c4cfa2$var$buildExportInitializationStatements(path, meta, wrapReference, constantReexports, noIncompleteNsImportDetection));
    return {
        meta: meta,
        headers: headers
    };
}
function $a180ba9626c4cfa2$var$ensureStatementsHoisted(statements) {
    statements.forEach((header)=>{
        header._blockHoist = 3;
    });
}
function $a180ba9626c4cfa2$var$wrapInterop(programPath, expr, type) {
    if (type === "none") return null;
    if (type === "node-namespace") return $a180ba9626c4cfa2$var$callExpression(programPath.hub.addHelper("interopRequireWildcard"), [
        expr,
        $a180ba9626c4cfa2$var$booleanLiteral(true)
    ]);
    else if (type === "node-default") return null;
    let helper;
    if (type === "default") helper = "interopRequireDefault";
    else if (type === "namespace") helper = "interopRequireWildcard";
    else throw new Error(`Unknown interop: ${type}`);
    return $a180ba9626c4cfa2$var$callExpression(programPath.hub.addHelper(helper), [
        expr
    ]);
}
function $a180ba9626c4cfa2$var$buildNamespaceInitStatements(metadata, sourceMetadata, constantReexports = false, wrapReference = $d4P5f.wrapReference) {
    var _wrapReference;
    const statements = [];
    const srcNamespaceId = $a180ba9626c4cfa2$var$identifier(sourceMetadata.name);
    for (const localName of sourceMetadata.importsNamespace){
        if (localName === sourceMetadata.name) continue;
        statements.push($7Ockm.template.statement`var NAME = SOURCE;`({
            NAME: localName,
            SOURCE: $a180ba9626c4cfa2$var$cloneNode(srcNamespaceId)
        }));
    }
    const srcNamespace = (_wrapReference = wrapReference(srcNamespaceId, sourceMetadata.wrap)) != null ? _wrapReference : srcNamespaceId;
    if (constantReexports) statements.push(...$a180ba9626c4cfa2$var$buildReexportsFromMeta(metadata, sourceMetadata, true, wrapReference));
    for (const exportName of sourceMetadata.reexportNamespace)statements.push((!$7Ockm.types.isIdentifier(srcNamespace) ? $7Ockm.template.statement`
            Object.defineProperty(EXPORTS, "NAME", {
              enumerable: true,
              get: function() {
                return NAMESPACE;
              }
            });
          ` : $7Ockm.template.statement`EXPORTS.NAME = NAMESPACE;`)({
        EXPORTS: metadata.exportName,
        NAME: exportName,
        NAMESPACE: $a180ba9626c4cfa2$var$cloneNode(srcNamespace)
    }));
    if (sourceMetadata.reexportAll) {
        const statement = $a180ba9626c4cfa2$var$buildNamespaceReexport(metadata, $a180ba9626c4cfa2$var$cloneNode(srcNamespace), constantReexports);
        statement.loc = sourceMetadata.reexportAll.loc;
        statements.push(statement);
    }
    return statements;
}
const $a180ba9626c4cfa2$var$ReexportTemplate = {
    constant: $7Ockm.template.statement`EXPORTS.EXPORT_NAME = NAMESPACE_IMPORT;`,
    constantComputed: $7Ockm.template.statement`EXPORTS["EXPORT_NAME"] = NAMESPACE_IMPORT;`,
    spec: $7Ockm.template.statement`
    Object.defineProperty(EXPORTS, "EXPORT_NAME", {
      enumerable: true,
      get: function() {
        return NAMESPACE_IMPORT;
      },
    });
    `
};
function $a180ba9626c4cfa2$var$buildReexportsFromMeta(meta, metadata, constantReexports, wrapReference) {
    var _wrapReference2;
    let namespace = $a180ba9626c4cfa2$var$identifier(metadata.name);
    namespace = (_wrapReference2 = wrapReference(namespace, metadata.wrap)) != null ? _wrapReference2 : namespace;
    const { stringSpecifiers: stringSpecifiers } = meta;
    return Array.from(metadata.reexports, ([exportName, importName])=>{
        let NAMESPACE_IMPORT = $a180ba9626c4cfa2$var$cloneNode(namespace);
        if (importName === "default" && metadata.interop === "node-default") ;
        else if (stringSpecifiers.has(importName)) NAMESPACE_IMPORT = $a180ba9626c4cfa2$var$memberExpression(NAMESPACE_IMPORT, $a180ba9626c4cfa2$var$stringLiteral(importName), true);
        else NAMESPACE_IMPORT = $a180ba9626c4cfa2$var$memberExpression(NAMESPACE_IMPORT, $a180ba9626c4cfa2$var$identifier(importName));
        const astNodes = {
            EXPORTS: meta.exportName,
            EXPORT_NAME: exportName,
            NAMESPACE_IMPORT: NAMESPACE_IMPORT
        };
        if (constantReexports || $a180ba9626c4cfa2$var$isIdentifier(NAMESPACE_IMPORT)) {
            if (stringSpecifiers.has(exportName)) return $a180ba9626c4cfa2$var$ReexportTemplate.constantComputed(astNodes);
            else return $a180ba9626c4cfa2$var$ReexportTemplate.constant(astNodes);
        } else return $a180ba9626c4cfa2$var$ReexportTemplate.spec(astNodes);
    });
}
function $a180ba9626c4cfa2$var$buildESModuleHeader(metadata, enumerableModuleMeta = false) {
    return (enumerableModuleMeta ? $7Ockm.template.statement`
        EXPORTS.__esModule = true;
      ` : $7Ockm.template.statement`
        Object.defineProperty(EXPORTS, "__esModule", {
          value: true,
        });
      `)({
        EXPORTS: metadata.exportName
    });
}
function $a180ba9626c4cfa2$var$buildNamespaceReexport(metadata, namespace, constantReexports) {
    return (constantReexports ? $7Ockm.template.statement`
        Object.keys(NAMESPACE).forEach(function(key) {
          if (key === "default" || key === "__esModule") return;
          VERIFY_NAME_LIST;
          if (key in EXPORTS && EXPORTS[key] === NAMESPACE[key]) return;

          EXPORTS[key] = NAMESPACE[key];
        });
      ` : $7Ockm.template.statement`
        Object.keys(NAMESPACE).forEach(function(key) {
          if (key === "default" || key === "__esModule") return;
          VERIFY_NAME_LIST;
          if (key in EXPORTS && EXPORTS[key] === NAMESPACE[key]) return;

          Object.defineProperty(EXPORTS, key, {
            enumerable: true,
            get: function() {
              return NAMESPACE[key];
            },
          });
        });
    `)({
        NAMESPACE: namespace,
        EXPORTS: metadata.exportName,
        VERIFY_NAME_LIST: metadata.exportNameListName ? (0, $7Ockm.template)`
            if (Object.prototype.hasOwnProperty.call(EXPORTS_LIST, key)) return;
          `({
            EXPORTS_LIST: metadata.exportNameListName
        }) : null
    });
}
function $a180ba9626c4cfa2$var$buildExportNameListDeclaration(programPath, metadata) {
    const exportedVars = Object.create(null);
    for (const data of metadata.local.values())for (const name of data.names)exportedVars[name] = true;
    let hasReexport = false;
    for (const data of metadata.source.values()){
        for (const exportName of data.reexports.keys())exportedVars[exportName] = true;
        for (const exportName of data.reexportNamespace)exportedVars[exportName] = true;
        hasReexport = hasReexport || !!data.reexportAll;
    }
    if (!hasReexport || Object.keys(exportedVars).length === 0) return null;
    const name = programPath.scope.generateUidIdentifier("exportNames");
    delete exportedVars.default;
    return {
        name: name.name,
        statement: $a180ba9626c4cfa2$var$variableDeclaration("var", [
            $a180ba9626c4cfa2$var$variableDeclarator(name, $a180ba9626c4cfa2$var$valueToNode(exportedVars))
        ])
    };
}
function $a180ba9626c4cfa2$var$buildExportInitializationStatements(programPath, metadata, wrapReference, constantReexports = false, noIncompleteNsImportDetection = false) {
    const initStatements = [];
    for (const [localName, data] of metadata.local){
        if (data.kind === "import") ;
        else if (data.kind === "hoisted") initStatements.push([
            data.names[0],
            $a180ba9626c4cfa2$var$buildInitStatement(metadata, data.names, $a180ba9626c4cfa2$var$identifier(localName))
        ]);
        else if (!noIncompleteNsImportDetection) for (const exportName of data.names)initStatements.push([
            exportName,
            null
        ]);
    }
    for (const data of metadata.source.values()){
        if (!constantReexports) {
            const reexportsStatements = $a180ba9626c4cfa2$var$buildReexportsFromMeta(metadata, data, false, wrapReference);
            const reexports = [
                ...data.reexports.keys()
            ];
            for(let i = 0; i < reexportsStatements.length; i++)initStatements.push([
                reexports[i],
                reexportsStatements[i]
            ]);
        }
        if (!noIncompleteNsImportDetection) for (const exportName of data.reexportNamespace)initStatements.push([
            exportName,
            null
        ]);
    }
    initStatements.sort(([a], [b])=>{
        if (a < b) return -1;
        if (b < a) return 1;
        return 0;
    });
    const results = [];
    if (noIncompleteNsImportDetection) for (const [, initStatement] of initStatements)results.push(initStatement);
    else {
        const chunkSize = 100;
        for(let i = 0; i < initStatements.length; i += chunkSize){
            let uninitializedExportNames = [];
            for(let j = 0; j < chunkSize && i + j < initStatements.length; j++){
                const [exportName, initStatement] = initStatements[i + j];
                if (initStatement !== null) {
                    if (uninitializedExportNames.length > 0) {
                        results.push($a180ba9626c4cfa2$var$buildInitStatement(metadata, uninitializedExportNames, programPath.scope.buildUndefinedNode()));
                        uninitializedExportNames = [];
                    }
                    results.push(initStatement);
                } else uninitializedExportNames.push(exportName);
            }
            if (uninitializedExportNames.length > 0) results.push($a180ba9626c4cfa2$var$buildInitStatement(metadata, uninitializedExportNames, programPath.scope.buildUndefinedNode()));
        }
    }
    return results;
}
const $a180ba9626c4cfa2$var$InitTemplate = {
    computed: $7Ockm.template.expression`EXPORTS["NAME"] = VALUE`,
    default: $7Ockm.template.expression`EXPORTS.NAME = VALUE`,
    define: $7Ockm.template.expression`Object.defineProperty(EXPORTS, "NAME", { enumerable:true, value: void 0, writable: true })["NAME"] = VALUE`
};
function $a180ba9626c4cfa2$var$buildInitStatement(metadata, exportNames, initExpr) {
    const { stringSpecifiers: stringSpecifiers, exportName: EXPORTS } = metadata;
    return $a180ba9626c4cfa2$var$expressionStatement(exportNames.reduce((acc, exportName)=>{
        const params = {
            EXPORTS: EXPORTS,
            NAME: exportName,
            VALUE: acc
        };
        if (exportName === "__proto__") return $a180ba9626c4cfa2$var$InitTemplate.define(params);
        if (stringSpecifiers.has(exportName)) return $a180ba9626c4cfa2$var$InitTemplate.computed(params);
        return $a180ba9626c4cfa2$var$InitTemplate.default(params);
    }, initExpr));
}

});
parcelRegister("aLUwE", function(module, exports) {
// Currently in sync with Node.js lib/assert.js
// https://github.com/nodejs/node/commit/2a51ae424a513ec9a6aa3466baa0cc1d55dd4f3b
// Originally from narwhal.js (http://narwhaljs.org)
// Copyright (c) 2009 Thomas Robinson <280north.com>
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the 'Software'), to
// deal in the Software without restriction, including without limitation the
// rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
// sell copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
// ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
// WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

var $hPtJY = parcelRequire("hPtJY");
"use strict";
function $7d7a23f7babfddb7$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $7d7a23f7babfddb7$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $7d7a23f7babfddb7$var$_typeof(o);
}
function $7d7a23f7babfddb7$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $7d7a23f7babfddb7$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $7d7a23f7babfddb7$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $7d7a23f7babfddb7$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $7d7a23f7babfddb7$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $7d7a23f7babfddb7$var$_toPropertyKey(arg) {
    var key = $7d7a23f7babfddb7$var$_toPrimitive(arg, "string");
    return $7d7a23f7babfddb7$var$_typeof(key) === "symbol" ? key : String(key);
}
function $7d7a23f7babfddb7$var$_toPrimitive(input, hint) {
    if ($7d7a23f7babfddb7$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($7d7a23f7babfddb7$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $7d7a23f7babfddb7$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

var $cCihK = parcelRequire("cCihK");
var $7d7a23f7babfddb7$var$_require$codes = $cCihK.codes, $7d7a23f7babfddb7$var$ERR_AMBIGUOUS_ARGUMENT = $7d7a23f7babfddb7$var$_require$codes.ERR_AMBIGUOUS_ARGUMENT, $7d7a23f7babfddb7$var$ERR_INVALID_ARG_TYPE = $7d7a23f7babfddb7$var$_require$codes.ERR_INVALID_ARG_TYPE, $7d7a23f7babfddb7$var$ERR_INVALID_ARG_VALUE = $7d7a23f7babfddb7$var$_require$codes.ERR_INVALID_ARG_VALUE, $7d7a23f7babfddb7$var$ERR_INVALID_RETURN_VALUE = $7d7a23f7babfddb7$var$_require$codes.ERR_INVALID_RETURN_VALUE, $7d7a23f7babfddb7$var$ERR_MISSING_ARGS = $7d7a23f7babfddb7$var$_require$codes.ERR_MISSING_ARGS;

var $8pS6q = parcelRequire("8pS6q");

var $N7Lcz = parcelRequire("N7Lcz");
var $7d7a23f7babfddb7$var$inspect = $N7Lcz.inspect;

var $N7Lcz = parcelRequire("N7Lcz");
var $7d7a23f7babfddb7$require$_require$types = $N7Lcz.types;
var $7d7a23f7babfddb7$var$isPromise = $7d7a23f7babfddb7$require$_require$types.isPromise, $7d7a23f7babfddb7$var$isRegExp = $7d7a23f7babfddb7$require$_require$types.isRegExp;

var $7d7a23f7babfddb7$var$objectAssign = (parcelRequire("boX8x"))();

var $7d7a23f7babfddb7$var$objectIs = (parcelRequire("5SxoI"))();

var $7d7a23f7babfddb7$var$RegExpPrototypeTest = (parcelRequire("hXu6F"))("RegExp.prototype.test");
var $7d7a23f7babfddb7$var$errorCache = new Map();
var $7d7a23f7babfddb7$var$isDeepEqual;
var $7d7a23f7babfddb7$var$isDeepStrictEqual;
var $7d7a23f7babfddb7$var$parseExpressionAt;
var $7d7a23f7babfddb7$var$findNodeAround;
var $7d7a23f7babfddb7$var$decoder;

function $7d7a23f7babfddb7$var$lazyLoadComparison() {
    var comparison = (parcelRequire("3LKhK"));
    $7d7a23f7babfddb7$var$isDeepEqual = comparison.isDeepEqual;
    $7d7a23f7babfddb7$var$isDeepStrictEqual = comparison.isDeepStrictEqual;
}
// Escape control characters but not \n and \t to keep the line breaks and
// indentation intact.
// eslint-disable-next-line no-control-regex
var $7d7a23f7babfddb7$var$escapeSequencesRegExp = /[\x00-\x08\x0b\x0c\x0e-\x1f]/g;
var $7d7a23f7babfddb7$var$meta = [
    "\\u0000",
    "\\u0001",
    "\\u0002",
    "\\u0003",
    "\\u0004",
    "\\u0005",
    "\\u0006",
    "\\u0007",
    "\\b",
    "",
    "",
    "\\u000b",
    "\\f",
    "",
    "\\u000e",
    "\\u000f",
    "\\u0010",
    "\\u0011",
    "\\u0012",
    "\\u0013",
    "\\u0014",
    "\\u0015",
    "\\u0016",
    "\\u0017",
    "\\u0018",
    "\\u0019",
    "\\u001a",
    "\\u001b",
    "\\u001c",
    "\\u001d",
    "\\u001e",
    "\\u001f"
];
var $7d7a23f7babfddb7$var$escapeFn = function escapeFn(str) {
    return $7d7a23f7babfddb7$var$meta[str.charCodeAt(0)];
};
var $7d7a23f7babfddb7$var$warned = false;
// The assert module provides functions that throw
// AssertionError's when particular conditions are not met. The
// assert module must conform to the following interface.
var $7d7a23f7babfddb7$var$assert = module.exports = $7d7a23f7babfddb7$var$ok;
var $7d7a23f7babfddb7$var$NO_EXCEPTION_SENTINEL = {};
// All of the following functions must throw an AssertionError
// when a corresponding condition is not met, with a message that
// may be undefined if not provided. All assertion methods provide
// both the actual and expected values to the assertion error for
// display purposes.
function $7d7a23f7babfddb7$var$innerFail(obj) {
    if (obj.message instanceof Error) throw obj.message;
    throw new $8pS6q(obj);
}
function $7d7a23f7babfddb7$var$fail(actual, expected, message, operator, stackStartFn) {
    var argsLen = arguments.length;
    var internalMessage;
    if (argsLen === 0) internalMessage = "Failed";
    else if (argsLen === 1) {
        message = actual;
        actual = undefined;
    } else {
        if ($7d7a23f7babfddb7$var$warned === false) {
            $7d7a23f7babfddb7$var$warned = true;
            var warn = $hPtJY.emitWarning ? $hPtJY.emitWarning : console.warn.bind(console);
            warn("assert.fail() with more than one argument is deprecated. Please use assert.strictEqual() instead or only pass a message.", "DeprecationWarning", "DEP0094");
        }
        if (argsLen === 2) operator = "!=";
    }
    if (message instanceof Error) throw message;
    var errArgs = {
        actual: actual,
        expected: expected,
        operator: operator === undefined ? "fail" : operator,
        stackStartFn: stackStartFn || $7d7a23f7babfddb7$var$fail
    };
    if (message !== undefined) errArgs.message = message;
    var err = new $8pS6q(errArgs);
    if (internalMessage) {
        err.message = internalMessage;
        err.generatedMessage = true;
    }
    throw err;
}
$7d7a23f7babfddb7$var$assert.fail = $7d7a23f7babfddb7$var$fail;
// The AssertionError is defined in internal/error.
$7d7a23f7babfddb7$var$assert.AssertionError = $8pS6q;
function $7d7a23f7babfddb7$var$innerOk(fn, argLen, value, message) {
    if (!value) {
        var generatedMessage = false;
        if (argLen === 0) {
            generatedMessage = true;
            message = "No value argument passed to `assert.ok()`";
        } else if (message instanceof Error) throw message;
        var err = new $8pS6q({
            actual: value,
            expected: true,
            message: message,
            operator: "==",
            stackStartFn: fn
        });
        err.generatedMessage = generatedMessage;
        throw err;
    }
}
// Pure assertion tests whether a value is truthy, as determined
// by !!value.
function $7d7a23f7babfddb7$var$ok() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    $7d7a23f7babfddb7$var$innerOk.apply(void 0, [
        $7d7a23f7babfddb7$var$ok,
        args.length
    ].concat(args));
}
$7d7a23f7babfddb7$var$assert.ok = $7d7a23f7babfddb7$var$ok;
// The equality assertion tests shallow, coercive equality with ==.
/* eslint-disable no-restricted-properties */ $7d7a23f7babfddb7$var$assert.equal = function equal(actual, expected, message) {
    if (arguments.length < 2) throw new $7d7a23f7babfddb7$var$ERR_MISSING_ARGS("actual", "expected");
    // eslint-disable-next-line eqeqeq
    if (actual != expected) $7d7a23f7babfddb7$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: "==",
        stackStartFn: equal
    });
};
// The non-equality assertion tests for whether two objects are not
// equal with !=.
$7d7a23f7babfddb7$var$assert.notEqual = function notEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $7d7a23f7babfddb7$var$ERR_MISSING_ARGS("actual", "expected");
    // eslint-disable-next-line eqeqeq
    if (actual == expected) $7d7a23f7babfddb7$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: "!=",
        stackStartFn: notEqual
    });
};
// The equivalence assertion tests a deep equality relation.
$7d7a23f7babfddb7$var$assert.deepEqual = function deepEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $7d7a23f7babfddb7$var$ERR_MISSING_ARGS("actual", "expected");
    if ($7d7a23f7babfddb7$var$isDeepEqual === undefined) $7d7a23f7babfddb7$var$lazyLoadComparison();
    if (!$7d7a23f7babfddb7$var$isDeepEqual(actual, expected)) $7d7a23f7babfddb7$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: "deepEqual",
        stackStartFn: deepEqual
    });
};
// The non-equivalence assertion tests for any deep inequality.
$7d7a23f7babfddb7$var$assert.notDeepEqual = function notDeepEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $7d7a23f7babfddb7$var$ERR_MISSING_ARGS("actual", "expected");
    if ($7d7a23f7babfddb7$var$isDeepEqual === undefined) $7d7a23f7babfddb7$var$lazyLoadComparison();
    if ($7d7a23f7babfddb7$var$isDeepEqual(actual, expected)) $7d7a23f7babfddb7$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: "notDeepEqual",
        stackStartFn: notDeepEqual
    });
};
/* eslint-enable */ $7d7a23f7babfddb7$var$assert.deepStrictEqual = function deepStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $7d7a23f7babfddb7$var$ERR_MISSING_ARGS("actual", "expected");
    if ($7d7a23f7babfddb7$var$isDeepEqual === undefined) $7d7a23f7babfddb7$var$lazyLoadComparison();
    if (!$7d7a23f7babfddb7$var$isDeepStrictEqual(actual, expected)) $7d7a23f7babfddb7$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: "deepStrictEqual",
        stackStartFn: deepStrictEqual
    });
};
$7d7a23f7babfddb7$var$assert.notDeepStrictEqual = $7d7a23f7babfddb7$var$notDeepStrictEqual;
function $7d7a23f7babfddb7$var$notDeepStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $7d7a23f7babfddb7$var$ERR_MISSING_ARGS("actual", "expected");
    if ($7d7a23f7babfddb7$var$isDeepEqual === undefined) $7d7a23f7babfddb7$var$lazyLoadComparison();
    if ($7d7a23f7babfddb7$var$isDeepStrictEqual(actual, expected)) $7d7a23f7babfddb7$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: "notDeepStrictEqual",
        stackStartFn: $7d7a23f7babfddb7$var$notDeepStrictEqual
    });
}
$7d7a23f7babfddb7$var$assert.strictEqual = function strictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $7d7a23f7babfddb7$var$ERR_MISSING_ARGS("actual", "expected");
    if (!$7d7a23f7babfddb7$var$objectIs(actual, expected)) $7d7a23f7babfddb7$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: "strictEqual",
        stackStartFn: strictEqual
    });
};
$7d7a23f7babfddb7$var$assert.notStrictEqual = function notStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $7d7a23f7babfddb7$var$ERR_MISSING_ARGS("actual", "expected");
    if ($7d7a23f7babfddb7$var$objectIs(actual, expected)) $7d7a23f7babfddb7$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: "notStrictEqual",
        stackStartFn: notStrictEqual
    });
};
var $7d7a23f7babfddb7$var$Comparison = /*#__PURE__*/ $7d7a23f7babfddb7$var$_createClass(function Comparison(obj, keys, actual) {
    var _this = this;
    $7d7a23f7babfddb7$var$_classCallCheck(this, Comparison);
    keys.forEach(function(key) {
        if (key in obj) {
            if (actual !== undefined && typeof actual[key] === "string" && $7d7a23f7babfddb7$var$isRegExp(obj[key]) && $7d7a23f7babfddb7$var$RegExpPrototypeTest(obj[key], actual[key])) _this[key] = actual[key];
            else _this[key] = obj[key];
        }
    });
});
function $7d7a23f7babfddb7$var$compareExceptionKey(actual, expected, key, message, keys, fn) {
    if (!(key in actual) || !$7d7a23f7babfddb7$var$isDeepStrictEqual(actual[key], expected[key])) {
        if (!message) {
            // Create placeholder objects to create a nice output.
            var a = new $7d7a23f7babfddb7$var$Comparison(actual, keys);
            var b = new $7d7a23f7babfddb7$var$Comparison(expected, keys, actual);
            var err = new $8pS6q({
                actual: a,
                expected: b,
                operator: "deepStrictEqual",
                stackStartFn: fn
            });
            err.actual = actual;
            err.expected = expected;
            err.operator = fn.name;
            throw err;
        }
        $7d7a23f7babfddb7$var$innerFail({
            actual: actual,
            expected: expected,
            message: message,
            operator: fn.name,
            stackStartFn: fn
        });
    }
}
function $7d7a23f7babfddb7$var$expectedException(actual, expected, msg, fn) {
    if (typeof expected !== "function") {
        if ($7d7a23f7babfddb7$var$isRegExp(expected)) return $7d7a23f7babfddb7$var$RegExpPrototypeTest(expected, actual);
        // assert.doesNotThrow does not accept objects.
        if (arguments.length === 2) throw new $7d7a23f7babfddb7$var$ERR_INVALID_ARG_TYPE("expected", [
            "Function",
            "RegExp"
        ], expected);
        // Handle primitives properly.
        if ($7d7a23f7babfddb7$var$_typeof(actual) !== "object" || actual === null) {
            var err = new $8pS6q({
                actual: actual,
                expected: expected,
                message: msg,
                operator: "deepStrictEqual",
                stackStartFn: fn
            });
            err.operator = fn.name;
            throw err;
        }
        var keys = Object.keys(expected);
        // Special handle errors to make sure the name and the message are compared
        // as well.
        if (expected instanceof Error) keys.push("name", "message");
        else if (keys.length === 0) throw new $7d7a23f7babfddb7$var$ERR_INVALID_ARG_VALUE("error", expected, "may not be an empty object");
        if ($7d7a23f7babfddb7$var$isDeepEqual === undefined) $7d7a23f7babfddb7$var$lazyLoadComparison();
        keys.forEach(function(key) {
            if (typeof actual[key] === "string" && $7d7a23f7babfddb7$var$isRegExp(expected[key]) && $7d7a23f7babfddb7$var$RegExpPrototypeTest(expected[key], actual[key])) return;
            $7d7a23f7babfddb7$var$compareExceptionKey(actual, expected, key, msg, keys, fn);
        });
        return true;
    }
    // Guard instanceof against arrow functions as they don't have a prototype.
    if (expected.prototype !== undefined && actual instanceof expected) return true;
    if (Error.isPrototypeOf(expected)) return false;
    return expected.call({}, actual) === true;
}
function $7d7a23f7babfddb7$var$getActual(fn) {
    if (typeof fn !== "function") throw new $7d7a23f7babfddb7$var$ERR_INVALID_ARG_TYPE("fn", "Function", fn);
    try {
        fn();
    } catch (e) {
        return e;
    }
    return $7d7a23f7babfddb7$var$NO_EXCEPTION_SENTINEL;
}
function $7d7a23f7babfddb7$var$checkIsPromise(obj) {
    // Accept native ES6 promises and promises that are implemented in a similar
    // way. Do not accept thenables that use a function as `obj` and that have no
    // `catch` handler.
    // TODO: thenables are checked up until they have the correct methods,
    // but according to documentation, the `then` method should receive
    // the `fulfill` and `reject` arguments as well or it may be never resolved.
    return $7d7a23f7babfddb7$var$isPromise(obj) || obj !== null && $7d7a23f7babfddb7$var$_typeof(obj) === "object" && typeof obj.then === "function" && typeof obj.catch === "function";
}
function $7d7a23f7babfddb7$var$waitForActual(promiseFn) {
    return Promise.resolve().then(function() {
        var resultPromise;
        if (typeof promiseFn === "function") {
            // Return a rejected promise if `promiseFn` throws synchronously.
            resultPromise = promiseFn();
            // Fail in case no promise is returned.
            if (!$7d7a23f7babfddb7$var$checkIsPromise(resultPromise)) throw new $7d7a23f7babfddb7$var$ERR_INVALID_RETURN_VALUE("instance of Promise", "promiseFn", resultPromise);
        } else if ($7d7a23f7babfddb7$var$checkIsPromise(promiseFn)) resultPromise = promiseFn;
        else throw new $7d7a23f7babfddb7$var$ERR_INVALID_ARG_TYPE("promiseFn", [
            "Function",
            "Promise"
        ], promiseFn);
        return Promise.resolve().then(function() {
            return resultPromise;
        }).then(function() {
            return $7d7a23f7babfddb7$var$NO_EXCEPTION_SENTINEL;
        }).catch(function(e) {
            return e;
        });
    });
}
function $7d7a23f7babfddb7$var$expectsError(stackStartFn, actual, error, message) {
    if (typeof error === "string") {
        if (arguments.length === 4) throw new $7d7a23f7babfddb7$var$ERR_INVALID_ARG_TYPE("error", [
            "Object",
            "Error",
            "Function",
            "RegExp"
        ], error);
        if ($7d7a23f7babfddb7$var$_typeof(actual) === "object" && actual !== null) {
            if (actual.message === error) throw new $7d7a23f7babfddb7$var$ERR_AMBIGUOUS_ARGUMENT("error/message", 'The error message "'.concat(actual.message, '" is identical to the message.'));
        } else if (actual === error) throw new $7d7a23f7babfddb7$var$ERR_AMBIGUOUS_ARGUMENT("error/message", 'The error "'.concat(actual, '" is identical to the message.'));
        message = error;
        error = undefined;
    } else if (error != null && $7d7a23f7babfddb7$var$_typeof(error) !== "object" && typeof error !== "function") throw new $7d7a23f7babfddb7$var$ERR_INVALID_ARG_TYPE("error", [
        "Object",
        "Error",
        "Function",
        "RegExp"
    ], error);
    if (actual === $7d7a23f7babfddb7$var$NO_EXCEPTION_SENTINEL) {
        var details = "";
        if (error && error.name) details += " (".concat(error.name, ")");
        details += message ? ": ".concat(message) : ".";
        var fnType = stackStartFn.name === "rejects" ? "rejection" : "exception";
        $7d7a23f7babfddb7$var$innerFail({
            actual: undefined,
            expected: error,
            operator: stackStartFn.name,
            message: "Missing expected ".concat(fnType).concat(details),
            stackStartFn: stackStartFn
        });
    }
    if (error && !$7d7a23f7babfddb7$var$expectedException(actual, error, message, stackStartFn)) throw actual;
}
function $7d7a23f7babfddb7$var$expectsNoError(stackStartFn, actual, error, message) {
    if (actual === $7d7a23f7babfddb7$var$NO_EXCEPTION_SENTINEL) return;
    if (typeof error === "string") {
        message = error;
        error = undefined;
    }
    if (!error || $7d7a23f7babfddb7$var$expectedException(actual, error)) {
        var details = message ? ": ".concat(message) : ".";
        var fnType = stackStartFn.name === "doesNotReject" ? "rejection" : "exception";
        $7d7a23f7babfddb7$var$innerFail({
            actual: actual,
            expected: error,
            operator: stackStartFn.name,
            message: "Got unwanted ".concat(fnType).concat(details, "\n") + 'Actual message: "'.concat(actual && actual.message, '"'),
            stackStartFn: stackStartFn
        });
    }
    throw actual;
}
$7d7a23f7babfddb7$var$assert.throws = function throws(promiseFn) {
    for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
    $7d7a23f7babfddb7$var$expectsError.apply(void 0, [
        throws,
        $7d7a23f7babfddb7$var$getActual(promiseFn)
    ].concat(args));
};
$7d7a23f7babfddb7$var$assert.rejects = function rejects(promiseFn) {
    for(var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)args[_key3 - 1] = arguments[_key3];
    return $7d7a23f7babfddb7$var$waitForActual(promiseFn).then(function(result) {
        return $7d7a23f7babfddb7$var$expectsError.apply(void 0, [
            rejects,
            result
        ].concat(args));
    });
};
$7d7a23f7babfddb7$var$assert.doesNotThrow = function doesNotThrow(fn) {
    for(var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)args[_key4 - 1] = arguments[_key4];
    $7d7a23f7babfddb7$var$expectsNoError.apply(void 0, [
        doesNotThrow,
        $7d7a23f7babfddb7$var$getActual(fn)
    ].concat(args));
};
$7d7a23f7babfddb7$var$assert.doesNotReject = function doesNotReject(fn) {
    for(var _len5 = arguments.length, args = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++)args[_key5 - 1] = arguments[_key5];
    return $7d7a23f7babfddb7$var$waitForActual(fn).then(function(result) {
        return $7d7a23f7babfddb7$var$expectsNoError.apply(void 0, [
            doesNotReject,
            result
        ].concat(args));
    });
};
$7d7a23f7babfddb7$var$assert.ifError = function ifError(err) {
    if (err !== null && err !== undefined) {
        var message = "ifError got unwanted exception: ";
        if ($7d7a23f7babfddb7$var$_typeof(err) === "object" && typeof err.message === "string") {
            if (err.message.length === 0 && err.constructor) message += err.constructor.name;
            else message += err.message;
        } else message += $7d7a23f7babfddb7$var$inspect(err);
        var newErr = new $8pS6q({
            actual: err,
            expected: null,
            operator: "ifError",
            message: message,
            stackStartFn: ifError
        });
        // Make sure we actually have a stack trace!
        var origStack = err.stack;
        if (typeof origStack === "string") {
            // This will remove any duplicated frames from the error frames taken
            // from within `ifError` and add the original error frames to the newly
            // created ones.
            var tmp2 = origStack.split("\n");
            tmp2.shift();
            // Filter all frames existing in err.stack.
            var tmp1 = newErr.stack.split("\n");
            for(var i = 0; i < tmp2.length; i++){
                // Find the first occurrence of the frame.
                var pos = tmp1.indexOf(tmp2[i]);
                if (pos !== -1) {
                    // Only keep new frames.
                    tmp1 = tmp1.slice(0, pos);
                    break;
                }
            }
            newErr.stack = "".concat(tmp1.join("\n"), "\n").concat(tmp2.join("\n"));
        }
        throw newErr;
    }
};
// Currently in sync with Node.js lib/assert.js
// https://github.com/nodejs/node/commit/2a871df3dfb8ea663ef5e1f8f62701ec51384ecb
function $7d7a23f7babfddb7$var$internalMatch(string, regexp, message, fn, fnName) {
    if (!$7d7a23f7babfddb7$var$isRegExp(regexp)) throw new $7d7a23f7babfddb7$var$ERR_INVALID_ARG_TYPE("regexp", "RegExp", regexp);
    var match = fnName === "match";
    if (typeof string !== "string" || $7d7a23f7babfddb7$var$RegExpPrototypeTest(regexp, string) !== match) {
        if (message instanceof Error) throw message;
        var generatedMessage = !message;
        // 'The input was expected to not match the regular expression ' +
        message = message || (typeof string !== "string" ? 'The "string" argument must be of type string. Received type ' + "".concat($7d7a23f7babfddb7$var$_typeof(string), " (").concat($7d7a23f7babfddb7$var$inspect(string), ")") : (match ? "The input did not match the regular expression " : "The input was expected to not match the regular expression ") + "".concat($7d7a23f7babfddb7$var$inspect(regexp), ". Input:\n\n").concat($7d7a23f7babfddb7$var$inspect(string), "\n"));
        var err = new $8pS6q({
            actual: string,
            expected: regexp,
            message: message,
            operator: fnName,
            stackStartFn: fn
        });
        err.generatedMessage = generatedMessage;
        throw err;
    }
}
$7d7a23f7babfddb7$var$assert.match = function match(string, regexp, message) {
    $7d7a23f7babfddb7$var$internalMatch(string, regexp, message, match, "match");
};
$7d7a23f7babfddb7$var$assert.doesNotMatch = function doesNotMatch(string, regexp, message) {
    $7d7a23f7babfddb7$var$internalMatch(string, regexp, message, doesNotMatch, "doesNotMatch");
};
// Expose a strict only variant of assert
function $7d7a23f7babfddb7$var$strict() {
    for(var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++)args[_key6] = arguments[_key6];
    $7d7a23f7babfddb7$var$innerOk.apply(void 0, [
        $7d7a23f7babfddb7$var$strict,
        args.length
    ].concat(args));
}
$7d7a23f7babfddb7$var$assert.strict = $7d7a23f7babfddb7$var$objectAssign($7d7a23f7babfddb7$var$strict, $7d7a23f7babfddb7$var$assert, {
    equal: $7d7a23f7babfddb7$var$assert.strictEqual,
    deepEqual: $7d7a23f7babfddb7$var$assert.deepStrictEqual,
    notEqual: $7d7a23f7babfddb7$var$assert.notStrictEqual,
    notDeepEqual: $7d7a23f7babfddb7$var$assert.notDeepStrictEqual
});
$7d7a23f7babfddb7$var$assert.strict.strict = $7d7a23f7babfddb7$var$assert.strict;

});
parcelRegister("cCihK", function(module, exports) {

$parcel$export(module.exports, "codes", () => $92f737b1c63f6b54$export$e45cb6485273080e, (v) => $92f737b1c63f6b54$export$e45cb6485273080e = v);
// Currently in sync with Node.js lib/internal/errors.js
// https://github.com/nodejs/node/commit/3b044962c48fe313905877a96b5d0894a5404f6f
/* eslint node-core/documented-errors: "error" */ /* eslint node-core/alphabetize-errors: "error" */ /* eslint node-core/prefer-util-format-errors: "error" */ var $92f737b1c63f6b54$export$e45cb6485273080e;
"use strict";
// The whole point behind this internal module is to allow Node.js to no
// longer be forced to treat every error message change as a semver-major
// change. The NodeError classes here all expose a `code` property whose
// value statically and permanently identifies the error. While the error
// message may change, the code should not.
function $92f737b1c63f6b54$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $92f737b1c63f6b54$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $92f737b1c63f6b54$var$_typeof(o);
}
function $92f737b1c63f6b54$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $92f737b1c63f6b54$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $92f737b1c63f6b54$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $92f737b1c63f6b54$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $92f737b1c63f6b54$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $92f737b1c63f6b54$var$_toPropertyKey(arg) {
    var key = $92f737b1c63f6b54$var$_toPrimitive(arg, "string");
    return $92f737b1c63f6b54$var$_typeof(key) === "symbol" ? key : String(key);
}
function $92f737b1c63f6b54$var$_toPrimitive(input, hint) {
    if ($92f737b1c63f6b54$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($92f737b1c63f6b54$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $92f737b1c63f6b54$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $92f737b1c63f6b54$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $92f737b1c63f6b54$var$_setPrototypeOf(subClass, superClass);
}
function $92f737b1c63f6b54$var$_setPrototypeOf(o, p) {
    $92f737b1c63f6b54$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $92f737b1c63f6b54$var$_setPrototypeOf(o, p);
}
function $92f737b1c63f6b54$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $92f737b1c63f6b54$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $92f737b1c63f6b54$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $92f737b1c63f6b54$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $92f737b1c63f6b54$var$_possibleConstructorReturn(this, result);
    };
}
function $92f737b1c63f6b54$var$_possibleConstructorReturn(self, call) {
    if (call && ($92f737b1c63f6b54$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $92f737b1c63f6b54$var$_assertThisInitialized(self);
}
function $92f737b1c63f6b54$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $92f737b1c63f6b54$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $92f737b1c63f6b54$var$_getPrototypeOf(o) {
    $92f737b1c63f6b54$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $92f737b1c63f6b54$var$_getPrototypeOf(o);
}
var $92f737b1c63f6b54$var$codes = {};
// Lazy loaded
var $92f737b1c63f6b54$var$assert;
var $92f737b1c63f6b54$var$util;
function $92f737b1c63f6b54$var$createErrorType(code, message, Base) {
    if (!Base) Base = Error;
    function getMessage(arg1, arg2, arg3) {
        if (typeof message === "string") return message;
        else return message(arg1, arg2, arg3);
    }
    var NodeError = /*#__PURE__*/ function(_Base) {
        $92f737b1c63f6b54$var$_inherits(NodeError, _Base);
        var _super = $92f737b1c63f6b54$var$_createSuper(NodeError);
        function NodeError(arg1, arg2, arg3) {
            var _this;
            $92f737b1c63f6b54$var$_classCallCheck(this, NodeError);
            _this = _super.call(this, getMessage(arg1, arg2, arg3));
            _this.code = code;
            return _this;
        }
        return $92f737b1c63f6b54$var$_createClass(NodeError);
    }(Base);
    $92f737b1c63f6b54$var$codes[code] = NodeError;
}
// https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
function $92f737b1c63f6b54$var$oneOf(expected, thing) {
    if (Array.isArray(expected)) {
        var len = expected.length;
        expected = expected.map(function(i) {
            return String(i);
        });
        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(", "), ", or ") + expected[len - 1];
        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
        else return "of ".concat(thing, " ").concat(expected[0]);
    } else return "of ".concat(thing, " ").concat(String(expected));
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
function $92f737b1c63f6b54$var$startsWith(str, search, pos) {
    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $92f737b1c63f6b54$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
function $92f737b1c63f6b54$var$includes(str, search, start) {
    if (typeof start !== "number") start = 0;
    if (start + search.length > str.length) return false;
    else return str.indexOf(search, start) !== -1;
}
$92f737b1c63f6b54$var$createErrorType("ERR_AMBIGUOUS_ARGUMENT", 'The "%s" argument is ambiguous. %s', TypeError);

$92f737b1c63f6b54$var$createErrorType("ERR_INVALID_ARG_TYPE", function(name, expected, actual) {
    if ($92f737b1c63f6b54$var$assert === undefined) $92f737b1c63f6b54$var$assert = (parcelRequire("aLUwE"));
    $92f737b1c63f6b54$var$assert(typeof name === "string", "'name' must be a string");
    // determiner: 'must be' or 'must not be'
    var determiner;
    if (typeof expected === "string" && $92f737b1c63f6b54$var$startsWith(expected, "not ")) {
        determiner = "must not be";
        expected = expected.replace(/^not /, "");
    } else determiner = "must be";
    var msg;
    if ($92f737b1c63f6b54$var$endsWith(name, " argument")) // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat($92f737b1c63f6b54$var$oneOf(expected, "type"));
    else {
        var type = $92f737b1c63f6b54$var$includes(name, ".") ? "property" : "argument";
        msg = 'The "'.concat(name, '" ').concat(type, " ").concat(determiner, " ").concat($92f737b1c63f6b54$var$oneOf(expected, "type"));
    }
    // TODO(BridgeAR): Improve the output by showing `null` and similar.
    msg += ". Received type ".concat($92f737b1c63f6b54$var$_typeof(actual));
    return msg;
}, TypeError);

$92f737b1c63f6b54$var$createErrorType("ERR_INVALID_ARG_VALUE", function(name, value) {
    var reason = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "is invalid";
    if ($92f737b1c63f6b54$var$util === undefined) $92f737b1c63f6b54$var$util = (parcelRequire("N7Lcz"));
    var inspected = $92f737b1c63f6b54$var$util.inspect(value);
    if (inspected.length > 128) inspected = "".concat(inspected.slice(0, 128), "...");
    return "The argument '".concat(name, "' ").concat(reason, ". Received ").concat(inspected);
}, TypeError, RangeError);
$92f737b1c63f6b54$var$createErrorType("ERR_INVALID_RETURN_VALUE", function(input, name, value) {
    var type;
    if (value && value.constructor && value.constructor.name) type = "instance of ".concat(value.constructor.name);
    else type = "type ".concat($92f737b1c63f6b54$var$_typeof(value));
    return "Expected ".concat(input, ' to be returned from the "').concat(name, '"') + " function but got ".concat(type, ".");
}, TypeError);

$92f737b1c63f6b54$var$createErrorType("ERR_MISSING_ARGS", function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    if ($92f737b1c63f6b54$var$assert === undefined) $92f737b1c63f6b54$var$assert = (parcelRequire("aLUwE"));
    $92f737b1c63f6b54$var$assert(args.length > 0, "At least one arg needs to be specified");
    var msg = "The ";
    var len = args.length;
    args = args.map(function(a) {
        return '"'.concat(a, '"');
    });
    switch(len){
        case 1:
            msg += "".concat(args[0], " argument");
            break;
        case 2:
            msg += "".concat(args[0], " and ").concat(args[1], " arguments");
            break;
        default:
            msg += args.slice(0, len - 1).join(", ");
            msg += ", and ".concat(args[len - 1], " arguments");
            break;
    }
    return "".concat(msg, " must be specified");
}, TypeError);
$92f737b1c63f6b54$export$e45cb6485273080e = $92f737b1c63f6b54$var$codes;

});
parcelRegister("N7Lcz", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $hPtJY = parcelRequire("hPtJY");
var $093a98c17cb6b6b8$var$getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function getOwnPropertyDescriptors(obj) {
    var keys = Object.keys(obj);
    var descriptors = {};
    for(var i = 0; i < keys.length; i++)descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
    return descriptors;
};
var $093a98c17cb6b6b8$var$formatRegExp = /%[sdj%]/g;
module.exports.format = function(f) {
    if (!$093a98c17cb6b6b8$var$isString(f)) {
        var objects = [];
        for(var i = 0; i < arguments.length; i++)objects.push($093a98c17cb6b6b8$var$inspect(arguments[i]));
        return objects.join(" ");
    }
    var i = 1;
    var args = arguments;
    var len = args.length;
    var str = String(f).replace($093a98c17cb6b6b8$var$formatRegExp, function(x) {
        if (x === "%%") return "%";
        if (i >= len) return x;
        switch(x){
            case "%s":
                return String(args[i++]);
            case "%d":
                return Number(args[i++]);
            case "%j":
                try {
                    return JSON.stringify(args[i++]);
                } catch (_) {
                    return "[Circular]";
                }
            default:
                return x;
        }
    });
    for(var x = args[i]; i < len; x = args[++i])if ($093a98c17cb6b6b8$var$isNull(x) || !$093a98c17cb6b6b8$var$isObject(x)) str += " " + x;
    else str += " " + $093a98c17cb6b6b8$var$inspect(x);
    return str;
};
// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
module.exports.deprecate = function(fn, msg) {
    if (typeof $hPtJY !== "undefined" && $hPtJY.noDeprecation === true) return fn;
    // Allow for deprecating things in the process of starting up.
    if (typeof $hPtJY === "undefined") return function() {
        return module.exports.deprecate(fn, msg).apply(this, arguments);
    };
    var warned = false;
    function deprecated() {
        if (!warned) {
            if ($hPtJY.throwDeprecation) throw new Error(msg);
            else if ($hPtJY.traceDeprecation) console.trace(msg);
            else console.error(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
};
var $093a98c17cb6b6b8$var$debugs = {};
var $093a98c17cb6b6b8$var$debugEnvRegex = /^$/;
var $093a98c17cb6b6b8$var$debugEnv;
module.exports.debuglog = function(set) {
    set = set.toUpperCase();
    if (!$093a98c17cb6b6b8$var$debugs[set]) {
        if ($093a98c17cb6b6b8$var$debugEnvRegex.test(set)) {
            var pid = $hPtJY.pid;
            $093a98c17cb6b6b8$var$debugs[set] = function() {
                var msg = module.exports.format.apply(module.exports, arguments);
                console.error("%s %d: %s", set, pid, msg);
            };
        } else $093a98c17cb6b6b8$var$debugs[set] = function() {};
    }
    return $093a98c17cb6b6b8$var$debugs[set];
};
/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */ /* legacy: obj, showHidden, depth, colors*/ function $093a98c17cb6b6b8$var$inspect(obj, opts) {
    // default options
    var ctx = {
        seen: [],
        stylize: $093a98c17cb6b6b8$var$stylizeNoColor
    };
    // legacy...
    if (arguments.length >= 3) ctx.depth = arguments[2];
    if (arguments.length >= 4) ctx.colors = arguments[3];
    if ($093a98c17cb6b6b8$var$isBoolean(opts)) // legacy...
    ctx.showHidden = opts;
    else if (opts) // got an "options" object
    module.exports._extend(ctx, opts);
    // set default options
    if ($093a98c17cb6b6b8$var$isUndefined(ctx.showHidden)) ctx.showHidden = false;
    if ($093a98c17cb6b6b8$var$isUndefined(ctx.depth)) ctx.depth = 2;
    if ($093a98c17cb6b6b8$var$isUndefined(ctx.colors)) ctx.colors = false;
    if ($093a98c17cb6b6b8$var$isUndefined(ctx.customInspect)) ctx.customInspect = true;
    if (ctx.colors) ctx.stylize = $093a98c17cb6b6b8$var$stylizeWithColor;
    return $093a98c17cb6b6b8$var$formatValue(ctx, obj, ctx.depth);
}
module.exports.inspect = $093a98c17cb6b6b8$var$inspect;
// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
$093a98c17cb6b6b8$var$inspect.colors = {
    "bold": [
        1,
        22
    ],
    "italic": [
        3,
        23
    ],
    "underline": [
        4,
        24
    ],
    "inverse": [
        7,
        27
    ],
    "white": [
        37,
        39
    ],
    "grey": [
        90,
        39
    ],
    "black": [
        30,
        39
    ],
    "blue": [
        34,
        39
    ],
    "cyan": [
        36,
        39
    ],
    "green": [
        32,
        39
    ],
    "magenta": [
        35,
        39
    ],
    "red": [
        31,
        39
    ],
    "yellow": [
        33,
        39
    ]
};
// Don't use 'blue' not visible on cmd.exe
$093a98c17cb6b6b8$var$inspect.styles = {
    "special": "cyan",
    "number": "yellow",
    "boolean": "yellow",
    "undefined": "grey",
    "null": "bold",
    "string": "green",
    "date": "magenta",
    // "name": intentionally not styling
    "regexp": "red"
};
function $093a98c17cb6b6b8$var$stylizeWithColor(str, styleType) {
    var style = $093a98c17cb6b6b8$var$inspect.styles[styleType];
    if (style) return "\x1b[" + $093a98c17cb6b6b8$var$inspect.colors[style][0] + "m" + str + "\x1b[" + $093a98c17cb6b6b8$var$inspect.colors[style][1] + "m";
    else return str;
}
function $093a98c17cb6b6b8$var$stylizeNoColor(str, styleType) {
    return str;
}
function $093a98c17cb6b6b8$var$arrayToHash(array) {
    var hash = {};
    array.forEach(function(val, idx) {
        hash[val] = true;
    });
    return hash;
}
function $093a98c17cb6b6b8$var$formatValue(ctx, value, recurseTimes) {
    // Provide a hook for user-specified inspect functions.
    // Check that value is an object with an inspect function on it
    if (ctx.customInspect && value && $093a98c17cb6b6b8$var$isFunction(value.inspect) && // Filter out the util module, it's inspect function is special
    value.inspect !== module.exports.inspect && // Also filter out any prototype objects using the circular check.
    !(value.constructor && value.constructor.prototype === value)) {
        var ret = value.inspect(recurseTimes, ctx);
        if (!$093a98c17cb6b6b8$var$isString(ret)) ret = $093a98c17cb6b6b8$var$formatValue(ctx, ret, recurseTimes);
        return ret;
    }
    // Primitive types cannot have properties
    var primitive = $093a98c17cb6b6b8$var$formatPrimitive(ctx, value);
    if (primitive) return primitive;
    // Look up the keys of the object.
    var keys = Object.keys(value);
    var visibleKeys = $093a98c17cb6b6b8$var$arrayToHash(keys);
    if (ctx.showHidden) keys = Object.getOwnPropertyNames(value);
    // IE doesn't make error fields non-enumerable
    // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
    if ($093a98c17cb6b6b8$var$isError(value) && (keys.indexOf("message") >= 0 || keys.indexOf("description") >= 0)) return $093a98c17cb6b6b8$var$formatError(value);
    // Some type of object without properties can be shortcutted.
    if (keys.length === 0) {
        if ($093a98c17cb6b6b8$var$isFunction(value)) {
            var name = value.name ? ": " + value.name : "";
            return ctx.stylize("[Function" + name + "]", "special");
        }
        if ($093a98c17cb6b6b8$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), "regexp");
        if ($093a98c17cb6b6b8$var$isDate(value)) return ctx.stylize(Date.prototype.toString.call(value), "date");
        if ($093a98c17cb6b6b8$var$isError(value)) return $093a98c17cb6b6b8$var$formatError(value);
    }
    var base = "", array = false, braces = [
        "{",
        "}"
    ];
    // Make Array say that they are Array
    if ($093a98c17cb6b6b8$var$isArray(value)) {
        array = true;
        braces = [
            "[",
            "]"
        ];
    }
    // Make functions say that they are functions
    if ($093a98c17cb6b6b8$var$isFunction(value)) {
        var n = value.name ? ": " + value.name : "";
        base = " [Function" + n + "]";
    }
    // Make RegExps say that they are RegExps
    if ($093a98c17cb6b6b8$var$isRegExp(value)) base = " " + RegExp.prototype.toString.call(value);
    // Make dates with properties first say the date
    if ($093a98c17cb6b6b8$var$isDate(value)) base = " " + Date.prototype.toUTCString.call(value);
    // Make error with message first say the error
    if ($093a98c17cb6b6b8$var$isError(value)) base = " " + $093a98c17cb6b6b8$var$formatError(value);
    if (keys.length === 0 && (!array || value.length == 0)) return braces[0] + base + braces[1];
    if (recurseTimes < 0) {
        if ($093a98c17cb6b6b8$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), "regexp");
        else return ctx.stylize("[Object]", "special");
    }
    ctx.seen.push(value);
    var output;
    if (array) output = $093a98c17cb6b6b8$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys);
    else output = keys.map(function(key) {
        return $093a98c17cb6b6b8$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
    ctx.seen.pop();
    return $093a98c17cb6b6b8$var$reduceToSingleString(output, base, braces);
}
function $093a98c17cb6b6b8$var$formatPrimitive(ctx, value) {
    if ($093a98c17cb6b6b8$var$isUndefined(value)) return ctx.stylize("undefined", "undefined");
    if ($093a98c17cb6b6b8$var$isString(value)) {
        var simple = "'" + JSON.stringify(value).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
        return ctx.stylize(simple, "string");
    }
    if ($093a98c17cb6b6b8$var$isNumber(value)) return ctx.stylize("" + value, "number");
    if ($093a98c17cb6b6b8$var$isBoolean(value)) return ctx.stylize("" + value, "boolean");
    // For some reason typeof null is "object", so special case here.
    if ($093a98c17cb6b6b8$var$isNull(value)) return ctx.stylize("null", "null");
}
function $093a98c17cb6b6b8$var$formatError(value) {
    return "[" + Error.prototype.toString.call(value) + "]";
}
function $093a98c17cb6b6b8$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
    var output = [];
    for(var i = 0, l = value.length; i < l; ++i)if ($093a98c17cb6b6b8$var$hasOwnProperty(value, String(i))) output.push($093a98c17cb6b6b8$var$formatProperty(ctx, value, recurseTimes, visibleKeys, String(i), true));
    else output.push("");
    keys.forEach(function(key) {
        if (!key.match(/^\d+$/)) output.push($093a98c17cb6b6b8$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, true));
    });
    return output;
}
function $093a98c17cb6b6b8$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
    var name, str, desc;
    desc = Object.getOwnPropertyDescriptor(value, key) || {
        value: value[key]
    };
    if (desc.get) {
        if (desc.set) str = ctx.stylize("[Getter/Setter]", "special");
        else str = ctx.stylize("[Getter]", "special");
    } else if (desc.set) str = ctx.stylize("[Setter]", "special");
    if (!$093a98c17cb6b6b8$var$hasOwnProperty(visibleKeys, key)) name = "[" + key + "]";
    if (!str) {
        if (ctx.seen.indexOf(desc.value) < 0) {
            if ($093a98c17cb6b6b8$var$isNull(recurseTimes)) str = $093a98c17cb6b6b8$var$formatValue(ctx, desc.value, null);
            else str = $093a98c17cb6b6b8$var$formatValue(ctx, desc.value, recurseTimes - 1);
            if (str.indexOf("\n") > -1) {
                if (array) str = str.split("\n").map(function(line) {
                    return "  " + line;
                }).join("\n").slice(2);
                else str = "\n" + str.split("\n").map(function(line) {
                    return "   " + line;
                }).join("\n");
            }
        } else str = ctx.stylize("[Circular]", "special");
    }
    if ($093a98c17cb6b6b8$var$isUndefined(name)) {
        if (array && key.match(/^\d+$/)) return str;
        name = JSON.stringify("" + key);
        if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
            name = name.slice(1, -1);
            name = ctx.stylize(name, "name");
        } else {
            name = name.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'");
            name = ctx.stylize(name, "string");
        }
    }
    return name + ": " + str;
}
function $093a98c17cb6b6b8$var$reduceToSingleString(output, base, braces) {
    var numLinesEst = 0;
    var length = output.reduce(function(prev, cur) {
        numLinesEst++;
        if (cur.indexOf("\n") >= 0) numLinesEst++;
        return prev + cur.replace(/\u001b\[\d\d?m/g, "").length + 1;
    }, 0);
    if (length > 60) return braces[0] + (base === "" ? "" : base + "\n ") + " " + output.join(",\n  ") + " " + braces[1];
    return braces[0] + base + " " + output.join(", ") + " " + braces[1];
}

// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
module.exports.types = (parcelRequire("7He6T"));
function $093a98c17cb6b6b8$var$isArray(ar) {
    return Array.isArray(ar);
}
module.exports.isArray = $093a98c17cb6b6b8$var$isArray;
function $093a98c17cb6b6b8$var$isBoolean(arg) {
    return typeof arg === "boolean";
}
module.exports.isBoolean = $093a98c17cb6b6b8$var$isBoolean;
function $093a98c17cb6b6b8$var$isNull(arg) {
    return arg === null;
}
module.exports.isNull = $093a98c17cb6b6b8$var$isNull;
function $093a98c17cb6b6b8$var$isNullOrUndefined(arg) {
    return arg == null;
}
module.exports.isNullOrUndefined = $093a98c17cb6b6b8$var$isNullOrUndefined;
function $093a98c17cb6b6b8$var$isNumber(arg) {
    return typeof arg === "number";
}
module.exports.isNumber = $093a98c17cb6b6b8$var$isNumber;
function $093a98c17cb6b6b8$var$isString(arg) {
    return typeof arg === "string";
}
module.exports.isString = $093a98c17cb6b6b8$var$isString;
function $093a98c17cb6b6b8$var$isSymbol(arg) {
    return typeof arg === "symbol";
}
module.exports.isSymbol = $093a98c17cb6b6b8$var$isSymbol;
function $093a98c17cb6b6b8$var$isUndefined(arg) {
    return arg === void 0;
}
module.exports.isUndefined = $093a98c17cb6b6b8$var$isUndefined;
function $093a98c17cb6b6b8$var$isRegExp(re) {
    return $093a98c17cb6b6b8$var$isObject(re) && $093a98c17cb6b6b8$var$objectToString(re) === "[object RegExp]";
}
module.exports.isRegExp = $093a98c17cb6b6b8$var$isRegExp;
module.exports.types.isRegExp = $093a98c17cb6b6b8$var$isRegExp;
function $093a98c17cb6b6b8$var$isObject(arg) {
    return typeof arg === "object" && arg !== null;
}
module.exports.isObject = $093a98c17cb6b6b8$var$isObject;
function $093a98c17cb6b6b8$var$isDate(d) {
    return $093a98c17cb6b6b8$var$isObject(d) && $093a98c17cb6b6b8$var$objectToString(d) === "[object Date]";
}
module.exports.isDate = $093a98c17cb6b6b8$var$isDate;
module.exports.types.isDate = $093a98c17cb6b6b8$var$isDate;
function $093a98c17cb6b6b8$var$isError(e) {
    return $093a98c17cb6b6b8$var$isObject(e) && ($093a98c17cb6b6b8$var$objectToString(e) === "[object Error]" || e instanceof Error);
}
module.exports.isError = $093a98c17cb6b6b8$var$isError;
module.exports.types.isNativeError = $093a98c17cb6b6b8$var$isError;
function $093a98c17cb6b6b8$var$isFunction(arg) {
    return typeof arg === "function";
}
module.exports.isFunction = $093a98c17cb6b6b8$var$isFunction;
function $093a98c17cb6b6b8$var$isPrimitive(arg) {
    return arg === null || typeof arg === "boolean" || typeof arg === "number" || typeof arg === "string" || typeof arg === "symbol" || // ES6 symbol
    typeof arg === "undefined";
}
module.exports.isPrimitive = $093a98c17cb6b6b8$var$isPrimitive;

module.exports.isBuffer = (parcelRequire("kotBY"));
function $093a98c17cb6b6b8$var$objectToString(o) {
    return Object.prototype.toString.call(o);
}
function $093a98c17cb6b6b8$var$pad(n) {
    return n < 10 ? "0" + n.toString(10) : n.toString(10);
}
var $093a98c17cb6b6b8$var$months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
// 26 Feb 16:19:34
function $093a98c17cb6b6b8$var$timestamp() {
    var d = new Date();
    var time = [
        $093a98c17cb6b6b8$var$pad(d.getHours()),
        $093a98c17cb6b6b8$var$pad(d.getMinutes()),
        $093a98c17cb6b6b8$var$pad(d.getSeconds())
    ].join(":");
    return [
        d.getDate(),
        $093a98c17cb6b6b8$var$months[d.getMonth()],
        time
    ].join(" ");
}
// log is just a thin wrapper to console.log that prepends a timestamp
module.exports.log = function() {
    console.log("%s - %s", $093a98c17cb6b6b8$var$timestamp(), module.exports.format.apply(module.exports, arguments));
};

/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */ module.exports.inherits = (parcelRequire("dlqwk"));
module.exports._extend = function(origin, add) {
    // Don't do anything if add isn't an object
    if (!add || !$093a98c17cb6b6b8$var$isObject(add)) return origin;
    var keys = Object.keys(add);
    var i = keys.length;
    while(i--)origin[keys[i]] = add[keys[i]];
    return origin;
};
function $093a98c17cb6b6b8$var$hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
var $093a98c17cb6b6b8$var$kCustomPromisifiedSymbol = typeof Symbol !== "undefined" ? Symbol("util.promisify.custom") : undefined;
module.exports.promisify = function promisify(original) {
    if (typeof original !== "function") throw new TypeError('The "original" argument must be of type Function');
    if ($093a98c17cb6b6b8$var$kCustomPromisifiedSymbol && original[$093a98c17cb6b6b8$var$kCustomPromisifiedSymbol]) {
        var fn = original[$093a98c17cb6b6b8$var$kCustomPromisifiedSymbol];
        if (typeof fn !== "function") throw new TypeError('The "util.promisify.custom" argument must be of type Function');
        Object.defineProperty(fn, $093a98c17cb6b6b8$var$kCustomPromisifiedSymbol, {
            value: fn,
            enumerable: false,
            writable: false,
            configurable: true
        });
        return fn;
    }
    function fn() {
        var promiseResolve, promiseReject;
        var promise = new Promise(function(resolve, reject) {
            promiseResolve = resolve;
            promiseReject = reject;
        });
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        args.push(function(err, value) {
            if (err) promiseReject(err);
            else promiseResolve(value);
        });
        try {
            original.apply(this, args);
        } catch (err) {
            promiseReject(err);
        }
        return promise;
    }
    Object.setPrototypeOf(fn, Object.getPrototypeOf(original));
    if ($093a98c17cb6b6b8$var$kCustomPromisifiedSymbol) Object.defineProperty(fn, $093a98c17cb6b6b8$var$kCustomPromisifiedSymbol, {
        value: fn,
        enumerable: false,
        writable: false,
        configurable: true
    });
    return Object.defineProperties(fn, $093a98c17cb6b6b8$var$getOwnPropertyDescriptors(original));
};
module.exports.promisify.custom = $093a98c17cb6b6b8$var$kCustomPromisifiedSymbol;
function $093a98c17cb6b6b8$var$callbackifyOnRejected(reason, cb) {
    // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
    // Because `null` is a special error value in callbacks which means "no error
    // occurred", we error-wrap so the callback consumer can distinguish between
    // "the promise rejected with null" or "the promise fulfilled with undefined".
    if (!reason) {
        var newReason = new Error("Promise was rejected with a falsy value");
        newReason.reason = reason;
        reason = newReason;
    }
    return cb(reason);
}
function $093a98c17cb6b6b8$var$callbackify(original) {
    if (typeof original !== "function") throw new TypeError('The "original" argument must be of type Function');
    // We DO NOT return the promise as it gives the user a false sense that
    // the promise is actually somehow related to the callback's execution
    // and that the callback throwing will reject the promise.
    function callbackified() {
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        var maybeCb = args.pop();
        if (typeof maybeCb !== "function") throw new TypeError("The last argument must be of type Function");
        var self = this;
        var cb = function() {
            return maybeCb.apply(self, arguments);
        };
        // In true node style we process the callback on `nextTick` with all the
        // implications (stack, `uncaughtException`, `async_hooks`)
        original.apply(this, args).then(function(ret) {
            $hPtJY.nextTick(cb.bind(null, null, ret));
        }, function(rej) {
            $hPtJY.nextTick($093a98c17cb6b6b8$var$callbackifyOnRejected.bind(null, rej, cb));
        });
    }
    Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
    Object.defineProperties(callbackified, $093a98c17cb6b6b8$var$getOwnPropertyDescriptors(original));
    return callbackified;
}
module.exports.callbackify = $093a98c17cb6b6b8$var$callbackify;

});
parcelRegister("7He6T", function(module, exports) {
// Currently in sync with Node.js lib/internal/util/types.js
// https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9
"use strict";

var $f4HGZ = parcelRequire("f4HGZ");

var $5WnCa = parcelRequire("5WnCa");

var $gJrpv = parcelRequire("gJrpv");

var $hN833 = parcelRequire("hN833");
function $59a77e8886024a57$var$uncurryThis(f) {
    return f.call.bind(f);
}
var $59a77e8886024a57$var$BigIntSupported = typeof BigInt !== "undefined";
var $59a77e8886024a57$var$SymbolSupported = typeof Symbol !== "undefined";
var $59a77e8886024a57$var$ObjectToString = $59a77e8886024a57$var$uncurryThis(Object.prototype.toString);
var $59a77e8886024a57$var$numberValue = $59a77e8886024a57$var$uncurryThis(Number.prototype.valueOf);
var $59a77e8886024a57$var$stringValue = $59a77e8886024a57$var$uncurryThis(String.prototype.valueOf);
var $59a77e8886024a57$var$booleanValue = $59a77e8886024a57$var$uncurryThis(Boolean.prototype.valueOf);
if ($59a77e8886024a57$var$BigIntSupported) var $59a77e8886024a57$var$bigIntValue = $59a77e8886024a57$var$uncurryThis(BigInt.prototype.valueOf);
if ($59a77e8886024a57$var$SymbolSupported) var $59a77e8886024a57$var$symbolValue = $59a77e8886024a57$var$uncurryThis(Symbol.prototype.valueOf);
function $59a77e8886024a57$var$checkBoxedPrimitive(value, prototypeValueOf) {
    if (typeof value !== "object") return false;
    try {
        prototypeValueOf(value);
        return true;
    } catch (e) {
        return false;
    }
}
module.exports.isArgumentsObject = $f4HGZ;
module.exports.isGeneratorFunction = $5WnCa;
module.exports.isTypedArray = $hN833;
// Taken from here and modified for better browser support
// https://github.com/sindresorhus/p-is-promise/blob/cda35a513bda03f977ad5cde3a079d237e82d7ef/index.js
function $59a77e8886024a57$var$isPromise(input) {
    return typeof Promise !== "undefined" && input instanceof Promise || input !== null && typeof input === "object" && typeof input.then === "function" && typeof input.catch === "function";
}
module.exports.isPromise = $59a77e8886024a57$var$isPromise;
function $59a77e8886024a57$var$isArrayBufferView(value) {
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) return ArrayBuffer.isView(value);
    return $hN833(value) || $59a77e8886024a57$var$isDataView(value);
}
module.exports.isArrayBufferView = $59a77e8886024a57$var$isArrayBufferView;
function $59a77e8886024a57$var$isUint8Array(value) {
    return $gJrpv(value) === "Uint8Array";
}
module.exports.isUint8Array = $59a77e8886024a57$var$isUint8Array;
function $59a77e8886024a57$var$isUint8ClampedArray(value) {
    return $gJrpv(value) === "Uint8ClampedArray";
}
module.exports.isUint8ClampedArray = $59a77e8886024a57$var$isUint8ClampedArray;
function $59a77e8886024a57$var$isUint16Array(value) {
    return $gJrpv(value) === "Uint16Array";
}
module.exports.isUint16Array = $59a77e8886024a57$var$isUint16Array;
function $59a77e8886024a57$var$isUint32Array(value) {
    return $gJrpv(value) === "Uint32Array";
}
module.exports.isUint32Array = $59a77e8886024a57$var$isUint32Array;
function $59a77e8886024a57$var$isInt8Array(value) {
    return $gJrpv(value) === "Int8Array";
}
module.exports.isInt8Array = $59a77e8886024a57$var$isInt8Array;
function $59a77e8886024a57$var$isInt16Array(value) {
    return $gJrpv(value) === "Int16Array";
}
module.exports.isInt16Array = $59a77e8886024a57$var$isInt16Array;
function $59a77e8886024a57$var$isInt32Array(value) {
    return $gJrpv(value) === "Int32Array";
}
module.exports.isInt32Array = $59a77e8886024a57$var$isInt32Array;
function $59a77e8886024a57$var$isFloat32Array(value) {
    return $gJrpv(value) === "Float32Array";
}
module.exports.isFloat32Array = $59a77e8886024a57$var$isFloat32Array;
function $59a77e8886024a57$var$isFloat64Array(value) {
    return $gJrpv(value) === "Float64Array";
}
module.exports.isFloat64Array = $59a77e8886024a57$var$isFloat64Array;
function $59a77e8886024a57$var$isBigInt64Array(value) {
    return $gJrpv(value) === "BigInt64Array";
}
module.exports.isBigInt64Array = $59a77e8886024a57$var$isBigInt64Array;
function $59a77e8886024a57$var$isBigUint64Array(value) {
    return $gJrpv(value) === "BigUint64Array";
}
module.exports.isBigUint64Array = $59a77e8886024a57$var$isBigUint64Array;
function $59a77e8886024a57$var$isMapToString(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === "[object Map]";
}
$59a77e8886024a57$var$isMapToString.working = typeof Map !== "undefined" && $59a77e8886024a57$var$isMapToString(new Map());
function $59a77e8886024a57$var$isMap(value) {
    if (typeof Map === "undefined") return false;
    return $59a77e8886024a57$var$isMapToString.working ? $59a77e8886024a57$var$isMapToString(value) : value instanceof Map;
}
module.exports.isMap = $59a77e8886024a57$var$isMap;
function $59a77e8886024a57$var$isSetToString(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === "[object Set]";
}
$59a77e8886024a57$var$isSetToString.working = typeof Set !== "undefined" && $59a77e8886024a57$var$isSetToString(new Set());
function $59a77e8886024a57$var$isSet(value) {
    if (typeof Set === "undefined") return false;
    return $59a77e8886024a57$var$isSetToString.working ? $59a77e8886024a57$var$isSetToString(value) : value instanceof Set;
}
module.exports.isSet = $59a77e8886024a57$var$isSet;
function $59a77e8886024a57$var$isWeakMapToString(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === "[object WeakMap]";
}
$59a77e8886024a57$var$isWeakMapToString.working = typeof WeakMap !== "undefined" && $59a77e8886024a57$var$isWeakMapToString(new WeakMap());
function $59a77e8886024a57$var$isWeakMap(value) {
    if (typeof WeakMap === "undefined") return false;
    return $59a77e8886024a57$var$isWeakMapToString.working ? $59a77e8886024a57$var$isWeakMapToString(value) : value instanceof WeakMap;
}
module.exports.isWeakMap = $59a77e8886024a57$var$isWeakMap;
function $59a77e8886024a57$var$isWeakSetToString(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === "[object WeakSet]";
}
$59a77e8886024a57$var$isWeakSetToString.working = typeof WeakSet !== "undefined" && $59a77e8886024a57$var$isWeakSetToString(new WeakSet());
function $59a77e8886024a57$var$isWeakSet(value) {
    return $59a77e8886024a57$var$isWeakSetToString(value);
}
module.exports.isWeakSet = $59a77e8886024a57$var$isWeakSet;
function $59a77e8886024a57$var$isArrayBufferToString(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === "[object ArrayBuffer]";
}
$59a77e8886024a57$var$isArrayBufferToString.working = typeof ArrayBuffer !== "undefined" && $59a77e8886024a57$var$isArrayBufferToString(new ArrayBuffer());
function $59a77e8886024a57$var$isArrayBuffer(value) {
    if (typeof ArrayBuffer === "undefined") return false;
    return $59a77e8886024a57$var$isArrayBufferToString.working ? $59a77e8886024a57$var$isArrayBufferToString(value) : value instanceof ArrayBuffer;
}
module.exports.isArrayBuffer = $59a77e8886024a57$var$isArrayBuffer;
function $59a77e8886024a57$var$isDataViewToString(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === "[object DataView]";
}
$59a77e8886024a57$var$isDataViewToString.working = typeof ArrayBuffer !== "undefined" && typeof DataView !== "undefined" && $59a77e8886024a57$var$isDataViewToString(new DataView(new ArrayBuffer(1), 0, 1));
function $59a77e8886024a57$var$isDataView(value) {
    if (typeof DataView === "undefined") return false;
    return $59a77e8886024a57$var$isDataViewToString.working ? $59a77e8886024a57$var$isDataViewToString(value) : value instanceof DataView;
}
module.exports.isDataView = $59a77e8886024a57$var$isDataView;
// Store a copy of SharedArrayBuffer in case it's deleted elsewhere
var $59a77e8886024a57$var$SharedArrayBufferCopy = typeof SharedArrayBuffer !== "undefined" ? SharedArrayBuffer : undefined;
function $59a77e8886024a57$var$isSharedArrayBufferToString(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === "[object SharedArrayBuffer]";
}
function $59a77e8886024a57$var$isSharedArrayBuffer(value) {
    if (typeof $59a77e8886024a57$var$SharedArrayBufferCopy === "undefined") return false;
    if (typeof $59a77e8886024a57$var$isSharedArrayBufferToString.working === "undefined") $59a77e8886024a57$var$isSharedArrayBufferToString.working = $59a77e8886024a57$var$isSharedArrayBufferToString(new $59a77e8886024a57$var$SharedArrayBufferCopy());
    return $59a77e8886024a57$var$isSharedArrayBufferToString.working ? $59a77e8886024a57$var$isSharedArrayBufferToString(value) : value instanceof $59a77e8886024a57$var$SharedArrayBufferCopy;
}
module.exports.isSharedArrayBuffer = $59a77e8886024a57$var$isSharedArrayBuffer;
function $59a77e8886024a57$var$isAsyncFunction(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === "[object AsyncFunction]";
}
module.exports.isAsyncFunction = $59a77e8886024a57$var$isAsyncFunction;
function $59a77e8886024a57$var$isMapIterator(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === "[object Map Iterator]";
}
module.exports.isMapIterator = $59a77e8886024a57$var$isMapIterator;
function $59a77e8886024a57$var$isSetIterator(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === "[object Set Iterator]";
}
module.exports.isSetIterator = $59a77e8886024a57$var$isSetIterator;
function $59a77e8886024a57$var$isGeneratorObject(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === "[object Generator]";
}
module.exports.isGeneratorObject = $59a77e8886024a57$var$isGeneratorObject;
function $59a77e8886024a57$var$isWebAssemblyCompiledModule(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === "[object WebAssembly.Module]";
}
module.exports.isWebAssemblyCompiledModule = $59a77e8886024a57$var$isWebAssemblyCompiledModule;
function $59a77e8886024a57$var$isNumberObject(value) {
    return $59a77e8886024a57$var$checkBoxedPrimitive(value, $59a77e8886024a57$var$numberValue);
}
module.exports.isNumberObject = $59a77e8886024a57$var$isNumberObject;
function $59a77e8886024a57$var$isStringObject(value) {
    return $59a77e8886024a57$var$checkBoxedPrimitive(value, $59a77e8886024a57$var$stringValue);
}
module.exports.isStringObject = $59a77e8886024a57$var$isStringObject;
function $59a77e8886024a57$var$isBooleanObject(value) {
    return $59a77e8886024a57$var$checkBoxedPrimitive(value, $59a77e8886024a57$var$booleanValue);
}
module.exports.isBooleanObject = $59a77e8886024a57$var$isBooleanObject;
function $59a77e8886024a57$var$isBigIntObject(value) {
    return $59a77e8886024a57$var$BigIntSupported && $59a77e8886024a57$var$checkBoxedPrimitive(value, $59a77e8886024a57$var$bigIntValue);
}
module.exports.isBigIntObject = $59a77e8886024a57$var$isBigIntObject;
function $59a77e8886024a57$var$isSymbolObject(value) {
    return $59a77e8886024a57$var$SymbolSupported && $59a77e8886024a57$var$checkBoxedPrimitive(value, $59a77e8886024a57$var$symbolValue);
}
module.exports.isSymbolObject = $59a77e8886024a57$var$isSymbolObject;
function $59a77e8886024a57$var$isBoxedPrimitive(value) {
    return $59a77e8886024a57$var$isNumberObject(value) || $59a77e8886024a57$var$isStringObject(value) || $59a77e8886024a57$var$isBooleanObject(value) || $59a77e8886024a57$var$isBigIntObject(value) || $59a77e8886024a57$var$isSymbolObject(value);
}
module.exports.isBoxedPrimitive = $59a77e8886024a57$var$isBoxedPrimitive;
function $59a77e8886024a57$var$isAnyArrayBuffer(value) {
    return typeof Uint8Array !== "undefined" && ($59a77e8886024a57$var$isArrayBuffer(value) || $59a77e8886024a57$var$isSharedArrayBuffer(value));
}
module.exports.isAnyArrayBuffer = $59a77e8886024a57$var$isAnyArrayBuffer;
[
    "isProxy",
    "isExternal",
    "isModuleNamespaceObject"
].forEach(function(method) {
    Object.defineProperty(module.exports, method, {
        enumerable: false,
        value: function() {
            throw new Error(method + " is not supported in userland");
        }
    });
});

});
parcelRegister("f4HGZ", function(module, exports) {
"use strict";

var $af991f1d6c80f097$var$hasToStringTag = (parcelRequire("3KyxH"))();

var $hXu6F = parcelRequire("hXu6F");
var $af991f1d6c80f097$var$$toString = $hXu6F("Object.prototype.toString");
var $af991f1d6c80f097$var$isStandardArguments = function isArguments(value) {
    if ($af991f1d6c80f097$var$hasToStringTag && value && typeof value === "object" && Symbol.toStringTag in value) return false;
    return $af991f1d6c80f097$var$$toString(value) === "[object Arguments]";
};
var $af991f1d6c80f097$var$isLegacyArguments = function isArguments(value) {
    if ($af991f1d6c80f097$var$isStandardArguments(value)) return true;
    return value !== null && typeof value === "object" && typeof value.length === "number" && value.length >= 0 && $af991f1d6c80f097$var$$toString(value) !== "[object Array]" && $af991f1d6c80f097$var$$toString(value.callee) === "[object Function]";
};
var $af991f1d6c80f097$var$supportsStandardArguments = function() {
    return $af991f1d6c80f097$var$isStandardArguments(arguments);
}();
$af991f1d6c80f097$var$isStandardArguments.isLegacyArguments = $af991f1d6c80f097$var$isLegacyArguments; // for tests
module.exports = $af991f1d6c80f097$var$supportsStandardArguments ? $af991f1d6c80f097$var$isStandardArguments : $af991f1d6c80f097$var$isLegacyArguments;

});
parcelRegister("3KyxH", function(module, exports) {
"use strict";

var $7YWkK = parcelRequire("7YWkK");
/** @type {import('.')} */ module.exports = function hasToStringTagShams() {
    return $7YWkK() && !!Symbol.toStringTag;
};

});
parcelRegister("7YWkK", function(module, exports) {
"use strict";
/* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== "function" || typeof Object.getOwnPropertySymbols !== "function") return false;
    if (typeof Symbol.iterator === "symbol") return true;
    var obj = {};
    var sym = Symbol("test");
    var symObj = Object(sym);
    if (typeof sym === "string") return false;
    if (Object.prototype.toString.call(sym) !== "[object Symbol]") return false;
    if (Object.prototype.toString.call(symObj) !== "[object Symbol]") return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(sym in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === "function" && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === "function" && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === "function") {
        var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

});


parcelRegister("hXu6F", function(module, exports) {
"use strict";

var $1zENl = parcelRequire("1zENl");

var $cOB0F = parcelRequire("cOB0F");
var $d12f4cdcd6b10506$var$$indexOf = $cOB0F($1zENl("String.prototype.indexOf"));
module.exports = function callBoundIntrinsic(name, allowMissing) {
    var intrinsic = $1zENl(name, !!allowMissing);
    if (typeof intrinsic === "function" && $d12f4cdcd6b10506$var$$indexOf(name, ".prototype.") > -1) return $cOB0F(intrinsic);
    return intrinsic;
};

});
parcelRegister("1zENl", function(module, exports) {
"use strict";
var $1258b452ecf218a1$var$undefined1;

var $5A49f = parcelRequire("5A49f");

var $hDtVy = parcelRequire("hDtVy");

var $9RC8m = parcelRequire("9RC8m");

var $2BaZq = parcelRequire("2BaZq");

var $5Ox6r = parcelRequire("5Ox6r");

var $eEkyn = parcelRequire("eEkyn");

var $hFSMY = parcelRequire("hFSMY");
var $1258b452ecf218a1$var$$Function = Function;
// eslint-disable-next-line consistent-return
var $1258b452ecf218a1$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $1258b452ecf218a1$var$$Function('"use strict"; return (' + expressionSyntax + ").constructor;")();
    } catch (e) {}
};
var $1258b452ecf218a1$var$$gOPD = Object.getOwnPropertyDescriptor;
if ($1258b452ecf218a1$var$$gOPD) try {
    $1258b452ecf218a1$var$$gOPD({}, "");
} catch (e) {
    $1258b452ecf218a1$var$$gOPD = null; // this is IE 8, which has a broken gOPD
}
var $1258b452ecf218a1$var$throwTypeError = function() {
    throw new $eEkyn();
};
var $1258b452ecf218a1$var$ThrowTypeError = $1258b452ecf218a1$var$$gOPD ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $1258b452ecf218a1$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $1258b452ecf218a1$var$$gOPD(arguments, "callee").get;
        } catch (gOPDthrows) {
            return $1258b452ecf218a1$var$throwTypeError;
        }
    }
}() : $1258b452ecf218a1$var$throwTypeError;

var $1258b452ecf218a1$var$hasSymbols = (parcelRequire("24qIq"))();

var $1258b452ecf218a1$var$hasProto = (parcelRequire("dSRh6"))();
var $1258b452ecf218a1$var$getProto = Object.getPrototypeOf || ($1258b452ecf218a1$var$hasProto ? function(x) {
    return x.__proto__;
} // eslint-disable-line no-proto
 : null);
var $1258b452ecf218a1$var$needsEval = {};
var $1258b452ecf218a1$var$TypedArray = typeof Uint8Array === "undefined" || !$1258b452ecf218a1$var$getProto ? undefined : $1258b452ecf218a1$var$getProto(Uint8Array);
var $1258b452ecf218a1$var$INTRINSICS = {
    __proto__: null,
    "%AggregateError%": typeof AggregateError === "undefined" ? undefined : AggregateError,
    "%Array%": Array,
    "%ArrayBuffer%": typeof ArrayBuffer === "undefined" ? undefined : ArrayBuffer,
    "%ArrayIteratorPrototype%": $1258b452ecf218a1$var$hasSymbols && $1258b452ecf218a1$var$getProto ? $1258b452ecf218a1$var$getProto([][Symbol.iterator]()) : undefined,
    "%AsyncFromSyncIteratorPrototype%": undefined,
    "%AsyncFunction%": $1258b452ecf218a1$var$needsEval,
    "%AsyncGenerator%": $1258b452ecf218a1$var$needsEval,
    "%AsyncGeneratorFunction%": $1258b452ecf218a1$var$needsEval,
    "%AsyncIteratorPrototype%": $1258b452ecf218a1$var$needsEval,
    "%Atomics%": typeof Atomics === "undefined" ? undefined : Atomics,
    "%BigInt%": typeof BigInt === "undefined" ? undefined : BigInt,
    "%BigInt64Array%": typeof BigInt64Array === "undefined" ? undefined : BigInt64Array,
    "%BigUint64Array%": typeof BigUint64Array === "undefined" ? undefined : BigUint64Array,
    "%Boolean%": Boolean,
    "%DataView%": typeof DataView === "undefined" ? undefined : DataView,
    "%Date%": Date,
    "%decodeURI%": decodeURI,
    "%decodeURIComponent%": decodeURIComponent,
    "%encodeURI%": encodeURI,
    "%encodeURIComponent%": encodeURIComponent,
    "%Error%": $5A49f,
    "%eval%": eval,
    "%EvalError%": $hDtVy,
    "%Float32Array%": typeof Float32Array === "undefined" ? undefined : Float32Array,
    "%Float64Array%": typeof Float64Array === "undefined" ? undefined : Float64Array,
    "%FinalizationRegistry%": typeof FinalizationRegistry === "undefined" ? undefined : FinalizationRegistry,
    "%Function%": $1258b452ecf218a1$var$$Function,
    "%GeneratorFunction%": $1258b452ecf218a1$var$needsEval,
    "%Int8Array%": typeof Int8Array === "undefined" ? undefined : Int8Array,
    "%Int16Array%": typeof Int16Array === "undefined" ? undefined : Int16Array,
    "%Int32Array%": typeof Int32Array === "undefined" ? undefined : Int32Array,
    "%isFinite%": isFinite,
    "%isNaN%": isNaN,
    "%IteratorPrototype%": $1258b452ecf218a1$var$hasSymbols && $1258b452ecf218a1$var$getProto ? $1258b452ecf218a1$var$getProto($1258b452ecf218a1$var$getProto([][Symbol.iterator]())) : undefined,
    "%JSON%": typeof JSON === "object" ? JSON : undefined,
    "%Map%": typeof Map === "undefined" ? undefined : Map,
    "%MapIteratorPrototype%": typeof Map === "undefined" || !$1258b452ecf218a1$var$hasSymbols || !$1258b452ecf218a1$var$getProto ? undefined : $1258b452ecf218a1$var$getProto(new Map()[Symbol.iterator]()),
    "%Math%": Math,
    "%Number%": Number,
    "%Object%": Object,
    "%parseFloat%": parseFloat,
    "%parseInt%": parseInt,
    "%Promise%": typeof Promise === "undefined" ? undefined : Promise,
    "%Proxy%": typeof Proxy === "undefined" ? undefined : Proxy,
    "%RangeError%": $9RC8m,
    "%ReferenceError%": $2BaZq,
    "%Reflect%": typeof Reflect === "undefined" ? undefined : Reflect,
    "%RegExp%": RegExp,
    "%Set%": typeof Set === "undefined" ? undefined : Set,
    "%SetIteratorPrototype%": typeof Set === "undefined" || !$1258b452ecf218a1$var$hasSymbols || !$1258b452ecf218a1$var$getProto ? undefined : $1258b452ecf218a1$var$getProto(new Set()[Symbol.iterator]()),
    "%SharedArrayBuffer%": typeof SharedArrayBuffer === "undefined" ? undefined : SharedArrayBuffer,
    "%String%": String,
    "%StringIteratorPrototype%": $1258b452ecf218a1$var$hasSymbols && $1258b452ecf218a1$var$getProto ? $1258b452ecf218a1$var$getProto(""[Symbol.iterator]()) : undefined,
    "%Symbol%": $1258b452ecf218a1$var$hasSymbols ? Symbol : undefined,
    "%SyntaxError%": $5Ox6r,
    "%ThrowTypeError%": $1258b452ecf218a1$var$ThrowTypeError,
    "%TypedArray%": $1258b452ecf218a1$var$TypedArray,
    "%TypeError%": $eEkyn,
    "%Uint8Array%": typeof Uint8Array === "undefined" ? undefined : Uint8Array,
    "%Uint8ClampedArray%": typeof Uint8ClampedArray === "undefined" ? undefined : Uint8ClampedArray,
    "%Uint16Array%": typeof Uint16Array === "undefined" ? undefined : Uint16Array,
    "%Uint32Array%": typeof Uint32Array === "undefined" ? undefined : Uint32Array,
    "%URIError%": $hFSMY,
    "%WeakMap%": typeof WeakMap === "undefined" ? undefined : WeakMap,
    "%WeakRef%": typeof WeakRef === "undefined" ? undefined : WeakRef,
    "%WeakSet%": typeof WeakSet === "undefined" ? undefined : WeakSet
};
if ($1258b452ecf218a1$var$getProto) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var $1258b452ecf218a1$var$errorProto = $1258b452ecf218a1$var$getProto($1258b452ecf218a1$var$getProto(e));
    $1258b452ecf218a1$var$INTRINSICS["%Error.prototype%"] = $1258b452ecf218a1$var$errorProto;
}
var $1258b452ecf218a1$var$doEval = function doEval(name) {
    var value;
    if (name === "%AsyncFunction%") value = $1258b452ecf218a1$var$getEvalledConstructor("async function () {}");
    else if (name === "%GeneratorFunction%") value = $1258b452ecf218a1$var$getEvalledConstructor("function* () {}");
    else if (name === "%AsyncGeneratorFunction%") value = $1258b452ecf218a1$var$getEvalledConstructor("async function* () {}");
    else if (name === "%AsyncGenerator%") {
        var fn = doEval("%AsyncGeneratorFunction%");
        if (fn) value = fn.prototype;
    } else if (name === "%AsyncIteratorPrototype%") {
        var gen = doEval("%AsyncGenerator%");
        if (gen && $1258b452ecf218a1$var$getProto) value = $1258b452ecf218a1$var$getProto(gen.prototype);
    }
    $1258b452ecf218a1$var$INTRINSICS[name] = value;
    return value;
};
var $1258b452ecf218a1$var$LEGACY_ALIASES = {
    __proto__: null,
    "%ArrayBufferPrototype%": [
        "ArrayBuffer",
        "prototype"
    ],
    "%ArrayPrototype%": [
        "Array",
        "prototype"
    ],
    "%ArrayProto_entries%": [
        "Array",
        "prototype",
        "entries"
    ],
    "%ArrayProto_forEach%": [
        "Array",
        "prototype",
        "forEach"
    ],
    "%ArrayProto_keys%": [
        "Array",
        "prototype",
        "keys"
    ],
    "%ArrayProto_values%": [
        "Array",
        "prototype",
        "values"
    ],
    "%AsyncFunctionPrototype%": [
        "AsyncFunction",
        "prototype"
    ],
    "%AsyncGenerator%": [
        "AsyncGeneratorFunction",
        "prototype"
    ],
    "%AsyncGeneratorPrototype%": [
        "AsyncGeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%BooleanPrototype%": [
        "Boolean",
        "prototype"
    ],
    "%DataViewPrototype%": [
        "DataView",
        "prototype"
    ],
    "%DatePrototype%": [
        "Date",
        "prototype"
    ],
    "%ErrorPrototype%": [
        "Error",
        "prototype"
    ],
    "%EvalErrorPrototype%": [
        "EvalError",
        "prototype"
    ],
    "%Float32ArrayPrototype%": [
        "Float32Array",
        "prototype"
    ],
    "%Float64ArrayPrototype%": [
        "Float64Array",
        "prototype"
    ],
    "%FunctionPrototype%": [
        "Function",
        "prototype"
    ],
    "%Generator%": [
        "GeneratorFunction",
        "prototype"
    ],
    "%GeneratorPrototype%": [
        "GeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%Int8ArrayPrototype%": [
        "Int8Array",
        "prototype"
    ],
    "%Int16ArrayPrototype%": [
        "Int16Array",
        "prototype"
    ],
    "%Int32ArrayPrototype%": [
        "Int32Array",
        "prototype"
    ],
    "%JSONParse%": [
        "JSON",
        "parse"
    ],
    "%JSONStringify%": [
        "JSON",
        "stringify"
    ],
    "%MapPrototype%": [
        "Map",
        "prototype"
    ],
    "%NumberPrototype%": [
        "Number",
        "prototype"
    ],
    "%ObjectPrototype%": [
        "Object",
        "prototype"
    ],
    "%ObjProto_toString%": [
        "Object",
        "prototype",
        "toString"
    ],
    "%ObjProto_valueOf%": [
        "Object",
        "prototype",
        "valueOf"
    ],
    "%PromisePrototype%": [
        "Promise",
        "prototype"
    ],
    "%PromiseProto_then%": [
        "Promise",
        "prototype",
        "then"
    ],
    "%Promise_all%": [
        "Promise",
        "all"
    ],
    "%Promise_reject%": [
        "Promise",
        "reject"
    ],
    "%Promise_resolve%": [
        "Promise",
        "resolve"
    ],
    "%RangeErrorPrototype%": [
        "RangeError",
        "prototype"
    ],
    "%ReferenceErrorPrototype%": [
        "ReferenceError",
        "prototype"
    ],
    "%RegExpPrototype%": [
        "RegExp",
        "prototype"
    ],
    "%SetPrototype%": [
        "Set",
        "prototype"
    ],
    "%SharedArrayBufferPrototype%": [
        "SharedArrayBuffer",
        "prototype"
    ],
    "%StringPrototype%": [
        "String",
        "prototype"
    ],
    "%SymbolPrototype%": [
        "Symbol",
        "prototype"
    ],
    "%SyntaxErrorPrototype%": [
        "SyntaxError",
        "prototype"
    ],
    "%TypedArrayPrototype%": [
        "TypedArray",
        "prototype"
    ],
    "%TypeErrorPrototype%": [
        "TypeError",
        "prototype"
    ],
    "%Uint8ArrayPrototype%": [
        "Uint8Array",
        "prototype"
    ],
    "%Uint8ClampedArrayPrototype%": [
        "Uint8ClampedArray",
        "prototype"
    ],
    "%Uint16ArrayPrototype%": [
        "Uint16Array",
        "prototype"
    ],
    "%Uint32ArrayPrototype%": [
        "Uint32Array",
        "prototype"
    ],
    "%URIErrorPrototype%": [
        "URIError",
        "prototype"
    ],
    "%WeakMapPrototype%": [
        "WeakMap",
        "prototype"
    ],
    "%WeakSetPrototype%": [
        "WeakSet",
        "prototype"
    ]
};

var $gvair = parcelRequire("gvair");

var $4c4Ky = parcelRequire("4c4Ky");
var $1258b452ecf218a1$var$$concat = $gvair.call(Function.call, Array.prototype.concat);
var $1258b452ecf218a1$var$$spliceApply = $gvair.call(Function.apply, Array.prototype.splice);
var $1258b452ecf218a1$var$$replace = $gvair.call(Function.call, String.prototype.replace);
var $1258b452ecf218a1$var$$strSlice = $gvair.call(Function.call, String.prototype.slice);
var $1258b452ecf218a1$var$$exec = $gvair.call(Function.call, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $1258b452ecf218a1$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $1258b452ecf218a1$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $1258b452ecf218a1$var$stringToPath = function stringToPath(string) {
    var first = $1258b452ecf218a1$var$$strSlice(string, 0, 1);
    var last = $1258b452ecf218a1$var$$strSlice(string, -1);
    if (first === "%" && last !== "%") throw new $5Ox6r("invalid intrinsic syntax, expected closing `%`");
    else if (last === "%" && first !== "%") throw new $5Ox6r("invalid intrinsic syntax, expected opening `%`");
    var result = [];
    $1258b452ecf218a1$var$$replace(string, $1258b452ecf218a1$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $1258b452ecf218a1$var$$replace(subString, $1258b452ecf218a1$var$reEscapeChar, "$1") : number || match;
    });
    return result;
};
/* end adaptation */ var $1258b452ecf218a1$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($4c4Ky($1258b452ecf218a1$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $1258b452ecf218a1$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = "%" + alias[0] + "%";
    }
    if ($4c4Ky($1258b452ecf218a1$var$INTRINSICS, intrinsicName)) {
        var value = $1258b452ecf218a1$var$INTRINSICS[intrinsicName];
        if (value === $1258b452ecf218a1$var$needsEval) value = $1258b452ecf218a1$var$doEval(intrinsicName);
        if (typeof value === "undefined" && !allowMissing) throw new $eEkyn("intrinsic " + name + " exists, but is not available. Please file an issue!");
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $5Ox6r("intrinsic " + name + " does not exist!");
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== "string" || name.length === 0) throw new $eEkyn("intrinsic name must be a non-empty string");
    if (arguments.length > 1 && typeof allowMissing !== "boolean") throw new $eEkyn('"allowMissing" argument must be a boolean');
    if ($1258b452ecf218a1$var$$exec(/^%?[^%]*%?$/, name) === null) throw new $5Ox6r("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
    var parts = $1258b452ecf218a1$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : "";
    var intrinsic = $1258b452ecf218a1$var$getBaseIntrinsic("%" + intrinsicBaseName + "%", allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $1258b452ecf218a1$var$$spliceApply(parts, $1258b452ecf218a1$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $1258b452ecf218a1$var$$strSlice(part, 0, 1);
        var last = $1258b452ecf218a1$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === "`" || last === '"' || last === "'" || last === "`") && first !== last) throw new $5Ox6r("property names with quotes must have matching quotes");
        if (part === "constructor" || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += "." + part;
        intrinsicRealName = "%" + intrinsicBaseName + "%";
        if ($4c4Ky($1258b452ecf218a1$var$INTRINSICS, intrinsicRealName)) value = $1258b452ecf218a1$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $eEkyn("base intrinsic for " + name + " exists, but the property is not available.");
                return void 0;
            }
            if ($1258b452ecf218a1$var$$gOPD && i + 1 >= parts.length) {
                var desc = $1258b452ecf218a1$var$$gOPD(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && "get" in desc && !("originalValue" in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $4c4Ky(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $1258b452ecf218a1$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

});
parcelRegister("5A49f", function(module, exports) {
"use strict";
/** @type {import('.')} */ module.exports = Error;

});

parcelRegister("hDtVy", function(module, exports) {
"use strict";
/** @type {import('./eval')} */ module.exports = EvalError;

});

parcelRegister("9RC8m", function(module, exports) {
"use strict";
/** @type {import('./range')} */ module.exports = RangeError;

});

parcelRegister("2BaZq", function(module, exports) {
"use strict";
/** @type {import('./ref')} */ module.exports = ReferenceError;

});

parcelRegister("5Ox6r", function(module, exports) {
"use strict";
/** @type {import('./syntax')} */ module.exports = SyntaxError;

});

parcelRegister("eEkyn", function(module, exports) {
"use strict";
/** @type {import('./type')} */ module.exports = TypeError;

});

parcelRegister("hFSMY", function(module, exports) {
"use strict";
/** @type {import('./uri')} */ module.exports = URIError;

});

parcelRegister("24qIq", function(module, exports) {
"use strict";
var $1820ada193f67aeb$var$origSymbol = typeof Symbol !== "undefined" && Symbol;

var $7YWkK = parcelRequire("7YWkK");
module.exports = function hasNativeSymbols() {
    if (typeof $1820ada193f67aeb$var$origSymbol !== "function") return false;
    if (typeof Symbol !== "function") return false;
    if (typeof $1820ada193f67aeb$var$origSymbol("foo") !== "symbol") return false;
    if (typeof Symbol("bar") !== "symbol") return false;
    return $7YWkK();
};

});

parcelRegister("dSRh6", function(module, exports) {
"use strict";
var $a1b9a4c94d7d9147$var$test = {
    __proto__: null,
    foo: {}
};
var $a1b9a4c94d7d9147$var$$Object = Object;
/** @type {import('.')} */ module.exports = function hasProto() {
    // @ts-expect-error: TS errors on an inherited property for some reason
    return ({
        __proto__: $a1b9a4c94d7d9147$var$test
    }).foo === $a1b9a4c94d7d9147$var$test.foo && !($a1b9a4c94d7d9147$var$test instanceof $a1b9a4c94d7d9147$var$$Object);
};

});

parcelRegister("gvair", function(module, exports) {
"use strict";

var $kAGnA = parcelRequire("kAGnA");
module.exports = Function.prototype.bind || $kAGnA;

});
parcelRegister("kAGnA", function(module, exports) {
"use strict";
/* eslint no-invalid-this: 1 */ var $efd80b1d7fbb2850$var$ERROR_MESSAGE = "Function.prototype.bind called on incompatible ";
var $efd80b1d7fbb2850$var$toStr = Object.prototype.toString;
var $efd80b1d7fbb2850$var$max = Math.max;
var $efd80b1d7fbb2850$var$funcType = "[object Function]";
var $efd80b1d7fbb2850$var$concatty = function concatty(a, b) {
    var arr = [];
    for(var i = 0; i < a.length; i += 1)arr[i] = a[i];
    for(var j = 0; j < b.length; j += 1)arr[j + a.length] = b[j];
    return arr;
};
var $efd80b1d7fbb2850$var$slicy = function slicy(arrLike, offset) {
    var arr = [];
    for(var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1)arr[j] = arrLike[i];
    return arr;
};
var $efd80b1d7fbb2850$var$joiny = function(arr, joiner) {
    var str = "";
    for(var i = 0; i < arr.length; i += 1){
        str += arr[i];
        if (i + 1 < arr.length) str += joiner;
    }
    return str;
};
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== "function" || $efd80b1d7fbb2850$var$toStr.apply(target) !== $efd80b1d7fbb2850$var$funcType) throw new TypeError($efd80b1d7fbb2850$var$ERROR_MESSAGE + target);
    var args = $efd80b1d7fbb2850$var$slicy(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, $efd80b1d7fbb2850$var$concatty(args, arguments));
            if (Object(result) === result) return result;
            return this;
        }
        return target.apply(that, $efd80b1d7fbb2850$var$concatty(args, arguments));
    };
    var boundLength = $efd80b1d7fbb2850$var$max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs[i] = "$" + i;
    bound = Function("binder", "return function (" + $efd80b1d7fbb2850$var$joiny(boundArgs, ",") + "){ return binder.apply(this,arguments); }")(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

});


parcelRegister("4c4Ky", function(module, exports) {
"use strict";
var $30dbf79dbae6c725$var$call = Function.prototype.call;
var $30dbf79dbae6c725$var$$hasOwn = Object.prototype.hasOwnProperty;

var $gvair = parcelRequire("gvair");
/** @type {import('.')} */ module.exports = $gvair.call($30dbf79dbae6c725$var$call, $30dbf79dbae6c725$var$$hasOwn);

});


parcelRegister("cOB0F", function(module, exports) {
"use strict";

var $gvair = parcelRequire("gvair");

var $1zENl = parcelRequire("1zENl");

var $BPe9e = parcelRequire("BPe9e");

var $eEkyn = parcelRequire("eEkyn");
var $9546dce5bd4976bd$var$$apply = $1zENl("%Function.prototype.apply%");
var $9546dce5bd4976bd$var$$call = $1zENl("%Function.prototype.call%");
var $9546dce5bd4976bd$var$$reflectApply = $1zENl("%Reflect.apply%", true) || $gvair.call($9546dce5bd4976bd$var$$call, $9546dce5bd4976bd$var$$apply);

var $jAy3M = parcelRequire("jAy3M");
var $9546dce5bd4976bd$var$$max = $1zENl("%Math.max%");
module.exports = function callBind(originalFunction) {
    if (typeof originalFunction !== "function") throw new $eEkyn("a function is required");
    var func = $9546dce5bd4976bd$var$$reflectApply($gvair, $9546dce5bd4976bd$var$$call, arguments);
    return $BPe9e(func, 1 + $9546dce5bd4976bd$var$$max(0, originalFunction.length - (arguments.length - 1)), true);
};
var $9546dce5bd4976bd$var$applyBind = function applyBind() {
    return $9546dce5bd4976bd$var$$reflectApply($gvair, $9546dce5bd4976bd$var$$apply, arguments);
};
if ($jAy3M) $jAy3M(module.exports, "apply", {
    value: $9546dce5bd4976bd$var$applyBind
});
else module.exports.apply = $9546dce5bd4976bd$var$applyBind;

});
parcelRegister("BPe9e", function(module, exports) {
"use strict";

var $1zENl = parcelRequire("1zENl");

var $5FEEt = parcelRequire("5FEEt");

var $071b317808876eb5$var$hasDescriptors = (parcelRequire("i16wS"))();

var $dYOee = parcelRequire("dYOee");

var $eEkyn = parcelRequire("eEkyn");
var $071b317808876eb5$var$$floor = $1zENl("%Math.floor%");
/** @type {import('.')} */ module.exports = function setFunctionLength(fn, length) {
    if (typeof fn !== "function") throw new $eEkyn("`fn` is not a function");
    if (typeof length !== "number" || length < 0 || length > 0xFFFFFFFF || $071b317808876eb5$var$$floor(length) !== length) throw new $eEkyn("`length` must be a positive 32-bit integer");
    var loose = arguments.length > 2 && !!arguments[2];
    var functionLengthIsConfigurable = true;
    var functionLengthIsWritable = true;
    if ("length" in fn && $dYOee) {
        var desc = $dYOee(fn, "length");
        if (desc && !desc.configurable) functionLengthIsConfigurable = false;
        if (desc && !desc.writable) functionLengthIsWritable = false;
    }
    if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
        if ($071b317808876eb5$var$hasDescriptors) $5FEEt(/** @type {Parameters<define>[0]} */ fn, "length", length, true, true);
        else $5FEEt(/** @type {Parameters<define>[0]} */ fn, "length", length);
    }
    return fn;
};

});
parcelRegister("5FEEt", function(module, exports) {
"use strict";

var $jAy3M = parcelRequire("jAy3M");

var $5Ox6r = parcelRequire("5Ox6r");

var $eEkyn = parcelRequire("eEkyn");

var $dYOee = parcelRequire("dYOee");
/** @type {import('.')} */ module.exports = function defineDataProperty(obj, property, value) {
    if (!obj || typeof obj !== "object" && typeof obj !== "function") throw new $eEkyn("`obj` must be an object or a function`");
    if (typeof property !== "string" && typeof property !== "symbol") throw new $eEkyn("`property` must be a string or a symbol`");
    if (arguments.length > 3 && typeof arguments[3] !== "boolean" && arguments[3] !== null) throw new $eEkyn("`nonEnumerable`, if provided, must be a boolean or null");
    if (arguments.length > 4 && typeof arguments[4] !== "boolean" && arguments[4] !== null) throw new $eEkyn("`nonWritable`, if provided, must be a boolean or null");
    if (arguments.length > 5 && typeof arguments[5] !== "boolean" && arguments[5] !== null) throw new $eEkyn("`nonConfigurable`, if provided, must be a boolean or null");
    if (arguments.length > 6 && typeof arguments[6] !== "boolean") throw new $eEkyn("`loose`, if provided, must be a boolean");
    var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
    var nonWritable = arguments.length > 4 ? arguments[4] : null;
    var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
    var loose = arguments.length > 6 ? arguments[6] : false;
    /* @type {false | TypedPropertyDescriptor<unknown>} */ var desc = !!$dYOee && $dYOee(obj, property);
    if ($jAy3M) $jAy3M(obj, property, {
        configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
        enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
        value: value,
        writable: nonWritable === null && desc ? desc.writable : !nonWritable
    });
    else if (loose || !nonEnumerable && !nonWritable && !nonConfigurable) // must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
    obj[property] = value; // eslint-disable-line no-param-reassign
    else throw new $5Ox6r("This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.");
};

});
parcelRegister("jAy3M", function(module, exports) {
"use strict";

var $1zENl = parcelRequire("1zENl");
/** @type {import('.')} */ var $e42bccb64e3fb3fd$var$$defineProperty = $1zENl("%Object.defineProperty%", true) || false;
if ($e42bccb64e3fb3fd$var$$defineProperty) try {
    $e42bccb64e3fb3fd$var$$defineProperty({}, "a", {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $e42bccb64e3fb3fd$var$$defineProperty = false;
}
module.exports = $e42bccb64e3fb3fd$var$$defineProperty;

});

parcelRegister("dYOee", function(module, exports) {
"use strict";

var $1zENl = parcelRequire("1zENl");
var $a2d7d74e83f6c3ed$var$$gOPD = $1zENl("%Object.getOwnPropertyDescriptor%", true);
if ($a2d7d74e83f6c3ed$var$$gOPD) try {
    $a2d7d74e83f6c3ed$var$$gOPD([], "length");
} catch (e) {
    // IE 8 has a broken gOPD
    $a2d7d74e83f6c3ed$var$$gOPD = null;
}
module.exports = $a2d7d74e83f6c3ed$var$$gOPD;

});


parcelRegister("i16wS", function(module, exports) {
"use strict";

var $jAy3M = parcelRequire("jAy3M");
var $d1dd62937e17e68d$var$hasPropertyDescriptors = function hasPropertyDescriptors() {
    return !!$jAy3M;
};
$d1dd62937e17e68d$var$hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
    // node v0.6 has a bug where array lengths can be Set but not Defined
    if (!$jAy3M) return null;
    try {
        return $jAy3M([], "length", {
            value: 1
        }).length !== 1;
    } catch (e) {
        // In Firefox 4-22, defining length on an array throws an exception.
        return true;
    }
};
module.exports = $d1dd62937e17e68d$var$hasPropertyDescriptors;

});





parcelRegister("5WnCa", function(module, exports) {
"use strict";
var $4534afe844d627e4$var$toStr = Object.prototype.toString;
var $4534afe844d627e4$var$fnToStr = Function.prototype.toString;
var $4534afe844d627e4$var$isFnRegex = /^\s*(?:function)?\*/;

var $4534afe844d627e4$var$hasToStringTag = (parcelRequire("3KyxH"))();
var $4534afe844d627e4$var$getProto = Object.getPrototypeOf;
var $4534afe844d627e4$var$getGeneratorFunc = function() {
    if (!$4534afe844d627e4$var$hasToStringTag) return false;
    try {
        return Function("return function*() {}")();
    } catch (e) {}
};
var $4534afe844d627e4$var$GeneratorFunction;
module.exports = function isGeneratorFunction(fn) {
    if (typeof fn !== "function") return false;
    if ($4534afe844d627e4$var$isFnRegex.test($4534afe844d627e4$var$fnToStr.call(fn))) return true;
    if (!$4534afe844d627e4$var$hasToStringTag) {
        var str = $4534afe844d627e4$var$toStr.call(fn);
        return str === "[object GeneratorFunction]";
    }
    if (!$4534afe844d627e4$var$getProto) return false;
    if (typeof $4534afe844d627e4$var$GeneratorFunction === "undefined") {
        var generatorFunc = $4534afe844d627e4$var$getGeneratorFunc();
        $4534afe844d627e4$var$GeneratorFunction = generatorFunc ? $4534afe844d627e4$var$getProto(generatorFunc) : false;
    }
    return $4534afe844d627e4$var$getProto(fn) === $4534afe844d627e4$var$GeneratorFunction;
};

});

parcelRegister("gJrpv", function(module, exports) {
"use strict";

var $gFhA7 = parcelRequire("gFhA7");

var $8yXCr = parcelRequire("8yXCr");

var $cOB0F = parcelRequire("cOB0F");

var $hXu6F = parcelRequire("hXu6F");

var $dYOee = parcelRequire("dYOee");
/** @type {(O: object) => string} */ var $c2e61c703a2c9ae0$var$$toString = $hXu6F("Object.prototype.toString");

var $c2e61c703a2c9ae0$var$hasToStringTag = (parcelRequire("3KyxH"))();
var $c2e61c703a2c9ae0$var$g = typeof globalThis === "undefined" ? $parcel$global : globalThis;
var $c2e61c703a2c9ae0$var$typedArrays = $8yXCr();
var $c2e61c703a2c9ae0$var$$slice = $hXu6F("String.prototype.slice");
var $c2e61c703a2c9ae0$var$getPrototypeOf = Object.getPrototypeOf; // require('getprototypeof');
/** @type {<T = unknown>(array: readonly T[], value: unknown) => number} */ var $c2e61c703a2c9ae0$var$$indexOf = $hXu6F("Array.prototype.indexOf", true) || function indexOf(array, value) {
    for(var i = 0; i < array.length; i += 1){
        if (array[i] === value) return i;
    }
    return -1;
};
/** @typedef {(receiver: import('.').TypedArray) => string | typeof Uint8Array.prototype.slice.call | typeof Uint8Array.prototype.set.call} Getter */ /** @type {{ [k in `\$${import('.').TypedArrayName}`]?: Getter } & { __proto__: null }} */ var $c2e61c703a2c9ae0$var$cache = {
    __proto__: null
};
if ($c2e61c703a2c9ae0$var$hasToStringTag && $dYOee && $c2e61c703a2c9ae0$var$getPrototypeOf) $gFhA7($c2e61c703a2c9ae0$var$typedArrays, function(typedArray) {
    var arr = new $c2e61c703a2c9ae0$var$g[typedArray]();
    if (Symbol.toStringTag in arr) {
        var proto = $c2e61c703a2c9ae0$var$getPrototypeOf(arr);
        // @ts-expect-error TS won't narrow inside a closure
        var descriptor = $dYOee(proto, Symbol.toStringTag);
        if (!descriptor) {
            var superProto = $c2e61c703a2c9ae0$var$getPrototypeOf(proto);
            // @ts-expect-error TS won't narrow inside a closure
            descriptor = $dYOee(superProto, Symbol.toStringTag);
        }
        // @ts-expect-error TODO: fix
        $c2e61c703a2c9ae0$var$cache["$" + typedArray] = $cOB0F(descriptor.get);
    }
});
else $gFhA7($c2e61c703a2c9ae0$var$typedArrays, function(typedArray) {
    var arr = new $c2e61c703a2c9ae0$var$g[typedArray]();
    var fn = arr.slice || arr.set;
    if (fn) // @ts-expect-error TODO: fix
    $c2e61c703a2c9ae0$var$cache["$" + typedArray] = $cOB0F(fn);
});
/** @type {(value: object) => false | import('.').TypedArrayName} */ var $c2e61c703a2c9ae0$var$tryTypedArrays = function tryAllTypedArrays(value) {
    /** @type {ReturnType<typeof tryAllTypedArrays>} */ var found = false;
    $gFhA7(// eslint-disable-next-line no-extra-parens
    /** @type {Record<`\$${TypedArrayName}`, Getter>} */ /** @type {any} */ $c2e61c703a2c9ae0$var$cache, /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */ function(getter, typedArray) {
        if (!found) try {
            // @ts-expect-error TODO: fix
            if ("$" + getter(value) === typedArray) found = $c2e61c703a2c9ae0$var$$slice(typedArray, 1);
        } catch (e) {}
    });
    return found;
};
/** @type {(value: object) => false | import('.').TypedArrayName} */ var $c2e61c703a2c9ae0$var$trySlices = function tryAllSlices(value) {
    /** @type {ReturnType<typeof tryAllSlices>} */ var found = false;
    $gFhA7(// eslint-disable-next-line no-extra-parens
    /** @type {Record<`\$${TypedArrayName}`, Getter>} */ /** @type {any} */ $c2e61c703a2c9ae0$var$cache, /** @type {(getter: typeof cache, name: `\$${import('.').TypedArrayName}`) => void} */ function(getter, name) {
        if (!found) try {
            // @ts-expect-error TODO: fix
            getter(value);
            found = $c2e61c703a2c9ae0$var$$slice(name, 1);
        } catch (e) {}
    });
    return found;
};
/** @type {import('.')} */ module.exports = function whichTypedArray(value) {
    if (!value || typeof value !== "object") return false;
    if (!$c2e61c703a2c9ae0$var$hasToStringTag) {
        /** @type {string} */ var tag = $c2e61c703a2c9ae0$var$$slice($c2e61c703a2c9ae0$var$$toString(value), 8, -1);
        if ($c2e61c703a2c9ae0$var$$indexOf($c2e61c703a2c9ae0$var$typedArrays, tag) > -1) return tag;
        if (tag !== "Object") return false;
        // node < 0.6 hits here on real Typed Arrays
        return $c2e61c703a2c9ae0$var$trySlices(value);
    }
    if (!$dYOee) return null;
     // unknown engine
    return $c2e61c703a2c9ae0$var$tryTypedArrays(value);
};

});
parcelRegister("gFhA7", function(module, exports) {
"use strict";

var $63RD0 = parcelRequire("63RD0");
var $c21e1d005400ef2a$var$toStr = Object.prototype.toString;
var $c21e1d005400ef2a$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $c21e1d005400ef2a$var$forEachArray = function forEachArray(array, iterator, receiver) {
    for(var i = 0, len = array.length; i < len; i++)if ($c21e1d005400ef2a$var$hasOwnProperty.call(array, i)) {
        if (receiver == null) iterator(array[i], i, array);
        else iterator.call(receiver, array[i], i, array);
    }
};
var $c21e1d005400ef2a$var$forEachString = function forEachString(string, iterator, receiver) {
    for(var i = 0, len = string.length; i < len; i++)// no such thing as a sparse string.
    if (receiver == null) iterator(string.charAt(i), i, string);
    else iterator.call(receiver, string.charAt(i), i, string);
};
var $c21e1d005400ef2a$var$forEachObject = function forEachObject(object, iterator, receiver) {
    for(var k in object)if ($c21e1d005400ef2a$var$hasOwnProperty.call(object, k)) {
        if (receiver == null) iterator(object[k], k, object);
        else iterator.call(receiver, object[k], k, object);
    }
};
var $c21e1d005400ef2a$var$forEach = function forEach(list, iterator, thisArg) {
    if (!$63RD0(iterator)) throw new TypeError("iterator must be a function");
    var receiver;
    if (arguments.length >= 3) receiver = thisArg;
    if ($c21e1d005400ef2a$var$toStr.call(list) === "[object Array]") $c21e1d005400ef2a$var$forEachArray(list, iterator, receiver);
    else if (typeof list === "string") $c21e1d005400ef2a$var$forEachString(list, iterator, receiver);
    else $c21e1d005400ef2a$var$forEachObject(list, iterator, receiver);
};
module.exports = $c21e1d005400ef2a$var$forEach;

});
parcelRegister("63RD0", function(module, exports) {
"use strict";
var $469c9f4bd3a650de$var$fnToStr = Function.prototype.toString;
var $469c9f4bd3a650de$var$reflectApply = typeof Reflect === "object" && Reflect !== null && Reflect.apply;
var $469c9f4bd3a650de$var$badArrayLike;
var $469c9f4bd3a650de$var$isCallableMarker;
if (typeof $469c9f4bd3a650de$var$reflectApply === "function" && typeof Object.defineProperty === "function") try {
    $469c9f4bd3a650de$var$badArrayLike = Object.defineProperty({}, "length", {
        get: function() {
            throw $469c9f4bd3a650de$var$isCallableMarker;
        }
    });
    $469c9f4bd3a650de$var$isCallableMarker = {};
    // eslint-disable-next-line no-throw-literal
    $469c9f4bd3a650de$var$reflectApply(function() {
        throw 42;
    }, null, $469c9f4bd3a650de$var$badArrayLike);
} catch (_) {
    if (_ !== $469c9f4bd3a650de$var$isCallableMarker) $469c9f4bd3a650de$var$reflectApply = null;
}
else $469c9f4bd3a650de$var$reflectApply = null;
var $469c9f4bd3a650de$var$constructorRegex = /^\s*class\b/;
var $469c9f4bd3a650de$var$isES6ClassFn = function isES6ClassFunction(value) {
    try {
        var fnStr = $469c9f4bd3a650de$var$fnToStr.call(value);
        return $469c9f4bd3a650de$var$constructorRegex.test(fnStr);
    } catch (e) {
        return false; // not a function
    }
};
var $469c9f4bd3a650de$var$tryFunctionObject = function tryFunctionToStr(value) {
    try {
        if ($469c9f4bd3a650de$var$isES6ClassFn(value)) return false;
        $469c9f4bd3a650de$var$fnToStr.call(value);
        return true;
    } catch (e) {
        return false;
    }
};
var $469c9f4bd3a650de$var$toStr = Object.prototype.toString;
var $469c9f4bd3a650de$var$objectClass = "[object Object]";
var $469c9f4bd3a650de$var$fnClass = "[object Function]";
var $469c9f4bd3a650de$var$genClass = "[object GeneratorFunction]";
var $469c9f4bd3a650de$var$ddaClass = "[object HTMLAllCollection]"; // IE 11
var $469c9f4bd3a650de$var$ddaClass2 = "[object HTML document.all class]";
var $469c9f4bd3a650de$var$ddaClass3 = "[object HTMLCollection]"; // IE 9-10
var $469c9f4bd3a650de$var$hasToStringTag = typeof Symbol === "function" && !!Symbol.toStringTag; // better: use `has-tostringtag`
var $469c9f4bd3a650de$var$isIE68 = !(0 in [
    , 
]); // eslint-disable-line no-sparse-arrays, comma-spacing
var $469c9f4bd3a650de$var$isDDA = function isDocumentDotAll() {
    return false;
};
if (typeof document === "object") {
    // Firefox 3 canonicalizes DDA to undefined when it's not accessed directly
    var $469c9f4bd3a650de$var$all = document.all;
    if ($469c9f4bd3a650de$var$toStr.call($469c9f4bd3a650de$var$all) === $469c9f4bd3a650de$var$toStr.call(document.all)) $469c9f4bd3a650de$var$isDDA = function isDocumentDotAll(value) {
        /* globals document: false */ // in IE 6-8, typeof document.all is "object" and it's truthy
        if (($469c9f4bd3a650de$var$isIE68 || !value) && (typeof value === "undefined" || typeof value === "object")) try {
            var str = $469c9f4bd3a650de$var$toStr.call(value);
            return (str === $469c9f4bd3a650de$var$ddaClass || str === $469c9f4bd3a650de$var$ddaClass2 || str === $469c9f4bd3a650de$var$ddaClass3 // opera 12.16
             || str === $469c9f4bd3a650de$var$objectClass // IE 6-8
            ) && value("") == null; // eslint-disable-line eqeqeq
        } catch (e) {}
        return false;
    };
}
module.exports = $469c9f4bd3a650de$var$reflectApply ? function isCallable(value) {
    if ($469c9f4bd3a650de$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== "function" && typeof value !== "object") return false;
    try {
        $469c9f4bd3a650de$var$reflectApply(value, null, $469c9f4bd3a650de$var$badArrayLike);
    } catch (e) {
        if (e !== $469c9f4bd3a650de$var$isCallableMarker) return false;
    }
    return !$469c9f4bd3a650de$var$isES6ClassFn(value) && $469c9f4bd3a650de$var$tryFunctionObject(value);
} : function isCallable(value) {
    if ($469c9f4bd3a650de$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== "function" && typeof value !== "object") return false;
    if ($469c9f4bd3a650de$var$hasToStringTag) return $469c9f4bd3a650de$var$tryFunctionObject(value);
    if ($469c9f4bd3a650de$var$isES6ClassFn(value)) return false;
    var strClass = $469c9f4bd3a650de$var$toStr.call(value);
    if (strClass !== $469c9f4bd3a650de$var$fnClass && strClass !== $469c9f4bd3a650de$var$genClass && !/^\[object HTML/.test(strClass)) return false;
    return $469c9f4bd3a650de$var$tryFunctionObject(value);
};

});


parcelRegister("8yXCr", function(module, exports) {
"use strict";

var $epJrh = parcelRequire("epJrh");
var $63bfbecf41903c8f$var$g = typeof globalThis === "undefined" ? $parcel$global : globalThis;
/** @type {import('.')} */ module.exports = function availableTypedArrays() {
    var /** @type {ReturnType<typeof availableTypedArrays>} */ out = [];
    for(var i = 0; i < $epJrh.length; i++)if (typeof $63bfbecf41903c8f$var$g[$epJrh[i]] === "function") // @ts-expect-error
    out[out.length] = $epJrh[i];
    return out;
};

});
parcelRegister("epJrh", function(module, exports) {
"use strict";
/** @type {import('.')} */ module.exports = [
    "Float32Array",
    "Float64Array",
    "Int8Array",
    "Int16Array",
    "Int32Array",
    "Uint8Array",
    "Uint8ClampedArray",
    "Uint16Array",
    "Uint32Array",
    "BigInt64Array",
    "BigUint64Array"
];

});



parcelRegister("hN833", function(module, exports) {
"use strict";

var $gJrpv = parcelRequire("gJrpv");
/** @type {import('.')} */ module.exports = function isTypedArray(value) {
    return !!$gJrpv(value);
};

});


parcelRegister("kotBY", function(module, exports) {
module.exports = function isBuffer(arg) {
    return arg && typeof arg === "object" && typeof arg.copy === "function" && typeof arg.fill === "function" && typeof arg.readUInt8 === "function";
};

});

parcelRegister("dlqwk", function(module, exports) {
if (typeof Object.create === "function") // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};

});



parcelRegister("8pS6q", function(module, exports) {
// Currently in sync with Node.js lib/internal/assert/assertion_error.js
// https://github.com/nodejs/node/commit/0817840f775032169ddd70c85ac059f18ffcc81c

var $hPtJY = parcelRequire("hPtJY");
"use strict";
function $620aa032cca82da4$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $620aa032cca82da4$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $620aa032cca82da4$var$ownKeys(Object(t), !0).forEach(function(r) {
            $620aa032cca82da4$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $620aa032cca82da4$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $620aa032cca82da4$var$_defineProperty(obj, key, value) {
    key = $620aa032cca82da4$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $620aa032cca82da4$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $620aa032cca82da4$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $620aa032cca82da4$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $620aa032cca82da4$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $620aa032cca82da4$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $620aa032cca82da4$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $620aa032cca82da4$var$_toPropertyKey(arg) {
    var key = $620aa032cca82da4$var$_toPrimitive(arg, "string");
    return $620aa032cca82da4$var$_typeof(key) === "symbol" ? key : String(key);
}
function $620aa032cca82da4$var$_toPrimitive(input, hint) {
    if ($620aa032cca82da4$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($620aa032cca82da4$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $620aa032cca82da4$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $620aa032cca82da4$var$_setPrototypeOf(subClass, superClass);
}
function $620aa032cca82da4$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $620aa032cca82da4$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $620aa032cca82da4$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $620aa032cca82da4$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $620aa032cca82da4$var$_possibleConstructorReturn(this, result);
    };
}
function $620aa032cca82da4$var$_possibleConstructorReturn(self, call) {
    if (call && ($620aa032cca82da4$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $620aa032cca82da4$var$_assertThisInitialized(self);
}
function $620aa032cca82da4$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $620aa032cca82da4$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $620aa032cca82da4$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$620aa032cca82da4$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $620aa032cca82da4$var$_construct(Class, arguments, $620aa032cca82da4$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $620aa032cca82da4$var$_setPrototypeOf(Wrapper, Class);
    };
    return $620aa032cca82da4$var$_wrapNativeSuper(Class);
}
function $620aa032cca82da4$var$_construct(Parent, args, Class) {
    if ($620aa032cca82da4$var$_isNativeReflectConstruct()) $620aa032cca82da4$var$_construct = Reflect.construct.bind();
    else $620aa032cca82da4$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $620aa032cca82da4$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $620aa032cca82da4$var$_construct.apply(null, arguments);
}
function $620aa032cca82da4$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $620aa032cca82da4$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $620aa032cca82da4$var$_setPrototypeOf(o, p) {
    $620aa032cca82da4$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $620aa032cca82da4$var$_setPrototypeOf(o, p);
}
function $620aa032cca82da4$var$_getPrototypeOf(o) {
    $620aa032cca82da4$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $620aa032cca82da4$var$_getPrototypeOf(o);
}
function $620aa032cca82da4$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $620aa032cca82da4$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $620aa032cca82da4$var$_typeof(o);
}

var $N7Lcz = parcelRequire("N7Lcz");
var $620aa032cca82da4$var$inspect = $N7Lcz.inspect;

var $cCihK = parcelRequire("cCihK");
var $620aa032cca82da4$var$ERR_INVALID_ARG_TYPE = $cCihK.codes.ERR_INVALID_ARG_TYPE;
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $620aa032cca82da4$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/repeat
function $620aa032cca82da4$var$repeat(str, count) {
    count = Math.floor(count);
    if (str.length == 0 || count == 0) return "";
    var maxCount = str.length * count;
    count = Math.floor(Math.log(count) / Math.log(2));
    while(count){
        str += str;
        count--;
    }
    str += str.substring(0, maxCount - str.length);
    return str;
}
var $620aa032cca82da4$var$blue = "";
var $620aa032cca82da4$var$green = "";
var $620aa032cca82da4$var$red = "";
var $620aa032cca82da4$var$white = "";
var $620aa032cca82da4$var$kReadableOperator = {
    deepStrictEqual: "Expected values to be strictly deep-equal:",
    strictEqual: "Expected values to be strictly equal:",
    strictEqualObject: 'Expected "actual" to be reference-equal to "expected":',
    deepEqual: "Expected values to be loosely deep-equal:",
    equal: "Expected values to be loosely equal:",
    notDeepStrictEqual: 'Expected "actual" not to be strictly deep-equal to:',
    notStrictEqual: 'Expected "actual" to be strictly unequal to:',
    notStrictEqualObject: 'Expected "actual" not to be reference-equal to "expected":',
    notDeepEqual: 'Expected "actual" not to be loosely deep-equal to:',
    notEqual: 'Expected "actual" to be loosely unequal to:',
    notIdentical: "Values identical but not reference-equal:"
};
// Comparing short primitives should just show === / !== instead of using the
// diff.
var $620aa032cca82da4$var$kMaxShortLength = 10;
function $620aa032cca82da4$var$copyError(source) {
    var keys = Object.keys(source);
    var target = Object.create(Object.getPrototypeOf(source));
    keys.forEach(function(key) {
        target[key] = source[key];
    });
    Object.defineProperty(target, "message", {
        value: source.message
    });
    return target;
}
function $620aa032cca82da4$var$inspectValue(val) {
    // The util.inspect default values could be changed. This makes sure the
    // error messages contain the necessary information nevertheless.
    return $620aa032cca82da4$var$inspect(val, {
        compact: false,
        customInspect: false,
        depth: 1000,
        maxArrayLength: Infinity,
        // Assert compares only enumerable properties (with a few exceptions).
        showHidden: false,
        // Having a long line as error is better than wrapping the line for
        // comparison for now.
        // TODO(BridgeAR): `breakLength` should be limited as soon as soon as we
        // have meta information about the inspected properties (i.e., know where
        // in what line the property starts and ends).
        breakLength: Infinity,
        // Assert does not detect proxies currently.
        showProxy: false,
        sorted: true,
        // Inspect getters as we also check them when comparing entries.
        getters: true
    });
}
function $620aa032cca82da4$var$createErrDiff(actual, expected, operator) {
    var other = "";
    var res = "";
    var lastPos = 0;
    var end = "";
    var skipped = false;
    var actualInspected = $620aa032cca82da4$var$inspectValue(actual);
    var actualLines = actualInspected.split("\n");
    var expectedLines = $620aa032cca82da4$var$inspectValue(expected).split("\n");
    var i = 0;
    var indicator = "";
    // In case both values are objects explicitly mark them as not reference equal
    // for the `strictEqual` operator.
    if (operator === "strictEqual" && $620aa032cca82da4$var$_typeof(actual) === "object" && $620aa032cca82da4$var$_typeof(expected) === "object" && actual !== null && expected !== null) operator = "strictEqualObject";
    // If "actual" and "expected" fit on a single line and they are not strictly
    // equal, check further special handling.
    if (actualLines.length === 1 && expectedLines.length === 1 && actualLines[0] !== expectedLines[0]) {
        var inputLength = actualLines[0].length + expectedLines[0].length;
        // If the character length of "actual" and "expected" together is less than
        // kMaxShortLength and if neither is an object and at least one of them is
        // not `zero`, use the strict equal comparison to visualize the output.
        if (inputLength <= $620aa032cca82da4$var$kMaxShortLength) {
            if (($620aa032cca82da4$var$_typeof(actual) !== "object" || actual === null) && ($620aa032cca82da4$var$_typeof(expected) !== "object" || expected === null) && (actual !== 0 || expected !== 0)) // -0 === +0
            return "".concat($620aa032cca82da4$var$kReadableOperator[operator], "\n\n") + "".concat(actualLines[0], " !== ").concat(expectedLines[0], "\n");
        } else if (operator !== "strictEqualObject") {
            // If the stderr is a tty and the input length is lower than the current
            // columns per line, add a mismatch indicator below the output. If it is
            // not a tty, use a default value of 80 characters.
            var maxLength = $hPtJY.stderr && $hPtJY.stderr.isTTY ? $hPtJY.stderr.columns : 80;
            if (inputLength < maxLength) {
                while(actualLines[0][i] === expectedLines[0][i])i++;
                // Ignore the first characters.
                if (i > 2) {
                    // Add position indicator for the first mismatch in case it is a
                    // single line and the input length is less than the column length.
                    indicator = "\n  ".concat($620aa032cca82da4$var$repeat(" ", i), "^");
                    i = 0;
                }
            }
        }
    }
    // Remove all ending lines that match (this optimizes the output for
    // readability by reducing the number of total changed lines).
    var a = actualLines[actualLines.length - 1];
    var b = expectedLines[expectedLines.length - 1];
    while(a === b){
        if (i++ < 2) end = "\n  ".concat(a).concat(end);
        else other = a;
        actualLines.pop();
        expectedLines.pop();
        if (actualLines.length === 0 || expectedLines.length === 0) break;
        a = actualLines[actualLines.length - 1];
        b = expectedLines[expectedLines.length - 1];
    }
    var maxLines = Math.max(actualLines.length, expectedLines.length);
    // Strict equal with identical objects that are not identical by reference.
    // E.g., assert.deepStrictEqual({ a: Symbol() }, { a: Symbol() })
    if (maxLines === 0) {
        // We have to get the result again. The lines were all removed before.
        var _actualLines = actualInspected.split("\n");
        // Only remove lines in case it makes sense to collapse those.
        // TODO: Accept env to always show the full error.
        if (_actualLines.length > 30) {
            _actualLines[26] = "".concat($620aa032cca82da4$var$blue, "...").concat($620aa032cca82da4$var$white);
            while(_actualLines.length > 27)_actualLines.pop();
        }
        return "".concat($620aa032cca82da4$var$kReadableOperator.notIdentical, "\n\n").concat(_actualLines.join("\n"), "\n");
    }
    if (i > 3) {
        end = "\n".concat($620aa032cca82da4$var$blue, "...").concat($620aa032cca82da4$var$white).concat(end);
        skipped = true;
    }
    if (other !== "") {
        end = "\n  ".concat(other).concat(end);
        other = "";
    }
    var printedLines = 0;
    var msg = $620aa032cca82da4$var$kReadableOperator[operator] + "\n".concat($620aa032cca82da4$var$green, "+ actual").concat($620aa032cca82da4$var$white, " ").concat($620aa032cca82da4$var$red, "- expected").concat($620aa032cca82da4$var$white);
    var skippedMsg = " ".concat($620aa032cca82da4$var$blue, "...").concat($620aa032cca82da4$var$white, " Lines skipped");
    for(i = 0; i < maxLines; i++){
        // Only extra expected lines exist
        var cur = i - lastPos;
        if (actualLines.length < i + 1) {
            // If the last diverging line is more than one line above and the
            // current line is at least line three, add some of the former lines and
            // also add dots to indicate skipped entries.
            if (cur > 1 && i > 2) {
                if (cur > 4) {
                    res += "\n".concat($620aa032cca82da4$var$blue, "...").concat($620aa032cca82da4$var$white);
                    skipped = true;
                } else if (cur > 3) {
                    res += "\n  ".concat(expectedLines[i - 2]);
                    printedLines++;
                }
                res += "\n  ".concat(expectedLines[i - 1]);
                printedLines++;
            }
            // Mark the current line as the last diverging one.
            lastPos = i;
            // Add the expected line to the cache.
            other += "\n".concat($620aa032cca82da4$var$red, "-").concat($620aa032cca82da4$var$white, " ").concat(expectedLines[i]);
            printedLines++;
        // Only extra actual lines exist
        } else if (expectedLines.length < i + 1) {
            // If the last diverging line is more than one line above and the
            // current line is at least line three, add some of the former lines and
            // also add dots to indicate skipped entries.
            if (cur > 1 && i > 2) {
                if (cur > 4) {
                    res += "\n".concat($620aa032cca82da4$var$blue, "...").concat($620aa032cca82da4$var$white);
                    skipped = true;
                } else if (cur > 3) {
                    res += "\n  ".concat(actualLines[i - 2]);
                    printedLines++;
                }
                res += "\n  ".concat(actualLines[i - 1]);
                printedLines++;
            }
            // Mark the current line as the last diverging one.
            lastPos = i;
            // Add the actual line to the result.
            res += "\n".concat($620aa032cca82da4$var$green, "+").concat($620aa032cca82da4$var$white, " ").concat(actualLines[i]);
            printedLines++;
        // Lines diverge
        } else {
            var expectedLine = expectedLines[i];
            var actualLine = actualLines[i];
            // If the lines diverge, specifically check for lines that only diverge by
            // a trailing comma. In that case it is actually identical and we should
            // mark it as such.
            var divergingLines = actualLine !== expectedLine && (!$620aa032cca82da4$var$endsWith(actualLine, ",") || actualLine.slice(0, -1) !== expectedLine);
            // If the expected line has a trailing comma but is otherwise identical,
            // add a comma at the end of the actual line. Otherwise the output could
            // look weird as in:
            //
            //   [
            //     1         // No comma at the end!
            // +   2
            //   ]
            //
            if (divergingLines && $620aa032cca82da4$var$endsWith(expectedLine, ",") && expectedLine.slice(0, -1) === actualLine) {
                divergingLines = false;
                actualLine += ",";
            }
            if (divergingLines) {
                // If the last diverging line is more than one line above and the
                // current line is at least line three, add some of the former lines and
                // also add dots to indicate skipped entries.
                if (cur > 1 && i > 2) {
                    if (cur > 4) {
                        res += "\n".concat($620aa032cca82da4$var$blue, "...").concat($620aa032cca82da4$var$white);
                        skipped = true;
                    } else if (cur > 3) {
                        res += "\n  ".concat(actualLines[i - 2]);
                        printedLines++;
                    }
                    res += "\n  ".concat(actualLines[i - 1]);
                    printedLines++;
                }
                // Mark the current line as the last diverging one.
                lastPos = i;
                // Add the actual line to the result and cache the expected diverging
                // line so consecutive diverging lines show up as +++--- and not +-+-+-.
                res += "\n".concat($620aa032cca82da4$var$green, "+").concat($620aa032cca82da4$var$white, " ").concat(actualLine);
                other += "\n".concat($620aa032cca82da4$var$red, "-").concat($620aa032cca82da4$var$white, " ").concat(expectedLine);
                printedLines += 2;
            // Lines are identical
            } else {
                // Add all cached information to the result before adding other things
                // and reset the cache.
                res += other;
                other = "";
                // If the last diverging line is exactly one line above or if it is the
                // very first line, add the line to the result.
                if (cur === 1 || i === 0) {
                    res += "\n  ".concat(actualLine);
                    printedLines++;
                }
            }
        }
        // Inspected object to big (Show ~20 rows max)
        if (printedLines > 20 && i < maxLines - 2) return "".concat(msg).concat(skippedMsg, "\n").concat(res, "\n").concat($620aa032cca82da4$var$blue, "...").concat($620aa032cca82da4$var$white).concat(other, "\n") + "".concat($620aa032cca82da4$var$blue, "...").concat($620aa032cca82da4$var$white);
    }
    return "".concat(msg).concat(skipped ? skippedMsg : "", "\n").concat(res).concat(other).concat(end).concat(indicator);
}
var $620aa032cca82da4$var$AssertionError = /*#__PURE__*/ function(_Error, _inspect$custom) {
    $620aa032cca82da4$var$_inherits(AssertionError, _Error);
    var _super = $620aa032cca82da4$var$_createSuper(AssertionError);
    function AssertionError(options) {
        var _this;
        $620aa032cca82da4$var$_classCallCheck(this, AssertionError);
        if ($620aa032cca82da4$var$_typeof(options) !== "object" || options === null) throw new $620aa032cca82da4$var$ERR_INVALID_ARG_TYPE("options", "Object", options);
        var message = options.message, operator = options.operator, stackStartFn = options.stackStartFn;
        var actual = options.actual, expected = options.expected;
        var limit = Error.stackTraceLimit;
        Error.stackTraceLimit = 0;
        if (message != null) _this = _super.call(this, String(message));
        else {
            if ($hPtJY.stderr && $hPtJY.stderr.isTTY) {
                // Reset on each call to make sure we handle dynamically set environment
                // variables correct.
                if ($hPtJY.stderr && $hPtJY.stderr.getColorDepth && $hPtJY.stderr.getColorDepth() !== 1) {
                    $620aa032cca82da4$var$blue = "\x1b[34m";
                    $620aa032cca82da4$var$green = "\x1b[32m";
                    $620aa032cca82da4$var$white = "\x1b[39m";
                    $620aa032cca82da4$var$red = "\x1b[31m";
                } else {
                    $620aa032cca82da4$var$blue = "";
                    $620aa032cca82da4$var$green = "";
                    $620aa032cca82da4$var$white = "";
                    $620aa032cca82da4$var$red = "";
                }
            }
            // Prevent the error stack from being visible by duplicating the error
            // in a very close way to the original in case both sides are actually
            // instances of Error.
            if ($620aa032cca82da4$var$_typeof(actual) === "object" && actual !== null && $620aa032cca82da4$var$_typeof(expected) === "object" && expected !== null && "stack" in actual && actual instanceof Error && "stack" in expected && expected instanceof Error) {
                actual = $620aa032cca82da4$var$copyError(actual);
                expected = $620aa032cca82da4$var$copyError(expected);
            }
            if (operator === "deepStrictEqual" || operator === "strictEqual") _this = _super.call(this, $620aa032cca82da4$var$createErrDiff(actual, expected, operator));
            else if (operator === "notDeepStrictEqual" || operator === "notStrictEqual") {
                // In case the objects are equal but the operator requires unequal, show
                // the first object and say A equals B
                var base = $620aa032cca82da4$var$kReadableOperator[operator];
                var res = $620aa032cca82da4$var$inspectValue(actual).split("\n");
                // In case "actual" is an object, it should not be reference equal.
                if (operator === "notStrictEqual" && $620aa032cca82da4$var$_typeof(actual) === "object" && actual !== null) base = $620aa032cca82da4$var$kReadableOperator.notStrictEqualObject;
                // Only remove lines in case it makes sense to collapse those.
                // TODO: Accept env to always show the full error.
                if (res.length > 30) {
                    res[26] = "".concat($620aa032cca82da4$var$blue, "...").concat($620aa032cca82da4$var$white);
                    while(res.length > 27)res.pop();
                }
                // Only print a single input.
                if (res.length === 1) _this = _super.call(this, "".concat(base, " ").concat(res[0]));
                else _this = _super.call(this, "".concat(base, "\n\n").concat(res.join("\n"), "\n"));
            } else {
                var _res = $620aa032cca82da4$var$inspectValue(actual);
                var other = "";
                var knownOperators = $620aa032cca82da4$var$kReadableOperator[operator];
                if (operator === "notDeepEqual" || operator === "notEqual") {
                    _res = "".concat($620aa032cca82da4$var$kReadableOperator[operator], "\n\n").concat(_res);
                    if (_res.length > 1024) _res = "".concat(_res.slice(0, 1021), "...");
                } else {
                    other = "".concat($620aa032cca82da4$var$inspectValue(expected));
                    if (_res.length > 512) _res = "".concat(_res.slice(0, 509), "...");
                    if (other.length > 512) other = "".concat(other.slice(0, 509), "...");
                    if (operator === "deepEqual" || operator === "equal") _res = "".concat(knownOperators, "\n\n").concat(_res, "\n\nshould equal\n\n");
                    else other = " ".concat(operator, " ").concat(other);
                }
                _this = _super.call(this, "".concat(_res).concat(other));
            }
        }
        Error.stackTraceLimit = limit;
        _this.generatedMessage = !message;
        Object.defineProperty($620aa032cca82da4$var$_assertThisInitialized(_this), "name", {
            value: "AssertionError [ERR_ASSERTION]",
            enumerable: false,
            writable: true,
            configurable: true
        });
        _this.code = "ERR_ASSERTION";
        _this.actual = actual;
        _this.expected = expected;
        _this.operator = operator;
        if (Error.captureStackTrace) // eslint-disable-next-line no-restricted-syntax
        Error.captureStackTrace($620aa032cca82da4$var$_assertThisInitialized(_this), stackStartFn);
        // Create error message including the error code in the name.
        _this.stack;
        // Reset the name.
        _this.name = "AssertionError";
        return $620aa032cca82da4$var$_possibleConstructorReturn(_this);
    }
    $620aa032cca82da4$var$_createClass(AssertionError, [
        {
            key: "toString",
            value: function toString() {
                return "".concat(this.name, " [").concat(this.code, "]: ").concat(this.message);
            }
        },
        {
            key: _inspect$custom,
            value: function value(recurseTimes, ctx) {
                // This limits the `actual` and `expected` property default inspection to
                // the minimum depth. Otherwise those values would be too verbose compared
                // to the actual error message which contains a combined view of these two
                // input values.
                return $620aa032cca82da4$var$inspect(this, $620aa032cca82da4$var$_objectSpread($620aa032cca82da4$var$_objectSpread({}, ctx), {}, {
                    customInspect: false,
                    depth: 0
                }));
            }
        }
    ]);
    return AssertionError;
}(/*#__PURE__*/ $620aa032cca82da4$var$_wrapNativeSuper(Error), $620aa032cca82da4$var$inspect.custom);
module.exports = $620aa032cca82da4$var$AssertionError;

});

parcelRegister("boX8x", function(module, exports) {
"use strict";

var $aHVV7 = parcelRequire("aHVV7");
var $84cfceeae7d9941c$var$lacksProperEnumerationOrder = function() {
    if (!Object.assign) return false;
    /*
	 * v8, specifically in node 4.x, has a bug with incorrect property enumeration order
	 * note: this does not detect the bug unless there's 20 characters
	 */ var str = "abcdefghijklmnopqrst";
    var letters = str.split("");
    var map = {};
    for(var i = 0; i < letters.length; ++i)map[letters[i]] = letters[i];
    var obj = Object.assign({}, map);
    var actual = "";
    for(var k in obj)actual += k;
    return str !== actual;
};
var $84cfceeae7d9941c$var$assignHasPendingExceptions = function() {
    if (!Object.assign || !Object.preventExtensions) return false;
    /*
	 * Firefox 37 still has "pending exception" logic in its Object.assign implementation,
	 * which is 72% slower than our shim, and Firefox 40's native implementation.
	 */ var thrower = Object.preventExtensions({
        1: 2
    });
    try {
        Object.assign(thrower, "xy");
    } catch (e) {
        return thrower[1] === "y";
    }
    return false;
};
module.exports = function getPolyfill() {
    if (!Object.assign) return $aHVV7;
    if ($84cfceeae7d9941c$var$lacksProperEnumerationOrder()) return $aHVV7;
    if ($84cfceeae7d9941c$var$assignHasPendingExceptions()) return $aHVV7;
    return Object.assign;
};

});
parcelRegister("aHVV7", function(module, exports) {
"use strict";

var $81enX = parcelRequire("81enX");

var $7cbad94b4017a2be$var$hasSymbols = (parcelRequire("7YWkK"))();

var $hXu6F = parcelRequire("hXu6F");
var $7cbad94b4017a2be$var$toObject = Object;
var $7cbad94b4017a2be$var$$push = $hXu6F("Array.prototype.push");
var $7cbad94b4017a2be$var$$propIsEnumerable = $hXu6F("Object.prototype.propertyIsEnumerable");
var $7cbad94b4017a2be$var$originalGetSymbols = $7cbad94b4017a2be$var$hasSymbols ? Object.getOwnPropertySymbols : null;
// eslint-disable-next-line no-unused-vars
module.exports = function assign(target, source1) {
    if (target == null) throw new TypeError("target must be an object");
    var to = $7cbad94b4017a2be$var$toObject(target); // step 1
    if (arguments.length === 1) return to; // step 2
    for(var s = 1; s < arguments.length; ++s){
        var from = $7cbad94b4017a2be$var$toObject(arguments[s]); // step 3.a.i
        // step 3.a.ii:
        var keys = $81enX(from);
        var getSymbols = $7cbad94b4017a2be$var$hasSymbols && (Object.getOwnPropertySymbols || $7cbad94b4017a2be$var$originalGetSymbols);
        if (getSymbols) {
            var syms = getSymbols(from);
            for(var j = 0; j < syms.length; ++j){
                var key = syms[j];
                if ($7cbad94b4017a2be$var$$propIsEnumerable(from, key)) $7cbad94b4017a2be$var$$push(keys, key);
            }
        }
        // step 3.a.iii:
        for(var i = 0; i < keys.length; ++i){
            var nextKey = keys[i];
            if ($7cbad94b4017a2be$var$$propIsEnumerable(from, nextKey)) {
                var propValue = from[nextKey]; // step 3.a.iii.2.a
                to[nextKey] = propValue; // step 3.a.iii.2.b
            }
        }
    }
    return to; // step 4
};

});
parcelRegister("81enX", function(module, exports) {
"use strict";
var $5d69935f2747da8d$var$slice = Array.prototype.slice;

var $z1gio = parcelRequire("z1gio");
var $5d69935f2747da8d$var$origKeys = Object.keys;

var $5d69935f2747da8d$var$keysShim = $5d69935f2747da8d$var$origKeys ? function keys(o) {
    return $5d69935f2747da8d$var$origKeys(o);
} : (parcelRequire("4nFCC"));
var $5d69935f2747da8d$var$originalKeys = Object.keys;
$5d69935f2747da8d$var$keysShim.shim = function shimObjectKeys() {
    if (Object.keys) {
        var keysWorksWithArguments = function() {
            // Safari 5.0 bug
            var args = Object.keys(arguments);
            return args && args.length === arguments.length;
        }(1, 2);
        if (!keysWorksWithArguments) Object.keys = function keys(object) {
            if ($z1gio(object)) return $5d69935f2747da8d$var$originalKeys($5d69935f2747da8d$var$slice.call(object));
            return $5d69935f2747da8d$var$originalKeys(object);
        };
    } else Object.keys = $5d69935f2747da8d$var$keysShim;
    return Object.keys || $5d69935f2747da8d$var$keysShim;
};
module.exports = $5d69935f2747da8d$var$keysShim;

});
parcelRegister("z1gio", function(module, exports) {
"use strict";
var $06943f92b55ad7fa$var$toStr = Object.prototype.toString;
module.exports = function isArguments(value) {
    var str = $06943f92b55ad7fa$var$toStr.call(value);
    var isArgs = str === "[object Arguments]";
    if (!isArgs) isArgs = str !== "[object Array]" && value !== null && typeof value === "object" && typeof value.length === "number" && value.length >= 0 && $06943f92b55ad7fa$var$toStr.call(value.callee) === "[object Function]";
    return isArgs;
};

});

parcelRegister("4nFCC", function(module, exports) {
"use strict";
var $330998a67e44345d$var$keysShim;

if (!Object.keys) {
    // modified from https://github.com/es-shims/es5-shim
    var $330998a67e44345d$var$has = Object.prototype.hasOwnProperty;
    var $330998a67e44345d$var$toStr = Object.prototype.toString;
    var $330998a67e44345d$var$isArgs = (parcelRequire("z1gio")); // eslint-disable-line global-require
    var $330998a67e44345d$var$isEnumerable = Object.prototype.propertyIsEnumerable;
    var $330998a67e44345d$var$hasDontEnumBug = !$330998a67e44345d$var$isEnumerable.call({
        toString: null
    }, "toString");
    var $330998a67e44345d$var$hasProtoEnumBug = $330998a67e44345d$var$isEnumerable.call(function() {}, "prototype");
    var $330998a67e44345d$var$dontEnums = [
        "toString",
        "toLocaleString",
        "valueOf",
        "hasOwnProperty",
        "isPrototypeOf",
        "propertyIsEnumerable",
        "constructor"
    ];
    var $330998a67e44345d$var$equalsConstructorPrototype = function(o) {
        var ctor = o.constructor;
        return ctor && ctor.prototype === o;
    };
    var $330998a67e44345d$var$excludedKeys = {
        $applicationCache: true,
        $console: true,
        $external: true,
        $frame: true,
        $frameElement: true,
        $frames: true,
        $innerHeight: true,
        $innerWidth: true,
        $onmozfullscreenchange: true,
        $onmozfullscreenerror: true,
        $outerHeight: true,
        $outerWidth: true,
        $pageXOffset: true,
        $pageYOffset: true,
        $parent: true,
        $scrollLeft: true,
        $scrollTop: true,
        $scrollX: true,
        $scrollY: true,
        $self: true,
        $webkitIndexedDB: true,
        $webkitStorageInfo: true,
        $window: true
    };
    var $330998a67e44345d$var$hasAutomationEqualityBug = function() {
        /* global window */ if (typeof window === "undefined") return false;
        for(var k in window)try {
            if (!$330998a67e44345d$var$excludedKeys["$" + k] && $330998a67e44345d$var$has.call(window, k) && window[k] !== null && typeof window[k] === "object") try {
                $330998a67e44345d$var$equalsConstructorPrototype(window[k]);
            } catch (e) {
                return true;
            }
        } catch (e) {
            return true;
        }
        return false;
    }();
    var $330998a67e44345d$var$equalsConstructorPrototypeIfNotBuggy = function(o) {
        /* global window */ if (typeof window === "undefined" || !$330998a67e44345d$var$hasAutomationEqualityBug) return $330998a67e44345d$var$equalsConstructorPrototype(o);
        try {
            return $330998a67e44345d$var$equalsConstructorPrototype(o);
        } catch (e) {
            return false;
        }
    };
    $330998a67e44345d$var$keysShim = function keys(object) {
        var isObject = object !== null && typeof object === "object";
        var isFunction = $330998a67e44345d$var$toStr.call(object) === "[object Function]";
        var isArguments = $330998a67e44345d$var$isArgs(object);
        var isString = isObject && $330998a67e44345d$var$toStr.call(object) === "[object String]";
        var theKeys = [];
        if (!isObject && !isFunction && !isArguments) throw new TypeError("Object.keys called on a non-object");
        var skipProto = $330998a67e44345d$var$hasProtoEnumBug && isFunction;
        if (isString && object.length > 0 && !$330998a67e44345d$var$has.call(object, 0)) for(var i = 0; i < object.length; ++i)theKeys.push(String(i));
        if (isArguments && object.length > 0) for(var j = 0; j < object.length; ++j)theKeys.push(String(j));
        else {
            for(var name in object)if (!(skipProto && name === "prototype") && $330998a67e44345d$var$has.call(object, name)) theKeys.push(String(name));
        }
        if ($330998a67e44345d$var$hasDontEnumBug) {
            var skipConstructor = $330998a67e44345d$var$equalsConstructorPrototypeIfNotBuggy(object);
            for(var k = 0; k < $330998a67e44345d$var$dontEnums.length; ++k)if (!(skipConstructor && $330998a67e44345d$var$dontEnums[k] === "constructor") && $330998a67e44345d$var$has.call(object, $330998a67e44345d$var$dontEnums[k])) theKeys.push($330998a67e44345d$var$dontEnums[k]);
        }
        return theKeys;
    };
}
module.exports = $330998a67e44345d$var$keysShim;

});




parcelRegister("5SxoI", function(module, exports) {
"use strict";

var $6wuPW = parcelRequire("6wuPW");
module.exports = function getPolyfill() {
    return typeof Object.is === "function" ? Object.is : $6wuPW;
};

});
parcelRegister("6wuPW", function(module, exports) {
"use strict";
var $4bfda6cb765ad269$var$numberIsNaN = function(value) {
    return value !== value;
};
module.exports = function is(a, b) {
    if (a === 0 && b === 0) return 1 / a === 1 / b;
    if (a === b) return true;
    if ($4bfda6cb765ad269$var$numberIsNaN(a) && $4bfda6cb765ad269$var$numberIsNaN(b)) return true;
    return false;
};

});


parcelRegister("3LKhK", function(module, exports) {
// Currently in sync with Node.js lib/internal/util/comparisons.js
// https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9
"use strict";
function $2be9aa30bff457b9$var$_slicedToArray(arr, i) {
    return $2be9aa30bff457b9$var$_arrayWithHoles(arr) || $2be9aa30bff457b9$var$_iterableToArrayLimit(arr, i) || $2be9aa30bff457b9$var$_unsupportedIterableToArray(arr, i) || $2be9aa30bff457b9$var$_nonIterableRest();
}
function $2be9aa30bff457b9$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $2be9aa30bff457b9$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $2be9aa30bff457b9$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $2be9aa30bff457b9$var$_arrayLikeToArray(o, minLen);
}
function $2be9aa30bff457b9$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $2be9aa30bff457b9$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $2be9aa30bff457b9$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $2be9aa30bff457b9$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $2be9aa30bff457b9$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $2be9aa30bff457b9$var$_typeof(o);
}
var $2be9aa30bff457b9$var$regexFlagsSupported = /a/g.flags !== undefined;
var $2be9aa30bff457b9$var$arrayFromSet = function arrayFromSet(set) {
    var array = [];
    set.forEach(function(value) {
        return array.push(value);
    });
    return array;
};
var $2be9aa30bff457b9$var$arrayFromMap = function arrayFromMap(map) {
    var array = [];
    map.forEach(function(value, key) {
        return array.push([
            key,
            value
        ]);
    });
    return array;
};

var $2be9aa30bff457b9$var$objectIs = Object.is ? Object.is : (parcelRequire("eT9RM"));
var $2be9aa30bff457b9$var$objectGetOwnPropertySymbols = Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols : function() {
    return [];
};

var $2be9aa30bff457b9$var$numberIsNaN = Number.isNaN ? Number.isNaN : (parcelRequire("c8Cyq"));
function $2be9aa30bff457b9$var$uncurryThis(f) {
    return f.call.bind(f);
}
var $2be9aa30bff457b9$var$hasOwnProperty = $2be9aa30bff457b9$var$uncurryThis(Object.prototype.hasOwnProperty);
var $2be9aa30bff457b9$var$propertyIsEnumerable = $2be9aa30bff457b9$var$uncurryThis(Object.prototype.propertyIsEnumerable);
var $2be9aa30bff457b9$var$objectToString = $2be9aa30bff457b9$var$uncurryThis(Object.prototype.toString);

var $N7Lcz = parcelRequire("N7Lcz");
var $2be9aa30bff457b9$require$_require$types = $N7Lcz.types;
var $2be9aa30bff457b9$var$isAnyArrayBuffer = $2be9aa30bff457b9$require$_require$types.isAnyArrayBuffer, $2be9aa30bff457b9$var$isArrayBufferView = $2be9aa30bff457b9$require$_require$types.isArrayBufferView, $2be9aa30bff457b9$var$isDate = $2be9aa30bff457b9$require$_require$types.isDate, $2be9aa30bff457b9$var$isMap = $2be9aa30bff457b9$require$_require$types.isMap, $2be9aa30bff457b9$var$isRegExp = $2be9aa30bff457b9$require$_require$types.isRegExp, $2be9aa30bff457b9$var$isSet = $2be9aa30bff457b9$require$_require$types.isSet, $2be9aa30bff457b9$var$isNativeError = $2be9aa30bff457b9$require$_require$types.isNativeError, $2be9aa30bff457b9$var$isBoxedPrimitive = $2be9aa30bff457b9$require$_require$types.isBoxedPrimitive, $2be9aa30bff457b9$var$isNumberObject = $2be9aa30bff457b9$require$_require$types.isNumberObject, $2be9aa30bff457b9$var$isStringObject = $2be9aa30bff457b9$require$_require$types.isStringObject, $2be9aa30bff457b9$var$isBooleanObject = $2be9aa30bff457b9$require$_require$types.isBooleanObject, $2be9aa30bff457b9$var$isBigIntObject = $2be9aa30bff457b9$require$_require$types.isBigIntObject, $2be9aa30bff457b9$var$isSymbolObject = $2be9aa30bff457b9$require$_require$types.isSymbolObject, $2be9aa30bff457b9$var$isFloat32Array = $2be9aa30bff457b9$require$_require$types.isFloat32Array, $2be9aa30bff457b9$var$isFloat64Array = $2be9aa30bff457b9$require$_require$types.isFloat64Array;
function $2be9aa30bff457b9$var$isNonIndex(key) {
    if (key.length === 0 || key.length > 10) return true;
    for(var i = 0; i < key.length; i++){
        var code = key.charCodeAt(i);
        if (code < 48 || code > 57) return true;
    }
    // The maximum size for an array is 2 ** 32 -1.
    return key.length === 10 && key >= Math.pow(2, 32);
}
function $2be9aa30bff457b9$var$getOwnNonIndexProperties(value) {
    return Object.keys(value).filter($2be9aa30bff457b9$var$isNonIndex).concat($2be9aa30bff457b9$var$objectGetOwnPropertySymbols(value).filter(Object.prototype.propertyIsEnumerable.bind(value)));
}
// Taken from https://github.com/feross/buffer/blob/680e9e5e488f22aac27599a57dc844a6315928dd/index.js
// original notice:
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */ function $2be9aa30bff457b9$var$compare(a, b) {
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
}
var $2be9aa30bff457b9$var$ONLY_ENUMERABLE = undefined;
var $2be9aa30bff457b9$var$kStrict = true;
var $2be9aa30bff457b9$var$kLoose = false;
var $2be9aa30bff457b9$var$kNoIterator = 0;
var $2be9aa30bff457b9$var$kIsArray = 1;
var $2be9aa30bff457b9$var$kIsSet = 2;
var $2be9aa30bff457b9$var$kIsMap = 3;
// Check if they have the same source and flags
function $2be9aa30bff457b9$var$areSimilarRegExps(a, b) {
    return $2be9aa30bff457b9$var$regexFlagsSupported ? a.source === b.source && a.flags === b.flags : RegExp.prototype.toString.call(a) === RegExp.prototype.toString.call(b);
}
function $2be9aa30bff457b9$var$areSimilarFloatArrays(a, b) {
    if (a.byteLength !== b.byteLength) return false;
    for(var offset = 0; offset < a.byteLength; offset++){
        if (a[offset] !== b[offset]) return false;
    }
    return true;
}
function $2be9aa30bff457b9$var$areSimilarTypedArrays(a, b) {
    if (a.byteLength !== b.byteLength) return false;
    return $2be9aa30bff457b9$var$compare(new Uint8Array(a.buffer, a.byteOffset, a.byteLength), new Uint8Array(b.buffer, b.byteOffset, b.byteLength)) === 0;
}
function $2be9aa30bff457b9$var$areEqualArrayBuffers(buf1, buf2) {
    return buf1.byteLength === buf2.byteLength && $2be9aa30bff457b9$var$compare(new Uint8Array(buf1), new Uint8Array(buf2)) === 0;
}
function $2be9aa30bff457b9$var$isEqualBoxedPrimitive(val1, val2) {
    if ($2be9aa30bff457b9$var$isNumberObject(val1)) return $2be9aa30bff457b9$var$isNumberObject(val2) && $2be9aa30bff457b9$var$objectIs(Number.prototype.valueOf.call(val1), Number.prototype.valueOf.call(val2));
    if ($2be9aa30bff457b9$var$isStringObject(val1)) return $2be9aa30bff457b9$var$isStringObject(val2) && String.prototype.valueOf.call(val1) === String.prototype.valueOf.call(val2);
    if ($2be9aa30bff457b9$var$isBooleanObject(val1)) return $2be9aa30bff457b9$var$isBooleanObject(val2) && Boolean.prototype.valueOf.call(val1) === Boolean.prototype.valueOf.call(val2);
    if ($2be9aa30bff457b9$var$isBigIntObject(val1)) return $2be9aa30bff457b9$var$isBigIntObject(val2) && BigInt.prototype.valueOf.call(val1) === BigInt.prototype.valueOf.call(val2);
    return $2be9aa30bff457b9$var$isSymbolObject(val2) && Symbol.prototype.valueOf.call(val1) === Symbol.prototype.valueOf.call(val2);
}
// Notes: Type tags are historical [[Class]] properties that can be set by
// FunctionTemplate::SetClassName() in C++ or Symbol.toStringTag in JS
// and retrieved using Object.prototype.toString.call(obj) in JS
// See https://tc39.github.io/ecma262/#sec-object.prototype.tostring
// for a list of tags pre-defined in the spec.
// There are some unspecified tags in the wild too (e.g. typed array tags).
// Since tags can be altered, they only serve fast failures
//
// Typed arrays and buffers are checked by comparing the content in their
// underlying ArrayBuffer. This optimization requires that it's
// reasonable to interpret their underlying memory in the same way,
// which is checked by comparing their type tags.
// (e.g. a Uint8Array and a Uint16Array with the same memory content
// could still be different because they will be interpreted differently).
//
// For strict comparison, objects should have
// a) The same built-in type tags
// b) The same prototypes.
function $2be9aa30bff457b9$var$innerDeepEqual(val1, val2, strict, memos) {
    // All identical values are equivalent, as determined by ===.
    if (val1 === val2) {
        if (val1 !== 0) return true;
        return strict ? $2be9aa30bff457b9$var$objectIs(val1, val2) : true;
    }
    // Check more closely if val1 and val2 are equal.
    if (strict) {
        if ($2be9aa30bff457b9$var$_typeof(val1) !== "object") return typeof val1 === "number" && $2be9aa30bff457b9$var$numberIsNaN(val1) && $2be9aa30bff457b9$var$numberIsNaN(val2);
        if ($2be9aa30bff457b9$var$_typeof(val2) !== "object" || val1 === null || val2 === null) return false;
        if (Object.getPrototypeOf(val1) !== Object.getPrototypeOf(val2)) return false;
    } else {
        if (val1 === null || $2be9aa30bff457b9$var$_typeof(val1) !== "object") {
            if (val2 === null || $2be9aa30bff457b9$var$_typeof(val2) !== "object") // eslint-disable-next-line eqeqeq
            return val1 == val2;
            return false;
        }
        if (val2 === null || $2be9aa30bff457b9$var$_typeof(val2) !== "object") return false;
    }
    var val1Tag = $2be9aa30bff457b9$var$objectToString(val1);
    var val2Tag = $2be9aa30bff457b9$var$objectToString(val2);
    if (val1Tag !== val2Tag) return false;
    if (Array.isArray(val1)) {
        // Check for sparse arrays and general fast path
        if (val1.length !== val2.length) return false;
        var keys1 = $2be9aa30bff457b9$var$getOwnNonIndexProperties(val1, $2be9aa30bff457b9$var$ONLY_ENUMERABLE);
        var keys2 = $2be9aa30bff457b9$var$getOwnNonIndexProperties(val2, $2be9aa30bff457b9$var$ONLY_ENUMERABLE);
        if (keys1.length !== keys2.length) return false;
        return $2be9aa30bff457b9$var$keyCheck(val1, val2, strict, memos, $2be9aa30bff457b9$var$kIsArray, keys1);
    }
    // [browserify] This triggers on certain types in IE (Map/Set) so we don't
    // wan't to early return out of the rest of the checks. However we can check
    // if the second value is one of these values and the first isn't.
    if (val1Tag === "[object Object]") {
        // return keyCheck(val1, val2, strict, memos, kNoIterator);
        if (!$2be9aa30bff457b9$var$isMap(val1) && $2be9aa30bff457b9$var$isMap(val2) || !$2be9aa30bff457b9$var$isSet(val1) && $2be9aa30bff457b9$var$isSet(val2)) return false;
    }
    if ($2be9aa30bff457b9$var$isDate(val1)) {
        if (!$2be9aa30bff457b9$var$isDate(val2) || Date.prototype.getTime.call(val1) !== Date.prototype.getTime.call(val2)) return false;
    } else if ($2be9aa30bff457b9$var$isRegExp(val1)) {
        if (!$2be9aa30bff457b9$var$isRegExp(val2) || !$2be9aa30bff457b9$var$areSimilarRegExps(val1, val2)) return false;
    } else if ($2be9aa30bff457b9$var$isNativeError(val1) || val1 instanceof Error) {
        // Do not compare the stack as it might differ even though the error itself
        // is otherwise identical.
        if (val1.message !== val2.message || val1.name !== val2.name) return false;
    } else if ($2be9aa30bff457b9$var$isArrayBufferView(val1)) {
        if (!strict && ($2be9aa30bff457b9$var$isFloat32Array(val1) || $2be9aa30bff457b9$var$isFloat64Array(val1))) {
            if (!$2be9aa30bff457b9$var$areSimilarFloatArrays(val1, val2)) return false;
        } else if (!$2be9aa30bff457b9$var$areSimilarTypedArrays(val1, val2)) return false;
        // Buffer.compare returns true, so val1.length === val2.length. If they both
        // only contain numeric keys, we don't need to exam further than checking
        // the symbols.
        var _keys = $2be9aa30bff457b9$var$getOwnNonIndexProperties(val1, $2be9aa30bff457b9$var$ONLY_ENUMERABLE);
        var _keys2 = $2be9aa30bff457b9$var$getOwnNonIndexProperties(val2, $2be9aa30bff457b9$var$ONLY_ENUMERABLE);
        if (_keys.length !== _keys2.length) return false;
        return $2be9aa30bff457b9$var$keyCheck(val1, val2, strict, memos, $2be9aa30bff457b9$var$kNoIterator, _keys);
    } else if ($2be9aa30bff457b9$var$isSet(val1)) {
        if (!$2be9aa30bff457b9$var$isSet(val2) || val1.size !== val2.size) return false;
        return $2be9aa30bff457b9$var$keyCheck(val1, val2, strict, memos, $2be9aa30bff457b9$var$kIsSet);
    } else if ($2be9aa30bff457b9$var$isMap(val1)) {
        if (!$2be9aa30bff457b9$var$isMap(val2) || val1.size !== val2.size) return false;
        return $2be9aa30bff457b9$var$keyCheck(val1, val2, strict, memos, $2be9aa30bff457b9$var$kIsMap);
    } else if ($2be9aa30bff457b9$var$isAnyArrayBuffer(val1)) {
        if (!$2be9aa30bff457b9$var$areEqualArrayBuffers(val1, val2)) return false;
    } else if ($2be9aa30bff457b9$var$isBoxedPrimitive(val1) && !$2be9aa30bff457b9$var$isEqualBoxedPrimitive(val1, val2)) return false;
    return $2be9aa30bff457b9$var$keyCheck(val1, val2, strict, memos, $2be9aa30bff457b9$var$kNoIterator);
}
function $2be9aa30bff457b9$var$getEnumerables(val, keys) {
    return keys.filter(function(k) {
        return $2be9aa30bff457b9$var$propertyIsEnumerable(val, k);
    });
}
function $2be9aa30bff457b9$var$keyCheck(val1, val2, strict, memos, iterationType, aKeys) {
    // For all remaining Object pairs, including Array, objects and Maps,
    // equivalence is determined by having:
    // a) The same number of owned enumerable properties
    // b) The same set of keys/indexes (although not necessarily the same order)
    // c) Equivalent values for every corresponding key/index
    // d) For Sets and Maps, equal contents
    // Note: this accounts for both named and indexed properties on Arrays.
    if (arguments.length === 5) {
        aKeys = Object.keys(val1);
        var bKeys = Object.keys(val2);
        // The pair must have the same number of owned properties.
        if (aKeys.length !== bKeys.length) return false;
    }
    // Cheap key test
    var i = 0;
    for(; i < aKeys.length; i++){
        if (!$2be9aa30bff457b9$var$hasOwnProperty(val2, aKeys[i])) return false;
    }
    if (strict && arguments.length === 5) {
        var symbolKeysA = $2be9aa30bff457b9$var$objectGetOwnPropertySymbols(val1);
        if (symbolKeysA.length !== 0) {
            var count = 0;
            for(i = 0; i < symbolKeysA.length; i++){
                var key = symbolKeysA[i];
                if ($2be9aa30bff457b9$var$propertyIsEnumerable(val1, key)) {
                    if (!$2be9aa30bff457b9$var$propertyIsEnumerable(val2, key)) return false;
                    aKeys.push(key);
                    count++;
                } else if ($2be9aa30bff457b9$var$propertyIsEnumerable(val2, key)) return false;
            }
            var symbolKeysB = $2be9aa30bff457b9$var$objectGetOwnPropertySymbols(val2);
            if (symbolKeysA.length !== symbolKeysB.length && $2be9aa30bff457b9$var$getEnumerables(val2, symbolKeysB).length !== count) return false;
        } else {
            var _symbolKeysB = $2be9aa30bff457b9$var$objectGetOwnPropertySymbols(val2);
            if (_symbolKeysB.length !== 0 && $2be9aa30bff457b9$var$getEnumerables(val2, _symbolKeysB).length !== 0) return false;
        }
    }
    if (aKeys.length === 0 && (iterationType === $2be9aa30bff457b9$var$kNoIterator || iterationType === $2be9aa30bff457b9$var$kIsArray && val1.length === 0 || val1.size === 0)) return true;
    // Use memos to handle cycles.
    if (memos === undefined) memos = {
        val1: new Map(),
        val2: new Map(),
        position: 0
    };
    else {
        // We prevent up to two map.has(x) calls by directly retrieving the value
        // and checking for undefined. The map can only contain numbers, so it is
        // safe to check for undefined only.
        var val2MemoA = memos.val1.get(val1);
        if (val2MemoA !== undefined) {
            var val2MemoB = memos.val2.get(val2);
            if (val2MemoB !== undefined) return val2MemoA === val2MemoB;
        }
        memos.position++;
    }
    memos.val1.set(val1, memos.position);
    memos.val2.set(val2, memos.position);
    var areEq = $2be9aa30bff457b9$var$objEquiv(val1, val2, strict, aKeys, memos, iterationType);
    memos.val1.delete(val1);
    memos.val2.delete(val2);
    return areEq;
}
function $2be9aa30bff457b9$var$setHasEqualElement(set, val1, strict, memo) {
    // Go looking.
    var setValues = $2be9aa30bff457b9$var$arrayFromSet(set);
    for(var i = 0; i < setValues.length; i++){
        var val2 = setValues[i];
        if ($2be9aa30bff457b9$var$innerDeepEqual(val1, val2, strict, memo)) {
            // Remove the matching element to make sure we do not check that again.
            set.delete(val2);
            return true;
        }
    }
    return false;
}
// See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Equality_comparisons_and_sameness#Loose_equality_using
// Sadly it is not possible to detect corresponding values properly in case the
// type is a string, number, bigint or boolean. The reason is that those values
// can match lots of different string values (e.g., 1n == '+00001').
function $2be9aa30bff457b9$var$findLooseMatchingPrimitives(prim) {
    switch($2be9aa30bff457b9$var$_typeof(prim)){
        case "undefined":
            return null;
        case "object":
            // Only pass in null as object!
            return undefined;
        case "symbol":
            return false;
        case "string":
            prim = +prim;
        // Loose equal entries exist only if the string is possible to convert to
        // a regular number and not NaN.
        // Fall through
        case "number":
            if ($2be9aa30bff457b9$var$numberIsNaN(prim)) return false;
    }
    return true;
}
function $2be9aa30bff457b9$var$setMightHaveLoosePrim(a, b, prim) {
    var altValue = $2be9aa30bff457b9$var$findLooseMatchingPrimitives(prim);
    if (altValue != null) return altValue;
    return b.has(altValue) && !a.has(altValue);
}
function $2be9aa30bff457b9$var$mapMightHaveLoosePrim(a, b, prim, item, memo) {
    var altValue = $2be9aa30bff457b9$var$findLooseMatchingPrimitives(prim);
    if (altValue != null) return altValue;
    var curB = b.get(altValue);
    if (curB === undefined && !b.has(altValue) || !$2be9aa30bff457b9$var$innerDeepEqual(item, curB, false, memo)) return false;
    return !a.has(altValue) && $2be9aa30bff457b9$var$innerDeepEqual(item, curB, false, memo);
}
function $2be9aa30bff457b9$var$setEquiv(a, b, strict, memo) {
    // This is a lazily initiated Set of entries which have to be compared
    // pairwise.
    var set = null;
    var aValues = $2be9aa30bff457b9$var$arrayFromSet(a);
    for(var i = 0; i < aValues.length; i++){
        var val = aValues[i];
        // Note: Checking for the objects first improves the performance for object
        // heavy sets but it is a minor slow down for primitives. As they are fast
        // to check this improves the worst case scenario instead.
        if ($2be9aa30bff457b9$var$_typeof(val) === "object" && val !== null) {
            if (set === null) set = new Set();
            // If the specified value doesn't exist in the second set its an not null
            // object (or non strict only: a not matching primitive) we'll need to go
            // hunting for something thats deep-(strict-)equal to it. To make this
            // O(n log n) complexity we have to copy these values in a new set first.
            set.add(val);
        } else if (!b.has(val)) {
            if (strict) return false;
            // Fast path to detect missing string, symbol, undefined and null values.
            if (!$2be9aa30bff457b9$var$setMightHaveLoosePrim(a, b, val)) return false;
            if (set === null) set = new Set();
            set.add(val);
        }
    }
    if (set !== null) {
        var bValues = $2be9aa30bff457b9$var$arrayFromSet(b);
        for(var _i = 0; _i < bValues.length; _i++){
            var _val = bValues[_i];
            // We have to check if a primitive value is already
            // matching and only if it's not, go hunting for it.
            if ($2be9aa30bff457b9$var$_typeof(_val) === "object" && _val !== null) {
                if (!$2be9aa30bff457b9$var$setHasEqualElement(set, _val, strict, memo)) return false;
            } else if (!strict && !a.has(_val) && !$2be9aa30bff457b9$var$setHasEqualElement(set, _val, strict, memo)) return false;
        }
        return set.size === 0;
    }
    return true;
}
function $2be9aa30bff457b9$var$mapHasEqualEntry(set, map, key1, item1, strict, memo) {
    // To be able to handle cases like:
    //   Map([[{}, 'a'], [{}, 'b']]) vs Map([[{}, 'b'], [{}, 'a']])
    // ... we need to consider *all* matching keys, not just the first we find.
    var setValues = $2be9aa30bff457b9$var$arrayFromSet(set);
    for(var i = 0; i < setValues.length; i++){
        var key2 = setValues[i];
        if ($2be9aa30bff457b9$var$innerDeepEqual(key1, key2, strict, memo) && $2be9aa30bff457b9$var$innerDeepEqual(item1, map.get(key2), strict, memo)) {
            set.delete(key2);
            return true;
        }
    }
    return false;
}
function $2be9aa30bff457b9$var$mapEquiv(a, b, strict, memo) {
    var set = null;
    var aEntries = $2be9aa30bff457b9$var$arrayFromMap(a);
    for(var i = 0; i < aEntries.length; i++){
        var _aEntries$i = $2be9aa30bff457b9$var$_slicedToArray(aEntries[i], 2), key = _aEntries$i[0], item1 = _aEntries$i[1];
        if ($2be9aa30bff457b9$var$_typeof(key) === "object" && key !== null) {
            if (set === null) set = new Set();
            set.add(key);
        } else {
            // By directly retrieving the value we prevent another b.has(key) check in
            // almost all possible cases.
            var item2 = b.get(key);
            if (item2 === undefined && !b.has(key) || !$2be9aa30bff457b9$var$innerDeepEqual(item1, item2, strict, memo)) {
                if (strict) return false;
                // Fast path to detect missing string, symbol, undefined and null
                // keys.
                if (!$2be9aa30bff457b9$var$mapMightHaveLoosePrim(a, b, key, item1, memo)) return false;
                if (set === null) set = new Set();
                set.add(key);
            }
        }
    }
    if (set !== null) {
        var bEntries = $2be9aa30bff457b9$var$arrayFromMap(b);
        for(var _i2 = 0; _i2 < bEntries.length; _i2++){
            var _bEntries$_i = $2be9aa30bff457b9$var$_slicedToArray(bEntries[_i2], 2), _key = _bEntries$_i[0], item = _bEntries$_i[1];
            if ($2be9aa30bff457b9$var$_typeof(_key) === "object" && _key !== null) {
                if (!$2be9aa30bff457b9$var$mapHasEqualEntry(set, a, _key, item, strict, memo)) return false;
            } else if (!strict && (!a.has(_key) || !$2be9aa30bff457b9$var$innerDeepEqual(a.get(_key), item, false, memo)) && !$2be9aa30bff457b9$var$mapHasEqualEntry(set, a, _key, item, false, memo)) return false;
        }
        return set.size === 0;
    }
    return true;
}
function $2be9aa30bff457b9$var$objEquiv(a, b, strict, keys, memos, iterationType) {
    // Sets and maps don't have their entries accessible via normal object
    // properties.
    var i = 0;
    if (iterationType === $2be9aa30bff457b9$var$kIsSet) {
        if (!$2be9aa30bff457b9$var$setEquiv(a, b, strict, memos)) return false;
    } else if (iterationType === $2be9aa30bff457b9$var$kIsMap) {
        if (!$2be9aa30bff457b9$var$mapEquiv(a, b, strict, memos)) return false;
    } else if (iterationType === $2be9aa30bff457b9$var$kIsArray) for(; i < a.length; i++){
        if ($2be9aa30bff457b9$var$hasOwnProperty(a, i)) {
            if (!$2be9aa30bff457b9$var$hasOwnProperty(b, i) || !$2be9aa30bff457b9$var$innerDeepEqual(a[i], b[i], strict, memos)) return false;
        } else if ($2be9aa30bff457b9$var$hasOwnProperty(b, i)) return false;
        else {
            // Array is sparse.
            var keysA = Object.keys(a);
            for(; i < keysA.length; i++){
                var key = keysA[i];
                if (!$2be9aa30bff457b9$var$hasOwnProperty(b, key) || !$2be9aa30bff457b9$var$innerDeepEqual(a[key], b[key], strict, memos)) return false;
            }
            if (keysA.length !== Object.keys(b).length) return false;
            return true;
        }
    }
    // The pair must have equivalent values for every corresponding key.
    // Possibly expensive deep test:
    for(i = 0; i < keys.length; i++){
        var _key2 = keys[i];
        if (!$2be9aa30bff457b9$var$innerDeepEqual(a[_key2], b[_key2], strict, memos)) return false;
    }
    return true;
}
function $2be9aa30bff457b9$var$isDeepEqual(val1, val2) {
    return $2be9aa30bff457b9$var$innerDeepEqual(val1, val2, $2be9aa30bff457b9$var$kLoose);
}
function $2be9aa30bff457b9$var$isDeepStrictEqual(val1, val2) {
    return $2be9aa30bff457b9$var$innerDeepEqual(val1, val2, $2be9aa30bff457b9$var$kStrict);
}
module.exports = {
    isDeepEqual: $2be9aa30bff457b9$var$isDeepEqual,
    isDeepStrictEqual: $2be9aa30bff457b9$var$isDeepStrictEqual
};

});
parcelRegister("eT9RM", function(module, exports) {
"use strict";

var $1UbTr = parcelRequire("1UbTr");

var $cOB0F = parcelRequire("cOB0F");

var $6wuPW = parcelRequire("6wuPW");

var $5SxoI = parcelRequire("5SxoI");

var $bNbuK = parcelRequire("bNbuK");
var $ad6ddb07ef0cb149$var$polyfill = $cOB0F($5SxoI(), Object);
$1UbTr($ad6ddb07ef0cb149$var$polyfill, {
    getPolyfill: $5SxoI,
    implementation: $6wuPW,
    shim: $bNbuK
});
module.exports = $ad6ddb07ef0cb149$var$polyfill;

});
parcelRegister("1UbTr", function(module, exports) {
"use strict";

var $81enX = parcelRequire("81enX");
var $16343f2546a69e4c$var$hasSymbols = typeof Symbol === "function" && typeof Symbol("foo") === "symbol";
var $16343f2546a69e4c$var$toStr = Object.prototype.toString;
var $16343f2546a69e4c$var$concat = Array.prototype.concat;

var $5FEEt = parcelRequire("5FEEt");
var $16343f2546a69e4c$var$isFunction = function(fn) {
    return typeof fn === "function" && $16343f2546a69e4c$var$toStr.call(fn) === "[object Function]";
};

var $16343f2546a69e4c$var$supportsDescriptors = (parcelRequire("i16wS"))();
var $16343f2546a69e4c$var$defineProperty = function(object, name, value, predicate) {
    if (name in object) {
        if (predicate === true) {
            if (object[name] === value) return;
        } else if (!$16343f2546a69e4c$var$isFunction(predicate) || !predicate()) return;
    }
    if ($16343f2546a69e4c$var$supportsDescriptors) $5FEEt(object, name, value, true);
    else $5FEEt(object, name, value);
};
var $16343f2546a69e4c$var$defineProperties = function(object, map) {
    var predicates = arguments.length > 2 ? arguments[2] : {};
    var props = $81enX(map);
    if ($16343f2546a69e4c$var$hasSymbols) props = $16343f2546a69e4c$var$concat.call(props, Object.getOwnPropertySymbols(map));
    for(var i = 0; i < props.length; i += 1)$16343f2546a69e4c$var$defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
};
$16343f2546a69e4c$var$defineProperties.supportsDescriptors = !!$16343f2546a69e4c$var$supportsDescriptors;
module.exports = $16343f2546a69e4c$var$defineProperties;

});

parcelRegister("bNbuK", function(module, exports) {
"use strict";

var $5SxoI = parcelRequire("5SxoI");

var $1UbTr = parcelRequire("1UbTr");
module.exports = function shimObjectIs() {
    var polyfill = $5SxoI();
    $1UbTr(Object, {
        is: polyfill
    }, {
        is: function testObjectIs() {
            return Object.is !== polyfill;
        }
    });
    return polyfill;
};

});


parcelRegister("c8Cyq", function(module, exports) {
"use strict";

var $cOB0F = parcelRequire("cOB0F");

var $1UbTr = parcelRequire("1UbTr");

var $8sYH2 = parcelRequire("8sYH2");

var $91M8b = parcelRequire("91M8b");

var $hCf9I = parcelRequire("hCf9I");
var $8d642377f5822430$var$polyfill = $cOB0F($91M8b(), Number);
/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ $1UbTr($8d642377f5822430$var$polyfill, {
    getPolyfill: $91M8b,
    implementation: $8sYH2,
    shim: $hCf9I
});
module.exports = $8d642377f5822430$var$polyfill;

});
parcelRegister("8sYH2", function(module, exports) {
"use strict";
/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ module.exports = function isNaN(value) {
    return value !== value;
};

});

parcelRegister("91M8b", function(module, exports) {
"use strict";

var $8sYH2 = parcelRequire("8sYH2");
module.exports = function getPolyfill() {
    if (Number.isNaN && Number.isNaN(NaN) && !Number.isNaN("a")) return Number.isNaN;
    return $8sYH2;
};

});

parcelRegister("hCf9I", function(module, exports) {
"use strict";

var $1UbTr = parcelRequire("1UbTr");

var $91M8b = parcelRequire("91M8b");
/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ module.exports = function shimNumberIsNaN() {
    var polyfill = $91M8b();
    $1UbTr(Number, {
        isNaN: polyfill
    }, {
        isNaN: function testIsNaN() {
            return Number.isNaN !== polyfill;
        }
    });
    return polyfill;
};

});




parcelRegister("7Ockm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DEFAULT_EXTENSIONS = void 0;
Object.defineProperty(module.exports, "File", {
    enumerable: true,
    get: function() {
        return $ir8Cn.default;
    }
});
Object.defineProperty(module.exports, "buildExternalHelpers", {
    enumerable: true,
    get: function() {
        return $fJWeE.default;
    }
});
Object.defineProperty(module.exports, "createConfigItem", {
    enumerable: true,
    get: function() {
        return $6JZbd.createConfigItem;
    }
});
Object.defineProperty(module.exports, "createConfigItemAsync", {
    enumerable: true,
    get: function() {
        return $6JZbd.createConfigItemAsync;
    }
});
Object.defineProperty(module.exports, "createConfigItemSync", {
    enumerable: true,
    get: function() {
        return $6JZbd.createConfigItemSync;
    }
});
Object.defineProperty(module.exports, "getEnv", {
    enumerable: true,
    get: function() {
        return $33Znv.getEnv;
    }
});
Object.defineProperty(module.exports, "loadOptions", {
    enumerable: true,
    get: function() {
        return $6JZbd.loadOptions;
    }
});
Object.defineProperty(module.exports, "loadOptionsAsync", {
    enumerable: true,
    get: function() {
        return $6JZbd.loadOptionsAsync;
    }
});
Object.defineProperty(module.exports, "loadOptionsSync", {
    enumerable: true,
    get: function() {
        return $6JZbd.loadOptionsSync;
    }
});
Object.defineProperty(module.exports, "loadPartialConfig", {
    enumerable: true,
    get: function() {
        return $6JZbd.loadPartialConfig;
    }
});
Object.defineProperty(module.exports, "loadPartialConfigAsync", {
    enumerable: true,
    get: function() {
        return $6JZbd.loadPartialConfigAsync;
    }
});
Object.defineProperty(module.exports, "loadPartialConfigSync", {
    enumerable: true,
    get: function() {
        return $6JZbd.loadPartialConfigSync;
    }
});
Object.defineProperty(module.exports, "parse", {
    enumerable: true,
    get: function() {
        return $dJ9wd.parse;
    }
});
Object.defineProperty(module.exports, "parseAsync", {
    enumerable: true,
    get: function() {
        return $dJ9wd.parseAsync;
    }
});
Object.defineProperty(module.exports, "parseSync", {
    enumerable: true,
    get: function() {
        return $dJ9wd.parseSync;
    }
});
Object.defineProperty(module.exports, "resolvePlugin", {
    enumerable: true,
    get: function() {
        return $4h8hI.resolvePlugin;
    }
});
Object.defineProperty(module.exports, "resolvePreset", {
    enumerable: true,
    get: function() {
        return $4h8hI.resolvePreset;
    }
});
Object.defineProperty(module.exports, "template", {
    enumerable: true,
    get: function() {
        return $5af6c3dc8fc00edf$var$_template().default;
    }
});
Object.defineProperty(module.exports, "tokTypes", {
    enumerable: true,
    get: function() {
        return $5af6c3dc8fc00edf$var$_parser().tokTypes;
    }
});
Object.defineProperty(module.exports, "transform", {
    enumerable: true,
    get: function() {
        return $cTdtM.transform;
    }
});
Object.defineProperty(module.exports, "transformAsync", {
    enumerable: true,
    get: function() {
        return $cTdtM.transformAsync;
    }
});
Object.defineProperty(module.exports, "transformFile", {
    enumerable: true,
    get: function() {
        return $5nbgi.transformFile;
    }
});
Object.defineProperty(module.exports, "transformFileAsync", {
    enumerable: true,
    get: function() {
        return $5nbgi.transformFileAsync;
    }
});
Object.defineProperty(module.exports, "transformFileSync", {
    enumerable: true,
    get: function() {
        return $5nbgi.transformFileSync;
    }
});
Object.defineProperty(module.exports, "transformFromAst", {
    enumerable: true,
    get: function() {
        return $7pAM0.transformFromAst;
    }
});
Object.defineProperty(module.exports, "transformFromAstAsync", {
    enumerable: true,
    get: function() {
        return $7pAM0.transformFromAstAsync;
    }
});
Object.defineProperty(module.exports, "transformFromAstSync", {
    enumerable: true,
    get: function() {
        return $7pAM0.transformFromAstSync;
    }
});
Object.defineProperty(module.exports, "transformSync", {
    enumerable: true,
    get: function() {
        return $cTdtM.transformSync;
    }
});
Object.defineProperty(module.exports, "traverse", {
    enumerable: true,
    get: function() {
        return $5af6c3dc8fc00edf$var$_traverse().default;
    }
});
module.exports.version = module.exports.types = void 0;

var $ir8Cn = parcelRequire("ir8Cn");

var $fJWeE = parcelRequire("fJWeE");

var $4h8hI = parcelRequire("4h8hI");

var $33Znv = parcelRequire("33Znv");

function $5af6c3dc8fc00edf$var$_types() {
    const data = (parcelRequire("ardUq"));
    $5af6c3dc8fc00edf$var$_types = function() {
        return data;
    };
    return data;
}
Object.defineProperty(module.exports, "types", {
    enumerable: true,
    get: function() {
        return $5af6c3dc8fc00edf$var$_types();
    }
});

function $5af6c3dc8fc00edf$var$_parser() {
    const data = (parcelRequire("fuTml"));
    $5af6c3dc8fc00edf$var$_parser = function() {
        return data;
    };
    return data;
}

function $5af6c3dc8fc00edf$var$_traverse() {
    const data = (parcelRequire("aHxeO"));
    $5af6c3dc8fc00edf$var$_traverse = function() {
        return data;
    };
    return data;
}

function $5af6c3dc8fc00edf$var$_template() {
    const data = (parcelRequire("gQ5sj"));
    $5af6c3dc8fc00edf$var$_template = function() {
        return data;
    };
    return data;
}

var $6JZbd = parcelRequire("6JZbd");

var $cTdtM = parcelRequire("cTdtM");

var $5nbgi = parcelRequire("5nbgi");

var $7pAM0 = parcelRequire("7pAM0");

var $dJ9wd = parcelRequire("dJ9wd");

const $5af6c3dc8fc00edf$var$version = module.exports.version = "7.24.3";
const $5af6c3dc8fc00edf$var$DEFAULT_EXTENSIONS = module.exports.DEFAULT_EXTENSIONS = Object.freeze([
    ".js",
    ".jsx",
    ".es6",
    ".es",
    ".mjs",
    ".cjs"
]);
module.exports.OptionManager = class OptionManager {
    init(opts) {
        return (0, $6JZbd.loadOptionsSync)(opts);
    }
};
module.exports.Plugin = function Plugin(alias) {
    throw new Error(`The (${alias}) Babel 5 plugin is being run with an unsupported Babel version.`);
};

});
parcelRegister("ir8Cn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

function $d6c16efc967bb5bf$var$helpers() {
    const data = (parcelRequire("8sOJt"));
    $d6c16efc967bb5bf$var$helpers = function() {
        return data;
    };
    return data;
}

function $d6c16efc967bb5bf$var$_traverse() {
    const data = (parcelRequire("aHxeO"));
    $d6c16efc967bb5bf$var$_traverse = function() {
        return data;
    };
    return data;
}

function $d6c16efc967bb5bf$var$_codeFrame() {
    const data = (parcelRequire("frkOe"));
    $d6c16efc967bb5bf$var$_codeFrame = function() {
        return data;
    };
    return data;
}

function $d6c16efc967bb5bf$var$_t() {
    const data = (parcelRequire("ardUq"));
    $d6c16efc967bb5bf$var$_t = function() {
        return data;
    };
    return data;
}

function $d6c16efc967bb5bf$var$_helperModuleTransforms() {
    const data = (parcelRequire("dRFU1"));
    $d6c16efc967bb5bf$var$_helperModuleTransforms = function() {
        return data;
    };
    return data;
}

function $d6c16efc967bb5bf$var$_semver() {
    const data = (parcelRequire("bX4qr"));
    $d6c16efc967bb5bf$var$_semver = function() {
        return data;
    };
    return data;
}
const { cloneNode: $d6c16efc967bb5bf$var$cloneNode, interpreterDirective: $d6c16efc967bb5bf$var$interpreterDirective } = $d6c16efc967bb5bf$var$_t();
const $d6c16efc967bb5bf$var$errorVisitor = {
    enter (path, state) {
        const loc = path.node.loc;
        if (loc) {
            state.loc = loc;
            path.stop();
        }
    }
};
class $d6c16efc967bb5bf$var$File {
    constructor(options, { code: code, ast: ast, inputMap: inputMap }){
        this._map = new Map();
        this.opts = void 0;
        this.declarations = {};
        this.path = void 0;
        this.ast = void 0;
        this.scope = void 0;
        this.metadata = {};
        this.code = "";
        this.inputMap = void 0;
        this.hub = {
            file: this,
            getCode: ()=>this.code,
            getScope: ()=>this.scope,
            addHelper: this.addHelper.bind(this),
            buildError: this.buildCodeFrameError.bind(this)
        };
        this.opts = options;
        this.code = code;
        this.ast = ast;
        this.inputMap = inputMap;
        this.path = $d6c16efc967bb5bf$var$_traverse().NodePath.get({
            hub: this.hub,
            parentPath: null,
            parent: this.ast,
            container: this.ast,
            key: "program"
        }).setContext();
        this.scope = this.path.scope;
    }
    get shebang() {
        const { interpreter: interpreter } = this.path.node;
        return interpreter ? interpreter.value : "";
    }
    set shebang(value) {
        if (value) this.path.get("interpreter").replaceWith($d6c16efc967bb5bf$var$interpreterDirective(value));
        else this.path.get("interpreter").remove();
    }
    set(key, val) {
        if (key === "helpersNamespace") throw new Error("Babel 7.0.0-beta.56 has dropped support for the 'helpersNamespace' utility.If you are using @babel/plugin-external-helpers you will need to use a newer version than the one you currently have installed. If you have your own implementation, you'll want to explore using 'helperGenerator' alongside 'file.availableHelper()'.");
        this._map.set(key, val);
    }
    get(key) {
        return this._map.get(key);
    }
    has(key) {
        return this._map.has(key);
    }
    getModuleName() {
        return (0, $d6c16efc967bb5bf$var$_helperModuleTransforms().getModuleName)(this.opts, this.opts);
    }
    availableHelper(name, versionRange) {
        let minVersion;
        try {
            minVersion = $d6c16efc967bb5bf$var$helpers().minVersion(name);
        } catch (err) {
            if (err.code !== "BABEL_HELPER_UNKNOWN") throw err;
            return false;
        }
        if (typeof versionRange !== "string") return true;
        if ($d6c16efc967bb5bf$var$_semver().valid(versionRange)) versionRange = `^${versionRange}`;
        return !$d6c16efc967bb5bf$var$_semver().intersects(`<${minVersion}`, versionRange) && !$d6c16efc967bb5bf$var$_semver().intersects(`>=8.0.0`, versionRange);
    }
    addHelper(name) {
        const declar = this.declarations[name];
        if (declar) return $d6c16efc967bb5bf$var$cloneNode(declar);
        const generator = this.get("helperGenerator");
        if (generator) {
            const res = generator(name);
            if (res) return res;
        }
        $d6c16efc967bb5bf$var$helpers().ensure(name, $d6c16efc967bb5bf$var$File);
        const uid = this.declarations[name] = this.scope.generateUidIdentifier(name);
        const dependencies = {};
        for (const dep of $d6c16efc967bb5bf$var$helpers().getDependencies(name))dependencies[dep] = this.addHelper(dep);
        const { nodes: nodes, globals: globals } = $d6c16efc967bb5bf$var$helpers().get(name, (dep)=>dependencies[dep], uid, Object.keys(this.scope.getAllBindings()));
        globals.forEach((name)=>{
            if (this.path.scope.hasBinding(name, true)) this.path.scope.rename(name);
        });
        nodes.forEach((node)=>{
            node._compact = true;
        });
        const added = this.path.unshiftContainer("body", nodes);
        for (const path of added)if (path.isVariableDeclaration()) this.scope.registerDeclaration(path);
        return uid;
    }
    buildCodeFrameError(node, msg, _Error = SyntaxError) {
        let loc = node == null ? void 0 : node.loc;
        if (!loc && node) {
            const state = {
                loc: null
            };
            (0, $d6c16efc967bb5bf$var$_traverse().default)(node, $d6c16efc967bb5bf$var$errorVisitor, this.scope, state);
            loc = state.loc;
            let txt = "This is an error on an internal node. Probably an internal error.";
            if (loc) txt += " Location has been estimated.";
            msg += ` (${txt})`;
        }
        if (loc) {
            const { highlightCode: highlightCode = true } = this.opts;
            msg += "\n" + (0, $d6c16efc967bb5bf$var$_codeFrame().codeFrameColumns)(this.code, {
                start: {
                    line: loc.start.line,
                    column: loc.start.column + 1
                },
                end: loc.end && loc.start.line === loc.end.line ? {
                    line: loc.end.line,
                    column: loc.end.column + 1
                } : undefined
            }, {
                highlightCode: highlightCode
            });
        }
        return new _Error(msg);
    }
}
module.exports.default = $d6c16efc967bb5bf$var$File;
$d6c16efc967bb5bf$var$File.prototype.addImport = function addImport() {
    throw new Error("This API has been removed. If you're looking for this functionality in Babel 7, you should import the '@babel/helper-module-imports' module and use the functions exposed  from that module, such as 'addNamed' or 'addDefault'.");
};
$d6c16efc967bb5bf$var$File.prototype.addTemplateObject = function addTemplateObject() {
    throw new Error("This function has been moved into the template literal transform itself.");
};

});
parcelRegister("bX4qr", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
exports = module.exports = SemVer;
var debug;
/* istanbul ignore next */ typeof $hPtJY === "object" && $hPtJY.env && undefined;
debug = function() {};
// Note: this is the semver.org version of the spec that it implements
// Not necessarily the package version of this code.
exports.SEMVER_SPEC_VERSION = "2.0.0";
var MAX_LENGTH = 256;
var MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || /* istanbul ignore next */ 9007199254740991;
// Max safe segment length for coercion.
var MAX_SAFE_COMPONENT_LENGTH = 16;
var MAX_SAFE_BUILD_LENGTH = MAX_LENGTH - 6;
// The actual regexps go on exports.re
var re = exports.re = [];
var safeRe = exports.safeRe = [];
var src = exports.src = [];
var t = exports.tokens = {};
var R = 0;
function tok(n) {
    t[n] = R++;
}
var LETTERDASHNUMBER = "[a-zA-Z0-9-]";
// Replace some greedy regex tokens to prevent regex dos issues. These regex are
// used internally via the safeRe object since all inputs in this library get
// normalized first to trim and collapse all extra whitespace. The original
// regexes are exported for userland consumption and lower level usage. A
// future breaking change could export the safer regex only with a note that
// all input should have extra whitespace removed.
var safeRegexReplacements = [
    [
        "\\s",
        1
    ],
    [
        "\\d",
        MAX_LENGTH
    ],
    [
        LETTERDASHNUMBER,
        MAX_SAFE_BUILD_LENGTH
    ]
];
function makeSafeRe(value) {
    for(var i = 0; i < safeRegexReplacements.length; i++){
        var token = safeRegexReplacements[i][0];
        var max = safeRegexReplacements[i][1];
        value = value.split(token + "*").join(token + "{0," + max + "}").split(token + "+").join(token + "{1," + max + "}");
    }
    return value;
}
// The following Regular Expressions can be used for tokenizing,
// validating, and parsing SemVer version strings.
// ## Numeric Identifier
// A single `0`, or a non-zero digit followed by zero or more digits.
tok("NUMERICIDENTIFIER");
src[t.NUMERICIDENTIFIER] = "0|[1-9]\\d*";
tok("NUMERICIDENTIFIERLOOSE");
src[t.NUMERICIDENTIFIERLOOSE] = "\\d+";
// ## Non-numeric Identifier
// Zero or more digits, followed by a letter or hyphen, and then zero or
// more letters, digits, or hyphens.
tok("NONNUMERICIDENTIFIER");
src[t.NONNUMERICIDENTIFIER] = "\\d*[a-zA-Z-]" + LETTERDASHNUMBER + "*";
// ## Main Version
// Three dot-separated numeric identifiers.
tok("MAINVERSION");
src[t.MAINVERSION] = "(" + src[t.NUMERICIDENTIFIER] + ")\\." + "(" + src[t.NUMERICIDENTIFIER] + ")\\." + "(" + src[t.NUMERICIDENTIFIER] + ")";
tok("MAINVERSIONLOOSE");
src[t.MAINVERSIONLOOSE] = "(" + src[t.NUMERICIDENTIFIERLOOSE] + ")\\." + "(" + src[t.NUMERICIDENTIFIERLOOSE] + ")\\." + "(" + src[t.NUMERICIDENTIFIERLOOSE] + ")";
// ## Pre-release Version Identifier
// A numeric identifier, or a non-numeric identifier.
tok("PRERELEASEIDENTIFIER");
src[t.PRERELEASEIDENTIFIER] = "(?:" + src[t.NUMERICIDENTIFIER] + "|" + src[t.NONNUMERICIDENTIFIER] + ")";
tok("PRERELEASEIDENTIFIERLOOSE");
src[t.PRERELEASEIDENTIFIERLOOSE] = "(?:" + src[t.NUMERICIDENTIFIERLOOSE] + "|" + src[t.NONNUMERICIDENTIFIER] + ")";
// ## Pre-release Version
// Hyphen, followed by one or more dot-separated pre-release version
// identifiers.
tok("PRERELEASE");
src[t.PRERELEASE] = "(?:-(" + src[t.PRERELEASEIDENTIFIER] + "(?:\\." + src[t.PRERELEASEIDENTIFIER] + ")*))";
tok("PRERELEASELOOSE");
src[t.PRERELEASELOOSE] = "(?:-?(" + src[t.PRERELEASEIDENTIFIERLOOSE] + "(?:\\." + src[t.PRERELEASEIDENTIFIERLOOSE] + ")*))";
// ## Build Metadata Identifier
// Any combination of digits, letters, or hyphens.
tok("BUILDIDENTIFIER");
src[t.BUILDIDENTIFIER] = LETTERDASHNUMBER + "+";
// ## Build Metadata
// Plus sign, followed by one or more period-separated build metadata
// identifiers.
tok("BUILD");
src[t.BUILD] = "(?:\\+(" + src[t.BUILDIDENTIFIER] + "(?:\\." + src[t.BUILDIDENTIFIER] + ")*))";
// ## Full Version String
// A main version, followed optionally by a pre-release version and
// build metadata.
// Note that the only major, minor, patch, and pre-release sections of
// the version string are capturing groups.  The build metadata is not a
// capturing group, because it should not ever be used in version
// comparison.
tok("FULL");
tok("FULLPLAIN");
src[t.FULLPLAIN] = "v?" + src[t.MAINVERSION] + src[t.PRERELEASE] + "?" + src[t.BUILD] + "?";
src[t.FULL] = "^" + src[t.FULLPLAIN] + "$";
// like full, but allows v1.2.3 and =1.2.3, which people do sometimes.
// also, 1.0.0alpha1 (prerelease without the hyphen) which is pretty
// common in the npm registry.
tok("LOOSEPLAIN");
src[t.LOOSEPLAIN] = "[v=\\s]*" + src[t.MAINVERSIONLOOSE] + src[t.PRERELEASELOOSE] + "?" + src[t.BUILD] + "?";
tok("LOOSE");
src[t.LOOSE] = "^" + src[t.LOOSEPLAIN] + "$";
tok("GTLT");
src[t.GTLT] = "((?:<|>)?=?)";
// Something like "2.*" or "1.2.x".
// Note that "x.x" is a valid xRange identifer, meaning "any version"
// Only the first item is strictly required.
tok("XRANGEIDENTIFIERLOOSE");
src[t.XRANGEIDENTIFIERLOOSE] = src[t.NUMERICIDENTIFIERLOOSE] + "|x|X|\\*";
tok("XRANGEIDENTIFIER");
src[t.XRANGEIDENTIFIER] = src[t.NUMERICIDENTIFIER] + "|x|X|\\*";
tok("XRANGEPLAIN");
src[t.XRANGEPLAIN] = "[v=\\s]*(" + src[t.XRANGEIDENTIFIER] + ")" + "(?:\\.(" + src[t.XRANGEIDENTIFIER] + ")" + "(?:\\.(" + src[t.XRANGEIDENTIFIER] + ")" + "(?:" + src[t.PRERELEASE] + ")?" + src[t.BUILD] + "?" + ")?)?";
tok("XRANGEPLAINLOOSE");
src[t.XRANGEPLAINLOOSE] = "[v=\\s]*(" + src[t.XRANGEIDENTIFIERLOOSE] + ")" + "(?:\\.(" + src[t.XRANGEIDENTIFIERLOOSE] + ")" + "(?:\\.(" + src[t.XRANGEIDENTIFIERLOOSE] + ")" + "(?:" + src[t.PRERELEASELOOSE] + ")?" + src[t.BUILD] + "?" + ")?)?";
tok("XRANGE");
src[t.XRANGE] = "^" + src[t.GTLT] + "\\s*" + src[t.XRANGEPLAIN] + "$";
tok("XRANGELOOSE");
src[t.XRANGELOOSE] = "^" + src[t.GTLT] + "\\s*" + src[t.XRANGEPLAINLOOSE] + "$";
// Coercion.
// Extract anything that could conceivably be a part of a valid semver
tok("COERCE");
src[t.COERCE] = "(^|[^\\d])(\\d{1," + MAX_SAFE_COMPONENT_LENGTH + "})" + "(?:\\.(\\d{1," + MAX_SAFE_COMPONENT_LENGTH + "}))?" + "(?:\\.(\\d{1," + MAX_SAFE_COMPONENT_LENGTH + "}))?" + "(?:$|[^\\d])";
tok("COERCERTL");
re[t.COERCERTL] = new RegExp(src[t.COERCE], "g");
safeRe[t.COERCERTL] = new RegExp(makeSafeRe(src[t.COERCE]), "g");
// Tilde ranges.
// Meaning is "reasonably at or greater than"
tok("LONETILDE");
src[t.LONETILDE] = "(?:~>?)";
tok("TILDETRIM");
src[t.TILDETRIM] = "(\\s*)" + src[t.LONETILDE] + "\\s+";
re[t.TILDETRIM] = new RegExp(src[t.TILDETRIM], "g");
safeRe[t.TILDETRIM] = new RegExp(makeSafeRe(src[t.TILDETRIM]), "g");
var tildeTrimReplace = "$1~";
tok("TILDE");
src[t.TILDE] = "^" + src[t.LONETILDE] + src[t.XRANGEPLAIN] + "$";
tok("TILDELOOSE");
src[t.TILDELOOSE] = "^" + src[t.LONETILDE] + src[t.XRANGEPLAINLOOSE] + "$";
// Caret ranges.
// Meaning is "at least and backwards compatible with"
tok("LONECARET");
src[t.LONECARET] = "(?:\\^)";
tok("CARETTRIM");
src[t.CARETTRIM] = "(\\s*)" + src[t.LONECARET] + "\\s+";
re[t.CARETTRIM] = new RegExp(src[t.CARETTRIM], "g");
safeRe[t.CARETTRIM] = new RegExp(makeSafeRe(src[t.CARETTRIM]), "g");
var caretTrimReplace = "$1^";
tok("CARET");
src[t.CARET] = "^" + src[t.LONECARET] + src[t.XRANGEPLAIN] + "$";
tok("CARETLOOSE");
src[t.CARETLOOSE] = "^" + src[t.LONECARET] + src[t.XRANGEPLAINLOOSE] + "$";
// A simple gt/lt/eq thing, or just "" to indicate "any version"
tok("COMPARATORLOOSE");
src[t.COMPARATORLOOSE] = "^" + src[t.GTLT] + "\\s*(" + src[t.LOOSEPLAIN] + ")$|^$";
tok("COMPARATOR");
src[t.COMPARATOR] = "^" + src[t.GTLT] + "\\s*(" + src[t.FULLPLAIN] + ")$|^$";
// An expression to strip any whitespace between the gtlt and the thing
// it modifies, so that `> 1.2.3` ==> `>1.2.3`
tok("COMPARATORTRIM");
src[t.COMPARATORTRIM] = "(\\s*)" + src[t.GTLT] + "\\s*(" + src[t.LOOSEPLAIN] + "|" + src[t.XRANGEPLAIN] + ")";
// this one has to use the /g flag
re[t.COMPARATORTRIM] = new RegExp(src[t.COMPARATORTRIM], "g");
safeRe[t.COMPARATORTRIM] = new RegExp(makeSafeRe(src[t.COMPARATORTRIM]), "g");
var comparatorTrimReplace = "$1$2$3";
// Something like `1.2.3 - 1.2.4`
// Note that these all use the loose form, because they'll be
// checked against either the strict or loose comparator form
// later.
tok("HYPHENRANGE");
src[t.HYPHENRANGE] = "^\\s*(" + src[t.XRANGEPLAIN] + ")" + "\\s+-\\s+" + "(" + src[t.XRANGEPLAIN] + ")" + "\\s*$";
tok("HYPHENRANGELOOSE");
src[t.HYPHENRANGELOOSE] = "^\\s*(" + src[t.XRANGEPLAINLOOSE] + ")" + "\\s+-\\s+" + "(" + src[t.XRANGEPLAINLOOSE] + ")" + "\\s*$";
// Star ranges basically just allow anything at all.
tok("STAR");
src[t.STAR] = "(<|>)?=?\\s*\\*";
// Compile to actual regexp objects.
// All are flag-free, unless they were created above with a flag.
for(var i = 0; i < R; i++){
    debug(i, src[i]);
    if (!re[i]) {
        re[i] = new RegExp(src[i]);
        // Replace all greedy whitespace to prevent regex dos issues. These regex are
        // used internally via the safeRe object since all inputs in this library get
        // normalized first to trim and collapse all extra whitespace. The original
        // regexes are exported for userland consumption and lower level usage. A
        // future breaking change could export the safer regex only with a note that
        // all input should have extra whitespace removed.
        safeRe[i] = new RegExp(makeSafeRe(src[i]));
    }
}
exports.parse = parse;
function parse(version, options) {
    if (!options || typeof options !== "object") options = {
        loose: !!options,
        includePrerelease: false
    };
    if (version instanceof SemVer) return version;
    if (typeof version !== "string") return null;
    if (version.length > MAX_LENGTH) return null;
    var r = options.loose ? safeRe[t.LOOSE] : safeRe[t.FULL];
    if (!r.test(version)) return null;
    try {
        return new SemVer(version, options);
    } catch (er) {
        return null;
    }
}
exports.valid = valid;
function valid(version, options) {
    var v = parse(version, options);
    return v ? v.version : null;
}
exports.clean = clean;
function clean(version, options) {
    var s = parse(version.trim().replace(/^[=v]+/, ""), options);
    return s ? s.version : null;
}
exports.SemVer = SemVer;
function SemVer(version, options) {
    if (!options || typeof options !== "object") options = {
        loose: !!options,
        includePrerelease: false
    };
    if (version instanceof SemVer) {
        if (version.loose === options.loose) return version;
        else version = version.version;
    } else if (typeof version !== "string") throw new TypeError("Invalid Version: " + version);
    if (version.length > MAX_LENGTH) throw new TypeError("version is longer than " + MAX_LENGTH + " characters");
    if (!(this instanceof SemVer)) return new SemVer(version, options);
    debug("SemVer", version, options);
    this.options = options;
    this.loose = !!options.loose;
    var m = version.trim().match(options.loose ? safeRe[t.LOOSE] : safeRe[t.FULL]);
    if (!m) throw new TypeError("Invalid Version: " + version);
    this.raw = version;
    // these are actually numbers
    this.major = +m[1];
    this.minor = +m[2];
    this.patch = +m[3];
    if (this.major > MAX_SAFE_INTEGER || this.major < 0) throw new TypeError("Invalid major version");
    if (this.minor > MAX_SAFE_INTEGER || this.minor < 0) throw new TypeError("Invalid minor version");
    if (this.patch > MAX_SAFE_INTEGER || this.patch < 0) throw new TypeError("Invalid patch version");
    // numberify any prerelease numeric ids
    if (!m[4]) this.prerelease = [];
    else this.prerelease = m[4].split(".").map(function(id) {
        if (/^[0-9]+$/.test(id)) {
            var num = +id;
            if (num >= 0 && num < MAX_SAFE_INTEGER) return num;
        }
        return id;
    });
    this.build = m[5] ? m[5].split(".") : [];
    this.format();
}
SemVer.prototype.format = function() {
    this.version = this.major + "." + this.minor + "." + this.patch;
    if (this.prerelease.length) this.version += "-" + this.prerelease.join(".");
    return this.version;
};
SemVer.prototype.toString = function() {
    return this.version;
};
SemVer.prototype.compare = function(other) {
    debug("SemVer.compare", this.version, this.options, other);
    if (!(other instanceof SemVer)) other = new SemVer(other, this.options);
    return this.compareMain(other) || this.comparePre(other);
};
SemVer.prototype.compareMain = function(other) {
    if (!(other instanceof SemVer)) other = new SemVer(other, this.options);
    return compareIdentifiers(this.major, other.major) || compareIdentifiers(this.minor, other.minor) || compareIdentifiers(this.patch, other.patch);
};
SemVer.prototype.comparePre = function(other) {
    if (!(other instanceof SemVer)) other = new SemVer(other, this.options);
    // NOT having a prerelease is > having one
    if (this.prerelease.length && !other.prerelease.length) return -1;
    else if (!this.prerelease.length && other.prerelease.length) return 1;
    else if (!this.prerelease.length && !other.prerelease.length) return 0;
    var i = 0;
    do {
        var a = this.prerelease[i];
        var b = other.prerelease[i];
        debug("prerelease compare", i, a, b);
        if (a === undefined && b === undefined) return 0;
        else if (b === undefined) return 1;
        else if (a === undefined) return -1;
        else if (a === b) continue;
        else return compareIdentifiers(a, b);
    }while (++i);
};
SemVer.prototype.compareBuild = function(other) {
    if (!(other instanceof SemVer)) other = new SemVer(other, this.options);
    var i = 0;
    do {
        var a = this.build[i];
        var b = other.build[i];
        debug("prerelease compare", i, a, b);
        if (a === undefined && b === undefined) return 0;
        else if (b === undefined) return 1;
        else if (a === undefined) return -1;
        else if (a === b) continue;
        else return compareIdentifiers(a, b);
    }while (++i);
};
// preminor will bump the version up to the next minor release, and immediately
// down to pre-release. premajor and prepatch work the same way.
SemVer.prototype.inc = function(release, identifier) {
    switch(release){
        case "premajor":
            this.prerelease.length = 0;
            this.patch = 0;
            this.minor = 0;
            this.major++;
            this.inc("pre", identifier);
            break;
        case "preminor":
            this.prerelease.length = 0;
            this.patch = 0;
            this.minor++;
            this.inc("pre", identifier);
            break;
        case "prepatch":
            // If this is already a prerelease, it will bump to the next version
            // drop any prereleases that might already exist, since they are not
            // relevant at this point.
            this.prerelease.length = 0;
            this.inc("patch", identifier);
            this.inc("pre", identifier);
            break;
        // If the input is a non-prerelease version, this acts the same as
        // prepatch.
        case "prerelease":
            if (this.prerelease.length === 0) this.inc("patch", identifier);
            this.inc("pre", identifier);
            break;
        case "major":
            // If this is a pre-major version, bump up to the same major version.
            // Otherwise increment major.
            // 1.0.0-5 bumps to 1.0.0
            // 1.1.0 bumps to 2.0.0
            if (this.minor !== 0 || this.patch !== 0 || this.prerelease.length === 0) this.major++;
            this.minor = 0;
            this.patch = 0;
            this.prerelease = [];
            break;
        case "minor":
            // If this is a pre-minor version, bump up to the same minor version.
            // Otherwise increment minor.
            // 1.2.0-5 bumps to 1.2.0
            // 1.2.1 bumps to 1.3.0
            if (this.patch !== 0 || this.prerelease.length === 0) this.minor++;
            this.patch = 0;
            this.prerelease = [];
            break;
        case "patch":
            // If this is not a pre-release version, it will increment the patch.
            // If it is a pre-release it will bump up to the same patch version.
            // 1.2.0-5 patches to 1.2.0
            // 1.2.0 patches to 1.2.1
            if (this.prerelease.length === 0) this.patch++;
            this.prerelease = [];
            break;
        // This probably shouldn't be used publicly.
        // 1.0.0 "pre" would become 1.0.0-0 which is the wrong direction.
        case "pre":
            if (this.prerelease.length === 0) this.prerelease = [
                0
            ];
            else {
                var i = this.prerelease.length;
                while(--i >= 0)if (typeof this.prerelease[i] === "number") {
                    this.prerelease[i]++;
                    i = -2;
                }
                if (i === -1) // didn't increment anything
                this.prerelease.push(0);
            }
            if (identifier) {
                // 1.2.0-beta.1 bumps to 1.2.0-beta.2,
                // 1.2.0-beta.fooblz or 1.2.0-beta bumps to 1.2.0-beta.0
                if (this.prerelease[0] === identifier) {
                    if (isNaN(this.prerelease[1])) this.prerelease = [
                        identifier,
                        0
                    ];
                } else this.prerelease = [
                    identifier,
                    0
                ];
            }
            break;
        default:
            throw new Error("invalid increment argument: " + release);
    }
    this.format();
    this.raw = this.version;
    return this;
};
exports.inc = inc;
function inc(version, release, loose, identifier) {
    if (typeof loose === "string") {
        identifier = loose;
        loose = undefined;
    }
    try {
        return new SemVer(version, loose).inc(release, identifier).version;
    } catch (er) {
        return null;
    }
}
exports.diff = diff;
function diff(version1, version2) {
    if (eq(version1, version2)) return null;
    else {
        var v1 = parse(version1);
        var v2 = parse(version2);
        var prefix = "";
        if (v1.prerelease.length || v2.prerelease.length) {
            prefix = "pre";
            var defaultResult = "prerelease";
        }
        for(var key in v1)if (key === "major" || key === "minor" || key === "patch") {
            if (v1[key] !== v2[key]) return prefix + key;
        }
        return defaultResult // may be undefined
        ;
    }
}
exports.compareIdentifiers = compareIdentifiers;
var numeric = /^[0-9]+$/;
function compareIdentifiers(a, b) {
    var anum = numeric.test(a);
    var bnum = numeric.test(b);
    if (anum && bnum) {
        a = +a;
        b = +b;
    }
    return a === b ? 0 : anum && !bnum ? -1 : bnum && !anum ? 1 : a < b ? -1 : 1;
}
exports.rcompareIdentifiers = rcompareIdentifiers;
function rcompareIdentifiers(a, b) {
    return compareIdentifiers(b, a);
}
exports.major = major;
function major(a, loose) {
    return new SemVer(a, loose).major;
}
exports.minor = minor;
function minor(a, loose) {
    return new SemVer(a, loose).minor;
}
exports.patch = patch;
function patch(a, loose) {
    return new SemVer(a, loose).patch;
}
exports.compare = compare;
function compare(a, b, loose) {
    return new SemVer(a, loose).compare(new SemVer(b, loose));
}
exports.compareLoose = compareLoose;
function compareLoose(a, b) {
    return compare(a, b, true);
}
exports.compareBuild = compareBuild;
function compareBuild(a, b, loose) {
    var versionA = new SemVer(a, loose);
    var versionB = new SemVer(b, loose);
    return versionA.compare(versionB) || versionA.compareBuild(versionB);
}
exports.rcompare = rcompare;
function rcompare(a, b, loose) {
    return compare(b, a, loose);
}
exports.sort = sort;
function sort(list, loose) {
    return list.sort(function(a, b) {
        return exports.compareBuild(a, b, loose);
    });
}
exports.rsort = rsort;
function rsort(list, loose) {
    return list.sort(function(a, b) {
        return exports.compareBuild(b, a, loose);
    });
}
exports.gt = gt;
function gt(a, b, loose) {
    return compare(a, b, loose) > 0;
}
exports.lt = lt;
function lt(a, b, loose) {
    return compare(a, b, loose) < 0;
}
exports.eq = eq;
function eq(a, b, loose) {
    return compare(a, b, loose) === 0;
}
exports.neq = neq;
function neq(a, b, loose) {
    return compare(a, b, loose) !== 0;
}
exports.gte = gte;
function gte(a, b, loose) {
    return compare(a, b, loose) >= 0;
}
exports.lte = lte;
function lte(a, b, loose) {
    return compare(a, b, loose) <= 0;
}
exports.cmp = cmp;
function cmp(a, op, b, loose) {
    switch(op){
        case "===":
            if (typeof a === "object") a = a.version;
            if (typeof b === "object") b = b.version;
            return a === b;
        case "!==":
            if (typeof a === "object") a = a.version;
            if (typeof b === "object") b = b.version;
            return a !== b;
        case "":
        case "=":
        case "==":
            return eq(a, b, loose);
        case "!=":
            return neq(a, b, loose);
        case ">":
            return gt(a, b, loose);
        case ">=":
            return gte(a, b, loose);
        case "<":
            return lt(a, b, loose);
        case "<=":
            return lte(a, b, loose);
        default:
            throw new TypeError("Invalid operator: " + op);
    }
}
exports.Comparator = Comparator;
function Comparator(comp, options) {
    if (!options || typeof options !== "object") options = {
        loose: !!options,
        includePrerelease: false
    };
    if (comp instanceof Comparator) {
        if (comp.loose === !!options.loose) return comp;
        else comp = comp.value;
    }
    if (!(this instanceof Comparator)) return new Comparator(comp, options);
    comp = comp.trim().split(/\s+/).join(" ");
    debug("comparator", comp, options);
    this.options = options;
    this.loose = !!options.loose;
    this.parse(comp);
    if (this.semver === ANY) this.value = "";
    else this.value = this.operator + this.semver.version;
    debug("comp", this);
}
var ANY = {};
Comparator.prototype.parse = function(comp) {
    var r = this.options.loose ? safeRe[t.COMPARATORLOOSE] : safeRe[t.COMPARATOR];
    var m = comp.match(r);
    if (!m) throw new TypeError("Invalid comparator: " + comp);
    this.operator = m[1] !== undefined ? m[1] : "";
    if (this.operator === "=") this.operator = "";
    // if it literally is just '>' or '' then allow anything.
    if (!m[2]) this.semver = ANY;
    else this.semver = new SemVer(m[2], this.options.loose);
};
Comparator.prototype.toString = function() {
    return this.value;
};
Comparator.prototype.test = function(version) {
    debug("Comparator.test", version, this.options.loose);
    if (this.semver === ANY || version === ANY) return true;
    if (typeof version === "string") try {
        version = new SemVer(version, this.options);
    } catch (er) {
        return false;
    }
    return cmp(version, this.operator, this.semver, this.options);
};
Comparator.prototype.intersects = function(comp, options) {
    if (!(comp instanceof Comparator)) throw new TypeError("a Comparator is required");
    if (!options || typeof options !== "object") options = {
        loose: !!options,
        includePrerelease: false
    };
    var rangeTmp;
    if (this.operator === "") {
        if (this.value === "") return true;
        rangeTmp = new Range(comp.value, options);
        return satisfies(this.value, rangeTmp, options);
    } else if (comp.operator === "") {
        if (comp.value === "") return true;
        rangeTmp = new Range(this.value, options);
        return satisfies(comp.semver, rangeTmp, options);
    }
    var sameDirectionIncreasing = (this.operator === ">=" || this.operator === ">") && (comp.operator === ">=" || comp.operator === ">");
    var sameDirectionDecreasing = (this.operator === "<=" || this.operator === "<") && (comp.operator === "<=" || comp.operator === "<");
    var sameSemVer = this.semver.version === comp.semver.version;
    var differentDirectionsInclusive = (this.operator === ">=" || this.operator === "<=") && (comp.operator === ">=" || comp.operator === "<=");
    var oppositeDirectionsLessThan = cmp(this.semver, "<", comp.semver, options) && (this.operator === ">=" || this.operator === ">") && (comp.operator === "<=" || comp.operator === "<");
    var oppositeDirectionsGreaterThan = cmp(this.semver, ">", comp.semver, options) && (this.operator === "<=" || this.operator === "<") && (comp.operator === ">=" || comp.operator === ">");
    return sameDirectionIncreasing || sameDirectionDecreasing || sameSemVer && differentDirectionsInclusive || oppositeDirectionsLessThan || oppositeDirectionsGreaterThan;
};
exports.Range = Range;
function Range(range, options) {
    if (!options || typeof options !== "object") options = {
        loose: !!options,
        includePrerelease: false
    };
    if (range instanceof Range) {
        if (range.loose === !!options.loose && range.includePrerelease === !!options.includePrerelease) return range;
        else return new Range(range.raw, options);
    }
    if (range instanceof Comparator) return new Range(range.value, options);
    if (!(this instanceof Range)) return new Range(range, options);
    this.options = options;
    this.loose = !!options.loose;
    this.includePrerelease = !!options.includePrerelease;
    // First reduce all whitespace as much as possible so we do not have to rely
    // on potentially slow regexes like \s*. This is then stored and used for
    // future error messages as well.
    this.raw = range.trim().split(/\s+/).join(" ");
    // First, split based on boolean or ||
    this.set = this.raw.split("||").map(function(range) {
        return this.parseRange(range.trim());
    }, this).filter(function(c) {
        // throw out any that are not relevant for whatever reason
        return c.length;
    });
    if (!this.set.length) throw new TypeError("Invalid SemVer Range: " + this.raw);
    this.format();
}
Range.prototype.format = function() {
    this.range = this.set.map(function(comps) {
        return comps.join(" ").trim();
    }).join("||").trim();
    return this.range;
};
Range.prototype.toString = function() {
    return this.range;
};
Range.prototype.parseRange = function(range) {
    var loose = this.options.loose;
    // `1.2.3 - 1.2.4` => `>=1.2.3 <=1.2.4`
    var hr = loose ? safeRe[t.HYPHENRANGELOOSE] : safeRe[t.HYPHENRANGE];
    range = range.replace(hr, hyphenReplace);
    debug("hyphen replace", range);
    // `> 1.2.3 < 1.2.5` => `>1.2.3 <1.2.5`
    range = range.replace(safeRe[t.COMPARATORTRIM], comparatorTrimReplace);
    debug("comparator trim", range, safeRe[t.COMPARATORTRIM]);
    // `~ 1.2.3` => `~1.2.3`
    range = range.replace(safeRe[t.TILDETRIM], tildeTrimReplace);
    // `^ 1.2.3` => `^1.2.3`
    range = range.replace(safeRe[t.CARETTRIM], caretTrimReplace);
    // normalize spaces
    range = range.split(/\s+/).join(" ");
    // At this point, the range is completely trimmed and
    // ready to be split into comparators.
    var compRe = loose ? safeRe[t.COMPARATORLOOSE] : safeRe[t.COMPARATOR];
    var set = range.split(" ").map(function(comp) {
        return parseComparator(comp, this.options);
    }, this).join(" ").split(/\s+/);
    if (this.options.loose) // in loose mode, throw out any that are not valid comparators
    set = set.filter(function(comp) {
        return !!comp.match(compRe);
    });
    set = set.map(function(comp) {
        return new Comparator(comp, this.options);
    }, this);
    return set;
};
Range.prototype.intersects = function(range, options) {
    if (!(range instanceof Range)) throw new TypeError("a Range is required");
    return this.set.some(function(thisComparators) {
        return isSatisfiable(thisComparators, options) && range.set.some(function(rangeComparators) {
            return isSatisfiable(rangeComparators, options) && thisComparators.every(function(thisComparator) {
                return rangeComparators.every(function(rangeComparator) {
                    return thisComparator.intersects(rangeComparator, options);
                });
            });
        });
    });
};
// take a set of comparators and determine whether there
// exists a version which can satisfy it
function isSatisfiable(comparators, options) {
    var result = true;
    var remainingComparators = comparators.slice();
    var testComparator = remainingComparators.pop();
    while(result && remainingComparators.length){
        result = remainingComparators.every(function(otherComparator) {
            return testComparator.intersects(otherComparator, options);
        });
        testComparator = remainingComparators.pop();
    }
    return result;
}
// Mostly just for testing and legacy API reasons
exports.toComparators = toComparators;
function toComparators(range, options) {
    return new Range(range, options).set.map(function(comp) {
        return comp.map(function(c) {
            return c.value;
        }).join(" ").trim().split(" ");
    });
}
// comprised of xranges, tildes, stars, and gtlt's at this point.
// already replaced the hyphen ranges
// turn into a set of JUST comparators.
function parseComparator(comp, options) {
    debug("comp", comp, options);
    comp = replaceCarets(comp, options);
    debug("caret", comp);
    comp = replaceTildes(comp, options);
    debug("tildes", comp);
    comp = replaceXRanges(comp, options);
    debug("xrange", comp);
    comp = replaceStars(comp, options);
    debug("stars", comp);
    return comp;
}
function isX(id) {
    return !id || id.toLowerCase() === "x" || id === "*";
}
// ~, ~> --> * (any, kinda silly)
// ~2, ~2.x, ~2.x.x, ~>2, ~>2.x ~>2.x.x --> >=2.0.0 <3.0.0
// ~2.0, ~2.0.x, ~>2.0, ~>2.0.x --> >=2.0.0 <2.1.0
// ~1.2, ~1.2.x, ~>1.2, ~>1.2.x --> >=1.2.0 <1.3.0
// ~1.2.3, ~>1.2.3 --> >=1.2.3 <1.3.0
// ~1.2.0, ~>1.2.0 --> >=1.2.0 <1.3.0
function replaceTildes(comp, options) {
    return comp.trim().split(/\s+/).map(function(comp) {
        return replaceTilde(comp, options);
    }).join(" ");
}
function replaceTilde(comp, options) {
    var r = options.loose ? safeRe[t.TILDELOOSE] : safeRe[t.TILDE];
    return comp.replace(r, function(_, M, m, p, pr) {
        debug("tilde", comp, _, M, m, p, pr);
        var ret;
        if (isX(M)) ret = "";
        else if (isX(m)) ret = ">=" + M + ".0.0 <" + (+M + 1) + ".0.0";
        else if (isX(p)) // ~1.2 == >=1.2.0 <1.3.0
        ret = ">=" + M + "." + m + ".0 <" + M + "." + (+m + 1) + ".0";
        else if (pr) {
            debug("replaceTilde pr", pr);
            ret = ">=" + M + "." + m + "." + p + "-" + pr + " <" + M + "." + (+m + 1) + ".0";
        } else // ~1.2.3 == >=1.2.3 <1.3.0
        ret = ">=" + M + "." + m + "." + p + " <" + M + "." + (+m + 1) + ".0";
        debug("tilde return", ret);
        return ret;
    });
}
// ^ --> * (any, kinda silly)
// ^2, ^2.x, ^2.x.x --> >=2.0.0 <3.0.0
// ^2.0, ^2.0.x --> >=2.0.0 <3.0.0
// ^1.2, ^1.2.x --> >=1.2.0 <2.0.0
// ^1.2.3 --> >=1.2.3 <2.0.0
// ^1.2.0 --> >=1.2.0 <2.0.0
function replaceCarets(comp, options) {
    return comp.trim().split(/\s+/).map(function(comp) {
        return replaceCaret(comp, options);
    }).join(" ");
}
function replaceCaret(comp, options) {
    debug("caret", comp, options);
    var r = options.loose ? safeRe[t.CARETLOOSE] : safeRe[t.CARET];
    return comp.replace(r, function(_, M, m, p, pr) {
        debug("caret", comp, _, M, m, p, pr);
        var ret;
        if (isX(M)) ret = "";
        else if (isX(m)) ret = ">=" + M + ".0.0 <" + (+M + 1) + ".0.0";
        else if (isX(p)) {
            if (M === "0") ret = ">=" + M + "." + m + ".0 <" + M + "." + (+m + 1) + ".0";
            else ret = ">=" + M + "." + m + ".0 <" + (+M + 1) + ".0.0";
        } else if (pr) {
            debug("replaceCaret pr", pr);
            if (M === "0") {
                if (m === "0") ret = ">=" + M + "." + m + "." + p + "-" + pr + " <" + M + "." + m + "." + (+p + 1);
                else ret = ">=" + M + "." + m + "." + p + "-" + pr + " <" + M + "." + (+m + 1) + ".0";
            } else ret = ">=" + M + "." + m + "." + p + "-" + pr + " <" + (+M + 1) + ".0.0";
        } else {
            debug("no pr");
            if (M === "0") {
                if (m === "0") ret = ">=" + M + "." + m + "." + p + " <" + M + "." + m + "." + (+p + 1);
                else ret = ">=" + M + "." + m + "." + p + " <" + M + "." + (+m + 1) + ".0";
            } else ret = ">=" + M + "." + m + "." + p + " <" + (+M + 1) + ".0.0";
        }
        debug("caret return", ret);
        return ret;
    });
}
function replaceXRanges(comp, options) {
    debug("replaceXRanges", comp, options);
    return comp.split(/\s+/).map(function(comp) {
        return replaceXRange(comp, options);
    }).join(" ");
}
function replaceXRange(comp, options) {
    comp = comp.trim();
    var r = options.loose ? safeRe[t.XRANGELOOSE] : safeRe[t.XRANGE];
    return comp.replace(r, function(ret, gtlt, M, m, p, pr) {
        debug("xRange", comp, ret, gtlt, M, m, p, pr);
        var xM = isX(M);
        var xm = xM || isX(m);
        var xp = xm || isX(p);
        var anyX = xp;
        if (gtlt === "=" && anyX) gtlt = "";
        // if we're including prereleases in the match, then we need
        // to fix this to -0, the lowest possible prerelease value
        pr = options.includePrerelease ? "-0" : "";
        if (xM) {
            if (gtlt === ">" || gtlt === "<") // nothing is allowed
            ret = "<0.0.0-0";
            else // nothing is forbidden
            ret = "*";
        } else if (gtlt && anyX) {
            // we know patch is an x, because we have any x at all.
            // replace X with 0
            if (xm) m = 0;
            p = 0;
            if (gtlt === ">") {
                // >1 => >=2.0.0
                // >1.2 => >=1.3.0
                // >1.2.3 => >= 1.2.4
                gtlt = ">=";
                if (xm) {
                    M = +M + 1;
                    m = 0;
                    p = 0;
                } else {
                    m = +m + 1;
                    p = 0;
                }
            } else if (gtlt === "<=") {
                // <=0.7.x is actually <0.8.0, since any 0.7.x should
                // pass.  Similarly, <=7.x is actually <8.0.0, etc.
                gtlt = "<";
                if (xm) M = +M + 1;
                else m = +m + 1;
            }
            ret = gtlt + M + "." + m + "." + p + pr;
        } else if (xm) ret = ">=" + M + ".0.0" + pr + " <" + (+M + 1) + ".0.0" + pr;
        else if (xp) ret = ">=" + M + "." + m + ".0" + pr + " <" + M + "." + (+m + 1) + ".0" + pr;
        debug("xRange return", ret);
        return ret;
    });
}
// Because * is AND-ed with everything else in the comparator,
// and '' means "any version", just remove the *s entirely.
function replaceStars(comp, options) {
    debug("replaceStars", comp, options);
    // Looseness is ignored here.  star is always as loose as it gets!
    return comp.trim().replace(safeRe[t.STAR], "");
}
// This function is passed to string.replace(re[t.HYPHENRANGE])
// M, m, patch, prerelease, build
// 1.2 - 3.4.5 => >=1.2.0 <=3.4.5
// 1.2.3 - 3.4 => >=1.2.0 <3.5.0 Any 3.4.x will do
// 1.2 - 3.4 => >=1.2.0 <3.5.0
function hyphenReplace($0, from, fM, fm, fp, fpr, fb, to, tM, tm, tp, tpr, tb) {
    if (isX(fM)) from = "";
    else if (isX(fm)) from = ">=" + fM + ".0.0";
    else if (isX(fp)) from = ">=" + fM + "." + fm + ".0";
    else from = ">=" + from;
    if (isX(tM)) to = "";
    else if (isX(tm)) to = "<" + (+tM + 1) + ".0.0";
    else if (isX(tp)) to = "<" + tM + "." + (+tm + 1) + ".0";
    else if (tpr) to = "<=" + tM + "." + tm + "." + tp + "-" + tpr;
    else to = "<=" + to;
    return (from + " " + to).trim();
}
// if ANY of the sets match ALL of its comparators, then pass
Range.prototype.test = function(version) {
    if (!version) return false;
    if (typeof version === "string") try {
        version = new SemVer(version, this.options);
    } catch (er) {
        return false;
    }
    for(var i = 0; i < this.set.length; i++){
        if (testSet(this.set[i], version, this.options)) return true;
    }
    return false;
};
function testSet(set, version, options) {
    for(var i = 0; i < set.length; i++){
        if (!set[i].test(version)) return false;
    }
    if (version.prerelease.length && !options.includePrerelease) {
        // Find the set of versions that are allowed to have prereleases
        // For example, ^1.2.3-pr.1 desugars to >=1.2.3-pr.1 <2.0.0
        // That should allow `1.2.3-pr.2` to pass.
        // However, `1.2.4-alpha.notready` should NOT be allowed,
        // even though it's within the range set by the comparators.
        for(i = 0; i < set.length; i++){
            debug(set[i].semver);
            if (set[i].semver === ANY) continue;
            if (set[i].semver.prerelease.length > 0) {
                var allowed = set[i].semver;
                if (allowed.major === version.major && allowed.minor === version.minor && allowed.patch === version.patch) return true;
            }
        }
        // Version has a -pre, but it's not one of the ones we like.
        return false;
    }
    return true;
}
exports.satisfies = satisfies;
function satisfies(version, range, options) {
    try {
        range = new Range(range, options);
    } catch (er) {
        return false;
    }
    return range.test(version);
}
exports.maxSatisfying = maxSatisfying;
function maxSatisfying(versions, range, options) {
    var max = null;
    var maxSV = null;
    try {
        var rangeObj = new Range(range, options);
    } catch (er) {
        return null;
    }
    versions.forEach(function(v) {
        if (rangeObj.test(v)) // satisfies(v, range, options)
        {
            if (!max || maxSV.compare(v) === -1) {
                // compare(max, v, true)
                max = v;
                maxSV = new SemVer(max, options);
            }
        }
    });
    return max;
}
exports.minSatisfying = minSatisfying;
function minSatisfying(versions, range, options) {
    var min = null;
    var minSV = null;
    try {
        var rangeObj = new Range(range, options);
    } catch (er) {
        return null;
    }
    versions.forEach(function(v) {
        if (rangeObj.test(v)) // satisfies(v, range, options)
        {
            if (!min || minSV.compare(v) === 1) {
                // compare(min, v, true)
                min = v;
                minSV = new SemVer(min, options);
            }
        }
    });
    return min;
}
exports.minVersion = minVersion;
function minVersion(range, loose) {
    range = new Range(range, loose);
    var minver = new SemVer("0.0.0");
    if (range.test(minver)) return minver;
    minver = new SemVer("0.0.0-0");
    if (range.test(minver)) return minver;
    minver = null;
    for(var i = 0; i < range.set.length; ++i){
        var comparators = range.set[i];
        comparators.forEach(function(comparator) {
            // Clone to avoid manipulating the comparator's semver object.
            var compver = new SemVer(comparator.semver.version);
            switch(comparator.operator){
                case ">":
                    if (compver.prerelease.length === 0) compver.patch++;
                    else compver.prerelease.push(0);
                    compver.raw = compver.format();
                /* fallthrough */ case "":
                case ">=":
                    if (!minver || gt(minver, compver)) minver = compver;
                    break;
                case "<":
                case "<=":
                    break;
                /* istanbul ignore next */ default:
                    throw new Error("Unexpected operation: " + comparator.operator);
            }
        });
    }
    if (minver && range.test(minver)) return minver;
    return null;
}
exports.validRange = validRange;
function validRange(range, options) {
    try {
        // Return '*' instead of '' so that truthiness works.
        // This will throw if it's invalid anyway
        return new Range(range, options).range || "*";
    } catch (er) {
        return null;
    }
}
// Determine if version is less than all the versions possible in the range
exports.ltr = ltr;
function ltr(version, range, options) {
    return outside(version, range, "<", options);
}
// Determine if version is greater than all the versions possible in the range.
exports.gtr = gtr;
function gtr(version, range, options) {
    return outside(version, range, ">", options);
}
exports.outside = outside;
function outside(version, range, hilo, options) {
    version = new SemVer(version, options);
    range = new Range(range, options);
    var gtfn, ltefn, ltfn, comp, ecomp;
    switch(hilo){
        case ">":
            gtfn = gt;
            ltefn = lte;
            ltfn = lt;
            comp = ">";
            ecomp = ">=";
            break;
        case "<":
            gtfn = lt;
            ltefn = gte;
            ltfn = gt;
            comp = "<";
            ecomp = "<=";
            break;
        default:
            throw new TypeError('Must provide a hilo val of "<" or ">"');
    }
    // If it satisifes the range it is not outside
    if (satisfies(version, range, options)) return false;
    // From now on, variable terms are as if we're in "gtr" mode.
    // but note that everything is flipped for the "ltr" function.
    for(var i = 0; i < range.set.length; ++i){
        var comparators = range.set[i];
        var high = null;
        var low = null;
        comparators.forEach(function(comparator) {
            if (comparator.semver === ANY) comparator = new Comparator(">=0.0.0");
            high = high || comparator;
            low = low || comparator;
            if (gtfn(comparator.semver, high.semver, options)) high = comparator;
            else if (ltfn(comparator.semver, low.semver, options)) low = comparator;
        });
        // If the edge version comparator has a operator then our version
        // isn't outside it
        if (high.operator === comp || high.operator === ecomp) return false;
        // If the lowest version comparator has an operator and our version
        // is less than it then it isn't higher than the range
        if ((!low.operator || low.operator === comp) && ltefn(version, low.semver)) return false;
        else if (low.operator === ecomp && ltfn(version, low.semver)) return false;
    }
    return true;
}
exports.prerelease = prerelease;
function prerelease(version, options) {
    var parsed = parse(version, options);
    return parsed && parsed.prerelease.length ? parsed.prerelease : null;
}
exports.intersects = intersects;
function intersects(r1, r2, options) {
    r1 = new Range(r1, options);
    r2 = new Range(r2, options);
    return r1.intersects(r2);
}
exports.coerce = coerce;
function coerce(version, options) {
    if (version instanceof SemVer) return version;
    if (typeof version === "number") version = String(version);
    if (typeof version !== "string") return null;
    options = options || {};
    var match = null;
    if (!options.rtl) match = version.match(safeRe[t.COERCE]);
    else {
        // Find the right-most coercible string that does not share
        // a terminus with a more left-ward coercible string.
        // Eg, '1.2.3.4' wants to coerce '2.3.4', not '3.4' or '4'
        //
        // Walk through the string checking with a /g regexp
        // Manually set the index so as to pick up overlapping matches.
        // Stop when we get a match that ends at the string end, since no
        // coercible string can be more right-ward without the same terminus.
        var next;
        while((next = safeRe[t.COERCERTL].exec(version)) && (!match || match.index + match[0].length !== version.length)){
            if (!match || next.index + next[0].length !== match.index + match[0].length) match = next;
            safeRe[t.COERCERTL].lastIndex = next.index + next[1].length + next[2].length;
        }
        // leave it in a clean state
        safeRe[t.COERCERTL].lastIndex = -1;
    }
    if (match === null) return null;
    return parse(match[2] + "." + (match[3] || "0") + "." + (match[4] || "0"), options);
}

});


parcelRegister("fJWeE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b7583b531e169c8e$var$_default;

function $b7583b531e169c8e$var$helpers() {
    const data = (parcelRequire("8sOJt"));
    $b7583b531e169c8e$var$helpers = function() {
        return data;
    };
    return data;
}

function $b7583b531e169c8e$var$_generator() {
    const data = (parcelRequire("iQrBP"));
    $b7583b531e169c8e$var$_generator = function() {
        return data;
    };
    return data;
}

function $b7583b531e169c8e$var$_template() {
    const data = (parcelRequire("gQ5sj"));
    $b7583b531e169c8e$var$_template = function() {
        return data;
    };
    return data;
}

function $b7583b531e169c8e$var$_t() {
    const data = (parcelRequire("ardUq"));
    $b7583b531e169c8e$var$_t = function() {
        return data;
    };
    return data;
}

var $ir8Cn = parcelRequire("ir8Cn");
const { arrayExpression: $b7583b531e169c8e$var$arrayExpression, assignmentExpression: $b7583b531e169c8e$var$assignmentExpression, binaryExpression: $b7583b531e169c8e$var$binaryExpression, blockStatement: $b7583b531e169c8e$var$blockStatement, callExpression: $b7583b531e169c8e$var$callExpression, cloneNode: $b7583b531e169c8e$var$cloneNode, conditionalExpression: $b7583b531e169c8e$var$conditionalExpression, exportNamedDeclaration: $b7583b531e169c8e$var$exportNamedDeclaration, exportSpecifier: $b7583b531e169c8e$var$exportSpecifier, expressionStatement: $b7583b531e169c8e$var$expressionStatement, functionExpression: $b7583b531e169c8e$var$functionExpression, identifier: $b7583b531e169c8e$var$identifier, memberExpression: $b7583b531e169c8e$var$memberExpression, objectExpression: $b7583b531e169c8e$var$objectExpression, program: $b7583b531e169c8e$var$program, stringLiteral: $b7583b531e169c8e$var$stringLiteral, unaryExpression: $b7583b531e169c8e$var$unaryExpression, variableDeclaration: $b7583b531e169c8e$var$variableDeclaration, variableDeclarator: $b7583b531e169c8e$var$variableDeclarator } = $b7583b531e169c8e$var$_t();
const $b7583b531e169c8e$var$buildUmdWrapper = (replacements)=>$b7583b531e169c8e$var$_template().default.statement`
    (function (root, factory) {
      if (typeof define === "function" && define.amd) {
        define(AMD_ARGUMENTS, factory);
      } else if (typeof exports === "object") {
        factory(COMMON_ARGUMENTS);
      } else {
        factory(BROWSER_ARGUMENTS);
      }
    })(UMD_ROOT, function (FACTORY_PARAMETERS) {
      FACTORY_BODY
    });
  `(replacements);
function $b7583b531e169c8e$var$buildGlobal(allowlist) {
    const namespace = $b7583b531e169c8e$var$identifier("babelHelpers");
    const body = [];
    const container = $b7583b531e169c8e$var$functionExpression(null, [
        $b7583b531e169c8e$var$identifier("global")
    ], $b7583b531e169c8e$var$blockStatement(body));
    const tree = $b7583b531e169c8e$var$program([
        $b7583b531e169c8e$var$expressionStatement($b7583b531e169c8e$var$callExpression(container, [
            $b7583b531e169c8e$var$conditionalExpression($b7583b531e169c8e$var$binaryExpression("===", $b7583b531e169c8e$var$unaryExpression("typeof", $b7583b531e169c8e$var$identifier("global")), $b7583b531e169c8e$var$stringLiteral("undefined")), $b7583b531e169c8e$var$identifier("self"), $b7583b531e169c8e$var$identifier("global"))
        ]))
    ]);
    body.push($b7583b531e169c8e$var$variableDeclaration("var", [
        $b7583b531e169c8e$var$variableDeclarator(namespace, $b7583b531e169c8e$var$assignmentExpression("=", $b7583b531e169c8e$var$memberExpression($b7583b531e169c8e$var$identifier("global"), namespace), $b7583b531e169c8e$var$objectExpression([])))
    ]));
    $b7583b531e169c8e$var$buildHelpers(body, namespace, allowlist);
    return tree;
}
function $b7583b531e169c8e$var$buildModule(allowlist) {
    const body = [];
    const refs = $b7583b531e169c8e$var$buildHelpers(body, null, allowlist);
    body.unshift($b7583b531e169c8e$var$exportNamedDeclaration(null, Object.keys(refs).map((name)=>{
        return $b7583b531e169c8e$var$exportSpecifier($b7583b531e169c8e$var$cloneNode(refs[name]), $b7583b531e169c8e$var$identifier(name));
    })));
    return $b7583b531e169c8e$var$program(body, [], "module");
}
function $b7583b531e169c8e$var$buildUmd(allowlist) {
    const namespace = $b7583b531e169c8e$var$identifier("babelHelpers");
    const body = [];
    body.push($b7583b531e169c8e$var$variableDeclaration("var", [
        $b7583b531e169c8e$var$variableDeclarator(namespace, $b7583b531e169c8e$var$identifier("global"))
    ]));
    $b7583b531e169c8e$var$buildHelpers(body, namespace, allowlist);
    return $b7583b531e169c8e$var$program([
        $b7583b531e169c8e$var$buildUmdWrapper({
            FACTORY_PARAMETERS: $b7583b531e169c8e$var$identifier("global"),
            BROWSER_ARGUMENTS: $b7583b531e169c8e$var$assignmentExpression("=", $b7583b531e169c8e$var$memberExpression($b7583b531e169c8e$var$identifier("root"), namespace), $b7583b531e169c8e$var$objectExpression([])),
            COMMON_ARGUMENTS: $b7583b531e169c8e$var$identifier("exports"),
            AMD_ARGUMENTS: $b7583b531e169c8e$var$arrayExpression([
                $b7583b531e169c8e$var$stringLiteral("exports")
            ]),
            FACTORY_BODY: body,
            UMD_ROOT: $b7583b531e169c8e$var$identifier("this")
        })
    ]);
}
function $b7583b531e169c8e$var$buildVar(allowlist) {
    const namespace = $b7583b531e169c8e$var$identifier("babelHelpers");
    const body = [];
    body.push($b7583b531e169c8e$var$variableDeclaration("var", [
        $b7583b531e169c8e$var$variableDeclarator(namespace, $b7583b531e169c8e$var$objectExpression([]))
    ]));
    const tree = $b7583b531e169c8e$var$program(body);
    $b7583b531e169c8e$var$buildHelpers(body, namespace, allowlist);
    body.push($b7583b531e169c8e$var$expressionStatement(namespace));
    return tree;
}
function $b7583b531e169c8e$var$buildHelpers(body, namespace, allowlist) {
    const getHelperReference = (name)=>{
        return namespace ? $b7583b531e169c8e$var$memberExpression(namespace, $b7583b531e169c8e$var$identifier(name)) : $b7583b531e169c8e$var$identifier(`_${name}`);
    };
    const refs = {};
    $b7583b531e169c8e$var$helpers().list.forEach(function(name) {
        if (allowlist && allowlist.indexOf(name) < 0) return;
        const ref = refs[name] = getHelperReference(name);
        $b7583b531e169c8e$var$helpers().ensure(name, $ir8Cn.default);
        const { nodes: nodes } = $b7583b531e169c8e$var$helpers().get(name, getHelperReference, ref);
        body.push(...nodes);
    });
    return refs;
}
function $b7583b531e169c8e$var$_default(allowlist, outputType = "global") {
    let tree;
    const build = {
        global: $b7583b531e169c8e$var$buildGlobal,
        module: $b7583b531e169c8e$var$buildModule,
        umd: $b7583b531e169c8e$var$buildUmd,
        var: $b7583b531e169c8e$var$buildVar
    }[outputType];
    if (build) tree = build(allowlist);
    else throw new Error(`Unsupported output type ${outputType}`);
    return (0, $b7583b531e169c8e$var$_generator().default)(tree).code;
}

});

parcelRegister("4h8hI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ROOT_CONFIG_FILENAMES = void 0;
module.exports.findConfigUpwards = $31cf2d201b5082f6$var$findConfigUpwards;
module.exports.findPackageData = $31cf2d201b5082f6$var$findPackageData;
module.exports.findRelativeConfig = $31cf2d201b5082f6$var$findRelativeConfig;
module.exports.findRootConfig = $31cf2d201b5082f6$var$findRootConfig;
module.exports.loadConfig = $31cf2d201b5082f6$var$loadConfig;
module.exports.loadPlugin = $31cf2d201b5082f6$var$loadPlugin;
module.exports.loadPreset = $31cf2d201b5082f6$var$loadPreset;
module.exports.resolvePlugin = $31cf2d201b5082f6$var$resolvePlugin;
module.exports.resolvePreset = $31cf2d201b5082f6$var$resolvePreset;
module.exports.resolveShowConfigPath = $31cf2d201b5082f6$var$resolveShowConfigPath;
function $31cf2d201b5082f6$var$findConfigUpwards(rootDir) {
    return null;
}
function* $31cf2d201b5082f6$var$findPackageData(filepath) {
    return {
        filepath: filepath,
        directories: [],
        pkg: null,
        isPackage: false
    };
}
function* $31cf2d201b5082f6$var$findRelativeConfig(pkgData, envName, caller) {
    return {
        config: null,
        ignore: null
    };
}
function* $31cf2d201b5082f6$var$findRootConfig(dirname, envName, caller) {
    return null;
}
function* $31cf2d201b5082f6$var$loadConfig(name, dirname, envName, caller) {
    throw new Error(`Cannot load ${name} relative to ${dirname} in a browser`);
}
function* $31cf2d201b5082f6$var$resolveShowConfigPath(dirname) {
    return null;
}
const $31cf2d201b5082f6$var$ROOT_CONFIG_FILENAMES = module.exports.ROOT_CONFIG_FILENAMES = [];
function $31cf2d201b5082f6$var$resolvePlugin(name, dirname) {
    return null;
}
function $31cf2d201b5082f6$var$resolvePreset(name, dirname) {
    return null;
}
function $31cf2d201b5082f6$var$loadPlugin(name, dirname) {
    throw new Error(`Cannot load plugin ${name} relative to ${dirname} in a browser`);
}
function $31cf2d201b5082f6$var$loadPreset(name, dirname) {
    throw new Error(`Cannot load preset ${name} relative to ${dirname} in a browser`);
}

});

parcelRegister("33Znv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getEnv = $23b1435358eb543a$var$getEnv;
function $23b1435358eb543a$var$getEnv(defaultValue = "development") {
    return "production";
}

});

parcelRegister("6JZbd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createConfigItem = $4e86671adb972761$var$createConfigItem;
module.exports.createConfigItemAsync = $4e86671adb972761$var$createConfigItemAsync;
module.exports.createConfigItemSync = $4e86671adb972761$var$createConfigItemSync;
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $2dkOY.default;
    }
});
module.exports.loadOptions = $4e86671adb972761$var$loadOptions;
module.exports.loadOptionsAsync = $4e86671adb972761$var$loadOptionsAsync;
module.exports.loadOptionsSync = $4e86671adb972761$var$loadOptionsSync;
module.exports.loadPartialConfig = $4e86671adb972761$var$loadPartialConfig;
module.exports.loadPartialConfigAsync = $4e86671adb972761$var$loadPartialConfigAsync;
module.exports.loadPartialConfigSync = $4e86671adb972761$var$loadPartialConfigSync;

function $4e86671adb972761$var$_gensync() {
    const data = (parcelRequire("8AIEE"));
    $4e86671adb972761$var$_gensync = function() {
        return data;
    };
    return data;
}

var $2dkOY = parcelRequire("2dkOY");

var $77Tks = parcelRequire("77Tks");

var $ajpbS = parcelRequire("ajpbS");

var $jYXMt = parcelRequire("jYXMt");
const $4e86671adb972761$var$loadPartialConfigRunner = $4e86671adb972761$var$_gensync()($77Tks.loadPartialConfig);
function $4e86671adb972761$var$loadPartialConfigAsync(...args) {
    return (0, $jYXMt.beginHiddenCallStack)($4e86671adb972761$var$loadPartialConfigRunner.async)(...args);
}
function $4e86671adb972761$var$loadPartialConfigSync(...args) {
    return (0, $jYXMt.beginHiddenCallStack)($4e86671adb972761$var$loadPartialConfigRunner.sync)(...args);
}
function $4e86671adb972761$var$loadPartialConfig(opts, callback) {
    if (callback !== undefined) (0, $jYXMt.beginHiddenCallStack)($4e86671adb972761$var$loadPartialConfigRunner.errback)(opts, callback);
    else if (typeof opts === "function") (0, $jYXMt.beginHiddenCallStack)($4e86671adb972761$var$loadPartialConfigRunner.errback)(undefined, opts);
    else return $4e86671adb972761$var$loadPartialConfigSync(opts);
}
function* $4e86671adb972761$var$loadOptionsImpl(opts) {
    var _config$options;
    const config = yield* (0, $2dkOY.default)(opts);
    return (_config$options = config == null ? void 0 : config.options) != null ? _config$options : null;
}
const $4e86671adb972761$var$loadOptionsRunner = $4e86671adb972761$var$_gensync()($4e86671adb972761$var$loadOptionsImpl);
function $4e86671adb972761$var$loadOptionsAsync(...args) {
    return (0, $jYXMt.beginHiddenCallStack)($4e86671adb972761$var$loadOptionsRunner.async)(...args);
}
function $4e86671adb972761$var$loadOptionsSync(...args) {
    return (0, $jYXMt.beginHiddenCallStack)($4e86671adb972761$var$loadOptionsRunner.sync)(...args);
}
function $4e86671adb972761$var$loadOptions(opts, callback) {
    if (callback !== undefined) (0, $jYXMt.beginHiddenCallStack)($4e86671adb972761$var$loadOptionsRunner.errback)(opts, callback);
    else if (typeof opts === "function") (0, $jYXMt.beginHiddenCallStack)($4e86671adb972761$var$loadOptionsRunner.errback)(undefined, opts);
    else return $4e86671adb972761$var$loadOptionsSync(opts);
}
const $4e86671adb972761$var$createConfigItemRunner = $4e86671adb972761$var$_gensync()($ajpbS.createConfigItem);
function $4e86671adb972761$var$createConfigItemAsync(...args) {
    return (0, $jYXMt.beginHiddenCallStack)($4e86671adb972761$var$createConfigItemRunner.async)(...args);
}
function $4e86671adb972761$var$createConfigItemSync(...args) {
    return (0, $jYXMt.beginHiddenCallStack)($4e86671adb972761$var$createConfigItemRunner.sync)(...args);
}
function $4e86671adb972761$var$createConfigItem(target, options, callback) {
    if (callback !== undefined) (0, $jYXMt.beginHiddenCallStack)($4e86671adb972761$var$createConfigItemRunner.errback)(target, options, callback);
    else if (typeof options === "function") (0, $jYXMt.beginHiddenCallStack)($4e86671adb972761$var$createConfigItemRunner.errback)(target, undefined, callback);
    else return $4e86671adb972761$var$createConfigItemSync(target, options);
}

});
parcelRegister("8AIEE", function(module, exports) {
"use strict";
// These use the global symbol registry so that multiple copies of this
// library can work together in case they are not deduped.
const $641452fd47dff0cf$var$GENSYNC_START = Symbol.for("gensync:v1:start");
const $641452fd47dff0cf$var$GENSYNC_SUSPEND = Symbol.for("gensync:v1:suspend");
const $641452fd47dff0cf$var$GENSYNC_EXPECTED_START = "GENSYNC_EXPECTED_START";
const $641452fd47dff0cf$var$GENSYNC_EXPECTED_SUSPEND = "GENSYNC_EXPECTED_SUSPEND";
const $641452fd47dff0cf$var$GENSYNC_OPTIONS_ERROR = "GENSYNC_OPTIONS_ERROR";
const $641452fd47dff0cf$var$GENSYNC_RACE_NONEMPTY = "GENSYNC_RACE_NONEMPTY";
const $641452fd47dff0cf$var$GENSYNC_ERRBACK_NO_CALLBACK = "GENSYNC_ERRBACK_NO_CALLBACK";
module.exports = Object.assign(function gensync(optsOrFn) {
    let genFn = optsOrFn;
    if (typeof optsOrFn !== "function") genFn = $641452fd47dff0cf$var$newGenerator(optsOrFn);
    else genFn = $641452fd47dff0cf$var$wrapGenerator(optsOrFn);
    return Object.assign(genFn, $641452fd47dff0cf$var$makeFunctionAPI(genFn));
}, {
    all: $641452fd47dff0cf$var$buildOperation({
        name: "all",
        arity: 1,
        sync: function(args) {
            const items = Array.from(args[0]);
            return items.map((item)=>$641452fd47dff0cf$var$evaluateSync(item));
        },
        async: function(args, resolve, reject) {
            const items = Array.from(args[0]);
            if (items.length === 0) {
                Promise.resolve().then(()=>resolve([]));
                return;
            }
            let count = 0;
            const results = items.map(()=>undefined);
            items.forEach((item, i)=>{
                $641452fd47dff0cf$var$evaluateAsync(item, (val)=>{
                    results[i] = val;
                    count += 1;
                    if (count === results.length) resolve(results);
                }, reject);
            });
        }
    }),
    race: $641452fd47dff0cf$var$buildOperation({
        name: "race",
        arity: 1,
        sync: function(args) {
            const items = Array.from(args[0]);
            if (items.length === 0) throw $641452fd47dff0cf$var$makeError("Must race at least 1 item", $641452fd47dff0cf$var$GENSYNC_RACE_NONEMPTY);
            return $641452fd47dff0cf$var$evaluateSync(items[0]);
        },
        async: function(args, resolve, reject) {
            const items = Array.from(args[0]);
            if (items.length === 0) throw $641452fd47dff0cf$var$makeError("Must race at least 1 item", $641452fd47dff0cf$var$GENSYNC_RACE_NONEMPTY);
            for (const item of items)$641452fd47dff0cf$var$evaluateAsync(item, resolve, reject);
        }
    })
});
/**
 * Given a generator function, return the standard API object that executes
 * the generator and calls the callbacks.
 */ function $641452fd47dff0cf$var$makeFunctionAPI(genFn) {
    const fns = {
        sync: function(...args) {
            return $641452fd47dff0cf$var$evaluateSync(genFn.apply(this, args));
        },
        async: function(...args) {
            return new Promise((resolve, reject)=>{
                $641452fd47dff0cf$var$evaluateAsync(genFn.apply(this, args), resolve, reject);
            });
        },
        errback: function(...args) {
            const cb = args.pop();
            if (typeof cb !== "function") throw $641452fd47dff0cf$var$makeError("Asynchronous function called without callback", $641452fd47dff0cf$var$GENSYNC_ERRBACK_NO_CALLBACK);
            let gen;
            try {
                gen = genFn.apply(this, args);
            } catch (err) {
                cb(err);
                return;
            }
            $641452fd47dff0cf$var$evaluateAsync(gen, (val)=>cb(undefined, val), (err)=>cb(err));
        }
    };
    return fns;
}
function $641452fd47dff0cf$var$assertTypeof(type, name, value, allowUndefined) {
    if (typeof value === type || allowUndefined && typeof value === "undefined") return;
    let msg;
    if (allowUndefined) msg = `Expected opts.${name} to be either a ${type}, or undefined.`;
    else msg = `Expected opts.${name} to be a ${type}.`;
    throw $641452fd47dff0cf$var$makeError(msg, $641452fd47dff0cf$var$GENSYNC_OPTIONS_ERROR);
}
function $641452fd47dff0cf$var$makeError(msg, code) {
    return Object.assign(new Error(msg), {
        code: code
    });
}
/**
 * Given an options object, return a new generator that dispatches the
 * correct handler based on sync or async execution.
 */ function $641452fd47dff0cf$var$newGenerator({ name: name, arity: arity, sync: sync, async: async, errback: errback }) {
    $641452fd47dff0cf$var$assertTypeof("string", "name", name, true);
    $641452fd47dff0cf$var$assertTypeof("number", "arity", arity, true);
    $641452fd47dff0cf$var$assertTypeof("function", "sync", sync);
    $641452fd47dff0cf$var$assertTypeof("function", "async", async, true);
    $641452fd47dff0cf$var$assertTypeof("function", "errback", errback, true);
    if (async && errback) throw $641452fd47dff0cf$var$makeError("Expected one of either opts.async or opts.errback, but got _both_.", $641452fd47dff0cf$var$GENSYNC_OPTIONS_ERROR);
    if (typeof name !== "string") {
        let fnName;
        if (errback && errback.name && errback.name !== "errback") fnName = errback.name;
        if (async && async.name && async.name !== "async") fnName = async.name.replace(/Async$/, "");
        if (sync && sync.name && sync.name !== "sync") fnName = sync.name.replace(/Sync$/, "");
        if (typeof fnName === "string") name = fnName;
    }
    if (typeof arity !== "number") arity = sync.length;
    return $641452fd47dff0cf$var$buildOperation({
        name: name,
        arity: arity,
        sync: function(args) {
            return sync.apply(this, args);
        },
        async: function(args, resolve, reject) {
            if (async) async.apply(this, args).then(resolve, reject);
            else if (errback) errback.call(this, ...args, (err, value)=>{
                if (err == null) resolve(value);
                else reject(err);
            });
            else resolve(sync.apply(this, args));
        }
    });
}
function $641452fd47dff0cf$var$wrapGenerator(genFn) {
    return $641452fd47dff0cf$var$setFunctionMetadata(genFn.name, genFn.length, function(...args) {
        return genFn.apply(this, args);
    });
}
function $641452fd47dff0cf$var$buildOperation({ name: name, arity: arity, sync: sync, async: async }) {
    return $641452fd47dff0cf$var$setFunctionMetadata(name, arity, function*(...args) {
        const resume = yield $641452fd47dff0cf$var$GENSYNC_START;
        if (!resume) {
            // Break the tail call to avoid a bug in V8 v6.X with --harmony enabled.
            const res = sync.call(this, args);
            return res;
        }
        let result;
        try {
            async.call(this, args, (value)=>{
                if (result) return;
                result = {
                    value: value
                };
                resume();
            }, (err)=>{
                if (result) return;
                result = {
                    err: err
                };
                resume();
            });
        } catch (err) {
            result = {
                err: err
            };
            resume();
        }
        // Suspend until the callbacks run. Will resume synchronously if the
        // callback was already called.
        yield $641452fd47dff0cf$var$GENSYNC_SUSPEND;
        if (result.hasOwnProperty("err")) throw result.err;
        return result.value;
    });
}
function $641452fd47dff0cf$var$evaluateSync(gen) {
    let value;
    while(!({ value: value } = gen.next()).done)$641452fd47dff0cf$var$assertStart(value, gen);
    return value;
}
function $641452fd47dff0cf$var$evaluateAsync(gen, resolve, reject) {
    (function step() {
        try {
            let value;
            while(!({ value: value } = gen.next()).done){
                $641452fd47dff0cf$var$assertStart(value, gen);
                // If this throws, it is considered to have broken the contract
                // established for async handlers. If these handlers are called
                // synchronously, it is also considered bad behavior.
                let sync = true;
                let didSyncResume = false;
                const out = gen.next(()=>{
                    if (sync) didSyncResume = true;
                    else step();
                });
                sync = false;
                $641452fd47dff0cf$var$assertSuspend(out, gen);
                if (!didSyncResume) // Callback wasn't called synchronously, so break out of the loop
                // and let it call 'step' later.
                return;
            }
            return resolve(value);
        } catch (err) {
            return reject(err);
        }
    })();
}
function $641452fd47dff0cf$var$assertStart(value, gen) {
    if (value === $641452fd47dff0cf$var$GENSYNC_START) return;
    $641452fd47dff0cf$var$throwError(gen, $641452fd47dff0cf$var$makeError(`Got unexpected yielded value in gensync generator: ${JSON.stringify(value)}. Did you perhaps mean to use 'yield*' instead of 'yield'?`, $641452fd47dff0cf$var$GENSYNC_EXPECTED_START));
}
function $641452fd47dff0cf$var$assertSuspend({ value: value, done: done }, gen) {
    if (!done && value === $641452fd47dff0cf$var$GENSYNC_SUSPEND) return;
    $641452fd47dff0cf$var$throwError(gen, $641452fd47dff0cf$var$makeError(done ? "Unexpected generator completion. If you get this, it is probably a gensync bug." : `Expected GENSYNC_SUSPEND, got ${JSON.stringify(value)}. If you get this, it is probably a gensync bug.`, $641452fd47dff0cf$var$GENSYNC_EXPECTED_SUSPEND));
}
function $641452fd47dff0cf$var$throwError(gen, err) {
    // Call `.throw` so that users can step in a debugger to easily see which
    // 'yield' passed an unexpected value. If the `.throw` call didn't throw
    // back to the generator, we explicitly do it to stop the error
    // from being swallowed by user code try/catches.
    if (gen.throw) gen.throw(err);
    throw err;
}
function $641452fd47dff0cf$var$isIterable(value) {
    return !!value && (typeof value === "object" || typeof value === "function") && !value[Symbol.iterator];
}
function $641452fd47dff0cf$var$setFunctionMetadata(name, arity, fn) {
    if (typeof name === "string") {
        // This should always work on the supported Node versions, but for the
        // sake of users that are compiling to older versions, we check for
        // configurability so we don't throw.
        const nameDesc = Object.getOwnPropertyDescriptor(fn, "name");
        if (!nameDesc || nameDesc.configurable) Object.defineProperty(fn, "name", Object.assign(nameDesc || {}, {
            configurable: true,
            value: name
        }));
    }
    if (typeof arity === "number") {
        const lengthDesc = Object.getOwnPropertyDescriptor(fn, "length");
        if (!lengthDesc || lengthDesc.configurable) Object.defineProperty(fn, "length", Object.assign(lengthDesc || {}, {
            configurable: true,
            value: arity
        }));
    }
    return fn;
}

});

parcelRegister("2dkOY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

function $19ccf254ab87d22d$var$_gensync() {
    const data = (parcelRequire("8AIEE"));
    $19ccf254ab87d22d$var$_gensync = function() {
        return data;
    };
    return data;
}

var $29V6P = parcelRequire("29V6P");

var $6b1E4 = parcelRequire("6b1E4");

var $7Ockm = parcelRequire("7Ockm");

var $ln7QF = parcelRequire("ln7QF");

var $ajpbS = parcelRequire("ajpbS");

var $hGEb1 = parcelRequire("hGEb1");

var $z3rWa = parcelRequire("z3rWa");

function $19ccf254ab87d22d$var$_traverse() {
    const data = (parcelRequire("aHxeO"));
    $19ccf254ab87d22d$var$_traverse = function() {
        return data;
    };
    return data;
}

var $jaXHj = parcelRequire("jaXHj");

var $kF3s2 = parcelRequire("kF3s2");

var $6VYDs = parcelRequire("6VYDs");

var $chlis = parcelRequire("chlis");

var $77Tks = parcelRequire("77Tks");

var $jHKkq = parcelRequire("jHKkq");
var $19ccf254ab87d22d$var$_default = module.exports.default = $19ccf254ab87d22d$var$_gensync()(function* loadFullConfig(inputOpts) {
    var _opts$assumptions;
    const result = yield* (0, $77Tks.default)(inputOpts);
    if (!result) return null;
    const { options: options, context: context, fileHandling: fileHandling } = result;
    if (fileHandling === "ignored") return null;
    const optionDefaults = {};
    const { plugins: plugins, presets: presets } = options;
    if (!plugins || !presets) throw new Error("Assertion failure - plugins and presets exist");
    const presetContext = Object.assign({}, context, {
        targets: options.targets
    });
    const toDescriptor = (item)=>{
        const desc = (0, $ajpbS.getItemDescriptor)(item);
        if (!desc) throw new Error("Assertion failure - must be config item");
        return desc;
    };
    const presetsDescriptors = presets.map(toDescriptor);
    const initialPluginsDescriptors = plugins.map(toDescriptor);
    const pluginDescriptorsByPass = [
        []
    ];
    const passes = [];
    const externalDependencies = [];
    const ignored = yield* $19ccf254ab87d22d$var$enhanceError(context, function* recursePresetDescriptors(rawPresets, pluginDescriptorsPass) {
        const presets = [];
        for(let i = 0; i < rawPresets.length; i++){
            const descriptor = rawPresets[i];
            if (descriptor.options !== false) {
                try {
                    var preset = yield* $19ccf254ab87d22d$var$loadPresetDescriptor(descriptor, presetContext);
                } catch (e) {
                    if (e.code === "BABEL_UNKNOWN_OPTION") (0, $kF3s2.checkNoUnwrappedItemOptionPairs)(rawPresets, i, "preset", e);
                    throw e;
                }
                externalDependencies.push(preset.externalDependencies);
                if (descriptor.ownPass) presets.push({
                    preset: preset.chain,
                    pass: []
                });
                else presets.unshift({
                    preset: preset.chain,
                    pass: pluginDescriptorsPass
                });
            }
        }
        if (presets.length > 0) {
            pluginDescriptorsByPass.splice(1, 0, ...presets.map((o)=>o.pass).filter((p)=>p !== pluginDescriptorsPass));
            for (const { preset: preset, pass: pass } of presets){
                if (!preset) return true;
                pass.push(...preset.plugins);
                const ignored = yield* recursePresetDescriptors(preset.presets, pass);
                if (ignored) return true;
                preset.options.forEach((opts)=>{
                    (0, $6b1E4.mergeOptions)(optionDefaults, opts);
                });
            }
        }
    })(presetsDescriptors, pluginDescriptorsByPass[0]);
    if (ignored) return null;
    const opts = optionDefaults;
    (0, $6b1E4.mergeOptions)(opts, options);
    const pluginContext = Object.assign({}, presetContext, {
        assumptions: (_opts$assumptions = opts.assumptions) != null ? _opts$assumptions : {}
    });
    yield* $19ccf254ab87d22d$var$enhanceError(context, function* loadPluginDescriptors() {
        pluginDescriptorsByPass[0].unshift(...initialPluginsDescriptors);
        for (const descs of pluginDescriptorsByPass){
            const pass = [];
            passes.push(pass);
            for(let i = 0; i < descs.length; i++){
                const descriptor = descs[i];
                if (descriptor.options !== false) {
                    try {
                        var plugin = yield* $19ccf254ab87d22d$var$loadPluginDescriptor(descriptor, pluginContext);
                    } catch (e) {
                        if (e.code === "BABEL_UNKNOWN_PLUGIN_PROPERTY") (0, $kF3s2.checkNoUnwrappedItemOptionPairs)(descs, i, "plugin", e);
                        throw e;
                    }
                    pass.push(plugin);
                    externalDependencies.push(plugin.externalDependencies);
                }
            }
        }
    })();
    opts.plugins = passes[0];
    opts.presets = passes.slice(1).filter((plugins)=>plugins.length > 0).map((plugins)=>({
            plugins: plugins
        }));
    opts.passPerPreset = opts.presets.length > 0;
    return {
        options: opts,
        passes: passes,
        externalDependencies: (0, $z3rWa.finalize)(externalDependencies)
    };
});
function $19ccf254ab87d22d$var$enhanceError(context, fn) {
    return function*(arg1, arg2) {
        try {
            return yield* fn(arg1, arg2);
        } catch (e) {
            if (!/^\[BABEL\]/.test(e.message)) {
                var _context$filename;
                e.message = `[BABEL] ${(_context$filename = context.filename) != null ? _context$filename : "unknown file"}: ${e.message}`;
            }
            throw e;
        }
    };
}
const $19ccf254ab87d22d$var$makeDescriptorLoader = (apiFactory)=>(0, $jaXHj.makeWeakCache)(function*({ value: value, options: options, dirname: dirname, alias: alias }, cache) {
        if (options === false) throw new Error("Assertion failure");
        options = options || {};
        const externalDependencies = [];
        let item = value;
        if (typeof value === "function") {
            const factory = (0, $29V6P.maybeAsync)(value, `You appear to be using an async plugin/preset, but Babel has been called synchronously`);
            const api = Object.assign({}, $7Ockm, apiFactory(cache, externalDependencies));
            try {
                item = yield* factory(api, options, dirname);
            } catch (e) {
                if (alias) e.message += ` (While processing: ${JSON.stringify(alias)})`;
                throw e;
            }
        }
        if (!item || typeof item !== "object") throw new Error("Plugin/Preset did not return an object.");
        if ((0, $29V6P.isThenable)(item)) {
            yield* [];
            throw new Error(`You appear to be using a promise as a plugin, ` + `which your current version of Babel does not support. ` + `If you're using a published plugin, ` + `you may need to upgrade your @babel/core version. ` + `As an alternative, you can prefix the promise with "await". ` + `(While processing: ${JSON.stringify(alias)})`);
        }
        if (externalDependencies.length > 0 && (!cache.configured() || cache.mode() === "forever")) {
            let error = `A plugin/preset has external untracked dependencies ` + `(${externalDependencies[0]}), but the cache `;
            if (!cache.configured()) error += `has not been configured to be invalidated when the external dependencies change. `;
            else error += ` has been configured to never be invalidated. `;
            error += `Plugins/presets should configure their cache to be invalidated when the external ` + `dependencies change, for example using \`api.cache.invalidate(() => ` + `statSync(filepath).mtimeMs)\` or \`api.cache.never()\`\n` + `(While processing: ${JSON.stringify(alias)})`;
            throw new Error(error);
        }
        return {
            value: item,
            options: options,
            dirname: dirname,
            alias: alias,
            externalDependencies: (0, $z3rWa.finalize)(externalDependencies)
        };
    });
const $19ccf254ab87d22d$var$pluginDescriptorLoader = $19ccf254ab87d22d$var$makeDescriptorLoader($chlis.makePluginAPI);
const $19ccf254ab87d22d$var$presetDescriptorLoader = $19ccf254ab87d22d$var$makeDescriptorLoader($chlis.makePresetAPI);
const $19ccf254ab87d22d$var$instantiatePlugin = (0, $jaXHj.makeWeakCache)(function*({ value: value, options: options, dirname: dirname, alias: alias, externalDependencies: externalDependencies }, cache) {
    const pluginObj = (0, $6VYDs.validatePluginObject)(value);
    const plugin = Object.assign({}, pluginObj);
    if (plugin.visitor) plugin.visitor = $19ccf254ab87d22d$var$_traverse().default.explode(Object.assign({}, plugin.visitor));
    if (plugin.inherits) {
        const inheritsDescriptor = {
            name: undefined,
            alias: `${alias}$inherits`,
            value: plugin.inherits,
            options: options,
            dirname: dirname
        };
        const inherits = yield* (0, $29V6P.forwardAsync)($19ccf254ab87d22d$var$loadPluginDescriptor, (run)=>{
            return cache.invalidate((data)=>run(inheritsDescriptor, data));
        });
        plugin.pre = $19ccf254ab87d22d$var$chain(inherits.pre, plugin.pre);
        plugin.post = $19ccf254ab87d22d$var$chain(inherits.post, plugin.post);
        plugin.manipulateOptions = $19ccf254ab87d22d$var$chain(inherits.manipulateOptions, plugin.manipulateOptions);
        plugin.visitor = $19ccf254ab87d22d$var$_traverse().default.visitors.merge([
            inherits.visitor || {},
            plugin.visitor || {}
        ]);
        if (inherits.externalDependencies.length > 0) {
            if (externalDependencies.length === 0) externalDependencies = inherits.externalDependencies;
            else externalDependencies = (0, $z3rWa.finalize)([
                externalDependencies,
                inherits.externalDependencies
            ]);
        }
    }
    return new $ln7QF.default(plugin, options, alias, externalDependencies);
});
function* $19ccf254ab87d22d$var$loadPluginDescriptor(descriptor, context) {
    if (descriptor.value instanceof $ln7QF.default) {
        if (descriptor.options) throw new Error("Passed options to an existing Plugin instance will not work.");
        return descriptor.value;
    }
    return yield* $19ccf254ab87d22d$var$instantiatePlugin((yield* $19ccf254ab87d22d$var$pluginDescriptorLoader(descriptor, context)), context);
}
const $19ccf254ab87d22d$var$needsFilename = (val)=>val && typeof val !== "function";
const $19ccf254ab87d22d$var$validateIfOptionNeedsFilename = (options, descriptor)=>{
    if ($19ccf254ab87d22d$var$needsFilename(options.test) || $19ccf254ab87d22d$var$needsFilename(options.include) || $19ccf254ab87d22d$var$needsFilename(options.exclude)) {
        const formattedPresetName = descriptor.name ? `"${descriptor.name}"` : "/* your preset */";
        throw new $jHKkq.default([
            `Preset ${formattedPresetName} requires a filename to be set when babel is called directly,`,
            `\`\`\``,
            `babel.transformSync(code, { filename: 'file.ts', presets: [${formattedPresetName}] });`,
            `\`\`\``,
            `See https://babeljs.io/docs/en/options#filename for more information.`
        ].join("\n"));
    }
};
const $19ccf254ab87d22d$var$validatePreset = (preset, context, descriptor)=>{
    if (!context.filename) {
        var _options$overrides;
        const { options: options } = preset;
        $19ccf254ab87d22d$var$validateIfOptionNeedsFilename(options, descriptor);
        (_options$overrides = options.overrides) == null || _options$overrides.forEach((overrideOptions)=>$19ccf254ab87d22d$var$validateIfOptionNeedsFilename(overrideOptions, descriptor));
    }
};
const $19ccf254ab87d22d$var$instantiatePreset = (0, $jaXHj.makeWeakCacheSync)(({ value: value, dirname: dirname, alias: alias, externalDependencies: externalDependencies })=>{
    return {
        options: (0, $kF3s2.validate)("preset", value),
        alias: alias,
        dirname: dirname,
        externalDependencies: externalDependencies
    };
});
function* $19ccf254ab87d22d$var$loadPresetDescriptor(descriptor, context) {
    const preset = $19ccf254ab87d22d$var$instantiatePreset((yield* $19ccf254ab87d22d$var$presetDescriptorLoader(descriptor, context)));
    $19ccf254ab87d22d$var$validatePreset(preset, context, descriptor);
    return {
        chain: yield* (0, $hGEb1.buildPresetChain)(preset, context),
        externalDependencies: preset.externalDependencies
    };
}
function $19ccf254ab87d22d$var$chain(a, b) {
    const fns = [
        a,
        b
    ].filter(Boolean);
    if (fns.length <= 1) return fns[0];
    return function(...args) {
        for (const fn of fns)fn.apply(this, args);
    };
}

});
parcelRegister("29V6P", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.forwardAsync = $1928b8be6e9f771f$var$forwardAsync;
module.exports.isAsync = void 0;
module.exports.isThenable = $1928b8be6e9f771f$var$isThenable;
module.exports.maybeAsync = $1928b8be6e9f771f$var$maybeAsync;
module.exports.waitFor = module.exports.onFirstPause = void 0;

function $1928b8be6e9f771f$var$_gensync() {
    const data = (parcelRequire("8AIEE"));
    $1928b8be6e9f771f$var$_gensync = function() {
        return data;
    };
    return data;
}
function $1928b8be6e9f771f$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $1928b8be6e9f771f$var$_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $1928b8be6e9f771f$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $1928b8be6e9f771f$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
const $1928b8be6e9f771f$var$runGenerator = $1928b8be6e9f771f$var$_gensync()(function*(item) {
    return yield* item;
});
const $1928b8be6e9f771f$var$isAsync = module.exports.isAsync = $1928b8be6e9f771f$var$_gensync()({
    sync: ()=>false,
    errback: (cb)=>cb(null, true)
});
function $1928b8be6e9f771f$var$maybeAsync(fn, message) {
    return $1928b8be6e9f771f$var$_gensync()({
        sync (...args) {
            const result = fn.apply(this, args);
            if ($1928b8be6e9f771f$var$isThenable(result)) throw new Error(message);
            return result;
        },
        async (...args) {
            return Promise.resolve(fn.apply(this, args));
        }
    });
}
const $1928b8be6e9f771f$var$withKind = $1928b8be6e9f771f$var$_gensync()({
    sync: (cb)=>cb("sync"),
    async: function() {
        var _ref = $1928b8be6e9f771f$var$_asyncToGenerator(function*(cb) {
            return cb("async");
        });
        return function async(_x) {
            return _ref.apply(this, arguments);
        };
    }()
});
function $1928b8be6e9f771f$var$forwardAsync(action, cb) {
    const g = $1928b8be6e9f771f$var$_gensync()(action);
    return $1928b8be6e9f771f$var$withKind((kind)=>{
        const adapted = g[kind];
        return cb(adapted);
    });
}
const $1928b8be6e9f771f$var$onFirstPause = module.exports.onFirstPause = $1928b8be6e9f771f$var$_gensync()({
    name: "onFirstPause",
    arity: 2,
    sync: function(item) {
        return $1928b8be6e9f771f$var$runGenerator.sync(item);
    },
    errback: function(item, firstPause, cb) {
        let completed = false;
        $1928b8be6e9f771f$var$runGenerator.errback(item, (err, value)=>{
            completed = true;
            cb(err, value);
        });
        if (!completed) firstPause();
    }
});
const $1928b8be6e9f771f$var$waitFor = module.exports.waitFor = $1928b8be6e9f771f$var$_gensync()({
    sync: (x)=>x,
    async: function() {
        var _ref2 = $1928b8be6e9f771f$var$_asyncToGenerator(function*(x) {
            return x;
        });
        return function async(_x2) {
            return _ref2.apply(this, arguments);
        };
    }()
});
function $1928b8be6e9f771f$var$isThenable(val) {
    return !!val && (typeof val === "object" || typeof val === "function") && !!val.then && typeof val.then === "function";
}

});

parcelRegister("6b1E4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isIterableIterator = $47f50be6942b0412$var$isIterableIterator;
module.exports.mergeOptions = $47f50be6942b0412$var$mergeOptions;
function $47f50be6942b0412$var$mergeOptions(target, source) {
    for (const k of Object.keys(source))if ((k === "parserOpts" || k === "generatorOpts" || k === "assumptions") && source[k]) {
        const parserOpts = source[k];
        const targetObj = target[k] || (target[k] = {});
        $47f50be6942b0412$var$mergeDefaultFields(targetObj, parserOpts);
    } else {
        const val = source[k];
        if (val !== undefined) target[k] = val;
    }
}
function $47f50be6942b0412$var$mergeDefaultFields(target, source) {
    for (const k of Object.keys(source)){
        const val = source[k];
        if (val !== undefined) target[k] = val;
    }
}
function $47f50be6942b0412$var$isIterableIterator(value) {
    return !!value && typeof value.next === "function" && typeof value[Symbol.iterator] === "function";
}

});

parcelRegister("ln7QF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $z3rWa = parcelRequire("z3rWa");
class $f8f1d5800c410092$var$Plugin {
    constructor(plugin, options, key, externalDependencies = (0, $z3rWa.finalize)([])){
        this.key = void 0;
        this.manipulateOptions = void 0;
        this.post = void 0;
        this.pre = void 0;
        this.visitor = void 0;
        this.parserOverride = void 0;
        this.generatorOverride = void 0;
        this.options = void 0;
        this.externalDependencies = void 0;
        this.key = plugin.name || key;
        this.manipulateOptions = plugin.manipulateOptions;
        this.post = plugin.post;
        this.pre = plugin.pre;
        this.visitor = plugin.visitor || {};
        this.parserOverride = plugin.parserOverride;
        this.generatorOverride = plugin.generatorOverride;
        this.options = options;
        this.externalDependencies = externalDependencies;
    }
}
module.exports.default = $f8f1d5800c410092$var$Plugin;

});
parcelRegister("z3rWa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.finalize = $0695f2049d6a95a2$var$finalize;
module.exports.flattenToSet = $0695f2049d6a95a2$var$flattenToSet;
function $0695f2049d6a95a2$var$finalize(deepArr) {
    return Object.freeze(deepArr);
}
function $0695f2049d6a95a2$var$flattenToSet(arr) {
    const result = new Set();
    const stack = [
        arr
    ];
    while(stack.length > 0){
        for (const el of stack.pop())if (Array.isArray(el)) stack.push(el);
        else result.add(el);
    }
    return result;
}

});


parcelRegister("ajpbS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createConfigItem = $781f3807c1271c8b$var$createConfigItem;
module.exports.createItemFromDescriptor = $781f3807c1271c8b$var$createItemFromDescriptor;
module.exports.getItemDescriptor = $781f3807c1271c8b$var$getItemDescriptor;

function $781f3807c1271c8b$var$_path() {
    const data = (parcelRequire("59kwG"));
    $781f3807c1271c8b$var$_path = function() {
        return data;
    };
    return data;
}

var $b7pIp = parcelRequire("b7pIp");
function $781f3807c1271c8b$var$createItemFromDescriptor(desc) {
    return new $781f3807c1271c8b$var$ConfigItem(desc);
}
function* $781f3807c1271c8b$var$createConfigItem(value, { dirname: dirname = ".", type: type } = {}) {
    const descriptor = yield* (0, $b7pIp.createDescriptor)(value, $781f3807c1271c8b$var$_path().resolve(dirname), {
        type: type,
        alias: "programmatic item"
    });
    return $781f3807c1271c8b$var$createItemFromDescriptor(descriptor);
}
const $781f3807c1271c8b$var$CONFIG_ITEM_BRAND = Symbol.for("@babel/core@7 - ConfigItem");
function $781f3807c1271c8b$var$getItemDescriptor(item) {
    if (item != null && item[$781f3807c1271c8b$var$CONFIG_ITEM_BRAND]) return item._descriptor;
    return undefined;
}
class $781f3807c1271c8b$var$ConfigItem {
    constructor(descriptor){
        this._descriptor = void 0;
        this[$781f3807c1271c8b$var$CONFIG_ITEM_BRAND] = true;
        this.value = void 0;
        this.options = void 0;
        this.dirname = void 0;
        this.name = void 0;
        this.file = void 0;
        this._descriptor = descriptor;
        Object.defineProperty(this, "_descriptor", {
            enumerable: false
        });
        Object.defineProperty(this, $781f3807c1271c8b$var$CONFIG_ITEM_BRAND, {
            enumerable: false
        });
        this.value = this._descriptor.value;
        this.options = this._descriptor.options;
        this.dirname = this._descriptor.dirname;
        this.name = this._descriptor.name;
        this.file = this._descriptor.file ? {
            request: this._descriptor.file.request,
            resolved: this._descriptor.file.resolved
        } : undefined;
        Object.freeze(this);
    }
}
Object.freeze($781f3807c1271c8b$var$ConfigItem.prototype);

});
parcelRegister("59kwG", function(module, exports) {
// 'path' module extracted from Node.js v8.11.1 (only the posix part)
// transplited with Babel
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $hPtJY = parcelRequire("hPtJY");
"use strict";
function $3bfdb7183e8721d6$var$assertPath(path) {
    if (typeof path !== "string") throw new TypeError("Path must be a string. Received " + JSON.stringify(path));
}
// Resolves . and .. elements in a path with directory names
function $3bfdb7183e8721d6$var$normalizeStringPosix(path, allowAboveRoot) {
    var res = "";
    var lastSegmentLength = 0;
    var lastSlash = -1;
    var dots = 0;
    var code;
    for(var i = 0; i <= path.length; ++i){
        if (i < path.length) code = path.charCodeAt(i);
        else if (code === 47 /*/*/ ) break;
        else code = 47 /*/*/ ;
        if (code === 47 /*/*/ ) {
            if (lastSlash === i - 1 || dots === 1) ;
            else if (lastSlash !== i - 1 && dots === 2) {
                if (res.length < 2 || lastSegmentLength !== 2 || res.charCodeAt(res.length - 1) !== 46 /*.*/  || res.charCodeAt(res.length - 2) !== 46 /*.*/ ) {
                    if (res.length > 2) {
                        var lastSlashIndex = res.lastIndexOf("/");
                        if (lastSlashIndex !== res.length - 1) {
                            if (lastSlashIndex === -1) {
                                res = "";
                                lastSegmentLength = 0;
                            } else {
                                res = res.slice(0, lastSlashIndex);
                                lastSegmentLength = res.length - 1 - res.lastIndexOf("/");
                            }
                            lastSlash = i;
                            dots = 0;
                            continue;
                        }
                    } else if (res.length === 2 || res.length === 1) {
                        res = "";
                        lastSegmentLength = 0;
                        lastSlash = i;
                        dots = 0;
                        continue;
                    }
                }
                if (allowAboveRoot) {
                    if (res.length > 0) res += "/..";
                    else res = "..";
                    lastSegmentLength = 2;
                }
            } else {
                if (res.length > 0) res += "/" + path.slice(lastSlash + 1, i);
                else res = path.slice(lastSlash + 1, i);
                lastSegmentLength = i - lastSlash - 1;
            }
            lastSlash = i;
            dots = 0;
        } else if (code === 46 /*.*/  && dots !== -1) ++dots;
        else dots = -1;
    }
    return res;
}
function $3bfdb7183e8721d6$var$_format(sep, pathObject) {
    var dir = pathObject.dir || pathObject.root;
    var base = pathObject.base || (pathObject.name || "") + (pathObject.ext || "");
    if (!dir) return base;
    if (dir === pathObject.root) return dir + base;
    return dir + sep + base;
}
var $3bfdb7183e8721d6$var$posix = {
    // path.resolve([from ...], to)
    resolve: function resolve() {
        var resolvedPath = "";
        var resolvedAbsolute = false;
        var cwd;
        for(var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--){
            var path;
            if (i >= 0) path = arguments[i];
            else {
                if (cwd === undefined) cwd = $hPtJY.cwd();
                path = cwd;
            }
            $3bfdb7183e8721d6$var$assertPath(path);
            // Skip empty entries
            if (path.length === 0) continue;
            resolvedPath = path + "/" + resolvedPath;
            resolvedAbsolute = path.charCodeAt(0) === 47 /*/*/ ;
        }
        // At this point the path should be resolved to a full absolute path, but
        // handle relative paths to be safe (might happen when process.cwd() fails)
        // Normalize the path
        resolvedPath = $3bfdb7183e8721d6$var$normalizeStringPosix(resolvedPath, !resolvedAbsolute);
        if (resolvedAbsolute) {
            if (resolvedPath.length > 0) return "/" + resolvedPath;
            else return "/";
        } else if (resolvedPath.length > 0) return resolvedPath;
        else return ".";
    },
    normalize: function normalize(path) {
        $3bfdb7183e8721d6$var$assertPath(path);
        if (path.length === 0) return ".";
        var isAbsolute = path.charCodeAt(0) === 47 /*/*/ ;
        var trailingSeparator = path.charCodeAt(path.length - 1) === 47 /*/*/ ;
        // Normalize the path
        path = $3bfdb7183e8721d6$var$normalizeStringPosix(path, !isAbsolute);
        if (path.length === 0 && !isAbsolute) path = ".";
        if (path.length > 0 && trailingSeparator) path += "/";
        if (isAbsolute) return "/" + path;
        return path;
    },
    isAbsolute: function isAbsolute(path) {
        $3bfdb7183e8721d6$var$assertPath(path);
        return path.length > 0 && path.charCodeAt(0) === 47 /*/*/ ;
    },
    join: function join() {
        if (arguments.length === 0) return ".";
        var joined;
        for(var i = 0; i < arguments.length; ++i){
            var arg = arguments[i];
            $3bfdb7183e8721d6$var$assertPath(arg);
            if (arg.length > 0) {
                if (joined === undefined) joined = arg;
                else joined += "/" + arg;
            }
        }
        if (joined === undefined) return ".";
        return $3bfdb7183e8721d6$var$posix.normalize(joined);
    },
    relative: function relative(from, to) {
        $3bfdb7183e8721d6$var$assertPath(from);
        $3bfdb7183e8721d6$var$assertPath(to);
        if (from === to) return "";
        from = $3bfdb7183e8721d6$var$posix.resolve(from);
        to = $3bfdb7183e8721d6$var$posix.resolve(to);
        if (from === to) return "";
        // Trim any leading backslashes
        var fromStart = 1;
        for(; fromStart < from.length; ++fromStart){
            if (from.charCodeAt(fromStart) !== 47 /*/*/ ) break;
        }
        var fromEnd = from.length;
        var fromLen = fromEnd - fromStart;
        // Trim any leading backslashes
        var toStart = 1;
        for(; toStart < to.length; ++toStart){
            if (to.charCodeAt(toStart) !== 47 /*/*/ ) break;
        }
        var toEnd = to.length;
        var toLen = toEnd - toStart;
        // Compare paths to find the longest common path from root
        var length = fromLen < toLen ? fromLen : toLen;
        var lastCommonSep = -1;
        var i = 0;
        for(; i <= length; ++i){
            if (i === length) {
                if (toLen > length) {
                    if (to.charCodeAt(toStart + i) === 47 /*/*/ ) // We get here if `from` is the exact base path for `to`.
                    // For example: from='/foo/bar'; to='/foo/bar/baz'
                    return to.slice(toStart + i + 1);
                    else if (i === 0) // We get here if `from` is the root
                    // For example: from='/'; to='/foo'
                    return to.slice(toStart + i);
                } else if (fromLen > length) {
                    if (from.charCodeAt(fromStart + i) === 47 /*/*/ ) // We get here if `to` is the exact base path for `from`.
                    // For example: from='/foo/bar/baz'; to='/foo/bar'
                    lastCommonSep = i;
                    else if (i === 0) // We get here if `to` is the root.
                    // For example: from='/foo'; to='/'
                    lastCommonSep = 0;
                }
                break;
            }
            var fromCode = from.charCodeAt(fromStart + i);
            var toCode = to.charCodeAt(toStart + i);
            if (fromCode !== toCode) break;
            else if (fromCode === 47 /*/*/ ) lastCommonSep = i;
        }
        var out = "";
        // Generate the relative path based on the path difference between `to`
        // and `from`
        for(i = fromStart + lastCommonSep + 1; i <= fromEnd; ++i)if (i === fromEnd || from.charCodeAt(i) === 47 /*/*/ ) {
            if (out.length === 0) out += "..";
            else out += "/..";
        }
        // Lastly, append the rest of the destination (`to`) path that comes after
        // the common path parts
        if (out.length > 0) return out + to.slice(toStart + lastCommonSep);
        else {
            toStart += lastCommonSep;
            if (to.charCodeAt(toStart) === 47 /*/*/ ) ++toStart;
            return to.slice(toStart);
        }
    },
    _makeLong: function _makeLong(path) {
        return path;
    },
    dirname: function dirname(path) {
        $3bfdb7183e8721d6$var$assertPath(path);
        if (path.length === 0) return ".";
        var code = path.charCodeAt(0);
        var hasRoot = code === 47 /*/*/ ;
        var end = -1;
        var matchedSlash = true;
        for(var i = path.length - 1; i >= 1; --i){
            code = path.charCodeAt(i);
            if (code === 47 /*/*/ ) {
                if (!matchedSlash) {
                    end = i;
                    break;
                }
            } else // We saw the first non-path separator
            matchedSlash = false;
        }
        if (end === -1) return hasRoot ? "/" : ".";
        if (hasRoot && end === 1) return "//";
        return path.slice(0, end);
    },
    basename: function basename(path, ext) {
        if (ext !== undefined && typeof ext !== "string") throw new TypeError('"ext" argument must be a string');
        $3bfdb7183e8721d6$var$assertPath(path);
        var start = 0;
        var end = -1;
        var matchedSlash = true;
        var i;
        if (ext !== undefined && ext.length > 0 && ext.length <= path.length) {
            if (ext.length === path.length && ext === path) return "";
            var extIdx = ext.length - 1;
            var firstNonSlashEnd = -1;
            for(i = path.length - 1; i >= 0; --i){
                var code = path.charCodeAt(i);
                if (code === 47 /*/*/ ) // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                {
                    if (!matchedSlash) {
                        start = i + 1;
                        break;
                    }
                } else {
                    if (firstNonSlashEnd === -1) {
                        // We saw the first non-path separator, remember this index in case
                        // we need it if the extension ends up not matching
                        matchedSlash = false;
                        firstNonSlashEnd = i + 1;
                    }
                    if (extIdx >= 0) {
                        // Try to match the explicit extension
                        if (code === ext.charCodeAt(extIdx)) {
                            if (--extIdx === -1) // We matched the extension, so mark this as the end of our path
                            // component
                            end = i;
                        } else {
                            // Extension does not match, so our result is the entire path
                            // component
                            extIdx = -1;
                            end = firstNonSlashEnd;
                        }
                    }
                }
            }
            if (start === end) end = firstNonSlashEnd;
            else if (end === -1) end = path.length;
            return path.slice(start, end);
        } else {
            for(i = path.length - 1; i >= 0; --i){
                if (path.charCodeAt(i) === 47 /*/*/ ) // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                {
                    if (!matchedSlash) {
                        start = i + 1;
                        break;
                    }
                } else if (end === -1) {
                    // We saw the first non-path separator, mark this as the end of our
                    // path component
                    matchedSlash = false;
                    end = i + 1;
                }
            }
            if (end === -1) return "";
            return path.slice(start, end);
        }
    },
    extname: function extname(path) {
        $3bfdb7183e8721d6$var$assertPath(path);
        var startDot = -1;
        var startPart = 0;
        var end = -1;
        var matchedSlash = true;
        // Track the state of characters (if any) we see before our first dot and
        // after any path separator we find
        var preDotState = 0;
        for(var i = path.length - 1; i >= 0; --i){
            var code = path.charCodeAt(i);
            if (code === 47 /*/*/ ) {
                // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                if (!matchedSlash) {
                    startPart = i + 1;
                    break;
                }
                continue;
            }
            if (end === -1) {
                // We saw the first non-path separator, mark this as the end of our
                // extension
                matchedSlash = false;
                end = i + 1;
            }
            if (code === 46 /*.*/ ) {
                // If this is our first dot, mark it as the start of our extension
                if (startDot === -1) startDot = i;
                else if (preDotState !== 1) preDotState = 1;
            } else if (startDot !== -1) // We saw a non-dot and non-path separator before our dot, so we should
            // have a good chance at having a non-empty extension
            preDotState = -1;
        }
        if (startDot === -1 || end === -1 || // We saw a non-dot character immediately before the dot
        preDotState === 0 || // The (right-most) trimmed path component is exactly '..'
        preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) return "";
        return path.slice(startDot, end);
    },
    format: function format(pathObject) {
        if (pathObject === null || typeof pathObject !== "object") throw new TypeError('The "pathObject" argument must be of type Object. Received type ' + typeof pathObject);
        return $3bfdb7183e8721d6$var$_format("/", pathObject);
    },
    parse: function parse(path) {
        $3bfdb7183e8721d6$var$assertPath(path);
        var ret = {
            root: "",
            dir: "",
            base: "",
            ext: "",
            name: ""
        };
        if (path.length === 0) return ret;
        var code = path.charCodeAt(0);
        var isAbsolute = code === 47 /*/*/ ;
        var start;
        if (isAbsolute) {
            ret.root = "/";
            start = 1;
        } else start = 0;
        var startDot = -1;
        var startPart = 0;
        var end = -1;
        var matchedSlash = true;
        var i = path.length - 1;
        // Track the state of characters (if any) we see before our first dot and
        // after any path separator we find
        var preDotState = 0;
        // Get non-dir info
        for(; i >= start; --i){
            code = path.charCodeAt(i);
            if (code === 47 /*/*/ ) {
                // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                if (!matchedSlash) {
                    startPart = i + 1;
                    break;
                }
                continue;
            }
            if (end === -1) {
                // We saw the first non-path separator, mark this as the end of our
                // extension
                matchedSlash = false;
                end = i + 1;
            }
            if (code === 46 /*.*/ ) {
                // If this is our first dot, mark it as the start of our extension
                if (startDot === -1) startDot = i;
                else if (preDotState !== 1) preDotState = 1;
            } else if (startDot !== -1) // We saw a non-dot and non-path separator before our dot, so we should
            // have a good chance at having a non-empty extension
            preDotState = -1;
        }
        if (startDot === -1 || end === -1 || // We saw a non-dot character immediately before the dot
        preDotState === 0 || // The (right-most) trimmed path component is exactly '..'
        preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
            if (end !== -1) {
                if (startPart === 0 && isAbsolute) ret.base = ret.name = path.slice(1, end);
                else ret.base = ret.name = path.slice(startPart, end);
            }
        } else {
            if (startPart === 0 && isAbsolute) {
                ret.name = path.slice(1, startDot);
                ret.base = path.slice(1, end);
            } else {
                ret.name = path.slice(startPart, startDot);
                ret.base = path.slice(startPart, end);
            }
            ret.ext = path.slice(startDot, end);
        }
        if (startPart > 0) ret.dir = path.slice(0, startPart - 1);
        else if (isAbsolute) ret.dir = "/";
        return ret;
    },
    sep: "/",
    delimiter: ":",
    win32: null,
    posix: null
};
$3bfdb7183e8721d6$var$posix.posix = $3bfdb7183e8721d6$var$posix;
module.exports = $3bfdb7183e8721d6$var$posix;

});

parcelRegister("b7pIp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createCachedDescriptors = $81844bade436be20$var$createCachedDescriptors;
module.exports.createDescriptor = $81844bade436be20$var$createDescriptor;
module.exports.createUncachedDescriptors = $81844bade436be20$var$createUncachedDescriptors;

function $81844bade436be20$var$_gensync() {
    const data = (parcelRequire("8AIEE"));
    $81844bade436be20$var$_gensync = function() {
        return data;
    };
    return data;
}

var $j94gv = parcelRequire("j94gv");

var $4h8hI = parcelRequire("4h8hI");

var $ajpbS = parcelRequire("ajpbS");

var $jaXHj = parcelRequire("jaXHj");

var $5hYhO = parcelRequire("5hYhO");
function $81844bade436be20$var$isEqualDescriptor(a, b) {
    var _a$file, _b$file, _a$file2, _b$file2;
    return a.name === b.name && a.value === b.value && a.options === b.options && a.dirname === b.dirname && a.alias === b.alias && a.ownPass === b.ownPass && ((_a$file = a.file) == null ? void 0 : _a$file.request) === ((_b$file = b.file) == null ? void 0 : _b$file.request) && ((_a$file2 = a.file) == null ? void 0 : _a$file2.resolved) === ((_b$file2 = b.file) == null ? void 0 : _b$file2.resolved);
}
function* $81844bade436be20$var$handlerOf(value) {
    return value;
}
function $81844bade436be20$var$optionsWithResolvedBrowserslistConfigFile(options, dirname) {
    if (typeof options.browserslistConfigFile === "string") options.browserslistConfigFile = (0, $5hYhO.resolveBrowserslistConfigFile)(options.browserslistConfigFile, dirname);
    return options;
}
function $81844bade436be20$var$createCachedDescriptors(dirname, options, alias) {
    const { plugins: plugins, presets: presets, passPerPreset: passPerPreset } = options;
    return {
        options: $81844bade436be20$var$optionsWithResolvedBrowserslistConfigFile(options, dirname),
        plugins: plugins ? ()=>$81844bade436be20$var$createCachedPluginDescriptors(plugins, dirname)(alias) : ()=>$81844bade436be20$var$handlerOf([]),
        presets: presets ? ()=>$81844bade436be20$var$createCachedPresetDescriptors(presets, dirname)(alias)(!!passPerPreset) : ()=>$81844bade436be20$var$handlerOf([])
    };
}
function $81844bade436be20$var$createUncachedDescriptors(dirname, options, alias) {
    return {
        options: $81844bade436be20$var$optionsWithResolvedBrowserslistConfigFile(options, dirname),
        plugins: (0, $j94gv.once)(()=>$81844bade436be20$var$createPluginDescriptors(options.plugins || [], dirname, alias)),
        presets: (0, $j94gv.once)(()=>$81844bade436be20$var$createPresetDescriptors(options.presets || [], dirname, alias, !!options.passPerPreset))
    };
}
const $81844bade436be20$var$PRESET_DESCRIPTOR_CACHE = new WeakMap();
const $81844bade436be20$var$createCachedPresetDescriptors = (0, $jaXHj.makeWeakCacheSync)((items, cache)=>{
    const dirname = cache.using((dir)=>dir);
    return (0, $jaXHj.makeStrongCacheSync)((alias)=>(0, $jaXHj.makeStrongCache)(function*(passPerPreset) {
            const descriptors = yield* $81844bade436be20$var$createPresetDescriptors(items, dirname, alias, passPerPreset);
            return descriptors.map((desc)=>$81844bade436be20$var$loadCachedDescriptor($81844bade436be20$var$PRESET_DESCRIPTOR_CACHE, desc));
        }));
});
const $81844bade436be20$var$PLUGIN_DESCRIPTOR_CACHE = new WeakMap();
const $81844bade436be20$var$createCachedPluginDescriptors = (0, $jaXHj.makeWeakCacheSync)((items, cache)=>{
    const dirname = cache.using((dir)=>dir);
    return (0, $jaXHj.makeStrongCache)(function*(alias) {
        const descriptors = yield* $81844bade436be20$var$createPluginDescriptors(items, dirname, alias);
        return descriptors.map((desc)=>$81844bade436be20$var$loadCachedDescriptor($81844bade436be20$var$PLUGIN_DESCRIPTOR_CACHE, desc));
    });
});
const $81844bade436be20$var$DEFAULT_OPTIONS = {};
function $81844bade436be20$var$loadCachedDescriptor(cache, desc) {
    const { value: value, options: options = $81844bade436be20$var$DEFAULT_OPTIONS } = desc;
    if (options === false) return desc;
    let cacheByOptions = cache.get(value);
    if (!cacheByOptions) {
        cacheByOptions = new WeakMap();
        cache.set(value, cacheByOptions);
    }
    let possibilities = cacheByOptions.get(options);
    if (!possibilities) {
        possibilities = [];
        cacheByOptions.set(options, possibilities);
    }
    if (possibilities.indexOf(desc) === -1) {
        const matches = possibilities.filter((possibility)=>$81844bade436be20$var$isEqualDescriptor(possibility, desc));
        if (matches.length > 0) return matches[0];
        possibilities.push(desc);
    }
    return desc;
}
function* $81844bade436be20$var$createPresetDescriptors(items, dirname, alias, passPerPreset) {
    return yield* $81844bade436be20$var$createDescriptors("preset", items, dirname, alias, passPerPreset);
}
function* $81844bade436be20$var$createPluginDescriptors(items, dirname, alias) {
    return yield* $81844bade436be20$var$createDescriptors("plugin", items, dirname, alias);
}
function* $81844bade436be20$var$createDescriptors(type, items, dirname, alias, ownPass) {
    const descriptors = yield* $81844bade436be20$var$_gensync().all(items.map((item, index)=>$81844bade436be20$var$createDescriptor(item, dirname, {
            type: type,
            alias: `${alias}$${index}`,
            ownPass: !!ownPass
        })));
    $81844bade436be20$var$assertNoDuplicates(descriptors);
    return descriptors;
}
function* $81844bade436be20$var$createDescriptor(pair, dirname, { type: type, alias: alias, ownPass: ownPass }) {
    const desc = (0, $ajpbS.getItemDescriptor)(pair);
    if (desc) return desc;
    let name;
    let options;
    let value = pair;
    if (Array.isArray(value)) {
        if (value.length === 3) [value, options, name] = value;
        else [value, options] = value;
    }
    let file = undefined;
    let filepath = null;
    if (typeof value === "string") {
        if (typeof type !== "string") throw new Error("To resolve a string-based item, the type of item must be given");
        const resolver = type === "plugin" ? $4h8hI.loadPlugin : $4h8hI.loadPreset;
        const request = value;
        ({ filepath: filepath, value: value } = yield* resolver(value, dirname));
        file = {
            request: request,
            resolved: filepath
        };
    }
    if (!value) throw new Error(`Unexpected falsy value: ${String(value)}`);
    if (typeof value === "object" && value.__esModule) {
        if (value.default) value = value.default;
        else throw new Error("Must export a default export when using ES6 modules.");
    }
    if (typeof value !== "object" && typeof value !== "function") throw new Error(`Unsupported format: ${typeof value}. Expected an object or a function.`);
    if (filepath !== null && typeof value === "object" && value) throw new Error(`Plugin/Preset files are not allowed to export objects, only functions. In ${filepath}`);
    return {
        name: name,
        alias: filepath || alias,
        value: value,
        options: options,
        dirname: dirname,
        ownPass: ownPass,
        file: file
    };
}
function $81844bade436be20$var$assertNoDuplicates(items) {
    const map = new Map();
    for (const item of items){
        if (typeof item.value !== "function") continue;
        let nameMap = map.get(item.value);
        if (!nameMap) {
            nameMap = new Set();
            map.set(item.value, nameMap);
        }
        if (nameMap.has(item.name)) {
            const conflicts = items.filter((i)=>i.value === item.value);
            throw new Error([
                `Duplicate plugin/preset detected.`,
                `If you'd like to use two separate instances of a plugin,`,
                `they need separate names, e.g.`,
                ``,
                `  plugins: [`,
                `    ['some-plugin', {}],`,
                `    ['some-plugin', {}, 'some unique name'],`,
                `  ]`,
                ``,
                `Duplicates detected are:`,
                `${JSON.stringify(conflicts, null, 2)}`
            ].join("\n"));
        }
        nameMap.add(item.name);
    }
}

});
parcelRegister("j94gv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.once = $df022a8f86a0df3c$var$once;

var $29V6P = parcelRequire("29V6P");
function $df022a8f86a0df3c$var$once(fn) {
    let result;
    let resultP;
    let promiseReferenced = false;
    return function*() {
        if (!result) {
            if (resultP) {
                promiseReferenced = true;
                return yield* (0, $29V6P.waitFor)(resultP);
            }
            if (!(yield* (0, $29V6P.isAsync)())) try {
                result = {
                    ok: true,
                    value: yield* fn()
                };
            } catch (error) {
                result = {
                    ok: false,
                    value: error
                };
            }
            else {
                let resolve, reject;
                resultP = new Promise((res, rej)=>{
                    resolve = res;
                    reject = rej;
                });
                try {
                    result = {
                        ok: true,
                        value: yield* fn()
                    };
                    resultP = null;
                    if (promiseReferenced) resolve(result.value);
                } catch (error) {
                    result = {
                        ok: false,
                        value: error
                    };
                    resultP = null;
                    if (promiseReferenced) reject(error);
                }
            }
        }
        if (result.ok) return result.value;
        else throw result.value;
    };
}

});

parcelRegister("jaXHj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.assertSimpleType = $df5d4230fa49933a$var$assertSimpleType;
module.exports.makeStrongCache = $df5d4230fa49933a$var$makeStrongCache;
module.exports.makeStrongCacheSync = $df5d4230fa49933a$var$makeStrongCacheSync;
module.exports.makeWeakCache = $df5d4230fa49933a$var$makeWeakCache;
module.exports.makeWeakCacheSync = $df5d4230fa49933a$var$makeWeakCacheSync;

function $df5d4230fa49933a$var$_gensync() {
    const data = (parcelRequire("8AIEE"));
    $df5d4230fa49933a$var$_gensync = function() {
        return data;
    };
    return data;
}

var $29V6P = parcelRequire("29V6P");

var $6b1E4 = parcelRequire("6b1E4");
const $df5d4230fa49933a$var$synchronize = (gen)=>{
    return $df5d4230fa49933a$var$_gensync()(gen).sync;
};
function* $df5d4230fa49933a$var$genTrue() {
    return true;
}
function $df5d4230fa49933a$var$makeWeakCache(handler) {
    return $df5d4230fa49933a$var$makeCachedFunction(WeakMap, handler);
}
function $df5d4230fa49933a$var$makeWeakCacheSync(handler) {
    return $df5d4230fa49933a$var$synchronize($df5d4230fa49933a$var$makeWeakCache(handler));
}
function $df5d4230fa49933a$var$makeStrongCache(handler) {
    return $df5d4230fa49933a$var$makeCachedFunction(Map, handler);
}
function $df5d4230fa49933a$var$makeStrongCacheSync(handler) {
    return $df5d4230fa49933a$var$synchronize($df5d4230fa49933a$var$makeStrongCache(handler));
}
function $df5d4230fa49933a$var$makeCachedFunction(CallCache, handler) {
    const callCacheSync = new CallCache();
    const callCacheAsync = new CallCache();
    const futureCache = new CallCache();
    return function* cachedFunction(arg, data) {
        const asyncContext = yield* (0, $29V6P.isAsync)();
        const callCache = asyncContext ? callCacheAsync : callCacheSync;
        const cached = yield* $df5d4230fa49933a$var$getCachedValueOrWait(asyncContext, callCache, futureCache, arg, data);
        if (cached.valid) return cached.value;
        const cache = new $df5d4230fa49933a$var$CacheConfigurator(data);
        const handlerResult = handler(arg, cache);
        let finishLock;
        let value;
        if ((0, $6b1E4.isIterableIterator)(handlerResult)) value = yield* (0, $29V6P.onFirstPause)(handlerResult, ()=>{
            finishLock = $df5d4230fa49933a$var$setupAsyncLocks(cache, futureCache, arg);
        });
        else value = handlerResult;
        $df5d4230fa49933a$var$updateFunctionCache(callCache, cache, arg, value);
        if (finishLock) {
            futureCache.delete(arg);
            finishLock.release(value);
        }
        return value;
    };
}
function* $df5d4230fa49933a$var$getCachedValue(cache, arg, data) {
    const cachedValue = cache.get(arg);
    if (cachedValue) for (const { value: value, valid: valid } of cachedValue){
        if (yield* valid(data)) return {
            valid: true,
            value: value
        };
    }
    return {
        valid: false,
        value: null
    };
}
function* $df5d4230fa49933a$var$getCachedValueOrWait(asyncContext, callCache, futureCache, arg, data) {
    const cached = yield* $df5d4230fa49933a$var$getCachedValue(callCache, arg, data);
    if (cached.valid) return cached;
    if (asyncContext) {
        const cached = yield* $df5d4230fa49933a$var$getCachedValue(futureCache, arg, data);
        if (cached.valid) {
            const value = yield* (0, $29V6P.waitFor)(cached.value.promise);
            return {
                valid: true,
                value: value
            };
        }
    }
    return {
        valid: false,
        value: null
    };
}
function $df5d4230fa49933a$var$setupAsyncLocks(config, futureCache, arg) {
    const finishLock = new $df5d4230fa49933a$var$Lock();
    $df5d4230fa49933a$var$updateFunctionCache(futureCache, config, arg, finishLock);
    return finishLock;
}
function $df5d4230fa49933a$var$updateFunctionCache(cache, config, arg, value) {
    if (!config.configured()) config.forever();
    let cachedValue = cache.get(arg);
    config.deactivate();
    switch(config.mode()){
        case "forever":
            cachedValue = [
                {
                    value: value,
                    valid: $df5d4230fa49933a$var$genTrue
                }
            ];
            cache.set(arg, cachedValue);
            break;
        case "invalidate":
            cachedValue = [
                {
                    value: value,
                    valid: config.validator()
                }
            ];
            cache.set(arg, cachedValue);
            break;
        case "valid":
            if (cachedValue) cachedValue.push({
                value: value,
                valid: config.validator()
            });
            else {
                cachedValue = [
                    {
                        value: value,
                        valid: config.validator()
                    }
                ];
                cache.set(arg, cachedValue);
            }
    }
}
class $df5d4230fa49933a$var$CacheConfigurator {
    constructor(data){
        this._active = true;
        this._never = false;
        this._forever = false;
        this._invalidate = false;
        this._configured = false;
        this._pairs = [];
        this._data = void 0;
        this._data = data;
    }
    simple() {
        return $df5d4230fa49933a$var$makeSimpleConfigurator(this);
    }
    mode() {
        if (this._never) return "never";
        if (this._forever) return "forever";
        if (this._invalidate) return "invalidate";
        return "valid";
    }
    forever() {
        if (!this._active) throw new Error("Cannot change caching after evaluation has completed.");
        if (this._never) throw new Error("Caching has already been configured with .never()");
        this._forever = true;
        this._configured = true;
    }
    never() {
        if (!this._active) throw new Error("Cannot change caching after evaluation has completed.");
        if (this._forever) throw new Error("Caching has already been configured with .forever()");
        this._never = true;
        this._configured = true;
    }
    using(handler) {
        if (!this._active) throw new Error("Cannot change caching after evaluation has completed.");
        if (this._never || this._forever) throw new Error("Caching has already been configured with .never or .forever()");
        this._configured = true;
        const key = handler(this._data);
        const fn = (0, $29V6P.maybeAsync)(handler, `You appear to be using an async cache handler, but Babel has been called synchronously`);
        if ((0, $29V6P.isThenable)(key)) return key.then((key)=>{
            this._pairs.push([
                key,
                fn
            ]);
            return key;
        });
        this._pairs.push([
            key,
            fn
        ]);
        return key;
    }
    invalidate(handler) {
        this._invalidate = true;
        return this.using(handler);
    }
    validator() {
        const pairs = this._pairs;
        return function*(data) {
            for (const [key, fn] of pairs){
                if (key !== (yield* fn(data))) return false;
            }
            return true;
        };
    }
    deactivate() {
        this._active = false;
    }
    configured() {
        return this._configured;
    }
}
function $df5d4230fa49933a$var$makeSimpleConfigurator(cache) {
    function cacheFn(val) {
        if (typeof val === "boolean") {
            if (val) cache.forever();
            else cache.never();
            return;
        }
        return cache.using(()=>$df5d4230fa49933a$var$assertSimpleType(val()));
    }
    cacheFn.forever = ()=>cache.forever();
    cacheFn.never = ()=>cache.never();
    cacheFn.using = (cb)=>cache.using(()=>$df5d4230fa49933a$var$assertSimpleType(cb()));
    cacheFn.invalidate = (cb)=>cache.invalidate(()=>$df5d4230fa49933a$var$assertSimpleType(cb()));
    return cacheFn;
}
function $df5d4230fa49933a$var$assertSimpleType(value) {
    if ((0, $29V6P.isThenable)(value)) throw new Error(`You appear to be using an async cache handler, ` + `which your current version of Babel does not support. ` + `We may add support for this in the future, ` + `but if you're on the most recent version of @babel/core and still ` + `seeing this error, then you'll need to synchronously handle your caching logic.`);
    if (value != null && typeof value !== "string" && typeof value !== "boolean" && typeof value !== "number") throw new Error("Cache keys must be either string, boolean, number, null, or undefined.");
    return value;
}
class $df5d4230fa49933a$var$Lock {
    constructor(){
        this.released = false;
        this.promise = void 0;
        this._resolve = void 0;
        this.promise = new Promise((resolve)=>{
            this._resolve = resolve;
        });
    }
    release(value) {
        this.released = true;
        this._resolve(value);
    }
}

});

parcelRegister("5hYhO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.resolveBrowserslistConfigFile = $3d9d4dddca495383$var$resolveBrowserslistConfigFile;
module.exports.resolveTargets = $3d9d4dddca495383$var$resolveTargets;

function $3d9d4dddca495383$var$_helperCompilationTargets() {
    const data = (parcelRequire("4r0OE"));
    $3d9d4dddca495383$var$_helperCompilationTargets = function() {
        return data;
    };
    return data;
}
function $3d9d4dddca495383$var$resolveBrowserslistConfigFile(browserslistConfigFile, configFilePath) {
    return undefined;
}
function $3d9d4dddca495383$var$resolveTargets(options, root) {
    const optTargets = options.targets;
    let targets;
    if (typeof optTargets === "string" || Array.isArray(optTargets)) targets = {
        browsers: optTargets
    };
    else if (optTargets) {
        if ("esmodules" in optTargets) targets = Object.assign({}, optTargets, {
            esmodules: "intersect"
        });
        else targets = optTargets;
    }
    return (0, $3d9d4dddca495383$var$_helperCompilationTargets().default)(targets, {
        ignoreBrowserslistConfig: true,
        browserslistEnv: options.browserslistEnv
    });
}

});
parcelRegister("4r0OE", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "TargetNames", {
    enumerable: true,
    get: function() {
        return $i2vZx.TargetNames;
    }
});
module.exports.default = $33aa510cafc60962$var$getTargets;
Object.defineProperty(module.exports, "filterItems", {
    enumerable: true,
    get: function() {
        return $dyKy0.default;
    }
});
Object.defineProperty(module.exports, "getInclusionReasons", {
    enumerable: true,
    get: function() {
        return $7fH1M.getInclusionReasons;
    }
});
module.exports.isBrowsersQueryValid = $33aa510cafc60962$var$isBrowsersQueryValid;
Object.defineProperty(module.exports, "isRequired", {
    enumerable: true,
    get: function() {
        return $dyKy0.isRequired;
    }
});
Object.defineProperty(module.exports, "prettifyTargets", {
    enumerable: true,
    get: function() {
        return $ggwgA.prettifyTargets;
    }
});
Object.defineProperty(module.exports, "unreleasedLabels", {
    enumerable: true,
    get: function() {
        return $5ztZ6.unreleasedLabels;
    }
});

var $cjv3H = parcelRequire("cjv3H");

var $lRd6h = parcelRequire("lRd6h");

var $kCuqa = parcelRequire("kCuqa");

var $dFGFv = parcelRequire("dFGFv");

var $6s1of = parcelRequire("6s1of");

var $5ztZ6 = parcelRequire("5ztZ6");

var $i2vZx = parcelRequire("i2vZx");

var $ggwgA = parcelRequire("ggwgA");

var $7fH1M = parcelRequire("7fH1M");

var $dyKy0 = parcelRequire("dyKy0");
const $33aa510cafc60962$var$ESM_SUPPORT = $kCuqa["es6.module"];
const $33aa510cafc60962$var$v = new $lRd6h.OptionValidator("@babel/helper-compilation-targets");
function $33aa510cafc60962$var$validateTargetNames(targets) {
    const validTargets = Object.keys($i2vZx.TargetNames);
    for (const target of Object.keys(targets)){
        if (!(target in $i2vZx.TargetNames)) throw new Error($33aa510cafc60962$var$v.formatMessage(`'${target}' is not a valid target
- Did you mean '${(0, $lRd6h.findSuggestion)(target, validTargets)}'?`));
    }
    return targets;
}
function $33aa510cafc60962$var$isBrowsersQueryValid(browsers) {
    return typeof browsers === "string" || Array.isArray(browsers) && browsers.every((b)=>typeof b === "string");
}
function $33aa510cafc60962$var$validateBrowsers(browsers) {
    $33aa510cafc60962$var$v.invariant(browsers === undefined || $33aa510cafc60962$var$isBrowsersQueryValid(browsers), `'${String(browsers)}' is not a valid browserslist query`);
    return browsers;
}
function $33aa510cafc60962$var$getLowestVersions(browsers) {
    return browsers.reduce((all, browser)=>{
        const [browserName, browserVersion] = browser.split(" ");
        const target = $5ztZ6.browserNameMap[browserName];
        if (!target) return all;
        try {
            const splitVersion = browserVersion.split("-")[0].toLowerCase();
            const isSplitUnreleased = (0, $6s1of.isUnreleasedVersion)(splitVersion, target);
            if (!all[target]) {
                all[target] = isSplitUnreleased ? splitVersion : (0, $6s1of.semverify)(splitVersion);
                return all;
            }
            const version = all[target];
            const isUnreleased = (0, $6s1of.isUnreleasedVersion)(version, target);
            if (isUnreleased && isSplitUnreleased) all[target] = (0, $6s1of.getLowestUnreleased)(version, splitVersion, target);
            else if (isUnreleased) all[target] = (0, $6s1of.semverify)(splitVersion);
            else if (!isUnreleased && !isSplitUnreleased) {
                const parsedBrowserVersion = (0, $6s1of.semverify)(splitVersion);
                all[target] = (0, $6s1of.semverMin)(version, parsedBrowserVersion);
            }
        } catch (e) {}
        return all;
    }, {});
}
function $33aa510cafc60962$var$outputDecimalWarning(decimalTargets) {
    if (!decimalTargets.length) return;
    console.warn("Warning, the following targets are using a decimal version:\n");
    decimalTargets.forEach(({ target: target, value: value })=>console.warn(`  ${target}: ${value}`));
    console.warn(`
We recommend using a string for minor/patch versions to avoid numbers like 6.10
getting parsed as 6.1, which can lead to unexpected behavior.
`);
}
function $33aa510cafc60962$var$semverifyTarget(target, value) {
    try {
        return (0, $6s1of.semverify)(value);
    } catch (error) {
        throw new Error($33aa510cafc60962$var$v.formatMessage(`'${value}' is not a valid value for 'targets.${target}'.`));
    }
}
function $33aa510cafc60962$var$nodeTargetParser(value) {
    const parsed = value === true || value === "current" ? $hPtJY.versions.node : $33aa510cafc60962$var$semverifyTarget("node", value);
    return [
        "node",
        parsed
    ];
}
function $33aa510cafc60962$var$defaultTargetParser(target, value) {
    const version = (0, $6s1of.isUnreleasedVersion)(value, target) ? value.toLowerCase() : $33aa510cafc60962$var$semverifyTarget(target, value);
    return [
        target,
        version
    ];
}
function $33aa510cafc60962$var$generateTargets(inputTargets) {
    const input = Object.assign({}, inputTargets);
    delete input.esmodules;
    delete input.browsers;
    return input;
}
function $33aa510cafc60962$var$resolveTargets(queries, env) {
    const resolved = $cjv3H(queries, {
        mobileToDesktop: true,
        env: env
    });
    return $33aa510cafc60962$var$getLowestVersions(resolved);
}
const $33aa510cafc60962$var$targetsCache = new $dFGFv({
    max: 64
});
function $33aa510cafc60962$var$resolveTargetsCached(queries, env) {
    const cacheKey = typeof queries === "string" ? queries : queries.join() + env;
    let cached = $33aa510cafc60962$var$targetsCache.get(cacheKey);
    if (!cached) {
        cached = $33aa510cafc60962$var$resolveTargets(queries, env);
        $33aa510cafc60962$var$targetsCache.set(cacheKey, cached);
    }
    return Object.assign({}, cached);
}
function $33aa510cafc60962$var$getTargets(inputTargets = {}, options = {}) {
    var _browsers, _browsers2;
    let { browsers: browsers, esmodules: esmodules } = inputTargets;
    const { configPath: configPath = "." } = options;
    $33aa510cafc60962$var$validateBrowsers(browsers);
    const input = $33aa510cafc60962$var$generateTargets(inputTargets);
    let targets = $33aa510cafc60962$var$validateTargetNames(input);
    const shouldParseBrowsers = !!browsers;
    const hasTargets = shouldParseBrowsers || Object.keys(targets).length > 0;
    const shouldSearchForConfig = !options.ignoreBrowserslistConfig && !hasTargets;
    if (!browsers && shouldSearchForConfig) {
        browsers = $cjv3H.loadConfig({
            config: options.configFile,
            path: configPath,
            env: options.browserslistEnv
        });
        if (browsers == null) browsers = [];
    }
    if (esmodules && (esmodules !== "intersect" || !((_browsers = browsers) != null && _browsers.length))) {
        browsers = Object.keys($33aa510cafc60962$var$ESM_SUPPORT).map((browser)=>`${browser} >= ${$33aa510cafc60962$var$ESM_SUPPORT[browser]}`).join(", ");
        esmodules = false;
    }
    if ((_browsers2 = browsers) != null && _browsers2.length) {
        const queryBrowsers = $33aa510cafc60962$var$resolveTargetsCached(browsers, options.browserslistEnv);
        if (esmodules === "intersect") {
            for (const browser of Object.keys(queryBrowsers))if (browser !== "deno" && browser !== "ie") {
                const esmSupportVersion = $33aa510cafc60962$var$ESM_SUPPORT[browser === "opera_mobile" ? "op_mob" : browser];
                if (esmSupportVersion) {
                    const version = queryBrowsers[browser];
                    queryBrowsers[browser] = (0, $6s1of.getHighestUnreleased)(version, (0, $6s1of.semverify)(esmSupportVersion), browser);
                } else delete queryBrowsers[browser];
            } else delete queryBrowsers[browser];
        }
        targets = Object.assign(queryBrowsers, targets);
    }
    const result = {};
    const decimalWarnings = [];
    for (const target of Object.keys(targets).sort()){
        const value = targets[target];
        if (typeof value === "number" && value % 1 !== 0) decimalWarnings.push({
            target: target,
            value: value
        });
        const [parsedTarget, parsedValue] = target === "node" ? $33aa510cafc60962$var$nodeTargetParser(value) : $33aa510cafc60962$var$defaultTargetParser(target, value);
        if (parsedValue) result[parsedTarget] = parsedValue;
    }
    $33aa510cafc60962$var$outputDecimalWarning(decimalWarnings);
    return result;
}

});
parcelRegister("cjv3H", function(module, exports) {

var $grcyC = parcelRequire("grcyC");

var $lH4v9 = parcelRequire("lH4v9");
var $8f6f59fe83328867$require$agents = $lH4v9.agents;

var $5pSOk = parcelRequire("5pSOk");

var $kjyEk = parcelRequire("kjyEk");

var $KkowK = parcelRequire("KkowK");

var $eOoAi = parcelRequire("eOoAi");

var $jhEfw = parcelRequire("jhEfw");

var $c2daN = parcelRequire("c2daN");
var $8f6f59fe83328867$var$YEAR = 365.259641 * 86400000;
var $8f6f59fe83328867$var$ANDROID_EVERGREEN_FIRST = "37";
var $8f6f59fe83328867$var$OP_MOB_BLINK_FIRST = 14;
// Helpers
function $8f6f59fe83328867$var$isVersionsMatch(versionA, versionB) {
    return (versionA + ".").indexOf(versionB + ".") === 0;
}
function $8f6f59fe83328867$var$isEolReleased(name) {
    var version = name.slice(1);
    return $8f6f59fe83328867$var$browserslist.nodeVersions.some(function(i) {
        return $8f6f59fe83328867$var$isVersionsMatch(i, version);
    });
}
function $8f6f59fe83328867$var$normalize(versions) {
    return versions.filter(function(version) {
        return typeof version === "string";
    });
}
function $8f6f59fe83328867$var$normalizeElectron(version) {
    var versionToUse = version;
    if (version.split(".").length === 3) versionToUse = version.split(".").slice(0, -1).join(".");
    return versionToUse;
}
function $8f6f59fe83328867$var$nameMapper(name) {
    return function mapName(version) {
        return name + " " + version;
    };
}
function $8f6f59fe83328867$var$getMajor(version) {
    return parseInt(version.split(".")[0]);
}
function $8f6f59fe83328867$var$getMajorVersions(released, number) {
    if (released.length === 0) return [];
    var majorVersions = $8f6f59fe83328867$var$uniq(released.map($8f6f59fe83328867$var$getMajor));
    var minimum = majorVersions[majorVersions.length - number];
    if (!minimum) return released;
    var selected = [];
    for(var i = released.length - 1; i >= 0; i--){
        if (minimum > $8f6f59fe83328867$var$getMajor(released[i])) break;
        selected.unshift(released[i]);
    }
    return selected;
}
function $8f6f59fe83328867$var$uniq(array) {
    var filtered = [];
    for(var i = 0; i < array.length; i++)if (filtered.indexOf(array[i]) === -1) filtered.push(array[i]);
    return filtered;
}
function $8f6f59fe83328867$var$fillUsage(result, name, data) {
    for(var i in data)result[name + " " + i] = data[i];
}
function $8f6f59fe83328867$var$generateFilter(sign, version) {
    version = parseFloat(version);
    if (sign === ">") return function(v) {
        return parseFloat(v) > version;
    };
    else if (sign === ">=") return function(v) {
        return parseFloat(v) >= version;
    };
    else if (sign === "<") return function(v) {
        return parseFloat(v) < version;
    };
    else return function(v) {
        return parseFloat(v) <= version;
    };
}
function $8f6f59fe83328867$var$generateSemverFilter(sign, version) {
    version = version.split(".").map($8f6f59fe83328867$var$parseSimpleInt);
    version[1] = version[1] || 0;
    version[2] = version[2] || 0;
    if (sign === ">") return function(v) {
        v = v.split(".").map($8f6f59fe83328867$var$parseSimpleInt);
        return $8f6f59fe83328867$var$compareSemver(v, version) > 0;
    };
    else if (sign === ">=") return function(v) {
        v = v.split(".").map($8f6f59fe83328867$var$parseSimpleInt);
        return $8f6f59fe83328867$var$compareSemver(v, version) >= 0;
    };
    else if (sign === "<") return function(v) {
        v = v.split(".").map($8f6f59fe83328867$var$parseSimpleInt);
        return $8f6f59fe83328867$var$compareSemver(version, v) > 0;
    };
    else return function(v) {
        v = v.split(".").map($8f6f59fe83328867$var$parseSimpleInt);
        return $8f6f59fe83328867$var$compareSemver(version, v) >= 0;
    };
}
function $8f6f59fe83328867$var$parseSimpleInt(x) {
    return parseInt(x);
}
function $8f6f59fe83328867$var$compare(a, b) {
    if (a < b) return -1;
    if (a > b) return 1;
    return 0;
}
function $8f6f59fe83328867$var$compareSemver(a, b) {
    return $8f6f59fe83328867$var$compare(parseInt(a[0]), parseInt(b[0])) || $8f6f59fe83328867$var$compare(parseInt(a[1] || "0"), parseInt(b[1] || "0")) || $8f6f59fe83328867$var$compare(parseInt(a[2] || "0"), parseInt(b[2] || "0"));
}
// this follows the npm-like semver behavior
function $8f6f59fe83328867$var$semverFilterLoose(operator, range) {
    range = range.split(".").map($8f6f59fe83328867$var$parseSimpleInt);
    if (typeof range[1] === "undefined") range[1] = "x";
    // ignore any patch version because we only return minor versions
    // range[2] = 'x'
    switch(operator){
        case "<=":
            return function(version) {
                version = version.split(".").map($8f6f59fe83328867$var$parseSimpleInt);
                return $8f6f59fe83328867$var$compareSemverLoose(version, range) <= 0;
            };
        case ">=":
        default:
            return function(version) {
                version = version.split(".").map($8f6f59fe83328867$var$parseSimpleInt);
                return $8f6f59fe83328867$var$compareSemverLoose(version, range) >= 0;
            };
    }
}
// this follows the npm-like semver behavior
function $8f6f59fe83328867$var$compareSemverLoose(version, range) {
    if (version[0] !== range[0]) return version[0] < range[0] ? -1 : 1;
    if (range[1] === "x") return 0;
    if (version[1] !== range[1]) return version[1] < range[1] ? -1 : 1;
    return 0;
}
function $8f6f59fe83328867$var$resolveVersion(data, version) {
    if (data.versions.indexOf(version) !== -1) return version;
    else if ($8f6f59fe83328867$var$browserslist.versionAliases[data.name][version]) return $8f6f59fe83328867$var$browserslist.versionAliases[data.name][version];
    else return false;
}
function $8f6f59fe83328867$var$normalizeVersion(data, version) {
    var resolved = $8f6f59fe83328867$var$resolveVersion(data, version);
    if (resolved) return resolved;
    else if (data.versions.length === 1) return data.versions[0];
    else return false;
}
function $8f6f59fe83328867$var$filterByYear(since, context) {
    since = since / 1000;
    return Object.keys($8f6f59fe83328867$require$agents).reduce(function(selected, name) {
        var data = $8f6f59fe83328867$var$byName(name, context);
        if (!data) return selected;
        var versions = Object.keys(data.releaseDate).filter(function(v) {
            var date = data.releaseDate[v];
            return date !== null && date >= since;
        });
        return selected.concat(versions.map($8f6f59fe83328867$var$nameMapper(data.name)));
    }, []);
}
function $8f6f59fe83328867$var$cloneData(data) {
    return {
        name: data.name,
        versions: data.versions,
        released: data.released,
        releaseDate: data.releaseDate
    };
}
function $8f6f59fe83328867$var$byName(name, context) {
    name = name.toLowerCase();
    name = $8f6f59fe83328867$var$browserslist.aliases[name] || name;
    if (context.mobileToDesktop && $8f6f59fe83328867$var$browserslist.desktopNames[name]) {
        var desktop = $8f6f59fe83328867$var$browserslist.data[$8f6f59fe83328867$var$browserslist.desktopNames[name]];
        if (name === "android") return $8f6f59fe83328867$var$normalizeAndroidData($8f6f59fe83328867$var$cloneData($8f6f59fe83328867$var$browserslist.data[name]), desktop);
        else {
            var cloned = $8f6f59fe83328867$var$cloneData(desktop);
            cloned.name = name;
            return cloned;
        }
    }
    return $8f6f59fe83328867$var$browserslist.data[name];
}
function $8f6f59fe83328867$var$normalizeAndroidVersions(androidVersions, chromeVersions) {
    var iFirstEvergreen = chromeVersions.indexOf($8f6f59fe83328867$var$ANDROID_EVERGREEN_FIRST);
    return androidVersions.filter(function(version) {
        return /^(?:[2-4]\.|[34]$)/.test(version);
    }).concat(chromeVersions.slice(iFirstEvergreen));
}
function $8f6f59fe83328867$var$copyObject(obj) {
    var copy = {};
    for(var key in obj)copy[key] = obj[key];
    return copy;
}
function $8f6f59fe83328867$var$normalizeAndroidData(android, chrome) {
    android.released = $8f6f59fe83328867$var$normalizeAndroidVersions(android.released, chrome.released);
    android.versions = $8f6f59fe83328867$var$normalizeAndroidVersions(android.versions, chrome.versions);
    android.releaseDate = $8f6f59fe83328867$var$copyObject(android.releaseDate);
    android.released.forEach(function(v) {
        if (android.releaseDate[v] === undefined) android.releaseDate[v] = chrome.releaseDate[v];
    });
    return android;
}
function $8f6f59fe83328867$var$checkName(name, context) {
    var data = $8f6f59fe83328867$var$byName(name, context);
    if (!data) throw new $eOoAi("Unknown browser " + name);
    return data;
}
function $8f6f59fe83328867$var$unknownQuery(query) {
    return new $eOoAi("Unknown browser query `" + query + "`. " + "Maybe you are using old Browserslist or made typo in query.");
}
// Adjusts last X versions queries for some mobile browsers,
// where caniuse data jumps from a legacy version to the latest
function $8f6f59fe83328867$var$filterJumps(list, name, nVersions, context) {
    var jump = 1;
    switch(name){
        case "android":
            if (context.mobileToDesktop) return list;
            var released = $8f6f59fe83328867$var$browserslist.data.chrome.released;
            jump = released.length - released.indexOf($8f6f59fe83328867$var$ANDROID_EVERGREEN_FIRST);
            break;
        case "op_mob":
            var latest = $8f6f59fe83328867$var$browserslist.data.op_mob.released.slice(-1)[0];
            jump = $8f6f59fe83328867$var$getMajor(latest) - $8f6f59fe83328867$var$OP_MOB_BLINK_FIRST + 1;
            break;
        default:
            return list;
    }
    if (nVersions <= jump) return list.slice(-1);
    return list.slice(jump - 1 - nVersions);
}
function $8f6f59fe83328867$var$isSupported(flags, withPartial) {
    return typeof flags === "string" && (flags.indexOf("y") >= 0 || withPartial && flags.indexOf("a") >= 0);
}
function $8f6f59fe83328867$var$resolve(queries, context) {
    return $jhEfw($8f6f59fe83328867$var$QUERIES, queries).reduce(function(result, node, index) {
        if (node.not && index === 0) throw new $eOoAi("Write any browsers query (for instance, `defaults`) before `" + node.query + "`");
        var type = $8f6f59fe83328867$var$QUERIES[node.type];
        var array = type.select.call($8f6f59fe83328867$var$browserslist, context, node).map(function(j) {
            var parts = j.split(" ");
            if (parts[1] === "0") return parts[0] + " " + $8f6f59fe83328867$var$byName(parts[0], context).versions[0];
            else return j;
        });
        if (node.compose === "and") {
            if (node.not) return result.filter(function(j) {
                return array.indexOf(j) === -1;
            });
            else return result.filter(function(j) {
                return array.indexOf(j) !== -1;
            });
        } else {
            if (node.not) {
                var filter = {};
                array.forEach(function(j) {
                    filter[j] = true;
                });
                return result.filter(function(j) {
                    return !filter[j];
                });
            }
            return result.concat(array);
        }
    }, []);
}
function $8f6f59fe83328867$var$prepareOpts(opts) {
    if (typeof opts === "undefined") opts = {};
    if (typeof opts.path === "undefined") opts.path = $kjyEk.resolve ? $kjyEk.resolve(".") : ".";
    return opts;
}
function $8f6f59fe83328867$var$prepareQueries(queries, opts) {
    if (typeof queries === "undefined" || queries === null) {
        var config = $8f6f59fe83328867$var$browserslist.loadConfig(opts);
        if (config) queries = config;
        else queries = $8f6f59fe83328867$var$browserslist.defaults;
    }
    return queries;
}
function $8f6f59fe83328867$var$checkQueries(queries) {
    if (!(typeof queries === "string" || Array.isArray(queries))) throw new $eOoAi("Browser queries must be an array or string. Got " + typeof queries + ".");
}
var $8f6f59fe83328867$var$cache = {};
function $8f6f59fe83328867$var$browserslist(queries, opts) {
    opts = $8f6f59fe83328867$var$prepareOpts(opts);
    queries = $8f6f59fe83328867$var$prepareQueries(queries, opts);
    $8f6f59fe83328867$var$checkQueries(queries);
    var context = {
        ignoreUnknownVersions: opts.ignoreUnknownVersions,
        dangerousExtend: opts.dangerousExtend,
        mobileToDesktop: opts.mobileToDesktop,
        path: opts.path,
        env: opts.env
    };
    $c2daN.oldDataWarning($8f6f59fe83328867$var$browserslist.data);
    var stats = $c2daN.getStat(opts, $8f6f59fe83328867$var$browserslist.data);
    if (stats) {
        context.customUsage = {};
        for(var browser in stats)$8f6f59fe83328867$var$fillUsage(context.customUsage, browser, stats[browser]);
    }
    var cacheKey = JSON.stringify([
        queries,
        context
    ]);
    if ($8f6f59fe83328867$var$cache[cacheKey]) return $8f6f59fe83328867$var$cache[cacheKey];
    var result = $8f6f59fe83328867$var$uniq($8f6f59fe83328867$var$resolve(queries, context)).sort(function(name1, name2) {
        name1 = name1.split(" ");
        name2 = name2.split(" ");
        if (name1[0] === name2[0]) {
            // assumptions on caniuse data
            // 1) version ranges never overlaps
            // 2) if version is not a range, it never contains `-`
            var version1 = name1[1].split("-")[0];
            var version2 = name2[1].split("-")[0];
            return $8f6f59fe83328867$var$compareSemver(version2.split("."), version1.split("."));
        } else return $8f6f59fe83328867$var$compare(name1[0], name2[0]);
    });
    if (!$c2daN.env.BROWSERSLIST_DISABLE_CACHE) $8f6f59fe83328867$var$cache[cacheKey] = result;
    return result;
}
$8f6f59fe83328867$var$browserslist.parse = function(queries, opts) {
    opts = $8f6f59fe83328867$var$prepareOpts(opts);
    queries = $8f6f59fe83328867$var$prepareQueries(queries, opts);
    $8f6f59fe83328867$var$checkQueries(queries);
    return $jhEfw($8f6f59fe83328867$var$QUERIES, queries);
};
// Will be filled by Can I Use data below
$8f6f59fe83328867$var$browserslist.cache = {};
$8f6f59fe83328867$var$browserslist.data = {};
$8f6f59fe83328867$var$browserslist.usage = {
    global: {},
    custom: null
};
// Default browsers query
$8f6f59fe83328867$var$browserslist.defaults = [
    "> 0.5%",
    "last 2 versions",
    "Firefox ESR",
    "not dead"
];
// Browser names aliases
$8f6f59fe83328867$var$browserslist.aliases = {
    fx: "firefox",
    ff: "firefox",
    ios: "ios_saf",
    explorer: "ie",
    blackberry: "bb",
    explorermobile: "ie_mob",
    operamini: "op_mini",
    operamobile: "op_mob",
    chromeandroid: "and_chr",
    firefoxandroid: "and_ff",
    ucandroid: "and_uc",
    qqandroid: "and_qq"
};
// Can I Use only provides a few versions for some browsers (e.g. and_chr).
// Fallback to a similar browser for unknown versions
// Note op_mob is not included as its chromium versions are not in sync with Opera desktop
$8f6f59fe83328867$var$browserslist.desktopNames = {
    and_chr: "chrome",
    and_ff: "firefox",
    ie_mob: "ie",
    android: "chrome" // has extra processing logic
};
// Aliases to work with joined versions like `ios_saf 7.0-7.1`
$8f6f59fe83328867$var$browserslist.versionAliases = {};
$8f6f59fe83328867$var$browserslist.clearCaches = $c2daN.clearCaches;
$8f6f59fe83328867$var$browserslist.parseConfig = $c2daN.parseConfig;
$8f6f59fe83328867$var$browserslist.readConfig = $c2daN.readConfig;
$8f6f59fe83328867$var$browserslist.findConfig = $c2daN.findConfig;
$8f6f59fe83328867$var$browserslist.loadConfig = $c2daN.loadConfig;
$8f6f59fe83328867$var$browserslist.coverage = function(browsers, stats) {
    var data;
    if (typeof stats === "undefined") data = $8f6f59fe83328867$var$browserslist.usage.global;
    else if (stats === "my stats") {
        var opts = {};
        opts.path = $kjyEk.resolve ? $kjyEk.resolve(".") : ".";
        var customStats = $c2daN.getStat(opts);
        if (!customStats) throw new $eOoAi("Custom usage statistics was not provided");
        data = {};
        for(var browser in customStats)$8f6f59fe83328867$var$fillUsage(data, browser, customStats[browser]);
    } else if (typeof stats === "string") {
        if (stats.length > 2) stats = stats.toLowerCase();
        else stats = stats.toUpperCase();
        $c2daN.loadCountry($8f6f59fe83328867$var$browserslist.usage, stats, $8f6f59fe83328867$var$browserslist.data);
        data = $8f6f59fe83328867$var$browserslist.usage[stats];
    } else {
        if ("dataByBrowser" in stats) stats = stats.dataByBrowser;
        data = {};
        for(var name in stats)for(var version in stats[name])data[name + " " + version] = stats[name][version];
    }
    return browsers.reduce(function(all, i) {
        var usage = data[i];
        if (usage === undefined) usage = data[i.replace(/ \S+$/, " 0")];
        return all + (usage || 0);
    }, 0);
};
function $8f6f59fe83328867$var$nodeQuery(context, node) {
    var matched = $8f6f59fe83328867$var$browserslist.nodeVersions.filter(function(i) {
        return $8f6f59fe83328867$var$isVersionsMatch(i, node.version);
    });
    if (matched.length === 0) {
        if (context.ignoreUnknownVersions) return [];
        else throw new $eOoAi("Unknown version " + node.version + " of Node.js");
    }
    return [
        "node " + matched[matched.length - 1]
    ];
}
function $8f6f59fe83328867$var$sinceQuery(context, node) {
    var year = parseInt(node.year);
    var month = parseInt(node.month || "01") - 1;
    var day = parseInt(node.day || "01");
    return $8f6f59fe83328867$var$filterByYear(Date.UTC(year, month, day, 0, 0, 0), context);
}
function $8f6f59fe83328867$var$coverQuery(context, node) {
    var coverage = parseFloat(node.coverage);
    var usage = $8f6f59fe83328867$var$browserslist.usage.global;
    if (node.place) {
        if (node.place.match(/^my\s+stats$/i)) {
            if (!context.customUsage) throw new $eOoAi("Custom usage statistics was not provided");
            usage = context.customUsage;
        } else {
            var place;
            if (node.place.length === 2) place = node.place.toUpperCase();
            else place = node.place.toLowerCase();
            $c2daN.loadCountry($8f6f59fe83328867$var$browserslist.usage, place, $8f6f59fe83328867$var$browserslist.data);
            usage = $8f6f59fe83328867$var$browserslist.usage[place];
        }
    }
    var versions = Object.keys(usage).sort(function(a, b) {
        return usage[b] - usage[a];
    });
    var coveraged = 0;
    var result = [];
    var version;
    for(var i = 0; i < versions.length; i++){
        version = versions[i];
        if (usage[version] === 0) break;
        coveraged += usage[version];
        result.push(version);
        if (coveraged >= coverage) break;
    }
    return result;
}
var $8f6f59fe83328867$var$QUERIES = {
    last_major_versions: {
        matches: [
            "versions"
        ],
        regexp: /^last\s+(\d+)\s+major\s+versions?$/i,
        select: function(context, node) {
            return Object.keys($8f6f59fe83328867$require$agents).reduce(function(selected, name) {
                var data = $8f6f59fe83328867$var$byName(name, context);
                if (!data) return selected;
                var list = $8f6f59fe83328867$var$getMajorVersions(data.released, node.versions);
                list = list.map($8f6f59fe83328867$var$nameMapper(data.name));
                list = $8f6f59fe83328867$var$filterJumps(list, data.name, node.versions, context);
                return selected.concat(list);
            }, []);
        }
    },
    last_versions: {
        matches: [
            "versions"
        ],
        regexp: /^last\s+(\d+)\s+versions?$/i,
        select: function(context, node) {
            return Object.keys($8f6f59fe83328867$require$agents).reduce(function(selected, name) {
                var data = $8f6f59fe83328867$var$byName(name, context);
                if (!data) return selected;
                var list = data.released.slice(-node.versions);
                list = list.map($8f6f59fe83328867$var$nameMapper(data.name));
                list = $8f6f59fe83328867$var$filterJumps(list, data.name, node.versions, context);
                return selected.concat(list);
            }, []);
        }
    },
    last_electron_major_versions: {
        matches: [
            "versions"
        ],
        regexp: /^last\s+(\d+)\s+electron\s+major\s+versions?$/i,
        select: function(context, node) {
            var validVersions = $8f6f59fe83328867$var$getMajorVersions(Object.keys($KkowK), node.versions);
            return validVersions.map(function(i) {
                return "chrome " + $KkowK[i];
            });
        }
    },
    last_node_major_versions: {
        matches: [
            "versions"
        ],
        regexp: /^last\s+(\d+)\s+node\s+major\s+versions?$/i,
        select: function(context, node) {
            return $8f6f59fe83328867$var$getMajorVersions($8f6f59fe83328867$var$browserslist.nodeVersions, node.versions).map(function(version) {
                return "node " + version;
            });
        }
    },
    last_browser_major_versions: {
        matches: [
            "versions",
            "browser"
        ],
        regexp: /^last\s+(\d+)\s+(\w+)\s+major\s+versions?$/i,
        select: function(context, node) {
            var data = $8f6f59fe83328867$var$checkName(node.browser, context);
            var validVersions = $8f6f59fe83328867$var$getMajorVersions(data.released, node.versions);
            var list = validVersions.map($8f6f59fe83328867$var$nameMapper(data.name));
            list = $8f6f59fe83328867$var$filterJumps(list, data.name, node.versions, context);
            return list;
        }
    },
    last_electron_versions: {
        matches: [
            "versions"
        ],
        regexp: /^last\s+(\d+)\s+electron\s+versions?$/i,
        select: function(context, node) {
            return Object.keys($KkowK).slice(-node.versions).map(function(i) {
                return "chrome " + $KkowK[i];
            });
        }
    },
    last_node_versions: {
        matches: [
            "versions"
        ],
        regexp: /^last\s+(\d+)\s+node\s+versions?$/i,
        select: function(context, node) {
            return $8f6f59fe83328867$var$browserslist.nodeVersions.slice(-node.versions).map(function(version) {
                return "node " + version;
            });
        }
    },
    last_browser_versions: {
        matches: [
            "versions",
            "browser"
        ],
        regexp: /^last\s+(\d+)\s+(\w+)\s+versions?$/i,
        select: function(context, node) {
            var data = $8f6f59fe83328867$var$checkName(node.browser, context);
            var list = data.released.slice(-node.versions).map($8f6f59fe83328867$var$nameMapper(data.name));
            list = $8f6f59fe83328867$var$filterJumps(list, data.name, node.versions, context);
            return list;
        }
    },
    unreleased_versions: {
        matches: [],
        regexp: /^unreleased\s+versions$/i,
        select: function(context) {
            return Object.keys($8f6f59fe83328867$require$agents).reduce(function(selected, name) {
                var data = $8f6f59fe83328867$var$byName(name, context);
                if (!data) return selected;
                var list = data.versions.filter(function(v) {
                    return data.released.indexOf(v) === -1;
                });
                list = list.map($8f6f59fe83328867$var$nameMapper(data.name));
                return selected.concat(list);
            }, []);
        }
    },
    unreleased_electron_versions: {
        matches: [],
        regexp: /^unreleased\s+electron\s+versions?$/i,
        select: function() {
            return [];
        }
    },
    unreleased_browser_versions: {
        matches: [
            "browser"
        ],
        regexp: /^unreleased\s+(\w+)\s+versions?$/i,
        select: function(context, node) {
            var data = $8f6f59fe83328867$var$checkName(node.browser, context);
            return data.versions.filter(function(v) {
                return data.released.indexOf(v) === -1;
            }).map($8f6f59fe83328867$var$nameMapper(data.name));
        }
    },
    last_years: {
        matches: [
            "years"
        ],
        regexp: /^last\s+(\d*.?\d+)\s+years?$/i,
        select: function(context, node) {
            return $8f6f59fe83328867$var$filterByYear(Date.now() - $8f6f59fe83328867$var$YEAR * node.years, context);
        }
    },
    since_y: {
        matches: [
            "year"
        ],
        regexp: /^since (\d+)$/i,
        select: $8f6f59fe83328867$var$sinceQuery
    },
    since_y_m: {
        matches: [
            "year",
            "month"
        ],
        regexp: /^since (\d+)-(\d+)$/i,
        select: $8f6f59fe83328867$var$sinceQuery
    },
    since_y_m_d: {
        matches: [
            "year",
            "month",
            "day"
        ],
        regexp: /^since (\d+)-(\d+)-(\d+)$/i,
        select: $8f6f59fe83328867$var$sinceQuery
    },
    popularity: {
        matches: [
            "sign",
            "popularity"
        ],
        regexp: /^(>=?|<=?)\s*(\d+|\d+\.\d+|\.\d+)%$/,
        select: function(context, node) {
            var popularity = parseFloat(node.popularity);
            var usage = $8f6f59fe83328867$var$browserslist.usage.global;
            return Object.keys(usage).reduce(function(result, version) {
                if (node.sign === ">") {
                    if (usage[version] > popularity) result.push(version);
                } else if (node.sign === "<") {
                    if (usage[version] < popularity) result.push(version);
                } else if (node.sign === "<=") {
                    if (usage[version] <= popularity) result.push(version);
                } else if (usage[version] >= popularity) result.push(version);
                return result;
            }, []);
        }
    },
    popularity_in_my_stats: {
        matches: [
            "sign",
            "popularity"
        ],
        regexp: /^(>=?|<=?)\s*(\d+|\d+\.\d+|\.\d+)%\s+in\s+my\s+stats$/,
        select: function(context, node) {
            var popularity = parseFloat(node.popularity);
            if (!context.customUsage) throw new $eOoAi("Custom usage statistics was not provided");
            var usage = context.customUsage;
            return Object.keys(usage).reduce(function(result, version) {
                var percentage = usage[version];
                if (percentage == null) return result;
                if (node.sign === ">") {
                    if (percentage > popularity) result.push(version);
                } else if (node.sign === "<") {
                    if (percentage < popularity) result.push(version);
                } else if (node.sign === "<=") {
                    if (percentage <= popularity) result.push(version);
                } else if (percentage >= popularity) result.push(version);
                return result;
            }, []);
        }
    },
    popularity_in_config_stats: {
        matches: [
            "sign",
            "popularity",
            "config"
        ],
        regexp: /^(>=?|<=?)\s*(\d+|\d+\.\d+|\.\d+)%\s+in\s+(\S+)\s+stats$/,
        select: function(context, node) {
            var popularity = parseFloat(node.popularity);
            var stats = $c2daN.loadStat(context, node.config, $8f6f59fe83328867$var$browserslist.data);
            if (stats) {
                context.customUsage = {};
                for(var browser in stats)$8f6f59fe83328867$var$fillUsage(context.customUsage, browser, stats[browser]);
            }
            if (!context.customUsage) throw new $eOoAi("Custom usage statistics was not provided");
            var usage = context.customUsage;
            return Object.keys(usage).reduce(function(result, version) {
                var percentage = usage[version];
                if (percentage == null) return result;
                if (node.sign === ">") {
                    if (percentage > popularity) result.push(version);
                } else if (node.sign === "<") {
                    if (percentage < popularity) result.push(version);
                } else if (node.sign === "<=") {
                    if (percentage <= popularity) result.push(version);
                } else if (percentage >= popularity) result.push(version);
                return result;
            }, []);
        }
    },
    popularity_in_place: {
        matches: [
            "sign",
            "popularity",
            "place"
        ],
        regexp: /^(>=?|<=?)\s*(\d+|\d+\.\d+|\.\d+)%\s+in\s+((alt-)?\w\w)$/,
        select: function(context, node) {
            var popularity = parseFloat(node.popularity);
            var place = node.place;
            if (place.length === 2) place = place.toUpperCase();
            else place = place.toLowerCase();
            $c2daN.loadCountry($8f6f59fe83328867$var$browserslist.usage, place, $8f6f59fe83328867$var$browserslist.data);
            var usage = $8f6f59fe83328867$var$browserslist.usage[place];
            return Object.keys(usage).reduce(function(result, version) {
                var percentage = usage[version];
                if (percentage == null) return result;
                if (node.sign === ">") {
                    if (percentage > popularity) result.push(version);
                } else if (node.sign === "<") {
                    if (percentage < popularity) result.push(version);
                } else if (node.sign === "<=") {
                    if (percentage <= popularity) result.push(version);
                } else if (percentage >= popularity) result.push(version);
                return result;
            }, []);
        }
    },
    cover: {
        matches: [
            "coverage"
        ],
        regexp: /^cover\s+(\d+|\d+\.\d+|\.\d+)%$/i,
        select: $8f6f59fe83328867$var$coverQuery
    },
    cover_in: {
        matches: [
            "coverage",
            "place"
        ],
        regexp: /^cover\s+(\d+|\d+\.\d+|\.\d+)%\s+in\s+(my\s+stats|(alt-)?\w\w)$/i,
        select: $8f6f59fe83328867$var$coverQuery
    },
    supports: {
        matches: [
            "supportType",
            "feature"
        ],
        regexp: /^(?:(fully|partially)\s+)?supports\s+([\w-]+)$/,
        select: function(context, node) {
            $c2daN.loadFeature($8f6f59fe83328867$var$browserslist.cache, node.feature);
            var withPartial = node.supportType !== "fully";
            var features = $8f6f59fe83328867$var$browserslist.cache[node.feature];
            var result = [];
            for(var name in features){
                var data = $8f6f59fe83328867$var$byName(name, context);
                // Only check desktop when latest released mobile has support
                var checkDesktop = context.mobileToDesktop && name in $8f6f59fe83328867$var$browserslist.desktopNames && $8f6f59fe83328867$var$isSupported(features[name][data.released.slice(-1)[0]], withPartial);
                data.versions.forEach(function(version) {
                    var flags = features[name][version];
                    if (flags === undefined && checkDesktop) flags = features[$8f6f59fe83328867$var$browserslist.desktopNames[name]][version];
                    if ($8f6f59fe83328867$var$isSupported(flags, withPartial)) result.push(name + " " + version);
                });
            }
            return result;
        }
    },
    electron_range: {
        matches: [
            "from",
            "to"
        ],
        regexp: /^electron\s+([\d.]+)\s*-\s*([\d.]+)$/i,
        select: function(context, node) {
            var fromToUse = $8f6f59fe83328867$var$normalizeElectron(node.from);
            var toToUse = $8f6f59fe83328867$var$normalizeElectron(node.to);
            var from = parseFloat(node.from);
            var to = parseFloat(node.to);
            if (!$KkowK[fromToUse]) throw new $eOoAi("Unknown version " + from + " of electron");
            if (!$KkowK[toToUse]) throw new $eOoAi("Unknown version " + to + " of electron");
            return Object.keys($KkowK).filter(function(i) {
                var parsed = parseFloat(i);
                return parsed >= from && parsed <= to;
            }).map(function(i) {
                return "chrome " + $KkowK[i];
            });
        }
    },
    node_range: {
        matches: [
            "from",
            "to"
        ],
        regexp: /^node\s+([\d.]+)\s*-\s*([\d.]+)$/i,
        select: function(context, node) {
            return $8f6f59fe83328867$var$browserslist.nodeVersions.filter($8f6f59fe83328867$var$semverFilterLoose(">=", node.from)).filter($8f6f59fe83328867$var$semverFilterLoose("<=", node.to)).map(function(v) {
                return "node " + v;
            });
        }
    },
    browser_range: {
        matches: [
            "browser",
            "from",
            "to"
        ],
        regexp: /^(\w+)\s+([\d.]+)\s*-\s*([\d.]+)$/i,
        select: function(context, node) {
            var data = $8f6f59fe83328867$var$checkName(node.browser, context);
            var from = parseFloat($8f6f59fe83328867$var$normalizeVersion(data, node.from) || node.from);
            var to = parseFloat($8f6f59fe83328867$var$normalizeVersion(data, node.to) || node.to);
            function filter(v) {
                var parsed = parseFloat(v);
                return parsed >= from && parsed <= to;
            }
            return data.released.filter(filter).map($8f6f59fe83328867$var$nameMapper(data.name));
        }
    },
    electron_ray: {
        matches: [
            "sign",
            "version"
        ],
        regexp: /^electron\s*(>=?|<=?)\s*([\d.]+)$/i,
        select: function(context, node) {
            var versionToUse = $8f6f59fe83328867$var$normalizeElectron(node.version);
            return Object.keys($KkowK).filter($8f6f59fe83328867$var$generateFilter(node.sign, versionToUse)).map(function(i) {
                return "chrome " + $KkowK[i];
            });
        }
    },
    node_ray: {
        matches: [
            "sign",
            "version"
        ],
        regexp: /^node\s*(>=?|<=?)\s*([\d.]+)$/i,
        select: function(context, node) {
            return $8f6f59fe83328867$var$browserslist.nodeVersions.filter($8f6f59fe83328867$var$generateSemverFilter(node.sign, node.version)).map(function(v) {
                return "node " + v;
            });
        }
    },
    browser_ray: {
        matches: [
            "browser",
            "sign",
            "version"
        ],
        regexp: /^(\w+)\s*(>=?|<=?)\s*([\d.]+)$/,
        select: function(context, node) {
            var version = node.version;
            var data = $8f6f59fe83328867$var$checkName(node.browser, context);
            var alias = $8f6f59fe83328867$var$browserslist.versionAliases[data.name][version];
            if (alias) version = alias;
            return data.released.filter($8f6f59fe83328867$var$generateFilter(node.sign, version)).map(function(v) {
                return data.name + " " + v;
            });
        }
    },
    firefox_esr: {
        matches: [],
        regexp: /^(firefox|ff|fx)\s+esr$/i,
        select: function() {
            return [
                "firefox 115"
            ];
        }
    },
    opera_mini_all: {
        matches: [],
        regexp: /(operamini|op_mini)\s+all/i,
        select: function() {
            return [
                "op_mini all"
            ];
        }
    },
    electron_version: {
        matches: [
            "version"
        ],
        regexp: /^electron\s+([\d.]+)$/i,
        select: function(context, node) {
            var versionToUse = $8f6f59fe83328867$var$normalizeElectron(node.version);
            var chrome = $KkowK[versionToUse];
            if (!chrome) throw new $eOoAi("Unknown version " + node.version + " of electron");
            return [
                "chrome " + chrome
            ];
        }
    },
    node_major_version: {
        matches: [
            "version"
        ],
        regexp: /^node\s+(\d+)$/i,
        select: $8f6f59fe83328867$var$nodeQuery
    },
    node_minor_version: {
        matches: [
            "version"
        ],
        regexp: /^node\s+(\d+\.\d+)$/i,
        select: $8f6f59fe83328867$var$nodeQuery
    },
    node_patch_version: {
        matches: [
            "version"
        ],
        regexp: /^node\s+(\d+\.\d+\.\d+)$/i,
        select: $8f6f59fe83328867$var$nodeQuery
    },
    current_node: {
        matches: [],
        regexp: /^current\s+node$/i,
        select: function(context) {
            return [
                $c2daN.currentNode($8f6f59fe83328867$var$resolve, context)
            ];
        }
    },
    maintained_node: {
        matches: [],
        regexp: /^maintained\s+node\s+versions$/i,
        select: function(context) {
            var now = Date.now();
            var queries = Object.keys($5pSOk).filter(function(key) {
                return now < Date.parse($5pSOk[key].end) && now > Date.parse($5pSOk[key].start) && $8f6f59fe83328867$var$isEolReleased(key);
            }).map(function(key) {
                return "node " + key.slice(1);
            });
            return $8f6f59fe83328867$var$resolve(queries, context);
        }
    },
    phantomjs_1_9: {
        matches: [],
        regexp: /^phantomjs\s+1.9$/i,
        select: function() {
            return [
                "safari 5"
            ];
        }
    },
    phantomjs_2_1: {
        matches: [],
        regexp: /^phantomjs\s+2.1$/i,
        select: function() {
            return [
                "safari 6"
            ];
        }
    },
    browser_version: {
        matches: [
            "browser",
            "version"
        ],
        regexp: /^(\w+)\s+(tp|[\d.]+)$/i,
        select: function(context, node) {
            var version = node.version;
            if (/^tp$/i.test(version)) version = "TP";
            var data = $8f6f59fe83328867$var$checkName(node.browser, context);
            var alias = $8f6f59fe83328867$var$normalizeVersion(data, version);
            if (alias) version = alias;
            else {
                if (version.indexOf(".") === -1) alias = version + ".0";
                else alias = version.replace(/\.0$/, "");
                alias = $8f6f59fe83328867$var$normalizeVersion(data, alias);
                if (alias) version = alias;
                else if (context.ignoreUnknownVersions) return [];
                else throw new $eOoAi("Unknown version " + version + " of " + node.browser);
            }
            return [
                data.name + " " + version
            ];
        }
    },
    browserslist_config: {
        matches: [],
        regexp: /^browserslist config$/i,
        select: function(context) {
            return $8f6f59fe83328867$var$browserslist(undefined, context);
        }
    },
    extends: {
        matches: [
            "config"
        ],
        regexp: /^extends (.+)$/i,
        select: function(context, node) {
            return $8f6f59fe83328867$var$resolve($c2daN.loadQueries(context, node.config), context);
        }
    },
    defaults: {
        matches: [],
        regexp: /^defaults$/i,
        select: function(context) {
            return $8f6f59fe83328867$var$resolve($8f6f59fe83328867$var$browserslist.defaults, context);
        }
    },
    dead: {
        matches: [],
        regexp: /^dead$/i,
        select: function(context) {
            var dead = [
                "Baidu >= 0",
                "ie <= 11",
                "ie_mob <= 11",
                "bb <= 10",
                "op_mob <= 12.1",
                "samsung 4"
            ];
            return $8f6f59fe83328867$var$resolve(dead, context);
        }
    },
    unknown: {
        matches: [],
        regexp: /^(\w+)$/i,
        select: function(context, node) {
            if ($8f6f59fe83328867$var$byName(node.query, context)) throw new $eOoAi("Specify versions in Browserslist query for browser " + node.query);
            else throw $8f6f59fe83328867$var$unknownQuery(node.query);
        }
    }
};
(function() {
    for(var name in $8f6f59fe83328867$require$agents){
        var browser = $8f6f59fe83328867$require$agents[name];
        $8f6f59fe83328867$var$browserslist.data[name] = {
            name: name,
            versions: $8f6f59fe83328867$var$normalize($8f6f59fe83328867$require$agents[name].versions),
            released: $8f6f59fe83328867$var$normalize($8f6f59fe83328867$require$agents[name].versions.slice(0, -3)),
            releaseDate: $8f6f59fe83328867$require$agents[name].release_date
        };
        $8f6f59fe83328867$var$fillUsage($8f6f59fe83328867$var$browserslist.usage.global, name, browser.usage_global);
        $8f6f59fe83328867$var$browserslist.versionAliases[name] = {};
        for(var i = 0; i < browser.versions.length; i++){
            var full = browser.versions[i];
            if (!full) continue;
            if (full.indexOf("-") !== -1) {
                var interval = full.split("-");
                for(var j = 0; j < interval.length; j++)$8f6f59fe83328867$var$browserslist.versionAliases[name][interval[j]] = full;
            }
        }
    }
    $8f6f59fe83328867$var$browserslist.nodeVersions = $grcyC.map(function(release) {
        return release.version;
    });
})();
module.exports = $8f6f59fe83328867$var$browserslist;

});
parcelRegister("grcyC", function(module, exports) {
module.exports = JSON.parse('[{"name":"nodejs","version":"0.2.0","date":"2011-08-26","lts":false,"security":false,"v8":"2.3.8.0"},{"name":"nodejs","version":"0.3.0","date":"2011-08-26","lts":false,"security":false,"v8":"2.5.1.0"},{"name":"nodejs","version":"0.4.0","date":"2011-08-26","lts":false,"security":false,"v8":"3.1.2.0"},{"name":"nodejs","version":"0.5.0","date":"2011-08-26","lts":false,"security":false,"v8":"3.1.8.25"},{"name":"nodejs","version":"0.6.0","date":"2011-11-04","lts":false,"security":false,"v8":"3.6.6.6"},{"name":"nodejs","version":"0.7.0","date":"2012-01-17","lts":false,"security":false,"v8":"3.8.6.0"},{"name":"nodejs","version":"0.8.0","date":"2012-06-22","lts":false,"security":false,"v8":"3.11.10.10"},{"name":"nodejs","version":"0.9.0","date":"2012-07-20","lts":false,"security":false,"v8":"3.11.10.15"},{"name":"nodejs","version":"0.10.0","date":"2013-03-11","lts":false,"security":false,"v8":"3.14.5.8"},{"name":"nodejs","version":"0.11.0","date":"2013-03-28","lts":false,"security":false,"v8":"3.17.13.0"},{"name":"nodejs","version":"0.12.0","date":"2015-02-06","lts":false,"security":false,"v8":"3.28.73.0"},{"name":"nodejs","version":"4.0.0","date":"2015-09-08","lts":false,"security":false,"v8":"4.5.103.30"},{"name":"nodejs","version":"4.1.0","date":"2015-09-17","lts":false,"security":false,"v8":"4.5.103.33"},{"name":"nodejs","version":"4.2.0","date":"2015-10-12","lts":"Argon","security":false,"v8":"4.5.103.35"},{"name":"nodejs","version":"4.3.0","date":"2016-02-09","lts":"Argon","security":false,"v8":"4.5.103.35"},{"name":"nodejs","version":"4.4.0","date":"2016-03-08","lts":"Argon","security":false,"v8":"4.5.103.35"},{"name":"nodejs","version":"4.5.0","date":"2016-08-16","lts":"Argon","security":false,"v8":"4.5.103.37"},{"name":"nodejs","version":"4.6.0","date":"2016-09-27","lts":"Argon","security":true,"v8":"4.5.103.37"},{"name":"nodejs","version":"4.7.0","date":"2016-12-06","lts":"Argon","security":false,"v8":"4.5.103.43"},{"name":"nodejs","version":"4.8.0","date":"2017-02-21","lts":"Argon","security":false,"v8":"4.5.103.45"},{"name":"nodejs","version":"4.9.0","date":"2018-03-28","lts":"Argon","security":true,"v8":"4.5.103.53"},{"name":"nodejs","version":"5.0.0","date":"2015-10-29","lts":false,"security":false,"v8":"4.6.85.28"},{"name":"nodejs","version":"5.1.0","date":"2015-11-17","lts":false,"security":false,"v8":"4.6.85.31"},{"name":"nodejs","version":"5.2.0","date":"2015-12-09","lts":false,"security":false,"v8":"4.6.85.31"},{"name":"nodejs","version":"5.3.0","date":"2015-12-15","lts":false,"security":false,"v8":"4.6.85.31"},{"name":"nodejs","version":"5.4.0","date":"2016-01-06","lts":false,"security":false,"v8":"4.6.85.31"},{"name":"nodejs","version":"5.5.0","date":"2016-01-21","lts":false,"security":false,"v8":"4.6.85.31"},{"name":"nodejs","version":"5.6.0","date":"2016-02-09","lts":false,"security":false,"v8":"4.6.85.31"},{"name":"nodejs","version":"5.7.0","date":"2016-02-23","lts":false,"security":false,"v8":"4.6.85.31"},{"name":"nodejs","version":"5.8.0","date":"2016-03-09","lts":false,"security":false,"v8":"4.6.85.31"},{"name":"nodejs","version":"5.9.0","date":"2016-03-16","lts":false,"security":false,"v8":"4.6.85.31"},{"name":"nodejs","version":"5.10.0","date":"2016-04-01","lts":false,"security":false,"v8":"4.6.85.31"},{"name":"nodejs","version":"5.11.0","date":"2016-04-21","lts":false,"security":false,"v8":"4.6.85.31"},{"name":"nodejs","version":"5.12.0","date":"2016-06-23","lts":false,"security":false,"v8":"4.6.85.32"},{"name":"nodejs","version":"6.0.0","date":"2016-04-26","lts":false,"security":false,"v8":"5.0.71.35"},{"name":"nodejs","version":"6.1.0","date":"2016-05-05","lts":false,"security":false,"v8":"5.0.71.35"},{"name":"nodejs","version":"6.2.0","date":"2016-05-17","lts":false,"security":false,"v8":"5.0.71.47"},{"name":"nodejs","version":"6.3.0","date":"2016-07-06","lts":false,"security":false,"v8":"5.0.71.52"},{"name":"nodejs","version":"6.4.0","date":"2016-08-12","lts":false,"security":false,"v8":"5.0.71.60"},{"name":"nodejs","version":"6.5.0","date":"2016-08-26","lts":false,"security":false,"v8":"5.1.281.81"},{"name":"nodejs","version":"6.6.0","date":"2016-09-14","lts":false,"security":false,"v8":"5.1.281.83"},{"name":"nodejs","version":"6.7.0","date":"2016-09-27","lts":false,"security":true,"v8":"5.1.281.83"},{"name":"nodejs","version":"6.8.0","date":"2016-10-12","lts":false,"security":false,"v8":"5.1.281.84"},{"name":"nodejs","version":"6.9.0","date":"2016-10-18","lts":"Boron","security":false,"v8":"5.1.281.84"},{"name":"nodejs","version":"6.10.0","date":"2017-02-21","lts":"Boron","security":false,"v8":"5.1.281.93"},{"name":"nodejs","version":"6.11.0","date":"2017-06-06","lts":"Boron","security":false,"v8":"5.1.281.102"},{"name":"nodejs","version":"6.12.0","date":"2017-11-06","lts":"Boron","security":false,"v8":"5.1.281.108"},{"name":"nodejs","version":"6.13.0","date":"2018-02-10","lts":"Boron","security":false,"v8":"5.1.281.111"},{"name":"nodejs","version":"6.14.0","date":"2018-03-28","lts":"Boron","security":true,"v8":"5.1.281.111"},{"name":"nodejs","version":"6.15.0","date":"2018-11-27","lts":"Boron","security":true,"v8":"5.1.281.111"},{"name":"nodejs","version":"6.16.0","date":"2018-12-26","lts":"Boron","security":false,"v8":"5.1.281.111"},{"name":"nodejs","version":"6.17.0","date":"2019-02-28","lts":"Boron","security":true,"v8":"5.1.281.111"},{"name":"nodejs","version":"7.0.0","date":"2016-10-25","lts":false,"security":false,"v8":"5.4.500.36"},{"name":"nodejs","version":"7.1.0","date":"2016-11-08","lts":false,"security":false,"v8":"5.4.500.36"},{"name":"nodejs","version":"7.2.0","date":"2016-11-22","lts":false,"security":false,"v8":"5.4.500.43"},{"name":"nodejs","version":"7.3.0","date":"2016-12-20","lts":false,"security":false,"v8":"5.4.500.45"},{"name":"nodejs","version":"7.4.0","date":"2017-01-04","lts":false,"security":false,"v8":"5.4.500.45"},{"name":"nodejs","version":"7.5.0","date":"2017-01-31","lts":false,"security":false,"v8":"5.4.500.48"},{"name":"nodejs","version":"7.6.0","date":"2017-02-21","lts":false,"security":false,"v8":"5.5.372.40"},{"name":"nodejs","version":"7.7.0","date":"2017-02-28","lts":false,"security":false,"v8":"5.5.372.41"},{"name":"nodejs","version":"7.8.0","date":"2017-03-29","lts":false,"security":false,"v8":"5.5.372.43"},{"name":"nodejs","version":"7.9.0","date":"2017-04-11","lts":false,"security":false,"v8":"5.5.372.43"},{"name":"nodejs","version":"7.10.0","date":"2017-05-02","lts":false,"security":false,"v8":"5.5.372.43"},{"name":"nodejs","version":"8.0.0","date":"2017-05-30","lts":false,"security":false,"v8":"5.8.283.41"},{"name":"nodejs","version":"8.1.0","date":"2017-06-08","lts":false,"security":false,"v8":"5.8.283.41"},{"name":"nodejs","version":"8.2.0","date":"2017-07-19","lts":false,"security":false,"v8":"5.8.283.41"},{"name":"nodejs","version":"8.3.0","date":"2017-08-08","lts":false,"security":false,"v8":"6.0.286.52"},{"name":"nodejs","version":"8.4.0","date":"2017-08-15","lts":false,"security":false,"v8":"6.0.286.52"},{"name":"nodejs","version":"8.5.0","date":"2017-09-12","lts":false,"security":false,"v8":"6.0.287.53"},{"name":"nodejs","version":"8.6.0","date":"2017-09-26","lts":false,"security":false,"v8":"6.0.287.53"},{"name":"nodejs","version":"8.7.0","date":"2017-10-11","lts":false,"security":false,"v8":"6.1.534.42"},{"name":"nodejs","version":"8.8.0","date":"2017-10-24","lts":false,"security":false,"v8":"6.1.534.42"},{"name":"nodejs","version":"8.9.0","date":"2017-10-31","lts":"Carbon","security":false,"v8":"6.1.534.46"},{"name":"nodejs","version":"8.10.0","date":"2018-03-06","lts":"Carbon","security":false,"v8":"6.2.414.50"},{"name":"nodejs","version":"8.11.0","date":"2018-03-28","lts":"Carbon","security":true,"v8":"6.2.414.50"},{"name":"nodejs","version":"8.12.0","date":"2018-09-10","lts":"Carbon","security":false,"v8":"6.2.414.66"},{"name":"nodejs","version":"8.13.0","date":"2018-11-20","lts":"Carbon","security":false,"v8":"6.2.414.72"},{"name":"nodejs","version":"8.14.0","date":"2018-11-27","lts":"Carbon","security":true,"v8":"6.2.414.72"},{"name":"nodejs","version":"8.15.0","date":"2018-12-26","lts":"Carbon","security":false,"v8":"6.2.414.75"},{"name":"nodejs","version":"8.16.0","date":"2019-04-16","lts":"Carbon","security":false,"v8":"6.2.414.77"},{"name":"nodejs","version":"8.17.0","date":"2019-12-17","lts":"Carbon","security":true,"v8":"6.2.414.78"},{"name":"nodejs","version":"9.0.0","date":"2017-10-31","lts":false,"security":false,"v8":"6.2.414.32"},{"name":"nodejs","version":"9.1.0","date":"2017-11-07","lts":false,"security":false,"v8":"6.2.414.32"},{"name":"nodejs","version":"9.2.0","date":"2017-11-14","lts":false,"security":false,"v8":"6.2.414.44"},{"name":"nodejs","version":"9.3.0","date":"2017-12-12","lts":false,"security":false,"v8":"6.2.414.46"},{"name":"nodejs","version":"9.4.0","date":"2018-01-10","lts":false,"security":false,"v8":"6.2.414.46"},{"name":"nodejs","version":"9.5.0","date":"2018-01-31","lts":false,"security":false,"v8":"6.2.414.46"},{"name":"nodejs","version":"9.6.0","date":"2018-02-21","lts":false,"security":false,"v8":"6.2.414.46"},{"name":"nodejs","version":"9.7.0","date":"2018-03-01","lts":false,"security":false,"v8":"6.2.414.46"},{"name":"nodejs","version":"9.8.0","date":"2018-03-07","lts":false,"security":false,"v8":"6.2.414.46"},{"name":"nodejs","version":"9.9.0","date":"2018-03-21","lts":false,"security":false,"v8":"6.2.414.46"},{"name":"nodejs","version":"9.10.0","date":"2018-03-28","lts":false,"security":true,"v8":"6.2.414.46"},{"name":"nodejs","version":"9.11.0","date":"2018-04-04","lts":false,"security":false,"v8":"6.2.414.46"},{"name":"nodejs","version":"10.0.0","date":"2018-04-24","lts":false,"security":false,"v8":"6.6.346.24"},{"name":"nodejs","version":"10.1.0","date":"2018-05-08","lts":false,"security":false,"v8":"6.6.346.27"},{"name":"nodejs","version":"10.2.0","date":"2018-05-23","lts":false,"security":false,"v8":"6.6.346.32"},{"name":"nodejs","version":"10.3.0","date":"2018-05-29","lts":false,"security":false,"v8":"6.6.346.32"},{"name":"nodejs","version":"10.4.0","date":"2018-06-06","lts":false,"security":false,"v8":"6.7.288.43"},{"name":"nodejs","version":"10.5.0","date":"2018-06-20","lts":false,"security":false,"v8":"6.7.288.46"},{"name":"nodejs","version":"10.6.0","date":"2018-07-04","lts":false,"security":false,"v8":"6.7.288.46"},{"name":"nodejs","version":"10.7.0","date":"2018-07-18","lts":false,"security":false,"v8":"6.7.288.49"},{"name":"nodejs","version":"10.8.0","date":"2018-08-01","lts":false,"security":false,"v8":"6.7.288.49"},{"name":"nodejs","version":"10.9.0","date":"2018-08-15","lts":false,"security":false,"v8":"6.8.275.24"},{"name":"nodejs","version":"10.10.0","date":"2018-09-06","lts":false,"security":false,"v8":"6.8.275.30"},{"name":"nodejs","version":"10.11.0","date":"2018-09-19","lts":false,"security":false,"v8":"6.8.275.32"},{"name":"nodejs","version":"10.12.0","date":"2018-10-10","lts":false,"security":false,"v8":"6.8.275.32"},{"name":"nodejs","version":"10.13.0","date":"2018-10-30","lts":"Dubnium","security":false,"v8":"6.8.275.32"},{"name":"nodejs","version":"10.14.0","date":"2018-11-27","lts":"Dubnium","security":true,"v8":"6.8.275.32"},{"name":"nodejs","version":"10.15.0","date":"2018-12-26","lts":"Dubnium","security":false,"v8":"6.8.275.32"},{"name":"nodejs","version":"10.16.0","date":"2019-05-28","lts":"Dubnium","security":false,"v8":"6.8.275.32"},{"name":"nodejs","version":"10.17.0","date":"2019-10-22","lts":"Dubnium","security":false,"v8":"6.8.275.32"},{"name":"nodejs","version":"10.18.0","date":"2019-12-17","lts":"Dubnium","security":true,"v8":"6.8.275.32"},{"name":"nodejs","version":"10.19.0","date":"2020-02-05","lts":"Dubnium","security":true,"v8":"6.8.275.32"},{"name":"nodejs","version":"10.20.0","date":"2020-03-26","lts":"Dubnium","security":false,"v8":"6.8.275.32"},{"name":"nodejs","version":"10.21.0","date":"2020-06-02","lts":"Dubnium","security":true,"v8":"6.8.275.32"},{"name":"nodejs","version":"10.22.0","date":"2020-07-21","lts":"Dubnium","security":false,"v8":"6.8.275.32"},{"name":"nodejs","version":"10.23.0","date":"2020-10-27","lts":"Dubnium","security":false,"v8":"6.8.275.32"},{"name":"nodejs","version":"10.24.0","date":"2021-02-23","lts":"Dubnium","security":true,"v8":"6.8.275.32"},{"name":"nodejs","version":"11.0.0","date":"2018-10-23","lts":false,"security":false,"v8":"7.0.276.28"},{"name":"nodejs","version":"11.1.0","date":"2018-10-30","lts":false,"security":false,"v8":"7.0.276.32"},{"name":"nodejs","version":"11.2.0","date":"2018-11-15","lts":false,"security":false,"v8":"7.0.276.38"},{"name":"nodejs","version":"11.3.0","date":"2018-11-27","lts":false,"security":true,"v8":"7.0.276.38"},{"name":"nodejs","version":"11.4.0","date":"2018-12-07","lts":false,"security":false,"v8":"7.0.276.38"},{"name":"nodejs","version":"11.5.0","date":"2018-12-18","lts":false,"security":false,"v8":"7.0.276.38"},{"name":"nodejs","version":"11.6.0","date":"2018-12-26","lts":false,"security":false,"v8":"7.0.276.38"},{"name":"nodejs","version":"11.7.0","date":"2019-01-17","lts":false,"security":false,"v8":"7.0.276.38"},{"name":"nodejs","version":"11.8.0","date":"2019-01-24","lts":false,"security":false,"v8":"7.0.276.38"},{"name":"nodejs","version":"11.9.0","date":"2019-01-30","lts":false,"security":false,"v8":"7.0.276.38"},{"name":"nodejs","version":"11.10.0","date":"2019-02-14","lts":false,"security":false,"v8":"7.0.276.38"},{"name":"nodejs","version":"11.11.0","date":"2019-03-05","lts":false,"security":false,"v8":"7.0.276.38"},{"name":"nodejs","version":"11.12.0","date":"2019-03-14","lts":false,"security":false,"v8":"7.0.276.38"},{"name":"nodejs","version":"11.13.0","date":"2019-03-28","lts":false,"security":false,"v8":"7.0.276.38"},{"name":"nodejs","version":"11.14.0","date":"2019-04-10","lts":false,"security":false,"v8":"7.0.276.38"},{"name":"nodejs","version":"11.15.0","date":"2019-04-30","lts":false,"security":false,"v8":"7.0.276.38"},{"name":"nodejs","version":"12.0.0","date":"2019-04-23","lts":false,"security":false,"v8":"7.4.288.21"},{"name":"nodejs","version":"12.1.0","date":"2019-04-29","lts":false,"security":false,"v8":"7.4.288.21"},{"name":"nodejs","version":"12.2.0","date":"2019-05-07","lts":false,"security":false,"v8":"7.4.288.21"},{"name":"nodejs","version":"12.3.0","date":"2019-05-21","lts":false,"security":false,"v8":"7.4.288.27"},{"name":"nodejs","version":"12.4.0","date":"2019-06-04","lts":false,"security":false,"v8":"7.4.288.27"},{"name":"nodejs","version":"12.5.0","date":"2019-06-26","lts":false,"security":false,"v8":"7.5.288.22"},{"name":"nodejs","version":"12.6.0","date":"2019-07-03","lts":false,"security":false,"v8":"7.5.288.22"},{"name":"nodejs","version":"12.7.0","date":"2019-07-23","lts":false,"security":false,"v8":"7.5.288.22"},{"name":"nodejs","version":"12.8.0","date":"2019-08-06","lts":false,"security":false,"v8":"7.5.288.22"},{"name":"nodejs","version":"12.9.0","date":"2019-08-20","lts":false,"security":false,"v8":"7.6.303.29"},{"name":"nodejs","version":"12.10.0","date":"2019-09-04","lts":false,"security":false,"v8":"7.6.303.29"},{"name":"nodejs","version":"12.11.0","date":"2019-09-25","lts":false,"security":false,"v8":"7.7.299.11"},{"name":"nodejs","version":"12.12.0","date":"2019-10-11","lts":false,"security":false,"v8":"7.7.299.13"},{"name":"nodejs","version":"12.13.0","date":"2019-10-21","lts":"Erbium","security":false,"v8":"7.7.299.13"},{"name":"nodejs","version":"12.14.0","date":"2019-12-17","lts":"Erbium","security":true,"v8":"7.7.299.13"},{"name":"nodejs","version":"12.15.0","date":"2020-02-05","lts":"Erbium","security":true,"v8":"7.7.299.13"},{"name":"nodejs","version":"12.16.0","date":"2020-02-11","lts":"Erbium","security":false,"v8":"7.8.279.23"},{"name":"nodejs","version":"12.17.0","date":"2020-05-26","lts":"Erbium","security":false,"v8":"7.8.279.23"},{"name":"nodejs","version":"12.18.0","date":"2020-06-02","lts":"Erbium","security":true,"v8":"7.8.279.23"},{"name":"nodejs","version":"12.19.0","date":"2020-10-06","lts":"Erbium","security":false,"v8":"7.8.279.23"},{"name":"nodejs","version":"12.20.0","date":"2020-11-24","lts":"Erbium","security":false,"v8":"7.8.279.23"},{"name":"nodejs","version":"12.21.0","date":"2021-02-23","lts":"Erbium","security":true,"v8":"7.8.279.23"},{"name":"nodejs","version":"12.22.0","date":"2021-03-30","lts":"Erbium","security":false,"v8":"7.8.279.23"},{"name":"nodejs","version":"13.0.0","date":"2019-10-22","lts":false,"security":false,"v8":"7.8.279.17"},{"name":"nodejs","version":"13.1.0","date":"2019-11-05","lts":false,"security":false,"v8":"7.8.279.17"},{"name":"nodejs","version":"13.2.0","date":"2019-11-21","lts":false,"security":false,"v8":"7.9.317.23"},{"name":"nodejs","version":"13.3.0","date":"2019-12-03","lts":false,"security":false,"v8":"7.9.317.25"},{"name":"nodejs","version":"13.4.0","date":"2019-12-17","lts":false,"security":true,"v8":"7.9.317.25"},{"name":"nodejs","version":"13.5.0","date":"2019-12-18","lts":false,"security":false,"v8":"7.9.317.25"},{"name":"nodejs","version":"13.6.0","date":"2020-01-07","lts":false,"security":false,"v8":"7.9.317.25"},{"name":"nodejs","version":"13.7.0","date":"2020-01-21","lts":false,"security":false,"v8":"7.9.317.25"},{"name":"nodejs","version":"13.8.0","date":"2020-02-05","lts":false,"security":true,"v8":"7.9.317.25"},{"name":"nodejs","version":"13.9.0","date":"2020-02-18","lts":false,"security":false,"v8":"7.9.317.25"},{"name":"nodejs","version":"13.10.0","date":"2020-03-04","lts":false,"security":false,"v8":"7.9.317.25"},{"name":"nodejs","version":"13.11.0","date":"2020-03-12","lts":false,"security":false,"v8":"7.9.317.25"},{"name":"nodejs","version":"13.12.0","date":"2020-03-26","lts":false,"security":false,"v8":"7.9.317.25"},{"name":"nodejs","version":"13.13.0","date":"2020-04-14","lts":false,"security":false,"v8":"7.9.317.25"},{"name":"nodejs","version":"13.14.0","date":"2020-04-29","lts":false,"security":false,"v8":"7.9.317.25"},{"name":"nodejs","version":"14.0.0","date":"2020-04-21","lts":false,"security":false,"v8":"8.1.307.30"},{"name":"nodejs","version":"14.1.0","date":"2020-04-29","lts":false,"security":false,"v8":"8.1.307.31"},{"name":"nodejs","version":"14.2.0","date":"2020-05-05","lts":false,"security":false,"v8":"8.1.307.31"},{"name":"nodejs","version":"14.3.0","date":"2020-05-19","lts":false,"security":false,"v8":"8.1.307.31"},{"name":"nodejs","version":"14.4.0","date":"2020-06-02","lts":false,"security":true,"v8":"8.1.307.31"},{"name":"nodejs","version":"14.5.0","date":"2020-06-30","lts":false,"security":false,"v8":"8.3.110.9"},{"name":"nodejs","version":"14.6.0","date":"2020-07-20","lts":false,"security":false,"v8":"8.4.371.19"},{"name":"nodejs","version":"14.7.0","date":"2020-07-29","lts":false,"security":false,"v8":"8.4.371.19"},{"name":"nodejs","version":"14.8.0","date":"2020-08-11","lts":false,"security":false,"v8":"8.4.371.19"},{"name":"nodejs","version":"14.9.0","date":"2020-08-27","lts":false,"security":false,"v8":"8.4.371.19"},{"name":"nodejs","version":"14.10.0","date":"2020-09-08","lts":false,"security":false,"v8":"8.4.371.19"},{"name":"nodejs","version":"14.11.0","date":"2020-09-15","lts":false,"security":true,"v8":"8.4.371.19"},{"name":"nodejs","version":"14.12.0","date":"2020-09-22","lts":false,"security":false,"v8":"8.4.371.19"},{"name":"nodejs","version":"14.13.0","date":"2020-09-29","lts":false,"security":false,"v8":"8.4.371.19"},{"name":"nodejs","version":"14.14.0","date":"2020-10-15","lts":false,"security":false,"v8":"8.4.371.19"},{"name":"nodejs","version":"14.15.0","date":"2020-10-27","lts":"Fermium","security":false,"v8":"8.4.371.19"},{"name":"nodejs","version":"14.16.0","date":"2021-02-23","lts":"Fermium","security":true,"v8":"8.4.371.19"},{"name":"nodejs","version":"14.17.0","date":"2021-05-11","lts":"Fermium","security":false,"v8":"8.4.371.23"},{"name":"nodejs","version":"14.18.0","date":"2021-09-28","lts":"Fermium","security":false,"v8":"8.4.371.23"},{"name":"nodejs","version":"14.19.0","date":"2022-02-01","lts":"Fermium","security":false,"v8":"8.4.371.23"},{"name":"nodejs","version":"14.20.0","date":"2022-07-07","lts":"Fermium","security":true,"v8":"8.4.371.23"},{"name":"nodejs","version":"14.21.0","date":"2022-11-01","lts":"Fermium","security":false,"v8":"8.4.371.23"},{"name":"nodejs","version":"15.0.0","date":"2020-10-20","lts":false,"security":false,"v8":"8.6.395.16"},{"name":"nodejs","version":"15.1.0","date":"2020-11-04","lts":false,"security":false,"v8":"8.6.395.17"},{"name":"nodejs","version":"15.2.0","date":"2020-11-10","lts":false,"security":false,"v8":"8.6.395.17"},{"name":"nodejs","version":"15.3.0","date":"2020-11-24","lts":false,"security":false,"v8":"8.6.395.17"},{"name":"nodejs","version":"15.4.0","date":"2020-12-09","lts":false,"security":false,"v8":"8.6.395.17"},{"name":"nodejs","version":"15.5.0","date":"2020-12-22","lts":false,"security":false,"v8":"8.6.395.17"},{"name":"nodejs","version":"15.6.0","date":"2021-01-14","lts":false,"security":false,"v8":"8.6.395.17"},{"name":"nodejs","version":"15.7.0","date":"2021-01-25","lts":false,"security":false,"v8":"8.6.395.17"},{"name":"nodejs","version":"15.8.0","date":"2021-02-02","lts":false,"security":false,"v8":"8.6.395.17"},{"name":"nodejs","version":"15.9.0","date":"2021-02-18","lts":false,"security":false,"v8":"8.6.395.17"},{"name":"nodejs","version":"15.10.0","date":"2021-02-23","lts":false,"security":true,"v8":"8.6.395.17"},{"name":"nodejs","version":"15.11.0","date":"2021-03-03","lts":false,"security":false,"v8":"8.6.395.17"},{"name":"nodejs","version":"15.12.0","date":"2021-03-17","lts":false,"security":false,"v8":"8.6.395.17"},{"name":"nodejs","version":"15.13.0","date":"2021-03-31","lts":false,"security":false,"v8":"8.6.395.17"},{"name":"nodejs","version":"15.14.0","date":"2021-04-06","lts":false,"security":false,"v8":"8.6.395.17"},{"name":"nodejs","version":"16.0.0","date":"2021-04-20","lts":false,"security":false,"v8":"9.0.257.17"},{"name":"nodejs","version":"16.1.0","date":"2021-05-04","lts":false,"security":false,"v8":"9.0.257.24"},{"name":"nodejs","version":"16.2.0","date":"2021-05-19","lts":false,"security":false,"v8":"9.0.257.25"},{"name":"nodejs","version":"16.3.0","date":"2021-06-03","lts":false,"security":false,"v8":"9.0.257.25"},{"name":"nodejs","version":"16.4.0","date":"2021-06-23","lts":false,"security":false,"v8":"9.1.269.36"},{"name":"nodejs","version":"16.5.0","date":"2021-07-14","lts":false,"security":false,"v8":"9.1.269.38"},{"name":"nodejs","version":"16.6.0","date":"2021-07-29","lts":false,"security":true,"v8":"9.2.230.21"},{"name":"nodejs","version":"16.7.0","date":"2021-08-18","lts":false,"security":false,"v8":"9.2.230.21"},{"name":"nodejs","version":"16.8.0","date":"2021-08-25","lts":false,"security":false,"v8":"9.2.230.21"},{"name":"nodejs","version":"16.9.0","date":"2021-09-07","lts":false,"security":false,"v8":"9.3.345.16"},{"name":"nodejs","version":"16.10.0","date":"2021-09-22","lts":false,"security":false,"v8":"9.3.345.19"},{"name":"nodejs","version":"16.11.0","date":"2021-10-08","lts":false,"security":false,"v8":"9.4.146.19"},{"name":"nodejs","version":"16.12.0","date":"2021-10-20","lts":false,"security":false,"v8":"9.4.146.19"},{"name":"nodejs","version":"16.13.0","date":"2021-10-26","lts":"Gallium","security":false,"v8":"9.4.146.19"},{"name":"nodejs","version":"16.14.0","date":"2022-02-08","lts":"Gallium","security":false,"v8":"9.4.146.24"},{"name":"nodejs","version":"16.15.0","date":"2022-04-26","lts":"Gallium","security":false,"v8":"9.4.146.24"},{"name":"nodejs","version":"16.16.0","date":"2022-07-07","lts":"Gallium","security":true,"v8":"9.4.146.24"},{"name":"nodejs","version":"16.17.0","date":"2022-08-16","lts":"Gallium","security":false,"v8":"9.4.146.26"},{"name":"nodejs","version":"16.18.0","date":"2022-10-12","lts":"Gallium","security":false,"v8":"9.4.146.26"},{"name":"nodejs","version":"16.19.0","date":"2022-12-13","lts":"Gallium","security":false,"v8":"9.4.146.26"},{"name":"nodejs","version":"16.20.0","date":"2023-03-28","lts":"Gallium","security":false,"v8":"9.4.146.26"},{"name":"nodejs","version":"17.0.0","date":"2021-10-19","lts":false,"security":false,"v8":"9.5.172.21"},{"name":"nodejs","version":"17.1.0","date":"2021-11-09","lts":false,"security":false,"v8":"9.5.172.25"},{"name":"nodejs","version":"17.2.0","date":"2021-11-30","lts":false,"security":false,"v8":"9.6.180.14"},{"name":"nodejs","version":"17.3.0","date":"2021-12-17","lts":false,"security":false,"v8":"9.6.180.15"},{"name":"nodejs","version":"17.4.0","date":"2022-01-18","lts":false,"security":false,"v8":"9.6.180.15"},{"name":"nodejs","version":"17.5.0","date":"2022-02-10","lts":false,"security":false,"v8":"9.6.180.15"},{"name":"nodejs","version":"17.6.0","date":"2022-02-22","lts":false,"security":false,"v8":"9.6.180.15"},{"name":"nodejs","version":"17.7.0","date":"2022-03-09","lts":false,"security":false,"v8":"9.6.180.15"},{"name":"nodejs","version":"17.8.0","date":"2022-03-22","lts":false,"security":false,"v8":"9.6.180.15"},{"name":"nodejs","version":"17.9.0","date":"2022-04-07","lts":false,"security":false,"v8":"9.6.180.15"},{"name":"nodejs","version":"18.0.0","date":"2022-04-18","lts":false,"security":false,"v8":"10.1.124.8"},{"name":"nodejs","version":"18.1.0","date":"2022-05-03","lts":false,"security":false,"v8":"10.1.124.8"},{"name":"nodejs","version":"18.2.0","date":"2022-05-17","lts":false,"security":false,"v8":"10.1.124.8"},{"name":"nodejs","version":"18.3.0","date":"2022-06-02","lts":false,"security":false,"v8":"10.2.154.4"},{"name":"nodejs","version":"18.4.0","date":"2022-06-16","lts":false,"security":false,"v8":"10.2.154.4"},{"name":"nodejs","version":"18.5.0","date":"2022-07-06","lts":false,"security":true,"v8":"10.2.154.4"},{"name":"nodejs","version":"18.6.0","date":"2022-07-13","lts":false,"security":false,"v8":"10.2.154.13"},{"name":"nodejs","version":"18.7.0","date":"2022-07-26","lts":false,"security":false,"v8":"10.2.154.13"},{"name":"nodejs","version":"18.8.0","date":"2022-08-24","lts":false,"security":false,"v8":"10.2.154.13"},{"name":"nodejs","version":"18.9.0","date":"2022-09-07","lts":false,"security":false,"v8":"10.2.154.15"},{"name":"nodejs","version":"18.10.0","date":"2022-09-28","lts":false,"security":false,"v8":"10.2.154.15"},{"name":"nodejs","version":"18.11.0","date":"2022-10-13","lts":false,"security":false,"v8":"10.2.154.15"},{"name":"nodejs","version":"18.12.0","date":"2022-10-25","lts":"Hydrogen","security":false,"v8":"10.2.154.15"},{"name":"nodejs","version":"18.13.0","date":"2023-01-05","lts":"Hydrogen","security":false,"v8":"10.2.154.23"},{"name":"nodejs","version":"18.14.0","date":"2023-02-01","lts":"Hydrogen","security":false,"v8":"10.2.154.23"},{"name":"nodejs","version":"18.15.0","date":"2023-03-05","lts":"Hydrogen","security":false,"v8":"10.2.154.26"},{"name":"nodejs","version":"18.16.0","date":"2023-04-12","lts":"Hydrogen","security":false,"v8":"10.2.154.26"},{"name":"nodejs","version":"18.17.0","date":"2023-07-18","lts":"Hydrogen","security":false,"v8":"10.2.154.26"},{"name":"nodejs","version":"18.18.0","date":"2023-09-18","lts":"Hydrogen","security":false,"v8":"10.2.154.26"},{"name":"nodejs","version":"18.19.0","date":"2023-11-29","lts":"Hydrogen","security":false,"v8":"10.2.154.26"},{"name":"nodejs","version":"19.0.0","date":"2022-10-17","lts":false,"security":false,"v8":"10.7.193.13"},{"name":"nodejs","version":"19.1.0","date":"2022-11-14","lts":false,"security":false,"v8":"10.7.193.20"},{"name":"nodejs","version":"19.2.0","date":"2022-11-29","lts":false,"security":false,"v8":"10.8.168.20"},{"name":"nodejs","version":"19.3.0","date":"2022-12-14","lts":false,"security":false,"v8":"10.8.168.21"},{"name":"nodejs","version":"19.4.0","date":"2023-01-05","lts":false,"security":false,"v8":"10.8.168.25"},{"name":"nodejs","version":"19.5.0","date":"2023-01-24","lts":false,"security":false,"v8":"10.8.168.25"},{"name":"nodejs","version":"19.6.0","date":"2023-02-01","lts":false,"security":false,"v8":"10.8.168.25"},{"name":"nodejs","version":"19.7.0","date":"2023-02-21","lts":false,"security":false,"v8":"10.8.168.25"},{"name":"nodejs","version":"19.8.0","date":"2023-03-14","lts":false,"security":false,"v8":"10.8.168.25"},{"name":"nodejs","version":"19.9.0","date":"2023-04-10","lts":false,"security":false,"v8":"10.8.168.25"},{"name":"nodejs","version":"20.0.0","date":"2023-04-17","lts":false,"security":false,"v8":"11.3.244.4"},{"name":"nodejs","version":"20.1.0","date":"2023-05-03","lts":false,"security":false,"v8":"11.3.244.8"},{"name":"nodejs","version":"20.2.0","date":"2023-05-16","lts":false,"security":false,"v8":"11.3.244.8"},{"name":"nodejs","version":"20.3.0","date":"2023-06-08","lts":false,"security":false,"v8":"11.3.244.8"},{"name":"nodejs","version":"20.4.0","date":"2023-07-04","lts":false,"security":false,"v8":"11.3.244.8"},{"name":"nodejs","version":"20.5.0","date":"2023-07-19","lts":false,"security":false,"v8":"11.3.244.8"},{"name":"nodejs","version":"20.6.0","date":"2023-08-23","lts":false,"security":false,"v8":"11.3.244.8"},{"name":"nodejs","version":"20.7.0","date":"2023-09-18","lts":false,"security":false,"v8":"11.3.244.8"},{"name":"nodejs","version":"20.8.0","date":"2023-09-28","lts":false,"security":false,"v8":"11.3.244.8"},{"name":"nodejs","version":"20.9.0","date":"2023-10-24","lts":"Iron","security":false,"v8":"11.3.244.8"},{"name":"nodejs","version":"20.10.0","date":"2023-11-22","lts":"Iron","security":false,"v8":"11.3.244.8"},{"name":"nodejs","version":"21.0.0","date":"2023-10-17","lts":false,"security":false,"v8":"11.8.172.13"},{"name":"nodejs","version":"21.1.0","date":"2023-10-24","lts":false,"security":false,"v8":"11.8.172.15"},{"name":"nodejs","version":"21.2.0","date":"2023-11-14","lts":false,"security":false,"v8":"11.8.172.17"},{"name":"nodejs","version":"21.3.0","date":"2023-11-30","lts":false,"security":false,"v8":"11.8.172.17"}]');

});

parcelRegister("lH4v9", function(module, exports) {

$parcel$export(module.exports, "agents", () => $fcb11b0a21633421$export$ac5be7df5fa52a3c, (v) => $fcb11b0a21633421$export$ac5be7df5fa52a3c = v);
var $fcb11b0a21633421$export$ac5be7df5fa52a3c;
"use strict";

var $gqNcL = parcelRequire("gqNcL");
var $fcb11b0a21633421$require$browsers = $gqNcL.browsers;

var $fefiJ = parcelRequire("fefiJ");
var $fcb11b0a21633421$require$versions = $fefiJ.browserVersions;

var $4WvAA = parcelRequire("4WvAA");
function $fcb11b0a21633421$var$unpackBrowserVersions(versionsData) {
    return Object.keys(versionsData).reduce((usage, version)=>{
        usage[$fcb11b0a21633421$require$versions[version]] = versionsData[version];
        return usage;
    }, {});
}
$fcb11b0a21633421$export$ac5be7df5fa52a3c = Object.keys($4WvAA).reduce((map, key)=>{
    let versionsData = $4WvAA[key];
    map[$fcb11b0a21633421$require$browsers[key]] = Object.keys(versionsData).reduce((data, entry)=>{
        if (entry === "A") data.usage_global = $fcb11b0a21633421$var$unpackBrowserVersions(versionsData[entry]);
        else if (entry === "C") data.versions = versionsData[entry].reduce((list, version)=>{
            if (version === "") list.push(null);
            else list.push($fcb11b0a21633421$require$versions[version]);
            return list;
        }, []);
        else if (entry === "D") data.prefix_exceptions = $fcb11b0a21633421$var$unpackBrowserVersions(versionsData[entry]);
        else if (entry === "E") data.browser = versionsData[entry];
        else if (entry === "F") data.release_date = Object.keys(versionsData[entry]).reduce((map2, key2)=>{
            map2[$fcb11b0a21633421$require$versions[key2]] = versionsData[entry][key2];
            return map2;
        }, {});
        else // entry is B
        data.prefix = versionsData[entry];
        return data;
    }, {});
    return map;
}, {});

});
parcelRegister("gqNcL", function(module, exports) {

$parcel$export(module.exports, "browsers", () => $bf653e1e26470d5a$export$804348712f697b1b, (v) => $bf653e1e26470d5a$export$804348712f697b1b = v);
var $bf653e1e26470d5a$export$804348712f697b1b;

$bf653e1e26470d5a$export$804348712f697b1b = (parcelRequire("7VP0u"));

});
parcelRegister("7VP0u", function(module, exports) {
module.exports = {
    A: "ie",
    B: "edge",
    C: "firefox",
    D: "chrome",
    E: "safari",
    F: "opera",
    G: "ios_saf",
    H: "op_mini",
    I: "android",
    J: "bb",
    K: "op_mob",
    L: "and_chr",
    M: "and_ff",
    N: "ie_mob",
    O: "and_uc",
    P: "samsung",
    Q: "and_qq",
    R: "baidu",
    S: "kaios"
};

});


parcelRegister("fefiJ", function(module, exports) {

$parcel$export(module.exports, "browserVersions", () => $b164084c9ea46f7e$export$e0222f875ebd697e, (v) => $b164084c9ea46f7e$export$e0222f875ebd697e = v);
var $b164084c9ea46f7e$export$e0222f875ebd697e;

$b164084c9ea46f7e$export$e0222f875ebd697e = (parcelRequire("7KwPM"));

});
parcelRegister("7KwPM", function(module, exports) {
module.exports = {
    "0": "113",
    "1": "114",
    "2": "115",
    "3": "116",
    "4": "117",
    "5": "118",
    "6": "119",
    "7": "120",
    "8": "121",
    "9": "5",
    A: "10",
    B: "11",
    C: "12",
    D: "7",
    E: "8",
    F: "9",
    G: "15",
    H: "80",
    I: "122",
    J: "4",
    K: "6",
    L: "13",
    M: "14",
    N: "16",
    O: "17",
    P: "18",
    Q: "79",
    R: "81",
    S: "83",
    T: "84",
    U: "85",
    V: "86",
    W: "87",
    X: "88",
    Y: "89",
    Z: "90",
    a: "91",
    b: "92",
    c: "93",
    d: "94",
    e: "95",
    f: "96",
    g: "97",
    h: "98",
    i: "99",
    j: "100",
    k: "101",
    l: "102",
    m: "103",
    n: "104",
    o: "105",
    p: "106",
    q: "107",
    r: "108",
    s: "20",
    t: "21",
    u: "22",
    v: "23",
    w: "109",
    x: "110",
    y: "111",
    z: "112",
    AB: "19",
    BB: "24",
    CB: "25",
    DB: "26",
    EB: "27",
    FB: "28",
    GB: "29",
    HB: "30",
    IB: "31",
    JB: "32",
    KB: "33",
    LB: "34",
    MB: "35",
    NB: "36",
    OB: "37",
    PB: "38",
    QB: "39",
    RB: "40",
    SB: "41",
    TB: "42",
    UB: "43",
    VB: "44",
    WB: "45",
    XB: "46",
    YB: "47",
    ZB: "48",
    aB: "49",
    bB: "50",
    cB: "51",
    dB: "52",
    eB: "53",
    fB: "54",
    gB: "55",
    hB: "56",
    iB: "57",
    jB: "58",
    kB: "60",
    lB: "62",
    mB: "63",
    nB: "64",
    oB: "65",
    pB: "66",
    qB: "67",
    rB: "68",
    sB: "69",
    tB: "70",
    uB: "71",
    vB: "72",
    wB: "73",
    xB: "74",
    yB: "75",
    zB: "76",
    "0B": "77",
    "1B": "78",
    "2B": "123",
    "3B": "11.1",
    "4B": "12.1",
    "5B": "15.5",
    "6B": "16.0",
    "7B": "17.0",
    "8B": "3",
    "9B": "59",
    AC: "61",
    BC: "82",
    CC: "124",
    DC: "125",
    EC: "3.2",
    FC: "10.1",
    GC: "15.2-15.3",
    HC: "15.4",
    IC: "16.1",
    JC: "16.2",
    KC: "16.3",
    LC: "16.4",
    MC: "16.5",
    NC: "17.1",
    OC: "17.2",
    PC: "17.3",
    QC: "17.4",
    RC: "11.5",
    SC: "4.2-4.3",
    TC: "5.5",
    UC: "2",
    VC: "126",
    WC: "3.5",
    XC: "3.6",
    YC: "3.1",
    ZC: "5.1",
    aC: "6.1",
    bC: "7.1",
    cC: "9.1",
    dC: "13.1",
    eC: "14.1",
    fC: "15.1",
    gC: "15.6",
    hC: "16.6",
    iC: "TP",
    jC: "9.5-9.6",
    kC: "10.0-10.1",
    lC: "10.5",
    mC: "10.6",
    nC: "11.6",
    oC: "4.0-4.1",
    pC: "5.0-5.1",
    qC: "6.0-6.1",
    rC: "7.0-7.1",
    sC: "8.1-8.4",
    tC: "9.0-9.2",
    uC: "9.3",
    vC: "10.0-10.2",
    wC: "10.3",
    xC: "11.0-11.2",
    yC: "11.3-11.4",
    zC: "12.0-12.1",
    "0C": "12.2-12.5",
    "1C": "13.0-13.1",
    "2C": "13.2",
    "3C": "13.3",
    "4C": "13.4-13.7",
    "5C": "14.0-14.4",
    "6C": "14.5-14.8",
    "7C": "15.0-15.1",
    "8C": "15.6-15.8",
    "9C": "16.6-16.7",
    AD: "all",
    BD: "2.1",
    CD: "2.2",
    DD: "2.3",
    ED: "4.1",
    FD: "4.4",
    GD: "4.4.3-4.4.4",
    HD: "5.0-5.4",
    ID: "6.2-6.4",
    JD: "7.2-7.4",
    KD: "8.2",
    LD: "9.2",
    MD: "11.1-11.2",
    ND: "12.0",
    OD: "13.0",
    PD: "14.0",
    QD: "15.0",
    RD: "18.0",
    SD: "19.0",
    TD: "14.9",
    UD: "13.52",
    VD: "2.5",
    WD: "3.0-3.1"
};

});


parcelRegister("4WvAA", function(module, exports) {
module.exports = {
    A: {
        A: {
            K: 0,
            D: 0,
            E: 0.0155495,
            F: 0.0466486,
            A: 0,
            B: 0.450937,
            TC: 0
        },
        B: "ms",
        C: [
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "TC",
            "K",
            "D",
            "E",
            "F",
            "A",
            "B",
            "",
            "",
            ""
        ],
        E: "IE",
        F: {
            TC: 962323200,
            K: 998870400,
            D: 1161129600,
            E: 1237420800,
            F: 1300060800,
            A: 1346716800,
            B: 1381968000
        }
    },
    B: {
        A: {
            "0": 0.015204,
            "1": 0.019005,
            "2": 0.011403,
            "3": 0.011403,
            "4": 0.015204,
            "5": 0.022806,
            "6": 0.133035,
            "7": 0.277473,
            "8": 3.58054,
            C: 0.003801,
            L: 0,
            M: 0.003801,
            G: 0.003801,
            N: 0,
            O: 0.007602,
            P: 0.011403,
            Q: 0,
            H: 0,
            R: 0,
            S: 0,
            T: 0,
            U: 0,
            V: 0,
            W: 0.053214,
            X: 0,
            Y: 0,
            Z: 0,
            a: 0,
            b: 0.011403,
            c: 0,
            d: 0,
            e: 0,
            f: 0,
            g: 0,
            h: 0,
            i: 0.011403,
            j: 0,
            k: 0,
            l: 0,
            m: 0,
            n: 0,
            o: 0,
            p: 0.003801,
            q: 0.007602,
            r: 0.007602,
            w: 0.068418,
            x: 0.007602,
            y: 0.007602,
            z: 0.007602,
            I: 0.551145
        },
        B: "webkit",
        C: [
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "C",
            "L",
            "M",
            "G",
            "N",
            "O",
            "P",
            "Q",
            "H",
            "R",
            "S",
            "T",
            "U",
            "V",
            "W",
            "X",
            "Y",
            "Z",
            "a",
            "b",
            "c",
            "d",
            "e",
            "f",
            "g",
            "h",
            "i",
            "j",
            "k",
            "l",
            "m",
            "n",
            "o",
            "p",
            "q",
            "r",
            "w",
            "x",
            "y",
            "z",
            "0",
            "1",
            "2",
            "3",
            "4",
            "5",
            "6",
            "7",
            "8",
            "I",
            "",
            "",
            ""
        ],
        E: "Edge",
        F: {
            "0": 1683158400,
            "1": 1685664000,
            "2": 1689897600,
            "3": 1692576000,
            "4": 1694649600,
            "5": 1697155200,
            "6": 1698969600,
            "7": 1701993600,
            "8": 1706227200,
            C: 1438128000,
            L: 1447286400,
            M: 1470096000,
            G: 1491868800,
            N: 1508198400,
            O: 1525046400,
            P: 1542067200,
            Q: 1579046400,
            H: 1581033600,
            R: 1586736000,
            S: 1590019200,
            T: 1594857600,
            U: 1598486400,
            V: 1602201600,
            W: 1605830400,
            X: 1611360000,
            Y: 1614816000,
            Z: 1618358400,
            a: 1622073600,
            b: 1626912000,
            c: 1630627200,
            d: 1632441600,
            e: 1634774400,
            f: 1637539200,
            g: 1641427200,
            h: 1643932800,
            i: 1646265600,
            j: 1649635200,
            k: 1651190400,
            l: 1653955200,
            m: 1655942400,
            n: 1659657600,
            o: 1661990400,
            p: 1664755200,
            q: 1666915200,
            r: 1670198400,
            w: 1673481600,
            x: 1675900800,
            y: 1678665600,
            z: 1680825600,
            I: 1708732800
        },
        D: {
            C: "ms",
            L: "ms",
            M: "ms",
            G: "ms",
            N: "ms",
            O: "ms",
            P: "ms"
        }
    },
    C: {
        A: {
            "0": 0.007602,
            "1": 0.007602,
            "2": 0.429513,
            "3": 0.003801,
            "4": 0.011403,
            "5": 0.095025,
            "6": 0.110229,
            "7": 0.106428,
            "8": 0.064617,
            "9": 0,
            UC: 0,
            "8B": 0,
            J: 0.003801,
            K: 0,
            D: 0,
            E: 0,
            F: 0,
            A: 0,
            B: 0.034209,
            C: 0.019005,
            L: 0,
            M: 0,
            G: 0,
            N: 0,
            O: 0,
            P: 0,
            AB: 0,
            s: 0,
            t: 0,
            u: 0,
            v: 0,
            BB: 0,
            CB: 0,
            DB: 0,
            EB: 0,
            FB: 0,
            GB: 0,
            HB: 0,
            IB: 0,
            JB: 0,
            KB: 0,
            LB: 0,
            MB: 0,
            NB: 0,
            OB: 0,
            PB: 0,
            QB: 0,
            RB: 0,
            SB: 0,
            TB: 0,
            UB: 0.007602,
            VB: 0.007602,
            WB: 0.003801,
            XB: 0,
            YB: 0,
            ZB: 0,
            aB: 0,
            bB: 0.007602,
            cB: 0,
            dB: 0.053214,
            eB: 0.007602,
            fB: 0.007602,
            gB: 0.003801,
            hB: 0.019005,
            iB: 0,
            jB: 0,
            "9B": 0.003801,
            kB: 0,
            AC: 0,
            lB: 0,
            mB: 0,
            nB: 0,
            oB: 0,
            pB: 0,
            qB: 0,
            rB: 0,
            sB: 0,
            tB: 0,
            uB: 0,
            vB: 0.003801,
            wB: 0,
            xB: 0,
            yB: 0,
            zB: 0,
            "0B": 0,
            "1B": 0.015204,
            Q: 0,
            H: 0,
            R: 0,
            BC: 0,
            S: 0,
            T: 0,
            U: 0,
            V: 0,
            W: 0,
            X: 0.011403,
            Y: 0,
            Z: 0,
            a: 0.007602,
            b: 0,
            c: 0,
            d: 0.003801,
            e: 0,
            f: 0,
            g: 0,
            h: 0,
            i: 0,
            j: 0,
            k: 0.003801,
            l: 0.022806,
            m: 0.030408,
            n: 0,
            o: 0.003801,
            p: 0,
            q: 0.003801,
            r: 0.003801,
            w: 0.007602,
            x: 0.003801,
            y: 0,
            z: 0.003801,
            I: 1.1593,
            "2B": 0.349692,
            CC: 0,
            DC: 0,
            VC: 0,
            WC: 0,
            XC: 0
        },
        B: "moz",
        C: [
            "UC",
            "8B",
            "WC",
            "XC",
            "J",
            "9",
            "K",
            "D",
            "E",
            "F",
            "A",
            "B",
            "C",
            "L",
            "M",
            "G",
            "N",
            "O",
            "P",
            "AB",
            "s",
            "t",
            "u",
            "v",
            "BB",
            "CB",
            "DB",
            "EB",
            "FB",
            "GB",
            "HB",
            "IB",
            "JB",
            "KB",
            "LB",
            "MB",
            "NB",
            "OB",
            "PB",
            "QB",
            "RB",
            "SB",
            "TB",
            "UB",
            "VB",
            "WB",
            "XB",
            "YB",
            "ZB",
            "aB",
            "bB",
            "cB",
            "dB",
            "eB",
            "fB",
            "gB",
            "hB",
            "iB",
            "jB",
            "9B",
            "kB",
            "AC",
            "lB",
            "mB",
            "nB",
            "oB",
            "pB",
            "qB",
            "rB",
            "sB",
            "tB",
            "uB",
            "vB",
            "wB",
            "xB",
            "yB",
            "zB",
            "0B",
            "1B",
            "Q",
            "H",
            "R",
            "BC",
            "S",
            "T",
            "U",
            "V",
            "W",
            "X",
            "Y",
            "Z",
            "a",
            "b",
            "c",
            "d",
            "e",
            "f",
            "g",
            "h",
            "i",
            "j",
            "k",
            "l",
            "m",
            "n",
            "o",
            "p",
            "q",
            "r",
            "w",
            "x",
            "y",
            "z",
            "0",
            "1",
            "2",
            "3",
            "4",
            "5",
            "6",
            "7",
            "8",
            "I",
            "2B",
            "CC",
            "DC",
            "VC"
        ],
        E: "Firefox",
        F: {
            "0": 1683590400,
            "1": 1686009600,
            "2": 1688428800,
            "3": 1690848000,
            "4": 1693267200,
            "5": 1695686400,
            "6": 1698105600,
            "7": 1700524800,
            "8": 1702944000,
            "9": 1308614400,
            UC: 1161648000,
            "8B": 1213660800,
            WC: 1246320000,
            XC: 1264032000,
            J: 1300752000,
            K: 1313452800,
            D: 1317081600,
            E: 1317081600,
            F: 1320710400,
            A: 1324339200,
            B: 1327968000,
            C: 1331596800,
            L: 1335225600,
            M: 1338854400,
            G: 1342483200,
            N: 1346112000,
            O: 1349740800,
            P: 1353628800,
            AB: 1357603200,
            s: 1361232000,
            t: 1364860800,
            u: 1368489600,
            v: 1372118400,
            BB: 1375747200,
            CB: 1379376000,
            DB: 1386633600,
            EB: 1391472000,
            FB: 1395100800,
            GB: 1398729600,
            HB: 1402358400,
            IB: 1405987200,
            JB: 1409616000,
            KB: 1413244800,
            LB: 1417392000,
            MB: 1421107200,
            NB: 1424736000,
            OB: 1428278400,
            PB: 1431475200,
            QB: 1435881600,
            RB: 1439251200,
            SB: 1442880000,
            TB: 1446508800,
            UB: 1450137600,
            VB: 1453852800,
            WB: 1457395200,
            XB: 1461628800,
            YB: 1465257600,
            ZB: 1470096000,
            aB: 1474329600,
            bB: 1479168000,
            cB: 1485216000,
            dB: 1488844800,
            eB: 1492560000,
            fB: 1497312000,
            gB: 1502150400,
            hB: 1506556800,
            iB: 1510617600,
            jB: 1516665600,
            "9B": 1520985600,
            kB: 1525824000,
            AC: 1529971200,
            lB: 1536105600,
            mB: 1540252800,
            nB: 1544486400,
            oB: 1548720000,
            pB: 1552953600,
            qB: 1558396800,
            rB: 1562630400,
            sB: 1567468800,
            tB: 1571788800,
            uB: 1575331200,
            vB: 1578355200,
            wB: 1581379200,
            xB: 1583798400,
            yB: 1586304000,
            zB: 1588636800,
            "0B": 1591056000,
            "1B": 1593475200,
            Q: 1595894400,
            H: 1598313600,
            R: 1600732800,
            BC: 1603152000,
            S: 1605571200,
            T: 1607990400,
            U: 1611619200,
            V: 1614038400,
            W: 1616457600,
            X: 1618790400,
            Y: 1622505600,
            Z: 1626134400,
            a: 1628553600,
            b: 1630972800,
            c: 1633392000,
            d: 1635811200,
            e: 1638835200,
            f: 1641859200,
            g: 1644364800,
            h: 1646697600,
            i: 1649116800,
            j: 1651536000,
            k: 1653955200,
            l: 1656374400,
            m: 1658793600,
            n: 1661212800,
            o: 1663632000,
            p: 1666051200,
            q: 1668470400,
            r: 1670889600,
            w: 1673913600,
            x: 1676332800,
            y: 1678752000,
            z: 1681171200,
            I: 1705968000,
            "2B": 1708387200,
            CC: null,
            DC: null,
            VC: null
        }
    },
    D: {
        A: {
            "0": 0.106428,
            "1": 0.102627,
            "2": 0.057015,
            "3": 0.250866,
            "4": 0.155841,
            "5": 0.273672,
            "6": 1.10229,
            "7": 2.08675,
            "8": 13.6988,
            "9": 0,
            J: 0,
            K: 0,
            D: 0,
            E: 0,
            F: 0,
            A: 0,
            B: 0,
            C: 0,
            L: 0,
            M: 0,
            G: 0,
            N: 0,
            O: 0,
            P: 0,
            AB: 0,
            s: 0,
            t: 0,
            u: 0,
            v: 0,
            BB: 0,
            CB: 0,
            DB: 0,
            EB: 0,
            FB: 0,
            GB: 0,
            HB: 0,
            IB: 0,
            JB: 0,
            KB: 0,
            LB: 0.003801,
            MB: 0,
            NB: 0,
            OB: 0,
            PB: 0.015204,
            QB: 0,
            RB: 0,
            SB: 0,
            TB: 0,
            UB: 0,
            VB: 0,
            WB: 0,
            XB: 0,
            YB: 0.007602,
            ZB: 0.030408,
            aB: 0.026607,
            bB: 0.011403,
            cB: 0,
            dB: 0,
            eB: 0.003801,
            fB: 0.003801,
            gB: 0.003801,
            hB: 0.011403,
            iB: 0.007602,
            jB: 0,
            "9B": 0,
            kB: 0.019005,
            AC: 0.011403,
            lB: 0,
            mB: 0.003801,
            nB: 0,
            oB: 0.003801,
            pB: 0.026607,
            qB: 0.003801,
            rB: 0.003801,
            sB: 0.034209,
            tB: 0.049413,
            uB: 0.007602,
            vB: 0.003801,
            wB: 0.007602,
            xB: 0.007602,
            yB: 0.007602,
            zB: 0.007602,
            "0B": 0.011403,
            "1B": 0.015204,
            Q: 0.11403,
            H: 0.015204,
            R: 0.030408,
            S: 0.03801,
            T: 0.007602,
            U: 0.022806,
            V: 0.03801,
            W: 0.079821,
            X: 0.019005,
            Y: 0.019005,
            Z: 0.015204,
            a: 0.057015,
            b: 0.026607,
            c: 0.049413,
            d: 0.045612,
            e: 0.011403,
            f: 0.011403,
            g: 0.019005,
            h: 0.072219,
            i: 0.034209,
            j: 0.030408,
            k: 0.041811,
            l: 0.034209,
            m: 0.144438,
            n: 0.03801,
            o: 0.030408,
            p: 0.041811,
            q: 0.034209,
            r: 0.060816,
            w: 1.62303,
            x: 0.049413,
            y: 0.057015,
            z: 0.053214,
            I: 1.87769,
            "2B": 0.019005,
            CC: 0.003801,
            DC: 0
        },
        B: "webkit",
        C: [
            "",
            "",
            "",
            "",
            "",
            "",
            "J",
            "9",
            "K",
            "D",
            "E",
            "F",
            "A",
            "B",
            "C",
            "L",
            "M",
            "G",
            "N",
            "O",
            "P",
            "AB",
            "s",
            "t",
            "u",
            "v",
            "BB",
            "CB",
            "DB",
            "EB",
            "FB",
            "GB",
            "HB",
            "IB",
            "JB",
            "KB",
            "LB",
            "MB",
            "NB",
            "OB",
            "PB",
            "QB",
            "RB",
            "SB",
            "TB",
            "UB",
            "VB",
            "WB",
            "XB",
            "YB",
            "ZB",
            "aB",
            "bB",
            "cB",
            "dB",
            "eB",
            "fB",
            "gB",
            "hB",
            "iB",
            "jB",
            "9B",
            "kB",
            "AC",
            "lB",
            "mB",
            "nB",
            "oB",
            "pB",
            "qB",
            "rB",
            "sB",
            "tB",
            "uB",
            "vB",
            "wB",
            "xB",
            "yB",
            "zB",
            "0B",
            "1B",
            "Q",
            "H",
            "R",
            "S",
            "T",
            "U",
            "V",
            "W",
            "X",
            "Y",
            "Z",
            "a",
            "b",
            "c",
            "d",
            "e",
            "f",
            "g",
            "h",
            "i",
            "j",
            "k",
            "l",
            "m",
            "n",
            "o",
            "p",
            "q",
            "r",
            "w",
            "x",
            "y",
            "z",
            "0",
            "1",
            "2",
            "3",
            "4",
            "5",
            "6",
            "7",
            "8",
            "I",
            "2B",
            "CC",
            "DC"
        ],
        E: "Chrome",
        F: {
            "0": 1682985600,
            "1": 1685404800,
            "2": 1689724800,
            "3": 1692057600,
            "4": 1694476800,
            "5": 1696896000,
            "6": 1698710400,
            "7": 1701993600,
            "8": 1705968000,
            "9": 1274745600,
            J: 1264377600,
            K: 1283385600,
            D: 1287619200,
            E: 1291248000,
            F: 1296777600,
            A: 1299542400,
            B: 1303862400,
            C: 1307404800,
            L: 1312243200,
            M: 1316131200,
            G: 1316131200,
            N: 1319500800,
            O: 1323734400,
            P: 1328659200,
            AB: 1332892800,
            s: 1337040000,
            t: 1340668800,
            u: 1343692800,
            v: 1348531200,
            BB: 1352246400,
            CB: 1357862400,
            DB: 1361404800,
            EB: 1364428800,
            FB: 1369094400,
            GB: 1374105600,
            HB: 1376956800,
            IB: 1384214400,
            JB: 1389657600,
            KB: 1392940800,
            LB: 1397001600,
            MB: 1400544000,
            NB: 1405468800,
            OB: 1409011200,
            PB: 1412640000,
            QB: 1416268800,
            RB: 1421798400,
            SB: 1425513600,
            TB: 1429401600,
            UB: 1432080000,
            VB: 1437523200,
            WB: 1441152000,
            XB: 1444780800,
            YB: 1449014400,
            ZB: 1453248000,
            aB: 1456963200,
            bB: 1460592000,
            cB: 1464134400,
            dB: 1469059200,
            eB: 1472601600,
            fB: 1476230400,
            gB: 1480550400,
            hB: 1485302400,
            iB: 1489017600,
            jB: 1492560000,
            "9B": 1496707200,
            kB: 1500940800,
            AC: 1504569600,
            lB: 1508198400,
            mB: 1512518400,
            nB: 1516752000,
            oB: 1520294400,
            pB: 1523923200,
            qB: 1527552000,
            rB: 1532390400,
            sB: 1536019200,
            tB: 1539648000,
            uB: 1543968000,
            vB: 1548720000,
            wB: 1552348800,
            xB: 1555977600,
            yB: 1559606400,
            zB: 1564444800,
            "0B": 1568073600,
            "1B": 1571702400,
            Q: 1575936000,
            H: 1580860800,
            R: 1586304000,
            S: 1589846400,
            T: 1594684800,
            U: 1598313600,
            V: 1601942400,
            W: 1605571200,
            X: 1611014400,
            Y: 1614556800,
            Z: 1618272000,
            a: 1621987200,
            b: 1626739200,
            c: 1630368000,
            d: 1632268800,
            e: 1634601600,
            f: 1637020800,
            g: 1641340800,
            h: 1643673600,
            i: 1646092800,
            j: 1648512000,
            k: 1650931200,
            l: 1653350400,
            m: 1655769600,
            n: 1659398400,
            o: 1661817600,
            p: 1664236800,
            q: 1666656000,
            r: 1669680000,
            w: 1673308800,
            x: 1675728000,
            y: 1678147200,
            z: 1680566400,
            I: 1708387200,
            "2B": null,
            CC: null,
            DC: null
        }
    },
    E: {
        A: {
            "9": 0,
            J: 0,
            K: 0,
            D: 0,
            E: 0.003801,
            F: 0.003801,
            A: 0,
            B: 0,
            C: 0,
            L: 0.007602,
            M: 0.03801,
            G: 0.007602,
            YC: 0,
            EC: 0,
            ZC: 0,
            aC: 0,
            bC: 0,
            cC: 0.007602,
            FC: 0,
            "3B": 0.011403,
            "4B": 0.015204,
            dC: 0.072219,
            eC: 0.106428,
            fC: 0.030408,
            GC: 0.011403,
            HC: 0.026607,
            "5B": 0.041811,
            gC: 0.273672,
            "6B": 0.030408,
            IC: 0.060816,
            JC: 0.053214,
            KC: 0.125433,
            LC: 0.049413,
            MC: 0.083622,
            hC: 0.440916,
            "7B": 0.07602,
            NC: 0.243264,
            OC: 0.919842,
            PC: 0.475125,
            QC: 0.011403,
            iC: 0
        },
        B: "webkit",
        C: [
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "YC",
            "EC",
            "J",
            "9",
            "ZC",
            "K",
            "aC",
            "D",
            "bC",
            "E",
            "F",
            "cC",
            "A",
            "FC",
            "B",
            "3B",
            "C",
            "4B",
            "L",
            "dC",
            "M",
            "eC",
            "G",
            "fC",
            "GC",
            "HC",
            "5B",
            "gC",
            "6B",
            "IC",
            "JC",
            "KC",
            "LC",
            "MC",
            "hC",
            "7B",
            "NC",
            "OC",
            "PC",
            "QC",
            "iC",
            "",
            ""
        ],
        E: "Safari",
        F: {
            "9": 1275868800,
            YC: 1205798400,
            EC: 1226534400,
            J: 1244419200,
            ZC: 1311120000,
            K: 1343174400,
            aC: 1382400000,
            D: 1382400000,
            bC: 1410998400,
            E: 1413417600,
            F: 1443657600,
            cC: 1458518400,
            A: 1474329600,
            FC: 1490572800,
            B: 1505779200,
            "3B": 1522281600,
            C: 1537142400,
            "4B": 1553472000,
            L: 1568851200,
            dC: 1585008000,
            M: 1600214400,
            eC: 1619395200,
            G: 1632096000,
            fC: 1635292800,
            GC: 1639353600,
            HC: 1647216000,
            "5B": 1652745600,
            gC: 1658275200,
            "6B": 1662940800,
            IC: 1666569600,
            JC: 1670889600,
            KC: 1674432000,
            LC: 1679875200,
            MC: 1684368000,
            hC: 1690156800,
            "7B": 1695686400,
            NC: 1698192000,
            OC: 1702252800,
            PC: 1705881600,
            QC: 1709596800,
            iC: null
        }
    },
    F: {
        A: {
            F: 0,
            B: 0,
            C: 0,
            G: 0,
            N: 0,
            O: 0,
            P: 0,
            AB: 0,
            s: 0,
            t: 0,
            u: 0,
            v: 0,
            BB: 0,
            CB: 0,
            DB: 0,
            EB: 0,
            FB: 0.003801,
            GB: 0,
            HB: 0,
            IB: 0,
            JB: 0,
            KB: 0,
            LB: 0,
            MB: 0,
            NB: 0.003801,
            OB: 0,
            PB: 0,
            QB: 0,
            RB: 0.003801,
            SB: 0,
            TB: 0,
            UB: 0,
            VB: 0,
            WB: 0,
            XB: 0.015204,
            YB: 0,
            ZB: 0,
            aB: 0,
            bB: 0,
            cB: 0,
            dB: 0,
            eB: 0,
            fB: 0,
            gB: 0,
            hB: 0,
            iB: 0,
            jB: 0,
            kB: 0,
            lB: 0,
            mB: 0,
            nB: 0,
            oB: 0,
            pB: 0,
            qB: 0,
            rB: 0,
            sB: 0,
            tB: 0,
            uB: 0,
            vB: 0,
            wB: 0,
            xB: 0,
            yB: 0,
            zB: 0,
            "0B": 0,
            "1B": 0,
            Q: 0,
            H: 0,
            R: 0,
            BC: 0,
            S: 0,
            T: 0,
            U: 0,
            V: 0,
            W: 0,
            X: 0,
            Y: 0,
            Z: 0,
            a: 0,
            b: 0,
            c: 0,
            d: 0,
            e: 0.045612,
            f: 0,
            g: 0,
            h: 0,
            i: 0,
            j: 0,
            k: 0,
            l: 0.049413,
            m: 0,
            n: 0,
            o: 0.007602,
            p: 0.661374,
            q: 0,
            r: 0,
            jC: 0,
            kC: 0,
            lC: 0,
            mC: 0,
            "3B": 0,
            RC: 0,
            nC: 0,
            "4B": 0
        },
        B: "webkit",
        C: [
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "F",
            "jC",
            "kC",
            "lC",
            "mC",
            "B",
            "3B",
            "RC",
            "nC",
            "C",
            "4B",
            "G",
            "N",
            "O",
            "P",
            "AB",
            "s",
            "t",
            "u",
            "v",
            "BB",
            "CB",
            "DB",
            "EB",
            "FB",
            "GB",
            "HB",
            "IB",
            "JB",
            "KB",
            "LB",
            "MB",
            "NB",
            "OB",
            "PB",
            "QB",
            "RB",
            "SB",
            "TB",
            "UB",
            "VB",
            "WB",
            "XB",
            "YB",
            "ZB",
            "aB",
            "bB",
            "cB",
            "dB",
            "eB",
            "fB",
            "gB",
            "hB",
            "iB",
            "jB",
            "kB",
            "lB",
            "mB",
            "nB",
            "oB",
            "pB",
            "qB",
            "rB",
            "sB",
            "tB",
            "uB",
            "vB",
            "wB",
            "xB",
            "yB",
            "zB",
            "0B",
            "1B",
            "Q",
            "H",
            "R",
            "BC",
            "S",
            "T",
            "U",
            "V",
            "W",
            "X",
            "Y",
            "Z",
            "a",
            "b",
            "c",
            "d",
            "e",
            "f",
            "g",
            "h",
            "i",
            "j",
            "k",
            "l",
            "m",
            "n",
            "o",
            "p",
            "q",
            "r",
            "",
            "",
            ""
        ],
        E: "Opera",
        F: {
            F: 1150761600,
            jC: 1223424000,
            kC: 1251763200,
            lC: 1267488000,
            mC: 1277942400,
            B: 1292457600,
            "3B": 1302566400,
            RC: 1309219200,
            nC: 1323129600,
            C: 1323129600,
            "4B": 1352073600,
            G: 1372723200,
            N: 1377561600,
            O: 1381104000,
            P: 1386288000,
            AB: 1390867200,
            s: 1393891200,
            t: 1399334400,
            u: 1401753600,
            v: 1405987200,
            BB: 1409616000,
            CB: 1413331200,
            DB: 1417132800,
            EB: 1422316800,
            FB: 1425945600,
            GB: 1430179200,
            HB: 1433808000,
            IB: 1438646400,
            JB: 1442448000,
            KB: 1445904000,
            LB: 1449100800,
            MB: 1454371200,
            NB: 1457308800,
            OB: 1462320000,
            PB: 1465344000,
            QB: 1470096000,
            RB: 1474329600,
            SB: 1477267200,
            TB: 1481587200,
            UB: 1486425600,
            VB: 1490054400,
            WB: 1494374400,
            XB: 1498003200,
            YB: 1502236800,
            ZB: 1506470400,
            aB: 1510099200,
            bB: 1515024000,
            cB: 1517961600,
            dB: 1521676800,
            eB: 1525910400,
            fB: 1530144000,
            gB: 1534982400,
            hB: 1537833600,
            iB: 1543363200,
            jB: 1548201600,
            kB: 1554768000,
            lB: 1561593600,
            mB: 1566259200,
            nB: 1570406400,
            oB: 1573689600,
            pB: 1578441600,
            qB: 1583971200,
            rB: 1587513600,
            sB: 1592956800,
            tB: 1595894400,
            uB: 1600128000,
            vB: 1603238400,
            wB: 1613520000,
            xB: 1612224000,
            yB: 1616544000,
            zB: 1619568000,
            "0B": 1623715200,
            "1B": 1627948800,
            Q: 1631577600,
            H: 1633392000,
            R: 1635984000,
            BC: 1638403200,
            S: 1642550400,
            T: 1644969600,
            U: 1647993600,
            V: 1650412800,
            W: 1652745600,
            X: 1654646400,
            Y: 1657152000,
            Z: 1660780800,
            a: 1663113600,
            b: 1668816000,
            c: 1668643200,
            d: 1671062400,
            e: 1675209600,
            f: 1677024000,
            g: 1679529600,
            h: 1681948800,
            i: 1684195200,
            j: 1687219200,
            k: 1690329600,
            l: 1692748800,
            m: 1696204800,
            n: 1699920000,
            o: 1699920000,
            p: 1702944000,
            q: 1707264000,
            r: 1710115200
        },
        D: {
            F: "o",
            B: "o",
            C: "o",
            jC: "o",
            kC: "o",
            lC: "o",
            mC: "o",
            "3B": "o",
            RC: "o",
            nC: "o",
            "4B": "o"
        }
    },
    G: {
        A: {
            E: 0,
            EC: 0,
            oC: 0,
            SC: 0.00293537,
            pC: 0.00293537,
            qC: 0.00880612,
            rC: 0.0102738,
            sC: 0.00146769,
            tC: 0.00733843,
            uC: 0.0352245,
            vC: 0.00587075,
            wC: 0.0587075,
            xC: 0.0264184,
            yC: 0.0190799,
            zC: 0.0102738,
            "0C": 0.265651,
            "1C": 0.00440306,
            "2C": 0.0425629,
            "3C": 0.0132092,
            "4C": 0.0572398,
            "5C": 0.121818,
            "6C": 0.15851,
            "7C": 0.0675136,
            GC: 0.0792551,
            HC: 0.0895289,
            "5B": 0.118883,
            "8C": 0.978947,
            "6B": 0.25391,
            IC: 0.540109,
            JC: 0.250974,
            KC: 0.457918,
            LC: 0.102738,
            MC: 0.214282,
            "9C": 1.65702,
            "7B": 0.237765,
            NC: 0.725037,
            OC: 5.42163,
            PC: 2.54497,
            QC: 0.0733843
        },
        B: "webkit",
        C: [
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "EC",
            "oC",
            "SC",
            "pC",
            "qC",
            "rC",
            "E",
            "sC",
            "tC",
            "uC",
            "vC",
            "wC",
            "xC",
            "yC",
            "zC",
            "0C",
            "1C",
            "2C",
            "3C",
            "4C",
            "5C",
            "6C",
            "7C",
            "GC",
            "HC",
            "5B",
            "8C",
            "6B",
            "IC",
            "JC",
            "KC",
            "LC",
            "MC",
            "9C",
            "7B",
            "NC",
            "OC",
            "PC",
            "QC",
            "",
            "",
            ""
        ],
        E: "Safari on iOS",
        F: {
            EC: 1270252800,
            oC: 1283904000,
            SC: 1299628800,
            pC: 1331078400,
            qC: 1359331200,
            rC: 1394409600,
            E: 1410912000,
            sC: 1413763200,
            tC: 1442361600,
            uC: 1458518400,
            vC: 1473724800,
            wC: 1490572800,
            xC: 1505779200,
            yC: 1522281600,
            zC: 1537142400,
            "0C": 1553472000,
            "1C": 1568851200,
            "2C": 1572220800,
            "3C": 1580169600,
            "4C": 1585008000,
            "5C": 1600214400,
            "6C": 1619395200,
            "7C": 1632096000,
            GC: 1639353600,
            HC: 1647216000,
            "5B": 1652659200,
            "8C": 1658275200,
            "6B": 1662940800,
            IC: 1666569600,
            JC: 1670889600,
            KC: 1674432000,
            LC: 1679875200,
            MC: 1684368000,
            "9C": 1690156800,
            "7B": 1694995200,
            NC: 1698192000,
            OC: 1702252800,
            PC: 1705881600,
            QC: 1709596800
        }
    },
    H: {
        A: {
            AD: 0.09
        },
        B: "o",
        C: [
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "AD",
            "",
            "",
            ""
        ],
        E: "Opera Mini",
        F: {
            AD: 1426464000
        }
    },
    I: {
        A: {
            "8B": 0,
            J: 0.0000582612,
            I: 0.580223,
            BD: 0,
            CD: 0.0000582612,
            DD: 0,
            ED: 0.0000582612,
            SC: 0.000349567,
            FD: 0,
            GD: 0.00139827
        },
        B: "webkit",
        C: [
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "BD",
            "CD",
            "DD",
            "8B",
            "J",
            "ED",
            "SC",
            "FD",
            "GD",
            "I",
            "",
            "",
            ""
        ],
        E: "Android Browser",
        F: {
            BD: 1256515200,
            CD: 1274313600,
            DD: 1291593600,
            "8B": 1298332800,
            J: 1318896000,
            ED: 1341792000,
            SC: 1374624000,
            FD: 1386547200,
            GD: 1401667200,
            I: 1709078400
        }
    },
    J: {
        A: {
            D: 0,
            A: 0
        },
        B: "webkit",
        C: [
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "D",
            "A",
            "",
            "",
            ""
        ],
        E: "Blackberry Browser",
        F: {
            D: 1325376000,
            A: 1359504000
        }
    },
    K: {
        A: {
            A: 0,
            B: 0,
            C: 0,
            H: 1.23017,
            "3B": 0,
            RC: 0,
            "4B": 0
        },
        B: "o",
        C: [
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "A",
            "B",
            "3B",
            "RC",
            "C",
            "4B",
            "H",
            "",
            "",
            ""
        ],
        E: "Opera Mobile",
        F: {
            A: 1287100800,
            B: 1300752000,
            "3B": 1314835200,
            RC: 1318291200,
            C: 1330300800,
            "4B": 1349740800,
            H: 1709769600
        },
        D: {
            H: "webkit"
        }
    },
    L: {
        A: {
            I: 42.4244
        },
        B: "webkit",
        C: [
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "I",
            "",
            "",
            ""
        ],
        E: "Chrome for Android",
        F: {
            I: 1709078400
        }
    },
    M: {
        A: {
            "2B": 0.291306
        },
        B: "moz",
        C: [
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "2B",
            "",
            "",
            ""
        ],
        E: "Firefox for Android",
        F: {
            "2B": 1708387200
        }
    },
    N: {
        A: {
            A: 0,
            B: 0
        },
        B: "ms",
        C: [
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "A",
            "B",
            "",
            "",
            ""
        ],
        E: "IE Mobile",
        F: {
            A: 1340150400,
            B: 1353456000
        }
    },
    O: {
        A: {
            "5B": 0.818136
        },
        B: "webkit",
        C: [
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "5B",
            "",
            "",
            ""
        ],
        E: "UC Browser for Android",
        F: {
            "5B": 1710115200
        },
        D: {
            "5B": "webkit"
        }
    },
    P: {
        A: {
            J: 0.13981,
            s: 0.0322639,
            t: 0.0752824,
            u: 0.0860371,
            v: 2.04338,
            HD: 0.0107546,
            ID: 0,
            JD: 0.0537732,
            KD: 0,
            LD: 0,
            FC: 0,
            MD: 0.0107546,
            ND: 0,
            OD: 0.0107546,
            PD: 0,
            QD: 0,
            "6B": 0.0107546,
            "7B": 0.0322639,
            RD: 0.0215093,
            SD: 0.0430185
        },
        B: "webkit",
        C: [
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "J",
            "HD",
            "ID",
            "JD",
            "KD",
            "LD",
            "FC",
            "MD",
            "ND",
            "OD",
            "PD",
            "QD",
            "6B",
            "7B",
            "RD",
            "SD",
            "s",
            "t",
            "u",
            "v",
            "",
            "",
            ""
        ],
        E: "Samsung Internet",
        F: {
            J: 1461024000,
            HD: 1481846400,
            ID: 1509408000,
            JD: 1528329600,
            KD: 1546128000,
            LD: 1554163200,
            FC: 1567900800,
            MD: 1582588800,
            ND: 1593475200,
            OD: 1605657600,
            PD: 1618531200,
            QD: 1629072000,
            "6B": 1640736000,
            "7B": 1651708800,
            RD: 1659657600,
            SD: 1667260800,
            s: 1677369600,
            t: 1684454400,
            u: 1689292800,
            v: 1697587200
        }
    },
    Q: {
        A: {
            TD: 0.241722
        },
        B: "webkit",
        C: [
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "TD",
            "",
            "",
            ""
        ],
        E: "QQ Browser",
        F: {
            TD: 1710288000
        }
    },
    R: {
        A: {
            UD: 0
        },
        B: "webkit",
        C: [
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "UD",
            "",
            "",
            ""
        ],
        E: "Baidu Browser",
        F: {
            UD: 1710201600
        }
    },
    S: {
        A: {
            VD: 0.086772,
            WD: 0
        },
        B: "moz",
        C: [
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "VD",
            "WD",
            "",
            "",
            ""
        ],
        E: "KaiOS Browser",
        F: {
            VD: 1527811200,
            WD: 1631664000
        }
    }
};

});


parcelRegister("5pSOk", function(module, exports) {
module.exports = JSON.parse('{"v0.8":{"start":"2012-06-25","end":"2014-07-31"},"v0.10":{"start":"2013-03-11","end":"2016-10-31"},"v0.12":{"start":"2015-02-06","end":"2016-12-31"},"v4":{"start":"2015-09-08","lts":"2015-10-12","maintenance":"2017-04-01","end":"2018-04-30","codename":"Argon"},"v5":{"start":"2015-10-29","maintenance":"2016-04-30","end":"2016-06-30"},"v6":{"start":"2016-04-26","lts":"2016-10-18","maintenance":"2018-04-30","end":"2019-04-30","codename":"Boron"},"v7":{"start":"2016-10-25","maintenance":"2017-04-30","end":"2017-06-30"},"v8":{"start":"2017-05-30","lts":"2017-10-31","maintenance":"2019-01-01","end":"2019-12-31","codename":"Carbon"},"v9":{"start":"2017-10-01","maintenance":"2018-04-01","end":"2018-06-30"},"v10":{"start":"2018-04-24","lts":"2018-10-30","maintenance":"2020-05-19","end":"2021-04-30","codename":"Dubnium"},"v11":{"start":"2018-10-23","maintenance":"2019-04-22","end":"2019-06-01"},"v12":{"start":"2019-04-23","lts":"2019-10-21","maintenance":"2020-11-30","end":"2022-04-30","codename":"Erbium"},"v13":{"start":"2019-10-22","maintenance":"2020-04-01","end":"2020-06-01"},"v14":{"start":"2020-04-21","lts":"2020-10-27","maintenance":"2021-10-19","end":"2023-04-30","codename":"Fermium"},"v15":{"start":"2020-10-20","maintenance":"2021-04-01","end":"2021-06-01"},"v16":{"start":"2021-04-20","lts":"2021-10-26","maintenance":"2022-10-18","end":"2023-09-11","codename":"Gallium"},"v17":{"start":"2021-10-19","maintenance":"2022-04-01","end":"2022-06-01"},"v18":{"start":"2022-04-19","lts":"2022-10-25","maintenance":"2023-10-18","end":"2025-04-30","codename":"Hydrogen"},"v19":{"start":"2022-10-18","maintenance":"2023-04-01","end":"2023-06-01"},"v20":{"start":"2023-04-18","lts":"2023-10-24","maintenance":"2024-10-22","end":"2026-04-30","codename":"Iron"},"v21":{"start":"2023-10-17","maintenance":"2024-04-01","end":"2024-06-01"},"v22":{"start":"2024-04-23","lts":"2024-10-29","maintenance":"2025-10-21","end":"2027-04-30","codename":""},"v23":{"start":"2024-10-15","maintenance":"2025-04-01","end":"2025-06-01"},"v24":{"start":"2025-04-22","lts":"2025-10-28","maintenance":"2026-10-20","end":"2028-04-30","codename":""}}');

});

parcelRegister("kjyEk", function(module, exports) {
"use strict";

});

parcelRegister("KkowK", function(module, exports) {
module.exports = {
    "0.20": "39",
    "0.21": "41",
    "0.22": "41",
    "0.23": "41",
    "0.24": "41",
    "0.25": "42",
    "0.26": "42",
    "0.27": "43",
    "0.28": "43",
    "0.29": "43",
    "0.30": "44",
    "0.31": "45",
    "0.32": "45",
    "0.33": "45",
    "0.34": "45",
    "0.35": "45",
    "0.36": "47",
    "0.37": "49",
    "1.0": "49",
    "1.1": "50",
    "1.2": "51",
    "1.3": "52",
    "1.4": "53",
    "1.5": "54",
    "1.6": "56",
    "1.7": "58",
    "1.8": "59",
    "2.0": "61",
    "2.1": "61",
    "3.0": "66",
    "3.1": "66",
    "4.0": "69",
    "4.1": "69",
    "4.2": "69",
    "5.0": "73",
    "6.0": "76",
    "6.1": "76",
    "7.0": "78",
    "7.1": "78",
    "7.2": "78",
    "7.3": "78",
    "8.0": "80",
    "8.1": "80",
    "8.2": "80",
    "8.3": "80",
    "8.4": "80",
    "8.5": "80",
    "9.0": "83",
    "9.1": "83",
    "9.2": "83",
    "9.3": "83",
    "9.4": "83",
    "10.0": "85",
    "10.1": "85",
    "10.2": "85",
    "10.3": "85",
    "10.4": "85",
    "11.0": "87",
    "11.1": "87",
    "11.2": "87",
    "11.3": "87",
    "11.4": "87",
    "11.5": "87",
    "12.0": "89",
    "12.1": "89",
    "12.2": "89",
    "13.0": "91",
    "13.1": "91",
    "13.2": "91",
    "13.3": "91",
    "13.4": "91",
    "13.5": "91",
    "13.6": "91",
    "14.0": "93",
    "14.1": "93",
    "14.2": "93",
    "15.0": "94",
    "15.1": "94",
    "15.2": "94",
    "15.3": "94",
    "15.4": "94",
    "15.5": "94",
    "16.0": "96",
    "16.1": "96",
    "16.2": "96",
    "17.0": "98",
    "17.1": "98",
    "17.2": "98",
    "17.3": "98",
    "17.4": "98",
    "18.0": "100",
    "18.1": "100",
    "18.2": "100",
    "18.3": "100",
    "19.0": "102",
    "19.1": "102",
    "20.0": "104",
    "20.1": "104",
    "20.2": "104",
    "20.3": "104",
    "21.0": "106",
    "21.1": "106",
    "21.2": "106",
    "21.3": "106",
    "21.4": "106",
    "22.0": "108",
    "22.1": "108",
    "22.2": "108",
    "22.3": "108",
    "23.0": "110",
    "23.1": "110",
    "23.2": "110",
    "23.3": "110",
    "24.0": "112",
    "24.1": "112",
    "24.2": "112",
    "24.3": "112",
    "24.4": "112",
    "24.5": "112",
    "24.6": "112",
    "24.7": "112",
    "24.8": "112",
    "25.0": "114",
    "25.1": "114",
    "25.2": "114",
    "25.3": "114",
    "25.4": "114",
    "25.5": "114",
    "25.6": "114",
    "25.7": "114",
    "25.8": "114",
    "25.9": "114",
    "26.0": "116",
    "26.1": "116",
    "26.2": "116",
    "26.3": "116",
    "26.4": "116",
    "26.5": "116",
    "26.6": "116",
    "27.0": "118",
    "27.1": "118",
    "27.2": "118",
    "27.3": "118",
    "28.0": "120",
    "28.1": "120",
    "28.2": "120",
    "29.0": "122",
    "29.1": "122",
    "30.0": "124"
};

});

parcelRegister("eOoAi", function(module, exports) {
function $ac88ce27e264fbe6$var$BrowserslistError(message) {
    this.name = "BrowserslistError";
    this.message = message;
    this.browserslist = true;
    if (Error.captureStackTrace) Error.captureStackTrace(this, $ac88ce27e264fbe6$var$BrowserslistError);
}
$ac88ce27e264fbe6$var$BrowserslistError.prototype = Error.prototype;
module.exports = $ac88ce27e264fbe6$var$BrowserslistError;

});

parcelRegister("jhEfw", function(module, exports) {
var $e09ed3866eedaa1b$var$AND_REGEXP = /^\s+and\s+(.*)/i;
var $e09ed3866eedaa1b$var$OR_REGEXP = /^(?:,\s*|\s+or\s+)(.*)/i;
function $e09ed3866eedaa1b$var$flatten(array) {
    if (!Array.isArray(array)) return [
        array
    ];
    return array.reduce(function(a, b) {
        return a.concat($e09ed3866eedaa1b$var$flatten(b));
    }, []);
}
function $e09ed3866eedaa1b$var$find(string, predicate) {
    for(var n = 1, max = string.length; n <= max; n++){
        var parsed = string.substr(-n, n);
        if (predicate(parsed, n, max)) return string.slice(0, -n);
    }
    return "";
}
function $e09ed3866eedaa1b$var$matchQuery(all, query) {
    var node = {
        query: query
    };
    if (query.indexOf("not ") === 0) {
        node.not = true;
        query = query.slice(4);
    }
    for(var name in all){
        var type = all[name];
        var match = query.match(type.regexp);
        if (match) {
            node.type = name;
            for(var i = 0; i < type.matches.length; i++)node[type.matches[i]] = match[i + 1];
            return node;
        }
    }
    node.type = "unknown";
    return node;
}
function $e09ed3866eedaa1b$var$matchBlock(all, string, qs) {
    var node;
    return $e09ed3866eedaa1b$var$find(string, function(parsed, n, max) {
        if ($e09ed3866eedaa1b$var$AND_REGEXP.test(parsed)) {
            node = $e09ed3866eedaa1b$var$matchQuery(all, parsed.match($e09ed3866eedaa1b$var$AND_REGEXP)[1]);
            node.compose = "and";
            qs.unshift(node);
            return true;
        } else if ($e09ed3866eedaa1b$var$OR_REGEXP.test(parsed)) {
            node = $e09ed3866eedaa1b$var$matchQuery(all, parsed.match($e09ed3866eedaa1b$var$OR_REGEXP)[1]);
            node.compose = "or";
            qs.unshift(node);
            return true;
        } else if (n === max) {
            node = $e09ed3866eedaa1b$var$matchQuery(all, parsed.trim());
            node.compose = "or";
            qs.unshift(node);
            return true;
        }
        return false;
    });
}
module.exports = function parse(all, queries) {
    if (!Array.isArray(queries)) queries = [
        queries
    ];
    return $e09ed3866eedaa1b$var$flatten(queries.map(function(block) {
        var qs = [];
        do block = $e09ed3866eedaa1b$var$matchBlock(all, block, qs);
        while (block);
        return qs;
    }));
};

});

parcelRegister("c2daN", function(module, exports) {

var $eOoAi = parcelRequire("eOoAi");
function $8c2fe3dfd7e38138$var$noop() {}
module.exports = {
    loadQueries: function loadQueries() {
        throw new $eOoAi("Sharable configs are not supported in client-side build of Browserslist");
    },
    getStat: function getStat(opts) {
        return opts.stats;
    },
    loadConfig: function loadConfig(opts) {
        if (opts.config) throw new $eOoAi("Browserslist config are not supported in client-side build");
    },
    loadCountry: function loadCountry() {
        throw new $eOoAi("Country statistics are not supported in client-side build of Browserslist");
    },
    loadFeature: function loadFeature() {
        throw new $eOoAi("Supports queries are not available in client-side build of Browserslist");
    },
    currentNode: function currentNode(resolve, context) {
        return resolve([
            "maintained node versions"
        ], context)[0];
    },
    parseConfig: $8c2fe3dfd7e38138$var$noop,
    readConfig: $8c2fe3dfd7e38138$var$noop,
    findConfig: $8c2fe3dfd7e38138$var$noop,
    clearCaches: $8c2fe3dfd7e38138$var$noop,
    oldDataWarning: $8c2fe3dfd7e38138$var$noop,
    env: {}
};

});


parcelRegister("lRd6h", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "OptionValidator", {
    enumerable: true,
    get: function() {
        return $a2mgH.OptionValidator;
    }
});
Object.defineProperty(module.exports, "findSuggestion", {
    enumerable: true,
    get: function() {
        return $5bGcZ.findSuggestion;
    }
});

var $a2mgH = parcelRequire("a2mgH");

var $5bGcZ = parcelRequire("5bGcZ");

});
parcelRegister("a2mgH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.OptionValidator = void 0;

var $5bGcZ = parcelRequire("5bGcZ");
class $74eb5d566efee7ea$var$OptionValidator {
    constructor(descriptor){
        this.descriptor = descriptor;
    }
    validateTopLevelOptions(options, TopLevelOptionShape) {
        const validOptionNames = Object.keys(TopLevelOptionShape);
        for (const option of Object.keys(options)){
            if (!validOptionNames.includes(option)) throw new Error(this.formatMessage(`'${option}' is not a valid top-level option.
- Did you mean '${(0, $5bGcZ.findSuggestion)(option, validOptionNames)}'?`));
        }
    }
    validateBooleanOption(name, value, defaultValue) {
        if (value === undefined) return defaultValue;
        else this.invariant(typeof value === "boolean", `'${name}' option must be a boolean.`);
        return value;
    }
    validateStringOption(name, value, defaultValue) {
        if (value === undefined) return defaultValue;
        else this.invariant(typeof value === "string", `'${name}' option must be a string.`);
        return value;
    }
    invariant(condition, message) {
        if (!condition) throw new Error(this.formatMessage(message));
    }
    formatMessage(message) {
        return `${this.descriptor}: ${message}`;
    }
}
module.exports.OptionValidator = $74eb5d566efee7ea$var$OptionValidator;

});
parcelRegister("5bGcZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.findSuggestion = $3c6eb89171058ab0$var$findSuggestion;
const { min: $3c6eb89171058ab0$var$min } = Math;
function $3c6eb89171058ab0$var$levenshtein(a, b) {
    let t = [], u = [], i, j;
    const m = a.length, n = b.length;
    if (!m) return n;
    if (!n) return m;
    for(j = 0; j <= n; j++)t[j] = j;
    for(i = 1; i <= m; i++){
        for(u = [
            i
        ], j = 1; j <= n; j++)u[j] = a[i - 1] === b[j - 1] ? t[j - 1] : $3c6eb89171058ab0$var$min(t[j - 1], t[j], u[j - 1]) + 1;
        t = u;
    }
    return u[n];
}
function $3c6eb89171058ab0$var$findSuggestion(str, arr) {
    const distances = arr.map((el)=>$3c6eb89171058ab0$var$levenshtein(el, str));
    return arr[distances.indexOf($3c6eb89171058ab0$var$min(...distances))];
}

});



parcelRegister("kCuqa", function(module, exports) {

module.exports = (parcelRequire("1f7Dw"));

});
parcelRegister("1f7Dw", function(module, exports) {
module.exports = JSON.parse('{"es6.module":{"chrome":"61","and_chr":"61","edge":"16","firefox":"60","and_ff":"60","node":"13.2.0","opera":"48","op_mob":"45","safari":"10.1","ios":"10.3","samsung":"8.2","android":"61","electron":"2.0","ios_saf":"10.3"}}');

});


parcelRegister("dFGFv", function(module, exports) {
"use strict";

var $2Hnfq = parcelRequire("2Hnfq");
const $9f4033c8ebb78b9f$var$MAX = Symbol("max");
const $9f4033c8ebb78b9f$var$LENGTH = Symbol("length");
const $9f4033c8ebb78b9f$var$LENGTH_CALCULATOR = Symbol("lengthCalculator");
const $9f4033c8ebb78b9f$var$ALLOW_STALE = Symbol("allowStale");
const $9f4033c8ebb78b9f$var$MAX_AGE = Symbol("maxAge");
const $9f4033c8ebb78b9f$var$DISPOSE = Symbol("dispose");
const $9f4033c8ebb78b9f$var$NO_DISPOSE_ON_SET = Symbol("noDisposeOnSet");
const $9f4033c8ebb78b9f$var$LRU_LIST = Symbol("lruList");
const $9f4033c8ebb78b9f$var$CACHE = Symbol("cache");
const $9f4033c8ebb78b9f$var$UPDATE_AGE_ON_GET = Symbol("updateAgeOnGet");
const $9f4033c8ebb78b9f$var$naiveLength = ()=>1;
// lruList is a yallist where the head is the youngest
// item, and the tail is the oldest.  the list contains the Hit
// objects as the entries.
// Each Hit object has a reference to its Yallist.Node.  This
// never changes.
//
// cache is a Map (or PseudoMap) that matches the keys to
// the Yallist.Node object.
class $9f4033c8ebb78b9f$var$LRUCache {
    constructor(options){
        if (typeof options === "number") options = {
            max: options
        };
        if (!options) options = {};
        if (options.max && (typeof options.max !== "number" || options.max < 0)) throw new TypeError("max must be a non-negative number");
        // Kind of weird to have a default max of Infinity, but oh well.
        const max = this[$9f4033c8ebb78b9f$var$MAX] = options.max || Infinity;
        const lc = options.length || $9f4033c8ebb78b9f$var$naiveLength;
        this[$9f4033c8ebb78b9f$var$LENGTH_CALCULATOR] = typeof lc !== "function" ? $9f4033c8ebb78b9f$var$naiveLength : lc;
        this[$9f4033c8ebb78b9f$var$ALLOW_STALE] = options.stale || false;
        if (options.maxAge && typeof options.maxAge !== "number") throw new TypeError("maxAge must be a number");
        this[$9f4033c8ebb78b9f$var$MAX_AGE] = options.maxAge || 0;
        this[$9f4033c8ebb78b9f$var$DISPOSE] = options.dispose;
        this[$9f4033c8ebb78b9f$var$NO_DISPOSE_ON_SET] = options.noDisposeOnSet || false;
        this[$9f4033c8ebb78b9f$var$UPDATE_AGE_ON_GET] = options.updateAgeOnGet || false;
        this.reset();
    }
    // resize the cache when the max changes.
    set max(mL) {
        if (typeof mL !== "number" || mL < 0) throw new TypeError("max must be a non-negative number");
        this[$9f4033c8ebb78b9f$var$MAX] = mL || Infinity;
        $9f4033c8ebb78b9f$var$trim(this);
    }
    get max() {
        return this[$9f4033c8ebb78b9f$var$MAX];
    }
    set allowStale(allowStale) {
        this[$9f4033c8ebb78b9f$var$ALLOW_STALE] = !!allowStale;
    }
    get allowStale() {
        return this[$9f4033c8ebb78b9f$var$ALLOW_STALE];
    }
    set maxAge(mA) {
        if (typeof mA !== "number") throw new TypeError("maxAge must be a non-negative number");
        this[$9f4033c8ebb78b9f$var$MAX_AGE] = mA;
        $9f4033c8ebb78b9f$var$trim(this);
    }
    get maxAge() {
        return this[$9f4033c8ebb78b9f$var$MAX_AGE];
    }
    // resize the cache when the lengthCalculator changes.
    set lengthCalculator(lC) {
        if (typeof lC !== "function") lC = $9f4033c8ebb78b9f$var$naiveLength;
        if (lC !== this[$9f4033c8ebb78b9f$var$LENGTH_CALCULATOR]) {
            this[$9f4033c8ebb78b9f$var$LENGTH_CALCULATOR] = lC;
            this[$9f4033c8ebb78b9f$var$LENGTH] = 0;
            this[$9f4033c8ebb78b9f$var$LRU_LIST].forEach((hit)=>{
                hit.length = this[$9f4033c8ebb78b9f$var$LENGTH_CALCULATOR](hit.value, hit.key);
                this[$9f4033c8ebb78b9f$var$LENGTH] += hit.length;
            });
        }
        $9f4033c8ebb78b9f$var$trim(this);
    }
    get lengthCalculator() {
        return this[$9f4033c8ebb78b9f$var$LENGTH_CALCULATOR];
    }
    get length() {
        return this[$9f4033c8ebb78b9f$var$LENGTH];
    }
    get itemCount() {
        return this[$9f4033c8ebb78b9f$var$LRU_LIST].length;
    }
    rforEach(fn, thisp) {
        thisp = thisp || this;
        for(let walker = this[$9f4033c8ebb78b9f$var$LRU_LIST].tail; walker !== null;){
            const prev = walker.prev;
            $9f4033c8ebb78b9f$var$forEachStep(this, fn, walker, thisp);
            walker = prev;
        }
    }
    forEach(fn, thisp) {
        thisp = thisp || this;
        for(let walker = this[$9f4033c8ebb78b9f$var$LRU_LIST].head; walker !== null;){
            const next = walker.next;
            $9f4033c8ebb78b9f$var$forEachStep(this, fn, walker, thisp);
            walker = next;
        }
    }
    keys() {
        return this[$9f4033c8ebb78b9f$var$LRU_LIST].toArray().map((k)=>k.key);
    }
    values() {
        return this[$9f4033c8ebb78b9f$var$LRU_LIST].toArray().map((k)=>k.value);
    }
    reset() {
        if (this[$9f4033c8ebb78b9f$var$DISPOSE] && this[$9f4033c8ebb78b9f$var$LRU_LIST] && this[$9f4033c8ebb78b9f$var$LRU_LIST].length) this[$9f4033c8ebb78b9f$var$LRU_LIST].forEach((hit)=>this[$9f4033c8ebb78b9f$var$DISPOSE](hit.key, hit.value));
        this[$9f4033c8ebb78b9f$var$CACHE] = new Map() // hash of items by key
        ;
        this[$9f4033c8ebb78b9f$var$LRU_LIST] = new $2Hnfq() // list of items in order of use recency
        ;
        this[$9f4033c8ebb78b9f$var$LENGTH] = 0 // length of items in the list
        ;
    }
    dump() {
        return this[$9f4033c8ebb78b9f$var$LRU_LIST].map((hit)=>$9f4033c8ebb78b9f$var$isStale(this, hit) ? false : {
                k: hit.key,
                v: hit.value,
                e: hit.now + (hit.maxAge || 0)
            }).toArray().filter((h)=>h);
    }
    dumpLru() {
        return this[$9f4033c8ebb78b9f$var$LRU_LIST];
    }
    set(key, value, maxAge) {
        maxAge = maxAge || this[$9f4033c8ebb78b9f$var$MAX_AGE];
        if (maxAge && typeof maxAge !== "number") throw new TypeError("maxAge must be a number");
        const now = maxAge ? Date.now() : 0;
        const len = this[$9f4033c8ebb78b9f$var$LENGTH_CALCULATOR](value, key);
        if (this[$9f4033c8ebb78b9f$var$CACHE].has(key)) {
            if (len > this[$9f4033c8ebb78b9f$var$MAX]) {
                $9f4033c8ebb78b9f$var$del(this, this[$9f4033c8ebb78b9f$var$CACHE].get(key));
                return false;
            }
            const node = this[$9f4033c8ebb78b9f$var$CACHE].get(key);
            const item = node.value;
            // dispose of the old one before overwriting
            // split out into 2 ifs for better coverage tracking
            if (this[$9f4033c8ebb78b9f$var$DISPOSE]) {
                if (!this[$9f4033c8ebb78b9f$var$NO_DISPOSE_ON_SET]) this[$9f4033c8ebb78b9f$var$DISPOSE](key, item.value);
            }
            item.now = now;
            item.maxAge = maxAge;
            item.value = value;
            this[$9f4033c8ebb78b9f$var$LENGTH] += len - item.length;
            item.length = len;
            this.get(key);
            $9f4033c8ebb78b9f$var$trim(this);
            return true;
        }
        const hit = new $9f4033c8ebb78b9f$var$Entry(key, value, len, now, maxAge);
        // oversized objects fall out of cache automatically.
        if (hit.length > this[$9f4033c8ebb78b9f$var$MAX]) {
            if (this[$9f4033c8ebb78b9f$var$DISPOSE]) this[$9f4033c8ebb78b9f$var$DISPOSE](key, value);
            return false;
        }
        this[$9f4033c8ebb78b9f$var$LENGTH] += hit.length;
        this[$9f4033c8ebb78b9f$var$LRU_LIST].unshift(hit);
        this[$9f4033c8ebb78b9f$var$CACHE].set(key, this[$9f4033c8ebb78b9f$var$LRU_LIST].head);
        $9f4033c8ebb78b9f$var$trim(this);
        return true;
    }
    has(key) {
        if (!this[$9f4033c8ebb78b9f$var$CACHE].has(key)) return false;
        const hit = this[$9f4033c8ebb78b9f$var$CACHE].get(key).value;
        return !$9f4033c8ebb78b9f$var$isStale(this, hit);
    }
    get(key) {
        return $9f4033c8ebb78b9f$var$get(this, key, true);
    }
    peek(key) {
        return $9f4033c8ebb78b9f$var$get(this, key, false);
    }
    pop() {
        const node = this[$9f4033c8ebb78b9f$var$LRU_LIST].tail;
        if (!node) return null;
        $9f4033c8ebb78b9f$var$del(this, node);
        return node.value;
    }
    del(key) {
        $9f4033c8ebb78b9f$var$del(this, this[$9f4033c8ebb78b9f$var$CACHE].get(key));
    }
    load(arr) {
        // reset the cache
        this.reset();
        const now = Date.now();
        // A previous serialized cache has the most recent items first
        for(let l = arr.length - 1; l >= 0; l--){
            const hit = arr[l];
            const expiresAt = hit.e || 0;
            if (expiresAt === 0) // the item was created without expiration in a non aged cache
            this.set(hit.k, hit.v);
            else {
                const maxAge = expiresAt - now;
                // dont add already expired items
                if (maxAge > 0) this.set(hit.k, hit.v, maxAge);
            }
        }
    }
    prune() {
        this[$9f4033c8ebb78b9f$var$CACHE].forEach((value, key)=>$9f4033c8ebb78b9f$var$get(this, key, false));
    }
}
const $9f4033c8ebb78b9f$var$get = (self, key, doUse)=>{
    const node = self[$9f4033c8ebb78b9f$var$CACHE].get(key);
    if (node) {
        const hit = node.value;
        if ($9f4033c8ebb78b9f$var$isStale(self, hit)) {
            $9f4033c8ebb78b9f$var$del(self, node);
            if (!self[$9f4033c8ebb78b9f$var$ALLOW_STALE]) return undefined;
        } else if (doUse) {
            if (self[$9f4033c8ebb78b9f$var$UPDATE_AGE_ON_GET]) node.value.now = Date.now();
            self[$9f4033c8ebb78b9f$var$LRU_LIST].unshiftNode(node);
        }
        return hit.value;
    }
};
const $9f4033c8ebb78b9f$var$isStale = (self, hit)=>{
    if (!hit || !hit.maxAge && !self[$9f4033c8ebb78b9f$var$MAX_AGE]) return false;
    const diff = Date.now() - hit.now;
    return hit.maxAge ? diff > hit.maxAge : self[$9f4033c8ebb78b9f$var$MAX_AGE] && diff > self[$9f4033c8ebb78b9f$var$MAX_AGE];
};
const $9f4033c8ebb78b9f$var$trim = (self)=>{
    if (self[$9f4033c8ebb78b9f$var$LENGTH] > self[$9f4033c8ebb78b9f$var$MAX]) for(let walker = self[$9f4033c8ebb78b9f$var$LRU_LIST].tail; self[$9f4033c8ebb78b9f$var$LENGTH] > self[$9f4033c8ebb78b9f$var$MAX] && walker !== null;){
        // We know that we're about to delete this one, and also
        // what the next least recently used key will be, so just
        // go ahead and set it now.
        const prev = walker.prev;
        $9f4033c8ebb78b9f$var$del(self, walker);
        walker = prev;
    }
};
const $9f4033c8ebb78b9f$var$del = (self, node)=>{
    if (node) {
        const hit = node.value;
        if (self[$9f4033c8ebb78b9f$var$DISPOSE]) self[$9f4033c8ebb78b9f$var$DISPOSE](hit.key, hit.value);
        self[$9f4033c8ebb78b9f$var$LENGTH] -= hit.length;
        self[$9f4033c8ebb78b9f$var$CACHE].delete(hit.key);
        self[$9f4033c8ebb78b9f$var$LRU_LIST].removeNode(node);
    }
};
class $9f4033c8ebb78b9f$var$Entry {
    constructor(key, value, length, now, maxAge){
        this.key = key;
        this.value = value;
        this.length = length;
        this.now = now;
        this.maxAge = maxAge || 0;
    }
}
const $9f4033c8ebb78b9f$var$forEachStep = (self, fn, node, thisp)=>{
    let hit = node.value;
    if ($9f4033c8ebb78b9f$var$isStale(self, hit)) {
        $9f4033c8ebb78b9f$var$del(self, node);
        if (!self[$9f4033c8ebb78b9f$var$ALLOW_STALE]) hit = undefined;
    }
    if (hit) fn.call(thisp, hit.value, hit.key, self);
};
module.exports = $9f4033c8ebb78b9f$var$LRUCache;

});
parcelRegister("2Hnfq", function(module, exports) {
"use strict";
module.exports = $1f71a177e633f8b1$var$Yallist;
$1f71a177e633f8b1$var$Yallist.Node = $1f71a177e633f8b1$var$Node;
$1f71a177e633f8b1$var$Yallist.create = $1f71a177e633f8b1$var$Yallist;
function $1f71a177e633f8b1$var$Yallist(list) {
    var self = this;
    if (!(self instanceof $1f71a177e633f8b1$var$Yallist)) self = new $1f71a177e633f8b1$var$Yallist();
    self.tail = null;
    self.head = null;
    self.length = 0;
    if (list && typeof list.forEach === "function") list.forEach(function(item) {
        self.push(item);
    });
    else if (arguments.length > 0) for(var i = 0, l = arguments.length; i < l; i++)self.push(arguments[i]);
    return self;
}
$1f71a177e633f8b1$var$Yallist.prototype.removeNode = function(node) {
    if (node.list !== this) throw new Error("removing node which does not belong to this list");
    var next = node.next;
    var prev = node.prev;
    if (next) next.prev = prev;
    if (prev) prev.next = next;
    if (node === this.head) this.head = next;
    if (node === this.tail) this.tail = prev;
    node.list.length--;
    node.next = null;
    node.prev = null;
    node.list = null;
    return next;
};
$1f71a177e633f8b1$var$Yallist.prototype.unshiftNode = function(node) {
    if (node === this.head) return;
    if (node.list) node.list.removeNode(node);
    var head = this.head;
    node.list = this;
    node.next = head;
    if (head) head.prev = node;
    this.head = node;
    if (!this.tail) this.tail = node;
    this.length++;
};
$1f71a177e633f8b1$var$Yallist.prototype.pushNode = function(node) {
    if (node === this.tail) return;
    if (node.list) node.list.removeNode(node);
    var tail = this.tail;
    node.list = this;
    node.prev = tail;
    if (tail) tail.next = node;
    this.tail = node;
    if (!this.head) this.head = node;
    this.length++;
};
$1f71a177e633f8b1$var$Yallist.prototype.push = function() {
    for(var i = 0, l = arguments.length; i < l; i++)$1f71a177e633f8b1$var$push(this, arguments[i]);
    return this.length;
};
$1f71a177e633f8b1$var$Yallist.prototype.unshift = function() {
    for(var i = 0, l = arguments.length; i < l; i++)$1f71a177e633f8b1$var$unshift(this, arguments[i]);
    return this.length;
};
$1f71a177e633f8b1$var$Yallist.prototype.pop = function() {
    if (!this.tail) return undefined;
    var res = this.tail.value;
    this.tail = this.tail.prev;
    if (this.tail) this.tail.next = null;
    else this.head = null;
    this.length--;
    return res;
};
$1f71a177e633f8b1$var$Yallist.prototype.shift = function() {
    if (!this.head) return undefined;
    var res = this.head.value;
    this.head = this.head.next;
    if (this.head) this.head.prev = null;
    else this.tail = null;
    this.length--;
    return res;
};
$1f71a177e633f8b1$var$Yallist.prototype.forEach = function(fn, thisp) {
    thisp = thisp || this;
    for(var walker = this.head, i = 0; walker !== null; i++){
        fn.call(thisp, walker.value, i, this);
        walker = walker.next;
    }
};
$1f71a177e633f8b1$var$Yallist.prototype.forEachReverse = function(fn, thisp) {
    thisp = thisp || this;
    for(var walker = this.tail, i = this.length - 1; walker !== null; i--){
        fn.call(thisp, walker.value, i, this);
        walker = walker.prev;
    }
};
$1f71a177e633f8b1$var$Yallist.prototype.get = function(n) {
    for(var i = 0, walker = this.head; walker !== null && i < n; i++)// abort out of the list early if we hit a cycle
    walker = walker.next;
    if (i === n && walker !== null) return walker.value;
};
$1f71a177e633f8b1$var$Yallist.prototype.getReverse = function(n) {
    for(var i = 0, walker = this.tail; walker !== null && i < n; i++)// abort out of the list early if we hit a cycle
    walker = walker.prev;
    if (i === n && walker !== null) return walker.value;
};
$1f71a177e633f8b1$var$Yallist.prototype.map = function(fn, thisp) {
    thisp = thisp || this;
    var res = new $1f71a177e633f8b1$var$Yallist();
    for(var walker = this.head; walker !== null;){
        res.push(fn.call(thisp, walker.value, this));
        walker = walker.next;
    }
    return res;
};
$1f71a177e633f8b1$var$Yallist.prototype.mapReverse = function(fn, thisp) {
    thisp = thisp || this;
    var res = new $1f71a177e633f8b1$var$Yallist();
    for(var walker = this.tail; walker !== null;){
        res.push(fn.call(thisp, walker.value, this));
        walker = walker.prev;
    }
    return res;
};
$1f71a177e633f8b1$var$Yallist.prototype.reduce = function(fn, initial) {
    var acc;
    var walker = this.head;
    if (arguments.length > 1) acc = initial;
    else if (this.head) {
        walker = this.head.next;
        acc = this.head.value;
    } else throw new TypeError("Reduce of empty list with no initial value");
    for(var i = 0; walker !== null; i++){
        acc = fn(acc, walker.value, i);
        walker = walker.next;
    }
    return acc;
};
$1f71a177e633f8b1$var$Yallist.prototype.reduceReverse = function(fn, initial) {
    var acc;
    var walker = this.tail;
    if (arguments.length > 1) acc = initial;
    else if (this.tail) {
        walker = this.tail.prev;
        acc = this.tail.value;
    } else throw new TypeError("Reduce of empty list with no initial value");
    for(var i = this.length - 1; walker !== null; i--){
        acc = fn(acc, walker.value, i);
        walker = walker.prev;
    }
    return acc;
};
$1f71a177e633f8b1$var$Yallist.prototype.toArray = function() {
    var arr = new Array(this.length);
    for(var i = 0, walker = this.head; walker !== null; i++){
        arr[i] = walker.value;
        walker = walker.next;
    }
    return arr;
};
$1f71a177e633f8b1$var$Yallist.prototype.toArrayReverse = function() {
    var arr = new Array(this.length);
    for(var i = 0, walker = this.tail; walker !== null; i++){
        arr[i] = walker.value;
        walker = walker.prev;
    }
    return arr;
};
$1f71a177e633f8b1$var$Yallist.prototype.slice = function(from, to) {
    to = to || this.length;
    if (to < 0) to += this.length;
    from = from || 0;
    if (from < 0) from += this.length;
    var ret = new $1f71a177e633f8b1$var$Yallist();
    if (to < from || to < 0) return ret;
    if (from < 0) from = 0;
    if (to > this.length) to = this.length;
    for(var i = 0, walker = this.head; walker !== null && i < from; i++)walker = walker.next;
    for(; walker !== null && i < to; i++, walker = walker.next)ret.push(walker.value);
    return ret;
};
$1f71a177e633f8b1$var$Yallist.prototype.sliceReverse = function(from, to) {
    to = to || this.length;
    if (to < 0) to += this.length;
    from = from || 0;
    if (from < 0) from += this.length;
    var ret = new $1f71a177e633f8b1$var$Yallist();
    if (to < from || to < 0) return ret;
    if (from < 0) from = 0;
    if (to > this.length) to = this.length;
    for(var i = this.length, walker = this.tail; walker !== null && i > to; i--)walker = walker.prev;
    for(; walker !== null && i > from; i--, walker = walker.prev)ret.push(walker.value);
    return ret;
};
$1f71a177e633f8b1$var$Yallist.prototype.splice = function(start, deleteCount /*, ...nodes */ ) {
    if (start > this.length) start = this.length - 1;
    if (start < 0) start = this.length + start;
    for(var i = 0, walker = this.head; walker !== null && i < start; i++)walker = walker.next;
    var ret = [];
    for(var i = 0; walker && i < deleteCount; i++){
        ret.push(walker.value);
        walker = this.removeNode(walker);
    }
    if (walker === null) walker = this.tail;
    if (walker !== this.head && walker !== this.tail) walker = walker.prev;
    for(var i = 2; i < arguments.length; i++)walker = $1f71a177e633f8b1$var$insert(this, walker, arguments[i]);
    return ret;
};
$1f71a177e633f8b1$var$Yallist.prototype.reverse = function() {
    var head = this.head;
    var tail = this.tail;
    for(var walker = head; walker !== null; walker = walker.prev){
        var p = walker.prev;
        walker.prev = walker.next;
        walker.next = p;
    }
    this.head = tail;
    this.tail = head;
    return this;
};
function $1f71a177e633f8b1$var$insert(self, node, value) {
    var inserted = node === self.head ? new $1f71a177e633f8b1$var$Node(value, null, node, self) : new $1f71a177e633f8b1$var$Node(value, node, node.next, self);
    if (inserted.next === null) self.tail = inserted;
    if (inserted.prev === null) self.head = inserted;
    self.length++;
    return inserted;
}
function $1f71a177e633f8b1$var$push(self, item) {
    self.tail = new $1f71a177e633f8b1$var$Node(item, self.tail, null, self);
    if (!self.head) self.head = self.tail;
    self.length++;
}
function $1f71a177e633f8b1$var$unshift(self, item) {
    self.head = new $1f71a177e633f8b1$var$Node(item, null, self.head, self);
    if (!self.tail) self.tail = self.head;
    self.length++;
}
function $1f71a177e633f8b1$var$Node(value, prev, next, list) {
    if (!(this instanceof $1f71a177e633f8b1$var$Node)) return new $1f71a177e633f8b1$var$Node(value, prev, next, list);
    this.list = list;
    this.value = value;
    if (prev) {
        prev.next = this;
        this.prev = prev;
    } else this.prev = null;
    if (next) {
        next.prev = this;
        this.next = next;
    } else this.next = null;
}

try {
    // add if support for Symbol.iterator is present
    (parcelRequire("bMpE2"))($1f71a177e633f8b1$var$Yallist);
} catch (er) {}

});
parcelRegister("bMpE2", function(module, exports) {
"use strict";
module.exports = function(Yallist) {
    Yallist.prototype[Symbol.iterator] = function*() {
        for(let walker = this.head; walker; walker = walker.next)yield walker.value;
    };
};

});



parcelRegister("6s1of", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getHighestUnreleased = $4b266fa170884cce$var$getHighestUnreleased;
module.exports.getLowestImplementedVersion = $4b266fa170884cce$var$getLowestImplementedVersion;
module.exports.getLowestUnreleased = $4b266fa170884cce$var$getLowestUnreleased;
module.exports.isUnreleasedVersion = $4b266fa170884cce$var$isUnreleasedVersion;
module.exports.semverMin = $4b266fa170884cce$var$semverMin;
module.exports.semverify = $4b266fa170884cce$var$semverify;

var $6Ekzs = parcelRequire("6Ekzs");

var $lRd6h = parcelRequire("lRd6h");

var $5ztZ6 = parcelRequire("5ztZ6");
const $4b266fa170884cce$var$versionRegExp = /^(\d+|\d+.\d+)$/;
const $4b266fa170884cce$var$v = new $lRd6h.OptionValidator("@babel/helper-compilation-targets");
function $4b266fa170884cce$var$semverMin(first, second) {
    return first && $6Ekzs.lt(first, second) ? first : second;
}
function $4b266fa170884cce$var$semverify(version) {
    if (typeof version === "string" && $6Ekzs.valid(version)) return version;
    $4b266fa170884cce$var$v.invariant(typeof version === "number" || typeof version === "string" && $4b266fa170884cce$var$versionRegExp.test(version), `'${version}' is not a valid version`);
    version = version.toString();
    let pos = 0;
    let num = 0;
    while((pos = version.indexOf(".", pos + 1)) > 0)num++;
    return version + ".0".repeat(2 - num);
}
function $4b266fa170884cce$var$isUnreleasedVersion(version, env) {
    const unreleasedLabel = $5ztZ6.unreleasedLabels[env];
    return !!unreleasedLabel && unreleasedLabel === version.toString().toLowerCase();
}
function $4b266fa170884cce$var$getLowestUnreleased(a, b, env) {
    const unreleasedLabel = $5ztZ6.unreleasedLabels[env];
    if (a === unreleasedLabel) return b;
    if (b === unreleasedLabel) return a;
    return $4b266fa170884cce$var$semverMin(a, b);
}
function $4b266fa170884cce$var$getHighestUnreleased(a, b, env) {
    return $4b266fa170884cce$var$getLowestUnreleased(a, b, env) === a ? b : a;
}
function $4b266fa170884cce$var$getLowestImplementedVersion(plugin, environment) {
    const result = plugin[environment];
    if (!result && environment === "android") return plugin.chrome;
    return result;
}

});
parcelRegister("6Ekzs", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
exports = module.exports = SemVer;
var debug;
/* istanbul ignore next */ typeof $hPtJY === "object" && $hPtJY.env && undefined;
debug = function() {};
// Note: this is the semver.org version of the spec that it implements
// Not necessarily the package version of this code.
exports.SEMVER_SPEC_VERSION = "2.0.0";
var MAX_LENGTH = 256;
var MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || /* istanbul ignore next */ 9007199254740991;
// Max safe segment length for coercion.
var MAX_SAFE_COMPONENT_LENGTH = 16;
var MAX_SAFE_BUILD_LENGTH = MAX_LENGTH - 6;
// The actual regexps go on exports.re
var re = exports.re = [];
var safeRe = exports.safeRe = [];
var src = exports.src = [];
var t = exports.tokens = {};
var R = 0;
function tok(n) {
    t[n] = R++;
}
var LETTERDASHNUMBER = "[a-zA-Z0-9-]";
// Replace some greedy regex tokens to prevent regex dos issues. These regex are
// used internally via the safeRe object since all inputs in this library get
// normalized first to trim and collapse all extra whitespace. The original
// regexes are exported for userland consumption and lower level usage. A
// future breaking change could export the safer regex only with a note that
// all input should have extra whitespace removed.
var safeRegexReplacements = [
    [
        "\\s",
        1
    ],
    [
        "\\d",
        MAX_LENGTH
    ],
    [
        LETTERDASHNUMBER,
        MAX_SAFE_BUILD_LENGTH
    ]
];
function makeSafeRe(value) {
    for(var i = 0; i < safeRegexReplacements.length; i++){
        var token = safeRegexReplacements[i][0];
        var max = safeRegexReplacements[i][1];
        value = value.split(token + "*").join(token + "{0," + max + "}").split(token + "+").join(token + "{1," + max + "}");
    }
    return value;
}
// The following Regular Expressions can be used for tokenizing,
// validating, and parsing SemVer version strings.
// ## Numeric Identifier
// A single `0`, or a non-zero digit followed by zero or more digits.
tok("NUMERICIDENTIFIER");
src[t.NUMERICIDENTIFIER] = "0|[1-9]\\d*";
tok("NUMERICIDENTIFIERLOOSE");
src[t.NUMERICIDENTIFIERLOOSE] = "\\d+";
// ## Non-numeric Identifier
// Zero or more digits, followed by a letter or hyphen, and then zero or
// more letters, digits, or hyphens.
tok("NONNUMERICIDENTIFIER");
src[t.NONNUMERICIDENTIFIER] = "\\d*[a-zA-Z-]" + LETTERDASHNUMBER + "*";
// ## Main Version
// Three dot-separated numeric identifiers.
tok("MAINVERSION");
src[t.MAINVERSION] = "(" + src[t.NUMERICIDENTIFIER] + ")\\." + "(" + src[t.NUMERICIDENTIFIER] + ")\\." + "(" + src[t.NUMERICIDENTIFIER] + ")";
tok("MAINVERSIONLOOSE");
src[t.MAINVERSIONLOOSE] = "(" + src[t.NUMERICIDENTIFIERLOOSE] + ")\\." + "(" + src[t.NUMERICIDENTIFIERLOOSE] + ")\\." + "(" + src[t.NUMERICIDENTIFIERLOOSE] + ")";
// ## Pre-release Version Identifier
// A numeric identifier, or a non-numeric identifier.
tok("PRERELEASEIDENTIFIER");
src[t.PRERELEASEIDENTIFIER] = "(?:" + src[t.NUMERICIDENTIFIER] + "|" + src[t.NONNUMERICIDENTIFIER] + ")";
tok("PRERELEASEIDENTIFIERLOOSE");
src[t.PRERELEASEIDENTIFIERLOOSE] = "(?:" + src[t.NUMERICIDENTIFIERLOOSE] + "|" + src[t.NONNUMERICIDENTIFIER] + ")";
// ## Pre-release Version
// Hyphen, followed by one or more dot-separated pre-release version
// identifiers.
tok("PRERELEASE");
src[t.PRERELEASE] = "(?:-(" + src[t.PRERELEASEIDENTIFIER] + "(?:\\." + src[t.PRERELEASEIDENTIFIER] + ")*))";
tok("PRERELEASELOOSE");
src[t.PRERELEASELOOSE] = "(?:-?(" + src[t.PRERELEASEIDENTIFIERLOOSE] + "(?:\\." + src[t.PRERELEASEIDENTIFIERLOOSE] + ")*))";
// ## Build Metadata Identifier
// Any combination of digits, letters, or hyphens.
tok("BUILDIDENTIFIER");
src[t.BUILDIDENTIFIER] = LETTERDASHNUMBER + "+";
// ## Build Metadata
// Plus sign, followed by one or more period-separated build metadata
// identifiers.
tok("BUILD");
src[t.BUILD] = "(?:\\+(" + src[t.BUILDIDENTIFIER] + "(?:\\." + src[t.BUILDIDENTIFIER] + ")*))";
// ## Full Version String
// A main version, followed optionally by a pre-release version and
// build metadata.
// Note that the only major, minor, patch, and pre-release sections of
// the version string are capturing groups.  The build metadata is not a
// capturing group, because it should not ever be used in version
// comparison.
tok("FULL");
tok("FULLPLAIN");
src[t.FULLPLAIN] = "v?" + src[t.MAINVERSION] + src[t.PRERELEASE] + "?" + src[t.BUILD] + "?";
src[t.FULL] = "^" + src[t.FULLPLAIN] + "$";
// like full, but allows v1.2.3 and =1.2.3, which people do sometimes.
// also, 1.0.0alpha1 (prerelease without the hyphen) which is pretty
// common in the npm registry.
tok("LOOSEPLAIN");
src[t.LOOSEPLAIN] = "[v=\\s]*" + src[t.MAINVERSIONLOOSE] + src[t.PRERELEASELOOSE] + "?" + src[t.BUILD] + "?";
tok("LOOSE");
src[t.LOOSE] = "^" + src[t.LOOSEPLAIN] + "$";
tok("GTLT");
src[t.GTLT] = "((?:<|>)?=?)";
// Something like "2.*" or "1.2.x".
// Note that "x.x" is a valid xRange identifer, meaning "any version"
// Only the first item is strictly required.
tok("XRANGEIDENTIFIERLOOSE");
src[t.XRANGEIDENTIFIERLOOSE] = src[t.NUMERICIDENTIFIERLOOSE] + "|x|X|\\*";
tok("XRANGEIDENTIFIER");
src[t.XRANGEIDENTIFIER] = src[t.NUMERICIDENTIFIER] + "|x|X|\\*";
tok("XRANGEPLAIN");
src[t.XRANGEPLAIN] = "[v=\\s]*(" + src[t.XRANGEIDENTIFIER] + ")" + "(?:\\.(" + src[t.XRANGEIDENTIFIER] + ")" + "(?:\\.(" + src[t.XRANGEIDENTIFIER] + ")" + "(?:" + src[t.PRERELEASE] + ")?" + src[t.BUILD] + "?" + ")?)?";
tok("XRANGEPLAINLOOSE");
src[t.XRANGEPLAINLOOSE] = "[v=\\s]*(" + src[t.XRANGEIDENTIFIERLOOSE] + ")" + "(?:\\.(" + src[t.XRANGEIDENTIFIERLOOSE] + ")" + "(?:\\.(" + src[t.XRANGEIDENTIFIERLOOSE] + ")" + "(?:" + src[t.PRERELEASELOOSE] + ")?" + src[t.BUILD] + "?" + ")?)?";
tok("XRANGE");
src[t.XRANGE] = "^" + src[t.GTLT] + "\\s*" + src[t.XRANGEPLAIN] + "$";
tok("XRANGELOOSE");
src[t.XRANGELOOSE] = "^" + src[t.GTLT] + "\\s*" + src[t.XRANGEPLAINLOOSE] + "$";
// Coercion.
// Extract anything that could conceivably be a part of a valid semver
tok("COERCE");
src[t.COERCE] = "(^|[^\\d])(\\d{1," + MAX_SAFE_COMPONENT_LENGTH + "})" + "(?:\\.(\\d{1," + MAX_SAFE_COMPONENT_LENGTH + "}))?" + "(?:\\.(\\d{1," + MAX_SAFE_COMPONENT_LENGTH + "}))?" + "(?:$|[^\\d])";
tok("COERCERTL");
re[t.COERCERTL] = new RegExp(src[t.COERCE], "g");
safeRe[t.COERCERTL] = new RegExp(makeSafeRe(src[t.COERCE]), "g");
// Tilde ranges.
// Meaning is "reasonably at or greater than"
tok("LONETILDE");
src[t.LONETILDE] = "(?:~>?)";
tok("TILDETRIM");
src[t.TILDETRIM] = "(\\s*)" + src[t.LONETILDE] + "\\s+";
re[t.TILDETRIM] = new RegExp(src[t.TILDETRIM], "g");
safeRe[t.TILDETRIM] = new RegExp(makeSafeRe(src[t.TILDETRIM]), "g");
var tildeTrimReplace = "$1~";
tok("TILDE");
src[t.TILDE] = "^" + src[t.LONETILDE] + src[t.XRANGEPLAIN] + "$";
tok("TILDELOOSE");
src[t.TILDELOOSE] = "^" + src[t.LONETILDE] + src[t.XRANGEPLAINLOOSE] + "$";
// Caret ranges.
// Meaning is "at least and backwards compatible with"
tok("LONECARET");
src[t.LONECARET] = "(?:\\^)";
tok("CARETTRIM");
src[t.CARETTRIM] = "(\\s*)" + src[t.LONECARET] + "\\s+";
re[t.CARETTRIM] = new RegExp(src[t.CARETTRIM], "g");
safeRe[t.CARETTRIM] = new RegExp(makeSafeRe(src[t.CARETTRIM]), "g");
var caretTrimReplace = "$1^";
tok("CARET");
src[t.CARET] = "^" + src[t.LONECARET] + src[t.XRANGEPLAIN] + "$";
tok("CARETLOOSE");
src[t.CARETLOOSE] = "^" + src[t.LONECARET] + src[t.XRANGEPLAINLOOSE] + "$";
// A simple gt/lt/eq thing, or just "" to indicate "any version"
tok("COMPARATORLOOSE");
src[t.COMPARATORLOOSE] = "^" + src[t.GTLT] + "\\s*(" + src[t.LOOSEPLAIN] + ")$|^$";
tok("COMPARATOR");
src[t.COMPARATOR] = "^" + src[t.GTLT] + "\\s*(" + src[t.FULLPLAIN] + ")$|^$";
// An expression to strip any whitespace between the gtlt and the thing
// it modifies, so that `> 1.2.3` ==> `>1.2.3`
tok("COMPARATORTRIM");
src[t.COMPARATORTRIM] = "(\\s*)" + src[t.GTLT] + "\\s*(" + src[t.LOOSEPLAIN] + "|" + src[t.XRANGEPLAIN] + ")";
// this one has to use the /g flag
re[t.COMPARATORTRIM] = new RegExp(src[t.COMPARATORTRIM], "g");
safeRe[t.COMPARATORTRIM] = new RegExp(makeSafeRe(src[t.COMPARATORTRIM]), "g");
var comparatorTrimReplace = "$1$2$3";
// Something like `1.2.3 - 1.2.4`
// Note that these all use the loose form, because they'll be
// checked against either the strict or loose comparator form
// later.
tok("HYPHENRANGE");
src[t.HYPHENRANGE] = "^\\s*(" + src[t.XRANGEPLAIN] + ")" + "\\s+-\\s+" + "(" + src[t.XRANGEPLAIN] + ")" + "\\s*$";
tok("HYPHENRANGELOOSE");
src[t.HYPHENRANGELOOSE] = "^\\s*(" + src[t.XRANGEPLAINLOOSE] + ")" + "\\s+-\\s+" + "(" + src[t.XRANGEPLAINLOOSE] + ")" + "\\s*$";
// Star ranges basically just allow anything at all.
tok("STAR");
src[t.STAR] = "(<|>)?=?\\s*\\*";
// Compile to actual regexp objects.
// All are flag-free, unless they were created above with a flag.
for(var i = 0; i < R; i++){
    debug(i, src[i]);
    if (!re[i]) {
        re[i] = new RegExp(src[i]);
        // Replace all greedy whitespace to prevent regex dos issues. These regex are
        // used internally via the safeRe object since all inputs in this library get
        // normalized first to trim and collapse all extra whitespace. The original
        // regexes are exported for userland consumption and lower level usage. A
        // future breaking change could export the safer regex only with a note that
        // all input should have extra whitespace removed.
        safeRe[i] = new RegExp(makeSafeRe(src[i]));
    }
}
exports.parse = parse;
function parse(version, options) {
    if (!options || typeof options !== "object") options = {
        loose: !!options,
        includePrerelease: false
    };
    if (version instanceof SemVer) return version;
    if (typeof version !== "string") return null;
    if (version.length > MAX_LENGTH) return null;
    var r = options.loose ? safeRe[t.LOOSE] : safeRe[t.FULL];
    if (!r.test(version)) return null;
    try {
        return new SemVer(version, options);
    } catch (er) {
        return null;
    }
}
exports.valid = valid;
function valid(version, options) {
    var v = parse(version, options);
    return v ? v.version : null;
}
exports.clean = clean;
function clean(version, options) {
    var s = parse(version.trim().replace(/^[=v]+/, ""), options);
    return s ? s.version : null;
}
exports.SemVer = SemVer;
function SemVer(version, options) {
    if (!options || typeof options !== "object") options = {
        loose: !!options,
        includePrerelease: false
    };
    if (version instanceof SemVer) {
        if (version.loose === options.loose) return version;
        else version = version.version;
    } else if (typeof version !== "string") throw new TypeError("Invalid Version: " + version);
    if (version.length > MAX_LENGTH) throw new TypeError("version is longer than " + MAX_LENGTH + " characters");
    if (!(this instanceof SemVer)) return new SemVer(version, options);
    debug("SemVer", version, options);
    this.options = options;
    this.loose = !!options.loose;
    var m = version.trim().match(options.loose ? safeRe[t.LOOSE] : safeRe[t.FULL]);
    if (!m) throw new TypeError("Invalid Version: " + version);
    this.raw = version;
    // these are actually numbers
    this.major = +m[1];
    this.minor = +m[2];
    this.patch = +m[3];
    if (this.major > MAX_SAFE_INTEGER || this.major < 0) throw new TypeError("Invalid major version");
    if (this.minor > MAX_SAFE_INTEGER || this.minor < 0) throw new TypeError("Invalid minor version");
    if (this.patch > MAX_SAFE_INTEGER || this.patch < 0) throw new TypeError("Invalid patch version");
    // numberify any prerelease numeric ids
    if (!m[4]) this.prerelease = [];
    else this.prerelease = m[4].split(".").map(function(id) {
        if (/^[0-9]+$/.test(id)) {
            var num = +id;
            if (num >= 0 && num < MAX_SAFE_INTEGER) return num;
        }
        return id;
    });
    this.build = m[5] ? m[5].split(".") : [];
    this.format();
}
SemVer.prototype.format = function() {
    this.version = this.major + "." + this.minor + "." + this.patch;
    if (this.prerelease.length) this.version += "-" + this.prerelease.join(".");
    return this.version;
};
SemVer.prototype.toString = function() {
    return this.version;
};
SemVer.prototype.compare = function(other) {
    debug("SemVer.compare", this.version, this.options, other);
    if (!(other instanceof SemVer)) other = new SemVer(other, this.options);
    return this.compareMain(other) || this.comparePre(other);
};
SemVer.prototype.compareMain = function(other) {
    if (!(other instanceof SemVer)) other = new SemVer(other, this.options);
    return compareIdentifiers(this.major, other.major) || compareIdentifiers(this.minor, other.minor) || compareIdentifiers(this.patch, other.patch);
};
SemVer.prototype.comparePre = function(other) {
    if (!(other instanceof SemVer)) other = new SemVer(other, this.options);
    // NOT having a prerelease is > having one
    if (this.prerelease.length && !other.prerelease.length) return -1;
    else if (!this.prerelease.length && other.prerelease.length) return 1;
    else if (!this.prerelease.length && !other.prerelease.length) return 0;
    var i = 0;
    do {
        var a = this.prerelease[i];
        var b = other.prerelease[i];
        debug("prerelease compare", i, a, b);
        if (a === undefined && b === undefined) return 0;
        else if (b === undefined) return 1;
        else if (a === undefined) return -1;
        else if (a === b) continue;
        else return compareIdentifiers(a, b);
    }while (++i);
};
SemVer.prototype.compareBuild = function(other) {
    if (!(other instanceof SemVer)) other = new SemVer(other, this.options);
    var i = 0;
    do {
        var a = this.build[i];
        var b = other.build[i];
        debug("prerelease compare", i, a, b);
        if (a === undefined && b === undefined) return 0;
        else if (b === undefined) return 1;
        else if (a === undefined) return -1;
        else if (a === b) continue;
        else return compareIdentifiers(a, b);
    }while (++i);
};
// preminor will bump the version up to the next minor release, and immediately
// down to pre-release. premajor and prepatch work the same way.
SemVer.prototype.inc = function(release, identifier) {
    switch(release){
        case "premajor":
            this.prerelease.length = 0;
            this.patch = 0;
            this.minor = 0;
            this.major++;
            this.inc("pre", identifier);
            break;
        case "preminor":
            this.prerelease.length = 0;
            this.patch = 0;
            this.minor++;
            this.inc("pre", identifier);
            break;
        case "prepatch":
            // If this is already a prerelease, it will bump to the next version
            // drop any prereleases that might already exist, since they are not
            // relevant at this point.
            this.prerelease.length = 0;
            this.inc("patch", identifier);
            this.inc("pre", identifier);
            break;
        // If the input is a non-prerelease version, this acts the same as
        // prepatch.
        case "prerelease":
            if (this.prerelease.length === 0) this.inc("patch", identifier);
            this.inc("pre", identifier);
            break;
        case "major":
            // If this is a pre-major version, bump up to the same major version.
            // Otherwise increment major.
            // 1.0.0-5 bumps to 1.0.0
            // 1.1.0 bumps to 2.0.0
            if (this.minor !== 0 || this.patch !== 0 || this.prerelease.length === 0) this.major++;
            this.minor = 0;
            this.patch = 0;
            this.prerelease = [];
            break;
        case "minor":
            // If this is a pre-minor version, bump up to the same minor version.
            // Otherwise increment minor.
            // 1.2.0-5 bumps to 1.2.0
            // 1.2.1 bumps to 1.3.0
            if (this.patch !== 0 || this.prerelease.length === 0) this.minor++;
            this.patch = 0;
            this.prerelease = [];
            break;
        case "patch":
            // If this is not a pre-release version, it will increment the patch.
            // If it is a pre-release it will bump up to the same patch version.
            // 1.2.0-5 patches to 1.2.0
            // 1.2.0 patches to 1.2.1
            if (this.prerelease.length === 0) this.patch++;
            this.prerelease = [];
            break;
        // This probably shouldn't be used publicly.
        // 1.0.0 "pre" would become 1.0.0-0 which is the wrong direction.
        case "pre":
            if (this.prerelease.length === 0) this.prerelease = [
                0
            ];
            else {
                var i = this.prerelease.length;
                while(--i >= 0)if (typeof this.prerelease[i] === "number") {
                    this.prerelease[i]++;
                    i = -2;
                }
                if (i === -1) // didn't increment anything
                this.prerelease.push(0);
            }
            if (identifier) {
                // 1.2.0-beta.1 bumps to 1.2.0-beta.2,
                // 1.2.0-beta.fooblz or 1.2.0-beta bumps to 1.2.0-beta.0
                if (this.prerelease[0] === identifier) {
                    if (isNaN(this.prerelease[1])) this.prerelease = [
                        identifier,
                        0
                    ];
                } else this.prerelease = [
                    identifier,
                    0
                ];
            }
            break;
        default:
            throw new Error("invalid increment argument: " + release);
    }
    this.format();
    this.raw = this.version;
    return this;
};
exports.inc = inc;
function inc(version, release, loose, identifier) {
    if (typeof loose === "string") {
        identifier = loose;
        loose = undefined;
    }
    try {
        return new SemVer(version, loose).inc(release, identifier).version;
    } catch (er) {
        return null;
    }
}
exports.diff = diff;
function diff(version1, version2) {
    if (eq(version1, version2)) return null;
    else {
        var v1 = parse(version1);
        var v2 = parse(version2);
        var prefix = "";
        if (v1.prerelease.length || v2.prerelease.length) {
            prefix = "pre";
            var defaultResult = "prerelease";
        }
        for(var key in v1)if (key === "major" || key === "minor" || key === "patch") {
            if (v1[key] !== v2[key]) return prefix + key;
        }
        return defaultResult // may be undefined
        ;
    }
}
exports.compareIdentifiers = compareIdentifiers;
var numeric = /^[0-9]+$/;
function compareIdentifiers(a, b) {
    var anum = numeric.test(a);
    var bnum = numeric.test(b);
    if (anum && bnum) {
        a = +a;
        b = +b;
    }
    return a === b ? 0 : anum && !bnum ? -1 : bnum && !anum ? 1 : a < b ? -1 : 1;
}
exports.rcompareIdentifiers = rcompareIdentifiers;
function rcompareIdentifiers(a, b) {
    return compareIdentifiers(b, a);
}
exports.major = major;
function major(a, loose) {
    return new SemVer(a, loose).major;
}
exports.minor = minor;
function minor(a, loose) {
    return new SemVer(a, loose).minor;
}
exports.patch = patch;
function patch(a, loose) {
    return new SemVer(a, loose).patch;
}
exports.compare = compare;
function compare(a, b, loose) {
    return new SemVer(a, loose).compare(new SemVer(b, loose));
}
exports.compareLoose = compareLoose;
function compareLoose(a, b) {
    return compare(a, b, true);
}
exports.compareBuild = compareBuild;
function compareBuild(a, b, loose) {
    var versionA = new SemVer(a, loose);
    var versionB = new SemVer(b, loose);
    return versionA.compare(versionB) || versionA.compareBuild(versionB);
}
exports.rcompare = rcompare;
function rcompare(a, b, loose) {
    return compare(b, a, loose);
}
exports.sort = sort;
function sort(list, loose) {
    return list.sort(function(a, b) {
        return exports.compareBuild(a, b, loose);
    });
}
exports.rsort = rsort;
function rsort(list, loose) {
    return list.sort(function(a, b) {
        return exports.compareBuild(b, a, loose);
    });
}
exports.gt = gt;
function gt(a, b, loose) {
    return compare(a, b, loose) > 0;
}
exports.lt = lt;
function lt(a, b, loose) {
    return compare(a, b, loose) < 0;
}
exports.eq = eq;
function eq(a, b, loose) {
    return compare(a, b, loose) === 0;
}
exports.neq = neq;
function neq(a, b, loose) {
    return compare(a, b, loose) !== 0;
}
exports.gte = gte;
function gte(a, b, loose) {
    return compare(a, b, loose) >= 0;
}
exports.lte = lte;
function lte(a, b, loose) {
    return compare(a, b, loose) <= 0;
}
exports.cmp = cmp;
function cmp(a, op, b, loose) {
    switch(op){
        case "===":
            if (typeof a === "object") a = a.version;
            if (typeof b === "object") b = b.version;
            return a === b;
        case "!==":
            if (typeof a === "object") a = a.version;
            if (typeof b === "object") b = b.version;
            return a !== b;
        case "":
        case "=":
        case "==":
            return eq(a, b, loose);
        case "!=":
            return neq(a, b, loose);
        case ">":
            return gt(a, b, loose);
        case ">=":
            return gte(a, b, loose);
        case "<":
            return lt(a, b, loose);
        case "<=":
            return lte(a, b, loose);
        default:
            throw new TypeError("Invalid operator: " + op);
    }
}
exports.Comparator = Comparator;
function Comparator(comp, options) {
    if (!options || typeof options !== "object") options = {
        loose: !!options,
        includePrerelease: false
    };
    if (comp instanceof Comparator) {
        if (comp.loose === !!options.loose) return comp;
        else comp = comp.value;
    }
    if (!(this instanceof Comparator)) return new Comparator(comp, options);
    comp = comp.trim().split(/\s+/).join(" ");
    debug("comparator", comp, options);
    this.options = options;
    this.loose = !!options.loose;
    this.parse(comp);
    if (this.semver === ANY) this.value = "";
    else this.value = this.operator + this.semver.version;
    debug("comp", this);
}
var ANY = {};
Comparator.prototype.parse = function(comp) {
    var r = this.options.loose ? safeRe[t.COMPARATORLOOSE] : safeRe[t.COMPARATOR];
    var m = comp.match(r);
    if (!m) throw new TypeError("Invalid comparator: " + comp);
    this.operator = m[1] !== undefined ? m[1] : "";
    if (this.operator === "=") this.operator = "";
    // if it literally is just '>' or '' then allow anything.
    if (!m[2]) this.semver = ANY;
    else this.semver = new SemVer(m[2], this.options.loose);
};
Comparator.prototype.toString = function() {
    return this.value;
};
Comparator.prototype.test = function(version) {
    debug("Comparator.test", version, this.options.loose);
    if (this.semver === ANY || version === ANY) return true;
    if (typeof version === "string") try {
        version = new SemVer(version, this.options);
    } catch (er) {
        return false;
    }
    return cmp(version, this.operator, this.semver, this.options);
};
Comparator.prototype.intersects = function(comp, options) {
    if (!(comp instanceof Comparator)) throw new TypeError("a Comparator is required");
    if (!options || typeof options !== "object") options = {
        loose: !!options,
        includePrerelease: false
    };
    var rangeTmp;
    if (this.operator === "") {
        if (this.value === "") return true;
        rangeTmp = new Range(comp.value, options);
        return satisfies(this.value, rangeTmp, options);
    } else if (comp.operator === "") {
        if (comp.value === "") return true;
        rangeTmp = new Range(this.value, options);
        return satisfies(comp.semver, rangeTmp, options);
    }
    var sameDirectionIncreasing = (this.operator === ">=" || this.operator === ">") && (comp.operator === ">=" || comp.operator === ">");
    var sameDirectionDecreasing = (this.operator === "<=" || this.operator === "<") && (comp.operator === "<=" || comp.operator === "<");
    var sameSemVer = this.semver.version === comp.semver.version;
    var differentDirectionsInclusive = (this.operator === ">=" || this.operator === "<=") && (comp.operator === ">=" || comp.operator === "<=");
    var oppositeDirectionsLessThan = cmp(this.semver, "<", comp.semver, options) && (this.operator === ">=" || this.operator === ">") && (comp.operator === "<=" || comp.operator === "<");
    var oppositeDirectionsGreaterThan = cmp(this.semver, ">", comp.semver, options) && (this.operator === "<=" || this.operator === "<") && (comp.operator === ">=" || comp.operator === ">");
    return sameDirectionIncreasing || sameDirectionDecreasing || sameSemVer && differentDirectionsInclusive || oppositeDirectionsLessThan || oppositeDirectionsGreaterThan;
};
exports.Range = Range;
function Range(range, options) {
    if (!options || typeof options !== "object") options = {
        loose: !!options,
        includePrerelease: false
    };
    if (range instanceof Range) {
        if (range.loose === !!options.loose && range.includePrerelease === !!options.includePrerelease) return range;
        else return new Range(range.raw, options);
    }
    if (range instanceof Comparator) return new Range(range.value, options);
    if (!(this instanceof Range)) return new Range(range, options);
    this.options = options;
    this.loose = !!options.loose;
    this.includePrerelease = !!options.includePrerelease;
    // First reduce all whitespace as much as possible so we do not have to rely
    // on potentially slow regexes like \s*. This is then stored and used for
    // future error messages as well.
    this.raw = range.trim().split(/\s+/).join(" ");
    // First, split based on boolean or ||
    this.set = this.raw.split("||").map(function(range) {
        return this.parseRange(range.trim());
    }, this).filter(function(c) {
        // throw out any that are not relevant for whatever reason
        return c.length;
    });
    if (!this.set.length) throw new TypeError("Invalid SemVer Range: " + this.raw);
    this.format();
}
Range.prototype.format = function() {
    this.range = this.set.map(function(comps) {
        return comps.join(" ").trim();
    }).join("||").trim();
    return this.range;
};
Range.prototype.toString = function() {
    return this.range;
};
Range.prototype.parseRange = function(range) {
    var loose = this.options.loose;
    // `1.2.3 - 1.2.4` => `>=1.2.3 <=1.2.4`
    var hr = loose ? safeRe[t.HYPHENRANGELOOSE] : safeRe[t.HYPHENRANGE];
    range = range.replace(hr, hyphenReplace);
    debug("hyphen replace", range);
    // `> 1.2.3 < 1.2.5` => `>1.2.3 <1.2.5`
    range = range.replace(safeRe[t.COMPARATORTRIM], comparatorTrimReplace);
    debug("comparator trim", range, safeRe[t.COMPARATORTRIM]);
    // `~ 1.2.3` => `~1.2.3`
    range = range.replace(safeRe[t.TILDETRIM], tildeTrimReplace);
    // `^ 1.2.3` => `^1.2.3`
    range = range.replace(safeRe[t.CARETTRIM], caretTrimReplace);
    // normalize spaces
    range = range.split(/\s+/).join(" ");
    // At this point, the range is completely trimmed and
    // ready to be split into comparators.
    var compRe = loose ? safeRe[t.COMPARATORLOOSE] : safeRe[t.COMPARATOR];
    var set = range.split(" ").map(function(comp) {
        return parseComparator(comp, this.options);
    }, this).join(" ").split(/\s+/);
    if (this.options.loose) // in loose mode, throw out any that are not valid comparators
    set = set.filter(function(comp) {
        return !!comp.match(compRe);
    });
    set = set.map(function(comp) {
        return new Comparator(comp, this.options);
    }, this);
    return set;
};
Range.prototype.intersects = function(range, options) {
    if (!(range instanceof Range)) throw new TypeError("a Range is required");
    return this.set.some(function(thisComparators) {
        return isSatisfiable(thisComparators, options) && range.set.some(function(rangeComparators) {
            return isSatisfiable(rangeComparators, options) && thisComparators.every(function(thisComparator) {
                return rangeComparators.every(function(rangeComparator) {
                    return thisComparator.intersects(rangeComparator, options);
                });
            });
        });
    });
};
// take a set of comparators and determine whether there
// exists a version which can satisfy it
function isSatisfiable(comparators, options) {
    var result = true;
    var remainingComparators = comparators.slice();
    var testComparator = remainingComparators.pop();
    while(result && remainingComparators.length){
        result = remainingComparators.every(function(otherComparator) {
            return testComparator.intersects(otherComparator, options);
        });
        testComparator = remainingComparators.pop();
    }
    return result;
}
// Mostly just for testing and legacy API reasons
exports.toComparators = toComparators;
function toComparators(range, options) {
    return new Range(range, options).set.map(function(comp) {
        return comp.map(function(c) {
            return c.value;
        }).join(" ").trim().split(" ");
    });
}
// comprised of xranges, tildes, stars, and gtlt's at this point.
// already replaced the hyphen ranges
// turn into a set of JUST comparators.
function parseComparator(comp, options) {
    debug("comp", comp, options);
    comp = replaceCarets(comp, options);
    debug("caret", comp);
    comp = replaceTildes(comp, options);
    debug("tildes", comp);
    comp = replaceXRanges(comp, options);
    debug("xrange", comp);
    comp = replaceStars(comp, options);
    debug("stars", comp);
    return comp;
}
function isX(id) {
    return !id || id.toLowerCase() === "x" || id === "*";
}
// ~, ~> --> * (any, kinda silly)
// ~2, ~2.x, ~2.x.x, ~>2, ~>2.x ~>2.x.x --> >=2.0.0 <3.0.0
// ~2.0, ~2.0.x, ~>2.0, ~>2.0.x --> >=2.0.0 <2.1.0
// ~1.2, ~1.2.x, ~>1.2, ~>1.2.x --> >=1.2.0 <1.3.0
// ~1.2.3, ~>1.2.3 --> >=1.2.3 <1.3.0
// ~1.2.0, ~>1.2.0 --> >=1.2.0 <1.3.0
function replaceTildes(comp, options) {
    return comp.trim().split(/\s+/).map(function(comp) {
        return replaceTilde(comp, options);
    }).join(" ");
}
function replaceTilde(comp, options) {
    var r = options.loose ? safeRe[t.TILDELOOSE] : safeRe[t.TILDE];
    return comp.replace(r, function(_, M, m, p, pr) {
        debug("tilde", comp, _, M, m, p, pr);
        var ret;
        if (isX(M)) ret = "";
        else if (isX(m)) ret = ">=" + M + ".0.0 <" + (+M + 1) + ".0.0";
        else if (isX(p)) // ~1.2 == >=1.2.0 <1.3.0
        ret = ">=" + M + "." + m + ".0 <" + M + "." + (+m + 1) + ".0";
        else if (pr) {
            debug("replaceTilde pr", pr);
            ret = ">=" + M + "." + m + "." + p + "-" + pr + " <" + M + "." + (+m + 1) + ".0";
        } else // ~1.2.3 == >=1.2.3 <1.3.0
        ret = ">=" + M + "." + m + "." + p + " <" + M + "." + (+m + 1) + ".0";
        debug("tilde return", ret);
        return ret;
    });
}
// ^ --> * (any, kinda silly)
// ^2, ^2.x, ^2.x.x --> >=2.0.0 <3.0.0
// ^2.0, ^2.0.x --> >=2.0.0 <3.0.0
// ^1.2, ^1.2.x --> >=1.2.0 <2.0.0
// ^1.2.3 --> >=1.2.3 <2.0.0
// ^1.2.0 --> >=1.2.0 <2.0.0
function replaceCarets(comp, options) {
    return comp.trim().split(/\s+/).map(function(comp) {
        return replaceCaret(comp, options);
    }).join(" ");
}
function replaceCaret(comp, options) {
    debug("caret", comp, options);
    var r = options.loose ? safeRe[t.CARETLOOSE] : safeRe[t.CARET];
    return comp.replace(r, function(_, M, m, p, pr) {
        debug("caret", comp, _, M, m, p, pr);
        var ret;
        if (isX(M)) ret = "";
        else if (isX(m)) ret = ">=" + M + ".0.0 <" + (+M + 1) + ".0.0";
        else if (isX(p)) {
            if (M === "0") ret = ">=" + M + "." + m + ".0 <" + M + "." + (+m + 1) + ".0";
            else ret = ">=" + M + "." + m + ".0 <" + (+M + 1) + ".0.0";
        } else if (pr) {
            debug("replaceCaret pr", pr);
            if (M === "0") {
                if (m === "0") ret = ">=" + M + "." + m + "." + p + "-" + pr + " <" + M + "." + m + "." + (+p + 1);
                else ret = ">=" + M + "." + m + "." + p + "-" + pr + " <" + M + "." + (+m + 1) + ".0";
            } else ret = ">=" + M + "." + m + "." + p + "-" + pr + " <" + (+M + 1) + ".0.0";
        } else {
            debug("no pr");
            if (M === "0") {
                if (m === "0") ret = ">=" + M + "." + m + "." + p + " <" + M + "." + m + "." + (+p + 1);
                else ret = ">=" + M + "." + m + "." + p + " <" + M + "." + (+m + 1) + ".0";
            } else ret = ">=" + M + "." + m + "." + p + " <" + (+M + 1) + ".0.0";
        }
        debug("caret return", ret);
        return ret;
    });
}
function replaceXRanges(comp, options) {
    debug("replaceXRanges", comp, options);
    return comp.split(/\s+/).map(function(comp) {
        return replaceXRange(comp, options);
    }).join(" ");
}
function replaceXRange(comp, options) {
    comp = comp.trim();
    var r = options.loose ? safeRe[t.XRANGELOOSE] : safeRe[t.XRANGE];
    return comp.replace(r, function(ret, gtlt, M, m, p, pr) {
        debug("xRange", comp, ret, gtlt, M, m, p, pr);
        var xM = isX(M);
        var xm = xM || isX(m);
        var xp = xm || isX(p);
        var anyX = xp;
        if (gtlt === "=" && anyX) gtlt = "";
        // if we're including prereleases in the match, then we need
        // to fix this to -0, the lowest possible prerelease value
        pr = options.includePrerelease ? "-0" : "";
        if (xM) {
            if (gtlt === ">" || gtlt === "<") // nothing is allowed
            ret = "<0.0.0-0";
            else // nothing is forbidden
            ret = "*";
        } else if (gtlt && anyX) {
            // we know patch is an x, because we have any x at all.
            // replace X with 0
            if (xm) m = 0;
            p = 0;
            if (gtlt === ">") {
                // >1 => >=2.0.0
                // >1.2 => >=1.3.0
                // >1.2.3 => >= 1.2.4
                gtlt = ">=";
                if (xm) {
                    M = +M + 1;
                    m = 0;
                    p = 0;
                } else {
                    m = +m + 1;
                    p = 0;
                }
            } else if (gtlt === "<=") {
                // <=0.7.x is actually <0.8.0, since any 0.7.x should
                // pass.  Similarly, <=7.x is actually <8.0.0, etc.
                gtlt = "<";
                if (xm) M = +M + 1;
                else m = +m + 1;
            }
            ret = gtlt + M + "." + m + "." + p + pr;
        } else if (xm) ret = ">=" + M + ".0.0" + pr + " <" + (+M + 1) + ".0.0" + pr;
        else if (xp) ret = ">=" + M + "." + m + ".0" + pr + " <" + M + "." + (+m + 1) + ".0" + pr;
        debug("xRange return", ret);
        return ret;
    });
}
// Because * is AND-ed with everything else in the comparator,
// and '' means "any version", just remove the *s entirely.
function replaceStars(comp, options) {
    debug("replaceStars", comp, options);
    // Looseness is ignored here.  star is always as loose as it gets!
    return comp.trim().replace(safeRe[t.STAR], "");
}
// This function is passed to string.replace(re[t.HYPHENRANGE])
// M, m, patch, prerelease, build
// 1.2 - 3.4.5 => >=1.2.0 <=3.4.5
// 1.2.3 - 3.4 => >=1.2.0 <3.5.0 Any 3.4.x will do
// 1.2 - 3.4 => >=1.2.0 <3.5.0
function hyphenReplace($0, from, fM, fm, fp, fpr, fb, to, tM, tm, tp, tpr, tb) {
    if (isX(fM)) from = "";
    else if (isX(fm)) from = ">=" + fM + ".0.0";
    else if (isX(fp)) from = ">=" + fM + "." + fm + ".0";
    else from = ">=" + from;
    if (isX(tM)) to = "";
    else if (isX(tm)) to = "<" + (+tM + 1) + ".0.0";
    else if (isX(tp)) to = "<" + tM + "." + (+tm + 1) + ".0";
    else if (tpr) to = "<=" + tM + "." + tm + "." + tp + "-" + tpr;
    else to = "<=" + to;
    return (from + " " + to).trim();
}
// if ANY of the sets match ALL of its comparators, then pass
Range.prototype.test = function(version) {
    if (!version) return false;
    if (typeof version === "string") try {
        version = new SemVer(version, this.options);
    } catch (er) {
        return false;
    }
    for(var i = 0; i < this.set.length; i++){
        if (testSet(this.set[i], version, this.options)) return true;
    }
    return false;
};
function testSet(set, version, options) {
    for(var i = 0; i < set.length; i++){
        if (!set[i].test(version)) return false;
    }
    if (version.prerelease.length && !options.includePrerelease) {
        // Find the set of versions that are allowed to have prereleases
        // For example, ^1.2.3-pr.1 desugars to >=1.2.3-pr.1 <2.0.0
        // That should allow `1.2.3-pr.2` to pass.
        // However, `1.2.4-alpha.notready` should NOT be allowed,
        // even though it's within the range set by the comparators.
        for(i = 0; i < set.length; i++){
            debug(set[i].semver);
            if (set[i].semver === ANY) continue;
            if (set[i].semver.prerelease.length > 0) {
                var allowed = set[i].semver;
                if (allowed.major === version.major && allowed.minor === version.minor && allowed.patch === version.patch) return true;
            }
        }
        // Version has a -pre, but it's not one of the ones we like.
        return false;
    }
    return true;
}
exports.satisfies = satisfies;
function satisfies(version, range, options) {
    try {
        range = new Range(range, options);
    } catch (er) {
        return false;
    }
    return range.test(version);
}
exports.maxSatisfying = maxSatisfying;
function maxSatisfying(versions, range, options) {
    var max = null;
    var maxSV = null;
    try {
        var rangeObj = new Range(range, options);
    } catch (er) {
        return null;
    }
    versions.forEach(function(v) {
        if (rangeObj.test(v)) // satisfies(v, range, options)
        {
            if (!max || maxSV.compare(v) === -1) {
                // compare(max, v, true)
                max = v;
                maxSV = new SemVer(max, options);
            }
        }
    });
    return max;
}
exports.minSatisfying = minSatisfying;
function minSatisfying(versions, range, options) {
    var min = null;
    var minSV = null;
    try {
        var rangeObj = new Range(range, options);
    } catch (er) {
        return null;
    }
    versions.forEach(function(v) {
        if (rangeObj.test(v)) // satisfies(v, range, options)
        {
            if (!min || minSV.compare(v) === 1) {
                // compare(min, v, true)
                min = v;
                minSV = new SemVer(min, options);
            }
        }
    });
    return min;
}
exports.minVersion = minVersion;
function minVersion(range, loose) {
    range = new Range(range, loose);
    var minver = new SemVer("0.0.0");
    if (range.test(minver)) return minver;
    minver = new SemVer("0.0.0-0");
    if (range.test(minver)) return minver;
    minver = null;
    for(var i = 0; i < range.set.length; ++i){
        var comparators = range.set[i];
        comparators.forEach(function(comparator) {
            // Clone to avoid manipulating the comparator's semver object.
            var compver = new SemVer(comparator.semver.version);
            switch(comparator.operator){
                case ">":
                    if (compver.prerelease.length === 0) compver.patch++;
                    else compver.prerelease.push(0);
                    compver.raw = compver.format();
                /* fallthrough */ case "":
                case ">=":
                    if (!minver || gt(minver, compver)) minver = compver;
                    break;
                case "<":
                case "<=":
                    break;
                /* istanbul ignore next */ default:
                    throw new Error("Unexpected operation: " + comparator.operator);
            }
        });
    }
    if (minver && range.test(minver)) return minver;
    return null;
}
exports.validRange = validRange;
function validRange(range, options) {
    try {
        // Return '*' instead of '' so that truthiness works.
        // This will throw if it's invalid anyway
        return new Range(range, options).range || "*";
    } catch (er) {
        return null;
    }
}
// Determine if version is less than all the versions possible in the range
exports.ltr = ltr;
function ltr(version, range, options) {
    return outside(version, range, "<", options);
}
// Determine if version is greater than all the versions possible in the range.
exports.gtr = gtr;
function gtr(version, range, options) {
    return outside(version, range, ">", options);
}
exports.outside = outside;
function outside(version, range, hilo, options) {
    version = new SemVer(version, options);
    range = new Range(range, options);
    var gtfn, ltefn, ltfn, comp, ecomp;
    switch(hilo){
        case ">":
            gtfn = gt;
            ltefn = lte;
            ltfn = lt;
            comp = ">";
            ecomp = ">=";
            break;
        case "<":
            gtfn = lt;
            ltefn = gte;
            ltfn = gt;
            comp = "<";
            ecomp = "<=";
            break;
        default:
            throw new TypeError('Must provide a hilo val of "<" or ">"');
    }
    // If it satisifes the range it is not outside
    if (satisfies(version, range, options)) return false;
    // From now on, variable terms are as if we're in "gtr" mode.
    // but note that everything is flipped for the "ltr" function.
    for(var i = 0; i < range.set.length; ++i){
        var comparators = range.set[i];
        var high = null;
        var low = null;
        comparators.forEach(function(comparator) {
            if (comparator.semver === ANY) comparator = new Comparator(">=0.0.0");
            high = high || comparator;
            low = low || comparator;
            if (gtfn(comparator.semver, high.semver, options)) high = comparator;
            else if (ltfn(comparator.semver, low.semver, options)) low = comparator;
        });
        // If the edge version comparator has a operator then our version
        // isn't outside it
        if (high.operator === comp || high.operator === ecomp) return false;
        // If the lowest version comparator has an operator and our version
        // is less than it then it isn't higher than the range
        if ((!low.operator || low.operator === comp) && ltefn(version, low.semver)) return false;
        else if (low.operator === ecomp && ltfn(version, low.semver)) return false;
    }
    return true;
}
exports.prerelease = prerelease;
function prerelease(version, options) {
    var parsed = parse(version, options);
    return parsed && parsed.prerelease.length ? parsed.prerelease : null;
}
exports.intersects = intersects;
function intersects(r1, r2, options) {
    r1 = new Range(r1, options);
    r2 = new Range(r2, options);
    return r1.intersects(r2);
}
exports.coerce = coerce;
function coerce(version, options) {
    if (version instanceof SemVer) return version;
    if (typeof version === "number") version = String(version);
    if (typeof version !== "string") return null;
    options = options || {};
    var match = null;
    if (!options.rtl) match = version.match(safeRe[t.COERCE]);
    else {
        // Find the right-most coercible string that does not share
        // a terminus with a more left-ward coercible string.
        // Eg, '1.2.3.4' wants to coerce '2.3.4', not '3.4' or '4'
        //
        // Walk through the string checking with a /g regexp
        // Manually set the index so as to pick up overlapping matches.
        // Stop when we get a match that ends at the string end, since no
        // coercible string can be more right-ward without the same terminus.
        var next;
        while((next = safeRe[t.COERCERTL].exec(version)) && (!match || match.index + match[0].length !== version.length)){
            if (!match || next.index + next[0].length !== match.index + match[0].length) match = next;
            safeRe[t.COERCERTL].lastIndex = next.index + next[1].length + next[2].length;
        }
        // leave it in a clean state
        safeRe[t.COERCERTL].lastIndex = -1;
    }
    if (match === null) return null;
    return parse(match[2] + "." + (match[3] || "0") + "." + (match[4] || "0"), options);
}

});

parcelRegister("5ztZ6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.unreleasedLabels = module.exports.browserNameMap = void 0;
const $40e77af5b87939ad$var$unreleasedLabels = module.exports.unreleasedLabels = {
    safari: "tp"
};
const $40e77af5b87939ad$var$browserNameMap = module.exports.browserNameMap = {
    and_chr: "chrome",
    and_ff: "firefox",
    android: "android",
    chrome: "chrome",
    edge: "edge",
    firefox: "firefox",
    ie: "ie",
    ie_mob: "ie",
    ios_saf: "ios",
    node: "node",
    deno: "deno",
    op_mob: "opera_mobile",
    opera: "opera",
    safari: "safari",
    samsung: "samsung"
};

});


parcelRegister("i2vZx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TargetNames = void 0;
const $d2213ac55f62277d$var$TargetNames = module.exports.TargetNames = {
    node: "node",
    deno: "deno",
    chrome: "chrome",
    opera: "opera",
    edge: "edge",
    firefox: "firefox",
    safari: "safari",
    ie: "ie",
    ios: "ios",
    android: "android",
    electron: "electron",
    samsung: "samsung",
    rhino: "rhino",
    opera_mobile: "opera_mobile"
};

});

parcelRegister("ggwgA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.prettifyTargets = $bd772b6724dfffa5$var$prettifyTargets;
module.exports.prettifyVersion = $bd772b6724dfffa5$var$prettifyVersion;

var $6Ekzs = parcelRequire("6Ekzs");

var $5ztZ6 = parcelRequire("5ztZ6");
function $bd772b6724dfffa5$var$prettifyVersion(version) {
    if (typeof version !== "string") return version;
    const { major: major, minor: minor, patch: patch } = $6Ekzs.parse(version);
    const parts = [
        major
    ];
    if (minor || patch) parts.push(minor);
    if (patch) parts.push(patch);
    return parts.join(".");
}
function $bd772b6724dfffa5$var$prettifyTargets(targets) {
    return Object.keys(targets).reduce((results, target)=>{
        let value = targets[target];
        const unreleasedLabel = $5ztZ6.unreleasedLabels[target];
        if (typeof value === "string" && unreleasedLabel !== value) value = $bd772b6724dfffa5$var$prettifyVersion(value);
        results[target] = value;
        return results;
    }, {});
}

});

parcelRegister("7fH1M", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getInclusionReasons = $547b4f835452ebc4$var$getInclusionReasons;

var $6Ekzs = parcelRequire("6Ekzs");

var $ggwgA = parcelRequire("ggwgA");

var $6s1of = parcelRequire("6s1of");
function $547b4f835452ebc4$var$getInclusionReasons(item, targetVersions, list) {
    const minVersions = list[item] || {};
    return Object.keys(targetVersions).reduce((result, env)=>{
        const minVersion = (0, $6s1of.getLowestImplementedVersion)(minVersions, env);
        const targetVersion = targetVersions[env];
        if (!minVersion) result[env] = (0, $ggwgA.prettifyVersion)(targetVersion);
        else {
            const minIsUnreleased = (0, $6s1of.isUnreleasedVersion)(minVersion, env);
            const targetIsUnreleased = (0, $6s1of.isUnreleasedVersion)(targetVersion, env);
            if (!targetIsUnreleased && (minIsUnreleased || $6Ekzs.lt(targetVersion.toString(), (0, $6s1of.semverify)(minVersion)))) result[env] = (0, $ggwgA.prettifyVersion)(targetVersion);
        }
        return result;
    }, {});
}

});

parcelRegister("dyKy0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9df28eb37668fa82$var$filterItems;
module.exports.isRequired = $9df28eb37668fa82$var$isRequired;
module.exports.targetsSupported = $9df28eb37668fa82$var$targetsSupported;

var $6Ekzs = parcelRequire("6Ekzs");

var $cREFe = parcelRequire("cREFe");

var $6s1of = parcelRequire("6s1of");
function $9df28eb37668fa82$var$targetsSupported(target, support) {
    const targetEnvironments = Object.keys(target);
    if (targetEnvironments.length === 0) return false;
    const unsupportedEnvironments = targetEnvironments.filter((environment)=>{
        const lowestImplementedVersion = (0, $6s1of.getLowestImplementedVersion)(support, environment);
        if (!lowestImplementedVersion) return true;
        const lowestTargetedVersion = target[environment];
        if ((0, $6s1of.isUnreleasedVersion)(lowestTargetedVersion, environment)) return false;
        if ((0, $6s1of.isUnreleasedVersion)(lowestImplementedVersion, environment)) return true;
        if (!$6Ekzs.valid(lowestTargetedVersion.toString())) throw new Error(`Invalid version passed for target "${environment}": "${lowestTargetedVersion}". ` + "Versions must be in semver format (major.minor.patch)");
        return $6Ekzs.gt((0, $6s1of.semverify)(lowestImplementedVersion), lowestTargetedVersion.toString());
    });
    return unsupportedEnvironments.length === 0;
}
function $9df28eb37668fa82$var$isRequired(name, targets, { compatData: compatData = $cREFe, includes: includes, excludes: excludes } = {}) {
    if (excludes != null && excludes.has(name)) return false;
    if (includes != null && includes.has(name)) return true;
    return !$9df28eb37668fa82$var$targetsSupported(targets, compatData[name]);
}
function $9df28eb37668fa82$var$filterItems(list, includes, excludes, targets, defaultIncludes, defaultExcludes, pluginSyntaxMap) {
    const result = new Set();
    const options = {
        compatData: list,
        includes: includes,
        excludes: excludes
    };
    for(const item in list){
        if ($9df28eb37668fa82$var$isRequired(item, targets, options)) result.add(item);
        else if (pluginSyntaxMap) {
            const shippedProposalsSyntax = pluginSyntaxMap.get(item);
            if (shippedProposalsSyntax) result.add(shippedProposalsSyntax);
        }
    }
    defaultIncludes == null || defaultIncludes.forEach((item)=>!excludes.has(item) && result.add(item));
    defaultExcludes == null || defaultExcludes.forEach((item)=>!includes.has(item) && result.delete(item));
    return result;
}

});
parcelRegister("cREFe", function(module, exports) {

module.exports = (parcelRequire("4Qs6s"));

});
parcelRegister("4Qs6s", function(module, exports) {
module.exports = JSON.parse('{"transform-unicode-sets-regex":{"chrome":"112","opera":"98","edge":"112","firefox":"116","safari":"tp","node":"20","deno":"1.32","opera_mobile":"75","electron":"24.0"},"bugfix/transform-v8-static-class-fields-redefine-readonly":{"chrome":"98","opera":"84","edge":"98","firefox":"95","safari":"15","node":"12","deno":"1.18","ios":"15","samsung":"11","opera_mobile":"52","electron":"17.0"},"transform-class-static-block":{"chrome":"94","opera":"80","edge":"94","firefox":"93","safari":"16.4","node":"16.11","deno":"1.14","ios":"16.4","samsung":"17","opera_mobile":"66","electron":"15.0"},"proposal-class-static-block":{"chrome":"94","opera":"80","edge":"94","firefox":"93","safari":"16.4","node":"16.11","deno":"1.14","ios":"16.4","samsung":"17","opera_mobile":"66","electron":"15.0"},"transform-private-property-in-object":{"chrome":"91","opera":"77","edge":"91","firefox":"90","safari":"15","node":"16.9","deno":"1.9","ios":"15","samsung":"16","opera_mobile":"64","electron":"13.0"},"proposal-private-property-in-object":{"chrome":"91","opera":"77","edge":"91","firefox":"90","safari":"15","node":"16.9","deno":"1.9","ios":"15","samsung":"16","opera_mobile":"64","electron":"13.0"},"transform-class-properties":{"chrome":"74","opera":"62","edge":"79","firefox":"90","safari":"14.1","node":"12","deno":"1","ios":"14.5","samsung":"11","opera_mobile":"53","electron":"6.0"},"proposal-class-properties":{"chrome":"74","opera":"62","edge":"79","firefox":"90","safari":"14.1","node":"12","deno":"1","ios":"14.5","samsung":"11","opera_mobile":"53","electron":"6.0"},"transform-private-methods":{"chrome":"84","opera":"70","edge":"84","firefox":"90","safari":"15","node":"14.6","deno":"1","ios":"15","samsung":"14","opera_mobile":"60","electron":"10.0"},"proposal-private-methods":{"chrome":"84","opera":"70","edge":"84","firefox":"90","safari":"15","node":"14.6","deno":"1","ios":"15","samsung":"14","opera_mobile":"60","electron":"10.0"},"transform-numeric-separator":{"chrome":"75","opera":"62","edge":"79","firefox":"70","safari":"13","node":"12.5","deno":"1","ios":"13","samsung":"11","rhino":"1.7.14","opera_mobile":"54","electron":"6.0"},"proposal-numeric-separator":{"chrome":"75","opera":"62","edge":"79","firefox":"70","safari":"13","node":"12.5","deno":"1","ios":"13","samsung":"11","rhino":"1.7.14","opera_mobile":"54","electron":"6.0"},"transform-logical-assignment-operators":{"chrome":"85","opera":"71","edge":"85","firefox":"79","safari":"14","node":"15","deno":"1.2","ios":"14","samsung":"14","opera_mobile":"60","electron":"10.0"},"proposal-logical-assignment-operators":{"chrome":"85","opera":"71","edge":"85","firefox":"79","safari":"14","node":"15","deno":"1.2","ios":"14","samsung":"14","opera_mobile":"60","electron":"10.0"},"transform-nullish-coalescing-operator":{"chrome":"80","opera":"67","edge":"80","firefox":"72","safari":"13.1","node":"14","deno":"1","ios":"13.4","samsung":"13","opera_mobile":"57","electron":"8.0"},"proposal-nullish-coalescing-operator":{"chrome":"80","opera":"67","edge":"80","firefox":"72","safari":"13.1","node":"14","deno":"1","ios":"13.4","samsung":"13","opera_mobile":"57","electron":"8.0"},"transform-optional-chaining":{"chrome":"91","opera":"77","edge":"91","firefox":"74","safari":"13.1","node":"16.9","deno":"1.9","ios":"13.4","samsung":"16","opera_mobile":"64","electron":"13.0"},"proposal-optional-chaining":{"chrome":"91","opera":"77","edge":"91","firefox":"74","safari":"13.1","node":"16.9","deno":"1.9","ios":"13.4","samsung":"16","opera_mobile":"64","electron":"13.0"},"transform-json-strings":{"chrome":"66","opera":"53","edge":"79","firefox":"62","safari":"12","node":"10","deno":"1","ios":"12","samsung":"9","rhino":"1.7.14","opera_mobile":"47","electron":"3.0"},"proposal-json-strings":{"chrome":"66","opera":"53","edge":"79","firefox":"62","safari":"12","node":"10","deno":"1","ios":"12","samsung":"9","rhino":"1.7.14","opera_mobile":"47","electron":"3.0"},"transform-optional-catch-binding":{"chrome":"66","opera":"53","edge":"79","firefox":"58","safari":"11.1","node":"10","deno":"1","ios":"11.3","samsung":"9","opera_mobile":"47","electron":"3.0"},"proposal-optional-catch-binding":{"chrome":"66","opera":"53","edge":"79","firefox":"58","safari":"11.1","node":"10","deno":"1","ios":"11.3","samsung":"9","opera_mobile":"47","electron":"3.0"},"transform-parameters":{"chrome":"49","opera":"36","edge":"18","firefox":"53","safari":"16.3","node":"6","deno":"1","ios":"16.3","samsung":"5","opera_mobile":"36","electron":"0.37"},"transform-async-generator-functions":{"chrome":"63","opera":"50","edge":"79","firefox":"57","safari":"12","node":"10","deno":"1","ios":"12","samsung":"8","opera_mobile":"46","electron":"3.0"},"proposal-async-generator-functions":{"chrome":"63","opera":"50","edge":"79","firefox":"57","safari":"12","node":"10","deno":"1","ios":"12","samsung":"8","opera_mobile":"46","electron":"3.0"},"transform-object-rest-spread":{"chrome":"60","opera":"47","edge":"79","firefox":"55","safari":"11.1","node":"8.3","deno":"1","ios":"11.3","samsung":"8","opera_mobile":"44","electron":"2.0"},"proposal-object-rest-spread":{"chrome":"60","opera":"47","edge":"79","firefox":"55","safari":"11.1","node":"8.3","deno":"1","ios":"11.3","samsung":"8","opera_mobile":"44","electron":"2.0"},"transform-dotall-regex":{"chrome":"62","opera":"49","edge":"79","firefox":"78","safari":"11.1","node":"8.10","deno":"1","ios":"11.3","samsung":"8","opera_mobile":"46","electron":"3.0"},"transform-unicode-property-regex":{"chrome":"64","opera":"51","edge":"79","firefox":"78","safari":"11.1","node":"10","deno":"1","ios":"11.3","samsung":"9","opera_mobile":"47","electron":"3.0"},"proposal-unicode-property-regex":{"chrome":"64","opera":"51","edge":"79","firefox":"78","safari":"11.1","node":"10","deno":"1","ios":"11.3","samsung":"9","opera_mobile":"47","electron":"3.0"},"transform-named-capturing-groups-regex":{"chrome":"64","opera":"51","edge":"79","firefox":"78","safari":"11.1","node":"10","deno":"1","ios":"11.3","samsung":"9","opera_mobile":"47","electron":"3.0"},"transform-async-to-generator":{"chrome":"55","opera":"42","edge":"15","firefox":"52","safari":"11","node":"7.6","deno":"1","ios":"11","samsung":"6","opera_mobile":"42","electron":"1.6"},"transform-exponentiation-operator":{"chrome":"52","opera":"39","edge":"14","firefox":"52","safari":"10.1","node":"7","deno":"1","ios":"10.3","samsung":"6","rhino":"1.7.14","opera_mobile":"41","electron":"1.3"},"transform-template-literals":{"chrome":"41","opera":"28","edge":"13","firefox":"34","safari":"13","node":"4","deno":"1","ios":"13","samsung":"3.4","opera_mobile":"28","electron":"0.21"},"transform-literals":{"chrome":"44","opera":"31","edge":"12","firefox":"53","safari":"9","node":"4","deno":"1","ios":"9","samsung":"4","opera_mobile":"32","electron":"0.30"},"transform-function-name":{"chrome":"51","opera":"38","edge":"79","firefox":"53","safari":"10","node":"6.5","deno":"1","ios":"10","samsung":"5","opera_mobile":"41","electron":"1.2"},"transform-arrow-functions":{"chrome":"47","opera":"34","edge":"13","firefox":"43","safari":"10","node":"6","deno":"1","ios":"10","samsung":"5","rhino":"1.7.13","opera_mobile":"34","electron":"0.36"},"transform-block-scoped-functions":{"chrome":"41","opera":"28","edge":"12","firefox":"46","safari":"10","node":"4","deno":"1","ie":"11","ios":"10","samsung":"3.4","opera_mobile":"28","electron":"0.21"},"transform-classes":{"chrome":"46","opera":"33","edge":"13","firefox":"45","safari":"10","node":"5","deno":"1","ios":"10","samsung":"5","opera_mobile":"33","electron":"0.36"},"transform-object-super":{"chrome":"46","opera":"33","edge":"13","firefox":"45","safari":"10","node":"5","deno":"1","ios":"10","samsung":"5","opera_mobile":"33","electron":"0.36"},"transform-shorthand-properties":{"chrome":"43","opera":"30","edge":"12","firefox":"33","safari":"9","node":"4","deno":"1","ios":"9","samsung":"4","rhino":"1.7.14","opera_mobile":"30","electron":"0.27"},"transform-duplicate-keys":{"chrome":"42","opera":"29","edge":"12","firefox":"34","safari":"9","node":"4","deno":"1","ios":"9","samsung":"3.4","opera_mobile":"29","electron":"0.25"},"transform-computed-properties":{"chrome":"44","opera":"31","edge":"12","firefox":"34","safari":"7.1","node":"4","deno":"1","ios":"8","samsung":"4","opera_mobile":"32","electron":"0.30"},"transform-for-of":{"chrome":"51","opera":"38","edge":"15","firefox":"53","safari":"10","node":"6.5","deno":"1","ios":"10","samsung":"5","opera_mobile":"41","electron":"1.2"},"transform-sticky-regex":{"chrome":"49","opera":"36","edge":"13","firefox":"3","safari":"10","node":"6","deno":"1","ios":"10","samsung":"5","opera_mobile":"36","electron":"0.37"},"transform-unicode-escapes":{"chrome":"44","opera":"31","edge":"12","firefox":"53","safari":"9","node":"4","deno":"1","ios":"9","samsung":"4","opera_mobile":"32","electron":"0.30"},"transform-unicode-regex":{"chrome":"50","opera":"37","edge":"13","firefox":"46","safari":"12","node":"6","deno":"1","ios":"12","samsung":"5","opera_mobile":"37","electron":"1.1"},"transform-spread":{"chrome":"46","opera":"33","edge":"13","firefox":"45","safari":"10","node":"5","deno":"1","ios":"10","samsung":"5","opera_mobile":"33","electron":"0.36"},"transform-destructuring":{"chrome":"51","opera":"38","edge":"15","firefox":"53","safari":"10","node":"6.5","deno":"1","ios":"10","samsung":"5","opera_mobile":"41","electron":"1.2"},"transform-block-scoping":{"chrome":"50","opera":"37","edge":"14","firefox":"53","safari":"11","node":"6","deno":"1","ios":"11","samsung":"5","opera_mobile":"37","electron":"1.1"},"transform-typeof-symbol":{"chrome":"38","opera":"25","edge":"12","firefox":"36","safari":"9","node":"0.12","deno":"1","ios":"9","samsung":"3","rhino":"1.7.13","opera_mobile":"25","electron":"0.20"},"transform-new-target":{"chrome":"46","opera":"33","edge":"14","firefox":"41","safari":"10","node":"5","deno":"1","ios":"10","samsung":"5","opera_mobile":"33","electron":"0.36"},"transform-regenerator":{"chrome":"50","opera":"37","edge":"13","firefox":"53","safari":"10","node":"6","deno":"1","ios":"10","samsung":"5","opera_mobile":"37","electron":"1.1"},"transform-member-expression-literals":{"chrome":"7","opera":"12","edge":"12","firefox":"2","safari":"5.1","node":"0.4","deno":"1","ie":"9","android":"4","ios":"6","phantom":"1.9","samsung":"1","rhino":"1.7.13","opera_mobile":"12","electron":"0.20"},"transform-property-literals":{"chrome":"7","opera":"12","edge":"12","firefox":"2","safari":"5.1","node":"0.4","deno":"1","ie":"9","android":"4","ios":"6","phantom":"1.9","samsung":"1","rhino":"1.7.13","opera_mobile":"12","electron":"0.20"},"transform-reserved-words":{"chrome":"13","opera":"10.50","edge":"12","firefox":"2","safari":"3.1","node":"0.6","deno":"1","ie":"9","android":"4.4","ios":"6","phantom":"1.9","samsung":"1","rhino":"1.7.13","opera_mobile":"10.1","electron":"0.20"},"transform-export-namespace-from":{"chrome":"72","deno":"1.0","edge":"79","firefox":"80","node":"13.2","opera":"60","opera_mobile":"51","safari":"14.1","ios":"14.5","samsung":"11.0","android":"72","electron":"5.0"},"proposal-export-namespace-from":{"chrome":"72","deno":"1.0","edge":"79","firefox":"80","node":"13.2","opera":"60","opera_mobile":"51","safari":"14.1","ios":"14.5","samsung":"11.0","android":"72","electron":"5.0"}}');

});







parcelRegister("hGEb1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.buildPresetChain = $ce05862a32c13715$var$buildPresetChain;
module.exports.buildPresetChainWalker = void 0;
module.exports.buildRootChain = $ce05862a32c13715$var$buildRootChain;

function $ce05862a32c13715$var$_path() {
    const data = (parcelRequire("59kwG"));
    $ce05862a32c13715$var$_path = function() {
        return data;
    };
    return data;
}

function $ce05862a32c13715$var$_debug() {
    const data = (parcelRequire("1SXIy"));
    $ce05862a32c13715$var$_debug = function() {
        return data;
    };
    return data;
}

var $kF3s2 = parcelRequire("kF3s2");

var $aqSp8 = parcelRequire("aqSp8");

var $ll0uj = parcelRequire("ll0uj");

var $jYXMt = parcelRequire("jYXMt");

var $jHKkq = parcelRequire("jHKkq");

var $4h8hI = parcelRequire("4h8hI");

var $jaXHj = parcelRequire("jaXHj");

var $b7pIp = parcelRequire("b7pIp");
const $ce05862a32c13715$var$debug = $ce05862a32c13715$var$_debug()("babel:config:config-chain");
function* $ce05862a32c13715$var$buildPresetChain(arg, context) {
    const chain = yield* $ce05862a32c13715$var$buildPresetChainWalker(arg, context);
    if (!chain) return null;
    return {
        plugins: $ce05862a32c13715$var$dedupDescriptors(chain.plugins),
        presets: $ce05862a32c13715$var$dedupDescriptors(chain.presets),
        options: chain.options.map((o)=>$ce05862a32c13715$var$normalizeOptions(o)),
        files: new Set()
    };
}
const $ce05862a32c13715$var$buildPresetChainWalker = module.exports.buildPresetChainWalker = $ce05862a32c13715$var$makeChainWalker({
    root: (preset)=>$ce05862a32c13715$var$loadPresetDescriptors(preset),
    env: (preset, envName)=>$ce05862a32c13715$var$loadPresetEnvDescriptors(preset)(envName),
    overrides: (preset, index)=>$ce05862a32c13715$var$loadPresetOverridesDescriptors(preset)(index),
    overridesEnv: (preset, index, envName)=>$ce05862a32c13715$var$loadPresetOverridesEnvDescriptors(preset)(index)(envName),
    createLogger: ()=>()=>{}
});
const $ce05862a32c13715$var$loadPresetDescriptors = (0, $jaXHj.makeWeakCacheSync)((preset)=>$ce05862a32c13715$var$buildRootDescriptors(preset, preset.alias, $b7pIp.createUncachedDescriptors));
const $ce05862a32c13715$var$loadPresetEnvDescriptors = (0, $jaXHj.makeWeakCacheSync)((preset)=>(0, $jaXHj.makeStrongCacheSync)((envName)=>$ce05862a32c13715$var$buildEnvDescriptors(preset, preset.alias, $b7pIp.createUncachedDescriptors, envName)));
const $ce05862a32c13715$var$loadPresetOverridesDescriptors = (0, $jaXHj.makeWeakCacheSync)((preset)=>(0, $jaXHj.makeStrongCacheSync)((index)=>$ce05862a32c13715$var$buildOverrideDescriptors(preset, preset.alias, $b7pIp.createUncachedDescriptors, index)));
const $ce05862a32c13715$var$loadPresetOverridesEnvDescriptors = (0, $jaXHj.makeWeakCacheSync)((preset)=>(0, $jaXHj.makeStrongCacheSync)((index)=>(0, $jaXHj.makeStrongCacheSync)((envName)=>$ce05862a32c13715$var$buildOverrideEnvDescriptors(preset, preset.alias, $b7pIp.createUncachedDescriptors, index, envName))));
function* $ce05862a32c13715$var$buildRootChain(opts, context) {
    let configReport, babelRcReport;
    const programmaticLogger = new $ll0uj.ConfigPrinter();
    const programmaticChain = yield* $ce05862a32c13715$var$loadProgrammaticChain({
        options: opts,
        dirname: context.cwd
    }, context, undefined, programmaticLogger);
    if (!programmaticChain) return null;
    const programmaticReport = yield* programmaticLogger.output();
    let configFile;
    if (typeof opts.configFile === "string") configFile = yield* (0, $4h8hI.loadConfig)(opts.configFile, context.cwd, context.envName, context.caller);
    else if (opts.configFile !== false) configFile = yield* (0, $4h8hI.findRootConfig)(context.root, context.envName, context.caller);
    let { babelrc: babelrc, babelrcRoots: babelrcRoots } = opts;
    let babelrcRootsDirectory = context.cwd;
    const configFileChain = $ce05862a32c13715$var$emptyChain();
    const configFileLogger = new $ll0uj.ConfigPrinter();
    if (configFile) {
        const validatedFile = $ce05862a32c13715$var$validateConfigFile(configFile);
        const result = yield* $ce05862a32c13715$var$loadFileChain(validatedFile, context, undefined, configFileLogger);
        if (!result) return null;
        configReport = yield* configFileLogger.output();
        if (babelrc === undefined) babelrc = validatedFile.options.babelrc;
        if (babelrcRoots === undefined) {
            babelrcRootsDirectory = validatedFile.dirname;
            babelrcRoots = validatedFile.options.babelrcRoots;
        }
        $ce05862a32c13715$var$mergeChain(configFileChain, result);
    }
    let ignoreFile, babelrcFile;
    let isIgnored = false;
    const fileChain = $ce05862a32c13715$var$emptyChain();
    if ((babelrc === true || babelrc === undefined) && typeof context.filename === "string") {
        const pkgData = yield* (0, $4h8hI.findPackageData)(context.filename);
        if (pkgData && $ce05862a32c13715$var$babelrcLoadEnabled(context, pkgData, babelrcRoots, babelrcRootsDirectory)) {
            ({ ignore: ignoreFile, config: babelrcFile } = yield* (0, $4h8hI.findRelativeConfig)(pkgData, context.envName, context.caller));
            if (ignoreFile) fileChain.files.add(ignoreFile.filepath);
            if (ignoreFile && $ce05862a32c13715$var$shouldIgnore(context, ignoreFile.ignore, null, ignoreFile.dirname)) isIgnored = true;
            if (babelrcFile && !isIgnored) {
                const validatedFile = $ce05862a32c13715$var$validateBabelrcFile(babelrcFile);
                const babelrcLogger = new $ll0uj.ConfigPrinter();
                const result = yield* $ce05862a32c13715$var$loadFileChain(validatedFile, context, undefined, babelrcLogger);
                if (!result) isIgnored = true;
                else {
                    babelRcReport = yield* babelrcLogger.output();
                    $ce05862a32c13715$var$mergeChain(fileChain, result);
                }
            }
            if (babelrcFile && isIgnored) fileChain.files.add(babelrcFile.filepath);
        }
    }
    if (context.showConfig) console.log(`Babel configs on "${context.filename}" (ascending priority):\n` + [
        configReport,
        babelRcReport,
        programmaticReport
    ].filter((x)=>!!x).join("\n\n") + "\n-----End Babel configs-----");
    const chain = $ce05862a32c13715$var$mergeChain($ce05862a32c13715$var$mergeChain($ce05862a32c13715$var$mergeChain($ce05862a32c13715$var$emptyChain(), configFileChain), fileChain), programmaticChain);
    return {
        plugins: isIgnored ? [] : $ce05862a32c13715$var$dedupDescriptors(chain.plugins),
        presets: isIgnored ? [] : $ce05862a32c13715$var$dedupDescriptors(chain.presets),
        options: isIgnored ? [] : chain.options.map((o)=>$ce05862a32c13715$var$normalizeOptions(o)),
        fileHandling: isIgnored ? "ignored" : "transpile",
        ignore: ignoreFile || undefined,
        babelrc: babelrcFile || undefined,
        config: configFile || undefined,
        files: chain.files
    };
}
function $ce05862a32c13715$var$babelrcLoadEnabled(context, pkgData, babelrcRoots, babelrcRootsDirectory) {
    if (typeof babelrcRoots === "boolean") return babelrcRoots;
    const absoluteRoot = context.root;
    if (babelrcRoots === undefined) return pkgData.directories.indexOf(absoluteRoot) !== -1;
    let babelrcPatterns = babelrcRoots;
    if (!Array.isArray(babelrcPatterns)) babelrcPatterns = [
        babelrcPatterns
    ];
    babelrcPatterns = babelrcPatterns.map((pat)=>{
        return typeof pat === "string" ? $ce05862a32c13715$var$_path().resolve(babelrcRootsDirectory, pat) : pat;
    });
    if (babelrcPatterns.length === 1 && babelrcPatterns[0] === absoluteRoot) return pkgData.directories.indexOf(absoluteRoot) !== -1;
    return babelrcPatterns.some((pat)=>{
        if (typeof pat === "string") pat = (0, $aqSp8.default)(pat, babelrcRootsDirectory);
        return pkgData.directories.some((directory)=>{
            return $ce05862a32c13715$var$matchPattern(pat, babelrcRootsDirectory, directory, context);
        });
    });
}
const $ce05862a32c13715$var$validateConfigFile = (0, $jaXHj.makeWeakCacheSync)((file)=>({
        filepath: file.filepath,
        dirname: file.dirname,
        options: (0, $kF3s2.validate)("configfile", file.options, file.filepath)
    }));
const $ce05862a32c13715$var$validateBabelrcFile = (0, $jaXHj.makeWeakCacheSync)((file)=>({
        filepath: file.filepath,
        dirname: file.dirname,
        options: (0, $kF3s2.validate)("babelrcfile", file.options, file.filepath)
    }));
const $ce05862a32c13715$var$validateExtendFile = (0, $jaXHj.makeWeakCacheSync)((file)=>({
        filepath: file.filepath,
        dirname: file.dirname,
        options: (0, $kF3s2.validate)("extendsfile", file.options, file.filepath)
    }));
const $ce05862a32c13715$var$loadProgrammaticChain = $ce05862a32c13715$var$makeChainWalker({
    root: (input)=>$ce05862a32c13715$var$buildRootDescriptors(input, "base", $b7pIp.createCachedDescriptors),
    env: (input, envName)=>$ce05862a32c13715$var$buildEnvDescriptors(input, "base", $b7pIp.createCachedDescriptors, envName),
    overrides: (input, index)=>$ce05862a32c13715$var$buildOverrideDescriptors(input, "base", $b7pIp.createCachedDescriptors, index),
    overridesEnv: (input, index, envName)=>$ce05862a32c13715$var$buildOverrideEnvDescriptors(input, "base", $b7pIp.createCachedDescriptors, index, envName),
    createLogger: (input, context, baseLogger)=>$ce05862a32c13715$var$buildProgrammaticLogger(input, context, baseLogger)
});
const $ce05862a32c13715$var$loadFileChainWalker = $ce05862a32c13715$var$makeChainWalker({
    root: (file)=>$ce05862a32c13715$var$loadFileDescriptors(file),
    env: (file, envName)=>$ce05862a32c13715$var$loadFileEnvDescriptors(file)(envName),
    overrides: (file, index)=>$ce05862a32c13715$var$loadFileOverridesDescriptors(file)(index),
    overridesEnv: (file, index, envName)=>$ce05862a32c13715$var$loadFileOverridesEnvDescriptors(file)(index)(envName),
    createLogger: (file, context, baseLogger)=>$ce05862a32c13715$var$buildFileLogger(file.filepath, context, baseLogger)
});
function* $ce05862a32c13715$var$loadFileChain(input, context, files, baseLogger) {
    const chain = yield* $ce05862a32c13715$var$loadFileChainWalker(input, context, files, baseLogger);
    chain == null || chain.files.add(input.filepath);
    return chain;
}
const $ce05862a32c13715$var$loadFileDescriptors = (0, $jaXHj.makeWeakCacheSync)((file)=>$ce05862a32c13715$var$buildRootDescriptors(file, file.filepath, $b7pIp.createUncachedDescriptors));
const $ce05862a32c13715$var$loadFileEnvDescriptors = (0, $jaXHj.makeWeakCacheSync)((file)=>(0, $jaXHj.makeStrongCacheSync)((envName)=>$ce05862a32c13715$var$buildEnvDescriptors(file, file.filepath, $b7pIp.createUncachedDescriptors, envName)));
const $ce05862a32c13715$var$loadFileOverridesDescriptors = (0, $jaXHj.makeWeakCacheSync)((file)=>(0, $jaXHj.makeStrongCacheSync)((index)=>$ce05862a32c13715$var$buildOverrideDescriptors(file, file.filepath, $b7pIp.createUncachedDescriptors, index)));
const $ce05862a32c13715$var$loadFileOverridesEnvDescriptors = (0, $jaXHj.makeWeakCacheSync)((file)=>(0, $jaXHj.makeStrongCacheSync)((index)=>(0, $jaXHj.makeStrongCacheSync)((envName)=>$ce05862a32c13715$var$buildOverrideEnvDescriptors(file, file.filepath, $b7pIp.createUncachedDescriptors, index, envName))));
function $ce05862a32c13715$var$buildFileLogger(filepath, context, baseLogger) {
    if (!baseLogger) return ()=>{};
    return baseLogger.configure(context.showConfig, $ll0uj.ChainFormatter.Config, {
        filepath: filepath
    });
}
function $ce05862a32c13715$var$buildRootDescriptors({ dirname: dirname, options: options }, alias, descriptors) {
    return descriptors(dirname, options, alias);
}
function $ce05862a32c13715$var$buildProgrammaticLogger(_, context, baseLogger) {
    var _context$caller;
    if (!baseLogger) return ()=>{};
    return baseLogger.configure(context.showConfig, $ll0uj.ChainFormatter.Programmatic, {
        callerName: (_context$caller = context.caller) == null ? void 0 : _context$caller.name
    });
}
function $ce05862a32c13715$var$buildEnvDescriptors({ dirname: dirname, options: options }, alias, descriptors, envName) {
    var _options$env;
    const opts = (_options$env = options.env) == null ? void 0 : _options$env[envName];
    return opts ? descriptors(dirname, opts, `${alias}.env["${envName}"]`) : null;
}
function $ce05862a32c13715$var$buildOverrideDescriptors({ dirname: dirname, options: options }, alias, descriptors, index) {
    var _options$overrides;
    const opts = (_options$overrides = options.overrides) == null ? void 0 : _options$overrides[index];
    if (!opts) throw new Error("Assertion failure - missing override");
    return descriptors(dirname, opts, `${alias}.overrides[${index}]`);
}
function $ce05862a32c13715$var$buildOverrideEnvDescriptors({ dirname: dirname, options: options }, alias, descriptors, index, envName) {
    var _options$overrides2, _override$env;
    const override = (_options$overrides2 = options.overrides) == null ? void 0 : _options$overrides2[index];
    if (!override) throw new Error("Assertion failure - missing override");
    const opts = (_override$env = override.env) == null ? void 0 : _override$env[envName];
    return opts ? descriptors(dirname, opts, `${alias}.overrides[${index}].env["${envName}"]`) : null;
}
function $ce05862a32c13715$var$makeChainWalker({ root: root, env: env, overrides: overrides, overridesEnv: overridesEnv, createLogger: createLogger }) {
    return function* chainWalker(input, context, files = new Set(), baseLogger) {
        const { dirname: dirname } = input;
        const flattenedConfigs = [];
        const rootOpts = root(input);
        if ($ce05862a32c13715$var$configIsApplicable(rootOpts, dirname, context, input.filepath)) {
            flattenedConfigs.push({
                config: rootOpts,
                envName: undefined,
                index: undefined
            });
            const envOpts = env(input, context.envName);
            if (envOpts && $ce05862a32c13715$var$configIsApplicable(envOpts, dirname, context, input.filepath)) flattenedConfigs.push({
                config: envOpts,
                envName: context.envName,
                index: undefined
            });
            (rootOpts.options.overrides || []).forEach((_, index)=>{
                const overrideOps = overrides(input, index);
                if ($ce05862a32c13715$var$configIsApplicable(overrideOps, dirname, context, input.filepath)) {
                    flattenedConfigs.push({
                        config: overrideOps,
                        index: index,
                        envName: undefined
                    });
                    const overrideEnvOpts = overridesEnv(input, index, context.envName);
                    if (overrideEnvOpts && $ce05862a32c13715$var$configIsApplicable(overrideEnvOpts, dirname, context, input.filepath)) flattenedConfigs.push({
                        config: overrideEnvOpts,
                        index: index,
                        envName: context.envName
                    });
                }
            });
        }
        if (flattenedConfigs.some(({ config: { options: { ignore: ignore, only: only } } })=>$ce05862a32c13715$var$shouldIgnore(context, ignore, only, dirname))) return null;
        const chain = $ce05862a32c13715$var$emptyChain();
        const logger = createLogger(input, context, baseLogger);
        for (const { config: config, index: index, envName: envName } of flattenedConfigs){
            if (!(yield* $ce05862a32c13715$var$mergeExtendsChain(chain, config.options, dirname, context, files, baseLogger))) return null;
            logger(config, index, envName);
            yield* $ce05862a32c13715$var$mergeChainOpts(chain, config);
        }
        return chain;
    };
}
function* $ce05862a32c13715$var$mergeExtendsChain(chain, opts, dirname, context, files, baseLogger) {
    if (opts.extends === undefined) return true;
    const file = yield* (0, $4h8hI.loadConfig)(opts.extends, dirname, context.envName, context.caller);
    if (files.has(file)) throw new Error(`Configuration cycle detected loading ${file.filepath}.\n` + `File already loaded following the config chain:\n` + Array.from(files, (file)=>` - ${file.filepath}`).join("\n"));
    files.add(file);
    const fileChain = yield* $ce05862a32c13715$var$loadFileChain($ce05862a32c13715$var$validateExtendFile(file), context, files, baseLogger);
    files.delete(file);
    if (!fileChain) return false;
    $ce05862a32c13715$var$mergeChain(chain, fileChain);
    return true;
}
function $ce05862a32c13715$var$mergeChain(target, source) {
    target.options.push(...source.options);
    target.plugins.push(...source.plugins);
    target.presets.push(...source.presets);
    for (const file of source.files)target.files.add(file);
    return target;
}
function* $ce05862a32c13715$var$mergeChainOpts(target, { options: options, plugins: plugins, presets: presets }) {
    target.options.push(options);
    target.plugins.push(...yield* plugins());
    target.presets.push(...yield* presets());
    return target;
}
function $ce05862a32c13715$var$emptyChain() {
    return {
        options: [],
        presets: [],
        plugins: [],
        files: new Set()
    };
}
function $ce05862a32c13715$var$normalizeOptions(opts) {
    const options = Object.assign({}, opts);
    delete options.extends;
    delete options.env;
    delete options.overrides;
    delete options.plugins;
    delete options.presets;
    delete options.passPerPreset;
    delete options.ignore;
    delete options.only;
    delete options.test;
    delete options.include;
    delete options.exclude;
    if (hasOwnProperty.call(options, "sourceMap")) {
        options.sourceMaps = options.sourceMap;
        delete options.sourceMap;
    }
    return options;
}
function $ce05862a32c13715$var$dedupDescriptors(items) {
    const map = new Map();
    const descriptors = [];
    for (const item of items)if (typeof item.value === "function") {
        const fnKey = item.value;
        let nameMap = map.get(fnKey);
        if (!nameMap) {
            nameMap = new Map();
            map.set(fnKey, nameMap);
        }
        let desc = nameMap.get(item.name);
        if (!desc) {
            desc = {
                value: item
            };
            descriptors.push(desc);
            if (!item.ownPass) nameMap.set(item.name, desc);
        } else desc.value = item;
    } else descriptors.push({
        value: item
    });
    return descriptors.reduce((acc, desc)=>{
        acc.push(desc.value);
        return acc;
    }, []);
}
function $ce05862a32c13715$var$configIsApplicable({ options: options }, dirname, context, configName) {
    return (options.test === undefined || $ce05862a32c13715$var$configFieldIsApplicable(context, options.test, dirname, configName)) && (options.include === undefined || $ce05862a32c13715$var$configFieldIsApplicable(context, options.include, dirname, configName)) && (options.exclude === undefined || !$ce05862a32c13715$var$configFieldIsApplicable(context, options.exclude, dirname, configName));
}
function $ce05862a32c13715$var$configFieldIsApplicable(context, test, dirname, configName) {
    const patterns = Array.isArray(test) ? test : [
        test
    ];
    return $ce05862a32c13715$var$matchesPatterns(context, patterns, dirname, configName);
}
function $ce05862a32c13715$var$ignoreListReplacer(_key, value) {
    if (value instanceof RegExp) return String(value);
    return value;
}
function $ce05862a32c13715$var$shouldIgnore(context, ignore, only, dirname) {
    if (ignore && $ce05862a32c13715$var$matchesPatterns(context, ignore, dirname)) {
        var _context$filename;
        const message = `No config is applied to "${(_context$filename = context.filename) != null ? _context$filename : "(unknown)"}" because it matches one of \`ignore: ${JSON.stringify(ignore, $ce05862a32c13715$var$ignoreListReplacer)}\` from "${dirname}"`;
        $ce05862a32c13715$var$debug(message);
        if (context.showConfig) console.log(message);
        return true;
    }
    if (only && !$ce05862a32c13715$var$matchesPatterns(context, only, dirname)) {
        var _context$filename2;
        const message = `No config is applied to "${(_context$filename2 = context.filename) != null ? _context$filename2 : "(unknown)"}" because it fails to match one of \`only: ${JSON.stringify(only, $ce05862a32c13715$var$ignoreListReplacer)}\` from "${dirname}"`;
        $ce05862a32c13715$var$debug(message);
        if (context.showConfig) console.log(message);
        return true;
    }
    return false;
}
function $ce05862a32c13715$var$matchesPatterns(context, patterns, dirname, configName) {
    return patterns.some((pattern)=>$ce05862a32c13715$var$matchPattern(pattern, dirname, context.filename, context, configName));
}
function $ce05862a32c13715$var$matchPattern(pattern, dirname, pathToTest, context, configName) {
    if (typeof pattern === "function") return !!(0, $jYXMt.endHiddenCallStack)(pattern)(pathToTest, {
        dirname: dirname,
        envName: context.envName,
        caller: context.caller
    });
    if (typeof pathToTest !== "string") throw new $jHKkq.default(`Configuration contains string/RegExp pattern, but no filename was passed to Babel`, configName);
    if (typeof pattern === "string") pattern = (0, $aqSp8.default)(pattern, dirname);
    return pattern.test(pathToTest);
}

});
parcelRegister("kF3s2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.assumptionsNames = void 0;
module.exports.checkNoUnwrappedItemOptionPairs = $f0aa5056235d759f$var$checkNoUnwrappedItemOptionPairs;
module.exports.validate = $f0aa5056235d759f$var$validate;

var $9KRIA = parcelRequire("9KRIA");

var $hgAim = parcelRequire("hgAim");

var $jHKkq = parcelRequire("jHKkq");
const $f0aa5056235d759f$var$ROOT_VALIDATORS = {
    cwd: $hgAim.assertString,
    root: $hgAim.assertString,
    rootMode: $hgAim.assertRootMode,
    configFile: $hgAim.assertConfigFileSearch,
    caller: $hgAim.assertCallerMetadata,
    filename: $hgAim.assertString,
    filenameRelative: $hgAim.assertString,
    code: $hgAim.assertBoolean,
    ast: $hgAim.assertBoolean,
    cloneInputAst: $hgAim.assertBoolean,
    envName: $hgAim.assertString
};
const $f0aa5056235d759f$var$BABELRC_VALIDATORS = {
    babelrc: $hgAim.assertBoolean,
    babelrcRoots: $hgAim.assertBabelrcSearch
};
const $f0aa5056235d759f$var$NONPRESET_VALIDATORS = {
    extends: $hgAim.assertString,
    ignore: $hgAim.assertIgnoreList,
    only: $hgAim.assertIgnoreList,
    targets: $hgAim.assertTargets,
    browserslistConfigFile: $hgAim.assertConfigFileSearch,
    browserslistEnv: $hgAim.assertString
};
const $f0aa5056235d759f$var$COMMON_VALIDATORS = {
    inputSourceMap: $hgAim.assertInputSourceMap,
    presets: $hgAim.assertPluginList,
    plugins: $hgAim.assertPluginList,
    passPerPreset: $hgAim.assertBoolean,
    assumptions: $hgAim.assertAssumptions,
    env: $f0aa5056235d759f$var$assertEnvSet,
    overrides: $f0aa5056235d759f$var$assertOverridesList,
    test: $hgAim.assertConfigApplicableTest,
    include: $hgAim.assertConfigApplicableTest,
    exclude: $hgAim.assertConfigApplicableTest,
    retainLines: $hgAim.assertBoolean,
    comments: $hgAim.assertBoolean,
    shouldPrintComment: $hgAim.assertFunction,
    compact: $hgAim.assertCompact,
    minified: $hgAim.assertBoolean,
    auxiliaryCommentBefore: $hgAim.assertString,
    auxiliaryCommentAfter: $hgAim.assertString,
    sourceType: $hgAim.assertSourceType,
    wrapPluginVisitorMethod: $hgAim.assertFunction,
    highlightCode: $hgAim.assertBoolean,
    sourceMaps: $hgAim.assertSourceMaps,
    sourceMap: $hgAim.assertSourceMaps,
    sourceFileName: $hgAim.assertString,
    sourceRoot: $hgAim.assertString,
    parserOpts: $hgAim.assertObject,
    generatorOpts: $hgAim.assertObject
};
Object.assign($f0aa5056235d759f$var$COMMON_VALIDATORS, {
    getModuleId: $hgAim.assertFunction,
    moduleRoot: $hgAim.assertString,
    moduleIds: $hgAim.assertBoolean,
    moduleId: $hgAim.assertString
});
const $f0aa5056235d759f$var$knownAssumptions = [
    "arrayLikeIsIterable",
    "constantReexports",
    "constantSuper",
    "enumerableModuleMeta",
    "ignoreFunctionLength",
    "ignoreToPrimitiveHint",
    "iterableIsArray",
    "mutableTemplateObject",
    "noClassCalls",
    "noDocumentAll",
    "noIncompleteNsImportDetection",
    "noNewArrows",
    "noUninitializedPrivateFieldAccess",
    "objectRestNoSymbols",
    "privateFieldsAsSymbols",
    "privateFieldsAsProperties",
    "pureGetters",
    "setClassMethods",
    "setComputedProperties",
    "setPublicClassFields",
    "setSpreadProperties",
    "skipForOfIteratorClosing",
    "superIsCallableConstructor"
];
const $f0aa5056235d759f$var$assumptionsNames = module.exports.assumptionsNames = new Set($f0aa5056235d759f$var$knownAssumptions);
function $f0aa5056235d759f$var$getSource(loc) {
    return loc.type === "root" ? loc.source : $f0aa5056235d759f$var$getSource(loc.parent);
}
function $f0aa5056235d759f$var$validate(type, opts, filename) {
    try {
        return $f0aa5056235d759f$var$validateNested({
            type: "root",
            source: type
        }, opts);
    } catch (error) {
        const configError = new $jHKkq.default(error.message, filename);
        if (error.code) configError.code = error.code;
        throw configError;
    }
}
function $f0aa5056235d759f$var$validateNested(loc, opts) {
    const type = $f0aa5056235d759f$var$getSource(loc);
    $f0aa5056235d759f$var$assertNoDuplicateSourcemap(opts);
    Object.keys(opts).forEach((key)=>{
        const optLoc = {
            type: "option",
            name: key,
            parent: loc
        };
        if (type === "preset" && $f0aa5056235d759f$var$NONPRESET_VALIDATORS[key]) throw new Error(`${(0, $hgAim.msg)(optLoc)} is not allowed in preset options`);
        if (type !== "arguments" && $f0aa5056235d759f$var$ROOT_VALIDATORS[key]) throw new Error(`${(0, $hgAim.msg)(optLoc)} is only allowed in root programmatic options`);
        if (type !== "arguments" && type !== "configfile" && $f0aa5056235d759f$var$BABELRC_VALIDATORS[key]) {
            if (type === "babelrcfile" || type === "extendsfile") throw new Error(`${(0, $hgAim.msg)(optLoc)} is not allowed in .babelrc or "extends"ed files, only in root programmatic options, ` + `or babel.config.js/config file options`);
            throw new Error(`${(0, $hgAim.msg)(optLoc)} is only allowed in root programmatic options, or babel.config.js/config file options`);
        }
        const validator = $f0aa5056235d759f$var$COMMON_VALIDATORS[key] || $f0aa5056235d759f$var$NONPRESET_VALIDATORS[key] || $f0aa5056235d759f$var$BABELRC_VALIDATORS[key] || $f0aa5056235d759f$var$ROOT_VALIDATORS[key] || $f0aa5056235d759f$var$throwUnknownError;
        validator(optLoc, opts[key]);
    });
    return opts;
}
function $f0aa5056235d759f$var$throwUnknownError(loc) {
    const key = loc.name;
    if ($9KRIA.default[key]) {
        const { message: message, version: version = 5 } = $9KRIA.default[key];
        throw new Error(`Using removed Babel ${version} option: ${(0, $hgAim.msg)(loc)} - ${message}`);
    } else {
        const unknownOptErr = new Error(`Unknown option: ${(0, $hgAim.msg)(loc)}. Check out https://babeljs.io/docs/en/babel-core/#options for more information about options.`);
        unknownOptErr.code = "BABEL_UNKNOWN_OPTION";
        throw unknownOptErr;
    }
}
function $f0aa5056235d759f$var$assertNoDuplicateSourcemap(opts) {
    if (hasOwnProperty.call(opts, "sourceMap") && hasOwnProperty.call(opts, "sourceMaps")) throw new Error(".sourceMap is an alias for .sourceMaps, cannot use both");
}
function $f0aa5056235d759f$var$assertEnvSet(loc, value) {
    if (loc.parent.type === "env") throw new Error(`${(0, $hgAim.msg)(loc)} is not allowed inside of another .env block`);
    const parent = loc.parent;
    const obj = (0, $hgAim.assertObject)(loc, value);
    if (obj) for (const envName of Object.keys(obj)){
        const env = (0, $hgAim.assertObject)((0, $hgAim.access)(loc, envName), obj[envName]);
        if (!env) continue;
        const envLoc = {
            type: "env",
            name: envName,
            parent: parent
        };
        $f0aa5056235d759f$var$validateNested(envLoc, env);
    }
    return obj;
}
function $f0aa5056235d759f$var$assertOverridesList(loc, value) {
    if (loc.parent.type === "env") throw new Error(`${(0, $hgAim.msg)(loc)} is not allowed inside an .env block`);
    if (loc.parent.type === "overrides") throw new Error(`${(0, $hgAim.msg)(loc)} is not allowed inside an .overrides block`);
    const parent = loc.parent;
    const arr = (0, $hgAim.assertArray)(loc, value);
    if (arr) for (const [index, item] of arr.entries()){
        const objLoc = (0, $hgAim.access)(loc, index);
        const env = (0, $hgAim.assertObject)(objLoc, item);
        if (!env) throw new Error(`${(0, $hgAim.msg)(objLoc)} must be an object`);
        const overridesLoc = {
            type: "overrides",
            index: index,
            parent: parent
        };
        $f0aa5056235d759f$var$validateNested(overridesLoc, env);
    }
    return arr;
}
function $f0aa5056235d759f$var$checkNoUnwrappedItemOptionPairs(items, index, type, e) {
    if (index === 0) return;
    const lastItem = items[index - 1];
    const thisItem = items[index];
    if (lastItem.file && lastItem.options === undefined && typeof thisItem.value === "object") e.message += `\n- Maybe you meant to use\n` + `"${type}s": [\n  ["${lastItem.file.request}", ${JSON.stringify(thisItem.value, undefined, 2)}]\n]\n` + `To be a valid ${type}, its name and options should be wrapped in a pair of brackets`;
}

});
parcelRegister("9KRIA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $71a21436e7d40350$var$_default = module.exports.default = {
    auxiliaryComment: {
        message: "Use `auxiliaryCommentBefore` or `auxiliaryCommentAfter`"
    },
    blacklist: {
        message: "Put the specific transforms you want in the `plugins` option"
    },
    breakConfig: {
        message: "This is not a necessary option in Babel 6"
    },
    experimental: {
        message: "Put the specific transforms you want in the `plugins` option"
    },
    externalHelpers: {
        message: "Use the `external-helpers` plugin instead. Check out http://babeljs.io/docs/plugins/external-helpers/"
    },
    extra: {
        message: ""
    },
    jsxPragma: {
        message: "use the `pragma` option in the `react-jsx` plugin. Check out http://babeljs.io/docs/plugins/transform-react-jsx/"
    },
    loose: {
        message: "Specify the `loose` option for the relevant plugin you are using or use a preset that sets the option."
    },
    metadataUsedHelpers: {
        message: "Not required anymore as this is enabled by default"
    },
    modules: {
        message: "Use the corresponding module transform plugin in the `plugins` option. Check out http://babeljs.io/docs/plugins/#modules"
    },
    nonStandard: {
        message: "Use the `react-jsx` and `flow-strip-types` plugins to support JSX and Flow. Also check out the react preset http://babeljs.io/docs/plugins/preset-react/"
    },
    optional: {
        message: "Put the specific transforms you want in the `plugins` option"
    },
    sourceMapName: {
        message: "The `sourceMapName` option has been removed because it makes more sense for the tooling that calls Babel to assign `map.file` themselves."
    },
    stage: {
        message: "Check out the corresponding stage-x presets http://babeljs.io/docs/plugins/#presets"
    },
    whitelist: {
        message: "Put the specific transforms you want in the `plugins` option"
    },
    resolveModuleSource: {
        version: 6,
        message: "Use `babel-plugin-module-resolver@3`'s 'resolvePath' options"
    },
    metadata: {
        version: 6,
        message: "Generated plugin metadata is always included in the output result"
    },
    sourceMapTarget: {
        version: 6,
        message: "The `sourceMapTarget` option has been removed because it makes more sense for the tooling that calls Babel to assign `map.file` themselves."
    }
};

});

parcelRegister("hgAim", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.access = $c92015bd971e076c$var$access;
module.exports.assertArray = $c92015bd971e076c$var$assertArray;
module.exports.assertAssumptions = $c92015bd971e076c$var$assertAssumptions;
module.exports.assertBabelrcSearch = $c92015bd971e076c$var$assertBabelrcSearch;
module.exports.assertBoolean = $c92015bd971e076c$var$assertBoolean;
module.exports.assertCallerMetadata = $c92015bd971e076c$var$assertCallerMetadata;
module.exports.assertCompact = $c92015bd971e076c$var$assertCompact;
module.exports.assertConfigApplicableTest = $c92015bd971e076c$var$assertConfigApplicableTest;
module.exports.assertConfigFileSearch = $c92015bd971e076c$var$assertConfigFileSearch;
module.exports.assertFunction = $c92015bd971e076c$var$assertFunction;
module.exports.assertIgnoreList = $c92015bd971e076c$var$assertIgnoreList;
module.exports.assertInputSourceMap = $c92015bd971e076c$var$assertInputSourceMap;
module.exports.assertObject = $c92015bd971e076c$var$assertObject;
module.exports.assertPluginList = $c92015bd971e076c$var$assertPluginList;
module.exports.assertRootMode = $c92015bd971e076c$var$assertRootMode;
module.exports.assertSourceMaps = $c92015bd971e076c$var$assertSourceMaps;
module.exports.assertSourceType = $c92015bd971e076c$var$assertSourceType;
module.exports.assertString = $c92015bd971e076c$var$assertString;
module.exports.assertTargets = $c92015bd971e076c$var$assertTargets;
module.exports.msg = $c92015bd971e076c$var$msg;

function $c92015bd971e076c$var$_helperCompilationTargets() {
    const data = (parcelRequire("4r0OE"));
    $c92015bd971e076c$var$_helperCompilationTargets = function() {
        return data;
    };
    return data;
}

var $kF3s2 = parcelRequire("kF3s2");
function $c92015bd971e076c$var$msg(loc) {
    switch(loc.type){
        case "root":
            return ``;
        case "env":
            return `${$c92015bd971e076c$var$msg(loc.parent)}.env["${loc.name}"]`;
        case "overrides":
            return `${$c92015bd971e076c$var$msg(loc.parent)}.overrides[${loc.index}]`;
        case "option":
            return `${$c92015bd971e076c$var$msg(loc.parent)}.${loc.name}`;
        case "access":
            return `${$c92015bd971e076c$var$msg(loc.parent)}[${JSON.stringify(loc.name)}]`;
        default:
            throw new Error(`Assertion failure: Unknown type ${loc.type}`);
    }
}
function $c92015bd971e076c$var$access(loc, name) {
    return {
        type: "access",
        name: name,
        parent: loc
    };
}
function $c92015bd971e076c$var$assertRootMode(loc, value) {
    if (value !== undefined && value !== "root" && value !== "upward" && value !== "upward-optional") throw new Error(`${$c92015bd971e076c$var$msg(loc)} must be a "root", "upward", "upward-optional" or undefined`);
    return value;
}
function $c92015bd971e076c$var$assertSourceMaps(loc, value) {
    if (value !== undefined && typeof value !== "boolean" && value !== "inline" && value !== "both") throw new Error(`${$c92015bd971e076c$var$msg(loc)} must be a boolean, "inline", "both", or undefined`);
    return value;
}
function $c92015bd971e076c$var$assertCompact(loc, value) {
    if (value !== undefined && typeof value !== "boolean" && value !== "auto") throw new Error(`${$c92015bd971e076c$var$msg(loc)} must be a boolean, "auto", or undefined`);
    return value;
}
function $c92015bd971e076c$var$assertSourceType(loc, value) {
    if (value !== undefined && value !== "module" && value !== "script" && value !== "unambiguous") throw new Error(`${$c92015bd971e076c$var$msg(loc)} must be "module", "script", "unambiguous", or undefined`);
    return value;
}
function $c92015bd971e076c$var$assertCallerMetadata(loc, value) {
    const obj = $c92015bd971e076c$var$assertObject(loc, value);
    if (obj) {
        if (typeof obj.name !== "string") throw new Error(`${$c92015bd971e076c$var$msg(loc)} set but does not contain "name" property string`);
        for (const prop of Object.keys(obj)){
            const propLoc = $c92015bd971e076c$var$access(loc, prop);
            const value = obj[prop];
            if (value != null && typeof value !== "boolean" && typeof value !== "string" && typeof value !== "number") throw new Error(`${$c92015bd971e076c$var$msg(propLoc)} must be null, undefined, a boolean, a string, or a number.`);
        }
    }
    return value;
}
function $c92015bd971e076c$var$assertInputSourceMap(loc, value) {
    if (value !== undefined && typeof value !== "boolean" && (typeof value !== "object" || !value)) throw new Error(`${$c92015bd971e076c$var$msg(loc)} must be a boolean, object, or undefined`);
    return value;
}
function $c92015bd971e076c$var$assertString(loc, value) {
    if (value !== undefined && typeof value !== "string") throw new Error(`${$c92015bd971e076c$var$msg(loc)} must be a string, or undefined`);
    return value;
}
function $c92015bd971e076c$var$assertFunction(loc, value) {
    if (value !== undefined && typeof value !== "function") throw new Error(`${$c92015bd971e076c$var$msg(loc)} must be a function, or undefined`);
    return value;
}
function $c92015bd971e076c$var$assertBoolean(loc, value) {
    if (value !== undefined && typeof value !== "boolean") throw new Error(`${$c92015bd971e076c$var$msg(loc)} must be a boolean, or undefined`);
    return value;
}
function $c92015bd971e076c$var$assertObject(loc, value) {
    if (value !== undefined && (typeof value !== "object" || Array.isArray(value) || !value)) throw new Error(`${$c92015bd971e076c$var$msg(loc)} must be an object, or undefined`);
    return value;
}
function $c92015bd971e076c$var$assertArray(loc, value) {
    if (value != null && !Array.isArray(value)) throw new Error(`${$c92015bd971e076c$var$msg(loc)} must be an array, or undefined`);
    return value;
}
function $c92015bd971e076c$var$assertIgnoreList(loc, value) {
    const arr = $c92015bd971e076c$var$assertArray(loc, value);
    arr == null || arr.forEach((item, i)=>$c92015bd971e076c$var$assertIgnoreItem($c92015bd971e076c$var$access(loc, i), item));
    return arr;
}
function $c92015bd971e076c$var$assertIgnoreItem(loc, value) {
    if (typeof value !== "string" && typeof value !== "function" && !(value instanceof RegExp)) throw new Error(`${$c92015bd971e076c$var$msg(loc)} must be an array of string/Function/RegExp values, or undefined`);
    return value;
}
function $c92015bd971e076c$var$assertConfigApplicableTest(loc, value) {
    if (value === undefined) return value;
    if (Array.isArray(value)) value.forEach((item, i)=>{
        if (!$c92015bd971e076c$var$checkValidTest(item)) throw new Error(`${$c92015bd971e076c$var$msg($c92015bd971e076c$var$access(loc, i))} must be a string/Function/RegExp.`);
    });
    else if (!$c92015bd971e076c$var$checkValidTest(value)) throw new Error(`${$c92015bd971e076c$var$msg(loc)} must be a string/Function/RegExp, or an array of those`);
    return value;
}
function $c92015bd971e076c$var$checkValidTest(value) {
    return typeof value === "string" || typeof value === "function" || value instanceof RegExp;
}
function $c92015bd971e076c$var$assertConfigFileSearch(loc, value) {
    if (value !== undefined && typeof value !== "boolean" && typeof value !== "string") throw new Error(`${$c92015bd971e076c$var$msg(loc)} must be a undefined, a boolean, a string, ` + `got ${JSON.stringify(value)}`);
    return value;
}
function $c92015bd971e076c$var$assertBabelrcSearch(loc, value) {
    if (value === undefined || typeof value === "boolean") return value;
    if (Array.isArray(value)) value.forEach((item, i)=>{
        if (!$c92015bd971e076c$var$checkValidTest(item)) throw new Error(`${$c92015bd971e076c$var$msg($c92015bd971e076c$var$access(loc, i))} must be a string/Function/RegExp.`);
    });
    else if (!$c92015bd971e076c$var$checkValidTest(value)) throw new Error(`${$c92015bd971e076c$var$msg(loc)} must be a undefined, a boolean, a string/Function/RegExp ` + `or an array of those, got ${JSON.stringify(value)}`);
    return value;
}
function $c92015bd971e076c$var$assertPluginList(loc, value) {
    const arr = $c92015bd971e076c$var$assertArray(loc, value);
    if (arr) arr.forEach((item, i)=>$c92015bd971e076c$var$assertPluginItem($c92015bd971e076c$var$access(loc, i), item));
    return arr;
}
function $c92015bd971e076c$var$assertPluginItem(loc, value) {
    if (Array.isArray(value)) {
        if (value.length === 0) throw new Error(`${$c92015bd971e076c$var$msg(loc)} must include an object`);
        if (value.length > 3) throw new Error(`${$c92015bd971e076c$var$msg(loc)} may only be a two-tuple or three-tuple`);
        $c92015bd971e076c$var$assertPluginTarget($c92015bd971e076c$var$access(loc, 0), value[0]);
        if (value.length > 1) {
            const opts = value[1];
            if (opts !== undefined && opts !== false && (typeof opts !== "object" || Array.isArray(opts) || opts === null)) throw new Error(`${$c92015bd971e076c$var$msg($c92015bd971e076c$var$access(loc, 1))} must be an object, false, or undefined`);
        }
        if (value.length === 3) {
            const name = value[2];
            if (name !== undefined && typeof name !== "string") throw new Error(`${$c92015bd971e076c$var$msg($c92015bd971e076c$var$access(loc, 2))} must be a string, or undefined`);
        }
    } else $c92015bd971e076c$var$assertPluginTarget(loc, value);
    return value;
}
function $c92015bd971e076c$var$assertPluginTarget(loc, value) {
    if ((typeof value !== "object" || !value) && typeof value !== "string" && typeof value !== "function") throw new Error(`${$c92015bd971e076c$var$msg(loc)} must be a string, object, function`);
    return value;
}
function $c92015bd971e076c$var$assertTargets(loc, value) {
    if ((0, $c92015bd971e076c$var$_helperCompilationTargets().isBrowsersQueryValid)(value)) return value;
    if (typeof value !== "object" || !value || Array.isArray(value)) throw new Error(`${$c92015bd971e076c$var$msg(loc)} must be a string, an array of strings or an object`);
    const browsersLoc = $c92015bd971e076c$var$access(loc, "browsers");
    const esmodulesLoc = $c92015bd971e076c$var$access(loc, "esmodules");
    $c92015bd971e076c$var$assertBrowsersList(browsersLoc, value.browsers);
    $c92015bd971e076c$var$assertBoolean(esmodulesLoc, value.esmodules);
    for (const key of Object.keys(value)){
        const val = value[key];
        const subLoc = $c92015bd971e076c$var$access(loc, key);
        if (key === "esmodules") $c92015bd971e076c$var$assertBoolean(subLoc, val);
        else if (key === "browsers") $c92015bd971e076c$var$assertBrowsersList(subLoc, val);
        else if (!hasOwnProperty.call($c92015bd971e076c$var$_helperCompilationTargets().TargetNames, key)) {
            const validTargets = Object.keys($c92015bd971e076c$var$_helperCompilationTargets().TargetNames).join(", ");
            throw new Error(`${$c92015bd971e076c$var$msg(subLoc)} is not a valid target. Supported targets are ${validTargets}`);
        } else $c92015bd971e076c$var$assertBrowserVersion(subLoc, val);
    }
    return value;
}
function $c92015bd971e076c$var$assertBrowsersList(loc, value) {
    if (value !== undefined && !(0, $c92015bd971e076c$var$_helperCompilationTargets().isBrowsersQueryValid)(value)) throw new Error(`${$c92015bd971e076c$var$msg(loc)} must be undefined, a string or an array of strings`);
}
function $c92015bd971e076c$var$assertBrowserVersion(loc, value) {
    if (typeof value === "number" && Math.round(value) === value) return;
    if (typeof value === "string") return;
    throw new Error(`${$c92015bd971e076c$var$msg(loc)} must be a string or an integer number`);
}
function $c92015bd971e076c$var$assertAssumptions(loc, value) {
    if (value === undefined) return;
    if (typeof value !== "object" || value === null) throw new Error(`${$c92015bd971e076c$var$msg(loc)} must be an object or undefined.`);
    let root = loc;
    do root = root.parent;
    while (root.type !== "root");
    const inPreset = root.source === "preset";
    for (const name of Object.keys(value)){
        const subLoc = $c92015bd971e076c$var$access(loc, name);
        if (!$kF3s2.assumptionsNames.has(name)) throw new Error(`${$c92015bd971e076c$var$msg(subLoc)} is not a supported assumption.`);
        if (typeof value[name] !== "boolean") throw new Error(`${$c92015bd971e076c$var$msg(subLoc)} must be a boolean.`);
        if (inPreset && value[name] === false) throw new Error(`${$c92015bd971e076c$var$msg(subLoc)} cannot be set to 'false' inside presets.`);
    }
    return value;
}

});

parcelRegister("jHKkq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $jYXMt = parcelRequire("jYXMt");
class $e585f85bf0dcec02$var$ConfigError extends Error {
    constructor(message, filename){
        super(message);
        (0, $jYXMt.expectedError)(this);
        if (filename) (0, $jYXMt.injectVirtualStackFrame)(this, filename);
    }
}
module.exports.default = $e585f85bf0dcec02$var$ConfigError;

});
parcelRegister("jYXMt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.beginHiddenCallStack = $e8c1fe21b205ad23$var$beginHiddenCallStack;
module.exports.endHiddenCallStack = $e8c1fe21b205ad23$var$endHiddenCallStack;
module.exports.expectedError = $e8c1fe21b205ad23$var$expectedError;
module.exports.injectVirtualStackFrame = $e8c1fe21b205ad23$var$injectVirtualStackFrame;
var $e8c1fe21b205ad23$var$_Object$getOwnPropert;
const $e8c1fe21b205ad23$var$ErrorToString = Function.call.bind(Error.prototype.toString);
const $e8c1fe21b205ad23$var$SUPPORTED = !!Error.captureStackTrace && (($e8c1fe21b205ad23$var$_Object$getOwnPropert = Object.getOwnPropertyDescriptor(Error, "stackTraceLimit")) == null ? void 0 : $e8c1fe21b205ad23$var$_Object$getOwnPropert.writable) === true;
const $e8c1fe21b205ad23$var$START_HIDING = "startHiding - secret - don't use this - v1";
const $e8c1fe21b205ad23$var$STOP_HIDING = "stopHiding - secret - don't use this - v1";
const $e8c1fe21b205ad23$var$expectedErrors = new WeakSet();
const $e8c1fe21b205ad23$var$virtualFrames = new WeakMap();
function $e8c1fe21b205ad23$var$CallSite(filename) {
    return Object.create({
        isNative: ()=>false,
        isConstructor: ()=>false,
        isToplevel: ()=>true,
        getFileName: ()=>filename,
        getLineNumber: ()=>undefined,
        getColumnNumber: ()=>undefined,
        getFunctionName: ()=>undefined,
        getMethodName: ()=>undefined,
        getTypeName: ()=>undefined,
        toString: ()=>filename
    });
}
function $e8c1fe21b205ad23$var$injectVirtualStackFrame(error, filename) {
    if (!$e8c1fe21b205ad23$var$SUPPORTED) return;
    let frames = $e8c1fe21b205ad23$var$virtualFrames.get(error);
    if (!frames) $e8c1fe21b205ad23$var$virtualFrames.set(error, frames = []);
    frames.push($e8c1fe21b205ad23$var$CallSite(filename));
    return error;
}
function $e8c1fe21b205ad23$var$expectedError(error) {
    if (!$e8c1fe21b205ad23$var$SUPPORTED) return;
    $e8c1fe21b205ad23$var$expectedErrors.add(error);
    return error;
}
function $e8c1fe21b205ad23$var$beginHiddenCallStack(fn) {
    if (!$e8c1fe21b205ad23$var$SUPPORTED) return fn;
    return Object.defineProperty(function(...args) {
        $e8c1fe21b205ad23$var$setupPrepareStackTrace();
        return fn(...args);
    }, "name", {
        value: $e8c1fe21b205ad23$var$STOP_HIDING
    });
}
function $e8c1fe21b205ad23$var$endHiddenCallStack(fn) {
    if (!$e8c1fe21b205ad23$var$SUPPORTED) return fn;
    return Object.defineProperty(function(...args) {
        return fn(...args);
    }, "name", {
        value: $e8c1fe21b205ad23$var$START_HIDING
    });
}
function $e8c1fe21b205ad23$var$setupPrepareStackTrace() {
    $e8c1fe21b205ad23$var$setupPrepareStackTrace = ()=>{};
    const { prepareStackTrace: prepareStackTrace = $e8c1fe21b205ad23$var$defaultPrepareStackTrace } = Error;
    const MIN_STACK_TRACE_LIMIT = 50;
    Error.stackTraceLimit && (Error.stackTraceLimit = Math.max(Error.stackTraceLimit, MIN_STACK_TRACE_LIMIT));
    Error.prepareStackTrace = function stackTraceRewriter(err, trace) {
        let newTrace = [];
        const isExpected = $e8c1fe21b205ad23$var$expectedErrors.has(err);
        let status = isExpected ? "hiding" : "unknown";
        for(let i = 0; i < trace.length; i++){
            const name = trace[i].getFunctionName();
            if (name === $e8c1fe21b205ad23$var$START_HIDING) status = "hiding";
            else if (name === $e8c1fe21b205ad23$var$STOP_HIDING) {
                if (status === "hiding") {
                    status = "showing";
                    if ($e8c1fe21b205ad23$var$virtualFrames.has(err)) newTrace.unshift(...$e8c1fe21b205ad23$var$virtualFrames.get(err));
                } else if (status === "unknown") {
                    newTrace = trace;
                    break;
                }
            } else if (status !== "hiding") newTrace.push(trace[i]);
        }
        return prepareStackTrace(err, newTrace);
    };
}
function $e8c1fe21b205ad23$var$defaultPrepareStackTrace(err, trace) {
    if (trace.length === 0) return $e8c1fe21b205ad23$var$ErrorToString(err);
    return `${$e8c1fe21b205ad23$var$ErrorToString(err)}\n    at ${trace.join("\n    at ")}`;
}

});



parcelRegister("aqSp8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $798688a7913f00dd$var$pathToPattern;

function $798688a7913f00dd$var$_path() {
    const data = (parcelRequire("59kwG"));
    $798688a7913f00dd$var$_path = function() {
        return data;
    };
    return data;
}
const $798688a7913f00dd$var$sep = `\\${$798688a7913f00dd$var$_path().sep}`;
const $798688a7913f00dd$var$endSep = `(?:${$798688a7913f00dd$var$sep}|$)`;
const $798688a7913f00dd$var$substitution = `[^${$798688a7913f00dd$var$sep}]+`;
const $798688a7913f00dd$var$starPat = `(?:${$798688a7913f00dd$var$substitution}${$798688a7913f00dd$var$sep})`;
const $798688a7913f00dd$var$starPatLast = `(?:${$798688a7913f00dd$var$substitution}${$798688a7913f00dd$var$endSep})`;
const $798688a7913f00dd$var$starStarPat = `${$798688a7913f00dd$var$starPat}*?`;
const $798688a7913f00dd$var$starStarPatLast = `${$798688a7913f00dd$var$starPat}*?${$798688a7913f00dd$var$starPatLast}?`;
function $798688a7913f00dd$var$escapeRegExp(string) {
    return string.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&");
}
function $798688a7913f00dd$var$pathToPattern(pattern, dirname) {
    const parts = $798688a7913f00dd$var$_path().resolve(dirname, pattern).split($798688a7913f00dd$var$_path().sep);
    return new RegExp([
        "^",
        ...parts.map((part, i)=>{
            const last = i === parts.length - 1;
            if (part === "**") return last ? $798688a7913f00dd$var$starStarPatLast : $798688a7913f00dd$var$starStarPat;
            if (part === "*") return last ? $798688a7913f00dd$var$starPatLast : $798688a7913f00dd$var$starPat;
            if (part.indexOf("*.") === 0) return $798688a7913f00dd$var$substitution + $798688a7913f00dd$var$escapeRegExp(part.slice(1)) + (last ? $798688a7913f00dd$var$endSep : $798688a7913f00dd$var$sep);
            return $798688a7913f00dd$var$escapeRegExp(part) + (last ? $798688a7913f00dd$var$endSep : $798688a7913f00dd$var$sep);
        })
    ].join(""));
}

});

parcelRegister("ll0uj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConfigPrinter = module.exports.ChainFormatter = void 0;

function $f88bf000ae1924b7$var$_gensync() {
    const data = (parcelRequire("8AIEE"));
    $f88bf000ae1924b7$var$_gensync = function() {
        return data;
    };
    return data;
}
const $f88bf000ae1924b7$var$ChainFormatter = module.exports.ChainFormatter = {
    Programmatic: 0,
    Config: 1
};
const $f88bf000ae1924b7$var$Formatter = {
    title (type, callerName, filepath) {
        let title = "";
        if (type === $f88bf000ae1924b7$var$ChainFormatter.Programmatic) {
            title = "programmatic options";
            if (callerName) title += " from " + callerName;
        } else title = "config " + filepath;
        return title;
    },
    loc (index, envName) {
        let loc = "";
        if (index != null) loc += `.overrides[${index}]`;
        if (envName != null) loc += `.env["${envName}"]`;
        return loc;
    },
    *optionsAndDescriptors (opt) {
        const content = Object.assign({}, opt.options);
        delete content.overrides;
        delete content.env;
        const pluginDescriptors = [
            ...yield* opt.plugins()
        ];
        if (pluginDescriptors.length) content.plugins = pluginDescriptors.map((d)=>$f88bf000ae1924b7$var$descriptorToConfig(d));
        const presetDescriptors = [
            ...yield* opt.presets()
        ];
        if (presetDescriptors.length) content.presets = [
            ...presetDescriptors
        ].map((d)=>$f88bf000ae1924b7$var$descriptorToConfig(d));
        return JSON.stringify(content, undefined, 2);
    }
};
function $f88bf000ae1924b7$var$descriptorToConfig(d) {
    var _d$file;
    let name = (_d$file = d.file) == null ? void 0 : _d$file.request;
    if (name == null) {
        if (typeof d.value === "object") name = d.value;
        else if (typeof d.value === "function") name = `[Function: ${d.value.toString().slice(0, 50)} ... ]`;
    }
    if (name == null) name = "[Unknown]";
    if (d.options === undefined) return name;
    else if (d.name == null) return [
        name,
        d.options
    ];
    else return [
        name,
        d.options,
        d.name
    ];
}
class $f88bf000ae1924b7$var$ConfigPrinter {
    constructor(){
        this._stack = [];
    }
    configure(enabled, type, { callerName: callerName, filepath: filepath }) {
        if (!enabled) return ()=>{};
        return (content, index, envName)=>{
            this._stack.push({
                type: type,
                callerName: callerName,
                filepath: filepath,
                content: content,
                index: index,
                envName: envName
            });
        };
    }
    static *format(config) {
        let title = $f88bf000ae1924b7$var$Formatter.title(config.type, config.callerName, config.filepath);
        const loc = $f88bf000ae1924b7$var$Formatter.loc(config.index, config.envName);
        if (loc) title += ` ${loc}`;
        const content = yield* $f88bf000ae1924b7$var$Formatter.optionsAndDescriptors(config.content);
        return `${title}\n${content}`;
    }
    *output() {
        if (this._stack.length === 0) return "";
        const configs = yield* $f88bf000ae1924b7$var$_gensync().all(this._stack.map((s)=>$f88bf000ae1924b7$var$ConfigPrinter.format(s)));
        return configs.join("\n\n");
    }
}
module.exports.ConfigPrinter = $f88bf000ae1924b7$var$ConfigPrinter;

});


parcelRegister("6VYDs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validatePluginObject = $50c719e2bbb2d8e9$var$validatePluginObject;

var $hgAim = parcelRequire("hgAim");
const $50c719e2bbb2d8e9$var$VALIDATORS = {
    name: $hgAim.assertString,
    manipulateOptions: $hgAim.assertFunction,
    pre: $hgAim.assertFunction,
    post: $hgAim.assertFunction,
    inherits: $hgAim.assertFunction,
    visitor: $50c719e2bbb2d8e9$var$assertVisitorMap,
    parserOverride: $hgAim.assertFunction,
    generatorOverride: $hgAim.assertFunction
};
function $50c719e2bbb2d8e9$var$assertVisitorMap(loc, value) {
    const obj = (0, $hgAim.assertObject)(loc, value);
    if (obj) {
        Object.keys(obj).forEach((prop)=>{
            if (prop !== "_exploded" && prop !== "_verified") $50c719e2bbb2d8e9$var$assertVisitorHandler(prop, obj[prop]);
        });
        if (obj.enter || obj.exit) throw new Error(`${(0, $hgAim.msg)(loc)} cannot contain catch-all "enter" or "exit" handlers. Please target individual nodes.`);
    }
    return obj;
}
function $50c719e2bbb2d8e9$var$assertVisitorHandler(key, value) {
    if (value && typeof value === "object") Object.keys(value).forEach((handler)=>{
        if (handler !== "enter" && handler !== "exit") throw new Error(`.visitor["${key}"] may only have .enter and/or .exit handlers.`);
    });
    else if (typeof value !== "function") throw new Error(`.visitor["${key}"] must be a function`);
}
function $50c719e2bbb2d8e9$var$validatePluginObject(obj) {
    const rootPath = {
        type: "root",
        source: "plugin"
    };
    Object.keys(obj).forEach((key)=>{
        const validator = $50c719e2bbb2d8e9$var$VALIDATORS[key];
        if (validator) {
            const optLoc = {
                type: "option",
                name: key,
                parent: rootPath
            };
            validator(optLoc, obj[key]);
        } else {
            const invalidPluginPropertyError = new Error(`.${key} is not a valid Plugin property`);
            invalidPluginPropertyError.code = "BABEL_UNKNOWN_PLUGIN_PROPERTY";
            throw invalidPluginPropertyError;
        }
    });
    return obj;
}

});

parcelRegister("chlis", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.makeConfigAPI = $8f0797a6b8c29abe$var$makeConfigAPI;
module.exports.makePluginAPI = $8f0797a6b8c29abe$var$makePluginAPI;
module.exports.makePresetAPI = $8f0797a6b8c29abe$var$makePresetAPI;

function $8f0797a6b8c29abe$var$_semver() {
    const data = (parcelRequire("bX4qr"));
    $8f0797a6b8c29abe$var$_semver = function() {
        return data;
    };
    return data;
}

var $7Ockm = parcelRequire("7Ockm");

var $jaXHj = parcelRequire("jaXHj");
function $8f0797a6b8c29abe$var$makeConfigAPI(cache) {
    const env = (value)=>cache.using((data)=>{
            if (typeof value === "undefined") return data.envName;
            if (typeof value === "function") return (0, $jaXHj.assertSimpleType)(value(data.envName));
            return (Array.isArray(value) ? value : [
                value
            ]).some((entry)=>{
                if (typeof entry !== "string") throw new Error("Unexpected non-string value");
                return entry === data.envName;
            });
        });
    const caller = (cb)=>cache.using((data)=>(0, $jaXHj.assertSimpleType)(cb(data.caller)));
    return {
        version: $7Ockm.version,
        cache: cache.simple(),
        env: env,
        async: ()=>false,
        caller: caller,
        assertVersion: $8f0797a6b8c29abe$var$assertVersion
    };
}
function $8f0797a6b8c29abe$var$makePresetAPI(cache, externalDependencies) {
    const targets = ()=>JSON.parse(cache.using((data)=>JSON.stringify(data.targets)));
    const addExternalDependency = (ref)=>{
        externalDependencies.push(ref);
    };
    return Object.assign({}, $8f0797a6b8c29abe$var$makeConfigAPI(cache), {
        targets: targets,
        addExternalDependency: addExternalDependency
    });
}
function $8f0797a6b8c29abe$var$makePluginAPI(cache, externalDependencies) {
    const assumption = (name)=>cache.using((data)=>data.assumptions[name]);
    return Object.assign({}, $8f0797a6b8c29abe$var$makePresetAPI(cache, externalDependencies), {
        assumption: assumption
    });
}
function $8f0797a6b8c29abe$var$assertVersion(range) {
    if (typeof range === "number") {
        if (!Number.isInteger(range)) throw new Error("Expected string or integer value.");
        range = `^${range}.0.0-0`;
    }
    if (typeof range !== "string") throw new Error("Expected string or integer value.");
    if ($8f0797a6b8c29abe$var$_semver().satisfies($7Ockm.version, range)) return;
    const limit = Error.stackTraceLimit;
    if (typeof limit === "number" && limit < 25) Error.stackTraceLimit = 25;
    const err = new Error(`Requires Babel "${range}", but was loaded with "${$7Ockm.version}". ` + `If you are sure you have a compatible version of @babel/core, ` + `it is likely that something in your build process is loading the ` + `wrong version. Inspect the stack trace of this error to look for ` + `the first entry that doesn't mention "@babel/core" or "babel-core" ` + `to see what is calling Babel.`);
    if (typeof limit === "number") Error.stackTraceLimit = limit;
    throw Object.assign(err, {
        code: "BABEL_VERSION_UNSUPPORTED",
        version: $7Ockm.version,
        range: range
    });
}

});

parcelRegister("77Tks", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $53041b069e71f7b0$var$loadPrivatePartialConfig;
module.exports.loadPartialConfig = $53041b069e71f7b0$var$loadPartialConfig;

function $53041b069e71f7b0$var$_path() {
    const data = (parcelRequire("59kwG"));
    $53041b069e71f7b0$var$_path = function() {
        return data;
    };
    return data;
}

var $ln7QF = parcelRequire("ln7QF");

var $6b1E4 = parcelRequire("6b1E4");

var $ajpbS = parcelRequire("ajpbS");

var $hGEb1 = parcelRequire("hGEb1");

var $33Znv = parcelRequire("33Znv");

var $kF3s2 = parcelRequire("kF3s2");

var $4h8hI = parcelRequire("4h8hI");

var $5hYhO = parcelRequire("5hYhO");
const $53041b069e71f7b0$var$_excluded = [
    "showIgnoredFiles"
];
function $53041b069e71f7b0$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $53041b069e71f7b0$var$resolveRootMode(rootDir, rootMode) {
    switch(rootMode){
        case "root":
            return rootDir;
        case "upward-optional":
            {
                const upwardRootDir = (0, $4h8hI.findConfigUpwards)(rootDir);
                return upwardRootDir === null ? rootDir : upwardRootDir;
            }
        case "upward":
            {
                const upwardRootDir = (0, $4h8hI.findConfigUpwards)(rootDir);
                if (upwardRootDir !== null) return upwardRootDir;
                throw Object.assign(new Error(`Babel was run with rootMode:"upward" but a root could not ` + `be found when searching upward from "${rootDir}".\n` + `One of the following config files must be in the directory tree: ` + `"${$4h8hI.ROOT_CONFIG_FILENAMES.join(", ")}".`), {
                    code: "BABEL_ROOT_NOT_FOUND",
                    dirname: rootDir
                });
            }
        default:
            throw new Error(`Assertion failure - unknown rootMode value.`);
    }
}
function* $53041b069e71f7b0$var$loadPrivatePartialConfig(inputOpts) {
    if (inputOpts != null && (typeof inputOpts !== "object" || Array.isArray(inputOpts))) throw new Error("Babel options must be an object, null, or undefined");
    const args = inputOpts ? (0, $kF3s2.validate)("arguments", inputOpts) : {};
    const { envName: envName = (0, $33Znv.getEnv)(), cwd: cwd = ".", root: rootDir = ".", rootMode: rootMode = "root", caller: caller, cloneInputAst: cloneInputAst = true } = args;
    const absoluteCwd = $53041b069e71f7b0$var$_path().resolve(cwd);
    const absoluteRootDir = $53041b069e71f7b0$var$resolveRootMode($53041b069e71f7b0$var$_path().resolve(absoluteCwd, rootDir), rootMode);
    const filename = typeof args.filename === "string" ? $53041b069e71f7b0$var$_path().resolve(cwd, args.filename) : undefined;
    const showConfigPath = yield* (0, $4h8hI.resolveShowConfigPath)(absoluteCwd);
    const context = {
        filename: filename,
        cwd: absoluteCwd,
        root: absoluteRootDir,
        envName: envName,
        caller: caller,
        showConfig: showConfigPath === filename
    };
    const configChain = yield* (0, $hGEb1.buildRootChain)(args, context);
    if (!configChain) return null;
    const merged = {
        assumptions: {}
    };
    configChain.options.forEach((opts)=>{
        (0, $6b1E4.mergeOptions)(merged, opts);
    });
    const options = Object.assign({}, merged, {
        targets: (0, $5hYhO.resolveTargets)(merged, absoluteRootDir),
        cloneInputAst: cloneInputAst,
        babelrc: false,
        configFile: false,
        browserslistConfigFile: false,
        passPerPreset: false,
        envName: context.envName,
        cwd: context.cwd,
        root: context.root,
        rootMode: "root",
        filename: typeof context.filename === "string" ? context.filename : undefined,
        plugins: configChain.plugins.map((descriptor)=>(0, $ajpbS.createItemFromDescriptor)(descriptor)),
        presets: configChain.presets.map((descriptor)=>(0, $ajpbS.createItemFromDescriptor)(descriptor))
    });
    return {
        options: options,
        context: context,
        fileHandling: configChain.fileHandling,
        ignore: configChain.ignore,
        babelrc: configChain.babelrc,
        config: configChain.config,
        files: configChain.files
    };
}
function* $53041b069e71f7b0$var$loadPartialConfig(opts) {
    let showIgnoredFiles = false;
    if (typeof opts === "object" && opts !== null && !Array.isArray(opts)) {
        var _opts = opts;
        ({ showIgnoredFiles: showIgnoredFiles } = _opts);
        opts = $53041b069e71f7b0$var$_objectWithoutPropertiesLoose(_opts, $53041b069e71f7b0$var$_excluded);
        _opts;
    }
    const result = yield* $53041b069e71f7b0$var$loadPrivatePartialConfig(opts);
    if (!result) return null;
    const { options: options, babelrc: babelrc, ignore: ignore, config: config, fileHandling: fileHandling, files: files } = result;
    if (fileHandling === "ignored" && !showIgnoredFiles) return null;
    (options.plugins || []).forEach((item)=>{
        if (item.value instanceof $ln7QF.default) throw new Error("Passing cached plugin instances is not supported in babel.loadPartialConfig()");
    });
    return new $53041b069e71f7b0$var$PartialConfig(options, babelrc ? babelrc.filepath : undefined, ignore ? ignore.filepath : undefined, config ? config.filepath : undefined, fileHandling, files);
}
class $53041b069e71f7b0$var$PartialConfig {
    constructor(options, babelrc, ignore, config, fileHandling, files){
        this.options = void 0;
        this.babelrc = void 0;
        this.babelignore = void 0;
        this.config = void 0;
        this.fileHandling = void 0;
        this.files = void 0;
        this.options = options;
        this.babelignore = ignore;
        this.babelrc = babelrc;
        this.config = config;
        this.fileHandling = fileHandling;
        this.files = files;
        Object.freeze(this);
    }
    hasFilesystemConfig() {
        return this.babelrc !== undefined || this.config !== undefined;
    }
}
Object.freeze($53041b069e71f7b0$var$PartialConfig.prototype);

});



parcelRegister("cTdtM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.transform = void 0;
module.exports.transformAsync = $962513d102c8497e$var$transformAsync;
module.exports.transformSync = $962513d102c8497e$var$transformSync;

function $962513d102c8497e$var$_gensync() {
    const data = (parcelRequire("8AIEE"));
    $962513d102c8497e$var$_gensync = function() {
        return data;
    };
    return data;
}

var $6JZbd = parcelRequire("6JZbd");

var $dsYSd = parcelRequire("dsYSd");

var $jYXMt = parcelRequire("jYXMt");
const $962513d102c8497e$var$transformRunner = $962513d102c8497e$var$_gensync()(function* transform(code, opts) {
    const config = yield* (0, $6JZbd.default)(opts);
    if (config === null) return null;
    return yield* (0, $dsYSd.run)(config, code);
});
const $962513d102c8497e$var$transform = module.exports.transform = function transform(code, optsOrCallback, maybeCallback) {
    let opts;
    let callback;
    if (typeof optsOrCallback === "function") {
        callback = optsOrCallback;
        opts = undefined;
    } else {
        opts = optsOrCallback;
        callback = maybeCallback;
    }
    if (callback === undefined) return (0, $jYXMt.beginHiddenCallStack)($962513d102c8497e$var$transformRunner.sync)(code, opts);
    (0, $jYXMt.beginHiddenCallStack)($962513d102c8497e$var$transformRunner.errback)(code, opts, callback);
};
function $962513d102c8497e$var$transformSync(...args) {
    return (0, $jYXMt.beginHiddenCallStack)($962513d102c8497e$var$transformRunner.sync)(...args);
}
function $962513d102c8497e$var$transformAsync(...args) {
    return (0, $jYXMt.beginHiddenCallStack)($962513d102c8497e$var$transformRunner.async)(...args);
}

});
parcelRegister("dsYSd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.run = $9cdd1c119af2148c$var$run;

function $9cdd1c119af2148c$var$_traverse() {
    const data = (parcelRequire("aHxeO"));
    $9cdd1c119af2148c$var$_traverse = function() {
        return data;
    };
    return data;
}

var $1xNll = parcelRequire("1xNll");

var $1SUbV = parcelRequire("1SUbV");

var $5umil = parcelRequire("5umil");

var $5ocyl = parcelRequire("5ocyl");

var $CCysw = parcelRequire("CCysw");

var $z3rWa = parcelRequire("z3rWa");
function* $9cdd1c119af2148c$var$run(config, code, ast) {
    const file = yield* (0, $5ocyl.default)(config.passes, (0, $5umil.default)(config), code, ast);
    const opts = file.opts;
    try {
        yield* $9cdd1c119af2148c$var$transformFile(file, config.passes);
    } catch (e) {
        var _opts$filename;
        e.message = `${(_opts$filename = opts.filename) != null ? _opts$filename : "unknown file"}: ${e.message}`;
        if (!e.code) e.code = "BABEL_TRANSFORM_ERROR";
        throw e;
    }
    let outputCode, outputMap;
    try {
        if (opts.code !== false) ({ outputCode: outputCode, outputMap: outputMap } = (0, $CCysw.default)(config.passes, file));
    } catch (e) {
        var _opts$filename2;
        e.message = `${(_opts$filename2 = opts.filename) != null ? _opts$filename2 : "unknown file"}: ${e.message}`;
        if (!e.code) e.code = "BABEL_GENERATE_ERROR";
        throw e;
    }
    return {
        metadata: file.metadata,
        options: opts,
        ast: opts.ast === true ? file.ast : null,
        code: outputCode === undefined ? null : outputCode,
        map: outputMap === undefined ? null : outputMap,
        sourceType: file.ast.program.sourceType,
        externalDependencies: (0, $z3rWa.flattenToSet)(config.externalDependencies)
    };
}
function* $9cdd1c119af2148c$var$transformFile(file, pluginPasses) {
    for (const pluginPairs of pluginPasses){
        const passPairs = [];
        const passes = [];
        const visitors = [];
        for (const plugin of pluginPairs.concat([
            (0, $1SUbV.default)()
        ])){
            const pass = new $1xNll.default(file, plugin.key, plugin.options);
            passPairs.push([
                plugin,
                pass
            ]);
            passes.push(pass);
            visitors.push(plugin.visitor);
        }
        for (const [plugin, pass] of passPairs){
            const fn = plugin.pre;
            if (fn) {
                const result = fn.call(pass, file);
                yield* [];
                if ($9cdd1c119af2148c$var$isThenable(result)) throw new Error(`You appear to be using an plugin with an async .pre, ` + `which your current version of Babel does not support. ` + `If you're using a published plugin, you may need to upgrade ` + `your @babel/core version.`);
            }
        }
        const visitor = $9cdd1c119af2148c$var$_traverse().default.visitors.merge(visitors, passes, file.opts.wrapPluginVisitorMethod);
        (0, $9cdd1c119af2148c$var$_traverse().default)(file.ast, visitor, file.scope);
        for (const [plugin, pass] of passPairs){
            const fn = plugin.post;
            if (fn) {
                const result = fn.call(pass, file);
                yield* [];
                if ($9cdd1c119af2148c$var$isThenable(result)) throw new Error(`You appear to be using an plugin with an async .post, ` + `which your current version of Babel does not support. ` + `If you're using a published plugin, you may need to upgrade ` + `your @babel/core version.`);
            }
        }
    }
}
function $9cdd1c119af2148c$var$isThenable(val) {
    return !!val && (typeof val === "object" || typeof val === "function") && !!val.then && typeof val.then === "function";
}

});
parcelRegister("1xNll", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
class $11ff260ea3fcde97$var$PluginPass {
    constructor(file, key, options){
        this._map = new Map();
        this.key = void 0;
        this.file = void 0;
        this.opts = void 0;
        this.cwd = void 0;
        this.filename = void 0;
        this.key = key;
        this.file = file;
        this.opts = options || {};
        this.cwd = file.opts.cwd;
        this.filename = file.opts.filename;
    }
    set(key, val) {
        this._map.set(key, val);
    }
    get(key) {
        return this._map.get(key);
    }
    availableHelper(name, versionRange) {
        return this.file.availableHelper(name, versionRange);
    }
    addHelper(name) {
        return this.file.addHelper(name);
    }
    buildCodeFrameError(node, msg, _Error) {
        return this.file.buildCodeFrameError(node, msg, _Error);
    }
}
module.exports.default = $11ff260ea3fcde97$var$PluginPass;
$11ff260ea3fcde97$var$PluginPass.prototype.getModuleName = function getModuleName() {
    return this.file.getModuleName();
};
$11ff260ea3fcde97$var$PluginPass.prototype.addImport = function addImport() {
    this.file.addImport();
};

});

parcelRegister("1SUbV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $15f66c08e7d30356$var$loadBlockHoistPlugin;

function $15f66c08e7d30356$var$_traverse() {
    const data = (parcelRequire("aHxeO"));
    $15f66c08e7d30356$var$_traverse = function() {
        return data;
    };
    return data;
}

var $ln7QF = parcelRequire("ln7QF");
let $15f66c08e7d30356$var$LOADED_PLUGIN;
const $15f66c08e7d30356$var$blockHoistPlugin = {
    name: "internal.blockHoist",
    visitor: {
        Block: {
            exit ({ node: node }) {
                const { body: body } = node;
                let max = Math.pow(2, 30) - 1;
                let hasChange = false;
                for(let i = 0; i < body.length; i++){
                    const n = body[i];
                    const p = $15f66c08e7d30356$var$priority(n);
                    if (p > max) {
                        hasChange = true;
                        break;
                    }
                    max = p;
                }
                if (!hasChange) return;
                node.body = $15f66c08e7d30356$var$stableSort(body.slice());
            }
        }
    }
};
function $15f66c08e7d30356$var$loadBlockHoistPlugin() {
    if (!$15f66c08e7d30356$var$LOADED_PLUGIN) $15f66c08e7d30356$var$LOADED_PLUGIN = new $ln7QF.default(Object.assign({}, $15f66c08e7d30356$var$blockHoistPlugin, {
        visitor: $15f66c08e7d30356$var$_traverse().default.explode($15f66c08e7d30356$var$blockHoistPlugin.visitor)
    }), {});
    return $15f66c08e7d30356$var$LOADED_PLUGIN;
}
function $15f66c08e7d30356$var$priority(bodyNode) {
    const priority = bodyNode == null ? void 0 : bodyNode._blockHoist;
    if (priority == null) return 1;
    if (priority === true) return 2;
    return priority;
}
function $15f66c08e7d30356$var$stableSort(body) {
    const buckets = Object.create(null);
    for(let i = 0; i < body.length; i++){
        const n = body[i];
        const p = $15f66c08e7d30356$var$priority(n);
        const bucket = buckets[p] || (buckets[p] = []);
        bucket.push(n);
    }
    const keys = Object.keys(buckets).map((k)=>+k).sort((a, b)=>b - a);
    let index = 0;
    for (const key of keys){
        const bucket = buckets[key];
        for (const n of bucket)body[index++] = n;
    }
    return body;
}

});

parcelRegister("5umil", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3ff10c6a6be405c4$var$normalizeOptions;

function $3ff10c6a6be405c4$var$_path() {
    const data = (parcelRequire("59kwG"));
    $3ff10c6a6be405c4$var$_path = function() {
        return data;
    };
    return data;
}
function $3ff10c6a6be405c4$var$normalizeOptions(config) {
    const { filename: filename, cwd: cwd, filenameRelative: filenameRelative = typeof filename === "string" ? $3ff10c6a6be405c4$var$_path().relative(cwd, filename) : "unknown", sourceType: sourceType = "module", inputSourceMap: inputSourceMap, sourceMaps: sourceMaps = !!inputSourceMap, sourceRoot: sourceRoot = config.options.moduleRoot, sourceFileName: sourceFileName = $3ff10c6a6be405c4$var$_path().basename(filenameRelative), comments: comments = true, compact: compact = "auto" } = config.options;
    const opts = config.options;
    const options = Object.assign({}, opts, {
        parserOpts: Object.assign({
            sourceType: $3ff10c6a6be405c4$var$_path().extname(filenameRelative) === ".mjs" ? "module" : sourceType,
            sourceFileName: filename,
            plugins: []
        }, opts.parserOpts),
        generatorOpts: Object.assign({
            filename: filename,
            auxiliaryCommentBefore: opts.auxiliaryCommentBefore,
            auxiliaryCommentAfter: opts.auxiliaryCommentAfter,
            retainLines: opts.retainLines,
            comments: comments,
            shouldPrintComment: opts.shouldPrintComment,
            compact: compact,
            minified: opts.minified,
            sourceMaps: sourceMaps,
            sourceRoot: sourceRoot,
            sourceFileName: sourceFileName
        }, opts.generatorOpts)
    });
    for (const plugins of config.passes){
        for (const plugin of plugins)if (plugin.manipulateOptions) plugin.manipulateOptions(options, options.parserOpts);
    }
    return options;
}

});

parcelRegister("5ocyl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3ec8ee666ceab6b7$var$normalizeFile;

function $3ec8ee666ceab6b7$var$_fs() {
    const data = (parcelRequire("kjyEk"));
    $3ec8ee666ceab6b7$var$_fs = function() {
        return data;
    };
    return data;
}

function $3ec8ee666ceab6b7$var$_path() {
    const data = (parcelRequire("59kwG"));
    $3ec8ee666ceab6b7$var$_path = function() {
        return data;
    };
    return data;
}

function $3ec8ee666ceab6b7$var$_debug() {
    const data = (parcelRequire("1SXIy"));
    $3ec8ee666ceab6b7$var$_debug = function() {
        return data;
    };
    return data;
}

function $3ec8ee666ceab6b7$var$_t() {
    const data = (parcelRequire("ardUq"));
    $3ec8ee666ceab6b7$var$_t = function() {
        return data;
    };
    return data;
}

function $3ec8ee666ceab6b7$var$_convertSourceMap() {
    const data = (parcelRequire("7olKr"));
    $3ec8ee666ceab6b7$var$_convertSourceMap = function() {
        return data;
    };
    return data;
}

var $ir8Cn = parcelRequire("ir8Cn");

var $3Igfj = parcelRequire("3Igfj");

var $2gRU0 = parcelRequire("2gRU0");
const { file: $3ec8ee666ceab6b7$var$file, traverseFast: $3ec8ee666ceab6b7$var$traverseFast } = $3ec8ee666ceab6b7$var$_t();
const $3ec8ee666ceab6b7$var$debug = $3ec8ee666ceab6b7$var$_debug()("babel:transform:file");
const $3ec8ee666ceab6b7$var$INLINE_SOURCEMAP_REGEX = /^[@#]\s+sourceMappingURL=data:(?:application|text)\/json;(?:charset[:=]\S+?;)?base64,(?:.*)$/;
const $3ec8ee666ceab6b7$var$EXTERNAL_SOURCEMAP_REGEX = /^[@#][ \t]+sourceMappingURL=([^\s'"`]+)[ \t]*$/;
function* $3ec8ee666ceab6b7$var$normalizeFile(pluginPasses, options, code, ast) {
    code = `${code || ""}`;
    if (ast) {
        if (ast.type === "Program") ast = $3ec8ee666ceab6b7$var$file(ast, [], []);
        else if (ast.type !== "File") throw new Error("AST root must be a Program or File node");
        if (options.cloneInputAst) ast = (0, $2gRU0.default)(ast);
    } else ast = yield* (0, $3Igfj.default)(pluginPasses, options, code);
    let inputMap = null;
    if (options.inputSourceMap !== false) {
        if (typeof options.inputSourceMap === "object") inputMap = $3ec8ee666ceab6b7$var$_convertSourceMap().fromObject(options.inputSourceMap);
        if (!inputMap) {
            const lastComment = $3ec8ee666ceab6b7$var$extractComments($3ec8ee666ceab6b7$var$INLINE_SOURCEMAP_REGEX, ast);
            if (lastComment) try {
                inputMap = $3ec8ee666ceab6b7$var$_convertSourceMap().fromComment("//" + lastComment);
            } catch (err) {
                $3ec8ee666ceab6b7$var$debug("discarding unknown inline input sourcemap");
            }
        }
        if (!inputMap) {
            const lastComment = $3ec8ee666ceab6b7$var$extractComments($3ec8ee666ceab6b7$var$EXTERNAL_SOURCEMAP_REGEX, ast);
            if (typeof options.filename === "string" && lastComment) try {
                const match = $3ec8ee666ceab6b7$var$EXTERNAL_SOURCEMAP_REGEX.exec(lastComment);
                const inputMapContent = $3ec8ee666ceab6b7$var$_fs().readFileSync($3ec8ee666ceab6b7$var$_path().resolve($3ec8ee666ceab6b7$var$_path().dirname(options.filename), match[1]), "utf8");
                inputMap = $3ec8ee666ceab6b7$var$_convertSourceMap().fromJSON(inputMapContent);
            } catch (err) {
                $3ec8ee666ceab6b7$var$debug("discarding unknown file input sourcemap", err);
            }
            else if (lastComment) $3ec8ee666ceab6b7$var$debug("discarding un-loadable file input sourcemap");
        }
    }
    return new $ir8Cn.default(options, {
        code: code,
        ast: ast,
        inputMap: inputMap
    });
}
function $3ec8ee666ceab6b7$var$extractCommentsFromList(regex, comments, lastComment) {
    if (comments) comments = comments.filter(({ value: value })=>{
        if (regex.test(value)) {
            lastComment = value;
            return false;
        }
        return true;
    });
    return [
        comments,
        lastComment
    ];
}
function $3ec8ee666ceab6b7$var$extractComments(regex, ast) {
    let lastComment = null;
    $3ec8ee666ceab6b7$var$traverseFast(ast, (node)=>{
        [node.leadingComments, lastComment] = $3ec8ee666ceab6b7$var$extractCommentsFromList(regex, node.leadingComments, lastComment);
        [node.innerComments, lastComment] = $3ec8ee666ceab6b7$var$extractCommentsFromList(regex, node.innerComments, lastComment);
        [node.trailingComments, lastComment] = $3ec8ee666ceab6b7$var$extractCommentsFromList(regex, node.trailingComments, lastComment);
    });
    return lastComment;
}

});
parcelRegister("7olKr", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $561ba50311f39504$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty(module.exports, "commentRegex", {
    get: function getCommentRegex() {
        // Groups: 1: media type, 2: MIME type, 3: charset, 4: encoding, 5: data.
        return /^\s*?\/[\/\*][@#]\s+?sourceMappingURL=data:(((?:application|text)\/json)(?:;charset=([^;,]+?)?)?)?(?:;(base64))?,(.*?)$/mg;
    }
});
Object.defineProperty(module.exports, "mapFileCommentRegex", {
    get: function getMapFileCommentRegex() {
        // Matches sourceMappingURL in either // or /* comment styles.
        return /(?:\/\/[@#][ \t]+?sourceMappingURL=([^\s'"`]+?)[ \t]*?$)|(?:\/\*[@#][ \t]+sourceMappingURL=([^*]+?)[ \t]*?(?:\*\/){1}[ \t]*?$)/mg;
    }
});
var $561ba50311f39504$var$decodeBase64;
if (typeof $561ba50311f39504$require$Buffer !== "undefined") {
    if (typeof $561ba50311f39504$require$Buffer.from === "function") $561ba50311f39504$var$decodeBase64 = $561ba50311f39504$var$decodeBase64WithBufferFrom;
    else $561ba50311f39504$var$decodeBase64 = $561ba50311f39504$var$decodeBase64WithNewBuffer;
} else $561ba50311f39504$var$decodeBase64 = $561ba50311f39504$var$decodeBase64WithAtob;
function $561ba50311f39504$var$decodeBase64WithBufferFrom(base64) {
    return $561ba50311f39504$require$Buffer.from(base64, "base64").toString();
}
function $561ba50311f39504$var$decodeBase64WithNewBuffer(base64) {
    if (typeof value === "number") throw new TypeError("The value to decode must not be of type number.");
    return new $561ba50311f39504$require$Buffer(base64, "base64").toString();
}
function $561ba50311f39504$var$decodeBase64WithAtob(base64) {
    return decodeURIComponent(escape(atob(base64)));
}
function $561ba50311f39504$var$stripComment(sm) {
    return sm.split(",").pop();
}
function $561ba50311f39504$var$readFromFileMap(sm, read) {
    var r = module.exports.mapFileCommentRegex.exec(sm);
    // for some odd reason //# .. captures in 1 and /* .. */ in 2
    var filename = r[1] || r[2];
    try {
        var sm = read(filename);
        if (sm != null && typeof sm.catch === "function") return sm.catch(throwError);
        else return sm;
    } catch (e) {
        throwError(e);
    }
    function throwError(e) {
        throw new Error("An error occurred while trying to read the map file at " + filename + "\n" + e.stack);
    }
}
function $561ba50311f39504$var$Converter(sm, opts) {
    opts = opts || {};
    if (opts.hasComment) sm = $561ba50311f39504$var$stripComment(sm);
    if (opts.encoding === "base64") sm = $561ba50311f39504$var$decodeBase64(sm);
    else if (opts.encoding === "uri") sm = decodeURIComponent(sm);
    if (opts.isJSON || opts.encoding) sm = JSON.parse(sm);
    this.sourcemap = sm;
}
$561ba50311f39504$var$Converter.prototype.toJSON = function(space) {
    return JSON.stringify(this.sourcemap, null, space);
};
if (typeof $561ba50311f39504$require$Buffer !== "undefined") {
    if (typeof $561ba50311f39504$require$Buffer.from === "function") $561ba50311f39504$var$Converter.prototype.toBase64 = $561ba50311f39504$var$encodeBase64WithBufferFrom;
    else $561ba50311f39504$var$Converter.prototype.toBase64 = $561ba50311f39504$var$encodeBase64WithNewBuffer;
} else $561ba50311f39504$var$Converter.prototype.toBase64 = $561ba50311f39504$var$encodeBase64WithBtoa;
function $561ba50311f39504$var$encodeBase64WithBufferFrom() {
    var json = this.toJSON();
    return $561ba50311f39504$require$Buffer.from(json, "utf8").toString("base64");
}
function $561ba50311f39504$var$encodeBase64WithNewBuffer() {
    var json = this.toJSON();
    if (typeof json === "number") throw new TypeError("The json to encode must not be of type number.");
    return new $561ba50311f39504$require$Buffer(json, "utf8").toString("base64");
}
function $561ba50311f39504$var$encodeBase64WithBtoa() {
    var json = this.toJSON();
    return btoa(unescape(encodeURIComponent(json)));
}
$561ba50311f39504$var$Converter.prototype.toURI = function() {
    var json = this.toJSON();
    return encodeURIComponent(json);
};
$561ba50311f39504$var$Converter.prototype.toComment = function(options) {
    var encoding, content, data;
    if (options != null && options.encoding === "uri") {
        encoding = "";
        content = this.toURI();
    } else {
        encoding = ";base64";
        content = this.toBase64();
    }
    data = "sourceMappingURL=data:application/json;charset=utf-8" + encoding + "," + content;
    return options != null && options.multiline ? "/*# " + data + " */" : "//# " + data;
};
// returns copy instead of original
$561ba50311f39504$var$Converter.prototype.toObject = function() {
    return JSON.parse(this.toJSON());
};
$561ba50311f39504$var$Converter.prototype.addProperty = function(key, value1) {
    if (this.sourcemap.hasOwnProperty(key)) throw new Error('property "' + key + '" already exists on the sourcemap, use set property instead');
    return this.setProperty(key, value1);
};
$561ba50311f39504$var$Converter.prototype.setProperty = function(key, value1) {
    this.sourcemap[key] = value1;
    return this;
};
$561ba50311f39504$var$Converter.prototype.getProperty = function(key) {
    return this.sourcemap[key];
};
module.exports.fromObject = function(obj) {
    return new $561ba50311f39504$var$Converter(obj);
};
module.exports.fromJSON = function(json) {
    return new $561ba50311f39504$var$Converter(json, {
        isJSON: true
    });
};
module.exports.fromURI = function(uri) {
    return new $561ba50311f39504$var$Converter(uri, {
        encoding: "uri"
    });
};
module.exports.fromBase64 = function(base64) {
    return new $561ba50311f39504$var$Converter(base64, {
        encoding: "base64"
    });
};
module.exports.fromComment = function(comment) {
    var m, encoding;
    comment = comment.replace(/^\/\*/g, "//").replace(/\*\/$/g, "");
    m = module.exports.commentRegex.exec(comment);
    encoding = m && m[4] || "uri";
    return new $561ba50311f39504$var$Converter(comment, {
        encoding: encoding,
        hasComment: true
    });
};
function $561ba50311f39504$var$makeConverter(sm) {
    return new $561ba50311f39504$var$Converter(sm, {
        isJSON: true
    });
}
module.exports.fromMapFileComment = function(comment, read) {
    if (typeof read === "string") throw new Error("String directory paths are no longer supported with `fromMapFileComment`\nPlease review the Upgrading documentation at https://github.com/thlorenz/convert-source-map#upgrading");
    var sm = $561ba50311f39504$var$readFromFileMap(comment, read);
    if (sm != null && typeof sm.then === "function") return sm.then($561ba50311f39504$var$makeConverter);
    else return $561ba50311f39504$var$makeConverter(sm);
};
// Finds last sourcemap comment in file or returns null if none was found
module.exports.fromSource = function(content) {
    var m = content.match(module.exports.commentRegex);
    return m ? module.exports.fromComment(m.pop()) : null;
};
// Finds last sourcemap comment in file or returns null if none was found
module.exports.fromMapFileSource = function(content, read) {
    if (typeof read === "string") throw new Error("String directory paths are no longer supported with `fromMapFileSource`\nPlease review the Upgrading documentation at https://github.com/thlorenz/convert-source-map#upgrading");
    var m = content.match(module.exports.mapFileCommentRegex);
    return m ? module.exports.fromMapFileComment(m.pop(), read) : null;
};
module.exports.removeComments = function(src) {
    return src.replace(module.exports.commentRegex, "");
};
module.exports.removeMapFileComments = function(src) {
    return src.replace(module.exports.mapFileCommentRegex, "");
};
module.exports.generateMapFileComment = function(file, options) {
    var data = "sourceMappingURL=" + file;
    return options && options.multiline ? "/*# " + data + " */" : "//# " + data;
};

});

parcelRegister("3Igfj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2b421547afdd80d9$var$parser;

function $2b421547afdd80d9$var$_parser() {
    const data = (parcelRequire("fuTml"));
    $2b421547afdd80d9$var$_parser = function() {
        return data;
    };
    return data;
}

function $2b421547afdd80d9$var$_codeFrame() {
    const data = (parcelRequire("frkOe"));
    $2b421547afdd80d9$var$_codeFrame = function() {
        return data;
    };
    return data;
}

var $6pbKg = parcelRequire("6pbKg");
function* $2b421547afdd80d9$var$parser(pluginPasses, { parserOpts: parserOpts, highlightCode: highlightCode = true, filename: filename = "unknown" }, code) {
    try {
        const results = [];
        for (const plugins of pluginPasses)for (const plugin of plugins){
            const { parserOverride: parserOverride } = plugin;
            if (parserOverride) {
                const ast = parserOverride(code, parserOpts, $2b421547afdd80d9$var$_parser().parse);
                if (ast !== undefined) results.push(ast);
            }
        }
        if (results.length === 0) return (0, $2b421547afdd80d9$var$_parser().parse)(code, parserOpts);
        else if (results.length === 1) {
            yield* [];
            if (typeof results[0].then === "function") throw new Error(`You appear to be using an async parser plugin, ` + `which your current version of Babel does not support. ` + `If you're using a published plugin, you may need to upgrade ` + `your @babel/core version.`);
            return results[0];
        }
        throw new Error("More than one plugin attempted to override parsing.");
    } catch (err) {
        if (err.code === "BABEL_PARSER_SOURCETYPE_MODULE_REQUIRED") err.message += "\nConsider renaming the file to '.mjs', or setting sourceType:module or sourceType:unambiguous in your Babel config for this file.";
        const { loc: loc, missingPlugin: missingPlugin } = err;
        if (loc) {
            const codeFrame = (0, $2b421547afdd80d9$var$_codeFrame().codeFrameColumns)(code, {
                start: {
                    line: loc.line,
                    column: loc.column + 1
                }
            }, {
                highlightCode: highlightCode
            });
            if (missingPlugin) err.message = `${filename}: ` + (0, $6pbKg.default)(missingPlugin[0], loc, codeFrame, filename);
            else err.message = `${filename}: ${err.message}\n\n` + codeFrame;
            err.code = "BABEL_PARSE_ERROR";
        }
        throw err;
    }
}

});
parcelRegister("6pbKg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4a9e3035be61475a$var$generateMissingPluginMessage;
const $4a9e3035be61475a$var$pluginNameMap = {
    asyncDoExpressions: {
        syntax: {
            name: "@babel/plugin-syntax-async-do-expressions",
            url: "https://github.com/babel/babel/tree/main/packages/babel-plugin-syntax-async-do-expressions"
        }
    },
    decimal: {
        syntax: {
            name: "@babel/plugin-syntax-decimal",
            url: "https://github.com/babel/babel/tree/main/packages/babel-plugin-syntax-decimal"
        }
    },
    decorators: {
        syntax: {
            name: "@babel/plugin-syntax-decorators",
            url: "https://github.com/babel/babel/tree/main/packages/babel-plugin-syntax-decorators"
        },
        transform: {
            name: "@babel/plugin-proposal-decorators",
            url: "https://github.com/babel/babel/tree/main/packages/babel-plugin-proposal-decorators"
        }
    },
    doExpressions: {
        syntax: {
            name: "@babel/plugin-syntax-do-expressions",
            url: "https://github.com/babel/babel/tree/main/packages/babel-plugin-syntax-do-expressions"
        },
        transform: {
            name: "@babel/plugin-proposal-do-expressions",
            url: "https://github.com/babel/babel/tree/main/packages/babel-plugin-proposal-do-expressions"
        }
    },
    exportDefaultFrom: {
        syntax: {
            name: "@babel/plugin-syntax-export-default-from",
            url: "https://github.com/babel/babel/tree/main/packages/babel-plugin-syntax-export-default-from"
        },
        transform: {
            name: "@babel/plugin-proposal-export-default-from",
            url: "https://github.com/babel/babel/tree/main/packages/babel-plugin-proposal-export-default-from"
        }
    },
    flow: {
        syntax: {
            name: "@babel/plugin-syntax-flow",
            url: "https://github.com/babel/babel/tree/main/packages/babel-plugin-syntax-flow"
        },
        transform: {
            name: "@babel/preset-flow",
            url: "https://github.com/babel/babel/tree/main/packages/babel-preset-flow"
        }
    },
    functionBind: {
        syntax: {
            name: "@babel/plugin-syntax-function-bind",
            url: "https://github.com/babel/babel/tree/main/packages/babel-plugin-syntax-function-bind"
        },
        transform: {
            name: "@babel/plugin-proposal-function-bind",
            url: "https://github.com/babel/babel/tree/main/packages/babel-plugin-proposal-function-bind"
        }
    },
    functionSent: {
        syntax: {
            name: "@babel/plugin-syntax-function-sent",
            url: "https://github.com/babel/babel/tree/main/packages/babel-plugin-syntax-function-sent"
        },
        transform: {
            name: "@babel/plugin-proposal-function-sent",
            url: "https://github.com/babel/babel/tree/main/packages/babel-plugin-proposal-function-sent"
        }
    },
    jsx: {
        syntax: {
            name: "@babel/plugin-syntax-jsx",
            url: "https://github.com/babel/babel/tree/main/packages/babel-plugin-syntax-jsx"
        },
        transform: {
            name: "@babel/preset-react",
            url: "https://github.com/babel/babel/tree/main/packages/babel-preset-react"
        }
    },
    importAttributes: {
        syntax: {
            name: "@babel/plugin-syntax-import-attributes",
            url: "https://github.com/babel/babel/tree/main/packages/babel-plugin-syntax-import-attributes"
        }
    },
    pipelineOperator: {
        syntax: {
            name: "@babel/plugin-syntax-pipeline-operator",
            url: "https://github.com/babel/babel/tree/main/packages/babel-plugin-syntax-pipeline-operator"
        },
        transform: {
            name: "@babel/plugin-proposal-pipeline-operator",
            url: "https://github.com/babel/babel/tree/main/packages/babel-plugin-proposal-pipeline-operator"
        }
    },
    recordAndTuple: {
        syntax: {
            name: "@babel/plugin-syntax-record-and-tuple",
            url: "https://github.com/babel/babel/tree/main/packages/babel-plugin-syntax-record-and-tuple"
        }
    },
    throwExpressions: {
        syntax: {
            name: "@babel/plugin-syntax-throw-expressions",
            url: "https://github.com/babel/babel/tree/main/packages/babel-plugin-syntax-throw-expressions"
        },
        transform: {
            name: "@babel/plugin-proposal-throw-expressions",
            url: "https://github.com/babel/babel/tree/main/packages/babel-plugin-proposal-throw-expressions"
        }
    },
    typescript: {
        syntax: {
            name: "@babel/plugin-syntax-typescript",
            url: "https://github.com/babel/babel/tree/main/packages/babel-plugin-syntax-typescript"
        },
        transform: {
            name: "@babel/preset-typescript",
            url: "https://github.com/babel/babel/tree/main/packages/babel-preset-typescript"
        }
    }
};
Object.assign($4a9e3035be61475a$var$pluginNameMap, {
    asyncGenerators: {
        syntax: {
            name: "@babel/plugin-syntax-async-generators",
            url: "https://github.com/babel/babel/tree/main/packages/babel-plugin-syntax-async-generators"
        },
        transform: {
            name: "@babel/plugin-transform-async-generator-functions",
            url: "https://github.com/babel/babel/tree/main/packages/babel-plugin-transform-async-generator-functions"
        }
    },
    classProperties: {
        syntax: {
            name: "@babel/plugin-syntax-class-properties",
            url: "https://github.com/babel/babel/tree/main/packages/babel-plugin-syntax-class-properties"
        },
        transform: {
            name: "@babel/plugin-transform-class-properties",
            url: "https://github.com/babel/babel/tree/main/packages/babel-plugin-transform-class-properties"
        }
    },
    classPrivateProperties: {
        syntax: {
            name: "@babel/plugin-syntax-class-properties",
            url: "https://github.com/babel/babel/tree/main/packages/babel-plugin-syntax-class-properties"
        },
        transform: {
            name: "@babel/plugin-transform-class-properties",
            url: "https://github.com/babel/babel/tree/main/packages/babel-plugin-transform-class-properties"
        }
    },
    classPrivateMethods: {
        syntax: {
            name: "@babel/plugin-syntax-class-properties",
            url: "https://github.com/babel/babel/tree/main/packages/babel-plugin-syntax-class-properties"
        },
        transform: {
            name: "@babel/plugin-transform-private-methods",
            url: "https://github.com/babel/babel/tree/main/packages/babel-plugin-transform-private-methods"
        }
    },
    classStaticBlock: {
        syntax: {
            name: "@babel/plugin-syntax-class-static-block",
            url: "https://github.com/babel/babel/tree/HEAD/packages/babel-plugin-syntax-class-static-block"
        },
        transform: {
            name: "@babel/plugin-transform-class-static-block",
            url: "https://github.com/babel/babel/tree/HEAD/packages/babel-plugin-transform-class-static-block"
        }
    },
    dynamicImport: {
        syntax: {
            name: "@babel/plugin-syntax-dynamic-import",
            url: "https://github.com/babel/babel/tree/main/packages/babel-plugin-syntax-dynamic-import"
        }
    },
    exportNamespaceFrom: {
        syntax: {
            name: "@babel/plugin-syntax-export-namespace-from",
            url: "https://github.com/babel/babel/tree/main/packages/babel-plugin-syntax-export-namespace-from"
        },
        transform: {
            name: "@babel/plugin-transform-export-namespace-from",
            url: "https://github.com/babel/babel/tree/main/packages/babel-plugin-transform-export-namespace-from"
        }
    },
    importAssertions: {
        syntax: {
            name: "@babel/plugin-syntax-import-assertions",
            url: "https://github.com/babel/babel/tree/main/packages/babel-plugin-syntax-import-assertions"
        }
    },
    importMeta: {
        syntax: {
            name: "@babel/plugin-syntax-import-meta",
            url: "https://github.com/babel/babel/tree/main/packages/babel-plugin-syntax-import-meta"
        }
    },
    logicalAssignment: {
        syntax: {
            name: "@babel/plugin-syntax-logical-assignment-operators",
            url: "https://github.com/babel/babel/tree/main/packages/babel-plugin-syntax-logical-assignment-operators"
        },
        transform: {
            name: "@babel/plugin-transform-logical-assignment-operators",
            url: "https://github.com/babel/babel/tree/main/packages/babel-plugin-transform-logical-assignment-operators"
        }
    },
    moduleStringNames: {
        syntax: {
            name: "@babel/plugin-syntax-module-string-names",
            url: "https://github.com/babel/babel/tree/main/packages/babel-plugin-syntax-module-string-names"
        }
    },
    numericSeparator: {
        syntax: {
            name: "@babel/plugin-syntax-numeric-separator",
            url: "https://github.com/babel/babel/tree/main/packages/babel-plugin-syntax-numeric-separator"
        },
        transform: {
            name: "@babel/plugin-transform-numeric-separator",
            url: "https://github.com/babel/babel/tree/main/packages/babel-plugin-transform-numeric-separator"
        }
    },
    nullishCoalescingOperator: {
        syntax: {
            name: "@babel/plugin-syntax-nullish-coalescing-operator",
            url: "https://github.com/babel/babel/tree/main/packages/babel-plugin-syntax-nullish-coalescing-operator"
        },
        transform: {
            name: "@babel/plugin-transform-nullish-coalescing-operator",
            url: "https://github.com/babel/babel/tree/main/packages/babel-plugin-transform-nullish-coalescing-opearator"
        }
    },
    objectRestSpread: {
        syntax: {
            name: "@babel/plugin-syntax-object-rest-spread",
            url: "https://github.com/babel/babel/tree/main/packages/babel-plugin-syntax-object-rest-spread"
        },
        transform: {
            name: "@babel/plugin-transform-object-rest-spread",
            url: "https://github.com/babel/babel/tree/main/packages/babel-plugin-transform-object-rest-spread"
        }
    },
    optionalCatchBinding: {
        syntax: {
            name: "@babel/plugin-syntax-optional-catch-binding",
            url: "https://github.com/babel/babel/tree/main/packages/babel-plugin-syntax-optional-catch-binding"
        },
        transform: {
            name: "@babel/plugin-transform-optional-catch-binding",
            url: "https://github.com/babel/babel/tree/main/packages/babel-plugin-transform-optional-catch-binding"
        }
    },
    optionalChaining: {
        syntax: {
            name: "@babel/plugin-syntax-optional-chaining",
            url: "https://github.com/babel/babel/tree/main/packages/babel-plugin-syntax-optional-chaining"
        },
        transform: {
            name: "@babel/plugin-transform-optional-chaining",
            url: "https://github.com/babel/babel/tree/main/packages/babel-plugin-transform-optional-chaining"
        }
    },
    privateIn: {
        syntax: {
            name: "@babel/plugin-syntax-private-property-in-object",
            url: "https://github.com/babel/babel/tree/main/packages/babel-plugin-syntax-private-property-in-object"
        },
        transform: {
            name: "@babel/plugin-transform-private-property-in-object",
            url: "https://github.com/babel/babel/tree/main/packages/babel-plugin-transform-private-property-in-object"
        }
    },
    regexpUnicodeSets: {
        syntax: {
            name: "@babel/plugin-syntax-unicode-sets-regex",
            url: "https://github.com/babel/babel/blob/main/packages/babel-plugin-syntax-unicode-sets-regex/README.md"
        },
        transform: {
            name: "@babel/plugin-transform-unicode-sets-regex",
            url: "https://github.com/babel/babel/blob/main/packages/babel-plugin-proposalunicode-sets-regex/README.md"
        }
    }
});
const $4a9e3035be61475a$var$getNameURLCombination = ({ name: name, url: url })=>`${name} (${url})`;
function $4a9e3035be61475a$var$generateMissingPluginMessage(missingPluginName, loc, codeFrame, filename) {
    let helpMessage = `Support for the experimental syntax '${missingPluginName}' isn't currently enabled ` + `(${loc.line}:${loc.column + 1}):\n\n` + codeFrame;
    const pluginInfo = $4a9e3035be61475a$var$pluginNameMap[missingPluginName];
    if (pluginInfo) {
        const { syntax: syntaxPlugin, transform: transformPlugin } = pluginInfo;
        if (syntaxPlugin) {
            const syntaxPluginInfo = $4a9e3035be61475a$var$getNameURLCombination(syntaxPlugin);
            if (transformPlugin) {
                const transformPluginInfo = $4a9e3035be61475a$var$getNameURLCombination(transformPlugin);
                const sectionType = transformPlugin.name.startsWith("@babel/plugin") ? "plugins" : "presets";
                helpMessage += `\n\nAdd ${transformPluginInfo} to the '${sectionType}' section of your Babel config to enable transformation.
If you want to leave it as-is, add ${syntaxPluginInfo} to the 'plugins' section to enable parsing.`;
            } else helpMessage += `\n\nAdd ${syntaxPluginInfo} to the 'plugins' section of your Babel config ` + `to enable parsing.`;
        }
    }
    const msgFilename = filename === "unknown" ? "<name of the input file>" : filename;
    helpMessage += `

If you already added the plugin for this syntax to your config, it's possible that your config \
isn't being loaded.
You can re-run Babel with the BABEL_SHOW_CONFIG_FOR environment variable to show the loaded \
configuration:
\tnpx cross-env BABEL_SHOW_CONFIG_FOR=${msgFilename} <your build command>
See https://babeljs.io/docs/configuration#print-effective-configs for more info.
`;
    return helpMessage;
}

});


parcelRegister("2gRU0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1a76e3418cb94cca$var$_default;
function $1a76e3418cb94cca$var$deepClone(value, cache) {
    if (value !== null) {
        if (cache.has(value)) return cache.get(value);
        let cloned;
        if (Array.isArray(value)) {
            cloned = new Array(value.length);
            cache.set(value, cloned);
            for(let i = 0; i < value.length; i++)cloned[i] = typeof value[i] !== "object" ? value[i] : $1a76e3418cb94cca$var$deepClone(value[i], cache);
        } else {
            cloned = {};
            cache.set(value, cloned);
            const keys = Object.keys(value);
            for(let i = 0; i < keys.length; i++){
                const key = keys[i];
                cloned[key] = typeof value[key] !== "object" ? value[key] : $1a76e3418cb94cca$var$deepClone(value[key], cache);
            }
        }
        return cloned;
    }
    return value;
}
function $1a76e3418cb94cca$var$_default(value) {
    if (typeof value !== "object") return value;
    return $1a76e3418cb94cca$var$deepClone(value, new Map());
}

});


parcelRegister("CCysw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $074174e736861b28$var$generateCode;

function $074174e736861b28$var$_convertSourceMap() {
    const data = (parcelRequire("7olKr"));
    $074174e736861b28$var$_convertSourceMap = function() {
        return data;
    };
    return data;
}

function $074174e736861b28$var$_generator() {
    const data = (parcelRequire("iQrBP"));
    $074174e736861b28$var$_generator = function() {
        return data;
    };
    return data;
}

var $7OAWx = parcelRequire("7OAWx");
function $074174e736861b28$var$generateCode(pluginPasses, file) {
    const { opts: opts, ast: ast, code: code, inputMap: inputMap } = file;
    const { generatorOpts: generatorOpts } = opts;
    generatorOpts.inputSourceMap = inputMap == null ? void 0 : inputMap.toObject();
    const results = [];
    for (const plugins of pluginPasses)for (const plugin of plugins){
        const { generatorOverride: generatorOverride } = plugin;
        if (generatorOverride) {
            const result = generatorOverride(ast, generatorOpts, code, $074174e736861b28$var$_generator().default);
            if (result !== undefined) results.push(result);
        }
    }
    let result;
    if (results.length === 0) result = (0, $074174e736861b28$var$_generator().default)(ast, generatorOpts, code);
    else if (results.length === 1) {
        result = results[0];
        if (typeof result.then === "function") throw new Error(`You appear to be using an async codegen plugin, ` + `which your current version of Babel does not support. ` + `If you're using a published plugin, ` + `you may need to upgrade your @babel/core version.`);
    } else throw new Error("More than one plugin attempted to override codegen.");
    let { code: outputCode, decodedMap: outputMap = result.map } = result;
    if (result.__mergedMap) outputMap = Object.assign({}, result.map);
    else if (outputMap) {
        if (inputMap) outputMap = (0, $7OAWx.default)(inputMap.toObject(), outputMap, generatorOpts.sourceFileName);
        else outputMap = result.map;
    }
    if (opts.sourceMaps === "inline" || opts.sourceMaps === "both") outputCode += "\n" + $074174e736861b28$var$_convertSourceMap().fromObject(outputMap).toComment();
    if (opts.sourceMaps === "inline") outputMap = null;
    return {
        outputCode: outputCode,
        outputMap: outputMap
    };
}

});
parcelRegister("7OAWx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5b09dc1078dfa852$var$mergeSourceMap;

function $5b09dc1078dfa852$var$_remapping() {
    const data = (parcelRequire("fDAPc"));
    $5b09dc1078dfa852$var$_remapping = function() {
        return data;
    };
    return data;
}
function $5b09dc1078dfa852$var$mergeSourceMap(inputMap, map, sourceFileName) {
    const source = sourceFileName.replace(/\\/g, "/");
    let found = false;
    const result = $5b09dc1078dfa852$var$_remapping()($5b09dc1078dfa852$var$rootless(map), (s, ctx)=>{
        if (s === source && !found) {
            found = true;
            ctx.source = "";
            return $5b09dc1078dfa852$var$rootless(inputMap);
        }
        return null;
    });
    if (typeof inputMap.sourceRoot === "string") result.sourceRoot = inputMap.sourceRoot;
    return Object.assign({}, result);
}
function $5b09dc1078dfa852$var$rootless(map) {
    return Object.assign({}, map, {
        sourceRoot: null
    });
}

});
parcelRegister("fDAPc", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $31b41b6a26d5d5ce$export$2e2bcd8739ae039);

var $5DzVE = parcelRequire("5DzVE");

var $1d5ib = parcelRequire("1d5ib");
const $31b41b6a26d5d5ce$var$SOURCELESS_MAPPING = /* #__PURE__ */ $31b41b6a26d5d5ce$var$SegmentObject("", -1, -1, "", null, false);
const $31b41b6a26d5d5ce$var$EMPTY_SOURCES = [];
function $31b41b6a26d5d5ce$var$SegmentObject(source, line, column, name, content, ignore) {
    return {
        source: source,
        line: line,
        column: column,
        name: name,
        content: content,
        ignore: ignore
    };
}
function $31b41b6a26d5d5ce$var$Source(map, sources, source, content, ignore) {
    return {
        map: map,
        sources: sources,
        source: source,
        content: content,
        ignore: ignore
    };
}
/**
 * MapSource represents a single sourcemap, with the ability to trace mappings into its child nodes
 * (which may themselves be SourceMapTrees).
 */ function $31b41b6a26d5d5ce$var$MapSource(map, sources) {
    return $31b41b6a26d5d5ce$var$Source(map, sources, "", null, false);
}
/**
 * A "leaf" node in the sourcemap tree, representing an original, unmodified source file. Recursive
 * segment tracing ends at the `OriginalSource`.
 */ function $31b41b6a26d5d5ce$var$OriginalSource(source, content, ignore) {
    return $31b41b6a26d5d5ce$var$Source(null, $31b41b6a26d5d5ce$var$EMPTY_SOURCES, source, content, ignore);
}
/**
 * traceMappings is only called on the root level SourceMapTree, and begins the process of
 * resolving each mapping in terms of the original source files.
 */ function $31b41b6a26d5d5ce$var$traceMappings(tree) {
    // TODO: Eventually support sourceRoot, which has to be removed because the sources are already
    // fully resolved. We'll need to make sources relative to the sourceRoot before adding them.
    const gen = new (0, $1d5ib.GenMapping)({
        file: tree.map.file
    });
    const { sources: rootSources, map: map } = tree;
    const rootNames = map.names;
    const rootMappings = (0, $5DzVE.decodedMappings)(map);
    for(let i = 0; i < rootMappings.length; i++){
        const segments = rootMappings[i];
        for(let j = 0; j < segments.length; j++){
            const segment = segments[j];
            const genCol = segment[0];
            let traced = $31b41b6a26d5d5ce$var$SOURCELESS_MAPPING;
            // 1-length segments only move the current generated column, there's no source information
            // to gather from it.
            if (segment.length !== 1) {
                const source = rootSources[segment[1]];
                traced = $31b41b6a26d5d5ce$var$originalPositionFor(source, segment[2], segment[3], segment.length === 5 ? rootNames[segment[4]] : "");
                // If the trace is invalid, then the trace ran into a sourcemap that doesn't contain a
                // respective segment into an original source.
                if (traced == null) continue;
            }
            const { column: column, line: line, name: name, content: content, source: source, ignore: ignore } = traced;
            (0, $1d5ib.maybeAddSegment)(gen, i, genCol, source, line, column, name);
            if (source && content != null) (0, $1d5ib.setSourceContent)(gen, source, content);
            if (ignore) (0, $1d5ib.setIgnore)(gen, source, true);
        }
    }
    return gen;
}
/**
 * originalPositionFor is only called on children SourceMapTrees. It recurses down into its own
 * child SourceMapTrees, until we find the original source map.
 */ function $31b41b6a26d5d5ce$var$originalPositionFor(source, line, column, name) {
    if (!source.map) return $31b41b6a26d5d5ce$var$SegmentObject(source.source, line, column, name, source.content, source.ignore);
    const segment = (0, $5DzVE.traceSegment)(source.map, line, column);
    // If we couldn't find a segment, then this doesn't exist in the sourcemap.
    if (segment == null) return null;
    // 1-length segments only move the current generated column, there's no source information
    // to gather from it.
    if (segment.length === 1) return $31b41b6a26d5d5ce$var$SOURCELESS_MAPPING;
    return $31b41b6a26d5d5ce$var$originalPositionFor(source.sources[segment[1]], segment[2], segment[3], segment.length === 5 ? source.map.names[segment[4]] : name);
}
function $31b41b6a26d5d5ce$var$asArray(value) {
    if (Array.isArray(value)) return value;
    return [
        value
    ];
}
/**
 * Recursively builds a tree structure out of sourcemap files, with each node
 * being either an `OriginalSource` "leaf" or a `SourceMapTree` composed of
 * `OriginalSource`s and `SourceMapTree`s.
 *
 * Every sourcemap is composed of a collection of source files and mappings
 * into locations of those source files. When we generate a `SourceMapTree` for
 * the sourcemap, we attempt to load each source file's own sourcemap. If it
 * does not have an associated sourcemap, it is considered an original,
 * unmodified source file.
 */ function $31b41b6a26d5d5ce$var$buildSourceMapTree(input, loader) {
    const maps = $31b41b6a26d5d5ce$var$asArray(input).map((m)=>new (0, $5DzVE.TraceMap)(m, ""));
    const map = maps.pop();
    for(let i = 0; i < maps.length; i++){
        if (maps[i].sources.length > 1) throw new Error(`Transformation map ${i} must have exactly one source file.\n` + "Did you specify these with the most recent transformation maps first?");
    }
    let tree = $31b41b6a26d5d5ce$var$build(map, loader, "", 0);
    for(let i = maps.length - 1; i >= 0; i--)tree = $31b41b6a26d5d5ce$var$MapSource(maps[i], [
        tree
    ]);
    return tree;
}
function $31b41b6a26d5d5ce$var$build(map, loader, importer, importerDepth) {
    const { resolvedSources: resolvedSources, sourcesContent: sourcesContent, ignoreList: ignoreList } = map;
    const depth = importerDepth + 1;
    const children = resolvedSources.map((sourceFile, i)=>{
        // The loading context gives the loader more information about why this file is being loaded
        // (eg, from which importer). It also allows the loader to override the location of the loaded
        // sourcemap/original source, or to override the content in the sourcesContent field if it's
        // an unmodified source file.
        const ctx = {
            importer: importer,
            depth: depth,
            source: sourceFile || "",
            content: undefined,
            ignore: undefined
        };
        // Use the provided loader callback to retrieve the file's sourcemap.
        // TODO: We should eventually support async loading of sourcemap files.
        const sourceMap = loader(ctx.source, ctx);
        const { source: source, content: content, ignore: ignore } = ctx;
        // If there is a sourcemap, then we need to recurse into it to load its source files.
        if (sourceMap) return $31b41b6a26d5d5ce$var$build(new (0, $5DzVE.TraceMap)(sourceMap, source), loader, source, depth);
        // Else, it's an unmodified source file.
        // The contents of this unmodified source file can be overridden via the loader context,
        // allowing it to be explicitly null or a string. If it remains undefined, we fall back to
        // the importing sourcemap's `sourcesContent` field.
        const sourceContent = content !== undefined ? content : sourcesContent ? sourcesContent[i] : null;
        const ignored = ignore !== undefined ? ignore : ignoreList ? ignoreList.includes(i) : false;
        return $31b41b6a26d5d5ce$var$OriginalSource(source, sourceContent, ignored);
    });
    return $31b41b6a26d5d5ce$var$MapSource(map, children);
}
/**
 * A SourceMap v3 compatible sourcemap, which only includes fields that were
 * provided to it.
 */ class $31b41b6a26d5d5ce$var$SourceMap {
    constructor(map, options){
        const out = options.decodedMappings ? (0, $1d5ib.toDecodedMap)(map) : (0, $1d5ib.toEncodedMap)(map);
        this.version = out.version; // SourceMap spec says this should be first.
        this.file = out.file;
        this.mappings = out.mappings;
        this.names = out.names;
        this.ignoreList = out.ignoreList;
        this.sourceRoot = out.sourceRoot;
        this.sources = out.sources;
        if (!options.excludeContent) this.sourcesContent = out.sourcesContent;
    }
    toString() {
        return JSON.stringify(this);
    }
}
/**
 * Traces through all the mappings in the root sourcemap, through the sources
 * (and their sourcemaps), all the way back to the original source location.
 *
 * `loader` will be called every time we encounter a source file. If it returns
 * a sourcemap, we will recurse into that sourcemap to continue the trace. If
 * it returns a falsey value, that source file is treated as an original,
 * unmodified source file.
 *
 * Pass `excludeContent` to exclude any self-containing source file content
 * from the output sourcemap.
 *
 * Pass `decodedMappings` to receive a SourceMap with decoded (instead of
 * VLQ encoded) mappings.
 */ function $31b41b6a26d5d5ce$export$2e2bcd8739ae039(input, loader, options) {
    const opts = typeof options === "object" ? options : {
        excludeContent: !!options,
        decodedMappings: false
    };
    const tree = $31b41b6a26d5d5ce$var$buildSourceMapTree(input, loader);
    return new $31b41b6a26d5d5ce$var$SourceMap($31b41b6a26d5d5ce$var$traceMappings(tree), opts);
}

});





parcelRegister("5nbgi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.transformFile = void 0;
module.exports.transformFileAsync = $3e97d61c5b7a325d$var$transformFileAsync;
module.exports.transformFileSync = $3e97d61c5b7a325d$var$transformFileSync;
const $3e97d61c5b7a325d$var$transformFile = module.exports.transformFile = function transformFile(filename, opts, callback) {
    if (typeof opts === "function") callback = opts;
    callback(new Error("Transforming files is not supported in browsers"), null);
};
function $3e97d61c5b7a325d$var$transformFileSync() {
    throw new Error("Transforming files is not supported in browsers");
}
function $3e97d61c5b7a325d$var$transformFileAsync() {
    return Promise.reject(new Error("Transforming files is not supported in browsers"));
}

});

parcelRegister("7pAM0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.transformFromAst = void 0;
module.exports.transformFromAstAsync = $565764a1349ce36d$var$transformFromAstAsync;
module.exports.transformFromAstSync = $565764a1349ce36d$var$transformFromAstSync;

function $565764a1349ce36d$var$_gensync() {
    const data = (parcelRequire("8AIEE"));
    $565764a1349ce36d$var$_gensync = function() {
        return data;
    };
    return data;
}

var $6JZbd = parcelRequire("6JZbd");

var $dsYSd = parcelRequire("dsYSd");

var $jYXMt = parcelRequire("jYXMt");
const $565764a1349ce36d$var$transformFromAstRunner = $565764a1349ce36d$var$_gensync()(function*(ast, code, opts) {
    const config = yield* (0, $6JZbd.default)(opts);
    if (config === null) return null;
    if (!ast) throw new Error("No AST given");
    return yield* (0, $dsYSd.run)(config, code, ast);
});
const $565764a1349ce36d$var$transformFromAst = module.exports.transformFromAst = function transformFromAst(ast, code, optsOrCallback, maybeCallback) {
    let opts;
    let callback;
    if (typeof optsOrCallback === "function") {
        callback = optsOrCallback;
        opts = undefined;
    } else {
        opts = optsOrCallback;
        callback = maybeCallback;
    }
    if (callback === undefined) return (0, $jYXMt.beginHiddenCallStack)($565764a1349ce36d$var$transformFromAstRunner.sync)(ast, code, opts);
    (0, $jYXMt.beginHiddenCallStack)($565764a1349ce36d$var$transformFromAstRunner.errback)(ast, code, opts, callback);
};
function $565764a1349ce36d$var$transformFromAstSync(...args) {
    return (0, $jYXMt.beginHiddenCallStack)($565764a1349ce36d$var$transformFromAstRunner.sync)(...args);
}
function $565764a1349ce36d$var$transformFromAstAsync(...args) {
    return (0, $jYXMt.beginHiddenCallStack)($565764a1349ce36d$var$transformFromAstRunner.async)(...args);
}

});

parcelRegister("dJ9wd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parse = void 0;
module.exports.parseAsync = $9fe6dc8d2bfdf90b$var$parseAsync;
module.exports.parseSync = $9fe6dc8d2bfdf90b$var$parseSync;

function $9fe6dc8d2bfdf90b$var$_gensync() {
    const data = (parcelRequire("8AIEE"));
    $9fe6dc8d2bfdf90b$var$_gensync = function() {
        return data;
    };
    return data;
}

var $6JZbd = parcelRequire("6JZbd");

var $3Igfj = parcelRequire("3Igfj");

var $5umil = parcelRequire("5umil");

var $jYXMt = parcelRequire("jYXMt");
const $9fe6dc8d2bfdf90b$var$parseRunner = $9fe6dc8d2bfdf90b$var$_gensync()(function* parse(code, opts) {
    const config = yield* (0, $6JZbd.default)(opts);
    if (config === null) return null;
    return yield* (0, $3Igfj.default)(config.passes, (0, $5umil.default)(config), code);
});
const $9fe6dc8d2bfdf90b$var$parse = module.exports.parse = function parse(code, opts, callback) {
    if (typeof opts === "function") {
        callback = opts;
        opts = undefined;
    }
    if (callback === undefined) return (0, $jYXMt.beginHiddenCallStack)($9fe6dc8d2bfdf90b$var$parseRunner.sync)(code, opts);
    (0, $jYXMt.beginHiddenCallStack)($9fe6dc8d2bfdf90b$var$parseRunner.errback)(code, opts, callback);
};
function $9fe6dc8d2bfdf90b$var$parseSync(...args) {
    return (0, $jYXMt.beginHiddenCallStack)($9fe6dc8d2bfdf90b$var$parseRunner.sync)(...args);
}
function $9fe6dc8d2bfdf90b$var$parseAsync(...args) {
    return (0, $jYXMt.beginHiddenCallStack)($9fe6dc8d2bfdf90b$var$parseRunner.async)(...args);
}

});


parcelRegister("ePJIL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "ImportInjector", {
    enumerable: true,
    get: function() {
        return $lRkf5.default;
    }
});
module.exports.addDefault = $acc94b5d88f1934a$var$addDefault;
module.exports.addNamed = $acc94b5d88f1934a$var$addNamed;
module.exports.addNamespace = $acc94b5d88f1934a$var$addNamespace;
module.exports.addSideEffect = $acc94b5d88f1934a$var$addSideEffect;
Object.defineProperty(module.exports, "isModule", {
    enumerable: true,
    get: function() {
        return $cHVJI.default;
    }
});

var $lRkf5 = parcelRequire("lRkf5");

var $cHVJI = parcelRequire("cHVJI");
function $acc94b5d88f1934a$var$addDefault(path, importedSource, opts) {
    return new $lRkf5.default(path).addDefault(importedSource, opts);
}
function $acc94b5d88f1934a$var$addNamed(path, name, importedSource, opts) {
    return new $lRkf5.default(path).addNamed(name, importedSource, opts);
}
function $acc94b5d88f1934a$var$addNamespace(path, importedSource, opts) {
    return new $lRkf5.default(path).addNamespace(importedSource, opts);
}
function $acc94b5d88f1934a$var$addSideEffect(path, importedSource, opts) {
    return new $lRkf5.default(path).addSideEffect(importedSource, opts);
}

});
parcelRegister("lRkf5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $aLUwE = parcelRequire("aLUwE");

var $ardUq = parcelRequire("ardUq");

var $fQheA = parcelRequire("fQheA");

var $cHVJI = parcelRequire("cHVJI");
const { identifier: $fe9e3fed4710ca73$var$identifier, importSpecifier: $fe9e3fed4710ca73$var$importSpecifier, numericLiteral: $fe9e3fed4710ca73$var$numericLiteral, sequenceExpression: $fe9e3fed4710ca73$var$sequenceExpression, isImportDeclaration: $fe9e3fed4710ca73$var$isImportDeclaration } = $ardUq;
class $fe9e3fed4710ca73$var$ImportInjector {
    constructor(path, importedSource, opts){
        this._defaultOpts = {
            importedSource: null,
            importedType: "commonjs",
            importedInterop: "babel",
            importingInterop: "babel",
            ensureLiveReference: false,
            ensureNoContext: false,
            importPosition: "before"
        };
        const programPath = path.find((p)=>p.isProgram());
        this._programPath = programPath;
        this._programScope = programPath.scope;
        this._hub = programPath.hub;
        this._defaultOpts = this._applyDefaults(importedSource, opts, true);
    }
    addDefault(importedSourceIn, opts) {
        return this.addNamed("default", importedSourceIn, opts);
    }
    addNamed(importName, importedSourceIn, opts) {
        $aLUwE(typeof importName === "string");
        return this._generateImport(this._applyDefaults(importedSourceIn, opts), importName);
    }
    addNamespace(importedSourceIn, opts) {
        return this._generateImport(this._applyDefaults(importedSourceIn, opts), null);
    }
    addSideEffect(importedSourceIn, opts) {
        return this._generateImport(this._applyDefaults(importedSourceIn, opts), void 0);
    }
    _applyDefaults(importedSource, opts, isInit = false) {
        let newOpts;
        if (typeof importedSource === "string") newOpts = Object.assign({}, this._defaultOpts, {
            importedSource: importedSource
        }, opts);
        else {
            $aLUwE(!opts, "Unexpected secondary arguments.");
            newOpts = Object.assign({}, this._defaultOpts, importedSource);
        }
        if (!isInit && opts) {
            if (opts.nameHint !== undefined) newOpts.nameHint = opts.nameHint;
            if (opts.blockHoist !== undefined) newOpts.blockHoist = opts.blockHoist;
        }
        return newOpts;
    }
    _generateImport(opts, importName) {
        const isDefault = importName === "default";
        const isNamed = !!importName && !isDefault;
        const isNamespace = importName === null;
        const { importedSource: importedSource, importedType: importedType, importedInterop: importedInterop, importingInterop: importingInterop, ensureLiveReference: ensureLiveReference, ensureNoContext: ensureNoContext, nameHint: nameHint, importPosition: importPosition, blockHoist: blockHoist } = opts;
        let name = nameHint || importName;
        const isMod = (0, $cHVJI.default)(this._programPath);
        const isModuleForNode = isMod && importingInterop === "node";
        const isModuleForBabel = isMod && importingInterop === "babel";
        if (importPosition === "after" && !isMod) throw new Error(`"importPosition": "after" is only supported in modules`);
        const builder = new $fQheA.default(importedSource, this._programScope, this._hub);
        if (importedType === "es6") {
            if (!isModuleForNode && !isModuleForBabel) throw new Error("Cannot import an ES6 module from CommonJS");
            builder.import();
            if (isNamespace) builder.namespace(nameHint || importedSource);
            else if (isDefault || isNamed) builder.named(name, importName);
        } else if (importedType !== "commonjs") throw new Error(`Unexpected interopType "${importedType}"`);
        else if (importedInterop === "babel") {
            if (isModuleForNode) {
                name = name !== "default" ? name : importedSource;
                const es6Default = `${importedSource}$es6Default`;
                builder.import();
                if (isNamespace) builder.default(es6Default).var(name || importedSource).wildcardInterop();
                else if (isDefault) {
                    if (ensureLiveReference) builder.default(es6Default).var(name || importedSource).defaultInterop().read("default");
                    else builder.default(es6Default).var(name).defaultInterop().prop(importName);
                } else if (isNamed) builder.default(es6Default).read(importName);
            } else if (isModuleForBabel) {
                builder.import();
                if (isNamespace) builder.namespace(name || importedSource);
                else if (isDefault || isNamed) builder.named(name, importName);
            } else {
                builder.require();
                if (isNamespace) builder.var(name || importedSource).wildcardInterop();
                else if ((isDefault || isNamed) && ensureLiveReference) {
                    if (isDefault) {
                        name = name !== "default" ? name : importedSource;
                        builder.var(name).read(importName);
                        builder.defaultInterop();
                    } else builder.var(importedSource).read(importName);
                } else if (isDefault) builder.var(name).defaultInterop().prop(importName);
                else if (isNamed) builder.var(name).prop(importName);
            }
        } else if (importedInterop === "compiled") {
            if (isModuleForNode) {
                builder.import();
                if (isNamespace) builder.default(name || importedSource);
                else if (isDefault || isNamed) builder.default(importedSource).read(name);
            } else if (isModuleForBabel) {
                builder.import();
                if (isNamespace) builder.namespace(name || importedSource);
                else if (isDefault || isNamed) builder.named(name, importName);
            } else {
                builder.require();
                if (isNamespace) builder.var(name || importedSource);
                else if (isDefault || isNamed) {
                    if (ensureLiveReference) builder.var(importedSource).read(name);
                    else builder.prop(importName).var(name);
                }
            }
        } else if (importedInterop === "uncompiled") {
            if (isDefault && ensureLiveReference) throw new Error("No live reference for commonjs default");
            if (isModuleForNode) {
                builder.import();
                if (isNamespace) builder.default(name || importedSource);
                else if (isDefault) builder.default(name);
                else if (isNamed) builder.default(importedSource).read(name);
            } else if (isModuleForBabel) {
                builder.import();
                if (isNamespace) builder.default(name || importedSource);
                else if (isDefault) builder.default(name);
                else if (isNamed) builder.named(name, importName);
            } else {
                builder.require();
                if (isNamespace) builder.var(name || importedSource);
                else if (isDefault) builder.var(name);
                else if (isNamed) {
                    if (ensureLiveReference) builder.var(importedSource).read(name);
                    else builder.var(name).prop(importName);
                }
            }
        } else throw new Error(`Unknown importedInterop "${importedInterop}".`);
        const { statements: statements, resultName: resultName } = builder.done();
        this._insertStatements(statements, importPosition, blockHoist);
        if ((isDefault || isNamed) && ensureNoContext && resultName.type !== "Identifier") return $fe9e3fed4710ca73$var$sequenceExpression([
            $fe9e3fed4710ca73$var$numericLiteral(0),
            resultName
        ]);
        return resultName;
    }
    _insertStatements(statements, importPosition = "before", blockHoist = 3) {
        if (importPosition === "after") {
            if (this._insertStatementsAfter(statements)) return;
        } else {
            if (this._insertStatementsBefore(statements, blockHoist)) return;
        }
        this._programPath.unshiftContainer("body", statements);
    }
    _insertStatementsBefore(statements, blockHoist) {
        if (statements.length === 1 && $fe9e3fed4710ca73$var$isImportDeclaration(statements[0]) && $fe9e3fed4710ca73$var$isValueImport(statements[0])) {
            const firstImportDecl = this._programPath.get("body").find((p)=>{
                return p.isImportDeclaration() && $fe9e3fed4710ca73$var$isValueImport(p.node);
            });
            if ((firstImportDecl == null ? void 0 : firstImportDecl.node.source.value) === statements[0].source.value && $fe9e3fed4710ca73$var$maybeAppendImportSpecifiers(firstImportDecl.node, statements[0])) return true;
        }
        statements.forEach((node)=>{
            node._blockHoist = blockHoist;
        });
        const targetPath = this._programPath.get("body").find((p)=>{
            const val = p.node._blockHoist;
            return Number.isFinite(val) && val < 4;
        });
        if (targetPath) {
            targetPath.insertBefore(statements);
            return true;
        }
        return false;
    }
    _insertStatementsAfter(statements) {
        const statementsSet = new Set(statements);
        const importDeclarations = new Map();
        for (const statement of statements)if ($fe9e3fed4710ca73$var$isImportDeclaration(statement) && $fe9e3fed4710ca73$var$isValueImport(statement)) {
            const source = statement.source.value;
            if (!importDeclarations.has(source)) importDeclarations.set(source, []);
            importDeclarations.get(source).push(statement);
        }
        let lastImportPath = null;
        for (const bodyStmt of this._programPath.get("body"))if (bodyStmt.isImportDeclaration() && $fe9e3fed4710ca73$var$isValueImport(bodyStmt.node)) {
            lastImportPath = bodyStmt;
            const source = bodyStmt.node.source.value;
            const newImports = importDeclarations.get(source);
            if (!newImports) continue;
            for (const decl of newImports){
                if (!statementsSet.has(decl)) continue;
                if ($fe9e3fed4710ca73$var$maybeAppendImportSpecifiers(bodyStmt.node, decl)) statementsSet.delete(decl);
            }
        }
        if (statementsSet.size === 0) return true;
        if (lastImportPath) lastImportPath.insertAfter(Array.from(statementsSet));
        return !!lastImportPath;
    }
}
module.exports.default = $fe9e3fed4710ca73$var$ImportInjector;
function $fe9e3fed4710ca73$var$isValueImport(node) {
    return node.importKind !== "type" && node.importKind !== "typeof";
}
function $fe9e3fed4710ca73$var$hasNamespaceImport(node) {
    return node.specifiers.length === 1 && node.specifiers[0].type === "ImportNamespaceSpecifier" || node.specifiers.length === 2 && node.specifiers[1].type === "ImportNamespaceSpecifier";
}
function $fe9e3fed4710ca73$var$hasDefaultImport(node) {
    return node.specifiers.length > 0 && node.specifiers[0].type === "ImportDefaultSpecifier";
}
function $fe9e3fed4710ca73$var$maybeAppendImportSpecifiers(target, source) {
    if (!target.specifiers.length) {
        target.specifiers = source.specifiers;
        return true;
    }
    if (!source.specifiers.length) return true;
    if ($fe9e3fed4710ca73$var$hasNamespaceImport(target) || $fe9e3fed4710ca73$var$hasNamespaceImport(source)) return false;
    if ($fe9e3fed4710ca73$var$hasDefaultImport(source)) {
        if ($fe9e3fed4710ca73$var$hasDefaultImport(target)) source.specifiers[0] = $fe9e3fed4710ca73$var$importSpecifier(source.specifiers[0].local, $fe9e3fed4710ca73$var$identifier("default"));
        else target.specifiers.unshift(source.specifiers.shift());
    }
    target.specifiers.push(...source.specifiers);
    return true;
}

});
parcelRegister("fQheA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $aLUwE = parcelRequire("aLUwE");

var $ardUq = parcelRequire("ardUq");
const { callExpression: $b88914b0469aa525$var$callExpression, cloneNode: $b88914b0469aa525$var$cloneNode, expressionStatement: $b88914b0469aa525$var$expressionStatement, identifier: $b88914b0469aa525$var$identifier, importDeclaration: $b88914b0469aa525$var$importDeclaration, importDefaultSpecifier: $b88914b0469aa525$var$importDefaultSpecifier, importNamespaceSpecifier: $b88914b0469aa525$var$importNamespaceSpecifier, importSpecifier: $b88914b0469aa525$var$importSpecifier, memberExpression: $b88914b0469aa525$var$memberExpression, stringLiteral: $b88914b0469aa525$var$stringLiteral, variableDeclaration: $b88914b0469aa525$var$variableDeclaration, variableDeclarator: $b88914b0469aa525$var$variableDeclarator } = $ardUq;
class $b88914b0469aa525$var$ImportBuilder {
    constructor(importedSource, scope, hub){
        this._statements = [];
        this._resultName = null;
        this._importedSource = void 0;
        this._scope = scope;
        this._hub = hub;
        this._importedSource = importedSource;
    }
    done() {
        return {
            statements: this._statements,
            resultName: this._resultName
        };
    }
    import() {
        this._statements.push($b88914b0469aa525$var$importDeclaration([], $b88914b0469aa525$var$stringLiteral(this._importedSource)));
        return this;
    }
    require() {
        this._statements.push($b88914b0469aa525$var$expressionStatement($b88914b0469aa525$var$callExpression($b88914b0469aa525$var$identifier("require"), [
            $b88914b0469aa525$var$stringLiteral(this._importedSource)
        ])));
        return this;
    }
    namespace(name = "namespace") {
        const local = this._scope.generateUidIdentifier(name);
        const statement = this._statements[this._statements.length - 1];
        $aLUwE(statement.type === "ImportDeclaration");
        $aLUwE(statement.specifiers.length === 0);
        statement.specifiers = [
            $b88914b0469aa525$var$importNamespaceSpecifier(local)
        ];
        this._resultName = $b88914b0469aa525$var$cloneNode(local);
        return this;
    }
    default(name) {
        const id = this._scope.generateUidIdentifier(name);
        const statement = this._statements[this._statements.length - 1];
        $aLUwE(statement.type === "ImportDeclaration");
        $aLUwE(statement.specifiers.length === 0);
        statement.specifiers = [
            $b88914b0469aa525$var$importDefaultSpecifier(id)
        ];
        this._resultName = $b88914b0469aa525$var$cloneNode(id);
        return this;
    }
    named(name, importName) {
        if (importName === "default") return this.default(name);
        const id = this._scope.generateUidIdentifier(name);
        const statement = this._statements[this._statements.length - 1];
        $aLUwE(statement.type === "ImportDeclaration");
        $aLUwE(statement.specifiers.length === 0);
        statement.specifiers = [
            $b88914b0469aa525$var$importSpecifier(id, $b88914b0469aa525$var$identifier(importName))
        ];
        this._resultName = $b88914b0469aa525$var$cloneNode(id);
        return this;
    }
    var(name) {
        const id = this._scope.generateUidIdentifier(name);
        let statement = this._statements[this._statements.length - 1];
        if (statement.type !== "ExpressionStatement") {
            $aLUwE(this._resultName);
            statement = $b88914b0469aa525$var$expressionStatement(this._resultName);
            this._statements.push(statement);
        }
        this._statements[this._statements.length - 1] = $b88914b0469aa525$var$variableDeclaration("var", [
            $b88914b0469aa525$var$variableDeclarator(id, statement.expression)
        ]);
        this._resultName = $b88914b0469aa525$var$cloneNode(id);
        return this;
    }
    defaultInterop() {
        return this._interop(this._hub.addHelper("interopRequireDefault"));
    }
    wildcardInterop() {
        return this._interop(this._hub.addHelper("interopRequireWildcard"));
    }
    _interop(callee) {
        const statement = this._statements[this._statements.length - 1];
        if (statement.type === "ExpressionStatement") statement.expression = $b88914b0469aa525$var$callExpression(callee, [
            statement.expression
        ]);
        else if (statement.type === "VariableDeclaration") {
            $aLUwE(statement.declarations.length === 1);
            statement.declarations[0].init = $b88914b0469aa525$var$callExpression(callee, [
                statement.declarations[0].init
            ]);
        } else $aLUwE.fail("Unexpected type.");
        return this;
    }
    prop(name) {
        const statement = this._statements[this._statements.length - 1];
        if (statement.type === "ExpressionStatement") statement.expression = $b88914b0469aa525$var$memberExpression(statement.expression, $b88914b0469aa525$var$identifier(name));
        else if (statement.type === "VariableDeclaration") {
            $aLUwE(statement.declarations.length === 1);
            statement.declarations[0].init = $b88914b0469aa525$var$memberExpression(statement.declarations[0].init, $b88914b0469aa525$var$identifier(name));
        } else $aLUwE.fail("Unexpected type:" + statement.type);
        return this;
    }
    read(name) {
        this._resultName = $b88914b0469aa525$var$memberExpression(this._resultName, $b88914b0469aa525$var$identifier(name));
    }
}
module.exports.default = $b88914b0469aa525$var$ImportBuilder;

});

parcelRegister("cHVJI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9406496ed587bb9b$var$isModule;
function $9406496ed587bb9b$var$isModule(path) {
    return path.node.sourceType === "module";
}

});



parcelRegister("hnZgL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ca841c76663167c4$var$rewriteThis;

var $elWuE = parcelRequire("elWuE");

var $7Ockm = parcelRequire("7Ockm");
const { numericLiteral: $ca841c76663167c4$var$numericLiteral, unaryExpression: $ca841c76663167c4$var$unaryExpression } = $7Ockm.types;
const $ca841c76663167c4$var$rewriteThisVisitor = $7Ockm.traverse.visitors.merge([
    $elWuE.default,
    {
        ThisExpression (path) {
            path.replaceWith($ca841c76663167c4$var$unaryExpression("void", $ca841c76663167c4$var$numericLiteral(0), true));
        }
    }
]);
function $ca841c76663167c4$var$rewriteThis(programPath) {
    (0, $7Ockm.traverse)(programPath.node, Object.assign({}, $ca841c76663167c4$var$rewriteThisVisitor, {
        noScope: true
    }));
}

});

parcelRegister("hNWIx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $cf648f4ed1c07dbd$var$rewriteLiveReferences;

var $aLUwE = parcelRequire("aLUwE");

var $7Ockm = parcelRequire("7Ockm");

var $f4Xay = parcelRequire("f4Xay");
const { assignmentExpression: $cf648f4ed1c07dbd$var$assignmentExpression, cloneNode: $cf648f4ed1c07dbd$var$cloneNode, expressionStatement: $cf648f4ed1c07dbd$var$expressionStatement, getOuterBindingIdentifiers: $cf648f4ed1c07dbd$var$getOuterBindingIdentifiers, identifier: $cf648f4ed1c07dbd$var$identifier, isArrowFunctionExpression: $cf648f4ed1c07dbd$var$isArrowFunctionExpression, isClassExpression: $cf648f4ed1c07dbd$var$isClassExpression, isFunctionExpression: $cf648f4ed1c07dbd$var$isFunctionExpression, isIdentifier: $cf648f4ed1c07dbd$var$isIdentifier, isMemberExpression: $cf648f4ed1c07dbd$var$isMemberExpression, isVariableDeclaration: $cf648f4ed1c07dbd$var$isVariableDeclaration, jsxIdentifier: $cf648f4ed1c07dbd$var$jsxIdentifier, jsxMemberExpression: $cf648f4ed1c07dbd$var$jsxMemberExpression, memberExpression: $cf648f4ed1c07dbd$var$memberExpression, numericLiteral: $cf648f4ed1c07dbd$var$numericLiteral, sequenceExpression: $cf648f4ed1c07dbd$var$sequenceExpression, stringLiteral: $cf648f4ed1c07dbd$var$stringLiteral, variableDeclaration: $cf648f4ed1c07dbd$var$variableDeclaration, variableDeclarator: $cf648f4ed1c07dbd$var$variableDeclarator } = $7Ockm.types;
function $cf648f4ed1c07dbd$var$isInType(path) {
    do switch(path.parent.type){
        case "TSTypeAnnotation":
        case "TSTypeAliasDeclaration":
        case "TSTypeReference":
        case "TypeAnnotation":
        case "TypeAlias":
            return true;
        case "ExportSpecifier":
            return path.parentPath.parent.exportKind === "type";
        default:
            if (path.parentPath.isStatement() || path.parentPath.isExpression()) return false;
    }
    while (path = path.parentPath);
}
function $cf648f4ed1c07dbd$var$rewriteLiveReferences(programPath, metadata, wrapReference) {
    const imported = new Map();
    const exported = new Map();
    const requeueInParent = (path)=>{
        programPath.requeue(path);
    };
    for (const [source, data] of metadata.source){
        for (const [localName, importName] of data.imports)imported.set(localName, [
            source,
            importName,
            null
        ]);
        for (const localName of data.importsNamespace)imported.set(localName, [
            source,
            null,
            localName
        ]);
    }
    for (const [local, data] of metadata.local){
        let exportMeta = exported.get(local);
        if (!exportMeta) {
            exportMeta = [];
            exported.set(local, exportMeta);
        }
        exportMeta.push(...data.names);
    }
    const rewriteBindingInitVisitorState = {
        metadata: metadata,
        requeueInParent: requeueInParent,
        scope: programPath.scope,
        exported: exported
    };
    programPath.traverse($cf648f4ed1c07dbd$var$rewriteBindingInitVisitor, rewriteBindingInitVisitorState);
    const bindingNames = new Set([
        ...Array.from(imported.keys()),
        ...Array.from(exported.keys())
    ]);
    (0, $f4Xay.default)(programPath, bindingNames, false);
    const rewriteReferencesVisitorState = {
        seen: new WeakSet(),
        metadata: metadata,
        requeueInParent: requeueInParent,
        scope: programPath.scope,
        imported: imported,
        exported: exported,
        buildImportReference ([source, importName, localName], identNode) {
            const meta = metadata.source.get(source);
            meta.referenced = true;
            if (localName) {
                if (meta.wrap) {
                    var _wrapReference;
                    identNode = (_wrapReference = wrapReference(identNode, meta.wrap)) != null ? _wrapReference : identNode;
                }
                return identNode;
            }
            let namespace = $cf648f4ed1c07dbd$var$identifier(meta.name);
            if (meta.wrap) {
                var _wrapReference2;
                namespace = (_wrapReference2 = wrapReference(namespace, meta.wrap)) != null ? _wrapReference2 : namespace;
            }
            if (importName === "default" && meta.interop === "node-default") return namespace;
            const computed = metadata.stringSpecifiers.has(importName);
            return $cf648f4ed1c07dbd$var$memberExpression(namespace, computed ? $cf648f4ed1c07dbd$var$stringLiteral(importName) : $cf648f4ed1c07dbd$var$identifier(importName), computed);
        }
    };
    programPath.traverse($cf648f4ed1c07dbd$var$rewriteReferencesVisitor, rewriteReferencesVisitorState);
}
const $cf648f4ed1c07dbd$var$rewriteBindingInitVisitor = {
    Scope (path) {
        path.skip();
    },
    ClassDeclaration (path) {
        const { requeueInParent: requeueInParent, exported: exported, metadata: metadata } = this;
        const { id: id } = path.node;
        if (!id) throw new Error("Expected class to have a name");
        const localName = id.name;
        const exportNames = exported.get(localName) || [];
        if (exportNames.length > 0) {
            const statement = $cf648f4ed1c07dbd$var$expressionStatement($cf648f4ed1c07dbd$var$buildBindingExportAssignmentExpression(metadata, exportNames, $cf648f4ed1c07dbd$var$identifier(localName), path.scope));
            statement._blockHoist = path.node._blockHoist;
            requeueInParent(path.insertAfter(statement)[0]);
        }
    },
    VariableDeclaration (path) {
        const { requeueInParent: requeueInParent, exported: exported, metadata: metadata } = this;
        const isVar = path.node.kind === "var";
        for (const decl of path.get("declarations")){
            const { id: id } = decl.node;
            let { init: init } = decl.node;
            if ($cf648f4ed1c07dbd$var$isIdentifier(id) && exported.has(id.name) && !$cf648f4ed1c07dbd$var$isArrowFunctionExpression(init) && (!$cf648f4ed1c07dbd$var$isFunctionExpression(init) || init.id) && (!$cf648f4ed1c07dbd$var$isClassExpression(init) || init.id)) {
                if (!init) {
                    if (isVar) continue;
                    else init = path.scope.buildUndefinedNode();
                }
                decl.node.init = $cf648f4ed1c07dbd$var$buildBindingExportAssignmentExpression(metadata, exported.get(id.name), init, path.scope);
                requeueInParent(decl.get("init"));
            } else {
                for (const localName of Object.keys(decl.getOuterBindingIdentifiers()))if (exported.has(localName)) {
                    const statement = $cf648f4ed1c07dbd$var$expressionStatement($cf648f4ed1c07dbd$var$buildBindingExportAssignmentExpression(metadata, exported.get(localName), $cf648f4ed1c07dbd$var$identifier(localName), path.scope));
                    statement._blockHoist = path.node._blockHoist;
                    requeueInParent(path.insertAfter(statement)[0]);
                }
            }
        }
    }
};
const $cf648f4ed1c07dbd$var$buildBindingExportAssignmentExpression = (metadata, exportNames, localExpr, scope)=>{
    const exportsObjectName = metadata.exportName;
    for(let currentScope = scope; currentScope != null; currentScope = currentScope.parent)if (currentScope.hasOwnBinding(exportsObjectName)) currentScope.rename(exportsObjectName);
    return (exportNames || []).reduce((expr, exportName)=>{
        const { stringSpecifiers: stringSpecifiers } = metadata;
        const computed = stringSpecifiers.has(exportName);
        return $cf648f4ed1c07dbd$var$assignmentExpression("=", $cf648f4ed1c07dbd$var$memberExpression($cf648f4ed1c07dbd$var$identifier(exportsObjectName), computed ? $cf648f4ed1c07dbd$var$stringLiteral(exportName) : $cf648f4ed1c07dbd$var$identifier(exportName), computed), expr);
    }, localExpr);
};
const $cf648f4ed1c07dbd$var$buildImportThrow = (localName)=>{
    return $7Ockm.template.expression.ast`
    (function() {
      throw new Error('"' + '${localName}' + '" is read-only.');
    })()
  `;
};
const $cf648f4ed1c07dbd$var$rewriteReferencesVisitor = {
    ReferencedIdentifier (path) {
        const { seen: seen, buildImportReference: buildImportReference, scope: scope, imported: imported, requeueInParent: requeueInParent } = this;
        if (seen.has(path.node)) return;
        seen.add(path.node);
        const localName = path.node.name;
        const importData = imported.get(localName);
        if (importData) {
            if ($cf648f4ed1c07dbd$var$isInType(path)) throw path.buildCodeFrameError(`Cannot transform the imported binding "${localName}" since it's also used in a type annotation. ` + `Please strip type annotations using @babel/preset-typescript or @babel/preset-flow.`);
            const localBinding = path.scope.getBinding(localName);
            const rootBinding = scope.getBinding(localName);
            if (rootBinding !== localBinding) return;
            const ref = buildImportReference(importData, path.node);
            ref.loc = path.node.loc;
            if ((path.parentPath.isCallExpression({
                callee: path.node
            }) || path.parentPath.isOptionalCallExpression({
                callee: path.node
            }) || path.parentPath.isTaggedTemplateExpression({
                tag: path.node
            })) && $cf648f4ed1c07dbd$var$isMemberExpression(ref)) path.replaceWith($cf648f4ed1c07dbd$var$sequenceExpression([
                $cf648f4ed1c07dbd$var$numericLiteral(0),
                ref
            ]));
            else if (path.isJSXIdentifier() && $cf648f4ed1c07dbd$var$isMemberExpression(ref)) {
                const { object: object, property: property } = ref;
                path.replaceWith($cf648f4ed1c07dbd$var$jsxMemberExpression($cf648f4ed1c07dbd$var$jsxIdentifier(object.name), $cf648f4ed1c07dbd$var$jsxIdentifier(property.name)));
            } else path.replaceWith(ref);
            requeueInParent(path);
            path.skip();
        }
    },
    UpdateExpression (path) {
        const { scope: scope, seen: seen, imported: imported, exported: exported, requeueInParent: requeueInParent, buildImportReference: buildImportReference } = this;
        if (seen.has(path.node)) return;
        seen.add(path.node);
        const arg = path.get("argument");
        if (arg.isMemberExpression()) return;
        const update = path.node;
        if (arg.isIdentifier()) {
            const localName = arg.node.name;
            if (scope.getBinding(localName) !== path.scope.getBinding(localName)) return;
            const exportedNames = exported.get(localName);
            const importData = imported.get(localName);
            if ((exportedNames == null ? void 0 : exportedNames.length) > 0 || importData) {
                if (importData) path.replaceWith($cf648f4ed1c07dbd$var$assignmentExpression(update.operator[0] + "=", buildImportReference(importData, arg.node), $cf648f4ed1c07dbd$var$buildImportThrow(localName)));
                else if (update.prefix) path.replaceWith($cf648f4ed1c07dbd$var$buildBindingExportAssignmentExpression(this.metadata, exportedNames, $cf648f4ed1c07dbd$var$cloneNode(update), path.scope));
                else {
                    const ref = scope.generateDeclaredUidIdentifier(localName);
                    path.replaceWith($cf648f4ed1c07dbd$var$sequenceExpression([
                        $cf648f4ed1c07dbd$var$assignmentExpression("=", $cf648f4ed1c07dbd$var$cloneNode(ref), $cf648f4ed1c07dbd$var$cloneNode(update)),
                        $cf648f4ed1c07dbd$var$buildBindingExportAssignmentExpression(this.metadata, exportedNames, $cf648f4ed1c07dbd$var$identifier(localName), path.scope),
                        $cf648f4ed1c07dbd$var$cloneNode(ref)
                    ]));
                }
            }
        }
        requeueInParent(path);
        path.skip();
    },
    AssignmentExpression: {
        exit (path) {
            const { scope: scope, seen: seen, imported: imported, exported: exported, requeueInParent: requeueInParent, buildImportReference: buildImportReference } = this;
            if (seen.has(path.node)) return;
            seen.add(path.node);
            const left = path.get("left");
            if (left.isMemberExpression()) return;
            if (left.isIdentifier()) {
                const localName = left.node.name;
                if (scope.getBinding(localName) !== path.scope.getBinding(localName)) return;
                const exportedNames = exported.get(localName);
                const importData = imported.get(localName);
                if ((exportedNames == null ? void 0 : exportedNames.length) > 0 || importData) {
                    $aLUwE(path.node.operator === "=", "Path was not simplified");
                    const assignment = path.node;
                    if (importData) {
                        assignment.left = buildImportReference(importData, left.node);
                        assignment.right = $cf648f4ed1c07dbd$var$sequenceExpression([
                            assignment.right,
                            $cf648f4ed1c07dbd$var$buildImportThrow(localName)
                        ]);
                    }
                    path.replaceWith($cf648f4ed1c07dbd$var$buildBindingExportAssignmentExpression(this.metadata, exportedNames, assignment, path.scope));
                    requeueInParent(path);
                }
            } else {
                const ids = left.getOuterBindingIdentifiers();
                const programScopeIds = Object.keys(ids).filter((localName)=>scope.getBinding(localName) === path.scope.getBinding(localName));
                const id = programScopeIds.find((localName)=>imported.has(localName));
                if (id) path.node.right = $cf648f4ed1c07dbd$var$sequenceExpression([
                    path.node.right,
                    $cf648f4ed1c07dbd$var$buildImportThrow(id)
                ]);
                const items = [];
                programScopeIds.forEach((localName)=>{
                    const exportedNames = exported.get(localName) || [];
                    if (exportedNames.length > 0) items.push($cf648f4ed1c07dbd$var$buildBindingExportAssignmentExpression(this.metadata, exportedNames, $cf648f4ed1c07dbd$var$identifier(localName), path.scope));
                });
                if (items.length > 0) {
                    let node = $cf648f4ed1c07dbd$var$sequenceExpression(items);
                    if (path.parentPath.isExpressionStatement()) {
                        node = $cf648f4ed1c07dbd$var$expressionStatement(node);
                        node._blockHoist = path.parentPath.node._blockHoist;
                    }
                    const statement = path.insertAfter(node)[0];
                    requeueInParent(statement);
                }
            }
        }
    },
    "ForOfStatement|ForInStatement" (path) {
        const { scope: scope, node: node } = path;
        const { left: left } = node;
        const { exported: exported, imported: imported, scope: programScope } = this;
        if (!$cf648f4ed1c07dbd$var$isVariableDeclaration(left)) {
            let didTransformExport = false, importConstViolationName;
            const loopBodyScope = path.get("body").scope;
            for (const name of Object.keys($cf648f4ed1c07dbd$var$getOuterBindingIdentifiers(left)))if (programScope.getBinding(name) === scope.getBinding(name)) {
                if (exported.has(name)) {
                    didTransformExport = true;
                    if (loopBodyScope.hasOwnBinding(name)) loopBodyScope.rename(name);
                }
                if (imported.has(name) && !importConstViolationName) importConstViolationName = name;
            }
            if (!didTransformExport && !importConstViolationName) return;
            path.ensureBlock();
            const bodyPath = path.get("body");
            const newLoopId = scope.generateUidIdentifierBasedOnNode(left);
            path.get("left").replaceWith($cf648f4ed1c07dbd$var$variableDeclaration("let", [
                $cf648f4ed1c07dbd$var$variableDeclarator($cf648f4ed1c07dbd$var$cloneNode(newLoopId))
            ]));
            scope.registerDeclaration(path.get("left"));
            if (didTransformExport) bodyPath.unshiftContainer("body", $cf648f4ed1c07dbd$var$expressionStatement($cf648f4ed1c07dbd$var$assignmentExpression("=", left, newLoopId)));
            if (importConstViolationName) bodyPath.unshiftContainer("body", $cf648f4ed1c07dbd$var$expressionStatement($cf648f4ed1c07dbd$var$buildImportThrow(importConstViolationName)));
        }
    }
};

});
parcelRegister("f4Xay", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $afa52088e8dd2a52$var$simplifyAccess;

var $ardUq = parcelRequire("ardUq");
const { LOGICAL_OPERATORS: $afa52088e8dd2a52$var$LOGICAL_OPERATORS, assignmentExpression: $afa52088e8dd2a52$var$assignmentExpression, binaryExpression: $afa52088e8dd2a52$var$binaryExpression, cloneNode: $afa52088e8dd2a52$var$cloneNode, identifier: $afa52088e8dd2a52$var$identifier, logicalExpression: $afa52088e8dd2a52$var$logicalExpression, numericLiteral: $afa52088e8dd2a52$var$numericLiteral, sequenceExpression: $afa52088e8dd2a52$var$sequenceExpression, unaryExpression: $afa52088e8dd2a52$var$unaryExpression } = $ardUq;
const $afa52088e8dd2a52$var$simpleAssignmentVisitor = {
    AssignmentExpression: {
        exit (path) {
            const { scope: scope, seen: seen, bindingNames: bindingNames } = this;
            if (path.node.operator === "=") return;
            if (seen.has(path.node)) return;
            seen.add(path.node);
            const left = path.get("left");
            if (!left.isIdentifier()) return;
            const localName = left.node.name;
            if (!bindingNames.has(localName)) return;
            if (scope.getBinding(localName) !== path.scope.getBinding(localName)) return;
            const operator = path.node.operator.slice(0, -1);
            if ($afa52088e8dd2a52$var$LOGICAL_OPERATORS.includes(operator)) path.replaceWith($afa52088e8dd2a52$var$logicalExpression(operator, path.node.left, $afa52088e8dd2a52$var$assignmentExpression("=", $afa52088e8dd2a52$var$cloneNode(path.node.left), path.node.right)));
            else {
                path.node.right = $afa52088e8dd2a52$var$binaryExpression(operator, $afa52088e8dd2a52$var$cloneNode(path.node.left), path.node.right);
                path.node.operator = "=";
            }
        }
    }
};
$afa52088e8dd2a52$var$simpleAssignmentVisitor.UpdateExpression = {
    exit (path) {
        if (!this.includeUpdateExpression) return;
        const { scope: scope, bindingNames: bindingNames } = this;
        const arg = path.get("argument");
        if (!arg.isIdentifier()) return;
        const localName = arg.node.name;
        if (!bindingNames.has(localName)) return;
        if (scope.getBinding(localName) !== path.scope.getBinding(localName)) return;
        if (path.parentPath.isExpressionStatement() && !path.isCompletionRecord()) {
            const operator = path.node.operator == "++" ? "+=" : "-=";
            path.replaceWith($afa52088e8dd2a52$var$assignmentExpression(operator, arg.node, $afa52088e8dd2a52$var$numericLiteral(1)));
        } else if (path.node.prefix) path.replaceWith($afa52088e8dd2a52$var$assignmentExpression("=", $afa52088e8dd2a52$var$identifier(localName), $afa52088e8dd2a52$var$binaryExpression(path.node.operator[0], $afa52088e8dd2a52$var$unaryExpression("+", arg.node), $afa52088e8dd2a52$var$numericLiteral(1))));
        else {
            const old = path.scope.generateUidIdentifierBasedOnNode(arg.node, "old");
            const varName = old.name;
            path.scope.push({
                id: old
            });
            const binary = $afa52088e8dd2a52$var$binaryExpression(path.node.operator[0], $afa52088e8dd2a52$var$identifier(varName), $afa52088e8dd2a52$var$numericLiteral(1));
            path.replaceWith($afa52088e8dd2a52$var$sequenceExpression([
                $afa52088e8dd2a52$var$assignmentExpression("=", $afa52088e8dd2a52$var$identifier(varName), $afa52088e8dd2a52$var$unaryExpression("+", arg.node)),
                $afa52088e8dd2a52$var$assignmentExpression("=", $afa52088e8dd2a52$var$cloneNode(arg.node), binary),
                $afa52088e8dd2a52$var$identifier(varName)
            ]));
        }
    }
};
function $afa52088e8dd2a52$var$simplifyAccess(path, bindingNames) {
    var _arguments$;
    path.traverse($afa52088e8dd2a52$var$simpleAssignmentVisitor, {
        scope: path.scope,
        bindingNames: bindingNames,
        seen: new WeakSet(),
        includeUpdateExpression: (_arguments$ = arguments[2]) != null ? _arguments$ : true
    });
}

});


parcelRegister("7DKf9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $59000be3c6fa3e00$var$normalizeModuleAndLoadMetadata;
module.exports.hasExports = $59000be3c6fa3e00$var$hasExports;
module.exports.isSideEffectImport = $59000be3c6fa3e00$var$isSideEffectImport;
module.exports.validateImportInteropOption = $59000be3c6fa3e00$var$validateImportInteropOption;

var $59kwG = parcelRequire("59kwG");

var $2Ghih = parcelRequire("2Ghih");

var $hBvI4 = parcelRequire("hBvI4");
function $59000be3c6fa3e00$var$hasExports(metadata) {
    return metadata.hasExports;
}
function $59000be3c6fa3e00$var$isSideEffectImport(source) {
    return source.imports.size === 0 && source.importsNamespace.size === 0 && source.reexports.size === 0 && source.reexportNamespace.size === 0 && !source.reexportAll;
}
function $59000be3c6fa3e00$var$validateImportInteropOption(importInterop) {
    if (typeof importInterop !== "function" && importInterop !== "none" && importInterop !== "babel" && importInterop !== "node") throw new Error(`.importInterop must be one of "none", "babel", "node", or a function returning one of those values (received ${importInterop}).`);
    return importInterop;
}
function $59000be3c6fa3e00$var$resolveImportInterop(importInterop, source, filename) {
    if (typeof importInterop === "function") return $59000be3c6fa3e00$var$validateImportInteropOption(importInterop(source, filename));
    return importInterop;
}
function $59000be3c6fa3e00$var$normalizeModuleAndLoadMetadata(programPath, exportName, { importInterop: importInterop, initializeReexports: initializeReexports = false, getWrapperPayload: getWrapperPayload, esNamespaceOnly: esNamespaceOnly = false, filename: filename }) {
    if (!exportName) exportName = programPath.scope.generateUidIdentifier("exports").name;
    const stringSpecifiers = new Set();
    $59000be3c6fa3e00$var$nameAnonymousExports(programPath);
    const { local: local, sources: sources, hasExports: hasExports } = $59000be3c6fa3e00$var$getModuleMetadata(programPath, {
        initializeReexports: initializeReexports,
        getWrapperPayload: getWrapperPayload
    }, stringSpecifiers);
    $59000be3c6fa3e00$var$removeImportExportDeclarations(programPath);
    for (const [source, metadata] of sources){
        const { importsNamespace: importsNamespace, imports: imports } = metadata;
        if (importsNamespace.size > 0 && imports.size === 0) {
            const [nameOfnamespace] = importsNamespace;
            metadata.name = nameOfnamespace;
        }
        const resolvedInterop = $59000be3c6fa3e00$var$resolveImportInterop(importInterop, source, filename);
        if (resolvedInterop === "none") metadata.interop = "none";
        else if (resolvedInterop === "node" && metadata.interop === "namespace") metadata.interop = "node-namespace";
        else if (resolvedInterop === "node" && metadata.interop === "default") metadata.interop = "node-default";
        else if (esNamespaceOnly && metadata.interop === "namespace") metadata.interop = "default";
    }
    return {
        exportName: exportName,
        exportNameListName: null,
        hasExports: hasExports,
        local: local,
        source: sources,
        stringSpecifiers: stringSpecifiers
    };
}
function $59000be3c6fa3e00$var$getExportSpecifierName(path, stringSpecifiers) {
    if (path.isIdentifier()) return path.node.name;
    else if (path.isStringLiteral()) {
        const stringValue = path.node.value;
        if (!(0, $2Ghih.isIdentifierName)(stringValue)) stringSpecifiers.add(stringValue);
        return stringValue;
    } else throw new Error(`Expected export specifier to be either Identifier or StringLiteral, got ${path.node.type}`);
}
function $59000be3c6fa3e00$var$assertExportSpecifier(path) {
    if (path.isExportSpecifier()) return;
    else if (path.isExportNamespaceSpecifier()) throw path.buildCodeFrameError("Export namespace should be first transformed by `@babel/plugin-transform-export-namespace-from`.");
    else throw path.buildCodeFrameError("Unexpected export specifier type");
}
function $59000be3c6fa3e00$var$getModuleMetadata(programPath, { getWrapperPayload: getWrapperPayload, initializeReexports: initializeReexports }, stringSpecifiers) {
    const localData = $59000be3c6fa3e00$var$getLocalExportMetadata(programPath, initializeReexports, stringSpecifiers);
    const importNodes = new Map();
    const sourceData = new Map();
    const getData = (sourceNode, node)=>{
        const source = sourceNode.value;
        let data = sourceData.get(source);
        if (!data) {
            data = {
                name: programPath.scope.generateUidIdentifier((0, $59kwG.basename)(source, (0, $59kwG.extname)(source))).name,
                interop: "none",
                loc: null,
                imports: new Map(),
                importsNamespace: new Set(),
                reexports: new Map(),
                reexportNamespace: new Set(),
                reexportAll: null,
                wrap: null,
                get lazy () {
                    return this.wrap === "lazy";
                },
                referenced: false
            };
            sourceData.set(source, data);
            importNodes.set(source, [
                node
            ]);
        } else importNodes.get(source).push(node);
        return data;
    };
    let hasExports = false;
    programPath.get("body").forEach((child)=>{
        if (child.isImportDeclaration()) {
            const data = getData(child.node.source, child.node);
            if (!data.loc) data.loc = child.node.loc;
            child.get("specifiers").forEach((spec)=>{
                if (spec.isImportDefaultSpecifier()) {
                    const localName = spec.get("local").node.name;
                    data.imports.set(localName, "default");
                    const reexport = localData.get(localName);
                    if (reexport) {
                        localData.delete(localName);
                        reexport.names.forEach((name)=>{
                            data.reexports.set(name, "default");
                        });
                        data.referenced = true;
                    }
                } else if (spec.isImportNamespaceSpecifier()) {
                    const localName = spec.get("local").node.name;
                    data.importsNamespace.add(localName);
                    const reexport = localData.get(localName);
                    if (reexport) {
                        localData.delete(localName);
                        reexport.names.forEach((name)=>{
                            data.reexportNamespace.add(name);
                        });
                        data.referenced = true;
                    }
                } else if (spec.isImportSpecifier()) {
                    const importName = $59000be3c6fa3e00$var$getExportSpecifierName(spec.get("imported"), stringSpecifiers);
                    const localName = spec.get("local").node.name;
                    data.imports.set(localName, importName);
                    const reexport = localData.get(localName);
                    if (reexport) {
                        localData.delete(localName);
                        reexport.names.forEach((name)=>{
                            data.reexports.set(name, importName);
                        });
                        data.referenced = true;
                    }
                }
            });
        } else if (child.isExportAllDeclaration()) {
            hasExports = true;
            const data = getData(child.node.source, child.node);
            if (!data.loc) data.loc = child.node.loc;
            data.reexportAll = {
                loc: child.node.loc
            };
            data.referenced = true;
        } else if (child.isExportNamedDeclaration() && child.node.source) {
            hasExports = true;
            const data = getData(child.node.source, child.node);
            if (!data.loc) data.loc = child.node.loc;
            child.get("specifiers").forEach((spec)=>{
                $59000be3c6fa3e00$var$assertExportSpecifier(spec);
                const importName = $59000be3c6fa3e00$var$getExportSpecifierName(spec.get("local"), stringSpecifiers);
                const exportName = $59000be3c6fa3e00$var$getExportSpecifierName(spec.get("exported"), stringSpecifiers);
                data.reexports.set(exportName, importName);
                data.referenced = true;
                if (exportName === "__esModule") throw spec.get("exported").buildCodeFrameError('Illegal export "__esModule".');
            });
        } else if (child.isExportNamedDeclaration() || child.isExportDefaultDeclaration()) hasExports = true;
    });
    for (const metadata of sourceData.values()){
        let needsDefault = false;
        let needsNamed = false;
        if (metadata.importsNamespace.size > 0) {
            needsDefault = true;
            needsNamed = true;
        }
        if (metadata.reexportAll) needsNamed = true;
        for (const importName of metadata.imports.values())if (importName === "default") needsDefault = true;
        else needsNamed = true;
        for (const importName of metadata.reexports.values())if (importName === "default") needsDefault = true;
        else needsNamed = true;
        if (needsDefault && needsNamed) metadata.interop = "namespace";
        else if (needsDefault) metadata.interop = "default";
    }
    if (getWrapperPayload) for (const [source, metadata] of sourceData)metadata.wrap = getWrapperPayload(source, metadata, importNodes.get(source));
    return {
        hasExports: hasExports,
        local: localData,
        sources: sourceData
    };
}
function $59000be3c6fa3e00$var$getLocalExportMetadata(programPath, initializeReexports, stringSpecifiers) {
    const bindingKindLookup = new Map();
    programPath.get("body").forEach((child)=>{
        let kind;
        if (child.isImportDeclaration()) kind = "import";
        else {
            if (child.isExportDefaultDeclaration()) child = child.get("declaration");
            if (child.isExportNamedDeclaration()) {
                if (child.node.declaration) child = child.get("declaration");
                else if (initializeReexports && child.node.source && child.get("source").isStringLiteral()) {
                    child.get("specifiers").forEach((spec)=>{
                        $59000be3c6fa3e00$var$assertExportSpecifier(spec);
                        bindingKindLookup.set(spec.get("local").node.name, "block");
                    });
                    return;
                }
            }
            if (child.isFunctionDeclaration()) kind = "hoisted";
            else if (child.isClassDeclaration()) kind = "block";
            else if (child.isVariableDeclaration({
                kind: "var"
            })) kind = "var";
            else if (child.isVariableDeclaration()) kind = "block";
            else return;
        }
        Object.keys(child.getOuterBindingIdentifiers()).forEach((name)=>{
            bindingKindLookup.set(name, kind);
        });
    });
    const localMetadata = new Map();
    const getLocalMetadata = (idPath)=>{
        const localName = idPath.node.name;
        let metadata = localMetadata.get(localName);
        if (!metadata) {
            const kind = bindingKindLookup.get(localName);
            if (kind === undefined) throw idPath.buildCodeFrameError(`Exporting local "${localName}", which is not declared.`);
            metadata = {
                names: [],
                kind: kind
            };
            localMetadata.set(localName, metadata);
        }
        return metadata;
    };
    programPath.get("body").forEach((child)=>{
        if (child.isExportNamedDeclaration() && (initializeReexports || !child.node.source)) {
            if (child.node.declaration) {
                const declaration = child.get("declaration");
                const ids = declaration.getOuterBindingIdentifierPaths();
                Object.keys(ids).forEach((name)=>{
                    if (name === "__esModule") throw declaration.buildCodeFrameError('Illegal export "__esModule".');
                    getLocalMetadata(ids[name]).names.push(name);
                });
            } else child.get("specifiers").forEach((spec)=>{
                const local = spec.get("local");
                const exported = spec.get("exported");
                const localMetadata = getLocalMetadata(local);
                const exportName = $59000be3c6fa3e00$var$getExportSpecifierName(exported, stringSpecifiers);
                if (exportName === "__esModule") throw exported.buildCodeFrameError('Illegal export "__esModule".');
                localMetadata.names.push(exportName);
            });
        } else if (child.isExportDefaultDeclaration()) {
            const declaration = child.get("declaration");
            if (declaration.isFunctionDeclaration() || declaration.isClassDeclaration()) getLocalMetadata(declaration.get("id")).names.push("default");
            else throw declaration.buildCodeFrameError("Unexpected default expression export.");
        }
    });
    return localMetadata;
}
function $59000be3c6fa3e00$var$nameAnonymousExports(programPath) {
    programPath.get("body").forEach((child)=>{
        if (!child.isExportDefaultDeclaration()) return;
        (0, $hBvI4.default)(child);
    });
}
function $59000be3c6fa3e00$var$removeImportExportDeclarations(programPath) {
    programPath.get("body").forEach((child)=>{
        if (child.isImportDeclaration()) child.remove();
        else if (child.isExportNamedDeclaration()) {
            if (child.node.declaration) {
                child.node.declaration._blockHoist = child.node._blockHoist;
                child.replaceWith(child.node.declaration);
            } else child.remove();
        } else if (child.isExportDefaultDeclaration()) {
            const declaration = child.get("declaration");
            if (declaration.isFunctionDeclaration() || declaration.isClassDeclaration()) {
                declaration._blockHoist = child.node._blockHoist;
                child.replaceWith(declaration);
            } else throw declaration.buildCodeFrameError("Unexpected default expression export.");
        } else if (child.isExportAllDeclaration()) child.remove();
    });
}

});

parcelRegister("d4P5f", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toGetWrapperPayload = $9853463e63d590a6$var$toGetWrapperPayload;
module.exports.wrapReference = $9853463e63d590a6$var$wrapReference;

var $7Ockm = parcelRequire("7Ockm");

var $7DKf9 = parcelRequire("7DKf9");
function $9853463e63d590a6$var$toGetWrapperPayload(lazy) {
    return (source, metadata)=>{
        if (lazy === false) return null;
        if ((0, $7DKf9.isSideEffectImport)(metadata) || metadata.reexportAll) return null;
        if (lazy === true) return /\./.test(source) ? null : "lazy";
        if (Array.isArray(lazy)) return lazy.indexOf(source) === -1 ? null : "lazy";
        if (typeof lazy === "function") return lazy(source) ? "lazy" : null;
        throw new Error(`.lazy must be a boolean, string array, or function`);
    };
}
function $9853463e63d590a6$var$wrapReference(ref, payload) {
    if (payload === "lazy") return $7Ockm.types.callExpression(ref, []);
    return null;
}

});

parcelRegister("fJot2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.buildDynamicImport = $b73e09aebd5b1e4d$var$buildDynamicImport;

var $7Ockm = parcelRequire("7Ockm");
module.exports.getDynamicImportSource = function getDynamicImportSource(node) {
    const [source] = node.arguments;
    return $7Ockm.types.isStringLiteral(source) || $7Ockm.types.isTemplateLiteral(source) ? source : $7Ockm.template.expression.ast`\`\${${source}}\``;
};
function $b73e09aebd5b1e4d$var$buildDynamicImport(node, deferToThen, wrapWithPromise, builder) {
    const specifier = $7Ockm.types.isCallExpression(node) ? node.arguments[0] : node.source;
    if ($7Ockm.types.isStringLiteral(specifier) || $7Ockm.types.isTemplateLiteral(specifier) && specifier.quasis.length === 0) {
        if (deferToThen) return $7Ockm.template.expression.ast`
        Promise.resolve().then(() => ${builder(specifier)})
      `;
        else return builder(specifier);
    }
    const specifierToString = $7Ockm.types.isTemplateLiteral(specifier) ? $7Ockm.types.identifier("specifier") : $7Ockm.types.templateLiteral([
        $7Ockm.types.templateElement({
            raw: ""
        }),
        $7Ockm.types.templateElement({
            raw: ""
        })
    ], [
        $7Ockm.types.identifier("specifier")
    ]);
    if (deferToThen) return $7Ockm.template.expression.ast`
      (specifier =>
        new Promise(r => r(${specifierToString}))
          .then(s => ${builder($7Ockm.types.identifier("s"))})
      )(${specifier})
    `;
    else if (wrapWithPromise) return $7Ockm.template.expression.ast`
      (specifier =>
        new Promise(r => r(${builder(specifierToString)}))
      )(${specifier})
    `;
    else return $7Ockm.template.expression.ast`
      (specifier => ${builder(specifierToString)})(${specifier})
    `;
}

});

parcelRegister("hEMlx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $cdabacb39a84e7fd$var$getModuleName;
{
    const originalGetModuleName = $cdabacb39a84e7fd$var$getModuleName;
    module.exports.default = $cdabacb39a84e7fd$var$getModuleName = function getModuleName(rootOpts, pluginOpts) {
        var _pluginOpts$moduleId, _pluginOpts$moduleIds, _pluginOpts$getModule, _pluginOpts$moduleRoo;
        return originalGetModuleName(rootOpts, {
            moduleId: (_pluginOpts$moduleId = pluginOpts.moduleId) != null ? _pluginOpts$moduleId : rootOpts.moduleId,
            moduleIds: (_pluginOpts$moduleIds = pluginOpts.moduleIds) != null ? _pluginOpts$moduleIds : rootOpts.moduleIds,
            getModuleId: (_pluginOpts$getModule = pluginOpts.getModuleId) != null ? _pluginOpts$getModule : rootOpts.getModuleId,
            moduleRoot: (_pluginOpts$moduleRoo = pluginOpts.moduleRoot) != null ? _pluginOpts$moduleRoo : rootOpts.moduleRoot
        });
    };
}function $cdabacb39a84e7fd$var$getModuleName(rootOpts, pluginOpts) {
    const { filename: filename, filenameRelative: filenameRelative = filename, sourceRoot: sourceRoot = pluginOpts.moduleRoot } = rootOpts;
    const { moduleId: moduleId, moduleIds: moduleIds = !!moduleId, getModuleId: getModuleId, moduleRoot: moduleRoot = sourceRoot } = pluginOpts;
    if (!moduleIds) return null;
    if (moduleId != null && !getModuleId) return moduleId;
    let moduleName = moduleRoot != null ? moduleRoot + "/" : "";
    if (filenameRelative) {
        const sourceRootReplacer = sourceRoot != null ? new RegExp("^" + sourceRoot + "/?") : "";
        moduleName += filenameRelative.replace(sourceRootReplacer, "").replace(/\.(\w*?)$/, "");
    }
    moduleName = moduleName.replace(/\\/g, "/");
    if (getModuleId) return getModuleId(moduleName) || moduleName;
    else return moduleName;
}

});


parcelRegister("sBxfj", function(module, exports) {

$parcel$export(module.exports, "renderToNodeStream", () => $055fbb5a82eb5281$export$307591e98609eddd, (v) => $055fbb5a82eb5281$export$307591e98609eddd = v);
$parcel$export(module.exports, "renderToStaticMarkup", () => $055fbb5a82eb5281$export$eb3a06aef9e6ee51, (v) => $055fbb5a82eb5281$export$eb3a06aef9e6ee51 = v);
$parcel$export(module.exports, "renderToStaticNodeStream", () => $055fbb5a82eb5281$export$b23711c915539651, (v) => $055fbb5a82eb5281$export$b23711c915539651 = v);
$parcel$export(module.exports, "renderToString", () => $055fbb5a82eb5281$export$80e7718417253a51, (v) => $055fbb5a82eb5281$export$80e7718417253a51 = v);
$parcel$export(module.exports, "version", () => $055fbb5a82eb5281$export$83d89fbfd8236492, (v) => $055fbb5a82eb5281$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom-server-legacy.browser.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $055fbb5a82eb5281$export$307591e98609eddd;
var $055fbb5a82eb5281$export$eb3a06aef9e6ee51;
var $055fbb5a82eb5281$export$b23711c915539651;
var $055fbb5a82eb5281$export$80e7718417253a51;
var $055fbb5a82eb5281$export$83d89fbfd8236492;
"use strict";

var $acw62 = parcelRequire("acw62");
function $055fbb5a82eb5281$var$l(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $055fbb5a82eb5281$var$p = Object.prototype.hasOwnProperty, $055fbb5a82eb5281$var$fa = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $055fbb5a82eb5281$var$ha = {}, $055fbb5a82eb5281$var$ia = {};
function $055fbb5a82eb5281$var$ja(a) {
    if ($055fbb5a82eb5281$var$p.call($055fbb5a82eb5281$var$ia, a)) return !0;
    if ($055fbb5a82eb5281$var$p.call($055fbb5a82eb5281$var$ha, a)) return !1;
    if ($055fbb5a82eb5281$var$fa.test(a)) return $055fbb5a82eb5281$var$ia[a] = !0;
    $055fbb5a82eb5281$var$ha[a] = !0;
    return !1;
}
function $055fbb5a82eb5281$var$r(a, b, c, d, f, e, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = f;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = e;
    this.removeEmptyString = g;
}
var $055fbb5a82eb5281$var$t = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $055fbb5a82eb5281$var$t[a] = new $055fbb5a82eb5281$var$r(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $055fbb5a82eb5281$var$t[b] = new $055fbb5a82eb5281$var$r(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $055fbb5a82eb5281$var$t[a] = new $055fbb5a82eb5281$var$r(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $055fbb5a82eb5281$var$t[a] = new $055fbb5a82eb5281$var$r(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $055fbb5a82eb5281$var$t[a] = new $055fbb5a82eb5281$var$r(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $055fbb5a82eb5281$var$t[a] = new $055fbb5a82eb5281$var$r(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $055fbb5a82eb5281$var$t[a] = new $055fbb5a82eb5281$var$r(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $055fbb5a82eb5281$var$t[a] = new $055fbb5a82eb5281$var$r(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $055fbb5a82eb5281$var$t[a] = new $055fbb5a82eb5281$var$r(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $055fbb5a82eb5281$var$ka = /[\-:]([a-z])/g;
function $055fbb5a82eb5281$var$la(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($055fbb5a82eb5281$var$ka, $055fbb5a82eb5281$var$la);
    $055fbb5a82eb5281$var$t[b] = new $055fbb5a82eb5281$var$r(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($055fbb5a82eb5281$var$ka, $055fbb5a82eb5281$var$la);
    $055fbb5a82eb5281$var$t[b] = new $055fbb5a82eb5281$var$r(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($055fbb5a82eb5281$var$ka, $055fbb5a82eb5281$var$la);
    $055fbb5a82eb5281$var$t[b] = new $055fbb5a82eb5281$var$r(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $055fbb5a82eb5281$var$t[a] = new $055fbb5a82eb5281$var$r(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$055fbb5a82eb5281$var$t.xlinkHref = new $055fbb5a82eb5281$var$r("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $055fbb5a82eb5281$var$t[a] = new $055fbb5a82eb5281$var$r(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
var $055fbb5a82eb5281$var$u = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $055fbb5a82eb5281$var$ma = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($055fbb5a82eb5281$var$u).forEach(function(a) {
    $055fbb5a82eb5281$var$ma.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $055fbb5a82eb5281$var$u[b] = $055fbb5a82eb5281$var$u[a];
    });
});
var $055fbb5a82eb5281$var$na = /["'&<>]/;
function $055fbb5a82eb5281$var$v(a) {
    if ("boolean" === typeof a || "number" === typeof a) return "" + a;
    a = "" + a;
    var b = $055fbb5a82eb5281$var$na.exec(a);
    if (b) {
        var c = "", d, f = 0;
        for(d = b.index; d < a.length; d++){
            switch(a.charCodeAt(d)){
                case 34:
                    b = "&quot;";
                    break;
                case 38:
                    b = "&amp;";
                    break;
                case 39:
                    b = "&#x27;";
                    break;
                case 60:
                    b = "&lt;";
                    break;
                case 62:
                    b = "&gt;";
                    break;
                default:
                    continue;
            }
            f !== d && (c += a.substring(f, d));
            f = d + 1;
            c += b;
        }
        a = f !== d ? c + a.substring(f, d) : c;
    }
    return a;
}
var $055fbb5a82eb5281$var$oa = /([A-Z])/g, $055fbb5a82eb5281$var$pa = /^ms-/, $055fbb5a82eb5281$var$qa = Array.isArray;
function $055fbb5a82eb5281$var$w(a, b) {
    return {
        insertionMode: a,
        selectedValue: b
    };
}
function $055fbb5a82eb5281$var$ra(a, b, c) {
    switch(b){
        case "select":
            return $055fbb5a82eb5281$var$w(1, null != c.value ? c.value : c.defaultValue);
        case "svg":
            return $055fbb5a82eb5281$var$w(2, null);
        case "math":
            return $055fbb5a82eb5281$var$w(3, null);
        case "foreignObject":
            return $055fbb5a82eb5281$var$w(1, null);
        case "table":
            return $055fbb5a82eb5281$var$w(4, null);
        case "thead":
        case "tbody":
        case "tfoot":
            return $055fbb5a82eb5281$var$w(5, null);
        case "colgroup":
            return $055fbb5a82eb5281$var$w(7, null);
        case "tr":
            return $055fbb5a82eb5281$var$w(6, null);
    }
    return 4 <= a.insertionMode || 0 === a.insertionMode ? $055fbb5a82eb5281$var$w(1, null) : a;
}
var $055fbb5a82eb5281$var$sa = new Map;
function $055fbb5a82eb5281$var$ta(a, b, c) {
    if ("object" !== typeof c) throw Error($055fbb5a82eb5281$var$l(62));
    b = !0;
    for(var d in c)if ($055fbb5a82eb5281$var$p.call(c, d)) {
        var f = c[d];
        if (null != f && "boolean" !== typeof f && "" !== f) {
            if (0 === d.indexOf("--")) {
                var e = $055fbb5a82eb5281$var$v(d);
                f = $055fbb5a82eb5281$var$v(("" + f).trim());
            } else {
                e = d;
                var g = $055fbb5a82eb5281$var$sa.get(e);
                void 0 !== g ? e = g : (g = $055fbb5a82eb5281$var$v(e.replace($055fbb5a82eb5281$var$oa, "-$1").toLowerCase().replace($055fbb5a82eb5281$var$pa, "-ms-")), $055fbb5a82eb5281$var$sa.set(e, g), e = g);
                f = "number" === typeof f ? 0 === f || $055fbb5a82eb5281$var$p.call($055fbb5a82eb5281$var$u, d) ? "" + f : f + "px" : $055fbb5a82eb5281$var$v(("" + f).trim());
            }
            b ? (b = !1, a.push(' style="', e, ":", f)) : a.push(";", e, ":", f);
        }
    }
    b || a.push('"');
}
function $055fbb5a82eb5281$var$x(a, b, c, d) {
    switch(c){
        case "style":
            $055fbb5a82eb5281$var$ta(a, b, d);
            return;
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
            return;
    }
    if (!(2 < c.length) || "o" !== c[0] && "O" !== c[0] || "n" !== c[1] && "N" !== c[1]) {
        if (b = $055fbb5a82eb5281$var$t.hasOwnProperty(c) ? $055fbb5a82eb5281$var$t[c] : null, null !== b) {
            switch(typeof d){
                case "function":
                case "symbol":
                    return;
                case "boolean":
                    if (!b.acceptsBooleans) return;
            }
            c = b.attributeName;
            switch(b.type){
                case 3:
                    d && a.push(" ", c, '=""');
                    break;
                case 4:
                    !0 === d ? a.push(" ", c, '=""') : !1 !== d && a.push(" ", c, '="', $055fbb5a82eb5281$var$v(d), '"');
                    break;
                case 5:
                    isNaN(d) || a.push(" ", c, '="', $055fbb5a82eb5281$var$v(d), '"');
                    break;
                case 6:
                    !isNaN(d) && 1 <= d && a.push(" ", c, '="', $055fbb5a82eb5281$var$v(d), '"');
                    break;
                default:
                    b.sanitizeURL && (d = "" + d), a.push(" ", c, '="', $055fbb5a82eb5281$var$v(d), '"');
            }
        } else if ($055fbb5a82eb5281$var$ja(c)) {
            switch(typeof d){
                case "function":
                case "symbol":
                    return;
                case "boolean":
                    if (b = c.toLowerCase().slice(0, 5), "data-" !== b && "aria-" !== b) return;
            }
            a.push(" ", c, '="', $055fbb5a82eb5281$var$v(d), '"');
        }
    }
}
function $055fbb5a82eb5281$var$y(a, b, c) {
    if (null != b) {
        if (null != c) throw Error($055fbb5a82eb5281$var$l(60));
        if ("object" !== typeof b || !("__html" in b)) throw Error($055fbb5a82eb5281$var$l(61));
        b = b.__html;
        null !== b && void 0 !== b && a.push("" + b);
    }
}
function $055fbb5a82eb5281$var$ua(a) {
    var b = "";
    $acw62.Children.forEach(a, function(a) {
        null != a && (b += a);
    });
    return b;
}
function $055fbb5a82eb5281$var$va(a, b, c, d) {
    a.push($055fbb5a82eb5281$var$A(c));
    var f = c = null, e;
    for(e in b)if ($055fbb5a82eb5281$var$p.call(b, e)) {
        var g = b[e];
        if (null != g) switch(e){
            case "children":
                c = g;
                break;
            case "dangerouslySetInnerHTML":
                f = g;
                break;
            default:
                $055fbb5a82eb5281$var$x(a, d, e, g);
        }
    }
    a.push(">");
    $055fbb5a82eb5281$var$y(a, f, c);
    return "string" === typeof c ? (a.push($055fbb5a82eb5281$var$v(c)), null) : c;
}
var $055fbb5a82eb5281$var$wa = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/, $055fbb5a82eb5281$var$xa = new Map;
function $055fbb5a82eb5281$var$A(a) {
    var b = $055fbb5a82eb5281$var$xa.get(a);
    if (void 0 === b) {
        if (!$055fbb5a82eb5281$var$wa.test(a)) throw Error($055fbb5a82eb5281$var$l(65, a));
        b = "<" + a;
        $055fbb5a82eb5281$var$xa.set(a, b);
    }
    return b;
}
function $055fbb5a82eb5281$var$ya(a, b, c, d, f) {
    switch(b){
        case "select":
            a.push($055fbb5a82eb5281$var$A("select"));
            var e = null, g = null;
            for(n in c)if ($055fbb5a82eb5281$var$p.call(c, n)) {
                var h = c[n];
                if (null != h) switch(n){
                    case "children":
                        e = h;
                        break;
                    case "dangerouslySetInnerHTML":
                        g = h;
                        break;
                    case "defaultValue":
                    case "value":
                        break;
                    default:
                        $055fbb5a82eb5281$var$x(a, d, n, h);
                }
            }
            a.push(">");
            $055fbb5a82eb5281$var$y(a, g, e);
            return e;
        case "option":
            g = f.selectedValue;
            a.push($055fbb5a82eb5281$var$A("option"));
            var k = h = null, m = null;
            var n = null;
            for(e in c)if ($055fbb5a82eb5281$var$p.call(c, e)) {
                var q = c[e];
                if (null != q) switch(e){
                    case "children":
                        h = q;
                        break;
                    case "selected":
                        m = q;
                        break;
                    case "dangerouslySetInnerHTML":
                        n = q;
                        break;
                    case "value":
                        k = q;
                    default:
                        $055fbb5a82eb5281$var$x(a, d, e, q);
                }
            }
            if (null != g) {
                if (c = null !== k ? "" + k : $055fbb5a82eb5281$var$ua(h), $055fbb5a82eb5281$var$qa(g)) {
                    for(d = 0; d < g.length; d++)if ("" + g[d] === c) {
                        a.push(' selected=""');
                        break;
                    }
                } else "" + g === c && a.push(' selected=""');
            } else m && a.push(' selected=""');
            a.push(">");
            $055fbb5a82eb5281$var$y(a, n, h);
            return h;
        case "textarea":
            a.push($055fbb5a82eb5281$var$A("textarea"));
            n = g = e = null;
            for(h in c)if ($055fbb5a82eb5281$var$p.call(c, h) && (k = c[h], null != k)) switch(h){
                case "children":
                    n = k;
                    break;
                case "value":
                    e = k;
                    break;
                case "defaultValue":
                    g = k;
                    break;
                case "dangerouslySetInnerHTML":
                    throw Error($055fbb5a82eb5281$var$l(91));
                default:
                    $055fbb5a82eb5281$var$x(a, d, h, k);
            }
            null === e && null !== g && (e = g);
            a.push(">");
            if (null != n) {
                if (null != e) throw Error($055fbb5a82eb5281$var$l(92));
                if ($055fbb5a82eb5281$var$qa(n) && 1 < n.length) throw Error($055fbb5a82eb5281$var$l(93));
                e = "" + n;
            }
            "string" === typeof e && "\n" === e[0] && a.push("\n");
            null !== e && a.push($055fbb5a82eb5281$var$v("" + e));
            return null;
        case "input":
            a.push($055fbb5a82eb5281$var$A("input"));
            k = n = h = e = null;
            for(g in c)if ($055fbb5a82eb5281$var$p.call(c, g) && (m = c[g], null != m)) switch(g){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($055fbb5a82eb5281$var$l(399, "input"));
                case "defaultChecked":
                    k = m;
                    break;
                case "defaultValue":
                    h = m;
                    break;
                case "checked":
                    n = m;
                    break;
                case "value":
                    e = m;
                    break;
                default:
                    $055fbb5a82eb5281$var$x(a, d, g, m);
            }
            null !== n ? $055fbb5a82eb5281$var$x(a, d, "checked", n) : null !== k && $055fbb5a82eb5281$var$x(a, d, "checked", k);
            null !== e ? $055fbb5a82eb5281$var$x(a, d, "value", e) : null !== h && $055fbb5a82eb5281$var$x(a, d, "value", h);
            a.push("/>");
            return null;
        case "menuitem":
            a.push($055fbb5a82eb5281$var$A("menuitem"));
            for(var C in c)if ($055fbb5a82eb5281$var$p.call(c, C) && (e = c[C], null != e)) switch(C){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($055fbb5a82eb5281$var$l(400));
                default:
                    $055fbb5a82eb5281$var$x(a, d, C, e);
            }
            a.push(">");
            return null;
        case "title":
            a.push($055fbb5a82eb5281$var$A("title"));
            e = null;
            for(q in c)if ($055fbb5a82eb5281$var$p.call(c, q) && (g = c[q], null != g)) switch(q){
                case "children":
                    e = g;
                    break;
                case "dangerouslySetInnerHTML":
                    throw Error($055fbb5a82eb5281$var$l(434));
                default:
                    $055fbb5a82eb5281$var$x(a, d, q, g);
            }
            a.push(">");
            return e;
        case "listing":
        case "pre":
            a.push($055fbb5a82eb5281$var$A(b));
            g = e = null;
            for(k in c)if ($055fbb5a82eb5281$var$p.call(c, k) && (h = c[k], null != h)) switch(k){
                case "children":
                    e = h;
                    break;
                case "dangerouslySetInnerHTML":
                    g = h;
                    break;
                default:
                    $055fbb5a82eb5281$var$x(a, d, k, h);
            }
            a.push(">");
            if (null != g) {
                if (null != e) throw Error($055fbb5a82eb5281$var$l(60));
                if ("object" !== typeof g || !("__html" in g)) throw Error($055fbb5a82eb5281$var$l(61));
                c = g.__html;
                null !== c && void 0 !== c && ("string" === typeof c && 0 < c.length && "\n" === c[0] ? a.push("\n", c) : a.push("" + c));
            }
            "string" === typeof e && "\n" === e[0] && a.push("\n");
            return e;
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "img":
        case "keygen":
        case "link":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
            a.push($055fbb5a82eb5281$var$A(b));
            for(var D in c)if ($055fbb5a82eb5281$var$p.call(c, D) && (e = c[D], null != e)) switch(D){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($055fbb5a82eb5281$var$l(399, b));
                default:
                    $055fbb5a82eb5281$var$x(a, d, D, e);
            }
            a.push("/>");
            return null;
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return $055fbb5a82eb5281$var$va(a, c, b, d);
        case "html":
            return 0 === f.insertionMode && a.push("<!DOCTYPE html>"), $055fbb5a82eb5281$var$va(a, c, b, d);
        default:
            if (-1 === b.indexOf("-") && "string" !== typeof c.is) return $055fbb5a82eb5281$var$va(a, c, b, d);
            a.push($055fbb5a82eb5281$var$A(b));
            g = e = null;
            for(m in c)if ($055fbb5a82eb5281$var$p.call(c, m) && (h = c[m], null != h)) switch(m){
                case "children":
                    e = h;
                    break;
                case "dangerouslySetInnerHTML":
                    g = h;
                    break;
                case "style":
                    $055fbb5a82eb5281$var$ta(a, d, h);
                    break;
                case "suppressContentEditableWarning":
                case "suppressHydrationWarning":
                    break;
                default:
                    $055fbb5a82eb5281$var$ja(m) && "function" !== typeof h && "symbol" !== typeof h && a.push(" ", m, '="', $055fbb5a82eb5281$var$v(h), '"');
            }
            a.push(">");
            $055fbb5a82eb5281$var$y(a, g, e);
            return e;
    }
}
function $055fbb5a82eb5281$var$za(a, b, c) {
    a.push('<!--$?--><template id="');
    if (null === c) throw Error($055fbb5a82eb5281$var$l(395));
    a.push(c);
    return a.push('"></template>');
}
function $055fbb5a82eb5281$var$Aa(a, b, c, d) {
    switch(c.insertionMode){
        case 0:
        case 1:
            return a.push('<div hidden id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        case 2:
            return a.push('<svg aria-hidden="true" style="display:none" id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        case 3:
            return a.push('<math aria-hidden="true" style="display:none" id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        case 4:
            return a.push('<table hidden id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        case 5:
            return a.push('<table hidden><tbody id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        case 6:
            return a.push('<table hidden><tr id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        case 7:
            return a.push('<table hidden><colgroup id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        default:
            throw Error($055fbb5a82eb5281$var$l(397));
    }
}
function $055fbb5a82eb5281$var$Ba(a, b) {
    switch(b.insertionMode){
        case 0:
        case 1:
            return a.push("</div>");
        case 2:
            return a.push("</svg>");
        case 3:
            return a.push("</math>");
        case 4:
            return a.push("</table>");
        case 5:
            return a.push("</tbody></table>");
        case 6:
            return a.push("</tr></table>");
        case 7:
            return a.push("</colgroup></table>");
        default:
            throw Error($055fbb5a82eb5281$var$l(397));
    }
}
var $055fbb5a82eb5281$var$Ca = /[<\u2028\u2029]/g;
function $055fbb5a82eb5281$var$Da(a) {
    return JSON.stringify(a).replace($055fbb5a82eb5281$var$Ca, function(a) {
        switch(a){
            case "<":
                return "\\u003c";
            case "\u2028":
                return "\\u2028";
            case "\u2029":
                return "\\u2029";
            default:
                throw Error("escapeJSStringsForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React");
        }
    });
}
function $055fbb5a82eb5281$var$Ea(a, b) {
    b = void 0 === b ? "" : b;
    return {
        bootstrapChunks: [],
        startInlineScript: "<script>",
        placeholderPrefix: b + "P:",
        segmentPrefix: b + "S:",
        boundaryPrefix: b + "B:",
        idPrefix: b,
        nextSuspenseID: 0,
        sentCompleteSegmentFunction: !1,
        sentCompleteBoundaryFunction: !1,
        sentClientRenderFunction: !1,
        generateStaticMarkup: a
    };
}
function $055fbb5a82eb5281$var$Fa(a, b, c, d) {
    if (c.generateStaticMarkup) return a.push($055fbb5a82eb5281$var$v(b)), !1;
    "" === b ? a = d : (d && a.push("<!-- -->"), a.push($055fbb5a82eb5281$var$v(b)), a = !0);
    return a;
}
var $055fbb5a82eb5281$var$B = Object.assign, $055fbb5a82eb5281$var$Ga = Symbol.for("react.element"), $055fbb5a82eb5281$var$Ha = Symbol.for("react.portal"), $055fbb5a82eb5281$var$Ia = Symbol.for("react.fragment"), $055fbb5a82eb5281$var$Ja = Symbol.for("react.strict_mode"), $055fbb5a82eb5281$var$Ka = Symbol.for("react.profiler"), $055fbb5a82eb5281$var$La = Symbol.for("react.provider"), $055fbb5a82eb5281$var$Ma = Symbol.for("react.context"), $055fbb5a82eb5281$var$Na = Symbol.for("react.forward_ref"), $055fbb5a82eb5281$var$Oa = Symbol.for("react.suspense"), $055fbb5a82eb5281$var$Pa = Symbol.for("react.suspense_list"), $055fbb5a82eb5281$var$Qa = Symbol.for("react.memo"), $055fbb5a82eb5281$var$Ra = Symbol.for("react.lazy"), $055fbb5a82eb5281$var$Sa = Symbol.for("react.scope"), $055fbb5a82eb5281$var$Ta = Symbol.for("react.debug_trace_mode"), $055fbb5a82eb5281$var$Ua = Symbol.for("react.legacy_hidden"), $055fbb5a82eb5281$var$Va = Symbol.for("react.default_value"), $055fbb5a82eb5281$var$Wa = Symbol.iterator;
function $055fbb5a82eb5281$var$Xa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $055fbb5a82eb5281$var$Ia:
            return "Fragment";
        case $055fbb5a82eb5281$var$Ha:
            return "Portal";
        case $055fbb5a82eb5281$var$Ka:
            return "Profiler";
        case $055fbb5a82eb5281$var$Ja:
            return "StrictMode";
        case $055fbb5a82eb5281$var$Oa:
            return "Suspense";
        case $055fbb5a82eb5281$var$Pa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $055fbb5a82eb5281$var$Ma:
            return (a.displayName || "Context") + ".Consumer";
        case $055fbb5a82eb5281$var$La:
            return (a._context.displayName || "Context") + ".Provider";
        case $055fbb5a82eb5281$var$Na:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $055fbb5a82eb5281$var$Qa:
            return b = a.displayName || null, null !== b ? b : $055fbb5a82eb5281$var$Xa(a.type) || "Memo";
        case $055fbb5a82eb5281$var$Ra:
            b = a._payload;
            a = a._init;
            try {
                return $055fbb5a82eb5281$var$Xa(a(b));
            } catch (c) {}
    }
    return null;
}
var $055fbb5a82eb5281$var$Ya = {};
function $055fbb5a82eb5281$var$Za(a, b) {
    a = a.contextTypes;
    if (!a) return $055fbb5a82eb5281$var$Ya;
    var c = {}, d;
    for(d in a)c[d] = b[d];
    return c;
}
var $055fbb5a82eb5281$var$E = null;
function $055fbb5a82eb5281$var$F(a, b) {
    if (a !== b) {
        a.context._currentValue2 = a.parentValue;
        a = a.parent;
        var c = b.parent;
        if (null === a) {
            if (null !== c) throw Error($055fbb5a82eb5281$var$l(401));
        } else {
            if (null === c) throw Error($055fbb5a82eb5281$var$l(401));
            $055fbb5a82eb5281$var$F(a, c);
        }
        b.context._currentValue2 = b.value;
    }
}
function $055fbb5a82eb5281$var$$a(a) {
    a.context._currentValue2 = a.parentValue;
    a = a.parent;
    null !== a && $055fbb5a82eb5281$var$$a(a);
}
function $055fbb5a82eb5281$var$ab(a) {
    var b = a.parent;
    null !== b && $055fbb5a82eb5281$var$ab(b);
    a.context._currentValue2 = a.value;
}
function $055fbb5a82eb5281$var$bb(a, b) {
    a.context._currentValue2 = a.parentValue;
    a = a.parent;
    if (null === a) throw Error($055fbb5a82eb5281$var$l(402));
    a.depth === b.depth ? $055fbb5a82eb5281$var$F(a, b) : $055fbb5a82eb5281$var$bb(a, b);
}
function $055fbb5a82eb5281$var$cb(a, b) {
    var c = b.parent;
    if (null === c) throw Error($055fbb5a82eb5281$var$l(402));
    a.depth === c.depth ? $055fbb5a82eb5281$var$F(a, c) : $055fbb5a82eb5281$var$cb(a, c);
    b.context._currentValue2 = b.value;
}
function $055fbb5a82eb5281$var$G(a) {
    var b = $055fbb5a82eb5281$var$E;
    b !== a && (null === b ? $055fbb5a82eb5281$var$ab(a) : null === a ? $055fbb5a82eb5281$var$$a(b) : b.depth === a.depth ? $055fbb5a82eb5281$var$F(b, a) : b.depth > a.depth ? $055fbb5a82eb5281$var$bb(b, a) : $055fbb5a82eb5281$var$cb(b, a), $055fbb5a82eb5281$var$E = a);
}
var $055fbb5a82eb5281$var$db = {
    isMounted: function() {
        return !1;
    },
    enqueueSetState: function(a, b) {
        a = a._reactInternals;
        null !== a.queue && a.queue.push(b);
    },
    enqueueReplaceState: function(a, b) {
        a = a._reactInternals;
        a.replace = !0;
        a.queue = [
            b
        ];
    },
    enqueueForceUpdate: function() {}
};
function $055fbb5a82eb5281$var$eb(a, b, c, d) {
    var f = void 0 !== a.state ? a.state : null;
    a.updater = $055fbb5a82eb5281$var$db;
    a.props = c;
    a.state = f;
    var e = {
        queue: [],
        replace: !1
    };
    a._reactInternals = e;
    var g = b.contextType;
    a.context = "object" === typeof g && null !== g ? g._currentValue2 : d;
    g = b.getDerivedStateFromProps;
    "function" === typeof g && (g = g(c, f), f = null === g || void 0 === g ? f : $055fbb5a82eb5281$var$B({}, f, g), a.state = f);
    if ("function" !== typeof b.getDerivedStateFromProps && "function" !== typeof a.getSnapshotBeforeUpdate && ("function" === typeof a.UNSAFE_componentWillMount || "function" === typeof a.componentWillMount)) {
        if (b = a.state, "function" === typeof a.componentWillMount && a.componentWillMount(), "function" === typeof a.UNSAFE_componentWillMount && a.UNSAFE_componentWillMount(), b !== a.state && $055fbb5a82eb5281$var$db.enqueueReplaceState(a, a.state, null), null !== e.queue && 0 < e.queue.length) {
            if (b = e.queue, g = e.replace, e.queue = null, e.replace = !1, g && 1 === b.length) a.state = b[0];
            else {
                e = g ? b[0] : a.state;
                f = !0;
                for(g = g ? 1 : 0; g < b.length; g++){
                    var h = b[g];
                    h = "function" === typeof h ? h.call(a, e, c, d) : h;
                    null != h && (f ? (f = !1, e = $055fbb5a82eb5281$var$B({}, e, h)) : $055fbb5a82eb5281$var$B(e, h));
                }
                a.state = e;
            }
        } else e.queue = null;
    }
}
var $055fbb5a82eb5281$var$fb = {
    id: 1,
    overflow: ""
};
function $055fbb5a82eb5281$var$gb(a, b, c) {
    var d = a.id;
    a = a.overflow;
    var f = 32 - $055fbb5a82eb5281$var$H(d) - 1;
    d &= ~(1 << f);
    c += 1;
    var e = 32 - $055fbb5a82eb5281$var$H(b) + f;
    if (30 < e) {
        var g = f - f % 5;
        e = (d & (1 << g) - 1).toString(32);
        d >>= g;
        f -= g;
        return {
            id: 1 << 32 - $055fbb5a82eb5281$var$H(b) + f | c << f | d,
            overflow: e + a
        };
    }
    return {
        id: 1 << e | c << f | d,
        overflow: a
    };
}
var $055fbb5a82eb5281$var$H = Math.clz32 ? Math.clz32 : $055fbb5a82eb5281$var$hb, $055fbb5a82eb5281$var$ib = Math.log, $055fbb5a82eb5281$var$jb = Math.LN2;
function $055fbb5a82eb5281$var$hb(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($055fbb5a82eb5281$var$ib(a) / $055fbb5a82eb5281$var$jb | 0) | 0;
}
function $055fbb5a82eb5281$var$kb(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $055fbb5a82eb5281$var$lb = "function" === typeof Object.is ? Object.is : $055fbb5a82eb5281$var$kb, $055fbb5a82eb5281$var$I = null, $055fbb5a82eb5281$var$ob = null, $055fbb5a82eb5281$var$J = null, $055fbb5a82eb5281$var$K = null, $055fbb5a82eb5281$var$L = !1, $055fbb5a82eb5281$var$M = !1, $055fbb5a82eb5281$var$N = 0, $055fbb5a82eb5281$var$O = null, $055fbb5a82eb5281$var$P = 0;
function $055fbb5a82eb5281$var$Q() {
    if (null === $055fbb5a82eb5281$var$I) throw Error($055fbb5a82eb5281$var$l(321));
    return $055fbb5a82eb5281$var$I;
}
function $055fbb5a82eb5281$var$pb() {
    if (0 < $055fbb5a82eb5281$var$P) throw Error($055fbb5a82eb5281$var$l(312));
    return {
        memoizedState: null,
        queue: null,
        next: null
    };
}
function $055fbb5a82eb5281$var$qb() {
    null === $055fbb5a82eb5281$var$K ? null === $055fbb5a82eb5281$var$J ? ($055fbb5a82eb5281$var$L = !1, $055fbb5a82eb5281$var$J = $055fbb5a82eb5281$var$K = $055fbb5a82eb5281$var$pb()) : ($055fbb5a82eb5281$var$L = !0, $055fbb5a82eb5281$var$K = $055fbb5a82eb5281$var$J) : null === $055fbb5a82eb5281$var$K.next ? ($055fbb5a82eb5281$var$L = !1, $055fbb5a82eb5281$var$K = $055fbb5a82eb5281$var$K.next = $055fbb5a82eb5281$var$pb()) : ($055fbb5a82eb5281$var$L = !0, $055fbb5a82eb5281$var$K = $055fbb5a82eb5281$var$K.next);
    return $055fbb5a82eb5281$var$K;
}
function $055fbb5a82eb5281$var$rb() {
    $055fbb5a82eb5281$var$ob = $055fbb5a82eb5281$var$I = null;
    $055fbb5a82eb5281$var$M = !1;
    $055fbb5a82eb5281$var$J = null;
    $055fbb5a82eb5281$var$P = 0;
    $055fbb5a82eb5281$var$K = $055fbb5a82eb5281$var$O = null;
}
function $055fbb5a82eb5281$var$sb(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $055fbb5a82eb5281$var$tb(a, b, c) {
    $055fbb5a82eb5281$var$I = $055fbb5a82eb5281$var$Q();
    $055fbb5a82eb5281$var$K = $055fbb5a82eb5281$var$qb();
    if ($055fbb5a82eb5281$var$L) {
        var d = $055fbb5a82eb5281$var$K.queue;
        b = d.dispatch;
        if (null !== $055fbb5a82eb5281$var$O && (c = $055fbb5a82eb5281$var$O.get(d), void 0 !== c)) {
            $055fbb5a82eb5281$var$O.delete(d);
            d = $055fbb5a82eb5281$var$K.memoizedState;
            do d = a(d, c.action), c = c.next;
            while (null !== c);
            $055fbb5a82eb5281$var$K.memoizedState = d;
            return [
                d,
                b
            ];
        }
        return [
            $055fbb5a82eb5281$var$K.memoizedState,
            b
        ];
    }
    a = a === $055fbb5a82eb5281$var$sb ? "function" === typeof b ? b() : b : void 0 !== c ? c(b) : b;
    $055fbb5a82eb5281$var$K.memoizedState = a;
    a = $055fbb5a82eb5281$var$K.queue = {
        last: null,
        dispatch: null
    };
    a = a.dispatch = $055fbb5a82eb5281$var$ub.bind(null, $055fbb5a82eb5281$var$I, a);
    return [
        $055fbb5a82eb5281$var$K.memoizedState,
        a
    ];
}
function $055fbb5a82eb5281$var$vb(a, b) {
    $055fbb5a82eb5281$var$I = $055fbb5a82eb5281$var$Q();
    $055fbb5a82eb5281$var$K = $055fbb5a82eb5281$var$qb();
    b = void 0 === b ? null : b;
    if (null !== $055fbb5a82eb5281$var$K) {
        var c = $055fbb5a82eb5281$var$K.memoizedState;
        if (null !== c && null !== b) {
            var d = c[1];
            a: if (null === d) d = !1;
            else {
                for(var f = 0; f < d.length && f < b.length; f++)if (!$055fbb5a82eb5281$var$lb(b[f], d[f])) {
                    d = !1;
                    break a;
                }
                d = !0;
            }
            if (d) return c[0];
        }
    }
    a = a();
    $055fbb5a82eb5281$var$K.memoizedState = [
        a,
        b
    ];
    return a;
}
function $055fbb5a82eb5281$var$ub(a, b, c) {
    if (25 <= $055fbb5a82eb5281$var$P) throw Error($055fbb5a82eb5281$var$l(301));
    if (a === $055fbb5a82eb5281$var$I) {
        if ($055fbb5a82eb5281$var$M = !0, a = {
            action: c,
            next: null
        }, null === $055fbb5a82eb5281$var$O && ($055fbb5a82eb5281$var$O = new Map), c = $055fbb5a82eb5281$var$O.get(b), void 0 === c) $055fbb5a82eb5281$var$O.set(b, a);
        else {
            for(b = c; null !== b.next;)b = b.next;
            b.next = a;
        }
    }
}
function $055fbb5a82eb5281$var$wb() {
    throw Error($055fbb5a82eb5281$var$l(394));
}
function $055fbb5a82eb5281$var$R() {}
var $055fbb5a82eb5281$var$xb = {
    readContext: function(a) {
        return a._currentValue2;
    },
    useContext: function(a) {
        $055fbb5a82eb5281$var$Q();
        return a._currentValue2;
    },
    useMemo: $055fbb5a82eb5281$var$vb,
    useReducer: $055fbb5a82eb5281$var$tb,
    useRef: function(a) {
        $055fbb5a82eb5281$var$I = $055fbb5a82eb5281$var$Q();
        $055fbb5a82eb5281$var$K = $055fbb5a82eb5281$var$qb();
        var b = $055fbb5a82eb5281$var$K.memoizedState;
        return null === b ? (a = {
            current: a
        }, $055fbb5a82eb5281$var$K.memoizedState = a) : b;
    },
    useState: function(a) {
        return $055fbb5a82eb5281$var$tb($055fbb5a82eb5281$var$sb, a);
    },
    useInsertionEffect: $055fbb5a82eb5281$var$R,
    useLayoutEffect: function() {},
    useCallback: function(a, b) {
        return $055fbb5a82eb5281$var$vb(function() {
            return a;
        }, b);
    },
    useImperativeHandle: $055fbb5a82eb5281$var$R,
    useEffect: $055fbb5a82eb5281$var$R,
    useDebugValue: $055fbb5a82eb5281$var$R,
    useDeferredValue: function(a) {
        $055fbb5a82eb5281$var$Q();
        return a;
    },
    useTransition: function() {
        $055fbb5a82eb5281$var$Q();
        return [
            !1,
            $055fbb5a82eb5281$var$wb
        ];
    },
    useId: function() {
        var a = $055fbb5a82eb5281$var$ob.treeContext;
        var b = a.overflow;
        a = a.id;
        a = (a & ~(1 << 32 - $055fbb5a82eb5281$var$H(a) - 1)).toString(32) + b;
        var c = $055fbb5a82eb5281$var$S;
        if (null === c) throw Error($055fbb5a82eb5281$var$l(404));
        b = $055fbb5a82eb5281$var$N++;
        a = ":" + c.idPrefix + "R" + a;
        0 < b && (a += "H" + b.toString(32));
        return a + ":";
    },
    useMutableSource: function(a, b) {
        $055fbb5a82eb5281$var$Q();
        return b(a._source);
    },
    useSyncExternalStore: function(a, b, c) {
        if (void 0 === c) throw Error($055fbb5a82eb5281$var$l(407));
        return c();
    }
}, $055fbb5a82eb5281$var$S = null, $055fbb5a82eb5281$var$yb = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentDispatcher;
function $055fbb5a82eb5281$var$zb(a) {
    console.error(a);
    return null;
}
function $055fbb5a82eb5281$var$T() {}
function $055fbb5a82eb5281$var$Ab(a, b, c, d, f, e, g, h, k) {
    var m = [], n = new Set;
    b = {
        destination: null,
        responseState: b,
        progressiveChunkSize: void 0 === d ? 12800 : d,
        status: 0,
        fatalError: null,
        nextSegmentId: 0,
        allPendingTasks: 0,
        pendingRootTasks: 0,
        completedRootSegment: null,
        abortableTasks: n,
        pingedTasks: m,
        clientRenderedBoundaries: [],
        completedBoundaries: [],
        partialBoundaries: [],
        onError: void 0 === f ? $055fbb5a82eb5281$var$zb : f,
        onAllReady: void 0 === e ? $055fbb5a82eb5281$var$T : e,
        onShellReady: void 0 === g ? $055fbb5a82eb5281$var$T : g,
        onShellError: void 0 === h ? $055fbb5a82eb5281$var$T : h,
        onFatalError: void 0 === k ? $055fbb5a82eb5281$var$T : k
    };
    c = $055fbb5a82eb5281$var$U(b, 0, null, c, !1, !1);
    c.parentFlushed = !0;
    a = $055fbb5a82eb5281$var$Bb(b, a, null, c, n, $055fbb5a82eb5281$var$Ya, null, $055fbb5a82eb5281$var$fb);
    m.push(a);
    return b;
}
function $055fbb5a82eb5281$var$Bb(a, b, c, d, f, e, g, h) {
    a.allPendingTasks++;
    null === c ? a.pendingRootTasks++ : c.pendingTasks++;
    var k = {
        node: b,
        ping: function() {
            var b = a.pingedTasks;
            b.push(k);
            1 === b.length && $055fbb5a82eb5281$var$Cb(a);
        },
        blockedBoundary: c,
        blockedSegment: d,
        abortSet: f,
        legacyContext: e,
        context: g,
        treeContext: h
    };
    f.add(k);
    return k;
}
function $055fbb5a82eb5281$var$U(a, b, c, d, f, e) {
    return {
        status: 0,
        id: -1,
        index: b,
        parentFlushed: !1,
        chunks: [],
        children: [],
        formatContext: d,
        boundary: c,
        lastPushedText: f,
        textEmbedded: e
    };
}
function $055fbb5a82eb5281$var$V(a, b) {
    a = a.onError(b);
    if (null != a && "string" !== typeof a) throw Error('onError returned something with a type other than "string". onError should return a string and may return null or undefined but must not return anything else. It received something of type "' + typeof a + '" instead');
    return a;
}
function $055fbb5a82eb5281$var$W(a, b) {
    var c = a.onShellError;
    c(b);
    c = a.onFatalError;
    c(b);
    null !== a.destination ? (a.status = 2, a.destination.destroy(b)) : (a.status = 1, a.fatalError = b);
}
function $055fbb5a82eb5281$var$Db(a, b, c, d, f) {
    $055fbb5a82eb5281$var$I = {};
    $055fbb5a82eb5281$var$ob = b;
    $055fbb5a82eb5281$var$N = 0;
    for(a = c(d, f); $055fbb5a82eb5281$var$M;)$055fbb5a82eb5281$var$M = !1, $055fbb5a82eb5281$var$N = 0, $055fbb5a82eb5281$var$P += 1, $055fbb5a82eb5281$var$K = null, a = c(d, f);
    $055fbb5a82eb5281$var$rb();
    return a;
}
function $055fbb5a82eb5281$var$Eb(a, b, c, d) {
    var f = c.render(), e = d.childContextTypes;
    if (null !== e && void 0 !== e) {
        var g = b.legacyContext;
        if ("function" !== typeof c.getChildContext) d = g;
        else {
            c = c.getChildContext();
            for(var h in c)if (!(h in e)) throw Error($055fbb5a82eb5281$var$l(108, $055fbb5a82eb5281$var$Xa(d) || "Unknown", h));
            d = $055fbb5a82eb5281$var$B({}, g, c);
        }
        b.legacyContext = d;
        $055fbb5a82eb5281$var$X(a, b, f);
        b.legacyContext = g;
    } else $055fbb5a82eb5281$var$X(a, b, f);
}
function $055fbb5a82eb5281$var$Fb(a, b) {
    if (a && a.defaultProps) {
        b = $055fbb5a82eb5281$var$B({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $055fbb5a82eb5281$var$Gb(a, b, c, d, f) {
    if ("function" === typeof c) {
        if (c.prototype && c.prototype.isReactComponent) {
            f = $055fbb5a82eb5281$var$Za(c, b.legacyContext);
            var e = c.contextType;
            e = new c(d, "object" === typeof e && null !== e ? e._currentValue2 : f);
            $055fbb5a82eb5281$var$eb(e, c, d, f);
            $055fbb5a82eb5281$var$Eb(a, b, e, c);
        } else {
            e = $055fbb5a82eb5281$var$Za(c, b.legacyContext);
            f = $055fbb5a82eb5281$var$Db(a, b, c, d, e);
            var g = 0 !== $055fbb5a82eb5281$var$N;
            if ("object" === typeof f && null !== f && "function" === typeof f.render && void 0 === f.$$typeof) $055fbb5a82eb5281$var$eb(f, c, d, e), $055fbb5a82eb5281$var$Eb(a, b, f, c);
            else if (g) {
                d = b.treeContext;
                b.treeContext = $055fbb5a82eb5281$var$gb(d, 1, 0);
                try {
                    $055fbb5a82eb5281$var$X(a, b, f);
                } finally{
                    b.treeContext = d;
                }
            } else $055fbb5a82eb5281$var$X(a, b, f);
        }
    } else if ("string" === typeof c) {
        f = b.blockedSegment;
        e = $055fbb5a82eb5281$var$ya(f.chunks, c, d, a.responseState, f.formatContext);
        f.lastPushedText = !1;
        g = f.formatContext;
        f.formatContext = $055fbb5a82eb5281$var$ra(g, c, d);
        $055fbb5a82eb5281$var$Hb(a, b, e);
        f.formatContext = g;
        switch(c){
            case "area":
            case "base":
            case "br":
            case "col":
            case "embed":
            case "hr":
            case "img":
            case "input":
            case "keygen":
            case "link":
            case "meta":
            case "param":
            case "source":
            case "track":
            case "wbr":
                break;
            default:
                f.chunks.push("</", c, ">");
        }
        f.lastPushedText = !1;
    } else {
        switch(c){
            case $055fbb5a82eb5281$var$Ua:
            case $055fbb5a82eb5281$var$Ta:
            case $055fbb5a82eb5281$var$Ja:
            case $055fbb5a82eb5281$var$Ka:
            case $055fbb5a82eb5281$var$Ia:
                $055fbb5a82eb5281$var$X(a, b, d.children);
                return;
            case $055fbb5a82eb5281$var$Pa:
                $055fbb5a82eb5281$var$X(a, b, d.children);
                return;
            case $055fbb5a82eb5281$var$Sa:
                throw Error($055fbb5a82eb5281$var$l(343));
            case $055fbb5a82eb5281$var$Oa:
                a: {
                    c = b.blockedBoundary;
                    f = b.blockedSegment;
                    e = d.fallback;
                    d = d.children;
                    g = new Set;
                    var h = {
                        id: null,
                        rootSegmentID: -1,
                        parentFlushed: !1,
                        pendingTasks: 0,
                        forceClientRender: !1,
                        completedSegments: [],
                        byteSize: 0,
                        fallbackAbortableTasks: g,
                        errorDigest: null
                    }, k = $055fbb5a82eb5281$var$U(a, f.chunks.length, h, f.formatContext, !1, !1);
                    f.children.push(k);
                    f.lastPushedText = !1;
                    var m = $055fbb5a82eb5281$var$U(a, 0, null, f.formatContext, !1, !1);
                    m.parentFlushed = !0;
                    b.blockedBoundary = h;
                    b.blockedSegment = m;
                    try {
                        if ($055fbb5a82eb5281$var$Hb(a, b, d), a.responseState.generateStaticMarkup || m.lastPushedText && m.textEmbedded && m.chunks.push("<!-- -->"), m.status = 1, $055fbb5a82eb5281$var$Y(h, m), 0 === h.pendingTasks) break a;
                    } catch (n) {
                        m.status = 4, h.forceClientRender = !0, h.errorDigest = $055fbb5a82eb5281$var$V(a, n);
                    } finally{
                        b.blockedBoundary = c, b.blockedSegment = f;
                    }
                    b = $055fbb5a82eb5281$var$Bb(a, e, c, k, g, b.legacyContext, b.context, b.treeContext);
                    a.pingedTasks.push(b);
                }
                return;
        }
        if ("object" === typeof c && null !== c) switch(c.$$typeof){
            case $055fbb5a82eb5281$var$Na:
                d = $055fbb5a82eb5281$var$Db(a, b, c.render, d, f);
                if (0 !== $055fbb5a82eb5281$var$N) {
                    c = b.treeContext;
                    b.treeContext = $055fbb5a82eb5281$var$gb(c, 1, 0);
                    try {
                        $055fbb5a82eb5281$var$X(a, b, d);
                    } finally{
                        b.treeContext = c;
                    }
                } else $055fbb5a82eb5281$var$X(a, b, d);
                return;
            case $055fbb5a82eb5281$var$Qa:
                c = c.type;
                d = $055fbb5a82eb5281$var$Fb(c, d);
                $055fbb5a82eb5281$var$Gb(a, b, c, d, f);
                return;
            case $055fbb5a82eb5281$var$La:
                f = d.children;
                c = c._context;
                d = d.value;
                e = c._currentValue2;
                c._currentValue2 = d;
                g = $055fbb5a82eb5281$var$E;
                $055fbb5a82eb5281$var$E = d = {
                    parent: g,
                    depth: null === g ? 0 : g.depth + 1,
                    context: c,
                    parentValue: e,
                    value: d
                };
                b.context = d;
                $055fbb5a82eb5281$var$X(a, b, f);
                a = $055fbb5a82eb5281$var$E;
                if (null === a) throw Error($055fbb5a82eb5281$var$l(403));
                d = a.parentValue;
                a.context._currentValue2 = d === $055fbb5a82eb5281$var$Va ? a.context._defaultValue : d;
                a = $055fbb5a82eb5281$var$E = a.parent;
                b.context = a;
                return;
            case $055fbb5a82eb5281$var$Ma:
                d = d.children;
                d = d(c._currentValue2);
                $055fbb5a82eb5281$var$X(a, b, d);
                return;
            case $055fbb5a82eb5281$var$Ra:
                f = c._init;
                c = f(c._payload);
                d = $055fbb5a82eb5281$var$Fb(c, d);
                $055fbb5a82eb5281$var$Gb(a, b, c, d, void 0);
                return;
        }
        throw Error($055fbb5a82eb5281$var$l(130, null == c ? c : typeof c, ""));
    }
}
function $055fbb5a82eb5281$var$X(a, b, c) {
    b.node = c;
    if ("object" === typeof c && null !== c) {
        switch(c.$$typeof){
            case $055fbb5a82eb5281$var$Ga:
                $055fbb5a82eb5281$var$Gb(a, b, c.type, c.props, c.ref);
                return;
            case $055fbb5a82eb5281$var$Ha:
                throw Error($055fbb5a82eb5281$var$l(257));
            case $055fbb5a82eb5281$var$Ra:
                var d = c._init;
                c = d(c._payload);
                $055fbb5a82eb5281$var$X(a, b, c);
                return;
        }
        if ($055fbb5a82eb5281$var$qa(c)) {
            $055fbb5a82eb5281$var$Ib(a, b, c);
            return;
        }
        null === c || "object" !== typeof c ? d = null : (d = $055fbb5a82eb5281$var$Wa && c[$055fbb5a82eb5281$var$Wa] || c["@@iterator"], d = "function" === typeof d ? d : null);
        if (d && (d = d.call(c))) {
            c = d.next();
            if (!c.done) {
                var f = [];
                do f.push(c.value), c = d.next();
                while (!c.done);
                $055fbb5a82eb5281$var$Ib(a, b, f);
            }
            return;
        }
        a = Object.prototype.toString.call(c);
        throw Error($055fbb5a82eb5281$var$l(31, "[object Object]" === a ? "object with keys {" + Object.keys(c).join(", ") + "}" : a));
    }
    "string" === typeof c ? (d = b.blockedSegment, d.lastPushedText = $055fbb5a82eb5281$var$Fa(b.blockedSegment.chunks, c, a.responseState, d.lastPushedText)) : "number" === typeof c && (d = b.blockedSegment, d.lastPushedText = $055fbb5a82eb5281$var$Fa(b.blockedSegment.chunks, "" + c, a.responseState, d.lastPushedText));
}
function $055fbb5a82eb5281$var$Ib(a, b, c) {
    for(var d = c.length, f = 0; f < d; f++){
        var e = b.treeContext;
        b.treeContext = $055fbb5a82eb5281$var$gb(e, d, f);
        try {
            $055fbb5a82eb5281$var$Hb(a, b, c[f]);
        } finally{
            b.treeContext = e;
        }
    }
}
function $055fbb5a82eb5281$var$Hb(a, b, c) {
    var d = b.blockedSegment.formatContext, f = b.legacyContext, e = b.context;
    try {
        return $055fbb5a82eb5281$var$X(a, b, c);
    } catch (k) {
        if ($055fbb5a82eb5281$var$rb(), "object" === typeof k && null !== k && "function" === typeof k.then) {
            c = k;
            var g = b.blockedSegment, h = $055fbb5a82eb5281$var$U(a, g.chunks.length, null, g.formatContext, g.lastPushedText, !0);
            g.children.push(h);
            g.lastPushedText = !1;
            a = $055fbb5a82eb5281$var$Bb(a, b.node, b.blockedBoundary, h, b.abortSet, b.legacyContext, b.context, b.treeContext).ping;
            c.then(a, a);
            b.blockedSegment.formatContext = d;
            b.legacyContext = f;
            b.context = e;
            $055fbb5a82eb5281$var$G(e);
        } else throw b.blockedSegment.formatContext = d, b.legacyContext = f, b.context = e, $055fbb5a82eb5281$var$G(e), k;
    }
}
function $055fbb5a82eb5281$var$Jb(a) {
    var b = a.blockedBoundary;
    a = a.blockedSegment;
    a.status = 3;
    $055fbb5a82eb5281$var$Kb(this, b, a);
}
function $055fbb5a82eb5281$var$Lb(a, b, c) {
    var d = a.blockedBoundary;
    a.blockedSegment.status = 3;
    null === d ? (b.allPendingTasks--, 2 !== b.status && (b.status = 2, null !== b.destination && b.destination.push(null))) : (d.pendingTasks--, d.forceClientRender || (d.forceClientRender = !0, a = void 0 === c ? Error($055fbb5a82eb5281$var$l(432)) : c, d.errorDigest = b.onError(a), d.parentFlushed && b.clientRenderedBoundaries.push(d)), d.fallbackAbortableTasks.forEach(function(a) {
        return $055fbb5a82eb5281$var$Lb(a, b, c);
    }), d.fallbackAbortableTasks.clear(), b.allPendingTasks--, 0 === b.allPendingTasks && (d = b.onAllReady, d()));
}
function $055fbb5a82eb5281$var$Y(a, b) {
    if (0 === b.chunks.length && 1 === b.children.length && null === b.children[0].boundary) {
        var c = b.children[0];
        c.id = b.id;
        c.parentFlushed = !0;
        1 === c.status && $055fbb5a82eb5281$var$Y(a, c);
    } else a.completedSegments.push(b);
}
function $055fbb5a82eb5281$var$Kb(a, b, c) {
    if (null === b) {
        if (c.parentFlushed) {
            if (null !== a.completedRootSegment) throw Error($055fbb5a82eb5281$var$l(389));
            a.completedRootSegment = c;
        }
        a.pendingRootTasks--;
        0 === a.pendingRootTasks && (a.onShellError = $055fbb5a82eb5281$var$T, b = a.onShellReady, b());
    } else b.pendingTasks--, b.forceClientRender || (0 === b.pendingTasks ? (c.parentFlushed && 1 === c.status && $055fbb5a82eb5281$var$Y(b, c), b.parentFlushed && a.completedBoundaries.push(b), b.fallbackAbortableTasks.forEach($055fbb5a82eb5281$var$Jb, a), b.fallbackAbortableTasks.clear()) : c.parentFlushed && 1 === c.status && ($055fbb5a82eb5281$var$Y(b, c), 1 === b.completedSegments.length && b.parentFlushed && a.partialBoundaries.push(b)));
    a.allPendingTasks--;
    0 === a.allPendingTasks && (a = a.onAllReady, a());
}
function $055fbb5a82eb5281$var$Cb(a) {
    if (2 !== a.status) {
        var b = $055fbb5a82eb5281$var$E, c = $055fbb5a82eb5281$var$yb.current;
        $055fbb5a82eb5281$var$yb.current = $055fbb5a82eb5281$var$xb;
        var d = $055fbb5a82eb5281$var$S;
        $055fbb5a82eb5281$var$S = a.responseState;
        try {
            var f = a.pingedTasks, e;
            for(e = 0; e < f.length; e++){
                var g = f[e];
                var h = a, k = g.blockedSegment;
                if (0 === k.status) {
                    $055fbb5a82eb5281$var$G(g.context);
                    try {
                        $055fbb5a82eb5281$var$X(h, g, g.node), h.responseState.generateStaticMarkup || k.lastPushedText && k.textEmbedded && k.chunks.push("<!-- -->"), g.abortSet.delete(g), k.status = 1, $055fbb5a82eb5281$var$Kb(h, g.blockedBoundary, k);
                    } catch (z) {
                        if ($055fbb5a82eb5281$var$rb(), "object" === typeof z && null !== z && "function" === typeof z.then) {
                            var m = g.ping;
                            z.then(m, m);
                        } else {
                            g.abortSet.delete(g);
                            k.status = 4;
                            var n = g.blockedBoundary, q = z, C = $055fbb5a82eb5281$var$V(h, q);
                            null === n ? $055fbb5a82eb5281$var$W(h, q) : (n.pendingTasks--, n.forceClientRender || (n.forceClientRender = !0, n.errorDigest = C, n.parentFlushed && h.clientRenderedBoundaries.push(n)));
                            h.allPendingTasks--;
                            if (0 === h.allPendingTasks) {
                                var D = h.onAllReady;
                                D();
                            }
                        }
                    } finally{}
                }
            }
            f.splice(0, e);
            null !== a.destination && $055fbb5a82eb5281$var$Mb(a, a.destination);
        } catch (z) {
            $055fbb5a82eb5281$var$V(a, z), $055fbb5a82eb5281$var$W(a, z);
        } finally{
            $055fbb5a82eb5281$var$S = d, $055fbb5a82eb5281$var$yb.current = c, c === $055fbb5a82eb5281$var$xb && $055fbb5a82eb5281$var$G(b);
        }
    }
}
function $055fbb5a82eb5281$var$Z(a, b, c) {
    c.parentFlushed = !0;
    switch(c.status){
        case 0:
            var d = c.id = a.nextSegmentId++;
            c.lastPushedText = !1;
            c.textEmbedded = !1;
            a = a.responseState;
            b.push('<template id="');
            b.push(a.placeholderPrefix);
            a = d.toString(16);
            b.push(a);
            return b.push('"></template>');
        case 1:
            c.status = 2;
            var f = !0;
            d = c.chunks;
            var e = 0;
            c = c.children;
            for(var g = 0; g < c.length; g++){
                for(f = c[g]; e < f.index; e++)b.push(d[e]);
                f = $055fbb5a82eb5281$var$Nb(a, b, f);
            }
            for(; e < d.length - 1; e++)b.push(d[e]);
            e < d.length && (f = b.push(d[e]));
            return f;
        default:
            throw Error($055fbb5a82eb5281$var$l(390));
    }
}
function $055fbb5a82eb5281$var$Nb(a, b, c) {
    var d = c.boundary;
    if (null === d) return $055fbb5a82eb5281$var$Z(a, b, c);
    d.parentFlushed = !0;
    if (d.forceClientRender) return a.responseState.generateStaticMarkup || (d = d.errorDigest, b.push("<!--$!-->"), b.push("<template"), d && (b.push(' data-dgst="'), d = $055fbb5a82eb5281$var$v(d), b.push(d), b.push('"')), b.push("></template>")), $055fbb5a82eb5281$var$Z(a, b, c), a = a.responseState.generateStaticMarkup ? !0 : b.push("<!--/$-->"), a;
    if (0 < d.pendingTasks) {
        d.rootSegmentID = a.nextSegmentId++;
        0 < d.completedSegments.length && a.partialBoundaries.push(d);
        var f = a.responseState;
        var e = f.nextSuspenseID++;
        f = f.boundaryPrefix + e.toString(16);
        d = d.id = f;
        $055fbb5a82eb5281$var$za(b, a.responseState, d);
        $055fbb5a82eb5281$var$Z(a, b, c);
        return b.push("<!--/$-->");
    }
    if (d.byteSize > a.progressiveChunkSize) return d.rootSegmentID = a.nextSegmentId++, a.completedBoundaries.push(d), $055fbb5a82eb5281$var$za(b, a.responseState, d.id), $055fbb5a82eb5281$var$Z(a, b, c), b.push("<!--/$-->");
    a.responseState.generateStaticMarkup || b.push("<!--$-->");
    c = d.completedSegments;
    if (1 !== c.length) throw Error($055fbb5a82eb5281$var$l(391));
    $055fbb5a82eb5281$var$Nb(a, b, c[0]);
    a = a.responseState.generateStaticMarkup ? !0 : b.push("<!--/$-->");
    return a;
}
function $055fbb5a82eb5281$var$Ob(a, b, c) {
    $055fbb5a82eb5281$var$Aa(b, a.responseState, c.formatContext, c.id);
    $055fbb5a82eb5281$var$Nb(a, b, c);
    return $055fbb5a82eb5281$var$Ba(b, c.formatContext);
}
function $055fbb5a82eb5281$var$Pb(a, b, c) {
    for(var d = c.completedSegments, f = 0; f < d.length; f++)$055fbb5a82eb5281$var$Qb(a, b, c, d[f]);
    d.length = 0;
    a = a.responseState;
    d = c.id;
    c = c.rootSegmentID;
    b.push(a.startInlineScript);
    a.sentCompleteBoundaryFunction ? b.push('$RC("') : (a.sentCompleteBoundaryFunction = !0, b.push('function $RC(a,b){a=document.getElementById(a);b=document.getElementById(b);b.parentNode.removeChild(b);if(a){a=a.previousSibling;var f=a.parentNode,c=a.nextSibling,e=0;do{if(c&&8===c.nodeType){var d=c.data;if("/$"===d)if(0===e)break;else e--;else"$"!==d&&"$?"!==d&&"$!"!==d||e++}d=c.nextSibling;f.removeChild(c);c=d}while(c);for(;b.firstChild;)f.insertBefore(b.firstChild,c);a.data="$";a._reactRetry&&a._reactRetry()}};$RC("'));
    if (null === d) throw Error($055fbb5a82eb5281$var$l(395));
    c = c.toString(16);
    b.push(d);
    b.push('","');
    b.push(a.segmentPrefix);
    b.push(c);
    return b.push('")</script>');
}
function $055fbb5a82eb5281$var$Qb(a, b, c, d) {
    if (2 === d.status) return !0;
    var f = d.id;
    if (-1 === f) {
        if (-1 === (d.id = c.rootSegmentID)) throw Error($055fbb5a82eb5281$var$l(392));
        return $055fbb5a82eb5281$var$Ob(a, b, d);
    }
    $055fbb5a82eb5281$var$Ob(a, b, d);
    a = a.responseState;
    b.push(a.startInlineScript);
    a.sentCompleteSegmentFunction ? b.push('$RS("') : (a.sentCompleteSegmentFunction = !0, b.push('function $RS(a,b){a=document.getElementById(a);b=document.getElementById(b);for(a.parentNode.removeChild(a);a.firstChild;)b.parentNode.insertBefore(a.firstChild,b);b.parentNode.removeChild(b)};$RS("'));
    b.push(a.segmentPrefix);
    f = f.toString(16);
    b.push(f);
    b.push('","');
    b.push(a.placeholderPrefix);
    b.push(f);
    return b.push('")</script>');
}
function $055fbb5a82eb5281$var$Mb(a, b) {
    try {
        var c = a.completedRootSegment;
        if (null !== c && 0 === a.pendingRootTasks) {
            $055fbb5a82eb5281$var$Nb(a, b, c);
            a.completedRootSegment = null;
            var d = a.responseState.bootstrapChunks;
            for(c = 0; c < d.length - 1; c++)b.push(d[c]);
            c < d.length && b.push(d[c]);
        }
        var f = a.clientRenderedBoundaries, e;
        for(e = 0; e < f.length; e++){
            var g = f[e];
            d = b;
            var h = a.responseState, k = g.id, m = g.errorDigest, n = g.errorMessage, q = g.errorComponentStack;
            d.push(h.startInlineScript);
            h.sentClientRenderFunction ? d.push('$RX("') : (h.sentClientRenderFunction = !0, d.push('function $RX(b,c,d,e){var a=document.getElementById(b);a&&(b=a.previousSibling,b.data="$!",a=a.dataset,c&&(a.dgst=c),d&&(a.msg=d),e&&(a.stck=e),b._reactRetry&&b._reactRetry())};$RX("'));
            if (null === k) throw Error($055fbb5a82eb5281$var$l(395));
            d.push(k);
            d.push('"');
            if (m || n || q) {
                d.push(",");
                var C = $055fbb5a82eb5281$var$Da(m || "");
                d.push(C);
            }
            if (n || q) {
                d.push(",");
                var D = $055fbb5a82eb5281$var$Da(n || "");
                d.push(D);
            }
            if (q) {
                d.push(",");
                var z = $055fbb5a82eb5281$var$Da(q);
                d.push(z);
            }
            if (!d.push(")</script>")) {
                a.destination = null;
                e++;
                f.splice(0, e);
                return;
            }
        }
        f.splice(0, e);
        var ba = a.completedBoundaries;
        for(e = 0; e < ba.length; e++)if (!$055fbb5a82eb5281$var$Pb(a, b, ba[e])) {
            a.destination = null;
            e++;
            ba.splice(0, e);
            return;
        }
        ba.splice(0, e);
        var ca = a.partialBoundaries;
        for(e = 0; e < ca.length; e++){
            var mb = ca[e];
            a: {
                f = a;
                g = b;
                var da = mb.completedSegments;
                for(h = 0; h < da.length; h++)if (!$055fbb5a82eb5281$var$Qb(f, g, mb, da[h])) {
                    h++;
                    da.splice(0, h);
                    var nb = !1;
                    break a;
                }
                da.splice(0, h);
                nb = !0;
            }
            if (!nb) {
                a.destination = null;
                e++;
                ca.splice(0, e);
                return;
            }
        }
        ca.splice(0, e);
        var ea = a.completedBoundaries;
        for(e = 0; e < ea.length; e++)if (!$055fbb5a82eb5281$var$Pb(a, b, ea[e])) {
            a.destination = null;
            e++;
            ea.splice(0, e);
            return;
        }
        ea.splice(0, e);
    } finally{
        0 === a.allPendingTasks && 0 === a.pingedTasks.length && 0 === a.clientRenderedBoundaries.length && 0 === a.completedBoundaries.length && b.push(null);
    }
}
function $055fbb5a82eb5281$var$Rb(a, b) {
    try {
        var c = a.abortableTasks;
        c.forEach(function(c) {
            return $055fbb5a82eb5281$var$Lb(c, a, b);
        });
        c.clear();
        null !== a.destination && $055fbb5a82eb5281$var$Mb(a, a.destination);
    } catch (d) {
        $055fbb5a82eb5281$var$V(a, d), $055fbb5a82eb5281$var$W(a, d);
    }
}
function $055fbb5a82eb5281$var$Sb() {}
function $055fbb5a82eb5281$var$Tb(a, b, c, d) {
    var f = !1, e = null, g = "", h = {
        push: function(a) {
            null !== a && (g += a);
            return !0;
        },
        destroy: function(a) {
            f = !0;
            e = a;
        }
    }, k = !1;
    a = $055fbb5a82eb5281$var$Ab(a, $055fbb5a82eb5281$var$Ea(c, b ? b.identifierPrefix : void 0), {
        insertionMode: 1,
        selectedValue: null
    }, Infinity, $055fbb5a82eb5281$var$Sb, void 0, function() {
        k = !0;
    }, void 0, void 0);
    $055fbb5a82eb5281$var$Cb(a);
    $055fbb5a82eb5281$var$Rb(a, d);
    if (1 === a.status) a.status = 2, h.destroy(a.fatalError);
    else if (2 !== a.status && null === a.destination) {
        a.destination = h;
        try {
            $055fbb5a82eb5281$var$Mb(a, h);
        } catch (m) {
            $055fbb5a82eb5281$var$V(a, m), $055fbb5a82eb5281$var$W(a, m);
        }
    }
    if (f) throw e;
    if (!k) throw Error($055fbb5a82eb5281$var$l(426));
    return g;
}
$055fbb5a82eb5281$export$307591e98609eddd = function() {
    throw Error($055fbb5a82eb5281$var$l(207));
};
$055fbb5a82eb5281$export$eb3a06aef9e6ee51 = function(a, b) {
    return $055fbb5a82eb5281$var$Tb(a, b, !0, 'The server used "renderToStaticMarkup" which does not support Suspense. If you intended to have the server wait for the suspended component please switch to "renderToReadableStream" which supports Suspense on the server');
};
$055fbb5a82eb5281$export$b23711c915539651 = function() {
    throw Error($055fbb5a82eb5281$var$l(208));
};
$055fbb5a82eb5281$export$80e7718417253a51 = function(a, b) {
    return $055fbb5a82eb5281$var$Tb(a, b, !1, 'The server used "renderToString" which does not support Suspense. If you intended for this Suspense boundary to render the fallback content on the server consider throwing an Error somewhere within the Suspense boundary. If you intended to have the server wait for the suspended component please switch to "renderToReadableStream" which supports Suspense on the server');
};
$055fbb5a82eb5281$export$83d89fbfd8236492 = "18.2.0";

});

parcelRegister("3odmW", function(module, exports) {

$parcel$export(module.exports, "renderToReadableStream", () => $277dfbc9b64034b1$export$7020a3240b287705, (v) => $277dfbc9b64034b1$export$7020a3240b287705 = v);
$parcel$export(module.exports, "version", () => $277dfbc9b64034b1$export$83d89fbfd8236492, (v) => $277dfbc9b64034b1$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom-server.browser.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $277dfbc9b64034b1$export$7020a3240b287705;
var $277dfbc9b64034b1$export$83d89fbfd8236492;
"use strict";

var $acw62 = parcelRequire("acw62");
function $277dfbc9b64034b1$var$k(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $277dfbc9b64034b1$var$l = null, $277dfbc9b64034b1$var$n = 0;
function $277dfbc9b64034b1$var$p(a, b) {
    if (0 !== b.length) {
        if (512 < b.length) 0 < $277dfbc9b64034b1$var$n && (a.enqueue(new Uint8Array($277dfbc9b64034b1$var$l.buffer, 0, $277dfbc9b64034b1$var$n)), $277dfbc9b64034b1$var$l = new Uint8Array(512), $277dfbc9b64034b1$var$n = 0), a.enqueue(b);
        else {
            var c = $277dfbc9b64034b1$var$l.length - $277dfbc9b64034b1$var$n;
            c < b.length && (0 === c ? a.enqueue($277dfbc9b64034b1$var$l) : ($277dfbc9b64034b1$var$l.set(b.subarray(0, c), $277dfbc9b64034b1$var$n), a.enqueue($277dfbc9b64034b1$var$l), b = b.subarray(c)), $277dfbc9b64034b1$var$l = new Uint8Array(512), $277dfbc9b64034b1$var$n = 0);
            $277dfbc9b64034b1$var$l.set(b, $277dfbc9b64034b1$var$n);
            $277dfbc9b64034b1$var$n += b.length;
        }
    }
}
function $277dfbc9b64034b1$var$t(a, b) {
    $277dfbc9b64034b1$var$p(a, b);
    return !0;
}
function $277dfbc9b64034b1$var$ba(a) {
    $277dfbc9b64034b1$var$l && 0 < $277dfbc9b64034b1$var$n && (a.enqueue(new Uint8Array($277dfbc9b64034b1$var$l.buffer, 0, $277dfbc9b64034b1$var$n)), $277dfbc9b64034b1$var$l = null, $277dfbc9b64034b1$var$n = 0);
}
var $277dfbc9b64034b1$var$ca = new TextEncoder;
function $277dfbc9b64034b1$var$u(a) {
    return $277dfbc9b64034b1$var$ca.encode(a);
}
function $277dfbc9b64034b1$var$w(a) {
    return $277dfbc9b64034b1$var$ca.encode(a);
}
function $277dfbc9b64034b1$var$da(a, b) {
    "function" === typeof a.error ? a.error(b) : a.close();
}
var $277dfbc9b64034b1$var$x = Object.prototype.hasOwnProperty, $277dfbc9b64034b1$var$ea = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $277dfbc9b64034b1$var$fa = {}, $277dfbc9b64034b1$var$ha = {};
function $277dfbc9b64034b1$var$ia(a) {
    if ($277dfbc9b64034b1$var$x.call($277dfbc9b64034b1$var$ha, a)) return !0;
    if ($277dfbc9b64034b1$var$x.call($277dfbc9b64034b1$var$fa, a)) return !1;
    if ($277dfbc9b64034b1$var$ea.test(a)) return $277dfbc9b64034b1$var$ha[a] = !0;
    $277dfbc9b64034b1$var$fa[a] = !0;
    return !1;
}
function $277dfbc9b64034b1$var$y(a, b, c, d, f, e, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = f;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = e;
    this.removeEmptyString = g;
}
var $277dfbc9b64034b1$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $277dfbc9b64034b1$var$z[a] = new $277dfbc9b64034b1$var$y(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $277dfbc9b64034b1$var$z[b] = new $277dfbc9b64034b1$var$y(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $277dfbc9b64034b1$var$z[a] = new $277dfbc9b64034b1$var$y(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $277dfbc9b64034b1$var$z[a] = new $277dfbc9b64034b1$var$y(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $277dfbc9b64034b1$var$z[a] = new $277dfbc9b64034b1$var$y(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $277dfbc9b64034b1$var$z[a] = new $277dfbc9b64034b1$var$y(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $277dfbc9b64034b1$var$z[a] = new $277dfbc9b64034b1$var$y(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $277dfbc9b64034b1$var$z[a] = new $277dfbc9b64034b1$var$y(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $277dfbc9b64034b1$var$z[a] = new $277dfbc9b64034b1$var$y(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $277dfbc9b64034b1$var$ja = /[\-:]([a-z])/g;
function $277dfbc9b64034b1$var$ka(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($277dfbc9b64034b1$var$ja, $277dfbc9b64034b1$var$ka);
    $277dfbc9b64034b1$var$z[b] = new $277dfbc9b64034b1$var$y(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($277dfbc9b64034b1$var$ja, $277dfbc9b64034b1$var$ka);
    $277dfbc9b64034b1$var$z[b] = new $277dfbc9b64034b1$var$y(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($277dfbc9b64034b1$var$ja, $277dfbc9b64034b1$var$ka);
    $277dfbc9b64034b1$var$z[b] = new $277dfbc9b64034b1$var$y(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $277dfbc9b64034b1$var$z[a] = new $277dfbc9b64034b1$var$y(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$277dfbc9b64034b1$var$z.xlinkHref = new $277dfbc9b64034b1$var$y("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $277dfbc9b64034b1$var$z[a] = new $277dfbc9b64034b1$var$y(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
var $277dfbc9b64034b1$var$B = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $277dfbc9b64034b1$var$la = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($277dfbc9b64034b1$var$B).forEach(function(a) {
    $277dfbc9b64034b1$var$la.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $277dfbc9b64034b1$var$B[b] = $277dfbc9b64034b1$var$B[a];
    });
});
var $277dfbc9b64034b1$var$oa = /["'&<>]/;
function $277dfbc9b64034b1$var$C(a) {
    if ("boolean" === typeof a || "number" === typeof a) return "" + a;
    a = "" + a;
    var b = $277dfbc9b64034b1$var$oa.exec(a);
    if (b) {
        var c = "", d, f = 0;
        for(d = b.index; d < a.length; d++){
            switch(a.charCodeAt(d)){
                case 34:
                    b = "&quot;";
                    break;
                case 38:
                    b = "&amp;";
                    break;
                case 39:
                    b = "&#x27;";
                    break;
                case 60:
                    b = "&lt;";
                    break;
                case 62:
                    b = "&gt;";
                    break;
                default:
                    continue;
            }
            f !== d && (c += a.substring(f, d));
            f = d + 1;
            c += b;
        }
        a = f !== d ? c + a.substring(f, d) : c;
    }
    return a;
}
var $277dfbc9b64034b1$var$pa = /([A-Z])/g, $277dfbc9b64034b1$var$qa = /^ms-/, $277dfbc9b64034b1$var$ra = Array.isArray, $277dfbc9b64034b1$var$sa = $277dfbc9b64034b1$var$w("<script>"), $277dfbc9b64034b1$var$ta = $277dfbc9b64034b1$var$w("</script>"), $277dfbc9b64034b1$var$ua = $277dfbc9b64034b1$var$w('<script src="'), $277dfbc9b64034b1$var$va = $277dfbc9b64034b1$var$w('<script type="module" src="'), $277dfbc9b64034b1$var$wa = $277dfbc9b64034b1$var$w('" async=""></script>'), $277dfbc9b64034b1$var$xa = /(<\/|<)(s)(cript)/gi;
function $277dfbc9b64034b1$var$ya(a, b, c, d) {
    return "" + b + ("s" === c ? "\\u0073" : "\\u0053") + d;
}
function $277dfbc9b64034b1$var$za(a, b, c, d, f) {
    a = void 0 === a ? "" : a;
    b = void 0 === b ? $277dfbc9b64034b1$var$sa : $277dfbc9b64034b1$var$w('<script nonce="' + $277dfbc9b64034b1$var$C(b) + '">');
    var e = [];
    void 0 !== c && e.push(b, $277dfbc9b64034b1$var$u(("" + c).replace($277dfbc9b64034b1$var$xa, $277dfbc9b64034b1$var$ya)), $277dfbc9b64034b1$var$ta);
    if (void 0 !== d) for(c = 0; c < d.length; c++)e.push($277dfbc9b64034b1$var$ua, $277dfbc9b64034b1$var$u($277dfbc9b64034b1$var$C(d[c])), $277dfbc9b64034b1$var$wa);
    if (void 0 !== f) for(d = 0; d < f.length; d++)e.push($277dfbc9b64034b1$var$va, $277dfbc9b64034b1$var$u($277dfbc9b64034b1$var$C(f[d])), $277dfbc9b64034b1$var$wa);
    return {
        bootstrapChunks: e,
        startInlineScript: b,
        placeholderPrefix: $277dfbc9b64034b1$var$w(a + "P:"),
        segmentPrefix: $277dfbc9b64034b1$var$w(a + "S:"),
        boundaryPrefix: a + "B:",
        idPrefix: a,
        nextSuspenseID: 0,
        sentCompleteSegmentFunction: !1,
        sentCompleteBoundaryFunction: !1,
        sentClientRenderFunction: !1
    };
}
function $277dfbc9b64034b1$var$D(a, b) {
    return {
        insertionMode: a,
        selectedValue: b
    };
}
function $277dfbc9b64034b1$var$Aa(a) {
    return $277dfbc9b64034b1$var$D("http://www.w3.org/2000/svg" === a ? 2 : "http://www.w3.org/1998/Math/MathML" === a ? 3 : 0, null);
}
function $277dfbc9b64034b1$var$Ba(a, b, c) {
    switch(b){
        case "select":
            return $277dfbc9b64034b1$var$D(1, null != c.value ? c.value : c.defaultValue);
        case "svg":
            return $277dfbc9b64034b1$var$D(2, null);
        case "math":
            return $277dfbc9b64034b1$var$D(3, null);
        case "foreignObject":
            return $277dfbc9b64034b1$var$D(1, null);
        case "table":
            return $277dfbc9b64034b1$var$D(4, null);
        case "thead":
        case "tbody":
        case "tfoot":
            return $277dfbc9b64034b1$var$D(5, null);
        case "colgroup":
            return $277dfbc9b64034b1$var$D(7, null);
        case "tr":
            return $277dfbc9b64034b1$var$D(6, null);
    }
    return 4 <= a.insertionMode || 0 === a.insertionMode ? $277dfbc9b64034b1$var$D(1, null) : a;
}
var $277dfbc9b64034b1$var$Ca = $277dfbc9b64034b1$var$w("<!-- -->");
function $277dfbc9b64034b1$var$Da(a, b, c, d) {
    if ("" === b) return d;
    d && a.push($277dfbc9b64034b1$var$Ca);
    a.push($277dfbc9b64034b1$var$u($277dfbc9b64034b1$var$C(b)));
    return !0;
}
var $277dfbc9b64034b1$var$Ea = new Map, $277dfbc9b64034b1$var$Fa = $277dfbc9b64034b1$var$w(' style="'), $277dfbc9b64034b1$var$Ga = $277dfbc9b64034b1$var$w(":"), $277dfbc9b64034b1$var$Ha = $277dfbc9b64034b1$var$w(";");
function $277dfbc9b64034b1$var$Ia(a, b, c) {
    if ("object" !== typeof c) throw Error($277dfbc9b64034b1$var$k(62));
    b = !0;
    for(var d in c)if ($277dfbc9b64034b1$var$x.call(c, d)) {
        var f = c[d];
        if (null != f && "boolean" !== typeof f && "" !== f) {
            if (0 === d.indexOf("--")) {
                var e = $277dfbc9b64034b1$var$u($277dfbc9b64034b1$var$C(d));
                f = $277dfbc9b64034b1$var$u($277dfbc9b64034b1$var$C(("" + f).trim()));
            } else {
                e = d;
                var g = $277dfbc9b64034b1$var$Ea.get(e);
                void 0 !== g ? e = g : (g = $277dfbc9b64034b1$var$w($277dfbc9b64034b1$var$C(e.replace($277dfbc9b64034b1$var$pa, "-$1").toLowerCase().replace($277dfbc9b64034b1$var$qa, "-ms-"))), $277dfbc9b64034b1$var$Ea.set(e, g), e = g);
                f = "number" === typeof f ? 0 === f || $277dfbc9b64034b1$var$x.call($277dfbc9b64034b1$var$B, d) ? $277dfbc9b64034b1$var$u("" + f) : $277dfbc9b64034b1$var$u(f + "px") : $277dfbc9b64034b1$var$u($277dfbc9b64034b1$var$C(("" + f).trim()));
            }
            b ? (b = !1, a.push($277dfbc9b64034b1$var$Fa, e, $277dfbc9b64034b1$var$Ga, f)) : a.push($277dfbc9b64034b1$var$Ha, e, $277dfbc9b64034b1$var$Ga, f);
        }
    }
    b || a.push($277dfbc9b64034b1$var$E);
}
var $277dfbc9b64034b1$var$H = $277dfbc9b64034b1$var$w(" "), $277dfbc9b64034b1$var$I = $277dfbc9b64034b1$var$w('="'), $277dfbc9b64034b1$var$E = $277dfbc9b64034b1$var$w('"'), $277dfbc9b64034b1$var$Ja = $277dfbc9b64034b1$var$w('=""');
function $277dfbc9b64034b1$var$J(a, b, c, d) {
    switch(c){
        case "style":
            $277dfbc9b64034b1$var$Ia(a, b, d);
            return;
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
            return;
    }
    if (!(2 < c.length) || "o" !== c[0] && "O" !== c[0] || "n" !== c[1] && "N" !== c[1]) {
        if (b = $277dfbc9b64034b1$var$z.hasOwnProperty(c) ? $277dfbc9b64034b1$var$z[c] : null, null !== b) {
            switch(typeof d){
                case "function":
                case "symbol":
                    return;
                case "boolean":
                    if (!b.acceptsBooleans) return;
            }
            c = $277dfbc9b64034b1$var$u(b.attributeName);
            switch(b.type){
                case 3:
                    d && a.push($277dfbc9b64034b1$var$H, c, $277dfbc9b64034b1$var$Ja);
                    break;
                case 4:
                    !0 === d ? a.push($277dfbc9b64034b1$var$H, c, $277dfbc9b64034b1$var$Ja) : !1 !== d && a.push($277dfbc9b64034b1$var$H, c, $277dfbc9b64034b1$var$I, $277dfbc9b64034b1$var$u($277dfbc9b64034b1$var$C(d)), $277dfbc9b64034b1$var$E);
                    break;
                case 5:
                    isNaN(d) || a.push($277dfbc9b64034b1$var$H, c, $277dfbc9b64034b1$var$I, $277dfbc9b64034b1$var$u($277dfbc9b64034b1$var$C(d)), $277dfbc9b64034b1$var$E);
                    break;
                case 6:
                    !isNaN(d) && 1 <= d && a.push($277dfbc9b64034b1$var$H, c, $277dfbc9b64034b1$var$I, $277dfbc9b64034b1$var$u($277dfbc9b64034b1$var$C(d)), $277dfbc9b64034b1$var$E);
                    break;
                default:
                    b.sanitizeURL && (d = "" + d), a.push($277dfbc9b64034b1$var$H, c, $277dfbc9b64034b1$var$I, $277dfbc9b64034b1$var$u($277dfbc9b64034b1$var$C(d)), $277dfbc9b64034b1$var$E);
            }
        } else if ($277dfbc9b64034b1$var$ia(c)) {
            switch(typeof d){
                case "function":
                case "symbol":
                    return;
                case "boolean":
                    if (b = c.toLowerCase().slice(0, 5), "data-" !== b && "aria-" !== b) return;
            }
            a.push($277dfbc9b64034b1$var$H, $277dfbc9b64034b1$var$u(c), $277dfbc9b64034b1$var$I, $277dfbc9b64034b1$var$u($277dfbc9b64034b1$var$C(d)), $277dfbc9b64034b1$var$E);
        }
    }
}
var $277dfbc9b64034b1$var$K = $277dfbc9b64034b1$var$w(">"), $277dfbc9b64034b1$var$Ka = $277dfbc9b64034b1$var$w("/>");
function $277dfbc9b64034b1$var$L(a, b, c) {
    if (null != b) {
        if (null != c) throw Error($277dfbc9b64034b1$var$k(60));
        if ("object" !== typeof b || !("__html" in b)) throw Error($277dfbc9b64034b1$var$k(61));
        b = b.__html;
        null !== b && void 0 !== b && a.push($277dfbc9b64034b1$var$u("" + b));
    }
}
function $277dfbc9b64034b1$var$La(a) {
    var b = "";
    $acw62.Children.forEach(a, function(a) {
        null != a && (b += a);
    });
    return b;
}
var $277dfbc9b64034b1$var$Ma = $277dfbc9b64034b1$var$w(' selected=""');
function $277dfbc9b64034b1$var$Na(a, b, c, d) {
    a.push($277dfbc9b64034b1$var$M(c));
    var f = c = null, e;
    for(e in b)if ($277dfbc9b64034b1$var$x.call(b, e)) {
        var g = b[e];
        if (null != g) switch(e){
            case "children":
                c = g;
                break;
            case "dangerouslySetInnerHTML":
                f = g;
                break;
            default:
                $277dfbc9b64034b1$var$J(a, d, e, g);
        }
    }
    a.push($277dfbc9b64034b1$var$K);
    $277dfbc9b64034b1$var$L(a, f, c);
    return "string" === typeof c ? (a.push($277dfbc9b64034b1$var$u($277dfbc9b64034b1$var$C(c))), null) : c;
}
var $277dfbc9b64034b1$var$Oa = $277dfbc9b64034b1$var$w("\n"), $277dfbc9b64034b1$var$Pa = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/, $277dfbc9b64034b1$var$Qa = new Map;
function $277dfbc9b64034b1$var$M(a) {
    var b = $277dfbc9b64034b1$var$Qa.get(a);
    if (void 0 === b) {
        if (!$277dfbc9b64034b1$var$Pa.test(a)) throw Error($277dfbc9b64034b1$var$k(65, a));
        b = $277dfbc9b64034b1$var$w("<" + a);
        $277dfbc9b64034b1$var$Qa.set(a, b);
    }
    return b;
}
var $277dfbc9b64034b1$var$Ra = $277dfbc9b64034b1$var$w("<!DOCTYPE html>");
function $277dfbc9b64034b1$var$Sa(a, b, c, d, f) {
    switch(b){
        case "select":
            a.push($277dfbc9b64034b1$var$M("select"));
            var e = null, g = null;
            for(r in c)if ($277dfbc9b64034b1$var$x.call(c, r)) {
                var h = c[r];
                if (null != h) switch(r){
                    case "children":
                        e = h;
                        break;
                    case "dangerouslySetInnerHTML":
                        g = h;
                        break;
                    case "defaultValue":
                    case "value":
                        break;
                    default:
                        $277dfbc9b64034b1$var$J(a, d, r, h);
                }
            }
            a.push($277dfbc9b64034b1$var$K);
            $277dfbc9b64034b1$var$L(a, g, e);
            return e;
        case "option":
            g = f.selectedValue;
            a.push($277dfbc9b64034b1$var$M("option"));
            var m = h = null, q = null;
            var r = null;
            for(e in c)if ($277dfbc9b64034b1$var$x.call(c, e)) {
                var v = c[e];
                if (null != v) switch(e){
                    case "children":
                        h = v;
                        break;
                    case "selected":
                        q = v;
                        break;
                    case "dangerouslySetInnerHTML":
                        r = v;
                        break;
                    case "value":
                        m = v;
                    default:
                        $277dfbc9b64034b1$var$J(a, d, e, v);
                }
            }
            if (null != g) {
                if (c = null !== m ? "" + m : $277dfbc9b64034b1$var$La(h), $277dfbc9b64034b1$var$ra(g)) {
                    for(d = 0; d < g.length; d++)if ("" + g[d] === c) {
                        a.push($277dfbc9b64034b1$var$Ma);
                        break;
                    }
                } else "" + g === c && a.push($277dfbc9b64034b1$var$Ma);
            } else q && a.push($277dfbc9b64034b1$var$Ma);
            a.push($277dfbc9b64034b1$var$K);
            $277dfbc9b64034b1$var$L(a, r, h);
            return h;
        case "textarea":
            a.push($277dfbc9b64034b1$var$M("textarea"));
            r = g = e = null;
            for(h in c)if ($277dfbc9b64034b1$var$x.call(c, h) && (m = c[h], null != m)) switch(h){
                case "children":
                    r = m;
                    break;
                case "value":
                    e = m;
                    break;
                case "defaultValue":
                    g = m;
                    break;
                case "dangerouslySetInnerHTML":
                    throw Error($277dfbc9b64034b1$var$k(91));
                default:
                    $277dfbc9b64034b1$var$J(a, d, h, m);
            }
            null === e && null !== g && (e = g);
            a.push($277dfbc9b64034b1$var$K);
            if (null != r) {
                if (null != e) throw Error($277dfbc9b64034b1$var$k(92));
                if ($277dfbc9b64034b1$var$ra(r) && 1 < r.length) throw Error($277dfbc9b64034b1$var$k(93));
                e = "" + r;
            }
            "string" === typeof e && "\n" === e[0] && a.push($277dfbc9b64034b1$var$Oa);
            null !== e && a.push($277dfbc9b64034b1$var$u($277dfbc9b64034b1$var$C("" + e)));
            return null;
        case "input":
            a.push($277dfbc9b64034b1$var$M("input"));
            m = r = h = e = null;
            for(g in c)if ($277dfbc9b64034b1$var$x.call(c, g) && (q = c[g], null != q)) switch(g){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($277dfbc9b64034b1$var$k(399, "input"));
                case "defaultChecked":
                    m = q;
                    break;
                case "defaultValue":
                    h = q;
                    break;
                case "checked":
                    r = q;
                    break;
                case "value":
                    e = q;
                    break;
                default:
                    $277dfbc9b64034b1$var$J(a, d, g, q);
            }
            null !== r ? $277dfbc9b64034b1$var$J(a, d, "checked", r) : null !== m && $277dfbc9b64034b1$var$J(a, d, "checked", m);
            null !== e ? $277dfbc9b64034b1$var$J(a, d, "value", e) : null !== h && $277dfbc9b64034b1$var$J(a, d, "value", h);
            a.push($277dfbc9b64034b1$var$Ka);
            return null;
        case "menuitem":
            a.push($277dfbc9b64034b1$var$M("menuitem"));
            for(var A in c)if ($277dfbc9b64034b1$var$x.call(c, A) && (e = c[A], null != e)) switch(A){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($277dfbc9b64034b1$var$k(400));
                default:
                    $277dfbc9b64034b1$var$J(a, d, A, e);
            }
            a.push($277dfbc9b64034b1$var$K);
            return null;
        case "title":
            a.push($277dfbc9b64034b1$var$M("title"));
            e = null;
            for(v in c)if ($277dfbc9b64034b1$var$x.call(c, v) && (g = c[v], null != g)) switch(v){
                case "children":
                    e = g;
                    break;
                case "dangerouslySetInnerHTML":
                    throw Error($277dfbc9b64034b1$var$k(434));
                default:
                    $277dfbc9b64034b1$var$J(a, d, v, g);
            }
            a.push($277dfbc9b64034b1$var$K);
            return e;
        case "listing":
        case "pre":
            a.push($277dfbc9b64034b1$var$M(b));
            g = e = null;
            for(m in c)if ($277dfbc9b64034b1$var$x.call(c, m) && (h = c[m], null != h)) switch(m){
                case "children":
                    e = h;
                    break;
                case "dangerouslySetInnerHTML":
                    g = h;
                    break;
                default:
                    $277dfbc9b64034b1$var$J(a, d, m, h);
            }
            a.push($277dfbc9b64034b1$var$K);
            if (null != g) {
                if (null != e) throw Error($277dfbc9b64034b1$var$k(60));
                if ("object" !== typeof g || !("__html" in g)) throw Error($277dfbc9b64034b1$var$k(61));
                c = g.__html;
                null !== c && void 0 !== c && ("string" === typeof c && 0 < c.length && "\n" === c[0] ? a.push($277dfbc9b64034b1$var$Oa, $277dfbc9b64034b1$var$u(c)) : a.push($277dfbc9b64034b1$var$u("" + c)));
            }
            "string" === typeof e && "\n" === e[0] && a.push($277dfbc9b64034b1$var$Oa);
            return e;
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "img":
        case "keygen":
        case "link":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
            a.push($277dfbc9b64034b1$var$M(b));
            for(var F in c)if ($277dfbc9b64034b1$var$x.call(c, F) && (e = c[F], null != e)) switch(F){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($277dfbc9b64034b1$var$k(399, b));
                default:
                    $277dfbc9b64034b1$var$J(a, d, F, e);
            }
            a.push($277dfbc9b64034b1$var$Ka);
            return null;
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return $277dfbc9b64034b1$var$Na(a, c, b, d);
        case "html":
            return 0 === f.insertionMode && a.push($277dfbc9b64034b1$var$Ra), $277dfbc9b64034b1$var$Na(a, c, b, d);
        default:
            if (-1 === b.indexOf("-") && "string" !== typeof c.is) return $277dfbc9b64034b1$var$Na(a, c, b, d);
            a.push($277dfbc9b64034b1$var$M(b));
            g = e = null;
            for(q in c)if ($277dfbc9b64034b1$var$x.call(c, q) && (h = c[q], null != h)) switch(q){
                case "children":
                    e = h;
                    break;
                case "dangerouslySetInnerHTML":
                    g = h;
                    break;
                case "style":
                    $277dfbc9b64034b1$var$Ia(a, d, h);
                    break;
                case "suppressContentEditableWarning":
                case "suppressHydrationWarning":
                    break;
                default:
                    $277dfbc9b64034b1$var$ia(q) && "function" !== typeof h && "symbol" !== typeof h && a.push($277dfbc9b64034b1$var$H, $277dfbc9b64034b1$var$u(q), $277dfbc9b64034b1$var$I, $277dfbc9b64034b1$var$u($277dfbc9b64034b1$var$C(h)), $277dfbc9b64034b1$var$E);
            }
            a.push($277dfbc9b64034b1$var$K);
            $277dfbc9b64034b1$var$L(a, g, e);
            return e;
    }
}
var $277dfbc9b64034b1$var$Ta = $277dfbc9b64034b1$var$w("</"), $277dfbc9b64034b1$var$Ua = $277dfbc9b64034b1$var$w(">"), $277dfbc9b64034b1$var$Va = $277dfbc9b64034b1$var$w('<template id="'), $277dfbc9b64034b1$var$Wa = $277dfbc9b64034b1$var$w('"></template>'), $277dfbc9b64034b1$var$Xa = $277dfbc9b64034b1$var$w("<!--$-->"), $277dfbc9b64034b1$var$Ya = $277dfbc9b64034b1$var$w('<!--$?--><template id="'), $277dfbc9b64034b1$var$Za = $277dfbc9b64034b1$var$w('"></template>'), $277dfbc9b64034b1$var$$a = $277dfbc9b64034b1$var$w("<!--$!-->"), $277dfbc9b64034b1$var$ab = $277dfbc9b64034b1$var$w("<!--/$-->"), $277dfbc9b64034b1$var$bb = $277dfbc9b64034b1$var$w("<template"), $277dfbc9b64034b1$var$cb = $277dfbc9b64034b1$var$w('"'), $277dfbc9b64034b1$var$db = $277dfbc9b64034b1$var$w(' data-dgst="');
$277dfbc9b64034b1$var$w(' data-msg="');
$277dfbc9b64034b1$var$w(' data-stck="');
var $277dfbc9b64034b1$var$eb = $277dfbc9b64034b1$var$w("></template>");
function $277dfbc9b64034b1$var$fb(a, b, c) {
    $277dfbc9b64034b1$var$p(a, $277dfbc9b64034b1$var$Ya);
    if (null === c) throw Error($277dfbc9b64034b1$var$k(395));
    $277dfbc9b64034b1$var$p(a, c);
    return $277dfbc9b64034b1$var$t(a, $277dfbc9b64034b1$var$Za);
}
var $277dfbc9b64034b1$var$gb = $277dfbc9b64034b1$var$w('<div hidden id="'), $277dfbc9b64034b1$var$hb = $277dfbc9b64034b1$var$w('">'), $277dfbc9b64034b1$var$ib = $277dfbc9b64034b1$var$w("</div>"), $277dfbc9b64034b1$var$jb = $277dfbc9b64034b1$var$w('<svg aria-hidden="true" style="display:none" id="'), $277dfbc9b64034b1$var$kb = $277dfbc9b64034b1$var$w('">'), $277dfbc9b64034b1$var$lb = $277dfbc9b64034b1$var$w("</svg>"), $277dfbc9b64034b1$var$mb = $277dfbc9b64034b1$var$w('<math aria-hidden="true" style="display:none" id="'), $277dfbc9b64034b1$var$nb = $277dfbc9b64034b1$var$w('">'), $277dfbc9b64034b1$var$ob = $277dfbc9b64034b1$var$w("</math>"), $277dfbc9b64034b1$var$pb = $277dfbc9b64034b1$var$w('<table hidden id="'), $277dfbc9b64034b1$var$qb = $277dfbc9b64034b1$var$w('">'), $277dfbc9b64034b1$var$rb = $277dfbc9b64034b1$var$w("</table>"), $277dfbc9b64034b1$var$sb = $277dfbc9b64034b1$var$w('<table hidden><tbody id="'), $277dfbc9b64034b1$var$tb = $277dfbc9b64034b1$var$w('">'), $277dfbc9b64034b1$var$ub = $277dfbc9b64034b1$var$w("</tbody></table>"), $277dfbc9b64034b1$var$vb = $277dfbc9b64034b1$var$w('<table hidden><tr id="'), $277dfbc9b64034b1$var$wb = $277dfbc9b64034b1$var$w('">'), $277dfbc9b64034b1$var$xb = $277dfbc9b64034b1$var$w("</tr></table>"), $277dfbc9b64034b1$var$yb = $277dfbc9b64034b1$var$w('<table hidden><colgroup id="'), $277dfbc9b64034b1$var$zb = $277dfbc9b64034b1$var$w('">'), $277dfbc9b64034b1$var$Ab = $277dfbc9b64034b1$var$w("</colgroup></table>");
function $277dfbc9b64034b1$var$Bb(a, b, c, d) {
    switch(c.insertionMode){
        case 0:
        case 1:
            return $277dfbc9b64034b1$var$p(a, $277dfbc9b64034b1$var$gb), $277dfbc9b64034b1$var$p(a, b.segmentPrefix), $277dfbc9b64034b1$var$p(a, $277dfbc9b64034b1$var$u(d.toString(16))), $277dfbc9b64034b1$var$t(a, $277dfbc9b64034b1$var$hb);
        case 2:
            return $277dfbc9b64034b1$var$p(a, $277dfbc9b64034b1$var$jb), $277dfbc9b64034b1$var$p(a, b.segmentPrefix), $277dfbc9b64034b1$var$p(a, $277dfbc9b64034b1$var$u(d.toString(16))), $277dfbc9b64034b1$var$t(a, $277dfbc9b64034b1$var$kb);
        case 3:
            return $277dfbc9b64034b1$var$p(a, $277dfbc9b64034b1$var$mb), $277dfbc9b64034b1$var$p(a, b.segmentPrefix), $277dfbc9b64034b1$var$p(a, $277dfbc9b64034b1$var$u(d.toString(16))), $277dfbc9b64034b1$var$t(a, $277dfbc9b64034b1$var$nb);
        case 4:
            return $277dfbc9b64034b1$var$p(a, $277dfbc9b64034b1$var$pb), $277dfbc9b64034b1$var$p(a, b.segmentPrefix), $277dfbc9b64034b1$var$p(a, $277dfbc9b64034b1$var$u(d.toString(16))), $277dfbc9b64034b1$var$t(a, $277dfbc9b64034b1$var$qb);
        case 5:
            return $277dfbc9b64034b1$var$p(a, $277dfbc9b64034b1$var$sb), $277dfbc9b64034b1$var$p(a, b.segmentPrefix), $277dfbc9b64034b1$var$p(a, $277dfbc9b64034b1$var$u(d.toString(16))), $277dfbc9b64034b1$var$t(a, $277dfbc9b64034b1$var$tb);
        case 6:
            return $277dfbc9b64034b1$var$p(a, $277dfbc9b64034b1$var$vb), $277dfbc9b64034b1$var$p(a, b.segmentPrefix), $277dfbc9b64034b1$var$p(a, $277dfbc9b64034b1$var$u(d.toString(16))), $277dfbc9b64034b1$var$t(a, $277dfbc9b64034b1$var$wb);
        case 7:
            return $277dfbc9b64034b1$var$p(a, $277dfbc9b64034b1$var$yb), $277dfbc9b64034b1$var$p(a, b.segmentPrefix), $277dfbc9b64034b1$var$p(a, $277dfbc9b64034b1$var$u(d.toString(16))), $277dfbc9b64034b1$var$t(a, $277dfbc9b64034b1$var$zb);
        default:
            throw Error($277dfbc9b64034b1$var$k(397));
    }
}
function $277dfbc9b64034b1$var$Cb(a, b) {
    switch(b.insertionMode){
        case 0:
        case 1:
            return $277dfbc9b64034b1$var$t(a, $277dfbc9b64034b1$var$ib);
        case 2:
            return $277dfbc9b64034b1$var$t(a, $277dfbc9b64034b1$var$lb);
        case 3:
            return $277dfbc9b64034b1$var$t(a, $277dfbc9b64034b1$var$ob);
        case 4:
            return $277dfbc9b64034b1$var$t(a, $277dfbc9b64034b1$var$rb);
        case 5:
            return $277dfbc9b64034b1$var$t(a, $277dfbc9b64034b1$var$ub);
        case 6:
            return $277dfbc9b64034b1$var$t(a, $277dfbc9b64034b1$var$xb);
        case 7:
            return $277dfbc9b64034b1$var$t(a, $277dfbc9b64034b1$var$Ab);
        default:
            throw Error($277dfbc9b64034b1$var$k(397));
    }
}
var $277dfbc9b64034b1$var$Db = $277dfbc9b64034b1$var$w('function $RS(a,b){a=document.getElementById(a);b=document.getElementById(b);for(a.parentNode.removeChild(a);a.firstChild;)b.parentNode.insertBefore(a.firstChild,b);b.parentNode.removeChild(b)};$RS("'), $277dfbc9b64034b1$var$Eb = $277dfbc9b64034b1$var$w('$RS("'), $277dfbc9b64034b1$var$Gb = $277dfbc9b64034b1$var$w('","'), $277dfbc9b64034b1$var$Hb = $277dfbc9b64034b1$var$w('")</script>'), $277dfbc9b64034b1$var$Ib = $277dfbc9b64034b1$var$w('function $RC(a,b){a=document.getElementById(a);b=document.getElementById(b);b.parentNode.removeChild(b);if(a){a=a.previousSibling;var f=a.parentNode,c=a.nextSibling,e=0;do{if(c&&8===c.nodeType){var d=c.data;if("/$"===d)if(0===e)break;else e--;else"$"!==d&&"$?"!==d&&"$!"!==d||e++}d=c.nextSibling;f.removeChild(c);c=d}while(c);for(;b.firstChild;)f.insertBefore(b.firstChild,c);a.data="$";a._reactRetry&&a._reactRetry()}};$RC("'), $277dfbc9b64034b1$var$Jb = $277dfbc9b64034b1$var$w('$RC("'), $277dfbc9b64034b1$var$Kb = $277dfbc9b64034b1$var$w('","'), $277dfbc9b64034b1$var$Lb = $277dfbc9b64034b1$var$w('")</script>'), $277dfbc9b64034b1$var$Mb = $277dfbc9b64034b1$var$w('function $RX(b,c,d,e){var a=document.getElementById(b);a&&(b=a.previousSibling,b.data="$!",a=a.dataset,c&&(a.dgst=c),d&&(a.msg=d),e&&(a.stck=e),b._reactRetry&&b._reactRetry())};$RX("'), $277dfbc9b64034b1$var$Nb = $277dfbc9b64034b1$var$w('$RX("'), $277dfbc9b64034b1$var$Ob = $277dfbc9b64034b1$var$w('"'), $277dfbc9b64034b1$var$Pb = $277dfbc9b64034b1$var$w(")</script>"), $277dfbc9b64034b1$var$Qb = $277dfbc9b64034b1$var$w(","), $277dfbc9b64034b1$var$Rb = /[<\u2028\u2029]/g;
function $277dfbc9b64034b1$var$Sb(a) {
    return JSON.stringify(a).replace($277dfbc9b64034b1$var$Rb, function(a) {
        switch(a){
            case "<":
                return "\\u003c";
            case "\u2028":
                return "\\u2028";
            case "\u2029":
                return "\\u2029";
            default:
                throw Error("escapeJSStringsForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React");
        }
    });
}
var $277dfbc9b64034b1$var$N = Object.assign, $277dfbc9b64034b1$var$Tb = Symbol.for("react.element"), $277dfbc9b64034b1$var$Ub = Symbol.for("react.portal"), $277dfbc9b64034b1$var$Vb = Symbol.for("react.fragment"), $277dfbc9b64034b1$var$Wb = Symbol.for("react.strict_mode"), $277dfbc9b64034b1$var$Xb = Symbol.for("react.profiler"), $277dfbc9b64034b1$var$Yb = Symbol.for("react.provider"), $277dfbc9b64034b1$var$Zb = Symbol.for("react.context"), $277dfbc9b64034b1$var$$b = Symbol.for("react.forward_ref"), $277dfbc9b64034b1$var$ac = Symbol.for("react.suspense"), $277dfbc9b64034b1$var$bc = Symbol.for("react.suspense_list"), $277dfbc9b64034b1$var$cc = Symbol.for("react.memo"), $277dfbc9b64034b1$var$dc = Symbol.for("react.lazy"), $277dfbc9b64034b1$var$ec = Symbol.for("react.scope"), $277dfbc9b64034b1$var$fc = Symbol.for("react.debug_trace_mode"), $277dfbc9b64034b1$var$gc = Symbol.for("react.legacy_hidden"), $277dfbc9b64034b1$var$hc = Symbol.for("react.default_value"), $277dfbc9b64034b1$var$ic = Symbol.iterator;
function $277dfbc9b64034b1$var$jc(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $277dfbc9b64034b1$var$Vb:
            return "Fragment";
        case $277dfbc9b64034b1$var$Ub:
            return "Portal";
        case $277dfbc9b64034b1$var$Xb:
            return "Profiler";
        case $277dfbc9b64034b1$var$Wb:
            return "StrictMode";
        case $277dfbc9b64034b1$var$ac:
            return "Suspense";
        case $277dfbc9b64034b1$var$bc:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $277dfbc9b64034b1$var$Zb:
            return (a.displayName || "Context") + ".Consumer";
        case $277dfbc9b64034b1$var$Yb:
            return (a._context.displayName || "Context") + ".Provider";
        case $277dfbc9b64034b1$var$$b:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $277dfbc9b64034b1$var$cc:
            return b = a.displayName || null, null !== b ? b : $277dfbc9b64034b1$var$jc(a.type) || "Memo";
        case $277dfbc9b64034b1$var$dc:
            b = a._payload;
            a = a._init;
            try {
                return $277dfbc9b64034b1$var$jc(a(b));
            } catch (c) {}
    }
    return null;
}
var $277dfbc9b64034b1$var$kc = {};
function $277dfbc9b64034b1$var$lc(a, b) {
    a = a.contextTypes;
    if (!a) return $277dfbc9b64034b1$var$kc;
    var c = {}, d;
    for(d in a)c[d] = b[d];
    return c;
}
var $277dfbc9b64034b1$var$O = null;
function $277dfbc9b64034b1$var$P(a, b) {
    if (a !== b) {
        a.context._currentValue = a.parentValue;
        a = a.parent;
        var c = b.parent;
        if (null === a) {
            if (null !== c) throw Error($277dfbc9b64034b1$var$k(401));
        } else {
            if (null === c) throw Error($277dfbc9b64034b1$var$k(401));
            $277dfbc9b64034b1$var$P(a, c);
        }
        b.context._currentValue = b.value;
    }
}
function $277dfbc9b64034b1$var$mc(a) {
    a.context._currentValue = a.parentValue;
    a = a.parent;
    null !== a && $277dfbc9b64034b1$var$mc(a);
}
function $277dfbc9b64034b1$var$nc(a) {
    var b = a.parent;
    null !== b && $277dfbc9b64034b1$var$nc(b);
    a.context._currentValue = a.value;
}
function $277dfbc9b64034b1$var$oc(a, b) {
    a.context._currentValue = a.parentValue;
    a = a.parent;
    if (null === a) throw Error($277dfbc9b64034b1$var$k(402));
    a.depth === b.depth ? $277dfbc9b64034b1$var$P(a, b) : $277dfbc9b64034b1$var$oc(a, b);
}
function $277dfbc9b64034b1$var$pc(a, b) {
    var c = b.parent;
    if (null === c) throw Error($277dfbc9b64034b1$var$k(402));
    a.depth === c.depth ? $277dfbc9b64034b1$var$P(a, c) : $277dfbc9b64034b1$var$pc(a, c);
    b.context._currentValue = b.value;
}
function $277dfbc9b64034b1$var$Q(a) {
    var b = $277dfbc9b64034b1$var$O;
    b !== a && (null === b ? $277dfbc9b64034b1$var$nc(a) : null === a ? $277dfbc9b64034b1$var$mc(b) : b.depth === a.depth ? $277dfbc9b64034b1$var$P(b, a) : b.depth > a.depth ? $277dfbc9b64034b1$var$oc(b, a) : $277dfbc9b64034b1$var$pc(b, a), $277dfbc9b64034b1$var$O = a);
}
var $277dfbc9b64034b1$var$qc = {
    isMounted: function() {
        return !1;
    },
    enqueueSetState: function(a, b) {
        a = a._reactInternals;
        null !== a.queue && a.queue.push(b);
    },
    enqueueReplaceState: function(a, b) {
        a = a._reactInternals;
        a.replace = !0;
        a.queue = [
            b
        ];
    },
    enqueueForceUpdate: function() {}
};
function $277dfbc9b64034b1$var$rc(a, b, c, d) {
    var f = void 0 !== a.state ? a.state : null;
    a.updater = $277dfbc9b64034b1$var$qc;
    a.props = c;
    a.state = f;
    var e = {
        queue: [],
        replace: !1
    };
    a._reactInternals = e;
    var g = b.contextType;
    a.context = "object" === typeof g && null !== g ? g._currentValue : d;
    g = b.getDerivedStateFromProps;
    "function" === typeof g && (g = g(c, f), f = null === g || void 0 === g ? f : $277dfbc9b64034b1$var$N({}, f, g), a.state = f);
    if ("function" !== typeof b.getDerivedStateFromProps && "function" !== typeof a.getSnapshotBeforeUpdate && ("function" === typeof a.UNSAFE_componentWillMount || "function" === typeof a.componentWillMount)) {
        if (b = a.state, "function" === typeof a.componentWillMount && a.componentWillMount(), "function" === typeof a.UNSAFE_componentWillMount && a.UNSAFE_componentWillMount(), b !== a.state && $277dfbc9b64034b1$var$qc.enqueueReplaceState(a, a.state, null), null !== e.queue && 0 < e.queue.length) {
            if (b = e.queue, g = e.replace, e.queue = null, e.replace = !1, g && 1 === b.length) a.state = b[0];
            else {
                e = g ? b[0] : a.state;
                f = !0;
                for(g = g ? 1 : 0; g < b.length; g++){
                    var h = b[g];
                    h = "function" === typeof h ? h.call(a, e, c, d) : h;
                    null != h && (f ? (f = !1, e = $277dfbc9b64034b1$var$N({}, e, h)) : $277dfbc9b64034b1$var$N(e, h));
                }
                a.state = e;
            }
        } else e.queue = null;
    }
}
var $277dfbc9b64034b1$var$sc = {
    id: 1,
    overflow: ""
};
function $277dfbc9b64034b1$var$tc(a, b, c) {
    var d = a.id;
    a = a.overflow;
    var f = 32 - $277dfbc9b64034b1$var$uc(d) - 1;
    d &= ~(1 << f);
    c += 1;
    var e = 32 - $277dfbc9b64034b1$var$uc(b) + f;
    if (30 < e) {
        var g = f - f % 5;
        e = (d & (1 << g) - 1).toString(32);
        d >>= g;
        f -= g;
        return {
            id: 1 << 32 - $277dfbc9b64034b1$var$uc(b) + f | c << f | d,
            overflow: e + a
        };
    }
    return {
        id: 1 << e | c << f | d,
        overflow: a
    };
}
var $277dfbc9b64034b1$var$uc = Math.clz32 ? Math.clz32 : $277dfbc9b64034b1$var$vc, $277dfbc9b64034b1$var$wc = Math.log, $277dfbc9b64034b1$var$xc = Math.LN2;
function $277dfbc9b64034b1$var$vc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($277dfbc9b64034b1$var$wc(a) / $277dfbc9b64034b1$var$xc | 0) | 0;
}
function $277dfbc9b64034b1$var$yc(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $277dfbc9b64034b1$var$zc = "function" === typeof Object.is ? Object.is : $277dfbc9b64034b1$var$yc, $277dfbc9b64034b1$var$R = null, $277dfbc9b64034b1$var$Ac = null, $277dfbc9b64034b1$var$Bc = null, $277dfbc9b64034b1$var$S = null, $277dfbc9b64034b1$var$T = !1, $277dfbc9b64034b1$var$Cc = !1, $277dfbc9b64034b1$var$U = 0, $277dfbc9b64034b1$var$V = null, $277dfbc9b64034b1$var$Dc = 0;
function $277dfbc9b64034b1$var$W() {
    if (null === $277dfbc9b64034b1$var$R) throw Error($277dfbc9b64034b1$var$k(321));
    return $277dfbc9b64034b1$var$R;
}
function $277dfbc9b64034b1$var$Ec() {
    if (0 < $277dfbc9b64034b1$var$Dc) throw Error($277dfbc9b64034b1$var$k(312));
    return {
        memoizedState: null,
        queue: null,
        next: null
    };
}
function $277dfbc9b64034b1$var$Fc() {
    null === $277dfbc9b64034b1$var$S ? null === $277dfbc9b64034b1$var$Bc ? ($277dfbc9b64034b1$var$T = !1, $277dfbc9b64034b1$var$Bc = $277dfbc9b64034b1$var$S = $277dfbc9b64034b1$var$Ec()) : ($277dfbc9b64034b1$var$T = !0, $277dfbc9b64034b1$var$S = $277dfbc9b64034b1$var$Bc) : null === $277dfbc9b64034b1$var$S.next ? ($277dfbc9b64034b1$var$T = !1, $277dfbc9b64034b1$var$S = $277dfbc9b64034b1$var$S.next = $277dfbc9b64034b1$var$Ec()) : ($277dfbc9b64034b1$var$T = !0, $277dfbc9b64034b1$var$S = $277dfbc9b64034b1$var$S.next);
    return $277dfbc9b64034b1$var$S;
}
function $277dfbc9b64034b1$var$Gc() {
    $277dfbc9b64034b1$var$Ac = $277dfbc9b64034b1$var$R = null;
    $277dfbc9b64034b1$var$Cc = !1;
    $277dfbc9b64034b1$var$Bc = null;
    $277dfbc9b64034b1$var$Dc = 0;
    $277dfbc9b64034b1$var$S = $277dfbc9b64034b1$var$V = null;
}
function $277dfbc9b64034b1$var$Hc(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $277dfbc9b64034b1$var$Ic(a, b, c) {
    $277dfbc9b64034b1$var$R = $277dfbc9b64034b1$var$W();
    $277dfbc9b64034b1$var$S = $277dfbc9b64034b1$var$Fc();
    if ($277dfbc9b64034b1$var$T) {
        var d = $277dfbc9b64034b1$var$S.queue;
        b = d.dispatch;
        if (null !== $277dfbc9b64034b1$var$V && (c = $277dfbc9b64034b1$var$V.get(d), void 0 !== c)) {
            $277dfbc9b64034b1$var$V.delete(d);
            d = $277dfbc9b64034b1$var$S.memoizedState;
            do d = a(d, c.action), c = c.next;
            while (null !== c);
            $277dfbc9b64034b1$var$S.memoizedState = d;
            return [
                d,
                b
            ];
        }
        return [
            $277dfbc9b64034b1$var$S.memoizedState,
            b
        ];
    }
    a = a === $277dfbc9b64034b1$var$Hc ? "function" === typeof b ? b() : b : void 0 !== c ? c(b) : b;
    $277dfbc9b64034b1$var$S.memoizedState = a;
    a = $277dfbc9b64034b1$var$S.queue = {
        last: null,
        dispatch: null
    };
    a = a.dispatch = $277dfbc9b64034b1$var$Jc.bind(null, $277dfbc9b64034b1$var$R, a);
    return [
        $277dfbc9b64034b1$var$S.memoizedState,
        a
    ];
}
function $277dfbc9b64034b1$var$Kc(a, b) {
    $277dfbc9b64034b1$var$R = $277dfbc9b64034b1$var$W();
    $277dfbc9b64034b1$var$S = $277dfbc9b64034b1$var$Fc();
    b = void 0 === b ? null : b;
    if (null !== $277dfbc9b64034b1$var$S) {
        var c = $277dfbc9b64034b1$var$S.memoizedState;
        if (null !== c && null !== b) {
            var d = c[1];
            a: if (null === d) d = !1;
            else {
                for(var f = 0; f < d.length && f < b.length; f++)if (!$277dfbc9b64034b1$var$zc(b[f], d[f])) {
                    d = !1;
                    break a;
                }
                d = !0;
            }
            if (d) return c[0];
        }
    }
    a = a();
    $277dfbc9b64034b1$var$S.memoizedState = [
        a,
        b
    ];
    return a;
}
function $277dfbc9b64034b1$var$Jc(a, b, c) {
    if (25 <= $277dfbc9b64034b1$var$Dc) throw Error($277dfbc9b64034b1$var$k(301));
    if (a === $277dfbc9b64034b1$var$R) {
        if ($277dfbc9b64034b1$var$Cc = !0, a = {
            action: c,
            next: null
        }, null === $277dfbc9b64034b1$var$V && ($277dfbc9b64034b1$var$V = new Map), c = $277dfbc9b64034b1$var$V.get(b), void 0 === c) $277dfbc9b64034b1$var$V.set(b, a);
        else {
            for(b = c; null !== b.next;)b = b.next;
            b.next = a;
        }
    }
}
function $277dfbc9b64034b1$var$Lc() {
    throw Error($277dfbc9b64034b1$var$k(394));
}
function $277dfbc9b64034b1$var$Mc() {}
var $277dfbc9b64034b1$var$Oc = {
    readContext: function(a) {
        return a._currentValue;
    },
    useContext: function(a) {
        $277dfbc9b64034b1$var$W();
        return a._currentValue;
    },
    useMemo: $277dfbc9b64034b1$var$Kc,
    useReducer: $277dfbc9b64034b1$var$Ic,
    useRef: function(a) {
        $277dfbc9b64034b1$var$R = $277dfbc9b64034b1$var$W();
        $277dfbc9b64034b1$var$S = $277dfbc9b64034b1$var$Fc();
        var b = $277dfbc9b64034b1$var$S.memoizedState;
        return null === b ? (a = {
            current: a
        }, $277dfbc9b64034b1$var$S.memoizedState = a) : b;
    },
    useState: function(a) {
        return $277dfbc9b64034b1$var$Ic($277dfbc9b64034b1$var$Hc, a);
    },
    useInsertionEffect: $277dfbc9b64034b1$var$Mc,
    useLayoutEffect: function() {},
    useCallback: function(a, b) {
        return $277dfbc9b64034b1$var$Kc(function() {
            return a;
        }, b);
    },
    useImperativeHandle: $277dfbc9b64034b1$var$Mc,
    useEffect: $277dfbc9b64034b1$var$Mc,
    useDebugValue: $277dfbc9b64034b1$var$Mc,
    useDeferredValue: function(a) {
        $277dfbc9b64034b1$var$W();
        return a;
    },
    useTransition: function() {
        $277dfbc9b64034b1$var$W();
        return [
            !1,
            $277dfbc9b64034b1$var$Lc
        ];
    },
    useId: function() {
        var a = $277dfbc9b64034b1$var$Ac.treeContext;
        var b = a.overflow;
        a = a.id;
        a = (a & ~(1 << 32 - $277dfbc9b64034b1$var$uc(a) - 1)).toString(32) + b;
        var c = $277dfbc9b64034b1$var$Nc;
        if (null === c) throw Error($277dfbc9b64034b1$var$k(404));
        b = $277dfbc9b64034b1$var$U++;
        a = ":" + c.idPrefix + "R" + a;
        0 < b && (a += "H" + b.toString(32));
        return a + ":";
    },
    useMutableSource: function(a, b) {
        $277dfbc9b64034b1$var$W();
        return b(a._source);
    },
    useSyncExternalStore: function(a, b, c) {
        if (void 0 === c) throw Error($277dfbc9b64034b1$var$k(407));
        return c();
    }
}, $277dfbc9b64034b1$var$Nc = null, $277dfbc9b64034b1$var$Pc = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentDispatcher;
function $277dfbc9b64034b1$var$Qc(a) {
    console.error(a);
    return null;
}
function $277dfbc9b64034b1$var$X() {}
function $277dfbc9b64034b1$var$Rc(a, b, c, d, f, e, g, h, m) {
    var q = [], r = new Set;
    b = {
        destination: null,
        responseState: b,
        progressiveChunkSize: void 0 === d ? 12800 : d,
        status: 0,
        fatalError: null,
        nextSegmentId: 0,
        allPendingTasks: 0,
        pendingRootTasks: 0,
        completedRootSegment: null,
        abortableTasks: r,
        pingedTasks: q,
        clientRenderedBoundaries: [],
        completedBoundaries: [],
        partialBoundaries: [],
        onError: void 0 === f ? $277dfbc9b64034b1$var$Qc : f,
        onAllReady: void 0 === e ? $277dfbc9b64034b1$var$X : e,
        onShellReady: void 0 === g ? $277dfbc9b64034b1$var$X : g,
        onShellError: void 0 === h ? $277dfbc9b64034b1$var$X : h,
        onFatalError: void 0 === m ? $277dfbc9b64034b1$var$X : m
    };
    c = $277dfbc9b64034b1$var$Sc(b, 0, null, c, !1, !1);
    c.parentFlushed = !0;
    a = $277dfbc9b64034b1$var$Tc(b, a, null, c, r, $277dfbc9b64034b1$var$kc, null, $277dfbc9b64034b1$var$sc);
    q.push(a);
    return b;
}
function $277dfbc9b64034b1$var$Tc(a, b, c, d, f, e, g, h) {
    a.allPendingTasks++;
    null === c ? a.pendingRootTasks++ : c.pendingTasks++;
    var m = {
        node: b,
        ping: function() {
            var b = a.pingedTasks;
            b.push(m);
            1 === b.length && $277dfbc9b64034b1$var$Uc(a);
        },
        blockedBoundary: c,
        blockedSegment: d,
        abortSet: f,
        legacyContext: e,
        context: g,
        treeContext: h
    };
    f.add(m);
    return m;
}
function $277dfbc9b64034b1$var$Sc(a, b, c, d, f, e) {
    return {
        status: 0,
        id: -1,
        index: b,
        parentFlushed: !1,
        chunks: [],
        children: [],
        formatContext: d,
        boundary: c,
        lastPushedText: f,
        textEmbedded: e
    };
}
function $277dfbc9b64034b1$var$Y(a, b) {
    a = a.onError(b);
    if (null != a && "string" !== typeof a) throw Error('onError returned something with a type other than "string". onError should return a string and may return null or undefined but must not return anything else. It received something of type "' + typeof a + '" instead');
    return a;
}
function $277dfbc9b64034b1$var$Vc(a, b) {
    var c = a.onShellError;
    c(b);
    c = a.onFatalError;
    c(b);
    null !== a.destination ? (a.status = 2, $277dfbc9b64034b1$var$da(a.destination, b)) : (a.status = 1, a.fatalError = b);
}
function $277dfbc9b64034b1$var$Wc(a, b, c, d, f) {
    $277dfbc9b64034b1$var$R = {};
    $277dfbc9b64034b1$var$Ac = b;
    $277dfbc9b64034b1$var$U = 0;
    for(a = c(d, f); $277dfbc9b64034b1$var$Cc;)$277dfbc9b64034b1$var$Cc = !1, $277dfbc9b64034b1$var$U = 0, $277dfbc9b64034b1$var$Dc += 1, $277dfbc9b64034b1$var$S = null, a = c(d, f);
    $277dfbc9b64034b1$var$Gc();
    return a;
}
function $277dfbc9b64034b1$var$Xc(a, b, c, d) {
    var f = c.render(), e = d.childContextTypes;
    if (null !== e && void 0 !== e) {
        var g = b.legacyContext;
        if ("function" !== typeof c.getChildContext) d = g;
        else {
            c = c.getChildContext();
            for(var h in c)if (!(h in e)) throw Error($277dfbc9b64034b1$var$k(108, $277dfbc9b64034b1$var$jc(d) || "Unknown", h));
            d = $277dfbc9b64034b1$var$N({}, g, c);
        }
        b.legacyContext = d;
        $277dfbc9b64034b1$var$Z(a, b, f);
        b.legacyContext = g;
    } else $277dfbc9b64034b1$var$Z(a, b, f);
}
function $277dfbc9b64034b1$var$Yc(a, b) {
    if (a && a.defaultProps) {
        b = $277dfbc9b64034b1$var$N({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $277dfbc9b64034b1$var$Zc(a, b, c, d, f) {
    if ("function" === typeof c) {
        if (c.prototype && c.prototype.isReactComponent) {
            f = $277dfbc9b64034b1$var$lc(c, b.legacyContext);
            var e = c.contextType;
            e = new c(d, "object" === typeof e && null !== e ? e._currentValue : f);
            $277dfbc9b64034b1$var$rc(e, c, d, f);
            $277dfbc9b64034b1$var$Xc(a, b, e, c);
        } else {
            e = $277dfbc9b64034b1$var$lc(c, b.legacyContext);
            f = $277dfbc9b64034b1$var$Wc(a, b, c, d, e);
            var g = 0 !== $277dfbc9b64034b1$var$U;
            if ("object" === typeof f && null !== f && "function" === typeof f.render && void 0 === f.$$typeof) $277dfbc9b64034b1$var$rc(f, c, d, e), $277dfbc9b64034b1$var$Xc(a, b, f, c);
            else if (g) {
                d = b.treeContext;
                b.treeContext = $277dfbc9b64034b1$var$tc(d, 1, 0);
                try {
                    $277dfbc9b64034b1$var$Z(a, b, f);
                } finally{
                    b.treeContext = d;
                }
            } else $277dfbc9b64034b1$var$Z(a, b, f);
        }
    } else if ("string" === typeof c) {
        f = b.blockedSegment;
        e = $277dfbc9b64034b1$var$Sa(f.chunks, c, d, a.responseState, f.formatContext);
        f.lastPushedText = !1;
        g = f.formatContext;
        f.formatContext = $277dfbc9b64034b1$var$Ba(g, c, d);
        $277dfbc9b64034b1$var$$c(a, b, e);
        f.formatContext = g;
        switch(c){
            case "area":
            case "base":
            case "br":
            case "col":
            case "embed":
            case "hr":
            case "img":
            case "input":
            case "keygen":
            case "link":
            case "meta":
            case "param":
            case "source":
            case "track":
            case "wbr":
                break;
            default:
                f.chunks.push($277dfbc9b64034b1$var$Ta, $277dfbc9b64034b1$var$u(c), $277dfbc9b64034b1$var$Ua);
        }
        f.lastPushedText = !1;
    } else {
        switch(c){
            case $277dfbc9b64034b1$var$gc:
            case $277dfbc9b64034b1$var$fc:
            case $277dfbc9b64034b1$var$Wb:
            case $277dfbc9b64034b1$var$Xb:
            case $277dfbc9b64034b1$var$Vb:
                $277dfbc9b64034b1$var$Z(a, b, d.children);
                return;
            case $277dfbc9b64034b1$var$bc:
                $277dfbc9b64034b1$var$Z(a, b, d.children);
                return;
            case $277dfbc9b64034b1$var$ec:
                throw Error($277dfbc9b64034b1$var$k(343));
            case $277dfbc9b64034b1$var$ac:
                a: {
                    c = b.blockedBoundary;
                    f = b.blockedSegment;
                    e = d.fallback;
                    d = d.children;
                    g = new Set;
                    var h = {
                        id: null,
                        rootSegmentID: -1,
                        parentFlushed: !1,
                        pendingTasks: 0,
                        forceClientRender: !1,
                        completedSegments: [],
                        byteSize: 0,
                        fallbackAbortableTasks: g,
                        errorDigest: null
                    }, m = $277dfbc9b64034b1$var$Sc(a, f.chunks.length, h, f.formatContext, !1, !1);
                    f.children.push(m);
                    f.lastPushedText = !1;
                    var q = $277dfbc9b64034b1$var$Sc(a, 0, null, f.formatContext, !1, !1);
                    q.parentFlushed = !0;
                    b.blockedBoundary = h;
                    b.blockedSegment = q;
                    try {
                        if ($277dfbc9b64034b1$var$$c(a, b, d), q.lastPushedText && q.textEmbedded && q.chunks.push($277dfbc9b64034b1$var$Ca), q.status = 1, $277dfbc9b64034b1$var$ad(h, q), 0 === h.pendingTasks) break a;
                    } catch (r) {
                        q.status = 4, h.forceClientRender = !0, h.errorDigest = $277dfbc9b64034b1$var$Y(a, r);
                    } finally{
                        b.blockedBoundary = c, b.blockedSegment = f;
                    }
                    b = $277dfbc9b64034b1$var$Tc(a, e, c, m, g, b.legacyContext, b.context, b.treeContext);
                    a.pingedTasks.push(b);
                }
                return;
        }
        if ("object" === typeof c && null !== c) switch(c.$$typeof){
            case $277dfbc9b64034b1$var$$b:
                d = $277dfbc9b64034b1$var$Wc(a, b, c.render, d, f);
                if (0 !== $277dfbc9b64034b1$var$U) {
                    c = b.treeContext;
                    b.treeContext = $277dfbc9b64034b1$var$tc(c, 1, 0);
                    try {
                        $277dfbc9b64034b1$var$Z(a, b, d);
                    } finally{
                        b.treeContext = c;
                    }
                } else $277dfbc9b64034b1$var$Z(a, b, d);
                return;
            case $277dfbc9b64034b1$var$cc:
                c = c.type;
                d = $277dfbc9b64034b1$var$Yc(c, d);
                $277dfbc9b64034b1$var$Zc(a, b, c, d, f);
                return;
            case $277dfbc9b64034b1$var$Yb:
                f = d.children;
                c = c._context;
                d = d.value;
                e = c._currentValue;
                c._currentValue = d;
                g = $277dfbc9b64034b1$var$O;
                $277dfbc9b64034b1$var$O = d = {
                    parent: g,
                    depth: null === g ? 0 : g.depth + 1,
                    context: c,
                    parentValue: e,
                    value: d
                };
                b.context = d;
                $277dfbc9b64034b1$var$Z(a, b, f);
                a = $277dfbc9b64034b1$var$O;
                if (null === a) throw Error($277dfbc9b64034b1$var$k(403));
                d = a.parentValue;
                a.context._currentValue = d === $277dfbc9b64034b1$var$hc ? a.context._defaultValue : d;
                a = $277dfbc9b64034b1$var$O = a.parent;
                b.context = a;
                return;
            case $277dfbc9b64034b1$var$Zb:
                d = d.children;
                d = d(c._currentValue);
                $277dfbc9b64034b1$var$Z(a, b, d);
                return;
            case $277dfbc9b64034b1$var$dc:
                f = c._init;
                c = f(c._payload);
                d = $277dfbc9b64034b1$var$Yc(c, d);
                $277dfbc9b64034b1$var$Zc(a, b, c, d, void 0);
                return;
        }
        throw Error($277dfbc9b64034b1$var$k(130, null == c ? c : typeof c, ""));
    }
}
function $277dfbc9b64034b1$var$Z(a, b, c) {
    b.node = c;
    if ("object" === typeof c && null !== c) {
        switch(c.$$typeof){
            case $277dfbc9b64034b1$var$Tb:
                $277dfbc9b64034b1$var$Zc(a, b, c.type, c.props, c.ref);
                return;
            case $277dfbc9b64034b1$var$Ub:
                throw Error($277dfbc9b64034b1$var$k(257));
            case $277dfbc9b64034b1$var$dc:
                var d = c._init;
                c = d(c._payload);
                $277dfbc9b64034b1$var$Z(a, b, c);
                return;
        }
        if ($277dfbc9b64034b1$var$ra(c)) {
            $277dfbc9b64034b1$var$bd(a, b, c);
            return;
        }
        null === c || "object" !== typeof c ? d = null : (d = $277dfbc9b64034b1$var$ic && c[$277dfbc9b64034b1$var$ic] || c["@@iterator"], d = "function" === typeof d ? d : null);
        if (d && (d = d.call(c))) {
            c = d.next();
            if (!c.done) {
                var f = [];
                do f.push(c.value), c = d.next();
                while (!c.done);
                $277dfbc9b64034b1$var$bd(a, b, f);
            }
            return;
        }
        a = Object.prototype.toString.call(c);
        throw Error($277dfbc9b64034b1$var$k(31, "[object Object]" === a ? "object with keys {" + Object.keys(c).join(", ") + "}" : a));
    }
    "string" === typeof c ? (d = b.blockedSegment, d.lastPushedText = $277dfbc9b64034b1$var$Da(b.blockedSegment.chunks, c, a.responseState, d.lastPushedText)) : "number" === typeof c && (d = b.blockedSegment, d.lastPushedText = $277dfbc9b64034b1$var$Da(b.blockedSegment.chunks, "" + c, a.responseState, d.lastPushedText));
}
function $277dfbc9b64034b1$var$bd(a, b, c) {
    for(var d = c.length, f = 0; f < d; f++){
        var e = b.treeContext;
        b.treeContext = $277dfbc9b64034b1$var$tc(e, d, f);
        try {
            $277dfbc9b64034b1$var$$c(a, b, c[f]);
        } finally{
            b.treeContext = e;
        }
    }
}
function $277dfbc9b64034b1$var$$c(a, b, c) {
    var d = b.blockedSegment.formatContext, f = b.legacyContext, e = b.context;
    try {
        return $277dfbc9b64034b1$var$Z(a, b, c);
    } catch (m) {
        if ($277dfbc9b64034b1$var$Gc(), "object" === typeof m && null !== m && "function" === typeof m.then) {
            c = m;
            var g = b.blockedSegment, h = $277dfbc9b64034b1$var$Sc(a, g.chunks.length, null, g.formatContext, g.lastPushedText, !0);
            g.children.push(h);
            g.lastPushedText = !1;
            a = $277dfbc9b64034b1$var$Tc(a, b.node, b.blockedBoundary, h, b.abortSet, b.legacyContext, b.context, b.treeContext).ping;
            c.then(a, a);
            b.blockedSegment.formatContext = d;
            b.legacyContext = f;
            b.context = e;
            $277dfbc9b64034b1$var$Q(e);
        } else throw b.blockedSegment.formatContext = d, b.legacyContext = f, b.context = e, $277dfbc9b64034b1$var$Q(e), m;
    }
}
function $277dfbc9b64034b1$var$cd(a) {
    var b = a.blockedBoundary;
    a = a.blockedSegment;
    a.status = 3;
    $277dfbc9b64034b1$var$dd(this, b, a);
}
function $277dfbc9b64034b1$var$ed(a, b, c) {
    var d = a.blockedBoundary;
    a.blockedSegment.status = 3;
    null === d ? (b.allPendingTasks--, 2 !== b.status && (b.status = 2, null !== b.destination && b.destination.close())) : (d.pendingTasks--, d.forceClientRender || (d.forceClientRender = !0, a = void 0 === c ? Error($277dfbc9b64034b1$var$k(432)) : c, d.errorDigest = b.onError(a), d.parentFlushed && b.clientRenderedBoundaries.push(d)), d.fallbackAbortableTasks.forEach(function(a) {
        return $277dfbc9b64034b1$var$ed(a, b, c);
    }), d.fallbackAbortableTasks.clear(), b.allPendingTasks--, 0 === b.allPendingTasks && (d = b.onAllReady, d()));
}
function $277dfbc9b64034b1$var$ad(a, b) {
    if (0 === b.chunks.length && 1 === b.children.length && null === b.children[0].boundary) {
        var c = b.children[0];
        c.id = b.id;
        c.parentFlushed = !0;
        1 === c.status && $277dfbc9b64034b1$var$ad(a, c);
    } else a.completedSegments.push(b);
}
function $277dfbc9b64034b1$var$dd(a, b, c) {
    if (null === b) {
        if (c.parentFlushed) {
            if (null !== a.completedRootSegment) throw Error($277dfbc9b64034b1$var$k(389));
            a.completedRootSegment = c;
        }
        a.pendingRootTasks--;
        0 === a.pendingRootTasks && (a.onShellError = $277dfbc9b64034b1$var$X, b = a.onShellReady, b());
    } else b.pendingTasks--, b.forceClientRender || (0 === b.pendingTasks ? (c.parentFlushed && 1 === c.status && $277dfbc9b64034b1$var$ad(b, c), b.parentFlushed && a.completedBoundaries.push(b), b.fallbackAbortableTasks.forEach($277dfbc9b64034b1$var$cd, a), b.fallbackAbortableTasks.clear()) : c.parentFlushed && 1 === c.status && ($277dfbc9b64034b1$var$ad(b, c), 1 === b.completedSegments.length && b.parentFlushed && a.partialBoundaries.push(b)));
    a.allPendingTasks--;
    0 === a.allPendingTasks && (a = a.onAllReady, a());
}
function $277dfbc9b64034b1$var$Uc(a) {
    if (2 !== a.status) {
        var b = $277dfbc9b64034b1$var$O, c = $277dfbc9b64034b1$var$Pc.current;
        $277dfbc9b64034b1$var$Pc.current = $277dfbc9b64034b1$var$Oc;
        var d = $277dfbc9b64034b1$var$Nc;
        $277dfbc9b64034b1$var$Nc = a.responseState;
        try {
            var f = a.pingedTasks, e;
            for(e = 0; e < f.length; e++){
                var g = f[e];
                var h = a, m = g.blockedSegment;
                if (0 === m.status) {
                    $277dfbc9b64034b1$var$Q(g.context);
                    try {
                        $277dfbc9b64034b1$var$Z(h, g, g.node), m.lastPushedText && m.textEmbedded && m.chunks.push($277dfbc9b64034b1$var$Ca), g.abortSet.delete(g), m.status = 1, $277dfbc9b64034b1$var$dd(h, g.blockedBoundary, m);
                    } catch (G) {
                        if ($277dfbc9b64034b1$var$Gc(), "object" === typeof G && null !== G && "function" === typeof G.then) {
                            var q = g.ping;
                            G.then(q, q);
                        } else {
                            g.abortSet.delete(g);
                            m.status = 4;
                            var r = g.blockedBoundary, v = G, A = $277dfbc9b64034b1$var$Y(h, v);
                            null === r ? $277dfbc9b64034b1$var$Vc(h, v) : (r.pendingTasks--, r.forceClientRender || (r.forceClientRender = !0, r.errorDigest = A, r.parentFlushed && h.clientRenderedBoundaries.push(r)));
                            h.allPendingTasks--;
                            if (0 === h.allPendingTasks) {
                                var F = h.onAllReady;
                                F();
                            }
                        }
                    } finally{}
                }
            }
            f.splice(0, e);
            null !== a.destination && $277dfbc9b64034b1$var$fd(a, a.destination);
        } catch (G) {
            $277dfbc9b64034b1$var$Y(a, G), $277dfbc9b64034b1$var$Vc(a, G);
        } finally{
            $277dfbc9b64034b1$var$Nc = d, $277dfbc9b64034b1$var$Pc.current = c, c === $277dfbc9b64034b1$var$Oc && $277dfbc9b64034b1$var$Q(b);
        }
    }
}
function $277dfbc9b64034b1$var$gd(a, b, c) {
    c.parentFlushed = !0;
    switch(c.status){
        case 0:
            var d = c.id = a.nextSegmentId++;
            c.lastPushedText = !1;
            c.textEmbedded = !1;
            a = a.responseState;
            $277dfbc9b64034b1$var$p(b, $277dfbc9b64034b1$var$Va);
            $277dfbc9b64034b1$var$p(b, a.placeholderPrefix);
            a = $277dfbc9b64034b1$var$u(d.toString(16));
            $277dfbc9b64034b1$var$p(b, a);
            return $277dfbc9b64034b1$var$t(b, $277dfbc9b64034b1$var$Wa);
        case 1:
            c.status = 2;
            var f = !0;
            d = c.chunks;
            var e = 0;
            c = c.children;
            for(var g = 0; g < c.length; g++){
                for(f = c[g]; e < f.index; e++)$277dfbc9b64034b1$var$p(b, d[e]);
                f = $277dfbc9b64034b1$var$hd(a, b, f);
            }
            for(; e < d.length - 1; e++)$277dfbc9b64034b1$var$p(b, d[e]);
            e < d.length && (f = $277dfbc9b64034b1$var$t(b, d[e]));
            return f;
        default:
            throw Error($277dfbc9b64034b1$var$k(390));
    }
}
function $277dfbc9b64034b1$var$hd(a, b, c) {
    var d = c.boundary;
    if (null === d) return $277dfbc9b64034b1$var$gd(a, b, c);
    d.parentFlushed = !0;
    if (d.forceClientRender) d = d.errorDigest, $277dfbc9b64034b1$var$t(b, $277dfbc9b64034b1$var$$a), $277dfbc9b64034b1$var$p(b, $277dfbc9b64034b1$var$bb), d && ($277dfbc9b64034b1$var$p(b, $277dfbc9b64034b1$var$db), $277dfbc9b64034b1$var$p(b, $277dfbc9b64034b1$var$u($277dfbc9b64034b1$var$C(d))), $277dfbc9b64034b1$var$p(b, $277dfbc9b64034b1$var$cb)), $277dfbc9b64034b1$var$t(b, $277dfbc9b64034b1$var$eb), $277dfbc9b64034b1$var$gd(a, b, c);
    else if (0 < d.pendingTasks) {
        d.rootSegmentID = a.nextSegmentId++;
        0 < d.completedSegments.length && a.partialBoundaries.push(d);
        var f = a.responseState;
        var e = f.nextSuspenseID++;
        f = $277dfbc9b64034b1$var$w(f.boundaryPrefix + e.toString(16));
        d = d.id = f;
        $277dfbc9b64034b1$var$fb(b, a.responseState, d);
        $277dfbc9b64034b1$var$gd(a, b, c);
    } else if (d.byteSize > a.progressiveChunkSize) d.rootSegmentID = a.nextSegmentId++, a.completedBoundaries.push(d), $277dfbc9b64034b1$var$fb(b, a.responseState, d.id), $277dfbc9b64034b1$var$gd(a, b, c);
    else {
        $277dfbc9b64034b1$var$t(b, $277dfbc9b64034b1$var$Xa);
        c = d.completedSegments;
        if (1 !== c.length) throw Error($277dfbc9b64034b1$var$k(391));
        $277dfbc9b64034b1$var$hd(a, b, c[0]);
    }
    return $277dfbc9b64034b1$var$t(b, $277dfbc9b64034b1$var$ab);
}
function $277dfbc9b64034b1$var$id(a, b, c) {
    $277dfbc9b64034b1$var$Bb(b, a.responseState, c.formatContext, c.id);
    $277dfbc9b64034b1$var$hd(a, b, c);
    return $277dfbc9b64034b1$var$Cb(b, c.formatContext);
}
function $277dfbc9b64034b1$var$jd(a, b, c) {
    for(var d = c.completedSegments, f = 0; f < d.length; f++)$277dfbc9b64034b1$var$kd(a, b, c, d[f]);
    d.length = 0;
    a = a.responseState;
    d = c.id;
    c = c.rootSegmentID;
    $277dfbc9b64034b1$var$p(b, a.startInlineScript);
    a.sentCompleteBoundaryFunction ? $277dfbc9b64034b1$var$p(b, $277dfbc9b64034b1$var$Jb) : (a.sentCompleteBoundaryFunction = !0, $277dfbc9b64034b1$var$p(b, $277dfbc9b64034b1$var$Ib));
    if (null === d) throw Error($277dfbc9b64034b1$var$k(395));
    c = $277dfbc9b64034b1$var$u(c.toString(16));
    $277dfbc9b64034b1$var$p(b, d);
    $277dfbc9b64034b1$var$p(b, $277dfbc9b64034b1$var$Kb);
    $277dfbc9b64034b1$var$p(b, a.segmentPrefix);
    $277dfbc9b64034b1$var$p(b, c);
    return $277dfbc9b64034b1$var$t(b, $277dfbc9b64034b1$var$Lb);
}
function $277dfbc9b64034b1$var$kd(a, b, c, d) {
    if (2 === d.status) return !0;
    var f = d.id;
    if (-1 === f) {
        if (-1 === (d.id = c.rootSegmentID)) throw Error($277dfbc9b64034b1$var$k(392));
        return $277dfbc9b64034b1$var$id(a, b, d);
    }
    $277dfbc9b64034b1$var$id(a, b, d);
    a = a.responseState;
    $277dfbc9b64034b1$var$p(b, a.startInlineScript);
    a.sentCompleteSegmentFunction ? $277dfbc9b64034b1$var$p(b, $277dfbc9b64034b1$var$Eb) : (a.sentCompleteSegmentFunction = !0, $277dfbc9b64034b1$var$p(b, $277dfbc9b64034b1$var$Db));
    $277dfbc9b64034b1$var$p(b, a.segmentPrefix);
    f = $277dfbc9b64034b1$var$u(f.toString(16));
    $277dfbc9b64034b1$var$p(b, f);
    $277dfbc9b64034b1$var$p(b, $277dfbc9b64034b1$var$Gb);
    $277dfbc9b64034b1$var$p(b, a.placeholderPrefix);
    $277dfbc9b64034b1$var$p(b, f);
    return $277dfbc9b64034b1$var$t(b, $277dfbc9b64034b1$var$Hb);
}
function $277dfbc9b64034b1$var$fd(a, b) {
    $277dfbc9b64034b1$var$l = new Uint8Array(512);
    $277dfbc9b64034b1$var$n = 0;
    try {
        var c = a.completedRootSegment;
        if (null !== c && 0 === a.pendingRootTasks) {
            $277dfbc9b64034b1$var$hd(a, b, c);
            a.completedRootSegment = null;
            var d = a.responseState.bootstrapChunks;
            for(c = 0; c < d.length - 1; c++)$277dfbc9b64034b1$var$p(b, d[c]);
            c < d.length && $277dfbc9b64034b1$var$t(b, d[c]);
        }
        var f = a.clientRenderedBoundaries, e;
        for(e = 0; e < f.length; e++){
            var g = f[e];
            d = b;
            var h = a.responseState, m = g.id, q = g.errorDigest, r = g.errorMessage, v = g.errorComponentStack;
            $277dfbc9b64034b1$var$p(d, h.startInlineScript);
            h.sentClientRenderFunction ? $277dfbc9b64034b1$var$p(d, $277dfbc9b64034b1$var$Nb) : (h.sentClientRenderFunction = !0, $277dfbc9b64034b1$var$p(d, $277dfbc9b64034b1$var$Mb));
            if (null === m) throw Error($277dfbc9b64034b1$var$k(395));
            $277dfbc9b64034b1$var$p(d, m);
            $277dfbc9b64034b1$var$p(d, $277dfbc9b64034b1$var$Ob);
            if (q || r || v) $277dfbc9b64034b1$var$p(d, $277dfbc9b64034b1$var$Qb), $277dfbc9b64034b1$var$p(d, $277dfbc9b64034b1$var$u($277dfbc9b64034b1$var$Sb(q || "")));
            if (r || v) $277dfbc9b64034b1$var$p(d, $277dfbc9b64034b1$var$Qb), $277dfbc9b64034b1$var$p(d, $277dfbc9b64034b1$var$u($277dfbc9b64034b1$var$Sb(r || "")));
            v && ($277dfbc9b64034b1$var$p(d, $277dfbc9b64034b1$var$Qb), $277dfbc9b64034b1$var$p(d, $277dfbc9b64034b1$var$u($277dfbc9b64034b1$var$Sb(v))));
            if (!$277dfbc9b64034b1$var$t(d, $277dfbc9b64034b1$var$Pb)) {
                a.destination = null;
                e++;
                f.splice(0, e);
                return;
            }
        }
        f.splice(0, e);
        var A = a.completedBoundaries;
        for(e = 0; e < A.length; e++)if (!$277dfbc9b64034b1$var$jd(a, b, A[e])) {
            a.destination = null;
            e++;
            A.splice(0, e);
            return;
        }
        A.splice(0, e);
        $277dfbc9b64034b1$var$ba(b);
        $277dfbc9b64034b1$var$l = new Uint8Array(512);
        $277dfbc9b64034b1$var$n = 0;
        var F = a.partialBoundaries;
        for(e = 0; e < F.length; e++){
            var G = F[e];
            a: {
                f = a;
                g = b;
                var ma = G.completedSegments;
                for(h = 0; h < ma.length; h++)if (!$277dfbc9b64034b1$var$kd(f, g, G, ma[h])) {
                    h++;
                    ma.splice(0, h);
                    var Fb = !1;
                    break a;
                }
                ma.splice(0, h);
                Fb = !0;
            }
            if (!Fb) {
                a.destination = null;
                e++;
                F.splice(0, e);
                return;
            }
        }
        F.splice(0, e);
        var na = a.completedBoundaries;
        for(e = 0; e < na.length; e++)if (!$277dfbc9b64034b1$var$jd(a, b, na[e])) {
            a.destination = null;
            e++;
            na.splice(0, e);
            return;
        }
        na.splice(0, e);
    } finally{
        $277dfbc9b64034b1$var$ba(b), 0 === a.allPendingTasks && 0 === a.pingedTasks.length && 0 === a.clientRenderedBoundaries.length && 0 === a.completedBoundaries.length && b.close();
    }
}
function $277dfbc9b64034b1$var$ld(a, b) {
    try {
        var c = a.abortableTasks;
        c.forEach(function(c) {
            return $277dfbc9b64034b1$var$ed(c, a, b);
        });
        c.clear();
        null !== a.destination && $277dfbc9b64034b1$var$fd(a, a.destination);
    } catch (d) {
        $277dfbc9b64034b1$var$Y(a, d), $277dfbc9b64034b1$var$Vc(a, d);
    }
}
$277dfbc9b64034b1$export$7020a3240b287705 = function(a, b) {
    return new Promise(function(c, d) {
        var f, e, g = new Promise(function(a, b) {
            e = a;
            f = b;
        }), h = $277dfbc9b64034b1$var$Rc(a, $277dfbc9b64034b1$var$za(b ? b.identifierPrefix : void 0, b ? b.nonce : void 0, b ? b.bootstrapScriptContent : void 0, b ? b.bootstrapScripts : void 0, b ? b.bootstrapModules : void 0), $277dfbc9b64034b1$var$Aa(b ? b.namespaceURI : void 0), b ? b.progressiveChunkSize : void 0, b ? b.onError : void 0, e, function() {
            var a = new ReadableStream({
                type: "bytes",
                pull: function(a) {
                    if (1 === h.status) h.status = 2, $277dfbc9b64034b1$var$da(a, h.fatalError);
                    else if (2 !== h.status && null === h.destination) {
                        h.destination = a;
                        try {
                            $277dfbc9b64034b1$var$fd(h, a);
                        } catch (A) {
                            $277dfbc9b64034b1$var$Y(h, A), $277dfbc9b64034b1$var$Vc(h, A);
                        }
                    }
                },
                cancel: function() {
                    $277dfbc9b64034b1$var$ld(h);
                }
            }, {
                highWaterMark: 0
            });
            a.allReady = g;
            c(a);
        }, function(a) {
            g.catch(function() {});
            d(a);
        }, f);
        if (b && b.signal) {
            var m = b.signal, q = function() {
                $277dfbc9b64034b1$var$ld(h, m.reason);
                m.removeEventListener("abort", q);
            };
            m.addEventListener("abort", q);
        }
        $277dfbc9b64034b1$var$Uc(h);
    });
};
$277dfbc9b64034b1$export$83d89fbfd8236492 = "18.2.0";

});

var $7b02d682eb115277$exports = {};
"use strict";

$7b02d682eb115277$exports = (parcelRequire("1b2ls"));



var $acw62 = parcelRequire("acw62");
var $7e96a608cb33bf79$exports = {};

$parcel$export($7e96a608cb33bf79$exports, "createRoot", () => $7e96a608cb33bf79$export$882461b6382ed46c, (v) => $7e96a608cb33bf79$export$882461b6382ed46c = v);
$parcel$export($7e96a608cb33bf79$exports, "hydrateRoot", () => $7e96a608cb33bf79$export$757ceba2d55c277e, (v) => $7e96a608cb33bf79$export$757ceba2d55c277e = v);
var $7e96a608cb33bf79$export$882461b6382ed46c;
var $7e96a608cb33bf79$export$757ceba2d55c277e;
"use strict";
var $11492dca620dcaa5$exports = {};
"use strict";
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

$11492dca620dcaa5$exports = (parcelRequire("Xw6Mv"));


var $7e96a608cb33bf79$var$i;
$7e96a608cb33bf79$export$882461b6382ed46c = $11492dca620dcaa5$exports.createRoot;
$7e96a608cb33bf79$export$757ceba2d55c277e = $11492dca620dcaa5$exports.hydrateRoot;


var $d8206b3ab2e65c05$exports = {};

$parcel$export($d8206b3ab2e65c05$exports, "prefix", () => $d8206b3ab2e65c05$export$82e9f45cca5ba907);
$parcel$export($d8206b3ab2e65c05$exports, "fa0", () => $d8206b3ab2e65c05$export$f22454595d96c106);
$parcel$export($d8206b3ab2e65c05$exports, "fa1", () => $d8206b3ab2e65c05$export$8398cb2addc9e182);
$parcel$export($d8206b3ab2e65c05$exports, "fa2", () => $d8206b3ab2e65c05$export$ed1a0ff7bd680a1d);
$parcel$export($d8206b3ab2e65c05$exports, "fa3", () => $d8206b3ab2e65c05$export$74b7ff79ce1818d6);
$parcel$export($d8206b3ab2e65c05$exports, "fa4", () => $d8206b3ab2e65c05$export$969b2215780d58fd);
$parcel$export($d8206b3ab2e65c05$exports, "fa5", () => $d8206b3ab2e65c05$export$3919f68a5b3825a9);
$parcel$export($d8206b3ab2e65c05$exports, "fa6", () => $d8206b3ab2e65c05$export$580ac17b31ffb5c3);
$parcel$export($d8206b3ab2e65c05$exports, "fa7", () => $d8206b3ab2e65c05$export$ee79cab31be16d23);
$parcel$export($d8206b3ab2e65c05$exports, "fa8", () => $d8206b3ab2e65c05$export$45d84c4b2c560d2f);
$parcel$export($d8206b3ab2e65c05$exports, "fa9", () => $d8206b3ab2e65c05$export$a120f1e4223629f2);
$parcel$export($d8206b3ab2e65c05$exports, "faFillDrip", () => $d8206b3ab2e65c05$export$38320138fc0262d0);
$parcel$export($d8206b3ab2e65c05$exports, "faArrowsToCircle", () => $d8206b3ab2e65c05$export$917a3d30f6cd766);
$parcel$export($d8206b3ab2e65c05$exports, "faCircleChevronRight", () => $d8206b3ab2e65c05$export$a39bab13d51abfd0);
$parcel$export($d8206b3ab2e65c05$exports, "faChevronCircleRight", () => $d8206b3ab2e65c05$export$2a5db4f6eba6f2b);
$parcel$export($d8206b3ab2e65c05$exports, "faAt", () => $d8206b3ab2e65c05$export$c115e8063ee02632);
$parcel$export($d8206b3ab2e65c05$exports, "faTrashCan", () => $d8206b3ab2e65c05$export$864bb8d6c21fb792);
$parcel$export($d8206b3ab2e65c05$exports, "faTrashAlt", () => $d8206b3ab2e65c05$export$88df7ff7eb32f9dc);
$parcel$export($d8206b3ab2e65c05$exports, "faTextHeight", () => $d8206b3ab2e65c05$export$3313bce3924ea7da);
$parcel$export($d8206b3ab2e65c05$exports, "faUserXmark", () => $d8206b3ab2e65c05$export$e585697127cda27);
$parcel$export($d8206b3ab2e65c05$exports, "faUserTimes", () => $d8206b3ab2e65c05$export$45b996d071667753);
$parcel$export($d8206b3ab2e65c05$exports, "faStethoscope", () => $d8206b3ab2e65c05$export$acb2d72d28cd92d9);
$parcel$export($d8206b3ab2e65c05$exports, "faMessage", () => $d8206b3ab2e65c05$export$6563a67224e7f879);
$parcel$export($d8206b3ab2e65c05$exports, "faCommentAlt", () => $d8206b3ab2e65c05$export$6e96904d9af0ec4a);
$parcel$export($d8206b3ab2e65c05$exports, "faInfo", () => $d8206b3ab2e65c05$export$d469b770895f47ac);
$parcel$export($d8206b3ab2e65c05$exports, "faDownLeftAndUpRightToCenter", () => $d8206b3ab2e65c05$export$d56736f5800b3f0d);
$parcel$export($d8206b3ab2e65c05$exports, "faCompressAlt", () => $d8206b3ab2e65c05$export$a05650ebe54bede);
$parcel$export($d8206b3ab2e65c05$exports, "faExplosion", () => $d8206b3ab2e65c05$export$36b5fbeae4855055);
$parcel$export($d8206b3ab2e65c05$exports, "faFileLines", () => $d8206b3ab2e65c05$export$ef565d07efe2b5e9);
$parcel$export($d8206b3ab2e65c05$exports, "faFileAlt", () => $d8206b3ab2e65c05$export$243b47dca32bf0b8);
$parcel$export($d8206b3ab2e65c05$exports, "faFileText", () => $d8206b3ab2e65c05$export$f466100bf9bf37a5);
$parcel$export($d8206b3ab2e65c05$exports, "faWaveSquare", () => $d8206b3ab2e65c05$export$c38cf504b3bc58a2);
$parcel$export($d8206b3ab2e65c05$exports, "faRing", () => $d8206b3ab2e65c05$export$a95486586631edc7);
$parcel$export($d8206b3ab2e65c05$exports, "faBuildingUn", () => $d8206b3ab2e65c05$export$fbbc7601eb465ac7);
$parcel$export($d8206b3ab2e65c05$exports, "faDiceThree", () => $d8206b3ab2e65c05$export$221059e0d5fd8958);
$parcel$export($d8206b3ab2e65c05$exports, "faCalendarDays", () => $d8206b3ab2e65c05$export$31c6cf6f5d38dc0);
$parcel$export($d8206b3ab2e65c05$exports, "faCalendarAlt", () => $d8206b3ab2e65c05$export$cbc139f33cff356);
$parcel$export($d8206b3ab2e65c05$exports, "faAnchorCircleCheck", () => $d8206b3ab2e65c05$export$8bce49e6ae597af8);
$parcel$export($d8206b3ab2e65c05$exports, "faBuildingCircleArrowRight", () => $d8206b3ab2e65c05$export$37584b1a5e175b47);
$parcel$export($d8206b3ab2e65c05$exports, "faVolleyball", () => $d8206b3ab2e65c05$export$cc519c9529a46c5c);
$parcel$export($d8206b3ab2e65c05$exports, "faVolleyballBall", () => $d8206b3ab2e65c05$export$a15e6fc8e68a76b0);
$parcel$export($d8206b3ab2e65c05$exports, "faArrowsUpToLine", () => $d8206b3ab2e65c05$export$159982ce2622211e);
$parcel$export($d8206b3ab2e65c05$exports, "faSortDown", () => $d8206b3ab2e65c05$export$58e2577a373e7d4);
$parcel$export($d8206b3ab2e65c05$exports, "faSortDesc", () => $d8206b3ab2e65c05$export$e24f016f5f78af6a);
$parcel$export($d8206b3ab2e65c05$exports, "faCircleMinus", () => $d8206b3ab2e65c05$export$d0163707993a8110);
$parcel$export($d8206b3ab2e65c05$exports, "faMinusCircle", () => $d8206b3ab2e65c05$export$f3979b49bf57313c);
$parcel$export($d8206b3ab2e65c05$exports, "faDoorOpen", () => $d8206b3ab2e65c05$export$41821b9a6fd703de);
$parcel$export($d8206b3ab2e65c05$exports, "faRightFromBracket", () => $d8206b3ab2e65c05$export$122a80ae0f87f726);
$parcel$export($d8206b3ab2e65c05$exports, "faSignOutAlt", () => $d8206b3ab2e65c05$export$c844d6923b7096c2);
$parcel$export($d8206b3ab2e65c05$exports, "faAtom", () => $d8206b3ab2e65c05$export$b5bb295e8ad4ab31);
$parcel$export($d8206b3ab2e65c05$exports, "faSoap", () => $d8206b3ab2e65c05$export$64f1c53b21f310ac);
$parcel$export($d8206b3ab2e65c05$exports, "faIcons", () => $d8206b3ab2e65c05$export$7fe2894454d8eb8a);
$parcel$export($d8206b3ab2e65c05$exports, "faHeartMusicCameraBolt", () => $d8206b3ab2e65c05$export$ec74c13cedb0791d);
$parcel$export($d8206b3ab2e65c05$exports, "faMicrophoneLinesSlash", () => $d8206b3ab2e65c05$export$4be1b324ac8a71ba);
$parcel$export($d8206b3ab2e65c05$exports, "faMicrophoneAltSlash", () => $d8206b3ab2e65c05$export$d2a53a388f30780);
$parcel$export($d8206b3ab2e65c05$exports, "faBridgeCircleCheck", () => $d8206b3ab2e65c05$export$ea908d3d80c57d08);
$parcel$export($d8206b3ab2e65c05$exports, "faPumpMedical", () => $d8206b3ab2e65c05$export$f1b881c73328720c);
$parcel$export($d8206b3ab2e65c05$exports, "faFingerprint", () => $d8206b3ab2e65c05$export$614dc068d88655af);
$parcel$export($d8206b3ab2e65c05$exports, "faHandPointRight", () => $d8206b3ab2e65c05$export$f7bc8714c970afa4);
$parcel$export($d8206b3ab2e65c05$exports, "faMagnifyingGlassLocation", () => $d8206b3ab2e65c05$export$234a18b2b4d530a3);
$parcel$export($d8206b3ab2e65c05$exports, "faSearchLocation", () => $d8206b3ab2e65c05$export$c33aba6c251a898a);
$parcel$export($d8206b3ab2e65c05$exports, "faForwardStep", () => $d8206b3ab2e65c05$export$908d699be6717adc);
$parcel$export($d8206b3ab2e65c05$exports, "faStepForward", () => $d8206b3ab2e65c05$export$b303329afce5de18);
$parcel$export($d8206b3ab2e65c05$exports, "faFaceSmileBeam", () => $d8206b3ab2e65c05$export$e3c56ed54f074063);
$parcel$export($d8206b3ab2e65c05$exports, "faSmileBeam", () => $d8206b3ab2e65c05$export$54ada6dc9690e0ca);
$parcel$export($d8206b3ab2e65c05$exports, "faFlagCheckered", () => $d8206b3ab2e65c05$export$92fad97e19a9fea);
$parcel$export($d8206b3ab2e65c05$exports, "faFootball", () => $d8206b3ab2e65c05$export$e15f65e77f717c29);
$parcel$export($d8206b3ab2e65c05$exports, "faFootballBall", () => $d8206b3ab2e65c05$export$e8fd664711e31704);
$parcel$export($d8206b3ab2e65c05$exports, "faSchoolCircleExclamation", () => $d8206b3ab2e65c05$export$f629fdee00932a01);
$parcel$export($d8206b3ab2e65c05$exports, "faCrop", () => $d8206b3ab2e65c05$export$afa58590dfb6fca2);
$parcel$export($d8206b3ab2e65c05$exports, "faAnglesDown", () => $d8206b3ab2e65c05$export$52783a541b1bb03);
$parcel$export($d8206b3ab2e65c05$exports, "faAngleDoubleDown", () => $d8206b3ab2e65c05$export$fd504117f273ca92);
$parcel$export($d8206b3ab2e65c05$exports, "faUsersRectangle", () => $d8206b3ab2e65c05$export$a28757068b9a3a9a);
$parcel$export($d8206b3ab2e65c05$exports, "faPeopleRoof", () => $d8206b3ab2e65c05$export$b96e695bdcf3f3f5);
$parcel$export($d8206b3ab2e65c05$exports, "faPeopleLine", () => $d8206b3ab2e65c05$export$d12c2d6def120efe);
$parcel$export($d8206b3ab2e65c05$exports, "faBeerMugEmpty", () => $d8206b3ab2e65c05$export$b957c27bc5330472);
$parcel$export($d8206b3ab2e65c05$exports, "faBeer", () => $d8206b3ab2e65c05$export$f74725691538983b);
$parcel$export($d8206b3ab2e65c05$exports, "faDiagramPredecessor", () => $d8206b3ab2e65c05$export$1852c99deca7bee8);
$parcel$export($d8206b3ab2e65c05$exports, "faArrowUpLong", () => $d8206b3ab2e65c05$export$92c58defe6e4c5a7);
$parcel$export($d8206b3ab2e65c05$exports, "faLongArrowUp", () => $d8206b3ab2e65c05$export$ede1d50ec4b01670);
$parcel$export($d8206b3ab2e65c05$exports, "faFireFlameSimple", () => $d8206b3ab2e65c05$export$9ebfff5c90672059);
$parcel$export($d8206b3ab2e65c05$exports, "faBurn", () => $d8206b3ab2e65c05$export$80ed4535efc60402);
$parcel$export($d8206b3ab2e65c05$exports, "faPerson", () => $d8206b3ab2e65c05$export$e6619e43cb090a16);
$parcel$export($d8206b3ab2e65c05$exports, "faMale", () => $d8206b3ab2e65c05$export$2e21f9dba1630651);
$parcel$export($d8206b3ab2e65c05$exports, "faLaptop", () => $d8206b3ab2e65c05$export$c2dee3bd177275a2);
$parcel$export($d8206b3ab2e65c05$exports, "faFileCsv", () => $d8206b3ab2e65c05$export$82cea4f586f6ec9);
$parcel$export($d8206b3ab2e65c05$exports, "faMenorah", () => $d8206b3ab2e65c05$export$232452c59d77c56e);
$parcel$export($d8206b3ab2e65c05$exports, "faTruckPlane", () => $d8206b3ab2e65c05$export$e1d5ceed99060d76);
$parcel$export($d8206b3ab2e65c05$exports, "faRecordVinyl", () => $d8206b3ab2e65c05$export$fe2d5012d9982673);
$parcel$export($d8206b3ab2e65c05$exports, "faFaceGrinStars", () => $d8206b3ab2e65c05$export$1d1fbac384a76a12);
$parcel$export($d8206b3ab2e65c05$exports, "faGrinStars", () => $d8206b3ab2e65c05$export$64347a5c8c402ef4);
$parcel$export($d8206b3ab2e65c05$exports, "faBong", () => $d8206b3ab2e65c05$export$e74974fac77c468e);
$parcel$export($d8206b3ab2e65c05$exports, "faSpaghettiMonsterFlying", () => $d8206b3ab2e65c05$export$3c8d5c62d76c33b8);
$parcel$export($d8206b3ab2e65c05$exports, "faPastafarianism", () => $d8206b3ab2e65c05$export$733efdaec97447be);
$parcel$export($d8206b3ab2e65c05$exports, "faArrowDownUpAcrossLine", () => $d8206b3ab2e65c05$export$9fe0c42ede2dd003);
$parcel$export($d8206b3ab2e65c05$exports, "faSpoon", () => $d8206b3ab2e65c05$export$faf854a434ce6d0c);
$parcel$export($d8206b3ab2e65c05$exports, "faUtensilSpoon", () => $d8206b3ab2e65c05$export$fb7af5d245fb9053);
$parcel$export($d8206b3ab2e65c05$exports, "faJarWheat", () => $d8206b3ab2e65c05$export$8b503c1d76716ddd);
$parcel$export($d8206b3ab2e65c05$exports, "faEnvelopesBulk", () => $d8206b3ab2e65c05$export$dc2cce064a1e70bb);
$parcel$export($d8206b3ab2e65c05$exports, "faMailBulk", () => $d8206b3ab2e65c05$export$dd24f40c5337e2e1);
$parcel$export($d8206b3ab2e65c05$exports, "faFileCircleExclamation", () => $d8206b3ab2e65c05$export$61fa9809253098e5);
$parcel$export($d8206b3ab2e65c05$exports, "faCircleH", () => $d8206b3ab2e65c05$export$bf5674308c61894f);
$parcel$export($d8206b3ab2e65c05$exports, "faHospitalSymbol", () => $d8206b3ab2e65c05$export$c8a3c78d99c23fed);
$parcel$export($d8206b3ab2e65c05$exports, "faPager", () => $d8206b3ab2e65c05$export$e1611f373a10a98c);
$parcel$export($d8206b3ab2e65c05$exports, "faAddressBook", () => $d8206b3ab2e65c05$export$853fd1561789e3bb);
$parcel$export($d8206b3ab2e65c05$exports, "faContactBook", () => $d8206b3ab2e65c05$export$594b5a5d4d2e156b);
$parcel$export($d8206b3ab2e65c05$exports, "faStrikethrough", () => $d8206b3ab2e65c05$export$eff51ea25b4de135);
$parcel$export($d8206b3ab2e65c05$exports, "faK", () => $d8206b3ab2e65c05$export$3f85413cb67e7f67);
$parcel$export($d8206b3ab2e65c05$exports, "faLandmarkFlag", () => $d8206b3ab2e65c05$export$f4d472cf47be4096);
$parcel$export($d8206b3ab2e65c05$exports, "faPencil", () => $d8206b3ab2e65c05$export$c72de95adaca18b8);
$parcel$export($d8206b3ab2e65c05$exports, "faPencilAlt", () => $d8206b3ab2e65c05$export$8210adc172262df);
$parcel$export($d8206b3ab2e65c05$exports, "faBackward", () => $d8206b3ab2e65c05$export$ae65f96ea7a4078d);
$parcel$export($d8206b3ab2e65c05$exports, "faCaretRight", () => $d8206b3ab2e65c05$export$f1011352b01c1c0);
$parcel$export($d8206b3ab2e65c05$exports, "faComments", () => $d8206b3ab2e65c05$export$932912e74adb8939);
$parcel$export($d8206b3ab2e65c05$exports, "faPaste", () => $d8206b3ab2e65c05$export$6f95f90dd1f6d86b);
$parcel$export($d8206b3ab2e65c05$exports, "faFileClipboard", () => $d8206b3ab2e65c05$export$ca3229c47de163fa);
$parcel$export($d8206b3ab2e65c05$exports, "faCodePullRequest", () => $d8206b3ab2e65c05$export$37576dfab037d8bf);
$parcel$export($d8206b3ab2e65c05$exports, "faClipboardList", () => $d8206b3ab2e65c05$export$2c5a9d8548d8810e);
$parcel$export($d8206b3ab2e65c05$exports, "faTruckRampBox", () => $d8206b3ab2e65c05$export$37396c36c76937bc);
$parcel$export($d8206b3ab2e65c05$exports, "faTruckLoading", () => $d8206b3ab2e65c05$export$f00c152db7d44638);
$parcel$export($d8206b3ab2e65c05$exports, "faUserCheck", () => $d8206b3ab2e65c05$export$76de2a120043c9f8);
$parcel$export($d8206b3ab2e65c05$exports, "faVialVirus", () => $d8206b3ab2e65c05$export$a56b2b0a1073620c);
$parcel$export($d8206b3ab2e65c05$exports, "faSheetPlastic", () => $d8206b3ab2e65c05$export$57f2bcd070bff91a);
$parcel$export($d8206b3ab2e65c05$exports, "faBlog", () => $d8206b3ab2e65c05$export$890d5e011054935a);
$parcel$export($d8206b3ab2e65c05$exports, "faUserNinja", () => $d8206b3ab2e65c05$export$a9174995732e03c5);
$parcel$export($d8206b3ab2e65c05$exports, "faPersonArrowUpFromLine", () => $d8206b3ab2e65c05$export$5709329dd2b70bdc);
$parcel$export($d8206b3ab2e65c05$exports, "faScrollTorah", () => $d8206b3ab2e65c05$export$4e3fe5b42a6cd494);
$parcel$export($d8206b3ab2e65c05$exports, "faTorah", () => $d8206b3ab2e65c05$export$54d07baabd8c2acb);
$parcel$export($d8206b3ab2e65c05$exports, "faBroomBall", () => $d8206b3ab2e65c05$export$3e1327487ce53231);
$parcel$export($d8206b3ab2e65c05$exports, "faQuidditch", () => $d8206b3ab2e65c05$export$c00c446e6db1605f);
$parcel$export($d8206b3ab2e65c05$exports, "faQuidditchBroomBall", () => $d8206b3ab2e65c05$export$791bfe29b97b4d42);
$parcel$export($d8206b3ab2e65c05$exports, "faToggleOff", () => $d8206b3ab2e65c05$export$d20aaceb882ca545);
$parcel$export($d8206b3ab2e65c05$exports, "faBoxArchive", () => $d8206b3ab2e65c05$export$2a0fcb66c3d79d00);
$parcel$export($d8206b3ab2e65c05$exports, "faArchive", () => $d8206b3ab2e65c05$export$26b3e1c454273f34);
$parcel$export($d8206b3ab2e65c05$exports, "faPersonDrowning", () => $d8206b3ab2e65c05$export$bac321083217fd4);
$parcel$export($d8206b3ab2e65c05$exports, "faArrowDown91", () => $d8206b3ab2e65c05$export$6cc91ce23eb3fae1);
$parcel$export($d8206b3ab2e65c05$exports, "faSortNumericDesc", () => $d8206b3ab2e65c05$export$99f058110e2c82a8);
$parcel$export($d8206b3ab2e65c05$exports, "faSortNumericDownAlt", () => $d8206b3ab2e65c05$export$857385fda7a5a98e);
$parcel$export($d8206b3ab2e65c05$exports, "faFaceGrinTongueSquint", () => $d8206b3ab2e65c05$export$8eee2c17ff89e724);
$parcel$export($d8206b3ab2e65c05$exports, "faGrinTongueSquint", () => $d8206b3ab2e65c05$export$4edf34c3def09a31);
$parcel$export($d8206b3ab2e65c05$exports, "faSprayCan", () => $d8206b3ab2e65c05$export$4952c502f544cf85);
$parcel$export($d8206b3ab2e65c05$exports, "faTruckMonster", () => $d8206b3ab2e65c05$export$24b8a0147653649a);
$parcel$export($d8206b3ab2e65c05$exports, "faW", () => $d8206b3ab2e65c05$export$c7f24bdea332f90a);
$parcel$export($d8206b3ab2e65c05$exports, "faEarthAfrica", () => $d8206b3ab2e65c05$export$11afa141d42099d0);
$parcel$export($d8206b3ab2e65c05$exports, "faGlobeAfrica", () => $d8206b3ab2e65c05$export$64af36f3b403a57c);
$parcel$export($d8206b3ab2e65c05$exports, "faRainbow", () => $d8206b3ab2e65c05$export$92ab27739d3a91b2);
$parcel$export($d8206b3ab2e65c05$exports, "faCircleNotch", () => $d8206b3ab2e65c05$export$9429fd8df55155d);
$parcel$export($d8206b3ab2e65c05$exports, "faTabletScreenButton", () => $d8206b3ab2e65c05$export$df1e253fc358ade4);
$parcel$export($d8206b3ab2e65c05$exports, "faTabletAlt", () => $d8206b3ab2e65c05$export$db0cac088255eacc);
$parcel$export($d8206b3ab2e65c05$exports, "faPaw", () => $d8206b3ab2e65c05$export$7bc6e4d977673e69);
$parcel$export($d8206b3ab2e65c05$exports, "faCloud", () => $d8206b3ab2e65c05$export$8bb3c4d5c2f50243);
$parcel$export($d8206b3ab2e65c05$exports, "faTrowelBricks", () => $d8206b3ab2e65c05$export$b6c20c10ddbd9898);
$parcel$export($d8206b3ab2e65c05$exports, "faFaceFlushed", () => $d8206b3ab2e65c05$export$ba5dc4287853ecbd);
$parcel$export($d8206b3ab2e65c05$exports, "faFlushed", () => $d8206b3ab2e65c05$export$dfd2bd012685aeac);
$parcel$export($d8206b3ab2e65c05$exports, "faHospitalUser", () => $d8206b3ab2e65c05$export$684703c93d630cc5);
$parcel$export($d8206b3ab2e65c05$exports, "faTentArrowLeftRight", () => $d8206b3ab2e65c05$export$fa95eb7418c0e2b8);
$parcel$export($d8206b3ab2e65c05$exports, "faGavel", () => $d8206b3ab2e65c05$export$c36fb40057e2c3aa);
$parcel$export($d8206b3ab2e65c05$exports, "faLegal", () => $d8206b3ab2e65c05$export$59d593c2dacb3781);
$parcel$export($d8206b3ab2e65c05$exports, "faBinoculars", () => $d8206b3ab2e65c05$export$8a910017964bb8c2);
$parcel$export($d8206b3ab2e65c05$exports, "faMicrophoneSlash", () => $d8206b3ab2e65c05$export$843f63d64e6f7951);
$parcel$export($d8206b3ab2e65c05$exports, "faBoxTissue", () => $d8206b3ab2e65c05$export$f2adc06617bc0c7);
$parcel$export($d8206b3ab2e65c05$exports, "faMotorcycle", () => $d8206b3ab2e65c05$export$f26017bdca99338d);
$parcel$export($d8206b3ab2e65c05$exports, "faBellConcierge", () => $d8206b3ab2e65c05$export$e433538b78718fb3);
$parcel$export($d8206b3ab2e65c05$exports, "faConciergeBell", () => $d8206b3ab2e65c05$export$ad92ffbbfbc0fcf3);
$parcel$export($d8206b3ab2e65c05$exports, "faPenRuler", () => $d8206b3ab2e65c05$export$85ba06027671d290);
$parcel$export($d8206b3ab2e65c05$exports, "faPencilRuler", () => $d8206b3ab2e65c05$export$e3a7a1affea005f5);
$parcel$export($d8206b3ab2e65c05$exports, "faPeopleArrows", () => $d8206b3ab2e65c05$export$804bfc5c390e1a2a);
$parcel$export($d8206b3ab2e65c05$exports, "faPeopleArrowsLeftRight", () => $d8206b3ab2e65c05$export$da01f044c59e3598);
$parcel$export($d8206b3ab2e65c05$exports, "faMarsAndVenusBurst", () => $d8206b3ab2e65c05$export$1dc6221efb867885);
$parcel$export($d8206b3ab2e65c05$exports, "faSquareCaretRight", () => $d8206b3ab2e65c05$export$5b1d41cdd118ea6d);
$parcel$export($d8206b3ab2e65c05$exports, "faCaretSquareRight", () => $d8206b3ab2e65c05$export$ae86c9de7e0f62fa);
$parcel$export($d8206b3ab2e65c05$exports, "faScissors", () => $d8206b3ab2e65c05$export$b2a906a5928c6404);
$parcel$export($d8206b3ab2e65c05$exports, "faCut", () => $d8206b3ab2e65c05$export$66847f2a71b260e7);
$parcel$export($d8206b3ab2e65c05$exports, "faSunPlantWilt", () => $d8206b3ab2e65c05$export$8db7f2f70484e17e);
$parcel$export($d8206b3ab2e65c05$exports, "faToiletsPortable", () => $d8206b3ab2e65c05$export$c00f55f36d386cb7);
$parcel$export($d8206b3ab2e65c05$exports, "faHockeyPuck", () => $d8206b3ab2e65c05$export$a274b02dc75663dc);
$parcel$export($d8206b3ab2e65c05$exports, "faTable", () => $d8206b3ab2e65c05$export$36583f5d3d5a971f);
$parcel$export($d8206b3ab2e65c05$exports, "faMagnifyingGlassArrowRight", () => $d8206b3ab2e65c05$export$382d3376c7fc7fc5);
$parcel$export($d8206b3ab2e65c05$exports, "faTachographDigital", () => $d8206b3ab2e65c05$export$73f2bf302381c86a);
$parcel$export($d8206b3ab2e65c05$exports, "faDigitalTachograph", () => $d8206b3ab2e65c05$export$b3bf1994f0fefe98);
$parcel$export($d8206b3ab2e65c05$exports, "faUsersSlash", () => $d8206b3ab2e65c05$export$b71a093b86e3da1f);
$parcel$export($d8206b3ab2e65c05$exports, "faClover", () => $d8206b3ab2e65c05$export$57813571c0e10a0a);
$parcel$export($d8206b3ab2e65c05$exports, "faReply", () => $d8206b3ab2e65c05$export$bb06d4a7bb6736fe);
$parcel$export($d8206b3ab2e65c05$exports, "faMailReply", () => $d8206b3ab2e65c05$export$12e45ff70d2646a1);
$parcel$export($d8206b3ab2e65c05$exports, "faStarAndCrescent", () => $d8206b3ab2e65c05$export$cafa834c96ebcb1a);
$parcel$export($d8206b3ab2e65c05$exports, "faHouseFire", () => $d8206b3ab2e65c05$export$947ee033a6942aa8);
$parcel$export($d8206b3ab2e65c05$exports, "faSquareMinus", () => $d8206b3ab2e65c05$export$814c9edba7b84aa4);
$parcel$export($d8206b3ab2e65c05$exports, "faMinusSquare", () => $d8206b3ab2e65c05$export$ffe9387966b3e681);
$parcel$export($d8206b3ab2e65c05$exports, "faHelicopter", () => $d8206b3ab2e65c05$export$612d3e1afaf45fa5);
$parcel$export($d8206b3ab2e65c05$exports, "faCompass", () => $d8206b3ab2e65c05$export$b4d344633433e50e);
$parcel$export($d8206b3ab2e65c05$exports, "faSquareCaretDown", () => $d8206b3ab2e65c05$export$a1ab39cd66c4e50e);
$parcel$export($d8206b3ab2e65c05$exports, "faCaretSquareDown", () => $d8206b3ab2e65c05$export$61aea18df1c84401);
$parcel$export($d8206b3ab2e65c05$exports, "faFileCircleQuestion", () => $d8206b3ab2e65c05$export$877d3692c1f94bda);
$parcel$export($d8206b3ab2e65c05$exports, "faLaptopCode", () => $d8206b3ab2e65c05$export$94100f4c6ee29932);
$parcel$export($d8206b3ab2e65c05$exports, "faSwatchbook", () => $d8206b3ab2e65c05$export$c74a20c81b957b6a);
$parcel$export($d8206b3ab2e65c05$exports, "faPrescriptionBottle", () => $d8206b3ab2e65c05$export$214f9ce665590486);
$parcel$export($d8206b3ab2e65c05$exports, "faBars", () => $d8206b3ab2e65c05$export$36e9cf7887265da2);
$parcel$export($d8206b3ab2e65c05$exports, "faNavicon", () => $d8206b3ab2e65c05$export$409fa7bcaa0e4cd9);
$parcel$export($d8206b3ab2e65c05$exports, "faPeopleGroup", () => $d8206b3ab2e65c05$export$be015e72863c3635);
$parcel$export($d8206b3ab2e65c05$exports, "faHourglassEnd", () => $d8206b3ab2e65c05$export$52757ecc5b1e25b9);
$parcel$export($d8206b3ab2e65c05$exports, "faHourglass3", () => $d8206b3ab2e65c05$export$1ec43c81fef8ffd6);
$parcel$export($d8206b3ab2e65c05$exports, "faHeartCrack", () => $d8206b3ab2e65c05$export$8e521ef33062b00e);
$parcel$export($d8206b3ab2e65c05$exports, "faHeartBroken", () => $d8206b3ab2e65c05$export$4a565395cb65b282);
$parcel$export($d8206b3ab2e65c05$exports, "faSquareUpRight", () => $d8206b3ab2e65c05$export$a47a20ab7bde8c67);
$parcel$export($d8206b3ab2e65c05$exports, "faExternalLinkSquareAlt", () => $d8206b3ab2e65c05$export$e4cdf2977151ee26);
$parcel$export($d8206b3ab2e65c05$exports, "faFaceKissBeam", () => $d8206b3ab2e65c05$export$eca99665af566fe1);
$parcel$export($d8206b3ab2e65c05$exports, "faKissBeam", () => $d8206b3ab2e65c05$export$d6ff8a73c0812e63);
$parcel$export($d8206b3ab2e65c05$exports, "faFilm", () => $d8206b3ab2e65c05$export$c03de0cc616e77bb);
$parcel$export($d8206b3ab2e65c05$exports, "faRulerHorizontal", () => $d8206b3ab2e65c05$export$46c6347bff3e04a);
$parcel$export($d8206b3ab2e65c05$exports, "faPeopleRobbery", () => $d8206b3ab2e65c05$export$75ce8513e1f1c5c4);
$parcel$export($d8206b3ab2e65c05$exports, "faLightbulb", () => $d8206b3ab2e65c05$export$1e80f89fe84a215b);
$parcel$export($d8206b3ab2e65c05$exports, "faCaretLeft", () => $d8206b3ab2e65c05$export$85a918a11b7643c2);
$parcel$export($d8206b3ab2e65c05$exports, "faCircleExclamation", () => $d8206b3ab2e65c05$export$59573943f9eebbd5);
$parcel$export($d8206b3ab2e65c05$exports, "faExclamationCircle", () => $d8206b3ab2e65c05$export$220e07e14c5d7e5d);
$parcel$export($d8206b3ab2e65c05$exports, "faSchoolCircleXmark", () => $d8206b3ab2e65c05$export$5e17b20e0f6b132b);
$parcel$export($d8206b3ab2e65c05$exports, "faArrowRightFromBracket", () => $d8206b3ab2e65c05$export$ca14f1b4d6afb7aa);
$parcel$export($d8206b3ab2e65c05$exports, "faSignOut", () => $d8206b3ab2e65c05$export$33e2b60243ca6d92);
$parcel$export($d8206b3ab2e65c05$exports, "faCircleChevronDown", () => $d8206b3ab2e65c05$export$aca07924996218d8);
$parcel$export($d8206b3ab2e65c05$exports, "faChevronCircleDown", () => $d8206b3ab2e65c05$export$9926124d75b2ecab);
$parcel$export($d8206b3ab2e65c05$exports, "faUnlockKeyhole", () => $d8206b3ab2e65c05$export$c98fdd5082b333ec);
$parcel$export($d8206b3ab2e65c05$exports, "faUnlockAlt", () => $d8206b3ab2e65c05$export$b19f508797f3d9c3);
$parcel$export($d8206b3ab2e65c05$exports, "faCloudShowersHeavy", () => $d8206b3ab2e65c05$export$af51c741ee9cc090);
$parcel$export($d8206b3ab2e65c05$exports, "faHeadphonesSimple", () => $d8206b3ab2e65c05$export$ca47801915e5a685);
$parcel$export($d8206b3ab2e65c05$exports, "faHeadphonesAlt", () => $d8206b3ab2e65c05$export$6f0433fa527dd5be);
$parcel$export($d8206b3ab2e65c05$exports, "faSitemap", () => $d8206b3ab2e65c05$export$b2ce5e79d0eccaf8);
$parcel$export($d8206b3ab2e65c05$exports, "faCircleDollarToSlot", () => $d8206b3ab2e65c05$export$5f92ac3e804644e3);
$parcel$export($d8206b3ab2e65c05$exports, "faDonate", () => $d8206b3ab2e65c05$export$40050ae52860cde7);
$parcel$export($d8206b3ab2e65c05$exports, "faMemory", () => $d8206b3ab2e65c05$export$5f9bd9f6df021f93);
$parcel$export($d8206b3ab2e65c05$exports, "faRoadSpikes", () => $d8206b3ab2e65c05$export$b372a24046126ad8);
$parcel$export($d8206b3ab2e65c05$exports, "faFireBurner", () => $d8206b3ab2e65c05$export$e4e44f7b1886fef);
$parcel$export($d8206b3ab2e65c05$exports, "faFlag", () => $d8206b3ab2e65c05$export$6591b1ea509be9da);
$parcel$export($d8206b3ab2e65c05$exports, "faHanukiah", () => $d8206b3ab2e65c05$export$3dcd4ca3f7108a82);
$parcel$export($d8206b3ab2e65c05$exports, "faFeather", () => $d8206b3ab2e65c05$export$5e19aea195b31816);
$parcel$export($d8206b3ab2e65c05$exports, "faVolumeLow", () => $d8206b3ab2e65c05$export$2b1464e7557b18eb);
$parcel$export($d8206b3ab2e65c05$exports, "faVolumeDown", () => $d8206b3ab2e65c05$export$69fdf57632b6cc29);
$parcel$export($d8206b3ab2e65c05$exports, "faCommentSlash", () => $d8206b3ab2e65c05$export$3786a0422a3f33ea);
$parcel$export($d8206b3ab2e65c05$exports, "faCloudSunRain", () => $d8206b3ab2e65c05$export$dd9dc9b4227dbe94);
$parcel$export($d8206b3ab2e65c05$exports, "faCompress", () => $d8206b3ab2e65c05$export$83632d1150d3541f);
$parcel$export($d8206b3ab2e65c05$exports, "faWheatAwn", () => $d8206b3ab2e65c05$export$79d4dac715a51fdf);
$parcel$export($d8206b3ab2e65c05$exports, "faWheatAlt", () => $d8206b3ab2e65c05$export$deaf03a29aa05e3a);
$parcel$export($d8206b3ab2e65c05$exports, "faAnkh", () => $d8206b3ab2e65c05$export$8736909014b15ca9);
$parcel$export($d8206b3ab2e65c05$exports, "faHandsHoldingChild", () => $d8206b3ab2e65c05$export$bfb254bf3c0bc50b);
$parcel$export($d8206b3ab2e65c05$exports, "faAsterisk", () => $d8206b3ab2e65c05$export$19eff32c0fd4f99f);
$parcel$export($d8206b3ab2e65c05$exports, "faSquareCheck", () => $d8206b3ab2e65c05$export$5bb6a0c94ad2f4bb);
$parcel$export($d8206b3ab2e65c05$exports, "faCheckSquare", () => $d8206b3ab2e65c05$export$f0c8040f596df7fe);
$parcel$export($d8206b3ab2e65c05$exports, "faPesetaSign", () => $d8206b3ab2e65c05$export$a6f8654bcd49a39f);
$parcel$export($d8206b3ab2e65c05$exports, "faHeading", () => $d8206b3ab2e65c05$export$4805b8d175aeb9fb);
$parcel$export($d8206b3ab2e65c05$exports, "faHeader", () => $d8206b3ab2e65c05$export$579f9604bb10a61a);
$parcel$export($d8206b3ab2e65c05$exports, "faGhost", () => $d8206b3ab2e65c05$export$1a989eb1919c64c1);
$parcel$export($d8206b3ab2e65c05$exports, "faList", () => $d8206b3ab2e65c05$export$6cfc59842fedbc16);
$parcel$export($d8206b3ab2e65c05$exports, "faListSquares", () => $d8206b3ab2e65c05$export$e3f160fc949c2b9d);
$parcel$export($d8206b3ab2e65c05$exports, "faSquarePhoneFlip", () => $d8206b3ab2e65c05$export$b627121801cad756);
$parcel$export($d8206b3ab2e65c05$exports, "faPhoneSquareAlt", () => $d8206b3ab2e65c05$export$a41e77f0de98bba7);
$parcel$export($d8206b3ab2e65c05$exports, "faCartPlus", () => $d8206b3ab2e65c05$export$6675e2bf21fdb87e);
$parcel$export($d8206b3ab2e65c05$exports, "faGamepad", () => $d8206b3ab2e65c05$export$6a66b1b639455bef);
$parcel$export($d8206b3ab2e65c05$exports, "faCircleDot", () => $d8206b3ab2e65c05$export$aa13d9234890e8d3);
$parcel$export($d8206b3ab2e65c05$exports, "faDotCircle", () => $d8206b3ab2e65c05$export$92bc269cb244d66a);
$parcel$export($d8206b3ab2e65c05$exports, "faFaceDizzy", () => $d8206b3ab2e65c05$export$635e4d8cc8428961);
$parcel$export($d8206b3ab2e65c05$exports, "faDizzy", () => $d8206b3ab2e65c05$export$89a2b10dabc487e8);
$parcel$export($d8206b3ab2e65c05$exports, "faEgg", () => $d8206b3ab2e65c05$export$1199a8ce85311ab5);
$parcel$export($d8206b3ab2e65c05$exports, "faHouseMedicalCircleXmark", () => $d8206b3ab2e65c05$export$bf221f0e8296233e);
$parcel$export($d8206b3ab2e65c05$exports, "faCampground", () => $d8206b3ab2e65c05$export$295287303c0e9c7c);
$parcel$export($d8206b3ab2e65c05$exports, "faFolderPlus", () => $d8206b3ab2e65c05$export$e18e05ffa2045d3b);
$parcel$export($d8206b3ab2e65c05$exports, "faFutbol", () => $d8206b3ab2e65c05$export$65a345b33858a655);
$parcel$export($d8206b3ab2e65c05$exports, "faFutbolBall", () => $d8206b3ab2e65c05$export$51a344ca0a215620);
$parcel$export($d8206b3ab2e65c05$exports, "faSoccerBall", () => $d8206b3ab2e65c05$export$f4a29712c724ba2d);
$parcel$export($d8206b3ab2e65c05$exports, "faPaintbrush", () => $d8206b3ab2e65c05$export$7c8b56f3f296a814);
$parcel$export($d8206b3ab2e65c05$exports, "faPaintBrush", () => $d8206b3ab2e65c05$export$594db3339e212bc9);
$parcel$export($d8206b3ab2e65c05$exports, "faLock", () => $d8206b3ab2e65c05$export$7aa08ad5d562578a);
$parcel$export($d8206b3ab2e65c05$exports, "faGasPump", () => $d8206b3ab2e65c05$export$84666c793cb2a347);
$parcel$export($d8206b3ab2e65c05$exports, "faHotTubPerson", () => $d8206b3ab2e65c05$export$6e6bd68568c17bbf);
$parcel$export($d8206b3ab2e65c05$exports, "faHotTub", () => $d8206b3ab2e65c05$export$4842af92b516c40b);
$parcel$export($d8206b3ab2e65c05$exports, "faMapLocation", () => $d8206b3ab2e65c05$export$9a8788ec0e4a9a0b);
$parcel$export($d8206b3ab2e65c05$exports, "faMapMarked", () => $d8206b3ab2e65c05$export$df04458e7e32352c);
$parcel$export($d8206b3ab2e65c05$exports, "faHouseFloodWater", () => $d8206b3ab2e65c05$export$70fd6006b4e54a5);
$parcel$export($d8206b3ab2e65c05$exports, "faTree", () => $d8206b3ab2e65c05$export$1744430f718caf6b);
$parcel$export($d8206b3ab2e65c05$exports, "faBridgeLock", () => $d8206b3ab2e65c05$export$cffe7d85a82d8116);
$parcel$export($d8206b3ab2e65c05$exports, "faSackDollar", () => $d8206b3ab2e65c05$export$15854c4475080853);
$parcel$export($d8206b3ab2e65c05$exports, "faPenToSquare", () => $d8206b3ab2e65c05$export$ba236543926e3569);
$parcel$export($d8206b3ab2e65c05$exports, "faEdit", () => $d8206b3ab2e65c05$export$7be713e57d023733);
$parcel$export($d8206b3ab2e65c05$exports, "faCarSide", () => $d8206b3ab2e65c05$export$6f7218565b1b8d0e);
$parcel$export($d8206b3ab2e65c05$exports, "faShareNodes", () => $d8206b3ab2e65c05$export$cdaf45d4e50ac035);
$parcel$export($d8206b3ab2e65c05$exports, "faShareAlt", () => $d8206b3ab2e65c05$export$f8e8bb0b3aa8c658);
$parcel$export($d8206b3ab2e65c05$exports, "faHeartCircleMinus", () => $d8206b3ab2e65c05$export$24c21c3ca00f3625);
$parcel$export($d8206b3ab2e65c05$exports, "faHourglassHalf", () => $d8206b3ab2e65c05$export$703272eebf5e3eea);
$parcel$export($d8206b3ab2e65c05$exports, "faHourglass2", () => $d8206b3ab2e65c05$export$f1052bbf6bf361c0);
$parcel$export($d8206b3ab2e65c05$exports, "faMicroscope", () => $d8206b3ab2e65c05$export$6a99139787bf9967);
$parcel$export($d8206b3ab2e65c05$exports, "faSink", () => $d8206b3ab2e65c05$export$2a9dda2096ce792e);
$parcel$export($d8206b3ab2e65c05$exports, "faBagShopping", () => $d8206b3ab2e65c05$export$b0137b4600e9ab12);
$parcel$export($d8206b3ab2e65c05$exports, "faShoppingBag", () => $d8206b3ab2e65c05$export$5745f8adbc11eb01);
$parcel$export($d8206b3ab2e65c05$exports, "faArrowDownZA", () => $d8206b3ab2e65c05$export$cf79d63ad07d943a);
$parcel$export($d8206b3ab2e65c05$exports, "faSortAlphaDesc", () => $d8206b3ab2e65c05$export$7caf99612a55d427);
$parcel$export($d8206b3ab2e65c05$exports, "faSortAlphaDownAlt", () => $d8206b3ab2e65c05$export$e12d23d82d5c8a89);
$parcel$export($d8206b3ab2e65c05$exports, "faMitten", () => $d8206b3ab2e65c05$export$5030322c5fc886d7);
$parcel$export($d8206b3ab2e65c05$exports, "faPersonRays", () => $d8206b3ab2e65c05$export$49577f913f0fe4d2);
$parcel$export($d8206b3ab2e65c05$exports, "faUsers", () => $d8206b3ab2e65c05$export$e5a8f011aef571ac);
$parcel$export($d8206b3ab2e65c05$exports, "faEyeSlash", () => $d8206b3ab2e65c05$export$ed3f2918429d029a);
$parcel$export($d8206b3ab2e65c05$exports, "faFlaskVial", () => $d8206b3ab2e65c05$export$a25a266ce0c95019);
$parcel$export($d8206b3ab2e65c05$exports, "faHand", () => $d8206b3ab2e65c05$export$f69db0b876f7d753);
$parcel$export($d8206b3ab2e65c05$exports, "faHandPaper", () => $d8206b3ab2e65c05$export$6e6216c8b50471bb);
$parcel$export($d8206b3ab2e65c05$exports, "faOm", () => $d8206b3ab2e65c05$export$8de8eb94230028a5);
$parcel$export($d8206b3ab2e65c05$exports, "faWorm", () => $d8206b3ab2e65c05$export$2571e33fa6c25993);
$parcel$export($d8206b3ab2e65c05$exports, "faHouseCircleXmark", () => $d8206b3ab2e65c05$export$423555e8708eb4c7);
$parcel$export($d8206b3ab2e65c05$exports, "faPlug", () => $d8206b3ab2e65c05$export$cae5752c3e3b6545);
$parcel$export($d8206b3ab2e65c05$exports, "faChevronUp", () => $d8206b3ab2e65c05$export$877e5ae47a854215);
$parcel$export($d8206b3ab2e65c05$exports, "faHandSpock", () => $d8206b3ab2e65c05$export$2262d6b626de1120);
$parcel$export($d8206b3ab2e65c05$exports, "faStopwatch", () => $d8206b3ab2e65c05$export$b85a7300fc7960b6);
$parcel$export($d8206b3ab2e65c05$exports, "faFaceKiss", () => $d8206b3ab2e65c05$export$5a54c83033a0a56a);
$parcel$export($d8206b3ab2e65c05$exports, "faKiss", () => $d8206b3ab2e65c05$export$c762a77aabf64fd0);
$parcel$export($d8206b3ab2e65c05$exports, "faBridgeCircleXmark", () => $d8206b3ab2e65c05$export$834071278537f121);
$parcel$export($d8206b3ab2e65c05$exports, "faFaceGrinTongue", () => $d8206b3ab2e65c05$export$95a7394c24f57943);
$parcel$export($d8206b3ab2e65c05$exports, "faGrinTongue", () => $d8206b3ab2e65c05$export$ef222816a43a4b3a);
$parcel$export($d8206b3ab2e65c05$exports, "faChessBishop", () => $d8206b3ab2e65c05$export$a831eedd2f59c62f);
$parcel$export($d8206b3ab2e65c05$exports, "faFaceGrinWink", () => $d8206b3ab2e65c05$export$1dd161850c5bc64e);
$parcel$export($d8206b3ab2e65c05$exports, "faGrinWink", () => $d8206b3ab2e65c05$export$2397fcd34eb12177);
$parcel$export($d8206b3ab2e65c05$exports, "faEarDeaf", () => $d8206b3ab2e65c05$export$c9c5b76ec992eab4);
$parcel$export($d8206b3ab2e65c05$exports, "faDeaf", () => $d8206b3ab2e65c05$export$4b666adf83f0de01);
$parcel$export($d8206b3ab2e65c05$exports, "faDeafness", () => $d8206b3ab2e65c05$export$85c6a9ab2fa2631e);
$parcel$export($d8206b3ab2e65c05$exports, "faHardOfHearing", () => $d8206b3ab2e65c05$export$ebecf90a5676e17a);
$parcel$export($d8206b3ab2e65c05$exports, "faRoadCircleCheck", () => $d8206b3ab2e65c05$export$3f22db9ae9b6be1c);
$parcel$export($d8206b3ab2e65c05$exports, "faDiceFive", () => $d8206b3ab2e65c05$export$d9769fb795c2db82);
$parcel$export($d8206b3ab2e65c05$exports, "faSquareRss", () => $d8206b3ab2e65c05$export$97d1903b1e012ff7);
$parcel$export($d8206b3ab2e65c05$exports, "faRssSquare", () => $d8206b3ab2e65c05$export$89c9b1cca2c11484);
$parcel$export($d8206b3ab2e65c05$exports, "faLandMineOn", () => $d8206b3ab2e65c05$export$567a897fc092e403);
$parcel$export($d8206b3ab2e65c05$exports, "faICursor", () => $d8206b3ab2e65c05$export$7fddf76ec23943d8);
$parcel$export($d8206b3ab2e65c05$exports, "faStamp", () => $d8206b3ab2e65c05$export$722e92d2d93ffc68);
$parcel$export($d8206b3ab2e65c05$exports, "faStairs", () => $d8206b3ab2e65c05$export$68b3af7444c89df7);
$parcel$export($d8206b3ab2e65c05$exports, "faI", () => $d8206b3ab2e65c05$export$aee03ca0815b7c38);
$parcel$export($d8206b3ab2e65c05$exports, "faHryvniaSign", () => $d8206b3ab2e65c05$export$22a9491150c64fef);
$parcel$export($d8206b3ab2e65c05$exports, "faHryvnia", () => $d8206b3ab2e65c05$export$33d5f94bd6f75f59);
$parcel$export($d8206b3ab2e65c05$exports, "faPills", () => $d8206b3ab2e65c05$export$6380e2ed6e69d350);
$parcel$export($d8206b3ab2e65c05$exports, "faFaceGrinWide", () => $d8206b3ab2e65c05$export$bdbabf493c478cde);
$parcel$export($d8206b3ab2e65c05$exports, "faGrinAlt", () => $d8206b3ab2e65c05$export$b4abebfe416d36ba);
$parcel$export($d8206b3ab2e65c05$exports, "faTooth", () => $d8206b3ab2e65c05$export$3a1fa2d16f90d635);
$parcel$export($d8206b3ab2e65c05$exports, "faV", () => $d8206b3ab2e65c05$export$6fb446f784f6b9b3);
$parcel$export($d8206b3ab2e65c05$exports, "faBangladeshiTakaSign", () => $d8206b3ab2e65c05$export$469d376940e10d37);
$parcel$export($d8206b3ab2e65c05$exports, "faBicycle", () => $d8206b3ab2e65c05$export$36cb1885ad7a570f);
$parcel$export($d8206b3ab2e65c05$exports, "faStaffSnake", () => $d8206b3ab2e65c05$export$76d998742bc186eb);
$parcel$export($d8206b3ab2e65c05$exports, "faRodAsclepius", () => $d8206b3ab2e65c05$export$f2c3e92ee37a8d89);
$parcel$export($d8206b3ab2e65c05$exports, "faRodSnake", () => $d8206b3ab2e65c05$export$5d61dcb598296af0);
$parcel$export($d8206b3ab2e65c05$exports, "faStaffAesculapius", () => $d8206b3ab2e65c05$export$97c8a2cdba3b7700);
$parcel$export($d8206b3ab2e65c05$exports, "faHeadSideCoughSlash", () => $d8206b3ab2e65c05$export$b293ee8fb8e6b0c4);
$parcel$export($d8206b3ab2e65c05$exports, "faTruckMedical", () => $d8206b3ab2e65c05$export$fb6bd43f079f72e2);
$parcel$export($d8206b3ab2e65c05$exports, "faAmbulance", () => $d8206b3ab2e65c05$export$f5c7042778b51765);
$parcel$export($d8206b3ab2e65c05$exports, "faWheatAwnCircleExclamation", () => $d8206b3ab2e65c05$export$e23367e54f665590);
$parcel$export($d8206b3ab2e65c05$exports, "faSnowman", () => $d8206b3ab2e65c05$export$b23df6bafb174693);
$parcel$export($d8206b3ab2e65c05$exports, "faMortarPestle", () => $d8206b3ab2e65c05$export$55ceb5d0c144580a);
$parcel$export($d8206b3ab2e65c05$exports, "faRoadBarrier", () => $d8206b3ab2e65c05$export$f3e925217e396f44);
$parcel$export($d8206b3ab2e65c05$exports, "faSchool", () => $d8206b3ab2e65c05$export$51e9b8434982947d);
$parcel$export($d8206b3ab2e65c05$exports, "faIgloo", () => $d8206b3ab2e65c05$export$4a284575edd6f1af);
$parcel$export($d8206b3ab2e65c05$exports, "faJoint", () => $d8206b3ab2e65c05$export$e5a289fb22ffb8cb);
$parcel$export($d8206b3ab2e65c05$exports, "faAngleRight", () => $d8206b3ab2e65c05$export$6bce1afb61f2eb66);
$parcel$export($d8206b3ab2e65c05$exports, "faHorse", () => $d8206b3ab2e65c05$export$5b05f097fa38352a);
$parcel$export($d8206b3ab2e65c05$exports, "faQ", () => $d8206b3ab2e65c05$export$5a2b164552deda9f);
$parcel$export($d8206b3ab2e65c05$exports, "faG", () => $d8206b3ab2e65c05$export$9f5c2b0db8eedeac);
$parcel$export($d8206b3ab2e65c05$exports, "faNotesMedical", () => $d8206b3ab2e65c05$export$b2d79133c81d6697);
$parcel$export($d8206b3ab2e65c05$exports, "faTemperatureHalf", () => $d8206b3ab2e65c05$export$a3f1d7f13c202adc);
$parcel$export($d8206b3ab2e65c05$exports, "faTemperature2", () => $d8206b3ab2e65c05$export$8176e649df45b32c);
$parcel$export($d8206b3ab2e65c05$exports, "faThermometer2", () => $d8206b3ab2e65c05$export$4dd764ac8d512682);
$parcel$export($d8206b3ab2e65c05$exports, "faThermometerHalf", () => $d8206b3ab2e65c05$export$2090f040324b4449);
$parcel$export($d8206b3ab2e65c05$exports, "faDongSign", () => $d8206b3ab2e65c05$export$18659308f17918a5);
$parcel$export($d8206b3ab2e65c05$exports, "faCapsules", () => $d8206b3ab2e65c05$export$ba6fd4a436804a48);
$parcel$export($d8206b3ab2e65c05$exports, "faPooStorm", () => $d8206b3ab2e65c05$export$48a38da471b097a2);
$parcel$export($d8206b3ab2e65c05$exports, "faPooBolt", () => $d8206b3ab2e65c05$export$9a24e77f74d9cbd9);
$parcel$export($d8206b3ab2e65c05$exports, "faFaceFrownOpen", () => $d8206b3ab2e65c05$export$c8a28356e07b9ccb);
$parcel$export($d8206b3ab2e65c05$exports, "faFrownOpen", () => $d8206b3ab2e65c05$export$c4775e66bed5d96);
$parcel$export($d8206b3ab2e65c05$exports, "faHandPointUp", () => $d8206b3ab2e65c05$export$cdc9f5e7e94e76da);
$parcel$export($d8206b3ab2e65c05$exports, "faMoneyBill", () => $d8206b3ab2e65c05$export$608138a7337b5d1a);
$parcel$export($d8206b3ab2e65c05$exports, "faBookmark", () => $d8206b3ab2e65c05$export$4ed9da5c3cca0ef1);
$parcel$export($d8206b3ab2e65c05$exports, "faAlignJustify", () => $d8206b3ab2e65c05$export$97c42b56d462df72);
$parcel$export($d8206b3ab2e65c05$exports, "faUmbrellaBeach", () => $d8206b3ab2e65c05$export$20932e4d438e4e4c);
$parcel$export($d8206b3ab2e65c05$exports, "faHelmetUn", () => $d8206b3ab2e65c05$export$5e975cb293c48461);
$parcel$export($d8206b3ab2e65c05$exports, "faBullseye", () => $d8206b3ab2e65c05$export$554720e3bf74fe90);
$parcel$export($d8206b3ab2e65c05$exports, "faBacon", () => $d8206b3ab2e65c05$export$ab07061fe21a3a8e);
$parcel$export($d8206b3ab2e65c05$exports, "faHandPointDown", () => $d8206b3ab2e65c05$export$f6dcbf0a940428f4);
$parcel$export($d8206b3ab2e65c05$exports, "faArrowUpFromBracket", () => $d8206b3ab2e65c05$export$c2af1be14cd87640);
$parcel$export($d8206b3ab2e65c05$exports, "faFolder", () => $d8206b3ab2e65c05$export$72b780186370e953);
$parcel$export($d8206b3ab2e65c05$exports, "faFolderBlank", () => $d8206b3ab2e65c05$export$9ef114244d26da0);
$parcel$export($d8206b3ab2e65c05$exports, "faFileWaveform", () => $d8206b3ab2e65c05$export$5e0c19cf315ac1bf);
$parcel$export($d8206b3ab2e65c05$exports, "faFileMedicalAlt", () => $d8206b3ab2e65c05$export$ef02a0f5b39aa61f);
$parcel$export($d8206b3ab2e65c05$exports, "faRadiation", () => $d8206b3ab2e65c05$export$4c4e509518093d6d);
$parcel$export($d8206b3ab2e65c05$exports, "faChartSimple", () => $d8206b3ab2e65c05$export$8760a1de19ea40b9);
$parcel$export($d8206b3ab2e65c05$exports, "faMarsStroke", () => $d8206b3ab2e65c05$export$aa05fce255a5d269);
$parcel$export($d8206b3ab2e65c05$exports, "faVial", () => $d8206b3ab2e65c05$export$aa014b06d2d70598);
$parcel$export($d8206b3ab2e65c05$exports, "faGauge", () => $d8206b3ab2e65c05$export$dbfb0a9f89ad94a4);
$parcel$export($d8206b3ab2e65c05$exports, "faDashboard", () => $d8206b3ab2e65c05$export$b7ce24136743d0f1);
$parcel$export($d8206b3ab2e65c05$exports, "faGaugeMed", () => $d8206b3ab2e65c05$export$f948a9dd257979f3);
$parcel$export($d8206b3ab2e65c05$exports, "faTachometerAltAverage", () => $d8206b3ab2e65c05$export$6f22c345e5a92d1a);
$parcel$export($d8206b3ab2e65c05$exports, "faWandMagicSparkles", () => $d8206b3ab2e65c05$export$5325fc72e75360b4);
$parcel$export($d8206b3ab2e65c05$exports, "faMagicWandSparkles", () => $d8206b3ab2e65c05$export$c93286938249f0da);
$parcel$export($d8206b3ab2e65c05$exports, "faE", () => $d8206b3ab2e65c05$export$86923e6fe1b42f5e);
$parcel$export($d8206b3ab2e65c05$exports, "faPenClip", () => $d8206b3ab2e65c05$export$eff4bdcafd3b8d1c);
$parcel$export($d8206b3ab2e65c05$exports, "faPenAlt", () => $d8206b3ab2e65c05$export$a3d3e92e430d3beb);
$parcel$export($d8206b3ab2e65c05$exports, "faBridgeCircleExclamation", () => $d8206b3ab2e65c05$export$4f25939fdf728c27);
$parcel$export($d8206b3ab2e65c05$exports, "faUser", () => $d8206b3ab2e65c05$export$f5699fa0844e0188);
$parcel$export($d8206b3ab2e65c05$exports, "faSchoolCircleCheck", () => $d8206b3ab2e65c05$export$c8c95c2f9937bf6a);
$parcel$export($d8206b3ab2e65c05$exports, "faDumpster", () => $d8206b3ab2e65c05$export$3b934e22d1851a3b);
$parcel$export($d8206b3ab2e65c05$exports, "faVanShuttle", () => $d8206b3ab2e65c05$export$ecbd233b96906ee1);
$parcel$export($d8206b3ab2e65c05$exports, "faShuttleVan", () => $d8206b3ab2e65c05$export$9d63d851db698c09);
$parcel$export($d8206b3ab2e65c05$exports, "faBuildingUser", () => $d8206b3ab2e65c05$export$d65aef1ed7db1dae);
$parcel$export($d8206b3ab2e65c05$exports, "faSquareCaretLeft", () => $d8206b3ab2e65c05$export$2c5163541229363);
$parcel$export($d8206b3ab2e65c05$exports, "faCaretSquareLeft", () => $d8206b3ab2e65c05$export$d0c8ba444f1f9581);
$parcel$export($d8206b3ab2e65c05$exports, "faHighlighter", () => $d8206b3ab2e65c05$export$73801ed54b42fabe);
$parcel$export($d8206b3ab2e65c05$exports, "faKey", () => $d8206b3ab2e65c05$export$fa6ecc35e7315db);
$parcel$export($d8206b3ab2e65c05$exports, "faBullhorn", () => $d8206b3ab2e65c05$export$dacae2b4ec565333);
$parcel$export($d8206b3ab2e65c05$exports, "faGlobe", () => $d8206b3ab2e65c05$export$b1b1cdce4a19c682);
$parcel$export($d8206b3ab2e65c05$exports, "faSynagogue", () => $d8206b3ab2e65c05$export$20d991385719b5b4);
$parcel$export($d8206b3ab2e65c05$exports, "faPersonHalfDress", () => $d8206b3ab2e65c05$export$f3d75c19191f1688);
$parcel$export($d8206b3ab2e65c05$exports, "faRoadBridge", () => $d8206b3ab2e65c05$export$4d6835e7175dec24);
$parcel$export($d8206b3ab2e65c05$exports, "faLocationArrow", () => $d8206b3ab2e65c05$export$4ac9c4c370f7b157);
$parcel$export($d8206b3ab2e65c05$exports, "faC", () => $d8206b3ab2e65c05$export$a2c1c457834fc6d8);
$parcel$export($d8206b3ab2e65c05$exports, "faTabletButton", () => $d8206b3ab2e65c05$export$2d33c367b2b091ac);
$parcel$export($d8206b3ab2e65c05$exports, "faBuildingLock", () => $d8206b3ab2e65c05$export$6f08294ba8a2459c);
$parcel$export($d8206b3ab2e65c05$exports, "faPizzaSlice", () => $d8206b3ab2e65c05$export$c9f93c4667edc585);
$parcel$export($d8206b3ab2e65c05$exports, "faMoneyBillWave", () => $d8206b3ab2e65c05$export$53e23123cc9a6796);
$parcel$export($d8206b3ab2e65c05$exports, "faChartArea", () => $d8206b3ab2e65c05$export$2acab8312b7a999b);
$parcel$export($d8206b3ab2e65c05$exports, "faAreaChart", () => $d8206b3ab2e65c05$export$fc2e595f0e0612cb);
$parcel$export($d8206b3ab2e65c05$exports, "faHouseFlag", () => $d8206b3ab2e65c05$export$9a3d31c75a465b9a);
$parcel$export($d8206b3ab2e65c05$exports, "faPersonCircleMinus", () => $d8206b3ab2e65c05$export$d7ccc6651f90f7cc);
$parcel$export($d8206b3ab2e65c05$exports, "faBan", () => $d8206b3ab2e65c05$export$76f704d256def3c7);
$parcel$export($d8206b3ab2e65c05$exports, "faCancel", () => $d8206b3ab2e65c05$export$6d25ef56192f6d69);
$parcel$export($d8206b3ab2e65c05$exports, "faCameraRotate", () => $d8206b3ab2e65c05$export$e0ce7d1aba7105e7);
$parcel$export($d8206b3ab2e65c05$exports, "faSprayCanSparkles", () => $d8206b3ab2e65c05$export$43832c90c10a7a31);
$parcel$export($d8206b3ab2e65c05$exports, "faAirFreshener", () => $d8206b3ab2e65c05$export$a5e63e89b5ccee83);
$parcel$export($d8206b3ab2e65c05$exports, "faStar", () => $d8206b3ab2e65c05$export$a3b0eb2cd7942125);
$parcel$export($d8206b3ab2e65c05$exports, "faRepeat", () => $d8206b3ab2e65c05$export$cb8434288c91ae83);
$parcel$export($d8206b3ab2e65c05$exports, "faCross", () => $d8206b3ab2e65c05$export$9d0a89fcd084abb);
$parcel$export($d8206b3ab2e65c05$exports, "faBox", () => $d8206b3ab2e65c05$export$6e7cf270cda52323);
$parcel$export($d8206b3ab2e65c05$exports, "faVenusMars", () => $d8206b3ab2e65c05$export$63f2d9e5f4689aa8);
$parcel$export($d8206b3ab2e65c05$exports, "faArrowPointer", () => $d8206b3ab2e65c05$export$e4f903bc63db445);
$parcel$export($d8206b3ab2e65c05$exports, "faMousePointer", () => $d8206b3ab2e65c05$export$2e19a69cc26b147);
$parcel$export($d8206b3ab2e65c05$exports, "faMaximize", () => $d8206b3ab2e65c05$export$8d2b1b230601e804);
$parcel$export($d8206b3ab2e65c05$exports, "faExpandArrowsAlt", () => $d8206b3ab2e65c05$export$6219dcd88b5fa6c2);
$parcel$export($d8206b3ab2e65c05$exports, "faChargingStation", () => $d8206b3ab2e65c05$export$bab2cd86f8c65657);
$parcel$export($d8206b3ab2e65c05$exports, "faShapes", () => $d8206b3ab2e65c05$export$b17d50542d1fc340);
$parcel$export($d8206b3ab2e65c05$exports, "faTriangleCircleSquare", () => $d8206b3ab2e65c05$export$34261e5aea24fc1d);
$parcel$export($d8206b3ab2e65c05$exports, "faShuffle", () => $d8206b3ab2e65c05$export$ee94b652453ad208);
$parcel$export($d8206b3ab2e65c05$exports, "faRandom", () => $d8206b3ab2e65c05$export$8357bf8cc666d5f0);
$parcel$export($d8206b3ab2e65c05$exports, "faPersonRunning", () => $d8206b3ab2e65c05$export$f48814ae62850c74);
$parcel$export($d8206b3ab2e65c05$exports, "faRunning", () => $d8206b3ab2e65c05$export$5dfd1cb43dc9eadb);
$parcel$export($d8206b3ab2e65c05$exports, "faMobileRetro", () => $d8206b3ab2e65c05$export$7955f08360418647);
$parcel$export($d8206b3ab2e65c05$exports, "faGripLinesVertical", () => $d8206b3ab2e65c05$export$523960de087f5198);
$parcel$export($d8206b3ab2e65c05$exports, "faSpider", () => $d8206b3ab2e65c05$export$6daa96b1986e2ef0);
$parcel$export($d8206b3ab2e65c05$exports, "faHandsBound", () => $d8206b3ab2e65c05$export$740142a89118fbc0);
$parcel$export($d8206b3ab2e65c05$exports, "faFileInvoiceDollar", () => $d8206b3ab2e65c05$export$a3dced32d48cb1ea);
$parcel$export($d8206b3ab2e65c05$exports, "faPlaneCircleExclamation", () => $d8206b3ab2e65c05$export$f201ba865ea1b8dc);
$parcel$export($d8206b3ab2e65c05$exports, "faXRay", () => $d8206b3ab2e65c05$export$8cf137aceaaf4de0);
$parcel$export($d8206b3ab2e65c05$exports, "faSpellCheck", () => $d8206b3ab2e65c05$export$761e747b06ed2e1f);
$parcel$export($d8206b3ab2e65c05$exports, "faSlash", () => $d8206b3ab2e65c05$export$f54d004dd5f1cb5e);
$parcel$export($d8206b3ab2e65c05$exports, "faComputerMouse", () => $d8206b3ab2e65c05$export$72cf138e5ddda6eb);
$parcel$export($d8206b3ab2e65c05$exports, "faMouse", () => $d8206b3ab2e65c05$export$198b96b894c66074);
$parcel$export($d8206b3ab2e65c05$exports, "faArrowRightToBracket", () => $d8206b3ab2e65c05$export$a02c5909359525be);
$parcel$export($d8206b3ab2e65c05$exports, "faSignIn", () => $d8206b3ab2e65c05$export$a55eff0ca4f9c3df);
$parcel$export($d8206b3ab2e65c05$exports, "faShopSlash", () => $d8206b3ab2e65c05$export$b3d636689da4a3e5);
$parcel$export($d8206b3ab2e65c05$exports, "faStoreAltSlash", () => $d8206b3ab2e65c05$export$b932a586f6ff48b4);
$parcel$export($d8206b3ab2e65c05$exports, "faServer", () => $d8206b3ab2e65c05$export$1bf820d499b6202e);
$parcel$export($d8206b3ab2e65c05$exports, "faVirusCovidSlash", () => $d8206b3ab2e65c05$export$61c2a6b698f55df6);
$parcel$export($d8206b3ab2e65c05$exports, "faShopLock", () => $d8206b3ab2e65c05$export$452410c103c2403b);
$parcel$export($d8206b3ab2e65c05$exports, "faHourglassStart", () => $d8206b3ab2e65c05$export$f0c28584caa8f4b);
$parcel$export($d8206b3ab2e65c05$exports, "faHourglass1", () => $d8206b3ab2e65c05$export$87929336ab5c59cd);
$parcel$export($d8206b3ab2e65c05$exports, "faBlenderPhone", () => $d8206b3ab2e65c05$export$f35a116a762ef8fc);
$parcel$export($d8206b3ab2e65c05$exports, "faBuildingWheat", () => $d8206b3ab2e65c05$export$6c0cfe6d58faf860);
$parcel$export($d8206b3ab2e65c05$exports, "faPersonBreastfeeding", () => $d8206b3ab2e65c05$export$9b94ed8d16d281f9);
$parcel$export($d8206b3ab2e65c05$exports, "faRightToBracket", () => $d8206b3ab2e65c05$export$a5fd2acfcb5247c6);
$parcel$export($d8206b3ab2e65c05$exports, "faSignInAlt", () => $d8206b3ab2e65c05$export$e6709746115bd2ea);
$parcel$export($d8206b3ab2e65c05$exports, "faVenus", () => $d8206b3ab2e65c05$export$f89d028573ffc0a6);
$parcel$export($d8206b3ab2e65c05$exports, "faPassport", () => $d8206b3ab2e65c05$export$2c31ca0d9bee400f);
$parcel$export($d8206b3ab2e65c05$exports, "faHeartPulse", () => $d8206b3ab2e65c05$export$a6d8e50dcd4b4294);
$parcel$export($d8206b3ab2e65c05$exports, "faHeartbeat", () => $d8206b3ab2e65c05$export$ca880e19206e80aa);
$parcel$export($d8206b3ab2e65c05$exports, "faPeopleCarryBox", () => $d8206b3ab2e65c05$export$7754cc6d5559ff38);
$parcel$export($d8206b3ab2e65c05$exports, "faPeopleCarry", () => $d8206b3ab2e65c05$export$35fbd4ff1265acd5);
$parcel$export($d8206b3ab2e65c05$exports, "faTemperatureHigh", () => $d8206b3ab2e65c05$export$15d012277c3ecf9a);
$parcel$export($d8206b3ab2e65c05$exports, "faMicrochip", () => $d8206b3ab2e65c05$export$4a7bb4be15f35178);
$parcel$export($d8206b3ab2e65c05$exports, "faCrown", () => $d8206b3ab2e65c05$export$dc1083dcd1d7b9d6);
$parcel$export($d8206b3ab2e65c05$exports, "faWeightHanging", () => $d8206b3ab2e65c05$export$43d1fa6671908715);
$parcel$export($d8206b3ab2e65c05$exports, "faXmarksLines", () => $d8206b3ab2e65c05$export$f4595f012786d346);
$parcel$export($d8206b3ab2e65c05$exports, "faFilePrescription", () => $d8206b3ab2e65c05$export$a20cb90865b6beb8);
$parcel$export($d8206b3ab2e65c05$exports, "faWeightScale", () => $d8206b3ab2e65c05$export$e521c542d18b85c3);
$parcel$export($d8206b3ab2e65c05$exports, "faWeight", () => $d8206b3ab2e65c05$export$cf3bafa68a60bae4);
$parcel$export($d8206b3ab2e65c05$exports, "faUserGroup", () => $d8206b3ab2e65c05$export$3d626cfc365a7e36);
$parcel$export($d8206b3ab2e65c05$exports, "faUserFriends", () => $d8206b3ab2e65c05$export$46073bec205635d9);
$parcel$export($d8206b3ab2e65c05$exports, "faArrowUpAZ", () => $d8206b3ab2e65c05$export$fb00fdd8857804c7);
$parcel$export($d8206b3ab2e65c05$exports, "faSortAlphaUp", () => $d8206b3ab2e65c05$export$3c4115b156be730d);
$parcel$export($d8206b3ab2e65c05$exports, "faChessKnight", () => $d8206b3ab2e65c05$export$861b1f13085cf122);
$parcel$export($d8206b3ab2e65c05$exports, "faFaceLaughSquint", () => $d8206b3ab2e65c05$export$67ca89c1ca38d559);
$parcel$export($d8206b3ab2e65c05$exports, "faLaughSquint", () => $d8206b3ab2e65c05$export$b206e700cf7084e1);
$parcel$export($d8206b3ab2e65c05$exports, "faWheelchair", () => $d8206b3ab2e65c05$export$76a9413fbe130a53);
$parcel$export($d8206b3ab2e65c05$exports, "faCircleArrowUp", () => $d8206b3ab2e65c05$export$a29c8ea43e92771d);
$parcel$export($d8206b3ab2e65c05$exports, "faArrowCircleUp", () => $d8206b3ab2e65c05$export$a2f6f3baa50af0b1);
$parcel$export($d8206b3ab2e65c05$exports, "faToggleOn", () => $d8206b3ab2e65c05$export$5cffc34afa81e517);
$parcel$export($d8206b3ab2e65c05$exports, "faPersonWalking", () => $d8206b3ab2e65c05$export$6af1cc5998ca52bc);
$parcel$export($d8206b3ab2e65c05$exports, "faWalking", () => $d8206b3ab2e65c05$export$4886811b7174ec35);
$parcel$export($d8206b3ab2e65c05$exports, "faL", () => $d8206b3ab2e65c05$export$be32b10ce70a09df);
$parcel$export($d8206b3ab2e65c05$exports, "faFire", () => $d8206b3ab2e65c05$export$7b24b34ef6cc130c);
$parcel$export($d8206b3ab2e65c05$exports, "faBedPulse", () => $d8206b3ab2e65c05$export$580ae0d0bbd809fb);
$parcel$export($d8206b3ab2e65c05$exports, "faProcedures", () => $d8206b3ab2e65c05$export$5f9e1870e1866dde);
$parcel$export($d8206b3ab2e65c05$exports, "faShuttleSpace", () => $d8206b3ab2e65c05$export$76d92e7f30d064c5);
$parcel$export($d8206b3ab2e65c05$exports, "faSpaceShuttle", () => $d8206b3ab2e65c05$export$4d1c12ba2b4ca565);
$parcel$export($d8206b3ab2e65c05$exports, "faFaceLaugh", () => $d8206b3ab2e65c05$export$2f203616c892d415);
$parcel$export($d8206b3ab2e65c05$exports, "faLaugh", () => $d8206b3ab2e65c05$export$6c74e314e801a4fe);
$parcel$export($d8206b3ab2e65c05$exports, "faFolderOpen", () => $d8206b3ab2e65c05$export$ff7e93418af88b78);
$parcel$export($d8206b3ab2e65c05$exports, "faHeartCirclePlus", () => $d8206b3ab2e65c05$export$2a155a6e20f64134);
$parcel$export($d8206b3ab2e65c05$exports, "faCodeFork", () => $d8206b3ab2e65c05$export$f54081bdbf6d4eb5);
$parcel$export($d8206b3ab2e65c05$exports, "faCity", () => $d8206b3ab2e65c05$export$a9947c2888b3c8fd);
$parcel$export($d8206b3ab2e65c05$exports, "faMicrophoneLines", () => $d8206b3ab2e65c05$export$417391ae30b5922e);
$parcel$export($d8206b3ab2e65c05$exports, "faMicrophoneAlt", () => $d8206b3ab2e65c05$export$f08ef94fea14f5ac);
$parcel$export($d8206b3ab2e65c05$exports, "faPepperHot", () => $d8206b3ab2e65c05$export$4894bf28f771e1f3);
$parcel$export($d8206b3ab2e65c05$exports, "faUnlock", () => $d8206b3ab2e65c05$export$db1382cd406cc506);
$parcel$export($d8206b3ab2e65c05$exports, "faColonSign", () => $d8206b3ab2e65c05$export$dec10d4c2c113312);
$parcel$export($d8206b3ab2e65c05$exports, "faHeadset", () => $d8206b3ab2e65c05$export$23b086400a31acfe);
$parcel$export($d8206b3ab2e65c05$exports, "faStoreSlash", () => $d8206b3ab2e65c05$export$4ab2f33219630bad);
$parcel$export($d8206b3ab2e65c05$exports, "faRoadCircleXmark", () => $d8206b3ab2e65c05$export$2ffc88a4d31e8ffc);
$parcel$export($d8206b3ab2e65c05$exports, "faUserMinus", () => $d8206b3ab2e65c05$export$d6e17c0df8ed1bf7);
$parcel$export($d8206b3ab2e65c05$exports, "faMarsStrokeUp", () => $d8206b3ab2e65c05$export$efc6d53e0dedceee);
$parcel$export($d8206b3ab2e65c05$exports, "faMarsStrokeV", () => $d8206b3ab2e65c05$export$ed7aa1c25104f333);
$parcel$export($d8206b3ab2e65c05$exports, "faChampagneGlasses", () => $d8206b3ab2e65c05$export$7df1926e9eef8cc3);
$parcel$export($d8206b3ab2e65c05$exports, "faGlassCheers", () => $d8206b3ab2e65c05$export$20007d7d74cb98fe);
$parcel$export($d8206b3ab2e65c05$exports, "faClipboard", () => $d8206b3ab2e65c05$export$97d84347d71ba297);
$parcel$export($d8206b3ab2e65c05$exports, "faHouseCircleExclamation", () => $d8206b3ab2e65c05$export$8403e4b31e8aa805);
$parcel$export($d8206b3ab2e65c05$exports, "faFileArrowUp", () => $d8206b3ab2e65c05$export$929df388c07f293d);
$parcel$export($d8206b3ab2e65c05$exports, "faFileUpload", () => $d8206b3ab2e65c05$export$dd55ded1264643d2);
$parcel$export($d8206b3ab2e65c05$exports, "faWifi", () => $d8206b3ab2e65c05$export$1642419fe3db2857);
$parcel$export($d8206b3ab2e65c05$exports, "faWifi3", () => $d8206b3ab2e65c05$export$2349bb04a04f4b2d);
$parcel$export($d8206b3ab2e65c05$exports, "faWifiStrong", () => $d8206b3ab2e65c05$export$4b3167c852f4c4aa);
$parcel$export($d8206b3ab2e65c05$exports, "faBath", () => $d8206b3ab2e65c05$export$1ea66a88b8f620c9);
$parcel$export($d8206b3ab2e65c05$exports, "faBathtub", () => $d8206b3ab2e65c05$export$40ae013b5e6269d8);
$parcel$export($d8206b3ab2e65c05$exports, "faUnderline", () => $d8206b3ab2e65c05$export$22346afd6a3cddf8);
$parcel$export($d8206b3ab2e65c05$exports, "faUserPen", () => $d8206b3ab2e65c05$export$3842882ea09b25af);
$parcel$export($d8206b3ab2e65c05$exports, "faUserEdit", () => $d8206b3ab2e65c05$export$a68a6960fc8eef82);
$parcel$export($d8206b3ab2e65c05$exports, "faSignature", () => $d8206b3ab2e65c05$export$afa7b53ac8ebcb5d);
$parcel$export($d8206b3ab2e65c05$exports, "faStroopwafel", () => $d8206b3ab2e65c05$export$195780ddabd8e0c6);
$parcel$export($d8206b3ab2e65c05$exports, "faBold", () => $d8206b3ab2e65c05$export$7e0c7fd2a2e88823);
$parcel$export($d8206b3ab2e65c05$exports, "faAnchorLock", () => $d8206b3ab2e65c05$export$217195c80db39097);
$parcel$export($d8206b3ab2e65c05$exports, "faBuildingNgo", () => $d8206b3ab2e65c05$export$374e1dce366a2175);
$parcel$export($d8206b3ab2e65c05$exports, "faManatSign", () => $d8206b3ab2e65c05$export$1ff755b523ab2851);
$parcel$export($d8206b3ab2e65c05$exports, "faNotEqual", () => $d8206b3ab2e65c05$export$6a15ccae09bbaf93);
$parcel$export($d8206b3ab2e65c05$exports, "faBorderTopLeft", () => $d8206b3ab2e65c05$export$cf897c3e0abd59e4);
$parcel$export($d8206b3ab2e65c05$exports, "faBorderStyle", () => $d8206b3ab2e65c05$export$c2867ca78120d644);
$parcel$export($d8206b3ab2e65c05$exports, "faMapLocationDot", () => $d8206b3ab2e65c05$export$757f50b8af780c19);
$parcel$export($d8206b3ab2e65c05$exports, "faMapMarkedAlt", () => $d8206b3ab2e65c05$export$a977d47c74d8e86c);
$parcel$export($d8206b3ab2e65c05$exports, "faJedi", () => $d8206b3ab2e65c05$export$859f204e59641ca4);
$parcel$export($d8206b3ab2e65c05$exports, "faSquarePollVertical", () => $d8206b3ab2e65c05$export$91d747e5aabe6fe8);
$parcel$export($d8206b3ab2e65c05$exports, "faPoll", () => $d8206b3ab2e65c05$export$bc8ca14ab51f93db);
$parcel$export($d8206b3ab2e65c05$exports, "faMugHot", () => $d8206b3ab2e65c05$export$47a822c30184e8af);
$parcel$export($d8206b3ab2e65c05$exports, "faCarBattery", () => $d8206b3ab2e65c05$export$a44d0c11093d9c1e);
$parcel$export($d8206b3ab2e65c05$exports, "faBatteryCar", () => $d8206b3ab2e65c05$export$9133165ca669dd4b);
$parcel$export($d8206b3ab2e65c05$exports, "faGift", () => $d8206b3ab2e65c05$export$b2727de8ccdbb5ec);
$parcel$export($d8206b3ab2e65c05$exports, "faDiceTwo", () => $d8206b3ab2e65c05$export$4d85df590065572f);
$parcel$export($d8206b3ab2e65c05$exports, "faChessQueen", () => $d8206b3ab2e65c05$export$7b8ce73615739d30);
$parcel$export($d8206b3ab2e65c05$exports, "faGlasses", () => $d8206b3ab2e65c05$export$58d7d709c0a8ca5f);
$parcel$export($d8206b3ab2e65c05$exports, "faChessBoard", () => $d8206b3ab2e65c05$export$bd301515df6246af);
$parcel$export($d8206b3ab2e65c05$exports, "faBuildingCircleCheck", () => $d8206b3ab2e65c05$export$5559de5f969b9590);
$parcel$export($d8206b3ab2e65c05$exports, "faPersonChalkboard", () => $d8206b3ab2e65c05$export$c9dc1583b207b7ff);
$parcel$export($d8206b3ab2e65c05$exports, "faMarsStrokeRight", () => $d8206b3ab2e65c05$export$321e84e6a900c2d6);
$parcel$export($d8206b3ab2e65c05$exports, "faMarsStrokeH", () => $d8206b3ab2e65c05$export$5cb0daeafbcdabe3);
$parcel$export($d8206b3ab2e65c05$exports, "faHandBackFist", () => $d8206b3ab2e65c05$export$be38a892fe9b4098);
$parcel$export($d8206b3ab2e65c05$exports, "faHandRock", () => $d8206b3ab2e65c05$export$97a81eba394c8c44);
$parcel$export($d8206b3ab2e65c05$exports, "faSquareCaretUp", () => $d8206b3ab2e65c05$export$66068918abb14406);
$parcel$export($d8206b3ab2e65c05$exports, "faCaretSquareUp", () => $d8206b3ab2e65c05$export$307ae80b26533ce5);
$parcel$export($d8206b3ab2e65c05$exports, "faCloudShowersWater", () => $d8206b3ab2e65c05$export$b416056e795d2eac);
$parcel$export($d8206b3ab2e65c05$exports, "faChartBar", () => $d8206b3ab2e65c05$export$b532f5d25de97633);
$parcel$export($d8206b3ab2e65c05$exports, "faBarChart", () => $d8206b3ab2e65c05$export$2d5f754a5e5738b);
$parcel$export($d8206b3ab2e65c05$exports, "faHandsBubbles", () => $d8206b3ab2e65c05$export$2f78563e14e49916);
$parcel$export($d8206b3ab2e65c05$exports, "faHandsWash", () => $d8206b3ab2e65c05$export$996b5dea53b124e3);
$parcel$export($d8206b3ab2e65c05$exports, "faLessThanEqual", () => $d8206b3ab2e65c05$export$b2c723344cff0d8);
$parcel$export($d8206b3ab2e65c05$exports, "faTrain", () => $d8206b3ab2e65c05$export$17cde74bf6f1ee89);
$parcel$export($d8206b3ab2e65c05$exports, "faEyeLowVision", () => $d8206b3ab2e65c05$export$23a892b1a4b994bd);
$parcel$export($d8206b3ab2e65c05$exports, "faLowVision", () => $d8206b3ab2e65c05$export$7a65d2aa54cb4e93);
$parcel$export($d8206b3ab2e65c05$exports, "faCrow", () => $d8206b3ab2e65c05$export$bfa312207b788ed9);
$parcel$export($d8206b3ab2e65c05$exports, "faSailboat", () => $d8206b3ab2e65c05$export$e363e74e36cce80c);
$parcel$export($d8206b3ab2e65c05$exports, "faWindowRestore", () => $d8206b3ab2e65c05$export$eccfff9bfd585652);
$parcel$export($d8206b3ab2e65c05$exports, "faSquarePlus", () => $d8206b3ab2e65c05$export$eaf727acca5a35e4);
$parcel$export($d8206b3ab2e65c05$exports, "faPlusSquare", () => $d8206b3ab2e65c05$export$b6359eebfe900c35);
$parcel$export($d8206b3ab2e65c05$exports, "faToriiGate", () => $d8206b3ab2e65c05$export$75825a4c2b3375e);
$parcel$export($d8206b3ab2e65c05$exports, "faFrog", () => $d8206b3ab2e65c05$export$fe2358263efac504);
$parcel$export($d8206b3ab2e65c05$exports, "faBucket", () => $d8206b3ab2e65c05$export$2124c7628e573b84);
$parcel$export($d8206b3ab2e65c05$exports, "faImage", () => $d8206b3ab2e65c05$export$7e9f0928967e03b);
$parcel$export($d8206b3ab2e65c05$exports, "faMicrophone", () => $d8206b3ab2e65c05$export$eed3c491effe6d12);
$parcel$export($d8206b3ab2e65c05$exports, "faCow", () => $d8206b3ab2e65c05$export$1da3b2e53dcafa2d);
$parcel$export($d8206b3ab2e65c05$exports, "faCaretUp", () => $d8206b3ab2e65c05$export$7de776bdab4e536d);
$parcel$export($d8206b3ab2e65c05$exports, "faScrewdriver", () => $d8206b3ab2e65c05$export$7484ff654cd6474f);
$parcel$export($d8206b3ab2e65c05$exports, "faFolderClosed", () => $d8206b3ab2e65c05$export$5e30548b7f8eeb95);
$parcel$export($d8206b3ab2e65c05$exports, "faHouseTsunami", () => $d8206b3ab2e65c05$export$197b9567e88a0b1d);
$parcel$export($d8206b3ab2e65c05$exports, "faSquareNfi", () => $d8206b3ab2e65c05$export$5498258519fc5b72);
$parcel$export($d8206b3ab2e65c05$exports, "faArrowUpFromGroundWater", () => $d8206b3ab2e65c05$export$cbe485a104805f4f);
$parcel$export($d8206b3ab2e65c05$exports, "faMartiniGlass", () => $d8206b3ab2e65c05$export$98401bb29cff68e0);
$parcel$export($d8206b3ab2e65c05$exports, "faGlassMartiniAlt", () => $d8206b3ab2e65c05$export$2258439b8f4e7acb);
$parcel$export($d8206b3ab2e65c05$exports, "faRotateLeft", () => $d8206b3ab2e65c05$export$7adaa412bd8eb08f);
$parcel$export($d8206b3ab2e65c05$exports, "faRotateBack", () => $d8206b3ab2e65c05$export$9706706f1bc7b12);
$parcel$export($d8206b3ab2e65c05$exports, "faRotateBackward", () => $d8206b3ab2e65c05$export$4ceb0b05fed961a9);
$parcel$export($d8206b3ab2e65c05$exports, "faUndoAlt", () => $d8206b3ab2e65c05$export$c8197b992c46c4a6);
$parcel$export($d8206b3ab2e65c05$exports, "faTableColumns", () => $d8206b3ab2e65c05$export$ccaa019a3fd4563f);
$parcel$export($d8206b3ab2e65c05$exports, "faColumns", () => $d8206b3ab2e65c05$export$bb861166644ac28a);
$parcel$export($d8206b3ab2e65c05$exports, "faLemon", () => $d8206b3ab2e65c05$export$4fbda8f64648f3b5);
$parcel$export($d8206b3ab2e65c05$exports, "faHeadSideMask", () => $d8206b3ab2e65c05$export$280300af4baa1a3e);
$parcel$export($d8206b3ab2e65c05$exports, "faHandshake", () => $d8206b3ab2e65c05$export$b4c63e9bfc7906f1);
$parcel$export($d8206b3ab2e65c05$exports, "faGem", () => $d8206b3ab2e65c05$export$31ee86ac717db552);
$parcel$export($d8206b3ab2e65c05$exports, "faDolly", () => $d8206b3ab2e65c05$export$5879d0bca1aa497b);
$parcel$export($d8206b3ab2e65c05$exports, "faDollyBox", () => $d8206b3ab2e65c05$export$461bbb9e92cc531b);
$parcel$export($d8206b3ab2e65c05$exports, "faSmoking", () => $d8206b3ab2e65c05$export$c4ab83701fc591a5);
$parcel$export($d8206b3ab2e65c05$exports, "faMinimize", () => $d8206b3ab2e65c05$export$e0601b1f239fec74);
$parcel$export($d8206b3ab2e65c05$exports, "faCompressArrowsAlt", () => $d8206b3ab2e65c05$export$39205db0ea980efd);
$parcel$export($d8206b3ab2e65c05$exports, "faMonument", () => $d8206b3ab2e65c05$export$6f9b0bfc012deb25);
$parcel$export($d8206b3ab2e65c05$exports, "faSnowplow", () => $d8206b3ab2e65c05$export$695fae58f55c3a87);
$parcel$export($d8206b3ab2e65c05$exports, "faAnglesRight", () => $d8206b3ab2e65c05$export$48b60f1720e09944);
$parcel$export($d8206b3ab2e65c05$exports, "faAngleDoubleRight", () => $d8206b3ab2e65c05$export$792931403404faf0);
$parcel$export($d8206b3ab2e65c05$exports, "faCannabis", () => $d8206b3ab2e65c05$export$8ec2f752344b69bd);
$parcel$export($d8206b3ab2e65c05$exports, "faCirclePlay", () => $d8206b3ab2e65c05$export$86c4e45dc3302d15);
$parcel$export($d8206b3ab2e65c05$exports, "faPlayCircle", () => $d8206b3ab2e65c05$export$cf04333781061c5e);
$parcel$export($d8206b3ab2e65c05$exports, "faTablets", () => $d8206b3ab2e65c05$export$bed2b0ed4ae45e0d);
$parcel$export($d8206b3ab2e65c05$exports, "faEthernet", () => $d8206b3ab2e65c05$export$6bad2c9f317b52e5);
$parcel$export($d8206b3ab2e65c05$exports, "faEuroSign", () => $d8206b3ab2e65c05$export$902a3969bb113dff);
$parcel$export($d8206b3ab2e65c05$exports, "faEur", () => $d8206b3ab2e65c05$export$4b859160cfeb12ff);
$parcel$export($d8206b3ab2e65c05$exports, "faEuro", () => $d8206b3ab2e65c05$export$bdabbefede2d3a2);
$parcel$export($d8206b3ab2e65c05$exports, "faChair", () => $d8206b3ab2e65c05$export$a339864ee3df7e9a);
$parcel$export($d8206b3ab2e65c05$exports, "faCircleCheck", () => $d8206b3ab2e65c05$export$c2e9877668862374);
$parcel$export($d8206b3ab2e65c05$exports, "faCheckCircle", () => $d8206b3ab2e65c05$export$be9e388158c74f29);
$parcel$export($d8206b3ab2e65c05$exports, "faCircleStop", () => $d8206b3ab2e65c05$export$229de76dfef2687f);
$parcel$export($d8206b3ab2e65c05$exports, "faStopCircle", () => $d8206b3ab2e65c05$export$47af2aad60ab3e7c);
$parcel$export($d8206b3ab2e65c05$exports, "faCompassDrafting", () => $d8206b3ab2e65c05$export$aaaddd2cf7e20f64);
$parcel$export($d8206b3ab2e65c05$exports, "faDraftingCompass", () => $d8206b3ab2e65c05$export$c8c2b127d13b9d79);
$parcel$export($d8206b3ab2e65c05$exports, "faPlateWheat", () => $d8206b3ab2e65c05$export$2eff9f6cbe00a643);
$parcel$export($d8206b3ab2e65c05$exports, "faIcicles", () => $d8206b3ab2e65c05$export$78792ed87d92a3ad);
$parcel$export($d8206b3ab2e65c05$exports, "faPersonShelter", () => $d8206b3ab2e65c05$export$d359c2cc7640953c);
$parcel$export($d8206b3ab2e65c05$exports, "faNeuter", () => $d8206b3ab2e65c05$export$771cf879fba0cf93);
$parcel$export($d8206b3ab2e65c05$exports, "faIdBadge", () => $d8206b3ab2e65c05$export$a75288855ea05282);
$parcel$export($d8206b3ab2e65c05$exports, "faMarker", () => $d8206b3ab2e65c05$export$e6789173649caa25);
$parcel$export($d8206b3ab2e65c05$exports, "faFaceLaughBeam", () => $d8206b3ab2e65c05$export$3f2d51c0547bf984);
$parcel$export($d8206b3ab2e65c05$exports, "faLaughBeam", () => $d8206b3ab2e65c05$export$a88d1f4073ea9369);
$parcel$export($d8206b3ab2e65c05$exports, "faHelicopterSymbol", () => $d8206b3ab2e65c05$export$2a66e6044c1f7036);
$parcel$export($d8206b3ab2e65c05$exports, "faUniversalAccess", () => $d8206b3ab2e65c05$export$e119aada7f690d05);
$parcel$export($d8206b3ab2e65c05$exports, "faCircleChevronUp", () => $d8206b3ab2e65c05$export$7b69b3617b84259b);
$parcel$export($d8206b3ab2e65c05$exports, "faChevronCircleUp", () => $d8206b3ab2e65c05$export$b786cf5db03f2c36);
$parcel$export($d8206b3ab2e65c05$exports, "faLariSign", () => $d8206b3ab2e65c05$export$d317bc452442782d);
$parcel$export($d8206b3ab2e65c05$exports, "faVolcano", () => $d8206b3ab2e65c05$export$bae30a76735500e1);
$parcel$export($d8206b3ab2e65c05$exports, "faPersonWalkingDashedLineArrowRight", () => $d8206b3ab2e65c05$export$a1d09c95bee8043b);
$parcel$export($d8206b3ab2e65c05$exports, "faSterlingSign", () => $d8206b3ab2e65c05$export$170c56774c8e7961);
$parcel$export($d8206b3ab2e65c05$exports, "faGbp", () => $d8206b3ab2e65c05$export$3d9479ec1d1ae83e);
$parcel$export($d8206b3ab2e65c05$exports, "faPoundSign", () => $d8206b3ab2e65c05$export$9ce041dfec8319b);
$parcel$export($d8206b3ab2e65c05$exports, "faViruses", () => $d8206b3ab2e65c05$export$ee194b18f5c6f6b6);
$parcel$export($d8206b3ab2e65c05$exports, "faSquarePersonConfined", () => $d8206b3ab2e65c05$export$8aaca358568da0e0);
$parcel$export($d8206b3ab2e65c05$exports, "faUserTie", () => $d8206b3ab2e65c05$export$48c51dda34e9f04c);
$parcel$export($d8206b3ab2e65c05$exports, "faArrowDownLong", () => $d8206b3ab2e65c05$export$5977e8de7e65b20);
$parcel$export($d8206b3ab2e65c05$exports, "faLongArrowDown", () => $d8206b3ab2e65c05$export$52ecf90b62f3f030);
$parcel$export($d8206b3ab2e65c05$exports, "faTentArrowDownToLine", () => $d8206b3ab2e65c05$export$8a4f323f00a91606);
$parcel$export($d8206b3ab2e65c05$exports, "faCertificate", () => $d8206b3ab2e65c05$export$a881f37164b11fbf);
$parcel$export($d8206b3ab2e65c05$exports, "faReplyAll", () => $d8206b3ab2e65c05$export$ca6fd367f31ecbc5);
$parcel$export($d8206b3ab2e65c05$exports, "faMailReplyAll", () => $d8206b3ab2e65c05$export$8274334f3a2c1841);
$parcel$export($d8206b3ab2e65c05$exports, "faSuitcase", () => $d8206b3ab2e65c05$export$60710f3921019268);
$parcel$export($d8206b3ab2e65c05$exports, "faPersonSkating", () => $d8206b3ab2e65c05$export$f3854553fe688388);
$parcel$export($d8206b3ab2e65c05$exports, "faSkating", () => $d8206b3ab2e65c05$export$21bd1d54bd4f2c5a);
$parcel$export($d8206b3ab2e65c05$exports, "faFilterCircleDollar", () => $d8206b3ab2e65c05$export$3300e4b4d1d1936f);
$parcel$export($d8206b3ab2e65c05$exports, "faFunnelDollar", () => $d8206b3ab2e65c05$export$cebe38ad8f0a143d);
$parcel$export($d8206b3ab2e65c05$exports, "faCameraRetro", () => $d8206b3ab2e65c05$export$41dbdadc07a89b05);
$parcel$export($d8206b3ab2e65c05$exports, "faCircleArrowDown", () => $d8206b3ab2e65c05$export$a30c52cde32bec7e);
$parcel$export($d8206b3ab2e65c05$exports, "faArrowCircleDown", () => $d8206b3ab2e65c05$export$6cfa36bbb3a057);
$parcel$export($d8206b3ab2e65c05$exports, "faFileImport", () => $d8206b3ab2e65c05$export$d796c05153b1255c);
$parcel$export($d8206b3ab2e65c05$exports, "faArrowRightToFile", () => $d8206b3ab2e65c05$export$32f14beaf6294476);
$parcel$export($d8206b3ab2e65c05$exports, "faSquareArrowUpRight", () => $d8206b3ab2e65c05$export$38150b61dfd06fff);
$parcel$export($d8206b3ab2e65c05$exports, "faExternalLinkSquare", () => $d8206b3ab2e65c05$export$e04d83fed5ebcebf);
$parcel$export($d8206b3ab2e65c05$exports, "faBoxOpen", () => $d8206b3ab2e65c05$export$9010ed816a8b9c97);
$parcel$export($d8206b3ab2e65c05$exports, "faScroll", () => $d8206b3ab2e65c05$export$7c265716d4399676);
$parcel$export($d8206b3ab2e65c05$exports, "faSpa", () => $d8206b3ab2e65c05$export$f9a38ef7b046ab51);
$parcel$export($d8206b3ab2e65c05$exports, "faLocationPinLock", () => $d8206b3ab2e65c05$export$db853fbb474326cc);
$parcel$export($d8206b3ab2e65c05$exports, "faPause", () => $d8206b3ab2e65c05$export$da79f048408b1722);
$parcel$export($d8206b3ab2e65c05$exports, "faHillAvalanche", () => $d8206b3ab2e65c05$export$50d11c98c99e3b2d);
$parcel$export($d8206b3ab2e65c05$exports, "faTemperatureEmpty", () => $d8206b3ab2e65c05$export$ac389bf5cc37feb5);
$parcel$export($d8206b3ab2e65c05$exports, "faTemperature0", () => $d8206b3ab2e65c05$export$e99b7d2ccc282383);
$parcel$export($d8206b3ab2e65c05$exports, "faThermometer0", () => $d8206b3ab2e65c05$export$4c13a186ecce3b80);
$parcel$export($d8206b3ab2e65c05$exports, "faThermometerEmpty", () => $d8206b3ab2e65c05$export$81a2f8298cf523f9);
$parcel$export($d8206b3ab2e65c05$exports, "faBomb", () => $d8206b3ab2e65c05$export$d59078f6e80b4a67);
$parcel$export($d8206b3ab2e65c05$exports, "faRegistered", () => $d8206b3ab2e65c05$export$5f519e9ac15ab8c3);
$parcel$export($d8206b3ab2e65c05$exports, "faAddressCard", () => $d8206b3ab2e65c05$export$6ea408c7266ed557);
$parcel$export($d8206b3ab2e65c05$exports, "faContactCard", () => $d8206b3ab2e65c05$export$4ac51eb0b298b190);
$parcel$export($d8206b3ab2e65c05$exports, "faVcard", () => $d8206b3ab2e65c05$export$91228257deb1bf18);
$parcel$export($d8206b3ab2e65c05$exports, "faScaleUnbalancedFlip", () => $d8206b3ab2e65c05$export$f4d7840209109993);
$parcel$export($d8206b3ab2e65c05$exports, "faBalanceScaleRight", () => $d8206b3ab2e65c05$export$2238e05f8920005a);
$parcel$export($d8206b3ab2e65c05$exports, "faSubscript", () => $d8206b3ab2e65c05$export$34c1e678c32ed646);
$parcel$export($d8206b3ab2e65c05$exports, "faDiamondTurnRight", () => $d8206b3ab2e65c05$export$99749ac517cbef07);
$parcel$export($d8206b3ab2e65c05$exports, "faDirections", () => $d8206b3ab2e65c05$export$6a6973de44442fe5);
$parcel$export($d8206b3ab2e65c05$exports, "faBurst", () => $d8206b3ab2e65c05$export$ea2986b45ba5d2cf);
$parcel$export($d8206b3ab2e65c05$exports, "faHouseLaptop", () => $d8206b3ab2e65c05$export$6486d62e77b910);
$parcel$export($d8206b3ab2e65c05$exports, "faLaptopHouse", () => $d8206b3ab2e65c05$export$efd983de5e4d6ad3);
$parcel$export($d8206b3ab2e65c05$exports, "faFaceTired", () => $d8206b3ab2e65c05$export$5352cbdc070ce8d);
$parcel$export($d8206b3ab2e65c05$exports, "faTired", () => $d8206b3ab2e65c05$export$3d016d62cda18371);
$parcel$export($d8206b3ab2e65c05$exports, "faMoneyBills", () => $d8206b3ab2e65c05$export$a822dad6e586ee9e);
$parcel$export($d8206b3ab2e65c05$exports, "faSmog", () => $d8206b3ab2e65c05$export$aa11b8edb09fed14);
$parcel$export($d8206b3ab2e65c05$exports, "faCrutch", () => $d8206b3ab2e65c05$export$e94134641c0e2);
$parcel$export($d8206b3ab2e65c05$exports, "faFontAwesome", () => $d8206b3ab2e65c05$export$aa4baaed1c60f58d);
$parcel$export($d8206b3ab2e65c05$exports, "faFontAwesomeFlag", () => $d8206b3ab2e65c05$export$102c25fde54d4843);
$parcel$export($d8206b3ab2e65c05$exports, "faFontAwesomeLogoFull", () => $d8206b3ab2e65c05$export$6e20d421a2e0f320);
$parcel$export($d8206b3ab2e65c05$exports, "faCloudArrowUp", () => $d8206b3ab2e65c05$export$3507214fff1cc655);
$parcel$export($d8206b3ab2e65c05$exports, "faCloudUpload", () => $d8206b3ab2e65c05$export$a48720e6366f5d9a);
$parcel$export($d8206b3ab2e65c05$exports, "faCloudUploadAlt", () => $d8206b3ab2e65c05$export$e73b3e819b9d14a5);
$parcel$export($d8206b3ab2e65c05$exports, "faPalette", () => $d8206b3ab2e65c05$export$5c390baea5db4f77);
$parcel$export($d8206b3ab2e65c05$exports, "faArrowsTurnRight", () => $d8206b3ab2e65c05$export$db9f783f15682c4a);
$parcel$export($d8206b3ab2e65c05$exports, "faVest", () => $d8206b3ab2e65c05$export$c8370e53051a657);
$parcel$export($d8206b3ab2e65c05$exports, "faFerry", () => $d8206b3ab2e65c05$export$fd312949b97346ae);
$parcel$export($d8206b3ab2e65c05$exports, "faArrowsDownToPeople", () => $d8206b3ab2e65c05$export$cfb044c7d35060bb);
$parcel$export($d8206b3ab2e65c05$exports, "faSeedling", () => $d8206b3ab2e65c05$export$d7b60b8dbd03cfe4);
$parcel$export($d8206b3ab2e65c05$exports, "faSprout", () => $d8206b3ab2e65c05$export$9f3035e3a8c62323);
$parcel$export($d8206b3ab2e65c05$exports, "faLeftRight", () => $d8206b3ab2e65c05$export$47d93e9001818ee7);
$parcel$export($d8206b3ab2e65c05$exports, "faArrowsAltH", () => $d8206b3ab2e65c05$export$7937ea574fb1389);
$parcel$export($d8206b3ab2e65c05$exports, "faBoxesPacking", () => $d8206b3ab2e65c05$export$e81e7f3390fe84fe);
$parcel$export($d8206b3ab2e65c05$exports, "faCircleArrowLeft", () => $d8206b3ab2e65c05$export$827fbb87bdbe1028);
$parcel$export($d8206b3ab2e65c05$exports, "faArrowCircleLeft", () => $d8206b3ab2e65c05$export$728262abb9f58d0a);
$parcel$export($d8206b3ab2e65c05$exports, "faGroupArrowsRotate", () => $d8206b3ab2e65c05$export$88a8383ecdd39a54);
$parcel$export($d8206b3ab2e65c05$exports, "faBowlFood", () => $d8206b3ab2e65c05$export$8b89ca3201039376);
$parcel$export($d8206b3ab2e65c05$exports, "faCandyCane", () => $d8206b3ab2e65c05$export$14d66ba7571ae0b9);
$parcel$export($d8206b3ab2e65c05$exports, "faArrowDownWideShort", () => $d8206b3ab2e65c05$export$4229d00802c33062);
$parcel$export($d8206b3ab2e65c05$exports, "faSortAmountAsc", () => $d8206b3ab2e65c05$export$ddf8b8dd5983367d);
$parcel$export($d8206b3ab2e65c05$exports, "faSortAmountDown", () => $d8206b3ab2e65c05$export$4b2a02d50e417b5f);
$parcel$export($d8206b3ab2e65c05$exports, "faCloudBolt", () => $d8206b3ab2e65c05$export$cdd116afa0309c17);
$parcel$export($d8206b3ab2e65c05$exports, "faThunderstorm", () => $d8206b3ab2e65c05$export$bbf9e3d433f8f6de);
$parcel$export($d8206b3ab2e65c05$exports, "faTextSlash", () => $d8206b3ab2e65c05$export$ec658c0f040c3e1a);
$parcel$export($d8206b3ab2e65c05$exports, "faRemoveFormat", () => $d8206b3ab2e65c05$export$d91179f327329532);
$parcel$export($d8206b3ab2e65c05$exports, "faFaceSmileWink", () => $d8206b3ab2e65c05$export$6143da800b0e6626);
$parcel$export($d8206b3ab2e65c05$exports, "faSmileWink", () => $d8206b3ab2e65c05$export$f5dbb37f6801ee3f);
$parcel$export($d8206b3ab2e65c05$exports, "faFileWord", () => $d8206b3ab2e65c05$export$f0858dff6e769cf6);
$parcel$export($d8206b3ab2e65c05$exports, "faFilePowerpoint", () => $d8206b3ab2e65c05$export$c341daeecdea449a);
$parcel$export($d8206b3ab2e65c05$exports, "faArrowsLeftRight", () => $d8206b3ab2e65c05$export$672e2f590b189583);
$parcel$export($d8206b3ab2e65c05$exports, "faArrowsH", () => $d8206b3ab2e65c05$export$de517642cdb40354);
$parcel$export($d8206b3ab2e65c05$exports, "faHouseLock", () => $d8206b3ab2e65c05$export$aa54b16c409e882f);
$parcel$export($d8206b3ab2e65c05$exports, "faCloudArrowDown", () => $d8206b3ab2e65c05$export$542a9676c5286e01);
$parcel$export($d8206b3ab2e65c05$exports, "faCloudDownload", () => $d8206b3ab2e65c05$export$b318977f29260464);
$parcel$export($d8206b3ab2e65c05$exports, "faCloudDownloadAlt", () => $d8206b3ab2e65c05$export$351357a14c41f824);
$parcel$export($d8206b3ab2e65c05$exports, "faChildren", () => $d8206b3ab2e65c05$export$f2819bf60df55912);
$parcel$export($d8206b3ab2e65c05$exports, "faChalkboard", () => $d8206b3ab2e65c05$export$49a36efd66df775);
$parcel$export($d8206b3ab2e65c05$exports, "faBlackboard", () => $d8206b3ab2e65c05$export$f497e01bf522fd9c);
$parcel$export($d8206b3ab2e65c05$exports, "faUserLargeSlash", () => $d8206b3ab2e65c05$export$ae7fc6b7f0534be9);
$parcel$export($d8206b3ab2e65c05$exports, "faUserAltSlash", () => $d8206b3ab2e65c05$export$46185fab4772ada6);
$parcel$export($d8206b3ab2e65c05$exports, "faEnvelopeOpen", () => $d8206b3ab2e65c05$export$c6c3bd5f7d9b8bf2);
$parcel$export($d8206b3ab2e65c05$exports, "faHandshakeSimpleSlash", () => $d8206b3ab2e65c05$export$e99ae494101c5e91);
$parcel$export($d8206b3ab2e65c05$exports, "faHandshakeAltSlash", () => $d8206b3ab2e65c05$export$ca302f956ae9f1bf);
$parcel$export($d8206b3ab2e65c05$exports, "faMattressPillow", () => $d8206b3ab2e65c05$export$f042d3e458efa721);
$parcel$export($d8206b3ab2e65c05$exports, "faGuaraniSign", () => $d8206b3ab2e65c05$export$b731a51acb74b00c);
$parcel$export($d8206b3ab2e65c05$exports, "faArrowsRotate", () => $d8206b3ab2e65c05$export$2fd091cb98dc8ab8);
$parcel$export($d8206b3ab2e65c05$exports, "faRefresh", () => $d8206b3ab2e65c05$export$fd4359e93d7b3d14);
$parcel$export($d8206b3ab2e65c05$exports, "faSync", () => $d8206b3ab2e65c05$export$ff87319002e3dae9);
$parcel$export($d8206b3ab2e65c05$exports, "faFireExtinguisher", () => $d8206b3ab2e65c05$export$d75fb6743634a0a);
$parcel$export($d8206b3ab2e65c05$exports, "faCruzeiroSign", () => $d8206b3ab2e65c05$export$64dd1b27affb6572);
$parcel$export($d8206b3ab2e65c05$exports, "faGreaterThanEqual", () => $d8206b3ab2e65c05$export$7bf8dfe2e6661a54);
$parcel$export($d8206b3ab2e65c05$exports, "faShieldHalved", () => $d8206b3ab2e65c05$export$36e034ccc72554a9);
$parcel$export($d8206b3ab2e65c05$exports, "faShieldAlt", () => $d8206b3ab2e65c05$export$d6508d18a824f291);
$parcel$export($d8206b3ab2e65c05$exports, "faBookAtlas", () => $d8206b3ab2e65c05$export$7fb8daedae341012);
$parcel$export($d8206b3ab2e65c05$exports, "faAtlas", () => $d8206b3ab2e65c05$export$380a9050e42fe5d7);
$parcel$export($d8206b3ab2e65c05$exports, "faVirus", () => $d8206b3ab2e65c05$export$37c67e0b3dc6bd1b);
$parcel$export($d8206b3ab2e65c05$exports, "faEnvelopeCircleCheck", () => $d8206b3ab2e65c05$export$74d890536dbd21b7);
$parcel$export($d8206b3ab2e65c05$exports, "faLayerGroup", () => $d8206b3ab2e65c05$export$a137712e11e257dd);
$parcel$export($d8206b3ab2e65c05$exports, "faArrowsToDot", () => $d8206b3ab2e65c05$export$ab3a06d4b53c0fc0);
$parcel$export($d8206b3ab2e65c05$exports, "faArchway", () => $d8206b3ab2e65c05$export$d56753dd2eb5c323);
$parcel$export($d8206b3ab2e65c05$exports, "faHeartCircleCheck", () => $d8206b3ab2e65c05$export$5e4b6785eedecc1a);
$parcel$export($d8206b3ab2e65c05$exports, "faHouseChimneyCrack", () => $d8206b3ab2e65c05$export$e824540f5a6a8a57);
$parcel$export($d8206b3ab2e65c05$exports, "faHouseDamage", () => $d8206b3ab2e65c05$export$8d7e943005ce0b49);
$parcel$export($d8206b3ab2e65c05$exports, "faFileZipper", () => $d8206b3ab2e65c05$export$7a4a0e4caa1e4e6f);
$parcel$export($d8206b3ab2e65c05$exports, "faFileArchive", () => $d8206b3ab2e65c05$export$bf2047a9946b5c3f);
$parcel$export($d8206b3ab2e65c05$exports, "faSquare", () => $d8206b3ab2e65c05$export$90b4406457aae8cc);
$parcel$export($d8206b3ab2e65c05$exports, "faMartiniGlassEmpty", () => $d8206b3ab2e65c05$export$a8a0de30198815a3);
$parcel$export($d8206b3ab2e65c05$exports, "faGlassMartini", () => $d8206b3ab2e65c05$export$e96f280e39af4a91);
$parcel$export($d8206b3ab2e65c05$exports, "faCouch", () => $d8206b3ab2e65c05$export$ce96e32767a7dd51);
$parcel$export($d8206b3ab2e65c05$exports, "faCediSign", () => $d8206b3ab2e65c05$export$66c557f70914132c);
$parcel$export($d8206b3ab2e65c05$exports, "faItalic", () => $d8206b3ab2e65c05$export$16e344bae4d495ed);
$parcel$export($d8206b3ab2e65c05$exports, "faChurch", () => $d8206b3ab2e65c05$export$16a3f12c6ae9650);
$parcel$export($d8206b3ab2e65c05$exports, "faCommentsDollar", () => $d8206b3ab2e65c05$export$d477129b070e5ac4);
$parcel$export($d8206b3ab2e65c05$exports, "faDemocrat", () => $d8206b3ab2e65c05$export$a1672d808fbed0bd);
$parcel$export($d8206b3ab2e65c05$exports, "faZ", () => $d8206b3ab2e65c05$export$3481c1aa28972f9b);
$parcel$export($d8206b3ab2e65c05$exports, "faPersonSkiing", () => $d8206b3ab2e65c05$export$5ebd3cd0630e3ae7);
$parcel$export($d8206b3ab2e65c05$exports, "faSkiing", () => $d8206b3ab2e65c05$export$eae1acab6fb96708);
$parcel$export($d8206b3ab2e65c05$exports, "faRoadLock", () => $d8206b3ab2e65c05$export$b81a894d5bc3eb17);
$parcel$export($d8206b3ab2e65c05$exports, "faA", () => $d8206b3ab2e65c05$export$406fe05808a3753e);
$parcel$export($d8206b3ab2e65c05$exports, "faTemperatureArrowDown", () => $d8206b3ab2e65c05$export$4520eb1840c4e110);
$parcel$export($d8206b3ab2e65c05$exports, "faTemperatureDown", () => $d8206b3ab2e65c05$export$f0b2aca3866f00f6);
$parcel$export($d8206b3ab2e65c05$exports, "faFeatherPointed", () => $d8206b3ab2e65c05$export$2a9d3e120019c92d);
$parcel$export($d8206b3ab2e65c05$exports, "faFeatherAlt", () => $d8206b3ab2e65c05$export$68cf766c786bcd78);
$parcel$export($d8206b3ab2e65c05$exports, "faP", () => $d8206b3ab2e65c05$export$bcb419f1cd5beac3);
$parcel$export($d8206b3ab2e65c05$exports, "faSnowflake", () => $d8206b3ab2e65c05$export$bab8f3647c394f48);
$parcel$export($d8206b3ab2e65c05$exports, "faNewspaper", () => $d8206b3ab2e65c05$export$d91b374112d4f8c1);
$parcel$export($d8206b3ab2e65c05$exports, "faRectangleAd", () => $d8206b3ab2e65c05$export$d0ccaddca9e06d1e);
$parcel$export($d8206b3ab2e65c05$exports, "faAd", () => $d8206b3ab2e65c05$export$7af266c3465b1ff2);
$parcel$export($d8206b3ab2e65c05$exports, "faCircleArrowRight", () => $d8206b3ab2e65c05$export$2f1e22e081a1ad05);
$parcel$export($d8206b3ab2e65c05$exports, "faArrowCircleRight", () => $d8206b3ab2e65c05$export$7d3d828103aa3be7);
$parcel$export($d8206b3ab2e65c05$exports, "faFilterCircleXmark", () => $d8206b3ab2e65c05$export$fb5ab619c34ea613);
$parcel$export($d8206b3ab2e65c05$exports, "faLocust", () => $d8206b3ab2e65c05$export$4982360d3b844c19);
$parcel$export($d8206b3ab2e65c05$exports, "faSort", () => $d8206b3ab2e65c05$export$4941c5969d5399b);
$parcel$export($d8206b3ab2e65c05$exports, "faUnsorted", () => $d8206b3ab2e65c05$export$418597748f0fe52d);
$parcel$export($d8206b3ab2e65c05$exports, "faListOl", () => $d8206b3ab2e65c05$export$3db8f67cd0fc963b);
$parcel$export($d8206b3ab2e65c05$exports, "faList12", () => $d8206b3ab2e65c05$export$7e3d894cd55296b);
$parcel$export($d8206b3ab2e65c05$exports, "faListNumeric", () => $d8206b3ab2e65c05$export$cf51408faadac277);
$parcel$export($d8206b3ab2e65c05$exports, "faPersonDressBurst", () => $d8206b3ab2e65c05$export$523180e731928397);
$parcel$export($d8206b3ab2e65c05$exports, "faMoneyCheckDollar", () => $d8206b3ab2e65c05$export$eeb59dd1825c6a65);
$parcel$export($d8206b3ab2e65c05$exports, "faMoneyCheckAlt", () => $d8206b3ab2e65c05$export$8c6ccc9745897cb2);
$parcel$export($d8206b3ab2e65c05$exports, "faVectorSquare", () => $d8206b3ab2e65c05$export$567d5631a7b0599f);
$parcel$export($d8206b3ab2e65c05$exports, "faBreadSlice", () => $d8206b3ab2e65c05$export$d78e8b0681279167);
$parcel$export($d8206b3ab2e65c05$exports, "faLanguage", () => $d8206b3ab2e65c05$export$8a7bee49fdf8c954);
$parcel$export($d8206b3ab2e65c05$exports, "faFaceKissWinkHeart", () => $d8206b3ab2e65c05$export$611ae61f02de0aa);
$parcel$export($d8206b3ab2e65c05$exports, "faKissWinkHeart", () => $d8206b3ab2e65c05$export$ebba617701dfb917);
$parcel$export($d8206b3ab2e65c05$exports, "faFilter", () => $d8206b3ab2e65c05$export$f253a38d7142e29f);
$parcel$export($d8206b3ab2e65c05$exports, "faQuestion", () => $d8206b3ab2e65c05$export$d96973f90e8f6e47);
$parcel$export($d8206b3ab2e65c05$exports, "faFileSignature", () => $d8206b3ab2e65c05$export$d0de575ac166712b);
$parcel$export($d8206b3ab2e65c05$exports, "faUpDownLeftRight", () => $d8206b3ab2e65c05$export$cd7b22f4e6e3834b);
$parcel$export($d8206b3ab2e65c05$exports, "faArrowsAlt", () => $d8206b3ab2e65c05$export$3cdabfff52cfc73a);
$parcel$export($d8206b3ab2e65c05$exports, "faHouseChimneyUser", () => $d8206b3ab2e65c05$export$1ddbaebce033a0d);
$parcel$export($d8206b3ab2e65c05$exports, "faHandHoldingHeart", () => $d8206b3ab2e65c05$export$97e5ef3e80a0fbef);
$parcel$export($d8206b3ab2e65c05$exports, "faPuzzlePiece", () => $d8206b3ab2e65c05$export$7ee0dbd1e92e2859);
$parcel$export($d8206b3ab2e65c05$exports, "faMoneyCheck", () => $d8206b3ab2e65c05$export$be069f641c85d0b3);
$parcel$export($d8206b3ab2e65c05$exports, "faStarHalfStroke", () => $d8206b3ab2e65c05$export$3e4892d8bf919edd);
$parcel$export($d8206b3ab2e65c05$exports, "faStarHalfAlt", () => $d8206b3ab2e65c05$export$c13575f42532efb3);
$parcel$export($d8206b3ab2e65c05$exports, "faCode", () => $d8206b3ab2e65c05$export$eba095993e51cc97);
$parcel$export($d8206b3ab2e65c05$exports, "faWhiskeyGlass", () => $d8206b3ab2e65c05$export$f1304dd34ea2afbd);
$parcel$export($d8206b3ab2e65c05$exports, "faGlassWhiskey", () => $d8206b3ab2e65c05$export$fdec0f5f1a169419);
$parcel$export($d8206b3ab2e65c05$exports, "faBuildingCircleExclamation", () => $d8206b3ab2e65c05$export$c49f030b19083ebe);
$parcel$export($d8206b3ab2e65c05$exports, "faMagnifyingGlassChart", () => $d8206b3ab2e65c05$export$6a1e4cdbb8ca10c5);
$parcel$export($d8206b3ab2e65c05$exports, "faArrowUpRightFromSquare", () => $d8206b3ab2e65c05$export$5ad84e891223f2c3);
$parcel$export($d8206b3ab2e65c05$exports, "faExternalLink", () => $d8206b3ab2e65c05$export$f4c613289034e5ef);
$parcel$export($d8206b3ab2e65c05$exports, "faCubesStacked", () => $d8206b3ab2e65c05$export$b1f00c433aabac05);
$parcel$export($d8206b3ab2e65c05$exports, "faWonSign", () => $d8206b3ab2e65c05$export$51790ddd26e431bc);
$parcel$export($d8206b3ab2e65c05$exports, "faKrw", () => $d8206b3ab2e65c05$export$2f65e07a45b95b50);
$parcel$export($d8206b3ab2e65c05$exports, "faWon", () => $d8206b3ab2e65c05$export$5a1fd3ed9564d7fa);
$parcel$export($d8206b3ab2e65c05$exports, "faVirusCovid", () => $d8206b3ab2e65c05$export$1df4e031b8ee4f84);
$parcel$export($d8206b3ab2e65c05$exports, "faAustralSign", () => $d8206b3ab2e65c05$export$299c200ad3db97b4);
$parcel$export($d8206b3ab2e65c05$exports, "faF", () => $d8206b3ab2e65c05$export$a2f384a559654618);
$parcel$export($d8206b3ab2e65c05$exports, "faLeaf", () => $d8206b3ab2e65c05$export$7c497bae2754a087);
$parcel$export($d8206b3ab2e65c05$exports, "faRoad", () => $d8206b3ab2e65c05$export$f224567a4851a5e9);
$parcel$export($d8206b3ab2e65c05$exports, "faTaxi", () => $d8206b3ab2e65c05$export$9958afcdfece1b58);
$parcel$export($d8206b3ab2e65c05$exports, "faCab", () => $d8206b3ab2e65c05$export$7bf12d9380f0971b);
$parcel$export($d8206b3ab2e65c05$exports, "faPersonCirclePlus", () => $d8206b3ab2e65c05$export$55686b1eb7d00307);
$parcel$export($d8206b3ab2e65c05$exports, "faChartPie", () => $d8206b3ab2e65c05$export$1de7b9cf7d1b153b);
$parcel$export($d8206b3ab2e65c05$exports, "faPieChart", () => $d8206b3ab2e65c05$export$7877286cd337de81);
$parcel$export($d8206b3ab2e65c05$exports, "faBoltLightning", () => $d8206b3ab2e65c05$export$b16dcd08f3da1ba2);
$parcel$export($d8206b3ab2e65c05$exports, "faSackXmark", () => $d8206b3ab2e65c05$export$2bad98c38bea5994);
$parcel$export($d8206b3ab2e65c05$exports, "faFileExcel", () => $d8206b3ab2e65c05$export$77cb1a465c4fe84);
$parcel$export($d8206b3ab2e65c05$exports, "faFileContract", () => $d8206b3ab2e65c05$export$70fde3f3fdaa6a6a);
$parcel$export($d8206b3ab2e65c05$exports, "faFishFins", () => $d8206b3ab2e65c05$export$e7af4f0123222b6f);
$parcel$export($d8206b3ab2e65c05$exports, "faBuildingFlag", () => $d8206b3ab2e65c05$export$592422b29ab0a914);
$parcel$export($d8206b3ab2e65c05$exports, "faFaceGrinBeam", () => $d8206b3ab2e65c05$export$3de52eeb00462407);
$parcel$export($d8206b3ab2e65c05$exports, "faGrinBeam", () => $d8206b3ab2e65c05$export$734da5249381ec7e);
$parcel$export($d8206b3ab2e65c05$exports, "faObjectUngroup", () => $d8206b3ab2e65c05$export$887f6345573abcac);
$parcel$export($d8206b3ab2e65c05$exports, "faPoop", () => $d8206b3ab2e65c05$export$bb45b6b87d1adf27);
$parcel$export($d8206b3ab2e65c05$exports, "faLocationPin", () => $d8206b3ab2e65c05$export$c0b7617de95c0c05);
$parcel$export($d8206b3ab2e65c05$exports, "faMapMarker", () => $d8206b3ab2e65c05$export$10d360e4f1a554dd);
$parcel$export($d8206b3ab2e65c05$exports, "faKaaba", () => $d8206b3ab2e65c05$export$ab1408bfbe914cc9);
$parcel$export($d8206b3ab2e65c05$exports, "faToiletPaper", () => $d8206b3ab2e65c05$export$c8cc083ccc72b17);
$parcel$export($d8206b3ab2e65c05$exports, "faHelmetSafety", () => $d8206b3ab2e65c05$export$aacaf42fba617981);
$parcel$export($d8206b3ab2e65c05$exports, "faHardHat", () => $d8206b3ab2e65c05$export$7b72177558a98b6f);
$parcel$export($d8206b3ab2e65c05$exports, "faHatHard", () => $d8206b3ab2e65c05$export$c0e235dbf1644a2f);
$parcel$export($d8206b3ab2e65c05$exports, "faEject", () => $d8206b3ab2e65c05$export$8484041d5b209494);
$parcel$export($d8206b3ab2e65c05$exports, "faCircleRight", () => $d8206b3ab2e65c05$export$1fec48c8bdd69c1d);
$parcel$export($d8206b3ab2e65c05$exports, "faArrowAltCircleRight", () => $d8206b3ab2e65c05$export$88962ffdad8b856d);
$parcel$export($d8206b3ab2e65c05$exports, "faPlaneCircleCheck", () => $d8206b3ab2e65c05$export$9cbf8612c6cadc74);
$parcel$export($d8206b3ab2e65c05$exports, "faFaceRollingEyes", () => $d8206b3ab2e65c05$export$a6d72a9a068392b5);
$parcel$export($d8206b3ab2e65c05$exports, "faMehRollingEyes", () => $d8206b3ab2e65c05$export$fdc62a1bea767cc2);
$parcel$export($d8206b3ab2e65c05$exports, "faObjectGroup", () => $d8206b3ab2e65c05$export$40cdac24aa94a57a);
$parcel$export($d8206b3ab2e65c05$exports, "faChartLine", () => $d8206b3ab2e65c05$export$e022f62a119e1d93);
$parcel$export($d8206b3ab2e65c05$exports, "faLineChart", () => $d8206b3ab2e65c05$export$f729617a20de475b);
$parcel$export($d8206b3ab2e65c05$exports, "faMaskVentilator", () => $d8206b3ab2e65c05$export$122c8413a0dc5ff6);
$parcel$export($d8206b3ab2e65c05$exports, "faArrowRight", () => $d8206b3ab2e65c05$export$b4da69a0247f3620);
$parcel$export($d8206b3ab2e65c05$exports, "faSignsPost", () => $d8206b3ab2e65c05$export$905f45f8ffd6b8e5);
$parcel$export($d8206b3ab2e65c05$exports, "faMapSigns", () => $d8206b3ab2e65c05$export$743f4b1071b3333a);
$parcel$export($d8206b3ab2e65c05$exports, "faCashRegister", () => $d8206b3ab2e65c05$export$6357093f67788b33);
$parcel$export($d8206b3ab2e65c05$exports, "faPersonCircleQuestion", () => $d8206b3ab2e65c05$export$c8f8a597ffd676c0);
$parcel$export($d8206b3ab2e65c05$exports, "faH", () => $d8206b3ab2e65c05$export$d762b7b66d5875e1);
$parcel$export($d8206b3ab2e65c05$exports, "faTarp", () => $d8206b3ab2e65c05$export$2305b1a41b3f914);
$parcel$export($d8206b3ab2e65c05$exports, "faScrewdriverWrench", () => $d8206b3ab2e65c05$export$158a12f36bbecf9);
$parcel$export($d8206b3ab2e65c05$exports, "faTools", () => $d8206b3ab2e65c05$export$646e4e7a8c6172aa);
$parcel$export($d8206b3ab2e65c05$exports, "faArrowsToEye", () => $d8206b3ab2e65c05$export$9adae865350879af);
$parcel$export($d8206b3ab2e65c05$exports, "faPlugCircleBolt", () => $d8206b3ab2e65c05$export$4f3b3144ce966486);
$parcel$export($d8206b3ab2e65c05$exports, "faHeart", () => $d8206b3ab2e65c05$export$e4b51a47a2f8b9db);
$parcel$export($d8206b3ab2e65c05$exports, "faMarsAndVenus", () => $d8206b3ab2e65c05$export$808b88e8735e31e8);
$parcel$export($d8206b3ab2e65c05$exports, "faHouseUser", () => $d8206b3ab2e65c05$export$9a513ee921e8e885);
$parcel$export($d8206b3ab2e65c05$exports, "faHomeUser", () => $d8206b3ab2e65c05$export$e732fa55ae5bbdf0);
$parcel$export($d8206b3ab2e65c05$exports, "faDumpsterFire", () => $d8206b3ab2e65c05$export$25e9b29b3f2230b5);
$parcel$export($d8206b3ab2e65c05$exports, "faHouseCrack", () => $d8206b3ab2e65c05$export$baa3c215534dbf2a);
$parcel$export($d8206b3ab2e65c05$exports, "faMartiniGlassCitrus", () => $d8206b3ab2e65c05$export$c6e76550bdc0255d);
$parcel$export($d8206b3ab2e65c05$exports, "faCocktail", () => $d8206b3ab2e65c05$export$4be708f1e41d387b);
$parcel$export($d8206b3ab2e65c05$exports, "faFaceSurprise", () => $d8206b3ab2e65c05$export$c938968e28178994);
$parcel$export($d8206b3ab2e65c05$exports, "faSurprise", () => $d8206b3ab2e65c05$export$46647c72213f53ba);
$parcel$export($d8206b3ab2e65c05$exports, "faBottleWater", () => $d8206b3ab2e65c05$export$3ee278c67519eeeb);
$parcel$export($d8206b3ab2e65c05$exports, "faCirclePause", () => $d8206b3ab2e65c05$export$fbeef2513e05ad08);
$parcel$export($d8206b3ab2e65c05$exports, "faPauseCircle", () => $d8206b3ab2e65c05$export$d8cf08a0362da8db);
$parcel$export($d8206b3ab2e65c05$exports, "faToiletPaperSlash", () => $d8206b3ab2e65c05$export$7a494edbf9b65575);
$parcel$export($d8206b3ab2e65c05$exports, "faAppleWhole", () => $d8206b3ab2e65c05$export$12de8220d30453a3);
$parcel$export($d8206b3ab2e65c05$exports, "faAppleAlt", () => $d8206b3ab2e65c05$export$bcdd94f3977a0884);
$parcel$export($d8206b3ab2e65c05$exports, "faKitchenSet", () => $d8206b3ab2e65c05$export$64c1570509eaf40d);
$parcel$export($d8206b3ab2e65c05$exports, "faR", () => $d8206b3ab2e65c05$export$eb4c616de6eef46f);
$parcel$export($d8206b3ab2e65c05$exports, "faTemperatureQuarter", () => $d8206b3ab2e65c05$export$f9d1c19925fd7fa8);
$parcel$export($d8206b3ab2e65c05$exports, "faTemperature1", () => $d8206b3ab2e65c05$export$d4f1cd380bde2129);
$parcel$export($d8206b3ab2e65c05$exports, "faThermometer1", () => $d8206b3ab2e65c05$export$3f77fbe2dabe285b);
$parcel$export($d8206b3ab2e65c05$exports, "faThermometerQuarter", () => $d8206b3ab2e65c05$export$ed05754fcbec6e46);
$parcel$export($d8206b3ab2e65c05$exports, "faCube", () => $d8206b3ab2e65c05$export$973ae4f1e4d2ce78);
$parcel$export($d8206b3ab2e65c05$exports, "faBitcoinSign", () => $d8206b3ab2e65c05$export$441bfc8058328ce8);
$parcel$export($d8206b3ab2e65c05$exports, "faShieldDog", () => $d8206b3ab2e65c05$export$2a5c6f182c0cbcb);
$parcel$export($d8206b3ab2e65c05$exports, "faSolarPanel", () => $d8206b3ab2e65c05$export$b9c649c5e37017f3);
$parcel$export($d8206b3ab2e65c05$exports, "faLockOpen", () => $d8206b3ab2e65c05$export$84b5acad4436d02a);
$parcel$export($d8206b3ab2e65c05$exports, "faElevator", () => $d8206b3ab2e65c05$export$c7a833ce065e0ea4);
$parcel$export($d8206b3ab2e65c05$exports, "faMoneyBillTransfer", () => $d8206b3ab2e65c05$export$1b71392d9effbe);
$parcel$export($d8206b3ab2e65c05$exports, "faMoneyBillTrendUp", () => $d8206b3ab2e65c05$export$18ab80cba7d5044f);
$parcel$export($d8206b3ab2e65c05$exports, "faHouseFloodWaterCircleArrowRight", () => $d8206b3ab2e65c05$export$30d3e64480aa266b);
$parcel$export($d8206b3ab2e65c05$exports, "faSquarePollHorizontal", () => $d8206b3ab2e65c05$export$287bdd70ab874659);
$parcel$export($d8206b3ab2e65c05$exports, "faPollH", () => $d8206b3ab2e65c05$export$456a238f0144d430);
$parcel$export($d8206b3ab2e65c05$exports, "faCircle", () => $d8206b3ab2e65c05$export$4280b2387fbdad12);
$parcel$export($d8206b3ab2e65c05$exports, "faBackwardFast", () => $d8206b3ab2e65c05$export$662cbc6ed5a3c5e8);
$parcel$export($d8206b3ab2e65c05$exports, "faFastBackward", () => $d8206b3ab2e65c05$export$e6246a3279a379b8);
$parcel$export($d8206b3ab2e65c05$exports, "faRecycle", () => $d8206b3ab2e65c05$export$a65c441f12cb6bd);
$parcel$export($d8206b3ab2e65c05$exports, "faUserAstronaut", () => $d8206b3ab2e65c05$export$94363e983c225a04);
$parcel$export($d8206b3ab2e65c05$exports, "faPlaneSlash", () => $d8206b3ab2e65c05$export$cfee4df0d5df6d21);
$parcel$export($d8206b3ab2e65c05$exports, "faTrademark", () => $d8206b3ab2e65c05$export$9c9b2fbddd59047d);
$parcel$export($d8206b3ab2e65c05$exports, "faBasketball", () => $d8206b3ab2e65c05$export$44dee69e3a29b0e);
$parcel$export($d8206b3ab2e65c05$exports, "faBasketballBall", () => $d8206b3ab2e65c05$export$36550ab8ffcc5b28);
$parcel$export($d8206b3ab2e65c05$exports, "faSatelliteDish", () => $d8206b3ab2e65c05$export$219ccae0e4da3c92);
$parcel$export($d8206b3ab2e65c05$exports, "faCircleUp", () => $d8206b3ab2e65c05$export$72ea8a5e4e86cd69);
$parcel$export($d8206b3ab2e65c05$exports, "faArrowAltCircleUp", () => $d8206b3ab2e65c05$export$3747a8ef0995eadf);
$parcel$export($d8206b3ab2e65c05$exports, "faMobileScreenButton", () => $d8206b3ab2e65c05$export$da39ed20699ee2d7);
$parcel$export($d8206b3ab2e65c05$exports, "faMobileAlt", () => $d8206b3ab2e65c05$export$e9599bc6cd92234d);
$parcel$export($d8206b3ab2e65c05$exports, "faVolumeHigh", () => $d8206b3ab2e65c05$export$39461921e738be65);
$parcel$export($d8206b3ab2e65c05$exports, "faVolumeUp", () => $d8206b3ab2e65c05$export$5940d3e475d90cc4);
$parcel$export($d8206b3ab2e65c05$exports, "faUsersRays", () => $d8206b3ab2e65c05$export$9c0b63b698611d06);
$parcel$export($d8206b3ab2e65c05$exports, "faWallet", () => $d8206b3ab2e65c05$export$79204db8777905c8);
$parcel$export($d8206b3ab2e65c05$exports, "faClipboardCheck", () => $d8206b3ab2e65c05$export$7babcb2c90eb609a);
$parcel$export($d8206b3ab2e65c05$exports, "faFileAudio", () => $d8206b3ab2e65c05$export$b8d24c57c9e64933);
$parcel$export($d8206b3ab2e65c05$exports, "faBurger", () => $d8206b3ab2e65c05$export$128a6cab12423493);
$parcel$export($d8206b3ab2e65c05$exports, "faHamburger", () => $d8206b3ab2e65c05$export$bab3bb9f4f59363);
$parcel$export($d8206b3ab2e65c05$exports, "faWrench", () => $d8206b3ab2e65c05$export$3c6c0c8185296ac5);
$parcel$export($d8206b3ab2e65c05$exports, "faBugs", () => $d8206b3ab2e65c05$export$f5bfd1271b8b71d1);
$parcel$export($d8206b3ab2e65c05$exports, "faRupeeSign", () => $d8206b3ab2e65c05$export$8bf9e3f7f57d486a);
$parcel$export($d8206b3ab2e65c05$exports, "faRupee", () => $d8206b3ab2e65c05$export$9da25a46cfcb6fa4);
$parcel$export($d8206b3ab2e65c05$exports, "faFileImage", () => $d8206b3ab2e65c05$export$6440b286d3cbac9b);
$parcel$export($d8206b3ab2e65c05$exports, "faCircleQuestion", () => $d8206b3ab2e65c05$export$d7cf0978afd90002);
$parcel$export($d8206b3ab2e65c05$exports, "faQuestionCircle", () => $d8206b3ab2e65c05$export$5ba67d7f2265c1a5);
$parcel$export($d8206b3ab2e65c05$exports, "faPlaneDeparture", () => $d8206b3ab2e65c05$export$6ccbeeccfea6dc8a);
$parcel$export($d8206b3ab2e65c05$exports, "faHandshakeSlash", () => $d8206b3ab2e65c05$export$2cef3f81ad90fb76);
$parcel$export($d8206b3ab2e65c05$exports, "faBookBookmark", () => $d8206b3ab2e65c05$export$3d177ecdf7fc50ec);
$parcel$export($d8206b3ab2e65c05$exports, "faCodeBranch", () => $d8206b3ab2e65c05$export$aa054a78ab078db3);
$parcel$export($d8206b3ab2e65c05$exports, "faHatCowboy", () => $d8206b3ab2e65c05$export$37672611144b857b);
$parcel$export($d8206b3ab2e65c05$exports, "faBridge", () => $d8206b3ab2e65c05$export$f402c7c97f3383f0);
$parcel$export($d8206b3ab2e65c05$exports, "faPhoneFlip", () => $d8206b3ab2e65c05$export$d86c56ab43eb0deb);
$parcel$export($d8206b3ab2e65c05$exports, "faPhoneAlt", () => $d8206b3ab2e65c05$export$a07a9b305deebf32);
$parcel$export($d8206b3ab2e65c05$exports, "faTruckFront", () => $d8206b3ab2e65c05$export$4a5a13c01d46357c);
$parcel$export($d8206b3ab2e65c05$exports, "faCat", () => $d8206b3ab2e65c05$export$ab927dada03be4b3);
$parcel$export($d8206b3ab2e65c05$exports, "faAnchorCircleExclamation", () => $d8206b3ab2e65c05$export$61add9eca991b5ec);
$parcel$export($d8206b3ab2e65c05$exports, "faTruckField", () => $d8206b3ab2e65c05$export$f4419f7b2e53b340);
$parcel$export($d8206b3ab2e65c05$exports, "faRoute", () => $d8206b3ab2e65c05$export$806c0a45a7ecd6e8);
$parcel$export($d8206b3ab2e65c05$exports, "faClipboardQuestion", () => $d8206b3ab2e65c05$export$d4aa151a4554b74e);
$parcel$export($d8206b3ab2e65c05$exports, "faPanorama", () => $d8206b3ab2e65c05$export$5dd22dcb6e3ed369);
$parcel$export($d8206b3ab2e65c05$exports, "faCommentMedical", () => $d8206b3ab2e65c05$export$101422b773924276);
$parcel$export($d8206b3ab2e65c05$exports, "faTeethOpen", () => $d8206b3ab2e65c05$export$c88ac21fe7c88ae6);
$parcel$export($d8206b3ab2e65c05$exports, "faFileCircleMinus", () => $d8206b3ab2e65c05$export$4b89fabf50a10951);
$parcel$export($d8206b3ab2e65c05$exports, "faTags", () => $d8206b3ab2e65c05$export$d55778e3ab6c933f);
$parcel$export($d8206b3ab2e65c05$exports, "faWineGlass", () => $d8206b3ab2e65c05$export$e06d6607d3577d6e);
$parcel$export($d8206b3ab2e65c05$exports, "faForwardFast", () => $d8206b3ab2e65c05$export$dc9cc4280bee320d);
$parcel$export($d8206b3ab2e65c05$exports, "faFastForward", () => $d8206b3ab2e65c05$export$61a8cdc53c2e078d);
$parcel$export($d8206b3ab2e65c05$exports, "faFaceMehBlank", () => $d8206b3ab2e65c05$export$38c072b870a9e4ab);
$parcel$export($d8206b3ab2e65c05$exports, "faMehBlank", () => $d8206b3ab2e65c05$export$e945435725f71e88);
$parcel$export($d8206b3ab2e65c05$exports, "faSquareParking", () => $d8206b3ab2e65c05$export$f2cfa036d76f69ab);
$parcel$export($d8206b3ab2e65c05$exports, "faParking", () => $d8206b3ab2e65c05$export$fda29c8f99573a4e);
$parcel$export($d8206b3ab2e65c05$exports, "faHouseSignal", () => $d8206b3ab2e65c05$export$58845db8e7e9a199);
$parcel$export($d8206b3ab2e65c05$exports, "faBarsProgress", () => $d8206b3ab2e65c05$export$ee3a02da18715b2);
$parcel$export($d8206b3ab2e65c05$exports, "faTasksAlt", () => $d8206b3ab2e65c05$export$bbc0784fc1578f7f);
$parcel$export($d8206b3ab2e65c05$exports, "faFaucetDrip", () => $d8206b3ab2e65c05$export$7a255960242435f6);
$parcel$export($d8206b3ab2e65c05$exports, "faCartFlatbed", () => $d8206b3ab2e65c05$export$df587aaf7765e1ce);
$parcel$export($d8206b3ab2e65c05$exports, "faDollyFlatbed", () => $d8206b3ab2e65c05$export$f7c6efb60c53b285);
$parcel$export($d8206b3ab2e65c05$exports, "faBanSmoking", () => $d8206b3ab2e65c05$export$130df7ed74437774);
$parcel$export($d8206b3ab2e65c05$exports, "faSmokingBan", () => $d8206b3ab2e65c05$export$e50452a49dec29f);
$parcel$export($d8206b3ab2e65c05$exports, "faTerminal", () => $d8206b3ab2e65c05$export$5e63e8b85b5f119c);
$parcel$export($d8206b3ab2e65c05$exports, "faMobileButton", () => $d8206b3ab2e65c05$export$c93d62849efbdd11);
$parcel$export($d8206b3ab2e65c05$exports, "faHouseMedicalFlag", () => $d8206b3ab2e65c05$export$86c50f517be57a40);
$parcel$export($d8206b3ab2e65c05$exports, "faBasketShopping", () => $d8206b3ab2e65c05$export$1d307c13b511e8e1);
$parcel$export($d8206b3ab2e65c05$exports, "faShoppingBasket", () => $d8206b3ab2e65c05$export$ca6d443595a6578f);
$parcel$export($d8206b3ab2e65c05$exports, "faTape", () => $d8206b3ab2e65c05$export$b88ed5e1e0eac4c6);
$parcel$export($d8206b3ab2e65c05$exports, "faBusSimple", () => $d8206b3ab2e65c05$export$d3724faf0c559353);
$parcel$export($d8206b3ab2e65c05$exports, "faBusAlt", () => $d8206b3ab2e65c05$export$40616edfab6d332a);
$parcel$export($d8206b3ab2e65c05$exports, "faEye", () => $d8206b3ab2e65c05$export$b8c3e79e8c99c95b);
$parcel$export($d8206b3ab2e65c05$exports, "faFaceSadCry", () => $d8206b3ab2e65c05$export$e8ea88c55e55be7c);
$parcel$export($d8206b3ab2e65c05$exports, "faSadCry", () => $d8206b3ab2e65c05$export$8e924e6bd422cef9);
$parcel$export($d8206b3ab2e65c05$exports, "faAudioDescription", () => $d8206b3ab2e65c05$export$b6b464c98c009494);
$parcel$export($d8206b3ab2e65c05$exports, "faPersonMilitaryToPerson", () => $d8206b3ab2e65c05$export$41b1e14a6b0fe11b);
$parcel$export($d8206b3ab2e65c05$exports, "faFileShield", () => $d8206b3ab2e65c05$export$348a01df65a66c99);
$parcel$export($d8206b3ab2e65c05$exports, "faUserSlash", () => $d8206b3ab2e65c05$export$3924ab4d3ef9b5ef);
$parcel$export($d8206b3ab2e65c05$exports, "faPen", () => $d8206b3ab2e65c05$export$8f4567331fb0d3bc);
$parcel$export($d8206b3ab2e65c05$exports, "faTowerObservation", () => $d8206b3ab2e65c05$export$5b2f0f631f559d51);
$parcel$export($d8206b3ab2e65c05$exports, "faFileCode", () => $d8206b3ab2e65c05$export$143d0ca7d2200f20);
$parcel$export($d8206b3ab2e65c05$exports, "faSignal", () => $d8206b3ab2e65c05$export$79046b073b6c584d);
$parcel$export($d8206b3ab2e65c05$exports, "faSignal5", () => $d8206b3ab2e65c05$export$3417071118065933);
$parcel$export($d8206b3ab2e65c05$exports, "faSignalPerfect", () => $d8206b3ab2e65c05$export$1aea50ab3e99cc95);
$parcel$export($d8206b3ab2e65c05$exports, "faBus", () => $d8206b3ab2e65c05$export$ce69441578ff2fdb);
$parcel$export($d8206b3ab2e65c05$exports, "faHeartCircleXmark", () => $d8206b3ab2e65c05$export$742f89ae2f8d6b20);
$parcel$export($d8206b3ab2e65c05$exports, "faHouseChimney", () => $d8206b3ab2e65c05$export$af554427144a7e5c);
$parcel$export($d8206b3ab2e65c05$exports, "faHomeLg", () => $d8206b3ab2e65c05$export$dbab81727ec94698);
$parcel$export($d8206b3ab2e65c05$exports, "faWindowMaximize", () => $d8206b3ab2e65c05$export$703cd98be31ec905);
$parcel$export($d8206b3ab2e65c05$exports, "faFaceFrown", () => $d8206b3ab2e65c05$export$e5f78e87efbb0248);
$parcel$export($d8206b3ab2e65c05$exports, "faFrown", () => $d8206b3ab2e65c05$export$43b7108508aecc5f);
$parcel$export($d8206b3ab2e65c05$exports, "faPrescription", () => $d8206b3ab2e65c05$export$8767bafb19515ee4);
$parcel$export($d8206b3ab2e65c05$exports, "faShop", () => $d8206b3ab2e65c05$export$78edc9b98453b6f7);
$parcel$export($d8206b3ab2e65c05$exports, "faStoreAlt", () => $d8206b3ab2e65c05$export$1f1871dab9cec9d8);
$parcel$export($d8206b3ab2e65c05$exports, "faFloppyDisk", () => $d8206b3ab2e65c05$export$f62f2879ccaea13f);
$parcel$export($d8206b3ab2e65c05$exports, "faSave", () => $d8206b3ab2e65c05$export$1aaa83ff70706e1e);
$parcel$export($d8206b3ab2e65c05$exports, "faVihara", () => $d8206b3ab2e65c05$export$ee4b92e89fe0dfaf);
$parcel$export($d8206b3ab2e65c05$exports, "faScaleUnbalanced", () => $d8206b3ab2e65c05$export$4d10bcc8d068f454);
$parcel$export($d8206b3ab2e65c05$exports, "faBalanceScaleLeft", () => $d8206b3ab2e65c05$export$786cb0c775487f19);
$parcel$export($d8206b3ab2e65c05$exports, "faSortUp", () => $d8206b3ab2e65c05$export$f9dd5b1410e95035);
$parcel$export($d8206b3ab2e65c05$exports, "faSortAsc", () => $d8206b3ab2e65c05$export$e4c8c924b1cc43a7);
$parcel$export($d8206b3ab2e65c05$exports, "faCommentDots", () => $d8206b3ab2e65c05$export$63ffcb3d4e94cb92);
$parcel$export($d8206b3ab2e65c05$exports, "faCommenting", () => $d8206b3ab2e65c05$export$49ee382a2425e89c);
$parcel$export($d8206b3ab2e65c05$exports, "faPlantWilt", () => $d8206b3ab2e65c05$export$77a38850ff8b0407);
$parcel$export($d8206b3ab2e65c05$exports, "faDiamond", () => $d8206b3ab2e65c05$export$f214f827e0023247);
$parcel$export($d8206b3ab2e65c05$exports, "faFaceGrinSquint", () => $d8206b3ab2e65c05$export$5d53da7627754bc6);
$parcel$export($d8206b3ab2e65c05$exports, "faGrinSquint", () => $d8206b3ab2e65c05$export$243ae757907b1580);
$parcel$export($d8206b3ab2e65c05$exports, "faHandHoldingDollar", () => $d8206b3ab2e65c05$export$61a67f5f8ab39be);
$parcel$export($d8206b3ab2e65c05$exports, "faHandHoldingUsd", () => $d8206b3ab2e65c05$export$47d27bc305b59690);
$parcel$export($d8206b3ab2e65c05$exports, "faBacterium", () => $d8206b3ab2e65c05$export$b0babe4230e35ebe);
$parcel$export($d8206b3ab2e65c05$exports, "faHandPointer", () => $d8206b3ab2e65c05$export$d97ff927c450c87f);
$parcel$export($d8206b3ab2e65c05$exports, "faDrumSteelpan", () => $d8206b3ab2e65c05$export$48d1206500db2e9d);
$parcel$export($d8206b3ab2e65c05$exports, "faHandScissors", () => $d8206b3ab2e65c05$export$c578e919f2c5c135);
$parcel$export($d8206b3ab2e65c05$exports, "faHandsPraying", () => $d8206b3ab2e65c05$export$a96374faedb12593);
$parcel$export($d8206b3ab2e65c05$exports, "faPrayingHands", () => $d8206b3ab2e65c05$export$95e08e91b0929943);
$parcel$export($d8206b3ab2e65c05$exports, "faArrowRotateRight", () => $d8206b3ab2e65c05$export$9c58ddc4b3356f98);
$parcel$export($d8206b3ab2e65c05$exports, "faArrowRightRotate", () => $d8206b3ab2e65c05$export$ffa1245982c1b28b);
$parcel$export($d8206b3ab2e65c05$exports, "faArrowRotateForward", () => $d8206b3ab2e65c05$export$89c59b5f47067f4c);
$parcel$export($d8206b3ab2e65c05$exports, "faRedo", () => $d8206b3ab2e65c05$export$3d9f98aa1c24c776);
$parcel$export($d8206b3ab2e65c05$exports, "faBiohazard", () => $d8206b3ab2e65c05$export$ae3a453550dec95);
$parcel$export($d8206b3ab2e65c05$exports, "faLocationCrosshairs", () => $d8206b3ab2e65c05$export$14e1096ad1719098);
$parcel$export($d8206b3ab2e65c05$exports, "faLocation", () => $d8206b3ab2e65c05$export$45e012c32174eb5d);
$parcel$export($d8206b3ab2e65c05$exports, "faMarsDouble", () => $d8206b3ab2e65c05$export$2f8a28204bb4b86f);
$parcel$export($d8206b3ab2e65c05$exports, "faChildDress", () => $d8206b3ab2e65c05$export$f31a37ecbfd4e707);
$parcel$export($d8206b3ab2e65c05$exports, "faUsersBetweenLines", () => $d8206b3ab2e65c05$export$6ea1decf8bb3513d);
$parcel$export($d8206b3ab2e65c05$exports, "faLungsVirus", () => $d8206b3ab2e65c05$export$895159d10626af74);
$parcel$export($d8206b3ab2e65c05$exports, "faFaceGrinTears", () => $d8206b3ab2e65c05$export$8ac6d81a3d5b40a1);
$parcel$export($d8206b3ab2e65c05$exports, "faGrinTears", () => $d8206b3ab2e65c05$export$b2f7512221512b5b);
$parcel$export($d8206b3ab2e65c05$exports, "faPhone", () => $d8206b3ab2e65c05$export$ddab067855cf34cb);
$parcel$export($d8206b3ab2e65c05$exports, "faCalendarXmark", () => $d8206b3ab2e65c05$export$3c70ffe5660af060);
$parcel$export($d8206b3ab2e65c05$exports, "faCalendarTimes", () => $d8206b3ab2e65c05$export$99b20d7352fbcf08);
$parcel$export($d8206b3ab2e65c05$exports, "faChildReaching", () => $d8206b3ab2e65c05$export$84a2f9476730c40e);
$parcel$export($d8206b3ab2e65c05$exports, "faHeadSideVirus", () => $d8206b3ab2e65c05$export$5b64b916710da7c7);
$parcel$export($d8206b3ab2e65c05$exports, "faUserGear", () => $d8206b3ab2e65c05$export$f504a6909b677146);
$parcel$export($d8206b3ab2e65c05$exports, "faUserCog", () => $d8206b3ab2e65c05$export$474108c2b86e730e);
$parcel$export($d8206b3ab2e65c05$exports, "faArrowUp19", () => $d8206b3ab2e65c05$export$bbbff45e04f4abab);
$parcel$export($d8206b3ab2e65c05$exports, "faSortNumericUp", () => $d8206b3ab2e65c05$export$d213a3ba3cabed48);
$parcel$export($d8206b3ab2e65c05$exports, "faDoorClosed", () => $d8206b3ab2e65c05$export$2c79e1a422528bba);
$parcel$export($d8206b3ab2e65c05$exports, "faShieldVirus", () => $d8206b3ab2e65c05$export$bea811bbf570f05a);
$parcel$export($d8206b3ab2e65c05$exports, "faDiceSix", () => $d8206b3ab2e65c05$export$3397c7b4679acccc);
$parcel$export($d8206b3ab2e65c05$exports, "faMosquitoNet", () => $d8206b3ab2e65c05$export$f3858ce1b3218e2);
$parcel$export($d8206b3ab2e65c05$exports, "faBridgeWater", () => $d8206b3ab2e65c05$export$154e99cb34841765);
$parcel$export($d8206b3ab2e65c05$exports, "faPersonBooth", () => $d8206b3ab2e65c05$export$2337c975289bdd84);
$parcel$export($d8206b3ab2e65c05$exports, "faTextWidth", () => $d8206b3ab2e65c05$export$d8724cf433389700);
$parcel$export($d8206b3ab2e65c05$exports, "faHatWizard", () => $d8206b3ab2e65c05$export$7daa48199dcb2ad1);
$parcel$export($d8206b3ab2e65c05$exports, "faPenFancy", () => $d8206b3ab2e65c05$export$8bdfe14ac72a8b17);
$parcel$export($d8206b3ab2e65c05$exports, "faPersonDigging", () => $d8206b3ab2e65c05$export$f4d483fca19a4604);
$parcel$export($d8206b3ab2e65c05$exports, "faDigging", () => $d8206b3ab2e65c05$export$7bd93e3343bd5671);
$parcel$export($d8206b3ab2e65c05$exports, "faTrash", () => $d8206b3ab2e65c05$export$ed8c149a0ea54bb4);
$parcel$export($d8206b3ab2e65c05$exports, "faGaugeSimple", () => $d8206b3ab2e65c05$export$f3a0a4e6723a86d4);
$parcel$export($d8206b3ab2e65c05$exports, "faGaugeSimpleMed", () => $d8206b3ab2e65c05$export$ba8c12ff7cfa2521);
$parcel$export($d8206b3ab2e65c05$exports, "faTachometerAverage", () => $d8206b3ab2e65c05$export$94fcfd6f6335431b);
$parcel$export($d8206b3ab2e65c05$exports, "faBookMedical", () => $d8206b3ab2e65c05$export$6feb44fec53ba30d);
$parcel$export($d8206b3ab2e65c05$exports, "faPoo", () => $d8206b3ab2e65c05$export$dd0ede1713d2d2f9);
$parcel$export($d8206b3ab2e65c05$exports, "faQuoteRight", () => $d8206b3ab2e65c05$export$54e3a80c9875b74c);
$parcel$export($d8206b3ab2e65c05$exports, "faQuoteRightAlt", () => $d8206b3ab2e65c05$export$dd692f2e88bd4b1a);
$parcel$export($d8206b3ab2e65c05$exports, "faShirt", () => $d8206b3ab2e65c05$export$312f2c01c6fedca8);
$parcel$export($d8206b3ab2e65c05$exports, "faTShirt", () => $d8206b3ab2e65c05$export$144e5f8bc4d705a6);
$parcel$export($d8206b3ab2e65c05$exports, "faTshirt", () => $d8206b3ab2e65c05$export$36edce3ba87c2b17);
$parcel$export($d8206b3ab2e65c05$exports, "faCubes", () => $d8206b3ab2e65c05$export$30523a9441a31e97);
$parcel$export($d8206b3ab2e65c05$exports, "faDivide", () => $d8206b3ab2e65c05$export$89fa217ec5503ac9);
$parcel$export($d8206b3ab2e65c05$exports, "faTengeSign", () => $d8206b3ab2e65c05$export$c04e864469c1d117);
$parcel$export($d8206b3ab2e65c05$exports, "faTenge", () => $d8206b3ab2e65c05$export$af6ebee83047b793);
$parcel$export($d8206b3ab2e65c05$exports, "faHeadphones", () => $d8206b3ab2e65c05$export$ad02dd8ca5816958);
$parcel$export($d8206b3ab2e65c05$exports, "faHandsHolding", () => $d8206b3ab2e65c05$export$96891bbcda1dbb7b);
$parcel$export($d8206b3ab2e65c05$exports, "faHandsClapping", () => $d8206b3ab2e65c05$export$765c446e974b5e59);
$parcel$export($d8206b3ab2e65c05$exports, "faRepublican", () => $d8206b3ab2e65c05$export$929518bb4b66a588);
$parcel$export($d8206b3ab2e65c05$exports, "faArrowLeft", () => $d8206b3ab2e65c05$export$b7fac681e7d09400);
$parcel$export($d8206b3ab2e65c05$exports, "faPersonCircleXmark", () => $d8206b3ab2e65c05$export$16c9e0374c346c6e);
$parcel$export($d8206b3ab2e65c05$exports, "faRuler", () => $d8206b3ab2e65c05$export$8e90575265a56cfc);
$parcel$export($d8206b3ab2e65c05$exports, "faAlignLeft", () => $d8206b3ab2e65c05$export$e490f662af4d1c78);
$parcel$export($d8206b3ab2e65c05$exports, "faDiceD6", () => $d8206b3ab2e65c05$export$64bfd48ed353c031);
$parcel$export($d8206b3ab2e65c05$exports, "faRestroom", () => $d8206b3ab2e65c05$export$5fbcef35138741a5);
$parcel$export($d8206b3ab2e65c05$exports, "faJ", () => $d8206b3ab2e65c05$export$bbf24078bd1f73e6);
$parcel$export($d8206b3ab2e65c05$exports, "faUsersViewfinder", () => $d8206b3ab2e65c05$export$72b785dcfe44c69b);
$parcel$export($d8206b3ab2e65c05$exports, "faFileVideo", () => $d8206b3ab2e65c05$export$b44eb38345c6a964);
$parcel$export($d8206b3ab2e65c05$exports, "faUpRightFromSquare", () => $d8206b3ab2e65c05$export$c1a3ba061b4f60c4);
$parcel$export($d8206b3ab2e65c05$exports, "faExternalLinkAlt", () => $d8206b3ab2e65c05$export$d7f107e456ab0306);
$parcel$export($d8206b3ab2e65c05$exports, "faTableCells", () => $d8206b3ab2e65c05$export$c517dffc18db483f);
$parcel$export($d8206b3ab2e65c05$exports, "faTh", () => $d8206b3ab2e65c05$export$4d383c83efc0c819);
$parcel$export($d8206b3ab2e65c05$exports, "faFilePdf", () => $d8206b3ab2e65c05$export$38611f1c776aba73);
$parcel$export($d8206b3ab2e65c05$exports, "faBookBible", () => $d8206b3ab2e65c05$export$df8194b081d34b27);
$parcel$export($d8206b3ab2e65c05$exports, "faBible", () => $d8206b3ab2e65c05$export$2eac809b0670d139);
$parcel$export($d8206b3ab2e65c05$exports, "faO", () => $d8206b3ab2e65c05$export$9db87eabf605857e);
$parcel$export($d8206b3ab2e65c05$exports, "faSuitcaseMedical", () => $d8206b3ab2e65c05$export$25ea11267429d202);
$parcel$export($d8206b3ab2e65c05$exports, "faMedkit", () => $d8206b3ab2e65c05$export$e75f02bae5b7d34b);
$parcel$export($d8206b3ab2e65c05$exports, "faUserSecret", () => $d8206b3ab2e65c05$export$597826232327559b);
$parcel$export($d8206b3ab2e65c05$exports, "faOtter", () => $d8206b3ab2e65c05$export$743cce3ca4eb1d7d);
$parcel$export($d8206b3ab2e65c05$exports, "faPersonDress", () => $d8206b3ab2e65c05$export$27f7383b96c3f4b4);
$parcel$export($d8206b3ab2e65c05$exports, "faFemale", () => $d8206b3ab2e65c05$export$70e8e75e61dd7169);
$parcel$export($d8206b3ab2e65c05$exports, "faCommentDollar", () => $d8206b3ab2e65c05$export$7a088030853df12c);
$parcel$export($d8206b3ab2e65c05$exports, "faBusinessTime", () => $d8206b3ab2e65c05$export$694b7e88782dec12);
$parcel$export($d8206b3ab2e65c05$exports, "faBriefcaseClock", () => $d8206b3ab2e65c05$export$8b00ae94743552ce);
$parcel$export($d8206b3ab2e65c05$exports, "faTableCellsLarge", () => $d8206b3ab2e65c05$export$d2bcaf492dfb3817);
$parcel$export($d8206b3ab2e65c05$exports, "faThLarge", () => $d8206b3ab2e65c05$export$69782f333e90cdc6);
$parcel$export($d8206b3ab2e65c05$exports, "faBookTanakh", () => $d8206b3ab2e65c05$export$24c764717169f536);
$parcel$export($d8206b3ab2e65c05$exports, "faTanakh", () => $d8206b3ab2e65c05$export$7fd4a58929315448);
$parcel$export($d8206b3ab2e65c05$exports, "faPhoneVolume", () => $d8206b3ab2e65c05$export$c377f240bb8b5d74);
$parcel$export($d8206b3ab2e65c05$exports, "faVolumeControlPhone", () => $d8206b3ab2e65c05$export$5358d004fa3d3be2);
$parcel$export($d8206b3ab2e65c05$exports, "faHatCowboySide", () => $d8206b3ab2e65c05$export$ab6f71fd6878da90);
$parcel$export($d8206b3ab2e65c05$exports, "faClipboardUser", () => $d8206b3ab2e65c05$export$1204f2d171424659);
$parcel$export($d8206b3ab2e65c05$exports, "faChild", () => $d8206b3ab2e65c05$export$60b41e3581d1739a);
$parcel$export($d8206b3ab2e65c05$exports, "faLiraSign", () => $d8206b3ab2e65c05$export$f0f37dbc60110b10);
$parcel$export($d8206b3ab2e65c05$exports, "faSatellite", () => $d8206b3ab2e65c05$export$da3f1730d013e224);
$parcel$export($d8206b3ab2e65c05$exports, "faPlaneLock", () => $d8206b3ab2e65c05$export$1125ac57be52258c);
$parcel$export($d8206b3ab2e65c05$exports, "faTag", () => $d8206b3ab2e65c05$export$cb61f447f29887e);
$parcel$export($d8206b3ab2e65c05$exports, "faComment", () => $d8206b3ab2e65c05$export$805cd88398a70581);
$parcel$export($d8206b3ab2e65c05$exports, "faCakeCandles", () => $d8206b3ab2e65c05$export$e4019fe302a972e1);
$parcel$export($d8206b3ab2e65c05$exports, "faBirthdayCake", () => $d8206b3ab2e65c05$export$bdcf98f725a7241a);
$parcel$export($d8206b3ab2e65c05$exports, "faCake", () => $d8206b3ab2e65c05$export$707bc1c80c0177c1);
$parcel$export($d8206b3ab2e65c05$exports, "faEnvelope", () => $d8206b3ab2e65c05$export$6f095630677adc);
$parcel$export($d8206b3ab2e65c05$exports, "faAnglesUp", () => $d8206b3ab2e65c05$export$152ef92a4f9d80a7);
$parcel$export($d8206b3ab2e65c05$exports, "faAngleDoubleUp", () => $d8206b3ab2e65c05$export$9bb51e1a2c07db7c);
$parcel$export($d8206b3ab2e65c05$exports, "faPaperclip", () => $d8206b3ab2e65c05$export$4b24ca1552f410af);
$parcel$export($d8206b3ab2e65c05$exports, "faArrowRightToCity", () => $d8206b3ab2e65c05$export$e201217e5046cd15);
$parcel$export($d8206b3ab2e65c05$exports, "faRibbon", () => $d8206b3ab2e65c05$export$838459d11f3971df);
$parcel$export($d8206b3ab2e65c05$exports, "faLungs", () => $d8206b3ab2e65c05$export$ba9b387e84727819);
$parcel$export($d8206b3ab2e65c05$exports, "faArrowUp91", () => $d8206b3ab2e65c05$export$25218e5886296cb9);
$parcel$export($d8206b3ab2e65c05$exports, "faSortNumericUpAlt", () => $d8206b3ab2e65c05$export$d41859f1bbb9e086);
$parcel$export($d8206b3ab2e65c05$exports, "faLitecoinSign", () => $d8206b3ab2e65c05$export$4a157bd81dcd8d80);
$parcel$export($d8206b3ab2e65c05$exports, "faBorderNone", () => $d8206b3ab2e65c05$export$2b488402ec335d97);
$parcel$export($d8206b3ab2e65c05$exports, "faCircleNodes", () => $d8206b3ab2e65c05$export$de462dd5a18e80d4);
$parcel$export($d8206b3ab2e65c05$exports, "faParachuteBox", () => $d8206b3ab2e65c05$export$ca9e3368f1d9500a);
$parcel$export($d8206b3ab2e65c05$exports, "faIndent", () => $d8206b3ab2e65c05$export$318208bc30aeebcc);
$parcel$export($d8206b3ab2e65c05$exports, "faTruckFieldUn", () => $d8206b3ab2e65c05$export$40cb0a4a3a74dc03);
$parcel$export($d8206b3ab2e65c05$exports, "faHourglass", () => $d8206b3ab2e65c05$export$b9098a890f61e022);
$parcel$export($d8206b3ab2e65c05$exports, "faHourglassEmpty", () => $d8206b3ab2e65c05$export$a2f8176a0161e891);
$parcel$export($d8206b3ab2e65c05$exports, "faMountain", () => $d8206b3ab2e65c05$export$64f9eb99c9749cce);
$parcel$export($d8206b3ab2e65c05$exports, "faUserDoctor", () => $d8206b3ab2e65c05$export$9884bf227eeb829);
$parcel$export($d8206b3ab2e65c05$exports, "faUserMd", () => $d8206b3ab2e65c05$export$ab0d33a2c03f1794);
$parcel$export($d8206b3ab2e65c05$exports, "faCircleInfo", () => $d8206b3ab2e65c05$export$317f99f46b39906e);
$parcel$export($d8206b3ab2e65c05$exports, "faInfoCircle", () => $d8206b3ab2e65c05$export$aa9288aeadf882fa);
$parcel$export($d8206b3ab2e65c05$exports, "faCloudMeatball", () => $d8206b3ab2e65c05$export$5d120e8b87ad33f4);
$parcel$export($d8206b3ab2e65c05$exports, "faCamera", () => $d8206b3ab2e65c05$export$84ffbd7161ca2008);
$parcel$export($d8206b3ab2e65c05$exports, "faCameraAlt", () => $d8206b3ab2e65c05$export$8872b5664e88e793);
$parcel$export($d8206b3ab2e65c05$exports, "faSquareVirus", () => $d8206b3ab2e65c05$export$f9409a7b020dbec4);
$parcel$export($d8206b3ab2e65c05$exports, "faMeteor", () => $d8206b3ab2e65c05$export$1439f0d6365138da);
$parcel$export($d8206b3ab2e65c05$exports, "faCarOn", () => $d8206b3ab2e65c05$export$d901d50df5cf8d91);
$parcel$export($d8206b3ab2e65c05$exports, "faSleigh", () => $d8206b3ab2e65c05$export$26a8fd1143d2d6c0);
$parcel$export($d8206b3ab2e65c05$exports, "faArrowDown19", () => $d8206b3ab2e65c05$export$9a40d582bd4628fb);
$parcel$export($d8206b3ab2e65c05$exports, "faSortNumericAsc", () => $d8206b3ab2e65c05$export$a4fb1aa2cdfb18d7);
$parcel$export($d8206b3ab2e65c05$exports, "faSortNumericDown", () => $d8206b3ab2e65c05$export$835db7eb35b3c29b);
$parcel$export($d8206b3ab2e65c05$exports, "faHandHoldingDroplet", () => $d8206b3ab2e65c05$export$b9c3f9a906f96b82);
$parcel$export($d8206b3ab2e65c05$exports, "faHandHoldingWater", () => $d8206b3ab2e65c05$export$4265371b99d38b95);
$parcel$export($d8206b3ab2e65c05$exports, "faWater", () => $d8206b3ab2e65c05$export$efaeddad0a6e901b);
$parcel$export($d8206b3ab2e65c05$exports, "faCalendarCheck", () => $d8206b3ab2e65c05$export$5655108e1162ba45);
$parcel$export($d8206b3ab2e65c05$exports, "faBraille", () => $d8206b3ab2e65c05$export$983e9c27cac7ed1c);
$parcel$export($d8206b3ab2e65c05$exports, "faPrescriptionBottleMedical", () => $d8206b3ab2e65c05$export$99cfe064ff0b71c9);
$parcel$export($d8206b3ab2e65c05$exports, "faPrescriptionBottleAlt", () => $d8206b3ab2e65c05$export$65d1c884b8581d1a);
$parcel$export($d8206b3ab2e65c05$exports, "faLandmark", () => $d8206b3ab2e65c05$export$2bebc54c51db6505);
$parcel$export($d8206b3ab2e65c05$exports, "faTruck", () => $d8206b3ab2e65c05$export$d7895f386f8bd8b8);
$parcel$export($d8206b3ab2e65c05$exports, "faCrosshairs", () => $d8206b3ab2e65c05$export$721c101130c40043);
$parcel$export($d8206b3ab2e65c05$exports, "faPersonCane", () => $d8206b3ab2e65c05$export$c48422e9da776c1b);
$parcel$export($d8206b3ab2e65c05$exports, "faTent", () => $d8206b3ab2e65c05$export$e5075400db564e24);
$parcel$export($d8206b3ab2e65c05$exports, "faVestPatches", () => $d8206b3ab2e65c05$export$750a64470c2e0f3f);
$parcel$export($d8206b3ab2e65c05$exports, "faCheckDouble", () => $d8206b3ab2e65c05$export$f178c8c2ad3cc861);
$parcel$export($d8206b3ab2e65c05$exports, "faArrowDownAZ", () => $d8206b3ab2e65c05$export$43b642fac7053978);
$parcel$export($d8206b3ab2e65c05$exports, "faSortAlphaAsc", () => $d8206b3ab2e65c05$export$cb87697f2fa77cfc);
$parcel$export($d8206b3ab2e65c05$exports, "faSortAlphaDown", () => $d8206b3ab2e65c05$export$7658045270aafde3);
$parcel$export($d8206b3ab2e65c05$exports, "faMoneyBillWheat", () => $d8206b3ab2e65c05$export$6a4ef2ef77625063);
$parcel$export($d8206b3ab2e65c05$exports, "faCookie", () => $d8206b3ab2e65c05$export$b3e64f5f68c6623f);
$parcel$export($d8206b3ab2e65c05$exports, "faArrowRotateLeft", () => $d8206b3ab2e65c05$export$89b706873769c180);
$parcel$export($d8206b3ab2e65c05$exports, "faArrowLeftRotate", () => $d8206b3ab2e65c05$export$1aea864c3e1d79b);
$parcel$export($d8206b3ab2e65c05$exports, "faArrowRotateBack", () => $d8206b3ab2e65c05$export$a34701878babe5fc);
$parcel$export($d8206b3ab2e65c05$exports, "faArrowRotateBackward", () => $d8206b3ab2e65c05$export$fce381d12e4535cd);
$parcel$export($d8206b3ab2e65c05$exports, "faUndo", () => $d8206b3ab2e65c05$export$a5e5ba60b1dfe2b2);
$parcel$export($d8206b3ab2e65c05$exports, "faHardDrive", () => $d8206b3ab2e65c05$export$4cb736b866cbb7ec);
$parcel$export($d8206b3ab2e65c05$exports, "faHdd", () => $d8206b3ab2e65c05$export$62551e9c5ba7093f);
$parcel$export($d8206b3ab2e65c05$exports, "faFaceGrinSquintTears", () => $d8206b3ab2e65c05$export$8ff56f5ebb8416a0);
$parcel$export($d8206b3ab2e65c05$exports, "faGrinSquintTears", () => $d8206b3ab2e65c05$export$542206d6a85f3b42);
$parcel$export($d8206b3ab2e65c05$exports, "faDumbbell", () => $d8206b3ab2e65c05$export$56700074cf37be5c);
$parcel$export($d8206b3ab2e65c05$exports, "faRectangleList", () => $d8206b3ab2e65c05$export$1f7600fa9fdb3978);
$parcel$export($d8206b3ab2e65c05$exports, "faListAlt", () => $d8206b3ab2e65c05$export$c6327a203ffc65a3);
$parcel$export($d8206b3ab2e65c05$exports, "faTarpDroplet", () => $d8206b3ab2e65c05$export$1585b7c3c7109751);
$parcel$export($d8206b3ab2e65c05$exports, "faHouseMedicalCircleCheck", () => $d8206b3ab2e65c05$export$5d08d08f88a96aac);
$parcel$export($d8206b3ab2e65c05$exports, "faPersonSkiingNordic", () => $d8206b3ab2e65c05$export$c8cd1786449517d3);
$parcel$export($d8206b3ab2e65c05$exports, "faSkiingNordic", () => $d8206b3ab2e65c05$export$6ea48260d7d09b1b);
$parcel$export($d8206b3ab2e65c05$exports, "faCalendarPlus", () => $d8206b3ab2e65c05$export$16768a660ae3ca9d);
$parcel$export($d8206b3ab2e65c05$exports, "faPlaneArrival", () => $d8206b3ab2e65c05$export$9b2dbe133273f284);
$parcel$export($d8206b3ab2e65c05$exports, "faCircleLeft", () => $d8206b3ab2e65c05$export$5ae86b9da9cca3bd);
$parcel$export($d8206b3ab2e65c05$exports, "faArrowAltCircleLeft", () => $d8206b3ab2e65c05$export$5460a5b11a24996f);
$parcel$export($d8206b3ab2e65c05$exports, "faTrainSubway", () => $d8206b3ab2e65c05$export$cda326cc3bce41c);
$parcel$export($d8206b3ab2e65c05$exports, "faSubway", () => $d8206b3ab2e65c05$export$4cabc8a12d4e2f9);
$parcel$export($d8206b3ab2e65c05$exports, "faChartGantt", () => $d8206b3ab2e65c05$export$dce43b02b3fe0c18);
$parcel$export($d8206b3ab2e65c05$exports, "faIndianRupeeSign", () => $d8206b3ab2e65c05$export$1d2b135cc5a2c852);
$parcel$export($d8206b3ab2e65c05$exports, "faIndianRupee", () => $d8206b3ab2e65c05$export$be886a4def17c565);
$parcel$export($d8206b3ab2e65c05$exports, "faInr", () => $d8206b3ab2e65c05$export$12c6d8b3e052490b);
$parcel$export($d8206b3ab2e65c05$exports, "faCropSimple", () => $d8206b3ab2e65c05$export$c3605731beb92daf);
$parcel$export($d8206b3ab2e65c05$exports, "faCropAlt", () => $d8206b3ab2e65c05$export$d932915fde4f1010);
$parcel$export($d8206b3ab2e65c05$exports, "faMoneyBill1", () => $d8206b3ab2e65c05$export$a312c7d58dd44a75);
$parcel$export($d8206b3ab2e65c05$exports, "faMoneyBillAlt", () => $d8206b3ab2e65c05$export$a35d573395884c3d);
$parcel$export($d8206b3ab2e65c05$exports, "faLeftLong", () => $d8206b3ab2e65c05$export$1db7e2ee10d36035);
$parcel$export($d8206b3ab2e65c05$exports, "faLongArrowAltLeft", () => $d8206b3ab2e65c05$export$a8b3226b2bf323d);
$parcel$export($d8206b3ab2e65c05$exports, "faDna", () => $d8206b3ab2e65c05$export$c062100d54a2da00);
$parcel$export($d8206b3ab2e65c05$exports, "faVirusSlash", () => $d8206b3ab2e65c05$export$c4ff5306c5470939);
$parcel$export($d8206b3ab2e65c05$exports, "faMinus", () => $d8206b3ab2e65c05$export$fee0376c250cdef);
$parcel$export($d8206b3ab2e65c05$exports, "faSubtract", () => $d8206b3ab2e65c05$export$f8cb2531ef1fc4a2);
$parcel$export($d8206b3ab2e65c05$exports, "faChess", () => $d8206b3ab2e65c05$export$442fddbbd741c590);
$parcel$export($d8206b3ab2e65c05$exports, "faArrowLeftLong", () => $d8206b3ab2e65c05$export$6e5225f0e6c0bacd);
$parcel$export($d8206b3ab2e65c05$exports, "faLongArrowLeft", () => $d8206b3ab2e65c05$export$80896efc906118b4);
$parcel$export($d8206b3ab2e65c05$exports, "faPlugCircleCheck", () => $d8206b3ab2e65c05$export$2bd45e99b9afa947);
$parcel$export($d8206b3ab2e65c05$exports, "faStreetView", () => $d8206b3ab2e65c05$export$6aab6c3359c2554c);
$parcel$export($d8206b3ab2e65c05$exports, "faFrancSign", () => $d8206b3ab2e65c05$export$acef3e5c2029d285);
$parcel$export($d8206b3ab2e65c05$exports, "faVolumeOff", () => $d8206b3ab2e65c05$export$d94ba52e980ea0f1);
$parcel$export($d8206b3ab2e65c05$exports, "faHandsAslInterpreting", () => $d8206b3ab2e65c05$export$bc43eb4655c78f49);
$parcel$export($d8206b3ab2e65c05$exports, "faAmericanSignLanguageInterpreting", () => $d8206b3ab2e65c05$export$23a7517099ab1b86);
$parcel$export($d8206b3ab2e65c05$exports, "faAslInterpreting", () => $d8206b3ab2e65c05$export$beb51abfb05a4eca);
$parcel$export($d8206b3ab2e65c05$exports, "faHandsAmericanSignLanguageInterpreting", () => $d8206b3ab2e65c05$export$82846008645b0301);
$parcel$export($d8206b3ab2e65c05$exports, "faGear", () => $d8206b3ab2e65c05$export$ec05accb7226d001);
$parcel$export($d8206b3ab2e65c05$exports, "faCog", () => $d8206b3ab2e65c05$export$d6298bbfd1912a78);
$parcel$export($d8206b3ab2e65c05$exports, "faDropletSlash", () => $d8206b3ab2e65c05$export$1d6c5a49025d720b);
$parcel$export($d8206b3ab2e65c05$exports, "faTintSlash", () => $d8206b3ab2e65c05$export$5d6f0943039b898f);
$parcel$export($d8206b3ab2e65c05$exports, "faMosque", () => $d8206b3ab2e65c05$export$4999586d7e1087fb);
$parcel$export($d8206b3ab2e65c05$exports, "faMosquito", () => $d8206b3ab2e65c05$export$67c7a1518d0715ff);
$parcel$export($d8206b3ab2e65c05$exports, "faStarOfDavid", () => $d8206b3ab2e65c05$export$f823fee3712b2601);
$parcel$export($d8206b3ab2e65c05$exports, "faPersonMilitaryRifle", () => $d8206b3ab2e65c05$export$842b988dae95ccb8);
$parcel$export($d8206b3ab2e65c05$exports, "faCartShopping", () => $d8206b3ab2e65c05$export$c790b41dc166ae13);
$parcel$export($d8206b3ab2e65c05$exports, "faShoppingCart", () => $d8206b3ab2e65c05$export$51da406e5aa1388c);
$parcel$export($d8206b3ab2e65c05$exports, "faVials", () => $d8206b3ab2e65c05$export$507e8edd7676b2e9);
$parcel$export($d8206b3ab2e65c05$exports, "faPlugCirclePlus", () => $d8206b3ab2e65c05$export$f193138a7d21971c);
$parcel$export($d8206b3ab2e65c05$exports, "faPlaceOfWorship", () => $d8206b3ab2e65c05$export$c5a9302c8c13c79a);
$parcel$export($d8206b3ab2e65c05$exports, "faGripVertical", () => $d8206b3ab2e65c05$export$cacbd95c283996ec);
$parcel$export($d8206b3ab2e65c05$exports, "faArrowTurnUp", () => $d8206b3ab2e65c05$export$2d3ccb9b2099f3fe);
$parcel$export($d8206b3ab2e65c05$exports, "faLevelUp", () => $d8206b3ab2e65c05$export$c227d3ba1de97ceb);
$parcel$export($d8206b3ab2e65c05$exports, "faU", () => $d8206b3ab2e65c05$export$4f39e8dbaf09ea8b);
$parcel$export($d8206b3ab2e65c05$exports, "faSquareRootVariable", () => $d8206b3ab2e65c05$export$60b44cfa7af18422);
$parcel$export($d8206b3ab2e65c05$exports, "faSquareRootAlt", () => $d8206b3ab2e65c05$export$28e4b96627e00057);
$parcel$export($d8206b3ab2e65c05$exports, "faClock", () => $d8206b3ab2e65c05$export$95b9968e7fceb821);
$parcel$export($d8206b3ab2e65c05$exports, "faClockFour", () => $d8206b3ab2e65c05$export$9a575facf1cab48f);
$parcel$export($d8206b3ab2e65c05$exports, "faBackwardStep", () => $d8206b3ab2e65c05$export$5d2b6a700940df16);
$parcel$export($d8206b3ab2e65c05$exports, "faStepBackward", () => $d8206b3ab2e65c05$export$2884e379aed297d4);
$parcel$export($d8206b3ab2e65c05$exports, "faPallet", () => $d8206b3ab2e65c05$export$d7ff2047dbc34562);
$parcel$export($d8206b3ab2e65c05$exports, "faFaucet", () => $d8206b3ab2e65c05$export$a0856b225f3b0614);
$parcel$export($d8206b3ab2e65c05$exports, "faBaseballBatBall", () => $d8206b3ab2e65c05$export$59669f486ab41d86);
$parcel$export($d8206b3ab2e65c05$exports, "faS", () => $d8206b3ab2e65c05$export$cb39585371b75720);
$parcel$export($d8206b3ab2e65c05$exports, "faTimeline", () => $d8206b3ab2e65c05$export$5e239d90ef904a84);
$parcel$export($d8206b3ab2e65c05$exports, "faKeyboard", () => $d8206b3ab2e65c05$export$fb61df5d98785fa8);
$parcel$export($d8206b3ab2e65c05$exports, "faCaretDown", () => $d8206b3ab2e65c05$export$f9395ef707603e40);
$parcel$export($d8206b3ab2e65c05$exports, "faHouseChimneyMedical", () => $d8206b3ab2e65c05$export$9c73560282dceccd);
$parcel$export($d8206b3ab2e65c05$exports, "faClinicMedical", () => $d8206b3ab2e65c05$export$20d8a680febc7434);
$parcel$export($d8206b3ab2e65c05$exports, "faTemperatureThreeQuarters", () => $d8206b3ab2e65c05$export$7ed2bad15ae6237f);
$parcel$export($d8206b3ab2e65c05$exports, "faTemperature3", () => $d8206b3ab2e65c05$export$89def3268ed9b4bc);
$parcel$export($d8206b3ab2e65c05$exports, "faThermometer3", () => $d8206b3ab2e65c05$export$2f653125f4e6463);
$parcel$export($d8206b3ab2e65c05$exports, "faThermometerThreeQuarters", () => $d8206b3ab2e65c05$export$6c632d1dc30d4a77);
$parcel$export($d8206b3ab2e65c05$exports, "faMobileScreen", () => $d8206b3ab2e65c05$export$8867e7da34bb8bf4);
$parcel$export($d8206b3ab2e65c05$exports, "faMobileAndroidAlt", () => $d8206b3ab2e65c05$export$cb39d7b468ba5838);
$parcel$export($d8206b3ab2e65c05$exports, "faPlaneUp", () => $d8206b3ab2e65c05$export$a5f2976a01fdc970);
$parcel$export($d8206b3ab2e65c05$exports, "faPiggyBank", () => $d8206b3ab2e65c05$export$46d49a6734c4872a);
$parcel$export($d8206b3ab2e65c05$exports, "faBatteryHalf", () => $d8206b3ab2e65c05$export$e6dadc1155c4ee48);
$parcel$export($d8206b3ab2e65c05$exports, "faBattery3", () => $d8206b3ab2e65c05$export$f9138caac2aedaed);
$parcel$export($d8206b3ab2e65c05$exports, "faMountainCity", () => $d8206b3ab2e65c05$export$28f06bbf9c17c3af);
$parcel$export($d8206b3ab2e65c05$exports, "faCoins", () => $d8206b3ab2e65c05$export$bc5da164799a0e);
$parcel$export($d8206b3ab2e65c05$exports, "faKhanda", () => $d8206b3ab2e65c05$export$8d41d1f1ba3f9217);
$parcel$export($d8206b3ab2e65c05$exports, "faSliders", () => $d8206b3ab2e65c05$export$ea6970ed5a15feb6);
$parcel$export($d8206b3ab2e65c05$exports, "faSlidersH", () => $d8206b3ab2e65c05$export$94d4dcb523f95563);
$parcel$export($d8206b3ab2e65c05$exports, "faFolderTree", () => $d8206b3ab2e65c05$export$54d16fa2e445d3fe);
$parcel$export($d8206b3ab2e65c05$exports, "faNetworkWired", () => $d8206b3ab2e65c05$export$882cabd11f4943b8);
$parcel$export($d8206b3ab2e65c05$exports, "faMapPin", () => $d8206b3ab2e65c05$export$184725965b3402dc);
$parcel$export($d8206b3ab2e65c05$exports, "faHamsa", () => $d8206b3ab2e65c05$export$38d20d399463edf9);
$parcel$export($d8206b3ab2e65c05$exports, "faCentSign", () => $d8206b3ab2e65c05$export$875b6c94a4b00ea8);
$parcel$export($d8206b3ab2e65c05$exports, "faFlask", () => $d8206b3ab2e65c05$export$f9b579ba06048af);
$parcel$export($d8206b3ab2e65c05$exports, "faPersonPregnant", () => $d8206b3ab2e65c05$export$e7b4c26b5857fe9c);
$parcel$export($d8206b3ab2e65c05$exports, "faWandSparkles", () => $d8206b3ab2e65c05$export$76cc39f249b6864e);
$parcel$export($d8206b3ab2e65c05$exports, "faEllipsisVertical", () => $d8206b3ab2e65c05$export$7480721bf113be3e);
$parcel$export($d8206b3ab2e65c05$exports, "faEllipsisV", () => $d8206b3ab2e65c05$export$e58494c7fcb5380);
$parcel$export($d8206b3ab2e65c05$exports, "faTicket", () => $d8206b3ab2e65c05$export$3604f15924cf0b98);
$parcel$export($d8206b3ab2e65c05$exports, "faPowerOff", () => $d8206b3ab2e65c05$export$a1cca9928dcf9798);
$parcel$export($d8206b3ab2e65c05$exports, "faRightLong", () => $d8206b3ab2e65c05$export$b356b1dbe7d7f736);
$parcel$export($d8206b3ab2e65c05$exports, "faLongArrowAltRight", () => $d8206b3ab2e65c05$export$533e1f578f74c066);
$parcel$export($d8206b3ab2e65c05$exports, "faFlagUsa", () => $d8206b3ab2e65c05$export$19357abad396e723);
$parcel$export($d8206b3ab2e65c05$exports, "faLaptopFile", () => $d8206b3ab2e65c05$export$e1046cf83da9b7ef);
$parcel$export($d8206b3ab2e65c05$exports, "faTty", () => $d8206b3ab2e65c05$export$7c85aba0f9624b29);
$parcel$export($d8206b3ab2e65c05$exports, "faTeletype", () => $d8206b3ab2e65c05$export$14bcd5c43dc736f9);
$parcel$export($d8206b3ab2e65c05$exports, "faDiagramNext", () => $d8206b3ab2e65c05$export$2faddf1690e14e11);
$parcel$export($d8206b3ab2e65c05$exports, "faPersonRifle", () => $d8206b3ab2e65c05$export$b16df914812cedbe);
$parcel$export($d8206b3ab2e65c05$exports, "faHouseMedicalCircleExclamation", () => $d8206b3ab2e65c05$export$bc50edea6e121df5);
$parcel$export($d8206b3ab2e65c05$exports, "faClosedCaptioning", () => $d8206b3ab2e65c05$export$8e047801a8603af7);
$parcel$export($d8206b3ab2e65c05$exports, "faPersonHiking", () => $d8206b3ab2e65c05$export$baf9f153991b2ea);
$parcel$export($d8206b3ab2e65c05$exports, "faHiking", () => $d8206b3ab2e65c05$export$b2ab0105a901499e);
$parcel$export($d8206b3ab2e65c05$exports, "faVenusDouble", () => $d8206b3ab2e65c05$export$6a6f9cba7a1e5fe4);
$parcel$export($d8206b3ab2e65c05$exports, "faImages", () => $d8206b3ab2e65c05$export$74f06b41ed2ca28a);
$parcel$export($d8206b3ab2e65c05$exports, "faCalculator", () => $d8206b3ab2e65c05$export$693bd40950ed2c3a);
$parcel$export($d8206b3ab2e65c05$exports, "faPeoplePulling", () => $d8206b3ab2e65c05$export$dace56f632fecf6f);
$parcel$export($d8206b3ab2e65c05$exports, "faN", () => $d8206b3ab2e65c05$export$328a9baf0f9e3405);
$parcel$export($d8206b3ab2e65c05$exports, "faCableCar", () => $d8206b3ab2e65c05$export$85cb04eaefaf2d8b);
$parcel$export($d8206b3ab2e65c05$exports, "faTram", () => $d8206b3ab2e65c05$export$a7a36674c079f293);
$parcel$export($d8206b3ab2e65c05$exports, "faCloudRain", () => $d8206b3ab2e65c05$export$a6c308ee087b4ded);
$parcel$export($d8206b3ab2e65c05$exports, "faBuildingCircleXmark", () => $d8206b3ab2e65c05$export$c4c015418a1f24df);
$parcel$export($d8206b3ab2e65c05$exports, "faShip", () => $d8206b3ab2e65c05$export$6c645741140616af);
$parcel$export($d8206b3ab2e65c05$exports, "faArrowsDownToLine", () => $d8206b3ab2e65c05$export$8f2463c7b2fc6ae4);
$parcel$export($d8206b3ab2e65c05$exports, "faDownload", () => $d8206b3ab2e65c05$export$8f734e51d72ca13a);
$parcel$export($d8206b3ab2e65c05$exports, "faFaceGrin", () => $d8206b3ab2e65c05$export$92292137ef3cf4c8);
$parcel$export($d8206b3ab2e65c05$exports, "faGrin", () => $d8206b3ab2e65c05$export$37e1f10b6de76621);
$parcel$export($d8206b3ab2e65c05$exports, "faDeleteLeft", () => $d8206b3ab2e65c05$export$bbcc9e0b6022772b);
$parcel$export($d8206b3ab2e65c05$exports, "faBackspace", () => $d8206b3ab2e65c05$export$e43e3f67102fc526);
$parcel$export($d8206b3ab2e65c05$exports, "faEyeDropper", () => $d8206b3ab2e65c05$export$1bc3e0ad56dc9eb0);
$parcel$export($d8206b3ab2e65c05$exports, "faEyeDropperEmpty", () => $d8206b3ab2e65c05$export$ef304e9b7524c1f9);
$parcel$export($d8206b3ab2e65c05$exports, "faEyedropper", () => $d8206b3ab2e65c05$export$91549a375c0b6d25);
$parcel$export($d8206b3ab2e65c05$exports, "faFileCircleCheck", () => $d8206b3ab2e65c05$export$8547e9f3a2ddab5b);
$parcel$export($d8206b3ab2e65c05$exports, "faForward", () => $d8206b3ab2e65c05$export$a8710cdb23198d53);
$parcel$export($d8206b3ab2e65c05$exports, "faMobile", () => $d8206b3ab2e65c05$export$59edacfad04cd121);
$parcel$export($d8206b3ab2e65c05$exports, "faMobileAndroid", () => $d8206b3ab2e65c05$export$82f602311a698c32);
$parcel$export($d8206b3ab2e65c05$exports, "faMobilePhone", () => $d8206b3ab2e65c05$export$475a9be8da747e57);
$parcel$export($d8206b3ab2e65c05$exports, "faFaceMeh", () => $d8206b3ab2e65c05$export$dc130582748497c6);
$parcel$export($d8206b3ab2e65c05$exports, "faMeh", () => $d8206b3ab2e65c05$export$6d2db489aaeeecd2);
$parcel$export($d8206b3ab2e65c05$exports, "faAlignCenter", () => $d8206b3ab2e65c05$export$70e29dd05344623e);
$parcel$export($d8206b3ab2e65c05$exports, "faBookSkull", () => $d8206b3ab2e65c05$export$a57d448e8969ce8a);
$parcel$export($d8206b3ab2e65c05$exports, "faBookDead", () => $d8206b3ab2e65c05$export$b98a3f8c3941a74a);
$parcel$export($d8206b3ab2e65c05$exports, "faIdCard", () => $d8206b3ab2e65c05$export$782ac893fc22249b);
$parcel$export($d8206b3ab2e65c05$exports, "faDriversLicense", () => $d8206b3ab2e65c05$export$8359c70e609eff64);
$parcel$export($d8206b3ab2e65c05$exports, "faOutdent", () => $d8206b3ab2e65c05$export$e21cfc4f23776bff);
$parcel$export($d8206b3ab2e65c05$exports, "faDedent", () => $d8206b3ab2e65c05$export$cbffb369d9299db7);
$parcel$export($d8206b3ab2e65c05$exports, "faHeartCircleExclamation", () => $d8206b3ab2e65c05$export$3772719b170306e2);
$parcel$export($d8206b3ab2e65c05$exports, "faHouse", () => $d8206b3ab2e65c05$export$dcadc0d67468dfa8);
$parcel$export($d8206b3ab2e65c05$exports, "faHome", () => $d8206b3ab2e65c05$export$48f10d71ec526479);
$parcel$export($d8206b3ab2e65c05$exports, "faHomeAlt", () => $d8206b3ab2e65c05$export$279659c4b23dbedb);
$parcel$export($d8206b3ab2e65c05$exports, "faHomeLgAlt", () => $d8206b3ab2e65c05$export$20d6d52d45f53262);
$parcel$export($d8206b3ab2e65c05$exports, "faCalendarWeek", () => $d8206b3ab2e65c05$export$39be5cb4aed5a521);
$parcel$export($d8206b3ab2e65c05$exports, "faLaptopMedical", () => $d8206b3ab2e65c05$export$ba2fa38f7bcc6930);
$parcel$export($d8206b3ab2e65c05$exports, "faB", () => $d8206b3ab2e65c05$export$fa30fcd1e0d0d8);
$parcel$export($d8206b3ab2e65c05$exports, "faFileMedical", () => $d8206b3ab2e65c05$export$56cbcd962389b090);
$parcel$export($d8206b3ab2e65c05$exports, "faDiceOne", () => $d8206b3ab2e65c05$export$d91800b7be5303b0);
$parcel$export($d8206b3ab2e65c05$exports, "faKiwiBird", () => $d8206b3ab2e65c05$export$d9933d91e1314d02);
$parcel$export($d8206b3ab2e65c05$exports, "faArrowRightArrowLeft", () => $d8206b3ab2e65c05$export$56b6d3d7d0e67a1c);
$parcel$export($d8206b3ab2e65c05$exports, "faExchange", () => $d8206b3ab2e65c05$export$1aab915ca61b734a);
$parcel$export($d8206b3ab2e65c05$exports, "faRotateRight", () => $d8206b3ab2e65c05$export$7f465bf410c6eff7);
$parcel$export($d8206b3ab2e65c05$exports, "faRedoAlt", () => $d8206b3ab2e65c05$export$50c037520c6cfdc1);
$parcel$export($d8206b3ab2e65c05$exports, "faRotateForward", () => $d8206b3ab2e65c05$export$2507849a0fdd7f64);
$parcel$export($d8206b3ab2e65c05$exports, "faUtensils", () => $d8206b3ab2e65c05$export$750d52edc1dafc7);
$parcel$export($d8206b3ab2e65c05$exports, "faCutlery", () => $d8206b3ab2e65c05$export$7034e54a8036c5c8);
$parcel$export($d8206b3ab2e65c05$exports, "faArrowUpWideShort", () => $d8206b3ab2e65c05$export$63f4908401ded049);
$parcel$export($d8206b3ab2e65c05$exports, "faSortAmountUp", () => $d8206b3ab2e65c05$export$28ef3e933e4b5364);
$parcel$export($d8206b3ab2e65c05$exports, "faMillSign", () => $d8206b3ab2e65c05$export$9b53510cf4010e4d);
$parcel$export($d8206b3ab2e65c05$exports, "faBowlRice", () => $d8206b3ab2e65c05$export$86079bc65a716451);
$parcel$export($d8206b3ab2e65c05$exports, "faSkull", () => $d8206b3ab2e65c05$export$138b45e2afb1dfa4);
$parcel$export($d8206b3ab2e65c05$exports, "faTowerBroadcast", () => $d8206b3ab2e65c05$export$fd06ff4ce9799eb0);
$parcel$export($d8206b3ab2e65c05$exports, "faBroadcastTower", () => $d8206b3ab2e65c05$export$f68b38d51f5c0ed);
$parcel$export($d8206b3ab2e65c05$exports, "faTruckPickup", () => $d8206b3ab2e65c05$export$f846b848b3ba3064);
$parcel$export($d8206b3ab2e65c05$exports, "faUpLong", () => $d8206b3ab2e65c05$export$5608156cc81126e7);
$parcel$export($d8206b3ab2e65c05$exports, "faLongArrowAltUp", () => $d8206b3ab2e65c05$export$43c8f2a46326c55f);
$parcel$export($d8206b3ab2e65c05$exports, "faStop", () => $d8206b3ab2e65c05$export$51577929c676143b);
$parcel$export($d8206b3ab2e65c05$exports, "faCodeMerge", () => $d8206b3ab2e65c05$export$e151fe5abf6db993);
$parcel$export($d8206b3ab2e65c05$exports, "faUpload", () => $d8206b3ab2e65c05$export$a9578350255b2b79);
$parcel$export($d8206b3ab2e65c05$exports, "faHurricane", () => $d8206b3ab2e65c05$export$4cf54a379be7e59a);
$parcel$export($d8206b3ab2e65c05$exports, "faMound", () => $d8206b3ab2e65c05$export$ac54ffffdb218383);
$parcel$export($d8206b3ab2e65c05$exports, "faToiletPortable", () => $d8206b3ab2e65c05$export$a3a5de5f6e2513ba);
$parcel$export($d8206b3ab2e65c05$exports, "faCompactDisc", () => $d8206b3ab2e65c05$export$84021631df0f831b);
$parcel$export($d8206b3ab2e65c05$exports, "faFileArrowDown", () => $d8206b3ab2e65c05$export$148bcede94488555);
$parcel$export($d8206b3ab2e65c05$exports, "faFileDownload", () => $d8206b3ab2e65c05$export$1013b9966d758343);
$parcel$export($d8206b3ab2e65c05$exports, "faCaravan", () => $d8206b3ab2e65c05$export$afb5d0eee7c1bdb);
$parcel$export($d8206b3ab2e65c05$exports, "faShieldCat", () => $d8206b3ab2e65c05$export$1639f087457d4f58);
$parcel$export($d8206b3ab2e65c05$exports, "faBolt", () => $d8206b3ab2e65c05$export$6869964aa308dd31);
$parcel$export($d8206b3ab2e65c05$exports, "faZap", () => $d8206b3ab2e65c05$export$d62abb82664f55ca);
$parcel$export($d8206b3ab2e65c05$exports, "faGlassWater", () => $d8206b3ab2e65c05$export$b80f542550a05ea7);
$parcel$export($d8206b3ab2e65c05$exports, "faOilWell", () => $d8206b3ab2e65c05$export$b69c6757012a2267);
$parcel$export($d8206b3ab2e65c05$exports, "faVault", () => $d8206b3ab2e65c05$export$4689a147513594a7);
$parcel$export($d8206b3ab2e65c05$exports, "faMars", () => $d8206b3ab2e65c05$export$a9f5c0b9c1e77a6f);
$parcel$export($d8206b3ab2e65c05$exports, "faToilet", () => $d8206b3ab2e65c05$export$505476859b9691c0);
$parcel$export($d8206b3ab2e65c05$exports, "faPlaneCircleXmark", () => $d8206b3ab2e65c05$export$94ef668f5108e431);
$parcel$export($d8206b3ab2e65c05$exports, "faYenSign", () => $d8206b3ab2e65c05$export$30f1437f5a4e991d);
$parcel$export($d8206b3ab2e65c05$exports, "faCny", () => $d8206b3ab2e65c05$export$268a23eee8f089a2);
$parcel$export($d8206b3ab2e65c05$exports, "faJpy", () => $d8206b3ab2e65c05$export$5460a9192eb79bf5);
$parcel$export($d8206b3ab2e65c05$exports, "faRmb", () => $d8206b3ab2e65c05$export$e2a8016afc962883);
$parcel$export($d8206b3ab2e65c05$exports, "faYen", () => $d8206b3ab2e65c05$export$cf914b1afb9455a2);
$parcel$export($d8206b3ab2e65c05$exports, "faRubleSign", () => $d8206b3ab2e65c05$export$1ae0a94c8ba4131a);
$parcel$export($d8206b3ab2e65c05$exports, "faRouble", () => $d8206b3ab2e65c05$export$c5dc3d98c4d8f2a5);
$parcel$export($d8206b3ab2e65c05$exports, "faRub", () => $d8206b3ab2e65c05$export$9c4d936240e1f0b1);
$parcel$export($d8206b3ab2e65c05$exports, "faRuble", () => $d8206b3ab2e65c05$export$6c0cf65134387046);
$parcel$export($d8206b3ab2e65c05$exports, "faSun", () => $d8206b3ab2e65c05$export$2fa35dcbc038dbe9);
$parcel$export($d8206b3ab2e65c05$exports, "faGuitar", () => $d8206b3ab2e65c05$export$790dd5b32282b6fb);
$parcel$export($d8206b3ab2e65c05$exports, "faFaceLaughWink", () => $d8206b3ab2e65c05$export$600a1b26b33c3d47);
$parcel$export($d8206b3ab2e65c05$exports, "faLaughWink", () => $d8206b3ab2e65c05$export$77ac40095f39933e);
$parcel$export($d8206b3ab2e65c05$exports, "faHorseHead", () => $d8206b3ab2e65c05$export$5bcca85203ebd1e8);
$parcel$export($d8206b3ab2e65c05$exports, "faBoreHole", () => $d8206b3ab2e65c05$export$cd79eeea6201e9d4);
$parcel$export($d8206b3ab2e65c05$exports, "faIndustry", () => $d8206b3ab2e65c05$export$5548c3eb51060fa8);
$parcel$export($d8206b3ab2e65c05$exports, "faCircleDown", () => $d8206b3ab2e65c05$export$531badb89cf01312);
$parcel$export($d8206b3ab2e65c05$exports, "faArrowAltCircleDown", () => $d8206b3ab2e65c05$export$ff3afbc8c0bc5d59);
$parcel$export($d8206b3ab2e65c05$exports, "faArrowsTurnToDots", () => $d8206b3ab2e65c05$export$b9d8fdf63999a76d);
$parcel$export($d8206b3ab2e65c05$exports, "faFlorinSign", () => $d8206b3ab2e65c05$export$6248ec7440b2ffcb);
$parcel$export($d8206b3ab2e65c05$exports, "faArrowDownShortWide", () => $d8206b3ab2e65c05$export$a51c464b699200ae);
$parcel$export($d8206b3ab2e65c05$exports, "faSortAmountDesc", () => $d8206b3ab2e65c05$export$93835bc31892b5c3);
$parcel$export($d8206b3ab2e65c05$exports, "faSortAmountDownAlt", () => $d8206b3ab2e65c05$export$e7d80d8c226cb77);
$parcel$export($d8206b3ab2e65c05$exports, "faLessThan", () => $d8206b3ab2e65c05$export$7f24f1bf98af5411);
$parcel$export($d8206b3ab2e65c05$exports, "faAngleDown", () => $d8206b3ab2e65c05$export$4b5be0142d10f342);
$parcel$export($d8206b3ab2e65c05$exports, "faCarTunnel", () => $d8206b3ab2e65c05$export$ec5cfe409de2ed37);
$parcel$export($d8206b3ab2e65c05$exports, "faHeadSideCough", () => $d8206b3ab2e65c05$export$3cd04b7c1624f598);
$parcel$export($d8206b3ab2e65c05$exports, "faGripLines", () => $d8206b3ab2e65c05$export$1412f35381064d7d);
$parcel$export($d8206b3ab2e65c05$exports, "faThumbsDown", () => $d8206b3ab2e65c05$export$aba24ca305bbe8c1);
$parcel$export($d8206b3ab2e65c05$exports, "faUserLock", () => $d8206b3ab2e65c05$export$d9b89b5872b67a4f);
$parcel$export($d8206b3ab2e65c05$exports, "faArrowRightLong", () => $d8206b3ab2e65c05$export$becbc35d3541bcc);
$parcel$export($d8206b3ab2e65c05$exports, "faLongArrowRight", () => $d8206b3ab2e65c05$export$7ec6527cf8651899);
$parcel$export($d8206b3ab2e65c05$exports, "faAnchorCircleXmark", () => $d8206b3ab2e65c05$export$f6773af4219eebd);
$parcel$export($d8206b3ab2e65c05$exports, "faEllipsis", () => $d8206b3ab2e65c05$export$37fe3659ba7b6b54);
$parcel$export($d8206b3ab2e65c05$exports, "faEllipsisH", () => $d8206b3ab2e65c05$export$c9f2fedd4489a2ee);
$parcel$export($d8206b3ab2e65c05$exports, "faChessPawn", () => $d8206b3ab2e65c05$export$3db75d5ac9e98468);
$parcel$export($d8206b3ab2e65c05$exports, "faKitMedical", () => $d8206b3ab2e65c05$export$f04e7a0f1033a0cd);
$parcel$export($d8206b3ab2e65c05$exports, "faFirstAid", () => $d8206b3ab2e65c05$export$5b01ccb2da4c4387);
$parcel$export($d8206b3ab2e65c05$exports, "faPersonThroughWindow", () => $d8206b3ab2e65c05$export$a77a2f6da72f89e3);
$parcel$export($d8206b3ab2e65c05$exports, "faToolbox", () => $d8206b3ab2e65c05$export$b34d64c205c732a9);
$parcel$export($d8206b3ab2e65c05$exports, "faHandsHoldingCircle", () => $d8206b3ab2e65c05$export$3aa81d0e606b08b6);
$parcel$export($d8206b3ab2e65c05$exports, "faBug", () => $d8206b3ab2e65c05$export$a18cfac400116d9f);
$parcel$export($d8206b3ab2e65c05$exports, "faCreditCard", () => $d8206b3ab2e65c05$export$3e7437bf6535bef0);
$parcel$export($d8206b3ab2e65c05$exports, "faCreditCardAlt", () => $d8206b3ab2e65c05$export$5fffe8e3c36964a2);
$parcel$export($d8206b3ab2e65c05$exports, "faCar", () => $d8206b3ab2e65c05$export$9eefe7fcdf123b76);
$parcel$export($d8206b3ab2e65c05$exports, "faAutomobile", () => $d8206b3ab2e65c05$export$240a6c53cf7ac525);
$parcel$export($d8206b3ab2e65c05$exports, "faHandHoldingHand", () => $d8206b3ab2e65c05$export$6638511b28df3be5);
$parcel$export($d8206b3ab2e65c05$exports, "faBookOpenReader", () => $d8206b3ab2e65c05$export$cb6e40528b98a5b);
$parcel$export($d8206b3ab2e65c05$exports, "faBookReader", () => $d8206b3ab2e65c05$export$cee14fe33262fa7d);
$parcel$export($d8206b3ab2e65c05$exports, "faMountainSun", () => $d8206b3ab2e65c05$export$af9eaee7db3ba7a9);
$parcel$export($d8206b3ab2e65c05$exports, "faArrowsLeftRightToLine", () => $d8206b3ab2e65c05$export$a63cecc8a4166c49);
$parcel$export($d8206b3ab2e65c05$exports, "faDiceD20", () => $d8206b3ab2e65c05$export$b06003a02c9055bd);
$parcel$export($d8206b3ab2e65c05$exports, "faTruckDroplet", () => $d8206b3ab2e65c05$export$41ce20639e8fef2b);
$parcel$export($d8206b3ab2e65c05$exports, "faFileCircleXmark", () => $d8206b3ab2e65c05$export$e4686afbe882e24a);
$parcel$export($d8206b3ab2e65c05$exports, "faTemperatureArrowUp", () => $d8206b3ab2e65c05$export$d7a5da41ce01461d);
$parcel$export($d8206b3ab2e65c05$exports, "faTemperatureUp", () => $d8206b3ab2e65c05$export$872345a0157330a3);
$parcel$export($d8206b3ab2e65c05$exports, "faMedal", () => $d8206b3ab2e65c05$export$b48a5be96314835a);
$parcel$export($d8206b3ab2e65c05$exports, "faBed", () => $d8206b3ab2e65c05$export$f24e0fce77994d4d);
$parcel$export($d8206b3ab2e65c05$exports, "faSquareH", () => $d8206b3ab2e65c05$export$51e3c5be06a49e32);
$parcel$export($d8206b3ab2e65c05$exports, "faHSquare", () => $d8206b3ab2e65c05$export$f08bbcf8f59eafc2);
$parcel$export($d8206b3ab2e65c05$exports, "faPodcast", () => $d8206b3ab2e65c05$export$5c0b4709125e92f8);
$parcel$export($d8206b3ab2e65c05$exports, "faTemperatureFull", () => $d8206b3ab2e65c05$export$bf4d97a79734997f);
$parcel$export($d8206b3ab2e65c05$exports, "faTemperature4", () => $d8206b3ab2e65c05$export$db946f8dc50a57ca);
$parcel$export($d8206b3ab2e65c05$exports, "faThermometer4", () => $d8206b3ab2e65c05$export$92b2e2293472dd50);
$parcel$export($d8206b3ab2e65c05$exports, "faThermometerFull", () => $d8206b3ab2e65c05$export$74e07083cef79a6f);
$parcel$export($d8206b3ab2e65c05$exports, "faBell", () => $d8206b3ab2e65c05$export$9b6162797ab1b255);
$parcel$export($d8206b3ab2e65c05$exports, "faSuperscript", () => $d8206b3ab2e65c05$export$4fa56a54e822dd25);
$parcel$export($d8206b3ab2e65c05$exports, "faPlugCircleXmark", () => $d8206b3ab2e65c05$export$12ef959394d63192);
$parcel$export($d8206b3ab2e65c05$exports, "faStarOfLife", () => $d8206b3ab2e65c05$export$aa3c4c1c5a47bf98);
$parcel$export($d8206b3ab2e65c05$exports, "faPhoneSlash", () => $d8206b3ab2e65c05$export$4c60a3aade08b6c2);
$parcel$export($d8206b3ab2e65c05$exports, "faPaintRoller", () => $d8206b3ab2e65c05$export$d1de8d1b815d6a5);
$parcel$export($d8206b3ab2e65c05$exports, "faHandshakeAngle", () => $d8206b3ab2e65c05$export$503f458ca5cf64c2);
$parcel$export($d8206b3ab2e65c05$exports, "faHandsHelping", () => $d8206b3ab2e65c05$export$287dbb1632da0d44);
$parcel$export($d8206b3ab2e65c05$exports, "faLocationDot", () => $d8206b3ab2e65c05$export$90a475e93ff4bb8a);
$parcel$export($d8206b3ab2e65c05$exports, "faMapMarkerAlt", () => $d8206b3ab2e65c05$export$4be92fa780613f93);
$parcel$export($d8206b3ab2e65c05$exports, "faFile", () => $d8206b3ab2e65c05$export$cad54bead856a678);
$parcel$export($d8206b3ab2e65c05$exports, "faGreaterThan", () => $d8206b3ab2e65c05$export$da07b6bc24a496ca);
$parcel$export($d8206b3ab2e65c05$exports, "faPersonSwimming", () => $d8206b3ab2e65c05$export$3fb4da6af843d39f);
$parcel$export($d8206b3ab2e65c05$exports, "faSwimmer", () => $d8206b3ab2e65c05$export$67daf2e2f88c1365);
$parcel$export($d8206b3ab2e65c05$exports, "faArrowDown", () => $d8206b3ab2e65c05$export$9686eff8d817f770);
$parcel$export($d8206b3ab2e65c05$exports, "faDroplet", () => $d8206b3ab2e65c05$export$cc1b6e60cb98fb90);
$parcel$export($d8206b3ab2e65c05$exports, "faTint", () => $d8206b3ab2e65c05$export$60dd975bd5938c15);
$parcel$export($d8206b3ab2e65c05$exports, "faEraser", () => $d8206b3ab2e65c05$export$e7fc4fe34e767f28);
$parcel$export($d8206b3ab2e65c05$exports, "faEarthAmericas", () => $d8206b3ab2e65c05$export$9c4218a898614082);
$parcel$export($d8206b3ab2e65c05$exports, "faEarth", () => $d8206b3ab2e65c05$export$c2118d3775773870);
$parcel$export($d8206b3ab2e65c05$exports, "faEarthAmerica", () => $d8206b3ab2e65c05$export$8b0f3a26397cf632);
$parcel$export($d8206b3ab2e65c05$exports, "faGlobeAmericas", () => $d8206b3ab2e65c05$export$e96bcc7bde9498db);
$parcel$export($d8206b3ab2e65c05$exports, "faPersonBurst", () => $d8206b3ab2e65c05$export$ae02241644924482);
$parcel$export($d8206b3ab2e65c05$exports, "faDove", () => $d8206b3ab2e65c05$export$a1ab1e69a300089f);
$parcel$export($d8206b3ab2e65c05$exports, "faBatteryEmpty", () => $d8206b3ab2e65c05$export$1344b64f6e922e12);
$parcel$export($d8206b3ab2e65c05$exports, "faBattery0", () => $d8206b3ab2e65c05$export$de8d0338927394c1);
$parcel$export($d8206b3ab2e65c05$exports, "faSocks", () => $d8206b3ab2e65c05$export$8d36a54dbf1e6bce);
$parcel$export($d8206b3ab2e65c05$exports, "faInbox", () => $d8206b3ab2e65c05$export$366b69cbdce46334);
$parcel$export($d8206b3ab2e65c05$exports, "faSection", () => $d8206b3ab2e65c05$export$a6f4f4a005d91fbd);
$parcel$export($d8206b3ab2e65c05$exports, "faGaugeHigh", () => $d8206b3ab2e65c05$export$d262c1f5912046e6);
$parcel$export($d8206b3ab2e65c05$exports, "faTachometerAlt", () => $d8206b3ab2e65c05$export$38dd17b9f064c10f);
$parcel$export($d8206b3ab2e65c05$exports, "faTachometerAltFast", () => $d8206b3ab2e65c05$export$e99d8b85f35b8ca5);
$parcel$export($d8206b3ab2e65c05$exports, "faEnvelopeOpenText", () => $d8206b3ab2e65c05$export$f5c53ce8ec380d11);
$parcel$export($d8206b3ab2e65c05$exports, "faHospital", () => $d8206b3ab2e65c05$export$7a76c9d35b42d691);
$parcel$export($d8206b3ab2e65c05$exports, "faHospitalAlt", () => $d8206b3ab2e65c05$export$cea7736417b94a3b);
$parcel$export($d8206b3ab2e65c05$exports, "faHospitalWide", () => $d8206b3ab2e65c05$export$69c8cc0360f017e8);
$parcel$export($d8206b3ab2e65c05$exports, "faWineBottle", () => $d8206b3ab2e65c05$export$770be8b3d5776043);
$parcel$export($d8206b3ab2e65c05$exports, "faChessRook", () => $d8206b3ab2e65c05$export$5d65c40a109eb09c);
$parcel$export($d8206b3ab2e65c05$exports, "faBarsStaggered", () => $d8206b3ab2e65c05$export$2f8a7938c06a2142);
$parcel$export($d8206b3ab2e65c05$exports, "faReorder", () => $d8206b3ab2e65c05$export$75d2bb378a2fc102);
$parcel$export($d8206b3ab2e65c05$exports, "faStream", () => $d8206b3ab2e65c05$export$ed81ab40fc4e904);
$parcel$export($d8206b3ab2e65c05$exports, "faDharmachakra", () => $d8206b3ab2e65c05$export$45cbd92c28deb2c7);
$parcel$export($d8206b3ab2e65c05$exports, "faHotdog", () => $d8206b3ab2e65c05$export$9fae219b4d3ce0be);
$parcel$export($d8206b3ab2e65c05$exports, "faPersonWalkingWithCane", () => $d8206b3ab2e65c05$export$2ffee5b2bc935c1f);
$parcel$export($d8206b3ab2e65c05$exports, "faBlind", () => $d8206b3ab2e65c05$export$923de21def6ea9b6);
$parcel$export($d8206b3ab2e65c05$exports, "faDrum", () => $d8206b3ab2e65c05$export$5b9205e1042594b7);
$parcel$export($d8206b3ab2e65c05$exports, "faIceCream", () => $d8206b3ab2e65c05$export$dd52741c60cc638f);
$parcel$export($d8206b3ab2e65c05$exports, "faHeartCircleBolt", () => $d8206b3ab2e65c05$export$2a376a9d0d8fee96);
$parcel$export($d8206b3ab2e65c05$exports, "faFax", () => $d8206b3ab2e65c05$export$b5698497901d7197);
$parcel$export($d8206b3ab2e65c05$exports, "faParagraph", () => $d8206b3ab2e65c05$export$dec46f8df1860e0);
$parcel$export($d8206b3ab2e65c05$exports, "faCheckToSlot", () => $d8206b3ab2e65c05$export$6999832247e52c2b);
$parcel$export($d8206b3ab2e65c05$exports, "faVoteYea", () => $d8206b3ab2e65c05$export$e87bb3db1608b850);
$parcel$export($d8206b3ab2e65c05$exports, "faStarHalf", () => $d8206b3ab2e65c05$export$228008b5e11032fa);
$parcel$export($d8206b3ab2e65c05$exports, "faBoxesStacked", () => $d8206b3ab2e65c05$export$2088efcf62cf3b1);
$parcel$export($d8206b3ab2e65c05$exports, "faBoxes", () => $d8206b3ab2e65c05$export$2007320dd6cde6db);
$parcel$export($d8206b3ab2e65c05$exports, "faBoxesAlt", () => $d8206b3ab2e65c05$export$e6ef1d896ed63b3e);
$parcel$export($d8206b3ab2e65c05$exports, "faLink", () => $d8206b3ab2e65c05$export$88bc01ff8dbecc55);
$parcel$export($d8206b3ab2e65c05$exports, "faChain", () => $d8206b3ab2e65c05$export$b5d071e02a25554f);
$parcel$export($d8206b3ab2e65c05$exports, "faEarListen", () => $d8206b3ab2e65c05$export$837bc776b490934d);
$parcel$export($d8206b3ab2e65c05$exports, "faAssistiveListeningSystems", () => $d8206b3ab2e65c05$export$8eeef3dc0035b165);
$parcel$export($d8206b3ab2e65c05$exports, "faTreeCity", () => $d8206b3ab2e65c05$export$ad95e4f80f98ebe0);
$parcel$export($d8206b3ab2e65c05$exports, "faPlay", () => $d8206b3ab2e65c05$export$436587205947bca5);
$parcel$export($d8206b3ab2e65c05$exports, "faFont", () => $d8206b3ab2e65c05$export$a5dc297d3f60936);
$parcel$export($d8206b3ab2e65c05$exports, "faRupiahSign", () => $d8206b3ab2e65c05$export$fe44d4c71644ea0);
$parcel$export($d8206b3ab2e65c05$exports, "faMagnifyingGlass", () => $d8206b3ab2e65c05$export$34c8b97060c09ff);
$parcel$export($d8206b3ab2e65c05$exports, "faSearch", () => $d8206b3ab2e65c05$export$871a78837687ffe8);
$parcel$export($d8206b3ab2e65c05$exports, "faTableTennisPaddleBall", () => $d8206b3ab2e65c05$export$eabe53838d45ac6a);
$parcel$export($d8206b3ab2e65c05$exports, "faPingPongPaddleBall", () => $d8206b3ab2e65c05$export$ebb246c621751737);
$parcel$export($d8206b3ab2e65c05$exports, "faTableTennis", () => $d8206b3ab2e65c05$export$f378fbb4e0ef7edf);
$parcel$export($d8206b3ab2e65c05$exports, "faPersonDotsFromLine", () => $d8206b3ab2e65c05$export$cdcec8ca7ec0d381);
$parcel$export($d8206b3ab2e65c05$exports, "faDiagnoses", () => $d8206b3ab2e65c05$export$68bad2b52a90d1fa);
$parcel$export($d8206b3ab2e65c05$exports, "faTrashCanArrowUp", () => $d8206b3ab2e65c05$export$60430351cdb4ba89);
$parcel$export($d8206b3ab2e65c05$exports, "faTrashRestoreAlt", () => $d8206b3ab2e65c05$export$d075b19b21cb9856);
$parcel$export($d8206b3ab2e65c05$exports, "faNairaSign", () => $d8206b3ab2e65c05$export$58b7558ca9822358);
$parcel$export($d8206b3ab2e65c05$exports, "faCartArrowDown", () => $d8206b3ab2e65c05$export$9206260ff0c0c616);
$parcel$export($d8206b3ab2e65c05$exports, "faWalkieTalkie", () => $d8206b3ab2e65c05$export$8a322f740d64e9fc);
$parcel$export($d8206b3ab2e65c05$exports, "faFilePen", () => $d8206b3ab2e65c05$export$27f34878d8ed7a76);
$parcel$export($d8206b3ab2e65c05$exports, "faFileEdit", () => $d8206b3ab2e65c05$export$e343e19f1757c5ae);
$parcel$export($d8206b3ab2e65c05$exports, "faReceipt", () => $d8206b3ab2e65c05$export$32b0cd6133c2742);
$parcel$export($d8206b3ab2e65c05$exports, "faSquarePen", () => $d8206b3ab2e65c05$export$3643b719db23d46e);
$parcel$export($d8206b3ab2e65c05$exports, "faPenSquare", () => $d8206b3ab2e65c05$export$fbb231ccb3d960bc);
$parcel$export($d8206b3ab2e65c05$exports, "faPencilSquare", () => $d8206b3ab2e65c05$export$35d253ecd249e771);
$parcel$export($d8206b3ab2e65c05$exports, "faSuitcaseRolling", () => $d8206b3ab2e65c05$export$957e62a9b80ff4e3);
$parcel$export($d8206b3ab2e65c05$exports, "faPersonCircleExclamation", () => $d8206b3ab2e65c05$export$38c8c32017dd9cc);
$parcel$export($d8206b3ab2e65c05$exports, "faChevronDown", () => $d8206b3ab2e65c05$export$8db9bc521720fccd);
$parcel$export($d8206b3ab2e65c05$exports, "faBatteryFull", () => $d8206b3ab2e65c05$export$9338fc4614cfc0cf);
$parcel$export($d8206b3ab2e65c05$exports, "faBattery", () => $d8206b3ab2e65c05$export$214720d39635cea8);
$parcel$export($d8206b3ab2e65c05$exports, "faBattery5", () => $d8206b3ab2e65c05$export$e426617482c711a7);
$parcel$export($d8206b3ab2e65c05$exports, "faSkullCrossbones", () => $d8206b3ab2e65c05$export$8717352b90217272);
$parcel$export($d8206b3ab2e65c05$exports, "faCodeCompare", () => $d8206b3ab2e65c05$export$ca4c5b4dcff58860);
$parcel$export($d8206b3ab2e65c05$exports, "faListUl", () => $d8206b3ab2e65c05$export$f8a219cf4f516384);
$parcel$export($d8206b3ab2e65c05$exports, "faListDots", () => $d8206b3ab2e65c05$export$e6f4ba30d84fa6ea);
$parcel$export($d8206b3ab2e65c05$exports, "faSchoolLock", () => $d8206b3ab2e65c05$export$8845cce2a763ee07);
$parcel$export($d8206b3ab2e65c05$exports, "faTowerCell", () => $d8206b3ab2e65c05$export$f4b64c3a138c1b59);
$parcel$export($d8206b3ab2e65c05$exports, "faDownLong", () => $d8206b3ab2e65c05$export$e88ba08d4f4d65b6);
$parcel$export($d8206b3ab2e65c05$exports, "faLongArrowAltDown", () => $d8206b3ab2e65c05$export$8b92530ca6418c2f);
$parcel$export($d8206b3ab2e65c05$exports, "faRankingStar", () => $d8206b3ab2e65c05$export$e6fd420a918b43b5);
$parcel$export($d8206b3ab2e65c05$exports, "faChessKing", () => $d8206b3ab2e65c05$export$d5713874f8fefe1b);
$parcel$export($d8206b3ab2e65c05$exports, "faPersonHarassing", () => $d8206b3ab2e65c05$export$dcd74f2821882a49);
$parcel$export($d8206b3ab2e65c05$exports, "faBrazilianRealSign", () => $d8206b3ab2e65c05$export$9d355b4e79216962);
$parcel$export($d8206b3ab2e65c05$exports, "faLandmarkDome", () => $d8206b3ab2e65c05$export$8a56136f40511e5d);
$parcel$export($d8206b3ab2e65c05$exports, "faLandmarkAlt", () => $d8206b3ab2e65c05$export$8b9c180efffc50ab);
$parcel$export($d8206b3ab2e65c05$exports, "faArrowUp", () => $d8206b3ab2e65c05$export$8e144ed4d52eef49);
$parcel$export($d8206b3ab2e65c05$exports, "faTv", () => $d8206b3ab2e65c05$export$e0cfed4ba2fe562c);
$parcel$export($d8206b3ab2e65c05$exports, "faTelevision", () => $d8206b3ab2e65c05$export$9803b0176917be28);
$parcel$export($d8206b3ab2e65c05$exports, "faTvAlt", () => $d8206b3ab2e65c05$export$6aa64ad5a1974ad7);
$parcel$export($d8206b3ab2e65c05$exports, "faShrimp", () => $d8206b3ab2e65c05$export$ac094c06f566cca3);
$parcel$export($d8206b3ab2e65c05$exports, "faListCheck", () => $d8206b3ab2e65c05$export$350a84fd0f833f4d);
$parcel$export($d8206b3ab2e65c05$exports, "faTasks", () => $d8206b3ab2e65c05$export$2f6d5b2fec286d63);
$parcel$export($d8206b3ab2e65c05$exports, "faJugDetergent", () => $d8206b3ab2e65c05$export$3fe50bd8062cd141);
$parcel$export($d8206b3ab2e65c05$exports, "faCircleUser", () => $d8206b3ab2e65c05$export$9a5c11a5e3d7f1e7);
$parcel$export($d8206b3ab2e65c05$exports, "faUserCircle", () => $d8206b3ab2e65c05$export$be7d974e9e0dba1a);
$parcel$export($d8206b3ab2e65c05$exports, "faUserShield", () => $d8206b3ab2e65c05$export$d1886bc596424e6c);
$parcel$export($d8206b3ab2e65c05$exports, "faWind", () => $d8206b3ab2e65c05$export$cc58cb0f2257a6a9);
$parcel$export($d8206b3ab2e65c05$exports, "faCarBurst", () => $d8206b3ab2e65c05$export$6d2be7c5d395dd16);
$parcel$export($d8206b3ab2e65c05$exports, "faCarCrash", () => $d8206b3ab2e65c05$export$8ff55566398404cd);
$parcel$export($d8206b3ab2e65c05$exports, "faY", () => $d8206b3ab2e65c05$export$b8c4c058fe7d193c);
$parcel$export($d8206b3ab2e65c05$exports, "faPersonSnowboarding", () => $d8206b3ab2e65c05$export$22c642403aeeaeaf);
$parcel$export($d8206b3ab2e65c05$exports, "faSnowboarding", () => $d8206b3ab2e65c05$export$72683772d587302a);
$parcel$export($d8206b3ab2e65c05$exports, "faTruckFast", () => $d8206b3ab2e65c05$export$27de16299ddd171);
$parcel$export($d8206b3ab2e65c05$exports, "faShippingFast", () => $d8206b3ab2e65c05$export$5e419f47aaeb3c05);
$parcel$export($d8206b3ab2e65c05$exports, "faFish", () => $d8206b3ab2e65c05$export$24228a855c5f6812);
$parcel$export($d8206b3ab2e65c05$exports, "faUserGraduate", () => $d8206b3ab2e65c05$export$10f5839059d22f7e);
$parcel$export($d8206b3ab2e65c05$exports, "faCircleHalfStroke", () => $d8206b3ab2e65c05$export$625fb3848216f28c);
$parcel$export($d8206b3ab2e65c05$exports, "faAdjust", () => $d8206b3ab2e65c05$export$cfa06e4b68edca2d);
$parcel$export($d8206b3ab2e65c05$exports, "faClapperboard", () => $d8206b3ab2e65c05$export$add3b381ced12554);
$parcel$export($d8206b3ab2e65c05$exports, "faCircleRadiation", () => $d8206b3ab2e65c05$export$55c8e3afd9f6c0b4);
$parcel$export($d8206b3ab2e65c05$exports, "faRadiationAlt", () => $d8206b3ab2e65c05$export$2f048fa82bbddf6f);
$parcel$export($d8206b3ab2e65c05$exports, "faBaseball", () => $d8206b3ab2e65c05$export$dc3654cf8a596fbf);
$parcel$export($d8206b3ab2e65c05$exports, "faBaseballBall", () => $d8206b3ab2e65c05$export$63a3f8ceae07c7f3);
$parcel$export($d8206b3ab2e65c05$exports, "faJetFighterUp", () => $d8206b3ab2e65c05$export$b024a52a4ccf5e69);
$parcel$export($d8206b3ab2e65c05$exports, "faDiagramProject", () => $d8206b3ab2e65c05$export$59c351869dc27435);
$parcel$export($d8206b3ab2e65c05$exports, "faProjectDiagram", () => $d8206b3ab2e65c05$export$30bf9f5b96509df1);
$parcel$export($d8206b3ab2e65c05$exports, "faCopy", () => $d8206b3ab2e65c05$export$e9bd786d30cb716c);
$parcel$export($d8206b3ab2e65c05$exports, "faVolumeXmark", () => $d8206b3ab2e65c05$export$28cc565c11db6f2e);
$parcel$export($d8206b3ab2e65c05$exports, "faVolumeMute", () => $d8206b3ab2e65c05$export$aa8decd057dfd29b);
$parcel$export($d8206b3ab2e65c05$exports, "faVolumeTimes", () => $d8206b3ab2e65c05$export$a1c7b36ba71dbeca);
$parcel$export($d8206b3ab2e65c05$exports, "faHandSparkles", () => $d8206b3ab2e65c05$export$72e2d874a963de0c);
$parcel$export($d8206b3ab2e65c05$exports, "faGrip", () => $d8206b3ab2e65c05$export$eb83fb404127db75);
$parcel$export($d8206b3ab2e65c05$exports, "faGripHorizontal", () => $d8206b3ab2e65c05$export$4a45308d6c8decc1);
$parcel$export($d8206b3ab2e65c05$exports, "faShareFromSquare", () => $d8206b3ab2e65c05$export$928280bdd54fa173);
$parcel$export($d8206b3ab2e65c05$exports, "faShareSquare", () => $d8206b3ab2e65c05$export$ae9e1434571f373c);
$parcel$export($d8206b3ab2e65c05$exports, "faChildCombatant", () => $d8206b3ab2e65c05$export$f7367a7301f2dc0f);
$parcel$export($d8206b3ab2e65c05$exports, "faChildRifle", () => $d8206b3ab2e65c05$export$9b027cdb5db3ae5c);
$parcel$export($d8206b3ab2e65c05$exports, "faGun", () => $d8206b3ab2e65c05$export$e18f576a7b31ba46);
$parcel$export($d8206b3ab2e65c05$exports, "faSquarePhone", () => $d8206b3ab2e65c05$export$318ed022991eef56);
$parcel$export($d8206b3ab2e65c05$exports, "faPhoneSquare", () => $d8206b3ab2e65c05$export$8ba22605a641ebdf);
$parcel$export($d8206b3ab2e65c05$exports, "faPlus", () => $d8206b3ab2e65c05$export$a105e7b44ca0eb9e);
$parcel$export($d8206b3ab2e65c05$exports, "faAdd", () => $d8206b3ab2e65c05$export$9e8f9a9d4ad32c0f);
$parcel$export($d8206b3ab2e65c05$exports, "faExpand", () => $d8206b3ab2e65c05$export$1fe4a9976a241685);
$parcel$export($d8206b3ab2e65c05$exports, "faComputer", () => $d8206b3ab2e65c05$export$9835883ce9d0fe78);
$parcel$export($d8206b3ab2e65c05$exports, "faXmark", () => $d8206b3ab2e65c05$export$e6e44779b2fa1a5c);
$parcel$export($d8206b3ab2e65c05$exports, "faClose", () => $d8206b3ab2e65c05$export$23c717133fd81476);
$parcel$export($d8206b3ab2e65c05$exports, "faMultiply", () => $d8206b3ab2e65c05$export$4ed4ff13d4dbc862);
$parcel$export($d8206b3ab2e65c05$exports, "faRemove", () => $d8206b3ab2e65c05$export$34810740c1bd6c54);
$parcel$export($d8206b3ab2e65c05$exports, "faTimes", () => $d8206b3ab2e65c05$export$174bd7f477b115b4);
$parcel$export($d8206b3ab2e65c05$exports, "faArrowsUpDownLeftRight", () => $d8206b3ab2e65c05$export$ff9a43e3a9cb653c);
$parcel$export($d8206b3ab2e65c05$exports, "faArrows", () => $d8206b3ab2e65c05$export$d5ae09a305d70340);
$parcel$export($d8206b3ab2e65c05$exports, "faChalkboardUser", () => $d8206b3ab2e65c05$export$fd7622d4b8d3674b);
$parcel$export($d8206b3ab2e65c05$exports, "faChalkboardTeacher", () => $d8206b3ab2e65c05$export$443fcf69b0155291);
$parcel$export($d8206b3ab2e65c05$exports, "faPesoSign", () => $d8206b3ab2e65c05$export$c8f99b9b5ea83555);
$parcel$export($d8206b3ab2e65c05$exports, "faBuildingShield", () => $d8206b3ab2e65c05$export$18ba6a500873dba9);
$parcel$export($d8206b3ab2e65c05$exports, "faBaby", () => $d8206b3ab2e65c05$export$8afab767536f59ad);
$parcel$export($d8206b3ab2e65c05$exports, "faUsersLine", () => $d8206b3ab2e65c05$export$d7e538fddb81da68);
$parcel$export($d8206b3ab2e65c05$exports, "faQuoteLeft", () => $d8206b3ab2e65c05$export$932a67a1b1a7a724);
$parcel$export($d8206b3ab2e65c05$exports, "faQuoteLeftAlt", () => $d8206b3ab2e65c05$export$95bb9ad3aa35c741);
$parcel$export($d8206b3ab2e65c05$exports, "faTractor", () => $d8206b3ab2e65c05$export$e87e41787bbedc98);
$parcel$export($d8206b3ab2e65c05$exports, "faTrashArrowUp", () => $d8206b3ab2e65c05$export$940cea0f5451895c);
$parcel$export($d8206b3ab2e65c05$exports, "faTrashRestore", () => $d8206b3ab2e65c05$export$d32f45a64ed40e8d);
$parcel$export($d8206b3ab2e65c05$exports, "faArrowDownUpLock", () => $d8206b3ab2e65c05$export$fc9f7bd981c34c45);
$parcel$export($d8206b3ab2e65c05$exports, "faLinesLeaning", () => $d8206b3ab2e65c05$export$4d384ffc907ddaff);
$parcel$export($d8206b3ab2e65c05$exports, "faRulerCombined", () => $d8206b3ab2e65c05$export$613f406c1b5802a8);
$parcel$export($d8206b3ab2e65c05$exports, "faCopyright", () => $d8206b3ab2e65c05$export$da61665fff8aebfe);
$parcel$export($d8206b3ab2e65c05$exports, "faEquals", () => $d8206b3ab2e65c05$export$a7c5f5e4805fdab);
$parcel$export($d8206b3ab2e65c05$exports, "faBlender", () => $d8206b3ab2e65c05$export$db34f7a6de38784f);
$parcel$export($d8206b3ab2e65c05$exports, "faTeeth", () => $d8206b3ab2e65c05$export$b4619aeaf0b9d18e);
$parcel$export($d8206b3ab2e65c05$exports, "faShekelSign", () => $d8206b3ab2e65c05$export$3570be7b68efb8db);
$parcel$export($d8206b3ab2e65c05$exports, "faIls", () => $d8206b3ab2e65c05$export$ecadeff45b05a451);
$parcel$export($d8206b3ab2e65c05$exports, "faShekel", () => $d8206b3ab2e65c05$export$27e0e10e74d98736);
$parcel$export($d8206b3ab2e65c05$exports, "faSheqel", () => $d8206b3ab2e65c05$export$28b3b26a80030d4e);
$parcel$export($d8206b3ab2e65c05$exports, "faSheqelSign", () => $d8206b3ab2e65c05$export$d84993fb5e8c6edd);
$parcel$export($d8206b3ab2e65c05$exports, "faMap", () => $d8206b3ab2e65c05$export$fc82fb79180cd17c);
$parcel$export($d8206b3ab2e65c05$exports, "faRocket", () => $d8206b3ab2e65c05$export$b24d84ed5657d89a);
$parcel$export($d8206b3ab2e65c05$exports, "faPhotoFilm", () => $d8206b3ab2e65c05$export$ed36ad335b36be22);
$parcel$export($d8206b3ab2e65c05$exports, "faPhotoVideo", () => $d8206b3ab2e65c05$export$739f6a6a12dfb6ed);
$parcel$export($d8206b3ab2e65c05$exports, "faFolderMinus", () => $d8206b3ab2e65c05$export$758f1fb3784e4080);
$parcel$export($d8206b3ab2e65c05$exports, "faStore", () => $d8206b3ab2e65c05$export$de59c2657a8ace67);
$parcel$export($d8206b3ab2e65c05$exports, "faArrowTrendUp", () => $d8206b3ab2e65c05$export$cf36928a9c52e98a);
$parcel$export($d8206b3ab2e65c05$exports, "faPlugCircleMinus", () => $d8206b3ab2e65c05$export$2a44d62160972254);
$parcel$export($d8206b3ab2e65c05$exports, "faSignHanging", () => $d8206b3ab2e65c05$export$5c1f29f4c7cad367);
$parcel$export($d8206b3ab2e65c05$exports, "faSign", () => $d8206b3ab2e65c05$export$d21d0d6c8e9e8bf9);
$parcel$export($d8206b3ab2e65c05$exports, "faBezierCurve", () => $d8206b3ab2e65c05$export$a527a6267c55a54c);
$parcel$export($d8206b3ab2e65c05$exports, "faBellSlash", () => $d8206b3ab2e65c05$export$6b31a1e5968b2378);
$parcel$export($d8206b3ab2e65c05$exports, "faTablet", () => $d8206b3ab2e65c05$export$1c92b67c45a4b4fc);
$parcel$export($d8206b3ab2e65c05$exports, "faTabletAndroid", () => $d8206b3ab2e65c05$export$5eddbb7c71278268);
$parcel$export($d8206b3ab2e65c05$exports, "faSchoolFlag", () => $d8206b3ab2e65c05$export$9b263780a7312c8c);
$parcel$export($d8206b3ab2e65c05$exports, "faFill", () => $d8206b3ab2e65c05$export$d3c2bcfd3b861e4a);
$parcel$export($d8206b3ab2e65c05$exports, "faAngleUp", () => $d8206b3ab2e65c05$export$887340269e6d6cac);
$parcel$export($d8206b3ab2e65c05$exports, "faDrumstickBite", () => $d8206b3ab2e65c05$export$482976e9a4ab10f3);
$parcel$export($d8206b3ab2e65c05$exports, "faHollyBerry", () => $d8206b3ab2e65c05$export$273296afacf93991);
$parcel$export($d8206b3ab2e65c05$exports, "faChevronLeft", () => $d8206b3ab2e65c05$export$75702e3e3dd44a44);
$parcel$export($d8206b3ab2e65c05$exports, "faBacteria", () => $d8206b3ab2e65c05$export$7fc18cf2d526c341);
$parcel$export($d8206b3ab2e65c05$exports, "faHandLizard", () => $d8206b3ab2e65c05$export$54608d0a883fea4d);
$parcel$export($d8206b3ab2e65c05$exports, "faNotdef", () => $d8206b3ab2e65c05$export$3db5bca65a1be8dc);
$parcel$export($d8206b3ab2e65c05$exports, "faDisease", () => $d8206b3ab2e65c05$export$c7675a37487adc45);
$parcel$export($d8206b3ab2e65c05$exports, "faBriefcaseMedical", () => $d8206b3ab2e65c05$export$5000f52ca9819bf5);
$parcel$export($d8206b3ab2e65c05$exports, "faGenderless", () => $d8206b3ab2e65c05$export$c093cc22e88981c2);
$parcel$export($d8206b3ab2e65c05$exports, "faChevronRight", () => $d8206b3ab2e65c05$export$930de8c26eb20490);
$parcel$export($d8206b3ab2e65c05$exports, "faRetweet", () => $d8206b3ab2e65c05$export$cebc76f79478e40e);
$parcel$export($d8206b3ab2e65c05$exports, "faCarRear", () => $d8206b3ab2e65c05$export$ff2b8d5628da5f14);
$parcel$export($d8206b3ab2e65c05$exports, "faCarAlt", () => $d8206b3ab2e65c05$export$7937ed2462a665c0);
$parcel$export($d8206b3ab2e65c05$exports, "faPumpSoap", () => $d8206b3ab2e65c05$export$821aeede187f23c9);
$parcel$export($d8206b3ab2e65c05$exports, "faVideoSlash", () => $d8206b3ab2e65c05$export$a714fc79f58cc9ef);
$parcel$export($d8206b3ab2e65c05$exports, "faBatteryQuarter", () => $d8206b3ab2e65c05$export$acec92052ac2183);
$parcel$export($d8206b3ab2e65c05$exports, "faBattery2", () => $d8206b3ab2e65c05$export$23ca8a94c555576);
$parcel$export($d8206b3ab2e65c05$exports, "faRadio", () => $d8206b3ab2e65c05$export$11b26516cae2104f);
$parcel$export($d8206b3ab2e65c05$exports, "faBabyCarriage", () => $d8206b3ab2e65c05$export$3b3ab4d86bad7d26);
$parcel$export($d8206b3ab2e65c05$exports, "faCarriageBaby", () => $d8206b3ab2e65c05$export$9f117d92ccd36cf1);
$parcel$export($d8206b3ab2e65c05$exports, "faTrafficLight", () => $d8206b3ab2e65c05$export$bf0b19daceaec9c2);
$parcel$export($d8206b3ab2e65c05$exports, "faThermometer", () => $d8206b3ab2e65c05$export$f576739e9b18ea4f);
$parcel$export($d8206b3ab2e65c05$exports, "faVrCardboard", () => $d8206b3ab2e65c05$export$248171cb6dad4307);
$parcel$export($d8206b3ab2e65c05$exports, "faHandMiddleFinger", () => $d8206b3ab2e65c05$export$bd40d3a3a16fb147);
$parcel$export($d8206b3ab2e65c05$exports, "faPercent", () => $d8206b3ab2e65c05$export$89a1764fbb7ad2cb);
$parcel$export($d8206b3ab2e65c05$exports, "faPercentage", () => $d8206b3ab2e65c05$export$89333857fc063a2e);
$parcel$export($d8206b3ab2e65c05$exports, "faTruckMoving", () => $d8206b3ab2e65c05$export$a06617a1a4ccea67);
$parcel$export($d8206b3ab2e65c05$exports, "faGlassWaterDroplet", () => $d8206b3ab2e65c05$export$b7ae54b4078b2060);
$parcel$export($d8206b3ab2e65c05$exports, "faDisplay", () => $d8206b3ab2e65c05$export$e9d85839f7751f01);
$parcel$export($d8206b3ab2e65c05$exports, "faFaceSmile", () => $d8206b3ab2e65c05$export$b5023c446f10324);
$parcel$export($d8206b3ab2e65c05$exports, "faSmile", () => $d8206b3ab2e65c05$export$c632b2334f0913bc);
$parcel$export($d8206b3ab2e65c05$exports, "faThumbtack", () => $d8206b3ab2e65c05$export$b6314cdc01bb5c43);
$parcel$export($d8206b3ab2e65c05$exports, "faThumbTack", () => $d8206b3ab2e65c05$export$b63d0c7b519a9aae);
$parcel$export($d8206b3ab2e65c05$exports, "faTrophy", () => $d8206b3ab2e65c05$export$29c432d69ccf85a5);
$parcel$export($d8206b3ab2e65c05$exports, "faPersonPraying", () => $d8206b3ab2e65c05$export$8ecd436ef91fc02e);
$parcel$export($d8206b3ab2e65c05$exports, "faPray", () => $d8206b3ab2e65c05$export$3b32c982141cad51);
$parcel$export($d8206b3ab2e65c05$exports, "faHammer", () => $d8206b3ab2e65c05$export$6310f315e1ebbca5);
$parcel$export($d8206b3ab2e65c05$exports, "faHandPeace", () => $d8206b3ab2e65c05$export$e49e3cfceea441cc);
$parcel$export($d8206b3ab2e65c05$exports, "faRotate", () => $d8206b3ab2e65c05$export$decde496a29c5b23);
$parcel$export($d8206b3ab2e65c05$exports, "faSyncAlt", () => $d8206b3ab2e65c05$export$2ff2056be8c281e4);
$parcel$export($d8206b3ab2e65c05$exports, "faSpinner", () => $d8206b3ab2e65c05$export$1025ad641edb49c2);
$parcel$export($d8206b3ab2e65c05$exports, "faRobot", () => $d8206b3ab2e65c05$export$30a5bb4ad3fa716c);
$parcel$export($d8206b3ab2e65c05$exports, "faPeace", () => $d8206b3ab2e65c05$export$8614cb1326eacd7a);
$parcel$export($d8206b3ab2e65c05$exports, "faGears", () => $d8206b3ab2e65c05$export$4aac79b9ae3cfdb8);
$parcel$export($d8206b3ab2e65c05$exports, "faCogs", () => $d8206b3ab2e65c05$export$af1575770afc9559);
$parcel$export($d8206b3ab2e65c05$exports, "faWarehouse", () => $d8206b3ab2e65c05$export$e3a174a50618c208);
$parcel$export($d8206b3ab2e65c05$exports, "faArrowUpRightDots", () => $d8206b3ab2e65c05$export$bc804c6ab898f610);
$parcel$export($d8206b3ab2e65c05$exports, "faSplotch", () => $d8206b3ab2e65c05$export$d6f21e17ea797702);
$parcel$export($d8206b3ab2e65c05$exports, "faFaceGrinHearts", () => $d8206b3ab2e65c05$export$fbb22081b65e4f33);
$parcel$export($d8206b3ab2e65c05$exports, "faGrinHearts", () => $d8206b3ab2e65c05$export$c56cf0e0c3bc5ed2);
$parcel$export($d8206b3ab2e65c05$exports, "faDiceFour", () => $d8206b3ab2e65c05$export$2df6451abf70a6ff);
$parcel$export($d8206b3ab2e65c05$exports, "faSimCard", () => $d8206b3ab2e65c05$export$3bee83bf278fddbe);
$parcel$export($d8206b3ab2e65c05$exports, "faTransgender", () => $d8206b3ab2e65c05$export$7e3f1701aa95ef01);
$parcel$export($d8206b3ab2e65c05$exports, "faTransgenderAlt", () => $d8206b3ab2e65c05$export$9c36cf9334c052f);
$parcel$export($d8206b3ab2e65c05$exports, "faMercury", () => $d8206b3ab2e65c05$export$e134ecd00b622a47);
$parcel$export($d8206b3ab2e65c05$exports, "faArrowTurnDown", () => $d8206b3ab2e65c05$export$fd4d6cfd52703f50);
$parcel$export($d8206b3ab2e65c05$exports, "faLevelDown", () => $d8206b3ab2e65c05$export$3794c07e7a666c94);
$parcel$export($d8206b3ab2e65c05$exports, "faPersonFallingBurst", () => $d8206b3ab2e65c05$export$a75569baaf4a6c3a);
$parcel$export($d8206b3ab2e65c05$exports, "faAward", () => $d8206b3ab2e65c05$export$f8db2747dadd48f7);
$parcel$export($d8206b3ab2e65c05$exports, "faTicketSimple", () => $d8206b3ab2e65c05$export$68ddda3b30ba09f0);
$parcel$export($d8206b3ab2e65c05$exports, "faTicketAlt", () => $d8206b3ab2e65c05$export$75e38ba471fd89c4);
$parcel$export($d8206b3ab2e65c05$exports, "faBuilding", () => $d8206b3ab2e65c05$export$f26673f8b10c3d46);
$parcel$export($d8206b3ab2e65c05$exports, "faAnglesLeft", () => $d8206b3ab2e65c05$export$2ebd565813951f81);
$parcel$export($d8206b3ab2e65c05$exports, "faAngleDoubleLeft", () => $d8206b3ab2e65c05$export$21b0833b3cf929a7);
$parcel$export($d8206b3ab2e65c05$exports, "faQrcode", () => $d8206b3ab2e65c05$export$fc19ca0fe15e73bc);
$parcel$export($d8206b3ab2e65c05$exports, "faClockRotateLeft", () => $d8206b3ab2e65c05$export$29be1665d1b36a3b);
$parcel$export($d8206b3ab2e65c05$exports, "faHistory", () => $d8206b3ab2e65c05$export$76d1986559ca7b7a);
$parcel$export($d8206b3ab2e65c05$exports, "faFaceGrinBeamSweat", () => $d8206b3ab2e65c05$export$2ff38f330c834084);
$parcel$export($d8206b3ab2e65c05$exports, "faGrinBeamSweat", () => $d8206b3ab2e65c05$export$14d0ccc54c5b6826);
$parcel$export($d8206b3ab2e65c05$exports, "faFileExport", () => $d8206b3ab2e65c05$export$364f19abcfac1b0a);
$parcel$export($d8206b3ab2e65c05$exports, "faArrowRightFromFile", () => $d8206b3ab2e65c05$export$b9c76255b38e1df1);
$parcel$export($d8206b3ab2e65c05$exports, "faShield", () => $d8206b3ab2e65c05$export$8241bd5b9163ca12);
$parcel$export($d8206b3ab2e65c05$exports, "faShieldBlank", () => $d8206b3ab2e65c05$export$64f54da8fbaba8ee);
$parcel$export($d8206b3ab2e65c05$exports, "faArrowUpShortWide", () => $d8206b3ab2e65c05$export$be9d5060a4bc3b4b);
$parcel$export($d8206b3ab2e65c05$exports, "faSortAmountUpAlt", () => $d8206b3ab2e65c05$export$6e87844b0f151b6a);
$parcel$export($d8206b3ab2e65c05$exports, "faHouseMedical", () => $d8206b3ab2e65c05$export$2d077da983246a68);
$parcel$export($d8206b3ab2e65c05$exports, "faGolfBallTee", () => $d8206b3ab2e65c05$export$14c9f1d85e53ae99);
$parcel$export($d8206b3ab2e65c05$exports, "faGolfBall", () => $d8206b3ab2e65c05$export$2251487a9a33c682);
$parcel$export($d8206b3ab2e65c05$exports, "faCircleChevronLeft", () => $d8206b3ab2e65c05$export$f2b13ad44c03c40f);
$parcel$export($d8206b3ab2e65c05$exports, "faChevronCircleLeft", () => $d8206b3ab2e65c05$export$4a42c8c2451a33fd);
$parcel$export($d8206b3ab2e65c05$exports, "faHouseChimneyWindow", () => $d8206b3ab2e65c05$export$792391babe46862d);
$parcel$export($d8206b3ab2e65c05$exports, "faPenNib", () => $d8206b3ab2e65c05$export$a82594dcc75a49f5);
$parcel$export($d8206b3ab2e65c05$exports, "faTentArrowTurnLeft", () => $d8206b3ab2e65c05$export$89af87b7d6c15adf);
$parcel$export($d8206b3ab2e65c05$exports, "faTents", () => $d8206b3ab2e65c05$export$c93b950e845a4ee7);
$parcel$export($d8206b3ab2e65c05$exports, "faWandMagic", () => $d8206b3ab2e65c05$export$8282f5f5dcf6b009);
$parcel$export($d8206b3ab2e65c05$exports, "faMagic", () => $d8206b3ab2e65c05$export$e58f9b502d4dd52d);
$parcel$export($d8206b3ab2e65c05$exports, "faDog", () => $d8206b3ab2e65c05$export$c6406747800cf702);
$parcel$export($d8206b3ab2e65c05$exports, "faCarrot", () => $d8206b3ab2e65c05$export$28e93ec9f5e2ddf3);
$parcel$export($d8206b3ab2e65c05$exports, "faMoon", () => $d8206b3ab2e65c05$export$c4c2f69a53bab720);
$parcel$export($d8206b3ab2e65c05$exports, "faWineGlassEmpty", () => $d8206b3ab2e65c05$export$b86d7336e68a3f57);
$parcel$export($d8206b3ab2e65c05$exports, "faWineGlassAlt", () => $d8206b3ab2e65c05$export$b8ff3fe2b78aef2f);
$parcel$export($d8206b3ab2e65c05$exports, "faCheese", () => $d8206b3ab2e65c05$export$549b99473b7201e6);
$parcel$export($d8206b3ab2e65c05$exports, "faYinYang", () => $d8206b3ab2e65c05$export$6ec1acbf3f610b8f);
$parcel$export($d8206b3ab2e65c05$exports, "faMusic", () => $d8206b3ab2e65c05$export$fcb0647a5340b5b8);
$parcel$export($d8206b3ab2e65c05$exports, "faCodeCommit", () => $d8206b3ab2e65c05$export$d5d870c10bc9f1ce);
$parcel$export($d8206b3ab2e65c05$exports, "faTemperatureLow", () => $d8206b3ab2e65c05$export$9e9af12b90a1abd2);
$parcel$export($d8206b3ab2e65c05$exports, "faPersonBiking", () => $d8206b3ab2e65c05$export$cf152282d5de300d);
$parcel$export($d8206b3ab2e65c05$exports, "faBiking", () => $d8206b3ab2e65c05$export$a5bcf835dbf9c0b);
$parcel$export($d8206b3ab2e65c05$exports, "faBroom", () => $d8206b3ab2e65c05$export$2a533051418ff4ca);
$parcel$export($d8206b3ab2e65c05$exports, "faShieldHeart", () => $d8206b3ab2e65c05$export$7b96388ca2be471b);
$parcel$export($d8206b3ab2e65c05$exports, "faGopuram", () => $d8206b3ab2e65c05$export$31f89d8ac1d14ed6);
$parcel$export($d8206b3ab2e65c05$exports, "faEarthOceania", () => $d8206b3ab2e65c05$export$bd931e906edf2f47);
$parcel$export($d8206b3ab2e65c05$exports, "faGlobeOceania", () => $d8206b3ab2e65c05$export$8ac3f5271448657d);
$parcel$export($d8206b3ab2e65c05$exports, "faSquareXmark", () => $d8206b3ab2e65c05$export$5a17e58bb7afb1d7);
$parcel$export($d8206b3ab2e65c05$exports, "faTimesSquare", () => $d8206b3ab2e65c05$export$c0248ac97142ea2a);
$parcel$export($d8206b3ab2e65c05$exports, "faXmarkSquare", () => $d8206b3ab2e65c05$export$9a364781d6b7602b);
$parcel$export($d8206b3ab2e65c05$exports, "faHashtag", () => $d8206b3ab2e65c05$export$c92c903bade56844);
$parcel$export($d8206b3ab2e65c05$exports, "faUpRightAndDownLeftFromCenter", () => $d8206b3ab2e65c05$export$95457ede07b81517);
$parcel$export($d8206b3ab2e65c05$exports, "faExpandAlt", () => $d8206b3ab2e65c05$export$bcb8d86a3a1d6eb6);
$parcel$export($d8206b3ab2e65c05$exports, "faOilCan", () => $d8206b3ab2e65c05$export$2599126c3a57f727);
$parcel$export($d8206b3ab2e65c05$exports, "faT", () => $d8206b3ab2e65c05$export$6e625d2e7790c860);
$parcel$export($d8206b3ab2e65c05$exports, "faHippo", () => $d8206b3ab2e65c05$export$d4c909619093de2d);
$parcel$export($d8206b3ab2e65c05$exports, "faChartColumn", () => $d8206b3ab2e65c05$export$d01ddcc9efe7b149);
$parcel$export($d8206b3ab2e65c05$exports, "faInfinity", () => $d8206b3ab2e65c05$export$a590003279d671b8);
$parcel$export($d8206b3ab2e65c05$exports, "faVialCircleCheck", () => $d8206b3ab2e65c05$export$2db4f9712313eafa);
$parcel$export($d8206b3ab2e65c05$exports, "faPersonArrowDownToLine", () => $d8206b3ab2e65c05$export$f9a5161975928326);
$parcel$export($d8206b3ab2e65c05$exports, "faVoicemail", () => $d8206b3ab2e65c05$export$4f1ce88b2b4cd5cd);
$parcel$export($d8206b3ab2e65c05$exports, "faFan", () => $d8206b3ab2e65c05$export$55145a3dae4f984a);
$parcel$export($d8206b3ab2e65c05$exports, "faPersonWalkingLuggage", () => $d8206b3ab2e65c05$export$1ae0a37b36ace746);
$parcel$export($d8206b3ab2e65c05$exports, "faUpDown", () => $d8206b3ab2e65c05$export$e36c32dd5cba9b90);
$parcel$export($d8206b3ab2e65c05$exports, "faArrowsAltV", () => $d8206b3ab2e65c05$export$138cb56a3f8f7040);
$parcel$export($d8206b3ab2e65c05$exports, "faCloudMoonRain", () => $d8206b3ab2e65c05$export$301c3fab0c4545bd);
$parcel$export($d8206b3ab2e65c05$exports, "faCalendar", () => $d8206b3ab2e65c05$export$34f5c36a3e80efa2);
$parcel$export($d8206b3ab2e65c05$exports, "faTrailer", () => $d8206b3ab2e65c05$export$3a48b9820e92f5ab);
$parcel$export($d8206b3ab2e65c05$exports, "faBahai", () => $d8206b3ab2e65c05$export$6d636565b3ec36b4);
$parcel$export($d8206b3ab2e65c05$exports, "faHaykal", () => $d8206b3ab2e65c05$export$5c15e34e0e43f15c);
$parcel$export($d8206b3ab2e65c05$exports, "faSdCard", () => $d8206b3ab2e65c05$export$303efb6031da122);
$parcel$export($d8206b3ab2e65c05$exports, "faDragon", () => $d8206b3ab2e65c05$export$ae1875ba975aa0e9);
$parcel$export($d8206b3ab2e65c05$exports, "faShoePrints", () => $d8206b3ab2e65c05$export$cdbdd2118099ae07);
$parcel$export($d8206b3ab2e65c05$exports, "faCirclePlus", () => $d8206b3ab2e65c05$export$eeda28b8ca4cb18e);
$parcel$export($d8206b3ab2e65c05$exports, "faPlusCircle", () => $d8206b3ab2e65c05$export$d9cc3a81499af48c);
$parcel$export($d8206b3ab2e65c05$exports, "faFaceGrinTongueWink", () => $d8206b3ab2e65c05$export$4272e56f2429da88);
$parcel$export($d8206b3ab2e65c05$exports, "faGrinTongueWink", () => $d8206b3ab2e65c05$export$58099903d50aefb3);
$parcel$export($d8206b3ab2e65c05$exports, "faHandHolding", () => $d8206b3ab2e65c05$export$e6094d25274088ab);
$parcel$export($d8206b3ab2e65c05$exports, "faPlugCircleExclamation", () => $d8206b3ab2e65c05$export$d893dd9509763a17);
$parcel$export($d8206b3ab2e65c05$exports, "faLinkSlash", () => $d8206b3ab2e65c05$export$22965c7f4d903953);
$parcel$export($d8206b3ab2e65c05$exports, "faChainBroken", () => $d8206b3ab2e65c05$export$382551e04f32620a);
$parcel$export($d8206b3ab2e65c05$exports, "faChainSlash", () => $d8206b3ab2e65c05$export$12f09d657be59586);
$parcel$export($d8206b3ab2e65c05$exports, "faUnlink", () => $d8206b3ab2e65c05$export$2f546f7d8ba01e18);
$parcel$export($d8206b3ab2e65c05$exports, "faClone", () => $d8206b3ab2e65c05$export$76c1aa4bf9a39458);
$parcel$export($d8206b3ab2e65c05$exports, "faPersonWalkingArrowLoopLeft", () => $d8206b3ab2e65c05$export$5a200e8504b7367a);
$parcel$export($d8206b3ab2e65c05$exports, "faArrowUpZA", () => $d8206b3ab2e65c05$export$a0a53d8e3c68e9f1);
$parcel$export($d8206b3ab2e65c05$exports, "faSortAlphaUpAlt", () => $d8206b3ab2e65c05$export$95ef20828693fb0f);
$parcel$export($d8206b3ab2e65c05$exports, "faFireFlameCurved", () => $d8206b3ab2e65c05$export$769724fc1434d618);
$parcel$export($d8206b3ab2e65c05$exports, "faFireAlt", () => $d8206b3ab2e65c05$export$70dc26b4926d0b1b);
$parcel$export($d8206b3ab2e65c05$exports, "faTornado", () => $d8206b3ab2e65c05$export$6d274258ba4b0089);
$parcel$export($d8206b3ab2e65c05$exports, "faFileCirclePlus", () => $d8206b3ab2e65c05$export$430d63b54b1d4009);
$parcel$export($d8206b3ab2e65c05$exports, "faBookQuran", () => $d8206b3ab2e65c05$export$ad3212bc3fa1595b);
$parcel$export($d8206b3ab2e65c05$exports, "faQuran", () => $d8206b3ab2e65c05$export$46f29ea84ed4c5f1);
$parcel$export($d8206b3ab2e65c05$exports, "faAnchor", () => $d8206b3ab2e65c05$export$12a35719f889cd1);
$parcel$export($d8206b3ab2e65c05$exports, "faBorderAll", () => $d8206b3ab2e65c05$export$93a5eb721c9c0d25);
$parcel$export($d8206b3ab2e65c05$exports, "faFaceAngry", () => $d8206b3ab2e65c05$export$67a047c738fb34da);
$parcel$export($d8206b3ab2e65c05$exports, "faAngry", () => $d8206b3ab2e65c05$export$3c96c08e234498c5);
$parcel$export($d8206b3ab2e65c05$exports, "faCookieBite", () => $d8206b3ab2e65c05$export$317dde8664f7de71);
$parcel$export($d8206b3ab2e65c05$exports, "faArrowTrendDown", () => $d8206b3ab2e65c05$export$d2caed5e37174c23);
$parcel$export($d8206b3ab2e65c05$exports, "faRss", () => $d8206b3ab2e65c05$export$7329a1ca27b90c5b);
$parcel$export($d8206b3ab2e65c05$exports, "faFeed", () => $d8206b3ab2e65c05$export$67ad3d0233cd7b33);
$parcel$export($d8206b3ab2e65c05$exports, "faDrawPolygon", () => $d8206b3ab2e65c05$export$df9bd3777d1154d2);
$parcel$export($d8206b3ab2e65c05$exports, "faScaleBalanced", () => $d8206b3ab2e65c05$export$33fb4280dc20f0dd);
$parcel$export($d8206b3ab2e65c05$exports, "faBalanceScale", () => $d8206b3ab2e65c05$export$fec323dcfd81d750);
$parcel$export($d8206b3ab2e65c05$exports, "faGaugeSimpleHigh", () => $d8206b3ab2e65c05$export$cc4351eb13da27d8);
$parcel$export($d8206b3ab2e65c05$exports, "faTachometer", () => $d8206b3ab2e65c05$export$362d0f652c3fbca2);
$parcel$export($d8206b3ab2e65c05$exports, "faTachometerFast", () => $d8206b3ab2e65c05$export$375b6a8680f980ed);
$parcel$export($d8206b3ab2e65c05$exports, "faShower", () => $d8206b3ab2e65c05$export$f7f7c15f18cc19a1);
$parcel$export($d8206b3ab2e65c05$exports, "faDesktop", () => $d8206b3ab2e65c05$export$6e6ddc253102e596);
$parcel$export($d8206b3ab2e65c05$exports, "faDesktopAlt", () => $d8206b3ab2e65c05$export$ff09a62b9e0fa899);
$parcel$export($d8206b3ab2e65c05$exports, "faM", () => $d8206b3ab2e65c05$export$bd6a7788954842b5);
$parcel$export($d8206b3ab2e65c05$exports, "faTableList", () => $d8206b3ab2e65c05$export$6e989c3c7050dbb);
$parcel$export($d8206b3ab2e65c05$exports, "faThList", () => $d8206b3ab2e65c05$export$daf2614a457122c0);
$parcel$export($d8206b3ab2e65c05$exports, "faCommentSms", () => $d8206b3ab2e65c05$export$435fe17e9d6170d6);
$parcel$export($d8206b3ab2e65c05$exports, "faSms", () => $d8206b3ab2e65c05$export$9dbcc3443daa7323);
$parcel$export($d8206b3ab2e65c05$exports, "faBook", () => $d8206b3ab2e65c05$export$c9d7ef726d1a8742);
$parcel$export($d8206b3ab2e65c05$exports, "faUserPlus", () => $d8206b3ab2e65c05$export$4c17261776a709f2);
$parcel$export($d8206b3ab2e65c05$exports, "faCheck", () => $d8206b3ab2e65c05$export$62b2c752fccc6a9c);
$parcel$export($d8206b3ab2e65c05$exports, "faBatteryThreeQuarters", () => $d8206b3ab2e65c05$export$cfb37069d38f379e);
$parcel$export($d8206b3ab2e65c05$exports, "faBattery4", () => $d8206b3ab2e65c05$export$35ffefed200d123c);
$parcel$export($d8206b3ab2e65c05$exports, "faHouseCircleCheck", () => $d8206b3ab2e65c05$export$c9382fa3394ef53a);
$parcel$export($d8206b3ab2e65c05$exports, "faAngleLeft", () => $d8206b3ab2e65c05$export$3cbcd1b7e35945d2);
$parcel$export($d8206b3ab2e65c05$exports, "faDiagramSuccessor", () => $d8206b3ab2e65c05$export$ff7f40159cadb0ac);
$parcel$export($d8206b3ab2e65c05$exports, "faTruckArrowRight", () => $d8206b3ab2e65c05$export$d69fa2b7839ce76);
$parcel$export($d8206b3ab2e65c05$exports, "faArrowsSplitUpAndLeft", () => $d8206b3ab2e65c05$export$7df274119d2469d1);
$parcel$export($d8206b3ab2e65c05$exports, "faHandFist", () => $d8206b3ab2e65c05$export$ca492f58fe30a42f);
$parcel$export($d8206b3ab2e65c05$exports, "faFistRaised", () => $d8206b3ab2e65c05$export$fa0323a4d7489a8d);
$parcel$export($d8206b3ab2e65c05$exports, "faCloudMoon", () => $d8206b3ab2e65c05$export$482eb125aaf0fbc2);
$parcel$export($d8206b3ab2e65c05$exports, "faBriefcase", () => $d8206b3ab2e65c05$export$8da450d063b0eb37);
$parcel$export($d8206b3ab2e65c05$exports, "faPersonFalling", () => $d8206b3ab2e65c05$export$e94ab3a30cf4aca5);
$parcel$export($d8206b3ab2e65c05$exports, "faImagePortrait", () => $d8206b3ab2e65c05$export$c23fd8b91a7ed48);
$parcel$export($d8206b3ab2e65c05$exports, "faPortrait", () => $d8206b3ab2e65c05$export$e3d25f819c7ee7d7);
$parcel$export($d8206b3ab2e65c05$exports, "faUserTag", () => $d8206b3ab2e65c05$export$9eec597148166b36);
$parcel$export($d8206b3ab2e65c05$exports, "faRug", () => $d8206b3ab2e65c05$export$7cee7480f25f5289);
$parcel$export($d8206b3ab2e65c05$exports, "faEarthEurope", () => $d8206b3ab2e65c05$export$7adefae4a1be1d97);
$parcel$export($d8206b3ab2e65c05$exports, "faGlobeEurope", () => $d8206b3ab2e65c05$export$5318b8ede86cc96b);
$parcel$export($d8206b3ab2e65c05$exports, "faCartFlatbedSuitcase", () => $d8206b3ab2e65c05$export$ab81ff863770d996);
$parcel$export($d8206b3ab2e65c05$exports, "faLuggageCart", () => $d8206b3ab2e65c05$export$bd1e24dd3cde8514);
$parcel$export($d8206b3ab2e65c05$exports, "faRectangleXmark", () => $d8206b3ab2e65c05$export$3896694b3e81fba7);
$parcel$export($d8206b3ab2e65c05$exports, "faRectangleTimes", () => $d8206b3ab2e65c05$export$eaaf26416a51dc1);
$parcel$export($d8206b3ab2e65c05$exports, "faTimesRectangle", () => $d8206b3ab2e65c05$export$10147c0014152a3f);
$parcel$export($d8206b3ab2e65c05$exports, "faWindowClose", () => $d8206b3ab2e65c05$export$18b7775f78a3e16);
$parcel$export($d8206b3ab2e65c05$exports, "faBahtSign", () => $d8206b3ab2e65c05$export$ffc7123046a28ee);
$parcel$export($d8206b3ab2e65c05$exports, "faBookOpen", () => $d8206b3ab2e65c05$export$8a3071811b2b7979);
$parcel$export($d8206b3ab2e65c05$exports, "faBookJournalWhills", () => $d8206b3ab2e65c05$export$d3d49030d557a09b);
$parcel$export($d8206b3ab2e65c05$exports, "faJournalWhills", () => $d8206b3ab2e65c05$export$66a0d8d45aab6631);
$parcel$export($d8206b3ab2e65c05$exports, "faHandcuffs", () => $d8206b3ab2e65c05$export$74d1f89b5feb9d42);
$parcel$export($d8206b3ab2e65c05$exports, "faTriangleExclamation", () => $d8206b3ab2e65c05$export$1cbf6e649ce86166);
$parcel$export($d8206b3ab2e65c05$exports, "faExclamationTriangle", () => $d8206b3ab2e65c05$export$3d249b63b52cce7c);
$parcel$export($d8206b3ab2e65c05$exports, "faWarning", () => $d8206b3ab2e65c05$export$2e470a35c38b096a);
$parcel$export($d8206b3ab2e65c05$exports, "faDatabase", () => $d8206b3ab2e65c05$export$24680dede86b1883);
$parcel$export($d8206b3ab2e65c05$exports, "faShare", () => $d8206b3ab2e65c05$export$c08b4b0e2b0dc027);
$parcel$export($d8206b3ab2e65c05$exports, "faMailForward", () => $d8206b3ab2e65c05$export$81df7693d3f2f8da);
$parcel$export($d8206b3ab2e65c05$exports, "faBottleDroplet", () => $d8206b3ab2e65c05$export$8f534e1e0ab75bfe);
$parcel$export($d8206b3ab2e65c05$exports, "faMaskFace", () => $d8206b3ab2e65c05$export$140d4da0adbaf435);
$parcel$export($d8206b3ab2e65c05$exports, "faHillRockslide", () => $d8206b3ab2e65c05$export$7ec15a32285f6c22);
$parcel$export($d8206b3ab2e65c05$exports, "faRightLeft", () => $d8206b3ab2e65c05$export$a082af56be9786ae);
$parcel$export($d8206b3ab2e65c05$exports, "faExchangeAlt", () => $d8206b3ab2e65c05$export$f6c6fb20d374b128);
$parcel$export($d8206b3ab2e65c05$exports, "faPaperPlane", () => $d8206b3ab2e65c05$export$b5378818301da1be);
$parcel$export($d8206b3ab2e65c05$exports, "faRoadCircleExclamation", () => $d8206b3ab2e65c05$export$79753c2153535b01);
$parcel$export($d8206b3ab2e65c05$exports, "faDungeon", () => $d8206b3ab2e65c05$export$1156dc6acb0058bd);
$parcel$export($d8206b3ab2e65c05$exports, "faAlignRight", () => $d8206b3ab2e65c05$export$7370f36a39a38737);
$parcel$export($d8206b3ab2e65c05$exports, "faMoneyBill1Wave", () => $d8206b3ab2e65c05$export$52e3e96cd1564779);
$parcel$export($d8206b3ab2e65c05$exports, "faMoneyBillWaveAlt", () => $d8206b3ab2e65c05$export$1613858e873cbb3e);
$parcel$export($d8206b3ab2e65c05$exports, "faLifeRing", () => $d8206b3ab2e65c05$export$53dd2cacf674142a);
$parcel$export($d8206b3ab2e65c05$exports, "faHands", () => $d8206b3ab2e65c05$export$f9712d0cf5150f0c);
$parcel$export($d8206b3ab2e65c05$exports, "faSignLanguage", () => $d8206b3ab2e65c05$export$20993813350f9671);
$parcel$export($d8206b3ab2e65c05$exports, "faSigning", () => $d8206b3ab2e65c05$export$5cc0e6f5191f4f02);
$parcel$export($d8206b3ab2e65c05$exports, "faCalendarDay", () => $d8206b3ab2e65c05$export$80968bcfef6481ca);
$parcel$export($d8206b3ab2e65c05$exports, "faWaterLadder", () => $d8206b3ab2e65c05$export$5930e9bdfd790d77);
$parcel$export($d8206b3ab2e65c05$exports, "faLadderWater", () => $d8206b3ab2e65c05$export$c5ea6eeef2db2b3b);
$parcel$export($d8206b3ab2e65c05$exports, "faSwimmingPool", () => $d8206b3ab2e65c05$export$4dee691631c67d5c);
$parcel$export($d8206b3ab2e65c05$exports, "faArrowsUpDown", () => $d8206b3ab2e65c05$export$64185f27d82c259f);
$parcel$export($d8206b3ab2e65c05$exports, "faArrowsV", () => $d8206b3ab2e65c05$export$cec5f1bc9e068e48);
$parcel$export($d8206b3ab2e65c05$exports, "faFaceGrimace", () => $d8206b3ab2e65c05$export$bd5bd2ef56b793b1);
$parcel$export($d8206b3ab2e65c05$exports, "faGrimace", () => $d8206b3ab2e65c05$export$3d08cd36ac1ef231);
$parcel$export($d8206b3ab2e65c05$exports, "faWheelchairMove", () => $d8206b3ab2e65c05$export$1482162f7fe04ac);
$parcel$export($d8206b3ab2e65c05$exports, "faWheelchairAlt", () => $d8206b3ab2e65c05$export$7db9460785019040);
$parcel$export($d8206b3ab2e65c05$exports, "faTurnDown", () => $d8206b3ab2e65c05$export$b5dc9dd0347bbb6);
$parcel$export($d8206b3ab2e65c05$exports, "faLevelDownAlt", () => $d8206b3ab2e65c05$export$c07eb6ff5a382cbd);
$parcel$export($d8206b3ab2e65c05$exports, "faPersonWalkingArrowRight", () => $d8206b3ab2e65c05$export$3e15790fe68c095b);
$parcel$export($d8206b3ab2e65c05$exports, "faSquareEnvelope", () => $d8206b3ab2e65c05$export$15da4ef8c0fb20d6);
$parcel$export($d8206b3ab2e65c05$exports, "faEnvelopeSquare", () => $d8206b3ab2e65c05$export$354e159473e73552);
$parcel$export($d8206b3ab2e65c05$exports, "faDice", () => $d8206b3ab2e65c05$export$4ed8206e6619cc8f);
$parcel$export($d8206b3ab2e65c05$exports, "faBowlingBall", () => $d8206b3ab2e65c05$export$5ee2640fe105312d);
$parcel$export($d8206b3ab2e65c05$exports, "faBrain", () => $d8206b3ab2e65c05$export$97fa4f4c1006ab1);
$parcel$export($d8206b3ab2e65c05$exports, "faBandage", () => $d8206b3ab2e65c05$export$658a137d3845bca7);
$parcel$export($d8206b3ab2e65c05$exports, "faBandAid", () => $d8206b3ab2e65c05$export$b14a1014df2fdf46);
$parcel$export($d8206b3ab2e65c05$exports, "faCalendarMinus", () => $d8206b3ab2e65c05$export$23e8b4955c2d951b);
$parcel$export($d8206b3ab2e65c05$exports, "faCircleXmark", () => $d8206b3ab2e65c05$export$30262489773a79a3);
$parcel$export($d8206b3ab2e65c05$exports, "faTimesCircle", () => $d8206b3ab2e65c05$export$ab0ec50720a747eb);
$parcel$export($d8206b3ab2e65c05$exports, "faXmarkCircle", () => $d8206b3ab2e65c05$export$90ac4096df8efdee);
$parcel$export($d8206b3ab2e65c05$exports, "faGifts", () => $d8206b3ab2e65c05$export$de9a67b55dbe819a);
$parcel$export($d8206b3ab2e65c05$exports, "faHotel", () => $d8206b3ab2e65c05$export$c402efcf01d5ca07);
$parcel$export($d8206b3ab2e65c05$exports, "faEarthAsia", () => $d8206b3ab2e65c05$export$807cdd395fe012cb);
$parcel$export($d8206b3ab2e65c05$exports, "faGlobeAsia", () => $d8206b3ab2e65c05$export$796fdfc909e603f4);
$parcel$export($d8206b3ab2e65c05$exports, "faIdCardClip", () => $d8206b3ab2e65c05$export$31e6961064ddac7b);
$parcel$export($d8206b3ab2e65c05$exports, "faIdCardAlt", () => $d8206b3ab2e65c05$export$dc37ebbac31f6c6c);
$parcel$export($d8206b3ab2e65c05$exports, "faMagnifyingGlassPlus", () => $d8206b3ab2e65c05$export$f48a3ba52a0a9e56);
$parcel$export($d8206b3ab2e65c05$exports, "faSearchPlus", () => $d8206b3ab2e65c05$export$378f00e6b1a8185);
$parcel$export($d8206b3ab2e65c05$exports, "faThumbsUp", () => $d8206b3ab2e65c05$export$47e4e0d519d33497);
$parcel$export($d8206b3ab2e65c05$exports, "faUserClock", () => $d8206b3ab2e65c05$export$b00596a09aa07311);
$parcel$export($d8206b3ab2e65c05$exports, "faHandDots", () => $d8206b3ab2e65c05$export$8846d49caaed1c0a);
$parcel$export($d8206b3ab2e65c05$exports, "faAllergies", () => $d8206b3ab2e65c05$export$dcae2101babbffff);
$parcel$export($d8206b3ab2e65c05$exports, "faFileInvoice", () => $d8206b3ab2e65c05$export$bef39294aed2281a);
$parcel$export($d8206b3ab2e65c05$exports, "faWindowMinimize", () => $d8206b3ab2e65c05$export$26a3f9d2784b90d8);
$parcel$export($d8206b3ab2e65c05$exports, "faMugSaucer", () => $d8206b3ab2e65c05$export$60048819854688c5);
$parcel$export($d8206b3ab2e65c05$exports, "faCoffee", () => $d8206b3ab2e65c05$export$1d24a9e457278011);
$parcel$export($d8206b3ab2e65c05$exports, "faBrush", () => $d8206b3ab2e65c05$export$5824ffe6f8983c83);
$parcel$export($d8206b3ab2e65c05$exports, "faMask", () => $d8206b3ab2e65c05$export$7b028758c03b9655);
$parcel$export($d8206b3ab2e65c05$exports, "faMagnifyingGlassMinus", () => $d8206b3ab2e65c05$export$56d810b9ab2e30bc);
$parcel$export($d8206b3ab2e65c05$exports, "faSearchMinus", () => $d8206b3ab2e65c05$export$efca97eef6a7a17d);
$parcel$export($d8206b3ab2e65c05$exports, "faRulerVertical", () => $d8206b3ab2e65c05$export$a6ad5df9d9f29553);
$parcel$export($d8206b3ab2e65c05$exports, "faUserLarge", () => $d8206b3ab2e65c05$export$50a28538498238f);
$parcel$export($d8206b3ab2e65c05$exports, "faUserAlt", () => $d8206b3ab2e65c05$export$ae9b19c2ac726cfc);
$parcel$export($d8206b3ab2e65c05$exports, "faTrainTram", () => $d8206b3ab2e65c05$export$d401d4aeba21cdf3);
$parcel$export($d8206b3ab2e65c05$exports, "faUserNurse", () => $d8206b3ab2e65c05$export$ab9af5aa013d2162);
$parcel$export($d8206b3ab2e65c05$exports, "faSyringe", () => $d8206b3ab2e65c05$export$1aa9423ec6b1d609);
$parcel$export($d8206b3ab2e65c05$exports, "faCloudSun", () => $d8206b3ab2e65c05$export$dcaadfd9c98e42a1);
$parcel$export($d8206b3ab2e65c05$exports, "faStopwatch20", () => $d8206b3ab2e65c05$export$df6244b0501f2112);
$parcel$export($d8206b3ab2e65c05$exports, "faSquareFull", () => $d8206b3ab2e65c05$export$7ec6541fee081990);
$parcel$export($d8206b3ab2e65c05$exports, "faMagnet", () => $d8206b3ab2e65c05$export$78932e9c9abea6b7);
$parcel$export($d8206b3ab2e65c05$exports, "faJar", () => $d8206b3ab2e65c05$export$53583b459a87a01);
$parcel$export($d8206b3ab2e65c05$exports, "faNoteSticky", () => $d8206b3ab2e65c05$export$4a4e034527c933f5);
$parcel$export($d8206b3ab2e65c05$exports, "faStickyNote", () => $d8206b3ab2e65c05$export$80889adc5d98bf4a);
$parcel$export($d8206b3ab2e65c05$exports, "faBugSlash", () => $d8206b3ab2e65c05$export$fc4dd5feed8df23);
$parcel$export($d8206b3ab2e65c05$exports, "faArrowUpFromWaterPump", () => $d8206b3ab2e65c05$export$1a093e7861c5e48f);
$parcel$export($d8206b3ab2e65c05$exports, "faBone", () => $d8206b3ab2e65c05$export$5902c007d5703f2d);
$parcel$export($d8206b3ab2e65c05$exports, "faUserInjured", () => $d8206b3ab2e65c05$export$c950c1ba7f227d5b);
$parcel$export($d8206b3ab2e65c05$exports, "faFaceSadTear", () => $d8206b3ab2e65c05$export$8a5a0dbb2a17e253);
$parcel$export($d8206b3ab2e65c05$exports, "faSadTear", () => $d8206b3ab2e65c05$export$4b5241926f692f91);
$parcel$export($d8206b3ab2e65c05$exports, "faPlane", () => $d8206b3ab2e65c05$export$f654c69e66b466c0);
$parcel$export($d8206b3ab2e65c05$exports, "faTentArrowsDown", () => $d8206b3ab2e65c05$export$51adfe7c9ee4f428);
$parcel$export($d8206b3ab2e65c05$exports, "faExclamation", () => $d8206b3ab2e65c05$export$de6218b649cbb6a9);
$parcel$export($d8206b3ab2e65c05$exports, "faArrowsSpin", () => $d8206b3ab2e65c05$export$7e05388be208e313);
$parcel$export($d8206b3ab2e65c05$exports, "faPrint", () => $d8206b3ab2e65c05$export$ae64371e02ee8e56);
$parcel$export($d8206b3ab2e65c05$exports, "faTurkishLiraSign", () => $d8206b3ab2e65c05$export$b458d393151b6960);
$parcel$export($d8206b3ab2e65c05$exports, "faTry", () => $d8206b3ab2e65c05$export$970dda513e46c41f);
$parcel$export($d8206b3ab2e65c05$exports, "faTurkishLira", () => $d8206b3ab2e65c05$export$40e66e5966827199);
$parcel$export($d8206b3ab2e65c05$exports, "faDollarSign", () => $d8206b3ab2e65c05$export$fb420d3e4d8c6a18);
$parcel$export($d8206b3ab2e65c05$exports, "faDollar", () => $d8206b3ab2e65c05$export$a4ffb0775547fcdf);
$parcel$export($d8206b3ab2e65c05$exports, "faUsd", () => $d8206b3ab2e65c05$export$72cca07d38a28589);
$parcel$export($d8206b3ab2e65c05$exports, "faX", () => $d8206b3ab2e65c05$export$476af662c0c32cbc);
$parcel$export($d8206b3ab2e65c05$exports, "faMagnifyingGlassDollar", () => $d8206b3ab2e65c05$export$fa4f1ead37dc1dce);
$parcel$export($d8206b3ab2e65c05$exports, "faSearchDollar", () => $d8206b3ab2e65c05$export$65b49a6767630708);
$parcel$export($d8206b3ab2e65c05$exports, "faUsersGear", () => $d8206b3ab2e65c05$export$3a18218720110fc0);
$parcel$export($d8206b3ab2e65c05$exports, "faUsersCog", () => $d8206b3ab2e65c05$export$5e0b06753fc69b81);
$parcel$export($d8206b3ab2e65c05$exports, "faPersonMilitaryPointing", () => $d8206b3ab2e65c05$export$50b6dcaa9ec03439);
$parcel$export($d8206b3ab2e65c05$exports, "faBuildingColumns", () => $d8206b3ab2e65c05$export$a411e7e26cb63d5e);
$parcel$export($d8206b3ab2e65c05$exports, "faBank", () => $d8206b3ab2e65c05$export$6e379b829ea8b99);
$parcel$export($d8206b3ab2e65c05$exports, "faInstitution", () => $d8206b3ab2e65c05$export$1dba320226a34c1f);
$parcel$export($d8206b3ab2e65c05$exports, "faMuseum", () => $d8206b3ab2e65c05$export$9b3953adff472ad2);
$parcel$export($d8206b3ab2e65c05$exports, "faUniversity", () => $d8206b3ab2e65c05$export$f2e1460ebe1a8cb0);
$parcel$export($d8206b3ab2e65c05$exports, "faUmbrella", () => $d8206b3ab2e65c05$export$9ff64ffae70e08c0);
$parcel$export($d8206b3ab2e65c05$exports, "faTrowel", () => $d8206b3ab2e65c05$export$12ca996a6f686fe1);
$parcel$export($d8206b3ab2e65c05$exports, "faD", () => $d8206b3ab2e65c05$export$56c73b799aac2555);
$parcel$export($d8206b3ab2e65c05$exports, "faStapler", () => $d8206b3ab2e65c05$export$c7e014b7e3ac3d83);
$parcel$export($d8206b3ab2e65c05$exports, "faMasksTheater", () => $d8206b3ab2e65c05$export$bf5896cc1ce4d55);
$parcel$export($d8206b3ab2e65c05$exports, "faTheaterMasks", () => $d8206b3ab2e65c05$export$3dbedc487b0159ac);
$parcel$export($d8206b3ab2e65c05$exports, "faKipSign", () => $d8206b3ab2e65c05$export$a6df39524c41472c);
$parcel$export($d8206b3ab2e65c05$exports, "faHandPointLeft", () => $d8206b3ab2e65c05$export$b276ec3dc9760d39);
$parcel$export($d8206b3ab2e65c05$exports, "faHandshakeSimple", () => $d8206b3ab2e65c05$export$e8485db4dab0ab30);
$parcel$export($d8206b3ab2e65c05$exports, "faHandshakeAlt", () => $d8206b3ab2e65c05$export$e9aa3c6f9f47aa1a);
$parcel$export($d8206b3ab2e65c05$exports, "faJetFighter", () => $d8206b3ab2e65c05$export$2130e629ab767ab3);
$parcel$export($d8206b3ab2e65c05$exports, "faFighterJet", () => $d8206b3ab2e65c05$export$102b809faf56e033);
$parcel$export($d8206b3ab2e65c05$exports, "faSquareShareNodes", () => $d8206b3ab2e65c05$export$1bdb0ec5af3fea99);
$parcel$export($d8206b3ab2e65c05$exports, "faShareAltSquare", () => $d8206b3ab2e65c05$export$3799c2d8fd7e493b);
$parcel$export($d8206b3ab2e65c05$exports, "faBarcode", () => $d8206b3ab2e65c05$export$3825a842b5afc5aa);
$parcel$export($d8206b3ab2e65c05$exports, "faPlusMinus", () => $d8206b3ab2e65c05$export$37bd38cf96417095);
$parcel$export($d8206b3ab2e65c05$exports, "faVideo", () => $d8206b3ab2e65c05$export$5c6bd8729527871b);
$parcel$export($d8206b3ab2e65c05$exports, "faVideoCamera", () => $d8206b3ab2e65c05$export$3a530df752193ccf);
$parcel$export($d8206b3ab2e65c05$exports, "faGraduationCap", () => $d8206b3ab2e65c05$export$874e305fd7920cce);
$parcel$export($d8206b3ab2e65c05$exports, "faMortarBoard", () => $d8206b3ab2e65c05$export$dd0a013bf23a9d86);
$parcel$export($d8206b3ab2e65c05$exports, "faHandHoldingMedical", () => $d8206b3ab2e65c05$export$bb2a6b1b5e852300);
$parcel$export($d8206b3ab2e65c05$exports, "faPersonCircleCheck", () => $d8206b3ab2e65c05$export$30294c81ac4031ca);
$parcel$export($d8206b3ab2e65c05$exports, "faTurnUp", () => $d8206b3ab2e65c05$export$314f5cab62fc6968);
$parcel$export($d8206b3ab2e65c05$exports, "faLevelUpAlt", () => $d8206b3ab2e65c05$export$d6f21a309b179c3d);
$parcel$export($d8206b3ab2e65c05$exports, "fas", () => $d8206b3ab2e65c05$export$da048c47c8dcd50a);
var $d8206b3ab2e65c05$export$82e9f45cca5ba907 = "fas";
var $d8206b3ab2e65c05$export$f22454595d96c106 = {
    prefix: "fas",
    iconName: "0",
    icon: [
        320,
        512,
        [],
        "30",
        "M0 192C0 103.6 71.6 32 160 32s160 71.6 160 160V320c0 88.4-71.6 160-160 160S0 408.4 0 320V192zM160 96c-53 0-96 43-96 96V320c0 53 43 96 96 96s96-43 96-96V192c0-53-43-96-96-96z"
    ]
};
var $d8206b3ab2e65c05$export$8398cb2addc9e182 = {
    prefix: "fas",
    iconName: "1",
    icon: [
        256,
        512,
        [],
        "31",
        "M160 64c0-11.8-6.5-22.6-16.9-28.2s-23-5-32.8 1.6l-96 64C-.5 111.2-4.4 131 5.4 145.8s29.7 18.7 44.4 8.9L96 123.8V416H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h96 96c17.7 0 32-14.3 32-32s-14.3-32-32-32H160V64z"
    ]
};
var $d8206b3ab2e65c05$export$ed1a0ff7bd680a1d = {
    prefix: "fas",
    iconName: "2",
    icon: [
        320,
        512,
        [],
        "32",
        "M142.9 96c-21.5 0-42.2 8.5-57.4 23.8L54.6 150.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L40.2 74.5C67.5 47.3 104.4 32 142.9 32C223 32 288 97 288 177.1c0 38.5-15.3 75.4-42.5 102.6L109.3 416H288c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9L200.2 234.5c15.2-15.2 23.8-35.9 23.8-57.4c0-44.8-36.3-81.1-81.1-81.1z"
    ]
};
var $d8206b3ab2e65c05$export$74b7ff79ce1818d6 = {
    prefix: "fas",
    iconName: "3",
    icon: [
        320,
        512,
        [],
        "33",
        "M0 64C0 46.3 14.3 32 32 32H272c13.2 0 25 8.1 29.8 20.4s1.5 26.3-8.2 35.2L162.3 208H184c75.1 0 136 60.9 136 136s-60.9 136-136 136H105.4C63 480 24.2 456 5.3 418.1l-1.9-3.8c-7.9-15.8-1.5-35 14.3-42.9s35-1.5 42.9 14.3l1.9 3.8c8.1 16.3 24.8 26.5 42.9 26.5H184c39.8 0 72-32.2 72-72s-32.2-72-72-72H80c-13.2 0-25-8.1-29.8-20.4s-1.5-26.3 8.2-35.2L189.7 96H32C14.3 96 0 81.7 0 64z"
    ]
};
var $d8206b3ab2e65c05$export$969b2215780d58fd = {
    prefix: "fas",
    iconName: "4",
    icon: [
        384,
        512,
        [],
        "34",
        "M189 77.6c7.5-16 .7-35.1-15.3-42.6s-35.1-.7-42.6 15.3L3 322.4c-4.7 9.9-3.9 21.5 1.9 30.8S21 368 32 368H256v80c0 17.7 14.3 32 32 32s32-14.3 32-32V368h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H320V160c0-17.7-14.3-32-32-32s-32 14.3-32 32V304H82.4L189 77.6z"
    ]
};
var $d8206b3ab2e65c05$export$3919f68a5b3825a9 = {
    prefix: "fas",
    iconName: "5",
    icon: [
        320,
        512,
        [],
        "35",
        "M32.5 58.3C35.3 43.1 48.5 32 64 32H256c17.7 0 32 14.3 32 32s-14.3 32-32 32H90.7L70.3 208H184c75.1 0 136 60.9 136 136s-60.9 136-136 136H100.5c-39.4 0-75.4-22.3-93-57.5l-4.1-8.2c-7.9-15.8-1.5-35 14.3-42.9s35-1.5 42.9 14.3l4.1 8.2c6.8 13.6 20.6 22.1 35.8 22.1H184c39.8 0 72-32.2 72-72s-32.2-72-72-72H32c-9.5 0-18.5-4.2-24.6-11.5s-8.6-16.9-6.9-26.2l32-176z"
    ]
};
var $d8206b3ab2e65c05$export$580ac17b31ffb5c3 = {
    prefix: "fas",
    iconName: "6",
    icon: [
        320,
        512,
        [],
        "36",
        "M232.4 84.7c11.4-13.5 9.7-33.7-3.8-45.1s-33.7-9.7-45.1 3.8L38.6 214.7C14.7 242.9 1.1 278.4 .1 315.2c0 1.4-.1 2.9-.1 4.3c0 .2 0 .3 0 .5c0 88.4 71.6 160 160 160s160-71.6 160-160c0-85.5-67.1-155.4-151.5-159.8l63.9-75.6zM256 320A96 96 0 1 1 64 320a96 96 0 1 1 192 0z"
    ]
};
var $d8206b3ab2e65c05$export$ee79cab31be16d23 = {
    prefix: "fas",
    iconName: "7",
    icon: [
        320,
        512,
        [],
        "37",
        "M0 64C0 46.3 14.3 32 32 32H288c11.5 0 22 6.1 27.7 16.1s5.7 22.2-.1 32.1l-224 384c-8.9 15.3-28.5 20.4-43.8 11.5s-20.4-28.5-11.5-43.8L232.3 96H32C14.3 96 0 81.7 0 64z"
    ]
};
var $d8206b3ab2e65c05$export$45d84c4b2c560d2f = {
    prefix: "fas",
    iconName: "8",
    icon: [
        320,
        512,
        [],
        "38",
        "M304 160c0-70.7-57.3-128-128-128H144C73.3 32 16 89.3 16 160c0 34.6 13.7 66 36 89C20.5 272.3 0 309.8 0 352c0 70.7 57.3 128 128 128h64c70.7 0 128-57.3 128-128c0-42.2-20.5-79.7-52-103c22.3-23 36-54.4 36-89zM176.1 288H192c35.3 0 64 28.7 64 64s-28.7 64-64 64H128c-35.3 0-64-28.7-64-64s28.7-64 64-64h15.9c0 0 .1 0 .1 0h32c0 0 .1 0 .1 0zm0-64c0 0 0 0 0 0H144c0 0 0 0 0 0c-35.3 0-64-28.7-64-64c0-35.3 28.7-64 64-64h32c35.3 0 64 28.7 64 64c0 35.3-28.6 64-64 64z"
    ]
};
var $d8206b3ab2e65c05$export$a120f1e4223629f2 = {
    prefix: "fas",
    iconName: "9",
    icon: [
        320,
        512,
        [],
        "39",
        "M64 192a96 96 0 1 0 192 0A96 96 0 1 0 64 192zm87.5 159.8C67.1 347.4 0 277.5 0 192C0 103.6 71.6 32 160 32s160 71.6 160 160c0 2.6-.1 5.3-.2 7.9c-1.7 35.7-15.2 70-38.4 97.4l-145 171.4c-11.4 13.5-31.6 15.2-45.1 3.8s-15.2-31.6-3.8-45.1l63.9-75.6z"
    ]
};
var $d8206b3ab2e65c05$export$38320138fc0262d0 = {
    prefix: "fas",
    iconName: "fill-drip",
    icon: [
        576,
        512,
        [],
        "f576",
        "M41.4 9.4C53.9-3.1 74.1-3.1 86.6 9.4L168 90.7l53.1-53.1c28.1-28.1 73.7-28.1 101.8 0L474.3 189.1c28.1 28.1 28.1 73.7 0 101.8L283.9 481.4c-37.5 37.5-98.3 37.5-135.8 0L30.6 363.9c-37.5-37.5-37.5-98.3 0-135.8L122.7 136 41.4 54.6c-12.5-12.5-12.5-32.8 0-45.3zm176 221.3L168 181.3 75.9 273.4c-4.2 4.2-7 9.3-8.4 14.6H386.7l42.3-42.3c3.1-3.1 3.1-8.2 0-11.3L277.7 82.9c-3.1-3.1-8.2-3.1-11.3 0L213.3 136l49.4 49.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0zM512 512c-35.3 0-64-28.7-64-64c0-25.2 32.6-79.6 51.2-108.7c6-9.4 19.5-9.4 25.5 0C543.4 368.4 576 422.8 576 448c0 35.3-28.7 64-64 64z"
    ]
};
var $d8206b3ab2e65c05$export$917a3d30f6cd766 = {
    prefix: "fas",
    iconName: "arrows-to-circle",
    icon: [
        640,
        512,
        [],
        "e4bd",
        "M9.4 9.4C21.9-3.1 42.1-3.1 54.6 9.4L160 114.7V96c0-17.7 14.3-32 32-32s32 14.3 32 32v96c0 4.3-.9 8.5-2.4 12.2c-1.6 3.7-3.8 7.3-6.9 10.3l-.1 .1c-3.1 3-6.6 5.3-10.3 6.9c-3.8 1.6-7.9 2.4-12.2 2.4H96c-17.7 0-32-14.3-32-32s14.3-32 32-32h18.7L9.4 54.6C-3.1 42.1-3.1 21.9 9.4 9.4zM256 256a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM114.7 352H96c-17.7 0-32-14.3-32-32s14.3-32 32-32h96 0l.1 0c8.8 0 16.7 3.6 22.5 9.3l.1 .1c3 3.1 5.3 6.6 6.9 10.3c1.6 3.8 2.4 7.9 2.4 12.2v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V397.3L54.6 502.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L114.7 352zM416 96c0-17.7 14.3-32 32-32s32 14.3 32 32v18.7L585.4 9.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L525.3 160H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H448c-8.8 0-16.8-3.6-22.6-9.3l-.1-.1c-3-3.1-5.3-6.6-6.9-10.3s-2.4-7.8-2.4-12.2l0-.1v0V96zM525.3 352L630.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L480 397.3V416c0 17.7-14.3 32-32 32s-32-14.3-32-32V320v0c0 0 0-.1 0-.1c0-4.3 .9-8.4 2.4-12.2c1.6-3.8 3.9-7.3 6.9-10.4c5.8-5.8 13.7-9.3 22.5-9.4c0 0 .1 0 .1 0h0 96c17.7 0 32 14.3 32 32s-14.3 32-32 32H525.3z"
    ]
};
var $d8206b3ab2e65c05$export$a39bab13d51abfd0 = {
    prefix: "fas",
    iconName: "circle-chevron-right",
    icon: [
        512,
        512,
        [
            "chevron-circle-right"
        ],
        "f138",
        "M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM241 377c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l87-87-87-87c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L345 239c9.4 9.4 9.4 24.6 0 33.9L241 377z"
    ]
};
var $d8206b3ab2e65c05$export$2a5db4f6eba6f2b = $d8206b3ab2e65c05$export$a39bab13d51abfd0;
var $d8206b3ab2e65c05$export$c115e8063ee02632 = {
    prefix: "fas",
    iconName: "at",
    icon: [
        512,
        512,
        [
            61946
        ],
        "40",
        "M256 64C150 64 64 150 64 256s86 192 192 192c17.7 0 32 14.3 32 32s-14.3 32-32 32C114.6 512 0 397.4 0 256S114.6 0 256 0S512 114.6 512 256v32c0 53-43 96-96 96c-29.3 0-55.6-13.2-73.2-33.9C320 371.1 289.5 384 256 384c-70.7 0-128-57.3-128-128s57.3-128 128-128c27.9 0 53.7 8.9 74.7 24.1c5.7-5 13.1-8.1 21.3-8.1c17.7 0 32 14.3 32 32v80 32c0 17.7 14.3 32 32 32s32-14.3 32-32V256c0-106-86-192-192-192zm64 192a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z"
    ]
};
var $d8206b3ab2e65c05$export$864bb8d6c21fb792 = {
    prefix: "fas",
    iconName: "trash-can",
    icon: [
        448,
        512,
        [
            61460,
            "trash-alt"
        ],
        "f2ed",
        "M135.2 17.7C140.6 6.8 151.7 0 163.8 0H284.2c12.1 0 23.2 6.8 28.6 17.7L320 32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64S14.3 32 32 32h96l7.2-14.3zM32 128H416V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V128zm96 64c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16z"
    ]
};
var $d8206b3ab2e65c05$export$88df7ff7eb32f9dc = $d8206b3ab2e65c05$export$864bb8d6c21fb792;
var $d8206b3ab2e65c05$export$3313bce3924ea7da = {
    prefix: "fas",
    iconName: "text-height",
    icon: [
        576,
        512,
        [],
        "f034",
        "M64 128V96h64l0 320H96c-17.7 0-32 14.3-32 32s14.3 32 32 32H224c17.7 0 32-14.3 32-32s-14.3-32-32-32H192l0-320h64v32c0 17.7 14.3 32 32 32s32-14.3 32-32V80c0-26.5-21.5-48-48-48H160 48C21.5 32 0 53.5 0 80v48c0 17.7 14.3 32 32 32s32-14.3 32-32zM502.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-64 64c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8h32V352H416c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l64 64c12.5 12.5 32.8 12.5 45.3 0l64-64c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8H512V160h32c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-64-64z"
    ]
};
var $d8206b3ab2e65c05$export$e585697127cda27 = {
    prefix: "fas",
    iconName: "user-xmark",
    icon: [
        640,
        512,
        [
            "user-times"
        ],
        "f235",
        "M96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM0 482.3C0 383.8 79.8 304 178.3 304h91.4C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3zM471 143c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"
    ]
};
var $d8206b3ab2e65c05$export$45b996d071667753 = $d8206b3ab2e65c05$export$e585697127cda27;
var $d8206b3ab2e65c05$export$acb2d72d28cd92d9 = {
    prefix: "fas",
    iconName: "stethoscope",
    icon: [
        576,
        512,
        [
            129658
        ],
        "f0f1",
        "M142.4 21.9c5.6 16.8-3.5 34.9-20.2 40.5L96 71.1V192c0 53 43 96 96 96s96-43 96-96V71.1l-26.1-8.7c-16.8-5.6-25.8-23.7-20.2-40.5s23.7-25.8 40.5-20.2l26.1 8.7C334.4 19.1 352 43.5 352 71.1V192c0 77.2-54.6 141.6-127.3 156.7C231 404.6 278.4 448 336 448c61.9 0 112-50.1 112-112V265.3c-28.3-12.3-48-40.5-48-73.3c0-44.2 35.8-80 80-80s80 35.8 80 80c0 32.8-19.7 61-48 73.3V336c0 97.2-78.8 176-176 176c-92.9 0-168.9-71.9-175.5-163.1C87.2 334.2 32 269.6 32 192V71.1c0-27.5 17.6-52 43.8-60.7l26.1-8.7c16.8-5.6 34.9 3.5 40.5 20.2zM480 224a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
var $d8206b3ab2e65c05$export$6563a67224e7f879 = {
    prefix: "fas",
    iconName: "message",
    icon: [
        512,
        512,
        [
            "comment-alt"
        ],
        "f27a",
        "M64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h96v80c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64z"
    ]
};
var $d8206b3ab2e65c05$export$6e96904d9af0ec4a = $d8206b3ab2e65c05$export$6563a67224e7f879;
var $d8206b3ab2e65c05$export$d469b770895f47ac = {
    prefix: "fas",
    iconName: "info",
    icon: [
        192,
        512,
        [],
        "f129",
        "M48 80a48 48 0 1 1 96 0A48 48 0 1 1 48 80zM0 224c0-17.7 14.3-32 32-32H96c17.7 0 32 14.3 32 32V448h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H64V256H32c-17.7 0-32-14.3-32-32z"
    ]
};
var $d8206b3ab2e65c05$export$d56736f5800b3f0d = {
    prefix: "fas",
    iconName: "down-left-and-up-right-to-center",
    icon: [
        512,
        512,
        [
            "compress-alt"
        ],
        "f422",
        "M439 7c9.4-9.4 24.6-9.4 33.9 0l32 32c9.4 9.4 9.4 24.6 0 33.9l-87 87 39 39c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8H296c-13.3 0-24-10.7-24-24V72c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2l39 39L439 7zM72 272H216c13.3 0 24 10.7 24 24V440c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-39-39L73 505c-9.4 9.4-24.6 9.4-33.9 0L7 473c-9.4-9.4-9.4-24.6 0-33.9l87-87L55 313c-6.9-6.9-8.9-17.2-5.2-26.2s12.5-14.8 22.2-14.8z"
    ]
};
var $d8206b3ab2e65c05$export$a05650ebe54bede = $d8206b3ab2e65c05$export$d56736f5800b3f0d;
var $d8206b3ab2e65c05$export$36b5fbeae4855055 = {
    prefix: "fas",
    iconName: "explosion",
    icon: [
        576,
        512,
        [],
        "e4e9",
        "M499.6 11.3c6.7-10.7 20.5-14.5 31.7-8.5s15.8 19.5 10.6 31L404.8 338.6c2.2 2.3 4.3 4.7 6.3 7.1l97.2-54.7c10.5-5.9 23.6-3.1 30.9 6.4s6.3 23-2.2 31.5l-87 87H378.5c-13.2-37.3-48.7-64-90.5-64s-77.4 26.7-90.5 64H117.8L42.3 363.7c-9.7-6.7-13.1-19.6-7.9-30.3s17.4-15.9 28.7-12.4l97.2 30.4c3-3.9 6.1-7.7 9.4-11.3L107.4 236.3c-6.1-10.1-3.9-23.1 5.1-30.7s22.2-7.5 31.1 .1L246 293.6c1.5-.4 3-.8 4.5-1.1l13.6-142.7c1.2-12.3 11.5-21.7 23.9-21.7s22.7 9.4 23.9 21.7l13.5 141.9L499.6 11.3zM64 448v0H512v0h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H64zM288 0c13.3 0 24 10.7 24 24V72c0 13.3-10.7 24-24 24s-24-10.7-24-24V24c0-13.3 10.7-24 24-24z"
    ]
};
var $d8206b3ab2e65c05$export$ef565d07efe2b5e9 = {
    prefix: "fas",
    iconName: "file-lines",
    icon: [
        384,
        512,
        [
            128441,
            128462,
            61686,
            "file-alt",
            "file-text"
        ],
        "f15c",
        "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM112 256H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
    ]
};
var $d8206b3ab2e65c05$export$243b47dca32bf0b8 = $d8206b3ab2e65c05$export$ef565d07efe2b5e9;
var $d8206b3ab2e65c05$export$f466100bf9bf37a5 = $d8206b3ab2e65c05$export$ef565d07efe2b5e9;
var $d8206b3ab2e65c05$export$c38cf504b3bc58a2 = {
    prefix: "fas",
    iconName: "wave-square",
    icon: [
        640,
        512,
        [],
        "f83e",
        "M128 64c0-17.7 14.3-32 32-32H320c17.7 0 32 14.3 32 32V416h96V256c0-17.7 14.3-32 32-32H608c17.7 0 32 14.3 32 32s-14.3 32-32 32H512V448c0 17.7-14.3 32-32 32H320c-17.7 0-32-14.3-32-32V96H192V256c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h96V64z"
    ]
};
var $d8206b3ab2e65c05$export$a95486586631edc7 = {
    prefix: "fas",
    iconName: "ring",
    icon: [
        512,
        512,
        [],
        "f70b",
        "M64 208c0 7.8 4.4 18.7 17.1 30.3C126.5 214.1 188.9 200 256 200s129.5 14.1 174.9 38.3C443.6 226.7 448 215.8 448 208c0-12.3-10.8-32-47.9-50.6C364.9 139.8 314 128 256 128s-108.9 11.8-144.1 29.4C74.8 176 64 195.7 64 208zm192 40c-47 0-89.3 7.6-122.9 19.7C166.3 280.2 208.8 288 256 288s89.7-7.8 122.9-20.3C345.3 255.6 303 248 256 248zM0 208c0-49.6 39.4-85.8 83.3-107.8C129.1 77.3 190.3 64 256 64s126.9 13.3 172.7 36.2c43.9 22 83.3 58.2 83.3 107.8v96c0 49.6-39.4 85.8-83.3 107.8C382.9 434.7 321.7 448 256 448s-126.9-13.3-172.7-36.2C39.4 389.8 0 353.6 0 304V208z"
    ]
};
var $d8206b3ab2e65c05$export$fbbc7601eb465ac7 = {
    prefix: "fas",
    iconName: "building-un",
    icon: [
        384,
        512,
        [],
        "e4d9",
        "M48 0C21.5 0 0 21.5 0 48V464c0 26.5 21.5 48 48 48h96V432c0-26.5 21.5-48 48-48s48 21.5 48 48v80h96c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H48zM64 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V240zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V240zM237.3 71.1l34.7 52V80c0-8.8 7.2-16 16-16s16 7.2 16 16v96c0 7.1-4.6 13.3-11.4 15.3s-14-.6-17.9-6.4l-34.7-52V176c0 8.8-7.2 16-16 16s-16-7.2-16-16V80c0-7.1 4.6-13.3 11.4-15.3s14 .6 17.9 6.4zM112 80v64c0 8.8 7.2 16 16 16s16-7.2 16-16V80c0-8.8 7.2-16 16-16s16 7.2 16 16v64c0 26.5-21.5 48-48 48s-48-21.5-48-48V80c0-8.8 7.2-16 16-16s16 7.2 16 16z"
    ]
};
var $d8206b3ab2e65c05$export$221059e0d5fd8958 = {
    prefix: "fas",
    iconName: "dice-three",
    icon: [
        448,
        512,
        [
            9858
        ],
        "f527",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm64 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm64 128a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm128 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $d8206b3ab2e65c05$export$31c6cf6f5d38dc0 = {
    prefix: "fas",
    iconName: "calendar-days",
    icon: [
        448,
        512,
        [
            "calendar-alt"
        ],
        "f073",
        "M128 0c17.7 0 32 14.3 32 32V64H288V32c0-17.7 14.3-32 32-32s32 14.3 32 32V64h48c26.5 0 48 21.5 48 48v48H0V112C0 85.5 21.5 64 48 64H96V32c0-17.7 14.3-32 32-32zM0 192H448V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V192zm64 80v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zm128 0v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H208c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H336zM64 400v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H208zm112 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H336c-8.8 0-16 7.2-16 16z"
    ]
};
var $d8206b3ab2e65c05$export$cbc139f33cff356 = $d8206b3ab2e65c05$export$31c6cf6f5d38dc0;
var $d8206b3ab2e65c05$export$8bce49e6ae597af8 = {
    prefix: "fas",
    iconName: "anchor-circle-check",
    icon: [
        640,
        512,
        [],
        "e4aa",
        "M320 96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm21.1 80C367 158.8 384 129.4 384 96c0-53-43-96-96-96s-96 43-96 96c0 33.4 17 62.8 42.9 80H224c-17.7 0-32 14.3-32 32s14.3 32 32 32h32V448H208c-53 0-96-43-96-96v-6.1l7 7c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L97 263c-9.4-9.4-24.6-9.4-33.9 0L7 319c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l7-7V352c0 88.4 71.6 160 160 160h80 80c8.2 0 16.3-.6 24.2-1.8c-22.2-16.2-40.4-37.5-53-62.2H320V368 240h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H341.1zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"
    ]
};
var $d8206b3ab2e65c05$export$37584b1a5e175b47 = {
    prefix: "fas",
    iconName: "building-circle-arrow-right",
    icon: [
        640,
        512,
        [],
        "e4d1",
        "M0 48C0 21.5 21.5 0 48 0H336c26.5 0 48 21.5 48 48V232.2c-39.1 32.3-64 81.1-64 135.8c0 49.5 20.4 94.2 53.3 126.2C364.5 505.1 351.1 512 336 512H240V432c0-26.5-21.5-48-48-48s-48 21.5-48 48v80H48c-26.5 0-48-21.5-48-48V48zM80 224c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H80zm80 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zm112-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H272zM64 112v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zM176 96c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H176zm80 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H272c-8.8 0-16 7.2-16 16zm96 256a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm140.7-67.3c-6.2 6.2-6.2 16.4 0 22.6L521.4 352H432c-8.8 0-16 7.2-16 16s7.2 16 16 16h89.4l-28.7 28.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l56-56c6.2-6.2 6.2-16.4 0-22.6l-56-56c-6.2-6.2-16.4-6.2-22.6 0z"
    ]
};
var $d8206b3ab2e65c05$export$cc519c9529a46c5c = {
    prefix: "fas",
    iconName: "volleyball",
    icon: [
        512,
        512,
        [
            127952,
            "volleyball-ball"
        ],
        "f45f",
        "M511.8 267.4c-26.1 8.7-53.4 13.8-81 15.1c9.2-105.3-31.5-204.2-103.2-272.4C434.1 41.1 512 139.5 512 256c0 3.8-.1 7.6-.2 11.4zm-3.9 34.7c-5.8 32-17.6 62-34.2 88.7c-97.5 48.5-217.7 42.6-311.9-24.5c23.7-36.2 55.4-67.7 94.5-91.8c79.9 43.2 170.1 50.8 251.6 27.6zm-236-55.5c-2.5-90.9-41.1-172.7-101.9-231.7C196.8 5.2 225.8 0 256 0c2.7 0 5.3 0 7.9 .1c90.8 60.2 145.7 167.2 134.7 282.3c-43.1-2.4-86.4-14.1-126.8-35.9zM138 28.8c20.6 18.3 38.7 39.4 53.7 62.6C95.9 136.1 30.6 220.8 7.3 316.9C2.5 297.4 0 277 0 256C0 157.2 56 71.5 138 28.8zm69.6 90.5c19.5 38.6 31 81.9 32.3 127.7C162.5 294.6 110.9 368.9 90.2 451C66 430.4 45.6 405.4 30.4 377.2c6.7-108.7 71.9-209.9 177.1-257.9zM256 512c-50.7 0-98-14.7-137.8-40.2c5.6-27 14.8-53.1 27.4-77.7C232.2 454.6 338.1 468.8 433 441c-46 44-108.3 71-177 71z"
    ]
};
var $d8206b3ab2e65c05$export$a15e6fc8e68a76b0 = $d8206b3ab2e65c05$export$cc519c9529a46c5c;
var $d8206b3ab2e65c05$export$159982ce2622211e = {
    prefix: "fas",
    iconName: "arrows-up-to-line",
    icon: [
        576,
        512,
        [],
        "e4c2",
        "M32 96l512 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 32C14.3 32 0 46.3 0 64S14.3 96 32 96zM9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L96 237.3 96 448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-210.7 41.4 41.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-96-96c-12.5-12.5-32.8-12.5-45.3 0l-96 96zm320 45.3c12.5 12.5 32.8 12.5 45.3 0L416 237.3 416 448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-210.7 41.4 41.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-96-96c-12.5-12.5-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3z"
    ]
};
var $d8206b3ab2e65c05$export$58e2577a373e7d4 = {
    prefix: "fas",
    iconName: "sort-down",
    icon: [
        320,
        512,
        [
            "sort-desc"
        ],
        "f0dd",
        "M182.6 470.6c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-9.2-9.2-11.9-22.9-6.9-34.9s16.6-19.8 29.6-19.8H288c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-128 128z"
    ]
};
var $d8206b3ab2e65c05$export$e24f016f5f78af6a = $d8206b3ab2e65c05$export$58e2577a373e7d4;
var $d8206b3ab2e65c05$export$d0163707993a8110 = {
    prefix: "fas",
    iconName: "circle-minus",
    icon: [
        512,
        512,
        [
            "minus-circle"
        ],
        "f056",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 232H328c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
    ]
};
var $d8206b3ab2e65c05$export$f3979b49bf57313c = $d8206b3ab2e65c05$export$d0163707993a8110;
var $d8206b3ab2e65c05$export$41821b9a6fd703de = {
    prefix: "fas",
    iconName: "door-open",
    icon: [
        576,
        512,
        [],
        "f52b",
        "M320 32c0-9.9-4.5-19.2-12.3-25.2S289.8-1.4 280.2 1l-179.9 45C79 51.3 64 70.5 64 92.5V448H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H96 288h32V480 32zM256 256c0 17.7-10.7 32-24 32s-24-14.3-24-32s10.7-32 24-32s24 14.3 24 32zm96-128h96V480c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H512V128c0-35.3-28.7-64-64-64H352v64z"
    ]
};
var $d8206b3ab2e65c05$export$122a80ae0f87f726 = {
    prefix: "fas",
    iconName: "right-from-bracket",
    icon: [
        512,
        512,
        [
            "sign-out-alt"
        ],
        "f2f5",
        "M377.9 105.9L500.7 228.7c7.2 7.2 11.3 17.1 11.3 27.3s-4.1 20.1-11.3 27.3L377.9 406.1c-6.4 6.4-15 9.9-24 9.9c-18.7 0-33.9-15.2-33.9-33.9l0-62.1-128 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l128 0 0-62.1c0-18.7 15.2-33.9 33.9-33.9c9 0 17.6 3.6 24 9.9zM160 96L96 96c-17.7 0-32 14.3-32 32l0 256c0 17.7 14.3 32 32 32l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0c-53 0-96-43-96-96L0 128C0 75 43 32 96 32l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32z"
    ]
};
var $d8206b3ab2e65c05$export$c844d6923b7096c2 = $d8206b3ab2e65c05$export$122a80ae0f87f726;
var $d8206b3ab2e65c05$export$b5bb295e8ad4ab31 = {
    prefix: "fas",
    iconName: "atom",
    icon: [
        512,
        512,
        [
            9883
        ],
        "f5d2",
        "M256 398.8c-11.8 5.1-23.4 9.7-34.9 13.5c16.7 33.8 31 35.7 34.9 35.7s18.1-1.9 34.9-35.7c-11.4-3.9-23.1-8.4-34.9-13.5zM446 256c33 45.2 44.3 90.9 23.6 128c-20.2 36.3-62.5 49.3-115.2 43.2c-22 52.1-55.6 84.8-98.4 84.8s-76.4-32.7-98.4-84.8c-52.7 6.1-95-6.8-115.2-43.2C21.7 346.9 33 301.2 66 256c-33-45.2-44.3-90.9-23.6-128c20.2-36.3 62.5-49.3 115.2-43.2C179.6 32.7 213.2 0 256 0s76.4 32.7 98.4 84.8c52.7-6.1 95 6.8 115.2 43.2c20.7 37.1 9.4 82.8-23.6 128zm-65.8 67.4c-1.7 14.2-3.9 28-6.7 41.2c31.8 1.4 38.6-8.7 40.2-11.7c2.3-4.2 7-17.9-11.9-48.1c-6.8 6.3-14 12.5-21.6 18.6zm-6.7-175.9c2.8 13.1 5 26.9 6.7 41.2c7.6 6.1 14.8 12.3 21.6 18.6c18.9-30.2 14.2-44 11.9-48.1c-1.6-2.9-8.4-13-40.2-11.7zM290.9 99.7C274.1 65.9 259.9 64 256 64s-18.1 1.9-34.9 35.7c11.4 3.9 23.1 8.4 34.9 13.5c11.8-5.1 23.4-9.7 34.9-13.5zm-159 88.9c1.7-14.3 3.9-28 6.7-41.2c-31.8-1.4-38.6 8.7-40.2 11.7c-2.3 4.2-7 17.9 11.9 48.1c6.8-6.3 14-12.5 21.6-18.6zM110.2 304.8C91.4 335 96 348.7 98.3 352.9c1.6 2.9 8.4 13 40.2 11.7c-2.8-13.1-5-26.9-6.7-41.2c-7.6-6.1-14.8-12.3-21.6-18.6zM336 256a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zm-80-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $d8206b3ab2e65c05$export$64f1c53b21f310ac = {
    prefix: "fas",
    iconName: "soap",
    icon: [
        512,
        512,
        [
            129532
        ],
        "e06e",
        "M208 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM320 256a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM416 32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm0 160c0 27.6-11.7 52.5-30.4 70.1C422.1 275.7 448 310.8 448 352c0 53-43 96-96 96H160c-53 0-96-43-96-96s43-96 96-96h88.4c-15.2-17-24.4-39.4-24.4-64H96c-53 0-96 43-96 96V416c0 53 43 96 96 96H416c53 0 96-43 96-96V288c0-53-43-96-96-96zM160 288c-35.3 0-64 28.7-64 64s28.7 64 64 64H352c35.3 0 64-28.7 64-64s-28.7-64-64-64H320 160z"
    ]
};
var $d8206b3ab2e65c05$export$7fe2894454d8eb8a = {
    prefix: "fas",
    iconName: "icons",
    icon: [
        512,
        512,
        [
            "heart-music-camera-bolt"
        ],
        "f86d",
        "M500.3 7.3C507.7 13.3 512 22.4 512 32V176c0 26.5-28.7 48-64 48s-64-21.5-64-48s28.7-48 64-48V71L352 90.2V208c0 26.5-28.7 48-64 48s-64-21.5-64-48s28.7-48 64-48V64c0-15.3 10.8-28.4 25.7-31.4l160-32c9.4-1.9 19.1 .6 26.6 6.6zM74.7 304l11.8-17.8c5.9-8.9 15.9-14.2 26.6-14.2h61.7c10.7 0 20.7 5.3 26.6 14.2L213.3 304H240c26.5 0 48 21.5 48 48V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V352c0-26.5 21.5-48 48-48H74.7zM192 408a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM478.7 278.3L440.3 368H496c6.7 0 12.6 4.1 15 10.4s.6 13.3-4.4 17.7l-128 112c-5.6 4.9-13.9 5.3-19.9 .9s-8.2-12.4-5.3-19.2L391.7 400H336c-6.7 0-12.6-4.1-15-10.4s-.6-13.3 4.4-17.7l128-112c5.6-4.9 13.9-5.3 19.9-.9s8.2 12.4 5.3 19.2zm-339-59.2c-6.5 6.5-17 6.5-23 0L19.9 119.2c-28-29-26.5-76.9 5-103.9c27-23.5 68.4-19 93.4 6.5l10 10.5 9.5-10.5c25-25.5 65.9-30 93.9-6.5c31 27 32.5 74.9 4.5 103.9l-96.4 99.9z"
    ]
};
var $d8206b3ab2e65c05$export$ec74c13cedb0791d = $d8206b3ab2e65c05$export$7fe2894454d8eb8a;
var $d8206b3ab2e65c05$export$4be1b324ac8a71ba = {
    prefix: "fas",
    iconName: "microphone-lines-slash",
    icon: [
        640,
        512,
        [
            "microphone-alt-slash"
        ],
        "f539",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L472.1 344.7c15.2-26 23.9-56.3 23.9-88.7V216c0-13.3-10.7-24-24-24s-24 10.7-24 24v24 16c0 21.2-5.1 41.1-14.2 58.7L416 300.8V256H358.9l-34.5-27c2.9-3.1 7-5 11.6-5h80V192H336c-8.8 0-16-7.2-16-16s7.2-16 16-16h80V128H336c-8.8 0-16-7.2-16-16s7.2-16 16-16h80c0-53-43-96-96-96s-96 43-96 96v54.3L38.8 5.1zM358.2 378.2C346.1 382 333.3 384 320 384c-70.7 0-128-57.3-128-128v-8.7L144.7 210c-.5 1.9-.7 3.9-.7 6v40c0 89.1 66.2 162.7 152 174.4V464H248c-13.3 0-24 10.7-24 24s10.7 24 24 24h72 72c13.3 0 24-10.7 24-24s-10.7-24-24-24H344V430.4c20.4-2.8 39.7-9.1 57.3-18.2l-43.1-33.9z"
    ]
};
var $d8206b3ab2e65c05$export$d2a53a388f30780 = $d8206b3ab2e65c05$export$4be1b324ac8a71ba;
var $d8206b3ab2e65c05$export$ea908d3d80c57d08 = {
    prefix: "fas",
    iconName: "bridge-circle-check",
    icon: [
        640,
        512,
        [],
        "e4c9",
        "M64 32C46.3 32 32 46.3 32 64s14.3 32 32 32h40v64H32V288c53 0 96 43 96 96v64c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V384c0-53 43-96 96-96c6.3 0 12.4 .6 18.3 1.7C367.1 231.8 426.9 192 496 192c42.5 0 81.6 15.1 112 40.2V160H536V96h40c17.7 0 32-14.3 32-32s-14.3-32-32-32H64zM488 96v64H408V96h80zM360 96v64H280V96h80zM232 96v64H152V96h80zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"
    ]
};
var $d8206b3ab2e65c05$export$f1b881c73328720c = {
    prefix: "fas",
    iconName: "pump-medical",
    icon: [
        448,
        512,
        [],
        "e06a",
        "M128 32v96H256V96h60.1c4.2 0 8.3 1.7 11.3 4.7l33.9 33.9c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L372.7 55.4c-15-15-35.4-23.4-56.6-23.4H256c0-17.7-14.3-32-32-32H160c-17.7 0-32 14.3-32 32zM117.4 160c-33.3 0-61 25.5-63.8 58.7L35 442.7C31.9 480 61.3 512 98.8 512H285.2c37.4 0 66.9-32 63.8-69.3l-18.7-224c-2.8-33.2-30.5-58.7-63.8-58.7H117.4zM216 280v32h32c13.3 0 24 10.7 24 24s-10.7 24-24 24H216v32c0 13.3-10.7 24-24 24s-24-10.7-24-24V360H136c-13.3 0-24-10.7-24-24s10.7-24 24-24h32V280c0-13.3 10.7-24 24-24s24 10.7 24 24z"
    ]
};
var $d8206b3ab2e65c05$export$614dc068d88655af = {
    prefix: "fas",
    iconName: "fingerprint",
    icon: [
        512,
        512,
        [],
        "f577",
        "M48 256C48 141.1 141.1 48 256 48c63.1 0 119.6 28.1 157.8 72.5c8.6 10.1 23.8 11.2 33.8 2.6s11.2-23.8 2.6-33.8C403.3 34.6 333.7 0 256 0C114.6 0 0 114.6 0 256v40c0 13.3 10.7 24 24 24s24-10.7 24-24V256zm458.5-52.9c-2.7-13-15.5-21.3-28.4-18.5s-21.3 15.5-18.5 28.4c2.9 13.9 4.5 28.3 4.5 43.1v40c0 13.3 10.7 24 24 24s24-10.7 24-24V256c0-18.1-1.9-35.8-5.5-52.9zM256 80c-19 0-37.4 3-54.5 8.6c-15.2 5-18.7 23.7-8.3 35.9c7.1 8.3 18.8 10.8 29.4 7.9c10.6-2.9 21.8-4.4 33.4-4.4c70.7 0 128 57.3 128 128v24.9c0 25.2-1.5 50.3-4.4 75.3c-1.7 14.6 9.4 27.8 24.2 27.8c11.8 0 21.9-8.6 23.3-20.3c3.3-27.4 5-55 5-82.7V256c0-97.2-78.8-176-176-176zM150.7 148.7c-9.1-10.6-25.3-11.4-33.9-.4C93.7 178 80 215.4 80 256v24.9c0 24.2-2.6 48.4-7.8 71.9C68.8 368.4 80.1 384 96.1 384c10.5 0 19.9-7 22.2-17.3c6.4-28.1 9.7-56.8 9.7-85.8V256c0-27.2 8.5-52.4 22.9-73.1c7.2-10.4 8-24.6-.2-34.2zM256 160c-53 0-96 43-96 96v24.9c0 35.9-4.6 71.5-13.8 106.1c-3.8 14.3 6.7 29 21.5 29c9.5 0 17.9-6.2 20.4-15.4c10.5-39 15.9-79.2 15.9-119.7V256c0-28.7 23.3-52 52-52s52 23.3 52 52v24.9c0 36.3-3.5 72.4-10.4 107.9c-2.7 13.9 7.7 27.2 21.8 27.2c10.2 0 19-7 21-17c7.7-38.8 11.6-78.3 11.6-118.1V256c0-53-43-96-96-96zm24 96c0-13.3-10.7-24-24-24s-24 10.7-24 24v24.9c0 59.9-11 119.3-32.5 175.2l-5.9 15.3c-4.8 12.4 1.4 26.3 13.8 31s26.3-1.4 31-13.8l5.9-15.3C267.9 411.9 280 346.7 280 280.9V256z"
    ]
};
var $d8206b3ab2e65c05$export$f7bc8714c970afa4 = {
    prefix: "fas",
    iconName: "hand-point-right",
    icon: [
        512,
        512,
        [],
        "f0a4",
        "M480 96c17.7 0 32 14.3 32 32s-14.3 32-32 32l-208 0 0-64 208 0zM320 288c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l64 0zm64-64c0 17.7-14.3 32-32 32l-48 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l48 0c17.7 0 32 14.3 32 32zM288 384c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l64 0zm-88-96l.6 0c-5.4 9.4-8.6 20.3-8.6 32c0 13.2 4 25.4 10.8 35.6C177.9 364.3 160 388.1 160 416c0 11.7 3.1 22.6 8.6 32l-8.6 0C71.6 448 0 376.4 0 288l0-61.7c0-42.4 16.9-83.1 46.9-113.1l11.6-11.6C82.5 77.5 115.1 64 149 64l27 0c35.3 0 64 28.7 64 64l0 88c0 22.1-17.9 40-40 40s-40-17.9-40-40l0-56c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 56c0 39.8 32.2 72 72 72z"
    ]
};
var $d8206b3ab2e65c05$export$234a18b2b4d530a3 = {
    prefix: "fas",
    iconName: "magnifying-glass-location",
    icon: [
        512,
        512,
        [
            "search-location"
        ],
        "f689",
        "M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM288 176c0-44.2-35.8-80-80-80s-80 35.8-80 80c0 48.8 46.5 111.6 68.6 138.6c6 7.3 16.8 7.3 22.7 0c22.1-27 68.6-89.8 68.6-138.6zm-112 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
    ]
};
var $d8206b3ab2e65c05$export$c33aba6c251a898a = $d8206b3ab2e65c05$export$234a18b2b4d530a3;
var $d8206b3ab2e65c05$export$908d699be6717adc = {
    prefix: "fas",
    iconName: "forward-step",
    icon: [
        320,
        512,
        [
            "step-forward"
        ],
        "f051",
        "M52.5 440.6c-9.5 7.9-22.8 9.7-34.1 4.4S0 428.4 0 416V96C0 83.6 7.2 72.3 18.4 67s24.5-3.6 34.1 4.4l192 160L256 241V96c0-17.7 14.3-32 32-32s32 14.3 32 32V416c0 17.7-14.3 32-32 32s-32-14.3-32-32V271l-11.5 9.6-192 160z"
    ]
};
var $d8206b3ab2e65c05$export$b303329afce5de18 = $d8206b3ab2e65c05$export$908d699be6717adc;
var $d8206b3ab2e65c05$export$e3c56ed54f074063 = {
    prefix: "fas",
    iconName: "face-smile-beam",
    icon: [
        512,
        512,
        [
            128522,
            "smile-beam"
        ],
        "f5b8",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM164.1 325.5C182 346.2 212.6 368 256 368s74-21.8 91.9-42.5c5.8-6.7 15.9-7.4 22.6-1.6s7.4 15.9 1.6 22.6C349.8 372.1 311.1 400 256 400s-93.8-27.9-116.1-53.5c-5.8-6.7-5.1-16.8 1.6-22.6s16.8-5.1 22.6 1.6zm53.5-96.7l0 0 0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0zm160 0l0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0 0 0z"
    ]
};
var $d8206b3ab2e65c05$export$54ada6dc9690e0ca = $d8206b3ab2e65c05$export$e3c56ed54f074063;
var $d8206b3ab2e65c05$export$92fad97e19a9fea = {
    prefix: "fas",
    iconName: "flag-checkered",
    icon: [
        448,
        512,
        [
            127937
        ],
        "f11e",
        "M32 0C49.7 0 64 14.3 64 32V48l69-17.2c38.1-9.5 78.3-5.1 113.5 12.5c46.3 23.2 100.8 23.2 147.1 0l9.6-4.8C423.8 28.1 448 43.1 448 66.1V345.8c0 13.3-8.3 25.3-20.8 30l-34.7 13c-46.2 17.3-97.6 14.6-141.7-7.4c-37.9-19-81.3-23.7-122.5-13.4L64 384v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V400 334 64 32C0 14.3 14.3 0 32 0zM64 187.1l64-13.9v65.5L64 252.6V318l48.8-12.2c5.1-1.3 10.1-2.4 15.2-3.3V238.7l38.9-8.4c8.3-1.8 16.7-2.5 25.1-2.1l0-64c13.6 .4 27.2 2.6 40.4 6.4l23.6 6.9v66.7l-41.7-12.3c-7.3-2.1-14.8-3.4-22.3-3.8v71.4c21.8 1.9 43.3 6.7 64 14.4V244.2l22.7 6.7c13.5 4 27.3 6.4 41.3 7.4V194c-7.8-.8-15.6-2.3-23.2-4.5l-40.8-12v-62c-13-3.8-25.8-8.8-38.2-15c-8.2-4.1-16.9-7-25.8-8.8v72.4c-13-.4-26 .8-38.7 3.6L128 173.2V98L64 114v73.1zM320 335.7c16.8 1.5 33.9-.7 50-6.8l14-5.2V251.9l-7.9 1.8c-18.4 4.3-37.3 5.7-56.1 4.5v77.4zm64-149.4V115.4c-20.9 6.1-42.4 9.1-64 9.1V194c13.9 1.4 28 .5 41.7-2.6l22.3-5.2z"
    ]
};
var $d8206b3ab2e65c05$export$e15f65e77f717c29 = {
    prefix: "fas",
    iconName: "football",
    icon: [
        512,
        512,
        [
            127944,
            "football-ball"
        ],
        "f44e",
        "M247.5 25.4c-13.5 3.3-26.4 7.2-38.6 11.7C142.9 61.6 96.7 103.6 66 153.6c-18.3 29.8-30.9 62.3-39.2 95.4L264.5 486.6c13.5-3.3 26.4-7.2 38.6-11.7c66-24.5 112.2-66.5 142.9-116.5c18.3-29.8 30.9-62.3 39.1-95.3L247.5 25.4zM495.2 205.3c6.1-56.8 1.4-112.2-7.7-156.4c-2.7-12.9-13-22.9-26.1-25.1c-58.2-9.7-109.9-12-155.6-7.9L495.2 205.3zM206.1 496L16.8 306.7c-6.1 56.8-1.4 112.2 7.7 156.4c2.7 12.9 13 22.9 26.1 25.1c58.2 9.7 109.9 12 155.6 7.9zm54.6-331.3c6.2-6.2 16.4-6.2 22.6 0l64 64c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6zm-48 48c6.2-6.2 16.4-6.2 22.6 0l64 64c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6zm-48 48c6.2-6.2 16.4-6.2 22.6 0l64 64c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6z"
    ]
};
var $d8206b3ab2e65c05$export$e8fd664711e31704 = $d8206b3ab2e65c05$export$e15f65e77f717c29;
var $d8206b3ab2e65c05$export$f629fdee00932a01 = {
    prefix: "fas",
    iconName: "school-circle-exclamation",
    icon: [
        640,
        512,
        [],
        "e56c",
        "M337.8 5.4C327-1.8 313-1.8 302.2 5.4L166.3 96H48C21.5 96 0 117.5 0 144V464c0 26.5 21.5 48 48 48H320v0H256V416c0-35.3 28.7-64 64-64l.3 0h.5c3.4-37.7 18.7-72.1 42.2-99.1C350.2 260 335.6 264 320 264c-48.6 0-88-39.4-88-88s39.4-88 88-88s88 39.4 88 88c0 18.3-5.6 35.3-15.1 49.4c29-21 64.6-33.4 103.1-33.4c59.5 0 112.1 29.6 144 74.8V144c0-26.5-21.5-48-48-48H473.7L337.8 5.4zM96 192h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V208c0-8.8 7.2-16 16-16zm0 128h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V336c0-8.8 7.2-16 16-16zM320 128c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H336V144c0-8.8-7.2-16-16-16zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V288c0-8.8 7.2-16 16-16z"
    ]
};
var $d8206b3ab2e65c05$export$afa58590dfb6fca2 = {
    prefix: "fas",
    iconName: "crop",
    icon: [
        512,
        512,
        [],
        "f125",
        "M448 109.3l54.6-54.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L402.7 64 160 64v64l178.7 0L128 338.7V32c0-17.7-14.3-32-32-32S64 14.3 64 32V64H32C14.3 64 0 78.3 0 96s14.3 32 32 32H64V384c0 35.3 28.7 64 64 64H352V384H173.3L384 173.3 384 480c0 17.7 14.3 32 32 32s32-14.3 32-32V448h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H448l0-274.7z"
    ]
};
var $d8206b3ab2e65c05$export$52783a541b1bb03 = {
    prefix: "fas",
    iconName: "angles-down",
    icon: [
        448,
        512,
        [
            "angle-double-down"
        ],
        "f103",
        "M246.6 470.6c-12.5 12.5-32.8 12.5-45.3 0l-160-160c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L224 402.7 361.4 265.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-160 160zm160-352l-160 160c-12.5 12.5-32.8 12.5-45.3 0l-160-160c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L224 210.7 361.4 73.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3z"
    ]
};
var $d8206b3ab2e65c05$export$fd504117f273ca92 = $d8206b3ab2e65c05$export$52783a541b1bb03;
var $d8206b3ab2e65c05$export$a28757068b9a3a9a = {
    prefix: "fas",
    iconName: "users-rectangle",
    icon: [
        640,
        512,
        [],
        "e594",
        "M96 0C43 0 0 43 0 96V416c0 53 43 96 96 96H544c53 0 96-43 96-96V96c0-53-43-96-96-96H96zM64 96c0-17.7 14.3-32 32-32H544c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V96zm159.8 80a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM96 309.3c0 14.7 11.9 26.7 26.7 26.7h56.1c8-34.1 32.8-61.7 65.2-73.6c-7.5-4.1-16.2-6.4-25.3-6.4H149.3C119.9 256 96 279.9 96 309.3zM461.2 336h56.1c14.7 0 26.7-11.9 26.7-26.7c0-29.5-23.9-53.3-53.3-53.3H421.3c-9.2 0-17.8 2.3-25.3 6.4c32.4 11.9 57.2 39.5 65.2 73.6zM372 289c-3.9-.7-7.9-1-12-1H280c-4.1 0-8.1 .3-12 1c-26 4.4-47.3 22.7-55.9 47c-2.7 7.5-4.1 15.6-4.1 24c0 13.3 10.7 24 24 24H408c13.3 0 24-10.7 24-24c0-8.4-1.4-16.5-4.1-24c-8.6-24.3-29.9-42.6-55.9-47zM512 176a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM320 256a64 64 0 1 0 0-128 64 64 0 1 0 0 128z"
    ]
};
var $d8206b3ab2e65c05$export$b96e695bdcf3f3f5 = {
    prefix: "fas",
    iconName: "people-roof",
    icon: [
        640,
        512,
        [],
        "e537",
        "M335.5 4l288 160c15.4 8.6 21 28.1 12.4 43.5s-28.1 21-43.5 12.4L320 68.6 47.5 220c-15.4 8.6-34.9 3-43.5-12.4s-3-34.9 12.4-43.5L304.5 4c9.7-5.4 21.4-5.4 31.1 0zM320 160a40 40 0 1 1 0 80 40 40 0 1 1 0-80zM144 256a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm312 40a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zM226.9 491.4L200 441.5V480c0 17.7-14.3 32-32 32H120c-17.7 0-32-14.3-32-32V441.5L61.1 491.4c-6.3 11.7-20.8 16-32.5 9.8s-16-20.8-9.8-32.5l37.9-70.3c15.3-28.5 45.1-46.3 77.5-46.3h19.5c16.3 0 31.9 4.5 45.4 12.6l33.6-62.3c15.3-28.5 45.1-46.3 77.5-46.3h19.5c32.4 0 62.1 17.8 77.5 46.3l33.6 62.3c13.5-8.1 29.1-12.6 45.4-12.6h19.5c32.4 0 62.1 17.8 77.5 46.3l37.9 70.3c6.3 11.7 1.9 26.2-9.8 32.5s-26.2 1.9-32.5-9.8L552 441.5V480c0 17.7-14.3 32-32 32H472c-17.7 0-32-14.3-32-32V441.5l-26.9 49.9c-6.3 11.7-20.8 16-32.5 9.8s-16-20.8-9.8-32.5l36.3-67.5c-1.7-1.7-3.2-3.6-4.3-5.8L376 345.5V400c0 17.7-14.3 32-32 32H296c-17.7 0-32-14.3-32-32V345.5l-26.9 49.9c-1.2 2.2-2.6 4.1-4.3 5.8l36.3 67.5c6.3 11.7 1.9 26.2-9.8 32.5s-26.2 1.9-32.5-9.8z"
    ]
};
var $d8206b3ab2e65c05$export$d12c2d6def120efe = {
    prefix: "fas",
    iconName: "people-line",
    icon: [
        640,
        512,
        [],
        "e534",
        "M360 72a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zM144 208a40 40 0 1 0 0-80 40 40 0 1 0 0 80zM32 416c-17.7 0-32 14.3-32 32s14.3 32 32 32H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H32zM496 208a40 40 0 1 0 0-80 40 40 0 1 0 0 80zM200 313.5l26.9 49.9c6.3 11.7 20.8 16 32.5 9.8s16-20.8 9.8-32.5l-36.3-67.5c1.7-1.7 3.2-3.6 4.3-5.8L264 217.5V272c0 17.7 14.3 32 32 32h48c17.7 0 32-14.3 32-32V217.5l26.9 49.9c1.2 2.2 2.6 4.1 4.3 5.8l-36.3 67.5c-6.3 11.7-1.9 26.2 9.8 32.5s26.2 1.9 32.5-9.8L440 313.5V352c0 17.7 14.3 32 32 32h48c17.7 0 32-14.3 32-32V313.5l26.9 49.9c6.3 11.7 20.8 16 32.5 9.8s16-20.8 9.8-32.5l-37.9-70.3c-15.3-28.5-45.1-46.3-77.5-46.3H486.2c-16.3 0-31.9 4.5-45.4 12.6l-33.6-62.3c-15.3-28.5-45.1-46.3-77.5-46.3H310.2c-32.4 0-62.1 17.8-77.5 46.3l-33.6 62.3c-13.5-8.1-29.1-12.6-45.4-12.6H134.2c-32.4 0-62.1 17.8-77.5 46.3L18.9 340.6c-6.3 11.7-1.9 26.2 9.8 32.5s26.2 1.9 32.5-9.8L88 313.5V352c0 17.7 14.3 32 32 32h48c17.7 0 32-14.3 32-32V313.5z"
    ]
};
var $d8206b3ab2e65c05$export$b957c27bc5330472 = {
    prefix: "fas",
    iconName: "beer-mug-empty",
    icon: [
        512,
        512,
        [
            "beer"
        ],
        "f0fc",
        "M32 64c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32V96h51.2c42.4 0 76.8 34.4 76.8 76.8V274.9c0 30.4-17.9 57.9-45.6 70.2L384 381.7V416c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V64zM384 311.6l56.4-25.1c4.6-2.1 7.6-6.6 7.6-11.7V172.8c0-7.1-5.7-12.8-12.8-12.8H384V311.6zM160 144c0-8.8-7.2-16-16-16s-16 7.2-16 16V368c0 8.8 7.2 16 16 16s16-7.2 16-16V144zm64 0c0-8.8-7.2-16-16-16s-16 7.2-16 16V368c0 8.8 7.2 16 16 16s16-7.2 16-16V144zm64 0c0-8.8-7.2-16-16-16s-16 7.2-16 16V368c0 8.8 7.2 16 16 16s16-7.2 16-16V144z"
    ]
};
var $d8206b3ab2e65c05$export$f74725691538983b = $d8206b3ab2e65c05$export$b957c27bc5330472;
var $d8206b3ab2e65c05$export$1852c99deca7bee8 = {
    prefix: "fas",
    iconName: "diagram-predecessor",
    icon: [
        512,
        512,
        [],
        "e477",
        "M448 416l0-64L64 352l0 64 384 0zm0 64L64 480c-35.3 0-64-28.7-64-64l0-64c0-35.3 28.7-64 64-64l384 0c35.3 0 64 28.7 64 64l0 64c0 35.3-28.7 64-64 64zM288 160c0 35.3-28.7 64-64 64L64 224c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l144 0 16 0 144 0c44.2 0 80 35.8 80 80l0 16 38.1 0c21.4 0 32.1 25.9 17 41L433 239c-9.4 9.4-24.6 9.4-33.9 0L329 169c-15.1-15.1-4.4-41 17-41l38.1 0 0-16c0-8.8-7.2-16-16-16l-80 0 0 64z"
    ]
};
var $d8206b3ab2e65c05$export$92c58defe6e4c5a7 = {
    prefix: "fas",
    iconName: "arrow-up-long",
    icon: [
        384,
        512,
        [
            "long-arrow-up"
        ],
        "f176",
        "M214.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 109.3V480c0 17.7 14.3 32 32 32s32-14.3 32-32V109.3l73.4 73.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-128-128z"
    ]
};
var $d8206b3ab2e65c05$export$ede1d50ec4b01670 = $d8206b3ab2e65c05$export$92c58defe6e4c5a7;
var $d8206b3ab2e65c05$export$9ebfff5c90672059 = {
    prefix: "fas",
    iconName: "fire-flame-simple",
    icon: [
        384,
        512,
        [
            "burn"
        ],
        "f46a",
        "M372.5 256.5l-.7-1.9C337.8 160.8 282 76.5 209.1 8.5l-3.3-3C202.1 2 197.1 0 192 0s-10.1 2-13.8 5.5l-3.3 3C102 76.5 46.2 160.8 12.2 254.6l-.7 1.9C3.9 277.3 0 299.4 0 321.6C0 426.7 86.8 512 192 512s192-85.3 192-190.4c0-22.2-3.9-44.2-11.5-65.1zm-90.8 49.5c4.1 9.3 6.2 19.4 6.2 29.5c0 53-43 96.5-96 96.5s-96-43.5-96-96.5c0-10.1 2.1-20.3 6.2-29.5l1.9-4.3c15.8-35.4 37.9-67.7 65.3-95.1l8.9-8.9c3.6-3.6 8.5-5.6 13.6-5.6s10 2 13.6 5.6l8.9 8.9c27.4 27.4 49.6 59.7 65.3 95.1l1.9 4.3z"
    ]
};
var $d8206b3ab2e65c05$export$80ed4535efc60402 = $d8206b3ab2e65c05$export$9ebfff5c90672059;
var $d8206b3ab2e65c05$export$e6619e43cb090a16 = {
    prefix: "fas",
    iconName: "person",
    icon: [
        320,
        512,
        [
            129485,
            "male"
        ],
        "f183",
        "M112 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm40 304V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V256.9L59.4 304.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c17.4-28.9 48.6-46.6 82.3-46.6h29.7c33.7 0 64.9 17.7 82.3 46.6l58.3 97c9.1 15.1 4.2 34.8-10.9 43.9s-34.8 4.2-43.9-10.9L232 256.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352H152z"
    ]
};
var $d8206b3ab2e65c05$export$2e21f9dba1630651 = $d8206b3ab2e65c05$export$e6619e43cb090a16;
var $d8206b3ab2e65c05$export$c2dee3bd177275a2 = {
    prefix: "fas",
    iconName: "laptop",
    icon: [
        640,
        512,
        [
            128187
        ],
        "f109",
        "M128 32C92.7 32 64 60.7 64 96V352h64V96H512V352h64V96c0-35.3-28.7-64-64-64H128zM19.2 384C8.6 384 0 392.6 0 403.2C0 445.6 34.4 480 76.8 480H563.2c42.4 0 76.8-34.4 76.8-76.8c0-10.6-8.6-19.2-19.2-19.2H19.2z"
    ]
};
var $d8206b3ab2e65c05$export$82cea4f586f6ec9 = {
    prefix: "fas",
    iconName: "file-csv",
    icon: [
        512,
        512,
        [],
        "f6dd",
        "M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384V304H176c-35.3 0-64 28.7-64 64V512H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128zM200 352h16c22.1 0 40 17.9 40 40v8c0 8.8-7.2 16-16 16s-16-7.2-16-16v-8c0-4.4-3.6-8-8-8H200c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-8c0-8.8 7.2-16 16-16s16 7.2 16 16v8c0 22.1-17.9 40-40 40H200c-22.1 0-40-17.9-40-40V392c0-22.1 17.9-40 40-40zm133.1 0H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H333.1c-7.2 0-13.1 5.9-13.1 13.1c0 5.2 3 9.9 7.8 12l37.4 16.6c16.3 7.2 26.8 23.4 26.8 41.2c0 24.9-20.2 45.1-45.1 45.1H304c-8.8 0-16-7.2-16-16s7.2-16 16-16h42.9c7.2 0 13.1-5.9 13.1-13.1c0-5.2-3-9.9-7.8-12l-37.4-16.6c-16.3-7.2-26.8-23.4-26.8-41.2c0-24.9 20.2-45.1 45.1-45.1zm98.9 0c8.8 0 16 7.2 16 16v31.6c0 23 5.5 45.6 16 66c10.5-20.3 16-42.9 16-66V368c0-8.8 7.2-16 16-16s16 7.2 16 16v31.6c0 34.7-10.3 68.7-29.6 97.6l-5.1 7.7c-3 4.5-8 7.1-13.3 7.1s-10.3-2.7-13.3-7.1l-5.1-7.7c-19.3-28.9-29.6-62.9-29.6-97.6V368c0-8.8 7.2-16 16-16z"
    ]
};
var $d8206b3ab2e65c05$export$232452c59d77c56e = {
    prefix: "fas",
    iconName: "menorah",
    icon: [
        640,
        512,
        [],
        "f676",
        "M20.8 7.4C22.8 2.9 27.1 0 32 0s9.2 2.9 11.2 7.4L61.3 49.7c1.8 4.1 2.7 8.6 2.7 13.1V64c0 17.7-14.3 32-32 32S0 81.7 0 64V62.8c0-4.5 .9-8.9 2.7-13.1L20.8 7.4zm96 0C118.8 2.9 123.1 0 128 0s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1V64c0 17.7-14.3 32-32 32s-32-14.3-32-32V62.8c0-4.5 .9-8.9 2.7-13.1L116.8 7.4zm77.8 42.4L212.8 7.4C214.8 2.9 219.1 0 224 0s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1V64c0 17.7-14.3 32-32 32s-32-14.3-32-32V62.8c0-4.5 .9-8.9 2.7-13.1zM308.8 7.4C310.8 2.9 315.1 0 320 0s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1V64c0 17.7-14.3 32-32 32s-32-14.3-32-32V62.8c0-4.5 .9-8.9 2.7-13.1L308.8 7.4zm77.8 42.4L404.8 7.4C406.8 2.9 411.1 0 416 0s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1V64c0 17.7-14.3 32-32 32s-32-14.3-32-32V62.8c0-4.5 .9-8.9 2.7-13.1zM500.8 7.4C502.8 2.9 507.1 0 512 0s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1V64c0 17.7-14.3 32-32 32s-32-14.3-32-32V62.8c0-4.5 .9-8.9 2.7-13.1L500.8 7.4zm77.8 42.4L596.8 7.4C598.8 2.9 603.1 0 608 0s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1V64c0 17.7-14.3 32-32 32s-32-14.3-32-32V62.8c0-4.5 .9-8.9 2.7-13.1zM32 128c17.7 0 32 14.3 32 32V288c0 17.7 14.3 32 32 32H288V160c0-17.7 14.3-32 32-32s32 14.3 32 32V320H544c17.7 0 32-14.3 32-32V160c0-17.7 14.3-32 32-32s32 14.3 32 32V288c0 53-43 96-96 96H352v64H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H320 160c-17.7 0-32-14.3-32-32s14.3-32 32-32H288V384H96c-53 0-96-43-96-96V160c0-17.7 14.3-32 32-32zm96 0c17.7 0 32 14.3 32 32v96 32H96V256 160c0-17.7 14.3-32 32-32zm96 0c17.7 0 32 14.3 32 32v96 32H192V256 160c0-17.7 14.3-32 32-32zm192 0c17.7 0 32 14.3 32 32v96 32H384V256 160c0-17.7 14.3-32 32-32zm96 0c17.7 0 32 14.3 32 32v96 32H480V256 160c0-17.7 14.3-32 32-32z"
    ]
};
var $d8206b3ab2e65c05$export$e1d5ceed99060d76 = {
    prefix: "fas",
    iconName: "truck-plane",
    icon: [
        640,
        512,
        [],
        "e58f",
        "M200 0c-30.6 0-56 54.7-56 86.1V192.5L7.8 274.3C2.9 277.2 0 282.4 0 288v64c0 5.1 2.4 9.8 6.4 12.8s9.3 3.9 14.1 2.5l123.4-37v81.2l-50 40c-3.8 3-6 7.6-6 12.5v32c0 5.1 2.5 10 6.6 13s9.5 3.8 14.4 2.2L200 480.9 290.4 511c-1.6-4.7-2.4-9.8-2.4-15V463.4c-18.2-10.5-30.7-29.7-31.9-51.8l-.1-.1V408 325.5 184l0-1.1 0 0V86.1C256 54.7 231.5 0 200 0zm88 176V400c0 20.9 13.4 38.7 32 45.3V488c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V448H544v40c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V445.3c18.6-6.6 32-24.4 32-45.3V176c0-26.5-21.5-48-48-48H336c-26.5 0-48 21.5-48 48zm79.8 78.7c3.3-8.7 11.2-14.7 20.5-14.7H539.7c9.2 0 17.2 6 20.5 14.7L576 304H352l15.8-49.3zM568 352a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM336 376a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"
    ]
};
var $d8206b3ab2e65c05$export$fe2d5012d9982673 = {
    prefix: "fas",
    iconName: "record-vinyl",
    icon: [
        512,
        512,
        [],
        "f8d9",
        "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256-96a96 96 0 1 1 0 192 96 96 0 1 1 0-192zm0 224a128 128 0 1 0 0-256 128 128 0 1 0 0 256zm0-96a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
var $d8206b3ab2e65c05$export$1d1fbac384a76a12 = {
    prefix: "fas",
    iconName: "face-grin-stars",
    icon: [
        512,
        512,
        [
            129321,
            "grin-stars"
        ],
        "f587",
        "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm407.4 75.5c5-11.8-7-22.5-19.3-18.7c-39.7 12.2-84.5 19-131.8 19s-92.1-6.8-131.8-19c-12.3-3.8-24.3 6.9-19.3 18.7c25 59.1 83.2 100.5 151.1 100.5s126.2-41.4 151.1-100.5zM160 120c-3.1 0-5.9 1.8-7.2 4.6l-16.6 34.7-38.1 5c-3.1 .4-5.6 2.5-6.6 5.5s-.1 6.2 2.1 8.3l27.9 26.5-7 37.8c-.6 3 .7 6.1 3.2 7.9s5.8 2 8.5 .6L160 232.5l33.8 18.3c2.7 1.5 6 1.3 8.5-.6s3.7-4.9 3.2-7.9l-7-37.8L226.4 178c2.2-2.1 3.1-5.3 2.1-8.3s-3.5-5.1-6.6-5.5l-38.1-5-16.6-34.7c-1.3-2.8-4.1-4.6-7.2-4.6zm192 0c-3.1 0-5.9 1.8-7.2 4.6l-16.6 34.7-38.1 5c-3.1 .4-5.6 2.5-6.6 5.5s-.1 6.2 2.1 8.3l27.9 26.5-7 37.8c-.6 3 .7 6.1 3.2 7.9s5.8 2 8.5 .6L352 232.5l33.8 18.3c2.7 1.5 6 1.3 8.5-.6s3.7-4.9 3.2-7.9l-7-37.8L418.4 178c2.2-2.1 3.1-5.3 2.1-8.3s-3.5-5.1-6.6-5.5l-38.1-5-16.6-34.7c-1.3-2.8-4.1-4.6-7.2-4.6z"
    ]
};
var $d8206b3ab2e65c05$export$64347a5c8c402ef4 = $d8206b3ab2e65c05$export$1d1fbac384a76a12;
var $d8206b3ab2e65c05$export$e74974fac77c468e = {
    prefix: "fas",
    iconName: "bong",
    icon: [
        448,
        512,
        [],
        "f55c",
        "M160 208.5c0 29.1-15.6 53.9-37.2 67.8c-17.2 11.1-31.5 26.1-41.7 43.7H302.9c-10.2-17.6-24.5-32.6-41.7-43.7c-21.6-13.9-37.2-38.7-37.2-67.8V64H160V208.5zM288 64V208.5c0 5.7 3.1 10.9 7.9 14c11.2 7.2 21.5 15.5 30.9 24.8L366.1 208l-7-7c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l24 24 24 24c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-7-7-43.3 43.3C374 314.1 384 347.9 384 384c0 39.4-11.9 76.1-32.2 106.5c-9.6 14.4-26.5 21.5-43.8 21.5H76.1c-17.3 0-34.2-7.1-43.8-21.5C11.9 460.1 0 423.4 0 384c0-67.8 35.1-127.3 88.1-161.5c4.8-3.1 7.9-8.3 7.9-14V64C78.3 64 64 49.7 64 32S78.3 0 96 0h16H272h16c17.7 0 32 14.3 32 32s-14.3 32-32 32z"
    ]
};
var $d8206b3ab2e65c05$export$3c8d5c62d76c33b8 = {
    prefix: "fas",
    iconName: "spaghetti-monster-flying",
    icon: [
        640,
        512,
        [
            "pastafarianism"
        ],
        "f67b",
        "M208 64a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm48 0c0 16.2-6 31.1-16 42.3l15.6 31.2c18.7-6 39.9-9.5 64.4-9.5s45.8 3.5 64.4 9.5L400 106.3C390 95.1 384 80.2 384 64c0-35.3 28.7-64 64-64s64 28.7 64 64s-28.7 64-64 64c-1.7 0-3.4-.1-5.1-.2L427.8 158c21.1 13.6 37.7 30.2 51.4 46.4c7.1 8.3 13.5 16.6 19.3 24l1.4 1.8c6.3 8.1 11.6 14.8 16.7 20.4C527.3 262.3 532.7 264 536 264c2.5 0 4.3-.6 7.1-3.3c3.7-3.5 7.1-8.8 12.5-17.4l.6-.9c4.6-7.4 11-17.6 19.4-25.7c9.7-9.3 22.9-16.7 40.4-16.7c13.3 0 24 10.7 24 24s-10.7 24-24 24c-2.5 0-4.3 .6-7.1 3.3c-3.7 3.5-7.1 8.8-12.5 17.4l-.6 .9c-4.6 7.4-11 17.6-19.4 25.7c-9.7 9.3-22.9 16.7-40.4 16.7c-18.5 0-32.9-8.5-44.3-18.6c-3.1 4-6.6 8.3-10.5 12.7c1.4 4.3 2.8 8.5 4 12.5c.9 3 1.8 5.8 2.6 8.6c3 9.8 5.5 18.2 8.6 25.9c3.9 9.8 7.4 15.4 10.8 18.5c2.6 2.4 5.9 4.3 12.8 4.3c8.7 0 16.9-4.2 33.7-13.2c15-8 35.7-18.8 62.3-18.8c13.3 0 24 10.7 24 24s-10.7 24-24 24c-13.4 0-24.7 5.2-39.7 13.2c-1 .6-2.1 1.1-3.2 1.7C559.9 414 541.4 424 520 424c-18.4 0-33.6-6.1-45.5-17.2c-11.1-10.3-17.9-23.7-22.7-36c-3.6-9-6.7-19.1-9.5-28.5c-16.4 12.3-36.1 23.6-58.9 31.3c3.6 10.8 8.4 23.5 14.4 36.2c7.5 15.9 16.2 30.4 25.8 40.5C433 460.5 441.2 464 448 464c13.3 0 24 10.7 24 24s-10.7 24-24 24c-25.2 0-45-13.5-59.5-28.8c-14.5-15.4-25.7-34.9-34.2-53c-8-17-14.1-33.8-18.3-46.9c-5.2 .4-10.6 .6-16 .6s-10.8-.2-16-.6c-4.2 13-10.3 29.9-18.3 46.9c-8.5 18.1-19.8 37.6-34.2 53C237 498.5 217.2 512 192 512c-13.3 0-24-10.7-24-24s10.7-24 24-24c6.8 0 15-3.5 24.5-13.7c9.5-10.1 18.3-24.6 25.8-40.5c5.9-12.6 10.7-25.4 14.4-36.2c-22.8-7.7-42.5-19-58.9-31.3c-2.9 9.4-6 19.5-9.5 28.5c-4.8 12.2-11.6 25.6-22.7 36C153.6 417.9 138.4 424 120 424c-21.4 0-39.9-10-53.1-17.1l0 0c-1.1-.6-2.2-1.2-3.2-1.7c-15-8-26.3-13.2-39.7-13.2c-13.3 0-24-10.7-24-24s10.7-24 24-24c26.6 0 47.3 10.8 62.3 18.8c16.8 9 25 13.2 33.7 13.2c6.8 0 10.2-1.9 12.8-4.3c3.4-3.2 7-8.8 10.8-18.5c3-7.7 5.6-16.1 8.6-25.9c.8-2.7 1.7-5.6 2.6-8.6c1.2-4 2.6-8.2 4-12.5c-3.9-4.5-7.4-8.8-10.5-12.7C136.9 303.5 122.5 312 104 312c-17.5 0-30.7-7.4-40.4-16.7c-8.4-8.1-14.8-18.3-19.4-25.7l-.6-.9c-5.4-8.6-8.8-13.9-12.5-17.4c-2.8-2.7-4.6-3.3-7.1-3.3c-13.3 0-24-10.7-24-24s10.7-24 24-24c17.5 0 30.7 7.4 40.4 16.7c8.4 8.1 14.8 18.3 19.4 25.7l.6 .9c5.4 8.6 8.8 13.9 12.5 17.4c2.8 2.7 4.6 3.3 7.1 3.3c3.3 0 8.7-1.7 19.4-13.4c5.1-5.6 10.4-12.3 16.7-20.4l1.4-1.8c5.8-7.4 12.2-15.7 19.3-24c13.8-16.2 30.3-32.8 51.4-46.4l-15.1-30.2c-1.7 .1-3.4 .2-5.1 .2c-35.3 0-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64zm208 0a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"
    ]
};
var $d8206b3ab2e65c05$export$733efdaec97447be = $d8206b3ab2e65c05$export$3c8d5c62d76c33b8;
var $d8206b3ab2e65c05$export$9fe0c42ede2dd003 = {
    prefix: "fas",
    iconName: "arrow-down-up-across-line",
    icon: [
        576,
        512,
        [],
        "e4af",
        "M137.4 502.6c12.5 12.5 32.8 12.5 45.3 0l96-96c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 402.7V288H544c17.7 0 32-14.3 32-32s-14.3-32-32-32H448V109.3l41.4 41.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-96-96c-12.5-12.5-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L384 109.3V224H192 128 32c-17.7 0-32 14.3-32 32s14.3 32 32 32h96V402.7L86.6 361.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96zM128 192h64V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V192zM448 320H384V448c0 17.7 14.3 32 32 32s32-14.3 32-32V320z"
    ]
};
var $d8206b3ab2e65c05$export$faf854a434ce6d0c = {
    prefix: "fas",
    iconName: "spoon",
    icon: [
        512,
        512,
        [
            129348,
            61873,
            "utensil-spoon"
        ],
        "f2e5",
        "M245.8 220.9c-14.5-17.6-21.8-39.2-21.8-60.8C224 80 320 0 416 0c53 0 96 43 96 96c0 96-80 192-160.2 192c-21.6 0-43.2-7.3-60.8-21.8L54.6 502.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L245.8 220.9z"
    ]
};
var $d8206b3ab2e65c05$export$fb7af5d245fb9053 = $d8206b3ab2e65c05$export$faf854a434ce6d0c;
var $d8206b3ab2e65c05$export$8b503c1d76716ddd = {
    prefix: "fas",
    iconName: "jar-wheat",
    icon: [
        320,
        512,
        [],
        "e517",
        "M32 32C32 14.3 46.3 0 64 0H256c17.7 0 32 14.3 32 32s-14.3 32-32 32H64C46.3 64 32 49.7 32 32zM0 160c0-35.3 28.7-64 64-64H256c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V160zm112 0H69.8c-3.2 0-5.8 2.6-5.8 5.8C64 198 90 224 122.2 224H144h32 21.8c32.1 0 58.2-26 58.2-58.2c0-3.2-2.6-5.8-5.8-5.8H208c-19.1 0-36.3 8.4-48 21.7c-11.7-13.3-28.9-21.7-48-21.7zm48 117.7c-11.7-13.3-28.9-21.7-48-21.7H69.8c-3.2 0-5.8 2.6-5.8 5.8C64 294 90 320 122.2 320H144h32 21.8c32.1 0 58.2-26 58.2-58.2c0-3.2-2.6-5.8-5.8-5.8H208c-19.1 0-36.3 8.4-48 21.7zM112 352H69.8c-3.2 0-5.8 2.6-5.8 5.8C64 390 90 416 122.2 416H144v32c0 8.8 7.2 16 16 16s16-7.2 16-16V416h21.8c32.1 0 58.2-26 58.2-58.2c0-3.2-2.6-5.8-5.8-5.8H208c-19.1 0-36.3 8.4-48 21.7c-11.7-13.3-28.9-21.7-48-21.7z"
    ]
};
var $d8206b3ab2e65c05$export$dc2cce064a1e70bb = {
    prefix: "fas",
    iconName: "envelopes-bulk",
    icon: [
        640,
        512,
        [
            "mail-bulk"
        ],
        "f674",
        "M128 0C110.3 0 96 14.3 96 32V224h96V192c0-35.3 28.7-64 64-64H480V32c0-17.7-14.3-32-32-32H128zM256 160c-17.7 0-32 14.3-32 32v32h96c35.3 0 64 28.7 64 64V416H576c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32H256zm240 64h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H496c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zM64 256c-17.7 0-32 14.3-32 32v13L187.1 415.9c1.4 1 3.1 1.6 4.9 1.6s3.5-.6 4.9-1.6L352 301V288c0-17.7-14.3-32-32-32H64zm288 84.8L216 441.6c-6.9 5.1-15.3 7.9-24 7.9s-17-2.8-24-7.9L32 340.8V480c0 17.7 14.3 32 32 32H320c17.7 0 32-14.3 32-32V340.8z"
    ]
};
var $d8206b3ab2e65c05$export$dd24f40c5337e2e1 = $d8206b3ab2e65c05$export$dc2cce064a1e70bb;
var $d8206b3ab2e65c05$export$61fa9809253098e5 = {
    prefix: "fas",
    iconName: "file-circle-exclamation",
    icon: [
        576,
        512,
        [],
        "e4eb",
        "M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384v38.6C310.1 219.5 256 287.4 256 368c0 59.1 29.1 111.3 73.7 143.3c-3.2 .5-6.4 .7-9.7 .7H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128zm48 96a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 240a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-192c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16V288c0-8.8-7.2-16-16-16z"
    ]
};
var $d8206b3ab2e65c05$export$bf5674308c61894f = {
    prefix: "fas",
    iconName: "circle-h",
    icon: [
        512,
        512,
        [
            9405,
            "hospital-symbol"
        ],
        "f47e",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM368 152V256 360c0 13.3-10.7 24-24 24s-24-10.7-24-24V280H192l0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-208c0-13.3 10.7-24 24-24s24 10.7 24 24v80H320V152c0-13.3 10.7-24 24-24s24 10.7 24 24z"
    ]
};
var $d8206b3ab2e65c05$export$c8a3c78d99c23fed = $d8206b3ab2e65c05$export$bf5674308c61894f;
var $d8206b3ab2e65c05$export$e1611f373a10a98c = {
    prefix: "fas",
    iconName: "pager",
    icon: [
        512,
        512,
        [
            128223
        ],
        "f815",
        "M0 128C0 92.7 28.7 64 64 64H448c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zm64 32v64c0 17.7 14.3 32 32 32H416c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32H96c-17.7 0-32 14.3-32 32zM80 320c-13.3 0-24 10.7-24 24s10.7 24 24 24h56c13.3 0 24-10.7 24-24s-10.7-24-24-24H80zm136 0c-13.3 0-24 10.7-24 24s10.7 24 24 24h48c13.3 0 24-10.7 24-24s-10.7-24-24-24H216z"
    ]
};
var $d8206b3ab2e65c05$export$853fd1561789e3bb = {
    prefix: "fas",
    iconName: "address-book",
    icon: [
        512,
        512,
        [
            62138,
            "contact-book"
        ],
        "f2b9",
        "M96 0C60.7 0 32 28.7 32 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H96zM208 288h64c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16H144c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80zm-32-96a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM512 80c0-8.8-7.2-16-16-16s-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V80zM496 192c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm16 144c0-8.8-7.2-16-16-16s-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V336z"
    ]
};
var $d8206b3ab2e65c05$export$594b5a5d4d2e156b = $d8206b3ab2e65c05$export$853fd1561789e3bb;
var $d8206b3ab2e65c05$export$eff51ea25b4de135 = {
    prefix: "fas",
    iconName: "strikethrough",
    icon: [
        512,
        512,
        [],
        "f0cc",
        "M161.3 144c3.2-17.2 14-30.1 33.7-38.6c21.1-9 51.8-12.3 88.6-6.5c11.9 1.9 48.8 9.1 60.1 12c17.1 4.5 34.6-5.6 39.2-22.7s-5.6-34.6-22.7-39.2c-14.3-3.8-53.6-11.4-66.6-13.4c-44.7-7-88.3-4.2-123.7 10.9c-36.5 15.6-64.4 44.8-71.8 87.3c-.1 .6-.2 1.1-.2 1.7c-2.8 23.9 .5 45.6 10.1 64.6c4.5 9 10.2 16.9 16.7 23.9H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H270.1c-.1 0-.3-.1-.4-.1l-1.1-.3c-36-10.8-65.2-19.6-85.2-33.1c-9.3-6.3-15-12.6-18.2-19.1c-3.1-6.1-5.2-14.6-3.8-27.4zM348.9 337.2c2.7 6.5 4.4 15.8 1.9 30.1c-3 17.6-13.8 30.8-33.9 39.4c-21.1 9-51.7 12.3-88.5 6.5c-18-2.9-49.1-13.5-74.4-22.1c-5.6-1.9-11-3.7-15.9-5.4c-16.8-5.6-34.9 3.5-40.5 20.3s3.5 34.9 20.3 40.5c3.6 1.2 7.9 2.7 12.7 4.3l0 0 0 0c24.9 8.5 63.6 21.7 87.6 25.6l0 0 .2 0c44.7 7 88.3 4.2 123.7-10.9c36.5-15.6 64.4-44.8 71.8-87.3c3.6-21 2.7-40.4-3.1-58.1H335.1c7 5.6 11.4 11.2 13.9 17.2z"
    ]
};
var $d8206b3ab2e65c05$export$3f85413cb67e7f67 = {
    prefix: "fas",
    iconName: "k",
    icon: [
        320,
        512,
        [
            107
        ],
        "4b",
        "M311 86.3c12.3-12.7 12-32.9-.7-45.2s-32.9-12-45.2 .7l-155.2 160L64 249V64c0-17.7-14.3-32-32-32S0 46.3 0 64V328 448c0 17.7 14.3 32 32 32s32-14.3 32-32V341l64.7-66.7 133 192c10.1 14.5 30 18.1 44.5 8.1s18.1-30 8.1-44.5L174.1 227.4 311 86.3z"
    ]
};
var $d8206b3ab2e65c05$export$f4d472cf47be4096 = {
    prefix: "fas",
    iconName: "landmark-flag",
    icon: [
        512,
        512,
        [],
        "e51c",
        "M272 0h80c8.8 0 16 7.2 16 16V80c0 8.8-7.2 16-16 16H272v32H464c17.7 0 32 14.3 32 32s-14.3 32-32 32H48c-17.7 0-32-14.3-32-32s14.3-32 32-32H240V16c0-8.8 7.2-16 16-16h16zM64 224h64V416h40V224h64V416h48V224h64V416h40V224h64V420.3c.6 .3 1.2 .7 1.8 1.1l48 32c11.7 7.8 17 22.4 12.9 35.9S494.1 512 480 512H32c-14.1 0-26.5-9.2-30.6-22.7s1.1-28.1 12.9-35.9l48-32c.6-.4 1.2-.7 1.8-1.1V224z"
    ]
};
var $d8206b3ab2e65c05$export$c72de95adaca18b8 = {
    prefix: "fas",
    iconName: "pencil",
    icon: [
        512,
        512,
        [
            9999,
            61504,
            "pencil-alt"
        ],
        "f303",
        "M410.3 231l11.3-11.3-33.9-33.9-62.1-62.1L291.7 89.8l-11.3 11.3-22.6 22.6L58.6 322.9c-10.4 10.4-18 23.3-22.2 37.4L1 480.7c-2.5 8.4-.2 17.5 6.1 23.7s15.3 8.5 23.7 6.1l120.3-35.4c14.1-4.2 27-11.8 37.4-22.2L387.7 253.7 410.3 231zM160 399.4l-9.1 22.7c-4 3.1-8.5 5.4-13.3 6.9L59.4 452l23-78.1c1.4-4.9 3.8-9.4 6.9-13.3l22.7-9.1v32c0 8.8 7.2 16 16 16h32zM362.7 18.7L348.3 33.2 325.7 55.8 314.3 67.1l33.9 33.9 62.1 62.1 33.9 33.9 11.3-11.3 22.6-22.6 14.5-14.5c25-25 25-65.5 0-90.5L453.3 18.7c-25-25-65.5-25-90.5 0zm-47.4 168l-144 144c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l144-144c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
    ]
};
var $d8206b3ab2e65c05$export$8210adc172262df = $d8206b3ab2e65c05$export$c72de95adaca18b8;
var $d8206b3ab2e65c05$export$ae65f96ea7a4078d = {
    prefix: "fas",
    iconName: "backward",
    icon: [
        512,
        512,
        [
            9194
        ],
        "f04a",
        "M459.5 440.6c9.5 7.9 22.8 9.7 34.1 4.4s18.4-16.6 18.4-29V96c0-12.4-7.2-23.7-18.4-29s-24.5-3.6-34.1 4.4L288 214.3V256v41.7L459.5 440.6zM256 352V256 128 96c0-12.4-7.2-23.7-18.4-29s-24.5-3.6-34.1 4.4l-192 160C4.2 237.5 0 246.5 0 256s4.2 18.5 11.5 24.6l192 160c9.5 7.9 22.8 9.7 34.1 4.4s18.4-16.6 18.4-29V352z"
    ]
};
var $d8206b3ab2e65c05$export$f1011352b01c1c0 = {
    prefix: "fas",
    iconName: "caret-right",
    icon: [
        256,
        512,
        [],
        "f0da",
        "M246.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-9.2-9.2-22.9-11.9-34.9-6.9s-19.8 16.6-19.8 29.6l0 256c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l128-128z"
    ]
};
var $d8206b3ab2e65c05$export$932912e74adb8939 = {
    prefix: "fas",
    iconName: "comments",
    icon: [
        640,
        512,
        [
            128490,
            61670
        ],
        "f086",
        "M208 352c114.9 0 208-78.8 208-176S322.9 0 208 0S0 78.8 0 176c0 38.6 14.7 74.3 39.6 103.4c-3.5 9.4-8.7 17.7-14.2 24.7c-4.8 6.2-9.7 11-13.3 14.3c-1.8 1.6-3.3 2.9-4.3 3.7c-.5 .4-.9 .7-1.1 .8l-.2 .2 0 0 0 0C1 327.2-1.4 334.4 .8 340.9S9.1 352 16 352c21.8 0 43.8-5.6 62.1-12.5c9.2-3.5 17.8-7.4 25.3-11.4C134.1 343.3 169.8 352 208 352zM448 176c0 112.3-99.1 196.9-216.5 207C255.8 457.4 336.4 512 432 512c38.2 0 73.9-8.7 104.7-23.9c7.5 4 16 7.9 25.2 11.4c18.3 6.9 40.3 12.5 62.1 12.5c6.9 0 13.1-4.5 15.2-11.1c2.1-6.6-.2-13.8-5.8-17.9l0 0 0 0-.2-.2c-.2-.2-.6-.4-1.1-.8c-1-.8-2.5-2-4.3-3.7c-3.6-3.3-8.5-8.1-13.3-14.3c-5.5-7-10.7-15.4-14.2-24.7c24.9-29 39.6-64.7 39.6-103.4c0-92.8-84.9-168.9-192.6-175.5c.4 5.1 .6 10.3 .6 15.5z"
    ]
};
var $d8206b3ab2e65c05$export$6f95f90dd1f6d86b = {
    prefix: "fas",
    iconName: "paste",
    icon: [
        512,
        512,
        [
            "file-clipboard"
        ],
        "f0ea",
        "M160 0c-23.7 0-44.4 12.9-55.4 32H48C21.5 32 0 53.5 0 80V400c0 26.5 21.5 48 48 48H192V176c0-44.2 35.8-80 80-80h48V80c0-26.5-21.5-48-48-48H215.4C204.4 12.9 183.7 0 160 0zM272 128c-26.5 0-48 21.5-48 48V448v16c0 26.5 21.5 48 48 48H464c26.5 0 48-21.5 48-48V243.9c0-12.7-5.1-24.9-14.1-33.9l-67.9-67.9c-9-9-21.2-14.1-33.9-14.1H320 272zM160 40a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
    ]
};
var $d8206b3ab2e65c05$export$ca3229c47de163fa = $d8206b3ab2e65c05$export$6f95f90dd1f6d86b;
var $d8206b3ab2e65c05$export$37576dfab037d8bf = {
    prefix: "fas",
    iconName: "code-pull-request",
    icon: [
        512,
        512,
        [],
        "e13c",
        "M305.8 2.1C314.4 5.9 320 14.5 320 24V64h16c70.7 0 128 57.3 128 128V358.7c28.3 12.3 48 40.5 48 73.3c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-32.8 19.7-61 48-73.3V192c0-35.3-28.7-64-64-64H320v40c0 9.5-5.6 18.1-14.2 21.9s-18.8 2.3-25.8-4.1l-80-72c-5.1-4.6-7.9-11-7.9-17.8s2.9-13.3 7.9-17.8l80-72c7-6.3 17.2-7.9 25.8-4.1zM104 80A24 24 0 1 0 56 80a24 24 0 1 0 48 0zm8 73.3V358.7c28.3 12.3 48 40.5 48 73.3c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-32.8 19.7-61 48-73.3V153.3C19.7 141 0 112.8 0 80C0 35.8 35.8 0 80 0s80 35.8 80 80c0 32.8-19.7 61-48 73.3zM104 432a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm328 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
    ]
};
var $d8206b3ab2e65c05$export$2c5a9d8548d8810e = {
    prefix: "fas",
    iconName: "clipboard-list",
    icon: [
        384,
        512,
        [],
        "f46d",
        "M192 0c-41.8 0-77.4 26.7-90.5 64H64C28.7 64 0 92.7 0 128V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H282.5C269.4 26.7 233.8 0 192 0zm0 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM72 272a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm104-16H304c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16zM72 368a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm88 0c0-8.8 7.2-16 16-16H304c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16z"
    ]
};
var $d8206b3ab2e65c05$export$37396c36c76937bc = {
    prefix: "fas",
    iconName: "truck-ramp-box",
    icon: [
        640,
        512,
        [
            "truck-loading"
        ],
        "f4de",
        "M640 0V400c0 61.9-50.1 112-112 112c-61 0-110.5-48.7-112-109.3L48.4 502.9c-17.1 4.6-34.6-5.4-39.3-22.5s5.4-34.6 22.5-39.3L352 353.8V64c0-35.3 28.7-64 64-64H640zM576 400a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM23.1 207.7c-4.6-17.1 5.6-34.6 22.6-39.2l46.4-12.4 20.7 77.3c2.3 8.5 11.1 13.6 19.6 11.3l30.9-8.3c8.5-2.3 13.6-11.1 11.3-19.6l-20.7-77.3 46.4-12.4c17.1-4.6 34.6 5.6 39.2 22.6l41.4 154.5c4.6 17.1-5.6 34.6-22.6 39.2L103.7 384.9c-17.1 4.6-34.6-5.6-39.2-22.6L23.1 207.7z"
    ]
};
var $d8206b3ab2e65c05$export$f00c152db7d44638 = $d8206b3ab2e65c05$export$37396c36c76937bc;
var $d8206b3ab2e65c05$export$76de2a120043c9f8 = {
    prefix: "fas",
    iconName: "user-check",
    icon: [
        640,
        512,
        [],
        "f4fc",
        "M96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM0 482.3C0 383.8 79.8 304 178.3 304h91.4C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3zM625 177L497 305c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L591 143c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"
    ]
};
var $d8206b3ab2e65c05$export$a56b2b0a1073620c = {
    prefix: "fas",
    iconName: "vial-virus",
    icon: [
        512,
        512,
        [],
        "e597",
        "M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96V384c0 53 43 96 96 96c28.6 0 54.2-12.5 71.8-32.3c.1-14.2 5.6-28.3 16.4-39.1c.2-.2 .1-.6-.2-.6c-30.9 0-56-25.1-56-56s25.1-56 56-56c.3 0 .4-.4 .2-.6c-21.9-21.9-21.9-57.3 0-79.2c2.4-2.4 5-4.6 7.8-6.5V96c17.7 0 32-14.3 32-32s-14.3-32-32-32H160 96 32zM96 192V96h64v96H96zM216 376c28.8 0 43.2 34.8 22.9 55.2c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0c20.4-20.4 55.2-5.9 55.2 22.9c0 13.3 10.7 24 24 24s24-10.7 24-24c0-28.8 34.8-43.2 55.2-22.9c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9C444.8 410.8 459.2 376 488 376c13.3 0 24-10.7 24-24s-10.7-24-24-24c-28.8 0-43.2-34.8-22.9-55.2c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0C410.8 259.2 376 244.8 376 216c0-13.3-10.7-24-24-24s-24 10.7-24 24c0 28.8-34.8 43.2-55.2 22.9c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9c20.4 20.4 5.9 55.2-22.9 55.2c-13.3 0-24 10.7-24 24s10.7 24 24 24zm104-88a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm40 96a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"
    ]
};
var $d8206b3ab2e65c05$export$57f2bcd070bff91a = {
    prefix: "fas",
    iconName: "sheet-plastic",
    icon: [
        384,
        512,
        [],
        "e571",
        "M0 448c0 35.3 28.7 64 64 64H224V384c0-17.7 14.3-32 32-32H384V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V448zM171.3 75.3l-96 96c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l96-96c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zm96 32l-160 160c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l160-160c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zM384 384H256V512L384 384z"
    ]
};
var $d8206b3ab2e65c05$export$890d5e011054935a = {
    prefix: "fas",
    iconName: "blog",
    icon: [
        512,
        512,
        [],
        "f781",
        "M192 32c0 17.7 14.3 32 32 32c123.7 0 224 100.3 224 224c0 17.7 14.3 32 32 32s32-14.3 32-32C512 128.9 383.1 0 224 0c-17.7 0-32 14.3-32 32zm0 96c0 17.7 14.3 32 32 32c70.7 0 128 57.3 128 128c0 17.7 14.3 32 32 32s32-14.3 32-32c0-106-86-192-192-192c-17.7 0-32 14.3-32 32zM96 144c0-26.5-21.5-48-48-48S0 117.5 0 144V368c0 79.5 64.5 144 144 144s144-64.5 144-144s-64.5-144-144-144H128v96h16c26.5 0 48 21.5 48 48s-21.5 48-48 48s-48-21.5-48-48V144z"
    ]
};
var $d8206b3ab2e65c05$export$a9174995732e03c5 = {
    prefix: "fas",
    iconName: "user-ninja",
    icon: [
        448,
        512,
        [
            129399
        ],
        "f504",
        "M224 256c-57.2 0-105.6-37.5-122-89.3c-1.1 1.3-2.2 2.6-3.5 3.8c-15.8 15.8-38.8 20.7-53.6 22.1c-8.1 .8-14.6-5.7-13.8-13.8c1.4-14.7 6.3-37.8 22.1-53.6c5.8-5.8 12.6-10.1 19.6-13.4c-7-3.2-13.8-7.6-19.6-13.4C37.4 82.7 32.6 59.7 31.1 44.9c-.8-8.1 5.7-14.6 13.8-13.8c14.7 1.4 37.8 6.3 53.6 22.1c4.8 4.8 8.7 10.4 11.7 16.1C131.4 28.2 174.4 0 224 0c70.7 0 128 57.3 128 128s-57.3 128-128 128zM0 482.3C0 399.5 56.4 330 132.8 309.9c6-1.6 12.2 .9 15.9 5.8l62.5 83.3c6.4 8.5 19.2 8.5 25.6 0l62.5-83.3c3.7-4.9 9.9-7.4 15.9-5.8C391.6 330 448 399.5 448 482.3c0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3zM160 96c-8.8 0-16 7.2-16 16s7.2 16 16 16H288c8.8 0 16-7.2 16-16s-7.2-16-16-16H160z"
    ]
};
var $d8206b3ab2e65c05$export$5709329dd2b70bdc = {
    prefix: "fas",
    iconName: "person-arrow-up-from-line",
    icon: [
        640,
        512,
        [],
        "e539",
        "M192 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-8 352V352h16v96H184zm-64 0H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H152h80H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H264V256.9l28.6 47.5c9.1 15.1 28.8 20 43.9 10.9s20-28.8 10.9-43.9l-58.3-97c-17.4-28.9-48.6-46.6-82.3-46.6H177.1c-33.7 0-64.9 17.7-82.3 46.6l-58.3 97c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9L120 256.9V448zM598.6 121.4l-80-80c-12.5-12.5-32.8-12.5-45.3 0l-80 80c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L464 141.3 464 384c0 17.7 14.3 32 32 32s32-14.3 32-32V141.3l25.4 25.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3z"
    ]
};
var $d8206b3ab2e65c05$export$4e3fe5b42a6cd494 = {
    prefix: "fas",
    iconName: "scroll-torah",
    icon: [
        640,
        512,
        [
            "torah"
        ],
        "f6a0",
        "M96 480V32C96 14.3 74.5 0 48 0S0 14.3 0 32V480c0 17.7 21.5 32 48 32s48-14.3 48-32zM512 32H128V480H512V32zM592 0c-26.5 0-48 14.3-48 32V480c0 17.7 21.5 32 48 32s48-14.3 48-32V32c0-17.7-21.5-32-48-32zM196 313.7c0-3.2 .9-6.4 2.5-9.2L226.7 256l-28.3-48.5c-1.6-2.8-2.5-6-2.5-9.2c0-10.1 8.2-18.3 18.3-18.3H271l31.4-53.9c3.6-6.3 10.3-10.1 17.6-10.1s13.9 3.8 17.6 10.1L369 180h56.7c10.1 0 18.3 8.2 18.3 18.3c0 3.2-.9 6.4-2.5 9.2L413.3 256l28.3 48.5c1.6 2.8 2.5 6 2.5 9.2c0 10.1-8.2 18.3-18.3 18.3H369l-31.4 53.9c-3.6 6.3-10.3 10.1-17.6 10.1s-13.9-3.8-17.6-10.1L271 332H214.3c-10.1 0-18.3-8.2-18.3-18.3zm124 54.7L341.2 332H298.8L320 368.4zM254.5 256l30.3 52h70.4l30.3-52-30.3-52H284.8l-30.3 52zm144.9 23.8L383 308h32.8l-16.4-28.2zM415.8 204H383l16.4 28.2L415.8 204zM320 143.6L298.8 180h42.4L320 143.6zM224.2 204l16.4 28.2L257 204H224.2zM257 308l-16.4-28.2L224.2 308H257z"
    ]
};
var $d8206b3ab2e65c05$export$54d07baabd8c2acb = $d8206b3ab2e65c05$export$4e3fe5b42a6cd494;
var $d8206b3ab2e65c05$export$3e1327487ce53231 = {
    prefix: "fas",
    iconName: "broom-ball",
    icon: [
        576,
        512,
        [
            "quidditch",
            "quidditch-broom-ball"
        ],
        "f458",
        "M566.6 9.4c12.5 12.5 12.5 32.8 0 45.3l-192 192 34.7 34.7c4.2 4.2 6.6 10 6.6 16c0 12.5-10.1 22.6-22.6 22.6H364.3L256 211.7V182.6c0-12.5 10.1-22.6 22.6-22.6c6 0 11.8 2.4 16 6.6l34.7 34.7 192-192c12.5-12.5 32.8-12.5 45.3 0zm-344 225.5L341.1 353.4c3.7 42.7-11.7 85.2-42.3 115.8C271.4 496.6 234.2 512 195.5 512L22.1 512C9.9 512 0 502.1 0 489.9c0-6.3 2.7-12.3 7.3-16.5L133.7 359.7c4.2-3.7-.4-10.4-5.4-7.9L77.2 377.4c-6.1 3-13.2-1.4-13.2-8.2c0-31.5 12.5-61.7 34.8-84l8-8c30.6-30.6 73.1-45.9 115.8-42.3zM464 352a80 80 0 1 1 0 160 80 80 0 1 1 0-160z"
    ]
};
var $d8206b3ab2e65c05$export$c00c446e6db1605f = $d8206b3ab2e65c05$export$3e1327487ce53231;
var $d8206b3ab2e65c05$export$791bfe29b97b4d42 = $d8206b3ab2e65c05$export$3e1327487ce53231;
var $d8206b3ab2e65c05$export$d20aaceb882ca545 = {
    prefix: "fas",
    iconName: "toggle-off",
    icon: [
        576,
        512,
        [],
        "f204",
        "M384 128c70.7 0 128 57.3 128 128s-57.3 128-128 128H192c-70.7 0-128-57.3-128-128s57.3-128 128-128H384zM576 256c0-106-86-192-192-192H192C86 64 0 150 0 256S86 448 192 448H384c106 0 192-86 192-192zM192 352a96 96 0 1 0 0-192 96 96 0 1 0 0 192z"
    ]
};
var $d8206b3ab2e65c05$export$2a0fcb66c3d79d00 = {
    prefix: "fas",
    iconName: "box-archive",
    icon: [
        512,
        512,
        [
            "archive"
        ],
        "f187",
        "M32 32H480c17.7 0 32 14.3 32 32V96c0 17.7-14.3 32-32 32H32C14.3 128 0 113.7 0 96V64C0 46.3 14.3 32 32 32zm0 128H480V416c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V160zm128 80c0 8.8 7.2 16 16 16H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H176c-8.8 0-16 7.2-16 16z"
    ]
};
var $d8206b3ab2e65c05$export$26b3e1c454273f34 = $d8206b3ab2e65c05$export$2a0fcb66c3d79d00;
var $d8206b3ab2e65c05$export$bac321083217fd4 = {
    prefix: "fas",
    iconName: "person-drowning",
    icon: [
        576,
        512,
        [],
        "e545",
        "M192 64c0-17.7-14.3-32-32-32s-32 14.3-32 32V96.2c0 54.1 23.5 104 62.2 138.3l-21 146.7c7.8 2.1 15.5 3.3 22.8 3.3c21.1 0 42-8.5 59.2-20.3c22.1-15.5 51.6-15.5 73.7 0c12.4 8.5 26.1 14.8 39.7 18l17.7-97.6c10.7-1.2 21.3-3.1 31.9-5.5l105-23.9c17.2-3.9 28-21.1 24.1-38.3s-21.1-28-38.3-24.1L400 216.6c-41 9.3-83.7 7.5-123.7-5.2c-50.2-16-84.3-62.6-84.3-115.3V64zM320 192a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM306.5 389.9c-11.1-7.9-25.9-7.9-37 0C247 405.4 219.5 416 192 416c-26.9 0-55.3-10.8-77.4-26.1l0 0c-11.9-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C126.5 469.7 159 480 192 480c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.4-27.3-10.1-39.2-1.7l0 0C439.4 405.2 410.9 416 384 416c-27.5 0-55-10.6-77.5-26.1z"
    ]
};
var $d8206b3ab2e65c05$export$6cc91ce23eb3fae1 = {
    prefix: "fas",
    iconName: "arrow-down-9-1",
    icon: [
        576,
        512,
        [
            "sort-numeric-desc",
            "sort-numeric-down-alt"
        ],
        "f886",
        "M160 480c9 0 17.5-3.8 23.6-10.4l88-96c11.9-13 11.1-33.3-2-45.2s-33.3-11.1-45.2 2L192 365.7V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V365.7L95.6 330.4c-11.9-13-32.2-13.9-45.2-2s-13.9 32.2-2 45.2l88 96C142.5 476.2 151 480 160 480zM450.7 294c-8.3-6-19.1-7.7-28.8-4.4l-48 16c-16.8 5.6-25.8 23.7-20.2 40.5s23.7 25.8 40.5 20.2l5.9-2V416H384c-17.7 0-32 14.3-32 32s14.3 32 32 32h48 48c17.7 0 32-14.3 32-32s-14.3-32-32-32H464V320c0-10.3-4.9-19.9-13.3-26zM418.3 91a32 32 0 1 1 27.4 57.9A32 32 0 1 1 418.3 91zM405.1 203.8l-6.8 9.2c-10.5 14.2-7.5 34.2 6.7 44.8s34.2 7.5 44.8-6.7l48.8-65.8c14-18.9 21.5-41.7 21.5-65.2c0-48.6-39.4-88-88-88s-88 39.4-88 88c0 39.2 25.6 72.4 61.1 83.8z"
    ]
};
var $d8206b3ab2e65c05$export$99f058110e2c82a8 = $d8206b3ab2e65c05$export$6cc91ce23eb3fae1;
var $d8206b3ab2e65c05$export$857385fda7a5a98e = $d8206b3ab2e65c05$export$6cc91ce23eb3fae1;
var $d8206b3ab2e65c05$export$8eee2c17ff89e724 = {
    prefix: "fas",
    iconName: "face-grin-tongue-squint",
    icon: [
        512,
        512,
        [
            128541,
            "grin-tongue-squint"
        ],
        "f58a",
        "M0 256C0 368.9 73.1 464.7 174.5 498.8C165.3 484 160 466.6 160 448V400.7c-24-17.5-43.1-41.4-54.8-69.2c-5-11.8 7-22.5 19.3-18.7c39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19c12.3-3.8 24.3 6.9 19.3 18.7c-11.8 28-31.1 52-55.4 69.6V448c0 18.6-5.3 36-14.5 50.8C438.9 464.7 512 368.9 512 256C512 114.6 397.4 0 256 0S0 114.6 0 256zM116 141.1c0-9 9.6-14.7 17.5-10.5l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5c0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6zm262.5-10.5c7.9-4.2 17.5 1.5 17.5 10.5c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6c0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9zM320 448V402.6c0-14.7-11.9-26.6-26.6-26.6h-2c-11.3 0-21.1 7.9-23.6 18.9c-2.8 12.6-20.8 12.6-23.6 0c-2.5-11.1-12.3-18.9-23.6-18.9h-2c-14.7 0-26.6 11.9-26.6 26.6V448c0 35.3 28.7 64 64 64s64-28.7 64-64z"
    ]
};
var $d8206b3ab2e65c05$export$4edf34c3def09a31 = $d8206b3ab2e65c05$export$8eee2c17ff89e724;
var $d8206b3ab2e65c05$export$4952c502f544cf85 = {
    prefix: "fas",
    iconName: "spray-can",
    icon: [
        512,
        512,
        [],
        "f5bd",
        "M128 0h64c17.7 0 32 14.3 32 32v96H96V32c0-17.7 14.3-32 32-32zM0 256c0-53 43-96 96-96H224c53 0 96 43 96 96V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V256zm240 80A80 80 0 1 0 80 336a80 80 0 1 0 160 0zM256 64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM384 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm64 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM448 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM384 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $d8206b3ab2e65c05$export$24b8a0147653649a = {
    prefix: "fas",
    iconName: "truck-monster",
    icon: [
        640,
        512,
        [],
        "f63b",
        "M288 64v64H416L368 64H288zM419.2 25.6L496 128h80c17.7 0 32 14.3 32 32v64c17.7 0 32 14.3 32 32s-14.3 32-32 32c-29.2-38.9-75.7-64-128-64s-98.8 25.1-128 64H288c-29.2-38.9-75.7-64-128-64s-98.8 25.1-128 64c-17.7 0-32-14.3-32-32s14.3-32 32-32V160c0-17.7 14.3-32 32-32H224V48c0-26.5 21.5-48 48-48h96c20.1 0 39.1 9.5 51.2 25.6zM152 256h16c12.1 0 22.1 8.9 23.8 20.6c7.6 2.2 14.9 5.3 21.7 9c9.4-7 22.8-6.3 31.3 2.3l11.3 11.3c8.6 8.6 9.3 21.9 2.3 31.3c3.7 6.8 6.8 14.1 9 21.7c11.6 1.7 20.6 11.7 20.6 23.8v16c0 12.1-8.9 22.1-20.6 23.8c-2.2 7.6-5.3 14.9-9 21.7c7 9.4 6.3 22.8-2.3 31.3l-11.3 11.3c-8.6 8.6-21.9 9.3-31.3 2.2c-6.8 3.7-14.1 6.8-21.7 9C190.1 503.1 180.1 512 168 512H152c-12.1 0-22.1-8.9-23.8-20.6c-7.6-2.2-14.9-5.3-21.7-9c-9.4 7.1-22.8 6.3-31.3-2.2L63.8 468.9c-8.6-8.6-9.3-21.9-2.3-31.3c-3.7-6.9-6.8-14.1-9-21.8C40.9 414.1 32 404.1 32 392V376c0-12.1 8.9-22.1 20.6-23.8c2.2-7.6 5.3-14.9 9-21.8c-7-9.4-6.3-22.8 2.3-31.3l11.3-11.3c8.6-8.6 21.9-9.3 31.3-2.3c6.8-3.7 14.1-6.8 21.7-9c1.7-11.6 11.7-20.6 23.8-20.6zm8 176a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM448.2 276.6c1.7-11.6 11.7-20.6 23.8-20.6h16c12.1 0 22.1 8.9 23.8 20.6c7.6 2.2 14.9 5.3 21.8 9c9.4-7 22.8-6.3 31.3 2.3l11.3 11.3c8.6 8.6 9.3 21.9 2.2 31.3c3.7 6.8 6.8 14.1 9 21.7c11.6 1.7 20.6 11.7 20.6 23.8v16c0 12.1-8.9 22.1-20.6 23.8c-2.2 7.6-5.3 14.9-9 21.7c7 9.4 6.3 22.8-2.2 31.3l-11.3 11.3c-8.6 8.6-21.9 9.3-31.3 2.2c-6.9 3.7-14.1 6.8-21.8 9C510.1 503.1 500.1 512 488 512H472c-12.1 0-22.1-8.9-23.8-20.6c-7.6-2.2-14.9-5.3-21.7-9c-9.4 7.1-22.8 6.3-31.3-2.2l-11.3-11.3c-8.6-8.6-9.3-21.9-2.2-31.3c-3.7-6.9-6.8-14.1-9-21.8C360.9 414.1 352 404.1 352 392V376c0-12.1 8.9-22.1 20.6-23.8c2.2-7.6 5.3-14.9 9-21.8c-7-9.4-6.3-22.8 2.2-31.3l11.3-11.3c8.6-8.6 21.9-9.3 31.3-2.3c6.8-3.7 14.1-6.8 21.7-9zM528 384a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"
    ]
};
var $d8206b3ab2e65c05$export$c7f24bdea332f90a = {
    prefix: "fas",
    iconName: "w",
    icon: [
        576,
        512,
        [
            119
        ],
        "57",
        "M20.8 34c16.5-6.2 35 2.2 41.2 18.7l110.2 294L257.3 55c4-13.7 16.5-23 30.7-23s26.7 9.4 30.7 23l85.1 291.7L514 52.8c6.2-16.5 24.6-24.9 41.2-18.7s24.9 24.7 18.7 41.2l-144 384c-4.8 12.9-17.4 21.3-31.2 20.7s-25.7-9.8-29.5-23L288 178.3 206.7 457c-3.9 13.2-15.8 22.5-29.5 23s-26.3-7.8-31.2-20.7L2 75.2C-4.2 58.7 4.2 40.2 20.8 34z"
    ]
};
var $d8206b3ab2e65c05$export$11afa141d42099d0 = {
    prefix: "fas",
    iconName: "earth-africa",
    icon: [
        512,
        512,
        [
            127757,
            "globe-africa"
        ],
        "f57c",
        "M177.8 63.2l10 17.4c2.8 4.8 4.2 10.3 4.2 15.9v41.4c0 3.9 1.6 7.7 4.3 10.4c6.2 6.2 16.5 5.7 22-1.2l13.6-17c4.7-5.9 12.9-7.7 19.6-4.3l15.2 7.6c3.4 1.7 7.2 2.6 11 2.6c6.5 0 12.8-2.6 17.4-7.2l3.9-3.9c2.9-2.9 7.3-3.6 11-1.8l29.2 14.6c7.8 3.9 12.6 11.8 12.6 20.5c0 10.5-7.1 19.6-17.3 22.2l-35.4 8.8c-7.4 1.8-15.1 1.5-22.4-.9l-32-10.7c-3.3-1.1-6.7-1.7-10.2-1.7c-7 0-13.8 2.3-19.4 6.5L176 212c-10.1 7.6-16 19.4-16 32v28c0 26.5 21.5 48 48 48h32c8.8 0 16 7.2 16 16v48c0 17.7 14.3 32 32 32c10.1 0 19.6-4.7 25.6-12.8l25.6-34.1c8.3-11.1 12.8-24.6 12.8-38.4V318.6c0-3.9 2.6-7.3 6.4-8.2l5.3-1.3c11.9-3 20.3-13.7 20.3-26c0-7.1-2.8-13.9-7.8-18.9l-33.5-33.5c-3.7-3.7-3.7-9.7 0-13.4c5.7-5.7 14.1-7.7 21.8-5.1l14.1 4.7c12.3 4.1 25.7-1.5 31.5-13c3.5-7 11.2-10.8 18.9-9.2l27.4 5.5C432 112.4 351.5 48 256 48c-27.7 0-54 5.4-78.2 15.2zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"
    ]
};
var $d8206b3ab2e65c05$export$64af36f3b403a57c = $d8206b3ab2e65c05$export$11afa141d42099d0;
var $d8206b3ab2e65c05$export$92ab27739d3a91b2 = {
    prefix: "fas",
    iconName: "rainbow",
    icon: [
        640,
        512,
        [
            127752
        ],
        "f75b",
        "M320 96C178.6 96 64 210.6 64 352v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V352C0 175.3 143.3 32 320 32s320 143.3 320 320v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V352C576 210.6 461.4 96 320 96zm0 192c-35.3 0-64 28.7-64 64v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V352c0-70.7 57.3-128 128-128s128 57.3 128 128v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V352c0-35.3-28.7-64-64-64zM160 352v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V352c0-123.7 100.3-224 224-224s224 100.3 224 224v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V352c0-88.4-71.6-160-160-160s-160 71.6-160 160z"
    ]
};
var $d8206b3ab2e65c05$export$9429fd8df55155d = {
    prefix: "fas",
    iconName: "circle-notch",
    icon: [
        512,
        512,
        [],
        "f1ce",
        "M222.7 32.1c5 16.9-4.6 34.8-21.5 39.8C121.8 95.6 64 169.1 64 256c0 106 86 192 192 192s192-86 192-192c0-86.9-57.8-160.4-137.1-184.1c-16.9-5-26.6-22.9-21.5-39.8s22.9-26.6 39.8-21.5C434.9 42.1 512 140 512 256c0 141.4-114.6 256-256 256S0 397.4 0 256C0 140 77.1 42.1 182.9 10.6c16.9-5 34.8 4.6 39.8 21.5z"
    ]
};
var $d8206b3ab2e65c05$export$df1e253fc358ade4 = {
    prefix: "fas",
    iconName: "tablet-screen-button",
    icon: [
        448,
        512,
        [
            "tablet-alt"
        ],
        "f3fa",
        "M0 64C0 28.7 28.7 0 64 0H384c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM256 448a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM384 64H64V384H384V64z"
    ]
};
var $d8206b3ab2e65c05$export$db0cac088255eacc = $d8206b3ab2e65c05$export$df1e253fc358ade4;
var $d8206b3ab2e65c05$export$7bc6e4d977673e69 = {
    prefix: "fas",
    iconName: "paw",
    icon: [
        512,
        512,
        [],
        "f1b0",
        "M226.5 92.9c14.3 42.9-.3 86.2-32.6 96.8s-70.1-15.6-84.4-58.5s.3-86.2 32.6-96.8s70.1 15.6 84.4 58.5zM100.4 198.6c18.9 32.4 14.3 70.1-10.2 84.1s-59.7-.9-78.5-33.3S-2.7 179.3 21.8 165.3s59.7 .9 78.5 33.3zM69.2 401.2C121.6 259.9 214.7 224 256 224s134.4 35.9 186.8 177.2c3.6 9.7 5.2 20.1 5.2 30.5v1.6c0 25.8-20.9 46.7-46.7 46.7c-11.5 0-22.9-1.4-34-4.2l-88-22c-15.3-3.8-31.3-3.8-46.6 0l-88 22c-11.1 2.8-22.5 4.2-34 4.2C84.9 480 64 459.1 64 433.3v-1.6c0-10.4 1.6-20.8 5.2-30.5zM421.8 282.7c-24.5-14-29.1-51.7-10.2-84.1s54-47.3 78.5-33.3s29.1 51.7 10.2 84.1s-54 47.3-78.5 33.3zM310.1 189.7c-32.3-10.6-46.9-53.9-32.6-96.8s52.1-69.1 84.4-58.5s46.9 53.9 32.6 96.8s-52.1 69.1-84.4 58.5z"
    ]
};
var $d8206b3ab2e65c05$export$8bb3c4d5c2f50243 = {
    prefix: "fas",
    iconName: "cloud",
    icon: [
        640,
        512,
        [
            9729
        ],
        "f0c2",
        "M0 336c0 79.5 64.5 144 144 144H512c70.7 0 128-57.3 128-128c0-61.9-44-113.6-102.4-125.4c4.1-10.7 6.4-22.4 6.4-34.6c0-53-43-96-96-96c-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32C167.6 32 96 103.6 96 192c0 2.7 .1 5.4 .2 8.1C40.2 219.8 0 273.2 0 336z"
    ]
};
var $d8206b3ab2e65c05$export$b6c20c10ddbd9898 = {
    prefix: "fas",
    iconName: "trowel-bricks",
    icon: [
        512,
        512,
        [],
        "e58a",
        "M240.8 4.8C250.3 10.6 256 20.9 256 32v72h89c3.6-13.8 16.1-24 31-24h88c26.5 0 48 21.5 48 48s-21.5 48-48 48H376c-14.9 0-27.4-10.2-31-24H256v72c0 11.1-5.7 21.4-15.2 27.2s-21.2 6.4-31.1 1.4l-192-96C6.8 151.2 0 140.1 0 128s6.8-23.2 17.7-28.6l192-96c9.9-5 21.7-4.4 31.1 1.4zM288 256c0-17.7 14.3-32 32-32H480c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H320c-17.7 0-32-14.3-32-32V256zM32 384h96c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V416c0-17.7 14.3-32 32-32zm192 0H480c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H224c-17.7 0-32-14.3-32-32V416c0-17.7 14.3-32 32-32z"
    ]
};
var $d8206b3ab2e65c05$export$ba5dc4287853ecbd = {
    prefix: "fas",
    iconName: "face-flushed",
    icon: [
        512,
        512,
        [
            128563,
            "flushed"
        ],
        "f579",
        "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM176 384c0 8.8 7.2 16 16 16H320c8.8 0 16-7.2 16-16s-7.2-16-16-16H192c-8.8 0-16 7.2-16 16zm-16-88a72 72 0 1 0 0-144 72 72 0 1 0 0 144zm264-72a72 72 0 1 0 -144 0 72 72 0 1 0 144 0zm-288 0a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm192 0a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"
    ]
};
var $d8206b3ab2e65c05$export$dfd2bd012685aeac = $d8206b3ab2e65c05$export$ba5dc4287853ecbd;
var $d8206b3ab2e65c05$export$684703c93d630cc5 = {
    prefix: "fas",
    iconName: "hospital-user",
    icon: [
        576,
        512,
        [],
        "f80d",
        "M48 0C21.5 0 0 21.5 0 48V256H144c8.8 0 16 7.2 16 16s-7.2 16-16 16H0v64H144c8.8 0 16 7.2 16 16s-7.2 16-16 16H0v80c0 26.5 21.5 48 48 48H265.9c-6.3-10.2-9.9-22.2-9.9-35.1c0-46.9 25.8-87.8 64-109.2V271.8 48c0-26.5-21.5-48-48-48H48zM152 64h16c8.8 0 16 7.2 16 16v24h24c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H184v24c0 8.8-7.2 16-16 16H152c-8.8 0-16-7.2-16-16V152H112c-8.8 0-16-7.2-16-16V120c0-8.8 7.2-16 16-16h24V80c0-8.8 7.2-16 16-16zM512 272a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM288 477.1c0 19.3 15.6 34.9 34.9 34.9H541.1c19.3 0 34.9-15.6 34.9-34.9c0-51.4-41.7-93.1-93.1-93.1H381.1c-51.4 0-93.1 41.7-93.1 93.1z"
    ]
};
var $d8206b3ab2e65c05$export$fa95eb7418c0e2b8 = {
    prefix: "fas",
    iconName: "tent-arrow-left-right",
    icon: [
        576,
        512,
        [],
        "e57f",
        "M488.1 6.2c-9.9-8.9-25-8.1-33.9 1.8s-8.1 25 1.8 33.9L489.5 72 86.5 72l33.5-30.2c9.9-8.9 10.7-24 1.8-33.9S97.8-2.7 87.9 6.2l-80 72C2.9 82.7 0 89.2 0 96s2.9 13.3 7.9 17.8l80 72c9.9 8.9 25 8.1 33.9-1.8s8.1-25-1.8-33.9L86.5 120l402.9 0-33.5 30.2c-9.9 8.9-10.7 24-1.8 33.9s24 10.7 33.9 1.8l80-72c5.1-4.6 7.9-11 7.9-17.8s-2.9-13.3-7.9-17.8l-80-72zM307.4 166.5c-11.5-8.7-27.3-8.7-38.8 0l-168 128c-6.6 5-11 12.5-12.3 20.7l-24 160c-1.4 9.2 1.3 18.6 7.4 25.6S86.7 512 96 512H240h16c17.7 0 32-14.3 32-32V361.9c0-5.5 4.4-9.9 9.9-9.9c3.7 0 7.2 2.1 8.8 5.5l68.4 136.8c5.4 10.8 16.5 17.7 28.6 17.7H464h16c9.3 0 18.2-4.1 24.2-11.1s8.8-16.4 7.4-25.6l-24-160c-1.2-8.2-5.6-15.7-12.3-20.7l-168-128z"
    ]
};
var $d8206b3ab2e65c05$export$c36fb40057e2c3aa = {
    prefix: "fas",
    iconName: "gavel",
    icon: [
        512,
        512,
        [
            "legal"
        ],
        "f0e3",
        "M318.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-120 120c-12.5 12.5-12.5 32.8 0 45.3l16 16c12.5 12.5 32.8 12.5 45.3 0l4-4L325.4 293.4l-4 4c-12.5 12.5-12.5 32.8 0 45.3l16 16c12.5 12.5 32.8 12.5 45.3 0l120-120c12.5-12.5 12.5-32.8 0-45.3l-16-16c-12.5-12.5-32.8-12.5-45.3 0l-4 4L330.6 74.6l4-4c12.5-12.5 12.5-32.8 0-45.3l-16-16zm-152 288c-12.5-12.5-32.8-12.5-45.3 0l-112 112c-12.5 12.5-12.5 32.8 0 45.3l48 48c12.5 12.5 32.8 12.5 45.3 0l112-112c12.5-12.5 12.5-32.8 0-45.3l-1.4-1.4L272 285.3 226.7 240 168 298.7l-1.4-1.4z"
    ]
};
var $d8206b3ab2e65c05$export$59d593c2dacb3781 = $d8206b3ab2e65c05$export$c36fb40057e2c3aa;
var $d8206b3ab2e65c05$export$8a910017964bb8c2 = {
    prefix: "fas",
    iconName: "binoculars",
    icon: [
        512,
        512,
        [],
        "f1e5",
        "M128 32h32c17.7 0 32 14.3 32 32V96H96V64c0-17.7 14.3-32 32-32zm64 96V448c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V388.9c0-34.6 9.4-68.6 27.2-98.3C40.9 267.8 49.7 242.4 53 216L60.5 156c2-16 15.6-28 31.8-28H192zm227.8 0c16.1 0 29.8 12 31.8 28L459 216c3.3 26.4 12.1 51.8 25.8 74.6c17.8 29.7 27.2 63.7 27.2 98.3V448c0 17.7-14.3 32-32 32H352c-17.7 0-32-14.3-32-32V128h99.8zM320 64c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32V96H320V64zm-32 64V288H224V128h64z"
    ]
};
var $d8206b3ab2e65c05$export$843f63d64e6f7951 = {
    prefix: "fas",
    iconName: "microphone-slash",
    icon: [
        640,
        512,
        [],
        "f131",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L472.1 344.7c15.2-26 23.9-56.3 23.9-88.7V216c0-13.3-10.7-24-24-24s-24 10.7-24 24v40c0 21.2-5.1 41.1-14.2 58.7L416 300.8V96c0-53-43-96-96-96s-96 43-96 96v54.3L38.8 5.1zm362.5 407l-43.1-33.9C346.1 382 333.3 384 320 384c-70.7 0-128-57.3-128-128v-8.7L144.7 210c-.5 1.9-.7 3.9-.7 6v40c0 89.1 66.2 162.7 152 174.4V464H248c-13.3 0-24 10.7-24 24s10.7 24 24 24h72 72c13.3 0 24-10.7 24-24s-10.7-24-24-24H344V430.4c20.4-2.8 39.7-9.1 57.3-18.2z"
    ]
};
var $d8206b3ab2e65c05$export$f2adc06617bc0c7 = {
    prefix: "fas",
    iconName: "box-tissue",
    icon: [
        512,
        512,
        [],
        "e05b",
        "M92.5 0H208c40 0 52 24 64 48s24 48 64 48h85.2C436 96 448 108 448 122.8c0 3.4-.7 6.8-1.9 10L409.6 224 384 288H128l-16-64L64.9 35.4c-.6-2.3-.9-4.6-.9-6.9C64 12.8 76.8 0 92.5 0zM79 224l16 64H80c-8.8 0-16 7.2-16 16s7.2 16 16 16h48H384h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H418.5l25.6-64H464c26.5 0 48 21.5 48 48V384H0V272c0-26.5 21.5-48 48-48H79zM0 416H512v48c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V416z"
    ]
};
var $d8206b3ab2e65c05$export$f26017bdca99338d = {
    prefix: "fas",
    iconName: "motorcycle",
    icon: [
        640,
        512,
        [
            127949
        ],
        "f21c",
        "M280 32c-13.3 0-24 10.7-24 24s10.7 24 24 24h57.7l16.4 30.3L256 192l-45.3-45.3c-12-12-28.3-18.7-45.3-18.7H64c-17.7 0-32 14.3-32 32v32h96c88.4 0 160 71.6 160 160c0 11-1.1 21.7-3.2 32h70.4c-2.1-10.3-3.2-21-3.2-32c0-52.2 25-98.6 63.7-127.8l15.4 28.6C402.4 276.3 384 312 384 352c0 70.7 57.3 128 128 128s128-57.3 128-128s-57.3-128-128-128c-13.5 0-26.5 2.1-38.7 6L418.2 128H480c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H459.6c-7.5 0-14.7 2.6-20.5 7.4L391.7 78.9l-14-26c-7-12.9-20.5-21-35.2-21H280zM462.7 311.2l28.2 52.2c6.3 11.7 20.9 16 32.5 9.7s16-20.9 9.7-32.5l-28.2-52.2c2.3-.3 4.7-.4 7.1-.4c35.3 0 64 28.7 64 64s-28.7 64-64 64s-64-28.7-64-64c0-15.5 5.5-29.7 14.7-40.8zM187.3 376c-9.5 23.5-32.5 40-59.3 40c-35.3 0-64-28.7-64-64s28.7-64 64-64c26.9 0 49.9 16.5 59.3 40h66.4C242.5 268.8 190.5 224 128 224C57.3 224 0 281.3 0 352s57.3 128 128 128c62.5 0 114.5-44.8 125.8-104H187.3zM128 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
var $d8206b3ab2e65c05$export$e433538b78718fb3 = {
    prefix: "fas",
    iconName: "bell-concierge",
    icon: [
        512,
        512,
        [
            128718,
            "concierge-bell"
        ],
        "f562",
        "M216 64c-13.3 0-24 10.7-24 24s10.7 24 24 24h16v33.3C119.6 157.2 32 252.4 32 368H480c0-115.6-87.6-210.8-200-222.7V112h16c13.3 0 24-10.7 24-24s-10.7-24-24-24H256 216zM24 400c-13.3 0-24 10.7-24 24s10.7 24 24 24H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H24z"
    ]
};
var $d8206b3ab2e65c05$export$ad92ffbbfbc0fcf3 = $d8206b3ab2e65c05$export$e433538b78718fb3;
var $d8206b3ab2e65c05$export$85ba06027671d290 = {
    prefix: "fas",
    iconName: "pen-ruler",
    icon: [
        512,
        512,
        [
            "pencil-ruler"
        ],
        "f5ae",
        "M469.3 19.3l23.4 23.4c25 25 25 65.5 0 90.5l-56.4 56.4L322.3 75.7l56.4-56.4c25-25 65.5-25 90.5 0zM44.9 353.2L299.7 98.3 413.7 212.3 158.8 467.1c-6.7 6.7-15.1 11.6-24.2 14.2l-104 29.7c-8.4 2.4-17.4 .1-23.6-6.1s-8.5-15.2-6.1-23.6l29.7-104c2.6-9.2 7.5-17.5 14.2-24.2zM249.4 103.4L103.4 249.4 16 161.9c-18.7-18.7-18.7-49.1 0-67.9L94.1 16c18.7-18.7 49.1-18.7 67.9 0l19.8 19.8c-.3 .3-.7 .6-1 .9l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l64-64c.3-.3 .6-.7 .9-1l45.1 45.1zM408.6 262.6l45.1 45.1c-.3 .3-.7 .6-1 .9l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l64-64c.3-.3 .6-.7 .9-1L496 350.1c18.7 18.7 18.7 49.1 0 67.9L417.9 496c-18.7 18.7-49.1 18.7-67.9 0l-87.4-87.4L408.6 262.6z"
    ]
};
var $d8206b3ab2e65c05$export$e3a7a1affea005f5 = $d8206b3ab2e65c05$export$85ba06027671d290;
var $d8206b3ab2e65c05$export$804bfc5c390e1a2a = {
    prefix: "fas",
    iconName: "people-arrows",
    icon: [
        640,
        512,
        [
            "people-arrows-left-right"
        ],
        "e068",
        "M64 64a64 64 0 1 1 128 0A64 64 0 1 1 64 64zM25.9 233.4C29.3 191.9 64 160 105.6 160h44.8c27 0 51 13.4 65.5 34.1c-2.7 1.9-5.2 4-7.5 6.3l-64 64c-21.9 21.9-21.9 57.3 0 79.2L192 391.2V464c0 26.5-21.5 48-48 48H112c-26.5 0-48-21.5-48-48V348.3c-26.5-9.5-44.7-35.8-42.2-65.6l4.1-49.3zM448 64a64 64 0 1 1 128 0A64 64 0 1 1 448 64zM431.6 200.4c-2.3-2.3-4.9-4.4-7.5-6.3c14.5-20.7 38.6-34.1 65.5-34.1h44.8c41.6 0 76.3 31.9 79.7 73.4l4.1 49.3c2.5 29.8-15.7 56.1-42.2 65.6V464c0 26.5-21.5 48-48 48H496c-26.5 0-48-21.5-48-48V391.2l47.6-47.6c21.9-21.9 21.9-57.3 0-79.2l-64-64zM272 240v32h96V240c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2l64 64c9.4 9.4 9.4 24.6 0 33.9l-64 64c-6.9 6.9-17.2 8.9-26.2 5.2s-14.8-12.5-14.8-22.2V336H272v32c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-64-64c-9.4-9.4-9.4-24.6 0-33.9l64-64c6.9-6.9 17.2-8.9 26.2-5.2s14.8 12.5 14.8 22.2z"
    ]
};
var $d8206b3ab2e65c05$export$da01f044c59e3598 = $d8206b3ab2e65c05$export$804bfc5c390e1a2a;
var $d8206b3ab2e65c05$export$1dc6221efb867885 = {
    prefix: "fas",
    iconName: "mars-and-venus-burst",
    icon: [
        640,
        512,
        [],
        "e523",
        "M504 0c-9.7 0-18.5 5.8-22.2 14.8s-1.7 19.3 5.2 26.2l39 39-22.2 22.2C475.9 78.4 439.6 64 400 64c-88.4 0-160 71.6-160 160c0 80.2 59 146.6 136 158.2V408H352c-13.3 0-24 10.7-24 24s10.7 24 24 24h24v32c0 13.3 10.7 24 24 24s24-10.7 24-24V456h24c13.3 0 24-10.7 24-24s-10.7-24-24-24H424V382.2c77-11.6 136-78 136-158.2c0-31.4-9-60.7-24.7-85.4L560 113.9l39 39c6.9 6.9 17.2 8.9 26.2 5.2s14.8-12.5 14.8-22.2V24c0-13.3-10.7-24-24-24H504zM400 128a96 96 0 1 1 0 192 96 96 0 1 1 0-192zM190.9 18.1C188.4 12 182.6 8 176 8s-12.4 4-14.9 10.1l-29.4 74L55.6 68.9c-6.3-1.9-13.1 .2-17.2 5.3s-4.6 12.2-1.4 17.9l39.5 69.1L10.9 206.4c-5.4 3.7-8 10.3-6.5 16.7s6.7 11.2 13.1 12.2l78.7 12.2L90.6 327c-.5 6.5 3.1 12.7 9 15.5s12.9 1.8 17.8-2.6L176 286.1l58.6 53.9c4.1 3.8 9.9 5.1 15.2 3.6C223.6 310.8 208 269.2 208 224c0-60.8 28.3-115 72.4-150.2L220.3 92.1l-29.4-74z"
    ]
};
var $d8206b3ab2e65c05$export$5b1d41cdd118ea6d = {
    prefix: "fas",
    iconName: "square-caret-right",
    icon: [
        448,
        512,
        [
            "caret-square-right"
        ],
        "f152",
        "M448 96c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320zM320 256c0 6.7-2.8 13-7.7 17.6l-112 104c-7 6.5-17.2 8.2-25.9 4.4s-14.4-12.5-14.4-22l0-208c0-9.5 5.7-18.2 14.4-22s18.9-2.1 25.9 4.4l112 104c4.9 4.5 7.7 10.9 7.7 17.6z"
    ]
};
var $d8206b3ab2e65c05$export$ae86c9de7e0f62fa = $d8206b3ab2e65c05$export$5b1d41cdd118ea6d;
var $d8206b3ab2e65c05$export$b2a906a5928c6404 = {
    prefix: "fas",
    iconName: "scissors",
    icon: [
        512,
        512,
        [
            9984,
            9986,
            9988,
            "cut"
        ],
        "f0c4",
        "M256 192l-39.5-39.5c4.9-12.6 7.5-26.2 7.5-40.5C224 50.1 173.9 0 112 0S0 50.1 0 112s50.1 112 112 112c14.3 0 27.9-2.7 40.5-7.5L192 256l-39.5 39.5c-12.6-4.9-26.2-7.5-40.5-7.5C50.1 288 0 338.1 0 400s50.1 112 112 112s112-50.1 112-112c0-14.3-2.7-27.9-7.5-40.5L499.2 76.8c7.1-7.1 7.1-18.5 0-25.6c-28.3-28.3-74.1-28.3-102.4 0L256 192zm22.6 150.6L396.8 460.8c28.3 28.3 74.1 28.3 102.4 0c7.1-7.1 7.1-18.5 0-25.6L342.6 278.6l-64 64zM64 112a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm48 240a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
    ]
};
var $d8206b3ab2e65c05$export$66847f2a71b260e7 = $d8206b3ab2e65c05$export$b2a906a5928c6404;
var $d8206b3ab2e65c05$export$8db7f2f70484e17e = {
    prefix: "fas",
    iconName: "sun-plant-wilt",
    icon: [
        640,
        512,
        [],
        "e57a",
        "M160 0c-6.3 0-12 3.7-14.6 9.5L120.6 64.9 63.9 43.2c-5.9-2.3-12.6-.8-17 3.6s-5.9 11.1-3.6 17l21.7 56.7L9.5 145.4C3.7 148 0 153.7 0 160s3.7 12 9.5 14.6l55.4 24.8L43.2 256.1c-2.3 5.9-.8 12.6 3.6 17s11.1 5.9 17 3.6l56.7-21.7 24.8 55.4c2.6 5.8 8.3 9.5 14.6 9.5s12-3.7 14.6-9.5l24.8-55.4 56.7 21.7c5.9 2.3 12.6 .8 17-3.6s5.9-11.1 3.6-17l-21.7-56.7 55.4-24.8c5.8-2.6 9.5-8.3 9.5-14.6s-3.7-12-9.5-14.6l-55.4-24.8 21.7-56.7c2.3-5.9 .8-12.6-3.6-17s-11.1-5.9-17-3.6L199.4 64.9 174.6 9.5C172 3.7 166.3 0 160 0zm0 96a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm32 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm312 16c0-17.7 14.3-32 32-32s32 14.3 32 32v53.4c-14.8 7.7-24 23.1-24 44.6c0 16.8 16 44 37.4 67.2c5.8 6.2 15.5 6.2 21.2 0C624 318 640 290.7 640 274c0-21.5-9.2-37-24-44.6V176c0-44.2-35.8-80-80-80s-80 35.8-80 80v22.7c-9.8-4.3-20.6-6.7-32-6.7c-44.2 0-80 35.8-80 80v21.4c-14.8 7.7-24 23.1-24 44.6c0 16.8 16 44 37.4 67.2c5.8 6.2 15.5 6.2 21.2 0C400 382 416 354.7 416 338c0-21.5-9.2-37-24-44.6V272c0-17.7 14.3-32 32-32s32 14.3 32 32v8V448H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H504V280v-8V176z"
    ]
};
var $d8206b3ab2e65c05$export$c00f55f36d386cb7 = {
    prefix: "fas",
    iconName: "toilets-portable",
    icon: [
        576,
        512,
        [],
        "e584",
        "M32 0H224c17.7 0 32 14.3 32 32V64H0V32C0 14.3 14.3 0 32 0zM0 96H24 232h24v24V488c0 13.3-10.7 24-24 24s-24-10.7-24-24v-8H48v8c0 13.3-10.7 24-24 24s-24-10.7-24-24V120 96zM192 224c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V240c0-8.8-7.2-16-16-16zM352 0H544c17.7 0 32 14.3 32 32V64H320V32c0-17.7 14.3-32 32-32zM320 96h24H552h24v24V488c0 13.3-10.7 24-24 24s-24-10.7-24-24v-8H368v8c0 13.3-10.7 24-24 24s-24-10.7-24-24V120 96zM512 224c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V240c0-8.8-7.2-16-16-16z"
    ]
};
var $d8206b3ab2e65c05$export$a274b02dc75663dc = {
    prefix: "fas",
    iconName: "hockey-puck",
    icon: [
        512,
        512,
        [],
        "f453",
        "M256 256C114.6 256 0 213 0 160s114.6-96 256-96s256 43 256 96s-114.6 96-256 96zm192.3 1.8c24.7-9.3 46.9-21 63.7-35.6V352c0 53-114.6 96-256 96S0 405 0 352V222.3c16.8 14.6 39 26.3 63.7 35.6C114.5 276.9 182.5 288 256 288s141.5-11.1 192.3-30.2z"
    ]
};
var $d8206b3ab2e65c05$export$36583f5d3d5a971f = {
    prefix: "fas",
    iconName: "table",
    icon: [
        512,
        512,
        [],
        "f0ce",
        "M64 256V160H224v96H64zm0 64H224v96H64V320zm224 96V320H448v96H288zM448 256H288V160H448v96zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64z"
    ]
};
var $d8206b3ab2e65c05$export$382d3376c7fc7fc5 = {
    prefix: "fas",
    iconName: "magnifying-glass-arrow-right",
    icon: [
        512,
        512,
        [],
        "e521",
        "M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM241 119c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l31 31H120c-13.3 0-24 10.7-24 24s10.7 24 24 24H238.1l-31 31c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l72-72c9.4-9.4 9.4-24.6 0-33.9l-72-72z"
    ]
};
var $d8206b3ab2e65c05$export$73f2bf302381c86a = {
    prefix: "fas",
    iconName: "tachograph-digital",
    icon: [
        640,
        512,
        [
            "digital-tachograph"
        ],
        "f566",
        "M64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H576c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zm32 64H320c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32zM64 368c0-8.8 7.2-16 16-16H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm320 0c0-8.8 7.2-16 16-16H560c8.8 0 16 7.2 16 16s-7.2 16-16 16H400c-8.8 0-16-7.2-16-16zM80 288a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"
    ]
};
var $d8206b3ab2e65c05$export$b3bf1994f0fefe98 = $d8206b3ab2e65c05$export$73f2bf302381c86a;
var $d8206b3ab2e65c05$export$b71a093b86e3da1f = {
    prefix: "fas",
    iconName: "users-slash",
    icon: [
        640,
        512,
        [],
        "e073",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L440.6 320H618.7c11.8 0 21.3-9.6 21.3-21.3C640 239.8 592.2 192 533.3 192H490.7c-15.9 0-31 3.5-44.6 9.7c1.3 7.2 1.9 14.7 1.9 22.3c0 30.2-10.5 58-28 79.9l-25.2-19.7C408.1 267.7 416 246.8 416 224c0-53-43-96-96-96c-31.1 0-58.7 14.8-76.3 37.7l-40.6-31.8c13-14.2 20.9-33.1 20.9-53.9c0-44.2-35.8-80-80-80C116.3 0 91.9 14.1 77.5 35.5L38.8 5.1zM106.7 192C47.8 192 0 239.8 0 298.7C0 310.4 9.6 320 21.3 320H234.7c.2 0 .4 0 .7 0c-20.6-18.2-35.2-42.8-40.8-70.8L121.8 192H106.7zM261.3 352C187.7 352 128 411.7 128 485.3c0 14.7 11.9 26.7 26.7 26.7H485.3c10.5 0 19.5-6 23.9-14.8L324.9 352H261.3zM512 160A80 80 0 1 0 512 0a80 80 0 1 0 0 160z"
    ]
};
var $d8206b3ab2e65c05$export$57813571c0e10a0a = {
    prefix: "fas",
    iconName: "clover",
    icon: [
        448,
        512,
        [],
        "e139",
        "M216.6 49.9C205.1 38.5 189.5 32 173.3 32C139.4 32 112 59.4 112 93.3v4.9c0 12 3.3 23.7 9.4 34l18.8 31.3c1.1 1.8 1.2 3.1 1 4.2c-.2 1.2-.8 2.5-2 3.6s-2.4 1.8-3.6 2c-1 .2-2.4 .1-4.2-1l-31.3-18.8c-10.3-6.2-22-9.4-34-9.4H61.3C27.4 144 0 171.4 0 205.3c0 16.2 6.5 31.8 17.9 43.3l1.2 1.2c3.4 3.4 3.4 9 0 12.4l-1.2 1.2C6.5 274.9 0 290.5 0 306.7C0 340.6 27.4 368 61.3 368h4.9c12 0 23.7-3.3 34-9.4l31.3-18.8c1.8-1.1 3.1-1.2 4.2-1c1.2 .2 2.5 .8 3.6 2s1.8 2.4 2 3.6c.2 1 .1 2.4-1 4.2l-18.8 31.3c-6.2 10.3-9.4 22-9.4 34v4.9c0 33.8 27.4 61.3 61.3 61.3c16.2 0 31.8-6.5 43.3-17.9l1.2-1.2c3.4-3.4 9-3.4 12.4 0l1.2 1.2c11.5 11.5 27.1 17.9 43.3 17.9c33.8 0 61.3-27.4 61.3-61.3v-4.9c0-12-3.3-23.7-9.4-34l-18.8-31.3c-1.1-1.8-1.2-3.1-1-4.2c.2-1.2 .8-2.5 2-3.6s2.4-1.8 3.6-2c1-.2 2.4-.1 4.2 1l31.3 18.8c10.3 6.2 22 9.4 34 9.4h4.9c33.8 0 61.3-27.4 61.3-61.3c0-16.2-6.5-31.8-17.9-43.3l-1.2-1.2c-3.4-3.4-3.4-9 0-12.4l1.2-1.2c11.5-11.5 17.9-27.1 17.9-43.3c0-33.8-27.4-61.3-61.3-61.3h-4.9c-12 0-23.7 3.3-34 9.4l-31.3 18.8c-1.8 1.1-3.1 1.2-4.2 1c-1.2-.2-2.5-.8-3.6-2s-1.8-2.4-2-3.6c-.2-1-.1-2.4 1-4.2l18.8-31.3c6.2-10.3 9.4-22 9.4-34V93.3C336 59.4 308.6 32 274.7 32c-16.2 0-31.8 6.5-43.3 17.9l-1.2 1.2c-3.4 3.4-9 3.4-12.4 0l-1.2-1.2z"
    ]
};
var $d8206b3ab2e65c05$export$bb06d4a7bb6736fe = {
    prefix: "fas",
    iconName: "reply",
    icon: [
        512,
        512,
        [
            61714,
            "mail-reply"
        ],
        "f3e5",
        "M205 34.8c11.5 5.1 19 16.6 19 29.2v64H336c97.2 0 176 78.8 176 176c0 113.3-81.5 163.9-100.2 174.1c-2.5 1.4-5.3 1.9-8.1 1.9c-10.9 0-19.7-8.9-19.7-19.7c0-7.5 4.3-14.4 9.8-19.5c9.4-8.8 22.2-26.4 22.2-56.7c0-53-43-96-96-96H224v64c0 12.6-7.4 24.1-19 29.2s-25 3-34.4-5.4l-160-144C3.9 225.7 0 217.1 0 208s3.9-17.7 10.6-23.8l160-144c9.4-8.5 22.9-10.6 34.4-5.4z"
    ]
};
var $d8206b3ab2e65c05$export$12e45ff70d2646a1 = $d8206b3ab2e65c05$export$bb06d4a7bb6736fe;
var $d8206b3ab2e65c05$export$cafa834c96ebcb1a = {
    prefix: "fas",
    iconName: "star-and-crescent",
    icon: [
        512,
        512,
        [
            9770
        ],
        "f699",
        "M0 256C0 114.6 114.6 0 256 0c33 0 64.6 6.3 93.6 17.7c7.4 2.9 11.5 10.7 9.8 18.4s-8.8 13-16.7 12.4c-4.8-.3-9.7-.5-14.6-.5c-114.9 0-208 93.1-208 208s93.1 208 208 208c4.9 0 9.8-.2 14.6-.5c7.9-.5 15 4.7 16.7 12.4s-2.4 15.5-9.8 18.4C320.6 505.7 289 512 256 512C114.6 512 0 397.4 0 256zM375.4 137.4c3.5-7.1 13.7-7.1 17.2 0l31.5 63.8c1.4 2.8 4.1 4.8 7.2 5.3l70.4 10.2c7.9 1.1 11 10.8 5.3 16.4l-50.9 49.6c-2.3 2.2-3.3 5.4-2.8 8.5l12 70.1c1.3 7.8-6.9 13.8-13.9 10.1l-63-33.1c-2.8-1.5-6.1-1.5-8.9 0l-63 33.1c-7 3.7-15.3-2.3-13.9-10.1l12-70.1c.5-3.1-.5-6.3-2.8-8.5L261 233.1c-5.7-5.6-2.6-15.2 5.3-16.4l70.4-10.2c3.1-.5 5.8-2.4 7.2-5.3l31.5-63.8z"
    ]
};
var $d8206b3ab2e65c05$export$947ee033a6942aa8 = {
    prefix: "fas",
    iconName: "house-fire",
    icon: [
        640,
        512,
        [],
        "e50c",
        "M288 350.1l0 1.9H256c-17.7 0-32 14.3-32 32v64 24c0 22.1-17.9 40-40 40H160 128.1c-1.5 0-3-.1-4.5-.2c-1.2 .1-2.4 .2-3.6 .2H104c-22.1 0-40-17.9-40-40V360c0-.9 0-1.9 .1-2.8V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L447.3 128.1c-12.3-1-25 3-34.8 11.7c-35.4 31.6-65.6 67.7-87.3 102.8C304.3 276.5 288 314.9 288 350.1zM480 512c-88.4 0-160-71.6-160-160c0-76.7 62.5-144.7 107.2-179.4c5-3.9 10.9-5.8 16.8-5.8c7.9-.1 16 3.1 22 9.2l46 46 11.3-11.3c11.7-11.7 30.6-12.7 42.3-1C624.5 268 640 320.2 640 352c0 88.4-71.6 160-160 160zm64-111.8c0-36.5-37-73-54.8-88.4c-5.4-4.7-13.1-4.7-18.5 0C453 327.1 416 363.6 416 400.2c0 35.3 28.7 64 64 64s64-28.7 64-64z"
    ]
};
var $d8206b3ab2e65c05$export$814c9edba7b84aa4 = {
    prefix: "fas",
    iconName: "square-minus",
    icon: [
        448,
        512,
        [
            61767,
            "minus-square"
        ],
        "f146",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm88 200H296c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
    ]
};
var $d8206b3ab2e65c05$export$ffe9387966b3e681 = $d8206b3ab2e65c05$export$814c9edba7b84aa4;
var $d8206b3ab2e65c05$export$612d3e1afaf45fa5 = {
    prefix: "fas",
    iconName: "helicopter",
    icon: [
        640,
        512,
        [
            128641
        ],
        "f533",
        "M128 32c0-17.7 14.3-32 32-32H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H384v64h32c88.4 0 160 71.6 160 160v64c0 17.7-14.3 32-32 32H384 320c-20.1 0-39.1-9.5-51.2-25.6l-71.4-95.2c-3.5-4.7-8.3-8.3-13.7-10.5L47.2 198.1c-9.5-3.8-16.7-12-19.2-22L5 83.9C2.4 73.8 10.1 64 20.5 64H48c10.1 0 19.6 4.7 25.6 12.8L112 128H320V64H160c-17.7 0-32-14.3-32-32zM384 320H512V288c0-53-43-96-96-96H384V320zM630.6 425.4c12.5 12.5 12.5 32.8 0 45.3l-3.9 3.9c-24 24-56.6 37.5-90.5 37.5H256c-17.7 0-32-14.3-32-32s14.3-32 32-32H536.2c17 0 33.3-6.7 45.3-18.7l3.9-3.9c12.5-12.5 32.8-12.5 45.3 0z"
    ]
};
var $d8206b3ab2e65c05$export$b4d344633433e50e = {
    prefix: "fas",
    iconName: "compass",
    icon: [
        512,
        512,
        [
            129517
        ],
        "f14e",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm50.7-186.9L162.4 380.6c-19.4 7.5-38.5-11.6-31-31l55.5-144.3c3.3-8.5 9.9-15.1 18.4-18.4l144.3-55.5c19.4-7.5 38.5 11.6 31 31L325.1 306.7c-3.2 8.5-9.9 15.1-18.4 18.4zM288 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"
    ]
};
var $d8206b3ab2e65c05$export$a1ab39cd66c4e50e = {
    prefix: "fas",
    iconName: "square-caret-down",
    icon: [
        448,
        512,
        [
            "caret-square-down"
        ],
        "f150",
        "M384 480c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0zM224 352c-6.7 0-13-2.8-17.6-7.7l-104-112c-6.5-7-8.2-17.2-4.4-25.9s12.5-14.4 22-14.4l208 0c9.5 0 18.2 5.7 22 14.4s2.1 18.9-4.4 25.9l-104 112c-4.5 4.9-10.9 7.7-17.6 7.7z"
    ]
};
var $d8206b3ab2e65c05$export$61aea18df1c84401 = $d8206b3ab2e65c05$export$a1ab39cd66c4e50e;
var $d8206b3ab2e65c05$export$877d3692c1f94bda = {
    prefix: "fas",
    iconName: "file-circle-question",
    icon: [
        576,
        512,
        [],
        "e4ef",
        "M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384v38.6C310.1 219.5 256 287.4 256 368c0 59.1 29.1 111.3 73.7 143.3c-3.2 .5-6.4 .7-9.7 .7H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128zm48 96a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 240a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM368 321.6V328c0 8.8 7.2 16 16 16s16-7.2 16-16v-6.4c0-5.3 4.3-9.6 9.6-9.6h40.5c7.7 0 13.9 6.2 13.9 13.9c0 5.2-2.9 9.9-7.4 12.3l-32 16.8c-5.3 2.8-8.6 8.2-8.6 14.2V384c0 8.8 7.2 16 16 16s16-7.2 16-16v-5.1l23.5-12.3c15.1-7.9 24.5-23.6 24.5-40.6c0-25.4-20.6-45.9-45.9-45.9H409.6c-23 0-41.6 18.6-41.6 41.6z"
    ]
};
var $d8206b3ab2e65c05$export$94100f4c6ee29932 = {
    prefix: "fas",
    iconName: "laptop-code",
    icon: [
        640,
        512,
        [],
        "f5fc",
        "M64 96c0-35.3 28.7-64 64-64H512c35.3 0 64 28.7 64 64V352H512V96H128V352H64V96zM0 403.2C0 392.6 8.6 384 19.2 384H620.8c10.6 0 19.2 8.6 19.2 19.2c0 42.4-34.4 76.8-76.8 76.8H76.8C34.4 480 0 445.6 0 403.2zM281 209l-31 31 31 31c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-48-48c-9.4-9.4-9.4-24.6 0-33.9l48-48c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zM393 175l48 48c9.4 9.4 9.4 24.6 0 33.9l-48 48c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l31-31-31-31c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0z"
    ]
};
var $d8206b3ab2e65c05$export$c74a20c81b957b6a = {
    prefix: "fas",
    iconName: "swatchbook",
    icon: [
        512,
        512,
        [],
        "f5c3",
        "M0 32C0 14.3 14.3 0 32 0H160c17.7 0 32 14.3 32 32V416c0 53-43 96-96 96s-96-43-96-96V32zM223.6 425.9c.3-3.3 .4-6.6 .4-9.9V154l75.4-75.4c12.5-12.5 32.8-12.5 45.3 0l90.5 90.5c12.5 12.5 12.5 32.8 0 45.3L223.6 425.9zM182.8 512l192-192H480c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H182.8zM128 64H64v64h64V64zM64 192v64h64V192H64zM96 440a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
    ]
};
var $d8206b3ab2e65c05$export$214f9ce665590486 = {
    prefix: "fas",
    iconName: "prescription-bottle",
    icon: [
        384,
        512,
        [],
        "f485",
        "M0 32C0 14.3 14.3 0 32 0H352c17.7 0 32 14.3 32 32V64c0 17.7-14.3 32-32 32H32C14.3 96 0 81.7 0 64V32zm32 96H352V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V416H144c8.8 0 16-7.2 16-16s-7.2-16-16-16H32V320H144c8.8 0 16-7.2 16-16s-7.2-16-16-16H32V224H144c8.8 0 16-7.2 16-16s-7.2-16-16-16H32V128z"
    ]
};
var $d8206b3ab2e65c05$export$36e9cf7887265da2 = {
    prefix: "fas",
    iconName: "bars",
    icon: [
        448,
        512,
        [
            "navicon"
        ],
        "f0c9",
        "M0 96C0 78.3 14.3 64 32 64H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 128 0 113.7 0 96zM0 256c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zM448 416c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32z"
    ]
};
var $d8206b3ab2e65c05$export$409fa7bcaa0e4cd9 = $d8206b3ab2e65c05$export$36e9cf7887265da2;
var $d8206b3ab2e65c05$export$be015e72863c3635 = {
    prefix: "fas",
    iconName: "people-group",
    icon: [
        640,
        512,
        [],
        "e533",
        "M72 88a56 56 0 1 1 112 0A56 56 0 1 1 72 88zM64 245.7C54 256.9 48 271.8 48 288s6 31.1 16 42.3V245.7zm144.4-49.3C178.7 222.7 160 261.2 160 304c0 34.3 12 65.8 32 90.5V416c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V389.2C26.2 371.2 0 332.7 0 288c0-61.9 50.1-112 112-112h32c24 0 46.2 7.5 64.4 20.3zM448 416V394.5c20-24.7 32-56.2 32-90.5c0-42.8-18.7-81.3-48.4-107.7C449.8 183.5 472 176 496 176h32c61.9 0 112 50.1 112 112c0 44.7-26.2 83.2-64 101.2V416c0 17.7-14.3 32-32 32H480c-17.7 0-32-14.3-32-32zm8-328a56 56 0 1 1 112 0A56 56 0 1 1 456 88zM576 245.7v84.7c10-11.3 16-26.1 16-42.3s-6-31.1-16-42.3zM320 32a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM240 304c0 16.2 6 31 16 42.3V261.7c-10 11.3-16 26.1-16 42.3zm144-42.3v84.7c10-11.3 16-26.1 16-42.3s-6-31.1-16-42.3zM448 304c0 44.7-26.2 83.2-64 101.2V448c0 17.7-14.3 32-32 32H288c-17.7 0-32-14.3-32-32V405.2c-37.8-18-64-56.5-64-101.2c0-61.9 50.1-112 112-112h32c61.9 0 112 50.1 112 112z"
    ]
};
var $d8206b3ab2e65c05$export$52757ecc5b1e25b9 = {
    prefix: "fas",
    iconName: "hourglass-end",
    icon: [
        384,
        512,
        [
            8987,
            "hourglass-3"
        ],
        "f253",
        "M32 0C14.3 0 0 14.3 0 32S14.3 64 32 64V75c0 42.4 16.9 83.1 46.9 113.1L146.7 256 78.9 323.9C48.9 353.9 32 394.6 32 437v11c-17.7 0-32 14.3-32 32s14.3 32 32 32H64 320h32c17.7 0 32-14.3 32-32s-14.3-32-32-32V437c0-42.4-16.9-83.1-46.9-113.1L237.3 256l67.9-67.9c30-30 46.9-70.7 46.9-113.1V64c17.7 0 32-14.3 32-32s-14.3-32-32-32H320 64 32zM96 75V64H288V75c0 25.5-10.1 49.9-28.1 67.9L192 210.7l-67.9-67.9C106.1 124.9 96 100.4 96 75z"
    ]
};
var $d8206b3ab2e65c05$export$1ec43c81fef8ffd6 = $d8206b3ab2e65c05$export$52757ecc5b1e25b9;
var $d8206b3ab2e65c05$export$8e521ef33062b00e = {
    prefix: "fas",
    iconName: "heart-crack",
    icon: [
        512,
        512,
        [
            128148,
            "heart-broken"
        ],
        "f7a9",
        "M119.4 44.1c23.3-3.9 46.8-1.9 68.6 5.3l49.8 77.5-75.4 75.4c-1.5 1.5-2.4 3.6-2.3 5.8s1 4.2 2.6 5.7l112 104c2.9 2.7 7.4 2.9 10.5 .3s3.8-7 1.7-10.4l-60.4-98.1 90.7-75.6c2.6-2.1 3.5-5.7 2.4-8.8L296.8 61.8c28.5-16.7 62.4-23.2 95.7-17.6C461.5 55.6 512 115.2 512 185.1v5.8c0 41.5-17.2 81.2-47.6 109.5L283.7 469.1c-7.5 7-17.4 10.9-27.7 10.9s-20.2-3.9-27.7-10.9L47.6 300.4C17.2 272.1 0 232.4 0 190.9v-5.8c0-69.9 50.5-129.5 119.4-141z"
    ]
};
var $d8206b3ab2e65c05$export$4a565395cb65b282 = $d8206b3ab2e65c05$export$8e521ef33062b00e;
var $d8206b3ab2e65c05$export$a47a20ab7bde8c67 = {
    prefix: "fas",
    iconName: "square-up-right",
    icon: [
        448,
        512,
        [
            8599,
            "external-link-square-alt"
        ],
        "f360",
        "M384 32c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H384zM320 313.4V176c0-8.8-7.2-16-16-16H166.6c-12.5 0-22.6 10.1-22.6 22.6c0 6 2.4 11.8 6.6 16L184 232l-66.3 66.3C114 302 112 306.9 112 312s2 10 5.7 13.7l36.7 36.7c3.6 3.6 8.5 5.7 13.7 5.7s10-2 13.7-5.7L248 296l33.4 33.4c4.2 4.2 10 6.6 16 6.6c12.5 0 22.6-10.1 22.6-22.6z"
    ]
};
var $d8206b3ab2e65c05$export$e4cdf2977151ee26 = $d8206b3ab2e65c05$export$a47a20ab7bde8c67;
var $d8206b3ab2e65c05$export$eca99665af566fe1 = {
    prefix: "fas",
    iconName: "face-kiss-beam",
    icon: [
        512,
        512,
        [
            128537,
            "kiss-beam"
        ],
        "f597",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm48.7-198.3c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4c-2.7 1.5-5.7 3-8.7 4.3c3.1 1.3 6 2.7 8.7 4.3c6.6 3.7 12.5 8.2 16.7 13.4c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4C274.7 443.1 257.4 448 240 448c-3.6 0-6.8-2.5-7.7-6s.6-7.2 3.8-9l0 0 0 0 0 0 0 0 .2-.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1c-.4-.2-.7-.4-.9-.5l-.2-.1 0 0 0 0 0 0c-2.5-1.4-4.1-4.1-4.1-7s1.6-5.6 4.1-7l0 0 0 0 0 0 0 0 0 0 .2-.1 .3-.2 .6-.4c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1l-.4-.3-.5-.3-.2-.1 0 0 0 0 0 0c-3.2-1.8-4.7-5.5-3.8-9s4.1-6 7.7-6c17.4 0 34.7 4.9 47.9 12.3c6.6 3.7 12.5 8.2 16.7 13.4zm-87.1-84.9l0 0 0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0zm160 0l0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0 0 0z"
    ]
};
var $d8206b3ab2e65c05$export$d6ff8a73c0812e63 = $d8206b3ab2e65c05$export$eca99665af566fe1;
var $d8206b3ab2e65c05$export$c03de0cc616e77bb = {
    prefix: "fas",
    iconName: "film",
    icon: [
        512,
        512,
        [
            127902
        ],
        "f008",
        "M0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM48 368v32c0 8.8 7.2 16 16 16H96c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16H64c-8.8 0-16 7.2-16 16zm368-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16H416zM48 240v32c0 8.8 7.2 16 16 16H96c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H64c-8.8 0-16 7.2-16 16zm368-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H416zM48 112v32c0 8.8 7.2 16 16 16H96c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H64c-8.8 0-16 7.2-16 16zM416 96c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H416zM160 128v64c0 17.7 14.3 32 32 32H320c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32H192c-17.7 0-32 14.3-32 32zm32 160c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H320c17.7 0 32-14.3 32-32V320c0-17.7-14.3-32-32-32H192z"
    ]
};
var $d8206b3ab2e65c05$export$46c6347bff3e04a = {
    prefix: "fas",
    iconName: "ruler-horizontal",
    icon: [
        640,
        512,
        [],
        "f547",
        "M0 336c0 26.5 21.5 48 48 48l544 0c26.5 0 48-21.5 48-48l0-160c0-26.5-21.5-48-48-48l-64 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-64 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-64 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-64 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-64 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-64 0c-26.5 0-48 21.5-48 48L0 336z"
    ]
};
var $d8206b3ab2e65c05$export$75ce8513e1f1c5c4 = {
    prefix: "fas",
    iconName: "people-robbery",
    icon: [
        576,
        512,
        [],
        "e536",
        "M488.2 59.1C478.1 99.6 441.7 128 400 128s-78.1-28.4-88.2-68.9L303 24.2C298.8 7.1 281.4-3.3 264.2 1S236.7 22.6 241 39.8l8.7 34.9c11 44 40.2 79.6 78.3 99.6V480c0 17.7 14.3 32 32 32s32-14.3 32-32V352h16V480c0 17.7 14.3 32 32 32s32-14.3 32-32V174.3c38.1-20 67.3-55.6 78.3-99.6L559 39.8c4.3-17.1-6.1-34.5-23.3-38.8S501.2 7.1 497 24.2l-8.7 34.9zM400 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM80 96A48 48 0 1 0 80 0a48 48 0 1 0 0 96zm-8 32c-35.3 0-64 28.7-64 64v96l0 .6V480c0 17.7 14.3 32 32 32s32-14.3 32-32V352H88V480c0 17.7 14.3 32 32 32s32-14.3 32-32V252.7l13 20.5c5.9 9.2 16.1 14.9 27 14.9h48c17.7 0 32-14.3 32-32s-14.3-32-32-32H209.6l-37.4-58.9C157.6 142 132.1 128 104.7 128H72z"
    ]
};
var $d8206b3ab2e65c05$export$1e80f89fe84a215b = {
    prefix: "fas",
    iconName: "lightbulb",
    icon: [
        384,
        512,
        [
            128161
        ],
        "f0eb",
        "M272 384c9.6-31.9 29.5-59.1 49.2-86.2l0 0c5.2-7.1 10.4-14.2 15.4-21.4c19.8-28.5 31.4-63 31.4-100.3C368 78.8 289.2 0 192 0S16 78.8 16 176c0 37.3 11.6 71.9 31.4 100.3c5 7.2 10.2 14.3 15.4 21.4l0 0c19.8 27.1 39.7 54.4 49.2 86.2H272zM192 512c44.2 0 80-35.8 80-80V416H112v16c0 44.2 35.8 80 80 80zM112 176c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-61.9 50.1-112 112-112c8.8 0 16 7.2 16 16s-7.2 16-16 16c-44.2 0-80 35.8-80 80z"
    ]
};
var $d8206b3ab2e65c05$export$85a918a11b7643c2 = {
    prefix: "fas",
    iconName: "caret-left",
    icon: [
        256,
        512,
        [],
        "f0d9",
        "M9.4 278.6c-12.5-12.5-12.5-32.8 0-45.3l128-128c9.2-9.2 22.9-11.9 34.9-6.9s19.8 16.6 19.8 29.6l0 256c0 12.9-7.8 24.6-19.8 29.6s-25.7 2.2-34.9-6.9l-128-128z"
    ]
};
var $d8206b3ab2e65c05$export$59573943f9eebbd5 = {
    prefix: "fas",
    iconName: "circle-exclamation",
    icon: [
        512,
        512,
        [
            "exclamation-circle"
        ],
        "f06a",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c13.3 0 24 10.7 24 24V264c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
    ]
};
var $d8206b3ab2e65c05$export$220e07e14c5d7e5d = $d8206b3ab2e65c05$export$59573943f9eebbd5;
var $d8206b3ab2e65c05$export$5e17b20e0f6b132b = {
    prefix: "fas",
    iconName: "school-circle-xmark",
    icon: [
        640,
        512,
        [],
        "e56d",
        "M337.8 5.4C327-1.8 313-1.8 302.2 5.4L166.3 96H48C21.5 96 0 117.5 0 144V464c0 26.5 21.5 48 48 48H320v0H256V416c0-35.3 28.7-64 64-64l.3 0h.5c3.4-37.7 18.7-72.1 42.2-99.1C350.2 260 335.6 264 320 264c-48.6 0-88-39.4-88-88s39.4-88 88-88s88 39.4 88 88c0 18.3-5.6 35.3-15.1 49.4c29-21 64.6-33.4 103.1-33.4c59.5 0 112.1 29.6 144 74.8V144c0-26.5-21.5-48-48-48H473.7L337.8 5.4zM96 192h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V208c0-8.8 7.2-16 16-16zm0 128h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V336c0-8.8 7.2-16 16-16zM320 128c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H336V144c0-8.8-7.2-16-16-16zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm22.6-144l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L473.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L496 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L518.6 368z"
    ]
};
var $d8206b3ab2e65c05$export$ca14f1b4d6afb7aa = {
    prefix: "fas",
    iconName: "arrow-right-from-bracket",
    icon: [
        512,
        512,
        [
            "sign-out"
        ],
        "f08b",
        "M502.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 224 192 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l210.7 0-73.4 73.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l128-128zM160 96c17.7 0 32-14.3 32-32s-14.3-32-32-32L96 32C43 32 0 75 0 128L0 384c0 53 43 96 96 96l64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0c-17.7 0-32-14.3-32-32l0-256c0-17.7 14.3-32 32-32l64 0z"
    ]
};
var $d8206b3ab2e65c05$export$33e2b60243ca6d92 = $d8206b3ab2e65c05$export$ca14f1b4d6afb7aa;
var $d8206b3ab2e65c05$export$aca07924996218d8 = {
    prefix: "fas",
    iconName: "circle-chevron-down",
    icon: [
        512,
        512,
        [
            "chevron-circle-down"
        ],
        "f13a",
        "M256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM135 241c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l87 87 87-87c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L273 345c-9.4 9.4-24.6 9.4-33.9 0L135 241z"
    ]
};
var $d8206b3ab2e65c05$export$9926124d75b2ecab = $d8206b3ab2e65c05$export$aca07924996218d8;
var $d8206b3ab2e65c05$export$c98fdd5082b333ec = {
    prefix: "fas",
    iconName: "unlock-keyhole",
    icon: [
        448,
        512,
        [
            "unlock-alt"
        ],
        "f13e",
        "M224 64c-44.2 0-80 35.8-80 80v48H384c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V256c0-35.3 28.7-64 64-64H80V144C80 64.5 144.5 0 224 0c57.5 0 107 33.7 130.1 82.3c7.6 16 .8 35.1-15.2 42.6s-35.1 .8-42.6-15.2C283.4 82.6 255.9 64 224 64zm32 320c17.7 0 32-14.3 32-32s-14.3-32-32-32H192c-17.7 0-32 14.3-32 32s14.3 32 32 32h64z"
    ]
};
var $d8206b3ab2e65c05$export$b19f508797f3d9c3 = $d8206b3ab2e65c05$export$c98fdd5082b333ec;
var $d8206b3ab2e65c05$export$af51c741ee9cc090 = {
    prefix: "fas",
    iconName: "cloud-showers-heavy",
    icon: [
        512,
        512,
        [],
        "f740",
        "M96 320c-53 0-96-43-96-96c0-42.5 27.6-78.6 65.9-91.2C64.7 126.1 64 119.1 64 112C64 50.1 114.1 0 176 0c43.1 0 80.5 24.3 99.2 60c14.7-17.1 36.5-28 60.8-28c44.2 0 80 35.8 80 80c0 5.5-.6 10.8-1.6 16c.5 0 1.1 0 1.6 0c53 0 96 43 96 96s-43 96-96 96H96zM81.5 353.9c12.2 5.2 17.8 19.3 12.6 31.5l-48 112c-5.2 12.2-19.3 17.8-31.5 12.6S-3.3 490.7 1.9 478.5l48-112c5.2-12.2 19.3-17.8 31.5-12.6zm120 0c12.2 5.2 17.8 19.3 12.6 31.5l-48 112c-5.2 12.2-19.3 17.8-31.5 12.6s-17.8-19.3-12.6-31.5l48-112c5.2-12.2 19.3-17.8 31.5-12.6zm244.6 31.5l-48 112c-5.2 12.2-19.3 17.8-31.5 12.6s-17.8-19.3-12.6-31.5l48-112c5.2-12.2 19.3-17.8 31.5-12.6s17.8 19.3 12.6 31.5zM313.5 353.9c12.2 5.2 17.8 19.3 12.6 31.5l-48 112c-5.2 12.2-19.3 17.8-31.5 12.6s-17.8-19.3-12.6-31.5l48-112c5.2-12.2 19.3-17.8 31.5-12.6z"
    ]
};
var $d8206b3ab2e65c05$export$ca47801915e5a685 = {
    prefix: "fas",
    iconName: "headphones-simple",
    icon: [
        512,
        512,
        [
            "headphones-alt"
        ],
        "f58f",
        "M256 80C141.1 80 48 173.1 48 288V392c0 13.3-10.7 24-24 24s-24-10.7-24-24V288C0 146.6 114.6 32 256 32s256 114.6 256 256V392c0 13.3-10.7 24-24 24s-24-10.7-24-24V288c0-114.9-93.1-208-208-208zM80 352c0-35.3 28.7-64 64-64h16c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32H144c-35.3 0-64-28.7-64-64V352zm288-64c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64H352c-17.7 0-32-14.3-32-32V320c0-17.7 14.3-32 32-32h16z"
    ]
};
var $d8206b3ab2e65c05$export$6f0433fa527dd5be = $d8206b3ab2e65c05$export$ca47801915e5a685;
var $d8206b3ab2e65c05$export$b2ce5e79d0eccaf8 = {
    prefix: "fas",
    iconName: "sitemap",
    icon: [
        576,
        512,
        [],
        "f0e8",
        "M208 80c0-26.5 21.5-48 48-48h64c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48h-8v40H464c30.9 0 56 25.1 56 56v32h8c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H464c-26.5 0-48-21.5-48-48V368c0-26.5 21.5-48 48-48h8V288c0-4.4-3.6-8-8-8H312v40h8c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H256c-26.5 0-48-21.5-48-48V368c0-26.5 21.5-48 48-48h8V280H112c-4.4 0-8 3.6-8 8v32h8c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V368c0-26.5 21.5-48 48-48h8V288c0-30.9 25.1-56 56-56H264V192h-8c-26.5 0-48-21.5-48-48V80z"
    ]
};
var $d8206b3ab2e65c05$export$5f92ac3e804644e3 = {
    prefix: "fas",
    iconName: "circle-dollar-to-slot",
    icon: [
        512,
        512,
        [
            "donate"
        ],
        "f4b9",
        "M326.7 403.7c-22.1 8-45.9 12.3-70.7 12.3s-48.7-4.4-70.7-12.3c-.3-.1-.5-.2-.8-.3c-30-11-56.8-28.7-78.6-51.4C70 314.6 48 263.9 48 208C48 93.1 141.1 0 256 0S464 93.1 464 208c0 55.9-22 106.6-57.9 144c-1 1-2 2.1-3 3.1c-21.4 21.4-47.4 38.1-76.3 48.6zM256 84c-11 0-20 9-20 20v14c-7.6 1.7-15.2 4.4-22.2 8.5c-13.9 8.3-25.9 22.8-25.8 43.9c.1 20.3 12 33.1 24.7 40.7c11 6.6 24.7 10.8 35.6 14l1.7 .5c12.6 3.8 21.8 6.8 28 10.7c5.1 3.2 5.8 5.4 5.9 8.2c.1 5-1.8 8-5.9 10.5c-5 3.1-12.9 5-21.4 4.7c-11.1-.4-21.5-3.9-35.1-8.5c-2.3-.8-4.7-1.6-7.2-2.4c-10.5-3.5-21.8 2.2-25.3 12.6s2.2 21.8 12.6 25.3c1.9 .6 4 1.3 6.1 2.1l0 0 0 0c8.3 2.9 17.9 6.2 28.2 8.4V312c0 11 9 20 20 20s20-9 20-20V298.2c8-1.7 16-4.5 23.2-9c14.3-8.9 25.1-24.1 24.8-45c-.3-20.3-11.7-33.4-24.6-41.6c-11.5-7.2-25.9-11.6-37.1-15l-.7-.2c-12.8-3.9-21.9-6.7-28.3-10.5c-5.2-3.1-5.3-4.9-5.3-6.7c0-3.7 1.4-6.5 6.2-9.3c5.4-3.2 13.6-5.1 21.5-5c9.6 .1 20.2 2.2 31.2 5.2c10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-6.5-1.7-13.7-3.4-21.1-4.7V104c0-11-9-20-20-20zM48 352H64c19.5 25.9 44 47.7 72.2 64H64v32H256 448V416H375.8c28.2-16.3 52.8-38.1 72.2-64h16c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V400c0-26.5 21.5-48 48-48z"
    ]
};
var $d8206b3ab2e65c05$export$40050ae52860cde7 = $d8206b3ab2e65c05$export$5f92ac3e804644e3;
var $d8206b3ab2e65c05$export$5f9bd9f6df021f93 = {
    prefix: "fas",
    iconName: "memory",
    icon: [
        576,
        512,
        [],
        "f538",
        "M64 64C28.7 64 0 92.7 0 128v7.4c0 6.8 4.4 12.6 10.1 16.3C23.3 160.3 32 175.1 32 192s-8.7 31.7-21.9 40.3C4.4 236 0 241.8 0 248.6V320H576V248.6c0-6.8-4.4-12.6-10.1-16.3C552.7 223.7 544 208.9 544 192s8.7-31.7 21.9-40.3c5.7-3.7 10.1-9.5 10.1-16.3V128c0-35.3-28.7-64-64-64H64zM576 352H0v64c0 17.7 14.3 32 32 32H80V416c0-8.8 7.2-16 16-16s16 7.2 16 16v32h96V416c0-8.8 7.2-16 16-16s16 7.2 16 16v32h96V416c0-8.8 7.2-16 16-16s16 7.2 16 16v32h96V416c0-8.8 7.2-16 16-16s16 7.2 16 16v32h48c17.7 0 32-14.3 32-32V352zM192 160v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V160c0-17.7 14.3-32 32-32s32 14.3 32 32zm128 0v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V160c0-17.7 14.3-32 32-32s32 14.3 32 32zm128 0v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V160c0-17.7 14.3-32 32-32s32 14.3 32 32z"
    ]
};
var $d8206b3ab2e65c05$export$b372a24046126ad8 = {
    prefix: "fas",
    iconName: "road-spikes",
    icon: [
        640,
        512,
        [],
        "e568",
        "M64 116.8c0-15.8 20.5-22 29.3-8.9L192 256V116.8c0-15.8 20.5-22 29.3-8.9L320 256V116.8c0-15.8 20.5-22 29.3-8.9L448 256V116.8c0-15.8 20.5-22 29.3-8.9L606.8 302.2c14.2 21.3-1.1 49.7-26.6 49.7H512 448 384 320 256 192 64V116.8zM32 384H608c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
    ]
};
var $d8206b3ab2e65c05$export$e4e44f7b1886fef = {
    prefix: "fas",
    iconName: "fire-burner",
    icon: [
        640,
        512,
        [],
        "e4f1",
        "M320 352c-88.4 0-160-71.6-160-160c0-76.7 62.5-144.7 107.2-179.4c5-3.9 10.9-5.8 16.8-5.8c7.9-.1 16 3.1 22 9.2l46 46 11.3-11.3c11.7-11.7 30.6-12.7 42.3-1C464.5 108 480 160.2 480 192c0 88.4-71.6 160-160 160zm64-111.8c0-36.5-37-73-54.8-88.4c-5.4-4.7-13.1-4.7-18.5 0C293 167.1 256 203.6 256 240.2c0 35.3 28.7 64 64 64s64-28.7 64-64zM32 288c0-17.7 14.3-32 32-32H96c17.7 0 32 14.3 32 32s-14.3 32-32 32v64H544V320c-17.7 0-32-14.3-32-32s14.3-32 32-32h32c17.7 0 32 14.3 32 32v96c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V416c0-17.7 14.3-32 32-32V288zM320 480a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm160-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM192 480a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
var $d8206b3ab2e65c05$export$6591b1ea509be9da = {
    prefix: "fas",
    iconName: "flag",
    icon: [
        448,
        512,
        [
            127988,
            61725
        ],
        "f024",
        "M64 32C64 14.3 49.7 0 32 0S0 14.3 0 32V64 368 480c0 17.7 14.3 32 32 32s32-14.3 32-32V352l64.3-16.1c41.1-10.3 84.6-5.5 122.5 13.4c44.2 22.1 95.5 24.8 141.7 7.4l34.7-13c12.5-4.7 20.8-16.6 20.8-30V66.1c0-23-24.2-38-44.8-27.7l-9.6 4.8c-46.3 23.2-100.8 23.2-147.1 0c-35.1-17.6-75.4-22-113.5-12.5L64 48V32z"
    ]
};
var $d8206b3ab2e65c05$export$3dcd4ca3f7108a82 = {
    prefix: "fas",
    iconName: "hanukiah",
    icon: [
        640,
        512,
        [
            128334
        ],
        "f6e6",
        "M314.2 3.3C309.1 12.1 296 36.6 296 56c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7C324.6 1.2 322.4 0 320 0s-4.6 1.2-5.8 3.3zm-288 48C21.1 60.1 8 84.6 8 104c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7C36.6 49.2 34.4 48 32 48s-4.6 1.2-5.8 3.3zM88 104c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7c-1.2-2.1-3.4-3.3-5.8-3.3s-4.6 1.2-5.8 3.3C101.1 60.1 88 84.6 88 104zm82.2-52.7C165.1 60.1 152 84.6 152 104c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7c-1.2-2.1-3.4-3.3-5.8-3.3s-4.6 1.2-5.8 3.3zM216 104c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7c-1.2-2.1-3.4-3.3-5.8-3.3s-4.6 1.2-5.8 3.3C229.1 60.1 216 84.6 216 104zM394.2 51.3C389.1 60.1 376 84.6 376 104c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7c-1.2-2.1-3.4-3.3-5.8-3.3s-4.6 1.2-5.8 3.3zM440 104c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7c-1.2-2.1-3.4-3.3-5.8-3.3s-4.6 1.2-5.8 3.3C453.1 60.1 440 84.6 440 104zm82.2-52.7C517.1 60.1 504 84.6 504 104c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7c-1.2-2.1-3.4-3.3-5.8-3.3s-4.6 1.2-5.8 3.3zM584 104c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7c-1.2-2.1-3.4-3.3-5.8-3.3s-4.6 1.2-5.8 3.3C597.1 60.1 584 84.6 584 104zM112 160c-8.8 0-16 7.2-16 16v96 16h32V272 176c0-8.8-7.2-16-16-16zm64 0c-8.8 0-16 7.2-16 16v96 16h32V272 176c0-8.8-7.2-16-16-16zm64 0c-8.8 0-16 7.2-16 16v96 16h32V272 176c0-8.8-7.2-16-16-16zm160 0c-8.8 0-16 7.2-16 16v96 16h32V272 176c0-8.8-7.2-16-16-16zm64 0c-8.8 0-16 7.2-16 16v96 16h32V272 176c0-8.8-7.2-16-16-16zm64 0c-8.8 0-16 7.2-16 16v96 16h32V272 176c0-8.8-7.2-16-16-16zM352 144c0-17.7-14.3-32-32-32s-32 14.3-32 32V320H96c-17.7 0-32-14.3-32-32V192c0-17.7-14.3-32-32-32s-32 14.3-32 32v96c0 53 43 96 96 96H288v64H160c-17.7 0-32 14.3-32 32s14.3 32 32 32H320 480c17.7 0 32-14.3 32-32s-14.3-32-32-32H352V384H544c53 0 96-43 96-96V192c0-17.7-14.3-32-32-32s-32 14.3-32 32v96c0 17.7-14.3 32-32 32H352V144z"
    ]
};
var $d8206b3ab2e65c05$export$5e19aea195b31816 = {
    prefix: "fas",
    iconName: "feather",
    icon: [
        512,
        512,
        [
            129718
        ],
        "f52d",
        "M278.5 215.6L23 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l57-57h68c49.7 0 97.9-14.4 139-41c11.1-7.2 5.5-23-7.8-23c-5.1 0-9.2-4.1-9.2-9.2c0-4.1 2.7-7.6 6.5-8.8l81-24.3c2.5-.8 4.8-2.1 6.7-4l22.4-22.4c10.1-10.1 2.9-27.3-11.3-27.3l-32.2 0c-5.1 0-9.2-4.1-9.2-9.2c0-4.1 2.7-7.6 6.5-8.8l112-33.6c4-1.2 7.4-3.9 9.3-7.7C506.4 207.6 512 184.1 512 160c0-41-16.3-80.3-45.3-109.3l-5.5-5.5C432.3 16.3 393 0 352 0s-80.3 16.3-109.3 45.3L139 149C91 197 64 262.1 64 330v55.3L253.6 195.8c6.2-6.2 16.4-6.2 22.6 0c5.4 5.4 6.1 13.6 2.2 19.8z"
    ]
};
var $d8206b3ab2e65c05$export$2b1464e7557b18eb = {
    prefix: "fas",
    iconName: "volume-low",
    icon: [
        448,
        512,
        [
            128264,
            "volume-down"
        ],
        "f027",
        "M301.1 34.8C312.6 40 320 51.4 320 64V448c0 12.6-7.4 24-18.9 29.2s-25 3.1-34.4-5.3L131.8 352H64c-35.3 0-64-28.7-64-64V224c0-35.3 28.7-64 64-64h67.8L266.7 40.1c9.4-8.4 22.9-10.4 34.4-5.3zM412.6 181.5C434.1 199.1 448 225.9 448 256s-13.9 56.9-35.4 74.5c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C393.1 284.4 400 271 400 256s-6.9-28.4-17.7-37.3c-10.3-8.4-11.8-23.5-3.5-33.8s23.5-11.8 33.8-3.5z"
    ]
};
var $d8206b3ab2e65c05$export$69fdf57632b6cc29 = $d8206b3ab2e65c05$export$2b1464e7557b18eb;
var $d8206b3ab2e65c05$export$3786a0422a3f33ea = {
    prefix: "fas",
    iconName: "comment-slash",
    icon: [
        640,
        512,
        [],
        "f4b3",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L512.9 376.7C552.2 340.2 576 292.3 576 240C576 125.1 461.4 32 320 32c-67.7 0-129.3 21.4-175.1 56.3L38.8 5.1zm385.2 425L82.9 161.3C70.7 185.6 64 212.2 64 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c37 0 72.3-6.4 104.1-17.9z"
    ]
};
var $d8206b3ab2e65c05$export$dd9dc9b4227dbe94 = {
    prefix: "fas",
    iconName: "cloud-sun-rain",
    icon: [
        640,
        512,
        [
            127782
        ],
        "f743",
        "M294.2 1.2c5.1 2.1 8.7 6.7 9.6 12.1l10.4 62.4c-23.3 10.8-42.9 28.4-56 50.3c-14.6-9-31.8-14.1-50.2-14.1c-53 0-96 43-96 96c0 35.5 19.3 66.6 48 83.2c.8 31.8 13.2 60.7 33.1 82.7l-56 39.2c-4.5 3.2-10.3 3.8-15.4 1.6s-8.7-6.7-9.6-12.1L98.1 317.9 13.4 303.8c-5.4-.9-10-4.5-12.1-9.6s-1.5-10.9 1.6-15.4L52.5 208 2.9 137.2c-3.2-4.5-3.8-10.3-1.6-15.4s6.7-8.7 12.1-9.6L98.1 98.1l14.1-84.7c.9-5.4 4.5-10 9.6-12.1s10.9-1.5 15.4 1.6L208 52.5 278.8 2.9c4.5-3.2 10.3-3.8 15.4-1.6zM208 144c13.8 0 26.7 4.4 37.1 11.9c-1.2 4.1-2.2 8.3-3 12.6c-37.9 14.6-67.2 46.6-77.8 86.4C151.8 243.1 144 226.5 144 208c0-35.3 28.7-64 64-64zm69.4 276c11 7.4 14 22.3 6.7 33.3l-32 48c-7.4 11-22.3 14-33.3 6.7s-14-22.3-6.7-33.3l32-48c7.4-11 22.3-14 33.3-6.7zm96 0c11 7.4 14 22.3 6.7 33.3l-32 48c-7.4 11-22.3 14-33.3 6.7s-14-22.3-6.7-33.3l32-48c7.4-11 22.3-14 33.3-6.7zm96 0c11 7.4 14 22.3 6.7 33.3l-32 48c-7.4 11-22.3 14-33.3 6.7s-14-22.3-6.7-33.3l32-48c7.4-11 22.3-14 33.3-6.7zm96 0c11 7.4 14 22.3 6.7 33.3l-32 48c-7.4 11-22.3 14-33.3 6.7s-14-22.3-6.7-33.3l32-48c7.4-11 22.3-14 33.3-6.7zm74.5-116.1c0 44.2-35.8 80-80 80H288c-53 0-96-43-96-96c0-47.6 34.6-87 80-94.6l0-1.3c0-53 43-96 96-96c34.9 0 65.4 18.6 82.2 46.4c13-9.1 28.8-14.4 45.8-14.4c44.2 0 80 35.8 80 80c0 5.9-.6 11.7-1.9 17.2c37.4 6.7 65.8 39.4 65.8 78.7z"
    ]
};
var $d8206b3ab2e65c05$export$83632d1150d3541f = {
    prefix: "fas",
    iconName: "compress",
    icon: [
        448,
        512,
        [],
        "f066",
        "M160 64c0-17.7-14.3-32-32-32s-32 14.3-32 32v64H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32V64zM32 320c-17.7 0-32 14.3-32 32s14.3 32 32 32H96v64c0 17.7 14.3 32 32 32s32-14.3 32-32V352c0-17.7-14.3-32-32-32H32zM352 64c0-17.7-14.3-32-32-32s-32 14.3-32 32v96c0 17.7 14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H352V64zM320 320c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32s32-14.3 32-32V384h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H320z"
    ]
};
var $d8206b3ab2e65c05$export$79d4dac715a51fdf = {
    prefix: "fas",
    iconName: "wheat-awn",
    icon: [
        512,
        512,
        [
            "wheat-alt"
        ],
        "e2cd",
        "M505 41c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L383 95c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l88-88zM305.5 27.3c-6.2-6.2-16.4-6.2-22.6 0L271.5 38.6c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4-30.5 30.5c-3.4-27.3-15.5-53.8-36.5-74.8l-11.3-11.3c-6.2-6.2-16.4-6.2-22.6 0l-11.3 11.3c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4-30.5 30.5c-3.4-27.3-15.5-53.8-36.5-74.8L101.8 231c-6.2-6.2-16.4-6.2-22.6 0L67.9 242.3c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4L9.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l68.9-68.9 12.2 12.2c37.5 37.5 98.3 37.5 135.8 0l11.3-11.3c6.2-6.2 6.2-16.4 0-22.6l-11.3-11.3c-21.8-21.8-49.6-34.1-78.1-36.9l31.9-31.9 12.2 12.2c37.5 37.5 98.3 37.5 135.8 0l11.3-11.3c6.2-6.2 6.2-16.4 0-22.6l-11.3-11.3c-21.8-21.8-49.6-34.1-78.1-36.9l31.9-31.9 12.2 12.2c37.5 37.5 98.3 37.5 135.8 0L486.5 231c6.2-6.2 6.2-16.4 0-22.6L475.2 197c-5.2-5.2-10.6-9.8-16.4-13.9L505 137c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-59.4 59.4c-20.6-4.4-42-3.7-62.3 2.1c6.1-21.3 6.6-43.8 1.4-65.3L409 41c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L329.1 52.9c-3.7-5-7.8-9.8-12.4-14.3L305.5 27.3z"
    ]
};
var $d8206b3ab2e65c05$export$deaf03a29aa05e3a = $d8206b3ab2e65c05$export$79d4dac715a51fdf;
var $d8206b3ab2e65c05$export$8736909014b15ca9 = {
    prefix: "fas",
    iconName: "ankh",
    icon: [
        320,
        512,
        [
            9765
        ],
        "f644",
        "M96 128c0-35.3 28.7-64 64-64s64 28.7 64 64c0 41.6-20.7 76.6-46.6 104.1c-5.9 6.2-11.8 11.8-17.4 16.7c-5.6-4.9-11.5-10.5-17.4-16.7C116.7 204.6 96 169.6 96 128zM160 0C89.3 0 32 57.3 32 128c0 52.4 21.5 95.5 46.8 128H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h96V480c0 17.7 14.3 32 32 32s32-14.3 32-32V320h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H241.2c25.4-32.5 46.8-75.6 46.8-128C288 57.3 230.7 0 160 0z"
    ]
};
var $d8206b3ab2e65c05$export$bfb254bf3c0bc50b = {
    prefix: "fas",
    iconName: "hands-holding-child",
    icon: [
        640,
        512,
        [],
        "e4fa",
        "M320 0a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm44.7 164.3L375.8 253c1.6 13.2-7.7 25.1-20.8 26.8s-25.1-7.7-26.8-20.8l-4.4-35h-7.6l-4.4 35c-1.6 13.2-13.6 22.5-26.8 20.8s-22.5-13.6-20.8-26.8l11.1-88.8L255.5 181c-10.1 8.6-25.3 7.3-33.8-2.8s-7.3-25.3 2.8-33.8l27.9-23.6C271.3 104.8 295.3 96 320 96s48.7 8.8 67.6 24.7l27.9 23.6c10.1 8.6 11.4 23.7 2.8 33.8s-23.7 11.4-33.8 2.8l-19.8-16.7zM40 64c22.1 0 40 17.9 40 40v40 80 40.2c0 17 6.7 33.3 18.7 45.3l51.1 51.1c8.3 8.3 21.3 9.6 31 3.1c12.9-8.6 14.7-26.9 3.7-37.8l-15.2-15.2-32-32c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l32 32 15.2 15.2 0 0 25.3 25.3c21 21 32.8 49.5 32.8 79.2V464c0 26.5-21.5 48-48 48H173.3c-17 0-33.3-6.7-45.3-18.7L28.1 393.4C10.1 375.4 0 351 0 325.5V224 160 104C0 81.9 17.9 64 40 64zm560 0c22.1 0 40 17.9 40 40v56 64V325.5c0 25.5-10.1 49.9-28.1 67.9L512 493.3c-12 12-28.3 18.7-45.3 18.7H400c-26.5 0-48-21.5-48-48V385.1c0-29.7 11.8-58.2 32.8-79.2l25.3-25.3 0 0 15.2-15.2 32-32c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-32 32-15.2 15.2c-11 11-9.2 29.2 3.7 37.8c9.7 6.5 22.7 5.2 31-3.1l51.1-51.1c12-12 18.7-28.3 18.7-45.3V224 144 104c0-22.1 17.9-40 40-40z"
    ]
};
var $d8206b3ab2e65c05$export$19eff32c0fd4f99f = {
    prefix: "fas",
    iconName: "asterisk",
    icon: [
        384,
        512,
        [
            10033,
            61545
        ],
        "2a",
        "M192 32c17.7 0 32 14.3 32 32V199.5l111.5-66.9c15.2-9.1 34.8-4.2 43.9 11s4.2 34.8-11 43.9L254.2 256l114.3 68.6c15.2 9.1 20.1 28.7 11 43.9s-28.7 20.1-43.9 11L224 312.5V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V312.5L48.5 379.4c-15.2 9.1-34.8 4.2-43.9-11s-4.2-34.8 11-43.9L129.8 256 15.5 187.4c-15.2-9.1-20.1-28.7-11-43.9s28.7-20.1 43.9-11L160 199.5V64c0-17.7 14.3-32 32-32z"
    ]
};
var $d8206b3ab2e65c05$export$5bb6a0c94ad2f4bb = {
    prefix: "fas",
    iconName: "square-check",
    icon: [
        448,
        512,
        [
            9745,
            9989,
            61510,
            "check-square"
        ],
        "f14a",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM337 209L209 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L303 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"
    ]
};
var $d8206b3ab2e65c05$export$f0c8040f596df7fe = $d8206b3ab2e65c05$export$5bb6a0c94ad2f4bb;
var $d8206b3ab2e65c05$export$a6f8654bcd49a39f = {
    prefix: "fas",
    iconName: "peseta-sign",
    icon: [
        384,
        512,
        [],
        "e221",
        "M64 32C46.3 32 32 46.3 32 64v96c-17.7 0-32 14.3-32 32s14.3 32 32 32l0 96V448c0 17.7 14.3 32 32 32s32-14.3 32-32V352h96c77.4 0 142-55 156.8-128H352c17.7 0 32-14.3 32-32s-14.3-32-32-32h-3.2C334 87 269.4 32 192 32H64zM282.5 160H96V96h96c41.8 0 77.4 26.7 90.5 64zM96 224H282.5c-13.2 37.3-48.7 64-90.5 64H96V224z"
    ]
};
var $d8206b3ab2e65c05$export$4805b8d175aeb9fb = {
    prefix: "fas",
    iconName: "heading",
    icon: [
        448,
        512,
        [
            "header"
        ],
        "f1dc",
        "M0 64C0 46.3 14.3 32 32 32H80h48c17.7 0 32 14.3 32 32s-14.3 32-32 32H112V208H336V96H320c-17.7 0-32-14.3-32-32s14.3-32 32-32h48 48c17.7 0 32 14.3 32 32s-14.3 32-32 32H400V240 416h16c17.7 0 32 14.3 32 32s-14.3 32-32 32H368 320c-17.7 0-32-14.3-32-32s14.3-32 32-32h16V272H112V416h16c17.7 0 32 14.3 32 32s-14.3 32-32 32H80 32c-17.7 0-32-14.3-32-32s14.3-32 32-32H48V240 96H32C14.3 96 0 81.7 0 64z"
    ]
};
var $d8206b3ab2e65c05$export$579f9604bb10a61a = $d8206b3ab2e65c05$export$4805b8d175aeb9fb;
var $d8206b3ab2e65c05$export$1a989eb1919c64c1 = {
    prefix: "fas",
    iconName: "ghost",
    icon: [
        384,
        512,
        [
            128123
        ],
        "f6e2",
        "M40.1 467.1l-11.2 9c-3.2 2.5-7.1 3.9-11.1 3.9C8 480 0 472 0 462.2V192C0 86 86 0 192 0S384 86 384 192V462.2c0 9.8-8 17.8-17.8 17.8c-4 0-7.9-1.4-11.1-3.9l-11.2-9c-13.4-10.7-32.8-9-44.1 3.9L269.3 506c-3.3 3.8-8.2 6-13.3 6s-9.9-2.2-13.3-6l-26.6-30.5c-12.7-14.6-35.4-14.6-48.2 0L141.3 506c-3.3 3.8-8.2 6-13.3 6s-9.9-2.2-13.3-6L84.2 471c-11.3-12.9-30.7-14.6-44.1-3.9zM160 192a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm96 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
var $d8206b3ab2e65c05$export$6cfc59842fedbc16 = {
    prefix: "fas",
    iconName: "list",
    icon: [
        512,
        512,
        [
            "list-squares"
        ],
        "f03a",
        "M40 48C26.7 48 16 58.7 16 72v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V72c0-13.3-10.7-24-24-24H40zM192 64c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zM16 232v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V232c0-13.3-10.7-24-24-24H40c-13.3 0-24 10.7-24 24zM40 368c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V392c0-13.3-10.7-24-24-24H40z"
    ]
};
var $d8206b3ab2e65c05$export$e3f160fc949c2b9d = $d8206b3ab2e65c05$export$6cfc59842fedbc16;
var $d8206b3ab2e65c05$export$b627121801cad756 = {
    prefix: "fas",
    iconName: "square-phone-flip",
    icon: [
        448,
        512,
        [
            "phone-square-alt"
        ],
        "f87b",
        "M384 32c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H384zm-90.7 96.7c-9.7-2.6-19.9 2.3-23.7 11.6l-20 48c-3.4 8.2-1 17.6 5.8 23.2L280 231.7c-16.6 35.2-45.1 63.7-80.3 80.3l-20.2-24.7c-5.6-6.8-15-9.2-23.2-5.8l-48 20c-9.3 3.9-14.2 14-11.6 23.7l12 44C111.1 378 119 384 128 384c123.7 0 224-100.3 224-224c0-9-6-16.9-14.7-19.3l-44-12z"
    ]
};
var $d8206b3ab2e65c05$export$a41e77f0de98bba7 = $d8206b3ab2e65c05$export$b627121801cad756;
var $d8206b3ab2e65c05$export$6675e2bf21fdb87e = {
    prefix: "fas",
    iconName: "cart-plus",
    icon: [
        576,
        512,
        [],
        "f217",
        "M0 24C0 10.7 10.7 0 24 0H69.5c22 0 41.5 12.8 50.6 32h411c26.3 0 45.5 25 38.6 50.4l-41 152.3c-8.5 31.4-37 53.3-69.5 53.3H170.7l5.4 28.5c2.2 11.3 12.1 19.5 23.6 19.5H488c13.3 0 24 10.7 24 24s-10.7 24-24 24H199.7c-34.6 0-64.3-24.6-70.7-58.5L77.4 54.5c-.7-3.8-4-6.5-7.9-6.5H24C10.7 48 0 37.3 0 24zM128 464a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm336-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM252 160c0 11 9 20 20 20h44v44c0 11 9 20 20 20s20-9 20-20V180h44c11 0 20-9 20-20s-9-20-20-20H356V96c0-11-9-20-20-20s-20 9-20 20v44H272c-11 0-20 9-20 20z"
    ]
};
var $d8206b3ab2e65c05$export$6a66b1b639455bef = {
    prefix: "fas",
    iconName: "gamepad",
    icon: [
        640,
        512,
        [],
        "f11b",
        "M192 64C86 64 0 150 0 256S86 448 192 448H448c106 0 192-86 192-192s-86-192-192-192H192zM496 168a40 40 0 1 1 0 80 40 40 0 1 1 0-80zM392 304a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zM168 200c0-13.3 10.7-24 24-24s24 10.7 24 24v32h32c13.3 0 24 10.7 24 24s-10.7 24-24 24H216v32c0 13.3-10.7 24-24 24s-24-10.7-24-24V280H136c-13.3 0-24-10.7-24-24s10.7-24 24-24h32V200z"
    ]
};
var $d8206b3ab2e65c05$export$aa13d9234890e8d3 = {
    prefix: "fas",
    iconName: "circle-dot",
    icon: [
        512,
        512,
        [
            128280,
            "dot-circle"
        ],
        "f192",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-352a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"
    ]
};
var $d8206b3ab2e65c05$export$92bc269cb244d66a = $d8206b3ab2e65c05$export$aa13d9234890e8d3;
var $d8206b3ab2e65c05$export$635e4d8cc8428961 = {
    prefix: "fas",
    iconName: "face-dizzy",
    icon: [
        512,
        512,
        [
            "dizzy"
        ],
        "f567",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-224a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM100.7 132.7c6.2-6.2 16.4-6.2 22.6 0L160 169.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L182.6 192l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L160 214.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L137.4 192l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6zm192 0c6.2-6.2 16.4-6.2 22.6 0L352 169.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L374.6 192l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L352 214.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L329.4 192l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6z"
    ]
};
var $d8206b3ab2e65c05$export$89a2b10dabc487e8 = $d8206b3ab2e65c05$export$635e4d8cc8428961;
var $d8206b3ab2e65c05$export$1199a8ce85311ab5 = {
    prefix: "fas",
    iconName: "egg",
    icon: [
        384,
        512,
        [
            129370
        ],
        "f7fb",
        "M192 496C86 496 0 394 0 288C0 176 64 16 192 16s192 160 192 272c0 106-86 208-192 208zM154.8 134c6.5-6 7-16.1 1-22.6s-16.1-7-22.6-1c-23.9 21.8-41.1 52.7-52.3 84.2C69.7 226.1 64 259.7 64 288c0 8.8 7.2 16 16 16s16-7.2 16-16c0-24.5 5-54.4 15.1-82.8c10.1-28.5 25-54.1 43.7-71.2z"
    ]
};
var $d8206b3ab2e65c05$export$bf221f0e8296233e = {
    prefix: "fas",
    iconName: "house-medical-circle-xmark",
    icon: [
        640,
        512,
        [],
        "e513",
        "M320 368c0 59.5 29.5 112.1 74.8 144H128.1c-35.3 0-64-28.7-64-64V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L522.1 193.9c-8.5-1.3-17.3-1.9-26.1-1.9c-54.7 0-103.5 24.9-135.8 64H320V208c0-8.8-7.2-16-16-16H272c-8.8 0-16 7.2-16 16v48H208c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16zM496 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm22.6 144l36.7-36.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L496 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L473.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L496 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L518.6 368z"
    ]
};
var $d8206b3ab2e65c05$export$295287303c0e9c7c = {
    prefix: "fas",
    iconName: "campground",
    icon: [
        576,
        512,
        [
            9978
        ],
        "f6bb",
        "M377 52c11-13.8 8.8-33.9-5-45s-33.9-8.8-45 5L288 60.8 249 12c-11-13.8-31.2-16-45-5s-16 31.2-5 45l48 60L12.3 405.4C4.3 415.4 0 427.7 0 440.4V464c0 26.5 21.5 48 48 48H288 528c26.5 0 48-21.5 48-48V440.4c0-12.7-4.3-25.1-12.3-35L329 112l48-60zM288 448H168.5L288 291.7 407.5 448H288z"
    ]
};
var $d8206b3ab2e65c05$export$e18e05ffa2045d3b = {
    prefix: "fas",
    iconName: "folder-plus",
    icon: [
        512,
        512,
        [],
        "f65e",
        "M512 416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H192c20.1 0 39.1 9.5 51.2 25.6l19.2 25.6c6 8.1 15.5 12.8 25.6 12.8H448c35.3 0 64 28.7 64 64V416zM232 376c0 13.3 10.7 24 24 24s24-10.7 24-24V312h64c13.3 0 24-10.7 24-24s-10.7-24-24-24H280V200c0-13.3-10.7-24-24-24s-24 10.7-24 24v64H168c-13.3 0-24 10.7-24 24s10.7 24 24 24h64v64z"
    ]
};
var $d8206b3ab2e65c05$export$65a345b33858a655 = {
    prefix: "fas",
    iconName: "futbol",
    icon: [
        512,
        512,
        [
            9917,
            "futbol-ball",
            "soccer-ball"
        ],
        "f1e3",
        "M417.3 360.1l-71.6-4.8c-5.2-.3-10.3 1.1-14.5 4.2s-7.2 7.4-8.4 12.5l-17.6 69.6C289.5 445.8 273 448 256 448s-33.5-2.2-49.2-6.4L189.2 372c-1.3-5-4.3-9.4-8.4-12.5s-9.3-4.5-14.5-4.2l-71.6 4.8c-17.6-27.2-28.5-59.2-30.4-93.6L125 228.3c4.4-2.8 7.6-7 9.2-11.9s1.4-10.2-.5-15l-26.7-66.6C128 109.2 155.3 89 186.7 76.9l55.2 46c4 3.3 9 5.1 14.1 5.1s10.2-1.8 14.1-5.1l55.2-46c31.3 12.1 58.7 32.3 79.6 57.9l-26.7 66.6c-1.9 4.8-2.1 10.1-.5 15s4.9 9.1 9.2 11.9l60.7 38.2c-1.9 34.4-12.8 66.4-30.4 93.6zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm14.1-325.7c-8.4-6.1-19.8-6.1-28.2 0L194 221c-8.4 6.1-11.9 16.9-8.7 26.8l18.3 56.3c3.2 9.9 12.4 16.6 22.8 16.6h59.2c10.4 0 19.6-6.7 22.8-16.6l18.3-56.3c3.2-9.9-.3-20.7-8.7-26.8l-47.9-34.8z"
    ]
};
var $d8206b3ab2e65c05$export$51a344ca0a215620 = $d8206b3ab2e65c05$export$65a345b33858a655;
var $d8206b3ab2e65c05$export$f4a29712c724ba2d = $d8206b3ab2e65c05$export$65a345b33858a655;
var $d8206b3ab2e65c05$export$7c8b56f3f296a814 = {
    prefix: "fas",
    iconName: "paintbrush",
    icon: [
        576,
        512,
        [
            128396,
            "paint-brush"
        ],
        "f1fc",
        "M339.3 367.1c27.3-3.9 51.9-19.4 67.2-42.9L568.2 74.1c12.6-19.5 9.4-45.3-7.6-61.2S517.7-4.4 499.1 9.6L262.4 187.2c-24 18-38.2 46.1-38.4 76.1L339.3 367.1zm-19.6 25.4l-116-104.4C143.9 290.3 96 339.6 96 400c0 3.9 .2 7.8 .6 11.6C98.4 429.1 86.4 448 68.8 448H64c-17.7 0-32 14.3-32 32s14.3 32 32 32H208c61.9 0 112-50.1 112-112c0-2.5-.1-5-.2-7.5z"
    ]
};
var $d8206b3ab2e65c05$export$594db3339e212bc9 = $d8206b3ab2e65c05$export$7c8b56f3f296a814;
var $d8206b3ab2e65c05$export$7aa08ad5d562578a = {
    prefix: "fas",
    iconName: "lock",
    icon: [
        448,
        512,
        [
            128274
        ],
        "f023",
        "M144 144v48H304V144c0-44.2-35.8-80-80-80s-80 35.8-80 80zM80 192V144C80 64.5 144.5 0 224 0s144 64.5 144 144v48h16c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V256c0-35.3 28.7-64 64-64H80z"
    ]
};
var $d8206b3ab2e65c05$export$84666c793cb2a347 = {
    prefix: "fas",
    iconName: "gas-pump",
    icon: [
        512,
        512,
        [
            9981
        ],
        "f52f",
        "M32 64C32 28.7 60.7 0 96 0H256c35.3 0 64 28.7 64 64V256h8c48.6 0 88 39.4 88 88v32c0 13.3 10.7 24 24 24s24-10.7 24-24V222c-27.6-7.1-48-32.2-48-62V96L384 64c-8.8-8.8-8.8-23.2 0-32s23.2-8.8 32 0l77.3 77.3c12 12 18.7 28.3 18.7 45.3V168v24 32V376c0 39.8-32.2 72-72 72s-72-32.2-72-72V344c0-22.1-17.9-40-40-40h-8V448c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32V64zM96 80v96c0 8.8 7.2 16 16 16H240c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16H112c-8.8 0-16 7.2-16 16z"
    ]
};
var $d8206b3ab2e65c05$export$6e6bd68568c17bbf = {
    prefix: "fas",
    iconName: "hot-tub-person",
    icon: [
        512,
        512,
        [
            "hot-tub"
        ],
        "f593",
        "M272 24c0-13.3-10.7-24-24-24s-24 10.7-24 24v5.2c0 34 14.4 66.4 39.7 89.2l16.4 14.8c15.2 13.7 23.8 33.1 23.8 53.5V200c0 13.3 10.7 24 24 24s24-10.7 24-24V186.8c0-34-14.4-66.4-39.7-89.2L295.8 82.8C280.7 69.1 272 49.7 272 29.2V24zM0 320v16V448c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V320c0-35.3-28.7-64-64-64H277.3c-13.8 0-27.3-4.5-38.4-12.8l-85.3-64C137 166.7 116.8 160 96 160c-53 0-96 43-96 96v64zm128 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V336c0-8.8 7.2-16 16-16s16 7.2 16 16zm80-16c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V336c0-8.8 7.2-16 16-16zm112 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V336c0-8.8 7.2-16 16-16s16 7.2 16 16zm80-16c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V336c0-8.8 7.2-16 16-16zM360 0c-13.3 0-24 10.7-24 24v5.2c0 34 14.4 66.4 39.7 89.2l16.4 14.8c15.2 13.7 23.8 33.1 23.8 53.5V200c0 13.3 10.7 24 24 24s24-10.7 24-24V186.8c0-34-14.4-66.4-39.7-89.2L407.8 82.8C392.7 69.1 384 49.7 384 29.2V24c0-13.3-10.7-24-24-24zM64 128A64 64 0 1 0 64 0a64 64 0 1 0 0 128z"
    ]
};
var $d8206b3ab2e65c05$export$4842af92b516c40b = $d8206b3ab2e65c05$export$6e6bd68568c17bbf;
var $d8206b3ab2e65c05$export$9a8788ec0e4a9a0b = {
    prefix: "fas",
    iconName: "map-location",
    icon: [
        576,
        512,
        [
            "map-marked"
        ],
        "f59f",
        "M302.8 312C334.9 271.9 408 174.6 408 120C408 53.7 354.3 0 288 0S168 53.7 168 120c0 54.6 73.1 151.9 105.2 192c7.7 9.6 22 9.6 29.6 0zM416 503l144.9-58c9.1-3.6 15.1-12.5 15.1-22.3V152c0-17-17.1-28.6-32.9-22.3l-116 46.4c-.5 1.2-1 2.5-1.5 3.7c-2.9 6.8-6.1 13.7-9.6 20.6V503zM15.1 187.3C6 191 0 199.8 0 209.6V480.4c0 17 17.1 28.6 32.9 22.3L160 451.8V200.4c-3.5-6.9-6.7-13.8-9.6-20.6c-5.6-13.2-10.4-27.4-12.8-41.5l-122.6 49zM384 255c-20.5 31.3-42.3 59.6-56.2 77c-20.5 25.6-59.1 25.6-79.6 0c-13.9-17.4-35.7-45.7-56.2-77V449.4l192 54.9V255z"
    ]
};
var $d8206b3ab2e65c05$export$df04458e7e32352c = $d8206b3ab2e65c05$export$9a8788ec0e4a9a0b;
var $d8206b3ab2e65c05$export$70fd6006b4e54a5 = {
    prefix: "fas",
    iconName: "house-flood-water",
    icon: [
        576,
        512,
        [],
        "e50e",
        "M306.8 6.1C295.6-2 280.4-2 269.2 6.1l-176 128c-11.2 8.2-15.9 22.6-11.6 35.8S98.1 192 112 192h16v73c1.7 1 3.3 2 4.9 3.1c18 12.4 40.1 20.3 59.2 20.3c21.1 0 42-8.5 59.2-20.3c22.1-15.5 51.6-15.5 73.7 0c18.4 12.7 39.6 20.3 59.2 20.3c19 0 41.2-7.9 59.2-20.3c1.5-1 3-2 4.5-2.9l-.3-73.2H464c13.9 0 26.1-8.9 30.4-22.1s-.4-27.6-11.6-35.8l-176-128zM269.5 309.9C247 325.4 219.5 336 192 336c-26.9 0-55.3-10.8-77.4-26.1l0 0c-11.9-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C126.5 389.7 159 400 192 400c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.5-27.3-10.1-39.2-1.7l0 0C439.4 325.2 410.9 336 384 336c-27.5 0-55-10.6-77.5-26.1c-11.1-7.9-25.9-7.9-37 0zM384 448c-27.5 0-55-10.6-77.5-26.1c-11.1-7.9-25.9-7.9-37 0C247 437.4 219.5 448 192 448c-26.9 0-55.3-10.8-77.4-26.1l0 0c-11.9-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C126.5 501.7 159 512 192 512c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.4-27.3-10.1-39.2-1.7l0 0C439.4 437.2 410.9 448 384 448z"
    ]
};
var $d8206b3ab2e65c05$export$1744430f718caf6b = {
    prefix: "fas",
    iconName: "tree",
    icon: [
        448,
        512,
        [
            127794
        ],
        "f1bb",
        "M210.6 5.9L62 169.4c-3.9 4.2-6 9.8-6 15.5C56 197.7 66.3 208 79.1 208H104L30.6 281.4c-4.2 4.2-6.6 10-6.6 16C24 309.9 34.1 320 46.6 320H80L5.4 409.5C1.9 413.7 0 419 0 424.5c0 13 10.5 23.5 23.5 23.5H192v32c0 17.7 14.3 32 32 32s32-14.3 32-32V448H424.5c13 0 23.5-10.5 23.5-23.5c0-5.5-1.9-10.8-5.4-15L368 320h33.4c12.5 0 22.6-10.1 22.6-22.6c0-6-2.4-11.8-6.6-16L344 208h24.9c12.7 0 23.1-10.3 23.1-23.1c0-5.7-2.1-11.3-6-15.5L237.4 5.9C234 2.1 229.1 0 224 0s-10 2.1-13.4 5.9z"
    ]
};
var $d8206b3ab2e65c05$export$cffe7d85a82d8116 = {
    prefix: "fas",
    iconName: "bridge-lock",
    icon: [
        640,
        512,
        [],
        "e4cc",
        "M32 64c0-17.7 14.3-32 32-32H576c17.7 0 32 14.3 32 32s-14.3 32-32 32H536v64h-8c-61.9 0-112 50.1-112 112v24.6c-9.9 5.8-18.2 14.1-23.8 24.1c-17.6-20-43.4-32.7-72.2-32.7c-53 0-96 43-96 96v64c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32V384c0-53-43-96-96-96V160h72V96H64C46.3 96 32 81.7 32 64zM408 96v64h80V96H408zm-48 64V96H280v64h80zM152 96v64h80V96H152zM528 240c-17.7 0-32 14.3-32 32v48h64V272c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80v48c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32V272z"
    ]
};
var $d8206b3ab2e65c05$export$15854c4475080853 = {
    prefix: "fas",
    iconName: "sack-dollar",
    icon: [
        512,
        512,
        [
            128176
        ],
        "f81d",
        "M320 96H192L144.6 24.9C137.5 14.2 145.1 0 157.9 0H354.1c12.8 0 20.4 14.2 13.3 24.9L320 96zM192 128H320c3.8 2.5 8.1 5.3 13 8.4C389.7 172.7 512 250.9 512 416c0 53-43 96-96 96H96c-53 0-96-43-96-96C0 250.9 122.3 172.7 179 136.4l0 0 0 0c4.8-3.1 9.2-5.9 13-8.4zm84 88c0-11-9-20-20-20s-20 9-20 20v14c-7.6 1.7-15.2 4.4-22.2 8.5c-13.9 8.3-25.9 22.8-25.8 43.9c.1 20.3 12 33.1 24.7 40.7c11 6.6 24.7 10.8 35.6 14l1.7 .5c12.6 3.8 21.8 6.8 28 10.7c5.1 3.2 5.8 5.4 5.9 8.2c.1 5-1.8 8-5.9 10.5c-5 3.1-12.9 5-21.4 4.7c-11.1-.4-21.5-3.9-35.1-8.5c-2.3-.8-4.7-1.6-7.2-2.4c-10.5-3.5-21.8 2.2-25.3 12.6s2.2 21.8 12.6 25.3c1.9 .6 4 1.3 6.1 2.1l0 0 0 0c8.3 2.9 17.9 6.2 28.2 8.4V424c0 11 9 20 20 20s20-9 20-20V410.2c8-1.7 16-4.5 23.2-9c14.3-8.9 25.1-24.1 24.8-45c-.3-20.3-11.7-33.4-24.6-41.6c-11.5-7.2-25.9-11.6-37.1-15l0 0-.7-.2c-12.8-3.9-21.9-6.7-28.3-10.5c-5.2-3.1-5.3-4.9-5.3-6.7c0-3.7 1.4-6.5 6.2-9.3c5.4-3.2 13.6-5.1 21.5-5c9.6 .1 20.2 2.2 31.2 5.2c10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-6.5-1.7-13.7-3.4-21.1-4.7V216z"
    ]
};
var $d8206b3ab2e65c05$export$ba236543926e3569 = {
    prefix: "fas",
    iconName: "pen-to-square",
    icon: [
        512,
        512,
        [
            "edit"
        ],
        "f044",
        "M471.6 21.7c-21.9-21.9-57.3-21.9-79.2 0L362.3 51.7l97.9 97.9 30.1-30.1c21.9-21.9 21.9-57.3 0-79.2L471.6 21.7zm-299.2 220c-6.1 6.1-10.8 13.6-13.5 21.9l-29.6 88.8c-2.9 8.6-.6 18.1 5.8 24.6s15.9 8.7 24.6 5.8l88.8-29.6c8.2-2.7 15.7-7.4 21.9-13.5L437.7 172.3 339.7 74.3 172.4 241.7zM96 64C43 64 0 107 0 160V416c0 53 43 96 96 96H352c53 0 96-43 96-96V320c0-17.7-14.3-32-32-32s-32 14.3-32 32v96c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H96z"
    ]
};
var $d8206b3ab2e65c05$export$7be713e57d023733 = $d8206b3ab2e65c05$export$ba236543926e3569;
var $d8206b3ab2e65c05$export$6f7218565b1b8d0e = {
    prefix: "fas",
    iconName: "car-side",
    icon: [
        640,
        512,
        [
            128663
        ],
        "f5e4",
        "M171.3 96H224v96H111.3l30.4-75.9C146.5 104 158.2 96 171.3 96zM272 192V96h81.2c9.7 0 18.9 4.4 25 12l67.2 84H272zm256.2 1L428.2 68c-18.2-22.8-45.8-36-75-36H171.3c-39.3 0-74.6 23.9-89.1 60.3L40.6 196.4C16.8 205.8 0 228.9 0 256V368c0 17.7 14.3 32 32 32H65.3c7.6 45.4 47.1 80 94.7 80s87.1-34.6 94.7-80H385.3c7.6 45.4 47.1 80 94.7 80s87.1-34.6 94.7-80H608c17.7 0 32-14.3 32-32V320c0-65.2-48.8-119-111.8-127zM434.7 368a48 48 0 1 1 90.5 32 48 48 0 1 1 -90.5-32zM160 336a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
    ]
};
var $d8206b3ab2e65c05$export$cdaf45d4e50ac035 = {
    prefix: "fas",
    iconName: "share-nodes",
    icon: [
        448,
        512,
        [
            "share-alt"
        ],
        "f1e0",
        "M352 224c53 0 96-43 96-96s-43-96-96-96s-96 43-96 96c0 4 .2 8 .7 11.9l-94.1 47C145.4 170.2 121.9 160 96 160c-53 0-96 43-96 96s43 96 96 96c25.9 0 49.4-10.2 66.6-26.9l94.1 47c-.5 3.9-.7 7.8-.7 11.9c0 53 43 96 96 96s96-43 96-96s-43-96-96-96c-25.9 0-49.4 10.2-66.6 26.9l-94.1-47c.5-3.9 .7-7.8 .7-11.9s-.2-8-.7-11.9l94.1-47C302.6 213.8 326.1 224 352 224z"
    ]
};
var $d8206b3ab2e65c05$export$f8e8bb0b3aa8c658 = $d8206b3ab2e65c05$export$cdaf45d4e50ac035;
var $d8206b3ab2e65c05$export$24c21c3ca00f3625 = {
    prefix: "fas",
    iconName: "heart-circle-minus",
    icon: [
        576,
        512,
        [],
        "e4ff",
        "M47.6 300.4L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9l2.6-2.4C267.2 438.6 256 404.6 256 368c0-97.2 78.8-176 176-176c28.3 0 55 6.7 78.7 18.5c.9-6.5 1.3-13 1.3-19.6v-5.8c0-69.9-50.5-129.5-119.4-141C347 36.5 300.6 51.4 268 84L256 96 244 84c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5zM576 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-64 0c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16s7.2-16 16-16H496c8.8 0 16 7.2 16 16z"
    ]
};
var $d8206b3ab2e65c05$export$703272eebf5e3eea = {
    prefix: "fas",
    iconName: "hourglass-half",
    icon: [
        384,
        512,
        [
            "hourglass-2"
        ],
        "f252",
        "M32 0C14.3 0 0 14.3 0 32S14.3 64 32 64V75c0 42.4 16.9 83.1 46.9 113.1L146.7 256 78.9 323.9C48.9 353.9 32 394.6 32 437v11c-17.7 0-32 14.3-32 32s14.3 32 32 32H64 320h32c17.7 0 32-14.3 32-32s-14.3-32-32-32V437c0-42.4-16.9-83.1-46.9-113.1L237.3 256l67.9-67.9c30-30 46.9-70.7 46.9-113.1V64c17.7 0 32-14.3 32-32s-14.3-32-32-32H320 64 32zM96 75V64H288V75c0 19-5.6 37.4-16 53H112c-10.3-15.6-16-34-16-53zm16 309c3.5-5.3 7.6-10.3 12.1-14.9L192 301.3l67.9 67.9c4.6 4.6 8.6 9.6 12.1 14.9H112z"
    ]
};
var $d8206b3ab2e65c05$export$f1052bbf6bf361c0 = $d8206b3ab2e65c05$export$703272eebf5e3eea;
var $d8206b3ab2e65c05$export$6a99139787bf9967 = {
    prefix: "fas",
    iconName: "microscope",
    icon: [
        512,
        512,
        [
            128300
        ],
        "f610",
        "M160 32c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32c17.7 0 32 14.3 32 32V288c0 17.7-14.3 32-32 32c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32zM32 448H320c70.7 0 128-57.3 128-128s-57.3-128-128-128V128c106 0 192 86 192 192c0 49.2-18.5 94-48.9 128H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H320 32c-17.7 0-32-14.3-32-32s14.3-32 32-32zm80-64H304c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
    ]
};
var $d8206b3ab2e65c05$export$2a9dda2096ce792e = {
    prefix: "fas",
    iconName: "sink",
    icon: [
        512,
        512,
        [],
        "e06d",
        "M288 96c0-17.7 14.3-32 32-32s32 14.3 32 32s14.3 32 32 32s32-14.3 32-32c0-53-43-96-96-96s-96 43-96 96V288H160V264c0-30.9-25.1-56-56-56H56c-13.3 0-24 10.7-24 24s10.7 24 24 24h48c4.4 0 8 3.6 8 8v24H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H256 480c17.7 0 32-14.3 32-32s-14.3-32-32-32H400V264c0-4.4 3.6-8 8-8h56c13.3 0 24-10.7 24-24s-10.7-24-24-24H408c-30.9 0-56 25.1-56 56v24H288V96zM480 416V384H32v32c0 53 43 96 96 96H384c53 0 96-43 96-96z"
    ]
};
var $d8206b3ab2e65c05$export$b0137b4600e9ab12 = {
    prefix: "fas",
    iconName: "bag-shopping",
    icon: [
        448,
        512,
        [
            "shopping-bag"
        ],
        "f290",
        "M160 112c0-35.3 28.7-64 64-64s64 28.7 64 64v48H160V112zm-48 48H48c-26.5 0-48 21.5-48 48V416c0 53 43 96 96 96H352c53 0 96-43 96-96V208c0-26.5-21.5-48-48-48H336V112C336 50.1 285.9 0 224 0S112 50.1 112 112v48zm24 48a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm152 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"
    ]
};
var $d8206b3ab2e65c05$export$5745f8adbc11eb01 = $d8206b3ab2e65c05$export$b0137b4600e9ab12;
var $d8206b3ab2e65c05$export$cf79d63ad07d943a = {
    prefix: "fas",
    iconName: "arrow-down-z-a",
    icon: [
        576,
        512,
        [
            "sort-alpha-desc",
            "sort-alpha-down-alt"
        ],
        "f881",
        "M183.6 469.6C177.5 476.2 169 480 160 480s-17.5-3.8-23.6-10.4l-88-96c-11.9-13-11.1-33.3 2-45.2s33.3-11.1 45.2 2L128 365.7V64c0-17.7 14.3-32 32-32s32 14.3 32 32V365.7l32.4-35.4c11.9-13 32.2-13.9 45.2-2s13.9 32.2 2 45.2l-88 96zM320 64c0-17.7 14.3-32 32-32H480c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9L429.3 160H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H352c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9L402.7 96H352c-17.7 0-32-14.3-32-32zm96 192c12.1 0 23.2 6.8 28.6 17.7l64 128 16 32c7.9 15.8 1.5 35-14.3 42.9s-35 1.5-42.9-14.3L460.2 448H371.8l-7.2 14.3c-7.9 15.8-27.1 22.2-42.9 14.3s-22.2-27.1-14.3-42.9l16-32 64-128c5.4-10.8 16.5-17.7 28.6-17.7zM395.8 400h40.4L416 359.6 395.8 400z"
    ]
};
var $d8206b3ab2e65c05$export$7caf99612a55d427 = $d8206b3ab2e65c05$export$cf79d63ad07d943a;
var $d8206b3ab2e65c05$export$e12d23d82d5c8a89 = $d8206b3ab2e65c05$export$cf79d63ad07d943a;
var $d8206b3ab2e65c05$export$5030322c5fc886d7 = {
    prefix: "fas",
    iconName: "mitten",
    icon: [
        448,
        512,
        [],
        "f7b5",
        "M352 384H64L5.4 178.9C1.8 166.4 0 153.4 0 140.3C0 62.8 62.8 0 140.3 0h3.4c66 0 123.5 44.9 139.5 108.9l31.4 125.8 17.6-20.1C344.8 200.2 362.9 192 382 192h2.8c34.9 0 63.3 28.3 63.3 63.3c0 15.9-6 31.2-16.8 42.9L352 384zM32 448c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V448z"
    ]
};
var $d8206b3ab2e65c05$export$49577f913f0fe4d2 = {
    prefix: "fas",
    iconName: "person-rays",
    icon: [
        512,
        512,
        [],
        "e54d",
        "M208 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm40 304V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V256.9l-28.6 47.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c17.4-28.9 48.6-46.6 82.3-46.6h29.7c33.7 0 64.9 17.7 82.3 46.6l58.3 97c9.1 15.1 4.2 34.8-10.9 43.9s-34.8 4.2-43.9-10.9L328 256.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352H248zM7 7C16.4-2.3 31.6-2.3 41 7l80 80c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L7 41C-2.3 31.6-2.3 16.4 7 7zM471 7c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-80 80c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L471 7zM7 505c-9.4-9.4-9.4-24.6 0-33.9l80-80c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L41 505c-9.4 9.4-24.6 9.4-33.9 0zm464 0l-80-80c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l80 80c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0z"
    ]
};
var $d8206b3ab2e65c05$export$e5a8f011aef571ac = {
    prefix: "fas",
    iconName: "users",
    icon: [
        640,
        512,
        [],
        "f0c0",
        "M144 0a80 80 0 1 1 0 160A80 80 0 1 1 144 0zM512 0a80 80 0 1 1 0 160A80 80 0 1 1 512 0zM0 298.7C0 239.8 47.8 192 106.7 192h42.7c15.9 0 31 3.5 44.6 9.7c-1.3 7.2-1.9 14.7-1.9 22.3c0 38.2 16.8 72.5 43.3 96c-.2 0-.4 0-.7 0H21.3C9.6 320 0 310.4 0 298.7zM405.3 320c-.2 0-.4 0-.7 0c26.6-23.5 43.3-57.8 43.3-96c0-7.6-.7-15-1.9-22.3c13.6-6.3 28.7-9.7 44.6-9.7h42.7C592.2 192 640 239.8 640 298.7c0 11.8-9.6 21.3-21.3 21.3H405.3zM224 224a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zM128 485.3C128 411.7 187.7 352 261.3 352H378.7C452.3 352 512 411.7 512 485.3c0 14.7-11.9 26.7-26.7 26.7H154.7c-14.7 0-26.7-11.9-26.7-26.7z"
    ]
};
var $d8206b3ab2e65c05$export$ed3f2918429d029a = {
    prefix: "fas",
    iconName: "eye-slash",
    icon: [
        640,
        512,
        [],
        "f070",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L525.6 386.7c39.6-40.6 66.4-86.1 79.9-118.4c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C465.5 68.8 400.8 32 320 32c-68.2 0-125 26.3-169.3 60.8L38.8 5.1zM223.1 149.5C248.6 126.2 282.7 112 320 112c79.5 0 144 64.5 144 144c0 24.9-6.3 48.3-17.4 68.7L408 294.5c8.4-19.3 10.6-41.4 4.8-63.3c-11.1-41.5-47.8-69.4-88.6-71.1c-5.8-.2-9.2 6.1-7.4 11.7c2.1 6.4 3.3 13.2 3.3 20.3c0 10.2-2.4 19.8-6.6 28.3l-90.3-70.8zM373 389.9c-16.4 6.5-34.3 10.1-53 10.1c-79.5 0-144-64.5-144-144c0-6.9 .5-13.6 1.4-20.2L83.1 161.5C60.3 191.2 44 220.8 34.5 243.7c-3.3 7.9-3.3 16.7 0 24.6c14.9 35.7 46.2 87.7 93 131.1C174.5 443.2 239.2 480 320 480c47.8 0 89.9-12.9 126.2-32.5L373 389.9z"
    ]
};
var $d8206b3ab2e65c05$export$a25a266ce0c95019 = {
    prefix: "fas",
    iconName: "flask-vial",
    icon: [
        640,
        512,
        [],
        "e4f3",
        "M175 389.4c-9.8 16-15 34.3-15 53.1c-10 3.5-20.8 5.5-32 5.5c-53 0-96-43-96-96V64C14.3 64 0 49.7 0 32S14.3 0 32 0H96h64 64c17.7 0 32 14.3 32 32s-14.3 32-32 32V309.9l-49 79.6zM96 64v96h64V64H96zM352 0H480h32c17.7 0 32 14.3 32 32s-14.3 32-32 32V214.9L629.7 406.2c6.7 10.9 10.3 23.5 10.3 36.4c0 38.3-31.1 69.4-69.4 69.4H261.4c-38.3 0-69.4-31.1-69.4-69.4c0-12.8 3.6-25.4 10.3-36.4L320 214.9V64c-17.7 0-32-14.3-32-32s14.3-32 32-32h32zm32 64V224c0 5.9-1.6 11.7-4.7 16.8L330.5 320h171l-48.8-79.2c-3.1-5-4.7-10.8-4.7-16.8V64H384z"
    ]
};
var $d8206b3ab2e65c05$export$f69db0b876f7d753 = {
    prefix: "fas",
    iconName: "hand",
    icon: [
        512,
        512,
        [
            129306,
            9995,
            "hand-paper"
        ],
        "f256",
        "M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V240c0 8.8-7.2 16-16 16s-16-7.2-16-16V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V336c0 1.5 0 3.1 .1 4.6L67.6 283c-16-15.2-41.3-14.6-56.6 1.4s-14.6 41.3 1.4 56.6L124.8 448c43.1 41.1 100.4 64 160 64H304c97.2 0 176-78.8 176-176V128c0-17.7-14.3-32-32-32s-32 14.3-32 32V240c0 8.8-7.2 16-16 16s-16-7.2-16-16V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V240c0 8.8-7.2 16-16 16s-16-7.2-16-16V32z"
    ]
};
var $d8206b3ab2e65c05$export$6e6216c8b50471bb = $d8206b3ab2e65c05$export$f69db0b876f7d753;
var $d8206b3ab2e65c05$export$8de8eb94230028a5 = {
    prefix: "fas",
    iconName: "om",
    icon: [
        512,
        512,
        [
            128329
        ],
        "f679",
        "M379.3 4.7c-6.2-6.2-16.4-6.2-22.6 0l-16 16c-6.2 6.2-6.2 16.4 0 22.6l16 16c6.2 6.2 16.4 6.2 22.6 0l16-16c6.2-6.2 6.2-16.4 0-22.6l-16-16zM281 66.7c-2.2-1.5-4.9-2.5-7.7-2.7c-.6 0-1.3-.1-1.9 0c-3.9 .2-7.4 1.7-10.1 4.2c-.9 .8-1.6 1.7-2.3 2.6c-1.7 2.4-2.7 5.3-2.9 8.5c0 .7 0 1.4 0 2.1c.2 2.2 .9 4.3 1.9 6.2l.3 .6c.3 .6 .8 1.4 1.4 2.4c1.2 2 2.9 4.8 5.1 8.2c4.4 6.7 11.1 15.5 20 24.4C302.4 141.1 330.3 160 368 160c31.2 0 56.6-10.4 73.9-20.2c8.7-5 15.6-9.9 20.4-13.8c2.4-1.9 4.3-3.6 5.7-4.9c.7-.6 1.3-1.2 1.7-1.6l.6-.5 .1-.1 .1-.1 0 0 0 0c5.9-5.8 9.5-13.9 9.5-22.8c0-17.7-14.3-32-32-32c-8.7 0-16.7 3.5-22.4 9.2c-.1 .1-.2 .2-.5 .4c-.5 .5-1.5 1.3-2.8 2.4c-2.7 2.2-6.8 5.2-12.1 8.2C399.4 90.4 384.8 96 368 96c-20.8 0-42.4-7-59.5-14.6c-8.4-3.7-15.4-7.5-20.3-10.3c-2.4-1.4-4.3-2.5-5.6-3.3c-.6-.4-1.1-.7-1.4-.9l-.3-.2zM115.2 169.6c8-6 17.9-9.6 28.8-9.6c26.5 0 48 21.5 48 48s-21.5 48-48 48H109.8c-7.6 0-13.8 6.2-13.8 13.8c0 1.5 .2 2.9 .7 4.4l8 24c4.4 13.1 16.6 21.9 30.4 21.9H144h16c35.3 0 64 28.7 64 64s-28.7 64-64 64c-50.8 0-82.7-21.5-102.2-42.8c-9.9-10.8-16.6-21.6-20.9-29.7c-2.1-4-3.6-7.3-4.5-9.6c-.5-1.1-.8-2-1-2.5l-.2-.5c-.3-.9-.7-1.8-1.1-2.6c-1.2-2.2-2.8-4-4.7-5.4c-1.9-1.4-4.1-2.3-6.5-2.8c-1.4-.3-2.9-.3-4.4-.2c-2.5 .2-4.8 1-6.8 2.3c-1.1 .7-2.2 1.5-3.1 2.5c-2.4 2.5-4.1 5.8-4.5 9.5c-.1 .6-.1 1.1-.1 1.7c0 0 0 0 0 0c0 .8 .1 1.7 .2 2.5l0 .1c0 .3 .1 .8 .2 1.3c.2 1.1 .4 2.7 .8 4.6c.8 3.9 2 9.4 3.9 15.9c3.8 13 10.3 30.4 21.3 48C48.7 476.2 89.4 512 160 512c70.7 0 128-57.3 128-128c0-23.3-6.2-45.2-17.1-64h22.6c25.5 0 49.9-10.1 67.9-28.1l26.5-26.5c6-6 14.1-9.4 22.6-9.4H416c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32c-25.7 0-41.4-12.5-51.2-25.6c-5-6.7-8.4-13.4-10.5-18.6c-1.1-2.5-1.8-4.6-2.2-6c-.2-.7-.4-1.2-.5-1.5l-.1-.2c-.3-1.3-.8-2.6-1.5-3.8c-1.1-2-2.6-3.8-4.4-5.1c-2.7-2-6-3.2-9.6-3.2l-.2 0c-8 .1-14.6 6.1-15.6 13.9l0 0c0 .3-.1 .6-.2 1.1c-.1 .9-.3 2.1-.4 3.6c-.3 3-.6 7.3-.6 12.4c0 10.1 1.1 23.9 5.8 38.1c4.8 14.3 13.4 29.3 28.6 40.7C368.7 473.3 389.3 480 416 480c53 0 96-43 96-96V288c0-53-43-96-96-96h-5.5c-25.5 0-49.9 10.1-67.9 28.1l-26.5 26.5c-6 6-14.1 9.4-22.6 9.4H245.2c6.9-14.5 10.8-30.8 10.8-48c0-61.9-50.1-112-112-112c-25.2 0-48.5 8.3-67.2 22.4c-14.1 10.6-17 30.7-6.4 44.8s30.7 17 44.8 6.4z"
    ]
};
var $d8206b3ab2e65c05$export$2571e33fa6c25993 = {
    prefix: "fas",
    iconName: "worm",
    icon: [
        512,
        512,
        [],
        "e599",
        "M256 96c0-53 43-96 96-96h38.4C439.9 0 480 40.1 480 89.6V176v16V376c0 75.1-60.9 136-136 136s-136-60.9-136-136V296c0-22.1-17.9-40-40-40s-40 17.9-40 40V464c0 26.5-21.5 48-48 48s-48-21.5-48-48V296c0-75.1 60.9-136 136-136s136 60.9 136 136v80c0 22.1 17.9 40 40 40s40-17.9 40-40V192H352c-53 0-96-43-96-96zm144-8a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"
    ]
};
var $d8206b3ab2e65c05$export$423555e8708eb4c7 = {
    prefix: "fas",
    iconName: "house-circle-xmark",
    icon: [
        640,
        512,
        [],
        "e50b",
        "M320.7 352c8.1-89.7 83.5-160 175.3-160c8.9 0 17.6 .7 26.1 1.9L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24c0 18 14 32.1 32 32.1h32v69.7c-.1 .9-.1 1.8-.1 2.8V472c0 22.1 17.9 40 40 40h16c1.2 0 2.4-.1 3.6-.2c1.5 .1 3 .2 4.5 .2H160h24c22.1 0 40-17.9 40-40V448 384c0-17.7 14.3-32 32-32h64l.7 0zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm59.3-180.7L518.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L473.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L496 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
    ]
};
var $d8206b3ab2e65c05$export$cae5752c3e3b6545 = {
    prefix: "fas",
    iconName: "plug",
    icon: [
        384,
        512,
        [
            128268
        ],
        "f1e6",
        "M96 0C78.3 0 64 14.3 64 32v96h64V32c0-17.7-14.3-32-32-32zM288 0c-17.7 0-32 14.3-32 32v96h64V32c0-17.7-14.3-32-32-32zM32 160c-17.7 0-32 14.3-32 32s14.3 32 32 32v32c0 77.4 55 142 128 156.8V480c0 17.7 14.3 32 32 32s32-14.3 32-32V412.8C297 398 352 333.4 352 256V224c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z"
    ]
};
var $d8206b3ab2e65c05$export$877e5ae47a854215 = {
    prefix: "fas",
    iconName: "chevron-up",
    icon: [
        512,
        512,
        [],
        "f077",
        "M233.4 105.4c12.5-12.5 32.8-12.5 45.3 0l192 192c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L256 173.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l192-192z"
    ]
};
var $d8206b3ab2e65c05$export$2262d6b626de1120 = {
    prefix: "fas",
    iconName: "hand-spock",
    icon: [
        576,
        512,
        [
            128406
        ],
        "f259",
        "M246.9 23.7C242.3 6.6 224.8-3.5 207.7 1.1s-27.2 22.1-22.6 39.2L238 237.8c2.5 9.2-4.5 18.2-14 18.2c-6.4 0-12-4.2-13.9-10.3L166.6 102.7c-5.1-16.9-23-26.4-39.9-21.3s-26.4 23-21.3 39.9l62.8 206.4c2.4 7.9-7.2 13.8-13.2 8.1L99.6 283c-16-15.2-41.3-14.6-56.6 1.4s-14.6 41.3 1.4 56.6L156.8 448c43.1 41.1 100.4 64 160 64h10.9 8.2c.1 0 .1-.1 .1-.1s.1-.1 .1-.1c58.3-3.5 108.6-43.2 125.3-99.7l81.2-275c5-16.9-4.7-34.7-21.6-39.8s-34.7 4.7-39.8 21.6L443.5 247.1c-1.6 5.3-6.4 8.9-12 8.9c-7.9 0-13.8-7.3-12.2-15.1l36-170.3c3.7-17.3-7.4-34.3-24.7-37.9s-34.3 7.4-37.9 24.7L355.1 235.1c-2.6 12.2-13.3 20.9-25.8 20.9c-11.9 0-22.4-8-25.4-19.5l-57-212.8z"
    ]
};
var $d8206b3ab2e65c05$export$b85a7300fc7960b6 = {
    prefix: "fas",
    iconName: "stopwatch",
    icon: [
        448,
        512,
        [
            9201
        ],
        "f2f2",
        "M176 0c-17.7 0-32 14.3-32 32s14.3 32 32 32h16V98.4C92.3 113.8 16 200 16 304c0 114.9 93.1 208 208 208s208-93.1 208-208c0-41.8-12.3-80.7-33.5-113.2l24.1-24.1c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L355.7 143c-28.1-23-62.2-38.8-99.7-44.6V64h16c17.7 0 32-14.3 32-32s-14.3-32-32-32H224 176zm72 192V320c0 13.3-10.7 24-24 24s-24-10.7-24-24V192c0-13.3 10.7-24 24-24s24 10.7 24 24z"
    ]
};
var $d8206b3ab2e65c05$export$5a54c83033a0a56a = {
    prefix: "fas",
    iconName: "face-kiss",
    icon: [
        512,
        512,
        [
            128535,
            "kiss"
        ],
        "f596",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm48.7-198.3c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4c-2.7 1.5-5.7 3-8.7 4.3c3.1 1.3 6 2.7 8.7 4.3c6.6 3.7 12.5 8.2 16.7 13.4c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4C274.7 443.1 257.4 448 240 448c-3.6 0-6.8-2.5-7.7-6s.6-7.2 3.8-9l0 0 0 0 0 0 0 0 .2-.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1c-.4-.2-.7-.4-.9-.5l-.2-.1 0 0 0 0 0 0c-2.5-1.4-4.1-4.1-4.1-7s1.6-5.6 4.1-7l0 0 0 0 0 0 0 0 0 0 .2-.1 .3-.2 .6-.4c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1l-.4-.3-.5-.3-.2-.1 0 0 0 0 0 0c-3.2-1.8-4.7-5.5-3.8-9s4.1-6 7.7-6c17.4 0 34.7 4.9 47.9 12.3c6.6 3.7 12.5 8.2 16.7 13.4zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $d8206b3ab2e65c05$export$c762a77aabf64fd0 = $d8206b3ab2e65c05$export$5a54c83033a0a56a;
var $d8206b3ab2e65c05$export$834071278537f121 = {
    prefix: "fas",
    iconName: "bridge-circle-xmark",
    icon: [
        640,
        512,
        [],
        "e4cb",
        "M64 32C46.3 32 32 46.3 32 64s14.3 32 32 32h40v64H32V288c53 0 96 43 96 96v64c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V384c0-53 43-96 96-96c6.3 0 12.4 .6 18.3 1.7C367.1 231.8 426.9 192 496 192c42.5 0 81.6 15.1 112 40.2V160H536V96h40c17.7 0 32-14.3 32-32s-14.3-32-32-32H64zM488 96v64H408V96h80zM360 96v64H280V96h80zM232 96v64H152V96h80zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm59.3-180.7L518.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L473.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L496 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
    ]
};
var $d8206b3ab2e65c05$export$95a7394c24f57943 = {
    prefix: "fas",
    iconName: "face-grin-tongue",
    icon: [
        512,
        512,
        [
            128539,
            "grin-tongue"
        ],
        "f589",
        "M0 256C0 368.9 73.1 464.7 174.5 498.8C165.3 484 160 466.6 160 448V400.7c-24-17.5-43.1-41.4-54.8-69.2c-5-11.8 7-22.5 19.3-18.7c39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19c12.3-3.8 24.3 6.9 19.3 18.7c-11.8 28-31.1 52-55.4 69.6V448c0 18.6-5.3 36-14.5 50.8C438.9 464.7 512 368.9 512 256C512 114.6 397.4 0 256 0S0 114.6 0 256zm176.4-80a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM320 448V402.6c0-14.7-11.9-26.6-26.6-26.6h-2c-11.3 0-21.1 7.9-23.6 18.9c-2.8 12.6-20.8 12.6-23.6 0c-2.5-11.1-12.3-18.9-23.6-18.9h-2c-14.7 0-26.6 11.9-26.6 26.6V448c0 35.3 28.7 64 64 64s64-28.7 64-64z"
    ]
};
var $d8206b3ab2e65c05$export$ef222816a43a4b3a = $d8206b3ab2e65c05$export$95a7394c24f57943;
var $d8206b3ab2e65c05$export$a831eedd2f59c62f = {
    prefix: "fas",
    iconName: "chess-bishop",
    icon: [
        320,
        512,
        [
            9821
        ],
        "f43a",
        "M128 0C110.3 0 96 14.3 96 32c0 16.1 11.9 29.4 27.4 31.7C78.4 106.8 8 190 8 288c0 47.4 30.8 72.3 56 84.7V400H256V372.7c25.2-12.5 56-37.4 56-84.7c0-37.3-10.2-72.4-25.3-104.1l-99.4 99.4c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L270.8 154.6c-23.2-38.1-51.8-69.5-74.2-90.9C212.1 61.4 224 48.1 224 32c0-17.7-14.3-32-32-32H128zM48 432L6.6 473.4c-4.2 4.2-6.6 10-6.6 16C0 501.9 10.1 512 22.6 512H297.4c12.5 0 22.6-10.1 22.6-22.6c0-6-2.4-11.8-6.6-16L272 432H48z"
    ]
};
var $d8206b3ab2e65c05$export$1dd161850c5bc64e = {
    prefix: "fas",
    iconName: "face-grin-wink",
    icon: [
        512,
        512,
        [
            "grin-wink"
        ],
        "f58c",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM388.1 312.8c12.3-3.8 24.3 6.9 19.3 18.7C382.4 390.6 324.2 432 256.3 432s-126.2-41.4-151.1-100.5c-5-11.8 7-22.5 19.3-18.7c39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19zm-16.9-79.2c-17.6-23.5-52.8-23.5-70.4 0c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2zM176.4 176a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $d8206b3ab2e65c05$export$2397fcd34eb12177 = $d8206b3ab2e65c05$export$1dd161850c5bc64e;
var $d8206b3ab2e65c05$export$c9c5b76ec992eab4 = {
    prefix: "fas",
    iconName: "ear-deaf",
    icon: [
        512,
        512,
        [
            "deaf",
            "deafness",
            "hard-of-hearing"
        ],
        "f2a4",
        "M502.6 54.6l-40 40c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l40-40c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3zm-320 320l-128 128c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l128-128c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3zM240 128c-57.6 0-105.1 43.6-111.3 99.5c-1.9 17.6-17.8 30.2-35.3 28.3s-30.2-17.8-28.3-35.3C74.8 132.5 149.4 64 240 64c97.2 0 176 78.8 176 176c0 46-17.7 87.9-46.6 119.3c-12 13-17.4 24.8-17.4 34.7V400c0 61.9-50.1 112-112 112c-17.7 0-32-14.3-32-32s14.3-32 32-32c26.5 0 48-21.5 48-48v-6.1c0-32.9 17.4-59.6 34.4-78c18.4-20 29.6-46.6 29.6-75.9c0-61.9-50.1-112-112-112zm0 80c-17.7 0-32 14.3-32 32c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-44.2 35.8-80 80-80s80 35.8 80 80c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-17.7-14.3-32-32-32z"
    ]
};
var $d8206b3ab2e65c05$export$4b666adf83f0de01 = $d8206b3ab2e65c05$export$c9c5b76ec992eab4;
var $d8206b3ab2e65c05$export$85c6a9ab2fa2631e = $d8206b3ab2e65c05$export$c9c5b76ec992eab4;
var $d8206b3ab2e65c05$export$ebecf90a5676e17a = $d8206b3ab2e65c05$export$c9c5b76ec992eab4;
var $d8206b3ab2e65c05$export$3f22db9ae9b6be1c = {
    prefix: "fas",
    iconName: "road-circle-check",
    icon: [
        640,
        512,
        [],
        "e564",
        "M213.2 32H288V96c0 17.7 14.3 32 32 32s32-14.3 32-32V32h74.8c27.1 0 51.3 17.1 60.3 42.6l42.7 120.6c-10.9-2.1-22.2-3.2-33.8-3.2c-59.5 0-112.1 29.6-144 74.8V224c0-17.7-14.3-32-32-32s-32 14.3-32 32v64c0 17.7 14.3 32 32 32c2.3 0 4.6-.3 6.8-.7c-4.5 15.5-6.8 31.8-6.8 48.7c0 5.4 .2 10.7 .7 16l-.7 0c-17.7 0-32 14.3-32 32v64H86.6C56.5 480 32 455.5 32 425.4c0-6.2 1.1-12.4 3.1-18.2L152.9 74.6C162 49.1 186.1 32 213.2 32zM352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm211.3-43.3c-6.2-6.2-16.4-6.2-22.6 0L480 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z"
    ]
};
var $d8206b3ab2e65c05$export$d9769fb795c2db82 = {
    prefix: "fas",
    iconName: "dice-five",
    icon: [
        448,
        512,
        [
            9860
        ],
        "f523",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm64 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM96 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM224 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm64-64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32 160a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $d8206b3ab2e65c05$export$97d1903b1e012ff7 = {
    prefix: "fas",
    iconName: "square-rss",
    icon: [
        448,
        512,
        [
            "rss-square"
        ],
        "f143",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM96 136c0-13.3 10.7-24 24-24c137 0 248 111 248 248c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-110.5-89.5-200-200-200c-13.3 0-24-10.7-24-24zm0 96c0-13.3 10.7-24 24-24c83.9 0 152 68.1 152 152c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-57.4-46.6-104-104-104c-13.3 0-24-10.7-24-24zm0 120a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
    ]
};
var $d8206b3ab2e65c05$export$89c9b1cca2c11484 = $d8206b3ab2e65c05$export$97d1903b1e012ff7;
var $d8206b3ab2e65c05$export$567a897fc092e403 = {
    prefix: "fas",
    iconName: "land-mine-on",
    icon: [
        640,
        512,
        [],
        "e51b",
        "M344 24V168c0 13.3-10.7 24-24 24s-24-10.7-24-24V24c0-13.3 10.7-24 24-24s24 10.7 24 24zM192 320c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32v32H192V320zm-77.3 90.5c8.1-16.3 24.8-26.5 42.9-26.5H482.3c18.2 0 34.8 10.3 42.9 26.5l27.6 55.2C563.5 487 548 512 524.2 512H115.8c-23.8 0-39.3-25-28.6-46.3l27.6-55.2zM36.3 138.3c7.5-10.9 22.5-13.6 33.4-6.1l104 72c10.9 7.5 13.6 22.5 6.1 33.4s-22.5 13.6-33.4 6.1l-104-72c-10.9-7.5-13.6-22.5-6.1-33.4zm534.1-6.1c10.9-7.5 25.8-4.8 33.4 6.1s4.8 25.8-6.1 33.4l-104 72c-10.9 7.5-25.8 4.8-33.4-6.1s-4.8-25.8 6.1-33.4l104-72z"
    ]
};
var $d8206b3ab2e65c05$export$7fddf76ec23943d8 = {
    prefix: "fas",
    iconName: "i-cursor",
    icon: [
        256,
        512,
        [],
        "f246",
        "M.1 29.3C-1.4 47 11.7 62.4 29.3 63.9l8 .7C70.5 67.3 96 95 96 128.3V224H64c-17.7 0-32 14.3-32 32s14.3 32 32 32H96v95.7c0 33.3-25.5 61-58.7 63.8l-8 .7C11.7 449.6-1.4 465 .1 482.7s16.9 30.7 34.5 29.2l8-.7c34.1-2.8 64.2-18.9 85.4-42.9c21.2 24 51.2 40.1 85.4 42.9l8 .7c17.6 1.5 33.1-11.6 34.5-29.2s-11.6-33.1-29.2-34.5l-8-.7C185.5 444.7 160 417 160 383.7V288h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H160V128.3c0-33.3 25.5-61 58.7-63.8l8-.7c17.6-1.5 30.7-16.9 29.2-34.5S239-1.4 221.3 .1l-8 .7C179.2 3.6 149.2 19.7 128 43.7c-21.2-24-51.2-40-85.4-42.9l-8-.7C17-1.4 1.6 11.7 .1 29.3z"
    ]
};
var $d8206b3ab2e65c05$export$722e92d2d93ffc68 = {
    prefix: "fas",
    iconName: "stamp",
    icon: [
        512,
        512,
        [],
        "f5bf",
        "M312 201.8c0-17.4 9.2-33.2 19.9-47C344.5 138.5 352 118.1 352 96c0-53-43-96-96-96s-96 43-96 96c0 22.1 7.5 42.5 20.1 58.8c10.7 13.8 19.9 29.6 19.9 47c0 29.9-24.3 54.2-54.2 54.2H112C50.1 256 0 306.1 0 368c0 20.9 13.4 38.7 32 45.3V464c0 26.5 21.5 48 48 48H432c26.5 0 48-21.5 48-48V413.3c18.6-6.6 32-24.4 32-45.3c0-61.9-50.1-112-112-112H366.2c-29.9 0-54.2-24.3-54.2-54.2zM416 416v32H96V416H416z"
    ]
};
var $d8206b3ab2e65c05$export$68b3af7444c89df7 = {
    prefix: "fas",
    iconName: "stairs",
    icon: [
        576,
        512,
        [],
        "e289",
        "M384 64c0-17.7 14.3-32 32-32H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H448v96c0 17.7-14.3 32-32 32H320v96c0 17.7-14.3 32-32 32H192v96c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h96V320c0-17.7 14.3-32 32-32h96V192c0-17.7 14.3-32 32-32h96V64z"
    ]
};
var $d8206b3ab2e65c05$export$aee03ca0815b7c38 = {
    prefix: "fas",
    iconName: "i",
    icon: [
        320,
        512,
        [
            105
        ],
        "49",
        "M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96h96V416H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H288c17.7 0 32-14.3 32-32s-14.3-32-32-32H192V96h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H160 32z"
    ]
};
var $d8206b3ab2e65c05$export$22a9491150c64fef = {
    prefix: "fas",
    iconName: "hryvnia-sign",
    icon: [
        384,
        512,
        [
            8372,
            "hryvnia"
        ],
        "f6f2",
        "M121.9 116.2C138.3 103.1 158.7 96 179.6 96H223c27.1 0 49 21.9 49 49c0 11.5-4 22.4-11.1 31H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H155.5l-50.6 28.9c-1.7 1-3.4 2-5.1 3.1H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H52.3c-2.8 9.9-4.3 20.4-4.3 31c0 62.4 50.6 113 113 113h43.4c35.5 0 70-12.1 97.7-34.3L308 441c13.8-11 16-31.2 5-45s-31.2-16-45-5l-5.9 4.7c-16.4 13.1-36.7 20.2-57.7 20.2H161c-27.1 0-49-21.9-49-49c0-11.5 4-22.4 11.1-31H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H228.5l50.6-28.9c1.7-1 3.4-2 5.1-3.1H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H331.7c2.8-10 4.3-20.4 4.3-31c0-62.4-50.6-113-113-113H179.6c-35.5 0-70 12.1-97.7 34.3L76 71c-13.8 11-16 31.2-5 45s31.2 16 45 5l5.9-4.7z"
    ]
};
var $d8206b3ab2e65c05$export$33d5f94bd6f75f59 = $d8206b3ab2e65c05$export$22a9491150c64fef;
var $d8206b3ab2e65c05$export$6380e2ed6e69d350 = {
    prefix: "fas",
    iconName: "pills",
    icon: [
        576,
        512,
        [],
        "f484",
        "M112 96c-26.5 0-48 21.5-48 48V256h96V144c0-26.5-21.5-48-48-48zM0 144C0 82.1 50.1 32 112 32s112 50.1 112 112V368c0 61.9-50.1 112-112 112S0 429.9 0 368V144zM554.9 399.4c-7.1 12.3-23.7 13.1-33.8 3.1L333.5 214.9c-10-10-9.3-26.7 3.1-33.8C360 167.7 387.1 160 416 160c88.4 0 160 71.6 160 160c0 28.9-7.7 56-21.1 79.4zm-59.5 59.5C472 472.3 444.9 480 416 480c-88.4 0-160-71.6-160-160c0-28.9 7.7-56 21.1-79.4c7.1-12.3 23.7-13.1 33.8-3.1L498.5 425.1c10 10 9.3 26.7-3.1 33.8z"
    ]
};
var $d8206b3ab2e65c05$export$bdbabf493c478cde = {
    prefix: "fas",
    iconName: "face-grin-wide",
    icon: [
        512,
        512,
        [
            128515,
            "grin-alt"
        ],
        "f581",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM388.1 312.8c12.3-3.8 24.3 6.9 19.3 18.7C382.4 390.6 324.2 432 256.3 432s-126.2-41.4-151.1-100.5c-5-11.8 7-22.5 19.3-18.7c39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19zM208 192c0 35.3-14.3 64-32 64s-32-28.7-32-64s14.3-64 32-64s32 28.7 32 64zm128 64c-17.7 0-32-28.7-32-64s14.3-64 32-64s32 28.7 32 64s-14.3 64-32 64z"
    ]
};
var $d8206b3ab2e65c05$export$b4abebfe416d36ba = $d8206b3ab2e65c05$export$bdbabf493c478cde;
var $d8206b3ab2e65c05$export$3a1fa2d16f90d635 = {
    prefix: "fas",
    iconName: "tooth",
    icon: [
        448,
        512,
        [
            129463
        ],
        "f5c9",
        "M186.1 52.1C169.3 39.1 148.7 32 127.5 32C74.7 32 32 74.7 32 127.5v6.2c0 15.8 3.7 31.3 10.7 45.5l23.5 47.1c4.5 8.9 7.6 18.4 9.4 28.2l36.7 205.8c2 11.2 11.6 19.4 22.9 19.8s21.4-7.4 24-18.4l28.9-121.3C192.2 323.7 207 312 224 312s31.8 11.7 35.8 28.3l28.9 121.3c2.6 11.1 12.7 18.8 24 18.4s20.9-8.6 22.9-19.8l36.7-205.8c1.8-9.8 4.9-19.3 9.4-28.2l23.5-47.1c7.1-14.1 10.7-29.7 10.7-45.5v-2.1c0-55-44.6-99.6-99.6-99.6c-24.1 0-47.4 8.8-65.6 24.6l-3.2 2.8 19.5 15.2c7 5.4 8.2 15.5 2.8 22.5s-15.5 8.2-22.5 2.8l-24.4-19-37-28.8z"
    ]
};
var $d8206b3ab2e65c05$export$6fb446f784f6b9b3 = {
    prefix: "fas",
    iconName: "v",
    icon: [
        384,
        512,
        [
            118
        ],
        "56",
        "M19.7 34.5c16.3-6.8 35 .9 41.8 17.2L192 364.8 322.5 51.7c6.8-16.3 25.5-24 41.8-17.2s24 25.5 17.2 41.8l-160 384c-5 11.9-16.6 19.7-29.5 19.7s-24.6-7.8-29.5-19.7L2.5 76.3c-6.8-16.3 .9-35 17.2-41.8z"
    ]
};
var $d8206b3ab2e65c05$export$469d376940e10d37 = {
    prefix: "fas",
    iconName: "bangladeshi-taka-sign",
    icon: [
        384,
        512,
        [],
        "e2e6",
        "M36 32.2C18.4 30.1 2.4 42.5 .2 60S10.5 93.6 28 95.8l7.9 1c16 2 28 15.6 28 31.8V160H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H64V384c0 53 43 96 96 96h32c106 0 192-86 192-192V256c0-53-43-96-96-96H272c-17.7 0-32 14.3-32 32s14.3 32 32 32h16c17.7 0 32 14.3 32 32v32c0 70.7-57.3 128-128 128H160c-17.7 0-32-14.3-32-32V224h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H128V128.5c0-48.4-36.1-89.3-84.1-95.3l-7.9-1z"
    ]
};
var $d8206b3ab2e65c05$export$36cb1885ad7a570f = {
    prefix: "fas",
    iconName: "bicycle",
    icon: [
        640,
        512,
        [
            128690
        ],
        "f206",
        "M312 32c-13.3 0-24 10.7-24 24s10.7 24 24 24h25.7l34.6 64H222.9l-27.4-38C191 99.7 183.7 96 176 96H120c-13.3 0-24 10.7-24 24s10.7 24 24 24h43.7l22.1 30.7-26.6 53.1c-10-2.5-20.5-3.8-31.2-3.8C57.3 224 0 281.3 0 352s57.3 128 128 128c65.3 0 119.1-48.9 127-112h49c8.5 0 16.3-4.5 20.7-11.8l84.8-143.5 21.7 40.1C402.4 276.3 384 312 384 352c0 70.7 57.3 128 128 128s128-57.3 128-128s-57.3-128-128-128c-13.5 0-26.5 2.1-38.7 6L375.4 48.8C369.8 38.4 359 32 347.2 32H312zM458.6 303.7l32.3 59.7c6.3 11.7 20.9 16 32.5 9.7s16-20.9 9.7-32.5l-32.3-59.7c3.6-.6 7.4-.9 11.2-.9c39.8 0 72 32.2 72 72s-32.2 72-72 72s-72-32.2-72-72c0-18.6 7-35.5 18.6-48.3zM133.2 368h65c-7.3 32.1-36 56-70.2 56c-39.8 0-72-32.2-72-72s32.2-72 72-72c1.7 0 3.4 .1 5.1 .2l-24.2 48.5c-9 18.1 4.1 39.4 24.3 39.4zm33.7-48l50.7-101.3 72.9 101.2-.1 .1H166.8zm90.6-128H365.9L317 274.8 257.4 192z"
    ]
};
var $d8206b3ab2e65c05$export$76d998742bc186eb = {
    prefix: "fas",
    iconName: "staff-snake",
    icon: [
        384,
        512,
        [
            "rod-asclepius",
            "rod-snake",
            "staff-aesculapius"
        ],
        "e579",
        "M222.6 43.2l-.1 4.8H288c53 0 96 43 96 96s-43 96-96 96H248V160h40c8.8 0 16-7.2 16-16s-7.2-16-16-16H248 220l-4.5 144H256c53 0 96 43 96 96s-43 96-96 96H240V384h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H213l-3.1 99.5L208.5 495l0 1c-.3 8.9-7.6 16-16.5 16s-16.2-7.1-16.5-16l0-1-1-31H136c-22.1 0-40-17.9-40-40s17.9-40 40-40h36l-1-32H152c-53 0-96-43-96-96c0-47.6 34.6-87.1 80-94.7V256c0 8.8 7.2 16 16 16h16.5L164 128H136 122.6c-9 18.9-28.3 32-50.6 32H56c-30.9 0-56-25.1-56-56S25.1 48 56 48h8 8 89.5l-.1-4.8L161 32c0-.7 0-1.3 0-1.9c.5-16.6 14.1-30 31-30s30.5 13.4 31 30c0 .6 0 1.3 0 1.9l-.4 11.2zM64 112a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"
    ]
};
var $d8206b3ab2e65c05$export$f2c3e92ee37a8d89 = $d8206b3ab2e65c05$export$76d998742bc186eb;
var $d8206b3ab2e65c05$export$5d61dcb598296af0 = $d8206b3ab2e65c05$export$76d998742bc186eb;
var $d8206b3ab2e65c05$export$97c8a2cdba3b7700 = $d8206b3ab2e65c05$export$76d998742bc186eb;
var $d8206b3ab2e65c05$export$b293ee8fb8e6b0c4 = {
    prefix: "fas",
    iconName: "head-side-cough-slash",
    icon: [
        640,
        512,
        [],
        "e062",
        "M448 325.8l44 34.5c8.1 1.4 14.8 6.8 18 14.1L552.9 408c10.6 .4 19.5 7.6 22.2 17.4l39.1 30.6c.6 0 1.2-.1 1.8-.1c11.1 0 20.4 7.5 23.2 17.8h-3.9c6.2 8.5 6.4 20.4-.4 29c-8.2 10.4-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2S28.4-3.1 38.8 5.1L89.6 44.9C127 16.7 173.5 0 224 0h24c95.2 0 181.2 69.3 197.3 160.2c2.3 13 6.8 25.7 15.1 36l42 52.6c6.2 7.8 9.6 17.4 9.6 27.4c0 24.2-19.6 43.8-43.8 43.8H448v0 5.8zM0 224.2c0-38.7 9.8-75.1 27.1-106.9L341.8 365.3l-2.5 .3c-11 1.4-19.2 10.7-19.2 21.8c0 11.6 9 21.2 20.6 21.9l62 3.9 43 33.9C439.3 466.2 421.2 480 400 480H320v8c0 13.3-10.7 24-24 24H256v0H96c-17.7 0-32-14.3-32-32V407.3c0-16.7-6.9-32.5-17.1-45.8C16.6 322.4 0 274.1 0 224.2zM616 360a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-64-48a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm40-24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"
    ]
};
var $d8206b3ab2e65c05$export$fb6bd43f079f72e2 = {
    prefix: "fas",
    iconName: "truck-medical",
    icon: [
        640,
        512,
        [
            128657,
            "ambulance"
        ],
        "f0f9",
        "M0 48C0 21.5 21.5 0 48 0H368c26.5 0 48 21.5 48 48V96h50.7c17 0 33.3 6.7 45.3 18.7L589.3 192c12 12 18.7 28.3 18.7 45.3V256v32 64c17.7 0 32 14.3 32 32s-14.3 32-32 32H576c0 53-43 96-96 96s-96-43-96-96H256c0 53-43 96-96 96s-96-43-96-96H48c-26.5 0-48-21.5-48-48V48zM416 256H544V237.3L466.7 160H416v96zM160 464a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm368-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM176 80v48l-48 0c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V192h48c8.8 0 16-7.2 16-16V144c0-8.8-7.2-16-16-16H240V80c0-8.8-7.2-16-16-16H192c-8.8 0-16 7.2-16 16z"
    ]
};
var $d8206b3ab2e65c05$export$f5c7042778b51765 = $d8206b3ab2e65c05$export$fb6bd43f079f72e2;
var $d8206b3ab2e65c05$export$e23367e54f665590 = {
    prefix: "fas",
    iconName: "wheat-awn-circle-exclamation",
    icon: [
        640,
        512,
        [],
        "e598",
        "M505 41c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L383 95c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l88-88zM305.5 27.3c-6.2-6.2-16.4-6.2-22.6 0L271.5 38.6c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4-30.5 30.5c-3.4-27.3-15.5-53.8-36.5-74.8l-11.3-11.3c-6.2-6.2-16.4-6.2-22.6 0l-11.3 11.3c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4-30.5 30.5c-3.4-27.3-15.5-53.8-36.5-74.8L101.8 231c-6.2-6.2-16.4-6.2-22.6 0L67.9 242.3c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4L9.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l68.9-68.9 12.2 12.2c37.5 37.5 98.3 37.5 135.8 0l11.3-11.3c6.2-6.2 6.2-16.4 0-22.6l-11.3-11.3c-21.8-21.8-49.6-34.1-78.1-36.9l31.9-31.9 12.2 12.2c22.5 22.5 53.3 31.5 82.4 27c0-1 0-2.1 0-3.1c0-33.1 9.1-64.1 25-90.6c-15.5-8.7-32.5-13.8-49.8-15.5l31.9-31.9 12.2 12.2c6 6 12.6 11.1 19.7 15.2c27.5-34 67.3-57.5 112.6-63.8c-4.1-3.8-8.4-7.3-12.9-10.5L505 137c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-59.4 59.4c-20.6-4.4-42-3.7-62.3 2.1c6.1-21.3 6.6-43.8 1.4-65.3L409 41c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L329.1 52.9c-3.7-5-7.8-9.8-12.4-14.3L305.5 27.3zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V288c0-8.8 7.2-16 16-16z"
    ]
};
var $d8206b3ab2e65c05$export$b23df6bafb174693 = {
    prefix: "fas",
    iconName: "snowman",
    icon: [
        512,
        512,
        [
            9731,
            9924
        ],
        "f7d0",
        "M341.1 140.6c-2 3.9-1.6 8.6 1.2 12c7 8.5 12.9 18.1 17.2 28.4L408 160.2V120c0-13.3 10.7-24 24-24s24 10.7 24 24v19.6l22.5-9.7c12.2-5.2 26.3 .4 31.5 12.6s-.4 26.3-12.6 31.5l-56 24-73.6 31.5c-.5 9.5-2.1 18.6-4.8 27.3c-1.2 3.8-.1 8 2.8 10.8C396.7 296.9 416 338.2 416 384c0 44.7-18.3 85-47.8 114.1c-9.9 9.7-23.7 13.9-37.5 13.9H181.3c-13.9 0-27.7-4.2-37.5-13.9C114.3 469 96 428.7 96 384c0-45.8 19.3-87.1 50.1-116.3c2.9-2.8 4-6.9 2.8-10.8c-2.7-8.7-4.3-17.9-4.8-27.3L70.5 198.1l-56-24C2.4 168.8-3.3 154.7 1.9 142.5s19.3-17.8 31.5-12.6L56 139.6V120c0-13.3 10.7-24 24-24s24 10.7 24 24v40.2L152.6 181c4.3-10.3 10.1-19.9 17.2-28.4c2.8-3.4 3.3-8.1 1.2-12C164 127.2 160 112.1 160 96c0-53 43-96 96-96s96 43 96 96c0 16.1-4 31.2-10.9 44.6zM224 96a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm48 128a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-16 80a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm16 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM288 96a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm-48 24v3.2c0 3.2 .8 6.3 2.3 9l9 16.9c.9 1.7 2.7 2.8 4.7 2.8s3.8-1.1 4.7-2.8l9-16.9c1.5-2.8 2.3-5.9 2.3-9V120c0-8.8-7.2-16-16-16s-16 7.2-16 16z"
    ]
};
var $d8206b3ab2e65c05$export$55ceb5d0c144580a = {
    prefix: "fas",
    iconName: "mortar-pestle",
    icon: [
        512,
        512,
        [],
        "f5a7",
        "M504.3 11.1C493.3-1.6 474.5-3.7 461 6.2L252.3 160H397.3L502.6 54.6c11.8-11.8 12.6-30.8 1.6-43.5zM32 192c-17.7 0-32 14.3-32 32s14.3 32 32 32c0 82.5 43.4 147.7 123.9 176.2c-11.1 13.9-19.4 30.3-23.9 48.1C127.6 497.4 142.3 512 160 512H352c17.7 0 32.4-14.6 28.1-31.7c-4.5-17.8-12.8-34.1-23.9-48.1C436.6 403.7 480 338.5 480 256c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z"
    ]
};
var $d8206b3ab2e65c05$export$f3e925217e396f44 = {
    prefix: "fas",
    iconName: "road-barrier",
    icon: [
        640,
        512,
        [],
        "e562",
        "M32 32C14.3 32 0 46.3 0 64V448c0 17.7 14.3 32 32 32s32-14.3 32-32V266.3L149.2 96H64V64c0-17.7-14.3-32-32-32zM405.2 96H330.8l-5.4 10.7L234.8 288h74.3l5.4-10.7L405.2 96zM362.8 288h74.3l5.4-10.7L533.2 96H458.8l-5.4 10.7L362.8 288zM202.8 96l-5.4 10.7L106.8 288h74.3l5.4-10.7L277.2 96H202.8zm288 192H576V448c0 17.7 14.3 32 32 32s32-14.3 32-32V64c0-17.7-14.3-32-32-32s-32 14.3-32 32v53.7L490.8 288z"
    ]
};
var $d8206b3ab2e65c05$export$51e9b8434982947d = {
    prefix: "fas",
    iconName: "school",
    icon: [
        640,
        512,
        [
            127979
        ],
        "f549",
        "M337.8 5.4C327-1.8 313-1.8 302.2 5.4L166.3 96H48C21.5 96 0 117.5 0 144V464c0 26.5 21.5 48 48 48H256V416c0-35.3 28.7-64 64-64s64 28.7 64 64v96H592c26.5 0 48-21.5 48-48V144c0-26.5-21.5-48-48-48H473.7L337.8 5.4zM96 192h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V208c0-8.8 7.2-16 16-16zm400 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H512c-8.8 0-16-7.2-16-16V208zM96 320h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V336c0-8.8 7.2-16 16-16zm400 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H512c-8.8 0-16-7.2-16-16V336zM232 176a88 88 0 1 1 176 0 88 88 0 1 1 -176 0zm88-48c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H336V144c0-8.8-7.2-16-16-16z"
    ]
};
var $d8206b3ab2e65c05$export$4a284575edd6f1af = {
    prefix: "fas",
    iconName: "igloo",
    icon: [
        576,
        512,
        [],
        "f7ae",
        "M320 33.8V160H48.5C100.2 82.8 188.1 32 288 32c10.8 0 21.5 .6 32 1.8zM352 160V39.1C424.9 55.7 487.2 99.8 527.5 160H352zM29.9 192H96V320H0c0-46 10.8-89.4 29.9-128zM192 320H128V192H448V320H384v32H576v80c0 26.5-21.5 48-48 48H352V352c0-35.3-28.7-64-64-64s-64 28.7-64 64V480H48c-26.5 0-48-21.5-48-48V352H192V320zm288 0V192h66.1c19.2 38.6 29.9 82 29.9 128H480z"
    ]
};
var $d8206b3ab2e65c05$export$e5a289fb22ffb8cb = {
    prefix: "fas",
    iconName: "joint",
    icon: [
        640,
        512,
        [],
        "f595",
        "M448 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V43c0 55.2 21.9 108.1 60.9 147.1l21 21c9 9 14.1 21.2 14.1 33.9v11c0 17.7 14.3 32 32 32s32-14.3 32-32V245c0-29.7-11.8-58.2-32.8-79.2l-21-21C463.2 117.8 448 81.2 448 43V32zM576 256c0 17.7 14.3 32 32 32s32-14.3 32-32V245c0-55.2-21.9-108.1-60.9-147.1l-21-21c-9-9-14.1-21.2-14.1-33.9V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V43c0 29.7 11.8 58.2 32.8 79.2l21 21c27 27 42.2 63.6 42.2 101.8v11zM229.8 360c-4.7-2.3-10-2.7-15.2-2c-37.8 5.6-75.2 14.3-106.9 22.8C81.3 388 58.3 395.1 42 400.4c-8.2 2.7-14.7 4.9-19.2 6.5c-2.3 .8-4 1.4-5.2 1.8l-1.3 .5C6.8 412.5 0 421.4 0 432s6.8 19.5 16.3 22.7l1.3 .5c1.2 .4 3 1.1 5.2 1.8c4.5 1.6 11 3.8 19.2 6.5c16.3 5.4 39.2 12.5 65.7 19.6C160.3 497.3 228.8 512 288 512h67.3c4.1 0 6.3-5.1 3.6-8.3L256.5 380.8c-7.4-8.9-16.5-15.9-26.7-20.8zM445 512h19 51.3c4.1 0 6.3-5.1 3.6-8.3L416.5 380.8C401.3 362.5 378.8 352 355 352H336 288c-1.1 0-2.3 0-3.4 0c-4.1 0-6.2 5.1-3.5 8.3L383.5 483.2C398.7 501.5 421.2 512 445 512zm-3.9-151.7L543.5 483.2c14.6 17.5 35.9 27.9 58.6 28.7c21.1-1.1 37.9-18.6 37.9-39.9V392c0-22.1-17.9-40-40-40H444.7c-4.1 0-6.3 5.1-3.6 8.3z"
    ]
};
var $d8206b3ab2e65c05$export$6bce1afb61f2eb66 = {
    prefix: "fas",
    iconName: "angle-right",
    icon: [
        320,
        512,
        [
            8250
        ],
        "f105",
        "M278.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-160 160c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L210.7 256 73.4 118.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l160 160z"
    ]
};
var $d8206b3ab2e65c05$export$5b05f097fa38352a = {
    prefix: "fas",
    iconName: "horse",
    icon: [
        576,
        512,
        [
            128014
        ],
        "f6f0",
        "M448 238.1V160h16l9.8 19.6c12.5 25.1 42.2 36.4 68.3 26c20.5-8.2 33.9-28 33.9-50.1V80c0-19.1-8.4-36.3-21.7-48H560c8.8 0 16-7.2 16-16s-7.2-16-16-16H480 448C377.3 0 320 57.3 320 128H224 203.2 148.8c-30.7 0-57.6 16.3-72.5 40.8C33.2 174.5 0 211.4 0 256v56c0 13.3 10.7 24 24 24s24-10.7 24-24V256c0-13.4 6.6-25.2 16.7-32.5c1.6 13 6.3 25.4 13.6 36.4l28.2 42.4c8.3 12.4 6.4 28.7-1.2 41.6c-16.5 28-20.6 62.2-10 93.9l17.5 52.4c4.4 13.1 16.6 21.9 30.4 21.9h33.7c21.8 0 37.3-21.4 30.4-42.1l-20.8-62.5c-2.1-6.4-.5-13.4 4.3-18.2l12.7-12.7c13.2-13.2 20.6-31.1 20.6-49.7c0-2.3-.1-4.6-.3-6.9l84 24c4.1 1.2 8.2 2.1 12.3 2.8V480c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V315.7c19.2-19.2 31.5-45.7 32-75.7h0v-1.9zM496 64a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"
    ]
};
var $d8206b3ab2e65c05$export$5a2b164552deda9f = {
    prefix: "fas",
    iconName: "q",
    icon: [
        448,
        512,
        [
            113
        ],
        "51",
        "M64 256c0 88.4 71.6 160 160 160c28.9 0 56-7.7 79.4-21.1l-72-86.4c-11.3-13.6-9.5-33.8 4.1-45.1s33.8-9.5 45.1 4.1l70.9 85.1C371.9 325.8 384 292.3 384 256c0-88.4-71.6-160-160-160S64 167.6 64 256zM344.9 444.6C310 467 268.5 480 224 480C100.3 480 0 379.7 0 256S100.3 32 224 32s224 100.3 224 224c0 56.1-20.6 107.4-54.7 146.7l47.3 56.8c11.3 13.6 9.5 33.8-4.1 45.1s-33.8 9.5-45.1-4.1l-46.6-55.9z"
    ]
};
var $d8206b3ab2e65c05$export$9f5c2b0db8eedeac = {
    prefix: "fas",
    iconName: "g",
    icon: [
        448,
        512,
        [
            103
        ],
        "47",
        "M224 96C135.6 96 64 167.6 64 256s71.6 160 160 160c77.4 0 142-55 156.8-128H256c-17.7 0-32-14.3-32-32s14.3-32 32-32H400c25.8 0 49.6 21.4 47.2 50.6C437.8 389.6 341.4 480 224 480C100.3 480 0 379.7 0 256S100.3 32 224 32c57.4 0 109.7 21.6 149.3 57c13.2 11.8 14.3 32 2.5 45.2s-32 14.3-45.2 2.5C302.3 111.4 265 96 224 96z"
    ]
};
var $d8206b3ab2e65c05$export$b2d79133c81d6697 = {
    prefix: "fas",
    iconName: "notes-medical",
    icon: [
        512,
        512,
        [],
        "f481",
        "M96 352V96c0-35.3 28.7-64 64-64H416c35.3 0 64 28.7 64 64V293.5c0 17-6.7 33.3-18.7 45.3l-58.5 58.5c-12 12-28.3 18.7-45.3 18.7H160c-35.3 0-64-28.7-64-64zM272 128c-8.8 0-16 7.2-16 16v48H208c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V256h48c8.8 0 16-7.2 16-16V208c0-8.8-7.2-16-16-16H320V144c0-8.8-7.2-16-16-16H272zm24 336c13.3 0 24 10.7 24 24s-10.7 24-24 24H136C60.9 512 0 451.1 0 376V152c0-13.3 10.7-24 24-24s24 10.7 24 24l0 224c0 48.6 39.4 88 88 88H296z"
    ]
};
var $d8206b3ab2e65c05$export$a3f1d7f13c202adc = {
    prefix: "fas",
    iconName: "temperature-half",
    icon: [
        320,
        512,
        [
            127777,
            "temperature-2",
            "thermometer-2",
            "thermometer-half"
        ],
        "f2c9",
        "M160 64c-26.5 0-48 21.5-48 48V276.5c0 17.3-7.1 31.9-15.3 42.5C86.2 332.6 80 349.5 80 368c0 44.2 35.8 80 80 80s80-35.8 80-80c0-18.5-6.2-35.4-16.7-48.9c-8.2-10.6-15.3-25.2-15.3-42.5V112c0-26.5-21.5-48-48-48zM48 112C48 50.2 98.1 0 160 0s112 50.1 112 112V276.5c0 .1 .1 .3 .2 .6c.2 .6 .8 1.6 1.7 2.8c18.9 24.4 30.1 55 30.1 88.1c0 79.5-64.5 144-144 144S16 447.5 16 368c0-33.2 11.2-63.8 30.1-88.1c.9-1.2 1.5-2.2 1.7-2.8c.1-.3 .2-.5 .2-.6V112zM208 368c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V208c0-8.8 7.2-16 16-16s16 7.2 16 16V322.7c18.6 6.6 32 24.4 32 45.3z"
    ]
};
var $d8206b3ab2e65c05$export$8176e649df45b32c = $d8206b3ab2e65c05$export$a3f1d7f13c202adc;
var $d8206b3ab2e65c05$export$4dd764ac8d512682 = $d8206b3ab2e65c05$export$a3f1d7f13c202adc;
var $d8206b3ab2e65c05$export$2090f040324b4449 = $d8206b3ab2e65c05$export$a3f1d7f13c202adc;
var $d8206b3ab2e65c05$export$18659308f17918a5 = {
    prefix: "fas",
    iconName: "dong-sign",
    icon: [
        384,
        512,
        [],
        "e169",
        "M288 32c-17.7 0-32 14.3-32 32l-32 0c-17.7 0-32 14.3-32 32s14.3 32 32 32h32v49.1c-18.8-10.9-40.7-17.1-64-17.1c-70.7 0-128 57.3-128 128s57.3 128 128 128c24.5 0 47.4-6.9 66.8-18.8c5 11.1 16.2 18.8 29.2 18.8c17.7 0 32-14.3 32-32V288 128c17.7 0 32-14.3 32-32s-14.3-32-32-32c0-17.7-14.3-32-32-32zM128 288a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM32 448c-17.7 0-32 14.3-32 32s14.3 32 32 32H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z"
    ]
};
var $d8206b3ab2e65c05$export$ba6fd4a436804a48 = {
    prefix: "fas",
    iconName: "capsules",
    icon: [
        576,
        512,
        [],
        "f46b",
        "M64 144c0-26.5 21.5-48 48-48s48 21.5 48 48V256H64V144zM0 144V368c0 61.9 50.1 112 112 112s112-50.1 112-112V189.6c1.8 19.1 8.2 38 19.8 54.8L372.3 431.7c35.5 51.7 105.3 64.3 156 28.1s63-107.5 27.5-159.2L427.3 113.3C391.8 61.5 321.9 49 271.3 85.2c-28 20-44.3 50.8-47.3 83V144c0-61.9-50.1-112-112-112S0 82.1 0 144zm296.6 64.2c-16-23.3-10-55.3 11.9-71c21.2-15.1 50.5-10.3 66 12.2l67 97.6L361.6 303l-65-94.8zM491 407.7c-.8 .6-1.6 1.1-2.4 1.6l4-2.8c-.5 .4-1 .8-1.6 1.2z"
    ]
};
var $d8206b3ab2e65c05$export$48a38da471b097a2 = {
    prefix: "fas",
    iconName: "poo-storm",
    icon: [
        448,
        512,
        [
            "poo-bolt"
        ],
        "f75a",
        "M236.9 .2c-5.5-.7-11 1.4-14.5 5.7s-4.6 10.1-2.8 15.3c2.8 8.2 4.3 16.9 4.3 26.1c0 21.7-8.5 37.2-21.9 47.6c-13.8 10.8-34 17-57.8 17H128c-35.3 0-64 28.7-64 64c0 12.2 3.4 23.5 9.3 33.2C31.7 216.2 0 252.4 0 296c0 40.9 28 75.4 65.8 85.2c-5.3-18.5 1-38.5 16.2-50.7l160-128c17.6-14.1 42.6-14 60.2 .2s22.8 38.6 12.8 58.8L285.7 320H304c20.4 0 38.5 12.9 45.3 32.1c3.7 10.6 3.5 21.8 0 31.9H360c48.6 0 88-39.4 88-88c0-43.6-31.7-79.8-73.3-86.8c5.9-9.7 9.3-21.1 9.3-33.2c0-35.3-28.7-64-64-64h-1.4c.9-5.4 1.4-10.9 1.4-16.6c0-48.7-36.1-88.9-83.1-95.2zm45.1 227.4c-5.8-4.7-14.2-4.7-20.1-.1l-160 128c-5.3 4.2-7.4 11.4-5.1 17.8s8.3 10.7 15.1 10.7h70.1L129.7 488.8c-3.4 6.7-1.6 14.9 4.3 19.6s14.2 4.7 20.1 .1l160-128c5.3-4.2 7.4-11.4 5.1-17.8s-8.3-10.7-15.1-10.7H233.9l52.4-104.8c3.4-6.7 1.6-14.9-4.3-19.6z"
    ]
};
var $d8206b3ab2e65c05$export$9a24e77f74d9cbd9 = $d8206b3ab2e65c05$export$48a38da471b097a2;
var $d8206b3ab2e65c05$export$c8a28356e07b9ccb = {
    prefix: "fas",
    iconName: "face-frown-open",
    icon: [
        512,
        512,
        [
            128550,
            "frown-open"
        ],
        "f57a",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM176.4 176a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm-122 174.5c-12.4 5.2-26.5-4.1-21.1-16.4c16-36.6 52.4-62.1 94.8-62.1s78.8 25.6 94.8 62.1c5.4 12.3-8.7 21.6-21.1 16.4c-22.4-9.5-47.4-14.8-73.7-14.8s-51.3 5.3-73.7 14.8z"
    ]
};
var $d8206b3ab2e65c05$export$c4775e66bed5d96 = $d8206b3ab2e65c05$export$c8a28356e07b9ccb;
var $d8206b3ab2e65c05$export$cdc9f5e7e94e76da = {
    prefix: "fas",
    iconName: "hand-point-up",
    icon: [
        384,
        512,
        [
            9757
        ],
        "f0a6",
        "M32 32C32 14.3 46.3 0 64 0S96 14.3 96 32V240H32V32zM224 192c0-17.7 14.3-32 32-32s32 14.3 32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V192zm-64-64c17.7 0 32 14.3 32 32v48c0 17.7-14.3 32-32 32s-32-14.3-32-32V160c0-17.7 14.3-32 32-32zm160 96c0-17.7 14.3-32 32-32s32 14.3 32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V224zm-96 88l0-.6c9.4 5.4 20.3 8.6 32 8.6c13.2 0 25.4-4 35.6-10.8c8.7 24.9 32.5 42.8 60.4 42.8c11.7 0 22.6-3.1 32-8.6V352c0 88.4-71.6 160-160 160H162.3c-42.4 0-83.1-16.9-113.1-46.9L37.5 453.5C13.5 429.5 0 396.9 0 363V336c0-35.3 28.7-64 64-64h88c22.1 0 40 17.9 40 40s-17.9 40-40 40H96c-8.8 0-16 7.2-16 16s7.2 16 16 16h56c39.8 0 72-32.2 72-72z"
    ]
};
var $d8206b3ab2e65c05$export$608138a7337b5d1a = {
    prefix: "fas",
    iconName: "money-bill",
    icon: [
        576,
        512,
        [],
        "f0d6",
        "M64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zm64 320H64V320c35.3 0 64 28.7 64 64zM64 192V128h64c0 35.3-28.7 64-64 64zM448 384c0-35.3 28.7-64 64-64v64H448zm64-192c-35.3 0-64-28.7-64-64h64v64zM288 160a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"
    ]
};
var $d8206b3ab2e65c05$export$4ed9da5c3cca0ef1 = {
    prefix: "fas",
    iconName: "bookmark",
    icon: [
        384,
        512,
        [
            128278,
            61591
        ],
        "f02e",
        "M0 48V487.7C0 501.1 10.9 512 24.3 512c5 0 9.9-1.5 14-4.4L192 400 345.7 507.6c4.1 2.9 9 4.4 14 4.4c13.4 0 24.3-10.9 24.3-24.3V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48z"
    ]
};
var $d8206b3ab2e65c05$export$97c42b56d462df72 = {
    prefix: "fas",
    iconName: "align-justify",
    icon: [
        448,
        512,
        [],
        "f039",
        "M448 64c0-17.7-14.3-32-32-32H32C14.3 32 0 46.3 0 64S14.3 96 32 96H416c17.7 0 32-14.3 32-32zm0 256c0-17.7-14.3-32-32-32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32zM0 192c0 17.7 14.3 32 32 32H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H32c-17.7 0-32 14.3-32 32zM448 448c0-17.7-14.3-32-32-32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32z"
    ]
};
var $d8206b3ab2e65c05$export$20932e4d438e4e4c = {
    prefix: "fas",
    iconName: "umbrella-beach",
    icon: [
        576,
        512,
        [
            127958
        ],
        "f5ca",
        "M346.3 271.8l-60.1-21.9L214 448H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H544c17.7 0 32-14.3 32-32s-14.3-32-32-32H282.1l64.1-176.2zm121.1-.2l-3.3 9.1 67.7 24.6c18.1 6.6 38-4.2 39.6-23.4c6.5-78.5-23.9-155.5-80.8-208.5c2 8 3.2 16.3 3.4 24.8l.2 6c1.8 57-7.3 113.8-26.8 167.4zM462 99.1c-1.1-34.4-22.5-64.8-54.4-77.4c-.9-.4-1.9-.7-2.8-1.1c-33-11.7-69.8-2.4-93.1 23.8l-4 4.5C272.4 88.3 245 134.2 226.8 184l-3.3 9.1L434 269.7l3.3-9.1c18.1-49.8 26.6-102.5 24.9-155.5l-.2-6zM107.2 112.9c-11.1 15.7-2.8 36.8 15.3 43.4l71 25.8 3.3-9.1c19.5-53.6 49.1-103 87.1-145.5l4-4.5c6.2-6.9 13.1-13 20.5-18.2c-79.6 2.5-154.7 42.2-201.2 108z"
    ]
};
var $d8206b3ab2e65c05$export$5e975cb293c48461 = {
    prefix: "fas",
    iconName: "helmet-un",
    icon: [
        512,
        512,
        [],
        "e503",
        "M479.5 224C471.2 98.9 367.2 0 240 0C107.5 0 0 107.5 0 240v56.3C0 344.8 39.2 384 87.7 384H200h14.9L343.5 505.4c4.5 4.2 10.4 6.6 16.5 6.6h96c13.3 0 24-10.7 24-24s-10.7-24-24-24H369.5l-1.5-1.5V288h80 32c17.7 0 32-14.3 32-32s-14.3-32-32-32h-.5zM320 417.2l-78-73.7L274.4 288H320V417.2zM285.3 103.1l34.7 52V112c0-8.8 7.2-16 16-16s16 7.2 16 16v96c0 7.1-4.6 13.3-11.4 15.3s-14-.6-17.9-6.4l-34.7-52V208c0 8.8-7.2 16-16 16s-16-7.2-16-16V112c0-7.1 4.6-13.3 11.4-15.3s14 .6 17.9 6.4zM160 112v64c0 8.8 7.2 16 16 16s16-7.2 16-16V112c0-8.8 7.2-16 16-16s16 7.2 16 16v64c0 26.5-21.5 48-48 48s-48-21.5-48-48V112c0-8.8 7.2-16 16-16s16 7.2 16 16z"
    ]
};
var $d8206b3ab2e65c05$export$554720e3bf74fe90 = {
    prefix: "fas",
    iconName: "bullseye",
    icon: [
        512,
        512,
        [],
        "f140",
        "M448 256A192 192 0 1 0 64 256a192 192 0 1 0 384 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256 80a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm0-224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zM224 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
    ]
};
var $d8206b3ab2e65c05$export$ab07061fe21a3a8e = {
    prefix: "fas",
    iconName: "bacon",
    icon: [
        576,
        512,
        [
            129363
        ],
        "f7e5",
        "M439.2 1.2c11.2-3.2 23.2-.1 31.4 8.1L518 56.7l-26.5 7.9c-58 16.6-98.1 39.6-129.6 67.4c-31.2 27.5-53.2 59.1-75.1 90.9l-2.3 3.3C241.6 288.7 195 356.6 72.8 417.7L37.9 435.2 9.4 406.6c-7.3-7.3-10.6-17.6-9-27.8s8.1-18.9 17.3-23.5C136.1 296.2 180.9 231 223.3 169.3l2.3-3.4c21.8-31.8 44.9-64.9 77.7-93.9c33.4-29.5 75.8-53.6 135.9-70.8zM61.8 459l25.4-12.7c129.5-64.7 179.9-138.1 223.8-202l2.2-3.3c22.1-32.1 42.1-60.5 69.9-85.1c27.5-24.3 63.4-45.2 117.3-60.6l0 0 .2-.1 43.1-12.9 23 23c8 8 11.2 19.7 8.3 30.7s-11.3 19.6-22.2 22.7c-51.9 14.8-85.6 34.7-111.1 57.2c-26.1 23-45.1 49.9-67.3 82.1l-2.2 3.2C327.8 365.9 275.5 442 142.3 508.6c-12.3 6.2-27.2 3.7-36.9-6L61.8 459z"
    ]
};
var $d8206b3ab2e65c05$export$f6dcbf0a940428f4 = {
    prefix: "fas",
    iconName: "hand-point-down",
    icon: [
        384,
        512,
        [],
        "f0a7",
        "M32 480c0 17.7 14.3 32 32 32s32-14.3 32-32V272H32V480zM224 320c0 17.7 14.3 32 32 32s32-14.3 32-32V256c0-17.7-14.3-32-32-32s-32 14.3-32 32v64zm-64 64c17.7 0 32-14.3 32-32V304c0-17.7-14.3-32-32-32s-32 14.3-32 32v48c0 17.7 14.3 32 32 32zm160-96c0 17.7 14.3 32 32 32s32-14.3 32-32V224c0-17.7-14.3-32-32-32s-32 14.3-32 32v64zm-96-88l0 .6c9.4-5.4 20.3-8.6 32-8.6c13.2 0 25.4 4 35.6 10.8c8.7-24.9 32.5-42.8 60.4-42.8c11.7 0 22.6 3.1 32 8.6V160C384 71.6 312.4 0 224 0H162.3C119.8 0 79.1 16.9 49.1 46.9L37.5 58.5C13.5 82.5 0 115.1 0 149v27c0 35.3 28.7 64 64 64h88c22.1 0 40-17.9 40-40s-17.9-40-40-40H96c-8.8 0-16-7.2-16-16s7.2-16 16-16h56c39.8 0 72 32.2 72 72z"
    ]
};
var $d8206b3ab2e65c05$export$c2af1be14cd87640 = {
    prefix: "fas",
    iconName: "arrow-up-from-bracket",
    icon: [
        448,
        512,
        [],
        "e09a",
        "M246.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 109.3V320c0 17.7 14.3 32 32 32s32-14.3 32-32V109.3l73.4 73.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-128-128zM64 352c0-17.7-14.3-32-32-32s-32 14.3-32 32v64c0 53 43 96 96 96H352c53 0 96-43 96-96V352c0-17.7-14.3-32-32-32s-32 14.3-32 32v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V352z"
    ]
};
var $d8206b3ab2e65c05$export$72b780186370e953 = {
    prefix: "fas",
    iconName: "folder",
    icon: [
        512,
        512,
        [
            128193,
            128447,
            61716,
            "folder-blank"
        ],
        "f07b",
        "M64 480H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H288c-10.1 0-19.6-4.7-25.6-12.8L243.2 57.6C231.1 41.5 212.1 32 192 32H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64z"
    ]
};
var $d8206b3ab2e65c05$export$9ef114244d26da0 = $d8206b3ab2e65c05$export$72b780186370e953;
var $d8206b3ab2e65c05$export$5e0c19cf315ac1bf = {
    prefix: "fas",
    iconName: "file-waveform",
    icon: [
        448,
        512,
        [
            "file-medical-alt"
        ],
        "f478",
        "M96 0C60.7 0 32 28.7 32 64V288H144c6.1 0 11.6 3.4 14.3 8.8L176 332.2l49.7-99.4c2.7-5.4 8.3-8.8 14.3-8.8s11.6 3.4 14.3 8.8L281.9 288H352c8.8 0 16 7.2 16 16s-7.2 16-16 16H272c-6.1 0-11.6-3.4-14.3-8.8L240 275.8l-49.7 99.4c-2.7 5.4-8.3 8.8-14.3 8.8s-11.6-3.4-14.3-8.8L134.1 320H32V448c0 35.3 28.7 64 64 64H352c35.3 0 64-28.7 64-64V160H288c-17.7 0-32-14.3-32-32V0H96zM288 0V128H416L288 0z"
    ]
};
var $d8206b3ab2e65c05$export$ef02a0f5b39aa61f = $d8206b3ab2e65c05$export$5e0c19cf315ac1bf;
var $d8206b3ab2e65c05$export$4c4e509518093d6d = {
    prefix: "fas",
    iconName: "radiation",
    icon: [
        512,
        512,
        [],
        "f7b9",
        "M216 186.7c-23.9 13.8-40 39.7-40 69.3L32 256C14.3 256-.2 241.6 2 224.1C10.7 154 47.8 92.7 101.3 52c14.1-10.7 33.8-5.3 42.7 10l72 124.7zM256 336c14.6 0 28.2-3.9 40-10.7l72 124.8c8.8 15.3 3.7 35.1-12.6 41.9c-30.6 12.9-64.2 20-99.4 20s-68.9-7.1-99.4-20c-16.3-6.9-21.4-26.6-12.6-41.9l72-124.8c11.8 6.8 25.4 10.7 40 10.7zm224-80l-144 0c0-29.6-16.1-55.5-40-69.3L368 62c8.8-15.3 28.6-20.7 42.7-10c53.6 40.7 90.6 102 99.4 172.1c2.2 17.5-12.4 31.9-30 31.9zM256 208a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
    ]
};
var $d8206b3ab2e65c05$export$8760a1de19ea40b9 = {
    prefix: "fas",
    iconName: "chart-simple",
    icon: [
        448,
        512,
        [],
        "e473",
        "M160 80c0-26.5 21.5-48 48-48h32c26.5 0 48 21.5 48 48V432c0 26.5-21.5 48-48 48H208c-26.5 0-48-21.5-48-48V80zM0 272c0-26.5 21.5-48 48-48H80c26.5 0 48 21.5 48 48V432c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V272zM368 96h32c26.5 0 48 21.5 48 48V432c0 26.5-21.5 48-48 48H368c-26.5 0-48-21.5-48-48V144c0-26.5 21.5-48 48-48z"
    ]
};
var $d8206b3ab2e65c05$export$aa05fce255a5d269 = {
    prefix: "fas",
    iconName: "mars-stroke",
    icon: [
        512,
        512,
        [
            9894
        ],
        "f229",
        "M376 0c-9.7 0-18.5 5.8-22.2 14.8s-1.7 19.3 5.2 26.2l33.4 33.4L370.3 96.4 345 71c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l25.4 25.4L307.8 159c-28.4-19.5-62.7-31-99.8-31c-97.2 0-176 78.8-176 176s78.8 176 176 176s176-78.8 176-176c0-37-11.4-71.4-31-99.8l28.6-28.6L407 201c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-25.4-25.4 22.1-22.1L471 153c6.9 6.9 17.2 8.9 26.2 5.2s14.8-12.5 14.8-22.2V24c0-13.3-10.7-24-24-24H376zm88 48h0v0l0 0zM96 304a112 112 0 1 1 224 0A112 112 0 1 1 96 304z"
    ]
};
var $d8206b3ab2e65c05$export$aa014b06d2d70598 = {
    prefix: "fas",
    iconName: "vial",
    icon: [
        512,
        512,
        [
            129514
        ],
        "f492",
        "M342.6 9.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l9.4 9.4L28.1 342.6C10.1 360.6 0 385 0 410.5V416c0 53 43 96 96 96h5.5c25.5 0 49.9-10.1 67.9-28.1L448 205.3l9.4 9.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-32-32-96-96-32-32zM205.3 256L352 109.3 402.7 160l-96 96H205.3z"
    ]
};
var $d8206b3ab2e65c05$export$dbfb0a9f89ad94a4 = {
    prefix: "fas",
    iconName: "gauge",
    icon: [
        512,
        512,
        [
            "dashboard",
            "gauge-med",
            "tachometer-alt-average"
        ],
        "f624",
        "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm320 96c0-26.9-16.5-49.9-40-59.3V88c0-13.3-10.7-24-24-24s-24 10.7-24 24V292.7c-23.5 9.5-40 32.5-40 59.3c0 35.3 28.7 64 64 64s64-28.7 64-64zM144 176a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-16 80a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm288 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM400 144a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"
    ]
};
var $d8206b3ab2e65c05$export$b7ce24136743d0f1 = $d8206b3ab2e65c05$export$dbfb0a9f89ad94a4;
var $d8206b3ab2e65c05$export$f948a9dd257979f3 = $d8206b3ab2e65c05$export$dbfb0a9f89ad94a4;
var $d8206b3ab2e65c05$export$6f22c345e5a92d1a = $d8206b3ab2e65c05$export$dbfb0a9f89ad94a4;
var $d8206b3ab2e65c05$export$5325fc72e75360b4 = {
    prefix: "fas",
    iconName: "wand-magic-sparkles",
    icon: [
        576,
        512,
        [
            "magic-wand-sparkles"
        ],
        "e2ca",
        "M234.7 42.7L197 56.8c-3 1.1-5 4-5 7.2s2 6.1 5 7.2l37.7 14.1L248.8 123c1.1 3 4 5 7.2 5s6.1-2 7.2-5l14.1-37.7L315 71.2c3-1.1 5-4 5-7.2s-2-6.1-5-7.2L277.3 42.7 263.2 5c-1.1-3-4-5-7.2-5s-6.1 2-7.2 5L234.7 42.7zM46.1 395.4c-18.7 18.7-18.7 49.1 0 67.9l34.6 34.6c18.7 18.7 49.1 18.7 67.9 0L529.9 116.5c18.7-18.7 18.7-49.1 0-67.9L495.3 14.1c-18.7-18.7-49.1-18.7-67.9 0L46.1 395.4zM484.6 82.6l-105 105-23.3-23.3 105-105 23.3 23.3zM7.5 117.2C3 118.9 0 123.2 0 128s3 9.1 7.5 10.8L64 160l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L128 160l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L128 96 106.8 39.5C105.1 35 100.8 32 96 32s-9.1 3-10.8 7.5L64 96 7.5 117.2zm352 256c-4.5 1.7-7.5 6-7.5 10.8s3 9.1 7.5 10.8L416 416l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L480 416l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L480 352l-21.2-56.5c-1.7-4.5-6-7.5-10.8-7.5s-9.1 3-10.8 7.5L416 352l-56.5 21.2z"
    ]
};
var $d8206b3ab2e65c05$export$c93286938249f0da = $d8206b3ab2e65c05$export$5325fc72e75360b4;
var $d8206b3ab2e65c05$export$86923e6fe1b42f5e = {
    prefix: "fas",
    iconName: "e",
    icon: [
        320,
        512,
        [
            101
        ],
        "45",
        "M64 32C28.7 32 0 60.7 0 96V256 416c0 35.3 28.7 64 64 64H288c17.7 0 32-14.3 32-32s-14.3-32-32-32H64V288H224c17.7 0 32-14.3 32-32s-14.3-32-32-32H64V96H288c17.7 0 32-14.3 32-32s-14.3-32-32-32H64z"
    ]
};
var $d8206b3ab2e65c05$export$eff4bdcafd3b8d1c = {
    prefix: "fas",
    iconName: "pen-clip",
    icon: [
        512,
        512,
        [
            "pen-alt"
        ],
        "f305",
        "M453.3 19.3l39.4 39.4c25 25 25 65.5 0 90.5l-52.1 52.1 0 0-1-1 0 0-16-16-96-96-17-17 52.1-52.1c25-25 65.5-25 90.5 0zM241 114.9c-9.4-9.4-24.6-9.4-33.9 0L105 217c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L173.1 81c28.1-28.1 73.7-28.1 101.8 0L288 94.1l17 17 96 96 16 16 1 1-17 17L229.5 412.5c-48 48-109.2 80.8-175.8 94.1l-25 5c-7.9 1.6-16-.9-21.7-6.6s-8.1-13.8-6.6-21.7l5-25c13.3-66.6 46.1-127.8 94.1-175.8L254.1 128 241 114.9z"
    ]
};
var $d8206b3ab2e65c05$export$a3d3e92e430d3beb = $d8206b3ab2e65c05$export$eff4bdcafd3b8d1c;
var $d8206b3ab2e65c05$export$4f25939fdf728c27 = {
    prefix: "fas",
    iconName: "bridge-circle-exclamation",
    icon: [
        640,
        512,
        [],
        "e4ca",
        "M64 32C46.3 32 32 46.3 32 64s14.3 32 32 32h40v64H32V288c53 0 96 43 96 96v64c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V384c0-53 43-96 96-96c6.3 0 12.4 .6 18.3 1.7C367.1 231.8 426.9 192 496 192c42.5 0 81.6 15.1 112 40.2V160H536V96h40c17.7 0 32-14.3 32-32s-14.3-32-32-32H64zM488 96v64H408V96h80zM360 96v64H280V96h80zM232 96v64H152V96h80zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V288c0-8.8 7.2-16 16-16z"
    ]
};
var $d8206b3ab2e65c05$export$f5699fa0844e0188 = {
    prefix: "fas",
    iconName: "user",
    icon: [
        448,
        512,
        [
            128100,
            62144
        ],
        "f007",
        "M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H418.3c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304H178.3z"
    ]
};
var $d8206b3ab2e65c05$export$c8c95c2f9937bf6a = {
    prefix: "fas",
    iconName: "school-circle-check",
    icon: [
        640,
        512,
        [],
        "e56b",
        "M337.8 5.4C327-1.8 313-1.8 302.2 5.4L166.3 96H48C21.5 96 0 117.5 0 144V464c0 26.5 21.5 48 48 48H320v0H256V416c0-35.3 28.7-64 64-64l.3 0h.5c3.4-37.7 18.7-72.1 42.2-99.1C350.2 260 335.6 264 320 264c-48.6 0-88-39.4-88-88s39.4-88 88-88s88 39.4 88 88c0 18.3-5.6 35.3-15.1 49.4c29-21 64.6-33.4 103.1-33.4c59.5 0 112.1 29.6 144 74.8V144c0-26.5-21.5-48-48-48H473.7L337.8 5.4zM96 192h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V208c0-8.8 7.2-16 16-16zm0 128h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V336c0-8.8 7.2-16 16-16zM320 128c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H336V144c0-8.8-7.2-16-16-16zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-99.3-43.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7z"
    ]
};
var $d8206b3ab2e65c05$export$3b934e22d1851a3b = {
    prefix: "fas",
    iconName: "dumpster",
    icon: [
        576,
        512,
        [],
        "f793",
        "M49.7 32c-10.5 0-19.8 6.9-22.9 16.9L.9 133c-.6 2-.9 4.1-.9 6.1C0 150.7 9.3 160 20.9 160h94L140.5 32H49.7zM272 160V32H173.1L147.5 160H272zm32 0H428.5L402.9 32H304V160zm157.1 0h94c11.5 0 20.9-9.3 20.9-20.9c0-2.1-.3-4.1-.9-6.1L549.2 48.9C546.1 38.9 536.8 32 526.3 32H435.5l25.6 128zM32 192l4 32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H44L64 448c0 17.7 14.3 32 32 32s32-14.3 32-32H448c0 17.7 14.3 32 32 32s32-14.3 32-32l20-160h12c17.7 0 32-14.3 32-32s-14.3-32-32-32h-4l4-32H32z"
    ]
};
var $d8206b3ab2e65c05$export$ecbd233b96906ee1 = {
    prefix: "fas",
    iconName: "van-shuttle",
    icon: [
        640,
        512,
        [
            128656,
            "shuttle-van"
        ],
        "f5b6",
        "M64 104v88h96V96H72c-4.4 0-8 3.6-8 8zm482 88L465.1 96H384v96H546zm-226 0V96H224v96h96zM592 384H576c0 53-43 96-96 96s-96-43-96-96H256c0 53-43 96-96 96s-96-43-96-96H48c-26.5 0-48-21.5-48-48V104C0 64.2 32.2 32 72 32H192 352 465.1c18.9 0 36.8 8.3 49 22.8L625 186.5c9.7 11.5 15 26.1 15 41.2V336c0 26.5-21.5 48-48 48zm-64 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM160 432a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"
    ]
};
var $d8206b3ab2e65c05$export$9d63d851db698c09 = $d8206b3ab2e65c05$export$ecbd233b96906ee1;
var $d8206b3ab2e65c05$export$d65aef1ed7db1dae = {
    prefix: "fas",
    iconName: "building-user",
    icon: [
        640,
        512,
        [],
        "e4da",
        "M48 0C21.5 0 0 21.5 0 48V464c0 26.5 21.5 48 48 48h96V432c0-26.5 21.5-48 48-48s48 21.5 48 48v80h89.9c-6.3-10.2-9.9-22.2-9.9-35.1c0-46.9 25.8-87.8 64-109.2V271.8 48c0-26.5-21.5-48-48-48H48zM64 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V240zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V240zM80 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V112zM272 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zM576 272a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM352 477.1c0 19.3 15.6 34.9 34.9 34.9H605.1c19.3 0 34.9-15.6 34.9-34.9c0-51.4-41.7-93.1-93.1-93.1H445.1c-51.4 0-93.1 41.7-93.1 93.1z"
    ]
};
var $d8206b3ab2e65c05$export$2c5163541229363 = {
    prefix: "fas",
    iconName: "square-caret-left",
    icon: [
        448,
        512,
        [
            "caret-square-left"
        ],
        "f191",
        "M0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416zM128 256c0-6.7 2.8-13 7.7-17.6l112-104c7-6.5 17.2-8.2 25.9-4.4s14.4 12.5 14.4 22l0 208c0 9.5-5.7 18.2-14.4 22s-18.9 2.1-25.9-4.4l-112-104c-4.9-4.5-7.7-10.9-7.7-17.6z"
    ]
};
var $d8206b3ab2e65c05$export$d0c8ba444f1f9581 = $d8206b3ab2e65c05$export$2c5163541229363;
var $d8206b3ab2e65c05$export$73801ed54b42fabe = {
    prefix: "fas",
    iconName: "highlighter",
    icon: [
        576,
        512,
        [],
        "f591",
        "M315 315l158.4-215L444.1 70.6 229 229 315 315zm-187 5l0 0V248.3c0-15.3 7.2-29.6 19.5-38.6L420.6 8.4C428 2.9 437 0 446.2 0c11.4 0 22.4 4.5 30.5 12.6l54.8 54.8c8.1 8.1 12.6 19 12.6 30.5c0 9.2-2.9 18.2-8.4 25.6L334.4 396.5c-9 12.3-23.4 19.5-38.6 19.5H224l-25.4 25.4c-12.5 12.5-32.8 12.5-45.3 0l-50.7-50.7c-12.5-12.5-12.5-32.8 0-45.3L128 320zM7 466.3l63-63 70.6 70.6-31 31c-4.5 4.5-10.6 7-17 7H24c-13.3 0-24-10.7-24-24v-4.7c0-6.4 2.5-12.5 7-17z"
    ]
};
var $d8206b3ab2e65c05$export$fa6ecc35e7315db = {
    prefix: "fas",
    iconName: "key",
    icon: [
        512,
        512,
        [
            128273
        ],
        "f084",
        "M336 352c97.2 0 176-78.8 176-176S433.2 0 336 0S160 78.8 160 176c0 18.7 2.9 36.8 8.3 53.7L7 391c-4.5 4.5-7 10.6-7 17v80c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V448h40c13.3 0 24-10.7 24-24V384h40c6.4 0 12.5-2.5 17-7l33.3-33.3c16.9 5.4 35 8.3 53.7 8.3zM376 96a40 40 0 1 1 0 80 40 40 0 1 1 0-80z"
    ]
};
var $d8206b3ab2e65c05$export$dacae2b4ec565333 = {
    prefix: "fas",
    iconName: "bullhorn",
    icon: [
        512,
        512,
        [
            128226,
            128363
        ],
        "f0a1",
        "M480 32c0-12.9-7.8-24.6-19.8-29.6s-25.7-2.2-34.9 6.9L381.7 53c-48 48-113.1 75-181 75H192 160 64c-35.3 0-64 28.7-64 64v96c0 35.3 28.7 64 64 64l0 128c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V352l8.7 0c67.9 0 133 27 181 75l43.6 43.6c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6V300.4c18.6-8.8 32-32.5 32-60.4s-13.4-51.6-32-60.4V32zm-64 76.7V240 371.3C357.2 317.8 280.5 288 200.7 288H192V192h8.7c79.8 0 156.5-29.8 215.3-83.3z"
    ]
};
var $d8206b3ab2e65c05$export$b1b1cdce4a19c682 = {
    prefix: "fas",
    iconName: "globe",
    icon: [
        512,
        512,
        [
            127760
        ],
        "f0ac",
        "M352 256c0 22.2-1.2 43.6-3.3 64H163.3c-2.2-20.4-3.3-41.8-3.3-64s1.2-43.6 3.3-64H348.7c2.2 20.4 3.3 41.8 3.3 64zm28.8-64H503.9c5.3 20.5 8.1 41.9 8.1 64s-2.8 43.5-8.1 64H380.8c2.1-20.6 3.2-42 3.2-64s-1.1-43.4-3.2-64zm112.6-32H376.7c-10-63.9-29.8-117.4-55.3-151.6c78.3 20.7 142 77.5 171.9 151.6zm-149.1 0H167.7c6.1-36.4 15.5-68.6 27-94.7c10.5-23.6 22.2-40.7 33.5-51.5C239.4 3.2 248.7 0 256 0s16.6 3.2 27.8 13.8c11.3 10.8 23 27.9 33.5 51.5c11.6 26 20.9 58.2 27 94.7zm-209 0H18.6C48.6 85.9 112.2 29.1 190.6 8.4C165.1 42.6 145.3 96.1 135.3 160zM8.1 192H131.2c-2.1 20.6-3.2 42-3.2 64s1.1 43.4 3.2 64H8.1C2.8 299.5 0 278.1 0 256s2.8-43.5 8.1-64zM194.7 446.6c-11.6-26-20.9-58.2-27-94.6H344.3c-6.1 36.4-15.5 68.6-27 94.6c-10.5 23.6-22.2 40.7-33.5 51.5C272.6 508.8 263.3 512 256 512s-16.6-3.2-27.8-13.8c-11.3-10.8-23-27.9-33.5-51.5zM135.3 352c10 63.9 29.8 117.4 55.3 151.6C112.2 482.9 48.6 426.1 18.6 352H135.3zm358.1 0c-30 74.1-93.6 130.9-171.9 151.6c25.5-34.2 45.2-87.7 55.3-151.6H493.4z"
    ]
};
var $d8206b3ab2e65c05$export$20d991385719b5b4 = {
    prefix: "fas",
    iconName: "synagogue",
    icon: [
        640,
        512,
        [
            128333
        ],
        "f69b",
        "M309.8 3.7c5.9-4.9 14.6-4.9 20.5 0l121 100.8C469.5 119.7 480 142.2 480 166V280.1 512H464 352V416c0-17.7-14.3-32-32-32s-32 14.3-32 32v96H176 160V280.1 166c0-23.7 10.5-46.3 28.8-61.5L309.8 3.7zM512 512V244.5l28.1-31.2c3-3.4 7.4-5.3 11.9-5.3s8.9 1.9 11.9 5.3l63.8 70.9c7.9 8.8 12.3 20.3 12.3 32.1V448c0 35.3-28.7 64-64 64H512zM128 244.5V512H64c-35.3 0-64-28.7-64-64V316.3c0-11.9 4.4-23.3 12.3-32.1l63.8-70.9c3-3.4 7.4-5.3 11.9-5.3s8.9 1.9 11.9 5.3L128 244.5zM327 124.3c-3.1-5.4-10.9-5.4-13.9 0l-15.9 28.1-32.3-.3c-6.2-.1-10.1 6.7-7 12.1L274.3 192l-16.4 27.8c-3.2 5.4 .7 12.1 7 12.1l32.3-.3L313 259.7c3.1 5.4 10.9 5.4 13.9 0l15.9-28.1 32.3 .3c6.2 .1 10.1-6.7 7-12.1L365.7 192l16.4-27.8c3.2-5.4-.7-12.1-7-12.1l-32.3 .3L327 124.3z"
    ]
};
var $d8206b3ab2e65c05$export$f3d75c19191f1688 = {
    prefix: "fas",
    iconName: "person-half-dress",
    icon: [
        320,
        512,
        [],
        "e548",
        "M160 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm8 352V128h6.9c33.7 0 64.9 17.7 82.3 46.6l58.3 97c9.1 15.1 4.2 34.8-10.9 43.9s-34.8 4.2-43.9-10.9L232 256.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352h0zM58.2 182.3c19.9-33.1 55.3-53.5 93.8-54.3V384h0v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V384H70.2c-10.9 0-18.6-10.7-15.2-21.1L93.3 248.1 59.4 304.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l53.6-89.2z"
    ]
};
var $d8206b3ab2e65c05$export$4d6835e7175dec24 = {
    prefix: "fas",
    iconName: "road-bridge",
    icon: [
        640,
        512,
        [],
        "e563",
        "M352 0H608c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H352c-17.7 0-32-14.3-32-32V32c0-17.7 14.3-32 32-32zM480 200c-13.3 0-24 10.7-24 24v64c0 13.3 10.7 24 24 24s24-10.7 24-24V224c0-13.3-10.7-24-24-24zm24 184c0-13.3-10.7-24-24-24s-24 10.7-24 24v64c0 13.3 10.7 24 24 24s24-10.7 24-24V384zM480 40c-13.3 0-24 10.7-24 24v64c0 13.3 10.7 24 24 24s24-10.7 24-24V64c0-13.3-10.7-24-24-24zM32 96H288v64H248v64h40v96c-53 0-96 43-96 96v64c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32V416c0-53-43-96-96-96V224H72V160H32c-17.7 0-32-14.3-32-32s14.3-32 32-32zm168 64H120v64h80V160z"
    ]
};
var $d8206b3ab2e65c05$export$4ac9c4c370f7b157 = {
    prefix: "fas",
    iconName: "location-arrow",
    icon: [
        448,
        512,
        [],
        "f124",
        "M429.6 92.1c4.9-11.9 2.1-25.6-7-34.7s-22.8-11.9-34.7-7l-352 144c-14.2 5.8-22.2 20.8-19.3 35.8s16.1 25.8 31.4 25.8H224V432c0 15.3 10.8 28.4 25.8 31.4s30-5.1 35.8-19.3l144-352z"
    ]
};
var $d8206b3ab2e65c05$export$a2c1c457834fc6d8 = {
    prefix: "fas",
    iconName: "c",
    icon: [
        384,
        512,
        [
            99
        ],
        "43",
        "M329.1 142.9c-62.5-62.5-155.8-62.5-218.3 0s-62.5 163.8 0 226.3s155.8 62.5 218.3 0c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3c-87.5 87.5-221.3 87.5-308.8 0s-87.5-229.3 0-316.8s221.3-87.5 308.8 0c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0z"
    ]
};
var $d8206b3ab2e65c05$export$2d33c367b2b091ac = {
    prefix: "fas",
    iconName: "tablet-button",
    icon: [
        448,
        512,
        [],
        "f10a",
        "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM224 400a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $d8206b3ab2e65c05$export$6f08294ba8a2459c = {
    prefix: "fas",
    iconName: "building-lock",
    icon: [
        576,
        512,
        [],
        "e4d6",
        "M48 0C21.5 0 0 21.5 0 48V464c0 26.5 21.5 48 48 48h96V432c0-26.5 21.5-48 48-48s48 21.5 48 48v80h88.6c-5.4-9.4-8.6-20.3-8.6-32V352c0-23.7 12.9-44.4 32-55.4V272c0-30.5 12.2-58.2 32-78.4V48c0-26.5-21.5-48-48-48H48zM64 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V240zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V240zM80 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V112zM272 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zM464 240c17.7 0 32 14.3 32 32v48H432V272c0-17.7 14.3-32 32-32zm-80 32v48c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H544c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32V272c0-44.2-35.8-80-80-80s-80 35.8-80 80z"
    ]
};
var $d8206b3ab2e65c05$export$c9f93c4667edc585 = {
    prefix: "fas",
    iconName: "pizza-slice",
    icon: [
        512,
        512,
        [],
        "f818",
        "M169.7 .9c-22.8-1.6-41.9 14-47.5 34.7L110.4 80c.5 0 1.1 0 1.6 0c176.7 0 320 143.3 320 320c0 .5 0 1.1 0 1.6l44.4-11.8c20.8-5.5 36.3-24.7 34.7-47.5C498.5 159.5 352.5 13.5 169.7 .9zM399.8 410.2c.1-3.4 .2-6.8 .2-10.2c0-159.1-128.9-288-288-288c-3.4 0-6.8 .1-10.2 .2L.5 491.9c-1.5 5.5 .1 11.4 4.1 15.4s9.9 5.6 15.4 4.1L399.8 410.2zM176 208a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm64 128a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM96 384a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
    ]
};
var $d8206b3ab2e65c05$export$53e23123cc9a6796 = {
    prefix: "fas",
    iconName: "money-bill-wave",
    icon: [
        576,
        512,
        [],
        "f53a",
        "M0 112.5V422.3c0 18 10.1 35 27 41.3c87 32.5 174 10.3 261-11.9c79.8-20.3 159.6-40.7 239.3-18.9c23 6.3 48.7-9.5 48.7-33.4V89.7c0-18-10.1-35-27-41.3C462 15.9 375 38.1 288 60.3C208.2 80.6 128.4 100.9 48.7 79.1C25.6 72.8 0 88.6 0 112.5zM288 352c-44.2 0-80-43-80-96s35.8-96 80-96s80 43 80 96s-35.8 96-80 96zM64 352c35.3 0 64 28.7 64 64H64V352zm64-208c0 35.3-28.7 64-64 64V144h64zM512 304v64H448c0-35.3 28.7-64 64-64zM448 96h64v64c-35.3 0-64-28.7-64-64z"
    ]
};
var $d8206b3ab2e65c05$export$2acab8312b7a999b = {
    prefix: "fas",
    iconName: "chart-area",
    icon: [
        512,
        512,
        [
            "area-chart"
        ],
        "f1fe",
        "M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64V400c0 44.2 35.8 80 80 80H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H80c-8.8 0-16-7.2-16-16V64zm96 288H448c17.7 0 32-14.3 32-32V251.8c0-7.6-2.7-15-7.7-20.8l-65.8-76.8c-12.1-14.2-33.7-15-46.9-1.8l-21 21c-10 10-26.4 9.2-35.4-1.6l-39.2-47c-12.6-15.1-35.7-15.4-48.7-.6L135.9 215c-5.1 5.8-7.9 13.3-7.9 21.1v84c0 17.7 14.3 32 32 32z"
    ]
};
var $d8206b3ab2e65c05$export$fc2e595f0e0612cb = $d8206b3ab2e65c05$export$2acab8312b7a999b;
var $d8206b3ab2e65c05$export$9a3d31c75a465b9a = {
    prefix: "fas",
    iconName: "house-flag",
    icon: [
        640,
        512,
        [],
        "e50d",
        "M480 0c-17.7 0-32 14.3-32 32V192 512h64V192H624c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16H512c0-17.7-14.3-32-32-32zM416 159L276.8 39.7c-12-10.3-29.7-10.3-41.7 0l-224 192C1 240.4-2.7 254.5 2 267.1S18.6 288 32 288H64V480c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V384c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v96c0 17.7 14.3 32 32 32h64.7l.2 0h-1V159z"
    ]
};
var $d8206b3ab2e65c05$export$d7ccc6651f90f7cc = {
    prefix: "fas",
    iconName: "person-circle-minus",
    icon: [
        576,
        512,
        [],
        "e540",
        "M112 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm40 304V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V256.9L59.4 304.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c17.4-28.9 48.6-46.6 82.3-46.6h29.7c33.7 0 64.9 17.7 82.3 46.6l44.9 74.7c-16.1 17.6-28.6 38.5-36.6 61.5c-1.9-1.8-3.5-3.9-4.9-6.3L232 256.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352H152zm136 16a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm224 0c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16s7.2 16 16 16H496c8.8 0 16-7.2 16-16z"
    ]
};
var $d8206b3ab2e65c05$export$76f704d256def3c7 = {
    prefix: "fas",
    iconName: "ban",
    icon: [
        512,
        512,
        [
            128683,
            "cancel"
        ],
        "f05e",
        "M367.2 412.5L99.5 144.8C77.1 176.1 64 214.5 64 256c0 106 86 192 192 192c41.5 0 79.9-13.1 111.2-35.5zm45.3-45.3C434.9 335.9 448 297.5 448 256c0-106-86-192-192-192c-41.5 0-79.9 13.1-111.2 35.5L412.5 367.2zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"
    ]
};
var $d8206b3ab2e65c05$export$6d25ef56192f6d69 = $d8206b3ab2e65c05$export$76f704d256def3c7;
var $d8206b3ab2e65c05$export$e0ce7d1aba7105e7 = {
    prefix: "fas",
    iconName: "camera-rotate",
    icon: [
        640,
        512,
        [],
        "e0d8",
        "M213.1 64.8L202.7 96H128c-35.3 0-64 28.7-64 64V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H437.3L426.9 64.8C420.4 45.2 402.1 32 381.4 32H258.6c-20.7 0-39 13.2-45.5 32.8zM448 256c0 8.8-7.2 16-16 16H355.3c-6.2 0-11.3-5.1-11.3-11.3c0-3 1.2-5.9 3.3-8L371 229c-13.6-13.4-31.9-21-51-21c-19.2 0-37.7 7.6-51.3 21.3L249 249c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l19.7-19.7C257.4 172.7 288 160 320 160c31.8 0 62.4 12.6 85 35l23.7-23.7c2.1-2.1 5-3.3 8-3.3c6.2 0 11.3 5.1 11.3 11.3V256zM192 320c0-8.8 7.2-16 16-16h76.7c6.2 0 11.3 5.1 11.3 11.3c0 3-1.2 5.9-3.3 8L269 347c13.6 13.4 31.9 21 51 21c19.2 0 37.7-7.6 51.3-21.3L391 327c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-19.7 19.7C382.6 403.3 352 416 320 416c-31.8 0-62.4-12.6-85-35l-23.7 23.7c-2.1 2.1-5 3.3-8 3.3c-6.2 0-11.3-5.1-11.3-11.3V320z"
    ]
};
var $d8206b3ab2e65c05$export$43832c90c10a7a31 = {
    prefix: "fas",
    iconName: "spray-can-sparkles",
    icon: [
        512,
        512,
        [
            "air-freshener"
        ],
        "f5d0",
        "M96 32v96H224V32c0-17.7-14.3-32-32-32H128C110.3 0 96 14.3 96 32zm0 128c-53 0-96 43-96 96V464c0 26.5 21.5 48 48 48H272c26.5 0 48-21.5 48-48V256c0-53-43-96-96-96H96zm64 96a80 80 0 1 1 0 160 80 80 0 1 1 0-160zM384 48c0-1.4-1-3-2.2-3.6L352 32 339.6 2.2C339 1 337.4 0 336 0s-3 1-3.6 2.2L320 32 290.2 44.4C289 45 288 46.6 288 48c0 1.4 1 3 2.2 3.6L320 64l12.4 29.8C333 95 334.6 96 336 96s3-1 3.6-2.2L352 64l29.8-12.4C383 51 384 49.4 384 48zm76.4 45.8C461 95 462.6 96 464 96s3-1 3.6-2.2L480 64l29.8-12.4C511 51 512 49.4 512 48c0-1.4-1-3-2.2-3.6L480 32 467.6 2.2C467 1 465.4 0 464 0s-3 1-3.6 2.2L448 32 418.2 44.4C417 45 416 46.6 416 48c0 1.4 1 3 2.2 3.6L448 64l12.4 29.8zm7.2 100.4c-.6-1.2-2.2-2.2-3.6-2.2s-3 1-3.6 2.2L448 224l-29.8 12.4c-1.2 .6-2.2 2.2-2.2 3.6c0 1.4 1 3 2.2 3.6L448 256l12.4 29.8c.6 1.2 2.2 2.2 3.6 2.2s3-1 3.6-2.2L480 256l29.8-12.4c1.2-.6 2.2-2.2 2.2-3.6c0-1.4-1-3-2.2-3.6L480 224l-12.4-29.8zM448 144c0-1.4-1-3-2.2-3.6L416 128 403.6 98.2C403 97 401.4 96 400 96s-3 1-3.6 2.2L384 128l-29.8 12.4c-1.2 .6-2.2 2.2-2.2 3.6c0 1.4 1 3 2.2 3.6L384 160l12.4 29.8c.6 1.2 2.2 2.2 3.6 2.2s3-1 3.6-2.2L416 160l29.8-12.4c1.2-.6 2.2-2.2 2.2-3.6z"
    ]
};
var $d8206b3ab2e65c05$export$a5e63e89b5ccee83 = $d8206b3ab2e65c05$export$43832c90c10a7a31;
var $d8206b3ab2e65c05$export$a3b0eb2cd7942125 = {
    prefix: "fas",
    iconName: "star",
    icon: [
        576,
        512,
        [
            11088,
            61446
        ],
        "f005",
        "M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z"
    ]
};
var $d8206b3ab2e65c05$export$cb8434288c91ae83 = {
    prefix: "fas",
    iconName: "repeat",
    icon: [
        512,
        512,
        [
            128257
        ],
        "f363",
        "M0 224c0 17.7 14.3 32 32 32s32-14.3 32-32c0-53 43-96 96-96H320v32c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l64-64c12.5-12.5 12.5-32.8 0-45.3l-64-64c-9.2-9.2-22.9-11.9-34.9-6.9S320 19.1 320 32V64H160C71.6 64 0 135.6 0 224zm512 64c0-17.7-14.3-32-32-32s-32 14.3-32 32c0 53-43 96-96 96H192V352c0-12.9-7.8-24.6-19.8-29.6s-25.7-2.2-34.9 6.9l-64 64c-12.5 12.5-12.5 32.8 0 45.3l64 64c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6V448H352c88.4 0 160-71.6 160-160z"
    ]
};
var $d8206b3ab2e65c05$export$9d0a89fcd084abb = {
    prefix: "fas",
    iconName: "cross",
    icon: [
        384,
        512,
        [
            128327,
            10013
        ],
        "f654",
        "M176 0c-26.5 0-48 21.5-48 48v80H48c-26.5 0-48 21.5-48 48v32c0 26.5 21.5 48 48 48h80V464c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V256h80c26.5 0 48-21.5 48-48V176c0-26.5-21.5-48-48-48H256V48c0-26.5-21.5-48-48-48H176z"
    ]
};
var $d8206b3ab2e65c05$export$6e7cf270cda52323 = {
    prefix: "fas",
    iconName: "box",
    icon: [
        448,
        512,
        [
            128230
        ],
        "f466",
        "M50.7 58.5L0 160H208V32H93.7C75.5 32 58.9 42.3 50.7 58.5zM240 160H448L397.3 58.5C389.1 42.3 372.5 32 354.3 32H240V160zm208 32H0V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V192z"
    ]
};
var $d8206b3ab2e65c05$export$63f2d9e5f4689aa8 = {
    prefix: "fas",
    iconName: "venus-mars",
    icon: [
        640,
        512,
        [
            9892
        ],
        "f228",
        "M176 288a112 112 0 1 0 0-224 112 112 0 1 0 0 224zM352 176c0 86.3-62.1 158.1-144 173.1V384h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H208v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V448H112c-17.7 0-32-14.3-32-32s14.3-32 32-32h32V349.1C62.1 334.1 0 262.3 0 176C0 78.8 78.8 0 176 0s176 78.8 176 176zM271.9 360.6c19.3-10.1 36.9-23.1 52.1-38.4c20 18.5 46.7 29.8 76.1 29.8c61.9 0 112-50.1 112-112s-50.1-112-112-112c-7.2 0-14.3 .7-21.1 2c-4.9-21.5-13-41.7-24-60.2C369.3 66 384.4 64 400 64c37 0 71.4 11.4 99.8 31l20.6-20.6L487 41c-6.9-6.9-8.9-17.2-5.2-26.2S494.3 0 504 0H616c13.3 0 24 10.7 24 24V136c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-33.4-33.4L545 140.2c19.5 28.4 31 62.7 31 99.8c0 97.2-78.8 176-176 176c-50.5 0-96-21.3-128.1-55.4z"
    ]
};
var $d8206b3ab2e65c05$export$e4f903bc63db445 = {
    prefix: "fas",
    iconName: "arrow-pointer",
    icon: [
        320,
        512,
        [
            "mouse-pointer"
        ],
        "f245",
        "M0 55.2V426c0 12.2 9.9 22 22 22c6.3 0 12.4-2.7 16.6-7.5L121.2 346l58.1 116.3c7.9 15.8 27.1 22.2 42.9 14.3s22.2-27.1 14.3-42.9L179.8 320H297.9c12.2 0 22.1-9.9 22.1-22.1c0-6.3-2.7-12.3-7.4-16.5L38.6 37.9C34.3 34.1 28.9 32 23.2 32C10.4 32 0 42.4 0 55.2z"
    ]
};
var $d8206b3ab2e65c05$export$2e19a69cc26b147 = $d8206b3ab2e65c05$export$e4f903bc63db445;
var $d8206b3ab2e65c05$export$8d2b1b230601e804 = {
    prefix: "fas",
    iconName: "maximize",
    icon: [
        512,
        512,
        [
            "expand-arrows-alt"
        ],
        "f31e",
        "M200 32H56C42.7 32 32 42.7 32 56V200c0 9.7 5.8 18.5 14.8 22.2s19.3 1.7 26.2-5.2l40-40 79 79-79 79L73 295c-6.9-6.9-17.2-8.9-26.2-5.2S32 302.3 32 312V456c0 13.3 10.7 24 24 24H200c9.7 0 18.5-5.8 22.2-14.8s1.7-19.3-5.2-26.2l-40-40 79-79 79 79-40 40c-6.9 6.9-8.9 17.2-5.2 26.2s12.5 14.8 22.2 14.8H456c13.3 0 24-10.7 24-24V312c0-9.7-5.8-18.5-14.8-22.2s-19.3-1.7-26.2 5.2l-40 40-79-79 79-79 40 40c6.9 6.9 17.2 8.9 26.2 5.2s14.8-12.5 14.8-22.2V56c0-13.3-10.7-24-24-24H312c-9.7 0-18.5 5.8-22.2 14.8s-1.7 19.3 5.2 26.2l40 40-79 79-79-79 40-40c6.9-6.9 8.9-17.2 5.2-26.2S209.7 32 200 32z"
    ]
};
var $d8206b3ab2e65c05$export$6219dcd88b5fa6c2 = $d8206b3ab2e65c05$export$8d2b1b230601e804;
var $d8206b3ab2e65c05$export$bab2cd86f8c65657 = {
    prefix: "fas",
    iconName: "charging-station",
    icon: [
        576,
        512,
        [],
        "f5e7",
        "M96 0C60.7 0 32 28.7 32 64V448c-17.7 0-32 14.3-32 32s14.3 32 32 32H320c17.7 0 32-14.3 32-32s-14.3-32-32-32V304h16c22.1 0 40 17.9 40 40v32c0 39.8 32.2 72 72 72s72-32.2 72-72V252.3c32.5-10.2 56-40.5 56-76.3V144c0-8.8-7.2-16-16-16H544V80c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H480V80c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H432c-8.8 0-16 7.2-16 16v32c0 35.8 23.5 66.1 56 76.3V376c0 13.3-10.7 24-24 24s-24-10.7-24-24V344c0-48.6-39.4-88-88-88H320V64c0-35.3-28.7-64-64-64H96zM216.9 82.7c6 4 8.5 11.5 6.3 18.3l-25 74.9H256c6.7 0 12.7 4.2 15 10.4s.5 13.3-4.6 17.7l-112 96c-5.5 4.7-13.4 5.1-19.3 1.1s-8.5-11.5-6.3-18.3l25-74.9H96c-6.7 0-12.7-4.2-15-10.4s-.5-13.3 4.6-17.7l112-96c5.5-4.7 13.4-5.1 19.3-1.1z"
    ]
};
var $d8206b3ab2e65c05$export$b17d50542d1fc340 = {
    prefix: "fas",
    iconName: "shapes",
    icon: [
        512,
        512,
        [
            "triangle-circle-square"
        ],
        "f61f",
        "M315.4 15.5C309.7 5.9 299.2 0 288 0s-21.7 5.9-27.4 15.5l-96 160c-5.9 9.9-6.1 22.2-.4 32.2s16.3 16.2 27.8 16.2H384c11.5 0 22.2-6.2 27.8-16.2s5.5-22.3-.4-32.2l-96-160zM288 312V456c0 22.1 17.9 40 40 40H472c22.1 0 40-17.9 40-40V312c0-22.1-17.9-40-40-40H328c-22.1 0-40 17.9-40 40zM128 512a128 128 0 1 0 0-256 128 128 0 1 0 0 256z"
    ]
};
var $d8206b3ab2e65c05$export$34261e5aea24fc1d = $d8206b3ab2e65c05$export$b17d50542d1fc340;
var $d8206b3ab2e65c05$export$ee94b652453ad208 = {
    prefix: "fas",
    iconName: "shuffle",
    icon: [
        512,
        512,
        [
            128256,
            "random"
        ],
        "f074",
        "M403.8 34.4c12-5 25.7-2.2 34.9 6.9l64 64c6 6 9.4 14.1 9.4 22.6s-3.4 16.6-9.4 22.6l-64 64c-9.2 9.2-22.9 11.9-34.9 6.9s-19.8-16.6-19.8-29.6V160H352c-10.1 0-19.6 4.7-25.6 12.8L284 229.3 244 176l31.2-41.6C293.3 110.2 321.8 96 352 96h32V64c0-12.9 7.8-24.6 19.8-29.6zM164 282.7L204 336l-31.2 41.6C154.7 401.8 126.2 416 96 416H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H96c10.1 0 19.6-4.7 25.6-12.8L164 282.7zm274.6 188c-9.2 9.2-22.9 11.9-34.9 6.9s-19.8-16.6-19.8-29.6V416H352c-30.2 0-58.7-14.2-76.8-38.4L121.6 172.8c-6-8.1-15.5-12.8-25.6-12.8H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H96c30.2 0 58.7 14.2 76.8 38.4L326.4 339.2c6 8.1 15.5 12.8 25.6 12.8h32V320c0-12.9 7.8-24.6 19.8-29.6s25.7-2.2 34.9 6.9l64 64c6 6 9.4 14.1 9.4 22.6s-3.4 16.6-9.4 22.6l-64 64z"
    ]
};
var $d8206b3ab2e65c05$export$8357bf8cc666d5f0 = $d8206b3ab2e65c05$export$ee94b652453ad208;
var $d8206b3ab2e65c05$export$f48814ae62850c74 = {
    prefix: "fas",
    iconName: "person-running",
    icon: [
        448,
        512,
        [
            127939,
            "running"
        ],
        "f70c",
        "M320 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM125.7 175.5c9.9-9.9 23.4-15.5 37.5-15.5c1.9 0 3.8 .1 5.6 .3L137.6 254c-9.3 28 1.7 58.8 26.8 74.5l86.2 53.9-25.4 88.8c-4.9 17 5 34.7 22 39.6s34.7-5 39.6-22l28.7-100.4c5.9-20.6-2.6-42.6-20.7-53.9L238 299l30.9-82.4 5.1 12.3C289 264.7 323.9 288 362.7 288H384c17.7 0 32-14.3 32-32s-14.3-32-32-32H362.7c-12.9 0-24.6-7.8-29.5-19.7l-6.3-15c-14.6-35.1-44.1-61.9-80.5-73.1l-48.7-15c-11.1-3.4-22.7-5.2-34.4-5.2c-31 0-60.8 12.3-82.7 34.3L57.4 153.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l23.1-23.1zM91.2 352H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h69.6c19 0 36.2-11.2 43.9-28.5L157 361.6l-9.5-6c-17.5-10.9-30.5-26.8-37.9-44.9L91.2 352z"
    ]
};
var $d8206b3ab2e65c05$export$5dfd1cb43dc9eadb = $d8206b3ab2e65c05$export$f48814ae62850c74;
var $d8206b3ab2e65c05$export$7955f08360418647 = {
    prefix: "fas",
    iconName: "mobile-retro",
    icon: [
        320,
        512,
        [],
        "e527",
        "M0 64C0 28.7 28.7 0 64 0H256c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm64 96v64c0 17.7 14.3 32 32 32H224c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32H96c-17.7 0-32 14.3-32 32zM80 352a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm24 56a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm56-56a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm24 56a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm56-56a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm24 56a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM128 48c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H128z"
    ]
};
var $d8206b3ab2e65c05$export$523960de087f5198 = {
    prefix: "fas",
    iconName: "grip-lines-vertical",
    icon: [
        192,
        512,
        [],
        "f7a5",
        "M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64V448c0 17.7 14.3 32 32 32s32-14.3 32-32V64zm128 0c0-17.7-14.3-32-32-32s-32 14.3-32 32V448c0 17.7 14.3 32 32 32s32-14.3 32-32V64z"
    ]
};
var $d8206b3ab2e65c05$export$6daa96b1986e2ef0 = {
    prefix: "fas",
    iconName: "spider",
    icon: [
        512,
        512,
        [
            128375
        ],
        "f717",
        "M158.4 32.6c4.8-12.4-1.4-26.3-13.8-31s-26.3 1.4-31 13.8L81.1 100c-7.9 20.7-3 44.1 12.7 59.7l57.4 57.4L70.8 190.3c-2.4-.8-4.3-2.7-5.1-5.1L46.8 128.4C42.6 115.8 29 109 16.4 113.2S-3 131 1.2 143.6l18.9 56.8c5.6 16.7 18.7 29.8 35.4 35.4L116.1 256 55.6 276.2c-16.7 5.6-29.8 18.7-35.4 35.4L1.2 368.4C-3 381 3.8 394.6 16.4 398.8s26.2-2.6 30.4-15.2l18.9-56.8c.8-2.4 2.7-4.3 5.1-5.1l80.4-26.8L93.7 352.3C78.1 368 73.1 391.4 81.1 412l32.5 84.6c4.8 12.4 18.6 18.5 31 13.8s18.5-18.6 13.8-31l-32.5-84.6c-1.1-3-.4-6.3 1.8-8.5L160 353.9c1 52.1 43.6 94.1 96 94.1s95-41.9 96-94.1l32.3 32.3c2.2 2.2 2.9 5.6 1.8 8.5l-32.5 84.6c-4.8 12.4 1.4 26.3 13.8 31s26.3-1.4 31-13.8L430.9 412c7.9-20.7 3-44.1-12.7-59.7l-57.4-57.4 80.4 26.8c2.4 .8 4.3 2.7 5.1 5.1l18.9 56.8c4.2 12.6 17.8 19.4 30.4 15.2s19.4-17.8 15.2-30.4l-18.9-56.8c-5.6-16.7-18.7-29.8-35.4-35.4L395.9 256l60.5-20.2c16.7-5.6 29.8-18.7 35.4-35.4l18.9-56.8c4.2-12.6-2.6-26.2-15.2-30.4s-26.2 2.6-30.4 15.2l-18.9 56.8c-.8 2.4-2.7 4.3-5.1 5.1l-80.4 26.8 57.4-57.4c15.6-15.6 20.6-39 12.7-59.7L398.4 15.4C393.6 3 379.8-3.2 367.4 1.6s-18.5 18.6-13.8 31l32.5 84.6c1.1 3 .4 6.3-1.8 8.5L336 174.1V160c0-31.8-18.6-59.3-45.5-72.2c-9.1-4.4-18.5 3.3-18.5 13.4V112c0 8.8-7.2 16-16 16s-16-7.2-16-16V101.2c0-10.1-9.4-17.7-18.5-13.4C194.6 100.7 176 128.2 176 160v14.1l-48.3-48.3c-2.2-2.2-2.9-5.6-1.8-8.5l32.5-84.6z"
    ]
};
var $d8206b3ab2e65c05$export$740142a89118fbc0 = {
    prefix: "fas",
    iconName: "hands-bound",
    icon: [
        640,
        512,
        [],
        "e4f9",
        "M96 32C96 14.3 81.7 0 64 0S32 14.3 32 32V96v59.1 .7V192v21.9c0 14.2 5.1 27.9 14.3 38.7L131.6 352H128c-13.3 0-24 10.7-24 24s10.7 24 24 24h32H288h64H480h32c13.3 0 24-10.7 24-24s-10.7-24-24-24h-3.6l85.3-99.5c9.2-10.8 14.3-24.5 14.3-38.7V192 155.8v-.7V96 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V96v48.8l-69.3 92.4c-5.7 7.6-16.1 9.6-24.2 4.8c-9.7-5.7-12.1-18.7-5.1-27.5L473 180c10.8-13.5 8.9-33.3-4.4-44.5s-33-9.8-44.5 3.2l-46.7 52.5C361 209.7 352 233.4 352 258.1V320v32H288V320 258.1c0-24.6-9-48.4-25.4-66.8l-46.7-52.5c-11.5-13-31.3-14.4-44.5-3.2s-15.2 30.9-4.4 44.5l27.6 34.5c7 8.8 4.7 21.8-5.1 27.5c-8.1 4.8-18.6 2.7-24.2-4.8L96 144.8V96 32zm64 448v32H288V480h64v32H480V480h32c13.3 0 24-10.7 24-24s-10.7-24-24-24H480 352 288 160 128c-13.3 0-24 10.7-24 24s10.7 24 24 24h32z"
    ]
};
var $d8206b3ab2e65c05$export$a3dced32d48cb1ea = {
    prefix: "fas",
    iconName: "file-invoice-dollar",
    icon: [
        384,
        512,
        [],
        "f571",
        "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM64 80c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm128 72c8.8 0 16 7.2 16 16v17.3c8.5 1.2 16.7 3.1 24.1 5.1c8.5 2.3 13.6 11 11.3 19.6s-11 13.6-19.6 11.3c-11.1-3-22-5.2-32.1-5.3c-8.4-.1-17.4 1.8-23.6 5.5c-5.7 3.4-8.1 7.3-8.1 12.8c0 3.7 1.3 6.5 7.3 10.1c6.9 4.1 16.6 7.1 29.2 10.9l.5 .1 0 0 0 0c11.3 3.4 25.3 7.6 36.3 14.6c12.1 7.6 22.4 19.7 22.7 38.2c.3 19.3-9.6 33.3-22.9 41.6c-7.7 4.8-16.4 7.6-25.1 9.1V440c0 8.8-7.2 16-16 16s-16-7.2-16-16V422.2c-11.2-2.1-21.7-5.7-30.9-8.9l0 0 0 0c-2.1-.7-4.2-1.4-6.2-2.1c-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1c2.5 .8 4.8 1.6 7.1 2.4l0 0 0 0 0 0c13.6 4.6 24.6 8.4 36.3 8.7c9.1 .3 17.9-1.7 23.7-5.3c5.1-3.2 7.9-7.3 7.8-14c-.1-4.6-1.8-7.8-7.7-11.6c-6.8-4.3-16.5-7.4-29-11.2l-1.6-.5 0 0c-11-3.3-24.3-7.3-34.8-13.7c-12-7.2-22.6-18.9-22.7-37.3c-.1-19.4 10.8-32.8 23.8-40.5c7.5-4.4 15.8-7.2 24.1-8.7V232c0-8.8 7.2-16 16-16z"
    ]
};
var $d8206b3ab2e65c05$export$f201ba865ea1b8dc = {
    prefix: "fas",
    iconName: "plane-circle-exclamation",
    icon: [
        640,
        512,
        [],
        "e556",
        "M256 0c-35 0-64 59.5-64 93.7v84.6L8.1 283.4c-5 2.8-8.1 8.2-8.1 13.9v65.5c0 10.6 10.2 18.3 20.4 15.4l171.6-49 0 70.9-57.6 43.2c-4 3-6.4 7.8-6.4 12.8v42c0 7.8 6.3 14 14 14c1.3 0 2.6-.2 3.9-.5L256 480l110.1 31.5c1.3 .4 2.6 .5 3.9 .5c6 0 11.1-3.7 13.1-9C344.5 470.7 320 422.2 320 368c0-60.6 30.6-114 77.1-145.6L320 178.3V93.7C320 59.5 292 0 256 0zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V288c0-8.8 7.2-16 16-16z"
    ]
};
var $d8206b3ab2e65c05$export$8cf137aceaaf4de0 = {
    prefix: "fas",
    iconName: "x-ray",
    icon: [
        512,
        512,
        [],
        "f497",
        "M0 64C0 46.3 14.3 32 32 32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32V416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32V96C14.3 96 0 81.7 0 64zM256 96c-8.8 0-16 7.2-16 16v32H160c-8.8 0-16 7.2-16 16s7.2 16 16 16h80v48H128c-8.8 0-16 7.2-16 16s7.2 16 16 16H240v70.6L189.1 307c-5.2-2-10.6-3-16.2-3h-2.1c-23.6 0-42.8 19.2-42.8 42.8c0 9.6 3.2 18.9 9.1 26.4l18.2 23.2c9.7 12.4 24.6 19.6 40.3 19.6H316.4c15.7 0 30.6-7.2 40.3-19.6l18.2-23.2c5.9-7.5 9.1-16.8 9.1-26.4c0-23.6-19.2-42.8-42.8-42.8H339c-5.5 0-11 1-16.2 3L272 326.6V256H384c8.8 0 16-7.2 16-16s-7.2-16-16-16H272V176h80c8.8 0 16-7.2 16-16s-7.2-16-16-16H272V112c0-8.8-7.2-16-16-16zM208 352a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm80 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"
    ]
};
var $d8206b3ab2e65c05$export$761e747b06ed2e1f = {
    prefix: "fas",
    iconName: "spell-check",
    icon: [
        576,
        512,
        [],
        "f891",
        "M112 0C99.1 0 87.4 7.8 82.5 19.7l-66.7 160-13.3 32c-6.8 16.3 .9 35 17.2 41.8s35-.9 41.8-17.2L66.7 224h90.7l5.1 12.3c6.8 16.3 25.5 24 41.8 17.2s24-25.5 17.2-41.8l-13.3-32-66.7-160C136.6 7.8 124.9 0 112 0zm18.7 160H93.3L112 115.2 130.7 160zM256 32v96 96c0 17.7 14.3 32 32 32h80c44.2 0 80-35.8 80-80c0-23.1-9.8-43.8-25.4-58.4c6-11.2 9.4-24 9.4-37.6c0-44.2-35.8-80-80-80H288c-17.7 0-32 14.3-32 32zm96 64H320V64h32c8.8 0 16 7.2 16 16s-7.2 16-16 16zm-32 64h32 16c8.8 0 16 7.2 16 16s-7.2 16-16 16H320V160zM566.6 310.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L352 434.7l-73.4-73.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0l192-192z"
    ]
};
var $d8206b3ab2e65c05$export$f54d004dd5f1cb5e = {
    prefix: "fas",
    iconName: "slash",
    icon: [
        640,
        512,
        [],
        "f715",
        "M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z"
    ]
};
var $d8206b3ab2e65c05$export$72cf138e5ddda6eb = {
    prefix: "fas",
    iconName: "computer-mouse",
    icon: [
        384,
        512,
        [
            128433,
            "mouse"
        ],
        "f8cc",
        "M0 192H176V0H160C71.6 0 0 71.6 0 160v32zm0 32V352c0 88.4 71.6 160 160 160h64c88.4 0 160-71.6 160-160V224H192 0zm384-32V160C384 71.6 312.4 0 224 0H208V192H384z"
    ]
};
var $d8206b3ab2e65c05$export$198b96b894c66074 = $d8206b3ab2e65c05$export$72cf138e5ddda6eb;
var $d8206b3ab2e65c05$export$a02c5909359525be = {
    prefix: "fas",
    iconName: "arrow-right-to-bracket",
    icon: [
        512,
        512,
        [
            "sign-in"
        ],
        "f090",
        "M352 96l64 0c17.7 0 32 14.3 32 32l0 256c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l64 0c53 0 96-43 96-96l0-256c0-53-43-96-96-96l-64 0c-17.7 0-32 14.3-32 32s14.3 32 32 32zm-9.4 182.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L242.7 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l210.7 0-73.4 73.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l128-128z"
    ]
};
var $d8206b3ab2e65c05$export$a55eff0ca4f9c3df = $d8206b3ab2e65c05$export$a02c5909359525be;
var $d8206b3ab2e65c05$export$b3d636689da4a3e5 = {
    prefix: "fas",
    iconName: "shop-slash",
    icon: [
        640,
        512,
        [
            "store-alt-slash"
        ],
        "e070",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-54.8-43V224H512V376L384 275.7V224H320v1.5L277.2 192H603.2c20.3 0 36.8-16.5 36.8-36.8c0-7.3-2.2-14.4-6.2-20.4L558.2 21.4C549.3 8 534.4 0 518.3 0H121.7c-16 0-31 8-39.9 21.4L74.1 32.8 38.8 5.1zM36.8 192h85L21 112.5 6.2 134.7c-4 6.1-6.2 13.2-6.2 20.4C0 175.5 16.5 192 36.8 192zM320 384H128V224H64V384v80c0 26.5 21.5 48 48 48H336c26.5 0 48-21.5 48-48V398.5l-64-50.4V384zM544 512l-.3 0h.6l-.3 0z"
    ]
};
var $d8206b3ab2e65c05$export$b932a586f6ff48b4 = $d8206b3ab2e65c05$export$b3d636689da4a3e5;
var $d8206b3ab2e65c05$export$1bf820d499b6202e = {
    prefix: "fas",
    iconName: "server",
    icon: [
        512,
        512,
        [],
        "f233",
        "M64 32C28.7 32 0 60.7 0 96v64c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm280 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm48 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM64 288c-35.3 0-64 28.7-64 64v64c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V352c0-35.3-28.7-64-64-64H64zm280 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm56 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"
    ]
};
var $d8206b3ab2e65c05$export$61c2a6b698f55df6 = {
    prefix: "fas",
    iconName: "virus-covid-slash",
    icon: [
        640,
        512,
        [],
        "e4a9",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L472.1 344.7c11.4-19.5 19.1-41.4 22.3-64.7H528v16c0 13.3 10.7 24 24 24s24-10.7 24-24V216c0-13.3-10.7-24-24-24s-24 10.7-24 24v16H494.4c-4.2-30.7-16.3-58.8-34.1-82.3L484 125.9l11.3 11.3c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L472.7 46.7c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L450.1 92l-23.8 23.8C402.8 97.9 374.7 85.8 344 81.6V48h16c13.3 0 24-10.7 24-24s-10.7-24-24-24H280c-13.3 0-24 10.7-24 24s10.7 24 24 24h16V81.6c-30.7 4.2-58.8 16.3-82.3 34.1L189.9 92l11.3-11.3c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L134.1 79.8 38.8 5.1zm362.5 407L149.2 213.5c-1.5 6-2.7 12.2-3.5 18.5H112V216c0-13.3-10.7-24-24-24s-24 10.7-24 24v80c0 13.3 10.7 24 24 24s24-10.7 24-24V280h33.6c4.2 30.7 16.3 58.8 34.1 82.3L156 386.1l-11.3-11.3c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l56.6 56.6c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L189.9 420l23.8-23.8c23.5 17.9 51.7 29.9 82.3 34.1V464H280c-13.3 0-24 10.7-24 24s10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24H344V430.4c20.4-2.8 39.7-9.1 57.3-18.2z"
    ]
};
var $d8206b3ab2e65c05$export$452410c103c2403b = {
    prefix: "fas",
    iconName: "shop-lock",
    icon: [
        640,
        512,
        [],
        "e4a5",
        "M36.8 192H449.6c20.2-19.8 47.9-32 78.4-32c30.5 0 58.1 12.2 78.3 31.9c18.9-1.6 33.7-17.4 33.7-36.7c0-7.3-2.2-14.4-6.2-20.4L558.2 21.4C549.3 8 534.4 0 518.3 0H121.7c-16 0-31 8-39.9 21.4L6.2 134.7c-4 6.1-6.2 13.2-6.2 20.4C0 175.5 16.5 192 36.8 192zM384 224H320V384H128V224H64V384v80c0 26.5 21.5 48 48 48H336c26.5 0 48-21.5 48-48V384 352 224zm144 16c17.7 0 32 14.3 32 32v48H496V272c0-17.7 14.3-32 32-32zm-80 32v48c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H608c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32V272c0-44.2-35.8-80-80-80s-80 35.8-80 80z"
    ]
};
var $d8206b3ab2e65c05$export$f0c28584caa8f4b = {
    prefix: "fas",
    iconName: "hourglass-start",
    icon: [
        384,
        512,
        [
            "hourglass-1"
        ],
        "f251",
        "M32 0C14.3 0 0 14.3 0 32S14.3 64 32 64V75c0 42.4 16.9 83.1 46.9 113.1L146.7 256 78.9 323.9C48.9 353.9 32 394.6 32 437v11c-17.7 0-32 14.3-32 32s14.3 32 32 32H64 320h32c17.7 0 32-14.3 32-32s-14.3-32-32-32V437c0-42.4-16.9-83.1-46.9-113.1L237.3 256l67.9-67.9c30-30 46.9-70.7 46.9-113.1V64c17.7 0 32-14.3 32-32s-14.3-32-32-32H320 64 32zM288 437v11H96V437c0-25.5 10.1-49.9 28.1-67.9L192 301.3l67.9 67.9c18 18 28.1 42.4 28.1 67.9z"
    ]
};
var $d8206b3ab2e65c05$export$87929336ab5c59cd = $d8206b3ab2e65c05$export$f0c28584caa8f4b;
var $d8206b3ab2e65c05$export$f35a116a762ef8fc = {
    prefix: "fas",
    iconName: "blender-phone",
    icon: [
        576,
        512,
        [],
        "f6b6",
        "M224 352L196.8 52.3C194.2 24.2 216.3 0 244.6 0H534.1c21.1 0 36.4 20.1 30.9 40.4L558.5 64H400c-8.8 0-16 7.2-16 16s7.2 16 16 16H549.8l-17.5 64H400c-8.8 0-16 7.2-16 16s7.2 16 16 16H523.6l-17.5 64H400c-8.8 0-16 7.2-16 16s7.2 16 16 16h97.5L480 352H224zm-16 32H496c26.5 0 48 21.5 48 48v32c0 26.5-21.5 48-48 48H208c-26.5 0-48-21.5-48-48V432c0-26.5 21.5-48 48-48zm144 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM147.5 30.7c10.8 6.7 15.3 21 10.6 33.4l-22 57.8c-4.2 10.9-14.5 17.6-25.3 16.4l-33.3-3.6c-13.6 42.2-13.6 88.4 0 130.7l33.3-3.6c10.9-1.2 21.2 5.5 25.3 16.4l22 57.8c4.7 12.4 .2 26.7-10.6 33.4l-44 27.2c-9.7 6-21.9 4.2-29.8-4.3C-24.6 286-24.6 114 73.7 7.8C81.6-.7 93.8-2.5 103.5 3.5l44 27.2z"
    ]
};
var $d8206b3ab2e65c05$export$6c0cfe6d58faf860 = {
    prefix: "fas",
    iconName: "building-wheat",
    icon: [
        640,
        512,
        [],
        "e4db",
        "M0 48C0 21.5 21.5 0 48 0H336c26.5 0 48 21.5 48 48V464c0 26.5-21.5 48-48 48H240V432c0-26.5-21.5-48-48-48s-48 21.5-48 48v80H48c-26.5 0-48-21.5-48-48V48zM80 224c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H80zm80 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zm112-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H272zM64 112v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zM176 96c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H176zm80 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H272c-8.8 0-16 7.2-16 16zm384 80v16c0 44.2-35.8 80-80 80H544V272c0-44.2 35.8-80 80-80h16zm0 128c0 44.2-35.8 80-80 80H544V384c0-44.2 35.8-80 80-80h16v16zm0 112c0 44.2-35.8 80-80 80H544V496c0-44.2 35.8-80 80-80h16v16zM512 496v16H496c-44.2 0-80-35.8-80-80V416h16c44.2 0 80 35.8 80 80zm0-96H496c-44.2 0-80-35.8-80-80V304h16c44.2 0 80 35.8 80 80v16zm0-128v16H496c-44.2 0-80-35.8-80-80V192h16c44.2 0 80 35.8 80 80zM528 32c13.3 0 24 10.7 24 24V160c0 13.3-10.7 24-24 24s-24-10.7-24-24V56c0-13.3 10.7-24 24-24zm96 64v32c0 13.3-10.7 24-24 24s-24-10.7-24-24V96c0-13.3 10.7-24 24-24s24 10.7 24 24zM456 72c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24s-24-10.7-24-24V96c0-13.3 10.7-24 24-24z"
    ]
};
var $d8206b3ab2e65c05$export$9b94ed8d16d281f9 = {
    prefix: "fas",
    iconName: "person-breastfeeding",
    icon: [
        448,
        512,
        [],
        "e53a",
        "M224 0a80 80 0 1 1 0 160A80 80 0 1 1 224 0zM436.8 382.8L373.5 462c-16.6 20.7-46.8 24.1-67.5 7.5c-17.6-14.1-22.7-38.1-13.5-57.7l-.8-.1c-38.9-5.6-74.3-25.1-99.7-54.8V320c0-17.7-14.3-32-32-32s-32 14.3-32 32v48c0 .8 0 1.6 .1 2.4l101.4 50.7c23.7 11.9 33.3 40.7 21.5 64.4s-40.7 33.3-64.4 21.5L27.2 427.3c-1.1-.5-2.2-1.1-3.3-1.7c-4.9-2.8-9.2-6.4-12.6-10.6c-4.6-5.4-7.8-11.7-9.6-18.4c-3.3-12-1.9-25.2 4.8-36.6c.6-1.1 1.3-2.2 2-3.2L75.6 256.1c26.7-40.1 71.7-64.1 119.8-64.1h75.2c46.5 0 90.1 22.5 117.2 60.3l50.7 70.9c2.2 3 4 6.1 5.5 9.4c2.9 6.7 4.3 13.8 4 20.8c-.3 10.6-4.2 21-11.2 29.4zM320 332a44 44 0 1 0 -88 0 44 44 0 1 0 88 0z"
    ]
};
var $d8206b3ab2e65c05$export$a5fd2acfcb5247c6 = {
    prefix: "fas",
    iconName: "right-to-bracket",
    icon: [
        512,
        512,
        [
            "sign-in-alt"
        ],
        "f2f6",
        "M217.9 105.9L340.7 228.7c7.2 7.2 11.3 17.1 11.3 27.3s-4.1 20.1-11.3 27.3L217.9 406.1c-6.4 6.4-15 9.9-24 9.9c-18.7 0-33.9-15.2-33.9-33.9l0-62.1L32 320c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l128 0 0-62.1c0-18.7 15.2-33.9 33.9-33.9c9 0 17.6 3.6 24 9.9zM352 416l64 0c17.7 0 32-14.3 32-32l0-256c0-17.7-14.3-32-32-32l-64 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l64 0c53 0 96 43 96 96l0 256c0 53-43 96-96 96l-64 0c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
    ]
};
var $d8206b3ab2e65c05$export$e6709746115bd2ea = $d8206b3ab2e65c05$export$a5fd2acfcb5247c6;
var $d8206b3ab2e65c05$export$f89d028573ffc0a6 = {
    prefix: "fas",
    iconName: "venus",
    icon: [
        384,
        512,
        [
            9792
        ],
        "f221",
        "M80 176a112 112 0 1 1 224 0A112 112 0 1 1 80 176zM224 349.1c81.9-15 144-86.8 144-173.1C368 78.8 289.2 0 192 0S16 78.8 16 176c0 86.3 62.1 158.1 144 173.1V384H128c-17.7 0-32 14.3-32 32s14.3 32 32 32h32v32c0 17.7 14.3 32 32 32s32-14.3 32-32V448h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H224V349.1z"
    ]
};
var $d8206b3ab2e65c05$export$2c31ca0d9bee400f = {
    prefix: "fas",
    iconName: "passport",
    icon: [
        448,
        512,
        [],
        "f5ab",
        "M0 64C0 28.7 28.7 0 64 0H384c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM183 278.8c-27.9-13.2-48.4-39.4-53.7-70.8h39.1c1.6 30.4 7.7 53.8 14.6 70.8zm41.3 9.2l-.3 0-.3 0c-2.4-3.5-5.7-8.9-9.1-16.5c-6-13.6-12.4-34.3-14.2-63.5h47.1c-1.8 29.2-8.1 49.9-14.2 63.5c-3.4 7.6-6.7 13-9.1 16.5zm40.7-9.2c6.8-17.1 12.9-40.4 14.6-70.8h39.1c-5.3 31.4-25.8 57.6-53.7 70.8zM279.6 176c-1.6-30.4-7.7-53.8-14.6-70.8c27.9 13.2 48.4 39.4 53.7 70.8H279.6zM223.7 96l.3 0 .3 0c2.4 3.5 5.7 8.9 9.1 16.5c6 13.6 12.4 34.3 14.2 63.5H200.5c1.8-29.2 8.1-49.9 14.2-63.5c3.4-7.6 6.7-13 9.1-16.5zM183 105.2c-6.8 17.1-12.9 40.4-14.6 70.8H129.3c5.3-31.4 25.8-57.6 53.7-70.8zM352 192A128 128 0 1 0 96 192a128 128 0 1 0 256 0zM112 384c-8.8 0-16 7.2-16 16s7.2 16 16 16H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H112z"
    ]
};
var $d8206b3ab2e65c05$export$a6d8e50dcd4b4294 = {
    prefix: "fas",
    iconName: "heart-pulse",
    icon: [
        512,
        512,
        [
            "heartbeat"
        ],
        "f21e",
        "M228.3 469.1L47.6 300.4c-4.2-3.9-8.2-8.1-11.9-12.4h87c22.6 0 43-13.6 51.7-34.5l10.5-25.2 49.3 109.5c3.8 8.5 12.1 14 21.4 14.1s17.8-5 22-13.3L320 253.7l1.7 3.4c9.5 19 28.9 31 50.1 31H476.3c-3.7 4.3-7.7 8.5-11.9 12.4L283.7 469.1c-7.5 7-17.4 10.9-27.7 10.9s-20.2-3.9-27.7-10.9zM503.7 240h-132c-3 0-5.8-1.7-7.2-4.4l-23.2-46.3c-4.1-8.1-12.4-13.3-21.5-13.3s-17.4 5.1-21.5 13.3l-41.4 82.8L205.9 158.2c-3.9-8.7-12.7-14.3-22.2-14.1s-18.1 5.9-21.8 14.8l-31.8 76.3c-1.2 3-4.2 4.9-7.4 4.9H16c-2.6 0-5 .4-7.3 1.1C3 225.2 0 208.2 0 190.9v-5.8c0-69.9 50.5-129.5 119.4-141C165 36.5 211.4 51.4 244 84l12 12 12-12c32.6-32.6 79-47.5 124.6-39.9C461.5 55.6 512 115.2 512 185.1v5.8c0 16.9-2.8 33.5-8.3 49.1z"
    ]
};
var $d8206b3ab2e65c05$export$ca880e19206e80aa = $d8206b3ab2e65c05$export$a6d8e50dcd4b4294;
var $d8206b3ab2e65c05$export$7754cc6d5559ff38 = {
    prefix: "fas",
    iconName: "people-carry-box",
    icon: [
        640,
        512,
        [
            "people-carry"
        ],
        "f4ce",
        "M80 48a48 48 0 1 1 96 0A48 48 0 1 1 80 48zm64 193.7v65.1l51 51c7.1 7.1 11.8 16.2 13.4 26.1l15.2 90.9c2.9 17.4-8.9 33.9-26.3 36.8s-33.9-8.9-36.8-26.3l-14.3-85.9L66.8 320C54.8 308 48 291.7 48 274.7V186.6c0-32.4 26.2-58.6 58.6-58.6c24.1 0 46.5 12 59.9 32l47.4 71.1 10.1 5V160c0-17.7 14.3-32 32-32H384c17.7 0 32 14.3 32 32v76.2l10.1-5L473.5 160c13.3-20 35.8-32 59.9-32c32.4 0 58.6 26.2 58.6 58.6v88.1c0 17-6.7 33.3-18.7 45.3l-79.4 79.4-14.3 85.9c-2.9 17.4-19.4 29.2-36.8 26.3s-29.2-19.4-26.3-36.8l15.2-90.9c1.6-9.9 6.3-19 13.4-26.1l51-51V241.7l-19 28.5c-4.6 7-11 12.6-18.5 16.3l-59.6 29.8c-2.4 1.3-4.9 2.2-7.6 2.8c-2.6 .6-5.3 .9-7.9 .8H256.7c-2.5 .1-5-.2-7.5-.7c-2.9-.6-5.6-1.6-8.1-3l-59.5-29.8c-7.5-3.7-13.8-9.4-18.5-16.3l-19-28.5zM2.3 468.1L50.1 348.6l49.2 49.2-37.6 94c-6.6 16.4-25.2 24.4-41.6 17.8S-4.3 484.5 2.3 468.1zM512 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm77.9 348.6l47.8 119.5c6.6 16.4-1.4 35-17.8 41.6s-35-1.4-41.6-17.8l-37.6-94 49.2-49.2z"
    ]
};
var $d8206b3ab2e65c05$export$35fbd4ff1265acd5 = $d8206b3ab2e65c05$export$7754cc6d5559ff38;
var $d8206b3ab2e65c05$export$15d012277c3ecf9a = {
    prefix: "fas",
    iconName: "temperature-high",
    icon: [
        512,
        512,
        [],
        "f769",
        "M416 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 128A96 96 0 1 0 416 0a96 96 0 1 0 0 192zM96 112c0-26.5 21.5-48 48-48s48 21.5 48 48V276.5c0 17.3 7.1 31.9 15.3 42.5C217.8 332.6 224 349.5 224 368c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-18.5 6.2-35.4 16.7-48.9C88.9 308.4 96 293.8 96 276.5V112zM144 0C82.1 0 32 50.2 32 112V276.5c0 .1-.1 .3-.2 .6c-.2 .6-.8 1.6-1.7 2.8C11.2 304.2 0 334.8 0 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-33.2-11.2-63.8-30.1-88.1c-.9-1.2-1.5-2.2-1.7-2.8c-.1-.3-.2-.5-.2-.6V112C256 50.2 205.9 0 144 0zm0 416c26.5 0 48-21.5 48-48c0-20.9-13.4-38.7-32-45.3V112c0-8.8-7.2-16-16-16s-16 7.2-16 16V322.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48z"
    ]
};
var $d8206b3ab2e65c05$export$4a7bb4be15f35178 = {
    prefix: "fas",
    iconName: "microchip",
    icon: [
        512,
        512,
        [],
        "f2db",
        "M176 24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64c-35.3 0-64 28.7-64 64H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H64v56H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H64v56H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H64c0 35.3 28.7 64 64 64v40c0 13.3 10.7 24 24 24s24-10.7 24-24V448h56v40c0 13.3 10.7 24 24 24s24-10.7 24-24V448h56v40c0 13.3 10.7 24 24 24s24-10.7 24-24V448c35.3 0 64-28.7 64-64h40c13.3 0 24-10.7 24-24s-10.7-24-24-24H448V280h40c13.3 0 24-10.7 24-24s-10.7-24-24-24H448V176h40c13.3 0 24-10.7 24-24s-10.7-24-24-24H448c0-35.3-28.7-64-64-64V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H280V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H176V24zM160 128H352c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32zm192 32H160V352H352V160z"
    ]
};
var $d8206b3ab2e65c05$export$dc1083dcd1d7b9d6 = {
    prefix: "fas",
    iconName: "crown",
    icon: [
        576,
        512,
        [
            128081
        ],
        "f521",
        "M309 106c11.4-7 19-19.7 19-34c0-22.1-17.9-40-40-40s-40 17.9-40 40c0 14.4 7.6 27 19 34L209.7 220.6c-9.1 18.2-32.7 23.4-48.6 10.7L72 160c5-6.7 8-15 8-24c0-22.1-17.9-40-40-40S0 113.9 0 136s17.9 40 40 40c.2 0 .5 0 .7 0L86.4 427.4c5.5 30.4 32 52.6 63 52.6H426.6c30.9 0 57.4-22.1 63-52.6L535.3 176c.2 0 .5 0 .7 0c22.1 0 40-17.9 40-40s-17.9-40-40-40s-40 17.9-40 40c0 9 3 17.3 8 24l-89.1 71.3c-15.9 12.7-39.5 7.5-48.6-10.7L309 106z"
    ]
};
var $d8206b3ab2e65c05$export$43d1fa6671908715 = {
    prefix: "fas",
    iconName: "weight-hanging",
    icon: [
        512,
        512,
        [],
        "f5cd",
        "M224 96a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm122.5 32c3.5-10 5.5-20.8 5.5-32c0-53-43-96-96-96s-96 43-96 96c0 11.2 1.9 22 5.5 32H120c-22 0-41.2 15-46.6 36.4l-72 288c-3.6 14.3-.4 29.5 8.7 41.2S33.2 512 48 512H464c14.8 0 28.7-6.8 37.8-18.5s12.3-26.8 8.7-41.2l-72-288C433.2 143 414 128 392 128H346.5z"
    ]
};
var $d8206b3ab2e65c05$export$f4595f012786d346 = {
    prefix: "fas",
    iconName: "xmarks-lines",
    icon: [
        640,
        512,
        [],
        "e59a",
        "M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H32zm0 384c-17.7 0-32 14.3-32 32s14.3 32 32 32H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H32zM7 167c-9.4 9.4-9.4 24.6 0 33.9l55 55L7 311c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l55-55 55 55c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-55-55 55-55c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-55 55L41 167c-9.4-9.4-24.6-9.4-33.9 0zM265 167c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l55 55-55 55c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l55-55 55 55c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-55-55 55-55c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-55 55-55-55zM455 167c-9.4 9.4-9.4 24.6 0 33.9l55 55-55 55c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l55-55 55 55c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-55-55 55-55c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-55 55-55-55c-9.4-9.4-24.6-9.4-33.9 0z"
    ]
};
var $d8206b3ab2e65c05$export$a20cb90865b6beb8 = {
    prefix: "fas",
    iconName: "file-prescription",
    icon: [
        384,
        512,
        [],
        "f572",
        "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM104 196h72c33.1 0 60 26.9 60 60c0 25.5-15.9 47.2-38.3 55.9l43 40.3 33.8-31c8.1-7.5 20.8-6.9 28.3 1.2s6.9 20.8-1.2 28.3L270 379.7l31.7 29.7c8.1 7.6 8.5 20.2 .9 28.3s-20.2 8.5-28.3 .9l-33.9-31.8-34.9 32c-8.1 7.5-20.8 6.9-28.3-1.2s-6.9-20.8 1.2-28.3l32.6-29.9-64.8-60.8c-.9-.8-1.6-1.7-2.3-2.6H124v44c0 11-9 20-20 20s-20-9-20-20V296 216c0-11 9-20 20-20zm72 80c11 0 20-9 20-20s-9-20-20-20H124v40h52z"
    ]
};
var $d8206b3ab2e65c05$export$e521c542d18b85c3 = {
    prefix: "fas",
    iconName: "weight-scale",
    icon: [
        512,
        512,
        [
            "weight"
        ],
        "f496",
        "M128 176a128 128 0 1 1 256 0 128 128 0 1 1 -256 0zM391.8 64C359.5 24.9 310.7 0 256 0S152.5 24.9 120.2 64H64C28.7 64 0 92.7 0 128V448c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H391.8zM296 224c0-10.6-4.1-20.2-10.9-27.4l33.6-78.3c3.5-8.1-.3-17.5-8.4-21s-17.5 .3-21 8.4L255.7 184c-22 .1-39.7 18-39.7 40c0 22.1 17.9 40 40 40s40-17.9 40-40z"
    ]
};
var $d8206b3ab2e65c05$export$cf3bafa68a60bae4 = $d8206b3ab2e65c05$export$e521c542d18b85c3;
var $d8206b3ab2e65c05$export$3d626cfc365a7e36 = {
    prefix: "fas",
    iconName: "user-group",
    icon: [
        640,
        512,
        [
            128101,
            "user-friends"
        ],
        "f500",
        "M96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM0 482.3C0 383.8 79.8 304 178.3 304h91.4C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3zM609.3 512H471.4c5.4-9.4 8.6-20.3 8.6-32v-8c0-60.7-27.1-115.2-69.8-151.8c2.4-.1 4.7-.2 7.1-.2h61.4C567.8 320 640 392.2 640 481.3c0 17-13.8 30.7-30.7 30.7zM432 256c-31 0-59-12.6-79.3-32.9C372.4 196.5 384 163.6 384 128c0-26.8-6.6-52.1-18.3-74.3C384.3 40.1 407.2 32 432 32c61.9 0 112 50.1 112 112s-50.1 112-112 112z"
    ]
};
var $d8206b3ab2e65c05$export$46073bec205635d9 = $d8206b3ab2e65c05$export$3d626cfc365a7e36;
var $d8206b3ab2e65c05$export$fb00fdd8857804c7 = {
    prefix: "fas",
    iconName: "arrow-up-a-z",
    icon: [
        576,
        512,
        [
            "sort-alpha-up"
        ],
        "f15e",
        "M183.6 42.4C177.5 35.8 169 32 160 32s-17.5 3.8-23.6 10.4l-88 96c-11.9 13-11.1 33.3 2 45.2s33.3 11.1 45.2-2L128 146.3V448c0 17.7 14.3 32 32 32s32-14.3 32-32V146.3l32.4 35.4c11.9 13 32.2 13.9 45.2 2s13.9-32.2 2-45.2l-88-96zM320 320c0 17.7 14.3 32 32 32h50.7l-73.4 73.4c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H429.3l73.4-73.4c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8H352c-17.7 0-32 14.3-32 32zM416 32c-12.1 0-23.2 6.8-28.6 17.7l-64 128-16 32c-7.9 15.8-1.5 35 14.3 42.9s35 1.5 42.9-14.3l7.2-14.3h88.4l7.2 14.3c7.9 15.8 27.1 22.2 42.9 14.3s22.2-27.1 14.3-42.9l-16-32-64-128C439.2 38.8 428.1 32 416 32zM395.8 176L416 135.6 436.2 176H395.8z"
    ]
};
var $d8206b3ab2e65c05$export$3c4115b156be730d = $d8206b3ab2e65c05$export$fb00fdd8857804c7;
var $d8206b3ab2e65c05$export$861b1f13085cf122 = {
    prefix: "fas",
    iconName: "chess-knight",
    icon: [
        448,
        512,
        [
            9822
        ],
        "f441",
        "M96 48L82.7 61.3C70.7 73.3 64 89.5 64 106.5V238.9c0 10.7 5.3 20.7 14.2 26.6l10.6 7c14.3 9.6 32.7 10.7 48.1 3l3.2-1.6c2.6-1.3 5-2.8 7.3-4.5l49.4-37c6.6-5 15.7-5 22.3 0c10.2 7.7 9.9 23.1-.7 30.3L90.4 350C73.9 361.3 64 380 64 400H384l28.9-159c2.1-11.3 3.1-22.8 3.1-34.3V192C416 86 330 0 224 0H83.8C72.9 0 64 8.9 64 19.8c0 7.5 4.2 14.3 10.9 17.7L96 48zm24 68a20 20 0 1 1 40 0 20 20 0 1 1 -40 0zM22.6 473.4c-4.2 4.2-6.6 10-6.6 16C16 501.9 26.1 512 38.6 512H409.4c12.5 0 22.6-10.1 22.6-22.6c0-6-2.4-11.8-6.6-16L384 432H64L22.6 473.4z"
    ]
};
var $d8206b3ab2e65c05$export$67ca89c1ca38d559 = {
    prefix: "fas",
    iconName: "face-laugh-squint",
    icon: [
        512,
        512,
        [
            "laugh-squint"
        ],
        "f59b",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM96.8 314.1c-3.8-13.7 7.4-26.1 21.6-26.1H393.6c14.2 0 25.5 12.4 21.6 26.1C396.2 382 332.1 432 256 432s-140.2-50-159.2-117.9zm36.7-199.4l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5c0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6c0-9 9.6-14.7 17.5-10.5zM396 125.1c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6c0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9c7.9-4.2 17.5 1.5 17.5 10.5z"
    ]
};
var $d8206b3ab2e65c05$export$b206e700cf7084e1 = $d8206b3ab2e65c05$export$67ca89c1ca38d559;
var $d8206b3ab2e65c05$export$76a9413fbe130a53 = {
    prefix: "fas",
    iconName: "wheelchair",
    icon: [
        512,
        512,
        [],
        "f193",
        "M192 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM120.5 247.2c12.4-4.7 18.7-18.5 14-30.9s-18.5-18.7-30.9-14C43.1 225.1 0 283.5 0 352c0 88.4 71.6 160 160 160c61.2 0 114.3-34.3 141.2-84.7c6.2-11.7 1.8-26.2-9.9-32.5s-26.2-1.8-32.5 9.9C240 440 202.8 464 160 464C98.1 464 48 413.9 48 352c0-47.9 30.1-88.8 72.5-104.8zM259.8 176l-1.9-9.7c-4.5-22.3-24-38.3-46.8-38.3c-30.1 0-52.7 27.5-46.8 57l23.1 115.5c6 29.9 32.2 51.4 62.8 51.4h5.1c.4 0 .8 0 1.3 0h94.1c6.7 0 12.6 4.1 15 10.4L402 459.2c6 16.1 23.8 24.6 40.1 19.1l48-16c16.8-5.6 25.8-23.7 20.2-40.5s-23.7-25.8-40.5-20.2l-18.7 6.2-25.5-68c-11.7-31.2-41.6-51.9-74.9-51.9H282.2l-9.6-48H336c17.7 0 32-14.3 32-32s-14.3-32-32-32H259.8z"
    ]
};
var $d8206b3ab2e65c05$export$a29c8ea43e92771d = {
    prefix: "fas",
    iconName: "circle-arrow-up",
    icon: [
        512,
        512,
        [
            "arrow-circle-up"
        ],
        "f0aa",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM385 231c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-71-71V376c0 13.3-10.7 24-24 24s-24-10.7-24-24V193.9l-71 71c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L239 119c9.4-9.4 24.6-9.4 33.9 0L385 231z"
    ]
};
var $d8206b3ab2e65c05$export$a2f6f3baa50af0b1 = $d8206b3ab2e65c05$export$a29c8ea43e92771d;
var $d8206b3ab2e65c05$export$5cffc34afa81e517 = {
    prefix: "fas",
    iconName: "toggle-on",
    icon: [
        576,
        512,
        [],
        "f205",
        "M192 64C86 64 0 150 0 256S86 448 192 448H384c106 0 192-86 192-192s-86-192-192-192H192zm192 96a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"
    ]
};
var $d8206b3ab2e65c05$export$6af1cc5998ca52bc = {
    prefix: "fas",
    iconName: "person-walking",
    icon: [
        320,
        512,
        [
            128694,
            "walking"
        ],
        "f554",
        "M160 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM126.5 199.3c-1 .4-1.9 .8-2.9 1.2l-8 3.5c-16.4 7.3-29 21.2-34.7 38.2l-2.6 7.8c-5.6 16.8-23.7 25.8-40.5 20.2s-25.8-23.7-20.2-40.5l2.6-7.8c11.4-34.1 36.6-61.9 69.4-76.5l8-3.5c20.8-9.2 43.3-14 66.1-14c44.6 0 84.8 26.8 101.9 67.9L281 232.7l21.4 10.7c15.8 7.9 22.2 27.1 14.3 42.9s-27.1 22.2-42.9 14.3L247 287.3c-10.3-5.2-18.4-13.8-22.8-24.5l-9.6-23-19.3 65.5 49.5 54c5.4 5.9 9.2 13 11.2 20.8l23 92.1c4.3 17.1-6.1 34.5-23.3 38.8s-34.5-6.1-38.8-23.3l-22-88.1-70.7-77.1c-14.8-16.1-20.3-38.6-14.7-59.7l16.9-63.5zM68.7 398l25-62.4c2.1 3 4.5 5.8 7 8.6l40.7 44.4-14.5 36.2c-2.4 6-6 11.5-10.6 16.1L54.6 502.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L68.7 398z"
    ]
};
var $d8206b3ab2e65c05$export$4886811b7174ec35 = $d8206b3ab2e65c05$export$6af1cc5998ca52bc;
var $d8206b3ab2e65c05$export$be32b10ce70a09df = {
    prefix: "fas",
    iconName: "l",
    icon: [
        320,
        512,
        [
            108
        ],
        "4c",
        "M64 32c17.7 0 32 14.3 32 32V416H288c17.7 0 32 14.3 32 32s-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32z"
    ]
};
var $d8206b3ab2e65c05$export$7b24b34ef6cc130c = {
    prefix: "fas",
    iconName: "fire",
    icon: [
        448,
        512,
        [
            128293
        ],
        "f06d",
        "M159.3 5.4c7.8-7.3 19.9-7.2 27.7 .1c27.6 25.9 53.5 53.8 77.7 84c11-14.4 23.5-30.1 37-42.9c7.9-7.4 20.1-7.4 28 .1c34.6 33 63.9 76.6 84.5 118c20.3 40.8 33.8 82.5 33.8 111.9C448 404.2 348.2 512 224 512C98.4 512 0 404.1 0 276.5c0-38.4 17.8-85.3 45.4-131.7C73.3 97.7 112.7 48.6 159.3 5.4zM225.7 416c25.3 0 47.7-7 68.8-21c42.1-29.4 53.4-88.2 28.1-134.4c-4.5-9-16-9.6-22.5-2l-25.2 29.3c-6.6 7.6-18.5 7.4-24.7-.5c-16.5-21-46-58.5-62.8-79.8c-6.3-8-18.3-8.1-24.7-.1c-33.8 42.5-50.8 69.3-50.8 99.4C112 375.4 162.6 416 225.7 416z"
    ]
};
var $d8206b3ab2e65c05$export$580ae0d0bbd809fb = {
    prefix: "fas",
    iconName: "bed-pulse",
    icon: [
        640,
        512,
        [
            "procedures"
        ],
        "f487",
        "M483.2 9.6L524 64h92c13.3 0 24 10.7 24 24s-10.7 24-24 24H512c-7.6 0-14.7-3.6-19.2-9.6L468.7 70.3l-47 99.9c-3.7 7.8-11.3 13.1-19.9 13.7s-16.9-3.4-21.7-10.6L339.2 112H216c-13.3 0-24-10.7-24-24s10.7-24 24-24H352c8 0 15.5 4 20 10.7l24.4 36.6 45.9-97.5C445.9 6.2 453.2 1 461.6 .1s16.6 2.7 21.6 9.5zM320 160h12.7l20.7 31.1c11.2 16.8 30.6 26.3 50.7 24.8s37.9-13.7 46.5-32L461.9 160H544c53 0 96 43 96 96V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V448H352 320 64v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V96C0 78.3 14.3 64 32 64s32 14.3 32 32V352H288V192c0-17.7 14.3-32 32-32zm-144 0a80 80 0 1 1 0 160 80 80 0 1 1 0-160z"
    ]
};
var $d8206b3ab2e65c05$export$5f9e1870e1866dde = $d8206b3ab2e65c05$export$580ae0d0bbd809fb;
var $d8206b3ab2e65c05$export$76d92e7f30d064c5 = {
    prefix: "fas",
    iconName: "shuttle-space",
    icon: [
        640,
        512,
        [
            "space-shuttle"
        ],
        "f197",
        "M130 480c40.6 0 80.4-11 115.2-31.9L352 384l-224 0 0 96h2zM352 128L245.2 63.9C210.4 43 170.6 32 130 32h-2v96l224 0zM96 128l0-96H80C53.5 32 32 53.5 32 80v48h8c-22.1 0-40 17.9-40 40v16V328v16c0 22.1 17.9 40 40 40H32v48c0 26.5 21.5 48 48 48H96l0-96h8c26.2 0 49.4-12.6 64-32H456c69.3 0 135-22.7 179.2-81.6c6.4-8.5 6.4-20.3 0-28.8C591 182.7 525.3 160 456 160H168c-14.6-19.4-37.8-32-64-32l-8 0zM512 243.6v24.9c0 19.6-15.9 35.6-35.6 35.6c-2.5 0-4.4-2-4.4-4.4V212.4c0-2.5 2-4.4 4.4-4.4c19.6 0 35.6 15.9 35.6 35.6z"
    ]
};
var $d8206b3ab2e65c05$export$4d1c12ba2b4ca565 = $d8206b3ab2e65c05$export$76d92e7f30d064c5;
var $d8206b3ab2e65c05$export$2f203616c892d415 = {
    prefix: "fas",
    iconName: "face-laugh",
    icon: [
        512,
        512,
        [
            "laugh"
        ],
        "f599",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM96.8 314.1c-3.8-13.7 7.4-26.1 21.6-26.1H393.6c14.2 0 25.5 12.4 21.6 26.1C396.2 382 332.1 432 256 432s-140.2-50-159.2-117.9zM144.4 192a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $d8206b3ab2e65c05$export$6c74e314e801a4fe = $d8206b3ab2e65c05$export$2f203616c892d415;
var $d8206b3ab2e65c05$export$ff7e93418af88b78 = {
    prefix: "fas",
    iconName: "folder-open",
    icon: [
        576,
        512,
        [
            128194,
            128449,
            61717
        ],
        "f07c",
        "M88.7 223.8L0 375.8V96C0 60.7 28.7 32 64 32H181.5c17 0 33.3 6.7 45.3 18.7l26.5 26.5c12 12 28.3 18.7 45.3 18.7H416c35.3 0 64 28.7 64 64v32H144c-22.8 0-43.8 12.1-55.3 31.8zm27.6 16.1C122.1 230 132.6 224 144 224H544c11.5 0 22 6.1 27.7 16.1s5.7 22.2-.1 32.1l-112 192C453.9 474 443.4 480 432 480H32c-11.5 0-22-6.1-27.7-16.1s-5.7-22.2 .1-32.1l112-192z"
    ]
};
var $d8206b3ab2e65c05$export$2a155a6e20f64134 = {
    prefix: "fas",
    iconName: "heart-circle-plus",
    icon: [
        576,
        512,
        [],
        "e500",
        "M47.6 300.4L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9l2.6-2.4C267.2 438.6 256 404.6 256 368c0-97.2 78.8-176 176-176c28.3 0 55 6.7 78.7 18.5c.9-6.5 1.3-13 1.3-19.6v-5.8c0-69.9-50.5-129.5-119.4-141C347 36.5 300.6 51.4 268 84L256 96 244 84c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm16-208v48h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H448v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V384H368c-8.8 0-16-7.2-16-16s7.2-16 16-16h48V304c0-8.8 7.2-16 16-16s16 7.2 16 16z"
    ]
};
var $d8206b3ab2e65c05$export$f54081bdbf6d4eb5 = {
    prefix: "fas",
    iconName: "code-fork",
    icon: [
        448,
        512,
        [],
        "e13b",
        "M80 104a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm80-24c0 32.8-19.7 61-48 73.3V192c0 17.7 14.3 32 32 32H304c17.7 0 32-14.3 32-32V153.3C307.7 141 288 112.8 288 80c0-44.2 35.8-80 80-80s80 35.8 80 80c0 32.8-19.7 61-48 73.3V192c0 53-43 96-96 96H256v70.7c28.3 12.3 48 40.5 48 73.3c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-32.8 19.7-61 48-73.3V288H144c-53 0-96-43-96-96V153.3C19.7 141 0 112.8 0 80C0 35.8 35.8 0 80 0s80 35.8 80 80zm208 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM248 432a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"
    ]
};
var $d8206b3ab2e65c05$export$a9947c2888b3c8fd = {
    prefix: "fas",
    iconName: "city",
    icon: [
        640,
        512,
        [
            127961
        ],
        "f64f",
        "M480 48c0-26.5-21.5-48-48-48H336c-26.5 0-48 21.5-48 48V96H224V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V96H112V24c0-13.3-10.7-24-24-24S64 10.7 64 24V96H48C21.5 96 0 117.5 0 144v96V464c0 26.5 21.5 48 48 48H304h32 96H592c26.5 0 48-21.5 48-48V240c0-26.5-21.5-48-48-48H480V48zm96 320v32c0 8.8-7.2 16-16 16H528c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16zM240 416H208c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16zM128 400c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32zM560 256c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H528c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16h32zM256 176v32c0 8.8-7.2 16-16 16H208c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16zM112 160c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h32zM256 304c0 8.8-7.2 16-16 16H208c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32zM112 320H80c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16zm304-48v32c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16zM400 64c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16h32zm16 112v32c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16z"
    ]
};
var $d8206b3ab2e65c05$export$417391ae30b5922e = {
    prefix: "fas",
    iconName: "microphone-lines",
    icon: [
        384,
        512,
        [
            127897,
            "microphone-alt"
        ],
        "f3c9",
        "M96 96V256c0 53 43 96 96 96s96-43 96-96H208c-8.8 0-16-7.2-16-16s7.2-16 16-16h80V192H208c-8.8 0-16-7.2-16-16s7.2-16 16-16h80V128H208c-8.8 0-16-7.2-16-16s7.2-16 16-16h80c0-53-43-96-96-96S96 43 96 96zM320 240v16c0 70.7-57.3 128-128 128s-128-57.3-128-128V216c0-13.3-10.7-24-24-24s-24 10.7-24 24v40c0 89.1 66.2 162.7 152 174.4V464H120c-13.3 0-24 10.7-24 24s10.7 24 24 24h72 72c13.3 0 24-10.7 24-24s-10.7-24-24-24H216V430.4c85.8-11.7 152-85.3 152-174.4V216c0-13.3-10.7-24-24-24s-24 10.7-24 24v24z"
    ]
};
var $d8206b3ab2e65c05$export$f08ef94fea14f5ac = $d8206b3ab2e65c05$export$417391ae30b5922e;
var $d8206b3ab2e65c05$export$4894bf28f771e1f3 = {
    prefix: "fas",
    iconName: "pepper-hot",
    icon: [
        512,
        512,
        [
            127798
        ],
        "f816",
        "M428.3 3c11.6-6.4 26.2-2.3 32.6 9.3l4.8 8.7c19.3 34.7 19.8 75.7 3.4 110C495.8 159.6 512 197.9 512 240c0 18.5-3.1 36.3-8.9 52.8c-6.1 17.3-28.5 16.3-36.8-.1l-11.7-23.4c-4.1-8.1-12.4-13.3-21.5-13.3H360c-13.3 0-24-10.7-24-24V152c0-13.3-10.7-24-24-24l-17.1 0c-21.3 0-30-23.9-10.8-32.9C304.7 85.4 327.7 80 352 80c28.3 0 54.8 7.3 77.8 20.2c5.5-18.2 3.7-38.4-6-55.8L419 35.7c-6.4-11.6-2.3-26.2 9.3-32.6zM171.2 345.5L264 160l40 0v80c0 26.5 21.5 48 48 48h76.2l23.9 47.8C372.3 443.9 244.3 512 103.2 512H44.4C19.9 512 0 492.1 0 467.6c0-20.8 14.5-38.8 34.8-43.3l49.8-11.1c37.6-8.4 69.5-33.2 86.7-67.7z"
    ]
};
var $d8206b3ab2e65c05$export$db1382cd406cc506 = {
    prefix: "fas",
    iconName: "unlock",
    icon: [
        448,
        512,
        [
            128275
        ],
        "f09c",
        "M144 144c0-44.2 35.8-80 80-80c31.9 0 59.4 18.6 72.3 45.7c7.6 16 26.7 22.8 42.6 15.2s22.8-26.7 15.2-42.6C331 33.7 281.5 0 224 0C144.5 0 80 64.5 80 144v48H64c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V256c0-35.3-28.7-64-64-64H144V144z"
    ]
};
var $d8206b3ab2e65c05$export$dec10d4c2c113312 = {
    prefix: "fas",
    iconName: "colon-sign",
    icon: [
        384,
        512,
        [],
        "e140",
        "M255 39.8c4.3-17.1-6.1-34.5-23.3-38.8S197.2 7.1 193 24.2L181.9 68.6C96.1 87.8 32 164.4 32 256c0 58.1 25.8 110.2 66.7 145.4L81 472.2c-4.3 17.1 6.1 34.5 23.3 38.8s34.5-6.1 38.8-23.3l13-52.1c9 3.4 18.4 6.2 28 8.2L177 472.2c-4.3 17.1 6.1 34.5 23.3 38.8s34.5-6.1 38.8-23.3l10.4-41.4c33.4-4.4 64.1-17.4 89.8-36.7c14.1-10.6 17-30.7 6.4-44.8s-30.7-17-44.8-6.4c-10.2 7.7-21.7 13.9-34 18.3L321 160c9.4-.3 18.5-4.7 24.6-12.8c10.6-14.1 7.8-34.2-6.4-44.8c-1.1-.8-2.2-1.6-3.3-2.4L351 39.8c4.3-17.1-6.1-34.5-23.3-38.8S293.2 7.1 289 24.2L277.2 71.5c-9.3-2.7-18.8-4.6-28.6-5.9L255 39.8zM163.2 143.3L117.3 326.8C103.9 306.5 96 282.2 96 256c0-48.7 27.2-91 67.2-112.7zm8.6 229.5l61.1-244.6c9.9 .7 19.5 2.5 28.7 5.3l-62 248.1c-9.7-1.9-19-4.8-27.8-8.8z"
    ]
};
var $d8206b3ab2e65c05$export$23b086400a31acfe = {
    prefix: "fas",
    iconName: "headset",
    icon: [
        512,
        512,
        [],
        "f590",
        "M256 48C141.1 48 48 141.1 48 256v40c0 13.3-10.7 24-24 24s-24-10.7-24-24V256C0 114.6 114.6 0 256 0S512 114.6 512 256V400.1c0 48.6-39.4 88-88.1 88L313.6 488c-8.3 14.3-23.8 24-41.6 24H240c-26.5 0-48-21.5-48-48s21.5-48 48-48h32c17.8 0 33.3 9.7 41.6 24l110.4 .1c22.1 0 40-17.9 40-40V256c0-114.9-93.1-208-208-208zM144 208h16c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H144c-35.3 0-64-28.7-64-64V272c0-35.3 28.7-64 64-64zm224 0c35.3 0 64 28.7 64 64v48c0 35.3-28.7 64-64 64H352c-17.7 0-32-14.3-32-32V240c0-17.7 14.3-32 32-32h16z"
    ]
};
var $d8206b3ab2e65c05$export$4ab2f33219630bad = {
    prefix: "fas",
    iconName: "store-slash",
    icon: [
        640,
        512,
        [],
        "e071",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-86.8-68V384 252.6c-4 1-8 1.8-12.3 2.3l-.1 0c-5.3 .7-10.7 1.1-16.2 1.1c-12.4 0-24.3-1.9-35.4-5.3V350.9L301.2 210.7c7-4.4 13.3-9.7 18.8-15.7c15.9 17.6 39.1 29 65.2 29c26.2 0 49.3-11.4 65.2-29c16 17.6 39.1 29 65.2 29c4.1 0 8.1-.3 12.1-.8c55.5-7.4 81.8-72.5 52.1-119.4L522.3 13.1C517.2 5 508.1 0 498.4 0H141.6c-9.7 0-18.8 5-23.9 13.1l-22.7 36L38.8 5.1zM514.9 501.7L365.5 384H160V250.6c-11.2 3.5-23.2 5.4-35.6 5.4c-5.5 0-11-.4-16.3-1.1l-.1 0c-4.1-.6-8.1-1.3-12-2.3V384v64c0 35.3 28.7 64 64 64H480c12.9 0 24.8-3.8 34.9-10.3zM155.3 218.4L48.9 134.5c-6.1 40.6 19.5 82.8 63.3 88.7c4 .5 8.1 .8 12.1 .8c11 0 21.4-2 31-5.6z"
    ]
};
var $d8206b3ab2e65c05$export$2ffc88a4d31e8ffc = {
    prefix: "fas",
    iconName: "road-circle-xmark",
    icon: [
        640,
        512,
        [],
        "e566",
        "M213.2 32H288V96c0 17.7 14.3 32 32 32s32-14.3 32-32V32h74.8c27.1 0 51.3 17.1 60.3 42.6l42.7 120.6c-10.9-2.1-22.2-3.2-33.8-3.2c-59.5 0-112.1 29.6-144 74.8V224c0-17.7-14.3-32-32-32s-32 14.3-32 32v64c0 17.7 14.3 32 32 32c2.3 0 4.6-.3 6.8-.7c-4.5 15.5-6.8 31.8-6.8 48.7c0 5.4 .2 10.7 .7 16l-.7 0c-17.7 0-32 14.3-32 32v64H86.6C56.5 480 32 455.5 32 425.4c0-6.2 1.1-12.4 3.1-18.2L152.9 74.6C162 49.1 186.1 32 213.2 32zM496 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm22.6 144l36.7-36.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L496 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L473.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L496 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L518.6 368z"
    ]
};
var $d8206b3ab2e65c05$export$d6e17c0df8ed1bf7 = {
    prefix: "fas",
    iconName: "user-minus",
    icon: [
        640,
        512,
        [],
        "f503",
        "M96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM0 482.3C0 383.8 79.8 304 178.3 304h91.4C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3zM472 200H616c13.3 0 24 10.7 24 24s-10.7 24-24 24H472c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
    ]
};
var $d8206b3ab2e65c05$export$efc6d53e0dedceee = {
    prefix: "fas",
    iconName: "mars-stroke-up",
    icon: [
        320,
        512,
        [
            9896,
            "mars-stroke-v"
        ],
        "f22a",
        "M148.7 4.7c6.2-6.2 16.4-6.2 22.6 0l64 64c4.6 4.6 5.9 11.5 3.5 17.4s-8.3 9.9-14.8 9.9H184v24h32c13.3 0 24 10.7 24 24s-10.7 24-24 24H184v24c0 .6 0 1.2-.1 1.8c77 11.6 136.1 78 136.1 158.2c0 88.4-71.6 160-160 160S0 440.4 0 352c0-80.2 59.1-146.7 136.1-158.2c0-.6-.1-1.2-.1-1.8V168H104c-13.3 0-24-10.7-24-24s10.7-24 24-24h32V96H96c-6.5 0-12.3-3.9-14.8-9.9s-1.1-12.9 3.5-17.4l64-64zM256 352A96 96 0 1 0 64 352a96 96 0 1 0 192 0z"
    ]
};
var $d8206b3ab2e65c05$export$ed7aa1c25104f333 = $d8206b3ab2e65c05$export$efc6d53e0dedceee;
var $d8206b3ab2e65c05$export$7df1926e9eef8cc3 = {
    prefix: "fas",
    iconName: "champagne-glasses",
    icon: [
        640,
        512,
        [
            129346,
            "glass-cheers"
        ],
        "f79f",
        "M155.6 17.3C163 3 179.9-3.6 195 1.9L320 47.5l125-45.6c15.1-5.5 32 1.1 39.4 15.4l78.8 152.9c28.8 55.8 10.3 122.3-38.5 156.6L556.1 413l41-15c16.6-6 35 2.5 41 19.1s-2.5 35-19.1 41l-71.1 25.9L476.8 510c-16.6 6.1-35-2.5-41-19.1s2.5-35 19.1-41l41-15-31.3-86.2c-59.4 5.2-116.2-34-130-95.2L320 188.8l-14.6 64.7c-13.8 61.3-70.6 100.4-130 95.2l-31.3 86.2 41 15c16.6 6 25.2 24.4 19.1 41s-24.4 25.2-41 19.1L92.2 484.1 21.1 458.2c-16.6-6.1-25.2-24.4-19.1-41s24.4-25.2 41-19.1l41 15 31.3-86.2C66.5 292.5 48.1 226 76.9 170.2L155.6 17.3zm44 54.4l-27.2 52.8L261.6 157l13.1-57.9L199.6 71.7zm240.9 0L365.4 99.1 378.5 157l89.2-32.5L440.5 71.7z"
    ]
};
var $d8206b3ab2e65c05$export$20007d7d74cb98fe = $d8206b3ab2e65c05$export$7df1926e9eef8cc3;
var $d8206b3ab2e65c05$export$97d84347d71ba297 = {
    prefix: "fas",
    iconName: "clipboard",
    icon: [
        384,
        512,
        [
            128203
        ],
        "f328",
        "M192 0c-41.8 0-77.4 26.7-90.5 64H64C28.7 64 0 92.7 0 128V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H282.5C269.4 26.7 233.8 0 192 0zm0 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM112 192H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
    ]
};
var $d8206b3ab2e65c05$export$8403e4b31e8aa805 = {
    prefix: "fas",
    iconName: "house-circle-exclamation",
    icon: [
        640,
        512,
        [],
        "e50a",
        "M320.7 352c8.1-89.7 83.5-160 175.3-160c8.9 0 17.6 .7 26.1 1.9L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24c0 18 14 32.1 32 32.1h32v69.7c-.1 .9-.1 1.8-.1 2.8V472c0 22.1 17.9 40 40 40h16c1.2 0 2.4-.1 3.6-.2c1.5 .1 3 .2 4.5 .2H160h24c22.1 0 40-17.9 40-40V448 384c0-17.7 14.3-32 32-32h64l.7 0zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V288c0-8.8 7.2-16 16-16z"
    ]
};
var $d8206b3ab2e65c05$export$929df388c07f293d = {
    prefix: "fas",
    iconName: "file-arrow-up",
    icon: [
        384,
        512,
        [
            "file-upload"
        ],
        "f574",
        "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM216 408c0 13.3-10.7 24-24 24s-24-10.7-24-24V305.9l-31 31c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l72-72c9.4-9.4 24.6-9.4 33.9 0l72 72c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-31-31V408z"
    ]
};
var $d8206b3ab2e65c05$export$dd55ded1264643d2 = $d8206b3ab2e65c05$export$929df388c07f293d;
var $d8206b3ab2e65c05$export$1642419fe3db2857 = {
    prefix: "fas",
    iconName: "wifi",
    icon: [
        640,
        512,
        [
            "wifi-3",
            "wifi-strong"
        ],
        "f1eb",
        "M54.2 202.9C123.2 136.7 216.8 96 320 96s196.8 40.7 265.8 106.9c12.8 12.2 33 11.8 45.2-.9s11.8-33-.9-45.2C549.7 79.5 440.4 32 320 32S90.3 79.5 9.8 156.7C-2.9 169-3.3 189.2 8.9 202s32.5 13.2 45.2 .9zM320 256c56.8 0 108.6 21.1 148.2 56c13.3 11.7 33.5 10.4 45.2-2.8s10.4-33.5-2.8-45.2C459.8 219.2 393 192 320 192s-139.8 27.2-190.5 72c-13.3 11.7-14.5 31.9-2.8 45.2s31.9 14.5 45.2 2.8c39.5-34.9 91.3-56 148.2-56zm64 160a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z"
    ]
};
var $d8206b3ab2e65c05$export$2349bb04a04f4b2d = $d8206b3ab2e65c05$export$1642419fe3db2857;
var $d8206b3ab2e65c05$export$4b3167c852f4c4aa = $d8206b3ab2e65c05$export$1642419fe3db2857;
var $d8206b3ab2e65c05$export$1ea66a88b8f620c9 = {
    prefix: "fas",
    iconName: "bath",
    icon: [
        512,
        512,
        [
            128705,
            "bathtub"
        ],
        "f2cd",
        "M96 77.3c0-7.3 5.9-13.3 13.3-13.3c3.5 0 6.9 1.4 9.4 3.9l14.9 14.9C130 91.8 128 101.7 128 112c0 19.9 7.2 38 19.2 52c-5.3 9.2-4 21.1 3.8 29c9.4 9.4 24.6 9.4 33.9 0L289 89c9.4-9.4 9.4-24.6 0-33.9c-7.9-7.9-19.8-9.1-29-3.8C246 39.2 227.9 32 208 32c-10.3 0-20.2 2-29.2 5.5L163.9 22.6C149.4 8.1 129.7 0 109.3 0C66.6 0 32 34.6 32 77.3V256c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H96V77.3zM32 352v16c0 28.4 12.4 54 32 71.6V480c0 17.7 14.3 32 32 32s32-14.3 32-32V464H384v16c0 17.7 14.3 32 32 32s32-14.3 32-32V439.6c19.6-17.6 32-43.1 32-71.6V352H32z"
    ]
};
var $d8206b3ab2e65c05$export$40ae013b5e6269d8 = $d8206b3ab2e65c05$export$1ea66a88b8f620c9;
var $d8206b3ab2e65c05$export$22346afd6a3cddf8 = {
    prefix: "fas",
    iconName: "underline",
    icon: [
        448,
        512,
        [],
        "f0cd",
        "M16 64c0-17.7 14.3-32 32-32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H128V224c0 53 43 96 96 96s96-43 96-96V96H304c-17.7 0-32-14.3-32-32s14.3-32 32-32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H384V224c0 88.4-71.6 160-160 160s-160-71.6-160-160V96H48C30.3 96 16 81.7 16 64zM0 448c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32z"
    ]
};
var $d8206b3ab2e65c05$export$3842882ea09b25af = {
    prefix: "fas",
    iconName: "user-pen",
    icon: [
        640,
        512,
        [
            "user-edit"
        ],
        "f4ff",
        "M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H322.8c-3.1-8.8-3.7-18.4-1.4-27.8l15-60.1c2.8-11.3 8.6-21.5 16.8-29.7l40.3-40.3c-32.1-31-75.7-50.1-123.9-50.1H178.3zm435.5-68.3c-15.6-15.6-40.9-15.6-56.6 0l-29.4 29.4 71 71 29.4-29.4c15.6-15.6 15.6-40.9 0-56.6l-14.4-14.4zM375.9 417c-4.1 4.1-7 9.2-8.4 14.9l-15 60.1c-1.4 5.5 .2 11.2 4.2 15.2s9.7 5.6 15.2 4.2l60.1-15c5.6-1.4 10.8-4.3 14.9-8.4L576.1 358.7l-71-71L375.9 417z"
    ]
};
var $d8206b3ab2e65c05$export$a68a6960fc8eef82 = $d8206b3ab2e65c05$export$3842882ea09b25af;
var $d8206b3ab2e65c05$export$afa7b53ac8ebcb5d = {
    prefix: "fas",
    iconName: "signature",
    icon: [
        640,
        512,
        [],
        "f5b7",
        "M192 128c0-17.7 14.3-32 32-32s32 14.3 32 32v7.8c0 27.7-2.4 55.3-7.1 82.5l-84.4 25.3c-40.6 12.2-68.4 49.6-68.4 92v71.9c0 40 32.5 72.5 72.5 72.5c26 0 50-13.9 62.9-36.5l13.9-24.3c26.8-47 46.5-97.7 58.4-150.5l94.4-28.3-12.5 37.5c-3.3 9.8-1.6 20.5 4.4 28.8s15.7 13.3 26 13.3H544c17.7 0 32-14.3 32-32s-14.3-32-32-32H460.4l18-53.9c3.8-11.3 .9-23.8-7.4-32.4s-20.7-11.8-32.2-8.4L316.4 198.1c2.4-20.7 3.6-41.4 3.6-62.3V128c0-53-43-96-96-96s-96 43-96 96v32c0 17.7 14.3 32 32 32s32-14.3 32-32V128zm-9.2 177l49-14.7c-10.4 33.8-24.5 66.4-42.1 97.2l-13.9 24.3c-1.5 2.6-4.3 4.3-7.4 4.3c-4.7 0-8.5-3.8-8.5-8.5V335.6c0-14.1 9.3-26.6 22.8-30.7zM24 368c-13.3 0-24 10.7-24 24s10.7 24 24 24H64.3c-.2-2.8-.3-5.6-.3-8.5V368H24zm592 48c13.3 0 24-10.7 24-24s-10.7-24-24-24H305.9c-6.7 16.3-14.2 32.3-22.3 48H616z"
    ]
};
var $d8206b3ab2e65c05$export$195780ddabd8e0c6 = {
    prefix: "fas",
    iconName: "stroopwafel",
    icon: [
        512,
        512,
        [],
        "f551",
        "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM312.6 63.7c-6.2-6.2-16.4-6.2-22.6 0L256 97.6 222.1 63.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l33.9 33.9-45.3 45.3-56.6-56.6c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l56.6 56.6-45.3 45.3L86.3 199.4c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L97.6 256 63.7 289.9c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l33.9-33.9 45.3 45.3-56.6 56.6c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l56.6-56.6 45.3 45.3-33.9 33.9c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L256 414.4l33.9 33.9c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-33.9-33.9 45.3-45.3 56.6 56.6c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-56.6-56.6 45.3-45.3 33.9 33.9c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L414.4 256l33.9-33.9c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-33.9 33.9-45.3-45.3 56.6-56.6c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-56.6 56.6-45.3-45.3 33.9-33.9c6.2-6.2 6.2-16.4 0-22.6zM142.9 256l45.3-45.3L233.4 256l-45.3 45.3L142.9 256zm67.9 67.9L256 278.6l45.3 45.3L256 369.1l-45.3-45.3zM278.6 256l45.3-45.3L369.1 256l-45.3 45.3L278.6 256zm22.6-67.9L256 233.4l-45.3-45.3L256 142.9l45.3 45.3z"
    ]
};
var $d8206b3ab2e65c05$export$7e0c7fd2a2e88823 = {
    prefix: "fas",
    iconName: "bold",
    icon: [
        384,
        512,
        [],
        "f032",
        "M0 64C0 46.3 14.3 32 32 32H80 96 224c70.7 0 128 57.3 128 128c0 31.3-11.3 60.1-30 82.3c37.1 22.4 62 63.1 62 109.7c0 70.7-57.3 128-128 128H96 80 32c-17.7 0-32-14.3-32-32s14.3-32 32-32H48V256 96H32C14.3 96 0 81.7 0 64zM224 224c35.3 0 64-28.7 64-64s-28.7-64-64-64H112V224H224zM112 288V416H256c35.3 0 64-28.7 64-64s-28.7-64-64-64H224 112z"
    ]
};
var $d8206b3ab2e65c05$export$217195c80db39097 = {
    prefix: "fas",
    iconName: "anchor-lock",
    icon: [
        640,
        512,
        [],
        "e4ad",
        "M320 96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm21.1 80C367 158.8 384 129.4 384 96c0-53-43-96-96-96s-96 43-96 96c0 33.4 17 62.8 42.9 80H224c-17.7 0-32 14.3-32 32s14.3 32 32 32h32V448H208c-53 0-96-43-96-96v-6.1l7 7c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L97 263c-9.4-9.4-24.6-9.4-33.9 0L7 319c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l7-7V352c0 88.4 71.6 160 160 160h80 80c8 0 15.9-.6 23.6-1.7c-4.8-9-7.6-19.3-7.6-30.3V446.7c-5.2 .9-10.5 1.3-16 1.3H320V240h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H341.1zM528 240c17.7 0 32 14.3 32 32v48H496V272c0-17.7 14.3-32 32-32zm-80 32v48c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H608c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32V272c0-44.2-35.8-80-80-80s-80 35.8-80 80z"
    ]
};
var $d8206b3ab2e65c05$export$374e1dce366a2175 = {
    prefix: "fas",
    iconName: "building-ngo",
    icon: [
        384,
        512,
        [],
        "e4d7",
        "M48 0C21.5 0 0 21.5 0 48V464c0 26.5 21.5 48 48 48h96V432c0-26.5 21.5-48 48-48s48 21.5 48 48v80h96c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H48zM64 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V240zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V240zM168 64h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H184v64h16V144c0-8.8 7.2-16 16-16s16 7.2 16 16v24c0 13.3-10.7 24-24 24H176c-13.3 0-24-10.7-24-24V80c0-8.8 7.2-16 16-16zM304 96c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16s16-7.2 16-16V112c0-8.8-7.2-16-16-16zm-48 16c0-26.5 21.5-48 48-48s48 21.5 48 48v32c0 26.5-21.5 48-48 48s-48-21.5-48-48V112zM61.3 71.1l34.7 52V80c0-8.8 7.2-16 16-16s16 7.2 16 16v96c0 7.1-4.6 13.3-11.4 15.3s-14-.6-17.9-6.4L64 132.8V176c0 8.8-7.2 16-16 16s-16-7.2-16-16V80c0-7.1 4.6-13.3 11.4-15.3s14 .6 17.9 6.4z"
    ]
};
var $d8206b3ab2e65c05$export$1ff755b523ab2851 = {
    prefix: "fas",
    iconName: "manat-sign",
    icon: [
        384,
        512,
        [],
        "e1d5",
        "M192 32c-17.7 0-32 14.3-32 32V98.7C69.2 113.9 0 192.9 0 288V448c0 17.7 14.3 32 32 32s32-14.3 32-32V288c0-59.6 40.8-109.8 96-124V448c0 17.7 14.3 32 32 32s32-14.3 32-32V164c55.2 14.2 96 64.3 96 124V448c0 17.7 14.3 32 32 32s32-14.3 32-32V288c0-95.1-69.2-174.1-160-189.3V64c0-17.7-14.3-32-32-32z"
    ]
};
var $d8206b3ab2e65c05$export$6a15ccae09bbaf93 = {
    prefix: "fas",
    iconName: "not-equal",
    icon: [
        448,
        512,
        [],
        "f53e",
        "M369.8 37.4c14.7 9.8 18.7 29.7 8.9 44.4L337.1 144H400c17.7 0 32 14.3 32 32s-14.3 32-32 32H294.5l-64 96H400c17.7 0 32 14.3 32 32s-14.3 32-32 32H187.8l-65.2 97.7c-9.8 14.7-29.7 18.7-44.4 8.9s-18.7-29.7-8.9-44.4L110.9 368H48c-17.7 0-32-14.3-32-32s14.3-32 32-32H153.5l64-96H48c-17.7 0-32-14.3-32-32s14.3-32 32-32H260.2l65.2-97.7c9.8-14.7 29.7-18.7 44.4-8.9z"
    ]
};
var $d8206b3ab2e65c05$export$cf897c3e0abd59e4 = {
    prefix: "fas",
    iconName: "border-top-left",
    icon: [
        448,
        512,
        [
            "border-style"
        ],
        "f853",
        "M0 448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-336c0-8.8 7.2-16 16-16l336 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L80 32C35.8 32 0 67.8 0 112L0 448zm160 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm192 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-96 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm192 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM416 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0 32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0-128a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
var $d8206b3ab2e65c05$export$c2867ca78120d644 = $d8206b3ab2e65c05$export$cf897c3e0abd59e4;
var $d8206b3ab2e65c05$export$757f50b8af780c19 = {
    prefix: "fas",
    iconName: "map-location-dot",
    icon: [
        576,
        512,
        [
            "map-marked-alt"
        ],
        "f5a0",
        "M408 120c0 54.6-73.1 151.9-105.2 192c-7.7 9.6-22 9.6-29.6 0C241.1 271.9 168 174.6 168 120C168 53.7 221.7 0 288 0s120 53.7 120 120zm8 80.4c3.5-6.9 6.7-13.8 9.6-20.6c.5-1.2 1-2.5 1.5-3.7l116-46.4C558.9 123.4 576 135 576 152V422.8c0 9.8-6 18.6-15.1 22.3L416 503V200.4zM137.6 138.3c2.4 14.1 7.2 28.3 12.8 41.5c2.9 6.8 6.1 13.7 9.6 20.6V451.8L32.9 502.7C17.1 509 0 497.4 0 480.4V209.6c0-9.8 6-18.6 15.1-22.3l122.6-49zM327.8 332c13.9-17.4 35.7-45.7 56.2-77V504.3L192 449.4V255c20.5 31.3 42.3 59.6 56.2 77c20.5 25.6 59.1 25.6 79.6 0zM288 152a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"
    ]
};
var $d8206b3ab2e65c05$export$a977d47c74d8e86c = $d8206b3ab2e65c05$export$757f50b8af780c19;
var $d8206b3ab2e65c05$export$859f204e59641ca4 = {
    prefix: "fas",
    iconName: "jedi",
    icon: [
        576,
        512,
        [],
        "f669",
        "M246 315.7l-21.2-31.9c-2.1-3.2-1.7-7.4 1-10.1s6.9-3.1 10.1-1l29.5 19.7c2.1 1.4 4.9 0 5-2.6L279.7 8c.1-4.5 3.8-8 8.3-8s8.1 3.5 8.3 8l9.4 281.9c.1 2.5 2.9 3.9 5 2.6l29.5-19.7c3.2-2.1 7.4-1.7 10.1 1s3.1 6.9 1 10.1L330 315.7c-1.3 1.9-.2 4.5 2 4.9l37.6 7.5c3.7 .7 6.4 4 6.4 7.8s-2.7 7.1-6.4 7.8L332 351.4c-2.2 .4-3.3 3-2 4.9l21.2 31.9c2.1 3.2 1.7 7.4-1 10.1s-6.9 3.1-10.1 1l-26.3-17.6c-2.2-1.4-5.1 .2-5 2.8l2.1 61.5C370.6 435.2 416 382.9 416 320c0-37-15.7-70.4-40.8-93.7c-7-6.5-6.5-18.6 1-24.4C410.1 175.5 432 134.3 432 88c0-16.8-2.9-33-8.2-48c-4.6-13 10.2-30 21.4-22c53.5 38 92.7 94.8 107.8 160.7c.5 2.1-.2 4.3-1.7 5.9l-28.4 28.4c-4 4-1.2 10.9 4.5 10.9h26c3.4 0 6.2 2.6 6.3 6c.1 3.3 .2 6.6 .2 10c0 17.5-1.7 34.7-4.8 51.3c-.2 1.2-.9 2.4-1.7 3.3l-46.5 46.5c-4 4-1.2 10.9 4.5 10.9H526c4.6 0 7.7 4.8 5.7 9C487.2 450.5 394.8 512 288 512S88.8 450.5 44.3 361c-2.1-4.2 1-9 5.7-9H64.5c5.7 0 8.6-6.9 4.5-10.9L22.6 294.6c-.9-.9-1.5-2-1.7-3.3C17.7 274.7 16 257.5 16 240c0-3.3 .1-6.7 .2-10c.1-3.4 2.9-6 6.3-6h26c5.7 0 8.6-6.9 4.5-10.9L24.6 184.6c-1.5-1.5-2.2-3.8-1.7-5.9C38.1 112.8 77.3 56 130.8 18c11.3-8 26 8.9 21.4 22c-5.3 15-8.2 31.2-8.2 48c0 46.3 21.9 87.5 55.8 113.9c7.5 5.8 8 17.9 1 24.4C175.7 249.6 160 283 160 320c0 62.9 45.4 115.2 105.1 126l2.1-61.5c.1-2.6-2.8-4.2-5-2.8l-26.3 17.6c-3.2 2.1-7.4 1.7-10.1-1s-3.1-6.9-1-10.1L246 356.3c1.3-1.9 .2-4.5-2-4.9l-37.6-7.5c-3.7-.7-6.4-4-6.4-7.8s2.7-7.1 6.4-7.8l37.6-7.5c2.2-.4 3.3-3 2-4.9z"
    ]
};
var $d8206b3ab2e65c05$export$91d747e5aabe6fe8 = {
    prefix: "fas",
    iconName: "square-poll-vertical",
    icon: [
        448,
        512,
        [
            "poll"
        ],
        "f681",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm64 192c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V256c0-17.7 14.3-32 32-32zm64-64c0-17.7 14.3-32 32-32s32 14.3 32 32V352c0 17.7-14.3 32-32 32s-32-14.3-32-32V160zM320 288c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V320c0-17.7 14.3-32 32-32z"
    ]
};
var $d8206b3ab2e65c05$export$bc8ca14ab51f93db = $d8206b3ab2e65c05$export$91d747e5aabe6fe8;
var $d8206b3ab2e65c05$export$47a822c30184e8af = {
    prefix: "fas",
    iconName: "mug-hot",
    icon: [
        512,
        512,
        [
            9749
        ],
        "f7b6",
        "M88 0C74.7 0 64 10.7 64 24c0 38.9 23.4 59.4 39.1 73.1l1.1 1C120.5 112.3 128 119.9 128 136c0 13.3 10.7 24 24 24s24-10.7 24-24c0-38.9-23.4-59.4-39.1-73.1l-1.1-1C119.5 47.7 112 40.1 112 24c0-13.3-10.7-24-24-24zM32 192c-17.7 0-32 14.3-32 32V416c0 53 43 96 96 96H288c53 0 96-43 96-96h16c61.9 0 112-50.1 112-112s-50.1-112-112-112H352 32zm352 64h16c26.5 0 48 21.5 48 48s-21.5 48-48 48H384V256zM224 24c0-13.3-10.7-24-24-24s-24 10.7-24 24c0 38.9 23.4 59.4 39.1 73.1l1.1 1C232.5 112.3 240 119.9 240 136c0 13.3 10.7 24 24 24s24-10.7 24-24c0-38.9-23.4-59.4-39.1-73.1l-1.1-1C231.5 47.7 224 40.1 224 24z"
    ]
};
var $d8206b3ab2e65c05$export$a44d0c11093d9c1e = {
    prefix: "fas",
    iconName: "car-battery",
    icon: [
        512,
        512,
        [
            "battery-car"
        ],
        "f5df",
        "M80 96c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32l96 0c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32h16c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64l16 0zm304 96c0-8.8-7.2-16-16-16s-16 7.2-16 16v32H320c-8.8 0-16 7.2-16 16s7.2 16 16 16h32v32c0 8.8 7.2 16 16 16s16-7.2 16-16V256h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H384V192zM80 240c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H96c-8.8 0-16 7.2-16 16z"
    ]
};
var $d8206b3ab2e65c05$export$9133165ca669dd4b = $d8206b3ab2e65c05$export$a44d0c11093d9c1e;
var $d8206b3ab2e65c05$export$b2727de8ccdbb5ec = {
    prefix: "fas",
    iconName: "gift",
    icon: [
        512,
        512,
        [
            127873
        ],
        "f06b",
        "M190.5 68.8L225.3 128H224 152c-22.1 0-40-17.9-40-40s17.9-40 40-40h2.2c14.9 0 28.8 7.9 36.3 20.8zM64 88c0 14.4 3.5 28 9.6 40H32c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H480c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32H438.4c6.1-12 9.6-25.6 9.6-40c0-48.6-39.4-88-88-88h-2.2c-31.9 0-61.5 16.9-77.7 44.4L256 85.5l-24.1-41C215.7 16.9 186.1 0 154.2 0H152C103.4 0 64 39.4 64 88zm336 0c0 22.1-17.9 40-40 40H288h-1.3l34.8-59.2C329.1 55.9 342.9 48 357.8 48H360c22.1 0 40 17.9 40 40zM32 288V464c0 26.5 21.5 48 48 48H224V288H32zM288 512H432c26.5 0 48-21.5 48-48V288H288V512z"
    ]
};
var $d8206b3ab2e65c05$export$4d85df590065572f = {
    prefix: "fas",
    iconName: "dice-two",
    icon: [
        448,
        512,
        [
            9857
        ],
        "f528",
        "M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM352 352a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM128 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
var $d8206b3ab2e65c05$export$7b8ce73615739d30 = {
    prefix: "fas",
    iconName: "chess-queen",
    icon: [
        512,
        512,
        [
            9819
        ],
        "f445",
        "M256 0a56 56 0 1 1 0 112A56 56 0 1 1 256 0zM134.1 143.8c3.3-13 15-23.8 30.2-23.8c12.3 0 22.6 7.2 27.7 17c12 23.2 36.2 39 64 39s52-15.8 64-39c5.1-9.8 15.4-17 27.7-17c15.3 0 27 10.8 30.2 23.8c7 27.8 32.2 48.3 62.1 48.3c10.8 0 21-2.7 29.8-7.4c8.4-4.4 18.9-4.5 27.6 .9c13 8 17.1 25 9.2 38L399.7 400H384 343.6 168.4 128 112.3L5.4 223.6c-7.9-13-3.8-30 9.2-38c8.7-5.3 19.2-5.3 27.6-.9c8.9 4.7 19 7.4 29.8 7.4c29.9 0 55.1-20.5 62.1-48.3zM256 224l0 0 0 0h0zM112 432H400l41.4 41.4c4.2 4.2 6.6 10 6.6 16c0 12.5-10.1 22.6-22.6 22.6H86.6C74.1 512 64 501.9 64 489.4c0-6 2.4-11.8 6.6-16L112 432z"
    ]
};
var $d8206b3ab2e65c05$export$58d7d709c0a8ca5f = {
    prefix: "fas",
    iconName: "glasses",
    icon: [
        576,
        512,
        [],
        "f530",
        "M118.6 80c-11.5 0-21.4 7.9-24 19.1L57 260.3c20.5-6.2 48.3-12.3 78.7-12.3c32.3 0 61.8 6.9 82.8 13.5c10.6 3.3 19.3 6.7 25.4 9.2c3.1 1.3 5.5 2.4 7.3 3.2c.9 .4 1.6 .7 2.1 1l.6 .3 .2 .1 .1 0 0 0 0 0s0 0-6.3 12.7h0l6.3-12.7c5.8 2.9 10.4 7.3 13.5 12.7h40.6c3.1-5.3 7.7-9.8 13.5-12.7l6.3 12.7h0c-6.3-12.7-6.3-12.7-6.3-12.7l0 0 0 0 .1 0 .2-.1 .6-.3c.5-.2 1.2-.6 2.1-1c1.8-.8 4.2-1.9 7.3-3.2c6.1-2.6 14.8-5.9 25.4-9.2c21-6.6 50.4-13.5 82.8-13.5c30.4 0 58.2 6.1 78.7 12.3L481.4 99.1c-2.6-11.2-12.6-19.1-24-19.1c-3.1 0-6.2 .6-9.2 1.8L416.9 94.3c-12.3 4.9-26.3-1.1-31.2-13.4s1.1-26.3 13.4-31.2l31.3-12.5c8.6-3.4 17.7-5.2 27-5.2c33.8 0 63.1 23.3 70.8 56.2l43.9 188c1.7 7.3 2.9 14.7 3.5 22.1c.3 1.9 .5 3.8 .5 5.7v6.7V352v16c0 61.9-50.1 112-112 112H419.7c-59.4 0-108.5-46.4-111.8-105.8L306.6 352H269.4l-1.2 22.2C264.9 433.6 215.8 480 156.3 480H112C50.1 480 0 429.9 0 368V352 310.7 304c0-1.9 .2-3.8 .5-5.7c.6-7.4 1.8-14.8 3.5-22.1l43.9-188C55.5 55.3 84.8 32 118.6 32c9.2 0 18.4 1.8 27 5.2l31.3 12.5c12.3 4.9 18.3 18.9 13.4 31.2s-18.9 18.3-31.2 13.4L127.8 81.8c-2.9-1.2-6-1.8-9.2-1.8zM64 325.4V368c0 26.5 21.5 48 48 48h44.3c25.5 0 46.5-19.9 47.9-45.3l2.5-45.6c-2.3-.8-4.9-1.7-7.5-2.5c-17.2-5.4-39.9-10.5-63.6-10.5c-23.7 0-46.2 5.1-63.2 10.5c-3.1 1-5.9 1.9-8.5 2.9zM512 368V325.4c-2.6-.9-5.5-1.9-8.5-2.9c-17-5.4-39.5-10.5-63.2-10.5c-23.7 0-46.4 5.1-63.6 10.5c-2.7 .8-5.2 1.7-7.5 2.5l2.5 45.6c1.4 25.4 22.5 45.3 47.9 45.3H464c26.5 0 48-21.5 48-48z"
    ]
};
var $d8206b3ab2e65c05$export$bd301515df6246af = {
    prefix: "fas",
    iconName: "chess-board",
    icon: [
        448,
        512,
        [],
        "f43c",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm64 64v64h64V96h64v64h64V96h64v64H320v64h64v64H320v64h64v64H320V352H256v64H192V352H128v64H64V352h64V288H64V224h64V160H64V96h64zm64 128h64V160H192v64zm0 64V224H128v64h64zm64 0H192v64h64V288zm0 0h64V224H256v64z"
    ]
};
var $d8206b3ab2e65c05$export$5559de5f969b9590 = {
    prefix: "fas",
    iconName: "building-circle-check",
    icon: [
        640,
        512,
        [],
        "e4d2",
        "M48 0C21.5 0 0 21.5 0 48V464c0 26.5 21.5 48 48 48h96V432c0-26.5 21.5-48 48-48s48 21.5 48 48v80h96c15.1 0 28.5-6.9 37.3-17.8C340.4 462.2 320 417.5 320 368c0-54.7 24.9-103.5 64-135.8V48c0-26.5-21.5-48-48-48H48zM64 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V240zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V240zM80 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V112zM272 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"
    ]
};
var $d8206b3ab2e65c05$export$c9dc1583b207b7ff = {
    prefix: "fas",
    iconName: "person-chalkboard",
    icon: [
        640,
        512,
        [],
        "e53d",
        "M192 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-8 384V352h16V480c0 17.7 14.3 32 32 32s32-14.3 32-32V192h56 64 16c17.7 0 32-14.3 32-32s-14.3-32-32-32H384V64H576V256H384V224H320v48c0 26.5 21.5 48 48 48H592c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H368c-26.5 0-48 21.5-48 48v80H243.1 177.1c-33.7 0-64.9 17.7-82.3 46.6l-58.3 97c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9L120 256.9V480c0 17.7 14.3 32 32 32s32-14.3 32-32z"
    ]
};
var $d8206b3ab2e65c05$export$321e84e6a900c2d6 = {
    prefix: "fas",
    iconName: "mars-stroke-right",
    icon: [
        640,
        512,
        [
            9897,
            "mars-stroke-h"
        ],
        "f22b",
        "M208 368a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm174.4-88C370.7 365.8 297.1 432 208 432c-97.2 0-176-78.8-176-176s78.8-176 176-176c89.1 0 162.7 66.2 174.4 152H416V176c0-13.3 10.7-24 24-24s24 10.7 24 24v56h32V176c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2l80 80c9.4 9.4 9.4 24.6 0 33.9l-80 80c-6.9 6.9-17.2 8.9-26.2 5.2s-14.8-12.5-14.8-22.2V280H464v56c0 13.3-10.7 24-24 24s-24-10.7-24-24V280H382.4z"
    ]
};
var $d8206b3ab2e65c05$export$5cb0daeafbcdabe3 = $d8206b3ab2e65c05$export$321e84e6a900c2d6;
var $d8206b3ab2e65c05$export$be38a892fe9b4098 = {
    prefix: "fas",
    iconName: "hand-back-fist",
    icon: [
        448,
        512,
        [
            "hand-rock"
        ],
        "f255",
        "M144 0C117.5 0 96 21.5 96 48V96v28.5V176c0 8.8-7.2 16-16 16s-16-7.2-16-16V149.3l-9 7.5C40.4 169 32 187 32 206V244c0 38 16.9 74 46.1 98.3L128 384v96c0 17.7 14.3 32 32 32H320c17.7 0 32-14.3 32-32V374.7c46.9-19 80-65 80-118.7V176 160 144c0-26.5-21.5-48-48-48c-12.4 0-23.6 4.7-32.1 12.3C350 83.5 329.3 64 304 64c-12.4 0-23.6 4.7-32.1 12.3C270 51.5 249.3 32 224 32c-12.4 0-23.6 4.7-32.1 12.3C190 19.5 169.3 0 144 0z"
    ]
};
var $d8206b3ab2e65c05$export$97a81eba394c8c44 = $d8206b3ab2e65c05$export$be38a892fe9b4098;
var $d8206b3ab2e65c05$export$66068918abb14406 = {
    prefix: "fas",
    iconName: "square-caret-up",
    icon: [
        448,
        512,
        [
            "caret-square-up"
        ],
        "f151",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM224 160c6.7 0 13 2.8 17.6 7.7l104 112c6.5 7 8.2 17.2 4.4 25.9s-12.5 14.4-22 14.4H120c-9.5 0-18.2-5.7-22-14.4s-2.1-18.9 4.4-25.9l104-112c4.5-4.9 10.9-7.7 17.6-7.7z"
    ]
};
var $d8206b3ab2e65c05$export$307ae80b26533ce5 = $d8206b3ab2e65c05$export$66068918abb14406;
var $d8206b3ab2e65c05$export$b416056e795d2eac = {
    prefix: "fas",
    iconName: "cloud-showers-water",
    icon: [
        576,
        512,
        [],
        "e4e4",
        "M224 0c38.6 0 71.9 22.8 87.2 55.7C325.7 41.1 345.8 32 368 32c38.7 0 71 27.5 78.4 64H448c35.3 0 64 28.7 64 64s-28.7 64-64 64H128c-35.3 0-64-28.7-64-64s28.7-64 64-64c0-53 43-96 96-96zM140.6 292.3l-48 80c-6.8 11.4-21.6 15-32.9 8.2s-15.1-21.6-8.2-32.9l48-80c6.8-11.4 21.6-15.1 32.9-8.2s15.1 21.6 8.2 32.9zm327.8-32.9c11.4 6.8 15 21.6 8.2 32.9l-48 80c-6.8 11.4-21.6 15-32.9 8.2s-15-21.6-8.2-32.9l48-80c6.8-11.4 21.6-15.1 32.9-8.2zM252.6 292.3l-48 80c-6.8 11.4-21.6 15-32.9 8.2s-15.1-21.6-8.2-32.9l48-80c6.8-11.4 21.6-15.1 32.9-8.2s15.1 21.6 8.2 32.9zm103.8-32.9c11.4 6.8 15 21.6 8.2 32.9l-48 80c-6.8 11.4-21.6 15-32.9 8.2s-15.1-21.6-8.2-32.9l48-80c6.8-11.4 21.6-15.1 32.9-8.2zM306.5 421.9C329 437.4 356.5 448 384 448c26.9 0 55.4-10.8 77.4-26.1l0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 501.7 417 512 384 512c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.4 27.3-10.1 39.2-1.7l0 0C136.7 437.2 165.1 448 192 448c27.5 0 55-10.6 77.5-26.1c11.1-7.9 25.9-7.9 37 0z"
    ]
};
var $d8206b3ab2e65c05$export$b532f5d25de97633 = {
    prefix: "fas",
    iconName: "chart-bar",
    icon: [
        512,
        512,
        [
            "bar-chart"
        ],
        "f080",
        "M32 32c17.7 0 32 14.3 32 32V400c0 8.8 7.2 16 16 16H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H80c-44.2 0-80-35.8-80-80V64C0 46.3 14.3 32 32 32zm96 96c0-17.7 14.3-32 32-32l192 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-192 0c-17.7 0-32-14.3-32-32zm32 64H288c17.7 0 32 14.3 32 32s-14.3 32-32 32H160c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 96H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H160c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
    ]
};
var $d8206b3ab2e65c05$export$2d5f754a5e5738b = $d8206b3ab2e65c05$export$b532f5d25de97633;
var $d8206b3ab2e65c05$export$2f78563e14e49916 = {
    prefix: "fas",
    iconName: "hands-bubbles",
    icon: [
        576,
        512,
        [
            "hands-wash"
        ],
        "e05e",
        "M416 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm96 128a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM160 464a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM32 160l.1 72.6c.1 52.2 24 101 64 133.1c-.1-1.9-.1-3.8-.1-5.7v-8c0-71.8 37-138.6 97.9-176.7l60.2-37.6c8.6-5.4 17.9-8.4 27.3-9.4l45.9-79.5c6.6-11.5 2.7-26.2-8.8-32.8s-26.2-2.7-32.8 8.8l-78 135.1c-3.3 5.7-10.7 7.7-16.4 4.4s-7.7-10.7-4.4-16.4l62-107.4c6.6-11.5 2.7-26.2-8.8-32.8S214 5 207.4 16.5l-68 117.8 0 0 0 0-43.3 75L96 160c0-17.7-14.4-32-32-32s-32 14.4-32 32zM332.1 88.5L307.5 131c13.9 4.5 26.4 13.7 34.7 27c.9 1.5 1.8 2.9 2.5 4.4l28.9-50c6.6-11.5 2.7-26.2-8.8-32.8s-26.2-2.7-32.8 8.8zm46.4 63.7l-26.8 46.4c-.6 6-2.1 11.8-4.3 17.4H352h13.3l0 0H397l23-39.8c6.6-11.5 2.7-26.2-8.8-32.8s-26.2-2.7-32.8 8.8zM315.1 175c-9.4-15-29.1-19.5-44.1-10.2l-60.2 37.6C159.3 234.7 128 291.2 128 352v8c0 8.9 .8 17.6 2.2 26.1c35.4 8.2 61.8 40 61.8 77.9c0 6.3-.7 12.5-2.1 18.4C215.1 501 246.3 512 280 512H456c13.3 0 24-10.7 24-24s-10.7-24-24-24H364c-6.6 0-12-5.4-12-12s5.4-12 12-12H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H364c-6.6 0-12-5.4-12-12s5.4-12 12-12H520c13.3 0 24-10.7 24-24s-10.7-24-24-24H364c-6.6 0-12-5.4-12-12s5.4-12 12-12H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H352l0 0 0 0H258.8L305 219.1c15-9.4 19.5-29.1 10.2-44.1z"
    ]
};
var $d8206b3ab2e65c05$export$996b5dea53b124e3 = $d8206b3ab2e65c05$export$2f78563e14e49916;
var $d8206b3ab2e65c05$export$b2c723344cff0d8 = {
    prefix: "fas",
    iconName: "less-than-equal",
    icon: [
        448,
        512,
        [],
        "f537",
        "M395.9 93.7c16.4-6.6 24.4-25.2 17.8-41.6s-25.2-24.4-41.6-17.8l-320 128C40 167.1 32 178.9 32 192s8 24.9 20.1 29.7l320 128c16.4 6.6 35-1.4 41.6-17.8s-1.4-35-17.8-41.6L150.2 192 395.9 93.7zM32 416c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z"
    ]
};
var $d8206b3ab2e65c05$export$17cde74bf6f1ee89 = {
    prefix: "fas",
    iconName: "train",
    icon: [
        448,
        512,
        [
            128646
        ],
        "f238",
        "M96 0C43 0 0 43 0 96V352c0 48 35.2 87.7 81.1 94.9l-46 46C28.1 499.9 33.1 512 43 512H82.7c8.5 0 16.6-3.4 22.6-9.4L160 448H288l54.6 54.6c6 6 14.1 9.4 22.6 9.4H405c10 0 15-12.1 7.9-19.1l-46-46c46-7.1 81.1-46.9 81.1-94.9V96c0-53-43-96-96-96H96zM64 96c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V96zM224 288a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
    ]
};
var $d8206b3ab2e65c05$export$23a892b1a4b994bd = {
    prefix: "fas",
    iconName: "eye-low-vision",
    icon: [
        640,
        512,
        [
            "low-vision"
        ],
        "f2a8",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L525.6 386.7c39.6-40.6 66.4-86.1 79.9-118.4c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C465.5 68.8 400.8 32 320 32c-68.2 0-125 26.3-169.3 60.8L38.8 5.1zM223 149.5c48.6-44.3 123-50.8 179.3-11.7c60.8 42.4 78.9 123.2 44.2 186.9L408 294.5c8.4-19.3 10.6-41.4 4.8-63.3c-11.1-41.5-47.8-69.4-88.6-71.1c-5.8-.2-9.2 6.1-7.4 11.7c2.1 6.4 3.3 13.2 3.3 20.3c0 10.2-2.4 19.8-6.6 28.3L223 149.5zm-139.9 12c-11 14.4-20.5 28.7-28.4 42.2l339 265.7c18.7-5.5 36.2-13 52.6-21.8L83.1 161.5zm-50 86.3c-1.8 6.8-1.3 14 1.4 20.5c14.9 35.7 46.2 87.7 93 131.1C174.5 443.2 239.2 480 320 480c3.1 0 6.1-.1 9.2-.2L33.1 247.8z"
    ]
};
var $d8206b3ab2e65c05$export$7a65d2aa54cb4e93 = $d8206b3ab2e65c05$export$23a892b1a4b994bd;
var $d8206b3ab2e65c05$export$bfa312207b788ed9 = {
    prefix: "fas",
    iconName: "crow",
    icon: [
        640,
        512,
        [],
        "f520",
        "M456 0c-48.6 0-88 39.4-88 88v29.2L12.5 390.6c-14 10.8-16.6 30.9-5.9 44.9s30.9 16.6 44.9 5.9L126.1 384H259.2l46.6 113.1c5 12.3 19.1 18.1 31.3 13.1s18.1-19.1 13.1-31.3L311.1 384H352c1.1 0 2.1 0 3.2 0l46.6 113.2c5 12.3 19.1 18.1 31.3 13.1s18.1-19.1 13.1-31.3l-42-102C484.9 354.1 544 280 544 192V128v-8l80.5-20.1c8.6-2.1 13.8-10.8 11.6-19.4C629 52 603.4 32 574 32H523.9C507.7 12.5 483.3 0 456 0zm0 64a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
    ]
};
var $d8206b3ab2e65c05$export$e363e74e36cce80c = {
    prefix: "fas",
    iconName: "sailboat",
    icon: [
        576,
        512,
        [],
        "e445",
        "M256 16c0-7 4.5-13.2 11.2-15.3s13.9 .4 17.9 6.1l224 320c3.4 4.9 3.8 11.3 1.1 16.6s-8.2 8.6-14.2 8.6H272c-8.8 0-16-7.2-16-16V16zM212.1 96.5c7 1.9 11.9 8.2 11.9 15.5V336c0 8.8-7.2 16-16 16H80c-5.7 0-11-3-13.8-8s-2.9-11-.1-16l128-224c3.6-6.3 11-9.4 18-7.5zM5.7 404.3C2.8 394.1 10.5 384 21.1 384H554.9c10.6 0 18.3 10.1 15.4 20.3l-4 14.3C550.7 473.9 500.4 512 443 512H133C75.6 512 25.3 473.9 9.7 418.7l-4-14.3z"
    ]
};
var $d8206b3ab2e65c05$export$eccfff9bfd585652 = {
    prefix: "fas",
    iconName: "window-restore",
    icon: [
        512,
        512,
        [],
        "f2d2",
        "M432 64H208c-8.8 0-16 7.2-16 16V96H128V80c0-44.2 35.8-80 80-80H432c44.2 0 80 35.8 80 80V304c0 44.2-35.8 80-80 80H416V320h16c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16zM0 192c0-35.3 28.7-64 64-64H320c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192zm64 32c0 17.7 14.3 32 32 32H288c17.7 0 32-14.3 32-32s-14.3-32-32-32H96c-17.7 0-32 14.3-32 32z"
    ]
};
var $d8206b3ab2e65c05$export$eaf727acca5a35e4 = {
    prefix: "fas",
    iconName: "square-plus",
    icon: [
        448,
        512,
        [
            61846,
            "plus-square"
        ],
        "f0fe",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM200 344V280H136c-13.3 0-24-10.7-24-24s10.7-24 24-24h64V168c0-13.3 10.7-24 24-24s24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H248v64c0 13.3-10.7 24-24 24s-24-10.7-24-24z"
    ]
};
var $d8206b3ab2e65c05$export$b6359eebfe900c35 = $d8206b3ab2e65c05$export$eaf727acca5a35e4;
var $d8206b3ab2e65c05$export$75825a4c2b3375e = {
    prefix: "fas",
    iconName: "torii-gate",
    icon: [
        512,
        512,
        [
            9961
        ],
        "f6a1",
        "M0 80c0 26.5 21.5 48 48 48H64v64h64V128h96v64h64V128h96v64h64V128h16c26.5 0 48-21.5 48-48V13.4C512 6 506 0 498.6 0c-1.7 0-3.4 .3-5 1l-49 19.6C425.7 28.1 405.5 32 385.2 32H126.8c-20.4 0-40.5-3.9-59.4-11.4L18.4 1c-1.6-.6-3.3-1-5-1C6 0 0 6 0 13.4V80zM64 288V480c0 17.7 14.3 32 32 32s32-14.3 32-32V288H384V480c0 17.7 14.3 32 32 32s32-14.3 32-32V288h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H64z"
    ]
};
var $d8206b3ab2e65c05$export$fe2358263efac504 = {
    prefix: "fas",
    iconName: "frog",
    icon: [
        576,
        512,
        [],
        "f52e",
        "M368 32c41.7 0 75.9 31.8 79.7 72.5l85.6 26.3c25.4 7.8 42.8 31.3 42.8 57.9c0 21.8-11.7 41.9-30.7 52.7L400.8 323.5 493.3 416H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H480c-8.5 0-16.6-3.4-22.6-9.4L346.9 360.2c11.7-36 3.2-77.1-25.4-105.7c-40.6-40.6-106.3-40.6-146.9-.1L101 324.4c-6.4 6.1-6.7 16.2-.6 22.6s16.2 6.6 22.6 .6l73.8-70.2 .1-.1 .1-.1c3.5-3.5 7.3-6.6 11.3-9.2c27.9-18.5 65.9-15.4 90.5 9.2c24.7 24.7 27.7 62.9 9 90.9c-2.6 3.8-5.6 7.5-9 10.9L261.8 416H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H64c-35.3 0-64-28.7-64-64C0 249.6 127 112.9 289.3 97.5C296.2 60.2 328.8 32 368 32zm0 104a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
    ]
};
var $d8206b3ab2e65c05$export$2124c7628e573b84 = {
    prefix: "fas",
    iconName: "bucket",
    icon: [
        448,
        512,
        [],
        "e4cf",
        "M96 152v8H48v-8C48 68.1 116.1 0 200 0h48c83.9 0 152 68.1 152 152v8H352v-8c0-57.4-46.6-104-104-104H200C142.6 48 96 94.6 96 152zM0 224c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32h-5.1L388.5 469c-2.6 24.4-23.2 43-47.7 43H107.2c-24.6 0-45.2-18.5-47.7-43L37.1 256H32c-17.7 0-32-14.3-32-32z"
    ]
};
var $d8206b3ab2e65c05$export$7e9f0928967e03b = {
    prefix: "fas",
    iconName: "image",
    icon: [
        512,
        512,
        [],
        "f03e",
        "M0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM323.8 202.5c-4.5-6.6-11.9-10.5-19.8-10.5s-15.4 3.9-19.8 10.5l-87 127.6L170.7 297c-4.6-5.7-11.5-9-18.7-9s-14.2 3.3-18.7 9l-64 80c-5.8 7.2-6.9 17.1-2.9 25.4s12.4 13.6 21.6 13.6h96 32H424c8.9 0 17.1-4.9 21.2-12.8s3.6-17.4-1.4-24.7l-120-176zM112 192a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"
    ]
};
var $d8206b3ab2e65c05$export$eed3c491effe6d12 = {
    prefix: "fas",
    iconName: "microphone",
    icon: [
        384,
        512,
        [],
        "f130",
        "M192 0C139 0 96 43 96 96V256c0 53 43 96 96 96s96-43 96-96V96c0-53-43-96-96-96zM64 216c0-13.3-10.7-24-24-24s-24 10.7-24 24v40c0 89.1 66.2 162.7 152 174.4V464H120c-13.3 0-24 10.7-24 24s10.7 24 24 24h72 72c13.3 0 24-10.7 24-24s-10.7-24-24-24H216V430.4c85.8-11.7 152-85.3 152-174.4V216c0-13.3-10.7-24-24-24s-24 10.7-24 24v40c0 70.7-57.3 128-128 128s-128-57.3-128-128V216z"
    ]
};
var $d8206b3ab2e65c05$export$1da3b2e53dcafa2d = {
    prefix: "fas",
    iconName: "cow",
    icon: [
        640,
        512,
        [
            128004
        ],
        "f6c8",
        "M96 224v32V416c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V327.8c9.9 6.6 20.6 12 32 16.1V368c0 8.8 7.2 16 16 16s16-7.2 16-16V351.1c5.3 .6 10.6 .9 16 .9s10.7-.3 16-.9V368c0 8.8 7.2 16 16 16s16-7.2 16-16V343.8c11.4-4 22.1-9.4 32-16.1V416c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V256l32 32v49.5c0 9.5 2.8 18.7 8.1 26.6L530 427c8.8 13.1 23.5 21 39.3 21c22.5 0 41.9-15.9 46.3-38l20.3-101.6c2.6-13-.3-26.5-8-37.3l-3.9-5.5V184c0-13.3-10.7-24-24-24s-24 10.7-24 24v14.4l-52.9-74.1C496 86.5 452.4 64 405.9 64H272 256 192 144C77.7 64 24 117.7 24 184v54C9.4 249.8 0 267.8 0 288v17.6c0 8 6.4 14.4 14.4 14.4C46.2 320 72 294.2 72 262.4V256 224 184c0-24.3 12.1-45.8 30.5-58.9C98.3 135.9 96 147.7 96 160v64zM560 336a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM166.6 166.6c-4.2-4.2-6.6-10-6.6-16c0-12.5 10.1-22.6 22.6-22.6H361.4c12.5 0 22.6 10.1 22.6 22.6c0 6-2.4 11.8-6.6 16l-23.4 23.4C332.2 211.8 302.7 224 272 224s-60.2-12.2-81.9-33.9l-23.4-23.4z"
    ]
};
var $d8206b3ab2e65c05$export$7de776bdab4e536d = {
    prefix: "fas",
    iconName: "caret-up",
    icon: [
        320,
        512,
        [],
        "f0d8",
        "M182.6 137.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8H288c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-128-128z"
    ]
};
var $d8206b3ab2e65c05$export$7484ff654cd6474f = {
    prefix: "fas",
    iconName: "screwdriver",
    icon: [
        512,
        512,
        [
            129691
        ],
        "f54a",
        "M465 7c-8.5-8.5-22-9.4-31.6-2.1l-104 80c-5.9 4.5-9.4 11.6-9.4 19v54.1l-85.6 85.6c6.7 4.2 13 9.3 18.8 15.1s10.9 12.2 15.1 18.8L353.9 192H408c7.5 0 14.5-3.5 19-9.4l80-104c7.4-9.6 6.5-23.1-2.1-31.6L465 7zM121.4 281.4l-112 112c-12.5 12.5-12.5 32.8 0 45.3l64 64c12.5 12.5 32.8 12.5 45.3 0l112-112c30.2-30.2 30.2-79.1 0-109.3s-79.1-30.2-109.3 0z"
    ]
};
var $d8206b3ab2e65c05$export$5e30548b7f8eeb95 = {
    prefix: "fas",
    iconName: "folder-closed",
    icon: [
        512,
        512,
        [],
        "e185",
        "M448 480H64c-35.3 0-64-28.7-64-64V192H512V416c0 35.3-28.7 64-64 64zm64-320H0V96C0 60.7 28.7 32 64 32H192c20.1 0 39.1 9.5 51.2 25.6l19.2 25.6c6 8.1 15.5 12.8 25.6 12.8H448c35.3 0 64 28.7 64 64z"
    ]
};
var $d8206b3ab2e65c05$export$197b9567e88a0b1d = {
    prefix: "fas",
    iconName: "house-tsunami",
    icon: [
        576,
        512,
        [],
        "e515",
        "M80.8 136.5C104.9 93.8 152.6 64 209 64c16.9 0 33.1 2.7 48.2 7.7c16.8 5.5 34.9-3.6 40.4-20.4s-3.6-34.9-20.4-40.4C255.8 3.8 232.8 0 209 0C95.2 0 0 88 0 200c0 91.6 53.5 172.1 142.2 194.1c13.4 3.8 27.5 5.9 42.2 5.9c.7 0 1.4 0 2.1-.1c1.8 0 3.7 .1 5.5 .1l0 0c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.5-27.3-10.1-39.2-1.7l0 0C439.4 325.2 410.9 336 384 336c-27.5 0-55-10.6-77.5-26.1c-11.1-7.9-25.9-7.9-37 0c-22.4 15.5-49.9 26.1-77.4 26.1c0 0-.1 0-.1 0c-12.4 0-24-1.5-34.9-4.3C121.6 320.2 96 287 96 248c0-48.5 39.5-88 88.4-88c13.5 0 26.1 3 37.5 8.3c16 7.5 35.1 .6 42.5-15.5s.6-35.1-15.5-42.5C229.3 101.1 207.4 96 184.4 96c-40 0-76.4 15.4-103.6 40.5zm252-18.1c-8.1 6-12.8 15.5-12.8 25.6V265c1.6 1 3.3 2 4.8 3.1c18.4 12.7 39.6 20.3 59.2 20.3c19 0 41.2-7.9 59.2-20.3c23.8-16.7 55.8-15.3 78.1 3.4c10.6 8.8 24.2 15.6 37.3 18.6c5.8 1.4 11.2 3.4 16.2 6.2c.7-2.7 1.1-5.5 1.1-8.4l-.4-144c0-10-4.7-19.4-12.7-25.5l-95.5-72c-11.4-8.6-27.1-8.6-38.5 0l-96 72zM384 448c-27.5 0-55-10.6-77.5-26.1c-11.1-7.9-25.9-7.9-37 0C247 437.4 219.5 448 192 448c-26.9 0-55.3-10.8-77.4-26.1l0 0c-11.9-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C126.5 501.7 159 512 192 512c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.4-27.3-10.1-39.2-1.7l0 0C439.4 437.2 410.9 448 384 448z"
    ]
};
var $d8206b3ab2e65c05$export$5498258519fc5b72 = {
    prefix: "fas",
    iconName: "square-nfi",
    icon: [
        448,
        512,
        [],
        "e576",
        "M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm75.7 64.6C68.8 162.5 64 168.8 64 176V336c0 8.8 7.2 16 16 16s16-7.2 16-16V233.8l66.3 110.5c3.7 6.2 11.1 9.1 18 7.2s11.7-8.2 11.7-15.4V176c0-8.8-7.2-16-16-16s-16 7.2-16 16V278.2L93.7 167.8c-3.7-6.2-11.1-9.1-18-7.2zM224 176v64 96c0 8.8 7.2 16 16 16s16-7.2 16-16V256h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H256V192h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H240c-8.8 0-16 7.2-16 16zm160 0c0-8.8-7.2-16-16-16s-16 7.2-16 16V336c0 8.8 7.2 16 16 16s16-7.2 16-16V176z"
    ]
};
var $d8206b3ab2e65c05$export$cbe485a104805f4f = {
    prefix: "fas",
    iconName: "arrow-up-from-ground-water",
    icon: [
        576,
        512,
        [],
        "e4b5",
        "M288 352c17.7 0 32-14.3 32-32V109.3l25.4 25.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-80-80c-12.5-12.5-32.8-12.5-45.3 0l-80 80c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L256 109.3V320c0 17.7 14.3 32 32 32zm-18.5 69.9C247 437.4 219.5 448 192 448c-26.9 0-55.3-10.8-77.4-26.1l0 0c-11.9-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C126.5 501.7 159 512 192 512c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.4-27.3-10.1-39.2-1.7l0 0C439.4 437.2 410.9 448 384 448c-27.5 0-55-10.6-77.5-26.1c-11.1-7.9-25.9-7.9-37 0zM192 192H48c-26.5 0-48 21.5-48 48V425c5.3-3.1 11.2-5.4 17.5-6.9c13.1-3.1 26.7-9.8 37.3-18.6c22.2-18.7 54.3-20.1 78.1-3.4c18 12.4 40.1 20.3 59.1 20.3V192zm384 48c0-26.5-21.5-48-48-48H384V416.5h0c19 0 41.2-7.9 59.2-20.3c23.8-16.7 55.8-15.3 78.1 3.4c10.6 8.8 24.2 15.6 37.3 18.6c6.3 1.5 12.1 3.8 17.5 6.9V240z"
    ]
};
var $d8206b3ab2e65c05$export$98401bb29cff68e0 = {
    prefix: "fas",
    iconName: "martini-glass",
    icon: [
        512,
        512,
        [
            127864,
            "glass-martini-alt"
        ],
        "f57b",
        "M32 0C19.1 0 7.4 7.8 2.4 19.8s-2.2 25.7 6.9 34.9L224 269.3V448H160c-17.7 0-32 14.3-32 32s14.3 32 32 32h96 96c17.7 0 32-14.3 32-32s-14.3-32-32-32H288V269.3L502.6 54.6c9.2-9.2 11.9-22.9 6.9-34.9S492.9 0 480 0H32zM173.3 128l-64-64H402.7l-64 64H173.3z"
    ]
};
var $d8206b3ab2e65c05$export$2258439b8f4e7acb = $d8206b3ab2e65c05$export$98401bb29cff68e0;
var $d8206b3ab2e65c05$export$7adaa412bd8eb08f = {
    prefix: "fas",
    iconName: "rotate-left",
    icon: [
        512,
        512,
        [
            "rotate-back",
            "rotate-backward",
            "undo-alt"
        ],
        "f2ea",
        "M48.5 224H40c-13.3 0-24-10.7-24-24V72c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2L98.6 96.6c87.6-86.5 228.7-86.2 315.8 1c87.5 87.5 87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3c-62.2-62.2-162.7-62.5-225.3-1L185 183c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8H48.5z"
    ]
};
var $d8206b3ab2e65c05$export$9706706f1bc7b12 = $d8206b3ab2e65c05$export$7adaa412bd8eb08f;
var $d8206b3ab2e65c05$export$4ceb0b05fed961a9 = $d8206b3ab2e65c05$export$7adaa412bd8eb08f;
var $d8206b3ab2e65c05$export$c8197b992c46c4a6 = $d8206b3ab2e65c05$export$7adaa412bd8eb08f;
var $d8206b3ab2e65c05$export$ccaa019a3fd4563f = {
    prefix: "fas",
    iconName: "table-columns",
    icon: [
        512,
        512,
        [
            "columns"
        ],
        "f0db",
        "M0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm64 64V416H224V160H64zm384 0H288V416H448V160z"
    ]
};
var $d8206b3ab2e65c05$export$bb861166644ac28a = $d8206b3ab2e65c05$export$ccaa019a3fd4563f;
var $d8206b3ab2e65c05$export$4fbda8f64648f3b5 = {
    prefix: "fas",
    iconName: "lemon",
    icon: [
        448,
        512,
        [
            127819
        ],
        "f094",
        "M448 96c0-35.3-28.7-64-64-64c-6.6 0-13 1-19 2.9c-22.5 7-48.1 14.9-71 9c-75.2-19.1-156.4 11-213.7 68.3S-7.2 250.8 11.9 326c5.8 22.9-2 48.4-9 71C1 403 0 409.4 0 416c0 35.3 28.7 64 64 64c6.6 0 13-1 19.1-2.9c22.5-7 48.1-14.9 71-9c75.2 19.1 156.4-11 213.7-68.3s87.5-138.5 68.3-213.7c-5.8-22.9 2-48.4 9-71c1.9-6 2.9-12.4 2.9-19.1zM212.5 127.4c-54.6 16-101.1 62.5-117.1 117.1C92.9 253 84 257.8 75.5 255.4S62.2 244 64.6 235.5c19.1-65.1 73.7-119.8 138.9-138.9c8.5-2.5 17.4 2.4 19.9 10.9s-2.4 17.4-10.9 19.9z"
    ]
};
var $d8206b3ab2e65c05$export$280300af4baa1a3e = {
    prefix: "fas",
    iconName: "head-side-mask",
    icon: [
        576,
        512,
        [],
        "e063",
        "M32 224.2c0-22.2 3.2-43.6 9.2-63.9L262.2 321c-4 9.5-6.2 20-6.2 31V512H128c-17.7 0-32-14.3-32-32V407.3c0-16.7-6.9-32.5-17.1-45.8C48.6 322.4 32 274.1 32 224.2zm248.3 70.4L53 129.3C88.7 53 166.2 0 256 0h24c95.2 0 181.2 69.3 197.3 160.2c2.3 13 6.8 25.7 15.1 36l42 52.6c5.4 6.7 8.6 14.8 9.4 23.2H336c-21.7 0-41.3 8.6-55.7 22.6zM336 304H534l0 0h10l-19.7 64H368c-8.8 0-16 7.2-16 16s7.2 16 16 16H514.5l-9.8 32H368c-8.8 0-16 7.2-16 16s7.2 16 16 16H494.8l-.9 2.8c-8.3 26.9-33.1 45.2-61.2 45.2H288V352c0-14 6-26.7 15.6-35.4c0 0 0 0 0 0c8.5-7.8 19.9-12.6 32.4-12.6zm48-80a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
var $d8206b3ab2e65c05$export$b4c63e9bfc7906f1 = {
    prefix: "fas",
    iconName: "handshake",
    icon: [
        640,
        512,
        [],
        "f2b5",
        "M323.4 85.2l-96.8 78.4c-16.1 13-19.2 36.4-7 53.1c12.9 17.8 38 21.3 55.3 7.8l99.3-77.2c7-5.4 17-4.2 22.5 2.8s4.2 17-2.8 22.5l-20.9 16.2L512 316.8V128h-.7l-3.9-2.5L434.8 79c-15.3-9.8-33.2-15-51.4-15c-21.8 0-43 7.5-60 21.2zm22.8 124.4l-51.7 40.2C263 274.4 217.3 268 193.7 235.6c-22.2-30.5-16.6-73.1 12.7-96.8l83.2-67.3c-11.6-4.9-24.1-7.4-36.8-7.4C234 64 215.7 69.6 200 80l-72 48V352h28.2l91.4 83.4c19.6 17.9 49.9 16.5 67.8-3.1c5.5-6.1 9.2-13.2 11.1-20.6l17 15.6c19.5 17.9 49.9 16.6 67.8-2.9c4.5-4.9 7.8-10.6 9.9-16.5c19.4 13 45.8 10.3 62.1-7.5c17.9-19.5 16.6-49.9-2.9-67.8l-134.2-123zM16 128c-8.8 0-16 7.2-16 16V352c0 17.7 14.3 32 32 32H64c17.7 0 32-14.3 32-32V128H16zM48 320a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM544 128V352c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V144c0-8.8-7.2-16-16-16H544zm32 208a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"
    ]
};
var $d8206b3ab2e65c05$export$31ee86ac717db552 = {
    prefix: "fas",
    iconName: "gem",
    icon: [
        512,
        512,
        [
            128142
        ],
        "f3a5",
        "M116.7 33.8c4.5-6.1 11.7-9.8 19.3-9.8H376c7.6 0 14.8 3.6 19.3 9.8l112 152c6.8 9.2 6.1 21.9-1.5 30.4l-232 256c-4.5 5-11 7.9-17.8 7.9s-13.2-2.9-17.8-7.9l-232-256c-7.7-8.5-8.3-21.2-1.5-30.4l112-152zm38.5 39.8c-3.3 2.5-4.2 7-2.1 10.5l57.4 95.6L63.3 192c-4.1 .3-7.3 3.8-7.3 8s3.2 7.6 7.3 8l192 16c.4 0 .9 0 1.3 0l192-16c4.1-.3 7.3-3.8 7.3-8s-3.2-7.6-7.3-8L301.5 179.8l57.4-95.6c2.1-3.5 1.2-8.1-2.1-10.5s-7.9-2-10.7 1L256 172.2 165.9 74.6c-2.8-3-7.4-3.4-10.7-1z"
    ]
};
var $d8206b3ab2e65c05$export$5879d0bca1aa497b = {
    prefix: "fas",
    iconName: "dolly",
    icon: [
        576,
        512,
        [
            "dolly-box"
        ],
        "f472",
        "M0 32C0 14.3 14.3 0 32 0h72.9c27.5 0 52 17.6 60.7 43.8L257.7 320c30.1 .5 56.8 14.9 74 37l202.1-67.4c16.8-5.6 34.9 3.5 40.5 20.2s-3.5 34.9-20.2 40.5L352 417.7c-.9 52.2-43.5 94.3-96 94.3c-53 0-96-43-96-96c0-30.8 14.5-58.2 37-75.8L104.9 64H32C14.3 64 0 49.7 0 32zM244.8 134.5c-5.5-16.8 3.7-34.9 20.5-40.3L311 79.4l19.8 60.9 60.9-19.8L371.8 59.6l45.7-14.8c16.8-5.5 34.9 3.7 40.3 20.5l49.4 152.2c5.5 16.8-3.7 34.9-20.5 40.3L334.5 307.2c-16.8 5.5-34.9-3.7-40.3-20.5L244.8 134.5z"
    ]
};
var $d8206b3ab2e65c05$export$461bbb9e92cc531b = $d8206b3ab2e65c05$export$5879d0bca1aa497b;
var $d8206b3ab2e65c05$export$c4ab83701fc591a5 = {
    prefix: "fas",
    iconName: "smoking",
    icon: [
        640,
        512,
        [
            128684
        ],
        "f48d",
        "M448 32V43c0 38.2 15.2 74.8 42.2 101.8l21 21c21 21 32.8 49.5 32.8 79.2v11c0 17.7-14.3 32-32 32s-32-14.3-32-32V245c0-12.7-5.1-24.9-14.1-33.9l-21-21C405.9 151.1 384 98.1 384 43V32c0-17.7 14.3-32 32-32s32 14.3 32 32zM576 256V245c0-38.2-15.2-74.8-42.2-101.8l-21-21c-21-21-32.8-49.5-32.8-79.2V32c0-17.7 14.3-32 32-32s32 14.3 32 32V43c0 12.7 5.1 24.9 14.1 33.9l21 21c39 39 60.9 91.9 60.9 147.1v11c0 17.7-14.3 32-32 32s-32-14.3-32-32zM0 416c0-35.3 28.7-64 64-64H416c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H64c-35.3 0-64-28.7-64-64V416zm224 0v32H384V416H224zm288-64c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V384c0-17.7 14.3-32 32-32zm96 0c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V384c0-17.7 14.3-32 32-32z"
    ]
};
var $d8206b3ab2e65c05$export$e0601b1f239fec74 = {
    prefix: "fas",
    iconName: "minimize",
    icon: [
        512,
        512,
        [
            "compress-arrows-alt"
        ],
        "f78c",
        "M456 224H312c-13.3 0-24-10.7-24-24V56c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2l40 40L442.3 5.7C446 2 450.9 0 456 0s10 2 13.7 5.7l36.7 36.7C510 46 512 50.9 512 56s-2 10-5.7 13.7L433 143l40 40c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8zm0 64c9.7 0 18.5 5.8 22.2 14.8s1.7 19.3-5.2 26.2l-40 40 73.4 73.4c3.6 3.6 5.7 8.5 5.7 13.7s-2 10-5.7 13.7l-36.7 36.7C466 510 461.1 512 456 512s-10-2-13.7-5.7L369 433l-40 40c-6.9 6.9-17.2 8.9-26.2 5.2s-14.8-12.5-14.8-22.2V312c0-13.3 10.7-24 24-24H456zm-256 0c13.3 0 24 10.7 24 24V456c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-40-40L69.7 506.3C66 510 61.1 512 56 512s-10-2-13.7-5.7L5.7 469.7C2 466 0 461.1 0 456s2-10 5.7-13.7L79 369 39 329c-6.9-6.9-8.9-17.2-5.2-26.2s12.5-14.8 22.2-14.8H200zM56 224c-9.7 0-18.5-5.8-22.2-14.8s-1.7-19.3 5.2-26.2l40-40L5.7 69.7C2 66 0 61.1 0 56s2-10 5.7-13.7L42.3 5.7C46 2 50.9 0 56 0s10 2 13.7 5.7L143 79l40-40c6.9-6.9 17.2-8.9 26.2-5.2s14.8 12.5 14.8 22.2V200c0 13.3-10.7 24-24 24H56z"
    ]
};
var $d8206b3ab2e65c05$export$39205db0ea980efd = $d8206b3ab2e65c05$export$e0601b1f239fec74;
var $d8206b3ab2e65c05$export$6f9b0bfc012deb25 = {
    prefix: "fas",
    iconName: "monument",
    icon: [
        384,
        512,
        [],
        "f5a6",
        "M180.7 4.7c6.2-6.2 16.4-6.2 22.6 0l80 80c2.5 2.5 4.1 5.8 4.6 9.3l40.2 322H55.9L96.1 94c.4-3.5 2-6.8 4.6-9.3l80-80zM152 272c-13.3 0-24 10.7-24 24s10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24H152zM32 448H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
    ]
};
var $d8206b3ab2e65c05$export$695fae58f55c3a87 = {
    prefix: "fas",
    iconName: "snowplow",
    icon: [
        640,
        512,
        [],
        "f7d2",
        "M298.9 64l68.6 160H256l-64-64V64H298.9zM445.1 242.7l-87.4-204C347.6 15.3 324.5 0 298.9 0H176c-26.5 0-48 21.5-48 48V160H96c-17.7 0-32 14.3-32 32V298.8C26.2 316.8 0 355.3 0 400c0 61.9 50.1 112 112 112H368c61.9 0 112-50.1 112-112c0-17.2-3.9-33.5-10.8-48H512v50.7c0 17 6.7 33.3 18.7 45.3l54.6 54.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L576 402.7V320 235.2L633 164c11-13.8 8.8-33.9-5-45s-33.9-8.8-45 5l-57 71.2c-9.1 11.3-14 25.4-14 40V288H448V256.7c.1-2.4-.2-4.8-.6-7.1s-1.2-4.7-2.2-6.8zM368 352c26.5 0 48 21.5 48 48s-21.5 48-48 48H112c-26.5 0-48-21.5-48-48s21.5-48 48-48H368zM144 400a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm216 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-56-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM200 424a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
    ]
};
var $d8206b3ab2e65c05$export$48b60f1720e09944 = {
    prefix: "fas",
    iconName: "angles-right",
    icon: [
        512,
        512,
        [
            187,
            "angle-double-right"
        ],
        "f101",
        "M470.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 256 265.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160zm-352 160l160-160c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L210.7 256 73.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0z"
    ]
};
var $d8206b3ab2e65c05$export$792931403404faf0 = $d8206b3ab2e65c05$export$48b60f1720e09944;
var $d8206b3ab2e65c05$export$8ec2f752344b69bd = {
    prefix: "fas",
    iconName: "cannabis",
    icon: [
        512,
        512,
        [],
        "f55f",
        "M256 0c5.3 0 10.3 2.7 13.3 7.1c15.8 23.5 36.7 63.7 49.2 109c7.2 26.4 11.8 55.2 10.4 84c11.5-8.8 23.7-16.7 35.8-23.6c41-23.3 84.4-36.9 112.2-42.5c5.2-1 10.7 .6 14.4 4.4s5.4 9.2 4.4 14.5c-5.6 27.7-19.3 70.9-42.7 111.7c-9.1 15.9-19.9 31.7-32.4 46.3c27.8 6.6 52.4 17.3 67.2 25.5c5.1 2.8 8.2 8.2 8.2 14s-3.2 11.2-8.2 14c-15.2 8.4-40.9 19.5-69.8 26.1c-20.2 4.6-42.9 7.2-65.2 4.6l8.3 33.1c1.5 6.1-.6 12.4-5.5 16.4s-11.6 4.6-17.2 1.9L280 417.2V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V417.2l-58.5 29.1c-5.6 2.8-12.3 2.1-17.2-1.9s-7-10.3-5.5-16.4l8.3-33.1c-22.2 2.6-45 0-65.2-4.6c-28.9-6.6-54.6-17.6-69.8-26.1c-5.1-2.8-8.2-8.2-8.2-14s3.2-11.2 8.2-14c14.8-8.2 39.4-18.8 67.2-25.5C78.9 296.3 68.1 280.5 59 264.6c-23.4-40.8-37.1-84-42.7-111.7c-1.1-5.2 .6-10.7 4.4-14.5s9.2-5.4 14.4-4.4c27.9 5.5 71.2 19.2 112.2 42.5c12.1 6.9 24.3 14.7 35.8 23.6c-1.4-28.7 3.1-57.6 10.4-84c12.5-45.3 33.4-85.5 49.2-109c3-4.4 8-7.1 13.3-7.1z"
    ]
};
var $d8206b3ab2e65c05$export$86c4e45dc3302d15 = {
    prefix: "fas",
    iconName: "circle-play",
    icon: [
        512,
        512,
        [
            61469,
            "play-circle"
        ],
        "f144",
        "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM188.3 147.1c-7.6 4.2-12.3 12.3-12.3 20.9V344c0 8.7 4.7 16.7 12.3 20.9s16.8 4.1 24.3-.5l144-88c7.1-4.4 11.5-12.1 11.5-20.5s-4.4-16.1-11.5-20.5l-144-88c-7.4-4.5-16.7-4.7-24.3-.5z"
    ]
};
var $d8206b3ab2e65c05$export$cf04333781061c5e = $d8206b3ab2e65c05$export$86c4e45dc3302d15;
var $d8206b3ab2e65c05$export$bed2b0ed4ae45e0d = {
    prefix: "fas",
    iconName: "tablets",
    icon: [
        640,
        512,
        [],
        "f490",
        "M614.3 247c16.3-25 25.7-54.9 25.7-87C640 71.6 568.4 0 480 0c-32.1 0-61.9 9.4-87 25.7c-7.9 5.2-8.5 16.2-1.8 22.9L591.4 248.8c6.7 6.7 17.8 6.2 22.9-1.8zM567 294.3c7.9-5.2 8.5-16.2 1.8-22.9L368.6 71.2c-6.7-6.7-17.8-6.2-22.9 1.8c-16.3 25-25.7 54.9-25.7 87c0 88.4 71.6 160 160 160c32.1 0 61.9-9.4 87-25.7zM301.5 368H18.5c-9.5 0-16.9 8.2-15 17.5C18.9 457.8 83.1 512 160 512s141.1-54.2 156.5-126.5c2-9.3-5.5-17.5-15-17.5zm0-32c9.5 0 16.9-8.2 15-17.5C301.1 246.2 236.9 192 160 192S18.9 246.2 3.5 318.5c-2 9.3 5.5 17.5 15 17.5H301.5z"
    ]
};
var $d8206b3ab2e65c05$export$6bad2c9f317b52e5 = {
    prefix: "fas",
    iconName: "ethernet",
    icon: [
        512,
        512,
        [],
        "f796",
        "M0 224V416c0 17.7 14.3 32 32 32H96V336c0-8.8 7.2-16 16-16s16 7.2 16 16V448h64V336c0-8.8 7.2-16 16-16s16 7.2 16 16V448h64V336c0-8.8 7.2-16 16-16s16 7.2 16 16V448h64V336c0-8.8 7.2-16 16-16s16 7.2 16 16V448h64c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32H448V160c0-17.7-14.3-32-32-32H384V96c0-17.7-14.3-32-32-32H160c-17.7 0-32 14.3-32 32v32H96c-17.7 0-32 14.3-32 32v32H32c-17.7 0-32 14.3-32 32z"
    ]
};
var $d8206b3ab2e65c05$export$902a3969bb113dff = {
    prefix: "fas",
    iconName: "euro-sign",
    icon: [
        320,
        512,
        [
            8364,
            "eur",
            "euro"
        ],
        "f153",
        "M48.1 240c-.1 2.7-.1 5.3-.1 8v16c0 2.7 0 5.3 .1 8H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H60.3C89.9 419.9 170 480 264 480h24c17.7 0 32-14.3 32-32s-14.3-32-32-32H264c-57.9 0-108.2-32.4-133.9-80H256c17.7 0 32-14.3 32-32s-14.3-32-32-32H112.2c-.1-2.6-.2-5.3-.2-8V248c0-2.7 .1-5.4 .2-8H256c17.7 0 32-14.3 32-32s-14.3-32-32-32H130.1c25.7-47.6 76-80 133.9-80h24c17.7 0 32-14.3 32-32s-14.3-32-32-32H264C170 32 89.9 92.1 60.3 176H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H48.1z"
    ]
};
var $d8206b3ab2e65c05$export$4b859160cfeb12ff = $d8206b3ab2e65c05$export$902a3969bb113dff;
var $d8206b3ab2e65c05$export$bdabbefede2d3a2 = $d8206b3ab2e65c05$export$902a3969bb113dff;
var $d8206b3ab2e65c05$export$a339864ee3df7e9a = {
    prefix: "fas",
    iconName: "chair",
    icon: [
        448,
        512,
        [
            129681
        ],
        "f6c0",
        "M248 48V256h48V58.7c23.9 13.8 40 39.7 40 69.3V256h48V128C384 57.3 326.7 0 256 0H192C121.3 0 64 57.3 64 128V256h48V128c0-29.6 16.1-55.5 40-69.3V256h48V48h48zM48 288c-12.1 0-23.2 6.8-28.6 17.7l-16 32c-5 9.9-4.4 21.7 1.4 31.1S20.9 384 32 384l0 96c0 17.7 14.3 32 32 32s32-14.3 32-32V384H352v96c0 17.7 14.3 32 32 32s32-14.3 32-32V384c11.1 0 21.4-5.7 27.2-15.2s6.4-21.2 1.4-31.1l-16-32C423.2 294.8 412.1 288 400 288H48z"
    ]
};
var $d8206b3ab2e65c05$export$c2e9877668862374 = {
    prefix: "fas",
    iconName: "circle-check",
    icon: [
        512,
        512,
        [
            61533,
            "check-circle"
        ],
        "f058",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"
    ]
};
var $d8206b3ab2e65c05$export$be9e388158c74f29 = $d8206b3ab2e65c05$export$c2e9877668862374;
var $d8206b3ab2e65c05$export$229de76dfef2687f = {
    prefix: "fas",
    iconName: "circle-stop",
    icon: [
        512,
        512,
        [
            62094,
            "stop-circle"
        ],
        "f28d",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM192 160H320c17.7 0 32 14.3 32 32V320c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V192c0-17.7 14.3-32 32-32z"
    ]
};
var $d8206b3ab2e65c05$export$47af2aad60ab3e7c = $d8206b3ab2e65c05$export$229de76dfef2687f;
var $d8206b3ab2e65c05$export$aaaddd2cf7e20f64 = {
    prefix: "fas",
    iconName: "compass-drafting",
    icon: [
        512,
        512,
        [
            "drafting-compass"
        ],
        "f568",
        "M352 96c0 14.3-3.1 27.9-8.8 40.2L396 227.4c-23.7 25.3-54.2 44.1-88.5 53.6L256 192h0 0l-68 117.5c21.5 6.8 44.3 10.5 68.1 10.5c70.7 0 133.8-32.7 174.9-84c11.1-13.8 31.2-16 45-5s16 31.2 5 45C428.1 341.8 347 384 256 384c-35.4 0-69.4-6.4-100.7-18.1L98.7 463.7C94 471.8 87 478.4 78.6 482.6L23.2 510.3c-5 2.5-10.9 2.2-15.6-.7S0 501.5 0 496V440.6c0-8.4 2.2-16.7 6.5-24.1l60-103.7C53.7 301.6 41.8 289.3 31.2 276c-11.1-13.8-8.8-33.9 5-45s33.9-8.8 45 5c5.7 7.1 11.8 13.8 18.2 20.1l69.4-119.9c-5.6-12.2-8.8-25.8-8.8-40.2c0-53 43-96 96-96s96 43 96 96zm21 297.9c32.6-12.8 62.5-30.8 88.9-52.9l43.7 75.5c4.2 7.3 6.5 15.6 6.5 24.1V496c0 5.5-2.9 10.7-7.6 13.6s-10.6 3.2-15.6 .7l-55.4-27.7c-8.4-4.2-15.4-10.8-20.1-18.9L373 393.9zM256 128a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
var $d8206b3ab2e65c05$export$c8c2b127d13b9d79 = $d8206b3ab2e65c05$export$aaaddd2cf7e20f64;
var $d8206b3ab2e65c05$export$2eff9f6cbe00a643 = {
    prefix: "fas",
    iconName: "plate-wheat",
    icon: [
        512,
        512,
        [],
        "e55a",
        "M176 32c44.2 0 80 35.8 80 80v16c0 8.8-7.2 16-16 16c-44.2 0-80-35.8-80-80V48c0-8.8 7.2-16 16-16zM56 64h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H56c-13.3 0-24-10.7-24-24s10.7-24 24-24zM24 136H136c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24zm8 96c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H56c-13.3 0-24-10.7-24-24zM272 48c0-8.8 7.2-16 16-16c44.2 0 80 35.8 80 80v16c0 8.8-7.2 16-16 16c-44.2 0-80-35.8-80-80V48zM400 32c44.2 0 80 35.8 80 80v16c0 8.8-7.2 16-16 16c-44.2 0-80-35.8-80-80V48c0-8.8 7.2-16 16-16zm80 160v16c0 44.2-35.8 80-80 80c-8.8 0-16-7.2-16-16V256c0-44.2 35.8-80 80-80c8.8 0 16 7.2 16 16zM352 176c8.8 0 16 7.2 16 16v16c0 44.2-35.8 80-80 80c-8.8 0-16-7.2-16-16V256c0-44.2 35.8-80 80-80zm-96 16v16c0 44.2-35.8 80-80 80c-8.8 0-16-7.2-16-16V256c0-44.2 35.8-80 80-80c8.8 0 16 7.2 16 16zM3.5 347.6C1.6 332.9 13 320 27.8 320H484.2c14.8 0 26.2 12.9 24.4 27.6C502.3 397.8 464.2 437 416 446v2c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32v-2c-48.2-9-86.3-48.2-92.5-98.4z"
    ]
};
var $d8206b3ab2e65c05$export$78792ed87d92a3ad = {
    prefix: "fas",
    iconName: "icicles",
    icon: [
        512,
        512,
        [],
        "f7ad",
        "M75.8 304.8L1 35.7c-.7-2.5-1-5-1-7.5C0 12.6 12.6 0 28.2 0H482.4C498.8 0 512 13.2 512 29.6c0 1.6-.1 3.3-.4 4.9L434.6 496.1c-1.5 9.2-9.5 15.9-18.8 15.9c-9.2 0-17.1-6.6-18.7-15.6L336 160 307.2 303.9c-1.9 9.3-10.1 16.1-19.6 16.1c-9.2 0-17.2-6.2-19.4-15.1L240 192 210.6 368.2c-1.5 9.1-9.4 15.8-18.6 15.8s-17.1-6.7-18.6-15.8L144 192 115.9 304.3c-2.3 9.2-10.6 15.7-20.1 15.7c-9.3 0-17.5-6.2-20-15.2z"
    ]
};
var $d8206b3ab2e65c05$export$d359c2cc7640953c = {
    prefix: "fas",
    iconName: "person-shelter",
    icon: [
        512,
        512,
        [],
        "e54f",
        "M271.9 4.2c-9.8-5.6-21.9-5.6-31.8 0l-224 128C6.2 137.9 0 148.5 0 160V480c0 17.7 14.3 32 32 32s32-14.3 32-32V178.6L256 68.9 448 178.6V480c0 17.7 14.3 32 32 32s32-14.3 32-32V160c0-11.5-6.2-22.1-16.1-27.8l-224-128zM256 208a40 40 0 1 0 0-80 40 40 0 1 0 0 80zm-8 280V400h16v88c0 13.3 10.7 24 24 24s24-10.7 24-24V313.5l26.9 49.9c6.3 11.7 20.8 16 32.5 9.8s16-20.8 9.8-32.5l-37.9-70.3c-15.3-28.5-45.1-46.3-77.5-46.3H246.2c-32.4 0-62.1 17.8-77.5 46.3l-37.9 70.3c-6.3 11.7-1.9 26.2 9.8 32.5s26.2 1.9 32.5-9.8L200 313.5V488c0 13.3 10.7 24 24 24s24-10.7 24-24z"
    ]
};
var $d8206b3ab2e65c05$export$771cf879fba0cf93 = {
    prefix: "fas",
    iconName: "neuter",
    icon: [
        384,
        512,
        [
            9906
        ],
        "f22c",
        "M80 176a112 112 0 1 1 224 0A112 112 0 1 1 80 176zM224 349.1c81.9-15 144-86.8 144-173.1C368 78.8 289.2 0 192 0S16 78.8 16 176c0 86.3 62.1 158.1 144 173.1V480c0 17.7 14.3 32 32 32s32-14.3 32-32V349.1z"
    ]
};
var $d8206b3ab2e65c05$export$a75288855ea05282 = {
    prefix: "fas",
    iconName: "id-badge",
    icon: [
        384,
        512,
        [],
        "f2c1",
        "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm96 320h64c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80zm-32-96a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM144 64h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
    ]
};
var $d8206b3ab2e65c05$export$e6789173649caa25 = {
    prefix: "fas",
    iconName: "marker",
    icon: [
        512,
        512,
        [],
        "f5a1",
        "M481 31C445.1-4.8 386.9-4.8 351 31l-15 15L322.9 33C294.8 4.9 249.2 4.9 221.1 33L135 119c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L255 66.9c9.4-9.4 24.6-9.4 33.9 0L302.1 80 186.3 195.7 316.3 325.7 481 161c35.9-35.9 35.9-94.1 0-129.9zM293.7 348.3L163.7 218.3 99.5 282.5c-48 48-80.8 109.2-94.1 175.8l-5 25c-1.6 7.9 .9 16 6.6 21.7s13.8 8.1 21.7 6.6l25-5c66.6-13.3 127.8-46.1 175.8-94.1l64.2-64.2z"
    ]
};
var $d8206b3ab2e65c05$export$3f2d51c0547bf984 = {
    prefix: "fas",
    iconName: "face-laugh-beam",
    icon: [
        512,
        512,
        [
            128513,
            "laugh-beam"
        ],
        "f59a",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM96.8 314.1c-3.8-13.7 7.4-26.1 21.6-26.1H393.6c14.2 0 25.5 12.4 21.6 26.1C396.2 382 332.1 432 256 432s-140.2-50-159.2-117.9zM217.6 212.8l0 0 0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0zm160 0l0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0 0 0z"
    ]
};
var $d8206b3ab2e65c05$export$a88d1f4073ea9369 = $d8206b3ab2e65c05$export$3f2d51c0547bf984;
var $d8206b3ab2e65c05$export$2a66e6044c1f7036 = {
    prefix: "fas",
    iconName: "helicopter-symbol",
    icon: [
        512,
        512,
        [],
        "e502",
        "M445.3 224H510C495.6 108.2 403.8 16.4 288 2V66.7C368.4 80.1 431.9 143.6 445.3 224zM510 288H445.3C431.9 368.4 368.4 431.9 288 445.4V510c115.8-14.4 207.6-106.2 222-222zM2 288C16.4 403.8 108.2 495.6 224 510V445.4C143.6 431.9 80.1 368.4 66.7 288H2zm0-64H66.7C80.1 143.6 143.6 80.1 224 66.7V2C108.2 16.4 16.4 108.2 2 224zm206-64c0-17.7-14.3-32-32-32s-32 14.3-32 32V352c0 17.7 14.3 32 32 32s32-14.3 32-32V288h96v64c0 17.7 14.3 32 32 32s32-14.3 32-32V160c0-17.7-14.3-32-32-32s-32 14.3-32 32v64H208V160z"
    ]
};
var $d8206b3ab2e65c05$export$e119aada7f690d05 = {
    prefix: "fas",
    iconName: "universal-access",
    icon: [
        512,
        512,
        [],
        "f29a",
        "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm161.5-86.1c-12.2-5.2-26.3 .4-31.5 12.6s.4 26.3 12.6 31.5l11.9 5.1c17.3 7.4 35.2 12.9 53.6 16.3v50.1c0 4.3-.7 8.6-2.1 12.6l-28.7 86.1c-4.2 12.6 2.6 26.2 15.2 30.4s26.2-2.6 30.4-15.2l24.4-73.2c1.3-3.8 4.8-6.4 8.8-6.4s7.6 2.6 8.8 6.4l24.4 73.2c4.2 12.6 17.8 19.4 30.4 15.2s19.4-17.8 15.2-30.4l-28.7-86.1c-1.4-4.1-2.1-8.3-2.1-12.6V235.5c18.4-3.5 36.3-8.9 53.6-16.3l11.9-5.1c12.2-5.2 17.8-19.3 12.6-31.5s-19.3-17.8-31.5-12.6L338.7 175c-26.1 11.2-54.2 17-82.7 17s-56.5-5.8-82.7-17l-11.9-5.1zM256 160a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"
    ]
};
var $d8206b3ab2e65c05$export$7b69b3617b84259b = {
    prefix: "fas",
    iconName: "circle-chevron-up",
    icon: [
        512,
        512,
        [
            "chevron-circle-up"
        ],
        "f139",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM377 271c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-87-87-87 87c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L239 167c9.4-9.4 24.6-9.4 33.9 0L377 271z"
    ]
};
var $d8206b3ab2e65c05$export$b786cf5db03f2c36 = $d8206b3ab2e65c05$export$7b69b3617b84259b;
var $d8206b3ab2e65c05$export$d317bc452442782d = {
    prefix: "fas",
    iconName: "lari-sign",
    icon: [
        384,
        512,
        [],
        "e1c8",
        "M144 32c17.7 0 32 14.3 32 32V96.7c5.3-.4 10.6-.7 16-.7s10.7 .2 16 .7V64c0-17.7 14.3-32 32-32s32 14.3 32 32v49.4c54.9 25.2 95.8 75.5 108.2 136.2c3.5 17.3-7.7 34.2-25 37.7s-34.2-7.7-37.7-25c-6.1-29.9-22.5-55.9-45.4-74.3V256c0 17.7-14.3 32-32 32s-32-14.3-32-32V161c-5.2-.7-10.6-1-16-1s-10.8 .3-16 1v95c0 17.7-14.3 32-32 32s-32-14.3-32-32V188.1C82.7 211.5 64 247.6 64 288c0 70.7 57.3 128 128 128H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H192 32c-17.7 0-32-14.3-32-32s14.3-32 32-32H48.9C18.5 382 0 337.2 0 288c0-77.5 45.9-144.3 112-174.6V64c0-17.7 14.3-32 32-32z"
    ]
};
var $d8206b3ab2e65c05$export$bae30a76735500e1 = {
    prefix: "fas",
    iconName: "volcano",
    icon: [
        512,
        512,
        [
            127755
        ],
        "f770",
        "M160 144c-35.3 0-64-28.7-64-64s28.7-64 64-64c15.7 0 30 5.6 41.2 15C212.4 12.4 232.7 0 256 0s43.6 12.4 54.8 31C322 21.6 336.3 16 352 16c35.3 0 64 28.7 64 64s-28.7 64-64 64c-14.7 0-28.3-5-39.1-13.3l-32 48C275.3 187 266 192 256 192s-19.3-5-24.9-13.3l-32-48C188.3 139 174.7 144 160 144zM144 352l48.4-24.2c10.2-5.1 21.6-7.8 33-7.8c19.6 0 38.4 7.8 52.2 21.6l32.5 32.5c6.3 6.3 14.9 9.9 23.8 9.9c11.3 0 21.8-5.6 28-15l9.7-14.6-58.9-66.3c-9.1-10.2-22.2-16.1-35.9-16.1H235.1c-13.7 0-26.8 5.9-35.9 16.1l-59.9 67.4L144 352zm19.4-95.8c18.2-20.5 44.3-32.2 71.8-32.2h41.8c27.4 0 53.5 11.7 71.8 32.2l150.2 169c8.5 9.5 13.2 21.9 13.2 34.7c0 28.8-23.4 52.2-52.2 52.2H52.2C23.4 512 0 488.6 0 459.8c0-12.8 4.7-25.1 13.2-34.7l150.2-169z"
    ]
};
var $d8206b3ab2e65c05$export$a1d09c95bee8043b = {
    prefix: "fas",
    iconName: "person-walking-dashed-line-arrow-right",
    icon: [
        640,
        512,
        [],
        "e553",
        "M208 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM123.7 200.5c1-.4 1.9-.8 2.9-1.2l-16.9 63.5c-5.6 21.1-.1 43.6 14.7 59.7l70.7 77.1 22 88.1c4.3 17.1 21.7 27.6 38.8 23.3s27.6-21.7 23.3-38.8l-23-92.1c-1.9-7.8-5.8-14.9-11.2-20.8l-49.5-54 19.3-65.5 9.6 23c4.4 10.6 12.5 19.3 22.8 24.5l26.7 13.3c15.8 7.9 35 1.5 42.9-14.3s1.5-35-14.3-42.9L281 232.7l-15.3-36.8C248.5 154.8 208.3 128 163.7 128c-22.8 0-45.3 4.8-66.1 14l-8 3.5c-32.9 14.6-58.1 42.4-69.4 76.5l-2.6 7.8c-5.6 16.8 3.5 34.9 20.2 40.5s34.9-3.5 40.5-20.2l2.6-7.8c5.7-17.1 18.3-30.9 34.7-38.2l8-3.5zm-30 135.1L68.7 398 9.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L116.3 441c4.6-4.6 8.2-10.1 10.6-16.1l14.5-36.2-40.7-44.4c-2.5-2.7-4.8-5.6-7-8.6zM550.6 153.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L530.7 224H384c-17.7 0-32 14.3-32 32s14.3 32 32 32H530.7l-25.4 25.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l80-80c12.5-12.5 12.5-32.8 0-45.3l-80-80zM392 0c-13.3 0-24 10.7-24 24V72c0 13.3 10.7 24 24 24s24-10.7 24-24V24c0-13.3-10.7-24-24-24zm24 152c0-13.3-10.7-24-24-24s-24 10.7-24 24v16c0 13.3 10.7 24 24 24s24-10.7 24-24V152zM392 320c-13.3 0-24 10.7-24 24v16c0 13.3 10.7 24 24 24s24-10.7 24-24V344c0-13.3-10.7-24-24-24zm24 120c0-13.3-10.7-24-24-24s-24 10.7-24 24v48c0 13.3 10.7 24 24 24s24-10.7 24-24V440z"
    ]
};
var $d8206b3ab2e65c05$export$170c56774c8e7961 = {
    prefix: "fas",
    iconName: "sterling-sign",
    icon: [
        320,
        512,
        [
            163,
            "gbp",
            "pound-sign"
        ],
        "f154",
        "M112 160.4c0-35.5 28.8-64.4 64.4-64.4c6.9 0 13.8 1.1 20.4 3.3l81.2 27.1c16.8 5.6 34.9-3.5 40.5-20.2s-3.5-34.9-20.2-40.5L217 38.6c-13.1-4.4-26.8-6.6-40.6-6.6C105.5 32 48 89.5 48 160.4V224H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H48v44.5c0 17.4-4.7 34.5-13.7 49.4L4.6 431.5c-5.9 9.9-6.1 22.2-.4 32.2S20.5 480 32 480H288c17.7 0 32-14.3 32-32s-14.3-32-32-32H88.5l.7-1.1C104.1 390 112 361.5 112 332.5V288H224c17.7 0 32-14.3 32-32s-14.3-32-32-32H112V160.4z"
    ]
};
var $d8206b3ab2e65c05$export$3d9479ec1d1ae83e = $d8206b3ab2e65c05$export$170c56774c8e7961;
var $d8206b3ab2e65c05$export$9ce041dfec8319b = $d8206b3ab2e65c05$export$170c56774c8e7961;
var $d8206b3ab2e65c05$export$ee194b18f5c6f6b6 = {
    prefix: "fas",
    iconName: "viruses",
    icon: [
        640,
        512,
        [],
        "e076",
        "M192 0c13.3 0 24 10.7 24 24V37.5c0 35.6 43.1 53.5 68.3 28.3l9.5-9.5c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-9.5 9.5C293 124.9 310.9 168 346.5 168H360c13.3 0 24 10.7 24 24s-10.7 24-24 24H346.5c-35.6 0-53.5 43.1-28.3 68.3l9.5 9.5c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-9.5-9.5C259.1 293 216 310.9 216 346.5V360c0 13.3-10.7 24-24 24s-24-10.7-24-24V346.5c0-35.6-43.1-53.5-68.3-28.3l-9.5 9.5c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l9.5-9.5C91 259.1 73.1 216 37.5 216H24c-13.3 0-24-10.7-24-24s10.7-24 24-24H37.5c35.6 0 53.5-43.1 28.3-68.3l-9.5-9.5c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l9.5 9.5C124.9 91 168 73.1 168 37.5V24c0-13.3 10.7-24 24-24zm48 224a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm-48-64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm320 80c0 33 39.9 49.5 63.2 26.2c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6C574.5 312.1 591 352 624 352c8.8 0 16 7.2 16 16s-7.2 16-16 16c-33 0-49.5 39.9-26.2 63.2c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0C551.9 446.5 512 463 512 496c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-33-39.9-49.5-63.2-26.2c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6C417.5 423.9 401 384 368 384c-8.8 0-16-7.2-16-16s7.2-16 16-16c33 0 49.5-39.9 26.2-63.2c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0C440.1 289.5 480 273 480 240c0-8.8 7.2-16 16-16s16 7.2 16 16zm0 112a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"
    ]
};
var $d8206b3ab2e65c05$export$8aaca358568da0e0 = {
    prefix: "fas",
    iconName: "square-person-confined",
    icon: [
        448,
        512,
        [],
        "e577",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm96 112a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm80 104c0-30.9 25.1-56 56-56s56 25.1 56 56V350.1c0 36.4-29.5 65.9-65.9 65.9c-17.5 0-34.3-6.9-46.6-19.3L184.8 342l-28.1 56.3c-7.9 15.8-27.1 22.2-42.9 14.3s-22.2-27.1-14.3-42.9l48-96c4.6-9.2 13.3-15.6 23.5-17.3s20.5 1.7 27.8 9L240 306.7V248z"
    ]
};
var $d8206b3ab2e65c05$export$48c51dda34e9f04c = {
    prefix: "fas",
    iconName: "user-tie",
    icon: [
        448,
        512,
        [],
        "f508",
        "M96 128a128 128 0 1 0 256 0A128 128 0 1 0 96 128zm94.5 200.2l18.6 31L175.8 483.1l-36-146.9c-2-8.1-9.8-13.4-17.9-11.3C51.9 342.4 0 405.8 0 481.3c0 17 13.8 30.7 30.7 30.7H162.5c0 0 0 0 .1 0H168 280h5.5c0 0 0 0 .1 0H417.3c17 0 30.7-13.8 30.7-30.7c0-75.5-51.9-138.9-121.9-156.4c-8.1-2-15.9 3.3-17.9 11.3l-36 146.9L238.9 359.2l18.6-31c6.4-10.7-1.3-24.2-13.7-24.2H224 204.3c-12.4 0-20.1 13.6-13.7 24.2z"
    ]
};
var $d8206b3ab2e65c05$export$5977e8de7e65b20 = {
    prefix: "fas",
    iconName: "arrow-down-long",
    icon: [
        384,
        512,
        [
            "long-arrow-down"
        ],
        "f175",
        "M169.4 502.6c12.5 12.5 32.8 12.5 45.3 0l128-128c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 402.7 224 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 370.7L86.6 329.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l128 128z"
    ]
};
var $d8206b3ab2e65c05$export$52ecf90b62f3f030 = $d8206b3ab2e65c05$export$5977e8de7e65b20;
var $d8206b3ab2e65c05$export$8a4f323f00a91606 = {
    prefix: "fas",
    iconName: "tent-arrow-down-to-line",
    icon: [
        640,
        512,
        [],
        "e57e",
        "M241.8 111.9c8.9 9.9 8.1 25-1.8 33.9l-80 72c-9.1 8.2-23 8.2-32.1 0l-80-72c-9.9-8.9-10.7-24-1.8-33.9s24-10.7 33.9-1.8l39.9 36L120 24c0-13.3 10.7-24 24-24s24 10.7 24 24l0 122.1 39.9-36c9.9-8.9 25-8.1 33.9 1.8zm122.8 22.6c11.5-8.7 27.3-8.7 38.8 0l168 128c6.6 5 11 12.5 12.3 20.7l24 160 .7 4.7c17.5 .2 31.6 14.4 31.6 32c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H159.6l.7-4.7 24-160c1.2-8.2 5.6-15.7 12.3-20.7l168-128zM384 448h80L402.7 325.5c-1.7-3.4-5.1-5.5-8.8-5.5c-5.5 0-9.9 4.4-9.9 9.9V448z"
    ]
};
var $d8206b3ab2e65c05$export$a881f37164b11fbf = {
    prefix: "fas",
    iconName: "certificate",
    icon: [
        512,
        512,
        [],
        "f0a3",
        "M211 7.3C205 1 196-1.4 187.6 .8s-14.9 8.9-17.1 17.3L154.7 80.6l-62-17.5c-8.4-2.4-17.4 0-23.5 6.1s-8.5 15.1-6.1 23.5l17.5 62L18.1 170.6c-8.4 2.1-15 8.7-17.3 17.1S1 205 7.3 211l46.2 45L7.3 301C1 307-1.4 316 .8 324.4s8.9 14.9 17.3 17.1l62.5 15.8-17.5 62c-2.4 8.4 0 17.4 6.1 23.5s15.1 8.5 23.5 6.1l62-17.5 15.8 62.5c2.1 8.4 8.7 15 17.1 17.3s17.3-.2 23.4-6.4l45-46.2 45 46.2c6.1 6.2 15 8.7 23.4 6.4s14.9-8.9 17.1-17.3l15.8-62.5 62 17.5c8.4 2.4 17.4 0 23.5-6.1s8.5-15.1 6.1-23.5l-17.5-62 62.5-15.8c8.4-2.1 15-8.7 17.3-17.1s-.2-17.4-6.4-23.4l-46.2-45 46.2-45c6.2-6.1 8.7-15 6.4-23.4s-8.9-14.9-17.3-17.1l-62.5-15.8 17.5-62c2.4-8.4 0-17.4-6.1-23.5s-15.1-8.5-23.5-6.1l-62 17.5L341.4 18.1c-2.1-8.4-8.7-15-17.1-17.3S307 1 301 7.3L256 53.5 211 7.3z"
    ]
};
var $d8206b3ab2e65c05$export$ca6fd367f31ecbc5 = {
    prefix: "fas",
    iconName: "reply-all",
    icon: [
        576,
        512,
        [
            "mail-reply-all"
        ],
        "f122",
        "M209.4 39.5c-9.1-9.6-24.3-10-33.9-.9L33.8 173.2c-19.9 18.9-19.9 50.7 0 69.6L175.5 377.4c9.6 9.1 24.8 8.7 33.9-.9s8.7-24.8-.9-33.9L66.8 208 208.5 73.4c9.6-9.1 10-24.3 .9-33.9zM352 64c0-12.6-7.4-24.1-19-29.2s-25-3-34.4 5.4l-160 144c-6.7 6.1-10.6 14.7-10.6 23.8s3.9 17.7 10.6 23.8l160 144c9.4 8.5 22.9 10.6 34.4 5.4s19-16.6 19-29.2V288h32c53 0 96 43 96 96c0 30.4-12.8 47.9-22.2 56.7c-5.5 5.1-9.8 12-9.8 19.5c0 10.9 8.8 19.7 19.7 19.7c2.8 0 5.6-.6 8.1-1.9C494.5 467.9 576 417.3 576 304c0-97.2-78.8-176-176-176H352V64z"
    ]
};
var $d8206b3ab2e65c05$export$8274334f3a2c1841 = $d8206b3ab2e65c05$export$ca6fd367f31ecbc5;
var $d8206b3ab2e65c05$export$60710f3921019268 = {
    prefix: "fas",
    iconName: "suitcase",
    icon: [
        512,
        512,
        [
            129523
        ],
        "f0f2",
        "M176 56V96H336V56c0-4.4-3.6-8-8-8H184c-4.4 0-8 3.6-8 8zM128 96V56c0-30.9 25.1-56 56-56H328c30.9 0 56 25.1 56 56V96v32V480H128V128 96zM64 96H96V480H64c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64zM448 480H416V96h32c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64z"
    ]
};
var $d8206b3ab2e65c05$export$f3854553fe688388 = {
    prefix: "fas",
    iconName: "person-skating",
    icon: [
        448,
        512,
        [
            "skating"
        ],
        "f7c5",
        "M352 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM128 128c0-17.7 14.3-32 32-32H319.4c43.6 0 64.6 53.4 32.8 83.1l-74.4 69.4 60.2 60.2c9 9 14.1 21.2 14.1 33.9V416c0 17.7-14.3 32-32 32s-32-14.3-32-32V349.3l-77.9-77.8c-26.6-26.6-24.6-70.3 4.3-94.4l20.4-17H160c-17.7 0-32-14.3-32-32zM81.4 353.4l86.9-86.9c4.6 10 11 19.3 19.3 27.5l21.8 21.8-82.7 82.7c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3zm322.5 95.1c8.6 2.1 13.8 10.8 11.6 19.4l-.4 1.7c-6.2 24.9-28.6 42.4-54.3 42.4H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h88.8c11 0 20.6-7.5 23.3-18.2l.4-1.7c2.1-8.6 10.8-13.8 19.4-11.6zM135.2 478.3l-6.2 3.1c-21.6 10.8-47.6 6.6-64.6-10.5L4.7 411.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l59.6 59.6c7.3 7.3 18.5 9.1 27.7 4.5l6.2-3.1c7.9-4 17.5-.7 21.5 7.2s.7 17.5-7.2 21.5z"
    ]
};
var $d8206b3ab2e65c05$export$21bd1d54bd4f2c5a = $d8206b3ab2e65c05$export$f3854553fe688388;
var $d8206b3ab2e65c05$export$3300e4b4d1d1936f = {
    prefix: "fas",
    iconName: "filter-circle-dollar",
    icon: [
        576,
        512,
        [
            "funnel-dollar"
        ],
        "f662",
        "M3.9 22.9C10.5 8.9 24.5 0 40 0H472c15.5 0 29.5 8.9 36.1 22.9s4.6 30.5-5.2 42.5L396.4 195.6C316.2 212.1 256 283 256 368c0 27.4 6.3 53.4 17.5 76.5c-1.6-.8-3.2-1.8-4.7-2.9l-64-48c-8.1-6-12.8-15.5-12.8-25.6V288.9L9 65.3C-.7 53.4-2.8 36.8 3.9 22.9zM288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm120.8-32.6c.6-.9 1.8-2.1 4.2-3.4c5.1-2.7 12.5-4.1 18.7-4c8.2 .1 17.1 1.8 26.4 4.1c8.6 2.1 17.3-3.1 19.4-11.7s-3.1-17.3-11.7-19.4c-5.6-1.4-11.6-2.7-17.9-3.7V288c0-8.8-7.2-16-16-16s-16 7.2-16 16v9.5c-6.1 1.2-12.3 3.2-18 6.3c-11.8 6.3-23 18.4-21.8 37.2c1 16 11.7 25.3 21.6 30.7c8.8 4.7 19.7 7.8 28.6 10.3l1.8 .5c10.3 2.9 17.9 5.2 23.2 8.3c4.5 2.7 4.7 4.2 4.7 5.6c.1 2.4-.5 3.7-1 4.5c-.6 1-1.8 2.2-4 3.3c-4.7 2.5-11.8 3.8-18.5 3.6c-9.5-.3-18.5-3.1-29.9-6.8c-1.9-.6-3.8-1.2-5.8-1.8c-8.4-2.6-17.4 2.1-20 10.5s2.1 17.4 10.5 20c1.6 .5 3.3 1 5 1.6l0 0 0 0c7 2.3 15.1 4.8 23.7 6.6v11.4c0 8.8 7.2 16 16 16s16-7.2 16-16V438.7c6.2-1.1 12.5-3.1 18.3-6.2c12.1-6.5 22.3-18.7 21.7-36.9c-.5-16.2-10.3-26.3-20.5-32.3c-9.4-5.6-21.2-8.9-30.5-11.5l-.2 0c-10.4-2.9-18.3-5.2-23.9-8.2c-4.8-2.6-4.8-4-4.8-4.5l0-.1c-.1-1.9 .3-2.9 .8-3.6z"
    ]
};
var $d8206b3ab2e65c05$export$cebe38ad8f0a143d = $d8206b3ab2e65c05$export$3300e4b4d1d1936f;
var $d8206b3ab2e65c05$export$41dbdadc07a89b05 = {
    prefix: "fas",
    iconName: "camera-retro",
    icon: [
        512,
        512,
        [
            128247
        ],
        "f083",
        "M220.6 121.2L271.1 96 448 96v96H333.2c-21.9-15.1-48.5-24-77.2-24s-55.2 8.9-77.2 24H64V128H192c9.9 0 19.7-2.3 28.6-6.8zM0 128V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H271.1c-9.9 0-19.7 2.3-28.6 6.8L192 64H160V48c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16l0 16C28.7 64 0 92.7 0 128zM168 304a88 88 0 1 1 176 0 88 88 0 1 1 -176 0z"
    ]
};
var $d8206b3ab2e65c05$export$a30c52cde32bec7e = {
    prefix: "fas",
    iconName: "circle-arrow-down",
    icon: [
        512,
        512,
        [
            "arrow-circle-down"
        ],
        "f0ab",
        "M256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM127 281c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l71 71L232 136c0-13.3 10.7-24 24-24s24 10.7 24 24l0 182.1 71-71c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L273 393c-9.4 9.4-24.6 9.4-33.9 0L127 281z"
    ]
};
var $d8206b3ab2e65c05$export$6cfa36bbb3a057 = $d8206b3ab2e65c05$export$a30c52cde32bec7e;
var $d8206b3ab2e65c05$export$d796c05153b1255c = {
    prefix: "fas",
    iconName: "file-import",
    icon: [
        512,
        512,
        [
            "arrow-right-to-file"
        ],
        "f56f",
        "M128 64c0-35.3 28.7-64 64-64H352V128c0 17.7 14.3 32 32 32H512V448c0 35.3-28.7 64-64 64H192c-35.3 0-64-28.7-64-64V336H302.1l-39 39c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9l-80-80c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l39 39H128V64zm0 224v48H24c-13.3 0-24-10.7-24-24s10.7-24 24-24H128zM512 128H384V0L512 128z"
    ]
};
var $d8206b3ab2e65c05$export$32f14beaf6294476 = $d8206b3ab2e65c05$export$d796c05153b1255c;
var $d8206b3ab2e65c05$export$38150b61dfd06fff = {
    prefix: "fas",
    iconName: "square-arrow-up-right",
    icon: [
        448,
        512,
        [
            "external-link-square"
        ],
        "f14c",
        "M384 32c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H384zM160 144c-13.3 0-24 10.7-24 24s10.7 24 24 24h94.1L119 327c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l135-135V328c0 13.3 10.7 24 24 24s24-10.7 24-24V168c0-13.3-10.7-24-24-24H160z"
    ]
};
var $d8206b3ab2e65c05$export$e04d83fed5ebcebf = $d8206b3ab2e65c05$export$38150b61dfd06fff;
var $d8206b3ab2e65c05$export$9010ed816a8b9c97 = {
    prefix: "fas",
    iconName: "box-open",
    icon: [
        640,
        512,
        [],
        "f49e",
        "M58.9 42.1c3-6.1 9.6-9.6 16.3-8.7L320 64 564.8 33.4c6.7-.8 13.3 2.7 16.3 8.7l41.7 83.4c9 17.9-.6 39.6-19.8 45.1L439.6 217.3c-13.9 4-28.8-1.9-36.2-14.3L320 64 236.6 203c-7.4 12.4-22.3 18.3-36.2 14.3L37.1 170.6c-19.3-5.5-28.8-27.2-19.8-45.1L58.9 42.1zM321.1 128l54.9 91.4c14.9 24.8 44.6 36.6 72.5 28.6L576 211.6v167c0 22-15 41.2-36.4 46.6l-204.1 51c-10.2 2.6-20.9 2.6-31 0l-204.1-51C79 419.7 64 400.5 64 378.5v-167L191.6 248c27.8 8 57.6-3.8 72.5-28.6L318.9 128h2.2z"
    ]
};
var $d8206b3ab2e65c05$export$7c265716d4399676 = {
    prefix: "fas",
    iconName: "scroll",
    icon: [
        576,
        512,
        [
            128220
        ],
        "f70e",
        "M0 80v48c0 17.7 14.3 32 32 32H48 96V80c0-26.5-21.5-48-48-48S0 53.5 0 80zM112 32c10 13.4 16 30 16 48V384c0 35.3 28.7 64 64 64s64-28.7 64-64v-5.3c0-32.4 26.3-58.7 58.7-58.7H480V128c0-53-43-96-96-96H112zM464 480c61.9 0 112-50.1 112-112c0-8.8-7.2-16-16-16H314.7c-14.7 0-26.7 11.9-26.7 26.7V384c0 53-43 96-96 96H368h96z"
    ]
};
var $d8206b3ab2e65c05$export$f9a38ef7b046ab51 = {
    prefix: "fas",
    iconName: "spa",
    icon: [
        576,
        512,
        [],
        "f5bb",
        "M183.1 235.3c33.7 20.7 62.9 48.1 85.8 80.5c7 9.9 13.4 20.3 19.1 31c5.7-10.8 12.1-21.1 19.1-31c22.9-32.4 52.1-59.8 85.8-80.5C437.6 207.8 490.1 192 546 192h9.9c11.1 0 20.1 9 20.1 20.1C576 360.1 456.1 480 308.1 480H288 267.9C119.9 480 0 360.1 0 212.1C0 201 9 192 20.1 192H30c55.9 0 108.4 15.8 153.1 43.3zM301.5 37.6c15.7 16.9 61.1 71.8 84.4 164.6c-38 21.6-71.4 50.8-97.9 85.6c-26.5-34.8-59.9-63.9-97.9-85.6c23.2-92.8 68.6-147.7 84.4-164.6C278 33.9 282.9 32 288 32s10 1.9 13.5 5.6z"
    ]
};
var $d8206b3ab2e65c05$export$db853fbb474326cc = {
    prefix: "fas",
    iconName: "location-pin-lock",
    icon: [
        512,
        512,
        [],
        "e51f",
        "M215.7 499.2c11-13.8 25.1-31.7 40.3-52.3V352c0-23.7 12.9-44.4 32-55.4V272c0-55.6 40.5-101.7 93.6-110.5C367 70 287.7 0 192 0C86 0 0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM192 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM400 240c17.7 0 32 14.3 32 32v48H368V272c0-17.7 14.3-32 32-32zm-80 32v48c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H480c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32V272c0-44.2-35.8-80-80-80s-80 35.8-80 80z"
    ]
};
var $d8206b3ab2e65c05$export$da79f048408b1722 = {
    prefix: "fas",
    iconName: "pause",
    icon: [
        320,
        512,
        [
            9208
        ],
        "f04c",
        "M48 64C21.5 64 0 85.5 0 112V400c0 26.5 21.5 48 48 48H80c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48H48zm192 0c-26.5 0-48 21.5-48 48V400c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48H240z"
    ]
};
var $d8206b3ab2e65c05$export$50d11c98c99e3b2d = {
    prefix: "fas",
    iconName: "hill-avalanche",
    icon: [
        576,
        512,
        [],
        "e507",
        "M439.7 401.9c34.2 23.1 81.1 19.5 111.4-10.8c34.4-34.4 34.4-90.1 0-124.4c-27.8-27.8-69.5-33.1-102.6-16c-11.8 6.1-16.4 20.6-10.3 32.3s20.6 16.4 32.3 10.3c15.1-7.8 34-5.3 46.6 7.3c15.6 15.6 15.6 40.9 0 56.6s-40.9 15.6-56.6 0l-81.7-81.7C401.2 261.3 416 236.4 416 208c0-33.9-21.1-62.9-50.9-74.5c1.9-6.8 2.9-14 2.9-21.5c0-44.2-35.8-80-80-80c-27.3 0-51.5 13.7-65.9 34.6C216.3 46.6 197.9 32 176 32c-26.5 0-48 21.5-48 48c0 4 .5 7.9 1.4 11.6L439.7 401.9zM480 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm0 128a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM68.3 87C43.1 61.8 0 79.7 0 115.3V432c0 44.2 35.8 80 80 80H396.7c35.6 0 53.5-43.1 28.3-68.3L68.3 87z"
    ]
};
var $d8206b3ab2e65c05$export$ac389bf5cc37feb5 = {
    prefix: "fas",
    iconName: "temperature-empty",
    icon: [
        320,
        512,
        [
            "temperature-0",
            "thermometer-0",
            "thermometer-empty"
        ],
        "f2cb",
        "M112 112c0-26.5 21.5-48 48-48s48 21.5 48 48V276.5c0 17.3 7.1 31.9 15.3 42.5C233.8 332.6 240 349.5 240 368c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-18.5 6.2-35.4 16.7-48.9c8.2-10.6 15.3-25.2 15.3-42.5V112zM160 0C98.1 0 48 50.2 48 112V276.5c0 .1-.1 .3-.2 .6c-.2 .6-.8 1.6-1.7 2.8C27.2 304.2 16 334.8 16 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-33.2-11.2-63.8-30.1-88.1c-.9-1.2-1.5-2.2-1.7-2.8c-.1-.3-.2-.5-.2-.6V112C272 50.2 221.9 0 160 0zm0 416a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"
    ]
};
var $d8206b3ab2e65c05$export$e99b7d2ccc282383 = $d8206b3ab2e65c05$export$ac389bf5cc37feb5;
var $d8206b3ab2e65c05$export$4c13a186ecce3b80 = $d8206b3ab2e65c05$export$ac389bf5cc37feb5;
var $d8206b3ab2e65c05$export$81a2f8298cf523f9 = $d8206b3ab2e65c05$export$ac389bf5cc37feb5;
var $d8206b3ab2e65c05$export$d59078f6e80b4a67 = {
    prefix: "fas",
    iconName: "bomb",
    icon: [
        512,
        512,
        [
            128163
        ],
        "f1e2",
        "M459.1 52.4L442.6 6.5C440.7 2.6 436.5 0 432.1 0s-8.5 2.6-10.4 6.5L405.2 52.4l-46 16.8c-4.3 1.6-7.3 5.9-7.2 10.4c0 4.5 3 8.7 7.2 10.2l45.7 16.8 16.8 45.8c1.5 4.4 5.8 7.5 10.4 7.5s8.9-3.1 10.4-7.5l16.5-45.8 45.7-16.8c4.2-1.5 7.2-5.7 7.2-10.2c0-4.6-3-8.9-7.2-10.4L459.1 52.4zm-132.4 53c-12.5-12.5-32.8-12.5-45.3 0l-2.9 2.9C256.5 100.3 232.7 96 208 96C93.1 96 0 189.1 0 304S93.1 512 208 512s208-93.1 208-208c0-24.7-4.3-48.5-12.2-70.5l2.9-2.9c12.5-12.5 12.5-32.8 0-45.3l-80-80zM200 192c-57.4 0-104 46.6-104 104v8c0 8.8-7.2 16-16 16s-16-7.2-16-16v-8c0-75.1 60.9-136 136-136h8c8.8 0 16 7.2 16 16s-7.2 16-16 16h-8z"
    ]
};
var $d8206b3ab2e65c05$export$5f519e9ac15ab8c3 = {
    prefix: "fas",
    iconName: "registered",
    icon: [
        512,
        512,
        [
            174
        ],
        "f25d",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM160 152c0-13.3 10.7-24 24-24h88c44.2 0 80 35.8 80 80c0 28-14.4 52.7-36.3 67l34.1 75.1c5.5 12.1 .1 26.3-11.9 31.8s-26.3 .1-31.8-11.9L268.9 288H208v72c0 13.3-10.7 24-24 24s-24-10.7-24-24V264 152zm48 88h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H208v64z"
    ]
};
var $d8206b3ab2e65c05$export$6ea408c7266ed557 = {
    prefix: "fas",
    iconName: "address-card",
    icon: [
        576,
        512,
        [
            62140,
            "contact-card",
            "vcard"
        ],
        "f2bb",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm80 256h64c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80zm-32-96a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm256-32H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H368c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H368c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H368c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
    ]
};
var $d8206b3ab2e65c05$export$4ac51eb0b298b190 = $d8206b3ab2e65c05$export$6ea408c7266ed557;
var $d8206b3ab2e65c05$export$91228257deb1bf18 = $d8206b3ab2e65c05$export$6ea408c7266ed557;
var $d8206b3ab2e65c05$export$f4d7840209109993 = {
    prefix: "fas",
    iconName: "scale-unbalanced-flip",
    icon: [
        640,
        512,
        [
            "balance-scale-right"
        ],
        "f516",
        "M117.9 62.4c-16.8-5.6-25.8-23.7-20.2-40.5s23.7-25.8 40.5-20.2l113 37.7C265 15.8 290.7 0 320 0c44.2 0 80 35.8 80 80c0 3-.2 5.9-.5 8.8l122.6 40.9c16.8 5.6 25.8 23.7 20.2 40.5s-23.7 25.8-40.5 20.2L366.4 145.2c-4.5 3.2-9.3 5.9-14.4 8.2V480c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32s14.3-32 32-32H288V153.3c-21-9.2-37.2-27-44.2-49l-125.9-42zM200.4 288L128 163.8 55.6 288H200.4zM128 384C65.1 384 12.8 350 2 305.1c-2.6-11 1-22.3 6.7-32.1l95.2-163.2c5-8.6 14.2-13.8 24.1-13.8s19.1 5.3 24.1 13.8l95.2 163.2c5.7 9.8 9.3 21.1 6.7 32.1C243.2 350 190.9 384 128 384zm382.8-92.2L438.4 416H583.3L510.8 291.8zm126 141.3C626 478 573.7 512 510.8 512s-115.2-34-126-78.9c-2.6-11 1-22.3 6.7-32.1l95.2-163.2c5-8.6 14.2-13.8 24.1-13.8s19.1 5.3 24.1 13.8l95.2 163.2c5.7 9.8 9.3 21.1 6.7 32.1z"
    ]
};
var $d8206b3ab2e65c05$export$2238e05f8920005a = $d8206b3ab2e65c05$export$f4d7840209109993;
var $d8206b3ab2e65c05$export$34c1e678c32ed646 = {
    prefix: "fas",
    iconName: "subscript",
    icon: [
        512,
        512,
        [],
        "f12c",
        "M32 64C14.3 64 0 78.3 0 96s14.3 32 32 32H47.3l89.6 128L47.3 384H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H64c10.4 0 20.2-5.1 26.2-13.6L176 311.8l85.8 122.6c6 8.6 15.8 13.6 26.2 13.6h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H304.7L215.1 256l89.6-128H320c17.7 0 32-14.3 32-32s-14.3-32-32-32H288c-10.4 0-20.2 5.1-26.2 13.6L176 200.2 90.2 77.6C84.2 69.1 74.4 64 64 64H32zM480 320c0-11.1-5.7-21.4-15.2-27.2s-21.2-6.4-31.1-1.4l-32 16c-15.8 7.9-22.2 27.1-14.3 42.9C393 361.5 404.3 368 416 368v80c-17.7 0-32 14.3-32 32s14.3 32 32 32h32 32c17.7 0 32-14.3 32-32s-14.3-32-32-32V320z"
    ]
};
var $d8206b3ab2e65c05$export$99749ac517cbef07 = {
    prefix: "fas",
    iconName: "diamond-turn-right",
    icon: [
        512,
        512,
        [
            "directions"
        ],
        "f5eb",
        "M227.7 11.7c15.6-15.6 40.9-15.6 56.6 0l216 216c15.6 15.6 15.6 40.9 0 56.6l-216 216c-15.6 15.6-40.9 15.6-56.6 0l-216-216c-15.6-15.6-15.6-40.9 0-56.6l216-216zm87.6 137c-4.6-4.6-11.5-5.9-17.4-3.5s-9.9 8.3-9.9 14.8v56H224c-35.3 0-64 28.7-64 64v48c0 13.3 10.7 24 24 24s24-10.7 24-24V280c0-8.8 7.2-16 16-16h64v56c0 6.5 3.9 12.3 9.9 14.8s12.9 1.1 17.4-3.5l80-80c6.2-6.2 6.2-16.4 0-22.6l-80-80z"
    ]
};
var $d8206b3ab2e65c05$export$6a6973de44442fe5 = $d8206b3ab2e65c05$export$99749ac517cbef07;
var $d8206b3ab2e65c05$export$ea2986b45ba5d2cf = {
    prefix: "fas",
    iconName: "burst",
    icon: [
        512,
        512,
        [],
        "e4dc",
        "M37.6 4.2C28-2.3 15.2-1.1 7 7s-9.4 21-2.8 30.5l112 163.3L16.6 233.2C6.7 236.4 0 245.6 0 256s6.7 19.6 16.6 22.8l103.1 33.4L66.8 412.8c-4.9 9.3-3.2 20.7 4.3 28.1s18.8 9.2 28.1 4.3l100.6-52.9 33.4 103.1c3.2 9.9 12.4 16.6 22.8 16.6s19.6-6.7 22.8-16.6l33.4-103.1 100.6 52.9c9.3 4.9 20.7 3.2 28.1-4.3s9.2-18.8 4.3-28.1L392.3 312.2l103.1-33.4c9.9-3.2 16.6-12.4 16.6-22.8s-6.7-19.6-16.6-22.8L388.9 198.7l25.7-70.4c3.2-8.8 1-18.6-5.6-25.2s-16.4-8.8-25.2-5.6l-70.4 25.7L278.8 16.6C275.6 6.7 266.4 0 256 0s-19.6 6.7-22.8 16.6l-32.3 99.6L37.6 4.2z"
    ]
};
var $d8206b3ab2e65c05$export$6486d62e77b910 = {
    prefix: "fas",
    iconName: "house-laptop",
    icon: [
        640,
        512,
        [
            "laptop-house"
        ],
        "e066",
        "M218.3 8.5c12.3-11.3 31.2-11.3 43.4 0l208 192c6.7 6.2 10.3 14.8 10.3 23.5H336c-19.1 0-36.3 8.4-48 21.7V208c0-8.8-7.2-16-16-16H208c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h64V416H112c-26.5 0-48-21.5-48-48V256H32c-13.2 0-25-8.1-29.8-20.3s-1.6-26.2 8.1-35.2l208-192zM352 304V448H544V304H352zm-48-16c0-17.7 14.3-32 32-32H560c17.7 0 32 14.3 32 32V448h32c8.8 0 16 7.2 16 16c0 26.5-21.5 48-48 48H544 352 304c-26.5 0-48-21.5-48-48c0-8.8 7.2-16 16-16h32V288z"
    ]
};
var $d8206b3ab2e65c05$export$efd983de5e4d6ad3 = $d8206b3ab2e65c05$export$6486d62e77b910;
var $d8206b3ab2e65c05$export$5352cbdc070ce8d = {
    prefix: "fas",
    iconName: "face-tired",
    icon: [
        512,
        512,
        [
            128555,
            "tired"
        ],
        "f5c8",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM164.7 328.7c22-22 53.9-40.7 91.3-40.7s69.3 18.7 91.3 40.7c11.1 11.1 20.1 23.4 26.4 35.4c6.2 11.7 10.3 24.4 10.3 35.9c0 5.2-2.6 10.2-6.9 13.2s-9.8 3.7-14.7 1.8l-20.5-7.7c-26.9-10.1-55.5-15.3-84.3-15.3h-3.2c-28.8 0-57.3 5.2-84.3 15.3L149.6 415c-4.9 1.8-10.4 1.2-14.7-1.8s-6.9-7.9-6.9-13.2c0-11.6 4.2-24.2 10.3-35.9c6.3-12 15.3-24.3 26.4-35.4zm-31.2-182l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5c0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6c0-9 9.6-14.7 17.5-10.5zM396 157.1c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6c0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9c7.9-4.2 17.5 1.5 17.5 10.5z"
    ]
};
var $d8206b3ab2e65c05$export$3d016d62cda18371 = $d8206b3ab2e65c05$export$5352cbdc070ce8d;
var $d8206b3ab2e65c05$export$a822dad6e586ee9e = {
    prefix: "fas",
    iconName: "money-bills",
    icon: [
        640,
        512,
        [],
        "e1f3",
        "M96 96V320c0 35.3 28.7 64 64 64H576c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H160c-35.3 0-64 28.7-64 64zm64 160c35.3 0 64 28.7 64 64H160V256zM224 96c0 35.3-28.7 64-64 64V96h64zM576 256v64H512c0-35.3 28.7-64 64-64zM512 96h64v64c-35.3 0-64-28.7-64-64zM288 208a80 80 0 1 1 160 0 80 80 0 1 1 -160 0zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120V360c0 66.3 53.7 120 120 120H520c13.3 0 24-10.7 24-24s-10.7-24-24-24H120c-39.8 0-72-32.2-72-72V120z"
    ]
};
var $d8206b3ab2e65c05$export$aa11b8edb09fed14 = {
    prefix: "fas",
    iconName: "smog",
    icon: [
        640,
        512,
        [],
        "f75f",
        "M32 144c0 79.5 64.5 144 144 144H299.3c22.6 19.9 52.2 32 84.7 32s62.1-12.1 84.7-32H496c61.9 0 112-50.1 112-112s-50.1-112-112-112c-10.7 0-21 1.5-30.8 4.3C443.8 27.7 401.1 0 352 0c-32.6 0-62.4 12.2-85.1 32.3C242.1 12.1 210.5 0 176 0C96.5 0 32 64.5 32 144zM616 368H280c-13.3 0-24 10.7-24 24s10.7 24 24 24H616c13.3 0 24-10.7 24-24s-10.7-24-24-24zm-64 96H440c-13.3 0-24 10.7-24 24s10.7 24 24 24H552c13.3 0 24-10.7 24-24s-10.7-24-24-24zm-192 0H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H360c13.3 0 24-10.7 24-24s-10.7-24-24-24zM224 392c0-13.3-10.7-24-24-24H96c-13.3 0-24 10.7-24 24s10.7 24 24 24H200c13.3 0 24-10.7 24-24z"
    ]
};
var $d8206b3ab2e65c05$export$e94134641c0e2 = {
    prefix: "fas",
    iconName: "crutch",
    icon: [
        512,
        512,
        [],
        "f7f7",
        "M297.4 9.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0zm-96 144l-34.8 34.8c-12.9 12.9-21.9 29.2-25.8 47.1L116.8 342.9c-1.3 5.9-4.3 11.4-8.6 15.7L9.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l98.8-98.8c4.3-4.3 9.7-7.3 15.7-8.6l107.6-23.9c17.8-4 34.1-12.9 47.1-25.8l34.7-34.7c0 0 .1-.1 .1-.1s.1-.1 .1-.1l74.6-74.6-45.3-45.3L336 242.7 269.3 176l52.1-52.1L276.1 78.6l-74.7 74.7zM224 221.3L290.7 288l-12.2 12.2c-4.3 4.3-9.7 7.3-15.7 8.6l-76.7 17 17-76.7c1.3-5.9 4.3-11.4 8.6-15.7L224 221.3z"
    ]
};
var $d8206b3ab2e65c05$export$aa4baaed1c60f58d = {
    prefix: "fas",
    iconName: "font-awesome",
    icon: [
        448,
        512,
        [
            62501,
            62694,
            "font-awesome-flag",
            "font-awesome-logo-full"
        ],
        "f2b4",
        "M448 48V384c-63.1 22.5-82.3 32-119.5 32c-62.8 0-86.6-32-149.3-32c-20.6 0-36.6 3.6-51.2 8.2v-64c14.6-4.6 30.6-8.2 51.2-8.2c62.7 0 86.5 32 149.3 32c20.4 0 35.6-3 55.5-9.3v-208c-19.9 6.3-35.1 9.3-55.5 9.3c-62.8 0-86.6-32-149.3-32c-50.8 0-74.9 20.6-115.2 28.7V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V64C0 46.3 14.3 32 32 32s32 14.3 32 32V76.7c40.3-8 64.4-28.7 115.2-28.7c62.7 0 86.5 32 149.3 32c37.1 0 56.4-9.5 119.5-32z"
    ]
};
var $d8206b3ab2e65c05$export$102c25fde54d4843 = $d8206b3ab2e65c05$export$aa4baaed1c60f58d;
var $d8206b3ab2e65c05$export$6e20d421a2e0f320 = $d8206b3ab2e65c05$export$aa4baaed1c60f58d;
var $d8206b3ab2e65c05$export$3507214fff1cc655 = {
    prefix: "fas",
    iconName: "cloud-arrow-up",
    icon: [
        640,
        512,
        [
            62338,
            "cloud-upload",
            "cloud-upload-alt"
        ],
        "f0ee",
        "M144 480C64.5 480 0 415.5 0 336c0-62.8 40.2-116.2 96.2-135.9c-.1-2.7-.2-5.4-.2-8.1c0-88.4 71.6-160 160-160c59.3 0 111 32.2 138.7 80.2C409.9 102 428.3 96 448 96c53 0 96 43 96 96c0 12.2-2.3 23.8-6.4 34.6C596 238.4 640 290.1 640 352c0 70.7-57.3 128-128 128H144zm79-217c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l39-39V392c0 13.3 10.7 24 24 24s24-10.7 24-24V257.9l39 39c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-80-80c-9.4-9.4-24.6-9.4-33.9 0l-80 80z"
    ]
};
var $d8206b3ab2e65c05$export$a48720e6366f5d9a = $d8206b3ab2e65c05$export$3507214fff1cc655;
var $d8206b3ab2e65c05$export$e73b3e819b9d14a5 = $d8206b3ab2e65c05$export$3507214fff1cc655;
var $d8206b3ab2e65c05$export$5c390baea5db4f77 = {
    prefix: "fas",
    iconName: "palette",
    icon: [
        512,
        512,
        [
            127912
        ],
        "f53f",
        "M512 256c0 .9 0 1.8 0 2.7c-.4 36.5-33.6 61.3-70.1 61.3H344c-26.5 0-48 21.5-48 48c0 3.4 .4 6.7 1 9.9c2.1 10.2 6.5 20 10.8 29.9c6.1 13.8 12.1 27.5 12.1 42c0 31.8-21.6 60.7-53.4 62c-3.5 .1-7 .2-10.6 .2C114.6 512 0 397.4 0 256S114.6 0 256 0S512 114.6 512 256zM128 288a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm0-96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM288 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm96 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
var $d8206b3ab2e65c05$export$db9f783f15682c4a = {
    prefix: "fas",
    iconName: "arrows-turn-right",
    icon: [
        448,
        512,
        [],
        "e4c0",
        "M297.4 9.4c12.5-12.5 32.8-12.5 45.3 0l96 96c12.5 12.5 12.5 32.8 0 45.3l-96 96c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L338.7 160H128c-35.3 0-64 28.7-64 64v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V224C0 153.3 57.3 96 128 96H338.7L297.4 54.6c-12.5-12.5-12.5-32.8 0-45.3zm-96 256c12.5-12.5 32.8-12.5 45.3 0l96 96c12.5 12.5 12.5 32.8 0 45.3l-96 96c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 416H96c-17.7 0-32 14.3-32 32v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V448c0-53 43-96 96-96H242.7l-41.4-41.4c-12.5-12.5-12.5-32.8 0-45.3z"
    ]
};
var $d8206b3ab2e65c05$export$c8370e53051a657 = {
    prefix: "fas",
    iconName: "vest",
    icon: [
        448,
        512,
        [],
        "e085",
        "M207.1 237.4L151.2 69.7C168.6 79.7 192.6 88 224 88s55.4-8.3 72.8-18.3L226.5 280.6c-1.6 4.9-2.5 10-2.5 15.2V464c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48V270.5c0-9.5-2.8-18.7-8.1-26.6l-47.9-71.8c-5.3-7.9-8.1-17.1-8.1-26.6V128 54.3 48c0-26.5-21.5-48-48-48h-4.5c-.2 0-.4 0-.6 0c-.4 0-.8 0-1.2 0C311 0 295.7 9.7 285.7 18.8C276.4 27.2 257.2 40 224 40s-52.4-12.8-61.7-21.2C152.3 9.7 137 0 118.3 0c-.4 0-.8 0-1.2 0c-.2 0-.4 0-.6 0H112C85.5 0 64 21.5 64 48v6.3V128v17.5c0 9.5-2.8 18.7-8.1 26.6L8.1 243.9C2.8 251.8 0 261.1 0 270.5V464c0 26.5 21.5 48 48 48H176c9.9 0 19-3 26.7-8.1C195.9 492.2 192 478.5 192 464V295.8c0-8.6 1.4-17.1 4.1-25.3l11-33.1zM347.3 356.7l48 48c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-48-48c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zm-294.6 48l48-48c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-48 48c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6z"
    ]
};
var $d8206b3ab2e65c05$export$fd312949b97346ae = {
    prefix: "fas",
    iconName: "ferry",
    icon: [
        576,
        512,
        [],
        "e4ea",
        "M224 0H352c17.7 0 32 14.3 32 32h75.1c20.6 0 31.6 24.3 18.1 39.8L456 96H120L98.8 71.8C85.3 56.3 96.3 32 116.9 32H192c0-17.7 14.3-32 32-32zM96 128H480c17.7 0 32 14.3 32 32V283.5c0 13.3-4.2 26.3-11.9 37.2l-51.4 71.9c-1.9 1.1-3.7 2.2-5.5 3.5c-15.5 10.7-34 18-51 19.9H375.6c-17.1-1.8-35-9-50.8-19.9c-22.1-15.5-51.6-15.5-73.7 0c-14.8 10.2-32.5 18-50.6 19.9H183.9c-17-1.8-35.6-9.2-51-19.9c-1.8-1.3-3.7-2.4-5.6-3.5L75.9 320.7C68.2 309.8 64 296.8 64 283.5V160c0-17.7 14.3-32 32-32zm32 64v96H448V192H128zM306.5 421.9C329 437.4 356.5 448 384 448c26.9 0 55.3-10.8 77.4-26.1l0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 501.7 417 512 384 512c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.4 27.3-10.1 39.2-1.7l0 0C136.7 437.2 165.1 448 192 448c27.5 0 55-10.6 77.5-26.1c11.1-7.9 25.9-7.9 37 0z"
    ]
};
var $d8206b3ab2e65c05$export$cfb044c7d35060bb = {
    prefix: "fas",
    iconName: "arrows-down-to-people",
    icon: [
        640,
        512,
        [],
        "e4b9",
        "M144 0c-13.3 0-24 10.7-24 24V142.1L97 119c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0l64-64c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-23 23V24c0-13.3-10.7-24-24-24zM360 200a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zM184 296a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zm312 40a40 40 0 1 0 0-80 40 40 0 1 0 0 80zM200 441.5l26.9 49.9c6.3 11.7 20.8 16 32.5 9.8s16-20.8 9.8-32.5l-36.3-67.5c1.7-1.7 3.2-3.6 4.3-5.8L264 345.5V400c0 17.7 14.3 32 32 32h48c17.7 0 32-14.3 32-32V345.5l26.9 49.9c1.2 2.2 2.6 4.1 4.3 5.8l-36.3 67.5c-6.3 11.7-1.9 26.2 9.8 32.5s26.2 1.9 32.5-9.8L440 441.5V480c0 17.7 14.3 32 32 32h48c17.7 0 32-14.3 32-32V441.5l26.9 49.9c6.3 11.7 20.8 16 32.5 9.8s16-20.8 9.8-32.5l-37.9-70.3c-15.3-28.5-45.1-46.3-77.5-46.3H486.2c-16.3 0-31.9 4.5-45.4 12.6l-33.6-62.3c-15.3-28.5-45.1-46.3-77.5-46.3H310.2c-32.4 0-62.1 17.8-77.5 46.3l-33.6 62.3c-13.5-8.1-29.1-12.6-45.4-12.6H134.2c-32.4 0-62.1 17.8-77.5 46.3L18.9 468.6c-6.3 11.7-1.9 26.2 9.8 32.5s26.2 1.9 32.5-9.8L88 441.5V480c0 17.7 14.3 32 32 32h48c17.7 0 32-14.3 32-32V441.5zM415 153l64 64c9.4 9.4 24.6 9.4 33.9 0l64-64c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-23 23V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V142.1l-23-23c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9z"
    ]
};
var $d8206b3ab2e65c05$export$d7b60b8dbd03cfe4 = {
    prefix: "fas",
    iconName: "seedling",
    icon: [
        512,
        512,
        [
            127793,
            "sprout"
        ],
        "f4d8",
        "M512 32c0 113.6-84.6 207.5-194.2 222c-7.1-53.4-30.6-101.6-65.3-139.3C290.8 46.3 364 0 448 0h32c17.7 0 32 14.3 32 32zM0 96C0 78.3 14.3 64 32 64H64c123.7 0 224 100.3 224 224v32V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V320C100.3 320 0 219.7 0 96z"
    ]
};
var $d8206b3ab2e65c05$export$9f3035e3a8c62323 = $d8206b3ab2e65c05$export$d7b60b8dbd03cfe4;
var $d8206b3ab2e65c05$export$47d93e9001818ee7 = {
    prefix: "fas",
    iconName: "left-right",
    icon: [
        512,
        512,
        [
            8596,
            "arrows-alt-h"
        ],
        "f337",
        "M504.3 273.6c4.9-4.5 7.7-10.9 7.7-17.6s-2.8-13-7.7-17.6l-112-104c-7-6.5-17.2-8.2-25.9-4.4s-14.4 12.5-14.4 22l0 56-192 0 0-56c0-9.5-5.7-18.2-14.4-22s-18.9-2.1-25.9 4.4l-112 104C2.8 243 0 249.3 0 256s2.8 13 7.7 17.6l112 104c7 6.5 17.2 8.2 25.9 4.4s14.4-12.5 14.4-22l0-56 192 0 0 56c0 9.5 5.7 18.2 14.4 22s18.9 2.1 25.9-4.4l112-104z"
    ]
};
var $d8206b3ab2e65c05$export$7937ea574fb1389 = $d8206b3ab2e65c05$export$47d93e9001818ee7;
var $d8206b3ab2e65c05$export$e81e7f3390fe84fe = {
    prefix: "fas",
    iconName: "boxes-packing",
    icon: [
        640,
        512,
        [],
        "e4c7",
        "M256 48c0-26.5 21.5-48 48-48H592c26.5 0 48 21.5 48 48V464c0 26.5-21.5 48-48 48H381.3c1.8-5 2.7-10.4 2.7-16V253.3c18.6-6.6 32-24.4 32-45.3V176c0-26.5-21.5-48-48-48H256V48zM571.3 347.3c6.2-6.2 6.2-16.4 0-22.6l-64-64c-6.2-6.2-16.4-6.2-22.6 0l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L480 310.6V432c0 8.8 7.2 16 16 16s16-7.2 16-16V310.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0zM0 176c0-8.8 7.2-16 16-16H368c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H16c-8.8 0-16-7.2-16-16V176zm352 80V480c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V256H352zM144 320c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H144z"
    ]
};
var $d8206b3ab2e65c05$export$827fbb87bdbe1028 = {
    prefix: "fas",
    iconName: "circle-arrow-left",
    icon: [
        512,
        512,
        [
            "arrow-circle-left"
        ],
        "f0a8",
        "M512 256A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM231 127c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-71 71L376 232c13.3 0 24 10.7 24 24s-10.7 24-24 24l-182.1 0 71 71c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L119 273c-9.4-9.4-9.4-24.6 0-33.9L231 127z"
    ]
};
var $d8206b3ab2e65c05$export$728262abb9f58d0a = $d8206b3ab2e65c05$export$827fbb87bdbe1028;
var $d8206b3ab2e65c05$export$88a8383ecdd39a54 = {
    prefix: "fas",
    iconName: "group-arrows-rotate",
    icon: [
        512,
        512,
        [],
        "e4f6",
        "M201.1 71.9c16.9-5 26.6-22.9 21.5-39.8s-22.9-26.6-39.8-21.5c-21.5 6.4-41.8 15.5-60.6 27C114.3 34 105.4 32 96 32C60.7 32 32 60.7 32 96c0 9.4 2 18.3 5.6 26.3c-11.5 18.7-20.6 39-27 60.6c-5 16.9 4.6 34.8 21.5 39.8s34.8-4.6 39.8-21.5c4.3-14.6 10.4-28.5 17.9-41.4c2 .2 4.1 .3 6.1 .3c35.3 0 64-28.7 64-64c0-2.1-.1-4.1-.3-6.1c12.9-7.5 26.8-13.6 41.4-17.9zm128-61.3c-16.9-5-34.8 4.6-39.8 21.5s4.6 34.8 21.5 39.8c14.6 4.3 28.5 10.4 41.4 17.9c-.2 2-.3 4.1-.3 6.1c0 35.3 28.7 64 64 64c2.1 0 4.1-.1 6.2-.3c7.5 12.9 13.6 26.8 17.9 41.4c5 16.9 22.9 26.6 39.8 21.5s26.6-22.9 21.5-39.8c-6.4-21.5-15.5-41.8-27-60.6c3.6-8 5.6-16.9 5.6-26.3c0-35.3-28.7-64-64-64c-9.4 0-18.3 2-26.3 5.6c-18.7-11.5-39-20.6-60.6-27zM71.9 310.9c-5-16.9-22.9-26.6-39.8-21.5s-26.6 22.9-21.5 39.8c6.4 21.5 15.5 41.8 27 60.6C34 397.7 32 406.6 32 416c0 35.3 28.7 64 64 64c9.4 0 18.3-2 26.3-5.6c18.7 11.5 39 20.6 60.6 27c16.9 5 34.8-4.6 39.8-21.5s-4.6-34.8-21.5-39.8c-14.6-4.3-28.5-10.4-41.4-17.9c.2-2 .3-4.1 .3-6.2c0-35.3-28.7-64-64-64c-2.1 0-4.1 .1-6.2 .3c-7.5-12.9-13.6-26.8-17.9-41.4zm429.4 18.3c5-16.9-4.6-34.8-21.5-39.8s-34.8 4.6-39.8 21.5c-4.3 14.6-10.4 28.5-17.9 41.4c-2-.2-4.1-.3-6.2-.3c-35.3 0-64 28.7-64 64c0 2.1 .1 4.1 .3 6.2c-12.9 7.5-26.8 13.6-41.4 17.9c-16.9 5-26.6 22.9-21.5 39.8s22.9 26.6 39.8 21.5c21.5-6.4 41.8-15.5 60.6-27c8 3.6 16.9 5.6 26.3 5.6c35.3 0 64-28.7 64-64c0-9.4-2-18.3-5.6-26.3c11.5-18.7 20.6-39 27-60.6zM192.8 256.8c0-15.6 5.6-29.9 14.9-41.1L223 231c6.6 6.6 17.8 1.9 17.8-7.4V163.2c0-5.7-4.7-10.4-10.4-10.4H169.9c-9.3 0-13.9 11.2-7.4 17.8l11.2 11.2c-17.9 19.8-28.9 46.2-28.9 75.1c0 43.6 24.9 81.3 61.1 99.8c11.8 6 26.3 1.4 32.3-10.4s1.4-26.3-10.4-32.3c-20.8-10.6-34.9-32.2-34.9-57zm93.1-58.6c20.8 10.6 34.9 32.2 34.9 57c0 15.6-5.6 29.9-14.9 41.1L290.6 281c-6.6-6.6-17.8-1.9-17.8 7.4v60.5c0 5.7 4.7 10.4 10.4 10.4h60.5c9.3 0 13.9-11.2 7.4-17.8l-11.2-11.2c17.9-19.8 28.9-46.2 28.9-75.1c0-43.6-24.9-81.3-61.1-99.8c-11.8-6-26.3-1.4-32.3 10.4s-1.4 26.3 10.4 32.3z"
    ]
};
var $d8206b3ab2e65c05$export$8b89ca3201039376 = {
    prefix: "fas",
    iconName: "bowl-food",
    icon: [
        512,
        512,
        [],
        "e4c6",
        "M0 192c0-35.3 28.7-64 64-64c.5 0 1.1 0 1.6 0C73 91.5 105.3 64 144 64c15 0 29 4.1 40.9 11.2C198.2 49.6 225.1 32 256 32s57.8 17.6 71.1 43.2C339 68.1 353 64 368 64c38.7 0 71 27.5 78.4 64c.5 0 1.1 0 1.6 0c35.3 0 64 28.7 64 64c0 11.7-3.1 22.6-8.6 32H8.6C3.1 214.6 0 203.7 0 192zm0 91.4C0 268.3 12.3 256 27.4 256H484.6c15.1 0 27.4 12.3 27.4 27.4c0 70.5-44.4 130.7-106.7 154.1L403.5 452c-2 16-15.6 28-31.8 28H140.2c-16.1 0-29.8-12-31.8-28l-1.8-14.4C44.4 414.1 0 353.9 0 283.4z"
    ]
};
var $d8206b3ab2e65c05$export$14d66ba7571ae0b9 = {
    prefix: "fas",
    iconName: "candy-cane",
    icon: [
        512,
        512,
        [],
        "f786",
        "M348.8 131.5c3.7-2.3 7.9-3.5 12.2-3.5c12.7 0 23 10.3 23 23v5.6c0 9.9-5.1 19.1-13.5 24.3L30.1 393.7C.1 412.5-9 451.9 9.7 481.9s58.2 39.1 88.2 20.4L438.4 289.5c45.8-28.6 73.6-78.8 73.6-132.8V151C512 67.6 444.4 0 361 0c-28.3 0-56 8-80.1 23L254.1 39.7c-30 18.7-39.1 58.2-20.4 88.2s58.2 39.1 88.2 20.4l26.8-16.8zM298.4 49.8c9.2-5.7 19.1-10.1 29.4-13.1L348 97.5c-5.7 1.4-11.2 3.7-16.3 6.8l-12.6 7.9L298.4 49.8zm88.5 52.7l46.2-46.2c8.5 6.5 16.1 14.1 22.6 22.6l-46.2 46.2c-5.1-9.6-13-17.5-22.6-22.6zm28.9 59.3l61.6 20.5c-2.2 10.5-5.8 20.7-10.5 30.2l-62-20.7c6.2-8.8 10.1-19.1 11-30.1zm-86.1 82.5l60.4 37.7-30.2 18.9-60.4-37.7 30.2-18.9zm-107.2 67l60.4 37.7-30.2 18.9-60.4-37.7 30.2-18.9zM119.3 375.7l60.4 37.7-30.2 18.9L89.1 394.6l30.2-18.9z"
    ]
};
var $d8206b3ab2e65c05$export$4229d00802c33062 = {
    prefix: "fas",
    iconName: "arrow-down-wide-short",
    icon: [
        576,
        512,
        [
            "sort-amount-asc",
            "sort-amount-down"
        ],
        "f160",
        "M151.6 469.6C145.5 476.2 137 480 128 480s-17.5-3.8-23.6-10.4l-88-96c-11.9-13-11.1-33.3 2-45.2s33.3-11.1 45.2 2L96 365.7V64c0-17.7 14.3-32 32-32s32 14.3 32 32V365.7l32.4-35.4c11.9-13 32.2-13.9 45.2-2s13.9 32.2 2 45.2l-88 96zM320 480c-17.7 0-32-14.3-32-32s14.3-32 32-32h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H320zm0-128c-17.7 0-32-14.3-32-32s14.3-32 32-32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H320zm0-128c-17.7 0-32-14.3-32-32s14.3-32 32-32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H320zm0-128c-17.7 0-32-14.3-32-32s14.3-32 32-32H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H320z"
    ]
};
var $d8206b3ab2e65c05$export$ddf8b8dd5983367d = $d8206b3ab2e65c05$export$4229d00802c33062;
var $d8206b3ab2e65c05$export$4b2a02d50e417b5f = $d8206b3ab2e65c05$export$4229d00802c33062;
var $d8206b3ab2e65c05$export$cdd116afa0309c17 = {
    prefix: "fas",
    iconName: "cloud-bolt",
    icon: [
        512,
        512,
        [
            127785,
            "thunderstorm"
        ],
        "f76c",
        "M0 224c0 53 43 96 96 96h47.2L290 202.5c17.6-14.1 42.6-14 60.2 .2s22.8 38.6 12.8 58.8L333.7 320H352h64c53 0 96-43 96-96s-43-96-96-96c-.5 0-1.1 0-1.6 0c1.1-5.2 1.6-10.5 1.6-16c0-44.2-35.8-80-80-80c-24.3 0-46.1 10.9-60.8 28C256.5 24.3 219.1 0 176 0C114.1 0 64 50.1 64 112c0 7.1 .7 14.1 1.9 20.8C27.6 145.4 0 181.5 0 224zm330.1 3.6c-5.8-4.7-14.2-4.7-20.1-.1l-160 128c-5.3 4.2-7.4 11.4-5.1 17.8s8.3 10.7 15.1 10.7h70.1L177.7 488.8c-3.4 6.7-1.6 14.9 4.3 19.6s14.2 4.7 20.1 .1l160-128c5.3-4.2 7.4-11.4 5.1-17.8s-8.3-10.7-15.1-10.7H281.9l52.4-104.8c3.4-6.7 1.6-14.9-4.2-19.6z"
    ]
};
var $d8206b3ab2e65c05$export$bbf9e3d433f8f6de = $d8206b3ab2e65c05$export$cdd116afa0309c17;
var $d8206b3ab2e65c05$export$ec658c0f040c3e1a = {
    prefix: "fas",
    iconName: "text-slash",
    icon: [
        640,
        512,
        [
            "remove-format"
        ],
        "f87d",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L355.7 253.5 400.2 96H503L497 120.2c-4.3 17.1 6.1 34.5 23.3 38.8s34.5-6.1 38.8-23.3l11-44.1C577.6 61.3 554.7 32 523.5 32H376.1h-.3H204.5c-22 0-41.2 15-46.6 36.4l-6.3 25.2L38.8 5.1zm168 131.7c.1-.3 .2-.7 .3-1L217 96H333.7L301.3 210.8l-94.5-74.1zM327.3 353.9L272.9 311 243.3 416H192c-17.7 0-32 14.3-32 32s14.3 32 32 32H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H309.8l17.6-62.1z"
    ]
};
var $d8206b3ab2e65c05$export$d91179f327329532 = $d8206b3ab2e65c05$export$ec658c0f040c3e1a;
var $d8206b3ab2e65c05$export$6143da800b0e6626 = {
    prefix: "fas",
    iconName: "face-smile-wink",
    icon: [
        512,
        512,
        [
            128521,
            "smile-wink"
        ],
        "f4da",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM164.1 325.5C182 346.2 212.6 368 256 368s74-21.8 91.9-42.5c5.8-6.7 15.9-7.4 22.6-1.6s7.4 15.9 1.6 22.6C349.8 372.1 311.1 400 256 400s-93.8-27.9-116.1-53.5c-5.8-6.7-5.1-16.8 1.6-22.6s16.8-5.1 22.6 1.6zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm156.4 25.6c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2c-17.6-23.5-52.8-23.5-70.4 0z"
    ]
};
var $d8206b3ab2e65c05$export$f5dbb37f6801ee3f = $d8206b3ab2e65c05$export$6143da800b0e6626;
var $d8206b3ab2e65c05$export$f0858dff6e769cf6 = {
    prefix: "fas",
    iconName: "file-word",
    icon: [
        384,
        512,
        [],
        "f1c2",
        "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM111 257.1l26.8 89.2 31.6-90.3c3.4-9.6 12.5-16.1 22.7-16.1s19.3 6.4 22.7 16.1l31.6 90.3L273 257.1c3.8-12.7 17.2-19.9 29.9-16.1s19.9 17.2 16.1 29.9l-48 160c-3 10-12 16.9-22.4 17.1s-19.8-6.2-23.2-16.1L192 336.6l-33.3 95.3c-3.4 9.8-12.8 16.3-23.2 16.1s-19.5-7.1-22.4-17.1l-48-160c-3.8-12.7 3.4-26.1 16.1-29.9s26.1 3.4 29.9 16.1z"
    ]
};
var $d8206b3ab2e65c05$export$c341daeecdea449a = {
    prefix: "fas",
    iconName: "file-powerpoint",
    icon: [
        384,
        512,
        [],
        "f1c4",
        "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM136 240h68c42 0 76 34 76 76s-34 76-76 76H160v32c0 13.3-10.7 24-24 24s-24-10.7-24-24V368 264c0-13.3 10.7-24 24-24zm68 104c15.5 0 28-12.5 28-28s-12.5-28-28-28H160v56h44z"
    ]
};
var $d8206b3ab2e65c05$export$672e2f590b189583 = {
    prefix: "fas",
    iconName: "arrows-left-right",
    icon: [
        512,
        512,
        [
            "arrows-h"
        ],
        "f07e",
        "M406.6 374.6l96-96c12.5-12.5 12.5-32.8 0-45.3l-96-96c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 224l-293.5 0 41.4-41.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 288l293.5 0-41.4 41.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0z"
    ]
};
var $d8206b3ab2e65c05$export$de517642cdb40354 = $d8206b3ab2e65c05$export$672e2f590b189583;
var $d8206b3ab2e65c05$export$aa54b16c409e882f = {
    prefix: "fas",
    iconName: "house-lock",
    icon: [
        640,
        512,
        [],
        "e510",
        "M384 480c0 11.7 3.1 22.6 8.6 32H392c-22.1 0-40-17.9-40-40V448 384c0-17.7-14.3-32-32-32H256c-17.7 0-32 14.3-32 32v64 24c0 22.1-17.9 40-40 40H160 128.1c-1.5 0-3-.1-4.5-.2c-1.2 .1-2.4 .2-3.6 .2H104c-22.1 0-40-17.9-40-40V360c0-.9 0-1.9 .1-2.8V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L490.7 166.3C447.2 181.7 416 223.2 416 272v24.6c-19.1 11.1-32 31.7-32 55.4V480zM528 240c-17.7 0-32 14.3-32 32v48h64V272c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80v48c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32V272z"
    ]
};
var $d8206b3ab2e65c05$export$542a9676c5286e01 = {
    prefix: "fas",
    iconName: "cloud-arrow-down",
    icon: [
        640,
        512,
        [
            62337,
            "cloud-download",
            "cloud-download-alt"
        ],
        "f0ed",
        "M144 480C64.5 480 0 415.5 0 336c0-62.8 40.2-116.2 96.2-135.9c-.1-2.7-.2-5.4-.2-8.1c0-88.4 71.6-160 160-160c59.3 0 111 32.2 138.7 80.2C409.9 102 428.3 96 448 96c53 0 96 43 96 96c0 12.2-2.3 23.8-6.4 34.6C596 238.4 640 290.1 640 352c0 70.7-57.3 128-128 128H144zm79-167l80 80c9.4 9.4 24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-39 39V184c0-13.3-10.7-24-24-24s-24 10.7-24 24V318.1l-39-39c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9z"
    ]
};
var $d8206b3ab2e65c05$export$b318977f29260464 = $d8206b3ab2e65c05$export$542a9676c5286e01;
var $d8206b3ab2e65c05$export$351357a14c41f824 = $d8206b3ab2e65c05$export$542a9676c5286e01;
var $d8206b3ab2e65c05$export$f2819bf60df55912 = {
    prefix: "fas",
    iconName: "children",
    icon: [
        640,
        512,
        [],
        "e4e1",
        "M160 0a64 64 0 1 1 0 128A64 64 0 1 1 160 0zM88 480V400H70.2c-10.9 0-18.6-10.7-15.2-21.1l31.1-93.4L57.5 323.3c-10.7 14.1-30.8 16.8-44.8 6.2s-16.8-30.7-6.2-44.8L65.4 207c22.4-29.6 57.5-47 94.6-47s72.2 17.4 94.6 47l58.9 77.7c10.7 14.1 7.9 34.2-6.2 44.8s-34.2 7.9-44.8-6.2l-28.6-37.8L265 378.9c3.5 10.4-4.3 21.1-15.2 21.1H232v80c0 17.7-14.3 32-32 32s-32-14.3-32-32V400H152v80c0 17.7-14.3 32-32 32s-32-14.3-32-32zM480 0a64 64 0 1 1 0 128A64 64 0 1 1 480 0zm-8 384v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V300.5L395.1 321c-9.4 15-29.2 19.4-44.1 10s-19.4-29.2-10-44.1l51.7-82.1c17.6-27.9 48.3-44.9 81.2-44.9h12.3c33 0 63.7 16.9 81.2 44.9L619.1 287c9.4 15 4.9 34.7-10 44.1s-34.7 4.9-44.1-10L552 300.5V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V384H472z"
    ]
};
var $d8206b3ab2e65c05$export$49a36efd66df775 = {
    prefix: "fas",
    iconName: "chalkboard",
    icon: [
        576,
        512,
        [
            "blackboard"
        ],
        "f51b",
        "M96 32C60.7 32 32 60.7 32 96V384H96V96l384 0V384h64V96c0-35.3-28.7-64-64-64H96zM224 384v32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H544c17.7 0 32-14.3 32-32s-14.3-32-32-32H416V384c0-17.7-14.3-32-32-32H256c-17.7 0-32 14.3-32 32z"
    ]
};
var $d8206b3ab2e65c05$export$f497e01bf522fd9c = $d8206b3ab2e65c05$export$49a36efd66df775;
var $d8206b3ab2e65c05$export$ae7fc6b7f0534be9 = {
    prefix: "fas",
    iconName: "user-large-slash",
    icon: [
        640,
        512,
        [
            "user-alt-slash"
        ],
        "f4fa",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L381.9 274c48.5-23.2 82.1-72.7 82.1-130C464 64.5 399.5 0 320 0C250.4 0 192.4 49.3 178.9 114.9L38.8 5.1zM545.5 512H528L284.3 320h-59C136.2 320 64 392.2 64 481.3c0 17 13.8 30.7 30.7 30.7H545.3l.3 0z"
    ]
};
var $d8206b3ab2e65c05$export$46185fab4772ada6 = $d8206b3ab2e65c05$export$ae7fc6b7f0534be9;
var $d8206b3ab2e65c05$export$c6c3bd5f7d9b8bf2 = {
    prefix: "fas",
    iconName: "envelope-open",
    icon: [
        512,
        512,
        [
            62135
        ],
        "f2b6",
        "M64 208.1L256 65.9 448 208.1v47.4L289.5 373c-9.7 7.2-21.4 11-33.5 11s-23.8-3.9-33.5-11L64 255.5V208.1zM256 0c-12.1 0-23.8 3.9-33.5 11L25.9 156.7C9.6 168.8 0 187.8 0 208.1V448c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V208.1c0-20.3-9.6-39.4-25.9-51.4L289.5 11C279.8 3.9 268.1 0 256 0z"
    ]
};
var $d8206b3ab2e65c05$export$e99ae494101c5e91 = {
    prefix: "fas",
    iconName: "handshake-simple-slash",
    icon: [
        640,
        512,
        [
            "handshake-alt-slash"
        ],
        "e05f",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-135-105.8c-1.1-11.3-6.3-22.3-15.3-30.7l-134.2-123-23.4 18.2-26-20.3 77.2-60.1c7-5.4 17-4.2 22.5 2.8s4.2 17-2.8 22.5l-20.9 16.2L550.2 352H592c26.5 0 48-21.5 48-48V176c0-26.5-21.5-48-48-48H516h-4-.7l-3.9-2.5L434.8 79c-15.3-9.8-33.2-15-51.4-15c-21.8 0-43 7.5-60 21.2l-89.7 72.6-25.8-20.3 81.8-66.2c-11.6-4.9-24.1-7.4-36.8-7.4C234 64 215.7 69.6 200 80l-35.5 23.7L38.8 5.1zM413.6 421.9L41.2 128.5C17.9 131.8 0 151.8 0 176V304c0 26.5 21.5 48 48 48H156.2l91.4 83.4c19.6 17.9 49.9 16.5 67.8-3.1c5.5-6.1 9.2-13.2 11.1-20.6l17 15.6c19.5 17.9 49.9 16.6 67.8-2.9c.8-.8 1.5-1.7 2.2-2.6z"
    ]
};
var $d8206b3ab2e65c05$export$ca302f956ae9f1bf = $d8206b3ab2e65c05$export$e99ae494101c5e91;
var $d8206b3ab2e65c05$export$f042d3e458efa721 = {
    prefix: "fas",
    iconName: "mattress-pillow",
    icon: [
        640,
        512,
        [],
        "e525",
        "M256 64H64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H256V64zm32 384H576c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H288V448zM64 160c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V160z"
    ]
};
var $d8206b3ab2e65c05$export$b731a51acb74b00c = {
    prefix: "fas",
    iconName: "guarani-sign",
    icon: [
        384,
        512,
        [],
        "e19a",
        "M192 0c-17.7 0-32 14.3-32 32V66.7C69.2 81.9 0 160.9 0 256s69.2 174.1 160 189.3V480c0 17.7 14.3 32 32 32s32-14.3 32-32V445.3c90.8-15.2 160-94.2 160-189.3c0-17.7-14.3-32-32-32H224V132c22.1 5.7 41.8 17.1 57.6 32.6c12.6 12.4 32.9 12.2 45.3-.4s12.2-32.9-.5-45.3C299 92 263.5 73.3 224 66.7V32c0-17.7-14.3-32-32-32zM160 132V380c-55.2-14.2-96-64.3-96-124s40.8-109.8 96-124zM224 380V288h92c-11.6 45-47 80.4-92 92z"
    ]
};
var $d8206b3ab2e65c05$export$2fd091cb98dc8ab8 = {
    prefix: "fas",
    iconName: "arrows-rotate",
    icon: [
        512,
        512,
        [
            128472,
            "refresh",
            "sync"
        ],
        "f021",
        "M105.1 202.6c7.7-21.8 20.2-42.3 37.8-59.8c62.5-62.5 163.8-62.5 226.3 0L386.3 160H352c-17.7 0-32 14.3-32 32s14.3 32 32 32H463.5c0 0 0 0 0 0h.4c17.7 0 32-14.3 32-32V80c0-17.7-14.3-32-32-32s-32 14.3-32 32v35.2L414.4 97.6c-87.5-87.5-229.3-87.5-316.8 0C73.2 122 55.6 150.7 44.8 181.4c-5.9 16.7 2.9 34.9 19.5 40.8s34.9-2.9 40.8-19.5zM39 289.3c-5 1.5-9.8 4.2-13.7 8.2c-4 4-6.7 8.8-8.1 14c-.3 1.2-.6 2.5-.8 3.8c-.3 1.7-.4 3.4-.4 5.1V432c0 17.7 14.3 32 32 32s32-14.3 32-32V396.9l17.6 17.5 0 0c87.5 87.4 229.3 87.4 316.7 0c24.4-24.4 42.1-53.1 52.9-83.7c5.9-16.7-2.9-34.9-19.5-40.8s-34.9 2.9-40.8 19.5c-7.7 21.8-20.2 42.3-37.8 59.8c-62.5 62.5-163.8 62.5-226.3 0l-.1-.1L125.6 352H160c17.7 0 32-14.3 32-32s-14.3-32-32-32H48.4c-1.6 0-3.2 .1-4.8 .3s-3.1 .5-4.6 1z"
    ]
};
var $d8206b3ab2e65c05$export$fd4359e93d7b3d14 = $d8206b3ab2e65c05$export$2fd091cb98dc8ab8;
var $d8206b3ab2e65c05$export$ff87319002e3dae9 = $d8206b3ab2e65c05$export$2fd091cb98dc8ab8;
var $d8206b3ab2e65c05$export$d75fb6743634a0a = {
    prefix: "fas",
    iconName: "fire-extinguisher",
    icon: [
        512,
        512,
        [
            129519
        ],
        "f134",
        "M500.3 7.3C507.7 13.3 512 22.4 512 32v96c0 9.6-4.3 18.7-11.7 24.7s-17.2 8.5-26.6 6.6l-160-32C301.5 124.9 292 115.7 289 104H224v34.8c37.8 18 64 56.5 64 101.2V384H64V240c0-44.7 26.2-83.2 64-101.2V110c-36.2 11.1-66 36.9-82.3 70.5c-5.8 11.9-20.2 16.9-32.1 11.1S-3.3 171.4 2.5 159.5C26.7 109.8 72.7 72.6 128 60.4V32c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32V56h65c3-11.7 12.5-20.9 24.7-23.4l160-32c9.4-1.9 19.1 .6 26.6 6.6zM288 416v32c0 35.3-28.7 64-64 64H128c-35.3 0-64-28.7-64-64V416H288zM176 96a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"
    ]
};
var $d8206b3ab2e65c05$export$64dd1b27affb6572 = {
    prefix: "fas",
    iconName: "cruzeiro-sign",
    icon: [
        448,
        512,
        [],
        "e152",
        "M96 256c0-88.4 71.6-160 160-160c41 0 78.3 15.4 106.7 40.7c13.2 11.8 33.4 10.7 45.2-2.5s10.7-33.4-2.5-45.2c-39.6-35.5-92-57-149.3-57C132.3 32 32 132.3 32 256s100.3 224 224 224c57.4 0 109.7-21.6 149.3-57c13.2-11.8 14.3-32 2.5-45.2s-32-14.3-45.2-2.5C334.3 400.6 297 416 256 416V320v-8.7c0-12.8 10.4-23.3 23.3-23.3c4.6 0 9.1 1.4 12.9 3.9l10.1 6.7c14.7 9.8 34.6 5.8 44.4-8.9s5.8-34.6-8.9-44.4l-10.1-6.7c-14.3-9.6-31.2-14.7-48.4-14.7c-12.4 0-24.2 2.6-34.9 7.3c-5.5-4.5-12.6-7.3-20.3-7.3c-17.7 0-32 14.3-32 32v55.3V320v82.7C135.5 378 96 321.6 96 256z"
    ]
};
var $d8206b3ab2e65c05$export$7bf8dfe2e6661a54 = {
    prefix: "fas",
    iconName: "greater-than-equal",
    icon: [
        448,
        512,
        [],
        "f532",
        "M52.1 93.7C35.7 87.1 27.7 68.5 34.3 52.1s25.2-24.4 41.6-17.8l320 128C408 167.1 416 178.9 416 192s-8 24.9-20.1 29.7l-320 128c-16.4 6.6-35-1.4-41.6-17.8s1.4-35 17.8-41.6L297.8 192 52.1 93.7zM416 416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H416z"
    ]
};
var $d8206b3ab2e65c05$export$36e034ccc72554a9 = {
    prefix: "fas",
    iconName: "shield-halved",
    icon: [
        512,
        512,
        [
            "shield-alt"
        ],
        "f3ed",
        "M256 0c4.6 0 9.2 1 13.4 2.9L457.7 82.8c22 9.3 38.4 31 38.3 57.2c-.5 99.2-41.3 280.7-213.6 363.2c-16.7 8-36.1 8-52.8 0C57.3 420.7 16.5 239.2 16 140c-.1-26.2 16.3-47.9 38.3-57.2L242.7 2.9C246.8 1 251.4 0 256 0zm0 66.8V444.8C394 378 431.1 230.1 432 141.4L256 66.8l0 0z"
    ]
};
var $d8206b3ab2e65c05$export$d6508d18a824f291 = $d8206b3ab2e65c05$export$36e034ccc72554a9;
var $d8206b3ab2e65c05$export$7fb8daedae341012 = {
    prefix: "fas",
    iconName: "book-atlas",
    icon: [
        448,
        512,
        [
            "atlas"
        ],
        "f558",
        "M0 96C0 43 43 0 96 0H384h32c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32v64c17.7 0 32 14.3 32 32s-14.3 32-32 32H384 96c-53 0-96-43-96-96V96zM64 416c0 17.7 14.3 32 32 32H352V384H96c-17.7 0-32 14.3-32 32zM247.4 283.8c-3.7 3.7-6.2 4.2-7.4 4.2s-3.7-.5-7.4-4.2c-3.8-3.7-8-10-11.8-18.9c-6.2-14.5-10.8-34.3-12.2-56.9h63c-1.5 22.6-6 42.4-12.2 56.9c-3.8 8.9-8 15.2-11.8 18.9zm42.7-9.9c7.3-18.3 12-41.1 13.4-65.9h31.1c-4.7 27.9-21.4 51.7-44.5 65.9zm0-163.8c23.2 14.2 39.9 38 44.5 65.9H303.5c-1.4-24.7-6.1-47.5-13.4-65.9zM368 192a128 128 0 1 0 -256 0 128 128 0 1 0 256 0zM145.3 208h31.1c1.4 24.7 6.1 47.5 13.4 65.9c-23.2-14.2-39.9-38-44.5-65.9zm31.1-32H145.3c4.7-27.9 21.4-51.7 44.5-65.9c-7.3 18.3-12 41.1-13.4 65.9zm56.1-75.8c3.7-3.7 6.2-4.2 7.4-4.2s3.7 .5 7.4 4.2c3.8 3.7 8 10 11.8 18.9c6.2 14.5 10.8 34.3 12.2 56.9h-63c1.5-22.6 6-42.4 12.2-56.9c3.8-8.9 8-15.2 11.8-18.9z"
    ]
};
var $d8206b3ab2e65c05$export$380a9050e42fe5d7 = $d8206b3ab2e65c05$export$7fb8daedae341012;
var $d8206b3ab2e65c05$export$37c67e0b3dc6bd1b = {
    prefix: "fas",
    iconName: "virus",
    icon: [
        512,
        512,
        [],
        "e074",
        "M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V43.5c0 49.9-60.3 74.9-95.6 39.6L120.2 75C107.7 62.5 87.5 62.5 75 75s-12.5 32.8 0 45.3l8.2 8.2C118.4 163.7 93.4 224 43.5 224H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H43.5c49.9 0 74.9 60.3 39.6 95.6L75 391.8c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l8.2-8.2c35.3-35.3 95.6-10.3 95.6 39.6V480c0 17.7 14.3 32 32 32s32-14.3 32-32V468.5c0-49.9 60.3-74.9 95.6-39.6l8.2 8.2c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-8.2-8.2c-35.3-35.3-10.3-95.6 39.6-95.6H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H468.5c-49.9 0-74.9-60.3-39.6-95.6l8.2-8.2c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-8.2 8.2C348.3 118.4 288 93.4 288 43.5V32zM176 224a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm128 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
    ]
};
var $d8206b3ab2e65c05$export$74d890536dbd21b7 = {
    prefix: "fas",
    iconName: "envelope-circle-check",
    icon: [
        640,
        512,
        [],
        "e4e8",
        "M48 64C21.5 64 0 85.5 0 112c0 15.1 7.1 29.3 19.2 38.4L236.8 313.6c11.4 8.5 27 8.5 38.4 0l57.4-43c23.9-59.8 79.7-103.3 146.3-109.8l13.9-10.4c12.1-9.1 19.2-23.3 19.2-38.4c0-26.5-21.5-48-48-48H48zM294.4 339.2c-22.8 17.1-54 17.1-76.8 0L0 176V384c0 35.3 28.7 64 64 64H360.2C335.1 417.6 320 378.5 320 336c0-5.6 .3-11.1 .8-16.6l-26.4 19.8zM640 336a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 353.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"
    ]
};
var $d8206b3ab2e65c05$export$a137712e11e257dd = {
    prefix: "fas",
    iconName: "layer-group",
    icon: [
        576,
        512,
        [],
        "f5fd",
        "M264.5 5.2c14.9-6.9 32.1-6.9 47 0l218.6 101c8.5 3.9 13.9 12.4 13.9 21.8s-5.4 17.9-13.9 21.8l-218.6 101c-14.9 6.9-32.1 6.9-47 0L45.9 149.8C37.4 145.8 32 137.3 32 128s5.4-17.9 13.9-21.8L264.5 5.2zM476.9 209.6l53.2 24.6c8.5 3.9 13.9 12.4 13.9 21.8s-5.4 17.9-13.9 21.8l-218.6 101c-14.9 6.9-32.1 6.9-47 0L45.9 277.8C37.4 273.8 32 265.3 32 256s5.4-17.9 13.9-21.8l53.2-24.6 152 70.2c23.4 10.8 50.4 10.8 73.8 0l152-70.2zm-152 198.2l152-70.2 53.2 24.6c8.5 3.9 13.9 12.4 13.9 21.8s-5.4 17.9-13.9 21.8l-218.6 101c-14.9 6.9-32.1 6.9-47 0L45.9 405.8C37.4 401.8 32 393.3 32 384s5.4-17.9 13.9-21.8l53.2-24.6 152 70.2c23.4 10.8 50.4 10.8 73.8 0z"
    ]
};
var $d8206b3ab2e65c05$export$ab3a06d4b53c0fc0 = {
    prefix: "fas",
    iconName: "arrows-to-dot",
    icon: [
        512,
        512,
        [],
        "e4be",
        "M256 0c17.7 0 32 14.3 32 32V64h32c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-64 64c-12.5 12.5-32.8 12.5-45.3 0l-64-64c-9.2-9.2-11.9-22.9-6.9-34.9s16.6-19.8 29.6-19.8h32V32c0-17.7 14.3-32 32-32zM169.4 393.4l64-64c12.5-12.5 32.8-12.5 45.3 0l64 64c9.2 9.2 11.9 22.9 6.9 34.9s-16.6 19.8-29.6 19.8H288v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V448H192c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9zM32 224H64V192c0-12.9 7.8-24.6 19.8-29.6s25.7-2.2 34.9 6.9l64 64c12.5 12.5 12.5 32.8 0 45.3l-64 64c-9.2 9.2-22.9 11.9-34.9 6.9s-19.8-16.6-19.8-29.6V288H32c-17.7 0-32-14.3-32-32s14.3-32 32-32zm297.4 54.6c-12.5-12.5-12.5-32.8 0-45.3l64-64c9.2-9.2 22.9-11.9 34.9-6.9s19.8 16.6 19.8 29.6v32h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H448v32c0 12.9-7.8 24.6-19.8 29.6s-25.7 2.2-34.9-6.9l-64-64zM256 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $d8206b3ab2e65c05$export$d56753dd2eb5c323 = {
    prefix: "fas",
    iconName: "archway",
    icon: [
        512,
        512,
        [],
        "f557",
        "M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H32zm0 384c-17.7 0-32 14.3-32 32s14.3 32 32 32H96h64V352c0-53 43-96 96-96s96 43 96 96V480h64 64c17.7 0 32-14.3 32-32s-14.3-32-32-32V128H32V416z"
    ]
};
var $d8206b3ab2e65c05$export$5e4b6785eedecc1a = {
    prefix: "fas",
    iconName: "heart-circle-check",
    icon: [
        576,
        512,
        [],
        "e4fd",
        "M47.6 300.4L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9l2.6-2.4C267.2 438.6 256 404.6 256 368c0-97.2 78.8-176 176-176c28.3 0 55 6.7 78.7 18.5c.9-6.5 1.3-13 1.3-19.6v-5.8c0-69.9-50.5-129.5-119.4-141C347 36.5 300.6 51.4 268 84L256 96 244 84c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5zM576 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L416 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"
    ]
};
var $d8206b3ab2e65c05$export$e824540f5a6a8a57 = {
    prefix: "fas",
    iconName: "house-chimney-crack",
    icon: [
        576,
        512,
        [
            "house-damage"
        ],
        "f6f1",
        "M575.8 255.5c0 18-15 32.1-32 32.1h-32l.7 160.2c.2 35.5-28.5 64.3-64 64.3H326.4L288 448l80.8-67.3c7.8-6.5 7.6-18.6-.4-24.9L250.6 263.2c-14.6-11.5-33.8 7-22.8 22L288 368l-85.5 71.2c-6.1 5-7.5 13.8-3.5 20.5L230.4 512H128.1c-35.3 0-64-28.7-64-64V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L416 100.7V64c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32V185l52.8 46.4c8 7 12 15 11 24z"
    ]
};
var $d8206b3ab2e65c05$export$8d7e943005ce0b49 = $d8206b3ab2e65c05$export$e824540f5a6a8a57;
var $d8206b3ab2e65c05$export$7a4a0e4caa1e4e6f = {
    prefix: "fas",
    iconName: "file-zipper",
    icon: [
        384,
        512,
        [
            "file-archive"
        ],
        "f1c6",
        "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM96 48c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16zm-6.3 71.8c3.7-14 16.4-23.8 30.9-23.8h14.8c14.5 0 27.2 9.7 30.9 23.8l23.5 88.2c1.4 5.4 2.1 10.9 2.1 16.4c0 35.2-28.8 63.7-64 63.7s-64-28.5-64-63.7c0-5.5 .7-11.1 2.1-16.4l23.5-88.2zM112 336c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H112z"
    ]
};
var $d8206b3ab2e65c05$export$bf2047a9946b5c3f = $d8206b3ab2e65c05$export$7a4a0e4caa1e4e6f;
var $d8206b3ab2e65c05$export$90b4406457aae8cc = {
    prefix: "fas",
    iconName: "square",
    icon: [
        448,
        512,
        [
            9632,
            9723,
            9724,
            61590
        ],
        "f0c8",
        "M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96z"
    ]
};
var $d8206b3ab2e65c05$export$a8a0de30198815a3 = {
    prefix: "fas",
    iconName: "martini-glass-empty",
    icon: [
        512,
        512,
        [
            "glass-martini"
        ],
        "f000",
        "M32 0C19.1 0 7.4 7.8 2.4 19.8s-2.2 25.7 6.9 34.9L224 269.3V448H160c-17.7 0-32 14.3-32 32s14.3 32 32 32h96 96c17.7 0 32-14.3 32-32s-14.3-32-32-32H288V269.3L502.6 54.6c9.2-9.2 11.9-22.9 6.9-34.9S492.9 0 480 0H32zM256 210.7L109.3 64H402.7L256 210.7z"
    ]
};
var $d8206b3ab2e65c05$export$e96f280e39af4a91 = $d8206b3ab2e65c05$export$a8a0de30198815a3;
var $d8206b3ab2e65c05$export$ce96e32767a7dd51 = {
    prefix: "fas",
    iconName: "couch",
    icon: [
        640,
        512,
        [],
        "f4b8",
        "M64 160C64 89.3 121.3 32 192 32H448c70.7 0 128 57.3 128 128v33.6c-36.5 7.4-64 39.7-64 78.4v48H128V272c0-38.7-27.5-71-64-78.4V160zM544 272c0-20.9 13.4-38.7 32-45.3c5-1.8 10.4-2.7 16-2.7c26.5 0 48 21.5 48 48V448c0 17.7-14.3 32-32 32H576c-17.7 0-32-14.3-32-32H96c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V272c0-26.5 21.5-48 48-48c5.6 0 11 1 16 2.7c18.6 6.6 32 24.4 32 45.3v48 32h32H512h32V320 272z"
    ]
};
var $d8206b3ab2e65c05$export$66c557f70914132c = {
    prefix: "fas",
    iconName: "cedi-sign",
    icon: [
        384,
        512,
        [],
        "e0df",
        "M256 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V66.7C101.2 81.9 32 160.9 32 256s69.2 174.1 160 189.3V480c0 17.7 14.3 32 32 32s32-14.3 32-32V445.3c30.9-5.2 59.2-17.7 83.2-35.8c14.1-10.6 17-30.7 6.4-44.8s-30.7-17-44.8-6.4c-13.2 9.9-28.3 17.3-44.8 21.6V132c16.4 4.2 31.6 11.6 44.8 21.6c14.1 10.6 34.2 7.8 44.8-6.4s7.8-34.2-6.4-44.8c-24-18-52.4-30.6-83.2-35.8V32zM192 132V380c-55.2-14.2-96-64.3-96-124s40.8-109.8 96-124z"
    ]
};
var $d8206b3ab2e65c05$export$16e344bae4d495ed = {
    prefix: "fas",
    iconName: "italic",
    icon: [
        384,
        512,
        [],
        "f033",
        "M128 64c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H293.3L160 416h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H90.7L224 96H160c-17.7 0-32-14.3-32-32z"
    ]
};
var $d8206b3ab2e65c05$export$16a3f12c6ae9650 = {
    prefix: "fas",
    iconName: "church",
    icon: [
        640,
        512,
        [
            9962
        ],
        "f51d",
        "M344 24c0-13.3-10.7-24-24-24s-24 10.7-24 24V48H264c-13.3 0-24 10.7-24 24s10.7 24 24 24h32v46.4L183.3 210c-14.5 8.7-23.3 24.3-23.3 41.2V512h96V416c0-35.3 28.7-64 64-64s64 28.7 64 64v96h96V251.2c0-16.9-8.8-32.5-23.3-41.2L344 142.4V96h32c13.3 0 24-10.7 24-24s-10.7-24-24-24H344V24zM24.9 330.3C9.5 338.8 0 354.9 0 372.4V464c0 26.5 21.5 48 48 48h80V273.6L24.9 330.3zM592 512c26.5 0 48-21.5 48-48V372.4c0-17.5-9.5-33.6-24.9-42.1L512 273.6V512h80z"
    ]
};
var $d8206b3ab2e65c05$export$d477129b070e5ac4 = {
    prefix: "fas",
    iconName: "comments-dollar",
    icon: [
        640,
        512,
        [],
        "f653",
        "M416 176c0 97.2-93.1 176-208 176c-38.2 0-73.9-8.7-104.7-23.9c-7.5 4-16 7.9-25.2 11.4C59.8 346.4 37.8 352 16 352c-6.9 0-13.1-4.5-15.2-11.1s.2-13.8 5.8-17.9l0 0 0 0 .2-.2c.2-.2 .6-.4 1.1-.8c1-.8 2.5-2 4.3-3.7c3.6-3.3 8.5-8.1 13.3-14.3c5.5-7 10.7-15.4 14.2-24.7C14.7 250.3 0 214.6 0 176C0 78.8 93.1 0 208 0S416 78.8 416 176zM231.5 383C348.9 372.9 448 288.3 448 176c0-5.2-.2-10.4-.6-15.5C555.1 167.1 640 243.2 640 336c0 38.6-14.7 74.3-39.6 103.4c3.5 9.4 8.7 17.7 14.2 24.7c4.8 6.2 9.7 11 13.3 14.3c1.8 1.6 3.3 2.9 4.3 3.7c.5 .4 .9 .7 1.1 .8l.2 .2 0 0 0 0c5.6 4.1 7.9 11.3 5.8 17.9c-2.1 6.6-8.3 11.1-15.2 11.1c-21.8 0-43.8-5.6-62.1-12.5c-9.2-3.5-17.8-7.4-25.2-11.4C505.9 503.3 470.2 512 432 512c-95.6 0-176.2-54.6-200.5-129zM228 72c0-11-9-20-20-20s-20 9-20 20V86c-7.6 1.7-15.2 4.4-22.2 8.5c-13.9 8.3-25.9 22.8-25.8 43.9c.1 20.3 12 33.1 24.7 40.7c11 6.6 24.7 10.8 35.6 14l1.7 .5c12.6 3.8 21.8 6.8 28 10.7c5.1 3.2 5.8 5.4 5.9 8.2c.1 5-1.8 8-5.9 10.5c-5 3.1-12.9 5-21.4 4.7c-11.1-.4-21.5-3.9-35.1-8.5c-2.3-.8-4.7-1.6-7.2-2.4c-10.5-3.5-21.8 2.2-25.3 12.6s2.2 21.8 12.6 25.3c1.9 .6 4 1.3 6.1 2.1l0 0 0 0c8.3 2.9 17.9 6.2 28.2 8.4V280c0 11 9 20 20 20s20-9 20-20V266.2c8-1.7 16-4.5 23.2-9c14.3-8.9 25.1-24.1 24.8-45c-.3-20.3-11.7-33.4-24.6-41.6c-11.5-7.2-25.9-11.6-37.1-15l-.7-.2c-12.8-3.9-21.9-6.7-28.3-10.5c-5.2-3.1-5.3-4.9-5.3-6.7c0-3.7 1.4-6.5 6.2-9.3c5.4-3.2 13.6-5.1 21.5-5c9.6 .1 20.2 2.2 31.2 5.2c10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-6.5-1.7-13.7-3.4-21.1-4.7V72z"
    ]
};
var $d8206b3ab2e65c05$export$a1672d808fbed0bd = {
    prefix: "fas",
    iconName: "democrat",
    icon: [
        640,
        512,
        [],
        "f747",
        "M64 32c0-8.9 3.8-20.9 6.2-27.3C71.2 1.8 74 0 77 0c1.9 0 3.8 .7 5.2 2.1L128 45.7 173.8 2.1C175.2 .7 177.1 0 179 0c3 0 5.8 1.8 6.8 4.7c2.4 6.5 6.2 18.4 6.2 27.3c0 26.5-21.9 42-29.5 46.6l76.2 72.6c6 5.7 13.9 8.8 22.1 8.8H480l32 0c40.3 0 78.2 19 102.4 51.2l19.2 25.6c10.6 14.1 7.7 34.2-6.4 44.8s-34.2 7.7-44.8-6.4l-19.2-25.6c-5.3-7-11.8-12.8-19.2-17V320H192l-40.4-94.3c-3.9-9.2-15.3-12.6-23.6-7l-42.1 28c-9.1 6.1-19.7 9.3-30.7 9.3h-2C23.9 256 0 232.1 0 202.7c0-12.1 4.1-23.8 11.7-33.3L87.6 74.6C78.1 67.4 64 53.2 64 32zM448 352h96v64 64c0 17.7-14.3 32-32 32H480c-17.7 0-32-14.3-32-32V416H288v64c0 17.7-14.3 32-32 32H224c-17.7 0-32-14.3-32-32V416 352h96H448zM260.9 210.9c-.9-1.8-2.8-2.9-4.8-2.9s-3.9 1.1-4.8 2.9l-10.5 20.5-23.5 3.3c-2 .3-3.7 1.6-4.3 3.5s-.1 3.9 1.3 5.3l17 16-4 22.6c-.3 1.9 .5 3.9 2.1 5s3.8 1.3 5.6 .4l21-10.7 21 10.7c1.8 .9 4 .8 5.6-.4s2.5-3.1 2.1-5l-4-22.6 17-16c1.5-1.4 2-3.4 1.3-5.3s-2.3-3.2-4.3-3.5l-23.5-3.3-10.5-20.5zM368.1 208c-2 0-3.9 1.1-4.8 2.9l-10.5 20.5-23.5 3.3c-2 .3-3.7 1.6-4.3 3.5s-.1 3.9 1.3 5.3l17 16-4 22.6c-.3 1.9 .5 3.9 2.1 5s3.8 1.3 5.6 .4l21-10.7 21 10.7c1.8 .9 4 .8 5.6-.4s2.5-3.1 2.1-5l-4-22.6 17-16c1.5-1.4 2-3.4 1.4-5.3s-2.3-3.2-4.3-3.5l-23.5-3.3-10.5-20.5c-.9-1.8-2.8-2.9-4.8-2.9zm116.8 2.9c-.9-1.8-2.8-2.9-4.8-2.9s-3.9 1.1-4.8 2.9l-10.5 20.5-23.5 3.3c-2 .3-3.7 1.6-4.3 3.5s-.1 3.9 1.3 5.3l17 16-4 22.6c-.3 1.9 .5 3.9 2.1 5s3.8 1.3 5.6 .4l21-10.7 21 10.7c1.8 .9 4 .8 5.6-.4s2.5-3.1 2.1-5l-4-22.6 17-16c1.5-1.4 2-3.4 1.4-5.3s-2.3-3.2-4.3-3.5l-23.5-3.3-10.5-20.5z"
    ]
};
var $d8206b3ab2e65c05$export$3481c1aa28972f9b = {
    prefix: "fas",
    iconName: "z",
    icon: [
        384,
        512,
        [
            122
        ],
        "5a",
        "M0 64C0 46.3 14.3 32 32 32H352c12.4 0 23.7 7.2 29 18.4s3.6 24.5-4.4 34.1L100.3 416H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-12.4 0-23.7-7.2-29-18.4s-3.6-24.5 4.4-34.1L283.7 96H32C14.3 96 0 81.7 0 64z"
    ]
};
var $d8206b3ab2e65c05$export$5ebd3cd0630e3ae7 = {
    prefix: "fas",
    iconName: "person-skiing",
    icon: [
        512,
        512,
        [
            9975,
            "skiing"
        ],
        "f7c9",
        "M380.7 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM2.7 268.9c6.1-11.8 20.6-16.3 32.4-10.2L232.7 361.3l46.2-69.2-75.1-75.1c-14.6-14.6-20.4-33.9-18.4-52.1l108.8 52 39.3 39.3c16.2 16.2 18.7 41.5 6 60.6L289.8 391l128.7 66.8c13.6 7.1 29.8 7.2 43.6 .3l15.2-7.6c11.9-5.9 26.3-1.1 32.2 10.7s1.1 26.3-10.7 32.2l-15.2 7.6c-27.5 13.7-59.9 13.5-87.2-.7L12.9 301.3C1.2 295.2-3.4 280.7 2.7 268.9zM118.9 65.6L137 74.2l8.7-17.4c4-7.9 13.6-11.1 21.5-7.2s11.1 13.6 7.2 21.5l-8.5 16.9 54.7 26.2c1.5-.7 3.1-1.4 4.7-2.1l83.4-33.4c34.2-13.7 72.8 4.2 84.5 39.2l17.1 51.2 52.1 26.1c15.8 7.9 22.2 27.1 14.3 42.9s-27.1 22.2-42.9 14.3l-58.1-29c-11.4-5.7-20-15.7-24.1-27.8l-5.8-17.3-27.3 12.1-6.8 3-6.7-3.2L151.5 116.7l-9.2 18.4c-4 7.9-13.6 11.1-21.5 7.2s-11.1-13.6-7.2-21.5l9-18-17.6-8.4c-8-3.8-11.3-13.4-7.5-21.3s13.4-11.3 21.3-7.5z"
    ]
};
var $d8206b3ab2e65c05$export$eae1acab6fb96708 = $d8206b3ab2e65c05$export$5ebd3cd0630e3ae7;
var $d8206b3ab2e65c05$export$b81a894d5bc3eb17 = {
    prefix: "fas",
    iconName: "road-lock",
    icon: [
        640,
        512,
        [],
        "e567",
        "M288 32H213.2c-27.1 0-51.3 17.1-60.3 42.6L35.1 407.2c-2.1 5.9-3.1 12-3.1 18.2C32 455.5 56.5 480 86.6 480H288V416c0-17.7 14.3-32 32-32s32 14.3 32 32v64h32V352c0-23.7 12.9-44.4 32-55.4V272c0-58.3 44.6-106.2 101.5-111.5L487.1 74.6C478 49.1 453.9 32 426.8 32H352V96c0 17.7-14.3 32-32 32s-32-14.3-32-32V32zm64 192v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V224c0-17.7 14.3-32 32-32s32 14.3 32 32zm176 16c17.7 0 32 14.3 32 32v48H496V272c0-17.7 14.3-32 32-32zm-80 32v48c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H608c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32V272c0-44.2-35.8-80-80-80s-80 35.8-80 80z"
    ]
};
var $d8206b3ab2e65c05$export$406fe05808a3753e = {
    prefix: "fas",
    iconName: "a",
    icon: [
        384,
        512,
        [
            97
        ],
        "41",
        "M221.5 51.7C216.6 39.8 204.9 32 192 32s-24.6 7.8-29.5 19.7l-120 288-40 96c-6.8 16.3 .9 35 17.2 41.8s35-.9 41.8-17.2L93.3 384H290.7l31.8 76.3c6.8 16.3 25.5 24 41.8 17.2s24-25.5 17.2-41.8l-40-96-120-288zM264 320H120l72-172.8L264 320z"
    ]
};
var $d8206b3ab2e65c05$export$4520eb1840c4e110 = {
    prefix: "fas",
    iconName: "temperature-arrow-down",
    icon: [
        576,
        512,
        [
            "temperature-down"
        ],
        "e03f",
        "M128 112c0-26.5 21.5-48 48-48s48 21.5 48 48V276.5c0 17.3 7.1 31.9 15.3 42.5C249.8 332.6 256 349.5 256 368c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-18.5 6.2-35.4 16.7-48.9c8.2-10.6 15.3-25.2 15.3-42.5V112zM176 0C114.1 0 64 50.1 64 112V276.4c0 .1-.1 .3-.2 .6c-.2 .6-.8 1.6-1.7 2.8C43.2 304.2 32 334.8 32 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-33.2-11.2-63.8-30.1-88.1c-.9-1.2-1.5-2.2-1.7-2.8c-.1-.3-.2-.5-.2-.6V112C288 50.1 237.9 0 176 0zm0 416c26.5 0 48-21.5 48-48c0-20.9-13.4-38.7-32-45.3V272c0-8.8-7.2-16-16-16s-16 7.2-16 16v50.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48zm336-64H480V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V352H384c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l64 64c6 6 14.1 9.4 22.6 9.4s16.6-3.4 22.6-9.4l64-64c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8z"
    ]
};
var $d8206b3ab2e65c05$export$f0b2aca3866f00f6 = $d8206b3ab2e65c05$export$4520eb1840c4e110;
var $d8206b3ab2e65c05$export$2a9d3e120019c92d = {
    prefix: "fas",
    iconName: "feather-pointed",
    icon: [
        512,
        512,
        [
            "feather-alt"
        ],
        "f56b",
        "M278.5 215.6L23 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l74.8-74.8c7.4 4.6 15.3 8.2 23.8 10.5C200.3 452.8 270 454.5 338 409.4c12.2-8.1 5.8-25.4-8.8-25.4l-16.1 0c-5.1 0-9.2-4.1-9.2-9.2c0-4.1 2.7-7.6 6.5-8.8l97.7-29.3c3.4-1 6.4-3.1 8.4-6.1c4.4-6.4 8.6-12.9 12.6-19.6c6.2-10.3-1.5-23-13.5-23l-38.6 0c-5.1 0-9.2-4.1-9.2-9.2c0-4.1 2.7-7.6 6.5-8.8l80.9-24.3c4.6-1.4 8.4-4.8 10.2-9.3C494.5 163 507.8 86.1 511.9 36.8c.8-9.9-3-19.6-10-26.6s-16.7-10.8-26.6-10C391.5 7 228.5 40.5 137.4 131.6C57.3 211.7 56.7 302.3 71.3 356.4c2.1 7.9 12 9.6 17.8 3.8L253.6 195.8c6.2-6.2 16.4-6.2 22.6 0c5.4 5.4 6.1 13.6 2.2 19.8z"
    ]
};
var $d8206b3ab2e65c05$export$68cf766c786bcd78 = $d8206b3ab2e65c05$export$2a9d3e120019c92d;
var $d8206b3ab2e65c05$export$bcb419f1cd5beac3 = {
    prefix: "fas",
    iconName: "p",
    icon: [
        320,
        512,
        [
            112
        ],
        "50",
        "M0 96C0 60.7 28.7 32 64 32h96c88.4 0 160 71.6 160 160s-71.6 160-160 160H64v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V320 96zM64 288h96c53 0 96-43 96-96s-43-96-96-96H64V288z"
    ]
};
var $d8206b3ab2e65c05$export$bab8f3647c394f48 = {
    prefix: "fas",
    iconName: "snowflake",
    icon: [
        448,
        512,
        [
            10052,
            10054
        ],
        "f2dc",
        "M224 0c17.7 0 32 14.3 32 32V62.1l15-15c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-49 49v70.3l61.4-35.8 17.7-66.1c3.4-12.8 16.6-20.4 29.4-17s20.4 16.6 17 29.4l-5.2 19.3 23.6-13.8c15.3-8.9 34.9-3.7 43.8 11.5s3.8 34.9-11.5 43.8l-25.3 14.8 21.7 5.8c12.8 3.4 20.4 16.6 17 29.4s-16.6 20.4-29.4 17l-67.7-18.1L287.5 256l60.9 35.5 67.7-18.1c12.8-3.4 26 4.2 29.4 17s-4.2 26-17 29.4l-21.7 5.8 25.3 14.8c15.3 8.9 20.4 28.5 11.5 43.8s-28.5 20.4-43.8 11.5l-23.6-13.8 5.2 19.3c3.4 12.8-4.2 26-17 29.4s-26-4.2-29.4-17l-17.7-66.1L256 311.7v70.3l49 49c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-15-15V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V449.9l-15 15c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l49-49V311.7l-61.4 35.8-17.7 66.1c-3.4 12.8-16.6 20.4-29.4 17s-20.4-16.6-17-29.4l5.2-19.3L48.1 395.6c-15.3 8.9-34.9 3.7-43.8-11.5s-3.7-34.9 11.5-43.8l25.3-14.8-21.7-5.8c-12.8-3.4-20.4-16.6-17-29.4s16.6-20.4 29.4-17l67.7 18.1L160.5 256 99.6 220.5 31.9 238.6c-12.8 3.4-26-4.2-29.4-17s4.2-26 17-29.4l21.7-5.8L15.9 171.6C.6 162.7-4.5 143.1 4.4 127.9s28.5-20.4 43.8-11.5l23.6 13.8-5.2-19.3c-3.4-12.8 4.2-26 17-29.4s26 4.2 29.4 17l17.7 66.1L192 200.3V129.9L143 81c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l15 15V32c0-17.7 14.3-32 32-32z"
    ]
};
var $d8206b3ab2e65c05$export$d91b374112d4f8c1 = {
    prefix: "fas",
    iconName: "newspaper",
    icon: [
        512,
        512,
        [
            128240
        ],
        "f1ea",
        "M96 96c0-35.3 28.7-64 64-64H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H80c-44.2 0-80-35.8-80-80V128c0-17.7 14.3-32 32-32s32 14.3 32 32V400c0 8.8 7.2 16 16 16s16-7.2 16-16V96zm64 24v80c0 13.3 10.7 24 24 24H296c13.3 0 24-10.7 24-24V120c0-13.3-10.7-24-24-24H184c-13.3 0-24 10.7-24 24zm208-8c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H384c-8.8 0-16 7.2-16 16zm0 96c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H384c-8.8 0-16 7.2-16 16zM160 304c0 8.8 7.2 16 16 16H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zm0 96c0 8.8 7.2 16 16 16H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H176c-8.8 0-16 7.2-16 16z"
    ]
};
var $d8206b3ab2e65c05$export$d0ccaddca9e06d1e = {
    prefix: "fas",
    iconName: "rectangle-ad",
    icon: [
        576,
        512,
        [
            "ad"
        ],
        "f641",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM229.5 173.3l72 144c5.9 11.9 1.1 26.3-10.7 32.2s-26.3 1.1-32.2-10.7L253.2 328H162.8l-5.4 10.7c-5.9 11.9-20.3 16.7-32.2 10.7s-16.7-20.3-10.7-32.2l72-144c4.1-8.1 12.4-13.3 21.5-13.3s17.4 5.1 21.5 13.3zM208 237.7L186.8 280h42.3L208 237.7zM392 256a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm24-43.9V184c0-13.3 10.7-24 24-24s24 10.7 24 24v96 48c0 13.3-10.7 24-24 24c-6.6 0-12.6-2.7-17-7c-9.4 4.5-19.9 7-31 7c-39.8 0-72-32.2-72-72s32.2-72 72-72c8.4 0 16.5 1.4 24 4.1z"
    ]
};
var $d8206b3ab2e65c05$export$7af266c3465b1ff2 = $d8206b3ab2e65c05$export$d0ccaddca9e06d1e;
var $d8206b3ab2e65c05$export$2f1e22e081a1ad05 = {
    prefix: "fas",
    iconName: "circle-arrow-right",
    icon: [
        512,
        512,
        [
            "arrow-circle-right"
        ],
        "f0a9",
        "M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM281 385c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l71-71L136 280c-13.3 0-24-10.7-24-24s10.7-24 24-24l182.1 0-71-71c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L393 239c9.4 9.4 9.4 24.6 0 33.9L281 385z"
    ]
};
var $d8206b3ab2e65c05$export$7d3d828103aa3be7 = $d8206b3ab2e65c05$export$2f1e22e081a1ad05;
var $d8206b3ab2e65c05$export$fb5ab619c34ea613 = {
    prefix: "fas",
    iconName: "filter-circle-xmark",
    icon: [
        576,
        512,
        [],
        "e17b",
        "M3.9 22.9C10.5 8.9 24.5 0 40 0H472c15.5 0 29.5 8.9 36.1 22.9s4.6 30.5-5.2 42.5L396.4 195.6C316.2 212.1 256 283 256 368c0 27.4 6.3 53.4 17.5 76.5c-1.6-.8-3.2-1.8-4.7-2.9l-64-48c-8.1-6-12.8-15.5-12.8-25.6V288.9L9 65.3C-.7 53.4-2.8 36.8 3.9 22.9zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm59.3 107.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L432 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L409.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L432 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L454.6 368l36.7-36.7z"
    ]
};
var $d8206b3ab2e65c05$export$4982360d3b844c19 = {
    prefix: "fas",
    iconName: "locust",
    icon: [
        576,
        512,
        [],
        "e520",
        "M312 32c-13.3 0-24 10.7-24 24s10.7 24 24 24h16c98.7 0 180.6 71.4 197 165.4c-9-3.5-18.8-5.4-29-5.4H431.8l-41.8-97.5c-3.4-7.9-10.8-13.4-19.3-14.4s-17 2.7-22.1 9.6l-40.9 55.5-21.7-50.7c-3.3-7.8-10.5-13.2-18.9-14.3s-16.7 2.3-22 8.9l-240 304c-8.2 10.4-6.4 25.5 4 33.7s25.5 6.4 33.7-4l79.4-100.5 43 16.4-40.5 55c-7.9 10.7-5.6 25.7 5.1 33.6s25.7 5.6 33.6-5.1L215.1 400h74.5l-29.3 42.3c-7.5 10.9-4.8 25.8 6.1 33.4s25.8 4.8 33.4-6.1L348 400h80.4l38.8 67.9c6.6 11.5 21.2 15.5 32.7 8.9s15.5-21.2 8.9-32.7L483.6 400H496c44.1 0 79.8-35.7 80-79.7c0-.1 0-.2 0-.3V280C576 143 465 32 328 32H312zm50.5 168l17.1 40H333l29.5-40zm-87.7 38.1l-1.4 1.9H225.1l32.7-41.5 16.9 39.5zM88.8 240C57.4 240 32 265.4 32 296.8c0 15.5 6.3 30 16.9 40.4L126.7 240H88.8zM496 288a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"
    ]
};
var $d8206b3ab2e65c05$export$4941c5969d5399b = {
    prefix: "fas",
    iconName: "sort",
    icon: [
        320,
        512,
        [
            "unsorted"
        ],
        "f0dc",
        "M137.4 41.4c12.5-12.5 32.8-12.5 45.3 0l128 128c9.2 9.2 11.9 22.9 6.9 34.9s-16.6 19.8-29.6 19.8H32c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9l128-128zm0 429.3l-128-128c-9.2-9.2-11.9-22.9-6.9-34.9s16.6-19.8 29.6-19.8H288c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-128 128c-12.5 12.5-32.8 12.5-45.3 0z"
    ]
};
var $d8206b3ab2e65c05$export$418597748f0fe52d = $d8206b3ab2e65c05$export$4941c5969d5399b;
var $d8206b3ab2e65c05$export$3db8f67cd0fc963b = {
    prefix: "fas",
    iconName: "list-ol",
    icon: [
        512,
        512,
        [
            "list-1-2",
            "list-numeric"
        ],
        "f0cb",
        "M24 56c0-13.3 10.7-24 24-24H80c13.3 0 24 10.7 24 24V176h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H40c-13.3 0-24-10.7-24-24s10.7-24 24-24H56V80H48C34.7 80 24 69.3 24 56zM86.7 341.2c-6.5-7.4-18.3-6.9-24 1.2L51.5 357.9c-7.7 10.8-22.7 13.3-33.5 5.6s-13.3-22.7-5.6-33.5l11.1-15.6c23.7-33.2 72.3-35.6 99.2-4.9c21.3 24.4 20.8 60.9-1.1 84.7L86.8 432H120c13.3 0 24 10.7 24 24s-10.7 24-24 24H32c-9.5 0-18.2-5.6-22-14.4s-2.1-18.9 4.3-25.9l72-78c5.3-5.8 5.4-14.6 .3-20.5zM224 64H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 160H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 160H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
    ]
};
var $d8206b3ab2e65c05$export$7e3d894cd55296b = $d8206b3ab2e65c05$export$3db8f67cd0fc963b;
var $d8206b3ab2e65c05$export$cf51408faadac277 = $d8206b3ab2e65c05$export$3db8f67cd0fc963b;
var $d8206b3ab2e65c05$export$523180e731928397 = {
    prefix: "fas",
    iconName: "person-dress-burst",
    icon: [
        640,
        512,
        [],
        "e544",
        "M528 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM390.2 384H408v96c0 17.7 14.3 32 32 32s32-14.3 32-32V384h16v96c0 17.7 14.3 32 32 32s32-14.3 32-32V384h17.8c10.9 0 18.6-10.7 15.2-21.1L546.7 248.1l33.9 56.3c9.1 15.1 28.8 20 43.9 10.9s20-28.8 10.9-43.9l-53.6-89.2c-20.2-33.7-56.7-54.3-96-54.3H474.2c-39.3 0-75.7 20.6-96 54.3l-53.6 89.2c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9l33.9-56.3L375 362.9c-3.5 10.4 4.3 21.1 15.2 21.1zM190.9 18.1C188.4 12 182.6 8 176 8s-12.4 4-14.9 10.1l-29.4 74L55.6 68.9c-6.3-1.9-13.1 .2-17.2 5.3s-4.6 12.2-1.4 17.9l39.5 69.1L10.9 206.4c-5.4 3.7-8 10.3-6.5 16.7s6.7 11.2 13.1 12.2l78.7 12.2L90.6 327c-.5 6.5 3.1 12.7 9 15.5s12.9 1.8 17.8-2.6L176 286.1l58.6 53.9c4.8 4.4 11.9 5.5 17.8 2.6s9.5-9 9-15.5l-5.6-79.4 50.5-7.8 24.4-40.5-55.2-38L315 92.2c3.3-5.7 2.7-12.8-1.4-17.9s-10.9-7.2-17.2-5.3L220.3 92.1l-29.4-74z"
    ]
};
var $d8206b3ab2e65c05$export$eeb59dd1825c6a65 = {
    prefix: "fas",
    iconName: "money-check-dollar",
    icon: [
        576,
        512,
        [
            "money-check-alt"
        ],
        "f53d",
        "M64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zM272 192H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H272c-8.8 0-16-7.2-16-16s7.2-16 16-16zM256 304c0-8.8 7.2-16 16-16H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H272c-8.8 0-16-7.2-16-16zM164 152v13.9c7.5 1.2 14.6 2.9 21.1 4.7c10.7 2.8 17 13.8 14.2 24.5s-13.8 17-24.5 14.2c-11-2.9-21.6-5-31.2-5.2c-7.9-.1-16 1.8-21.5 5c-4.8 2.8-6.2 5.6-6.2 9.3c0 1.8 .1 3.5 5.3 6.7c6.3 3.8 15.5 6.7 28.3 10.5l.7 .2c11.2 3.4 25.6 7.7 37.1 15c12.9 8.1 24.3 21.3 24.6 41.6c.3 20.9-10.5 36.1-24.8 45c-7.2 4.5-15.2 7.3-23.2 9V360c0 11-9 20-20 20s-20-9-20-20V345.4c-10.3-2.2-20-5.5-28.2-8.4l0 0 0 0c-2.1-.7-4.1-1.4-6.1-2.1c-10.5-3.5-16.1-14.8-12.6-25.3s14.8-16.1 25.3-12.6c2.5 .8 4.9 1.7 7.2 2.4c13.6 4.6 24 8.1 35.1 8.5c8.6 .3 16.5-1.6 21.4-4.7c4.1-2.5 6-5.5 5.9-10.5c0-2.9-.8-5-5.9-8.2c-6.3-4-15.4-6.9-28-10.7l-1.7-.5c-10.9-3.3-24.6-7.4-35.6-14c-12.7-7.7-24.6-20.5-24.7-40.7c-.1-21.1 11.8-35.7 25.8-43.9c6.9-4.1 14.5-6.8 22.2-8.5V152c0-11 9-20 20-20s20 9 20 20z"
    ]
};
var $d8206b3ab2e65c05$export$8c6ccc9745897cb2 = $d8206b3ab2e65c05$export$eeb59dd1825c6a65;
var $d8206b3ab2e65c05$export$567d5631a7b0599f = {
    prefix: "fas",
    iconName: "vector-square",
    icon: [
        448,
        512,
        [],
        "f5cb",
        "M368 80h32v32H368V80zM352 32c-17.7 0-32 14.3-32 32H128c0-17.7-14.3-32-32-32H32C14.3 32 0 46.3 0 64v64c0 17.7 14.3 32 32 32V352c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H96c17.7 0 32-14.3 32-32H320c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V384c0-17.7-14.3-32-32-32V160c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H352zM96 160c17.7 0 32-14.3 32-32H320c0 17.7 14.3 32 32 32V352c-17.7 0-32 14.3-32 32H128c0-17.7-14.3-32-32-32V160zM48 400H80v32H48V400zm320 32V400h32v32H368zM48 112V80H80v32H48z"
    ]
};
var $d8206b3ab2e65c05$export$d78e8b0681279167 = {
    prefix: "fas",
    iconName: "bread-slice",
    icon: [
        512,
        512,
        [],
        "f7ec",
        "M256 32C192 32 0 64 0 192c0 35.3 28.7 64 64 64V432c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48V256c35.3 0 64-28.7 64-64C512 64 320 32 256 32z"
    ]
};
var $d8206b3ab2e65c05$export$8a7bee49fdf8c954 = {
    prefix: "fas",
    iconName: "language",
    icon: [
        640,
        512,
        [],
        "f1ab",
        "M0 128C0 92.7 28.7 64 64 64H256h48 16H576c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H320 304 256 64c-35.3 0-64-28.7-64-64V128zm320 0V384H576V128H320zM178.3 175.9c-3.2-7.2-10.4-11.9-18.3-11.9s-15.1 4.7-18.3 11.9l-64 144c-4.5 10.1 .1 21.9 10.2 26.4s21.9-.1 26.4-10.2l8.9-20.1h73.6l8.9 20.1c4.5 10.1 16.3 14.6 26.4 10.2s14.6-16.3 10.2-26.4l-64-144zM160 233.2L179 276H141l19-42.8zM448 164c11 0 20 9 20 20v4h44 16c11 0 20 9 20 20s-9 20-20 20h-2l-1.6 4.5c-8.9 24.4-22.4 46.6-39.6 65.4c.9 .6 1.8 1.1 2.7 1.6l18.9 11.3c9.5 5.7 12.5 18 6.9 27.4s-18 12.5-27.4 6.9l-18.9-11.3c-4.5-2.7-8.8-5.5-13.1-8.5c-10.6 7.5-21.9 14-34 19.4l-3.6 1.6c-10.1 4.5-21.9-.1-26.4-10.2s.1-21.9 10.2-26.4l3.6-1.6c6.4-2.9 12.6-6.1 18.5-9.8l-12.2-12.2c-7.8-7.8-7.8-20.5 0-28.3s20.5-7.8 28.3 0l14.6 14.6 .5 .5c12.4-13.1 22.5-28.3 29.8-45H448 376c-11 0-20-9-20-20s9-20 20-20h52v-4c0-11 9-20 20-20z"
    ]
};
var $d8206b3ab2e65c05$export$611ae61f02de0aa = {
    prefix: "fas",
    iconName: "face-kiss-wink-heart",
    icon: [
        512,
        512,
        [
            128536,
            "kiss-wink-heart"
        ],
        "f598",
        "M498 339.7c9.1-26.2 14-54.4 14-83.7C512 114.6 397.4 0 256 0S0 114.6 0 256S114.6 512 256 512c35.4 0 69.1-7.2 99.7-20.2c-4.8-5.5-8.5-12.2-10.4-19.7l-22.9-89.3c-10-39 11.8-80.9 51.8-92.1c37.2-10.4 73.8 10.1 87.5 44c12.7-1.6 25.1 .4 36.2 5zM296 332c0 6.9-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4c-2.7 1.5-5.7 3-8.7 4.3c3.1 1.3 6 2.7 8.7 4.3c6.6 3.7 12.5 8.2 16.7 13.4c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4C258.7 443.1 241.4 448 224 448c-3.6 0-6.8-2.5-7.7-6s.6-7.2 3.8-9l0 0 0 0 0 0 0 0 .2-.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1l-.6-.4-.3-.2-.2-.1 0 0 0 0 0 0c-2.5-1.4-4.1-4.1-4.1-7s1.6-5.6 4.1-7l0 0 0 0 0 0 0 0 0 0 .2-.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1c-.4-.2-.7-.4-.9-.5l-.2-.1 0 0 0 0 0 0c-3.2-1.8-4.7-5.5-3.8-9s4.1-6 7.7-6c17.4 0 34.7 4.9 47.9 12.3c6.6 3.7 12.5 8.2 16.7 13.4c4.3 5.1 7.3 11.4 7.3 18.3zM176.4 176a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm194.8 57.6c-17.6-23.5-52.8-23.5-70.4 0c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2zM434 352.3c-6-23.2-28.8-37-51.1-30.8s-35.4 30.1-29.5 53.4l22.9 89.3c2.2 8.7 11.2 13.9 19.8 11.4l84.9-23.8c22.2-6.2 35.4-30.1 29.5-53.4s-28.8-37-51.1-30.8l-20.2 5.6-5.4-21z"
    ]
};
var $d8206b3ab2e65c05$export$ebba617701dfb917 = $d8206b3ab2e65c05$export$611ae61f02de0aa;
var $d8206b3ab2e65c05$export$f253a38d7142e29f = {
    prefix: "fas",
    iconName: "filter",
    icon: [
        512,
        512,
        [],
        "f0b0",
        "M3.9 54.9C10.5 40.9 24.5 32 40 32H472c15.5 0 29.5 8.9 36.1 22.9s4.6 30.5-5.2 42.5L320 320.9V448c0 12.1-6.8 23.2-17.7 28.6s-23.8 4.3-33.5-3l-64-48c-8.1-6-12.8-15.5-12.8-25.6V320.9L9 97.3C-.7 85.4-2.8 68.8 3.9 54.9z"
    ]
};
var $d8206b3ab2e65c05$export$d96973f90e8f6e47 = {
    prefix: "fas",
    iconName: "question",
    icon: [
        320,
        512,
        [
            10067,
            10068,
            61736
        ],
        "3f",
        "M80 160c0-35.3 28.7-64 64-64h32c35.3 0 64 28.7 64 64v3.6c0 21.8-11.1 42.1-29.4 53.8l-42.2 27.1c-25.2 16.2-40.4 44.1-40.4 74V320c0 17.7 14.3 32 32 32s32-14.3 32-32v-1.4c0-8.2 4.2-15.8 11-20.2l42.2-27.1c36.6-23.6 58.8-64.1 58.8-107.7V160c0-70.7-57.3-128-128-128H144C73.3 32 16 89.3 16 160c0 17.7 14.3 32 32 32s32-14.3 32-32zm80 320a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"
    ]
};
var $d8206b3ab2e65c05$export$d0de575ac166712b = {
    prefix: "fas",
    iconName: "file-signature",
    icon: [
        576,
        512,
        [],
        "f573",
        "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V428.7c-2.7 1.1-5.4 2-8.2 2.7l-60.1 15c-3 .7-6 1.2-9 1.4c-.9 .1-1.8 .2-2.7 .2H240c-6.1 0-11.6-3.4-14.3-8.8l-8.8-17.7c-1.7-3.4-5.1-5.5-8.8-5.5s-7.2 2.1-8.8 5.5l-8.8 17.7c-2.9 5.9-9.2 9.4-15.7 8.8s-12.1-5.1-13.9-11.3L144 381l-9.8 32.8c-6.1 20.3-24.8 34.2-46 34.2H80c-8.8 0-16-7.2-16-16s7.2-16 16-16h8.2c7.1 0 13.3-4.6 15.3-11.4l14.9-49.5c3.4-11.3 13.8-19.1 25.6-19.1s22.2 7.8 25.6 19.1l11.6 38.6c7.4-6.2 16.8-9.7 26.8-9.7c15.9 0 30.4 9 37.5 23.2l4.4 8.8h8.9c-3.1-8.8-3.7-18.4-1.4-27.8l15-60.1c2.8-11.3 8.6-21.5 16.8-29.7L384 203.6V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM549.8 139.7c-15.6-15.6-40.9-15.6-56.6 0l-29.4 29.4 71 71 29.4-29.4c15.6-15.6 15.6-40.9 0-56.6l-14.4-14.4zM311.9 321c-4.1 4.1-7 9.2-8.4 14.9l-15 60.1c-1.4 5.5 .2 11.2 4.2 15.2s9.7 5.6 15.2 4.2l60.1-15c5.6-1.4 10.8-4.3 14.9-8.4L512.1 262.7l-71-71L311.9 321z"
    ]
};
var $d8206b3ab2e65c05$export$cd7b22f4e6e3834b = {
    prefix: "fas",
    iconName: "up-down-left-right",
    icon: [
        512,
        512,
        [
            "arrows-alt"
        ],
        "f0b2",
        "M278.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-64 64c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8h32v96H128V192c0-12.9-7.8-24.6-19.8-29.6s-25.7-2.2-34.9 6.9l-64 64c-12.5 12.5-12.5 32.8 0 45.3l64 64c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6V288h96v96H192c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l64 64c12.5 12.5 32.8 12.5 45.3 0l64-64c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8H288V288h96v32c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l64-64c12.5-12.5 12.5-32.8 0-45.3l-64-64c-9.2-9.2-22.9-11.9-34.9-6.9s-19.8 16.6-19.8 29.6v32H288V128h32c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-64-64z"
    ]
};
var $d8206b3ab2e65c05$export$3cdabfff52cfc73a = $d8206b3ab2e65c05$export$cd7b22f4e6e3834b;
var $d8206b3ab2e65c05$export$1ddbaebce033a0d = {
    prefix: "fas",
    iconName: "house-chimney-user",
    icon: [
        576,
        512,
        [],
        "e065",
        "M543.8 287.6c17 0 32-14 32-32.1c1-9-3-17-11-24L512 185V64c0-17.7-14.3-32-32-32H448c-17.7 0-32 14.3-32 32v36.7L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24c0 18 14 32.1 32 32.1h32V448c0 35.3 28.7 64 64 64H448.5c35.5 0 64.2-28.8 64-64.3l-.7-160.2h32zM288 160a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM176 400c0-44.2 35.8-80 80-80h64c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16H192c-8.8 0-16-7.2-16-16z"
    ]
};
var $d8206b3ab2e65c05$export$97e5ef3e80a0fbef = {
    prefix: "fas",
    iconName: "hand-holding-heart",
    icon: [
        576,
        512,
        [],
        "f4be",
        "M163.9 136.9c-29.4-29.8-29.4-78.2 0-108s77-29.8 106.4 0l17.7 18 17.7-18c29.4-29.8 77-29.8 106.4 0s29.4 78.2 0 108L310.5 240.1c-6.2 6.3-14.3 9.4-22.5 9.4s-16.3-3.1-22.5-9.4L163.9 136.9zM568.2 336.3c13.1 17.8 9.3 42.8-8.5 55.9L433.1 485.5c-23.4 17.2-51.6 26.5-80.7 26.5H192 32c-17.7 0-32-14.3-32-32V416c0-17.7 14.3-32 32-32H68.8l44.9-36c22.7-18.2 50.9-28 80-28H272h16 64c17.7 0 32 14.3 32 32s-14.3 32-32 32H288 272c-8.8 0-16 7.2-16 16s7.2 16 16 16H392.6l119.7-88.2c17.8-13.1 42.8-9.3 55.9 8.5zM193.6 384l0 0-.9 0c.3 0 .6 0 .9 0z"
    ]
};
var $d8206b3ab2e65c05$export$7ee0dbd1e92e2859 = {
    prefix: "fas",
    iconName: "puzzle-piece",
    icon: [
        512,
        512,
        [
            129513
        ],
        "f12e",
        "M192 104.8c0-9.2-5.8-17.3-13.2-22.8C167.2 73.3 160 61.3 160 48c0-26.5 28.7-48 64-48s64 21.5 64 48c0 13.3-7.2 25.3-18.8 34c-7.4 5.5-13.2 13.6-13.2 22.8c0 12.8 10.4 23.2 23.2 23.2H336c26.5 0 48 21.5 48 48v56.8c0 12.8 10.4 23.2 23.2 23.2c9.2 0 17.3-5.8 22.8-13.2c8.7-11.6 20.7-18.8 34-18.8c26.5 0 48 28.7 48 64s-21.5 64-48 64c-13.3 0-25.3-7.2-34-18.8c-5.5-7.4-13.6-13.2-22.8-13.2c-12.8 0-23.2 10.4-23.2 23.2V464c0 26.5-21.5 48-48 48H279.2c-12.8 0-23.2-10.4-23.2-23.2c0-9.2 5.8-17.3 13.2-22.8c11.6-8.7 18.8-20.7 18.8-34c0-26.5-28.7-48-64-48s-64 21.5-64 48c0 13.3 7.2 25.3 18.8 34c7.4 5.5 13.2 13.6 13.2 22.8c0 12.8-10.4 23.2-23.2 23.2H48c-26.5 0-48-21.5-48-48V343.2C0 330.4 10.4 320 23.2 320c9.2 0 17.3 5.8 22.8 13.2C54.7 344.8 66.7 352 80 352c26.5 0 48-28.7 48-64s-21.5-64-48-64c-13.3 0-25.3 7.2-34 18.8C40.5 250.2 32.4 256 23.2 256C10.4 256 0 245.6 0 232.8V176c0-26.5 21.5-48 48-48H168.8c12.8 0 23.2-10.4 23.2-23.2z"
    ]
};
var $d8206b3ab2e65c05$export$be069f641c85d0b3 = {
    prefix: "fas",
    iconName: "money-check",
    icon: [
        576,
        512,
        [],
        "f53c",
        "M64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zm48 160H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zM96 336c0-8.8 7.2-16 16-16H464c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16zM376 160h80c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H376c-13.3 0-24-10.7-24-24V184c0-13.3 10.7-24 24-24z"
    ]
};
var $d8206b3ab2e65c05$export$3e4892d8bf919edd = {
    prefix: "fas",
    iconName: "star-half-stroke",
    icon: [
        576,
        512,
        [
            "star-half-alt"
        ],
        "f5c0",
        "M288 376.4l.1-.1 26.4 14.1 85.2 45.5-16.5-97.6-4.8-28.7 20.7-20.5 70.1-69.3-96.1-14.2-29.3-4.3-12.9-26.6L288.1 86.9l-.1 .3V376.4zm175.1 98.3c2 12-3 24.2-12.9 31.3s-23 8-33.8 2.3L288.1 439.8 159.8 508.3C149 514 135.9 513.1 126 506s-14.9-19.3-12.9-31.3L137.8 329 33.6 225.9c-8.6-8.5-11.7-21.2-7.9-32.7s13.7-19.9 25.7-21.7L195 150.3 259.4 18c5.4-11 16.5-18 28.8-18s23.4 7 28.8 18l64.3 132.3 143.6 21.2c12 1.8 22 10.2 25.7 21.7s.7 24.2-7.9 32.7L438.5 329l24.6 145.7z"
    ]
};
var $d8206b3ab2e65c05$export$c13575f42532efb3 = $d8206b3ab2e65c05$export$3e4892d8bf919edd;
var $d8206b3ab2e65c05$export$eba095993e51cc97 = {
    prefix: "fas",
    iconName: "code",
    icon: [
        640,
        512,
        [],
        "f121",
        "M392.8 1.2c-17-4.9-34.7 5-39.6 22l-128 448c-4.9 17 5 34.7 22 39.6s34.7-5 39.6-22l128-448c4.9-17-5-34.7-22-39.6zm80.6 120.1c-12.5 12.5-12.5 32.8 0 45.3L562.7 256l-89.4 89.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l112-112c12.5-12.5 12.5-32.8 0-45.3l-112-112c-12.5-12.5-32.8-12.5-45.3 0zm-306.7 0c-12.5-12.5-32.8-12.5-45.3 0l-112 112c-12.5 12.5-12.5 32.8 0 45.3l112 112c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256l89.4-89.4c12.5-12.5 12.5-32.8 0-45.3z"
    ]
};
var $d8206b3ab2e65c05$export$f1304dd34ea2afbd = {
    prefix: "fas",
    iconName: "whiskey-glass",
    icon: [
        512,
        512,
        [
            129347,
            "glass-whiskey"
        ],
        "f7a0",
        "M32 32c-9.3 0-18.1 4-24.2 11.1S-1 59.4 .3 68.6l50 342.9c5.7 39.3 39.4 68.5 79.2 68.5h253c39.7 0 73.4-29.1 79.2-68.5l50-342.9c1.3-9.2-1.4-18.5-7.5-25.5S489.3 32 480 32H32zM87.7 224L69 96H443L424.3 224H87.7z"
    ]
};
var $d8206b3ab2e65c05$export$fdec0f5f1a169419 = $d8206b3ab2e65c05$export$f1304dd34ea2afbd;
var $d8206b3ab2e65c05$export$c49f030b19083ebe = {
    prefix: "fas",
    iconName: "building-circle-exclamation",
    icon: [
        640,
        512,
        [],
        "e4d3",
        "M48 0C21.5 0 0 21.5 0 48V464c0 26.5 21.5 48 48 48h96V432c0-26.5 21.5-48 48-48s48 21.5 48 48v80h96c15.1 0 28.5-6.9 37.3-17.8C340.4 462.2 320 417.5 320 368c0-54.7 24.9-103.5 64-135.8V48c0-26.5-21.5-48-48-48H48zM64 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V240zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V240zM80 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V112zM272 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V288c0-8.8 7.2-16 16-16z"
    ]
};
var $d8206b3ab2e65c05$export$6a1e4cdbb8ca10c5 = {
    prefix: "fas",
    iconName: "magnifying-glass-chart",
    icon: [
        512,
        512,
        [],
        "e522",
        "M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zm-312 8v64c0 13.3 10.7 24 24 24s24-10.7 24-24l0-64c0-13.3-10.7-24-24-24s-24 10.7-24 24zm80-96V280c0 13.3 10.7 24 24 24s24-10.7 24-24V120c0-13.3-10.7-24-24-24s-24 10.7-24 24zm80 64v96c0 13.3 10.7 24 24 24s24-10.7 24-24V184c0-13.3-10.7-24-24-24s-24 10.7-24 24z"
    ]
};
var $d8206b3ab2e65c05$export$5ad84e891223f2c3 = {
    prefix: "fas",
    iconName: "arrow-up-right-from-square",
    icon: [
        512,
        512,
        [
            "external-link"
        ],
        "f08e",
        "M320 0c-17.7 0-32 14.3-32 32s14.3 32 32 32h82.7L201.4 265.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L448 109.3V192c0 17.7 14.3 32 32 32s32-14.3 32-32V32c0-17.7-14.3-32-32-32H320zM80 32C35.8 32 0 67.8 0 112V432c0 44.2 35.8 80 80 80H400c44.2 0 80-35.8 80-80V320c0-17.7-14.3-32-32-32s-32 14.3-32 32V432c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16H192c17.7 0 32-14.3 32-32s-14.3-32-32-32H80z"
    ]
};
var $d8206b3ab2e65c05$export$f4c613289034e5ef = $d8206b3ab2e65c05$export$5ad84e891223f2c3;
var $d8206b3ab2e65c05$export$b1f00c433aabac05 = {
    prefix: "fas",
    iconName: "cubes-stacked",
    icon: [
        448,
        512,
        [],
        "e4e6",
        "M192 64v64c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H224c-17.7 0-32 14.3-32 32zM82.7 207c-15.3 8.8-20.5 28.4-11.7 43.7l32 55.4c8.8 15.3 28.4 20.5 43.7 11.7l55.4-32c15.3-8.8 20.5-28.4 11.7-43.7l-32-55.4c-8.8-15.3-28.4-20.5-43.7-11.7L82.7 207zM288 192c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32H288zm64 160c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V384c0-17.7-14.3-32-32-32H352zM160 384v64c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V384c0-17.7-14.3-32-32-32H192c-17.7 0-32 14.3-32 32zM32 352c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H96c17.7 0 32-14.3 32-32V384c0-17.7-14.3-32-32-32H32z"
    ]
};
var $d8206b3ab2e65c05$export$51790ddd26e431bc = {
    prefix: "fas",
    iconName: "won-sign",
    icon: [
        512,
        512,
        [
            8361,
            "krw",
            "won"
        ],
        "f159",
        "M62.4 53.9C56.8 37.1 38.6 28.1 21.9 33.6S-3.9 57.4 1.6 74.1L51.6 224H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H72.9l56.7 170.1c4.5 13.5 17.4 22.4 31.6 21.9s26.4-10.4 29.8-24.2L233 288h46L321 455.8c3.4 13.8 15.6 23.7 29.8 24.2s27.1-8.4 31.6-21.9L439.1 288H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H460.4l50-149.9c5.6-16.8-3.5-34.9-20.2-40.5s-34.9 3.5-40.5 20.2L392.9 224H329L287 56.2C283.5 42 270.7 32 256 32s-27.5 10-31 24.2L183 224h-64L62.4 53.9zm78 234.1H167l-11.4 45.6L140.4 288zM249 224l7-28.1 7 28.1H249zm96 64h26.6l-15.2 45.6L345 288z"
    ]
};
var $d8206b3ab2e65c05$export$2f65e07a45b95b50 = $d8206b3ab2e65c05$export$51790ddd26e431bc;
var $d8206b3ab2e65c05$export$5a1fd3ed9564d7fa = $d8206b3ab2e65c05$export$51790ddd26e431bc;
var $d8206b3ab2e65c05$export$1df4e031b8ee4f84 = {
    prefix: "fas",
    iconName: "virus-covid",
    icon: [
        512,
        512,
        [],
        "e4a8",
        "M192 24c0-13.3 10.7-24 24-24h80c13.3 0 24 10.7 24 24s-10.7 24-24 24H280V81.6c30.7 4.2 58.8 16.3 82.3 34.1L386.1 92 374.8 80.6c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l56.6 56.6c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L420 125.9l-23.8 23.8c17.9 23.5 29.9 51.7 34.1 82.3H464V216c0-13.3 10.7-24 24-24s24 10.7 24 24v80c0 13.3-10.7 24-24 24s-24-10.7-24-24V280H430.4c-4.2 30.7-16.3 58.8-34.1 82.3L420 386.1l11.3-11.3c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-56.6 56.6c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L386.1 420l-23.8-23.8c-23.5 17.9-51.7 29.9-82.3 34.1V464h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H216c-13.3 0-24-10.7-24-24s10.7-24 24-24h16V430.4c-30.7-4.2-58.8-16.3-82.3-34.1L125.9 420l11.3 11.3c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L46.7 408.7c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L92 386.1l23.8-23.8C97.9 338.8 85.8 310.7 81.6 280H48v16c0 13.3-10.7 24-24 24s-24-10.7-24-24V216c0-13.3 10.7-24 24-24s24 10.7 24 24v16H81.6c4.2-30.7 16.3-58.8 34.1-82.3L92 125.9 80.6 137.2c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l56.6-56.6c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L125.9 92l23.8 23.8c23.5-17.9 51.7-29.9 82.3-34.1V48H216c-13.3 0-24-10.7-24-24zm48 200a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm64 104a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
    ]
};
var $d8206b3ab2e65c05$export$299c200ad3db97b4 = {
    prefix: "fas",
    iconName: "austral-sign",
    icon: [
        448,
        512,
        [],
        "e0a9",
        "M253.5 51.7C248.6 39.8 236.9 32 224 32s-24.6 7.8-29.5 19.7L122.7 224H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H96L82.7 320H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H56L34.5 435.7c-6.8 16.3 .9 35 17.2 41.8s35-.9 41.8-17.2L125.3 384H322.7l31.8 76.3c6.8 16.3 25.5 24 41.8 17.2s24-25.5 17.2-41.8L392 384h24c17.7 0 32-14.3 32-32s-14.3-32-32-32H365.3L352 288h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H325.3L253.5 51.7zM256 224H192l32-76.8L256 224zm-90.7 64H282.7L296 320H152l13.3-32z"
    ]
};
var $d8206b3ab2e65c05$export$a2f384a559654618 = {
    prefix: "fas",
    iconName: "f",
    icon: [
        320,
        512,
        [
            102
        ],
        "46",
        "M64 32C28.7 32 0 60.7 0 96V256 448c0 17.7 14.3 32 32 32s32-14.3 32-32V288H224c17.7 0 32-14.3 32-32s-14.3-32-32-32H64V96H288c17.7 0 32-14.3 32-32s-14.3-32-32-32H64z"
    ]
};
var $d8206b3ab2e65c05$export$7c497bae2754a087 = {
    prefix: "fas",
    iconName: "leaf",
    icon: [
        512,
        512,
        [],
        "f06c",
        "M272 96c-78.6 0-145.1 51.5-167.7 122.5c33.6-17 71.5-26.5 111.7-26.5h88c8.8 0 16 7.2 16 16s-7.2 16-16 16H288 216s0 0 0 0c-16.6 0-32.7 1.9-48.3 5.4c-25.9 5.9-49.9 16.4-71.4 30.7c0 0 0 0 0 0C38.3 298.8 0 364.9 0 440v16c0 13.3 10.7 24 24 24s24-10.7 24-24V440c0-48.7 20.7-92.5 53.8-123.2C121.6 392.3 190.3 448 272 448l1 0c132.1-.7 239-130.9 239-291.4c0-42.6-7.5-83.1-21.1-119.6c-2.6-6.9-12.7-6.6-16.2-.1C455.9 72.1 418.7 96 376 96L272 96z"
    ]
};
var $d8206b3ab2e65c05$export$f224567a4851a5e9 = {
    prefix: "fas",
    iconName: "road",
    icon: [
        576,
        512,
        [
            128739
        ],
        "f018",
        "M256 32H181.2c-27.1 0-51.3 17.1-60.3 42.6L3.1 407.2C1.1 413 0 419.2 0 425.4C0 455.5 24.5 480 54.6 480H256V416c0-17.7 14.3-32 32-32s32 14.3 32 32v64H521.4c30.2 0 54.6-24.5 54.6-54.6c0-6.2-1.1-12.4-3.1-18.2L455.1 74.6C446 49.1 421.9 32 394.8 32H320V96c0 17.7-14.3 32-32 32s-32-14.3-32-32V32zm64 192v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V224c0-17.7 14.3-32 32-32s32 14.3 32 32z"
    ]
};
var $d8206b3ab2e65c05$export$9958afcdfece1b58 = {
    prefix: "fas",
    iconName: "taxi",
    icon: [
        512,
        512,
        [
            128662,
            "cab"
        ],
        "f1ba",
        "M192 0c-17.7 0-32 14.3-32 32V64c0 .1 0 .1 0 .2c-38.6 2.2-72.3 27.3-85.2 64.1L39.6 228.8C16.4 238.4 0 261.3 0 288V432v48c0 17.7 14.3 32 32 32H64c17.7 0 32-14.3 32-32V432H416v48c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V432 288c0-26.7-16.4-49.6-39.6-59.2L437.2 128.3c-12.9-36.8-46.6-62-85.2-64.1c0-.1 0-.1 0-.2V32c0-17.7-14.3-32-32-32H192zM165.4 128H346.6c13.6 0 25.7 8.6 30.2 21.4L402.9 224H109.1l26.1-74.6c4.5-12.8 16.6-21.4 30.2-21.4zM96 288a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm288 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
    ]
};
var $d8206b3ab2e65c05$export$7bf12d9380f0971b = $d8206b3ab2e65c05$export$9958afcdfece1b58;
var $d8206b3ab2e65c05$export$55686b1eb7d00307 = {
    prefix: "fas",
    iconName: "person-circle-plus",
    icon: [
        576,
        512,
        [],
        "e541",
        "M112 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm40 304V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V256.9L59.4 304.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c17.4-28.9 48.6-46.6 82.3-46.6h29.7c33.7 0 64.9 17.7 82.3 46.6l44.9 74.7c-16.1 17.6-28.6 38.5-36.6 61.5c-1.9-1.8-3.5-3.9-4.9-6.3L232 256.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352H152zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm16 80c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H368c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v48c0 8.8 7.2 16 16 16s16-7.2 16-16V384h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H448V304z"
    ]
};
var $d8206b3ab2e65c05$export$1de7b9cf7d1b153b = {
    prefix: "fas",
    iconName: "chart-pie",
    icon: [
        576,
        512,
        [
            "pie-chart"
        ],
        "f200",
        "M304 240V16.6c0-9 7-16.6 16-16.6C443.7 0 544 100.3 544 224c0 9-7.6 16-16.6 16H304zM32 272C32 150.7 122.1 50.3 239 34.3c9.2-1.3 17 6.1 17 15.4V288L412.5 444.5c6.7 6.7 6.2 17.7-1.5 23.1C371.8 495.6 323.8 512 272 512C139.5 512 32 404.6 32 272zm526.4 16c9.3 0 16.6 7.8 15.4 17c-7.7 55.9-34.6 105.6-73.9 142.3c-6 5.6-15.4 5.2-21.2-.7L320 288H558.4z"
    ]
};
var $d8206b3ab2e65c05$export$7877286cd337de81 = $d8206b3ab2e65c05$export$1de7b9cf7d1b153b;
var $d8206b3ab2e65c05$export$b16dcd08f3da1ba2 = {
    prefix: "fas",
    iconName: "bolt-lightning",
    icon: [
        384,
        512,
        [],
        "e0b7",
        "M0 256L28.5 28c2-16 15.6-28 31.8-28H228.9c15 0 27.1 12.1 27.1 27.1c0 3.2-.6 6.5-1.7 9.5L208 160H347.3c20.2 0 36.7 16.4 36.7 36.7c0 7.4-2.2 14.6-6.4 20.7l-192.2 281c-5.9 8.6-15.6 13.7-25.9 13.7h-2.9c-15.7 0-28.5-12.8-28.5-28.5c0-2.3 .3-4.6 .9-6.9L176 288H32c-17.7 0-32-14.3-32-32z"
    ]
};
var $d8206b3ab2e65c05$export$2bad98c38bea5994 = {
    prefix: "fas",
    iconName: "sack-xmark",
    icon: [
        512,
        512,
        [],
        "e56a",
        "M192 96H320l47.4-71.1C374.5 14.2 366.9 0 354.1 0H157.9c-12.8 0-20.4 14.2-13.3 24.9L192 96zm128 32H192c-3.8 2.5-8.1 5.3-13 8.4l0 0 0 0C122.3 172.7 0 250.9 0 416c0 53 43 96 96 96H416c53 0 96-43 96-96c0-165.1-122.3-243.3-179-279.6c-4.8-3.1-9.2-5.9-13-8.4zM289.9 336l47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47z"
    ]
};
var $d8206b3ab2e65c05$export$77cb1a465c4fe84 = {
    prefix: "fas",
    iconName: "file-excel",
    icon: [
        384,
        512,
        [],
        "f1c3",
        "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM155.7 250.2L192 302.1l36.3-51.9c7.6-10.9 22.6-13.5 33.4-5.9s13.5 22.6 5.9 33.4L221.3 344l46.4 66.2c7.6 10.9 5 25.8-5.9 33.4s-25.8 5-33.4-5.9L192 385.8l-36.3 51.9c-7.6 10.9-22.6 13.5-33.4 5.9s-13.5-22.6-5.9-33.4L162.7 344l-46.4-66.2c-7.6-10.9-5-25.8 5.9-33.4s25.8-5 33.4 5.9z"
    ]
};
var $d8206b3ab2e65c05$export$70fde3f3fdaa6a6a = {
    prefix: "fas",
    iconName: "file-contract",
    icon: [
        384,
        512,
        [],
        "f56c",
        "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM80 64h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16zm54.2 253.8c-6.1 20.3-24.8 34.2-46 34.2H80c-8.8 0-16-7.2-16-16s7.2-16 16-16h8.2c7.1 0 13.3-4.6 15.3-11.4l14.9-49.5c3.4-11.3 13.8-19.1 25.6-19.1s22.2 7.7 25.6 19.1l11.6 38.6c7.4-6.2 16.8-9.7 26.8-9.7c15.9 0 30.4 9 37.5 23.2l4.4 8.8H304c8.8 0 16 7.2 16 16s-7.2 16-16 16H240c-6.1 0-11.6-3.4-14.3-8.8l-8.8-17.7c-1.7-3.4-5.1-5.5-8.8-5.5s-7.2 2.1-8.8 5.5l-8.8 17.7c-2.9 5.9-9.2 9.4-15.7 8.8s-12.1-5.1-13.9-11.3L144 349l-9.8 32.8z"
    ]
};
var $d8206b3ab2e65c05$export$e7af4f0123222b6f = {
    prefix: "fas",
    iconName: "fish-fins",
    icon: [
        576,
        512,
        [],
        "e4f2",
        "M275.2 38.4c-10.6-8-25-8.5-36.3-1.5S222 57.3 224.6 70.3l9.7 48.6c-19.4 9-36.9 19.9-52.4 31.5c-15.3 11.5-29 23.9-40.7 36.3L48.1 132.4c-12.5-7.3-28.4-5.3-38.6 4.9S-3 163.3 4.2 175.9L50 256 4.2 336.1c-7.2 12.6-5 28.4 5.3 38.6s26.1 12.2 38.6 4.9l93.1-54.3c11.8 12.3 25.4 24.8 40.7 36.3c15.5 11.6 33 22.5 52.4 31.5l-9.7 48.6c-2.6 13 3.1 26.3 14.3 33.3s25.6 6.5 36.3-1.5l77.6-58.2c54.9-4 101.5-27 137.2-53.8c39.2-29.4 67.2-64.7 81.6-89.5c5.8-9.9 5.8-22.2 0-32.1c-14.4-24.8-42.5-60.1-81.6-89.5c-35.8-26.8-82.3-49.8-137.2-53.8L275.2 38.4zM384 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
    ]
};
var $d8206b3ab2e65c05$export$592422b29ab0a914 = {
    prefix: "fas",
    iconName: "building-flag",
    icon: [
        640,
        512,
        [],
        "e4d5",
        "M48 0C21.5 0 0 21.5 0 48V464c0 26.5 21.5 48 48 48h96V432c0-26.5 21.5-48 48-48s48 21.5 48 48v80h96c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H48zM64 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V240zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V240zM80 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V112zM272 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zM448 0c-17.7 0-32 14.3-32 32V512h64V192H624c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16H480c0-17.7-14.3-32-32-32z"
    ]
};
var $d8206b3ab2e65c05$export$3de52eeb00462407 = {
    prefix: "fas",
    iconName: "face-grin-beam",
    icon: [
        512,
        512,
        [
            128516,
            "grin-beam"
        ],
        "f582",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM388.1 312.8c12.3-3.8 24.3 6.9 19.3 18.7C382.4 390.6 324.2 432 256.3 432s-126.2-41.4-151.1-100.5c-5-11.8 7-22.5 19.3-18.7c39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19zm-170.5-84l0 0 0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0zm160 0l0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0 0 0z"
    ]
};
var $d8206b3ab2e65c05$export$734da5249381ec7e = $d8206b3ab2e65c05$export$3de52eeb00462407;
var $d8206b3ab2e65c05$export$887f6345573abcac = {
    prefix: "fas",
    iconName: "object-ungroup",
    icon: [
        640,
        512,
        [],
        "f248",
        "M32 119.4C12.9 108.4 0 87.7 0 64C0 28.7 28.7 0 64 0c23.7 0 44.4 12.9 55.4 32H328.6C339.6 12.9 360.3 0 384 0c35.3 0 64 28.7 64 64c0 23.7-12.9 44.4-32 55.4V232.6c19.1 11.1 32 31.7 32 55.4c0 35.3-28.7 64-64 64c-23.7 0-44.4-12.9-55.4-32H119.4c-11.1 19.1-31.7 32-55.4 32c-35.3 0-64-28.7-64-64c0-23.7 12.9-44.4 32-55.4V119.4zM119.4 96c-5.6 9.7-13.7 17.8-23.4 23.4V232.6c9.7 5.6 17.8 13.7 23.4 23.4H328.6c5.6-9.7 13.7-17.8 23.4-23.4V119.4c-9.7-5.6-17.8-13.7-23.4-23.4H119.4zm192 384c-11.1 19.1-31.7 32-55.4 32c-35.3 0-64-28.7-64-64c0-23.7 12.9-44.4 32-55.4V352h64v40.6c9.7 5.6 17.8 13.7 23.4 23.4H520.6c5.6-9.7 13.7-17.8 23.4-23.4V279.4c-9.7-5.6-17.8-13.7-23.4-23.4h-46c-5.4-15.4-14.6-28.9-26.5-39.6V192h72.6c11.1-19.1 31.7-32 55.4-32c35.3 0 64 28.7 64 64c0 23.7-12.9 44.4-32 55.4V392.6c19.1 11.1 32 31.7 32 55.4c0 35.3-28.7 64-64 64c-23.7 0-44.4-12.9-55.4-32H311.4z"
    ]
};
var $d8206b3ab2e65c05$export$bb45b6b87d1adf27 = {
    prefix: "fas",
    iconName: "poop",
    icon: [
        512,
        512,
        [],
        "f619",
        "M254.4 6.6c3.5-4.3 9-6.5 14.5-5.7C315.8 7.2 352 47.4 352 96c0 11.2-1.9 22-5.5 32H352c35.3 0 64 28.7 64 64c0 19.1-8.4 36.3-21.7 48H408c39.8 0 72 32.2 72 72c0 23.2-11 43.8-28 57c34.1 5.7 60 35.3 60 71c0 39.8-32.2 72-72 72H72c-39.8 0-72-32.2-72-72c0-35.7 25.9-65.3 60-71c-17-13.2-28-33.8-28-57c0-39.8 32.2-72 72-72h13.7C104.4 228.3 96 211.1 96 192c0-35.3 28.7-64 64-64h16.2c44.1-.1 79.8-35.9 79.8-80c0-9.2-1.5-17.9-4.3-26.1c-1.8-5.2-.8-11.1 2.8-15.4z"
    ]
};
var $d8206b3ab2e65c05$export$c0b7617de95c0c05 = {
    prefix: "fas",
    iconName: "location-pin",
    icon: [
        384,
        512,
        [
            "map-marker"
        ],
        "f041",
        "M384 192c0 87.4-117 243-168.3 307.2c-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192C0 86 86 0 192 0S384 86 384 192z"
    ]
};
var $d8206b3ab2e65c05$export$10d360e4f1a554dd = $d8206b3ab2e65c05$export$c0b7617de95c0c05;
var $d8206b3ab2e65c05$export$ab1408bfbe914cc9 = {
    prefix: "fas",
    iconName: "kaaba",
    icon: [
        576,
        512,
        [
            128331
        ],
        "f66b",
        "M60 120l228 71.2L516 120 288 48.8 60 120zM278.5 1.5c6.2-1.9 12.9-1.9 19.1 0l256 80C566.9 85.6 576 98 576 112v16 0 21.2L292.8 237.7c-3.1 1-6.4 1-9.5 0L0 149.2V128 112C0 98 9.1 85.6 22.5 81.5l256-80zm23.9 266.8L576 182.8v46.5l-52.8 16.5c-8.4 2.6-13.1 11.6-10.5 20s11.6 13.1 20 10.5L576 262.8V400c0 14-9.1 26.4-22.5 30.5l-256 80c-6.2 1.9-12.9 1.9-19.1 0l-256-80C9.1 426.4 0 414 0 400V262.8l43.2 13.5c8.4 2.6 17.4-2.1 20-10.5s-2.1-17.4-10.5-20L0 229.2V182.8l273.7 85.5c9.3 2.9 19.3 2.9 28.6 0zm-185.5-2.6c-8.4-2.6-17.4 2.1-20 10.5s2.1 17.4 10.5 20l64 20c8.4 2.6 17.4-2.1 20-10.5s-2.1-17.4-10.5-20l-64-20zm352 30.5c8.4-2.6 13.1-11.6 10.5-20s-11.6-13.1-20-10.5l-64 20c-8.4 2.6-13.1 11.6-10.5 20s11.6 13.1 20 10.5l64-20zm-224 9.5c-8.4-2.6-17.4 2.1-20 10.5s2.1 17.4 10.5 20l38.5 12c9.3 2.9 19.3 2.9 28.6 0l38.5-12c8.4-2.6 13.1-11.6 10.5-20s-11.6-13.1-20-10.5l-38.5 12c-3.1 1-6.4 1-9.5 0l-38.5-12z"
    ]
};
var $d8206b3ab2e65c05$export$c8cc083ccc72b17 = {
    prefix: "fas",
    iconName: "toilet-paper",
    icon: [
        640,
        512,
        [
            129531
        ],
        "f71e",
        "M444.2 0C397.2 49.6 384 126.5 384 192c0 158.8-27.3 247-42.7 283.9c-10 24-33.2 36.1-55.4 36.1H48c-11.5 0-22.2-6.2-27.8-16.2s-5.6-22.3 .4-32.2c9.8-17.7 15.4-38.2 20.5-57.7C52.3 362.8 64 293.5 64 192C64 86 107 0 160 0H444.2zM512 384c-53 0-96-86-96-192S459 0 512 0s96 86 96 192s-43 192-96 192zm0-128c17.7 0 32-28.7 32-64s-14.3-64-32-64s-32 28.7-32 64s14.3 64 32 64zM144 208a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm64 0a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm48 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm80-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"
    ]
};
var $d8206b3ab2e65c05$export$aacaf42fba617981 = {
    prefix: "fas",
    iconName: "helmet-safety",
    icon: [
        576,
        512,
        [
            "hard-hat",
            "hat-hard"
        ],
        "f807",
        "M256 32c-17.7 0-32 14.3-32 32v2.3 99.6c0 5.6-4.5 10.1-10.1 10.1c-3.6 0-7-1.9-8.8-5.1L157.1 87C83 123.5 32 199.8 32 288v64H544l0-66.4c-.9-87.2-51.7-162.4-125.1-198.6l-48 83.9c-1.8 3.2-5.2 5.1-8.8 5.1c-5.6 0-10.1-4.5-10.1-10.1V66.3 64c0-17.7-14.3-32-32-32H256zM16.6 384C7.4 384 0 391.4 0 400.6c0 4.7 2 9.2 5.8 11.9C27.5 428.4 111.8 480 288 480s260.5-51.6 282.2-67.5c3.8-2.8 5.8-7.2 5.8-11.9c0-9.2-7.4-16.6-16.6-16.6H16.6z"
    ]
};
var $d8206b3ab2e65c05$export$7b72177558a98b6f = $d8206b3ab2e65c05$export$aacaf42fba617981;
var $d8206b3ab2e65c05$export$c0e235dbf1644a2f = $d8206b3ab2e65c05$export$aacaf42fba617981;
var $d8206b3ab2e65c05$export$8484041d5b209494 = {
    prefix: "fas",
    iconName: "eject",
    icon: [
        448,
        512,
        [
            9167
        ],
        "f052",
        "M224 32c13.5 0 26.3 5.6 35.4 15.6l176 192c12.9 14 16.2 34.3 8.6 51.8S419 320 400 320H48c-19 0-36.3-11.2-43.9-28.7s-4.3-37.7 8.6-51.8l176-192C197.7 37.6 210.5 32 224 32zM0 432c0-26.5 21.5-48 48-48H400c26.5 0 48 21.5 48 48s-21.5 48-48 48H48c-26.5 0-48-21.5-48-48z"
    ]
};
var $d8206b3ab2e65c05$export$1fec48c8bdd69c1d = {
    prefix: "fas",
    iconName: "circle-right",
    icon: [
        512,
        512,
        [
            61838,
            "arrow-alt-circle-right"
        ],
        "f35a",
        "M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM294.6 135.1l99.9 107.1c3.5 3.8 5.5 8.7 5.5 13.8s-2 10.1-5.5 13.8L294.6 376.9c-4.2 4.5-10.1 7.1-16.3 7.1C266 384 256 374 256 361.7l0-57.7-96 0c-17.7 0-32-14.3-32-32l0-32c0-17.7 14.3-32 32-32l96 0 0-57.7c0-12.3 10-22.3 22.3-22.3c6.2 0 12.1 2.6 16.3 7.1z"
    ]
};
var $d8206b3ab2e65c05$export$88962ffdad8b856d = $d8206b3ab2e65c05$export$1fec48c8bdd69c1d;
var $d8206b3ab2e65c05$export$9cbf8612c6cadc74 = {
    prefix: "fas",
    iconName: "plane-circle-check",
    icon: [
        640,
        512,
        [],
        "e555",
        "M256 0c-35 0-64 59.5-64 93.7v84.6L8.1 283.4c-5 2.8-8.1 8.2-8.1 13.9v65.5c0 10.6 10.2 18.3 20.4 15.4l171.6-49 0 70.9-57.6 43.2c-4 3-6.4 7.8-6.4 12.8v42c0 7.8 6.3 14 14 14c1.3 0 2.6-.2 3.9-.5L256 480l110.1 31.5c1.3 .4 2.6 .5 3.9 .5c6 0 11.1-3.7 13.1-9C344.5 470.7 320 422.2 320 368c0-60.6 30.6-114 77.1-145.6L320 178.3V93.7C320 59.5 292 0 256 0zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"
    ]
};
var $d8206b3ab2e65c05$export$a6d72a9a068392b5 = {
    prefix: "fas",
    iconName: "face-rolling-eyes",
    icon: [
        512,
        512,
        [
            128580,
            "meh-rolling-eyes"
        ],
        "f5a5",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM192 368H320c8.8 0 16 7.2 16 16s-7.2 16-16 16H192c-8.8 0-16-7.2-16-16s7.2-16 16-16zm32-144c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-26 15.5-48.4 37.8-58.4c-3.7 5.2-5.8 11.6-5.8 18.4c0 17.7 14.3 32 32 32s32-14.3 32-32c0-6.9-2.2-13.2-5.8-18.4C208.5 175.6 224 198 224 224zm128 64c-35.3 0-64-28.7-64-64c0-26 15.5-48.4 37.8-58.4c-3.7 5.2-5.8 11.6-5.8 18.4c0 17.7 14.3 32 32 32s32-14.3 32-32c0-6.9-2.2-13.2-5.8-18.4C400.5 175.6 416 198 416 224c0 35.3-28.7 64-64 64z"
    ]
};
var $d8206b3ab2e65c05$export$fdc62a1bea767cc2 = $d8206b3ab2e65c05$export$a6d72a9a068392b5;
var $d8206b3ab2e65c05$export$40cdac24aa94a57a = {
    prefix: "fas",
    iconName: "object-group",
    icon: [
        576,
        512,
        [],
        "f247",
        "M32 119.4C12.9 108.4 0 87.7 0 64C0 28.7 28.7 0 64 0c23.7 0 44.4 12.9 55.4 32H456.6C467.6 12.9 488.3 0 512 0c35.3 0 64 28.7 64 64c0 23.7-12.9 44.4-32 55.4V392.6c19.1 11.1 32 31.7 32 55.4c0 35.3-28.7 64-64 64c-23.7 0-44.4-12.9-55.4-32H119.4c-11.1 19.1-31.7 32-55.4 32c-35.3 0-64-28.7-64-64c0-23.7 12.9-44.4 32-55.4V119.4zM456.6 96H119.4c-5.6 9.7-13.7 17.8-23.4 23.4V392.6c9.7 5.6 17.8 13.7 23.4 23.4H456.6c5.6-9.7 13.7-17.8 23.4-23.4V119.4c-9.7-5.6-17.8-13.7-23.4-23.4zM128 160c0-17.7 14.3-32 32-32H288c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32V160zM256 320h32c35.3 0 64-28.7 64-64V224h64c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H288c-17.7 0-32-14.3-32-32V320z"
    ]
};
var $d8206b3ab2e65c05$export$e022f62a119e1d93 = {
    prefix: "fas",
    iconName: "chart-line",
    icon: [
        512,
        512,
        [
            "line-chart"
        ],
        "f201",
        "M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64V400c0 44.2 35.8 80 80 80H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H80c-8.8 0-16-7.2-16-16V64zm406.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L320 210.7l-57.4-57.4c-12.5-12.5-32.8-12.5-45.3 0l-112 112c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L240 221.3l57.4 57.4c12.5 12.5 32.8 12.5 45.3 0l128-128z"
    ]
};
var $d8206b3ab2e65c05$export$f729617a20de475b = $d8206b3ab2e65c05$export$e022f62a119e1d93;
var $d8206b3ab2e65c05$export$122c8413a0dc5ff6 = {
    prefix: "fas",
    iconName: "mask-ventilator",
    icon: [
        640,
        512,
        [],
        "e524",
        "M159.1 176C139.4 219.2 128 264.7 128 300.8c0 15.9 2.2 31.4 6.3 46l-31.8-7.9C70.5 330.9 48 302.1 48 269V184c0-4.4 3.6-8 8-8H159.1zm26-48H56c-30.9 0-56 25.1-56 56v85c0 55.1 37.5 103.1 90.9 116.4l71.3 17.8c22.7 30.5 55.4 54.1 93.8 66.6V393.3c-19.7-16.4-32-40.3-32-66.9c0-49.5 43-134.4 96-134.4c52.5 0 96 84.9 96 134.4c0 26.7-12.4 50.4-32 66.8v76.6c38-12.6 70.6-36 93.5-66.4l71.6-17.9C602.5 372.1 640 324.1 640 269V184c0-30.9-25.1-56-56-56H454.5C419.7 73.8 372.1 32 320 32c-52.6 0-100.2 41.8-134.9 96zm295.6 48H584c4.4 0 8 3.6 8 8v85c0 33-22.5 61.8-54.5 69.9l-31.8 8c4.2-14.7 6.4-30.1 6.4-46.1c0-36.1-11.6-81.6-31.3-124.8zM288 320V512h64V320c0-17.7-14.3-32-32-32s-32 14.3-32 32z"
    ]
};
var $d8206b3ab2e65c05$export$b4da69a0247f3620 = {
    prefix: "fas",
    iconName: "arrow-right",
    icon: [
        448,
        512,
        [
            8594
        ],
        "f061",
        "M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z"
    ]
};
var $d8206b3ab2e65c05$export$905f45f8ffd6b8e5 = {
    prefix: "fas",
    iconName: "signs-post",
    icon: [
        512,
        512,
        [
            "map-signs"
        ],
        "f277",
        "M224 32H64C46.3 32 32 46.3 32 64v64c0 17.7 14.3 32 32 32H441.4c4.2 0 8.3-1.7 11.3-4.7l48-48c6.2-6.2 6.2-16.4 0-22.6l-48-48c-3-3-7.1-4.7-11.3-4.7H288c0-17.7-14.3-32-32-32s-32 14.3-32 32zM480 256c0-17.7-14.3-32-32-32H288V192H224v32H70.6c-4.2 0-8.3 1.7-11.3 4.7l-48 48c-6.2 6.2-6.2 16.4 0 22.6l48 48c3 3 7.1 4.7 11.3 4.7H448c17.7 0 32-14.3 32-32V256zM288 480V384H224v96c0 17.7 14.3 32 32 32s32-14.3 32-32z"
    ]
};
var $d8206b3ab2e65c05$export$743f4b1071b3333a = $d8206b3ab2e65c05$export$905f45f8ffd6b8e5;
var $d8206b3ab2e65c05$export$6357093f67788b33 = {
    prefix: "fas",
    iconName: "cash-register",
    icon: [
        512,
        512,
        [],
        "f788",
        "M64 0C46.3 0 32 14.3 32 32V96c0 17.7 14.3 32 32 32h80v32H87c-31.6 0-58.5 23.1-63.3 54.4L1.1 364.1C.4 368.8 0 373.6 0 378.4V448c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V378.4c0-4.8-.4-9.6-1.1-14.4L488.2 214.4C483.5 183.1 456.6 160 425 160H208V128h80c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32H64zM96 48H256c8.8 0 16 7.2 16 16s-7.2 16-16 16H96c-8.8 0-16-7.2-16-16s7.2-16 16-16zM64 432c0-8.8 7.2-16 16-16H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm48-168a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm120-24a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM160 344a24 24 0 1 1 0-48 24 24 0 1 1 0 48zM328 240a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM256 344a24 24 0 1 1 0-48 24 24 0 1 1 0 48zM424 240a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM352 344a24 24 0 1 1 0-48 24 24 0 1 1 0 48z"
    ]
};
var $d8206b3ab2e65c05$export$c8f8a597ffd676c0 = {
    prefix: "fas",
    iconName: "person-circle-question",
    icon: [
        576,
        512,
        [],
        "e542",
        "M112 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm40 304V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V256.9L59.4 304.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c17.4-28.9 48.6-46.6 82.3-46.6h29.7c33.7 0 64.9 17.7 82.3 46.6l44.9 74.7c-16.1 17.6-28.6 38.5-36.6 61.5c-1.9-1.8-3.5-3.9-4.9-6.3L232 256.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352H152zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 240a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM368 321.6V328c0 8.8 7.2 16 16 16s16-7.2 16-16v-6.4c0-5.3 4.3-9.6 9.6-9.6h40.5c7.7 0 13.9 6.2 13.9 13.9c0 5.2-2.9 9.9-7.4 12.3l-32 16.8c-5.3 2.8-8.6 8.2-8.6 14.2V384c0 8.8 7.2 16 16 16s16-7.2 16-16v-5.1l23.5-12.3c15.1-7.9 24.5-23.6 24.5-40.6c0-25.4-20.6-45.9-45.9-45.9H409.6c-23 0-41.6 18.6-41.6 41.6z"
    ]
};
var $d8206b3ab2e65c05$export$d762b7b66d5875e1 = {
    prefix: "fas",
    iconName: "h",
    icon: [
        384,
        512,
        [
            104
        ],
        "48",
        "M320 256l0 192c0 17.7 14.3 32 32 32s32-14.3 32-32l0-224V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V192L64 192 64 64c0-17.7-14.3-32-32-32S0 46.3 0 64V448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-192 256 0z"
    ]
};
var $d8206b3ab2e65c05$export$2305b1a41b3f914 = {
    prefix: "fas",
    iconName: "tarp",
    icon: [
        576,
        512,
        [],
        "e57b",
        "M576 128c0-35.3-28.7-64-64-64H64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64l352 0 0-128c0-17.7 14.3-32 32-32H576V128zM448 448L576 320H448l0 128zM96 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $d8206b3ab2e65c05$export$158a12f36bbecf9 = {
    prefix: "fas",
    iconName: "screwdriver-wrench",
    icon: [
        512,
        512,
        [
            "tools"
        ],
        "f7d9",
        "M78.6 5C69.1-2.4 55.6-1.5 47 7L7 47c-8.5 8.5-9.4 22-2.1 31.6l80 104c4.5 5.9 11.6 9.4 19 9.4h54.1l109 109c-14.7 29-10 65.4 14.3 89.6l112 112c12.5 12.5 32.8 12.5 45.3 0l64-64c12.5-12.5 12.5-32.8 0-45.3l-112-112c-24.2-24.2-60.6-29-89.6-14.3l-109-109V104c0-7.5-3.5-14.5-9.4-19L78.6 5zM19.9 396.1C7.2 408.8 0 426.1 0 444.1C0 481.6 30.4 512 67.9 512c18 0 35.3-7.2 48-19.9L233.7 374.3c-7.8-20.9-9-43.6-3.6-65.1l-61.7-61.7L19.9 396.1zM512 144c0-10.5-1.1-20.7-3.2-30.5c-2.4-11.2-16.1-14.1-24.2-6l-63.9 63.9c-3 3-7.1 4.7-11.3 4.7H352c-8.8 0-16-7.2-16-16V102.6c0-4.2 1.7-8.3 4.7-11.3l63.9-63.9c8.1-8.1 5.2-21.8-6-24.2C388.7 1.1 378.5 0 368 0C288.5 0 224 64.5 224 144l0 .8 85.3 85.3c36-9.1 75.8 .5 104 28.7L429 274.5c49-23 83-72.8 83-130.5zM56 432a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"
    ]
};
var $d8206b3ab2e65c05$export$646e4e7a8c6172aa = $d8206b3ab2e65c05$export$158a12f36bbecf9;
var $d8206b3ab2e65c05$export$9adae865350879af = {
    prefix: "fas",
    iconName: "arrows-to-eye",
    icon: [
        640,
        512,
        [],
        "e4bf",
        "M15 15C24.4 5.7 39.6 5.7 49 15l63 63V40c0-13.3 10.7-24 24-24s24 10.7 24 24v96c0 13.3-10.7 24-24 24H40c-13.3 0-24-10.7-24-24s10.7-24 24-24H78.1L15 49C5.7 39.6 5.7 24.4 15 15zM133.5 243.9C158.6 193.6 222.7 112 320 112s161.4 81.6 186.5 131.9c3.8 7.6 3.8 16.5 0 24.2C481.4 318.4 417.3 400 320 400s-161.4-81.6-186.5-131.9c-3.8-7.6-3.8-16.5 0-24.2zM320 320a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM591 15c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-63 63H600c13.3 0 24 10.7 24 24s-10.7 24-24 24H504c-13.3 0-24-10.7-24-24V40c0-13.3 10.7-24 24-24s24 10.7 24 24V78.1l63-63zM15 497c-9.4-9.4-9.4-24.6 0-33.9l63-63H40c-13.3 0-24-10.7-24-24s10.7-24 24-24h96c13.3 0 24 10.7 24 24v96c0 13.3-10.7 24-24 24s-24-10.7-24-24V433.9L49 497c-9.4 9.4-24.6 9.4-33.9 0zm576 0l-63-63V472c0 13.3-10.7 24-24 24s-24-10.7-24-24V376c0-13.3 10.7-24 24-24h96c13.3 0 24 10.7 24 24s-10.7 24-24 24H561.9l63 63c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0z"
    ]
};
var $d8206b3ab2e65c05$export$4f3b3144ce966486 = {
    prefix: "fas",
    iconName: "plug-circle-bolt",
    icon: [
        576,
        512,
        [],
        "e55b",
        "M96 0C78.3 0 64 14.3 64 32v96h64V32c0-17.7-14.3-32-32-32zM288 0c-17.7 0-32 14.3-32 32v96h64V32c0-17.7-14.3-32-32-32zM32 160c-17.7 0-32 14.3-32 32s14.3 32 32 32v32c0 77.4 55 142 128 156.8V480c0 17.7 14.3 32 32 32s32-14.3 32-32V412.8c12.3-2.5 24.1-6.4 35.1-11.5c-2.1-10.8-3.1-21.9-3.1-33.3c0-80.3 53.8-148 127.3-169.2c.5-2.2 .7-4.5 .7-6.8c0-17.7-14.3-32-32-32H32zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm47.9-225c4.3 3.7 5.4 9.9 2.6 14.9L452.4 356H488c5.2 0 9.8 3.3 11.4 8.2s-.1 10.3-4.2 13.4l-96 72c-4.5 3.4-10.8 3.2-15.1-.6s-5.4-9.9-2.6-14.9L411.6 380H376c-5.2 0-9.8-3.3-11.4-8.2s.1-10.3 4.2-13.4l96-72c4.5-3.4 10.8-3.2 15.1 .6z"
    ]
};
var $d8206b3ab2e65c05$export$e4b51a47a2f8b9db = {
    prefix: "fas",
    iconName: "heart",
    icon: [
        512,
        512,
        [
            128153,
            128154,
            128155,
            128156,
            128420,
            129293,
            129294,
            129505,
            9829,
            10084,
            61578
        ],
        "f004",
        "M47.6 300.4L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9L464.4 300.4c30.4-28.3 47.6-68 47.6-109.5v-5.8c0-69.9-50.5-129.5-119.4-141C347 36.5 300.6 51.4 268 84L256 96 244 84c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5z"
    ]
};
var $d8206b3ab2e65c05$export$808b88e8735e31e8 = {
    prefix: "fas",
    iconName: "mars-and-venus",
    icon: [
        512,
        512,
        [
            9893
        ],
        "f224",
        "M337.8 14.8C341.5 5.8 350.3 0 360 0H472c13.3 0 24 10.7 24 24V136c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-39-39-24.7 24.7C407 163.3 416 192.6 416 224c0 80.2-59 146.6-136 158.2V408h24c13.3 0 24 10.7 24 24s-10.7 24-24 24H280v32c0 13.3-10.7 24-24 24s-24-10.7-24-24V456H208c-13.3 0-24-10.7-24-24s10.7-24 24-24h24V382.2C155 370.6 96 304.2 96 224c0-88.4 71.6-160 160-160c39.6 0 75.9 14.4 103.8 38.2L382.1 80 343 41c-6.9-6.9-8.9-17.2-5.2-26.2zM448 48l0 0h0v0zM352 224a96 96 0 1 0 -192 0 96 96 0 1 0 192 0z"
    ]
};
var $d8206b3ab2e65c05$export$9a513ee921e8e885 = {
    prefix: "fas",
    iconName: "house-user",
    icon: [
        576,
        512,
        [
            "home-user"
        ],
        "e1b0",
        "M575.8 255.5c0 18-15 32.1-32 32.1h-32l.7 160.2c.2 35.5-28.5 64.3-64 64.3H128.1c-35.3 0-64-28.7-64-64V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L564.8 231.5c8 7 12 15 11 24zM352 224a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm-96 96c-44.2 0-80 35.8-80 80c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16c0-44.2-35.8-80-80-80H256z"
    ]
};
var $d8206b3ab2e65c05$export$e732fa55ae5bbdf0 = $d8206b3ab2e65c05$export$9a513ee921e8e885;
var $d8206b3ab2e65c05$export$25e9b29b3f2230b5 = {
    prefix: "fas",
    iconName: "dumpster-fire",
    icon: [
        640,
        512,
        [],
        "f794",
        "M49.7 32c-10.5 0-19.8 6.9-22.9 16.9L.9 133c-.6 2-.9 4.1-.9 6.1C0 150.7 9.3 160 20.9 160h94L140.5 32H49.7zM272 160V32H173.1L147.5 160H272zm32 0h58c15.1-18.1 32.1-35.7 50.5-52.1c1.5-1.4 3.2-2.6 4.8-3.8L402.9 32H304V160zm209.9-23.7c17.4-15.8 43.9-16.2 61.7-1.2c-.1-.7-.3-1.4-.5-2.1L549.2 48.9C546.1 38.9 536.8 32 526.3 32H435.5l12.8 64.2c9.6 1 19 4.9 26.6 11.8c11.7 10.6 23 21.6 33.9 33.1c1.7-1.6 3.3-3.2 5-4.8zM325.2 210.7c3.8-6.2 7.9-12.5 12.3-18.7H32l4 32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H44L64 448c0 17.7 14.3 32 32 32s32-14.3 32-32H337.6c-31-34.7-49.6-80.6-49.6-129.9c0-35.2 16.3-73.6 37.2-107.4zM480 480c88.4 0 160-71.6 160-160c0-31.8-15.5-84-74.4-142.4c-11.8-11.7-30.6-10.7-42.3 1L512 189.9l-46-46c-6-6.1-14.1-9.3-22-9.2c-5.9 .1-11.8 1.9-16.8 5.8C382.5 175.3 320 243.3 320 320c0 88.4 71.6 160 160 160zm64-111.8c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-36.5 37-73 54.8-88.4c5.4-4.7 13.1-4.7 18.5 0C507 295.1 544 331.6 544 368.2z"
    ]
};
var $d8206b3ab2e65c05$export$baa3c215534dbf2a = {
    prefix: "fas",
    iconName: "house-crack",
    icon: [
        576,
        512,
        [],
        "e3b1",
        "M543.8 287.6c17 0 32-14 32-32.1c1-9-3-17-11-24L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24c0 18 14 32.1 32 32.1h32V448c0 35.3 28.7 64 64 64H230.4l-31.3-52.2c-4.1-6.8-2.6-15.5 3.5-20.5L288 368l-60.2-82.8c-10.9-15 8.2-33.5 22.8-22l117.9 92.6c8 6.3 8.2 18.4 .4 24.9L288 448l38.4 64H448.5c35.5 0 64.2-28.8 64-64.3l-.7-160.2h32z"
    ]
};
var $d8206b3ab2e65c05$export$c6e76550bdc0255d = {
    prefix: "fas",
    iconName: "martini-glass-citrus",
    icon: [
        576,
        512,
        [
            "cocktail"
        ],
        "f561",
        "M432 240c53 0 96-43 96-96s-43-96-96-96c-35.5 0-66.6 19.3-83.2 48H296.2C316 40.1 369.3 0 432 0c79.5 0 144 64.5 144 144s-64.5 144-144 144c-27.7 0-53.5-7.8-75.5-21.3l35.4-35.4c12.2 5.6 25.8 8.7 40.1 8.7zM1.8 142.8C5.5 133.8 14.3 128 24 128H392c9.7 0 18.5 5.8 22.2 14.8s1.7 19.3-5.2 26.2l-177 177V464h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H208 120c-13.3 0-24-10.7-24-24s10.7-24 24-24h64V345.9L7 169c-6.9-6.9-8.9-17.2-5.2-26.2z"
    ]
};
var $d8206b3ab2e65c05$export$4be708f1e41d387b = $d8206b3ab2e65c05$export$c6e76550bdc0255d;
var $d8206b3ab2e65c05$export$c938968e28178994 = {
    prefix: "fas",
    iconName: "face-surprise",
    icon: [
        512,
        512,
        [
            128558,
            "surprise"
        ],
        "f5c2",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM176.4 176a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM256 288a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"
    ]
};
var $d8206b3ab2e65c05$export$46647c72213f53ba = $d8206b3ab2e65c05$export$c938968e28178994;
var $d8206b3ab2e65c05$export$3ee278c67519eeeb = {
    prefix: "fas",
    iconName: "bottle-water",
    icon: [
        320,
        512,
        [],
        "e4c5",
        "M120 0h80c13.3 0 24 10.7 24 24V64H96V24c0-13.3 10.7-24 24-24zM32 167.5c0-19.5 10-37.6 26.6-47.9l15.8-9.9C88.7 100.7 105.2 96 122.1 96h75.8c16.9 0 33.4 4.7 47.7 13.7l15.8 9.9C278 129.9 288 148 288 167.5c0 17-7.5 32.3-19.4 42.6C280.6 221.7 288 238 288 256c0 19.1-8.4 36.3-21.7 48c13.3 11.7 21.7 28.9 21.7 48s-8.4 36.3-21.7 48c13.3 11.7 21.7 28.9 21.7 48c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64c0-19.1 8.4-36.3 21.7-48C40.4 388.3 32 371.1 32 352s8.4-36.3 21.7-48C40.4 292.3 32 275.1 32 256c0-18 7.4-34.3 19.4-45.9C39.5 199.7 32 184.5 32 167.5zM96 240c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H112c-8.8 0-16 7.2-16 16zm16 112c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H112z"
    ]
};
var $d8206b3ab2e65c05$export$fbeef2513e05ad08 = {
    prefix: "fas",
    iconName: "circle-pause",
    icon: [
        512,
        512,
        [
            62092,
            "pause-circle"
        ],
        "f28b",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM224 192V320c0 17.7-14.3 32-32 32s-32-14.3-32-32V192c0-17.7 14.3-32 32-32s32 14.3 32 32zm128 0V320c0 17.7-14.3 32-32 32s-32-14.3-32-32V192c0-17.7 14.3-32 32-32s32 14.3 32 32z"
    ]
};
var $d8206b3ab2e65c05$export$d8cf08a0362da8db = $d8206b3ab2e65c05$export$fbeef2513e05ad08;
var $d8206b3ab2e65c05$export$7a494edbf9b65575 = {
    prefix: "fas",
    iconName: "toilet-paper-slash",
    icon: [
        640,
        512,
        [],
        "e072",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-109.7-86C569.9 374 608 291.9 608 192C608 86 565 0 512 0s-96 86-96 192c0 49.1 9.2 93.9 24.4 127.9l-59-46.2c1.6-24.8 2.6-52 2.6-81.6c0-65.5 13.2-142.4 60.2-192H160c-24.8 0-47.4 18.8-64.4 49.6L38.8 5.1zM367.3 385.4L66.5 148.4C64.9 162.4 64 177 64 192c0 101.5-11.7 170.8-23 213.9c-5.1 19.4-10.7 39.9-20.5 57.7c-5.9 9.9-6.1 22.1-.4 32.2S36.5 512 48 512H285.9c22.3 0 45.4-12.1 55.4-36.1c7.4-17.7 17.5-47.2 26-90.6zM544 192c0 35.3-14.3 64-32 64s-32-28.7-32-64s14.3-64 32-64s32 28.7 32 64z"
    ]
};
var $d8206b3ab2e65c05$export$12de8220d30453a3 = {
    prefix: "fas",
    iconName: "apple-whole",
    icon: [
        448,
        512,
        [
            127822,
            127823,
            "apple-alt"
        ],
        "f5d1",
        "M224 112c-8.8 0-16-7.2-16-16V80c0-44.2 35.8-80 80-80h16c8.8 0 16 7.2 16 16V32c0 44.2-35.8 80-80 80H224zM0 288c0-76.3 35.7-160 112-160c27.3 0 59.7 10.3 82.7 19.3c18.8 7.3 39.9 7.3 58.7 0c22.9-8.9 55.4-19.3 82.7-19.3c76.3 0 112 83.7 112 160c0 128-80 224-160 224c-16.5 0-38.1-6.6-51.5-11.3c-8.1-2.8-16.9-2.8-25 0c-13.4 4.7-35 11.3-51.5 11.3C80 512 0 416 0 288z"
    ]
};
var $d8206b3ab2e65c05$export$bcdd94f3977a0884 = $d8206b3ab2e65c05$export$12de8220d30453a3;
var $d8206b3ab2e65c05$export$64c1570509eaf40d = {
    prefix: "fas",
    iconName: "kitchen-set",
    icon: [
        576,
        512,
        [],
        "e51a",
        "M240 144A96 96 0 1 0 48 144a96 96 0 1 0 192 0zm44.4 32C269.9 240.1 212.5 288 144 288C64.5 288 0 223.5 0 144S64.5 0 144 0c68.5 0 125.9 47.9 140.4 112h71.8c8.8-9.8 21.6-16 35.8-16H496c26.5 0 48 21.5 48 48s-21.5 48-48 48H392c-14.2 0-27-6.2-35.8-16H284.4zM144 80a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM400 240c13.3 0 24 10.7 24 24v8h96c13.3 0 24 10.7 24 24s-10.7 24-24 24H280c-13.3 0-24-10.7-24-24s10.7-24 24-24h96v-8c0-13.3 10.7-24 24-24zM288 464V352H512V464c0 26.5-21.5 48-48 48H336c-26.5 0-48-21.5-48-48zM48 320h80 16 32c26.5 0 48 21.5 48 48s-21.5 48-48 48H160c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V336c0-8.8 7.2-16 16-16zm128 64c8.8 0 16-7.2 16-16s-7.2-16-16-16H160v32h16zM24 464H200c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
    ]
};
var $d8206b3ab2e65c05$export$eb4c616de6eef46f = {
    prefix: "fas",
    iconName: "r",
    icon: [
        320,
        512,
        [
            114
        ],
        "52",
        "M64 32C28.7 32 0 60.7 0 96V288 448c0 17.7 14.3 32 32 32s32-14.3 32-32V320h95.3L261.8 466.4c10.1 14.5 30.1 18 44.6 7.9s18-30.1 7.9-44.6L230.1 309.5C282.8 288.1 320 236.4 320 176c0-79.5-64.5-144-144-144H64zM176 256H64V96H176c44.2 0 80 35.8 80 80s-35.8 80-80 80z"
    ]
};
var $d8206b3ab2e65c05$export$f9d1c19925fd7fa8 = {
    prefix: "fas",
    iconName: "temperature-quarter",
    icon: [
        320,
        512,
        [
            "temperature-1",
            "thermometer-1",
            "thermometer-quarter"
        ],
        "f2ca",
        "M160 64c-26.5 0-48 21.5-48 48V276.5c0 17.3-7.1 31.9-15.3 42.5C86.2 332.6 80 349.5 80 368c0 44.2 35.8 80 80 80s80-35.8 80-80c0-18.5-6.2-35.4-16.7-48.9c-8.2-10.6-15.3-25.2-15.3-42.5V112c0-26.5-21.5-48-48-48zM48 112C48 50.2 98.1 0 160 0s112 50.1 112 112V276.5c0 .1 .1 .3 .2 .6c.2 .6 .8 1.6 1.7 2.8c18.9 24.4 30.1 55 30.1 88.1c0 79.5-64.5 144-144 144S16 447.5 16 368c0-33.2 11.2-63.8 30.1-88.1c.9-1.2 1.5-2.2 1.7-2.8c.1-.3 .2-.5 .2-.6V112zM208 368c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V272c0-8.8 7.2-16 16-16s16 7.2 16 16v50.7c18.6 6.6 32 24.4 32 45.3z"
    ]
};
var $d8206b3ab2e65c05$export$d4f1cd380bde2129 = $d8206b3ab2e65c05$export$f9d1c19925fd7fa8;
var $d8206b3ab2e65c05$export$3f77fbe2dabe285b = $d8206b3ab2e65c05$export$f9d1c19925fd7fa8;
var $d8206b3ab2e65c05$export$ed05754fcbec6e46 = $d8206b3ab2e65c05$export$f9d1c19925fd7fa8;
var $d8206b3ab2e65c05$export$973ae4f1e4d2ce78 = {
    prefix: "fas",
    iconName: "cube",
    icon: [
        512,
        512,
        [],
        "f1b2",
        "M234.5 5.7c13.9-5 29.1-5 43.1 0l192 68.6C495 83.4 512 107.5 512 134.6V377.4c0 27-17 51.2-42.5 60.3l-192 68.6c-13.9 5-29.1 5-43.1 0l-192-68.6C17 428.6 0 404.5 0 377.4V134.6c0-27 17-51.2 42.5-60.3l192-68.6zM256 66L82.3 128 256 190l173.7-62L256 66zm32 368.6l160-57.1v-188L288 246.6v188z"
    ]
};
var $d8206b3ab2e65c05$export$441bfc8058328ce8 = {
    prefix: "fas",
    iconName: "bitcoin-sign",
    icon: [
        320,
        512,
        [],
        "e0b4",
        "M48 32C48 14.3 62.3 0 80 0s32 14.3 32 32V64h32V32c0-17.7 14.3-32 32-32s32 14.3 32 32V64c0 1.5-.1 3.1-.3 4.5C254.1 82.2 288 125.1 288 176c0 24.2-7.7 46.6-20.7 64.9c31.7 19.8 52.7 55 52.7 95.1c0 61.9-50.1 112-112 112v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V448H112v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V448H41.7C18.7 448 0 429.3 0 406.3V288 265.7 224 101.6C0 80.8 16.8 64 37.6 64H48V32zM64 224H176c26.5 0 48-21.5 48-48s-21.5-48-48-48H64v96zm112 64H64v96H208c26.5 0 48-21.5 48-48s-21.5-48-48-48H176z"
    ]
};
var $d8206b3ab2e65c05$export$2a5c6f182c0cbcb = {
    prefix: "fas",
    iconName: "shield-dog",
    icon: [
        512,
        512,
        [],
        "e573",
        "M269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L269.4 2.9zM160.9 286.2c4.8 1.2 9.9 1.8 15.1 1.8c35.3 0 64-28.7 64-64V160h44.2c12.1 0 23.2 6.8 28.6 17.7L320 192h64c8.8 0 16 7.2 16 16v32c0 44.2-35.8 80-80 80H272v50.7c0 7.3-5.9 13.3-13.3 13.3c-1.8 0-3.6-.4-5.2-1.1l-98.7-42.3c-6.6-2.8-10.8-9.3-10.8-16.4c0-2.8 .6-5.5 1.9-8l15-30zM160 160h40 8v32 32c0 17.7-14.3 32-32 32s-32-14.3-32-32V176c0-8.8 7.2-16 16-16zm128 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"
    ]
};
var $d8206b3ab2e65c05$export$b9c649c5e37017f3 = {
    prefix: "fas",
    iconName: "solar-panel",
    icon: [
        640,
        512,
        [],
        "f5ba",
        "M122.2 0C91.7 0 65.5 21.5 59.5 51.4L8.3 307.4C.4 347 30.6 384 71 384H288v64H224c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H352V384H569c40.4 0 70.7-36.9 62.8-76.6l-51.2-256C574.5 21.5 548.3 0 517.8 0H122.2zM260.9 64H379.1l10.4 104h-139L260.9 64zM202.3 168H101.4L122.2 64h90.4L202.3 168zM91.8 216H197.5L187.1 320H71L91.8 216zm153.9 0H394.3l10.4 104-169.4 0 10.4-104zm196.8 0H548.2L569 320h-116L442.5 216zm96-48H437.7L427.3 64h90.4l31.4-6.3L517.8 64l20.8 104z"
    ]
};
var $d8206b3ab2e65c05$export$84b5acad4436d02a = {
    prefix: "fas",
    iconName: "lock-open",
    icon: [
        576,
        512,
        [],
        "f3c1",
        "M352 144c0-44.2 35.8-80 80-80s80 35.8 80 80v48c0 17.7 14.3 32 32 32s32-14.3 32-32V144C576 64.5 511.5 0 432 0S288 64.5 288 144v48H64c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V256c0-35.3-28.7-64-64-64H352V144z"
    ]
};
var $d8206b3ab2e65c05$export$c7a833ce065e0ea4 = {
    prefix: "fas",
    iconName: "elevator",
    icon: [
        512,
        512,
        [],
        "e16d",
        "M132.7 4.7l-64 64c-4.6 4.6-5.9 11.5-3.5 17.4s8.3 9.9 14.8 9.9H208c6.5 0 12.3-3.9 14.8-9.9s1.1-12.9-3.5-17.4l-64-64c-6.2-6.2-16.4-6.2-22.6 0zM64 128c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V192c0-35.3-28.7-64-64-64H64zm96 96a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM80 400c0-26.5 21.5-48 48-48h64c26.5 0 48 21.5 48 48v16c0 17.7-14.3 32-32 32H112c-17.7 0-32-14.3-32-32V400zm192 0c0-26.5 21.5-48 48-48h64c26.5 0 48 21.5 48 48v16c0 17.7-14.3 32-32 32H304c-17.7 0-32-14.3-32-32V400zm32-128a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM356.7 91.3c6.2 6.2 16.4 6.2 22.6 0l64-64c4.6-4.6 5.9-11.5 3.5-17.4S438.5 0 432 0H304c-6.5 0-12.3 3.9-14.8 9.9s-1.1 12.9 3.5 17.4l64 64z"
    ]
};
var $d8206b3ab2e65c05$export$1b71392d9effbe = {
    prefix: "fas",
    iconName: "money-bill-transfer",
    icon: [
        640,
        512,
        [],
        "e528",
        "M535 41c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l64 64c4.5 4.5 7 10.6 7 17s-2.5 12.5-7 17l-64 64c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l23-23L384 112c-13.3 0-24-10.7-24-24s10.7-24 24-24l174.1 0L535 41zM105 377l-23 23L256 400c13.3 0 24 10.7 24 24s-10.7 24-24 24L81.9 448l23 23c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L7 441c-4.5-4.5-7-10.6-7-17s2.5-12.5 7-17l64-64c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zM96 64H337.9c-3.7 7.2-5.9 15.3-5.9 24c0 28.7 23.3 52 52 52l117.4 0c-4 17 .6 35.5 13.8 48.8c20.3 20.3 53.2 20.3 73.5 0L608 169.5V384c0 35.3-28.7 64-64 64H302.1c3.7-7.2 5.9-15.3 5.9-24c0-28.7-23.3-52-52-52l-117.4 0c4-17-.6-35.5-13.8-48.8c-20.3-20.3-53.2-20.3-73.5 0L32 342.5V128c0-35.3 28.7-64 64-64zm64 64H96v64c35.3 0 64-28.7 64-64zM544 320c-35.3 0-64 28.7-64 64h64V320zM320 352a96 96 0 1 0 0-192 96 96 0 1 0 0 192z"
    ]
};
var $d8206b3ab2e65c05$export$18ab80cba7d5044f = {
    prefix: "fas",
    iconName: "money-bill-trend-up",
    icon: [
        512,
        512,
        [],
        "e529",
        "M470.7 9.4c3 3.1 5.3 6.6 6.9 10.3s2.4 7.8 2.4 12.2l0 .1v0 96c0 17.7-14.3 32-32 32s-32-14.3-32-32V109.3L310.6 214.6c-11.8 11.8-30.8 12.6-43.5 1.7L176 138.1 84.8 216.3c-13.4 11.5-33.6 9.9-45.1-3.5s-9.9-33.6 3.5-45.1l112-96c12-10.3 29.7-10.3 41.7 0l89.5 76.7L370.7 64H352c-17.7 0-32-14.3-32-32s14.3-32 32-32h96 0c8.8 0 16.8 3.6 22.6 9.3l.1 .1zM0 304c0-26.5 21.5-48 48-48H464c26.5 0 48 21.5 48 48V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V304zM48 416v48H96c0-26.5-21.5-48-48-48zM96 304H48v48c26.5 0 48-21.5 48-48zM464 416c-26.5 0-48 21.5-48 48h48V416zM416 304c0 26.5 21.5 48 48 48V304H416zm-96 80a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z"
    ]
};
var $d8206b3ab2e65c05$export$30d3e64480aa266b = {
    prefix: "fas",
    iconName: "house-flood-water-circle-arrow-right",
    icon: [
        640,
        512,
        [],
        "e50f",
        "M288 144A144 144 0 1 0 0 144a144 144 0 1 0 288 0zM140.7 76.7c6.2-6.2 16.4-6.2 22.6 0l56 56c6.2 6.2 6.2 16.4 0 22.6l-56 56c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L169.4 160H80c-8.8 0-16-7.2-16-16s7.2-16 16-16h89.4L140.7 99.3c-6.2-6.2-6.2-16.4 0-22.6zM320 144c0 57.3-27.4 108.2-69.8 140.3c11.8-3.6 23-9.4 33-16.2c22.1-15.5 51.6-15.5 73.7 0c18.4 12.7 39.6 20.3 59.2 20.3c19 0 41.2-7.9 59.2-20.3c23.8-16.7 55.8-15.4 78.1 3.4c2.1 1.7 4.2 3.3 6.5 4.9l-.3-84.4H576c13.9 0 26.1-8.9 30.4-22.1s-.4-27.6-11.6-35.8l-176-128C407.6-2 392.4-2 381.2 6.1L301 64.4c12.1 23.9 19 50.9 19 79.6zm18.5 165.9c-11.1-7.9-25.9-7.9-37 0C279 325.4 251.5 336 224 336c-26.9 0-55.3-10.8-77.4-26.1l0 0c-11.9-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C158.5 389.7 191 400 224 400c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.6 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.5-27.3-10.1-39.2-1.7l0 0C471.4 325.2 442.9 336 416 336c-27.5 0-55-10.6-77.5-26.1zm0 112c-11.1-7.9-25.9-7.9-37 0C279 437.4 251.5 448 224 448c-26.9 0-55.3-10.8-77.4-26.1l0 0c-11.9-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C158.5 501.7 191 512 224 512c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.6 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.4-27.3-10.1-39.2-1.7l0 0C471.4 437.2 442.9 448 416 448c-27.5 0-55-10.6-77.5-26.1z"
    ]
};
var $d8206b3ab2e65c05$export$287bdd70ab874659 = {
    prefix: "fas",
    iconName: "square-poll-horizontal",
    icon: [
        448,
        512,
        [
            "poll-h"
        ],
        "f682",
        "M448 96c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320zM256 160c0 17.7-14.3 32-32 32l-96 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l96 0c17.7 0 32 14.3 32 32zm64 64c17.7 0 32 14.3 32 32s-14.3 32-32 32l-192 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l192 0zM192 352c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l32 0c17.7 0 32 14.3 32 32z"
    ]
};
var $d8206b3ab2e65c05$export$456a238f0144d430 = $d8206b3ab2e65c05$export$287bdd70ab874659;
var $d8206b3ab2e65c05$export$4280b2387fbdad12 = {
    prefix: "fas",
    iconName: "circle",
    icon: [
        512,
        512,
        [
            128308,
            128309,
            128992,
            128993,
            128994,
            128995,
            128996,
            9679,
            9898,
            9899,
            11044,
            61708,
            61915
        ],
        "f111",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512z"
    ]
};
var $d8206b3ab2e65c05$export$662cbc6ed5a3c5e8 = {
    prefix: "fas",
    iconName: "backward-fast",
    icon: [
        512,
        512,
        [
            9198,
            "fast-backward"
        ],
        "f049",
        "M493.6 445c-11.2 5.3-24.5 3.6-34.1-4.4L288 297.7V416c0 12.4-7.2 23.7-18.4 29s-24.5 3.6-34.1-4.4L64 297.7V416c0 17.7-14.3 32-32 32s-32-14.3-32-32V96C0 78.3 14.3 64 32 64s32 14.3 32 32V214.3L235.5 71.4c9.5-7.9 22.8-9.7 34.1-4.4S288 83.6 288 96V214.3L459.5 71.4c9.5-7.9 22.8-9.7 34.1-4.4S512 83.6 512 96V416c0 12.4-7.2 23.7-18.4 29z"
    ]
};
var $d8206b3ab2e65c05$export$e6246a3279a379b8 = $d8206b3ab2e65c05$export$662cbc6ed5a3c5e8;
var $d8206b3ab2e65c05$export$a65c441f12cb6bd = {
    prefix: "fas",
    iconName: "recycle",
    icon: [
        512,
        512,
        [
            9842,
            9850,
            9851
        ],
        "f1b8",
        "M174.7 45.1C192.2 17 223 0 256 0s63.8 17 81.3 45.1l38.6 61.7 27-15.6c8.4-4.9 18.9-4.2 26.6 1.7s11.1 15.9 8.6 25.3l-23.4 87.4c-3.4 12.8-16.6 20.4-29.4 17l-87.4-23.4c-9.4-2.5-16.3-10.4-17.6-20s3.4-19.1 11.8-23.9l28.4-16.4L283 79c-5.8-9.3-16-15-27-15s-21.2 5.7-27 15l-17.5 28c-9.2 14.8-28.6 19.5-43.6 10.5c-15.3-9.2-20.2-29.2-10.7-44.4l17.5-28zM429.5 251.9c15-9 34.4-4.3 43.6 10.5l24.4 39.1c9.4 15.1 14.4 32.4 14.6 50.2c.3 53.1-42.7 96.4-95.8 96.4L320 448v32c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-64-64c-9.4-9.4-9.4-24.6 0-33.9l64-64c6.9-6.9 17.2-8.9 26.2-5.2s14.8 12.5 14.8 22.2v32l96.2 0c17.6 0 31.9-14.4 31.8-32c0-5.9-1.7-11.7-4.8-16.7l-24.4-39.1c-9.5-15.2-4.7-35.2 10.7-44.4zm-364.6-31L36 204.2c-8.4-4.9-13.1-14.3-11.8-23.9s8.2-17.5 17.6-20l87.4-23.4c12.8-3.4 26 4.2 29.4 17L182 241.2c2.5 9.4-.9 19.3-8.6 25.3s-18.2 6.6-26.6 1.7l-26.5-15.3L68.8 335.3c-3.1 5-4.8 10.8-4.8 16.7c-.1 17.6 14.2 32 31.8 32l32.2 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32.2 0C42.7 448-.3 404.8 0 351.6c.1-17.8 5.1-35.1 14.6-50.2l50.3-80.5z"
    ]
};
var $d8206b3ab2e65c05$export$94363e983c225a04 = {
    prefix: "fas",
    iconName: "user-astronaut",
    icon: [
        448,
        512,
        [],
        "f4fb",
        "M370.7 96.1C346.1 39.5 289.7 0 224 0S101.9 39.5 77.3 96.1C60.9 97.5 48 111.2 48 128v64c0 16.8 12.9 30.5 29.3 31.9C101.9 280.5 158.3 320 224 320s122.1-39.5 146.7-96.1c16.4-1.4 29.3-15.1 29.3-31.9V128c0-16.8-12.9-30.5-29.3-31.9zM336 144v16c0 53-43 96-96 96H208c-53 0-96-43-96-96V144c0-26.5 21.5-48 48-48H288c26.5 0 48 21.5 48 48zM189.3 162.7l-6-21.2c-.9-3.3-3.9-5.5-7.3-5.5s-6.4 2.2-7.3 5.5l-6 21.2-21.2 6c-3.3 .9-5.5 3.9-5.5 7.3s2.2 6.4 5.5 7.3l21.2 6 6 21.2c.9 3.3 3.9 5.5 7.3 5.5s6.4-2.2 7.3-5.5l6-21.2 21.2-6c3.3-.9 5.5-3.9 5.5-7.3s-2.2-6.4-5.5-7.3l-21.2-6zM112.7 316.5C46.7 342.6 0 407 0 482.3C0 498.7 13.3 512 29.7 512H128V448c0-17.7 14.3-32 32-32H288c17.7 0 32 14.3 32 32v64l98.3 0c16.4 0 29.7-13.3 29.7-29.7c0-75.3-46.7-139.7-112.7-165.8C303.9 338.8 265.5 352 224 352s-79.9-13.2-111.3-35.5zM176 448c-8.8 0-16 7.2-16 16v48h32V464c0-8.8-7.2-16-16-16zm96 32a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"
    ]
};
var $d8206b3ab2e65c05$export$cfee4df0d5df6d21 = {
    prefix: "fas",
    iconName: "plane-slash",
    icon: [
        640,
        512,
        [],
        "e069",
        "M440.6 320h73.8c34.2 0 93.7-28 93.7-64c0-35-59.5-64-93.7-64l-116.6 0L297.2 16.1C291.5 6.2 280.9 0 269.4 0H213.2c-10.6 0-18.3 10.2-15.4 20.4l40.3 140.9L38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L440.6 320zm-78.1 61.6L41.5 128.7C36 130.6 32 135.9 32 142c0 1.3 .2 2.6 .5 3.9L64 256 32.5 366.1c-.4 1.3-.5 2.6-.5 3.9c0 7.8 6.3 14 14 14H88c5 0 9.8-2.4 12.8-6.4L144 320H246.9l-49 171.6c-2.9 10.2 4.8 20.4 15.4 20.4l56.2 0c11.5 0 22.1-6.2 27.8-16.1l65.3-114.3z"
    ]
};
var $d8206b3ab2e65c05$export$9c9b2fbddd59047d = {
    prefix: "fas",
    iconName: "trademark",
    icon: [
        640,
        512,
        [
            8482
        ],
        "f25c",
        "M345.6 108.8c-8.3-11-22.7-15.5-35.7-11.2S288 114.2 288 128V384c0 17.7 14.3 32 32 32s32-14.3 32-32V224l86.4 115.2c6 8.1 15.5 12.8 25.6 12.8s19.6-4.7 25.6-12.8L576 224V384c0 17.7 14.3 32 32 32s32-14.3 32-32V128c0-13.8-8.8-26-21.9-30.4s-27.5 .1-35.7 11.2L464 266.7 345.6 108.8zM0 128c0 17.7 14.3 32 32 32H96V384c0 17.7 14.3 32 32 32s32-14.3 32-32V160h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H32C14.3 96 0 110.3 0 128z"
    ]
};
var $d8206b3ab2e65c05$export$44dee69e3a29b0e = {
    prefix: "fas",
    iconName: "basketball",
    icon: [
        512,
        512,
        [
            127936,
            "basketball-ball"
        ],
        "f434",
        "M86.6 64l85.2 85.2C194.5 121.7 208 86.4 208 48c0-14.7-2-28.9-5.7-42.4C158.6 15 119 35.5 86.6 64zM64 86.6C35.5 119 15 158.6 5.6 202.3C19.1 206 33.3 208 48 208c38.4 0 73.7-13.5 101.3-36.1L64 86.6zM256 0c-7.3 0-14.6 .3-21.8 .9C238 16 240 31.8 240 48c0 47.3-17.1 90.5-45.4 124L256 233.4 425.4 64C380.2 24.2 320.9 0 256 0zM48 240c-16.2 0-32-2-47.1-5.8C.3 241.4 0 248.7 0 256c0 64.9 24.2 124.2 64 169.4L233.4 256 172 194.6C138.5 222.9 95.3 240 48 240zm463.1 37.8c.6-7.2 .9-14.5 .9-21.8c0-64.9-24.2-124.2-64-169.4L278.6 256 340 317.4c33.4-28.3 76.7-45.4 124-45.4c16.2 0 32 2 47.1 5.8zm-4.7 31.9C492.9 306 478.7 304 464 304c-38.4 0-73.7 13.5-101.3 36.1L448 425.4c28.5-32.3 49.1-71.9 58.4-115.7zM340.1 362.7C317.5 390.3 304 425.6 304 464c0 14.7 2 28.9 5.7 42.4C353.4 497 393 476.5 425.4 448l-85.2-85.2zM317.4 340L256 278.6 86.6 448c45.1 39.8 104.4 64 169.4 64c7.3 0 14.6-.3 21.8-.9C274 496 272 480.2 272 464c0-47.3 17.1-90.5 45.4-124z"
    ]
};
var $d8206b3ab2e65c05$export$36550ab8ffcc5b28 = $d8206b3ab2e65c05$export$44dee69e3a29b0e;
var $d8206b3ab2e65c05$export$219ccae0e4da3c92 = {
    prefix: "fas",
    iconName: "satellite-dish",
    icon: [
        512,
        512,
        [
            128225
        ],
        "f7c0",
        "M192 32c0-17.7 14.3-32 32-32C383.1 0 512 128.9 512 288c0 17.7-14.3 32-32 32s-32-14.3-32-32C448 164.3 347.7 64 224 64c-17.7 0-32-14.3-32-32zM60.6 220.6L164.7 324.7l28.4-28.4c-.7-2.6-1.1-5.4-1.1-8.3c0-17.7 14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32c-2.9 0-5.6-.4-8.3-1.1l-28.4 28.4L291.4 451.4c14.5 14.5 11.8 38.8-7.3 46.3C260.5 506.9 234.9 512 208 512C93.1 512 0 418.9 0 304c0-26.9 5.1-52.5 14.4-76.1c7.5-19 31.8-21.8 46.3-7.3zM224 96c106 0 192 86 192 192c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-70.7-57.3-128-128-128c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
    ]
};
var $d8206b3ab2e65c05$export$72ea8a5e4e86cd69 = {
    prefix: "fas",
    iconName: "circle-up",
    icon: [
        512,
        512,
        [
            61467,
            "arrow-alt-circle-up"
        ],
        "f35b",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM135.1 217.4l107.1-99.9c3.8-3.5 8.7-5.5 13.8-5.5s10.1 2 13.8 5.5l107.1 99.9c4.5 4.2 7.1 10.1 7.1 16.3c0 12.3-10 22.3-22.3 22.3H304v96c0 17.7-14.3 32-32 32H240c-17.7 0-32-14.3-32-32V256H150.3C138 256 128 246 128 233.7c0-6.2 2.6-12.1 7.1-16.3z"
    ]
};
var $d8206b3ab2e65c05$export$3747a8ef0995eadf = $d8206b3ab2e65c05$export$72ea8a5e4e86cd69;
var $d8206b3ab2e65c05$export$da39ed20699ee2d7 = {
    prefix: "fas",
    iconName: "mobile-screen-button",
    icon: [
        384,
        512,
        [
            "mobile-alt"
        ],
        "f3cd",
        "M16 64C16 28.7 44.7 0 80 0H304c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H80c-35.3 0-64-28.7-64-64V64zM224 448a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM304 64H80V384H304V64z"
    ]
};
var $d8206b3ab2e65c05$export$e9599bc6cd92234d = $d8206b3ab2e65c05$export$da39ed20699ee2d7;
var $d8206b3ab2e65c05$export$39461921e738be65 = {
    prefix: "fas",
    iconName: "volume-high",
    icon: [
        640,
        512,
        [
            128266,
            "volume-up"
        ],
        "f028",
        "M533.6 32.5C598.5 85.2 640 165.8 640 256s-41.5 170.7-106.4 223.5c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C557.5 398.2 592 331.2 592 256s-34.5-142.2-88.7-186.3c-10.3-8.4-11.8-23.5-3.5-33.8s23.5-11.8 33.8-3.5zM473.1 107c43.2 35.2 70.9 88.9 70.9 149s-27.7 113.8-70.9 149c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C475.3 341.3 496 301.1 496 256s-20.7-85.3-53.2-111.8c-10.3-8.4-11.8-23.5-3.5-33.8s23.5-11.8 33.8-3.5zm-60.5 74.5C434.1 199.1 448 225.9 448 256s-13.9 56.9-35.4 74.5c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C393.1 284.4 400 271 400 256s-6.9-28.4-17.7-37.3c-10.3-8.4-11.8-23.5-3.5-33.8s23.5-11.8 33.8-3.5zM301.1 34.8C312.6 40 320 51.4 320 64V448c0 12.6-7.4 24-18.9 29.2s-25 3.1-34.4-5.3L131.8 352H64c-35.3 0-64-28.7-64-64V224c0-35.3 28.7-64 64-64h67.8L266.7 40.1c9.4-8.4 22.9-10.4 34.4-5.3z"
    ]
};
var $d8206b3ab2e65c05$export$5940d3e475d90cc4 = $d8206b3ab2e65c05$export$39461921e738be65;
var $d8206b3ab2e65c05$export$9c0b63b698611d06 = {
    prefix: "fas",
    iconName: "users-rays",
    icon: [
        640,
        512,
        [],
        "e593",
        "M41 7C31.6-2.3 16.4-2.3 7 7S-2.3 31.6 7 41l72 72c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L41 7zM599 7L527 79c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l72-72c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0zM7 505c9.4 9.4 24.6 9.4 33.9 0l72-72c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L7 471c-9.4 9.4-9.4 24.6 0 33.9zm592 0c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-72-72c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l72 72zM320 256a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM212.1 336c-2.7 7.5-4.1 15.6-4.1 24c0 13.3 10.7 24 24 24H408c13.3 0 24-10.7 24-24c0-8.4-1.4-16.5-4.1-24c-.5-1.4-1-2.7-1.6-4c-9.4-22.3-29.8-38.9-54.3-43c-3.9-.7-7.9-1-12-1H280c-4.1 0-8.1 .3-12 1c-.8 .1-1.7 .3-2.5 .5c-24.9 5.1-45.1 23-53.4 46.5zM175.8 224a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-26.5 32C119.9 256 96 279.9 96 309.3c0 14.7 11.9 26.7 26.7 26.7h56.1c8-34.1 32.8-61.7 65.2-73.6c-7.5-4.1-16.2-6.4-25.3-6.4H149.3zm368 80c14.7 0 26.7-11.9 26.7-26.7c0-29.5-23.9-53.3-53.3-53.3H421.3c-9.2 0-17.8 2.3-25.3 6.4c32.4 11.9 57.2 39.5 65.2 73.6h56.1zM464 224a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"
    ]
};
var $d8206b3ab2e65c05$export$79204db8777905c8 = {
    prefix: "fas",
    iconName: "wallet",
    icon: [
        512,
        512,
        [],
        "f555",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V192c0-35.3-28.7-64-64-64H80c-8.8 0-16-7.2-16-16s7.2-16 16-16H448c17.7 0 32-14.3 32-32s-14.3-32-32-32H64zM416 272a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $d8206b3ab2e65c05$export$7babcb2c90eb609a = {
    prefix: "fas",
    iconName: "clipboard-check",
    icon: [
        384,
        512,
        [],
        "f46c",
        "M192 0c-41.8 0-77.4 26.7-90.5 64H64C28.7 64 0 92.7 0 128V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H282.5C269.4 26.7 233.8 0 192 0zm0 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM305 273L177 401c-9.4 9.4-24.6 9.4-33.9 0L79 337c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L271 239c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"
    ]
};
var $d8206b3ab2e65c05$export$b8d24c57c9e64933 = {
    prefix: "fas",
    iconName: "file-audio",
    icon: [
        384,
        512,
        [],
        "f1c7",
        "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zm2 226.3c37.1 22.4 62 63.1 62 109.7s-24.9 87.3-62 109.7c-7.6 4.6-17.4 2.1-22-5.4s-2.1-17.4 5.4-22C269.4 401.5 288 370.9 288 336s-18.6-65.5-46.5-82.3c-7.6-4.6-10-14.4-5.4-22s14.4-10 22-5.4zm-91.9 30.9c6 2.5 9.9 8.3 9.9 14.8V400c0 6.5-3.9 12.3-9.9 14.8s-12.9 1.1-17.4-3.5L113.4 376H80c-8.8 0-16-7.2-16-16V312c0-8.8 7.2-16 16-16h33.4l35.3-35.3c4.6-4.6 11.5-5.9 17.4-3.5zm51 34.9c6.6-5.9 16.7-5.3 22.6 1.3C249.8 304.6 256 319.6 256 336s-6.2 31.4-16.3 42.7c-5.9 6.6-16 7.1-22.6 1.3s-7.1-16-1.3-22.6c5.1-5.7 8.1-13.1 8.1-21.3s-3.1-15.7-8.1-21.3c-5.9-6.6-5.3-16.7 1.3-22.6z"
    ]
};
var $d8206b3ab2e65c05$export$128a6cab12423493 = {
    prefix: "fas",
    iconName: "burger",
    icon: [
        512,
        512,
        [
            "hamburger"
        ],
        "f805",
        "M61.1 224C45 224 32 211 32 194.9c0-1.9 .2-3.7 .6-5.6C37.9 168.3 78.8 32 256 32s218.1 136.3 223.4 157.3c.5 1.9 .6 3.7 .6 5.6c0 16.1-13 29.1-29.1 29.1H61.1zM144 128a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm240 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM272 96a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM16 304c0-26.5 21.5-48 48-48H448c26.5 0 48 21.5 48 48s-21.5 48-48 48H64c-26.5 0-48-21.5-48-48zm16 96c0-8.8 7.2-16 16-16H464c8.8 0 16 7.2 16 16v16c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V400z"
    ]
};
var $d8206b3ab2e65c05$export$bab3bb9f4f59363 = $d8206b3ab2e65c05$export$128a6cab12423493;
var $d8206b3ab2e65c05$export$3c6c0c8185296ac5 = {
    prefix: "fas",
    iconName: "wrench",
    icon: [
        512,
        512,
        [
            128295
        ],
        "f0ad",
        "M352 320c88.4 0 160-71.6 160-160c0-15.3-2.2-30.1-6.2-44.2c-3.1-10.8-16.4-13.2-24.3-5.3l-76.8 76.8c-3 3-7.1 4.7-11.3 4.7H336c-8.8 0-16-7.2-16-16V118.6c0-4.2 1.7-8.3 4.7-11.3l76.8-76.8c7.9-7.9 5.4-21.2-5.3-24.3C382.1 2.2 367.3 0 352 0C263.6 0 192 71.6 192 160c0 19.1 3.4 37.5 9.5 54.5L19.9 396.1C7.2 408.8 0 426.1 0 444.1C0 481.6 30.4 512 67.9 512c18 0 35.3-7.2 48-19.9L297.5 310.5c17 6.2 35.4 9.5 54.5 9.5zM80 408a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
    ]
};
var $d8206b3ab2e65c05$export$f5bfd1271b8b71d1 = {
    prefix: "fas",
    iconName: "bugs",
    icon: [
        576,
        512,
        [],
        "e4d0",
        "M164.5 107.4l33.4-73.5c5.5-12.1 .1-26.3-11.9-31.8s-26.3-.1-31.8 11.9L128 71.7 101.9 14.1C96.4 2 82.1-3.3 70.1 2.1S52.7 21.9 58.1 33.9l33.4 73.5c-10.2 7.1-18.2 17-22.9 28.6h-17l-4.1-20.7c-2.6-13-15.2-21.4-28.2-18.8S-2.1 111.7 .5 124.7l8 40C10.7 175.9 20.6 184 32 184H64v23.3l-37.8 9.5c-9.5 2.4-16.6 10.2-17.9 19.9l-8 56c-1.9 13.1 7.2 25.3 20.4 27.2s25.3-7.2 27.2-20.4l5.7-40 18.4-4.6C82.7 274.6 103.8 288 128 288s45.3-13.4 56.1-33.2l18.4 4.6 5.7 40c1.9 13.1 14 22.2 27.2 20.4s22.2-14 20.4-27.2l-8-56c-1.4-9.7-8.5-17.5-17.9-19.9L192 207.3V184h32c11.4 0 21.3-8.1 23.5-19.3l8-40c2.6-13-5.8-25.6-18.8-28.2s-25.6 5.8-28.2 18.8L204.3 136h-17c-4.7-11.6-12.7-21.5-22.9-28.6zM496 286.5l65.6-47c10.8-7.7 13.3-22.7 5.6-33.5s-22.7-13.3-33.5-5.6l-51.4 36.8 6.1-62.9c1.3-13.2-8.4-24.9-21.6-26.2s-24.9 8.4-26.2 21.6L432.8 250c-12.3 1-24.2 5.6-34.1 13.3L384 254.8l6.8-20c4.2-12.6-2.5-26.2-15-30.4s-26.2 2.5-30.4 15l-13.1 38.6c-3.7 10.8 .8 22.8 10.7 28.5l27.7 16L359 322.7 321.5 312c-9.4-2.7-19.5 .6-25.5 8.3l-34.9 44.5c-8.2 10.4-6.4 25.5 4.1 33.7s25.5 6.4 33.7-4.1l25-31.8 18.2 5.2c-.5 22.6 11 44.7 32 56.8s45.9 11 65.2-.7l13.6 13.2-15.1 37.5c-4.9 12.3 1 26.3 13.3 31.2s26.3-1 31.2-13.3L503.5 440c3.6-9.1 1.4-19.4-5.6-26.2l-28-27.1 11.6-20.1 27.7 16c9.9 5.7 22.5 3.7 30-4.9L566.2 347c8.7-10 7.8-25.1-2.2-33.9s-25.1-7.8-33.9 2.2l-13.9 15.9-14.7-8.5c1.7-12.4-.2-25-5.5-36.2z"
    ]
};
var $d8206b3ab2e65c05$export$8bf9e3f7f57d486a = {
    prefix: "fas",
    iconName: "rupee-sign",
    icon: [
        448,
        512,
        [
            8360,
            "rupee"
        ],
        "f156",
        "M0 64C0 46.3 14.3 32 32 32h80c79.5 0 144 64.5 144 144c0 58.8-35.2 109.3-85.7 131.7l51.4 128.4c6.6 16.4-1.4 35-17.8 41.6s-35-1.4-41.6-17.8L106.3 320H64V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V288 64zM64 256h48c44.2 0 80-35.8 80-80s-35.8-80-80-80H64V256zm256.5 16.4c-.9 6 0 8.7 .4 9.8c.4 1.1 1.4 2.6 4.2 4.9c7.2 5.7 18.7 10 37.9 16.8l1.3 .5c16 5.6 38.7 13.6 55.7 28.1c9.5 8.1 17.9 18.6 23.1 32.3c5.1 13.7 6.1 28.5 3.8 44c-4.2 28.1-20.5 49.3-43.8 60.9c-22.1 11-48.1 12.5-73.2 8l-.2 0 0 0c-9.3-1.8-20.5-5.7-29.3-9c-6-2.3-12.6-4.9-17.7-6.9l0 0c-2.5-1-4.6-1.8-6.3-2.5c-16.5-6.4-24.6-25-18.2-41.4s24.9-24.6 41.4-18.2c2.6 1 5.2 2 7.9 3.1l0 0c4.8 1.9 9.8 3.9 15.4 6c8.8 3.3 15.3 5.4 18.7 6c15.7 2.8 26.7 .8 32.9-2.3c5-2.5 8-6 9.1-13c1-6.9 .2-10.5-.5-12.3c-.6-1.7-1.8-3.6-4.5-5.9c-6.9-5.8-18.2-10.4-36.9-17l-3-1.1c-15.5-5.4-37-13-53.3-25.9c-9.5-7.5-18.3-17.6-23.7-31c-5.5-13.4-6.6-28-4.4-43.2c8.4-57.1 67-78 116.9-68.9c6.9 1.3 27.3 5.8 35.4 8.4c16.9 5.2 26.3 23.2 21.1 40.1s-23.2 26.3-40.1 21.1c-4.7-1.4-22.3-5.5-27.9-6.5c-14.6-2.7-25.8-.4-32.6 3.2c-6.3 3.3-8.9 7.6-9.5 12z"
    ]
};
var $d8206b3ab2e65c05$export$9da25a46cfcb6fa4 = $d8206b3ab2e65c05$export$8bf9e3f7f57d486a;
var $d8206b3ab2e65c05$export$6440b286d3cbac9b = {
    prefix: "fas",
    iconName: "file-image",
    icon: [
        384,
        512,
        [
            128443
        ],
        "f1c5",
        "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM64 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm152 32c5.3 0 10.2 2.6 13.2 6.9l88 128c3.4 4.9 3.7 11.3 1 16.5s-8.2 8.6-14.2 8.6H216 176 128 80c-5.8 0-11.1-3.1-13.9-8.1s-2.8-11.2 .2-16.1l48-80c2.9-4.8 8.1-7.8 13.7-7.8s10.8 2.9 13.7 7.8l12.8 21.4 48.3-70.2c3-4.3 7.9-6.9 13.2-6.9z"
    ]
};
var $d8206b3ab2e65c05$export$d7cf0978afd90002 = {
    prefix: "fas",
    iconName: "circle-question",
    icon: [
        512,
        512,
        [
            62108,
            "question-circle"
        ],
        "f059",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM169.8 165.3c7.9-22.3 29.1-37.3 52.8-37.3h58.3c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24V250.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1H222.6c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
    ]
};
var $d8206b3ab2e65c05$export$5ba67d7f2265c1a5 = $d8206b3ab2e65c05$export$d7cf0978afd90002;
var $d8206b3ab2e65c05$export$6ccbeeccfea6dc8a = {
    prefix: "fas",
    iconName: "plane-departure",
    icon: [
        640,
        512,
        [
            128747
        ],
        "f5b0",
        "M381 114.9L186.1 41.8c-16.7-6.2-35.2-5.3-51.1 2.7L89.1 67.4C78 73 77.2 88.5 87.6 95.2l146.9 94.5L136 240 77.8 214.1c-8.7-3.9-18.8-3.7-27.3 .6L18.3 230.8c-9.3 4.7-11.8 16.8-5 24.7l73.1 85.3c6.1 7.1 15 11.2 24.3 11.2H248.4c5 0 9.9-1.2 14.3-3.4L535.6 212.2c46.5-23.3 82.5-63.3 100.8-112C645.9 75 627.2 48 600.2 48H542.8c-20.2 0-40.2 4.8-58.2 14L381 114.9zM0 480c0 17.7 14.3 32 32 32H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H32c-17.7 0-32 14.3-32 32z"
    ]
};
var $d8206b3ab2e65c05$export$2cef3f81ad90fb76 = {
    prefix: "fas",
    iconName: "handshake-slash",
    icon: [
        640,
        512,
        [],
        "e060",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-135-105.8c-1.1-11.3-6.3-22.3-15.3-30.7l-134.2-123-23.4 18.2-26-20.3 77.2-60.1c7-5.4 17-4.2 22.5 2.8s4.2 17-2.8 22.5l-20.9 16.2L512 316.8V128h-.7l-3.9-2.5L434.8 79c-15.3-9.8-33.2-15-51.4-15c-21.8 0-43 7.5-60 21.2l-89.7 72.6-25.8-20.3 81.8-66.2c-11.6-4.9-24.1-7.4-36.8-7.4C234 64 215.7 69.6 200 80l-35.5 23.7L38.8 5.1zM413.6 421.9L128 196.8V352h28.2l91.4 83.4c19.6 17.9 49.9 16.5 67.8-3.1c5.5-6.1 9.2-13.2 11.1-20.6l17 15.6c19.5 17.9 49.9 16.6 67.8-2.9c.8-.8 1.5-1.7 2.2-2.6zM96 171.6L40.6 128H16c-8.8 0-16 7.2-16 16V352c0 17.7 14.3 32 32 32H64c17.7 0 32-14.3 32-32V171.6zM48 320a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM544 128V352c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V144c0-8.8-7.2-16-16-16H544zm32 208a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"
    ]
};
var $d8206b3ab2e65c05$export$3d177ecdf7fc50ec = {
    prefix: "fas",
    iconName: "book-bookmark",
    icon: [
        448,
        512,
        [],
        "e0bb",
        "M0 96C0 43 43 0 96 0h96V190.7c0 13.4 15.5 20.9 26 12.5L272 160l54 43.2c10.5 8.4 26 .9 26-12.5V0h32 32c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32v64c17.7 0 32 14.3 32 32s-14.3 32-32 32H384 96c-53 0-96-43-96-96V96zM64 416c0 17.7 14.3 32 32 32H352V384H96c-17.7 0-32 14.3-32 32z"
    ]
};
var $d8206b3ab2e65c05$export$aa054a78ab078db3 = {
    prefix: "fas",
    iconName: "code-branch",
    icon: [
        448,
        512,
        [],
        "f126",
        "M80 104a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm80-24c0 32.8-19.7 61-48 73.3v87.8c18.8-10.9 40.7-17.1 64-17.1h96c35.3 0 64-28.7 64-64v-6.7C307.7 141 288 112.8 288 80c0-44.2 35.8-80 80-80s80 35.8 80 80c0 32.8-19.7 61-48 73.3V160c0 70.7-57.3 128-128 128H176c-35.3 0-64 28.7-64 64v6.7c28.3 12.3 48 40.5 48 73.3c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-32.8 19.7-61 48-73.3V352 153.3C19.7 141 0 112.8 0 80C0 35.8 35.8 0 80 0s80 35.8 80 80zm232 0a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM80 456a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
    ]
};
var $d8206b3ab2e65c05$export$37672611144b857b = {
    prefix: "fas",
    iconName: "hat-cowboy",
    icon: [
        640,
        512,
        [],
        "f8c0",
        "M320 64c14.4 0 22.3-7 30.8-14.4C360.4 41.1 370.7 32 392 32c49.3 0 84.4 152.2 97.9 221.9C447.8 272.1 390.9 288 320 288s-127.8-15.9-169.9-34.1C163.6 184.2 198.7 32 248 32c21.3 0 31.6 9.1 41.2 17.6C297.7 57 305.6 64 320 64zM111.1 270.7c47.2 24.5 117.5 49.3 209 49.3s161.8-24.8 208.9-49.3c24.8-12.9 49.8-28.3 70.1-47.7c7.9-7.9 20.2-9.2 29.6-3.3c9.5 5.9 13.5 17.9 9.9 28.5c-13.5 37.7-38.4 72.3-66.1 100.6C523.7 398.9 443.6 448 320 448s-203.6-49.1-252.5-99.2C39.8 320.4 14.9 285.8 1.4 248.1c-3.6-10.6 .4-22.6 9.9-28.5c9.5-5.9 21.7-4.5 29.6 3.3c20.4 19.4 45.3 34.8 70.1 47.7z"
    ]
};
var $d8206b3ab2e65c05$export$f402c7c97f3383f0 = {
    prefix: "fas",
    iconName: "bridge",
    icon: [
        576,
        512,
        [],
        "e4c8",
        "M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96H72v64H0V288c53 0 96 43 96 96v64c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V384c0-53 43-96 96-96s96 43 96 96v64c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V384c0-53 43-96 96-96V160H504V96h40c17.7 0 32-14.3 32-32s-14.3-32-32-32H32zM456 96v64H376V96h80zM328 96v64H248V96h80zM200 96v64H120V96h80z"
    ]
};
var $d8206b3ab2e65c05$export$d86c56ab43eb0deb = {
    prefix: "fas",
    iconName: "phone-flip",
    icon: [
        512,
        512,
        [
            128381,
            "phone-alt"
        ],
        "f879",
        "M347.1 24.6c7.7-18.6 28-28.5 47.4-23.2l88 24C499.9 30.2 512 46 512 64c0 247.4-200.6 448-448 448c-18 0-33.8-12.1-38.6-29.5l-24-88c-5.3-19.4 4.6-39.7 23.2-47.4l96-40c16.3-6.8 35.2-2.1 46.3 11.6L207.3 368c70.4-33.3 127.4-90.3 160.7-160.7L318.7 167c-13.7-11.2-18.4-30-11.6-46.3l40-96z"
    ]
};
var $d8206b3ab2e65c05$export$a07a9b305deebf32 = $d8206b3ab2e65c05$export$d86c56ab43eb0deb;
var $d8206b3ab2e65c05$export$4a5a13c01d46357c = {
    prefix: "fas",
    iconName: "truck-front",
    icon: [
        512,
        512,
        [],
        "e2b7",
        "M0 80C0 35.8 35.8 0 80 0H432c44.2 0 80 35.8 80 80V368c0 26.2-12.6 49.4-32 64v48c0 17.7-14.3 32-32 32H416c-17.7 0-32-14.3-32-32V448H128v32c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V432C12.6 417.4 0 394.2 0 368V80zm129.9 72.2L112 224H400l-17.9-71.8C378.5 138 365.7 128 351 128H161c-14.7 0-27.5 10-31 24.2zM128 320a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm288 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
var $d8206b3ab2e65c05$export$ab927dada03be4b3 = {
    prefix: "fas",
    iconName: "cat",
    icon: [
        576,
        512,
        [
            128008
        ],
        "f6be",
        "M320 192h17.1c22.1 38.3 63.5 64 110.9 64c11 0 21.8-1.4 32-4v4 32V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V339.2L280 448h56c17.7 0 32 14.3 32 32s-14.3 32-32 32H192c-53 0-96-43-96-96V192.5c0-16.1-12-29.8-28-31.8l-7.9-1c-17.5-2.2-30-18.2-27.8-35.7s18.2-30 35.7-27.8l7.9 1c48 6 84.1 46.8 84.1 95.3v85.3c34.4-51.7 93.2-85.8 160-85.8zm160 26.5v0c-10 3.5-20.8 5.5-32 5.5c-28.4 0-54-12.4-71.6-32h0c-3.7-4.1-7-8.5-9.9-13.2C357.3 164 352 146.6 352 128v0V32 12 10.7C352 4.8 356.7 .1 362.6 0h.2c3.3 0 6.4 1.6 8.4 4.2l0 .1L384 21.3l27.2 36.3L416 64h64l4.8-6.4L512 21.3 524.8 4.3l0-.1c2-2.6 5.1-4.2 8.4-4.2h.2C539.3 .1 544 4.8 544 10.7V12 32v96c0 17.3-4.6 33.6-12.6 47.6c-11.3 19.8-29.6 35.2-51.4 42.9zM432 128a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm48 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"
    ]
};
var $d8206b3ab2e65c05$export$61add9eca991b5ec = {
    prefix: "fas",
    iconName: "anchor-circle-exclamation",
    icon: [
        640,
        512,
        [],
        "e4ab",
        "M320 96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm21.1 80C367 158.8 384 129.4 384 96c0-53-43-96-96-96s-96 43-96 96c0 33.4 17 62.8 42.9 80H224c-17.7 0-32 14.3-32 32s14.3 32 32 32h32V448H208c-53 0-96-43-96-96v-6.1l7 7c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L97 263c-9.4-9.4-24.6-9.4-33.9 0L7 319c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l7-7V352c0 88.4 71.6 160 160 160h80 80c8.2 0 16.3-.6 24.2-1.8c-22.2-16.2-40.4-37.5-53-62.2H320V368 240h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H341.1zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V288c0-8.8 7.2-16 16-16z"
    ]
};
var $d8206b3ab2e65c05$export$f4419f7b2e53b340 = {
    prefix: "fas",
    iconName: "truck-field",
    icon: [
        640,
        512,
        [],
        "e58d",
        "M32 96c0-35.3 28.7-64 64-64H320c23.7 0 44.4 12.9 55.4 32h51.8c25.3 0 48.2 14.9 58.5 38l52.8 118.8c.5 1.1 .9 2.1 1.3 3.2H544c35.3 0 64 28.7 64 64v32c17.7 0 32 14.3 32 32s-14.3 32-32 32H576c0 53-43 96-96 96s-96-43-96-96H256c0 53-43 96-96 96s-96-43-96-96H32c-17.7 0-32-14.3-32-32s14.3-32 32-32V288c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32V96zM384 224h85.9l-42.7-96H384v96zM160 432a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm368-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"
    ]
};
var $d8206b3ab2e65c05$export$806c0a45a7ecd6e8 = {
    prefix: "fas",
    iconName: "route",
    icon: [
        512,
        512,
        [],
        "f4d7",
        "M512 96c0 50.2-59.1 125.1-84.6 155c-3.8 4.4-9.4 6.1-14.5 5H320c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c53 0 96 43 96 96s-43 96-96 96H139.6c8.7-9.9 19.3-22.6 30-36.8c6.3-8.4 12.8-17.6 19-27.2H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H320c-53 0-96-43-96-96s43-96 96-96h39.8c-21-31.5-39.8-67.7-39.8-96c0-53 43-96 96-96s96 43 96 96zM117.1 489.1c-3.8 4.3-7.2 8.1-10.1 11.3l-1.8 2-.2-.2c-6 4.6-14.6 4-20-1.8C59.8 473 0 402.5 0 352c0-53 43-96 96-96s96 43 96 96c0 30-21.1 67-43.5 97.9c-10.7 14.7-21.7 28-30.8 38.5l-.6 .7zM128 352a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM416 128a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
var $d8206b3ab2e65c05$export$d4aa151a4554b74e = {
    prefix: "fas",
    iconName: "clipboard-question",
    icon: [
        384,
        512,
        [],
        "e4e3",
        "M192 0c-41.8 0-77.4 26.7-90.5 64H64C28.7 64 0 92.7 0 128V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H282.5C269.4 26.7 233.8 0 192 0zm0 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM105.8 229.3c7.9-22.3 29.1-37.3 52.8-37.3h58.3c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L216 328.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24V314.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1H158.6c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM160 416a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
    ]
};
var $d8206b3ab2e65c05$export$5dd22dcb6e3ed369 = {
    prefix: "fas",
    iconName: "panorama",
    icon: [
        640,
        512,
        [],
        "e209",
        "M45.6 32C20.4 32 0 52.4 0 77.6V434.4C0 459.6 20.4 480 45.6 480c5.1 0 10-.8 14.7-2.4C74.6 472.8 177.6 440 320 440s245.4 32.8 259.6 37.6c4.7 1.6 9.7 2.4 14.7 2.4c25.2 0 45.6-20.4 45.6-45.6V77.6C640 52.4 619.6 32 594.4 32c-5 0-10 .8-14.7 2.4C565.4 39.2 462.4 72 320 72S74.6 39.2 60.4 34.4C55.6 32.8 50.7 32 45.6 32zM96 160a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm272 0c7.9 0 15.4 3.9 19.8 10.5L512.3 353c5.4 8 5.6 18.4 .4 26.5s-14.7 12.3-24.2 10.7C442.7 382.4 385.2 376 320 376c-65.6 0-123.4 6.5-169.3 14.4c-9.8 1.7-19.7-2.9-24.7-11.5s-4.3-19.4 1.9-27.2L197.3 265c4.6-5.7 11.4-9 18.7-9s14.2 3.3 18.7 9l26.4 33.1 87-127.6c4.5-6.6 11.9-10.5 19.8-10.5z"
    ]
};
var $d8206b3ab2e65c05$export$101422b773924276 = {
    prefix: "fas",
    iconName: "comment-medical",
    icon: [
        512,
        512,
        [],
        "f7f5",
        "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zM224 160c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H288v48c0 8.8-7.2 16-16 16H240c-8.8 0-16-7.2-16-16V272H176c-8.8 0-16-7.2-16-16V224c0-8.8 7.2-16 16-16h48V160z"
    ]
};
var $d8206b3ab2e65c05$export$c88ac21fe7c88ae6 = {
    prefix: "fas",
    iconName: "teeth-open",
    icon: [
        576,
        512,
        [],
        "f62f",
        "M96 32C43 32 0 75 0 128v64c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V128c0-53-43-96-96-96H96zM224 96c26.5 0 48 21.5 48 48v56c0 13.3-10.7 24-24 24H200c-13.3 0-24-10.7-24-24V144c0-26.5 21.5-48 48-48zm80 48c0-26.5 21.5-48 48-48s48 21.5 48 48v56c0 13.3-10.7 24-24 24H328c-13.3 0-24-10.7-24-24V144zM96 128c26.5 0 48 21.5 48 48v24c0 13.3-10.7 24-24 24H72c-13.3 0-24-10.7-24-24V176c0-26.5 21.5-48 48-48zm336 48c0-26.5 21.5-48 48-48s48 21.5 48 48v24c0 13.3-10.7 24-24 24H456c-13.3 0-24-10.7-24-24V176zM96 480H480c53 0 96-43 96-96V352c0-35.3-28.7-64-64-64H64c-35.3 0-64 28.7-64 64v32c0 53 43 96 96 96zm0-64c-26.5 0-48-21.5-48-48V344c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v24c0 26.5-21.5 48-48 48zm80-48V344c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v24c0 26.5-21.5 48-48 48s-48-21.5-48-48zm176 48c-26.5 0-48-21.5-48-48V344c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v24c0 26.5-21.5 48-48 48zm80-48V344c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v24c0 26.5-21.5 48-48 48s-48-21.5-48-48z"
    ]
};
var $d8206b3ab2e65c05$export$4b89fabf50a10951 = {
    prefix: "fas",
    iconName: "file-circle-minus",
    icon: [
        576,
        512,
        [],
        "e4ed",
        "M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384v38.6C310.1 219.5 256 287.4 256 368c0 59.1 29.1 111.3 73.7 143.3c-3.2 .5-6.4 .7-9.7 .7H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128zM288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm224 0c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16s7.2 16 16 16H496c8.8 0 16-7.2 16-16z"
    ]
};
var $d8206b3ab2e65c05$export$d55778e3ab6c933f = {
    prefix: "fas",
    iconName: "tags",
    icon: [
        512,
        512,
        [],
        "f02c",
        "M345 39.1L472.8 168.4c52.4 53 52.4 138.2 0 191.2L360.8 472.9c-9.3 9.4-24.5 9.5-33.9 .2s-9.5-24.5-.2-33.9L438.6 325.9c33.9-34.3 33.9-89.4 0-123.7L310.9 72.9c-9.3-9.4-9.2-24.6 .2-33.9s24.6-9.2 33.9 .2zM0 229.5V80C0 53.5 21.5 32 48 32H197.5c17 0 33.3 6.7 45.3 18.7l168 168c25 25 25 65.5 0 90.5L277.3 442.7c-25 25-65.5 25-90.5 0l-168-168C6.7 262.7 0 246.5 0 229.5zM144 144a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"
    ]
};
var $d8206b3ab2e65c05$export$e06d6607d3577d6e = {
    prefix: "fas",
    iconName: "wine-glass",
    icon: [
        320,
        512,
        [
            127863
        ],
        "f4e3",
        "M32.1 29.3C33.5 12.8 47.4 0 64 0H256c16.6 0 30.5 12.8 31.9 29.3l14 168.4c6 72-42.5 135.2-109.9 150.6V448h48c17.7 0 32 14.3 32 32s-14.3 32-32 32H160 80c-17.7 0-32-14.3-32-32s14.3-32 32-32h48V348.4C60.6 333 12.1 269.8 18.1 197.8l14-168.4zm56 98.7H231.9l-5.3-64H93.4l-5.3 64z"
    ]
};
var $d8206b3ab2e65c05$export$dc9cc4280bee320d = {
    prefix: "fas",
    iconName: "forward-fast",
    icon: [
        512,
        512,
        [
            9197,
            "fast-forward"
        ],
        "f050",
        "M18.4 445c11.2 5.3 24.5 3.6 34.1-4.4L224 297.7V416c0 12.4 7.2 23.7 18.4 29s24.5 3.6 34.1-4.4L448 297.7V416c0 17.7 14.3 32 32 32s32-14.3 32-32V96c0-17.7-14.3-32-32-32s-32 14.3-32 32V214.3L276.5 71.4c-9.5-7.9-22.8-9.7-34.1-4.4S224 83.6 224 96V214.3L52.5 71.4c-9.5-7.9-22.8-9.7-34.1-4.4S0 83.6 0 96V416c0 12.4 7.2 23.7 18.4 29z"
    ]
};
var $d8206b3ab2e65c05$export$61a8cdc53c2e078d = $d8206b3ab2e65c05$export$dc9cc4280bee320d;
var $d8206b3ab2e65c05$export$38c072b870a9e4ab = {
    prefix: "fas",
    iconName: "face-meh-blank",
    icon: [
        512,
        512,
        [
            128566,
            "meh-blank"
        ],
        "f5a4",
        "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm208.4-48a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm128 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
var $d8206b3ab2e65c05$export$e945435725f71e88 = $d8206b3ab2e65c05$export$38c072b870a9e4ab;
var $d8206b3ab2e65c05$export$f2cfa036d76f69ab = {
    prefix: "fas",
    iconName: "square-parking",
    icon: [
        448,
        512,
        [
            127359,
            "parking"
        ],
        "f540",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM192 256h48c17.7 0 32-14.3 32-32s-14.3-32-32-32H192v64zm48 64H192v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V288 168c0-22.1 17.9-40 40-40h72c53 0 96 43 96 96s-43 96-96 96z"
    ]
};
var $d8206b3ab2e65c05$export$fda29c8f99573a4e = $d8206b3ab2e65c05$export$f2cfa036d76f69ab;
var $d8206b3ab2e65c05$export$58845db8e7e9a199 = {
    prefix: "fas",
    iconName: "house-signal",
    icon: [
        576,
        512,
        [],
        "e012",
        "M357.7 8.5c-12.3-11.3-31.2-11.3-43.4 0l-208 192c-9.4 8.6-12.7 22-8.5 34c87.1 25.3 155.6 94.2 180.3 181.6H464c26.5 0 48-21.5 48-48V256h32c13.2 0 25-8.1 29.8-20.3s1.6-26.2-8.1-35.2l-208-192zM288 208c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H304c-8.8 0-16-7.2-16-16V208zM24 256c-13.3 0-24 10.7-24 24s10.7 24 24 24c101.6 0 184 82.4 184 184c0 13.3 10.7 24 24 24s24-10.7 24-24c0-128.1-103.9-232-232-232zm8 256a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM0 376c0 13.3 10.7 24 24 24c48.6 0 88 39.4 88 88c0 13.3 10.7 24 24 24s24-10.7 24-24c0-75.1-60.9-136-136-136c-13.3 0-24 10.7-24 24z"
    ]
};
var $d8206b3ab2e65c05$export$ee3a02da18715b2 = {
    prefix: "fas",
    iconName: "bars-progress",
    icon: [
        512,
        512,
        [
            "tasks-alt"
        ],
        "f828",
        "M448 160H320V128H448v32zM48 64C21.5 64 0 85.5 0 112v64c0 26.5 21.5 48 48 48H464c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48H48zM448 352v32H192V352H448zM48 288c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48H464c26.5 0 48-21.5 48-48V336c0-26.5-21.5-48-48-48H48z"
    ]
};
var $d8206b3ab2e65c05$export$bbc0784fc1578f7f = $d8206b3ab2e65c05$export$ee3a02da18715b2;
var $d8206b3ab2e65c05$export$7a255960242435f6 = {
    prefix: "fas",
    iconName: "faucet-drip",
    icon: [
        512,
        512,
        [
            128688
        ],
        "e006",
        "M224 0c17.7 0 32 14.3 32 32V44l96-12c17.7 0 32 14.3 32 32s-14.3 32-32 32L256 84l-31-3.9-1-.1-1 .1L192 84 96 96C78.3 96 64 81.7 64 64s14.3-32 32-32l96 12V32c0-17.7 14.3-32 32-32zM0 224c0-17.7 14.3-32 32-32h96l22.6-22.6c6-6 14.1-9.4 22.6-9.4H192V116.2l32-4 32 4V160h18.7c8.5 0 16.6 3.4 22.6 9.4L320 192h32c88.4 0 160 71.6 160 160c0 17.7-14.3 32-32 32H416c-17.7 0-32-14.3-32-32s-14.3-32-32-32H315.9c-20.2 29-53.9 48-91.9 48s-71.7-19-91.9-48H32c-17.7 0-32-14.3-32-32V224zM436.8 423.4c1.9-4.5 6.3-7.4 11.2-7.4s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1V480c0 17.7-14.3 32-32 32s-32-14.3-32-32v-1.2c0-4.5 .9-8.9 2.7-13.1l18.2-42.4z"
    ]
};
var $d8206b3ab2e65c05$export$df587aaf7765e1ce = {
    prefix: "fas",
    iconName: "cart-flatbed",
    icon: [
        640,
        512,
        [
            "dolly-flatbed"
        ],
        "f474",
        "M32 0C14.3 0 0 14.3 0 32S14.3 64 32 64H48c8.8 0 16 7.2 16 16V368c0 44.2 35.8 80 80 80h18.7c-1.8 5-2.7 10.4-2.7 16c0 26.5 21.5 48 48 48s48-21.5 48-48c0-5.6-1-11-2.7-16H450.7c-1.8 5-2.7 10.4-2.7 16c0 26.5 21.5 48 48 48s48-21.5 48-48c0-5.6-1-11-2.7-16H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H144c-8.8 0-16-7.2-16-16V80C128 35.8 92.2 0 48 0H32zM192 80V272c0 26.5 21.5 48 48 48H560c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H464V176c0 5.9-3.2 11.3-8.5 14.1s-11.5 2.5-16.4-.8L400 163.2l-39.1 26.1c-4.9 3.3-11.2 3.6-16.4 .8s-8.5-8.2-8.5-14.1V32H240c-26.5 0-48 21.5-48 48z"
    ]
};
var $d8206b3ab2e65c05$export$f7c6efb60c53b285 = $d8206b3ab2e65c05$export$df587aaf7765e1ce;
var $d8206b3ab2e65c05$export$130df7ed74437774 = {
    prefix: "fas",
    iconName: "ban-smoking",
    icon: [
        512,
        512,
        [
            128685,
            "smoking-ban"
        ],
        "f54d",
        "M99.5 144.8L178.7 224l96 96 92.5 92.5C335.9 434.9 297.5 448 256 448C150 448 64 362 64 256c0-41.5 13.1-79.9 35.5-111.2zM333.3 288l-32-32H384v32H333.3zm32 32H400c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H269.3L144.8 99.5C176.1 77.1 214.5 64 256 64c106 0 192 86 192 192c0 41.5-13.1 79.9-35.5 111.2L365.3 320zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM272 96c-8.8 0-16 7.2-16 16c0 26.5 21.5 48 48 48h32c8.8 0 16 7.2 16 16s7.2 16 16 16s16-7.2 16-16c0-26.5-21.5-48-48-48H304c-8.8 0-16-7.2-16-16s-7.2-16-16-16zM229.5 320l-96-96H112c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16H229.5z"
    ]
};
var $d8206b3ab2e65c05$export$e50452a49dec29f = $d8206b3ab2e65c05$export$130df7ed74437774;
var $d8206b3ab2e65c05$export$5e63e8b85b5f119c = {
    prefix: "fas",
    iconName: "terminal",
    icon: [
        576,
        512,
        [],
        "f120",
        "M9.4 86.6C-3.1 74.1-3.1 53.9 9.4 41.4s32.8-12.5 45.3 0l192 192c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L178.7 256 9.4 86.6zM256 416H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H256c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
    ]
};
var $d8206b3ab2e65c05$export$c93d62849efbdd11 = {
    prefix: "fas",
    iconName: "mobile-button",
    icon: [
        384,
        512,
        [],
        "f10b",
        "M80 0C44.7 0 16 28.7 16 64V448c0 35.3 28.7 64 64 64H304c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H80zM192 400a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $d8206b3ab2e65c05$export$86c50f517be57a40 = {
    prefix: "fas",
    iconName: "house-medical-flag",
    icon: [
        640,
        512,
        [],
        "e514",
        "M480 0c17.7 0 32 14.3 32 32H624c8.8 0 16 7.2 16 16V176c0 8.8-7.2 16-16 16H512V512H448V192 32c0-17.7 14.3-32 32-32zM276.8 39.7L416 159V512h1l-.2 0H96c-17.7 0-32-14.3-32-32V288H32c-13.4 0-25.4-8.3-30-20.9s-1-26.7 9.2-35.4l224-192c12-10.3 29.7-10.3 41.7 0zM224 208v48H176c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320h48c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H288V208c0-8.8-7.2-16-16-16H240c-8.8 0-16 7.2-16 16z"
    ]
};
var $d8206b3ab2e65c05$export$1d307c13b511e8e1 = {
    prefix: "fas",
    iconName: "basket-shopping",
    icon: [
        576,
        512,
        [
            "shopping-basket"
        ],
        "f291",
        "M253.3 35.1c6.1-11.8 1.5-26.3-10.2-32.4s-26.3-1.5-32.4 10.2L117.6 192H32c-17.7 0-32 14.3-32 32s14.3 32 32 32L83.9 463.5C91 492 116.6 512 146 512H430c29.4 0 55-20 62.1-48.5L544 256c17.7 0 32-14.3 32-32s-14.3-32-32-32H458.4L365.3 12.9C359.2 1.2 344.7-3.4 332.9 2.7s-16.3 20.6-10.2 32.4L404.3 192H171.7L253.3 35.1zM192 304v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V304c0-8.8 7.2-16 16-16s16 7.2 16 16zm96-16c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V304c0-8.8 7.2-16 16-16zm128 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V304c0-8.8 7.2-16 16-16s16 7.2 16 16z"
    ]
};
var $d8206b3ab2e65c05$export$ca6d443595a6578f = $d8206b3ab2e65c05$export$1d307c13b511e8e1;
var $d8206b3ab2e65c05$export$b88ed5e1e0eac4c6 = {
    prefix: "fas",
    iconName: "tape",
    icon: [
        576,
        512,
        [],
        "f4db",
        "M380.8 416c41.5-40.7 67.2-97.3 67.2-160C448 132.3 347.7 32 224 32S0 132.3 0 256S100.3 480 224 480H544c17.7 0 32-14.3 32-32s-14.3-32-32-32H380.8zM224 160a96 96 0 1 1 0 192 96 96 0 1 1 0-192zm64 96a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z"
    ]
};
var $d8206b3ab2e65c05$export$d3724faf0c559353 = {
    prefix: "fas",
    iconName: "bus-simple",
    icon: [
        448,
        512,
        [
            "bus-alt"
        ],
        "f55e",
        "M224 0C348.8 0 448 35.2 448 80V96 416c0 17.7-14.3 32-32 32v32c0 17.7-14.3 32-32 32H352c-17.7 0-32-14.3-32-32V448H128v32c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32l0-32c-17.7 0-32-14.3-32-32V96 80C0 35.2 99.2 0 224 0zM64 128V256c0 17.7 14.3 32 32 32H352c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32H96c-17.7 0-32 14.3-32 32zM80 400a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm288 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
var $d8206b3ab2e65c05$export$40616edfab6d332a = $d8206b3ab2e65c05$export$d3724faf0c559353;
var $d8206b3ab2e65c05$export$b8c3e79e8c99c95b = {
    prefix: "fas",
    iconName: "eye",
    icon: [
        576,
        512,
        [
            128065
        ],
        "f06e",
        "M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4C142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM144 256a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-64c0 35.3-28.7 64-64 64c-7.1 0-13.9-1.2-20.3-3.3c-5.5-1.8-11.9 1.6-11.7 7.4c.3 6.9 1.3 13.8 3.2 20.7c13.7 51.2 66.4 81.6 117.6 67.9s81.6-66.4 67.9-117.6c-11.1-41.5-47.8-69.4-88.6-71.1c-5.8-.2-9.2 6.1-7.4 11.7c2.1 6.4 3.3 13.2 3.3 20.3z"
    ]
};
var $d8206b3ab2e65c05$export$e8ea88c55e55be7c = {
    prefix: "fas",
    iconName: "face-sad-cry",
    icon: [
        512,
        512,
        [
            128557,
            "sad-cry"
        ],
        "f5b3",
        "M352 493.4c-29.6 12-62.1 18.6-96 18.6s-66.4-6.6-96-18.6V288c0-8.8-7.2-16-16-16s-16 7.2-16 16V477.8C51.5 433.5 0 350.8 0 256C0 114.6 114.6 0 256 0S512 114.6 512 256c0 94.8-51.5 177.5-128 221.8V288c0-8.8-7.2-16-16-16s-16 7.2-16 16V493.4zM195.2 233.6c5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4c-30.4-40.5-91.2-40.5-121.6 0c-5.3 7.1-3.9 17.1 3.2 22.4s17.1 3.9 22.4-3.2c17.6-23.5 52.8-23.5 70.4 0zm121.6 0c17.6-23.5 52.8-23.5 70.4 0c5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4c-30.4-40.5-91.2-40.5-121.6 0c-5.3 7.1-3.9 17.1 3.2 22.4s17.1 3.9 22.4-3.2zM208 336v32c0 26.5 21.5 48 48 48s48-21.5 48-48V336c0-26.5-21.5-48-48-48s-48 21.5-48 48z"
    ]
};
var $d8206b3ab2e65c05$export$8e924e6bd422cef9 = $d8206b3ab2e65c05$export$e8ea88c55e55be7c;
var $d8206b3ab2e65c05$export$b6b464c98c009494 = {
    prefix: "fas",
    iconName: "audio-description",
    icon: [
        576,
        512,
        [],
        "f29e",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM213.5 173.3l72 144c5.9 11.9 1.1 26.3-10.7 32.2s-26.3 1.1-32.2-10.7l-9.4-18.9H150.9l-9.4 18.9c-5.9 11.9-20.3 16.7-32.2 10.7s-16.7-20.3-10.7-32.2l72-144c4.1-8.1 12.4-13.3 21.5-13.3s17.4 5.1 21.5 13.3zm-.4 106.6L192 237.7l-21.1 42.2h42.2zM304 184c0-13.3 10.7-24 24-24h56c53 0 96 43 96 96s-43 96-96 96H328c-13.3 0-24-10.7-24-24V184zm48 24v96h32c26.5 0 48-21.5 48-48s-21.5-48-48-48H352z"
    ]
};
var $d8206b3ab2e65c05$export$41b1e14a6b0fe11b = {
    prefix: "fas",
    iconName: "person-military-to-person",
    icon: [
        512,
        512,
        [],
        "e54c",
        "M71 12.5c-8.6 1-15 8.2-15 16.8c0 9.3 7.5 16.8 16.7 16.9H184.1c8.8-.1 15.9-7.2 15.9-16V16c0-9.5-8.3-17-17.8-15.9L71 12.5zM189.5 78.1H66.5C64.9 83.8 64 89.8 64 96c0 35.3 28.7 64 64 64s64-28.7 64-64c0-6.2-.9-12.2-2.5-17.9zM32 256v32c0 17.7 14.3 32 32 32H192c1.8 0 3.5-.1 5.2-.4L53 208.6C40.1 220.3 32 237.2 32 256zm190.2 42.5c1.1-3.3 1.8-6.8 1.8-10.5V256c0-35.3-28.7-64-64-64H96c-3.7 0-7.4 .3-10.9 .9L222.2 298.5zM384 160a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-32 32c-35.3 0-64 28.7-64 64v32c0 17.7 14.3 32 32 32H448c17.7 0 32-14.3 32-32V256c0-35.3-28.7-64-64-64H352zM215.8 450.1c5.2-4.6 8.2-11.1 8.2-18.1s-3-13.5-8.2-18.1l-64-56c-7.1-6.2-17.1-7.7-25.7-3.8S112 366.6 112 376v32l-88 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l88 0v32c0 9.4 5.5 18 14.1 21.9s18.6 2.4 25.7-3.8l64-56zM288 431.9c0 6.9 2.9 13.5 8.1 18.1l64 56.4c7.1 6.2 17.1 7.8 25.7 3.9s14.1-12.4 14.1-21.9l0-32.4 88 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-88 0 0-32c0-9.4-5.5-18-14.1-21.9s-18.6-2.4-25.7 3.8l-64 56c-5.2 4.5-8.2 11.1-8.2 18z"
    ]
};
var $d8206b3ab2e65c05$export$348a01df65a66c99 = {
    prefix: "fas",
    iconName: "file-shield",
    icon: [
        576,
        512,
        [],
        "e4f0",
        "M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384v47l-92.8 37.1c-21.3 8.5-35.2 29.1-35.2 52c0 56.6 18.9 148 94.2 208.3c-9 4.8-19.3 7.6-30.2 7.6H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128zm39.1 97.7c5.7-2.3 12.1-2.3 17.8 0l120 48C570 277.4 576 286.2 576 296c0 63.3-25.9 168.8-134.8 214.2c-5.9 2.5-12.6 2.5-18.5 0C313.9 464.8 288 359.3 288 296c0-9.8 6-18.6 15.1-22.3l120-48zM527.4 312L432 273.8V461.7c68.2-33 91.5-99 95.4-149.7z"
    ]
};
var $d8206b3ab2e65c05$export$3924ab4d3ef9b5ef = {
    prefix: "fas",
    iconName: "user-slash",
    icon: [
        640,
        512,
        [],
        "f506",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L353.3 251.6C407.9 237 448 187.2 448 128C448 57.3 390.7 0 320 0C250.2 0 193.5 55.8 192 125.2L38.8 5.1zM264.3 304.3C170.5 309.4 96 387.2 96 482.3c0 16.4 13.3 29.7 29.7 29.7H514.3c3.9 0 7.6-.7 11-2.1l-261-205.6z"
    ]
};
var $d8206b3ab2e65c05$export$8f4567331fb0d3bc = {
    prefix: "fas",
    iconName: "pen",
    icon: [
        512,
        512,
        [
            128394
        ],
        "f304",
        "M362.7 19.3L314.3 67.7 444.3 197.7l48.4-48.4c25-25 25-65.5 0-90.5L453.3 19.3c-25-25-65.5-25-90.5 0zm-71 71L58.6 323.5c-10.4 10.4-18 23.3-22.2 37.4L1 481.2C-1.5 489.7 .8 498.8 7 505s15.3 8.5 23.7 6.1l120.3-35.4c14.1-4.2 27-11.8 37.4-22.2L421.7 220.3 291.7 90.3z"
    ]
};
var $d8206b3ab2e65c05$export$5b2f0f631f559d51 = {
    prefix: "fas",
    iconName: "tower-observation",
    icon: [
        512,
        512,
        [],
        "e586",
        "M241.7 3.4c9-4.5 19.6-4.5 28.6 0l160 80c15.8 7.9 22.2 27.1 14.3 42.9C439 137.5 427.7 144 416 144v80c0 17.7-14.3 32-32 32h-4.9l32 192H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H384.5c-.4 0-.8 0-1.1 0H128.6c-.4 0-.8 0-1.1 0H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h68.9l32-192H128c-17.7 0-32-14.3-32-32V144c-11.7 0-23-6.5-28.6-17.7c-7.9-15.8-1.5-35 14.3-42.9l160-80zM314.5 448L256 399.2 197.5 448h117zM197.8 256l-4.7 28.3L256 336.8l62.9-52.5L314.2 256H197.8zm-13.9 83.2l-11.2 67L218.5 368l-34.6-28.8zM293.5 368l45.8 38.1-11.2-67L293.5 368zM176 128c-8.8 0-16 7.2-16 16s7.2 16 16 16H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H176z"
    ]
};
var $d8206b3ab2e65c05$export$143d0ca7d2200f20 = {
    prefix: "fas",
    iconName: "file-code",
    icon: [
        384,
        512,
        [],
        "f1c9",
        "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM153 289l-31 31 31 31c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L71 337c-9.4-9.4-9.4-24.6 0-33.9l48-48c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zM265 255l48 48c9.4 9.4 9.4 24.6 0 33.9l-48 48c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l31-31-31-31c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0z"
    ]
};
var $d8206b3ab2e65c05$export$79046b073b6c584d = {
    prefix: "fas",
    iconName: "signal",
    icon: [
        640,
        512,
        [
            128246,
            "signal-5",
            "signal-perfect"
        ],
        "f012",
        "M576 0c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V32c0-17.7 14.3-32 32-32zM448 96c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V128c0-17.7 14.3-32 32-32zM352 224V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V224c0-17.7 14.3-32 32-32s32 14.3 32 32zM192 288c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V320c0-17.7 14.3-32 32-32zM96 416v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V416c0-17.7 14.3-32 32-32s32 14.3 32 32z"
    ]
};
var $d8206b3ab2e65c05$export$3417071118065933 = $d8206b3ab2e65c05$export$79046b073b6c584d;
var $d8206b3ab2e65c05$export$1aea50ab3e99cc95 = $d8206b3ab2e65c05$export$79046b073b6c584d;
var $d8206b3ab2e65c05$export$ce69441578ff2fdb = {
    prefix: "fas",
    iconName: "bus",
    icon: [
        576,
        512,
        [
            128653
        ],
        "f207",
        "M288 0C422.4 0 512 35.2 512 80V96l0 32c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32l0 160c0 17.7-14.3 32-32 32v32c0 17.7-14.3 32-32 32H416c-17.7 0-32-14.3-32-32V448H192v32c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32l0-32c-17.7 0-32-14.3-32-32l0-160c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32h0V96h0V80C64 35.2 153.6 0 288 0zM128 160v96c0 17.7 14.3 32 32 32H272V128H160c-17.7 0-32 14.3-32 32zM304 288H416c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32H304V288zM144 400a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm288 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM384 80c0-8.8-7.2-16-16-16H208c-8.8 0-16 7.2-16 16s7.2 16 16 16H368c8.8 0 16-7.2 16-16z"
    ]
};
var $d8206b3ab2e65c05$export$742f89ae2f8d6b20 = {
    prefix: "fas",
    iconName: "heart-circle-xmark",
    icon: [
        576,
        512,
        [],
        "e501",
        "M47.6 300.4L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9l2.6-2.4C267.2 438.6 256 404.6 256 368c0-97.2 78.8-176 176-176c28.3 0 55 6.7 78.7 18.5c.9-6.5 1.3-13 1.3-19.6v-5.8c0-69.9-50.5-129.5-119.4-141C347 36.5 300.6 51.4 268 84L256 96 244 84c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm59.3-180.7L454.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L432 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L409.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L432 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
    ]
};
var $d8206b3ab2e65c05$export$af554427144a7e5c = {
    prefix: "fas",
    iconName: "house-chimney",
    icon: [
        576,
        512,
        [
            63499,
            "home-lg"
        ],
        "e3af",
        "M543.8 287.6c17 0 32-14 32-32.1c1-9-3-17-11-24L512 185V64c0-17.7-14.3-32-32-32H448c-17.7 0-32 14.3-32 32v36.7L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24c0 18 14 32.1 32 32.1h32v69.7c-.1 .9-.1 1.8-.1 2.8V472c0 22.1 17.9 40 40 40h16c1.2 0 2.4-.1 3.6-.2c1.5 .1 3 .2 4.5 .2H160h24c22.1 0 40-17.9 40-40V448 384c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v64 24c0 22.1 17.9 40 40 40h24 32.5c1.4 0 2.8 0 4.2-.1c1.1 .1 2.2 .1 3.3 .1h16c22.1 0 40-17.9 40-40V455.8c.3-2.6 .5-5.3 .5-8.1l-.7-160.2h32z"
    ]
};
var $d8206b3ab2e65c05$export$dbab81727ec94698 = $d8206b3ab2e65c05$export$af554427144a7e5c;
var $d8206b3ab2e65c05$export$703cd98be31ec905 = {
    prefix: "fas",
    iconName: "window-maximize",
    icon: [
        512,
        512,
        [
            128470
        ],
        "f2d0",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM96 96H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H96c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
    ]
};
var $d8206b3ab2e65c05$export$e5f78e87efbb0248 = {
    prefix: "fas",
    iconName: "face-frown",
    icon: [
        512,
        512,
        [
            9785,
            "frown"
        ],
        "f119",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM159.3 388.7c-2.6 8.4-11.6 13.2-20 10.5s-13.2-11.6-10.5-20C145.2 326.1 196.3 288 256 288s110.8 38.1 127.3 91.3c2.6 8.4-2.1 17.4-10.5 20s-17.4-2.1-20-10.5C340.5 349.4 302.1 320 256 320s-84.5 29.4-96.7 68.7zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $d8206b3ab2e65c05$export$43b7108508aecc5f = $d8206b3ab2e65c05$export$e5f78e87efbb0248;
var $d8206b3ab2e65c05$export$8767bafb19515ee4 = {
    prefix: "fas",
    iconName: "prescription",
    icon: [
        448,
        512,
        [],
        "f5b1",
        "M32 0C14.3 0 0 14.3 0 32V192v96c0 17.7 14.3 32 32 32s32-14.3 32-32V224h50.7l128 128L137.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L288 397.3 393.4 502.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L333.3 352 438.6 246.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L288 306.7l-85.8-85.8C251.4 209.1 288 164.8 288 112C288 50.1 237.9 0 176 0H32zM176 160H64V64H176c26.5 0 48 21.5 48 48s-21.5 48-48 48z"
    ]
};
var $d8206b3ab2e65c05$export$78edc9b98453b6f7 = {
    prefix: "fas",
    iconName: "shop",
    icon: [
        640,
        512,
        [
            "store-alt"
        ],
        "f54f",
        "M36.8 192H603.2c20.3 0 36.8-16.5 36.8-36.8c0-7.3-2.2-14.4-6.2-20.4L558.2 21.4C549.3 8 534.4 0 518.3 0H121.7c-16 0-31 8-39.9 21.4L6.2 134.7c-4 6.1-6.2 13.2-6.2 20.4C0 175.5 16.5 192 36.8 192zM64 224V384v80c0 26.5 21.5 48 48 48H336c26.5 0 48-21.5 48-48V384 224H320V384H128V224H64zm448 0V480c0 17.7 14.3 32 32 32s32-14.3 32-32V224H512z"
    ]
};
var $d8206b3ab2e65c05$export$1f1871dab9cec9d8 = $d8206b3ab2e65c05$export$78edc9b98453b6f7;
var $d8206b3ab2e65c05$export$f62f2879ccaea13f = {
    prefix: "fas",
    iconName: "floppy-disk",
    icon: [
        448,
        512,
        [
            128190,
            128426,
            "save"
        ],
        "f0c7",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V173.3c0-17-6.7-33.3-18.7-45.3L352 50.7C340 38.7 323.7 32 306.7 32H64zm0 96c0-17.7 14.3-32 32-32H288c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V128zM224 288a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"
    ]
};
var $d8206b3ab2e65c05$export$1aaa83ff70706e1e = $d8206b3ab2e65c05$export$f62f2879ccaea13f;
var $d8206b3ab2e65c05$export$ee4b92e89fe0dfaf = {
    prefix: "fas",
    iconName: "vihara",
    icon: [
        640,
        512,
        [],
        "f6a7",
        "M281 22L305.8 4.7c1.3-.9 2.7-1.8 4.1-2.4C313.1 .7 316.6 0 320 0s6.9 .7 10.1 2.2c1.4 .7 2.8 1.5 4.1 2.4L359 22C393 45.8 430.8 63.5 470.8 74.4l23 6.3c1.8 .5 3.6 1.1 5.2 2c3.2 1.7 5.9 4 8.1 6.8c3.8 4.9 5.6 11.3 4.7 17.8c-.4 2.8-1.2 5.4-2.5 7.8c-1.7 3.2-4 5.9-6.8 8.1c-4.3 3.2-9.6 5.1-15.1 4.9H480v56.1l6.4 5.1 5.2 4.1c21.1 16.7 45 29.6 70.5 38.1l28.9 9.6c1.6 .5 3.2 1.2 4.6 2c3.1 1.7 5.8 4.1 7.8 6.9s3.5 6.1 4.1 9.6c.5 2.7 .6 5.5 .1 8.3s-1.4 5.4-2.7 7.8c-1.7 3.1-4.1 5.8-6.9 7.8s-6.1 3.5-9.6 4.1c-1.6 .3-3.3 .4-5 .4H544v65.9c20.5 22.8 47.4 39.2 77.4 46.7C632 403 640 412.6 640 424c0 13.3-10.7 24-24 24H576v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V448H352v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V448H128v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V448H24c-13.3 0-24-10.7-24-24c0-11.4 8-21 18.6-23.4c30-7.6 56.9-23.9 77.4-46.7V288H56.6c-1.7 0-3.4-.1-5-.4c-3.5-.7-6.8-2.1-9.6-4.1s-5.2-4.7-7-7.8c-1.3-2.4-2.3-5-2.7-7.8s-.4-5.6 .1-8.3c.7-3.5 2.1-6.8 4.1-9.6s4.7-5.2 7.8-6.9c1.4-.8 3-1.5 4.6-2l28.9-9.6c25.5-8.5 49.4-21.4 70.5-38.1l5.2-4.1 6.4-5.1V176 128h-7.5c-5.5 .1-10.8-1.7-15.1-4.9c-2.8-2.1-5.1-4.8-6.8-8.1c-1.2-2.4-2.1-5-2.5-7.8c-.9-6.5 .9-12.8 4.7-17.8c2.1-2.8 4.8-5.1 8.1-6.8c1.6-.8 3.4-1.5 5.2-2l23-6.3C209.2 63.5 247 45.8 281 22zM416 128H320 224v64h72 48 72V128zM160 288v64H296h24 24H480V288H344 320h0H296 160z"
    ]
};
var $d8206b3ab2e65c05$export$4d10bcc8d068f454 = {
    prefix: "fas",
    iconName: "scale-unbalanced",
    icon: [
        640,
        512,
        [
            "balance-scale-left"
        ],
        "f515",
        "M522.1 62.4c16.8-5.6 25.8-23.7 20.2-40.5S518.6-3.9 501.9 1.6l-113 37.7C375 15.8 349.3 0 320 0c-44.2 0-80 35.8-80 80c0 3 .2 5.9 .5 8.8L117.9 129.6c-16.8 5.6-25.8 23.7-20.2 40.5s23.7 25.8 40.5 20.2l135.5-45.2c4.5 3.2 9.3 5.9 14.4 8.2V480c0 17.7 14.3 32 32 32H512c17.7 0 32-14.3 32-32s-14.3-32-32-32H352V153.3c21-9.2 37.2-27 44.2-49l125.9-42zM439.6 288L512 163.8 584.4 288H439.6zM512 384c62.9 0 115.2-34 126-78.9c2.6-11-1-22.3-6.7-32.1L536.1 109.8c-5-8.6-14.2-13.8-24.1-13.8s-19.1 5.3-24.1 13.8L392.7 273.1c-5.7 9.8-9.3 21.1-6.7 32.1C396.8 350 449.1 384 512 384zM129.2 291.8L201.6 416H56.7l72.4-124.2zM3.2 433.1C14 478 66.3 512 129.2 512s115.2-34 126-78.9c2.6-11-1-22.3-6.7-32.1L153.2 237.8c-5-8.6-14.2-13.8-24.1-13.8s-19.1 5.3-24.1 13.8L9.9 401.1c-5.7 9.8-9.3 21.1-6.7 32.1z"
    ]
};
var $d8206b3ab2e65c05$export$786cb0c775487f19 = $d8206b3ab2e65c05$export$4d10bcc8d068f454;
var $d8206b3ab2e65c05$export$f9dd5b1410e95035 = {
    prefix: "fas",
    iconName: "sort-up",
    icon: [
        320,
        512,
        [
            "sort-asc"
        ],
        "f0de",
        "M182.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8H288c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-128-128z"
    ]
};
var $d8206b3ab2e65c05$export$e4c8c924b1cc43a7 = $d8206b3ab2e65c05$export$f9dd5b1410e95035;
var $d8206b3ab2e65c05$export$63ffcb3d4e94cb92 = {
    prefix: "fas",
    iconName: "comment-dots",
    icon: [
        512,
        512,
        [
            128172,
            62075,
            "commenting"
        ],
        "f4ad",
        "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zM128 208a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm96 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
    ]
};
var $d8206b3ab2e65c05$export$49ee382a2425e89c = $d8206b3ab2e65c05$export$63ffcb3d4e94cb92;
var $d8206b3ab2e65c05$export$77a38850ff8b0407 = {
    prefix: "fas",
    iconName: "plant-wilt",
    icon: [
        512,
        512,
        [],
        "e5aa",
        "M288 120c0-30.9 25.1-56 56-56s56 25.1 56 56v13c-29.3 10-48 34.5-48 70.1c0 27.9 25.3 74.8 66 111.6c3.8 3.5 8.9 5.3 14 5.3s10.2-1.8 14-5.3c40.7-36.8 66-83.7 66-111.6c0-35.6-18.7-60.2-48-70.1V120C464 53.7 410.3 0 344 0S224 53.7 224 120v21.8C207.3 133 188.2 128 168 128c-66.3 0-120 53.7-120 120v13c-29.3 10-48 34.5-48 70.1C0 359 25.3 405.9 66 442.7c3.8 3.5 8.9 5.3 14 5.3s10.2-1.8 14-5.3c40.7-36.8 66-83.7 66-111.6c0-35.6-18.7-60.2-48-70.1V248c0-30.9 25.1-56 56-56s56 25.1 56 56v32V480c0 17.7 14.3 32 32 32s32-14.3 32-32V280 248 120z"
    ]
};
var $d8206b3ab2e65c05$export$f214f827e0023247 = {
    prefix: "fas",
    iconName: "diamond",
    icon: [
        512,
        512,
        [
            9830
        ],
        "f219",
        "M284.3 11.7c-15.6-15.6-40.9-15.6-56.6 0l-216 216c-15.6 15.6-15.6 40.9 0 56.6l216 216c15.6 15.6 40.9 15.6 56.6 0l216-216c15.6-15.6 15.6-40.9 0-56.6l-216-216z"
    ]
};
var $d8206b3ab2e65c05$export$5d53da7627754bc6 = {
    prefix: "fas",
    iconName: "face-grin-squint",
    icon: [
        512,
        512,
        [
            128518,
            "grin-squint"
        ],
        "f585",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM388.1 312.8c12.3-3.8 24.3 6.9 19.3 18.7C382.4 390.6 324.2 432 256.3 432s-126.2-41.4-151.1-100.5c-5-11.8 7-22.5 19.3-18.7c39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19zM133.5 146.7l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5c0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6c0-9 9.6-14.7 17.5-10.5zM396 157.1c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6c0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9c7.9-4.2 17.5 1.5 17.5 10.5z"
    ]
};
var $d8206b3ab2e65c05$export$243ae757907b1580 = $d8206b3ab2e65c05$export$5d53da7627754bc6;
var $d8206b3ab2e65c05$export$61a67f5f8ab39be = {
    prefix: "fas",
    iconName: "hand-holding-dollar",
    icon: [
        576,
        512,
        [
            "hand-holding-usd"
        ],
        "f4c0",
        "M312 24V34.5c6.4 1.2 12.6 2.7 18.2 4.2c12.8 3.4 20.4 16.6 17 29.4s-16.6 20.4-29.4 17c-10.9-2.9-21.1-4.9-30.2-5c-7.3-.1-14.7 1.7-19.4 4.4c-2.1 1.3-3.1 2.4-3.5 3c-.3 .5-.7 1.2-.7 2.8c0 .3 0 .5 0 .6c.2 .2 .9 1.2 3.3 2.6c5.8 3.5 14.4 6.2 27.4 10.1l.9 .3c11.1 3.3 25.9 7.8 37.9 15.3c13.7 8.6 26.1 22.9 26.4 44.9c.3 22.5-11.4 38.9-26.7 48.5c-6.7 4.1-13.9 7-21.3 8.8V232c0 13.3-10.7 24-24 24s-24-10.7-24-24V220.6c-9.5-2.3-18.2-5.3-25.6-7.8c-2.1-.7-4.1-1.4-6-2c-12.6-4.2-19.4-17.8-15.2-30.4s17.8-19.4 30.4-15.2c2.6 .9 5 1.7 7.3 2.5c13.6 4.6 23.4 7.9 33.9 8.3c8 .3 15.1-1.6 19.2-4.1c1.9-1.2 2.8-2.2 3.2-2.9c.4-.6 .9-1.8 .8-4.1l0-.2c0-1 0-2.1-4-4.6c-5.7-3.6-14.3-6.4-27.1-10.3l-1.9-.6c-10.8-3.2-25-7.5-36.4-14.4c-13.5-8.1-26.5-22-26.6-44.1c-.1-22.9 12.9-38.6 27.7-47.4c6.4-3.8 13.3-6.4 20.2-8.2V24c0-13.3 10.7-24 24-24s24 10.7 24 24zM568.2 336.3c13.1 17.8 9.3 42.8-8.5 55.9L433.1 485.5c-23.4 17.2-51.6 26.5-80.7 26.5H192 32c-17.7 0-32-14.3-32-32V416c0-17.7 14.3-32 32-32H68.8l44.9-36c22.7-18.2 50.9-28 80-28H272h16 64c17.7 0 32 14.3 32 32s-14.3 32-32 32H288 272c-8.8 0-16 7.2-16 16s7.2 16 16 16H392.6l119.7-88.2c17.8-13.1 42.8-9.3 55.9 8.5zM193.6 384l0 0-.9 0c.3 0 .6 0 .9 0z"
    ]
};
var $d8206b3ab2e65c05$export$47d27bc305b59690 = $d8206b3ab2e65c05$export$61a67f5f8ab39be;
var $d8206b3ab2e65c05$export$b0babe4230e35ebe = {
    prefix: "fas",
    iconName: "bacterium",
    icon: [
        512,
        512,
        [],
        "e05a",
        "M423.1 30.6c3.6-12.7-3.7-26-16.5-29.7s-26 3.7-29.7 16.5l-4.2 14.7c-9.8-.4-19.9 .5-29.9 2.8c-12.1 2.8-23.7 5.9-34.9 9.4l-5.9-13.7c-5.2-12.2-19.3-17.8-31.5-12.6s-17.8 19.3-12.6 31.5l4.9 11.3c-22 9.4-42 20.1-60.2 31.8L196 82.7c-7.4-11-22.3-14-33.3-6.7s-14 22.3-6.7 33.3l7.8 11.6c-18 15-33.7 30.8-47.3 47.1L103 157.3c-10.4-8.3-25.5-6.6-33.7 3.7s-6.6 25.5 3.7 33.7l15 12c-2.1 3.2-4.1 6.5-6 9.7c-9.4 15.7-17 31-23.2 45.3l-9.9-3.9c-12.3-4.9-26.3 1.1-31.2 13.4s1.1 26.3 13.4 31.2l11.6 4.6c-.3 1.1-.6 2.1-.9 3.1c-3.5 12.5-5.7 23.2-7.1 31.3c-.7 4.1-1.2 7.5-1.6 10.3c-.2 1.4-.3 2.6-.4 3.6l-.1 1.4-.1 .6 0 .3 0 .1c0 0 0 .1 39.2 3.7l0 0-39.2-3.6c-.5 5-.6 10-.4 14.9l-14.7 4.2C4.7 380.6-2.7 393.8 .9 406.6s16.9 20.1 29.7 16.5l13.8-3.9c10.6 20.7 27.6 37.8 48.5 48.5l-3.9 13.7c-3.6 12.7 3.7 26 16.5 29.7s26-3.7 29.7-16.5l4.2-14.7c23.8 1 46.3-5.5 65.1-17.6L215 473c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-10.6-10.6c9.1-14.1 15.1-30.5 17-48.3l.1-.8c.3-1.7 1-5.1 2.3-9.8l.2-.8 12.6 5.4c12.2 5.2 26.3-.4 31.5-12.6s-.4-26.3-12.6-31.5l-11.3-4.8c9.9-14.9 24.9-31.6 48.6-46l2.1 7.5c3.6 12.7 16.9 20.1 29.7 16.5s20.1-16.9 16.5-29.7L371 259.2c6.9-2.2 14.3-4.3 22.2-6.1c12.9-3 24.7-8 35.2-14.8L439 249c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-10.6-10.6c12.2-19 18.6-41.6 17.6-65.1l14.7-4.2c12.7-3.6 20.1-16.9 16.5-29.7s-16.9-20.1-29.7-16.5l-13.7 3.9c-10.8-21.2-28-38-48.5-48.5l3.9-13.8zM92.1 363.3l0 0L144 368l-51.9-4.7zM112 320a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM240 184a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
    ]
};
var $d8206b3ab2e65c05$export$d97ff927c450c87f = {
    prefix: "fas",
    iconName: "hand-pointer",
    icon: [
        448,
        512,
        [],
        "f25a",
        "M128 40c0-22.1 17.9-40 40-40s40 17.9 40 40V188.2c8.5-7.6 19.7-12.2 32-12.2c20.6 0 38.2 13 45 31.2c8.8-9.3 21.2-15.2 35-15.2c25.3 0 46 19.5 47.9 44.3c8.5-7.7 19.8-12.3 32.1-12.3c26.5 0 48 21.5 48 48v48 16 48c0 70.7-57.3 128-128 128l-16 0H240l-.1 0h-5.2c-5 0-9.9-.3-14.7-1c-55.3-5.6-106.2-34-140-79L8 336c-13.3-17.7-9.7-42.7 8-56s42.7-9.7 56 8l56 74.7V40zM240 304c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V304zm48-16c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V304c0-8.8-7.2-16-16-16zm80 16c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V304z"
    ]
};
var $d8206b3ab2e65c05$export$48d1206500db2e9d = {
    prefix: "fas",
    iconName: "drum-steelpan",
    icon: [
        576,
        512,
        [],
        "f56a",
        "M288 32c159.1 0 288 48 288 128V352c0 80-128.9 128-288 128S0 432 0 352V160C0 80 128.9 32 288 32zM528 160c0-9.9-8-29.9-55-49.8c-18.6-7.9-40.9-14.4-66-19.4l-27.8 43.6c-7.3 11.5-11.2 24.8-11.2 38.4c0 17.5 6.4 34.4 18.1 47.5l9.8 11c29.8-5.2 55.9-12.5 77.2-21.5c47.1-19.9 55-39.9 55-49.8zM349.2 237.3c-8-26.2-32.4-45.3-61.2-45.3s-53.3 19.1-61.2 45.3c19.4 1.7 39.9 2.7 61.2 2.7s41.8-.9 61.2-2.7zM169 90.8c-25.2 5-47.4 11.6-66 19.4C56 130.1 48 150.1 48 160s8 29.9 55 49.8c21.3 9 47.4 16.3 77.2 21.5l9.8-11c11.6-13.1 18.1-30 18.1-47.5c0-13.6-3.9-26.9-11.2-38.4L169 90.8zm56.3-8C224.5 87 224 91.5 224 96c0 35.3 28.7 64 64 64s64-28.7 64-64c0-4.5-.5-9-1.4-13.2C330.8 81 309.8 80 288 80s-42.8 1-62.6 2.8z"
    ]
};
var $d8206b3ab2e65c05$export$c578e919f2c5c135 = {
    prefix: "fas",
    iconName: "hand-scissors",
    icon: [
        512,
        512,
        [],
        "f257",
        "M40 208c-22.1 0-40 17.9-40 40s17.9 40 40 40l180.2 0c-7.6 8.5-12.2 19.7-12.2 32c0 25.3 19.5 46 44.3 47.9c-7.7 8.5-12.3 19.8-12.3 32.1c0 26.5 21.5 48 48 48l32 0 64 0c70.7 0 128-57.3 128-128l0-113.1c0-40.2-16-78.8-44.4-107.3C444.8 76.8 413.9 64 381.7 64L336 64c-21.3 0-39.3 13.9-45.6 33.1l74.5 23.7c8.4 2.7 13.1 11.7 10.4 20.1s-11.7 13.1-20.1 10.4L288 129.9l0 .1L84 65.8C62.9 59.2 40.5 70.9 33.8 92s5.1 43.5 26.2 50.2L269.5 208 40 208z"
    ]
};
var $d8206b3ab2e65c05$export$a96374faedb12593 = {
    prefix: "fas",
    iconName: "hands-praying",
    icon: [
        640,
        512,
        [
            "praying-hands"
        ],
        "f684",
        "M351.2 4.8c3.2-2 6.6-3.3 10-4.1c4.7-1 9.6-.9 14.1 .1c7.7 1.8 14.8 6.5 19.4 13.6L514.6 194.2c8.8 13.1 13.4 28.6 13.4 44.4v73.5c0 6.9 4.4 13 10.9 15.2l79.2 26.4C631.2 358 640 370.2 640 384v96c0 9.9-4.6 19.3-12.5 25.4s-18.1 8.1-27.7 5.5L431 465.9c-56-14.9-95-65.7-95-123.7V224c0-17.7 14.3-32 32-32s32 14.3 32 32v80c0 8.8 7.2 16 16 16s16-7.2 16-16V219.1c0-7-1.8-13.8-5.3-19.8L340.3 48.1c-1.7-3-2.9-6.1-3.6-9.3c-1-4.7-1-9.6 .1-14.1c1.9-8 6.8-15.2 14.3-19.9zm-62.4 0c7.5 4.6 12.4 11.9 14.3 19.9c1.1 4.6 1.2 9.4 .1 14.1c-.7 3.2-1.9 6.3-3.6 9.3L213.3 199.3c-3.5 6-5.3 12.9-5.3 19.8V304c0 8.8 7.2 16 16 16s16-7.2 16-16V224c0-17.7 14.3-32 32-32s32 14.3 32 32V342.3c0 58-39 108.7-95 123.7l-168.7 45c-9.6 2.6-19.9 .5-27.7-5.5S0 490 0 480V384c0-13.8 8.8-26 21.9-30.4l79.2-26.4c6.5-2.2 10.9-8.3 10.9-15.2V238.5c0-15.8 4.7-31.2 13.4-44.4L245.2 14.5c4.6-7.1 11.7-11.8 19.4-13.6c4.6-1.1 9.4-1.2 14.1-.1c3.5 .8 6.9 2.1 10 4.1z"
    ]
};
var $d8206b3ab2e65c05$export$95e08e91b0929943 = $d8206b3ab2e65c05$export$a96374faedb12593;
var $d8206b3ab2e65c05$export$9c58ddc4b3356f98 = {
    prefix: "fas",
    iconName: "arrow-rotate-right",
    icon: [
        512,
        512,
        [
            8635,
            "arrow-right-rotate",
            "arrow-rotate-forward",
            "redo"
        ],
        "f01e",
        "M386.3 160H336c-17.7 0-32 14.3-32 32s14.3 32 32 32H464c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32s-32 14.3-32 32v51.2L414.4 97.6c-87.5-87.5-229.3-87.5-316.8 0s-87.5 229.3 0 316.8s229.3 87.5 316.8 0c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0c-62.5 62.5-163.8 62.5-226.3 0s-62.5-163.8 0-226.3s163.8-62.5 226.3 0L386.3 160z"
    ]
};
var $d8206b3ab2e65c05$export$ffa1245982c1b28b = $d8206b3ab2e65c05$export$9c58ddc4b3356f98;
var $d8206b3ab2e65c05$export$89c59b5f47067f4c = $d8206b3ab2e65c05$export$9c58ddc4b3356f98;
var $d8206b3ab2e65c05$export$3d9f98aa1c24c776 = $d8206b3ab2e65c05$export$9c58ddc4b3356f98;
var $d8206b3ab2e65c05$export$ae3a453550dec95 = {
    prefix: "fas",
    iconName: "biohazard",
    icon: [
        576,
        512,
        [
            9763
        ],
        "f780",
        "M173.2 0c-1.8 0-3.5 .7-4.8 2C138.5 32.3 120 74 120 120c0 26.2 6 50.9 16.6 73c-22 2.4-43.8 9.1-64.2 20.5C37.9 232.8 13.3 262.4 .4 296c-.7 1.7-.5 3.7 .5 5.2c2.2 3.7 7.4 4.3 10.6 1.3C64.2 254.3 158 245.1 205 324s-8.1 153.1-77.6 173.2c-4.2 1.2-6.3 5.9-4.1 9.6c1 1.6 2.6 2.7 4.5 3c36.5 5.9 75.2 .1 109.7-19.2c20.4-11.4 37.4-26.5 50.5-43.8c13.1 17.3 30.1 32.4 50.5 43.8c34.5 19.3 73.3 25.2 109.7 19.2c1.9-.3 3.5-1.4 4.5-3c2.2-3.7 .1-8.4-4.1-9.6C379.1 477.1 324 403 371 324s140.7-69.8 193.5-21.4c3.2 2.9 8.4 2.3 10.6-1.3c1-1.6 1.1-3.5 .5-5.2c-12.9-33.6-37.5-63.2-72.1-82.5c-20.4-11.4-42.2-18.1-64.2-20.5C450 170.9 456 146.2 456 120c0-46-18.5-87.7-48.4-118c-1.3-1.3-3-2-4.8-2c-5 0-8.4 5.2-6.7 9.9C421.7 80.5 385.6 176 288 176S154.3 80.5 179.9 9.9c1.7-4.7-1.6-9.9-6.7-9.9zM240 272a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM181.7 417.6c6.3-11.8 9.8-25.1 8.6-39.8c-19.5-18-34-41.4-41.2-67.8c-12.5-8.1-26.2-11.8-40-12.4c-9-.4-18.1 .6-27.1 2.7c7.8 57.1 38.7 106.8 82.9 139.4c6.8-6.7 12.6-14.1 16.8-22.1zM288 64c-28.8 0-56.3 5.9-81.2 16.5c2 8.3 5 16.2 9 23.5c6.8 12.4 16.7 23.1 30.1 30.3c13.3-4.1 27.5-6.3 42.2-6.3s28.8 2.2 42.2 6.3c13.4-7.2 23.3-17.9 30.1-30.3c4-7.3 7-15.2 9-23.5C344.3 69.9 316.8 64 288 64zM426.9 310c-7.2 26.4-21.7 49.7-41.2 67.8c-1.2 14.7 2.2 28.1 8.6 39.8c4.3 8 10 15.4 16.8 22.1c44.3-32.6 75.2-82.3 82.9-139.4c-9-2.2-18.1-3.1-27.1-2.7c-13.8 .6-27.5 4.4-40 12.4z"
    ]
};
var $d8206b3ab2e65c05$export$14e1096ad1719098 = {
    prefix: "fas",
    iconName: "location-crosshairs",
    icon: [
        512,
        512,
        [
            "location"
        ],
        "f601",
        "M256 0c17.7 0 32 14.3 32 32V66.7C368.4 80.1 431.9 143.6 445.3 224H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H445.3C431.9 368.4 368.4 431.9 288 445.3V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V445.3C143.6 431.9 80.1 368.4 66.7 288H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H66.7C80.1 143.6 143.6 80.1 224 66.7V32c0-17.7 14.3-32 32-32zM128 256a128 128 0 1 0 256 0 128 128 0 1 0 -256 0zm128-80a80 80 0 1 1 0 160 80 80 0 1 1 0-160z"
    ]
};
var $d8206b3ab2e65c05$export$45e012c32174eb5d = $d8206b3ab2e65c05$export$14e1096ad1719098;
var $d8206b3ab2e65c05$export$2f8a28204bb4b86f = {
    prefix: "fas",
    iconName: "mars-double",
    icon: [
        640,
        512,
        [
            9891
        ],
        "f227",
        "M312 32c-9.7 0-18.5 5.8-22.2 14.8s-1.7 19.3 5.2 26.2l33.4 33.4L275.8 159c-28.4-19.5-62.7-31-99.8-31C78.8 128 0 206.8 0 304s78.8 176 176 176s176-78.8 176-176c0-37-11.4-71.4-31-99.8l52.6-52.6L407 185c6.9 6.9 17.2 8.9 26.2 5.2s14.8-12.5 14.8-22.2V56c0-13.3-10.7-24-24-24H312zm88 48h0v0l0 0zM64 304a112 112 0 1 1 224 0A112 112 0 1 1 64 304zM368 480c97.2 0 176-78.8 176-176c0-37-11.4-71.4-31-99.8l52.6-52.6L599 185c6.9 6.9 17.2 8.9 26.2 5.2s14.8-12.5 14.8-22.2V56c0-13.3-10.7-24-24-24H504c-9.7 0-18.5 5.8-22.2 14.8c-1.2 2.9-1.8 6-1.8 9l0 .2v.2c0 6.2 2.5 12.2 7 16.8l33.4 33.4L480 146.7V168c0 22.6-13.6 43.1-34.6 51.7c-.8 .3-1.7 .7-2.5 1C465.7 241.2 480 270.9 480 304c0 61.9-50.1 112-112 112c-5.4 0-10.8-.4-16-1.1c-12.9 20.4-29.1 38.3-48.1 53.1c19.8 7.8 41.4 12 64 12z"
    ]
};
var $d8206b3ab2e65c05$export$f31a37ecbfd4e707 = {
    prefix: "fas",
    iconName: "child-dress",
    icon: [
        320,
        512,
        [],
        "e59c",
        "M224 64A64 64 0 1 0 96 64a64 64 0 1 0 128 0zM88 400v80c0 17.7 14.3 32 32 32s32-14.3 32-32V400h16v80c0 17.7 14.3 32 32 32s32-14.3 32-32V400h17.8c10.9 0 18.6-10.7 15.2-21.1l-31.1-93.4 28.6 37.8c10.7 14.1 30.8 16.8 44.8 6.2s16.8-30.7 6.2-44.8L254.6 207c-22.4-29.6-57.5-47-94.6-47s-72.2 17.4-94.6 47L6.5 284.7c-10.7 14.1-7.9 34.2 6.2 44.8s34.2 7.9 44.8-6.2l28.7-37.8L55 378.9C51.6 389.3 59.3 400 70.2 400H88z"
    ]
};
var $d8206b3ab2e65c05$export$6ea1decf8bb3513d = {
    prefix: "fas",
    iconName: "users-between-lines",
    icon: [
        640,
        512,
        [],
        "e591",
        "M0 24C0 10.7 10.7 0 24 0H616c13.3 0 24 10.7 24 24s-10.7 24-24 24H24C10.7 48 0 37.3 0 24zM0 488c0-13.3 10.7-24 24-24H616c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24zM83.2 160a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM32 320c0-35.3 28.7-64 64-64h96c12.2 0 23.7 3.4 33.4 9.4c-37.2 15.1-65.6 47.2-75.8 86.6H64c-17.7 0-32-14.3-32-32zm461.6 32c-10.3-40.1-39.6-72.6-77.7-87.4c9.4-5.5 20.4-8.6 32.1-8.6h96c35.3 0 64 28.7 64 64c0 17.7-14.3 32-32 32H493.6zM391.2 290.4c32.1 7.4 58.1 30.9 68.9 61.6c3.5 10 5.5 20.8 5.5 32c0 17.7-14.3 32-32 32h-224c-17.7 0-32-14.3-32-32c0-11.2 1.9-22 5.5-32c10.5-29.7 35.3-52.8 66.1-60.9c7.8-2.1 16-3.1 24.5-3.1h96c7.4 0 14.7 .8 21.6 2.4zm44-130.4a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM321.6 96a80 80 0 1 1 0 160 80 80 0 1 1 0-160z"
    ]
};
var $d8206b3ab2e65c05$export$895159d10626af74 = {
    prefix: "fas",
    iconName: "lungs-virus",
    icon: [
        640,
        512,
        [],
        "e067",
        "M320 0c17.7 0 32 14.3 32 32V156.2c-8.5-7.6-19.7-12.2-32-12.2s-23.5 4.6-32 12.2V32c0-17.7 14.3-32 32-32zM444.5 195.5c-16.4-16.4-41.8-18.5-60.5-6.1V165.3C384 127 415 96 453.3 96c21.7 0 42.8 10.2 55.8 28.8c15.4 22.1 44.3 65.4 71 116.9c26.5 50.9 52.4 112.5 59.6 170.3c.2 1.3 .2 2.6 .2 4v7c0 49.1-39.8 89-89 89c-7.3 0-14.5-.9-21.6-2.7l-72.7-18.2c-20.9-5.2-38.7-17.1-51.5-32.9c14 1.5 28.5-3 39.2-13.8l-22.6-22.6 22.6 22.6c18.7-18.7 18.7-49.1 0-67.9c-1.1-1.1-1.4-2-1.5-2.5c-.1-.8-.1-1.8 .4-2.9s1.2-1.9 1.8-2.3c.5-.3 1.3-.8 2.9-.8c26.5 0 48-21.5 48-48s-21.5-48-48-48c-1.6 0-2.4-.4-2.9-.8c-.6-.4-1.3-1.2-1.8-2.3s-.5-2.2-.4-2.9c.1-.6 .4-1.4 1.5-2.5c18.7-18.7 18.7-49.1 0-67.9zM421.8 421.8c-6.2 6.2-16.4 6.2-22.6 0C375.9 398.5 336 415 336 448c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-33-39.9-49.5-63.2-26.2c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6C241.5 375.9 225 336 192 336c-8.8 0-16-7.2-16-16s7.2-16 16-16c33 0 49.5-39.9 26.2-63.2c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0C264.1 241.5 304 225 304 192c0-8.8 7.2-16 16-16s16 7.2 16 16c0 33 39.9 49.5 63.2 26.2c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6C398.5 264.1 415 304 448 304c8.8 0 16 7.2 16 16s-7.2 16-16 16c-33 0-49.5 39.9-26.2 63.2c6.2 6.2 6.2 16.4 0 22.6zM183.3 491.2l-72.7 18.2c-7.1 1.8-14.3 2.7-21.6 2.7c-49.1 0-89-39.8-89-89v-7c0-1.3 .1-2.7 .2-4c7.2-57.9 33.1-119.4 59.6-170.3c26.8-51.5 55.6-94.8 71-116.9c13-18.6 34-28.8 55.8-28.8C225 96 256 127 256 165.3v24.1c-18.6-12.4-44-10.3-60.5 6.1c-18.7 18.7-18.7 49.1 0 67.9c1.1 1.1 1.4 2 1.5 2.5c.1 .8 .1 1.8-.4 2.9s-1.2 1.9-1.8 2.3c-.5 .3-1.3 .8-2.9 .8c-26.5 0-48 21.5-48 48s21.5 48 48 48c1.6 0 2.4 .4 2.9 .8c.6 .4 1.3 1.2 1.8 2.3s.5 2.2 .4 2.9c-.1 .6-.4 1.4-1.5 2.5c-18.7 18.7-18.7 49.1 0 67.9c10.7 10.7 25.3 15.3 39.2 13.8c-12.8 15.9-30.6 27.7-51.5 32.9zM296 320a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm72 32a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"
    ]
};
var $d8206b3ab2e65c05$export$8ac6d81a3d5b40a1 = {
    prefix: "fas",
    iconName: "face-grin-tears",
    icon: [
        640,
        512,
        [
            128514,
            "grin-tears"
        ],
        "f588",
        "M548.6 371.4C506.4 454.8 419.9 512 320 512s-186.4-57.2-228.6-140.6c4.5-2.9 8.7-6.3 12.7-10.3c8.1-8.1 13.2-18.6 16.5-26.6c3.6-8.8 6.5-18.4 8.8-27.5c4.6-18.2 7.7-37 9.3-48.2c3.9-26.5-18.8-49.2-45.2-45.4c-6.8 .9-16.2 2.4-26.6 4.4C85.3 94.5 191.6 0 320 0S554.7 94.5 573.2 217.7c-10.3-2-19.8-3.5-26.6-4.4c-26.5-3.9-49.2 18.8-45.2 45.4c1.6 11.3 4.6 30 9.3 48.2c2.3 9.1 5.2 18.8 8.8 27.5c3.3 8.1 8.4 18.5 16.5 26.6c3.9 3.9 8.2 7.4 12.7 10.3zM107 254.1c-3.1 21.5-11.4 70.2-25.5 84.4c-.9 1-1.9 1.8-2.9 2.7C60 356.7 32 355.5 14.3 337.7c-18.7-18.7-19.1-48.8-.7-67.2c8.6-8.6 30.1-15.1 50.5-19.6c13-2.8 25.5-4.8 33.9-6c5.4-.8 9.9 3.7 9 9zm454.5 87.1c-.8-.6-1.5-1.3-2.3-2c-.2-.2-.5-.4-.7-.7c-14.1-14.1-22.5-62.9-25.5-84.4c-.8-5.4 3.7-9.9 9-9c1 .1 2.2 .3 3.3 .5c8.2 1.2 19.2 3 30.6 5.5c20.4 4.4 41.9 10.9 50.5 19.6c18.4 18.4 18 48.5-.7 67.2c-17.7 17.7-45.7 19-64.2 3.4zm-90.1-9.7c5-11.8-7-22.5-19.3-18.7c-39.7 12.2-84.5 19-131.8 19s-92.1-6.8-131.8-19c-12.3-3.8-24.3 6.9-19.3 18.7c25 59.1 83.2 100.5 151.1 100.5s126.2-41.4 151.1-100.5zM281.6 228.8l0 0 0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C190.7 188.4 184 206.1 184 224c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8l0 0 0 0 0 0 .2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2 0 0zm160 0l0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C350.7 188.4 344 206.1 344 224c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8l0 0 0 0 0 0 .2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2 0 0 0 0z"
    ]
};
var $d8206b3ab2e65c05$export$b2f7512221512b5b = $d8206b3ab2e65c05$export$8ac6d81a3d5b40a1;
var $d8206b3ab2e65c05$export$ddab067855cf34cb = {
    prefix: "fas",
    iconName: "phone",
    icon: [
        512,
        512,
        [
            128222,
            128379
        ],
        "f095",
        "M164.9 24.6c-7.7-18.6-28-28.5-47.4-23.2l-88 24C12.1 30.2 0 46 0 64C0 311.4 200.6 512 448 512c18 0 33.8-12.1 38.6-29.5l24-88c5.3-19.4-4.6-39.7-23.2-47.4l-96-40c-16.3-6.8-35.2-2.1-46.3 11.6L304.7 368C234.3 334.7 177.3 277.7 144 207.3L193.3 167c13.7-11.2 18.4-30 11.6-46.3l-40-96z"
    ]
};
var $d8206b3ab2e65c05$export$3c70ffe5660af060 = {
    prefix: "fas",
    iconName: "calendar-xmark",
    icon: [
        448,
        512,
        [
            "calendar-times"
        ],
        "f273",
        "M128 0c17.7 0 32 14.3 32 32V64H288V32c0-17.7 14.3-32 32-32s32 14.3 32 32V64h48c26.5 0 48 21.5 48 48v48H0V112C0 85.5 21.5 64 48 64H96V32c0-17.7 14.3-32 32-32zM0 192H448V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V192zM305 305c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47z"
    ]
};
var $d8206b3ab2e65c05$export$99b20d7352fbcf08 = $d8206b3ab2e65c05$export$3c70ffe5660af060;
var $d8206b3ab2e65c05$export$84a2f9476730c40e = {
    prefix: "fas",
    iconName: "child-reaching",
    icon: [
        384,
        512,
        [],
        "e59d",
        "M256 64A64 64 0 1 0 128 64a64 64 0 1 0 128 0zM152.9 169.3c-23.7-8.4-44.5-24.3-58.8-45.8L74.6 94.2C64.8 79.5 45 75.6 30.2 85.4s-18.7 29.7-8.9 44.4L40.9 159c18.1 27.1 42.8 48.4 71.1 62.4V480c0 17.7 14.3 32 32 32s32-14.3 32-32V384h32v96c0 17.7 14.3 32 32 32s32-14.3 32-32V221.6c29.1-14.2 54.4-36.2 72.7-64.2l18.2-27.9c9.6-14.8 5.4-34.6-9.4-44.3s-34.6-5.5-44.3 9.4L291 122.4c-21.8 33.4-58.9 53.6-98.8 53.6c-12.6 0-24.9-2-36.6-5.8c-.9-.3-1.8-.7-2.7-.9z"
    ]
};
var $d8206b3ab2e65c05$export$5b64b916710da7c7 = {
    prefix: "fas",
    iconName: "head-side-virus",
    icon: [
        512,
        512,
        [],
        "e064",
        "M0 224.2C0 100.6 100.2 0 224 0h24c95.2 0 181.2 69.3 197.3 160.2c2.3 13 6.8 25.7 15.1 36l42 52.6c6.2 7.8 9.6 17.4 9.6 27.4c0 24.2-19.6 43.8-43.8 43.8H448v64c0 35.3-28.7 64-64 64H320v32c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V407.3c0-16.7-6.9-32.5-17.1-45.8C16.6 322.4 0 274.1 0 224.2zM224 64c-8.8 0-16 7.2-16 16c0 33-39.9 49.5-63.2 26.2c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6C145.5 152.1 129 192 96 192c-8.8 0-16 7.2-16 16s7.2 16 16 16c33 0 49.5 39.9 26.2 63.2c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0C168.1 286.5 208 303 208 336c0 8.8 7.2 16 16 16s16-7.2 16-16c0-33 39.9-49.5 63.2-26.2c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6C302.5 263.9 319 224 352 224c8.8 0 16-7.2 16-16s-7.2-16-16-16c-33 0-49.5-39.9-26.2-63.2c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0C279.9 129.5 240 113 240 80c0-8.8-7.2-16-16-16zm-24 96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm40 80a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"
    ]
};
var $d8206b3ab2e65c05$export$f504a6909b677146 = {
    prefix: "fas",
    iconName: "user-gear",
    icon: [
        640,
        512,
        [
            "user-cog"
        ],
        "f4fe",
        "M224 0a128 128 0 1 1 0 256A128 128 0 1 1 224 0zM178.3 304h91.4c11.8 0 23.4 1.2 34.5 3.3c-2.1 18.5 7.4 35.6 21.8 44.8c-16.6 10.6-26.7 31.6-20 53.3c4 12.9 9.4 25.5 16.4 37.6s15.2 23.1 24.4 33c15.7 16.9 39.6 18.4 57.2 8.7v.9c0 9.2 2.7 18.5 7.9 26.3H29.7C13.3 512 0 498.7 0 482.3C0 383.8 79.8 304 178.3 304zM436 218.2c0-7 4.5-13.3 11.3-14.8c10.5-2.4 21.5-3.7 32.7-3.7s22.2 1.3 32.7 3.7c6.8 1.5 11.3 7.8 11.3 14.8v17.7c0 7.8 4.8 14.8 11.6 18.7c6.8 3.9 15.1 4.5 21.8 .6l13.8-7.9c6.1-3.5 13.7-2.7 18.5 2.4c7.6 8.1 14.3 17.2 20.1 27.2s10.3 20.4 13.5 31c2.1 6.7-1.1 13.7-7.2 17.2l-14.4 8.3c-6.5 3.7-10 10.9-10 18.4s3.5 14.7 10 18.4l14.4 8.3c6.1 3.5 9.2 10.5 7.2 17.2c-3.3 10.6-7.8 21-13.5 31s-12.5 19.1-20.1 27.2c-4.8 5.1-12.5 5.9-18.5 2.4l-13.8-7.9c-6.7-3.9-15.1-3.3-21.8 .6c-6.8 3.9-11.6 10.9-11.6 18.7v17.7c0 7-4.5 13.3-11.3 14.8c-10.5 2.4-21.5 3.7-32.7 3.7s-22.2-1.3-32.7-3.7c-6.8-1.5-11.3-7.8-11.3-14.8V467.8c0-7.9-4.9-14.9-11.7-18.9c-6.8-3.9-15.2-4.5-22-.6l-13.5 7.8c-6.1 3.5-13.7 2.7-18.5-2.4c-7.6-8.1-14.3-17.2-20.1-27.2s-10.3-20.4-13.5-31c-2.1-6.7 1.1-13.7 7.2-17.2l14-8.1c6.5-3.8 10.1-11.1 10.1-18.6s-3.5-14.8-10.1-18.6l-14-8.1c-6.1-3.5-9.2-10.5-7.2-17.2c3.3-10.6 7.7-21 13.5-31s12.5-19.1 20.1-27.2c4.8-5.1 12.4-5.9 18.5-2.4l13.6 7.8c6.8 3.9 15.2 3.3 22-.6c6.9-3.9 11.7-11 11.7-18.9V218.2zm92.1 133.5a48.1 48.1 0 1 0 -96.1 0 48.1 48.1 0 1 0 96.1 0z"
    ]
};
var $d8206b3ab2e65c05$export$474108c2b86e730e = $d8206b3ab2e65c05$export$f504a6909b677146;
var $d8206b3ab2e65c05$export$bbbff45e04f4abab = {
    prefix: "fas",
    iconName: "arrow-up-1-9",
    icon: [
        576,
        512,
        [
            "sort-numeric-up"
        ],
        "f163",
        "M450.7 38c8.3 6 13.3 15.7 13.3 26v96h16c17.7 0 32 14.3 32 32s-14.3 32-32 32H432 384c-17.7 0-32-14.3-32-32s14.3-32 32-32h16V108.4l-5.9 2c-16.8 5.6-34.9-3.5-40.5-20.2s3.5-34.9 20.2-40.5l48-16c9.8-3.3 20.5-1.6 28.8 4.4zM160 32c9 0 17.5 3.8 23.6 10.4l88 96c11.9 13 11.1 33.3-2 45.2s-33.3 11.1-45.2-2L192 146.3V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V146.3L95.6 181.6c-11.9 13-32.2 13.9-45.2 2s-13.9-32.2-2-45.2l88-96C142.5 35.8 151 32 160 32zM445.7 364.9A32 32 0 1 0 418.3 307a32 32 0 1 0 27.4 57.9zm-40.7 54.9C369.6 408.4 344 375.2 344 336c0-48.6 39.4-88 88-88s88 39.4 88 88c0 23.5-7.5 46.3-21.5 65.2L449.7 467c-10.5 14.2-30.6 17.2-44.8 6.7s-17.2-30.6-6.7-44.8l6.8-9.2z"
    ]
};
var $d8206b3ab2e65c05$export$d213a3ba3cabed48 = $d8206b3ab2e65c05$export$bbbff45e04f4abab;
var $d8206b3ab2e65c05$export$2c79e1a422528bba = {
    prefix: "fas",
    iconName: "door-closed",
    icon: [
        576,
        512,
        [
            128682
        ],
        "f52a",
        "M96 64c0-35.3 28.7-64 64-64H416c35.3 0 64 28.7 64 64V448h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H432 144 32c-17.7 0-32-14.3-32-32s14.3-32 32-32H96V64zM384 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
var $d8206b3ab2e65c05$export$bea811bbf570f05a = {
    prefix: "fas",
    iconName: "shield-virus",
    icon: [
        512,
        512,
        [],
        "e06c",
        "M269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L269.4 2.9zM256 112c8.8 0 16 7.2 16 16c0 33 39.9 49.5 63.2 26.2c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6C334.5 200.1 351 240 384 240c8.8 0 16 7.2 16 16s-7.2 16-16 16c-33 0-49.5 39.9-26.2 63.2c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0C311.9 334.5 272 351 272 384c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-33-39.9-49.5-63.2-26.2c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6C177.5 311.9 161 272 128 272c-8.8 0-16-7.2-16-16s7.2-16 16-16c33 0 49.5-39.9 26.2-63.2c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0C200.1 177.5 240 161 240 128c0-8.8 7.2-16 16-16zM232 256a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm72 32a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"
    ]
};
var $d8206b3ab2e65c05$export$3397c7b4679acccc = {
    prefix: "fas",
    iconName: "dice-six",
    icon: [
        448,
        512,
        [
            9861
        ],
        "f526",
        "M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm160 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM128 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm32 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM320 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm32 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM320 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
var $d8206b3ab2e65c05$export$f3858ce1b3218e2 = {
    prefix: "fas",
    iconName: "mosquito-net",
    icon: [
        640,
        512,
        [],
        "e52c",
        "M168.8 462.3c-7.9-4-11.1-13.6-7.2-21.5L192 380.2l0-44.2c0-4.2 1.7-8.3 4.7-11.3L256 265.4V242.2L139.2 344C87.8 395.3 0 358.9 0 286.3c0-41.1 30.6-75.8 71.4-80.9l159.9-23.9-49.6-41.3c-5.1-4.2-7-11.1-4.9-17.4l13.9-41.7-29-58.1c-4-7.9-.7-17.5 7.2-21.5s17.5-.7 21.5 7.2l32 64c1.9 3.8 2.2 8.2 .9 12.2l-12.5 37.6L256 160.5V137.9c0-14.9 10.1-27.3 23.8-31V63.7c0-4.5 3.7-8.2 8.2-8.2s8.2 3.7 8.2 8.2V107c13.7 3.6 23.8 16.1 23.8 31v22.6l45.4-37.8L352.8 85.1c-1.3-4-1-8.4 .9-12.2l32-64c4-7.9 13.6-11.1 21.5-7.2s11.1 13.6 7.2 21.5l-29 58.1 13.9 41.7c2.1 6.2 .1 13.1-4.9 17.4l-49.6 41.3 159.9 23.9c22.5 2.8 41.8 14.6 54.7 31.4c-2.7 2.6-5.2 5.4-7.3 8.6c-8.6-12.9-23.3-21.5-40-21.5s-31.4 8.5-40 21.5c-8.6-12.9-23.3-21.5-40-21.5c-21.7 0-40 14.3-45.9 34.1c-10.7 3.2-19.8 10.1-25.9 19.2l-40.2-35v23.1l32.4 32.4c-.3 2-.4 4.1-.4 6.2c0 16.7 8.5 31.4 21.5 40c-4 2.6-7.5 5.9-10.6 9.5L320 310.6v50c0 17.7-14.3 32-32 32s-32-14.3-32-32v-50l-32 32 0 41.4c0 2.5-.6 4.9-1.7 7.2l-32 64c-4 7.9-13.6 11.1-21.5 7.2zM512 256c8.8 0 16 7.2 16 16v16h48V272c0-8.8 7.2-16 16-16s16 7.2 16 16v16h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H608v48h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H608v48h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H608v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V480H528v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V480H448v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V480H400c-8.8 0-16-7.2-16-16s7.2-16 16-16h16V400H400c-8.8 0-16-7.2-16-16s7.2-16 16-16h16V320H400c-8.8 0-16-7.2-16-16s7.2-16 16-16h16V272c0-8.8 7.2-16 16-16s16 7.2 16 16v16h48V272c0-8.8 7.2-16 16-16zm16 112h48V320H528v48zm0 80h48V400H528v48zM448 320v48h48V320H448zm0 80v48h48V400H448z"
    ]
};
var $d8206b3ab2e65c05$export$154e99cb34841765 = {
    prefix: "fas",
    iconName: "bridge-water",
    icon: [
        576,
        512,
        [],
        "e4ce",
        "M0 96C0 78.3 14.3 64 32 64H544c17.7 0 32 14.3 32 32v35.6c0 15.7-12.7 28.4-28.4 28.4c-37.3 0-67.6 30.2-67.6 67.6V352.5c-12.9 0-25.8 3.9-36.8 11.7c-18 12.4-40.1 20.3-59.2 20.3h0l0-.5V256c0-53-43-96-96-96s-96 43-96 96V384l0 .5c-19 0-41.2-7.9-59.1-20.3c-11.1-7.8-24-11.7-36.9-11.7V227.6C96 190.2 65.8 160 28.4 160C12.7 160 0 147.3 0 131.6V96zM306.5 389.9C329 405.4 356.5 416 384 416c26.9 0 55.4-10.8 77.4-26.1l0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 469.7 417 480 384 480c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.4 27.3-10.1 39.2-1.7l0 0C136.7 405.2 165.1 416 192 416c27.5 0 55-10.6 77.5-26.1c11.1-7.9 25.9-7.9 37 0z"
    ]
};
var $d8206b3ab2e65c05$export$2337c975289bdd84 = {
    prefix: "fas",
    iconName: "person-booth",
    icon: [
        576,
        512,
        [],
        "f756",
        "M256 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V192h64V32zm320 0c0-17.7-14.3-32-32-32s-32 14.3-32 32V480c0 17.7 14.3 32 32 32s32-14.3 32-32V32zM224 512c17.7 0 32-14.3 32-32V320H192V480c0 17.7 14.3 32 32 32zM320 0c-9.3 0-18.1 4-24.2 11s-8.8 16.3-7.5 25.5l31.2 218.6L288.6 409.7c-3.5 17.3 7.8 34.2 25.1 37.7s34.2-7.8 37.7-25.1l.7-3.6c1.3 16.4 15.1 29.4 31.9 29.4c17.7 0 32-14.3 32-32c0 17.7 14.3 32 32 32s32-14.3 32-32V32c0-17.7-14.3-32-32-32H320zM112 80A48 48 0 1 0 16 80a48 48 0 1 0 96 0zm0 261.3V269.3l4.7 4.7c9 9 21.2 14.1 33.9 14.1H224c17.7 0 32-14.3 32-32s-14.3-32-32-32H157.3l-41.6-41.6c-14.3-14.3-33.8-22.4-54-22.4C27.6 160 0 187.6 0 221.6v55.7l0 .9V480c0 17.7 14.3 32 32 32s32-14.3 32-32V384l32 42.7V480c0 17.7 14.3 32 32 32s32-14.3 32-32V421.3c0-10.4-3.4-20.5-9.6-28.8L112 341.3z"
    ]
};
var $d8206b3ab2e65c05$export$d8724cf433389700 = {
    prefix: "fas",
    iconName: "text-width",
    icon: [
        448,
        512,
        [],
        "f035",
        "M64 128V96H192l0 128H176c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H256l0-128H384v32c0 17.7 14.3 32 32 32s32-14.3 32-32V80c0-26.5-21.5-48-48-48H224 48C21.5 32 0 53.5 0 80v48c0 17.7 14.3 32 32 32s32-14.3 32-32zM9.4 361.4c-12.5 12.5-12.5 32.8 0 45.3l64 64c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6V416H320v32c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l64-64c12.5-12.5 12.5-32.8 0-45.3l-64-64c-9.2-9.2-22.9-11.9-34.9-6.9s-19.8 16.6-19.8 29.6v32H128V320c0-12.9-7.8-24.6-19.8-29.6s-25.7-2.2-34.9 6.9l-64 64z"
    ]
};
var $d8206b3ab2e65c05$export$7daa48199dcb2ad1 = {
    prefix: "fas",
    iconName: "hat-wizard",
    icon: [
        512,
        512,
        [],
        "f6e8",
        "M64 416L168.6 180.7c15.3-34.4 40.3-63.5 72-83.7l146.9-94c3-1.9 6.5-2.9 10-2.9C407.7 0 416 8.3 416 18.6v1.6c0 2.6-.5 5.1-1.4 7.5L354.8 176.9c-1.9 4.7-2.8 9.7-2.8 14.7c0 5.5 1.2 11 3.4 16.1L448 416H240.9l11.8-35.4 40.4-13.5c6.5-2.2 10.9-8.3 10.9-15.2s-4.4-13-10.9-15.2l-40.4-13.5-13.5-40.4C237 276.4 230.9 272 224 272s-13 4.4-15.2 10.9l-13.5 40.4-40.4 13.5C148.4 339 144 345.1 144 352s4.4 13 10.9 15.2l40.4 13.5L207.1 416H64zM279.6 141.5c-1.1-3.3-4.1-5.5-7.6-5.5s-6.5 2.2-7.6 5.5l-6.7 20.2-20.2 6.7c-3.3 1.1-5.5 4.1-5.5 7.6s2.2 6.5 5.5 7.6l20.2 6.7 6.7 20.2c1.1 3.3 4.1 5.5 7.6 5.5s6.5-2.2 7.6-5.5l6.7-20.2 20.2-6.7c3.3-1.1 5.5-4.1 5.5-7.6s-2.2-6.5-5.5-7.6l-20.2-6.7-6.7-20.2zM32 448H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
    ]
};
var $d8206b3ab2e65c05$export$8bdfe14ac72a8b17 = {
    prefix: "fas",
    iconName: "pen-fancy",
    icon: [
        512,
        512,
        [
            128395,
            10002
        ],
        "f5ac",
        "M373.5 27.1C388.5 9.9 410.2 0 433 0c43.6 0 79 35.4 79 79c0 22.8-9.9 44.6-27.1 59.6L277.7 319l-10.3-10.3-64-64L193 234.3 373.5 27.1zM170.3 256.9l10.4 10.4 64 64 10.4 10.4-19.2 83.4c-3.9 17.1-16.9 30.7-33.8 35.4L24.4 510.3l95.4-95.4c2.6 .7 5.4 1.1 8.3 1.1c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32c0 2.9 .4 5.6 1.1 8.3L1.7 487.6 51.5 310c4.7-16.9 18.3-29.9 35.4-33.8l83.4-19.2z"
    ]
};
var $d8206b3ab2e65c05$export$f4d483fca19a4604 = {
    prefix: "fas",
    iconName: "person-digging",
    icon: [
        576,
        512,
        [
            "digging"
        ],
        "f85e",
        "M208 64a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM9.8 214.8c5.1-12.2 19.1-18 31.4-12.9L60.7 210l22.9-38.1C99.9 144.6 129.3 128 161 128c51.4 0 97 32.9 113.3 81.7l34.6 103.7 79.3 33.1 34.2-45.6c6.4-8.5 16.6-13.3 27.2-12.8s20.3 6.4 25.8 15.5l96 160c5.9 9.9 6.1 22.2 .4 32.2s-16.3 16.2-27.8 16.2H288c-11.1 0-21.4-5.7-27.2-15.2s-6.4-21.2-1.4-31.1l16-32c5.4-10.8 16.5-17.7 28.6-17.7h32l22.5-30L22.8 246.2c-12.2-5.1-18-19.1-12.9-31.4zm82.8 91.8l112 48c11.8 5 19.4 16.6 19.4 29.4v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V405.1l-60.6-26-37 111c-5.6 16.8-23.7 25.8-40.5 20.2S-3.9 486.6 1.6 469.9l48-144 11-33 32 13.7z"
    ]
};
var $d8206b3ab2e65c05$export$7bd93e3343bd5671 = $d8206b3ab2e65c05$export$f4d483fca19a4604;
var $d8206b3ab2e65c05$export$ed8c149a0ea54bb4 = {
    prefix: "fas",
    iconName: "trash",
    icon: [
        448,
        512,
        [],
        "f1f8",
        "M135.2 17.7L128 32H32C14.3 32 0 46.3 0 64S14.3 96 32 96H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H320l-7.2-14.3C307.4 6.8 296.3 0 284.2 0H163.8c-12.1 0-23.2 6.8-28.6 17.7zM416 128H32L53.2 467c1.6 25.3 22.6 45 47.9 45H346.9c25.3 0 46.3-19.7 47.9-45L416 128z"
    ]
};
var $d8206b3ab2e65c05$export$f3a0a4e6723a86d4 = {
    prefix: "fas",
    iconName: "gauge-simple",
    icon: [
        512,
        512,
        [
            "gauge-simple-med",
            "tachometer-average"
        ],
        "f629",
        "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm320 96c0-26.9-16.5-49.9-40-59.3V88c0-13.3-10.7-24-24-24s-24 10.7-24 24V292.7c-23.5 9.5-40 32.5-40 59.3c0 35.3 28.7 64 64 64s64-28.7 64-64z"
    ]
};
var $d8206b3ab2e65c05$export$ba8c12ff7cfa2521 = $d8206b3ab2e65c05$export$f3a0a4e6723a86d4;
var $d8206b3ab2e65c05$export$94fcfd6f6335431b = $d8206b3ab2e65c05$export$f3a0a4e6723a86d4;
var $d8206b3ab2e65c05$export$6feb44fec53ba30d = {
    prefix: "fas",
    iconName: "book-medical",
    icon: [
        448,
        512,
        [],
        "f7e6",
        "M0 96C0 43 43 0 96 0H384h32c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32v64c17.7 0 32 14.3 32 32s-14.3 32-32 32H384 96c-53 0-96-43-96-96V96zM64 416c0 17.7 14.3 32 32 32H352V384H96c-17.7 0-32 14.3-32 32zM208 112v48H160c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V224h48c8.8 0 16-7.2 16-16V176c0-8.8-7.2-16-16-16H272V112c0-8.8-7.2-16-16-16H224c-8.8 0-16 7.2-16 16z"
    ]
};
var $d8206b3ab2e65c05$export$dd0ede1713d2d2f9 = {
    prefix: "fas",
    iconName: "poo",
    icon: [
        512,
        512,
        [
            128169
        ],
        "f2fe",
        "M268.9 .9c-5.5-.7-11 1.4-14.5 5.7s-4.6 10.1-2.8 15.4c2.8 8.2 4.3 16.9 4.3 26.1c0 44.1-35.7 79.9-79.8 80H160c-35.3 0-64 28.7-64 64c0 19.1 8.4 36.3 21.7 48H104c-39.8 0-72 32.2-72 72c0 23.2 11 43.8 28 57c-34.1 5.7-60 35.3-60 71c0 39.8 32.2 72 72 72H440c39.8 0 72-32.2 72-72c0-35.7-25.9-65.3-60-71c17-13.2 28-33.8 28-57c0-39.8-32.2-72-72-72H394.3c13.3-11.7 21.7-28.9 21.7-48c0-35.3-28.7-64-64-64h-5.5c3.5-10 5.5-20.8 5.5-32c0-48.6-36.2-88.8-83.1-95.1zM192 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm96 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm64 108.3c0 2.4-.7 4.8-2.2 6.7c-8.2 10.5-39.5 45-93.8 45s-85.6-34.6-93.8-45c-1.5-1.9-2.2-4.3-2.2-6.7c0-6.8 5.5-12.3 12.3-12.3H339.7c6.8 0 12.3 5.5 12.3 12.3z"
    ]
};
var $d8206b3ab2e65c05$export$54e3a80c9875b74c = {
    prefix: "fas",
    iconName: "quote-right",
    icon: [
        448,
        512,
        [
            8221,
            "quote-right-alt"
        ],
        "f10e",
        "M448 296c0 66.3-53.7 120-120 120h-8c-17.7 0-32-14.3-32-32s14.3-32 32-32h8c30.9 0 56-25.1 56-56v-8H320c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64h64c35.3 0 64 28.7 64 64v32 32 72zm-256 0c0 66.3-53.7 120-120 120H64c-17.7 0-32-14.3-32-32s14.3-32 32-32h8c30.9 0 56-25.1 56-56v-8H64c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64h64c35.3 0 64 28.7 64 64v32 32 72z"
    ]
};
var $d8206b3ab2e65c05$export$dd692f2e88bd4b1a = $d8206b3ab2e65c05$export$54e3a80c9875b74c;
var $d8206b3ab2e65c05$export$312f2c01c6fedca8 = {
    prefix: "fas",
    iconName: "shirt",
    icon: [
        640,
        512,
        [
            128085,
            "t-shirt",
            "tshirt"
        ],
        "f553",
        "M211.8 0c7.8 0 14.3 5.7 16.7 13.2C240.8 51.9 277.1 80 320 80s79.2-28.1 91.5-66.8C413.9 5.7 420.4 0 428.2 0h12.6c22.5 0 44.2 7.9 61.5 22.3L628.5 127.4c6.6 5.5 10.7 13.5 11.4 22.1s-2.1 17.1-7.8 23.6l-56 64c-11.4 13.1-31.2 14.6-44.6 3.5L480 197.7V448c0 35.3-28.7 64-64 64H224c-35.3 0-64-28.7-64-64V197.7l-51.5 42.9c-13.3 11.1-33.1 9.6-44.6-3.5l-56-64c-5.7-6.5-8.5-15-7.8-23.6s4.8-16.6 11.4-22.1L137.7 22.3C155 7.9 176.7 0 199.2 0h12.6z"
    ]
};
var $d8206b3ab2e65c05$export$144e5f8bc4d705a6 = $d8206b3ab2e65c05$export$312f2c01c6fedca8;
var $d8206b3ab2e65c05$export$36edce3ba87c2b17 = $d8206b3ab2e65c05$export$312f2c01c6fedca8;
var $d8206b3ab2e65c05$export$30523a9441a31e97 = {
    prefix: "fas",
    iconName: "cubes",
    icon: [
        576,
        512,
        [],
        "f1b3",
        "M290.8 48.6l78.4 29.7L288 109.5 206.8 78.3l78.4-29.7c1.8-.7 3.8-.7 5.7 0zM136 92.5V204.7c-1.3 .4-2.6 .8-3.9 1.3l-96 36.4C14.4 250.6 0 271.5 0 294.7V413.9c0 22.2 13.1 42.3 33.5 51.3l96 42.2c14.4 6.3 30.7 6.3 45.1 0L288 457.5l113.5 49.9c14.4 6.3 30.7 6.3 45.1 0l96-42.2c20.3-8.9 33.5-29.1 33.5-51.3V294.7c0-23.3-14.4-44.1-36.1-52.4l-96-36.4c-1.3-.5-2.6-.9-3.9-1.3V92.5c0-23.3-14.4-44.1-36.1-52.4l-96-36.4c-12.8-4.8-26.9-4.8-39.7 0l-96 36.4C150.4 48.4 136 69.3 136 92.5zM392 210.6l-82.4 31.2V152.6L392 121v89.6zM154.8 250.9l78.4 29.7L152 311.7 70.8 280.6l78.4-29.7c1.8-.7 3.8-.7 5.7 0zm18.8 204.4V354.8L256 323.2v95.9l-82.4 36.2zM421.2 250.9c1.8-.7 3.8-.7 5.7 0l78.4 29.7L424 311.7l-81.2-31.1 78.4-29.7zM523.2 421.2l-77.6 34.1V354.8L528 323.2v90.7c0 3.2-1.9 6-4.8 7.3z"
    ]
};
var $d8206b3ab2e65c05$export$89fa217ec5503ac9 = {
    prefix: "fas",
    iconName: "divide",
    icon: [
        448,
        512,
        [
            10135,
            247
        ],
        "f529",
        "M272 96a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm0 320a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM400 288c17.7 0 32-14.3 32-32s-14.3-32-32-32H48c-17.7 0-32 14.3-32 32s14.3 32 32 32H400z"
    ]
};
var $d8206b3ab2e65c05$export$c04e864469c1d117 = {
    prefix: "fas",
    iconName: "tenge-sign",
    icon: [
        384,
        512,
        [
            8376,
            "tenge"
        ],
        "f7d7",
        "M0 64C0 46.3 14.3 32 32 32H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64zM0 192c0-17.7 14.3-32 32-32H192 352c17.7 0 32 14.3 32 32s-14.3 32-32 32H224V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V224H32c-17.7 0-32-14.3-32-32z"
    ]
};
var $d8206b3ab2e65c05$export$af6ebee83047b793 = $d8206b3ab2e65c05$export$c04e864469c1d117;
var $d8206b3ab2e65c05$export$ad02dd8ca5816958 = {
    prefix: "fas",
    iconName: "headphones",
    icon: [
        512,
        512,
        [
            127911
        ],
        "f025",
        "M256 80C149.9 80 62.4 159.4 49.6 262c9.4-3.8 19.6-6 30.4-6c26.5 0 48 21.5 48 48V432c0 26.5-21.5 48-48 48c-44.2 0-80-35.8-80-80V384 336 288C0 146.6 114.6 32 256 32s256 114.6 256 256v48 48 16c0 44.2-35.8 80-80 80c-26.5 0-48-21.5-48-48V304c0-26.5 21.5-48 48-48c10.8 0 21 2.1 30.4 6C449.6 159.4 362.1 80 256 80z"
    ]
};
var $d8206b3ab2e65c05$export$96891bbcda1dbb7b = {
    prefix: "fas",
    iconName: "hands-holding",
    icon: [
        640,
        512,
        [],
        "f4c2",
        "M80 104c0-22.1-17.9-40-40-40S0 81.9 0 104v56 64V325.5c0 25.5 10.1 49.9 28.1 67.9L128 493.3c12 12 28.3 18.7 45.3 18.7H240c26.5 0 48-21.5 48-48V385.1c0-29.7-11.8-58.2-32.8-79.2l-25.3-25.3 0 0-15.2-15.2-32-32c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l32 32 15.2 15.2c11 11 9.2 29.2-3.7 37.8c-9.7 6.5-22.7 5.2-31-3.1L98.7 309.5c-12-12-18.7-28.3-18.7-45.3V224 144 104zm480 0v40 80 40.2c0 17-6.7 33.3-18.7 45.3l-51.1 51.1c-8.3 8.3-21.3 9.6-31 3.1c-12.9-8.6-14.7-26.9-3.7-37.8l15.2-15.2 32-32c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-32 32-15.2 15.2 0 0-25.3 25.3c-21 21-32.8 49.5-32.8 79.2V464c0 26.5 21.5 48 48 48h66.7c17 0 33.3-6.7 45.3-18.7l99.9-99.9c18-18 28.1-42.4 28.1-67.9V224 160 104c0-22.1-17.9-40-40-40s-40 17.9-40 40z"
    ]
};
var $d8206b3ab2e65c05$export$765c446e974b5e59 = {
    prefix: "fas",
    iconName: "hands-clapping",
    icon: [
        512,
        512,
        [],
        "e1a8",
        "M336 16V80c0 8.8-7.2 16-16 16s-16-7.2-16-16V16c0-8.8 7.2-16 16-16s16 7.2 16 16zm-98.7 7.1l32 48c4.9 7.4 2.9 17.3-4.4 22.2s-17.3 2.9-22.2-4.4l-32-48c-4.9-7.4-2.9-17.3 4.4-22.2s17.3-2.9 22.2 4.4zM135 119c9.4-9.4 24.6-9.4 33.9 0L292.7 242.7c10.1 10.1 27.3 2.9 27.3-11.3V192c0-17.7 14.3-32 32-32s32 14.3 32 32V345.6c0 57.1-30 110-78.9 139.4c-64 38.4-145.8 28.3-198.5-24.4L7 361c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l53 53c6.1 6.1 16 6.1 22.1 0s6.1-16 0-22.1L23 265c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l93 93c6.1 6.1 16 6.1 22.1 0s6.1-16 0-22.1L55 185c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l117 117c6.1 6.1 16 6.1 22.1 0s6.1-16 0-22.1l-93-93c-9.4-9.4-9.4-24.6 0-33.9zM433.1 484.9c-24.2 14.5-50.9 22.1-77.7 23.1c48.1-39.6 76.6-99 76.6-162.4l0-98.1c8.2-.1 16-6.4 16-16V192c0-17.7 14.3-32 32-32s32 14.3 32 32V345.6c0 57.1-30 110-78.9 139.4zM424.9 18.7c7.4 4.9 9.3 14.8 4.4 22.2l-32 48c-4.9 7.4-14.8 9.3-22.2 4.4s-9.3-14.8-4.4-22.2l32-48c4.9-7.4 14.8-9.3 22.2-4.4z"
    ]
};
var $d8206b3ab2e65c05$export$929518bb4b66a588 = {
    prefix: "fas",
    iconName: "republican",
    icon: [
        640,
        512,
        [],
        "f75e",
        "M0 192C0 103.6 71.6 32 160 32H384c88.4 0 160 71.6 160 160v64H0V192zm415.9-64c-2.4 0-4.7 1.3-5.7 3.4l-12.6 24.6-28.2 4c-2.4 .3-4.4 2-5.2 4.2s-.1 4.7 1.6 6.3l20.4 19.2-4.8 27.1c-.4 2.3 .6 4.7 2.5 6s4.6 1.6 6.7 .5l25.2-12.8 25.2 12.8c2.2 1.1 4.8 .9 6.7-.5s3-3.7 2.5-6l-4.8-27.1L466 170.5c1.7-1.6 2.4-4.1 1.6-6.3s-2.8-3.9-5.2-4.2l-28.2-4-12.6-24.6c-1.1-2.1-3.3-3.4-5.7-3.4zm-138.3 3.4c-1.1-2.1-3.3-3.4-5.7-3.4s-4.7 1.3-5.7 3.4l-12.6 24.6-28.2 4c-2.4 .3-4.4 2-5.2 4.2s-.1 4.7 1.6 6.3l20.4 19.2-4.8 27.1c-.4 2.3 .6 4.7 2.5 6s4.6 1.6 6.7 .5l25.2-12.8 25.2 12.8c2.2 1.1 4.8 .9 6.7-.5s3-3.7 2.5-6l-4.8-27.1L322 170.5c1.7-1.6 2.4-4.1 1.6-6.3s-2.8-3.9-5.2-4.2l-28.2-4-12.6-24.6zM127.9 128c-2.4 0-4.7 1.3-5.7 3.4l-12.6 24.6-28.2 4c-2.4 .3-4.4 2-5.2 4.2s-.1 4.7 1.6 6.3l20.4 19.2-4.8 27.1c-.4 2.3 .6 4.7 2.5 6s4.6 1.6 6.7 .5l25.2-12.8 25.2 12.8c2.2 1.1 4.8 .9 6.7-.5s3-3.7 2.5-6l-4.8-27.1L178 170.5c1.7-1.6 2.4-4.1 1.6-6.3s-2.8-3.9-5.2-4.2l-28.2-4-12.6-24.6c-1.1-2.1-3.3-3.4-5.7-3.4zm.1 160H320h96 32 64 32v32 80c0 8.8 7.2 16 16 16s16-7.2 16-16V352c0-17.7 14.3-32 32-32s32 14.3 32 32v48c0 44.2-35.8 80-80 80s-80-35.8-80-80V352H448v32 64c0 17.7-14.3 32-32 32H352c-17.7 0-32-14.3-32-32V384H128v64c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V384 288H128z"
    ]
};
var $d8206b3ab2e65c05$export$b7fac681e7d09400 = {
    prefix: "fas",
    iconName: "arrow-left",
    icon: [
        448,
        512,
        [
            8592
        ],
        "f060",
        "M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z"
    ]
};
var $d8206b3ab2e65c05$export$16c9e0374c346c6e = {
    prefix: "fas",
    iconName: "person-circle-xmark",
    icon: [
        576,
        512,
        [],
        "e543",
        "M112 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm40 304V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V256.9L59.4 304.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c17.4-28.9 48.6-46.6 82.3-46.6h29.7c33.7 0 64.9 17.7 82.3 46.6l44.9 74.7c-16.1 17.6-28.6 38.5-36.6 61.5c-1.9-1.8-3.5-3.9-4.9-6.3L232 256.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352H152zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm59.3 107.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L432 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L409.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L432 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L454.6 368l36.7-36.7z"
    ]
};
var $d8206b3ab2e65c05$export$8e90575265a56cfc = {
    prefix: "fas",
    iconName: "ruler",
    icon: [
        512,
        512,
        [
            128207
        ],
        "f545",
        "M177.9 494.1c-18.7 18.7-49.1 18.7-67.9 0L17.9 401.9c-18.7-18.7-18.7-49.1 0-67.9l50.7-50.7 48 48c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-48-48 41.4-41.4 48 48c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-48-48 41.4-41.4 48 48c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-48-48 41.4-41.4 48 48c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-48-48 50.7-50.7c18.7-18.7 49.1-18.7 67.9 0l92.1 92.1c18.7 18.7 18.7 49.1 0 67.9L177.9 494.1z"
    ]
};
var $d8206b3ab2e65c05$export$e490f662af4d1c78 = {
    prefix: "fas",
    iconName: "align-left",
    icon: [
        448,
        512,
        [],
        "f036",
        "M288 64c0 17.7-14.3 32-32 32H32C14.3 96 0 81.7 0 64S14.3 32 32 32H256c17.7 0 32 14.3 32 32zm0 256c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H256c17.7 0 32 14.3 32 32zM0 192c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zM448 448c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32z"
    ]
};
var $d8206b3ab2e65c05$export$64bfd48ed353c031 = {
    prefix: "fas",
    iconName: "dice-d6",
    icon: [
        448,
        512,
        [],
        "f6d1",
        "M201 10.3c14.3-7.8 31.6-7.8 46 0L422.3 106c5.1 2.8 8.3 8.2 8.3 14s-3.2 11.2-8.3 14L231.7 238c-4.8 2.6-10.5 2.6-15.3 0L25.7 134c-5.1-2.8-8.3-8.2-8.3-14s3.2-11.2 8.3-14L201 10.3zM23.7 170l176 96c5.1 2.8 8.3 8.2 8.3 14V496c0 5.6-3 10.9-7.8 13.8s-10.9 3-15.8 .3L25 423.1C9.6 414.7 0 398.6 0 381V184c0-5.6 3-10.9 7.8-13.8s10.9-3 15.8-.3zm400.7 0c5-2.7 11-2.6 15.8 .3s7.8 8.1 7.8 13.8V381c0 17.6-9.6 33.7-25 42.1L263.7 510c-5 2.7-11 2.6-15.8-.3s-7.8-8.1-7.8-13.8V280c0-5.9 3.2-11.2 8.3-14l176-96z"
    ]
};
var $d8206b3ab2e65c05$export$5fbcef35138741a5 = {
    prefix: "fas",
    iconName: "restroom",
    icon: [
        640,
        512,
        [],
        "f7bd",
        "M80 48a48 48 0 1 1 96 0A48 48 0 1 1 80 48zm40 304V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V325.2c-8.1 9.2-21.1 13.2-33.5 9.4c-16.9-5.3-26.3-23.2-21-40.1l30.9-99.1C44.9 155.3 82 128 124 128h8c42 0 79.1 27.3 91.6 67.4l30.9 99.1c5.3 16.9-4.1 34.8-21 40.1c-12.4 3.9-25.4-.2-33.5-9.4V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352H120zM320 0c13.3 0 24 10.7 24 24V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V24c0-13.3 10.7-24 24-24zM464 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM440 480V384H422.2c-10.9 0-18.6-10.7-15.2-21.1l9-26.9c-3.2 0-6.4-.5-9.5-1.5c-16.9-5.3-26.3-23.2-21-40.1l29.7-95.2C428.4 156.9 467.6 128 512 128s83.6 28.9 96.8 71.2l29.7 95.2c5.3 16.9-4.1 34.8-21 40.1c-3.2 1-6.4 1.5-9.5 1.5l9 26.9c3.5 10.4-4.3 21.1-15.2 21.1H584v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V384H504v96c0 17.7-14.3 32-32 32s-32-14.3-32-32z"
    ]
};
var $d8206b3ab2e65c05$export$bbf24078bd1f73e6 = {
    prefix: "fas",
    iconName: "j",
    icon: [
        320,
        512,
        [
            106
        ],
        "4a",
        "M288 32c17.7 0 32 14.3 32 32V320c0 88.4-71.6 160-160 160S0 408.4 0 320V288c0-17.7 14.3-32 32-32s32 14.3 32 32v32c0 53 43 96 96 96s96-43 96-96V64c0-17.7 14.3-32 32-32z"
    ]
};
var $d8206b3ab2e65c05$export$72b785dcfe44c69b = {
    prefix: "fas",
    iconName: "users-viewfinder",
    icon: [
        640,
        512,
        [],
        "e595",
        "M48 48h88c13.3 0 24-10.7 24-24s-10.7-24-24-24H32C14.3 0 0 14.3 0 32V136c0 13.3 10.7 24 24 24s24-10.7 24-24V48zM175.8 224a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-26.5 32C119.9 256 96 279.9 96 309.3c0 14.7 11.9 26.7 26.7 26.7h56.1c8-34.1 32.8-61.7 65.2-73.6c-7.5-4.1-16.2-6.4-25.3-6.4H149.3zm368 80c14.7 0 26.7-11.9 26.7-26.7c0-29.5-23.9-53.3-53.3-53.3H421.3c-9.2 0-17.8 2.3-25.3 6.4c32.4 11.9 57.2 39.5 65.2 73.6h56.1zm-89.4 0c-8.6-24.3-29.9-42.6-55.9-47c-3.9-.7-7.9-1-12-1H280c-4.1 0-8.1 .3-12 1c-26 4.4-47.3 22.7-55.9 47c-2.7 7.5-4.1 15.6-4.1 24c0 13.3 10.7 24 24 24H408c13.3 0 24-10.7 24-24c0-8.4-1.4-16.5-4.1-24zM464 224a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-80-32a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM504 48h88v88c0 13.3 10.7 24 24 24s24-10.7 24-24V32c0-17.7-14.3-32-32-32H504c-13.3 0-24 10.7-24 24s10.7 24 24 24zM48 464V376c0-13.3-10.7-24-24-24s-24 10.7-24 24V480c0 17.7 14.3 32 32 32H136c13.3 0 24-10.7 24-24s-10.7-24-24-24H48zm456 0c-13.3 0-24 10.7-24 24s10.7 24 24 24H608c17.7 0 32-14.3 32-32V376c0-13.3-10.7-24-24-24s-24 10.7-24 24v88H504z"
    ]
};
var $d8206b3ab2e65c05$export$b44eb38345c6a964 = {
    prefix: "fas",
    iconName: "file-video",
    icon: [
        384,
        512,
        [],
        "f1c8",
        "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM64 288c0-17.7 14.3-32 32-32h96c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V288zM300.9 397.9L256 368V304l44.9-29.9c2-1.3 4.4-2.1 6.8-2.1c6.8 0 12.3 5.5 12.3 12.3V387.7c0 6.8-5.5 12.3-12.3 12.3c-2.4 0-4.8-.7-6.8-2.1z"
    ]
};
var $d8206b3ab2e65c05$export$c1a3ba061b4f60c4 = {
    prefix: "fas",
    iconName: "up-right-from-square",
    icon: [
        512,
        512,
        [
            "external-link-alt"
        ],
        "f35d",
        "M352 0c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9L370.7 96 201.4 265.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L416 141.3l41.4 41.4c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6V32c0-17.7-14.3-32-32-32H352zM80 32C35.8 32 0 67.8 0 112V432c0 44.2 35.8 80 80 80H400c44.2 0 80-35.8 80-80V320c0-17.7-14.3-32-32-32s-32 14.3-32 32V432c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16H192c17.7 0 32-14.3 32-32s-14.3-32-32-32H80z"
    ]
};
var $d8206b3ab2e65c05$export$d7f107e456ab0306 = $d8206b3ab2e65c05$export$c1a3ba061b4f60c4;
var $d8206b3ab2e65c05$export$c517dffc18db483f = {
    prefix: "fas",
    iconName: "table-cells",
    icon: [
        512,
        512,
        [
            "th"
        ],
        "f00a",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm88 64v64H64V96h88zm56 0h88v64H208V96zm240 0v64H360V96h88zM64 224h88v64H64V224zm232 0v64H208V224h88zm64 0h88v64H360V224zM152 352v64H64V352h88zm56 0h88v64H208V352zm240 0v64H360V352h88z"
    ]
};
var $d8206b3ab2e65c05$export$4d383c83efc0c819 = $d8206b3ab2e65c05$export$c517dffc18db483f;
var $d8206b3ab2e65c05$export$38611f1c776aba73 = {
    prefix: "fas",
    iconName: "file-pdf",
    icon: [
        512,
        512,
        [],
        "f1c1",
        "M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 144-208 0c-35.3 0-64 28.7-64 64l0 144-48 0c-35.3 0-64-28.7-64-64L0 64zm384 64l-128 0L256 0 384 128zM176 352l32 0c30.9 0 56 25.1 56 56s-25.1 56-56 56l-16 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48 0-80c0-8.8 7.2-16 16-16zm32 80c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0 0 48 16 0zm96-80l32 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-32 0c-8.8 0-16-7.2-16-16l0-128c0-8.8 7.2-16 16-16zm32 128c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-16 0 0 96 16 0zm80-112c0-8.8 7.2-16 16-16l48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 32 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64 0-64z"
    ]
};
var $d8206b3ab2e65c05$export$df8194b081d34b27 = {
    prefix: "fas",
    iconName: "book-bible",
    icon: [
        448,
        512,
        [
            "bible"
        ],
        "f647",
        "M96 0C43 0 0 43 0 96V416c0 53 43 96 96 96H384h32c17.7 0 32-14.3 32-32s-14.3-32-32-32V384c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32H384 96zm0 384H352v64H96c-17.7 0-32-14.3-32-32s14.3-32 32-32zM208 80c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272V304c0 8.8-7.2 16-16 16H224c-8.8 0-16-7.2-16-16V192H160c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16h48V80z"
    ]
};
var $d8206b3ab2e65c05$export$2eac809b0670d139 = $d8206b3ab2e65c05$export$df8194b081d34b27;
var $d8206b3ab2e65c05$export$9db87eabf605857e = {
    prefix: "fas",
    iconName: "o",
    icon: [
        448,
        512,
        [
            111
        ],
        "4f",
        "M224 96a160 160 0 1 0 0 320 160 160 0 1 0 0-320zM448 256A224 224 0 1 1 0 256a224 224 0 1 1 448 0z"
    ]
};
var $d8206b3ab2e65c05$export$25ea11267429d202 = {
    prefix: "fas",
    iconName: "suitcase-medical",
    icon: [
        512,
        512,
        [
            "medkit"
        ],
        "f0fa",
        "M184 48H328c4.4 0 8 3.6 8 8V96H176V56c0-4.4 3.6-8 8-8zm-56 8V96v32V480H384V128 96 56c0-30.9-25.1-56-56-56H184c-30.9 0-56 25.1-56 56zM96 96H64C28.7 96 0 124.7 0 160V416c0 35.3 28.7 64 64 64H96V96zM416 480h32c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H416V480zM224 208c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H288v48c0 8.8-7.2 16-16 16H240c-8.8 0-16-7.2-16-16V320H176c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16h48V208z"
    ]
};
var $d8206b3ab2e65c05$export$e75f02bae5b7d34b = $d8206b3ab2e65c05$export$25ea11267429d202;
var $d8206b3ab2e65c05$export$597826232327559b = {
    prefix: "fas",
    iconName: "user-secret",
    icon: [
        448,
        512,
        [
            128373
        ],
        "f21b",
        "M224 16c-6.7 0-10.8-2.8-15.5-6.1C201.9 5.4 194 0 176 0c-30.5 0-52 43.7-66 89.4C62.7 98.1 32 112.2 32 128c0 14.3 25 27.1 64.6 35.9c-.4 4-.6 8-.6 12.1c0 17 3.3 33.2 9.3 48H45.4C38 224 32 230 32 237.4c0 1.7 .3 3.4 1 5l38.8 96.9C28.2 371.8 0 423.8 0 482.3C0 498.7 13.3 512 29.7 512H418.3c16.4 0 29.7-13.3 29.7-29.7c0-58.5-28.2-110.4-71.7-143L415 242.4c.6-1.6 1-3.3 1-5c0-7.4-6-13.4-13.4-13.4H342.7c6-14.8 9.3-31 9.3-48c0-4.1-.2-8.1-.6-12.1C391 155.1 416 142.3 416 128c0-15.8-30.7-29.9-78-38.6C324 43.7 302.5 0 272 0c-18 0-25.9 5.4-32.5 9.9c-4.8 3.3-8.8 6.1-15.5 6.1zm56 208H267.6c-16.5 0-31.1-10.6-36.3-26.2c-2.3-7-12.2-7-14.5 0c-5.2 15.6-19.9 26.2-36.3 26.2H168c-22.1 0-40-17.9-40-40V169.6c28.2 4.1 61 6.4 96 6.4s67.8-2.3 96-6.4V184c0 22.1-17.9 40-40 40zm-88 96l16 32L176 480 128 288l64 32zm128-32L272 480 240 352l16-32 64-32z"
    ]
};
var $d8206b3ab2e65c05$export$743cce3ca4eb1d7d = {
    prefix: "fas",
    iconName: "otter",
    icon: [
        640,
        512,
        [
            129446
        ],
        "f700",
        "M181.5 197.1l12.9 6.4c5.9 3 12.4 4.5 19.1 4.5c23.5 0 42.6-19.1 42.6-42.6V144c0-35.3-28.7-64-64-64H128c-35.3 0-64 28.7-64 64v21.4c0 23.5 19.1 42.6 42.6 42.6c6.6 0 13.1-1.5 19.1-4.5l12.9-6.4 8.4-4.2L135.1 185c-4.5-3-7.1-8-7.1-13.3V168c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24v3.7c0 5.3-2.7 10.3-7.1 13.3l-11.8 7.9 8.4 4.2zm-8.6 49.4L160 240l-12.9 6.4c-12.6 6.3-26.5 9.6-40.5 9.6c-3.6 0-7.1-.2-10.6-.6v.6c0 35.3 28.7 64 64 64h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H384V336 320c0-23.7 12.9-44.4 32-55.4c9.4-5.4 20.3-8.6 32-8.6V240c0-26.5 21.5-48 48-48c8.8 0 16 7.2 16 16v32 16 48c0 8.8 7.2 16 16 16s16-7.2 16-16V204.3c0-48.2-30.8-91-76.6-106.3l-8.5-2.8c-8-2.7-12.6-11.1-10.4-19.3s10.3-13.2 18.6-11.6l19.9 4C576 86.1 640 164.2 640 254.9l0 1.1h0c0 123.7-100.3 224-224 224h-1.1H256h-.6C132 480 32 380 32 256.6V256 216.8c-10.1-14.6-16-32.3-16-51.4V144l0-1.4C6.7 139.3 0 130.5 0 120c0-13.3 10.7-24 24-24h2.8C44.8 58.2 83.3 32 128 32h64c44.7 0 83.2 26.2 101.2 64H296c13.3 0 24 10.7 24 24c0 10.5-6.7 19.3-16 22.6l0 1.4v21.4c0 1.4 0 2.8-.1 4.3c12-6.2 25.7-9.6 40.1-9.6h8c17.7 0 32 14.3 32 32s-14.3 32-32 32h-8c-13.3 0-24 10.7-24 24v8h56.4c-15.2 17-24.4 39.4-24.4 64H320c-42.3 0-78.2-27.4-91-65.3c-5.1 .9-10.3 1.3-15.6 1.3c-14.1 0-27.9-3.3-40.5-9.6zM96 128a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm112 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"
    ]
};
var $d8206b3ab2e65c05$export$27f7383b96c3f4b4 = {
    prefix: "fas",
    iconName: "person-dress",
    icon: [
        320,
        512,
        [
            "female"
        ],
        "f182",
        "M160 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM88 384H70.2c-10.9 0-18.6-10.7-15.2-21.1L93.3 248.1 59.4 304.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l53.6-89.2c20.3-33.7 56.7-54.3 96-54.3h11.6c39.3 0 75.7 20.6 96 54.3l53.6 89.2c9.1 15.1 4.2 34.8-10.9 43.9s-34.8 4.2-43.9-10.9l-33.9-56.3L265 362.9c3.5 10.4-4.3 21.1-15.2 21.1H232v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V384H152v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V384z"
    ]
};
var $d8206b3ab2e65c05$export$70e8e75e61dd7169 = $d8206b3ab2e65c05$export$27f7383b96c3f4b4;
var $d8206b3ab2e65c05$export$7a088030853df12c = {
    prefix: "fas",
    iconName: "comment-dollar",
    icon: [
        512,
        512,
        [],
        "f651",
        "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zm20-312v13.9c7.5 1.2 14.6 2.9 21.1 4.7c10.7 2.8 17 13.8 14.2 24.5s-13.8 17-24.5 14.2c-11-2.9-21.6-5-31.2-5.2c-7.9-.1-16 1.8-21.5 5c-4.8 2.8-6.2 5.6-6.2 9.3c0 1.8 .1 3.5 5.3 6.7c6.3 3.8 15.5 6.7 28.3 10.5l.7 .2c11.2 3.4 25.6 7.7 37.1 15c12.9 8.1 24.3 21.3 24.6 41.6c.3 20.9-10.5 36.1-24.8 45c-7.2 4.5-15.2 7.3-23.2 9V344c0 11-9 20-20 20s-20-9-20-20V329.4c-10.3-2.2-20-5.5-28.2-8.4l0 0 0 0c-2.1-.7-4.1-1.4-6.1-2.1c-10.5-3.5-16.1-14.8-12.6-25.3s14.8-16.1 25.3-12.6c2.5 .8 4.9 1.7 7.2 2.4c13.6 4.6 24 8.1 35.1 8.5c8.6 .3 16.5-1.6 21.4-4.7c4.1-2.5 6-5.5 5.9-10.5c0-2.9-.8-5-5.9-8.2c-6.3-4-15.4-6.9-28-10.7l-1.7-.5c-10.9-3.3-24.6-7.4-35.6-14c-12.7-7.7-24.6-20.5-24.7-40.7c-.1-21.1 11.8-35.7 25.8-43.9c6.9-4.1 14.5-6.8 22.2-8.5V136c0-11 9-20 20-20s20 9 20 20z"
    ]
};
var $d8206b3ab2e65c05$export$694b7e88782dec12 = {
    prefix: "fas",
    iconName: "business-time",
    icon: [
        640,
        512,
        [
            "briefcase-clock"
        ],
        "f64a",
        "M184 48H328c4.4 0 8 3.6 8 8V96H176V56c0-4.4 3.6-8 8-8zm-56 8V96H64C28.7 96 0 124.7 0 160v96H192 352h8.2c32.3-39.1 81.1-64 135.8-64c5.4 0 10.7 .2 16 .7V160c0-35.3-28.7-64-64-64H384V56c0-30.9-25.1-56-56-56H184c-30.9 0-56 25.1-56 56zM320 352H224c-17.7 0-32-14.3-32-32V288H0V416c0 35.3 28.7 64 64 64H360.2C335.1 449.6 320 410.5 320 368c0-5.4 .2-10.7 .7-16l-.7 0zm320 16a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM496 288c8.8 0 16 7.2 16 16v48h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H496c-8.8 0-16-7.2-16-16V304c0-8.8 7.2-16 16-16z"
    ]
};
var $d8206b3ab2e65c05$export$8b00ae94743552ce = $d8206b3ab2e65c05$export$694b7e88782dec12;
var $d8206b3ab2e65c05$export$d2bcaf492dfb3817 = {
    prefix: "fas",
    iconName: "table-cells-large",
    icon: [
        512,
        512,
        [
            "th-large"
        ],
        "f009",
        "M448 96V224H288V96H448zm0 192V416H288V288H448zM224 224H64V96H224V224zM64 288H224V416H64V288zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64z"
    ]
};
var $d8206b3ab2e65c05$export$69782f333e90cdc6 = $d8206b3ab2e65c05$export$d2bcaf492dfb3817;
var $d8206b3ab2e65c05$export$24c764717169f536 = {
    prefix: "fas",
    iconName: "book-tanakh",
    icon: [
        448,
        512,
        [
            "tanakh"
        ],
        "f827",
        "M352 0c53 0 96 43 96 96V416c0 53-43 96-96 96H64 32c-17.7 0-32-14.3-32-32s14.3-32 32-32V384c-17.7 0-32-14.3-32-32V32C0 14.3 14.3 0 32 0H64 352zm0 384H96v64H352c17.7 0 32-14.3 32-32s-14.3-32-32-32zM138.7 208l13.9 24H124.9l13.9-24zm-13.9-24L97.1 232c-6.2 10.7 1.5 24 13.9 24h55.4l27.7 48c6.2 10.7 21.6 10.7 27.7 0l27.7-48H305c12.3 0 20-13.3 13.9-24l-27.7-48 27.7-48c6.2-10.7-1.5-24-13.9-24H249.6L221.9 64c-6.2-10.7-21.6-10.7-27.7 0l-27.7 48H111c-12.3 0-20 13.3-13.9 24l27.7 48zm27.7 0l27.7-48h55.4l27.7 48-27.7 48H180.3l-27.7-48zm0-48l-13.9 24-13.9-24h27.7zm41.6-24L208 88l13.9 24H194.1zm69.3 24h27.7l-13.9 24-13.9-24zm13.9 72l13.9 24H263.4l13.9-24zm-55.4 48L208 280l-13.9-24h27.7z"
    ]
};
var $d8206b3ab2e65c05$export$7fd4a58929315448 = $d8206b3ab2e65c05$export$24c764717169f536;
var $d8206b3ab2e65c05$export$c377f240bb8b5d74 = {
    prefix: "fas",
    iconName: "phone-volume",
    icon: [
        512,
        512,
        [
            "volume-control-phone"
        ],
        "f2a0",
        "M280 0C408.1 0 512 103.9 512 232c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-101.6-82.4-184-184-184c-13.3 0-24-10.7-24-24s10.7-24 24-24zm8 192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-32-72c0-13.3 10.7-24 24-24c75.1 0 136 60.9 136 136c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-48.6-39.4-88-88-88c-13.3 0-24-10.7-24-24zM117.5 1.4c19.4-5.3 39.7 4.6 47.4 23.2l40 96c6.8 16.3 2.1 35.2-11.6 46.3L144 207.3c33.3 70.4 90.3 127.4 160.7 160.7L345 318.7c11.2-13.7 30-18.4 46.3-11.6l96 40c18.6 7.7 28.5 28 23.2 47.4l-24 88C481.8 499.9 466 512 448 512C200.6 512 0 311.4 0 64C0 46 12.1 30.2 29.5 25.4l88-24z"
    ]
};
var $d8206b3ab2e65c05$export$5358d004fa3d3be2 = $d8206b3ab2e65c05$export$c377f240bb8b5d74;
var $d8206b3ab2e65c05$export$ab6f71fd6878da90 = {
    prefix: "fas",
    iconName: "hat-cowboy-side",
    icon: [
        640,
        512,
        [],
        "f8c1",
        "M152.7 135.9l-10.4 57.2c6.8-.7 13.6-1.1 20.5-1.1h10.7c39.4 0 77.8 12.1 110.1 34.7L562.4 421.8l35.1 24.6c24.4-6 42.5-28.1 42.5-54.4c0-75.8-94.7-126.6-134.6-144.7L474 83.9C468.2 53.8 441.8 32 411.1 32h-2.7c-5.6 0-11.1 .7-16.5 2.2L199.2 85.5c-23.9 6.4-42 26-46.5 50.4zM0 384c0 35.3 28.7 64 64 64H544L265.3 252.9c-26.9-18.8-58.9-28.9-91.8-28.9H162.9c-60.6 0-116 34.2-143.1 88.4L13.5 325C4.6 342.7 0 362.3 0 382.2V384z"
    ]
};
var $d8206b3ab2e65c05$export$1204f2d171424659 = {
    prefix: "fas",
    iconName: "clipboard-user",
    icon: [
        384,
        512,
        [],
        "f7f3",
        "M192 0c-41.8 0-77.4 26.7-90.5 64H64C28.7 64 0 92.7 0 128V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H282.5C269.4 26.7 233.8 0 192 0zm0 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM128 256a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM80 432c0-44.2 35.8-80 80-80h64c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16z"
    ]
};
var $d8206b3ab2e65c05$export$60b41e3581d1739a = {
    prefix: "fas",
    iconName: "child",
    icon: [
        320,
        512,
        [],
        "f1ae",
        "M96 64a64 64 0 1 1 128 0A64 64 0 1 1 96 64zm48 320v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V287.8L59.1 321c-9.4 15-29.2 19.4-44.1 10S-4.5 301.9 4.9 287l39.9-63.3C69.7 184 113.2 160 160 160s90.3 24 115.2 63.6L315.1 287c9.4 15 4.9 34.7-10 44.1s-34.7 4.9-44.1-10L240 287.8V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V384H144z"
    ]
};
var $d8206b3ab2e65c05$export$f0f37dbc60110b10 = {
    prefix: "fas",
    iconName: "lira-sign",
    icon: [
        320,
        512,
        [
            8356
        ],
        "f195",
        "M112 160.4c0-35.5 28.8-64.4 64.4-64.4c6.9 0 13.8 1.1 20.4 3.3l81.2 27.1c16.8 5.6 34.9-3.5 40.5-20.2s-3.5-34.9-20.2-40.5L217 38.6c-13.1-4.4-26.8-6.6-40.6-6.6C105.5 32 48 89.5 48 160.4V192H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H48v32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H46c-2.2 10.5-6.1 20.6-11.7 29.9L4.6 431.5c-5.9 9.9-6.1 22.2-.4 32.2S20.5 480 32 480H288c17.7 0 32-14.3 32-32s-14.3-32-32-32H88.5l.7-1.1c11.6-19.3 18.9-40.7 21.6-62.9H224c17.7 0 32-14.3 32-32s-14.3-32-32-32H112V256H224c17.7 0 32-14.3 32-32s-14.3-32-32-32H112V160.4z"
    ]
};
var $d8206b3ab2e65c05$export$da3f1730d013e224 = {
    prefix: "fas",
    iconName: "satellite",
    icon: [
        512,
        512,
        [
            128752
        ],
        "f7bf",
        "M233 7c-9.4-9.4-24.6-9.4-33.9 0l-96 96c-9.4 9.4-9.4 24.6 0 33.9l89.4 89.4-15.5 15.5C152.3 230.4 124.9 224 96 224c-31.7 0-61.5 7.7-87.8 21.2c-9 4.7-10.3 16.7-3.1 23.8L112.7 376.7 96.3 393.1c-2.6-.7-5.4-1.1-8.3-1.1c-17.7 0-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32c0-2.9-.4-5.6-1.1-8.3l16.4-16.4L242.9 506.9c7.2 7.2 19.2 5.9 23.8-3.1C280.3 477.5 288 447.7 288 416c0-28.9-6.4-56.3-17.8-80.9l15.5-15.5L375 409c9.4 9.4 24.6 9.4 33.9 0l96-96c9.4-9.4 9.4-24.6 0-33.9l-89.4-89.4 55-55c12.5-12.5 12.5-32.8 0-45.3l-48-48c-12.5-12.5-32.8-12.5-45.3 0l-55 55L233 7zm159 351l-72.4-72.4 62.1-62.1L454.1 296 392 358.1zM226.3 192.4L153.9 120 216 57.9l72.4 72.4-62.1 62.1z"
    ]
};
var $d8206b3ab2e65c05$export$1125ac57be52258c = {
    prefix: "fas",
    iconName: "plane-lock",
    icon: [
        640,
        512,
        [],
        "e558",
        "M192 93.7C192 59.5 221 0 256 0c36 0 64 59.5 64 93.7v84.6l101.8 58.2C418 247.6 416 259.6 416 272v24.6c-17.9 10.4-30.3 29.1-31.8 50.9L320 329.1V400l57.6 43.2c4 3 6.4 7.8 6.4 12.8v24 18c0 7.8-6.3 14-14 14c-1.3 0-2.6-.2-3.9-.5L256 480 145.9 511.5c-1.3 .4-2.6 .5-3.9 .5c-7.8 0-14-6.3-14-14V456c0-5 2.4-9.8 6.4-12.8L192 400l0-70.9-171.6 49C10.2 381.1 0 373.4 0 362.8V297.3c0-5.7 3.1-11 8.1-13.9L192 178.3V93.7zM528 240c-17.7 0-32 14.3-32 32v48h64V272c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80v48c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32V272z"
    ]
};
var $d8206b3ab2e65c05$export$cb61f447f29887e = {
    prefix: "fas",
    iconName: "tag",
    icon: [
        448,
        512,
        [
            127991
        ],
        "f02b",
        "M0 80V229.5c0 17 6.7 33.3 18.7 45.3l176 176c25 25 65.5 25 90.5 0L418.7 317.3c25-25 25-65.5 0-90.5l-176-176c-12-12-28.3-18.7-45.3-18.7H48C21.5 32 0 53.5 0 80zm112 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $d8206b3ab2e65c05$export$805cd88398a70581 = {
    prefix: "fas",
    iconName: "comment",
    icon: [
        512,
        512,
        [
            128489,
            61669
        ],
        "f075",
        "M512 240c0 114.9-114.6 208-256 208c-37.1 0-72.3-6.4-104.1-17.9c-11.9 8.7-31.3 20.6-54.3 30.6C73.6 471.1 44.7 480 16 480c-6.5 0-12.3-3.9-14.8-9.9c-2.5-6-1.1-12.8 3.4-17.4l0 0 0 0 0 0 0 0 .3-.3c.3-.3 .7-.7 1.3-1.4c1.1-1.2 2.8-3.1 4.9-5.7c4.1-5 9.6-12.4 15.2-21.6c10-16.6 19.5-38.4 21.4-62.9C17.7 326.8 0 285.1 0 240C0 125.1 114.6 32 256 32s256 93.1 256 208z"
    ]
};
var $d8206b3ab2e65c05$export$e4019fe302a972e1 = {
    prefix: "fas",
    iconName: "cake-candles",
    icon: [
        448,
        512,
        [
            127874,
            "birthday-cake",
            "cake"
        ],
        "f1fd",
        "M86.4 5.5L61.8 47.6C58 54.1 56 61.6 56 69.2V72c0 22.1 17.9 40 40 40s40-17.9 40-40V69.2c0-7.6-2-15-5.8-21.6L105.6 5.5C103.6 2.1 100 0 96 0s-7.6 2.1-9.6 5.5zm128 0L189.8 47.6c-3.8 6.5-5.8 14-5.8 21.6V72c0 22.1 17.9 40 40 40s40-17.9 40-40V69.2c0-7.6-2-15-5.8-21.6L233.6 5.5C231.6 2.1 228 0 224 0s-7.6 2.1-9.6 5.5zM317.8 47.6c-3.8 6.5-5.8 14-5.8 21.6V72c0 22.1 17.9 40 40 40s40-17.9 40-40V69.2c0-7.6-2-15-5.8-21.6L361.6 5.5C359.6 2.1 356 0 352 0s-7.6 2.1-9.6 5.5L317.8 47.6zM128 176c0-17.7-14.3-32-32-32s-32 14.3-32 32v48c-35.3 0-64 28.7-64 64v71c8.3 5.2 18.1 9 28.8 9c13.5 0 27.2-6.1 38.4-13.4c5.4-3.5 9.9-7.1 13-9.7c1.5-1.3 2.7-2.4 3.5-3.1c.4-.4 .7-.6 .8-.8l.1-.1 0 0 0 0s0 0 0 0s0 0 0 0c3.1-3.2 7.4-4.9 11.9-4.8s8.6 2.1 11.6 5.4l0 0 0 0 .1 .1c.1 .1 .4 .4 .7 .7c.7 .7 1.7 1.7 3.1 3c2.8 2.6 6.8 6.1 11.8 9.5c10.2 7.1 23 13.1 36.3 13.1s26.1-6 36.3-13.1c5-3.5 9-6.9 11.8-9.5c1.4-1.3 2.4-2.3 3.1-3c.3-.3 .6-.6 .7-.7l.1-.1c3-3.5 7.4-5.4 12-5.4s9 2 12 5.4l.1 .1c.1 .1 .4 .4 .7 .7c.7 .7 1.7 1.7 3.1 3c2.8 2.6 6.8 6.1 11.8 9.5c10.2 7.1 23 13.1 36.3 13.1s26.1-6 36.3-13.1c5-3.5 9-6.9 11.8-9.5c1.4-1.3 2.4-2.3 3.1-3c.3-.3 .6-.6 .7-.7l.1-.1c2.9-3.4 7.1-5.3 11.6-5.4s8.7 1.6 11.9 4.8l0 0 0 0 0 0 .1 .1c.2 .2 .4 .4 .8 .8c.8 .7 1.9 1.8 3.5 3.1c3.1 2.6 7.5 6.2 13 9.7c11.2 7.3 24.9 13.4 38.4 13.4c10.7 0 20.5-3.9 28.8-9V288c0-35.3-28.7-64-64-64V176c0-17.7-14.3-32-32-32s-32 14.3-32 32v48H256V176c0-17.7-14.3-32-32-32s-32 14.3-32 32v48H128V176zM448 394.6c-8.5 3.3-18.2 5.4-28.8 5.4c-22.5 0-42.4-9.9-55.8-18.6c-4.1-2.7-7.8-5.4-10.9-7.8c-2.8 2.4-6.1 5-9.8 7.5C329.8 390 310.6 400 288 400s-41.8-10-54.6-18.9c-3.5-2.4-6.7-4.9-9.4-7.2c-2.7 2.3-5.9 4.7-9.4 7.2C201.8 390 182.6 400 160 400s-41.8-10-54.6-18.9c-3.7-2.6-7-5.2-9.8-7.5c-3.1 2.4-6.8 5.1-10.9 7.8C71.2 390.1 51.3 400 28.8 400c-10.6 0-20.3-2.2-28.8-5.4V480c0 17.7 14.3 32 32 32H416c17.7 0 32-14.3 32-32V394.6z"
    ]
};
var $d8206b3ab2e65c05$export$bdcf98f725a7241a = $d8206b3ab2e65c05$export$e4019fe302a972e1;
var $d8206b3ab2e65c05$export$707bc1c80c0177c1 = $d8206b3ab2e65c05$export$e4019fe302a972e1;
var $d8206b3ab2e65c05$export$6f095630677adc = {
    prefix: "fas",
    iconName: "envelope",
    icon: [
        512,
        512,
        [
            128386,
            9993,
            61443
        ],
        "f0e0",
        "M48 64C21.5 64 0 85.5 0 112c0 15.1 7.1 29.3 19.2 38.4L236.8 313.6c11.4 8.5 27 8.5 38.4 0L492.8 150.4c12.1-9.1 19.2-23.3 19.2-38.4c0-26.5-21.5-48-48-48H48zM0 176V384c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V176L294.4 339.2c-22.8 17.1-54 17.1-76.8 0L0 176z"
    ]
};
var $d8206b3ab2e65c05$export$152ef92a4f9d80a7 = {
    prefix: "fas",
    iconName: "angles-up",
    icon: [
        448,
        512,
        [
            "angle-double-up"
        ],
        "f102",
        "M246.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-160 160c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L224 109.3 361.4 246.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-160-160zm160 352l-160-160c-12.5-12.5-32.8-12.5-45.3 0l-160 160c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L224 301.3 361.4 438.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3z"
    ]
};
var $d8206b3ab2e65c05$export$9bb51e1a2c07db7c = $d8206b3ab2e65c05$export$152ef92a4f9d80a7;
var $d8206b3ab2e65c05$export$4b24ca1552f410af = {
    prefix: "fas",
    iconName: "paperclip",
    icon: [
        448,
        512,
        [
            128206
        ],
        "f0c6",
        "M364.2 83.8c-24.4-24.4-64-24.4-88.4 0l-184 184c-42.1 42.1-42.1 110.3 0 152.4s110.3 42.1 152.4 0l152-152c10.9-10.9 28.7-10.9 39.6 0s10.9 28.7 0 39.6l-152 152c-64 64-167.6 64-231.6 0s-64-167.6 0-231.6l184-184c46.3-46.3 121.3-46.3 167.6 0s46.3 121.3 0 167.6l-176 176c-28.6 28.6-75 28.6-103.6 0s-28.6-75 0-103.6l144-144c10.9-10.9 28.7-10.9 39.6 0s10.9 28.7 0 39.6l-144 144c-6.7 6.7-6.7 17.7 0 24.4s17.7 6.7 24.4 0l176-176c24.4-24.4 24.4-64 0-88.4z"
    ]
};
var $d8206b3ab2e65c05$export$e201217e5046cd15 = {
    prefix: "fas",
    iconName: "arrow-right-to-city",
    icon: [
        640,
        512,
        [],
        "e4b3",
        "M288 48c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48V192h40V120c0-13.3 10.7-24 24-24s24 10.7 24 24v72h24c26.5 0 48 21.5 48 48V464c0 26.5-21.5 48-48 48H432 336c-26.5 0-48-21.5-48-48V48zm64 32v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16zm16 80c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V176c0-8.8-7.2-16-16-16H368zM352 272v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16zm176-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H528zM512 368v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16H528c-8.8 0-16 7.2-16 16zM166.6 153.4l80 80c12.5 12.5 12.5 32.8 0 45.3l-80 80c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L146.7 288H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H146.7l-25.4-25.4c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0z"
    ]
};
var $d8206b3ab2e65c05$export$838459d11f3971df = {
    prefix: "fas",
    iconName: "ribbon",
    icon: [
        448,
        512,
        [
            127895
        ],
        "f4d6",
        "M333.2 322.8l0 0-133.9-146 0 0L146 118.6c7.8-5.1 37-22.6 78-22.6s70.2 17.4 78 22.6L245.7 180l85.6 93.4 27.4-29.8c16.3-17.7 25.3-40.9 25.3-65V149.1c0-19-5.6-37.5-16.1-53.3L327.8 35.6C312.9 13.4 287.9 0 261.2 0h-76c-25.8 0-50.1 12.5-65.1 33.5L81.9 87C70.3 103.2 64 122.8 64 142.8V164c0 23.2 8.4 45.6 23.6 63.1l56 64.2 0 0 83.3 95.6 0 0 91.8 105.3c10 11.5 26.8 14.3 40 6.8l54.5-31.1c17.8-10.2 21.6-34.3 7.7-49.4l-87.7-95.7zM205.2 410.6l-83.3-95.6L27.1 418.5c-13.9 15.1-10.1 39.2 7.7 49.4l55.1 31.5c13 7.4 29.3 4.9 39.4-6.1l75.9-82.6z"
    ]
};
var $d8206b3ab2e65c05$export$ba9b387e84727819 = {
    prefix: "fas",
    iconName: "lungs",
    icon: [
        640,
        512,
        [
            129729
        ],
        "f604",
        "M320 0c17.7 0 32 14.3 32 32V164.1c0 16.4 8.4 31.7 22.2 40.5l9.8 6.2V165.3C384 127 415 96 453.3 96c21.7 0 42.8 10.2 55.8 28.8c15.4 22.1 44.3 65.4 71 116.9c26.5 50.9 52.4 112.5 59.6 170.3c.2 1.3 .2 2.6 .2 4v7c0 49.1-39.8 89-89 89c-7.3 0-14.5-.9-21.6-2.7l-72.7-18.2C414 480.5 384 442.1 384 398V325l90.5 57.6c7.5 4.7 17.3 2.5 22.1-4.9s2.5-17.3-4.9-22.1L384 287.1v-.4l-44.1-28.1c-7.3-4.6-13.9-10.1-19.9-16.1c-5.9 6-12.6 11.5-19.9 16.1L256 286.7 161.2 347l-13.5 8.6c0 0 0 0-.1 0c-7.4 4.8-9.6 14.6-4.8 22.1c4.7 7.5 14.6 9.7 22.1 4.9l91.1-58V398c0 44.1-30 82.5-72.7 93.1l-72.7 18.2c-7.1 1.8-14.3 2.7-21.6 2.7c-49.1 0-89-39.8-89-89v-7c0-1.3 .1-2.7 .2-4c7.2-57.9 33.1-119.4 59.6-170.3c26.8-51.5 55.6-94.8 71-116.9c13-18.6 34-28.8 55.8-28.8C225 96 256 127 256 165.3v45.5l9.8-6.2c13.8-8.8 22.2-24.1 22.2-40.5V32c0-17.7 14.3-32 32-32z"
    ]
};
var $d8206b3ab2e65c05$export$25218e5886296cb9 = {
    prefix: "fas",
    iconName: "arrow-up-9-1",
    icon: [
        576,
        512,
        [
            "sort-numeric-up-alt"
        ],
        "f887",
        "M160 32c9 0 17.5 3.8 23.6 10.4l88 96c11.9 13 11.1 33.3-2 45.2s-33.3 11.1-45.2-2L192 146.3V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V146.3L95.6 181.6c-11.9 13-32.2 13.9-45.2 2s-13.9-32.2-2-45.2l88-96C142.5 35.8 151 32 160 32zM450.7 294c8.3 6 13.3 15.7 13.3 26v96h16c17.7 0 32 14.3 32 32s-14.3 32-32 32H432 384c-17.7 0-32-14.3-32-32s14.3-32 32-32h16V364.4l-5.9 2c-16.8 5.6-34.9-3.5-40.5-20.2s3.5-34.9 20.2-40.5l48-16c9.8-3.3 20.5-1.6 28.8 4.4zm-5-145.1A32 32 0 1 0 418.3 91a32 32 0 1 0 27.4 57.9zm-40.7 54.9C369.6 192.4 344 159.2 344 120c0-48.6 39.4-88 88-88s88 39.4 88 88c0 23.5-7.5 46.3-21.5 65.2L449.7 251c-10.5 14.2-30.6 17.2-44.8 6.7s-17.2-30.6-6.7-44.8l6.8-9.2z"
    ]
};
var $d8206b3ab2e65c05$export$d41859f1bbb9e086 = $d8206b3ab2e65c05$export$25218e5886296cb9;
var $d8206b3ab2e65c05$export$4a157bd81dcd8d80 = {
    prefix: "fas",
    iconName: "litecoin-sign",
    icon: [
        384,
        512,
        [],
        "e1d3",
        "M128 64c0-17.7-14.3-32-32-32S64 46.3 64 64V213.6L23.2 225.2c-17 4.9-26.8 22.6-22 39.6s22.6 26.8 39.6 22L64 280.1V448c0 17.7 14.3 32 32 32H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H128V261.9l136.8-39.1c17-4.9 26.8-22.6 22-39.6s-22.6-26.8-39.6-22L128 195.3V64z"
    ]
};
var $d8206b3ab2e65c05$export$2b488402ec335d97 = {
    prefix: "fas",
    iconName: "border-none",
    icon: [
        448,
        512,
        [],
        "f850",
        "M32 480a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm96-64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0-384a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 256a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM320 416a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0-320a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM224 480a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0-448a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 256a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM416 416a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0-384a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM32 96a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM416 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM32 288a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm192 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm192 64a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM32 320a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM416 192a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM32 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm192 64a32 32 0 1 1 0-64 32 32 0 1 1 0 64z"
    ]
};
var $d8206b3ab2e65c05$export$de462dd5a18e80d4 = {
    prefix: "fas",
    iconName: "circle-nodes",
    icon: [
        512,
        512,
        [],
        "e4e2",
        "M418.4 157.9c35.3-8.3 61.6-40 61.6-77.9c0-44.2-35.8-80-80-80c-43.4 0-78.7 34.5-80 77.5L136.2 151.1C121.7 136.8 101.9 128 80 128c-44.2 0-80 35.8-80 80s35.8 80 80 80c12.2 0 23.8-2.7 34.1-7.6L259.7 407.8c-2.4 7.6-3.7 15.8-3.7 24.2c0 44.2 35.8 80 80 80s80-35.8 80-80c0-27.7-14-52.1-35.4-66.4l37.8-207.7zM156.3 232.2c2.2-6.9 3.5-14.2 3.7-21.7l183.8-73.5c3.6 3.5 7.4 6.7 11.6 9.5L317.6 354.1c-5.5 1.3-10.8 3.1-15.8 5.5L156.3 232.2z"
    ]
};
var $d8206b3ab2e65c05$export$ca9e3368f1d9500a = {
    prefix: "fas",
    iconName: "parachute-box",
    icon: [
        512,
        512,
        [],
        "f4cd",
        "M383.5 192c.3-5.3 .5-10.6 .5-16c0-51-15.9-96-40.2-127.6C319.5 16.9 288.2 0 256 0s-63.5 16.9-87.8 48.4C143.9 80 128 125 128 176c0 5.4 .2 10.7 .5 16H240V320H208c-7 0-13.7 1.5-19.7 4.2L68.2 192H96.5c-.3-5.3-.5-10.6-.5-16c0-64 22.2-121.2 57.1-159.3C62 49.3 18.6 122.6 4.2 173.6C1.5 183.1 9 192 18.9 192h6L165.2 346.3c-3.3 6.5-5.2 13.9-5.2 21.7v96c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V368c0-7.8-1.9-15.2-5.2-21.7L487.1 192h6c9.9 0 17.4-8.9 14.7-18.4C493.4 122.6 450 49.3 358.9 16.7C393.8 54.8 416 112.1 416 176c0 5.4-.2 10.7-.5 16h28.3L323.7 324.2c-6-2.7-12.7-4.2-19.7-4.2H272V192H383.5z"
    ]
};
var $d8206b3ab2e65c05$export$318208bc30aeebcc = {
    prefix: "fas",
    iconName: "indent",
    icon: [
        448,
        512,
        [],
        "f03c",
        "M0 64C0 46.3 14.3 32 32 32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64zM192 192c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32zm32 96H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32s14.3-32 32-32zM0 448c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zM127.8 268.6L25.8 347.9C15.3 356.1 0 348.6 0 335.3V176.7c0-13.3 15.3-20.8 25.8-12.6l101.9 79.3c8.2 6.4 8.2 18.9 0 25.3z"
    ]
};
var $d8206b3ab2e65c05$export$40cb0a4a3a74dc03 = {
    prefix: "fas",
    iconName: "truck-field-un",
    icon: [
        640,
        512,
        [],
        "e58e",
        "M96 32C60.7 32 32 60.7 32 96v32c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32v32c-17.7 0-32 14.3-32 32s14.3 32 32 32H64c0 53 43 96 96 96s96-43 96-96H384c0 53 43 96 96 96s96-43 96-96h32c17.7 0 32-14.3 32-32s-14.3-32-32-32V288c0-35.3-28.7-64-64-64h-4.2c-.4-1.1-.9-2.1-1.3-3.2L485.7 102c-10.3-23.1-33.2-38-58.5-38H375.4C364.4 44.9 343.7 32 320 32H96zm288 96h43.2l42.7 96H384V128zM112 384a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm368-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM253.3 135.1l34.7 52V144c0-8.8 7.2-16 16-16s16 7.2 16 16v96c0 7.1-4.6 13.3-11.4 15.3s-14-.6-17.9-6.4l-34.7-52V240c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-7.1 4.6-13.3 11.4-15.3s14 .6 17.9 6.4zM128 144v64c0 8.8 7.2 16 16 16s16-7.2 16-16V144c0-8.8 7.2-16 16-16s16 7.2 16 16v64c0 26.5-21.5 48-48 48s-48-21.5-48-48V144c0-8.8 7.2-16 16-16s16 7.2 16 16z"
    ]
};
var $d8206b3ab2e65c05$export$b9098a890f61e022 = {
    prefix: "fas",
    iconName: "hourglass",
    icon: [
        384,
        512,
        [
            9203,
            62032,
            "hourglass-empty"
        ],
        "f254",
        "M0 32C0 14.3 14.3 0 32 0H64 320h32c17.7 0 32 14.3 32 32s-14.3 32-32 32V75c0 42.4-16.9 83.1-46.9 113.1L237.3 256l67.9 67.9c30 30 46.9 70.7 46.9 113.1v11c17.7 0 32 14.3 32 32s-14.3 32-32 32H320 64 32c-17.7 0-32-14.3-32-32s14.3-32 32-32V437c0-42.4 16.9-83.1 46.9-113.1L146.7 256 78.9 188.1C48.9 158.1 32 117.4 32 75V64C14.3 64 0 49.7 0 32zM96 64V75c0 25.5 10.1 49.9 28.1 67.9L192 210.7l67.9-67.9c18-18 28.1-42.4 28.1-67.9V64H96zm0 384H288V437c0-25.5-10.1-49.9-28.1-67.9L192 301.3l-67.9 67.9c-18 18-28.1 42.4-28.1 67.9v11z"
    ]
};
var $d8206b3ab2e65c05$export$a2f8176a0161e891 = $d8206b3ab2e65c05$export$b9098a890f61e022;
var $d8206b3ab2e65c05$export$64f9eb99c9749cce = {
    prefix: "fas",
    iconName: "mountain",
    icon: [
        512,
        512,
        [
            127956
        ],
        "f6fc",
        "M256 32c12.5 0 24.1 6.4 30.8 17L503.4 394.4c5.6 8.9 8.6 19.2 8.6 29.7c0 30.9-25 55.9-55.9 55.9H55.9C25 480 0 455 0 424.1c0-10.5 3-20.8 8.6-29.7L225.2 49c6.6-10.6 18.3-17 30.8-17zm65 192L256 120.4 176.9 246.5l18.3 24.4c6.4 8.5 19.2 8.5 25.6 0l25.6-34.1c6-8.1 15.5-12.8 25.6-12.8h49z"
    ]
};
var $d8206b3ab2e65c05$export$9884bf227eeb829 = {
    prefix: "fas",
    iconName: "user-doctor",
    icon: [
        448,
        512,
        [
            "user-md"
        ],
        "f0f0",
        "M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-96 55.2C54 332.9 0 401.3 0 482.3C0 498.7 13.3 512 29.7 512H418.3c16.4 0 29.7-13.3 29.7-29.7c0-81-54-149.4-128-171.1V362c27.6 7.1 48 32.2 48 62v40c0 8.8-7.2 16-16 16H336c-8.8 0-16-7.2-16-16s7.2-16 16-16V424c0-17.7-14.3-32-32-32s-32 14.3-32 32v24c8.8 0 16 7.2 16 16s-7.2 16-16 16H256c-8.8 0-16-7.2-16-16V424c0-29.8 20.4-54.9 48-62V304.9c-6-.6-12.1-.9-18.3-.9H178.3c-6.2 0-12.3 .3-18.3 .9v65.4c23.1 6.9 40 28.3 40 53.7c0 30.9-25.1 56-56 56s-56-25.1-56-56c0-25.4 16.9-46.8 40-53.7V311.2zM144 448a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
    ]
};
var $d8206b3ab2e65c05$export$ab0d33a2c03f1794 = $d8206b3ab2e65c05$export$9884bf227eeb829;
var $d8206b3ab2e65c05$export$317f99f46b39906e = {
    prefix: "fas",
    iconName: "circle-info",
    icon: [
        512,
        512,
        [
            "info-circle"
        ],
        "f05a",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336h24V272H216c-13.3 0-24-10.7-24-24s10.7-24 24-24h48c13.3 0 24 10.7 24 24v88h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H216c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-208a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $d8206b3ab2e65c05$export$aa9288aeadf882fa = $d8206b3ab2e65c05$export$317f99f46b39906e;
var $d8206b3ab2e65c05$export$5d120e8b87ad33f4 = {
    prefix: "fas",
    iconName: "cloud-meatball",
    icon: [
        512,
        512,
        [],
        "f73b",
        "M0 224c0 53 43 96 96 96h44.7c9.5-23.5 32.5-40 59.3-40c2 0 3.9 .1 5.8 .3C217.6 265.5 235.7 256 256 256s38.4 9.5 50.2 24.3c1.9-.2 3.9-.3 5.8-.3c26.9 0 49.9 16.5 59.3 40H416c53 0 96-43 96-96s-43-96-96-96c-.5 0-1.1 0-1.6 0c1.1-5.2 1.6-10.5 1.6-16c0-44.2-35.8-80-80-80c-24.3 0-46.1 10.9-60.8 28C256.5 24.3 219.1 0 176 0C114.1 0 64 50.1 64 112c0 7.1 .7 14.1 1.9 20.8C27.6 145.4 0 181.5 0 224zm288 96c0-17.7-14.3-32-32-32s-32 14.3-32 32c0 1 .1 2.1 .1 3.1c-.7-.8-1.4-1.6-2.1-2.3c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3c.7 .7 1.5 1.4 2.3 2.1c-1-.1-2.1-.1-3.1-.1c-17.7 0-32 14.3-32 32s14.3 32 32 32c1 0 2.1-.1 3.1-.1c-.8 .7-1.6 1.3-2.3 2.1c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0c.7-.7 1.4-1.5 2.1-2.3c-.1 1-.1 2.1-.1 3.1c0 17.7 14.3 32 32 32s32-14.3 32-32c0-1-.1-2.1-.1-3.1c.7 .8 1.3 1.6 2.1 2.3c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3c-.7-.7-1.5-1.4-2.3-2.1c1 .1 2.1 .1 3.1 .1c17.7 0 32-14.3 32-32s-14.3-32-32-32c-1 0-2.1 .1-3.1 .1c.8-.7 1.6-1.3 2.3-2.1c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0c-.7 .7-1.4 1.5-2.1 2.3c.1-1 .1-2.1 .1-3.1zM48 448a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm416 0a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"
    ]
};
var $d8206b3ab2e65c05$export$84ffbd7161ca2008 = {
    prefix: "fas",
    iconName: "camera",
    icon: [
        512,
        512,
        [
            62258,
            "camera-alt"
        ],
        "f030",
        "M149.1 64.8L138.7 96H64C28.7 96 0 124.7 0 160V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H373.3L362.9 64.8C356.4 45.2 338.1 32 317.4 32H194.6c-20.7 0-39 13.2-45.5 32.8zM256 192a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"
    ]
};
var $d8206b3ab2e65c05$export$8872b5664e88e793 = $d8206b3ab2e65c05$export$84ffbd7161ca2008;
var $d8206b3ab2e65c05$export$f9409a7b020dbec4 = {
    prefix: "fas",
    iconName: "square-virus",
    icon: [
        448,
        512,
        [],
        "e578",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM223.8 93.7c13.3 0 24 10.7 24 24c0 29.3 35.4 43.9 56.1 23.2c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9c-20.7 20.7-6 56.1 23.2 56.1c13.3 0 24 10.7 24 24s-10.7 24-24 24c-29.3 0-43.9 35.4-23.2 56.1c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0c-20.7-20.7-56.1-6-56.1 23.2c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-29.3-35.4-43.9-56.1-23.2c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9c20.7-20.7 6-56.1-23.2-56.1c-13.3 0-24-10.7-24-24s10.7-24 24-24c29.3 0 43.9-35.4 23.2-56.1c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0c20.7 20.7 56.1 6 56.1-23.2c0-13.3 10.7-24 24-24zM192 256a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm88 32a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"
    ]
};
var $d8206b3ab2e65c05$export$1439f0d6365138da = {
    prefix: "fas",
    iconName: "meteor",
    icon: [
        512,
        512,
        [
            9732
        ],
        "f753",
        "M493.7 .9L299.4 75.6l2.3-29.3c1-12.8-12.8-21.5-24-15.1L101.3 133.4C38.6 169.7 0 236.6 0 309C0 421.1 90.9 512 203 512c72.4 0 139.4-38.6 175.7-101.3L480.8 234.3c6.5-11.1-2.2-25-15.1-24l-29.3 2.3L511.1 18.3c.6-1.5 .9-3.2 .9-4.8C512 6 506 0 498.5 0c-1.7 0-3.3 .3-4.8 .9zM192 192a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm0 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm16 96a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"
    ]
};
var $d8206b3ab2e65c05$export$d901d50df5cf8d91 = {
    prefix: "fas",
    iconName: "car-on",
    icon: [
        512,
        512,
        [],
        "e4dd",
        "M280 24c0-13.3-10.7-24-24-24s-24 10.7-24 24v80c0 13.3 10.7 24 24 24s24-10.7 24-24V24zM185.8 224H326.2c6.8 0 12.8 4.3 15.1 10.6L360.3 288H151.7l19.1-53.4c2.3-6.4 8.3-10.6 15.1-10.6zm-75.3-10.9L82.2 292.4C62.1 300.9 48 320.8 48 344v40 64 32c0 17.7 14.3 32 32 32H96c17.7 0 32-14.3 32-32V448H384v32c0 17.7 14.3 32 32 32h16c17.7 0 32-14.3 32-32V448 384 344c0-23.2-14.1-43.1-34.2-51.6l-28.3-79.3C390.1 181.3 360 160 326.2 160H185.8c-33.8 0-64 21.3-75.3 53.1zM128 344a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm232 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM39 39c-9.4 9.4-9.4 24.6 0 33.9l48 48c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L73 39c-9.4-9.4-24.6-9.4-33.9 0zm400 0L391 87c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l48-48c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0z"
    ]
};
var $d8206b3ab2e65c05$export$26a8fd1143d2d6c0 = {
    prefix: "fas",
    iconName: "sleigh",
    icon: [
        640,
        512,
        [],
        "f7cc",
        "M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96V256c0 53 43 96 96 96v32h64V352H384v32h64V352c53 0 96-43 96-96V160c17.7 0 32-14.3 32-32s-14.3-32-32-32H512 480c-17.7 0-32 14.3-32 32v41.3c0 30.2-24.5 54.7-54.7 54.7c-75.5 0-145.6-38.9-185.6-102.9l-4.3-6.9C174.2 67.6 125 37.6 70.7 32.7c-2.2-.5-4.4-.7-6.7-.7H55 32zM640 384c0-17.7-14.3-32-32-32s-32 14.3-32 32v8c0 13.3-10.7 24-24 24H64c-17.7 0-32 14.3-32 32s14.3 32 32 32H552c48.6 0 88-39.4 88-88v-8z"
    ]
};
var $d8206b3ab2e65c05$export$9a40d582bd4628fb = {
    prefix: "fas",
    iconName: "arrow-down-1-9",
    icon: [
        576,
        512,
        [
            "sort-numeric-asc",
            "sort-numeric-down"
        ],
        "f162",
        "M450.7 38c-8.3-6-19.1-7.7-28.8-4.4l-48 16c-16.8 5.6-25.8 23.7-20.2 40.5s23.7 25.8 40.5 20.2l5.9-2V160H384c-17.7 0-32 14.3-32 32s14.3 32 32 32h48 48c17.7 0 32-14.3 32-32s-14.3-32-32-32H464V64c0-10.3-4.9-19.9-13.3-26zM160 480c9 0 17.5-3.8 23.6-10.4l88-96c11.9-13 11.1-33.3-2-45.2s-33.3-11.1-45.2 2L192 365.7V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V365.7L95.6 330.4c-11.9-13-32.2-13.9-45.2-2s-13.9 32.2-2 45.2l88 96C142.5 476.2 151 480 160 480zM418.3 307a32 32 0 1 1 27.4 57.9A32 32 0 1 1 418.3 307zM405.1 419.8l-6.8 9.2c-10.5 14.2-7.5 34.2 6.7 44.8s34.2 7.5 44.8-6.7l48.8-65.8c14-18.9 21.5-41.7 21.5-65.2c0-48.6-39.4-88-88-88s-88 39.4-88 88c0 39.2 25.6 72.4 61.1 83.8z"
    ]
};
var $d8206b3ab2e65c05$export$a4fb1aa2cdfb18d7 = $d8206b3ab2e65c05$export$9a40d582bd4628fb;
var $d8206b3ab2e65c05$export$835db7eb35b3c29b = $d8206b3ab2e65c05$export$9a40d582bd4628fb;
var $d8206b3ab2e65c05$export$b9c3f9a906f96b82 = {
    prefix: "fas",
    iconName: "hand-holding-droplet",
    icon: [
        576,
        512,
        [
            "hand-holding-water"
        ],
        "f4c1",
        "M275.5 6.6C278.3 2.5 283 0 288 0s9.7 2.5 12.5 6.6L366.8 103C378 119.3 384 138.6 384 158.3V160c0 53-43 96-96 96s-96-43-96-96v-1.7c0-19.8 6-39 17.2-55.3L275.5 6.6zM568.2 336.3c13.1 17.8 9.3 42.8-8.5 55.9L433.1 485.5c-23.4 17.2-51.6 26.5-80.7 26.5H192 32c-17.7 0-32-14.3-32-32V416c0-17.7 14.3-32 32-32H68.8l44.9-36c22.7-18.2 50.9-28 80-28H272h16 64c17.7 0 32 14.3 32 32s-14.3 32-32 32H288 272c-8.8 0-16 7.2-16 16s7.2 16 16 16H392.6l119.7-88.2c17.8-13.1 42.8-9.3 55.9 8.5zM193.6 384l0 0-.9 0c.3 0 .6 0 .9 0z"
    ]
};
var $d8206b3ab2e65c05$export$4265371b99d38b95 = $d8206b3ab2e65c05$export$b9c3f9a906f96b82;
var $d8206b3ab2e65c05$export$efaeddad0a6e901b = {
    prefix: "fas",
    iconName: "water",
    icon: [
        576,
        512,
        [],
        "f773",
        "M269.5 69.9c11.1-7.9 25.9-7.9 37 0C329 85.4 356.5 96 384 96c26.9 0 55.4-10.8 77.4-26.1l0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 149.7 417 160 384 160c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4C42.8 92.6 61 83.5 75.3 71.6c11.1-9.5 27.3-10.1 39.2-1.7l0 0C136.7 85.2 165.1 96 192 96c27.5 0 55-10.6 77.5-26.1zm37 288C329 373.4 356.5 384 384 384c26.9 0 55.4-10.8 77.4-26.1l0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 437.7 417 448 384 448c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.4 27.3-10.1 39.2-1.7l0 0C136.7 373.2 165.1 384 192 384c27.5 0 55-10.6 77.5-26.1c11.1-7.9 25.9-7.9 37 0zm0-144C329 229.4 356.5 240 384 240c26.9 0 55.4-10.8 77.4-26.1l0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 293.7 417 304 384 304c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.5 27.3-10.1 39.2-1.7l0 0C136.7 229.2 165.1 240 192 240c27.5 0 55-10.6 77.5-26.1c11.1-7.9 25.9-7.9 37 0z"
    ]
};
var $d8206b3ab2e65c05$export$5655108e1162ba45 = {
    prefix: "fas",
    iconName: "calendar-check",
    icon: [
        448,
        512,
        [],
        "f274",
        "M128 0c17.7 0 32 14.3 32 32V64H288V32c0-17.7 14.3-32 32-32s32 14.3 32 32V64h48c26.5 0 48 21.5 48 48v48H0V112C0 85.5 21.5 64 48 64H96V32c0-17.7 14.3-32 32-32zM0 192H448V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V192zM329 305c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-95 95-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L329 305z"
    ]
};
var $d8206b3ab2e65c05$export$983e9c27cac7ed1c = {
    prefix: "fas",
    iconName: "braille",
    icon: [
        640,
        512,
        [],
        "f2a1",
        "M0 96a64 64 0 1 1 128 0A64 64 0 1 1 0 96zM224 272a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-80a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM80 416a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM0 416a64 64 0 1 1 128 0A64 64 0 1 1 0 416zm240 0a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-80 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM64 192a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM224 32a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM352 96a64 64 0 1 1 128 0A64 64 0 1 1 352 96zm240 0a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-80 0a64 64 0 1 1 128 0A64 64 0 1 1 512 96zm64 176a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-80a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm16 224a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-80 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM416 272a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-80a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm16 224a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-80 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z"
    ]
};
var $d8206b3ab2e65c05$export$99cfe064ff0b71c9 = {
    prefix: "fas",
    iconName: "prescription-bottle-medical",
    icon: [
        384,
        512,
        [
            "prescription-bottle-alt"
        ],
        "f486",
        "M0 32C0 14.3 14.3 0 32 0H352c17.7 0 32 14.3 32 32V64c0 17.7-14.3 32-32 32H32C14.3 96 0 81.7 0 64V32zm32 96H352V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V128zM160 240v48H112c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V352h48c8.8 0 16-7.2 16-16V304c0-8.8-7.2-16-16-16H224V240c0-8.8-7.2-16-16-16H176c-8.8 0-16 7.2-16 16z"
    ]
};
var $d8206b3ab2e65c05$export$65d1c884b8581d1a = $d8206b3ab2e65c05$export$99cfe064ff0b71c9;
var $d8206b3ab2e65c05$export$2bebc54c51db6505 = {
    prefix: "fas",
    iconName: "landmark",
    icon: [
        512,
        512,
        [
            127963
        ],
        "f66f",
        "M240.1 4.2c9.8-5.6 21.9-5.6 31.8 0l171.8 98.1L448 104l0 .9 47.9 27.4c12.6 7.2 18.8 22 15.1 36s-16.4 23.8-30.9 23.8H32c-14.5 0-27.2-9.8-30.9-23.8s2.5-28.8 15.1-36L64 104.9V104l4.4-1.6L240.1 4.2zM64 224h64V416h40V224h64V416h48V224h64V416h40V224h64V420.3c.6 .3 1.2 .7 1.8 1.1l48 32c11.7 7.8 17 22.4 12.9 35.9S494.1 512 480 512H32c-14.1 0-26.5-9.2-30.6-22.7s1.1-28.1 12.9-35.9l48-32c.6-.4 1.2-.7 1.8-1.1V224z"
    ]
};
var $d8206b3ab2e65c05$export$d7895f386f8bd8b8 = {
    prefix: "fas",
    iconName: "truck",
    icon: [
        640,
        512,
        [
            128666,
            9951
        ],
        "f0d1",
        "M48 0C21.5 0 0 21.5 0 48V368c0 26.5 21.5 48 48 48H64c0 53 43 96 96 96s96-43 96-96H384c0 53 43 96 96 96s96-43 96-96h32c17.7 0 32-14.3 32-32s-14.3-32-32-32V288 256 237.3c0-17-6.7-33.3-18.7-45.3L512 114.7c-12-12-28.3-18.7-45.3-18.7H416V48c0-26.5-21.5-48-48-48H48zM416 160h50.7L544 237.3V256H416V160zM112 416a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm368-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
    ]
};
var $d8206b3ab2e65c05$export$721c101130c40043 = {
    prefix: "fas",
    iconName: "crosshairs",
    icon: [
        512,
        512,
        [],
        "f05b",
        "M256 0c17.7 0 32 14.3 32 32V42.4c93.7 13.9 167.7 88 181.6 181.6H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H469.6c-13.9 93.7-88 167.7-181.6 181.6V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V469.6C130.3 455.7 56.3 381.7 42.4 288H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H42.4C56.3 130.3 130.3 56.3 224 42.4V32c0-17.7 14.3-32 32-32zM107.4 288c12.5 58.3 58.4 104.1 116.6 116.6V384c0-17.7 14.3-32 32-32s32 14.3 32 32v20.6c58.3-12.5 104.1-58.4 116.6-116.6H384c-17.7 0-32-14.3-32-32s14.3-32 32-32h20.6C392.1 165.7 346.3 119.9 288 107.4V128c0 17.7-14.3 32-32 32s-32-14.3-32-32V107.4C165.7 119.9 119.9 165.7 107.4 224H128c17.7 0 32 14.3 32 32s-14.3 32-32 32H107.4zM256 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $d8206b3ab2e65c05$export$c48422e9da776c1b = {
    prefix: "fas",
    iconName: "person-cane",
    icon: [
        448,
        512,
        [],
        "e53c",
        "M272 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-8 187.3l47.4 57.1c11.3 13.6 31.5 15.5 45.1 4.2s15.5-31.5 4.2-45.1l-73.7-88.9c-18.2-22-45.3-34.7-73.9-34.7H177.1c-33.7 0-64.9 17.7-82.3 46.6l-58.3 97c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9L120 256.9V480c0 17.7 14.3 32 32 32s32-14.3 32-32V352h16V480c0 17.7 14.3 32 32 32s32-14.3 32-32V235.3zM352 376c0-4.4 3.6-8 8-8s8 3.6 8 8V488c0 13.3 10.7 24 24 24s24-10.7 24-24V376c0-30.9-25.1-56-56-56s-56 25.1-56 56v8c0 13.3 10.7 24 24 24s24-10.7 24-24v-8z"
    ]
};
var $d8206b3ab2e65c05$export$e5075400db564e24 = {
    prefix: "fas",
    iconName: "tent",
    icon: [
        576,
        512,
        [],
        "e57d",
        "M269.4 6C280.5-2 295.5-2 306.6 6l224 160c7.4 5.3 12.2 13.5 13.2 22.5l32 288c1 9-1.9 18.1-8 24.9s-14.7 10.7-23.8 10.7H464 435.8c-12.1 0-23.2-6.8-28.6-17.7L306.7 293.5c-1.7-3.4-5.1-5.5-8.8-5.5c-5.5 0-9.9 4.4-9.9 9.9V480c0 17.7-14.3 32-32 32H240 32c-9.1 0-17.8-3.9-23.8-10.7s-9-15.8-8-24.9l32-288c1-9 5.8-17.2 13.2-22.5L269.4 6z"
    ]
};
var $d8206b3ab2e65c05$export$750a64470c2e0f3f = {
    prefix: "fas",
    iconName: "vest-patches",
    icon: [
        448,
        512,
        [],
        "e086",
        "M151.2 69.7l55.9 167.7-11 33.1c-2.7 8.2-4.1 16.7-4.1 25.3V464c0 14.5 3.9 28.2 10.7 39.9C195 509 185.9 512 176 512H48c-26.5 0-48-21.5-48-48V270.5c0-9.5 2.8-18.7 8.1-26.6l47.9-71.8c5.3-7.9 8.1-17.1 8.1-26.6V128 54.3 48C64 21.5 85.5 0 112 0h4.5c.2 0 .4 0 .6 0c.4 0 .8 0 1.2 0c18.8 0 34.1 9.7 44.1 18.8C171.6 27.2 190.8 40 224 40s52.4-12.8 61.7-21.2C295.7 9.7 311 0 329.7 0c.4 0 .8 0 1.2 0c.2 0 .4 0 .6 0H336c26.5 0 48 21.5 48 48v6.3V128v17.5c0 9.5 2.8 18.7 8.1 26.6l47.9 71.8c5.3 7.9 8.1 17.1 8.1 26.6V464c0 26.5-21.5 48-48 48H272c-26.5 0-48-21.5-48-48V295.8c0-5.2 .8-10.3 2.5-15.2L296.8 69.7C279.4 79.7 255.4 88 224 88s-55.4-8.3-72.8-18.3zM96 456a40 40 0 1 0 0-80 40 40 0 1 0 0 80zM63.5 255.5c-4.7 4.7-4.7 12.3 0 17L79 288 63.5 303.5c-4.7 4.7-4.7 12.3 0 17s12.3 4.7 17 0L96 305l15.5 15.5c4.7 4.7 12.3 4.7 17 0s4.7-12.3 0-17L113 288l15.5-15.5c4.7-4.7 4.7-12.3 0-17s-12.3-4.7-17 0L96 271 80.5 255.5c-4.7-4.7-12.3-4.7-17 0zM304 280v8 32c0 8.8 7.2 16 16 16h32 8c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8v-8c0-13.3-10.7-24-24-24s-24 10.7-24 24z"
    ]
};
var $d8206b3ab2e65c05$export$f178c8c2ad3cc861 = {
    prefix: "fas",
    iconName: "check-double",
    icon: [
        448,
        512,
        [],
        "f560",
        "M342.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L160 178.7l-57.4-57.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l80 80c12.5 12.5 32.8 12.5 45.3 0l160-160zm96 128c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L160 402.7 54.6 297.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l128 128c12.5 12.5 32.8 12.5 45.3 0l256-256z"
    ]
};
var $d8206b3ab2e65c05$export$43b642fac7053978 = {
    prefix: "fas",
    iconName: "arrow-down-a-z",
    icon: [
        576,
        512,
        [
            "sort-alpha-asc",
            "sort-alpha-down"
        ],
        "f15d",
        "M183.6 469.6C177.5 476.2 169 480 160 480s-17.5-3.8-23.6-10.4l-88-96c-11.9-13-11.1-33.3 2-45.2s33.3-11.1 45.2 2L128 365.7V64c0-17.7 14.3-32 32-32s32 14.3 32 32V365.7l32.4-35.4c11.9-13 32.2-13.9 45.2-2s13.9 32.2 2 45.2l-88 96zM320 320c0-17.7 14.3-32 32-32H480c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9L429.3 416H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H352c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9L402.7 352H352c-17.7 0-32-14.3-32-32zM416 32c12.1 0 23.2 6.8 28.6 17.7l64 128 16 32c7.9 15.8 1.5 35-14.3 42.9s-35 1.5-42.9-14.3L460.2 224H371.8l-7.2 14.3c-7.9 15.8-27.1 22.2-42.9 14.3s-22.2-27.1-14.3-42.9l16-32 64-128C392.8 38.8 403.9 32 416 32zM395.8 176h40.4L416 135.6 395.8 176z"
    ]
};
var $d8206b3ab2e65c05$export$cb87697f2fa77cfc = $d8206b3ab2e65c05$export$43b642fac7053978;
var $d8206b3ab2e65c05$export$7658045270aafde3 = $d8206b3ab2e65c05$export$43b642fac7053978;
var $d8206b3ab2e65c05$export$6a4ef2ef77625063 = {
    prefix: "fas",
    iconName: "money-bill-wheat",
    icon: [
        512,
        512,
        [],
        "e52a",
        "M176 0c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16c-44.2 0-80-35.8-80-80c0-8.8 7.2-16 16-16zM56 16h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H56C42.7 64 32 53.3 32 40s10.7-24 24-24zM24 88H136c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24S10.7 88 24 88zm8 96c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H56c-13.3 0-24-10.7-24-24zM272 16c0-8.8 7.2-16 16-16c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16c-44.2 0-80-35.8-80-80zM400 0c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16c-44.2 0-80-35.8-80-80c0-8.8 7.2-16 16-16zm80 144c0 44.2-35.8 80-80 80c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80c8.8 0 16 7.2 16 16zM352 128c8.8 0 16 7.2 16 16c0 44.2-35.8 80-80 80c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80zm-96 16c0 44.2-35.8 80-80 80c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80c8.8 0 16 7.2 16 16zM0 304c0-26.5 21.5-48 48-48H464c26.5 0 48 21.5 48 48V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V304zM48 416v48H96c0-26.5-21.5-48-48-48zM96 304H48v48c26.5 0 48-21.5 48-48zM464 416c-26.5 0-48 21.5-48 48h48V416zM416 304c0 26.5 21.5 48 48 48V304H416zm-96 80a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z"
    ]
};
var $d8206b3ab2e65c05$export$b3e64f5f68c6623f = {
    prefix: "fas",
    iconName: "cookie",
    icon: [
        512,
        512,
        [
            127850
        ],
        "f563",
        "M247.2 17c-22.1-3.1-44.6 .9-64.4 11.4l-74 39.5C89.1 78.4 73.2 94.9 63.4 115L26.7 190.6c-9.8 20.1-13 42.9-9.1 64.9l14.5 82.8c3.9 22.1 14.6 42.3 30.7 57.9l60.3 58.4c16.1 15.6 36.6 25.6 58.7 28.7l83 11.7c22.1 3.1 44.6-.9 64.4-11.4l74-39.5c19.7-10.5 35.6-27 45.4-47.2l36.7-75.5c9.8-20.1 13-42.9 9.1-64.9l-14.6-82.8c-3.9-22.1-14.6-42.3-30.7-57.9L388.9 57.5c-16.1-15.6-36.6-25.6-58.7-28.7L247.2 17zM208 144a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM144 336a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm224-64a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $d8206b3ab2e65c05$export$89b706873769c180 = {
    prefix: "fas",
    iconName: "arrow-rotate-left",
    icon: [
        512,
        512,
        [
            8634,
            "arrow-left-rotate",
            "arrow-rotate-back",
            "arrow-rotate-backward",
            "undo"
        ],
        "f0e2",
        "M125.7 160H176c17.7 0 32 14.3 32 32s-14.3 32-32 32H48c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32s32 14.3 32 32v51.2L97.6 97.6c87.5-87.5 229.3-87.5 316.8 0s87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3s-163.8-62.5-226.3 0L125.7 160z"
    ]
};
var $d8206b3ab2e65c05$export$1aea864c3e1d79b = $d8206b3ab2e65c05$export$89b706873769c180;
var $d8206b3ab2e65c05$export$a34701878babe5fc = $d8206b3ab2e65c05$export$89b706873769c180;
var $d8206b3ab2e65c05$export$fce381d12e4535cd = $d8206b3ab2e65c05$export$89b706873769c180;
var $d8206b3ab2e65c05$export$a5e5ba60b1dfe2b2 = $d8206b3ab2e65c05$export$89b706873769c180;
var $d8206b3ab2e65c05$export$4cb736b866cbb7ec = {
    prefix: "fas",
    iconName: "hard-drive",
    icon: [
        512,
        512,
        [
            128436,
            "hdd"
        ],
        "f0a0",
        "M0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V280.4c-17-15.2-39.4-24.4-64-24.4H64c-24.6 0-47 9.2-64 24.4V96zM64 288H448c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V352c0-35.3 28.7-64 64-64zM320 416a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm128-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"
    ]
};
var $d8206b3ab2e65c05$export$62551e9c5ba7093f = $d8206b3ab2e65c05$export$4cb736b866cbb7ec;
var $d8206b3ab2e65c05$export$8ff56f5ebb8416a0 = {
    prefix: "fas",
    iconName: "face-grin-squint-tears",
    icon: [
        512,
        512,
        [
            129315,
            "grin-squint-tears"
        ],
        "f586",
        "M426.8 14.2C446-5 477.5-4.6 497.1 14.9s20 51 .7 70.3c-6.8 6.8-21.4 12.4-37.4 16.7c-16.3 4.4-34.1 7.5-46.3 9.3c-1.6 .2-3.1 .5-4.6 .6c-5.6 .9-10.3-3.9-9.5-9.5c1.6-11.2 4.6-29.6 9-47c.3-1.3 .7-2.6 1-3.9c4.3-15.9 9.8-30.5 16.7-37.4zm-44.7 19c-1.5 4.8-2.9 9.6-4.1 14.3c-4.8 18.9-8 38.5-9.7 50.3c-4 26.8 18.9 49.7 45.7 45.8c11.9-1.6 31.5-4.8 50.4-9.7c4.7-1.2 9.5-2.5 14.3-4.1C534.2 227.5 520.2 353.8 437 437c-83.2 83.2-209.5 97.2-307.2 41.8c1.5-4.8 2.8-9.6 4-14.3c4.8-18.9 8-38.5 9.7-50.3c4-26.8-18.9-49.7-45.7-45.8c-11.9 1.6-31.5 4.8-50.4 9.7c-4.7 1.2-9.5 2.5-14.3 4.1C-22.2 284.5-8.2 158.2 75 75C158.2-8.3 284.5-22.2 382.2 33.2zM51.5 410.1c18.5-5 38.8-8.3 50.9-10c5.6-.9 10.3 3.9 9.5 9.5c-1.7 12.1-5 32.4-10 50.9C97.6 476.4 92 491 85.2 497.8C66 517 34.5 516.6 14.9 497.1s-20-51-.7-70.3c6.8-6.8 21.4-12.4 37.4-16.7zM416.4 202.3c-4.8-11.9-20.9-10.9-26.9 .4c-19.4 36.7-46.3 73.2-79.8 106.7s-70 60.3-106.7 79.8c-11.3 6-12.3 22.1-.4 26.9c59.4 24.1 129.9 12.2 177.9-35.8s59.9-118.5 35.8-177.9zM87.1 285.1c2 2 4.6 3.2 7.3 3.4l56.1 5.1 5.1 56.1c.3 2.8 1.5 5.4 3.4 7.3c6.3 6.3 17.2 3.6 19.8-4.9l29.7-97.4c3.5-11.6-7.3-22.5-19-19L92 265.3c-8.6 2.6-11.3 13.4-4.9 19.8zM265.3 92l-29.7 97.4c-3.5 11.6 7.3 22.5 19 19l97.4-29.7c8.6-2.6 11.3-13.4 4.9-19.8c-2-2-4.6-3.2-7.3-3.4l-56.1-5.1-5.1-56.1c-.3-2.8-1.5-5.4-3.4-7.3c-6.3-6.3-17.2-3.6-19.8 4.9z"
    ]
};
var $d8206b3ab2e65c05$export$542206d6a85f3b42 = $d8206b3ab2e65c05$export$8ff56f5ebb8416a0;
var $d8206b3ab2e65c05$export$56700074cf37be5c = {
    prefix: "fas",
    iconName: "dumbbell",
    icon: [
        640,
        512,
        [],
        "f44b",
        "M96 64c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32V224v64V448c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32V384H64c-17.7 0-32-14.3-32-32V288c-17.7 0-32-14.3-32-32s14.3-32 32-32V160c0-17.7 14.3-32 32-32H96V64zm448 0v64h32c17.7 0 32 14.3 32 32v64c17.7 0 32 14.3 32 32s-14.3 32-32 32v64c0 17.7-14.3 32-32 32H544v64c0 17.7-14.3 32-32 32H480c-17.7 0-32-14.3-32-32V288 224 64c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32zM416 224v64H224V224H416z"
    ]
};
var $d8206b3ab2e65c05$export$1f7600fa9fdb3978 = {
    prefix: "fas",
    iconName: "rectangle-list",
    icon: [
        576,
        512,
        [
            "list-alt"
        ],
        "f022",
        "M0 96C0 60.7 28.7 32 64 32H512c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM128 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm32-128a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM128 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm96-248c-13.3 0-24 10.7-24 24s10.7 24 24 24H448c13.3 0 24-10.7 24-24s-10.7-24-24-24H224zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24H448c13.3 0 24-10.7 24-24s-10.7-24-24-24H224zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24H448c13.3 0 24-10.7 24-24s-10.7-24-24-24H224z"
    ]
};
var $d8206b3ab2e65c05$export$c6327a203ffc65a3 = $d8206b3ab2e65c05$export$1f7600fa9fdb3978;
var $d8206b3ab2e65c05$export$1585b7c3c7109751 = {
    prefix: "fas",
    iconName: "tarp-droplet",
    icon: [
        576,
        512,
        [],
        "e57c",
        "M288 160c-35.3 0-64-26.9-64-60c0-24 33.7-70.1 52.2-93.5c6.1-7.7 17.5-7.7 23.6 0C318.3 29.9 352 76 352 100c0 33.1-28.7 60-64 60zM64 128H197.5c13.2 37.3 48.7 64 90.5 64s77.4-26.7 90.5-64H512c35.3 0 64 28.7 64 64V352H448c-17.7 0-32 14.3-32 32l0 128L64 512c-35.3 0-64-28.7-64-64V192c0-35.3 28.7-64 64-64zM448 512l0-128H576L448 512zM96 256a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
var $d8206b3ab2e65c05$export$5d08d08f88a96aac = {
    prefix: "fas",
    iconName: "house-medical-circle-check",
    icon: [
        640,
        512,
        [],
        "e511",
        "M320 368c0 59.5 29.5 112.1 74.8 144H128.1c-35.3 0-64-28.7-64-64V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L522.1 193.9c-8.5-1.3-17.3-1.9-26.1-1.9c-54.7 0-103.5 24.9-135.8 64H320V208c0-8.8-7.2-16-16-16H272c-8.8 0-16 7.2-16 16v48H208c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16zm32 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm211.3-43.3c-6.2-6.2-16.4-6.2-22.6 0L480 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z"
    ]
};
var $d8206b3ab2e65c05$export$c8cd1786449517d3 = {
    prefix: "fas",
    iconName: "person-skiing-nordic",
    icon: [
        576,
        512,
        [
            "skiing-nordic"
        ],
        "f7ca",
        "M336 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM227.2 160c1.9 0 3.8 .1 5.6 .3L201.6 254c-9.3 28 1.7 58.8 26.8 74.5l86.2 53.9L291.3 464H202.8l41.1-88.1-32.4-20.3c-7.8-4.9-14.7-10.7-20.6-17.3L132.2 464H99.7l54.2-257.6c4.6-1.5 9-4.1 12.7-7.8l23.1-23.1c9.9-9.9 23.4-15.5 37.5-15.5zM121.4 198.6c.4 .4 .8 .8 1.3 1.2L67 464H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H159.3c.4 0 .9 0 1.3 0H319.3c.5 0 1 0 1.4 0H504c39.8 0 72-32.2 72-72v-8c0-13.3-10.7-24-24-24s-24 10.7-24 24v8c0 13.3-10.7 24-24 24H434.6l27.6-179.3c10.5-5.2 17.8-16.1 17.8-28.7c0-17.7-14.3-32-32-32H426.7c-12.9 0-24.6-7.8-29.5-19.7l-6.3-15c-14.6-35.1-44.1-61.9-80.5-73.1l-48.7-15c-11.1-3.4-22.7-5.2-34.4-5.2c-31 0-60.8 12.3-82.7 34.3l-23.1 23.1c-12.5 12.5-12.5 32.8 0 45.3zm308 89.4L402.3 464H357.8l21.6-75.6c5.9-20.6-2.6-42.6-20.7-53.9L302 299l30.9-82.4 5.1 12.3C353 264.7 387.9 288 426.7 288h2.7z"
    ]
};
var $d8206b3ab2e65c05$export$6ea48260d7d09b1b = $d8206b3ab2e65c05$export$c8cd1786449517d3;
var $d8206b3ab2e65c05$export$16768a660ae3ca9d = {
    prefix: "fas",
    iconName: "calendar-plus",
    icon: [
        448,
        512,
        [],
        "f271",
        "M96 32V64H48C21.5 64 0 85.5 0 112v48H448V112c0-26.5-21.5-48-48-48H352V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H160V32c0-17.7-14.3-32-32-32S96 14.3 96 32zM448 192H0V464c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48V192zM224 248c13.3 0 24 10.7 24 24v56h56c13.3 0 24 10.7 24 24s-10.7 24-24 24H248v56c0 13.3-10.7 24-24 24s-24-10.7-24-24V376H144c-13.3 0-24-10.7-24-24s10.7-24 24-24h56V272c0-13.3 10.7-24 24-24z"
    ]
};
var $d8206b3ab2e65c05$export$9b2dbe133273f284 = {
    prefix: "fas",
    iconName: "plane-arrival",
    icon: [
        640,
        512,
        [
            128748
        ],
        "f5af",
        "M.3 166.9L0 68C0 57.7 9.5 50.1 19.5 52.3l35.6 7.9c10.6 2.3 19.2 9.9 23 20L96 128l127.3 37.6L181.8 20.4C178.9 10.2 186.6 0 197.2 0h40.1c11.6 0 22.2 6.2 27.9 16.3l109 193.8 107.2 31.7c15.9 4.7 30.8 12.5 43.7 22.8l34.4 27.6c24 19.2 18.1 57.3-10.7 68.2c-41.2 15.6-86.2 18.1-128.8 7L121.7 289.8c-11.1-2.9-21.2-8.7-29.3-16.9L9.5 189.4c-5.9-6-9.3-14.1-9.3-22.5zM32 448H608c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32zm96-80a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm128-16a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $d8206b3ab2e65c05$export$5ae86b9da9cca3bd = {
    prefix: "fas",
    iconName: "circle-left",
    icon: [
        512,
        512,
        [
            61840,
            "arrow-alt-circle-left"
        ],
        "f359",
        "M512 256A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM217.4 376.9L117.5 269.8c-3.5-3.8-5.5-8.7-5.5-13.8s2-10.1 5.5-13.8l99.9-107.1c4.2-4.5 10.1-7.1 16.3-7.1c12.3 0 22.3 10 22.3 22.3l0 57.7 96 0c17.7 0 32 14.3 32 32l0 32c0 17.7-14.3 32-32 32l-96 0 0 57.7c0 12.3-10 22.3-22.3 22.3c-6.2 0-12.1-2.6-16.3-7.1z"
    ]
};
var $d8206b3ab2e65c05$export$5460a5b11a24996f = $d8206b3ab2e65c05$export$5ae86b9da9cca3bd;
var $d8206b3ab2e65c05$export$cda326cc3bce41c = {
    prefix: "fas",
    iconName: "train-subway",
    icon: [
        448,
        512,
        [
            "subway"
        ],
        "f239",
        "M96 0C43 0 0 43 0 96V352c0 48 35.2 87.7 81.1 94.9l-46 46C28.1 499.9 33.1 512 43 512H82.7c8.5 0 16.6-3.4 22.6-9.4L160 448H288l54.6 54.6c6 6 14.1 9.4 22.6 9.4H405c10 0 15-12.1 7.9-19.1l-46-46c46-7.1 81.1-46.9 81.1-94.9V96c0-53-43-96-96-96H96zM64 128c0-17.7 14.3-32 32-32h80c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V128zM272 96h80c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H272c-17.7 0-32-14.3-32-32V128c0-17.7 14.3-32 32-32zM64 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm288-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $d8206b3ab2e65c05$export$4cabc8a12d4e2f9 = $d8206b3ab2e65c05$export$cda326cc3bce41c;
var $d8206b3ab2e65c05$export$dce43b02b3fe0c18 = {
    prefix: "fas",
    iconName: "chart-gantt",
    icon: [
        512,
        512,
        [],
        "e0e4",
        "M32 32c17.7 0 32 14.3 32 32V400c0 8.8 7.2 16 16 16H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H80c-44.2 0-80-35.8-80-80V64C0 46.3 14.3 32 32 32zm96 96c0-17.7 14.3-32 32-32l96 0c17.7 0 32 14.3 32 32s-14.3 32-32 32H160c-17.7 0-32-14.3-32-32zm96 64H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32s14.3-32 32-32zm160 96h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H384c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
    ]
};
var $d8206b3ab2e65c05$export$1d2b135cc5a2c852 = {
    prefix: "fas",
    iconName: "indian-rupee-sign",
    icon: [
        320,
        512,
        [
            "indian-rupee",
            "inr"
        ],
        "e1bc",
        "M0 64C0 46.3 14.3 32 32 32H96h16H288c17.7 0 32 14.3 32 32s-14.3 32-32 32H231.8c9.6 14.4 16.7 30.6 20.7 48H288c17.7 0 32 14.3 32 32s-14.3 32-32 32H252.4c-13.2 58.3-61.9 103.2-122.2 110.9L274.6 422c14.4 10.3 17.7 30.3 7.4 44.6s-30.3 17.7-44.6 7.4L13.4 314C2.1 306-2.7 291.5 1.5 278.2S18.1 256 32 256h80c32.8 0 61-19.7 73.3-48H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H185.3C173 115.7 144.8 96 112 96H96 32C14.3 96 0 81.7 0 64z"
    ]
};
var $d8206b3ab2e65c05$export$be886a4def17c565 = $d8206b3ab2e65c05$export$1d2b135cc5a2c852;
var $d8206b3ab2e65c05$export$12c6d8b3e052490b = $d8206b3ab2e65c05$export$1d2b135cc5a2c852;
var $d8206b3ab2e65c05$export$c3605731beb92daf = {
    prefix: "fas",
    iconName: "crop-simple",
    icon: [
        512,
        512,
        [
            "crop-alt"
        ],
        "f565",
        "M128 32c0-17.7-14.3-32-32-32S64 14.3 64 32V64H32C14.3 64 0 78.3 0 96s14.3 32 32 32H64V384c0 35.3 28.7 64 64 64H352V384H128V32zM384 480c0 17.7 14.3 32 32 32s32-14.3 32-32V448h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H448l0-256c0-35.3-28.7-64-64-64L160 64v64l224 0 0 352z"
    ]
};
var $d8206b3ab2e65c05$export$d932915fde4f1010 = $d8206b3ab2e65c05$export$c3605731beb92daf;
var $d8206b3ab2e65c05$export$a312c7d58dd44a75 = {
    prefix: "fas",
    iconName: "money-bill-1",
    icon: [
        576,
        512,
        [
            "money-bill-alt"
        ],
        "f3d1",
        "M64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zm64 320H64V320c35.3 0 64 28.7 64 64zM64 192V128h64c0 35.3-28.7 64-64 64zM448 384c0-35.3 28.7-64 64-64v64H448zm64-192c-35.3 0-64-28.7-64-64h64v64zM176 256a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm76-48c0 9.7 6.9 17.7 16 19.6V276h-4c-11 0-20 9-20 20s9 20 20 20h24 24c11 0 20-9 20-20s-9-20-20-20h-4V208c0-11-9-20-20-20H272c-11 0-20 9-20 20z"
    ]
};
var $d8206b3ab2e65c05$export$a35d573395884c3d = $d8206b3ab2e65c05$export$a312c7d58dd44a75;
var $d8206b3ab2e65c05$export$1db7e2ee10d36035 = {
    prefix: "fas",
    iconName: "left-long",
    icon: [
        512,
        512,
        [
            "long-arrow-alt-left"
        ],
        "f30a",
        "M177.5 414c-8.8 3.8-19 2-26-4.6l-144-136C2.7 268.9 0 262.6 0 256s2.7-12.9 7.5-17.4l144-136c7-6.6 17.2-8.4 26-4.6s14.5 12.5 14.5 22l0 72 288 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-288 0 0 72c0 9.6-5.7 18.2-14.5 22z"
    ]
};
var $d8206b3ab2e65c05$export$a8b3226b2bf323d = $d8206b3ab2e65c05$export$1db7e2ee10d36035;
var $d8206b3ab2e65c05$export$c062100d54a2da00 = {
    prefix: "fas",
    iconName: "dna",
    icon: [
        448,
        512,
        [
            129516
        ],
        "f471",
        "M416 0c17.7 0 32 14.3 32 32c0 59.8-30.3 107.5-69.4 146.6c-28 28-62.5 53.5-97.3 77.4l-2.5 1.7c-11.9 8.1-23.8 16.1-35.5 23.9l0 0 0 0 0 0-1.6 1c-6 4-11.9 7.9-17.8 11.9c-20.9 14-40.8 27.7-59.3 41.5H283.3c-9.8-7.4-20.1-14.7-30.7-22.1l7-4.7 3-2c15.1-10.1 30.9-20.6 46.7-31.6c25 18.1 48.9 37.3 69.4 57.7C417.7 372.5 448 420.2 448 480c0 17.7-14.3 32-32 32s-32-14.3-32-32H64c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-59.8 30.3-107.5 69.4-146.6c28-28 62.5-53.5 97.3-77.4c-34.8-23.9-69.3-49.3-97.3-77.4C30.3 139.5 0 91.8 0 32C0 14.3 14.3 0 32 0S64 14.3 64 32H384c0-17.7 14.3-32 32-32zM338.6 384H109.4c-10.1 10.6-18.6 21.3-25.5 32H364.1c-6.8-10.7-15.3-21.4-25.5-32zM109.4 128H338.6c10.1-10.7 18.6-21.3 25.5-32H83.9c6.8 10.7 15.3 21.3 25.5 32zm55.4 48c18.4 13.8 38.4 27.5 59.3 41.5c20.9-14 40.8-27.7 59.3-41.5H164.7z"
    ]
};
var $d8206b3ab2e65c05$export$c4ff5306c5470939 = {
    prefix: "fas",
    iconName: "virus-slash",
    icon: [
        640,
        512,
        [],
        "e075",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-154.3-121c-2-30.1 20.8-60.1 56-60.1H544c17.7 0 32-14.3 32-32s-14.3-32-32-32H532.5c-49.9 0-74.9-60.3-39.6-95.6l8.2-8.2c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-8.2 8.2C412.3 118.4 352 93.4 352 43.5V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V43.5c0 49.9-60.3 74.9-95.6 39.6L184.2 75c-12.5-12.5-32.8-12.5-45.3 0c-1.6 1.6-3.1 3.4-4.3 5.3L38.8 5.1zm225.8 177c6.9-3.9 14.9-6.1 23.4-6.1c26.5 0 48 21.5 48 48c0 4.4-.6 8.7-1.7 12.7l-69.7-54.6zM402 412.7L144.7 210c-9.5 8.5-22.2 14-37.2 14H96c-17.7 0-32 14.3-32 32s14.3 32 32 32h11.5c49.9 0 74.9 60.3 39.6 95.6l-8.2 8.2c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l8.2-8.2c35.3-35.3 95.6-10.3 95.6 39.6V480c0 17.7 14.3 32 32 32s32-14.3 32-32V468.5c0-31.2 23.6-52.7 50-55.7z"
    ]
};
var $d8206b3ab2e65c05$export$fee0376c250cdef = {
    prefix: "fas",
    iconName: "minus",
    icon: [
        448,
        512,
        [
            8211,
            8722,
            10134,
            "subtract"
        ],
        "f068",
        "M432 256c0 17.7-14.3 32-32 32L48 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l352 0c17.7 0 32 14.3 32 32z"
    ]
};
var $d8206b3ab2e65c05$export$f8cb2531ef1fc4a2 = $d8206b3ab2e65c05$export$fee0376c250cdef;
var $d8206b3ab2e65c05$export$442fddbbd741c590 = {
    prefix: "fas",
    iconName: "chess",
    icon: [
        512,
        512,
        [],
        "f439",
        "M144 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V32H96c-8.8 0-16 7.2-16 16s7.2 16 16 16h16V96H60.2C49.1 96 40 105.1 40 116.2c0 2.5 .5 4.9 1.3 7.3L73.8 208H72c-13.3 0-24 10.7-24 24s10.7 24 24 24h4L60 384H196L180 256h4c13.3 0 24-10.7 24-24s-10.7-24-24-24h-1.8l32.5-84.5c.9-2.3 1.3-4.8 1.3-7.3c0-11.2-9.1-20.2-20.2-20.2H144V64h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H144V16zM48 416L4.8 473.6C1.7 477.8 0 482.8 0 488c0 13.3 10.7 24 24 24H232c13.3 0 24-10.7 24-24c0-5.2-1.7-10.2-4.8-14.4L208 416H48zm288 0l-43.2 57.6c-3.1 4.2-4.8 9.2-4.8 14.4c0 13.3 10.7 24 24 24H488c13.3 0 24-10.7 24-24c0-5.2-1.7-10.2-4.8-14.4L464 416H336zM304 208v51.9c0 7.8 2.8 15.3 8 21.1L339.2 312 337 384H462.5l-3.3-72 28.3-30.8c5.4-5.9 8.5-13.6 8.5-21.7V208c0-8.8-7.2-16-16-16H464c-8.8 0-16 7.2-16 16v16H424V208c0-8.8-7.2-16-16-16H392c-8.8 0-16 7.2-16 16v16H352V208c0-8.8-7.2-16-16-16H320c-8.8 0-16 7.2-16 16zm80 96c0-8.8 7.2-16 16-16s16 7.2 16 16v32H384V304z"
    ]
};
var $d8206b3ab2e65c05$export$6e5225f0e6c0bacd = {
    prefix: "fas",
    iconName: "arrow-left-long",
    icon: [
        512,
        512,
        [
            "long-arrow-left"
        ],
        "f177",
        "M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l128 128c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 288 480 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-370.7 0 73.4-73.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-128 128z"
    ]
};
var $d8206b3ab2e65c05$export$80896efc906118b4 = $d8206b3ab2e65c05$export$6e5225f0e6c0bacd;
var $d8206b3ab2e65c05$export$2bd45e99b9afa947 = {
    prefix: "fas",
    iconName: "plug-circle-check",
    icon: [
        576,
        512,
        [],
        "e55c",
        "M96 0C78.3 0 64 14.3 64 32v96h64V32c0-17.7-14.3-32-32-32zM288 0c-17.7 0-32 14.3-32 32v96h64V32c0-17.7-14.3-32-32-32zM32 160c-17.7 0-32 14.3-32 32s14.3 32 32 32v32c0 77.4 55 142 128 156.8V480c0 17.7 14.3 32 32 32s32-14.3 32-32V412.8c12.3-2.5 24.1-6.4 35.1-11.5c-2.1-10.8-3.1-21.9-3.1-33.3c0-80.3 53.8-148 127.3-169.2c.5-2.2 .7-4.5 .7-6.8c0-17.7-14.3-32-32-32H32zM576 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L416 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"
    ]
};
var $d8206b3ab2e65c05$export$6aab6c3359c2554c = {
    prefix: "fas",
    iconName: "street-view",
    icon: [
        512,
        512,
        [],
        "f21d",
        "M320 64A64 64 0 1 0 192 64a64 64 0 1 0 128 0zm-96 96c-35.3 0-64 28.7-64 64v48c0 17.7 14.3 32 32 32h1.8l11.1 99.5c1.8 16.2 15.5 28.5 31.8 28.5h38.7c16.3 0 30-12.3 31.8-28.5L318.2 304H320c17.7 0 32-14.3 32-32V224c0-35.3-28.7-64-64-64H224zM132.3 394.2c13-2.4 21.7-14.9 19.3-27.9s-14.9-21.7-27.9-19.3c-32.4 5.9-60.9 14.2-82 24.8c-10.5 5.3-20.3 11.7-27.8 19.6C6.4 399.5 0 410.5 0 424c0 21.4 15.5 36.1 29.1 45c14.7 9.6 34.3 17.3 56.4 23.4C130.2 504.7 190.4 512 256 512s125.8-7.3 170.4-19.6c22.1-6.1 41.8-13.8 56.4-23.4c13.7-8.9 29.1-23.6 29.1-45c0-13.5-6.4-24.5-14-32.6c-7.5-7.9-17.3-14.3-27.8-19.6c-21-10.6-49.5-18.9-82-24.8c-13-2.4-25.5 6.3-27.9 19.3s6.3 25.5 19.3 27.9c30.2 5.5 53.7 12.8 69 20.5c3.2 1.6 5.8 3.1 7.9 4.5c3.6 2.4 3.6 7.2 0 9.6c-8.8 5.7-23.1 11.8-43 17.3C374.3 457 318.5 464 256 464s-118.3-7-157.7-17.9c-19.9-5.5-34.2-11.6-43-17.3c-3.6-2.4-3.6-7.2 0-9.6c2.1-1.4 4.8-2.9 7.9-4.5c15.3-7.7 38.8-14.9 69-20.5z"
    ]
};
var $d8206b3ab2e65c05$export$acef3e5c2029d285 = {
    prefix: "fas",
    iconName: "franc-sign",
    icon: [
        320,
        512,
        [],
        "e18f",
        "M80 32C62.3 32 48 46.3 48 64V224v96H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H48v64c0 17.7 14.3 32 32 32s32-14.3 32-32V384h80c17.7 0 32-14.3 32-32s-14.3-32-32-32H112V256H256c17.7 0 32-14.3 32-32s-14.3-32-32-32H112V96H288c17.7 0 32-14.3 32-32s-14.3-32-32-32H80z"
    ]
};
var $d8206b3ab2e65c05$export$d94ba52e980ea0f1 = {
    prefix: "fas",
    iconName: "volume-off",
    icon: [
        320,
        512,
        [],
        "f026",
        "M320 64c0-12.6-7.4-24-18.9-29.2s-25-3.1-34.4 5.3L131.8 160H64c-35.3 0-64 28.7-64 64v64c0 35.3 28.7 64 64 64h67.8L266.7 471.9c9.4 8.4 22.9 10.4 34.4 5.3S320 460.6 320 448V64z"
    ]
};
var $d8206b3ab2e65c05$export$bc43eb4655c78f49 = {
    prefix: "fas",
    iconName: "hands-asl-interpreting",
    icon: [
        640,
        512,
        [
            "american-sign-language-interpreting",
            "asl-interpreting",
            "hands-american-sign-language-interpreting"
        ],
        "f2a3",
        "M156.6 46.3c7.9-15.8 1.5-35-14.3-42.9s-35-1.5-42.9 14.3L13.5 189.4C4.6 207.2 0 226.8 0 246.7V256c0 70.7 57.3 128 128 128h72 8v-.3c35.2-2.7 65.4-22.8 82.1-51.7c8.8-15.3 3.6-34.9-11.7-43.7s-34.9-3.6-43.7 11.7c-7 12-19.9 20-34.7 20c-22.1 0-40-17.9-40-40s17.9-40 40-40c14.8 0 27.7 8 34.7 20c8.8 15.3 28.4 20.5 43.7 11.7s20.5-28.4 11.7-43.7c-12.8-22.1-33.6-39.1-58.4-47.1l80.8-22c17-4.6 27.1-22.2 22.5-39.3s-22.2-27.1-39.3-22.5L194.9 124.6l81.6-68c13.6-11.3 15.4-31.5 4.1-45.1S249.1-3.9 235.5 7.4L133.6 92.3l23-46zM483.4 465.7c-7.9 15.8-1.5 35 14.3 42.9s35 1.5 42.9-14.3l85.9-171.7c8.9-17.8 13.5-37.4 13.5-57.2V256c0-70.7-57.3-128-128-128H440h-8v.3c-35.2 2.7-65.4 22.8-82.1 51.7c-8.9 15.3-3.6 34.9 11.7 43.7s34.9 3.6 43.7-11.7c7-12 19.9-20 34.7-20c22.1 0 40 17.9 40 40s-17.9 40-40 40c-14.8 0-27.7-8-34.7-20c-8.9-15.3-28.4-20.5-43.7-11.7s-20.5 28.4-11.7 43.7c12.8 22.1 33.6 39.1 58.4 47.1l-80.8 22c-17.1 4.7-27.1 22.2-22.5 39.3s22.2 27.1 39.3 22.5l100.7-27.5-81.6 68c-13.6 11.3-15.4 31.5-4.1 45.1s31.5 15.4 45.1 4.1l101.9-84.9-23 46z"
    ]
};
var $d8206b3ab2e65c05$export$23a7517099ab1b86 = $d8206b3ab2e65c05$export$bc43eb4655c78f49;
var $d8206b3ab2e65c05$export$beb51abfb05a4eca = $d8206b3ab2e65c05$export$bc43eb4655c78f49;
var $d8206b3ab2e65c05$export$82846008645b0301 = $d8206b3ab2e65c05$export$bc43eb4655c78f49;
var $d8206b3ab2e65c05$export$ec05accb7226d001 = {
    prefix: "fas",
    iconName: "gear",
    icon: [
        512,
        512,
        [
            9881,
            "cog"
        ],
        "f013",
        "M495.9 166.6c3.2 8.7 .5 18.4-6.4 24.6l-43.3 39.4c1.1 8.3 1.7 16.8 1.7 25.4s-.6 17.1-1.7 25.4l43.3 39.4c6.9 6.2 9.6 15.9 6.4 24.6c-4.4 11.9-9.7 23.3-15.8 34.3l-4.7 8.1c-6.6 11-14 21.4-22.1 31.2c-5.9 7.2-15.7 9.6-24.5 6.8l-55.7-17.7c-13.4 10.3-28.2 18.9-44 25.4l-12.5 57.1c-2 9.1-9 16.3-18.2 17.8c-13.8 2.3-28 3.5-42.5 3.5s-28.7-1.2-42.5-3.5c-9.2-1.5-16.2-8.7-18.2-17.8l-12.5-57.1c-15.8-6.5-30.6-15.1-44-25.4L83.1 425.9c-8.8 2.8-18.6 .3-24.5-6.8c-8.1-9.8-15.5-20.2-22.1-31.2l-4.7-8.1c-6.1-11-11.4-22.4-15.8-34.3c-3.2-8.7-.5-18.4 6.4-24.6l43.3-39.4C64.6 273.1 64 264.6 64 256s.6-17.1 1.7-25.4L22.4 191.2c-6.9-6.2-9.6-15.9-6.4-24.6c4.4-11.9 9.7-23.3 15.8-34.3l4.7-8.1c6.6-11 14-21.4 22.1-31.2c5.9-7.2 15.7-9.6 24.5-6.8l55.7 17.7c13.4-10.3 28.2-18.9 44-25.4l12.5-57.1c2-9.1 9-16.3 18.2-17.8C227.3 1.2 241.5 0 256 0s28.7 1.2 42.5 3.5c9.2 1.5 16.2 8.7 18.2 17.8l12.5 57.1c15.8 6.5 30.6 15.1 44 25.4l55.7-17.7c8.8-2.8 18.6-.3 24.5 6.8c8.1 9.8 15.5 20.2 22.1 31.2l4.7 8.1c6.1 11 11.4 22.4 15.8 34.3zM256 336a80 80 0 1 0 0-160 80 80 0 1 0 0 160z"
    ]
};
var $d8206b3ab2e65c05$export$d6298bbfd1912a78 = $d8206b3ab2e65c05$export$ec05accb7226d001;
var $d8206b3ab2e65c05$export$1d6c5a49025d720b = {
    prefix: "fas",
    iconName: "droplet-slash",
    icon: [
        640,
        512,
        [
            "tint-slash"
        ],
        "f5c7",
        "M320 512c53.2 0 101.4-21.6 136.1-56.6l-298.3-235C140 257.1 128 292.3 128 320c0 106 86 192 192 192zM505.2 370.7c4.4-16.1 6.8-33.1 6.8-50.7c0-91.2-130.2-262.3-166.6-308.3C339.4 4.2 330.5 0 320.9 0h-1.8c-9.6 0-18.5 4.2-24.5 11.7C277.8 33 240.7 81.3 205.8 136L38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L505.2 370.7zM224 336c0 44.2 35.8 80 80 80c8.8 0 16 7.2 16 16s-7.2 16-16 16c-61.9 0-112-50.1-112-112c0-8.8 7.2-16 16-16s16 7.2 16 16z"
    ]
};
var $d8206b3ab2e65c05$export$5d6f0943039b898f = $d8206b3ab2e65c05$export$1d6c5a49025d720b;
var $d8206b3ab2e65c05$export$4999586d7e1087fb = {
    prefix: "fas",
    iconName: "mosque",
    icon: [
        640,
        512,
        [
            128332
        ],
        "f678",
        "M400 0c5 0 9.8 2.4 12.8 6.4c34.7 46.3 78.1 74.9 133.5 111.5l0 0 0 0c5.2 3.4 10.5 7 16 10.6c28.9 19.2 45.7 51.7 45.7 86.1c0 28.6-11.3 54.5-29.8 73.4H221.8c-18.4-19-29.8-44.9-29.8-73.4c0-34.4 16.7-66.9 45.7-86.1c5.4-3.6 10.8-7.1 16-10.6l0 0 0 0C309.1 81.3 352.5 52.7 387.2 6.4c3-4 7.8-6.4 12.8-6.4zM288 512V440c0-13.3-10.7-24-24-24s-24 10.7-24 24v72H192c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32H608c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H560V440c0-13.3-10.7-24-24-24s-24 10.7-24 24v72H448V454c0-19-8.4-37-23-49.2L400 384l-25 20.8C360.4 417 352 435 352 454v58H288zM70.4 5.2c5.7-4.3 13.5-4.3 19.2 0l16 12C139.8 42.9 160 83.2 160 126v2H0v-2C0 83.2 20.2 42.9 54.4 17.2l16-12zM0 160H160V296.6c-19.1 11.1-32 31.7-32 55.4V480c0 9.6 2.1 18.6 5.8 26.8c-6.6 3.4-14 5.2-21.8 5.2H48c-26.5 0-48-21.5-48-48V176 160z"
    ]
};
var $d8206b3ab2e65c05$export$67c7a1518d0715ff = {
    prefix: "fas",
    iconName: "mosquito",
    icon: [
        640,
        512,
        [],
        "e52b",
        "M463.7 505.9c9.8-8.9 10.7-24.3 2.1-34.3l-42.1-49 0-54.7c0-5.5-1.8-10.8-5.1-15.1L352 266.3l0-.3L485.4 387.8C542.4 447.6 640 405.2 640 320.6c0-47.9-34-88.3-79.4-94.2l-153-23.9 40.8-40.9c7.8-7.8 9.4-20.1 3.9-29.8L428.5 90.1l38.2-50.9c8-10.6 6.1-25.9-4.3-34.1s-25.2-6.3-33.2 4.4l-48 63.9c-5.9 7.9-6.6 18.6-1.7 27.2L402.2 140 352 190.3l0-38.2c0-14.9-10.2-27.4-24-31l0-57.2c0-4.4-3.6-8-8-8s-8 3.6-8 8l0 57.2c-13.8 3.6-24 16.1-24 31l0 38.1L237.8 140l22.6-39.5c4.9-8.6 4.2-19.3-1.7-27.2l-48-63.9c-8-10.6-22.8-12.6-33.2-4.4s-12.2 23.5-4.3 34.1l38.2 50.9-23.9 41.7c-5.5 9.7-3.9 22 3.9 29.8l40.8 40.9-153 23.9C34 232.3 0 272.7 0 320.6c0 84.6 97.6 127 154.6 67.1L288 266l0 .3-66.5 86.4c-3.3 4.3-5.1 9.6-5.1 15.1l0 54.7-42.1 49c-8.6 10.1-7.7 25.5 2.1 34.3s24.7 7.9 33.4-2.1l48-55.9c3.8-4.4 5.9-10.2 5.9-16.1l0-55.4L288 344.7l0 63.1c0 17.7 14.3 32 32 32s32-14.3 32-32l0-63.1 24.3 31.6 0 55.4c0 5.9 2.1 11.7 5.9 16.1l48 55.9c8.6 10.1 23.6 11 33.4 2.1z"
    ]
};
var $d8206b3ab2e65c05$export$f823fee3712b2601 = {
    prefix: "fas",
    iconName: "star-of-david",
    icon: [
        512,
        512,
        [
            10017
        ],
        "f69a",
        "M404.2 309.5L383.1 344h42.3l-21.1-34.5zM371.4 256l-54-88H194.6l-54 88 54 88H317.4l54-88zm65.7 0l53.4 87c3.6 5.9 5.5 12.7 5.5 19.6c0 20.7-16.8 37.4-37.4 37.4H348.7l-56.2 91.5C284.8 504.3 270.9 512 256 512s-28.8-7.7-36.6-20.5L163.3 400H53.4C32.8 400 16 383.2 16 362.6c0-6.9 1.9-13.7 5.5-19.6l53.4-87L21.5 169c-3.6-5.9-5.5-12.7-5.5-19.6C16 128.8 32.8 112 53.4 112H163.3l56.2-91.5C227.2 7.7 241.1 0 256 0s28.8 7.7 36.6 20.5L348.7 112H458.6c20.7 0 37.4 16.8 37.4 37.4c0 6.9-1.9 13.7-5.5 19.6l-53.4 87zm-54-88l21.1 34.5L425.4 168H383.1zM283 112L256 68l-27 44h54zM128.9 168H86.6l21.1 34.5L128.9 168zM107.8 309.5L86.6 344h42.3l-21.1-34.5zM229 400l27 44 27-44H229z"
    ]
};
var $d8206b3ab2e65c05$export$842b988dae95ccb8 = {
    prefix: "fas",
    iconName: "person-military-rifle",
    icon: [
        512,
        512,
        [],
        "e54b",
        "M160 39c0-13 10-23.8 22.9-24.9L334.7 1.4C344 .7 352 8 352 17.4V48c0 8.8-7.2 16-16 16H185c-13.8 0-25-11.2-25-25zm17.6 57H334.4c1 5.2 1.6 10.5 1.6 16c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-5.5 .6-10.8 1.6-16zm228 364.3L352 369.7V480c0 1.3-.1 2.5-.2 3.8L177.5 234.9c16.6-7.1 34.6-10.9 53.3-10.9h50.4c15.9 0 31.3 2.8 45.8 7.9L421.9 67.7c-7.7-4.4-10.3-14.2-5.9-21.9s14.2-10.3 21.9-5.9l13.9 8 13.9 8c7.7 4.4 10.3 14.2 5.9 21.9L416 173.9l1.6 .9c15.3 8.8 20.6 28.4 11.7 43.7L392.6 282c2 2.8 3.9 5.8 5.7 8.8l76.1 128.8c11.2 19 4.9 43.5-14.1 54.8s-43.5 4.9-54.8-14.1zM320 512H192c-17.7 0-32-14.3-32-32V369.7l-53.6 90.6c-11.2 19-35.8 25.3-54.8 14.1s-25.3-35.8-14.1-54.8l76.1-128.8c9.4-15.8 21.7-29.3 36-40L331.1 510c-3.5 1.3-7.2 2-11.1 2zM296 320a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
    ]
};
var $d8206b3ab2e65c05$export$c790b41dc166ae13 = {
    prefix: "fas",
    iconName: "cart-shopping",
    icon: [
        576,
        512,
        [
            128722,
            "shopping-cart"
        ],
        "f07a",
        "M0 24C0 10.7 10.7 0 24 0H69.5c22 0 41.5 12.8 50.6 32h411c26.3 0 45.5 25 38.6 50.4l-41 152.3c-8.5 31.4-37 53.3-69.5 53.3H170.7l5.4 28.5c2.2 11.3 12.1 19.5 23.6 19.5H488c13.3 0 24 10.7 24 24s-10.7 24-24 24H199.7c-34.6 0-64.3-24.6-70.7-58.5L77.4 54.5c-.7-3.8-4-6.5-7.9-6.5H24C10.7 48 0 37.3 0 24zM128 464a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm336-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
    ]
};
var $d8206b3ab2e65c05$export$51da406e5aa1388c = $d8206b3ab2e65c05$export$c790b41dc166ae13;
var $d8206b3ab2e65c05$export$507e8edd7676b2e9 = {
    prefix: "fas",
    iconName: "vials",
    icon: [
        512,
        512,
        [],
        "f493",
        "M0 64C0 46.3 14.3 32 32 32H88h48 56c17.7 0 32 14.3 32 32s-14.3 32-32 32V400c0 44.2-35.8 80-80 80s-80-35.8-80-80V96C14.3 96 0 81.7 0 64zM136 96H88V256h48V96zM288 64c0-17.7 14.3-32 32-32h56 48 56c17.7 0 32 14.3 32 32s-14.3 32-32 32V400c0 44.2-35.8 80-80 80s-80-35.8-80-80V96c-17.7 0-32-14.3-32-32zM424 96H376V256h48V96z"
    ]
};
var $d8206b3ab2e65c05$export$f193138a7d21971c = {
    prefix: "fas",
    iconName: "plug-circle-plus",
    icon: [
        576,
        512,
        [],
        "e55f",
        "M96 0C78.3 0 64 14.3 64 32v96h64V32c0-17.7-14.3-32-32-32zM288 0c-17.7 0-32 14.3-32 32v96h64V32c0-17.7-14.3-32-32-32zM32 160c-17.7 0-32 14.3-32 32s14.3 32 32 32v32c0 77.4 55 142 128 156.8V480c0 17.7 14.3 32 32 32s32-14.3 32-32V412.8c12.3-2.5 24.1-6.4 35.1-11.5c-2.1-10.8-3.1-21.9-3.1-33.3c0-80.3 53.8-148 127.3-169.2c.5-2.2 .7-4.5 .7-6.8c0-17.7-14.3-32-32-32H32zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm16-208v48h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H448v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V384H368c-8.8 0-16-7.2-16-16s7.2-16 16-16h48V304c0-8.8 7.2-16 16-16s16 7.2 16 16z"
    ]
};
var $d8206b3ab2e65c05$export$c5a9302c8c13c79a = {
    prefix: "fas",
    iconName: "place-of-worship",
    icon: [
        640,
        512,
        [],
        "f67f",
        "M224 109.3V217.6L183.3 242c-14.5 8.7-23.3 24.3-23.3 41.2V512h96V416c0-35.3 28.7-64 64-64s64 28.7 64 64v96h96V283.2c0-16.9-8.8-32.5-23.3-41.2L416 217.6V109.3c0-8.5-3.4-16.6-9.4-22.6L331.3 11.3c-6.2-6.2-16.4-6.2-22.6 0L233.4 86.6c-6 6-9.4 14.1-9.4 22.6zM24.9 330.3C9.5 338.8 0 354.9 0 372.4V464c0 26.5 21.5 48 48 48h80V273.6L24.9 330.3zM592 512c26.5 0 48-21.5 48-48V372.4c0-17.5-9.5-33.6-24.9-42.1L512 273.6V512h80z"
    ]
};
var $d8206b3ab2e65c05$export$cacbd95c283996ec = {
    prefix: "fas",
    iconName: "grip-vertical",
    icon: [
        320,
        512,
        [],
        "f58e",
        "M40 352l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40zm192 0l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40zM40 320c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0zM232 192l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40zM40 160c-22.1 0-40-17.9-40-40L0 72C0 49.9 17.9 32 40 32l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0zM232 32l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40z"
    ]
};
var $d8206b3ab2e65c05$export$2d3ccb9b2099f3fe = {
    prefix: "fas",
    iconName: "arrow-turn-up",
    icon: [
        384,
        512,
        [
            "level-up"
        ],
        "f148",
        "M32 448c-17.7 0-32 14.3-32 32s14.3 32 32 32l96 0c53 0 96-43 96-96l0-306.7 73.4 73.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 109.3 160 416c0 17.7-14.3 32-32 32l-96 0z"
    ]
};
var $d8206b3ab2e65c05$export$c227d3ba1de97ceb = $d8206b3ab2e65c05$export$2d3ccb9b2099f3fe;
var $d8206b3ab2e65c05$export$4f39e8dbaf09ea8b = {
    prefix: "fas",
    iconName: "u",
    icon: [
        384,
        512,
        [
            117
        ],
        "55",
        "M32 32c17.7 0 32 14.3 32 32V288c0 70.7 57.3 128 128 128s128-57.3 128-128V64c0-17.7 14.3-32 32-32s32 14.3 32 32V288c0 106-86 192-192 192S0 394 0 288V64C0 46.3 14.3 32 32 32z"
    ]
};
var $d8206b3ab2e65c05$export$60b44cfa7af18422 = {
    prefix: "fas",
    iconName: "square-root-variable",
    icon: [
        576,
        512,
        [
            "square-root-alt"
        ],
        "f698",
        "M282.6 78.1c8-27.3 33-46.1 61.4-46.1H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H344L238.7 457c-3.6 12.3-14.1 21.2-26.8 22.8s-25.1-4.6-31.5-15.6L77.6 288H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H77.6c22.8 0 43.8 12.1 55.3 31.8l65.2 111.8L282.6 78.1zM393.4 233.4c12.5-12.5 32.8-12.5 45.3 0L480 274.7l41.4-41.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L525.3 320l41.4 41.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L480 365.3l-41.4 41.4c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L434.7 320l-41.4-41.4c-12.5-12.5-12.5-32.8 0-45.3z"
    ]
};
var $d8206b3ab2e65c05$export$28e4b96627e00057 = $d8206b3ab2e65c05$export$60b44cfa7af18422;
var $d8206b3ab2e65c05$export$95b9968e7fceb821 = {
    prefix: "fas",
    iconName: "clock",
    icon: [
        512,
        512,
        [
            128339,
            "clock-four"
        ],
        "f017",
        "M256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zM232 120V256c0 8 4 15.5 10.7 20l96 64c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L280 243.2V120c0-13.3-10.7-24-24-24s-24 10.7-24 24z"
    ]
};
var $d8206b3ab2e65c05$export$9a575facf1cab48f = $d8206b3ab2e65c05$export$95b9968e7fceb821;
var $d8206b3ab2e65c05$export$5d2b6a700940df16 = {
    prefix: "fas",
    iconName: "backward-step",
    icon: [
        320,
        512,
        [
            "step-backward"
        ],
        "f048",
        "M267.5 440.6c9.5 7.9 22.8 9.7 34.1 4.4s18.4-16.6 18.4-29V96c0-12.4-7.2-23.7-18.4-29s-24.5-3.6-34.1 4.4l-192 160L64 241V96c0-17.7-14.3-32-32-32S0 78.3 0 96V416c0 17.7 14.3 32 32 32s32-14.3 32-32V271l11.5 9.6 192 160z"
    ]
};
var $d8206b3ab2e65c05$export$2884e379aed297d4 = $d8206b3ab2e65c05$export$5d2b6a700940df16;
var $d8206b3ab2e65c05$export$d7ff2047dbc34562 = {
    prefix: "fas",
    iconName: "pallet",
    icon: [
        640,
        512,
        [],
        "f482",
        "M32 320c-17.7 0-32 14.3-32 32s14.3 32 32 32H64v64H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H96 320 544h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H576V384h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H544 320 96 32zm96 64H288v64H128V384zm224 0H512v64H352V384z"
    ]
};
var $d8206b3ab2e65c05$export$a0856b225f3b0614 = {
    prefix: "fas",
    iconName: "faucet",
    icon: [
        512,
        512,
        [],
        "e005",
        "M192 96v12L96 96c-17.7 0-32 14.3-32 32s14.3 32 32 32l96-12 31-3.9 1-.1 1 .1 31 3.9 96 12c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 12V96c0-17.7-14.3-32-32-32s-32 14.3-32 32zM32 256c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H132.1c20.2 29 53.9 48 91.9 48s71.7-19 91.9-48H352c17.7 0 32 14.3 32 32s14.3 32 32 32h64c17.7 0 32-14.3 32-32c0-88.4-71.6-160-160-160H320l-22.6-22.6c-6-6-14.1-9.4-22.6-9.4H256V180.2l-32-4-32 4V224H173.3c-8.5 0-16.6 3.4-22.6 9.4L128 256H32z"
    ]
};
var $d8206b3ab2e65c05$export$59669f486ab41d86 = {
    prefix: "fas",
    iconName: "baseball-bat-ball",
    icon: [
        512,
        512,
        [],
        "f432",
        "M424 0c-12.4 0-24.2 4.9-33 13.7L233.5 171.2c-10.5 10.5-19.8 22.1-27.7 34.6L132.7 321.6c-7.3 11.5-15.8 22.2-25.5 31.9L69.9 390.7l51.3 51.3 37.3-37.3c9.6-9.6 20.3-18.2 31.9-25.5l115.8-73.1c12.5-7.9 24.1-17.2 34.6-27.7L498.3 121c8.7-8.7 13.7-20.6 13.7-33s-4.9-24.2-13.7-33L457 13.7C448.2 4.9 436.4 0 424 0zm88 432a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM15 399c-9.4 9.4-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L49 399c-9.4-9.4-24.6-9.4-33.9 0z"
    ]
};
var $d8206b3ab2e65c05$export$cb39585371b75720 = {
    prefix: "fas",
    iconName: "s",
    icon: [
        320,
        512,
        [
            115
        ],
        "53",
        "M99.1 105.4C79 114 68.2 127.2 65.2 144.8c-2.4 14.1-.7 23.2 2 29.4c2.8 6.3 7.9 12.4 16.7 18.6c19.2 13.4 48.3 22.1 84.9 32.5c1 .3 1.9 .6 2.9 .8c32.7 9.3 72 20.6 100.9 40.7c15.7 10.9 29.9 25.5 38.6 45.1c8.8 19.8 10.8 42 6.6 66.3c-7.3 42.5-35.3 71.7-71.8 87.3c-35.4 15.2-79.1 17.9-123.7 10.9l-.2 0 0 0c-24-3.9-62.7-17.1-87.6-25.6c-4.8-1.7-9.2-3.1-12.8-4.3C5.1 440.8-3.9 422.7 1.6 405.9s23.7-25.8 40.5-20.3c4.9 1.6 10.2 3.4 15.9 5.4c25.4 8.6 56.4 19.2 74.4 22.1c36.8 5.7 67.5 2.5 88.5-6.5c20.1-8.6 30.8-21.8 33.9-39.4c2.4-14.1 .7-23.2-2-29.4c-2.8-6.3-7.9-12.4-16.7-18.6c-19.2-13.4-48.3-22.1-84.9-32.5c-1-.3-1.9-.6-2.9-.8c-32.7-9.3-72-20.6-100.9-40.7c-15.7-10.9-29.9-25.5-38.6-45.1c-8.8-19.8-10.8-42-6.6-66.3l31.5 5.5L2.1 133.9C9.4 91.4 37.4 62.2 73.9 46.6c35.4-15.2 79.1-17.9 123.7-10.9c13 2 52.4 9.6 66.6 13.4c17.1 4.5 27.2 22.1 22.7 39.2s-22.1 27.2-39.2 22.7c-11.2-3-48.1-10.2-60.1-12l4.9-31.5-4.9 31.5c-36.9-5.8-67.5-2.5-88.6 6.5z"
    ]
};
var $d8206b3ab2e65c05$export$5e239d90ef904a84 = {
    prefix: "fas",
    iconName: "timeline",
    icon: [
        640,
        512,
        [],
        "e29c",
        "M128 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm32 97.3c28.3-12.3 48-40.5 48-73.3c0-44.2-35.8-80-80-80S48 51.8 48 96c0 32.8 19.7 61 48 73.3V224H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H288v54.7c-28.3 12.3-48 40.5-48 73.3c0 44.2 35.8 80 80 80s80-35.8 80-80c0-32.8-19.7-61-48-73.3V288H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H544V169.3c28.3-12.3 48-40.5 48-73.3c0-44.2-35.8-80-80-80s-80 35.8-80 80c0 32.8 19.7 61 48 73.3V224H160V169.3zM488 96a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM320 392a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
    ]
};
var $d8206b3ab2e65c05$export$fb61df5d98785fa8 = {
    prefix: "fas",
    iconName: "keyboard",
    icon: [
        576,
        512,
        [
            9000
        ],
        "f11c",
        "M64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zm16 64h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16zM64 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V240zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V336c0-8.8 7.2-16 16-16zm80-176c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V144zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zM160 336c0-8.8 7.2-16 16-16H400c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V336zM272 128h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16zM256 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V240zM368 128h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16zM352 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16V240zM464 128h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H464c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16zM448 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H464c-8.8 0-16-7.2-16-16V240zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H464c-8.8 0-16-7.2-16-16V336c0-8.8 7.2-16 16-16z"
    ]
};
var $d8206b3ab2e65c05$export$f9395ef707603e40 = {
    prefix: "fas",
    iconName: "caret-down",
    icon: [
        320,
        512,
        [],
        "f0d7",
        "M137.4 374.6c12.5 12.5 32.8 12.5 45.3 0l128-128c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8L32 192c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l128 128z"
    ]
};
var $d8206b3ab2e65c05$export$9c73560282dceccd = {
    prefix: "fas",
    iconName: "house-chimney-medical",
    icon: [
        576,
        512,
        [
            "clinic-medical"
        ],
        "f7f2",
        "M575.8 255.5c0 18-15 32.1-32 32.1h-32l.7 160.2c.2 35.5-28.5 64.3-64 64.3H128.1c-35.3 0-64-28.7-64-64V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L416 100.7V64c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32V185l52.8 46.4c8 7 12 15 11 24zM272 192c-8.8 0-16 7.2-16 16v48H208c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320h48c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H320V208c0-8.8-7.2-16-16-16H272z"
    ]
};
var $d8206b3ab2e65c05$export$20d8a680febc7434 = $d8206b3ab2e65c05$export$9c73560282dceccd;
var $d8206b3ab2e65c05$export$7ed2bad15ae6237f = {
    prefix: "fas",
    iconName: "temperature-three-quarters",
    icon: [
        320,
        512,
        [
            "temperature-3",
            "thermometer-3",
            "thermometer-three-quarters"
        ],
        "f2c8",
        "M160 64c-26.5 0-48 21.5-48 48V276.5c0 17.3-7.1 31.9-15.3 42.5C86.2 332.6 80 349.5 80 368c0 44.2 35.8 80 80 80s80-35.8 80-80c0-18.5-6.2-35.4-16.7-48.9c-8.2-10.6-15.3-25.2-15.3-42.5V112c0-26.5-21.5-48-48-48zM48 112C48 50.2 98.1 0 160 0s112 50.1 112 112V276.5c0 .1 .1 .3 .2 .6c.2 .6 .8 1.6 1.7 2.8c18.9 24.4 30.1 55 30.1 88.1c0 79.5-64.5 144-144 144S16 447.5 16 368c0-33.2 11.2-63.8 30.1-88.1c.9-1.2 1.5-2.2 1.7-2.8c.1-.3 .2-.5 .2-.6V112zM208 368c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V144c0-8.8 7.2-16 16-16s16 7.2 16 16V322.7c18.6 6.6 32 24.4 32 45.3z"
    ]
};
var $d8206b3ab2e65c05$export$89def3268ed9b4bc = $d8206b3ab2e65c05$export$7ed2bad15ae6237f;
var $d8206b3ab2e65c05$export$2f653125f4e6463 = $d8206b3ab2e65c05$export$7ed2bad15ae6237f;
var $d8206b3ab2e65c05$export$6c632d1dc30d4a77 = $d8206b3ab2e65c05$export$7ed2bad15ae6237f;
var $d8206b3ab2e65c05$export$8867e7da34bb8bf4 = {
    prefix: "fas",
    iconName: "mobile-screen",
    icon: [
        384,
        512,
        [
            "mobile-android-alt"
        ],
        "f3cf",
        "M16 64C16 28.7 44.7 0 80 0H304c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H80c-35.3 0-64-28.7-64-64V64zM144 448c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H160c-8.8 0-16 7.2-16 16zM304 64H80V384H304V64z"
    ]
};
var $d8206b3ab2e65c05$export$cb39d7b468ba5838 = $d8206b3ab2e65c05$export$8867e7da34bb8bf4;
var $d8206b3ab2e65c05$export$a5f2976a01fdc970 = {
    prefix: "fas",
    iconName: "plane-up",
    icon: [
        512,
        512,
        [],
        "e22d",
        "M192 93.7C192 59.5 221 0 256 0c36 0 64 59.5 64 93.7l0 66.3L497.8 278.5c8.9 5.9 14.2 15.9 14.2 26.6v56.7c0 10.9-10.7 18.6-21.1 15.2L320 320v80l57.6 43.2c4 3 6.4 7.8 6.4 12.8v42c0 7.8-6.3 14-14 14c-1.3 0-2.6-.2-3.9-.5L256 480 145.9 511.5c-1.3 .4-2.6 .5-3.9 .5c-7.8 0-14-6.3-14-14V456c0-5 2.4-9.8 6.4-12.8L192 400V320L21.1 377C10.7 380.4 0 372.7 0 361.8V305.1c0-10.7 5.3-20.7 14.2-26.6L192 160V93.7z"
    ]
};
var $d8206b3ab2e65c05$export$46d49a6734c4872a = {
    prefix: "fas",
    iconName: "piggy-bank",
    icon: [
        576,
        512,
        [],
        "f4d3",
        "M400 96l0 .7c-5.3-.4-10.6-.7-16-.7H256c-16.5 0-32.5 2.1-47.8 6c-.1-2-.2-4-.2-6c0-53 43-96 96-96s96 43 96 96zm-16 32c3.5 0 7 .1 10.4 .3c4.2 .3 8.4 .7 12.6 1.3C424.6 109.1 450.8 96 480 96h11.5c10.4 0 18 9.8 15.5 19.9l-13.8 55.2c15.8 14.8 28.7 32.8 37.5 52.9H544c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H512c-9.1 12.1-19.9 22.9-32 32v64c0 17.7-14.3 32-32 32H416c-17.7 0-32-14.3-32-32V448H256v32c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V416c-34.9-26.2-58.7-66.3-63.2-112H68c-37.6 0-68-30.4-68-68s30.4-68 68-68h4c13.3 0 24 10.7 24 24s-10.7 24-24 24H68c-11 0-20 9-20 20s9 20 20 20H99.2c12.1-59.8 57.7-107.5 116.3-122.8c12.9-3.4 26.5-5.2 40.5-5.2H384zm64 136a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"
    ]
};
var $d8206b3ab2e65c05$export$e6dadc1155c4ee48 = {
    prefix: "fas",
    iconName: "battery-half",
    icon: [
        576,
        512,
        [
            "battery-3"
        ],
        "f242",
        "M464 160c8.8 0 16 7.2 16 16V336c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16H464zM80 96C35.8 96 0 131.8 0 176V336c0 44.2 35.8 80 80 80H464c44.2 0 80-35.8 80-80V320c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32V176c0-44.2-35.8-80-80-80H80zm208 96H96V320H288V192z"
    ]
};
var $d8206b3ab2e65c05$export$f9138caac2aedaed = $d8206b3ab2e65c05$export$e6dadc1155c4ee48;
var $d8206b3ab2e65c05$export$28f06bbf9c17c3af = {
    prefix: "fas",
    iconName: "mountain-city",
    icon: [
        640,
        512,
        [],
        "e52e",
        "M336 0c-26.5 0-48 21.5-48 48v92.1l71.4 118.4c2.5-1.6 5.4-2.5 8.6-2.5h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-3.5l73.8 122.4c12.4 20.6 12.9 46.3 1.2 67.3c-.4 .8-.9 1.6-1.4 2.3H592c26.5 0 48-21.5 48-48V240c0-26.5-21.5-48-48-48H568V120c0-13.3-10.7-24-24-24s-24 10.7-24 24v72H480V48c0-26.5-21.5-48-48-48H336zm32 64h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16zM352 176c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16V176zm160 96c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H528c-8.8 0-16-7.2-16-16V272zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H528c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16zM224 188.9L283.8 288H223l-48 64-24.6-41.2L224 188.9zm29.4-44.2C247.1 134.3 236 128 224 128s-23.1 6.3-29.4 16.7L5.1 458.9c-6.5 10.8-6.7 24.3-.7 35.3S22 512 34.5 512H413.5c12.5 0 24-6.8 30.1-17.8s5.8-24.5-.7-35.3L253.4 144.7z"
    ]
};
var $d8206b3ab2e65c05$export$bc5da164799a0e = {
    prefix: "fas",
    iconName: "coins",
    icon: [
        512,
        512,
        [],
        "f51e",
        "M512 80c0 18-14.3 34.6-38.4 48c-29.1 16.1-72.5 27.5-122.3 30.9c-3.7-1.8-7.4-3.5-11.3-5C300.6 137.4 248.2 128 192 128c-8.3 0-16.4 .2-24.5 .6l-1.1-.6C142.3 114.6 128 98 128 80c0-44.2 86-80 192-80S512 35.8 512 80zM160.7 161.1c10.2-.7 20.7-1.1 31.3-1.1c62.2 0 117.4 12.3 152.5 31.4C369.3 204.9 384 221.7 384 240c0 4-.7 7.9-2.1 11.7c-4.6 13.2-17 25.3-35 35.5c0 0 0 0 0 0c-.1 .1-.3 .1-.4 .2l0 0 0 0c-.3 .2-.6 .3-.9 .5c-35 19.4-90.8 32-153.6 32c-59.6 0-112.9-11.3-148.2-29.1c-1.9-.9-3.7-1.9-5.5-2.9C14.3 274.6 0 258 0 240c0-34.8 53.4-64.5 128-75.4c10.5-1.5 21.4-2.7 32.7-3.5zM416 240c0-21.9-10.6-39.9-24.1-53.4c28.3-4.4 54.2-11.4 76.2-20.5c16.3-6.8 31.5-15.2 43.9-25.5V176c0 19.3-16.5 37.1-43.8 50.9c-14.6 7.4-32.4 13.7-52.4 18.5c.1-1.8 .2-3.5 .2-5.3zm-32 96c0 18-14.3 34.6-38.4 48c-1.8 1-3.6 1.9-5.5 2.9C304.9 404.7 251.6 416 192 416c-62.8 0-118.6-12.6-153.6-32C14.3 370.6 0 354 0 336V300.6c12.5 10.3 27.6 18.7 43.9 25.5C83.4 342.6 135.8 352 192 352s108.6-9.4 148.1-25.9c7.8-3.2 15.3-6.9 22.4-10.9c6.1-3.4 11.8-7.2 17.2-11.2c1.5-1.1 2.9-2.3 4.3-3.4V304v5.7V336zm32 0V304 278.1c19-4.2 36.5-9.5 52.1-16c16.3-6.8 31.5-15.2 43.9-25.5V272c0 10.5-5 21-14.9 30.9c-16.3 16.3-45 29.7-81.3 38.4c.1-1.7 .2-3.5 .2-5.3zM192 448c56.2 0 108.6-9.4 148.1-25.9c16.3-6.8 31.5-15.2 43.9-25.5V432c0 44.2-86 80-192 80S0 476.2 0 432V396.6c12.5 10.3 27.6 18.7 43.9 25.5C83.4 438.6 135.8 448 192 448z"
    ]
};
var $d8206b3ab2e65c05$export$8d41d1f1ba3f9217 = {
    prefix: "fas",
    iconName: "khanda",
    icon: [
        512,
        512,
        [
            9772
        ],
        "f66d",
        "M245.8 3.7c5.9-4.9 14.6-4.9 20.5 0l48 40c5.9 4.9 7.5 13.2 3.8 19.9l0 0 0 0 0 0 0 0-.1 .1-.3 .6c-.3 .5-.7 1.3-1.2 2.3c-1 2-2.6 5-4.4 8.6c-.5 .9-.9 1.9-1.4 2.9C344.9 97.4 368 134 368 176s-23.1 78.6-57.3 97.8c.5 1 1 2 1.4 2.9c1.8 3.7 3.3 6.6 4.4 8.6c.5 1 .9 1.8 1.2 2.3l.3 .6 .1 .1 0 0 0 0c3.6 6.7 2 15-3.8 19.9L272 343.5v19.8l35.6-24.5 41.1-28.2c42.8-29.4 68.4-78 68.4-130c0-31.1-9.2-61.6-26.5-87.5l-2.8-4.2c-4-6-3.5-14 1.3-19.5s12.7-7 19.2-3.7L401.1 80c7.2-14.3 7.2-14.3 7.2-14.3l0 0 0 0 .1 0 .3 .2 1 .5c.8 .4 2 1.1 3.5 1.9c2.9 1.7 7 4.1 11.8 7.3c9.6 6.4 22.5 16.1 35.4 29c25.7 25.7 52.7 65.6 52.7 119.3c0 53.1-26.4 100.5-51.2 133.6c-12.6 16.7-25.1 30.3-34.5 39.7c-4.7 4.7-8.7 8.4-11.5 10.9c-1.4 1.3-2.5 2.2-3.3 2.9l-.9 .8-.3 .2-.1 .1 0 0 0 0s0 0-10.2-12.3l10.2 12.3c-5.1 4.3-12.4 4.9-18.2 1.6l-75.6-43-32.7 22.5 45.5 31.3c1.8-.4 3.7-.7 5.7-.7c13.3 0 24 10.7 24 24s-10.7 24-24 24c-12.2 0-22.3-9.1-23.8-21L272 423.4v28.9c9.6 5.5 16 15.9 16 27.7c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-11.8 6.4-22.2 16-27.7V424.1l-40.3 27.7C197.8 463.3 187.9 472 176 472c-13.3 0-24-10.7-24-24s10.7-24 24-24c2.2 0 4.4 .3 6.5 .9l45.8-31.5-32.7-22.5-75.6 43c-5.8 3.3-13 2.7-18.2-1.6L112 400c-10.2 12.3-10.2 12.3-10.3 12.3l0 0 0 0-.1-.1-.3-.2-.9-.8c-.8-.7-1.9-1.7-3.3-2.9c-2.8-2.5-6.7-6.2-11.5-10.9c-9.4-9.4-21.9-23-34.5-39.7C26.4 324.5 0 277.1 0 224c0-53.7 26.9-93.6 52.7-119.3c12.9-12.9 25.8-22.6 35.4-29C93 72.5 97 70 99.9 68.4c1.5-.8 2.6-1.5 3.5-1.9l1-.5 .3-.2 .1 0 0 0 0 0s0 0 7.2 14.3l-7.2-14.3c6.5-3.2 14.3-1.7 19.2 3.7s5.3 13.4 1.3 19.5l-2.8 4.2C105.2 119 96 149.5 96 180.6c0 51.9 25.6 100.6 68.4 130l41.1 28.2L240 362.6V343.5l-42.2-35.2c-5.9-4.9-7.5-13.2-3.8-19.9l0 0 0 0 0 0 .1-.1 .3-.6c.3-.5 .7-1.3 1.2-2.3c1-2 2.6-5 4.4-8.6c.5-.9 .9-1.9 1.4-2.9C167.1 254.6 144 218 144 176s23.1-78.6 57.3-97.8c-.5-1-1-2-1.4-2.9c-1.8-3.7-3.3-6.6-4.4-8.6c-.5-1-.9-1.8-1.2-2.3l-.3-.6-.1-.1 0 0 0 0 0 0c-3.6-6.7-2-15 3.8-19.9l48-40zM220.2 122.9c-17 11.5-28.2 31-28.2 53.1s11.2 41.6 28.2 53.1C227 210.2 232 190.9 232 176s-5-34.2-11.8-53.1zm71.5 106.2c17-11.5 28.2-31 28.2-53.1s-11.2-41.6-28.2-53.1C285 141.8 280 161.1 280 176s5 34.2 11.8 53.1z"
    ]
};
var $d8206b3ab2e65c05$export$ea6970ed5a15feb6 = {
    prefix: "fas",
    iconName: "sliders",
    icon: [
        512,
        512,
        [
            "sliders-h"
        ],
        "f1de",
        "M0 416c0 17.7 14.3 32 32 32l54.7 0c12.3 28.3 40.5 48 73.3 48s61-19.7 73.3-48L480 448c17.7 0 32-14.3 32-32s-14.3-32-32-32l-246.7 0c-12.3-28.3-40.5-48-73.3-48s-61 19.7-73.3 48L32 384c-17.7 0-32 14.3-32 32zm128 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM320 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32-80c-32.8 0-61 19.7-73.3 48L32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l246.7 0c12.3 28.3 40.5 48 73.3 48s61-19.7 73.3-48l54.7 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-54.7 0c-12.3-28.3-40.5-48-73.3-48zM192 128a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm73.3-64C253 35.7 224.8 16 192 16s-61 19.7-73.3 48L32 64C14.3 64 0 78.3 0 96s14.3 32 32 32l86.7 0c12.3 28.3 40.5 48 73.3 48s61-19.7 73.3-48L480 128c17.7 0 32-14.3 32-32s-14.3-32-32-32L265.3 64z"
    ]
};
var $d8206b3ab2e65c05$export$94d4dcb523f95563 = $d8206b3ab2e65c05$export$ea6970ed5a15feb6;
var $d8206b3ab2e65c05$export$54d16fa2e445d3fe = {
    prefix: "fas",
    iconName: "folder-tree",
    icon: [
        576,
        512,
        [],
        "f802",
        "M64 32C64 14.3 49.7 0 32 0S0 14.3 0 32v96V384c0 35.3 28.7 64 64 64H256V384H64V160H256V96H64V32zM288 192c0 17.7 14.3 32 32 32H544c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H445.3c-8.5 0-16.6-3.4-22.6-9.4L409.4 9.4c-6-6-14.1-9.4-22.6-9.4H320c-17.7 0-32 14.3-32 32V192zm0 288c0 17.7 14.3 32 32 32H544c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32H445.3c-8.5 0-16.6-3.4-22.6-9.4l-13.3-13.3c-6-6-14.1-9.4-22.6-9.4H320c-17.7 0-32 14.3-32 32V480z"
    ]
};
var $d8206b3ab2e65c05$export$882cabd11f4943b8 = {
    prefix: "fas",
    iconName: "network-wired",
    icon: [
        640,
        512,
        [],
        "f6ff",
        "M256 64H384v64H256V64zM240 0c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48h48v32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h96v32H80c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48H240c26.5 0 48-21.5 48-48V368c0-26.5-21.5-48-48-48H192V288H448v32H400c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48H560c26.5 0 48-21.5 48-48V368c0-26.5-21.5-48-48-48H512V288h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H352V192h48c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H240zM96 448V384H224v64H96zm320-64H544v64H416V384z"
    ]
};
var $d8206b3ab2e65c05$export$184725965b3402dc = {
    prefix: "fas",
    iconName: "map-pin",
    icon: [
        320,
        512,
        [
            128205
        ],
        "f276",
        "M16 144a144 144 0 1 1 288 0A144 144 0 1 1 16 144zM160 80c8.8 0 16-7.2 16-16s-7.2-16-16-16c-53 0-96 43-96 96c0 8.8 7.2 16 16 16s16-7.2 16-16c0-35.3 28.7-64 64-64zM128 480V317.1c10.4 1.9 21.1 2.9 32 2.9s21.6-1 32-2.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32z"
    ]
};
var $d8206b3ab2e65c05$export$38d20d399463edf9 = {
    prefix: "fas",
    iconName: "hamsa",
    icon: [
        512,
        512,
        [],
        "f665",
        "M34.6 288H80c8.8 0 16-7.2 16-16V72c0-22.1 17.9-40 40-40s40 17.9 40 40V204c0 11 9 20 20 20s20-9 20-20V40c0-22.1 17.9-40 40-40s40 17.9 40 40V204c0 11 9 20 20 20s20-9 20-20V72c0-22.1 17.9-40 40-40s40 17.9 40 40V272c0 8.8 7.2 16 16 16h45.4c19.1 0 34.6 15.5 34.6 34.6c0 8.6-3.2 16.9-9 23.3L416.6 441c-41.1 45.2-99.4 71-160.6 71s-119.4-25.8-160.6-71L9 345.9c-5.8-6.4-9-14.7-9-23.3C0 303.5 15.5 288 34.6 288zM256 288c-38.4 0-76.8 35.8-90.6 50.2c-3.6 3.7-5.4 8.7-5.4 13.8s1.8 10.1 5.4 13.8C179.2 380.2 217.6 416 256 416s76.8-35.8 90.6-50.2c3.6-3.7 5.4-8.7 5.4-13.8s-1.8-10.1-5.4-13.8C332.8 323.8 294.4 288 256 288zm0 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $d8206b3ab2e65c05$export$875b6c94a4b00ea8 = {
    prefix: "fas",
    iconName: "cent-sign",
    icon: [
        384,
        512,
        [],
        "e3f5",
        "M224 0c17.7 0 32 14.3 32 32V66.7c30.9 5.2 59.2 17.7 83.2 35.8c14.1 10.6 17 30.7 6.4 44.8s-30.7 17-44.8 6.4C279.4 137.5 252.9 128 224 128c-70.7 0-128 57.3-128 128s57.3 128 128 128c28.9 0 55.4-9.5 76.8-25.6c14.1-10.6 34.2-7.8 44.8 6.4s7.8 34.2-6.4 44.8c-24 18-52.4 30.6-83.2 35.8V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V445.3C101.2 430.1 32 351.1 32 256s69.2-174.1 160-189.3V32c0-17.7 14.3-32 32-32z"
    ]
};
var $d8206b3ab2e65c05$export$f9b579ba06048af = {
    prefix: "fas",
    iconName: "flask",
    icon: [
        448,
        512,
        [],
        "f0c3",
        "M288 0H160 128C110.3 0 96 14.3 96 32s14.3 32 32 32V196.8c0 11.8-3.3 23.5-9.5 33.5L10.3 406.2C3.6 417.2 0 429.7 0 442.6C0 480.9 31.1 512 69.4 512H378.6c38.3 0 69.4-31.1 69.4-69.4c0-12.8-3.6-25.4-10.3-36.4L329.5 230.4c-6.2-10.1-9.5-21.7-9.5-33.5V64c17.7 0 32-14.3 32-32s-14.3-32-32-32H288zM192 196.8V64h64V196.8c0 23.7 6.6 46.9 19 67.1L309.5 320h-171L173 263.9c12.4-20.2 19-43.4 19-67.1z"
    ]
};
var $d8206b3ab2e65c05$export$e7b4c26b5857fe9c = {
    prefix: "fas",
    iconName: "person-pregnant",
    icon: [
        384,
        512,
        [],
        "e31e",
        "M192 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM120 383c-13.8-3.6-24-16.1-24-31V296.9l-4.6 7.6c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c15-24.9 40.3-41.5 68.7-45.6c4.1-.6 8.2-1 12.5-1h1.1 12.5H192c1.4 0 2.8 .1 4.1 .3c35.7 2.9 65.4 29.3 72.1 65l6.1 32.5c44.3 8.6 77.7 47.5 77.7 94.3v32c0 17.7-14.3 32-32 32H304 264v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V384h-8-8v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V383z"
    ]
};
var $d8206b3ab2e65c05$export$76cc39f249b6864e = {
    prefix: "fas",
    iconName: "wand-sparkles",
    icon: [
        512,
        512,
        [],
        "f72b",
        "M464 6.1c9.5-8.5 24-8.1 33 .9l8 8c9 9 9.4 23.5 .9 33l-85.8 95.9c-2.6 2.9-4.1 6.7-4.1 10.7V176c0 8.8-7.2 16-16 16H384.2c-4.6 0-8.9 1.9-11.9 5.3L100.7 500.9C94.3 508 85.3 512 75.8 512c-8.8 0-17.3-3.5-23.5-9.8L9.7 459.7C3.5 453.4 0 445 0 436.2c0-9.5 4-18.5 11.1-24.8l111.6-99.8c3.4-3 5.3-7.4 5.3-11.9V272c0-8.8 7.2-16 16-16h34.6c3.9 0 7.7-1.5 10.7-4.1L464 6.1zM432 288c3.6 0 6.7 2.4 7.7 5.8l14.8 51.7 51.7 14.8c3.4 1 5.8 4.1 5.8 7.7s-2.4 6.7-5.8 7.7l-51.7 14.8-14.8 51.7c-1 3.4-4.1 5.8-7.7 5.8s-6.7-2.4-7.7-5.8l-14.8-51.7-51.7-14.8c-3.4-1-5.8-4.1-5.8-7.7s2.4-6.7 5.8-7.7l51.7-14.8 14.8-51.7c1-3.4 4.1-5.8 7.7-5.8zM87.7 69.8l14.8 51.7 51.7 14.8c3.4 1 5.8 4.1 5.8 7.7s-2.4 6.7-5.8 7.7l-51.7 14.8L87.7 218.2c-1 3.4-4.1 5.8-7.7 5.8s-6.7-2.4-7.7-5.8L57.5 166.5 5.8 151.7c-3.4-1-5.8-4.1-5.8-7.7s2.4-6.7 5.8-7.7l51.7-14.8L72.3 69.8c1-3.4 4.1-5.8 7.7-5.8s6.7 2.4 7.7 5.8zM208 0c3.7 0 6.9 2.5 7.8 6.1l6.8 27.3 27.3 6.8c3.6 .9 6.1 4.1 6.1 7.8s-2.5 6.9-6.1 7.8l-27.3 6.8-6.8 27.3c-.9 3.6-4.1 6.1-7.8 6.1s-6.9-2.5-7.8-6.1l-6.8-27.3-27.3-6.8c-3.6-.9-6.1-4.1-6.1-7.8s2.5-6.9 6.1-7.8l27.3-6.8 6.8-27.3c.9-3.6 4.1-6.1 7.8-6.1z"
    ]
};
var $d8206b3ab2e65c05$export$7480721bf113be3e = {
    prefix: "fas",
    iconName: "ellipsis-vertical",
    icon: [
        128,
        512,
        [
            "ellipsis-v"
        ],
        "f142",
        "M64 360a56 56 0 1 0 0 112 56 56 0 1 0 0-112zm0-160a56 56 0 1 0 0 112 56 56 0 1 0 0-112zM120 96A56 56 0 1 0 8 96a56 56 0 1 0 112 0z"
    ]
};
var $d8206b3ab2e65c05$export$e58494c7fcb5380 = $d8206b3ab2e65c05$export$7480721bf113be3e;
var $d8206b3ab2e65c05$export$3604f15924cf0b98 = {
    prefix: "fas",
    iconName: "ticket",
    icon: [
        576,
        512,
        [
            127903
        ],
        "f145",
        "M64 64C28.7 64 0 92.7 0 128v64c0 8.8 7.4 15.7 15.7 18.6C34.5 217.1 48 235 48 256s-13.5 38.9-32.3 45.4C7.4 304.3 0 311.2 0 320v64c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V320c0-8.8-7.4-15.7-15.7-18.6C541.5 294.9 528 277 528 256s13.5-38.9 32.3-45.4c8.3-2.9 15.7-9.8 15.7-18.6V128c0-35.3-28.7-64-64-64H64zm64 112l0 160c0 8.8 7.2 16 16 16H432c8.8 0 16-7.2 16-16V176c0-8.8-7.2-16-16-16H144c-8.8 0-16 7.2-16 16zM96 160c0-17.7 14.3-32 32-32H448c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32V160z"
    ]
};
var $d8206b3ab2e65c05$export$a1cca9928dcf9798 = {
    prefix: "fas",
    iconName: "power-off",
    icon: [
        512,
        512,
        [
            9211
        ],
        "f011",
        "M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V256c0 17.7 14.3 32 32 32s32-14.3 32-32V32zM143.5 120.6c13.6-11.3 15.4-31.5 4.1-45.1s-31.5-15.4-45.1-4.1C49.7 115.4 16 181.8 16 256c0 132.5 107.5 240 240 240s240-107.5 240-240c0-74.2-33.8-140.6-86.6-184.6c-13.6-11.3-33.8-9.4-45.1 4.1s-9.4 33.8 4.1 45.1c38.9 32.3 63.5 81 63.5 135.4c0 97.2-78.8 176-176 176s-176-78.8-176-176c0-54.4 24.7-103.1 63.5-135.4z"
    ]
};
var $d8206b3ab2e65c05$export$b356b1dbe7d7f736 = {
    prefix: "fas",
    iconName: "right-long",
    icon: [
        512,
        512,
        [
            "long-arrow-alt-right"
        ],
        "f30b",
        "M334.5 414c8.8 3.8 19 2 26-4.6l144-136c4.8-4.5 7.5-10.8 7.5-17.4s-2.7-12.9-7.5-17.4l-144-136c-7-6.6-17.2-8.4-26-4.6s-14.5 12.5-14.5 22l0 72L32 192c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l288 0 0 72c0 9.6 5.7 18.2 14.5 22z"
    ]
};
var $d8206b3ab2e65c05$export$533e1f578f74c066 = $d8206b3ab2e65c05$export$b356b1dbe7d7f736;
var $d8206b3ab2e65c05$export$19357abad396e723 = {
    prefix: "fas",
    iconName: "flag-usa",
    icon: [
        448,
        512,
        [],
        "f74d",
        "M32 0C49.7 0 64 14.3 64 32V48l69-17.2c38.1-9.5 78.3-5.1 113.5 12.5c46.3 23.2 100.8 23.2 147.1 0l9.6-4.8C423.8 28.1 448 43.1 448 66.1v36.1l-44.7 16.2c-42.8 15.6-90 13.9-131.6-4.6l-16.1-7.2c-20.3-9-41.8-14.7-63.6-16.9v32.2c17.4 2.1 34.4 6.7 50.6 13.9l16.1 7.2c49.2 21.9 105 23.8 155.6 5.4L448 136.3v62l-44.7 16.2c-42.8 15.6-90 13.9-131.6-4.6l-16.1-7.2c-40.2-17.9-85-22.5-128.1-13.3L64 203.1v32.7l70.2-15.1c36.4-7.8 74.3-3.9 108.4 11.3l16.1 7.2c49.2 21.9 105 23.8 155.6 5.4L448 232.3v62l-44.7 16.2c-42.8 15.6-90 13.9-131.6-4.6l-16.1-7.2c-40.2-17.9-85-22.5-128.1-13.3L64 299.1v32.7l70.2-15.1c36.4-7.8 74.3-3.9 108.4 11.3l16.1 7.2c49.2 21.9 105 23.8 155.6 5.4L448 328.3v33.5c0 13.3-8.3 25.3-20.8 30l-34.7 13c-46.2 17.3-97.6 14.6-141.7-7.4c-37.9-19-81.3-23.7-122.5-13.4L64 400v80c0 17.7-14.3 32-32 32s-32-14.3-32-32V416 345.5 312.8 249.5 216.8 153.5 120.8 64 32C0 14.3 14.3 0 32 0zm80 96A16 16 0 1 0 80 96a16 16 0 1 0 32 0zm32 0a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm-32 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm32 0a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"
    ]
};
var $d8206b3ab2e65c05$export$e1046cf83da9b7ef = {
    prefix: "fas",
    iconName: "laptop-file",
    icon: [
        640,
        512,
        [],
        "e51d",
        "M128 0C92.7 0 64 28.7 64 64V288H19.2C8.6 288 0 296.6 0 307.2C0 349.6 34.4 384 76.8 384H320V288H128V64H448V96h64V64c0-35.3-28.7-64-64-64H128zM512 128H400c-26.5 0-48 21.5-48 48V464c0 26.5 21.5 48 48 48H592c26.5 0 48-21.5 48-48V256H544c-17.7 0-32-14.3-32-32V128zm32 0v96h96l-96-96z"
    ]
};
var $d8206b3ab2e65c05$export$7c85aba0f9624b29 = {
    prefix: "fas",
    iconName: "tty",
    icon: [
        512,
        512,
        [
            "teletype"
        ],
        "f1e4",
        "M38.3 241.3L15.1 200.6c-9.2-16.2-8.4-36.5 4.5-50C61.4 106.8 144.7 48 256 48s194.6 58.8 236.4 102.6c12.9 13.5 13.7 33.8 4.5 50l-23.1 40.7c-7.5 13.2-23.3 19.3-37.8 14.6l-81.1-26.6c-13.1-4.3-22-16.6-22-30.4V144c-49.6-18.1-104-18.1-153.6 0v54.8c0 13.8-8.9 26.1-22 30.4L76.1 255.8c-14.5 4.7-30.3-1.4-37.8-14.6zM32 336c0-8.8 7.2-16 16-16H80c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V336zm0 96c0-8.8 7.2-16 16-16H80c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V432zM144 320h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H144c-8.8 0-16-7.2-16-16V336c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H240c-8.8 0-16-7.2-16-16V336zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H336c-8.8 0-16-7.2-16-16V336c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H432c-8.8 0-16-7.2-16-16V336zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H432c-8.8 0-16-7.2-16-16V432c0-8.8 7.2-16 16-16zM128 432c0-8.8 7.2-16 16-16H368c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H144c-8.8 0-16-7.2-16-16V432z"
    ]
};
var $d8206b3ab2e65c05$export$14bcd5c43dc736f9 = $d8206b3ab2e65c05$export$7c85aba0f9624b29;
var $d8206b3ab2e65c05$export$2faddf1690e14e11 = {
    prefix: "fas",
    iconName: "diagram-next",
    icon: [
        512,
        512,
        [],
        "e476",
        "M512 160c0 35.3-28.7 64-64 64H280v64h46.1c21.4 0 32.1 25.9 17 41L273 399c-9.4 9.4-24.6 9.4-33.9 0L169 329c-15.1-15.1-4.4-41 17-41H232V224H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64v64zM448 416V352H365.3l.4-.4c18.4-18.4 20.4-43.7 11-63.6l71.3 0c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64V352c0-35.3 28.7-64 64-64l71.3 0c-9.4 19.9-7.4 45.2 11 63.6l.4 .4H64v64H210.7l5.7 5.7c21.9 21.9 57.3 21.9 79.2 0l5.7-5.7H448z"
    ]
};
var $d8206b3ab2e65c05$export$b16df914812cedbe = {
    prefix: "fas",
    iconName: "person-rifle",
    icon: [
        576,
        512,
        [],
        "e54e",
        "M265.2 192c25.4 0 49.8 7.1 70.8 19.9V512H144V337.7L90.4 428.3c-11.2 19-35.8 25.3-54.8 14.1s-25.3-35.8-14.1-54.8L97.7 258.8c24.5-41.4 69-66.8 117.1-66.8h50.4zM160 80a80 80 0 1 1 160 0A80 80 0 1 1 160 80zM448 0c8.8 0 16 7.2 16 16V132.3c9.6 5.5 16 15.9 16 27.7V269.3l16-5.3V208c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v84.5c0 6.9-4.4 13-10.9 15.2L480 325.3V352h48c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H484l23 92.1c2.5 10.1-5.1 19.9-15.5 19.9H432c-8.8 0-16-7.2-16-16V400H400c-17.7 0-32-14.3-32-32V224c0-17.7 14.3-32 32-32V160c0-11.8 6.4-22.2 16-27.7V32c-8.8 0-16-7.2-16-16s7.2-16 16-16h16 16z"
    ]
};
var $d8206b3ab2e65c05$export$bc50edea6e121df5 = {
    prefix: "fas",
    iconName: "house-medical-circle-exclamation",
    icon: [
        640,
        512,
        [],
        "e512",
        "M320 368c0 59.5 29.5 112.1 74.8 144H128.1c-35.3 0-64-28.7-64-64V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L522.1 193.9c-8.5-1.3-17.3-1.9-26.1-1.9c-54.7 0-103.5 24.9-135.8 64H320V208c0-8.8-7.2-16-16-16H272c-8.8 0-16 7.2-16 16v48H208c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16zM496 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 240a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-192c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16V288c0-8.8-7.2-16-16-16z"
    ]
};
var $d8206b3ab2e65c05$export$8e047801a8603af7 = {
    prefix: "fas",
    iconName: "closed-captioning",
    icon: [
        576,
        512,
        [],
        "f20a",
        "M0 96C0 60.7 28.7 32 64 32H512c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM200 208c14.2 0 27 6.1 35.8 16c8.8 9.9 24 10.7 33.9 1.9s10.7-24 1.9-33.9c-17.5-19.6-43.1-32-71.5-32c-53 0-96 43-96 96s43 96 96 96c28.4 0 54-12.4 71.5-32c8.8-9.9 8-25-1.9-33.9s-25-8-33.9 1.9c-8.8 9.9-21.6 16-35.8 16c-26.5 0-48-21.5-48-48s21.5-48 48-48zm144 48c0-26.5 21.5-48 48-48c14.2 0 27 6.1 35.8 16c8.8 9.9 24 10.7 33.9 1.9s10.7-24 1.9-33.9c-17.5-19.6-43.1-32-71.5-32c-53 0-96 43-96 96s43 96 96 96c28.4 0 54-12.4 71.5-32c8.8-9.9 8-25-1.9-33.9s-25-8-33.9 1.9c-8.8 9.9-21.6 16-35.8 16c-26.5 0-48-21.5-48-48z"
    ]
};
var $d8206b3ab2e65c05$export$baf9f153991b2ea = {
    prefix: "fas",
    iconName: "person-hiking",
    icon: [
        384,
        512,
        [
            "hiking"
        ],
        "f6ec",
        "M192 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm51.3 182.7L224.2 307l49.7 49.7c9 9 14.1 21.2 14.1 33.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V397.3l-73.9-73.9c-15.8-15.8-22.2-38.6-16.9-60.3l20.4-84c8.3-34.1 42.7-54.9 76.7-46.4c19 4.8 35.6 16.4 46.4 32.7L305.1 208H336V184c0-13.3 10.7-24 24-24s24 10.7 24 24v55.8c0 .1 0 .2 0 .2s0 .2 0 .2V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V272H296.6c-16 0-31-8-39.9-21.4l-13.3-20zM81.1 471.9L117.3 334c3 4.2 6.4 8.2 10.1 11.9l41.9 41.9L142.9 488.1c-4.5 17.1-22 27.3-39.1 22.8s-27.3-22-22.8-39.1zm55.5-346L101.4 266.5c-3 12.1-14.9 19.9-27.2 17.9l-47.9-8c-14-2.3-22.9-16.3-19.2-30L31.9 155c9.5-34.8 41.1-59 77.2-59h4.2c15.6 0 27.1 14.7 23.3 29.8z"
    ]
};
var $d8206b3ab2e65c05$export$b2ab0105a901499e = $d8206b3ab2e65c05$export$baf9f153991b2ea;
var $d8206b3ab2e65c05$export$6a6f9cba7a1e5fe4 = {
    prefix: "fas",
    iconName: "venus-double",
    icon: [
        640,
        512,
        [
            9890
        ],
        "f226",
        "M192 288a112 112 0 1 0 0-224 112 112 0 1 0 0 224zM368 176c0 86.3-62.1 158.1-144 173.1V384h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H224v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V448H128c-17.7 0-32-14.3-32-32s14.3-32 32-32h32V349.1C78.1 334.1 16 262.3 16 176C16 78.8 94.8 0 192 0s176 78.8 176 176zM344 318c14.6-15.6 26.8-33.4 36-53c18.8 14.4 42.4 23 68 23c61.9 0 112-50.1 112-112s-50.1-112-112-112c-25.6 0-49.1 8.6-68 23c-9.3-19.5-21.5-37.4-36-53C373.1 12.6 409.1 0 448 0c97.2 0 176 78.8 176 176c0 86.3-62.1 158.1-144 173.1V384h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H480v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V448H384c-17.7 0-32-14.3-32-32s14.3-32 32-32h32V349.1c-26.6-4.9-51.1-15.7-72-31.1z"
    ]
};
var $d8206b3ab2e65c05$export$74f06b41ed2ca28a = {
    prefix: "fas",
    iconName: "images",
    icon: [
        576,
        512,
        [],
        "f302",
        "M160 32c-35.3 0-64 28.7-64 64V320c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H160zM396 138.7l96 144c4.9 7.4 5.4 16.8 1.2 24.6S480.9 320 472 320H328 280 200c-9.2 0-17.6-5.3-21.6-13.6s-2.9-18.2 2.9-25.4l64-80c4.6-5.7 11.4-9 18.7-9s14.2 3.3 18.7 9l17.3 21.6 56-84C360.5 132 368 128 376 128s15.5 4 20 10.7zM192 128a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120V344c0 75.1 60.9 136 136 136H456c13.3 0 24-10.7 24-24s-10.7-24-24-24H136c-48.6 0-88-39.4-88-88V120z"
    ]
};
var $d8206b3ab2e65c05$export$693bd40950ed2c3a = {
    prefix: "fas",
    iconName: "calculator",
    icon: [
        384,
        512,
        [
            128425
        ],
        "f1ec",
        "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM96 64H288c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32zm32 160a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM96 352a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM64 416c0-17.7 14.3-32 32-32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H96c-17.7 0-32-14.3-32-32zM192 256a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm64-64a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM288 448a32 32 0 1 1 0-64 32 32 0 1 1 0 64z"
    ]
};
var $d8206b3ab2e65c05$export$dace56f632fecf6f = {
    prefix: "fas",
    iconName: "people-pulling",
    icon: [
        576,
        512,
        [],
        "e535",
        "M80 96A48 48 0 1 0 80 0a48 48 0 1 0 0 96zM64 128c-35.3 0-64 28.7-64 64V320c0 17.7 14.3 32 32 32c9.8 0 18.5-4.4 24.4-11.2L80.4 485.3c2.9 17.4 19.4 29.2 36.8 26.3s29.2-19.4 26.3-36.8L123.1 352h15.7l30 134.9c3.8 17.3 20.9 28.1 38.2 24.3s28.1-20.9 24.3-38.2l-57.3-258 116.3 53.8c.5 .3 1.1 .5 1.6 .7c8.6 3.6 18 3.1 25.9-.7c3.4-1.6 6.6-3.9 9.3-6.7c3.1-3.2 5.5-7 7.1-11.4c.1-.3 .2-.7 .3-1l2.5-7.5c5.7-17.1 18.3-30.9 34.7-38.2l8-3.5c1-.4 1.9-.8 2.9-1.2l-16.9 63.5c-5.6 21.1-.1 43.6 14.7 59.7l70.7 77.1 22 88.1c4.3 17.1 21.7 27.6 38.8 23.3s27.6-21.7 23.3-38.8l-23-92.1c-1.9-7.8-5.8-14.9-11.2-20.8l-49.5-54 19.3-65.5 9.6 23c4.4 10.6 12.5 19.3 22.8 24.5l26.7 13.3c15.8 7.9 35 1.5 42.9-14.3s1.5-35-14.3-42.9L537 232.7l-15.3-36.8C504.5 154.8 464.3 128 419.7 128c-22.8 0-45.3 4.8-66.1 14l-8 3.5c-24.4 10.9-44.6 29-58.1 51.6L157.3 136.9C144.7 131 130.9 128 117 128H64zM464 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM349.7 335.6l-25 62.4-59.4 59.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L372.3 441c4.6-4.6 8.2-10.1 10.6-16.1l14.5-36.2-40.7-44.4c-2.5-2.7-4.8-5.6-7-8.6z"
    ]
};
var $d8206b3ab2e65c05$export$328a9baf0f9e3405 = {
    prefix: "fas",
    iconName: "n",
    icon: [
        384,
        512,
        [
            110
        ],
        "4e",
        "M21.1 33.9c12.7-4.6 26.9-.7 35.5 9.6L320 359.6V64c0-17.7 14.3-32 32-32s32 14.3 32 32V448c0 13.5-8.4 25.5-21.1 30.1s-26.9 .7-35.5-9.6L64 152.4V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V64C0 50.5 8.4 38.5 21.1 33.9z"
    ]
};
var $d8206b3ab2e65c05$export$85cb04eaefaf2d8b = {
    prefix: "fas",
    iconName: "cable-car",
    icon: [
        512,
        512,
        [
            128673,
            57551,
            "tram"
        ],
        "f7da",
        "M288 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM160 56a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM32 288c0-35.3 28.7-64 64-64H232V157.5l-203.1 42c-13 2.7-25.7-5.7-28.4-18.6s5.7-25.7 18.6-28.4l232-48 232-48c13-2.7 25.7 5.7 28.4 18.6s-5.7 25.7-18.6 28.4L280 147.5V224H416c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V288zm64 0c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V304c0-8.8-7.2-16-16-16H96zm112 16v64c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V304c0-8.8-7.2-16-16-16H224c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V304c0-8.8-7.2-16-16-16H352z"
    ]
};
var $d8206b3ab2e65c05$export$a7a36674c079f293 = $d8206b3ab2e65c05$export$85cb04eaefaf2d8b;
var $d8206b3ab2e65c05$export$a6c308ee087b4ded = {
    prefix: "fas",
    iconName: "cloud-rain",
    icon: [
        512,
        512,
        [
            127783,
            9926
        ],
        "f73d",
        "M96 320c-53 0-96-43-96-96c0-42.5 27.6-78.6 65.9-91.2C64.7 126.1 64 119.1 64 112C64 50.1 114.1 0 176 0c43.1 0 80.5 24.3 99.2 60c14.7-17.1 36.5-28 60.8-28c44.2 0 80 35.8 80 80c0 5.5-.6 10.8-1.6 16c.5 0 1.1 0 1.6 0c53 0 96 43 96 96s-43 96-96 96H96zm-6.8 52c1.3-2.5 3.9-4 6.8-4s5.4 1.5 6.8 4l35.1 64.6c4.1 7.5 6.2 15.8 6.2 24.3v3c0 26.5-21.5 48-48 48s-48-21.5-48-48v-3c0-8.5 2.1-16.9 6.2-24.3L89.2 372zm160 0c1.3-2.5 3.9-4 6.8-4s5.4 1.5 6.8 4l35.1 64.6c4.1 7.5 6.2 15.8 6.2 24.3v3c0 26.5-21.5 48-48 48s-48-21.5-48-48v-3c0-8.5 2.1-16.9 6.2-24.3L249.2 372zm124.9 64.6L409.2 372c1.3-2.5 3.9-4 6.8-4s5.4 1.5 6.8 4l35.1 64.6c4.1 7.5 6.2 15.8 6.2 24.3v3c0 26.5-21.5 48-48 48s-48-21.5-48-48v-3c0-8.5 2.1-16.9 6.2-24.3z"
    ]
};
var $d8206b3ab2e65c05$export$c4c015418a1f24df = {
    prefix: "fas",
    iconName: "building-circle-xmark",
    icon: [
        640,
        512,
        [],
        "e4d4",
        "M48 0C21.5 0 0 21.5 0 48V464c0 26.5 21.5 48 48 48h96V432c0-26.5 21.5-48 48-48s48 21.5 48 48v80h96c15.1 0 28.5-6.9 37.3-17.8C340.4 462.2 320 417.5 320 368c0-54.7 24.9-103.5 64-135.8V48c0-26.5-21.5-48-48-48H48zM64 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V240zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V240zM80 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V112zM272 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm59.3-180.7L518.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L473.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L496 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
    ]
};
var $d8206b3ab2e65c05$export$6c645741140616af = {
    prefix: "fas",
    iconName: "ship",
    icon: [
        576,
        512,
        [
            128674
        ],
        "f21a",
        "M192 32c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32V64h48c26.5 0 48 21.5 48 48V240l44.4 14.8c23.1 7.7 29.5 37.5 11.5 53.9l-101 92.6c-16.2 9.4-34.7 15.1-50.9 15.1c-19.6 0-40.8-7.7-59.2-20.3c-22.1-15.5-51.6-15.5-73.7 0c-17.1 11.8-38 20.3-59.2 20.3c-16.2 0-34.7-5.7-50.9-15.1l-101-92.6c-18-16.5-11.6-46.2 11.5-53.9L96 240V112c0-26.5 21.5-48 48-48h48V32zM160 218.7l107.8-35.9c13.1-4.4 27.3-4.4 40.5 0L416 218.7V128H160v90.7zM306.5 421.9C329 437.4 356.5 448 384 448c26.9 0 55.4-10.8 77.4-26.1l0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 501.7 417 512 384 512c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.4 27.3-10.1 39.2-1.7l0 0C136.7 437.2 165.1 448 192 448c27.5 0 55-10.6 77.5-26.1c11.1-7.9 25.9-7.9 37 0z"
    ]
};
var $d8206b3ab2e65c05$export$8f2463c7b2fc6ae4 = {
    prefix: "fas",
    iconName: "arrows-down-to-line",
    icon: [
        576,
        512,
        [],
        "e4b8",
        "M544 416L32 416c-17.7 0-32 14.3-32 32s14.3 32 32 32l512 0c17.7 0 32-14.3 32-32s-14.3-32-32-32zm22.6-137.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L480 274.7 480 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 210.7-41.4-41.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0l96-96zm-320-45.3c-12.5-12.5-32.8-12.5-45.3 0L160 274.7 160 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 210.7L54.6 233.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0l96-96c12.5-12.5 12.5-32.8 0-45.3z"
    ]
};
var $d8206b3ab2e65c05$export$8f734e51d72ca13a = {
    prefix: "fas",
    iconName: "download",
    icon: [
        512,
        512,
        [],
        "f019",
        "M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V274.7l-73.4-73.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l128 128c12.5 12.5 32.8 12.5 45.3 0l128-128c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L288 274.7V32zM64 352c-35.3 0-64 28.7-64 64v32c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V416c0-35.3-28.7-64-64-64H346.5l-45.3 45.3c-25 25-65.5 25-90.5 0L165.5 352H64zm368 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
    ]
};
var $d8206b3ab2e65c05$export$92292137ef3cf4c8 = {
    prefix: "fas",
    iconName: "face-grin",
    icon: [
        512,
        512,
        [
            128512,
            "grin"
        ],
        "f580",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM388.1 312.8c12.3-3.8 24.3 6.9 19.3 18.7C382.4 390.6 324.2 432 256.3 432s-126.2-41.4-151.1-100.5c-5-11.8 7-22.5 19.3-18.7c39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $d8206b3ab2e65c05$export$37e1f10b6de76621 = $d8206b3ab2e65c05$export$92292137ef3cf4c8;
var $d8206b3ab2e65c05$export$bbcc9e0b6022772b = {
    prefix: "fas",
    iconName: "delete-left",
    icon: [
        576,
        512,
        [
            9003,
            "backspace"
        ],
        "f55a",
        "M576 128c0-35.3-28.7-64-64-64H205.3c-17 0-33.3 6.7-45.3 18.7L9.4 233.4c-6 6-9.4 14.1-9.4 22.6s3.4 16.6 9.4 22.6L160 429.3c12 12 28.3 18.7 45.3 18.7H512c35.3 0 64-28.7 64-64V128zM271 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"
    ]
};
var $d8206b3ab2e65c05$export$e43e3f67102fc526 = $d8206b3ab2e65c05$export$bbcc9e0b6022772b;
var $d8206b3ab2e65c05$export$1bc3e0ad56dc9eb0 = {
    prefix: "fas",
    iconName: "eye-dropper",
    icon: [
        512,
        512,
        [
            "eye-dropper-empty",
            "eyedropper"
        ],
        "f1fb",
        "M341.6 29.2L240.1 130.8l-9.4-9.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-9.4-9.4L482.8 170.4c39-39 39-102.2 0-141.1s-102.2-39-141.1 0zM55.4 323.3c-15 15-23.4 35.4-23.4 56.6v42.4L5.4 462.2c-8.5 12.7-6.8 29.6 4 40.4s27.7 12.5 40.4 4L89.7 480h42.4c21.2 0 41.6-8.4 56.6-23.4L309.4 335.9l-45.3-45.3L143.4 411.3c-3 3-7.1 4.7-11.3 4.7H96V379.9c0-4.2 1.7-8.3 4.7-11.3L221.4 247.9l-45.3-45.3L55.4 323.3z"
    ]
};
var $d8206b3ab2e65c05$export$ef304e9b7524c1f9 = $d8206b3ab2e65c05$export$1bc3e0ad56dc9eb0;
var $d8206b3ab2e65c05$export$91549a375c0b6d25 = $d8206b3ab2e65c05$export$1bc3e0ad56dc9eb0;
var $d8206b3ab2e65c05$export$8547e9f3a2ddab5b = {
    prefix: "fas",
    iconName: "file-circle-check",
    icon: [
        576,
        512,
        [],
        "e5a0",
        "M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384v38.6C310.1 219.5 256 287.4 256 368c0 59.1 29.1 111.3 73.7 143.3c-3.2 .5-6.4 .7-9.7 .7H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128zM288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm211.3-43.3c-6.2-6.2-16.4-6.2-22.6 0L416 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z"
    ]
};
var $d8206b3ab2e65c05$export$a8710cdb23198d53 = {
    prefix: "fas",
    iconName: "forward",
    icon: [
        512,
        512,
        [
            9193
        ],
        "f04e",
        "M52.5 440.6c-9.5 7.9-22.8 9.7-34.1 4.4S0 428.4 0 416V96C0 83.6 7.2 72.3 18.4 67s24.5-3.6 34.1 4.4L224 214.3V256v41.7L52.5 440.6zM256 352V256 128 96c0-12.4 7.2-23.7 18.4-29s24.5-3.6 34.1 4.4l192 160c7.3 6.1 11.5 15.1 11.5 24.6s-4.2 18.5-11.5 24.6l-192 160c-9.5 7.9-22.8 9.7-34.1 4.4s-18.4-16.6-18.4-29V352z"
    ]
};
var $d8206b3ab2e65c05$export$59edacfad04cd121 = {
    prefix: "fas",
    iconName: "mobile",
    icon: [
        384,
        512,
        [
            128241,
            "mobile-android",
            "mobile-phone"
        ],
        "f3ce",
        "M80 0C44.7 0 16 28.7 16 64V448c0 35.3 28.7 64 64 64H304c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H80zm80 432h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H160c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
    ]
};
var $d8206b3ab2e65c05$export$82f602311a698c32 = $d8206b3ab2e65c05$export$59edacfad04cd121;
var $d8206b3ab2e65c05$export$475a9be8da747e57 = $d8206b3ab2e65c05$export$59edacfad04cd121;
var $d8206b3ab2e65c05$export$dc130582748497c6 = {
    prefix: "fas",
    iconName: "face-meh",
    icon: [
        512,
        512,
        [
            128528,
            "meh"
        ],
        "f11a",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM176.4 176a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM160 336H352c8.8 0 16 7.2 16 16s-7.2 16-16 16H160c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
    ]
};
var $d8206b3ab2e65c05$export$6d2db489aaeeecd2 = $d8206b3ab2e65c05$export$dc130582748497c6;
var $d8206b3ab2e65c05$export$70e29dd05344623e = {
    prefix: "fas",
    iconName: "align-center",
    icon: [
        448,
        512,
        [],
        "f037",
        "M352 64c0-17.7-14.3-32-32-32H128c-17.7 0-32 14.3-32 32s14.3 32 32 32H320c17.7 0 32-14.3 32-32zm96 128c0-17.7-14.3-32-32-32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32zM0 448c0 17.7 14.3 32 32 32H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H32c-17.7 0-32 14.3-32 32zM352 320c0-17.7-14.3-32-32-32H128c-17.7 0-32 14.3-32 32s14.3 32 32 32H320c17.7 0 32-14.3 32-32z"
    ]
};
var $d8206b3ab2e65c05$export$a57d448e8969ce8a = {
    prefix: "fas",
    iconName: "book-skull",
    icon: [
        448,
        512,
        [
            "book-dead"
        ],
        "f6b7",
        "M0 96C0 43 43 0 96 0H384h32c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32v64c17.7 0 32 14.3 32 32s-14.3 32-32 32H384 96c-53 0-96-43-96-96V96zM64 416c0 17.7 14.3 32 32 32H352V384H96c-17.7 0-32 14.3-32 32zM320 112c0-35.3-35.8-64-80-64s-80 28.7-80 64c0 20.9 12.6 39.5 32 51.2V176c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V163.2c19.4-11.7 32-30.3 32-51.2zM208 96a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM134.3 209.3c-8.1-3.5-17.5 .3-21 8.4s.3 17.5 8.4 21L199.4 272l-77.7 33.3c-8.1 3.5-11.9 12.9-8.4 21s12.9 11.9 21 8.4L240 289.4l105.7 45.3c8.1 3.5 17.5-.3 21-8.4s-.3-17.5-8.4-21L280.6 272l77.7-33.3c8.1-3.5 11.9-12.9 8.4-21s-12.9-11.9-21-8.4L240 254.6 134.3 209.3z"
    ]
};
var $d8206b3ab2e65c05$export$b98a3f8c3941a74a = $d8206b3ab2e65c05$export$a57d448e8969ce8a;
var $d8206b3ab2e65c05$export$782ac893fc22249b = {
    prefix: "fas",
    iconName: "id-card",
    icon: [
        576,
        512,
        [
            62147,
            "drivers-license"
        ],
        "f2c2",
        "M0 96l576 0c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96zm0 32V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V128H0zM64 405.3c0-29.5 23.9-53.3 53.3-53.3H234.7c29.5 0 53.3 23.9 53.3 53.3c0 5.9-4.8 10.7-10.7 10.7H74.7c-5.9 0-10.7-4.8-10.7-10.7zM176 192a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm176 16c0-8.8 7.2-16 16-16H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H368c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H368c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H368c-8.8 0-16-7.2-16-16z"
    ]
};
var $d8206b3ab2e65c05$export$8359c70e609eff64 = $d8206b3ab2e65c05$export$782ac893fc22249b;
var $d8206b3ab2e65c05$export$e21cfc4f23776bff = {
    prefix: "fas",
    iconName: "outdent",
    icon: [
        448,
        512,
        [
            "dedent"
        ],
        "f03b",
        "M0 64C0 46.3 14.3 32 32 32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64zM192 192c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32zm32 96H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32s14.3-32 32-32zM0 448c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zM.2 268.6c-8.2-6.4-8.2-18.9 0-25.3l101.9-79.3c10.5-8.2 25.8-.7 25.8 12.6V335.3c0 13.3-15.3 20.8-25.8 12.6L.2 268.6z"
    ]
};
var $d8206b3ab2e65c05$export$cbffb369d9299db7 = $d8206b3ab2e65c05$export$e21cfc4f23776bff;
var $d8206b3ab2e65c05$export$3772719b170306e2 = {
    prefix: "fas",
    iconName: "heart-circle-exclamation",
    icon: [
        576,
        512,
        [],
        "e4fe",
        "M47.6 300.4L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9l2.6-2.4C267.2 438.6 256 404.6 256 368c0-97.2 78.8-176 176-176c28.3 0 55 6.7 78.7 18.5c.9-6.5 1.3-13 1.3-19.6v-5.8c0-69.9-50.5-129.5-119.4-141C347 36.5 300.6 51.4 268 84L256 96 244 84c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V288c0-8.8 7.2-16 16-16z"
    ]
};
var $d8206b3ab2e65c05$export$dcadc0d67468dfa8 = {
    prefix: "fas",
    iconName: "house",
    icon: [
        576,
        512,
        [
            127968,
            63498,
            63500,
            "home",
            "home-alt",
            "home-lg-alt"
        ],
        "f015",
        "M575.8 255.5c0 18-15 32.1-32 32.1h-32l.7 160.2c0 2.7-.2 5.4-.5 8.1V472c0 22.1-17.9 40-40 40H456c-1.1 0-2.2 0-3.3-.1c-1.4 .1-2.8 .1-4.2 .1H416 392c-22.1 0-40-17.9-40-40V448 384c0-17.7-14.3-32-32-32H256c-17.7 0-32 14.3-32 32v64 24c0 22.1-17.9 40-40 40H160 128.1c-1.5 0-3-.1-4.5-.2c-1.2 .1-2.4 .2-3.6 .2H104c-22.1 0-40-17.9-40-40V360c0-.9 0-1.9 .1-2.8V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L564.8 231.5c8 7 12 15 11 24z"
    ]
};
var $d8206b3ab2e65c05$export$48f10d71ec526479 = $d8206b3ab2e65c05$export$dcadc0d67468dfa8;
var $d8206b3ab2e65c05$export$279659c4b23dbedb = $d8206b3ab2e65c05$export$dcadc0d67468dfa8;
var $d8206b3ab2e65c05$export$20d6d52d45f53262 = $d8206b3ab2e65c05$export$dcadc0d67468dfa8;
var $d8206b3ab2e65c05$export$39be5cb4aed5a521 = {
    prefix: "fas",
    iconName: "calendar-week",
    icon: [
        448,
        512,
        [],
        "f784",
        "M128 0c17.7 0 32 14.3 32 32V64H288V32c0-17.7 14.3-32 32-32s32 14.3 32 32V64h48c26.5 0 48 21.5 48 48v48H0V112C0 85.5 21.5 64 48 64H96V32c0-17.7 14.3-32 32-32zM0 192H448V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V192zm80 64c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16H368c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H80z"
    ]
};
var $d8206b3ab2e65c05$export$ba2fa38f7bcc6930 = {
    prefix: "fas",
    iconName: "laptop-medical",
    icon: [
        640,
        512,
        [],
        "f812",
        "M64 96c0-35.3 28.7-64 64-64H512c35.3 0 64 28.7 64 64V352H512V96H128V352H64V96zM0 403.2C0 392.6 8.6 384 19.2 384H620.8c10.6 0 19.2 8.6 19.2 19.2c0 42.4-34.4 76.8-76.8 76.8H76.8C34.4 480 0 445.6 0 403.2zM288 160c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H352v48c0 8.8-7.2 16-16 16H304c-8.8 0-16-7.2-16-16V272H240c-8.8 0-16-7.2-16-16V224c0-8.8 7.2-16 16-16h48V160z"
    ]
};
var $d8206b3ab2e65c05$export$fa30fcd1e0d0d8 = {
    prefix: "fas",
    iconName: "b",
    icon: [
        320,
        512,
        [
            98
        ],
        "42",
        "M64 32C28.7 32 0 60.7 0 96V256 416c0 35.3 28.7 64 64 64H192c70.7 0 128-57.3 128-128c0-46.5-24.8-87.3-62-109.7c18.7-22.3 30-51 30-82.3c0-70.7-57.3-128-128-128H64zm96 192H64V96h96c35.3 0 64 28.7 64 64s-28.7 64-64 64zM64 288h96 32c35.3 0 64 28.7 64 64s-28.7 64-64 64H64V288z"
    ]
};
var $d8206b3ab2e65c05$export$56cbcd962389b090 = {
    prefix: "fas",
    iconName: "file-medical",
    icon: [
        384,
        512,
        [],
        "f477",
        "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM160 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H224v48c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V352H112c-8.8 0-16-7.2-16-16V304c0-8.8 7.2-16 16-16h48V240z"
    ]
};
var $d8206b3ab2e65c05$export$d91800b7be5303b0 = {
    prefix: "fas",
    iconName: "dice-one",
    icon: [
        448,
        512,
        [
            9856
        ],
        "f525",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM224 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $d8206b3ab2e65c05$export$d9933d91e1314d02 = {
    prefix: "fas",
    iconName: "kiwi-bird",
    icon: [
        576,
        512,
        [],
        "f535",
        "M291.2 388.4c31.2-18.8 64.7-36.4 101.1-36.4H448c4.6 0 9.1-.2 13.6-.7l85.3 121.9c4 5.7 11.3 8.2 17.9 6.1s11.2-8.3 11.2-15.3V224c0-70.7-57.3-128-128-128H392.3c-36.4 0-69.9-17.6-101.1-36.4C262.3 42.1 228.3 32 192 32C86 32 0 118 0 224c0 71.1 38.6 133.1 96 166.3V456c0 13.3 10.7 24 24 24s24-10.7 24-24V410c15.3 3.9 31.4 6 48 6c5.4 0 10.7-.2 16-.7V456c0 13.3 10.7 24 24 24s24-10.7 24-24V405.1c12.4-4.4 24.2-10 35.2-16.7zM448 200a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
    ]
};
var $d8206b3ab2e65c05$export$56b6d3d7d0e67a1c = {
    prefix: "fas",
    iconName: "arrow-right-arrow-left",
    icon: [
        448,
        512,
        [
            8644,
            "exchange"
        ],
        "f0ec",
        "M438.6 150.6c12.5-12.5 12.5-32.8 0-45.3l-96-96c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.7 96 32 96C14.3 96 0 110.3 0 128s14.3 32 32 32l306.7 0-41.4 41.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l96-96zm-333.3 352c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 416 416 416c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0 41.4-41.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3l96 96z"
    ]
};
var $d8206b3ab2e65c05$export$1aab915ca61b734a = $d8206b3ab2e65c05$export$56b6d3d7d0e67a1c;
var $d8206b3ab2e65c05$export$7f465bf410c6eff7 = {
    prefix: "fas",
    iconName: "rotate-right",
    icon: [
        512,
        512,
        [
            "redo-alt",
            "rotate-forward"
        ],
        "f2f9",
        "M463.5 224H472c13.3 0 24-10.7 24-24V72c0-9.7-5.8-18.5-14.8-22.2s-19.3-1.7-26.2 5.2L413.4 96.6c-87.6-86.5-228.7-86.2-315.8 1c-87.5 87.5-87.5 229.3 0 316.8s229.3 87.5 316.8 0c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0c-62.5 62.5-163.8 62.5-226.3 0s-62.5-163.8 0-226.3c62.2-62.2 162.7-62.5 225.3-1L327 183c-6.9 6.9-8.9 17.2-5.2 26.2s12.5 14.8 22.2 14.8H463.5z"
    ]
};
var $d8206b3ab2e65c05$export$50c037520c6cfdc1 = $d8206b3ab2e65c05$export$7f465bf410c6eff7;
var $d8206b3ab2e65c05$export$2507849a0fdd7f64 = $d8206b3ab2e65c05$export$7f465bf410c6eff7;
var $d8206b3ab2e65c05$export$750d52edc1dafc7 = {
    prefix: "fas",
    iconName: "utensils",
    icon: [
        448,
        512,
        [
            127860,
            61685,
            "cutlery"
        ],
        "f2e7",
        "M416 0C400 0 288 32 288 176V288c0 35.3 28.7 64 64 64h32V480c0 17.7 14.3 32 32 32s32-14.3 32-32V352 240 32c0-17.7-14.3-32-32-32zM64 16C64 7.8 57.9 1 49.7 .1S34.2 4.6 32.4 12.5L2.1 148.8C.7 155.1 0 161.5 0 167.9c0 45.9 35.1 83.6 80 87.7V480c0 17.7 14.3 32 32 32s32-14.3 32-32V255.6c44.9-4.1 80-41.8 80-87.7c0-6.4-.7-12.8-2.1-19.1L191.6 12.5c-1.8-8-9.3-13.3-17.4-12.4S160 7.8 160 16V150.2c0 5.4-4.4 9.8-9.8 9.8c-5.1 0-9.3-3.9-9.8-9L127.9 14.6C127.2 6.3 120.3 0 112 0s-15.2 6.3-15.9 14.6L83.7 151c-.5 5.1-4.7 9-9.8 9c-5.4 0-9.8-4.4-9.8-9.8V16zm48.3 152l-.3 0-.3 0 .3-.7 .3 .7z"
    ]
};
var $d8206b3ab2e65c05$export$7034e54a8036c5c8 = $d8206b3ab2e65c05$export$750d52edc1dafc7;
var $d8206b3ab2e65c05$export$63f4908401ded049 = {
    prefix: "fas",
    iconName: "arrow-up-wide-short",
    icon: [
        576,
        512,
        [
            "sort-amount-up"
        ],
        "f161",
        "M151.6 42.4C145.5 35.8 137 32 128 32s-17.5 3.8-23.6 10.4l-88 96c-11.9 13-11.1 33.3 2 45.2s33.3 11.1 45.2-2L96 146.3V448c0 17.7 14.3 32 32 32s32-14.3 32-32V146.3l32.4 35.4c11.9 13 32.2 13.9 45.2 2s13.9-32.2 2-45.2l-88-96zM320 480h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H320c-17.7 0-32 14.3-32 32s14.3 32 32 32zm0-128h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H320c-17.7 0-32 14.3-32 32s14.3 32 32 32zm0-128H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H320c-17.7 0-32 14.3-32 32s14.3 32 32 32zm0-128H544c17.7 0 32-14.3 32-32s-14.3-32-32-32H320c-17.7 0-32 14.3-32 32s14.3 32 32 32z"
    ]
};
var $d8206b3ab2e65c05$export$28ef3e933e4b5364 = $d8206b3ab2e65c05$export$63f4908401ded049;
var $d8206b3ab2e65c05$export$9b53510cf4010e4d = {
    prefix: "fas",
    iconName: "mill-sign",
    icon: [
        384,
        512,
        [],
        "e1ed",
        "M302.1 42.8c5.9-16.6-2.7-35-19.4-40.9s-35 2.7-40.9 19.4L208 116.1c-5.7 4-11.1 8.5-16 13.5C171.7 108.9 143.3 96 112 96c-19.5 0-37.8 5-53.7 13.7C52.5 101.4 42.9 96 32 96C14.3 96 0 110.3 0 128v80V416c0 17.7 14.3 32 32 32s32-14.3 32-32V208c0-26.5 21.5-48 48-48s48 21.5 48 48v42.5L81.9 469.2c-5.9 16.6 2.7 35 19.4 40.9s35-2.7 40.9-19.4l21.4-60C168.9 441 179.6 448 192 448c17.7 0 32-14.3 32-32V261.5l35.7-100c3.9-1 8.1-1.6 12.3-1.6c26.5 0 48 21.5 48 48V416c0 17.7 14.3 32 32 32s32-14.3 32-32V208c0-58.2-44.3-106-101.1-111.5l19.2-53.8z"
    ]
};
var $d8206b3ab2e65c05$export$86079bc65a716451 = {
    prefix: "fas",
    iconName: "bowl-rice",
    icon: [
        512,
        512,
        [],
        "e2eb",
        "M176 56c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H200c-13.3 0-24-10.7-24-24zm24 48h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H200c-13.3 0-24-10.7-24-24s10.7-24 24-24zM56 176H72c13.3 0 24 10.7 24 24s-10.7 24-24 24H56c-13.3 0-24-10.7-24-24s10.7-24 24-24zM0 283.4C0 268.3 12.3 256 27.4 256H484.6c15.1 0 27.4 12.3 27.4 27.4c0 70.5-44.4 130.7-106.7 154.1L403.5 452c-2 16-15.6 28-31.8 28H140.2c-16.1 0-29.8-12-31.8-28l-1.8-14.4C44.4 414.1 0 353.9 0 283.4zM224 200c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H248c-13.3 0-24-10.7-24-24zm-96 0c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24zm-24-96h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H104c-13.3 0-24-10.7-24-24s10.7-24 24-24zm216 96c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H344c-13.3 0-24-10.7-24-24zm-24-96h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H296c-13.3 0-24-10.7-24-24s10.7-24 24-24zm120 96c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H440c-13.3 0-24-10.7-24-24zm-24-96h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H392c-13.3 0-24-10.7-24-24s10.7-24 24-24zM296 32h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H296c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
    ]
};
var $d8206b3ab2e65c05$export$138b45e2afb1dfa4 = {
    prefix: "fas",
    iconName: "skull",
    icon: [
        512,
        512,
        [
            128128
        ],
        "f54c",
        "M416 398.9c58.5-41.1 96-104.1 96-174.9C512 100.3 397.4 0 256 0S0 100.3 0 224c0 70.7 37.5 133.8 96 174.9c0 .4 0 .7 0 1.1v64c0 26.5 21.5 48 48 48h48V464c0-8.8 7.2-16 16-16s16 7.2 16 16v48h64V464c0-8.8 7.2-16 16-16s16 7.2 16 16v48h48c26.5 0 48-21.5 48-48V400c0-.4 0-.7 0-1.1zM96 256a64 64 0 1 1 128 0A64 64 0 1 1 96 256zm256-64a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"
    ]
};
var $d8206b3ab2e65c05$export$fd06ff4ce9799eb0 = {
    prefix: "fas",
    iconName: "tower-broadcast",
    icon: [
        576,
        512,
        [
            "broadcast-tower"
        ],
        "f519",
        "M80.3 44C69.8 69.9 64 98.2 64 128s5.8 58.1 16.3 84c6.6 16.4-1.3 35-17.7 41.7s-35-1.3-41.7-17.7C7.4 202.6 0 166.1 0 128S7.4 53.4 20.9 20C27.6 3.6 46.2-4.3 62.6 2.3S86.9 27.6 80.3 44zM555.1 20C568.6 53.4 576 89.9 576 128s-7.4 74.6-20.9 108c-6.6 16.4-25.3 24.3-41.7 17.7S489.1 228.4 495.7 212c10.5-25.9 16.3-54.2 16.3-84s-5.8-58.1-16.3-84C489.1 27.6 497 9 513.4 2.3s35 1.3 41.7 17.7zM352 128c0 23.7-12.9 44.4-32 55.4V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V183.4c-19.1-11.1-32-31.7-32-55.4c0-35.3 28.7-64 64-64s64 28.7 64 64zM170.6 76.8C163.8 92.4 160 109.7 160 128s3.8 35.6 10.6 51.2c7.1 16.2-.3 35.1-16.5 42.1s-35.1-.3-42.1-16.5c-10.3-23.6-16-49.6-16-76.8s5.7-53.2 16-76.8c7.1-16.2 25.9-23.6 42.1-16.5s23.6 25.9 16.5 42.1zM464 51.2c10.3 23.6 16 49.6 16 76.8s-5.7 53.2-16 76.8c-7.1 16.2-25.9 23.6-42.1 16.5s-23.6-25.9-16.5-42.1c6.8-15.6 10.6-32.9 10.6-51.2s-3.8-35.6-10.6-51.2c-7.1-16.2 .3-35.1 16.5-42.1s35.1 .3 42.1 16.5z"
    ]
};
var $d8206b3ab2e65c05$export$f68b38d51f5c0ed = $d8206b3ab2e65c05$export$fd06ff4ce9799eb0;
var $d8206b3ab2e65c05$export$f846b848b3ba3064 = {
    prefix: "fas",
    iconName: "truck-pickup",
    icon: [
        640,
        512,
        [
            128763
        ],
        "f63c",
        "M368.6 96l76.8 96H288V96h80.6zM224 80V192H64c-17.7 0-32 14.3-32 32v64c-17.7 0-32 14.3-32 32s14.3 32 32 32H65.1c-.7 5.2-1.1 10.6-1.1 16c0 61.9 50.1 112 112 112s112-50.1 112-112c0-5.4-.4-10.8-1.1-16h66.3c-.7 5.2-1.1 10.6-1.1 16c0 61.9 50.1 112 112 112s112-50.1 112-112c0-5.4-.4-10.8-1.1-16H608c17.7 0 32-14.3 32-32s-14.3-32-32-32V224c0-17.7-14.3-32-32-32H527.4L418.6 56c-12.1-15.2-30.5-24-50-24H272c-26.5 0-48 21.5-48 48zm0 288a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zm288 0a48 48 0 1 1 -96 0 48 48 0 1 1 96 0z"
    ]
};
var $d8206b3ab2e65c05$export$5608156cc81126e7 = {
    prefix: "fas",
    iconName: "up-long",
    icon: [
        320,
        512,
        [
            "long-arrow-alt-up"
        ],
        "f30c",
        "M318 177.5c3.8-8.8 2-19-4.6-26l-136-144C172.9 2.7 166.6 0 160 0s-12.9 2.7-17.4 7.5l-136 144c-6.6 7-8.4 17.2-4.6 26S14.4 192 24 192H96l0 288c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32l0-288h72c9.6 0 18.2-5.7 22-14.5z"
    ]
};
var $d8206b3ab2e65c05$export$43c8f2a46326c55f = $d8206b3ab2e65c05$export$5608156cc81126e7;
var $d8206b3ab2e65c05$export$51577929c676143b = {
    prefix: "fas",
    iconName: "stop",
    icon: [
        384,
        512,
        [
            9209
        ],
        "f04d",
        "M0 128C0 92.7 28.7 64 64 64H320c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128z"
    ]
};
var $d8206b3ab2e65c05$export$e151fe5abf6db993 = {
    prefix: "fas",
    iconName: "code-merge",
    icon: [
        448,
        512,
        [],
        "f387",
        "M80 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm32.4 97.2c28-12.4 47.6-40.5 47.6-73.2c0-44.2-35.8-80-80-80S0 35.8 0 80c0 32.8 19.7 61 48 73.3V358.7C19.7 371 0 399.2 0 432c0 44.2 35.8 80 80 80s80-35.8 80-80c0-32.8-19.7-61-48-73.3V272c26.7 20.1 60 32 96 32h86.7c12.3 28.3 40.5 48 73.3 48c44.2 0 80-35.8 80-80s-35.8-80-80-80c-32.8 0-61 19.7-73.3 48H208c-49.9 0-91-38.1-95.6-86.8zM80 408a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM344 272a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"
    ]
};
var $d8206b3ab2e65c05$export$a9578350255b2b79 = {
    prefix: "fas",
    iconName: "upload",
    icon: [
        512,
        512,
        [],
        "f093",
        "M288 109.3V352c0 17.7-14.3 32-32 32s-32-14.3-32-32V109.3l-73.4 73.4c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l128-128c12.5-12.5 32.8-12.5 45.3 0l128 128c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L288 109.3zM64 352H192c0 35.3 28.7 64 64 64s64-28.7 64-64H448c35.3 0 64 28.7 64 64v32c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V416c0-35.3 28.7-64 64-64zM432 456a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
    ]
};
var $d8206b3ab2e65c05$export$4cf54a379be7e59a = {
    prefix: "fas",
    iconName: "hurricane",
    icon: [
        384,
        512,
        [],
        "f751",
        "M0 208C0 104.4 75.7 18.5 174.9 2.6C184 1.2 192 8.6 192 17.9V81.2c0 8.4 6.5 15.3 14.7 16.5C307 112.5 384 199 384 303.4c0 103.6-75.7 189.5-174.9 205.4c-9.2 1.5-17.1-5.9-17.1-15.2V430.2c0-8.4-6.5-15.3-14.7-16.5C77 398.9 0 312.4 0 208zm288 48A96 96 0 1 0 96 256a96 96 0 1 0 192 0zm-96-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $d8206b3ab2e65c05$export$ac54ffffdb218383 = {
    prefix: "fas",
    iconName: "mound",
    icon: [
        576,
        512,
        [],
        "e52d",
        "M144.1 179.2C173.8 127.7 228.6 96 288 96s114.2 31.7 143.9 83.2L540.4 368c12.3 21.3-3.1 48-27.7 48H63.3c-24.6 0-40-26.6-27.7-48L144.1 179.2z"
    ]
};
var $d8206b3ab2e65c05$export$a3a5de5f6e2513ba = {
    prefix: "fas",
    iconName: "toilet-portable",
    icon: [
        320,
        512,
        [],
        "e583",
        "M0 32V64H320V32c0-17.7-14.3-32-32-32H32C14.3 0 0 14.3 0 32zM24 96H0v24V488c0 13.3 10.7 24 24 24s24-10.7 24-24v-8H272v8c0 13.3 10.7 24 24 24s24-10.7 24-24V120 96H296 24zM256 240v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V240c0-8.8 7.2-16 16-16s16 7.2 16 16z"
    ]
};
var $d8206b3ab2e65c05$export$84021631df0f831b = {
    prefix: "fas",
    iconName: "compact-disc",
    icon: [
        512,
        512,
        [
            128191,
            128192,
            128440
        ],
        "f51f",
        "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256 32a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm-96-32a96 96 0 1 0 192 0 96 96 0 1 0 -192 0zM96 240c0-35 17.5-71.1 45.2-98.8S205 96 240 96c8.8 0 16-7.2 16-16s-7.2-16-16-16c-45.4 0-89.2 22.3-121.5 54.5S64 194.6 64 240c0 8.8 7.2 16 16 16s16-7.2 16-16z"
    ]
};
var $d8206b3ab2e65c05$export$148bcede94488555 = {
    prefix: "fas",
    iconName: "file-arrow-down",
    icon: [
        384,
        512,
        [
            "file-download"
        ],
        "f56d",
        "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM216 232V334.1l31-31c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-72 72c-9.4 9.4-24.6 9.4-33.9 0l-72-72c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l31 31V232c0-13.3 10.7-24 24-24s24 10.7 24 24z"
    ]
};
var $d8206b3ab2e65c05$export$1013b9966d758343 = $d8206b3ab2e65c05$export$148bcede94488555;
var $d8206b3ab2e65c05$export$afb5d0eee7c1bdb = {
    prefix: "fas",
    iconName: "caravan",
    icon: [
        640,
        512,
        [],
        "f8ff",
        "M0 112C0 67.8 35.8 32 80 32H416c88.4 0 160 71.6 160 160V352h32c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0H288c0 53-43 96-96 96s-96-43-96-96H80c-44.2 0-80-35.8-80-80V112zM320 352H448V256H416c-8.8 0-16-7.2-16-16s7.2-16 16-16h32V160c0-17.7-14.3-32-32-32H352c-17.7 0-32 14.3-32 32V352zM96 128c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H224c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32H96zm96 336a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"
    ]
};
var $d8206b3ab2e65c05$export$1639f087457d4f58 = {
    prefix: "fas",
    iconName: "shield-cat",
    icon: [
        512,
        512,
        [],
        "e572",
        "M269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L269.4 2.9zM160 154.4c0-5.8 4.7-10.4 10.4-10.4h.2c3.4 0 6.5 1.6 8.5 4.3l40 53.3c3 4 7.8 6.4 12.8 6.4h48c5 0 9.8-2.4 12.8-6.4l40-53.3c2-2.7 5.2-4.3 8.5-4.3h.2c5.8 0 10.4 4.7 10.4 10.4V272c0 53-43 96-96 96s-96-43-96-96V154.4zM216 288a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm96-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"
    ]
};
var $d8206b3ab2e65c05$export$6869964aa308dd31 = {
    prefix: "fas",
    iconName: "bolt",
    icon: [
        448,
        512,
        [
            9889,
            "zap"
        ],
        "f0e7",
        "M349.4 44.6c5.9-13.7 1.5-29.7-10.6-38.5s-28.6-8-39.9 1.8l-256 224c-10 8.8-13.6 22.9-8.9 35.3S50.7 288 64 288H175.5L98.6 467.4c-5.9 13.7-1.5 29.7 10.6 38.5s28.6 8 39.9-1.8l256-224c10-8.8 13.6-22.9 8.9-35.3s-16.6-20.7-30-20.7H272.5L349.4 44.6z"
    ]
};
var $d8206b3ab2e65c05$export$d62abb82664f55ca = $d8206b3ab2e65c05$export$6869964aa308dd31;
var $d8206b3ab2e65c05$export$b80f542550a05ea7 = {
    prefix: "fas",
    iconName: "glass-water",
    icon: [
        384,
        512,
        [],
        "e4f4",
        "M32 0C23.1 0 14.6 3.7 8.6 10.2S-.6 25.4 .1 34.3L28.9 437.7c3 41.9 37.8 74.3 79.8 74.3H275.3c42 0 76.8-32.4 79.8-74.3L383.9 34.3c.6-8.9-2.4-17.6-8.5-24.1S360.9 0 352 0H32zM73 156.5L66.4 64H317.6L311 156.5l-24.2 12.1c-19.4 9.7-42.2 9.7-61.6 0c-20.9-10.4-45.5-10.4-66.4 0c-19.4 9.7-42.2 9.7-61.6 0L73 156.5z"
    ]
};
var $d8206b3ab2e65c05$export$b69c6757012a2267 = {
    prefix: "fas",
    iconName: "oil-well",
    icon: [
        576,
        512,
        [],
        "e532",
        "M528.3 61.3c-11.4-42.7-55.3-68-98-56.6L414.9 8.8C397.8 13.4 387.7 31 392.3 48l24.5 91.4L308.5 167.5l-6.3-18.1C297.7 136.6 285.6 128 272 128s-25.7 8.6-30.2 21.4l-13.6 39L96 222.6V184c0-13.3-10.7-24-24-24s-24 10.7-24 24V448H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H544c17.7 0 32-14.3 32-32s-14.3-32-32-32H406.7L340 257.5l-62.2 16.1L305.3 352H238.7L265 277l-74.6 19.3L137.3 448H96V288.8l337.4-87.5 25.2 94c4.6 17.1 22.1 27.2 39.2 22.6l15.5-4.1c42.7-11.4 68-55.3 56.6-98L528.3 61.3zM205.1 448l11.2-32H327.7l11.2 32H205.1z"
    ]
};
var $d8206b3ab2e65c05$export$4689a147513594a7 = {
    prefix: "fas",
    iconName: "vault",
    icon: [
        576,
        512,
        [],
        "e2c5",
        "M64 0C28.7 0 0 28.7 0 64V416c0 35.3 28.7 64 64 64H80l16 32h64l16-32H400l16 32h64l16-32h16c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM224 320a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm0-240a160 160 0 1 1 0 320 160 160 0 1 1 0-320zM480 221.3V336c0 8.8-7.2 16-16 16s-16-7.2-16-16V221.3c-18.6-6.6-32-24.4-32-45.3c0-26.5 21.5-48 48-48s48 21.5 48 48c0 20.9-13.4 38.7-32 45.3z"
    ]
};
var $d8206b3ab2e65c05$export$a9f5c0b9c1e77a6f = {
    prefix: "fas",
    iconName: "mars",
    icon: [
        448,
        512,
        [
            9794
        ],
        "f222",
        "M289.8 46.8c3.7-9 12.5-14.8 22.2-14.8H424c13.3 0 24 10.7 24 24V168c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-33.4-33.4L321 204.2c19.5 28.4 31 62.7 31 99.8c0 97.2-78.8 176-176 176S0 401.2 0 304s78.8-176 176-176c37 0 71.4 11.4 99.8 31l52.6-52.6L295 73c-6.9-6.9-8.9-17.2-5.2-26.2zM400 80l0 0h0v0zM176 416a112 112 0 1 0 0-224 112 112 0 1 0 0 224z"
    ]
};
var $d8206b3ab2e65c05$export$505476859b9691c0 = {
    prefix: "fas",
    iconName: "toilet",
    icon: [
        448,
        512,
        [
            128701
        ],
        "f7d8",
        "M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48h8V196.9c-1.9 1.4-3.8 2.9-5.6 4.4C10.9 214.5 0 232.9 0 256c0 46.9 14.3 84.1 37 112.5c14.2 17.7 31.1 31.3 48.5 41.8L65.6 469.9c-3.3 9.8-1.6 20.5 4.4 28.8s15.7 13.3 26 13.3H352c10.3 0 19.9-4.9 26-13.3s7.7-19.1 4.4-28.8l-19.8-59.5c17.4-10.5 34.3-24.1 48.5-41.8c22.7-28.4 37-65.5 37-112.5c0-23.1-10.9-41.5-26.4-54.6c-1.8-1.5-3.7-3-5.6-4.4V48h8c13.3 0 24-10.7 24-24s-10.7-24-24-24H24zM384 256.3c0 1-.3 2.6-3.8 5.6c-4.8 4.1-14 9-29.3 13.4C320.5 284 276.1 288 224 288s-96.5-4-126.9-12.8c-15.3-4.4-24.5-9.3-29.3-13.4c-3.5-3-3.8-4.6-3.8-5.6l0-.3 0-.1c0-1 0-2.5 3.8-5.8c4.8-4.1 14-9 29.3-13.4C127.5 228 171.9 224 224 224s96.5 4 126.9 12.8c15.3 4.4 24.5 9.3 29.3 13.4c3.8 3.2 3.8 4.8 3.8 5.8l0 .1 0 .3zM328.2 384l-.2 .5 0-.5h.2zM112 64h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
    ]
};
var $d8206b3ab2e65c05$export$94ef668f5108e431 = {
    prefix: "fas",
    iconName: "plane-circle-xmark",
    icon: [
        640,
        512,
        [],
        "e557",
        "M256 0c-35 0-64 59.5-64 93.7v84.6L8.1 283.4c-5 2.8-8.1 8.2-8.1 13.9v65.5c0 10.6 10.2 18.3 20.4 15.4l171.6-49 0 70.9-57.6 43.2c-4 3-6.4 7.8-6.4 12.8v42c0 7.8 6.3 14 14 14c1.3 0 2.6-.2 3.9-.5L256 480l110.1 31.5c1.3 .4 2.6 .5 3.9 .5c6 0 11.1-3.7 13.1-9C344.5 470.7 320 422.2 320 368c0-60.6 30.6-114 77.1-145.6L320 178.3V93.7C320 59.5 292 0 256 0zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm59.3-180.7L518.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L473.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L496 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
    ]
};
var $d8206b3ab2e65c05$export$30f1437f5a4e991d = {
    prefix: "fas",
    iconName: "yen-sign",
    icon: [
        320,
        512,
        [
            165,
            "cny",
            "jpy",
            "rmb",
            "yen"
        ],
        "f157",
        "M58.6 46.2C48.8 31.5 29 27.6 14.3 37.4S-4.4 67 5.4 81.7L100.2 224H48c-17.7 0-32 14.3-32 32s14.3 32 32 32h80v32H48c-17.7 0-32 14.3-32 32s14.3 32 32 32h80v64c0 17.7 14.3 32 32 32s32-14.3 32-32V384h80c17.7 0 32-14.3 32-32s-14.3-32-32-32H192V288h80c17.7 0 32-14.3 32-32s-14.3-32-32-32H219.8L314.6 81.7c9.8-14.7 5.8-34.6-8.9-44.4s-34.6-5.8-44.4 8.9L160 198.3 58.6 46.2z"
    ]
};
var $d8206b3ab2e65c05$export$268a23eee8f089a2 = $d8206b3ab2e65c05$export$30f1437f5a4e991d;
var $d8206b3ab2e65c05$export$5460a9192eb79bf5 = $d8206b3ab2e65c05$export$30f1437f5a4e991d;
var $d8206b3ab2e65c05$export$e2a8016afc962883 = $d8206b3ab2e65c05$export$30f1437f5a4e991d;
var $d8206b3ab2e65c05$export$cf914b1afb9455a2 = $d8206b3ab2e65c05$export$30f1437f5a4e991d;
var $d8206b3ab2e65c05$export$1ae0a94c8ba4131a = {
    prefix: "fas",
    iconName: "ruble-sign",
    icon: [
        384,
        512,
        [
            8381,
            "rouble",
            "rub",
            "ruble"
        ],
        "f158",
        "M96 32C78.3 32 64 46.3 64 64V256H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H64v32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H64v32c0 17.7 14.3 32 32 32s32-14.3 32-32V416H288c17.7 0 32-14.3 32-32s-14.3-32-32-32H128V320H240c79.5 0 144-64.5 144-144s-64.5-144-144-144H96zM240 256H128V96H240c44.2 0 80 35.8 80 80s-35.8 80-80 80z"
    ]
};
var $d8206b3ab2e65c05$export$c5dc3d98c4d8f2a5 = $d8206b3ab2e65c05$export$1ae0a94c8ba4131a;
var $d8206b3ab2e65c05$export$9c4d936240e1f0b1 = $d8206b3ab2e65c05$export$1ae0a94c8ba4131a;
var $d8206b3ab2e65c05$export$6c0cf65134387046 = $d8206b3ab2e65c05$export$1ae0a94c8ba4131a;
var $d8206b3ab2e65c05$export$2fa35dcbc038dbe9 = {
    prefix: "fas",
    iconName: "sun",
    icon: [
        512,
        512,
        [
            9728
        ],
        "f185",
        "M361.5 1.2c5 2.1 8.6 6.6 9.6 11.9L391 121l107.9 19.8c5.3 1 9.8 4.6 11.9 9.6s1.5 10.7-1.6 15.2L446.9 256l62.3 90.3c3.1 4.5 3.7 10.2 1.6 15.2s-6.6 8.6-11.9 9.6L391 391 371.1 498.9c-1 5.3-4.6 9.8-9.6 11.9s-10.7 1.5-15.2-1.6L256 446.9l-90.3 62.3c-4.5 3.1-10.2 3.7-15.2 1.6s-8.6-6.6-9.6-11.9L121 391 13.1 371.1c-5.3-1-9.8-4.6-11.9-9.6s-1.5-10.7 1.6-15.2L65.1 256 2.8 165.7c-3.1-4.5-3.7-10.2-1.6-15.2s6.6-8.6 11.9-9.6L121 121 140.9 13.1c1-5.3 4.6-9.8 9.6-11.9s10.7-1.5 15.2 1.6L256 65.1 346.3 2.8c4.5-3.1 10.2-3.7 15.2-1.6zM160 256a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zm224 0a128 128 0 1 0 -256 0 128 128 0 1 0 256 0z"
    ]
};
var $d8206b3ab2e65c05$export$790dd5b32282b6fb = {
    prefix: "fas",
    iconName: "guitar",
    icon: [
        512,
        512,
        [],
        "f7a6",
        "M465 7c-9.4-9.4-24.6-9.4-33.9 0L383 55c-2.4 2.4-4.3 5.3-5.5 8.5l-15.4 41-77.5 77.6c-45.1-29.4-99.3-30.2-131 1.6c-11 11-18 24.6-21.4 39.6c-3.7 16.6-19.1 30.7-36.1 31.6c-25.6 1.3-49.3 10.7-67.3 28.6C-16 328.4-7.6 409.4 47.5 464.5s136.1 63.5 180.9 18.7c17.9-17.9 27.4-41.7 28.6-67.3c.9-17 15-32.3 31.6-36.1c15-3.4 28.6-10.5 39.6-21.4c31.8-31.8 31-85.9 1.6-131l77.6-77.6 41-15.4c3.2-1.2 6.1-3.1 8.5-5.5l48-48c9.4-9.4 9.4-24.6 0-33.9L465 7zM208 256a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
    ]
};
var $d8206b3ab2e65c05$export$600a1b26b33c3d47 = {
    prefix: "fas",
    iconName: "face-laugh-wink",
    icon: [
        512,
        512,
        [
            "laugh-wink"
        ],
        "f59c",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM96.8 314.1c-3.8-13.7 7.4-26.1 21.6-26.1H393.6c14.2 0 25.5 12.4 21.6 26.1C396.2 382 332.1 432 256 432s-140.2-50-159.2-117.9zM144.4 192a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm156.4 25.6c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2c-17.6-23.5-52.8-23.5-70.4 0z"
    ]
};
var $d8206b3ab2e65c05$export$77ac40095f39933e = $d8206b3ab2e65c05$export$600a1b26b33c3d47;
var $d8206b3ab2e65c05$export$5bcca85203ebd1e8 = {
    prefix: "fas",
    iconName: "horse-head",
    icon: [
        640,
        512,
        [],
        "f7ab",
        "M64 464V316.9c0-108.4 68.3-205.1 170.5-241.3L404.2 15.5C425.6 7.9 448 23.8 448 46.4c0 11-5.5 21.2-14.6 27.3L400 96c48.1 0 91.2 29.8 108.1 74.9l48.6 129.5c11.8 31.4 4.1 66.8-19.6 90.5c-16 16-37.8 25.1-60.5 25.1h-3.4c-26.1 0-50.9-11.6-67.6-31.7l-32.3-38.7c-11.7 4.1-24.2 6.4-37.3 6.4l-.1 0 0 0c-6.3 0-12.5-.5-18.6-1.5c-3.6-.6-7.2-1.4-10.7-2.3l0 0c-28.9-7.8-53.1-26.8-67.8-52.2c-4.4-7.6-14.2-10.3-21.9-5.8s-10.3 14.2-5.8 21.9c24 41.5 68.3 70 119.3 71.9l47.2 70.8c4 6.1 6.2 13.2 6.2 20.4c0 20.3-16.5 36.8-36.8 36.8H112c-26.5 0-48-21.5-48-48zM392 224a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
    ]
};
var $d8206b3ab2e65c05$export$cd79eeea6201e9d4 = {
    prefix: "fas",
    iconName: "bore-hole",
    icon: [
        512,
        512,
        [],
        "e4c3",
        "M256 0c-17.7 0-32 14.3-32 32V296.6c-19.1 11.1-32 31.7-32 55.4c0 35.3 28.7 64 64 64s64-28.7 64-64c0-23.7-12.9-44.4-32-55.4V32c0-17.7-14.3-32-32-32zM48 128c-26.5 0-48 21.5-48 48V464c0 26.5 21.5 48 48 48H464c26.5 0 48-21.5 48-48V176c0-26.5-21.5-48-48-48H384c-17.7 0-32 14.3-32 32V352c0 53-43 96-96 96s-96-43-96-96V160c0-17.7-14.3-32-32-32H48z"
    ]
};
var $d8206b3ab2e65c05$export$5548c3eb51060fa8 = {
    prefix: "fas",
    iconName: "industry",
    icon: [
        576,
        512,
        [],
        "f275",
        "M64 32C46.3 32 32 46.3 32 64V304v48 80c0 26.5 21.5 48 48 48H496c26.5 0 48-21.5 48-48V304 152.2c0-18.2-19.4-29.7-35.4-21.1L352 215.4V152.2c0-18.2-19.4-29.7-35.4-21.1L160 215.4V64c0-17.7-14.3-32-32-32H64z"
    ]
};
var $d8206b3ab2e65c05$export$531badb89cf01312 = {
    prefix: "fas",
    iconName: "circle-down",
    icon: [
        512,
        512,
        [
            61466,
            "arrow-alt-circle-down"
        ],
        "f358",
        "M256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM376.9 294.6L269.8 394.5c-3.8 3.5-8.7 5.5-13.8 5.5s-10.1-2-13.8-5.5L135.1 294.6c-4.5-4.2-7.1-10.1-7.1-16.3c0-12.3 10-22.3 22.3-22.3l57.7 0 0-96c0-17.7 14.3-32 32-32l32 0c17.7 0 32 14.3 32 32l0 96 57.7 0c12.3 0 22.3 10 22.3 22.3c0 6.2-2.6 12.1-7.1 16.3z"
    ]
};
var $d8206b3ab2e65c05$export$ff3afbc8c0bc5d59 = $d8206b3ab2e65c05$export$531badb89cf01312;
var $d8206b3ab2e65c05$export$b9d8fdf63999a76d = {
    prefix: "fas",
    iconName: "arrows-turn-to-dots",
    icon: [
        512,
        512,
        [],
        "e4c1",
        "M249.4 25.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L269.3 96 416 96c53 0 96 43 96 96v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V192c0-17.7-14.3-32-32-32l-146.7 0 25.4 25.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-80-80c-12.5-12.5-12.5-32.8 0-45.3l80-80zm13.3 256l80 80c12.5 12.5 12.5 32.8 0 45.3l-80 80c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 416 96 416c-17.7 0-32 14.3-32 32v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V448c0-53 43-96 96-96l146.7 0-25.4-25.4c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0zM384 384a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM64 192A64 64 0 1 1 64 64a64 64 0 1 1 0 128z"
    ]
};
var $d8206b3ab2e65c05$export$6248ec7440b2ffcb = {
    prefix: "fas",
    iconName: "florin-sign",
    icon: [
        384,
        512,
        [],
        "e184",
        "M314.7 32c-38.8 0-73.7 23.3-88.6 59.1L170.7 224H64c-17.7 0-32 14.3-32 32s14.3 32 32 32h80L98.9 396.3c-5 11.9-16.6 19.7-29.5 19.7H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H69.3c38.8 0 73.7-23.3 88.6-59.1L213.3 288H320c17.7 0 32-14.3 32-32s-14.3-32-32-32H240l45.1-108.3c5-11.9 16.6-19.7 29.5-19.7H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H314.7z"
    ]
};
var $d8206b3ab2e65c05$export$a51c464b699200ae = {
    prefix: "fas",
    iconName: "arrow-down-short-wide",
    icon: [
        576,
        512,
        [
            "sort-amount-desc",
            "sort-amount-down-alt"
        ],
        "f884",
        "M151.6 469.6C145.5 476.2 137 480 128 480s-17.5-3.8-23.6-10.4l-88-96c-11.9-13-11.1-33.3 2-45.2s33.3-11.1 45.2 2L96 365.7V64c0-17.7 14.3-32 32-32s32 14.3 32 32V365.7l32.4-35.4c11.9-13 32.2-13.9 45.2-2s13.9 32.2 2 45.2l-88 96zM320 32h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H320c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 128h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H320c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 128H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H320c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 128H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H320c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
    ]
};
var $d8206b3ab2e65c05$export$93835bc31892b5c3 = $d8206b3ab2e65c05$export$a51c464b699200ae;
var $d8206b3ab2e65c05$export$e7d80d8c226cb77 = $d8206b3ab2e65c05$export$a51c464b699200ae;
var $d8206b3ab2e65c05$export$7f24f1bf98af5411 = {
    prefix: "fas",
    iconName: "less-than",
    icon: [
        384,
        512,
        [
            62774
        ],
        "3c",
        "M380.6 81.7c7.9 15.8 1.5 35-14.3 42.9L103.6 256 366.3 387.4c15.8 7.9 22.2 27.1 14.3 42.9s-27.1 22.2-42.9 14.3l-320-160C6.8 279.2 0 268.1 0 256s6.8-23.2 17.7-28.6l320-160c15.8-7.9 35-1.5 42.9 14.3z"
    ]
};
var $d8206b3ab2e65c05$export$4b5be0142d10f342 = {
    prefix: "fas",
    iconName: "angle-down",
    icon: [
        448,
        512,
        [
            8964
        ],
        "f107",
        "M201.4 342.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 274.7 86.6 137.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z"
    ]
};
var $d8206b3ab2e65c05$export$ec5cfe409de2ed37 = {
    prefix: "fas",
    iconName: "car-tunnel",
    icon: [
        512,
        512,
        [],
        "e4de",
        "M256 0C114.6 0 0 114.6 0 256V448c0 35.3 28.7 64 64 64h42.8c-6.6-5.9-10.8-14.4-10.8-24V376c0-20.8 11.3-38.9 28.1-48.6l21-64.7c7.5-23.1 29-38.7 53.3-38.7H313.6c24.3 0 45.8 15.6 53.3 38.7l21 64.7c16.8 9.7 28.2 27.8 28.2 48.6V488c0 9.6-4.2 18.1-10.8 24H448c35.3 0 64-28.7 64-64V256C512 114.6 397.4 0 256 0zM362.8 512c-6.6-5.9-10.8-14.4-10.8-24V448H160v40c0 9.6-4.2 18.1-10.8 24H362.8zM190.8 277.5L177 320H335l-13.8-42.5c-1.1-3.3-4.1-5.5-7.6-5.5H198.4c-3.5 0-6.5 2.2-7.6 5.5zM168 408a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm200-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"
    ]
};
var $d8206b3ab2e65c05$export$3cd04b7c1624f598 = {
    prefix: "fas",
    iconName: "head-side-cough",
    icon: [
        640,
        512,
        [],
        "e061",
        "M0 224.2C0 100.6 100.2 0 224 0h24c95.2 0 181.2 69.3 197.3 160.2c2.3 13 6.8 25.7 15.1 36l42 52.6c6.2 7.8 9.6 17.4 9.6 27.4c0 24.2-19.6 43.8-43.8 43.8H448v0 32L339.2 365.6c-11 1.4-19.2 10.7-19.2 21.8c0 11.6 9 21.2 20.6 21.9L448 416v16c0 26.5-21.5 48-48 48H320v8c0 13.3-10.7 24-24 24H256v0H96c-17.7 0-32-14.3-32-32V407.3c0-16.7-6.9-32.5-17.1-45.8C16.6 322.4 0 274.1 0 224.2zm352-.2a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM464 384a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm152-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM592 480a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM552 312a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm40-24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM552 408a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
    ]
};
var $d8206b3ab2e65c05$export$1412f35381064d7d = {
    prefix: "fas",
    iconName: "grip-lines",
    icon: [
        448,
        512,
        [],
        "f7a4",
        "M32 288c-17.7 0-32 14.3-32 32s14.3 32 32 32l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 288zm0-128c-17.7 0-32 14.3-32 32s14.3 32 32 32l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 160z"
    ]
};
var $d8206b3ab2e65c05$export$aba24ca305bbe8c1 = {
    prefix: "fas",
    iconName: "thumbs-down",
    icon: [
        512,
        512,
        [
            128078,
            61576
        ],
        "f165",
        "M313.4 479.1c26-5.2 42.9-30.5 37.7-56.5l-2.3-11.4c-5.3-26.7-15.1-52.1-28.8-75.2H464c26.5 0 48-21.5 48-48c0-18.5-10.5-34.6-25.9-42.6C497 236.6 504 223.1 504 208c0-23.4-16.8-42.9-38.9-47.1c4.4-7.3 6.9-15.8 6.9-24.9c0-21.3-13.9-39.4-33.1-45.6c.7-3.3 1.1-6.8 1.1-10.4c0-26.5-21.5-48-48-48H294.5c-19 0-37.5 5.6-53.3 16.1L202.7 73.8C176 91.6 160 121.6 160 153.7V192v48 24.9c0 29.2 13.3 56.7 36 75l7.4 5.9c26.5 21.2 44.6 51 51.2 84.2l2.3 11.4c5.2 26 30.5 42.9 56.5 37.7zM32 384H96c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32H32C14.3 96 0 110.3 0 128V352c0 17.7 14.3 32 32 32z"
    ]
};
var $d8206b3ab2e65c05$export$d9b89b5872b67a4f = {
    prefix: "fas",
    iconName: "user-lock",
    icon: [
        640,
        512,
        [],
        "f502",
        "M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H392.6c-5.4-9.4-8.6-20.3-8.6-32V352c0-2.1 .1-4.2 .3-6.3c-31-26-71-41.7-114.6-41.7H178.3zM528 240c17.7 0 32 14.3 32 32v48H496V272c0-17.7 14.3-32 32-32zm-80 32v48c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H608c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32V272c0-44.2-35.8-80-80-80s-80 35.8-80 80z"
    ]
};
var $d8206b3ab2e65c05$export$becbc35d3541bcc = {
    prefix: "fas",
    iconName: "arrow-right-long",
    icon: [
        512,
        512,
        [
            "long-arrow-right"
        ],
        "f178",
        "M502.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l370.7 0-73.4 73.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l128-128z"
    ]
};
var $d8206b3ab2e65c05$export$7ec6527cf8651899 = $d8206b3ab2e65c05$export$becbc35d3541bcc;
var $d8206b3ab2e65c05$export$f6773af4219eebd = {
    prefix: "fas",
    iconName: "anchor-circle-xmark",
    icon: [
        640,
        512,
        [],
        "e4ac",
        "M320 96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm21.1 80C367 158.8 384 129.4 384 96c0-53-43-96-96-96s-96 43-96 96c0 33.4 17 62.8 42.9 80H224c-17.7 0-32 14.3-32 32s14.3 32 32 32h32V448H208c-53 0-96-43-96-96v-6.1l7 7c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L97 263c-9.4-9.4-24.6-9.4-33.9 0L7 319c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l7-7V352c0 88.4 71.6 160 160 160h80 80c8.2 0 16.3-.6 24.2-1.8c-22.2-16.2-40.4-37.5-53-62.2H320V368 240h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H341.1zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm59.3-180.7L518.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L473.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L496 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
    ]
};
var $d8206b3ab2e65c05$export$37fe3659ba7b6b54 = {
    prefix: "fas",
    iconName: "ellipsis",
    icon: [
        448,
        512,
        [
            "ellipsis-h"
        ],
        "f141",
        "M8 256a56 56 0 1 1 112 0A56 56 0 1 1 8 256zm160 0a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zm216-56a56 56 0 1 1 0 112 56 56 0 1 1 0-112z"
    ]
};
var $d8206b3ab2e65c05$export$c9f2fedd4489a2ee = $d8206b3ab2e65c05$export$37fe3659ba7b6b54;
var $d8206b3ab2e65c05$export$3db75d5ac9e98468 = {
    prefix: "fas",
    iconName: "chess-pawn",
    icon: [
        320,
        512,
        [
            9823
        ],
        "f443",
        "M215.5 224c29.2-18.4 48.5-50.9 48.5-88c0-57.4-46.6-104-104-104S56 78.6 56 136c0 37.1 19.4 69.6 48.5 88H96c-17.7 0-32 14.3-32 32c0 16.5 12.5 30 28.5 31.8L80 400H240L227.5 287.8c16-1.8 28.5-15.3 28.5-31.8c0-17.7-14.3-32-32-32h-8.5zM22.6 473.4c-4.2 4.2-6.6 10-6.6 16C16 501.9 26.1 512 38.6 512H281.4c12.5 0 22.6-10.1 22.6-22.6c0-6-2.4-11.8-6.6-16L256 432H64L22.6 473.4z"
    ]
};
var $d8206b3ab2e65c05$export$f04e7a0f1033a0cd = {
    prefix: "fas",
    iconName: "kit-medical",
    icon: [
        576,
        512,
        [
            "first-aid"
        ],
        "f479",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H96V32H64zm64 0V480H448V32H128zM512 480c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H480V480h32zM256 176c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H320v48c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V288H208c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16h48V176z"
    ]
};
var $d8206b3ab2e65c05$export$5b01ccb2da4c4387 = $d8206b3ab2e65c05$export$f04e7a0f1033a0cd;
var $d8206b3ab2e65c05$export$a77a2f6da72f89e3 = {
    prefix: "fas",
    iconName: "person-through-window",
    icon: [
        640,
        512,
        [],
        "e5a9",
        "M64 64l224 0 0 9.8c0 39-23.7 74-59.9 88.4C167.6 186.5 128 245 128 310.2l0 73.8s0 0 0 0H64V64zm288 0l224 0V384H508.3l-3.7-4.5-75.2-90.2c-9.1-10.9-22.6-17.3-36.9-17.3l-71.1 0-41-63.1c-.3-.5-.6-1-1-1.4c44.7-29 72.5-79 72.5-133.6l0-9.8zm73 320H379.2l42.7 64H592c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48V400c0 26.5 21.5 48 48 48H308.2l33.2 49.8c9.8 14.7 29.7 18.7 44.4 8.9s18.7-29.7 8.9-44.4L310.5 336l74.6 0 40 48zm-159.5 0H192s0 0 0 0l0-73.8c0-10.2 1.6-20.1 4.7-29.5L265.5 384zM192 128a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"
    ]
};
var $d8206b3ab2e65c05$export$b34d64c205c732a9 = {
    prefix: "fas",
    iconName: "toolbox",
    icon: [
        512,
        512,
        [
            129520
        ],
        "f552",
        "M176 88v40H336V88c0-4.4-3.6-8-8-8H184c-4.4 0-8 3.6-8 8zm-48 40V88c0-30.9 25.1-56 56-56H328c30.9 0 56 25.1 56 56v40h28.1c12.7 0 24.9 5.1 33.9 14.1l51.9 51.9c9 9 14.1 21.2 14.1 33.9V304H384V288c0-17.7-14.3-32-32-32s-32 14.3-32 32v16H192V288c0-17.7-14.3-32-32-32s-32 14.3-32 32v16H0V227.9c0-12.7 5.1-24.9 14.1-33.9l51.9-51.9c9-9 21.2-14.1 33.9-14.1H128zM0 416V336H128v16c0 17.7 14.3 32 32 32s32-14.3 32-32V336H320v16c0 17.7 14.3 32 32 32s32-14.3 32-32V336H512v80c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64z"
    ]
};
var $d8206b3ab2e65c05$export$3aa81d0e606b08b6 = {
    prefix: "fas",
    iconName: "hands-holding-circle",
    icon: [
        640,
        512,
        [],
        "e4fb",
        "M320 0a128 128 0 1 1 0 256A128 128 0 1 1 320 0zM40 64c22.1 0 40 17.9 40 40v40 80 40.2c0 17 6.7 33.3 18.7 45.3l51.1 51.1c8.3 8.3 21.3 9.6 31 3.1c12.9-8.6 14.7-26.9 3.7-37.8l-15.2-15.2-32-32c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l32 32 15.2 15.2 0 0 25.3 25.3c21 21 32.8 49.5 32.8 79.2V464c0 26.5-21.5 48-48 48H173.3c-17 0-33.3-6.7-45.3-18.7L28.1 393.4C10.1 375.4 0 351 0 325.5V224 160 104C0 81.9 17.9 64 40 64zm560 0c22.1 0 40 17.9 40 40v56 64V325.5c0 25.5-10.1 49.9-28.1 67.9L512 493.3c-12 12-28.3 18.7-45.3 18.7H400c-26.5 0-48-21.5-48-48V385.1c0-29.7 11.8-58.2 32.8-79.2l25.3-25.3 0 0 15.2-15.2 32-32c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-32 32-15.2 15.2c-11 11-9.2 29.2 3.7 37.8c9.7 6.5 22.7 5.2 31-3.1l51.1-51.1c12-12 18.7-28.3 18.7-45.3V224 144 104c0-22.1 17.9-40 40-40z"
    ]
};
var $d8206b3ab2e65c05$export$a18cfac400116d9f = {
    prefix: "fas",
    iconName: "bug",
    icon: [
        512,
        512,
        [],
        "f188",
        "M256 0c53 0 96 43 96 96v3.6c0 15.7-12.7 28.4-28.4 28.4H188.4c-15.7 0-28.4-12.7-28.4-28.4V96c0-53 43-96 96-96zM41.4 105.4c12.5-12.5 32.8-12.5 45.3 0l64 64c.7 .7 1.3 1.4 1.9 2.1c14.2-7.3 30.4-11.4 47.5-11.4H312c17.1 0 33.2 4.1 47.5 11.4c.6-.7 1.2-1.4 1.9-2.1l64-64c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-64 64c-.7 .7-1.4 1.3-2.1 1.9c6.2 12 10.1 25.3 11.1 39.5H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H416c0 24.6-5.5 47.8-15.4 68.6c2.2 1.3 4.2 2.9 6 4.8l64 64c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-63.1-63.1c-24.5 21.8-55.8 36.2-90.3 39.6V240c0-8.8-7.2-16-16-16s-16 7.2-16 16V479.2c-34.5-3.4-65.8-17.8-90.3-39.6L86.6 502.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l64-64c1.9-1.9 3.9-3.4 6-4.8C101.5 367.8 96 344.6 96 320H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H96.3c1.1-14.1 5-27.5 11.1-39.5c-.7-.6-1.4-1.2-2.1-1.9l-64-64c-12.5-12.5-12.5-32.8 0-45.3z"
    ]
};
var $d8206b3ab2e65c05$export$3e7437bf6535bef0 = {
    prefix: "fas",
    iconName: "credit-card",
    icon: [
        576,
        512,
        [
            128179,
            62083,
            "credit-card-alt"
        ],
        "f09d",
        "M64 32C28.7 32 0 60.7 0 96v32H576V96c0-35.3-28.7-64-64-64H64zM576 224H0V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V224zM112 352h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm112 16c0-8.8 7.2-16 16-16H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H240c-8.8 0-16-7.2-16-16z"
    ]
};
var $d8206b3ab2e65c05$export$5fffe8e3c36964a2 = $d8206b3ab2e65c05$export$3e7437bf6535bef0;
var $d8206b3ab2e65c05$export$9eefe7fcdf123b76 = {
    prefix: "fas",
    iconName: "car",
    icon: [
        512,
        512,
        [
            128664,
            "automobile"
        ],
        "f1b9",
        "M135.2 117.4L109.1 192H402.9l-26.1-74.6C372.3 104.6 360.2 96 346.6 96H165.4c-13.6 0-25.7 8.6-30.2 21.4zM39.6 196.8L74.8 96.3C88.3 57.8 124.6 32 165.4 32H346.6c40.8 0 77.1 25.8 90.6 64.3l35.2 100.5c23.2 9.6 39.6 32.5 39.6 59.2V400v48c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32V400H96v48c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V400 256c0-26.7 16.4-49.6 39.6-59.2zM128 288a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm288 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
var $d8206b3ab2e65c05$export$240a6c53cf7ac525 = $d8206b3ab2e65c05$export$9eefe7fcdf123b76;
var $d8206b3ab2e65c05$export$6638511b28df3be5 = {
    prefix: "fas",
    iconName: "hand-holding-hand",
    icon: [
        576,
        512,
        [],
        "e4f7",
        "M7.8 207.7c-13.1-17.8-9.3-42.8 8.5-55.9L142.9 58.5C166.2 41.3 194.5 32 223.5 32H384 544c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H507.2l-44.9 36c-22.7 18.2-50.9 28-80 28H304 288 224c-17.7 0-32-14.3-32-32s14.3-32 32-32h64 16c8.8 0 16-7.2 16-16s-7.2-16-16-16H183.4L63.7 216.2c-17.8 13.1-42.8 9.3-55.9-8.5zM382.4 160l0 0 .9 0c-.3 0-.6 0-.9 0zM568.2 304.3c13.1 17.8 9.3 42.8-8.5 55.9L433.1 453.5c-23.4 17.2-51.6 26.5-80.7 26.5H192 32c-17.7 0-32-14.3-32-32V384c0-17.7 14.3-32 32-32H68.8l44.9-36c22.7-18.2 50.9-28 80-28H272h16 64c17.7 0 32 14.3 32 32s-14.3 32-32 32H288 272c-8.8 0-16 7.2-16 16s7.2 16 16 16H392.6l119.7-88.2c17.8-13.1 42.8-9.3 55.9 8.5zM193.6 352l0 0-.9 0c.3 0 .6 0 .9 0z"
    ]
};
var $d8206b3ab2e65c05$export$cb6e40528b98a5b = {
    prefix: "fas",
    iconName: "book-open-reader",
    icon: [
        512,
        512,
        [
            "book-reader"
        ],
        "f5da",
        "M160 96a96 96 0 1 1 192 0A96 96 0 1 1 160 96zm80 152V512l-48.4-24.2c-20.9-10.4-43.5-17-66.8-19.3l-96-9.6C12.5 457.2 0 443.5 0 427V224c0-17.7 14.3-32 32-32H62.3c63.6 0 125.6 19.6 177.7 56zm32 264V248c52.1-36.4 114.1-56 177.7-56H480c17.7 0 32 14.3 32 32V427c0 16.4-12.5 30.2-28.8 31.8l-96 9.6c-23.2 2.3-45.9 8.9-66.8 19.3L272 512z"
    ]
};
var $d8206b3ab2e65c05$export$cee14fe33262fa7d = $d8206b3ab2e65c05$export$cb6e40528b98a5b;
var $d8206b3ab2e65c05$export$af9eaee7db3ba7a9 = {
    prefix: "fas",
    iconName: "mountain-sun",
    icon: [
        640,
        512,
        [],
        "e52f",
        "M560 160A80 80 0 1 0 560 0a80 80 0 1 0 0 160zM55.9 512H381.1h75H578.9c33.8 0 61.1-27.4 61.1-61.1c0-11.2-3.1-22.2-8.9-31.8l-132-216.3C495 196.1 487.8 192 480 192s-15 4.1-19.1 10.7l-48.2 79L286.8 81c-6.6-10.6-18.3-17-30.8-17s-24.1 6.4-30.8 17L8.6 426.4C3 435.3 0 445.6 0 456.1C0 487 25 512 55.9 512z"
    ]
};
var $d8206b3ab2e65c05$export$a63cecc8a4166c49 = {
    prefix: "fas",
    iconName: "arrows-left-right-to-line",
    icon: [
        640,
        512,
        [],
        "e4ba",
        "M32 64c17.7 0 32 14.3 32 32l0 320c0 17.7-14.3 32-32 32s-32-14.3-32-32V96C0 78.3 14.3 64 32 64zm214.6 73.4c12.5 12.5 12.5 32.8 0 45.3L205.3 224l229.5 0-41.4-41.4c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l96 96c12.5 12.5 12.5 32.8 0 45.3l-96 96c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L434.7 288l-229.5 0 41.4 41.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-96-96c-12.5-12.5-12.5-32.8 0-45.3l96-96c12.5-12.5 32.8-12.5 45.3 0zM640 96V416c0 17.7-14.3 32-32 32s-32-14.3-32-32V96c0-17.7 14.3-32 32-32s32 14.3 32 32z"
    ]
};
var $d8206b3ab2e65c05$export$b06003a02c9055bd = {
    prefix: "fas",
    iconName: "dice-d20",
    icon: [
        512,
        512,
        [],
        "f6cf",
        "M48.7 125.8l53.2 31.9c7.8 4.7 17.8 2 22.2-5.9L201.6 12.1c3-5.4-.9-12.1-7.1-12.1c-1.6 0-3.2 .5-4.6 1.4L47.9 98.8c-9.6 6.6-9.2 20.9 .8 26.9zM16 171.7V295.3c0 8 10.4 11 14.7 4.4l60-92c5-7.6 2.6-17.8-5.2-22.5L40.2 158C29.6 151.6 16 159.3 16 171.7zM310.4 12.1l77.6 139.6c4.4 7.9 14.5 10.6 22.2 5.9l53.2-31.9c10-6 10.4-20.3 .8-26.9L322.1 1.4c-1.4-.9-3-1.4-4.6-1.4c-6.2 0-10.1 6.7-7.1 12.1zM496 171.7c0-12.4-13.6-20.1-24.2-13.7l-45.3 27.2c-7.8 4.7-10.1 14.9-5.2 22.5l60 92c4.3 6.7 14.7 3.6 14.7-4.4V171.7zm-49.3 246L286.1 436.6c-8.1 .9-14.1 7.8-14.1 15.9v52.8c0 3.7 3 6.8 6.8 6.8c.8 0 1.6-.1 2.4-.4l172.7-64c6.1-2.2 10.1-8 10.1-14.5c0-9.3-8.1-16.5-17.3-15.4zM233.2 512c3.7 0 6.8-3 6.8-6.8V452.6c0-8.1-6.1-14.9-14.1-15.9l-160.6-19c-9.2-1.1-17.3 6.1-17.3 15.4c0 6.5 4 12.3 10.1 14.5l172.7 64c.8 .3 1.6 .4 2.4 .4zM41.7 382.9l170.9 20.2c7.8 .9 13.4-7.5 9.5-14.3l-85.7-150c-5.9-10.4-20.7-10.8-27.3-.8L30.2 358.2c-6.5 9.9-.3 23.3 11.5 24.7zm439.6-24.8L402.9 238.1c-6.5-10-21.4-9.6-27.3 .8L290.2 388.5c-3.9 6.8 1.6 15.2 9.5 14.3l170.1-20c11.8-1.4 18-14.7 11.5-24.6zm-216.9 11l78.4-137.2c6.1-10.7-1.6-23.9-13.9-23.9H183.1c-12.3 0-20 13.3-13.9 23.9l78.4 137.2c3.7 6.4 13 6.4 16.7 0zM174.4 176H337.6c12.2 0 19.9-13.1 14-23.8l-80-144c-2.8-5.1-8.2-8.2-14-8.2h-3.2c-5.8 0-11.2 3.2-14 8.2l-80 144c-5.9 10.7 1.8 23.8 14 23.8z"
    ]
};
var $d8206b3ab2e65c05$export$41ce20639e8fef2b = {
    prefix: "fas",
    iconName: "truck-droplet",
    icon: [
        640,
        512,
        [],
        "e58c",
        "M0 48C0 21.5 21.5 0 48 0H368c26.5 0 48 21.5 48 48V96h50.7c17 0 33.3 6.7 45.3 18.7L589.3 192c12 12 18.7 28.3 18.7 45.3V256v32 64c17.7 0 32 14.3 32 32s-14.3 32-32 32H576c0 53-43 96-96 96s-96-43-96-96H256c0 53-43 96-96 96s-96-43-96-96H48c-26.5 0-48-21.5-48-48V48zM416 256H544V237.3L466.7 160H416v96zM160 464a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm368-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM208 272c39.8 0 72-29.6 72-66c0-27-39.4-82.9-59.9-110.3c-6.1-8.2-18.1-8.2-24.2 0C175.4 123 136 179 136 206c0 36.5 32.2 66 72 66z"
    ]
};
var $d8206b3ab2e65c05$export$e4686afbe882e24a = {
    prefix: "fas",
    iconName: "file-circle-xmark",
    icon: [
        576,
        512,
        [],
        "e5a1",
        "M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384v38.6C310.1 219.5 256 287.4 256 368c0 59.1 29.1 111.3 73.7 143.3c-3.2 .5-6.4 .7-9.7 .7H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128zm48 96a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm59.3 107.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L432 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L409.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L432 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L454.6 368l36.7-36.7z"
    ]
};
var $d8206b3ab2e65c05$export$d7a5da41ce01461d = {
    prefix: "fas",
    iconName: "temperature-arrow-up",
    icon: [
        576,
        512,
        [
            "temperature-up"
        ],
        "e040",
        "M128 112c0-26.5 21.5-48 48-48s48 21.5 48 48V276.5c0 17.3 7.1 31.9 15.3 42.5C249.8 332.6 256 349.5 256 368c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-18.5 6.2-35.4 16.7-48.9c8.2-10.6 15.3-25.2 15.3-42.5V112zM176 0C114.1 0 64 50.1 64 112V276.4c0 .1-.1 .3-.2 .6c-.2 .6-.8 1.6-1.7 2.8C43.2 304.2 32 334.8 32 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-33.2-11.2-63.8-30.1-88.1c-.9-1.2-1.5-2.2-1.7-2.8c-.1-.3-.2-.5-.2-.6V112C288 50.1 237.9 0 176 0zm0 416c26.5 0 48-21.5 48-48c0-20.9-13.4-38.7-32-45.3V112c0-8.8-7.2-16-16-16s-16 7.2-16 16V322.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48zM480 160h32c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-64-64c-12.5-12.5-32.8-12.5-45.3 0l-64 64c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8h32V448c0 17.7 14.3 32 32 32s32-14.3 32-32V160z"
    ]
};
var $d8206b3ab2e65c05$export$872345a0157330a3 = $d8206b3ab2e65c05$export$d7a5da41ce01461d;
var $d8206b3ab2e65c05$export$b48a5be96314835a = {
    prefix: "fas",
    iconName: "medal",
    icon: [
        512,
        512,
        [
            127941
        ],
        "f5a2",
        "M4.1 38.2C1.4 34.2 0 29.4 0 24.6C0 11 11 0 24.6 0H133.9c11.2 0 21.7 5.9 27.4 15.5l68.5 114.1c-48.2 6.1-91.3 28.6-123.4 61.9L4.1 38.2zm503.7 0L405.6 191.5c-32.1-33.3-75.2-55.8-123.4-61.9L350.7 15.5C356.5 5.9 366.9 0 378.1 0H487.4C501 0 512 11 512 24.6c0 4.8-1.4 9.6-4.1 13.6zM80 336a176 176 0 1 1 352 0A176 176 0 1 1 80 336zm184.4-94.9c-3.4-7-13.3-7-16.8 0l-22.4 45.4c-1.4 2.8-4 4.7-7 5.1L168 298.9c-7.7 1.1-10.7 10.5-5.2 16l36.3 35.4c2.2 2.2 3.2 5.2 2.7 8.3l-8.6 49.9c-1.3 7.6 6.7 13.5 13.6 9.9l44.8-23.6c2.7-1.4 6-1.4 8.7 0l44.8 23.6c6.9 3.6 14.9-2.2 13.6-9.9l-8.6-49.9c-.5-3 .5-6.1 2.7-8.3l36.3-35.4c5.6-5.4 2.5-14.8-5.2-16l-50.1-7.3c-3-.4-5.7-2.4-7-5.1l-22.4-45.4z"
    ]
};
var $d8206b3ab2e65c05$export$f24e0fce77994d4d = {
    prefix: "fas",
    iconName: "bed",
    icon: [
        640,
        512,
        [
            128716
        ],
        "f236",
        "M32 32c17.7 0 32 14.3 32 32V320H288V160c0-17.7 14.3-32 32-32H544c53 0 96 43 96 96V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V416H352 320 64v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V64C0 46.3 14.3 32 32 32zm144 96a80 80 0 1 1 0 160 80 80 0 1 1 0-160z"
    ]
};
var $d8206b3ab2e65c05$export$51e3c5be06a49e32 = {
    prefix: "fas",
    iconName: "square-h",
    icon: [
        448,
        512,
        [
            "h-square"
        ],
        "f0fd",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM336 152V256 360c0 13.3-10.7 24-24 24s-24-10.7-24-24V280H160l0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-208c0-13.3 10.7-24 24-24s24 10.7 24 24v80H288V152c0-13.3 10.7-24 24-24s24 10.7 24 24z"
    ]
};
var $d8206b3ab2e65c05$export$f08bbcf8f59eafc2 = $d8206b3ab2e65c05$export$51e3c5be06a49e32;
var $d8206b3ab2e65c05$export$5c0b4709125e92f8 = {
    prefix: "fas",
    iconName: "podcast",
    icon: [
        448,
        512,
        [],
        "f2ce",
        "M319.4 372c48.5-31.3 80.6-85.9 80.6-148c0-97.2-78.8-176-176-176S48 126.8 48 224c0 62.1 32.1 116.6 80.6 148c1.2 17.3 4 38 7.2 57.1l.2 1C56 395.8 0 316.5 0 224C0 100.3 100.3 0 224 0S448 100.3 448 224c0 92.5-56 171.9-136 206.1l.2-1.1c3.1-19.2 6-39.8 7.2-57zm-2.3-38.1c-1.6-5.7-3.9-11.1-7-16.2c-5.8-9.7-13.5-17-21.9-22.4c19.5-17.6 31.8-43 31.8-71.3c0-53-43-96-96-96s-96 43-96 96c0 28.3 12.3 53.8 31.8 71.3c-8.4 5.4-16.1 12.7-21.9 22.4c-3.1 5.1-5.4 10.5-7 16.2C99.8 307.5 80 268 80 224c0-79.5 64.5-144 144-144s144 64.5 144 144c0 44-19.8 83.5-50.9 109.9zM224 312c32.9 0 64 8.6 64 43.8c0 33-12.9 104.1-20.6 132.9c-5.1 19-24.5 23.4-43.4 23.4s-38.2-4.4-43.4-23.4c-7.8-28.5-20.6-99.7-20.6-132.8c0-35.1 31.1-43.8 64-43.8zm0-144a56 56 0 1 1 0 112 56 56 0 1 1 0-112z"
    ]
};
var $d8206b3ab2e65c05$export$bf4d97a79734997f = {
    prefix: "fas",
    iconName: "temperature-full",
    icon: [
        320,
        512,
        [
            "temperature-4",
            "thermometer-4",
            "thermometer-full"
        ],
        "f2c7",
        "M160 64c-26.5 0-48 21.5-48 48V276.5c0 17.3-7.1 31.9-15.3 42.5C86.2 332.6 80 349.5 80 368c0 44.2 35.8 80 80 80s80-35.8 80-80c0-18.5-6.2-35.4-16.7-48.9c-8.2-10.6-15.3-25.2-15.3-42.5V112c0-26.5-21.5-48-48-48zM48 112C48 50.2 98.1 0 160 0s112 50.1 112 112V276.5c0 .1 .1 .3 .2 .6c.2 .6 .8 1.6 1.7 2.8c18.9 24.4 30.1 55 30.1 88.1c0 79.5-64.5 144-144 144S16 447.5 16 368c0-33.2 11.2-63.8 30.1-88.1c.9-1.2 1.5-2.2 1.7-2.8c.1-.3 .2-.5 .2-.6V112zM208 368c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V112c0-8.8 7.2-16 16-16s16 7.2 16 16V322.7c18.6 6.6 32 24.4 32 45.3z"
    ]
};
var $d8206b3ab2e65c05$export$db946f8dc50a57ca = $d8206b3ab2e65c05$export$bf4d97a79734997f;
var $d8206b3ab2e65c05$export$92b2e2293472dd50 = $d8206b3ab2e65c05$export$bf4d97a79734997f;
var $d8206b3ab2e65c05$export$74e07083cef79a6f = $d8206b3ab2e65c05$export$bf4d97a79734997f;
var $d8206b3ab2e65c05$export$9b6162797ab1b255 = {
    prefix: "fas",
    iconName: "bell",
    icon: [
        448,
        512,
        [
            128276,
            61602
        ],
        "f0f3",
        "M224 0c-17.7 0-32 14.3-32 32V51.2C119 66 64 130.6 64 208v18.8c0 47-17.3 92.4-48.5 127.6l-7.4 8.3c-8.4 9.4-10.4 22.9-5.3 34.4S19.4 416 32 416H416c12.6 0 24-7.4 29.2-18.9s3.1-25-5.3-34.4l-7.4-8.3C401.3 319.2 384 273.9 384 226.8V208c0-77.4-55-142-128-156.8V32c0-17.7-14.3-32-32-32zm45.3 493.3c12-12 18.7-28.3 18.7-45.3H224 160c0 17 6.7 33.3 18.7 45.3s28.3 18.7 45.3 18.7s33.3-6.7 45.3-18.7z"
    ]
};
var $d8206b3ab2e65c05$export$4fa56a54e822dd25 = {
    prefix: "fas",
    iconName: "superscript",
    icon: [
        512,
        512,
        [],
        "f12b",
        "M480 32c0-11.1-5.7-21.4-15.2-27.2s-21.2-6.4-31.1-1.4l-32 16c-15.8 7.9-22.2 27.1-14.3 42.9C393 73.5 404.3 80 416 80v80c-17.7 0-32 14.3-32 32s14.3 32 32 32h32 32c17.7 0 32-14.3 32-32s-14.3-32-32-32V32zM32 64C14.3 64 0 78.3 0 96s14.3 32 32 32H47.3l89.6 128L47.3 384H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H64c10.4 0 20.2-5.1 26.2-13.6L176 311.8l85.8 122.6c6 8.6 15.8 13.6 26.2 13.6h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H304.7L215.1 256l89.6-128H320c17.7 0 32-14.3 32-32s-14.3-32-32-32H288c-10.4 0-20.2 5.1-26.2 13.6L176 200.2 90.2 77.6C84.2 69.1 74.4 64 64 64H32z"
    ]
};
var $d8206b3ab2e65c05$export$12ef959394d63192 = {
    prefix: "fas",
    iconName: "plug-circle-xmark",
    icon: [
        576,
        512,
        [],
        "e560",
        "M96 0C78.3 0 64 14.3 64 32v96h64V32c0-17.7-14.3-32-32-32zM288 0c-17.7 0-32 14.3-32 32v96h64V32c0-17.7-14.3-32-32-32zM32 160c-17.7 0-32 14.3-32 32s14.3 32 32 32v32c0 77.4 55 142 128 156.8V480c0 17.7 14.3 32 32 32s32-14.3 32-32V412.8c12.3-2.5 24.1-6.4 35.1-11.5c-2.1-10.8-3.1-21.9-3.1-33.3c0-80.3 53.8-148 127.3-169.2c.5-2.2 .7-4.5 .7-6.8c0-17.7-14.3-32-32-32H32zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm59.3-180.7L454.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L432 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L409.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L432 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
    ]
};
var $d8206b3ab2e65c05$export$aa3c4c1c5a47bf98 = {
    prefix: "fas",
    iconName: "star-of-life",
    icon: [
        512,
        512,
        [],
        "f621",
        "M208 32c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32V172.9l122-70.4c15.3-8.8 34.9-3.6 43.7 11.7l16 27.7c8.8 15.3 3.6 34.9-11.7 43.7L352 256l122 70.4c15.3 8.8 20.5 28.4 11.7 43.7l-16 27.7c-8.8 15.3-28.4 20.6-43.7 11.7L304 339.1V480c0 17.7-14.3 32-32 32H240c-17.7 0-32-14.3-32-32V339.1L86 409.6c-15.3 8.8-34.9 3.6-43.7-11.7l-16-27.7c-8.8-15.3-3.6-34.9 11.7-43.7L160 256 38 185.6c-15.3-8.8-20.5-28.4-11.7-43.7l16-27.7C51.1 98.8 70.7 93.6 86 102.4l122 70.4V32z"
    ]
};
var $d8206b3ab2e65c05$export$4c60a3aade08b6c2 = {
    prefix: "fas",
    iconName: "phone-slash",
    icon: [
        640,
        512,
        [],
        "f3dd",
        "M601.2 5.1c10.4-8.2 25.5-6.3 33.7 4.1s6.3 25.5-4.1 33.7l-592 464c-10.4 8.2-25.5 6.3-33.7-4.1s-6.3-25.5 4.1-33.7l155.6-122C101.8 270 64 171.4 64 64c0-18 12.1-33.8 29.5-38.6l88-24c19.4-5.3 39.7 4.6 47.4 23.2l40 96c6.8 16.3 2.1 35.2-11.6 46.3L208 207.3c12 25.5 27.2 49.2 45 70.7L601.2 5.1zM234.3 415.6l91.3-72c13.7 9.1 28 17.3 43 24.3L409 318.7c11.2-13.7 30-18.4 46.3-11.6l96 40c18.6 7.7 28.5 28 23.2 47.4l-24 88C545.8 499.9 530 512 512 512c-104.9 0-201.3-36-277.7-96.4z"
    ]
};
var $d8206b3ab2e65c05$export$d1de8d1b815d6a5 = {
    prefix: "fas",
    iconName: "paint-roller",
    icon: [
        512,
        512,
        [],
        "f5aa",
        "M0 64C0 28.7 28.7 0 64 0H352c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM160 352c0-17.7 14.3-32 32-32V304c0-44.2 35.8-80 80-80H416c17.7 0 32-14.3 32-32V160 69.5c37.3 13.2 64 48.7 64 90.5v32c0 53-43 96-96 96H272c-8.8 0-16 7.2-16 16v16c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V352z"
    ]
};
var $d8206b3ab2e65c05$export$503f458ca5cf64c2 = {
    prefix: "fas",
    iconName: "handshake-angle",
    icon: [
        640,
        512,
        [
            "hands-helping"
        ],
        "f4c4",
        "M544 248v3.3l69.7-69.7c21.9-21.9 21.9-57.3 0-79.2L535.6 24.4c-21.9-21.9-57.3-21.9-79.2 0L416.3 64.5c-2.7-.3-5.5-.5-8.3-.5H296c-37.1 0-67.6 28-71.6 64H224V248c0 22.1 17.9 40 40 40s40-17.9 40-40V176c0 0 0-.1 0-.1V160l16 0 136 0c0 0 0 0 .1 0H464c44.2 0 80 35.8 80 80v8zM336 192v56c0 39.8-32.2 72-72 72s-72-32.2-72-72V129.4c-35.9 6.2-65.8 32.3-76 68.2L99.5 255.2 26.3 328.4c-21.9 21.9-21.9 57.3 0 79.2l78.1 78.1c21.9 21.9 57.3 21.9 79.2 0l37.7-37.7c.9 0 1.8 .1 2.7 .1H384c26.5 0 48-21.5 48-48c0-5.6-1-11-2.7-16H432c26.5 0 48-21.5 48-48c0-12.8-5-24.4-13.2-33c25.7-5 45.1-27.6 45.2-54.8v-.4c-.1-30.8-25.1-55.8-56-55.8c0 0 0 0 0 0l-120 0z"
    ]
};
var $d8206b3ab2e65c05$export$287dbb1632da0d44 = $d8206b3ab2e65c05$export$503f458ca5cf64c2;
var $d8206b3ab2e65c05$export$90a475e93ff4bb8a = {
    prefix: "fas",
    iconName: "location-dot",
    icon: [
        384,
        512,
        [
            "map-marker-alt"
        ],
        "f3c5",
        "M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM192 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"
    ]
};
var $d8206b3ab2e65c05$export$4be92fa780613f93 = $d8206b3ab2e65c05$export$90a475e93ff4bb8a;
var $d8206b3ab2e65c05$export$cad54bead856a678 = {
    prefix: "fas",
    iconName: "file",
    icon: [
        384,
        512,
        [
            128196,
            128459,
            61462
        ],
        "f15b",
        "M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128z"
    ]
};
var $d8206b3ab2e65c05$export$da07b6bc24a496ca = {
    prefix: "fas",
    iconName: "greater-than",
    icon: [
        384,
        512,
        [
            62769
        ],
        "3e",
        "M3.4 81.7c-7.9 15.8-1.5 35 14.3 42.9L280.5 256 17.7 387.4C1.9 395.3-4.5 414.5 3.4 430.3s27.1 22.2 42.9 14.3l320-160c10.8-5.4 17.7-16.5 17.7-28.6s-6.8-23.2-17.7-28.6l-320-160c-15.8-7.9-35-1.5-42.9 14.3z"
    ]
};
var $d8206b3ab2e65c05$export$3fb4da6af843d39f = {
    prefix: "fas",
    iconName: "person-swimming",
    icon: [
        576,
        512,
        [
            127946,
            "swimmer"
        ],
        "f5c4",
        "M309.5 178.4L447.9 297.1c-1.6 .9-3.2 2-4.8 3c-18 12.4-40.1 20.3-59.2 20.3c-19.6 0-40.8-7.7-59.2-20.3c-22.1-15.5-51.6-15.5-73.7 0c-17.1 11.8-38 20.3-59.2 20.3c-10.1 0-21.1-2.2-31.9-6.2C163.1 193.2 262.2 96 384 96h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H384c-26.9 0-52.3 6.6-74.5 18.4zM160 160A64 64 0 1 1 32 160a64 64 0 1 1 128 0zM306.5 325.9C329 341.4 356.5 352 384 352c26.9 0 55.4-10.8 77.4-26.1l0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 405.7 417 416 384 416c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.4 27.3-10.1 39.2-1.7l0 0C136.7 341.2 165.1 352 192 352c27.5 0 55-10.6 77.5-26.1c11.1-7.9 25.9-7.9 37 0z"
    ]
};
var $d8206b3ab2e65c05$export$67daf2e2f88c1365 = $d8206b3ab2e65c05$export$3fb4da6af843d39f;
var $d8206b3ab2e65c05$export$9686eff8d817f770 = {
    prefix: "fas",
    iconName: "arrow-down",
    icon: [
        384,
        512,
        [
            8595
        ],
        "f063",
        "M169.4 470.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 370.8 224 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 306.7L54.6 265.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z"
    ]
};
var $d8206b3ab2e65c05$export$cc1b6e60cb98fb90 = {
    prefix: "fas",
    iconName: "droplet",
    icon: [
        384,
        512,
        [
            128167,
            "tint"
        ],
        "f043",
        "M192 512C86 512 0 426 0 320C0 228.8 130.2 57.7 166.6 11.7C172.6 4.2 181.5 0 191.1 0h1.8c9.6 0 18.5 4.2 24.5 11.7C253.8 57.7 384 228.8 384 320c0 106-86 192-192 192zM96 336c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 61.9 50.1 112 112 112c8.8 0 16-7.2 16-16s-7.2-16-16-16c-44.2 0-80-35.8-80-80z"
    ]
};
var $d8206b3ab2e65c05$export$60dd975bd5938c15 = $d8206b3ab2e65c05$export$cc1b6e60cb98fb90;
var $d8206b3ab2e65c05$export$e7fc4fe34e767f28 = {
    prefix: "fas",
    iconName: "eraser",
    icon: [
        576,
        512,
        [],
        "f12d",
        "M290.7 57.4L57.4 290.7c-25 25-25 65.5 0 90.5l80 80c12 12 28.3 18.7 45.3 18.7H288h9.4H512c17.7 0 32-14.3 32-32s-14.3-32-32-32H387.9L518.6 285.3c25-25 25-65.5 0-90.5L381.3 57.4c-25-25-65.5-25-90.5 0zM297.4 416H288l-105.4 0-80-80L227.3 211.3 364.7 348.7 297.4 416z"
    ]
};
var $d8206b3ab2e65c05$export$9c4218a898614082 = {
    prefix: "fas",
    iconName: "earth-americas",
    icon: [
        512,
        512,
        [
            127758,
            "earth",
            "earth-america",
            "globe-americas"
        ],
        "f57d",
        "M57.7 193l9.4 16.4c8.3 14.5 21.9 25.2 38 29.8L163 255.7c17.2 4.9 29 20.6 29 38.5v39.9c0 11 6.2 21 16 25.9s16 14.9 16 25.9v39c0 15.6 14.9 26.9 29.9 22.6c16.1-4.6 28.6-17.5 32.7-33.8l2.8-11.2c4.2-16.9 15.2-31.4 30.3-40l8.1-4.6c15-8.5 24.2-24.5 24.2-41.7v-8.3c0-12.7-5.1-24.9-14.1-33.9l-3.9-3.9c-9-9-21.2-14.1-33.9-14.1H257c-11.1 0-22.1-2.9-31.8-8.4l-34.5-19.7c-4.3-2.5-7.6-6.5-9.2-11.2c-3.2-9.6 1.1-20 10.2-24.5l5.9-3c6.6-3.3 14.3-3.9 21.3-1.5l23.2 7.7c8.2 2.7 17.2-.4 21.9-7.5c4.7-7 4.2-16.3-1.2-22.8l-13.6-16.3c-10-12-9.9-29.5 .3-41.3l15.7-18.3c8.8-10.3 10.2-25 3.5-36.7l-2.4-4.2c-3.5-.2-6.9-.3-10.4-.3C163.1 48 84.4 108.9 57.7 193zM464 256c0-36.8-9.6-71.4-26.4-101.5L412 164.8c-15.7 6.3-23.8 23.8-18.5 39.8l16.9 50.7c3.5 10.4 12 18.3 22.6 20.9l29.1 7.3c1.2-9 1.8-18.2 1.8-27.5zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"
    ]
};
var $d8206b3ab2e65c05$export$c2118d3775773870 = $d8206b3ab2e65c05$export$9c4218a898614082;
var $d8206b3ab2e65c05$export$8b0f3a26397cf632 = $d8206b3ab2e65c05$export$9c4218a898614082;
var $d8206b3ab2e65c05$export$e96bcc7bde9498db = $d8206b3ab2e65c05$export$9c4218a898614082;
var $d8206b3ab2e65c05$export$ae02241644924482 = {
    prefix: "fas",
    iconName: "person-burst",
    icon: [
        640,
        512,
        [],
        "e53b",
        "M480 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-8 384V352h16V480c0 17.7 14.3 32 32 32s32-14.3 32-32V256.9l28.6 47.5c9.1 15.1 28.8 20 43.9 10.9s20-28.8 10.9-43.9l-58.3-97c-17.4-28.9-48.6-46.6-82.3-46.6H465.1c-33.7 0-64.9 17.7-82.3 46.6l-58.3 97c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9L408 256.9V480c0 17.7 14.3 32 32 32s32-14.3 32-32zM190.9 18.1C188.4 12 182.6 8 176 8s-12.4 4-14.9 10.1l-29.4 74L55.6 68.9c-6.3-1.9-13.1 .2-17.2 5.3s-4.6 12.2-1.4 17.9l39.5 69.1L10.9 206.4c-5.4 3.7-8 10.3-6.5 16.7s6.7 11.2 13.1 12.2l78.7 12.2L90.6 327c-.5 6.5 3.1 12.7 9 15.5s12.9 1.8 17.8-2.6L176 286.1l58.6 53.9c4.8 4.4 11.9 5.5 17.8 2.6s9.5-9 9-15.5l-5.6-79.4 50.5-7.8 24.3-40.5-55.2-38L315 92.2c3.3-5.7 2.7-12.8-1.4-17.9s-10.9-7.2-17.2-5.3L220.3 92.1l-29.4-74z"
    ]
};
var $d8206b3ab2e65c05$export$a1ab1e69a300089f = {
    prefix: "fas",
    iconName: "dove",
    icon: [
        512,
        512,
        [
            128330
        ],
        "f4ba",
        "M160.8 96.5c14 17 31 30.9 49.5 42.2c25.9 15.8 53.7 25.9 77.7 31.6V138.8C265.8 108.5 250 71.5 248.6 28c-.4-11.3-7.5-21.5-18.4-24.4c-7.6-2-15.8-.2-21 5.8c-13.3 15.4-32.7 44.6-48.4 87.2zM320 144v30.6l0 0v1.3l0 0 0 32.1c-60.8-5.1-185-43.8-219.3-157.2C97.4 40 87.9 32 76.6 32c-7.9 0-15.3 3.9-18.8 11C46.8 65.9 32 112.1 32 176c0 116.9 80.1 180.5 118.4 202.8L11.8 416.6C6.7 418 2.6 421.8 .9 426.8s-.8 10.6 2.3 14.8C21.7 466.2 77.3 512 160 512c3.6 0 7.2-1.2 10-3.5L245.6 448H320c88.4 0 160-71.6 160-160V128l29.9-44.9c1.3-2 2.1-4.4 2.1-6.8c0-6.8-5.5-12.3-12.3-12.3H400c-44.2 0-80 35.8-80 80zm80-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"
    ]
};
var $d8206b3ab2e65c05$export$1344b64f6e922e12 = {
    prefix: "fas",
    iconName: "battery-empty",
    icon: [
        576,
        512,
        [
            "battery-0"
        ],
        "f244",
        "M80 160c-8.8 0-16 7.2-16 16V336c0 8.8 7.2 16 16 16H464c8.8 0 16-7.2 16-16V176c0-8.8-7.2-16-16-16H80zM0 176c0-44.2 35.8-80 80-80H464c44.2 0 80 35.8 80 80v16c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32v16c0 44.2-35.8 80-80 80H80c-44.2 0-80-35.8-80-80V176z"
    ]
};
var $d8206b3ab2e65c05$export$de8d0338927394c1 = $d8206b3ab2e65c05$export$1344b64f6e922e12;
var $d8206b3ab2e65c05$export$8d36a54dbf1e6bce = {
    prefix: "fas",
    iconName: "socks",
    icon: [
        512,
        512,
        [
            129510
        ],
        "f696",
        "M175.2 476.6c-9.7-18-15.2-38.7-15.2-60.6c0-40.3 19-78.2 51.2-102.4l64-48c8.1-6 12.8-15.5 12.8-25.6V96H128V240c0 20.1-9.5 39.1-25.6 51.2l-64 48C14.2 357.3 0 385.8 0 416c0 53 43 96 96 96c20.8 0 41-6.7 57.6-19.2l21.6-16.2zM128 64H288V48c0-14.5 3.9-28.2 10.7-39.9C291 3 281.9 0 272 0H176c-26.5 0-48 21.5-48 48V64zM320 96V240c0 20.1-9.5 39.1-25.6 51.2l-64 48C206.2 357.3 192 385.8 192 416c0 53 43 96 96 96c20.8 0 41-6.7 57.6-19.2l115.2-86.4C493 382.2 512 344.3 512 304V96H320zM512 64V48c0-26.5-21.5-48-48-48H368c-26.5 0-48 21.5-48 48V64H512z"
    ]
};
var $d8206b3ab2e65c05$export$366b69cbdce46334 = {
    prefix: "fas",
    iconName: "inbox",
    icon: [
        512,
        512,
        [],
        "f01c",
        "M121 32C91.6 32 66 52 58.9 80.5L1.9 308.4C.6 313.5 0 318.7 0 323.9V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V323.9c0-5.2-.6-10.4-1.9-15.5l-57-227.9C446 52 420.4 32 391 32H121zm0 64H391l48 192H387.8c-12.1 0-23.2 6.8-28.6 17.7l-14.3 28.6c-5.4 10.8-16.5 17.7-28.6 17.7H195.8c-12.1 0-23.2-6.8-28.6-17.7l-14.3-28.6c-5.4-10.8-16.5-17.7-28.6-17.7H73L121 96z"
    ]
};
var $d8206b3ab2e65c05$export$a6f4f4a005d91fbd = {
    prefix: "fas",
    iconName: "section",
    icon: [
        256,
        512,
        [],
        "e447",
        "M64.9 96C67.1 84.4 73.7 76.2 86 70.6c13.8-6.2 34.8-8.9 61.2-4.5c8.8 1.4 36.1 7.1 44.1 9.3c17 4.8 34.7-5.1 39.5-22.2s-5.1-34.7-22.2-39.5c-11.1-3.1-41-9.2-50.9-10.8C123-2.7 88.3-.6 59.7 12.3C29.9 25.8 7.5 50.9 1.6 86.5c-.1 .5-.2 1.1-.2 1.6c-2.2 19.7 .3 37.9 8.1 54.1c7.7 16.1 19.4 28 32 36.9c.6 .5 1.3 .9 2 1.4C22.3 194.2 6.5 215.1 1.7 243c-.1 .6-.2 1.1-.2 1.7c-2.3 19.3 .4 37.1 8.4 53c7.9 15.6 19.8 27 32.3 35.5c22.4 15.2 51.9 24 75.4 31l0 0 3.7 1.1c27.2 8.2 46.9 14.6 59.4 23.8c5.5 4 8.2 7.6 9.5 10.9c1.3 3.2 2.6 8.6 .9 18.1c-1.7 10.1-7.7 18-20.7 23.5c-14 6-35.4 8.5-62 4.4c-12.8-2.1-35.1-9.7-54.1-16.2l0 0c-4.3-1.5-8.5-2.9-12.3-4.2C25.3 420 7.2 429.1 1.6 445.8s3.5 34.9 20.3 40.5c2.6 .8 5.7 1.9 9.2 3.1c18.6 6.3 48.5 16.6 67.3 19.6l0 0 .2 0c34.5 5.4 68.8 3.4 97.2-8.7c29.4-12.6 52.5-36.5 58.5-71.5c3.3-19.3 1.9-37.4-5-53.9c-6.3-15-16.4-26.4-27.6-35.2c16.5-13.9 28.5-33.2 32.6-58.2c3.2-19.8 1.9-38.3-4.8-55.1c-6.7-16.8-17.8-29.4-30.2-39c-22.8-17.6-53.6-27.4-77.7-35l-1.4-.5c-27.4-8.7-47.8-15.3-61.5-25c-6.1-4.4-9.5-8.5-11.4-12.4c-1.8-3.7-3.2-9.3-2.3-18.5zm76.7 208.5c-.2-.1-.4-.1-.6-.2l-1.4-.4c-27.4-8.2-47.9-14.5-61.7-23.8c-6.2-4.2-9.3-7.9-11-11.3c-1.5-3-2.9-7.7-2.1-15.7c1.9-9.7 7.9-17.3 20.5-22.7c14-6 35.4-8.5 62.1-4.3l16.4 2.6c6.3 2.9 11.7 6 16.2 9.5c5.5 4.2 8.4 8.2 10 12.2c1.6 4 2.8 10.4 1.1 20.9c-2.4 14.7-12.8 26.4-37.1 31l-12.4 2.3z"
    ]
};
var $d8206b3ab2e65c05$export$d262c1f5912046e6 = {
    prefix: "fas",
    iconName: "gauge-high",
    icon: [
        512,
        512,
        [
            62461,
            "tachometer-alt",
            "tachometer-alt-fast"
        ],
        "f625",
        "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM288 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM256 416c35.3 0 64-28.7 64-64c0-17.4-6.9-33.1-18.1-44.6L366 161.7c5.3-12.1-.2-26.3-12.3-31.6s-26.3 .2-31.6 12.3L257.9 288c-.6 0-1.3 0-1.9 0c-35.3 0-64 28.7-64 64s28.7 64 64 64zM176 144a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM96 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm352-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"
    ]
};
var $d8206b3ab2e65c05$export$38dd17b9f064c10f = $d8206b3ab2e65c05$export$d262c1f5912046e6;
var $d8206b3ab2e65c05$export$e99d8b85f35b8ca5 = $d8206b3ab2e65c05$export$d262c1f5912046e6;
var $d8206b3ab2e65c05$export$f5c53ce8ec380d11 = {
    prefix: "fas",
    iconName: "envelope-open-text",
    icon: [
        512,
        512,
        [],
        "f658",
        "M215.4 96H144 107.8 96v8.8V144v40.4 89L.2 202.5c1.6-18.1 10.9-34.9 25.7-45.8L48 140.3V96c0-26.5 21.5-48 48-48h76.6l49.9-36.9C232.2 3.9 243.9 0 256 0s23.8 3.9 33.5 11L339.4 48H416c26.5 0 48 21.5 48 48v44.3l22.1 16.4c14.8 10.9 24.1 27.7 25.7 45.8L416 273.4v-89V144 104.8 96H404.2 368 296.6 215.4zM0 448V242.1L217.6 403.3c11.1 8.2 24.6 12.7 38.4 12.7s27.3-4.4 38.4-12.7L512 242.1V448v0c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64v0zM176 160H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
    ]
};
var $d8206b3ab2e65c05$export$7a76c9d35b42d691 = {
    prefix: "fas",
    iconName: "hospital",
    icon: [
        640,
        512,
        [
            127973,
            62589,
            "hospital-alt",
            "hospital-wide"
        ],
        "f0f8",
        "M192 48c0-26.5 21.5-48 48-48H400c26.5 0 48 21.5 48 48V512H368V432c0-26.5-21.5-48-48-48s-48 21.5-48 48v80H192V48zM48 96H160V512H48c-26.5 0-48-21.5-48-48V320H80c8.8 0 16-7.2 16-16s-7.2-16-16-16H0V224H80c8.8 0 16-7.2 16-16s-7.2-16-16-16H0V144c0-26.5 21.5-48 48-48zm544 0c26.5 0 48 21.5 48 48v48H560c-8.8 0-16 7.2-16 16s7.2 16 16 16h80v64H560c-8.8 0-16 7.2-16 16s7.2 16 16 16h80V464c0 26.5-21.5 48-48 48H480V96H592zM312 64c-8.8 0-16 7.2-16 16v24H272c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h24v24c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V152h24c8.8 0 16-7.2 16-16V120c0-8.8-7.2-16-16-16H344V80c0-8.8-7.2-16-16-16H312z"
    ]
};
var $d8206b3ab2e65c05$export$cea7736417b94a3b = $d8206b3ab2e65c05$export$7a76c9d35b42d691;
var $d8206b3ab2e65c05$export$69c8cc0360f017e8 = $d8206b3ab2e65c05$export$7a76c9d35b42d691;
var $d8206b3ab2e65c05$export$770be8b3d5776043 = {
    prefix: "fas",
    iconName: "wine-bottle",
    icon: [
        512,
        512,
        [],
        "f72f",
        "M393.4 9.4c12.5-12.5 32.8-12.5 45.3 0l64 64c12.5 12.5 12.5 32.8 0 45.3c-11.8 11.8-30.7 12.5-43.2 1.9l-9.5 9.5-48.8 48.8c-9.2 9.2-11.5 22.9-8.6 35.6c9.4 40.9-1.9 85.6-33.8 117.5L197.3 493.3c-25 25-65.5 25-90.5 0l-88-88c-25-25-25-65.5 0-90.5L180.2 153.3c31.9-31.9 76.6-43.1 117.5-33.8c12.6 2.9 26.4 .5 35.5-8.6l48.8-48.8 9.5-9.5c-10.6-12.6-10-31.4 1.9-43.2zM99.3 347.3l65.4 65.4c6.2 6.2 16.4 6.2 22.6 0l97.4-97.4c6.2-6.2 6.2-16.4 0-22.6l-65.4-65.4c-6.2-6.2-16.4-6.2-22.6 0L99.3 324.7c-6.2 6.2-6.2 16.4 0 22.6z"
    ]
};
var $d8206b3ab2e65c05$export$5d65c40a109eb09c = {
    prefix: "fas",
    iconName: "chess-rook",
    icon: [
        448,
        512,
        [
            9820
        ],
        "f447",
        "M32 192V48c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16V88c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8V48c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16V88c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8V48c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16V192c0 10.1-4.7 19.6-12.8 25.6L352 256l16 144H80L96 256 44.8 217.6C36.7 211.6 32 202.1 32 192zm176 96h32c8.8 0 16-7.2 16-16V224c0-17.7-14.3-32-32-32s-32 14.3-32 32v48c0 8.8 7.2 16 16 16zM22.6 473.4L64 432H384l41.4 41.4c4.2 4.2 6.6 10 6.6 16c0 12.5-10.1 22.6-22.6 22.6H38.6C26.1 512 16 501.9 16 489.4c0-6 2.4-11.8 6.6-16z"
    ]
};
var $d8206b3ab2e65c05$export$2f8a7938c06a2142 = {
    prefix: "fas",
    iconName: "bars-staggered",
    icon: [
        512,
        512,
        [
            "reorder",
            "stream"
        ],
        "f550",
        "M0 96C0 78.3 14.3 64 32 64H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 128 0 113.7 0 96zM64 256c0-17.7 14.3-32 32-32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H96c-17.7 0-32-14.3-32-32zM448 416c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32z"
    ]
};
var $d8206b3ab2e65c05$export$75d2bb378a2fc102 = $d8206b3ab2e65c05$export$2f8a7938c06a2142;
var $d8206b3ab2e65c05$export$ed81ab40fc4e904 = $d8206b3ab2e65c05$export$2f8a7938c06a2142;
var $d8206b3ab2e65c05$export$45cbd92c28deb2c7 = {
    prefix: "fas",
    iconName: "dharmachakra",
    icon: [
        512,
        512,
        [
            9784
        ],
        "f655",
        "M337.8 205.7l48.6-42.5c13.8 19.3 23.4 41.9 27.4 66.2l-64.4 4.3c-2.4-10.1-6.4-19.5-11.6-28zm140.1 19.5c-5.3-38.8-20.6-74.5-43.2-104.3l.8-.7C449 108.4 449.7 87.6 437 75s-33.4-12-45.2 1.5l-.7 .8c-29.8-22.6-65.5-37.9-104.3-43.2l.1-1.1c1.2-17.9-13-33-30.9-33s-32.1 15.2-30.9 33l.1 1.1c-38.8 5.3-74.5 20.6-104.3 43.2l-.7-.8C108.4 63 87.6 62.3 75 75s-12 33.4 1.5 45.2l.8 .7c-22.6 29.8-37.9 65.5-43.2 104.3l-1.1-.1c-17.9-1.2-33 13-33 30.9s15.2 32.1 33 30.9l1.1-.1c5.3 38.8 20.6 74.5 43.2 104.3l-.8 .7C63 403.6 62.3 424.4 75 437s33.4 12 45.2-1.5l.7-.8c29.8 22.6 65.5 37.9 104.3 43.2l-.1 1.1c-1.2 17.9 13 33 30.9 33s32.1-15.2 30.9-33l-.1-1.1c38.8-5.3 74.5-20.6 104.3-43.2l.7 .8c11.8 13.5 32.5 14.2 45.2 1.5s12-33.4-1.5-45.2l-.8-.7c22.6-29.8 37.9-65.5 43.2-104.3l1.1 .1c17.9 1.2 33-13 33-30.9s-15.2-32.1-33-30.9l-1.1 .1zM163.2 125.6c19.3-13.8 41.9-23.4 66.2-27.5l4.3 64.4c-10 2.4-19.5 6.4-28 11.6l-42.5-48.6zm-65 103.8c4.1-24.4 13.7-46.9 27.5-66.2l48.6 42.5c-5.3 8.5-9.2 18-11.6 28l-64.4-4.3zm27.5 119.4c-13.8-19.3-23.4-41.9-27.5-66.2l64.4-4.3c2.4 10 6.4 19.5 11.6 28l-48.6 42.5zm103.8 65c-24.4-4.1-46.9-13.7-66.2-27.4l42.5-48.6c8.5 5.3 18 9.2 28 11.6l-4.3 64.4zm119.4-27.4c-19.3 13.8-41.9 23.4-66.2 27.4l-4.3-64.4c10-2.4 19.5-6.4 28-11.6l42.5 48.6zm65-103.8c-4.1 24.4-13.7 46.9-27.4 66.2l-48.6-42.5c5.3-8.5 9.2-18 11.6-28l64.4 4.3zm-65-156.9l-42.5 48.6c-8.5-5.3-18-9.2-28-11.6l4.3-64.4c24.4 4.1 46.9 13.7 66.2 27.5zM256 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $d8206b3ab2e65c05$export$9fae219b4d3ce0be = {
    prefix: "fas",
    iconName: "hotdog",
    icon: [
        512,
        512,
        [
            127789
        ],
        "f80f",
        "M488.6 23.4c31.2 31.2 31.2 81.9 0 113.1l-352 352c-31.2 31.2-81.9 31.2-113.1 0s-31.2-81.9 0-113.1l352-352c31.2-31.2 81.9-31.2 113.1 0zM443.3 92.7c-6.2-6.2-16.4-6.2-22.6 0c-12.5 12.5-23.8 15.1-37.5 17.6l-2.5 .4c-13.8 2.5-31.6 5.6-48 22c-16.7 16.7-20.9 36-24.1 50.9l0 0v0l-.2 1c-3.4 15.6-6 26.4-15.7 36.1s-20.5 12.3-36.1 15.7l-1 .2c-14.9 3.2-34.2 7.4-50.9 24.1s-20.9 36-24.1 50.9l-.2 1c-3.4 15.6-6 26.4-15.7 36.1c-9.2 9.2-18 10.8-32.7 13.4l0 0-.9 .2c-15.6 2.8-34.9 6.9-54.4 26.4c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0c12.5-12.5 23.8-15.1 37.5-17.6l2.5-.4c13.8-2.5 31.6-5.6 48-22c16.7-16.7 20.9-36 24.1-50.9l.2-1c3.4-15.6 6-26.4 15.7-36.1s20.5-12.3 36.1-15.7l1-.2c14.9-3.2 34.2-7.4 50.9-24.1s20.9-36 24.1-50.9l.2-1c3.4-15.6 6-26.4 15.7-36.1c9.2-9.2 18-10.8 32.7-13.4l.9-.2c15.6-2.8 34.9-6.9 54.4-26.4c6.2-6.2 6.2-16.4 0-22.6zM191.2 479.2l288-288L495 207c10.9 10.9 17 25.6 17 41s-6.1 30.1-17 41L289 495c-10.9 10.9-25.6 17-41 17s-30.1-6.1-41-17l-15.8-15.8zM17 305C6.1 294.1 0 279.4 0 264s6.1-30.1 17-41L223 17C233.9 6.1 248.6 0 264 0s30.1 6.1 41 17l15.8 15.8-288 288L17 305z"
    ]
};
var $d8206b3ab2e65c05$export$2ffee5b2bc935c1f = {
    prefix: "fas",
    iconName: "person-walking-with-cane",
    icon: [
        512,
        512,
        [
            "blind"
        ],
        "f29d",
        "M176 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-8.4 32c-36.4 0-69.6 20.5-85.9 53.1L35.4 273.7c-7.9 15.8-1.5 35 14.3 42.9s35 1.5 42.9-14.3L128 231.6v43.2c0 17 6.7 33.3 18.7 45.3L224 397.3V480c0 17.7 14.3 32 32 32s32-14.3 32-32V390.6c0-12.7-5.1-24.9-14.1-33.9L224 306.7V213.3l70.4 93.9c10.6 14.1 30.7 17 44.8 6.4s17-30.7 6.4-44.8L268.8 166.4C250.7 142.2 222.2 128 192 128H167.6zM128.3 346.8L97 472.2c-4.3 17.1 6.1 34.5 23.3 38.8s34.5-6.1 38.8-23.3l22-88.2-52.8-52.8zM450.8 505.1c5 7.3 15 9.1 22.3 4s9.1-15 4-22.3L358.9 316.1c-2.8 3.8-6.1 7.3-10.1 10.3c-5 3.8-10.5 6.4-16.2 7.9L450.8 505.1z"
    ]
};
var $d8206b3ab2e65c05$export$923de21def6ea9b6 = $d8206b3ab2e65c05$export$2ffee5b2bc935c1f;
var $d8206b3ab2e65c05$export$5b9205e1042594b7 = {
    prefix: "fas",
    iconName: "drum",
    icon: [
        512,
        512,
        [
            129345
        ],
        "f569",
        "M501.2 76.1c11.1-7.3 14.2-22.1 6.9-33.2s-22.1-14.2-33.2-6.9L370.2 104.5C335.8 98.7 297 96 256 96C114.6 96 0 128 0 208V368c0 31.3 27.4 58.8 72 78.7V344c0-13.3 10.7-24 24-24s24 10.7 24 24V463.4c33 8.9 71.1 14.5 112 16.1V376c0-13.3 10.7-24 24-24s24 10.7 24 24V479.5c40.9-1.6 79-7.2 112-16.1V344c0-13.3 10.7-24 24-24s24 10.7 24 24V446.7c44.6-19.9 72-47.4 72-78.7V208c0-41.1-30.2-69.5-78.8-87.4l67.9-44.5zM307.4 145.6l-64.6 42.3c-11.1 7.3-14.2 22.1-6.9 33.2s22.1 14.2 33.2 6.9l111.1-72.8c14.7 3.2 27.9 7 39.4 11.5C458.4 181.8 464 197.4 464 208c0 .8-2.7 17.2-46 35.9C379.1 260.7 322 272 256 272s-123.1-11.3-162-28.1C50.7 225.2 48 208.8 48 208c0-10.6 5.6-26.2 44.4-41.3C130.6 151.9 187.8 144 256 144c18 0 35.1 .5 51.4 1.6z"
    ]
};
var $d8206b3ab2e65c05$export$dd52741c60cc638f = {
    prefix: "fas",
    iconName: "ice-cream",
    icon: [
        448,
        512,
        [
            127848
        ],
        "f810",
        "M367.1 160c.6-5.3 .9-10.6 .9-16C368 64.5 303.5 0 224 0S80 64.5 80 144c0 5.4 .3 10.7 .9 16H80c-26.5 0-48 21.5-48 48s21.5 48 48 48h53.5 181H368c26.5 0 48-21.5 48-48s-21.5-48-48-48h-.9zM96 288L200.8 497.7c4.4 8.8 13.3 14.3 23.2 14.3s18.8-5.5 23.2-14.3L352 288H96z"
    ]
};
var $d8206b3ab2e65c05$export$2a376a9d0d8fee96 = {
    prefix: "fas",
    iconName: "heart-circle-bolt",
    icon: [
        576,
        512,
        [],
        "e4fc",
        "M47.6 300.4L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9l2.6-2.4C267.2 438.6 256 404.6 256 368c0-97.2 78.8-176 176-176c28.3 0 55 6.7 78.7 18.5c.9-6.5 1.3-13 1.3-19.6v-5.8c0-69.9-50.5-129.5-119.4-141C347 36.5 300.6 51.4 268 84L256 96 244 84c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm47.9-225c4.3 3.7 5.4 9.9 2.6 14.9L452.4 356H488c5.2 0 9.8 3.3 11.4 8.2s-.1 10.3-4.2 13.4l-96 72c-4.5 3.4-10.8 3.2-15.1-.6s-5.4-9.9-2.6-14.9L411.6 380H376c-5.2 0-9.8-3.3-11.4-8.2s.1-10.3 4.2-13.4l96-72c4.5-3.4 10.8-3.2 15.1 .6z"
    ]
};
var $d8206b3ab2e65c05$export$b5698497901d7197 = {
    prefix: "fas",
    iconName: "fax",
    icon: [
        512,
        512,
        [
            128224,
            128439
        ],
        "f1ac",
        "M128 64v96h64V64H386.7L416 93.3V160h64V93.3c0-17-6.7-33.3-18.7-45.3L432 18.7C420 6.7 403.7 0 386.7 0H192c-35.3 0-64 28.7-64 64zM0 160V480c0 17.7 14.3 32 32 32H64c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32H32c-17.7 0-32 14.3-32 32zm480 32H128V480c0 17.7 14.3 32 32 32H480c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32zM256 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm96 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM224 416a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
    ]
};
var $d8206b3ab2e65c05$export$dec46f8df1860e0 = {
    prefix: "fas",
    iconName: "paragraph",
    icon: [
        448,
        512,
        [
            182
        ],
        "f1dd",
        "M192 32h64H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H384l0 352c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-352H288V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V352H192c-88.4 0-160-71.6-160-160s71.6-160 160-160z"
    ]
};
var $d8206b3ab2e65c05$export$6999832247e52c2b = {
    prefix: "fas",
    iconName: "check-to-slot",
    icon: [
        576,
        512,
        [
            "vote-yea"
        ],
        "f772",
        "M96 80c0-26.5 21.5-48 48-48H432c26.5 0 48 21.5 48 48V384H96V80zm313 47c-9.4-9.4-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L409 161c9.4-9.4 9.4-24.6 0-33.9zM0 336c0-26.5 21.5-48 48-48H64V416H512V288h16c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V336z"
    ]
};
var $d8206b3ab2e65c05$export$e87bb3db1608b850 = $d8206b3ab2e65c05$export$6999832247e52c2b;
var $d8206b3ab2e65c05$export$228008b5e11032fa = {
    prefix: "fas",
    iconName: "star-half",
    icon: [
        576,
        512,
        [
            61731
        ],
        "f089",
        "M288 0c-12.2 .1-23.3 7-28.6 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3L288 439.8V0zM429.9 512c1.1 .1 2.1 .1 3.2 0h-3.2z"
    ]
};
var $d8206b3ab2e65c05$export$2088efcf62cf3b1 = {
    prefix: "fas",
    iconName: "boxes-stacked",
    icon: [
        576,
        512,
        [
            62625,
            "boxes",
            "boxes-alt"
        ],
        "f468",
        "M248 0H208c-26.5 0-48 21.5-48 48V160c0 35.3 28.7 64 64 64H352c35.3 0 64-28.7 64-64V48c0-26.5-21.5-48-48-48H328V80c0 8.8-7.2 16-16 16H264c-8.8 0-16-7.2-16-16V0zM64 256c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H224c35.3 0 64-28.7 64-64V320c0-35.3-28.7-64-64-64H184v80c0 8.8-7.2 16-16 16H120c-8.8 0-16-7.2-16-16V256H64zM352 512H512c35.3 0 64-28.7 64-64V320c0-35.3-28.7-64-64-64H472v80c0 8.8-7.2 16-16 16H408c-8.8 0-16-7.2-16-16V256H352c-15 0-28.8 5.1-39.7 13.8c4.9 10.4 7.7 22 7.7 34.2V464c0 12.2-2.8 23.8-7.7 34.2C323.2 506.9 337 512 352 512z"
    ]
};
var $d8206b3ab2e65c05$export$2007320dd6cde6db = $d8206b3ab2e65c05$export$2088efcf62cf3b1;
var $d8206b3ab2e65c05$export$e6ef1d896ed63b3e = $d8206b3ab2e65c05$export$2088efcf62cf3b1;
var $d8206b3ab2e65c05$export$88bc01ff8dbecc55 = {
    prefix: "fas",
    iconName: "link",
    icon: [
        640,
        512,
        [
            128279,
            "chain"
        ],
        "f0c1",
        "M579.8 267.7c56.5-56.5 56.5-148 0-204.5c-50-50-128.8-56.5-186.3-15.4l-1.6 1.1c-14.4 10.3-17.7 30.3-7.4 44.6s30.3 17.7 44.6 7.4l1.6-1.1c32.1-22.9 76-19.3 103.8 8.6c31.5 31.5 31.5 82.5 0 114L422.3 334.8c-31.5 31.5-82.5 31.5-114 0c-27.9-27.9-31.5-71.8-8.6-103.8l1.1-1.6c10.3-14.4 6.9-34.4-7.4-44.6s-34.4-6.9-44.6 7.4l-1.1 1.6C206.5 251.2 213 330 263 380c56.5 56.5 148 56.5 204.5 0L579.8 267.7zM60.2 244.3c-56.5 56.5-56.5 148 0 204.5c50 50 128.8 56.5 186.3 15.4l1.6-1.1c14.4-10.3 17.7-30.3 7.4-44.6s-30.3-17.7-44.6-7.4l-1.6 1.1c-32.1 22.9-76 19.3-103.8-8.6C74 372 74 321 105.5 289.5L217.7 177.2c31.5-31.5 82.5-31.5 114 0c27.9 27.9 31.5 71.8 8.6 103.9l-1.1 1.6c-10.3 14.4-6.9 34.4 7.4 44.6s34.4 6.9 44.6-7.4l1.1-1.6C433.5 260.8 427 182 377 132c-56.5-56.5-148-56.5-204.5 0L60.2 244.3z"
    ]
};
var $d8206b3ab2e65c05$export$b5d071e02a25554f = $d8206b3ab2e65c05$export$88bc01ff8dbecc55;
var $d8206b3ab2e65c05$export$837bc776b490934d = {
    prefix: "fas",
    iconName: "ear-listen",
    icon: [
        512,
        512,
        [
            "assistive-listening-systems"
        ],
        "f2a2",
        "M398.3 3.4c-15.8-7.9-35-1.5-42.9 14.3c-7.9 15.8-1.5 34.9 14.2 42.9l.4 .2c.4 .2 1.1 .6 2.1 1.2c2 1.2 5 3 8.7 5.6c7.5 5.2 17.6 13.2 27.7 24.2C428.5 113.4 448 146 448 192c0 17.7 14.3 32 32 32s32-14.3 32-32c0-66-28.5-113.4-56.5-143.7C441.6 33.2 427.7 22.2 417.3 15c-5.3-3.7-9.7-6.4-13-8.3c-1.6-1-3-1.7-4-2.2c-.5-.3-.9-.5-1.2-.7l-.4-.2-.2-.1-.1 0 0 0c0 0 0 0-14.3 28.6L398.3 3.4zM128.7 227.5c6.2-56 53.7-99.5 111.3-99.5c61.9 0 112 50.1 112 112c0 29.3-11.2 55.9-29.6 75.9c-17 18.4-34.4 45.1-34.4 78V400c0 26.5-21.5 48-48 48c-17.7 0-32 14.3-32 32s14.3 32 32 32c61.9 0 112-50.1 112-112v-6.1c0-9.8 5.4-21.7 17.4-34.7C398.3 327.9 416 286 416 240c0-97.2-78.8-176-176-176C149.4 64 74.8 132.5 65.1 220.5c-1.9 17.6 10.7 33.4 28.3 35.3s33.4-10.7 35.3-28.3zM32 512a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM192 352a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3l64 64c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-64-64c-12.5-12.5-32.8-12.5-45.3 0zM208 240c0-17.7 14.3-32 32-32s32 14.3 32 32c0 13.3 10.7 24 24 24s24-10.7 24-24c0-44.2-35.8-80-80-80s-80 35.8-80 80c0 13.3 10.7 24 24 24s24-10.7 24-24z"
    ]
};
var $d8206b3ab2e65c05$export$8eeef3dc0035b165 = $d8206b3ab2e65c05$export$837bc776b490934d;
var $d8206b3ab2e65c05$export$ad95e4f80f98ebe0 = {
    prefix: "fas",
    iconName: "tree-city",
    icon: [
        640,
        512,
        [],
        "e587",
        "M288 48c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48V192h40V120c0-13.3 10.7-24 24-24s24 10.7 24 24v72h24c26.5 0 48 21.5 48 48V464c0 26.5-21.5 48-48 48H432 336c-26.5 0-48-21.5-48-48V48zm64 32v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16zm16 80c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V176c0-8.8-7.2-16-16-16H368zM352 272v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16zm176-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H528zM512 368v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16H528c-8.8 0-16 7.2-16 16zM224 160c0 6-1 11-2 16c20 14 34 38 34 64c0 45-36 80-80 80H160V480c0 18-15 32-32 32c-18 0-32-14-32-32V320H80c-45 0-80-35-80-80c0-26 13-50 33-64c-1-5-1-10-1-16c0-53 42-96 96-96c53 0 96 43 96 96z"
    ]
};
var $d8206b3ab2e65c05$export$436587205947bca5 = {
    prefix: "fas",
    iconName: "play",
    icon: [
        384,
        512,
        [
            9654
        ],
        "f04b",
        "M73 39c-14.8-9.1-33.4-9.4-48.5-.9S0 62.6 0 80V432c0 17.4 9.4 33.4 24.5 41.9s33.7 8.1 48.5-.9L361 297c14.3-8.7 23-24.2 23-41s-8.7-32.2-23-41L73 39z"
    ]
};
var $d8206b3ab2e65c05$export$a5dc297d3f60936 = {
    prefix: "fas",
    iconName: "font",
    icon: [
        448,
        512,
        [],
        "f031",
        "M254 52.8C249.3 40.3 237.3 32 224 32s-25.3 8.3-30 20.8L57.8 416H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32h-1.8l18-48H303.8l18 48H320c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H390.2L254 52.8zM279.8 304H168.2L224 155.1 279.8 304z"
    ]
};
var $d8206b3ab2e65c05$export$fe44d4c71644ea0 = {
    prefix: "fas",
    iconName: "rupiah-sign",
    icon: [
        512,
        512,
        [],
        "e23d",
        "M0 64C0 46.3 14.3 32 32 32h80c79.5 0 144 64.5 144 144c0 58.8-35.2 109.3-85.7 131.7l51.4 128.4c6.6 16.4-1.4 35-17.8 41.6s-35-1.4-41.6-17.8L106.3 320H64V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V288 64zM64 256h48c44.2 0 80-35.8 80-80s-35.8-80-80-80H64V256zm256-96h80c61.9 0 112 50.1 112 112s-50.1 112-112 112H352v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V352 192c0-17.7 14.3-32 32-32zm80 160c26.5 0 48-21.5 48-48s-21.5-48-48-48H352v96h48z"
    ]
};
var $d8206b3ab2e65c05$export$34c8b97060c09ff = {
    prefix: "fas",
    iconName: "magnifying-glass",
    icon: [
        512,
        512,
        [
            128269,
            "search"
        ],
        "f002",
        "M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"
    ]
};
var $d8206b3ab2e65c05$export$871a78837687ffe8 = $d8206b3ab2e65c05$export$34c8b97060c09ff;
var $d8206b3ab2e65c05$export$eabe53838d45ac6a = {
    prefix: "fas",
    iconName: "table-tennis-paddle-ball",
    icon: [
        640,
        512,
        [
            127955,
            "ping-pong-paddle-ball",
            "table-tennis"
        ],
        "f45d",
        "M480 288c-50.1 0-93.6 28.8-114.6 70.8L132.9 126.3l.6-.6 60.1-60.1c87.5-87.5 229.3-87.5 316.8 0c67.1 67.1 82.7 166.3 46.8 248.3C535.8 297.6 509 288 480 288zM113.3 151.9L354.1 392.7c-1.4 7.5-2.1 15.3-2.1 23.3c0 23.2 6.2 44.9 16.9 63.7c-3 .2-6.1 .3-9.2 .3H357c-33.9 0-66.5-13.5-90.5-37.5l-9.8-9.8c-13.1-13.1-34.6-12.4-46.8 1.7L152.2 501c-5.8 6.7-14.2 10.7-23 11s-17.5-3.1-23.8-9.4l-32-32c-6.3-6.3-9.7-14.9-9.4-23.8s4.3-17.2 11-23l66.6-57.7c14-12.2 14.8-33.7 1.7-46.8l-9.8-9.8c-24-24-37.5-56.6-37.5-90.5v-2.7c0-22.8 6.1-44.9 17.3-64.3zM480 320a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"
    ]
};
var $d8206b3ab2e65c05$export$ebb246c621751737 = $d8206b3ab2e65c05$export$eabe53838d45ac6a;
var $d8206b3ab2e65c05$export$f378fbb4e0ef7edf = $d8206b3ab2e65c05$export$eabe53838d45ac6a;
var $d8206b3ab2e65c05$export$cdcec8ca7ec0d381 = {
    prefix: "fas",
    iconName: "person-dots-from-line",
    icon: [
        576,
        512,
        [
            "diagnoses"
        ],
        "f470",
        "M288 176A88 88 0 1 0 288 0a88 88 0 1 0 0 176zM78.7 372.9c15-12.5 50-34.4 97.3-50.1V432H400V322.7c47.3 15.8 82.3 37.7 97.3 50.1c20.4 17 50.6 14.2 67.6-6.1s14.2-50.6-6.1-67.6c-12-10-30.1-22.5-53.2-35C497.2 278.4 481.7 288 464 288c-26.5 0-48-21.5-48-48c0-4.3 .6-8.4 1.6-12.4C379.1 215.9 335.3 208 288 208c-60.2 0-114.9 12.9-160 29.9c0 .7 0 1.4 0 2.1c0 26.5-21.5 48-48 48c-11.8 0-22.7-4.3-31-11.4c-13.1 8.1-23.7 15.9-31.7 22.5c-20.4 17-23.1 47.2-6.1 67.6s47.2 23.1 67.6 6.1zM24 464c-13.3 0-24 10.7-24 24s10.7 24 24 24H552c13.3 0 24-10.7 24-24s-10.7-24-24-24H24zM224 280a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm104 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM96 240a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm368 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"
    ]
};
var $d8206b3ab2e65c05$export$68bad2b52a90d1fa = $d8206b3ab2e65c05$export$cdcec8ca7ec0d381;
var $d8206b3ab2e65c05$export$60430351cdb4ba89 = {
    prefix: "fas",
    iconName: "trash-can-arrow-up",
    icon: [
        448,
        512,
        [
            "trash-restore-alt"
        ],
        "f82a",
        "M163.8 0H284.2c12.1 0 23.2 6.8 28.6 17.7L320 32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64S14.3 32 32 32h96l7.2-14.3C140.6 6.8 151.7 0 163.8 0zM32 128H416V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V128zm192 64c-6.4 0-12.5 2.5-17 7l-80 80c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l39-39V408c0 13.3 10.7 24 24 24s24-10.7 24-24V273.9l39 39c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-80-80c-4.5-4.5-10.6-7-17-7z"
    ]
};
var $d8206b3ab2e65c05$export$d075b19b21cb9856 = $d8206b3ab2e65c05$export$60430351cdb4ba89;
var $d8206b3ab2e65c05$export$58b7558ca9822358 = {
    prefix: "fas",
    iconName: "naira-sign",
    icon: [
        448,
        512,
        [],
        "e1f6",
        "M122.6 46.3c-7.8-11.7-22.4-17-35.9-12.9S64 49.9 64 64V256H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H64V448c0 17.7 14.3 32 32 32s32-14.3 32-32V320H228.2l97.2 145.8c7.8 11.7 22.4 17 35.9 12.9s22.7-16.5 22.7-30.6V320h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H384V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V256H262.5L122.6 46.3zM305.1 320H320v22.3L305.1 320zM185.5 256H128V169.7L185.5 256z"
    ]
};
var $d8206b3ab2e65c05$export$9206260ff0c0c616 = {
    prefix: "fas",
    iconName: "cart-arrow-down",
    icon: [
        576,
        512,
        [],
        "f218",
        "M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48H69.5c3.8 0 7.1 2.7 7.9 6.5l51.6 271c6.5 34 36.2 58.5 70.7 58.5H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H199.7c-11.5 0-21.4-8.2-23.6-19.5L170.7 288H459.2c32.6 0 61.1-21.8 69.5-53.3l41-152.3C576.6 57 557.4 32 531.1 32H360V134.1l23-23c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-64 64c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l23 23V32H120.1C111 12.8 91.6 0 69.5 0H24zM176 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm336-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"
    ]
};
var $d8206b3ab2e65c05$export$8a322f740d64e9fc = {
    prefix: "fas",
    iconName: "walkie-talkie",
    icon: [
        384,
        512,
        [],
        "f8ef",
        "M112 24c0-13.3-10.7-24-24-24S64 10.7 64 24V96H48C21.5 96 0 117.5 0 144V300.1c0 12.7 5.1 24.9 14.1 33.9l3.9 3.9c9 9 14.1 21.2 14.1 33.9V464c0 26.5 21.5 48 48 48H304c26.5 0 48-21.5 48-48V371.9c0-12.7 5.1-24.9 14.1-33.9l3.9-3.9c9-9 14.1-21.2 14.1-33.9V144c0-26.5-21.5-48-48-48H320c0-17.7-14.3-32-32-32s-32 14.3-32 32H224c0-17.7-14.3-32-32-32s-32 14.3-32 32H112V24zm0 136H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
    ]
};
var $d8206b3ab2e65c05$export$27f34878d8ed7a76 = {
    prefix: "fas",
    iconName: "file-pen",
    icon: [
        576,
        512,
        [
            128221,
            "file-edit"
        ],
        "f31c",
        "M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384V299.6l-94.7 94.7c-8.2 8.2-14 18.5-16.8 29.7l-15 60.1c-2.3 9.4-1.8 19 1.4 27.8H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128zM549.8 235.7l14.4 14.4c15.6 15.6 15.6 40.9 0 56.6l-29.4 29.4-71-71 29.4-29.4c15.6-15.6 40.9-15.6 56.6 0zM311.9 417L441.1 287.8l71 71L382.9 487.9c-4.1 4.1-9.2 7-14.9 8.4l-60.1 15c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l15-60.1c1.4-5.6 4.3-10.8 8.4-14.9z"
    ]
};
var $d8206b3ab2e65c05$export$e343e19f1757c5ae = $d8206b3ab2e65c05$export$27f34878d8ed7a76;
var $d8206b3ab2e65c05$export$32b0cd6133c2742 = {
    prefix: "fas",
    iconName: "receipt",
    icon: [
        384,
        512,
        [
            129534
        ],
        "f543",
        "M14 2.2C22.5-1.7 32.5-.3 39.6 5.8L80 40.4 120.4 5.8c9-7.7 22.3-7.7 31.2 0L192 40.4 232.4 5.8c9-7.7 22.3-7.7 31.2 0L304 40.4 344.4 5.8c7.1-6.1 17.1-7.5 25.6-3.6s14 12.4 14 21.8V488c0 9.4-5.5 17.9-14 21.8s-18.5 2.5-25.6-3.6L304 471.6l-40.4 34.6c-9 7.7-22.3 7.7-31.2 0L192 471.6l-40.4 34.6c-9 7.7-22.3 7.7-31.2 0L80 471.6 39.6 506.2c-7.1 6.1-17.1 7.5-25.6 3.6S0 497.4 0 488V24C0 14.6 5.5 6.1 14 2.2zM96 144c-8.8 0-16 7.2-16 16s7.2 16 16 16H288c8.8 0 16-7.2 16-16s-7.2-16-16-16H96zM80 352c0 8.8 7.2 16 16 16H288c8.8 0 16-7.2 16-16s-7.2-16-16-16H96c-8.8 0-16 7.2-16 16zM96 240c-8.8 0-16 7.2-16 16s7.2 16 16 16H288c8.8 0 16-7.2 16-16s-7.2-16-16-16H96z"
    ]
};
var $d8206b3ab2e65c05$export$3643b719db23d46e = {
    prefix: "fas",
    iconName: "square-pen",
    icon: [
        448,
        512,
        [
            "pen-square",
            "pencil-square"
        ],
        "f14b",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM325.8 139.7l14.4 14.4c15.6 15.6 15.6 40.9 0 56.6l-21.4 21.4-71-71 21.4-21.4c15.6-15.6 40.9-15.6 56.6 0zM119.9 289L225.1 183.8l71 71L190.9 359.9c-4.1 4.1-9.2 7-14.9 8.4l-60.1 15c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l15-60.1c1.4-5.6 4.3-10.8 8.4-14.9z"
    ]
};
var $d8206b3ab2e65c05$export$fbb231ccb3d960bc = $d8206b3ab2e65c05$export$3643b719db23d46e;
var $d8206b3ab2e65c05$export$35d253ecd249e771 = $d8206b3ab2e65c05$export$3643b719db23d46e;
var $d8206b3ab2e65c05$export$957e62a9b80ff4e3 = {
    prefix: "fas",
    iconName: "suitcase-rolling",
    icon: [
        384,
        512,
        [],
        "f5c1",
        "M144 56c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v72H144V56zm176 72H288V56c0-30.9-25.1-56-56-56H152C121.1 0 96 25.1 96 56v72H64c-35.3 0-64 28.7-64 64V416c0 35.3 28.7 64 64 64c0 17.7 14.3 32 32 32s32-14.3 32-32H256c0 17.7 14.3 32 32 32s32-14.3 32-32c35.3 0 64-28.7 64-64V192c0-35.3-28.7-64-64-64zM112 224H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 128H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
    ]
};
var $d8206b3ab2e65c05$export$38c8c32017dd9cc = {
    prefix: "fas",
    iconName: "person-circle-exclamation",
    icon: [
        576,
        512,
        [],
        "e53f",
        "M112 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm40 304V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V256.9L59.4 304.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c17.4-28.9 48.6-46.6 82.3-46.6h29.7c33.7 0 64.9 17.7 82.3 46.6l44.9 74.7c-16.1 17.6-28.6 38.5-36.6 61.5c-1.9-1.8-3.5-3.9-4.9-6.3L232 256.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352H152zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 240a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-192c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16V288c0-8.8-7.2-16-16-16z"
    ]
};
var $d8206b3ab2e65c05$export$8db9bc521720fccd = {
    prefix: "fas",
    iconName: "chevron-down",
    icon: [
        512,
        512,
        [],
        "f078",
        "M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"
    ]
};
var $d8206b3ab2e65c05$export$9338fc4614cfc0cf = {
    prefix: "fas",
    iconName: "battery-full",
    icon: [
        576,
        512,
        [
            128267,
            "battery",
            "battery-5"
        ],
        "f240",
        "M464 160c8.8 0 16 7.2 16 16V336c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16H464zM80 96C35.8 96 0 131.8 0 176V336c0 44.2 35.8 80 80 80H464c44.2 0 80-35.8 80-80V320c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32V176c0-44.2-35.8-80-80-80H80zm368 96H96V320H448V192z"
    ]
};
var $d8206b3ab2e65c05$export$214720d39635cea8 = $d8206b3ab2e65c05$export$9338fc4614cfc0cf;
var $d8206b3ab2e65c05$export$e426617482c711a7 = $d8206b3ab2e65c05$export$9338fc4614cfc0cf;
var $d8206b3ab2e65c05$export$8717352b90217272 = {
    prefix: "fas",
    iconName: "skull-crossbones",
    icon: [
        448,
        512,
        [
            128369,
            9760
        ],
        "f714",
        "M368 128c0 44.4-25.4 83.5-64 106.4V256c0 17.7-14.3 32-32 32H176c-17.7 0-32-14.3-32-32V234.4c-38.6-23-64-62.1-64-106.4C80 57.3 144.5 0 224 0s144 57.3 144 128zM168 176a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm144-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM3.4 273.7c7.9-15.8 27.1-22.2 42.9-14.3L224 348.2l177.7-88.8c15.8-7.9 35-1.5 42.9 14.3s1.5 35-14.3 42.9L295.6 384l134.8 67.4c15.8 7.9 22.2 27.1 14.3 42.9s-27.1 22.2-42.9 14.3L224 419.8 46.3 508.6c-15.8 7.9-35 1.5-42.9-14.3s-1.5-35 14.3-42.9L152.4 384 17.7 316.6C1.9 308.7-4.5 289.5 3.4 273.7z"
    ]
};
var $d8206b3ab2e65c05$export$ca4c5b4dcff58860 = {
    prefix: "fas",
    iconName: "code-compare",
    icon: [
        512,
        512,
        [],
        "e13a",
        "M320 488c0 9.5-5.6 18.1-14.2 21.9s-18.8 2.3-25.8-4.1l-80-72c-5.1-4.6-7.9-11-7.9-17.8s2.9-13.3 7.9-17.8l80-72c7-6.3 17.2-7.9 25.8-4.1s14.2 12.4 14.2 21.9v40h16c35.3 0 64-28.7 64-64V153.3C371.7 141 352 112.8 352 80c0-44.2 35.8-80 80-80s80 35.8 80 80c0 32.8-19.7 61-48 73.3V320c0 70.7-57.3 128-128 128H320v40zM456 80a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM192 24c0-9.5 5.6-18.1 14.2-21.9s18.8-2.3 25.8 4.1l80 72c5.1 4.6 7.9 11 7.9 17.8s-2.9 13.3-7.9 17.8l-80 72c-7 6.3-17.2 7.9-25.8 4.1s-14.2-12.4-14.2-21.9V128H176c-35.3 0-64 28.7-64 64V358.7c28.3 12.3 48 40.5 48 73.3c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-32.8 19.7-61 48-73.3V192c0-70.7 57.3-128 128-128h16V24zM56 432a24 24 0 1 0 48 0 24 24 0 1 0 -48 0z"
    ]
};
var $d8206b3ab2e65c05$export$f8a219cf4f516384 = {
    prefix: "fas",
    iconName: "list-ul",
    icon: [
        512,
        512,
        [
            "list-dots"
        ],
        "f0ca",
        "M64 144a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM192 64c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zM64 464a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm48-208a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"
    ]
};
var $d8206b3ab2e65c05$export$e6f4ba30d84fa6ea = $d8206b3ab2e65c05$export$f8a219cf4f516384;
var $d8206b3ab2e65c05$export$8845cce2a763ee07 = {
    prefix: "fas",
    iconName: "school-lock",
    icon: [
        640,
        512,
        [],
        "e56f",
        "M302.2 5.4c10.7-7.2 24.8-7.2 35.5 0L473.7 96H592c26.5 0 48 21.5 48 48V272c0-61.9-50.1-112-112-112s-112 50.1-112 112v24.6c-19.1 11.1-32 31.7-32 55.4H320.3l-.3 0c-35.3 0-64 28.7-64 64v96h64v0H48c-26.5 0-48-21.5-48-48V144c0-26.5 21.5-48 48-48H166.3L302.2 5.4zM80 208v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V208c0-8.8-7.2-16-16-16H96c-8.8 0-16 7.2-16 16zm0 128v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V336c0-8.8-7.2-16-16-16H96c-8.8 0-16 7.2-16 16zm240-72a88 88 0 1 0 0-176 88 88 0 1 0 0 176zm16-120v16h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H320c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16s16 7.2 16 16zm192 96c-17.7 0-32 14.3-32 32v48h64V272c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80v48c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32V272z"
    ]
};
var $d8206b3ab2e65c05$export$f4b64c3a138c1b59 = {
    prefix: "fas",
    iconName: "tower-cell",
    icon: [
        576,
        512,
        [],
        "e585",
        "M62.6 2.3C46.2-4.3 27.6 3.6 20.9 20C7.4 53.4 0 89.9 0 128s7.4 74.6 20.9 108c6.6 16.4 25.3 24.3 41.7 17.7S86.9 228.4 80.3 212C69.8 186.1 64 157.8 64 128s5.8-58.1 16.3-84C86.9 27.6 79 9 62.6 2.3zm450.8 0C497 9 489.1 27.6 495.7 44C506.2 69.9 512 98.2 512 128s-5.8 58.1-16.3 84c-6.6 16.4 1.3 35 17.7 41.7s35-1.3 41.7-17.7c13.5-33.4 20.9-69.9 20.9-108s-7.4-74.6-20.9-108C548.4 3.6 529.8-4.3 513.4 2.3zM340.1 165.2c7.5-10.5 11.9-23.3 11.9-37.2c0-35.3-28.7-64-64-64s-64 28.7-64 64c0 13.9 4.4 26.7 11.9 37.2L98.9 466.8c-7.3 16.1-.2 35.1 15.9 42.4s35.1 .2 42.4-15.9L177.7 448H398.3l20.6 45.2c7.3 16.1 26.3 23.2 42.4 15.9s23.2-26.3 15.9-42.4L340.1 165.2zM369.2 384H206.8l14.5-32H354.7l14.5 32zM288 205.3L325.6 288H250.4L288 205.3zM163.3 73.6c5.3-12.1-.2-26.3-12.4-31.6s-26.3 .2-31.6 12.4C109.5 77 104 101.9 104 128s5.5 51 15.3 73.6c5.3 12.1 19.5 17.7 31.6 12.4s17.7-19.5 12.4-31.6C156 165.8 152 147.4 152 128s4-37.8 11.3-54.4zM456.7 54.4c-5.3-12.1-19.5-17.7-31.6-12.4s-17.7 19.5-12.4 31.6C420 90.2 424 108.6 424 128s-4 37.8-11.3 54.4c-5.3 12.1 .2 26.3 12.4 31.6s26.3-.2 31.6-12.4C466.5 179 472 154.1 472 128s-5.5-51-15.3-73.6z"
    ]
};
var $d8206b3ab2e65c05$export$e88ba08d4f4d65b6 = {
    prefix: "fas",
    iconName: "down-long",
    icon: [
        320,
        512,
        [
            "long-arrow-alt-down"
        ],
        "f309",
        "M2 334.5c-3.8 8.8-2 19 4.6 26l136 144c4.5 4.8 10.8 7.5 17.4 7.5s12.9-2.7 17.4-7.5l136-144c6.6-7 8.4-17.2 4.6-26s-12.5-14.5-22-14.5l-72 0 0-288c0-17.7-14.3-32-32-32L128 0C110.3 0 96 14.3 96 32l0 288-72 0c-9.6 0-18.2 5.7-22 14.5z"
    ]
};
var $d8206b3ab2e65c05$export$8b92530ca6418c2f = $d8206b3ab2e65c05$export$e88ba08d4f4d65b6;
var $d8206b3ab2e65c05$export$e6fd420a918b43b5 = {
    prefix: "fas",
    iconName: "ranking-star",
    icon: [
        640,
        512,
        [],
        "e561",
        "M353.8 54.1L330.2 6.3c-3.9-8.3-16.1-8.6-20.4 0L286.2 54.1l-52.3 7.5c-9.3 1.4-13.3 12.9-6.4 19.8l38 37-9 52.1c-1.4 9.3 8.2 16.5 16.8 12.2l46.9-24.8 46.6 24.4c8.6 4.3 18.3-2.9 16.8-12.2l-9-52.1 38-36.6c6.8-6.8 2.9-18.3-6.4-19.8l-52.3-7.5zM256 256c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V288c0-17.7-14.3-32-32-32H256zM32 320c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H160c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32H32zm416 96v64c0 17.7 14.3 32 32 32H608c17.7 0 32-14.3 32-32V416c0-17.7-14.3-32-32-32H480c-17.7 0-32 14.3-32 32z"
    ]
};
var $d8206b3ab2e65c05$export$d5713874f8fefe1b = {
    prefix: "fas",
    iconName: "chess-king",
    icon: [
        448,
        512,
        [
            9818
        ],
        "f43f",
        "M224 0c17.7 0 32 14.3 32 32V48h16c17.7 0 32 14.3 32 32s-14.3 32-32 32H256v48H408c22.1 0 40 17.9 40 40c0 5.3-1 10.5-3.1 15.4L368 400H80L3.1 215.4C1 210.5 0 205.3 0 200c0-22.1 17.9-40 40-40H192V112H176c-17.7 0-32-14.3-32-32s14.3-32 32-32h16V32c0-17.7 14.3-32 32-32zM38.6 473.4L80 432H368l41.4 41.4c4.2 4.2 6.6 10 6.6 16c0 12.5-10.1 22.6-22.6 22.6H54.6C42.1 512 32 501.9 32 489.4c0-6 2.4-11.8 6.6-16z"
    ]
};
var $d8206b3ab2e65c05$export$dcd74f2821882a49 = {
    prefix: "fas",
    iconName: "person-harassing",
    icon: [
        576,
        512,
        [],
        "e549",
        "M192 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM59.4 304.5L88 256.9V480c0 17.7 14.3 32 32 32s32-14.3 32-32V352h16V480c0 17.7 14.3 32 32 32s32-14.3 32-32V235.3l47.4 57.1c11.3 13.6 31.5 15.5 45.1 4.2s15.5-31.5 4.2-45.1l-73.7-88.9c-18.2-22-45.3-34.7-73.9-34.7H145.1c-33.7 0-64.9 17.7-82.3 46.6l-58.3 97c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9zM480 240a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM464 344v58.7l-41.4-41.4c-7.3-7.3-17.6-10.6-27.8-9s-18.9 8.1-23.5 17.3l-48 96c-7.9 15.8-1.5 35 14.3 42.9s35 1.5 42.9-14.3L408.8 438l54.7 54.7c12.4 12.4 29.1 19.3 46.6 19.3c36.4 0 65.9-29.5 65.9-65.9V344c0-30.9-25.1-56-56-56s-56 25.1-56 56zM288 48c0 8.8 7.2 16 16 16h56c8.8 0 16-7.2 16-16s-7.2-16-16-16H304c-8.8 0-16 7.2-16 16zm-.8 49.7c-7.9-4-17.5-.7-21.5 7.2s-.7 17.5 7.2 21.5l48 24c7.9 4 17.5 .7 21.5-7.2s.7-17.5-7.2-21.5l-48-24z"
    ]
};
var $d8206b3ab2e65c05$export$9d355b4e79216962 = {
    prefix: "fas",
    iconName: "brazilian-real-sign",
    icon: [
        512,
        512,
        [],
        "e46c",
        "M400 0c17.7 0 32 14.3 32 32V50.2c12.5 2.3 24.7 6.4 36.2 12.1l10.1 5.1c15.8 7.9 22.2 27.1 14.3 42.9s-27.1 22.2-42.9 14.3l-10.2-5.1c-9.9-5-20.9-7.5-32-7.5h-1.7c-29.8 0-53.9 24.1-53.9 53.9c0 22 13.4 41.8 33.9 50l52 20.8c44.7 17.9 74.1 61.2 74.1 109.4v3.4c0 51.2-33.6 94.6-80 109.2V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V460.6c-15-3.5-29.4-9.7-42.3-18.3l-23.4-15.6c-14.7-9.8-18.7-29.7-8.9-44.4s29.7-18.7 44.4-8.9L361.2 389c10.8 7.2 23.4 11 36.3 11c27.9 0 50.5-22.6 50.5-50.5v-3.4c0-22-13.4-41.8-33.9-50l-52-20.8C317.3 257.4 288 214.1 288 165.9C288 114 321.5 70 368 54.2V32c0-17.7 14.3-32 32-32zM0 64C0 46.3 14.3 32 32 32h80c79.5 0 144 64.5 144 144c0 58.8-35.2 109.3-85.7 131.7l51.4 128.4c6.6 16.4-1.4 35-17.8 41.6s-35-1.4-41.6-17.8L106.3 320H64V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V288 64zM64 256h48c44.2 0 80-35.8 80-80s-35.8-80-80-80H64V256z"
    ]
};
var $d8206b3ab2e65c05$export$8a56136f40511e5d = {
    prefix: "fas",
    iconName: "landmark-dome",
    icon: [
        512,
        512,
        [
            "landmark-alt"
        ],
        "f752",
        "M248 0h16c13.3 0 24 10.7 24 24V34.7C368.4 48.1 431.9 111.6 445.3 192H448c17.7 0 32 14.3 32 32s-14.3 32-32 32H64c-17.7 0-32-14.3-32-32s14.3-32 32-32h2.7C80.1 111.6 143.6 48.1 224 34.7V24c0-13.3 10.7-24 24-24zM64 288h64V416h40V288h64V416h48V288h64V416h40V288h64V420.3c.6 .3 1.2 .7 1.7 1.1l48 32c11.7 7.8 17 22.4 12.9 35.9S494.1 512 480 512H32c-14.1 0-26.5-9.2-30.6-22.7s1.1-28.1 12.9-35.9l48-32c.6-.4 1.2-.7 1.8-1.1V288z"
    ]
};
var $d8206b3ab2e65c05$export$8b9c180efffc50ab = $d8206b3ab2e65c05$export$8a56136f40511e5d;
var $d8206b3ab2e65c05$export$8e144ed4d52eef49 = {
    prefix: "fas",
    iconName: "arrow-up",
    icon: [
        384,
        512,
        [
            8593
        ],
        "f062",
        "M214.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-160 160c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 141.2V448c0 17.7 14.3 32 32 32s32-14.3 32-32V141.2L329.4 246.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-160-160z"
    ]
};
var $d8206b3ab2e65c05$export$e0cfed4ba2fe562c = {
    prefix: "fas",
    iconName: "tv",
    icon: [
        640,
        512,
        [
            63717,
            "television",
            "tv-alt"
        ],
        "f26c",
        "M64 64V352H576V64H64zM0 64C0 28.7 28.7 0 64 0H576c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM128 448H512c17.7 0 32 14.3 32 32s-14.3 32-32 32H128c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
    ]
};
var $d8206b3ab2e65c05$export$9803b0176917be28 = $d8206b3ab2e65c05$export$e0cfed4ba2fe562c;
var $d8206b3ab2e65c05$export$6aa64ad5a1974ad7 = $d8206b3ab2e65c05$export$e0cfed4ba2fe562c;
var $d8206b3ab2e65c05$export$ac094c06f566cca3 = {
    prefix: "fas",
    iconName: "shrimp",
    icon: [
        512,
        512,
        [
            129424
        ],
        "e448",
        "M64 32C28.7 32 0 60.7 0 96s28.7 64 64 64h1c3.7 88.9 77 160 167 160h56V128H264 88.8 64c-17.7 0-32-14.3-32-32s14.3-32 32-32H464c8.8 0 16-7.2 16-16s-7.2-16-16-16H64zM224 456c0 13.3 10.7 24 24 24h72V407.8l-64.1-22.4c-12.5-4.4-26.2 2.2-30.6 14.7s2.2 26.2 14.7 30.6l4.5 1.6C233 433.9 224 443.9 224 456zm128 23.3c36.4-3.3 69.5-17.6 96.1-39.6l-86.5-34.6c-3 1.8-6.2 3.2-9.6 4.3v69.9zM472.6 415c24.6-30.3 39.4-68.9 39.4-111c0-12.3-1.3-24.3-3.7-35.9L382.8 355.1c.8 3.4 1.2 7 1.2 10.6c0 4.6-.7 9-1.9 13.1L472.6 415zM336 128H320V320h18.3c9.9 0 19.1 3.2 26.6 8.5l133.5-92.4C471.8 172.6 409.1 128 336 128zM168 192a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"
    ]
};
var $d8206b3ab2e65c05$export$350a84fd0f833f4d = {
    prefix: "fas",
    iconName: "list-check",
    icon: [
        512,
        512,
        [
            "tasks"
        ],
        "f0ae",
        "M152.1 38.2c9.9 8.9 10.7 24 1.8 33.9l-72 80c-4.4 4.9-10.6 7.8-17.2 7.9s-12.9-2.4-17.6-7L7 113C-2.3 103.6-2.3 88.4 7 79s24.6-9.4 33.9 0l22.1 22.1 55.1-61.2c8.9-9.9 24-10.7 33.9-1.8zm0 160c9.9 8.9 10.7 24 1.8 33.9l-72 80c-4.4 4.9-10.6 7.8-17.2 7.9s-12.9-2.4-17.6-7L7 273c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l22.1 22.1 55.1-61.2c8.9-9.9 24-10.7 33.9-1.8zM224 96c0-17.7 14.3-32 32-32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H256c-17.7 0-32-14.3-32-32zm0 160c0-17.7 14.3-32 32-32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H256c-17.7 0-32-14.3-32-32zM160 416c0-17.7 14.3-32 32-32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H192c-17.7 0-32-14.3-32-32zM48 368a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
    ]
};
var $d8206b3ab2e65c05$export$2f6d5b2fec286d63 = $d8206b3ab2e65c05$export$350a84fd0f833f4d;
var $d8206b3ab2e65c05$export$3fe50bd8062cd141 = {
    prefix: "fas",
    iconName: "jug-detergent",
    icon: [
        384,
        512,
        [],
        "e519",
        "M96 24c0-13.3 10.7-24 24-24h80c13.3 0 24 10.7 24 24V48h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H88C74.7 96 64 85.3 64 72s10.7-24 24-24h8V24zM0 256c0-70.7 57.3-128 128-128H256c70.7 0 128 57.3 128 128V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V256zm256 0v96c0 17.7 14.3 32 32 32s32-14.3 32-32V256c0-17.7-14.3-32-32-32s-32 14.3-32 32z"
    ]
};
var $d8206b3ab2e65c05$export$9a5c11a5e3d7f1e7 = {
    prefix: "fas",
    iconName: "circle-user",
    icon: [
        512,
        512,
        [
            62142,
            "user-circle"
        ],
        "f2bd",
        "M399 384.2C376.9 345.8 335.4 320 288 320H224c-47.4 0-88.9 25.8-111 64.2c35.2 39.2 86.2 63.8 143 63.8s107.8-24.7 143-63.8zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256 16a72 72 0 1 0 0-144 72 72 0 1 0 0 144z"
    ]
};
var $d8206b3ab2e65c05$export$be7d974e9e0dba1a = $d8206b3ab2e65c05$export$9a5c11a5e3d7f1e7;
var $d8206b3ab2e65c05$export$d1886bc596424e6c = {
    prefix: "fas",
    iconName: "user-shield",
    icon: [
        640,
        512,
        [],
        "f505",
        "M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H418.3c1.8 0 3.5-.2 5.3-.5c-76.3-55.1-99.8-141-103.1-200.2c-16.1-4.8-33.1-7.3-50.7-7.3H178.3zm308.8-78.3l-120 48C358 277.4 352 286.2 352 296c0 63.3 25.9 168.8 134.8 214.2c5.9 2.5 12.6 2.5 18.5 0C614.1 464.8 640 359.3 640 296c0-9.8-6-18.6-15.1-22.3l-120-48c-5.7-2.3-12.1-2.3-17.8 0zM591.4 312c-3.9 50.7-27.2 116.7-95.4 149.7V273.8L591.4 312z"
    ]
};
var $d8206b3ab2e65c05$export$cc58cb0f2257a6a9 = {
    prefix: "fas",
    iconName: "wind",
    icon: [
        512,
        512,
        [],
        "f72e",
        "M288 32c0 17.7 14.3 32 32 32h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H352c53 0 96-43 96-96s-43-96-96-96H320c-17.7 0-32 14.3-32 32zm64 352c0 17.7 14.3 32 32 32h32c53 0 96-43 96-96s-43-96-96-96H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H384c-17.7 0-32 14.3-32 32zM128 512h32c53 0 96-43 96-96s-43-96-96-96H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H160c17.7 0 32 14.3 32 32s-14.3 32-32 32H128c-17.7 0-32 14.3-32 32s14.3 32 32 32z"
    ]
};
var $d8206b3ab2e65c05$export$6d2be7c5d395dd16 = {
    prefix: "fas",
    iconName: "car-burst",
    icon: [
        640,
        512,
        [
            "car-crash"
        ],
        "f5e1",
        "M176 8c-6.6 0-12.4 4-14.9 10.1l-29.4 74L55.6 68.9c-6.3-1.9-13.1 .2-17.2 5.3s-4.6 12.2-1.4 17.9l39.5 69.1L10.9 206.4c-5.4 3.7-8 10.3-6.5 16.7s6.7 11.2 13.1 12.2l78.7 12.2L90.6 327c-.5 6.5 3.1 12.7 9 15.5s12.9 1.8 17.8-2.6l35.3-32.5 9.5-35.4 10.4-38.6c8-29.9 30.5-52.1 57.9-60.9l41-59.2c11.3-16.3 26.4-28.9 43.5-37.2c-.4-.6-.8-1.2-1.3-1.8c-4.1-5.1-10.9-7.2-17.2-5.3L220.3 92.1l-29.4-74C188.4 12 182.6 8 176 8zM367.7 161.5l135.6 36.3c6.5 1.8 11.3 7.4 11.8 14.2l4.6 56.5-201.5-54 32.2-46.6c3.8-5.6 10.8-8.1 17.3-6.4zm-69.9-30l-47.9 69.3c-21.6 3-40.3 18.6-46.3 41l-10.4 38.6-16.6 61.8-8.3 30.9c-4.6 17.1 5.6 34.6 22.6 39.2l15.5 4.1c17.1 4.6 34.6-5.6 39.2-22.6l8.3-30.9 247.3 66.3-8.3 30.9c-4.6 17.1 5.6 34.6 22.6 39.2l15.5 4.1c17.1 4.6 34.6-5.6 39.2-22.6l8.3-30.9L595 388l10.4-38.6c6-22.4-2.5-45.2-19.6-58.7l-6.8-84c-2.7-33.7-26.4-62-59-70.8L384.2 99.7c-32.7-8.8-67.3 4-86.5 31.8zm-17 131a24 24 0 1 1 -12.4 46.4 24 24 0 1 1 12.4-46.4zm217.9 83.2A24 24 0 1 1 545 358.1a24 24 0 1 1 -46.4-12.4z"
    ]
};
var $d8206b3ab2e65c05$export$8ff55566398404cd = $d8206b3ab2e65c05$export$6d2be7c5d395dd16;
var $d8206b3ab2e65c05$export$b8c4c058fe7d193c = {
    prefix: "fas",
    iconName: "y",
    icon: [
        384,
        512,
        [
            121
        ],
        "59",
        "M58 45.4C47.8 31 27.8 27.7 13.4 38S-4.3 68.2 6 82.6L160 298.3V448c0 17.7 14.3 32 32 32s32-14.3 32-32V298.3L378 82.6c10.3-14.4 6.9-34.4-7.4-44.6S336.2 31 326 45.4L192 232.9 58 45.4z"
    ]
};
var $d8206b3ab2e65c05$export$22c642403aeeaeaf = {
    prefix: "fas",
    iconName: "person-snowboarding",
    icon: [
        512,
        512,
        [
            127938,
            "snowboarding"
        ],
        "f7ce",
        "M209.7 3.4c15.8-7.9 35-1.5 42.9 14.3l25 50 42.4 8.5c19.5 3.9 37.8 12.3 53.5 24.5l126.1 98.1c14 10.9 16.5 31 5.6 44.9s-31 16.5-44.9 5.6l-72.1-56.1-71.5 31.8 33.1 27.6c23.2 19.3 33.5 50 26.7 79.4l-17.4 75.2c-2.2 9.4-8.2 16.8-16.1 21l86.5 33.1c4.6 1.8 9.4 2.6 14.3 2.6H472c13.3 0 24 10.7 24 24s-10.7 24-24 24H443.8c-10.8 0-21.4-2-31.5-5.8L60.1 371.3c-11.5-4.4-22-11.2-30.8-20L7 329c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l22.4 22.4c4 4 8.7 7.1 14 9.1l22.4 8.6c-.8-1.6-1.5-3.2-2.1-4.9c-5.6-16.8 3.5-34.9 20.2-40.5L192 264.9l0-53.2c0-24.2 13.7-46.4 35.4-57.2l45.2-22.6-7.5-1.5c-19.4-3.9-35.9-16.5-44.7-34.1l-25-50c-7.9-15.8-1.5-35 14.3-42.9zM139 350.1l159 60.9c-2.1-5.6-2.6-11.9-1.1-18.2l17.4-75.2c1.4-5.9-.7-12-5.3-15.9l-52.8-44 0 18.8c0 20.7-13.2 39-32.8 45.5L139 350.1zM432 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
    ]
};
var $d8206b3ab2e65c05$export$72683772d587302a = $d8206b3ab2e65c05$export$22c642403aeeaeaf;
var $d8206b3ab2e65c05$export$27de16299ddd171 = {
    prefix: "fas",
    iconName: "truck-fast",
    icon: [
        640,
        512,
        [
            "shipping-fast"
        ],
        "f48b",
        "M112 0C85.5 0 64 21.5 64 48V96H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H64 272c8.8 0 16 7.2 16 16s-7.2 16-16 16H64 48c-8.8 0-16 7.2-16 16s7.2 16 16 16H64 240c8.8 0 16 7.2 16 16s-7.2 16-16 16H64 16c-8.8 0-16 7.2-16 16s7.2 16 16 16H64 208c8.8 0 16 7.2 16 16s-7.2 16-16 16H64V416c0 53 43 96 96 96s96-43 96-96H384c0 53 43 96 96 96s96-43 96-96h32c17.7 0 32-14.3 32-32s-14.3-32-32-32V288 256 237.3c0-17-6.7-33.3-18.7-45.3L512 114.7c-12-12-28.3-18.7-45.3-18.7H416V48c0-26.5-21.5-48-48-48H112zM544 237.3V256H416V160h50.7L544 237.3zM160 368a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm272 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z"
    ]
};
var $d8206b3ab2e65c05$export$5e419f47aaeb3c05 = $d8206b3ab2e65c05$export$27de16299ddd171;
var $d8206b3ab2e65c05$export$24228a855c5f6812 = {
    prefix: "fas",
    iconName: "fish",
    icon: [
        576,
        512,
        [
            128031
        ],
        "f578",
        "M180.5 141.5C219.7 108.5 272.6 80 336 80s116.3 28.5 155.5 61.5c39.1 33 66.9 72.4 81 99.8c4.7 9.2 4.7 20.1 0 29.3c-14.1 27.4-41.9 66.8-81 99.8C452.3 403.5 399.4 432 336 432s-116.3-28.5-155.5-61.5c-16.2-13.7-30.5-28.5-42.7-43.1L48.1 379.6c-12.5 7.3-28.4 5.3-38.7-4.9S-3 348.7 4.2 336.1L50 256 4.2 175.9c-7.2-12.6-5-28.4 5.3-38.6s26.1-12.2 38.7-4.9l89.7 52.3c12.2-14.6 26.5-29.4 42.7-43.1zM448 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"
    ]
};
var $d8206b3ab2e65c05$export$10f5839059d22f7e = {
    prefix: "fas",
    iconName: "user-graduate",
    icon: [
        448,
        512,
        [],
        "f501",
        "M219.3 .5c3.1-.6 6.3-.6 9.4 0l200 40C439.9 42.7 448 52.6 448 64s-8.1 21.3-19.3 23.5L352 102.9V160c0 70.7-57.3 128-128 128s-128-57.3-128-128V102.9L48 93.3v65.1l15.7 78.4c.9 4.7-.3 9.6-3.3 13.3s-7.6 5.9-12.4 5.9H16c-4.8 0-9.3-2.1-12.4-5.9s-4.3-8.6-3.3-13.3L16 158.4V86.6C6.5 83.3 0 74.3 0 64C0 52.6 8.1 42.7 19.3 40.5l200-40zM111.9 327.7c10.5-3.4 21.8 .4 29.4 8.5l71 75.5c6.3 6.7 17 6.7 23.3 0l71-75.5c7.6-8.1 18.9-11.9 29.4-8.5C401 348.6 448 409.4 448 481.3c0 17-13.8 30.7-30.7 30.7H30.7C13.8 512 0 498.2 0 481.3c0-71.9 47-132.7 111.9-153.6z"
    ]
};
var $d8206b3ab2e65c05$export$625fb3848216f28c = {
    prefix: "fas",
    iconName: "circle-half-stroke",
    icon: [
        512,
        512,
        [
            9680,
            "adjust"
        ],
        "f042",
        "M448 256c0-106-86-192-192-192V448c106 0 192-86 192-192zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"
    ]
};
var $d8206b3ab2e65c05$export$cfa06e4b68edca2d = $d8206b3ab2e65c05$export$625fb3848216f28c;
var $d8206b3ab2e65c05$export$add3b381ced12554 = {
    prefix: "fas",
    iconName: "clapperboard",
    icon: [
        512,
        512,
        [],
        "e131",
        "M448 32H361.9l-1 1-127 127h92.1l1-1L453.8 32.3c-1.9-.2-3.8-.3-5.8-.3zm64 128V96c0-15.1-5.3-29.1-14-40l-104 104H512zM294.1 32H201.9l-1 1L73.9 160h92.1l1-1 127-127zM64 32C28.7 32 0 60.7 0 96v64H6.1l1-1 127-127H64zM512 192H0V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V192z"
    ]
};
var $d8206b3ab2e65c05$export$55c8e3afd9f6c0b4 = {
    prefix: "fas",
    iconName: "circle-radiation",
    icon: [
        512,
        512,
        [
            9762,
            "radiation-alt"
        ],
        "f7ba",
        "M256 64a192 192 0 1 1 0 384 192 192 0 1 1 0-384zm0 448A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM200 256c0-20.7 11.3-38.8 28-48.5l-36-62.3c-8.8-15.3-28.7-20.8-42-9c-25.6 22.6-43.9 53.3-50.9 88.1C95.7 241.5 110.3 256 128 256l72 0zm28 48.5l-36 62.4c-8.8 15.3-3.6 35.2 13.1 40.8c16 5.4 33.1 8.3 50.9 8.3s34.9-2.9 50.9-8.3c16.7-5.6 21.9-25.5 13.1-40.8l-36-62.4c-8.2 4.8-17.8 7.5-28 7.5s-19.8-2.7-28-7.5zM312 256l72 0c17.7 0 32.3-14.5 28.8-31.8c-7-34.8-25.3-65.5-50.9-88.1c-13.2-11.7-33.1-6.3-42 9l-36 62.3c16.7 9.7 28 27.8 28 48.5zm-56 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
var $d8206b3ab2e65c05$export$2f048fa82bbddf6f = $d8206b3ab2e65c05$export$55c8e3afd9f6c0b4;
var $d8206b3ab2e65c05$export$dc3654cf8a596fbf = {
    prefix: "fas",
    iconName: "baseball",
    icon: [
        512,
        512,
        [
            129358,
            9918,
            "baseball-ball"
        ],
        "f433",
        "M62.7 223.4c-4.8 .4-9.7 .6-14.7 .6c-15.6 0-30.8-2-45.2-5.9C19.2 107.1 107.1 19.2 218.1 2.8C222 17.2 224 32.4 224 48c0 4.9-.2 9.8-.6 14.7c-.7 8.8 5.8 16.5 14.6 17.3s16.5-5.8 17.3-14.6c.5-5.7 .7-11.5 .7-17.3c0-16.5-1.9-32.6-5.6-47.9c1.8 0 3.7-.1 5.6-.1C397.4 0 512 114.6 512 256c0 1.9 0 3.7-.1 5.6c-15.4-3.6-31.4-5.6-47.9-5.6c-5.8 0-11.6 .2-17.3 .7c-8.8 .7-15.4 8.5-14.6 17.3s8.5 15.4 17.3 14.6c4.8-.4 9.7-.6 14.7-.6c15.6 0 30.8 2 45.2 5.9C492.8 404.9 404.9 492.8 293.9 509.2C290 494.8 288 479.6 288 464c0-4.9 .2-9.8 .6-14.7c.7-8.8-5.8-16.5-14.6-17.3s-16.5 5.8-17.3 14.6c-.5 5.7-.7 11.5-.7 17.3c0 16.5 1.9 32.6 5.6 47.9c-1.8 0-3.7 .1-5.6 .1C114.6 512 0 397.4 0 256c0-1.9 0-3.7 .1-5.6C15.4 254.1 31.5 256 48 256c5.8 0 11.6-.2 17.3-.7c8.8-.7 15.4-8.5 14.6-17.3s-8.5-15.4-17.3-14.6zM121.3 208c-8 3.7-11.6 13.2-7.9 21.2s13.2 11.6 21.2 7.9c45.2-20.8 81.7-57.2 102.5-102.5c3.7-8 .2-17.5-7.9-21.2s-17.5-.2-21.2 7.9c-17.6 38.3-48.5 69.2-86.7 86.7zm277.2 74.7c-3.7-8-13.2-11.6-21.2-7.9c-45.2 20.8-81.7 57.2-102.5 102.5c-3.7 8-.2 17.5 7.9 21.2s17.5 .2 21.2-7.9c17.6-38.3 48.5-69.2 86.7-86.7c8-3.7 11.6-13.2 7.9-21.2z"
    ]
};
var $d8206b3ab2e65c05$export$63a3f8ceae07c7f3 = $d8206b3ab2e65c05$export$dc3654cf8a596fbf;
var $d8206b3ab2e65c05$export$b024a52a4ccf5e69 = {
    prefix: "fas",
    iconName: "jet-fighter-up",
    icon: [
        512,
        512,
        [],
        "e518",
        "M270.7 9.7C268.2 3.8 262.4 0 256 0s-12.2 3.8-14.7 9.7L197.2 112.6c-3.4 8-5.2 16.5-5.2 25.2v77l-144 84V280c0-13.3-10.7-24-24-24s-24 10.7-24 24v56 32 24c0 13.3 10.7 24 24 24s24-10.7 24-24v-8H192v32.7L133.5 468c-3.5 3-5.5 7.4-5.5 12v16c0 8.8 7.2 16 16 16h96V448c0-8.8 7.2-16 16-16s16 7.2 16 16v64h96c8.8 0 16-7.2 16-16V480c0-4.6-2-9-5.5-12L320 416.7V384H464v8c0 13.3 10.7 24 24 24s24-10.7 24-24V368 336 280c0-13.3-10.7-24-24-24s-24 10.7-24 24v18.8l-144-84v-77c0-8.7-1.8-17.2-5.2-25.2L270.7 9.7z"
    ]
};
var $d8206b3ab2e65c05$export$59c351869dc27435 = {
    prefix: "fas",
    iconName: "diagram-project",
    icon: [
        576,
        512,
        [
            "project-diagram"
        ],
        "f542",
        "M0 80C0 53.5 21.5 32 48 32h96c26.5 0 48 21.5 48 48V96H384V80c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H432c-26.5 0-48-21.5-48-48V160H192v16c0 1.7-.1 3.4-.3 5L272 288h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H272c-26.5 0-48-21.5-48-48V336c0-1.7 .1-3.4 .3-5L144 224H48c-26.5 0-48-21.5-48-48V80z"
    ]
};
var $d8206b3ab2e65c05$export$30bf9f5b96509df1 = $d8206b3ab2e65c05$export$59c351869dc27435;
var $d8206b3ab2e65c05$export$e9bd786d30cb716c = {
    prefix: "fas",
    iconName: "copy",
    icon: [
        448,
        512,
        [],
        "f0c5",
        "M208 0H332.1c12.7 0 24.9 5.1 33.9 14.1l67.9 67.9c9 9 14.1 21.2 14.1 33.9V336c0 26.5-21.5 48-48 48H208c-26.5 0-48-21.5-48-48V48c0-26.5 21.5-48 48-48zM48 128h80v64H64V448H256V416h64v48c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V176c0-26.5 21.5-48 48-48z"
    ]
};
var $d8206b3ab2e65c05$export$28cc565c11db6f2e = {
    prefix: "fas",
    iconName: "volume-xmark",
    icon: [
        576,
        512,
        [
            "volume-mute",
            "volume-times"
        ],
        "f6a9",
        "M301.1 34.8C312.6 40 320 51.4 320 64V448c0 12.6-7.4 24-18.9 29.2s-25 3.1-34.4-5.3L131.8 352H64c-35.3 0-64-28.7-64-64V224c0-35.3 28.7-64 64-64h67.8L266.7 40.1c9.4-8.4 22.9-10.4 34.4-5.3zM425 167l55 55 55-55c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-55 55 55 55c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-55-55-55 55c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l55-55-55-55c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0z"
    ]
};
var $d8206b3ab2e65c05$export$aa8decd057dfd29b = $d8206b3ab2e65c05$export$28cc565c11db6f2e;
var $d8206b3ab2e65c05$export$a1c7b36ba71dbeca = $d8206b3ab2e65c05$export$28cc565c11db6f2e;
var $d8206b3ab2e65c05$export$72e2d874a963de0c = {
    prefix: "fas",
    iconName: "hand-sparkles",
    icon: [
        640,
        512,
        [],
        "e05d",
        "M320 0c17.7 0 32 14.3 32 32V240c0 8.8 7.2 16 16 16s16-7.2 16-16V64c0-17.7 14.3-32 32-32s32 14.3 32 32V240c0 8.8 7.2 16 16 16s16-7.2 16-16V128c0-17.7 14.3-32 32-32s32 14.3 32 32V323.1c-11.9 4.8-21.3 14.9-25 27.8l-8.9 31.2L478.9 391C460.6 396.3 448 413 448 432c0 18.9 12.5 35.6 30.6 40.9C448.4 497.4 409.9 512 368 512H348.8c-59.6 0-116.9-22.9-160-64L76.4 341c-16-15.2-16.6-40.6-1.4-56.6s40.6-16.6 56.6-1.4l60.5 57.6c0-1.5-.1-3.1-.1-4.6V64c0-17.7 14.3-32 32-32s32 14.3 32 32V240c0 8.8 7.2 16 16 16s16-7.2 16-16V32c0-17.7 14.3-32 32-32zm-7.3 326.6c-1.1-3.9-4.7-6.6-8.7-6.6s-7.6 2.7-8.7 6.6L288 352l-25.4 7.3c-3.9 1.1-6.6 4.7-6.6 8.7s2.7 7.6 6.6 8.7L288 384l7.3 25.4c1.1 3.9 4.7 6.6 8.7 6.6s7.6-2.7 8.7-6.6L320 384l25.4-7.3c3.9-1.1 6.6-4.7 6.6-8.7s-2.7-7.6-6.6-8.7L320 352l-7.3-25.4zM104 120l48.3 13.8c4.6 1.3 7.7 5.5 7.7 10.2s-3.1 8.9-7.7 10.2L104 168 90.2 216.3c-1.3 4.6-5.5 7.7-10.2 7.7s-8.9-3.1-10.2-7.7L56 168 7.7 154.2C3.1 152.9 0 148.7 0 144s3.1-8.9 7.7-10.2L56 120 69.8 71.7C71.1 67.1 75.3 64 80 64s8.9 3.1 10.2 7.7L104 120zM584 408l48.3 13.8c4.6 1.3 7.7 5.5 7.7 10.2s-3.1 8.9-7.7 10.2L584 456l-13.8 48.3c-1.3 4.6-5.5 7.7-10.2 7.7s-8.9-3.1-10.2-7.7L536 456l-48.3-13.8c-4.6-1.3-7.7-5.5-7.7-10.2s3.1-8.9 7.7-10.2L536 408l13.8-48.3c1.3-4.6 5.5-7.7 10.2-7.7s8.9 3.1 10.2 7.7L584 408z"
    ]
};
var $d8206b3ab2e65c05$export$eb83fb404127db75 = {
    prefix: "fas",
    iconName: "grip",
    icon: [
        448,
        512,
        [
            "grip-horizontal"
        ],
        "f58d",
        "M128 136c0-22.1-17.9-40-40-40L40 96C17.9 96 0 113.9 0 136l0 48c0 22.1 17.9 40 40 40H88c22.1 0 40-17.9 40-40l0-48zm0 192c0-22.1-17.9-40-40-40H40c-22.1 0-40 17.9-40 40l0 48c0 22.1 17.9 40 40 40H88c22.1 0 40-17.9 40-40V328zm32-192v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V136c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40zM288 328c0-22.1-17.9-40-40-40H200c-22.1 0-40 17.9-40 40l0 48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V328zm32-192v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V136c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40zM448 328c0-22.1-17.9-40-40-40H360c-22.1 0-40 17.9-40 40v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V328z"
    ]
};
var $d8206b3ab2e65c05$export$4a45308d6c8decc1 = $d8206b3ab2e65c05$export$eb83fb404127db75;
var $d8206b3ab2e65c05$export$928280bdd54fa173 = {
    prefix: "fas",
    iconName: "share-from-square",
    icon: [
        576,
        512,
        [
            61509,
            "share-square"
        ],
        "f14d",
        "M352 224H305.5c-45 0-81.5 36.5-81.5 81.5c0 22.3 10.3 34.3 19.2 40.5c6.8 4.7 12.8 12 12.8 20.3c0 9.8-8 17.8-17.8 17.8h-2.5c-2.4 0-4.8-.4-7.1-1.4C210.8 374.8 128 333.4 128 240c0-79.5 64.5-144 144-144h80V34.7C352 15.5 367.5 0 386.7 0c8.6 0 16.8 3.2 23.2 8.9L548.1 133.3c7.6 6.8 11.9 16.5 11.9 26.7s-4.3 19.9-11.9 26.7l-139 125.1c-5.9 5.3-13.5 8.2-21.4 8.2H384c-17.7 0-32-14.3-32-32V224zM80 96c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16H400c8.8 0 16-7.2 16-16V384c0-17.7 14.3-32 32-32s32 14.3 32 32v48c0 44.2-35.8 80-80 80H80c-44.2 0-80-35.8-80-80V112C0 67.8 35.8 32 80 32h48c17.7 0 32 14.3 32 32s-14.3 32-32 32H80z"
    ]
};
var $d8206b3ab2e65c05$export$ae9e1434571f373c = $d8206b3ab2e65c05$export$928280bdd54fa173;
var $d8206b3ab2e65c05$export$f7367a7301f2dc0f = {
    prefix: "fas",
    iconName: "child-combatant",
    icon: [
        576,
        512,
        [
            "child-rifle"
        ],
        "e4e0",
        "M176 128A64 64 0 1 0 176 0a64 64 0 1 0 0 128zm-8 352V352h16V480c0 17.7 14.3 32 32 32s32-14.3 32-32V300.5L260.9 321c9.4 15 29.2 19.4 44.1 10s19.4-29.2 10-44.1l-51.7-82.1c-17.6-27.9-48.3-44.9-81.2-44.9H169.8c-33 0-63.7 16.9-81.2 44.9L36.9 287c-9.4 15-4.9 34.7 10 44.1s34.7 4.9 44.1-10L104 300.5V480c0 17.7 14.3 32 32 32s32-14.3 32-32zM448 0H432 416c-8.8 0-16 7.2-16 16s7.2 16 16 16V132.3c-9.6 5.5-16 15.9-16 27.7v32c-17.7 0-32 14.3-32 32V368c0 17.7 14.3 32 32 32h16v96c0 8.8 7.2 16 16 16h59.5c10.4 0 18-9.8 15.5-19.9L484 400h44c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16H480V325.3l53.1-17.7c6.5-2.2 10.9-8.3 10.9-15.2V208c0-8.8-7.2-16-16-16H512c-8.8 0-16 7.2-16 16v56l-16 5.3V160c0-11.8-6.4-22.2-16-27.7V16c0-8.8-7.2-16-16-16z"
    ]
};
var $d8206b3ab2e65c05$export$9b027cdb5db3ae5c = $d8206b3ab2e65c05$export$f7367a7301f2dc0f;
var $d8206b3ab2e65c05$export$e18f576a7b31ba46 = {
    prefix: "fas",
    iconName: "gun",
    icon: [
        576,
        512,
        [],
        "e19b",
        "M528 56c0-13.3-10.7-24-24-24s-24 10.7-24 24v8H32C14.3 64 0 78.3 0 96V208c0 17.7 14.3 32 32 32H42c20.8 0 36.1 19.6 31 39.8L33 440.2c-2.4 9.6-.2 19.7 5.8 27.5S54.1 480 64 480h96c14.7 0 27.5-10 31-24.2L217 352H321.4c23.7 0 44.8-14.9 52.7-37.2L400.9 240H432c8.5 0 16.6-3.4 22.6-9.4L477.3 208H544c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H528V56zM321.4 304H229l16-64h105l-21 58.7c-1.1 3.2-4.2 5.3-7.5 5.3zM80 128H464c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
    ]
};
var $d8206b3ab2e65c05$export$318ed022991eef56 = {
    prefix: "fas",
    iconName: "square-phone",
    icon: [
        448,
        512,
        [
            "phone-square"
        ],
        "f098",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm90.7 96.7c9.7-2.6 19.9 2.3 23.7 11.6l20 48c3.4 8.2 1 17.6-5.8 23.2L168 231.7c16.6 35.2 45.1 63.7 80.3 80.3l20.2-24.7c5.6-6.8 15-9.2 23.2-5.8l48 20c9.3 3.9 14.2 14 11.6 23.7l-12 44C336.9 378 329 384 320 384C196.3 384 96 283.7 96 160c0-9 6-16.9 14.7-19.3l44-12z"
    ]
};
var $d8206b3ab2e65c05$export$8ba22605a641ebdf = $d8206b3ab2e65c05$export$318ed022991eef56;
var $d8206b3ab2e65c05$export$a105e7b44ca0eb9e = {
    prefix: "fas",
    iconName: "plus",
    icon: [
        448,
        512,
        [
            10133,
            61543,
            "add"
        ],
        "2b",
        "M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32V224H48c-17.7 0-32 14.3-32 32s14.3 32 32 32H192V432c0 17.7 14.3 32 32 32s32-14.3 32-32V288H400c17.7 0 32-14.3 32-32s-14.3-32-32-32H256V80z"
    ]
};
var $d8206b3ab2e65c05$export$9e8f9a9d4ad32c0f = $d8206b3ab2e65c05$export$a105e7b44ca0eb9e;
var $d8206b3ab2e65c05$export$1fe4a9976a241685 = {
    prefix: "fas",
    iconName: "expand",
    icon: [
        448,
        512,
        [],
        "f065",
        "M32 32C14.3 32 0 46.3 0 64v96c0 17.7 14.3 32 32 32s32-14.3 32-32V96h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H32zM64 352c0-17.7-14.3-32-32-32s-32 14.3-32 32v96c0 17.7 14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H64V352zM320 32c-17.7 0-32 14.3-32 32s14.3 32 32 32h64v64c0 17.7 14.3 32 32 32s32-14.3 32-32V64c0-17.7-14.3-32-32-32H320zM448 352c0-17.7-14.3-32-32-32s-32 14.3-32 32v64H320c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32V352z"
    ]
};
var $d8206b3ab2e65c05$export$9835883ce9d0fe78 = {
    prefix: "fas",
    iconName: "computer",
    icon: [
        640,
        512,
        [],
        "e4e5",
        "M384 96V320H64L64 96H384zM64 32C28.7 32 0 60.7 0 96V320c0 35.3 28.7 64 64 64H181.3l-10.7 32H96c-17.7 0-32 14.3-32 32s14.3 32 32 32H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H277.3l-10.7-32H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm464 0c-26.5 0-48 21.5-48 48V432c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H528zm16 64h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H544c-8.8 0-16-7.2-16-16s7.2-16 16-16zm-16 80c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H544c-8.8 0-16-7.2-16-16zm32 160a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $d8206b3ab2e65c05$export$e6e44779b2fa1a5c = {
    prefix: "fas",
    iconName: "xmark",
    icon: [
        384,
        512,
        [
            128473,
            10005,
            10006,
            10060,
            215,
            "close",
            "multiply",
            "remove",
            "times"
        ],
        "f00d",
        "M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"
    ]
};
var $d8206b3ab2e65c05$export$23c717133fd81476 = $d8206b3ab2e65c05$export$e6e44779b2fa1a5c;
var $d8206b3ab2e65c05$export$4ed4ff13d4dbc862 = $d8206b3ab2e65c05$export$e6e44779b2fa1a5c;
var $d8206b3ab2e65c05$export$34810740c1bd6c54 = $d8206b3ab2e65c05$export$e6e44779b2fa1a5c;
var $d8206b3ab2e65c05$export$174bd7f477b115b4 = $d8206b3ab2e65c05$export$e6e44779b2fa1a5c;
var $d8206b3ab2e65c05$export$ff9a43e3a9cb653c = {
    prefix: "fas",
    iconName: "arrows-up-down-left-right",
    icon: [
        512,
        512,
        [
            "arrows"
        ],
        "f047",
        "M278.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-64 64c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l9.4-9.4V224H109.3l9.4-9.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-64 64c-12.5 12.5-12.5 32.8 0 45.3l64 64c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-9.4-9.4H224V402.7l-9.4-9.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l64 64c12.5 12.5 32.8 12.5 45.3 0l64-64c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-9.4 9.4V288H402.7l-9.4 9.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l64-64c12.5-12.5 12.5-32.8 0-45.3l-64-64c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l9.4 9.4H288V109.3l9.4 9.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-64-64z"
    ]
};
var $d8206b3ab2e65c05$export$d5ae09a305d70340 = $d8206b3ab2e65c05$export$ff9a43e3a9cb653c;
var $d8206b3ab2e65c05$export$fd7622d4b8d3674b = {
    prefix: "fas",
    iconName: "chalkboard-user",
    icon: [
        640,
        512,
        [
            "chalkboard-teacher"
        ],
        "f51c",
        "M160 64c0-35.3 28.7-64 64-64H576c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H336.8c-11.8-25.5-29.9-47.5-52.4-64H384V320c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v32h64V64L224 64v49.1C205.2 102.2 183.3 96 160 96V64zm0 64a96 96 0 1 1 0 192 96 96 0 1 1 0-192zM133.3 352h53.3C260.3 352 320 411.7 320 485.3c0 14.7-11.9 26.7-26.7 26.7H26.7C11.9 512 0 500.1 0 485.3C0 411.7 59.7 352 133.3 352z"
    ]
};
var $d8206b3ab2e65c05$export$443fcf69b0155291 = $d8206b3ab2e65c05$export$fd7622d4b8d3674b;
var $d8206b3ab2e65c05$export$c8f99b9b5ea83555 = {
    prefix: "fas",
    iconName: "peso-sign",
    icon: [
        384,
        512,
        [],
        "e222",
        "M64 32C46.3 32 32 46.3 32 64v64c-17.7 0-32 14.3-32 32s14.3 32 32 32l0 32c-17.7 0-32 14.3-32 32s14.3 32 32 32l0 64v96c0 17.7 14.3 32 32 32s32-14.3 32-32V384h80c68.4 0 127.7-39 156.8-96H352c17.7 0 32-14.3 32-32s-14.3-32-32-32h-.7c.5-5.3 .7-10.6 .7-16s-.2-10.7-.7-16h.7c17.7 0 32-14.3 32-32s-14.3-32-32-32H332.8C303.7 71 244.4 32 176 32H64zm190.4 96H96V96h80c30.5 0 58.2 12.2 78.4 32zM96 192H286.9c.7 5.2 1.1 10.6 1.1 16s-.4 10.8-1.1 16H96V192zm158.4 96c-20.2 19.8-47.9 32-78.4 32H96V288H254.4z"
    ]
};
var $d8206b3ab2e65c05$export$18ba6a500873dba9 = {
    prefix: "fas",
    iconName: "building-shield",
    icon: [
        576,
        512,
        [],
        "e4d8",
        "M0 48C0 21.5 21.5 0 48 0H336c26.5 0 48 21.5 48 48V207l-42.4 17H304 272c-8.8 0-16 7.2-16 16v32 24.2V304c0 .9 .1 1.7 .2 2.6c2.3 58.1 24.1 144.8 98.7 201.5c-5.8 2.5-12.2 3.9-18.9 3.9H240V432c0-26.5-21.5-48-48-48s-48 21.5-48 48v80H48c-26.5 0-48-21.5-48-48V48zM80 224c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H80zm80 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zM64 112v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zM176 96c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H176zm80 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H272c-8.8 0-16 7.2-16 16zM423.1 225.7c5.7-2.3 12.1-2.3 17.8 0l120 48C570 277.4 576 286.2 576 296c0 63.3-25.9 168.8-134.8 214.2c-5.9 2.5-12.6 2.5-18.5 0C313.9 464.8 288 359.3 288 296c0-9.8 6-18.6 15.1-22.3l120-48zM527.4 312L432 273.8V461.7c68.2-33 91.5-99 95.4-149.7z"
    ]
};
var $d8206b3ab2e65c05$export$8afab767536f59ad = {
    prefix: "fas",
    iconName: "baby",
    icon: [
        448,
        512,
        [],
        "f77c",
        "M152 88a72 72 0 1 1 144 0A72 72 0 1 1 152 88zM39.7 144.5c13-17.9 38-21.8 55.9-8.8L131.8 162c26.8 19.5 59.1 30 92.2 30s65.4-10.5 92.2-30l36.2-26.4c17.9-13 42.9-9 55.9 8.8s9 42.9-8.8 55.9l-36.2 26.4c-13.6 9.9-28.1 18.2-43.3 25V288H128V251.7c-15.2-6.7-29.7-15.1-43.3-25L48.5 200.3c-17.9-13-21.8-38-8.8-55.9zm89.8 184.8l60.6 53-26 37.2 24.3 24.3c15.6 15.6 15.6 40.9 0 56.6s-40.9 15.6-56.6 0l-48-48C70 438.6 68.1 417 79.2 401.1l50.2-71.8zm128.5 53l60.6-53 50.2 71.8c11.1 15.9 9.2 37.5-4.5 51.2l-48 48c-15.6 15.6-40.9 15.6-56.6 0s-15.6-40.9 0-56.6L284 419.4l-26-37.2z"
    ]
};
var $d8206b3ab2e65c05$export$d7e538fddb81da68 = {
    prefix: "fas",
    iconName: "users-line",
    icon: [
        640,
        512,
        [],
        "e592",
        "M211.2 96a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM32 256c0 17.7 14.3 32 32 32h85.6c10.1-39.4 38.6-71.5 75.8-86.6c-9.7-6-21.2-9.4-33.4-9.4H96c-35.3 0-64 28.7-64 64zm461.6 32H576c17.7 0 32-14.3 32-32c0-35.3-28.7-64-64-64H448c-11.7 0-22.7 3.1-32.1 8.6c38.1 14.8 67.4 47.3 77.7 87.4zM391.2 226.4c-6.9-1.6-14.2-2.4-21.6-2.4h-96c-8.5 0-16.7 1.1-24.5 3.1c-30.8 8.1-55.6 31.1-66.1 60.9c-3.5 10-5.5 20.8-5.5 32c0 17.7 14.3 32 32 32h224c17.7 0 32-14.3 32-32c0-11.2-1.9-22-5.5-32c-10.8-30.7-36.8-54.2-68.9-61.6zM563.2 96a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM321.6 192a80 80 0 1 0 0-160 80 80 0 1 0 0 160zM32 416c-17.7 0-32 14.3-32 32s14.3 32 32 32H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z"
    ]
};
var $d8206b3ab2e65c05$export$932a67a1b1a7a724 = {
    prefix: "fas",
    iconName: "quote-left",
    icon: [
        448,
        512,
        [
            8220,
            "quote-left-alt"
        ],
        "f10d",
        "M0 216C0 149.7 53.7 96 120 96h8c17.7 0 32 14.3 32 32s-14.3 32-32 32h-8c-30.9 0-56 25.1-56 56v8h64c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V320 288 216zm256 0c0-66.3 53.7-120 120-120h8c17.7 0 32 14.3 32 32s-14.3 32-32 32h-8c-30.9 0-56 25.1-56 56v8h64c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64H320c-35.3 0-64-28.7-64-64V320 288 216z"
    ]
};
var $d8206b3ab2e65c05$export$95bb9ad3aa35c741 = $d8206b3ab2e65c05$export$932a67a1b1a7a724;
var $d8206b3ab2e65c05$export$e87e41787bbedc98 = {
    prefix: "fas",
    iconName: "tractor",
    icon: [
        640,
        512,
        [
            128668
        ],
        "f722",
        "M96 64c0-35.3 28.7-64 64-64H266.3c26.2 0 49.7 15.9 59.4 40.2L373.7 160H480V126.2c0-24.8 5.8-49.3 16.9-71.6l2.5-5c7.9-15.8 27.1-22.2 42.9-14.3s22.2 27.1 14.3 42.9l-2.5 5c-6.7 13.3-10.1 28-10.1 42.9V160h56c22.1 0 40 17.9 40 40v45.4c0 16.5-8.5 31.9-22.6 40.7l-43.3 27.1c-14.2-5.9-29.8-9.2-46.1-9.2c-39.3 0-74.1 18.9-96 48H352c0 17.7-14.3 32-32 32h-8.2c-1.7 4.8-3.7 9.5-5.8 14.1l5.8 5.8c12.5 12.5 12.5 32.8 0 45.3l-22.6 22.6c-12.5 12.5-32.8 12.5-45.3 0l-5.8-5.8c-4.6 2.2-9.3 4.1-14.1 5.8V480c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32v-8.2c-4.8-1.7-9.5-3.7-14.1-5.8l-5.8 5.8c-12.5 12.5-32.8 12.5-45.3 0L40.2 449.1c-12.5-12.5-12.5-32.8 0-45.3l5.8-5.8c-2.2-4.6-4.1-9.3-5.8-14.1H32c-17.7 0-32-14.3-32-32V320c0-17.7 14.3-32 32-32h8.2c1.7-4.8 3.7-9.5 5.8-14.1l-5.8-5.8c-12.5-12.5-12.5-32.8 0-45.3l22.6-22.6c9-9 21.9-11.5 33.1-7.6V192 160 64zm170.3 0H160v96h32H304.7L266.3 64zM176 256a80 80 0 1 0 0 160 80 80 0 1 0 0-160zM528 448a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0 64c-48.6 0-88-39.4-88-88c0-29.8 14.8-56.1 37.4-72c14.3-10.1 31.8-16 50.6-16c2.7 0 5.3 .1 7.9 .3c44.9 4 80.1 41.7 80.1 87.7c0 48.6-39.4 88-88 88z"
    ]
};
var $d8206b3ab2e65c05$export$940cea0f5451895c = {
    prefix: "fas",
    iconName: "trash-arrow-up",
    icon: [
        448,
        512,
        [
            "trash-restore"
        ],
        "f829",
        "M163.8 0H284.2c12.1 0 23.2 6.8 28.6 17.7L320 32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64S14.3 32 32 32h96l7.2-14.3C140.6 6.8 151.7 0 163.8 0zM32 128H416L394.8 467c-1.6 25.3-22.6 45-47.9 45H101.1c-25.3 0-46.3-19.7-47.9-45L32 128zm192 64c-6.4 0-12.5 2.5-17 7l-80 80c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l39-39V408c0 13.3 10.7 24 24 24s24-10.7 24-24V273.9l39 39c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-80-80c-4.5-4.5-10.6-7-17-7z"
    ]
};
var $d8206b3ab2e65c05$export$d32f45a64ed40e8d = $d8206b3ab2e65c05$export$940cea0f5451895c;
var $d8206b3ab2e65c05$export$fc9f7bd981c34c45 = {
    prefix: "fas",
    iconName: "arrow-down-up-lock",
    icon: [
        640,
        512,
        [],
        "e4b0",
        "M150.6 502.6l96-96c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L160 402.7V288H416V272c0-17.2 3.9-33.5 10.8-48H352V109.3l41.4 41.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-96-96c-6-6-14.1-9.4-22.6-9.4s-16.6 3.4-22.6 9.4l-96 96c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L288 109.3V224l-128 0H96l-64 0c-17.7 0-32 14.3-32 32s14.3 32 32 32H96V402.7L54.6 361.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0zM160 192V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V192h64zM288 320V448c0 17.7 14.3 32 32 32s32-14.3 32-32V320H288zm240-80c17.7 0 32 14.3 32 32v48H496V272c0-17.7 14.3-32 32-32zm-80 32v48c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H608c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32V272c0-44.2-35.8-80-80-80s-80 35.8-80 80z"
    ]
};
var $d8206b3ab2e65c05$export$4d384ffc907ddaff = {
    prefix: "fas",
    iconName: "lines-leaning",
    icon: [
        384,
        512,
        [],
        "e51e",
        "M190.4 74.1c5.6-16.8-3.5-34.9-20.2-40.5s-34.9 3.5-40.5 20.2l-128 384c-5.6 16.8 3.5 34.9 20.2 40.5s34.9-3.5 40.5-20.2l128-384zm70.9-41.7c-17.4-2.9-33.9 8.9-36.8 26.3l-64 384c-2.9 17.4 8.9 33.9 26.3 36.8s33.9-8.9 36.8-26.3l64-384c2.9-17.4-8.9-33.9-26.3-36.8zM352 32c-17.7 0-32 14.3-32 32V448c0 17.7 14.3 32 32 32s32-14.3 32-32V64c0-17.7-14.3-32-32-32z"
    ]
};
var $d8206b3ab2e65c05$export$613f406c1b5802a8 = {
    prefix: "fas",
    iconName: "ruler-combined",
    icon: [
        512,
        512,
        [],
        "f546",
        "M.2 468.9C2.7 493.1 23.1 512 48 512l96 0 320 0c26.5 0 48-21.5 48-48l0-96c0-26.5-21.5-48-48-48l-48 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-64 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-64 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-80 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l80 0 0-64-80 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l80 0 0-64-80 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l80 0 0-48c0-26.5-21.5-48-48-48L48 0C21.5 0 0 21.5 0 48L0 368l0 96c0 1.7 .1 3.3 .2 4.9z"
    ]
};
var $d8206b3ab2e65c05$export$da61665fff8aebfe = {
    prefix: "fas",
    iconName: "copyright",
    icon: [
        512,
        512,
        [
            169
        ],
        "f1f9",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM199.4 312.6c31.2 31.2 81.9 31.2 113.1 0c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9c-50 50-131 50-181 0s-50-131 0-181s131-50 181 0c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0c-31.2-31.2-81.9-31.2-113.1 0s-31.2 81.9 0 113.1z"
    ]
};
var $d8206b3ab2e65c05$export$a7c5f5e4805fdab = {
    prefix: "fas",
    iconName: "equals",
    icon: [
        448,
        512,
        [
            62764
        ],
        "3d",
        "M48 128c-17.7 0-32 14.3-32 32s14.3 32 32 32H400c17.7 0 32-14.3 32-32s-14.3-32-32-32H48zm0 192c-17.7 0-32 14.3-32 32s14.3 32 32 32H400c17.7 0 32-14.3 32-32s-14.3-32-32-32H48z"
    ]
};
var $d8206b3ab2e65c05$export$db34f7a6de38784f = {
    prefix: "fas",
    iconName: "blender",
    icon: [
        512,
        512,
        [],
        "f517",
        "M0 64C0 28.7 28.7 0 64 0h64 32H470.1c21.1 0 36.4 20.1 30.9 40.4L494.5 64H336c-8.8 0-16 7.2-16 16s7.2 16 16 16H485.8l-17.5 64H336c-8.8 0-16 7.2-16 16s7.2 16 16 16H459.6l-17.5 64H336c-8.8 0-16 7.2-16 16s7.2 16 16 16h97.5L416 352H160l-8.7-96H64c-35.3 0-64-28.7-64-64V64zM145.5 192L133.8 64H64V192h81.5zM144 384H432c26.5 0 48 21.5 48 48v32c0 26.5-21.5 48-48 48H144c-26.5 0-48-21.5-48-48V432c0-26.5 21.5-48 48-48zm144 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
var $d8206b3ab2e65c05$export$b4619aeaf0b9d18e = {
    prefix: "fas",
    iconName: "teeth",
    icon: [
        576,
        512,
        [],
        "f62e",
        "M0 128C0 75 43 32 96 32H480c53 0 96 43 96 96V384c0 53-43 96-96 96H96c-53 0-96-43-96-96V128zm176 48v56c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V176c0-26.5-21.5-48-48-48s-48 21.5-48 48zm176-48c-26.5 0-48 21.5-48 48v56c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V176c0-26.5-21.5-48-48-48zM48 208v24c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V208c0-26.5-21.5-48-48-48s-48 21.5-48 48zM96 384c26.5 0 48-21.5 48-48V312c0-13.3-10.7-24-24-24H72c-13.3 0-24 10.7-24 24v24c0 26.5 21.5 48 48 48zm80-48c0 26.5 21.5 48 48 48s48-21.5 48-48V312c0-13.3-10.7-24-24-24H200c-13.3 0-24 10.7-24 24v24zm176 48c26.5 0 48-21.5 48-48V312c0-13.3-10.7-24-24-24H328c-13.3 0-24 10.7-24 24v24c0 26.5 21.5 48 48 48zm80-176v24c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V208c0-26.5-21.5-48-48-48s-48 21.5-48 48zm48 176c26.5 0 48-21.5 48-48V312c0-13.3-10.7-24-24-24H456c-13.3 0-24 10.7-24 24v24c0 26.5 21.5 48 48 48z"
    ]
};
var $d8206b3ab2e65c05$export$3570be7b68efb8db = {
    prefix: "fas",
    iconName: "shekel-sign",
    icon: [
        448,
        512,
        [
            8362,
            "ils",
            "shekel",
            "sheqel",
            "sheqel-sign"
        ],
        "f20b",
        "M32 32C14.3 32 0 46.3 0 64V448c0 17.7 14.3 32 32 32s32-14.3 32-32V96H192c35.3 0 64 28.7 64 64V320c0 17.7 14.3 32 32 32s32-14.3 32-32V160c0-70.7-57.3-128-128-128H32zM320 480c70.7 0 128-57.3 128-128V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V352c0 35.3-28.7 64-64 64H192V192c0-17.7-14.3-32-32-32s-32 14.3-32 32V448c0 17.7 14.3 32 32 32H320z"
    ]
};
var $d8206b3ab2e65c05$export$ecadeff45b05a451 = $d8206b3ab2e65c05$export$3570be7b68efb8db;
var $d8206b3ab2e65c05$export$27e0e10e74d98736 = $d8206b3ab2e65c05$export$3570be7b68efb8db;
var $d8206b3ab2e65c05$export$28b3b26a80030d4e = $d8206b3ab2e65c05$export$3570be7b68efb8db;
var $d8206b3ab2e65c05$export$d84993fb5e8c6edd = $d8206b3ab2e65c05$export$3570be7b68efb8db;
var $d8206b3ab2e65c05$export$fc82fb79180cd17c = {
    prefix: "fas",
    iconName: "map",
    icon: [
        576,
        512,
        [
            128506,
            62072
        ],
        "f279",
        "M384 476.1L192 421.2V35.9L384 90.8V476.1zm32-1.2V88.4L543.1 37.5c15.8-6.3 32.9 5.3 32.9 22.3V394.6c0 9.8-6 18.6-15.1 22.3L416 474.8zM15.1 95.1L160 37.2V423.6L32.9 474.5C17.1 480.8 0 469.2 0 452.2V117.4c0-9.8 6-18.6 15.1-22.3z"
    ]
};
var $d8206b3ab2e65c05$export$b24d84ed5657d89a = {
    prefix: "fas",
    iconName: "rocket",
    icon: [
        512,
        512,
        [],
        "f135",
        "M156.6 384.9L125.7 354c-8.5-8.5-11.5-20.8-7.7-32.2c3-8.9 7-20.5 11.8-33.8L24 288c-8.6 0-16.6-4.6-20.9-12.1s-4.2-16.7 .2-24.1l52.5-88.5c13-21.9 36.5-35.3 61.9-35.3l82.3 0c2.4-4 4.8-7.7 7.2-11.3C289.1-4.1 411.1-8.1 483.9 5.3c11.6 2.1 20.6 11.2 22.8 22.8c13.4 72.9 9.3 194.8-111.4 276.7c-3.5 2.4-7.3 4.8-11.3 7.2v82.3c0 25.4-13.4 49-35.3 61.9l-88.5 52.5c-7.4 4.4-16.6 4.5-24.1 .2s-12.1-12.2-12.1-20.9V380.8c-14.1 4.9-26.4 8.9-35.7 11.9c-11.2 3.6-23.4 .5-31.8-7.8zM384 168a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"
    ]
};
var $d8206b3ab2e65c05$export$ed36ad335b36be22 = {
    prefix: "fas",
    iconName: "photo-film",
    icon: [
        640,
        512,
        [
            "photo-video"
        ],
        "f87c",
        "M256 0H576c35.3 0 64 28.7 64 64V288c0 35.3-28.7 64-64 64H256c-35.3 0-64-28.7-64-64V64c0-35.3 28.7-64 64-64zM476 106.7C471.5 100 464 96 456 96s-15.5 4-20 10.7l-56 84L362.7 169c-4.6-5.7-11.5-9-18.7-9s-14.2 3.3-18.7 9l-64 80c-5.8 7.2-6.9 17.1-2.9 25.4s12.4 13.6 21.6 13.6h80 48H552c8.9 0 17-4.9 21.2-12.7s3.7-17.3-1.2-24.6l-96-144zM336 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM64 128h96V384v32c0 17.7 14.3 32 32 32H320c17.7 0 32-14.3 32-32V384H512v64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192c0-35.3 28.7-64 64-64zm8 64c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16H88c8.8 0 16-7.2 16-16V208c0-8.8-7.2-16-16-16H72zm0 104c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16H88c8.8 0 16-7.2 16-16V312c0-8.8-7.2-16-16-16H72zm0 104c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16H88c8.8 0 16-7.2 16-16V416c0-8.8-7.2-16-16-16H72zm336 16v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V416c0-8.8-7.2-16-16-16H424c-8.8 0-16 7.2-16 16z"
    ]
};
var $d8206b3ab2e65c05$export$739f6a6a12dfb6ed = $d8206b3ab2e65c05$export$ed36ad335b36be22;
var $d8206b3ab2e65c05$export$758f1fb3784e4080 = {
    prefix: "fas",
    iconName: "folder-minus",
    icon: [
        512,
        512,
        [],
        "f65d",
        "M448 480H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H192c20.1 0 39.1 9.5 51.2 25.6l19.2 25.6c6 8.1 15.5 12.8 25.6 12.8H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64zM184 272c-13.3 0-24 10.7-24 24s10.7 24 24 24H328c13.3 0 24-10.7 24-24s-10.7-24-24-24H184z"
    ]
};
var $d8206b3ab2e65c05$export$de59c2657a8ace67 = {
    prefix: "fas",
    iconName: "store",
    icon: [
        576,
        512,
        [],
        "f54e",
        "M547.6 103.8L490.3 13.1C485.2 5 476.1 0 466.4 0H109.6C99.9 0 90.8 5 85.7 13.1L28.3 103.8c-29.6 46.8-3.4 111.9 51.9 119.4c4 .5 8.1 .8 12.1 .8c26.1 0 49.3-11.4 65.2-29c15.9 17.6 39.1 29 65.2 29c26.1 0 49.3-11.4 65.2-29c15.9 17.6 39.1 29 65.2 29c26.2 0 49.3-11.4 65.2-29c16 17.6 39.1 29 65.2 29c4.1 0 8.1-.3 12.1-.8c55.5-7.4 81.8-72.5 52.1-119.4zM499.7 254.9l-.1 0c-5.3 .7-10.7 1.1-16.2 1.1c-12.4 0-24.3-1.9-35.4-5.3V384H128V250.6c-11.2 3.5-23.2 5.4-35.6 5.4c-5.5 0-11-.4-16.3-1.1l-.1 0c-4.1-.6-8.1-1.3-12-2.3V384v64c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V384 252.6c-4 1-8 1.8-12.3 2.3z"
    ]
};
var $d8206b3ab2e65c05$export$cf36928a9c52e98a = {
    prefix: "fas",
    iconName: "arrow-trend-up",
    icon: [
        576,
        512,
        [],
        "e098",
        "M384 160c-17.7 0-32-14.3-32-32s14.3-32 32-32H544c17.7 0 32 14.3 32 32V288c0 17.7-14.3 32-32 32s-32-14.3-32-32V205.3L342.6 374.6c-12.5 12.5-32.8 12.5-45.3 0L192 269.3 54.6 406.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l160-160c12.5-12.5 32.8-12.5 45.3 0L320 306.7 466.7 160H384z"
    ]
};
var $d8206b3ab2e65c05$export$2a44d62160972254 = {
    prefix: "fas",
    iconName: "plug-circle-minus",
    icon: [
        576,
        512,
        [],
        "e55e",
        "M96 0C78.3 0 64 14.3 64 32v96h64V32c0-17.7-14.3-32-32-32zM288 0c-17.7 0-32 14.3-32 32v96h64V32c0-17.7-14.3-32-32-32zM32 160c-17.7 0-32 14.3-32 32s14.3 32 32 32v32c0 77.4 55 142 128 156.8V480c0 17.7 14.3 32 32 32s32-14.3 32-32V412.8c12.3-2.5 24.1-6.4 35.1-11.5c-2.1-10.8-3.1-21.9-3.1-33.3c0-80.3 53.8-148 127.3-169.2c.5-2.2 .7-4.5 .7-6.8c0-17.7-14.3-32-32-32H32zM576 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-64 0c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16s7.2-16 16-16H496c8.8 0 16 7.2 16 16z"
    ]
};
var $d8206b3ab2e65c05$export$5c1f29f4c7cad367 = {
    prefix: "fas",
    iconName: "sign-hanging",
    icon: [
        512,
        512,
        [
            "sign"
        ],
        "f4d9",
        "M96 0c17.7 0 32 14.3 32 32V64l352 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-352 0V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V128H32C14.3 128 0 113.7 0 96S14.3 64 32 64H64V32C64 14.3 78.3 0 96 0zm96 160H448c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V192c0-17.7 14.3-32 32-32z"
    ]
};
var $d8206b3ab2e65c05$export$d21d0d6c8e9e8bf9 = $d8206b3ab2e65c05$export$5c1f29f4c7cad367;
var $d8206b3ab2e65c05$export$a527a6267c55a54c = {
    prefix: "fas",
    iconName: "bezier-curve",
    icon: [
        640,
        512,
        [],
        "f55b",
        "M296 136V88h48v48H296zM288 32c-26.5 0-48 21.5-48 48v4H121.6C111.2 62.7 89.3 48 64 48C28.7 48 0 76.7 0 112s28.7 64 64 64c25.3 0 47.2-14.7 57.6-36h66.9c-58.9 39.6-98.9 105-104 180H80c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48V368c0-26.5-21.5-48-48-48h-3.3c5.9-67 48.5-123.4 107.5-149.1c8.6 12.7 23.2 21.1 39.8 21.1h64c16.6 0 31.1-8.4 39.8-21.1c59 25.7 101.6 82.1 107.5 149.1H496c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48V368c0-26.5-21.5-48-48-48h-4.5c-5-75-45.1-140.4-104-180h66.9c10.4 21.3 32.3 36 57.6 36c35.3 0 64-28.7 64-64s-28.7-64-64-64c-25.3 0-47.2 14.7-57.6 36H400V80c0-26.5-21.5-48-48-48H288zM88 376h48v48H88V376zm416 48V376h48v48H504z"
    ]
};
var $d8206b3ab2e65c05$export$6b31a1e5968b2378 = {
    prefix: "fas",
    iconName: "bell-slash",
    icon: [
        640,
        512,
        [
            128277,
            61943
        ],
        "f1f6",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-90.2-70.7c.2-.4 .4-.9 .6-1.3c5.2-11.5 3.1-25-5.3-34.4l-7.4-8.3C497.3 319.2 480 273.9 480 226.8V208c0-77.4-55-142-128-156.8V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V51.2c-42.6 8.6-79 34.2-102 69.3L38.8 5.1zM406.2 416L160 222.1v4.8c0 47-17.3 92.4-48.5 127.6l-7.4 8.3c-8.4 9.4-10.4 22.9-5.3 34.4S115.4 416 128 416H406.2zm-40.9 77.3c12-12 18.7-28.3 18.7-45.3H320 256c0 17 6.7 33.3 18.7 45.3s28.3 18.7 45.3 18.7s33.3-6.7 45.3-18.7z"
    ]
};
var $d8206b3ab2e65c05$export$1c92b67c45a4b4fc = {
    prefix: "fas",
    iconName: "tablet",
    icon: [
        448,
        512,
        [
            "tablet-android"
        ],
        "f3fb",
        "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM176 432h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
    ]
};
var $d8206b3ab2e65c05$export$5eddbb7c71278268 = $d8206b3ab2e65c05$export$1c92b67c45a4b4fc;
var $d8206b3ab2e65c05$export$9b263780a7312c8c = {
    prefix: "fas",
    iconName: "school-flag",
    icon: [
        576,
        512,
        [],
        "e56e",
        "M288 0H400c8.8 0 16 7.2 16 16V80c0 8.8-7.2 16-16 16H320.7l89.6 64H512c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H336V400c0-26.5-21.5-48-48-48s-48 21.5-48 48V512H64c-35.3 0-64-28.7-64-64V224c0-35.3 28.7-64 64-64H165.7L256 95.5V32c0-17.7 14.3-32 32-32zm48 240a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM80 224c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H80zm368 16v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H464c-8.8 0-16 7.2-16 16zM80 352c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16H80zm384 0c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16H464z"
    ]
};
var $d8206b3ab2e65c05$export$d3c2bcfd3b861e4a = {
    prefix: "fas",
    iconName: "fill",
    icon: [
        512,
        512,
        [],
        "f575",
        "M86.6 9.4C74.1-3.1 53.9-3.1 41.4 9.4s-12.5 32.8 0 45.3L122.7 136 30.6 228.1c-37.5 37.5-37.5 98.3 0 135.8L148.1 481.4c37.5 37.5 98.3 37.5 135.8 0L474.3 290.9c28.1-28.1 28.1-73.7 0-101.8L322.9 37.7c-28.1-28.1-73.7-28.1-101.8 0L168 90.7 86.6 9.4zM168 181.3l49.4 49.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L213.3 136l53.1-53.1c3.1-3.1 8.2-3.1 11.3 0L429.1 234.3c3.1 3.1 3.1 8.2 0 11.3L386.7 288H67.5c1.4-5.4 4.2-10.4 8.4-14.6L168 181.3z"
    ]
};
var $d8206b3ab2e65c05$export$887340269e6d6cac = {
    prefix: "fas",
    iconName: "angle-up",
    icon: [
        448,
        512,
        [
            8963
        ],
        "f106",
        "M201.4 137.4c12.5-12.5 32.8-12.5 45.3 0l160 160c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L224 205.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l160-160z"
    ]
};
var $d8206b3ab2e65c05$export$482976e9a4ab10f3 = {
    prefix: "fas",
    iconName: "drumstick-bite",
    icon: [
        512,
        512,
        [],
        "f6d7",
        "M160 265.2c0 8.5-3.4 16.6-9.4 22.6l-26.8 26.8c-12.3 12.3-32.5 11.4-49.4 7.2C69.8 320.6 65 320 60 320c-33.1 0-60 26.9-60 60s26.9 60 60 60c6.3 0 12 5.7 12 12c0 33.1 26.9 60 60 60s60-26.9 60-60c0-5-.6-9.8-1.8-14.5c-4.2-16.9-5.2-37.1 7.2-49.4l26.8-26.8c6-6 14.1-9.4 22.6-9.4H336c6.3 0 12.4-.3 18.5-1c11.9-1.2 16.4-15.5 10.8-26c-8.5-15.8-13.3-33.8-13.3-53c0-61.9 50.1-112 112-112c8 0 15.7 .8 23.2 2.4c11.7 2.5 24.1-5.9 22-17.6C494.5 62.5 422.5 0 336 0C238.8 0 160 78.8 160 176v89.2z"
    ]
};
var $d8206b3ab2e65c05$export$273296afacf93991 = {
    prefix: "fas",
    iconName: "holly-berry",
    icon: [
        512,
        512,
        [],
        "f7aa",
        "M256 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-80 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM276.8 383.8c1 .1 2.1 .2 3.2 .2c39.8 0 72 32.2 72 72v22.7c0 16.4 16 27.9 31.6 22.8l12.8-4.3c18-6 37.3-6.5 55.6-1.5l19.4 5.3c17.9 4.9 34.4-11.6 29.5-29.5L495.6 452c-5-18.3-4.4-37.6 1.5-55.6l4.3-12.8c5.2-15.5-6.4-31.6-22.8-31.6c-34.6 0-62.7-28.1-62.7-62.7v-32c0-16.4-16-27.9-31.6-22.8l-12.8 4.3c-18 6-37.3 6.5-55.6 1.5l-29.6-8.1c-2.9-.8-5.9-1-8.7-.7c4.2 9.7 5.8 20.8 3.7 32.3L275 298.7c-1.5 8.4-1.4 17 .5 25.3l5.3 23.9c2.8 12.7 1.1 25.2-4 35.9zM127.6 234.5c-15.5-5.2-31.6 6.4-31.6 22.8v32C96 323.9 67.9 352 33.3 352c-16.4 0-27.9 16-22.8 31.6l4.3 12.8c6 18 6.5 37.3 1.5 55.6l-5.3 19.4C6.2 489.4 22.6 505.8 40.5 501L60 495.6c18.3-5 37.6-4.5 55.6 1.5l12.8 4.3c15.5 5.2 31.6-6.4 31.6-22.8v-32c0-34.6 28.1-62.7 62.7-62.7c16.4 0 27.9-16 22.8-31.6l-4.3-12.8c-6-18-6.5-37.3-1.5-55.6l5.3-19.4c4.9-17.9-11.6-34.4-29.5-29.5L196 240.4c-18.3 5-37.6 4.4-55.6-1.5l-12.8-4.3zM384 144a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"
    ]
};
var $d8206b3ab2e65c05$export$75702e3e3dd44a44 = {
    prefix: "fas",
    iconName: "chevron-left",
    icon: [
        320,
        512,
        [
            9001
        ],
        "f053",
        "M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z"
    ]
};
var $d8206b3ab2e65c05$export$7fc18cf2d526c341 = {
    prefix: "fas",
    iconName: "bacteria",
    icon: [
        640,
        512,
        [],
        "e059",
        "M304.9 .7c-9.6-2.7-19.5 2.8-22.3 12.4l-4.3 15.2c-8.3-.6-16.8 0-25.2 1.9c-7.3 1.7-14.3 3.5-21.1 5.5l-5.5-12.7c-3.9-9.1-14.5-13.4-23.6-9.5s-13.4 14.5-9.5 23.6l4.4 10.4c-16.6 6.7-31.7 14.4-45.4 22.8L147 62c-5.5-8.3-16.7-10.5-25-5s-10.5 16.7-5 25l6 9c-13.7 11-25.5 22.8-35.8 34.9l-10-8c-7.8-6.2-19.1-5-25.3 2.8s-5 19.1 2.8 25.3L65.9 155c-1.8 2.8-3.5 5.7-5.1 8.5c-6.6 11.4-11.8 22.6-16 33l-8-3.2c-9.2-3.7-19.7 .8-23.4 10s.8 19.7 10 23.4l10.4 4.2c-.2 .8-.4 1.5-.5 2.3c-2.2 9.3-3.4 17.3-4.1 23.4c-.4 3.1-.6 5.7-.8 7.8c-.1 1.1-.1 2-.2 2.8l-.1 1.1 0 .5 0 .2 0 .1c0 0 0 .1 29.1 1l-.1 0L28 269.3c-.1 3.1 0 6.1 .2 9.1l-15.2 4.3C3.5 285.4-2 295.4 .7 304.9s12.7 15.1 22.3 12.4l15.6-4.5c7.6 13.6 18.9 25 32.6 32.6L66.7 361c-2.7 9.6 2.8 19.5 12.4 22.3s19.5-2.8 22.3-12.4l4.3-15.2c1.2 .1 2.4 .2 3.6 .2c15.6 .5 30.3-3.3 43-10.2l9 9c7 7 18.4 7 25.5 0s7-18.4 0-25.5l-7.2-7.2c9.3-12.6 15.2-27.8 16.3-44.5l7.1 3c9.1 3.9 19.7-.3 23.6-9.5s-.3-19.7-9.5-23.6l-8.6-3.7c6.4-9.9 17.3-22.4 36.9-33.3l1.3 4.4c2.7 9.6 12.7 15.1 22.3 12.4s15.1-12.7 12.4-22.3l-2.3-8.1c3.8-1.1 7.7-2.1 11.9-3.1c11.6-2.7 22.1-7.7 31.1-14.4l7.2 7.2c7 7 18.4 7 25.5 0s7-18.4 0-25.5l-9-9c7.6-13.9 11.3-30.1 10.1-46.6l15.2-4.3c9.6-2.7 15.1-12.7 12.4-22.3S370.6 64 361 66.7l-15.6 4.5c-7.7-13.9-19.1-25.1-32.6-32.6l4.5-15.6c2.7-9.6-2.8-19.5-12.4-22.3zM112 272l-48-1.5 0 0c11.7 .4 27.3 .9 48 1.6zm16-80a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm64-48a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM322.7 489c-2.7 9.6 2.8 19.5 12.4 22.3s19.5-2.8 22.2-12.4l4.3-15.2c8.3 .6 16.8 0 25.2-1.9c7.3-1.7 14.3-3.5 21.1-5.5l5.5 12.7c3.9 9.1 14.5 13.4 23.6 9.5s13.4-14.5 9.5-23.6l-4.4-10.4c16.6-6.7 31.7-14.4 45.4-22.8L493 450c5.5 8.3 16.7 10.5 25 5s10.5-16.7 5-25l-6-9c13.7-11 25.5-22.8 35.8-34.9l10 8c7.8 6.2 19.1 5 25.3-2.8s5-19.1-2.8-25.3L574.1 357c1.8-2.8 3.5-5.7 5.1-8.5c6.6-11.4 11.8-22.6 16-33l8 3.2c9.2 3.7 19.7-.8 23.4-10s-.8-19.7-10-23.4l-10.4-4.2c.2-.8 .4-1.5 .5-2.3c2.2-9.3 3.4-17.3 4.1-23.4c.4-3.1 .6-5.7 .8-7.8c.1-1.1 .1-2 .2-2.8l.1-1.1 0-.5 0-.2 0-.1c0 0 0-.1-29.1-1l.1 0 29.1 .9c.1-3.1 0-6.1-.2-9.1l15.2-4.3c9.6-2.7 15.1-12.7 12.4-22.3s-12.7-15.1-22.3-12.4l-15.6 4.5c-7.6-13.6-18.9-25-32.6-32.6l4.5-15.6c2.7-9.6-2.8-19.5-12.4-22.3s-19.5 2.8-22.3 12.4l-4.3 15.2c-1.2-.1-2.4-.2-3.6-.2c-15.6-.5-30.3 3.3-43 10.2l-9-9c-7-7-18.4-7-25.5 0s-7 18.4 0 25.5l7.2 7.2c-9.3 12.6-15.2 27.8-16.3 44.5l-7.1-3c-9.1-3.9-19.7 .3-23.6 9.5s.3 19.7 9.5 23.6l8.6 3.7c-6.4 9.9-17.3 22.4-36.9 33.3l-1.3-4.4c-2.7-9.6-12.7-15.1-22.3-12.4s-15.1 12.7-12.4 22.3l2.3 8.1c-3.8 1.1-7.7 2.1-11.9 3.1c-11.6 2.7-22.1 7.7-31.1 14.4l-7.2-7.2c-7-7-18.4-7-25.5 0s-7 18.4 0 25.5l9 9c-7.6 13.9-11.3 30.1-10.1 46.6l-15.2 4.3c-9.6 2.7-15.1 12.7-12.4 22.2s12.7 15.1 22.3 12.4l15.6-4.5c7.7 13.9 19.1 25.1 32.6 32.6L322.7 489zM576 241.5l0 0c-11.7-.4-27.3-.9-48-1.6l48 1.5zM448 384a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z"
    ]
};
var $d8206b3ab2e65c05$export$54608d0a883fea4d = {
    prefix: "fas",
    iconName: "hand-lizard",
    icon: [
        512,
        512,
        [],
        "f258",
        "M0 112C0 85.5 21.5 64 48 64H160h80 46.5c36.8 0 71.2 18 92.1 48.2l113.5 164c13 18.7 19.9 41 19.9 63.8v12 16 48c0 17.7-14.3 32-32 32H384c-17.7 0-32-14.3-32-32V402.2L273.9 352H240 160 112c-26.5 0-48-21.5-48-48s21.5-48 48-48h48 80c26.5 0 48-21.5 48-48s-21.5-48-48-48H160 48c-26.5 0-48-21.5-48-48z"
    ]
};
var $d8206b3ab2e65c05$export$3db5bca65a1be8dc = {
    prefix: "fas",
    iconName: "notdef",
    icon: [
        384,
        512,
        [],
        "e1fe",
        "M64 390.3L153.5 256 64 121.7V390.3zM102.5 448H281.5L192 313.7 102.5 448zm128-192L320 390.3V121.7L230.5 256zM281.5 64H102.5L192 198.3 281.5 64zM0 48C0 21.5 21.5 0 48 0H336c26.5 0 48 21.5 48 48V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V48z"
    ]
};
var $d8206b3ab2e65c05$export$c7675a37487adc45 = {
    prefix: "fas",
    iconName: "disease",
    icon: [
        512,
        512,
        [],
        "f7fa",
        "M236.4 61.4L227 75.5c-21.3 32-59.4 48.5-97.3 42.1l-59.6-9.9C33.4 101.6 0 129.9 .1 167.1c0 15.9 6.4 31.2 17.6 42.5l29.2 29.2c11 11 17.2 25.9 17.2 41.5c0 15.8-6.4 30.9-17.7 42L33.3 335.1C22.2 345.9 16 360.7 16 376.2c0 36.8 34.1 64.2 70.1 56.2l62.3-13.8c7.7-1.7 15.7-2.6 23.6-2.6h10c27.2 0 53.7 9.3 75 26.3L287.8 467c10.5 8.4 23.6 13 37 13c32.7 0 59.3-26.5 59.3-59.3l0-25.2c0-34.9 21.4-66.2 53.9-78.8l36.9-14.3c22.4-8.7 37.2-30.3 37.2-54.3c0-28.1-20.1-52.3-47.8-57.3l-28-5.1c-36.5-6.7-65.4-34.5-73.6-70.7l-7.1-31.5C348.9 53.4 322.1 32 291.3 32c-22 0-42.6 11-54.9 29.4zM160 192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm0 80a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $d8206b3ab2e65c05$export$5000f52ca9819bf5 = {
    prefix: "fas",
    iconName: "briefcase-medical",
    icon: [
        512,
        512,
        [],
        "f469",
        "M184 48H328c4.4 0 8 3.6 8 8V96H176V56c0-4.4 3.6-8 8-8zm-56 8V96H64C28.7 96 0 124.7 0 160V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H384V56c0-30.9-25.1-56-56-56H184c-30.9 0-56 25.1-56 56zm96 152c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H288v48c0 8.8-7.2 16-16 16H240c-8.8 0-16-7.2-16-16V320H176c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16h48V208z"
    ]
};
var $d8206b3ab2e65c05$export$c093cc22e88981c2 = {
    prefix: "fas",
    iconName: "genderless",
    icon: [
        384,
        512,
        [],
        "f22d",
        "M192 144a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 288a176 176 0 1 0 0-352 176 176 0 1 0 0 352z"
    ]
};
var $d8206b3ab2e65c05$export$930de8c26eb20490 = {
    prefix: "fas",
    iconName: "chevron-right",
    icon: [
        320,
        512,
        [
            9002
        ],
        "f054",
        "M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"
    ]
};
var $d8206b3ab2e65c05$export$cebc76f79478e40e = {
    prefix: "fas",
    iconName: "retweet",
    icon: [
        576,
        512,
        [],
        "f079",
        "M272 416c17.7 0 32-14.3 32-32s-14.3-32-32-32H160c-17.7 0-32-14.3-32-32V192h32c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-64-64c-12.5-12.5-32.8-12.5-45.3 0l-64 64c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8l32 0 0 128c0 53 43 96 96 96H272zM304 96c-17.7 0-32 14.3-32 32s14.3 32 32 32l112 0c17.7 0 32 14.3 32 32l0 128H416c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l64 64c12.5 12.5 32.8 12.5 45.3 0l64-64c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8l-32 0V192c0-53-43-96-96-96L304 96z"
    ]
};
var $d8206b3ab2e65c05$export$ff2b8d5628da5f14 = {
    prefix: "fas",
    iconName: "car-rear",
    icon: [
        512,
        512,
        [
            "car-alt"
        ],
        "f5de",
        "M165.4 96H346.6c13.6 0 25.7 8.6 30.2 21.4L402.9 192H109.1l26.1-74.6c4.5-12.8 16.6-21.4 30.2-21.4zm-90.6 .3L39.6 196.8C16.4 206.4 0 229.3 0 256v80c0 23.7 12.9 44.4 32 55.4V448c0 17.7 14.3 32 32 32H96c17.7 0 32-14.3 32-32V400H384v48c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V391.4c19.1-11.1 32-31.7 32-55.4V256c0-26.7-16.4-49.6-39.6-59.2L437.2 96.3C423.7 57.8 387.4 32 346.6 32H165.4c-40.8 0-77.1 25.8-90.6 64.3zM208 272h96c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H208c-8.8 0-16-7.2-16-16V288c0-8.8 7.2-16 16-16zM48 280c0-13.3 10.7-24 24-24h32c13.3 0 24 10.7 24 24s-10.7 24-24 24H72c-13.3 0-24-10.7-24-24zm360-24h32c13.3 0 24 10.7 24 24s-10.7 24-24 24H408c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
    ]
};
var $d8206b3ab2e65c05$export$7937ed2462a665c0 = $d8206b3ab2e65c05$export$ff2b8d5628da5f14;
var $d8206b3ab2e65c05$export$821aeede187f23c9 = {
    prefix: "fas",
    iconName: "pump-soap",
    icon: [
        448,
        512,
        [],
        "e06b",
        "M128 32v96H256V96h60.1c4.2 0 8.3 1.7 11.3 4.7l33.9 33.9c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L372.7 55.4c-15-15-35.4-23.4-56.6-23.4H256c0-17.7-14.3-32-32-32H160c-17.7 0-32 14.3-32 32zM117.4 160c-33.3 0-61 25.5-63.8 58.7L35 442.7C31.9 480 61.3 512 98.8 512H285.2c37.4 0 66.9-32 63.8-69.3l-18.7-224c-2.8-33.2-30.5-58.7-63.8-58.7H117.4zM256 360c0 35.3-28.7 56-64 56s-64-20.7-64-56c0-32.5 37-80.9 50.9-97.9c3.2-3.9 8.1-6.1 13.1-6.1s9.9 2.2 13.1 6.1C219 279.1 256 327.5 256 360z"
    ]
};
var $d8206b3ab2e65c05$export$a714fc79f58cc9ef = {
    prefix: "fas",
    iconName: "video-slash",
    icon: [
        640,
        512,
        [],
        "f4e2",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-86.4-67.7 13.8 9.2c9.8 6.5 22.4 7.2 32.9 1.6s16.9-16.4 16.9-28.2V128c0-11.8-6.5-22.6-16.9-28.2s-23-5-32.9 1.6l-96 64L448 174.9V192 320v5.8l-32-25.1V128c0-35.3-28.7-64-64-64H113.9L38.8 5.1zM407 416.7L32.3 121.5c-.2 2.1-.3 4.3-.3 6.5V384c0 35.3 28.7 64 64 64H352c23.4 0 43.9-12.6 55-31.3z"
    ]
};
var $d8206b3ab2e65c05$export$acec92052ac2183 = {
    prefix: "fas",
    iconName: "battery-quarter",
    icon: [
        576,
        512,
        [
            "battery-2"
        ],
        "f243",
        "M464 160c8.8 0 16 7.2 16 16V336c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16H464zM80 96C35.8 96 0 131.8 0 176V336c0 44.2 35.8 80 80 80H464c44.2 0 80-35.8 80-80V320c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32V176c0-44.2-35.8-80-80-80H80zm112 96H96V320h96V192z"
    ]
};
var $d8206b3ab2e65c05$export$23ca8a94c555576 = $d8206b3ab2e65c05$export$acec92052ac2183;
var $d8206b3ab2e65c05$export$11b26516cae2104f = {
    prefix: "fas",
    iconName: "radio",
    icon: [
        512,
        512,
        [
            128251
        ],
        "f8d7",
        "M494.8 47c12.7-3.7 20-17.1 16.3-29.8S494-2.8 481.2 1L51.7 126.9c-9.4 2.7-17.9 7.3-25.1 13.2C10.5 151.7 0 170.6 0 192v4V304 448c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V192c0-35.3-28.7-64-64-64H218.5L494.8 47zM368 240a80 80 0 1 1 0 160 80 80 0 1 1 0-160zM80 256c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H96c-8.8 0-16-7.2-16-16zM64 320c0-8.8 7.2-16 16-16H208c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm16 64c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H96c-8.8 0-16-7.2-16-16z"
    ]
};
var $d8206b3ab2e65c05$export$3b3ab4d86bad7d26 = {
    prefix: "fas",
    iconName: "baby-carriage",
    icon: [
        512,
        512,
        [
            "carriage-baby"
        ],
        "f77d",
        "M256 192H.1C2.7 117.9 41.3 52.9 99 14.1c13.3-8.9 30.8-4.3 39.9 8.8L256 192zm128-32c0-35.3 28.7-64 64-64h32c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0v64c0 25.2-5.8 50.2-17 73.5s-27.8 44.5-48.6 62.3s-45.5 32-72.7 41.6S253.4 416 224 416s-58.5-5-85.7-14.6s-51.9-23.8-72.7-41.6s-37.3-39-48.6-62.3S0 249.2 0 224l224 0 160 0V160zM80 416a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm240 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z"
    ]
};
var $d8206b3ab2e65c05$export$9f117d92ccd36cf1 = $d8206b3ab2e65c05$export$3b3ab4d86bad7d26;
var $d8206b3ab2e65c05$export$bf0b19daceaec9c2 = {
    prefix: "fas",
    iconName: "traffic-light",
    icon: [
        320,
        512,
        [
            128678
        ],
        "f637",
        "M64 0C28.7 0 0 28.7 0 64V352c0 88.4 71.6 160 160 160s160-71.6 160-160V64c0-35.3-28.7-64-64-64H64zm96 416a48 48 0 1 1 0-96 48 48 0 1 1 0 96zm48-176a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zm-48-80a48 48 0 1 1 0-96 48 48 0 1 1 0 96z"
    ]
};
var $d8206b3ab2e65c05$export$f576739e9b18ea4f = {
    prefix: "fas",
    iconName: "thermometer",
    icon: [
        512,
        512,
        [],
        "f491",
        "M96 382.1V293.3c0-14.9 5.9-29.1 16.4-39.6l27.3-27.3 57 57c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-57-57 41.4-41.4 57 57c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-57-57 41.4-41.4 57 57c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-57-57 45.5-45.5C355.2 10.9 381.4 0 408.8 0C465.8 0 512 46.2 512 103.2c0 27.4-10.9 53.6-30.2 73L258.3 399.6c-10.5 10.5-24.7 16.4-39.6 16.4H129.9L41 505c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l89-89z"
    ]
};
var $d8206b3ab2e65c05$export$248171cb6dad4307 = {
    prefix: "fas",
    iconName: "vr-cardboard",
    icon: [
        640,
        512,
        [],
        "f729",
        "M576 64H64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H184.4c24.2 0 46.4-13.7 57.2-35.4l32-64c8.8-17.5 26.7-28.6 46.3-28.6s37.5 11.1 46.3 28.6l32 64c10.8 21.7 33 35.4 57.2 35.4H576c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64zM96 240a64 64 0 1 1 128 0A64 64 0 1 1 96 240zm384-64a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"
    ]
};
var $d8206b3ab2e65c05$export$bd40d3a3a16fb147 = {
    prefix: "fas",
    iconName: "hand-middle-finger",
    icon: [
        448,
        512,
        [
            128405
        ],
        "f806",
        "M232 0c-22.1 0-40 17.9-40 40V204.2c-8.5-7.6-19.7-12.2-32-12.2c-26.5 0-48 21.5-48 48v7 73c0 8.8-7.2 16-16 16s-16-7.2-16-16V264.3c-2 1.4-3.9 3-5.8 4.5L55 284.8C40.4 297 32 315 32 334V372c0 38 16.9 74 46.1 98.3l5.4 4.5c28.8 24 65 37.1 102.4 37.1H304c70.7 0 128-57.3 128-128V320 288c0-26.5-21.5-48-48-48c-12.4 0-23.6 4.7-32.1 12.3C350 227.5 329.3 208 304 208c-12.3 0-23.5 4.6-32 12.2V40c0-22.1-17.9-40-40-40z"
    ]
};
var $d8206b3ab2e65c05$export$89a1764fbb7ad2cb = {
    prefix: "fas",
    iconName: "percent",
    icon: [
        384,
        512,
        [
            62101,
            62785,
            "percentage"
        ],
        "25",
        "M374.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-320 320c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l320-320zM128 128A64 64 0 1 0 0 128a64 64 0 1 0 128 0zM384 384a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z"
    ]
};
var $d8206b3ab2e65c05$export$89333857fc063a2e = $d8206b3ab2e65c05$export$89a1764fbb7ad2cb;
var $d8206b3ab2e65c05$export$a06617a1a4ccea67 = {
    prefix: "fas",
    iconName: "truck-moving",
    icon: [
        640,
        512,
        [],
        "f4df",
        "M64 32C28.7 32 0 60.7 0 96V304v80 16c0 44.2 35.8 80 80 80c26.2 0 49.4-12.6 64-32c14.6 19.4 37.8 32 64 32c44.2 0 80-35.8 80-80c0-5.5-.6-10.8-1.6-16H416h33.6c-1 5.2-1.6 10.5-1.6 16c0 44.2 35.8 80 80 80s80-35.8 80-80c0-5.5-.6-10.8-1.6-16H608c17.7 0 32-14.3 32-32V288 272 261.7c0-9.2-3.2-18.2-9-25.3l-58.8-71.8c-10.6-13-26.5-20.5-43.3-20.5H480V96c0-35.3-28.7-64-64-64H64zM585 256H480V192h48.8c2.4 0 4.7 1.1 6.2 2.9L585 256zM528 368a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM176 400a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM80 368a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $d8206b3ab2e65c05$export$b7ae54b4078b2060 = {
    prefix: "fas",
    iconName: "glass-water-droplet",
    icon: [
        384,
        512,
        [],
        "e4f5",
        "M32 0C23.1 0 14.6 3.7 8.6 10.2S-.6 25.4 .1 34.3L28.9 437.7c3 41.9 37.8 74.3 79.8 74.3H275.3c42 0 76.8-32.4 79.8-74.3L383.9 34.3c.6-8.9-2.4-17.6-8.5-24.1S360.9 0 352 0H32zM83 297.5L66.4 64H317.6L301 297.5 288 304c-20.1 10.1-43.9 10.1-64 0s-43.9-10.1-64 0s-43.9 10.1-64 0l-13-6.5zM256 196c0-24-33.7-70.1-52.2-93.5c-6.1-7.7-17.5-7.7-23.6 0C161.7 125.9 128 172 128 196c0 33.1 28.7 60 64 60s64-26.9 64-60z"
    ]
};
var $d8206b3ab2e65c05$export$e9d85839f7751f01 = {
    prefix: "fas",
    iconName: "display",
    icon: [
        576,
        512,
        [],
        "e163",
        "M64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64H240l-10.7 32H160c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H346.7L336 416H512c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM512 64V352H64V64H512z"
    ]
};
var $d8206b3ab2e65c05$export$b5023c446f10324 = {
    prefix: "fas",
    iconName: "face-smile",
    icon: [
        512,
        512,
        [
            128578,
            "smile"
        ],
        "f118",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM164.1 325.5C182 346.2 212.6 368 256 368s74-21.8 91.9-42.5c5.8-6.7 15.9-7.4 22.6-1.6s7.4 15.9 1.6 22.6C349.8 372.1 311.1 400 256 400s-93.8-27.9-116.1-53.5c-5.8-6.7-5.1-16.8 1.6-22.6s16.8-5.1 22.6 1.6zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $d8206b3ab2e65c05$export$c632b2334f0913bc = $d8206b3ab2e65c05$export$b5023c446f10324;
var $d8206b3ab2e65c05$export$b6314cdc01bb5c43 = {
    prefix: "fas",
    iconName: "thumbtack",
    icon: [
        384,
        512,
        [
            128204,
            128392,
            "thumb-tack"
        ],
        "f08d",
        "M32 32C32 14.3 46.3 0 64 0H320c17.7 0 32 14.3 32 32s-14.3 32-32 32H290.5l11.4 148.2c36.7 19.9 65.7 53.2 79.5 94.7l1 3c3.3 9.8 1.6 20.5-4.4 28.8s-15.7 13.3-26 13.3H32c-10.3 0-19.9-4.9-26-13.3s-7.7-19.1-4.4-28.8l1-3c13.8-41.5 42.8-74.8 79.5-94.7L93.5 64H64C46.3 64 32 49.7 32 32zM160 384h64v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V384z"
    ]
};
var $d8206b3ab2e65c05$export$b63d0c7b519a9aae = $d8206b3ab2e65c05$export$b6314cdc01bb5c43;
var $d8206b3ab2e65c05$export$29c432d69ccf85a5 = {
    prefix: "fas",
    iconName: "trophy",
    icon: [
        576,
        512,
        [
            127942
        ],
        "f091",
        "M400 0H176c-26.5 0-48.1 21.8-47.1 48.2c.2 5.3 .4 10.6 .7 15.8H24C10.7 64 0 74.7 0 88c0 92.6 33.5 157 78.5 200.7c44.3 43.1 98.3 64.8 138.1 75.8c23.4 6.5 39.4 26 39.4 45.6c0 20.9-17 37.9-37.9 37.9H192c-17.7 0-32 14.3-32 32s14.3 32 32 32H384c17.7 0 32-14.3 32-32s-14.3-32-32-32H357.9C337 448 320 431 320 410.1c0-19.6 15.9-39.2 39.4-45.6c39.9-11 93.9-32.7 138.2-75.8C542.5 245 576 180.6 576 88c0-13.3-10.7-24-24-24H446.4c.3-5.2 .5-10.4 .7-15.8C448.1 21.8 426.5 0 400 0zM48.9 112h84.4c9.1 90.1 29.2 150.3 51.9 190.6c-24.9-11-50.8-26.5-73.2-48.3c-32-31.1-58-76-63-142.3zM464.1 254.3c-22.4 21.8-48.3 37.3-73.2 48.3c22.7-40.3 42.8-100.5 51.9-190.6h84.4c-5.1 66.3-31.1 111.2-63 142.3z"
    ]
};
var $d8206b3ab2e65c05$export$8ecd436ef91fc02e = {
    prefix: "fas",
    iconName: "person-praying",
    icon: [
        448,
        512,
        [
            128720,
            "pray"
        ],
        "f683",
        "M352 64A64 64 0 1 0 224 64a64 64 0 1 0 128 0zM232.7 264l22.9 31.5c6.5 8.9 16.3 14.7 27.2 16.1s21.9-1.7 30.4-8.7l88-72c17.1-14 19.6-39.2 5.6-56.3s-39.2-19.6-56.3-5.6l-55.2 45.2-26.2-36C253.6 156.7 228.6 144 202 144c-30.9 0-59.2 17.1-73.6 44.4L79.8 280.9c-20.2 38.5-9.4 85.9 25.6 111.8L158.6 432H72c-22.1 0-40 17.9-40 40s17.9 40 40 40H280c17.3 0 32.6-11.1 38-27.5s-.3-34.4-14.2-44.7L187.7 354l45-90z"
    ]
};
var $d8206b3ab2e65c05$export$3b32c982141cad51 = $d8206b3ab2e65c05$export$8ecd436ef91fc02e;
var $d8206b3ab2e65c05$export$6310f315e1ebbca5 = {
    prefix: "fas",
    iconName: "hammer",
    icon: [
        576,
        512,
        [
            128296
        ],
        "f6e3",
        "M413.5 237.5c-28.2 4.8-58.2-3.6-80-25.4l-38.1-38.1C280.4 159 272 138.8 272 117.6V105.5L192.3 62c-5.3-2.9-8.6-8.6-8.3-14.7s3.9-11.5 9.5-14l47.2-21C259.1 4.2 279 0 299.2 0h18.1c36.7 0 72 14 98.7 39.1l44.6 42c24.2 22.8 33.2 55.7 26.6 86L503 183l8-8c9.4-9.4 24.6-9.4 33.9 0l24 24c9.4 9.4 9.4 24.6 0 33.9l-88 88c-9.4 9.4-24.6 9.4-33.9 0l-24-24c-9.4-9.4-9.4-24.6 0-33.9l8-8-17.5-17.5zM27.4 377.1L260.9 182.6c3.5 4.9 7.5 9.6 11.8 14l38.1 38.1c6 6 12.4 11.2 19.2 15.7L134.9 484.6c-14.5 17.4-36 27.4-58.6 27.4C34.1 512 0 477.8 0 435.7c0-22.6 10.1-44.1 27.4-58.6z"
    ]
};
var $d8206b3ab2e65c05$export$e49e3cfceea441cc = {
    prefix: "fas",
    iconName: "hand-peace",
    icon: [
        512,
        512,
        [
            9996
        ],
        "f25b",
        "M224 0c17.7 0 32 14.3 32 32V240H192V32c0-17.7 14.3-32 32-32zm96 160c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V192c0-17.7 14.3-32 32-32zm64 64c0-17.7 14.3-32 32-32s32 14.3 32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V224zM93.3 51.2L175.9 240H106.1L34.7 76.8C27.6 60.6 35 41.8 51.2 34.7s35.1 .3 42.1 16.5zm27 221.3l-.2-.5h69.9H216c22.1 0 40 17.9 40 40s-17.9 40-40 40H160c-8.8 0-16 7.2-16 16s7.2 16 16 16h56c39.8 0 72-32.2 72-72l0-.6c9.4 5.4 20.3 8.6 32 8.6c13.2 0 25.4-4 35.6-10.8c8.7 24.9 32.5 42.8 60.4 42.8c11.7 0 22.6-3.1 32-8.6V352c0 88.4-71.6 160-160 160H226.3c-42.4 0-83.1-16.9-113.1-46.9l-11.6-11.6C77.5 429.5 64 396.9 64 363V336c0-32.7 24.6-59.7 56.3-63.5z"
    ]
};
var $d8206b3ab2e65c05$export$decde496a29c5b23 = {
    prefix: "fas",
    iconName: "rotate",
    icon: [
        512,
        512,
        [
            128260,
            "sync-alt"
        ],
        "f2f1",
        "M142.9 142.9c62.2-62.2 162.7-62.5 225.3-1L327 183c-6.9 6.9-8.9 17.2-5.2 26.2s12.5 14.8 22.2 14.8H463.5c0 0 0 0 0 0H472c13.3 0 24-10.7 24-24V72c0-9.7-5.8-18.5-14.8-22.2s-19.3-1.7-26.2 5.2L413.4 96.6c-87.6-86.5-228.7-86.2-315.8 1C73.2 122 55.6 150.7 44.8 181.4c-5.9 16.7 2.9 34.9 19.5 40.8s34.9-2.9 40.8-19.5c7.7-21.8 20.2-42.3 37.8-59.8zM16 312v7.6 .7V440c0 9.7 5.8 18.5 14.8 22.2s19.3 1.7 26.2-5.2l41.6-41.6c87.6 86.5 228.7 86.2 315.8-1c24.4-24.4 42.1-53.1 52.9-83.7c5.9-16.7-2.9-34.9-19.5-40.8s-34.9 2.9-40.8 19.5c-7.7 21.8-20.2 42.3-37.8 59.8c-62.2 62.2-162.7 62.5-225.3 1L185 329c6.9-6.9 8.9-17.2 5.2-26.2s-12.5-14.8-22.2-14.8H48.4h-.7H40c-13.3 0-24 10.7-24 24z"
    ]
};
var $d8206b3ab2e65c05$export$2ff2056be8c281e4 = $d8206b3ab2e65c05$export$decde496a29c5b23;
var $d8206b3ab2e65c05$export$1025ad641edb49c2 = {
    prefix: "fas",
    iconName: "spinner",
    icon: [
        512,
        512,
        [],
        "f110",
        "M304 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm0 416a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM48 304a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm464-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM142.9 437A48 48 0 1 0 75 369.1 48 48 0 1 0 142.9 437zm0-294.2A48 48 0 1 0 75 75a48 48 0 1 0 67.9 67.9zM369.1 437A48 48 0 1 0 437 369.1 48 48 0 1 0 369.1 437z"
    ]
};
var $d8206b3ab2e65c05$export$30a5bb4ad3fa716c = {
    prefix: "fas",
    iconName: "robot",
    icon: [
        640,
        512,
        [
            129302
        ],
        "f544",
        "M320 0c17.7 0 32 14.3 32 32V96H472c39.8 0 72 32.2 72 72V440c0 39.8-32.2 72-72 72H168c-39.8 0-72-32.2-72-72V168c0-39.8 32.2-72 72-72H288V32c0-17.7 14.3-32 32-32zM208 384c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H208zm96 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H304zm96 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H400zM264 256a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zm152 40a40 40 0 1 0 0-80 40 40 0 1 0 0 80zM48 224H64V416H48c-26.5 0-48-21.5-48-48V272c0-26.5 21.5-48 48-48zm544 0c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H576V224h16z"
    ]
};
var $d8206b3ab2e65c05$export$8614cb1326eacd7a = {
    prefix: "fas",
    iconName: "peace",
    icon: [
        512,
        512,
        [
            9774
        ],
        "f67c",
        "M224 445.3V323.5l-94.3 77.1c26.1 22.8 58.5 38.7 94.3 44.7zM89.2 351.1L224 240.8V66.7C133.2 81.9 64 160.9 64 256c0 34.6 9.2 67.1 25.2 95.1zm293.1 49.5L288 323.5V445.3c35.7-6 68.1-21.9 94.3-44.7zm40.6-49.5c16-28 25.2-60.5 25.2-95.1c0-95.1-69.2-174.1-160-189.3V240.8L422.8 351.1zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"
    ]
};
var $d8206b3ab2e65c05$export$4aac79b9ae3cfdb8 = {
    prefix: "fas",
    iconName: "gears",
    icon: [
        640,
        512,
        [
            "cogs"
        ],
        "f085",
        "M308.5 135.3c7.1-6.3 9.9-16.2 6.2-25c-2.3-5.3-4.8-10.5-7.6-15.5L304 89.4c-3-5-6.3-9.9-9.8-14.6c-5.7-7.6-15.7-10.1-24.7-7.1l-28.2 9.3c-10.7-8.8-23-16-36.2-20.9L199 27.1c-1.9-9.3-9.1-16.7-18.5-17.8C173.9 8.4 167.2 8 160.4 8h-.7c-6.8 0-13.5 .4-20.1 1.2c-9.4 1.1-16.6 8.6-18.5 17.8L115 56.1c-13.3 5-25.5 12.1-36.2 20.9L50.5 67.8c-9-3-19-.5-24.7 7.1c-3.5 4.7-6.8 9.6-9.9 14.6l-3 5.3c-2.8 5-5.3 10.2-7.6 15.6c-3.7 8.7-.9 18.6 6.2 25l22.2 19.8C32.6 161.9 32 168.9 32 176s.6 14.1 1.7 20.9L11.5 216.7c-7.1 6.3-9.9 16.2-6.2 25c2.3 5.3 4.8 10.5 7.6 15.6l3 5.2c3 5.1 6.3 9.9 9.9 14.6c5.7 7.6 15.7 10.1 24.7 7.1l28.2-9.3c10.7 8.8 23 16 36.2 20.9l6.1 29.1c1.9 9.3 9.1 16.7 18.5 17.8c6.7 .8 13.5 1.2 20.4 1.2s13.7-.4 20.4-1.2c9.4-1.1 16.6-8.6 18.5-17.8l6.1-29.1c13.3-5 25.5-12.1 36.2-20.9l28.2 9.3c9 3 19 .5 24.7-7.1c3.5-4.7 6.8-9.5 9.8-14.6l3.1-5.4c2.8-5 5.3-10.2 7.6-15.5c3.7-8.7 .9-18.6-6.2-25l-22.2-19.8c1.1-6.8 1.7-13.8 1.7-20.9s-.6-14.1-1.7-20.9l22.2-19.8zM112 176a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM504.7 500.5c6.3 7.1 16.2 9.9 25 6.2c5.3-2.3 10.5-4.8 15.5-7.6l5.4-3.1c5-3 9.9-6.3 14.6-9.8c7.6-5.7 10.1-15.7 7.1-24.7l-9.3-28.2c8.8-10.7 16-23 20.9-36.2l29.1-6.1c9.3-1.9 16.7-9.1 17.8-18.5c.8-6.7 1.2-13.5 1.2-20.4s-.4-13.7-1.2-20.4c-1.1-9.4-8.6-16.6-17.8-18.5L583.9 307c-5-13.3-12.1-25.5-20.9-36.2l9.3-28.2c3-9 .5-19-7.1-24.7c-4.7-3.5-9.6-6.8-14.6-9.9l-5.3-3c-5-2.8-10.2-5.3-15.6-7.6c-8.7-3.7-18.6-.9-25 6.2l-19.8 22.2c-6.8-1.1-13.8-1.7-20.9-1.7s-14.1 .6-20.9 1.7l-19.8-22.2c-6.3-7.1-16.2-9.9-25-6.2c-5.3 2.3-10.5 4.8-15.6 7.6l-5.2 3c-5.1 3-9.9 6.3-14.6 9.9c-7.6 5.7-10.1 15.7-7.1 24.7l9.3 28.2c-8.8 10.7-16 23-20.9 36.2L315.1 313c-9.3 1.9-16.7 9.1-17.8 18.5c-.8 6.7-1.2 13.5-1.2 20.4s.4 13.7 1.2 20.4c1.1 9.4 8.6 16.6 17.8 18.5l29.1 6.1c5 13.3 12.1 25.5 20.9 36.2l-9.3 28.2c-3 9-.5 19 7.1 24.7c4.7 3.5 9.5 6.8 14.6 9.8l5.4 3.1c5 2.8 10.2 5.3 15.5 7.6c8.7 3.7 18.6 .9 25-6.2l19.8-22.2c6.8 1.1 13.8 1.7 20.9 1.7s14.1-.6 20.9-1.7l19.8 22.2zM464 304a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
    ]
};
var $d8206b3ab2e65c05$export$af1575770afc9559 = $d8206b3ab2e65c05$export$4aac79b9ae3cfdb8;
var $d8206b3ab2e65c05$export$e3a174a50618c208 = {
    prefix: "fas",
    iconName: "warehouse",
    icon: [
        640,
        512,
        [],
        "f494",
        "M0 488V171.3c0-26.2 15.9-49.7 40.2-59.4L308.1 4.8c7.6-3.1 16.1-3.1 23.8 0L599.8 111.9c24.3 9.7 40.2 33.3 40.2 59.4V488c0 13.3-10.7 24-24 24H568c-13.3 0-24-10.7-24-24V224c0-17.7-14.3-32-32-32H128c-17.7 0-32 14.3-32 32V488c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24zm488 24l-336 0c-13.3 0-24-10.7-24-24V432H512l0 56c0 13.3-10.7 24-24 24zM128 400V336H512v64H128zm0-96V224H512l0 80H128z"
    ]
};
var $d8206b3ab2e65c05$export$bc804c6ab898f610 = {
    prefix: "fas",
    iconName: "arrow-up-right-dots",
    icon: [
        576,
        512,
        [],
        "e4b7",
        "M160 0c-17.7 0-32 14.3-32 32s14.3 32 32 32h50.7L9.4 265.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L256 109.3V160c0 17.7 14.3 32 32 32s32-14.3 32-32V32c0-17.7-14.3-32-32-32H160zM576 80a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM448 208a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM400 384a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm48 80a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm128 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM272 384a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm48 80a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM144 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM576 336a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-48-80a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"
    ]
};
var $d8206b3ab2e65c05$export$d6f21e17ea797702 = {
    prefix: "fas",
    iconName: "splotch",
    icon: [
        512,
        512,
        [],
        "f5bc",
        "M208.5 62.3l28.1-36.9C248.8 9.4 267.8 0 288 0c28.5 0 53.6 18.7 61.8 46l17.8 59.4c10.3 34.4 36.1 62 69.8 74.6l39.8 14.9c20.9 7.9 34.8 27.9 34.8 50.2c0 16.9-7.9 32.8-21.5 42.9l-67.3 50.5c-24.3 18.2-37.2 47.9-33.8 78.1l2.5 22.7c4.3 38.7-26 72.6-65 72.6c-14.8 0-29.3-5.1-40.8-14.3l-55.4-44.3c-4.5-3.6-9.3-6.7-14.5-9.2c-15.8-7.9-33.7-10.4-51-7.3L82.4 451.9C47.8 458.2 16 431.6 16 396.5c0-13.2 4.7-26 13.1-36.2l11.2-13.4c14.6-17.4 22.6-39.4 22.6-62.1c0-18.8-5.5-37.2-15.8-53L8.8 173.5C3.1 164.7 0 154.4 0 143.9c0-33.4 30.1-58.8 63-53.2l51.3 8.7c35.9 6.1 72.2-8.2 94.2-37.1z"
    ]
};
var $d8206b3ab2e65c05$export$fbb22081b65e4f33 = {
    prefix: "fas",
    iconName: "face-grin-hearts",
    icon: [
        512,
        512,
        [
            128525,
            "grin-hearts"
        ],
        "f584",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM388.1 312.8c12.3-3.8 24.3 6.9 19.3 18.7C382.4 390.6 324.2 432 256.3 432s-126.2-41.4-151.1-100.5c-5-11.8 7-22.5 19.3-18.7c39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19zM199.3 129.1c17.8 4.8 28.4 23.1 23.6 40.8l-17.4 65c-2.3 8.5-11.1 13.6-19.6 11.3l-65.1-17.4c-17.8-4.8-28.4-23.1-23.6-40.8s23.1-28.4 40.8-23.6l16.1 4.3 4.3-16.1c4.8-17.8 23.1-28.4 40.8-23.6zm154.3 23.6l4.3 16.1 16.1-4.3c17.8-4.8 36.1 5.8 40.8 23.6s-5.8 36.1-23.6 40.8l-65.1 17.4c-8.5 2.3-17.3-2.8-19.6-11.3l-17.4-65c-4.8-17.8 5.8-36.1 23.6-40.8s36.1 5.8 40.9 23.6z"
    ]
};
var $d8206b3ab2e65c05$export$c56cf0e0c3bc5ed2 = $d8206b3ab2e65c05$export$fbb22081b65e4f33;
var $d8206b3ab2e65c05$export$2df6451abf70a6ff = {
    prefix: "fas",
    iconName: "dice-four",
    icon: [
        448,
        512,
        [
            9859
        ],
        "f524",
        "M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm160 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM128 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM352 160a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM320 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
var $d8206b3ab2e65c05$export$3bee83bf278fddbe = {
    prefix: "fas",
    iconName: "sim-card",
    icon: [
        384,
        512,
        [],
        "f7c4",
        "M64 0H242.7c17 0 33.3 6.7 45.3 18.7L365.3 96c12 12 18.7 28.3 18.7 45.3V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0zM96 192c-17.7 0-32 14.3-32 32v32h64V192H96zM64 352h80 96 80V288H240 144 64v64zM320 224c0-17.7-14.3-32-32-32H256v64h64V224zM160 192v64h64V192H160zM288 448c17.7 0 32-14.3 32-32V384H256v64h32zM160 384v64h64V384H160zM64 416c0 17.7 14.3 32 32 32h32V384H64v32z"
    ]
};
var $d8206b3ab2e65c05$export$7e3f1701aa95ef01 = {
    prefix: "fas",
    iconName: "transgender",
    icon: [
        512,
        512,
        [
            9895,
            "transgender-alt"
        ],
        "f225",
        "M112 0c6.5 0 12.3 3.9 14.8 9.9s1.1 12.9-3.5 17.4l-31 31L112 78.1l7-7c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-7 7 15.2 15.2C187.7 107.6 220.5 96 256 96s68.3 11.6 94.9 31.2l68.8-68.8-31-31c-4.6-4.6-5.9-11.5-3.5-17.4s8.3-9.9 14.8-9.9h96c8.8 0 16 7.2 16 16v96c0 6.5-3.9 12.3-9.9 14.8s-12.9 1.1-17.4-3.5l-31-31-68.8 68.8C404.4 187.7 416 220.5 416 256c0 80.2-59 146.6-136 158.2V432h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H280v8c0 13.3-10.7 24-24 24s-24-10.7-24-24v-8H216c-13.3 0-24-10.7-24-24s10.7-24 24-24h16V414.2C155 402.6 96 336.2 96 256c0-35.5 11.6-68.3 31.2-94.9L112 145.9l-7 7c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l7-7L58.3 92.3l-31 31c-4.6 4.6-11.5 5.9-17.4 3.5S0 118.5 0 112V16C0 7.2 7.2 0 16 0h96zM352 256a96 96 0 1 0 -192 0 96 96 0 1 0 192 0z"
    ]
};
var $d8206b3ab2e65c05$export$9c36cf9334c052f = $d8206b3ab2e65c05$export$7e3f1701aa95ef01;
var $d8206b3ab2e65c05$export$e134ecd00b622a47 = {
    prefix: "fas",
    iconName: "mercury",
    icon: [
        384,
        512,
        [
            9791
        ],
        "f223",
        "M72.1 7C85.8-4 106-1.8 117 12c17.6 22 44.7 36 75 36s57.3-14 75-36c11.1-13.8 31.2-16 45-5s16 31.2 5 45c-7.8 9.7-16.6 18.4-26.4 26.1C337.3 109.7 368 163.3 368 224c0 89.1-66.2 162.7-152 174.4V424h32c13.3 0 24 10.7 24 24s-10.7 24-24 24H216v16c0 13.3-10.7 24-24 24s-24-10.7-24-24V472H136c-13.3 0-24-10.7-24-24s10.7-24 24-24h32V398.4C82.2 386.7 16 313.1 16 224c0-60.7 30.7-114.3 77.5-145.9C83.7 70.5 74.9 61.7 67.1 52c-11.1-13.8-8.8-33.9 5-45zM80 224a112 112 0 1 0 224 0A112 112 0 1 0 80 224z"
    ]
};
var $d8206b3ab2e65c05$export$fd4d6cfd52703f50 = {
    prefix: "fas",
    iconName: "arrow-turn-down",
    icon: [
        384,
        512,
        [
            "level-down"
        ],
        "f149",
        "M32 64C14.3 64 0 49.7 0 32S14.3 0 32 0l96 0c53 0 96 43 96 96l0 306.7 73.4-73.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-128 128c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 402.7 160 96c0-17.7-14.3-32-32-32L32 64z"
    ]
};
var $d8206b3ab2e65c05$export$3794c07e7a666c94 = $d8206b3ab2e65c05$export$fd4d6cfd52703f50;
var $d8206b3ab2e65c05$export$a75569baaf4a6c3a = {
    prefix: "fas",
    iconName: "person-falling-burst",
    icon: [
        640,
        512,
        [],
        "e547",
        "M256 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 9.8c0 39-23.7 74-59.9 88.4C71.6 154.5 32 213 32 278.2V352c0 17.7 14.3 32 32 32s32-14.3 32-32l0-73.8c0-10 1.6-19.8 4.5-29L261.1 497.4c9.6 14.8 29.4 19.1 44.3 9.5s19.1-29.4 9.5-44.3L222.6 320H224l80 0 38.4 51.2c10.6 14.1 30.7 17 44.8 6.4s17-30.7 6.4-44.8l-43.2-57.6C341.3 263.1 327.1 256 312 256l-71.5 0-56.8-80.2-.2-.3c44.7-29 72.5-79 72.5-133.6l0-9.8zM96 80A48 48 0 1 0 0 80a48 48 0 1 0 96 0zM464 286.1l58.6 53.9c4.8 4.4 11.9 5.5 17.8 2.6s9.5-9 9-15.5l-5.6-79.4 78.7-12.2c6.5-1 11.7-5.9 13.1-12.2s-1.1-13-6.5-16.7l-65.6-45.1L603 92.2c3.3-5.7 2.7-12.8-1.4-17.9s-10.9-7.2-17.2-5.3L508.3 92.1l-29.4-74C476.4 12 470.6 8 464 8s-12.4 4-14.9 10.1l-29.4 74L343.6 68.9c-6.3-1.9-13.1 .2-17.2 5.3s-4.6 12.2-1.4 17.9l39.5 69.1-65.6 45.1c-5.4 3.7-8 10.3-6.5 16.7c.1 .3 .1 .6 .2 .8l19.4 0c20.1 0 39.2 7.5 53.8 20.8l18.4 2.9L383 265.3l36.2 48.3c2.1 2.8 3.9 5.7 5.5 8.6L464 286.1z"
    ]
};
var $d8206b3ab2e65c05$export$f8db2747dadd48f7 = {
    prefix: "fas",
    iconName: "award",
    icon: [
        384,
        512,
        [],
        "f559",
        "M173.8 5.5c11-7.3 25.4-7.3 36.4 0L228 17.2c6 3.9 13 5.8 20.1 5.4l21.3-1.3c13.2-.8 25.6 6.4 31.5 18.2l9.6 19.1c3.2 6.4 8.4 11.5 14.7 14.7L344.5 83c11.8 5.9 19 18.3 18.2 31.5l-1.3 21.3c-.4 7.1 1.5 14.2 5.4 20.1l11.8 17.8c7.3 11 7.3 25.4 0 36.4L366.8 228c-3.9 6-5.8 13-5.4 20.1l1.3 21.3c.8 13.2-6.4 25.6-18.2 31.5l-19.1 9.6c-6.4 3.2-11.5 8.4-14.7 14.7L301 344.5c-5.9 11.8-18.3 19-31.5 18.2l-21.3-1.3c-7.1-.4-14.2 1.5-20.1 5.4l-17.8 11.8c-11 7.3-25.4 7.3-36.4 0L156 366.8c-6-3.9-13-5.8-20.1-5.4l-21.3 1.3c-13.2 .8-25.6-6.4-31.5-18.2l-9.6-19.1c-3.2-6.4-8.4-11.5-14.7-14.7L39.5 301c-11.8-5.9-19-18.3-18.2-31.5l1.3-21.3c.4-7.1-1.5-14.2-5.4-20.1L5.5 210.2c-7.3-11-7.3-25.4 0-36.4L17.2 156c3.9-6 5.8-13 5.4-20.1l-1.3-21.3c-.8-13.2 6.4-25.6 18.2-31.5l19.1-9.6C65 70.2 70.2 65 73.4 58.6L83 39.5c5.9-11.8 18.3-19 31.5-18.2l21.3 1.3c7.1 .4 14.2-1.5 20.1-5.4L173.8 5.5zM272 192a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM1.3 441.8L44.4 339.3c.2 .1 .3 .2 .4 .4l9.6 19.1c11.7 23.2 36 37.3 62 35.8l21.3-1.3c.2 0 .5 0 .7 .2l17.8 11.8c5.1 3.3 10.5 5.9 16.1 7.7l-37.6 89.3c-2.3 5.5-7.4 9.2-13.3 9.7s-11.6-2.2-14.8-7.2L74.4 455.5l-56.1 8.3c-5.7 .8-11.4-1.5-15-6s-4.3-10.7-2.1-16zm248 60.4L211.7 413c5.6-1.8 11-4.3 16.1-7.7l17.8-11.8c.2-.1 .4-.2 .7-.2l21.3 1.3c26 1.5 50.3-12.6 62-35.8l9.6-19.1c.1-.2 .2-.3 .4-.4l43.2 102.5c2.2 5.3 1.4 11.4-2.1 16s-9.3 6.9-15 6l-56.1-8.3-32.2 49.2c-3.2 5-8.9 7.7-14.8 7.2s-11-4.3-13.3-9.7z"
    ]
};
var $d8206b3ab2e65c05$export$68ddda3b30ba09f0 = {
    prefix: "fas",
    iconName: "ticket-simple",
    icon: [
        576,
        512,
        [
            "ticket-alt"
        ],
        "f3ff",
        "M0 128C0 92.7 28.7 64 64 64H512c35.3 0 64 28.7 64 64v64c0 8.8-7.4 15.7-15.7 18.6C541.5 217.1 528 235 528 256s13.5 38.9 32.3 45.4c8.3 2.9 15.7 9.8 15.7 18.6v64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V320c0-8.8 7.4-15.7 15.7-18.6C34.5 294.9 48 277 48 256s-13.5-38.9-32.3-45.4C7.4 207.7 0 200.8 0 192V128z"
    ]
};
var $d8206b3ab2e65c05$export$75e38ba471fd89c4 = $d8206b3ab2e65c05$export$68ddda3b30ba09f0;
var $d8206b3ab2e65c05$export$f26673f8b10c3d46 = {
    prefix: "fas",
    iconName: "building",
    icon: [
        384,
        512,
        [
            127970,
            61687
        ],
        "f1ad",
        "M48 0C21.5 0 0 21.5 0 48V464c0 26.5 21.5 48 48 48h96V432c0-26.5 21.5-48 48-48s48 21.5 48 48v80h96c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H48zM64 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V240zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V240zM80 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V112zM272 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16z"
    ]
};
var $d8206b3ab2e65c05$export$2ebd565813951f81 = {
    prefix: "fas",
    iconName: "angles-left",
    icon: [
        512,
        512,
        [
            171,
            "angle-double-left"
        ],
        "f100",
        "M41.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 256 246.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160zm352-160l-160 160c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L301.3 256 438.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0z"
    ]
};
var $d8206b3ab2e65c05$export$21b0833b3cf929a7 = $d8206b3ab2e65c05$export$2ebd565813951f81;
var $d8206b3ab2e65c05$export$fc19ca0fe15e73bc = {
    prefix: "fas",
    iconName: "qrcode",
    icon: [
        448,
        512,
        [],
        "f029",
        "M0 80C0 53.5 21.5 32 48 32h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80zM64 96v64h64V96H64zM0 336c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V336zm64 16v64h64V352H64zM304 32h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H304c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48zm80 64H320v64h64V96zM256 304c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s7.2-16 16-16s16 7.2 16 16v96c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16s-7.2-16-16-16s-16 7.2-16 16v64c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V304zM368 480a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm64 0a16 16 0 1 1 0-32 16 16 0 1 1 0 32z"
    ]
};
var $d8206b3ab2e65c05$export$29be1665d1b36a3b = {
    prefix: "fas",
    iconName: "clock-rotate-left",
    icon: [
        512,
        512,
        [
            "history"
        ],
        "f1da",
        "M75 75L41 41C25.9 25.9 0 36.6 0 57.9V168c0 13.3 10.7 24 24 24H134.1c21.4 0 32.1-25.9 17-41l-30.8-30.8C155 85.5 203 64 256 64c106 0 192 86 192 192s-86 192-192 192c-40.8 0-78.6-12.7-109.7-34.4c-14.5-10.1-34.4-6.6-44.6 7.9s-6.6 34.4 7.9 44.6C151.2 495 201.7 512 256 512c141.4 0 256-114.6 256-256S397.4 0 256 0C185.3 0 121.3 28.7 75 75zm181 53c-13.3 0-24 10.7-24 24V256c0 6.4 2.5 12.5 7 17l72 72c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-65-65V152c0-13.3-10.7-24-24-24z"
    ]
};
var $d8206b3ab2e65c05$export$76d1986559ca7b7a = $d8206b3ab2e65c05$export$29be1665d1b36a3b;
var $d8206b3ab2e65c05$export$2ff38f330c834084 = {
    prefix: "fas",
    iconName: "face-grin-beam-sweat",
    icon: [
        512,
        512,
        [
            128517,
            "grin-beam-sweat"
        ],
        "f583",
        "M476.8 126.3c-4.1 1.1-8.4 1.7-12.8 1.7c-26.5 0-48-21-48-47c0-5 1.8-11.3 4.6-18.1c.3-.7 .6-1.4 .9-2.1c9-20.2 26.5-44.9 36-57.5c3.2-4.4 9.6-4.4 12.8 0C483.4 20.6 512 61 512 81c0 21.7-14.9 39.8-35.2 45.3zM256 0c51.4 0 99.3 15.2 139.4 41.2c-1.5 3.1-3 6.2-4.3 9.3c-3.4 8-7.1 19-7.1 30.5c0 44.3 36.6 79 80 79c9.6 0 18.8-1.7 27.4-4.8c13.3 30.9 20.6 65 20.6 100.8c0 141.4-114.6 256-256 256S0 397.4 0 256S114.6 0 256 0zM388.1 312.8c-39.7 12.2-84.5 19-131.8 19s-92.1-6.8-131.8-19c-12.3-3.8-24.3 6.9-19.3 18.7c25 59.1 83.2 100.5 151.1 100.5s126.2-41.4 151.1-100.5c5-11.8-7-22.5-19.3-18.7zm-170.5-84l0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C126.7 188.4 120 206.1 120 224c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8l0 0 0 0 0 0 .2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2 0 0 0 0zm160 0l0 0 0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C286.7 188.4 280 206.1 280 224c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8l0 0 0 0 0 0 .2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2 0 0z"
    ]
};
var $d8206b3ab2e65c05$export$14d0ccc54c5b6826 = $d8206b3ab2e65c05$export$2ff38f330c834084;
var $d8206b3ab2e65c05$export$364f19abcfac1b0a = {
    prefix: "fas",
    iconName: "file-export",
    icon: [
        576,
        512,
        [
            "arrow-right-from-file"
        ],
        "f56e",
        "M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384V288H216c-13.3 0-24 10.7-24 24s10.7 24 24 24H384V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM384 336V288H494.1l-39-39c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l80 80c9.4 9.4 9.4 24.6 0 33.9l-80 80c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l39-39H384zm0-208H256V0L384 128z"
    ]
};
var $d8206b3ab2e65c05$export$b9c76255b38e1df1 = $d8206b3ab2e65c05$export$364f19abcfac1b0a;
var $d8206b3ab2e65c05$export$8241bd5b9163ca12 = {
    prefix: "fas",
    iconName: "shield",
    icon: [
        512,
        512,
        [
            128737,
            "shield-blank"
        ],
        "f132",
        "M256 0c4.6 0 9.2 1 13.4 2.9L457.7 82.8c22 9.3 38.4 31 38.3 57.2c-.5 99.2-41.3 280.7-213.6 363.2c-16.7 8-36.1 8-52.8 0C57.3 420.7 16.5 239.2 16 140c-.1-26.2 16.3-47.9 38.3-57.2L242.7 2.9C246.8 1 251.4 0 256 0z"
    ]
};
var $d8206b3ab2e65c05$export$64f54da8fbaba8ee = $d8206b3ab2e65c05$export$8241bd5b9163ca12;
var $d8206b3ab2e65c05$export$be9d5060a4bc3b4b = {
    prefix: "fas",
    iconName: "arrow-up-short-wide",
    icon: [
        576,
        512,
        [
            "sort-amount-up-alt"
        ],
        "f885",
        "M151.6 42.4C145.5 35.8 137 32 128 32s-17.5 3.8-23.6 10.4l-88 96c-11.9 13-11.1 33.3 2 45.2s33.3 11.1 45.2-2L96 146.3V448c0 17.7 14.3 32 32 32s32-14.3 32-32V146.3l32.4 35.4c11.9 13 32.2 13.9 45.2 2s13.9-32.2 2-45.2l-88-96zM320 32c-17.7 0-32 14.3-32 32s14.3 32 32 32h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H320zm0 128c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H320zm0 128c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H320zm0 128c-17.7 0-32 14.3-32 32s14.3 32 32 32H544c17.7 0 32-14.3 32-32s-14.3-32-32-32H320z"
    ]
};
var $d8206b3ab2e65c05$export$6e87844b0f151b6a = $d8206b3ab2e65c05$export$be9d5060a4bc3b4b;
var $d8206b3ab2e65c05$export$2d077da983246a68 = {
    prefix: "fas",
    iconName: "house-medical",
    icon: [
        576,
        512,
        [],
        "e3b2",
        "M543.8 287.6c17 0 32-14 32-32.1c1-9-3-17-11-24L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24c0 18 14 32.1 32 32.1h32V448c0 35.3 28.7 64 64 64H448.5c35.5 0 64.2-28.8 64-64.3l-.7-160.2h32zM256 208c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H320v48c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V320H208c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16h48V208z"
    ]
};
var $d8206b3ab2e65c05$export$14c9f1d85e53ae99 = {
    prefix: "fas",
    iconName: "golf-ball-tee",
    icon: [
        384,
        512,
        [
            "golf-ball"
        ],
        "f450",
        "M384 192c0 66.8-34.1 125.6-85.8 160H85.8C34.1 317.6 0 258.8 0 192C0 86 86 0 192 0S384 86 384 192zM242.1 256.6c0 18.5-15 33.5-33.5 33.5c-4.9 0-9.1 5.1-5.4 8.4c5.9 5.2 13.7 8.4 22.1 8.4c18.5 0 33.5-15 33.5-33.5c0-8.5-3.2-16.2-8.4-22.1c-3.3-3.7-8.4 .5-8.4 5.4zm-52.3-49.3c-4.9 0-9.1 5.1-5.4 8.4c5.9 5.2 13.7 8.4 22.1 8.4c18.5 0 33.5-15 33.5-33.5c0-8.5-3.2-16.2-8.4-22.1c-3.3-3.7-8.4 .5-8.4 5.4c0 18.5-15 33.5-33.5 33.5zm113.5-17.5c0 18.5-15 33.5-33.5 33.5c-4.9 0-9.1 5.1-5.4 8.4c5.9 5.2 13.7 8.4 22.1 8.4c18.5 0 33.5-15 33.5-33.5c0-8.5-3.2-16.2-8.4-22.1c-3.3-3.7-8.4 .5-8.4 5.4zM96 416c0-17.7 14.3-32 32-32h64 64c17.7 0 32 14.3 32 32s-14.3 32-32 32H240c-8.8 0-16 7.2-16 16v16c0 17.7-14.3 32-32 32s-32-14.3-32-32V464c0-8.8-7.2-16-16-16H128c-17.7 0-32-14.3-32-32z"
    ]
};
var $d8206b3ab2e65c05$export$2251487a9a33c682 = $d8206b3ab2e65c05$export$14c9f1d85e53ae99;
var $d8206b3ab2e65c05$export$f2b13ad44c03c40f = {
    prefix: "fas",
    iconName: "circle-chevron-left",
    icon: [
        512,
        512,
        [
            "chevron-circle-left"
        ],
        "f137",
        "M512 256A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM271 135c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-87 87 87 87c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L167 273c-9.4-9.4-9.4-24.6 0-33.9L271 135z"
    ]
};
var $d8206b3ab2e65c05$export$4a42c8c2451a33fd = $d8206b3ab2e65c05$export$f2b13ad44c03c40f;
var $d8206b3ab2e65c05$export$792391babe46862d = {
    prefix: "fas",
    iconName: "house-chimney-window",
    icon: [
        576,
        512,
        [],
        "e00d",
        "M575.8 255.5c0 18-15 32.1-32 32.1h-32l.7 160.2c.2 35.5-28.5 64.3-64 64.3H128.1c-35.3 0-64-28.7-64-64V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L416 100.7V64c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32V185l52.8 46.4c8 7 12 15 11 24zM248 192c-13.3 0-24 10.7-24 24v80c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V216c0-13.3-10.7-24-24-24H248z"
    ]
};
var $d8206b3ab2e65c05$export$a82594dcc75a49f5 = {
    prefix: "fas",
    iconName: "pen-nib",
    icon: [
        512,
        512,
        [
            10001
        ],
        "f5ad",
        "M368.4 18.3L312.7 74.1 437.9 199.3l55.7-55.7c21.9-21.9 21.9-57.3 0-79.2L447.6 18.3c-21.9-21.9-57.3-21.9-79.2 0zM288 94.6l-9.2 2.8L134.7 140.6c-19.9 6-35.7 21.2-42.3 41L3.8 445.8c-3.8 11.3-1 23.9 7.3 32.4L164.7 324.7c-3-6.3-4.7-13.3-4.7-20.7c0-26.5 21.5-48 48-48s48 21.5 48 48s-21.5 48-48 48c-7.4 0-14.4-1.7-20.7-4.7L33.7 500.9c8.6 8.3 21.1 11.2 32.4 7.3l264.3-88.6c19.7-6.6 35-22.4 41-42.3l43.2-144.1 2.8-9.2L288 94.6z"
    ]
};
var $d8206b3ab2e65c05$export$89af87b7d6c15adf = {
    prefix: "fas",
    iconName: "tent-arrow-turn-left",
    icon: [
        576,
        512,
        [],
        "e580",
        "M120.1 41.8c9.9-8.9 10.7-24 1.8-33.9S97.8-2.7 87.9 6.2l-80 72C2.9 82.7 0 89.2 0 96s2.9 13.3 7.9 17.8l80 72c9.9 8.9 25 8.1 33.9-1.8s8.1-25-1.8-33.9L86.5 120 456 120c39.8 0 72 32.2 72 72v40c0 13.3 10.7 24 24 24s24-10.7 24-24V192c0-66.3-53.7-120-120-120L86.5 72l33.5-30.2zM307.4 166.5c-11.5-8.7-27.3-8.7-38.8 0l-168 128c-6.6 5-11 12.5-12.3 20.7l-24 160c-1.4 9.2 1.3 18.6 7.4 25.6S86.7 512 96 512H240h16c17.7 0 32-14.3 32-32V361.9c0-5.5 4.4-9.9 9.9-9.9c3.7 0 7.2 2.1 8.8 5.5l68.4 136.8c5.4 10.8 16.5 17.7 28.6 17.7H464h16c9.3 0 18.2-4.1 24.2-11.1s8.8-16.4 7.4-25.6l-24-160c-1.2-8.2-5.6-15.7-12.3-20.7l-168-128z"
    ]
};
var $d8206b3ab2e65c05$export$c93b950e845a4ee7 = {
    prefix: "fas",
    iconName: "tents",
    icon: [
        640,
        512,
        [],
        "e582",
        "M396.6 6.5L235.8 129.1c9.6 1.8 18.9 5.8 27 12l168 128c13.2 10.1 22 24.9 24.5 41.4l6.2 41.5H608c9.3 0 18.2-4.1 24.2-11.1s8.8-16.4 7.4-25.6l-24-160c-1.2-8.2-5.6-15.7-12.3-20.7l-168-128c-11.5-8.7-27.3-8.7-38.8 0zm-153.2 160c-11.5-8.7-27.3-8.7-38.8 0l-168 128c-6.6 5-11 12.5-12.3 20.7l-24 160c-1.4 9.2 1.3 18.6 7.4 25.6S22.7 512 32 512H176h16c17.7 0 32-14.3 32-32V361.9c0-5.5 4.4-9.9 9.9-9.9c3.7 0 7.2 2.1 8.8 5.5l68.4 136.8c5.4 10.8 16.5 17.7 28.6 17.7H400h16c9.3 0 18.2-4.1 24.2-11.1s8.8-16.4 7.4-25.6l-24-160c-1.2-8.2-5.6-15.7-12.3-20.7l-168-128z"
    ]
};
var $d8206b3ab2e65c05$export$8282f5f5dcf6b009 = {
    prefix: "fas",
    iconName: "wand-magic",
    icon: [
        512,
        512,
        [
            "magic"
        ],
        "f0d0",
        "M14.1 463.3c-18.7-18.7-18.7-49.1 0-67.9L395.4 14.1c18.7-18.7 49.1-18.7 67.9 0l34.6 34.6c18.7 18.7 18.7 49.1 0 67.9L116.5 497.9c-18.7 18.7-49.1 18.7-67.9 0L14.1 463.3zM347.6 187.6l105-105L429.4 59.3l-105 105 23.3 23.3z"
    ]
};
var $d8206b3ab2e65c05$export$e58f9b502d4dd52d = $d8206b3ab2e65c05$export$8282f5f5dcf6b009;
var $d8206b3ab2e65c05$export$c6406747800cf702 = {
    prefix: "fas",
    iconName: "dog",
    icon: [
        576,
        512,
        [
            128021
        ],
        "f6d3",
        "M309.6 158.5L332.7 19.8C334.6 8.4 344.5 0 356.1 0c7.5 0 14.5 3.5 19 9.5L392 32h52.1c12.7 0 24.9 5.1 33.9 14.1L496 64h56c13.3 0 24 10.7 24 24v24c0 44.2-35.8 80-80 80H464 448 426.7l-5.1 30.5-112-64zM416 256.1L416 480c0 17.7-14.3 32-32 32H352c-17.7 0-32-14.3-32-32V364.8c-24 12.3-51.2 19.2-80 19.2s-56-6.9-80-19.2V480c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V249.8c-28.8-10.9-51.4-35.3-59.2-66.5L1 167.8c-4.3-17.1 6.1-34.5 23.3-38.8s34.5 6.1 38.8 23.3l3.9 15.5C70.5 182 83.3 192 98 192h30 16H303.8L416 256.1zM464 80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"
    ]
};
var $d8206b3ab2e65c05$export$28e93ec9f5e2ddf3 = {
    prefix: "fas",
    iconName: "carrot",
    icon: [
        512,
        512,
        [
            129365
        ],
        "f787",
        "M346.7 6C337.6 17 320 42.3 320 72c0 40 15.3 55.3 40 80s40 40 80 40c29.7 0 55-17.6 66-26.7c4-3.3 6-8.2 6-13.3s-2-10-6-13.2c-11.4-9.1-38.3-26.8-74-26.8c-32 0-40 8-40 8s8-8 8-40c0-35.7-17.7-62.6-26.8-74C370 2 365.1 0 360 0s-10 2-13.3 6zM244.6 136c-40 0-77.1 18.1-101.7 48.2l60.5 60.5c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-55.3-55.3 0 .1L2.2 477.9C-2 487-.1 497.8 7 505s17.9 9 27.1 4.8l134.7-62.4-52.1-52.1c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L199.7 433l100.2-46.4c46.4-21.5 76.2-68 76.2-119.2C376 194.8 317.2 136 244.6 136z"
    ]
};
var $d8206b3ab2e65c05$export$c4c2f69a53bab720 = {
    prefix: "fas",
    iconName: "moon",
    icon: [
        384,
        512,
        [
            127769,
            9214
        ],
        "f186",
        "M223.5 32C100 32 0 132.3 0 256S100 480 223.5 480c60.6 0 115.5-24.2 155.8-63.4c5-4.9 6.3-12.5 3.1-18.7s-10.1-9.7-17-8.5c-9.8 1.7-19.8 2.6-30.1 2.6c-96.9 0-175.5-78.8-175.5-176c0-65.8 36-123.1 89.3-153.3c6.1-3.5 9.2-10.5 7.7-17.3s-7.3-11.9-14.3-12.5c-6.3-.5-12.6-.8-19-.8z"
    ]
};
var $d8206b3ab2e65c05$export$b86d7336e68a3f57 = {
    prefix: "fas",
    iconName: "wine-glass-empty",
    icon: [
        320,
        512,
        [
            "wine-glass-alt"
        ],
        "f5ce",
        "M64 0C47.4 0 33.5 12.8 32.1 29.3l-14 168.4c-6 72 42.5 135.2 109.9 150.6V448H80c-17.7 0-32 14.3-32 32s14.3 32 32 32h80 80c17.7 0 32-14.3 32-32s-14.3-32-32-32H192V348.4c67.4-15.4 115.9-78.6 109.9-150.6l-14-168.4C286.5 12.8 272.6 0 256 0H64zM81.9 203.1L93.4 64H226.6l11.6 139.1C242 248.8 205.9 288 160 288s-82-39.2-78.1-84.9z"
    ]
};
var $d8206b3ab2e65c05$export$b8ff3fe2b78aef2f = $d8206b3ab2e65c05$export$b86d7336e68a3f57;
var $d8206b3ab2e65c05$export$549b99473b7201e6 = {
    prefix: "fas",
    iconName: "cheese",
    icon: [
        512,
        512,
        [],
        "f7ef",
        "M512 240.2V256H0c0-20 10-38.7 26.6-49.8L274.9 40.7c8.6-5.7 18.6-8.7 28.9-8.7C418.8 32 512 125.2 512 240.2zm0 47.8V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V288H512z"
    ]
};
var $d8206b3ab2e65c05$export$6ec1acbf3f610b8f = {
    prefix: "fas",
    iconName: "yin-yang",
    icon: [
        512,
        512,
        [
            9775
        ],
        "f6ad",
        "M256 64c53 0 96 43 96 96s-43 96-96 96s-96 43-96 96s43 96 96 96C150 448 64 362 64 256S150 64 256 64zm0 448A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm32-352a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
    ]
};
var $d8206b3ab2e65c05$export$fcb0647a5340b5b8 = {
    prefix: "fas",
    iconName: "music",
    icon: [
        512,
        512,
        [
            127925
        ],
        "f001",
        "M499.1 6.3c8.1 6 12.9 15.6 12.9 25.7v72V368c0 44.2-43 80-96 80s-96-35.8-96-80s43-80 96-80c11.2 0 22 1.6 32 4.6V147L192 223.8V432c0 44.2-43 80-96 80s-96-35.8-96-80s43-80 96-80c11.2 0 22 1.6 32 4.6V200 128c0-14.1 9.3-26.6 22.8-30.7l320-96c9.7-2.9 20.2-1.1 28.3 5z"
    ]
};
var $d8206b3ab2e65c05$export$d5d870c10bc9f1ce = {
    prefix: "fas",
    iconName: "code-commit",
    icon: [
        640,
        512,
        [],
        "f386",
        "M320 336a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm156.8-48C462 361 397.4 416 320 416s-142-55-156.8-128H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H163.2C178 151 242.6 96 320 96s142 55 156.8 128H608c17.7 0 32 14.3 32 32s-14.3 32-32 32H476.8z"
    ]
};
var $d8206b3ab2e65c05$export$9e9af12b90a1abd2 = {
    prefix: "fas",
    iconName: "temperature-low",
    icon: [
        512,
        512,
        [],
        "f76b",
        "M448 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM320 96a96 96 0 1 1 192 0A96 96 0 1 1 320 96zM144 64c-26.5 0-48 21.5-48 48V276.5c0 17.3-7.1 31.9-15.3 42.5C70.2 332.6 64 349.5 64 368c0 44.2 35.8 80 80 80s80-35.8 80-80c0-18.5-6.2-35.4-16.7-48.9c-8.2-10.6-15.3-25.2-15.3-42.5V112c0-26.5-21.5-48-48-48zM32 112C32 50.2 82.1 0 144 0s112 50.1 112 112V276.5c0 .1 .1 .3 .2 .6c.2 .6 .8 1.6 1.7 2.8c18.9 24.4 30.1 55 30.1 88.1c0 79.5-64.5 144-144 144S0 447.5 0 368c0-33.2 11.2-63.8 30.1-88.1c.9-1.2 1.5-2.2 1.7-2.8c.1-.3 .2-.5 .2-.6V112zM192 368c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V272c0-8.8 7.2-16 16-16s16 7.2 16 16v50.7c18.6 6.6 32 24.4 32 45.3z"
    ]
};
var $d8206b3ab2e65c05$export$cf152282d5de300d = {
    prefix: "fas",
    iconName: "person-biking",
    icon: [
        640,
        512,
        [
            128692,
            "biking"
        ],
        "f84a",
        "M400 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm27.2 64l-61.8-48.8c-17.3-13.6-41.7-13.8-59.1-.3l-83.1 64.2c-30.7 23.8-28.5 70.8 4.3 91.6L288 305.1V416c0 17.7 14.3 32 32 32s32-14.3 32-32V288c0-10.7-5.3-20.7-14.2-26.6L295 232.9l60.3-48.5L396 217c5.7 4.5 12.7 7 20 7h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H427.2zM56 384a72 72 0 1 1 144 0A72 72 0 1 1 56 384zm200 0A128 128 0 1 0 0 384a128 128 0 1 0 256 0zm184 0a72 72 0 1 1 144 0 72 72 0 1 1 -144 0zm200 0a128 128 0 1 0 -256 0 128 128 0 1 0 256 0z"
    ]
};
var $d8206b3ab2e65c05$export$a5bcf835dbf9c0b = $d8206b3ab2e65c05$export$cf152282d5de300d;
var $d8206b3ab2e65c05$export$2a533051418ff4ca = {
    prefix: "fas",
    iconName: "broom",
    icon: [
        576,
        512,
        [
            129529
        ],
        "f51a",
        "M566.6 54.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192-34.7-34.7c-4.2-4.2-10-6.6-16-6.6c-12.5 0-22.6 10.1-22.6 22.6v29.1L364.3 320h29.1c12.5 0 22.6-10.1 22.6-22.6c0-6-2.4-11.8-6.6-16l-34.7-34.7 192-192zM341.1 353.4L222.6 234.9c-42.7-3.7-85.2 11.7-115.8 42.3l-8 8C76.5 307.5 64 337.7 64 369.2c0 6.8 7.1 11.2 13.2 8.2l51.1-25.5c5-2.5 9.5 4.1 5.4 7.9L7.3 473.4C2.7 477.6 0 483.6 0 489.9C0 502.1 9.9 512 22.1 512l173.3 0c38.8 0 75.9-15.4 103.4-42.8c30.6-30.6 45.9-73.1 42.3-115.8z"
    ]
};
var $d8206b3ab2e65c05$export$7b96388ca2be471b = {
    prefix: "fas",
    iconName: "shield-heart",
    icon: [
        512,
        512,
        [],
        "e574",
        "M269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L269.4 2.9zM144 221.3c0-33.8 27.4-61.3 61.3-61.3c16.2 0 31.8 6.5 43.3 17.9l7.4 7.4 7.4-7.4c11.5-11.5 27.1-17.9 43.3-17.9c33.8 0 61.3 27.4 61.3 61.3c0 16.2-6.5 31.8-17.9 43.3l-82.7 82.7c-6.2 6.2-16.4 6.2-22.6 0l-82.7-82.7c-11.5-11.5-17.9-27.1-17.9-43.3z"
    ]
};
var $d8206b3ab2e65c05$export$31f89d8ac1d14ed6 = {
    prefix: "fas",
    iconName: "gopuram",
    icon: [
        512,
        512,
        [],
        "f664",
        "M120 0c13.3 0 24 10.7 24 24v8h40V24c0-13.3 10.7-24 24-24s24 10.7 24 24v8h48V24c0-13.3 10.7-24 24-24s24 10.7 24 24v8h40V24c0-13.3 10.7-24 24-24s24 10.7 24 24v8V64v64c17.7 0 32 14.3 32 32v64c17.7 0 32 14.3 32 32v96c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H416V352H384V224H352V128H320v96h32V352h32V512H304V464c0-26.5-21.5-48-48-48s-48 21.5-48 48v48H128V352h32V224h32V128H160v96H128V352H96V512H32c-17.7 0-32-14.3-32-32V384c0-17.7 14.3-32 32-32V256c0-17.7 14.3-32 32-32V160c0-17.7 14.3-32 32-32V64 32 24c0-13.3 10.7-24 24-24zM256 272c-17.7 0-32 14.3-32 32v48h64V304c0-17.7-14.3-32-32-32zm-32-80v32h64V192c0-17.7-14.3-32-32-32s-32 14.3-32 32z"
    ]
};
var $d8206b3ab2e65c05$export$bd931e906edf2f47 = {
    prefix: "fas",
    iconName: "earth-oceania",
    icon: [
        512,
        512,
        [
            "globe-oceania"
        ],
        "e47b",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM208.6 357.3l-39-13.5c-6.5-2.2-13.6-2.3-20.1-.3l-15.3 4.9c-18.5 5.9-38.5-2.4-47.5-19.5l-3.3-6.2c-10.6-20.1-2.3-45 18.2-54.7l35.3-16.8c2.3-1.1 4.4-2.8 5.9-4.8l5.3-7c7.2-9.6 18.6-15.3 30.6-15.3s23.4 5.7 30.6 15.3l4.6 6.1c2 2.6 4.9 4.5 8.1 5.1c7.8 1.6 15.7-1.5 20.4-7.9l10.4-14.2c2-2.8 5.3-4.4 8.7-4.4c4.4 0 8.4 2.7 10 6.8l10.1 25.9c2.8 7.2 6.7 14 11.5 20.2L311 299.8c5.8 7.4 9 16.6 9 26s-3.2 18.6-9 26L299 367.2c-8.3 10.6-21 16.8-34.4 16.8c-8.4 0-16.6-2.4-23.7-7l-25.4-16.4c-2.2-1.4-4.5-2.5-6.9-3.4zm65.2-214.8L296 164.7c10.1 10.1 2.9 27.3-11.3 27.3H254.8c-5.6 0-11.1-1.2-16.2-3.4l-42.8-19c-14.3-6.3-11.9-27.3 3.4-30.3l38.5-7.7c13.1-2.6 26.7 1.5 36.1 10.9zM248 432c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H264c-8.8 0-16-7.2-16-16zM431.2 298.9l8 24c2.8 8.4-1.7 17.4-10.1 20.2s-17.4-1.7-20.2-10.1l-8-24c-2.8-8.4 1.7-17.4 10.1-20.2s17.4 1.7 20.2 10.1zm-19.9 80.4l-32 32c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l32-32c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
    ]
};
var $d8206b3ab2e65c05$export$8ac3f5271448657d = $d8206b3ab2e65c05$export$bd931e906edf2f47;
var $d8206b3ab2e65c05$export$5a17e58bb7afb1d7 = {
    prefix: "fas",
    iconName: "square-xmark",
    icon: [
        448,
        512,
        [
            10062,
            "times-square",
            "xmark-square"
        ],
        "f2d3",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm79 143c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"
    ]
};
var $d8206b3ab2e65c05$export$c0248ac97142ea2a = $d8206b3ab2e65c05$export$5a17e58bb7afb1d7;
var $d8206b3ab2e65c05$export$9a364781d6b7602b = $d8206b3ab2e65c05$export$5a17e58bb7afb1d7;
var $d8206b3ab2e65c05$export$c92c903bade56844 = {
    prefix: "fas",
    iconName: "hashtag",
    icon: [
        448,
        512,
        [
            62098
        ],
        "23",
        "M181.3 32.4c17.4 2.9 29.2 19.4 26.3 36.8L197.8 128h95.1l11.5-69.3c2.9-17.4 19.4-29.2 36.8-26.3s29.2 19.4 26.3 36.8L357.8 128H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H347.1L325.8 320H384c17.7 0 32 14.3 32 32s-14.3 32-32 32H315.1l-11.5 69.3c-2.9 17.4-19.4 29.2-36.8 26.3s-29.2-19.4-26.3-36.8l9.8-58.7H155.1l-11.5 69.3c-2.9 17.4-19.4 29.2-36.8 26.3s-29.2-19.4-26.3-36.8L90.2 384H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h68.9l21.3-128H64c-17.7 0-32-14.3-32-32s14.3-32 32-32h68.9l11.5-69.3c2.9-17.4 19.4-29.2 36.8-26.3zM187.1 192L165.8 320h95.1l21.3-128H187.1z"
    ]
};
var $d8206b3ab2e65c05$export$95457ede07b81517 = {
    prefix: "fas",
    iconName: "up-right-and-down-left-from-center",
    icon: [
        512,
        512,
        [
            "expand-alt"
        ],
        "f424",
        "M344 0H488c13.3 0 24 10.7 24 24V168c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-39-39-87 87c-9.4 9.4-24.6 9.4-33.9 0l-32-32c-9.4-9.4-9.4-24.6 0-33.9l87-87L327 41c-6.9-6.9-8.9-17.2-5.2-26.2S334.3 0 344 0zM168 512H24c-13.3 0-24-10.7-24-24V344c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2l39 39 87-87c9.4-9.4 24.6-9.4 33.9 0l32 32c9.4 9.4 9.4 24.6 0 33.9l-87 87 39 39c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8z"
    ]
};
var $d8206b3ab2e65c05$export$bcb8d86a3a1d6eb6 = $d8206b3ab2e65c05$export$95457ede07b81517;
var $d8206b3ab2e65c05$export$2599126c3a57f727 = {
    prefix: "fas",
    iconName: "oil-can",
    icon: [
        640,
        512,
        [],
        "f613",
        "M320 128c17.7 0 32-14.3 32-32s-14.3-32-32-32H192c-17.7 0-32 14.3-32 32s14.3 32 32 32h32v32H144 96 48c-26.5 0-48 21.5-48 48v64.8c0 19 11.2 36.2 28.5 43.9l67.5 30V368c0 26.5 21.5 48 48 48H403.1c18.4 0 35.8-7.9 48-21.7L633.5 187.7c12.3-13.9-.3-35.4-18.4-31.5L448 192l-50.5-25.2c-8.9-4.4-18.7-6.8-28.6-6.8H288V128h32zM96 208v86.1L48 272.8V208H96z"
    ]
};
var $d8206b3ab2e65c05$export$6e625d2e7790c860 = {
    prefix: "fas",
    iconName: "t",
    icon: [
        384,
        512,
        [
            116
        ],
        "54",
        "M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96H160V448c0 17.7 14.3 32 32 32s32-14.3 32-32V96H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H192 32z"
    ]
};
var $d8206b3ab2e65c05$export$d4c909619093de2d = {
    prefix: "fas",
    iconName: "hippo",
    icon: [
        640,
        512,
        [
            129435
        ],
        "f6ed",
        "M407 47c9.4-9.4 24.6-9.4 33.9 0l17.2 17.2c1.9-.1 3.9-.2 5.8-.2h32c11.2 0 21.9 2.3 31.6 6.5L543 55c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L564 101.9c7.6 12.2 12 26.7 12 42.1c0 10.2 7.4 18.8 16.7 23c27.9 12.5 47.3 40.5 47.3 73c0 26.2-12.6 49.4-32 64v32c0 8.8-7.2 16-16 16H560c-8.8 0-16-7.2-16-16V320H480v16c0 8.8-7.2 16-16 16H432c-8.8 0-16-7.2-16-16V318.4c-11.8-2.4-22.7-7.4-32-14.4c-1.5-1.1-2.9-2.3-4.3-3.5c-17-14.7-27.7-36.4-27.7-60.5c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 44.7 26.2 83.2 64 101.2V352c0 17.7 14.3 32 32 32h32v64c0 17.7-14.3 32-32 32H352c-17.7 0-32-14.3-32-32V372c-19.8 7.7-41.4 12-64 12s-44.2-4.3-64-12v76c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V329.1L45.9 369.7c-5.4 12.1-19.6 17.6-31.7 12.2S-3.3 362.4 2.1 350.3L24 300.9c5.3-11.9 8-24.7 8-37.7C32 155.7 117.2 68 223.8 64.1l.2-.1h7.2H256h32c41.7 0 83.4 12.1 117.2 25.7c1.7-1.8 3.5-3.6 5.3-5.2L407 81c-9.4-9.4-9.4-24.6 0-33.9zm73 185a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm88 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM480 144a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm48 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"
    ]
};
var $d8206b3ab2e65c05$export$d01ddcc9efe7b149 = {
    prefix: "fas",
    iconName: "chart-column",
    icon: [
        512,
        512,
        [],
        "e0e3",
        "M32 32c17.7 0 32 14.3 32 32V400c0 8.8 7.2 16 16 16H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H80c-44.2 0-80-35.8-80-80V64C0 46.3 14.3 32 32 32zM160 224c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V256c0-17.7 14.3-32 32-32zm128-64V320c0 17.7-14.3 32-32 32s-32-14.3-32-32V160c0-17.7 14.3-32 32-32s32 14.3 32 32zm64 32c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V224c0-17.7 14.3-32 32-32zM480 96V320c0 17.7-14.3 32-32 32s-32-14.3-32-32V96c0-17.7 14.3-32 32-32s32 14.3 32 32z"
    ]
};
var $d8206b3ab2e65c05$export$a590003279d671b8 = {
    prefix: "fas",
    iconName: "infinity",
    icon: [
        640,
        512,
        [
            8734,
            9854
        ],
        "f534",
        "M0 241.1C0 161 65 96 145.1 96c38.5 0 75.4 15.3 102.6 42.5L320 210.7l72.2-72.2C419.5 111.3 456.4 96 494.9 96C575 96 640 161 640 241.1v29.7C640 351 575 416 494.9 416c-38.5 0-75.4-15.3-102.6-42.5L320 301.3l-72.2 72.2C220.5 400.7 183.6 416 145.1 416C65 416 0 351 0 270.9V241.1zM274.7 256l-72.2-72.2c-15.2-15.2-35.9-23.8-57.4-23.8C100.3 160 64 196.3 64 241.1v29.7c0 44.8 36.3 81.1 81.1 81.1c21.5 0 42.2-8.5 57.4-23.8L274.7 256zm90.5 0l72.2 72.2c15.2 15.2 35.9 23.8 57.4 23.8c44.8 0 81.1-36.3 81.1-81.1V241.1c0-44.8-36.3-81.1-81.1-81.1c-21.5 0-42.2 8.5-57.4 23.8L365.3 256z"
    ]
};
var $d8206b3ab2e65c05$export$2db4f9712313eafa = {
    prefix: "fas",
    iconName: "vial-circle-check",
    icon: [
        512,
        512,
        [],
        "e596",
        "M0 64C0 46.3 14.3 32 32 32H96h64 64c17.7 0 32 14.3 32 32s-14.3 32-32 32V266.8c-20.2 28.6-32 63.5-32 101.2c0 25.2 5.3 49.1 14.8 70.8C189.5 463.7 160.6 480 128 480c-53 0-96-43-96-96V96C14.3 96 0 81.7 0 64zM96 96v96h64V96H96zM224 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm211.3-43.3c-6.2-6.2-16.4-6.2-22.6 0L352 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z"
    ]
};
var $d8206b3ab2e65c05$export$f9a5161975928326 = {
    prefix: "fas",
    iconName: "person-arrow-down-to-line",
    icon: [
        640,
        512,
        [],
        "e538",
        "M192 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-8 352V352h16v96H184zm-64 0H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H152h80H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H264V256.9l28.6 47.5c9.1 15.1 28.8 20 43.9 10.9s20-28.8 10.9-43.9l-58.3-97c-17.4-28.9-48.6-46.6-82.3-46.6H177.1c-33.7 0-64.9 17.7-82.3 46.6l-58.3 97c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9L120 256.9V448zM464 64V306.7l-25.4-25.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l80 80c12.5 12.5 32.8 12.5 45.3 0l80-80c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L528 306.7V64c0-17.7-14.3-32-32-32s-32 14.3-32 32z"
    ]
};
var $d8206b3ab2e65c05$export$4f1ce88b2b4cd5cd = {
    prefix: "fas",
    iconName: "voicemail",
    icon: [
        640,
        512,
        [],
        "f897",
        "M144 320a80 80 0 1 1 0-160 80 80 0 1 1 0 160zm119.8 0c15.3-22.9 24.2-50.4 24.2-80c0-79.5-64.5-144-144-144S0 160.5 0 240s64.5 144 144 144H496c79.5 0 144-64.5 144-144s-64.5-144-144-144s-144 64.5-144 144c0 29.6 8.9 57.1 24.2 80H263.8zM496 160a80 80 0 1 1 0 160 80 80 0 1 1 0-160z"
    ]
};
var $d8206b3ab2e65c05$export$55145a3dae4f984a = {
    prefix: "fas",
    iconName: "fan",
    icon: [
        512,
        512,
        [],
        "f863",
        "M258.6 0c-1.7 0-3.4 .1-5.1 .5C168 17 115.6 102.3 130.5 189.3c2.9 17 8.4 32.9 15.9 47.4L32 224H29.4C13.2 224 0 237.2 0 253.4c0 1.7 .1 3.4 .5 5.1C17 344 102.3 396.4 189.3 381.5c17-2.9 32.9-8.4 47.4-15.9L224 480v2.6c0 16.2 13.2 29.4 29.4 29.4c1.7 0 3.4-.1 5.1-.5C344 495 396.4 409.7 381.5 322.7c-2.9-17-8.4-32.9-15.9-47.4L480 288h2.6c16.2 0 29.4-13.2 29.4-29.4c0-1.7-.1-3.4-.5-5.1C495 168 409.7 115.6 322.7 130.5c-17 2.9-32.9 8.4-47.4 15.9L288 32V29.4C288 13.2 274.8 0 258.6 0zM256 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $d8206b3ab2e65c05$export$1ae0a37b36ace746 = {
    prefix: "fas",
    iconName: "person-walking-luggage",
    icon: [
        576,
        512,
        [],
        "e554",
        "M432 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM347.7 200.5c1-.4 1.9-.8 2.9-1.2l-16.9 63.5c-5.6 21.1-.1 43.6 14.7 59.7l70.7 77.1 22 88.1c4.3 17.1 21.7 27.6 38.8 23.3s27.6-21.7 23.3-38.8l-23-92.1c-1.9-7.8-5.8-14.9-11.2-20.8l-49.5-54 19.3-65.5 9.6 23c4.4 10.6 12.5 19.3 22.8 24.5l26.7 13.3c15.8 7.9 35 1.5 42.9-14.3s1.5-35-14.3-42.9L505 232.7l-15.3-36.8C472.5 154.8 432.3 128 387.7 128c-22.8 0-45.3 4.8-66.1 14l-8 3.5c-32.9 14.6-58.1 42.4-69.4 76.5l-2.6 7.8c-5.6 16.8 3.5 34.9 20.2 40.5s34.9-3.5 40.5-20.2l2.6-7.8c5.7-17.1 18.3-30.9 34.7-38.2l8-3.5zm-30 135.1l-25 62.4-59.4 59.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L340.3 441c4.6-4.6 8.2-10.1 10.6-16.1l14.5-36.2-40.7-44.4c-2.5-2.7-4.8-5.6-7-8.6zM256 274.1c-7.7-4.4-17.4-1.8-21.9 5.9l-32 55.4L147.7 304c-15.3-8.8-34.9-3.6-43.7 11.7L40 426.6c-8.8 15.3-3.6 34.9 11.7 43.7l55.4 32c15.3 8.8 34.9 3.6 43.7-11.7l64-110.9c1.5-2.6 2.6-5.2 3.3-8L261.9 296c4.4-7.7 1.8-17.4-5.9-21.9z"
    ]
};
var $d8206b3ab2e65c05$export$e36c32dd5cba9b90 = {
    prefix: "fas",
    iconName: "up-down",
    icon: [
        256,
        512,
        [
            8597,
            11021,
            "arrows-alt-v"
        ],
        "f338",
        "M145.6 7.7C141 2.8 134.7 0 128 0s-13 2.8-17.6 7.7l-104 112c-6.5 7-8.2 17.2-4.4 25.9S14.5 160 24 160H80V352H24c-9.5 0-18.2 5.7-22 14.4s-2.1 18.9 4.4 25.9l104 112c4.5 4.9 10.9 7.7 17.6 7.7s13-2.8 17.6-7.7l104-112c6.5-7 8.2-17.2 4.4-25.9s-12.5-14.4-22-14.4H176V160h56c9.5 0 18.2-5.7 22-14.4s2.1-18.9-4.4-25.9l-104-112z"
    ]
};
var $d8206b3ab2e65c05$export$138cb56a3f8f7040 = $d8206b3ab2e65c05$export$e36c32dd5cba9b90;
var $d8206b3ab2e65c05$export$301c3fab0c4545bd = {
    prefix: "fas",
    iconName: "cloud-moon-rain",
    icon: [
        576,
        512,
        [],
        "f73c",
        "M481.2 0C417 0 363.5 46.5 353.7 107.6c35.4 17.6 60.2 53.3 62.1 95.1c23.2 11 42 29.7 53.1 52.7c4 .4 8.1 .6 12.3 .6c34.9 0 66.7-13.8 89.9-36.1c5.1-4.9 6.4-12.5 3.2-18.7s-10.1-9.7-17-8.6c-4.9 .8-10 1.3-15.2 1.3c-49 0-88.4-39.3-88.4-87.4c0-32.6 18-61.1 44.9-76.1c6.1-3.4 9.3-10.5 7.8-17.4s-7.3-12-14.3-12.6c-3.6-.3-7.3-.5-10.9-.5zM367.9 383.9c44.2 0 80-35.8 80-80c0-39.3-28.4-72.1-65.8-78.7c1.2-5.6 1.9-11.3 1.9-17.2c0-44.2-35.8-80-80-80c-17 0-32.8 5.3-45.8 14.4C241.3 114.6 210.8 96 176 96c-53 0-96 43-96 96l0 1.3c-45.4 7.6-80 47.1-80 94.6c0 53 43 96 96 96H367.9zM85.4 420.1c-11-7.4-25.9-4.4-33.3 6.7l-32 48c-7.4 11-4.4 25.9 6.7 33.3s25.9 4.4 33.3-6.7l32-48c7.4-11 4.4-25.9-6.7-33.3zm96 0c-11-7.4-25.9-4.4-33.3 6.7l-32 48c-7.4 11-4.4 25.9 6.7 33.3s25.9 4.4 33.3-6.7l32-48c7.4-11 4.4-25.9-6.7-33.3zm96 0c-11-7.4-25.9-4.4-33.3 6.7l-32 48c-7.4 11-4.4 25.9 6.7 33.3s25.9 4.4 33.3-6.7l32-48c7.4-11 4.4-25.9-6.7-33.3zm96 0c-11-7.4-25.9-4.4-33.3 6.7l-32 48c-7.4 11-4.4 25.9 6.7 33.3s25.9 4.4 33.3-6.7l32-48c7.4-11 4.4-25.9-6.7-33.3z"
    ]
};
var $d8206b3ab2e65c05$export$34f5c36a3e80efa2 = {
    prefix: "fas",
    iconName: "calendar",
    icon: [
        448,
        512,
        [
            128197,
            128198
        ],
        "f133",
        "M96 32V64H48C21.5 64 0 85.5 0 112v48H448V112c0-26.5-21.5-48-48-48H352V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H160V32c0-17.7-14.3-32-32-32S96 14.3 96 32zM448 192H0V464c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48V192z"
    ]
};
var $d8206b3ab2e65c05$export$3a48b9820e92f5ab = {
    prefix: "fas",
    iconName: "trailer",
    icon: [
        640,
        512,
        [],
        "e041",
        "M48 32C21.5 32 0 53.5 0 80V336c0 26.5 21.5 48 48 48H65.1c7.8-54.3 54.4-96 110.9-96s103.1 41.7 110.9 96H488h8H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H544V80c0-26.5-21.5-48-48-48H48zM80 96c8.8 0 16 7.2 16 16l0 131.2c-11.4 5.9-22.2 12.9-32 21V112c0-8.8 7.2-16 16-16zm96 128c-5.4 0-10.7 .2-16 .7L160 112c0-8.8 7.2-16 16-16s16 7.2 16 16l0 112.7c-5.3-.5-10.6-.7-16-.7zm80 19.2L256 112c0-8.8 7.2-16 16-16s16 7.2 16 16l0 152.2c-9.8-8.1-20.6-15.2-32-21zM368 96c8.8 0 16 7.2 16 16l0 192c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-192c0-8.8 7.2-16 16-16zm112 16l0 192c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-192c0-8.8 7.2-16 16-16s16 7.2 16 16zM176 480a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm0-112a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $d8206b3ab2e65c05$export$6d636565b3ec36b4 = {
    prefix: "fas",
    iconName: "bahai",
    icon: [
        576,
        512,
        [
            "haykal"
        ],
        "f666",
        "M288 0c14.5 0 27.2 9.7 30.9 23.8l23.9 89.6 75.9-53.3c11.9-8.3 27.8-7.6 39 1.7s14.6 24.9 8.4 38.1l-39.3 84 92.4 8c14.4 1.2 26.2 12 28.8 26.3s-4.9 28.5-18 34.6l-84.1 39.1 65.7 65.5c10.3 10.2 12.4 26.1 5.1 38.7s-22 18.7-36 14.9L391 386.8l8.2 92.4c1.3 14.4-7.3 27.9-20.9 32.9s-28.9 .1-37.2-11.7l-53.1-76-53.1 76c-8.3 11.9-23.6 16.7-37.2 11.7s-22.2-18.5-20.9-32.9l8.2-92.4L95.4 410.9c-14 3.8-28.8-2.3-36-14.9s-5.2-28.4 5.1-38.7l65.7-65.5L46 252.7c-13.1-6.1-20.5-20.3-18-34.6s14.3-25.1 28.8-26.3l92.4-8-39.3-84c-6.1-13.1-2.7-28.8 8.4-38.1s27.1-10 39-1.7l75.9 53.3 23.9-89.6C260.8 9.7 273.5 0 288 0zm0 156.2l-4.8 18c-2.7 10.1-10.2 18.2-20 21.8s-20.8 2.1-29.3-3.9l-15.2-10.7 7.9 16.8c4.4 9.5 4 20.5-1.3 29.6s-14.5 15-25 15.9l-18.5 1.6 16.8 7.8c9.5 4.4 16.2 13.2 18 23.5s-1.5 20.8-8.9 28.2l-13.2 13.1 17.9-4.8c10.1-2.7 20.9-.3 28.9 6.4s12.2 16.9 11.3 27.3l-1.6 18.5 10.6-15.2c6-8.6 15.8-13.7 26.2-13.7s20.2 5.1 26.2 13.7l10.6 15.2-1.6-18.5c-.9-10.4 3.3-20.6 11.3-27.3s18.8-9.1 28.9-6.4l17.9 4.8-13.2-13.1c-7.4-7.4-10.7-17.9-8.9-28.2s8.5-19.1 18-23.5l16.8-7.8-18.5-1.6c-10.4-.9-19.7-6.8-25-15.9s-5.7-20.1-1.3-29.6l7.9-16.8-15.2 10.7c-8.6 6-19.5 7.5-29.3 3.9s-17.3-11.7-20-21.8l-4.8-18z"
    ]
};
var $d8206b3ab2e65c05$export$5c15e34e0e43f15c = $d8206b3ab2e65c05$export$6d636565b3ec36b4;
var $d8206b3ab2e65c05$export$303efb6031da122 = {
    prefix: "fas",
    iconName: "sd-card",
    icon: [
        384,
        512,
        [],
        "f7c2",
        "M320 0H141.3C124.3 0 108 6.7 96 18.7L18.7 96C6.7 108 0 124.3 0 141.3V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64zM160 88v48c0 13.3-10.7 24-24 24s-24-10.7-24-24V88c0-13.3 10.7-24 24-24s24 10.7 24 24zm80 0v48c0 13.3-10.7 24-24 24s-24-10.7-24-24V88c0-13.3 10.7-24 24-24s24 10.7 24 24zm80 0v48c0 13.3-10.7 24-24 24s-24-10.7-24-24V88c0-13.3 10.7-24 24-24s24 10.7 24 24z"
    ]
};
var $d8206b3ab2e65c05$export$ae1875ba975aa0e9 = {
    prefix: "fas",
    iconName: "dragon",
    icon: [
        640,
        512,
        [
            128009
        ],
        "f6d5",
        "M352 124.5l-51.9-13c-6.5-1.6-11.3-7.1-12-13.8s2.8-13.1 8.7-16.1l40.8-20.4L294.4 28.8c-5.5-4.1-7.8-11.3-5.6-17.9S297.1 0 304 0H416h32 16c30.2 0 58.7 14.2 76.8 38.4l57.6 76.8c6.2 8.3 9.6 18.4 9.6 28.8c0 26.5-21.5 48-48 48H538.5c-17 0-33.3-6.7-45.3-18.7L480 160H448v21.5c0 24.8 12.8 47.9 33.8 61.1l106.6 66.6c32.1 20.1 51.6 55.2 51.6 93.1C640 462.9 590.9 512 530.2 512H496 432 32.3c-3.3 0-6.6-.4-9.6-1.4C13.5 507.8 6 501 2.4 492.1C1 488.7 .2 485.2 0 481.4c-.2-3.7 .3-7.3 1.3-10.7c2.8-9.2 9.6-16.7 18.6-20.4c3-1.2 6.2-2 9.5-2.2L433.3 412c8.3-.7 14.7-7.7 14.7-16.1c0-4.3-1.7-8.4-4.7-11.4l-44.4-44.4c-30-30-46.9-70.7-46.9-113.1V181.5v-57zM512 72.3c0-.1 0-.2 0-.3s0-.2 0-.3v.6zm-1.3 7.4L464.3 68.1c-.2 1.3-.3 2.6-.3 3.9c0 13.3 10.7 24 24 24c10.6 0 19.5-6.8 22.7-16.3zM130.9 116.5c16.3-14.5 40.4-16.2 58.5-4.1l130.6 87V227c0 32.8 8.4 64.8 24 93H112c-6.7 0-12.7-4.2-15-10.4s-.5-13.3 4.6-17.7L171 232.3 18.4 255.8c-7 1.1-13.9-2.6-16.9-9s-1.5-14.1 3.8-18.8L130.9 116.5z"
    ]
};
var $d8206b3ab2e65c05$export$cdbdd2118099ae07 = {
    prefix: "fas",
    iconName: "shoe-prints",
    icon: [
        640,
        512,
        [],
        "f54b",
        "M416 0C352.3 0 256 32 256 32V160c48 0 76 16 104 32s56 32 104 32c56.4 0 176-16 176-96S512 0 416 0zM128 96c0 35.3 28.7 64 64 64h32V32H192c-35.3 0-64 28.7-64 64zM288 512c96 0 224-48 224-128s-119.6-96-176-96c-48 0-76 16-104 32s-56 32-104 32V480s96.3 32 160 32zM0 416c0 35.3 28.7 64 64 64H96V352H64c-35.3 0-64 28.7-64 64z"
    ]
};
var $d8206b3ab2e65c05$export$eeda28b8ca4cb18e = {
    prefix: "fas",
    iconName: "circle-plus",
    icon: [
        512,
        512,
        [
            "plus-circle"
        ],
        "f055",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM232 344V280H168c-13.3 0-24-10.7-24-24s10.7-24 24-24h64V168c0-13.3 10.7-24 24-24s24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H280v64c0 13.3-10.7 24-24 24s-24-10.7-24-24z"
    ]
};
var $d8206b3ab2e65c05$export$d9cc3a81499af48c = $d8206b3ab2e65c05$export$eeda28b8ca4cb18e;
var $d8206b3ab2e65c05$export$4272e56f2429da88 = {
    prefix: "fas",
    iconName: "face-grin-tongue-wink",
    icon: [
        512,
        512,
        [
            128540,
            "grin-tongue-wink"
        ],
        "f58b",
        "M174.5 498.8C73.1 464.7 0 368.9 0 256C0 114.6 114.6 0 256 0S512 114.6 512 256c0 112.9-73.1 208.7-174.5 242.8C346.7 484 352 466.6 352 448V401.1c24.3-17.5 43.6-41.6 55.4-69.6c5-11.8-7-22.5-19.3-18.7c-39.7 12.2-84.5 19-131.8 19s-92.1-6.8-131.8-19c-12.3-3.8-24.3 6.9-19.3 18.7c11.7 27.8 30.8 51.7 54.8 69.2V448c0 18.6 5.3 36 14.5 50.8zm20.7-265.2c5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4c-30.4-40.5-91.2-40.5-121.6 0c-5.3 7.1-3.9 17.1 3.2 22.4s17.1 3.9 22.4-3.2c17.6-23.5 52.8-23.5 70.4 0zM336 272a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM320 402.6V448c0 35.3-28.7 64-64 64s-64-28.7-64-64V402.6c0-14.7 11.9-26.6 26.6-26.6h2c11.3 0 21.1 7.9 23.6 18.9c2.8 12.6 20.8 12.6 23.6 0c2.5-11.1 12.3-18.9 23.6-18.9h2c14.7 0 26.6 11.9 26.6 26.6zM336 184a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
    ]
};
var $d8206b3ab2e65c05$export$58099903d50aefb3 = $d8206b3ab2e65c05$export$4272e56f2429da88;
var $d8206b3ab2e65c05$export$e6094d25274088ab = {
    prefix: "fas",
    iconName: "hand-holding",
    icon: [
        576,
        512,
        [],
        "f4bd",
        "M559.7 392.2c17.8-13.1 21.6-38.1 8.5-55.9s-38.1-21.6-55.9-8.5L392.6 416H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h16 64c17.7 0 32-14.3 32-32s-14.3-32-32-32H288 272 193.7c-29.1 0-57.3 9.9-80 28L68.8 384H32c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H192 352.5c29 0 57.3-9.3 80.7-26.5l126.6-93.3zm-366.1-8.3a.5 .5 0 1 1 -.9 .2 .5 .5 0 1 1 .9-.2z"
    ]
};
var $d8206b3ab2e65c05$export$d893dd9509763a17 = {
    prefix: "fas",
    iconName: "plug-circle-exclamation",
    icon: [
        576,
        512,
        [],
        "e55d",
        "M96 0C78.3 0 64 14.3 64 32v96h64V32c0-17.7-14.3-32-32-32zM288 0c-17.7 0-32 14.3-32 32v96h64V32c0-17.7-14.3-32-32-32zM32 160c-17.7 0-32 14.3-32 32s14.3 32 32 32v32c0 77.4 55 142 128 156.8V480c0 17.7 14.3 32 32 32s32-14.3 32-32V412.8c12.3-2.5 24.1-6.4 35.1-11.5c-2.1-10.8-3.1-21.9-3.1-33.3c0-80.3 53.8-148 127.3-169.2c.5-2.2 .7-4.5 .7-6.8c0-17.7-14.3-32-32-32H32zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V288c0-8.8 7.2-16 16-16z"
    ]
};
var $d8206b3ab2e65c05$export$22965c7f4d903953 = {
    prefix: "fas",
    iconName: "link-slash",
    icon: [
        640,
        512,
        [
            "chain-broken",
            "chain-slash",
            "unlink"
        ],
        "f127",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L489.3 358.2l90.5-90.5c56.5-56.5 56.5-148 0-204.5c-50-50-128.8-56.5-186.3-15.4l-1.6 1.1c-14.4 10.3-17.7 30.3-7.4 44.6s30.3 17.7 44.6 7.4l1.6-1.1c32.1-22.9 76-19.3 103.8 8.6c31.5 31.5 31.5 82.5 0 114l-96 96-31.9-25C430.9 239.6 420.1 175.1 377 132c-52.2-52.3-134.5-56.2-191.3-11.7L38.8 5.1zM239 162c30.1-14.9 67.7-9.9 92.8 15.3c20 20 27.5 48.3 21.7 74.5L239 162zM116.6 187.9L60.2 244.3c-56.5 56.5-56.5 148 0 204.5c50 50 128.8 56.5 186.3 15.4l1.6-1.1c14.4-10.3 17.7-30.3 7.4-44.6s-30.3-17.7-44.6-7.4l-1.6 1.1c-32.1 22.9-76 19.3-103.8-8.6C74 372 74 321 105.5 289.5l61.8-61.8-50.6-39.9zM220.9 270c-2.1 39.8 12.2 80.1 42.2 110c38.9 38.9 94.4 51 143.6 36.3L220.9 270z"
    ]
};
var $d8206b3ab2e65c05$export$382551e04f32620a = $d8206b3ab2e65c05$export$22965c7f4d903953;
var $d8206b3ab2e65c05$export$12f09d657be59586 = $d8206b3ab2e65c05$export$22965c7f4d903953;
var $d8206b3ab2e65c05$export$2f546f7d8ba01e18 = $d8206b3ab2e65c05$export$22965c7f4d903953;
var $d8206b3ab2e65c05$export$76c1aa4bf9a39458 = {
    prefix: "fas",
    iconName: "clone",
    icon: [
        512,
        512,
        [],
        "f24d",
        "M288 448H64V224h64V160H64c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H288c35.3 0 64-28.7 64-64V384H288v64zm-64-96H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H224c-35.3 0-64 28.7-64 64V288c0 35.3 28.7 64 64 64z"
    ]
};
var $d8206b3ab2e65c05$export$5a200e8504b7367a = {
    prefix: "fas",
    iconName: "person-walking-arrow-loop-left",
    icon: [
        640,
        512,
        [],
        "e551",
        "M208 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM123.7 200.5c1-.4 1.9-.8 2.9-1.2l-16.9 63.5c-5.6 21.1-.1 43.6 14.7 59.7l70.7 77.1 22 88.1c4.3 17.1 21.7 27.6 38.8 23.3s27.6-21.7 23.3-38.8l-23-92.1c-1.9-7.8-5.8-14.9-11.2-20.8l-49.5-54 19.3-65.5 9.6 23c4.4 10.6 12.5 19.3 22.8 24.5l26.7 13.3c15.8 7.9 35 1.5 42.9-14.3s1.5-35-14.3-42.9L281 232.7l-15.3-36.8C248.5 154.8 208.3 128 163.7 128c-22.8 0-45.3 4.8-66.1 14l-8 3.5c-32.9 14.6-58.1 42.4-69.4 76.5l-2.6 7.8c-5.6 16.8 3.5 34.9 20.2 40.5s34.9-3.5 40.5-20.2l2.6-7.8c5.7-17.1 18.3-30.9 34.7-38.2l8-3.5zm-30 135.1L68.7 398 9.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L116.3 441c4.6-4.6 8.2-10.1 10.6-16.1l14.5-36.2-40.7-44.4c-2.5-2.7-4.8-5.6-7-8.6zm347.7 119c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L461.3 384H480c88.4 0 160-71.6 160-160s-71.6-160-160-160L352 64c-17.7 0-32 14.3-32 32s14.3 32 32 32l128 0c53 0 96 43 96 96s-43 96-96 96H461.3l25.4-25.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-80 80c-12.5 12.5-12.5 32.8 0 45.3l80 80z"
    ]
};
var $d8206b3ab2e65c05$export$a0a53d8e3c68e9f1 = {
    prefix: "fas",
    iconName: "arrow-up-z-a",
    icon: [
        576,
        512,
        [
            "sort-alpha-up-alt"
        ],
        "f882",
        "M183.6 42.4C177.5 35.8 169 32 160 32s-17.5 3.8-23.6 10.4l-88 96c-11.9 13-11.1 33.3 2 45.2s33.3 11.1 45.2-2L128 146.3V448c0 17.7 14.3 32 32 32s32-14.3 32-32V146.3l32.4 35.4c11.9 13 32.2 13.9 45.2 2s13.9-32.2 2-45.2l-88-96zM320 64c0 17.7 14.3 32 32 32h50.7l-73.4 73.4c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H429.3l73.4-73.4c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8H352c-17.7 0-32 14.3-32 32zm96 192c-12.1 0-23.2 6.8-28.6 17.7l-64 128-16 32c-7.9 15.8-1.5 35 14.3 42.9s35 1.5 42.9-14.3l7.2-14.3h88.4l7.2 14.3c7.9 15.8 27.1 22.2 42.9 14.3s22.2-27.1 14.3-42.9l-16-32-64-128C439.2 262.8 428.1 256 416 256zM395.8 400L416 359.6 436.2 400H395.8z"
    ]
};
var $d8206b3ab2e65c05$export$95ef20828693fb0f = $d8206b3ab2e65c05$export$a0a53d8e3c68e9f1;
var $d8206b3ab2e65c05$export$769724fc1434d618 = {
    prefix: "fas",
    iconName: "fire-flame-curved",
    icon: [
        384,
        512,
        [
            "fire-alt"
        ],
        "f7e4",
        "M153.6 29.9l16-21.3C173.6 3.2 180 0 186.7 0C198.4 0 208 9.6 208 21.3V43.5c0 13.1 5.4 25.7 14.9 34.7L307.6 159C356.4 205.6 384 270.2 384 337.7C384 434 306 512 209.7 512H192C86 512 0 426 0 320v-3.8c0-48.8 19.4-95.6 53.9-130.1l3.5-3.5c4.2-4.2 10-6.6 16-6.6C85.9 176 96 186.1 96 198.6V288c0 35.3 28.7 64 64 64s64-28.7 64-64v-3.9c0-18-7.2-35.3-19.9-48l-38.6-38.6c-24-24-37.5-56.7-37.5-90.7c0-27.7 9-54.8 25.6-76.9z"
    ]
};
var $d8206b3ab2e65c05$export$70dc26b4926d0b1b = $d8206b3ab2e65c05$export$769724fc1434d618;
var $d8206b3ab2e65c05$export$6d274258ba4b0089 = {
    prefix: "fas",
    iconName: "tornado",
    icon: [
        448,
        512,
        [
            127786
        ],
        "f76f",
        "M0 32V45.6C0 62.7 1.7 79.6 5 96H357.8c3.2-6.9 7.5-13.3 13-18.8l38.6-38.6c4.2-4.2 6.6-10 6.6-16C416 10.1 405.9 0 393.4 0H32C14.3 0 0 14.3 0 32zm352.2 96H13.6c12.2 35.9 32.3 68.7 58.8 96H412l-47.2-62.9c-7.3-9.7-11.6-21.2-12.6-33.1zm-226 138.2l116.4 68.5c8.2 4.8 15.8 10.7 22.5 17.3H445c2-9.8 3-19.9 3-30.1c0-23-5.3-45.5-15.3-65.9H110.2c5.2 3.6 10.5 7 16 10.2zM288 384c10.3 21.4 13.8 45.5 9.9 69l-5.9 35.7c-2 12.2 7.4 23.4 19.8 23.4c5.3 0 10.4-2.1 14.2-5.9l78.2-78.2c12.8-12.8 23.1-27.7 30.4-43.9H288z"
    ]
};
var $d8206b3ab2e65c05$export$430d63b54b1d4009 = {
    prefix: "fas",
    iconName: "file-circle-plus",
    icon: [
        576,
        512,
        [
            58606
        ],
        "e494",
        "M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384v38.6C310.1 219.5 256 287.4 256 368c0 59.1 29.1 111.3 73.7 143.3c-3.2 .5-6.4 .7-9.7 .7H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128zm48 96a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm16 80c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H368c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v48c0 8.8 7.2 16 16 16s16-7.2 16-16V384h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H448V304z"
    ]
};
var $d8206b3ab2e65c05$export$ad3212bc3fa1595b = {
    prefix: "fas",
    iconName: "book-quran",
    icon: [
        448,
        512,
        [
            "quran"
        ],
        "f687",
        "M352 0c53 0 96 43 96 96V416c0 53-43 96-96 96H64 32c-17.7 0-32-14.3-32-32s14.3-32 32-32V384c-17.7 0-32-14.3-32-32V32C0 14.3 14.3 0 32 0H64 352zm0 384H96v64H352c17.7 0 32-14.3 32-32s-14.3-32-32-32zM274.1 150.2l-8.9 21.4-23.1 1.9c-5.7 .5-8 7.5-3.7 11.2L256 199.8l-5.4 22.6c-1.3 5.5 4.7 9.9 9.6 6.9L280 217.2l19.8 12.1c4.9 3 10.9-1.4 9.6-6.9L304 199.8l17.6-15.1c4.3-3.7 2-10.8-3.7-11.2l-23.1-1.9-8.9-21.4c-2.2-5.3-9.6-5.3-11.8 0zM96 192c0 70.7 57.3 128 128 128c25.6 0 49.5-7.5 69.5-20.5c3.2-2.1 4.5-6.2 3.1-9.7s-5.2-5.6-9-4.8c-6.1 1.2-12.5 1.9-19 1.9c-52.4 0-94.9-42.5-94.9-94.9s42.5-94.9 94.9-94.9c6.5 0 12.8 .7 19 1.9c3.8 .8 7.5-1.3 9-4.8s.2-7.6-3.1-9.7C273.5 71.5 249.6 64 224 64C153.3 64 96 121.3 96 192z"
    ]
};
var $d8206b3ab2e65c05$export$46f29ea84ed4c5f1 = $d8206b3ab2e65c05$export$ad3212bc3fa1595b;
var $d8206b3ab2e65c05$export$12a35719f889cd1 = {
    prefix: "fas",
    iconName: "anchor",
    icon: [
        576,
        512,
        [
            9875
        ],
        "f13d",
        "M320 96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm21.1 80C367 158.8 384 129.4 384 96c0-53-43-96-96-96s-96 43-96 96c0 33.4 17 62.8 42.9 80H224c-17.7 0-32 14.3-32 32s14.3 32 32 32h32V448H208c-53 0-96-43-96-96v-6.1l7 7c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L97 263c-9.4-9.4-24.6-9.4-33.9 0L7 319c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l7-7V352c0 88.4 71.6 160 160 160h80 80c88.4 0 160-71.6 160-160v-6.1l7 7c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-56-56c-9.4-9.4-24.6-9.4-33.9 0l-56 56c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l7-7V352c0 53-43 96-96 96H320V240h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H341.1z"
    ]
};
var $d8206b3ab2e65c05$export$93a5eb721c9c0d25 = {
    prefix: "fas",
    iconName: "border-all",
    icon: [
        448,
        512,
        [],
        "f84c",
        "M384 96V224H256V96H384zm0 192V416H256V288H384zM192 224H64V96H192V224zM64 288H192V416H64V288zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64z"
    ]
};
var $d8206b3ab2e65c05$export$67a047c738fb34da = {
    prefix: "fas",
    iconName: "face-angry",
    icon: [
        512,
        512,
        [
            128544,
            "angry"
        ],
        "f556",
        "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM338.7 395.9c6.6-5.9 7.1-16 1.2-22.6C323.8 355.4 295.7 336 256 336s-67.8 19.4-83.9 37.3c-5.9 6.6-5.4 16.7 1.2 22.6s16.7 5.4 22.6-1.2c11.7-13 31.6-26.7 60.1-26.7s48.4 13.7 60.1 26.7c5.9 6.6 16 7.1 22.6 1.2zM176.4 272c17.7 0 32-14.3 32-32c0-1.5-.1-3-.3-4.4l10.9 3.6c8.4 2.8 17.4-1.7 20.2-10.1s-1.7-17.4-10.1-20.2l-96-32c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2l30.7 10.2c-5.8 5.8-9.3 13.8-9.3 22.6c0 17.7 14.3 32 32 32zm192-32c0-8.9-3.6-17-9.5-22.8l30.2-10.1c8.4-2.8 12.9-11.9 10.1-20.2s-11.9-12.9-20.2-10.1l-96 32c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l11.7-3.9c-.2 1.5-.3 3.1-.3 4.7c0 17.7 14.3 32 32 32s32-14.3 32-32z"
    ]
};
var $d8206b3ab2e65c05$export$3c96c08e234498c5 = $d8206b3ab2e65c05$export$67a047c738fb34da;
var $d8206b3ab2e65c05$export$317dde8664f7de71 = {
    prefix: "fas",
    iconName: "cookie-bite",
    icon: [
        512,
        512,
        [],
        "f564",
        "M257.5 27.6c-.8-5.4-4.9-9.8-10.3-10.6v0c-22.1-3.1-44.6 .9-64.4 11.4l-74 39.5C89.1 78.4 73.2 94.9 63.4 115L26.7 190.6c-9.8 20.1-13 42.9-9.1 64.9l14.5 82.8c3.9 22.1 14.6 42.3 30.7 57.9l60.3 58.4c16.1 15.6 36.6 25.6 58.7 28.7l83 11.7c22.1 3.1 44.6-.9 64.4-11.4l74-39.5c19.7-10.5 35.6-27 45.4-47.2l36.7-75.5c9.8-20.1 13-42.9 9.1-64.9v0c-.9-5.3-5.3-9.3-10.6-10.1c-51.5-8.2-92.8-47.1-104.5-97.4c-1.8-7.6-8-13.4-15.7-14.6c-54.6-8.7-97.7-52-106.2-106.8zM208 144a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM144 336a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm224-64a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $d8206b3ab2e65c05$export$d2caed5e37174c23 = {
    prefix: "fas",
    iconName: "arrow-trend-down",
    icon: [
        576,
        512,
        [],
        "e097",
        "M384 352c-17.7 0-32 14.3-32 32s14.3 32 32 32H544c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32s-32 14.3-32 32v82.7L342.6 137.4c-12.5-12.5-32.8-12.5-45.3 0L192 242.7 54.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0L320 205.3 466.7 352H384z"
    ]
};
var $d8206b3ab2e65c05$export$7329a1ca27b90c5b = {
    prefix: "fas",
    iconName: "rss",
    icon: [
        448,
        512,
        [
            "feed"
        ],
        "f09e",
        "M0 64C0 46.3 14.3 32 32 32c229.8 0 416 186.2 416 416c0 17.7-14.3 32-32 32s-32-14.3-32-32C384 253.6 226.4 96 32 96C14.3 96 0 81.7 0 64zM0 416a64 64 0 1 1 128 0A64 64 0 1 1 0 416zM32 160c159.1 0 288 128.9 288 288c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-123.7-100.3-224-224-224c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
    ]
};
var $d8206b3ab2e65c05$export$67ad3d0233cd7b33 = $d8206b3ab2e65c05$export$7329a1ca27b90c5b;
var $d8206b3ab2e65c05$export$df9bd3777d1154d2 = {
    prefix: "fas",
    iconName: "draw-polygon",
    icon: [
        448,
        512,
        [],
        "f5ee",
        "M96 151.4V360.6c9.7 5.6 17.8 13.7 23.4 23.4H328.6c0-.1 .1-.2 .1-.3l-4.5-7.9-32-56 0 0c-1.4 .1-2.8 .1-4.2 .1c-35.3 0-64-28.7-64-64s28.7-64 64-64c1.4 0 2.8 0 4.2 .1l0 0 32-56 4.5-7.9-.1-.3H119.4c-5.6 9.7-13.7 17.8-23.4 23.4zM384.3 352c35.2 .2 63.7 28.7 63.7 64c0 35.3-28.7 64-64 64c-23.7 0-44.4-12.9-55.4-32H119.4c-11.1 19.1-31.7 32-55.4 32c-35.3 0-64-28.7-64-64c0-23.7 12.9-44.4 32-55.4V151.4C12.9 140.4 0 119.7 0 96C0 60.7 28.7 32 64 32c23.7 0 44.4 12.9 55.4 32H328.6c11.1-19.1 31.7-32 55.4-32c35.3 0 64 28.7 64 64c0 35.3-28.5 63.8-63.7 64l-4.5 7.9-32 56-2.3 4c4.2 8.5 6.5 18 6.5 28.1s-2.3 19.6-6.5 28.1l2.3 4 32 56 4.5 7.9z"
    ]
};
var $d8206b3ab2e65c05$export$33fb4280dc20f0dd = {
    prefix: "fas",
    iconName: "scale-balanced",
    icon: [
        640,
        512,
        [
            9878,
            "balance-scale"
        ],
        "f24e",
        "M384 32H512c17.7 0 32 14.3 32 32s-14.3 32-32 32H398.4c-5.2 25.8-22.9 47.1-46.4 57.3V448H512c17.7 0 32 14.3 32 32s-14.3 32-32 32H320 128c-17.7 0-32-14.3-32-32s14.3-32 32-32H288V153.3c-23.5-10.3-41.2-31.6-46.4-57.3H128c-17.7 0-32-14.3-32-32s14.3-32 32-32H256c14.6-19.4 37.8-32 64-32s49.4 12.6 64 32zm55.6 288H584.4L512 195.8 439.6 320zM512 416c-62.9 0-115.2-34-126-78.9c-2.6-11 1-22.3 6.7-32.1l95.2-163.2c5-8.6 14.2-13.8 24.1-13.8s19.1 5.3 24.1 13.8l95.2 163.2c5.7 9.8 9.3 21.1 6.7 32.1C627.2 382 574.9 416 512 416zM126.8 195.8L54.4 320H199.3L126.8 195.8zM.9 337.1c-2.6-11 1-22.3 6.7-32.1l95.2-163.2c5-8.6 14.2-13.8 24.1-13.8s19.1 5.3 24.1 13.8l95.2 163.2c5.7 9.8 9.3 21.1 6.7 32.1C242 382 189.7 416 126.8 416S11.7 382 .9 337.1z"
    ]
};
var $d8206b3ab2e65c05$export$fec323dcfd81d750 = $d8206b3ab2e65c05$export$33fb4280dc20f0dd;
var $d8206b3ab2e65c05$export$cc4351eb13da27d8 = {
    prefix: "fas",
    iconName: "gauge-simple-high",
    icon: [
        512,
        512,
        [
            61668,
            "tachometer",
            "tachometer-fast"
        ],
        "f62a",
        "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm320 96c0-15.9-5.8-30.4-15.3-41.6l76.6-147.4c6.1-11.8 1.5-26.3-10.2-32.4s-26.2-1.5-32.4 10.2L262.1 288.3c-2-.2-4-.3-6.1-.3c-35.3 0-64 28.7-64 64s28.7 64 64 64s64-28.7 64-64z"
    ]
};
var $d8206b3ab2e65c05$export$362d0f652c3fbca2 = $d8206b3ab2e65c05$export$cc4351eb13da27d8;
var $d8206b3ab2e65c05$export$375b6a8680f980ed = $d8206b3ab2e65c05$export$cc4351eb13da27d8;
var $d8206b3ab2e65c05$export$f7f7c15f18cc19a1 = {
    prefix: "fas",
    iconName: "shower",
    icon: [
        512,
        512,
        [
            128703
        ],
        "f2cc",
        "M64 131.9C64 112.1 80.1 96 99.9 96c9.5 0 18.6 3.8 25.4 10.5l16.2 16.2c-21 38.9-17.4 87.5 10.9 123L151 247c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L345 121c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-1.3 1.3c-35.5-28.3-84.2-31.9-123-10.9L170.5 61.3C151.8 42.5 126.4 32 99.9 32C44.7 32 0 76.7 0 131.9V448c0 17.7 14.3 32 32 32s32-14.3 32-32V131.9zM256 352a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm64 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm0-128a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm64 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm0-128a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm64 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm32-32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
var $d8206b3ab2e65c05$export$6e6ddc253102e596 = {
    prefix: "fas",
    iconName: "desktop",
    icon: [
        576,
        512,
        [
            128421,
            61704,
            "desktop-alt"
        ],
        "f390",
        "M64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64H240l-10.7 32H160c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H346.7L336 416H512c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM512 64V288H64V64H512z"
    ]
};
var $d8206b3ab2e65c05$export$ff09a62b9e0fa899 = $d8206b3ab2e65c05$export$6e6ddc253102e596;
var $d8206b3ab2e65c05$export$bd6a7788954842b5 = {
    prefix: "fas",
    iconName: "m",
    icon: [
        448,
        512,
        [
            109
        ],
        "4d",
        "M22.7 33.4c13.5-4.1 28.1 1.1 35.9 12.9L224 294.3 389.4 46.2c7.8-11.7 22.4-17 35.9-12.9S448 49.9 448 64V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V169.7L250.6 369.8c-5.9 8.9-15.9 14.2-26.6 14.2s-20.7-5.3-26.6-14.2L64 169.7V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V64C0 49.9 9.2 37.5 22.7 33.4z"
    ]
};
var $d8206b3ab2e65c05$export$6e989c3c7050dbb = {
    prefix: "fas",
    iconName: "table-list",
    icon: [
        512,
        512,
        [
            "th-list"
        ],
        "f00b",
        "M0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm64 0v64h64V96H64zm384 0H192v64H448V96zM64 224v64h64V224H64zm384 0H192v64H448V224zM64 352v64h64V352H64zm384 0H192v64H448V352z"
    ]
};
var $d8206b3ab2e65c05$export$daf2614a457122c0 = $d8206b3ab2e65c05$export$6e989c3c7050dbb;
var $d8206b3ab2e65c05$export$435fe17e9d6170d6 = {
    prefix: "fas",
    iconName: "comment-sms",
    icon: [
        512,
        512,
        [
            "sms"
        ],
        "f7cd",
        "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zM96 212.8c0-20.3 16.5-36.8 36.8-36.8H152c8.8 0 16 7.2 16 16s-7.2 16-16 16H132.8c-2.7 0-4.8 2.2-4.8 4.8c0 1.6 .8 3.1 2.2 4l29.4 19.6c10.3 6.8 16.4 18.3 16.4 30.7c0 20.3-16.5 36.8-36.8 36.8H112c-8.8 0-16-7.2-16-16s7.2-16 16-16h27.2c2.7 0 4.8-2.2 4.8-4.8c0-1.6-.8-3.1-2.2-4l-29.4-19.6C102.2 236.7 96 225.2 96 212.8zM372.8 176H392c8.8 0 16 7.2 16 16s-7.2 16-16 16H372.8c-2.7 0-4.8 2.2-4.8 4.8c0 1.6 .8 3.1 2.2 4l29.4 19.6c10.2 6.8 16.4 18.3 16.4 30.7c0 20.3-16.5 36.8-36.8 36.8H352c-8.8 0-16-7.2-16-16s7.2-16 16-16h27.2c2.7 0 4.8-2.2 4.8-4.8c0-1.6-.8-3.1-2.2-4l-29.4-19.6c-10.2-6.8-16.4-18.3-16.4-30.7c0-20.3 16.5-36.8 36.8-36.8zm-152 6.4L256 229.3l35.2-46.9c4.1-5.5 11.3-7.8 17.9-5.6s10.9 8.3 10.9 15.2v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V240l-19.2 25.6c-3 4-7.8 6.4-12.8 6.4s-9.8-2.4-12.8-6.4L224 240v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V192c0-6.9 4.4-13 10.9-15.2s13.7 .1 17.9 5.6z"
    ]
};
var $d8206b3ab2e65c05$export$9dbcc3443daa7323 = $d8206b3ab2e65c05$export$435fe17e9d6170d6;
var $d8206b3ab2e65c05$export$c9d7ef726d1a8742 = {
    prefix: "fas",
    iconName: "book",
    icon: [
        448,
        512,
        [
            128212
        ],
        "f02d",
        "M96 0C43 0 0 43 0 96V416c0 53 43 96 96 96H384h32c17.7 0 32-14.3 32-32s-14.3-32-32-32V384c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32H384 96zm0 384H352v64H96c-17.7 0-32-14.3-32-32s14.3-32 32-32zm32-240c0-8.8 7.2-16 16-16H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16zm16 48H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
    ]
};
var $d8206b3ab2e65c05$export$4c17261776a709f2 = {
    prefix: "fas",
    iconName: "user-plus",
    icon: [
        640,
        512,
        [],
        "f234",
        "M96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM0 482.3C0 383.8 79.8 304 178.3 304h91.4C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3zM504 312V248H440c-13.3 0-24-10.7-24-24s10.7-24 24-24h64V136c0-13.3 10.7-24 24-24s24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H552v64c0 13.3-10.7 24-24 24s-24-10.7-24-24z"
    ]
};
var $d8206b3ab2e65c05$export$62b2c752fccc6a9c = {
    prefix: "fas",
    iconName: "check",
    icon: [
        448,
        512,
        [
            10003,
            10004
        ],
        "f00c",
        "M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"
    ]
};
var $d8206b3ab2e65c05$export$cfb37069d38f379e = {
    prefix: "fas",
    iconName: "battery-three-quarters",
    icon: [
        576,
        512,
        [
            "battery-4"
        ],
        "f241",
        "M464 160c8.8 0 16 7.2 16 16V336c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16H464zM80 96C35.8 96 0 131.8 0 176V336c0 44.2 35.8 80 80 80H464c44.2 0 80-35.8 80-80V320c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32V176c0-44.2-35.8-80-80-80H80zm272 96H96V320H352V192z"
    ]
};
var $d8206b3ab2e65c05$export$35ffefed200d123c = $d8206b3ab2e65c05$export$cfb37069d38f379e;
var $d8206b3ab2e65c05$export$c9382fa3394ef53a = {
    prefix: "fas",
    iconName: "house-circle-check",
    icon: [
        640,
        512,
        [],
        "e509",
        "M320.7 352c8.1-89.7 83.5-160 175.3-160c8.9 0 17.6 .7 26.1 1.9L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24c0 18 14 32.1 32 32.1h32v69.7c-.1 .9-.1 1.8-.1 2.8V472c0 22.1 17.9 40 40 40h16c1.2 0 2.4-.1 3.6-.2c1.5 .1 3 .2 4.5 .2H160h24c22.1 0 40-17.9 40-40V448 384c0-17.7 14.3-32 32-32h64l.7 0zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"
    ]
};
var $d8206b3ab2e65c05$export$3cbcd1b7e35945d2 = {
    prefix: "fas",
    iconName: "angle-left",
    icon: [
        320,
        512,
        [
            8249
        ],
        "f104",
        "M41.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 256 246.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z"
    ]
};
var $d8206b3ab2e65c05$export$ff7f40159cadb0ac = {
    prefix: "fas",
    iconName: "diagram-successor",
    icon: [
        512,
        512,
        [],
        "e47a",
        "M512 416l0-64c0-35.3-28.7-64-64-64L64 288c-35.3 0-64 28.7-64 64l0 64c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64zM64 160l0-64 144 0 16 0 0 64L64 160zm224 0l0-64 80 0c8.8 0 16 7.2 16 16l0 16-38.1 0c-21.4 0-32.1 25.9-17 41L399 239c9.4 9.4 24.6 9.4 33.9 0L503 169c15.1-15.1 4.4-41-17-41L448 128l0-16c0-44.2-35.8-80-80-80L224 32l-16 0L64 32C28.7 32 0 60.7 0 96l0 64c0 35.3 28.7 64 64 64l160 0c35.3 0 64-28.7 64-64z"
    ]
};
var $d8206b3ab2e65c05$export$d69fa2b7839ce76 = {
    prefix: "fas",
    iconName: "truck-arrow-right",
    icon: [
        640,
        512,
        [],
        "e58b",
        "M0 48C0 21.5 21.5 0 48 0H368c26.5 0 48 21.5 48 48V96h50.7c17 0 33.3 6.7 45.3 18.7L589.3 192c12 12 18.7 28.3 18.7 45.3V256v32 64c17.7 0 32 14.3 32 32s-14.3 32-32 32H576c0 53-43 96-96 96s-96-43-96-96H256c0 53-43 96-96 96s-96-43-96-96H48c-26.5 0-48-21.5-48-48V48zM416 256H544V237.3L466.7 160H416v96zM160 464a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm368-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM257 95c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l39 39H96c-13.3 0-24 10.7-24 24s10.7 24 24 24H262.1l-39 39c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9L257 95z"
    ]
};
var $d8206b3ab2e65c05$export$7df274119d2469d1 = {
    prefix: "fas",
    iconName: "arrows-split-up-and-left",
    icon: [
        512,
        512,
        [],
        "e4bc",
        "M246.6 150.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l96-96c12.5-12.5 32.8-12.5 45.3 0l96 96c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L352 109.3V384c0 35.3 28.7 64 64 64h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H416c-70.7 0-128-57.3-128-128c0-35.3-28.7-64-64-64H109.3l41.4 41.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-96-96c-12.5-12.5-12.5-32.8 0-45.3l96-96c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L109.3 256H224c23.3 0 45.2 6.2 64 17.1V109.3l-41.4 41.4z"
    ]
};
var $d8206b3ab2e65c05$export$ca492f58fe30a42f = {
    prefix: "fas",
    iconName: "hand-fist",
    icon: [
        448,
        512,
        [
            9994,
            "fist-raised"
        ],
        "f6de",
        "M192 0c17.7 0 32 14.3 32 32V144H160V32c0-17.7 14.3-32 32-32zM64 64c0-17.7 14.3-32 32-32s32 14.3 32 32v80H64V64zm192 0c0-17.7 14.3-32 32-32s32 14.3 32 32v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V64zm96 64c0-17.7 14.3-32 32-32s32 14.3 32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V128zm-96 88l0-.6c9.4 5.4 20.3 8.6 32 8.6c13.2 0 25.4-4 35.6-10.8c8.7 24.9 32.5 42.8 60.4 42.8c11.7 0 22.6-3.1 32-8.6V256c0 52.3-25.1 98.8-64 128v96c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32V401.6c-17.3-7.9-33.2-18.8-46.9-32.5L69.5 357.5C45.5 333.5 32 300.9 32 267V240c0-35.3 28.7-64 64-64h88c22.1 0 40 17.9 40 40s-17.9 40-40 40H128c-8.8 0-16 7.2-16 16s7.2 16 16 16h56c39.8 0 72-32.2 72-72z"
    ]
};
var $d8206b3ab2e65c05$export$fa0323a4d7489a8d = $d8206b3ab2e65c05$export$ca492f58fe30a42f;
var $d8206b3ab2e65c05$export$482eb125aaf0fbc2 = {
    prefix: "fas",
    iconName: "cloud-moon",
    icon: [
        640,
        512,
        [],
        "f6c3",
        "M495.8 0c5.5 0 10.9 .2 16.3 .7c7 .6 12.8 5.7 14.3 12.5s-1.6 13.9-7.7 17.3c-44.4 25.2-74.4 73-74.4 127.8c0 81 65.5 146.6 146.2 146.6c8.6 0 17-.7 25.1-2.1c6.9-1.2 13.8 2.2 17 8.5s1.9 13.8-3.1 18.7c-34.5 33.6-81.7 54.4-133.6 54.4c-9.3 0-18.4-.7-27.4-1.9c-11.2-22.6-29.8-40.9-52.6-51.7c-2.7-58.5-50.3-105.3-109.2-106.7c-1.7-10.4-2.6-21-2.6-31.8C304 86.1 389.8 0 495.8 0zM447.9 431.9c0 44.2-35.8 80-80 80H96c-53 0-96-43-96-96c0-47.6 34.6-87 80-94.6l0-1.3c0-53 43-96 96-96c34.9 0 65.4 18.6 82.2 46.4c13-9.1 28.8-14.4 45.8-14.4c44.2 0 80 35.8 80 80c0 5.9-.6 11.7-1.9 17.2c37.4 6.7 65.8 39.4 65.8 78.7z"
    ]
};
var $d8206b3ab2e65c05$export$8da450d063b0eb37 = {
    prefix: "fas",
    iconName: "briefcase",
    icon: [
        512,
        512,
        [
            128188
        ],
        "f0b1",
        "M184 48H328c4.4 0 8 3.6 8 8V96H176V56c0-4.4 3.6-8 8-8zm-56 8V96H64C28.7 96 0 124.7 0 160v96H192 320 512V160c0-35.3-28.7-64-64-64H384V56c0-30.9-25.1-56-56-56H184c-30.9 0-56 25.1-56 56zM512 288H320v32c0 17.7-14.3 32-32 32H224c-17.7 0-32-14.3-32-32V288H0V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V288z"
    ]
};
var $d8206b3ab2e65c05$export$e94ab3a30cf4aca5 = {
    prefix: "fas",
    iconName: "person-falling",
    icon: [
        512,
        512,
        [],
        "e546",
        "M288 0c17.7 0 32 14.3 32 32l0 9.8c0 54.6-27.9 104.6-72.5 133.6l.2 .3L304.5 256l87.5 0c15.1 0 29.3 7.1 38.4 19.2l43.2 57.6c10.6 14.1 7.7 34.2-6.4 44.8s-34.2 7.7-44.8-6.4L384 320l-96 0h-1.4l92.3 142.6c9.6 14.8 5.4 34.6-9.5 44.3s-34.6 5.4-44.3-9.5L164.5 249.2c-2.9 9.2-4.5 19-4.5 29l0 73.8c0 17.7-14.3 32-32 32s-32-14.3-32-32V278.2c0-65.1 39.6-123.7 100.1-147.9C232.3 115.8 256 80.8 256 41.8l0-9.8c0-17.7 14.3-32 32-32zM112 32a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
    ]
};
var $d8206b3ab2e65c05$export$c23fd8b91a7ed48 = {
    prefix: "fas",
    iconName: "image-portrait",
    icon: [
        384,
        512,
        [
            "portrait"
        ],
        "f3e0",
        "M384 64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64l0-384zM128 192a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM80 356.6c0-37.9 30.7-68.6 68.6-68.6h86.9c37.9 0 68.6 30.7 68.6 68.6c0 15.1-12.3 27.4-27.4 27.4H107.4C92.3 384 80 371.7 80 356.6z"
    ]
};
var $d8206b3ab2e65c05$export$e3d25f819c7ee7d7 = $d8206b3ab2e65c05$export$c23fd8b91a7ed48;
var $d8206b3ab2e65c05$export$9eec597148166b36 = {
    prefix: "fas",
    iconName: "user-tag",
    icon: [
        640,
        512,
        [],
        "f507",
        "M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H418.3c10 0 18.8-4.9 24.2-12.5l-99.2-99.2c-14.9-14.9-23.3-35.1-23.3-56.1v-33c-15.9-4.7-32.8-7.2-50.3-7.2H178.3zM384 224c-17.7 0-32 14.3-32 32v82.7c0 17 6.7 33.3 18.7 45.3L478.1 491.3c18.7 18.7 49.1 18.7 67.9 0l73.4-73.4c18.7-18.7 18.7-49.1 0-67.9L512 242.7c-12-12-28.3-18.7-45.3-18.7H384zm24 80a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"
    ]
};
var $d8206b3ab2e65c05$export$7cee7480f25f5289 = {
    prefix: "fas",
    iconName: "rug",
    icon: [
        640,
        512,
        [],
        "e569",
        "M24 64H56 80V88v88 80 80 88 24H56 24c-13.3 0-24-10.7-24-24s10.7-24 24-24h8V360H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h8V280H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h8V200H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h8V112H24C10.7 112 0 101.3 0 88S10.7 64 24 64zm88 0H528V448H112V64zM640 88c0 13.3-10.7 24-24 24h-8v40h8c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8v32h8c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8v32h8c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8v40h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H584 560V424 336 256 176 88 64h24 32c13.3 0 24 10.7 24 24z"
    ]
};
var $d8206b3ab2e65c05$export$7adefae4a1be1d97 = {
    prefix: "fas",
    iconName: "earth-europe",
    icon: [
        512,
        512,
        [
            "globe-europe"
        ],
        "f7a2",
        "M266.3 48.3L232.5 73.6c-5.4 4-8.5 10.4-8.5 17.1v9.1c0 6.8 5.5 12.3 12.3 12.3c2.4 0 4.8-.7 6.8-2.1l41.8-27.9c2-1.3 4.4-2.1 6.8-2.1h1c6.2 0 11.3 5.1 11.3 11.3c0 3-1.2 5.9-3.3 8l-19.9 19.9c-5.8 5.8-12.9 10.2-20.7 12.8l-26.5 8.8c-5.8 1.9-9.6 7.3-9.6 13.4c0 3.7-1.5 7.3-4.1 10l-17.9 17.9c-6.4 6.4-9.9 15-9.9 24v4.3c0 16.4 13.6 29.7 29.9 29.7c11 0 21.2-6.2 26.1-16l4-8.1c2.4-4.8 7.4-7.9 12.8-7.9c4.5 0 8.7 2.1 11.4 5.7l16.3 21.7c2.1 2.9 5.5 4.5 9.1 4.5c8.4 0 13.9-8.9 10.1-16.4l-1.1-2.3c-3.5-7 0-15.5 7.5-18l21.2-7.1c7.6-2.5 12.7-9.6 12.7-17.6c0-10.3 8.3-18.6 18.6-18.6H400c8.8 0 16 7.2 16 16s-7.2 16-16 16H379.3c-7.2 0-14.2 2.9-19.3 8l-4.7 4.7c-2.1 2.1-3.3 5-3.3 8c0 6.2 5.1 11.3 11.3 11.3h11.3c6 0 11.8 2.4 16 6.6l6.5 6.5c1.8 1.8 2.8 4.3 2.8 6.8s-1 5-2.8 6.8l-7.5 7.5C386 262 384 266.9 384 272s2 10 5.7 13.7L408 304c10.2 10.2 24.1 16 38.6 16H454c6.5-20.2 10-41.7 10-64c0-111.4-87.6-202.4-197.7-207.7zm172 307.9c-3.7-2.6-8.2-4.1-13-4.1c-6 0-11.8-2.4-16-6.6L396 332c-7.7-7.7-18-12-28.9-12c-9.7 0-19.2-3.5-26.6-9.8L314 287.4c-11.6-9.9-26.4-15.4-41.7-15.4H251.4c-12.6 0-25 3.7-35.5 10.7L188.5 301c-17.8 11.9-28.5 31.9-28.5 53.3v3.2c0 17 6.7 33.3 18.7 45.3l16 16c8.5 8.5 20 13.3 32 13.3H248c13.3 0 24 10.7 24 24c0 2.5 .4 5 1.1 7.3c71.3-5.8 132.5-47.6 165.2-107.2zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM187.3 100.7c-6.2-6.2-16.4-6.2-22.6 0l-32 32c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l32-32c6.2-6.2 6.2-16.4 0-22.6z"
    ]
};
var $d8206b3ab2e65c05$export$5318b8ede86cc96b = $d8206b3ab2e65c05$export$7adefae4a1be1d97;
var $d8206b3ab2e65c05$export$ab81ff863770d996 = {
    prefix: "fas",
    iconName: "cart-flatbed-suitcase",
    icon: [
        640,
        512,
        [
            "luggage-cart"
        ],
        "f59d",
        "M0 32C0 14.3 14.3 0 32 0H48c44.2 0 80 35.8 80 80V368c0 8.8 7.2 16 16 16H608c17.7 0 32 14.3 32 32s-14.3 32-32 32H541.3c1.8 5 2.7 10.4 2.7 16c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-5.6 1-11 2.7-16H253.3c1.8 5 2.7 10.4 2.7 16c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-5.6 1-11 2.7-16H144c-44.2 0-80-35.8-80-80V80c0-8.8-7.2-16-16-16H32C14.3 64 0 49.7 0 32zM432 96V56c0-4.4-3.6-8-8-8H344c-4.4 0-8 3.6-8 8V96h96zM288 96V56c0-30.9 25.1-56 56-56h80c30.9 0 56 25.1 56 56V96 320H288V96zM512 320V96h16c26.5 0 48 21.5 48 48V272c0 26.5-21.5 48-48 48H512zM240 96h16V320H240c-26.5 0-48-21.5-48-48V144c0-26.5 21.5-48 48-48z"
    ]
};
var $d8206b3ab2e65c05$export$bd1e24dd3cde8514 = $d8206b3ab2e65c05$export$ab81ff863770d996;
var $d8206b3ab2e65c05$export$3896694b3e81fba7 = {
    prefix: "fas",
    iconName: "rectangle-xmark",
    icon: [
        512,
        512,
        [
            62164,
            "rectangle-times",
            "times-rectangle",
            "window-close"
        ],
        "f410",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM175 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"
    ]
};
var $d8206b3ab2e65c05$export$eaaf26416a51dc1 = $d8206b3ab2e65c05$export$3896694b3e81fba7;
var $d8206b3ab2e65c05$export$10147c0014152a3f = $d8206b3ab2e65c05$export$3896694b3e81fba7;
var $d8206b3ab2e65c05$export$18b7775f78a3e16 = $d8206b3ab2e65c05$export$3896694b3e81fba7;
var $d8206b3ab2e65c05$export$ffc7123046a28ee = {
    prefix: "fas",
    iconName: "baht-sign",
    icon: [
        320,
        512,
        [],
        "e0ac",
        "M144 0c-17.7 0-32 14.3-32 32V64H37.6C16.8 64 0 80.8 0 101.6V224v41.7V288 406.3c0 23 18.7 41.7 41.7 41.7H112v32c0 17.7 14.3 32 32 32s32-14.3 32-32V448h32c61.9 0 112-50.1 112-112c0-40.1-21.1-75.3-52.7-95.1C280.3 222.6 288 200.2 288 176c0-61.9-50.1-112-112-112V32c0-17.7-14.3-32-32-32zM112 128v96H64V128h48zm64 96V128c26.5 0 48 21.5 48 48s-21.5 48-48 48zm-64 64v96H64V288h48zm64 96V288h32c26.5 0 48 21.5 48 48s-21.5 48-48 48H176z"
    ]
};
var $d8206b3ab2e65c05$export$8a3071811b2b7979 = {
    prefix: "fas",
    iconName: "book-open",
    icon: [
        576,
        512,
        [
            128214,
            128366
        ],
        "f518",
        "M249.6 471.5c10.8 3.8 22.4-4.1 22.4-15.5V78.6c0-4.2-1.6-8.4-5-11C247.4 52 202.4 32 144 32C93.5 32 46.3 45.3 18.1 56.1C6.8 60.5 0 71.7 0 83.8V454.1c0 11.9 12.8 20.2 24.1 16.5C55.6 460.1 105.5 448 144 448c33.9 0 79 14 105.6 23.5zm76.8 0C353 462 398.1 448 432 448c38.5 0 88.4 12.1 119.9 22.6c11.3 3.8 24.1-4.6 24.1-16.5V83.8c0-12.1-6.8-23.3-18.1-27.6C529.7 45.3 482.5 32 432 32c-58.4 0-103.4 20-123 35.6c-3.3 2.6-5 6.8-5 11V456c0 11.4 11.7 19.3 22.4 15.5z"
    ]
};
var $d8206b3ab2e65c05$export$d3d49030d557a09b = {
    prefix: "fas",
    iconName: "book-journal-whills",
    icon: [
        448,
        512,
        [
            "journal-whills"
        ],
        "f66a",
        "M0 96C0 43 43 0 96 0H384h32c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32v64c17.7 0 32 14.3 32 32s-14.3 32-32 32H384 96c-53 0-96-43-96-96V96zM64 416c0 17.7 14.3 32 32 32H352V384H96c-17.7 0-32 14.3-32 32zm90.4-234.4l-21.2-21.2c-3 10.1-5.1 20.6-5.1 31.6c0 .2 0 .5 .1 .8s.1 .5 .1 .8L165.2 226c2.5 2.1 3.4 5.8 2.3 8.9c-1.3 3-4.1 5.1-7.5 5.1c-1.9-.1-3.8-.8-5.2-2l-23.6-20.6C142.8 267 186.9 304 240 304s97.3-37 108.9-86.6L325.3 238c-1.4 1.2-3.3 2-5.3 2c-2.2-.1-4.4-1.1-6-2.8c-1.2-1.5-1.9-3.4-2-5.2c.1-2.2 1.1-4.4 2.8-6l37.1-32.5c0-.3 0-.5 .1-.8s.1-.5 .1-.8c0-11-2.1-21.5-5.1-31.6l-21.2 21.2c-3.1 3.1-8.1 3.1-11.3 0s-3.1-8.1 0-11.2l26.4-26.5c-8.2-17-20.5-31.7-35.9-42.6c-2.7-1.9-6.2 1.4-5 4.5c8.5 22.4 3.6 48-13 65.6c-3.2 3.4-3.6 8.9-.9 12.7c9.8 14 12.7 31.9 7.5 48.5c-5.9 19.4-22 34.1-41.9 38.3l-1.4-34.3 12.6 8.6c.6 .4 1.5 .6 2.3 .6c1.5 0 2.7-.8 3.5-2s.6-2.8-.1-4L260 225.4l18-3.6c1.8-.4 3.1-2.1 3.1-4s-1.4-3.5-3.1-3.9l-18-3.7 8.5-14.3c.8-1.2 .9-2.9 .1-4.1s-2-2-3.5-2l-.1 0c-.7 .1-1.5 .3-2.1 .7l-14.1 9.6L244 87.9c-.1-2.2-1.9-3.9-4-3.9s-3.9 1.6-4 3.9l-4.6 110.8-12-8.1c-1.5-1.1-3.6-.9-5 .4s-1.6 3.4-.8 5l8.6 14.3-18 3.7c-1.8 .4-3.1 2-3.1 3.9s1.4 3.6 3.1 4l18 3.8-8.6 14.2c-.2 .6-.5 1.4-.5 2c0 1.1 .5 2.1 1.2 3c.8 .6 1.8 1 2.8 1c.7 0 1.6-.2 2.2-.6l10.4-7.1-1.4 32.8c-19.9-4.1-36-18.9-41.9-38.3c-5.1-16.6-2.2-34.4 7.6-48.5c2.7-3.9 2.3-9.3-.9-12.7c-16.6-17.5-21.6-43.1-13.1-65.5c1.2-3.1-2.3-6.4-5-4.5c-15.3 10.9-27.6 25.6-35.8 42.6l26.4 26.5c3.1 3.1 3.1 8.1 0 11.2s-8.1 3.1-11.2 0z"
    ]
};
var $d8206b3ab2e65c05$export$66a0d8d45aab6631 = $d8206b3ab2e65c05$export$d3d49030d557a09b;
var $d8206b3ab2e65c05$export$74d1f89b5feb9d42 = {
    prefix: "fas",
    iconName: "handcuffs",
    icon: [
        640,
        512,
        [],
        "e4f8",
        "M240 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM192 48a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-32 80c17.7 0 32 14.3 32 32h8c13.3 0 24 10.7 24 24v16c0 1.7-.2 3.4-.5 5.1C280.3 229.6 320 286.2 320 352c0 88.4-71.6 160-160 160S0 440.4 0 352c0-65.8 39.7-122.4 96.5-146.9c-.4-1.6-.5-3.3-.5-5.1V184c0-13.3 10.7-24 24-24h8c0-17.7 14.3-32 32-32zm0 320a96 96 0 1 0 0-192 96 96 0 1 0 0 192zm192-96c0-25.9-5.1-50.5-14.4-73.1c16.9-32.9 44.8-59.1 78.9-73.9c-.4-1.6-.5-3.3-.5-5.1V184c0-13.3 10.7-24 24-24h8c0-17.7 14.3-32 32-32s32 14.3 32 32h8c13.3 0 24 10.7 24 24v16c0 1.7-.2 3.4-.5 5.1C600.3 229.6 640 286.2 640 352c0 88.4-71.6 160-160 160c-62 0-115.8-35.3-142.4-86.9c9.3-22.5 14.4-47.2 14.4-73.1zm224 0a96 96 0 1 0 -192 0 96 96 0 1 0 192 0zM368 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm80 48a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $d8206b3ab2e65c05$export$1cbf6e649ce86166 = {
    prefix: "fas",
    iconName: "triangle-exclamation",
    icon: [
        512,
        512,
        [
            9888,
            "exclamation-triangle",
            "warning"
        ],
        "f071",
        "M256 32c14.2 0 27.3 7.5 34.5 19.8l216 368c7.3 12.4 7.3 27.7 .2 40.1S486.3 480 472 480H40c-14.3 0-27.6-7.7-34.7-20.1s-7-27.8 .2-40.1l216-368C228.7 39.5 241.8 32 256 32zm0 128c-13.3 0-24 10.7-24 24V296c0 13.3 10.7 24 24 24s24-10.7 24-24V184c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"
    ]
};
var $d8206b3ab2e65c05$export$3d249b63b52cce7c = $d8206b3ab2e65c05$export$1cbf6e649ce86166;
var $d8206b3ab2e65c05$export$2e470a35c38b096a = $d8206b3ab2e65c05$export$1cbf6e649ce86166;
var $d8206b3ab2e65c05$export$24680dede86b1883 = {
    prefix: "fas",
    iconName: "database",
    icon: [
        448,
        512,
        [],
        "f1c0",
        "M448 80v48c0 44.2-100.3 80-224 80S0 172.2 0 128V80C0 35.8 100.3 0 224 0S448 35.8 448 80zM393.2 214.7c20.8-7.4 39.9-16.9 54.8-28.6V288c0 44.2-100.3 80-224 80S0 332.2 0 288V186.1c14.9 11.8 34 21.2 54.8 28.6C99.7 230.7 159.5 240 224 240s124.3-9.3 169.2-25.3zM0 346.1c14.9 11.8 34 21.2 54.8 28.6C99.7 390.7 159.5 400 224 400s124.3-9.3 169.2-25.3c20.8-7.4 39.9-16.9 54.8-28.6V432c0 44.2-100.3 80-224 80S0 476.2 0 432V346.1z"
    ]
};
var $d8206b3ab2e65c05$export$c08b4b0e2b0dc027 = {
    prefix: "fas",
    iconName: "share",
    icon: [
        512,
        512,
        [
            "mail-forward"
        ],
        "f064",
        "M307 34.8c-11.5 5.1-19 16.6-19 29.2v64H176C78.8 128 0 206.8 0 304C0 417.3 81.5 467.9 100.2 478.1c2.5 1.4 5.3 1.9 8.1 1.9c10.9 0 19.7-8.9 19.7-19.7c0-7.5-4.3-14.4-9.8-19.5C108.8 431.9 96 414.4 96 384c0-53 43-96 96-96h96v64c0 12.6 7.4 24.1 19 29.2s25 3 34.4-5.4l160-144c6.7-6.1 10.6-14.7 10.6-23.8s-3.8-17.7-10.6-23.8l-160-144c-9.4-8.5-22.9-10.6-34.4-5.4z"
    ]
};
var $d8206b3ab2e65c05$export$81df7693d3f2f8da = $d8206b3ab2e65c05$export$c08b4b0e2b0dc027;
var $d8206b3ab2e65c05$export$8f534e1e0ab75bfe = {
    prefix: "fas",
    iconName: "bottle-droplet",
    icon: [
        320,
        512,
        [],
        "e4c4",
        "M96 0C82.7 0 72 10.7 72 24s10.7 24 24 24c4.4 0 8 3.6 8 8v64.9c0 12.2-7.2 23.1-17.2 30.1C53.7 174.1 32 212.5 32 256V448c0 35.3 28.7 64 64 64H224c35.3 0 64-28.7 64-64V256c0-43.5-21.7-81.9-54.8-105c-10-7-17.2-17.9-17.2-30.1V56c0-4.4 3.6-8 8-8c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0 0 0 0H104l0 0 0 0L96 0zm64 382c-26.5 0-48-20.1-48-45c0-16.8 22.1-48.1 36.3-66.4c6-7.8 17.5-7.8 23.5 0C185.9 288.9 208 320.2 208 337c0 24.9-21.5 45-48 45z"
    ]
};
var $d8206b3ab2e65c05$export$140d4da0adbaf435 = {
    prefix: "fas",
    iconName: "mask-face",
    icon: [
        640,
        512,
        [],
        "e1d7",
        "M320 64c-27.2 0-53.8 8-76.4 23.1l-37.1 24.8c-15.8 10.5-34.3 16.1-53.3 16.1H144 128 56c-30.9 0-56 25.1-56 56v85c0 55.1 37.5 103.1 90.9 116.4l108 27C233.8 435 275.4 448 320 448s86.2-13 121.1-35.5l108-27C602.5 372.1 640 324.1 640 269V184c0-30.9-25.1-56-56-56H512 496h-9.2c-19 0-37.5-5.6-53.3-16.1L396.4 87.1C373.8 72 347.2 64 320 64zM132.3 346.3l-29.8-7.4C70.5 330.9 48 302.1 48 269V184c0-4.4 3.6-8 8-8H96v48c0 45.1 13.4 87.2 36.3 122.3zm405.1-7.4l-29.8 7.4c23-35.2 36.3-77.2 36.3-122.3V176h40c4.4 0 8 3.6 8 8v85c0 33-22.5 61.8-54.5 69.9zM192 208c0-8.8 7.2-16 16-16H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H208c-8.8 0-16-7.2-16-16zm16 48H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H208c-8.8 0-16-7.2-16-16s7.2-16 16-16zm16 80c0-8.8 7.2-16 16-16H400c8.8 0 16 7.2 16 16s-7.2 16-16 16H240c-8.8 0-16-7.2-16-16z"
    ]
};
var $d8206b3ab2e65c05$export$7ec15a32285f6c22 = {
    prefix: "fas",
    iconName: "hill-rockslide",
    icon: [
        576,
        512,
        [],
        "e508",
        "M252.4 103.8l27 48c2.8 5 8.2 8.2 13.9 8.2l53.3 0c5.8 0 11.1-3.1 13.9-8.2l27-48c2.7-4.9 2.7-10.8 0-15.7l-27-48c-2.8-5-8.2-8.2-13.9-8.2H293.4c-5.8 0-11.1 3.1-13.9 8.2l-27 48c-2.7 4.9-2.7 10.8 0 15.7zM68.3 87C43.1 61.8 0 79.7 0 115.3V432c0 44.2 35.8 80 80 80H396.7c35.6 0 53.5-43.1 28.3-68.3L68.3 87zM504.2 403.6c4.9 2.7 10.8 2.7 15.7 0l48-27c5-2.8 8.2-8.2 8.2-13.9V309.4c0-5.8-3.1-11.1-8.2-13.9l-48-27c-4.9-2.7-10.8-2.7-15.7 0l-48 27c-5 2.8-8.2 8.2-8.2 13.9v53.3c0 5.8 3.1 11.1 8.2 13.9l48 27zM192 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM384 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
var $d8206b3ab2e65c05$export$a082af56be9786ae = {
    prefix: "fas",
    iconName: "right-left",
    icon: [
        512,
        512,
        [
            "exchange-alt"
        ],
        "f362",
        "M32 96l320 0V32c0-12.9 7.8-24.6 19.8-29.6s25.7-2.2 34.9 6.9l96 96c6 6 9.4 14.1 9.4 22.6s-3.4 16.6-9.4 22.6l-96 96c-9.2 9.2-22.9 11.9-34.9 6.9s-19.8-16.6-19.8-29.6V160L32 160c-17.7 0-32-14.3-32-32s14.3-32 32-32zM480 352c17.7 0 32 14.3 32 32s-14.3 32-32 32H160v64c0 12.9-7.8 24.6-19.8 29.6s-25.7 2.2-34.9-6.9l-96-96c-6-6-9.4-14.1-9.4-22.6s3.4-16.6 9.4-22.6l96-96c9.2-9.2 22.9-11.9 34.9-6.9s19.8 16.6 19.8 29.6l0 64H480z"
    ]
};
var $d8206b3ab2e65c05$export$f6c6fb20d374b128 = $d8206b3ab2e65c05$export$a082af56be9786ae;
var $d8206b3ab2e65c05$export$b5378818301da1be = {
    prefix: "fas",
    iconName: "paper-plane",
    icon: [
        512,
        512,
        [
            61913
        ],
        "f1d8",
        "M498.1 5.6c10.1 7 15.4 19.1 13.5 31.2l-64 416c-1.5 9.7-7.4 18.2-16 23s-18.9 5.4-28 1.6L284 427.7l-68.5 74.1c-8.9 9.7-22.9 12.9-35.2 8.1S160 493.2 160 480V396.4c0-4 1.5-7.8 4.2-10.7L331.8 202.8c5.8-6.3 5.6-16-.4-22s-15.7-6.4-22-.7L106 360.8 17.7 316.6C7.1 311.3 .3 300.7 0 288.9s5.9-22.8 16.1-28.7l448-256c10.7-6.1 23.9-5.5 34 1.4z"
    ]
};
var $d8206b3ab2e65c05$export$79753c2153535b01 = {
    prefix: "fas",
    iconName: "road-circle-exclamation",
    icon: [
        640,
        512,
        [],
        "e565",
        "M213.2 32H288V96c0 17.7 14.3 32 32 32s32-14.3 32-32V32h74.8c27.1 0 51.3 17.1 60.3 42.6l42.7 120.6c-10.9-2.1-22.2-3.2-33.8-3.2c-59.5 0-112.1 29.6-144 74.8V224c0-17.7-14.3-32-32-32s-32 14.3-32 32v64c0 17.7 14.3 32 32 32c2.3 0 4.6-.3 6.8-.7c-4.5 15.5-6.8 31.8-6.8 48.7c0 5.4 .2 10.7 .7 16l-.7 0c-17.7 0-32 14.3-32 32v64H86.6C56.5 480 32 455.5 32 425.4c0-6.2 1.1-12.4 3.1-18.2L152.9 74.6C162 49.1 186.1 32 213.2 32zM496 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 240a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-192c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16V288c0-8.8-7.2-16-16-16z"
    ]
};
var $d8206b3ab2e65c05$export$1156dc6acb0058bd = {
    prefix: "fas",
    iconName: "dungeon",
    icon: [
        512,
        512,
        [],
        "f6d9",
        "M336.6 156.5c1.3 1.1 2.7 2.2 3.9 3.3c9.3 8.2 23 10.5 33.4 3.6l67.6-45.1c11.4-7.6 14.2-23.2 5.1-33.4C430 66.6 410.9 50.6 389.7 37.6c-11.9-7.3-26.9-1.4-32.1 11.6l-30.5 76.2c-4.5 11.1 .2 23.6 9.5 31.2zM328 36.8c5.1-12.8-1.6-27.4-15-30.5C294.7 2.2 275.6 0 256 0s-38.7 2.2-57 6.4C185.5 9.4 178.8 24 184 36.8l30.3 75.8c4.5 11.3 16.8 17.2 29 16c4.2-.4 8.4-.6 12.7-.6s8.6 .2 12.7 .6c12.1 1.2 24.4-4.7 29-16L328 36.8zM65.5 85c-9.1 10.2-6.3 25.8 5.1 33.4l67.6 45.1c10.3 6.9 24.1 4.6 33.4-3.6c1.3-1.1 2.6-2.3 4-3.3c9.3-7.5 13.9-20.1 9.5-31.2L154.4 49.2c-5.2-12.9-20.3-18.8-32.1-11.6C101.1 50.6 82 66.6 65.5 85zm314 137.1c.9 3.3 1.7 6.6 2.3 10c2.5 13 13 23.9 26.2 23.9h80c13.3 0 24.1-10.8 22.9-24c-2.5-27.2-9.3-53.2-19.7-77.3c-5.5-12.9-21.4-16.6-33.1-8.9l-68.6 45.7c-9.8 6.5-13.2 19.2-10 30.5zM53.9 145.8c-11.6-7.8-27.6-4-33.1 8.9C10.4 178.8 3.6 204.8 1.1 232c-1.2 13.2 9.6 24 22.9 24h80c13.3 0 23.8-10.8 26.2-23.9c.6-3.4 1.4-6.7 2.3-10c3.1-11.4-.2-24-10-30.5L53.9 145.8zM104 288H24c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V312c0-13.3-10.7-24-24-24zm304 0c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V312c0-13.3-10.7-24-24-24H408zM24 416c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V440c0-13.3-10.7-24-24-24H24zm384 0c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V440c0-13.3-10.7-24-24-24H408zM272 192c0-8.8-7.2-16-16-16s-16 7.2-16 16V464c0 8.8 7.2 16 16 16s16-7.2 16-16V192zm-64 32c0-8.8-7.2-16-16-16s-16 7.2-16 16V464c0 8.8 7.2 16 16 16s16-7.2 16-16V224zm128 0c0-8.8-7.2-16-16-16s-16 7.2-16 16V464c0 8.8 7.2 16 16 16s16-7.2 16-16V224z"
    ]
};
var $d8206b3ab2e65c05$export$7370f36a39a38737 = {
    prefix: "fas",
    iconName: "align-right",
    icon: [
        448,
        512,
        [],
        "f038",
        "M448 64c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32zm0 256c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32zM0 192c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zM448 448c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32z"
    ]
};
var $d8206b3ab2e65c05$export$52e3e96cd1564779 = {
    prefix: "fas",
    iconName: "money-bill-1-wave",
    icon: [
        576,
        512,
        [
            "money-bill-wave-alt"
        ],
        "f53b",
        "M0 112.5V422.3c0 18 10.1 35 27 41.3c87 32.5 174 10.3 261-11.9c79.8-20.3 159.6-40.7 239.3-18.9c23 6.3 48.7-9.5 48.7-33.4V89.7c0-18-10.1-35-27-41.3C462 15.9 375 38.1 288 60.3C208.2 80.6 128.4 100.9 48.7 79.1C25.6 72.8 0 88.6 0 112.5zM128 416H64V352c35.3 0 64 28.7 64 64zM64 224V160h64c0 35.3-28.7 64-64 64zM448 352c0-35.3 28.7-64 64-64v64H448zm64-192c-35.3 0-64-28.7-64-64h64v64zM384 256c0 61.9-43 112-96 112s-96-50.1-96-112s43-112 96-112s96 50.1 96 112zM252 208c0 9.7 6.9 17.7 16 19.6V276h-4c-11 0-20 9-20 20s9 20 20 20h24 24c11 0 20-9 20-20s-9-20-20-20h-4V208c0-11-9-20-20-20H272c-11 0-20 9-20 20z"
    ]
};
var $d8206b3ab2e65c05$export$1613858e873cbb3e = $d8206b3ab2e65c05$export$52e3e96cd1564779;
var $d8206b3ab2e65c05$export$53dd2cacf674142a = {
    prefix: "fas",
    iconName: "life-ring",
    icon: [
        512,
        512,
        [],
        "f1cd",
        "M367.2 412.5C335.9 434.9 297.5 448 256 448s-79.9-13.1-111.2-35.5l58-58c15.8 8.6 34 13.5 53.3 13.5s37.4-4.9 53.3-13.5l58 58zm90.7 .8c33.8-43.4 54-98 54-157.3s-20.2-113.9-54-157.3c9-12.5 7.9-30.1-3.4-41.3S425.8 45 413.3 54C369.9 20.2 315.3 0 256 0S142.1 20.2 98.7 54c-12.5-9-30.1-7.9-41.3 3.4S45 86.2 54 98.7C20.2 142.1 0 196.7 0 256s20.2 113.9 54 157.3c-9 12.5-7.9 30.1 3.4 41.3S86.2 467 98.7 458c43.4 33.8 98 54 157.3 54s113.9-20.2 157.3-54c12.5 9 30.1 7.9 41.3-3.4s12.4-28.8 3.4-41.3zm-45.5-46.1l-58-58c8.6-15.8 13.5-34 13.5-53.3s-4.9-37.4-13.5-53.3l58-58C434.9 176.1 448 214.5 448 256s-13.1 79.9-35.5 111.2zM367.2 99.5l-58 58c-15.8-8.6-34-13.5-53.3-13.5s-37.4 4.9-53.3 13.5l-58-58C176.1 77.1 214.5 64 256 64s79.9 13.1 111.2 35.5zM157.5 309.3l-58 58C77.1 335.9 64 297.5 64 256s13.1-79.9 35.5-111.2l58 58c-8.6 15.8-13.5 34-13.5 53.3s4.9 37.4 13.5 53.3zM208 256a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z"
    ]
};
var $d8206b3ab2e65c05$export$f9712d0cf5150f0c = {
    prefix: "fas",
    iconName: "hands",
    icon: [
        576,
        512,
        [
            "sign-language",
            "signing"
        ],
        "f2a7",
        "M544 160l-.1 72.6c-.1 52.2-24 101-64 133.1c.1-1.9 .1-3.8 .1-5.7v-8c0-71.8-37-138.6-97.9-176.7l-60.2-37.6c-8.6-5.4-17.9-8.4-27.3-9.4L248.7 48.8c-6.6-11.5-2.7-26.2 8.8-32.8s26.2-2.7 32.8 8.8l78 135.1c3.3 5.7 10.7 7.7 16.4 4.4s7.7-10.7 4.4-16.4l-62-107.4c-6.6-11.5-2.7-26.2 8.8-32.8S362 5 368.6 16.5l68 117.8 0 0 0 0 43.3 75L480 160c0-17.7 14.4-32 32-32s32 14.4 32 32zM243.9 88.5L268.5 131c-13.9 4.5-26.4 13.7-34.7 27c-.9 1.4-1.7 2.9-2.5 4.4l-28.9-50c-6.6-11.5-2.7-26.2 8.8-32.8s26.2-2.7 32.8 8.8zm-46.4 63.7l26.8 46.4c.6 6 2.1 11.8 4.3 17.4H224 210.7l0 0H179l-23-39.8c-6.6-11.5-2.7-26.2 8.8-32.8s26.2-2.7 32.8 8.8zM260.9 175c9.4-15 29.1-19.5 44.1-10.2l60.2 37.6C416.7 234.7 448 291.2 448 352v8c0 83.9-68.1 152-152 152H120c-13.3 0-24-10.7-24-24s10.7-24 24-24h92c6.6 0 12-5.4 12-12s-5.4-12-12-12H88c-13.3 0-24-10.7-24-24s10.7-24 24-24H212c6.6 0 12-5.4 12-12s-5.4-12-12-12H56c-13.3 0-24-10.7-24-24s10.7-24 24-24H212c6.6 0 12-5.4 12-12s-5.4-12-12-12H88c-13.3 0-24-10.7-24-24s10.7-24 24-24H224l0 0 0 0h93.2L271 219.1c-15-9.4-19.5-29.1-10.2-44.1z"
    ]
};
var $d8206b3ab2e65c05$export$20993813350f9671 = $d8206b3ab2e65c05$export$f9712d0cf5150f0c;
var $d8206b3ab2e65c05$export$5cc0e6f5191f4f02 = $d8206b3ab2e65c05$export$f9712d0cf5150f0c;
var $d8206b3ab2e65c05$export$80968bcfef6481ca = {
    prefix: "fas",
    iconName: "calendar-day",
    icon: [
        448,
        512,
        [],
        "f783",
        "M128 0c17.7 0 32 14.3 32 32V64H288V32c0-17.7 14.3-32 32-32s32 14.3 32 32V64h48c26.5 0 48 21.5 48 48v48H0V112C0 85.5 21.5 64 48 64H96V32c0-17.7 14.3-32 32-32zM0 192H448V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V192zm80 64c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H80z"
    ]
};
var $d8206b3ab2e65c05$export$5930e9bdfd790d77 = {
    prefix: "fas",
    iconName: "water-ladder",
    icon: [
        576,
        512,
        [
            "ladder-water",
            "swimming-pool"
        ],
        "f5c5",
        "M128 127.7C128 74.9 170.9 32 223.7 32c48.3 0 89 36 95 83.9l1 8.2c2.2 17.5-10.2 33.5-27.8 35.7s-33.5-10.2-35.7-27.8l-1-8.2c-2-15.9-15.5-27.8-31.5-27.8c-17.5 0-31.7 14.2-31.7 31.7V224H384V127.7C384 74.9 426.9 32 479.7 32c48.3 0 89 36 95 83.9l1 8.2c2.2 17.5-10.2 33.5-27.8 35.7s-33.5-10.2-35.7-27.8l-1-8.2c-2-15.9-15.5-27.8-31.5-27.8c-17.5 0-31.7 14.2-31.7 31.7V361c-1.6 1-3.3 2-4.8 3.1c-18 12.4-40.1 20.3-59.2 20.3h0V288H192v96.5c-19 0-41.2-7.9-59.1-20.3c-1.6-1.1-3.2-2.2-4.9-3.1V127.7zM306.5 389.9C329 405.4 356.5 416 384 416c26.9 0 55.4-10.8 77.4-26.1l0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 469.7 417 480 384 480c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.4 27.3-10.1 39.2-1.7l0 0C136.7 405.2 165.1 416 192 416c27.5 0 55-10.6 77.5-26.1c11.1-7.9 25.9-7.9 37 0z"
    ]
};
var $d8206b3ab2e65c05$export$c5ea6eeef2db2b3b = $d8206b3ab2e65c05$export$5930e9bdfd790d77;
var $d8206b3ab2e65c05$export$4dee691631c67d5c = $d8206b3ab2e65c05$export$5930e9bdfd790d77;
var $d8206b3ab2e65c05$export$64185f27d82c259f = {
    prefix: "fas",
    iconName: "arrows-up-down",
    icon: [
        320,
        512,
        [
            "arrows-v"
        ],
        "f07d",
        "M182.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L128 109.3V402.7L86.6 361.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0l96-96c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 402.7V109.3l41.4 41.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-96-96z"
    ]
};
var $d8206b3ab2e65c05$export$cec5f1bc9e068e48 = $d8206b3ab2e65c05$export$64185f27d82c259f;
var $d8206b3ab2e65c05$export$bd5bd2ef56b793b1 = {
    prefix: "fas",
    iconName: "face-grimace",
    icon: [
        512,
        512,
        [
            128556,
            "grimace"
        ],
        "f57f",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm96-112h-8V360l55.3 0c-3.8 22.7-23.6 40-47.3 40zm47.3-56L344 344V304h8c23.8 0 43.5 17.3 47.3 40zM328 344H264V304h64v40zm0 56H264V360h64v40zm-80-96v40l-64 0V304h64zm0 56v40H184V360l64 0zm-80-16H112.7c3.8-22.7 23.6-40 47.3-40h8v40zm0 56h-8c-23.8 0-43.5-17.3-47.3-40H168v40zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $d8206b3ab2e65c05$export$3d08cd36ac1ef231 = $d8206b3ab2e65c05$export$bd5bd2ef56b793b1;
var $d8206b3ab2e65c05$export$1482162f7fe04ac = {
    prefix: "fas",
    iconName: "wheelchair-move",
    icon: [
        448,
        512,
        [
            "wheelchair-alt"
        ],
        "e2ce",
        "M320 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM204.5 121.3c-5.4-2.5-11.7-1.9-16.4 1.7l-40.9 30.7c-14.1 10.6-34.2 7.7-44.8-6.4s-7.7-34.2 6.4-44.8l40.9-30.7c23.7-17.8 55.3-21 82.1-8.4l90.4 42.5c29.1 13.7 36.8 51.6 15.2 75.5L299.1 224h97.4c30.3 0 53 27.7 47.1 57.4L415.4 422.3c-3.5 17.3-20.3 28.6-37.7 25.1s-28.6-20.3-25.1-37.7L377 288H306.7c8.6 19.6 13.3 41.2 13.3 64c0 88.4-71.6 160-160 160S0 440.4 0 352s71.6-160 160-160c11.1 0 22 1.1 32.4 3.3l54.2-54.2-42.1-19.8zM160 448a96 96 0 1 0 0-192 96 96 0 1 0 0 192z"
    ]
};
var $d8206b3ab2e65c05$export$7db9460785019040 = $d8206b3ab2e65c05$export$1482162f7fe04ac;
var $d8206b3ab2e65c05$export$b5dc9dd0347bbb6 = {
    prefix: "fas",
    iconName: "turn-down",
    icon: [
        384,
        512,
        [
            10549,
            "level-down-alt"
        ],
        "f3be",
        "M350 334.5c3.8 8.8 2 19-4.6 26l-136 144c-4.5 4.8-10.8 7.5-17.4 7.5s-12.9-2.7-17.4-7.5l-136-144c-6.6-7-8.4-17.2-4.6-26s12.5-14.5 22-14.5h88l0-192c0-17.7-14.3-32-32-32H32C14.3 96 0 81.7 0 64V32C0 14.3 14.3 0 32 0l80 0c70.7 0 128 57.3 128 128l0 192h88c9.6 0 18.2 5.7 22 14.5z"
    ]
};
var $d8206b3ab2e65c05$export$c07eb6ff5a382cbd = $d8206b3ab2e65c05$export$b5dc9dd0347bbb6;
var $d8206b3ab2e65c05$export$3e15790fe68c095b = {
    prefix: "fas",
    iconName: "person-walking-arrow-right",
    icon: [
        640,
        512,
        [],
        "e552",
        "M208 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM123.7 200.5c1-.4 1.9-.8 2.9-1.2l-16.9 63.5c-5.6 21.1-.1 43.6 14.7 59.7l70.7 77.1 22 88.1c4.3 17.1 21.7 27.6 38.8 23.3s27.6-21.7 23.3-38.8l-23-92.1c-1.9-7.8-5.8-14.9-11.2-20.8l-49.5-54 19.3-65.5 9.6 23c4.4 10.6 12.5 19.3 22.8 24.5l26.7 13.3c15.8 7.9 35 1.5 42.9-14.3s1.5-35-14.3-42.9L281 232.7l-15.3-36.8C248.5 154.8 208.3 128 163.7 128c-22.8 0-45.3 4.8-66.1 14l-8 3.5c-32.9 14.6-58.1 42.4-69.4 76.5l-2.6 7.8c-5.6 16.8 3.5 34.9 20.2 40.5s34.9-3.5 40.5-20.2l2.6-7.8c5.7-17.1 18.3-30.9 34.7-38.2l8-3.5zm-30 135.1L68.7 398 9.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L116.3 441c4.6-4.6 8.2-10.1 10.6-16.1l14.5-36.2-40.7-44.4c-2.5-2.7-4.8-5.6-7-8.6zM550.6 153.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L530.7 224H384c-17.7 0-32 14.3-32 32s14.3 32 32 32H530.7l-25.4 25.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l80-80c12.5-12.5 12.5-32.8 0-45.3l-80-80z"
    ]
};
var $d8206b3ab2e65c05$export$15da4ef8c0fb20d6 = {
    prefix: "fas",
    iconName: "square-envelope",
    icon: [
        448,
        512,
        [
            "envelope-square"
        ],
        "f199",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM218 271.7L64.2 172.4C66 156.4 79.5 144 96 144H352c16.5 0 30 12.4 31.8 28.4L230 271.7c-1.8 1.2-3.9 1.8-6 1.8s-4.2-.6-6-1.8zm29.4 26.9L384 210.4V336c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V210.4l136.6 88.2c7 4.5 15.1 6.9 23.4 6.9s16.4-2.4 23.4-6.9z"
    ]
};
var $d8206b3ab2e65c05$export$354e159473e73552 = $d8206b3ab2e65c05$export$15da4ef8c0fb20d6;
var $d8206b3ab2e65c05$export$4ed8206e6619cc8f = {
    prefix: "fas",
    iconName: "dice",
    icon: [
        640,
        512,
        [
            127922
        ],
        "f522",
        "M274.9 34.3c-28.1-28.1-73.7-28.1-101.8 0L34.3 173.1c-28.1 28.1-28.1 73.7 0 101.8L173.1 413.7c28.1 28.1 73.7 28.1 101.8 0L413.7 274.9c28.1-28.1 28.1-73.7 0-101.8L274.9 34.3zM200 224a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM96 200a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM224 376a24 24 0 1 1 0-48 24 24 0 1 1 0 48zM352 200a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM224 120a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm96 328c0 35.3 28.7 64 64 64H576c35.3 0 64-28.7 64-64V256c0-35.3-28.7-64-64-64H461.7c11.6 36 3.1 77-25.4 105.5L320 413.8V448zM480 328a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
    ]
};
var $d8206b3ab2e65c05$export$5ee2640fe105312d = {
    prefix: "fas",
    iconName: "bowling-ball",
    icon: [
        512,
        512,
        [],
        "f436",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM240 80a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM208 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm-64-64a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $d8206b3ab2e65c05$export$97fa4f4c1006ab1 = {
    prefix: "fas",
    iconName: "brain",
    icon: [
        512,
        512,
        [
            129504
        ],
        "f5dc",
        "M184 0c30.9 0 56 25.1 56 56V456c0 30.9-25.1 56-56 56c-28.9 0-52.7-21.9-55.7-50.1c-5.2 1.4-10.7 2.1-16.3 2.1c-35.3 0-64-28.7-64-64c0-7.4 1.3-14.6 3.6-21.2C21.4 367.4 0 338.2 0 304c0-31.9 18.7-59.5 45.8-72.3C37.1 220.8 32 207 32 192c0-30.7 21.6-56.3 50.4-62.6C80.8 123.9 80 118 80 112c0-29.9 20.6-55.1 48.3-62.1C131.3 21.9 155.1 0 184 0zM328 0c28.9 0 52.6 21.9 55.7 49.9c27.8 7 48.3 32.1 48.3 62.1c0 6-.8 11.9-2.4 17.4c28.8 6.2 50.4 31.9 50.4 62.6c0 15-5.1 28.8-13.8 39.7C493.3 244.5 512 272.1 512 304c0 34.2-21.4 63.4-51.6 74.8c2.3 6.6 3.6 13.8 3.6 21.2c0 35.3-28.7 64-64 64c-5.6 0-11.1-.7-16.3-2.1c-3 28.2-26.8 50.1-55.7 50.1c-30.9 0-56-25.1-56-56V56c0-30.9 25.1-56 56-56z"
    ]
};
var $d8206b3ab2e65c05$export$658a137d3845bca7 = {
    prefix: "fas",
    iconName: "bandage",
    icon: [
        640,
        512,
        [
            129657,
            "band-aid"
        ],
        "f462",
        "M480 416h96c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H480V416zM448 96H192V416H448V96zM64 96C28.7 96 0 124.7 0 160V352c0 35.3 28.7 64 64 64h96V96H64zM248 208a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm120-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM248 304a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm120-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
    ]
};
var $d8206b3ab2e65c05$export$b14a1014df2fdf46 = $d8206b3ab2e65c05$export$658a137d3845bca7;
var $d8206b3ab2e65c05$export$23e8b4955c2d951b = {
    prefix: "fas",
    iconName: "calendar-minus",
    icon: [
        448,
        512,
        [],
        "f272",
        "M128 0c17.7 0 32 14.3 32 32V64H288V32c0-17.7 14.3-32 32-32s32 14.3 32 32V64h48c26.5 0 48 21.5 48 48v48H0V112C0 85.5 21.5 64 48 64H96V32c0-17.7 14.3-32 32-32zM0 192H448V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V192zM312 376c13.3 0 24-10.7 24-24s-10.7-24-24-24H136c-13.3 0-24 10.7-24 24s10.7 24 24 24H312z"
    ]
};
var $d8206b3ab2e65c05$export$30262489773a79a3 = {
    prefix: "fas",
    iconName: "circle-xmark",
    icon: [
        512,
        512,
        [
            61532,
            "times-circle",
            "xmark-circle"
        ],
        "f057",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"
    ]
};
var $d8206b3ab2e65c05$export$ab0ec50720a747eb = $d8206b3ab2e65c05$export$30262489773a79a3;
var $d8206b3ab2e65c05$export$90ac4096df8efdee = $d8206b3ab2e65c05$export$30262489773a79a3;
var $d8206b3ab2e65c05$export$de9a67b55dbe819a = {
    prefix: "fas",
    iconName: "gifts",
    icon: [
        640,
        512,
        [],
        "f79c",
        "M200.6 32C205 19.5 198.5 5.8 186 1.4S159.8 3.5 155.4 16L144.7 46.2l-9.9-29.8C130.6 3.8 117-3 104.4 1.2S85 19 89.2 31.6l8.3 25-27.4-20c-10.7-7.8-25.7-5.4-33.5 5.3s-5.4 25.7 5.3 33.5L70.2 96H48C21.5 96 0 117.5 0 144V464c0 26.5 21.5 48 48 48H200.6c-5.4-9.4-8.6-20.3-8.6-32V256c0-29.9 20.5-55 48.2-62c1.8-31 17.1-58.2 40.1-76.1C271.7 104.7 256.9 96 240 96H217.8l28.3-20.6c10.7-7.8 13.1-22.8 5.3-33.5s-22.8-13.1-33.5-5.3L192.5 55.1 200.6 32zM363.5 185.5L393.1 224H344c-13.3 0-24-10.7-24-24c0-13.1 10.8-24 24.2-24c7.6 0 14.7 3.5 19.3 9.5zM272 200c0 8.4 1.4 16.5 4.1 24H272c-26.5 0-48 21.5-48 48v80H416V256h32v96H640V272c0-26.5-21.5-48-48-48h-4.1c2.7-7.5 4.1-15.6 4.1-24c0-39.9-32.5-72-72.2-72c-22.4 0-43.6 10.4-57.3 28.2L432 195.8l-30.5-39.6c-13.7-17.8-35-28.2-57.3-28.2c-39.7 0-72.2 32.1-72.2 72zM224 464c0 26.5 21.5 48 48 48H416V384H224v80zm224 48H592c26.5 0 48-21.5 48-48V384H448V512zm96-312c0 13.3-10.7 24-24 24H470.9l29.6-38.5c4.6-5.9 11.7-9.5 19.3-9.5c13.4 0 24.2 10.9 24.2 24z"
    ]
};
var $d8206b3ab2e65c05$export$c402efcf01d5ca07 = {
    prefix: "fas",
    iconName: "hotel",
    icon: [
        512,
        512,
        [
            127976
        ],
        "f594",
        "M0 32C0 14.3 14.3 0 32 0H480c17.7 0 32 14.3 32 32s-14.3 32-32 32V448c17.7 0 32 14.3 32 32s-14.3 32-32 32H304V464c0-26.5-21.5-48-48-48s-48 21.5-48 48v48H32c-17.7 0-32-14.3-32-32s14.3-32 32-32V64C14.3 64 0 49.7 0 32zm96 80v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H112c-8.8 0-16 7.2-16 16zM240 96c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H240zm112 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16zM112 192c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V208c0-8.8-7.2-16-16-16H112zm112 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V208c0-8.8-7.2-16-16-16H240c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V208c0-8.8-7.2-16-16-16H368zM328 384c13.3 0 24.3-10.9 21-23.8c-10.6-41.5-48.2-72.2-93-72.2s-82.5 30.7-93 72.2c-3.3 12.8 7.8 23.8 21 23.8H328z"
    ]
};
var $d8206b3ab2e65c05$export$807cdd395fe012cb = {
    prefix: "fas",
    iconName: "earth-asia",
    icon: [
        512,
        512,
        [
            127759,
            "globe-asia"
        ],
        "f57e",
        "M51.7 295.1l31.7 6.3c7.9 1.6 16-.9 21.7-6.6l15.4-15.4c11.6-11.6 31.1-8.4 38.4 6.2l9.3 18.5c4.8 9.6 14.6 15.7 25.4 15.7c15.2 0 26.1-14.6 21.7-29.2l-6-19.9c-4.6-15.4 6.9-30.9 23-30.9h2.3c13.4 0 25.9-6.7 33.3-17.8l10.7-16.1c5.6-8.5 5.3-19.6-.8-27.7l-16.1-21.5c-10.3-13.7-3.3-33.5 13.4-37.7l17-4.3c7.5-1.9 13.6-7.2 16.5-14.4l16.4-40.9C303.4 52.1 280.2 48 256 48C141.1 48 48 141.1 48 256c0 13.4 1.3 26.5 3.7 39.1zm407.7 4.6c-3-.3-6-.1-9 .8l-15.8 4.4c-6.7 1.9-13.8-.9-17.5-6.7l-2-3.1c-6-9.4-16.4-15.1-27.6-15.1s-21.6 5.7-27.6 15.1l-6.1 9.5c-1.4 2.2-3.4 4.1-5.7 5.3L312 330.1c-18.1 10.1-25.5 32.4-17 51.3l5.5 12.4c8.6 19.2 30.7 28.5 50.5 21.1l2.6-1c10-3.7 21.3-2.2 29.9 4.1l1.5 1.1c37.2-29.5 64.1-71.4 74.4-119.5zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm144.5 92.1c-2.1 8.6 3.1 17.3 11.6 19.4l32 8c8.6 2.1 17.3-3.1 19.4-11.6s-3.1-17.3-11.6-19.4l-32-8c-8.6-2.1-17.3 3.1-19.4 11.6zm92-20c-2.1 8.6 3.1 17.3 11.6 19.4s17.3-3.1 19.4-11.6l8-32c2.1-8.6-3.1-17.3-11.6-19.4s-17.3 3.1-19.4 11.6l-8 32zM343.2 113.7c-7.9-4-17.5-.7-21.5 7.2l-16 32c-4 7.9-.7 17.5 7.2 21.5s17.5 .7 21.5-7.2l16-32c4-7.9 .7-17.5-7.2-21.5z"
    ]
};
var $d8206b3ab2e65c05$export$796fdfc909e603f4 = $d8206b3ab2e65c05$export$807cdd395fe012cb;
var $d8206b3ab2e65c05$export$31e6961064ddac7b = {
    prefix: "fas",
    iconName: "id-card-clip",
    icon: [
        576,
        512,
        [
            "id-card-alt"
        ],
        "f47f",
        "M256 0h64c17.7 0 32 14.3 32 32V96c0 17.7-14.3 32-32 32H256c-17.7 0-32-14.3-32-32V32c0-17.7 14.3-32 32-32zM64 64H192v48c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V64H512c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128C0 92.7 28.7 64 64 64zM176 437.3c0 5.9 4.8 10.7 10.7 10.7H389.3c5.9 0 10.7-4.8 10.7-10.7c0-29.5-23.9-53.3-53.3-53.3H229.3c-29.5 0-53.3 23.9-53.3 53.3zM288 352a64 64 0 1 0 0-128 64 64 0 1 0 0 128z"
    ]
};
var $d8206b3ab2e65c05$export$dc37ebbac31f6c6c = $d8206b3ab2e65c05$export$31e6961064ddac7b;
var $d8206b3ab2e65c05$export$f48a3ba52a0a9e56 = {
    prefix: "fas",
    iconName: "magnifying-glass-plus",
    icon: [
        512,
        512,
        [
            "search-plus"
        ],
        "f00e",
        "M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM184 296c0 13.3 10.7 24 24 24s24-10.7 24-24V232h64c13.3 0 24-10.7 24-24s-10.7-24-24-24H232V120c0-13.3-10.7-24-24-24s-24 10.7-24 24v64H120c-13.3 0-24 10.7-24 24s10.7 24 24 24h64v64z"
    ]
};
var $d8206b3ab2e65c05$export$378f00e6b1a8185 = $d8206b3ab2e65c05$export$f48a3ba52a0a9e56;
var $d8206b3ab2e65c05$export$47e4e0d519d33497 = {
    prefix: "fas",
    iconName: "thumbs-up",
    icon: [
        512,
        512,
        [
            128077,
            61575
        ],
        "f164",
        "M313.4 32.9c26 5.2 42.9 30.5 37.7 56.5l-2.3 11.4c-5.3 26.7-15.1 52.1-28.8 75.2H464c26.5 0 48 21.5 48 48c0 18.5-10.5 34.6-25.9 42.6C497 275.4 504 288.9 504 304c0 23.4-16.8 42.9-38.9 47.1c4.4 7.3 6.9 15.8 6.9 24.9c0 21.3-13.9 39.4-33.1 45.6c.7 3.3 1.1 6.8 1.1 10.4c0 26.5-21.5 48-48 48H294.5c-19 0-37.5-5.6-53.3-16.1l-38.5-25.7C176 420.4 160 390.4 160 358.3V320 272 247.1c0-29.2 13.3-56.7 36-75l7.4-5.9c26.5-21.2 44.6-51 51.2-84.2l2.3-11.4c5.2-26 30.5-42.9 56.5-37.7zM32 192H96c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V224c0-17.7 14.3-32 32-32z"
    ]
};
var $d8206b3ab2e65c05$export$b00596a09aa07311 = {
    prefix: "fas",
    iconName: "user-clock",
    icon: [
        640,
        512,
        [],
        "f4fd",
        "M224 0a128 128 0 1 1 0 256A128 128 0 1 1 224 0zM178.3 304h91.4c20.6 0 40.4 3.5 58.8 9.9C323 331 320 349.1 320 368c0 59.5 29.5 112.1 74.8 144H29.7C13.3 512 0 498.7 0 482.3C0 383.8 79.8 304 178.3 304zM352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-80c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H512V304c0-8.8-7.2-16-16-16z"
    ]
};
var $d8206b3ab2e65c05$export$8846d49caaed1c0a = {
    prefix: "fas",
    iconName: "hand-dots",
    icon: [
        512,
        512,
        [
            "allergies"
        ],
        "f461",
        "M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V240c0 8.8-7.2 16-16 16s-16-7.2-16-16V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V336c0 1.5 0 3.1 .1 4.6L67.6 283c-16-15.2-41.3-14.6-56.6 1.4s-14.6 41.3 1.4 56.6L124.8 448c43.1 41.1 100.4 64 160 64H304c97.2 0 176-78.8 176-176V128c0-17.7-14.3-32-32-32s-32 14.3-32 32V240c0 8.8-7.2 16-16 16s-16-7.2-16-16V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V240c0 8.8-7.2 16-16 16s-16-7.2-16-16V32zM240 336a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80 16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48-16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm-16 80a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM240 432a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm-48-48a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"
    ]
};
var $d8206b3ab2e65c05$export$dcae2101babbffff = $d8206b3ab2e65c05$export$8846d49caaed1c0a;
var $d8206b3ab2e65c05$export$bef39294aed2281a = {
    prefix: "fas",
    iconName: "file-invoice",
    icon: [
        384,
        512,
        [],
        "f570",
        "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM80 64h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16zm16 96H288c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V256c0-17.7 14.3-32 32-32zm0 32v64H288V256H96zM240 416h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H240c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
    ]
};
var $d8206b3ab2e65c05$export$26a3f9d2784b90d8 = {
    prefix: "fas",
    iconName: "window-minimize",
    icon: [
        512,
        512,
        [
            128469
        ],
        "f2d1",
        "M32 416c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z"
    ]
};
var $d8206b3ab2e65c05$export$60048819854688c5 = {
    prefix: "fas",
    iconName: "mug-saucer",
    icon: [
        640,
        512,
        [
            "coffee"
        ],
        "f0f4",
        "M96 64c0-17.7 14.3-32 32-32H448h64c70.7 0 128 57.3 128 128s-57.3 128-128 128H480c0 53-43 96-96 96H192c-53 0-96-43-96-96V64zM480 224h32c35.3 0 64-28.7 64-64s-28.7-64-64-64H480V224zM32 416H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
    ]
};
var $d8206b3ab2e65c05$export$1d24a9e457278011 = $d8206b3ab2e65c05$export$60048819854688c5;
var $d8206b3ab2e65c05$export$5824ffe6f8983c83 = {
    prefix: "fas",
    iconName: "brush",
    icon: [
        384,
        512,
        [],
        "f55d",
        "M162.4 6c-1.5-3.6-5-6-8.9-6h-19c-3.9 0-7.5 2.4-8.9 6L104.9 57.7c-3.2 8-14.6 8-17.8 0L66.4 6c-1.5-3.6-5-6-8.9-6H48C21.5 0 0 21.5 0 48V224v22.4V256H9.6 374.4 384v-9.6V224 48c0-26.5-21.5-48-48-48H230.5c-3.9 0-7.5 2.4-8.9 6L200.9 57.7c-3.2 8-14.6 8-17.8 0L162.4 6zM0 288v32c0 35.3 28.7 64 64 64h64v64c0 35.3 28.7 64 64 64s64-28.7 64-64V384h64c35.3 0 64-28.7 64-64V288H0zM192 432a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"
    ]
};
var $d8206b3ab2e65c05$export$7b028758c03b9655 = {
    prefix: "fas",
    iconName: "mask",
    icon: [
        576,
        512,
        [],
        "f6fa",
        "M288 64C64 64 0 160 0 272S80 448 176 448h8.4c24.2 0 46.4-13.7 57.2-35.4l23.2-46.3c4.4-8.8 13.3-14.3 23.2-14.3s18.8 5.5 23.2 14.3l23.2 46.3c10.8 21.7 33 35.4 57.2 35.4H400c96 0 176-64 176-176s-64-208-288-208zM96 256a64 64 0 1 1 128 0A64 64 0 1 1 96 256zm320-64a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"
    ]
};
var $d8206b3ab2e65c05$export$56d810b9ab2e30bc = {
    prefix: "fas",
    iconName: "magnifying-glass-minus",
    icon: [
        512,
        512,
        [
            "search-minus"
        ],
        "f010",
        "M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM136 184c-13.3 0-24 10.7-24 24s10.7 24 24 24H280c13.3 0 24-10.7 24-24s-10.7-24-24-24H136z"
    ]
};
var $d8206b3ab2e65c05$export$efca97eef6a7a17d = $d8206b3ab2e65c05$export$56d810b9ab2e30bc;
var $d8206b3ab2e65c05$export$a6ad5df9d9f29553 = {
    prefix: "fas",
    iconName: "ruler-vertical",
    icon: [
        256,
        512,
        [],
        "f548",
        "M0 48C0 21.5 21.5 0 48 0H208c26.5 0 48 21.5 48 48V96H176c-8.8 0-16 7.2-16 16s7.2 16 16 16h80v64H176c-8.8 0-16 7.2-16 16s7.2 16 16 16h80v64H176c-8.8 0-16 7.2-16 16s7.2 16 16 16h80v64H176c-8.8 0-16 7.2-16 16s7.2 16 16 16h80v48c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V48z"
    ]
};
var $d8206b3ab2e65c05$export$50a28538498238f = {
    prefix: "fas",
    iconName: "user-large",
    icon: [
        512,
        512,
        [
            "user-alt"
        ],
        "f406",
        "M256 288A144 144 0 1 0 256 0a144 144 0 1 0 0 288zm-94.7 32C72.2 320 0 392.2 0 481.3c0 17 13.8 30.7 30.7 30.7H481.3c17 0 30.7-13.8 30.7-30.7C512 392.2 439.8 320 350.7 320H161.3z"
    ]
};
var $d8206b3ab2e65c05$export$ae9b19c2ac726cfc = $d8206b3ab2e65c05$export$50a28538498238f;
var $d8206b3ab2e65c05$export$d401d4aeba21cdf3 = {
    prefix: "fas",
    iconName: "train-tram",
    icon: [
        448,
        512,
        [
            128650
        ],
        "e5b4",
        "M86.8 48c-12.2 0-23.6 5.5-31.2 15L42.7 79C34.5 89.3 19.4 91 9 82.7S-3 59.4 5.3 49L18 33C34.7 12.2 60 0 86.8 0H361.2c26.7 0 52 12.2 68.7 33l12.8 16c8.3 10.4 6.6 25.5-3.8 33.7s-25.5 6.6-33.7-3.7L392.5 63c-7.6-9.5-19.1-15-31.2-15H248V96h40c53 0 96 43 96 96V352c0 30.6-14.3 57.8-36.6 75.4l65.5 65.5c7.1 7.1 2.1 19.1-7.9 19.1H365.3c-8.5 0-16.6-3.4-22.6-9.4L288 448H160l-54.6 54.6c-6 6-14.1 9.4-22.6 9.4H43c-10 0-15-12.1-7.9-19.1l65.5-65.5C78.3 409.8 64 382.6 64 352V192c0-53 43-96 96-96h40V48H86.8zM160 160c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32H288c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32H160zm32 192a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm96 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
var $d8206b3ab2e65c05$export$ab9af5aa013d2162 = {
    prefix: "fas",
    iconName: "user-nurse",
    icon: [
        448,
        512,
        [],
        "f82f",
        "M96 128V70.2c0-13.3 8.3-25.3 20.8-30l96-36c7.2-2.7 15.2-2.7 22.5 0l96 36c12.5 4.7 20.8 16.6 20.8 30V128h-.3c.2 2.6 .3 5.3 .3 8v40c0 70.7-57.3 128-128 128s-128-57.3-128-128V136c0-2.7 .1-5.4 .3-8H96zm48 48c0 44.2 35.8 80 80 80s80-35.8 80-80V160H144v16zM111.9 327.7c10.5-3.4 21.8 .4 29.4 8.5l71 75.5c6.3 6.7 17 6.7 23.3 0l71-75.5c7.6-8.1 18.9-11.9 29.4-8.5C401 348.6 448 409.4 448 481.3c0 17-13.8 30.7-30.7 30.7H30.7C13.8 512 0 498.2 0 481.3c0-71.9 47-132.7 111.9-153.6zM208 48V64H192c-4.4 0-8 3.6-8 8V88c0 4.4 3.6 8 8 8h16v16c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V96h16c4.4 0 8-3.6 8-8V72c0-4.4-3.6-8-8-8H240V48c0-4.4-3.6-8-8-8H216c-4.4 0-8 3.6-8 8z"
    ]
};
var $d8206b3ab2e65c05$export$1aa9423ec6b1d609 = {
    prefix: "fas",
    iconName: "syringe",
    icon: [
        512,
        512,
        [
            128137
        ],
        "f48e",
        "M441 7l32 32 32 32c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-15-15L417.9 128l55 55c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-72-72L295 73c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l55 55L422.1 56 407 41c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0zM210.3 155.7l61.1-61.1c.3 .3 .6 .7 1 1l16 16 56 56 56 56 16 16c.3 .3 .6 .6 1 1l-191 191c-10.5 10.5-24.7 16.4-39.6 16.4H97.9L41 505c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l57-57V325.3c0-14.9 5.9-29.1 16.4-39.6l43.3-43.3 57 57c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-57-57 41.4-41.4 57 57c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-57-57z"
    ]
};
var $d8206b3ab2e65c05$export$dcaadfd9c98e42a1 = {
    prefix: "fas",
    iconName: "cloud-sun",
    icon: [
        640,
        512,
        [
            9925
        ],
        "f6c4",
        "M294.2 1.2c5.1 2.1 8.7 6.7 9.6 12.1l14.1 84.7 84.7 14.1c5.4 .9 10 4.5 12.1 9.6s1.5 10.9-1.6 15.4l-38.5 55c-2.2-.1-4.4-.2-6.7-.2c-23.3 0-45.1 6.2-64 17.1l0-1.1c0-53-43-96-96-96s-96 43-96 96s43 96 96 96c8.1 0 15.9-1 23.4-2.9c-36.6 18.1-63.3 53.1-69.8 94.9l-24.4 17c-4.5 3.1-10.3 3.8-15.4 1.6s-8.7-6.7-9.6-12.1L98.1 317.9 13.4 303.8c-5.4-.9-10-4.5-12.1-9.6s-1.5-10.9 1.6-15.4L52.5 208 2.9 137.2c-3.2-4.5-3.8-10.3-1.6-15.4s6.7-8.7 12.1-9.6L98.1 98.1l14.1-84.7c.9-5.4 4.5-10 9.6-12.1s10.9-1.5 15.4 1.6L208 52.5 278.8 2.9c4.5-3.2 10.3-3.8 15.4-1.6zM144 208a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM639.9 431.9c0 44.2-35.8 80-80 80H288c-53 0-96-43-96-96c0-47.6 34.6-87 80-94.6l0-1.3c0-53 43-96 96-96c34.9 0 65.4 18.6 82.2 46.4c13-9.1 28.8-14.4 45.8-14.4c44.2 0 80 35.8 80 80c0 5.9-.6 11.7-1.9 17.2c37.4 6.7 65.8 39.4 65.8 78.7z"
    ]
};
var $d8206b3ab2e65c05$export$df6244b0501f2112 = {
    prefix: "fas",
    iconName: "stopwatch-20",
    icon: [
        448,
        512,
        [],
        "e06f",
        "M176 0c-17.7 0-32 14.3-32 32s14.3 32 32 32h16V98.4C92.3 113.8 16 200 16 304c0 114.9 93.1 208 208 208s208-93.1 208-208c0-41.8-12.3-80.7-33.5-113.2l24.1-24.1c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L355.7 143c-28.1-23-62.2-38.8-99.7-44.6V64h16c17.7 0 32-14.3 32-32s-14.3-32-32-32H176zM288 204c28.7 0 52 23.3 52 52v96c0 28.7-23.3 52-52 52s-52-23.3-52-52V256c0-28.7 23.3-52 52-52zm-12 52v96c0 6.6 5.4 12 12 12s12-5.4 12-12V256c0-6.6-5.4-12-12-12s-12 5.4-12 12zM159.5 244c-5.4 0-10.2 3.5-11.9 8.6l-.6 1.7c-3.5 10.5-14.8 16.1-25.3 12.6s-16.1-14.8-12.6-25.3l.6-1.7c7.2-21.5 27.2-35.9 49.8-35.9c29 0 52.5 23.5 52.5 52.5v2.2c0 13.4-4.9 26.4-13.8 36.4l-39 43.9c-6.2 7-10 15.7-10.9 24.9H192c11 0 20 9 20 20s-9 20-20 20H128c-11 0-20-9-20-20V368.3c0-20.6 7.5-40.4 21.2-55.8l39-43.9c2.4-2.7 3.7-6.2 3.7-9.8v-2.2c0-6.9-5.6-12.5-12.5-12.5z"
    ]
};
var $d8206b3ab2e65c05$export$7ec6541fee081990 = {
    prefix: "fas",
    iconName: "square-full",
    icon: [
        512,
        512,
        [
            128997,
            128998,
            128999,
            129000,
            129001,
            129002,
            129003,
            11035,
            11036
        ],
        "f45c",
        "M0 0H512V512H0V0z"
    ]
};
var $d8206b3ab2e65c05$export$78932e9c9abea6b7 = {
    prefix: "fas",
    iconName: "magnet",
    icon: [
        448,
        512,
        [
            129522
        ],
        "f076",
        "M0 160v96C0 379.7 100.3 480 224 480s224-100.3 224-224V160H320v96c0 53-43 96-96 96s-96-43-96-96V160H0zm0-32H128V64c0-17.7-14.3-32-32-32H32C14.3 32 0 46.3 0 64v64zm320 0H448V64c0-17.7-14.3-32-32-32H352c-17.7 0-32 14.3-32 32v64z"
    ]
};
var $d8206b3ab2e65c05$export$53583b459a87a01 = {
    prefix: "fas",
    iconName: "jar",
    icon: [
        320,
        512,
        [],
        "e516",
        "M32 32C32 14.3 46.3 0 64 0H256c17.7 0 32 14.3 32 32s-14.3 32-32 32H64C46.3 64 32 49.7 32 32zM0 160c0-35.3 28.7-64 64-64H256c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V160zm96 64c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32H224c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32H96z"
    ]
};
var $d8206b3ab2e65c05$export$4a4e034527c933f5 = {
    prefix: "fas",
    iconName: "note-sticky",
    icon: [
        448,
        512,
        [
            62026,
            "sticky-note"
        ],
        "f249",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H288V368c0-26.5 21.5-48 48-48H448V96c0-35.3-28.7-64-64-64H64zM448 352H402.7 336c-8.8 0-16 7.2-16 16v66.7V480l32-32 64-64 32-32z"
    ]
};
var $d8206b3ab2e65c05$export$80889adc5d98bf4a = $d8206b3ab2e65c05$export$4a4e034527c933f5;
var $d8206b3ab2e65c05$export$fc4dd5feed8df23 = {
    prefix: "fas",
    iconName: "bug-slash",
    icon: [
        640,
        512,
        [],
        "e490",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L477.4 348.9c1.7-9.4 2.6-19 2.6-28.9h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H479.7c-1.1-14.1-5-27.5-11.1-39.5c.7-.6 1.4-1.2 2.1-1.9l64-64c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-64 64c-.7 .7-1.3 1.4-1.9 2.1C409.2 164.1 393.1 160 376 160H264c-8.3 0-16.3 1-24 2.8L38.8 5.1zm392 430.3L336 360.7V479.2c36.6-3.6 69.7-19.6 94.8-43.8zM166.7 227.3c-3.4 9-5.6 18.7-6.4 28.7H96c-17.7 0-32 14.3-32 32s14.3 32 32 32h64c0 24.6 5.5 47.8 15.4 68.6c-2.2 1.3-4.2 2.9-6 4.8l-64 64c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l63.1-63.1c24.5 21.8 55.8 36.2 90.3 39.6V335.5L166.7 227.3zM320 0c-53 0-96 43-96 96v3.6c0 15.7 12.7 28.4 28.4 28.4H387.6c15.7 0 28.4-12.7 28.4-28.4V96c0-53-43-96-96-96z"
    ]
};
var $d8206b3ab2e65c05$export$1a093e7861c5e48f = {
    prefix: "fas",
    iconName: "arrow-up-from-water-pump",
    icon: [
        576,
        512,
        [],
        "e4b6",
        "M112 0C85.5 0 64 21.5 64 48V256H48c-26.5 0-48 21.5-48 48v96c0 8 2 15.6 5.4 22.2c3.8-1.7 7.8-3.1 12-4.1c13.1-3.1 26.7-9.8 37.3-18.6c22.2-18.7 54.3-20.1 78.1-3.4c18 12.4 40.1 20.3 59.2 20.3c21.1 0 42-8.5 59.2-20.3c22.1-15.5 51.6-15.5 73.7 0c18.4 12.7 39.6 20.3 59.2 20.3c19 0 41.2-7.9 59.2-20.3c23.8-16.7 55.8-15.3 78.1 3.4c10.6 8.8 24.2 15.6 37.3 18.6c4.2 1 8.2 2.4 12 4.1C574 415.6 576 408 576 400V304c0-26.5-21.5-48-48-48H480l0-146.7 25.4 25.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-80-80c-12.5-12.5-32.8-12.5-45.3 0l-80 80c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L416 109.3 416 256H288V48c0-26.5-21.5-48-48-48H112zM306.5 421.9c-11.1-7.9-25.9-7.9-37 0C247 437.4 219.5 448 192 448c-26.9 0-55.3-10.8-77.4-26.1l0 0c-11.9-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C126.5 501.7 159 512 192 512c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.4-27.3-10.1-39.2-1.7l0 0C439.4 437.2 410.9 448 384 448c-27.5 0-55-10.6-77.5-26.1z"
    ]
};
var $d8206b3ab2e65c05$export$5902c007d5703f2d = {
    prefix: "fas",
    iconName: "bone",
    icon: [
        576,
        512,
        [
            129460
        ],
        "f5d7",
        "M153.7 144.8c6.9 16.3 20.6 31.2 38.3 31.2H384c17.7 0 31.4-14.9 38.3-31.2C434.4 116.1 462.9 96 496 96c44.2 0 80 35.8 80 80c0 30.4-17 56.9-42 70.4c-3.6 1.9-6 5.5-6 9.6s2.4 7.7 6 9.6c25 13.5 42 40 42 70.4c0 44.2-35.8 80-80 80c-33.1 0-61.6-20.1-73.7-48.8C415.4 350.9 401.7 336 384 336H192c-17.7 0-31.4 14.9-38.3 31.2C141.6 395.9 113.1 416 80 416c-44.2 0-80-35.8-80-80c0-30.4 17-56.9 42-70.4c3.6-1.9 6-5.5 6-9.6s-2.4-7.7-6-9.6C17 232.9 0 206.4 0 176c0-44.2 35.8-80 80-80c33.1 0 61.6 20.1 73.7 48.8z"
    ]
};
var $d8206b3ab2e65c05$export$c950c1ba7f227d5b = {
    prefix: "fas",
    iconName: "user-injured",
    icon: [
        448,
        512,
        [],
        "f728",
        "M240 80H342.7c-7.9-19.5-20.4-36.5-36.2-49.9L240 80zm37.7-68.2C261.3 4.2 243.2 0 224 0c-53.7 0-99.7 33.1-118.7 80h81.4l91-68.2zM224 256c70.7 0 128-57.3 128-128c0-5.4-.3-10.8-1-16H97c-.7 5.2-1 10.6-1 16c0 70.7 57.3 128 128 128zM124 312.4c-9.7 3.1-19.1 7-28 11.7V512H243.7L181.5 408.2 124 312.4zm33-7.2L204.3 384H272c44.2 0 80 35.8 80 80c0 18-6 34.6-16 48h82.3c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304H178.3c-7.2 0-14.3 .4-21.3 1.3zM0 482.3C0 498.7 13.3 512 29.7 512H64V345.4C24.9 378.1 0 427.3 0 482.3zM320 464c0-26.5-21.5-48-48-48H223.5l57.1 95.2C303 507.2 320 487.6 320 464z"
    ]
};
var $d8206b3ab2e65c05$export$8a5a0dbb2a17e253 = {
    prefix: "fas",
    iconName: "face-sad-tear",
    icon: [
        512,
        512,
        [
            128546,
            "sad-tear"
        ],
        "f5b4",
        "M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm240 80c0-8.8 7.2-16 16-16c45 0 85.6 20.5 115.7 53.1c6 6.5 5.6 16.6-.9 22.6s-16.6 5.6-22.6-.9c-25-27.1-57.4-42.9-92.3-42.9c-8.8 0-16-7.2-16-16zm-80 80c-26.5 0-48-21-48-47c0-20 28.6-60.4 41.6-77.7c3.2-4.4 9.6-4.4 12.8 0C179.6 308.6 208 349 208 369c0 26-21.5 47-48 47zM367.6 208a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm-192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $d8206b3ab2e65c05$export$4b5241926f692f91 = $d8206b3ab2e65c05$export$8a5a0dbb2a17e253;
var $d8206b3ab2e65c05$export$f654c69e66b466c0 = {
    prefix: "fas",
    iconName: "plane",
    icon: [
        576,
        512,
        [],
        "f072",
        "M482.3 192c34.2 0 93.7 29 93.7 64c0 36-59.5 64-93.7 64l-116.6 0L265.2 495.9c-5.7 10-16.3 16.1-27.8 16.1l-56.2 0c-10.6 0-18.3-10.2-15.4-20.4l49-171.6L112 320 68.8 377.6c-3 4-7.8 6.4-12.8 6.4l-42 0c-7.8 0-14-6.3-14-14c0-1.3 .2-2.6 .5-3.9L32 256 .5 145.9c-.4-1.3-.5-2.6-.5-3.9c0-7.8 6.3-14 14-14l42 0c5 0 9.8 2.4 12.8 6.4L112 192l102.9 0-49-171.6C162.9 10.2 170.6 0 181.2 0l56.2 0c11.5 0 22.1 6.2 27.8 16.1L365.7 192l116.6 0z"
    ]
};
var $d8206b3ab2e65c05$export$51adfe7c9ee4f428 = {
    prefix: "fas",
    iconName: "tent-arrows-down",
    icon: [
        576,
        512,
        [],
        "e581",
        "M209.8 111.9c-8.9-9.9-24-10.7-33.9-1.8l-39.9 36L136 24c0-13.3-10.7-24-24-24S88 10.7 88 24l0 122.1-39.9-36c-9.9-8.9-25-8.1-33.9 1.8s-8.1 25 1.8 33.9l80 72c9.1 8.2 23 8.2 32.1 0l80-72c9.9-8.9 10.7-24 1.8-33.9zm352 0c-8.9-9.9-24-10.7-33.9-1.8l-39.9 36V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V146.1l-39.9-36c-9.9-8.9-25-8.1-33.9 1.8s-8.1 25 1.8 33.9l80 72c9.1 8.2 23 8.2 32.1 0l80-72c9.9-8.9 10.7-24 1.8-33.9zM307.4 166.5c-11.5-8.7-27.3-8.7-38.8 0l-168 128c-6.6 5-11 12.5-12.3 20.7l-24 160c-1.4 9.2 1.3 18.6 7.4 25.6S86.7 512 96 512H240h16c17.7 0 32-14.3 32-32V361.9c0-5.5 4.4-9.9 9.9-9.9c3.7 0 7.2 2.1 8.8 5.5l68.4 136.8c5.4 10.8 16.5 17.7 28.6 17.7H464h16c9.3 0 18.2-4.1 24.2-11.1s8.8-16.4 7.4-25.6l-24-160c-1.2-8.2-5.6-15.7-12.3-20.7l-168-128z"
    ]
};
var $d8206b3ab2e65c05$export$de6218b649cbb6a9 = {
    prefix: "fas",
    iconName: "exclamation",
    icon: [
        64,
        512,
        [
            10069,
            10071,
            61738
        ],
        "21",
        "M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64V320c0 17.7 14.3 32 32 32s32-14.3 32-32V64zM32 480a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"
    ]
};
var $d8206b3ab2e65c05$export$7e05388be208e313 = {
    prefix: "fas",
    iconName: "arrows-spin",
    icon: [
        512,
        512,
        [],
        "e4bb",
        "M256 96c38.4 0 73.7 13.5 101.3 36.1l-32.6 32.6c-4.6 4.6-5.9 11.5-3.5 17.4s8.3 9.9 14.8 9.9H448c8.8 0 16-7.2 16-16V64c0-6.5-3.9-12.3-9.9-14.8s-12.9-1.1-17.4 3.5l-34 34C363.4 52.6 312.1 32 256 32c-10.9 0-21.5 .8-32 2.3V99.2c10.3-2.1 21-3.2 32-3.2zM132.1 154.7l32.6 32.6c4.6 4.6 11.5 5.9 17.4 3.5s9.9-8.3 9.9-14.8V64c0-8.8-7.2-16-16-16H64c-6.5 0-12.3 3.9-14.8 9.9s-1.1 12.9 3.5 17.4l34 34C52.6 148.6 32 199.9 32 256c0 10.9 .8 21.5 2.3 32H99.2c-2.1-10.3-3.2-21-3.2-32c0-38.4 13.5-73.7 36.1-101.3zM477.7 224H412.8c2.1 10.3 3.2 21 3.2 32c0 38.4-13.5 73.7-36.1 101.3l-32.6-32.6c-4.6-4.6-11.5-5.9-17.4-3.5s-9.9 8.3-9.9 14.8V448c0 8.8 7.2 16 16 16H448c6.5 0 12.3-3.9 14.8-9.9s1.1-12.9-3.5-17.4l-34-34C459.4 363.4 480 312.1 480 256c0-10.9-.8-21.5-2.3-32zM256 416c-38.4 0-73.7-13.5-101.3-36.1l32.6-32.6c4.6-4.6 5.9-11.5 3.5-17.4s-8.3-9.9-14.8-9.9H64c-8.8 0-16 7.2-16 16l0 112c0 6.5 3.9 12.3 9.9 14.8s12.9 1.1 17.4-3.5l34-34C148.6 459.4 199.9 480 256 480c10.9 0 21.5-.8 32-2.3V412.8c-10.3 2.1-21 3.2-32 3.2z"
    ]
};
var $d8206b3ab2e65c05$export$ae64371e02ee8e56 = {
    prefix: "fas",
    iconName: "print",
    icon: [
        512,
        512,
        [
            128424,
            128438,
            9113
        ],
        "f02f",
        "M128 0C92.7 0 64 28.7 64 64v96h64V64H354.7L384 93.3V160h64V93.3c0-17-6.7-33.3-18.7-45.3L400 18.7C388 6.7 371.7 0 354.7 0H128zM384 352v32 64H128V384 368 352H384zm64 32h32c17.7 0 32-14.3 32-32V256c0-35.3-28.7-64-64-64H64c-35.3 0-64 28.7-64 64v96c0 17.7 14.3 32 32 32H64v64c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V384zM432 248a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
    ]
};
var $d8206b3ab2e65c05$export$b458d393151b6960 = {
    prefix: "fas",
    iconName: "turkish-lira-sign",
    icon: [
        384,
        512,
        [
            "try",
            "turkish-lira"
        ],
        "e2bb",
        "M96 32c17.7 0 32 14.3 32 32V99.3L247.2 65.2c17-4.9 34.7 5 39.6 22s-5 34.7-22 39.6L128 165.9v29.4l119.2-34.1c17-4.9 34.7 5 39.6 22s-5 34.7-22 39.6L128 261.9V416h63.8c68.2 0 124.4-53.5 127.8-121.6l.4-8c.9-17.7 15.9-31.2 33.6-30.4s31.2 15.9 30.4 33.6l-.4 8C378.5 399.8 294.1 480 191.8 480H96c-17.7 0-32-14.3-32-32V280.1l-23.2 6.6c-17 4.9-34.7-5-39.6-22s5-34.7 22-39.6L64 213.6V184.1l-23.2 6.6c-17 4.9-34.7-5-39.6-22s5-34.7 22-39.6L64 117.6V64c0-17.7 14.3-32 32-32z"
    ]
};
var $d8206b3ab2e65c05$export$970dda513e46c41f = $d8206b3ab2e65c05$export$b458d393151b6960;
var $d8206b3ab2e65c05$export$40e66e5966827199 = $d8206b3ab2e65c05$export$b458d393151b6960;
var $d8206b3ab2e65c05$export$fb420d3e4d8c6a18 = {
    prefix: "fas",
    iconName: "dollar-sign",
    icon: [
        320,
        512,
        [
            128178,
            61781,
            "dollar",
            "usd"
        ],
        "24",
        "M160 0c17.7 0 32 14.3 32 32V67.7c1.6 .2 3.1 .4 4.7 .7c.4 .1 .7 .1 1.1 .2l48 8.8c17.4 3.2 28.9 19.9 25.7 37.2s-19.9 28.9-37.2 25.7l-47.5-8.7c-31.3-4.6-58.9-1.5-78.3 6.2s-27.2 18.3-29 28.1c-2 10.7-.5 16.7 1.2 20.4c1.8 3.9 5.5 8.3 12.8 13.2c16.3 10.7 41.3 17.7 73.7 26.3l2.9 .8c28.6 7.6 63.6 16.8 89.6 33.8c14.2 9.3 27.6 21.9 35.9 39.5c8.5 17.9 10.3 37.9 6.4 59.2c-6.9 38-33.1 63.4-65.6 76.7c-13.7 5.6-28.6 9.2-44.4 11V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V445.1c-.4-.1-.9-.1-1.3-.2l-.2 0 0 0c-24.4-3.8-64.5-14.3-91.5-26.3c-16.1-7.2-23.4-26.1-16.2-42.2s26.1-23.4 42.2-16.2c20.9 9.3 55.3 18.5 75.2 21.6c31.9 4.7 58.2 2 76-5.3c16.9-6.9 24.6-16.9 26.8-28.9c1.9-10.6 .4-16.7-1.3-20.4c-1.9-4-5.6-8.4-13-13.3c-16.4-10.7-41.5-17.7-74-26.3l-2.8-.7 0 0C119.4 279.3 84.4 270 58.4 253c-14.2-9.3-27.5-22-35.8-39.6c-8.4-17.9-10.1-37.9-6.1-59.2C23.7 116 52.3 91.2 84.8 78.3c13.3-5.3 27.9-8.9 43.2-11V32c0-17.7 14.3-32 32-32z"
    ]
};
var $d8206b3ab2e65c05$export$a4ffb0775547fcdf = $d8206b3ab2e65c05$export$fb420d3e4d8c6a18;
var $d8206b3ab2e65c05$export$72cca07d38a28589 = $d8206b3ab2e65c05$export$fb420d3e4d8c6a18;
var $d8206b3ab2e65c05$export$476af662c0c32cbc = {
    prefix: "fas",
    iconName: "x",
    icon: [
        384,
        512,
        [
            120
        ],
        "58",
        "M376.6 84.5c11.3-13.6 9.5-33.8-4.1-45.1s-33.8-9.5-45.1 4.1L192 206 56.6 43.5C45.3 29.9 25.1 28.1 11.5 39.4S-3.9 70.9 7.4 84.5L150.3 256 7.4 427.5c-11.3 13.6-9.5 33.8 4.1 45.1s33.8 9.5 45.1-4.1L192 306 327.4 468.5c11.3 13.6 31.5 15.4 45.1 4.1s15.4-31.5 4.1-45.1L233.7 256 376.6 84.5z"
    ]
};
var $d8206b3ab2e65c05$export$fa4f1ead37dc1dce = {
    prefix: "fas",
    iconName: "magnifying-glass-dollar",
    icon: [
        512,
        512,
        [
            "search-dollar"
        ],
        "f688",
        "M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM228 104c0-11-9-20-20-20s-20 9-20 20v14c-7.6 1.7-15.2 4.4-22.2 8.5c-13.9 8.3-25.9 22.8-25.8 43.9c.1 20.3 12 33.1 24.7 40.7c11 6.6 24.7 10.8 35.6 14l1.7 .5c12.6 3.8 21.8 6.8 28 10.7c5.1 3.2 5.8 5.4 5.9 8.2c.1 5-1.8 8-5.9 10.5c-5 3.1-12.9 5-21.4 4.7c-11.1-.4-21.5-3.9-35.1-8.5c-2.3-.8-4.7-1.6-7.2-2.4c-10.5-3.5-21.8 2.2-25.3 12.6s2.2 21.8 12.6 25.3c1.9 .6 4 1.3 6.1 2.1l0 0 0 0c8.3 2.9 17.9 6.2 28.2 8.4V312c0 11 9 20 20 20s20-9 20-20V298.2c8-1.7 16-4.5 23.2-9c14.3-8.9 25.1-24.1 24.8-45c-.3-20.3-11.7-33.4-24.6-41.6c-11.5-7.2-25.9-11.6-37.1-15l-.7-.2c-12.8-3.9-21.9-6.7-28.3-10.5c-5.2-3.1-5.3-4.9-5.3-6.7c0-3.7 1.4-6.5 6.2-9.3c5.4-3.2 13.6-5.1 21.5-5c9.6 .1 20.2 2.2 31.2 5.2c10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-6.5-1.7-13.7-3.4-21.1-4.7V104z"
    ]
};
var $d8206b3ab2e65c05$export$65b49a6767630708 = $d8206b3ab2e65c05$export$fa4f1ead37dc1dce;
var $d8206b3ab2e65c05$export$3a18218720110fc0 = {
    prefix: "fas",
    iconName: "users-gear",
    icon: [
        640,
        512,
        [
            "users-cog"
        ],
        "f509",
        "M144 160A80 80 0 1 0 144 0a80 80 0 1 0 0 160zm368 0A80 80 0 1 0 512 0a80 80 0 1 0 0 160zM0 298.7C0 310.4 9.6 320 21.3 320H234.7c.2 0 .4 0 .7 0c-26.6-23.5-43.3-57.8-43.3-96c0-7.6 .7-15 1.9-22.3c-13.6-6.3-28.7-9.7-44.6-9.7H106.7C47.8 192 0 239.8 0 298.7zM320 320c24 0 45.9-8.8 62.7-23.3c2.5-3.7 5.2-7.3 8-10.7c2.7-3.3 5.7-6.1 9-8.3C410 262.3 416 243.9 416 224c0-53-43-96-96-96s-96 43-96 96s43 96 96 96zm65.4 60.2c-10.3-5.9-18.1-16.2-20.8-28.2H261.3C187.7 352 128 411.7 128 485.3c0 14.7 11.9 26.7 26.7 26.7H455.2c-2.1-5.2-3.2-10.9-3.2-16.4v-3c-1.3-.7-2.7-1.5-4-2.3l-2.6 1.5c-16.8 9.7-40.5 8-54.7-9.7c-4.5-5.6-8.6-11.5-12.4-17.6l-.1-.2-.1-.2-2.4-4.1-.1-.2-.1-.2c-3.4-6.2-6.4-12.6-9-19.3c-8.2-21.2 2.2-42.6 19-52.3l2.7-1.5c0-.8 0-1.5 0-2.3s0-1.5 0-2.3l-2.7-1.5zM533.3 192H490.7c-15.9 0-31 3.5-44.6 9.7c1.3 7.2 1.9 14.7 1.9 22.3c0 17.4-3.5 33.9-9.7 49c2.5 .9 4.9 2 7.1 3.3l2.6 1.5c1.3-.8 2.6-1.6 4-2.3v-3c0-19.4 13.3-39.1 35.8-42.6c7.9-1.2 16-1.9 24.2-1.9s16.3 .6 24.2 1.9c22.5 3.5 35.8 23.2 35.8 42.6v3c1.3 .7 2.7 1.5 4 2.3l2.6-1.5c16.8-9.7 40.5-8 54.7 9.7c2.3 2.8 4.5 5.8 6.6 8.7c-2.1-57.1-49-102.7-106.6-102.7zm91.3 163.9c6.3-3.6 9.5-11.1 6.8-18c-2.1-5.5-4.6-10.8-7.4-15.9l-2.3-4c-3.1-5.1-6.5-9.9-10.2-14.5c-4.6-5.7-12.7-6.7-19-3l-2.9 1.7c-9.2 5.3-20.4 4-29.6-1.3s-16.1-14.5-16.1-25.1v-3.4c0-7.3-4.9-13.8-12.1-14.9c-6.5-1-13.1-1.5-19.9-1.5s-13.4 .5-19.9 1.5c-7.2 1.1-12.1 7.6-12.1 14.9v3.4c0 10.6-6.9 19.8-16.1 25.1s-20.4 6.6-29.6 1.3l-2.9-1.7c-6.3-3.6-14.4-2.6-19 3c-3.7 4.6-7.1 9.5-10.2 14.6l-2.3 3.9c-2.8 5.1-5.3 10.4-7.4 15.9c-2.6 6.8 .5 14.3 6.8 17.9l2.9 1.7c9.2 5.3 13.7 15.8 13.7 26.4s-4.5 21.1-13.7 26.4l-3 1.7c-6.3 3.6-9.5 11.1-6.8 17.9c2.1 5.5 4.6 10.7 7.4 15.8l2.4 4.1c3 5.1 6.4 9.9 10.1 14.5c4.6 5.7 12.7 6.7 19 3l2.9-1.7c9.2-5.3 20.4-4 29.6 1.3s16.1 14.5 16.1 25.1v3.4c0 7.3 4.9 13.8 12.1 14.9c6.5 1 13.1 1.5 19.9 1.5s13.4-.5 19.9-1.5c7.2-1.1 12.1-7.6 12.1-14.9v-3.4c0-10.6 6.9-19.8 16.1-25.1s20.4-6.6 29.6-1.3l2.9 1.7c6.3 3.6 14.4 2.6 19-3c3.7-4.6 7.1-9.4 10.1-14.5l2.4-4.2c2.8-5.1 5.3-10.3 7.4-15.8c2.6-6.8-.5-14.3-6.8-17.9l-3-1.7c-9.2-5.3-13.7-15.8-13.7-26.4s4.5-21.1 13.7-26.4l3-1.7zM472 384a40 40 0 1 1 80 0 40 40 0 1 1 -80 0z"
    ]
};
var $d8206b3ab2e65c05$export$5e0b06753fc69b81 = $d8206b3ab2e65c05$export$3a18218720110fc0;
var $d8206b3ab2e65c05$export$50b6dcaa9ec03439 = {
    prefix: "fas",
    iconName: "person-military-pointing",
    icon: [
        576,
        512,
        [],
        "e54a",
        "M246.9 14.1C234 15.2 224 26 224 39c0 13.8 11.2 25 25 25H400c8.8 0 16-7.2 16-16V17.4C416 8 408 .7 398.7 1.4L246.9 14.1zM240 112c0 44.2 35.8 80 80 80s80-35.8 80-80c0-5.5-.6-10.8-1.6-16H241.6c-1 5.2-1.6 10.5-1.6 16zM72 224c-22.1 0-40 17.9-40 40s17.9 40 40 40H224v89.4L386.8 230.5c-13.3-4.3-27.3-6.5-41.6-6.5H240 72zm345.7 20.9L246.6 416H416V369.7l53.6 90.6c11.2 19 35.8 25.3 54.8 14.1s25.3-35.8 14.1-54.8L462.3 290.8c-11.2-18.9-26.6-34.5-44.6-45.9zM224 448v32c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V448H224z"
    ]
};
var $d8206b3ab2e65c05$export$a411e7e26cb63d5e = {
    prefix: "fas",
    iconName: "building-columns",
    icon: [
        512,
        512,
        [
            "bank",
            "institution",
            "museum",
            "university"
        ],
        "f19c",
        "M243.4 2.6l-224 96c-14 6-21.8 21-18.7 35.8S16.8 160 32 160v8c0 13.3 10.7 24 24 24H456c13.3 0 24-10.7 24-24v-8c15.2 0 28.3-10.7 31.3-25.6s-4.8-29.9-18.7-35.8l-224-96c-8-3.4-17.2-3.4-25.2 0zM128 224H64V420.3c-.6 .3-1.2 .7-1.8 1.1l-48 32c-11.7 7.8-17 22.4-12.9 35.9S17.9 512 32 512H480c14.1 0 26.5-9.2 30.6-22.7s-1.1-28.1-12.9-35.9l-48-32c-.6-.4-1.2-.7-1.8-1.1V224H384V416H344V224H280V416H232V224H168V416H128V224zM256 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $d8206b3ab2e65c05$export$6e379b829ea8b99 = $d8206b3ab2e65c05$export$a411e7e26cb63d5e;
var $d8206b3ab2e65c05$export$1dba320226a34c1f = $d8206b3ab2e65c05$export$a411e7e26cb63d5e;
var $d8206b3ab2e65c05$export$9b3953adff472ad2 = $d8206b3ab2e65c05$export$a411e7e26cb63d5e;
var $d8206b3ab2e65c05$export$f2e1460ebe1a8cb0 = $d8206b3ab2e65c05$export$a411e7e26cb63d5e;
var $d8206b3ab2e65c05$export$9ff64ffae70e08c0 = {
    prefix: "fas",
    iconName: "umbrella",
    icon: [
        576,
        512,
        [],
        "f0e9",
        "M288 0c17.7 0 32 14.3 32 32V49.7C451.8 63.4 557.7 161 573.9 285.9c2 15.6-17.3 24.4-27.8 12.7C532.1 283 504.8 272 480 272c-38.7 0-71 27.5-78.4 64.1c-1.7 8.7-8.7 15.9-17.6 15.9s-15.8-7.2-17.6-15.9C359 299.5 326.7 272 288 272s-71 27.5-78.4 64.1c-1.7 8.7-8.7 15.9-17.6 15.9s-15.8-7.2-17.6-15.9C167 299.5 134.7 272 96 272c-24.8 0-52.1 11-66.1 26.7C19.4 310.4 .1 301.5 2.1 285.9C18.3 161 124.2 63.4 256 49.7V32c0-17.7 14.3-32 32-32zm0 304c12.3 0 23.5 4.6 32 12.2V430.6c0 45-36.5 81.4-81.4 81.4c-30.8 0-59-17.4-72.8-45l-2.3-4.7c-7.9-15.8-1.5-35 14.3-42.9s35-1.5 42.9 14.3l2.3 4.7c3 5.9 9 9.6 15.6 9.6c9.6 0 17.4-7.8 17.4-17.4V316.2c8.5-7.6 19.7-12.2 32-12.2z"
    ]
};
var $d8206b3ab2e65c05$export$12ca996a6f686fe1 = {
    prefix: "fas",
    iconName: "trowel",
    icon: [
        512,
        512,
        [],
        "e589",
        "M343.9 213.4L245.3 312l65.4 65.4c7.9 7.9 11.1 19.4 8.4 30.3s-10.8 19.6-21.5 22.9l-256 80c-11.4 3.5-23.8 .5-32.2-7.9S-2.1 481.8 1.5 470.5l80-256c3.3-10.7 12-18.9 22.9-21.5s22.4 .5 30.3 8.4L200 266.7l98.6-98.6c-14.3-14.6-14.2-38 .3-52.5l95.4-95.4c26.9-26.9 70.5-26.9 97.5 0s26.9 70.5 0 97.5l-95.4 95.4c-14.5 14.5-37.9 14.6-52.5 .3z"
    ]
};
var $d8206b3ab2e65c05$export$56c73b799aac2555 = {
    prefix: "fas",
    iconName: "d",
    icon: [
        384,
        512,
        [
            100
        ],
        "44",
        "M0 96C0 60.7 28.7 32 64 32h96c123.7 0 224 100.3 224 224s-100.3 224-224 224H64c-35.3 0-64-28.7-64-64V96zm160 0H64V416h96c88.4 0 160-71.6 160-160s-71.6-160-160-160z"
    ]
};
var $d8206b3ab2e65c05$export$c7e014b7e3ac3d83 = {
    prefix: "fas",
    iconName: "stapler",
    icon: [
        640,
        512,
        [],
        "e5af",
        "M640 299.3V304 432c0 26.5-21.5 48-48 48H512 448 64c-17.7 0-32-14.3-32-32s14.3-32 32-32H448V368H96c-17.7 0-32-14.3-32-32V219.4L33.8 214C14.2 210.5 0 193.5 0 173.7c0-8.9 2.9-17.5 8.2-24.6l35.6-47.5C76.7 57.8 128.2 32 182.9 32c27 0 53.6 6.3 77.8 18.4L586.9 213.5C619.5 229.7 640 263 640 299.3zM448 304V288L128 230.9V304H448z"
    ]
};
var $d8206b3ab2e65c05$export$bf5896cc1ce4d55 = {
    prefix: "fas",
    iconName: "masks-theater",
    icon: [
        640,
        512,
        [
            127917,
            "theater-masks"
        ],
        "f630",
        "M74.6 373.2c41.7 36.1 108 82.5 166.1 73.7c6.1-.9 12.1-2.5 18-4.5c-9.2-12.3-17.3-24.4-24.2-35.4c-21.9-35-28.8-75.2-25.9-113.6c-20.6 4.1-39.2 13-54.7 25.4c-6.5 5.2-16.3 1.3-14.8-7c6.4-33.5 33-60.9 68.2-66.3c2.6-.4 5.3-.7 7.9-.8l19.4-131.3c2-13.8 8-32.7 25-45.9C278.2 53.2 310.5 37 363.2 32.2c-.8-.7-1.6-1.4-2.4-2.1C340.6 14.5 288.4-11.5 175.7 5.6S20.5 63 5.7 83.9C0 91.9-.8 102 .6 111.8L24.8 276.1c5.5 37.3 21.5 72.6 49.8 97.2zm87.7-219.6c4.4-3.1 10.8-2 11.8 3.3c.1 .5 .2 1.1 .3 1.6c3.2 21.8-11.6 42-33.1 45.3s-41.5-11.8-44.7-33.5c-.1-.5-.1-1.1-.2-1.6c-.6-5.4 5.2-8.4 10.3-6.7c9 3 18.8 3.9 28.7 2.4s19.1-5.3 26.8-10.8zM261.6 390c29.4 46.9 79.5 110.9 137.6 119.7s124.5-37.5 166.1-73.7c28.3-24.5 44.3-59.8 49.8-97.2l24.2-164.3c1.4-9.8 .6-19.9-5.1-27.9c-14.8-20.9-57.3-61.2-170-78.3S299.4 77.2 279.2 92.8c-7.8 6-11.5 15.4-12.9 25.2L242.1 282.3c-5.5 37.3-.4 75.8 19.6 107.7zM404.5 235.3c-7.7-5.5-16.8-9.3-26.8-10.8s-19.8-.6-28.7 2.4c-5.1 1.7-10.9-1.3-10.3-6.7c.1-.5 .1-1.1 .2-1.6c3.2-21.8 23.2-36.8 44.7-33.5s36.3 23.5 33.1 45.3c-.1 .5-.2 1.1-.3 1.6c-1 5.3-7.4 6.4-11.8 3.3zm136.2 15.5c-1 5.3-7.4 6.4-11.8 3.3c-7.7-5.5-16.8-9.3-26.8-10.8s-19.8-.6-28.7 2.4c-5.1 1.7-10.9-1.3-10.3-6.7c.1-.5 .1-1.1 .2-1.6c3.2-21.8 23.2-36.8 44.7-33.5s36.3 23.5 33.1 45.3c-.1 .5-.2 1.1-.3 1.6zM530 350.2c-19.6 44.7-66.8 72.5-116.8 64.9s-87.1-48.2-93-96.7c-1-8.3 8.9-12.1 15.2-6.7c23.9 20.8 53.6 35.3 87 40.3s66.1 .1 94.9-12.8c7.6-3.4 16 3.2 12.6 10.9z"
    ]
};
var $d8206b3ab2e65c05$export$3dbedc487b0159ac = $d8206b3ab2e65c05$export$bf5896cc1ce4d55;
var $d8206b3ab2e65c05$export$a6df39524c41472c = {
    prefix: "fas",
    iconName: "kip-sign",
    icon: [
        384,
        512,
        [],
        "e1c4",
        "M340.8 88.3c13.4-11.5 15-31.7 3.5-45.1s-31.7-15-45.1-3.5L128 186.4V64c0-17.7-14.3-32-32-32S64 46.3 64 64V224H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H64V448c0 17.7 14.3 32 32 32s32-14.3 32-32V325.6L299.2 472.3c13.4 11.5 33.6 9.9 45.1-3.5s9.9-33.6-3.5-45.1L182.5 288H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H182.5L340.8 88.3z"
    ]
};
var $d8206b3ab2e65c05$export$b276ec3dc9760d39 = {
    prefix: "fas",
    iconName: "hand-point-left",
    icon: [
        512,
        512,
        [],
        "f0a5",
        "M32 96C14.3 96 0 110.3 0 128s14.3 32 32 32l208 0 0-64L32 96zM192 288c-17.7 0-32 14.3-32 32s14.3 32 32 32l64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0zm-64-64c0 17.7 14.3 32 32 32l48 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-48 0c-17.7 0-32 14.3-32 32zm96 160c-17.7 0-32 14.3-32 32s14.3 32 32 32l64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0zm88-96l-.6 0c5.4 9.4 8.6 20.3 8.6 32c0 13.2-4 25.4-10.8 35.6c24.9 8.7 42.8 32.5 42.8 60.4c0 11.7-3.1 22.6-8.6 32l8.6 0c88.4 0 160-71.6 160-160l0-61.7c0-42.4-16.9-83.1-46.9-113.1l-11.6-11.6C429.5 77.5 396.9 64 363 64l-27 0c-35.3 0-64 28.7-64 64l0 88c0 22.1 17.9 40 40 40s40-17.9 40-40l0-56c0-8.8 7.2-16 16-16s16 7.2 16 16l0 56c0 39.8-32.2 72-72 72z"
    ]
};
var $d8206b3ab2e65c05$export$e8485db4dab0ab30 = {
    prefix: "fas",
    iconName: "handshake-simple",
    icon: [
        640,
        512,
        [
            129309,
            "handshake-alt"
        ],
        "f4c6",
        "M323.4 85.2l-96.8 78.4c-16.1 13-19.2 36.4-7 53.1c12.9 17.8 38 21.3 55.3 7.8l99.3-77.2c7-5.4 17-4.2 22.5 2.8s4.2 17-2.8 22.5l-20.9 16.2L550.2 352H592c26.5 0 48-21.5 48-48V176c0-26.5-21.5-48-48-48H516h-4-.7l-3.9-2.5L434.8 79c-15.3-9.8-33.2-15-51.4-15c-21.8 0-43 7.5-60 21.2zm22.8 124.4l-51.7 40.2C263 274.4 217.3 268 193.7 235.6c-22.2-30.5-16.6-73.1 12.7-96.8l83.2-67.3c-11.6-4.9-24.1-7.4-36.8-7.4C234 64 215.7 69.6 200 80l-72 48H48c-26.5 0-48 21.5-48 48V304c0 26.5 21.5 48 48 48H156.2l91.4 83.4c19.6 17.9 49.9 16.5 67.8-3.1c5.5-6.1 9.2-13.2 11.1-20.6l17 15.6c19.5 17.9 49.9 16.6 67.8-2.9c4.5-4.9 7.8-10.6 9.9-16.5c19.4 13 45.8 10.3 62.1-7.5c17.9-19.5 16.6-49.9-2.9-67.8l-134.2-123z"
    ]
};
var $d8206b3ab2e65c05$export$e9aa3c6f9f47aa1a = $d8206b3ab2e65c05$export$e8485db4dab0ab30;
var $d8206b3ab2e65c05$export$2130e629ab767ab3 = {
    prefix: "fas",
    iconName: "jet-fighter",
    icon: [
        640,
        512,
        [
            "fighter-jet"
        ],
        "f0fb",
        "M160 24c0-13.3 10.7-24 24-24H296c13.3 0 24 10.7 24 24s-10.7 24-24 24H280L384 192H500.4c7.7 0 15.3 1.4 22.5 4.1L625 234.4c9 3.4 15 12 15 21.6s-6 18.2-15 21.6L522.9 315.9c-7.2 2.7-14.8 4.1-22.5 4.1H384L280 464h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24s10.7-24 24-24h8V320H160l-54.6 54.6c-6 6-14.1 9.4-22.6 9.4H64c-17.7 0-32-14.3-32-32V288c-17.7 0-32-14.3-32-32s14.3-32 32-32V160c0-17.7 14.3-32 32-32H82.7c8.5 0 16.6 3.4 22.6 9.4L160 192h32V48h-8c-13.3 0-24-10.7-24-24zM80 240c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H80z"
    ]
};
var $d8206b3ab2e65c05$export$102b809faf56e033 = $d8206b3ab2e65c05$export$2130e629ab767ab3;
var $d8206b3ab2e65c05$export$1bdb0ec5af3fea99 = {
    prefix: "fas",
    iconName: "square-share-nodes",
    icon: [
        448,
        512,
        [
            "share-alt-square"
        ],
        "f1e1",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM384 160c0 35.3-28.7 64-64 64c-15.4 0-29.5-5.4-40.6-14.5L194.1 256l85.3 46.5c11-9.1 25.2-14.5 40.6-14.5c35.3 0 64 28.7 64 64s-28.7 64-64 64s-64-28.7-64-64c0-2.5 .1-4.9 .4-7.3L174.5 300c-11.7 12.3-28.2 20-46.5 20c-35.3 0-64-28.7-64-64s28.7-64 64-64c18.3 0 34.8 7.7 46.5 20l81.9-44.7c-.3-2.4-.4-4.9-.4-7.3c0-35.3 28.7-64 64-64s64 28.7 64 64z"
    ]
};
var $d8206b3ab2e65c05$export$3799c2d8fd7e493b = $d8206b3ab2e65c05$export$1bdb0ec5af3fea99;
var $d8206b3ab2e65c05$export$3825a842b5afc5aa = {
    prefix: "fas",
    iconName: "barcode",
    icon: [
        512,
        512,
        [],
        "f02a",
        "M24 32C10.7 32 0 42.7 0 56V456c0 13.3 10.7 24 24 24H40c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24H24zm88 0c-8.8 0-16 7.2-16 16V464c0 8.8 7.2 16 16 16s16-7.2 16-16V48c0-8.8-7.2-16-16-16zm72 0c-13.3 0-24 10.7-24 24V456c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24H184zm96 0c-13.3 0-24 10.7-24 24V456c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24H280zM448 56V456c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24H472c-13.3 0-24 10.7-24 24zm-64-8V464c0 8.8 7.2 16 16 16s16-7.2 16-16V48c0-8.8-7.2-16-16-16s-16 7.2-16 16z"
    ]
};
var $d8206b3ab2e65c05$export$37bd38cf96417095 = {
    prefix: "fas",
    iconName: "plus-minus",
    icon: [
        384,
        512,
        [],
        "e43c",
        "M224 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V144H48c-17.7 0-32 14.3-32 32s14.3 32 32 32H160V320c0 17.7 14.3 32 32 32s32-14.3 32-32V208H336c17.7 0 32-14.3 32-32s-14.3-32-32-32H224V32zM0 480c0 17.7 14.3 32 32 32H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H32c-17.7 0-32 14.3-32 32z"
    ]
};
var $d8206b3ab2e65c05$export$5c6bd8729527871b = {
    prefix: "fas",
    iconName: "video",
    icon: [
        576,
        512,
        [
            "video-camera"
        ],
        "f03d",
        "M0 128C0 92.7 28.7 64 64 64H320c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zM559.1 99.8c10.4 5.6 16.9 16.4 16.9 28.2V384c0 11.8-6.5 22.6-16.9 28.2s-23 5-32.9-1.6l-96-64L416 337.1V320 192 174.9l14.2-9.5 96-64c9.8-6.5 22.4-7.2 32.9-1.6z"
    ]
};
var $d8206b3ab2e65c05$export$3a530df752193ccf = $d8206b3ab2e65c05$export$5c6bd8729527871b;
var $d8206b3ab2e65c05$export$874e305fd7920cce = {
    prefix: "fas",
    iconName: "graduation-cap",
    icon: [
        640,
        512,
        [
            127891,
            "mortar-board"
        ],
        "f19d",
        "M320 32c-8.1 0-16.1 1.4-23.7 4.1L15.8 137.4C6.3 140.9 0 149.9 0 160s6.3 19.1 15.8 22.6l57.9 20.9C57.3 229.3 48 259.8 48 291.9v28.1c0 28.4-10.8 57.7-22.3 80.8c-6.5 13-13.9 25.8-22.5 37.6C0 442.7-.9 448.3 .9 453.4s6 8.9 11.2 10.2l64 16c4.2 1.1 8.7 .3 12.4-2s6.3-6.1 7.1-10.4c8.6-42.8 4.3-81.2-2.1-108.7C90.3 344.3 86 329.8 80 316.5V291.9c0-30.2 10.2-58.7 27.9-81.5c12.9-15.5 29.6-28 49.2-35.7l157-61.7c8.2-3.2 17.5 .8 20.7 9s-.8 17.5-9 20.7l-157 61.7c-12.4 4.9-23.3 12.4-32.2 21.6l159.6 57.6c7.6 2.7 15.6 4.1 23.7 4.1s16.1-1.4 23.7-4.1L624.2 182.6c9.5-3.4 15.8-12.5 15.8-22.6s-6.3-19.1-15.8-22.6L343.7 36.1C336.1 33.4 328.1 32 320 32zM128 408c0 35.3 86 72 192 72s192-36.7 192-72L496.7 262.6 354.5 314c-11.1 4-22.8 6-34.5 6s-23.5-2-34.5-6L143.3 262.6 128 408z"
    ]
};
var $d8206b3ab2e65c05$export$dd0a013bf23a9d86 = $d8206b3ab2e65c05$export$874e305fd7920cce;
var $d8206b3ab2e65c05$export$bb2a6b1b5e852300 = {
    prefix: "fas",
    iconName: "hand-holding-medical",
    icon: [
        576,
        512,
        [],
        "e05c",
        "M224 24V80H168c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h56v56c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V176h56c13.3 0 24-10.7 24-24V104c0-13.3-10.7-24-24-24H320V24c0-13.3-10.7-24-24-24H248c-13.3 0-24 10.7-24 24zM559.7 392.2c17.8-13.1 21.6-38.1 8.5-55.9s-38.1-21.6-55.9-8.5L392.6 416H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h16 64c17.7 0 32-14.3 32-32s-14.3-32-32-32H288 272 193.7c-29.1 0-57.3 9.9-80 28L68.8 384H32c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H192 352.5c29 0 57.3-9.3 80.7-26.5l126.6-93.3zm-367-8.2l.9 0 0 0c-.3 0-.6 0-.9 0z"
    ]
};
var $d8206b3ab2e65c05$export$30294c81ac4031ca = {
    prefix: "fas",
    iconName: "person-circle-check",
    icon: [
        576,
        512,
        [],
        "e53e",
        "M112 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm40 304V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V256.9L59.4 304.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c17.4-28.9 48.6-46.6 82.3-46.6h29.7c33.7 0 64.9 17.7 82.3 46.6l44.9 74.7c-16.1 17.6-28.6 38.5-36.6 61.5c-1.9-1.8-3.5-3.9-4.9-6.3L232 256.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352H152zm136 16a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm211.3-43.3c-6.2-6.2-16.4-6.2-22.6 0L416 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z"
    ]
};
var $d8206b3ab2e65c05$export$314f5cab62fc6968 = {
    prefix: "fas",
    iconName: "turn-up",
    icon: [
        384,
        512,
        [
            10548,
            "level-up-alt"
        ],
        "f3bf",
        "M350 177.5c3.8-8.8 2-19-4.6-26l-136-144C204.9 2.7 198.6 0 192 0s-12.9 2.7-17.4 7.5l-136 144c-6.6 7-8.4 17.2-4.6 26s12.5 14.5 22 14.5h88l0 192c0 17.7-14.3 32-32 32H32c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32l80 0c70.7 0 128-57.3 128-128l0-192h88c9.6 0 18.2-5.7 22-14.5z"
    ]
};
var $d8206b3ab2e65c05$export$d6f21a309b179c3d = $d8206b3ab2e65c05$export$314f5cab62fc6968;
var $d8206b3ab2e65c05$export$da048c47c8dcd50a = {
    fa0: $d8206b3ab2e65c05$export$f22454595d96c106,
    fa1: $d8206b3ab2e65c05$export$8398cb2addc9e182,
    fa2: $d8206b3ab2e65c05$export$ed1a0ff7bd680a1d,
    fa3: $d8206b3ab2e65c05$export$74b7ff79ce1818d6,
    fa4: $d8206b3ab2e65c05$export$969b2215780d58fd,
    fa5: $d8206b3ab2e65c05$export$3919f68a5b3825a9,
    fa6: $d8206b3ab2e65c05$export$580ac17b31ffb5c3,
    fa7: $d8206b3ab2e65c05$export$ee79cab31be16d23,
    fa8: $d8206b3ab2e65c05$export$45d84c4b2c560d2f,
    fa9: $d8206b3ab2e65c05$export$a120f1e4223629f2,
    faFillDrip: $d8206b3ab2e65c05$export$38320138fc0262d0,
    faArrowsToCircle: $d8206b3ab2e65c05$export$917a3d30f6cd766,
    faCircleChevronRight: $d8206b3ab2e65c05$export$a39bab13d51abfd0,
    faChevronCircleRight: $d8206b3ab2e65c05$export$2a5db4f6eba6f2b,
    faAt: $d8206b3ab2e65c05$export$c115e8063ee02632,
    faTrashCan: $d8206b3ab2e65c05$export$864bb8d6c21fb792,
    faTrashAlt: $d8206b3ab2e65c05$export$88df7ff7eb32f9dc,
    faTextHeight: $d8206b3ab2e65c05$export$3313bce3924ea7da,
    faUserXmark: $d8206b3ab2e65c05$export$e585697127cda27,
    faUserTimes: $d8206b3ab2e65c05$export$45b996d071667753,
    faStethoscope: $d8206b3ab2e65c05$export$acb2d72d28cd92d9,
    faMessage: $d8206b3ab2e65c05$export$6563a67224e7f879,
    faCommentAlt: $d8206b3ab2e65c05$export$6e96904d9af0ec4a,
    faInfo: $d8206b3ab2e65c05$export$d469b770895f47ac,
    faDownLeftAndUpRightToCenter: $d8206b3ab2e65c05$export$d56736f5800b3f0d,
    faCompressAlt: $d8206b3ab2e65c05$export$a05650ebe54bede,
    faExplosion: $d8206b3ab2e65c05$export$36b5fbeae4855055,
    faFileLines: $d8206b3ab2e65c05$export$ef565d07efe2b5e9,
    faFileAlt: $d8206b3ab2e65c05$export$243b47dca32bf0b8,
    faFileText: $d8206b3ab2e65c05$export$f466100bf9bf37a5,
    faWaveSquare: $d8206b3ab2e65c05$export$c38cf504b3bc58a2,
    faRing: $d8206b3ab2e65c05$export$a95486586631edc7,
    faBuildingUn: $d8206b3ab2e65c05$export$fbbc7601eb465ac7,
    faDiceThree: $d8206b3ab2e65c05$export$221059e0d5fd8958,
    faCalendarDays: $d8206b3ab2e65c05$export$31c6cf6f5d38dc0,
    faCalendarAlt: $d8206b3ab2e65c05$export$cbc139f33cff356,
    faAnchorCircleCheck: $d8206b3ab2e65c05$export$8bce49e6ae597af8,
    faBuildingCircleArrowRight: $d8206b3ab2e65c05$export$37584b1a5e175b47,
    faVolleyball: $d8206b3ab2e65c05$export$cc519c9529a46c5c,
    faVolleyballBall: $d8206b3ab2e65c05$export$a15e6fc8e68a76b0,
    faArrowsUpToLine: $d8206b3ab2e65c05$export$159982ce2622211e,
    faSortDown: $d8206b3ab2e65c05$export$58e2577a373e7d4,
    faSortDesc: $d8206b3ab2e65c05$export$e24f016f5f78af6a,
    faCircleMinus: $d8206b3ab2e65c05$export$d0163707993a8110,
    faMinusCircle: $d8206b3ab2e65c05$export$f3979b49bf57313c,
    faDoorOpen: $d8206b3ab2e65c05$export$41821b9a6fd703de,
    faRightFromBracket: $d8206b3ab2e65c05$export$122a80ae0f87f726,
    faSignOutAlt: $d8206b3ab2e65c05$export$c844d6923b7096c2,
    faAtom: $d8206b3ab2e65c05$export$b5bb295e8ad4ab31,
    faSoap: $d8206b3ab2e65c05$export$64f1c53b21f310ac,
    faIcons: $d8206b3ab2e65c05$export$7fe2894454d8eb8a,
    faHeartMusicCameraBolt: $d8206b3ab2e65c05$export$ec74c13cedb0791d,
    faMicrophoneLinesSlash: $d8206b3ab2e65c05$export$4be1b324ac8a71ba,
    faMicrophoneAltSlash: $d8206b3ab2e65c05$export$d2a53a388f30780,
    faBridgeCircleCheck: $d8206b3ab2e65c05$export$ea908d3d80c57d08,
    faPumpMedical: $d8206b3ab2e65c05$export$f1b881c73328720c,
    faFingerprint: $d8206b3ab2e65c05$export$614dc068d88655af,
    faHandPointRight: $d8206b3ab2e65c05$export$f7bc8714c970afa4,
    faMagnifyingGlassLocation: $d8206b3ab2e65c05$export$234a18b2b4d530a3,
    faSearchLocation: $d8206b3ab2e65c05$export$c33aba6c251a898a,
    faForwardStep: $d8206b3ab2e65c05$export$908d699be6717adc,
    faStepForward: $d8206b3ab2e65c05$export$b303329afce5de18,
    faFaceSmileBeam: $d8206b3ab2e65c05$export$e3c56ed54f074063,
    faSmileBeam: $d8206b3ab2e65c05$export$54ada6dc9690e0ca,
    faFlagCheckered: $d8206b3ab2e65c05$export$92fad97e19a9fea,
    faFootball: $d8206b3ab2e65c05$export$e15f65e77f717c29,
    faFootballBall: $d8206b3ab2e65c05$export$e8fd664711e31704,
    faSchoolCircleExclamation: $d8206b3ab2e65c05$export$f629fdee00932a01,
    faCrop: $d8206b3ab2e65c05$export$afa58590dfb6fca2,
    faAnglesDown: $d8206b3ab2e65c05$export$52783a541b1bb03,
    faAngleDoubleDown: $d8206b3ab2e65c05$export$fd504117f273ca92,
    faUsersRectangle: $d8206b3ab2e65c05$export$a28757068b9a3a9a,
    faPeopleRoof: $d8206b3ab2e65c05$export$b96e695bdcf3f3f5,
    faPeopleLine: $d8206b3ab2e65c05$export$d12c2d6def120efe,
    faBeerMugEmpty: $d8206b3ab2e65c05$export$b957c27bc5330472,
    faBeer: $d8206b3ab2e65c05$export$f74725691538983b,
    faDiagramPredecessor: $d8206b3ab2e65c05$export$1852c99deca7bee8,
    faArrowUpLong: $d8206b3ab2e65c05$export$92c58defe6e4c5a7,
    faLongArrowUp: $d8206b3ab2e65c05$export$ede1d50ec4b01670,
    faFireFlameSimple: $d8206b3ab2e65c05$export$9ebfff5c90672059,
    faBurn: $d8206b3ab2e65c05$export$80ed4535efc60402,
    faPerson: $d8206b3ab2e65c05$export$e6619e43cb090a16,
    faMale: $d8206b3ab2e65c05$export$2e21f9dba1630651,
    faLaptop: $d8206b3ab2e65c05$export$c2dee3bd177275a2,
    faFileCsv: $d8206b3ab2e65c05$export$82cea4f586f6ec9,
    faMenorah: $d8206b3ab2e65c05$export$232452c59d77c56e,
    faTruckPlane: $d8206b3ab2e65c05$export$e1d5ceed99060d76,
    faRecordVinyl: $d8206b3ab2e65c05$export$fe2d5012d9982673,
    faFaceGrinStars: $d8206b3ab2e65c05$export$1d1fbac384a76a12,
    faGrinStars: $d8206b3ab2e65c05$export$64347a5c8c402ef4,
    faBong: $d8206b3ab2e65c05$export$e74974fac77c468e,
    faSpaghettiMonsterFlying: $d8206b3ab2e65c05$export$3c8d5c62d76c33b8,
    faPastafarianism: $d8206b3ab2e65c05$export$733efdaec97447be,
    faArrowDownUpAcrossLine: $d8206b3ab2e65c05$export$9fe0c42ede2dd003,
    faSpoon: $d8206b3ab2e65c05$export$faf854a434ce6d0c,
    faUtensilSpoon: $d8206b3ab2e65c05$export$fb7af5d245fb9053,
    faJarWheat: $d8206b3ab2e65c05$export$8b503c1d76716ddd,
    faEnvelopesBulk: $d8206b3ab2e65c05$export$dc2cce064a1e70bb,
    faMailBulk: $d8206b3ab2e65c05$export$dd24f40c5337e2e1,
    faFileCircleExclamation: $d8206b3ab2e65c05$export$61fa9809253098e5,
    faCircleH: $d8206b3ab2e65c05$export$bf5674308c61894f,
    faHospitalSymbol: $d8206b3ab2e65c05$export$c8a3c78d99c23fed,
    faPager: $d8206b3ab2e65c05$export$e1611f373a10a98c,
    faAddressBook: $d8206b3ab2e65c05$export$853fd1561789e3bb,
    faContactBook: $d8206b3ab2e65c05$export$594b5a5d4d2e156b,
    faStrikethrough: $d8206b3ab2e65c05$export$eff51ea25b4de135,
    faK: $d8206b3ab2e65c05$export$3f85413cb67e7f67,
    faLandmarkFlag: $d8206b3ab2e65c05$export$f4d472cf47be4096,
    faPencil: $d8206b3ab2e65c05$export$c72de95adaca18b8,
    faPencilAlt: $d8206b3ab2e65c05$export$8210adc172262df,
    faBackward: $d8206b3ab2e65c05$export$ae65f96ea7a4078d,
    faCaretRight: $d8206b3ab2e65c05$export$f1011352b01c1c0,
    faComments: $d8206b3ab2e65c05$export$932912e74adb8939,
    faPaste: $d8206b3ab2e65c05$export$6f95f90dd1f6d86b,
    faFileClipboard: $d8206b3ab2e65c05$export$ca3229c47de163fa,
    faCodePullRequest: $d8206b3ab2e65c05$export$37576dfab037d8bf,
    faClipboardList: $d8206b3ab2e65c05$export$2c5a9d8548d8810e,
    faTruckRampBox: $d8206b3ab2e65c05$export$37396c36c76937bc,
    faTruckLoading: $d8206b3ab2e65c05$export$f00c152db7d44638,
    faUserCheck: $d8206b3ab2e65c05$export$76de2a120043c9f8,
    faVialVirus: $d8206b3ab2e65c05$export$a56b2b0a1073620c,
    faSheetPlastic: $d8206b3ab2e65c05$export$57f2bcd070bff91a,
    faBlog: $d8206b3ab2e65c05$export$890d5e011054935a,
    faUserNinja: $d8206b3ab2e65c05$export$a9174995732e03c5,
    faPersonArrowUpFromLine: $d8206b3ab2e65c05$export$5709329dd2b70bdc,
    faScrollTorah: $d8206b3ab2e65c05$export$4e3fe5b42a6cd494,
    faTorah: $d8206b3ab2e65c05$export$54d07baabd8c2acb,
    faBroomBall: $d8206b3ab2e65c05$export$3e1327487ce53231,
    faQuidditch: $d8206b3ab2e65c05$export$c00c446e6db1605f,
    faQuidditchBroomBall: $d8206b3ab2e65c05$export$791bfe29b97b4d42,
    faToggleOff: $d8206b3ab2e65c05$export$d20aaceb882ca545,
    faBoxArchive: $d8206b3ab2e65c05$export$2a0fcb66c3d79d00,
    faArchive: $d8206b3ab2e65c05$export$26b3e1c454273f34,
    faPersonDrowning: $d8206b3ab2e65c05$export$bac321083217fd4,
    faArrowDown91: $d8206b3ab2e65c05$export$6cc91ce23eb3fae1,
    faSortNumericDesc: $d8206b3ab2e65c05$export$99f058110e2c82a8,
    faSortNumericDownAlt: $d8206b3ab2e65c05$export$857385fda7a5a98e,
    faFaceGrinTongueSquint: $d8206b3ab2e65c05$export$8eee2c17ff89e724,
    faGrinTongueSquint: $d8206b3ab2e65c05$export$4edf34c3def09a31,
    faSprayCan: $d8206b3ab2e65c05$export$4952c502f544cf85,
    faTruckMonster: $d8206b3ab2e65c05$export$24b8a0147653649a,
    faW: $d8206b3ab2e65c05$export$c7f24bdea332f90a,
    faEarthAfrica: $d8206b3ab2e65c05$export$11afa141d42099d0,
    faGlobeAfrica: $d8206b3ab2e65c05$export$64af36f3b403a57c,
    faRainbow: $d8206b3ab2e65c05$export$92ab27739d3a91b2,
    faCircleNotch: $d8206b3ab2e65c05$export$9429fd8df55155d,
    faTabletScreenButton: $d8206b3ab2e65c05$export$df1e253fc358ade4,
    faTabletAlt: $d8206b3ab2e65c05$export$db0cac088255eacc,
    faPaw: $d8206b3ab2e65c05$export$7bc6e4d977673e69,
    faCloud: $d8206b3ab2e65c05$export$8bb3c4d5c2f50243,
    faTrowelBricks: $d8206b3ab2e65c05$export$b6c20c10ddbd9898,
    faFaceFlushed: $d8206b3ab2e65c05$export$ba5dc4287853ecbd,
    faFlushed: $d8206b3ab2e65c05$export$dfd2bd012685aeac,
    faHospitalUser: $d8206b3ab2e65c05$export$684703c93d630cc5,
    faTentArrowLeftRight: $d8206b3ab2e65c05$export$fa95eb7418c0e2b8,
    faGavel: $d8206b3ab2e65c05$export$c36fb40057e2c3aa,
    faLegal: $d8206b3ab2e65c05$export$59d593c2dacb3781,
    faBinoculars: $d8206b3ab2e65c05$export$8a910017964bb8c2,
    faMicrophoneSlash: $d8206b3ab2e65c05$export$843f63d64e6f7951,
    faBoxTissue: $d8206b3ab2e65c05$export$f2adc06617bc0c7,
    faMotorcycle: $d8206b3ab2e65c05$export$f26017bdca99338d,
    faBellConcierge: $d8206b3ab2e65c05$export$e433538b78718fb3,
    faConciergeBell: $d8206b3ab2e65c05$export$ad92ffbbfbc0fcf3,
    faPenRuler: $d8206b3ab2e65c05$export$85ba06027671d290,
    faPencilRuler: $d8206b3ab2e65c05$export$e3a7a1affea005f5,
    faPeopleArrows: $d8206b3ab2e65c05$export$804bfc5c390e1a2a,
    faPeopleArrowsLeftRight: $d8206b3ab2e65c05$export$da01f044c59e3598,
    faMarsAndVenusBurst: $d8206b3ab2e65c05$export$1dc6221efb867885,
    faSquareCaretRight: $d8206b3ab2e65c05$export$5b1d41cdd118ea6d,
    faCaretSquareRight: $d8206b3ab2e65c05$export$ae86c9de7e0f62fa,
    faScissors: $d8206b3ab2e65c05$export$b2a906a5928c6404,
    faCut: $d8206b3ab2e65c05$export$66847f2a71b260e7,
    faSunPlantWilt: $d8206b3ab2e65c05$export$8db7f2f70484e17e,
    faToiletsPortable: $d8206b3ab2e65c05$export$c00f55f36d386cb7,
    faHockeyPuck: $d8206b3ab2e65c05$export$a274b02dc75663dc,
    faTable: $d8206b3ab2e65c05$export$36583f5d3d5a971f,
    faMagnifyingGlassArrowRight: $d8206b3ab2e65c05$export$382d3376c7fc7fc5,
    faTachographDigital: $d8206b3ab2e65c05$export$73f2bf302381c86a,
    faDigitalTachograph: $d8206b3ab2e65c05$export$b3bf1994f0fefe98,
    faUsersSlash: $d8206b3ab2e65c05$export$b71a093b86e3da1f,
    faClover: $d8206b3ab2e65c05$export$57813571c0e10a0a,
    faReply: $d8206b3ab2e65c05$export$bb06d4a7bb6736fe,
    faMailReply: $d8206b3ab2e65c05$export$12e45ff70d2646a1,
    faStarAndCrescent: $d8206b3ab2e65c05$export$cafa834c96ebcb1a,
    faHouseFire: $d8206b3ab2e65c05$export$947ee033a6942aa8,
    faSquareMinus: $d8206b3ab2e65c05$export$814c9edba7b84aa4,
    faMinusSquare: $d8206b3ab2e65c05$export$ffe9387966b3e681,
    faHelicopter: $d8206b3ab2e65c05$export$612d3e1afaf45fa5,
    faCompass: $d8206b3ab2e65c05$export$b4d344633433e50e,
    faSquareCaretDown: $d8206b3ab2e65c05$export$a1ab39cd66c4e50e,
    faCaretSquareDown: $d8206b3ab2e65c05$export$61aea18df1c84401,
    faFileCircleQuestion: $d8206b3ab2e65c05$export$877d3692c1f94bda,
    faLaptopCode: $d8206b3ab2e65c05$export$94100f4c6ee29932,
    faSwatchbook: $d8206b3ab2e65c05$export$c74a20c81b957b6a,
    faPrescriptionBottle: $d8206b3ab2e65c05$export$214f9ce665590486,
    faBars: $d8206b3ab2e65c05$export$36e9cf7887265da2,
    faNavicon: $d8206b3ab2e65c05$export$409fa7bcaa0e4cd9,
    faPeopleGroup: $d8206b3ab2e65c05$export$be015e72863c3635,
    faHourglassEnd: $d8206b3ab2e65c05$export$52757ecc5b1e25b9,
    faHourglass3: $d8206b3ab2e65c05$export$1ec43c81fef8ffd6,
    faHeartCrack: $d8206b3ab2e65c05$export$8e521ef33062b00e,
    faHeartBroken: $d8206b3ab2e65c05$export$4a565395cb65b282,
    faSquareUpRight: $d8206b3ab2e65c05$export$a47a20ab7bde8c67,
    faExternalLinkSquareAlt: $d8206b3ab2e65c05$export$e4cdf2977151ee26,
    faFaceKissBeam: $d8206b3ab2e65c05$export$eca99665af566fe1,
    faKissBeam: $d8206b3ab2e65c05$export$d6ff8a73c0812e63,
    faFilm: $d8206b3ab2e65c05$export$c03de0cc616e77bb,
    faRulerHorizontal: $d8206b3ab2e65c05$export$46c6347bff3e04a,
    faPeopleRobbery: $d8206b3ab2e65c05$export$75ce8513e1f1c5c4,
    faLightbulb: $d8206b3ab2e65c05$export$1e80f89fe84a215b,
    faCaretLeft: $d8206b3ab2e65c05$export$85a918a11b7643c2,
    faCircleExclamation: $d8206b3ab2e65c05$export$59573943f9eebbd5,
    faExclamationCircle: $d8206b3ab2e65c05$export$220e07e14c5d7e5d,
    faSchoolCircleXmark: $d8206b3ab2e65c05$export$5e17b20e0f6b132b,
    faArrowRightFromBracket: $d8206b3ab2e65c05$export$ca14f1b4d6afb7aa,
    faSignOut: $d8206b3ab2e65c05$export$33e2b60243ca6d92,
    faCircleChevronDown: $d8206b3ab2e65c05$export$aca07924996218d8,
    faChevronCircleDown: $d8206b3ab2e65c05$export$9926124d75b2ecab,
    faUnlockKeyhole: $d8206b3ab2e65c05$export$c98fdd5082b333ec,
    faUnlockAlt: $d8206b3ab2e65c05$export$b19f508797f3d9c3,
    faCloudShowersHeavy: $d8206b3ab2e65c05$export$af51c741ee9cc090,
    faHeadphonesSimple: $d8206b3ab2e65c05$export$ca47801915e5a685,
    faHeadphonesAlt: $d8206b3ab2e65c05$export$6f0433fa527dd5be,
    faSitemap: $d8206b3ab2e65c05$export$b2ce5e79d0eccaf8,
    faCircleDollarToSlot: $d8206b3ab2e65c05$export$5f92ac3e804644e3,
    faDonate: $d8206b3ab2e65c05$export$40050ae52860cde7,
    faMemory: $d8206b3ab2e65c05$export$5f9bd9f6df021f93,
    faRoadSpikes: $d8206b3ab2e65c05$export$b372a24046126ad8,
    faFireBurner: $d8206b3ab2e65c05$export$e4e44f7b1886fef,
    faFlag: $d8206b3ab2e65c05$export$6591b1ea509be9da,
    faHanukiah: $d8206b3ab2e65c05$export$3dcd4ca3f7108a82,
    faFeather: $d8206b3ab2e65c05$export$5e19aea195b31816,
    faVolumeLow: $d8206b3ab2e65c05$export$2b1464e7557b18eb,
    faVolumeDown: $d8206b3ab2e65c05$export$69fdf57632b6cc29,
    faCommentSlash: $d8206b3ab2e65c05$export$3786a0422a3f33ea,
    faCloudSunRain: $d8206b3ab2e65c05$export$dd9dc9b4227dbe94,
    faCompress: $d8206b3ab2e65c05$export$83632d1150d3541f,
    faWheatAwn: $d8206b3ab2e65c05$export$79d4dac715a51fdf,
    faWheatAlt: $d8206b3ab2e65c05$export$deaf03a29aa05e3a,
    faAnkh: $d8206b3ab2e65c05$export$8736909014b15ca9,
    faHandsHoldingChild: $d8206b3ab2e65c05$export$bfb254bf3c0bc50b,
    faAsterisk: $d8206b3ab2e65c05$export$19eff32c0fd4f99f,
    faSquareCheck: $d8206b3ab2e65c05$export$5bb6a0c94ad2f4bb,
    faCheckSquare: $d8206b3ab2e65c05$export$f0c8040f596df7fe,
    faPesetaSign: $d8206b3ab2e65c05$export$a6f8654bcd49a39f,
    faHeading: $d8206b3ab2e65c05$export$4805b8d175aeb9fb,
    faHeader: $d8206b3ab2e65c05$export$579f9604bb10a61a,
    faGhost: $d8206b3ab2e65c05$export$1a989eb1919c64c1,
    faList: $d8206b3ab2e65c05$export$6cfc59842fedbc16,
    faListSquares: $d8206b3ab2e65c05$export$e3f160fc949c2b9d,
    faSquarePhoneFlip: $d8206b3ab2e65c05$export$b627121801cad756,
    faPhoneSquareAlt: $d8206b3ab2e65c05$export$a41e77f0de98bba7,
    faCartPlus: $d8206b3ab2e65c05$export$6675e2bf21fdb87e,
    faGamepad: $d8206b3ab2e65c05$export$6a66b1b639455bef,
    faCircleDot: $d8206b3ab2e65c05$export$aa13d9234890e8d3,
    faDotCircle: $d8206b3ab2e65c05$export$92bc269cb244d66a,
    faFaceDizzy: $d8206b3ab2e65c05$export$635e4d8cc8428961,
    faDizzy: $d8206b3ab2e65c05$export$89a2b10dabc487e8,
    faEgg: $d8206b3ab2e65c05$export$1199a8ce85311ab5,
    faHouseMedicalCircleXmark: $d8206b3ab2e65c05$export$bf221f0e8296233e,
    faCampground: $d8206b3ab2e65c05$export$295287303c0e9c7c,
    faFolderPlus: $d8206b3ab2e65c05$export$e18e05ffa2045d3b,
    faFutbol: $d8206b3ab2e65c05$export$65a345b33858a655,
    faFutbolBall: $d8206b3ab2e65c05$export$51a344ca0a215620,
    faSoccerBall: $d8206b3ab2e65c05$export$f4a29712c724ba2d,
    faPaintbrush: $d8206b3ab2e65c05$export$7c8b56f3f296a814,
    faPaintBrush: $d8206b3ab2e65c05$export$594db3339e212bc9,
    faLock: $d8206b3ab2e65c05$export$7aa08ad5d562578a,
    faGasPump: $d8206b3ab2e65c05$export$84666c793cb2a347,
    faHotTubPerson: $d8206b3ab2e65c05$export$6e6bd68568c17bbf,
    faHotTub: $d8206b3ab2e65c05$export$4842af92b516c40b,
    faMapLocation: $d8206b3ab2e65c05$export$9a8788ec0e4a9a0b,
    faMapMarked: $d8206b3ab2e65c05$export$df04458e7e32352c,
    faHouseFloodWater: $d8206b3ab2e65c05$export$70fd6006b4e54a5,
    faTree: $d8206b3ab2e65c05$export$1744430f718caf6b,
    faBridgeLock: $d8206b3ab2e65c05$export$cffe7d85a82d8116,
    faSackDollar: $d8206b3ab2e65c05$export$15854c4475080853,
    faPenToSquare: $d8206b3ab2e65c05$export$ba236543926e3569,
    faEdit: $d8206b3ab2e65c05$export$7be713e57d023733,
    faCarSide: $d8206b3ab2e65c05$export$6f7218565b1b8d0e,
    faShareNodes: $d8206b3ab2e65c05$export$cdaf45d4e50ac035,
    faShareAlt: $d8206b3ab2e65c05$export$f8e8bb0b3aa8c658,
    faHeartCircleMinus: $d8206b3ab2e65c05$export$24c21c3ca00f3625,
    faHourglassHalf: $d8206b3ab2e65c05$export$703272eebf5e3eea,
    faHourglass2: $d8206b3ab2e65c05$export$f1052bbf6bf361c0,
    faMicroscope: $d8206b3ab2e65c05$export$6a99139787bf9967,
    faSink: $d8206b3ab2e65c05$export$2a9dda2096ce792e,
    faBagShopping: $d8206b3ab2e65c05$export$b0137b4600e9ab12,
    faShoppingBag: $d8206b3ab2e65c05$export$5745f8adbc11eb01,
    faArrowDownZA: $d8206b3ab2e65c05$export$cf79d63ad07d943a,
    faSortAlphaDesc: $d8206b3ab2e65c05$export$7caf99612a55d427,
    faSortAlphaDownAlt: $d8206b3ab2e65c05$export$e12d23d82d5c8a89,
    faMitten: $d8206b3ab2e65c05$export$5030322c5fc886d7,
    faPersonRays: $d8206b3ab2e65c05$export$49577f913f0fe4d2,
    faUsers: $d8206b3ab2e65c05$export$e5a8f011aef571ac,
    faEyeSlash: $d8206b3ab2e65c05$export$ed3f2918429d029a,
    faFlaskVial: $d8206b3ab2e65c05$export$a25a266ce0c95019,
    faHand: $d8206b3ab2e65c05$export$f69db0b876f7d753,
    faHandPaper: $d8206b3ab2e65c05$export$6e6216c8b50471bb,
    faOm: $d8206b3ab2e65c05$export$8de8eb94230028a5,
    faWorm: $d8206b3ab2e65c05$export$2571e33fa6c25993,
    faHouseCircleXmark: $d8206b3ab2e65c05$export$423555e8708eb4c7,
    faPlug: $d8206b3ab2e65c05$export$cae5752c3e3b6545,
    faChevronUp: $d8206b3ab2e65c05$export$877e5ae47a854215,
    faHandSpock: $d8206b3ab2e65c05$export$2262d6b626de1120,
    faStopwatch: $d8206b3ab2e65c05$export$b85a7300fc7960b6,
    faFaceKiss: $d8206b3ab2e65c05$export$5a54c83033a0a56a,
    faKiss: $d8206b3ab2e65c05$export$c762a77aabf64fd0,
    faBridgeCircleXmark: $d8206b3ab2e65c05$export$834071278537f121,
    faFaceGrinTongue: $d8206b3ab2e65c05$export$95a7394c24f57943,
    faGrinTongue: $d8206b3ab2e65c05$export$ef222816a43a4b3a,
    faChessBishop: $d8206b3ab2e65c05$export$a831eedd2f59c62f,
    faFaceGrinWink: $d8206b3ab2e65c05$export$1dd161850c5bc64e,
    faGrinWink: $d8206b3ab2e65c05$export$2397fcd34eb12177,
    faEarDeaf: $d8206b3ab2e65c05$export$c9c5b76ec992eab4,
    faDeaf: $d8206b3ab2e65c05$export$4b666adf83f0de01,
    faDeafness: $d8206b3ab2e65c05$export$85c6a9ab2fa2631e,
    faHardOfHearing: $d8206b3ab2e65c05$export$ebecf90a5676e17a,
    faRoadCircleCheck: $d8206b3ab2e65c05$export$3f22db9ae9b6be1c,
    faDiceFive: $d8206b3ab2e65c05$export$d9769fb795c2db82,
    faSquareRss: $d8206b3ab2e65c05$export$97d1903b1e012ff7,
    faRssSquare: $d8206b3ab2e65c05$export$89c9b1cca2c11484,
    faLandMineOn: $d8206b3ab2e65c05$export$567a897fc092e403,
    faICursor: $d8206b3ab2e65c05$export$7fddf76ec23943d8,
    faStamp: $d8206b3ab2e65c05$export$722e92d2d93ffc68,
    faStairs: $d8206b3ab2e65c05$export$68b3af7444c89df7,
    faI: $d8206b3ab2e65c05$export$aee03ca0815b7c38,
    faHryvniaSign: $d8206b3ab2e65c05$export$22a9491150c64fef,
    faHryvnia: $d8206b3ab2e65c05$export$33d5f94bd6f75f59,
    faPills: $d8206b3ab2e65c05$export$6380e2ed6e69d350,
    faFaceGrinWide: $d8206b3ab2e65c05$export$bdbabf493c478cde,
    faGrinAlt: $d8206b3ab2e65c05$export$b4abebfe416d36ba,
    faTooth: $d8206b3ab2e65c05$export$3a1fa2d16f90d635,
    faV: $d8206b3ab2e65c05$export$6fb446f784f6b9b3,
    faBangladeshiTakaSign: $d8206b3ab2e65c05$export$469d376940e10d37,
    faBicycle: $d8206b3ab2e65c05$export$36cb1885ad7a570f,
    faStaffSnake: $d8206b3ab2e65c05$export$76d998742bc186eb,
    faRodAsclepius: $d8206b3ab2e65c05$export$f2c3e92ee37a8d89,
    faRodSnake: $d8206b3ab2e65c05$export$5d61dcb598296af0,
    faStaffAesculapius: $d8206b3ab2e65c05$export$97c8a2cdba3b7700,
    faHeadSideCoughSlash: $d8206b3ab2e65c05$export$b293ee8fb8e6b0c4,
    faTruckMedical: $d8206b3ab2e65c05$export$fb6bd43f079f72e2,
    faAmbulance: $d8206b3ab2e65c05$export$f5c7042778b51765,
    faWheatAwnCircleExclamation: $d8206b3ab2e65c05$export$e23367e54f665590,
    faSnowman: $d8206b3ab2e65c05$export$b23df6bafb174693,
    faMortarPestle: $d8206b3ab2e65c05$export$55ceb5d0c144580a,
    faRoadBarrier: $d8206b3ab2e65c05$export$f3e925217e396f44,
    faSchool: $d8206b3ab2e65c05$export$51e9b8434982947d,
    faIgloo: $d8206b3ab2e65c05$export$4a284575edd6f1af,
    faJoint: $d8206b3ab2e65c05$export$e5a289fb22ffb8cb,
    faAngleRight: $d8206b3ab2e65c05$export$6bce1afb61f2eb66,
    faHorse: $d8206b3ab2e65c05$export$5b05f097fa38352a,
    faQ: $d8206b3ab2e65c05$export$5a2b164552deda9f,
    faG: $d8206b3ab2e65c05$export$9f5c2b0db8eedeac,
    faNotesMedical: $d8206b3ab2e65c05$export$b2d79133c81d6697,
    faTemperatureHalf: $d8206b3ab2e65c05$export$a3f1d7f13c202adc,
    faTemperature2: $d8206b3ab2e65c05$export$8176e649df45b32c,
    faThermometer2: $d8206b3ab2e65c05$export$4dd764ac8d512682,
    faThermometerHalf: $d8206b3ab2e65c05$export$2090f040324b4449,
    faDongSign: $d8206b3ab2e65c05$export$18659308f17918a5,
    faCapsules: $d8206b3ab2e65c05$export$ba6fd4a436804a48,
    faPooStorm: $d8206b3ab2e65c05$export$48a38da471b097a2,
    faPooBolt: $d8206b3ab2e65c05$export$9a24e77f74d9cbd9,
    faFaceFrownOpen: $d8206b3ab2e65c05$export$c8a28356e07b9ccb,
    faFrownOpen: $d8206b3ab2e65c05$export$c4775e66bed5d96,
    faHandPointUp: $d8206b3ab2e65c05$export$cdc9f5e7e94e76da,
    faMoneyBill: $d8206b3ab2e65c05$export$608138a7337b5d1a,
    faBookmark: $d8206b3ab2e65c05$export$4ed9da5c3cca0ef1,
    faAlignJustify: $d8206b3ab2e65c05$export$97c42b56d462df72,
    faUmbrellaBeach: $d8206b3ab2e65c05$export$20932e4d438e4e4c,
    faHelmetUn: $d8206b3ab2e65c05$export$5e975cb293c48461,
    faBullseye: $d8206b3ab2e65c05$export$554720e3bf74fe90,
    faBacon: $d8206b3ab2e65c05$export$ab07061fe21a3a8e,
    faHandPointDown: $d8206b3ab2e65c05$export$f6dcbf0a940428f4,
    faArrowUpFromBracket: $d8206b3ab2e65c05$export$c2af1be14cd87640,
    faFolder: $d8206b3ab2e65c05$export$72b780186370e953,
    faFolderBlank: $d8206b3ab2e65c05$export$9ef114244d26da0,
    faFileWaveform: $d8206b3ab2e65c05$export$5e0c19cf315ac1bf,
    faFileMedicalAlt: $d8206b3ab2e65c05$export$ef02a0f5b39aa61f,
    faRadiation: $d8206b3ab2e65c05$export$4c4e509518093d6d,
    faChartSimple: $d8206b3ab2e65c05$export$8760a1de19ea40b9,
    faMarsStroke: $d8206b3ab2e65c05$export$aa05fce255a5d269,
    faVial: $d8206b3ab2e65c05$export$aa014b06d2d70598,
    faGauge: $d8206b3ab2e65c05$export$dbfb0a9f89ad94a4,
    faDashboard: $d8206b3ab2e65c05$export$b7ce24136743d0f1,
    faGaugeMed: $d8206b3ab2e65c05$export$f948a9dd257979f3,
    faTachometerAltAverage: $d8206b3ab2e65c05$export$6f22c345e5a92d1a,
    faWandMagicSparkles: $d8206b3ab2e65c05$export$5325fc72e75360b4,
    faMagicWandSparkles: $d8206b3ab2e65c05$export$c93286938249f0da,
    faE: $d8206b3ab2e65c05$export$86923e6fe1b42f5e,
    faPenClip: $d8206b3ab2e65c05$export$eff4bdcafd3b8d1c,
    faPenAlt: $d8206b3ab2e65c05$export$a3d3e92e430d3beb,
    faBridgeCircleExclamation: $d8206b3ab2e65c05$export$4f25939fdf728c27,
    faUser: $d8206b3ab2e65c05$export$f5699fa0844e0188,
    faSchoolCircleCheck: $d8206b3ab2e65c05$export$c8c95c2f9937bf6a,
    faDumpster: $d8206b3ab2e65c05$export$3b934e22d1851a3b,
    faVanShuttle: $d8206b3ab2e65c05$export$ecbd233b96906ee1,
    faShuttleVan: $d8206b3ab2e65c05$export$9d63d851db698c09,
    faBuildingUser: $d8206b3ab2e65c05$export$d65aef1ed7db1dae,
    faSquareCaretLeft: $d8206b3ab2e65c05$export$2c5163541229363,
    faCaretSquareLeft: $d8206b3ab2e65c05$export$d0c8ba444f1f9581,
    faHighlighter: $d8206b3ab2e65c05$export$73801ed54b42fabe,
    faKey: $d8206b3ab2e65c05$export$fa6ecc35e7315db,
    faBullhorn: $d8206b3ab2e65c05$export$dacae2b4ec565333,
    faGlobe: $d8206b3ab2e65c05$export$b1b1cdce4a19c682,
    faSynagogue: $d8206b3ab2e65c05$export$20d991385719b5b4,
    faPersonHalfDress: $d8206b3ab2e65c05$export$f3d75c19191f1688,
    faRoadBridge: $d8206b3ab2e65c05$export$4d6835e7175dec24,
    faLocationArrow: $d8206b3ab2e65c05$export$4ac9c4c370f7b157,
    faC: $d8206b3ab2e65c05$export$a2c1c457834fc6d8,
    faTabletButton: $d8206b3ab2e65c05$export$2d33c367b2b091ac,
    faBuildingLock: $d8206b3ab2e65c05$export$6f08294ba8a2459c,
    faPizzaSlice: $d8206b3ab2e65c05$export$c9f93c4667edc585,
    faMoneyBillWave: $d8206b3ab2e65c05$export$53e23123cc9a6796,
    faChartArea: $d8206b3ab2e65c05$export$2acab8312b7a999b,
    faAreaChart: $d8206b3ab2e65c05$export$fc2e595f0e0612cb,
    faHouseFlag: $d8206b3ab2e65c05$export$9a3d31c75a465b9a,
    faPersonCircleMinus: $d8206b3ab2e65c05$export$d7ccc6651f90f7cc,
    faBan: $d8206b3ab2e65c05$export$76f704d256def3c7,
    faCancel: $d8206b3ab2e65c05$export$6d25ef56192f6d69,
    faCameraRotate: $d8206b3ab2e65c05$export$e0ce7d1aba7105e7,
    faSprayCanSparkles: $d8206b3ab2e65c05$export$43832c90c10a7a31,
    faAirFreshener: $d8206b3ab2e65c05$export$a5e63e89b5ccee83,
    faStar: $d8206b3ab2e65c05$export$a3b0eb2cd7942125,
    faRepeat: $d8206b3ab2e65c05$export$cb8434288c91ae83,
    faCross: $d8206b3ab2e65c05$export$9d0a89fcd084abb,
    faBox: $d8206b3ab2e65c05$export$6e7cf270cda52323,
    faVenusMars: $d8206b3ab2e65c05$export$63f2d9e5f4689aa8,
    faArrowPointer: $d8206b3ab2e65c05$export$e4f903bc63db445,
    faMousePointer: $d8206b3ab2e65c05$export$2e19a69cc26b147,
    faMaximize: $d8206b3ab2e65c05$export$8d2b1b230601e804,
    faExpandArrowsAlt: $d8206b3ab2e65c05$export$6219dcd88b5fa6c2,
    faChargingStation: $d8206b3ab2e65c05$export$bab2cd86f8c65657,
    faShapes: $d8206b3ab2e65c05$export$b17d50542d1fc340,
    faTriangleCircleSquare: $d8206b3ab2e65c05$export$34261e5aea24fc1d,
    faShuffle: $d8206b3ab2e65c05$export$ee94b652453ad208,
    faRandom: $d8206b3ab2e65c05$export$8357bf8cc666d5f0,
    faPersonRunning: $d8206b3ab2e65c05$export$f48814ae62850c74,
    faRunning: $d8206b3ab2e65c05$export$5dfd1cb43dc9eadb,
    faMobileRetro: $d8206b3ab2e65c05$export$7955f08360418647,
    faGripLinesVertical: $d8206b3ab2e65c05$export$523960de087f5198,
    faSpider: $d8206b3ab2e65c05$export$6daa96b1986e2ef0,
    faHandsBound: $d8206b3ab2e65c05$export$740142a89118fbc0,
    faFileInvoiceDollar: $d8206b3ab2e65c05$export$a3dced32d48cb1ea,
    faPlaneCircleExclamation: $d8206b3ab2e65c05$export$f201ba865ea1b8dc,
    faXRay: $d8206b3ab2e65c05$export$8cf137aceaaf4de0,
    faSpellCheck: $d8206b3ab2e65c05$export$761e747b06ed2e1f,
    faSlash: $d8206b3ab2e65c05$export$f54d004dd5f1cb5e,
    faComputerMouse: $d8206b3ab2e65c05$export$72cf138e5ddda6eb,
    faMouse: $d8206b3ab2e65c05$export$198b96b894c66074,
    faArrowRightToBracket: $d8206b3ab2e65c05$export$a02c5909359525be,
    faSignIn: $d8206b3ab2e65c05$export$a55eff0ca4f9c3df,
    faShopSlash: $d8206b3ab2e65c05$export$b3d636689da4a3e5,
    faStoreAltSlash: $d8206b3ab2e65c05$export$b932a586f6ff48b4,
    faServer: $d8206b3ab2e65c05$export$1bf820d499b6202e,
    faVirusCovidSlash: $d8206b3ab2e65c05$export$61c2a6b698f55df6,
    faShopLock: $d8206b3ab2e65c05$export$452410c103c2403b,
    faHourglassStart: $d8206b3ab2e65c05$export$f0c28584caa8f4b,
    faHourglass1: $d8206b3ab2e65c05$export$87929336ab5c59cd,
    faBlenderPhone: $d8206b3ab2e65c05$export$f35a116a762ef8fc,
    faBuildingWheat: $d8206b3ab2e65c05$export$6c0cfe6d58faf860,
    faPersonBreastfeeding: $d8206b3ab2e65c05$export$9b94ed8d16d281f9,
    faRightToBracket: $d8206b3ab2e65c05$export$a5fd2acfcb5247c6,
    faSignInAlt: $d8206b3ab2e65c05$export$e6709746115bd2ea,
    faVenus: $d8206b3ab2e65c05$export$f89d028573ffc0a6,
    faPassport: $d8206b3ab2e65c05$export$2c31ca0d9bee400f,
    faHeartPulse: $d8206b3ab2e65c05$export$a6d8e50dcd4b4294,
    faHeartbeat: $d8206b3ab2e65c05$export$ca880e19206e80aa,
    faPeopleCarryBox: $d8206b3ab2e65c05$export$7754cc6d5559ff38,
    faPeopleCarry: $d8206b3ab2e65c05$export$35fbd4ff1265acd5,
    faTemperatureHigh: $d8206b3ab2e65c05$export$15d012277c3ecf9a,
    faMicrochip: $d8206b3ab2e65c05$export$4a7bb4be15f35178,
    faCrown: $d8206b3ab2e65c05$export$dc1083dcd1d7b9d6,
    faWeightHanging: $d8206b3ab2e65c05$export$43d1fa6671908715,
    faXmarksLines: $d8206b3ab2e65c05$export$f4595f012786d346,
    faFilePrescription: $d8206b3ab2e65c05$export$a20cb90865b6beb8,
    faWeightScale: $d8206b3ab2e65c05$export$e521c542d18b85c3,
    faWeight: $d8206b3ab2e65c05$export$cf3bafa68a60bae4,
    faUserGroup: $d8206b3ab2e65c05$export$3d626cfc365a7e36,
    faUserFriends: $d8206b3ab2e65c05$export$46073bec205635d9,
    faArrowUpAZ: $d8206b3ab2e65c05$export$fb00fdd8857804c7,
    faSortAlphaUp: $d8206b3ab2e65c05$export$3c4115b156be730d,
    faChessKnight: $d8206b3ab2e65c05$export$861b1f13085cf122,
    faFaceLaughSquint: $d8206b3ab2e65c05$export$67ca89c1ca38d559,
    faLaughSquint: $d8206b3ab2e65c05$export$b206e700cf7084e1,
    faWheelchair: $d8206b3ab2e65c05$export$76a9413fbe130a53,
    faCircleArrowUp: $d8206b3ab2e65c05$export$a29c8ea43e92771d,
    faArrowCircleUp: $d8206b3ab2e65c05$export$a2f6f3baa50af0b1,
    faToggleOn: $d8206b3ab2e65c05$export$5cffc34afa81e517,
    faPersonWalking: $d8206b3ab2e65c05$export$6af1cc5998ca52bc,
    faWalking: $d8206b3ab2e65c05$export$4886811b7174ec35,
    faL: $d8206b3ab2e65c05$export$be32b10ce70a09df,
    faFire: $d8206b3ab2e65c05$export$7b24b34ef6cc130c,
    faBedPulse: $d8206b3ab2e65c05$export$580ae0d0bbd809fb,
    faProcedures: $d8206b3ab2e65c05$export$5f9e1870e1866dde,
    faShuttleSpace: $d8206b3ab2e65c05$export$76d92e7f30d064c5,
    faSpaceShuttle: $d8206b3ab2e65c05$export$4d1c12ba2b4ca565,
    faFaceLaugh: $d8206b3ab2e65c05$export$2f203616c892d415,
    faLaugh: $d8206b3ab2e65c05$export$6c74e314e801a4fe,
    faFolderOpen: $d8206b3ab2e65c05$export$ff7e93418af88b78,
    faHeartCirclePlus: $d8206b3ab2e65c05$export$2a155a6e20f64134,
    faCodeFork: $d8206b3ab2e65c05$export$f54081bdbf6d4eb5,
    faCity: $d8206b3ab2e65c05$export$a9947c2888b3c8fd,
    faMicrophoneLines: $d8206b3ab2e65c05$export$417391ae30b5922e,
    faMicrophoneAlt: $d8206b3ab2e65c05$export$f08ef94fea14f5ac,
    faPepperHot: $d8206b3ab2e65c05$export$4894bf28f771e1f3,
    faUnlock: $d8206b3ab2e65c05$export$db1382cd406cc506,
    faColonSign: $d8206b3ab2e65c05$export$dec10d4c2c113312,
    faHeadset: $d8206b3ab2e65c05$export$23b086400a31acfe,
    faStoreSlash: $d8206b3ab2e65c05$export$4ab2f33219630bad,
    faRoadCircleXmark: $d8206b3ab2e65c05$export$2ffc88a4d31e8ffc,
    faUserMinus: $d8206b3ab2e65c05$export$d6e17c0df8ed1bf7,
    faMarsStrokeUp: $d8206b3ab2e65c05$export$efc6d53e0dedceee,
    faMarsStrokeV: $d8206b3ab2e65c05$export$ed7aa1c25104f333,
    faChampagneGlasses: $d8206b3ab2e65c05$export$7df1926e9eef8cc3,
    faGlassCheers: $d8206b3ab2e65c05$export$20007d7d74cb98fe,
    faClipboard: $d8206b3ab2e65c05$export$97d84347d71ba297,
    faHouseCircleExclamation: $d8206b3ab2e65c05$export$8403e4b31e8aa805,
    faFileArrowUp: $d8206b3ab2e65c05$export$929df388c07f293d,
    faFileUpload: $d8206b3ab2e65c05$export$dd55ded1264643d2,
    faWifi: $d8206b3ab2e65c05$export$1642419fe3db2857,
    faWifi3: $d8206b3ab2e65c05$export$2349bb04a04f4b2d,
    faWifiStrong: $d8206b3ab2e65c05$export$4b3167c852f4c4aa,
    faBath: $d8206b3ab2e65c05$export$1ea66a88b8f620c9,
    faBathtub: $d8206b3ab2e65c05$export$40ae013b5e6269d8,
    faUnderline: $d8206b3ab2e65c05$export$22346afd6a3cddf8,
    faUserPen: $d8206b3ab2e65c05$export$3842882ea09b25af,
    faUserEdit: $d8206b3ab2e65c05$export$a68a6960fc8eef82,
    faSignature: $d8206b3ab2e65c05$export$afa7b53ac8ebcb5d,
    faStroopwafel: $d8206b3ab2e65c05$export$195780ddabd8e0c6,
    faBold: $d8206b3ab2e65c05$export$7e0c7fd2a2e88823,
    faAnchorLock: $d8206b3ab2e65c05$export$217195c80db39097,
    faBuildingNgo: $d8206b3ab2e65c05$export$374e1dce366a2175,
    faManatSign: $d8206b3ab2e65c05$export$1ff755b523ab2851,
    faNotEqual: $d8206b3ab2e65c05$export$6a15ccae09bbaf93,
    faBorderTopLeft: $d8206b3ab2e65c05$export$cf897c3e0abd59e4,
    faBorderStyle: $d8206b3ab2e65c05$export$c2867ca78120d644,
    faMapLocationDot: $d8206b3ab2e65c05$export$757f50b8af780c19,
    faMapMarkedAlt: $d8206b3ab2e65c05$export$a977d47c74d8e86c,
    faJedi: $d8206b3ab2e65c05$export$859f204e59641ca4,
    faSquarePollVertical: $d8206b3ab2e65c05$export$91d747e5aabe6fe8,
    faPoll: $d8206b3ab2e65c05$export$bc8ca14ab51f93db,
    faMugHot: $d8206b3ab2e65c05$export$47a822c30184e8af,
    faCarBattery: $d8206b3ab2e65c05$export$a44d0c11093d9c1e,
    faBatteryCar: $d8206b3ab2e65c05$export$9133165ca669dd4b,
    faGift: $d8206b3ab2e65c05$export$b2727de8ccdbb5ec,
    faDiceTwo: $d8206b3ab2e65c05$export$4d85df590065572f,
    faChessQueen: $d8206b3ab2e65c05$export$7b8ce73615739d30,
    faGlasses: $d8206b3ab2e65c05$export$58d7d709c0a8ca5f,
    faChessBoard: $d8206b3ab2e65c05$export$bd301515df6246af,
    faBuildingCircleCheck: $d8206b3ab2e65c05$export$5559de5f969b9590,
    faPersonChalkboard: $d8206b3ab2e65c05$export$c9dc1583b207b7ff,
    faMarsStrokeRight: $d8206b3ab2e65c05$export$321e84e6a900c2d6,
    faMarsStrokeH: $d8206b3ab2e65c05$export$5cb0daeafbcdabe3,
    faHandBackFist: $d8206b3ab2e65c05$export$be38a892fe9b4098,
    faHandRock: $d8206b3ab2e65c05$export$97a81eba394c8c44,
    faSquareCaretUp: $d8206b3ab2e65c05$export$66068918abb14406,
    faCaretSquareUp: $d8206b3ab2e65c05$export$307ae80b26533ce5,
    faCloudShowersWater: $d8206b3ab2e65c05$export$b416056e795d2eac,
    faChartBar: $d8206b3ab2e65c05$export$b532f5d25de97633,
    faBarChart: $d8206b3ab2e65c05$export$2d5f754a5e5738b,
    faHandsBubbles: $d8206b3ab2e65c05$export$2f78563e14e49916,
    faHandsWash: $d8206b3ab2e65c05$export$996b5dea53b124e3,
    faLessThanEqual: $d8206b3ab2e65c05$export$b2c723344cff0d8,
    faTrain: $d8206b3ab2e65c05$export$17cde74bf6f1ee89,
    faEyeLowVision: $d8206b3ab2e65c05$export$23a892b1a4b994bd,
    faLowVision: $d8206b3ab2e65c05$export$7a65d2aa54cb4e93,
    faCrow: $d8206b3ab2e65c05$export$bfa312207b788ed9,
    faSailboat: $d8206b3ab2e65c05$export$e363e74e36cce80c,
    faWindowRestore: $d8206b3ab2e65c05$export$eccfff9bfd585652,
    faSquarePlus: $d8206b3ab2e65c05$export$eaf727acca5a35e4,
    faPlusSquare: $d8206b3ab2e65c05$export$b6359eebfe900c35,
    faToriiGate: $d8206b3ab2e65c05$export$75825a4c2b3375e,
    faFrog: $d8206b3ab2e65c05$export$fe2358263efac504,
    faBucket: $d8206b3ab2e65c05$export$2124c7628e573b84,
    faImage: $d8206b3ab2e65c05$export$7e9f0928967e03b,
    faMicrophone: $d8206b3ab2e65c05$export$eed3c491effe6d12,
    faCow: $d8206b3ab2e65c05$export$1da3b2e53dcafa2d,
    faCaretUp: $d8206b3ab2e65c05$export$7de776bdab4e536d,
    faScrewdriver: $d8206b3ab2e65c05$export$7484ff654cd6474f,
    faFolderClosed: $d8206b3ab2e65c05$export$5e30548b7f8eeb95,
    faHouseTsunami: $d8206b3ab2e65c05$export$197b9567e88a0b1d,
    faSquareNfi: $d8206b3ab2e65c05$export$5498258519fc5b72,
    faArrowUpFromGroundWater: $d8206b3ab2e65c05$export$cbe485a104805f4f,
    faMartiniGlass: $d8206b3ab2e65c05$export$98401bb29cff68e0,
    faGlassMartiniAlt: $d8206b3ab2e65c05$export$2258439b8f4e7acb,
    faRotateLeft: $d8206b3ab2e65c05$export$7adaa412bd8eb08f,
    faRotateBack: $d8206b3ab2e65c05$export$9706706f1bc7b12,
    faRotateBackward: $d8206b3ab2e65c05$export$4ceb0b05fed961a9,
    faUndoAlt: $d8206b3ab2e65c05$export$c8197b992c46c4a6,
    faTableColumns: $d8206b3ab2e65c05$export$ccaa019a3fd4563f,
    faColumns: $d8206b3ab2e65c05$export$bb861166644ac28a,
    faLemon: $d8206b3ab2e65c05$export$4fbda8f64648f3b5,
    faHeadSideMask: $d8206b3ab2e65c05$export$280300af4baa1a3e,
    faHandshake: $d8206b3ab2e65c05$export$b4c63e9bfc7906f1,
    faGem: $d8206b3ab2e65c05$export$31ee86ac717db552,
    faDolly: $d8206b3ab2e65c05$export$5879d0bca1aa497b,
    faDollyBox: $d8206b3ab2e65c05$export$461bbb9e92cc531b,
    faSmoking: $d8206b3ab2e65c05$export$c4ab83701fc591a5,
    faMinimize: $d8206b3ab2e65c05$export$e0601b1f239fec74,
    faCompressArrowsAlt: $d8206b3ab2e65c05$export$39205db0ea980efd,
    faMonument: $d8206b3ab2e65c05$export$6f9b0bfc012deb25,
    faSnowplow: $d8206b3ab2e65c05$export$695fae58f55c3a87,
    faAnglesRight: $d8206b3ab2e65c05$export$48b60f1720e09944,
    faAngleDoubleRight: $d8206b3ab2e65c05$export$792931403404faf0,
    faCannabis: $d8206b3ab2e65c05$export$8ec2f752344b69bd,
    faCirclePlay: $d8206b3ab2e65c05$export$86c4e45dc3302d15,
    faPlayCircle: $d8206b3ab2e65c05$export$cf04333781061c5e,
    faTablets: $d8206b3ab2e65c05$export$bed2b0ed4ae45e0d,
    faEthernet: $d8206b3ab2e65c05$export$6bad2c9f317b52e5,
    faEuroSign: $d8206b3ab2e65c05$export$902a3969bb113dff,
    faEur: $d8206b3ab2e65c05$export$4b859160cfeb12ff,
    faEuro: $d8206b3ab2e65c05$export$bdabbefede2d3a2,
    faChair: $d8206b3ab2e65c05$export$a339864ee3df7e9a,
    faCircleCheck: $d8206b3ab2e65c05$export$c2e9877668862374,
    faCheckCircle: $d8206b3ab2e65c05$export$be9e388158c74f29,
    faCircleStop: $d8206b3ab2e65c05$export$229de76dfef2687f,
    faStopCircle: $d8206b3ab2e65c05$export$47af2aad60ab3e7c,
    faCompassDrafting: $d8206b3ab2e65c05$export$aaaddd2cf7e20f64,
    faDraftingCompass: $d8206b3ab2e65c05$export$c8c2b127d13b9d79,
    faPlateWheat: $d8206b3ab2e65c05$export$2eff9f6cbe00a643,
    faIcicles: $d8206b3ab2e65c05$export$78792ed87d92a3ad,
    faPersonShelter: $d8206b3ab2e65c05$export$d359c2cc7640953c,
    faNeuter: $d8206b3ab2e65c05$export$771cf879fba0cf93,
    faIdBadge: $d8206b3ab2e65c05$export$a75288855ea05282,
    faMarker: $d8206b3ab2e65c05$export$e6789173649caa25,
    faFaceLaughBeam: $d8206b3ab2e65c05$export$3f2d51c0547bf984,
    faLaughBeam: $d8206b3ab2e65c05$export$a88d1f4073ea9369,
    faHelicopterSymbol: $d8206b3ab2e65c05$export$2a66e6044c1f7036,
    faUniversalAccess: $d8206b3ab2e65c05$export$e119aada7f690d05,
    faCircleChevronUp: $d8206b3ab2e65c05$export$7b69b3617b84259b,
    faChevronCircleUp: $d8206b3ab2e65c05$export$b786cf5db03f2c36,
    faLariSign: $d8206b3ab2e65c05$export$d317bc452442782d,
    faVolcano: $d8206b3ab2e65c05$export$bae30a76735500e1,
    faPersonWalkingDashedLineArrowRight: $d8206b3ab2e65c05$export$a1d09c95bee8043b,
    faSterlingSign: $d8206b3ab2e65c05$export$170c56774c8e7961,
    faGbp: $d8206b3ab2e65c05$export$3d9479ec1d1ae83e,
    faPoundSign: $d8206b3ab2e65c05$export$9ce041dfec8319b,
    faViruses: $d8206b3ab2e65c05$export$ee194b18f5c6f6b6,
    faSquarePersonConfined: $d8206b3ab2e65c05$export$8aaca358568da0e0,
    faUserTie: $d8206b3ab2e65c05$export$48c51dda34e9f04c,
    faArrowDownLong: $d8206b3ab2e65c05$export$5977e8de7e65b20,
    faLongArrowDown: $d8206b3ab2e65c05$export$52ecf90b62f3f030,
    faTentArrowDownToLine: $d8206b3ab2e65c05$export$8a4f323f00a91606,
    faCertificate: $d8206b3ab2e65c05$export$a881f37164b11fbf,
    faReplyAll: $d8206b3ab2e65c05$export$ca6fd367f31ecbc5,
    faMailReplyAll: $d8206b3ab2e65c05$export$8274334f3a2c1841,
    faSuitcase: $d8206b3ab2e65c05$export$60710f3921019268,
    faPersonSkating: $d8206b3ab2e65c05$export$f3854553fe688388,
    faSkating: $d8206b3ab2e65c05$export$21bd1d54bd4f2c5a,
    faFilterCircleDollar: $d8206b3ab2e65c05$export$3300e4b4d1d1936f,
    faFunnelDollar: $d8206b3ab2e65c05$export$cebe38ad8f0a143d,
    faCameraRetro: $d8206b3ab2e65c05$export$41dbdadc07a89b05,
    faCircleArrowDown: $d8206b3ab2e65c05$export$a30c52cde32bec7e,
    faArrowCircleDown: $d8206b3ab2e65c05$export$6cfa36bbb3a057,
    faFileImport: $d8206b3ab2e65c05$export$d796c05153b1255c,
    faArrowRightToFile: $d8206b3ab2e65c05$export$32f14beaf6294476,
    faSquareArrowUpRight: $d8206b3ab2e65c05$export$38150b61dfd06fff,
    faExternalLinkSquare: $d8206b3ab2e65c05$export$e04d83fed5ebcebf,
    faBoxOpen: $d8206b3ab2e65c05$export$9010ed816a8b9c97,
    faScroll: $d8206b3ab2e65c05$export$7c265716d4399676,
    faSpa: $d8206b3ab2e65c05$export$f9a38ef7b046ab51,
    faLocationPinLock: $d8206b3ab2e65c05$export$db853fbb474326cc,
    faPause: $d8206b3ab2e65c05$export$da79f048408b1722,
    faHillAvalanche: $d8206b3ab2e65c05$export$50d11c98c99e3b2d,
    faTemperatureEmpty: $d8206b3ab2e65c05$export$ac389bf5cc37feb5,
    faTemperature0: $d8206b3ab2e65c05$export$e99b7d2ccc282383,
    faThermometer0: $d8206b3ab2e65c05$export$4c13a186ecce3b80,
    faThermometerEmpty: $d8206b3ab2e65c05$export$81a2f8298cf523f9,
    faBomb: $d8206b3ab2e65c05$export$d59078f6e80b4a67,
    faRegistered: $d8206b3ab2e65c05$export$5f519e9ac15ab8c3,
    faAddressCard: $d8206b3ab2e65c05$export$6ea408c7266ed557,
    faContactCard: $d8206b3ab2e65c05$export$4ac51eb0b298b190,
    faVcard: $d8206b3ab2e65c05$export$91228257deb1bf18,
    faScaleUnbalancedFlip: $d8206b3ab2e65c05$export$f4d7840209109993,
    faBalanceScaleRight: $d8206b3ab2e65c05$export$2238e05f8920005a,
    faSubscript: $d8206b3ab2e65c05$export$34c1e678c32ed646,
    faDiamondTurnRight: $d8206b3ab2e65c05$export$99749ac517cbef07,
    faDirections: $d8206b3ab2e65c05$export$6a6973de44442fe5,
    faBurst: $d8206b3ab2e65c05$export$ea2986b45ba5d2cf,
    faHouseLaptop: $d8206b3ab2e65c05$export$6486d62e77b910,
    faLaptopHouse: $d8206b3ab2e65c05$export$efd983de5e4d6ad3,
    faFaceTired: $d8206b3ab2e65c05$export$5352cbdc070ce8d,
    faTired: $d8206b3ab2e65c05$export$3d016d62cda18371,
    faMoneyBills: $d8206b3ab2e65c05$export$a822dad6e586ee9e,
    faSmog: $d8206b3ab2e65c05$export$aa11b8edb09fed14,
    faCrutch: $d8206b3ab2e65c05$export$e94134641c0e2,
    faFontAwesome: $d8206b3ab2e65c05$export$aa4baaed1c60f58d,
    faFontAwesomeFlag: $d8206b3ab2e65c05$export$102c25fde54d4843,
    faFontAwesomeLogoFull: $d8206b3ab2e65c05$export$6e20d421a2e0f320,
    faCloudArrowUp: $d8206b3ab2e65c05$export$3507214fff1cc655,
    faCloudUpload: $d8206b3ab2e65c05$export$a48720e6366f5d9a,
    faCloudUploadAlt: $d8206b3ab2e65c05$export$e73b3e819b9d14a5,
    faPalette: $d8206b3ab2e65c05$export$5c390baea5db4f77,
    faArrowsTurnRight: $d8206b3ab2e65c05$export$db9f783f15682c4a,
    faVest: $d8206b3ab2e65c05$export$c8370e53051a657,
    faFerry: $d8206b3ab2e65c05$export$fd312949b97346ae,
    faArrowsDownToPeople: $d8206b3ab2e65c05$export$cfb044c7d35060bb,
    faSeedling: $d8206b3ab2e65c05$export$d7b60b8dbd03cfe4,
    faSprout: $d8206b3ab2e65c05$export$9f3035e3a8c62323,
    faLeftRight: $d8206b3ab2e65c05$export$47d93e9001818ee7,
    faArrowsAltH: $d8206b3ab2e65c05$export$7937ea574fb1389,
    faBoxesPacking: $d8206b3ab2e65c05$export$e81e7f3390fe84fe,
    faCircleArrowLeft: $d8206b3ab2e65c05$export$827fbb87bdbe1028,
    faArrowCircleLeft: $d8206b3ab2e65c05$export$728262abb9f58d0a,
    faGroupArrowsRotate: $d8206b3ab2e65c05$export$88a8383ecdd39a54,
    faBowlFood: $d8206b3ab2e65c05$export$8b89ca3201039376,
    faCandyCane: $d8206b3ab2e65c05$export$14d66ba7571ae0b9,
    faArrowDownWideShort: $d8206b3ab2e65c05$export$4229d00802c33062,
    faSortAmountAsc: $d8206b3ab2e65c05$export$ddf8b8dd5983367d,
    faSortAmountDown: $d8206b3ab2e65c05$export$4b2a02d50e417b5f,
    faCloudBolt: $d8206b3ab2e65c05$export$cdd116afa0309c17,
    faThunderstorm: $d8206b3ab2e65c05$export$bbf9e3d433f8f6de,
    faTextSlash: $d8206b3ab2e65c05$export$ec658c0f040c3e1a,
    faRemoveFormat: $d8206b3ab2e65c05$export$d91179f327329532,
    faFaceSmileWink: $d8206b3ab2e65c05$export$6143da800b0e6626,
    faSmileWink: $d8206b3ab2e65c05$export$f5dbb37f6801ee3f,
    faFileWord: $d8206b3ab2e65c05$export$f0858dff6e769cf6,
    faFilePowerpoint: $d8206b3ab2e65c05$export$c341daeecdea449a,
    faArrowsLeftRight: $d8206b3ab2e65c05$export$672e2f590b189583,
    faArrowsH: $d8206b3ab2e65c05$export$de517642cdb40354,
    faHouseLock: $d8206b3ab2e65c05$export$aa54b16c409e882f,
    faCloudArrowDown: $d8206b3ab2e65c05$export$542a9676c5286e01,
    faCloudDownload: $d8206b3ab2e65c05$export$b318977f29260464,
    faCloudDownloadAlt: $d8206b3ab2e65c05$export$351357a14c41f824,
    faChildren: $d8206b3ab2e65c05$export$f2819bf60df55912,
    faChalkboard: $d8206b3ab2e65c05$export$49a36efd66df775,
    faBlackboard: $d8206b3ab2e65c05$export$f497e01bf522fd9c,
    faUserLargeSlash: $d8206b3ab2e65c05$export$ae7fc6b7f0534be9,
    faUserAltSlash: $d8206b3ab2e65c05$export$46185fab4772ada6,
    faEnvelopeOpen: $d8206b3ab2e65c05$export$c6c3bd5f7d9b8bf2,
    faHandshakeSimpleSlash: $d8206b3ab2e65c05$export$e99ae494101c5e91,
    faHandshakeAltSlash: $d8206b3ab2e65c05$export$ca302f956ae9f1bf,
    faMattressPillow: $d8206b3ab2e65c05$export$f042d3e458efa721,
    faGuaraniSign: $d8206b3ab2e65c05$export$b731a51acb74b00c,
    faArrowsRotate: $d8206b3ab2e65c05$export$2fd091cb98dc8ab8,
    faRefresh: $d8206b3ab2e65c05$export$fd4359e93d7b3d14,
    faSync: $d8206b3ab2e65c05$export$ff87319002e3dae9,
    faFireExtinguisher: $d8206b3ab2e65c05$export$d75fb6743634a0a,
    faCruzeiroSign: $d8206b3ab2e65c05$export$64dd1b27affb6572,
    faGreaterThanEqual: $d8206b3ab2e65c05$export$7bf8dfe2e6661a54,
    faShieldHalved: $d8206b3ab2e65c05$export$36e034ccc72554a9,
    faShieldAlt: $d8206b3ab2e65c05$export$d6508d18a824f291,
    faBookAtlas: $d8206b3ab2e65c05$export$7fb8daedae341012,
    faAtlas: $d8206b3ab2e65c05$export$380a9050e42fe5d7,
    faVirus: $d8206b3ab2e65c05$export$37c67e0b3dc6bd1b,
    faEnvelopeCircleCheck: $d8206b3ab2e65c05$export$74d890536dbd21b7,
    faLayerGroup: $d8206b3ab2e65c05$export$a137712e11e257dd,
    faArrowsToDot: $d8206b3ab2e65c05$export$ab3a06d4b53c0fc0,
    faArchway: $d8206b3ab2e65c05$export$d56753dd2eb5c323,
    faHeartCircleCheck: $d8206b3ab2e65c05$export$5e4b6785eedecc1a,
    faHouseChimneyCrack: $d8206b3ab2e65c05$export$e824540f5a6a8a57,
    faHouseDamage: $d8206b3ab2e65c05$export$8d7e943005ce0b49,
    faFileZipper: $d8206b3ab2e65c05$export$7a4a0e4caa1e4e6f,
    faFileArchive: $d8206b3ab2e65c05$export$bf2047a9946b5c3f,
    faSquare: $d8206b3ab2e65c05$export$90b4406457aae8cc,
    faMartiniGlassEmpty: $d8206b3ab2e65c05$export$a8a0de30198815a3,
    faGlassMartini: $d8206b3ab2e65c05$export$e96f280e39af4a91,
    faCouch: $d8206b3ab2e65c05$export$ce96e32767a7dd51,
    faCediSign: $d8206b3ab2e65c05$export$66c557f70914132c,
    faItalic: $d8206b3ab2e65c05$export$16e344bae4d495ed,
    faChurch: $d8206b3ab2e65c05$export$16a3f12c6ae9650,
    faCommentsDollar: $d8206b3ab2e65c05$export$d477129b070e5ac4,
    faDemocrat: $d8206b3ab2e65c05$export$a1672d808fbed0bd,
    faZ: $d8206b3ab2e65c05$export$3481c1aa28972f9b,
    faPersonSkiing: $d8206b3ab2e65c05$export$5ebd3cd0630e3ae7,
    faSkiing: $d8206b3ab2e65c05$export$eae1acab6fb96708,
    faRoadLock: $d8206b3ab2e65c05$export$b81a894d5bc3eb17,
    faA: $d8206b3ab2e65c05$export$406fe05808a3753e,
    faTemperatureArrowDown: $d8206b3ab2e65c05$export$4520eb1840c4e110,
    faTemperatureDown: $d8206b3ab2e65c05$export$f0b2aca3866f00f6,
    faFeatherPointed: $d8206b3ab2e65c05$export$2a9d3e120019c92d,
    faFeatherAlt: $d8206b3ab2e65c05$export$68cf766c786bcd78,
    faP: $d8206b3ab2e65c05$export$bcb419f1cd5beac3,
    faSnowflake: $d8206b3ab2e65c05$export$bab8f3647c394f48,
    faNewspaper: $d8206b3ab2e65c05$export$d91b374112d4f8c1,
    faRectangleAd: $d8206b3ab2e65c05$export$d0ccaddca9e06d1e,
    faAd: $d8206b3ab2e65c05$export$7af266c3465b1ff2,
    faCircleArrowRight: $d8206b3ab2e65c05$export$2f1e22e081a1ad05,
    faArrowCircleRight: $d8206b3ab2e65c05$export$7d3d828103aa3be7,
    faFilterCircleXmark: $d8206b3ab2e65c05$export$fb5ab619c34ea613,
    faLocust: $d8206b3ab2e65c05$export$4982360d3b844c19,
    faSort: $d8206b3ab2e65c05$export$4941c5969d5399b,
    faUnsorted: $d8206b3ab2e65c05$export$418597748f0fe52d,
    faListOl: $d8206b3ab2e65c05$export$3db8f67cd0fc963b,
    faList12: $d8206b3ab2e65c05$export$7e3d894cd55296b,
    faListNumeric: $d8206b3ab2e65c05$export$cf51408faadac277,
    faPersonDressBurst: $d8206b3ab2e65c05$export$523180e731928397,
    faMoneyCheckDollar: $d8206b3ab2e65c05$export$eeb59dd1825c6a65,
    faMoneyCheckAlt: $d8206b3ab2e65c05$export$8c6ccc9745897cb2,
    faVectorSquare: $d8206b3ab2e65c05$export$567d5631a7b0599f,
    faBreadSlice: $d8206b3ab2e65c05$export$d78e8b0681279167,
    faLanguage: $d8206b3ab2e65c05$export$8a7bee49fdf8c954,
    faFaceKissWinkHeart: $d8206b3ab2e65c05$export$611ae61f02de0aa,
    faKissWinkHeart: $d8206b3ab2e65c05$export$ebba617701dfb917,
    faFilter: $d8206b3ab2e65c05$export$f253a38d7142e29f,
    faQuestion: $d8206b3ab2e65c05$export$d96973f90e8f6e47,
    faFileSignature: $d8206b3ab2e65c05$export$d0de575ac166712b,
    faUpDownLeftRight: $d8206b3ab2e65c05$export$cd7b22f4e6e3834b,
    faArrowsAlt: $d8206b3ab2e65c05$export$3cdabfff52cfc73a,
    faHouseChimneyUser: $d8206b3ab2e65c05$export$1ddbaebce033a0d,
    faHandHoldingHeart: $d8206b3ab2e65c05$export$97e5ef3e80a0fbef,
    faPuzzlePiece: $d8206b3ab2e65c05$export$7ee0dbd1e92e2859,
    faMoneyCheck: $d8206b3ab2e65c05$export$be069f641c85d0b3,
    faStarHalfStroke: $d8206b3ab2e65c05$export$3e4892d8bf919edd,
    faStarHalfAlt: $d8206b3ab2e65c05$export$c13575f42532efb3,
    faCode: $d8206b3ab2e65c05$export$eba095993e51cc97,
    faWhiskeyGlass: $d8206b3ab2e65c05$export$f1304dd34ea2afbd,
    faGlassWhiskey: $d8206b3ab2e65c05$export$fdec0f5f1a169419,
    faBuildingCircleExclamation: $d8206b3ab2e65c05$export$c49f030b19083ebe,
    faMagnifyingGlassChart: $d8206b3ab2e65c05$export$6a1e4cdbb8ca10c5,
    faArrowUpRightFromSquare: $d8206b3ab2e65c05$export$5ad84e891223f2c3,
    faExternalLink: $d8206b3ab2e65c05$export$f4c613289034e5ef,
    faCubesStacked: $d8206b3ab2e65c05$export$b1f00c433aabac05,
    faWonSign: $d8206b3ab2e65c05$export$51790ddd26e431bc,
    faKrw: $d8206b3ab2e65c05$export$2f65e07a45b95b50,
    faWon: $d8206b3ab2e65c05$export$5a1fd3ed9564d7fa,
    faVirusCovid: $d8206b3ab2e65c05$export$1df4e031b8ee4f84,
    faAustralSign: $d8206b3ab2e65c05$export$299c200ad3db97b4,
    faF: $d8206b3ab2e65c05$export$a2f384a559654618,
    faLeaf: $d8206b3ab2e65c05$export$7c497bae2754a087,
    faRoad: $d8206b3ab2e65c05$export$f224567a4851a5e9,
    faTaxi: $d8206b3ab2e65c05$export$9958afcdfece1b58,
    faCab: $d8206b3ab2e65c05$export$7bf12d9380f0971b,
    faPersonCirclePlus: $d8206b3ab2e65c05$export$55686b1eb7d00307,
    faChartPie: $d8206b3ab2e65c05$export$1de7b9cf7d1b153b,
    faPieChart: $d8206b3ab2e65c05$export$7877286cd337de81,
    faBoltLightning: $d8206b3ab2e65c05$export$b16dcd08f3da1ba2,
    faSackXmark: $d8206b3ab2e65c05$export$2bad98c38bea5994,
    faFileExcel: $d8206b3ab2e65c05$export$77cb1a465c4fe84,
    faFileContract: $d8206b3ab2e65c05$export$70fde3f3fdaa6a6a,
    faFishFins: $d8206b3ab2e65c05$export$e7af4f0123222b6f,
    faBuildingFlag: $d8206b3ab2e65c05$export$592422b29ab0a914,
    faFaceGrinBeam: $d8206b3ab2e65c05$export$3de52eeb00462407,
    faGrinBeam: $d8206b3ab2e65c05$export$734da5249381ec7e,
    faObjectUngroup: $d8206b3ab2e65c05$export$887f6345573abcac,
    faPoop: $d8206b3ab2e65c05$export$bb45b6b87d1adf27,
    faLocationPin: $d8206b3ab2e65c05$export$c0b7617de95c0c05,
    faMapMarker: $d8206b3ab2e65c05$export$10d360e4f1a554dd,
    faKaaba: $d8206b3ab2e65c05$export$ab1408bfbe914cc9,
    faToiletPaper: $d8206b3ab2e65c05$export$c8cc083ccc72b17,
    faHelmetSafety: $d8206b3ab2e65c05$export$aacaf42fba617981,
    faHardHat: $d8206b3ab2e65c05$export$7b72177558a98b6f,
    faHatHard: $d8206b3ab2e65c05$export$c0e235dbf1644a2f,
    faEject: $d8206b3ab2e65c05$export$8484041d5b209494,
    faCircleRight: $d8206b3ab2e65c05$export$1fec48c8bdd69c1d,
    faArrowAltCircleRight: $d8206b3ab2e65c05$export$88962ffdad8b856d,
    faPlaneCircleCheck: $d8206b3ab2e65c05$export$9cbf8612c6cadc74,
    faFaceRollingEyes: $d8206b3ab2e65c05$export$a6d72a9a068392b5,
    faMehRollingEyes: $d8206b3ab2e65c05$export$fdc62a1bea767cc2,
    faObjectGroup: $d8206b3ab2e65c05$export$40cdac24aa94a57a,
    faChartLine: $d8206b3ab2e65c05$export$e022f62a119e1d93,
    faLineChart: $d8206b3ab2e65c05$export$f729617a20de475b,
    faMaskVentilator: $d8206b3ab2e65c05$export$122c8413a0dc5ff6,
    faArrowRight: $d8206b3ab2e65c05$export$b4da69a0247f3620,
    faSignsPost: $d8206b3ab2e65c05$export$905f45f8ffd6b8e5,
    faMapSigns: $d8206b3ab2e65c05$export$743f4b1071b3333a,
    faCashRegister: $d8206b3ab2e65c05$export$6357093f67788b33,
    faPersonCircleQuestion: $d8206b3ab2e65c05$export$c8f8a597ffd676c0,
    faH: $d8206b3ab2e65c05$export$d762b7b66d5875e1,
    faTarp: $d8206b3ab2e65c05$export$2305b1a41b3f914,
    faScrewdriverWrench: $d8206b3ab2e65c05$export$158a12f36bbecf9,
    faTools: $d8206b3ab2e65c05$export$646e4e7a8c6172aa,
    faArrowsToEye: $d8206b3ab2e65c05$export$9adae865350879af,
    faPlugCircleBolt: $d8206b3ab2e65c05$export$4f3b3144ce966486,
    faHeart: $d8206b3ab2e65c05$export$e4b51a47a2f8b9db,
    faMarsAndVenus: $d8206b3ab2e65c05$export$808b88e8735e31e8,
    faHouseUser: $d8206b3ab2e65c05$export$9a513ee921e8e885,
    faHomeUser: $d8206b3ab2e65c05$export$e732fa55ae5bbdf0,
    faDumpsterFire: $d8206b3ab2e65c05$export$25e9b29b3f2230b5,
    faHouseCrack: $d8206b3ab2e65c05$export$baa3c215534dbf2a,
    faMartiniGlassCitrus: $d8206b3ab2e65c05$export$c6e76550bdc0255d,
    faCocktail: $d8206b3ab2e65c05$export$4be708f1e41d387b,
    faFaceSurprise: $d8206b3ab2e65c05$export$c938968e28178994,
    faSurprise: $d8206b3ab2e65c05$export$46647c72213f53ba,
    faBottleWater: $d8206b3ab2e65c05$export$3ee278c67519eeeb,
    faCirclePause: $d8206b3ab2e65c05$export$fbeef2513e05ad08,
    faPauseCircle: $d8206b3ab2e65c05$export$d8cf08a0362da8db,
    faToiletPaperSlash: $d8206b3ab2e65c05$export$7a494edbf9b65575,
    faAppleWhole: $d8206b3ab2e65c05$export$12de8220d30453a3,
    faAppleAlt: $d8206b3ab2e65c05$export$bcdd94f3977a0884,
    faKitchenSet: $d8206b3ab2e65c05$export$64c1570509eaf40d,
    faR: $d8206b3ab2e65c05$export$eb4c616de6eef46f,
    faTemperatureQuarter: $d8206b3ab2e65c05$export$f9d1c19925fd7fa8,
    faTemperature1: $d8206b3ab2e65c05$export$d4f1cd380bde2129,
    faThermometer1: $d8206b3ab2e65c05$export$3f77fbe2dabe285b,
    faThermometerQuarter: $d8206b3ab2e65c05$export$ed05754fcbec6e46,
    faCube: $d8206b3ab2e65c05$export$973ae4f1e4d2ce78,
    faBitcoinSign: $d8206b3ab2e65c05$export$441bfc8058328ce8,
    faShieldDog: $d8206b3ab2e65c05$export$2a5c6f182c0cbcb,
    faSolarPanel: $d8206b3ab2e65c05$export$b9c649c5e37017f3,
    faLockOpen: $d8206b3ab2e65c05$export$84b5acad4436d02a,
    faElevator: $d8206b3ab2e65c05$export$c7a833ce065e0ea4,
    faMoneyBillTransfer: $d8206b3ab2e65c05$export$1b71392d9effbe,
    faMoneyBillTrendUp: $d8206b3ab2e65c05$export$18ab80cba7d5044f,
    faHouseFloodWaterCircleArrowRight: $d8206b3ab2e65c05$export$30d3e64480aa266b,
    faSquarePollHorizontal: $d8206b3ab2e65c05$export$287bdd70ab874659,
    faPollH: $d8206b3ab2e65c05$export$456a238f0144d430,
    faCircle: $d8206b3ab2e65c05$export$4280b2387fbdad12,
    faBackwardFast: $d8206b3ab2e65c05$export$662cbc6ed5a3c5e8,
    faFastBackward: $d8206b3ab2e65c05$export$e6246a3279a379b8,
    faRecycle: $d8206b3ab2e65c05$export$a65c441f12cb6bd,
    faUserAstronaut: $d8206b3ab2e65c05$export$94363e983c225a04,
    faPlaneSlash: $d8206b3ab2e65c05$export$cfee4df0d5df6d21,
    faTrademark: $d8206b3ab2e65c05$export$9c9b2fbddd59047d,
    faBasketball: $d8206b3ab2e65c05$export$44dee69e3a29b0e,
    faBasketballBall: $d8206b3ab2e65c05$export$36550ab8ffcc5b28,
    faSatelliteDish: $d8206b3ab2e65c05$export$219ccae0e4da3c92,
    faCircleUp: $d8206b3ab2e65c05$export$72ea8a5e4e86cd69,
    faArrowAltCircleUp: $d8206b3ab2e65c05$export$3747a8ef0995eadf,
    faMobileScreenButton: $d8206b3ab2e65c05$export$da39ed20699ee2d7,
    faMobileAlt: $d8206b3ab2e65c05$export$e9599bc6cd92234d,
    faVolumeHigh: $d8206b3ab2e65c05$export$39461921e738be65,
    faVolumeUp: $d8206b3ab2e65c05$export$5940d3e475d90cc4,
    faUsersRays: $d8206b3ab2e65c05$export$9c0b63b698611d06,
    faWallet: $d8206b3ab2e65c05$export$79204db8777905c8,
    faClipboardCheck: $d8206b3ab2e65c05$export$7babcb2c90eb609a,
    faFileAudio: $d8206b3ab2e65c05$export$b8d24c57c9e64933,
    faBurger: $d8206b3ab2e65c05$export$128a6cab12423493,
    faHamburger: $d8206b3ab2e65c05$export$bab3bb9f4f59363,
    faWrench: $d8206b3ab2e65c05$export$3c6c0c8185296ac5,
    faBugs: $d8206b3ab2e65c05$export$f5bfd1271b8b71d1,
    faRupeeSign: $d8206b3ab2e65c05$export$8bf9e3f7f57d486a,
    faRupee: $d8206b3ab2e65c05$export$9da25a46cfcb6fa4,
    faFileImage: $d8206b3ab2e65c05$export$6440b286d3cbac9b,
    faCircleQuestion: $d8206b3ab2e65c05$export$d7cf0978afd90002,
    faQuestionCircle: $d8206b3ab2e65c05$export$5ba67d7f2265c1a5,
    faPlaneDeparture: $d8206b3ab2e65c05$export$6ccbeeccfea6dc8a,
    faHandshakeSlash: $d8206b3ab2e65c05$export$2cef3f81ad90fb76,
    faBookBookmark: $d8206b3ab2e65c05$export$3d177ecdf7fc50ec,
    faCodeBranch: $d8206b3ab2e65c05$export$aa054a78ab078db3,
    faHatCowboy: $d8206b3ab2e65c05$export$37672611144b857b,
    faBridge: $d8206b3ab2e65c05$export$f402c7c97f3383f0,
    faPhoneFlip: $d8206b3ab2e65c05$export$d86c56ab43eb0deb,
    faPhoneAlt: $d8206b3ab2e65c05$export$a07a9b305deebf32,
    faTruckFront: $d8206b3ab2e65c05$export$4a5a13c01d46357c,
    faCat: $d8206b3ab2e65c05$export$ab927dada03be4b3,
    faAnchorCircleExclamation: $d8206b3ab2e65c05$export$61add9eca991b5ec,
    faTruckField: $d8206b3ab2e65c05$export$f4419f7b2e53b340,
    faRoute: $d8206b3ab2e65c05$export$806c0a45a7ecd6e8,
    faClipboardQuestion: $d8206b3ab2e65c05$export$d4aa151a4554b74e,
    faPanorama: $d8206b3ab2e65c05$export$5dd22dcb6e3ed369,
    faCommentMedical: $d8206b3ab2e65c05$export$101422b773924276,
    faTeethOpen: $d8206b3ab2e65c05$export$c88ac21fe7c88ae6,
    faFileCircleMinus: $d8206b3ab2e65c05$export$4b89fabf50a10951,
    faTags: $d8206b3ab2e65c05$export$d55778e3ab6c933f,
    faWineGlass: $d8206b3ab2e65c05$export$e06d6607d3577d6e,
    faForwardFast: $d8206b3ab2e65c05$export$dc9cc4280bee320d,
    faFastForward: $d8206b3ab2e65c05$export$61a8cdc53c2e078d,
    faFaceMehBlank: $d8206b3ab2e65c05$export$38c072b870a9e4ab,
    faMehBlank: $d8206b3ab2e65c05$export$e945435725f71e88,
    faSquareParking: $d8206b3ab2e65c05$export$f2cfa036d76f69ab,
    faParking: $d8206b3ab2e65c05$export$fda29c8f99573a4e,
    faHouseSignal: $d8206b3ab2e65c05$export$58845db8e7e9a199,
    faBarsProgress: $d8206b3ab2e65c05$export$ee3a02da18715b2,
    faTasksAlt: $d8206b3ab2e65c05$export$bbc0784fc1578f7f,
    faFaucetDrip: $d8206b3ab2e65c05$export$7a255960242435f6,
    faCartFlatbed: $d8206b3ab2e65c05$export$df587aaf7765e1ce,
    faDollyFlatbed: $d8206b3ab2e65c05$export$f7c6efb60c53b285,
    faBanSmoking: $d8206b3ab2e65c05$export$130df7ed74437774,
    faSmokingBan: $d8206b3ab2e65c05$export$e50452a49dec29f,
    faTerminal: $d8206b3ab2e65c05$export$5e63e8b85b5f119c,
    faMobileButton: $d8206b3ab2e65c05$export$c93d62849efbdd11,
    faHouseMedicalFlag: $d8206b3ab2e65c05$export$86c50f517be57a40,
    faBasketShopping: $d8206b3ab2e65c05$export$1d307c13b511e8e1,
    faShoppingBasket: $d8206b3ab2e65c05$export$ca6d443595a6578f,
    faTape: $d8206b3ab2e65c05$export$b88ed5e1e0eac4c6,
    faBusSimple: $d8206b3ab2e65c05$export$d3724faf0c559353,
    faBusAlt: $d8206b3ab2e65c05$export$40616edfab6d332a,
    faEye: $d8206b3ab2e65c05$export$b8c3e79e8c99c95b,
    faFaceSadCry: $d8206b3ab2e65c05$export$e8ea88c55e55be7c,
    faSadCry: $d8206b3ab2e65c05$export$8e924e6bd422cef9,
    faAudioDescription: $d8206b3ab2e65c05$export$b6b464c98c009494,
    faPersonMilitaryToPerson: $d8206b3ab2e65c05$export$41b1e14a6b0fe11b,
    faFileShield: $d8206b3ab2e65c05$export$348a01df65a66c99,
    faUserSlash: $d8206b3ab2e65c05$export$3924ab4d3ef9b5ef,
    faPen: $d8206b3ab2e65c05$export$8f4567331fb0d3bc,
    faTowerObservation: $d8206b3ab2e65c05$export$5b2f0f631f559d51,
    faFileCode: $d8206b3ab2e65c05$export$143d0ca7d2200f20,
    faSignal: $d8206b3ab2e65c05$export$79046b073b6c584d,
    faSignal5: $d8206b3ab2e65c05$export$3417071118065933,
    faSignalPerfect: $d8206b3ab2e65c05$export$1aea50ab3e99cc95,
    faBus: $d8206b3ab2e65c05$export$ce69441578ff2fdb,
    faHeartCircleXmark: $d8206b3ab2e65c05$export$742f89ae2f8d6b20,
    faHouseChimney: $d8206b3ab2e65c05$export$af554427144a7e5c,
    faHomeLg: $d8206b3ab2e65c05$export$dbab81727ec94698,
    faWindowMaximize: $d8206b3ab2e65c05$export$703cd98be31ec905,
    faFaceFrown: $d8206b3ab2e65c05$export$e5f78e87efbb0248,
    faFrown: $d8206b3ab2e65c05$export$43b7108508aecc5f,
    faPrescription: $d8206b3ab2e65c05$export$8767bafb19515ee4,
    faShop: $d8206b3ab2e65c05$export$78edc9b98453b6f7,
    faStoreAlt: $d8206b3ab2e65c05$export$1f1871dab9cec9d8,
    faFloppyDisk: $d8206b3ab2e65c05$export$f62f2879ccaea13f,
    faSave: $d8206b3ab2e65c05$export$1aaa83ff70706e1e,
    faVihara: $d8206b3ab2e65c05$export$ee4b92e89fe0dfaf,
    faScaleUnbalanced: $d8206b3ab2e65c05$export$4d10bcc8d068f454,
    faBalanceScaleLeft: $d8206b3ab2e65c05$export$786cb0c775487f19,
    faSortUp: $d8206b3ab2e65c05$export$f9dd5b1410e95035,
    faSortAsc: $d8206b3ab2e65c05$export$e4c8c924b1cc43a7,
    faCommentDots: $d8206b3ab2e65c05$export$63ffcb3d4e94cb92,
    faCommenting: $d8206b3ab2e65c05$export$49ee382a2425e89c,
    faPlantWilt: $d8206b3ab2e65c05$export$77a38850ff8b0407,
    faDiamond: $d8206b3ab2e65c05$export$f214f827e0023247,
    faFaceGrinSquint: $d8206b3ab2e65c05$export$5d53da7627754bc6,
    faGrinSquint: $d8206b3ab2e65c05$export$243ae757907b1580,
    faHandHoldingDollar: $d8206b3ab2e65c05$export$61a67f5f8ab39be,
    faHandHoldingUsd: $d8206b3ab2e65c05$export$47d27bc305b59690,
    faBacterium: $d8206b3ab2e65c05$export$b0babe4230e35ebe,
    faHandPointer: $d8206b3ab2e65c05$export$d97ff927c450c87f,
    faDrumSteelpan: $d8206b3ab2e65c05$export$48d1206500db2e9d,
    faHandScissors: $d8206b3ab2e65c05$export$c578e919f2c5c135,
    faHandsPraying: $d8206b3ab2e65c05$export$a96374faedb12593,
    faPrayingHands: $d8206b3ab2e65c05$export$95e08e91b0929943,
    faArrowRotateRight: $d8206b3ab2e65c05$export$9c58ddc4b3356f98,
    faArrowRightRotate: $d8206b3ab2e65c05$export$ffa1245982c1b28b,
    faArrowRotateForward: $d8206b3ab2e65c05$export$89c59b5f47067f4c,
    faRedo: $d8206b3ab2e65c05$export$3d9f98aa1c24c776,
    faBiohazard: $d8206b3ab2e65c05$export$ae3a453550dec95,
    faLocationCrosshairs: $d8206b3ab2e65c05$export$14e1096ad1719098,
    faLocation: $d8206b3ab2e65c05$export$45e012c32174eb5d,
    faMarsDouble: $d8206b3ab2e65c05$export$2f8a28204bb4b86f,
    faChildDress: $d8206b3ab2e65c05$export$f31a37ecbfd4e707,
    faUsersBetweenLines: $d8206b3ab2e65c05$export$6ea1decf8bb3513d,
    faLungsVirus: $d8206b3ab2e65c05$export$895159d10626af74,
    faFaceGrinTears: $d8206b3ab2e65c05$export$8ac6d81a3d5b40a1,
    faGrinTears: $d8206b3ab2e65c05$export$b2f7512221512b5b,
    faPhone: $d8206b3ab2e65c05$export$ddab067855cf34cb,
    faCalendarXmark: $d8206b3ab2e65c05$export$3c70ffe5660af060,
    faCalendarTimes: $d8206b3ab2e65c05$export$99b20d7352fbcf08,
    faChildReaching: $d8206b3ab2e65c05$export$84a2f9476730c40e,
    faHeadSideVirus: $d8206b3ab2e65c05$export$5b64b916710da7c7,
    faUserGear: $d8206b3ab2e65c05$export$f504a6909b677146,
    faUserCog: $d8206b3ab2e65c05$export$474108c2b86e730e,
    faArrowUp19: $d8206b3ab2e65c05$export$bbbff45e04f4abab,
    faSortNumericUp: $d8206b3ab2e65c05$export$d213a3ba3cabed48,
    faDoorClosed: $d8206b3ab2e65c05$export$2c79e1a422528bba,
    faShieldVirus: $d8206b3ab2e65c05$export$bea811bbf570f05a,
    faDiceSix: $d8206b3ab2e65c05$export$3397c7b4679acccc,
    faMosquitoNet: $d8206b3ab2e65c05$export$f3858ce1b3218e2,
    faBridgeWater: $d8206b3ab2e65c05$export$154e99cb34841765,
    faPersonBooth: $d8206b3ab2e65c05$export$2337c975289bdd84,
    faTextWidth: $d8206b3ab2e65c05$export$d8724cf433389700,
    faHatWizard: $d8206b3ab2e65c05$export$7daa48199dcb2ad1,
    faPenFancy: $d8206b3ab2e65c05$export$8bdfe14ac72a8b17,
    faPersonDigging: $d8206b3ab2e65c05$export$f4d483fca19a4604,
    faDigging: $d8206b3ab2e65c05$export$7bd93e3343bd5671,
    faTrash: $d8206b3ab2e65c05$export$ed8c149a0ea54bb4,
    faGaugeSimple: $d8206b3ab2e65c05$export$f3a0a4e6723a86d4,
    faGaugeSimpleMed: $d8206b3ab2e65c05$export$ba8c12ff7cfa2521,
    faTachometerAverage: $d8206b3ab2e65c05$export$94fcfd6f6335431b,
    faBookMedical: $d8206b3ab2e65c05$export$6feb44fec53ba30d,
    faPoo: $d8206b3ab2e65c05$export$dd0ede1713d2d2f9,
    faQuoteRight: $d8206b3ab2e65c05$export$54e3a80c9875b74c,
    faQuoteRightAlt: $d8206b3ab2e65c05$export$dd692f2e88bd4b1a,
    faShirt: $d8206b3ab2e65c05$export$312f2c01c6fedca8,
    faTShirt: $d8206b3ab2e65c05$export$144e5f8bc4d705a6,
    faTshirt: $d8206b3ab2e65c05$export$36edce3ba87c2b17,
    faCubes: $d8206b3ab2e65c05$export$30523a9441a31e97,
    faDivide: $d8206b3ab2e65c05$export$89fa217ec5503ac9,
    faTengeSign: $d8206b3ab2e65c05$export$c04e864469c1d117,
    faTenge: $d8206b3ab2e65c05$export$af6ebee83047b793,
    faHeadphones: $d8206b3ab2e65c05$export$ad02dd8ca5816958,
    faHandsHolding: $d8206b3ab2e65c05$export$96891bbcda1dbb7b,
    faHandsClapping: $d8206b3ab2e65c05$export$765c446e974b5e59,
    faRepublican: $d8206b3ab2e65c05$export$929518bb4b66a588,
    faArrowLeft: $d8206b3ab2e65c05$export$b7fac681e7d09400,
    faPersonCircleXmark: $d8206b3ab2e65c05$export$16c9e0374c346c6e,
    faRuler: $d8206b3ab2e65c05$export$8e90575265a56cfc,
    faAlignLeft: $d8206b3ab2e65c05$export$e490f662af4d1c78,
    faDiceD6: $d8206b3ab2e65c05$export$64bfd48ed353c031,
    faRestroom: $d8206b3ab2e65c05$export$5fbcef35138741a5,
    faJ: $d8206b3ab2e65c05$export$bbf24078bd1f73e6,
    faUsersViewfinder: $d8206b3ab2e65c05$export$72b785dcfe44c69b,
    faFileVideo: $d8206b3ab2e65c05$export$b44eb38345c6a964,
    faUpRightFromSquare: $d8206b3ab2e65c05$export$c1a3ba061b4f60c4,
    faExternalLinkAlt: $d8206b3ab2e65c05$export$d7f107e456ab0306,
    faTableCells: $d8206b3ab2e65c05$export$c517dffc18db483f,
    faTh: $d8206b3ab2e65c05$export$4d383c83efc0c819,
    faFilePdf: $d8206b3ab2e65c05$export$38611f1c776aba73,
    faBookBible: $d8206b3ab2e65c05$export$df8194b081d34b27,
    faBible: $d8206b3ab2e65c05$export$2eac809b0670d139,
    faO: $d8206b3ab2e65c05$export$9db87eabf605857e,
    faSuitcaseMedical: $d8206b3ab2e65c05$export$25ea11267429d202,
    faMedkit: $d8206b3ab2e65c05$export$e75f02bae5b7d34b,
    faUserSecret: $d8206b3ab2e65c05$export$597826232327559b,
    faOtter: $d8206b3ab2e65c05$export$743cce3ca4eb1d7d,
    faPersonDress: $d8206b3ab2e65c05$export$27f7383b96c3f4b4,
    faFemale: $d8206b3ab2e65c05$export$70e8e75e61dd7169,
    faCommentDollar: $d8206b3ab2e65c05$export$7a088030853df12c,
    faBusinessTime: $d8206b3ab2e65c05$export$694b7e88782dec12,
    faBriefcaseClock: $d8206b3ab2e65c05$export$8b00ae94743552ce,
    faTableCellsLarge: $d8206b3ab2e65c05$export$d2bcaf492dfb3817,
    faThLarge: $d8206b3ab2e65c05$export$69782f333e90cdc6,
    faBookTanakh: $d8206b3ab2e65c05$export$24c764717169f536,
    faTanakh: $d8206b3ab2e65c05$export$7fd4a58929315448,
    faPhoneVolume: $d8206b3ab2e65c05$export$c377f240bb8b5d74,
    faVolumeControlPhone: $d8206b3ab2e65c05$export$5358d004fa3d3be2,
    faHatCowboySide: $d8206b3ab2e65c05$export$ab6f71fd6878da90,
    faClipboardUser: $d8206b3ab2e65c05$export$1204f2d171424659,
    faChild: $d8206b3ab2e65c05$export$60b41e3581d1739a,
    faLiraSign: $d8206b3ab2e65c05$export$f0f37dbc60110b10,
    faSatellite: $d8206b3ab2e65c05$export$da3f1730d013e224,
    faPlaneLock: $d8206b3ab2e65c05$export$1125ac57be52258c,
    faTag: $d8206b3ab2e65c05$export$cb61f447f29887e,
    faComment: $d8206b3ab2e65c05$export$805cd88398a70581,
    faCakeCandles: $d8206b3ab2e65c05$export$e4019fe302a972e1,
    faBirthdayCake: $d8206b3ab2e65c05$export$bdcf98f725a7241a,
    faCake: $d8206b3ab2e65c05$export$707bc1c80c0177c1,
    faEnvelope: $d8206b3ab2e65c05$export$6f095630677adc,
    faAnglesUp: $d8206b3ab2e65c05$export$152ef92a4f9d80a7,
    faAngleDoubleUp: $d8206b3ab2e65c05$export$9bb51e1a2c07db7c,
    faPaperclip: $d8206b3ab2e65c05$export$4b24ca1552f410af,
    faArrowRightToCity: $d8206b3ab2e65c05$export$e201217e5046cd15,
    faRibbon: $d8206b3ab2e65c05$export$838459d11f3971df,
    faLungs: $d8206b3ab2e65c05$export$ba9b387e84727819,
    faArrowUp91: $d8206b3ab2e65c05$export$25218e5886296cb9,
    faSortNumericUpAlt: $d8206b3ab2e65c05$export$d41859f1bbb9e086,
    faLitecoinSign: $d8206b3ab2e65c05$export$4a157bd81dcd8d80,
    faBorderNone: $d8206b3ab2e65c05$export$2b488402ec335d97,
    faCircleNodes: $d8206b3ab2e65c05$export$de462dd5a18e80d4,
    faParachuteBox: $d8206b3ab2e65c05$export$ca9e3368f1d9500a,
    faIndent: $d8206b3ab2e65c05$export$318208bc30aeebcc,
    faTruckFieldUn: $d8206b3ab2e65c05$export$40cb0a4a3a74dc03,
    faHourglass: $d8206b3ab2e65c05$export$b9098a890f61e022,
    faHourglassEmpty: $d8206b3ab2e65c05$export$a2f8176a0161e891,
    faMountain: $d8206b3ab2e65c05$export$64f9eb99c9749cce,
    faUserDoctor: $d8206b3ab2e65c05$export$9884bf227eeb829,
    faUserMd: $d8206b3ab2e65c05$export$ab0d33a2c03f1794,
    faCircleInfo: $d8206b3ab2e65c05$export$317f99f46b39906e,
    faInfoCircle: $d8206b3ab2e65c05$export$aa9288aeadf882fa,
    faCloudMeatball: $d8206b3ab2e65c05$export$5d120e8b87ad33f4,
    faCamera: $d8206b3ab2e65c05$export$84ffbd7161ca2008,
    faCameraAlt: $d8206b3ab2e65c05$export$8872b5664e88e793,
    faSquareVirus: $d8206b3ab2e65c05$export$f9409a7b020dbec4,
    faMeteor: $d8206b3ab2e65c05$export$1439f0d6365138da,
    faCarOn: $d8206b3ab2e65c05$export$d901d50df5cf8d91,
    faSleigh: $d8206b3ab2e65c05$export$26a8fd1143d2d6c0,
    faArrowDown19: $d8206b3ab2e65c05$export$9a40d582bd4628fb,
    faSortNumericAsc: $d8206b3ab2e65c05$export$a4fb1aa2cdfb18d7,
    faSortNumericDown: $d8206b3ab2e65c05$export$835db7eb35b3c29b,
    faHandHoldingDroplet: $d8206b3ab2e65c05$export$b9c3f9a906f96b82,
    faHandHoldingWater: $d8206b3ab2e65c05$export$4265371b99d38b95,
    faWater: $d8206b3ab2e65c05$export$efaeddad0a6e901b,
    faCalendarCheck: $d8206b3ab2e65c05$export$5655108e1162ba45,
    faBraille: $d8206b3ab2e65c05$export$983e9c27cac7ed1c,
    faPrescriptionBottleMedical: $d8206b3ab2e65c05$export$99cfe064ff0b71c9,
    faPrescriptionBottleAlt: $d8206b3ab2e65c05$export$65d1c884b8581d1a,
    faLandmark: $d8206b3ab2e65c05$export$2bebc54c51db6505,
    faTruck: $d8206b3ab2e65c05$export$d7895f386f8bd8b8,
    faCrosshairs: $d8206b3ab2e65c05$export$721c101130c40043,
    faPersonCane: $d8206b3ab2e65c05$export$c48422e9da776c1b,
    faTent: $d8206b3ab2e65c05$export$e5075400db564e24,
    faVestPatches: $d8206b3ab2e65c05$export$750a64470c2e0f3f,
    faCheckDouble: $d8206b3ab2e65c05$export$f178c8c2ad3cc861,
    faArrowDownAZ: $d8206b3ab2e65c05$export$43b642fac7053978,
    faSortAlphaAsc: $d8206b3ab2e65c05$export$cb87697f2fa77cfc,
    faSortAlphaDown: $d8206b3ab2e65c05$export$7658045270aafde3,
    faMoneyBillWheat: $d8206b3ab2e65c05$export$6a4ef2ef77625063,
    faCookie: $d8206b3ab2e65c05$export$b3e64f5f68c6623f,
    faArrowRotateLeft: $d8206b3ab2e65c05$export$89b706873769c180,
    faArrowLeftRotate: $d8206b3ab2e65c05$export$1aea864c3e1d79b,
    faArrowRotateBack: $d8206b3ab2e65c05$export$a34701878babe5fc,
    faArrowRotateBackward: $d8206b3ab2e65c05$export$fce381d12e4535cd,
    faUndo: $d8206b3ab2e65c05$export$a5e5ba60b1dfe2b2,
    faHardDrive: $d8206b3ab2e65c05$export$4cb736b866cbb7ec,
    faHdd: $d8206b3ab2e65c05$export$62551e9c5ba7093f,
    faFaceGrinSquintTears: $d8206b3ab2e65c05$export$8ff56f5ebb8416a0,
    faGrinSquintTears: $d8206b3ab2e65c05$export$542206d6a85f3b42,
    faDumbbell: $d8206b3ab2e65c05$export$56700074cf37be5c,
    faRectangleList: $d8206b3ab2e65c05$export$1f7600fa9fdb3978,
    faListAlt: $d8206b3ab2e65c05$export$c6327a203ffc65a3,
    faTarpDroplet: $d8206b3ab2e65c05$export$1585b7c3c7109751,
    faHouseMedicalCircleCheck: $d8206b3ab2e65c05$export$5d08d08f88a96aac,
    faPersonSkiingNordic: $d8206b3ab2e65c05$export$c8cd1786449517d3,
    faSkiingNordic: $d8206b3ab2e65c05$export$6ea48260d7d09b1b,
    faCalendarPlus: $d8206b3ab2e65c05$export$16768a660ae3ca9d,
    faPlaneArrival: $d8206b3ab2e65c05$export$9b2dbe133273f284,
    faCircleLeft: $d8206b3ab2e65c05$export$5ae86b9da9cca3bd,
    faArrowAltCircleLeft: $d8206b3ab2e65c05$export$5460a5b11a24996f,
    faTrainSubway: $d8206b3ab2e65c05$export$cda326cc3bce41c,
    faSubway: $d8206b3ab2e65c05$export$4cabc8a12d4e2f9,
    faChartGantt: $d8206b3ab2e65c05$export$dce43b02b3fe0c18,
    faIndianRupeeSign: $d8206b3ab2e65c05$export$1d2b135cc5a2c852,
    faIndianRupee: $d8206b3ab2e65c05$export$be886a4def17c565,
    faInr: $d8206b3ab2e65c05$export$12c6d8b3e052490b,
    faCropSimple: $d8206b3ab2e65c05$export$c3605731beb92daf,
    faCropAlt: $d8206b3ab2e65c05$export$d932915fde4f1010,
    faMoneyBill1: $d8206b3ab2e65c05$export$a312c7d58dd44a75,
    faMoneyBillAlt: $d8206b3ab2e65c05$export$a35d573395884c3d,
    faLeftLong: $d8206b3ab2e65c05$export$1db7e2ee10d36035,
    faLongArrowAltLeft: $d8206b3ab2e65c05$export$a8b3226b2bf323d,
    faDna: $d8206b3ab2e65c05$export$c062100d54a2da00,
    faVirusSlash: $d8206b3ab2e65c05$export$c4ff5306c5470939,
    faMinus: $d8206b3ab2e65c05$export$fee0376c250cdef,
    faSubtract: $d8206b3ab2e65c05$export$f8cb2531ef1fc4a2,
    faChess: $d8206b3ab2e65c05$export$442fddbbd741c590,
    faArrowLeftLong: $d8206b3ab2e65c05$export$6e5225f0e6c0bacd,
    faLongArrowLeft: $d8206b3ab2e65c05$export$80896efc906118b4,
    faPlugCircleCheck: $d8206b3ab2e65c05$export$2bd45e99b9afa947,
    faStreetView: $d8206b3ab2e65c05$export$6aab6c3359c2554c,
    faFrancSign: $d8206b3ab2e65c05$export$acef3e5c2029d285,
    faVolumeOff: $d8206b3ab2e65c05$export$d94ba52e980ea0f1,
    faHandsAslInterpreting: $d8206b3ab2e65c05$export$bc43eb4655c78f49,
    faAmericanSignLanguageInterpreting: $d8206b3ab2e65c05$export$23a7517099ab1b86,
    faAslInterpreting: $d8206b3ab2e65c05$export$beb51abfb05a4eca,
    faHandsAmericanSignLanguageInterpreting: $d8206b3ab2e65c05$export$82846008645b0301,
    faGear: $d8206b3ab2e65c05$export$ec05accb7226d001,
    faCog: $d8206b3ab2e65c05$export$d6298bbfd1912a78,
    faDropletSlash: $d8206b3ab2e65c05$export$1d6c5a49025d720b,
    faTintSlash: $d8206b3ab2e65c05$export$5d6f0943039b898f,
    faMosque: $d8206b3ab2e65c05$export$4999586d7e1087fb,
    faMosquito: $d8206b3ab2e65c05$export$67c7a1518d0715ff,
    faStarOfDavid: $d8206b3ab2e65c05$export$f823fee3712b2601,
    faPersonMilitaryRifle: $d8206b3ab2e65c05$export$842b988dae95ccb8,
    faCartShopping: $d8206b3ab2e65c05$export$c790b41dc166ae13,
    faShoppingCart: $d8206b3ab2e65c05$export$51da406e5aa1388c,
    faVials: $d8206b3ab2e65c05$export$507e8edd7676b2e9,
    faPlugCirclePlus: $d8206b3ab2e65c05$export$f193138a7d21971c,
    faPlaceOfWorship: $d8206b3ab2e65c05$export$c5a9302c8c13c79a,
    faGripVertical: $d8206b3ab2e65c05$export$cacbd95c283996ec,
    faArrowTurnUp: $d8206b3ab2e65c05$export$2d3ccb9b2099f3fe,
    faLevelUp: $d8206b3ab2e65c05$export$c227d3ba1de97ceb,
    faU: $d8206b3ab2e65c05$export$4f39e8dbaf09ea8b,
    faSquareRootVariable: $d8206b3ab2e65c05$export$60b44cfa7af18422,
    faSquareRootAlt: $d8206b3ab2e65c05$export$28e4b96627e00057,
    faClock: $d8206b3ab2e65c05$export$95b9968e7fceb821,
    faClockFour: $d8206b3ab2e65c05$export$9a575facf1cab48f,
    faBackwardStep: $d8206b3ab2e65c05$export$5d2b6a700940df16,
    faStepBackward: $d8206b3ab2e65c05$export$2884e379aed297d4,
    faPallet: $d8206b3ab2e65c05$export$d7ff2047dbc34562,
    faFaucet: $d8206b3ab2e65c05$export$a0856b225f3b0614,
    faBaseballBatBall: $d8206b3ab2e65c05$export$59669f486ab41d86,
    faS: $d8206b3ab2e65c05$export$cb39585371b75720,
    faTimeline: $d8206b3ab2e65c05$export$5e239d90ef904a84,
    faKeyboard: $d8206b3ab2e65c05$export$fb61df5d98785fa8,
    faCaretDown: $d8206b3ab2e65c05$export$f9395ef707603e40,
    faHouseChimneyMedical: $d8206b3ab2e65c05$export$9c73560282dceccd,
    faClinicMedical: $d8206b3ab2e65c05$export$20d8a680febc7434,
    faTemperatureThreeQuarters: $d8206b3ab2e65c05$export$7ed2bad15ae6237f,
    faTemperature3: $d8206b3ab2e65c05$export$89def3268ed9b4bc,
    faThermometer3: $d8206b3ab2e65c05$export$2f653125f4e6463,
    faThermometerThreeQuarters: $d8206b3ab2e65c05$export$6c632d1dc30d4a77,
    faMobileScreen: $d8206b3ab2e65c05$export$8867e7da34bb8bf4,
    faMobileAndroidAlt: $d8206b3ab2e65c05$export$cb39d7b468ba5838,
    faPlaneUp: $d8206b3ab2e65c05$export$a5f2976a01fdc970,
    faPiggyBank: $d8206b3ab2e65c05$export$46d49a6734c4872a,
    faBatteryHalf: $d8206b3ab2e65c05$export$e6dadc1155c4ee48,
    faBattery3: $d8206b3ab2e65c05$export$f9138caac2aedaed,
    faMountainCity: $d8206b3ab2e65c05$export$28f06bbf9c17c3af,
    faCoins: $d8206b3ab2e65c05$export$bc5da164799a0e,
    faKhanda: $d8206b3ab2e65c05$export$8d41d1f1ba3f9217,
    faSliders: $d8206b3ab2e65c05$export$ea6970ed5a15feb6,
    faSlidersH: $d8206b3ab2e65c05$export$94d4dcb523f95563,
    faFolderTree: $d8206b3ab2e65c05$export$54d16fa2e445d3fe,
    faNetworkWired: $d8206b3ab2e65c05$export$882cabd11f4943b8,
    faMapPin: $d8206b3ab2e65c05$export$184725965b3402dc,
    faHamsa: $d8206b3ab2e65c05$export$38d20d399463edf9,
    faCentSign: $d8206b3ab2e65c05$export$875b6c94a4b00ea8,
    faFlask: $d8206b3ab2e65c05$export$f9b579ba06048af,
    faPersonPregnant: $d8206b3ab2e65c05$export$e7b4c26b5857fe9c,
    faWandSparkles: $d8206b3ab2e65c05$export$76cc39f249b6864e,
    faEllipsisVertical: $d8206b3ab2e65c05$export$7480721bf113be3e,
    faEllipsisV: $d8206b3ab2e65c05$export$e58494c7fcb5380,
    faTicket: $d8206b3ab2e65c05$export$3604f15924cf0b98,
    faPowerOff: $d8206b3ab2e65c05$export$a1cca9928dcf9798,
    faRightLong: $d8206b3ab2e65c05$export$b356b1dbe7d7f736,
    faLongArrowAltRight: $d8206b3ab2e65c05$export$533e1f578f74c066,
    faFlagUsa: $d8206b3ab2e65c05$export$19357abad396e723,
    faLaptopFile: $d8206b3ab2e65c05$export$e1046cf83da9b7ef,
    faTty: $d8206b3ab2e65c05$export$7c85aba0f9624b29,
    faTeletype: $d8206b3ab2e65c05$export$14bcd5c43dc736f9,
    faDiagramNext: $d8206b3ab2e65c05$export$2faddf1690e14e11,
    faPersonRifle: $d8206b3ab2e65c05$export$b16df914812cedbe,
    faHouseMedicalCircleExclamation: $d8206b3ab2e65c05$export$bc50edea6e121df5,
    faClosedCaptioning: $d8206b3ab2e65c05$export$8e047801a8603af7,
    faPersonHiking: $d8206b3ab2e65c05$export$baf9f153991b2ea,
    faHiking: $d8206b3ab2e65c05$export$b2ab0105a901499e,
    faVenusDouble: $d8206b3ab2e65c05$export$6a6f9cba7a1e5fe4,
    faImages: $d8206b3ab2e65c05$export$74f06b41ed2ca28a,
    faCalculator: $d8206b3ab2e65c05$export$693bd40950ed2c3a,
    faPeoplePulling: $d8206b3ab2e65c05$export$dace56f632fecf6f,
    faN: $d8206b3ab2e65c05$export$328a9baf0f9e3405,
    faCableCar: $d8206b3ab2e65c05$export$85cb04eaefaf2d8b,
    faTram: $d8206b3ab2e65c05$export$a7a36674c079f293,
    faCloudRain: $d8206b3ab2e65c05$export$a6c308ee087b4ded,
    faBuildingCircleXmark: $d8206b3ab2e65c05$export$c4c015418a1f24df,
    faShip: $d8206b3ab2e65c05$export$6c645741140616af,
    faArrowsDownToLine: $d8206b3ab2e65c05$export$8f2463c7b2fc6ae4,
    faDownload: $d8206b3ab2e65c05$export$8f734e51d72ca13a,
    faFaceGrin: $d8206b3ab2e65c05$export$92292137ef3cf4c8,
    faGrin: $d8206b3ab2e65c05$export$37e1f10b6de76621,
    faDeleteLeft: $d8206b3ab2e65c05$export$bbcc9e0b6022772b,
    faBackspace: $d8206b3ab2e65c05$export$e43e3f67102fc526,
    faEyeDropper: $d8206b3ab2e65c05$export$1bc3e0ad56dc9eb0,
    faEyeDropperEmpty: $d8206b3ab2e65c05$export$ef304e9b7524c1f9,
    faEyedropper: $d8206b3ab2e65c05$export$91549a375c0b6d25,
    faFileCircleCheck: $d8206b3ab2e65c05$export$8547e9f3a2ddab5b,
    faForward: $d8206b3ab2e65c05$export$a8710cdb23198d53,
    faMobile: $d8206b3ab2e65c05$export$59edacfad04cd121,
    faMobileAndroid: $d8206b3ab2e65c05$export$82f602311a698c32,
    faMobilePhone: $d8206b3ab2e65c05$export$475a9be8da747e57,
    faFaceMeh: $d8206b3ab2e65c05$export$dc130582748497c6,
    faMeh: $d8206b3ab2e65c05$export$6d2db489aaeeecd2,
    faAlignCenter: $d8206b3ab2e65c05$export$70e29dd05344623e,
    faBookSkull: $d8206b3ab2e65c05$export$a57d448e8969ce8a,
    faBookDead: $d8206b3ab2e65c05$export$b98a3f8c3941a74a,
    faIdCard: $d8206b3ab2e65c05$export$782ac893fc22249b,
    faDriversLicense: $d8206b3ab2e65c05$export$8359c70e609eff64,
    faOutdent: $d8206b3ab2e65c05$export$e21cfc4f23776bff,
    faDedent: $d8206b3ab2e65c05$export$cbffb369d9299db7,
    faHeartCircleExclamation: $d8206b3ab2e65c05$export$3772719b170306e2,
    faHouse: $d8206b3ab2e65c05$export$dcadc0d67468dfa8,
    faHome: $d8206b3ab2e65c05$export$48f10d71ec526479,
    faHomeAlt: $d8206b3ab2e65c05$export$279659c4b23dbedb,
    faHomeLgAlt: $d8206b3ab2e65c05$export$20d6d52d45f53262,
    faCalendarWeek: $d8206b3ab2e65c05$export$39be5cb4aed5a521,
    faLaptopMedical: $d8206b3ab2e65c05$export$ba2fa38f7bcc6930,
    faB: $d8206b3ab2e65c05$export$fa30fcd1e0d0d8,
    faFileMedical: $d8206b3ab2e65c05$export$56cbcd962389b090,
    faDiceOne: $d8206b3ab2e65c05$export$d91800b7be5303b0,
    faKiwiBird: $d8206b3ab2e65c05$export$d9933d91e1314d02,
    faArrowRightArrowLeft: $d8206b3ab2e65c05$export$56b6d3d7d0e67a1c,
    faExchange: $d8206b3ab2e65c05$export$1aab915ca61b734a,
    faRotateRight: $d8206b3ab2e65c05$export$7f465bf410c6eff7,
    faRedoAlt: $d8206b3ab2e65c05$export$50c037520c6cfdc1,
    faRotateForward: $d8206b3ab2e65c05$export$2507849a0fdd7f64,
    faUtensils: $d8206b3ab2e65c05$export$750d52edc1dafc7,
    faCutlery: $d8206b3ab2e65c05$export$7034e54a8036c5c8,
    faArrowUpWideShort: $d8206b3ab2e65c05$export$63f4908401ded049,
    faSortAmountUp: $d8206b3ab2e65c05$export$28ef3e933e4b5364,
    faMillSign: $d8206b3ab2e65c05$export$9b53510cf4010e4d,
    faBowlRice: $d8206b3ab2e65c05$export$86079bc65a716451,
    faSkull: $d8206b3ab2e65c05$export$138b45e2afb1dfa4,
    faTowerBroadcast: $d8206b3ab2e65c05$export$fd06ff4ce9799eb0,
    faBroadcastTower: $d8206b3ab2e65c05$export$f68b38d51f5c0ed,
    faTruckPickup: $d8206b3ab2e65c05$export$f846b848b3ba3064,
    faUpLong: $d8206b3ab2e65c05$export$5608156cc81126e7,
    faLongArrowAltUp: $d8206b3ab2e65c05$export$43c8f2a46326c55f,
    faStop: $d8206b3ab2e65c05$export$51577929c676143b,
    faCodeMerge: $d8206b3ab2e65c05$export$e151fe5abf6db993,
    faUpload: $d8206b3ab2e65c05$export$a9578350255b2b79,
    faHurricane: $d8206b3ab2e65c05$export$4cf54a379be7e59a,
    faMound: $d8206b3ab2e65c05$export$ac54ffffdb218383,
    faToiletPortable: $d8206b3ab2e65c05$export$a3a5de5f6e2513ba,
    faCompactDisc: $d8206b3ab2e65c05$export$84021631df0f831b,
    faFileArrowDown: $d8206b3ab2e65c05$export$148bcede94488555,
    faFileDownload: $d8206b3ab2e65c05$export$1013b9966d758343,
    faCaravan: $d8206b3ab2e65c05$export$afb5d0eee7c1bdb,
    faShieldCat: $d8206b3ab2e65c05$export$1639f087457d4f58,
    faBolt: $d8206b3ab2e65c05$export$6869964aa308dd31,
    faZap: $d8206b3ab2e65c05$export$d62abb82664f55ca,
    faGlassWater: $d8206b3ab2e65c05$export$b80f542550a05ea7,
    faOilWell: $d8206b3ab2e65c05$export$b69c6757012a2267,
    faVault: $d8206b3ab2e65c05$export$4689a147513594a7,
    faMars: $d8206b3ab2e65c05$export$a9f5c0b9c1e77a6f,
    faToilet: $d8206b3ab2e65c05$export$505476859b9691c0,
    faPlaneCircleXmark: $d8206b3ab2e65c05$export$94ef668f5108e431,
    faYenSign: $d8206b3ab2e65c05$export$30f1437f5a4e991d,
    faCny: $d8206b3ab2e65c05$export$268a23eee8f089a2,
    faJpy: $d8206b3ab2e65c05$export$5460a9192eb79bf5,
    faRmb: $d8206b3ab2e65c05$export$e2a8016afc962883,
    faYen: $d8206b3ab2e65c05$export$cf914b1afb9455a2,
    faRubleSign: $d8206b3ab2e65c05$export$1ae0a94c8ba4131a,
    faRouble: $d8206b3ab2e65c05$export$c5dc3d98c4d8f2a5,
    faRub: $d8206b3ab2e65c05$export$9c4d936240e1f0b1,
    faRuble: $d8206b3ab2e65c05$export$6c0cf65134387046,
    faSun: $d8206b3ab2e65c05$export$2fa35dcbc038dbe9,
    faGuitar: $d8206b3ab2e65c05$export$790dd5b32282b6fb,
    faFaceLaughWink: $d8206b3ab2e65c05$export$600a1b26b33c3d47,
    faLaughWink: $d8206b3ab2e65c05$export$77ac40095f39933e,
    faHorseHead: $d8206b3ab2e65c05$export$5bcca85203ebd1e8,
    faBoreHole: $d8206b3ab2e65c05$export$cd79eeea6201e9d4,
    faIndustry: $d8206b3ab2e65c05$export$5548c3eb51060fa8,
    faCircleDown: $d8206b3ab2e65c05$export$531badb89cf01312,
    faArrowAltCircleDown: $d8206b3ab2e65c05$export$ff3afbc8c0bc5d59,
    faArrowsTurnToDots: $d8206b3ab2e65c05$export$b9d8fdf63999a76d,
    faFlorinSign: $d8206b3ab2e65c05$export$6248ec7440b2ffcb,
    faArrowDownShortWide: $d8206b3ab2e65c05$export$a51c464b699200ae,
    faSortAmountDesc: $d8206b3ab2e65c05$export$93835bc31892b5c3,
    faSortAmountDownAlt: $d8206b3ab2e65c05$export$e7d80d8c226cb77,
    faLessThan: $d8206b3ab2e65c05$export$7f24f1bf98af5411,
    faAngleDown: $d8206b3ab2e65c05$export$4b5be0142d10f342,
    faCarTunnel: $d8206b3ab2e65c05$export$ec5cfe409de2ed37,
    faHeadSideCough: $d8206b3ab2e65c05$export$3cd04b7c1624f598,
    faGripLines: $d8206b3ab2e65c05$export$1412f35381064d7d,
    faThumbsDown: $d8206b3ab2e65c05$export$aba24ca305bbe8c1,
    faUserLock: $d8206b3ab2e65c05$export$d9b89b5872b67a4f,
    faArrowRightLong: $d8206b3ab2e65c05$export$becbc35d3541bcc,
    faLongArrowRight: $d8206b3ab2e65c05$export$7ec6527cf8651899,
    faAnchorCircleXmark: $d8206b3ab2e65c05$export$f6773af4219eebd,
    faEllipsis: $d8206b3ab2e65c05$export$37fe3659ba7b6b54,
    faEllipsisH: $d8206b3ab2e65c05$export$c9f2fedd4489a2ee,
    faChessPawn: $d8206b3ab2e65c05$export$3db75d5ac9e98468,
    faKitMedical: $d8206b3ab2e65c05$export$f04e7a0f1033a0cd,
    faFirstAid: $d8206b3ab2e65c05$export$5b01ccb2da4c4387,
    faPersonThroughWindow: $d8206b3ab2e65c05$export$a77a2f6da72f89e3,
    faToolbox: $d8206b3ab2e65c05$export$b34d64c205c732a9,
    faHandsHoldingCircle: $d8206b3ab2e65c05$export$3aa81d0e606b08b6,
    faBug: $d8206b3ab2e65c05$export$a18cfac400116d9f,
    faCreditCard: $d8206b3ab2e65c05$export$3e7437bf6535bef0,
    faCreditCardAlt: $d8206b3ab2e65c05$export$5fffe8e3c36964a2,
    faCar: $d8206b3ab2e65c05$export$9eefe7fcdf123b76,
    faAutomobile: $d8206b3ab2e65c05$export$240a6c53cf7ac525,
    faHandHoldingHand: $d8206b3ab2e65c05$export$6638511b28df3be5,
    faBookOpenReader: $d8206b3ab2e65c05$export$cb6e40528b98a5b,
    faBookReader: $d8206b3ab2e65c05$export$cee14fe33262fa7d,
    faMountainSun: $d8206b3ab2e65c05$export$af9eaee7db3ba7a9,
    faArrowsLeftRightToLine: $d8206b3ab2e65c05$export$a63cecc8a4166c49,
    faDiceD20: $d8206b3ab2e65c05$export$b06003a02c9055bd,
    faTruckDroplet: $d8206b3ab2e65c05$export$41ce20639e8fef2b,
    faFileCircleXmark: $d8206b3ab2e65c05$export$e4686afbe882e24a,
    faTemperatureArrowUp: $d8206b3ab2e65c05$export$d7a5da41ce01461d,
    faTemperatureUp: $d8206b3ab2e65c05$export$872345a0157330a3,
    faMedal: $d8206b3ab2e65c05$export$b48a5be96314835a,
    faBed: $d8206b3ab2e65c05$export$f24e0fce77994d4d,
    faSquareH: $d8206b3ab2e65c05$export$51e3c5be06a49e32,
    faHSquare: $d8206b3ab2e65c05$export$f08bbcf8f59eafc2,
    faPodcast: $d8206b3ab2e65c05$export$5c0b4709125e92f8,
    faTemperatureFull: $d8206b3ab2e65c05$export$bf4d97a79734997f,
    faTemperature4: $d8206b3ab2e65c05$export$db946f8dc50a57ca,
    faThermometer4: $d8206b3ab2e65c05$export$92b2e2293472dd50,
    faThermometerFull: $d8206b3ab2e65c05$export$74e07083cef79a6f,
    faBell: $d8206b3ab2e65c05$export$9b6162797ab1b255,
    faSuperscript: $d8206b3ab2e65c05$export$4fa56a54e822dd25,
    faPlugCircleXmark: $d8206b3ab2e65c05$export$12ef959394d63192,
    faStarOfLife: $d8206b3ab2e65c05$export$aa3c4c1c5a47bf98,
    faPhoneSlash: $d8206b3ab2e65c05$export$4c60a3aade08b6c2,
    faPaintRoller: $d8206b3ab2e65c05$export$d1de8d1b815d6a5,
    faHandshakeAngle: $d8206b3ab2e65c05$export$503f458ca5cf64c2,
    faHandsHelping: $d8206b3ab2e65c05$export$287dbb1632da0d44,
    faLocationDot: $d8206b3ab2e65c05$export$90a475e93ff4bb8a,
    faMapMarkerAlt: $d8206b3ab2e65c05$export$4be92fa780613f93,
    faFile: $d8206b3ab2e65c05$export$cad54bead856a678,
    faGreaterThan: $d8206b3ab2e65c05$export$da07b6bc24a496ca,
    faPersonSwimming: $d8206b3ab2e65c05$export$3fb4da6af843d39f,
    faSwimmer: $d8206b3ab2e65c05$export$67daf2e2f88c1365,
    faArrowDown: $d8206b3ab2e65c05$export$9686eff8d817f770,
    faDroplet: $d8206b3ab2e65c05$export$cc1b6e60cb98fb90,
    faTint: $d8206b3ab2e65c05$export$60dd975bd5938c15,
    faEraser: $d8206b3ab2e65c05$export$e7fc4fe34e767f28,
    faEarthAmericas: $d8206b3ab2e65c05$export$9c4218a898614082,
    faEarth: $d8206b3ab2e65c05$export$c2118d3775773870,
    faEarthAmerica: $d8206b3ab2e65c05$export$8b0f3a26397cf632,
    faGlobeAmericas: $d8206b3ab2e65c05$export$e96bcc7bde9498db,
    faPersonBurst: $d8206b3ab2e65c05$export$ae02241644924482,
    faDove: $d8206b3ab2e65c05$export$a1ab1e69a300089f,
    faBatteryEmpty: $d8206b3ab2e65c05$export$1344b64f6e922e12,
    faBattery0: $d8206b3ab2e65c05$export$de8d0338927394c1,
    faSocks: $d8206b3ab2e65c05$export$8d36a54dbf1e6bce,
    faInbox: $d8206b3ab2e65c05$export$366b69cbdce46334,
    faSection: $d8206b3ab2e65c05$export$a6f4f4a005d91fbd,
    faGaugeHigh: $d8206b3ab2e65c05$export$d262c1f5912046e6,
    faTachometerAlt: $d8206b3ab2e65c05$export$38dd17b9f064c10f,
    faTachometerAltFast: $d8206b3ab2e65c05$export$e99d8b85f35b8ca5,
    faEnvelopeOpenText: $d8206b3ab2e65c05$export$f5c53ce8ec380d11,
    faHospital: $d8206b3ab2e65c05$export$7a76c9d35b42d691,
    faHospitalAlt: $d8206b3ab2e65c05$export$cea7736417b94a3b,
    faHospitalWide: $d8206b3ab2e65c05$export$69c8cc0360f017e8,
    faWineBottle: $d8206b3ab2e65c05$export$770be8b3d5776043,
    faChessRook: $d8206b3ab2e65c05$export$5d65c40a109eb09c,
    faBarsStaggered: $d8206b3ab2e65c05$export$2f8a7938c06a2142,
    faReorder: $d8206b3ab2e65c05$export$75d2bb378a2fc102,
    faStream: $d8206b3ab2e65c05$export$ed81ab40fc4e904,
    faDharmachakra: $d8206b3ab2e65c05$export$45cbd92c28deb2c7,
    faHotdog: $d8206b3ab2e65c05$export$9fae219b4d3ce0be,
    faPersonWalkingWithCane: $d8206b3ab2e65c05$export$2ffee5b2bc935c1f,
    faBlind: $d8206b3ab2e65c05$export$923de21def6ea9b6,
    faDrum: $d8206b3ab2e65c05$export$5b9205e1042594b7,
    faIceCream: $d8206b3ab2e65c05$export$dd52741c60cc638f,
    faHeartCircleBolt: $d8206b3ab2e65c05$export$2a376a9d0d8fee96,
    faFax: $d8206b3ab2e65c05$export$b5698497901d7197,
    faParagraph: $d8206b3ab2e65c05$export$dec46f8df1860e0,
    faCheckToSlot: $d8206b3ab2e65c05$export$6999832247e52c2b,
    faVoteYea: $d8206b3ab2e65c05$export$e87bb3db1608b850,
    faStarHalf: $d8206b3ab2e65c05$export$228008b5e11032fa,
    faBoxesStacked: $d8206b3ab2e65c05$export$2088efcf62cf3b1,
    faBoxes: $d8206b3ab2e65c05$export$2007320dd6cde6db,
    faBoxesAlt: $d8206b3ab2e65c05$export$e6ef1d896ed63b3e,
    faLink: $d8206b3ab2e65c05$export$88bc01ff8dbecc55,
    faChain: $d8206b3ab2e65c05$export$b5d071e02a25554f,
    faEarListen: $d8206b3ab2e65c05$export$837bc776b490934d,
    faAssistiveListeningSystems: $d8206b3ab2e65c05$export$8eeef3dc0035b165,
    faTreeCity: $d8206b3ab2e65c05$export$ad95e4f80f98ebe0,
    faPlay: $d8206b3ab2e65c05$export$436587205947bca5,
    faFont: $d8206b3ab2e65c05$export$a5dc297d3f60936,
    faRupiahSign: $d8206b3ab2e65c05$export$fe44d4c71644ea0,
    faMagnifyingGlass: $d8206b3ab2e65c05$export$34c8b97060c09ff,
    faSearch: $d8206b3ab2e65c05$export$871a78837687ffe8,
    faTableTennisPaddleBall: $d8206b3ab2e65c05$export$eabe53838d45ac6a,
    faPingPongPaddleBall: $d8206b3ab2e65c05$export$ebb246c621751737,
    faTableTennis: $d8206b3ab2e65c05$export$f378fbb4e0ef7edf,
    faPersonDotsFromLine: $d8206b3ab2e65c05$export$cdcec8ca7ec0d381,
    faDiagnoses: $d8206b3ab2e65c05$export$68bad2b52a90d1fa,
    faTrashCanArrowUp: $d8206b3ab2e65c05$export$60430351cdb4ba89,
    faTrashRestoreAlt: $d8206b3ab2e65c05$export$d075b19b21cb9856,
    faNairaSign: $d8206b3ab2e65c05$export$58b7558ca9822358,
    faCartArrowDown: $d8206b3ab2e65c05$export$9206260ff0c0c616,
    faWalkieTalkie: $d8206b3ab2e65c05$export$8a322f740d64e9fc,
    faFilePen: $d8206b3ab2e65c05$export$27f34878d8ed7a76,
    faFileEdit: $d8206b3ab2e65c05$export$e343e19f1757c5ae,
    faReceipt: $d8206b3ab2e65c05$export$32b0cd6133c2742,
    faSquarePen: $d8206b3ab2e65c05$export$3643b719db23d46e,
    faPenSquare: $d8206b3ab2e65c05$export$fbb231ccb3d960bc,
    faPencilSquare: $d8206b3ab2e65c05$export$35d253ecd249e771,
    faSuitcaseRolling: $d8206b3ab2e65c05$export$957e62a9b80ff4e3,
    faPersonCircleExclamation: $d8206b3ab2e65c05$export$38c8c32017dd9cc,
    faChevronDown: $d8206b3ab2e65c05$export$8db9bc521720fccd,
    faBatteryFull: $d8206b3ab2e65c05$export$9338fc4614cfc0cf,
    faBattery: $d8206b3ab2e65c05$export$214720d39635cea8,
    faBattery5: $d8206b3ab2e65c05$export$e426617482c711a7,
    faSkullCrossbones: $d8206b3ab2e65c05$export$8717352b90217272,
    faCodeCompare: $d8206b3ab2e65c05$export$ca4c5b4dcff58860,
    faListUl: $d8206b3ab2e65c05$export$f8a219cf4f516384,
    faListDots: $d8206b3ab2e65c05$export$e6f4ba30d84fa6ea,
    faSchoolLock: $d8206b3ab2e65c05$export$8845cce2a763ee07,
    faTowerCell: $d8206b3ab2e65c05$export$f4b64c3a138c1b59,
    faDownLong: $d8206b3ab2e65c05$export$e88ba08d4f4d65b6,
    faLongArrowAltDown: $d8206b3ab2e65c05$export$8b92530ca6418c2f,
    faRankingStar: $d8206b3ab2e65c05$export$e6fd420a918b43b5,
    faChessKing: $d8206b3ab2e65c05$export$d5713874f8fefe1b,
    faPersonHarassing: $d8206b3ab2e65c05$export$dcd74f2821882a49,
    faBrazilianRealSign: $d8206b3ab2e65c05$export$9d355b4e79216962,
    faLandmarkDome: $d8206b3ab2e65c05$export$8a56136f40511e5d,
    faLandmarkAlt: $d8206b3ab2e65c05$export$8b9c180efffc50ab,
    faArrowUp: $d8206b3ab2e65c05$export$8e144ed4d52eef49,
    faTv: $d8206b3ab2e65c05$export$e0cfed4ba2fe562c,
    faTelevision: $d8206b3ab2e65c05$export$9803b0176917be28,
    faTvAlt: $d8206b3ab2e65c05$export$6aa64ad5a1974ad7,
    faShrimp: $d8206b3ab2e65c05$export$ac094c06f566cca3,
    faListCheck: $d8206b3ab2e65c05$export$350a84fd0f833f4d,
    faTasks: $d8206b3ab2e65c05$export$2f6d5b2fec286d63,
    faJugDetergent: $d8206b3ab2e65c05$export$3fe50bd8062cd141,
    faCircleUser: $d8206b3ab2e65c05$export$9a5c11a5e3d7f1e7,
    faUserCircle: $d8206b3ab2e65c05$export$be7d974e9e0dba1a,
    faUserShield: $d8206b3ab2e65c05$export$d1886bc596424e6c,
    faWind: $d8206b3ab2e65c05$export$cc58cb0f2257a6a9,
    faCarBurst: $d8206b3ab2e65c05$export$6d2be7c5d395dd16,
    faCarCrash: $d8206b3ab2e65c05$export$8ff55566398404cd,
    faY: $d8206b3ab2e65c05$export$b8c4c058fe7d193c,
    faPersonSnowboarding: $d8206b3ab2e65c05$export$22c642403aeeaeaf,
    faSnowboarding: $d8206b3ab2e65c05$export$72683772d587302a,
    faTruckFast: $d8206b3ab2e65c05$export$27de16299ddd171,
    faShippingFast: $d8206b3ab2e65c05$export$5e419f47aaeb3c05,
    faFish: $d8206b3ab2e65c05$export$24228a855c5f6812,
    faUserGraduate: $d8206b3ab2e65c05$export$10f5839059d22f7e,
    faCircleHalfStroke: $d8206b3ab2e65c05$export$625fb3848216f28c,
    faAdjust: $d8206b3ab2e65c05$export$cfa06e4b68edca2d,
    faClapperboard: $d8206b3ab2e65c05$export$add3b381ced12554,
    faCircleRadiation: $d8206b3ab2e65c05$export$55c8e3afd9f6c0b4,
    faRadiationAlt: $d8206b3ab2e65c05$export$2f048fa82bbddf6f,
    faBaseball: $d8206b3ab2e65c05$export$dc3654cf8a596fbf,
    faBaseballBall: $d8206b3ab2e65c05$export$63a3f8ceae07c7f3,
    faJetFighterUp: $d8206b3ab2e65c05$export$b024a52a4ccf5e69,
    faDiagramProject: $d8206b3ab2e65c05$export$59c351869dc27435,
    faProjectDiagram: $d8206b3ab2e65c05$export$30bf9f5b96509df1,
    faCopy: $d8206b3ab2e65c05$export$e9bd786d30cb716c,
    faVolumeXmark: $d8206b3ab2e65c05$export$28cc565c11db6f2e,
    faVolumeMute: $d8206b3ab2e65c05$export$aa8decd057dfd29b,
    faVolumeTimes: $d8206b3ab2e65c05$export$a1c7b36ba71dbeca,
    faHandSparkles: $d8206b3ab2e65c05$export$72e2d874a963de0c,
    faGrip: $d8206b3ab2e65c05$export$eb83fb404127db75,
    faGripHorizontal: $d8206b3ab2e65c05$export$4a45308d6c8decc1,
    faShareFromSquare: $d8206b3ab2e65c05$export$928280bdd54fa173,
    faShareSquare: $d8206b3ab2e65c05$export$ae9e1434571f373c,
    faChildCombatant: $d8206b3ab2e65c05$export$f7367a7301f2dc0f,
    faChildRifle: $d8206b3ab2e65c05$export$9b027cdb5db3ae5c,
    faGun: $d8206b3ab2e65c05$export$e18f576a7b31ba46,
    faSquarePhone: $d8206b3ab2e65c05$export$318ed022991eef56,
    faPhoneSquare: $d8206b3ab2e65c05$export$8ba22605a641ebdf,
    faPlus: $d8206b3ab2e65c05$export$a105e7b44ca0eb9e,
    faAdd: $d8206b3ab2e65c05$export$9e8f9a9d4ad32c0f,
    faExpand: $d8206b3ab2e65c05$export$1fe4a9976a241685,
    faComputer: $d8206b3ab2e65c05$export$9835883ce9d0fe78,
    faXmark: $d8206b3ab2e65c05$export$e6e44779b2fa1a5c,
    faClose: $d8206b3ab2e65c05$export$23c717133fd81476,
    faMultiply: $d8206b3ab2e65c05$export$4ed4ff13d4dbc862,
    faRemove: $d8206b3ab2e65c05$export$34810740c1bd6c54,
    faTimes: $d8206b3ab2e65c05$export$174bd7f477b115b4,
    faArrowsUpDownLeftRight: $d8206b3ab2e65c05$export$ff9a43e3a9cb653c,
    faArrows: $d8206b3ab2e65c05$export$d5ae09a305d70340,
    faChalkboardUser: $d8206b3ab2e65c05$export$fd7622d4b8d3674b,
    faChalkboardTeacher: $d8206b3ab2e65c05$export$443fcf69b0155291,
    faPesoSign: $d8206b3ab2e65c05$export$c8f99b9b5ea83555,
    faBuildingShield: $d8206b3ab2e65c05$export$18ba6a500873dba9,
    faBaby: $d8206b3ab2e65c05$export$8afab767536f59ad,
    faUsersLine: $d8206b3ab2e65c05$export$d7e538fddb81da68,
    faQuoteLeft: $d8206b3ab2e65c05$export$932a67a1b1a7a724,
    faQuoteLeftAlt: $d8206b3ab2e65c05$export$95bb9ad3aa35c741,
    faTractor: $d8206b3ab2e65c05$export$e87e41787bbedc98,
    faTrashArrowUp: $d8206b3ab2e65c05$export$940cea0f5451895c,
    faTrashRestore: $d8206b3ab2e65c05$export$d32f45a64ed40e8d,
    faArrowDownUpLock: $d8206b3ab2e65c05$export$fc9f7bd981c34c45,
    faLinesLeaning: $d8206b3ab2e65c05$export$4d384ffc907ddaff,
    faRulerCombined: $d8206b3ab2e65c05$export$613f406c1b5802a8,
    faCopyright: $d8206b3ab2e65c05$export$da61665fff8aebfe,
    faEquals: $d8206b3ab2e65c05$export$a7c5f5e4805fdab,
    faBlender: $d8206b3ab2e65c05$export$db34f7a6de38784f,
    faTeeth: $d8206b3ab2e65c05$export$b4619aeaf0b9d18e,
    faShekelSign: $d8206b3ab2e65c05$export$3570be7b68efb8db,
    faIls: $d8206b3ab2e65c05$export$ecadeff45b05a451,
    faShekel: $d8206b3ab2e65c05$export$27e0e10e74d98736,
    faSheqel: $d8206b3ab2e65c05$export$28b3b26a80030d4e,
    faSheqelSign: $d8206b3ab2e65c05$export$d84993fb5e8c6edd,
    faMap: $d8206b3ab2e65c05$export$fc82fb79180cd17c,
    faRocket: $d8206b3ab2e65c05$export$b24d84ed5657d89a,
    faPhotoFilm: $d8206b3ab2e65c05$export$ed36ad335b36be22,
    faPhotoVideo: $d8206b3ab2e65c05$export$739f6a6a12dfb6ed,
    faFolderMinus: $d8206b3ab2e65c05$export$758f1fb3784e4080,
    faStore: $d8206b3ab2e65c05$export$de59c2657a8ace67,
    faArrowTrendUp: $d8206b3ab2e65c05$export$cf36928a9c52e98a,
    faPlugCircleMinus: $d8206b3ab2e65c05$export$2a44d62160972254,
    faSignHanging: $d8206b3ab2e65c05$export$5c1f29f4c7cad367,
    faSign: $d8206b3ab2e65c05$export$d21d0d6c8e9e8bf9,
    faBezierCurve: $d8206b3ab2e65c05$export$a527a6267c55a54c,
    faBellSlash: $d8206b3ab2e65c05$export$6b31a1e5968b2378,
    faTablet: $d8206b3ab2e65c05$export$1c92b67c45a4b4fc,
    faTabletAndroid: $d8206b3ab2e65c05$export$5eddbb7c71278268,
    faSchoolFlag: $d8206b3ab2e65c05$export$9b263780a7312c8c,
    faFill: $d8206b3ab2e65c05$export$d3c2bcfd3b861e4a,
    faAngleUp: $d8206b3ab2e65c05$export$887340269e6d6cac,
    faDrumstickBite: $d8206b3ab2e65c05$export$482976e9a4ab10f3,
    faHollyBerry: $d8206b3ab2e65c05$export$273296afacf93991,
    faChevronLeft: $d8206b3ab2e65c05$export$75702e3e3dd44a44,
    faBacteria: $d8206b3ab2e65c05$export$7fc18cf2d526c341,
    faHandLizard: $d8206b3ab2e65c05$export$54608d0a883fea4d,
    faNotdef: $d8206b3ab2e65c05$export$3db5bca65a1be8dc,
    faDisease: $d8206b3ab2e65c05$export$c7675a37487adc45,
    faBriefcaseMedical: $d8206b3ab2e65c05$export$5000f52ca9819bf5,
    faGenderless: $d8206b3ab2e65c05$export$c093cc22e88981c2,
    faChevronRight: $d8206b3ab2e65c05$export$930de8c26eb20490,
    faRetweet: $d8206b3ab2e65c05$export$cebc76f79478e40e,
    faCarRear: $d8206b3ab2e65c05$export$ff2b8d5628da5f14,
    faCarAlt: $d8206b3ab2e65c05$export$7937ed2462a665c0,
    faPumpSoap: $d8206b3ab2e65c05$export$821aeede187f23c9,
    faVideoSlash: $d8206b3ab2e65c05$export$a714fc79f58cc9ef,
    faBatteryQuarter: $d8206b3ab2e65c05$export$acec92052ac2183,
    faBattery2: $d8206b3ab2e65c05$export$23ca8a94c555576,
    faRadio: $d8206b3ab2e65c05$export$11b26516cae2104f,
    faBabyCarriage: $d8206b3ab2e65c05$export$3b3ab4d86bad7d26,
    faCarriageBaby: $d8206b3ab2e65c05$export$9f117d92ccd36cf1,
    faTrafficLight: $d8206b3ab2e65c05$export$bf0b19daceaec9c2,
    faThermometer: $d8206b3ab2e65c05$export$f576739e9b18ea4f,
    faVrCardboard: $d8206b3ab2e65c05$export$248171cb6dad4307,
    faHandMiddleFinger: $d8206b3ab2e65c05$export$bd40d3a3a16fb147,
    faPercent: $d8206b3ab2e65c05$export$89a1764fbb7ad2cb,
    faPercentage: $d8206b3ab2e65c05$export$89333857fc063a2e,
    faTruckMoving: $d8206b3ab2e65c05$export$a06617a1a4ccea67,
    faGlassWaterDroplet: $d8206b3ab2e65c05$export$b7ae54b4078b2060,
    faDisplay: $d8206b3ab2e65c05$export$e9d85839f7751f01,
    faFaceSmile: $d8206b3ab2e65c05$export$b5023c446f10324,
    faSmile: $d8206b3ab2e65c05$export$c632b2334f0913bc,
    faThumbtack: $d8206b3ab2e65c05$export$b6314cdc01bb5c43,
    faThumbTack: $d8206b3ab2e65c05$export$b63d0c7b519a9aae,
    faTrophy: $d8206b3ab2e65c05$export$29c432d69ccf85a5,
    faPersonPraying: $d8206b3ab2e65c05$export$8ecd436ef91fc02e,
    faPray: $d8206b3ab2e65c05$export$3b32c982141cad51,
    faHammer: $d8206b3ab2e65c05$export$6310f315e1ebbca5,
    faHandPeace: $d8206b3ab2e65c05$export$e49e3cfceea441cc,
    faRotate: $d8206b3ab2e65c05$export$decde496a29c5b23,
    faSyncAlt: $d8206b3ab2e65c05$export$2ff2056be8c281e4,
    faSpinner: $d8206b3ab2e65c05$export$1025ad641edb49c2,
    faRobot: $d8206b3ab2e65c05$export$30a5bb4ad3fa716c,
    faPeace: $d8206b3ab2e65c05$export$8614cb1326eacd7a,
    faGears: $d8206b3ab2e65c05$export$4aac79b9ae3cfdb8,
    faCogs: $d8206b3ab2e65c05$export$af1575770afc9559,
    faWarehouse: $d8206b3ab2e65c05$export$e3a174a50618c208,
    faArrowUpRightDots: $d8206b3ab2e65c05$export$bc804c6ab898f610,
    faSplotch: $d8206b3ab2e65c05$export$d6f21e17ea797702,
    faFaceGrinHearts: $d8206b3ab2e65c05$export$fbb22081b65e4f33,
    faGrinHearts: $d8206b3ab2e65c05$export$c56cf0e0c3bc5ed2,
    faDiceFour: $d8206b3ab2e65c05$export$2df6451abf70a6ff,
    faSimCard: $d8206b3ab2e65c05$export$3bee83bf278fddbe,
    faTransgender: $d8206b3ab2e65c05$export$7e3f1701aa95ef01,
    faTransgenderAlt: $d8206b3ab2e65c05$export$9c36cf9334c052f,
    faMercury: $d8206b3ab2e65c05$export$e134ecd00b622a47,
    faArrowTurnDown: $d8206b3ab2e65c05$export$fd4d6cfd52703f50,
    faLevelDown: $d8206b3ab2e65c05$export$3794c07e7a666c94,
    faPersonFallingBurst: $d8206b3ab2e65c05$export$a75569baaf4a6c3a,
    faAward: $d8206b3ab2e65c05$export$f8db2747dadd48f7,
    faTicketSimple: $d8206b3ab2e65c05$export$68ddda3b30ba09f0,
    faTicketAlt: $d8206b3ab2e65c05$export$75e38ba471fd89c4,
    faBuilding: $d8206b3ab2e65c05$export$f26673f8b10c3d46,
    faAnglesLeft: $d8206b3ab2e65c05$export$2ebd565813951f81,
    faAngleDoubleLeft: $d8206b3ab2e65c05$export$21b0833b3cf929a7,
    faQrcode: $d8206b3ab2e65c05$export$fc19ca0fe15e73bc,
    faClockRotateLeft: $d8206b3ab2e65c05$export$29be1665d1b36a3b,
    faHistory: $d8206b3ab2e65c05$export$76d1986559ca7b7a,
    faFaceGrinBeamSweat: $d8206b3ab2e65c05$export$2ff38f330c834084,
    faGrinBeamSweat: $d8206b3ab2e65c05$export$14d0ccc54c5b6826,
    faFileExport: $d8206b3ab2e65c05$export$364f19abcfac1b0a,
    faArrowRightFromFile: $d8206b3ab2e65c05$export$b9c76255b38e1df1,
    faShield: $d8206b3ab2e65c05$export$8241bd5b9163ca12,
    faShieldBlank: $d8206b3ab2e65c05$export$64f54da8fbaba8ee,
    faArrowUpShortWide: $d8206b3ab2e65c05$export$be9d5060a4bc3b4b,
    faSortAmountUpAlt: $d8206b3ab2e65c05$export$6e87844b0f151b6a,
    faHouseMedical: $d8206b3ab2e65c05$export$2d077da983246a68,
    faGolfBallTee: $d8206b3ab2e65c05$export$14c9f1d85e53ae99,
    faGolfBall: $d8206b3ab2e65c05$export$2251487a9a33c682,
    faCircleChevronLeft: $d8206b3ab2e65c05$export$f2b13ad44c03c40f,
    faChevronCircleLeft: $d8206b3ab2e65c05$export$4a42c8c2451a33fd,
    faHouseChimneyWindow: $d8206b3ab2e65c05$export$792391babe46862d,
    faPenNib: $d8206b3ab2e65c05$export$a82594dcc75a49f5,
    faTentArrowTurnLeft: $d8206b3ab2e65c05$export$89af87b7d6c15adf,
    faTents: $d8206b3ab2e65c05$export$c93b950e845a4ee7,
    faWandMagic: $d8206b3ab2e65c05$export$8282f5f5dcf6b009,
    faMagic: $d8206b3ab2e65c05$export$e58f9b502d4dd52d,
    faDog: $d8206b3ab2e65c05$export$c6406747800cf702,
    faCarrot: $d8206b3ab2e65c05$export$28e93ec9f5e2ddf3,
    faMoon: $d8206b3ab2e65c05$export$c4c2f69a53bab720,
    faWineGlassEmpty: $d8206b3ab2e65c05$export$b86d7336e68a3f57,
    faWineGlassAlt: $d8206b3ab2e65c05$export$b8ff3fe2b78aef2f,
    faCheese: $d8206b3ab2e65c05$export$549b99473b7201e6,
    faYinYang: $d8206b3ab2e65c05$export$6ec1acbf3f610b8f,
    faMusic: $d8206b3ab2e65c05$export$fcb0647a5340b5b8,
    faCodeCommit: $d8206b3ab2e65c05$export$d5d870c10bc9f1ce,
    faTemperatureLow: $d8206b3ab2e65c05$export$9e9af12b90a1abd2,
    faPersonBiking: $d8206b3ab2e65c05$export$cf152282d5de300d,
    faBiking: $d8206b3ab2e65c05$export$a5bcf835dbf9c0b,
    faBroom: $d8206b3ab2e65c05$export$2a533051418ff4ca,
    faShieldHeart: $d8206b3ab2e65c05$export$7b96388ca2be471b,
    faGopuram: $d8206b3ab2e65c05$export$31f89d8ac1d14ed6,
    faEarthOceania: $d8206b3ab2e65c05$export$bd931e906edf2f47,
    faGlobeOceania: $d8206b3ab2e65c05$export$8ac3f5271448657d,
    faSquareXmark: $d8206b3ab2e65c05$export$5a17e58bb7afb1d7,
    faTimesSquare: $d8206b3ab2e65c05$export$c0248ac97142ea2a,
    faXmarkSquare: $d8206b3ab2e65c05$export$9a364781d6b7602b,
    faHashtag: $d8206b3ab2e65c05$export$c92c903bade56844,
    faUpRightAndDownLeftFromCenter: $d8206b3ab2e65c05$export$95457ede07b81517,
    faExpandAlt: $d8206b3ab2e65c05$export$bcb8d86a3a1d6eb6,
    faOilCan: $d8206b3ab2e65c05$export$2599126c3a57f727,
    faT: $d8206b3ab2e65c05$export$6e625d2e7790c860,
    faHippo: $d8206b3ab2e65c05$export$d4c909619093de2d,
    faChartColumn: $d8206b3ab2e65c05$export$d01ddcc9efe7b149,
    faInfinity: $d8206b3ab2e65c05$export$a590003279d671b8,
    faVialCircleCheck: $d8206b3ab2e65c05$export$2db4f9712313eafa,
    faPersonArrowDownToLine: $d8206b3ab2e65c05$export$f9a5161975928326,
    faVoicemail: $d8206b3ab2e65c05$export$4f1ce88b2b4cd5cd,
    faFan: $d8206b3ab2e65c05$export$55145a3dae4f984a,
    faPersonWalkingLuggage: $d8206b3ab2e65c05$export$1ae0a37b36ace746,
    faUpDown: $d8206b3ab2e65c05$export$e36c32dd5cba9b90,
    faArrowsAltV: $d8206b3ab2e65c05$export$138cb56a3f8f7040,
    faCloudMoonRain: $d8206b3ab2e65c05$export$301c3fab0c4545bd,
    faCalendar: $d8206b3ab2e65c05$export$34f5c36a3e80efa2,
    faTrailer: $d8206b3ab2e65c05$export$3a48b9820e92f5ab,
    faBahai: $d8206b3ab2e65c05$export$6d636565b3ec36b4,
    faHaykal: $d8206b3ab2e65c05$export$5c15e34e0e43f15c,
    faSdCard: $d8206b3ab2e65c05$export$303efb6031da122,
    faDragon: $d8206b3ab2e65c05$export$ae1875ba975aa0e9,
    faShoePrints: $d8206b3ab2e65c05$export$cdbdd2118099ae07,
    faCirclePlus: $d8206b3ab2e65c05$export$eeda28b8ca4cb18e,
    faPlusCircle: $d8206b3ab2e65c05$export$d9cc3a81499af48c,
    faFaceGrinTongueWink: $d8206b3ab2e65c05$export$4272e56f2429da88,
    faGrinTongueWink: $d8206b3ab2e65c05$export$58099903d50aefb3,
    faHandHolding: $d8206b3ab2e65c05$export$e6094d25274088ab,
    faPlugCircleExclamation: $d8206b3ab2e65c05$export$d893dd9509763a17,
    faLinkSlash: $d8206b3ab2e65c05$export$22965c7f4d903953,
    faChainBroken: $d8206b3ab2e65c05$export$382551e04f32620a,
    faChainSlash: $d8206b3ab2e65c05$export$12f09d657be59586,
    faUnlink: $d8206b3ab2e65c05$export$2f546f7d8ba01e18,
    faClone: $d8206b3ab2e65c05$export$76c1aa4bf9a39458,
    faPersonWalkingArrowLoopLeft: $d8206b3ab2e65c05$export$5a200e8504b7367a,
    faArrowUpZA: $d8206b3ab2e65c05$export$a0a53d8e3c68e9f1,
    faSortAlphaUpAlt: $d8206b3ab2e65c05$export$95ef20828693fb0f,
    faFireFlameCurved: $d8206b3ab2e65c05$export$769724fc1434d618,
    faFireAlt: $d8206b3ab2e65c05$export$70dc26b4926d0b1b,
    faTornado: $d8206b3ab2e65c05$export$6d274258ba4b0089,
    faFileCirclePlus: $d8206b3ab2e65c05$export$430d63b54b1d4009,
    faBookQuran: $d8206b3ab2e65c05$export$ad3212bc3fa1595b,
    faQuran: $d8206b3ab2e65c05$export$46f29ea84ed4c5f1,
    faAnchor: $d8206b3ab2e65c05$export$12a35719f889cd1,
    faBorderAll: $d8206b3ab2e65c05$export$93a5eb721c9c0d25,
    faFaceAngry: $d8206b3ab2e65c05$export$67a047c738fb34da,
    faAngry: $d8206b3ab2e65c05$export$3c96c08e234498c5,
    faCookieBite: $d8206b3ab2e65c05$export$317dde8664f7de71,
    faArrowTrendDown: $d8206b3ab2e65c05$export$d2caed5e37174c23,
    faRss: $d8206b3ab2e65c05$export$7329a1ca27b90c5b,
    faFeed: $d8206b3ab2e65c05$export$67ad3d0233cd7b33,
    faDrawPolygon: $d8206b3ab2e65c05$export$df9bd3777d1154d2,
    faScaleBalanced: $d8206b3ab2e65c05$export$33fb4280dc20f0dd,
    faBalanceScale: $d8206b3ab2e65c05$export$fec323dcfd81d750,
    faGaugeSimpleHigh: $d8206b3ab2e65c05$export$cc4351eb13da27d8,
    faTachometer: $d8206b3ab2e65c05$export$362d0f652c3fbca2,
    faTachometerFast: $d8206b3ab2e65c05$export$375b6a8680f980ed,
    faShower: $d8206b3ab2e65c05$export$f7f7c15f18cc19a1,
    faDesktop: $d8206b3ab2e65c05$export$6e6ddc253102e596,
    faDesktopAlt: $d8206b3ab2e65c05$export$ff09a62b9e0fa899,
    faM: $d8206b3ab2e65c05$export$bd6a7788954842b5,
    faTableList: $d8206b3ab2e65c05$export$6e989c3c7050dbb,
    faThList: $d8206b3ab2e65c05$export$daf2614a457122c0,
    faCommentSms: $d8206b3ab2e65c05$export$435fe17e9d6170d6,
    faSms: $d8206b3ab2e65c05$export$9dbcc3443daa7323,
    faBook: $d8206b3ab2e65c05$export$c9d7ef726d1a8742,
    faUserPlus: $d8206b3ab2e65c05$export$4c17261776a709f2,
    faCheck: $d8206b3ab2e65c05$export$62b2c752fccc6a9c,
    faBatteryThreeQuarters: $d8206b3ab2e65c05$export$cfb37069d38f379e,
    faBattery4: $d8206b3ab2e65c05$export$35ffefed200d123c,
    faHouseCircleCheck: $d8206b3ab2e65c05$export$c9382fa3394ef53a,
    faAngleLeft: $d8206b3ab2e65c05$export$3cbcd1b7e35945d2,
    faDiagramSuccessor: $d8206b3ab2e65c05$export$ff7f40159cadb0ac,
    faTruckArrowRight: $d8206b3ab2e65c05$export$d69fa2b7839ce76,
    faArrowsSplitUpAndLeft: $d8206b3ab2e65c05$export$7df274119d2469d1,
    faHandFist: $d8206b3ab2e65c05$export$ca492f58fe30a42f,
    faFistRaised: $d8206b3ab2e65c05$export$fa0323a4d7489a8d,
    faCloudMoon: $d8206b3ab2e65c05$export$482eb125aaf0fbc2,
    faBriefcase: $d8206b3ab2e65c05$export$8da450d063b0eb37,
    faPersonFalling: $d8206b3ab2e65c05$export$e94ab3a30cf4aca5,
    faImagePortrait: $d8206b3ab2e65c05$export$c23fd8b91a7ed48,
    faPortrait: $d8206b3ab2e65c05$export$e3d25f819c7ee7d7,
    faUserTag: $d8206b3ab2e65c05$export$9eec597148166b36,
    faRug: $d8206b3ab2e65c05$export$7cee7480f25f5289,
    faEarthEurope: $d8206b3ab2e65c05$export$7adefae4a1be1d97,
    faGlobeEurope: $d8206b3ab2e65c05$export$5318b8ede86cc96b,
    faCartFlatbedSuitcase: $d8206b3ab2e65c05$export$ab81ff863770d996,
    faLuggageCart: $d8206b3ab2e65c05$export$bd1e24dd3cde8514,
    faRectangleXmark: $d8206b3ab2e65c05$export$3896694b3e81fba7,
    faRectangleTimes: $d8206b3ab2e65c05$export$eaaf26416a51dc1,
    faTimesRectangle: $d8206b3ab2e65c05$export$10147c0014152a3f,
    faWindowClose: $d8206b3ab2e65c05$export$18b7775f78a3e16,
    faBahtSign: $d8206b3ab2e65c05$export$ffc7123046a28ee,
    faBookOpen: $d8206b3ab2e65c05$export$8a3071811b2b7979,
    faBookJournalWhills: $d8206b3ab2e65c05$export$d3d49030d557a09b,
    faJournalWhills: $d8206b3ab2e65c05$export$66a0d8d45aab6631,
    faHandcuffs: $d8206b3ab2e65c05$export$74d1f89b5feb9d42,
    faTriangleExclamation: $d8206b3ab2e65c05$export$1cbf6e649ce86166,
    faExclamationTriangle: $d8206b3ab2e65c05$export$3d249b63b52cce7c,
    faWarning: $d8206b3ab2e65c05$export$2e470a35c38b096a,
    faDatabase: $d8206b3ab2e65c05$export$24680dede86b1883,
    faShare: $d8206b3ab2e65c05$export$c08b4b0e2b0dc027,
    faMailForward: $d8206b3ab2e65c05$export$81df7693d3f2f8da,
    faBottleDroplet: $d8206b3ab2e65c05$export$8f534e1e0ab75bfe,
    faMaskFace: $d8206b3ab2e65c05$export$140d4da0adbaf435,
    faHillRockslide: $d8206b3ab2e65c05$export$7ec15a32285f6c22,
    faRightLeft: $d8206b3ab2e65c05$export$a082af56be9786ae,
    faExchangeAlt: $d8206b3ab2e65c05$export$f6c6fb20d374b128,
    faPaperPlane: $d8206b3ab2e65c05$export$b5378818301da1be,
    faRoadCircleExclamation: $d8206b3ab2e65c05$export$79753c2153535b01,
    faDungeon: $d8206b3ab2e65c05$export$1156dc6acb0058bd,
    faAlignRight: $d8206b3ab2e65c05$export$7370f36a39a38737,
    faMoneyBill1Wave: $d8206b3ab2e65c05$export$52e3e96cd1564779,
    faMoneyBillWaveAlt: $d8206b3ab2e65c05$export$1613858e873cbb3e,
    faLifeRing: $d8206b3ab2e65c05$export$53dd2cacf674142a,
    faHands: $d8206b3ab2e65c05$export$f9712d0cf5150f0c,
    faSignLanguage: $d8206b3ab2e65c05$export$20993813350f9671,
    faSigning: $d8206b3ab2e65c05$export$5cc0e6f5191f4f02,
    faCalendarDay: $d8206b3ab2e65c05$export$80968bcfef6481ca,
    faWaterLadder: $d8206b3ab2e65c05$export$5930e9bdfd790d77,
    faLadderWater: $d8206b3ab2e65c05$export$c5ea6eeef2db2b3b,
    faSwimmingPool: $d8206b3ab2e65c05$export$4dee691631c67d5c,
    faArrowsUpDown: $d8206b3ab2e65c05$export$64185f27d82c259f,
    faArrowsV: $d8206b3ab2e65c05$export$cec5f1bc9e068e48,
    faFaceGrimace: $d8206b3ab2e65c05$export$bd5bd2ef56b793b1,
    faGrimace: $d8206b3ab2e65c05$export$3d08cd36ac1ef231,
    faWheelchairMove: $d8206b3ab2e65c05$export$1482162f7fe04ac,
    faWheelchairAlt: $d8206b3ab2e65c05$export$7db9460785019040,
    faTurnDown: $d8206b3ab2e65c05$export$b5dc9dd0347bbb6,
    faLevelDownAlt: $d8206b3ab2e65c05$export$c07eb6ff5a382cbd,
    faPersonWalkingArrowRight: $d8206b3ab2e65c05$export$3e15790fe68c095b,
    faSquareEnvelope: $d8206b3ab2e65c05$export$15da4ef8c0fb20d6,
    faEnvelopeSquare: $d8206b3ab2e65c05$export$354e159473e73552,
    faDice: $d8206b3ab2e65c05$export$4ed8206e6619cc8f,
    faBowlingBall: $d8206b3ab2e65c05$export$5ee2640fe105312d,
    faBrain: $d8206b3ab2e65c05$export$97fa4f4c1006ab1,
    faBandage: $d8206b3ab2e65c05$export$658a137d3845bca7,
    faBandAid: $d8206b3ab2e65c05$export$b14a1014df2fdf46,
    faCalendarMinus: $d8206b3ab2e65c05$export$23e8b4955c2d951b,
    faCircleXmark: $d8206b3ab2e65c05$export$30262489773a79a3,
    faTimesCircle: $d8206b3ab2e65c05$export$ab0ec50720a747eb,
    faXmarkCircle: $d8206b3ab2e65c05$export$90ac4096df8efdee,
    faGifts: $d8206b3ab2e65c05$export$de9a67b55dbe819a,
    faHotel: $d8206b3ab2e65c05$export$c402efcf01d5ca07,
    faEarthAsia: $d8206b3ab2e65c05$export$807cdd395fe012cb,
    faGlobeAsia: $d8206b3ab2e65c05$export$796fdfc909e603f4,
    faIdCardClip: $d8206b3ab2e65c05$export$31e6961064ddac7b,
    faIdCardAlt: $d8206b3ab2e65c05$export$dc37ebbac31f6c6c,
    faMagnifyingGlassPlus: $d8206b3ab2e65c05$export$f48a3ba52a0a9e56,
    faSearchPlus: $d8206b3ab2e65c05$export$378f00e6b1a8185,
    faThumbsUp: $d8206b3ab2e65c05$export$47e4e0d519d33497,
    faUserClock: $d8206b3ab2e65c05$export$b00596a09aa07311,
    faHandDots: $d8206b3ab2e65c05$export$8846d49caaed1c0a,
    faAllergies: $d8206b3ab2e65c05$export$dcae2101babbffff,
    faFileInvoice: $d8206b3ab2e65c05$export$bef39294aed2281a,
    faWindowMinimize: $d8206b3ab2e65c05$export$26a3f9d2784b90d8,
    faMugSaucer: $d8206b3ab2e65c05$export$60048819854688c5,
    faCoffee: $d8206b3ab2e65c05$export$1d24a9e457278011,
    faBrush: $d8206b3ab2e65c05$export$5824ffe6f8983c83,
    faMask: $d8206b3ab2e65c05$export$7b028758c03b9655,
    faMagnifyingGlassMinus: $d8206b3ab2e65c05$export$56d810b9ab2e30bc,
    faSearchMinus: $d8206b3ab2e65c05$export$efca97eef6a7a17d,
    faRulerVertical: $d8206b3ab2e65c05$export$a6ad5df9d9f29553,
    faUserLarge: $d8206b3ab2e65c05$export$50a28538498238f,
    faUserAlt: $d8206b3ab2e65c05$export$ae9b19c2ac726cfc,
    faTrainTram: $d8206b3ab2e65c05$export$d401d4aeba21cdf3,
    faUserNurse: $d8206b3ab2e65c05$export$ab9af5aa013d2162,
    faSyringe: $d8206b3ab2e65c05$export$1aa9423ec6b1d609,
    faCloudSun: $d8206b3ab2e65c05$export$dcaadfd9c98e42a1,
    faStopwatch20: $d8206b3ab2e65c05$export$df6244b0501f2112,
    faSquareFull: $d8206b3ab2e65c05$export$7ec6541fee081990,
    faMagnet: $d8206b3ab2e65c05$export$78932e9c9abea6b7,
    faJar: $d8206b3ab2e65c05$export$53583b459a87a01,
    faNoteSticky: $d8206b3ab2e65c05$export$4a4e034527c933f5,
    faStickyNote: $d8206b3ab2e65c05$export$80889adc5d98bf4a,
    faBugSlash: $d8206b3ab2e65c05$export$fc4dd5feed8df23,
    faArrowUpFromWaterPump: $d8206b3ab2e65c05$export$1a093e7861c5e48f,
    faBone: $d8206b3ab2e65c05$export$5902c007d5703f2d,
    faUserInjured: $d8206b3ab2e65c05$export$c950c1ba7f227d5b,
    faFaceSadTear: $d8206b3ab2e65c05$export$8a5a0dbb2a17e253,
    faSadTear: $d8206b3ab2e65c05$export$4b5241926f692f91,
    faPlane: $d8206b3ab2e65c05$export$f654c69e66b466c0,
    faTentArrowsDown: $d8206b3ab2e65c05$export$51adfe7c9ee4f428,
    faExclamation: $d8206b3ab2e65c05$export$de6218b649cbb6a9,
    faArrowsSpin: $d8206b3ab2e65c05$export$7e05388be208e313,
    faPrint: $d8206b3ab2e65c05$export$ae64371e02ee8e56,
    faTurkishLiraSign: $d8206b3ab2e65c05$export$b458d393151b6960,
    faTry: $d8206b3ab2e65c05$export$970dda513e46c41f,
    faTurkishLira: $d8206b3ab2e65c05$export$40e66e5966827199,
    faDollarSign: $d8206b3ab2e65c05$export$fb420d3e4d8c6a18,
    faDollar: $d8206b3ab2e65c05$export$a4ffb0775547fcdf,
    faUsd: $d8206b3ab2e65c05$export$72cca07d38a28589,
    faX: $d8206b3ab2e65c05$export$476af662c0c32cbc,
    faMagnifyingGlassDollar: $d8206b3ab2e65c05$export$fa4f1ead37dc1dce,
    faSearchDollar: $d8206b3ab2e65c05$export$65b49a6767630708,
    faUsersGear: $d8206b3ab2e65c05$export$3a18218720110fc0,
    faUsersCog: $d8206b3ab2e65c05$export$5e0b06753fc69b81,
    faPersonMilitaryPointing: $d8206b3ab2e65c05$export$50b6dcaa9ec03439,
    faBuildingColumns: $d8206b3ab2e65c05$export$a411e7e26cb63d5e,
    faBank: $d8206b3ab2e65c05$export$6e379b829ea8b99,
    faInstitution: $d8206b3ab2e65c05$export$1dba320226a34c1f,
    faMuseum: $d8206b3ab2e65c05$export$9b3953adff472ad2,
    faUniversity: $d8206b3ab2e65c05$export$f2e1460ebe1a8cb0,
    faUmbrella: $d8206b3ab2e65c05$export$9ff64ffae70e08c0,
    faTrowel: $d8206b3ab2e65c05$export$12ca996a6f686fe1,
    faD: $d8206b3ab2e65c05$export$56c73b799aac2555,
    faStapler: $d8206b3ab2e65c05$export$c7e014b7e3ac3d83,
    faMasksTheater: $d8206b3ab2e65c05$export$bf5896cc1ce4d55,
    faTheaterMasks: $d8206b3ab2e65c05$export$3dbedc487b0159ac,
    faKipSign: $d8206b3ab2e65c05$export$a6df39524c41472c,
    faHandPointLeft: $d8206b3ab2e65c05$export$b276ec3dc9760d39,
    faHandshakeSimple: $d8206b3ab2e65c05$export$e8485db4dab0ab30,
    faHandshakeAlt: $d8206b3ab2e65c05$export$e9aa3c6f9f47aa1a,
    faJetFighter: $d8206b3ab2e65c05$export$2130e629ab767ab3,
    faFighterJet: $d8206b3ab2e65c05$export$102b809faf56e033,
    faSquareShareNodes: $d8206b3ab2e65c05$export$1bdb0ec5af3fea99,
    faShareAltSquare: $d8206b3ab2e65c05$export$3799c2d8fd7e493b,
    faBarcode: $d8206b3ab2e65c05$export$3825a842b5afc5aa,
    faPlusMinus: $d8206b3ab2e65c05$export$37bd38cf96417095,
    faVideo: $d8206b3ab2e65c05$export$5c6bd8729527871b,
    faVideoCamera: $d8206b3ab2e65c05$export$3a530df752193ccf,
    faGraduationCap: $d8206b3ab2e65c05$export$874e305fd7920cce,
    faMortarBoard: $d8206b3ab2e65c05$export$dd0a013bf23a9d86,
    faHandHoldingMedical: $d8206b3ab2e65c05$export$bb2a6b1b5e852300,
    faPersonCircleCheck: $d8206b3ab2e65c05$export$30294c81ac4031ca,
    faTurnUp: $d8206b3ab2e65c05$export$314f5cab62fc6968,
    faLevelUpAlt: $d8206b3ab2e65c05$export$d6f21a309b179c3d
};


function $a43d996a7aa8a839$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $a43d996a7aa8a839$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $a43d996a7aa8a839$var$ownKeys(Object(source), !0).forEach(function(key) {
            $a43d996a7aa8a839$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $a43d996a7aa8a839$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $a43d996a7aa8a839$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $a43d996a7aa8a839$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $a43d996a7aa8a839$var$_typeof(obj);
}
function $a43d996a7aa8a839$var$_wrapRegExp() {
    $a43d996a7aa8a839$var$_wrapRegExp = function(re, groups) {
        return new BabelRegExp(re, void 0, groups);
    };
    var _super = RegExp.prototype, _groups = new WeakMap();
    function BabelRegExp(re, flags, groups) {
        var _this = new RegExp(re, flags);
        return _groups.set(_this, groups || _groups.get(re)), $a43d996a7aa8a839$var$_setPrototypeOf(_this, BabelRegExp.prototype);
    }
    function buildGroups(result, re) {
        var g = _groups.get(re);
        return Object.keys(g).reduce(function(groups, name) {
            return groups[name] = result[g[name]], groups;
        }, Object.create(null));
    }
    return $a43d996a7aa8a839$var$_inherits(BabelRegExp, RegExp), BabelRegExp.prototype.exec = function(str) {
        var result = _super.exec.call(this, str);
        return result && (result.groups = buildGroups(result, this)), result;
    }, BabelRegExp.prototype[Symbol.replace] = function(str, substitution) {
        if ("string" == typeof substitution) {
            var groups = _groups.get(this);
            return _super[Symbol.replace].call(this, str, substitution.replace(/\$<([^>]+)>/g, function(_, name) {
                return "$" + groups[name];
            }));
        }
        if ("function" == typeof substitution) {
            var _this = this;
            return _super[Symbol.replace].call(this, str, function() {
                var args = arguments;
                return "object" != typeof args[args.length - 1] && (args = [].slice.call(args)).push(buildGroups(args, _this)), substitution.apply(this, args);
            });
        }
        return _super[Symbol.replace].call(this, str, substitution);
    }, $a43d996a7aa8a839$var$_wrapRegExp.apply(this, arguments);
}
function $a43d996a7aa8a839$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $a43d996a7aa8a839$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $a43d996a7aa8a839$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $a43d996a7aa8a839$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $a43d996a7aa8a839$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $a43d996a7aa8a839$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $a43d996a7aa8a839$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $a43d996a7aa8a839$var$_setPrototypeOf(subClass, superClass);
}
function $a43d996a7aa8a839$var$_setPrototypeOf(o, p) {
    $a43d996a7aa8a839$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $a43d996a7aa8a839$var$_setPrototypeOf(o, p);
}
function $a43d996a7aa8a839$var$_slicedToArray(arr, i) {
    return $a43d996a7aa8a839$var$_arrayWithHoles(arr) || $a43d996a7aa8a839$var$_iterableToArrayLimit(arr, i) || $a43d996a7aa8a839$var$_unsupportedIterableToArray(arr, i) || $a43d996a7aa8a839$var$_nonIterableRest();
}
function $a43d996a7aa8a839$var$_toConsumableArray(arr) {
    return $a43d996a7aa8a839$var$_arrayWithoutHoles(arr) || $a43d996a7aa8a839$var$_iterableToArray(arr) || $a43d996a7aa8a839$var$_unsupportedIterableToArray(arr) || $a43d996a7aa8a839$var$_nonIterableSpread();
}
function $a43d996a7aa8a839$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $a43d996a7aa8a839$var$_arrayLikeToArray(arr);
}
function $a43d996a7aa8a839$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $a43d996a7aa8a839$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $a43d996a7aa8a839$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $a43d996a7aa8a839$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $a43d996a7aa8a839$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $a43d996a7aa8a839$var$_arrayLikeToArray(o, minLen);
}
function $a43d996a7aa8a839$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $a43d996a7aa8a839$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $a43d996a7aa8a839$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
var $a43d996a7aa8a839$var$noop = function noop() {};
var $a43d996a7aa8a839$var$_WINDOW = {};
var $a43d996a7aa8a839$var$_DOCUMENT = {};
var $a43d996a7aa8a839$var$_MUTATION_OBSERVER = null;
var $a43d996a7aa8a839$var$_PERFORMANCE = {
    mark: $a43d996a7aa8a839$var$noop,
    measure: $a43d996a7aa8a839$var$noop
};
try {
    if (typeof window !== "undefined") $a43d996a7aa8a839$var$_WINDOW = window;
    if (typeof document !== "undefined") $a43d996a7aa8a839$var$_DOCUMENT = document;
    if (typeof MutationObserver !== "undefined") $a43d996a7aa8a839$var$_MUTATION_OBSERVER = MutationObserver;
    if (typeof performance !== "undefined") $a43d996a7aa8a839$var$_PERFORMANCE = performance;
} catch (e) {}
var $a43d996a7aa8a839$var$_ref = $a43d996a7aa8a839$var$_WINDOW.navigator || {}, $a43d996a7aa8a839$var$_ref$userAgent = $a43d996a7aa8a839$var$_ref.userAgent, $a43d996a7aa8a839$var$userAgent = $a43d996a7aa8a839$var$_ref$userAgent === void 0 ? "" : $a43d996a7aa8a839$var$_ref$userAgent;
var $a43d996a7aa8a839$var$WINDOW = $a43d996a7aa8a839$var$_WINDOW;
var $a43d996a7aa8a839$var$DOCUMENT = $a43d996a7aa8a839$var$_DOCUMENT;
var $a43d996a7aa8a839$var$MUTATION_OBSERVER = $a43d996a7aa8a839$var$_MUTATION_OBSERVER;
var $a43d996a7aa8a839$var$PERFORMANCE = $a43d996a7aa8a839$var$_PERFORMANCE;
var $a43d996a7aa8a839$var$IS_BROWSER = !!$a43d996a7aa8a839$var$WINDOW.document;
var $a43d996a7aa8a839$var$IS_DOM = !!$a43d996a7aa8a839$var$DOCUMENT.documentElement && !!$a43d996a7aa8a839$var$DOCUMENT.head && typeof $a43d996a7aa8a839$var$DOCUMENT.addEventListener === "function" && typeof $a43d996a7aa8a839$var$DOCUMENT.createElement === "function";
var $a43d996a7aa8a839$var$IS_IE = ~$a43d996a7aa8a839$var$userAgent.indexOf("MSIE") || ~$a43d996a7aa8a839$var$userAgent.indexOf("Trident/");
var $a43d996a7aa8a839$var$_familyProxy, $a43d996a7aa8a839$var$_familyProxy2, $a43d996a7aa8a839$var$_familyProxy3, $a43d996a7aa8a839$var$_familyProxy4, $a43d996a7aa8a839$var$_familyProxy5;
var $a43d996a7aa8a839$var$NAMESPACE_IDENTIFIER = "___FONT_AWESOME___";
var $a43d996a7aa8a839$var$UNITS_IN_GRID = 16;
var $a43d996a7aa8a839$var$DEFAULT_CSS_PREFIX = "fa";
var $a43d996a7aa8a839$var$DEFAULT_REPLACEMENT_CLASS = "svg-inline--fa";
var $a43d996a7aa8a839$var$DATA_FA_I2SVG = "data-fa-i2svg";
var $a43d996a7aa8a839$var$DATA_FA_PSEUDO_ELEMENT = "data-fa-pseudo-element";
var $a43d996a7aa8a839$var$DATA_FA_PSEUDO_ELEMENT_PENDING = "data-fa-pseudo-element-pending";
var $a43d996a7aa8a839$var$DATA_PREFIX = "data-prefix";
var $a43d996a7aa8a839$var$DATA_ICON = "data-icon";
var $a43d996a7aa8a839$var$HTML_CLASS_I2SVG_BASE_CLASS = "fontawesome-i2svg";
var $a43d996a7aa8a839$var$MUTATION_APPROACH_ASYNC = "async";
var $a43d996a7aa8a839$var$TAGNAMES_TO_SKIP_FOR_PSEUDOELEMENTS = [
    "HTML",
    "HEAD",
    "STYLE",
    "SCRIPT"
];
var $a43d996a7aa8a839$var$PRODUCTION = function() {
    try {
        return true;
    } catch (e) {
        return false;
    }
}();
var $a43d996a7aa8a839$var$FAMILY_CLASSIC = "classic";
var $a43d996a7aa8a839$var$FAMILY_SHARP = "sharp";
var $a43d996a7aa8a839$var$FAMILIES = [
    $a43d996a7aa8a839$var$FAMILY_CLASSIC,
    $a43d996a7aa8a839$var$FAMILY_SHARP
];
function $a43d996a7aa8a839$var$familyProxy(obj) {
    // Defaults to the classic family if family is not available
    return new Proxy(obj, {
        get: function get(target, prop) {
            return prop in target ? target[prop] : target[$a43d996a7aa8a839$var$FAMILY_CLASSIC];
        }
    });
}
var $a43d996a7aa8a839$var$PREFIX_TO_STYLE = $a43d996a7aa8a839$var$familyProxy(($a43d996a7aa8a839$var$_familyProxy = {}, $a43d996a7aa8a839$var$_defineProperty($a43d996a7aa8a839$var$_familyProxy, $a43d996a7aa8a839$var$FAMILY_CLASSIC, {
    "fa": "solid",
    "fas": "solid",
    "fa-solid": "solid",
    "far": "regular",
    "fa-regular": "regular",
    "fal": "light",
    "fa-light": "light",
    "fat": "thin",
    "fa-thin": "thin",
    "fad": "duotone",
    "fa-duotone": "duotone",
    "fab": "brands",
    "fa-brands": "brands",
    "fak": "kit",
    "fakd": "kit",
    "fa-kit": "kit",
    "fa-kit-duotone": "kit"
}), $a43d996a7aa8a839$var$_defineProperty($a43d996a7aa8a839$var$_familyProxy, $a43d996a7aa8a839$var$FAMILY_SHARP, {
    "fa": "solid",
    "fass": "solid",
    "fa-solid": "solid",
    "fasr": "regular",
    "fa-regular": "regular",
    "fasl": "light",
    "fa-light": "light",
    "fast": "thin",
    "fa-thin": "thin"
}), $a43d996a7aa8a839$var$_familyProxy));
var $a43d996a7aa8a839$var$STYLE_TO_PREFIX = $a43d996a7aa8a839$var$familyProxy(($a43d996a7aa8a839$var$_familyProxy2 = {}, $a43d996a7aa8a839$var$_defineProperty($a43d996a7aa8a839$var$_familyProxy2, $a43d996a7aa8a839$var$FAMILY_CLASSIC, {
    solid: "fas",
    regular: "far",
    light: "fal",
    thin: "fat",
    duotone: "fad",
    brands: "fab",
    kit: "fak"
}), $a43d996a7aa8a839$var$_defineProperty($a43d996a7aa8a839$var$_familyProxy2, $a43d996a7aa8a839$var$FAMILY_SHARP, {
    solid: "fass",
    regular: "fasr",
    light: "fasl",
    thin: "fast"
}), $a43d996a7aa8a839$var$_familyProxy2));
var $a43d996a7aa8a839$var$PREFIX_TO_LONG_STYLE = $a43d996a7aa8a839$var$familyProxy(($a43d996a7aa8a839$var$_familyProxy3 = {}, $a43d996a7aa8a839$var$_defineProperty($a43d996a7aa8a839$var$_familyProxy3, $a43d996a7aa8a839$var$FAMILY_CLASSIC, {
    fab: "fa-brands",
    fad: "fa-duotone",
    fak: "fa-kit",
    fal: "fa-light",
    far: "fa-regular",
    fas: "fa-solid",
    fat: "fa-thin"
}), $a43d996a7aa8a839$var$_defineProperty($a43d996a7aa8a839$var$_familyProxy3, $a43d996a7aa8a839$var$FAMILY_SHARP, {
    fass: "fa-solid",
    fasr: "fa-regular",
    fasl: "fa-light",
    fast: "fa-thin"
}), $a43d996a7aa8a839$var$_familyProxy3));
var $a43d996a7aa8a839$var$LONG_STYLE_TO_PREFIX = $a43d996a7aa8a839$var$familyProxy(($a43d996a7aa8a839$var$_familyProxy4 = {}, $a43d996a7aa8a839$var$_defineProperty($a43d996a7aa8a839$var$_familyProxy4, $a43d996a7aa8a839$var$FAMILY_CLASSIC, {
    "fa-brands": "fab",
    "fa-duotone": "fad",
    "fa-kit": "fak",
    "fa-light": "fal",
    "fa-regular": "far",
    "fa-solid": "fas",
    "fa-thin": "fat"
}), $a43d996a7aa8a839$var$_defineProperty($a43d996a7aa8a839$var$_familyProxy4, $a43d996a7aa8a839$var$FAMILY_SHARP, {
    "fa-solid": "fass",
    "fa-regular": "fasr",
    "fa-light": "fasl",
    "fa-thin": "fast"
}), $a43d996a7aa8a839$var$_familyProxy4));
var $a43d996a7aa8a839$var$ICON_SELECTION_SYNTAX_PATTERN = /fa(s|r|l|t|d|b|k|ss|sr|sl|st)?[\-\ ]/; // eslint-disable-line no-useless-escape
var $a43d996a7aa8a839$var$LAYERS_TEXT_CLASSNAME = "fa-layers-text";
var $a43d996a7aa8a839$var$FONT_FAMILY_PATTERN = /Font ?Awesome ?([56 ]*)(Solid|Regular|Light|Thin|Duotone|Brands|Free|Pro|Sharp|Kit)?.*/i;
var $a43d996a7aa8a839$var$FONT_WEIGHT_TO_PREFIX = $a43d996a7aa8a839$var$familyProxy(($a43d996a7aa8a839$var$_familyProxy5 = {}, $a43d996a7aa8a839$var$_defineProperty($a43d996a7aa8a839$var$_familyProxy5, $a43d996a7aa8a839$var$FAMILY_CLASSIC, {
    900: "fas",
    400: "far",
    normal: "far",
    300: "fal",
    100: "fat"
}), $a43d996a7aa8a839$var$_defineProperty($a43d996a7aa8a839$var$_familyProxy5, $a43d996a7aa8a839$var$FAMILY_SHARP, {
    900: "fass",
    400: "fasr",
    300: "fasl",
    100: "fast"
}), $a43d996a7aa8a839$var$_familyProxy5));
var $a43d996a7aa8a839$var$oneToTen = [
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10
];
var $a43d996a7aa8a839$var$oneToTwenty = $a43d996a7aa8a839$var$oneToTen.concat([
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20
]);
var $a43d996a7aa8a839$var$ATTRIBUTES_WATCHED_FOR_MUTATION = [
    "class",
    "data-prefix",
    "data-icon",
    "data-fa-transform",
    "data-fa-mask"
];
var $a43d996a7aa8a839$var$DUOTONE_CLASSES = {
    GROUP: "duotone-group",
    SWAP_OPACITY: "swap-opacity",
    PRIMARY: "primary",
    SECONDARY: "secondary"
};
var $a43d996a7aa8a839$var$prefixes = new Set();
Object.keys($a43d996a7aa8a839$var$STYLE_TO_PREFIX[$a43d996a7aa8a839$var$FAMILY_CLASSIC]).map($a43d996a7aa8a839$var$prefixes.add.bind($a43d996a7aa8a839$var$prefixes));
Object.keys($a43d996a7aa8a839$var$STYLE_TO_PREFIX[$a43d996a7aa8a839$var$FAMILY_SHARP]).map($a43d996a7aa8a839$var$prefixes.add.bind($a43d996a7aa8a839$var$prefixes));
var $a43d996a7aa8a839$var$RESERVED_CLASSES = [].concat($a43d996a7aa8a839$var$FAMILIES, $a43d996a7aa8a839$var$_toConsumableArray($a43d996a7aa8a839$var$prefixes), [
    "2xs",
    "xs",
    "sm",
    "lg",
    "xl",
    "2xl",
    "beat",
    "border",
    "fade",
    "beat-fade",
    "bounce",
    "flip-both",
    "flip-horizontal",
    "flip-vertical",
    "flip",
    "fw",
    "inverse",
    "layers-counter",
    "layers-text",
    "layers",
    "li",
    "pull-left",
    "pull-right",
    "pulse",
    "rotate-180",
    "rotate-270",
    "rotate-90",
    "rotate-by",
    "shake",
    "spin-pulse",
    "spin-reverse",
    "spin",
    "stack-1x",
    "stack-2x",
    "stack",
    "ul",
    $a43d996a7aa8a839$var$DUOTONE_CLASSES.GROUP,
    $a43d996a7aa8a839$var$DUOTONE_CLASSES.SWAP_OPACITY,
    $a43d996a7aa8a839$var$DUOTONE_CLASSES.PRIMARY,
    $a43d996a7aa8a839$var$DUOTONE_CLASSES.SECONDARY
]).concat($a43d996a7aa8a839$var$oneToTen.map(function(n) {
    return "".concat(n, "x");
})).concat($a43d996a7aa8a839$var$oneToTwenty.map(function(n) {
    return "w-".concat(n);
}));
var $a43d996a7aa8a839$var$initial = $a43d996a7aa8a839$var$WINDOW.FontAwesomeConfig || {};
function $a43d996a7aa8a839$var$getAttrConfig(attr) {
    var element = $a43d996a7aa8a839$var$DOCUMENT.querySelector("script[" + attr + "]");
    if (element) return element.getAttribute(attr);
}
function $a43d996a7aa8a839$var$coerce(val) {
    // Getting an empty string will occur if the attribute is set on the HTML tag but without a value
    // We'll assume that this is an indication that it should be toggled to true
    if (val === "") return true;
    if (val === "false") return false;
    if (val === "true") return true;
    return val;
}
if ($a43d996a7aa8a839$var$DOCUMENT && typeof $a43d996a7aa8a839$var$DOCUMENT.querySelector === "function") {
    var $a43d996a7aa8a839$var$attrs = [
        [
            "data-family-prefix",
            "familyPrefix"
        ],
        [
            "data-css-prefix",
            "cssPrefix"
        ],
        [
            "data-family-default",
            "familyDefault"
        ],
        [
            "data-style-default",
            "styleDefault"
        ],
        [
            "data-replacement-class",
            "replacementClass"
        ],
        [
            "data-auto-replace-svg",
            "autoReplaceSvg"
        ],
        [
            "data-auto-add-css",
            "autoAddCss"
        ],
        [
            "data-auto-a11y",
            "autoA11y"
        ],
        [
            "data-search-pseudo-elements",
            "searchPseudoElements"
        ],
        [
            "data-observe-mutations",
            "observeMutations"
        ],
        [
            "data-mutate-approach",
            "mutateApproach"
        ],
        [
            "data-keep-original-source",
            "keepOriginalSource"
        ],
        [
            "data-measure-performance",
            "measurePerformance"
        ],
        [
            "data-show-missing-icons",
            "showMissingIcons"
        ]
    ];
    $a43d996a7aa8a839$var$attrs.forEach(function(_ref) {
        var _ref2 = $a43d996a7aa8a839$var$_slicedToArray(_ref, 2), attr = _ref2[0], key = _ref2[1];
        var val = $a43d996a7aa8a839$var$coerce($a43d996a7aa8a839$var$getAttrConfig(attr));
        if (val !== undefined && val !== null) $a43d996a7aa8a839$var$initial[key] = val;
    });
}
var $a43d996a7aa8a839$var$_default = {
    styleDefault: "solid",
    familyDefault: "classic",
    cssPrefix: $a43d996a7aa8a839$var$DEFAULT_CSS_PREFIX,
    replacementClass: $a43d996a7aa8a839$var$DEFAULT_REPLACEMENT_CLASS,
    autoReplaceSvg: true,
    autoAddCss: true,
    autoA11y: true,
    searchPseudoElements: false,
    observeMutations: true,
    mutateApproach: "async",
    keepOriginalSource: true,
    measurePerformance: false,
    showMissingIcons: true
}; // familyPrefix is deprecated but we must still support it if present
if ($a43d996a7aa8a839$var$initial.familyPrefix) $a43d996a7aa8a839$var$initial.cssPrefix = $a43d996a7aa8a839$var$initial.familyPrefix;
var $a43d996a7aa8a839$var$_config = $a43d996a7aa8a839$var$_objectSpread2($a43d996a7aa8a839$var$_objectSpread2({}, $a43d996a7aa8a839$var$_default), $a43d996a7aa8a839$var$initial);
if (!$a43d996a7aa8a839$var$_config.autoReplaceSvg) $a43d996a7aa8a839$var$_config.observeMutations = false;
var $a43d996a7aa8a839$var$config = {};
Object.keys($a43d996a7aa8a839$var$_default).forEach(function(key) {
    Object.defineProperty($a43d996a7aa8a839$var$config, key, {
        enumerable: true,
        set: function set(val) {
            $a43d996a7aa8a839$var$_config[key] = val;
            $a43d996a7aa8a839$var$_onChangeCb.forEach(function(cb) {
                return cb($a43d996a7aa8a839$var$config);
            });
        },
        get: function get() {
            return $a43d996a7aa8a839$var$_config[key];
        }
    });
}); // familyPrefix is deprecated as of 6.2.0 and should be removed in 7.0.0
Object.defineProperty($a43d996a7aa8a839$var$config, "familyPrefix", {
    enumerable: true,
    set: function set(val) {
        $a43d996a7aa8a839$var$_config.cssPrefix = val;
        $a43d996a7aa8a839$var$_onChangeCb.forEach(function(cb) {
            return cb($a43d996a7aa8a839$var$config);
        });
    },
    get: function get() {
        return $a43d996a7aa8a839$var$_config.cssPrefix;
    }
});
$a43d996a7aa8a839$var$WINDOW.FontAwesomeConfig = $a43d996a7aa8a839$var$config;
var $a43d996a7aa8a839$var$_onChangeCb = [];
function $a43d996a7aa8a839$var$onChange(cb) {
    $a43d996a7aa8a839$var$_onChangeCb.push(cb);
    return function() {
        $a43d996a7aa8a839$var$_onChangeCb.splice($a43d996a7aa8a839$var$_onChangeCb.indexOf(cb), 1);
    };
}
var $a43d996a7aa8a839$var$d = $a43d996a7aa8a839$var$UNITS_IN_GRID;
var $a43d996a7aa8a839$var$meaninglessTransform = {
    size: 16,
    x: 0,
    y: 0,
    rotate: 0,
    flipX: false,
    flipY: false
};
function $a43d996a7aa8a839$var$insertCss(css) {
    if (!css || !$a43d996a7aa8a839$var$IS_DOM) return;
    var style = $a43d996a7aa8a839$var$DOCUMENT.createElement("style");
    style.setAttribute("type", "text/css");
    style.innerHTML = css;
    var headChildren = $a43d996a7aa8a839$var$DOCUMENT.head.childNodes;
    var beforeChild = null;
    for(var i = headChildren.length - 1; i > -1; i--){
        var child = headChildren[i];
        var tagName = (child.tagName || "").toUpperCase();
        if ([
            "STYLE",
            "LINK"
        ].indexOf(tagName) > -1) beforeChild = child;
    }
    $a43d996a7aa8a839$var$DOCUMENT.head.insertBefore(style, beforeChild);
    return css;
}
var $a43d996a7aa8a839$var$idPool = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
function $a43d996a7aa8a839$var$nextUniqueId() {
    var size = 12;
    var id = "";
    while(size-- > 0)id += $a43d996a7aa8a839$var$idPool[Math.random() * 62 | 0];
    return id;
}
function $a43d996a7aa8a839$var$toArray(obj) {
    var array = [];
    for(var i = (obj || []).length >>> 0; i--;)array[i] = obj[i];
    return array;
}
function $a43d996a7aa8a839$var$classArray(node) {
    if (node.classList) return $a43d996a7aa8a839$var$toArray(node.classList);
    else return (node.getAttribute("class") || "").split(" ").filter(function(i) {
        return i;
    });
}
function $a43d996a7aa8a839$var$htmlEscape(str) {
    return "".concat(str).replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#39;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
function $a43d996a7aa8a839$var$joinAttributes(attributes) {
    return Object.keys(attributes || {}).reduce(function(acc, attributeName) {
        return acc + "".concat(attributeName, '="').concat($a43d996a7aa8a839$var$htmlEscape(attributes[attributeName]), '" ');
    }, "").trim();
}
function $a43d996a7aa8a839$var$joinStyles(styles) {
    return Object.keys(styles || {}).reduce(function(acc, styleName) {
        return acc + "".concat(styleName, ": ").concat(styles[styleName].trim(), ";");
    }, "");
}
function $a43d996a7aa8a839$var$transformIsMeaningful(transform) {
    return transform.size !== $a43d996a7aa8a839$var$meaninglessTransform.size || transform.x !== $a43d996a7aa8a839$var$meaninglessTransform.x || transform.y !== $a43d996a7aa8a839$var$meaninglessTransform.y || transform.rotate !== $a43d996a7aa8a839$var$meaninglessTransform.rotate || transform.flipX || transform.flipY;
}
function $a43d996a7aa8a839$var$transformForSvg(_ref) {
    var transform = _ref.transform, containerWidth = _ref.containerWidth, iconWidth = _ref.iconWidth;
    var outer = {
        transform: "translate(".concat(containerWidth / 2, " 256)")
    };
    var innerTranslate = "translate(".concat(transform.x * 32, ", ").concat(transform.y * 32, ") ");
    var innerScale = "scale(".concat(transform.size / 16 * (transform.flipX ? -1 : 1), ", ").concat(transform.size / 16 * (transform.flipY ? -1 : 1), ") ");
    var innerRotate = "rotate(".concat(transform.rotate, " 0 0)");
    var inner = {
        transform: "".concat(innerTranslate, " ").concat(innerScale, " ").concat(innerRotate)
    };
    var path = {
        transform: "translate(".concat(iconWidth / 2 * -1, " -256)")
    };
    return {
        outer: outer,
        inner: inner,
        path: path
    };
}
function $a43d996a7aa8a839$var$transformForCss(_ref2) {
    var transform = _ref2.transform, _ref2$width = _ref2.width, width = _ref2$width === void 0 ? $a43d996a7aa8a839$var$UNITS_IN_GRID : _ref2$width, _ref2$height = _ref2.height, height = _ref2$height === void 0 ? $a43d996a7aa8a839$var$UNITS_IN_GRID : _ref2$height, _ref2$startCentered = _ref2.startCentered, startCentered = _ref2$startCentered === void 0 ? false : _ref2$startCentered;
    var val = "";
    if (startCentered && $a43d996a7aa8a839$var$IS_IE) val += "translate(".concat(transform.x / $a43d996a7aa8a839$var$d - width / 2, "em, ").concat(transform.y / $a43d996a7aa8a839$var$d - height / 2, "em) ");
    else if (startCentered) val += "translate(calc(-50% + ".concat(transform.x / $a43d996a7aa8a839$var$d, "em), calc(-50% + ").concat(transform.y / $a43d996a7aa8a839$var$d, "em)) ");
    else val += "translate(".concat(transform.x / $a43d996a7aa8a839$var$d, "em, ").concat(transform.y / $a43d996a7aa8a839$var$d, "em) ");
    val += "scale(".concat(transform.size / $a43d996a7aa8a839$var$d * (transform.flipX ? -1 : 1), ", ").concat(transform.size / $a43d996a7aa8a839$var$d * (transform.flipY ? -1 : 1), ") ");
    val += "rotate(".concat(transform.rotate, "deg) ");
    return val;
}
var $a43d996a7aa8a839$var$baseStyles = ':root, :host {\n  --fa-font-solid: normal 900 1em/1 "Font Awesome 6 Solid";\n  --fa-font-regular: normal 400 1em/1 "Font Awesome 6 Regular";\n  --fa-font-light: normal 300 1em/1 "Font Awesome 6 Light";\n  --fa-font-thin: normal 100 1em/1 "Font Awesome 6 Thin";\n  --fa-font-duotone: normal 900 1em/1 "Font Awesome 6 Duotone";\n  --fa-font-sharp-solid: normal 900 1em/1 "Font Awesome 6 Sharp";\n  --fa-font-sharp-regular: normal 400 1em/1 "Font Awesome 6 Sharp";\n  --fa-font-sharp-light: normal 300 1em/1 "Font Awesome 6 Sharp";\n  --fa-font-sharp-thin: normal 100 1em/1 "Font Awesome 6 Sharp";\n  --fa-font-brands: normal 400 1em/1 "Font Awesome 6 Brands";\n}\n\nsvg:not(:root).svg-inline--fa, svg:not(:host).svg-inline--fa {\n  overflow: visible;\n  box-sizing: content-box;\n}\n\n.svg-inline--fa {\n  display: var(--fa-display, inline-block);\n  height: 1em;\n  overflow: visible;\n  vertical-align: -0.125em;\n}\n.svg-inline--fa.fa-2xs {\n  vertical-align: 0.1em;\n}\n.svg-inline--fa.fa-xs {\n  vertical-align: 0em;\n}\n.svg-inline--fa.fa-sm {\n  vertical-align: -0.0714285705em;\n}\n.svg-inline--fa.fa-lg {\n  vertical-align: -0.2em;\n}\n.svg-inline--fa.fa-xl {\n  vertical-align: -0.25em;\n}\n.svg-inline--fa.fa-2xl {\n  vertical-align: -0.3125em;\n}\n.svg-inline--fa.fa-pull-left {\n  margin-right: var(--fa-pull-margin, 0.3em);\n  width: auto;\n}\n.svg-inline--fa.fa-pull-right {\n  margin-left: var(--fa-pull-margin, 0.3em);\n  width: auto;\n}\n.svg-inline--fa.fa-li {\n  width: var(--fa-li-width, 2em);\n  top: 0.25em;\n}\n.svg-inline--fa.fa-fw {\n  width: var(--fa-fw-width, 1.25em);\n}\n\n.fa-layers svg.svg-inline--fa {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n.fa-layers-counter, .fa-layers-text {\n  display: inline-block;\n  position: absolute;\n  text-align: center;\n}\n\n.fa-layers {\n  display: inline-block;\n  height: 1em;\n  position: relative;\n  text-align: center;\n  vertical-align: -0.125em;\n  width: 1em;\n}\n.fa-layers svg.svg-inline--fa {\n  -webkit-transform-origin: center center;\n          transform-origin: center center;\n}\n\n.fa-layers-text {\n  left: 50%;\n  top: 50%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  -webkit-transform-origin: center center;\n          transform-origin: center center;\n}\n\n.fa-layers-counter {\n  background-color: var(--fa-counter-background-color, #ff253a);\n  border-radius: var(--fa-counter-border-radius, 1em);\n  box-sizing: border-box;\n  color: var(--fa-inverse, #fff);\n  line-height: var(--fa-counter-line-height, 1);\n  max-width: var(--fa-counter-max-width, 5em);\n  min-width: var(--fa-counter-min-width, 1.5em);\n  overflow: hidden;\n  padding: var(--fa-counter-padding, 0.25em 0.5em);\n  right: var(--fa-right, 0);\n  text-overflow: ellipsis;\n  top: var(--fa-top, 0);\n  -webkit-transform: scale(var(--fa-counter-scale, 0.25));\n          transform: scale(var(--fa-counter-scale, 0.25));\n  -webkit-transform-origin: top right;\n          transform-origin: top right;\n}\n\n.fa-layers-bottom-right {\n  bottom: var(--fa-bottom, 0);\n  right: var(--fa-right, 0);\n  top: auto;\n  -webkit-transform: scale(var(--fa-layers-scale, 0.25));\n          transform: scale(var(--fa-layers-scale, 0.25));\n  -webkit-transform-origin: bottom right;\n          transform-origin: bottom right;\n}\n\n.fa-layers-bottom-left {\n  bottom: var(--fa-bottom, 0);\n  left: var(--fa-left, 0);\n  right: auto;\n  top: auto;\n  -webkit-transform: scale(var(--fa-layers-scale, 0.25));\n          transform: scale(var(--fa-layers-scale, 0.25));\n  -webkit-transform-origin: bottom left;\n          transform-origin: bottom left;\n}\n\n.fa-layers-top-right {\n  top: var(--fa-top, 0);\n  right: var(--fa-right, 0);\n  -webkit-transform: scale(var(--fa-layers-scale, 0.25));\n          transform: scale(var(--fa-layers-scale, 0.25));\n  -webkit-transform-origin: top right;\n          transform-origin: top right;\n}\n\n.fa-layers-top-left {\n  left: var(--fa-left, 0);\n  right: auto;\n  top: var(--fa-top, 0);\n  -webkit-transform: scale(var(--fa-layers-scale, 0.25));\n          transform: scale(var(--fa-layers-scale, 0.25));\n  -webkit-transform-origin: top left;\n          transform-origin: top left;\n}\n\n.fa-1x {\n  font-size: 1em;\n}\n\n.fa-2x {\n  font-size: 2em;\n}\n\n.fa-3x {\n  font-size: 3em;\n}\n\n.fa-4x {\n  font-size: 4em;\n}\n\n.fa-5x {\n  font-size: 5em;\n}\n\n.fa-6x {\n  font-size: 6em;\n}\n\n.fa-7x {\n  font-size: 7em;\n}\n\n.fa-8x {\n  font-size: 8em;\n}\n\n.fa-9x {\n  font-size: 9em;\n}\n\n.fa-10x {\n  font-size: 10em;\n}\n\n.fa-2xs {\n  font-size: 0.625em;\n  line-height: 0.1em;\n  vertical-align: 0.225em;\n}\n\n.fa-xs {\n  font-size: 0.75em;\n  line-height: 0.0833333337em;\n  vertical-align: 0.125em;\n}\n\n.fa-sm {\n  font-size: 0.875em;\n  line-height: 0.0714285718em;\n  vertical-align: 0.0535714295em;\n}\n\n.fa-lg {\n  font-size: 1.25em;\n  line-height: 0.05em;\n  vertical-align: -0.075em;\n}\n\n.fa-xl {\n  font-size: 1.5em;\n  line-height: 0.0416666682em;\n  vertical-align: -0.125em;\n}\n\n.fa-2xl {\n  font-size: 2em;\n  line-height: 0.03125em;\n  vertical-align: -0.1875em;\n}\n\n.fa-fw {\n  text-align: center;\n  width: 1.25em;\n}\n\n.fa-ul {\n  list-style-type: none;\n  margin-left: var(--fa-li-margin, 2.5em);\n  padding-left: 0;\n}\n.fa-ul > li {\n  position: relative;\n}\n\n.fa-li {\n  left: calc(var(--fa-li-width, 2em) * -1);\n  position: absolute;\n  text-align: center;\n  width: var(--fa-li-width, 2em);\n  line-height: inherit;\n}\n\n.fa-border {\n  border-color: var(--fa-border-color, #eee);\n  border-radius: var(--fa-border-radius, 0.1em);\n  border-style: var(--fa-border-style, solid);\n  border-width: var(--fa-border-width, 0.08em);\n  padding: var(--fa-border-padding, 0.2em 0.25em 0.15em);\n}\n\n.fa-pull-left {\n  float: left;\n  margin-right: var(--fa-pull-margin, 0.3em);\n}\n\n.fa-pull-right {\n  float: right;\n  margin-left: var(--fa-pull-margin, 0.3em);\n}\n\n.fa-beat {\n  -webkit-animation-name: fa-beat;\n          animation-name: fa-beat;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, ease-in-out);\n          animation-timing-function: var(--fa-animation-timing, ease-in-out);\n}\n\n.fa-bounce {\n  -webkit-animation-name: fa-bounce;\n          animation-name: fa-bounce;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));\n          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));\n}\n\n.fa-fade {\n  -webkit-animation-name: fa-fade;\n          animation-name: fa-fade;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n}\n\n.fa-beat-fade {\n  -webkit-animation-name: fa-beat-fade;\n          animation-name: fa-beat-fade;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n}\n\n.fa-flip {\n  -webkit-animation-name: fa-flip;\n          animation-name: fa-flip;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, ease-in-out);\n          animation-timing-function: var(--fa-animation-timing, ease-in-out);\n}\n\n.fa-shake {\n  -webkit-animation-name: fa-shake;\n          animation-name: fa-shake;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, linear);\n          animation-timing-function: var(--fa-animation-timing, linear);\n}\n\n.fa-spin {\n  -webkit-animation-name: fa-spin;\n          animation-name: fa-spin;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 2s);\n          animation-duration: var(--fa-animation-duration, 2s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, linear);\n          animation-timing-function: var(--fa-animation-timing, linear);\n}\n\n.fa-spin-reverse {\n  --fa-animation-direction: reverse;\n}\n\n.fa-pulse,\n.fa-spin-pulse {\n  -webkit-animation-name: fa-spin;\n          animation-name: fa-spin;\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, steps(8));\n          animation-timing-function: var(--fa-animation-timing, steps(8));\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .fa-beat,\n.fa-bounce,\n.fa-fade,\n.fa-beat-fade,\n.fa-flip,\n.fa-pulse,\n.fa-shake,\n.fa-spin,\n.fa-spin-pulse {\n    -webkit-animation-delay: -1ms;\n            animation-delay: -1ms;\n    -webkit-animation-duration: 1ms;\n            animation-duration: 1ms;\n    -webkit-animation-iteration-count: 1;\n            animation-iteration-count: 1;\n    -webkit-transition-delay: 0s;\n            transition-delay: 0s;\n    -webkit-transition-duration: 0s;\n            transition-duration: 0s;\n  }\n}\n@-webkit-keyframes fa-beat {\n  0%, 90% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  45% {\n    -webkit-transform: scale(var(--fa-beat-scale, 1.25));\n            transform: scale(var(--fa-beat-scale, 1.25));\n  }\n}\n@keyframes fa-beat {\n  0%, 90% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  45% {\n    -webkit-transform: scale(var(--fa-beat-scale, 1.25));\n            transform: scale(var(--fa-beat-scale, 1.25));\n  }\n}\n@-webkit-keyframes fa-bounce {\n  0% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n  10% {\n    -webkit-transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n            transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n  }\n  30% {\n    -webkit-transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n            transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n  }\n  50% {\n    -webkit-transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n            transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n  }\n  57% {\n    -webkit-transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n            transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n  }\n  64% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n  100% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n}\n@keyframes fa-bounce {\n  0% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n  10% {\n    -webkit-transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n            transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n  }\n  30% {\n    -webkit-transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n            transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n  }\n  50% {\n    -webkit-transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n            transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n  }\n  57% {\n    -webkit-transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n            transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n  }\n  64% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n  100% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n}\n@-webkit-keyframes fa-fade {\n  50% {\n    opacity: var(--fa-fade-opacity, 0.4);\n  }\n}\n@keyframes fa-fade {\n  50% {\n    opacity: var(--fa-fade-opacity, 0.4);\n  }\n}\n@-webkit-keyframes fa-beat-fade {\n  0%, 100% {\n    opacity: var(--fa-beat-fade-opacity, 0.4);\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  50% {\n    opacity: 1;\n    -webkit-transform: scale(var(--fa-beat-fade-scale, 1.125));\n            transform: scale(var(--fa-beat-fade-scale, 1.125));\n  }\n}\n@keyframes fa-beat-fade {\n  0%, 100% {\n    opacity: var(--fa-beat-fade-opacity, 0.4);\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  50% {\n    opacity: 1;\n    -webkit-transform: scale(var(--fa-beat-fade-scale, 1.125));\n            transform: scale(var(--fa-beat-fade-scale, 1.125));\n  }\n}\n@-webkit-keyframes fa-flip {\n  50% {\n    -webkit-transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n            transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n  }\n}\n@keyframes fa-flip {\n  50% {\n    -webkit-transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n            transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n  }\n}\n@-webkit-keyframes fa-shake {\n  0% {\n    -webkit-transform: rotate(-15deg);\n            transform: rotate(-15deg);\n  }\n  4% {\n    -webkit-transform: rotate(15deg);\n            transform: rotate(15deg);\n  }\n  8%, 24% {\n    -webkit-transform: rotate(-18deg);\n            transform: rotate(-18deg);\n  }\n  12%, 28% {\n    -webkit-transform: rotate(18deg);\n            transform: rotate(18deg);\n  }\n  16% {\n    -webkit-transform: rotate(-22deg);\n            transform: rotate(-22deg);\n  }\n  20% {\n    -webkit-transform: rotate(22deg);\n            transform: rotate(22deg);\n  }\n  32% {\n    -webkit-transform: rotate(-12deg);\n            transform: rotate(-12deg);\n  }\n  36% {\n    -webkit-transform: rotate(12deg);\n            transform: rotate(12deg);\n  }\n  40%, 100% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n}\n@keyframes fa-shake {\n  0% {\n    -webkit-transform: rotate(-15deg);\n            transform: rotate(-15deg);\n  }\n  4% {\n    -webkit-transform: rotate(15deg);\n            transform: rotate(15deg);\n  }\n  8%, 24% {\n    -webkit-transform: rotate(-18deg);\n            transform: rotate(-18deg);\n  }\n  12%, 28% {\n    -webkit-transform: rotate(18deg);\n            transform: rotate(18deg);\n  }\n  16% {\n    -webkit-transform: rotate(-22deg);\n            transform: rotate(-22deg);\n  }\n  20% {\n    -webkit-transform: rotate(22deg);\n            transform: rotate(22deg);\n  }\n  32% {\n    -webkit-transform: rotate(-12deg);\n            transform: rotate(-12deg);\n  }\n  36% {\n    -webkit-transform: rotate(12deg);\n            transform: rotate(12deg);\n  }\n  40%, 100% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n}\n@-webkit-keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n@keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n.fa-rotate-90 {\n  -webkit-transform: rotate(90deg);\n          transform: rotate(90deg);\n}\n\n.fa-rotate-180 {\n  -webkit-transform: rotate(180deg);\n          transform: rotate(180deg);\n}\n\n.fa-rotate-270 {\n  -webkit-transform: rotate(270deg);\n          transform: rotate(270deg);\n}\n\n.fa-flip-horizontal {\n  -webkit-transform: scale(-1, 1);\n          transform: scale(-1, 1);\n}\n\n.fa-flip-vertical {\n  -webkit-transform: scale(1, -1);\n          transform: scale(1, -1);\n}\n\n.fa-flip-both,\n.fa-flip-horizontal.fa-flip-vertical {\n  -webkit-transform: scale(-1, -1);\n          transform: scale(-1, -1);\n}\n\n.fa-rotate-by {\n  -webkit-transform: rotate(var(--fa-rotate-angle, none));\n          transform: rotate(var(--fa-rotate-angle, none));\n}\n\n.fa-stack {\n  display: inline-block;\n  vertical-align: middle;\n  height: 2em;\n  position: relative;\n  width: 2.5em;\n}\n\n.fa-stack-1x,\n.fa-stack-2x {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n  z-index: var(--fa-stack-z-index, auto);\n}\n\n.svg-inline--fa.fa-stack-1x {\n  height: 1em;\n  width: 1.25em;\n}\n.svg-inline--fa.fa-stack-2x {\n  height: 2em;\n  width: 2.5em;\n}\n\n.fa-inverse {\n  color: var(--fa-inverse, #fff);\n}\n\n.sr-only,\n.fa-sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border-width: 0;\n}\n\n.sr-only-focusable:not(:focus),\n.fa-sr-only-focusable:not(:focus) {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border-width: 0;\n}\n\n.svg-inline--fa .fa-primary {\n  fill: var(--fa-primary-color, currentColor);\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa .fa-secondary {\n  fill: var(--fa-secondary-color, currentColor);\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-primary {\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-secondary {\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa mask .fa-primary,\n.svg-inline--fa mask .fa-secondary {\n  fill: black;\n}\n\n.fad.fa-inverse,\n.fa-duotone.fa-inverse {\n  color: var(--fa-inverse, #fff);\n}';
function $a43d996a7aa8a839$var$css() {
    var dcp = $a43d996a7aa8a839$var$DEFAULT_CSS_PREFIX;
    var drc = $a43d996a7aa8a839$var$DEFAULT_REPLACEMENT_CLASS;
    var fp = $a43d996a7aa8a839$var$config.cssPrefix;
    var rc = $a43d996a7aa8a839$var$config.replacementClass;
    var s = $a43d996a7aa8a839$var$baseStyles;
    if (fp !== dcp || rc !== drc) {
        var dPatt = new RegExp("\\.".concat(dcp, "\\-"), "g");
        var customPropPatt = new RegExp("\\--".concat(dcp, "\\-"), "g");
        var rPatt = new RegExp("\\.".concat(drc), "g");
        s = s.replace(dPatt, ".".concat(fp, "-")).replace(customPropPatt, "--".concat(fp, "-")).replace(rPatt, ".".concat(rc));
    }
    return s;
}
var $a43d996a7aa8a839$var$_cssInserted = false;
function $a43d996a7aa8a839$var$ensureCss() {
    if ($a43d996a7aa8a839$var$config.autoAddCss && !$a43d996a7aa8a839$var$_cssInserted) {
        $a43d996a7aa8a839$var$insertCss($a43d996a7aa8a839$var$css());
        $a43d996a7aa8a839$var$_cssInserted = true;
    }
}
var $a43d996a7aa8a839$var$InjectCSS = {
    mixout: function mixout() {
        return {
            dom: {
                css: $a43d996a7aa8a839$var$css,
                insertCss: $a43d996a7aa8a839$var$ensureCss
            }
        };
    },
    hooks: function hooks() {
        return {
            beforeDOMElementCreation: function beforeDOMElementCreation() {
                $a43d996a7aa8a839$var$ensureCss();
            },
            beforeI2svg: function beforeI2svg() {
                $a43d996a7aa8a839$var$ensureCss();
            }
        };
    }
};
var $a43d996a7aa8a839$var$w = $a43d996a7aa8a839$var$WINDOW || {};
if (!$a43d996a7aa8a839$var$w[$a43d996a7aa8a839$var$NAMESPACE_IDENTIFIER]) $a43d996a7aa8a839$var$w[$a43d996a7aa8a839$var$NAMESPACE_IDENTIFIER] = {};
if (!$a43d996a7aa8a839$var$w[$a43d996a7aa8a839$var$NAMESPACE_IDENTIFIER].styles) $a43d996a7aa8a839$var$w[$a43d996a7aa8a839$var$NAMESPACE_IDENTIFIER].styles = {};
if (!$a43d996a7aa8a839$var$w[$a43d996a7aa8a839$var$NAMESPACE_IDENTIFIER].hooks) $a43d996a7aa8a839$var$w[$a43d996a7aa8a839$var$NAMESPACE_IDENTIFIER].hooks = {};
if (!$a43d996a7aa8a839$var$w[$a43d996a7aa8a839$var$NAMESPACE_IDENTIFIER].shims) $a43d996a7aa8a839$var$w[$a43d996a7aa8a839$var$NAMESPACE_IDENTIFIER].shims = [];
var $a43d996a7aa8a839$var$namespace = $a43d996a7aa8a839$var$w[$a43d996a7aa8a839$var$NAMESPACE_IDENTIFIER];
var $a43d996a7aa8a839$var$functions = [];
var $a43d996a7aa8a839$var$listener = function listener() {
    $a43d996a7aa8a839$var$DOCUMENT.removeEventListener("DOMContentLoaded", listener);
    $a43d996a7aa8a839$var$loaded = 1;
    $a43d996a7aa8a839$var$functions.map(function(fn) {
        return fn();
    });
};
var $a43d996a7aa8a839$var$loaded = false;
if ($a43d996a7aa8a839$var$IS_DOM) {
    $a43d996a7aa8a839$var$loaded = ($a43d996a7aa8a839$var$DOCUMENT.documentElement.doScroll ? /^loaded|^c/ : /^loaded|^i|^c/).test($a43d996a7aa8a839$var$DOCUMENT.readyState);
    if (!$a43d996a7aa8a839$var$loaded) $a43d996a7aa8a839$var$DOCUMENT.addEventListener("DOMContentLoaded", $a43d996a7aa8a839$var$listener);
}
function $a43d996a7aa8a839$var$domready(fn) {
    if (!$a43d996a7aa8a839$var$IS_DOM) return;
    $a43d996a7aa8a839$var$loaded ? setTimeout(fn, 0) : $a43d996a7aa8a839$var$functions.push(fn);
}
function $a43d996a7aa8a839$var$toHtml(abstractNodes) {
    var tag = abstractNodes.tag, _abstractNodes$attrib = abstractNodes.attributes, attributes = _abstractNodes$attrib === void 0 ? {} : _abstractNodes$attrib, _abstractNodes$childr = abstractNodes.children, children = _abstractNodes$childr === void 0 ? [] : _abstractNodes$childr;
    if (typeof abstractNodes === "string") return $a43d996a7aa8a839$var$htmlEscape(abstractNodes);
    else return "<".concat(tag, " ").concat($a43d996a7aa8a839$var$joinAttributes(attributes), ">").concat(children.map($a43d996a7aa8a839$var$toHtml).join(""), "</").concat(tag, ">");
}
function $a43d996a7aa8a839$var$iconFromMapping(mapping, prefix, iconName) {
    if (mapping && mapping[prefix] && mapping[prefix][iconName]) return {
        prefix: prefix,
        iconName: iconName,
        icon: mapping[prefix][iconName]
    };
}
/**
 * Internal helper to bind a function known to have 4 arguments
 * to a given context.
 */ var $a43d996a7aa8a839$var$bindInternal4 = function bindInternal4(func, thisContext) {
    return function(a, b, c, d) {
        return func.call(thisContext, a, b, c, d);
    };
};
/**
 * # Reduce
 *
 * A fast object `.reduce()` implementation.
 *
 * @param  {Object}   subject      The object to reduce over.
 * @param  {Function} fn           The reducer function.
 * @param  {mixed}    initialValue The initial value for the reducer, defaults to subject[0].
 * @param  {Object}   thisContext  The context for the reducer.
 * @return {mixed}                 The final result.
 */ var $a43d996a7aa8a839$var$reduce = function fastReduceObject(subject, fn, initialValue, thisContext) {
    var keys = Object.keys(subject), length = keys.length, iterator = thisContext !== undefined ? $a43d996a7aa8a839$var$bindInternal4(fn, thisContext) : fn, i, key, result;
    if (initialValue === undefined) {
        i = 1;
        result = subject[keys[0]];
    } else {
        i = 0;
        result = initialValue;
    }
    for(; i < length; i++){
        key = keys[i];
        result = iterator(result, subject[key], key, subject);
    }
    return result;
};
/**
 * ucs2decode() and codePointAt() are both works of Mathias Bynens and licensed under MIT
 *
 * Copyright Mathias Bynens <https://mathiasbynens.be/>

 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:

 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.

 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */ function $a43d996a7aa8a839$var$ucs2decode(string) {
    var output = [];
    var counter = 0;
    var length = string.length;
    while(counter < length){
        var value = string.charCodeAt(counter++);
        if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
            var extra = string.charCodeAt(counter++);
            if ((extra & 0xFC00) == 0xDC00) // eslint-disable-line eqeqeq
            output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
            else {
                output.push(value);
                counter--;
            }
        } else output.push(value);
    }
    return output;
}
function $a43d996a7aa8a839$var$toHex(unicode) {
    var decoded = $a43d996a7aa8a839$var$ucs2decode(unicode);
    return decoded.length === 1 ? decoded[0].toString(16) : null;
}
function $a43d996a7aa8a839$var$codePointAt(string, index) {
    var size = string.length;
    var first = string.charCodeAt(index);
    var second;
    if (first >= 0xD800 && first <= 0xDBFF && size > index + 1) {
        second = string.charCodeAt(index + 1);
        if (second >= 0xDC00 && second <= 0xDFFF) return (first - 0xD800) * 0x400 + second - 0xDC00 + 0x10000;
    }
    return first;
}
function $a43d996a7aa8a839$var$normalizeIcons(icons) {
    return Object.keys(icons).reduce(function(acc, iconName) {
        var icon = icons[iconName];
        var expanded = !!icon.icon;
        if (expanded) acc[icon.iconName] = icon.icon;
        else acc[iconName] = icon;
        return acc;
    }, {});
}
function $a43d996a7aa8a839$var$defineIcons(prefix, icons) {
    var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var _params$skipHooks = params.skipHooks, skipHooks = _params$skipHooks === void 0 ? false : _params$skipHooks;
    var normalized = $a43d996a7aa8a839$var$normalizeIcons(icons);
    if (typeof $a43d996a7aa8a839$var$namespace.hooks.addPack === "function" && !skipHooks) $a43d996a7aa8a839$var$namespace.hooks.addPack(prefix, $a43d996a7aa8a839$var$normalizeIcons(icons));
    else $a43d996a7aa8a839$var$namespace.styles[prefix] = $a43d996a7aa8a839$var$_objectSpread2($a43d996a7aa8a839$var$_objectSpread2({}, $a43d996a7aa8a839$var$namespace.styles[prefix] || {}), normalized);
    /**
   * Font Awesome 4 used the prefix of `fa` for all icons. With the introduction
   * of new styles we needed to differentiate between them. Prefix `fa` is now an alias
   * for `fas` so we'll ease the upgrade process for our users by automatically defining
   * this as well.
   */ if (prefix === "fas") $a43d996a7aa8a839$var$defineIcons("fa", icons);
}
var $a43d996a7aa8a839$var$duotonePathRe = [
    /*#__PURE__*/ $a43d996a7aa8a839$var$_wrapRegExp(/path d="((?:(?!")[\s\S])+)".*path d="((?:(?!")[\s\S])+)"/, {
        d1: 1,
        d2: 2
    }),
    /*#__PURE__*/ $a43d996a7aa8a839$var$_wrapRegExp(/path class="((?:(?!")[\s\S])+)".*d="((?:(?!")[\s\S])+)".*path class="((?:(?!")[\s\S])+)".*d="((?:(?!")[\s\S])+)"/, {
        cls1: 1,
        d1: 2,
        cls2: 3,
        d2: 4
    }),
    /*#__PURE__*/ $a43d996a7aa8a839$var$_wrapRegExp(/path class="((?:(?!")[\s\S])+)".*d="((?:(?!")[\s\S])+)"/, {
        cls1: 1,
        d1: 2
    })
];
var $a43d996a7aa8a839$var$_LONG_STYLE, $a43d996a7aa8a839$var$_PREFIXES, $a43d996a7aa8a839$var$_PREFIXES_FOR_FAMILY;
var $a43d996a7aa8a839$var$styles = $a43d996a7aa8a839$var$namespace.styles, $a43d996a7aa8a839$var$shims = $a43d996a7aa8a839$var$namespace.shims;
var $a43d996a7aa8a839$var$LONG_STYLE = ($a43d996a7aa8a839$var$_LONG_STYLE = {}, $a43d996a7aa8a839$var$_defineProperty($a43d996a7aa8a839$var$_LONG_STYLE, $a43d996a7aa8a839$var$FAMILY_CLASSIC, Object.values($a43d996a7aa8a839$var$PREFIX_TO_LONG_STYLE[$a43d996a7aa8a839$var$FAMILY_CLASSIC])), $a43d996a7aa8a839$var$_defineProperty($a43d996a7aa8a839$var$_LONG_STYLE, $a43d996a7aa8a839$var$FAMILY_SHARP, Object.values($a43d996a7aa8a839$var$PREFIX_TO_LONG_STYLE[$a43d996a7aa8a839$var$FAMILY_SHARP])), $a43d996a7aa8a839$var$_LONG_STYLE);
var $a43d996a7aa8a839$var$_defaultUsablePrefix = null;
var $a43d996a7aa8a839$var$_byUnicode = {};
var $a43d996a7aa8a839$var$_byLigature = {};
var $a43d996a7aa8a839$var$_byOldName = {};
var $a43d996a7aa8a839$var$_byOldUnicode = {};
var $a43d996a7aa8a839$var$_byAlias = {};
var $a43d996a7aa8a839$var$PREFIXES = ($a43d996a7aa8a839$var$_PREFIXES = {}, $a43d996a7aa8a839$var$_defineProperty($a43d996a7aa8a839$var$_PREFIXES, $a43d996a7aa8a839$var$FAMILY_CLASSIC, Object.keys($a43d996a7aa8a839$var$PREFIX_TO_STYLE[$a43d996a7aa8a839$var$FAMILY_CLASSIC])), $a43d996a7aa8a839$var$_defineProperty($a43d996a7aa8a839$var$_PREFIXES, $a43d996a7aa8a839$var$FAMILY_SHARP, Object.keys($a43d996a7aa8a839$var$PREFIX_TO_STYLE[$a43d996a7aa8a839$var$FAMILY_SHARP])), $a43d996a7aa8a839$var$_PREFIXES);
function $a43d996a7aa8a839$var$isReserved(name) {
    return ~$a43d996a7aa8a839$var$RESERVED_CLASSES.indexOf(name);
}
function $a43d996a7aa8a839$var$getIconName(cssPrefix, cls) {
    var parts = cls.split("-");
    var prefix = parts[0];
    var iconName = parts.slice(1).join("-");
    if (prefix === cssPrefix && iconName !== "" && !$a43d996a7aa8a839$var$isReserved(iconName)) return iconName;
    else return null;
}
var $a43d996a7aa8a839$var$build = function build() {
    var lookup = function lookup(reducer) {
        return $a43d996a7aa8a839$var$reduce($a43d996a7aa8a839$var$styles, function(o, style, prefix) {
            o[prefix] = $a43d996a7aa8a839$var$reduce(style, reducer, {});
            return o;
        }, {});
    };
    $a43d996a7aa8a839$var$_byUnicode = lookup(function(acc, icon, iconName) {
        if (icon[3]) acc[icon[3]] = iconName;
        if (icon[2]) {
            var aliases = icon[2].filter(function(a) {
                return typeof a === "number";
            });
            aliases.forEach(function(alias) {
                acc[alias.toString(16)] = iconName;
            });
        }
        return acc;
    });
    $a43d996a7aa8a839$var$_byLigature = lookup(function(acc, icon, iconName) {
        acc[iconName] = iconName;
        if (icon[2]) {
            var aliases = icon[2].filter(function(a) {
                return typeof a === "string";
            });
            aliases.forEach(function(alias) {
                acc[alias] = iconName;
            });
        }
        return acc;
    });
    $a43d996a7aa8a839$var$_byAlias = lookup(function(acc, icon, iconName) {
        var aliases = icon[2];
        acc[iconName] = iconName;
        aliases.forEach(function(alias) {
            acc[alias] = iconName;
        });
        return acc;
    }); // If we have a Kit, we can't determine if regular is available since we
    // could be auto-fetching it. We'll have to assume that it is available.
    var hasRegular = "far" in $a43d996a7aa8a839$var$styles || $a43d996a7aa8a839$var$config.autoFetchSvg;
    var shimLookups = $a43d996a7aa8a839$var$reduce($a43d996a7aa8a839$var$shims, function(acc, shim) {
        var maybeNameMaybeUnicode = shim[0];
        var prefix = shim[1];
        var iconName = shim[2];
        if (prefix === "far" && !hasRegular) prefix = "fas";
        if (typeof maybeNameMaybeUnicode === "string") acc.names[maybeNameMaybeUnicode] = {
            prefix: prefix,
            iconName: iconName
        };
        if (typeof maybeNameMaybeUnicode === "number") acc.unicodes[maybeNameMaybeUnicode.toString(16)] = {
            prefix: prefix,
            iconName: iconName
        };
        return acc;
    }, {
        names: {},
        unicodes: {}
    });
    $a43d996a7aa8a839$var$_byOldName = shimLookups.names;
    $a43d996a7aa8a839$var$_byOldUnicode = shimLookups.unicodes;
    $a43d996a7aa8a839$var$_defaultUsablePrefix = $a43d996a7aa8a839$var$getCanonicalPrefix($a43d996a7aa8a839$var$config.styleDefault, {
        family: $a43d996a7aa8a839$var$config.familyDefault
    });
};
$a43d996a7aa8a839$var$onChange(function(c) {
    $a43d996a7aa8a839$var$_defaultUsablePrefix = $a43d996a7aa8a839$var$getCanonicalPrefix(c.styleDefault, {
        family: $a43d996a7aa8a839$var$config.familyDefault
    });
});
$a43d996a7aa8a839$var$build();
function $a43d996a7aa8a839$var$byUnicode(prefix, unicode) {
    return ($a43d996a7aa8a839$var$_byUnicode[prefix] || {})[unicode];
}
function $a43d996a7aa8a839$var$byLigature(prefix, ligature) {
    return ($a43d996a7aa8a839$var$_byLigature[prefix] || {})[ligature];
}
function $a43d996a7aa8a839$var$byAlias(prefix, alias) {
    return ($a43d996a7aa8a839$var$_byAlias[prefix] || {})[alias];
}
function $a43d996a7aa8a839$var$byOldName(name) {
    return $a43d996a7aa8a839$var$_byOldName[name] || {
        prefix: null,
        iconName: null
    };
}
function $a43d996a7aa8a839$var$byOldUnicode(unicode) {
    var oldUnicode = $a43d996a7aa8a839$var$_byOldUnicode[unicode];
    var newUnicode = $a43d996a7aa8a839$var$byUnicode("fas", unicode);
    return oldUnicode || (newUnicode ? {
        prefix: "fas",
        iconName: newUnicode
    } : null) || {
        prefix: null,
        iconName: null
    };
}
function $a43d996a7aa8a839$var$getDefaultUsablePrefix() {
    return $a43d996a7aa8a839$var$_defaultUsablePrefix;
}
var $a43d996a7aa8a839$var$emptyCanonicalIcon = function emptyCanonicalIcon() {
    return {
        prefix: null,
        iconName: null,
        rest: []
    };
};
function $a43d996a7aa8a839$var$getCanonicalPrefix(styleOrPrefix) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _params$family = params.family, family = _params$family === void 0 ? $a43d996a7aa8a839$var$FAMILY_CLASSIC : _params$family;
    var style = $a43d996a7aa8a839$var$PREFIX_TO_STYLE[family][styleOrPrefix];
    var prefix = $a43d996a7aa8a839$var$STYLE_TO_PREFIX[family][styleOrPrefix] || $a43d996a7aa8a839$var$STYLE_TO_PREFIX[family][style];
    var defined = styleOrPrefix in $a43d996a7aa8a839$var$namespace.styles ? styleOrPrefix : null;
    return prefix || defined || null;
}
var $a43d996a7aa8a839$var$PREFIXES_FOR_FAMILY = ($a43d996a7aa8a839$var$_PREFIXES_FOR_FAMILY = {}, $a43d996a7aa8a839$var$_defineProperty($a43d996a7aa8a839$var$_PREFIXES_FOR_FAMILY, $a43d996a7aa8a839$var$FAMILY_CLASSIC, Object.keys($a43d996a7aa8a839$var$PREFIX_TO_LONG_STYLE[$a43d996a7aa8a839$var$FAMILY_CLASSIC])), $a43d996a7aa8a839$var$_defineProperty($a43d996a7aa8a839$var$_PREFIXES_FOR_FAMILY, $a43d996a7aa8a839$var$FAMILY_SHARP, Object.keys($a43d996a7aa8a839$var$PREFIX_TO_LONG_STYLE[$a43d996a7aa8a839$var$FAMILY_SHARP])), $a43d996a7aa8a839$var$_PREFIXES_FOR_FAMILY);
function $a43d996a7aa8a839$var$getCanonicalIcon(values) {
    var _famProps;
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _params$skipLookups = params.skipLookups, skipLookups = _params$skipLookups === void 0 ? false : _params$skipLookups;
    var famProps = (_famProps = {}, $a43d996a7aa8a839$var$_defineProperty(_famProps, $a43d996a7aa8a839$var$FAMILY_CLASSIC, "".concat($a43d996a7aa8a839$var$config.cssPrefix, "-").concat($a43d996a7aa8a839$var$FAMILY_CLASSIC)), $a43d996a7aa8a839$var$_defineProperty(_famProps, $a43d996a7aa8a839$var$FAMILY_SHARP, "".concat($a43d996a7aa8a839$var$config.cssPrefix, "-").concat($a43d996a7aa8a839$var$FAMILY_SHARP)), _famProps);
    var givenPrefix = null;
    var family = $a43d996a7aa8a839$var$FAMILY_CLASSIC;
    if (values.includes(famProps[$a43d996a7aa8a839$var$FAMILY_CLASSIC]) || values.some(function(v) {
        return $a43d996a7aa8a839$var$PREFIXES_FOR_FAMILY[$a43d996a7aa8a839$var$FAMILY_CLASSIC].includes(v);
    })) family = $a43d996a7aa8a839$var$FAMILY_CLASSIC;
    if (values.includes(famProps[$a43d996a7aa8a839$var$FAMILY_SHARP]) || values.some(function(v) {
        return $a43d996a7aa8a839$var$PREFIXES_FOR_FAMILY[$a43d996a7aa8a839$var$FAMILY_SHARP].includes(v);
    })) family = $a43d996a7aa8a839$var$FAMILY_SHARP;
    var canonical = values.reduce(function(acc, cls) {
        var iconName = $a43d996a7aa8a839$var$getIconName($a43d996a7aa8a839$var$config.cssPrefix, cls);
        if ($a43d996a7aa8a839$var$styles[cls]) {
            cls = $a43d996a7aa8a839$var$LONG_STYLE[family].includes(cls) ? $a43d996a7aa8a839$var$LONG_STYLE_TO_PREFIX[family][cls] : cls;
            givenPrefix = cls;
            acc.prefix = cls;
        } else if ($a43d996a7aa8a839$var$PREFIXES[family].indexOf(cls) > -1) {
            givenPrefix = cls;
            acc.prefix = $a43d996a7aa8a839$var$getCanonicalPrefix(cls, {
                family: family
            });
        } else if (iconName) acc.iconName = iconName;
        else if (cls !== $a43d996a7aa8a839$var$config.replacementClass && cls !== famProps[$a43d996a7aa8a839$var$FAMILY_CLASSIC] && cls !== famProps[$a43d996a7aa8a839$var$FAMILY_SHARP]) acc.rest.push(cls);
        if (!skipLookups && acc.prefix && acc.iconName) {
            var shim = givenPrefix === "fa" ? $a43d996a7aa8a839$var$byOldName(acc.iconName) : {};
            var aliasIconName = $a43d996a7aa8a839$var$byAlias(acc.prefix, acc.iconName);
            if (shim.prefix) givenPrefix = null;
            acc.iconName = shim.iconName || aliasIconName || acc.iconName;
            acc.prefix = shim.prefix || acc.prefix;
            if (acc.prefix === "far" && !$a43d996a7aa8a839$var$styles["far"] && $a43d996a7aa8a839$var$styles["fas"] && !$a43d996a7aa8a839$var$config.autoFetchSvg) // Allow a fallback from the regular style to solid if regular is not available
            // but only if we aren't auto-fetching SVGs
            acc.prefix = "fas";
        }
        return acc;
    }, $a43d996a7aa8a839$var$emptyCanonicalIcon());
    if (values.includes("fa-brands") || values.includes("fab")) canonical.prefix = "fab";
    if (values.includes("fa-duotone") || values.includes("fad")) canonical.prefix = "fad";
    if (!canonical.prefix && family === $a43d996a7aa8a839$var$FAMILY_SHARP && ($a43d996a7aa8a839$var$styles["fass"] || $a43d996a7aa8a839$var$config.autoFetchSvg)) {
        canonical.prefix = "fass";
        canonical.iconName = $a43d996a7aa8a839$var$byAlias(canonical.prefix, canonical.iconName) || canonical.iconName;
    }
    if (canonical.prefix === "fa" || givenPrefix === "fa") // The fa prefix is not canonical. So if it has made it through until this point
    // we will shift it to the correct prefix.
    canonical.prefix = $a43d996a7aa8a839$var$getDefaultUsablePrefix() || "fas";
    return canonical;
}
var $a43d996a7aa8a839$var$Library = /*#__PURE__*/ function() {
    function Library() {
        $a43d996a7aa8a839$var$_classCallCheck(this, Library);
        this.definitions = {};
    }
    $a43d996a7aa8a839$var$_createClass(Library, [
        {
            key: "add",
            value: function add() {
                var _this = this;
                for(var _len = arguments.length, definitions = new Array(_len), _key = 0; _key < _len; _key++)definitions[_key] = arguments[_key];
                var additions = definitions.reduce(this._pullDefinitions, {});
                Object.keys(additions).forEach(function(key) {
                    _this.definitions[key] = $a43d996a7aa8a839$var$_objectSpread2($a43d996a7aa8a839$var$_objectSpread2({}, _this.definitions[key] || {}), additions[key]);
                    $a43d996a7aa8a839$var$defineIcons(key, additions[key]); // TODO can we stop doing this? We can't get the icons by 'fa-solid' any longer so this probably needs to change
                    var longPrefix = $a43d996a7aa8a839$var$PREFIX_TO_LONG_STYLE[$a43d996a7aa8a839$var$FAMILY_CLASSIC][key];
                    if (longPrefix) $a43d996a7aa8a839$var$defineIcons(longPrefix, additions[key]);
                    $a43d996a7aa8a839$var$build();
                });
            }
        },
        {
            key: "reset",
            value: function reset() {
                this.definitions = {};
            }
        },
        {
            key: "_pullDefinitions",
            value: function _pullDefinitions(additions, definition) {
                var normalized = definition.prefix && definition.iconName && definition.icon ? {
                    0: definition
                } : definition;
                Object.keys(normalized).map(function(key) {
                    var _normalized$key = normalized[key], prefix = _normalized$key.prefix, iconName = _normalized$key.iconName, icon = _normalized$key.icon;
                    var aliases = icon[2];
                    if (!additions[prefix]) additions[prefix] = {};
                    if (aliases.length > 0) aliases.forEach(function(alias) {
                        if (typeof alias === "string") additions[prefix][alias] = icon;
                    });
                    additions[prefix][iconName] = icon;
                });
                return additions;
            }
        }
    ]);
    return Library;
}();
var $a43d996a7aa8a839$var$_plugins = [];
var $a43d996a7aa8a839$var$_hooks = {};
var $a43d996a7aa8a839$var$providers = {};
var $a43d996a7aa8a839$var$defaultProviderKeys = Object.keys($a43d996a7aa8a839$var$providers);
function $a43d996a7aa8a839$var$registerPlugins(nextPlugins, _ref) {
    var obj = _ref.mixoutsTo;
    $a43d996a7aa8a839$var$_plugins = nextPlugins;
    $a43d996a7aa8a839$var$_hooks = {};
    Object.keys($a43d996a7aa8a839$var$providers).forEach(function(k) {
        if ($a43d996a7aa8a839$var$defaultProviderKeys.indexOf(k) === -1) delete $a43d996a7aa8a839$var$providers[k];
    });
    $a43d996a7aa8a839$var$_plugins.forEach(function(plugin) {
        var mixout = plugin.mixout ? plugin.mixout() : {};
        Object.keys(mixout).forEach(function(tk) {
            if (typeof mixout[tk] === "function") obj[tk] = mixout[tk];
            if ($a43d996a7aa8a839$var$_typeof(mixout[tk]) === "object") Object.keys(mixout[tk]).forEach(function(sk) {
                if (!obj[tk]) obj[tk] = {};
                obj[tk][sk] = mixout[tk][sk];
            });
        });
        if (plugin.hooks) {
            var hooks = plugin.hooks();
            Object.keys(hooks).forEach(function(hook) {
                if (!$a43d996a7aa8a839$var$_hooks[hook]) $a43d996a7aa8a839$var$_hooks[hook] = [];
                $a43d996a7aa8a839$var$_hooks[hook].push(hooks[hook]);
            });
        }
        if (plugin.provides) plugin.provides($a43d996a7aa8a839$var$providers);
    });
    return obj;
}
function $a43d996a7aa8a839$var$chainHooks(hook, accumulator) {
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    var hookFns = $a43d996a7aa8a839$var$_hooks[hook] || [];
    hookFns.forEach(function(hookFn) {
        accumulator = hookFn.apply(null, [
            accumulator
        ].concat(args)); // eslint-disable-line no-useless-call
    });
    return accumulator;
}
function $a43d996a7aa8a839$var$callHooks(hook) {
    for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
    var hookFns = $a43d996a7aa8a839$var$_hooks[hook] || [];
    hookFns.forEach(function(hookFn) {
        hookFn.apply(null, args);
    });
    return undefined;
}
function $a43d996a7aa8a839$var$callProvided() {
    var hook = arguments[0];
    var args = Array.prototype.slice.call(arguments, 1);
    return $a43d996a7aa8a839$var$providers[hook] ? $a43d996a7aa8a839$var$providers[hook].apply(null, args) : undefined;
}
function $a43d996a7aa8a839$var$findIconDefinition(iconLookup) {
    if (iconLookup.prefix === "fa") iconLookup.prefix = "fas";
    var iconName = iconLookup.iconName;
    var prefix = iconLookup.prefix || $a43d996a7aa8a839$var$getDefaultUsablePrefix();
    if (!iconName) return;
    iconName = $a43d996a7aa8a839$var$byAlias(prefix, iconName) || iconName;
    return $a43d996a7aa8a839$var$iconFromMapping($a43d996a7aa8a839$var$library.definitions, prefix, iconName) || $a43d996a7aa8a839$var$iconFromMapping($a43d996a7aa8a839$var$namespace.styles, prefix, iconName);
}
var $a43d996a7aa8a839$var$library = new $a43d996a7aa8a839$var$Library();
var $a43d996a7aa8a839$var$noAuto = function noAuto() {
    $a43d996a7aa8a839$var$config.autoReplaceSvg = false;
    $a43d996a7aa8a839$var$config.observeMutations = false;
    $a43d996a7aa8a839$var$callHooks("noAuto");
};
var $a43d996a7aa8a839$var$dom = {
    i2svg: function i2svg() {
        var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        if ($a43d996a7aa8a839$var$IS_DOM) {
            $a43d996a7aa8a839$var$callHooks("beforeI2svg", params);
            $a43d996a7aa8a839$var$callProvided("pseudoElements2svg", params);
            return $a43d996a7aa8a839$var$callProvided("i2svg", params);
        } else return Promise.reject("Operation requires a DOM of some kind.");
    },
    watch: function watch() {
        var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var autoReplaceSvgRoot = params.autoReplaceSvgRoot;
        if ($a43d996a7aa8a839$var$config.autoReplaceSvg === false) $a43d996a7aa8a839$var$config.autoReplaceSvg = true;
        $a43d996a7aa8a839$var$config.observeMutations = true;
        $a43d996a7aa8a839$var$domready(function() {
            $a43d996a7aa8a839$var$autoReplace({
                autoReplaceSvgRoot: autoReplaceSvgRoot
            });
            $a43d996a7aa8a839$var$callHooks("watch", params);
        });
    }
};
var $a43d996a7aa8a839$var$parse = {
    icon: function icon(_icon) {
        if (_icon === null) return null;
        if ($a43d996a7aa8a839$var$_typeof(_icon) === "object" && _icon.prefix && _icon.iconName) return {
            prefix: _icon.prefix,
            iconName: $a43d996a7aa8a839$var$byAlias(_icon.prefix, _icon.iconName) || _icon.iconName
        };
        if (Array.isArray(_icon) && _icon.length === 2) {
            var iconName = _icon[1].indexOf("fa-") === 0 ? _icon[1].slice(3) : _icon[1];
            var prefix = $a43d996a7aa8a839$var$getCanonicalPrefix(_icon[0]);
            return {
                prefix: prefix,
                iconName: $a43d996a7aa8a839$var$byAlias(prefix, iconName) || iconName
            };
        }
        if (typeof _icon === "string" && (_icon.indexOf("".concat($a43d996a7aa8a839$var$config.cssPrefix, "-")) > -1 || _icon.match($a43d996a7aa8a839$var$ICON_SELECTION_SYNTAX_PATTERN))) {
            var canonicalIcon = $a43d996a7aa8a839$var$getCanonicalIcon(_icon.split(" "), {
                skipLookups: true
            });
            return {
                prefix: canonicalIcon.prefix || $a43d996a7aa8a839$var$getDefaultUsablePrefix(),
                iconName: $a43d996a7aa8a839$var$byAlias(canonicalIcon.prefix, canonicalIcon.iconName) || canonicalIcon.iconName
            };
        }
        if (typeof _icon === "string") {
            var _prefix = $a43d996a7aa8a839$var$getDefaultUsablePrefix();
            return {
                prefix: _prefix,
                iconName: $a43d996a7aa8a839$var$byAlias(_prefix, _icon) || _icon
            };
        }
    }
};
var $a43d996a7aa8a839$export$644d8ea042df96a6 = {
    noAuto: $a43d996a7aa8a839$var$noAuto,
    config: $a43d996a7aa8a839$var$config,
    dom: $a43d996a7aa8a839$var$dom,
    parse: $a43d996a7aa8a839$var$parse,
    library: $a43d996a7aa8a839$var$library,
    findIconDefinition: $a43d996a7aa8a839$var$findIconDefinition,
    toHtml: $a43d996a7aa8a839$var$toHtml
};
var $a43d996a7aa8a839$var$autoReplace = function autoReplace() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _params$autoReplaceSv = params.autoReplaceSvgRoot, autoReplaceSvgRoot = _params$autoReplaceSv === void 0 ? $a43d996a7aa8a839$var$DOCUMENT : _params$autoReplaceSv;
    if ((Object.keys($a43d996a7aa8a839$var$namespace.styles).length > 0 || $a43d996a7aa8a839$var$config.autoFetchSvg) && $a43d996a7aa8a839$var$IS_DOM && $a43d996a7aa8a839$var$config.autoReplaceSvg) $a43d996a7aa8a839$export$644d8ea042df96a6.dom.i2svg({
        node: autoReplaceSvgRoot
    });
};
function $a43d996a7aa8a839$var$domVariants(val, abstractCreator) {
    Object.defineProperty(val, "abstract", {
        get: abstractCreator
    });
    Object.defineProperty(val, "html", {
        get: function get() {
            return val.abstract.map(function(a) {
                return $a43d996a7aa8a839$var$toHtml(a);
            });
        }
    });
    Object.defineProperty(val, "node", {
        get: function get() {
            if (!$a43d996a7aa8a839$var$IS_DOM) return;
            var container = $a43d996a7aa8a839$var$DOCUMENT.createElement("div");
            container.innerHTML = val.html;
            return container.children;
        }
    });
    return val;
}
function $a43d996a7aa8a839$var$asIcon(_ref) {
    var children = _ref.children, main = _ref.main, mask = _ref.mask, attributes = _ref.attributes, styles = _ref.styles, transform = _ref.transform;
    if ($a43d996a7aa8a839$var$transformIsMeaningful(transform) && main.found && !mask.found) {
        var width = main.width, height = main.height;
        var offset = {
            x: width / height / 2,
            y: 0.5
        };
        attributes["style"] = $a43d996a7aa8a839$var$joinStyles($a43d996a7aa8a839$var$_objectSpread2($a43d996a7aa8a839$var$_objectSpread2({}, styles), {}, {
            "transform-origin": "".concat(offset.x + transform.x / 16, "em ").concat(offset.y + transform.y / 16, "em")
        }));
    }
    return [
        {
            tag: "svg",
            attributes: attributes,
            children: children
        }
    ];
}
function $a43d996a7aa8a839$var$asSymbol(_ref) {
    var prefix = _ref.prefix, iconName = _ref.iconName, children = _ref.children, attributes = _ref.attributes, symbol = _ref.symbol;
    var id = symbol === true ? "".concat(prefix, "-").concat($a43d996a7aa8a839$var$config.cssPrefix, "-").concat(iconName) : symbol;
    return [
        {
            tag: "svg",
            attributes: {
                style: "display: none;"
            },
            children: [
                {
                    tag: "symbol",
                    attributes: $a43d996a7aa8a839$var$_objectSpread2($a43d996a7aa8a839$var$_objectSpread2({}, attributes), {}, {
                        id: id
                    }),
                    children: children
                }
            ]
        }
    ];
}
function $a43d996a7aa8a839$var$makeInlineSvgAbstract(params) {
    var _params$icons = params.icons, main = _params$icons.main, mask = _params$icons.mask, prefix = params.prefix, iconName = params.iconName, transform = params.transform, symbol = params.symbol, title = params.title, maskId = params.maskId, titleId = params.titleId, extra = params.extra, _params$watchable = params.watchable, watchable = _params$watchable === void 0 ? false : _params$watchable;
    var _ref = mask.found ? mask : main, width = _ref.width, height = _ref.height;
    var isUploadedIcon = prefix === "fak";
    var attrClass = [
        $a43d996a7aa8a839$var$config.replacementClass,
        iconName ? "".concat($a43d996a7aa8a839$var$config.cssPrefix, "-").concat(iconName) : ""
    ].filter(function(c) {
        return extra.classes.indexOf(c) === -1;
    }).filter(function(c) {
        return c !== "" || !!c;
    }).concat(extra.classes).join(" ");
    var content = {
        children: [],
        attributes: $a43d996a7aa8a839$var$_objectSpread2($a43d996a7aa8a839$var$_objectSpread2({}, extra.attributes), {}, {
            "data-prefix": prefix,
            "data-icon": iconName,
            "class": attrClass,
            "role": extra.attributes.role || "img",
            "xmlns": "http://www.w3.org/2000/svg",
            "viewBox": "0 0 ".concat(width, " ").concat(height)
        })
    };
    var uploadedIconWidthStyle = isUploadedIcon && !~extra.classes.indexOf("fa-fw") ? {
        width: "".concat(width / height * 1, "em")
    } : {};
    if (watchable) content.attributes[$a43d996a7aa8a839$var$DATA_FA_I2SVG] = "";
    if (title) {
        content.children.push({
            tag: "title",
            attributes: {
                id: content.attributes["aria-labelledby"] || "title-".concat(titleId || $a43d996a7aa8a839$var$nextUniqueId())
            },
            children: [
                title
            ]
        });
        delete content.attributes.title;
    }
    var args = $a43d996a7aa8a839$var$_objectSpread2($a43d996a7aa8a839$var$_objectSpread2({}, content), {}, {
        prefix: prefix,
        iconName: iconName,
        main: main,
        mask: mask,
        maskId: maskId,
        transform: transform,
        symbol: symbol,
        styles: $a43d996a7aa8a839$var$_objectSpread2($a43d996a7aa8a839$var$_objectSpread2({}, uploadedIconWidthStyle), extra.styles)
    });
    var _ref2 = mask.found && main.found ? $a43d996a7aa8a839$var$callProvided("generateAbstractMask", args) || {
        children: [],
        attributes: {}
    } : $a43d996a7aa8a839$var$callProvided("generateAbstractIcon", args) || {
        children: [],
        attributes: {}
    }, children = _ref2.children, attributes = _ref2.attributes;
    args.children = children;
    args.attributes = attributes;
    if (symbol) return $a43d996a7aa8a839$var$asSymbol(args);
    else return $a43d996a7aa8a839$var$asIcon(args);
}
function $a43d996a7aa8a839$var$makeLayersTextAbstract(params) {
    var content = params.content, width = params.width, height = params.height, transform = params.transform, title = params.title, extra = params.extra, _params$watchable2 = params.watchable, watchable = _params$watchable2 === void 0 ? false : _params$watchable2;
    var attributes = $a43d996a7aa8a839$var$_objectSpread2($a43d996a7aa8a839$var$_objectSpread2($a43d996a7aa8a839$var$_objectSpread2({}, extra.attributes), title ? {
        "title": title
    } : {}), {}, {
        "class": extra.classes.join(" ")
    });
    if (watchable) attributes[$a43d996a7aa8a839$var$DATA_FA_I2SVG] = "";
    var styles = $a43d996a7aa8a839$var$_objectSpread2({}, extra.styles);
    if ($a43d996a7aa8a839$var$transformIsMeaningful(transform)) {
        styles["transform"] = $a43d996a7aa8a839$var$transformForCss({
            transform: transform,
            startCentered: true,
            width: width,
            height: height
        });
        styles["-webkit-transform"] = styles["transform"];
    }
    var styleString = $a43d996a7aa8a839$var$joinStyles(styles);
    if (styleString.length > 0) attributes["style"] = styleString;
    var val = [];
    val.push({
        tag: "span",
        attributes: attributes,
        children: [
            content
        ]
    });
    if (title) val.push({
        tag: "span",
        attributes: {
            class: "sr-only"
        },
        children: [
            title
        ]
    });
    return val;
}
function $a43d996a7aa8a839$var$makeLayersCounterAbstract(params) {
    var content = params.content, title = params.title, extra = params.extra;
    var attributes = $a43d996a7aa8a839$var$_objectSpread2($a43d996a7aa8a839$var$_objectSpread2($a43d996a7aa8a839$var$_objectSpread2({}, extra.attributes), title ? {
        "title": title
    } : {}), {}, {
        "class": extra.classes.join(" ")
    });
    var styleString = $a43d996a7aa8a839$var$joinStyles(extra.styles);
    if (styleString.length > 0) attributes["style"] = styleString;
    var val = [];
    val.push({
        tag: "span",
        attributes: attributes,
        children: [
            content
        ]
    });
    if (title) val.push({
        tag: "span",
        attributes: {
            class: "sr-only"
        },
        children: [
            title
        ]
    });
    return val;
}
var $a43d996a7aa8a839$var$styles$1 = $a43d996a7aa8a839$var$namespace.styles;
function $a43d996a7aa8a839$var$asFoundIcon(icon) {
    var width = icon[0];
    var height = icon[1];
    var _icon$slice = icon.slice(4), _icon$slice2 = $a43d996a7aa8a839$var$_slicedToArray(_icon$slice, 1), vectorData = _icon$slice2[0];
    var element = null;
    if (Array.isArray(vectorData)) element = {
        tag: "g",
        attributes: {
            class: "".concat($a43d996a7aa8a839$var$config.cssPrefix, "-").concat($a43d996a7aa8a839$var$DUOTONE_CLASSES.GROUP)
        },
        children: [
            {
                tag: "path",
                attributes: {
                    class: "".concat($a43d996a7aa8a839$var$config.cssPrefix, "-").concat($a43d996a7aa8a839$var$DUOTONE_CLASSES.SECONDARY),
                    fill: "currentColor",
                    d: vectorData[0]
                }
            },
            {
                tag: "path",
                attributes: {
                    class: "".concat($a43d996a7aa8a839$var$config.cssPrefix, "-").concat($a43d996a7aa8a839$var$DUOTONE_CLASSES.PRIMARY),
                    fill: "currentColor",
                    d: vectorData[1]
                }
            }
        ]
    };
    else element = {
        tag: "path",
        attributes: {
            fill: "currentColor",
            d: vectorData
        }
    };
    return {
        found: true,
        width: width,
        height: height,
        icon: element
    };
}
var $a43d996a7aa8a839$var$missingIconResolutionMixin = {
    found: false,
    width: 512,
    height: 512
};
function $a43d996a7aa8a839$var$maybeNotifyMissing(iconName, prefix) {
    if (!$a43d996a7aa8a839$var$PRODUCTION && !$a43d996a7aa8a839$var$config.showMissingIcons && iconName) console.error('Icon with name "'.concat(iconName, '" and prefix "').concat(prefix, '" is missing.'));
}
function $a43d996a7aa8a839$var$findIcon(iconName, prefix) {
    var givenPrefix = prefix;
    if (prefix === "fa" && $a43d996a7aa8a839$var$config.styleDefault !== null) prefix = $a43d996a7aa8a839$var$getDefaultUsablePrefix();
    return new Promise(function(resolve, reject) {
        var val = {
            found: false,
            width: 512,
            height: 512,
            icon: $a43d996a7aa8a839$var$callProvided("missingIconAbstract") || {}
        };
        if (givenPrefix === "fa") {
            var shim = $a43d996a7aa8a839$var$byOldName(iconName) || {};
            iconName = shim.iconName || iconName;
            prefix = shim.prefix || prefix;
        }
        if (iconName && prefix && $a43d996a7aa8a839$var$styles$1[prefix] && $a43d996a7aa8a839$var$styles$1[prefix][iconName]) {
            var icon = $a43d996a7aa8a839$var$styles$1[prefix][iconName];
            return resolve($a43d996a7aa8a839$var$asFoundIcon(icon));
        }
        $a43d996a7aa8a839$var$maybeNotifyMissing(iconName, prefix);
        resolve($a43d996a7aa8a839$var$_objectSpread2($a43d996a7aa8a839$var$_objectSpread2({}, $a43d996a7aa8a839$var$missingIconResolutionMixin), {}, {
            icon: $a43d996a7aa8a839$var$config.showMissingIcons && iconName ? $a43d996a7aa8a839$var$callProvided("missingIconAbstract") || {} : {}
        }));
    });
}
var $a43d996a7aa8a839$var$noop$1 = function noop() {};
var $a43d996a7aa8a839$var$p = $a43d996a7aa8a839$var$config.measurePerformance && $a43d996a7aa8a839$var$PERFORMANCE && $a43d996a7aa8a839$var$PERFORMANCE.mark && $a43d996a7aa8a839$var$PERFORMANCE.measure ? $a43d996a7aa8a839$var$PERFORMANCE : {
    mark: $a43d996a7aa8a839$var$noop$1,
    measure: $a43d996a7aa8a839$var$noop$1
};
var $a43d996a7aa8a839$var$preamble = 'FA "6.5.1"';
var $a43d996a7aa8a839$var$begin = function begin(name) {
    $a43d996a7aa8a839$var$p.mark("".concat($a43d996a7aa8a839$var$preamble, " ").concat(name, " begins"));
    return function() {
        return $a43d996a7aa8a839$var$end(name);
    };
};
var $a43d996a7aa8a839$var$end = function end(name) {
    $a43d996a7aa8a839$var$p.mark("".concat($a43d996a7aa8a839$var$preamble, " ").concat(name, " ends"));
    $a43d996a7aa8a839$var$p.measure("".concat($a43d996a7aa8a839$var$preamble, " ").concat(name), "".concat($a43d996a7aa8a839$var$preamble, " ").concat(name, " begins"), "".concat($a43d996a7aa8a839$var$preamble, " ").concat(name, " ends"));
};
var $a43d996a7aa8a839$var$perf = {
    begin: $a43d996a7aa8a839$var$begin,
    end: $a43d996a7aa8a839$var$end
};
var $a43d996a7aa8a839$var$noop$2 = function noop() {};
function $a43d996a7aa8a839$var$isWatched(node) {
    var i2svg = node.getAttribute ? node.getAttribute($a43d996a7aa8a839$var$DATA_FA_I2SVG) : null;
    return typeof i2svg === "string";
}
function $a43d996a7aa8a839$var$hasPrefixAndIcon(node) {
    var prefix = node.getAttribute ? node.getAttribute($a43d996a7aa8a839$var$DATA_PREFIX) : null;
    var icon = node.getAttribute ? node.getAttribute($a43d996a7aa8a839$var$DATA_ICON) : null;
    return prefix && icon;
}
function $a43d996a7aa8a839$var$hasBeenReplaced(node) {
    return node && node.classList && node.classList.contains && node.classList.contains($a43d996a7aa8a839$var$config.replacementClass);
}
function $a43d996a7aa8a839$var$getMutator() {
    if ($a43d996a7aa8a839$var$config.autoReplaceSvg === true) return $a43d996a7aa8a839$var$mutators.replace;
    var mutator = $a43d996a7aa8a839$var$mutators[$a43d996a7aa8a839$var$config.autoReplaceSvg];
    return mutator || $a43d996a7aa8a839$var$mutators.replace;
}
function $a43d996a7aa8a839$var$createElementNS(tag) {
    return $a43d996a7aa8a839$var$DOCUMENT.createElementNS("http://www.w3.org/2000/svg", tag);
}
function $a43d996a7aa8a839$var$createElement(tag) {
    return $a43d996a7aa8a839$var$DOCUMENT.createElement(tag);
}
function $a43d996a7aa8a839$var$convertSVG(abstractObj) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _params$ceFn = params.ceFn, ceFn = _params$ceFn === void 0 ? abstractObj.tag === "svg" ? $a43d996a7aa8a839$var$createElementNS : $a43d996a7aa8a839$var$createElement : _params$ceFn;
    if (typeof abstractObj === "string") return $a43d996a7aa8a839$var$DOCUMENT.createTextNode(abstractObj);
    var tag = ceFn(abstractObj.tag);
    Object.keys(abstractObj.attributes || []).forEach(function(key) {
        tag.setAttribute(key, abstractObj.attributes[key]);
    });
    var children = abstractObj.children || [];
    children.forEach(function(child) {
        tag.appendChild($a43d996a7aa8a839$var$convertSVG(child, {
            ceFn: ceFn
        }));
    });
    return tag;
}
function $a43d996a7aa8a839$var$nodeAsComment(node) {
    var comment = " ".concat(node.outerHTML, " ");
    /* BEGIN.ATTRIBUTION */ comment = "".concat(comment, "Font Awesome fontawesome.com ");
    /* END.ATTRIBUTION */ return comment;
}
var $a43d996a7aa8a839$var$mutators = {
    replace: function replace(mutation) {
        var node = mutation[0];
        if (node.parentNode) {
            mutation[1].forEach(function(_abstract) {
                node.parentNode.insertBefore($a43d996a7aa8a839$var$convertSVG(_abstract), node);
            });
            if (node.getAttribute($a43d996a7aa8a839$var$DATA_FA_I2SVG) === null && $a43d996a7aa8a839$var$config.keepOriginalSource) {
                var comment = $a43d996a7aa8a839$var$DOCUMENT.createComment($a43d996a7aa8a839$var$nodeAsComment(node));
                node.parentNode.replaceChild(comment, node);
            } else node.remove();
        }
    },
    nest: function nest(mutation) {
        var node = mutation[0];
        var _abstract2 = mutation[1]; // If we already have a replaced node we do not want to continue nesting within it.
        // Short-circuit to the standard replacement
        if (~$a43d996a7aa8a839$var$classArray(node).indexOf($a43d996a7aa8a839$var$config.replacementClass)) return $a43d996a7aa8a839$var$mutators.replace(mutation);
        var forSvg = new RegExp("".concat($a43d996a7aa8a839$var$config.cssPrefix, "-.*"));
        delete _abstract2[0].attributes.id;
        if (_abstract2[0].attributes.class) {
            var splitClasses = _abstract2[0].attributes.class.split(" ").reduce(function(acc, cls) {
                if (cls === $a43d996a7aa8a839$var$config.replacementClass || cls.match(forSvg)) acc.toSvg.push(cls);
                else acc.toNode.push(cls);
                return acc;
            }, {
                toNode: [],
                toSvg: []
            });
            _abstract2[0].attributes.class = splitClasses.toSvg.join(" ");
            if (splitClasses.toNode.length === 0) node.removeAttribute("class");
            else node.setAttribute("class", splitClasses.toNode.join(" "));
        }
        var newInnerHTML = _abstract2.map(function(a) {
            return $a43d996a7aa8a839$var$toHtml(a);
        }).join("\n");
        node.setAttribute($a43d996a7aa8a839$var$DATA_FA_I2SVG, "");
        node.innerHTML = newInnerHTML;
    }
};
function $a43d996a7aa8a839$var$performOperationSync(op) {
    op();
}
function $a43d996a7aa8a839$var$perform(mutations, callback) {
    var callbackFunction = typeof callback === "function" ? callback : $a43d996a7aa8a839$var$noop$2;
    if (mutations.length === 0) callbackFunction();
    else {
        var frame = $a43d996a7aa8a839$var$performOperationSync;
        if ($a43d996a7aa8a839$var$config.mutateApproach === $a43d996a7aa8a839$var$MUTATION_APPROACH_ASYNC) frame = $a43d996a7aa8a839$var$WINDOW.requestAnimationFrame || $a43d996a7aa8a839$var$performOperationSync;
        frame(function() {
            var mutator = $a43d996a7aa8a839$var$getMutator();
            var mark = $a43d996a7aa8a839$var$perf.begin("mutate");
            mutations.map(mutator);
            mark();
            callbackFunction();
        });
    }
}
var $a43d996a7aa8a839$var$disabled = false;
function $a43d996a7aa8a839$var$disableObservation() {
    $a43d996a7aa8a839$var$disabled = true;
}
function $a43d996a7aa8a839$var$enableObservation() {
    $a43d996a7aa8a839$var$disabled = false;
}
var $a43d996a7aa8a839$var$mo = null;
function $a43d996a7aa8a839$var$observe(options) {
    if (!$a43d996a7aa8a839$var$MUTATION_OBSERVER) return;
    if (!$a43d996a7aa8a839$var$config.observeMutations) return;
    var _options$treeCallback = options.treeCallback, treeCallback = _options$treeCallback === void 0 ? $a43d996a7aa8a839$var$noop$2 : _options$treeCallback, _options$nodeCallback = options.nodeCallback, nodeCallback = _options$nodeCallback === void 0 ? $a43d996a7aa8a839$var$noop$2 : _options$nodeCallback, _options$pseudoElemen = options.pseudoElementsCallback, pseudoElementsCallback = _options$pseudoElemen === void 0 ? $a43d996a7aa8a839$var$noop$2 : _options$pseudoElemen, _options$observeMutat = options.observeMutationsRoot, observeMutationsRoot = _options$observeMutat === void 0 ? $a43d996a7aa8a839$var$DOCUMENT : _options$observeMutat;
    $a43d996a7aa8a839$var$mo = new $a43d996a7aa8a839$var$MUTATION_OBSERVER(function(objects) {
        if ($a43d996a7aa8a839$var$disabled) return;
        var defaultPrefix = $a43d996a7aa8a839$var$getDefaultUsablePrefix();
        $a43d996a7aa8a839$var$toArray(objects).forEach(function(mutationRecord) {
            if (mutationRecord.type === "childList" && mutationRecord.addedNodes.length > 0 && !$a43d996a7aa8a839$var$isWatched(mutationRecord.addedNodes[0])) {
                if ($a43d996a7aa8a839$var$config.searchPseudoElements) pseudoElementsCallback(mutationRecord.target);
                treeCallback(mutationRecord.target);
            }
            if (mutationRecord.type === "attributes" && mutationRecord.target.parentNode && $a43d996a7aa8a839$var$config.searchPseudoElements) pseudoElementsCallback(mutationRecord.target.parentNode);
            if (mutationRecord.type === "attributes" && $a43d996a7aa8a839$var$isWatched(mutationRecord.target) && ~$a43d996a7aa8a839$var$ATTRIBUTES_WATCHED_FOR_MUTATION.indexOf(mutationRecord.attributeName)) {
                if (mutationRecord.attributeName === "class" && $a43d996a7aa8a839$var$hasPrefixAndIcon(mutationRecord.target)) {
                    var _getCanonicalIcon = $a43d996a7aa8a839$var$getCanonicalIcon($a43d996a7aa8a839$var$classArray(mutationRecord.target)), prefix = _getCanonicalIcon.prefix, iconName = _getCanonicalIcon.iconName;
                    mutationRecord.target.setAttribute($a43d996a7aa8a839$var$DATA_PREFIX, prefix || defaultPrefix);
                    if (iconName) mutationRecord.target.setAttribute($a43d996a7aa8a839$var$DATA_ICON, iconName);
                } else if ($a43d996a7aa8a839$var$hasBeenReplaced(mutationRecord.target)) nodeCallback(mutationRecord.target);
            }
        });
    });
    if (!$a43d996a7aa8a839$var$IS_DOM) return;
    $a43d996a7aa8a839$var$mo.observe(observeMutationsRoot, {
        childList: true,
        attributes: true,
        characterData: true,
        subtree: true
    });
}
function $a43d996a7aa8a839$var$disconnect() {
    if (!$a43d996a7aa8a839$var$mo) return;
    $a43d996a7aa8a839$var$mo.disconnect();
}
function $a43d996a7aa8a839$var$styleParser(node) {
    var style = node.getAttribute("style");
    var val = [];
    if (style) val = style.split(";").reduce(function(acc, style) {
        var styles = style.split(":");
        var prop = styles[0];
        var value = styles.slice(1);
        if (prop && value.length > 0) acc[prop] = value.join(":").trim();
        return acc;
    }, {});
    return val;
}
function $a43d996a7aa8a839$var$classParser(node) {
    var existingPrefix = node.getAttribute("data-prefix");
    var existingIconName = node.getAttribute("data-icon");
    var innerText = node.innerText !== undefined ? node.innerText.trim() : "";
    var val = $a43d996a7aa8a839$var$getCanonicalIcon($a43d996a7aa8a839$var$classArray(node));
    if (!val.prefix) val.prefix = $a43d996a7aa8a839$var$getDefaultUsablePrefix();
    if (existingPrefix && existingIconName) {
        val.prefix = existingPrefix;
        val.iconName = existingIconName;
    }
    if (val.iconName && val.prefix) return val;
    if (val.prefix && innerText.length > 0) val.iconName = $a43d996a7aa8a839$var$byLigature(val.prefix, node.innerText) || $a43d996a7aa8a839$var$byUnicode(val.prefix, $a43d996a7aa8a839$var$toHex(node.innerText));
    if (!val.iconName && $a43d996a7aa8a839$var$config.autoFetchSvg && node.firstChild && node.firstChild.nodeType === Node.TEXT_NODE) val.iconName = node.firstChild.data;
    return val;
}
function $a43d996a7aa8a839$var$attributesParser(node) {
    var extraAttributes = $a43d996a7aa8a839$var$toArray(node.attributes).reduce(function(acc, attr) {
        if (acc.name !== "class" && acc.name !== "style") acc[attr.name] = attr.value;
        return acc;
    }, {});
    var title = node.getAttribute("title");
    var titleId = node.getAttribute("data-fa-title-id");
    if ($a43d996a7aa8a839$var$config.autoA11y) {
        if (title) extraAttributes["aria-labelledby"] = "".concat($a43d996a7aa8a839$var$config.replacementClass, "-title-").concat(titleId || $a43d996a7aa8a839$var$nextUniqueId());
        else {
            extraAttributes["aria-hidden"] = "true";
            extraAttributes["focusable"] = "false";
        }
    }
    return extraAttributes;
}
function $a43d996a7aa8a839$var$blankMeta() {
    return {
        iconName: null,
        title: null,
        titleId: null,
        prefix: null,
        transform: $a43d996a7aa8a839$var$meaninglessTransform,
        symbol: false,
        mask: {
            iconName: null,
            prefix: null,
            rest: []
        },
        maskId: null,
        extra: {
            classes: [],
            styles: {},
            attributes: {}
        }
    };
}
function $a43d996a7aa8a839$var$parseMeta(node) {
    var parser = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        styleParser: true
    };
    var _classParser = $a43d996a7aa8a839$var$classParser(node), iconName = _classParser.iconName, prefix = _classParser.prefix, extraClasses = _classParser.rest;
    var extraAttributes = $a43d996a7aa8a839$var$attributesParser(node);
    var pluginMeta = $a43d996a7aa8a839$var$chainHooks("parseNodeAttributes", {}, node);
    var extraStyles = parser.styleParser ? $a43d996a7aa8a839$var$styleParser(node) : [];
    return $a43d996a7aa8a839$var$_objectSpread2({
        iconName: iconName,
        title: node.getAttribute("title"),
        titleId: node.getAttribute("data-fa-title-id"),
        prefix: prefix,
        transform: $a43d996a7aa8a839$var$meaninglessTransform,
        mask: {
            iconName: null,
            prefix: null,
            rest: []
        },
        maskId: null,
        symbol: false,
        extra: {
            classes: extraClasses,
            styles: extraStyles,
            attributes: extraAttributes
        }
    }, pluginMeta);
}
var $a43d996a7aa8a839$var$styles$2 = $a43d996a7aa8a839$var$namespace.styles;
function $a43d996a7aa8a839$var$generateMutation(node) {
    var nodeMeta = $a43d996a7aa8a839$var$config.autoReplaceSvg === "nest" ? $a43d996a7aa8a839$var$parseMeta(node, {
        styleParser: false
    }) : $a43d996a7aa8a839$var$parseMeta(node);
    if (~nodeMeta.extra.classes.indexOf($a43d996a7aa8a839$var$LAYERS_TEXT_CLASSNAME)) return $a43d996a7aa8a839$var$callProvided("generateLayersText", node, nodeMeta);
    else return $a43d996a7aa8a839$var$callProvided("generateSvgReplacementMutation", node, nodeMeta);
}
var $a43d996a7aa8a839$var$knownPrefixes = new Set();
$a43d996a7aa8a839$var$FAMILIES.map(function(family) {
    $a43d996a7aa8a839$var$knownPrefixes.add("fa-".concat(family));
});
Object.keys($a43d996a7aa8a839$var$PREFIX_TO_STYLE[$a43d996a7aa8a839$var$FAMILY_CLASSIC]).map($a43d996a7aa8a839$var$knownPrefixes.add.bind($a43d996a7aa8a839$var$knownPrefixes));
Object.keys($a43d996a7aa8a839$var$PREFIX_TO_STYLE[$a43d996a7aa8a839$var$FAMILY_SHARP]).map($a43d996a7aa8a839$var$knownPrefixes.add.bind($a43d996a7aa8a839$var$knownPrefixes));
$a43d996a7aa8a839$var$knownPrefixes = $a43d996a7aa8a839$var$_toConsumableArray($a43d996a7aa8a839$var$knownPrefixes);
function $a43d996a7aa8a839$var$onTree(root) {
    var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    if (!$a43d996a7aa8a839$var$IS_DOM) return Promise.resolve();
    var htmlClassList = $a43d996a7aa8a839$var$DOCUMENT.documentElement.classList;
    var hclAdd = function hclAdd(suffix) {
        return htmlClassList.add("".concat($a43d996a7aa8a839$var$HTML_CLASS_I2SVG_BASE_CLASS, "-").concat(suffix));
    };
    var hclRemove = function hclRemove(suffix) {
        return htmlClassList.remove("".concat($a43d996a7aa8a839$var$HTML_CLASS_I2SVG_BASE_CLASS, "-").concat(suffix));
    };
    var prefixes = $a43d996a7aa8a839$var$config.autoFetchSvg ? $a43d996a7aa8a839$var$knownPrefixes : $a43d996a7aa8a839$var$FAMILIES.map(function(f) {
        return "fa-".concat(f);
    }).concat(Object.keys($a43d996a7aa8a839$var$styles$2));
    if (!prefixes.includes("fa")) prefixes.push("fa");
    var prefixesDomQuery = [
        ".".concat($a43d996a7aa8a839$var$LAYERS_TEXT_CLASSNAME, ":not([").concat($a43d996a7aa8a839$var$DATA_FA_I2SVG, "])")
    ].concat(prefixes.map(function(p) {
        return ".".concat(p, ":not([").concat($a43d996a7aa8a839$var$DATA_FA_I2SVG, "])");
    })).join(", ");
    if (prefixesDomQuery.length === 0) return Promise.resolve();
    var candidates = [];
    try {
        candidates = $a43d996a7aa8a839$var$toArray(root.querySelectorAll(prefixesDomQuery));
    } catch (e) {}
    if (candidates.length > 0) {
        hclAdd("pending");
        hclRemove("complete");
    } else return Promise.resolve();
    var mark = $a43d996a7aa8a839$var$perf.begin("onTree");
    var mutations = candidates.reduce(function(acc, node) {
        try {
            var mutation = $a43d996a7aa8a839$var$generateMutation(node);
            if (mutation) acc.push(mutation);
        } catch (e) {
            if (!$a43d996a7aa8a839$var$PRODUCTION) {
                if (e.name === "MissingIcon") console.error(e);
            }
        }
        return acc;
    }, []);
    return new Promise(function(resolve, reject) {
        Promise.all(mutations).then(function(resolvedMutations) {
            $a43d996a7aa8a839$var$perform(resolvedMutations, function() {
                hclAdd("active");
                hclAdd("complete");
                hclRemove("pending");
                if (typeof callback === "function") callback();
                mark();
                resolve();
            });
        }).catch(function(e) {
            mark();
            reject(e);
        });
    });
}
function $a43d996a7aa8a839$var$onNode(node) {
    var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    $a43d996a7aa8a839$var$generateMutation(node).then(function(mutation) {
        if (mutation) $a43d996a7aa8a839$var$perform([
            mutation
        ], callback);
    });
}
function $a43d996a7aa8a839$var$resolveIcons(next) {
    return function(maybeIconDefinition) {
        var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var iconDefinition = (maybeIconDefinition || {}).icon ? maybeIconDefinition : $a43d996a7aa8a839$var$findIconDefinition(maybeIconDefinition || {});
        var mask = params.mask;
        if (mask) mask = (mask || {}).icon ? mask : $a43d996a7aa8a839$var$findIconDefinition(mask || {});
        return next(iconDefinition, $a43d996a7aa8a839$var$_objectSpread2($a43d996a7aa8a839$var$_objectSpread2({}, params), {}, {
            mask: mask
        }));
    };
}
var $a43d996a7aa8a839$var$render = function render(iconDefinition) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _params$transform = params.transform, transform = _params$transform === void 0 ? $a43d996a7aa8a839$var$meaninglessTransform : _params$transform, _params$symbol = params.symbol, symbol = _params$symbol === void 0 ? false : _params$symbol, _params$mask = params.mask, mask = _params$mask === void 0 ? null : _params$mask, _params$maskId = params.maskId, maskId = _params$maskId === void 0 ? null : _params$maskId, _params$title = params.title, title = _params$title === void 0 ? null : _params$title, _params$titleId = params.titleId, titleId = _params$titleId === void 0 ? null : _params$titleId, _params$classes = params.classes, classes = _params$classes === void 0 ? [] : _params$classes, _params$attributes = params.attributes, attributes = _params$attributes === void 0 ? {} : _params$attributes, _params$styles = params.styles, styles = _params$styles === void 0 ? {} : _params$styles;
    if (!iconDefinition) return;
    var prefix = iconDefinition.prefix, iconName = iconDefinition.iconName, icon = iconDefinition.icon;
    return $a43d996a7aa8a839$var$domVariants($a43d996a7aa8a839$var$_objectSpread2({
        type: "icon"
    }, iconDefinition), function() {
        $a43d996a7aa8a839$var$callHooks("beforeDOMElementCreation", {
            iconDefinition: iconDefinition,
            params: params
        });
        if ($a43d996a7aa8a839$var$config.autoA11y) {
            if (title) attributes["aria-labelledby"] = "".concat($a43d996a7aa8a839$var$config.replacementClass, "-title-").concat(titleId || $a43d996a7aa8a839$var$nextUniqueId());
            else {
                attributes["aria-hidden"] = "true";
                attributes["focusable"] = "false";
            }
        }
        return $a43d996a7aa8a839$var$makeInlineSvgAbstract({
            icons: {
                main: $a43d996a7aa8a839$var$asFoundIcon(icon),
                mask: mask ? $a43d996a7aa8a839$var$asFoundIcon(mask.icon) : {
                    found: false,
                    width: null,
                    height: null,
                    icon: {}
                }
            },
            prefix: prefix,
            iconName: iconName,
            transform: $a43d996a7aa8a839$var$_objectSpread2($a43d996a7aa8a839$var$_objectSpread2({}, $a43d996a7aa8a839$var$meaninglessTransform), transform),
            symbol: symbol,
            title: title,
            maskId: maskId,
            titleId: titleId,
            extra: {
                attributes: attributes,
                styles: styles,
                classes: classes
            }
        });
    });
};
var $a43d996a7aa8a839$var$ReplaceElements = {
    mixout: function mixout() {
        return {
            icon: $a43d996a7aa8a839$var$resolveIcons($a43d996a7aa8a839$var$render)
        };
    },
    hooks: function hooks() {
        return {
            mutationObserverCallbacks: function mutationObserverCallbacks(accumulator) {
                accumulator.treeCallback = $a43d996a7aa8a839$var$onTree;
                accumulator.nodeCallback = $a43d996a7aa8a839$var$onNode;
                return accumulator;
            }
        };
    },
    provides: function provides(providers$$1) {
        providers$$1.i2svg = function(params) {
            var _params$node = params.node, node = _params$node === void 0 ? $a43d996a7aa8a839$var$DOCUMENT : _params$node, _params$callback = params.callback, callback = _params$callback === void 0 ? function() {} : _params$callback;
            return $a43d996a7aa8a839$var$onTree(node, callback);
        };
        providers$$1.generateSvgReplacementMutation = function(node, nodeMeta) {
            var iconName = nodeMeta.iconName, title = nodeMeta.title, titleId = nodeMeta.titleId, prefix = nodeMeta.prefix, transform = nodeMeta.transform, symbol = nodeMeta.symbol, mask = nodeMeta.mask, maskId = nodeMeta.maskId, extra = nodeMeta.extra;
            return new Promise(function(resolve, reject) {
                Promise.all([
                    $a43d996a7aa8a839$var$findIcon(iconName, prefix),
                    mask.iconName ? $a43d996a7aa8a839$var$findIcon(mask.iconName, mask.prefix) : Promise.resolve({
                        found: false,
                        width: 512,
                        height: 512,
                        icon: {}
                    })
                ]).then(function(_ref) {
                    var _ref2 = $a43d996a7aa8a839$var$_slicedToArray(_ref, 2), main = _ref2[0], mask = _ref2[1];
                    resolve([
                        node,
                        $a43d996a7aa8a839$var$makeInlineSvgAbstract({
                            icons: {
                                main: main,
                                mask: mask
                            },
                            prefix: prefix,
                            iconName: iconName,
                            transform: transform,
                            symbol: symbol,
                            maskId: maskId,
                            title: title,
                            titleId: titleId,
                            extra: extra,
                            watchable: true
                        })
                    ]);
                }).catch(reject);
            });
        };
        providers$$1.generateAbstractIcon = function(_ref3) {
            var children = _ref3.children, attributes = _ref3.attributes, main = _ref3.main, transform = _ref3.transform, styles = _ref3.styles;
            var styleString = $a43d996a7aa8a839$var$joinStyles(styles);
            if (styleString.length > 0) attributes["style"] = styleString;
            var nextChild;
            if ($a43d996a7aa8a839$var$transformIsMeaningful(transform)) nextChild = $a43d996a7aa8a839$var$callProvided("generateAbstractTransformGrouping", {
                main: main,
                transform: transform,
                containerWidth: main.width,
                iconWidth: main.width
            });
            children.push(nextChild || main.icon);
            return {
                children: children,
                attributes: attributes
            };
        };
    }
};
var $a43d996a7aa8a839$var$Layers = {
    mixout: function mixout() {
        return {
            layer: function layer(assembler) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var _params$classes = params.classes, classes = _params$classes === void 0 ? [] : _params$classes;
                return $a43d996a7aa8a839$var$domVariants({
                    type: "layer"
                }, function() {
                    $a43d996a7aa8a839$var$callHooks("beforeDOMElementCreation", {
                        assembler: assembler,
                        params: params
                    });
                    var children = [];
                    assembler(function(args) {
                        Array.isArray(args) ? args.map(function(a) {
                            children = children.concat(a.abstract);
                        }) : children = children.concat(args.abstract);
                    });
                    return [
                        {
                            tag: "span",
                            attributes: {
                                class: [
                                    "".concat($a43d996a7aa8a839$var$config.cssPrefix, "-layers")
                                ].concat($a43d996a7aa8a839$var$_toConsumableArray(classes)).join(" ")
                            },
                            children: children
                        }
                    ];
                });
            }
        };
    }
};
var $a43d996a7aa8a839$var$LayersCounter = {
    mixout: function mixout() {
        return {
            counter: function counter(content) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var _params$title = params.title, title = _params$title === void 0 ? null : _params$title, _params$classes = params.classes, classes = _params$classes === void 0 ? [] : _params$classes, _params$attributes = params.attributes, attributes = _params$attributes === void 0 ? {} : _params$attributes, _params$styles = params.styles, styles = _params$styles === void 0 ? {} : _params$styles;
                return $a43d996a7aa8a839$var$domVariants({
                    type: "counter",
                    content: content
                }, function() {
                    $a43d996a7aa8a839$var$callHooks("beforeDOMElementCreation", {
                        content: content,
                        params: params
                    });
                    return $a43d996a7aa8a839$var$makeLayersCounterAbstract({
                        content: content.toString(),
                        title: title,
                        extra: {
                            attributes: attributes,
                            styles: styles,
                            classes: [
                                "".concat($a43d996a7aa8a839$var$config.cssPrefix, "-layers-counter")
                            ].concat($a43d996a7aa8a839$var$_toConsumableArray(classes))
                        }
                    });
                });
            }
        };
    }
};
var $a43d996a7aa8a839$var$LayersText = {
    mixout: function mixout() {
        return {
            text: function text(content) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var _params$transform = params.transform, transform = _params$transform === void 0 ? $a43d996a7aa8a839$var$meaninglessTransform : _params$transform, _params$title = params.title, title = _params$title === void 0 ? null : _params$title, _params$classes = params.classes, classes = _params$classes === void 0 ? [] : _params$classes, _params$attributes = params.attributes, attributes = _params$attributes === void 0 ? {} : _params$attributes, _params$styles = params.styles, styles = _params$styles === void 0 ? {} : _params$styles;
                return $a43d996a7aa8a839$var$domVariants({
                    type: "text",
                    content: content
                }, function() {
                    $a43d996a7aa8a839$var$callHooks("beforeDOMElementCreation", {
                        content: content,
                        params: params
                    });
                    return $a43d996a7aa8a839$var$makeLayersTextAbstract({
                        content: content,
                        transform: $a43d996a7aa8a839$var$_objectSpread2($a43d996a7aa8a839$var$_objectSpread2({}, $a43d996a7aa8a839$var$meaninglessTransform), transform),
                        title: title,
                        extra: {
                            attributes: attributes,
                            styles: styles,
                            classes: [
                                "".concat($a43d996a7aa8a839$var$config.cssPrefix, "-layers-text")
                            ].concat($a43d996a7aa8a839$var$_toConsumableArray(classes))
                        }
                    });
                });
            }
        };
    },
    provides: function provides(providers$$1) {
        providers$$1.generateLayersText = function(node, nodeMeta) {
            var title = nodeMeta.title, transform = nodeMeta.transform, extra = nodeMeta.extra;
            var width = null;
            var height = null;
            if ($a43d996a7aa8a839$var$IS_IE) {
                var computedFontSize = parseInt(getComputedStyle(node).fontSize, 10);
                var boundingClientRect = node.getBoundingClientRect();
                width = boundingClientRect.width / computedFontSize;
                height = boundingClientRect.height / computedFontSize;
            }
            if ($a43d996a7aa8a839$var$config.autoA11y && !title) extra.attributes["aria-hidden"] = "true";
            return Promise.resolve([
                node,
                $a43d996a7aa8a839$var$makeLayersTextAbstract({
                    content: node.innerHTML,
                    width: width,
                    height: height,
                    transform: transform,
                    title: title,
                    extra: extra,
                    watchable: true
                })
            ]);
        };
    }
};
var $a43d996a7aa8a839$var$CLEAN_CONTENT_PATTERN = new RegExp('"', "ug");
var $a43d996a7aa8a839$var$SECONDARY_UNICODE_RANGE = [
    1105920,
    1112319
];
function $a43d996a7aa8a839$var$hexValueFromContent(content) {
    var cleaned = content.replace($a43d996a7aa8a839$var$CLEAN_CONTENT_PATTERN, "");
    var codePoint = $a43d996a7aa8a839$var$codePointAt(cleaned, 0);
    var isPrependTen = codePoint >= $a43d996a7aa8a839$var$SECONDARY_UNICODE_RANGE[0] && codePoint <= $a43d996a7aa8a839$var$SECONDARY_UNICODE_RANGE[1];
    var isDoubled = cleaned.length === 2 ? cleaned[0] === cleaned[1] : false;
    return {
        value: isDoubled ? $a43d996a7aa8a839$var$toHex(cleaned[0]) : $a43d996a7aa8a839$var$toHex(cleaned),
        isSecondary: isPrependTen || isDoubled
    };
}
function $a43d996a7aa8a839$var$replaceForPosition(node, position) {
    var pendingAttribute = "".concat($a43d996a7aa8a839$var$DATA_FA_PSEUDO_ELEMENT_PENDING).concat(position.replace(":", "-"));
    return new Promise(function(resolve, reject) {
        if (node.getAttribute(pendingAttribute) !== null) // This node is already being processed
        return resolve();
        var children = $a43d996a7aa8a839$var$toArray(node.children);
        var alreadyProcessedPseudoElement = children.filter(function(c) {
            return c.getAttribute($a43d996a7aa8a839$var$DATA_FA_PSEUDO_ELEMENT) === position;
        })[0];
        var styles = $a43d996a7aa8a839$var$WINDOW.getComputedStyle(node, position);
        var fontFamily = styles.getPropertyValue("font-family").match($a43d996a7aa8a839$var$FONT_FAMILY_PATTERN);
        var fontWeight = styles.getPropertyValue("font-weight");
        var content = styles.getPropertyValue("content");
        if (alreadyProcessedPseudoElement && !fontFamily) {
            // If we've already processed it but the current computed style does not result in a font-family,
            // that probably means that a class name that was previously present to make the icon has been
            // removed. So we now should delete the icon.
            node.removeChild(alreadyProcessedPseudoElement);
            return resolve();
        } else if (fontFamily && content !== "none" && content !== "") {
            var _content = styles.getPropertyValue("content");
            var family = ~[
                "Sharp"
            ].indexOf(fontFamily[2]) ? $a43d996a7aa8a839$var$FAMILY_SHARP : $a43d996a7aa8a839$var$FAMILY_CLASSIC;
            var prefix = ~[
                "Solid",
                "Regular",
                "Light",
                "Thin",
                "Duotone",
                "Brands",
                "Kit"
            ].indexOf(fontFamily[2]) ? $a43d996a7aa8a839$var$STYLE_TO_PREFIX[family][fontFamily[2].toLowerCase()] : $a43d996a7aa8a839$var$FONT_WEIGHT_TO_PREFIX[family][fontWeight];
            var _hexValueFromContent = $a43d996a7aa8a839$var$hexValueFromContent(_content), hexValue = _hexValueFromContent.value, isSecondary = _hexValueFromContent.isSecondary;
            var isV4 = fontFamily[0].startsWith("FontAwesome");
            var iconName = $a43d996a7aa8a839$var$byUnicode(prefix, hexValue);
            var iconIdentifier = iconName;
            if (isV4) {
                var iconName4 = $a43d996a7aa8a839$var$byOldUnicode(hexValue);
                if (iconName4.iconName && iconName4.prefix) {
                    iconName = iconName4.iconName;
                    prefix = iconName4.prefix;
                }
            } // Only convert the pseudo element in this ::before/::after position into an icon if we haven't
            // already done so with the same prefix and iconName
            if (iconName && !isSecondary && (!alreadyProcessedPseudoElement || alreadyProcessedPseudoElement.getAttribute($a43d996a7aa8a839$var$DATA_PREFIX) !== prefix || alreadyProcessedPseudoElement.getAttribute($a43d996a7aa8a839$var$DATA_ICON) !== iconIdentifier)) {
                node.setAttribute(pendingAttribute, iconIdentifier);
                if (alreadyProcessedPseudoElement) // Delete the old one, since we're replacing it with a new one
                node.removeChild(alreadyProcessedPseudoElement);
                var meta = $a43d996a7aa8a839$var$blankMeta();
                var extra = meta.extra;
                extra.attributes[$a43d996a7aa8a839$var$DATA_FA_PSEUDO_ELEMENT] = position;
                $a43d996a7aa8a839$var$findIcon(iconName, prefix).then(function(main) {
                    var _abstract = $a43d996a7aa8a839$var$makeInlineSvgAbstract($a43d996a7aa8a839$var$_objectSpread2($a43d996a7aa8a839$var$_objectSpread2({}, meta), {}, {
                        icons: {
                            main: main,
                            mask: $a43d996a7aa8a839$var$emptyCanonicalIcon()
                        },
                        prefix: prefix,
                        iconName: iconIdentifier,
                        extra: extra,
                        watchable: true
                    }));
                    var element = $a43d996a7aa8a839$var$DOCUMENT.createElementNS("http://www.w3.org/2000/svg", "svg");
                    if (position === "::before") node.insertBefore(element, node.firstChild);
                    else node.appendChild(element);
                    element.outerHTML = _abstract.map(function(a) {
                        return $a43d996a7aa8a839$var$toHtml(a);
                    }).join("\n");
                    node.removeAttribute(pendingAttribute);
                    resolve();
                }).catch(reject);
            } else resolve();
        } else resolve();
    });
}
function $a43d996a7aa8a839$var$replace(node) {
    return Promise.all([
        $a43d996a7aa8a839$var$replaceForPosition(node, "::before"),
        $a43d996a7aa8a839$var$replaceForPosition(node, "::after")
    ]);
}
function $a43d996a7aa8a839$var$processable(node) {
    return node.parentNode !== document.head && !~$a43d996a7aa8a839$var$TAGNAMES_TO_SKIP_FOR_PSEUDOELEMENTS.indexOf(node.tagName.toUpperCase()) && !node.getAttribute($a43d996a7aa8a839$var$DATA_FA_PSEUDO_ELEMENT) && (!node.parentNode || node.parentNode.tagName !== "svg");
}
function $a43d996a7aa8a839$var$searchPseudoElements(root) {
    if (!$a43d996a7aa8a839$var$IS_DOM) return;
    return new Promise(function(resolve, reject) {
        var operations = $a43d996a7aa8a839$var$toArray(root.querySelectorAll("*")).filter($a43d996a7aa8a839$var$processable).map($a43d996a7aa8a839$var$replace);
        var end = $a43d996a7aa8a839$var$perf.begin("searchPseudoElements");
        $a43d996a7aa8a839$var$disableObservation();
        Promise.all(operations).then(function() {
            end();
            $a43d996a7aa8a839$var$enableObservation();
            resolve();
        }).catch(function() {
            end();
            $a43d996a7aa8a839$var$enableObservation();
            reject();
        });
    });
}
var $a43d996a7aa8a839$var$PseudoElements = {
    hooks: function hooks() {
        return {
            mutationObserverCallbacks: function mutationObserverCallbacks(accumulator) {
                accumulator.pseudoElementsCallback = $a43d996a7aa8a839$var$searchPseudoElements;
                return accumulator;
            }
        };
    },
    provides: function provides(providers$$1) {
        providers$$1.pseudoElements2svg = function(params) {
            var _params$node = params.node, node = _params$node === void 0 ? $a43d996a7aa8a839$var$DOCUMENT : _params$node;
            if ($a43d996a7aa8a839$var$config.searchPseudoElements) $a43d996a7aa8a839$var$searchPseudoElements(node);
        };
    }
};
var $a43d996a7aa8a839$var$_unwatched = false;
var $a43d996a7aa8a839$var$MutationObserver$1 = {
    mixout: function mixout() {
        return {
            dom: {
                unwatch: function unwatch() {
                    $a43d996a7aa8a839$var$disableObservation();
                    $a43d996a7aa8a839$var$_unwatched = true;
                }
            }
        };
    },
    hooks: function hooks() {
        return {
            bootstrap: function bootstrap() {
                $a43d996a7aa8a839$var$observe($a43d996a7aa8a839$var$chainHooks("mutationObserverCallbacks", {}));
            },
            noAuto: function noAuto() {
                $a43d996a7aa8a839$var$disconnect();
            },
            watch: function watch(params) {
                var observeMutationsRoot = params.observeMutationsRoot;
                if ($a43d996a7aa8a839$var$_unwatched) $a43d996a7aa8a839$var$enableObservation();
                else $a43d996a7aa8a839$var$observe($a43d996a7aa8a839$var$chainHooks("mutationObserverCallbacks", {
                    observeMutationsRoot: observeMutationsRoot
                }));
            }
        };
    }
};
var $a43d996a7aa8a839$var$parseTransformString = function parseTransformString(transformString) {
    var transform = {
        size: 16,
        x: 0,
        y: 0,
        flipX: false,
        flipY: false,
        rotate: 0
    };
    return transformString.toLowerCase().split(" ").reduce(function(acc, n) {
        var parts = n.toLowerCase().split("-");
        var first = parts[0];
        var rest = parts.slice(1).join("-");
        if (first && rest === "h") {
            acc.flipX = true;
            return acc;
        }
        if (first && rest === "v") {
            acc.flipY = true;
            return acc;
        }
        rest = parseFloat(rest);
        if (isNaN(rest)) return acc;
        switch(first){
            case "grow":
                acc.size = acc.size + rest;
                break;
            case "shrink":
                acc.size = acc.size - rest;
                break;
            case "left":
                acc.x = acc.x - rest;
                break;
            case "right":
                acc.x = acc.x + rest;
                break;
            case "up":
                acc.y = acc.y - rest;
                break;
            case "down":
                acc.y = acc.y + rest;
                break;
            case "rotate":
                acc.rotate = acc.rotate + rest;
                break;
        }
        return acc;
    }, transform);
};
var $a43d996a7aa8a839$var$PowerTransforms = {
    mixout: function mixout() {
        return {
            parse: {
                transform: function transform(transformString) {
                    return $a43d996a7aa8a839$var$parseTransformString(transformString);
                }
            }
        };
    },
    hooks: function hooks() {
        return {
            parseNodeAttributes: function parseNodeAttributes(accumulator, node) {
                var transformString = node.getAttribute("data-fa-transform");
                if (transformString) accumulator.transform = $a43d996a7aa8a839$var$parseTransformString(transformString);
                return accumulator;
            }
        };
    },
    provides: function provides(providers) {
        providers.generateAbstractTransformGrouping = function(_ref) {
            var main = _ref.main, transform = _ref.transform, containerWidth = _ref.containerWidth, iconWidth = _ref.iconWidth;
            var outer = {
                transform: "translate(".concat(containerWidth / 2, " 256)")
            };
            var innerTranslate = "translate(".concat(transform.x * 32, ", ").concat(transform.y * 32, ") ");
            var innerScale = "scale(".concat(transform.size / 16 * (transform.flipX ? -1 : 1), ", ").concat(transform.size / 16 * (transform.flipY ? -1 : 1), ") ");
            var innerRotate = "rotate(".concat(transform.rotate, " 0 0)");
            var inner = {
                transform: "".concat(innerTranslate, " ").concat(innerScale, " ").concat(innerRotate)
            };
            var path = {
                transform: "translate(".concat(iconWidth / 2 * -1, " -256)")
            };
            var operations = {
                outer: outer,
                inner: inner,
                path: path
            };
            return {
                tag: "g",
                attributes: $a43d996a7aa8a839$var$_objectSpread2({}, operations.outer),
                children: [
                    {
                        tag: "g",
                        attributes: $a43d996a7aa8a839$var$_objectSpread2({}, operations.inner),
                        children: [
                            {
                                tag: main.icon.tag,
                                children: main.icon.children,
                                attributes: $a43d996a7aa8a839$var$_objectSpread2($a43d996a7aa8a839$var$_objectSpread2({}, main.icon.attributes), operations.path)
                            }
                        ]
                    }
                ]
            };
        };
    }
};
var $a43d996a7aa8a839$var$ALL_SPACE = {
    x: 0,
    y: 0,
    width: "100%",
    height: "100%"
};
function $a43d996a7aa8a839$var$fillBlack(_abstract) {
    var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    if (_abstract.attributes && (_abstract.attributes.fill || force)) _abstract.attributes.fill = "black";
    return _abstract;
}
function $a43d996a7aa8a839$var$deGroup(_abstract2) {
    if (_abstract2.tag === "g") return _abstract2.children;
    else return [
        _abstract2
    ];
}
var $a43d996a7aa8a839$var$Masks = {
    hooks: function hooks() {
        return {
            parseNodeAttributes: function parseNodeAttributes(accumulator, node) {
                var maskData = node.getAttribute("data-fa-mask");
                var mask = !maskData ? $a43d996a7aa8a839$var$emptyCanonicalIcon() : $a43d996a7aa8a839$var$getCanonicalIcon(maskData.split(" ").map(function(i) {
                    return i.trim();
                }));
                if (!mask.prefix) mask.prefix = $a43d996a7aa8a839$var$getDefaultUsablePrefix();
                accumulator.mask = mask;
                accumulator.maskId = node.getAttribute("data-fa-mask-id");
                return accumulator;
            }
        };
    },
    provides: function provides(providers) {
        providers.generateAbstractMask = function(_ref) {
            var children = _ref.children, attributes = _ref.attributes, main = _ref.main, mask = _ref.mask, explicitMaskId = _ref.maskId, transform = _ref.transform;
            var mainWidth = main.width, mainPath = main.icon;
            var maskWidth = mask.width, maskPath = mask.icon;
            var trans = $a43d996a7aa8a839$var$transformForSvg({
                transform: transform,
                containerWidth: maskWidth,
                iconWidth: mainWidth
            });
            var maskRect = {
                tag: "rect",
                attributes: $a43d996a7aa8a839$var$_objectSpread2($a43d996a7aa8a839$var$_objectSpread2({}, $a43d996a7aa8a839$var$ALL_SPACE), {}, {
                    fill: "white"
                })
            };
            var maskInnerGroupChildrenMixin = mainPath.children ? {
                children: mainPath.children.map($a43d996a7aa8a839$var$fillBlack)
            } : {};
            var maskInnerGroup = {
                tag: "g",
                attributes: $a43d996a7aa8a839$var$_objectSpread2({}, trans.inner),
                children: [
                    $a43d996a7aa8a839$var$fillBlack($a43d996a7aa8a839$var$_objectSpread2({
                        tag: mainPath.tag,
                        attributes: $a43d996a7aa8a839$var$_objectSpread2($a43d996a7aa8a839$var$_objectSpread2({}, mainPath.attributes), trans.path)
                    }, maskInnerGroupChildrenMixin))
                ]
            };
            var maskOuterGroup = {
                tag: "g",
                attributes: $a43d996a7aa8a839$var$_objectSpread2({}, trans.outer),
                children: [
                    maskInnerGroup
                ]
            };
            var maskId = "mask-".concat(explicitMaskId || $a43d996a7aa8a839$var$nextUniqueId());
            var clipId = "clip-".concat(explicitMaskId || $a43d996a7aa8a839$var$nextUniqueId());
            var maskTag = {
                tag: "mask",
                attributes: $a43d996a7aa8a839$var$_objectSpread2($a43d996a7aa8a839$var$_objectSpread2({}, $a43d996a7aa8a839$var$ALL_SPACE), {}, {
                    id: maskId,
                    maskUnits: "userSpaceOnUse",
                    maskContentUnits: "userSpaceOnUse"
                }),
                children: [
                    maskRect,
                    maskOuterGroup
                ]
            };
            var defs = {
                tag: "defs",
                children: [
                    {
                        tag: "clipPath",
                        attributes: {
                            id: clipId
                        },
                        children: $a43d996a7aa8a839$var$deGroup(maskPath)
                    },
                    maskTag
                ]
            };
            children.push(defs, {
                tag: "rect",
                attributes: $a43d996a7aa8a839$var$_objectSpread2({
                    fill: "currentColor",
                    "clip-path": "url(#".concat(clipId, ")"),
                    mask: "url(#".concat(maskId, ")")
                }, $a43d996a7aa8a839$var$ALL_SPACE)
            });
            return {
                children: children,
                attributes: attributes
            };
        };
    }
};
var $a43d996a7aa8a839$var$MissingIconIndicator = {
    provides: function provides(providers) {
        var reduceMotion = false;
        if ($a43d996a7aa8a839$var$WINDOW.matchMedia) reduceMotion = $a43d996a7aa8a839$var$WINDOW.matchMedia("(prefers-reduced-motion: reduce)").matches;
        providers.missingIconAbstract = function() {
            var gChildren = [];
            var FILL = {
                fill: "currentColor"
            };
            var ANIMATION_BASE = {
                attributeType: "XML",
                repeatCount: "indefinite",
                dur: "2s"
            }; // Ring
            gChildren.push({
                tag: "path",
                attributes: $a43d996a7aa8a839$var$_objectSpread2($a43d996a7aa8a839$var$_objectSpread2({}, FILL), {}, {
                    d: "M156.5,447.7l-12.6,29.5c-18.7-9.5-35.9-21.2-51.5-34.9l22.7-22.7C127.6,430.5,141.5,440,156.5,447.7z M40.6,272H8.5 c1.4,21.2,5.4,41.7,11.7,61.1L50,321.2C45.1,305.5,41.8,289,40.6,272z M40.6,240c1.4-18.8,5.2-37,11.1-54.1l-29.5-12.6 C14.7,194.3,10,216.7,8.5,240H40.6z M64.3,156.5c7.8-14.9,17.2-28.8,28.1-41.5L69.7,92.3c-13.7,15.6-25.5,32.8-34.9,51.5 L64.3,156.5z M397,419.6c-13.9,12-29.4,22.3-46.1,30.4l11.9,29.8c20.7-9.9,39.8-22.6,56.9-37.6L397,419.6z M115,92.4 c13.9-12,29.4-22.3,46.1-30.4l-11.9-29.8c-20.7,9.9-39.8,22.6-56.8,37.6L115,92.4z M447.7,355.5c-7.8,14.9-17.2,28.8-28.1,41.5 l22.7,22.7c13.7-15.6,25.5-32.9,34.9-51.5L447.7,355.5z M471.4,272c-1.4,18.8-5.2,37-11.1,54.1l29.5,12.6 c7.5-21.1,12.2-43.5,13.6-66.8H471.4z M321.2,462c-15.7,5-32.2,8.2-49.2,9.4v32.1c21.2-1.4,41.7-5.4,61.1-11.7L321.2,462z M240,471.4c-18.8-1.4-37-5.2-54.1-11.1l-12.6,29.5c21.1,7.5,43.5,12.2,66.8,13.6V471.4z M462,190.8c5,15.7,8.2,32.2,9.4,49.2h32.1 c-1.4-21.2-5.4-41.7-11.7-61.1L462,190.8z M92.4,397c-12-13.9-22.3-29.4-30.4-46.1l-29.8,11.9c9.9,20.7,22.6,39.8,37.6,56.9 L92.4,397z M272,40.6c18.8,1.4,36.9,5.2,54.1,11.1l12.6-29.5C317.7,14.7,295.3,10,272,8.5V40.6z M190.8,50 c15.7-5,32.2-8.2,49.2-9.4V8.5c-21.2,1.4-41.7,5.4-61.1,11.7L190.8,50z M442.3,92.3L419.6,115c12,13.9,22.3,29.4,30.5,46.1 l29.8-11.9C470,128.5,457.3,109.4,442.3,92.3z M397,92.4l22.7-22.7c-15.6-13.7-32.8-25.5-51.5-34.9l-12.6,29.5 C370.4,72.1,384.4,81.5,397,92.4z"
                })
            });
            var OPACITY_ANIMATE = $a43d996a7aa8a839$var$_objectSpread2($a43d996a7aa8a839$var$_objectSpread2({}, ANIMATION_BASE), {}, {
                attributeName: "opacity"
            });
            var dot = {
                tag: "circle",
                attributes: $a43d996a7aa8a839$var$_objectSpread2($a43d996a7aa8a839$var$_objectSpread2({}, FILL), {}, {
                    cx: "256",
                    cy: "364",
                    r: "28"
                }),
                children: []
            };
            if (!reduceMotion) dot.children.push({
                tag: "animate",
                attributes: $a43d996a7aa8a839$var$_objectSpread2($a43d996a7aa8a839$var$_objectSpread2({}, ANIMATION_BASE), {}, {
                    attributeName: "r",
                    values: "28;14;28;28;14;28;"
                })
            }, {
                tag: "animate",
                attributes: $a43d996a7aa8a839$var$_objectSpread2($a43d996a7aa8a839$var$_objectSpread2({}, OPACITY_ANIMATE), {}, {
                    values: "1;0;1;1;0;1;"
                })
            });
            gChildren.push(dot);
            gChildren.push({
                tag: "path",
                attributes: $a43d996a7aa8a839$var$_objectSpread2($a43d996a7aa8a839$var$_objectSpread2({}, FILL), {}, {
                    opacity: "1",
                    d: "M263.7,312h-16c-6.6,0-12-5.4-12-12c0-71,77.4-63.9,77.4-107.8c0-20-17.8-40.2-57.4-40.2c-29.1,0-44.3,9.6-59.2,28.7 c-3.9,5-11.1,6-16.2,2.4l-13.1-9.2c-5.6-3.9-6.9-11.8-2.6-17.2c21.2-27.2,46.4-44.7,91.2-44.7c52.3,0,97.4,29.8,97.4,80.2 c0,67.6-77.4,63.5-77.4,107.8C275.7,306.6,270.3,312,263.7,312z"
                }),
                children: reduceMotion ? [] : [
                    {
                        tag: "animate",
                        attributes: $a43d996a7aa8a839$var$_objectSpread2($a43d996a7aa8a839$var$_objectSpread2({}, OPACITY_ANIMATE), {}, {
                            values: "1;0;0;0;0;1;"
                        })
                    }
                ]
            });
            if (!reduceMotion) // Exclamation
            gChildren.push({
                tag: "path",
                attributes: $a43d996a7aa8a839$var$_objectSpread2($a43d996a7aa8a839$var$_objectSpread2({}, FILL), {}, {
                    opacity: "0",
                    d: "M232.5,134.5l7,168c0.3,6.4,5.6,11.5,12,11.5h9c6.4,0,11.7-5.1,12-11.5l7-168c0.3-6.8-5.2-12.5-12-12.5h-23 C237.7,122,232.2,127.7,232.5,134.5z"
                }),
                children: [
                    {
                        tag: "animate",
                        attributes: $a43d996a7aa8a839$var$_objectSpread2($a43d996a7aa8a839$var$_objectSpread2({}, OPACITY_ANIMATE), {}, {
                            values: "0;0;1;1;0;0;"
                        })
                    }
                ]
            });
            return {
                tag: "g",
                attributes: {
                    "class": "missing"
                },
                children: gChildren
            };
        };
    }
};
var $a43d996a7aa8a839$var$SvgSymbols = {
    hooks: function hooks() {
        return {
            parseNodeAttributes: function parseNodeAttributes(accumulator, node) {
                var symbolData = node.getAttribute("data-fa-symbol");
                var symbol = symbolData === null ? false : symbolData === "" ? true : symbolData;
                accumulator["symbol"] = symbol;
                return accumulator;
            }
        };
    }
};
var $a43d996a7aa8a839$var$plugins = [
    $a43d996a7aa8a839$var$InjectCSS,
    $a43d996a7aa8a839$var$ReplaceElements,
    $a43d996a7aa8a839$var$Layers,
    $a43d996a7aa8a839$var$LayersCounter,
    $a43d996a7aa8a839$var$LayersText,
    $a43d996a7aa8a839$var$PseudoElements,
    $a43d996a7aa8a839$var$MutationObserver$1,
    $a43d996a7aa8a839$var$PowerTransforms,
    $a43d996a7aa8a839$var$Masks,
    $a43d996a7aa8a839$var$MissingIconIndicator,
    $a43d996a7aa8a839$var$SvgSymbols
];
$a43d996a7aa8a839$var$registerPlugins($a43d996a7aa8a839$var$plugins, {
    mixoutsTo: $a43d996a7aa8a839$export$644d8ea042df96a6
});
var $a43d996a7aa8a839$export$4f8e844b2782642c = $a43d996a7aa8a839$export$644d8ea042df96a6.noAuto;
var $a43d996a7aa8a839$export$e506a1d27d1eaa20 = $a43d996a7aa8a839$export$644d8ea042df96a6.config;
var $a43d996a7aa8a839$export$b839f963c7dc0e34 = $a43d996a7aa8a839$export$644d8ea042df96a6.library;
var $a43d996a7aa8a839$export$df3a06d6289f983e = $a43d996a7aa8a839$export$644d8ea042df96a6.dom;
var $a43d996a7aa8a839$export$98e6a39c04603d36 = $a43d996a7aa8a839$export$644d8ea042df96a6.parse;
var $a43d996a7aa8a839$export$221fed4a47f597a5 = $a43d996a7aa8a839$export$644d8ea042df96a6.findIconDefinition;
var $a43d996a7aa8a839$export$a10125c086a4df16 = $a43d996a7aa8a839$export$644d8ea042df96a6.toHtml;
var $a43d996a7aa8a839$export$1ca1ec8b29a4ce27 = $a43d996a7aa8a839$export$644d8ea042df96a6.icon;
var $a43d996a7aa8a839$export$50a222d9023da98b = $a43d996a7aa8a839$export$644d8ea042df96a6.layer;
var $a43d996a7aa8a839$export$6f093cfa640b7166 = $a43d996a7aa8a839$export$644d8ea042df96a6.text;
var $a43d996a7aa8a839$export$e575061ef2a070eb = $a43d996a7aa8a839$export$644d8ea042df96a6.counter;


var $8da5bfbbed271cd7$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $8da5bfbbed271cd7$var$ReactIs, $8da5bfbbed271cd7$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
$8da5bfbbed271cd7$exports = (parcelRequire("hOzOt"))();



var $acw62 = parcelRequire("acw62");
function $e4ec753f5c716375$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $e4ec753f5c716375$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $e4ec753f5c716375$var$ownKeys(Object(source), !0).forEach(function(key) {
            $e4ec753f5c716375$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $e4ec753f5c716375$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $e4ec753f5c716375$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $e4ec753f5c716375$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $e4ec753f5c716375$var$_typeof(obj);
}
function $e4ec753f5c716375$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $e4ec753f5c716375$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $e4ec753f5c716375$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $e4ec753f5c716375$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $e4ec753f5c716375$var$_toConsumableArray(arr) {
    return $e4ec753f5c716375$var$_arrayWithoutHoles(arr) || $e4ec753f5c716375$var$_iterableToArray(arr) || $e4ec753f5c716375$var$_unsupportedIterableToArray(arr) || $e4ec753f5c716375$var$_nonIterableSpread();
}
function $e4ec753f5c716375$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $e4ec753f5c716375$var$_arrayLikeToArray(arr);
}
function $e4ec753f5c716375$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $e4ec753f5c716375$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $e4ec753f5c716375$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $e4ec753f5c716375$var$_arrayLikeToArray(o, minLen);
}
function $e4ec753f5c716375$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $e4ec753f5c716375$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
// Get CSS class list from a props object
function $e4ec753f5c716375$var$classList(props) {
    var _classes;
    var beat = props.beat, fade = props.fade, beatFade = props.beatFade, bounce = props.bounce, shake = props.shake, flash = props.flash, spin = props.spin, spinPulse = props.spinPulse, spinReverse = props.spinReverse, pulse = props.pulse, fixedWidth = props.fixedWidth, inverse = props.inverse, border = props.border, listItem = props.listItem, flip = props.flip, size = props.size, rotation = props.rotation, pull = props.pull; // map of CSS class names to properties
    var classes = (_classes = {
        "fa-beat": beat,
        "fa-fade": fade,
        "fa-beat-fade": beatFade,
        "fa-bounce": bounce,
        "fa-shake": shake,
        "fa-flash": flash,
        "fa-spin": spin,
        "fa-spin-reverse": spinReverse,
        "fa-spin-pulse": spinPulse,
        "fa-pulse": pulse,
        "fa-fw": fixedWidth,
        "fa-inverse": inverse,
        "fa-border": border,
        "fa-li": listItem,
        "fa-flip": flip === true,
        "fa-flip-horizontal": flip === "horizontal" || flip === "both",
        "fa-flip-vertical": flip === "vertical" || flip === "both"
    }, $e4ec753f5c716375$var$_defineProperty(_classes, "fa-".concat(size), typeof size !== "undefined" && size !== null), $e4ec753f5c716375$var$_defineProperty(_classes, "fa-rotate-".concat(rotation), typeof rotation !== "undefined" && rotation !== null && rotation !== 0), $e4ec753f5c716375$var$_defineProperty(_classes, "fa-pull-".concat(pull), typeof pull !== "undefined" && pull !== null), $e4ec753f5c716375$var$_defineProperty(_classes, "fa-swap-opacity", props.swapOpacity), _classes); // map over all the keys in the classes object
    // return an array of the keys where the value for the key is not null
    return Object.keys(classes).map(function(key) {
        return classes[key] ? key : null;
    }).filter(function(key) {
        return key;
    });
}
// Camelize taken from humps
// humps is copyright © 2012+ Dom Christie
// Released under the MIT license.
// Performant way to determine if object coerces to a number
function $e4ec753f5c716375$var$_isNumerical(obj) {
    obj = obj - 0; // eslint-disable-next-line no-self-compare
    return obj === obj;
}
function $e4ec753f5c716375$var$camelize(string) {
    if ($e4ec753f5c716375$var$_isNumerical(string)) return string;
     // eslint-disable-next-line no-useless-escape
    string = string.replace(/[\-_\s]+(.)?/g, function(match, chr) {
        return chr ? chr.toUpperCase() : "";
    }); // Ensure 1st char is always lowercase
    return string.substr(0, 1).toLowerCase() + string.substr(1);
}
var $e4ec753f5c716375$var$_excluded = [
    "style"
];
function $e4ec753f5c716375$var$capitalize(val) {
    return val.charAt(0).toUpperCase() + val.slice(1);
}
function $e4ec753f5c716375$var$styleToObject(style) {
    return style.split(";").map(function(s) {
        return s.trim();
    }).filter(function(s) {
        return s;
    }).reduce(function(acc, pair) {
        var i = pair.indexOf(":");
        var prop = $e4ec753f5c716375$var$camelize(pair.slice(0, i));
        var value = pair.slice(i + 1).trim();
        prop.startsWith("webkit") ? acc[$e4ec753f5c716375$var$capitalize(prop)] = value : acc[prop] = value;
        return acc;
    }, {});
}
function $e4ec753f5c716375$var$convert(createElement, element) {
    var extraProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    if (typeof element === "string") return element;
    var children = (element.children || []).map(function(child) {
        return $e4ec753f5c716375$var$convert(createElement, child);
    });
    /* eslint-disable dot-notation */ var mixins = Object.keys(element.attributes || {}).reduce(function(acc, key) {
        var val = element.attributes[key];
        switch(key){
            case "class":
                acc.attrs["className"] = val;
                delete element.attributes["class"];
                break;
            case "style":
                acc.attrs["style"] = $e4ec753f5c716375$var$styleToObject(val);
                break;
            default:
                if (key.indexOf("aria-") === 0 || key.indexOf("data-") === 0) acc.attrs[key.toLowerCase()] = val;
                else acc.attrs[$e4ec753f5c716375$var$camelize(key)] = val;
        }
        return acc;
    }, {
        attrs: {}
    });
    var _extraProps$style = extraProps.style, existingStyle = _extraProps$style === void 0 ? {} : _extraProps$style, remaining = $e4ec753f5c716375$var$_objectWithoutProperties(extraProps, $e4ec753f5c716375$var$_excluded);
    mixins.attrs["style"] = $e4ec753f5c716375$var$_objectSpread2($e4ec753f5c716375$var$_objectSpread2({}, mixins.attrs["style"]), existingStyle);
    /* eslint-enable */ return createElement.apply(void 0, [
        element.tag,
        $e4ec753f5c716375$var$_objectSpread2($e4ec753f5c716375$var$_objectSpread2({}, mixins.attrs), remaining)
    ].concat($e4ec753f5c716375$var$_toConsumableArray(children)));
}
var $e4ec753f5c716375$var$PRODUCTION = false;
try {
    $e4ec753f5c716375$var$PRODUCTION = true;
} catch (e) {}
function $e4ec753f5c716375$var$log() {
    if (!$e4ec753f5c716375$var$PRODUCTION && console && typeof console.error === "function") {
        var _console;
        (_console = console).error.apply(_console, arguments);
    }
}
function $e4ec753f5c716375$var$normalizeIconArgs(icon) {
    // this has everything that it needs to be rendered which means it was probably imported
    // directly from an icon svg package
    if (icon && $e4ec753f5c716375$var$_typeof(icon) === "object" && icon.prefix && icon.iconName && icon.icon) return icon;
    if ((0, $a43d996a7aa8a839$export$98e6a39c04603d36).icon) return (0, $a43d996a7aa8a839$export$98e6a39c04603d36).icon(icon);
     // if the icon is null, there's nothing to do
    if (icon === null) return null;
     // if the icon is an object and has a prefix and an icon name, return it
    if (icon && $e4ec753f5c716375$var$_typeof(icon) === "object" && icon.prefix && icon.iconName) return icon;
     // if it's an array with length of two
    if (Array.isArray(icon) && icon.length === 2) // use the first item as prefix, second as icon name
    return {
        prefix: icon[0],
        iconName: icon[1]
    };
     // if it's a string, use it as the icon name
    if (typeof icon === "string") return {
        prefix: "fas",
        iconName: icon
    };
}
// creates an object with a key of key
// and a value of value
// if certain conditions are met
function $e4ec753f5c716375$var$objectWithKey(key, value) {
    // if the value is a non-empty array
    // or it's not an array but it is truthy
    // then create the object with the key and the value
    // if not, return an empty array
    return Array.isArray(value) && value.length > 0 || !Array.isArray(value) && value ? $e4ec753f5c716375$var$_defineProperty({}, key, value) : {};
}
var $e4ec753f5c716375$export$2b9260d4a45c8710 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function(props, ref) {
    var iconArgs = props.icon, maskArgs = props.mask, symbol = props.symbol, className = props.className, title = props.title, titleId = props.titleId, maskId = props.maskId;
    var iconLookup = $e4ec753f5c716375$var$normalizeIconArgs(iconArgs);
    var classes = $e4ec753f5c716375$var$objectWithKey("classes", [].concat($e4ec753f5c716375$var$_toConsumableArray($e4ec753f5c716375$var$classList(props)), $e4ec753f5c716375$var$_toConsumableArray(className.split(" "))));
    var transform = $e4ec753f5c716375$var$objectWithKey("transform", typeof props.transform === "string" ? (0, $a43d996a7aa8a839$export$98e6a39c04603d36).transform(props.transform) : props.transform);
    var mask = $e4ec753f5c716375$var$objectWithKey("mask", $e4ec753f5c716375$var$normalizeIconArgs(maskArgs));
    var renderedIcon = (0, $a43d996a7aa8a839$export$1ca1ec8b29a4ce27)(iconLookup, $e4ec753f5c716375$var$_objectSpread2($e4ec753f5c716375$var$_objectSpread2($e4ec753f5c716375$var$_objectSpread2($e4ec753f5c716375$var$_objectSpread2({}, classes), transform), mask), {}, {
        symbol: symbol,
        title: title,
        titleId: titleId,
        maskId: maskId
    }));
    if (!renderedIcon) {
        $e4ec753f5c716375$var$log("Could not find icon", iconLookup);
        return null;
    }
    var abstract = renderedIcon.abstract;
    var extraProps = {
        ref: ref
    };
    Object.keys(props).forEach(function(key) {
        // eslint-disable-next-line no-prototype-builtins
        if (!$e4ec753f5c716375$export$2b9260d4a45c8710.defaultProps.hasOwnProperty(key)) extraProps[key] = props[key];
    });
    return $e4ec753f5c716375$var$convertCurry(abstract[0], extraProps);
});
$e4ec753f5c716375$export$2b9260d4a45c8710.displayName = "FontAwesomeIcon";
$e4ec753f5c716375$export$2b9260d4a45c8710.propTypes = {
    beat: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    border: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    beatFade: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    bounce: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    fade: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    flash: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    mask: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).array,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string
    ]),
    maskId: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    fixedWidth: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    inverse: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    flip: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf([
        true,
        false,
        "horizontal",
        "vertical",
        "both"
    ]),
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).array,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string
    ]),
    listItem: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    pull: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf([
        "right",
        "left"
    ]),
    pulse: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    rotation: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf([
        0,
        90,
        180,
        270
    ]),
    shake: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf([
        "2xs",
        "xs",
        "sm",
        "lg",
        "xl",
        "2xl",
        "1x",
        "2x",
        "3x",
        "4x",
        "5x",
        "6x",
        "7x",
        "8x",
        "9x",
        "10x"
    ]),
    spin: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    spinPulse: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    spinReverse: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    symbol: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    titleId: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    transform: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object
    ]),
    swapOpacity: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool
};
$e4ec753f5c716375$export$2b9260d4a45c8710.defaultProps = {
    border: false,
    className: "",
    mask: null,
    maskId: null,
    fixedWidth: false,
    inverse: false,
    flip: false,
    icon: null,
    listItem: false,
    pull: null,
    pulse: false,
    rotation: null,
    size: null,
    spin: false,
    spinPulse: false,
    spinReverse: false,
    beat: false,
    fade: false,
    beatFade: false,
    bounce: false,
    shake: false,
    symbol: false,
    title: "",
    titleId: null,
    transform: null,
    swapOpacity: false
};
var $e4ec753f5c716375$var$convertCurry = $e4ec753f5c716375$var$convert.bind(null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement);


var $6f23581c0aef6dc2$exports = {};

$parcel$export($6f23581c0aef6dc2$exports, "emptyEnv", () => $6f23581c0aef6dc2$export$ae0bd03227ec549f);
$parcel$export($6f23581c0aef6dc2$exports, "isBlock", () => $6f23581c0aef6dc2$export$de5a9e42c1dff8da);
$parcel$export($6f23581c0aef6dc2$exports, "useBlockDispatcher", () => $6f23581c0aef6dc2$export$ece2d8b003194dcc);
$parcel$export($6f23581c0aef6dc2$exports, "create", () => $6f23581c0aef6dc2$export$185802fd694ee1f5);
$parcel$export($6f23581c0aef6dc2$exports, "mapWithEnv", () => $6f23581c0aef6dc2$export$7ebd55fd2b28b5a);
$parcel$export($6f23581c0aef6dc2$exports, "dispatcherToSetter", () => $6f23581c0aef6dc2$export$46fcd87d869db630);
$parcel$export($6f23581c0aef6dc2$exports, "dispatchWhenMatch", () => $6f23581c0aef6dc2$export$486f2ea1e5f66327);
$parcel$export($6f23581c0aef6dc2$exports, "dispatchCaseField", () => $6f23581c0aef6dc2$export$574ac5a1d40355c9);
$parcel$export($6f23581c0aef6dc2$exports, "extractActionDescription", () => $6f23581c0aef6dc2$export$b6ca37fc03181c21);

var $acw62 = parcelRequire("acw62");
var $dc2e80b7ebe4adb5$exports = {};

$parcel$export($dc2e80b7ebe4adb5$exports, "validate", () => $dc2e80b7ebe4adb5$export$a22775fa5e2eebd9);
$parcel$export($dc2e80b7ebe4adb5$exports, "tuple", () => $dc2e80b7ebe4adb5$export$65e3907585753458);
$parcel$export($dc2e80b7ebe4adb5$exports, "loosely", () => $dc2e80b7ebe4adb5$export$5b742f9ac70b1ea3);
$parcel$export($dc2e80b7ebe4adb5$exports, "ValidationError", () => $dc2e80b7ebe4adb5$export$2191b9da168c6cf0);
$parcel$export($dc2e80b7ebe4adb5$exports, "assertValid", () => $dc2e80b7ebe4adb5$export$d855ff590c973c92);
$parcel$export($dc2e80b7ebe4adb5$exports, "strict", () => $dc2e80b7ebe4adb5$export$29be874c1daba180);
$parcel$export($dc2e80b7ebe4adb5$exports, "and", () => $dc2e80b7ebe4adb5$export$21c0ac7fe1cef1b8);
$parcel$export($dc2e80b7ebe4adb5$exports, "or", () => $dc2e80b7ebe4adb5$export$252bb8b3bbdf6749);
$parcel$export($dc2e80b7ebe4adb5$exports, "not", () => $dc2e80b7ebe4adb5$export$6003a5f097c73977);
$parcel$export($dc2e80b7ebe4adb5$exports, "nullable", () => $dc2e80b7ebe4adb5$export$133fc36489ac9add);
$parcel$export($dc2e80b7ebe4adb5$exports, "oneOf", () => $dc2e80b7ebe4adb5$export$a9a18ae5ba42aeab);
$parcel$export($dc2e80b7ebe4adb5$exports, "array", () => $dc2e80b7ebe4adb5$export$2f23118c22fb2630);
$parcel$export($dc2e80b7ebe4adb5$exports, "lazy", () => $dc2e80b7ebe4adb5$export$488013bae63b21da);
$parcel$export($dc2e80b7ebe4adb5$exports, "is", () => $dc2e80b7ebe4adb5$export$226b3eccf92c9ed9);
$parcel$export($dc2e80b7ebe4adb5$exports, "typeis", () => $dc2e80b7ebe4adb5$export$42f353d40f388c19);
$parcel$export($dc2e80b7ebe4adb5$exports, "any", () => $dc2e80b7ebe4adb5$export$4154a199d7d90455);
$parcel$export($dc2e80b7ebe4adb5$exports, "defined", () => $dc2e80b7ebe4adb5$export$43f40ad3fa1d5c97);
$parcel$export($dc2e80b7ebe4adb5$exports, "string", () => $dc2e80b7ebe4adb5$export$22b082955e083ec3);
$parcel$export($dc2e80b7ebe4adb5$exports, "number", () => $dc2e80b7ebe4adb5$export$98e628dec113755e);
$parcel$export($dc2e80b7ebe4adb5$exports, "boolean", () => $dc2e80b7ebe4adb5$export$4a21f16c33752377);
$parcel$export($dc2e80b7ebe4adb5$exports, "validatorSwitch", () => $dc2e80b7ebe4adb5$export$6fc572fe80b0d49c);
// inspired by https://github.com/manvel-khnkoyan/jpv
var $512ec8d668819b2f$exports = {};

$parcel$export($512ec8d668819b2f$exports, "clampBetween", () => $512ec8d668819b2f$export$fc3e3729c0793f12);
$parcel$export($512ec8d668819b2f$exports, "clampTo", () => $512ec8d668819b2f$export$d17171af8942fb21);
$parcel$export($512ec8d668819b2f$exports, "nextElem", () => $512ec8d668819b2f$export$77e0d221223292dc);
$parcel$export($512ec8d668819b2f$exports, "interpolate", () => $512ec8d668819b2f$export$89e29e4ab65e70a9);
$parcel$export($512ec8d668819b2f$exports, "intersperse", () => $512ec8d668819b2f$export$af200dcf8b7cb5de);
$parcel$export($512ec8d668819b2f$exports, "arrayEquals", () => $512ec8d668819b2f$export$22d6d01dd47e89dd);
$parcel$export($512ec8d668819b2f$exports, "arrayStartsWith", () => $512ec8d668819b2f$export$28e46a10850766f0);
$parcel$export($512ec8d668819b2f$exports, "mapObject", () => $512ec8d668819b2f$export$d6051a0f7a227332);
$parcel$export($512ec8d668819b2f$exports, "filterEntries", () => $512ec8d668819b2f$export$e1c26c24c276b1f4);
$parcel$export($512ec8d668819b2f$exports, "areDisjoint", () => $512ec8d668819b2f$export$23cccc239d174dbc);
$parcel$export($512ec8d668819b2f$exports, "flatObj", () => $512ec8d668819b2f$export$b7f59998ebbc3be7);
$parcel$export($512ec8d668819b2f$exports, "isEqualDepth", () => $512ec8d668819b2f$export$1ffefdb29429119e);
$parcel$export($512ec8d668819b2f$exports, "stringify", () => $512ec8d668819b2f$export$fac44ee5b035f737);
$parcel$export($512ec8d668819b2f$exports, "stringifyFields", () => $512ec8d668819b2f$export$7e96d4cabba4fc13);
$parcel$export($512ec8d668819b2f$exports, "uint8ArrayToBase64", () => $512ec8d668819b2f$export$36bac84b1c2da9c7);
$parcel$export($512ec8d668819b2f$exports, "base64ToUint8Array", () => $512ec8d668819b2f$export$f01069a3c307e50e);
$parcel$export($512ec8d668819b2f$exports, "isPromise", () => $512ec8d668819b2f$export$4369c812aac99591);

var $f1q41 = parcelRequire("f1q41");
function $512ec8d668819b2f$export$fc3e3729c0793f12(minimumInclusive, maximumInclusive, value) {
    if (value < minimumInclusive) return minimumInclusive;
    if (value > maximumInclusive) return maximumInclusive;
    return value;
}
function $512ec8d668819b2f$export$d17171af8942fb21(minimumInclusive, maximumExclusive, value) {
    if (value < minimumInclusive) return minimumInclusive;
    if (value >= maximumExclusive) return maximumExclusive - 1;
    return value;
}
function $512ec8d668819b2f$export$77e0d221223292dc(elem, allElems, eq, delta = 1) {
    const elemIdx = eq ? allElems.findIndex((e)=>eq(e, elem)) : allElems.findIndex((e)=>e === elem);
    const nextElemIdx = (elemIdx + delta + allElems.length) % allElems.length;
    return allElems[nextElemIdx];
}
function $512ec8d668819b2f$export$89e29e4ab65e70a9(strings, interpolations, props) {
    const computedInterpolations = interpolations.map((interpolation)=>{
        if (typeof interpolation === "function") return String(interpolation(props));
        else return String(interpolation);
    });
    return strings.reduce((prev, string, idx)=>prev.concat(string, computedInterpolations[idx] ?? ""), "");
}
function $512ec8d668819b2f$export$af200dcf8b7cb5de(elem, array) {
    return array.flatMap((item)=>[
            elem,
            item
        ]).slice(1);
}
function $512ec8d668819b2f$export$22d6d01dd47e89dd(arr1, arr2, eq) {
    if (arr1 === arr2) return true;
    if (arr1.length !== arr2.length) return false;
    if (!eq) for(let i = 0; i < arr1.length; i++){
        if (arr1[i] !== arr2[i]) return false;
    }
    else for(let i = 0; i < arr1.length; i++){
        if (!eq(arr1[i], arr2[i])) return false;
    }
    return true;
}
function $512ec8d668819b2f$export$28e46a10850766f0(prefix, array, eq) {
    return $512ec8d668819b2f$export$22d6d01dd47e89dd(prefix, array.slice(0, prefix.length), eq);
}
function $512ec8d668819b2f$export$d6051a0f7a227332(obj, fn) {
    return Object.fromEntries(Object.entries(obj).map((entry)=>fn(...entry)));
}
function $512ec8d668819b2f$export$e1c26c24c276b1f4(predicate, obj) {
    return Object.fromEntries(Object.entries(obj).filter((entry)=>predicate(...entry)));
}
function $512ec8d668819b2f$export$23cccc239d174dbc(set1, set2) {
    const [smallerSet, biggerSet] = set1.size < set2.size ? [
        set1,
        set2
    ] : [
        set2,
        set1
    ];
    for (const key of smallerSet.keys()){
        if (biggerSet.has(key)) return false;
    }
    return true;
}
function $512ec8d668819b2f$export$b7f59998ebbc3be7(value, visited = new Set()) {
    if (visited.has(value)) return value;
    else if (typeof value === "object" && value !== null) {
        visited.add(value);
        return Object.fromEntries(Object.entries(value).flatMap(([key, field])=>{
            const flatField = $512ec8d668819b2f$export$b7f59998ebbc3be7(field, visited);
            if (typeof flatField === "object" && flatField !== null) return Object.entries(flatField).map(([subkey, subfield])=>[
                    `${key}.${subkey}`,
                    subfield
                ]);
            else return [
                [
                    key,
                    flatField
                ]
            ];
        }));
    } else return value;
}
function $512ec8d668819b2f$export$1ffefdb29429119e(l, r, depth) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).isEqualWith(l, r, (l, r, _key, _objL, _objR, stack)=>{
        if ((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).toPath(stack).length >= depth) return Object.is(l, r);
    });
}
function $512ec8d668819b2f$export$fac44ee5b035f737(value) {
    if (typeof value === "string") return JSON.stringify(value);
    if (Array.isArray(value)) return `[${value.map($512ec8d668819b2f$export$fac44ee5b035f737).join(", ")}]`;
    if (typeof value === "object" && Object.getPrototypeOf(value) === null) return `{ ${$512ec8d668819b2f$export$7e96d4cabba4fc13(value)} }`;
    if (value?.toString === Object.prototype.toString) return `{ ${$512ec8d668819b2f$export$7e96d4cabba4fc13(value)} }`;
    if (value?.toString) return value.toString();
    return String(value);
}
function $512ec8d668819b2f$export$7e96d4cabba4fc13(obj) {
    return Object.entries(obj).map(([field, value])=>`${field}: ${$512ec8d668819b2f$export$fac44ee5b035f737(value)}`).join(", ");
}
function $512ec8d668819b2f$export$36bac84b1c2da9c7(uint8Array) {
    const chunkSize = 6144 // must be a multiple of 6, so btoa doesn't add padding to a chunk
    ;
    const chunks = [];
    for(let i = 0; i < uint8Array.length; i += chunkSize){
        const chunk = uint8Array.subarray(i, i + chunkSize);
        const binaryString = String.fromCharCode.apply(null, chunk);
        chunks.push(btoa(binaryString));
    }
    return chunks.join("");
}
function $512ec8d668819b2f$export$f01069a3c307e50e(base64String) {
    const binaryString = atob(base64String);
    const uint8Array = new Uint8Array(binaryString.length);
    for(let i = 0; i < binaryString.length; i++)uint8Array[i] = binaryString.charCodeAt(i);
    return uint8Array;
}
function $512ec8d668819b2f$export$4369c812aac99591(value) {
    return typeof value?.then === "function";
}


function $dc2e80b7ebe4adb5$export$a22775fa5e2eebd9(validator, input, options = {}) {
    if (typeof validator === "function") return validator(input, options);
    if (validator instanceof RegExp) {
        if (typeof input !== "string") return false;
        return validator.test(input);
    }
    if (Array.isArray(validator)) return $dc2e80b7ebe4adb5$export$65e3907585753458(validator)(input, options);
    if (typeof validator === "object" && validator !== null && validator.constructor === Object) return $dc2e80b7ebe4adb5$export$5b742f9ac70b1ea3(validator)(input, options);
    return input === validator;
}
class $dc2e80b7ebe4adb5$export$2191b9da168c6cf0 extends Error {
    constructor(validator, input, options){
        super("Validation failed");
        this.validator = validator;
        this.input = input;
        this.options = options;
    }
    toString() {
        return [
            `Validation failed`,
            `  Expected: ${(0, $512ec8d668819b2f$export$fac44ee5b035f737)(this.validator)}`,
            `  Got: ${(0, $512ec8d668819b2f$export$fac44ee5b035f737)(this.input)}`,
            `  Options: ${(0, $512ec8d668819b2f$export$fac44ee5b035f737)(this.options)}`
        ].join("\n");
    }
}
function $dc2e80b7ebe4adb5$export$d855ff590c973c92(validator, input, options) {
    if (!$dc2e80b7ebe4adb5$export$a22775fa5e2eebd9(validator, input, options)) throw new $dc2e80b7ebe4adb5$export$2191b9da168c6cf0(validator, input, options);
}
function $dc2e80b7ebe4adb5$export$5b742f9ac70b1ea3(fields) {
    function validateObjectLoosely(input, options = {}) {
        if (typeof input !== "object") return false;
        if (input === null) return false;
        if (Array.isArray(input)) return false;
        if (input.constructor !== Object) return false;
        for(const fieldName in fields){
            if (!$dc2e80b7ebe4adb5$export$a22775fa5e2eebd9(fields[fieldName], input[fieldName], options)) return false;
        }
        return true;
    }
    validateObjectLoosely.toString = ()=>$dc2e80b7ebe4adb5$var$strfy`loosely(${fields})`;
    return validateObjectLoosely;
}
function $dc2e80b7ebe4adb5$export$29be874c1daba180(fieldValidators) {
    function validateObjectStrictly(input, options = {}) {
        if (!$dc2e80b7ebe4adb5$export$5b742f9ac70b1ea3(fieldValidators)(input, options)) return false;
        // check if both `input` and `fieldValidators` have exactly the smae fields
        const fields = Object.keys(fieldValidators);
        const inputFields = Object.keys(input);
        if (!(fields.length === inputFields.length && fields.every((field)=>inputFields.includes(field)) && inputFields.every((inputField)=>fields.includes(inputField)))) return false;
        return true;
    }
    validateObjectStrictly.toString = ()=>$dc2e80b7ebe4adb5$var$strfy`strict(${fieldValidators})`;
    return validateObjectStrictly;
}
function $dc2e80b7ebe4adb5$export$21c0ac7fe1cef1b8(...validators) {
    function validateEvery(input, options = {}) {
        return validators.every((validator)=>$dc2e80b7ebe4adb5$export$a22775fa5e2eebd9(validator, input, options));
    }
    validateEvery.toString = ()=>$dc2e80b7ebe4adb5$var$strfy`and(${$dc2e80b7ebe4adb5$var$argfy(validators)})`;
    return validateEvery;
}
function $dc2e80b7ebe4adb5$export$252bb8b3bbdf6749(...validators) {
    function validateSome(input, options = {}) {
        return validators.some((validator)=>$dc2e80b7ebe4adb5$export$a22775fa5e2eebd9(validator, input, options));
    }
    validateSome.toString = ()=>$dc2e80b7ebe4adb5$var$strfy`or(${$dc2e80b7ebe4adb5$var$argfy(validators)})`;
    return validateSome;
}
function $dc2e80b7ebe4adb5$export$6003a5f097c73977(validator) {
    function validateNot(input, options = {}) {
        return !$dc2e80b7ebe4adb5$export$a22775fa5e2eebd9(validator, input, options);
    }
    validateNot.toString = ()=>$dc2e80b7ebe4adb5$var$strfy`not(${validator})`;
    return validateNot;
}
function $dc2e80b7ebe4adb5$export$133fc36489ac9add(validator) {
    function validateNullable(input, options = {}) {
        if (input === null || typeof input === "undefined") return true;
        return $dc2e80b7ebe4adb5$export$a22775fa5e2eebd9(validator, input, options);
    }
    validateNullable.toString = ()=>$dc2e80b7ebe4adb5$var$strfy`nullable(${validator})`;
    return validateNullable;
}
function $dc2e80b7ebe4adb5$export$a9a18ae5ba42aeab(...validators) {
    function validateOneOf(input, options = {}) {
        return validators.some((validator)=>$dc2e80b7ebe4adb5$export$a22775fa5e2eebd9(validator, input, options));
    }
    validateOneOf.toString = ()=>$dc2e80b7ebe4adb5$var$strfy`oneOf(${$dc2e80b7ebe4adb5$var$argfy(validators)})`;
    return validateOneOf;
}
function $dc2e80b7ebe4adb5$export$2f23118c22fb2630(validator) {
    function validateArray(input, options = {}) {
        if (!Array.isArray(input)) return false;
        return input.every((item)=>$dc2e80b7ebe4adb5$export$a22775fa5e2eebd9(validator, item, options));
    }
    validateArray.toString = ()=>$dc2e80b7ebe4adb5$var$strfy`array(${validator})`;
    return validateArray;
}
function $dc2e80b7ebe4adb5$export$65e3907585753458(validators) {
    function validateTuple(input, options = {}) {
        if (!Array.isArray(input)) return false;
        if (validators.length !== input.length) return false;
        for(let index = 0; index < validators.length; index++){
            if (!$dc2e80b7ebe4adb5$export$a22775fa5e2eebd9(validators[index], input[index], options)) return false;
        }
        return true;
    }
    validateTuple.toString = ()=>$dc2e80b7ebe4adb5$var$strfy`${validators}`;
    return validateTuple;
}
function $dc2e80b7ebe4adb5$export$488013bae63b21da(validatorCreator, ...args) {
    function lazyValidator(input, options = {}) {
        return $dc2e80b7ebe4adb5$export$a22775fa5e2eebd9(validatorCreator(...args), input, options);
    }
    lazyValidator.toString = ()=>$dc2e80b7ebe4adb5$var$strfy`lazy(${validatorCreator}, ${$dc2e80b7ebe4adb5$var$argfy(args)})`;
    return lazyValidator;
}
function $dc2e80b7ebe4adb5$export$226b3eccf92c9ed9(value) {
    function isValue(input, options = {}) {
        return input === value;
    }
    isValue.toString = ()=>$dc2e80b7ebe4adb5$var$strfy`is(${value})`;
    return isValue;
}
function $dc2e80b7ebe4adb5$export$42f353d40f388c19(typeName) {
    function validateTypeof(input, options = {}) {
        return typeof input === typeName;
    }
    validateTypeof.toString = ()=>typeName;
    return validateTypeof;
}
function $dc2e80b7ebe4adb5$export$4154a199d7d90455(input, options = {}) {
    return true;
}
$dc2e80b7ebe4adb5$export$4154a199d7d90455.toString = ()=>"any";
function $dc2e80b7ebe4adb5$export$43f40ad3fa1d5c97(input, options = {}) {
    return typeof input !== "undefined";
}
$dc2e80b7ebe4adb5$export$43f40ad3fa1d5c97.toString = ()=>"defined";
const $dc2e80b7ebe4adb5$export$22b082955e083ec3 = $dc2e80b7ebe4adb5$export$42f353d40f388c19("string");
const $dc2e80b7ebe4adb5$export$98e628dec113755e = $dc2e80b7ebe4adb5$export$42f353d40f388c19("number");
const $dc2e80b7ebe4adb5$export$4a21f16c33752377 = $dc2e80b7ebe4adb5$export$42f353d40f388c19("boolean");
function $dc2e80b7ebe4adb5$export$6fc572fe80b0d49c(input, ...cases) {
    for (const [validator, handler] of cases){
        if ($dc2e80b7ebe4adb5$export$a22775fa5e2eebd9(validator, input)) return handler(input);
    }
}
function $dc2e80b7ebe4adb5$var$strfy(strs, ...interpolations) {
    return strs[0] + strs.slice(1).map((str, idx)=>(idx < interpolations.length ? (0, $512ec8d668819b2f$export$fac44ee5b035f737)(interpolations[idx]) : "") + str).join("");
}
function $dc2e80b7ebe4adb5$var$argfy(args) {
    return {
        toString () {
            return args.map((0, $512ec8d668819b2f$export$fac44ee5b035f737)).join(", ");
        }
    };
}


var $d0f575b1326e7f91$exports = {};

$parcel$export($d0f575b1326e7f91$exports, "debugDispatcher", () => $d0f575b1326e7f91$export$834280ed8d07adce);
$parcel$export($d0f575b1326e7f91$exports, "logDispatcher", () => $d0f575b1326e7f91$export$af1ca9b36f26ee57);
$parcel$export($d0f575b1326e7f91$exports, "updateToDispatch", () => $d0f575b1326e7f91$export$61411c93e1287c1e);
$parcel$export($d0f575b1326e7f91$exports, "useDispatcher", () => $d0f575b1326e7f91$export$103c0bfe0332eea8);
$parcel$export($d0f575b1326e7f91$exports, "mapDispatcher", () => $d0f575b1326e7f91$export$185cfda0b8e365b1);
$parcel$export($d0f575b1326e7f91$exports, "fieldDispatcher", () => $d0f575b1326e7f91$export$f153e5abd026c378);

var $acw62 = parcelRequire("acw62");
var $3c22431224d334b1$exports = {};

$parcel$export($3c22431224d334b1$exports, "Iterable", () => $3c22431224d334b1$export$6936595027d5d5e8);
$parcel$export($3c22431224d334b1$exports, "Seq", () => $a5938beaa66b3822$export$4802c350533dc67e);
$parcel$export($3c22431224d334b1$exports, "OrderedMap", () => $acfb3e7ae62d9682$export$8e8eaa3741ef504c);
$parcel$export($3c22431224d334b1$exports, "List", () => $80b7afef873cee5f$export$54c2e3dc7acea9f5);
$parcel$export($3c22431224d334b1$exports, "Map", () => $3ff96ffc4297bcc8$export$a5c7b93649eaf8f8);
$parcel$export($3c22431224d334b1$exports, "Stack", () => $e410790f9257995e$export$694e0d28c7ffc90c);
$parcel$export($3c22431224d334b1$exports, "OrderedSet", () => $eeb9b1d6c94112ab$export$ba0280ac83f150c1);
$parcel$export($3c22431224d334b1$exports, "PairSorting", () => $5999b57de4ee0fe6$export$b26aa21284963439);
$parcel$export($3c22431224d334b1$exports, "Set", () => $e6de90c09d008aae$export$bdf4ff5a442cbbc5);
$parcel$export($3c22431224d334b1$exports, "Record", () => $7cd7e3a810169eec$export$5b163c6d120341e7);
$parcel$export($3c22431224d334b1$exports, "Range", () => $b409607006c0c262$export$9a58ef0d7ad3278c);
$parcel$export($3c22431224d334b1$exports, "Repeat", () => $e3a6fdc4c252a16f$export$f9d61a2a6155ab51);
$parcel$export($3c22431224d334b1$exports, "is", () => $cffd0257ddfe6a6e$export$226b3eccf92c9ed9);
$parcel$export($3c22431224d334b1$exports, "fromJS", () => $7de3496ae9b1ff54$export$fb763b55bf590791);
$parcel$export($3c22431224d334b1$exports, "isPlainObject", () => $c80481447c971627$export$2e2bcd8739ae039);
$parcel$export($3c22431224d334b1$exports, "isImmutable", () => $821b634c82af17ef$export$f8647edfbac13b4f);
$parcel$export($3c22431224d334b1$exports, "isCollection", () => $d70bc35f1b2e7a74$export$cea7aa84e978eba5);
$parcel$export($3c22431224d334b1$exports, "isKeyed", () => $e8d80ef58ba97d1e$export$66d51e2080425364);
$parcel$export($3c22431224d334b1$exports, "isIndexed", () => $a4ecf346f3821d5f$export$3bfb5e72e8bc6e09);
$parcel$export($3c22431224d334b1$exports, "isAssociative", () => $7a2788a9210b8dae$export$9c3ce8f7b89c6d66);
$parcel$export($3c22431224d334b1$exports, "isOrdered", () => $d95bc815d10ddd62$export$e670b9b76442ef6c);
$parcel$export($3c22431224d334b1$exports, "isValueObject", () => $4e243b6ea8a0da68$export$b24f7407c77e5bd);
$parcel$export($3c22431224d334b1$exports, "isSeq", () => $781499ae681aa138$export$342ac1d101ffe14b);
$parcel$export($3c22431224d334b1$exports, "isList", () => $4da6d49bd1d5a072$export$ead95ff48ba53ffd);
$parcel$export($3c22431224d334b1$exports, "isMap", () => $bd1a46f68c54954f$export$5c90113a285f2241);
$parcel$export($3c22431224d334b1$exports, "isOrderedMap", () => $693a5cb59d634058$export$739bc167e02d45ee);
$parcel$export($3c22431224d334b1$exports, "isStack", () => $56ddec3bbd4ddd33$export$db58588880737c1c);
$parcel$export($3c22431224d334b1$exports, "isSet", () => $8b6e80d3bc0e2623$export$6750766a7c7ec627);
$parcel$export($3c22431224d334b1$exports, "isOrderedSet", () => $fac081eee1ee61a7$export$a5eec3a3b03b602f);
$parcel$export($3c22431224d334b1$exports, "isRecord", () => $0465e764326921ff$export$6ba840931da50680);
$parcel$export($3c22431224d334b1$exports, "hash", () => $826fab6845b48e0a$export$d6af199866bfb566);
$parcel$export($3c22431224d334b1$exports, "get", () => $a91ac00741fd7597$export$3988ae62b71be9a3);
$parcel$export($3c22431224d334b1$exports, "getIn", () => $b1accaecafec2e09$export$c52e5867d5879e24);
$parcel$export($3c22431224d334b1$exports, "has", () => $0161bd0c35897c14$export$a4f4bb6b1453fff5);
$parcel$export($3c22431224d334b1$exports, "hasIn", () => $78f95ef4cef506a6$export$d39a4e62499f2a79);
$parcel$export($3c22431224d334b1$exports, "merge", () => $b8fe2d75c7583f49$export$4950aa0f605343fb);
$parcel$export($3c22431224d334b1$exports, "mergeDeep", () => $b8fe2d75c7583f49$export$dd702b3c8240390c);
$parcel$export($3c22431224d334b1$exports, "mergeDeepWith", () => $b8fe2d75c7583f49$export$aa0aa29a716b1650);
$parcel$export($3c22431224d334b1$exports, "mergeWith", () => $b8fe2d75c7583f49$export$2ee76fde9ffe109d);
$parcel$export($3c22431224d334b1$exports, "remove", () => $cebde492a88f7762$export$cd7f480d6b8286c3);
$parcel$export($3c22431224d334b1$exports, "removeIn", () => $1f771dded4c47a9e$export$b56fa1d8ac1a28ad);
$parcel$export($3c22431224d334b1$exports, "set", () => $dc9f544fa111904d$export$adaa4cf7ef1b65be);
$parcel$export($3c22431224d334b1$exports, "setIn", () => $417ec453c2fca3b4$export$e6bdf135a54e021b);
$parcel$export($3c22431224d334b1$exports, "update", () => $bddc5e7208652b84$export$722fbec263ad908a);
$parcel$export($3c22431224d334b1$exports, "updateIn", () => $f32fb19553378b7c$export$f3e3cd1fc9c33ca1);
$parcel$export($3c22431224d334b1$exports, "version", () => $a9fa044fd9b28e77$export$83d89fbfd8236492);
$parcel$export($3c22431224d334b1$exports, "Collection", () => $4952a3ccc7265b27$export$fb8073518f34e6ec);
/**
 * @license
 * MIT License
 * 
 * Copyright (c) 2014-present, Lee Byron and other contributors.
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ /**
 * @license
 * MIT License
 * 
 * Copyright (c) 2014-present, Lee Byron and other contributors.
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ /**
 * @license
 * MIT License
 * 
 * Copyright (c) 2014-present, Lee Byron and other contributors.
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ // Used for setting prototype methods that IE8 chokes on.
var $c2ddc03a1d32db1a$export$4bd2facc4a3e6aa1 = "delete";
// Constants describing the size of trie nodes.
var $c2ddc03a1d32db1a$export$d36167fd695703b4 = 5; // Resulted in best performance after ______?
var $c2ddc03a1d32db1a$export$8d4e26484c874870 = 1 << $c2ddc03a1d32db1a$export$d36167fd695703b4;
var $c2ddc03a1d32db1a$export$e14dab7236868a5 = $c2ddc03a1d32db1a$export$8d4e26484c874870 - 1;
// A consistent shared value representing "not set" which equals nothing other
// than itself, and nothing that could be provided externally.
var $c2ddc03a1d32db1a$export$dc6d556e3fa8f459 = {};
// Boolean references, Rough equivalent of `bool &`.
function $c2ddc03a1d32db1a$export$a4907f3d95a6b59f() {
    return {
        value: false
    };
}
function $c2ddc03a1d32db1a$export$5c111b5829d07529(ref) {
    if (ref) ref.value = true;
}
// A function which returns a value representing an "owner" for transient writes
// to tries. The return value will only ever equal itself, and will not equal
// the return of any subsequent call of this function.
function $c2ddc03a1d32db1a$export$f629661819ff67eb() {}
function $c2ddc03a1d32db1a$export$b8443e9e8396a588(iter) {
    if (iter.size === undefined) iter.size = iter.__iterate($c2ddc03a1d32db1a$export$8a16822a2b63cb79);
    return iter.size;
}
function $c2ddc03a1d32db1a$export$acb6ab09ed1b7b8b(iter, index) {
    // This implements "is array index" which the ECMAString spec defines as:
    //
    //     A String property name P is an array index if and only if
    //     ToString(ToUint32(P)) is equal to P and ToUint32(P) is not equal
    //     to 2^32−1.
    //
    // http://www.ecma-international.org/ecma-262/6.0/#sec-array-exotic-objects
    if (typeof index !== "number") {
        var uint32Index = index >>> 0; // N >>> 0 is shorthand for ToUint32
        if ("" + uint32Index !== index || uint32Index === 4294967295) return NaN;
        index = uint32Index;
    }
    return index < 0 ? $c2ddc03a1d32db1a$export$b8443e9e8396a588(iter) + index : index;
}
function $c2ddc03a1d32db1a$export$8a16822a2b63cb79() {
    return true;
}
function $c2ddc03a1d32db1a$export$39c07963d3ae8010(begin, end, size) {
    return (begin === 0 && !$c2ddc03a1d32db1a$var$isNeg(begin) || size !== undefined && begin <= -size) && (end === undefined || size !== undefined && end >= size);
}
function $c2ddc03a1d32db1a$export$b50255956c5410d8(begin, size) {
    return $c2ddc03a1d32db1a$var$resolveIndex(begin, size, 0);
}
function $c2ddc03a1d32db1a$export$9be3172c55e482a(end, size) {
    return $c2ddc03a1d32db1a$var$resolveIndex(end, size, size);
}
function $c2ddc03a1d32db1a$var$resolveIndex(index, size, defaultIndex) {
    // Sanitize indices using this shorthand for ToInt32(argument)
    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
    return index === undefined ? defaultIndex : $c2ddc03a1d32db1a$var$isNeg(index) ? size === Infinity ? size : Math.max(0, size + index) | 0 : size === undefined || size === index ? index : Math.min(size, index) | 0;
}
function $c2ddc03a1d32db1a$var$isNeg(value) {
    // Account for -0 which is negative, but not less than 0.
    return value < 0 || value === 0 && 1 / value === -Infinity;
}


/**
 * @license
 * MIT License
 * 
 * Copyright (c) 2014-present, Lee Byron and other contributors.
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ 
/**
 * @license
 * MIT License
 * 
 * Copyright (c) 2014-present, Lee Byron and other contributors.
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ // Note: value is unchanged to not break immutable-devtools.
var $d70bc35f1b2e7a74$export$763d354e117c1e1a = "@@__IMMUTABLE_ITERABLE__@@";
function $d70bc35f1b2e7a74$export$cea7aa84e978eba5(maybeCollection) {
    return Boolean(maybeCollection && maybeCollection[$d70bc35f1b2e7a74$export$763d354e117c1e1a]);
}


/**
 * @license
 * MIT License
 * 
 * Copyright (c) 2014-present, Lee Byron and other contributors.
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ var $e8d80ef58ba97d1e$export$ddf5566dca80552 = "@@__IMMUTABLE_KEYED__@@";
function $e8d80ef58ba97d1e$export$66d51e2080425364(maybeKeyed) {
    return Boolean(maybeKeyed && maybeKeyed[$e8d80ef58ba97d1e$export$ddf5566dca80552]);
}


/**
 * @license
 * MIT License
 * 
 * Copyright (c) 2014-present, Lee Byron and other contributors.
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ var $a4ecf346f3821d5f$export$b6d03b330dce40f4 = "@@__IMMUTABLE_INDEXED__@@";
function $a4ecf346f3821d5f$export$3bfb5e72e8bc6e09(maybeIndexed) {
    return Boolean(maybeIndexed && maybeIndexed[$a4ecf346f3821d5f$export$b6d03b330dce40f4]);
}


/**
 * @license
 * MIT License
 * 
 * Copyright (c) 2014-present, Lee Byron and other contributors.
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ 

function $7a2788a9210b8dae$export$9c3ce8f7b89c6d66(maybeAssociative) {
    return (0, $e8d80ef58ba97d1e$export$66d51e2080425364)(maybeAssociative) || (0, $a4ecf346f3821d5f$export$3bfb5e72e8bc6e09)(maybeAssociative);
}


var $4952a3ccc7265b27$export$fb8073518f34e6ec = function Collection(value) {
    return (0, $d70bc35f1b2e7a74$export$cea7aa84e978eba5)(value) ? value : (0, $a5938beaa66b3822$export$4802c350533dc67e)(value);
};
var $4952a3ccc7265b27$export$6e235e3661e8f430 = /*@__PURE__*/ function(Collection) {
    function KeyedCollection(value) {
        return (0, $e8d80ef58ba97d1e$export$66d51e2080425364)(value) ? value : (0, $a5938beaa66b3822$export$20f601f934d554cc)(value);
    }
    if (Collection) KeyedCollection.__proto__ = Collection;
    KeyedCollection.prototype = Object.create(Collection && Collection.prototype);
    KeyedCollection.prototype.constructor = KeyedCollection;
    return KeyedCollection;
}($4952a3ccc7265b27$export$fb8073518f34e6ec);
var $4952a3ccc7265b27$export$eb9d6a4c2661c7e7 = /*@__PURE__*/ function(Collection) {
    function IndexedCollection(value) {
        return (0, $a4ecf346f3821d5f$export$3bfb5e72e8bc6e09)(value) ? value : (0, $a5938beaa66b3822$export$1b5716c72c24a934)(value);
    }
    if (Collection) IndexedCollection.__proto__ = Collection;
    IndexedCollection.prototype = Object.create(Collection && Collection.prototype);
    IndexedCollection.prototype.constructor = IndexedCollection;
    return IndexedCollection;
}($4952a3ccc7265b27$export$fb8073518f34e6ec);
var $4952a3ccc7265b27$export$8ace86ce31a5e0e7 = /*@__PURE__*/ function(Collection) {
    function SetCollection(value) {
        return (0, $d70bc35f1b2e7a74$export$cea7aa84e978eba5)(value) && !(0, $7a2788a9210b8dae$export$9c3ce8f7b89c6d66)(value) ? value : (0, $a5938beaa66b3822$export$bd141fae6edeb9b9)(value);
    }
    if (Collection) SetCollection.__proto__ = Collection;
    SetCollection.prototype = Object.create(Collection && Collection.prototype);
    SetCollection.prototype.constructor = SetCollection;
    return SetCollection;
}($4952a3ccc7265b27$export$fb8073518f34e6ec);
$4952a3ccc7265b27$export$fb8073518f34e6ec.Keyed = $4952a3ccc7265b27$export$6e235e3661e8f430;
$4952a3ccc7265b27$export$fb8073518f34e6ec.Indexed = $4952a3ccc7265b27$export$eb9d6a4c2661c7e7;
$4952a3ccc7265b27$export$fb8073518f34e6ec.Set = $4952a3ccc7265b27$export$8ace86ce31a5e0e7;


/**
 * @license
 * MIT License
 * 
 * Copyright (c) 2014-present, Lee Byron and other contributors.
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ var $781499ae681aa138$export$985f343fb54849a7 = "@@__IMMUTABLE_SEQ__@@";
function $781499ae681aa138$export$342ac1d101ffe14b(maybeSeq) {
    return Boolean(maybeSeq && maybeSeq[$781499ae681aa138$export$985f343fb54849a7]);
}


/**
 * @license
 * MIT License
 * 
 * Copyright (c) 2014-present, Lee Byron and other contributors.
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ 
/**
 * @license
 * MIT License
 * 
 * Copyright (c) 2014-present, Lee Byron and other contributors.
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ var $0465e764326921ff$export$698b77566b5d832f = "@@__IMMUTABLE_RECORD__@@";
function $0465e764326921ff$export$6ba840931da50680(maybeRecord) {
    return Boolean(maybeRecord && maybeRecord[$0465e764326921ff$export$698b77566b5d832f]);
}


function $821b634c82af17ef$export$f8647edfbac13b4f(maybeImmutable) {
    return (0, $d70bc35f1b2e7a74$export$cea7aa84e978eba5)(maybeImmutable) || (0, $0465e764326921ff$export$6ba840931da50680)(maybeImmutable);
}






/**
 * @license
 * MIT License
 * 
 * Copyright (c) 2014-present, Lee Byron and other contributors.
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ var $d95bc815d10ddd62$export$63a33a562da7c584 = "@@__IMMUTABLE_ORDERED__@@";
function $d95bc815d10ddd62$export$e670b9b76442ef6c(maybeOrdered) {
    return Boolean(maybeOrdered && maybeOrdered[$d95bc815d10ddd62$export$63a33a562da7c584]);
}


/**
 * @license
 * MIT License
 * 
 * Copyright (c) 2014-present, Lee Byron and other contributors.
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ var $88d0bf2511806126$export$cf2425c07c5cbc1 = 0;
var $88d0bf2511806126$export$20a9ccb927958bae = 1;
var $88d0bf2511806126$export$ba5b1d03002a31af = 2;
var $88d0bf2511806126$var$REAL_ITERATOR_SYMBOL = typeof Symbol === "function" && Symbol.iterator;
var $88d0bf2511806126$var$FAUX_ITERATOR_SYMBOL = "@@iterator";
var $88d0bf2511806126$export$f3bc9dfea2800188 = $88d0bf2511806126$var$REAL_ITERATOR_SYMBOL || $88d0bf2511806126$var$FAUX_ITERATOR_SYMBOL;
var $88d0bf2511806126$export$b67e82436e407e40 = function Iterator(next) {
    this.next = next;
};
$88d0bf2511806126$export$b67e82436e407e40.prototype.toString = function toString() {
    return "[Iterator]";
};
$88d0bf2511806126$export$b67e82436e407e40.KEYS = $88d0bf2511806126$export$cf2425c07c5cbc1;
$88d0bf2511806126$export$b67e82436e407e40.VALUES = $88d0bf2511806126$export$20a9ccb927958bae;
$88d0bf2511806126$export$b67e82436e407e40.ENTRIES = $88d0bf2511806126$export$ba5b1d03002a31af;
$88d0bf2511806126$export$b67e82436e407e40.prototype.inspect = $88d0bf2511806126$export$b67e82436e407e40.prototype.toSource = function() {
    return this.toString();
};
$88d0bf2511806126$export$b67e82436e407e40.prototype[$88d0bf2511806126$export$f3bc9dfea2800188] = function() {
    return this;
};
function $88d0bf2511806126$export$dde1781ce8ad65f(type, k, v, iteratorResult) {
    var value = type === 0 ? k : type === 1 ? v : [
        k,
        v
    ];
    iteratorResult ? iteratorResult.value = value : iteratorResult = {
        value: value,
        done: false
    };
    return iteratorResult;
}
function $88d0bf2511806126$export$e141d6e2268e9d85() {
    return {
        value: undefined,
        done: true
    };
}
function $88d0bf2511806126$export$57f74772748f5c4e(maybeIterable) {
    if (Array.isArray(maybeIterable)) // IE11 trick as it does not support `Symbol.iterator`
    return true;
    return !!$88d0bf2511806126$var$getIteratorFn(maybeIterable);
}
function $88d0bf2511806126$export$50db6e277db66ea0(maybeIterator) {
    return maybeIterator && typeof maybeIterator.next === "function";
}
function $88d0bf2511806126$export$6731da38428a8625(iterable) {
    var iteratorFn = $88d0bf2511806126$var$getIteratorFn(iterable);
    return iteratorFn && iteratorFn.call(iterable);
}
function $88d0bf2511806126$var$getIteratorFn(iterable) {
    var iteratorFn = iterable && ($88d0bf2511806126$var$REAL_ITERATOR_SYMBOL && iterable[$88d0bf2511806126$var$REAL_ITERATOR_SYMBOL] || iterable[$88d0bf2511806126$var$FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === "function") return iteratorFn;
}
function $88d0bf2511806126$export$8c03840462a0569d(maybeIterable) {
    var iteratorFn = $88d0bf2511806126$var$getIteratorFn(maybeIterable);
    return iteratorFn && iteratorFn === maybeIterable.entries;
}
function $88d0bf2511806126$export$4bdcf90d51764622(maybeIterable) {
    var iteratorFn = $88d0bf2511806126$var$getIteratorFn(maybeIterable);
    return iteratorFn && iteratorFn === maybeIterable.keys;
}


/**
 * @license
 * MIT License
 * 
 * Copyright (c) 2014-present, Lee Byron and other contributors.
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ var $e96acf24d7e0818a$export$2e2bcd8739ae039 = Object.prototype.hasOwnProperty;


/**
 * @license
 * MIT License
 * 
 * Copyright (c) 2014-present, Lee Byron and other contributors.
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ function $67716be90529aa17$export$2e2bcd8739ae039(value) {
    if (Array.isArray(value) || typeof value === "string") return true;
    return value && typeof value === "object" && Number.isInteger(value.length) && value.length >= 0 && (value.length === 0 ? Object.keys(value).length === 1 : // in the array-like may be found (which could be undefined).
    value.hasOwnProperty(value.length - 1));
}


var $a5938beaa66b3822$export$4802c350533dc67e = /*@__PURE__*/ function(Collection) {
    function Seq(value) {
        return value === undefined || value === null ? $a5938beaa66b3822$var$emptySequence() : (0, $821b634c82af17ef$export$f8647edfbac13b4f)(value) ? value.toSeq() : $a5938beaa66b3822$var$seqFromValue(value);
    }
    if (Collection) Seq.__proto__ = Collection;
    Seq.prototype = Object.create(Collection && Collection.prototype);
    Seq.prototype.constructor = Seq;
    Seq.prototype.toSeq = function toSeq() {
        return this;
    };
    Seq.prototype.toString = function toString() {
        return this.__toString("Seq {", "}");
    };
    Seq.prototype.cacheResult = function cacheResult() {
        if (!this._cache && this.__iterateUncached) {
            this._cache = this.entrySeq().toArray();
            this.size = this._cache.length;
        }
        return this;
    };
    // abstract __iterateUncached(fn, reverse)
    Seq.prototype.__iterate = function __iterate(fn, reverse) {
        var cache = this._cache;
        if (cache) {
            var size = cache.length;
            var i = 0;
            while(i !== size){
                var entry = cache[reverse ? size - ++i : i++];
                if (fn(entry[1], entry[0], this) === false) break;
            }
            return i;
        }
        return this.__iterateUncached(fn, reverse);
    };
    // abstract __iteratorUncached(type, reverse)
    Seq.prototype.__iterator = function __iterator(type, reverse) {
        var cache = this._cache;
        if (cache) {
            var size = cache.length;
            var i = 0;
            return new (0, $88d0bf2511806126$export$b67e82436e407e40)(function() {
                if (i === size) return (0, $88d0bf2511806126$export$e141d6e2268e9d85)();
                var entry = cache[reverse ? size - ++i : i++];
                return (0, $88d0bf2511806126$export$dde1781ce8ad65f)(type, entry[0], entry[1]);
            });
        }
        return this.__iteratorUncached(type, reverse);
    };
    return Seq;
}((0, $4952a3ccc7265b27$export$fb8073518f34e6ec));
var $a5938beaa66b3822$export$20f601f934d554cc = /*@__PURE__*/ function(Seq) {
    function KeyedSeq(value) {
        return value === undefined || value === null ? $a5938beaa66b3822$var$emptySequence().toKeyedSeq() : (0, $d70bc35f1b2e7a74$export$cea7aa84e978eba5)(value) ? (0, $e8d80ef58ba97d1e$export$66d51e2080425364)(value) ? value.toSeq() : value.fromEntrySeq() : (0, $0465e764326921ff$export$6ba840931da50680)(value) ? value.toSeq() : $a5938beaa66b3822$export$437b28e5b41f462b(value);
    }
    if (Seq) KeyedSeq.__proto__ = Seq;
    KeyedSeq.prototype = Object.create(Seq && Seq.prototype);
    KeyedSeq.prototype.constructor = KeyedSeq;
    KeyedSeq.prototype.toKeyedSeq = function toKeyedSeq() {
        return this;
    };
    return KeyedSeq;
}($a5938beaa66b3822$export$4802c350533dc67e);
var $a5938beaa66b3822$export$1b5716c72c24a934 = /*@__PURE__*/ function(Seq) {
    function IndexedSeq(value) {
        return value === undefined || value === null ? $a5938beaa66b3822$var$emptySequence() : (0, $d70bc35f1b2e7a74$export$cea7aa84e978eba5)(value) ? (0, $e8d80ef58ba97d1e$export$66d51e2080425364)(value) ? value.entrySeq() : value.toIndexedSeq() : (0, $0465e764326921ff$export$6ba840931da50680)(value) ? value.toSeq().entrySeq() : $a5938beaa66b3822$export$205e4de7b617cdbd(value);
    }
    if (Seq) IndexedSeq.__proto__ = Seq;
    IndexedSeq.prototype = Object.create(Seq && Seq.prototype);
    IndexedSeq.prototype.constructor = IndexedSeq;
    IndexedSeq.of = function of() {
        return IndexedSeq(arguments);
    };
    IndexedSeq.prototype.toIndexedSeq = function toIndexedSeq() {
        return this;
    };
    IndexedSeq.prototype.toString = function toString() {
        return this.__toString("Seq [", "]");
    };
    return IndexedSeq;
}($a5938beaa66b3822$export$4802c350533dc67e);
var $a5938beaa66b3822$export$bd141fae6edeb9b9 = /*@__PURE__*/ function(Seq) {
    function SetSeq(value) {
        return ((0, $d70bc35f1b2e7a74$export$cea7aa84e978eba5)(value) && !(0, $7a2788a9210b8dae$export$9c3ce8f7b89c6d66)(value) ? value : $a5938beaa66b3822$export$1b5716c72c24a934(value)).toSetSeq();
    }
    if (Seq) SetSeq.__proto__ = Seq;
    SetSeq.prototype = Object.create(Seq && Seq.prototype);
    SetSeq.prototype.constructor = SetSeq;
    SetSeq.of = function of() {
        return SetSeq(arguments);
    };
    SetSeq.prototype.toSetSeq = function toSetSeq() {
        return this;
    };
    return SetSeq;
}($a5938beaa66b3822$export$4802c350533dc67e);
$a5938beaa66b3822$export$4802c350533dc67e.isSeq = (0, $781499ae681aa138$export$342ac1d101ffe14b);
$a5938beaa66b3822$export$4802c350533dc67e.Keyed = $a5938beaa66b3822$export$20f601f934d554cc;
$a5938beaa66b3822$export$4802c350533dc67e.Set = $a5938beaa66b3822$export$bd141fae6edeb9b9;
$a5938beaa66b3822$export$4802c350533dc67e.Indexed = $a5938beaa66b3822$export$1b5716c72c24a934;
$a5938beaa66b3822$export$4802c350533dc67e.prototype[0, $781499ae681aa138$export$985f343fb54849a7] = true;
// #pragma Root Sequences
var $a5938beaa66b3822$export$b0774ff537b4dcee = /*@__PURE__*/ function(IndexedSeq) {
    function ArraySeq(array) {
        this._array = array;
        this.size = array.length;
    }
    if (IndexedSeq) ArraySeq.__proto__ = IndexedSeq;
    ArraySeq.prototype = Object.create(IndexedSeq && IndexedSeq.prototype);
    ArraySeq.prototype.constructor = ArraySeq;
    ArraySeq.prototype.get = function get(index, notSetValue) {
        return this.has(index) ? this._array[(0, $c2ddc03a1d32db1a$export$acb6ab09ed1b7b8b)(this, index)] : notSetValue;
    };
    ArraySeq.prototype.__iterate = function __iterate(fn, reverse) {
        var array = this._array;
        var size = array.length;
        var i = 0;
        while(i !== size){
            var ii = reverse ? size - ++i : i++;
            if (fn(array[ii], ii, this) === false) break;
        }
        return i;
    };
    ArraySeq.prototype.__iterator = function __iterator(type, reverse) {
        var array = this._array;
        var size = array.length;
        var i = 0;
        return new (0, $88d0bf2511806126$export$b67e82436e407e40)(function() {
            if (i === size) return (0, $88d0bf2511806126$export$e141d6e2268e9d85)();
            var ii = reverse ? size - ++i : i++;
            return (0, $88d0bf2511806126$export$dde1781ce8ad65f)(type, ii, array[ii]);
        });
    };
    return ArraySeq;
}($a5938beaa66b3822$export$1b5716c72c24a934);
var $a5938beaa66b3822$var$ObjectSeq = /*@__PURE__*/ function(KeyedSeq) {
    function ObjectSeq(object) {
        var keys = Object.keys(object).concat(Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(object) : []);
        this._object = object;
        this._keys = keys;
        this.size = keys.length;
    }
    if (KeyedSeq) ObjectSeq.__proto__ = KeyedSeq;
    ObjectSeq.prototype = Object.create(KeyedSeq && KeyedSeq.prototype);
    ObjectSeq.prototype.constructor = ObjectSeq;
    ObjectSeq.prototype.get = function get(key, notSetValue) {
        if (notSetValue !== undefined && !this.has(key)) return notSetValue;
        return this._object[key];
    };
    ObjectSeq.prototype.has = function has(key) {
        return (0, $e96acf24d7e0818a$export$2e2bcd8739ae039).call(this._object, key);
    };
    ObjectSeq.prototype.__iterate = function __iterate(fn, reverse) {
        var object = this._object;
        var keys = this._keys;
        var size = keys.length;
        var i = 0;
        while(i !== size){
            var key = keys[reverse ? size - ++i : i++];
            if (fn(object[key], key, this) === false) break;
        }
        return i;
    };
    ObjectSeq.prototype.__iterator = function __iterator(type, reverse) {
        var object = this._object;
        var keys = this._keys;
        var size = keys.length;
        var i = 0;
        return new (0, $88d0bf2511806126$export$b67e82436e407e40)(function() {
            if (i === size) return (0, $88d0bf2511806126$export$e141d6e2268e9d85)();
            var key = keys[reverse ? size - ++i : i++];
            return (0, $88d0bf2511806126$export$dde1781ce8ad65f)(type, key, object[key]);
        });
    };
    return ObjectSeq;
}($a5938beaa66b3822$export$20f601f934d554cc);
$a5938beaa66b3822$var$ObjectSeq.prototype[0, $d95bc815d10ddd62$export$63a33a562da7c584] = true;
var $a5938beaa66b3822$var$CollectionSeq = /*@__PURE__*/ function(IndexedSeq) {
    function CollectionSeq(collection) {
        this._collection = collection;
        this.size = collection.length || collection.size;
    }
    if (IndexedSeq) CollectionSeq.__proto__ = IndexedSeq;
    CollectionSeq.prototype = Object.create(IndexedSeq && IndexedSeq.prototype);
    CollectionSeq.prototype.constructor = CollectionSeq;
    CollectionSeq.prototype.__iterateUncached = function __iterateUncached(fn, reverse) {
        if (reverse) return this.cacheResult().__iterate(fn, reverse);
        var collection = this._collection;
        var iterator = (0, $88d0bf2511806126$export$6731da38428a8625)(collection);
        var iterations = 0;
        if ((0, $88d0bf2511806126$export$50db6e277db66ea0)(iterator)) {
            var step;
            while(!(step = iterator.next()).done){
                if (fn(step.value, iterations++, this) === false) break;
            }
        }
        return iterations;
    };
    CollectionSeq.prototype.__iteratorUncached = function __iteratorUncached(type, reverse) {
        if (reverse) return this.cacheResult().__iterator(type, reverse);
        var collection = this._collection;
        var iterator = (0, $88d0bf2511806126$export$6731da38428a8625)(collection);
        if (!(0, $88d0bf2511806126$export$50db6e277db66ea0)(iterator)) return new (0, $88d0bf2511806126$export$b67e82436e407e40)((0, $88d0bf2511806126$export$e141d6e2268e9d85));
        var iterations = 0;
        return new (0, $88d0bf2511806126$export$b67e82436e407e40)(function() {
            var step = iterator.next();
            return step.done ? step : (0, $88d0bf2511806126$export$dde1781ce8ad65f)(type, iterations++, step.value);
        });
    };
    return CollectionSeq;
}($a5938beaa66b3822$export$1b5716c72c24a934);
// # pragma Helper functions
var $a5938beaa66b3822$var$EMPTY_SEQ;
function $a5938beaa66b3822$var$emptySequence() {
    return $a5938beaa66b3822$var$EMPTY_SEQ || ($a5938beaa66b3822$var$EMPTY_SEQ = new $a5938beaa66b3822$export$b0774ff537b4dcee([]));
}
function $a5938beaa66b3822$export$437b28e5b41f462b(value) {
    var seq = $a5938beaa66b3822$var$maybeIndexedSeqFromValue(value);
    if (seq) return seq.fromEntrySeq();
    if (typeof value === "object") return new $a5938beaa66b3822$var$ObjectSeq(value);
    throw new TypeError("Expected Array or collection object of [k, v] entries, or keyed object: " + value);
}
function $a5938beaa66b3822$export$205e4de7b617cdbd(value) {
    var seq = $a5938beaa66b3822$var$maybeIndexedSeqFromValue(value);
    if (seq) return seq;
    throw new TypeError("Expected Array or collection object of values: " + value);
}
function $a5938beaa66b3822$var$seqFromValue(value) {
    var seq = $a5938beaa66b3822$var$maybeIndexedSeqFromValue(value);
    if (seq) return (0, $88d0bf2511806126$export$8c03840462a0569d)(value) ? seq.fromEntrySeq() : (0, $88d0bf2511806126$export$4bdcf90d51764622)(value) ? seq.toSetSeq() : seq;
    if (typeof value === "object") return new $a5938beaa66b3822$var$ObjectSeq(value);
    throw new TypeError("Expected Array or collection object of values, or keyed object: " + value);
}
function $a5938beaa66b3822$var$maybeIndexedSeqFromValue(value) {
    return (0, $67716be90529aa17$export$2e2bcd8739ae039)(value) ? new $a5938beaa66b3822$export$b0774ff537b4dcee(value) : (0, $88d0bf2511806126$export$57f74772748f5c4e)(value) ? new $a5938beaa66b3822$var$CollectionSeq(value) : undefined;
}


/**
 * @license
 * MIT License
 * 
 * Copyright (c) 2014-present, Lee Byron and other contributors.
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ 

/**
 * @license
 * MIT License
 * 
 * Copyright (c) 2014-present, Lee Byron and other contributors.
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ /**
 * @license
 * MIT License
 * 
 * Copyright (c) 2014-present, Lee Byron and other contributors.
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ var $bd1a46f68c54954f$export$80f29b83543c27c5 = "@@__IMMUTABLE_MAP__@@";
function $bd1a46f68c54954f$export$5c90113a285f2241(maybeMap) {
    return Boolean(maybeMap && maybeMap[$bd1a46f68c54954f$export$80f29b83543c27c5]);
}



function $693a5cb59d634058$export$739bc167e02d45ee(maybeOrderedMap) {
    return (0, $bd1a46f68c54954f$export$5c90113a285f2241)(maybeOrderedMap) && (0, $d95bc815d10ddd62$export$e670b9b76442ef6c)(maybeOrderedMap);
}


/**
 * @license
 * MIT License
 * 
 * Copyright (c) 2014-present, Lee Byron and other contributors.
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ /**
 * @license
 * MIT License
 * 
 * Copyright (c) 2014-present, Lee Byron and other contributors.
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ /**
 * @license
 * MIT License
 * 
 * Copyright (c) 2014-present, Lee Byron and other contributors.
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ function $4e243b6ea8a0da68$export$b24f7407c77e5bd(maybeValue) {
    return Boolean(maybeValue && typeof maybeValue.equals === "function" && typeof maybeValue.hashCode === "function");
}


/**
 * An extension of the "same-value" algorithm as [described for use by ES6 Map
 * and Set](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map#Key_equality)
 *
 * NaN is considered the same as NaN, however -0 and 0 are considered the same
 * value, which is different from the algorithm described by
 * [`Object.is`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is).
 *
 * This is extended further to allow Objects to describe the values they
 * represent, by way of `valueOf` or `equals` (and `hashCode`).
 *
 * Note: because of this extension, the key equality of Immutable.Map and the
 * value equality of Immutable.Set will differ from ES6 Map and Set.
 *
 * ### Defining custom values
 *
 * The easiest way to describe the value an object represents is by implementing
 * `valueOf`. For example, `Date` represents a value by returning a unix
 * timestamp for `valueOf`:
 *
 *     var date1 = new Date(1234567890000); // Fri Feb 13 2009 ...
 *     var date2 = new Date(1234567890000);
 *     date1.valueOf(); // 1234567890000
 *     assert( date1 !== date2 );
 *     assert( Immutable.is( date1, date2 ) );
 *
 * Note: overriding `valueOf` may have other implications if you use this object
 * where JavaScript expects a primitive, such as implicit string coercion.
 *
 * For more complex types, especially collections, implementing `valueOf` may
 * not be performant. An alternative is to implement `equals` and `hashCode`.
 *
 * `equals` takes another object, presumably of similar type, and returns true
 * if it is equal. Equality is symmetrical, so the same result should be
 * returned if this and the argument are flipped.
 *
 *     assert( a.equals(b) === b.equals(a) );
 *
 * `hashCode` returns a 32bit integer number representing the object which will
 * be used to determine how to store the value object in a Map or Set. You must
 * provide both or neither methods, one must not exist without the other.
 *
 * Also, an important relationship between these methods must be upheld: if two
 * values are equal, they *must* return the same hashCode. If the values are not
 * equal, they might have the same hashCode; this is called a hash collision,
 * and while undesirable for performance reasons, it is acceptable.
 *
 *     if (a.equals(b)) {
 *       assert( a.hashCode() === b.hashCode() );
 *     }
 *
 * All Immutable collections are Value Objects: they implement `equals()`
 * and `hashCode()`.
 */ function $cffd0257ddfe6a6e$export$226b3eccf92c9ed9(valueA, valueB) {
    if (valueA === valueB || valueA !== valueA && valueB !== valueB) return true;
    if (!valueA || !valueB) return false;
    if (typeof valueA.valueOf === "function" && typeof valueB.valueOf === "function") {
        valueA = valueA.valueOf();
        valueB = valueB.valueOf();
        if (valueA === valueB || valueA !== valueA && valueB !== valueB) return true;
        if (!valueA || !valueB) return false;
    }
    return !!((0, $4e243b6ea8a0da68$export$b24f7407c77e5bd)(valueA) && (0, $4e243b6ea8a0da68$export$b24f7407c77e5bd)(valueB) && valueA.equals(valueB));
}






/**
 * @license
 * MIT License
 * 
 * Copyright (c) 2014-present, Lee Byron and other contributors.
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ /**
 * @license
 * MIT License
 * 
 * Copyright (c) 2014-present, Lee Byron and other contributors.
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ var $e36528f3fc6f83e1$export$46de3d998ca9a030 = typeof Math.imul === "function" && Math.imul(0xffffffff, 2) === -2 ? Math.imul : function imul(a, b) {
    a |= 0; // int
    b |= 0; // int
    var c = a & 0xffff;
    var d = b & 0xffff;
    // Shift by 0 fixes the sign on the high part.
    return c * d + ((a >>> 16) * d + c * (b >>> 16) << 16 >>> 0) | 0; // int
};
// v8 has an optimization for storing 31-bit signed numbers.
// Values which have either 00 or 11 as the high order bits qualify.
// This function drops the highest order bit in a signed number, maintaining
// the sign bit.
function $e36528f3fc6f83e1$export$6a4e4a90997f18fb(i32) {
    return i32 >>> 1 & 0x40000000 | i32 & 0xbfffffff;
}


var $826fab6845b48e0a$var$defaultValueOf = Object.prototype.valueOf;
function $826fab6845b48e0a$export$d6af199866bfb566(o) {
    if (o == null) return $826fab6845b48e0a$var$hashNullish(o);
    if (typeof o.hashCode === "function") // Drop any high bits from accidentally long hash codes.
    return (0, $e36528f3fc6f83e1$export$6a4e4a90997f18fb)(o.hashCode(o));
    var v = $826fab6845b48e0a$var$valueOf(o);
    if (v == null) return $826fab6845b48e0a$var$hashNullish(v);
    switch(typeof v){
        case "boolean":
            // The hash values for built-in constants are a 1 value for each 5-byte
            // shift region expect for the first, which encodes the value. This
            // reduces the odds of a hash collision for these common values.
            return v ? 0x42108421 : 0x42108420;
        case "number":
            return $826fab6845b48e0a$var$hashNumber(v);
        case "string":
            return v.length > $826fab6845b48e0a$var$STRING_HASH_CACHE_MIN_STRLEN ? $826fab6845b48e0a$var$cachedHashString(v) : $826fab6845b48e0a$var$hashString(v);
        case "object":
        case "function":
            return $826fab6845b48e0a$var$hashJSObj(v);
        case "symbol":
            return $826fab6845b48e0a$var$hashSymbol(v);
        default:
            if (typeof v.toString === "function") return $826fab6845b48e0a$var$hashString(v.toString());
            throw new Error("Value type " + typeof v + " cannot be hashed.");
    }
}
function $826fab6845b48e0a$var$hashNullish(nullish) {
    return nullish === null ? 0x42108422 : /* undefined */ 0x42108423;
}
// Compress arbitrarily large numbers into smi hashes.
function $826fab6845b48e0a$var$hashNumber(n) {
    if (n !== n || n === Infinity) return 0;
    var hash = n | 0;
    if (hash !== n) hash ^= n * 0xffffffff;
    while(n > 0xffffffff){
        n /= 0xffffffff;
        hash ^= n;
    }
    return (0, $e36528f3fc6f83e1$export$6a4e4a90997f18fb)(hash);
}
function $826fab6845b48e0a$var$cachedHashString(string) {
    var hashed = $826fab6845b48e0a$var$stringHashCache[string];
    if (hashed === undefined) {
        hashed = $826fab6845b48e0a$var$hashString(string);
        if ($826fab6845b48e0a$var$STRING_HASH_CACHE_SIZE === $826fab6845b48e0a$var$STRING_HASH_CACHE_MAX_SIZE) {
            $826fab6845b48e0a$var$STRING_HASH_CACHE_SIZE = 0;
            $826fab6845b48e0a$var$stringHashCache = {};
        }
        $826fab6845b48e0a$var$STRING_HASH_CACHE_SIZE++;
        $826fab6845b48e0a$var$stringHashCache[string] = hashed;
    }
    return hashed;
}
// http://jsperf.com/hashing-strings
function $826fab6845b48e0a$var$hashString(string) {
    // This is the hash from JVM
    // The hash code for a string is computed as
    // s[0] * 31 ^ (n - 1) + s[1] * 31 ^ (n - 2) + ... + s[n - 1],
    // where s[i] is the ith character of the string and n is the length of
    // the string. We "mod" the result to make it between 0 (inclusive) and 2^31
    // (exclusive) by dropping high bits.
    var hashed = 0;
    for(var ii = 0; ii < string.length; ii++)hashed = 31 * hashed + string.charCodeAt(ii) | 0;
    return (0, $e36528f3fc6f83e1$export$6a4e4a90997f18fb)(hashed);
}
function $826fab6845b48e0a$var$hashSymbol(sym) {
    var hashed = $826fab6845b48e0a$var$symbolMap[sym];
    if (hashed !== undefined) return hashed;
    hashed = $826fab6845b48e0a$var$nextHash();
    $826fab6845b48e0a$var$symbolMap[sym] = hashed;
    return hashed;
}
function $826fab6845b48e0a$var$hashJSObj(obj) {
    var hashed;
    if ($826fab6845b48e0a$var$usingWeakMap) {
        hashed = $826fab6845b48e0a$var$weakMap.get(obj);
        if (hashed !== undefined) return hashed;
    }
    hashed = obj[$826fab6845b48e0a$var$UID_HASH_KEY];
    if (hashed !== undefined) return hashed;
    if (!$826fab6845b48e0a$var$canDefineProperty) {
        hashed = obj.propertyIsEnumerable && obj.propertyIsEnumerable[$826fab6845b48e0a$var$UID_HASH_KEY];
        if (hashed !== undefined) return hashed;
        hashed = $826fab6845b48e0a$var$getIENodeHash(obj);
        if (hashed !== undefined) return hashed;
    }
    hashed = $826fab6845b48e0a$var$nextHash();
    if ($826fab6845b48e0a$var$usingWeakMap) $826fab6845b48e0a$var$weakMap.set(obj, hashed);
    else if ($826fab6845b48e0a$var$isExtensible !== undefined && $826fab6845b48e0a$var$isExtensible(obj) === false) throw new Error("Non-extensible objects are not allowed as keys.");
    else if ($826fab6845b48e0a$var$canDefineProperty) Object.defineProperty(obj, $826fab6845b48e0a$var$UID_HASH_KEY, {
        enumerable: false,
        configurable: false,
        writable: false,
        value: hashed
    });
    else if (obj.propertyIsEnumerable !== undefined && obj.propertyIsEnumerable === obj.constructor.prototype.propertyIsEnumerable) {
        // Since we can't define a non-enumerable property on the object
        // we'll hijack one of the less-used non-enumerable properties to
        // save our hash on it. Since this is a function it will not show up in
        // `JSON.stringify` which is what we want.
        obj.propertyIsEnumerable = function() {
            return this.constructor.prototype.propertyIsEnumerable.apply(this, arguments);
        };
        obj.propertyIsEnumerable[$826fab6845b48e0a$var$UID_HASH_KEY] = hashed;
    } else if (obj.nodeType !== undefined) // At this point we couldn't get the IE `uniqueID` to use as a hash
    // and we couldn't use a non-enumerable property to exploit the
    // dontEnum bug so we simply add the `UID_HASH_KEY` on the node
    // itself.
    obj[$826fab6845b48e0a$var$UID_HASH_KEY] = hashed;
    else throw new Error("Unable to set a non-enumerable property on object.");
    return hashed;
}
// Get references to ES5 object methods.
var $826fab6845b48e0a$var$isExtensible = Object.isExtensible;
// True if Object.defineProperty works as expected. IE8 fails this test.
var $826fab6845b48e0a$var$canDefineProperty = function() {
    try {
        Object.defineProperty({}, "@", {});
        return true;
    } catch (e) {
        return false;
    }
}();
// IE has a `uniqueID` property on DOM nodes. We can construct the hash from it
// and avoid memory leaks from the IE cloneNode bug.
function $826fab6845b48e0a$var$getIENodeHash(node) {
    if (node && node.nodeType > 0) switch(node.nodeType){
        case 1:
            return node.uniqueID;
        case 9:
            return node.documentElement && node.documentElement.uniqueID;
    }
}
function $826fab6845b48e0a$var$valueOf(obj) {
    return obj.valueOf !== $826fab6845b48e0a$var$defaultValueOf && typeof obj.valueOf === "function" ? obj.valueOf(obj) : obj;
}
function $826fab6845b48e0a$var$nextHash() {
    var nextHash = ++$826fab6845b48e0a$var$_objHashUID;
    if ($826fab6845b48e0a$var$_objHashUID & 0x40000000) $826fab6845b48e0a$var$_objHashUID = 0;
    return nextHash;
}
// If possible, use a WeakMap.
var $826fab6845b48e0a$var$usingWeakMap = typeof WeakMap === "function";
var $826fab6845b48e0a$var$weakMap;
if ($826fab6845b48e0a$var$usingWeakMap) $826fab6845b48e0a$var$weakMap = new WeakMap();
var $826fab6845b48e0a$var$symbolMap = Object.create(null);
var $826fab6845b48e0a$var$_objHashUID = 0;
var $826fab6845b48e0a$var$UID_HASH_KEY = "__immutablehash__";
if (typeof Symbol === "function") $826fab6845b48e0a$var$UID_HASH_KEY = Symbol($826fab6845b48e0a$var$UID_HASH_KEY);
var $826fab6845b48e0a$var$STRING_HASH_CACHE_MIN_STRLEN = 16;
var $826fab6845b48e0a$var$STRING_HASH_CACHE_MAX_SIZE = 255;
var $826fab6845b48e0a$var$STRING_HASH_CACHE_SIZE = 0;
var $826fab6845b48e0a$var$stringHashCache = {};



/**
 * @license
 * MIT License
 * 
 * Copyright (c) 2014-present, Lee Byron and other contributors.
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ 










var $8ec84f2e16db5cf4$export$219a757d6570b3bf = /*@__PURE__*/ function(KeyedSeq) {
    function ToKeyedSequence(indexed, useKeys) {
        this._iter = indexed;
        this._useKeys = useKeys;
        this.size = indexed.size;
    }
    if (KeyedSeq) ToKeyedSequence.__proto__ = KeyedSeq;
    ToKeyedSequence.prototype = Object.create(KeyedSeq && KeyedSeq.prototype);
    ToKeyedSequence.prototype.constructor = ToKeyedSequence;
    ToKeyedSequence.prototype.get = function get(key, notSetValue) {
        return this._iter.get(key, notSetValue);
    };
    ToKeyedSequence.prototype.has = function has(key) {
        return this._iter.has(key);
    };
    ToKeyedSequence.prototype.valueSeq = function valueSeq() {
        return this._iter.valueSeq();
    };
    ToKeyedSequence.prototype.reverse = function reverse() {
        var this$1$1 = this;
        var reversedSequence = $8ec84f2e16db5cf4$export$477fdcc6fc1d9334(this, true);
        if (!this._useKeys) reversedSequence.valueSeq = function() {
            return this$1$1._iter.toSeq().reverse();
        };
        return reversedSequence;
    };
    ToKeyedSequence.prototype.map = function map(mapper, context) {
        var this$1$1 = this;
        var mappedSequence = $8ec84f2e16db5cf4$export$5d295c87bcf8a823(this, mapper, context);
        if (!this._useKeys) mappedSequence.valueSeq = function() {
            return this$1$1._iter.toSeq().map(mapper, context);
        };
        return mappedSequence;
    };
    ToKeyedSequence.prototype.__iterate = function __iterate(fn, reverse) {
        var this$1$1 = this;
        return this._iter.__iterate(function(v, k) {
            return fn(v, k, this$1$1);
        }, reverse);
    };
    ToKeyedSequence.prototype.__iterator = function __iterator(type, reverse) {
        return this._iter.__iterator(type, reverse);
    };
    return ToKeyedSequence;
}((0, $a5938beaa66b3822$export$20f601f934d554cc));
$8ec84f2e16db5cf4$export$219a757d6570b3bf.prototype[0, $d95bc815d10ddd62$export$63a33a562da7c584] = true;
var $8ec84f2e16db5cf4$export$7b754de2844682e2 = /*@__PURE__*/ function(IndexedSeq) {
    function ToIndexedSequence(iter) {
        this._iter = iter;
        this.size = iter.size;
    }
    if (IndexedSeq) ToIndexedSequence.__proto__ = IndexedSeq;
    ToIndexedSequence.prototype = Object.create(IndexedSeq && IndexedSeq.prototype);
    ToIndexedSequence.prototype.constructor = ToIndexedSequence;
    ToIndexedSequence.prototype.includes = function includes(value) {
        return this._iter.includes(value);
    };
    ToIndexedSequence.prototype.__iterate = function __iterate(fn, reverse) {
        var this$1$1 = this;
        var i = 0;
        reverse && (0, $c2ddc03a1d32db1a$export$b8443e9e8396a588)(this);
        return this._iter.__iterate(function(v) {
            return fn(v, reverse ? this$1$1.size - ++i : i++, this$1$1);
        }, reverse);
    };
    ToIndexedSequence.prototype.__iterator = function __iterator(type, reverse) {
        var this$1$1 = this;
        var iterator = this._iter.__iterator((0, $88d0bf2511806126$export$20a9ccb927958bae), reverse);
        var i = 0;
        reverse && (0, $c2ddc03a1d32db1a$export$b8443e9e8396a588)(this);
        return new (0, $88d0bf2511806126$export$b67e82436e407e40)(function() {
            var step = iterator.next();
            return step.done ? step : (0, $88d0bf2511806126$export$dde1781ce8ad65f)(type, reverse ? this$1$1.size - ++i : i++, step.value, step);
        });
    };
    return ToIndexedSequence;
}((0, $a5938beaa66b3822$export$1b5716c72c24a934));
var $8ec84f2e16db5cf4$export$1c4696a2ef8f42ed = /*@__PURE__*/ function(SetSeq) {
    function ToSetSequence(iter) {
        this._iter = iter;
        this.size = iter.size;
    }
    if (SetSeq) ToSetSequence.__proto__ = SetSeq;
    ToSetSequence.prototype = Object.create(SetSeq && SetSeq.prototype);
    ToSetSequence.prototype.constructor = ToSetSequence;
    ToSetSequence.prototype.has = function has(key) {
        return this._iter.includes(key);
    };
    ToSetSequence.prototype.__iterate = function __iterate(fn, reverse) {
        var this$1$1 = this;
        return this._iter.__iterate(function(v) {
            return fn(v, v, this$1$1);
        }, reverse);
    };
    ToSetSequence.prototype.__iterator = function __iterator(type, reverse) {
        var iterator = this._iter.__iterator((0, $88d0bf2511806126$export$20a9ccb927958bae), reverse);
        return new (0, $88d0bf2511806126$export$b67e82436e407e40)(function() {
            var step = iterator.next();
            return step.done ? step : (0, $88d0bf2511806126$export$dde1781ce8ad65f)(type, step.value, step.value, step);
        });
    };
    return ToSetSequence;
}((0, $a5938beaa66b3822$export$bd141fae6edeb9b9));
var $8ec84f2e16db5cf4$export$394aa8ca251ed0c7 = /*@__PURE__*/ function(KeyedSeq) {
    function FromEntriesSequence(entries) {
        this._iter = entries;
        this.size = entries.size;
    }
    if (KeyedSeq) FromEntriesSequence.__proto__ = KeyedSeq;
    FromEntriesSequence.prototype = Object.create(KeyedSeq && KeyedSeq.prototype);
    FromEntriesSequence.prototype.constructor = FromEntriesSequence;
    FromEntriesSequence.prototype.entrySeq = function entrySeq() {
        return this._iter.toSeq();
    };
    FromEntriesSequence.prototype.__iterate = function __iterate(fn, reverse) {
        var this$1$1 = this;
        return this._iter.__iterate(function(entry) {
            // Check if entry exists first so array access doesn't throw for holes
            // in the parent iteration.
            if (entry) {
                $8ec84f2e16db5cf4$var$validateEntry(entry);
                var indexedCollection = (0, $d70bc35f1b2e7a74$export$cea7aa84e978eba5)(entry);
                return fn(indexedCollection ? entry.get(1) : entry[1], indexedCollection ? entry.get(0) : entry[0], this$1$1);
            }
        }, reverse);
    };
    FromEntriesSequence.prototype.__iterator = function __iterator(type, reverse) {
        var iterator = this._iter.__iterator((0, $88d0bf2511806126$export$20a9ccb927958bae), reverse);
        return new (0, $88d0bf2511806126$export$b67e82436e407e40)(function() {
            while(true){
                var step = iterator.next();
                if (step.done) return step;
                var entry = step.value;
                // Check if entry exists first so array access doesn't throw for holes
                // in the parent iteration.
                if (entry) {
                    $8ec84f2e16db5cf4$var$validateEntry(entry);
                    var indexedCollection = (0, $d70bc35f1b2e7a74$export$cea7aa84e978eba5)(entry);
                    return (0, $88d0bf2511806126$export$dde1781ce8ad65f)(type, indexedCollection ? entry.get(0) : entry[0], indexedCollection ? entry.get(1) : entry[1], step);
                }
            }
        });
    };
    return FromEntriesSequence;
}((0, $a5938beaa66b3822$export$20f601f934d554cc));
$8ec84f2e16db5cf4$export$7b754de2844682e2.prototype.cacheResult = $8ec84f2e16db5cf4$export$219a757d6570b3bf.prototype.cacheResult = $8ec84f2e16db5cf4$export$1c4696a2ef8f42ed.prototype.cacheResult = $8ec84f2e16db5cf4$export$394aa8ca251ed0c7.prototype.cacheResult = $8ec84f2e16db5cf4$var$cacheResultThrough;
function $8ec84f2e16db5cf4$export$1cc293e2f3cd461f(collection) {
    var flipSequence = $8ec84f2e16db5cf4$var$makeSequence(collection);
    flipSequence._iter = collection;
    flipSequence.size = collection.size;
    flipSequence.flip = function() {
        return collection;
    };
    flipSequence.reverse = function() {
        var reversedSequence = collection.reverse.apply(this); // super.reverse()
        reversedSequence.flip = function() {
            return collection.reverse();
        };
        return reversedSequence;
    };
    flipSequence.has = function(key) {
        return collection.includes(key);
    };
    flipSequence.includes = function(key) {
        return collection.has(key);
    };
    flipSequence.cacheResult = $8ec84f2e16db5cf4$var$cacheResultThrough;
    flipSequence.__iterateUncached = function(fn, reverse) {
        var this$1$1 = this;
        return collection.__iterate(function(v, k) {
            return fn(k, v, this$1$1) !== false;
        }, reverse);
    };
    flipSequence.__iteratorUncached = function(type, reverse) {
        if (type === (0, $88d0bf2511806126$export$ba5b1d03002a31af)) {
            var iterator = collection.__iterator(type, reverse);
            return new (0, $88d0bf2511806126$export$b67e82436e407e40)(function() {
                var step = iterator.next();
                if (!step.done) {
                    var k = step.value[0];
                    step.value[0] = step.value[1];
                    step.value[1] = k;
                }
                return step;
            });
        }
        return collection.__iterator(type === (0, $88d0bf2511806126$export$20a9ccb927958bae) ? (0, $88d0bf2511806126$export$cf2425c07c5cbc1) : (0, $88d0bf2511806126$export$20a9ccb927958bae), reverse);
    };
    return flipSequence;
}
function $8ec84f2e16db5cf4$export$5d295c87bcf8a823(collection, mapper, context) {
    var mappedSequence = $8ec84f2e16db5cf4$var$makeSequence(collection);
    mappedSequence.size = collection.size;
    mappedSequence.has = function(key) {
        return collection.has(key);
    };
    mappedSequence.get = function(key, notSetValue) {
        var v = collection.get(key, (0, $c2ddc03a1d32db1a$export$dc6d556e3fa8f459));
        return v === (0, $c2ddc03a1d32db1a$export$dc6d556e3fa8f459) ? notSetValue : mapper.call(context, v, key, collection);
    };
    mappedSequence.__iterateUncached = function(fn, reverse) {
        var this$1$1 = this;
        return collection.__iterate(function(v, k, c) {
            return fn(mapper.call(context, v, k, c), k, this$1$1) !== false;
        }, reverse);
    };
    mappedSequence.__iteratorUncached = function(type, reverse) {
        var iterator = collection.__iterator((0, $88d0bf2511806126$export$ba5b1d03002a31af), reverse);
        return new (0, $88d0bf2511806126$export$b67e82436e407e40)(function() {
            var step = iterator.next();
            if (step.done) return step;
            var entry = step.value;
            var key = entry[0];
            return (0, $88d0bf2511806126$export$dde1781ce8ad65f)(type, key, mapper.call(context, entry[1], key, collection), step);
        });
    };
    return mappedSequence;
}
function $8ec84f2e16db5cf4$export$477fdcc6fc1d9334(collection, useKeys) {
    var this$1$1 = this;
    var reversedSequence = $8ec84f2e16db5cf4$var$makeSequence(collection);
    reversedSequence._iter = collection;
    reversedSequence.size = collection.size;
    reversedSequence.reverse = function() {
        return collection;
    };
    if (collection.flip) reversedSequence.flip = function() {
        var flipSequence = $8ec84f2e16db5cf4$export$1cc293e2f3cd461f(collection);
        flipSequence.reverse = function() {
            return collection.flip();
        };
        return flipSequence;
    };
    reversedSequence.get = function(key, notSetValue) {
        return collection.get(useKeys ? key : -1 - key, notSetValue);
    };
    reversedSequence.has = function(key) {
        return collection.has(useKeys ? key : -1 - key);
    };
    reversedSequence.includes = function(value) {
        return collection.includes(value);
    };
    reversedSequence.cacheResult = $8ec84f2e16db5cf4$var$cacheResultThrough;
    reversedSequence.__iterate = function(fn, reverse) {
        var this$1$1 = this;
        var i = 0;
        reverse && (0, $c2ddc03a1d32db1a$export$b8443e9e8396a588)(collection);
        return collection.__iterate(function(v, k) {
            return fn(v, useKeys ? k : reverse ? this$1$1.size - ++i : i++, this$1$1);
        }, !reverse);
    };
    reversedSequence.__iterator = function(type, reverse) {
        var i = 0;
        reverse && (0, $c2ddc03a1d32db1a$export$b8443e9e8396a588)(collection);
        var iterator = collection.__iterator((0, $88d0bf2511806126$export$ba5b1d03002a31af), !reverse);
        return new (0, $88d0bf2511806126$export$b67e82436e407e40)(function() {
            var step = iterator.next();
            if (step.done) return step;
            var entry = step.value;
            return (0, $88d0bf2511806126$export$dde1781ce8ad65f)(type, useKeys ? entry[0] : reverse ? this$1$1.size - ++i : i++, entry[1], step);
        });
    };
    return reversedSequence;
}
function $8ec84f2e16db5cf4$export$97ef98b518aa31ce(collection, predicate, context, useKeys) {
    var filterSequence = $8ec84f2e16db5cf4$var$makeSequence(collection);
    if (useKeys) {
        filterSequence.has = function(key) {
            var v = collection.get(key, (0, $c2ddc03a1d32db1a$export$dc6d556e3fa8f459));
            return v !== (0, $c2ddc03a1d32db1a$export$dc6d556e3fa8f459) && !!predicate.call(context, v, key, collection);
        };
        filterSequence.get = function(key, notSetValue) {
            var v = collection.get(key, (0, $c2ddc03a1d32db1a$export$dc6d556e3fa8f459));
            return v !== (0, $c2ddc03a1d32db1a$export$dc6d556e3fa8f459) && predicate.call(context, v, key, collection) ? v : notSetValue;
        };
    }
    filterSequence.__iterateUncached = function(fn, reverse) {
        var this$1$1 = this;
        var iterations = 0;
        collection.__iterate(function(v, k, c) {
            if (predicate.call(context, v, k, c)) {
                iterations++;
                return fn(v, useKeys ? k : iterations - 1, this$1$1);
            }
        }, reverse);
        return iterations;
    };
    filterSequence.__iteratorUncached = function(type, reverse) {
        var iterator = collection.__iterator((0, $88d0bf2511806126$export$ba5b1d03002a31af), reverse);
        var iterations = 0;
        return new (0, $88d0bf2511806126$export$b67e82436e407e40)(function() {
            while(true){
                var step = iterator.next();
                if (step.done) return step;
                var entry = step.value;
                var key = entry[0];
                var value = entry[1];
                if (predicate.call(context, value, key, collection)) return (0, $88d0bf2511806126$export$dde1781ce8ad65f)(type, useKeys ? key : iterations++, value, step);
            }
        });
    };
    return filterSequence;
}
function $8ec84f2e16db5cf4$export$f662f6780bee687f(collection, grouper, context) {
    var groups = (0, $3ff96ffc4297bcc8$export$a5c7b93649eaf8f8)().asMutable();
    collection.__iterate(function(v, k) {
        groups.update(grouper.call(context, v, k, collection), 0, function(a) {
            return a + 1;
        });
    });
    return groups.asImmutable();
}
function $8ec84f2e16db5cf4$export$c6f81c0551133212(collection, grouper, context) {
    var isKeyedIter = (0, $e8d80ef58ba97d1e$export$66d51e2080425364)(collection);
    var groups = ((0, $d95bc815d10ddd62$export$e670b9b76442ef6c)(collection) ? (0, $acfb3e7ae62d9682$export$8e8eaa3741ef504c)() : (0, $3ff96ffc4297bcc8$export$a5c7b93649eaf8f8)()).asMutable();
    collection.__iterate(function(v, k) {
        groups.update(grouper.call(context, v, k, collection), function(a) {
            return a = a || [], a.push(isKeyedIter ? [
                k,
                v
            ] : v), a;
        });
    });
    var coerce = $8ec84f2e16db5cf4$var$collectionClass(collection);
    return groups.map(function(arr) {
        return $8ec84f2e16db5cf4$export$46ba2b2dce92f7a(collection, coerce(arr));
    }).asImmutable();
}
function $8ec84f2e16db5cf4$export$14c53bee7f214c1a(collection, predicate, context) {
    var isKeyedIter = (0, $e8d80ef58ba97d1e$export$66d51e2080425364)(collection);
    var groups = [
        [],
        []
    ];
    collection.__iterate(function(v, k) {
        groups[predicate.call(context, v, k, collection) ? 1 : 0].push(isKeyedIter ? [
            k,
            v
        ] : v);
    });
    var coerce = $8ec84f2e16db5cf4$var$collectionClass(collection);
    return groups.map(function(arr) {
        return $8ec84f2e16db5cf4$export$46ba2b2dce92f7a(collection, coerce(arr));
    });
}
function $8ec84f2e16db5cf4$export$819dab7fe30346f0(collection, begin, end, useKeys) {
    var originalSize = collection.size;
    if ((0, $c2ddc03a1d32db1a$export$39c07963d3ae8010)(begin, end, originalSize)) return collection;
    var resolvedBegin = (0, $c2ddc03a1d32db1a$export$b50255956c5410d8)(begin, originalSize);
    var resolvedEnd = (0, $c2ddc03a1d32db1a$export$9be3172c55e482a)(end, originalSize);
    // begin or end will be NaN if they were provided as negative numbers and
    // this collection's size is unknown. In that case, cache first so there is
    // a known size and these do not resolve to NaN.
    if (resolvedBegin !== resolvedBegin || resolvedEnd !== resolvedEnd) return $8ec84f2e16db5cf4$export$819dab7fe30346f0(collection.toSeq().cacheResult(), begin, end, useKeys);
    // Note: resolvedEnd is undefined when the original sequence's length is
    // unknown and this slice did not supply an end and should contain all
    // elements after resolvedBegin.
    // In that case, resolvedSize will be NaN and sliceSize will remain undefined.
    var resolvedSize = resolvedEnd - resolvedBegin;
    var sliceSize;
    if (resolvedSize === resolvedSize) sliceSize = resolvedSize < 0 ? 0 : resolvedSize;
    var sliceSeq = $8ec84f2e16db5cf4$var$makeSequence(collection);
    // If collection.size is undefined, the size of the realized sliceSeq is
    // unknown at this point unless the number of items to slice is 0
    sliceSeq.size = sliceSize === 0 ? sliceSize : collection.size && sliceSize || undefined;
    if (!useKeys && (0, $781499ae681aa138$export$342ac1d101ffe14b)(collection) && sliceSize >= 0) sliceSeq.get = function(index, notSetValue) {
        index = (0, $c2ddc03a1d32db1a$export$acb6ab09ed1b7b8b)(this, index);
        return index >= 0 && index < sliceSize ? collection.get(index + resolvedBegin, notSetValue) : notSetValue;
    };
    sliceSeq.__iterateUncached = function(fn, reverse) {
        var this$1$1 = this;
        if (sliceSize === 0) return 0;
        if (reverse) return this.cacheResult().__iterate(fn, reverse);
        var skipped = 0;
        var isSkipping = true;
        var iterations = 0;
        collection.__iterate(function(v, k) {
            if (!(isSkipping && (isSkipping = skipped++ < resolvedBegin))) {
                iterations++;
                return fn(v, useKeys ? k : iterations - 1, this$1$1) !== false && iterations !== sliceSize;
            }
        });
        return iterations;
    };
    sliceSeq.__iteratorUncached = function(type, reverse) {
        if (sliceSize !== 0 && reverse) return this.cacheResult().__iterator(type, reverse);
        // Don't bother instantiating parent iterator if taking 0.
        if (sliceSize === 0) return new (0, $88d0bf2511806126$export$b67e82436e407e40)((0, $88d0bf2511806126$export$e141d6e2268e9d85));
        var iterator = collection.__iterator(type, reverse);
        var skipped = 0;
        var iterations = 0;
        return new (0, $88d0bf2511806126$export$b67e82436e407e40)(function() {
            while(skipped++ < resolvedBegin)iterator.next();
            if (++iterations > sliceSize) return (0, $88d0bf2511806126$export$e141d6e2268e9d85)();
            var step = iterator.next();
            if (useKeys || type === (0, $88d0bf2511806126$export$20a9ccb927958bae) || step.done) return step;
            if (type === (0, $88d0bf2511806126$export$cf2425c07c5cbc1)) return (0, $88d0bf2511806126$export$dde1781ce8ad65f)(type, iterations - 1, undefined, step);
            return (0, $88d0bf2511806126$export$dde1781ce8ad65f)(type, iterations - 1, step.value[1], step);
        });
    };
    return sliceSeq;
}
function $8ec84f2e16db5cf4$export$3802045e50446382(collection, predicate, context) {
    var takeSequence = $8ec84f2e16db5cf4$var$makeSequence(collection);
    takeSequence.__iterateUncached = function(fn, reverse) {
        var this$1$1 = this;
        if (reverse) return this.cacheResult().__iterate(fn, reverse);
        var iterations = 0;
        collection.__iterate(function(v, k, c) {
            return predicate.call(context, v, k, c) && ++iterations && fn(v, k, this$1$1);
        });
        return iterations;
    };
    takeSequence.__iteratorUncached = function(type, reverse) {
        var this$1$1 = this;
        if (reverse) return this.cacheResult().__iterator(type, reverse);
        var iterator = collection.__iterator((0, $88d0bf2511806126$export$ba5b1d03002a31af), reverse);
        var iterating = true;
        return new (0, $88d0bf2511806126$export$b67e82436e407e40)(function() {
            if (!iterating) return (0, $88d0bf2511806126$export$e141d6e2268e9d85)();
            var step = iterator.next();
            if (step.done) return step;
            var entry = step.value;
            var k = entry[0];
            var v = entry[1];
            if (!predicate.call(context, v, k, this$1$1)) {
                iterating = false;
                return (0, $88d0bf2511806126$export$e141d6e2268e9d85)();
            }
            return type === (0, $88d0bf2511806126$export$ba5b1d03002a31af) ? step : (0, $88d0bf2511806126$export$dde1781ce8ad65f)(type, k, v, step);
        });
    };
    return takeSequence;
}
function $8ec84f2e16db5cf4$export$f2073acb6c95136f(collection, predicate, context, useKeys) {
    var skipSequence = $8ec84f2e16db5cf4$var$makeSequence(collection);
    skipSequence.__iterateUncached = function(fn, reverse) {
        var this$1$1 = this;
        if (reverse) return this.cacheResult().__iterate(fn, reverse);
        var isSkipping = true;
        var iterations = 0;
        collection.__iterate(function(v, k, c) {
            if (!(isSkipping && (isSkipping = predicate.call(context, v, k, c)))) {
                iterations++;
                return fn(v, useKeys ? k : iterations - 1, this$1$1);
            }
        });
        return iterations;
    };
    skipSequence.__iteratorUncached = function(type, reverse) {
        var this$1$1 = this;
        if (reverse) return this.cacheResult().__iterator(type, reverse);
        var iterator = collection.__iterator((0, $88d0bf2511806126$export$ba5b1d03002a31af), reverse);
        var skipping = true;
        var iterations = 0;
        return new (0, $88d0bf2511806126$export$b67e82436e407e40)(function() {
            var step;
            var k;
            var v;
            do {
                step = iterator.next();
                if (step.done) {
                    if (useKeys || type === (0, $88d0bf2511806126$export$20a9ccb927958bae)) return step;
                    if (type === (0, $88d0bf2511806126$export$cf2425c07c5cbc1)) return (0, $88d0bf2511806126$export$dde1781ce8ad65f)(type, iterations++, undefined, step);
                    return (0, $88d0bf2511806126$export$dde1781ce8ad65f)(type, iterations++, step.value[1], step);
                }
                var entry = step.value;
                k = entry[0];
                v = entry[1];
                skipping && (skipping = predicate.call(context, v, k, this$1$1));
            }while (skipping);
            return type === (0, $88d0bf2511806126$export$ba5b1d03002a31af) ? step : (0, $88d0bf2511806126$export$dde1781ce8ad65f)(type, k, v, step);
        });
    };
    return skipSequence;
}
function $8ec84f2e16db5cf4$export$dc42ac9421804a0a(collection, values) {
    var isKeyedCollection = (0, $e8d80ef58ba97d1e$export$66d51e2080425364)(collection);
    var iters = [
        collection
    ].concat(values).map(function(v) {
        if (!(0, $d70bc35f1b2e7a74$export$cea7aa84e978eba5)(v)) v = isKeyedCollection ? (0, $a5938beaa66b3822$export$437b28e5b41f462b)(v) : (0, $a5938beaa66b3822$export$205e4de7b617cdbd)(Array.isArray(v) ? v : [
            v
        ]);
        else if (isKeyedCollection) v = (0, $4952a3ccc7265b27$export$6e235e3661e8f430)(v);
        return v;
    }).filter(function(v) {
        return v.size !== 0;
    });
    if (iters.length === 0) return collection;
    if (iters.length === 1) {
        var singleton = iters[0];
        if (singleton === collection || isKeyedCollection && (0, $e8d80ef58ba97d1e$export$66d51e2080425364)(singleton) || (0, $a4ecf346f3821d5f$export$3bfb5e72e8bc6e09)(collection) && (0, $a4ecf346f3821d5f$export$3bfb5e72e8bc6e09)(singleton)) return singleton;
    }
    var concatSeq = new (0, $a5938beaa66b3822$export$b0774ff537b4dcee)(iters);
    if (isKeyedCollection) concatSeq = concatSeq.toKeyedSeq();
    else if (!(0, $a4ecf346f3821d5f$export$3bfb5e72e8bc6e09)(collection)) concatSeq = concatSeq.toSetSeq();
    concatSeq = concatSeq.flatten(true);
    concatSeq.size = iters.reduce(function(sum, seq) {
        if (sum !== undefined) {
            var size = seq.size;
            if (size !== undefined) return sum + size;
        }
    }, 0);
    return concatSeq;
}
function $8ec84f2e16db5cf4$export$12d97d167e8720a3(collection, depth, useKeys) {
    var flatSequence = $8ec84f2e16db5cf4$var$makeSequence(collection);
    flatSequence.__iterateUncached = function(fn, reverse) {
        if (reverse) return this.cacheResult().__iterate(fn, reverse);
        var iterations = 0;
        var stopped = false;
        function flatDeep(iter, currentDepth) {
            iter.__iterate(function(v, k) {
                if ((!depth || currentDepth < depth) && (0, $d70bc35f1b2e7a74$export$cea7aa84e978eba5)(v)) flatDeep(v, currentDepth + 1);
                else {
                    iterations++;
                    if (fn(v, useKeys ? k : iterations - 1, flatSequence) === false) stopped = true;
                }
                return !stopped;
            }, reverse);
        }
        flatDeep(collection, 0);
        return iterations;
    };
    flatSequence.__iteratorUncached = function(type, reverse) {
        if (reverse) return this.cacheResult().__iterator(type, reverse);
        var iterator = collection.__iterator(type, reverse);
        var stack = [];
        var iterations = 0;
        return new (0, $88d0bf2511806126$export$b67e82436e407e40)(function() {
            while(iterator){
                var step = iterator.next();
                if (step.done !== false) {
                    iterator = stack.pop();
                    continue;
                }
                var v = step.value;
                if (type === (0, $88d0bf2511806126$export$ba5b1d03002a31af)) v = v[1];
                if ((!depth || stack.length < depth) && (0, $d70bc35f1b2e7a74$export$cea7aa84e978eba5)(v)) {
                    stack.push(iterator);
                    iterator = v.__iterator(type, reverse);
                } else return useKeys ? step : (0, $88d0bf2511806126$export$dde1781ce8ad65f)(type, iterations++, v, step);
            }
            return (0, $88d0bf2511806126$export$e141d6e2268e9d85)();
        });
    };
    return flatSequence;
}
function $8ec84f2e16db5cf4$export$8f6683ff3cb92273(collection, mapper, context) {
    var coerce = $8ec84f2e16db5cf4$var$collectionClass(collection);
    return collection.toSeq().map(function(v, k) {
        return coerce(mapper.call(context, v, k, collection));
    }).flatten(true);
}
function $8ec84f2e16db5cf4$export$780b5c72de7da758(collection, separator) {
    var interposedSequence = $8ec84f2e16db5cf4$var$makeSequence(collection);
    interposedSequence.size = collection.size && collection.size * 2 - 1;
    interposedSequence.__iterateUncached = function(fn, reverse) {
        var this$1$1 = this;
        var iterations = 0;
        collection.__iterate(function(v) {
            return (!iterations || fn(separator, iterations++, this$1$1) !== false) && fn(v, iterations++, this$1$1) !== false;
        }, reverse);
        return iterations;
    };
    interposedSequence.__iteratorUncached = function(type, reverse) {
        var iterator = collection.__iterator((0, $88d0bf2511806126$export$20a9ccb927958bae), reverse);
        var iterations = 0;
        var step;
        return new (0, $88d0bf2511806126$export$b67e82436e407e40)(function() {
            if (!step || iterations % 2) {
                step = iterator.next();
                if (step.done) return step;
            }
            return iterations % 2 ? (0, $88d0bf2511806126$export$dde1781ce8ad65f)(type, iterations++, separator) : (0, $88d0bf2511806126$export$dde1781ce8ad65f)(type, iterations++, step.value, step);
        });
    };
    return interposedSequence;
}
function $8ec84f2e16db5cf4$export$2950ac5a8a1b38e5(collection, comparator, mapper) {
    if (!comparator) comparator = $8ec84f2e16db5cf4$var$defaultComparator;
    var isKeyedCollection = (0, $e8d80ef58ba97d1e$export$66d51e2080425364)(collection);
    var index = 0;
    var entries = collection.toSeq().map(function(v, k) {
        return [
            k,
            v,
            index++,
            mapper ? mapper(v, k, collection) : v
        ];
    }).valueSeq().toArray();
    entries.sort(function(a, b) {
        return comparator(a[3], b[3]) || a[2] - b[2];
    }).forEach(isKeyedCollection ? function(v, i) {
        entries[i].length = 2;
    } : function(v, i) {
        entries[i] = v[1];
    });
    return isKeyedCollection ? (0, $a5938beaa66b3822$export$20f601f934d554cc)(entries) : (0, $a4ecf346f3821d5f$export$3bfb5e72e8bc6e09)(collection) ? (0, $a5938beaa66b3822$export$1b5716c72c24a934)(entries) : (0, $a5938beaa66b3822$export$bd141fae6edeb9b9)(entries);
}
function $8ec84f2e16db5cf4$export$9f2d12982e77eb8(collection, comparator, mapper) {
    if (!comparator) comparator = $8ec84f2e16db5cf4$var$defaultComparator;
    if (mapper) {
        var entry = collection.toSeq().map(function(v, k) {
            return [
                v,
                mapper(v, k, collection)
            ];
        }).reduce(function(a, b) {
            return $8ec84f2e16db5cf4$var$maxCompare(comparator, a[1], b[1]) ? b : a;
        });
        return entry && entry[0];
    }
    return collection.reduce(function(a, b) {
        return $8ec84f2e16db5cf4$var$maxCompare(comparator, a, b) ? b : a;
    });
}
function $8ec84f2e16db5cf4$var$maxCompare(comparator, a, b) {
    var comp = comparator(b, a);
    // b is considered the new max if the comparator declares them equal, but
    // they are not equal and b is in fact a nullish value.
    return comp === 0 && b !== a && (b === undefined || b === null || b !== b) || comp > 0;
}
function $8ec84f2e16db5cf4$export$7573772064585831(keyIter, zipper, iters, zipAll) {
    var zipSequence = $8ec84f2e16db5cf4$var$makeSequence(keyIter);
    var sizes = new (0, $a5938beaa66b3822$export$b0774ff537b4dcee)(iters).map(function(i) {
        return i.size;
    });
    zipSequence.size = zipAll ? sizes.max() : sizes.min();
    // Note: this a generic base implementation of __iterate in terms of
    // __iterator which may be more generically useful in the future.
    zipSequence.__iterate = function(fn, reverse) {
        /* generic:
    var iterator = this.__iterator(ITERATE_ENTRIES, reverse);
    var step;
    var iterations = 0;
    while (!(step = iterator.next()).done) {
      iterations++;
      if (fn(step.value[1], step.value[0], this) === false) {
        break;
      }
    }
    return iterations;
    */ // indexed:
        var iterator = this.__iterator((0, $88d0bf2511806126$export$20a9ccb927958bae), reverse);
        var step;
        var iterations = 0;
        while(!(step = iterator.next()).done){
            if (fn(step.value, iterations++, this) === false) break;
        }
        return iterations;
    };
    zipSequence.__iteratorUncached = function(type, reverse) {
        var iterators = iters.map(function(i) {
            return i = (0, $4952a3ccc7265b27$export$fb8073518f34e6ec)(i), (0, $88d0bf2511806126$export$6731da38428a8625)(reverse ? i.reverse() : i);
        });
        var iterations = 0;
        var isDone = false;
        return new (0, $88d0bf2511806126$export$b67e82436e407e40)(function() {
            var steps;
            if (!isDone) {
                steps = iterators.map(function(i) {
                    return i.next();
                });
                isDone = zipAll ? steps.every(function(s) {
                    return s.done;
                }) : steps.some(function(s) {
                    return s.done;
                });
            }
            if (isDone) return (0, $88d0bf2511806126$export$e141d6e2268e9d85)();
            return (0, $88d0bf2511806126$export$dde1781ce8ad65f)(type, iterations++, zipper.apply(null, steps.map(function(s) {
                return s.value;
            })));
        });
    };
    return zipSequence;
}
// #pragma Helper Functions
function $8ec84f2e16db5cf4$export$46ba2b2dce92f7a(iter, seq) {
    return iter === seq ? iter : (0, $781499ae681aa138$export$342ac1d101ffe14b)(iter) ? seq : iter.constructor(seq);
}
function $8ec84f2e16db5cf4$var$validateEntry(entry) {
    if (entry !== Object(entry)) throw new TypeError("Expected [K, V] tuple: " + entry);
}
function $8ec84f2e16db5cf4$var$collectionClass(collection) {
    return (0, $e8d80ef58ba97d1e$export$66d51e2080425364)(collection) ? (0, $4952a3ccc7265b27$export$6e235e3661e8f430) : (0, $a4ecf346f3821d5f$export$3bfb5e72e8bc6e09)(collection) ? (0, $4952a3ccc7265b27$export$eb9d6a4c2661c7e7) : (0, $4952a3ccc7265b27$export$8ace86ce31a5e0e7);
}
function $8ec84f2e16db5cf4$var$makeSequence(collection) {
    return Object.create(((0, $e8d80ef58ba97d1e$export$66d51e2080425364)(collection) ? (0, $a5938beaa66b3822$export$20f601f934d554cc) : (0, $a4ecf346f3821d5f$export$3bfb5e72e8bc6e09)(collection) ? (0, $a5938beaa66b3822$export$1b5716c72c24a934) : (0, $a5938beaa66b3822$export$bd141fae6edeb9b9)).prototype);
}
function $8ec84f2e16db5cf4$var$cacheResultThrough() {
    if (this._iter.cacheResult) {
        this._iter.cacheResult();
        this.size = this._iter.size;
        return this;
    }
    return (0, $a5938beaa66b3822$export$4802c350533dc67e).prototype.cacheResult.call(this);
}
function $8ec84f2e16db5cf4$var$defaultComparator(a, b) {
    if (a === undefined && b === undefined) return 0;
    if (a === undefined) return 1;
    if (b === undefined) return -1;
    return a > b ? 1 : a < b ? -1 : 0;
}


/**
 * @license
 * MIT License
 * 
 * Copyright (c) 2014-present, Lee Byron and other contributors.
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ // http://jsperf.com/copy-array-inline
function $1464138edd0700c2$export$2e2bcd8739ae039(arr, offset) {
    offset = offset || 0;
    var len = Math.max(0, arr.length - offset);
    var newArr = new Array(len);
    for(var ii = 0; ii < len; ii++)newArr[ii] = arr[ii + offset];
    return newArr;
}


/**
 * @license
 * MIT License
 * 
 * Copyright (c) 2014-present, Lee Byron and other contributors.
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ /**
 * @license
 * MIT License
 * 
 * Copyright (c) 2014-present, Lee Byron and other contributors.
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ function $e70ac56ed1101873$export$2e2bcd8739ae039(condition, error) {
    if (!condition) throw new Error(error);
}


function $6ec38c7a88fbe1b6$export$2e2bcd8739ae039(size) {
    (0, $e70ac56ed1101873$export$2e2bcd8739ae039)(size !== Infinity, "Cannot perform this action with an infinite size.");
}


/**
 * @license
 * MIT License
 * 
 * Copyright (c) 2014-present, Lee Byron and other contributors.
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ /**
 * @license
 * MIT License
 * 
 * Copyright (c) 2014-present, Lee Byron and other contributors.
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ /**
 * @license
 * MIT License
 * 
 * Copyright (c) 2014-present, Lee Byron and other contributors.
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ 
/**
 * @license
 * MIT License
 * 
 * Copyright (c) 2014-present, Lee Byron and other contributors.
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ 

function $31ceb94ca8bbb05a$export$2e2bcd8739ae039(keyPath) {
    if ((0, $67716be90529aa17$export$2e2bcd8739ae039)(keyPath) && typeof keyPath !== "string") return keyPath;
    if ((0, $d95bc815d10ddd62$export$e670b9b76442ef6c)(keyPath)) return keyPath.toArray();
    throw new TypeError("Invalid keyPath: expected Ordered Collection or Array: " + keyPath);
}


/**
 * @license
 * MIT License
 * 
 * Copyright (c) 2014-present, Lee Byron and other contributors.
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ 
/**
 * @license
 * MIT License
 * 
 * Copyright (c) 2014-present, Lee Byron and other contributors.
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ var $c80481447c971627$var$toString = Object.prototype.toString;
function $c80481447c971627$export$2e2bcd8739ae039(value) {
    // The base prototype's toString deals with Argument objects and native namespaces like Math
    if (!value || typeof value !== "object" || $c80481447c971627$var$toString.call(value) !== "[object Object]") return false;
    var proto = Object.getPrototypeOf(value);
    if (proto === null) return true;
    // Iteratively going up the prototype chain is needed for cross-realm environments (differing contexts, iframes, etc)
    var parentProto = proto;
    var nextProto = Object.getPrototypeOf(proto);
    while(nextProto !== null){
        parentProto = nextProto;
        nextProto = Object.getPrototypeOf(parentProto);
    }
    return parentProto === proto;
}


/**
 * Returns true if the value is a potentially-persistent data structure, either
 * provided by Immutable.js or a plain Array or Object.
 */ function $ffb9edbd071c7829$export$2e2bcd8739ae039(value) {
    return typeof value === "object" && ((0, $821b634c82af17ef$export$f8647edfbac13b4f)(value) || Array.isArray(value) || (0, $c80481447c971627$export$2e2bcd8739ae039)(value));
}


/**
 * @license
 * MIT License
 * 
 * Copyright (c) 2014-present, Lee Byron and other contributors.
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ /**
 * Converts a value to a string, adding quotes if a string was provided.
 */ function $bd09225c08825e19$export$2e2bcd8739ae039(value) {
    try {
        return typeof value === "string" ? JSON.stringify(value) : String(value);
    } catch (_ignoreError) {
        return JSON.stringify(value);
    }
}




/**
 * @license
 * MIT License
 * 
 * Copyright (c) 2014-present, Lee Byron and other contributors.
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ 
/**
 * @license
 * MIT License
 * 
 * Copyright (c) 2014-present, Lee Byron and other contributors.
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ 


function $0161bd0c35897c14$export$a4f4bb6b1453fff5(collection, key) {
    return (0, $821b634c82af17ef$export$f8647edfbac13b4f)(collection) ? collection.has(key) : (0, $ffb9edbd071c7829$export$2e2bcd8739ae039)(collection) && (0, $e96acf24d7e0818a$export$2e2bcd8739ae039).call(collection, key);
}


function $a91ac00741fd7597$export$3988ae62b71be9a3(collection, key, notSetValue) {
    return (0, $821b634c82af17ef$export$f8647edfbac13b4f)(collection) ? collection.get(key, notSetValue) : !(0, $0161bd0c35897c14$export$a4f4bb6b1453fff5)(collection, key) ? notSetValue : typeof collection.get === "function" ? collection.get(key) : collection[key];
}


/**
 * @license
 * MIT License
 * 
 * Copyright (c) 2014-present, Lee Byron and other contributors.
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ 


/**
 * @license
 * MIT License
 * 
 * Copyright (c) 2014-present, Lee Byron and other contributors.
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ 

function $55d732cadea25415$export$2e2bcd8739ae039(from) {
    if (Array.isArray(from)) return (0, $1464138edd0700c2$export$2e2bcd8739ae039)(from);
    var to = {};
    for(var key in from)if ((0, $e96acf24d7e0818a$export$2e2bcd8739ae039).call(from, key)) to[key] = from[key];
    return to;
}


function $cebde492a88f7762$export$cd7f480d6b8286c3(collection, key) {
    if (!(0, $ffb9edbd071c7829$export$2e2bcd8739ae039)(collection)) throw new TypeError("Cannot update non-data-structure value: " + collection);
    if ((0, $821b634c82af17ef$export$f8647edfbac13b4f)(collection)) {
        if (!collection.remove) throw new TypeError("Cannot update immutable value without .remove() method: " + collection);
        return collection.remove(key);
    }
    if (!(0, $e96acf24d7e0818a$export$2e2bcd8739ae039).call(collection, key)) return collection;
    var collectionCopy = (0, $55d732cadea25415$export$2e2bcd8739ae039)(collection);
    if (Array.isArray(collectionCopy)) collectionCopy.splice(key, 1);
    else delete collectionCopy[key];
    return collectionCopy;
}


/**
 * @license
 * MIT License
 * 
 * Copyright (c) 2014-present, Lee Byron and other contributors.
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ 



function $dc9f544fa111904d$export$adaa4cf7ef1b65be(collection, key, value) {
    if (!(0, $ffb9edbd071c7829$export$2e2bcd8739ae039)(collection)) throw new TypeError("Cannot update non-data-structure value: " + collection);
    if ((0, $821b634c82af17ef$export$f8647edfbac13b4f)(collection)) {
        if (!collection.set) throw new TypeError("Cannot update immutable value without .set() method: " + collection);
        return collection.set(key, value);
    }
    if ((0, $e96acf24d7e0818a$export$2e2bcd8739ae039).call(collection, key) && value === collection[key]) return collection;
    var collectionCopy = (0, $55d732cadea25415$export$2e2bcd8739ae039)(collection);
    collectionCopy[key] = value;
    return collectionCopy;
}


function $f32fb19553378b7c$export$f3e3cd1fc9c33ca1(collection, keyPath, notSetValue, updater) {
    if (!updater) {
        updater = notSetValue;
        notSetValue = undefined;
    }
    var updatedValue = $f32fb19553378b7c$var$updateInDeeply((0, $821b634c82af17ef$export$f8647edfbac13b4f)(collection), collection, (0, $31ceb94ca8bbb05a$export$2e2bcd8739ae039)(keyPath), 0, notSetValue, updater);
    return updatedValue === (0, $c2ddc03a1d32db1a$export$dc6d556e3fa8f459) ? notSetValue : updatedValue;
}
function $f32fb19553378b7c$var$updateInDeeply(inImmutable, existing, keyPath, i, notSetValue, updater) {
    var wasNotSet = existing === (0, $c2ddc03a1d32db1a$export$dc6d556e3fa8f459);
    if (i === keyPath.length) {
        var existingValue = wasNotSet ? notSetValue : existing;
        var newValue = updater(existingValue);
        return newValue === existingValue ? existing : newValue;
    }
    if (!wasNotSet && !(0, $ffb9edbd071c7829$export$2e2bcd8739ae039)(existing)) throw new TypeError("Cannot update within non-data-structure value in path [" + keyPath.slice(0, i).map((0, $bd09225c08825e19$export$2e2bcd8739ae039)) + "]: " + existing);
    var key = keyPath[i];
    var nextExisting = wasNotSet ? (0, $c2ddc03a1d32db1a$export$dc6d556e3fa8f459) : (0, $a91ac00741fd7597$export$3988ae62b71be9a3)(existing, key, (0, $c2ddc03a1d32db1a$export$dc6d556e3fa8f459));
    var nextUpdated = $f32fb19553378b7c$var$updateInDeeply(nextExisting === (0, $c2ddc03a1d32db1a$export$dc6d556e3fa8f459) ? inImmutable : (0, $821b634c82af17ef$export$f8647edfbac13b4f)(nextExisting), nextExisting, keyPath, i + 1, notSetValue, updater);
    return nextUpdated === nextExisting ? existing : nextUpdated === (0, $c2ddc03a1d32db1a$export$dc6d556e3fa8f459) ? (0, $cebde492a88f7762$export$cd7f480d6b8286c3)(existing, key) : (0, $dc9f544fa111904d$export$adaa4cf7ef1b65be)(wasNotSet ? inImmutable ? (0, $3ff96ffc4297bcc8$export$dbfbb79577167c48)() : {} : existing, key, nextUpdated);
}



function $417ec453c2fca3b4$export$e6bdf135a54e021b(collection, keyPath, value) {
    return (0, $f32fb19553378b7c$export$f3e3cd1fc9c33ca1)(collection, keyPath, (0, $c2ddc03a1d32db1a$export$dc6d556e3fa8f459), function() {
        return value;
    });
}


function $a04d866a117c3434$export$e6bdf135a54e021b(keyPath, v) {
    return (0, $417ec453c2fca3b4$export$e6bdf135a54e021b)(this, keyPath, v);
}


/**
 * @license
 * MIT License
 * 
 * Copyright (c) 2014-present, Lee Byron and other contributors.
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ /**
 * @license
 * MIT License
 * 
 * Copyright (c) 2014-present, Lee Byron and other contributors.
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ 

function $1f771dded4c47a9e$export$b56fa1d8ac1a28ad(collection, keyPath) {
    return (0, $f32fb19553378b7c$export$f3e3cd1fc9c33ca1)(collection, keyPath, function() {
        return 0, $c2ddc03a1d32db1a$export$dc6d556e3fa8f459;
    });
}


function $2b25b81e7ecaadb3$export$706cff822a6f730d(keyPath) {
    return (0, $1f771dded4c47a9e$export$b56fa1d8ac1a28ad)(this, keyPath);
}


/**
 * @license
 * MIT License
 * 
 * Copyright (c) 2014-present, Lee Byron and other contributors.
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ /**
 * @license
 * MIT License
 * 
 * Copyright (c) 2014-present, Lee Byron and other contributors.
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ 
function $bddc5e7208652b84$export$722fbec263ad908a(collection, key, notSetValue, updater) {
    return (0, $f32fb19553378b7c$export$f3e3cd1fc9c33ca1)(collection, [
        key
    ], notSetValue, updater);
}


function $32345e910e3f25e5$export$722fbec263ad908a(key, notSetValue, updater) {
    return arguments.length === 1 ? key(this) : (0, $bddc5e7208652b84$export$722fbec263ad908a)(this, key, notSetValue, updater);
}


/**
 * @license
 * MIT License
 * 
 * Copyright (c) 2014-present, Lee Byron and other contributors.
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ 
function $614b9ab34d28a86a$export$f3e3cd1fc9c33ca1(keyPath, notSetValue, updater) {
    return (0, $f32fb19553378b7c$export$f3e3cd1fc9c33ca1)(this, keyPath, notSetValue, updater);
}


/**
 * @license
 * MIT License
 * 
 * Copyright (c) 2014-present, Lee Byron and other contributors.
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ 


function $5836386861972c7b$export$4950aa0f605343fb() {
    var iters = [], len = arguments.length;
    while(len--)iters[len] = arguments[len];
    return $5836386861972c7b$var$mergeIntoKeyedWith(this, iters);
}
function $5836386861972c7b$export$2ee76fde9ffe109d(merger) {
    var iters = [], len = arguments.length - 1;
    while(len-- > 0)iters[len] = arguments[len + 1];
    if (typeof merger !== "function") throw new TypeError("Invalid merger function: " + merger);
    return $5836386861972c7b$var$mergeIntoKeyedWith(this, iters, merger);
}
function $5836386861972c7b$var$mergeIntoKeyedWith(collection, collections, merger) {
    var iters = [];
    for(var ii = 0; ii < collections.length; ii++){
        var collection$1 = (0, $4952a3ccc7265b27$export$6e235e3661e8f430)(collections[ii]);
        if (collection$1.size !== 0) iters.push(collection$1);
    }
    if (iters.length === 0) return collection;
    if (collection.toSeq().size === 0 && !collection.__ownerID && iters.length === 1) return collection.constructor(iters[0]);
    return collection.withMutations(function(collection) {
        var mergeIntoCollection = merger ? function(value, key) {
            (0, $bddc5e7208652b84$export$722fbec263ad908a)(collection, key, (0, $c2ddc03a1d32db1a$export$dc6d556e3fa8f459), function(oldVal) {
                return oldVal === (0, $c2ddc03a1d32db1a$export$dc6d556e3fa8f459) ? value : merger(oldVal, value, key);
            });
        } : function(value, key) {
            collection.set(key, value);
        };
        for(var ii = 0; ii < iters.length; ii++)iters[ii].forEach(mergeIntoCollection);
    });
}


/**
 * @license
 * MIT License
 * 
 * Copyright (c) 2014-present, Lee Byron and other contributors.
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ /**
 * @license
 * MIT License
 * 
 * Copyright (c) 2014-present, Lee Byron and other contributors.
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ 







function $b8fe2d75c7583f49$export$4950aa0f605343fb(collection) {
    var sources = [], len = arguments.length - 1;
    while(len-- > 0)sources[len] = arguments[len + 1];
    return $b8fe2d75c7583f49$export$4eb66a6fbdf78d6b(collection, sources);
}
function $b8fe2d75c7583f49$export$2ee76fde9ffe109d(merger, collection) {
    var sources = [], len = arguments.length - 2;
    while(len-- > 0)sources[len] = arguments[len + 2];
    return $b8fe2d75c7583f49$export$4eb66a6fbdf78d6b(collection, sources, merger);
}
function $b8fe2d75c7583f49$export$dd702b3c8240390c(collection) {
    var sources = [], len = arguments.length - 1;
    while(len-- > 0)sources[len] = arguments[len + 1];
    return $b8fe2d75c7583f49$export$a64d743c5f536d03(collection, sources);
}
function $b8fe2d75c7583f49$export$aa0aa29a716b1650(merger, collection) {
    var sources = [], len = arguments.length - 2;
    while(len-- > 0)sources[len] = arguments[len + 2];
    return $b8fe2d75c7583f49$export$a64d743c5f536d03(collection, sources, merger);
}
function $b8fe2d75c7583f49$export$a64d743c5f536d03(collection, sources, merger) {
    return $b8fe2d75c7583f49$export$4eb66a6fbdf78d6b(collection, sources, $b8fe2d75c7583f49$var$deepMergerWith(merger));
}
function $b8fe2d75c7583f49$export$4eb66a6fbdf78d6b(collection, sources, merger) {
    if (!(0, $ffb9edbd071c7829$export$2e2bcd8739ae039)(collection)) throw new TypeError("Cannot merge into non-data-structure value: " + collection);
    if ((0, $821b634c82af17ef$export$f8647edfbac13b4f)(collection)) return typeof merger === "function" && collection.mergeWith ? collection.mergeWith.apply(collection, [
        merger
    ].concat(sources)) : collection.merge ? collection.merge.apply(collection, sources) : collection.concat.apply(collection, sources);
    var isArray = Array.isArray(collection);
    var merged = collection;
    var Collection = isArray ? (0, $4952a3ccc7265b27$export$eb9d6a4c2661c7e7) : (0, $4952a3ccc7265b27$export$6e235e3661e8f430);
    var mergeItem = isArray ? function(value) {
        // Copy on write
        if (merged === collection) merged = (0, $55d732cadea25415$export$2e2bcd8739ae039)(merged);
        merged.push(value);
    } : function(value, key) {
        var hasVal = (0, $e96acf24d7e0818a$export$2e2bcd8739ae039).call(merged, key);
        var nextVal = hasVal && merger ? merger(merged[key], value, key) : value;
        if (!hasVal || nextVal !== merged[key]) {
            // Copy on write
            if (merged === collection) merged = (0, $55d732cadea25415$export$2e2bcd8739ae039)(merged);
            merged[key] = nextVal;
        }
    };
    for(var i = 0; i < sources.length; i++)Collection(sources[i]).forEach(mergeItem);
    return merged;
}
function $b8fe2d75c7583f49$var$deepMergerWith(merger) {
    function deepMerger(oldValue, newValue, key) {
        return (0, $ffb9edbd071c7829$export$2e2bcd8739ae039)(oldValue) && (0, $ffb9edbd071c7829$export$2e2bcd8739ae039)(newValue) && $b8fe2d75c7583f49$var$areMergeable(oldValue, newValue) ? $b8fe2d75c7583f49$export$4eb66a6fbdf78d6b(oldValue, [
            newValue
        ], deepMerger) : merger ? merger(oldValue, newValue, key) : newValue;
    }
    return deepMerger;
}
/**
 * It's unclear what the desired behavior is for merging two collections that
 * fall into separate categories between keyed, indexed, or set-like, so we only
 * consider them mergeable if they fall into the same category.
 */ function $b8fe2d75c7583f49$var$areMergeable(oldDataStructure, newDataStructure) {
    var oldSeq = (0, $a5938beaa66b3822$export$4802c350533dc67e)(oldDataStructure);
    var newSeq = (0, $a5938beaa66b3822$export$4802c350533dc67e)(newDataStructure);
    // This logic assumes that a sequence can only fall into one of the three
    // categories mentioned above (since there's no `isSetLike()` method).
    return (0, $a4ecf346f3821d5f$export$3bfb5e72e8bc6e09)(oldSeq) === (0, $a4ecf346f3821d5f$export$3bfb5e72e8bc6e09)(newSeq) && (0, $e8d80ef58ba97d1e$export$66d51e2080425364)(oldSeq) === (0, $e8d80ef58ba97d1e$export$66d51e2080425364)(newSeq);
}


function $cea06d4b36e8eb56$export$dd702b3c8240390c() {
    var iters = [], len = arguments.length;
    while(len--)iters[len] = arguments[len];
    return (0, $b8fe2d75c7583f49$export$a64d743c5f536d03)(this, iters);
}
function $cea06d4b36e8eb56$export$aa0aa29a716b1650(merger) {
    var iters = [], len = arguments.length - 1;
    while(len-- > 0)iters[len] = arguments[len + 1];
    return (0, $b8fe2d75c7583f49$export$a64d743c5f536d03)(this, iters, merger);
}


/**
 * @license
 * MIT License
 * 
 * Copyright (c) 2014-present, Lee Byron and other contributors.
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ 


function $f6cbcb4ed76baee0$export$271ff073c1ade46a(keyPath) {
    var iters = [], len = arguments.length - 1;
    while(len-- > 0)iters[len] = arguments[len + 1];
    return (0, $f32fb19553378b7c$export$f3e3cd1fc9c33ca1)(this, keyPath, (0, $3ff96ffc4297bcc8$export$dbfbb79577167c48)(), function(m) {
        return (0, $b8fe2d75c7583f49$export$4eb66a6fbdf78d6b)(m, iters);
    });
}


/**
 * @license
 * MIT License
 * 
 * Copyright (c) 2014-present, Lee Byron and other contributors.
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ 


function $abe07da7d44267a3$export$534837be55d4be99(keyPath) {
    var iters = [], len = arguments.length - 1;
    while(len-- > 0)iters[len] = arguments[len + 1];
    return (0, $f32fb19553378b7c$export$f3e3cd1fc9c33ca1)(this, keyPath, (0, $3ff96ffc4297bcc8$export$dbfbb79577167c48)(), function(m) {
        return (0, $b8fe2d75c7583f49$export$a64d743c5f536d03)(m, iters);
    });
}


/**
 * @license
 * MIT License
 * 
 * Copyright (c) 2014-present, Lee Byron and other contributors.
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ function $17d048964b7d8355$export$c779a0e1bb0d59bf(fn) {
    var mutable = this.asMutable();
    fn(mutable);
    return mutable.wasAltered() ? mutable.__ensureOwner(this.__ownerID) : this;
}


/**
 * @license
 * MIT License
 * 
 * Copyright (c) 2014-present, Lee Byron and other contributors.
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ 
function $49ab0d381a1fe1a2$export$9cce5776307dcd36() {
    return this.__ownerID ? this : this.__ensureOwner(new (0, $c2ddc03a1d32db1a$export$f629661819ff67eb)());
}


/**
 * @license
 * MIT License
 * 
 * Copyright (c) 2014-present, Lee Byron and other contributors.
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ function $3042678b907a98f2$export$158f0e042e0dd7fe() {
    return this.__ensureOwner();
}


/**
 * @license
 * MIT License
 * 
 * Copyright (c) 2014-present, Lee Byron and other contributors.
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ function $72ebf32788fc71db$export$b9916d438dfa08cf() {
    return this.__altered;
}



var $3ff96ffc4297bcc8$export$a5c7b93649eaf8f8 = /*@__PURE__*/ function(KeyedCollection) {
    function Map(value) {
        return value === undefined || value === null ? $3ff96ffc4297bcc8$export$dbfbb79577167c48() : (0, $bd1a46f68c54954f$export$5c90113a285f2241)(value) && !(0, $d95bc815d10ddd62$export$e670b9b76442ef6c)(value) ? value : $3ff96ffc4297bcc8$export$dbfbb79577167c48().withMutations(function(map) {
            var iter = KeyedCollection(value);
            (0, $6ec38c7a88fbe1b6$export$2e2bcd8739ae039)(iter.size);
            iter.forEach(function(v, k) {
                return map.set(k, v);
            });
        });
    }
    if (KeyedCollection) Map.__proto__ = KeyedCollection;
    Map.prototype = Object.create(KeyedCollection && KeyedCollection.prototype);
    Map.prototype.constructor = Map;
    Map.of = function of() {
        var keyValues = [], len = arguments.length;
        while(len--)keyValues[len] = arguments[len];
        return $3ff96ffc4297bcc8$export$dbfbb79577167c48().withMutations(function(map) {
            for(var i = 0; i < keyValues.length; i += 2){
                if (i + 1 >= keyValues.length) throw new Error("Missing value for key: " + keyValues[i]);
                map.set(keyValues[i], keyValues[i + 1]);
            }
        });
    };
    Map.prototype.toString = function toString() {
        return this.__toString("Map {", "}");
    };
    // @pragma Access
    Map.prototype.get = function get(k, notSetValue) {
        return this._root ? this._root.get(0, undefined, k, notSetValue) : notSetValue;
    };
    // @pragma Modification
    Map.prototype.set = function set(k, v) {
        return $3ff96ffc4297bcc8$var$updateMap(this, k, v);
    };
    Map.prototype.remove = function remove(k) {
        return $3ff96ffc4297bcc8$var$updateMap(this, k, (0, $c2ddc03a1d32db1a$export$dc6d556e3fa8f459));
    };
    Map.prototype.deleteAll = function deleteAll(keys) {
        var collection = (0, $4952a3ccc7265b27$export$fb8073518f34e6ec)(keys);
        if (collection.size === 0) return this;
        return this.withMutations(function(map) {
            collection.forEach(function(key) {
                return map.remove(key);
            });
        });
    };
    Map.prototype.clear = function clear() {
        if (this.size === 0) return this;
        if (this.__ownerID) {
            this.size = 0;
            this._root = null;
            this.__hash = undefined;
            this.__altered = true;
            return this;
        }
        return $3ff96ffc4297bcc8$export$dbfbb79577167c48();
    };
    // @pragma Composition
    Map.prototype.sort = function sort(comparator) {
        // Late binding
        return (0, $acfb3e7ae62d9682$export$8e8eaa3741ef504c)((0, $8ec84f2e16db5cf4$export$2950ac5a8a1b38e5)(this, comparator));
    };
    Map.prototype.sortBy = function sortBy(mapper, comparator) {
        // Late binding
        return (0, $acfb3e7ae62d9682$export$8e8eaa3741ef504c)((0, $8ec84f2e16db5cf4$export$2950ac5a8a1b38e5)(this, comparator, mapper));
    };
    Map.prototype.map = function map(mapper, context) {
        var this$1$1 = this;
        return this.withMutations(function(map) {
            map.forEach(function(value, key) {
                map.set(key, mapper.call(context, value, key, this$1$1));
            });
        });
    };
    // @pragma Mutability
    Map.prototype.__iterator = function __iterator(type, reverse) {
        return new $3ff96ffc4297bcc8$var$MapIterator(this, type, reverse);
    };
    Map.prototype.__iterate = function __iterate(fn, reverse) {
        var this$1$1 = this;
        var iterations = 0;
        this._root && this._root.iterate(function(entry) {
            iterations++;
            return fn(entry[1], entry[0], this$1$1);
        }, reverse);
        return iterations;
    };
    Map.prototype.__ensureOwner = function __ensureOwner(ownerID) {
        if (ownerID === this.__ownerID) return this;
        if (!ownerID) {
            if (this.size === 0) return $3ff96ffc4297bcc8$export$dbfbb79577167c48();
            this.__ownerID = ownerID;
            this.__altered = false;
            return this;
        }
        return $3ff96ffc4297bcc8$var$makeMap(this.size, this._root, ownerID, this.__hash);
    };
    return Map;
}((0, $4952a3ccc7265b27$export$6e235e3661e8f430));
$3ff96ffc4297bcc8$export$a5c7b93649eaf8f8.isMap = (0, $bd1a46f68c54954f$export$5c90113a285f2241);
var $3ff96ffc4297bcc8$var$MapPrototype = $3ff96ffc4297bcc8$export$a5c7b93649eaf8f8.prototype;
$3ff96ffc4297bcc8$var$MapPrototype[0, $bd1a46f68c54954f$export$80f29b83543c27c5] = true;
$3ff96ffc4297bcc8$var$MapPrototype[0, $c2ddc03a1d32db1a$export$4bd2facc4a3e6aa1] = $3ff96ffc4297bcc8$var$MapPrototype.remove;
$3ff96ffc4297bcc8$var$MapPrototype.removeAll = $3ff96ffc4297bcc8$var$MapPrototype.deleteAll;
$3ff96ffc4297bcc8$var$MapPrototype.setIn = (0, $a04d866a117c3434$export$e6bdf135a54e021b);
$3ff96ffc4297bcc8$var$MapPrototype.removeIn = $3ff96ffc4297bcc8$var$MapPrototype.deleteIn = (0, $2b25b81e7ecaadb3$export$706cff822a6f730d);
$3ff96ffc4297bcc8$var$MapPrototype.update = (0, $32345e910e3f25e5$export$722fbec263ad908a);
$3ff96ffc4297bcc8$var$MapPrototype.updateIn = (0, $614b9ab34d28a86a$export$f3e3cd1fc9c33ca1);
$3ff96ffc4297bcc8$var$MapPrototype.merge = $3ff96ffc4297bcc8$var$MapPrototype.concat = (0, $5836386861972c7b$export$4950aa0f605343fb);
$3ff96ffc4297bcc8$var$MapPrototype.mergeWith = (0, $5836386861972c7b$export$2ee76fde9ffe109d);
$3ff96ffc4297bcc8$var$MapPrototype.mergeDeep = (0, $cea06d4b36e8eb56$export$dd702b3c8240390c);
$3ff96ffc4297bcc8$var$MapPrototype.mergeDeepWith = (0, $cea06d4b36e8eb56$export$aa0aa29a716b1650);
$3ff96ffc4297bcc8$var$MapPrototype.mergeIn = (0, $f6cbcb4ed76baee0$export$271ff073c1ade46a);
$3ff96ffc4297bcc8$var$MapPrototype.mergeDeepIn = (0, $abe07da7d44267a3$export$534837be55d4be99);
$3ff96ffc4297bcc8$var$MapPrototype.withMutations = (0, $17d048964b7d8355$export$c779a0e1bb0d59bf);
$3ff96ffc4297bcc8$var$MapPrototype.wasAltered = (0, $72ebf32788fc71db$export$b9916d438dfa08cf);
$3ff96ffc4297bcc8$var$MapPrototype.asImmutable = (0, $3042678b907a98f2$export$158f0e042e0dd7fe);
$3ff96ffc4297bcc8$var$MapPrototype["@@transducer/init"] = $3ff96ffc4297bcc8$var$MapPrototype.asMutable = (0, $49ab0d381a1fe1a2$export$9cce5776307dcd36);
$3ff96ffc4297bcc8$var$MapPrototype["@@transducer/step"] = function(result, arr) {
    return result.set(arr[0], arr[1]);
};
$3ff96ffc4297bcc8$var$MapPrototype["@@transducer/result"] = function(obj) {
    return obj.asImmutable();
};
// #pragma Trie Nodes
var $3ff96ffc4297bcc8$var$ArrayMapNode = function ArrayMapNode(ownerID, entries) {
    this.ownerID = ownerID;
    this.entries = entries;
};
$3ff96ffc4297bcc8$var$ArrayMapNode.prototype.get = function get(shift, keyHash, key, notSetValue) {
    var entries = this.entries;
    for(var ii = 0, len = entries.length; ii < len; ii++){
        if ((0, $cffd0257ddfe6a6e$export$226b3eccf92c9ed9)(key, entries[ii][0])) return entries[ii][1];
    }
    return notSetValue;
};
$3ff96ffc4297bcc8$var$ArrayMapNode.prototype.update = function update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
    var removed = value === (0, $c2ddc03a1d32db1a$export$dc6d556e3fa8f459);
    var entries = this.entries;
    var idx = 0;
    var len = entries.length;
    for(; idx < len; idx++){
        if ((0, $cffd0257ddfe6a6e$export$226b3eccf92c9ed9)(key, entries[idx][0])) break;
    }
    var exists = idx < len;
    if (exists ? entries[idx][1] === value : removed) return this;
    (0, $c2ddc03a1d32db1a$export$5c111b5829d07529)(didAlter);
    (removed || !exists) && (0, $c2ddc03a1d32db1a$export$5c111b5829d07529)(didChangeSize);
    if (removed && entries.length === 1) return; // undefined
    if (!exists && !removed && entries.length >= $3ff96ffc4297bcc8$var$MAX_ARRAY_MAP_SIZE) return $3ff96ffc4297bcc8$var$createNodes(ownerID, entries, key, value);
    var isEditable = ownerID && ownerID === this.ownerID;
    var newEntries = isEditable ? entries : (0, $1464138edd0700c2$export$2e2bcd8739ae039)(entries);
    if (exists) {
        if (removed) idx === len - 1 ? newEntries.pop() : newEntries[idx] = newEntries.pop();
        else newEntries[idx] = [
            key,
            value
        ];
    } else newEntries.push([
        key,
        value
    ]);
    if (isEditable) {
        this.entries = newEntries;
        return this;
    }
    return new $3ff96ffc4297bcc8$var$ArrayMapNode(ownerID, newEntries);
};
var $3ff96ffc4297bcc8$var$BitmapIndexedNode = function BitmapIndexedNode(ownerID, bitmap, nodes) {
    this.ownerID = ownerID;
    this.bitmap = bitmap;
    this.nodes = nodes;
};
$3ff96ffc4297bcc8$var$BitmapIndexedNode.prototype.get = function get(shift, keyHash, key, notSetValue) {
    if (keyHash === undefined) keyHash = (0, $826fab6845b48e0a$export$d6af199866bfb566)(key);
    var bit = 1 << ((shift === 0 ? keyHash : keyHash >>> shift) & (0, $c2ddc03a1d32db1a$export$e14dab7236868a5));
    var bitmap = this.bitmap;
    return (bitmap & bit) === 0 ? notSetValue : this.nodes[$3ff96ffc4297bcc8$var$popCount(bitmap & bit - 1)].get(shift + (0, $c2ddc03a1d32db1a$export$d36167fd695703b4), keyHash, key, notSetValue);
};
$3ff96ffc4297bcc8$var$BitmapIndexedNode.prototype.update = function update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
    if (keyHash === undefined) keyHash = (0, $826fab6845b48e0a$export$d6af199866bfb566)(key);
    var keyHashFrag = (shift === 0 ? keyHash : keyHash >>> shift) & (0, $c2ddc03a1d32db1a$export$e14dab7236868a5);
    var bit = 1 << keyHashFrag;
    var bitmap = this.bitmap;
    var exists = (bitmap & bit) !== 0;
    if (!exists && value === (0, $c2ddc03a1d32db1a$export$dc6d556e3fa8f459)) return this;
    var idx = $3ff96ffc4297bcc8$var$popCount(bitmap & bit - 1);
    var nodes = this.nodes;
    var node = exists ? nodes[idx] : undefined;
    var newNode = $3ff96ffc4297bcc8$var$updateNode(node, ownerID, shift + (0, $c2ddc03a1d32db1a$export$d36167fd695703b4), keyHash, key, value, didChangeSize, didAlter);
    if (newNode === node) return this;
    if (!exists && newNode && nodes.length >= $3ff96ffc4297bcc8$var$MAX_BITMAP_INDEXED_SIZE) return $3ff96ffc4297bcc8$var$expandNodes(ownerID, nodes, bitmap, keyHashFrag, newNode);
    if (exists && !newNode && nodes.length === 2 && $3ff96ffc4297bcc8$var$isLeafNode(nodes[idx ^ 1])) return nodes[idx ^ 1];
    if (exists && newNode && nodes.length === 1 && $3ff96ffc4297bcc8$var$isLeafNode(newNode)) return newNode;
    var isEditable = ownerID && ownerID === this.ownerID;
    var newBitmap = exists ? newNode ? bitmap : bitmap ^ bit : bitmap | bit;
    var newNodes = exists ? newNode ? $3ff96ffc4297bcc8$var$setAt(nodes, idx, newNode, isEditable) : $3ff96ffc4297bcc8$var$spliceOut(nodes, idx, isEditable) : $3ff96ffc4297bcc8$var$spliceIn(nodes, idx, newNode, isEditable);
    if (isEditable) {
        this.bitmap = newBitmap;
        this.nodes = newNodes;
        return this;
    }
    return new $3ff96ffc4297bcc8$var$BitmapIndexedNode(ownerID, newBitmap, newNodes);
};
var $3ff96ffc4297bcc8$var$HashArrayMapNode = function HashArrayMapNode(ownerID, count, nodes) {
    this.ownerID = ownerID;
    this.count = count;
    this.nodes = nodes;
};
$3ff96ffc4297bcc8$var$HashArrayMapNode.prototype.get = function get(shift, keyHash, key, notSetValue) {
    if (keyHash === undefined) keyHash = (0, $826fab6845b48e0a$export$d6af199866bfb566)(key);
    var idx = (shift === 0 ? keyHash : keyHash >>> shift) & (0, $c2ddc03a1d32db1a$export$e14dab7236868a5);
    var node = this.nodes[idx];
    return node ? node.get(shift + (0, $c2ddc03a1d32db1a$export$d36167fd695703b4), keyHash, key, notSetValue) : notSetValue;
};
$3ff96ffc4297bcc8$var$HashArrayMapNode.prototype.update = function update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
    if (keyHash === undefined) keyHash = (0, $826fab6845b48e0a$export$d6af199866bfb566)(key);
    var idx = (shift === 0 ? keyHash : keyHash >>> shift) & (0, $c2ddc03a1d32db1a$export$e14dab7236868a5);
    var removed = value === (0, $c2ddc03a1d32db1a$export$dc6d556e3fa8f459);
    var nodes = this.nodes;
    var node = nodes[idx];
    if (removed && !node) return this;
    var newNode = $3ff96ffc4297bcc8$var$updateNode(node, ownerID, shift + (0, $c2ddc03a1d32db1a$export$d36167fd695703b4), keyHash, key, value, didChangeSize, didAlter);
    if (newNode === node) return this;
    var newCount = this.count;
    if (!node) newCount++;
    else if (!newNode) {
        newCount--;
        if (newCount < $3ff96ffc4297bcc8$var$MIN_HASH_ARRAY_MAP_SIZE) return $3ff96ffc4297bcc8$var$packNodes(ownerID, nodes, newCount, idx);
    }
    var isEditable = ownerID && ownerID === this.ownerID;
    var newNodes = $3ff96ffc4297bcc8$var$setAt(nodes, idx, newNode, isEditable);
    if (isEditable) {
        this.count = newCount;
        this.nodes = newNodes;
        return this;
    }
    return new $3ff96ffc4297bcc8$var$HashArrayMapNode(ownerID, newCount, newNodes);
};
var $3ff96ffc4297bcc8$var$HashCollisionNode = function HashCollisionNode(ownerID, keyHash, entries) {
    this.ownerID = ownerID;
    this.keyHash = keyHash;
    this.entries = entries;
};
$3ff96ffc4297bcc8$var$HashCollisionNode.prototype.get = function get(shift, keyHash, key, notSetValue) {
    var entries = this.entries;
    for(var ii = 0, len = entries.length; ii < len; ii++){
        if ((0, $cffd0257ddfe6a6e$export$226b3eccf92c9ed9)(key, entries[ii][0])) return entries[ii][1];
    }
    return notSetValue;
};
$3ff96ffc4297bcc8$var$HashCollisionNode.prototype.update = function update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
    if (keyHash === undefined) keyHash = (0, $826fab6845b48e0a$export$d6af199866bfb566)(key);
    var removed = value === (0, $c2ddc03a1d32db1a$export$dc6d556e3fa8f459);
    if (keyHash !== this.keyHash) {
        if (removed) return this;
        (0, $c2ddc03a1d32db1a$export$5c111b5829d07529)(didAlter);
        (0, $c2ddc03a1d32db1a$export$5c111b5829d07529)(didChangeSize);
        return $3ff96ffc4297bcc8$var$mergeIntoNode(this, ownerID, shift, keyHash, [
            key,
            value
        ]);
    }
    var entries = this.entries;
    var idx = 0;
    var len = entries.length;
    for(; idx < len; idx++){
        if ((0, $cffd0257ddfe6a6e$export$226b3eccf92c9ed9)(key, entries[idx][0])) break;
    }
    var exists = idx < len;
    if (exists ? entries[idx][1] === value : removed) return this;
    (0, $c2ddc03a1d32db1a$export$5c111b5829d07529)(didAlter);
    (removed || !exists) && (0, $c2ddc03a1d32db1a$export$5c111b5829d07529)(didChangeSize);
    if (removed && len === 2) return new $3ff96ffc4297bcc8$var$ValueNode(ownerID, this.keyHash, entries[idx ^ 1]);
    var isEditable = ownerID && ownerID === this.ownerID;
    var newEntries = isEditable ? entries : (0, $1464138edd0700c2$export$2e2bcd8739ae039)(entries);
    if (exists) {
        if (removed) idx === len - 1 ? newEntries.pop() : newEntries[idx] = newEntries.pop();
        else newEntries[idx] = [
            key,
            value
        ];
    } else newEntries.push([
        key,
        value
    ]);
    if (isEditable) {
        this.entries = newEntries;
        return this;
    }
    return new $3ff96ffc4297bcc8$var$HashCollisionNode(ownerID, this.keyHash, newEntries);
};
var $3ff96ffc4297bcc8$var$ValueNode = function ValueNode(ownerID, keyHash, entry) {
    this.ownerID = ownerID;
    this.keyHash = keyHash;
    this.entry = entry;
};
$3ff96ffc4297bcc8$var$ValueNode.prototype.get = function get(shift, keyHash, key, notSetValue) {
    return (0, $cffd0257ddfe6a6e$export$226b3eccf92c9ed9)(key, this.entry[0]) ? this.entry[1] : notSetValue;
};
$3ff96ffc4297bcc8$var$ValueNode.prototype.update = function update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
    var removed = value === (0, $c2ddc03a1d32db1a$export$dc6d556e3fa8f459);
    var keyMatch = (0, $cffd0257ddfe6a6e$export$226b3eccf92c9ed9)(key, this.entry[0]);
    if (keyMatch ? value === this.entry[1] : removed) return this;
    (0, $c2ddc03a1d32db1a$export$5c111b5829d07529)(didAlter);
    if (removed) {
        (0, $c2ddc03a1d32db1a$export$5c111b5829d07529)(didChangeSize);
        return; // undefined
    }
    if (keyMatch) {
        if (ownerID && ownerID === this.ownerID) {
            this.entry[1] = value;
            return this;
        }
        return new $3ff96ffc4297bcc8$var$ValueNode(ownerID, this.keyHash, [
            key,
            value
        ]);
    }
    (0, $c2ddc03a1d32db1a$export$5c111b5829d07529)(didChangeSize);
    return $3ff96ffc4297bcc8$var$mergeIntoNode(this, ownerID, shift, (0, $826fab6845b48e0a$export$d6af199866bfb566)(key), [
        key,
        value
    ]);
};
// #pragma Iterators
$3ff96ffc4297bcc8$var$ArrayMapNode.prototype.iterate = $3ff96ffc4297bcc8$var$HashCollisionNode.prototype.iterate = function(fn, reverse) {
    var entries = this.entries;
    for(var ii = 0, maxIndex = entries.length - 1; ii <= maxIndex; ii++){
        if (fn(entries[reverse ? maxIndex - ii : ii]) === false) return false;
    }
};
$3ff96ffc4297bcc8$var$BitmapIndexedNode.prototype.iterate = $3ff96ffc4297bcc8$var$HashArrayMapNode.prototype.iterate = function(fn, reverse) {
    var nodes = this.nodes;
    for(var ii = 0, maxIndex = nodes.length - 1; ii <= maxIndex; ii++){
        var node = nodes[reverse ? maxIndex - ii : ii];
        if (node && node.iterate(fn, reverse) === false) return false;
    }
};
// eslint-disable-next-line no-unused-vars
$3ff96ffc4297bcc8$var$ValueNode.prototype.iterate = function(fn, reverse) {
    return fn(this.entry);
};
var $3ff96ffc4297bcc8$var$MapIterator = /*@__PURE__*/ function(Iterator) {
    function MapIterator(map, type, reverse) {
        this._type = type;
        this._reverse = reverse;
        this._stack = map._root && $3ff96ffc4297bcc8$var$mapIteratorFrame(map._root);
    }
    if (Iterator) MapIterator.__proto__ = Iterator;
    MapIterator.prototype = Object.create(Iterator && Iterator.prototype);
    MapIterator.prototype.constructor = MapIterator;
    MapIterator.prototype.next = function next() {
        var type = this._type;
        var stack = this._stack;
        while(stack){
            var node = stack.node;
            var index = stack.index++;
            var maxIndex = void 0;
            if (node.entry) {
                if (index === 0) return $3ff96ffc4297bcc8$var$mapIteratorValue(type, node.entry);
            } else if (node.entries) {
                maxIndex = node.entries.length - 1;
                if (index <= maxIndex) return $3ff96ffc4297bcc8$var$mapIteratorValue(type, node.entries[this._reverse ? maxIndex - index : index]);
            } else {
                maxIndex = node.nodes.length - 1;
                if (index <= maxIndex) {
                    var subNode = node.nodes[this._reverse ? maxIndex - index : index];
                    if (subNode) {
                        if (subNode.entry) return $3ff96ffc4297bcc8$var$mapIteratorValue(type, subNode.entry);
                        stack = this._stack = $3ff96ffc4297bcc8$var$mapIteratorFrame(subNode, stack);
                    }
                    continue;
                }
            }
            stack = this._stack = this._stack.__prev;
        }
        return (0, $88d0bf2511806126$export$e141d6e2268e9d85)();
    };
    return MapIterator;
}((0, $88d0bf2511806126$export$b67e82436e407e40));
function $3ff96ffc4297bcc8$var$mapIteratorValue(type, entry) {
    return (0, $88d0bf2511806126$export$dde1781ce8ad65f)(type, entry[0], entry[1]);
}
function $3ff96ffc4297bcc8$var$mapIteratorFrame(node, prev) {
    return {
        node: node,
        index: 0,
        __prev: prev
    };
}
function $3ff96ffc4297bcc8$var$makeMap(size, root, ownerID, hash) {
    var map = Object.create($3ff96ffc4297bcc8$var$MapPrototype);
    map.size = size;
    map._root = root;
    map.__ownerID = ownerID;
    map.__hash = hash;
    map.__altered = false;
    return map;
}
var $3ff96ffc4297bcc8$var$EMPTY_MAP;
function $3ff96ffc4297bcc8$export$dbfbb79577167c48() {
    return $3ff96ffc4297bcc8$var$EMPTY_MAP || ($3ff96ffc4297bcc8$var$EMPTY_MAP = $3ff96ffc4297bcc8$var$makeMap(0));
}
function $3ff96ffc4297bcc8$var$updateMap(map, k, v) {
    var newRoot;
    var newSize;
    if (!map._root) {
        if (v === (0, $c2ddc03a1d32db1a$export$dc6d556e3fa8f459)) return map;
        newSize = 1;
        newRoot = new $3ff96ffc4297bcc8$var$ArrayMapNode(map.__ownerID, [
            [
                k,
                v
            ]
        ]);
    } else {
        var didChangeSize = (0, $c2ddc03a1d32db1a$export$a4907f3d95a6b59f)();
        var didAlter = (0, $c2ddc03a1d32db1a$export$a4907f3d95a6b59f)();
        newRoot = $3ff96ffc4297bcc8$var$updateNode(map._root, map.__ownerID, 0, undefined, k, v, didChangeSize, didAlter);
        if (!didAlter.value) return map;
        newSize = map.size + (didChangeSize.value ? v === (0, $c2ddc03a1d32db1a$export$dc6d556e3fa8f459) ? -1 : 1 : 0);
    }
    if (map.__ownerID) {
        map.size = newSize;
        map._root = newRoot;
        map.__hash = undefined;
        map.__altered = true;
        return map;
    }
    return newRoot ? $3ff96ffc4297bcc8$var$makeMap(newSize, newRoot) : $3ff96ffc4297bcc8$export$dbfbb79577167c48();
}
function $3ff96ffc4297bcc8$var$updateNode(node, ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
    if (!node) {
        if (value === (0, $c2ddc03a1d32db1a$export$dc6d556e3fa8f459)) return node;
        (0, $c2ddc03a1d32db1a$export$5c111b5829d07529)(didAlter);
        (0, $c2ddc03a1d32db1a$export$5c111b5829d07529)(didChangeSize);
        return new $3ff96ffc4297bcc8$var$ValueNode(ownerID, keyHash, [
            key,
            value
        ]);
    }
    return node.update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter);
}
function $3ff96ffc4297bcc8$var$isLeafNode(node) {
    return node.constructor === $3ff96ffc4297bcc8$var$ValueNode || node.constructor === $3ff96ffc4297bcc8$var$HashCollisionNode;
}
function $3ff96ffc4297bcc8$var$mergeIntoNode(node, ownerID, shift, keyHash, entry) {
    if (node.keyHash === keyHash) return new $3ff96ffc4297bcc8$var$HashCollisionNode(ownerID, keyHash, [
        node.entry,
        entry
    ]);
    var idx1 = (shift === 0 ? node.keyHash : node.keyHash >>> shift) & (0, $c2ddc03a1d32db1a$export$e14dab7236868a5);
    var idx2 = (shift === 0 ? keyHash : keyHash >>> shift) & (0, $c2ddc03a1d32db1a$export$e14dab7236868a5);
    var newNode;
    var nodes = idx1 === idx2 ? [
        $3ff96ffc4297bcc8$var$mergeIntoNode(node, ownerID, shift + (0, $c2ddc03a1d32db1a$export$d36167fd695703b4), keyHash, entry)
    ] : (newNode = new $3ff96ffc4297bcc8$var$ValueNode(ownerID, keyHash, entry), idx1 < idx2 ? [
        node,
        newNode
    ] : [
        newNode,
        node
    ]);
    return new $3ff96ffc4297bcc8$var$BitmapIndexedNode(ownerID, 1 << idx1 | 1 << idx2, nodes);
}
function $3ff96ffc4297bcc8$var$createNodes(ownerID, entries, key, value) {
    if (!ownerID) ownerID = new (0, $c2ddc03a1d32db1a$export$f629661819ff67eb)();
    var node = new $3ff96ffc4297bcc8$var$ValueNode(ownerID, (0, $826fab6845b48e0a$export$d6af199866bfb566)(key), [
        key,
        value
    ]);
    for(var ii = 0; ii < entries.length; ii++){
        var entry = entries[ii];
        node = node.update(ownerID, 0, undefined, entry[0], entry[1]);
    }
    return node;
}
function $3ff96ffc4297bcc8$var$packNodes(ownerID, nodes, count, excluding) {
    var bitmap = 0;
    var packedII = 0;
    var packedNodes = new Array(count);
    for(var ii = 0, bit = 1, len = nodes.length; ii < len; ii++, bit <<= 1){
        var node = nodes[ii];
        if (node !== undefined && ii !== excluding) {
            bitmap |= bit;
            packedNodes[packedII++] = node;
        }
    }
    return new $3ff96ffc4297bcc8$var$BitmapIndexedNode(ownerID, bitmap, packedNodes);
}
function $3ff96ffc4297bcc8$var$expandNodes(ownerID, nodes, bitmap, including, node) {
    var count = 0;
    var expandedNodes = new Array((0, $c2ddc03a1d32db1a$export$8d4e26484c874870));
    for(var ii = 0; bitmap !== 0; ii++, bitmap >>>= 1)expandedNodes[ii] = bitmap & 1 ? nodes[count++] : undefined;
    expandedNodes[including] = node;
    return new $3ff96ffc4297bcc8$var$HashArrayMapNode(ownerID, count + 1, expandedNodes);
}
function $3ff96ffc4297bcc8$var$popCount(x) {
    x -= x >> 1 & 0x55555555;
    x = (x & 0x33333333) + (x >> 2 & 0x33333333);
    x = x + (x >> 4) & 0x0f0f0f0f;
    x += x >> 8;
    x += x >> 16;
    return x & 0x7f;
}
function $3ff96ffc4297bcc8$var$setAt(array, idx, val, canEdit) {
    var newArray = canEdit ? array : (0, $1464138edd0700c2$export$2e2bcd8739ae039)(array);
    newArray[idx] = val;
    return newArray;
}
function $3ff96ffc4297bcc8$var$spliceIn(array, idx, val, canEdit) {
    var newLen = array.length + 1;
    if (canEdit && idx + 1 === newLen) {
        array[idx] = val;
        return array;
    }
    var newArray = new Array(newLen);
    var after = 0;
    for(var ii = 0; ii < newLen; ii++)if (ii === idx) {
        newArray[ii] = val;
        after = -1;
    } else newArray[ii] = array[ii + after];
    return newArray;
}
function $3ff96ffc4297bcc8$var$spliceOut(array, idx, canEdit) {
    var newLen = array.length - 1;
    if (canEdit && idx === newLen) {
        array.pop();
        return array;
    }
    var newArray = new Array(newLen);
    var after = 0;
    for(var ii = 0; ii < newLen; ii++){
        if (ii === idx) after = 1;
        newArray[ii] = array[ii + after];
    }
    return newArray;
}
var $3ff96ffc4297bcc8$var$MAX_ARRAY_MAP_SIZE = (0, $c2ddc03a1d32db1a$export$8d4e26484c874870) / 4;
var $3ff96ffc4297bcc8$var$MAX_BITMAP_INDEXED_SIZE = (0, $c2ddc03a1d32db1a$export$8d4e26484c874870) / 2;
var $3ff96ffc4297bcc8$var$MIN_HASH_ARRAY_MAP_SIZE = (0, $c2ddc03a1d32db1a$export$8d4e26484c874870) / 4;


/**
 * @license
 * MIT License
 * 
 * Copyright (c) 2014-present, Lee Byron and other contributors.
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ 
/**
 * @license
 * MIT License
 * 
 * Copyright (c) 2014-present, Lee Byron and other contributors.
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ var $4da6d49bd1d5a072$export$2603f0b5fa81c9fa = "@@__IMMUTABLE_LIST__@@";
function $4da6d49bd1d5a072$export$ead95ff48ba53ffd(maybeList) {
    return Boolean(maybeList && maybeList[$4da6d49bd1d5a072$export$2603f0b5fa81c9fa]);
}















var $80b7afef873cee5f$export$54c2e3dc7acea9f5 = /*@__PURE__*/ function(IndexedCollection) {
    function List(value) {
        var empty = $80b7afef873cee5f$export$51d1964542c02d5f();
        if (value === undefined || value === null) return empty;
        if ((0, $4da6d49bd1d5a072$export$ead95ff48ba53ffd)(value)) return value;
        var iter = IndexedCollection(value);
        var size = iter.size;
        if (size === 0) return empty;
        (0, $6ec38c7a88fbe1b6$export$2e2bcd8739ae039)(size);
        if (size > 0 && size < (0, $c2ddc03a1d32db1a$export$8d4e26484c874870)) return $80b7afef873cee5f$var$makeList(0, size, (0, $c2ddc03a1d32db1a$export$d36167fd695703b4), null, new $80b7afef873cee5f$var$VNode(iter.toArray()));
        return empty.withMutations(function(list) {
            list.setSize(size);
            iter.forEach(function(v, i) {
                return list.set(i, v);
            });
        });
    }
    if (IndexedCollection) List.__proto__ = IndexedCollection;
    List.prototype = Object.create(IndexedCollection && IndexedCollection.prototype);
    List.prototype.constructor = List;
    List.of = function of() {
        return this(arguments);
    };
    List.prototype.toString = function toString() {
        return this.__toString("List [", "]");
    };
    // @pragma Access
    List.prototype.get = function get(index, notSetValue) {
        index = (0, $c2ddc03a1d32db1a$export$acb6ab09ed1b7b8b)(this, index);
        if (index >= 0 && index < this.size) {
            index += this._origin;
            var node = $80b7afef873cee5f$var$listNodeFor(this, index);
            return node && node.array[index & (0, $c2ddc03a1d32db1a$export$e14dab7236868a5)];
        }
        return notSetValue;
    };
    // @pragma Modification
    List.prototype.set = function set(index, value) {
        return $80b7afef873cee5f$var$updateList(this, index, value);
    };
    List.prototype.remove = function remove(index) {
        return !this.has(index) ? this : index === 0 ? this.shift() : index === this.size - 1 ? this.pop() : this.splice(index, 1);
    };
    List.prototype.insert = function insert(index, value) {
        return this.splice(index, 0, value);
    };
    List.prototype.clear = function clear() {
        if (this.size === 0) return this;
        if (this.__ownerID) {
            this.size = this._origin = this._capacity = 0;
            this._level = (0, $c2ddc03a1d32db1a$export$d36167fd695703b4);
            this._root = this._tail = this.__hash = undefined;
            this.__altered = true;
            return this;
        }
        return $80b7afef873cee5f$export$51d1964542c02d5f();
    };
    List.prototype.push = function push() {
        var values = arguments;
        var oldSize = this.size;
        return this.withMutations(function(list) {
            $80b7afef873cee5f$var$setListBounds(list, 0, oldSize + values.length);
            for(var ii = 0; ii < values.length; ii++)list.set(oldSize + ii, values[ii]);
        });
    };
    List.prototype.pop = function pop() {
        return $80b7afef873cee5f$var$setListBounds(this, 0, -1);
    };
    List.prototype.unshift = function unshift() {
        var values = arguments;
        return this.withMutations(function(list) {
            $80b7afef873cee5f$var$setListBounds(list, -values.length);
            for(var ii = 0; ii < values.length; ii++)list.set(ii, values[ii]);
        });
    };
    List.prototype.shift = function shift() {
        return $80b7afef873cee5f$var$setListBounds(this, 1);
    };
    // @pragma Composition
    List.prototype.concat = function concat() {
        var arguments$1 = arguments;
        var seqs = [];
        for(var i = 0; i < arguments.length; i++){
            var argument = arguments$1[i];
            var seq = IndexedCollection(typeof argument !== "string" && (0, $88d0bf2511806126$export$57f74772748f5c4e)(argument) ? argument : [
                argument
            ]);
            if (seq.size !== 0) seqs.push(seq);
        }
        if (seqs.length === 0) return this;
        if (this.size === 0 && !this.__ownerID && seqs.length === 1) return this.constructor(seqs[0]);
        return this.withMutations(function(list) {
            seqs.forEach(function(seq) {
                return seq.forEach(function(value) {
                    return list.push(value);
                });
            });
        });
    };
    List.prototype.setSize = function setSize(size) {
        return $80b7afef873cee5f$var$setListBounds(this, 0, size);
    };
    List.prototype.map = function map(mapper, context) {
        var this$1$1 = this;
        return this.withMutations(function(list) {
            for(var i = 0; i < this$1$1.size; i++)list.set(i, mapper.call(context, list.get(i), i, this$1$1));
        });
    };
    // @pragma Iteration
    List.prototype.slice = function slice(begin, end) {
        var size = this.size;
        if ((0, $c2ddc03a1d32db1a$export$39c07963d3ae8010)(begin, end, size)) return this;
        return $80b7afef873cee5f$var$setListBounds(this, (0, $c2ddc03a1d32db1a$export$b50255956c5410d8)(begin, size), (0, $c2ddc03a1d32db1a$export$9be3172c55e482a)(end, size));
    };
    List.prototype.__iterator = function __iterator(type, reverse) {
        var index = reverse ? this.size : 0;
        var values = $80b7afef873cee5f$var$iterateList(this, reverse);
        return new (0, $88d0bf2511806126$export$b67e82436e407e40)(function() {
            var value = values();
            return value === $80b7afef873cee5f$var$DONE ? (0, $88d0bf2511806126$export$e141d6e2268e9d85)() : (0, $88d0bf2511806126$export$dde1781ce8ad65f)(type, reverse ? --index : index++, value);
        });
    };
    List.prototype.__iterate = function __iterate(fn, reverse) {
        var index = reverse ? this.size : 0;
        var values = $80b7afef873cee5f$var$iterateList(this, reverse);
        var value;
        while((value = values()) !== $80b7afef873cee5f$var$DONE){
            if (fn(value, reverse ? --index : index++, this) === false) break;
        }
        return index;
    };
    List.prototype.__ensureOwner = function __ensureOwner(ownerID) {
        if (ownerID === this.__ownerID) return this;
        if (!ownerID) {
            if (this.size === 0) return $80b7afef873cee5f$export$51d1964542c02d5f();
            this.__ownerID = ownerID;
            this.__altered = false;
            return this;
        }
        return $80b7afef873cee5f$var$makeList(this._origin, this._capacity, this._level, this._root, this._tail, ownerID, this.__hash);
    };
    return List;
}((0, $4952a3ccc7265b27$export$eb9d6a4c2661c7e7));
$80b7afef873cee5f$export$54c2e3dc7acea9f5.isList = (0, $4da6d49bd1d5a072$export$ead95ff48ba53ffd);
var $80b7afef873cee5f$var$ListPrototype = $80b7afef873cee5f$export$54c2e3dc7acea9f5.prototype;
$80b7afef873cee5f$var$ListPrototype[0, $4da6d49bd1d5a072$export$2603f0b5fa81c9fa] = true;
$80b7afef873cee5f$var$ListPrototype[0, $c2ddc03a1d32db1a$export$4bd2facc4a3e6aa1] = $80b7afef873cee5f$var$ListPrototype.remove;
$80b7afef873cee5f$var$ListPrototype.merge = $80b7afef873cee5f$var$ListPrototype.concat;
$80b7afef873cee5f$var$ListPrototype.setIn = (0, $a04d866a117c3434$export$e6bdf135a54e021b);
$80b7afef873cee5f$var$ListPrototype.deleteIn = $80b7afef873cee5f$var$ListPrototype.removeIn = (0, $2b25b81e7ecaadb3$export$706cff822a6f730d);
$80b7afef873cee5f$var$ListPrototype.update = (0, $32345e910e3f25e5$export$722fbec263ad908a);
$80b7afef873cee5f$var$ListPrototype.updateIn = (0, $614b9ab34d28a86a$export$f3e3cd1fc9c33ca1);
$80b7afef873cee5f$var$ListPrototype.mergeIn = (0, $f6cbcb4ed76baee0$export$271ff073c1ade46a);
$80b7afef873cee5f$var$ListPrototype.mergeDeepIn = (0, $abe07da7d44267a3$export$534837be55d4be99);
$80b7afef873cee5f$var$ListPrototype.withMutations = (0, $17d048964b7d8355$export$c779a0e1bb0d59bf);
$80b7afef873cee5f$var$ListPrototype.wasAltered = (0, $72ebf32788fc71db$export$b9916d438dfa08cf);
$80b7afef873cee5f$var$ListPrototype.asImmutable = (0, $3042678b907a98f2$export$158f0e042e0dd7fe);
$80b7afef873cee5f$var$ListPrototype["@@transducer/init"] = $80b7afef873cee5f$var$ListPrototype.asMutable = (0, $49ab0d381a1fe1a2$export$9cce5776307dcd36);
$80b7afef873cee5f$var$ListPrototype["@@transducer/step"] = function(result, arr) {
    return result.push(arr);
};
$80b7afef873cee5f$var$ListPrototype["@@transducer/result"] = function(obj) {
    return obj.asImmutable();
};
var $80b7afef873cee5f$var$VNode = function VNode(array, ownerID) {
    this.array = array;
    this.ownerID = ownerID;
};
// TODO: seems like these methods are very similar
$80b7afef873cee5f$var$VNode.prototype.removeBefore = function removeBefore(ownerID, level, index) {
    if (index === level ? 1 << level : this.array.length === 0) return this;
    var originIndex = index >>> level & (0, $c2ddc03a1d32db1a$export$e14dab7236868a5);
    if (originIndex >= this.array.length) return new $80b7afef873cee5f$var$VNode([], ownerID);
    var removingFirst = originIndex === 0;
    var newChild;
    if (level > 0) {
        var oldChild = this.array[originIndex];
        newChild = oldChild && oldChild.removeBefore(ownerID, level - (0, $c2ddc03a1d32db1a$export$d36167fd695703b4), index);
        if (newChild === oldChild && removingFirst) return this;
    }
    if (removingFirst && !newChild) return this;
    var editable = $80b7afef873cee5f$var$editableVNode(this, ownerID);
    if (!removingFirst) for(var ii = 0; ii < originIndex; ii++)editable.array[ii] = undefined;
    if (newChild) editable.array[originIndex] = newChild;
    return editable;
};
$80b7afef873cee5f$var$VNode.prototype.removeAfter = function removeAfter(ownerID, level, index) {
    if (index === (level ? 1 << level : 0) || this.array.length === 0) return this;
    var sizeIndex = index - 1 >>> level & (0, $c2ddc03a1d32db1a$export$e14dab7236868a5);
    if (sizeIndex >= this.array.length) return this;
    var newChild;
    if (level > 0) {
        var oldChild = this.array[sizeIndex];
        newChild = oldChild && oldChild.removeAfter(ownerID, level - (0, $c2ddc03a1d32db1a$export$d36167fd695703b4), index);
        if (newChild === oldChild && sizeIndex === this.array.length - 1) return this;
    }
    var editable = $80b7afef873cee5f$var$editableVNode(this, ownerID);
    editable.array.splice(sizeIndex + 1);
    if (newChild) editable.array[sizeIndex] = newChild;
    return editable;
};
var $80b7afef873cee5f$var$DONE = {};
function $80b7afef873cee5f$var$iterateList(list, reverse) {
    var left = list._origin;
    var right = list._capacity;
    var tailPos = $80b7afef873cee5f$var$getTailOffset(right);
    var tail = list._tail;
    return iterateNodeOrLeaf(list._root, list._level, 0);
    function iterateNodeOrLeaf(node, level, offset) {
        return level === 0 ? iterateLeaf(node, offset) : iterateNode(node, level, offset);
    }
    function iterateLeaf(node, offset) {
        var array = offset === tailPos ? tail && tail.array : node && node.array;
        var from = offset > left ? 0 : left - offset;
        var to = right - offset;
        if (to > (0, $c2ddc03a1d32db1a$export$8d4e26484c874870)) to = (0, $c2ddc03a1d32db1a$export$8d4e26484c874870);
        return function() {
            if (from === to) return $80b7afef873cee5f$var$DONE;
            var idx = reverse ? --to : from++;
            return array && array[idx];
        };
    }
    function iterateNode(node, level, offset) {
        var values;
        var array = node && node.array;
        var from = offset > left ? 0 : left - offset >> level;
        var to = (right - offset >> level) + 1;
        if (to > (0, $c2ddc03a1d32db1a$export$8d4e26484c874870)) to = (0, $c2ddc03a1d32db1a$export$8d4e26484c874870);
        return function() {
            while(true){
                if (values) {
                    var value = values();
                    if (value !== $80b7afef873cee5f$var$DONE) return value;
                    values = null;
                }
                if (from === to) return $80b7afef873cee5f$var$DONE;
                var idx = reverse ? --to : from++;
                values = iterateNodeOrLeaf(array && array[idx], level - (0, $c2ddc03a1d32db1a$export$d36167fd695703b4), offset + (idx << level));
            }
        };
    }
}
function $80b7afef873cee5f$var$makeList(origin, capacity, level, root, tail, ownerID, hash) {
    var list = Object.create($80b7afef873cee5f$var$ListPrototype);
    list.size = capacity - origin;
    list._origin = origin;
    list._capacity = capacity;
    list._level = level;
    list._root = root;
    list._tail = tail;
    list.__ownerID = ownerID;
    list.__hash = hash;
    list.__altered = false;
    return list;
}
var $80b7afef873cee5f$var$EMPTY_LIST;
function $80b7afef873cee5f$export$51d1964542c02d5f() {
    return $80b7afef873cee5f$var$EMPTY_LIST || ($80b7afef873cee5f$var$EMPTY_LIST = $80b7afef873cee5f$var$makeList(0, 0, (0, $c2ddc03a1d32db1a$export$d36167fd695703b4)));
}
function $80b7afef873cee5f$var$updateList(list, index, value) {
    index = (0, $c2ddc03a1d32db1a$export$acb6ab09ed1b7b8b)(list, index);
    if (index !== index) return list;
    if (index >= list.size || index < 0) return list.withMutations(function(list) {
        index < 0 ? $80b7afef873cee5f$var$setListBounds(list, index).set(0, value) : $80b7afef873cee5f$var$setListBounds(list, 0, index + 1).set(index, value);
    });
    index += list._origin;
    var newTail = list._tail;
    var newRoot = list._root;
    var didAlter = (0, $c2ddc03a1d32db1a$export$a4907f3d95a6b59f)();
    if (index >= $80b7afef873cee5f$var$getTailOffset(list._capacity)) newTail = $80b7afef873cee5f$var$updateVNode(newTail, list.__ownerID, 0, index, value, didAlter);
    else newRoot = $80b7afef873cee5f$var$updateVNode(newRoot, list.__ownerID, list._level, index, value, didAlter);
    if (!didAlter.value) return list;
    if (list.__ownerID) {
        list._root = newRoot;
        list._tail = newTail;
        list.__hash = undefined;
        list.__altered = true;
        return list;
    }
    return $80b7afef873cee5f$var$makeList(list._origin, list._capacity, list._level, newRoot, newTail);
}
function $80b7afef873cee5f$var$updateVNode(node, ownerID, level, index, value, didAlter) {
    var idx = index >>> level & (0, $c2ddc03a1d32db1a$export$e14dab7236868a5);
    var nodeHas = node && idx < node.array.length;
    if (!nodeHas && value === undefined) return node;
    var newNode;
    if (level > 0) {
        var lowerNode = node && node.array[idx];
        var newLowerNode = $80b7afef873cee5f$var$updateVNode(lowerNode, ownerID, level - (0, $c2ddc03a1d32db1a$export$d36167fd695703b4), index, value, didAlter);
        if (newLowerNode === lowerNode) return node;
        newNode = $80b7afef873cee5f$var$editableVNode(node, ownerID);
        newNode.array[idx] = newLowerNode;
        return newNode;
    }
    if (nodeHas && node.array[idx] === value) return node;
    if (didAlter) (0, $c2ddc03a1d32db1a$export$5c111b5829d07529)(didAlter);
    newNode = $80b7afef873cee5f$var$editableVNode(node, ownerID);
    if (value === undefined && idx === newNode.array.length - 1) newNode.array.pop();
    else newNode.array[idx] = value;
    return newNode;
}
function $80b7afef873cee5f$var$editableVNode(node, ownerID) {
    if (ownerID && node && ownerID === node.ownerID) return node;
    return new $80b7afef873cee5f$var$VNode(node ? node.array.slice() : [], ownerID);
}
function $80b7afef873cee5f$var$listNodeFor(list, rawIndex) {
    if (rawIndex >= $80b7afef873cee5f$var$getTailOffset(list._capacity)) return list._tail;
    if (rawIndex < 1 << list._level + (0, $c2ddc03a1d32db1a$export$d36167fd695703b4)) {
        var node = list._root;
        var level = list._level;
        while(node && level > 0){
            node = node.array[rawIndex >>> level & (0, $c2ddc03a1d32db1a$export$e14dab7236868a5)];
            level -= (0, $c2ddc03a1d32db1a$export$d36167fd695703b4);
        }
        return node;
    }
}
function $80b7afef873cee5f$var$setListBounds(list, begin, end) {
    // Sanitize begin & end using this shorthand for ToInt32(argument)
    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
    if (begin !== undefined) begin |= 0;
    if (end !== undefined) end |= 0;
    var owner = list.__ownerID || new (0, $c2ddc03a1d32db1a$export$f629661819ff67eb)();
    var oldOrigin = list._origin;
    var oldCapacity = list._capacity;
    var newOrigin = oldOrigin + begin;
    var newCapacity = end === undefined ? oldCapacity : end < 0 ? oldCapacity + end : oldOrigin + end;
    if (newOrigin === oldOrigin && newCapacity === oldCapacity) return list;
    // If it's going to end after it starts, it's empty.
    if (newOrigin >= newCapacity) return list.clear();
    var newLevel = list._level;
    var newRoot = list._root;
    // New origin might need creating a higher root.
    var offsetShift = 0;
    while(newOrigin + offsetShift < 0){
        newRoot = new $80b7afef873cee5f$var$VNode(newRoot && newRoot.array.length ? [
            undefined,
            newRoot
        ] : [], owner);
        newLevel += (0, $c2ddc03a1d32db1a$export$d36167fd695703b4);
        offsetShift += 1 << newLevel;
    }
    if (offsetShift) {
        newOrigin += offsetShift;
        oldOrigin += offsetShift;
        newCapacity += offsetShift;
        oldCapacity += offsetShift;
    }
    var oldTailOffset = $80b7afef873cee5f$var$getTailOffset(oldCapacity);
    var newTailOffset = $80b7afef873cee5f$var$getTailOffset(newCapacity);
    // New size might need creating a higher root.
    while(newTailOffset >= 1 << newLevel + (0, $c2ddc03a1d32db1a$export$d36167fd695703b4)){
        newRoot = new $80b7afef873cee5f$var$VNode(newRoot && newRoot.array.length ? [
            newRoot
        ] : [], owner);
        newLevel += (0, $c2ddc03a1d32db1a$export$d36167fd695703b4);
    }
    // Locate or create the new tail.
    var oldTail = list._tail;
    var newTail = newTailOffset < oldTailOffset ? $80b7afef873cee5f$var$listNodeFor(list, newCapacity - 1) : newTailOffset > oldTailOffset ? new $80b7afef873cee5f$var$VNode([], owner) : oldTail;
    // Merge Tail into tree.
    if (oldTail && newTailOffset > oldTailOffset && newOrigin < oldCapacity && oldTail.array.length) {
        newRoot = $80b7afef873cee5f$var$editableVNode(newRoot, owner);
        var node = newRoot;
        for(var level = newLevel; level > (0, $c2ddc03a1d32db1a$export$d36167fd695703b4); level -= (0, $c2ddc03a1d32db1a$export$d36167fd695703b4)){
            var idx = oldTailOffset >>> level & (0, $c2ddc03a1d32db1a$export$e14dab7236868a5);
            node = node.array[idx] = $80b7afef873cee5f$var$editableVNode(node.array[idx], owner);
        }
        node.array[oldTailOffset >>> (0, $c2ddc03a1d32db1a$export$d36167fd695703b4) & (0, $c2ddc03a1d32db1a$export$e14dab7236868a5)] = oldTail;
    }
    // If the size has been reduced, there's a chance the tail needs to be trimmed.
    if (newCapacity < oldCapacity) newTail = newTail && newTail.removeAfter(owner, 0, newCapacity);
    // If the new origin is within the tail, then we do not need a root.
    if (newOrigin >= newTailOffset) {
        newOrigin -= newTailOffset;
        newCapacity -= newTailOffset;
        newLevel = (0, $c2ddc03a1d32db1a$export$d36167fd695703b4);
        newRoot = null;
        newTail = newTail && newTail.removeBefore(owner, 0, newOrigin);
    // Otherwise, if the root has been trimmed, garbage collect.
    } else if (newOrigin > oldOrigin || newTailOffset < oldTailOffset) {
        offsetShift = 0;
        // Identify the new top root node of the subtree of the old root.
        while(newRoot){
            var beginIndex = newOrigin >>> newLevel & (0, $c2ddc03a1d32db1a$export$e14dab7236868a5);
            if (beginIndex !== newTailOffset >>> newLevel & (0, $c2ddc03a1d32db1a$export$e14dab7236868a5)) break;
            if (beginIndex) offsetShift += (1 << newLevel) * beginIndex;
            newLevel -= (0, $c2ddc03a1d32db1a$export$d36167fd695703b4);
            newRoot = newRoot.array[beginIndex];
        }
        // Trim the new sides of the new root.
        if (newRoot && newOrigin > oldOrigin) newRoot = newRoot.removeBefore(owner, newLevel, newOrigin - offsetShift);
        if (newRoot && newTailOffset < oldTailOffset) newRoot = newRoot.removeAfter(owner, newLevel, newTailOffset - offsetShift);
        if (offsetShift) {
            newOrigin -= offsetShift;
            newCapacity -= offsetShift;
        }
    }
    if (list.__ownerID) {
        list.size = newCapacity - newOrigin;
        list._origin = newOrigin;
        list._capacity = newCapacity;
        list._level = newLevel;
        list._root = newRoot;
        list._tail = newTail;
        list.__hash = undefined;
        list.__altered = true;
        return list;
    }
    return $80b7afef873cee5f$var$makeList(newOrigin, newCapacity, newLevel, newRoot, newTail);
}
function $80b7afef873cee5f$var$getTailOffset(size) {
    return size < (0, $c2ddc03a1d32db1a$export$8d4e26484c874870) ? 0 : size - 1 >>> (0, $c2ddc03a1d32db1a$export$d36167fd695703b4) << (0, $c2ddc03a1d32db1a$export$d36167fd695703b4);
}




var $acfb3e7ae62d9682$export$8e8eaa3741ef504c = /*@__PURE__*/ function(Map) {
    function OrderedMap(value) {
        return value === undefined || value === null ? $acfb3e7ae62d9682$export$6b155c12215e99ec() : (0, $693a5cb59d634058$export$739bc167e02d45ee)(value) ? value : $acfb3e7ae62d9682$export$6b155c12215e99ec().withMutations(function(map) {
            var iter = (0, $4952a3ccc7265b27$export$6e235e3661e8f430)(value);
            (0, $6ec38c7a88fbe1b6$export$2e2bcd8739ae039)(iter.size);
            iter.forEach(function(v, k) {
                return map.set(k, v);
            });
        });
    }
    if (Map) OrderedMap.__proto__ = Map;
    OrderedMap.prototype = Object.create(Map && Map.prototype);
    OrderedMap.prototype.constructor = OrderedMap;
    OrderedMap.of = function of() {
        return this(arguments);
    };
    OrderedMap.prototype.toString = function toString() {
        return this.__toString("OrderedMap {", "}");
    };
    // @pragma Access
    OrderedMap.prototype.get = function get(k, notSetValue) {
        var index = this._map.get(k);
        return index !== undefined ? this._list.get(index)[1] : notSetValue;
    };
    // @pragma Modification
    OrderedMap.prototype.clear = function clear() {
        if (this.size === 0) return this;
        if (this.__ownerID) {
            this.size = 0;
            this._map.clear();
            this._list.clear();
            this.__altered = true;
            return this;
        }
        return $acfb3e7ae62d9682$export$6b155c12215e99ec();
    };
    OrderedMap.prototype.set = function set(k, v) {
        return $acfb3e7ae62d9682$var$updateOrderedMap(this, k, v);
    };
    OrderedMap.prototype.remove = function remove(k) {
        return $acfb3e7ae62d9682$var$updateOrderedMap(this, k, (0, $c2ddc03a1d32db1a$export$dc6d556e3fa8f459));
    };
    OrderedMap.prototype.__iterate = function __iterate(fn, reverse) {
        var this$1$1 = this;
        return this._list.__iterate(function(entry) {
            return entry && fn(entry[1], entry[0], this$1$1);
        }, reverse);
    };
    OrderedMap.prototype.__iterator = function __iterator(type, reverse) {
        return this._list.fromEntrySeq().__iterator(type, reverse);
    };
    OrderedMap.prototype.__ensureOwner = function __ensureOwner(ownerID) {
        if (ownerID === this.__ownerID) return this;
        var newMap = this._map.__ensureOwner(ownerID);
        var newList = this._list.__ensureOwner(ownerID);
        if (!ownerID) {
            if (this.size === 0) return $acfb3e7ae62d9682$export$6b155c12215e99ec();
            this.__ownerID = ownerID;
            this.__altered = false;
            this._map = newMap;
            this._list = newList;
            return this;
        }
        return $acfb3e7ae62d9682$var$makeOrderedMap(newMap, newList, ownerID, this.__hash);
    };
    return OrderedMap;
}((0, $3ff96ffc4297bcc8$export$a5c7b93649eaf8f8));
$acfb3e7ae62d9682$export$8e8eaa3741ef504c.isOrderedMap = (0, $693a5cb59d634058$export$739bc167e02d45ee);
$acfb3e7ae62d9682$export$8e8eaa3741ef504c.prototype[0, $d95bc815d10ddd62$export$63a33a562da7c584] = true;
$acfb3e7ae62d9682$export$8e8eaa3741ef504c.prototype[0, $c2ddc03a1d32db1a$export$4bd2facc4a3e6aa1] = $acfb3e7ae62d9682$export$8e8eaa3741ef504c.prototype.remove;
function $acfb3e7ae62d9682$var$makeOrderedMap(map, list, ownerID, hash) {
    var omap = Object.create($acfb3e7ae62d9682$export$8e8eaa3741ef504c.prototype);
    omap.size = map ? map.size : 0;
    omap._map = map;
    omap._list = list;
    omap.__ownerID = ownerID;
    omap.__hash = hash;
    omap.__altered = false;
    return omap;
}
var $acfb3e7ae62d9682$var$EMPTY_ORDERED_MAP;
function $acfb3e7ae62d9682$export$6b155c12215e99ec() {
    return $acfb3e7ae62d9682$var$EMPTY_ORDERED_MAP || ($acfb3e7ae62d9682$var$EMPTY_ORDERED_MAP = $acfb3e7ae62d9682$var$makeOrderedMap((0, $3ff96ffc4297bcc8$export$dbfbb79577167c48)(), (0, $80b7afef873cee5f$export$51d1964542c02d5f)()));
}
function $acfb3e7ae62d9682$var$updateOrderedMap(omap, k, v) {
    var map = omap._map;
    var list = omap._list;
    var i = map.get(k);
    var has = i !== undefined;
    var newMap;
    var newList;
    if (v === (0, $c2ddc03a1d32db1a$export$dc6d556e3fa8f459)) {
        // removed
        if (!has) return omap;
        if (list.size >= (0, $c2ddc03a1d32db1a$export$8d4e26484c874870) && list.size >= map.size * 2) {
            newList = list.filter(function(entry, idx) {
                return entry !== undefined && i !== idx;
            });
            newMap = newList.toKeyedSeq().map(function(entry) {
                return entry[0];
            }).flip().toMap();
            if (omap.__ownerID) newMap.__ownerID = newList.__ownerID = omap.__ownerID;
        } else {
            newMap = map.remove(k);
            newList = i === list.size - 1 ? list.pop() : list.set(i, undefined);
        }
    } else if (has) {
        if (v === list.get(i)[1]) return omap;
        newMap = map;
        newList = list.set(i, [
            k,
            v
        ]);
    } else {
        newMap = map.set(k, list.size);
        newList = list.set(list.size, [
            k,
            v
        ]);
    }
    if (omap.__ownerID) {
        omap.size = newMap.size;
        omap._map = newMap;
        omap._list = newList;
        omap.__hash = undefined;
        omap.__altered = true;
        return omap;
    }
    return $acfb3e7ae62d9682$var$makeOrderedMap(newMap, newList);
}




/**
 * @license
 * MIT License
 * 
 * Copyright (c) 2014-present, Lee Byron and other contributors.
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ 



/**
 * @license
 * MIT License
 * 
 * Copyright (c) 2014-present, Lee Byron and other contributors.
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ var $56ddec3bbd4ddd33$export$3e5415c3137462f8 = "@@__IMMUTABLE_STACK__@@";
function $56ddec3bbd4ddd33$export$db58588880737c1c(maybeStack) {
    return Boolean(maybeStack && maybeStack[$56ddec3bbd4ddd33$export$3e5415c3137462f8]);
}







var $e410790f9257995e$export$694e0d28c7ffc90c = /*@__PURE__*/ function(IndexedCollection) {
    function Stack(value) {
        return value === undefined || value === null ? $e410790f9257995e$var$emptyStack() : (0, $56ddec3bbd4ddd33$export$db58588880737c1c)(value) ? value : $e410790f9257995e$var$emptyStack().pushAll(value);
    }
    if (IndexedCollection) Stack.__proto__ = IndexedCollection;
    Stack.prototype = Object.create(IndexedCollection && IndexedCollection.prototype);
    Stack.prototype.constructor = Stack;
    Stack.of = function of() {
        return this(arguments);
    };
    Stack.prototype.toString = function toString() {
        return this.__toString("Stack [", "]");
    };
    // @pragma Access
    Stack.prototype.get = function get(index, notSetValue) {
        var head = this._head;
        index = (0, $c2ddc03a1d32db1a$export$acb6ab09ed1b7b8b)(this, index);
        while(head && index--)head = head.next;
        return head ? head.value : notSetValue;
    };
    Stack.prototype.peek = function peek() {
        return this._head && this._head.value;
    };
    // @pragma Modification
    Stack.prototype.push = function push() {
        var arguments$1 = arguments;
        if (arguments.length === 0) return this;
        var newSize = this.size + arguments.length;
        var head = this._head;
        for(var ii = arguments.length - 1; ii >= 0; ii--)head = {
            value: arguments$1[ii],
            next: head
        };
        if (this.__ownerID) {
            this.size = newSize;
            this._head = head;
            this.__hash = undefined;
            this.__altered = true;
            return this;
        }
        return $e410790f9257995e$var$makeStack(newSize, head);
    };
    Stack.prototype.pushAll = function pushAll(iter) {
        iter = IndexedCollection(iter);
        if (iter.size === 0) return this;
        if (this.size === 0 && (0, $56ddec3bbd4ddd33$export$db58588880737c1c)(iter)) return iter;
        (0, $6ec38c7a88fbe1b6$export$2e2bcd8739ae039)(iter.size);
        var newSize = this.size;
        var head = this._head;
        iter.__iterate(function(value) {
            newSize++;
            head = {
                value: value,
                next: head
            };
        }, /* reverse */ true);
        if (this.__ownerID) {
            this.size = newSize;
            this._head = head;
            this.__hash = undefined;
            this.__altered = true;
            return this;
        }
        return $e410790f9257995e$var$makeStack(newSize, head);
    };
    Stack.prototype.pop = function pop() {
        return this.slice(1);
    };
    Stack.prototype.clear = function clear() {
        if (this.size === 0) return this;
        if (this.__ownerID) {
            this.size = 0;
            this._head = undefined;
            this.__hash = undefined;
            this.__altered = true;
            return this;
        }
        return $e410790f9257995e$var$emptyStack();
    };
    Stack.prototype.slice = function slice(begin, end) {
        if ((0, $c2ddc03a1d32db1a$export$39c07963d3ae8010)(begin, end, this.size)) return this;
        var resolvedBegin = (0, $c2ddc03a1d32db1a$export$b50255956c5410d8)(begin, this.size);
        var resolvedEnd = (0, $c2ddc03a1d32db1a$export$9be3172c55e482a)(end, this.size);
        if (resolvedEnd !== this.size) // super.slice(begin, end);
        return IndexedCollection.prototype.slice.call(this, begin, end);
        var newSize = this.size - resolvedBegin;
        var head = this._head;
        while(resolvedBegin--)head = head.next;
        if (this.__ownerID) {
            this.size = newSize;
            this._head = head;
            this.__hash = undefined;
            this.__altered = true;
            return this;
        }
        return $e410790f9257995e$var$makeStack(newSize, head);
    };
    // @pragma Mutability
    Stack.prototype.__ensureOwner = function __ensureOwner(ownerID) {
        if (ownerID === this.__ownerID) return this;
        if (!ownerID) {
            if (this.size === 0) return $e410790f9257995e$var$emptyStack();
            this.__ownerID = ownerID;
            this.__altered = false;
            return this;
        }
        return $e410790f9257995e$var$makeStack(this.size, this._head, ownerID, this.__hash);
    };
    // @pragma Iteration
    Stack.prototype.__iterate = function __iterate(fn, reverse) {
        var this$1$1 = this;
        if (reverse) return new (0, $a5938beaa66b3822$export$b0774ff537b4dcee)(this.toArray()).__iterate(function(v, k) {
            return fn(v, k, this$1$1);
        }, reverse);
        var iterations = 0;
        var node = this._head;
        while(node){
            if (fn(node.value, iterations++, this) === false) break;
            node = node.next;
        }
        return iterations;
    };
    Stack.prototype.__iterator = function __iterator(type, reverse) {
        if (reverse) return new (0, $a5938beaa66b3822$export$b0774ff537b4dcee)(this.toArray()).__iterator(type, reverse);
        var iterations = 0;
        var node = this._head;
        return new (0, $88d0bf2511806126$export$b67e82436e407e40)(function() {
            if (node) {
                var value = node.value;
                node = node.next;
                return (0, $88d0bf2511806126$export$dde1781ce8ad65f)(type, iterations++, value);
            }
            return (0, $88d0bf2511806126$export$e141d6e2268e9d85)();
        });
    };
    return Stack;
}((0, $4952a3ccc7265b27$export$eb9d6a4c2661c7e7));
$e410790f9257995e$export$694e0d28c7ffc90c.isStack = (0, $56ddec3bbd4ddd33$export$db58588880737c1c);
var $e410790f9257995e$var$StackPrototype = $e410790f9257995e$export$694e0d28c7ffc90c.prototype;
$e410790f9257995e$var$StackPrototype[0, $56ddec3bbd4ddd33$export$3e5415c3137462f8] = true;
$e410790f9257995e$var$StackPrototype.shift = $e410790f9257995e$var$StackPrototype.pop;
$e410790f9257995e$var$StackPrototype.unshift = $e410790f9257995e$var$StackPrototype.push;
$e410790f9257995e$var$StackPrototype.unshiftAll = $e410790f9257995e$var$StackPrototype.pushAll;
$e410790f9257995e$var$StackPrototype.withMutations = (0, $17d048964b7d8355$export$c779a0e1bb0d59bf);
$e410790f9257995e$var$StackPrototype.wasAltered = (0, $72ebf32788fc71db$export$b9916d438dfa08cf);
$e410790f9257995e$var$StackPrototype.asImmutable = (0, $3042678b907a98f2$export$158f0e042e0dd7fe);
$e410790f9257995e$var$StackPrototype["@@transducer/init"] = $e410790f9257995e$var$StackPrototype.asMutable = (0, $49ab0d381a1fe1a2$export$9cce5776307dcd36);
$e410790f9257995e$var$StackPrototype["@@transducer/step"] = function(result, arr) {
    return result.unshift(arr);
};
$e410790f9257995e$var$StackPrototype["@@transducer/result"] = function(obj) {
    return obj.asImmutable();
};
function $e410790f9257995e$var$makeStack(size, head, ownerID, hash) {
    var map = Object.create($e410790f9257995e$var$StackPrototype);
    map.size = size;
    map._head = head;
    map.__ownerID = ownerID;
    map.__hash = hash;
    map.__altered = false;
    return map;
}
var $e410790f9257995e$var$EMPTY_STACK;
function $e410790f9257995e$var$emptyStack() {
    return $e410790f9257995e$var$EMPTY_STACK || ($e410790f9257995e$var$EMPTY_STACK = $e410790f9257995e$var$makeStack(0));
}


/**
 * @license
 * MIT License
 * 
 * Copyright (c) 2014-present, Lee Byron and other contributors.
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ 

/**
 * @license
 * MIT License
 * 
 * Copyright (c) 2014-present, Lee Byron and other contributors.
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ /**
 * @license
 * MIT License
 * 
 * Copyright (c) 2014-present, Lee Byron and other contributors.
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ var $8b6e80d3bc0e2623$export$319d06920c1f0301 = "@@__IMMUTABLE_SET__@@";
function $8b6e80d3bc0e2623$export$6750766a7c7ec627(maybeSet) {
    return Boolean(maybeSet && maybeSet[$8b6e80d3bc0e2623$export$319d06920c1f0301]);
}



function $fac081eee1ee61a7$export$a5eec3a3b03b602f(maybeOrderedSet) {
    return (0, $8b6e80d3bc0e2623$export$6750766a7c7ec627)(maybeOrderedSet) && (0, $d95bc815d10ddd62$export$e670b9b76442ef6c)(maybeOrderedSet);
}


/**
 * @license
 * MIT License
 * 
 * Copyright (c) 2014-present, Lee Byron and other contributors.
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ 












/**
 * @license
 * MIT License
 * 
 * Copyright (c) 2014-present, Lee Byron and other contributors.
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ 






function $a7a25cdf95c5ecae$export$2e2bcd8739ae039(a, b) {
    if (a === b) return true;
    if (!(0, $d70bc35f1b2e7a74$export$cea7aa84e978eba5)(b) || a.size !== undefined && b.size !== undefined && a.size !== b.size || a.__hash !== undefined && b.__hash !== undefined && a.__hash !== b.__hash || (0, $e8d80ef58ba97d1e$export$66d51e2080425364)(a) !== (0, $e8d80ef58ba97d1e$export$66d51e2080425364)(b) || (0, $a4ecf346f3821d5f$export$3bfb5e72e8bc6e09)(a) !== (0, $a4ecf346f3821d5f$export$3bfb5e72e8bc6e09)(b) || (0, $d95bc815d10ddd62$export$e670b9b76442ef6c)(a) !== (0, $d95bc815d10ddd62$export$e670b9b76442ef6c)(b)) return false;
    if (a.size === 0 && b.size === 0) return true;
    var notAssociative = !(0, $7a2788a9210b8dae$export$9c3ce8f7b89c6d66)(a);
    if ((0, $d95bc815d10ddd62$export$e670b9b76442ef6c)(a)) {
        var entries = a.entries();
        return b.every(function(v, k) {
            var entry = entries.next().value;
            return entry && (0, $cffd0257ddfe6a6e$export$226b3eccf92c9ed9)(entry[1], v) && (notAssociative || (0, $cffd0257ddfe6a6e$export$226b3eccf92c9ed9)(entry[0], k));
        }) && entries.next().done;
    }
    var flipped = false;
    if (a.size === undefined) {
        if (b.size === undefined) {
            if (typeof a.cacheResult === "function") a.cacheResult();
        } else {
            flipped = true;
            var _ = a;
            a = b;
            b = _;
        }
    }
    var allEqual = true;
    var bSize = b.__iterate(function(v, k) {
        if (notAssociative ? !a.has(v) : flipped ? !(0, $cffd0257ddfe6a6e$export$226b3eccf92c9ed9)(v, a.get(k, (0, $c2ddc03a1d32db1a$export$dc6d556e3fa8f459))) : !(0, $cffd0257ddfe6a6e$export$226b3eccf92c9ed9)(a.get(k, (0, $c2ddc03a1d32db1a$export$dc6d556e3fa8f459)), v)) {
            allEqual = false;
            return false;
        }
    });
    return allEqual && a.size === bSize;
}


/**
 * @license
 * MIT License
 * 
 * Copyright (c) 2014-present, Lee Byron and other contributors.
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ /**
 * Contributes additional methods to a constructor
 */ function $ba814b0331493f6e$export$2e2bcd8739ae039(ctor, methods) {
    var keyCopier = function(key) {
        ctor.prototype[key] = methods[key];
    };
    Object.keys(methods).forEach(keyCopier);
    Object.getOwnPropertySymbols && Object.getOwnPropertySymbols(methods).forEach(keyCopier);
    return ctor;
}



/**
 * @license
 * MIT License
 * 
 * Copyright (c) 2014-present, Lee Byron and other contributors.
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ 



function $5739de8a73a6dd48$export$f08965dd1304d490(value) {
    if (!value || typeof value !== "object") return value;
    if (!(0, $d70bc35f1b2e7a74$export$cea7aa84e978eba5)(value)) {
        if (!(0, $ffb9edbd071c7829$export$2e2bcd8739ae039)(value)) return value;
        value = (0, $a5938beaa66b3822$export$4802c350533dc67e)(value);
    }
    if ((0, $e8d80ef58ba97d1e$export$66d51e2080425364)(value)) {
        var result$1 = {};
        value.__iterate(function(v, k) {
            result$1[k] = $5739de8a73a6dd48$export$f08965dd1304d490(v);
        });
        return result$1;
    }
    var result = [];
    value.__iterate(function(v) {
        result.push($5739de8a73a6dd48$export$f08965dd1304d490(v));
    });
    return result;
}





/**
 * @license
 * MIT License
 * 
 * Copyright (c) 2014-present, Lee Byron and other contributors.
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ 










var $e6de90c09d008aae$export$bdf4ff5a442cbbc5 = /*@__PURE__*/ function(SetCollection) {
    function Set(value) {
        return value === undefined || value === null ? $e6de90c09d008aae$var$emptySet() : (0, $8b6e80d3bc0e2623$export$6750766a7c7ec627)(value) && !(0, $d95bc815d10ddd62$export$e670b9b76442ef6c)(value) ? value : $e6de90c09d008aae$var$emptySet().withMutations(function(set) {
            var iter = SetCollection(value);
            (0, $6ec38c7a88fbe1b6$export$2e2bcd8739ae039)(iter.size);
            iter.forEach(function(v) {
                return set.add(v);
            });
        });
    }
    if (SetCollection) Set.__proto__ = SetCollection;
    Set.prototype = Object.create(SetCollection && SetCollection.prototype);
    Set.prototype.constructor = Set;
    Set.of = function of() {
        return this(arguments);
    };
    Set.fromKeys = function fromKeys(value) {
        return this((0, $4952a3ccc7265b27$export$6e235e3661e8f430)(value).keySeq());
    };
    Set.intersect = function intersect(sets) {
        sets = (0, $4952a3ccc7265b27$export$fb8073518f34e6ec)(sets).toArray();
        return sets.length ? $e6de90c09d008aae$var$SetPrototype.intersect.apply(Set(sets.pop()), sets) : $e6de90c09d008aae$var$emptySet();
    };
    Set.union = function union(sets) {
        sets = (0, $4952a3ccc7265b27$export$fb8073518f34e6ec)(sets).toArray();
        return sets.length ? $e6de90c09d008aae$var$SetPrototype.union.apply(Set(sets.pop()), sets) : $e6de90c09d008aae$var$emptySet();
    };
    Set.prototype.toString = function toString() {
        return this.__toString("Set {", "}");
    };
    // @pragma Access
    Set.prototype.has = function has(value) {
        return this._map.has(value);
    };
    // @pragma Modification
    Set.prototype.add = function add(value) {
        return $e6de90c09d008aae$var$updateSet(this, this._map.set(value, value));
    };
    Set.prototype.remove = function remove(value) {
        return $e6de90c09d008aae$var$updateSet(this, this._map.remove(value));
    };
    Set.prototype.clear = function clear() {
        return $e6de90c09d008aae$var$updateSet(this, this._map.clear());
    };
    // @pragma Composition
    Set.prototype.map = function map(mapper, context) {
        var this$1$1 = this;
        // keep track if the set is altered by the map function
        var didChanges = false;
        var newMap = $e6de90c09d008aae$var$updateSet(this, this._map.mapEntries(function(ref) {
            var v = ref[1];
            var mapped = mapper.call(context, v, v, this$1$1);
            if (mapped !== v) didChanges = true;
            return [
                mapped,
                mapped
            ];
        }, context));
        return didChanges ? newMap : this;
    };
    Set.prototype.union = function union() {
        var iters = [], len = arguments.length;
        while(len--)iters[len] = arguments[len];
        iters = iters.filter(function(x) {
            return x.size !== 0;
        });
        if (iters.length === 0) return this;
        if (this.size === 0 && !this.__ownerID && iters.length === 1) return this.constructor(iters[0]);
        return this.withMutations(function(set) {
            for(var ii = 0; ii < iters.length; ii++)if (typeof iters[ii] === "string") set.add(iters[ii]);
            else SetCollection(iters[ii]).forEach(function(value) {
                return set.add(value);
            });
        });
    };
    Set.prototype.intersect = function intersect() {
        var iters = [], len = arguments.length;
        while(len--)iters[len] = arguments[len];
        if (iters.length === 0) return this;
        iters = iters.map(function(iter) {
            return SetCollection(iter);
        });
        var toRemove = [];
        this.forEach(function(value) {
            if (!iters.every(function(iter) {
                return iter.includes(value);
            })) toRemove.push(value);
        });
        return this.withMutations(function(set) {
            toRemove.forEach(function(value) {
                set.remove(value);
            });
        });
    };
    Set.prototype.subtract = function subtract() {
        var iters = [], len = arguments.length;
        while(len--)iters[len] = arguments[len];
        if (iters.length === 0) return this;
        iters = iters.map(function(iter) {
            return SetCollection(iter);
        });
        var toRemove = [];
        this.forEach(function(value) {
            if (iters.some(function(iter) {
                return iter.includes(value);
            })) toRemove.push(value);
        });
        return this.withMutations(function(set) {
            toRemove.forEach(function(value) {
                set.remove(value);
            });
        });
    };
    Set.prototype.sort = function sort(comparator) {
        // Late binding
        return (0, $eeb9b1d6c94112ab$export$ba0280ac83f150c1)((0, $8ec84f2e16db5cf4$export$2950ac5a8a1b38e5)(this, comparator));
    };
    Set.prototype.sortBy = function sortBy(mapper, comparator) {
        // Late binding
        return (0, $eeb9b1d6c94112ab$export$ba0280ac83f150c1)((0, $8ec84f2e16db5cf4$export$2950ac5a8a1b38e5)(this, comparator, mapper));
    };
    Set.prototype.wasAltered = function wasAltered() {
        return this._map.wasAltered();
    };
    Set.prototype.__iterate = function __iterate(fn, reverse) {
        var this$1$1 = this;
        return this._map.__iterate(function(k) {
            return fn(k, k, this$1$1);
        }, reverse);
    };
    Set.prototype.__iterator = function __iterator(type, reverse) {
        return this._map.__iterator(type, reverse);
    };
    Set.prototype.__ensureOwner = function __ensureOwner(ownerID) {
        if (ownerID === this.__ownerID) return this;
        var newMap = this._map.__ensureOwner(ownerID);
        if (!ownerID) {
            if (this.size === 0) return this.__empty();
            this.__ownerID = ownerID;
            this._map = newMap;
            return this;
        }
        return this.__make(newMap, ownerID);
    };
    return Set;
}((0, $4952a3ccc7265b27$export$8ace86ce31a5e0e7));
$e6de90c09d008aae$export$bdf4ff5a442cbbc5.isSet = (0, $8b6e80d3bc0e2623$export$6750766a7c7ec627);
var $e6de90c09d008aae$var$SetPrototype = $e6de90c09d008aae$export$bdf4ff5a442cbbc5.prototype;
$e6de90c09d008aae$var$SetPrototype[0, $8b6e80d3bc0e2623$export$319d06920c1f0301] = true;
$e6de90c09d008aae$var$SetPrototype[0, $c2ddc03a1d32db1a$export$4bd2facc4a3e6aa1] = $e6de90c09d008aae$var$SetPrototype.remove;
$e6de90c09d008aae$var$SetPrototype.merge = $e6de90c09d008aae$var$SetPrototype.concat = $e6de90c09d008aae$var$SetPrototype.union;
$e6de90c09d008aae$var$SetPrototype.withMutations = (0, $17d048964b7d8355$export$c779a0e1bb0d59bf);
$e6de90c09d008aae$var$SetPrototype.asImmutable = (0, $3042678b907a98f2$export$158f0e042e0dd7fe);
$e6de90c09d008aae$var$SetPrototype["@@transducer/init"] = $e6de90c09d008aae$var$SetPrototype.asMutable = (0, $49ab0d381a1fe1a2$export$9cce5776307dcd36);
$e6de90c09d008aae$var$SetPrototype["@@transducer/step"] = function(result, arr) {
    return result.add(arr);
};
$e6de90c09d008aae$var$SetPrototype["@@transducer/result"] = function(obj) {
    return obj.asImmutable();
};
$e6de90c09d008aae$var$SetPrototype.__empty = $e6de90c09d008aae$var$emptySet;
$e6de90c09d008aae$var$SetPrototype.__make = $e6de90c09d008aae$var$makeSet;
function $e6de90c09d008aae$var$updateSet(set, newMap) {
    if (set.__ownerID) {
        set.size = newMap.size;
        set._map = newMap;
        return set;
    }
    return newMap === set._map ? set : newMap.size === 0 ? set.__empty() : set.__make(newMap);
}
function $e6de90c09d008aae$var$makeSet(map, ownerID) {
    var set = Object.create($e6de90c09d008aae$var$SetPrototype);
    set.size = map ? map.size : 0;
    set._map = map;
    set.__ownerID = ownerID;
    return set;
}
var $e6de90c09d008aae$var$EMPTY_SET;
function $e6de90c09d008aae$var$emptySet() {
    return $e6de90c09d008aae$var$EMPTY_SET || ($e6de90c09d008aae$var$EMPTY_SET = $e6de90c09d008aae$var$makeSet((0, $3ff96ffc4297bcc8$export$dbfbb79577167c48)()));
}




/**
 * @license
 * MIT License
 * 
 * Copyright (c) 2014-present, Lee Byron and other contributors.
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ 




/**
 * Returns a lazy seq of nums from start (inclusive) to end
 * (exclusive), by step, where start defaults to 0, step to 1, and end to
 * infinity. When start is equal to end, returns empty list.
 */ var $b409607006c0c262$export$9a58ef0d7ad3278c = /*@__PURE__*/ function(IndexedSeq) {
    function Range(start, end, step) {
        if (step === void 0) step = 1;
        if (!(this instanceof Range)) return new Range(start, end, step);
        (0, $e70ac56ed1101873$export$2e2bcd8739ae039)(step !== 0, "Cannot step a Range by 0");
        (0, $e70ac56ed1101873$export$2e2bcd8739ae039)(start !== undefined, "You must define a start value when using Range");
        (0, $e70ac56ed1101873$export$2e2bcd8739ae039)(end !== undefined, "You must define an end value when using Range");
        step = Math.abs(step);
        if (end < start) step = -step;
        this._start = start;
        this._end = end;
        this._step = step;
        this.size = Math.max(0, Math.ceil((end - start) / step - 1) + 1);
        if (this.size === 0) {
            if ($b409607006c0c262$var$EMPTY_RANGE) return $b409607006c0c262$var$EMPTY_RANGE;
            $b409607006c0c262$var$EMPTY_RANGE = this;
        }
    }
    if (IndexedSeq) Range.__proto__ = IndexedSeq;
    Range.prototype = Object.create(IndexedSeq && IndexedSeq.prototype);
    Range.prototype.constructor = Range;
    Range.prototype.toString = function toString() {
        if (this.size === 0) return "Range []";
        return "Range [ " + this._start + "..." + this._end + (this._step !== 1 ? " by " + this._step : "") + " ]";
    };
    Range.prototype.get = function get(index, notSetValue) {
        return this.has(index) ? this._start + (0, $c2ddc03a1d32db1a$export$acb6ab09ed1b7b8b)(this, index) * this._step : notSetValue;
    };
    Range.prototype.includes = function includes(searchValue) {
        var possibleIndex = (searchValue - this._start) / this._step;
        return possibleIndex >= 0 && possibleIndex < this.size && possibleIndex === Math.floor(possibleIndex);
    };
    Range.prototype.slice = function slice(begin, end) {
        if ((0, $c2ddc03a1d32db1a$export$39c07963d3ae8010)(begin, end, this.size)) return this;
        begin = (0, $c2ddc03a1d32db1a$export$b50255956c5410d8)(begin, this.size);
        end = (0, $c2ddc03a1d32db1a$export$9be3172c55e482a)(end, this.size);
        if (end <= begin) return new Range(0, 0);
        return new Range(this.get(begin, this._end), this.get(end, this._end), this._step);
    };
    Range.prototype.indexOf = function indexOf(searchValue) {
        var offsetValue = searchValue - this._start;
        if (offsetValue % this._step === 0) {
            var index = offsetValue / this._step;
            if (index >= 0 && index < this.size) return index;
        }
        return -1;
    };
    Range.prototype.lastIndexOf = function lastIndexOf(searchValue) {
        return this.indexOf(searchValue);
    };
    Range.prototype.__iterate = function __iterate(fn, reverse) {
        var size = this.size;
        var step = this._step;
        var value = reverse ? this._start + (size - 1) * step : this._start;
        var i = 0;
        while(i !== size){
            if (fn(value, reverse ? size - ++i : i++, this) === false) break;
            value += reverse ? -step : step;
        }
        return i;
    };
    Range.prototype.__iterator = function __iterator(type, reverse) {
        var size = this.size;
        var step = this._step;
        var value = reverse ? this._start + (size - 1) * step : this._start;
        var i = 0;
        return new (0, $88d0bf2511806126$export$b67e82436e407e40)(function() {
            if (i === size) return (0, $88d0bf2511806126$export$e141d6e2268e9d85)();
            var v = value;
            value += reverse ? -step : step;
            return (0, $88d0bf2511806126$export$dde1781ce8ad65f)(type, reverse ? size - ++i : i++, v);
        });
    };
    Range.prototype.equals = function equals(other) {
        return other instanceof Range ? this._start === other._start && this._end === other._end && this._step === other._step : (0, $a7a25cdf95c5ecae$export$2e2bcd8739ae039)(this, other);
    };
    return Range;
}((0, $a5938beaa66b3822$export$1b5716c72c24a934));
var $b409607006c0c262$var$EMPTY_RANGE;




/**
 * @license
 * MIT License
 * 
 * Copyright (c) 2014-present, Lee Byron and other contributors.
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ /**
 * @license
 * MIT License
 * 
 * Copyright (c) 2014-present, Lee Byron and other contributors.
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ 


function $b1accaecafec2e09$export$c52e5867d5879e24(collection, searchKeyPath, notSetValue) {
    var keyPath = (0, $31ceb94ca8bbb05a$export$2e2bcd8739ae039)(searchKeyPath);
    var i = 0;
    while(i !== keyPath.length){
        collection = (0, $a91ac00741fd7597$export$3988ae62b71be9a3)(collection, keyPath[i++], (0, $c2ddc03a1d32db1a$export$dc6d556e3fa8f459));
        if (collection === (0, $c2ddc03a1d32db1a$export$dc6d556e3fa8f459)) return notSetValue;
    }
    return collection;
}


function $6789b3dc360c2d7e$export$c52e5867d5879e24(searchKeyPath, notSetValue) {
    return (0, $b1accaecafec2e09$export$c52e5867d5879e24)(this, searchKeyPath, notSetValue);
}


/**
 * @license
 * MIT License
 * 
 * Copyright (c) 2014-present, Lee Byron and other contributors.
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ /**
 * @license
 * MIT License
 * 
 * Copyright (c) 2014-present, Lee Byron and other contributors.
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ 

function $78f95ef4cef506a6$export$d39a4e62499f2a79(collection, keyPath) {
    return (0, $b1accaecafec2e09$export$c52e5867d5879e24)(collection, keyPath, (0, $c2ddc03a1d32db1a$export$dc6d556e3fa8f459)) !== (0, $c2ddc03a1d32db1a$export$dc6d556e3fa8f459);
}


function $bba71960d93ce160$export$d39a4e62499f2a79(searchKeyPath) {
    return (0, $78f95ef4cef506a6$export$d39a4e62499f2a79)(this, searchKeyPath);
}


/**
 * @license
 * MIT License
 * 
 * Copyright (c) 2014-present, Lee Byron and other contributors.
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ 
function $6553e2d513279022$export$697e4a1b90752ce2() {
    (0, $6ec38c7a88fbe1b6$export$2e2bcd8739ae039)(this.size);
    var object = {};
    this.__iterate(function(v, k) {
        object[k] = v;
    });
    return object;
}


// Note: all of these methods are deprecated.
(0, $4952a3ccc7265b27$export$fb8073518f34e6ec).isIterable = (0, $d70bc35f1b2e7a74$export$cea7aa84e978eba5);
(0, $4952a3ccc7265b27$export$fb8073518f34e6ec).isKeyed = (0, $e8d80ef58ba97d1e$export$66d51e2080425364);
(0, $4952a3ccc7265b27$export$fb8073518f34e6ec).isIndexed = (0, $a4ecf346f3821d5f$export$3bfb5e72e8bc6e09);
(0, $4952a3ccc7265b27$export$fb8073518f34e6ec).isAssociative = (0, $7a2788a9210b8dae$export$9c3ce8f7b89c6d66);
(0, $4952a3ccc7265b27$export$fb8073518f34e6ec).isOrdered = (0, $d95bc815d10ddd62$export$e670b9b76442ef6c);
(0, $4952a3ccc7265b27$export$fb8073518f34e6ec).Iterator = (0, $88d0bf2511806126$export$b67e82436e407e40);
(0, $ba814b0331493f6e$export$2e2bcd8739ae039)((0, $4952a3ccc7265b27$export$fb8073518f34e6ec), {
    // ### Conversion to other types
    toArray: function toArray() {
        (0, $6ec38c7a88fbe1b6$export$2e2bcd8739ae039)(this.size);
        var array = new Array(this.size || 0);
        var useTuples = (0, $e8d80ef58ba97d1e$export$66d51e2080425364)(this);
        var i = 0;
        this.__iterate(function(v, k) {
            // Keyed collections produce an array of tuples.
            array[i++] = useTuples ? [
                k,
                v
            ] : v;
        });
        return array;
    },
    toIndexedSeq: function toIndexedSeq() {
        return new (0, $8ec84f2e16db5cf4$export$7b754de2844682e2)(this);
    },
    toJS: function toJS$1() {
        return (0, $5739de8a73a6dd48$export$f08965dd1304d490)(this);
    },
    toKeyedSeq: function toKeyedSeq() {
        return new (0, $8ec84f2e16db5cf4$export$219a757d6570b3bf)(this, true);
    },
    toMap: function toMap() {
        // Use Late Binding here to solve the circular dependency.
        return (0, $3ff96ffc4297bcc8$export$a5c7b93649eaf8f8)(this.toKeyedSeq());
    },
    toObject: (0, $6553e2d513279022$export$697e4a1b90752ce2),
    toOrderedMap: function toOrderedMap() {
        // Use Late Binding here to solve the circular dependency.
        return (0, $acfb3e7ae62d9682$export$8e8eaa3741ef504c)(this.toKeyedSeq());
    },
    toOrderedSet: function toOrderedSet() {
        // Use Late Binding here to solve the circular dependency.
        return (0, $eeb9b1d6c94112ab$export$ba0280ac83f150c1)((0, $e8d80ef58ba97d1e$export$66d51e2080425364)(this) ? this.valueSeq() : this);
    },
    toSet: function toSet() {
        // Use Late Binding here to solve the circular dependency.
        return (0, $e6de90c09d008aae$export$bdf4ff5a442cbbc5)((0, $e8d80ef58ba97d1e$export$66d51e2080425364)(this) ? this.valueSeq() : this);
    },
    toSetSeq: function toSetSeq() {
        return new (0, $8ec84f2e16db5cf4$export$1c4696a2ef8f42ed)(this);
    },
    toSeq: function toSeq() {
        return (0, $a4ecf346f3821d5f$export$3bfb5e72e8bc6e09)(this) ? this.toIndexedSeq() : (0, $e8d80ef58ba97d1e$export$66d51e2080425364)(this) ? this.toKeyedSeq() : this.toSetSeq();
    },
    toStack: function toStack() {
        // Use Late Binding here to solve the circular dependency.
        return (0, $e410790f9257995e$export$694e0d28c7ffc90c)((0, $e8d80ef58ba97d1e$export$66d51e2080425364)(this) ? this.valueSeq() : this);
    },
    toList: function toList() {
        // Use Late Binding here to solve the circular dependency.
        return (0, $80b7afef873cee5f$export$54c2e3dc7acea9f5)((0, $e8d80ef58ba97d1e$export$66d51e2080425364)(this) ? this.valueSeq() : this);
    },
    // ### Common JavaScript methods and properties
    toString: function toString() {
        return "[Collection]";
    },
    __toString: function __toString(head, tail) {
        if (this.size === 0) return head + tail;
        return head + " " + this.toSeq().map(this.__toStringMapper).join(", ") + " " + tail;
    },
    // ### ES6 Collection methods (ES6 Array and Map)
    concat: function concat() {
        var values = [], len = arguments.length;
        while(len--)values[len] = arguments[len];
        return (0, $8ec84f2e16db5cf4$export$46ba2b2dce92f7a)(this, (0, $8ec84f2e16db5cf4$export$dc42ac9421804a0a)(this, values));
    },
    includes: function includes(searchValue) {
        return this.some(function(value) {
            return (0, $cffd0257ddfe6a6e$export$226b3eccf92c9ed9)(value, searchValue);
        });
    },
    entries: function entries() {
        return this.__iterator((0, $88d0bf2511806126$export$ba5b1d03002a31af));
    },
    every: function every(predicate, context) {
        (0, $6ec38c7a88fbe1b6$export$2e2bcd8739ae039)(this.size);
        var returnValue = true;
        this.__iterate(function(v, k, c) {
            if (!predicate.call(context, v, k, c)) {
                returnValue = false;
                return false;
            }
        });
        return returnValue;
    },
    filter: function filter(predicate, context) {
        return (0, $8ec84f2e16db5cf4$export$46ba2b2dce92f7a)(this, (0, $8ec84f2e16db5cf4$export$97ef98b518aa31ce)(this, predicate, context, true));
    },
    partition: function partition(predicate, context) {
        return (0, $8ec84f2e16db5cf4$export$14c53bee7f214c1a)(this, predicate, context);
    },
    find: function find(predicate, context, notSetValue) {
        var entry = this.findEntry(predicate, context);
        return entry ? entry[1] : notSetValue;
    },
    forEach: function forEach(sideEffect, context) {
        (0, $6ec38c7a88fbe1b6$export$2e2bcd8739ae039)(this.size);
        return this.__iterate(context ? sideEffect.bind(context) : sideEffect);
    },
    join: function join(separator) {
        (0, $6ec38c7a88fbe1b6$export$2e2bcd8739ae039)(this.size);
        separator = separator !== undefined ? "" + separator : ",";
        var joined = "";
        var isFirst = true;
        this.__iterate(function(v) {
            isFirst ? isFirst = false : joined += separator;
            joined += v !== null && v !== undefined ? v.toString() : "";
        });
        return joined;
    },
    keys: function keys() {
        return this.__iterator((0, $88d0bf2511806126$export$cf2425c07c5cbc1));
    },
    map: function map(mapper, context) {
        return (0, $8ec84f2e16db5cf4$export$46ba2b2dce92f7a)(this, (0, $8ec84f2e16db5cf4$export$5d295c87bcf8a823)(this, mapper, context));
    },
    reduce: function reduce$1(reducer, initialReduction, context) {
        return $79bc54f771ac9964$var$reduce(this, reducer, initialReduction, context, arguments.length < 2, false);
    },
    reduceRight: function reduceRight(reducer, initialReduction, context) {
        return $79bc54f771ac9964$var$reduce(this, reducer, initialReduction, context, arguments.length < 2, true);
    },
    reverse: function reverse() {
        return (0, $8ec84f2e16db5cf4$export$46ba2b2dce92f7a)(this, (0, $8ec84f2e16db5cf4$export$477fdcc6fc1d9334)(this, true));
    },
    slice: function slice(begin, end) {
        return (0, $8ec84f2e16db5cf4$export$46ba2b2dce92f7a)(this, (0, $8ec84f2e16db5cf4$export$819dab7fe30346f0)(this, begin, end, true));
    },
    some: function some(predicate, context) {
        (0, $6ec38c7a88fbe1b6$export$2e2bcd8739ae039)(this.size);
        var returnValue = false;
        this.__iterate(function(v, k, c) {
            if (predicate.call(context, v, k, c)) {
                returnValue = true;
                return false;
            }
        });
        return returnValue;
    },
    sort: function sort(comparator) {
        return (0, $8ec84f2e16db5cf4$export$46ba2b2dce92f7a)(this, (0, $8ec84f2e16db5cf4$export$2950ac5a8a1b38e5)(this, comparator));
    },
    values: function values() {
        return this.__iterator((0, $88d0bf2511806126$export$20a9ccb927958bae));
    },
    // ### More sequential methods
    butLast: function butLast() {
        return this.slice(0, -1);
    },
    isEmpty: function isEmpty() {
        return this.size !== undefined ? this.size === 0 : !this.some(function() {
            return true;
        });
    },
    count: function count(predicate, context) {
        return (0, $c2ddc03a1d32db1a$export$b8443e9e8396a588)(predicate ? this.toSeq().filter(predicate, context) : this);
    },
    countBy: function countBy(grouper, context) {
        return (0, $8ec84f2e16db5cf4$export$f662f6780bee687f)(this, grouper, context);
    },
    equals: function equals(other) {
        return (0, $a7a25cdf95c5ecae$export$2e2bcd8739ae039)(this, other);
    },
    entrySeq: function entrySeq() {
        var collection = this;
        if (collection._cache) // We cache as an entries array, so we can just return the cache!
        return new (0, $a5938beaa66b3822$export$b0774ff537b4dcee)(collection._cache);
        var entriesSequence = collection.toSeq().map($79bc54f771ac9964$var$entryMapper).toIndexedSeq();
        entriesSequence.fromEntrySeq = function() {
            return collection.toSeq();
        };
        return entriesSequence;
    },
    filterNot: function filterNot(predicate, context) {
        return this.filter($79bc54f771ac9964$var$not(predicate), context);
    },
    findEntry: function findEntry(predicate, context, notSetValue) {
        var found = notSetValue;
        this.__iterate(function(v, k, c) {
            if (predicate.call(context, v, k, c)) {
                found = [
                    k,
                    v
                ];
                return false;
            }
        });
        return found;
    },
    findKey: function findKey(predicate, context) {
        var entry = this.findEntry(predicate, context);
        return entry && entry[0];
    },
    findLast: function findLast(predicate, context, notSetValue) {
        return this.toKeyedSeq().reverse().find(predicate, context, notSetValue);
    },
    findLastEntry: function findLastEntry(predicate, context, notSetValue) {
        return this.toKeyedSeq().reverse().findEntry(predicate, context, notSetValue);
    },
    findLastKey: function findLastKey(predicate, context) {
        return this.toKeyedSeq().reverse().findKey(predicate, context);
    },
    first: function first(notSetValue) {
        return this.find((0, $c2ddc03a1d32db1a$export$8a16822a2b63cb79), null, notSetValue);
    },
    flatMap: function flatMap(mapper, context) {
        return (0, $8ec84f2e16db5cf4$export$46ba2b2dce92f7a)(this, (0, $8ec84f2e16db5cf4$export$8f6683ff3cb92273)(this, mapper, context));
    },
    flatten: function flatten(depth) {
        return (0, $8ec84f2e16db5cf4$export$46ba2b2dce92f7a)(this, (0, $8ec84f2e16db5cf4$export$12d97d167e8720a3)(this, depth, true));
    },
    fromEntrySeq: function fromEntrySeq() {
        return new (0, $8ec84f2e16db5cf4$export$394aa8ca251ed0c7)(this);
    },
    get: function get(searchKey, notSetValue) {
        return this.find(function(_, key) {
            return (0, $cffd0257ddfe6a6e$export$226b3eccf92c9ed9)(key, searchKey);
        }, undefined, notSetValue);
    },
    getIn: (0, $6789b3dc360c2d7e$export$c52e5867d5879e24),
    groupBy: function groupBy(grouper, context) {
        return (0, $8ec84f2e16db5cf4$export$c6f81c0551133212)(this, grouper, context);
    },
    has: function has(searchKey) {
        return this.get(searchKey, (0, $c2ddc03a1d32db1a$export$dc6d556e3fa8f459)) !== (0, $c2ddc03a1d32db1a$export$dc6d556e3fa8f459);
    },
    hasIn: (0, $bba71960d93ce160$export$d39a4e62499f2a79),
    isSubset: function isSubset(iter) {
        iter = typeof iter.includes === "function" ? iter : (0, $4952a3ccc7265b27$export$fb8073518f34e6ec)(iter);
        return this.every(function(value) {
            return iter.includes(value);
        });
    },
    isSuperset: function isSuperset(iter) {
        iter = typeof iter.isSubset === "function" ? iter : (0, $4952a3ccc7265b27$export$fb8073518f34e6ec)(iter);
        return iter.isSubset(this);
    },
    keyOf: function keyOf(searchValue) {
        return this.findKey(function(value) {
            return (0, $cffd0257ddfe6a6e$export$226b3eccf92c9ed9)(value, searchValue);
        });
    },
    keySeq: function keySeq() {
        return this.toSeq().map($79bc54f771ac9964$var$keyMapper).toIndexedSeq();
    },
    last: function last(notSetValue) {
        return this.toSeq().reverse().first(notSetValue);
    },
    lastKeyOf: function lastKeyOf(searchValue) {
        return this.toKeyedSeq().reverse().keyOf(searchValue);
    },
    max: function max(comparator) {
        return (0, $8ec84f2e16db5cf4$export$9f2d12982e77eb8)(this, comparator);
    },
    maxBy: function maxBy(mapper, comparator) {
        return (0, $8ec84f2e16db5cf4$export$9f2d12982e77eb8)(this, comparator, mapper);
    },
    min: function min(comparator) {
        return (0, $8ec84f2e16db5cf4$export$9f2d12982e77eb8)(this, comparator ? $79bc54f771ac9964$var$neg(comparator) : $79bc54f771ac9964$var$defaultNegComparator);
    },
    minBy: function minBy(mapper, comparator) {
        return (0, $8ec84f2e16db5cf4$export$9f2d12982e77eb8)(this, comparator ? $79bc54f771ac9964$var$neg(comparator) : $79bc54f771ac9964$var$defaultNegComparator, mapper);
    },
    rest: function rest() {
        return this.slice(1);
    },
    skip: function skip(amount) {
        return amount === 0 ? this : this.slice(Math.max(0, amount));
    },
    skipLast: function skipLast(amount) {
        return amount === 0 ? this : this.slice(0, -Math.max(0, amount));
    },
    skipWhile: function skipWhile(predicate, context) {
        return (0, $8ec84f2e16db5cf4$export$46ba2b2dce92f7a)(this, (0, $8ec84f2e16db5cf4$export$f2073acb6c95136f)(this, predicate, context, true));
    },
    skipUntil: function skipUntil(predicate, context) {
        return this.skipWhile($79bc54f771ac9964$var$not(predicate), context);
    },
    sortBy: function sortBy(mapper, comparator) {
        return (0, $8ec84f2e16db5cf4$export$46ba2b2dce92f7a)(this, (0, $8ec84f2e16db5cf4$export$2950ac5a8a1b38e5)(this, comparator, mapper));
    },
    take: function take(amount) {
        return this.slice(0, Math.max(0, amount));
    },
    takeLast: function takeLast(amount) {
        return this.slice(-Math.max(0, amount));
    },
    takeWhile: function takeWhile(predicate, context) {
        return (0, $8ec84f2e16db5cf4$export$46ba2b2dce92f7a)(this, (0, $8ec84f2e16db5cf4$export$3802045e50446382)(this, predicate, context));
    },
    takeUntil: function takeUntil(predicate, context) {
        return this.takeWhile($79bc54f771ac9964$var$not(predicate), context);
    },
    update: function update(fn) {
        return fn(this);
    },
    valueSeq: function valueSeq() {
        return this.toIndexedSeq();
    },
    // ### Hashable Object
    hashCode: function hashCode() {
        return this.__hash || (this.__hash = $79bc54f771ac9964$var$hashCollection(this));
    }
});
var $79bc54f771ac9964$export$684bccb786e593c1 = (0, $4952a3ccc7265b27$export$fb8073518f34e6ec).prototype;
$79bc54f771ac9964$export$684bccb786e593c1[0, $d70bc35f1b2e7a74$export$763d354e117c1e1a] = true;
$79bc54f771ac9964$export$684bccb786e593c1[0, $88d0bf2511806126$export$f3bc9dfea2800188] = $79bc54f771ac9964$export$684bccb786e593c1.values;
$79bc54f771ac9964$export$684bccb786e593c1.toJSON = $79bc54f771ac9964$export$684bccb786e593c1.toArray;
$79bc54f771ac9964$export$684bccb786e593c1.__toStringMapper = (0, $bd09225c08825e19$export$2e2bcd8739ae039);
$79bc54f771ac9964$export$684bccb786e593c1.inspect = $79bc54f771ac9964$export$684bccb786e593c1.toSource = function() {
    return this.toString();
};
$79bc54f771ac9964$export$684bccb786e593c1.chain = $79bc54f771ac9964$export$684bccb786e593c1.flatMap;
$79bc54f771ac9964$export$684bccb786e593c1.contains = $79bc54f771ac9964$export$684bccb786e593c1.includes;
(0, $ba814b0331493f6e$export$2e2bcd8739ae039)((0, $4952a3ccc7265b27$export$6e235e3661e8f430), {
    // ### More sequential methods
    flip: function flip() {
        return (0, $8ec84f2e16db5cf4$export$46ba2b2dce92f7a)(this, (0, $8ec84f2e16db5cf4$export$1cc293e2f3cd461f)(this));
    },
    mapEntries: function mapEntries(mapper, context) {
        var this$1$1 = this;
        var iterations = 0;
        return (0, $8ec84f2e16db5cf4$export$46ba2b2dce92f7a)(this, this.toSeq().map(function(v, k) {
            return mapper.call(context, [
                k,
                v
            ], iterations++, this$1$1);
        }).fromEntrySeq());
    },
    mapKeys: function mapKeys(mapper, context) {
        var this$1$1 = this;
        return (0, $8ec84f2e16db5cf4$export$46ba2b2dce92f7a)(this, this.toSeq().flip().map(function(k, v) {
            return mapper.call(context, k, v, this$1$1);
        }).flip());
    }
});
var $79bc54f771ac9964$var$KeyedCollectionPrototype = (0, $4952a3ccc7265b27$export$6e235e3661e8f430).prototype;
$79bc54f771ac9964$var$KeyedCollectionPrototype[0, $e8d80ef58ba97d1e$export$ddf5566dca80552] = true;
$79bc54f771ac9964$var$KeyedCollectionPrototype[0, $88d0bf2511806126$export$f3bc9dfea2800188] = $79bc54f771ac9964$export$684bccb786e593c1.entries;
$79bc54f771ac9964$var$KeyedCollectionPrototype.toJSON = (0, $6553e2d513279022$export$697e4a1b90752ce2);
$79bc54f771ac9964$var$KeyedCollectionPrototype.__toStringMapper = function(v, k) {
    return (0, $bd09225c08825e19$export$2e2bcd8739ae039)(k) + ": " + (0, $bd09225c08825e19$export$2e2bcd8739ae039)(v);
};
(0, $ba814b0331493f6e$export$2e2bcd8739ae039)((0, $4952a3ccc7265b27$export$eb9d6a4c2661c7e7), {
    // ### Conversion to other types
    toKeyedSeq: function toKeyedSeq() {
        return new (0, $8ec84f2e16db5cf4$export$219a757d6570b3bf)(this, false);
    },
    // ### ES6 Collection methods (ES6 Array and Map)
    filter: function filter(predicate, context) {
        return (0, $8ec84f2e16db5cf4$export$46ba2b2dce92f7a)(this, (0, $8ec84f2e16db5cf4$export$97ef98b518aa31ce)(this, predicate, context, false));
    },
    findIndex: function findIndex(predicate, context) {
        var entry = this.findEntry(predicate, context);
        return entry ? entry[0] : -1;
    },
    indexOf: function indexOf(searchValue) {
        var key = this.keyOf(searchValue);
        return key === undefined ? -1 : key;
    },
    lastIndexOf: function lastIndexOf(searchValue) {
        var key = this.lastKeyOf(searchValue);
        return key === undefined ? -1 : key;
    },
    reverse: function reverse() {
        return (0, $8ec84f2e16db5cf4$export$46ba2b2dce92f7a)(this, (0, $8ec84f2e16db5cf4$export$477fdcc6fc1d9334)(this, false));
    },
    slice: function slice(begin, end) {
        return (0, $8ec84f2e16db5cf4$export$46ba2b2dce92f7a)(this, (0, $8ec84f2e16db5cf4$export$819dab7fe30346f0)(this, begin, end, false));
    },
    splice: function splice(index, removeNum /*, ...values*/ ) {
        var numArgs = arguments.length;
        removeNum = Math.max(removeNum || 0, 0);
        if (numArgs === 0 || numArgs === 2 && !removeNum) return this;
        // If index is negative, it should resolve relative to the size of the
        // collection. However size may be expensive to compute if not cached, so
        // only call count() if the number is in fact negative.
        index = (0, $c2ddc03a1d32db1a$export$b50255956c5410d8)(index, index < 0 ? this.count() : this.size);
        var spliced = this.slice(0, index);
        return (0, $8ec84f2e16db5cf4$export$46ba2b2dce92f7a)(this, numArgs === 1 ? spliced : spliced.concat((0, $1464138edd0700c2$export$2e2bcd8739ae039)(arguments, 2), this.slice(index + removeNum)));
    },
    // ### More collection methods
    findLastIndex: function findLastIndex(predicate, context) {
        var entry = this.findLastEntry(predicate, context);
        return entry ? entry[0] : -1;
    },
    first: function first(notSetValue) {
        return this.get(0, notSetValue);
    },
    flatten: function flatten(depth) {
        return (0, $8ec84f2e16db5cf4$export$46ba2b2dce92f7a)(this, (0, $8ec84f2e16db5cf4$export$12d97d167e8720a3)(this, depth, false));
    },
    get: function get(index, notSetValue) {
        index = (0, $c2ddc03a1d32db1a$export$acb6ab09ed1b7b8b)(this, index);
        return index < 0 || this.size === Infinity || this.size !== undefined && index > this.size ? notSetValue : this.find(function(_, key) {
            return key === index;
        }, undefined, notSetValue);
    },
    has: function has(index) {
        index = (0, $c2ddc03a1d32db1a$export$acb6ab09ed1b7b8b)(this, index);
        return index >= 0 && (this.size !== undefined ? this.size === Infinity || index < this.size : this.indexOf(index) !== -1);
    },
    interpose: function interpose(separator) {
        return (0, $8ec84f2e16db5cf4$export$46ba2b2dce92f7a)(this, (0, $8ec84f2e16db5cf4$export$780b5c72de7da758)(this, separator));
    },
    interleave: function interleave() {
        var collections = [
            this
        ].concat((0, $1464138edd0700c2$export$2e2bcd8739ae039)(arguments));
        var zipped = (0, $8ec84f2e16db5cf4$export$7573772064585831)(this.toSeq(), (0, $a5938beaa66b3822$export$1b5716c72c24a934).of, collections);
        var interleaved = zipped.flatten(true);
        if (zipped.size) interleaved.size = zipped.size * collections.length;
        return (0, $8ec84f2e16db5cf4$export$46ba2b2dce92f7a)(this, interleaved);
    },
    keySeq: function keySeq() {
        return (0, $b409607006c0c262$export$9a58ef0d7ad3278c)(0, this.size);
    },
    last: function last(notSetValue) {
        return this.get(-1, notSetValue);
    },
    skipWhile: function skipWhile(predicate, context) {
        return (0, $8ec84f2e16db5cf4$export$46ba2b2dce92f7a)(this, (0, $8ec84f2e16db5cf4$export$f2073acb6c95136f)(this, predicate, context, false));
    },
    zip: function zip() {
        var collections = [
            this
        ].concat((0, $1464138edd0700c2$export$2e2bcd8739ae039)(arguments));
        return (0, $8ec84f2e16db5cf4$export$46ba2b2dce92f7a)(this, (0, $8ec84f2e16db5cf4$export$7573772064585831)(this, $79bc54f771ac9964$var$defaultZipper, collections));
    },
    zipAll: function zipAll() {
        var collections = [
            this
        ].concat((0, $1464138edd0700c2$export$2e2bcd8739ae039)(arguments));
        return (0, $8ec84f2e16db5cf4$export$46ba2b2dce92f7a)(this, (0, $8ec84f2e16db5cf4$export$7573772064585831)(this, $79bc54f771ac9964$var$defaultZipper, collections, true));
    },
    zipWith: function zipWith(zipper /*, ...collections */ ) {
        var collections = (0, $1464138edd0700c2$export$2e2bcd8739ae039)(arguments);
        collections[0] = this;
        return (0, $8ec84f2e16db5cf4$export$46ba2b2dce92f7a)(this, (0, $8ec84f2e16db5cf4$export$7573772064585831)(this, zipper, collections));
    }
});
var $79bc54f771ac9964$export$21c4c45f5d56eb59 = (0, $4952a3ccc7265b27$export$eb9d6a4c2661c7e7).prototype;
$79bc54f771ac9964$export$21c4c45f5d56eb59[0, $a4ecf346f3821d5f$export$b6d03b330dce40f4] = true;
$79bc54f771ac9964$export$21c4c45f5d56eb59[0, $d95bc815d10ddd62$export$63a33a562da7c584] = true;
(0, $ba814b0331493f6e$export$2e2bcd8739ae039)((0, $4952a3ccc7265b27$export$8ace86ce31a5e0e7), {
    // ### ES6 Collection methods (ES6 Array and Map)
    get: function get(value, notSetValue) {
        return this.has(value) ? value : notSetValue;
    },
    includes: function includes(value) {
        return this.has(value);
    },
    // ### More sequential methods
    keySeq: function keySeq() {
        return this.valueSeq();
    }
});
var $79bc54f771ac9964$var$SetCollectionPrototype = (0, $4952a3ccc7265b27$export$8ace86ce31a5e0e7).prototype;
$79bc54f771ac9964$var$SetCollectionPrototype.has = $79bc54f771ac9964$export$684bccb786e593c1.includes;
$79bc54f771ac9964$var$SetCollectionPrototype.contains = $79bc54f771ac9964$var$SetCollectionPrototype.includes;
$79bc54f771ac9964$var$SetCollectionPrototype.keys = $79bc54f771ac9964$var$SetCollectionPrototype.values;
// Mixin subclasses
(0, $ba814b0331493f6e$export$2e2bcd8739ae039)((0, $a5938beaa66b3822$export$20f601f934d554cc), $79bc54f771ac9964$var$KeyedCollectionPrototype);
(0, $ba814b0331493f6e$export$2e2bcd8739ae039)((0, $a5938beaa66b3822$export$1b5716c72c24a934), $79bc54f771ac9964$export$21c4c45f5d56eb59);
(0, $ba814b0331493f6e$export$2e2bcd8739ae039)((0, $a5938beaa66b3822$export$bd141fae6edeb9b9), $79bc54f771ac9964$var$SetCollectionPrototype);
// #pragma Helper functions
function $79bc54f771ac9964$var$reduce(collection, reducer, reduction, context, useFirst, reverse) {
    (0, $6ec38c7a88fbe1b6$export$2e2bcd8739ae039)(collection.size);
    collection.__iterate(function(v, k, c) {
        if (useFirst) {
            useFirst = false;
            reduction = v;
        } else reduction = reducer.call(context, reduction, v, k, c);
    }, reverse);
    return reduction;
}
function $79bc54f771ac9964$var$keyMapper(v, k) {
    return k;
}
function $79bc54f771ac9964$var$entryMapper(v, k) {
    return [
        k,
        v
    ];
}
function $79bc54f771ac9964$var$not(predicate) {
    return function() {
        return !predicate.apply(this, arguments);
    };
}
function $79bc54f771ac9964$var$neg(predicate) {
    return function() {
        return -predicate.apply(this, arguments);
    };
}
function $79bc54f771ac9964$var$defaultZipper() {
    return (0, $1464138edd0700c2$export$2e2bcd8739ae039)(arguments);
}
function $79bc54f771ac9964$var$defaultNegComparator(a, b) {
    return a < b ? 1 : a > b ? -1 : 0;
}
function $79bc54f771ac9964$var$hashCollection(collection) {
    if (collection.size === Infinity) return 0;
    var ordered = (0, $d95bc815d10ddd62$export$e670b9b76442ef6c)(collection);
    var keyed = (0, $e8d80ef58ba97d1e$export$66d51e2080425364)(collection);
    var h = ordered ? 1 : 0;
    var size = collection.__iterate(keyed ? ordered ? function(v, k) {
        h = 31 * h + $79bc54f771ac9964$var$hashMerge((0, $826fab6845b48e0a$export$d6af199866bfb566)(v), (0, $826fab6845b48e0a$export$d6af199866bfb566)(k)) | 0;
    } : function(v, k) {
        h = h + $79bc54f771ac9964$var$hashMerge((0, $826fab6845b48e0a$export$d6af199866bfb566)(v), (0, $826fab6845b48e0a$export$d6af199866bfb566)(k)) | 0;
    } : ordered ? function(v) {
        h = 31 * h + (0, $826fab6845b48e0a$export$d6af199866bfb566)(v) | 0;
    } : function(v) {
        h = h + (0, $826fab6845b48e0a$export$d6af199866bfb566)(v) | 0;
    });
    return $79bc54f771ac9964$var$murmurHashOfSize(size, h);
}
function $79bc54f771ac9964$var$murmurHashOfSize(size, h) {
    h = (0, $e36528f3fc6f83e1$export$46de3d998ca9a030)(h, 0xcc9e2d51);
    h = (0, $e36528f3fc6f83e1$export$46de3d998ca9a030)(h << 15 | h >>> -15, 0x1b873593);
    h = (0, $e36528f3fc6f83e1$export$46de3d998ca9a030)(h << 13 | h >>> -13, 5);
    h = (h + 0xe6546b64 | 0) ^ size;
    h = (0, $e36528f3fc6f83e1$export$46de3d998ca9a030)(h ^ h >>> 16, 0x85ebca6b);
    h = (0, $e36528f3fc6f83e1$export$46de3d998ca9a030)(h ^ h >>> 13, 0xc2b2ae35);
    h = (0, $e36528f3fc6f83e1$export$6a4e4a90997f18fb)(h ^ h >>> 16);
    return h;
}
function $79bc54f771ac9964$var$hashMerge(a, b) {
    return a ^ b + 0x9e3779b9 + (a << 6) + (a >> 2) | 0; // int
}





var $eeb9b1d6c94112ab$export$ba0280ac83f150c1 = /*@__PURE__*/ function(Set) {
    function OrderedSet(value) {
        return value === undefined || value === null ? $eeb9b1d6c94112ab$var$emptyOrderedSet() : (0, $fac081eee1ee61a7$export$a5eec3a3b03b602f)(value) ? value : $eeb9b1d6c94112ab$var$emptyOrderedSet().withMutations(function(set) {
            var iter = (0, $4952a3ccc7265b27$export$8ace86ce31a5e0e7)(value);
            (0, $6ec38c7a88fbe1b6$export$2e2bcd8739ae039)(iter.size);
            iter.forEach(function(v) {
                return set.add(v);
            });
        });
    }
    if (Set) OrderedSet.__proto__ = Set;
    OrderedSet.prototype = Object.create(Set && Set.prototype);
    OrderedSet.prototype.constructor = OrderedSet;
    OrderedSet.of = function of() {
        return this(arguments);
    };
    OrderedSet.fromKeys = function fromKeys(value) {
        return this((0, $4952a3ccc7265b27$export$6e235e3661e8f430)(value).keySeq());
    };
    OrderedSet.prototype.toString = function toString() {
        return this.__toString("OrderedSet {", "}");
    };
    return OrderedSet;
}((0, $e6de90c09d008aae$export$bdf4ff5a442cbbc5));
$eeb9b1d6c94112ab$export$ba0280ac83f150c1.isOrderedSet = (0, $fac081eee1ee61a7$export$a5eec3a3b03b602f);
var $eeb9b1d6c94112ab$var$OrderedSetPrototype = $eeb9b1d6c94112ab$export$ba0280ac83f150c1.prototype;
$eeb9b1d6c94112ab$var$OrderedSetPrototype[0, $d95bc815d10ddd62$export$63a33a562da7c584] = true;
$eeb9b1d6c94112ab$var$OrderedSetPrototype.zip = (0, $79bc54f771ac9964$export$21c4c45f5d56eb59).zip;
$eeb9b1d6c94112ab$var$OrderedSetPrototype.zipWith = (0, $79bc54f771ac9964$export$21c4c45f5d56eb59).zipWith;
$eeb9b1d6c94112ab$var$OrderedSetPrototype.zipAll = (0, $79bc54f771ac9964$export$21c4c45f5d56eb59).zipAll;
$eeb9b1d6c94112ab$var$OrderedSetPrototype.__empty = $eeb9b1d6c94112ab$var$emptyOrderedSet;
$eeb9b1d6c94112ab$var$OrderedSetPrototype.__make = $eeb9b1d6c94112ab$var$makeOrderedSet;
function $eeb9b1d6c94112ab$var$makeOrderedSet(map, ownerID) {
    var set = Object.create($eeb9b1d6c94112ab$var$OrderedSetPrototype);
    set.size = map ? map.size : 0;
    set._map = map;
    set.__ownerID = ownerID;
    return set;
}
var $eeb9b1d6c94112ab$var$EMPTY_ORDERED_SET;
function $eeb9b1d6c94112ab$var$emptyOrderedSet() {
    return $eeb9b1d6c94112ab$var$EMPTY_ORDERED_SET || ($eeb9b1d6c94112ab$var$EMPTY_ORDERED_SET = $eeb9b1d6c94112ab$var$makeOrderedSet((0, $acfb3e7ae62d9682$export$6b155c12215e99ec)()));
}


/**
 * @license
 * MIT License
 * 
 * Copyright (c) 2014-present, Lee Byron and other contributors.
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ var $5999b57de4ee0fe6$export$b26aa21284963439 = {
    LeftThenRight: -1,
    RightThenLeft: 1
};



/**
 * @license
 * MIT License
 * 
 * Copyright (c) 2014-present, Lee Byron and other contributors.
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ 






















function $7cd7e3a810169eec$var$throwOnInvalidDefaultValues(defaultValues) {
    if ((0, $0465e764326921ff$export$6ba840931da50680)(defaultValues)) throw new Error("Can not call `Record` with an immutable Record as default values. Use a plain javascript object instead.");
    if ((0, $821b634c82af17ef$export$f8647edfbac13b4f)(defaultValues)) throw new Error("Can not call `Record` with an immutable Collection as default values. Use a plain javascript object instead.");
    if (defaultValues === null || typeof defaultValues !== "object") throw new Error("Can not call `Record` with a non-object as default values. Use a plain javascript object instead.");
}
var $7cd7e3a810169eec$export$5b163c6d120341e7 = function Record(defaultValues, name) {
    var hasInitialized;
    $7cd7e3a810169eec$var$throwOnInvalidDefaultValues(defaultValues);
    var RecordType = function Record(values) {
        var this$1$1 = this;
        if (values instanceof RecordType) return values;
        if (!(this instanceof RecordType)) return new RecordType(values);
        if (!hasInitialized) {
            hasInitialized = true;
            var keys = Object.keys(defaultValues);
            var indices = RecordTypePrototype._indices = {};
            // Deprecated: left to attempt not to break any external code which
            // relies on a ._name property existing on record instances.
            // Use Record.getDescriptiveName() instead
            RecordTypePrototype._name = name;
            RecordTypePrototype._keys = keys;
            RecordTypePrototype._defaultValues = defaultValues;
            for(var i = 0; i < keys.length; i++){
                var propName = keys[i];
                indices[propName] = i;
                if (RecordTypePrototype[propName]) /* eslint-disable no-console */ typeof console === "object" && console.warn && console.warn("Cannot define " + $7cd7e3a810169eec$var$recordName(this) + ' with property "' + propName + '" since that property name is part of the Record API.');
                else $7cd7e3a810169eec$var$setProp(RecordTypePrototype, propName);
            }
        }
        this.__ownerID = undefined;
        this._values = (0, $80b7afef873cee5f$export$54c2e3dc7acea9f5)().withMutations(function(l) {
            l.setSize(this$1$1._keys.length);
            (0, $4952a3ccc7265b27$export$6e235e3661e8f430)(values).forEach(function(v, k) {
                l.set(this$1$1._indices[k], v === this$1$1._defaultValues[k] ? undefined : v);
            });
        });
        return this;
    };
    var RecordTypePrototype = RecordType.prototype = Object.create($7cd7e3a810169eec$var$RecordPrototype);
    RecordTypePrototype.constructor = RecordType;
    if (name) RecordType.displayName = name;
    return RecordType;
};
$7cd7e3a810169eec$export$5b163c6d120341e7.prototype.toString = function toString() {
    var str = $7cd7e3a810169eec$var$recordName(this) + " { ";
    var keys = this._keys;
    var k;
    for(var i = 0, l = keys.length; i !== l; i++){
        k = keys[i];
        str += (i ? ", " : "") + k + ": " + (0, $bd09225c08825e19$export$2e2bcd8739ae039)(this.get(k));
    }
    return str + " }";
};
$7cd7e3a810169eec$export$5b163c6d120341e7.prototype.equals = function equals(other) {
    return this === other || (0, $0465e764326921ff$export$6ba840931da50680)(other) && $7cd7e3a810169eec$var$recordSeq(this).equals($7cd7e3a810169eec$var$recordSeq(other));
};
$7cd7e3a810169eec$export$5b163c6d120341e7.prototype.hashCode = function hashCode() {
    return $7cd7e3a810169eec$var$recordSeq(this).hashCode();
};
// @pragma Access
$7cd7e3a810169eec$export$5b163c6d120341e7.prototype.has = function has(k) {
    return this._indices.hasOwnProperty(k);
};
$7cd7e3a810169eec$export$5b163c6d120341e7.prototype.get = function get(k, notSetValue) {
    if (!this.has(k)) return notSetValue;
    var index = this._indices[k];
    var value = this._values.get(index);
    return value === undefined ? this._defaultValues[k] : value;
};
// @pragma Modification
$7cd7e3a810169eec$export$5b163c6d120341e7.prototype.set = function set(k, v) {
    if (this.has(k)) {
        var newValues = this._values.set(this._indices[k], v === this._defaultValues[k] ? undefined : v);
        if (newValues !== this._values && !this.__ownerID) return $7cd7e3a810169eec$var$makeRecord(this, newValues);
    }
    return this;
};
$7cd7e3a810169eec$export$5b163c6d120341e7.prototype.remove = function remove(k) {
    return this.set(k);
};
$7cd7e3a810169eec$export$5b163c6d120341e7.prototype.clear = function clear() {
    var newValues = this._values.clear().setSize(this._keys.length);
    return this.__ownerID ? this : $7cd7e3a810169eec$var$makeRecord(this, newValues);
};
$7cd7e3a810169eec$export$5b163c6d120341e7.prototype.wasAltered = function wasAltered() {
    return this._values.wasAltered();
};
$7cd7e3a810169eec$export$5b163c6d120341e7.prototype.toSeq = function toSeq() {
    return $7cd7e3a810169eec$var$recordSeq(this);
};
$7cd7e3a810169eec$export$5b163c6d120341e7.prototype.toJS = function toJS$1() {
    return (0, $5739de8a73a6dd48$export$f08965dd1304d490)(this);
};
$7cd7e3a810169eec$export$5b163c6d120341e7.prototype.entries = function entries() {
    return this.__iterator((0, $88d0bf2511806126$export$ba5b1d03002a31af));
};
$7cd7e3a810169eec$export$5b163c6d120341e7.prototype.__iterator = function __iterator(type, reverse) {
    return $7cd7e3a810169eec$var$recordSeq(this).__iterator(type, reverse);
};
$7cd7e3a810169eec$export$5b163c6d120341e7.prototype.__iterate = function __iterate(fn, reverse) {
    return $7cd7e3a810169eec$var$recordSeq(this).__iterate(fn, reverse);
};
$7cd7e3a810169eec$export$5b163c6d120341e7.prototype.__ensureOwner = function __ensureOwner(ownerID) {
    if (ownerID === this.__ownerID) return this;
    var newValues = this._values.__ensureOwner(ownerID);
    if (!ownerID) {
        this.__ownerID = ownerID;
        this._values = newValues;
        return this;
    }
    return $7cd7e3a810169eec$var$makeRecord(this, newValues, ownerID);
};
$7cd7e3a810169eec$export$5b163c6d120341e7.isRecord = (0, $0465e764326921ff$export$6ba840931da50680);
$7cd7e3a810169eec$export$5b163c6d120341e7.getDescriptiveName = $7cd7e3a810169eec$var$recordName;
var $7cd7e3a810169eec$var$RecordPrototype = $7cd7e3a810169eec$export$5b163c6d120341e7.prototype;
$7cd7e3a810169eec$var$RecordPrototype[0, $0465e764326921ff$export$698b77566b5d832f] = true;
$7cd7e3a810169eec$var$RecordPrototype[0, $c2ddc03a1d32db1a$export$4bd2facc4a3e6aa1] = $7cd7e3a810169eec$var$RecordPrototype.remove;
$7cd7e3a810169eec$var$RecordPrototype.deleteIn = $7cd7e3a810169eec$var$RecordPrototype.removeIn = (0, $2b25b81e7ecaadb3$export$706cff822a6f730d);
$7cd7e3a810169eec$var$RecordPrototype.getIn = (0, $6789b3dc360c2d7e$export$c52e5867d5879e24);
$7cd7e3a810169eec$var$RecordPrototype.hasIn = (0, $79bc54f771ac9964$export$684bccb786e593c1).hasIn;
$7cd7e3a810169eec$var$RecordPrototype.merge = (0, $5836386861972c7b$export$4950aa0f605343fb);
$7cd7e3a810169eec$var$RecordPrototype.mergeWith = (0, $5836386861972c7b$export$2ee76fde9ffe109d);
$7cd7e3a810169eec$var$RecordPrototype.mergeIn = (0, $f6cbcb4ed76baee0$export$271ff073c1ade46a);
$7cd7e3a810169eec$var$RecordPrototype.mergeDeep = (0, $cea06d4b36e8eb56$export$dd702b3c8240390c);
$7cd7e3a810169eec$var$RecordPrototype.mergeDeepWith = (0, $cea06d4b36e8eb56$export$aa0aa29a716b1650);
$7cd7e3a810169eec$var$RecordPrototype.mergeDeepIn = (0, $abe07da7d44267a3$export$534837be55d4be99);
$7cd7e3a810169eec$var$RecordPrototype.setIn = (0, $a04d866a117c3434$export$e6bdf135a54e021b);
$7cd7e3a810169eec$var$RecordPrototype.update = (0, $32345e910e3f25e5$export$722fbec263ad908a);
$7cd7e3a810169eec$var$RecordPrototype.updateIn = (0, $614b9ab34d28a86a$export$f3e3cd1fc9c33ca1);
$7cd7e3a810169eec$var$RecordPrototype.withMutations = (0, $17d048964b7d8355$export$c779a0e1bb0d59bf);
$7cd7e3a810169eec$var$RecordPrototype.asMutable = (0, $49ab0d381a1fe1a2$export$9cce5776307dcd36);
$7cd7e3a810169eec$var$RecordPrototype.asImmutable = (0, $3042678b907a98f2$export$158f0e042e0dd7fe);
$7cd7e3a810169eec$var$RecordPrototype[0, $88d0bf2511806126$export$f3bc9dfea2800188] = $7cd7e3a810169eec$var$RecordPrototype.entries;
$7cd7e3a810169eec$var$RecordPrototype.toJSON = $7cd7e3a810169eec$var$RecordPrototype.toObject = (0, $79bc54f771ac9964$export$684bccb786e593c1).toObject;
$7cd7e3a810169eec$var$RecordPrototype.inspect = $7cd7e3a810169eec$var$RecordPrototype.toSource = function() {
    return this.toString();
};
function $7cd7e3a810169eec$var$makeRecord(likeRecord, values, ownerID) {
    var record = Object.create(Object.getPrototypeOf(likeRecord));
    record._values = values;
    record.__ownerID = ownerID;
    return record;
}
function $7cd7e3a810169eec$var$recordName(record) {
    return record.constructor.displayName || record.constructor.name || "Record";
}
function $7cd7e3a810169eec$var$recordSeq(record) {
    return (0, $a5938beaa66b3822$export$437b28e5b41f462b)(record._keys.map(function(k) {
        return [
            k,
            record.get(k)
        ];
    }));
}
function $7cd7e3a810169eec$var$setProp(prototype, name) {
    try {
        Object.defineProperty(prototype, name, {
            get: function() {
                return this.get(name);
            },
            set: function(value) {
                (0, $e70ac56ed1101873$export$2e2bcd8739ae039)(this.__ownerID, "Cannot set on an immutable record.");
                this.set(name, value);
            }
        });
    } catch (error) {
    // Object.defineProperty failed. Probably IE8.
    }
}



/**
 * @license
 * MIT License
 * 
 * Copyright (c) 2014-present, Lee Byron and other contributors.
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ 




/**
 * Returns a lazy Seq of `value` repeated `times` times. When `times` is
 * undefined, returns an infinite sequence of `value`.
 */ var $e3a6fdc4c252a16f$export$f9d61a2a6155ab51 = /*@__PURE__*/ function(IndexedSeq) {
    function Repeat(value, times) {
        if (!(this instanceof Repeat)) return new Repeat(value, times);
        this._value = value;
        this.size = times === undefined ? Infinity : Math.max(0, times);
        if (this.size === 0) {
            if ($e3a6fdc4c252a16f$var$EMPTY_REPEAT) return $e3a6fdc4c252a16f$var$EMPTY_REPEAT;
            $e3a6fdc4c252a16f$var$EMPTY_REPEAT = this;
        }
    }
    if (IndexedSeq) Repeat.__proto__ = IndexedSeq;
    Repeat.prototype = Object.create(IndexedSeq && IndexedSeq.prototype);
    Repeat.prototype.constructor = Repeat;
    Repeat.prototype.toString = function toString() {
        if (this.size === 0) return "Repeat []";
        return "Repeat [ " + this._value + " " + this.size + " times ]";
    };
    Repeat.prototype.get = function get(index, notSetValue) {
        return this.has(index) ? this._value : notSetValue;
    };
    Repeat.prototype.includes = function includes(searchValue) {
        return (0, $cffd0257ddfe6a6e$export$226b3eccf92c9ed9)(this._value, searchValue);
    };
    Repeat.prototype.slice = function slice(begin, end) {
        var size = this.size;
        return (0, $c2ddc03a1d32db1a$export$39c07963d3ae8010)(begin, end, size) ? this : new Repeat(this._value, (0, $c2ddc03a1d32db1a$export$9be3172c55e482a)(end, size) - (0, $c2ddc03a1d32db1a$export$b50255956c5410d8)(begin, size));
    };
    Repeat.prototype.reverse = function reverse() {
        return this;
    };
    Repeat.prototype.indexOf = function indexOf(searchValue) {
        if ((0, $cffd0257ddfe6a6e$export$226b3eccf92c9ed9)(this._value, searchValue)) return 0;
        return -1;
    };
    Repeat.prototype.lastIndexOf = function lastIndexOf(searchValue) {
        if ((0, $cffd0257ddfe6a6e$export$226b3eccf92c9ed9)(this._value, searchValue)) return this.size;
        return -1;
    };
    Repeat.prototype.__iterate = function __iterate(fn, reverse) {
        var size = this.size;
        var i = 0;
        while(i !== size){
            if (fn(this._value, reverse ? size - ++i : i++, this) === false) break;
        }
        return i;
    };
    Repeat.prototype.__iterator = function __iterator(type, reverse) {
        var this$1$1 = this;
        var size = this.size;
        var i = 0;
        return new (0, $88d0bf2511806126$export$b67e82436e407e40)(function() {
            return i === size ? (0, $88d0bf2511806126$export$e141d6e2268e9d85)() : (0, $88d0bf2511806126$export$dde1781ce8ad65f)(type, reverse ? size - ++i : i++, this$1$1._value);
        });
    };
    Repeat.prototype.equals = function equals(other) {
        return other instanceof Repeat ? (0, $cffd0257ddfe6a6e$export$226b3eccf92c9ed9)(this._value, other._value) : (0, $a7a25cdf95c5ecae$export$2e2bcd8739ae039)(other);
    };
    return Repeat;
}((0, $a5938beaa66b3822$export$1b5716c72c24a934));
var $e3a6fdc4c252a16f$var$EMPTY_REPEAT;



/**
 * @license
 * MIT License
 * 
 * Copyright (c) 2014-present, Lee Byron and other contributors.
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ 






function $7de3496ae9b1ff54$export$fb763b55bf590791(value, converter) {
    return $7de3496ae9b1ff54$var$fromJSWith([], converter || $7de3496ae9b1ff54$var$defaultConverter, value, "", converter && converter.length > 2 ? [] : undefined, {
        "": value
    });
}
function $7de3496ae9b1ff54$var$fromJSWith(stack, converter, value, key, keyPath, parentValue) {
    if (typeof value !== "string" && !(0, $821b634c82af17ef$export$f8647edfbac13b4f)(value) && ((0, $67716be90529aa17$export$2e2bcd8739ae039)(value) || (0, $88d0bf2511806126$export$57f74772748f5c4e)(value) || (0, $c80481447c971627$export$2e2bcd8739ae039)(value))) {
        if (~stack.indexOf(value)) throw new TypeError("Cannot convert circular structure to Immutable");
        stack.push(value);
        keyPath && key !== "" && keyPath.push(key);
        var converted = converter.call(parentValue, key, (0, $a5938beaa66b3822$export$4802c350533dc67e)(value).map(function(v, k) {
            return $7de3496ae9b1ff54$var$fromJSWith(stack, converter, v, k, keyPath, value);
        }), keyPath && keyPath.slice());
        stack.pop();
        keyPath && keyPath.pop();
        return converted;
    }
    return value;
}
function $7de3496ae9b1ff54$var$defaultConverter(k, v) {
    // Effectively the opposite of "Collection.toSeq()"
    return (0, $a4ecf346f3821d5f$export$3bfb5e72e8bc6e09)(v) ? v.toList() : (0, $e8d80ef58ba97d1e$export$66d51e2080425364)(v) ? v.toMap() : v.toSet();
}































/**
 * @license
 * MIT License
 * 
 * Copyright (c) 2014-present, Lee Byron and other contributors.
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ var $a9fa044fd9b28e77$export$83d89fbfd8236492 = "5.0.0-beta.5";



// Note: Iterable is deprecated
var $3c22431224d334b1$export$6936595027d5d5e8 = (0, $4952a3ccc7265b27$export$fb8073518f34e6ec);


function $d0f575b1326e7f91$export$834280ed8d07adce(dispatch) {
    return function dispatchDebug(action) {
        return dispatch((state, ...input)=>{
            debugger;
            const result = action(state, ...input);
            return result;
        });
    };
}
function $d0f575b1326e7f91$export$af1ca9b36f26ee57(dispatch) {
    return function dispatchLog(action) {
        return dispatch((state, ...input)=>{
            console.log("dispatch incoming", {
                state: state,
                input: input
            });
            const result = action(state, ...input);
            console.log("dispatch outgoing", result);
            return result;
        });
    };
}
function $d0f575b1326e7f91$export$61411c93e1287c1e(update, input, handleOutput) {
    return function dispatch(action) {
        update((state)=>{
            const { state: newState, ...output } = action(state, ...input);
            handleOutput(output, state, newState);
            return newState;
        });
    };
}
function $d0f575b1326e7f91$export$103c0bfe0332eea8(init, input, handleOutput) {
    const [state, setState] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(init);
    const dispatch = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>$d0f575b1326e7f91$export$61411c93e1287c1e(setState, input, handleOutput), [
        setState,
        input,
        handleOutput
    ]);
    return [
        state,
        dispatch
    ];
}
function $d0f575b1326e7f91$export$185cfda0b8e365b1(mapIncoming, mapOutgoing, dispatch) {
    return function mappedDispatch(action) {
        dispatch((stateBefore, ...input)=>{
            const { state: state, ...output } = action(mapIncoming(stateBefore), ...input);
            return {
                state: mapOutgoing(state, stateBefore),
                ...output
            };
        });
    };
}
function $d0f575b1326e7f91$export$f153e5abd026c378(fieldName, dispatch) {
    return $d0f575b1326e7f91$export$185cfda0b8e365b1((state)=>state[fieldName], (newFieldState, state)=>(0, $dc9f544fa111904d$export$adaa4cf7ef1b65be)(state, fieldName, newFieldState), dispatch);
}


const $6f23581c0aef6dc2$export$ae0bd03227ec549f = Object.create(null);
const $6f23581c0aef6dc2$var$BlockTag = Symbol("block");
const $6f23581c0aef6dc2$export$de5a9e42c1dff8da = (obj)=>obj?.[$6f23581c0aef6dc2$var$BlockTag] === $6f23581c0aef6dc2$var$BlockTag;
const $6f23581c0aef6dc2$var$DUMMY_OUTPUT_HANDLER = ()=>{};
function $6f23581c0aef6dc2$export$ece2d8b003194dcc(init, input, handleOutput = $6f23581c0aef6dc2$var$DUMMY_OUTPUT_HANDLER) {
    return (0, $d0f575b1326e7f91$export$103c0bfe0332eea8)(init, input, handleOutput);
}
function $6f23581c0aef6dc2$export$185802fd694ee1f5(description) {
    const forwardRefView = /*#__PURE__*/ $acw62.forwardRef(description.view);
    return {
        [$6f23581c0aef6dc2$var$BlockTag]: $6f23581c0aef6dc2$var$BlockTag,
        ...description,
        view (props) {
            return /*#__PURE__*/ $acw62.createElement(forwardRefView, props);
        }
    };
}
function $6f23581c0aef6dc2$export$7ebd55fd2b28b5a(array, fn, startEnv = $6f23581c0aef6dc2$export$ae0bd03227ec549f) {
    const result = [];
    let currentEnv = startEnv;
    array.forEach((item)=>{
        const { out: out, env: env } = fn(item, currentEnv);
        result.push(out);
        currentEnv = {
            ...currentEnv,
            ...env
        };
    });
    return result;
}
function $6f23581c0aef6dc2$export$46fcd87d869db630(dispatch) {
    return function setState(newState) {
        dispatch(()=>({
                state: newState
            }));
    };
}
function $6f23581c0aef6dc2$export$486f2ea1e5f66327(schema, dispatch) {
    return function dispatchMatch(action) {
        dispatch((state, context)=>{
            if ((0, $dc2e80b7ebe4adb5$export$a22775fa5e2eebd9)(schema, state)) return action(state, context);
            return {
                state: state
            };
        });
    };
}
function $6f23581c0aef6dc2$export$574ac5a1d40355c9(discriminator, fieldName, dispatch) {
    return (0, $d0f575b1326e7f91$export$f153e5abd026c378)(fieldName, $6f23581c0aef6dc2$export$486f2ea1e5f66327(discriminator, dispatch));
}
function $6f23581c0aef6dc2$export$b6ca37fc03181c21(action, fn) {
    // Not pretty, but it works
    let description = undefined;
    const outerState = fn((innerState, context)=>{
        const result = action(innerState, context);
        description = result.description;
        return result.state;
    });
    return {
        state: outerState,
        description: description
    };
}


var $2d38c60d8f38da78$exports = {};

$parcel$export($2d38c60d8f38da78$exports, "DocumentOf", () => $2d38c60d8f38da78$export$e2d7b3be314ea7f1);
$parcel$export($2d38c60d8f38da78$exports, "Model", () => $ee99fa6430885fc2$exports);
$parcel$export($2d38c60d8f38da78$exports, "UI", () => $70e75050ef1824a9$exports);


var $acw62 = parcelRequire("acw62");

var $5bc960417406f657$exports = {};

$parcel$export($5bc960417406f657$exports, "shiftStableKeysWithoutAlpha", () => $5bc960417406f657$export$ebc55bfcfb6a9a19);
$parcel$export($5bc960417406f657$exports, "shiftStableKeysWithoutAlphaRegex", () => $5bc960417406f657$export$219c2fb406789343);
$parcel$export($5bc960417406f657$exports, "shiftStableKeys", () => $5bc960417406f657$export$b510f7bffe56700b);
$parcel$export($5bc960417406f657$exports, "shiftStableKeysRegex", () => $5bc960417406f657$export$3e4fa4e2da976575);
$parcel$export($5bc960417406f657$exports, "getFullKey", () => $5bc960417406f657$export$ebf72dfe5a040886);
$parcel$export($5bc960417406f657$exports, "checkCondition", () => $5bc960417406f657$export$a50d2f4cc719808);
$parcel$export($5bc960417406f657$exports, "isAnInput", () => $5bc960417406f657$export$9e8412ac51432a33);
$parcel$export($5bc960417406f657$exports, "onFullKey", () => $5bc960417406f657$export$a889265682f30448);
$parcel$export($5bc960417406f657$exports, "keybindingsHandler", () => $5bc960417406f657$export$c18a895b2c65c088);
$parcel$export($5bc960417406f657$exports, "useKeybindingsHandler", () => $5bc960417406f657$export$a54803f24a0921f3);
$parcel$export($5bc960417406f657$exports, "useKeymap", () => $5bc960417406f657$export$f8f88c5443ad5a5e);
$parcel$export($5bc960417406f657$exports, "filterBindings", () => $5bc960417406f657$export$a820f87ad5ae2b75);
$parcel$export($5bc960417406f657$exports, "filterShadowedBindings", () => $5bc960417406f657$export$124a6ee3366ef11f);
$parcel$export($5bc960417406f657$exports, "useBindingNotifications", () => $5bc960417406f657$export$9914e7ca655daf12);
$parcel$export($5bc960417406f657$exports, "useSubscribeBindings", () => $5bc960417406f657$export$829d991a806e8f6e);
$parcel$export($5bc960417406f657$exports, "useActiveBindings", () => $5bc960417406f657$export$52d9ab9c36a83b4b);
$parcel$export($5bc960417406f657$exports, "GatherShortcuts", () => $5bc960417406f657$export$38fa2c572343d169);
$parcel$export($5bc960417406f657$exports, "useShortcuts", () => $5bc960417406f657$export$a1ca853c6e4bb6fb);
$parcel$export($5bc960417406f657$exports, "ShortcutSuggestions", () => $5bc960417406f657$export$a9a3fd41d8e3fc63);
$parcel$export($5bc960417406f657$exports, "KeyButtonContainer", () => $5bc960417406f657$export$299640fc954ba1db);
$parcel$export($5bc960417406f657$exports, "KeyComposition", () => $5bc960417406f657$export$214722d3fd34b95f);
$parcel$export($5bc960417406f657$exports, "KeySymbol", () => $5bc960417406f657$export$e0ce128c4d56328a);
$parcel$export($5bc960417406f657$exports, "KeyButton", () => $5bc960417406f657$export$95fe205332e7931c);
$parcel$export($5bc960417406f657$exports, "remapKey", () => $5bc960417406f657$export$2a961f5c71093cf4);
$parcel$export($5bc960417406f657$exports, "CollectKeymap", () => $5bc960417406f657$export$179b7008884d6e13);


var $acw62 = parcelRequire("acw62");




var $f1q41 = parcelRequire("f1q41");

var $ff99259e85546794$exports = {};

$parcel$export($ff99259e85546794$exports, "useThrottlePending", () => $ff99259e85546794$export$8ad2e812c0619d28);
$parcel$export($ff99259e85546794$exports, "useAutoretrigger", () => $ff99259e85546794$export$367c5b30159bf195);
$parcel$export($ff99259e85546794$exports, "useEffectQueue", () => $ff99259e85546794$export$4ed76960a7e92ef6);
$parcel$export($ff99259e85546794$exports, "manyEffects", () => $ff99259e85546794$export$ba177a87d02ed2ff);
$parcel$export($ff99259e85546794$exports, "useEffectfulDispatch", () => $ff99259e85546794$export$a902f8b72ad3dfd8);
$parcel$export($ff99259e85546794$exports, "useRefMap", () => $ff99259e85546794$export$a4bd4d7d17a12a52);
$parcel$export($ff99259e85546794$exports, "useSyncRef", () => $ff99259e85546794$export$4debdb1a3f0fa79e);
$parcel$export($ff99259e85546794$exports, "renderConditionally", () => $ff99259e85546794$export$3dcb0090454f7b27);
$parcel$export($ff99259e85546794$exports, "useSelectionRect", () => $ff99259e85546794$export$4826a080e03186d9);
$parcel$export($ff99259e85546794$exports, "useStable", () => $ff99259e85546794$export$b540f128867fb8a2);
$parcel$export($ff99259e85546794$exports, "useStableCallback", () => $ff99259e85546794$export$1a8b1350915fe2e0);

var $acw62 = parcelRequire("acw62");

var $f1q41 = parcelRequire("f1q41");

function $ff99259e85546794$export$8ad2e812c0619d28(delay, callback, options) {
    const [pendingState, setPendingState] = $acw62.useState({
        state: "finished"
    });
    const callbackAndUpdate = $acw62.useCallback((...args)=>{
        try {
            const result = callback(...args);
            if ((0, $512ec8d668819b2f$export$4369c812aac99591)(result)) result.then(()=>{
                setPendingState({
                    state: "finished"
                });
            }, (error)=>{
                setPendingState({
                    state: "failed",
                    error: error
                });
            });
            else setPendingState({
                state: "finished"
            });
        } catch (error) {
            setPendingState({
                state: "failed",
                error: error
            });
        }
    }, [
        callback
    ]);
    const throttledCallback = $acw62.useMemo(()=>(0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).throttle(callbackAndUpdate, delay, options), [
        callbackAndUpdate
    ]);
    const callbackWithPending = $acw62.useCallback((...args)=>{
        setPendingState({
            state: "pending"
        });
        throttledCallback(...args);
    }, [
        throttledCallback
    ]);
    return [
        pendingState,
        callbackWithPending
    ];
}
function $ff99259e85546794$export$367c5b30159bf195(onTrigger) {
    const timeoutRef = $acw62.useRef(null);
    function triggerPeriodically(period, args) {
        return ()=>{
            onTrigger(...args);
            timeoutRef.current = setTimeout(triggerPeriodically(period * 0.99, args), period);
        };
    }
    function triggerStart(...args) {
        onTrigger(...args);
        timeoutRef.current = setTimeout(triggerPeriodically(100, args), 1000);
    }
    function triggerStop() {
        if (timeoutRef.current !== null) clearTimeout(timeoutRef.current);
    }
    return [
        triggerStart,
        triggerStop
    ];
}
function $ff99259e85546794$export$4ed76960a7e92ef6() {
    const effect = $acw62.useRef();
    const timeout = $acw62.useRef();
    const queueEffect = $acw62.useCallback(function queueEffect(newEffect) {
        if (typeof effect.current !== "function") effect.current = newEffect;
        else {
            const previousEffect = effect.current;
            effect.current = ()=>{
                previousEffect();
                newEffect();
            };
        }
        if (timeout.current === undefined) timeout.current = setTimeout(()=>{
            timeout.current = undefined;
            effect.current?.();
            effect.current = undefined;
        });
    }, [
        effect
    ]);
    return queueEffect;
}
function $ff99259e85546794$export$ba177a87d02ed2ff(...effects) {
    return ()=>{
        effects.forEach((effect)=>{
            effect();
        });
    };
}
function $ff99259e85546794$export$a902f8b72ad3dfd8(dispatch) {
    const queueEffect = $ff99259e85546794$export$4ed76960a7e92ef6();
    return $acw62.useCallback((action)=>{
        dispatch((state, ...args)=>{
            const { state: newState = state, effect: effect, ...output } = action(state, ...args);
            if (effect !== undefined) queueEffect(effect);
            return {
                state: newState,
                ...output
            };
        });
    }, [
        dispatch,
        queueEffect
    ]);
}
function $ff99259e85546794$export$a4bd4d7d17a12a52() {
    const refMap = $acw62.useRef(new Map());
    const setRef = $acw62.useCallback((key)=>(ref)=>{
            if (ref === null) refMap.current.delete(key);
            else refMap.current.set(key, ref);
        }, [
        refMap
    ]);
    return [
        setRef,
        refMap.current
    ];
}
function $ff99259e85546794$export$4debdb1a3f0fa79e(value) {
    const ref = $acw62.useRef(value);
    $acw62.useEffect(()=>{
        ref.current = value;
    });
    return ref;
}
function $ff99259e85546794$export$3dcb0090454f7b27(Component, compareProps = "default") {
    let compare;
    switch(compareProps){
        case "never":
            compare = function neverCompare(_before, after) {
                if (after.skipRender) return true;
                return false;
            };
            break;
        case "default":
            compare = function defaultCompare(before, after) {
                if (after.skipRender) return true;
                for(const prop in after){
                    if (prop !== "skipRender" && !Object.is(before[prop], after[prop])) return false;
                }
                return true;
            };
            break;
        default:
            compare = function customCompare(before, after) {
                if (after.skipRender) return true;
                return compareProps(before, after);
            };
    }
    return $acw62.memo(Component, compare);
}
function $ff99259e85546794$export$4826a080e03186d9(active = true) {
    const [rect, setRect] = $acw62.useState(null);
    const rectRef = $ff99259e85546794$export$4debdb1a3f0fa79e(rect);
    function updateSelectionRect() {
        const selection = document.getSelection();
        if (!selection || selection.rangeCount <= 0) {
            if (rectRef.current !== null) setRect(null);
            return;
        }
        const newRect = selection.getRangeAt(0).getBoundingClientRect();
        if (rectRef.current?.x === newRect.x && rectRef.current?.y === newRect.y && rectRef.current?.width === newRect.width && rectRef.current?.height === newRect.height) return;
        setRect(newRect);
    }
    $acw62.useEffect(()=>{
        if (!active) return;
        updateSelectionRect();
        document.addEventListener("selectionchange", updateSelectionRect);
        return ()=>{
            document.removeEventListener("selectionchange", updateSelectionRect);
        };
    }, [
        active
    ]);
    $acw62.useEffect(updateSelectionRect);
    return active ? rect : null;
}
function $ff99259e85546794$export$b540f128867fb8a2(value, equal = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).isEqual) {
    const prevRef = $acw62.useRef(value);
    const prevValue = prevRef.current;
    const stableValue = equal(prevValue, value) ? prevValue : value;
    prevRef.current = stableValue;
    return stableValue;
}
function $ff99259e85546794$export$1a8b1350915fe2e0(func) {
    const funcRef = $acw62.useRef(func);
    funcRef.current = func;
    return $acw62.useCallback((...args)=>funcRef.current(...args), []);
}


const $5bc960417406f657$export$ebc55bfcfb6a9a19 = [
    " ",
    "Tab",
    "Enter",
    "Backspace",
    "Delete",
    "Escape",
    "Arrow(Up|Down|Left|Right)",
    "Home",
    "End",
    "Page(Up|Down)"
];
const $5bc960417406f657$export$219c2fb406789343 = new RegExp("^(" + $5bc960417406f657$export$ebc55bfcfb6a9a19.join("|") + ")$");
const $5bc960417406f657$export$b510f7bffe56700b = [
    "[A-Z]",
    ...$5bc960417406f657$export$ebc55bfcfb6a9a19
];
const $5bc960417406f657$export$3e4fa4e2da976575 = new RegExp("^(" + $5bc960417406f657$export$b510f7bffe56700b.join("|") + ")$");
function $5bc960417406f657$export$ebf72dfe5a040886(event) {
    return [
        event.ctrlKey || event.metaKey ? "C-" : "",
        event.shiftKey ? "Shift-" : "",
        event.altKey ? "Alt-" : "",
        event.code
    ].join("");
}
function $5bc960417406f657$export$a50d2f4cc719808(condition, isSelfFocused, isInputFocused) {
    switch(condition){
        case "none":
        case "hidden":
            return true;
        case "selfFocused":
            return isSelfFocused;
        case "!selfFocused":
            return !isSelfFocused;
        case "!inputFocused":
            return !isInputFocused;
    }
}
function $5bc960417406f657$export$9e8412ac51432a33(value) {
    return value instanceof HTMLTextAreaElement || value instanceof HTMLInputElement || value instanceof HTMLElement && value.isContentEditable;
}
function $5bc960417406f657$export$a889265682f30448(event, keys, condition, action, options = {}) {
    if (event.isPropagationStopped()) return;
    if (!keys.includes($5bc960417406f657$export$ebf72dfe5a040886(event))) return;
    if (!$5bc960417406f657$export$a50d2f4cc719808(condition, event.currentTarget === event.target, $5bc960417406f657$export$9e8412ac51432a33(event.target))) return;
    action(event);
    if (!options.noAutoPrevent) {
        event.stopPropagation();
        event.preventDefault();
    }
}
function $5bc960417406f657$export$c18a895b2c65c088(bindings, keymap) {
    const flatBindings = bindings.flatMap((group)=>group.bindings.flatMap((binding)=>binding[0].map((key)=>[
                    key,
                    binding
                ])));
    const bindingMap = flatBindings.reduce((map, [key, binding])=>map.update(key, (0, $80b7afef873cee5f$export$54c2e3dc7acea9f5)(), (l)=>l.push(binding)), (0, $3ff96ffc4297bcc8$export$a5c7b93649eaf8f8)());
    return function onKeyDown(event) {
        const bindings = bindingMap.get($5bc960417406f657$export$ebf72dfe5a040886(event));
        if (bindings !== undefined) {
            for (const binding of bindings)if ($5bc960417406f657$export$a50d2f4cc719808(binding[1], event.currentTarget === event.target, $5bc960417406f657$export$9e8412ac51432a33(event.target))) {
                binding[3](event);
                if (!binding[4]?.noAutoPrevent) {
                    event.stopPropagation();
                    event.preventDefault();
                }
                return;
            }
        }
    };
}
function $5bc960417406f657$export$a54803f24a0921f3(bindings) {
    const keymap = $5bc960417406f657$export$f8f88c5443ad5a5e();
    return $acw62.useMemo(()=>$5bc960417406f657$export$c18a895b2c65c088(bindings, keymap), [
        bindings,
        keymap
    ]);
}
function $5bc960417406f657$export$a820f87ad5ae2b75(bindings, isSelfFocused, isInputFocused) {
    return bindings.map((binding)=>({
            ...binding,
            bindings: binding.bindings.filter(([_keys, condition, _description, _action])=>{
                return $5bc960417406f657$export$a50d2f4cc719808(condition, isSelfFocused, isInputFocused);
            })
        }));
}
function $5bc960417406f657$export$124a6ee3366ef11f(bindings) {
    function filterBinding(binding, existingBindings) {
        const [keys, condition, description, action] = binding;
        const filteredKeys = keys.filter((key)=>!existingBindings.contains(key));
        if (filteredKeys.length === 0) return [];
        return [
            [
                filteredKeys,
                condition,
                description,
                action
            ]
        ];
    }
    function filterHelper(bindings, existingBindings) {
        if (bindings.isEmpty()) return (0, $80b7afef873cee5f$export$54c2e3dc7acea9f5)();
        const current = bindings.get(0);
        const filteredBindings = current.bindings.flatMap((binding)=>filterBinding(binding, existingBindings));
        const bindingsKeys = current.bindings.flatMap(([keys])=>keys);
        return filterHelper(bindings.shift(), existingBindings.union(bindingsKeys)).unshift({
            ...current,
            bindings: filteredBindings
        });
    }
    return filterHelper((0, $80b7afef873cee5f$export$54c2e3dc7acea9f5)(bindings), (0, $e6de90c09d008aae$export$bdf4ff5a442cbbc5)()).toArray();
}
const $5bc960417406f657$var$dummyShortcutsReporter = {
    updateBindings () {},
    reportBindings () {},
    removeBindings () {}
};
const $5bc960417406f657$var$dummyShortcutsNotifier = {
    getBindings () {
        return [];
    },
    subscribe (id, consumer) {},
    unsubscribe (id) {}
};
const $5bc960417406f657$var$ShortcutsReporterContext = /*#__PURE__*/ $acw62.createContext($5bc960417406f657$var$dummyShortcutsReporter);
const $5bc960417406f657$var$ShortcutsNotifierContext = /*#__PURE__*/ $acw62.createContext($5bc960417406f657$var$dummyShortcutsNotifier);
function $5bc960417406f657$export$9914e7ca655daf12() {
    return $acw62.useContext($5bc960417406f657$var$ShortcutsNotifierContext);
}
function $5bc960417406f657$export$829d991a806e8f6e(consumer) {
    const { getBindings: getBindings, subscribe: subscribe, unsubscribe: unsubscribe } = $5bc960417406f657$export$9914e7ca655daf12();
    const id = $acw62.useId();
    $acw62.useEffect(()=>{
        subscribe(id, ()=>{
            consumer(getBindings());
        });
        return ()=>{
            unsubscribe(id);
        };
    }, [
        consumer
    ]);
}
function $5bc960417406f657$export$52d9ab9c36a83b4b() {
    const { getBindings: getBindings, subscribe: subscribe, unsubscribe: unsubscribe } = $5bc960417406f657$export$9914e7ca655daf12();
    const id = $acw62.useId();
    const [cachedBindings, setCachedBindings] = $acw62.useState(getBindings);
    $acw62.useEffect(()=>{
        subscribe(id, ()=>{
            setCachedBindings(getBindings());
        });
        return ()=>{
            unsubscribe(id);
        };
    }, []);
    return cachedBindings;
}
function $5bc960417406f657$export$38fa2c572343d169({ children: children }) {
    const activeBindings = $acw62.useRef((0, $acfb3e7ae62d9682$export$8e8eaa3741ef504c)());
    const bindingUpdateNotificationConsumers = $acw62.useRef((0, $3ff96ffc4297bcc8$export$a5c7b93649eaf8f8)());
    const notifyUpdate = $acw62.useMemo(()=>(0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).debounce(()=>{
            bindingUpdateNotificationConsumers.current.valueSeq().forEach((consumer)=>consumer());
        }, 100), []);
    const reporters = $acw62.useMemo(()=>({
            updateBindings (id, bindings) {
                activeBindings.current = activeBindings.current.set(id, bindings);
                notifyUpdate();
            },
            reportBindings (id, bindings) {
                activeBindings.current = activeBindings.current.delete(id).set(id, bindings) // delete first to change the order
                ;
                notifyUpdate();
            },
            removeBindings (id) {
                activeBindings.current = activeBindings.current.delete(id);
                notifyUpdate();
            }
        }), []);
    const notifier = $acw62.useMemo(()=>({
            getBindings () {
                return $5bc960417406f657$export$124a6ee3366ef11f(activeBindings.current.valueSeq().toArray().flat());
            },
            subscribe (id, consumer) {
                bindingUpdateNotificationConsumers.current = bindingUpdateNotificationConsumers.current.set(id, consumer);
            },
            unsubscribe (id) {
                bindingUpdateNotificationConsumers.current = bindingUpdateNotificationConsumers.current.delete(id);
            }
        }), []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5bc960417406f657$var$ShortcutsReporterContext.Provider, {
        value: reporters,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5bc960417406f657$var$ShortcutsNotifierContext.Provider, {
            value: notifier,
            children: children
        })
    });
}
function $5bc960417406f657$export$a1ca853c6e4bb6fb(bindings, active = true) {
    const id = $acw62.useId();
    const { updateBindings: updateBindings, reportBindings: reportBindings, removeBindings: removeBindings } = $acw62.useContext($5bc960417406f657$var$ShortcutsReporterContext);
    const onKeyDownUnstable = $5bc960417406f657$export$a54803f24a0921f3(bindings);
    const onKeyDown = (0, $ff99259e85546794$export$1a8b1350915fe2e0)(onKeyDownUnstable);
    const focusRef = $acw62.useRef(null);
    $acw62.useEffect(()=>{
        if (!active) removeBindings(id);
        return ()=>{
            removeBindings(id);
        };
    }, [
        active
    ]);
    $acw62.useEffect(()=>{
        if (focusRef.current && active) {
            const activeBindings = $5bc960417406f657$export$a820f87ad5ae2b75(bindings, focusRef.current.isSelfFocused, focusRef.current.isAnInputFocused);
            updateBindings(id, activeBindings);
        }
    }, [
        bindings,
        active
    ]);
    const onFocus = (0, $ff99259e85546794$export$1a8b1350915fe2e0)(function onFocus(event) {
        const isSelfFocused = event.currentTarget === event.target;
        const isAnInputFocused = $5bc960417406f657$export$9e8412ac51432a33(event.target);
        focusRef.current = {
            isSelfFocused: isSelfFocused,
            isAnInputFocused: isAnInputFocused
        };
        const newActiveBindings = $5bc960417406f657$export$a820f87ad5ae2b75(bindings, isSelfFocused, isAnInputFocused);
        active && reportBindings(id, newActiveBindings);
    });
    const onBlur = $acw62.useCallback(function onBlur(event) {
        const isStillFocused = event.currentTarget.contains(event.relatedTarget) // contains the element receiving focus
        ;
        if (!isStillFocused) {
            focusRef.current = null;
            removeBindings(id);
        }
    }, []);
    return {
        onKeyDown: onKeyDown,
        onFocus: onFocus,
        onBlur: onBlur
    };
}
function $5bc960417406f657$var$flattenBindings(bindings) {
    return bindings.flatMap((binding)=>binding.bindings);
}
function $5bc960417406f657$export$a9a3fd41d8e3fc63({ flat: flat, allbindings: allbindings }) {
    const activeBindings = $5bc960417406f657$export$52d9ab9c36a83b4b();
    const bindings = allbindings ?? activeBindings;
    if (bindings.length === 0) return null;
    if (flat) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: $5bc960417406f657$var$flattenBindings(bindings).map((binding)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5bc960417406f657$var$KeybindingSuggestion, {
                binding: binding
            }, JSON.stringify(binding[0])))
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: bindings.map((binding)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5bc960417406f657$var$GroupSuggestion, {
                group: binding
            }, binding.description))
    });
}
function $5bc960417406f657$var$KeybindingSuggestion({ binding: binding }) {
    const [keys, condition, description, action] = binding;
    if (condition === "hidden") return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex flex-row space-x-1 cursor-pointer hover:-translate-y-0.5 transition text-xs",
        // prevent changing focus
        onPointerDown: (ev)=>ev.preventDefault(),
        onClick: ()=>action(),
        children: [
            (0, $512ec8d668819b2f$export$af200dcf8b7cb5de)(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                children: "/"
            }), keys.map((k)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5bc960417406f657$export$299640fc954ba1db, {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5bc960417406f657$export$214722d3fd34b95f, {
                        shortcut: k
                    }, k)
                }))),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "ml-2 text-gray-700 whitespace-nowrap",
                children: description
            })
        ]
    });
}
function $5bc960417406f657$var$GroupSuggestion({ group: group }) {
    if (group.bindings.length === 0) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "space-y-2",
        children: [
            group.description && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "text-xs font-medium",
                children: group.description
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("table", {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                    children: group.bindings.map(([keys, condition, description, action])=>condition !== "hidden" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                            className: "cursor-pointer hover:-translate-x-0.5 transition",
                            // prevent changing focus
                            onPointerDown: (ev)=>ev.preventDefault(),
                            onClick: ()=>action(),
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                    className: "py-0.5 flex flex-row space-x-1 text-xs",
                                    children: keys.flatMap((k, index)=>[
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                children: "/"
                                            }, index),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5bc960417406f657$export$299640fc954ba1db, {
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5bc960417406f657$export$214722d3fd34b95f, {
                                                    shortcut: k
                                                })
                                            })
                                        ]).slice(1)
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                    className: "py-0.5 pl-2 text-xs text-gray-700 whitespace-nowrap",
                                    children: description
                                })
                            ]
                        }))
                })
            })
        ]
    });
}
function $5bc960417406f657$export$214722d3fd34b95f({ shortcut: shortcut, Key: Key = $5bc960417406f657$export$e0ce128c4d56328a }) {
    const keyMap = $5bc960417406f657$export$f8f88c5443ad5a5e();
    const parts = shortcut.split("-");
    const modifiers = parts.slice(0, -1);
    const code = parts.slice(-1)[0];
    const key = keyMap.get(code, code);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            modifiers.map((k)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("kbd", {
                    className: "font-sans",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Key, {
                        keyName: k === "C" ? "Cmd" : k
                    })
                }, k)),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("kbd", {
                className: "font-sans",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Key, {
                    keyName: key
                })
            })
        ]
    });
}
function $5bc960417406f657$export$95fe205332e7931c({ keyName: keyName, className: className }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5bc960417406f657$export$299640fc954ba1db, {
        className: className,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5bc960417406f657$export$e0ce128c4d56328a, {
            keyName: keyName
        })
    });
}
function $5bc960417406f657$export$299640fc954ba1db({ children: children, className: className = "" }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("kbd", {
        style: {
            display: "inline flex"
        },
        className: `
                justify-center items-center text-center space-x-0.5
                px-1 rounded shadow shadow-gray-400
                font-mono
                ${className}
            `,
        children: children
    });
}
function $5bc960417406f657$export$e0ce128c4d56328a({ keyName: keyName }) {
    switch(keyName){
        case "Shift":
            return "\u21E7";
        case "Cmd":
            return "\u2318";
        case "Alt":
            return "\u2325";
        case "Backspace":
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e4ec753f5c716375$export$2b9260d4a45c8710), {
                size: "xs",
                className: "text-gray-600",
                icon: $d8206b3ab2e65c05$export$bbcc9e0b6022772b
            });
        case "Enter":
            return "\u23CE";
        case "ArrowUp":
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e4ec753f5c716375$export$2b9260d4a45c8710), {
                className: "text-gray-600",
                icon: $d8206b3ab2e65c05$export$7de776bdab4e536d
            });
        case "ArrowDown":
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e4ec753f5c716375$export$2b9260d4a45c8710), {
                className: "text-gray-600",
                icon: $d8206b3ab2e65c05$export$f9395ef707603e40
            });
        case "ArrowLeft":
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e4ec753f5c716375$export$2b9260d4a45c8710), {
                className: "text-gray-600",
                icon: $d8206b3ab2e65c05$export$85a918a11b7643c2
            });
        case "ArrowRight":
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e4ec753f5c716375$export$2b9260d4a45c8710), {
                className: "text-gray-600",
                icon: $d8206b3ab2e65c05$export$f1011352b01c1c0
            });
        case "Escape":
            return "esc";
        case " ":
            return "space";
        default:
            return keyName.length === 1 ? keyName.toUpperCase() : keyName;
    }
}
function $5bc960417406f657$export$2a961f5c71093cf4(keymap, code, fallbackKey) {
    return keymap.get(code) ?? fallbackKey;
}
function $5bc960417406f657$var$loadSavedKeymap() {
    try {
        const keyMapJson = localStorage.getItem("keyMap");
        if (keyMapJson === null) return (0, $3ff96ffc4297bcc8$export$a5c7b93649eaf8f8)();
        const map = JSON.parse(keyMapJson);
        // is old version of keyMap?
        if (typeof Object.values(map)[0] === "object") return (0, $3ff96ffc4297bcc8$export$a5c7b93649eaf8f8)((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).mapValues(map, (obj)=>obj.noshift));
        return (0, $3ff96ffc4297bcc8$export$a5c7b93649eaf8f8)(map);
    } catch (e) {
        return (0, $3ff96ffc4297bcc8$export$a5c7b93649eaf8f8)();
    }
}
const $5bc960417406f657$var$KeymapContext = /*#__PURE__*/ $acw62.createContext((0, $3ff96ffc4297bcc8$export$a5c7b93649eaf8f8)());
function $5bc960417406f657$export$f8f88c5443ad5a5e() {
    return $acw62.useContext($5bc960417406f657$var$KeymapContext);
}
const $5bc960417406f657$var$IGNORE_KEYS_COLLECT = [
    "Shift",
    "Meta",
    "Alt",
    "Control"
];
function $5bc960417406f657$export$179b7008884d6e13({ children: children }) {
    const [keyMap, setKeyMap] = $acw62.useState($5bc960417406f657$var$loadSavedKeymap);
    $acw62.useEffect(()=>{
        localStorage.setItem("keyMap", JSON.stringify(keyMap.toObject()));
    }, [
        keyMap
    ]);
    function onCollectKey(event) {
        if ($5bc960417406f657$var$IGNORE_KEYS_COLLECT.includes(event.key) || $5bc960417406f657$export$219c2fb406789343.test(event.key)) return;
        if (!event.ctrlKey && (event.altKey || event.metaKey || event.shiftKey)) return;
        if (keyMap.get(event.code) !== event.key) setKeyMap((keyMap)=>keyMap.set(event.code, event.key));
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "w-full h-full min-h-fit",
        onKeyDownCapture: onCollectKey,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5bc960417406f657$var$KeymapContext.Provider, {
            value: keyMap,
            children: children
        })
    });
}


var $ee99fa6430885fc2$exports = {};

$parcel$export($ee99fa6430885fc2$exports, "init", () => $ee99fa6430885fc2$export$2cd8252107eb640b);
$parcel$export($ee99fa6430885fc2$exports, "fromJSON", () => $ee99fa6430885fc2$export$21625637effda04);
$parcel$export($ee99fa6430885fc2$exports, "getResult", () => $ee99fa6430885fc2$export$ec795fdf61e2a255);
$parcel$export($ee99fa6430885fc2$exports, "recompute", () => $ee99fa6430885fc2$export$1f297d8d0ce29e3);
$parcel$export($ee99fa6430885fc2$exports, "getOpenPage", () => $ee99fa6430885fc2$export$d99fd09303be89f2);
$parcel$export($ee99fa6430885fc2$exports, "getOpenPageDeps", () => $ee99fa6430885fc2$export$20827ed15e8882d8);
$parcel$export($ee99fa6430885fc2$exports, "pageDepsToEnv", () => $ee99fa6430885fc2$export$193537437f9d47dc);
$parcel$export($ee99fa6430885fc2$exports, "changeOpenPage", () => $ee99fa6430885fc2$export$c71f8f524af5213e);
$parcel$export($ee99fa6430885fc2$exports, "deletePageAt", () => $ee99fa6430885fc2$export$769f13194e872724);
$parcel$export($ee99fa6430885fc2$exports, "addPageAt", () => $ee99fa6430885fc2$export$bcc445b1fd74503c);
$parcel$export($ee99fa6430885fc2$exports, "updatePageAt_NO_RECOMPUTE", () => $ee99fa6430885fc2$export$5813b750fe20a278);
$parcel$export($ee99fa6430885fc2$exports, "recomputeFrom", () => $ee99fa6430885fc2$export$bb6ff48d725fca5e);
$parcel$export($ee99fa6430885fc2$exports, "toJSON", () => $9d7e60768dbfb647$export$54fd2c36b5cc6731);

var $9d52f07a71ba7cea$exports = {};

$parcel$export($9d52f07a71ba7cea$exports, "entryDefaultName", () => $9d52f07a71ba7cea$export$3ef451a1310c1c34);
$parcel$export($9d52f07a71ba7cea$exports, "entryName", () => $9d52f07a71ba7cea$export$dc55bda8be79296a);
$parcel$export($9d52f07a71ba7cea$exports, "getEntriesUntil", () => $9d52f07a71ba7cea$export$8ff6683eaf414994);
$parcel$export($9d52f07a71ba7cea$exports, "getLastResult", () => $9d52f07a71ba7cea$export$b0bda37006f1b949);
$parcel$export($9d52f07a71ba7cea$exports, "getResultEnv", () => $9d52f07a71ba7cea$export$3024f7e3be75347b);
$parcel$export($9d52f07a71ba7cea$exports, "entryToEnv", () => $9d52f07a71ba7cea$export$947e1a03252d3fb2);
$parcel$export($9d52f07a71ba7cea$exports, "entriesToEnv", () => $9d52f07a71ba7cea$export$6c97b09d1d8ba2ed);
$parcel$export($9d52f07a71ba7cea$exports, "nextFreeId", () => $9d52f07a71ba7cea$export$fba3009e3ea7651a);
$parcel$export($9d52f07a71ba7cea$exports, "updateBlockWithId", () => $9d52f07a71ba7cea$export$6000eb93d6447365);
$parcel$export($9d52f07a71ba7cea$exports, "insertEntryBefore", () => $9d52f07a71ba7cea$export$22e6c95d5bbbfd04);
$parcel$export($9d52f07a71ba7cea$exports, "insertEntryAfter", () => $9d52f07a71ba7cea$export$41ee562435ce1bbf);
$parcel$export($9d52f07a71ba7cea$exports, "entryEnv", () => $9d52f07a71ba7cea$export$2e7002a5cdf22418);
$parcel$export($9d52f07a71ba7cea$exports, "updateEntries", () => $9d52f07a71ba7cea$export$60a9011407bd8525);
$parcel$export($9d52f07a71ba7cea$exports, "updateEntryState", () => $9d52f07a71ba7cea$export$853a2b6d97afe5a);
$parcel$export($9d52f07a71ba7cea$exports, "recompute", () => $9d52f07a71ba7cea$export$1f297d8d0ce29e3);
$parcel$export($9d52f07a71ba7cea$exports, "recomputeFrom", () => $9d52f07a71ba7cea$export$bb6ff48d725fca5e);
$parcel$export($9d52f07a71ba7cea$exports, "entryJSONV", () => $9d52f07a71ba7cea$export$313bdf01d4f71749);
$parcel$export($9d52f07a71ba7cea$exports, "fromJSON", () => $9d52f07a71ba7cea$export$21625637effda04);



function $9d52f07a71ba7cea$export$3ef451a1310c1c34(entry) {
    return "$" + entry.id;
}
function $9d52f07a71ba7cea$export$dc55bda8be79296a(entry) {
    if (entry.name.length === 0) return $9d52f07a71ba7cea$export$3ef451a1310c1c34(entry);
    return entry.name;
}
function $9d52f07a71ba7cea$export$8ff6683eaf414994(entries, id) {
    const index = entries.findIndex((entry)=>entry.id === id);
    return entries.slice(0, index + 1);
}
function $9d52f07a71ba7cea$export$b0bda37006f1b949(entries, innerBlock) {
    if (entries.length === 0) return undefined;
    const lastEntry = entries.slice(-1)[0];
    return innerBlock.getResult(lastEntry.state);
}
function $9d52f07a71ba7cea$export$3024f7e3be75347b(entries, innerBlock) {
    return Object.fromEntries(entries.map((entry)=>{
        const result = innerBlock.getResult(entry.state);
        return [
            $9d52f07a71ba7cea$export$dc55bda8be79296a(entry),
            result
        ];
    }));
}
function $9d52f07a71ba7cea$export$947e1a03252d3fb2(entry, innerBlock) {
    return {
        [$9d52f07a71ba7cea$export$dc55bda8be79296a(entry)]: innerBlock.getResult(entry.state)
    };
}
function $9d52f07a71ba7cea$export$6c97b09d1d8ba2ed(entries, innerBlock) {
    return Object.assign({}, ...entries.map((entry)=>$9d52f07a71ba7cea$export$947e1a03252d3fb2(entry, innerBlock)));
}
function $9d52f07a71ba7cea$export$fba3009e3ea7651a(blocks) {
    const highestId = blocks.map((entry)=>entry.id).reduce((a, b)=>Math.max(a, b), -1);
    return 1 + highestId;
}
function $9d52f07a71ba7cea$export$6000eb93d6447365(entries, id, update) {
    return entries.map((entry)=>entry.id === id ? update(entry) : entry);
}
function $9d52f07a71ba7cea$export$22e6c95d5bbbfd04(entries, id, ...newEntries) {
    return entries.flatMap((entry)=>entry.id === id ? [
            ...newEntries,
            entry
        ] : [
            entry
        ]);
}
function $9d52f07a71ba7cea$export$41ee562435ce1bbf(entries, id, ...newEntries) {
    return entries.flatMap((entry)=>entry.id === id ? [
            entry,
            ...newEntries
        ] : [
            entry
        ]);
}
function $9d52f07a71ba7cea$export$2e7002a5cdf22418(env) {
    return (siblingsEnv)=>({
            ...env,
            ...siblingsEnv,
            $before: siblingsEnv
        });
}
function $9d52f07a71ba7cea$export$60a9011407bd8525(entries, updateEntry, dispatch, innerBlock, getLocalEnv) {
    return $6f23581c0aef6dc2$export$7ebd55fd2b28b5a(entries, (entry, siblingEnv)=>{
        const localEnv = getLocalEnv(siblingEnv);
        function localDispatch(localAction) {
            dispatch((entries, context)=>$6f23581c0aef6dc2$export$b6ca37fc03181c21(localAction, (pureAction)=>$9d52f07a71ba7cea$export$853a2b6d97afe5a(entries, entry.id, pureAction, context.env, innerBlock, dispatch)));
        }
        const newEntry = updateEntry(entry, localEnv, localDispatch);
        return {
            out: newEntry,
            env: $9d52f07a71ba7cea$export$947e1a03252d3fb2(newEntry, innerBlock)
        };
    });
}
function $9d52f07a71ba7cea$export$1f297d8d0ce29e3(entries, dispatch, env, changedVars, innerBlock) {
    return $9d52f07a71ba7cea$export$bb6ff48d725fca5e(entries, undefined, env, changedVars, innerBlock, dispatch);
}
function $9d52f07a71ba7cea$export$bb6ff48d725fca5e(entries, id, env, changedVars, innerBlock, dispatch, offset = 0) {
    const index = id === undefined ? 0 : entries.findIndex((entry)=>entry.id === id);
    if (index < 0) return {
        state: entries,
        invalidated: false
    };
    const entriesUntilId = entries.slice(0, Math.max(0, index + offset));
    const entriesAfter = entries.slice(Math.max(0, index + offset));
    const siblingsBeforeEnv = $9d52f07a71ba7cea$export$6c97b09d1d8ba2ed(entriesUntilId, innerBlock);
    const { entries: recomputedEntries, anyInvalidated: anyInvalidated } = entriesAfter.reduce(({ entries: entries, siblingsEnv: siblingsEnv, changedVars: changedVars, anyInvalidated: anyInvalidated }, entry)=>{
        const localEnv = {
            ...env,
            ...siblingsEnv,
            $before: siblingsEnv
        };
        function localDispatch(localAction) {
            dispatch((entries, context)=>$6f23581c0aef6dc2$export$b6ca37fc03181c21(localAction, (pureAction)=>$9d52f07a71ba7cea$export$853a2b6d97afe5a(entries, entry.id, pureAction, context.env, innerBlock, dispatch)));
        }
        const { state: state, invalidated: invalidated } = innerBlock.recompute(entry.state, localDispatch, localEnv, changedVars);
        const newEntry = {
            ...entry,
            state: state
        };
        const name = $9d52f07a71ba7cea$export$dc55bda8be79296a(entry);
        const newChangedVars = invalidated ? changedVars?.add(name) : changedVars?.remove(name);
        return {
            entries: [
                ...entries,
                newEntry
            ],
            siblingsEnv: {
                ...siblingsEnv,
                ...$9d52f07a71ba7cea$export$947e1a03252d3fb2(newEntry, innerBlock)
            },
            changedVars: newChangedVars,
            anyInvalidated: anyInvalidated || invalidated
        };
    }, {
        entries: [],
        siblingsEnv: siblingsBeforeEnv,
        changedVars: changedVars,
        anyInvalidated: false
    });
    return {
        state: [
            ...entriesUntilId,
            ...recomputedEntries
        ],
        invalidated: anyInvalidated
    };
}
function $9d52f07a71ba7cea$export$853a2b6d97afe5a(entries, id, action, env, innerBlock, dispatch) {
    const entryIndex = entries.findIndex((entry)=>entry.id === id);
    if (entryIndex < 0) return entries;
    const siblings = entries.slice(0, entryIndex);
    const siblingsEnv = $9d52f07a71ba7cea$export$6c97b09d1d8ba2ed(siblings, innerBlock);
    const entry = entries[entryIndex];
    const updatedEntries = (0, $dc9f544fa111904d$export$adaa4cf7ef1b65be)(entries, entryIndex, (0, $bddc5e7208652b84$export$722fbec263ad908a)(entry, "state", (state)=>action(state, {
            env: {
                ...env,
                ...siblingsEnv,
                $before: siblingsEnv
            }
        })));
    const changedVars = (0, $e6de90c09d008aae$export$bdf4ff5a442cbbc5)([
        $9d52f07a71ba7cea$export$dc55bda8be79296a(entry)
    ]);
    const { state: recomputedEntries } = $9d52f07a71ba7cea$export$bb6ff48d725fca5e(updatedEntries, id, env, changedVars, innerBlock, dispatch, 1);
    return recomputedEntries;
}
function $9d52f07a71ba7cea$export$313bdf01d4f71749(inner, rest) {
    return {
        id: (0, $dc2e80b7ebe4adb5$export$98e628dec113755e),
        name: (0, $dc2e80b7ebe4adb5$export$22b082955e083ec3),
        state: inner,
        ...rest
    };
}
function $9d52f07a71ba7cea$export$21625637effda04(json, dispatch, env, innerBlock, parseEntryRest) {
    return $6f23581c0aef6dc2$export$7ebd55fd2b28b5a(json, (jsonEntry, siblingEnv)=>{
        const localEnv = {
            ...env,
            ...siblingEnv,
            $before: siblingEnv
        };
        function localDispatch(localAction) {
            dispatch((entries, context)=>$6f23581c0aef6dc2$export$b6ca37fc03181c21(localAction, (pureAction)=>$9d52f07a71ba7cea$export$853a2b6d97afe5a(entries, entry.id, pureAction, context.env, innerBlock, dispatch)));
        }
        const { id: id, name: name, state: state, ...jsonRest } = jsonEntry;
        const loadedState = innerBlock.fromJSON(state, localDispatch, localEnv);
        const entry = {
            id: id,
            name: name,
            state: loadedState
        };
        const fullEntry = parseEntryRest(entry, jsonRest, localEnv);
        return {
            out: fullEntry,
            env: $9d52f07a71ba7cea$export$947e1a03252d3fb2(fullEntry, innerBlock)
        };
    });
}



var $ea3d541d2f2fc6fe$exports = {};

$parcel$export($ea3d541d2f2fc6fe$exports, "init", () => $ea3d541d2f2fc6fe$export$2cd8252107eb640b);
$parcel$export($ea3d541d2f2fc6fe$exports, "toEnv", () => $ea3d541d2f2fc6fe$export$9d6acabda8b45309);
$parcel$export($ea3d541d2f2fc6fe$exports, "getPageAt", () => $ea3d541d2f2fc6fe$export$a12370985d3b367);
$parcel$export($ea3d541d2f2fc6fe$exports, "getAllPaths", () => $ea3d541d2f2fc6fe$export$d42c447bd3fad192);
$parcel$export($ea3d541d2f2fc6fe$exports, "getExpandedPaths", () => $ea3d541d2f2fc6fe$export$65bbd8e473548251);
$parcel$export($ea3d541d2f2fc6fe$exports, "getSiblingsOf", () => $ea3d541d2f2fc6fe$export$6a032b865f6fa31d);
$parcel$export($ea3d541d2f2fc6fe$exports, "getSiblingsAt", () => $ea3d541d2f2fc6fe$export$399e9750aa264c82);
$parcel$export($ea3d541d2f2fc6fe$exports, "getNextOrPrevPath", () => $ea3d541d2f2fc6fe$export$7d76a0b6947ec50f);
$parcel$export($ea3d541d2f2fc6fe$exports, "pagesToEnv", () => $ea3d541d2f2fc6fe$export$6d5fb87801f9083b);
$parcel$export($ea3d541d2f2fc6fe$exports, "getPageDepsAt", () => $ea3d541d2f2fc6fe$export$71b7cddbb772ef8c);
$parcel$export($ea3d541d2f2fc6fe$exports, "unnestPage", () => $ea3d541d2f2fc6fe$export$3966830784117211);
$parcel$export($ea3d541d2f2fc6fe$exports, "updatePageSiblings", () => $ea3d541d2f2fc6fe$export$8860063974dfcb99);
$parcel$export($ea3d541d2f2fc6fe$exports, "recomputePagesFrom", () => $ea3d541d2f2fc6fe$export$7f76e9ee07028bf0);
$parcel$export($ea3d541d2f2fc6fe$exports, "nestPage", () => $ea3d541d2f2fc6fe$export$ba53fb6ee6a1097f);
$parcel$export($ea3d541d2f2fc6fe$exports, "updatePageSiblingsAt", () => $ea3d541d2f2fc6fe$export$e065bdcd47f54c29);
$parcel$export($ea3d541d2f2fc6fe$exports, "movePage", () => $ea3d541d2f2fc6fe$export$c90f31335c54e820);
$parcel$export($ea3d541d2f2fc6fe$exports, "mapPages", () => $ea3d541d2f2fc6fe$export$99c419afdb002672);
$parcel$export($ea3d541d2f2fc6fe$exports, "updatePageStateAt", () => $ea3d541d2f2fc6fe$export$f009d12f262e197f);
$parcel$export($ea3d541d2f2fc6fe$exports, "updatePageAt", () => $ea3d541d2f2fc6fe$export$7a67d5096c18e401);
$parcel$export($ea3d541d2f2fc6fe$exports, "updatePageAt_NO_RECOMPUTE", () => $ea3d541d2f2fc6fe$export$5813b750fe20a278);
$parcel$export($ea3d541d2f2fc6fe$exports, "PageChildren", () => $ea3d541d2f2fc6fe$export$ba4ce60cb663c13f);
$parcel$export($ea3d541d2f2fc6fe$exports, "PageEntry", () => $ea3d541d2f2fc6fe$export$2e3a14fa5b062651);
$parcel$export($ea3d541d2f2fc6fe$exports, "isPageStructureEqual", () => $ea3d541d2f2fc6fe$export$9aad1f9ca871fc45);


var $acw62 = parcelRequire("acw62");


var $7435a4b2c8a749a5$exports = {};

$parcel$export($7435a4b2c8a749a5$exports, "prefix", () => $7435a4b2c8a749a5$export$82e9f45cca5ba907);
$parcel$export($7435a4b2c8a749a5$exports, "faTrashCan", () => $7435a4b2c8a749a5$export$864bb8d6c21fb792);
$parcel$export($7435a4b2c8a749a5$exports, "faTrashAlt", () => $7435a4b2c8a749a5$export$88df7ff7eb32f9dc);
$parcel$export($7435a4b2c8a749a5$exports, "faMessage", () => $7435a4b2c8a749a5$export$6563a67224e7f879);
$parcel$export($7435a4b2c8a749a5$exports, "faCommentAlt", () => $7435a4b2c8a749a5$export$6e96904d9af0ec4a);
$parcel$export($7435a4b2c8a749a5$exports, "faFileLines", () => $7435a4b2c8a749a5$export$ef565d07efe2b5e9);
$parcel$export($7435a4b2c8a749a5$exports, "faFileAlt", () => $7435a4b2c8a749a5$export$243b47dca32bf0b8);
$parcel$export($7435a4b2c8a749a5$exports, "faFileText", () => $7435a4b2c8a749a5$export$f466100bf9bf37a5);
$parcel$export($7435a4b2c8a749a5$exports, "faCalendarDays", () => $7435a4b2c8a749a5$export$31c6cf6f5d38dc0);
$parcel$export($7435a4b2c8a749a5$exports, "faCalendarAlt", () => $7435a4b2c8a749a5$export$cbc139f33cff356);
$parcel$export($7435a4b2c8a749a5$exports, "faHandPointRight", () => $7435a4b2c8a749a5$export$f7bc8714c970afa4);
$parcel$export($7435a4b2c8a749a5$exports, "faFaceSmileBeam", () => $7435a4b2c8a749a5$export$e3c56ed54f074063);
$parcel$export($7435a4b2c8a749a5$exports, "faSmileBeam", () => $7435a4b2c8a749a5$export$54ada6dc9690e0ca);
$parcel$export($7435a4b2c8a749a5$exports, "faFaceGrinStars", () => $7435a4b2c8a749a5$export$1d1fbac384a76a12);
$parcel$export($7435a4b2c8a749a5$exports, "faGrinStars", () => $7435a4b2c8a749a5$export$64347a5c8c402ef4);
$parcel$export($7435a4b2c8a749a5$exports, "faAddressBook", () => $7435a4b2c8a749a5$export$853fd1561789e3bb);
$parcel$export($7435a4b2c8a749a5$exports, "faContactBook", () => $7435a4b2c8a749a5$export$594b5a5d4d2e156b);
$parcel$export($7435a4b2c8a749a5$exports, "faComments", () => $7435a4b2c8a749a5$export$932912e74adb8939);
$parcel$export($7435a4b2c8a749a5$exports, "faPaste", () => $7435a4b2c8a749a5$export$6f95f90dd1f6d86b);
$parcel$export($7435a4b2c8a749a5$exports, "faFileClipboard", () => $7435a4b2c8a749a5$export$ca3229c47de163fa);
$parcel$export($7435a4b2c8a749a5$exports, "faFaceGrinTongueSquint", () => $7435a4b2c8a749a5$export$8eee2c17ff89e724);
$parcel$export($7435a4b2c8a749a5$exports, "faGrinTongueSquint", () => $7435a4b2c8a749a5$export$4edf34c3def09a31);
$parcel$export($7435a4b2c8a749a5$exports, "faFaceFlushed", () => $7435a4b2c8a749a5$export$ba5dc4287853ecbd);
$parcel$export($7435a4b2c8a749a5$exports, "faFlushed", () => $7435a4b2c8a749a5$export$dfd2bd012685aeac);
$parcel$export($7435a4b2c8a749a5$exports, "faSquareCaretRight", () => $7435a4b2c8a749a5$export$5b1d41cdd118ea6d);
$parcel$export($7435a4b2c8a749a5$exports, "faCaretSquareRight", () => $7435a4b2c8a749a5$export$ae86c9de7e0f62fa);
$parcel$export($7435a4b2c8a749a5$exports, "faSquareMinus", () => $7435a4b2c8a749a5$export$814c9edba7b84aa4);
$parcel$export($7435a4b2c8a749a5$exports, "faMinusSquare", () => $7435a4b2c8a749a5$export$ffe9387966b3e681);
$parcel$export($7435a4b2c8a749a5$exports, "faCompass", () => $7435a4b2c8a749a5$export$b4d344633433e50e);
$parcel$export($7435a4b2c8a749a5$exports, "faSquareCaretDown", () => $7435a4b2c8a749a5$export$a1ab39cd66c4e50e);
$parcel$export($7435a4b2c8a749a5$exports, "faCaretSquareDown", () => $7435a4b2c8a749a5$export$61aea18df1c84401);
$parcel$export($7435a4b2c8a749a5$exports, "faFaceKissBeam", () => $7435a4b2c8a749a5$export$eca99665af566fe1);
$parcel$export($7435a4b2c8a749a5$exports, "faKissBeam", () => $7435a4b2c8a749a5$export$d6ff8a73c0812e63);
$parcel$export($7435a4b2c8a749a5$exports, "faLightbulb", () => $7435a4b2c8a749a5$export$1e80f89fe84a215b);
$parcel$export($7435a4b2c8a749a5$exports, "faFlag", () => $7435a4b2c8a749a5$export$6591b1ea509be9da);
$parcel$export($7435a4b2c8a749a5$exports, "faSquareCheck", () => $7435a4b2c8a749a5$export$5bb6a0c94ad2f4bb);
$parcel$export($7435a4b2c8a749a5$exports, "faCheckSquare", () => $7435a4b2c8a749a5$export$f0c8040f596df7fe);
$parcel$export($7435a4b2c8a749a5$exports, "faCircleDot", () => $7435a4b2c8a749a5$export$aa13d9234890e8d3);
$parcel$export($7435a4b2c8a749a5$exports, "faDotCircle", () => $7435a4b2c8a749a5$export$92bc269cb244d66a);
$parcel$export($7435a4b2c8a749a5$exports, "faFaceDizzy", () => $7435a4b2c8a749a5$export$635e4d8cc8428961);
$parcel$export($7435a4b2c8a749a5$exports, "faDizzy", () => $7435a4b2c8a749a5$export$89a2b10dabc487e8);
$parcel$export($7435a4b2c8a749a5$exports, "faFutbol", () => $7435a4b2c8a749a5$export$65a345b33858a655);
$parcel$export($7435a4b2c8a749a5$exports, "faFutbolBall", () => $7435a4b2c8a749a5$export$51a344ca0a215620);
$parcel$export($7435a4b2c8a749a5$exports, "faSoccerBall", () => $7435a4b2c8a749a5$export$f4a29712c724ba2d);
$parcel$export($7435a4b2c8a749a5$exports, "faPenToSquare", () => $7435a4b2c8a749a5$export$ba236543926e3569);
$parcel$export($7435a4b2c8a749a5$exports, "faEdit", () => $7435a4b2c8a749a5$export$7be713e57d023733);
$parcel$export($7435a4b2c8a749a5$exports, "faHourglassHalf", () => $7435a4b2c8a749a5$export$703272eebf5e3eea);
$parcel$export($7435a4b2c8a749a5$exports, "faHourglass2", () => $7435a4b2c8a749a5$export$f1052bbf6bf361c0);
$parcel$export($7435a4b2c8a749a5$exports, "faEyeSlash", () => $7435a4b2c8a749a5$export$ed3f2918429d029a);
$parcel$export($7435a4b2c8a749a5$exports, "faHand", () => $7435a4b2c8a749a5$export$f69db0b876f7d753);
$parcel$export($7435a4b2c8a749a5$exports, "faHandPaper", () => $7435a4b2c8a749a5$export$6e6216c8b50471bb);
$parcel$export($7435a4b2c8a749a5$exports, "faHandSpock", () => $7435a4b2c8a749a5$export$2262d6b626de1120);
$parcel$export($7435a4b2c8a749a5$exports, "faFaceKiss", () => $7435a4b2c8a749a5$export$5a54c83033a0a56a);
$parcel$export($7435a4b2c8a749a5$exports, "faKiss", () => $7435a4b2c8a749a5$export$c762a77aabf64fd0);
$parcel$export($7435a4b2c8a749a5$exports, "faFaceGrinTongue", () => $7435a4b2c8a749a5$export$95a7394c24f57943);
$parcel$export($7435a4b2c8a749a5$exports, "faGrinTongue", () => $7435a4b2c8a749a5$export$ef222816a43a4b3a);
$parcel$export($7435a4b2c8a749a5$exports, "faChessBishop", () => $7435a4b2c8a749a5$export$a831eedd2f59c62f);
$parcel$export($7435a4b2c8a749a5$exports, "faFaceGrinWink", () => $7435a4b2c8a749a5$export$1dd161850c5bc64e);
$parcel$export($7435a4b2c8a749a5$exports, "faGrinWink", () => $7435a4b2c8a749a5$export$2397fcd34eb12177);
$parcel$export($7435a4b2c8a749a5$exports, "faFaceGrinWide", () => $7435a4b2c8a749a5$export$bdbabf493c478cde);
$parcel$export($7435a4b2c8a749a5$exports, "faGrinAlt", () => $7435a4b2c8a749a5$export$b4abebfe416d36ba);
$parcel$export($7435a4b2c8a749a5$exports, "faFaceFrownOpen", () => $7435a4b2c8a749a5$export$c8a28356e07b9ccb);
$parcel$export($7435a4b2c8a749a5$exports, "faFrownOpen", () => $7435a4b2c8a749a5$export$c4775e66bed5d96);
$parcel$export($7435a4b2c8a749a5$exports, "faHandPointUp", () => $7435a4b2c8a749a5$export$cdc9f5e7e94e76da);
$parcel$export($7435a4b2c8a749a5$exports, "faBookmark", () => $7435a4b2c8a749a5$export$4ed9da5c3cca0ef1);
$parcel$export($7435a4b2c8a749a5$exports, "faHandPointDown", () => $7435a4b2c8a749a5$export$f6dcbf0a940428f4);
$parcel$export($7435a4b2c8a749a5$exports, "faFolder", () => $7435a4b2c8a749a5$export$72b780186370e953);
$parcel$export($7435a4b2c8a749a5$exports, "faFolderBlank", () => $7435a4b2c8a749a5$export$9ef114244d26da0);
$parcel$export($7435a4b2c8a749a5$exports, "faUser", () => $7435a4b2c8a749a5$export$f5699fa0844e0188);
$parcel$export($7435a4b2c8a749a5$exports, "faSquareCaretLeft", () => $7435a4b2c8a749a5$export$2c5163541229363);
$parcel$export($7435a4b2c8a749a5$exports, "faCaretSquareLeft", () => $7435a4b2c8a749a5$export$d0c8ba444f1f9581);
$parcel$export($7435a4b2c8a749a5$exports, "faStar", () => $7435a4b2c8a749a5$export$a3b0eb2cd7942125);
$parcel$export($7435a4b2c8a749a5$exports, "faChessKnight", () => $7435a4b2c8a749a5$export$861b1f13085cf122);
$parcel$export($7435a4b2c8a749a5$exports, "faFaceLaughSquint", () => $7435a4b2c8a749a5$export$67ca89c1ca38d559);
$parcel$export($7435a4b2c8a749a5$exports, "faLaughSquint", () => $7435a4b2c8a749a5$export$b206e700cf7084e1);
$parcel$export($7435a4b2c8a749a5$exports, "faFaceLaugh", () => $7435a4b2c8a749a5$export$2f203616c892d415);
$parcel$export($7435a4b2c8a749a5$exports, "faLaugh", () => $7435a4b2c8a749a5$export$6c74e314e801a4fe);
$parcel$export($7435a4b2c8a749a5$exports, "faFolderOpen", () => $7435a4b2c8a749a5$export$ff7e93418af88b78);
$parcel$export($7435a4b2c8a749a5$exports, "faClipboard", () => $7435a4b2c8a749a5$export$97d84347d71ba297);
$parcel$export($7435a4b2c8a749a5$exports, "faChessQueen", () => $7435a4b2c8a749a5$export$7b8ce73615739d30);
$parcel$export($7435a4b2c8a749a5$exports, "faHandBackFist", () => $7435a4b2c8a749a5$export$be38a892fe9b4098);
$parcel$export($7435a4b2c8a749a5$exports, "faHandRock", () => $7435a4b2c8a749a5$export$97a81eba394c8c44);
$parcel$export($7435a4b2c8a749a5$exports, "faSquareCaretUp", () => $7435a4b2c8a749a5$export$66068918abb14406);
$parcel$export($7435a4b2c8a749a5$exports, "faCaretSquareUp", () => $7435a4b2c8a749a5$export$307ae80b26533ce5);
$parcel$export($7435a4b2c8a749a5$exports, "faChartBar", () => $7435a4b2c8a749a5$export$b532f5d25de97633);
$parcel$export($7435a4b2c8a749a5$exports, "faBarChart", () => $7435a4b2c8a749a5$export$2d5f754a5e5738b);
$parcel$export($7435a4b2c8a749a5$exports, "faWindowRestore", () => $7435a4b2c8a749a5$export$eccfff9bfd585652);
$parcel$export($7435a4b2c8a749a5$exports, "faSquarePlus", () => $7435a4b2c8a749a5$export$eaf727acca5a35e4);
$parcel$export($7435a4b2c8a749a5$exports, "faPlusSquare", () => $7435a4b2c8a749a5$export$b6359eebfe900c35);
$parcel$export($7435a4b2c8a749a5$exports, "faImage", () => $7435a4b2c8a749a5$export$7e9f0928967e03b);
$parcel$export($7435a4b2c8a749a5$exports, "faFolderClosed", () => $7435a4b2c8a749a5$export$5e30548b7f8eeb95);
$parcel$export($7435a4b2c8a749a5$exports, "faLemon", () => $7435a4b2c8a749a5$export$4fbda8f64648f3b5);
$parcel$export($7435a4b2c8a749a5$exports, "faHandshake", () => $7435a4b2c8a749a5$export$b4c63e9bfc7906f1);
$parcel$export($7435a4b2c8a749a5$exports, "faGem", () => $7435a4b2c8a749a5$export$31ee86ac717db552);
$parcel$export($7435a4b2c8a749a5$exports, "faCirclePlay", () => $7435a4b2c8a749a5$export$86c4e45dc3302d15);
$parcel$export($7435a4b2c8a749a5$exports, "faPlayCircle", () => $7435a4b2c8a749a5$export$cf04333781061c5e);
$parcel$export($7435a4b2c8a749a5$exports, "faCircleCheck", () => $7435a4b2c8a749a5$export$c2e9877668862374);
$parcel$export($7435a4b2c8a749a5$exports, "faCheckCircle", () => $7435a4b2c8a749a5$export$be9e388158c74f29);
$parcel$export($7435a4b2c8a749a5$exports, "faCircleStop", () => $7435a4b2c8a749a5$export$229de76dfef2687f);
$parcel$export($7435a4b2c8a749a5$exports, "faStopCircle", () => $7435a4b2c8a749a5$export$47af2aad60ab3e7c);
$parcel$export($7435a4b2c8a749a5$exports, "faIdBadge", () => $7435a4b2c8a749a5$export$a75288855ea05282);
$parcel$export($7435a4b2c8a749a5$exports, "faFaceLaughBeam", () => $7435a4b2c8a749a5$export$3f2d51c0547bf984);
$parcel$export($7435a4b2c8a749a5$exports, "faLaughBeam", () => $7435a4b2c8a749a5$export$a88d1f4073ea9369);
$parcel$export($7435a4b2c8a749a5$exports, "faRegistered", () => $7435a4b2c8a749a5$export$5f519e9ac15ab8c3);
$parcel$export($7435a4b2c8a749a5$exports, "faAddressCard", () => $7435a4b2c8a749a5$export$6ea408c7266ed557);
$parcel$export($7435a4b2c8a749a5$exports, "faContactCard", () => $7435a4b2c8a749a5$export$4ac51eb0b298b190);
$parcel$export($7435a4b2c8a749a5$exports, "faVcard", () => $7435a4b2c8a749a5$export$91228257deb1bf18);
$parcel$export($7435a4b2c8a749a5$exports, "faFaceTired", () => $7435a4b2c8a749a5$export$5352cbdc070ce8d);
$parcel$export($7435a4b2c8a749a5$exports, "faTired", () => $7435a4b2c8a749a5$export$3d016d62cda18371);
$parcel$export($7435a4b2c8a749a5$exports, "faFontAwesome", () => $7435a4b2c8a749a5$export$aa4baaed1c60f58d);
$parcel$export($7435a4b2c8a749a5$exports, "faFontAwesomeFlag", () => $7435a4b2c8a749a5$export$102c25fde54d4843);
$parcel$export($7435a4b2c8a749a5$exports, "faFontAwesomeLogoFull", () => $7435a4b2c8a749a5$export$6e20d421a2e0f320);
$parcel$export($7435a4b2c8a749a5$exports, "faFaceSmileWink", () => $7435a4b2c8a749a5$export$6143da800b0e6626);
$parcel$export($7435a4b2c8a749a5$exports, "faSmileWink", () => $7435a4b2c8a749a5$export$f5dbb37f6801ee3f);
$parcel$export($7435a4b2c8a749a5$exports, "faFileWord", () => $7435a4b2c8a749a5$export$f0858dff6e769cf6);
$parcel$export($7435a4b2c8a749a5$exports, "faFilePowerpoint", () => $7435a4b2c8a749a5$export$c341daeecdea449a);
$parcel$export($7435a4b2c8a749a5$exports, "faEnvelopeOpen", () => $7435a4b2c8a749a5$export$c6c3bd5f7d9b8bf2);
$parcel$export($7435a4b2c8a749a5$exports, "faFileZipper", () => $7435a4b2c8a749a5$export$7a4a0e4caa1e4e6f);
$parcel$export($7435a4b2c8a749a5$exports, "faFileArchive", () => $7435a4b2c8a749a5$export$bf2047a9946b5c3f);
$parcel$export($7435a4b2c8a749a5$exports, "faSquare", () => $7435a4b2c8a749a5$export$90b4406457aae8cc);
$parcel$export($7435a4b2c8a749a5$exports, "faSnowflake", () => $7435a4b2c8a749a5$export$bab8f3647c394f48);
$parcel$export($7435a4b2c8a749a5$exports, "faNewspaper", () => $7435a4b2c8a749a5$export$d91b374112d4f8c1);
$parcel$export($7435a4b2c8a749a5$exports, "faFaceKissWinkHeart", () => $7435a4b2c8a749a5$export$611ae61f02de0aa);
$parcel$export($7435a4b2c8a749a5$exports, "faKissWinkHeart", () => $7435a4b2c8a749a5$export$ebba617701dfb917);
$parcel$export($7435a4b2c8a749a5$exports, "faStarHalfStroke", () => $7435a4b2c8a749a5$export$3e4892d8bf919edd);
$parcel$export($7435a4b2c8a749a5$exports, "faStarHalfAlt", () => $7435a4b2c8a749a5$export$c13575f42532efb3);
$parcel$export($7435a4b2c8a749a5$exports, "faFileExcel", () => $7435a4b2c8a749a5$export$77cb1a465c4fe84);
$parcel$export($7435a4b2c8a749a5$exports, "faFaceGrinBeam", () => $7435a4b2c8a749a5$export$3de52eeb00462407);
$parcel$export($7435a4b2c8a749a5$exports, "faGrinBeam", () => $7435a4b2c8a749a5$export$734da5249381ec7e);
$parcel$export($7435a4b2c8a749a5$exports, "faObjectUngroup", () => $7435a4b2c8a749a5$export$887f6345573abcac);
$parcel$export($7435a4b2c8a749a5$exports, "faCircleRight", () => $7435a4b2c8a749a5$export$1fec48c8bdd69c1d);
$parcel$export($7435a4b2c8a749a5$exports, "faArrowAltCircleRight", () => $7435a4b2c8a749a5$export$88962ffdad8b856d);
$parcel$export($7435a4b2c8a749a5$exports, "faFaceRollingEyes", () => $7435a4b2c8a749a5$export$a6d72a9a068392b5);
$parcel$export($7435a4b2c8a749a5$exports, "faMehRollingEyes", () => $7435a4b2c8a749a5$export$fdc62a1bea767cc2);
$parcel$export($7435a4b2c8a749a5$exports, "faObjectGroup", () => $7435a4b2c8a749a5$export$40cdac24aa94a57a);
$parcel$export($7435a4b2c8a749a5$exports, "faHeart", () => $7435a4b2c8a749a5$export$e4b51a47a2f8b9db);
$parcel$export($7435a4b2c8a749a5$exports, "faFaceSurprise", () => $7435a4b2c8a749a5$export$c938968e28178994);
$parcel$export($7435a4b2c8a749a5$exports, "faSurprise", () => $7435a4b2c8a749a5$export$46647c72213f53ba);
$parcel$export($7435a4b2c8a749a5$exports, "faCirclePause", () => $7435a4b2c8a749a5$export$fbeef2513e05ad08);
$parcel$export($7435a4b2c8a749a5$exports, "faPauseCircle", () => $7435a4b2c8a749a5$export$d8cf08a0362da8db);
$parcel$export($7435a4b2c8a749a5$exports, "faCircle", () => $7435a4b2c8a749a5$export$4280b2387fbdad12);
$parcel$export($7435a4b2c8a749a5$exports, "faCircleUp", () => $7435a4b2c8a749a5$export$72ea8a5e4e86cd69);
$parcel$export($7435a4b2c8a749a5$exports, "faArrowAltCircleUp", () => $7435a4b2c8a749a5$export$3747a8ef0995eadf);
$parcel$export($7435a4b2c8a749a5$exports, "faFileAudio", () => $7435a4b2c8a749a5$export$b8d24c57c9e64933);
$parcel$export($7435a4b2c8a749a5$exports, "faFileImage", () => $7435a4b2c8a749a5$export$6440b286d3cbac9b);
$parcel$export($7435a4b2c8a749a5$exports, "faCircleQuestion", () => $7435a4b2c8a749a5$export$d7cf0978afd90002);
$parcel$export($7435a4b2c8a749a5$exports, "faQuestionCircle", () => $7435a4b2c8a749a5$export$5ba67d7f2265c1a5);
$parcel$export($7435a4b2c8a749a5$exports, "faFaceMehBlank", () => $7435a4b2c8a749a5$export$38c072b870a9e4ab);
$parcel$export($7435a4b2c8a749a5$exports, "faMehBlank", () => $7435a4b2c8a749a5$export$e945435725f71e88);
$parcel$export($7435a4b2c8a749a5$exports, "faEye", () => $7435a4b2c8a749a5$export$b8c3e79e8c99c95b);
$parcel$export($7435a4b2c8a749a5$exports, "faFaceSadCry", () => $7435a4b2c8a749a5$export$e8ea88c55e55be7c);
$parcel$export($7435a4b2c8a749a5$exports, "faSadCry", () => $7435a4b2c8a749a5$export$8e924e6bd422cef9);
$parcel$export($7435a4b2c8a749a5$exports, "faFileCode", () => $7435a4b2c8a749a5$export$143d0ca7d2200f20);
$parcel$export($7435a4b2c8a749a5$exports, "faWindowMaximize", () => $7435a4b2c8a749a5$export$703cd98be31ec905);
$parcel$export($7435a4b2c8a749a5$exports, "faFaceFrown", () => $7435a4b2c8a749a5$export$e5f78e87efbb0248);
$parcel$export($7435a4b2c8a749a5$exports, "faFrown", () => $7435a4b2c8a749a5$export$43b7108508aecc5f);
$parcel$export($7435a4b2c8a749a5$exports, "faFloppyDisk", () => $7435a4b2c8a749a5$export$f62f2879ccaea13f);
$parcel$export($7435a4b2c8a749a5$exports, "faSave", () => $7435a4b2c8a749a5$export$1aaa83ff70706e1e);
$parcel$export($7435a4b2c8a749a5$exports, "faCommentDots", () => $7435a4b2c8a749a5$export$63ffcb3d4e94cb92);
$parcel$export($7435a4b2c8a749a5$exports, "faCommenting", () => $7435a4b2c8a749a5$export$49ee382a2425e89c);
$parcel$export($7435a4b2c8a749a5$exports, "faFaceGrinSquint", () => $7435a4b2c8a749a5$export$5d53da7627754bc6);
$parcel$export($7435a4b2c8a749a5$exports, "faGrinSquint", () => $7435a4b2c8a749a5$export$243ae757907b1580);
$parcel$export($7435a4b2c8a749a5$exports, "faHandPointer", () => $7435a4b2c8a749a5$export$d97ff927c450c87f);
$parcel$export($7435a4b2c8a749a5$exports, "faHandScissors", () => $7435a4b2c8a749a5$export$c578e919f2c5c135);
$parcel$export($7435a4b2c8a749a5$exports, "faFaceGrinTears", () => $7435a4b2c8a749a5$export$8ac6d81a3d5b40a1);
$parcel$export($7435a4b2c8a749a5$exports, "faGrinTears", () => $7435a4b2c8a749a5$export$b2f7512221512b5b);
$parcel$export($7435a4b2c8a749a5$exports, "faCalendarXmark", () => $7435a4b2c8a749a5$export$3c70ffe5660af060);
$parcel$export($7435a4b2c8a749a5$exports, "faCalendarTimes", () => $7435a4b2c8a749a5$export$99b20d7352fbcf08);
$parcel$export($7435a4b2c8a749a5$exports, "faFileVideo", () => $7435a4b2c8a749a5$export$b44eb38345c6a964);
$parcel$export($7435a4b2c8a749a5$exports, "faFilePdf", () => $7435a4b2c8a749a5$export$38611f1c776aba73);
$parcel$export($7435a4b2c8a749a5$exports, "faComment", () => $7435a4b2c8a749a5$export$805cd88398a70581);
$parcel$export($7435a4b2c8a749a5$exports, "faEnvelope", () => $7435a4b2c8a749a5$export$6f095630677adc);
$parcel$export($7435a4b2c8a749a5$exports, "faHourglass", () => $7435a4b2c8a749a5$export$b9098a890f61e022);
$parcel$export($7435a4b2c8a749a5$exports, "faHourglassEmpty", () => $7435a4b2c8a749a5$export$a2f8176a0161e891);
$parcel$export($7435a4b2c8a749a5$exports, "faCalendarCheck", () => $7435a4b2c8a749a5$export$5655108e1162ba45);
$parcel$export($7435a4b2c8a749a5$exports, "faHardDrive", () => $7435a4b2c8a749a5$export$4cb736b866cbb7ec);
$parcel$export($7435a4b2c8a749a5$exports, "faHdd", () => $7435a4b2c8a749a5$export$62551e9c5ba7093f);
$parcel$export($7435a4b2c8a749a5$exports, "faFaceGrinSquintTears", () => $7435a4b2c8a749a5$export$8ff56f5ebb8416a0);
$parcel$export($7435a4b2c8a749a5$exports, "faGrinSquintTears", () => $7435a4b2c8a749a5$export$542206d6a85f3b42);
$parcel$export($7435a4b2c8a749a5$exports, "faRectangleList", () => $7435a4b2c8a749a5$export$1f7600fa9fdb3978);
$parcel$export($7435a4b2c8a749a5$exports, "faListAlt", () => $7435a4b2c8a749a5$export$c6327a203ffc65a3);
$parcel$export($7435a4b2c8a749a5$exports, "faCalendarPlus", () => $7435a4b2c8a749a5$export$16768a660ae3ca9d);
$parcel$export($7435a4b2c8a749a5$exports, "faCircleLeft", () => $7435a4b2c8a749a5$export$5ae86b9da9cca3bd);
$parcel$export($7435a4b2c8a749a5$exports, "faArrowAltCircleLeft", () => $7435a4b2c8a749a5$export$5460a5b11a24996f);
$parcel$export($7435a4b2c8a749a5$exports, "faMoneyBill1", () => $7435a4b2c8a749a5$export$a312c7d58dd44a75);
$parcel$export($7435a4b2c8a749a5$exports, "faMoneyBillAlt", () => $7435a4b2c8a749a5$export$a35d573395884c3d);
$parcel$export($7435a4b2c8a749a5$exports, "faClock", () => $7435a4b2c8a749a5$export$95b9968e7fceb821);
$parcel$export($7435a4b2c8a749a5$exports, "faClockFour", () => $7435a4b2c8a749a5$export$9a575facf1cab48f);
$parcel$export($7435a4b2c8a749a5$exports, "faKeyboard", () => $7435a4b2c8a749a5$export$fb61df5d98785fa8);
$parcel$export($7435a4b2c8a749a5$exports, "faClosedCaptioning", () => $7435a4b2c8a749a5$export$8e047801a8603af7);
$parcel$export($7435a4b2c8a749a5$exports, "faImages", () => $7435a4b2c8a749a5$export$74f06b41ed2ca28a);
$parcel$export($7435a4b2c8a749a5$exports, "faFaceGrin", () => $7435a4b2c8a749a5$export$92292137ef3cf4c8);
$parcel$export($7435a4b2c8a749a5$exports, "faGrin", () => $7435a4b2c8a749a5$export$37e1f10b6de76621);
$parcel$export($7435a4b2c8a749a5$exports, "faFaceMeh", () => $7435a4b2c8a749a5$export$dc130582748497c6);
$parcel$export($7435a4b2c8a749a5$exports, "faMeh", () => $7435a4b2c8a749a5$export$6d2db489aaeeecd2);
$parcel$export($7435a4b2c8a749a5$exports, "faIdCard", () => $7435a4b2c8a749a5$export$782ac893fc22249b);
$parcel$export($7435a4b2c8a749a5$exports, "faDriversLicense", () => $7435a4b2c8a749a5$export$8359c70e609eff64);
$parcel$export($7435a4b2c8a749a5$exports, "faSun", () => $7435a4b2c8a749a5$export$2fa35dcbc038dbe9);
$parcel$export($7435a4b2c8a749a5$exports, "faFaceLaughWink", () => $7435a4b2c8a749a5$export$600a1b26b33c3d47);
$parcel$export($7435a4b2c8a749a5$exports, "faLaughWink", () => $7435a4b2c8a749a5$export$77ac40095f39933e);
$parcel$export($7435a4b2c8a749a5$exports, "faCircleDown", () => $7435a4b2c8a749a5$export$531badb89cf01312);
$parcel$export($7435a4b2c8a749a5$exports, "faArrowAltCircleDown", () => $7435a4b2c8a749a5$export$ff3afbc8c0bc5d59);
$parcel$export($7435a4b2c8a749a5$exports, "faThumbsDown", () => $7435a4b2c8a749a5$export$aba24ca305bbe8c1);
$parcel$export($7435a4b2c8a749a5$exports, "faChessPawn", () => $7435a4b2c8a749a5$export$3db75d5ac9e98468);
$parcel$export($7435a4b2c8a749a5$exports, "faCreditCard", () => $7435a4b2c8a749a5$export$3e7437bf6535bef0);
$parcel$export($7435a4b2c8a749a5$exports, "faCreditCardAlt", () => $7435a4b2c8a749a5$export$5fffe8e3c36964a2);
$parcel$export($7435a4b2c8a749a5$exports, "faBell", () => $7435a4b2c8a749a5$export$9b6162797ab1b255);
$parcel$export($7435a4b2c8a749a5$exports, "faFile", () => $7435a4b2c8a749a5$export$cad54bead856a678);
$parcel$export($7435a4b2c8a749a5$exports, "faHospital", () => $7435a4b2c8a749a5$export$7a76c9d35b42d691);
$parcel$export($7435a4b2c8a749a5$exports, "faHospitalAlt", () => $7435a4b2c8a749a5$export$cea7736417b94a3b);
$parcel$export($7435a4b2c8a749a5$exports, "faHospitalWide", () => $7435a4b2c8a749a5$export$69c8cc0360f017e8);
$parcel$export($7435a4b2c8a749a5$exports, "faChessRook", () => $7435a4b2c8a749a5$export$5d65c40a109eb09c);
$parcel$export($7435a4b2c8a749a5$exports, "faStarHalf", () => $7435a4b2c8a749a5$export$228008b5e11032fa);
$parcel$export($7435a4b2c8a749a5$exports, "faChessKing", () => $7435a4b2c8a749a5$export$d5713874f8fefe1b);
$parcel$export($7435a4b2c8a749a5$exports, "faCircleUser", () => $7435a4b2c8a749a5$export$9a5c11a5e3d7f1e7);
$parcel$export($7435a4b2c8a749a5$exports, "faUserCircle", () => $7435a4b2c8a749a5$export$be7d974e9e0dba1a);
$parcel$export($7435a4b2c8a749a5$exports, "faCopy", () => $7435a4b2c8a749a5$export$e9bd786d30cb716c);
$parcel$export($7435a4b2c8a749a5$exports, "faShareFromSquare", () => $7435a4b2c8a749a5$export$928280bdd54fa173);
$parcel$export($7435a4b2c8a749a5$exports, "faShareSquare", () => $7435a4b2c8a749a5$export$ae9e1434571f373c);
$parcel$export($7435a4b2c8a749a5$exports, "faCopyright", () => $7435a4b2c8a749a5$export$da61665fff8aebfe);
$parcel$export($7435a4b2c8a749a5$exports, "faMap", () => $7435a4b2c8a749a5$export$fc82fb79180cd17c);
$parcel$export($7435a4b2c8a749a5$exports, "faBellSlash", () => $7435a4b2c8a749a5$export$6b31a1e5968b2378);
$parcel$export($7435a4b2c8a749a5$exports, "faHandLizard", () => $7435a4b2c8a749a5$export$54608d0a883fea4d);
$parcel$export($7435a4b2c8a749a5$exports, "faFaceSmile", () => $7435a4b2c8a749a5$export$b5023c446f10324);
$parcel$export($7435a4b2c8a749a5$exports, "faSmile", () => $7435a4b2c8a749a5$export$c632b2334f0913bc);
$parcel$export($7435a4b2c8a749a5$exports, "faHandPeace", () => $7435a4b2c8a749a5$export$e49e3cfceea441cc);
$parcel$export($7435a4b2c8a749a5$exports, "faFaceGrinHearts", () => $7435a4b2c8a749a5$export$fbb22081b65e4f33);
$parcel$export($7435a4b2c8a749a5$exports, "faGrinHearts", () => $7435a4b2c8a749a5$export$c56cf0e0c3bc5ed2);
$parcel$export($7435a4b2c8a749a5$exports, "faBuilding", () => $7435a4b2c8a749a5$export$f26673f8b10c3d46);
$parcel$export($7435a4b2c8a749a5$exports, "faFaceGrinBeamSweat", () => $7435a4b2c8a749a5$export$2ff38f330c834084);
$parcel$export($7435a4b2c8a749a5$exports, "faGrinBeamSweat", () => $7435a4b2c8a749a5$export$14d0ccc54c5b6826);
$parcel$export($7435a4b2c8a749a5$exports, "faMoon", () => $7435a4b2c8a749a5$export$c4c2f69a53bab720);
$parcel$export($7435a4b2c8a749a5$exports, "faCalendar", () => $7435a4b2c8a749a5$export$34f5c36a3e80efa2);
$parcel$export($7435a4b2c8a749a5$exports, "faFaceGrinTongueWink", () => $7435a4b2c8a749a5$export$4272e56f2429da88);
$parcel$export($7435a4b2c8a749a5$exports, "faGrinTongueWink", () => $7435a4b2c8a749a5$export$58099903d50aefb3);
$parcel$export($7435a4b2c8a749a5$exports, "faClone", () => $7435a4b2c8a749a5$export$76c1aa4bf9a39458);
$parcel$export($7435a4b2c8a749a5$exports, "faFaceAngry", () => $7435a4b2c8a749a5$export$67a047c738fb34da);
$parcel$export($7435a4b2c8a749a5$exports, "faAngry", () => $7435a4b2c8a749a5$export$3c96c08e234498c5);
$parcel$export($7435a4b2c8a749a5$exports, "faRectangleXmark", () => $7435a4b2c8a749a5$export$3896694b3e81fba7);
$parcel$export($7435a4b2c8a749a5$exports, "faRectangleTimes", () => $7435a4b2c8a749a5$export$eaaf26416a51dc1);
$parcel$export($7435a4b2c8a749a5$exports, "faTimesRectangle", () => $7435a4b2c8a749a5$export$10147c0014152a3f);
$parcel$export($7435a4b2c8a749a5$exports, "faWindowClose", () => $7435a4b2c8a749a5$export$18b7775f78a3e16);
$parcel$export($7435a4b2c8a749a5$exports, "faPaperPlane", () => $7435a4b2c8a749a5$export$b5378818301da1be);
$parcel$export($7435a4b2c8a749a5$exports, "faLifeRing", () => $7435a4b2c8a749a5$export$53dd2cacf674142a);
$parcel$export($7435a4b2c8a749a5$exports, "faFaceGrimace", () => $7435a4b2c8a749a5$export$bd5bd2ef56b793b1);
$parcel$export($7435a4b2c8a749a5$exports, "faGrimace", () => $7435a4b2c8a749a5$export$3d08cd36ac1ef231);
$parcel$export($7435a4b2c8a749a5$exports, "faCalendarMinus", () => $7435a4b2c8a749a5$export$23e8b4955c2d951b);
$parcel$export($7435a4b2c8a749a5$exports, "faCircleXmark", () => $7435a4b2c8a749a5$export$30262489773a79a3);
$parcel$export($7435a4b2c8a749a5$exports, "faTimesCircle", () => $7435a4b2c8a749a5$export$ab0ec50720a747eb);
$parcel$export($7435a4b2c8a749a5$exports, "faXmarkCircle", () => $7435a4b2c8a749a5$export$90ac4096df8efdee);
$parcel$export($7435a4b2c8a749a5$exports, "faThumbsUp", () => $7435a4b2c8a749a5$export$47e4e0d519d33497);
$parcel$export($7435a4b2c8a749a5$exports, "faWindowMinimize", () => $7435a4b2c8a749a5$export$26a3f9d2784b90d8);
$parcel$export($7435a4b2c8a749a5$exports, "faSquareFull", () => $7435a4b2c8a749a5$export$7ec6541fee081990);
$parcel$export($7435a4b2c8a749a5$exports, "faNoteSticky", () => $7435a4b2c8a749a5$export$4a4e034527c933f5);
$parcel$export($7435a4b2c8a749a5$exports, "faStickyNote", () => $7435a4b2c8a749a5$export$80889adc5d98bf4a);
$parcel$export($7435a4b2c8a749a5$exports, "faFaceSadTear", () => $7435a4b2c8a749a5$export$8a5a0dbb2a17e253);
$parcel$export($7435a4b2c8a749a5$exports, "faSadTear", () => $7435a4b2c8a749a5$export$4b5241926f692f91);
$parcel$export($7435a4b2c8a749a5$exports, "faHandPointLeft", () => $7435a4b2c8a749a5$export$b276ec3dc9760d39);
$parcel$export($7435a4b2c8a749a5$exports, "far", () => $7435a4b2c8a749a5$export$f9059ea71e16fa16);
var $7435a4b2c8a749a5$export$82e9f45cca5ba907 = "far";
var $7435a4b2c8a749a5$export$864bb8d6c21fb792 = {
    prefix: "far",
    iconName: "trash-can",
    icon: [
        448,
        512,
        [
            61460,
            "trash-alt"
        ],
        "f2ed",
        "M170.5 51.6L151.5 80h145l-19-28.4c-1.5-2.2-4-3.6-6.7-3.6H177.1c-2.7 0-5.2 1.3-6.7 3.6zm147-26.6L354.2 80H368h48 8c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8V432c0 44.2-35.8 80-80 80H112c-44.2 0-80-35.8-80-80V128H24c-13.3 0-24-10.7-24-24S10.7 80 24 80h8H80 93.8l36.7-55.1C140.9 9.4 158.4 0 177.1 0h93.7c18.7 0 36.2 9.4 46.6 24.9zM80 128V432c0 17.7 14.3 32 32 32H336c17.7 0 32-14.3 32-32V128H80zm80 64V400c0 8.8-7.2 16-16 16s-16-7.2-16-16V192c0-8.8 7.2-16 16-16s16 7.2 16 16zm80 0V400c0 8.8-7.2 16-16 16s-16-7.2-16-16V192c0-8.8 7.2-16 16-16s16 7.2 16 16zm80 0V400c0 8.8-7.2 16-16 16s-16-7.2-16-16V192c0-8.8 7.2-16 16-16s16 7.2 16 16z"
    ]
};
var $7435a4b2c8a749a5$export$88df7ff7eb32f9dc = $7435a4b2c8a749a5$export$864bb8d6c21fb792;
var $7435a4b2c8a749a5$export$6563a67224e7f879 = {
    prefix: "far",
    iconName: "message",
    icon: [
        512,
        512,
        [
            "comment-alt"
        ],
        "f27a",
        "M160 368c26.5 0 48 21.5 48 48v16l72.5-54.4c8.3-6.2 18.4-9.6 28.8-9.6H448c8.8 0 16-7.2 16-16V64c0-8.8-7.2-16-16-16H64c-8.8 0-16 7.2-16 16V352c0 8.8 7.2 16 16 16h96zm48 124l-.2 .2-5.1 3.8-17.1 12.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3V474.7v-6.4V468v-4V416H112 64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H448c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H309.3L208 492z"
    ]
};
var $7435a4b2c8a749a5$export$6e96904d9af0ec4a = $7435a4b2c8a749a5$export$6563a67224e7f879;
var $7435a4b2c8a749a5$export$ef565d07efe2b5e9 = {
    prefix: "far",
    iconName: "file-lines",
    icon: [
        384,
        512,
        [
            128441,
            128462,
            61686,
            "file-alt",
            "file-text"
        ],
        "f15c",
        "M64 464c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16H224v80c0 17.7 14.3 32 32 32h80V448c0 8.8-7.2 16-16 16H64zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V154.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0H64zm56 256c-13.3 0-24 10.7-24 24s10.7 24 24 24H264c13.3 0 24-10.7 24-24s-10.7-24-24-24H120zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24H264c13.3 0 24-10.7 24-24s-10.7-24-24-24H120z"
    ]
};
var $7435a4b2c8a749a5$export$243b47dca32bf0b8 = $7435a4b2c8a749a5$export$ef565d07efe2b5e9;
var $7435a4b2c8a749a5$export$f466100bf9bf37a5 = $7435a4b2c8a749a5$export$ef565d07efe2b5e9;
var $7435a4b2c8a749a5$export$31c6cf6f5d38dc0 = {
    prefix: "far",
    iconName: "calendar-days",
    icon: [
        448,
        512,
        [
            "calendar-alt"
        ],
        "f073",
        "M152 24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H64C28.7 64 0 92.7 0 128v16 48V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V192 144 128c0-35.3-28.7-64-64-64H344V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H152V24zM48 192h80v56H48V192zm0 104h80v64H48V296zm128 0h96v64H176V296zm144 0h80v64H320V296zm80-48H320V192h80v56zm0 160v40c0 8.8-7.2 16-16 16H320V408h80zm-128 0v56H176V408h96zm-144 0v56H64c-8.8 0-16-7.2-16-16V408h80zM272 248H176V192h96v56z"
    ]
};
var $7435a4b2c8a749a5$export$cbc139f33cff356 = $7435a4b2c8a749a5$export$31c6cf6f5d38dc0;
var $7435a4b2c8a749a5$export$f7bc8714c970afa4 = {
    prefix: "far",
    iconName: "hand-point-right",
    icon: [
        512,
        512,
        [],
        "f0a4",
        "M448 128l-177.6 0c1 5.2 1.6 10.5 1.6 16l0 16 32 0 144 0c8.8 0 16-7.2 16-16s-7.2-16-16-16zM224 144c0-17.7-14.3-32-32-32c0 0 0 0 0 0l-24 0c-66.3 0-120 53.7-120 120l0 48c0 52.5 33.7 97.1 80.7 113.4c-.5-3.1-.7-6.2-.7-9.4c0-20 9.2-37.9 23.6-49.7c-4.9-9-7.6-19.4-7.6-30.3c0-15.1 5.3-29 14-40c-8.8-11-14-24.9-14-40l0-40c0-13.3 10.7-24 24-24s24 10.7 24 24l0 40c0 8.8 7.2 16 16 16s16-7.2 16-16l0-40 0-40zM192 64s0 0 0 0c18 0 34.6 6 48 16l208 0c35.3 0 64 28.7 64 64s-28.7 64-64 64l-82 0c1.3 5.1 2 10.5 2 16c0 25.3-14.7 47.2-36 57.6c2.6 7 4 14.5 4 22.4c0 20-9.2 37.9-23.6 49.7c4.9 9 7.6 19.4 7.6 30.3c0 35.3-28.7 64-64 64l-64 0-24 0C75.2 448 0 372.8 0 280l0-48C0 139.2 75.2 64 168 64l24 0zm64 336c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0zm16-176c0 5.5-.7 10.9-2 16l2 0 32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0 0 16zm-24 64l-40 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-24 0z"
    ]
};
var $7435a4b2c8a749a5$export$e3c56ed54f074063 = {
    prefix: "far",
    iconName: "face-smile-beam",
    icon: [
        512,
        512,
        [
            128522,
            "smile-beam"
        ],
        "f5b8",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm177.6 62.1C192.8 334.5 218.8 352 256 352s63.2-17.5 78.4-33.9c9-9.7 24.2-10.4 33.9-1.4s10.4 24.2 1.4 33.9c-22 23.8-60 49.4-113.6 49.4s-91.7-25.5-113.6-49.4c-9-9.7-8.4-24.9 1.4-33.9s24.9-8.4 33.9 1.4zm40-89.3l0 0 0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0zm160 0l0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0 0 0z"
    ]
};
var $7435a4b2c8a749a5$export$54ada6dc9690e0ca = $7435a4b2c8a749a5$export$e3c56ed54f074063;
var $7435a4b2c8a749a5$export$1d1fbac384a76a12 = {
    prefix: "far",
    iconName: "face-grin-stars",
    icon: [
        512,
        512,
        [
            129321,
            "grin-stars"
        ],
        "f587",
        "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM183.2 132.6c-1.3-2.8-4.1-4.6-7.2-4.6s-5.9 1.8-7.2 4.6l-16.6 34.7-38.1 5c-3.1 .4-5.6 2.5-6.6 5.5s-.1 6.2 2.1 8.3l27.9 26.5-7 37.8c-.6 3 .7 6.1 3.2 7.9s5.8 2 8.5 .6L176 240.5l33.8 18.3c2.7 1.5 6 1.3 8.5-.6s3.7-4.9 3.2-7.9l-7-37.8L242.4 186c2.2-2.1 3.1-5.3 2.1-8.3s-3.5-5.1-6.6-5.5l-38.1-5-16.6-34.7zm160 0c-1.3-2.8-4.1-4.6-7.2-4.6s-5.9 1.8-7.2 4.6l-16.6 34.7-38.1 5c-3.1 .4-5.6 2.5-6.6 5.5s-.1 6.2 2.1 8.3l27.9 26.5-7 37.8c-.6 3 .7 6.1 3.2 7.9s5.8 2 8.5 .6L336 240.5l33.8 18.3c2.7 1.5 6 1.3 8.5-.6s3.7-4.9 3.2-7.9l-7-37.8L402.4 186c2.2-2.1 3.1-5.3 2.1-8.3s-3.5-5.1-6.6-5.5l-38.1-5-16.6-34.7zm6.3 175.8c-28.9 6.8-60.5 10.5-93.6 10.5s-64.7-3.7-93.6-10.5c-18.7-4.4-35.9 12-25.5 28.1c24.6 38.1 68.7 63.5 119.1 63.5s94.5-25.4 119.1-63.5c10.4-16.1-6.8-32.5-25.5-28.1z"
    ]
};
var $7435a4b2c8a749a5$export$64347a5c8c402ef4 = $7435a4b2c8a749a5$export$1d1fbac384a76a12;
var $7435a4b2c8a749a5$export$853fd1561789e3bb = {
    prefix: "far",
    iconName: "address-book",
    icon: [
        512,
        512,
        [
            62138,
            "contact-book"
        ],
        "f2b9",
        "M384 48c8.8 0 16 7.2 16 16V448c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16H384zM96 0C60.7 0 32 28.7 32 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H96zM240 256a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-32 32c-44.2 0-80 35.8-80 80c0 8.8 7.2 16 16 16H336c8.8 0 16-7.2 16-16c0-44.2-35.8-80-80-80H208zM512 80c0-8.8-7.2-16-16-16s-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V80zM496 192c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm16 144c0-8.8-7.2-16-16-16s-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V336z"
    ]
};
var $7435a4b2c8a749a5$export$594b5a5d4d2e156b = $7435a4b2c8a749a5$export$853fd1561789e3bb;
var $7435a4b2c8a749a5$export$932912e74adb8939 = {
    prefix: "far",
    iconName: "comments",
    icon: [
        640,
        512,
        [
            128490,
            61670
        ],
        "f086",
        "M88.2 309.1c9.8-18.3 6.8-40.8-7.5-55.8C59.4 230.9 48 204 48 176c0-63.5 63.8-128 160-128s160 64.5 160 128s-63.8 128-160 128c-13.1 0-25.8-1.3-37.8-3.6c-10.4-2-21.2-.6-30.7 4.2c-4.1 2.1-8.3 4.1-12.6 6c-16 7.2-32.9 13.5-49.9 18c2.8-4.6 5.4-9.1 7.9-13.6c1.1-1.9 2.2-3.9 3.2-5.9zM0 176c0 41.8 17.2 80.1 45.9 110.3c-.9 1.7-1.9 3.5-2.8 5.1c-10.3 18.4-22.3 36.5-36.6 52.1c-6.6 7-8.3 17.2-4.6 25.9C5.8 378.3 14.4 384 24 384c43 0 86.5-13.3 122.7-29.7c4.8-2.2 9.6-4.5 14.2-6.8c15.1 3 30.9 4.5 47.1 4.5c114.9 0 208-78.8 208-176S322.9 0 208 0S0 78.8 0 176zM432 480c16.2 0 31.9-1.6 47.1-4.5c4.6 2.3 9.4 4.6 14.2 6.8C529.5 498.7 573 512 616 512c9.6 0 18.2-5.7 22-14.5c3.8-8.8 2-19-4.6-25.9c-14.2-15.6-26.2-33.7-36.6-52.1c-.9-1.7-1.9-3.4-2.8-5.1C622.8 384.1 640 345.8 640 304c0-94.4-87.9-171.5-198.2-175.8c4.1 15.2 6.2 31.2 6.2 47.8l0 .6c87.2 6.7 144 67.5 144 127.4c0 28-11.4 54.9-32.7 77.2c-14.3 15-17.3 37.6-7.5 55.8c1.1 2 2.2 4 3.2 5.9c2.5 4.5 5.2 9 7.9 13.6c-17-4.5-33.9-10.7-49.9-18c-4.3-1.9-8.5-3.9-12.6-6c-9.5-4.8-20.3-6.2-30.7-4.2c-12.1 2.4-24.7 3.6-37.8 3.6c-61.7 0-110-26.5-136.8-62.3c-16 5.4-32.8 9.4-50 11.8C279 439.8 350 480 432 480z"
    ]
};
var $7435a4b2c8a749a5$export$6f95f90dd1f6d86b = {
    prefix: "far",
    iconName: "paste",
    icon: [
        512,
        512,
        [
            "file-clipboard"
        ],
        "f0ea",
        "M104.6 48H64C28.7 48 0 76.7 0 112V384c0 35.3 28.7 64 64 64h96V400H64c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16H80c0 17.7 14.3 32 32 32h72.4C202 108.4 227.6 96 256 96h62c-7.1-27.6-32.2-48-62-48H215.4C211.6 20.9 188.2 0 160 0s-51.6 20.9-55.4 48zM144 56a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM448 464H256c-8.8 0-16-7.2-16-16V192c0-8.8 7.2-16 16-16l140.1 0L464 243.9V448c0 8.8-7.2 16-16 16zM256 512H448c35.3 0 64-28.7 64-64V243.9c0-12.7-5.1-24.9-14.1-33.9l-67.9-67.9c-9-9-21.2-14.1-33.9-14.1H256c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64z"
    ]
};
var $7435a4b2c8a749a5$export$ca3229c47de163fa = $7435a4b2c8a749a5$export$6f95f90dd1f6d86b;
var $7435a4b2c8a749a5$export$8eee2c17ff89e724 = {
    prefix: "far",
    iconName: "face-grin-tongue-squint",
    icon: [
        512,
        512,
        [
            128541,
            "grin-tongue-squint"
        ],
        "f58a",
        "M464 256c0-114.9-93.1-208-208-208S48 141.1 48 256c0 81.7 47.1 152.4 115.7 186.4c-2.4-8.4-3.7-17.3-3.7-26.4V392.7c-24-17.5-43.1-41.4-54.8-69.2c-5-11.8 7-22.5 19.3-18.7c39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19c12.3-3.8 24.3 6.9 19.3 18.7c-11.8 28-31.1 52-55.4 69.6V416c0 9.2-1.3 18-3.7 26.4C416.9 408.4 464 337.7 464 256zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm116-98.9c0-9 9.6-14.7 17.5-10.5l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5c0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6zm262.5-10.5c7.9-4.2 17.5 1.5 17.5 10.5c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6c0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9zM320 416V378.6c0-14.7-11.9-26.6-26.6-26.6h-2c-11.3 0-21.1 7.9-23.6 18.9c-2.8 12.6-20.8 12.6-23.6 0c-2.5-11.1-12.3-18.9-23.6-18.9h-2c-14.7 0-26.6 11.9-26.6 26.6V416c0 35.3 28.7 64 64 64s64-28.7 64-64z"
    ]
};
var $7435a4b2c8a749a5$export$4edf34c3def09a31 = $7435a4b2c8a749a5$export$8eee2c17ff89e724;
var $7435a4b2c8a749a5$export$ba5dc4287853ecbd = {
    prefix: "far",
    iconName: "face-flushed",
    icon: [
        512,
        512,
        [
            128563,
            "flushed"
        ],
        "f579",
        "M464 256A208 208 0 1 1 48 256a208 208 0 1 1 416 0zM256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM160.4 248a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm216-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM192 336c-13.3 0-24 10.7-24 24s10.7 24 24 24H320c13.3 0 24-10.7 24-24s-10.7-24-24-24H192zM160 176a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 128a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm144-80a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm128 0a80 80 0 1 0 -160 0 80 80 0 1 0 160 0z"
    ]
};
var $7435a4b2c8a749a5$export$dfd2bd012685aeac = $7435a4b2c8a749a5$export$ba5dc4287853ecbd;
var $7435a4b2c8a749a5$export$5b1d41cdd118ea6d = {
    prefix: "far",
    iconName: "square-caret-right",
    icon: [
        448,
        512,
        [
            "caret-square-right"
        ],
        "f152",
        "M400 96c0-8.8-7.2-16-16-16L64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320zM384 32c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0zM320 256c0 6.7-2.8 13-7.7 17.6l-112 104c-7 6.5-17.2 8.2-25.9 4.4s-14.4-12.5-14.4-22l0-208c0-9.5 5.7-18.2 14.4-22s18.9-2.1 25.9 4.4l112 104c4.9 4.5 7.7 10.9 7.7 17.6z"
    ]
};
var $7435a4b2c8a749a5$export$ae86c9de7e0f62fa = $7435a4b2c8a749a5$export$5b1d41cdd118ea6d;
var $7435a4b2c8a749a5$export$814c9edba7b84aa4 = {
    prefix: "far",
    iconName: "square-minus",
    icon: [
        448,
        512,
        [
            61767,
            "minus-square"
        ],
        "f146",
        "M64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM152 232H296c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
    ]
};
var $7435a4b2c8a749a5$export$ffe9387966b3e681 = $7435a4b2c8a749a5$export$814c9edba7b84aa4;
var $7435a4b2c8a749a5$export$b4d344633433e50e = {
    prefix: "far",
    iconName: "compass",
    icon: [
        512,
        512,
        [
            129517
        ],
        "f14e",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm306.7 69.1L162.4 380.6c-19.4 7.5-38.5-11.6-31-31l55.5-144.3c3.3-8.5 9.9-15.1 18.4-18.4l144.3-55.5c19.4-7.5 38.5 11.6 31 31L325.1 306.7c-3.2 8.5-9.9 15.1-18.4 18.4zM288 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"
    ]
};
var $7435a4b2c8a749a5$export$a1ab39cd66c4e50e = {
    prefix: "far",
    iconName: "square-caret-down",
    icon: [
        448,
        512,
        [
            "caret-square-down"
        ],
        "f150",
        "M384 432c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0zm64-16c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320zM224 352c-6.7 0-13-2.8-17.6-7.7l-104-112c-6.5-7-8.2-17.2-4.4-25.9s12.5-14.4 22-14.4l208 0c9.5 0 18.2 5.7 22 14.4s2.1 18.9-4.4 25.9l-104 112c-4.5 4.9-10.9 7.7-17.6 7.7z"
    ]
};
var $7435a4b2c8a749a5$export$61aea18df1c84401 = $7435a4b2c8a749a5$export$a1ab39cd66c4e50e;
var $7435a4b2c8a749a5$export$eca99665af566fe1 = {
    prefix: "far",
    iconName: "face-kiss-beam",
    icon: [
        512,
        512,
        [
            128537,
            "kiss-beam"
        ],
        "f597",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm304.7 41.7c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4c-2.7 1.5-5.7 3-8.7 4.3c3.1 1.3 6 2.7 8.7 4.3c6.6 3.7 12.5 8.2 16.7 13.4c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4C274.7 427.1 257.4 432 240 432c-3.6 0-6.8-2.5-7.7-6s.6-7.2 3.8-9l0 0 0 0 0 0 0 0 .2-.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1c-.4-.2-.7-.4-.9-.5l-.2-.1 0 0 0 0 0 0c-2.5-1.4-4.1-4.1-4.1-7s1.6-5.6 4.1-7l0 0 0 0 0 0 0 0 0 0 .2-.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1c-.4-.2-.7-.4-.9-.5l-.2-.1 0 0 0 0 0 0c-3.2-1.8-4.7-5.5-3.8-9s4.1-6 7.7-6c17.4 0 34.7 4.9 47.9 12.3c6.6 3.7 12.5 8.2 16.7 13.4zm-87.1-68.9l0 0 0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0zm160 0l0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0 0 0z"
    ]
};
var $7435a4b2c8a749a5$export$d6ff8a73c0812e63 = $7435a4b2c8a749a5$export$eca99665af566fe1;
var $7435a4b2c8a749a5$export$1e80f89fe84a215b = {
    prefix: "far",
    iconName: "lightbulb",
    icon: [
        384,
        512,
        [
            128161
        ],
        "f0eb",
        "M297.2 248.9C311.6 228.3 320 203.2 320 176c0-70.7-57.3-128-128-128S64 105.3 64 176c0 27.2 8.4 52.3 22.8 72.9c3.7 5.3 8.1 11.3 12.8 17.7l0 0c12.9 17.7 28.3 38.9 39.8 59.8c10.4 19 15.7 38.8 18.3 57.5H109c-2.2-12-5.9-23.7-11.8-34.5c-9.9-18-22.2-34.9-34.5-51.8l0 0 0 0c-5.2-7.1-10.4-14.2-15.4-21.4C27.6 247.9 16 213.3 16 176C16 78.8 94.8 0 192 0s176 78.8 176 176c0 37.3-11.6 71.9-31.4 100.3c-5 7.2-10.2 14.3-15.4 21.4l0 0 0 0c-12.3 16.8-24.6 33.7-34.5 51.8c-5.9 10.8-9.6 22.5-11.8 34.5H226.4c2.6-18.7 7.9-38.6 18.3-57.5c11.5-20.9 26.9-42.1 39.8-59.8l0 0 0 0 0 0c4.7-6.4 9-12.4 12.7-17.7zM192 128c-26.5 0-48 21.5-48 48c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-44.2 35.8-80 80-80c8.8 0 16 7.2 16 16s-7.2 16-16 16zm0 384c-44.2 0-80-35.8-80-80V416H272v16c0 44.2-35.8 80-80 80z"
    ]
};
var $7435a4b2c8a749a5$export$6591b1ea509be9da = {
    prefix: "far",
    iconName: "flag",
    icon: [
        448,
        512,
        [
            127988,
            61725
        ],
        "f024",
        "M48 24C48 10.7 37.3 0 24 0S0 10.7 0 24V64 350.5 400v88c0 13.3 10.7 24 24 24s24-10.7 24-24V388l80.3-20.1c41.1-10.3 84.6-5.5 122.5 13.4c44.2 22.1 95.5 24.8 141.7 7.4l34.7-13c12.5-4.7 20.8-16.6 20.8-30V66.1c0-23-24.2-38-44.8-27.7l-9.6 4.8c-46.3 23.2-100.8 23.2-147.1 0c-35.1-17.6-75.4-22-113.5-12.5L48 52V24zm0 77.5l96.6-24.2c27-6.7 55.5-3.6 80.4 8.8c54.9 27.4 118.7 29.7 175 6.8V334.7l-24.4 9.1c-33.7 12.6-71.2 10.7-103.4-5.4c-48.2-24.1-103.3-30.1-155.6-17.1L48 338.5v-237z"
    ]
};
var $7435a4b2c8a749a5$export$5bb6a0c94ad2f4bb = {
    prefix: "far",
    iconName: "square-check",
    icon: [
        448,
        512,
        [
            9745,
            9989,
            61510,
            "check-square"
        ],
        "f14a",
        "M64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM337 209L209 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L303 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"
    ]
};
var $7435a4b2c8a749a5$export$f0c8040f596df7fe = $7435a4b2c8a749a5$export$5bb6a0c94ad2f4bb;
var $7435a4b2c8a749a5$export$aa13d9234890e8d3 = {
    prefix: "far",
    iconName: "circle-dot",
    icon: [
        512,
        512,
        [
            128280,
            "dot-circle"
        ],
        "f192",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256-96a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"
    ]
};
var $7435a4b2c8a749a5$export$92bc269cb244d66a = $7435a4b2c8a749a5$export$aa13d9234890e8d3;
var $7435a4b2c8a749a5$export$635e4d8cc8428961 = {
    prefix: "far",
    iconName: "face-dizzy",
    icon: [
        512,
        512,
        [
            "dizzy"
        ],
        "f567",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256 32a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM103 135c9.4-9.4 24.6-9.4 33.9 0l23 23 23-23c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-23 23 23 23c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-23-23-23 23c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l23-23-23-23c-9.4-9.4-9.4-24.6 0-33.9zm192 0c9.4-9.4 24.6-9.4 33.9 0l23 23 23-23c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-23 23 23 23c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-23-23-23 23c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l23-23-23-23c-9.4-9.4-9.4-24.6 0-33.9z"
    ]
};
var $7435a4b2c8a749a5$export$89a2b10dabc487e8 = $7435a4b2c8a749a5$export$635e4d8cc8428961;
var $7435a4b2c8a749a5$export$65a345b33858a655 = {
    prefix: "far",
    iconName: "futbol",
    icon: [
        512,
        512,
        [
            9917,
            "futbol-ball",
            "soccer-ball"
        ],
        "f1e3",
        "M435.4 361.3l-89.7-6c-5.2-.3-10.3 1.1-14.5 4.2s-7.2 7.4-8.4 12.5l-22 87.2c-14.4 3.2-29.4 4.8-44.8 4.8s-30.3-1.7-44.8-4.8l-22-87.2c-1.3-5-4.3-9.4-8.4-12.5s-9.3-4.5-14.5-4.2l-89.7 6C61.7 335.9 51.9 307 49 276.2L125 228.3c4.4-2.8 7.6-7 9.2-11.9s1.4-10.2-.5-15L100.4 118c19.9-22.4 44.6-40.5 72.4-52.7l69.1 57.6c4 3.3 9 5.1 14.1 5.1s10.2-1.8 14.1-5.1l69.1-57.6c27.8 12.2 52.5 30.3 72.4 52.7l-33.4 83.4c-1.9 4.8-2.1 10.1-.5 15s4.9 9.1 9.2 11.9L463 276.2c-3 30.8-12.7 59.7-27.6 85.1zM256 48l.9 0h-1.8l.9 0zM56.7 196.2c.9-3 1.9-6.1 2.9-9.1l-2.9 9.1zM132 423l3.8 2.7c-1.3-.9-2.5-1.8-3.8-2.7zm248.1-.1c-1.3 1-2.7 2-4 2.9l4-2.9zm75.2-226.6l-3-9.2c1.1 3 2.1 6.1 3 9.2zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm14.1-325.7c-8.4-6.1-19.8-6.1-28.2 0L194 221c-8.4 6.1-11.9 16.9-8.7 26.8l18.3 56.3c3.2 9.9 12.4 16.6 22.8 16.6h59.2c10.4 0 19.6-6.7 22.8-16.6l18.3-56.3c3.2-9.9-.3-20.7-8.7-26.8l-47.9-34.8z"
    ]
};
var $7435a4b2c8a749a5$export$51a344ca0a215620 = $7435a4b2c8a749a5$export$65a345b33858a655;
var $7435a4b2c8a749a5$export$f4a29712c724ba2d = $7435a4b2c8a749a5$export$65a345b33858a655;
var $7435a4b2c8a749a5$export$ba236543926e3569 = {
    prefix: "far",
    iconName: "pen-to-square",
    icon: [
        512,
        512,
        [
            "edit"
        ],
        "f044",
        "M441 58.9L453.1 71c9.4 9.4 9.4 24.6 0 33.9L424 134.1 377.9 88 407 58.9c9.4-9.4 24.6-9.4 33.9 0zM209.8 256.2L344 121.9 390.1 168 255.8 302.2c-2.9 2.9-6.5 5-10.4 6.1l-58.5 16.7 16.7-58.5c1.1-3.9 3.2-7.5 6.1-10.4zM373.1 25L175.8 222.2c-8.7 8.7-15 19.4-18.3 31.1l-28.6 100c-2.4 8.4-.1 17.4 6.1 23.6s15.2 8.5 23.6 6.1l100-28.6c11.8-3.4 22.5-9.7 31.1-18.3L487 138.9c28.1-28.1 28.1-73.7 0-101.8L474.9 25C446.8-3.1 401.2-3.1 373.1 25zM88 64C39.4 64 0 103.4 0 152V424c0 48.6 39.4 88 88 88H360c48.6 0 88-39.4 88-88V312c0-13.3-10.7-24-24-24s-24 10.7-24 24V424c0 22.1-17.9 40-40 40H88c-22.1 0-40-17.9-40-40V152c0-22.1 17.9-40 40-40H200c13.3 0 24-10.7 24-24s-10.7-24-24-24H88z"
    ]
};
var $7435a4b2c8a749a5$export$7be713e57d023733 = $7435a4b2c8a749a5$export$ba236543926e3569;
var $7435a4b2c8a749a5$export$703272eebf5e3eea = {
    prefix: "far",
    iconName: "hourglass-half",
    icon: [
        384,
        512,
        [
            "hourglass-2"
        ],
        "f252",
        "M0 24C0 10.7 10.7 0 24 0H360c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8V67c0 40.3-16 79-44.5 107.5L225.9 256l81.5 81.5C336 366 352 404.7 352 445v19h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h8V445c0-40.3 16-79 44.5-107.5L158.1 256 76.5 174.5C48 146 32 107.3 32 67V48H24C10.7 48 0 37.3 0 24zM110.5 371.5c-3.9 3.9-7.5 8.1-10.7 12.5H284.2c-3.2-4.4-6.8-8.6-10.7-12.5L192 289.9l-81.5 81.5zM284.2 128C297 110.4 304 89 304 67V48H80V67c0 22.1 7 43.4 19.8 61H284.2z"
    ]
};
var $7435a4b2c8a749a5$export$f1052bbf6bf361c0 = $7435a4b2c8a749a5$export$703272eebf5e3eea;
var $7435a4b2c8a749a5$export$ed3f2918429d029a = {
    prefix: "far",
    iconName: "eye-slash",
    icon: [
        640,
        512,
        [],
        "f070",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L525.6 386.7c39.6-40.6 66.4-86.1 79.9-118.4c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C465.5 68.8 400.8 32 320 32c-68.2 0-125 26.3-169.3 60.8L38.8 5.1zm151 118.3C226 97.7 269.5 80 320 80c65.2 0 118.8 29.6 159.9 67.7C518.4 183.5 545 226 558.6 256c-12.6 28-36.6 66.8-70.9 100.9l-53.8-42.2c9.1-17.6 14.2-37.5 14.2-58.7c0-70.7-57.3-128-128-128c-32.2 0-61.7 11.9-84.2 31.5l-46.1-36.1zM394.9 284.2l-81.5-63.9c4.2-8.5 6.6-18.2 6.6-28.3c0-5.5-.7-10.9-2-16c.7 0 1.3 0 2 0c44.2 0 80 35.8 80 80c0 9.9-1.8 19.4-5.1 28.2zm51.3 163.3l-41.9-33C378.8 425.4 350.7 432 320 432c-65.2 0-118.8-29.6-159.9-67.7C121.6 328.5 95 286 81.4 256c8.3-18.4 21.5-41.5 39.4-64.8L83.1 161.5C60.3 191.2 44 220.8 34.5 243.7c-3.3 7.9-3.3 16.7 0 24.6c14.9 35.7 46.2 87.7 93 131.1C174.5 443.2 239.2 480 320 480c47.8 0 89.9-12.9 126.2-32.5zm-88-69.3L302 334c-23.5-5.4-43.1-21.2-53.7-42.3l-56.1-44.2c-.2 2.8-.3 5.6-.3 8.5c0 70.7 57.3 128 128 128c13.3 0 26.1-2 38.2-5.8z"
    ]
};
var $7435a4b2c8a749a5$export$f69db0b876f7d753 = {
    prefix: "far",
    iconName: "hand",
    icon: [
        512,
        512,
        [
            129306,
            9995,
            "hand-paper"
        ],
        "f256",
        "M256 0c-25.3 0-47.2 14.7-57.6 36c-7-2.6-14.5-4-22.4-4c-35.3 0-64 28.7-64 64V261.5l-2.7-2.7c-25-25-65.5-25-90.5 0s-25 65.5 0 90.5L106.5 437c48 48 113.1 75 181 75H296h8c1.5 0 3-.1 4.5-.4c91.7-6.2 165-79.4 171.1-171.1c.3-1.5 .4-3 .4-4.5V160c0-35.3-28.7-64-64-64c-5.5 0-10.9 .7-16 2V96c0-35.3-28.7-64-64-64c-7.9 0-15.4 1.4-22.4 4C303.2 14.7 281.3 0 256 0zM240 96.1c0 0 0-.1 0-.1V64c0-8.8 7.2-16 16-16s16 7.2 16 16V95.9c0 0 0 .1 0 .1V232c0 13.3 10.7 24 24 24s24-10.7 24-24V96c0 0 0 0 0-.1c0-8.8 7.2-16 16-16s16 7.2 16 16v55.9c0 0 0 .1 0 .1v80c0 13.3 10.7 24 24 24s24-10.7 24-24V160.1c0 0 0-.1 0-.1c0-8.8 7.2-16 16-16s16 7.2 16 16V332.9c-.1 .6-.1 1.3-.2 1.9c-3.4 69.7-59.3 125.6-129 129c-.6 0-1.3 .1-1.9 .2H296h-8.5c-55.2 0-108.1-21.9-147.1-60.9L52.7 315.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L119 336.4c6.9 6.9 17.2 8.9 26.2 5.2s14.8-12.5 14.8-22.2V96c0-8.8 7.2-16 16-16c8.8 0 16 7.1 16 15.9V232c0 13.3 10.7 24 24 24s24-10.7 24-24V96.1z"
    ]
};
var $7435a4b2c8a749a5$export$6e6216c8b50471bb = $7435a4b2c8a749a5$export$f69db0b876f7d753;
var $7435a4b2c8a749a5$export$2262d6b626de1120 = {
    prefix: "far",
    iconName: "hand-spock",
    icon: [
        576,
        512,
        [
            128406
        ],
        "f259",
        "M170.2 80.8C161 47 180.8 12 214.6 2.4c34-9.6 69.4 10.2 79 44.2l30.3 107.1L337.1 84c6.6-34.7 40.1-57.5 74.8-50.9c31.4 6 53 33.9 52 64.9c10-2.6 20.8-2.8 31.5-.1c34.3 8.6 55.1 43.3 46.6 77.6L486.7 397.2C469.8 464.7 409.2 512 339.6 512c-11.2 0-22.5 0-33.7 0c-56.9 0-112.2-19-157.2-53.9l-92-71.6c-27.9-21.7-32.9-61.9-11.2-89.8s61.9-32.9 89.8-11.2l17 13.2L100.5 167.5c-13-32.9 3.2-70.1 36-83c11.1-4.4 22.7-5.4 33.7-3.7zm77.1-21.2c-2.4-8.5-11.2-13.4-19.7-11s-13.4 11.2-11 19.7l54.8 182.4c3.5 12.3-3.3 25.2-15.4 29.3s-25.3-2-30-13.9L174.9 138.1c-3.2-8.2-12.5-12.3-20.8-9s-12.3 12.5-9 20.8l73.3 185.6c12 30.3-23.7 57-49.4 37l-63.1-49.1c-7-5.4-17-4.2-22.5 2.8s-4.2 17 2.8 22.5l92 71.6c36.5 28.4 81.4 43.8 127.7 43.8c11.2 0 22.5 0 33.7 0c47.5 0 89-32.4 100.5-78.5l55.4-221.6c2.1-8.6-3.1-17.3-11.6-19.4s-17.3 3.1-19.4 11.6l-26 104C435.6 271.8 425 280 413 280c-16.5 0-28.9-15-25.8-31.2L415.7 99c1.7-8.7-4-17.1-12.7-18.7s-17.1 4-18.7 12.7L352.5 260c-2.2 11.6-12.4 20-24.2 20c-11 0-20.7-7.3-23.7-17.9L247.4 59.6z"
    ]
};
var $7435a4b2c8a749a5$export$5a54c83033a0a56a = {
    prefix: "far",
    iconName: "face-kiss",
    icon: [
        512,
        512,
        [
            128535,
            "kiss"
        ],
        "f596",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm304.7 25.7c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4c-2.7 1.5-5.7 3-8.7 4.3c3.1 1.3 6 2.7 8.7 4.3c6.6 3.7 12.5 8.2 16.7 13.4c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4C274.7 411.1 257.4 416 240 416c-3.6 0-6.8-2.5-7.7-6s.6-7.2 3.8-9l0 0 0 0 0 0 0 0 .2-.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1l-.8-.5-.1-.1-.2-.1 0 0 0 0 0 0c-2.5-1.4-4.1-4.1-4.1-7s1.6-5.6 4.1-7l0 0 0 0 0 0 0 0 0 0 .2-.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1c-.4-.2-.7-.4-.9-.5l-.2-.1 0 0 0 0 0 0c-3.2-1.8-4.7-5.5-3.8-9s4.1-6 7.7-6c17.4 0 34.7 4.9 47.9 12.3c6.6 3.7 12.5 8.2 16.7 13.4zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $7435a4b2c8a749a5$export$c762a77aabf64fd0 = $7435a4b2c8a749a5$export$5a54c83033a0a56a;
var $7435a4b2c8a749a5$export$95a7394c24f57943 = {
    prefix: "far",
    iconName: "face-grin-tongue",
    icon: [
        512,
        512,
        [
            128539,
            "grin-tongue"
        ],
        "f589",
        "M464 256c0-114.9-93.1-208-208-208S48 141.1 48 256c0 81.7 47.1 152.4 115.7 186.4c-2.4-8.4-3.7-17.3-3.7-26.4V363.6c-8.9-8-16.7-17.1-23.1-27.1c-10.4-16.1 6.8-32.5 25.5-28.1c28.9 6.8 60.5 10.5 93.6 10.5s64.7-3.7 93.6-10.5c18.7-4.4 35.9 12 25.5 28.1c-6.4 9.9-14.2 19-23 27V416c0 9.2-1.3 18-3.7 26.4C416.9 408.4 464 337.7 464 256zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm176.4-80a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM320 416V378.6c0-14.7-11.9-26.6-26.6-26.6h-2c-11.3 0-21.1 7.9-23.6 18.9c-2.8 12.6-20.8 12.6-23.6 0c-2.5-11.1-12.3-18.9-23.6-18.9h-2c-14.7 0-26.6 11.9-26.6 26.6V416c0 35.3 28.7 64 64 64s64-28.7 64-64z"
    ]
};
var $7435a4b2c8a749a5$export$ef222816a43a4b3a = $7435a4b2c8a749a5$export$95a7394c24f57943;
var $7435a4b2c8a749a5$export$a831eedd2f59c62f = {
    prefix: "far",
    iconName: "chess-bishop",
    icon: [
        320,
        512,
        [
            9821
        ],
        "f43a",
        "M104 0C90.7 0 80 10.7 80 24c0 11.2 7.6 20.6 18 23.2c-7.8 8-16.1 17-24.4 27C38.2 116.7 0 178.8 0 250.9c0 44.8 24.6 72.2 48 87.8V352H96V325c0-9-5-17.2-13-21.3c-18-9.3-35-24.7-35-52.7c0-55.5 29.8-106.8 62.4-145.9c16-19.2 32.1-34.8 44.2-45.5c1.9-1.7 3.7-3.2 5.3-4.6c1.7 1.4 3.4 3 5.3 4.6c12.1 10.7 28.2 26.3 44.2 45.5c5.3 6.3 10.5 13 15.5 20L159 191c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l57.8-57.8c12.8 25.9 21.2 54.3 21.2 83.8c0 28-17 43.4-35 52.7c-8 4.1-13 12.3-13 21.3v27h48V338.7c23.4-15.6 48-42.9 48-87.8c0-72.1-38.2-134.2-73.6-176.7c-8.3-9.9-16.6-19-24.4-27c10.3-2.7 18-12.1 18-23.2c0-13.3-10.7-24-24-24H160 104zM52.7 464l16.6-32H250.8l16.6 32H52.7zm207.9-80H59.5c-12 0-22.9 6.7-28.4 17.3L4.6 452.5c-3 5.8-4.6 12.2-4.6 18.7C0 493.8 18.2 512 40.8 512H279.2c22.5 0 40.8-18.2 40.8-40.8c0-6.5-1.6-12.9-4.6-18.7l-26.5-51.2c-5.5-10.6-16.5-17.3-28.4-17.3z"
    ]
};
var $7435a4b2c8a749a5$export$1dd161850c5bc64e = {
    prefix: "far",
    iconName: "face-grin-wink",
    icon: [
        512,
        512,
        [
            "grin-wink"
        ],
        "f58c",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm349.5 52.4c18.7-4.4 35.9 12 25.5 28.1C350.4 374.6 306.3 400 255.9 400s-94.5-25.4-119.1-63.5c-10.4-16.1 6.8-32.5 25.5-28.1c28.9 6.8 60.5 10.5 93.6 10.5s64.7-3.7 93.6-10.5zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm165.8 21.7c-7.6 8.1-20.2 8.5-28.3 .9s-8.5-20.2-.9-28.3c14.5-15.5 35.2-22.3 54.6-22.3s40.1 6.8 54.6 22.3c7.6 8.1 7.1 20.7-.9 28.3s-20.7 7.1-28.3-.9c-5.5-5.8-14.8-9.7-25.4-9.7s-19.9 3.8-25.4 9.7z"
    ]
};
var $7435a4b2c8a749a5$export$2397fcd34eb12177 = $7435a4b2c8a749a5$export$1dd161850c5bc64e;
var $7435a4b2c8a749a5$export$bdbabf493c478cde = {
    prefix: "far",
    iconName: "face-grin-wide",
    icon: [
        512,
        512,
        [
            128515,
            "grin-alt"
        ],
        "f581",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm349.5 52.4c18.7-4.4 35.9 12 25.5 28.1C350.4 374.6 306.3 400 255.9 400s-94.5-25.4-119.1-63.5c-10.4-16.1 6.8-32.5 25.5-28.1c28.9 6.8 60.5 10.5 93.6 10.5s64.7-3.7 93.6-10.5zM224 192c0 35.3-14.3 64-32 64s-32-28.7-32-64s14.3-64 32-64s32 28.7 32 64zm96 64c-17.7 0-32-28.7-32-64s14.3-64 32-64s32 28.7 32 64s-14.3 64-32 64z"
    ]
};
var $7435a4b2c8a749a5$export$b4abebfe416d36ba = $7435a4b2c8a749a5$export$bdbabf493c478cde;
var $7435a4b2c8a749a5$export$c8a28356e07b9ccb = {
    prefix: "far",
    iconName: "face-frown-open",
    icon: [
        512,
        512,
        [
            128550,
            "frown-open"
        ],
        "f57a",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM182.4 382.5c-12.4 5.2-26.5-4.1-21.1-16.4c16-36.6 52.4-62.1 94.8-62.1s78.8 25.6 94.8 62.1c5.4 12.3-8.7 21.6-21.1 16.4c-22.4-9.5-47.4-14.8-73.7-14.8s-51.3 5.3-73.7 14.8zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $7435a4b2c8a749a5$export$c4775e66bed5d96 = $7435a4b2c8a749a5$export$c8a28356e07b9ccb;
var $7435a4b2c8a749a5$export$cdc9f5e7e94e76da = {
    prefix: "far",
    iconName: "hand-point-up",
    icon: [
        384,
        512,
        [
            9757
        ],
        "f0a6",
        "M64 64V241.6c5.2-1 10.5-1.6 16-1.6H96V208 64c0-8.8-7.2-16-16-16s-16 7.2-16 16zM80 288c-17.7 0-32 14.3-32 32c0 0 0 0 0 0v24c0 66.3 53.7 120 120 120h48c52.5 0 97.1-33.7 113.4-80.7c-3.1 .5-6.2 .7-9.4 .7c-20 0-37.9-9.2-49.7-23.6c-9 4.9-19.4 7.6-30.3 7.6c-15.1 0-29-5.3-40-14c-11 8.8-24.9 14-40 14H120c-13.3 0-24-10.7-24-24s10.7-24 24-24h40c8.8 0 16-7.2 16-16s-7.2-16-16-16H120 80zM0 320s0 0 0 0c0-18 6-34.6 16-48V64C16 28.7 44.7 0 80 0s64 28.7 64 64v82c5.1-1.3 10.5-2 16-2c25.3 0 47.2 14.7 57.6 36c7-2.6 14.5-4 22.4-4c20 0 37.9 9.2 49.7 23.6c9-4.9 19.4-7.6 30.3-7.6c35.3 0 64 28.7 64 64v64 24c0 92.8-75.2 168-168 168H168C75.2 512 0 436.8 0 344V320zm336-64c0-8.8-7.2-16-16-16s-16 7.2-16 16v48 16c0 8.8 7.2 16 16 16s16-7.2 16-16V256zM160 240c5.5 0 10.9 .7 16 2v-2V208c0-8.8-7.2-16-16-16s-16 7.2-16 16v32h16zm64 24v40c0 8.8 7.2 16 16 16s16-7.2 16-16V256 240c0-8.8-7.2-16-16-16s-16 7.2-16 16v24z"
    ]
};
var $7435a4b2c8a749a5$export$4ed9da5c3cca0ef1 = {
    prefix: "far",
    iconName: "bookmark",
    icon: [
        384,
        512,
        [
            128278,
            61591
        ],
        "f02e",
        "M0 48C0 21.5 21.5 0 48 0l0 48V441.4l130.1-92.9c8.3-6 19.6-6 27.9 0L336 441.4V48H48V0H336c26.5 0 48 21.5 48 48V488c0 9-5 17.2-13 21.3s-17.6 3.4-24.9-1.8L192 397.5 37.9 507.5c-7.3 5.2-16.9 5.9-24.9 1.8S0 497 0 488V48z"
    ]
};
var $7435a4b2c8a749a5$export$f6dcbf0a940428f4 = {
    prefix: "far",
    iconName: "hand-point-down",
    icon: [
        384,
        512,
        [],
        "f0a7",
        "M64 448l0-177.6c5.2 1 10.5 1.6 16 1.6l16 0 0 32 0 144c0 8.8-7.2 16-16 16s-16-7.2-16-16zM80 224c-17.7 0-32-14.3-32-32c0 0 0 0 0 0l0-24c0-66.3 53.7-120 120-120l48 0c52.5 0 97.1 33.7 113.4 80.7c-3.1-.5-6.2-.7-9.4-.7c-20 0-37.9 9.2-49.7 23.6c-9-4.9-19.4-7.6-30.3-7.6c-15.1 0-29 5.3-40 14c-11-8.8-24.9-14-40-14l-40 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l40 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-40 0-40 0zM0 192s0 0 0 0c0 18 6 34.6 16 48l0 208c0 35.3 28.7 64 64 64s64-28.7 64-64l0-82c5.1 1.3 10.5 2 16 2c25.3 0 47.2-14.7 57.6-36c7 2.6 14.5 4 22.4 4c20 0 37.9-9.2 49.7-23.6c9 4.9 19.4 7.6 30.3 7.6c35.3 0 64-28.7 64-64l0-64 0-24C384 75.2 308.8 0 216 0L168 0C75.2 0 0 75.2 0 168l0 24zm336 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48 0-16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 64zM160 272c5.5 0 10.9-.7 16-2l0 2 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32 16 0zm64-24l0-40c0-8.8 7.2-16 16-16s16 7.2 16 16l0 48 0 16c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-24z"
    ]
};
var $7435a4b2c8a749a5$export$72b780186370e953 = {
    prefix: "far",
    iconName: "folder",
    icon: [
        512,
        512,
        [
            128193,
            128447,
            61716,
            "folder-blank"
        ],
        "f07b",
        "M0 96C0 60.7 28.7 32 64 32H196.1c19.1 0 37.4 7.6 50.9 21.1L289.9 96H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H448c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16H286.6c-10.6 0-20.8-4.2-28.3-11.7L213.1 87c-4.5-4.5-10.6-7-17-7H64z"
    ]
};
var $7435a4b2c8a749a5$export$9ef114244d26da0 = $7435a4b2c8a749a5$export$72b780186370e953;
var $7435a4b2c8a749a5$export$f5699fa0844e0188 = {
    prefix: "far",
    iconName: "user",
    icon: [
        448,
        512,
        [
            128100,
            62144
        ],
        "f007",
        "M304 128a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM49.3 464H398.7c-8.9-63.3-63.3-112-129-112H178.3c-65.7 0-120.1 48.7-129 112zM0 482.3C0 383.8 79.8 304 178.3 304h91.4C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3z"
    ]
};
var $7435a4b2c8a749a5$export$2c5163541229363 = {
    prefix: "far",
    iconName: "square-caret-left",
    icon: [
        448,
        512,
        [
            "caret-square-left"
        ],
        "f191",
        "M48 416c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80c-8.8 0-16 7.2-16 16l0 320zm16 64c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480zm64-224c0-6.7 2.8-13 7.7-17.6l112-104c7-6.5 17.2-8.2 25.9-4.4s14.4 12.5 14.4 22l0 208c0 9.5-5.7 18.2-14.4 22s-18.9 2.1-25.9-4.4l-112-104c-4.9-4.5-7.7-10.9-7.7-17.6z"
    ]
};
var $7435a4b2c8a749a5$export$d0c8ba444f1f9581 = $7435a4b2c8a749a5$export$2c5163541229363;
var $7435a4b2c8a749a5$export$a3b0eb2cd7942125 = {
    prefix: "far",
    iconName: "star",
    icon: [
        576,
        512,
        [
            11088,
            61446
        ],
        "f005",
        "M287.9 0c9.2 0 17.6 5.2 21.6 13.5l68.6 141.3 153.2 22.6c9 1.3 16.5 7.6 19.3 16.3s.5 18.1-5.9 24.5L433.6 328.4l26.2 155.6c1.5 9-2.2 18.1-9.7 23.5s-17.3 6-25.3 1.7l-137-73.2L151 509.1c-8.1 4.3-17.9 3.7-25.3-1.7s-11.2-14.5-9.7-23.5l26.2-155.6L31.1 218.2c-6.5-6.4-8.7-15.9-5.9-24.5s10.3-14.9 19.3-16.3l153.2-22.6L266.3 13.5C270.4 5.2 278.7 0 287.9 0zm0 79L235.4 187.2c-3.5 7.1-10.2 12.1-18.1 13.3L99 217.9 184.9 303c5.5 5.5 8.1 13.3 6.8 21L171.4 443.7l105.2-56.2c7.1-3.8 15.6-3.8 22.6 0l105.2 56.2L384.2 324.1c-1.3-7.7 1.2-15.5 6.8-21l85.9-85.1L358.6 200.5c-7.8-1.2-14.6-6.1-18.1-13.3L287.9 79z"
    ]
};
var $7435a4b2c8a749a5$export$861b1f13085cf122 = {
    prefix: "far",
    iconName: "chess-knight",
    icon: [
        448,
        512,
        [
            9822
        ],
        "f441",
        "M226.6 48H117.3l17.1 12.8c6 4.5 9.6 11.6 9.6 19.2s-3.6 14.7-9.6 19.2l-6.5 4.9c-10 7.5-16 19.3-16 31.9l-.3 91c0 10.2 4.9 19.9 13.2 25.8l1.9 1.3c9.9 7.1 23.3 7 33.2-.1l49.9-36.3c10.7-7.8 25.7-5.4 33.5 5.3s5.4 25.7-5.3 33.5l-49.9 36.3-53.8 39.1c-7.3 5.3-13 12.2-16.9 20.1H66.8c5.3-22.1 17.8-41.9 35.9-56.3c-1.3-.8-2.6-1.7-3.8-2.6L97 291.8c-21-15-33.4-39.2-33.3-65l.3-91c.1-19.8 6.7-38.7 18.6-53.9l-.4-.3C70.7 73 64 59.6 64 45.3C64 20.3 84.3 0 109.3 0H226.6C331.2 0 416 84.8 416 189.4c0 11.1-1 22.2-2.9 33.2L390.1 352H341.3l24.5-137.8c1.5-8.2 2.2-16.5 2.2-24.8C368 111.3 304.7 48 226.6 48zM85.2 432L68.7 464H379.3l-16.6-32H85.2zm315.7-30.7l26.5 51.2c3 5.8 4.6 12.2 4.6 18.7c0 22.5-18.2 40.8-40.8 40.8H56.8C34.2 512 16 493.8 16 471.2c0-6.5 1.6-12.9 4.6-18.7l26.5-51.2C52.5 390.7 63.5 384 75.5 384h297c12 0 22.9 6.7 28.4 17.3zM172 128a20 20 0 1 1 0 40 20 20 0 1 1 0-40z"
    ]
};
var $7435a4b2c8a749a5$export$67ca89c1ca38d559 = {
    prefix: "far",
    iconName: "face-laugh-squint",
    icon: [
        512,
        512,
        [
            "laugh-squint"
        ],
        "f59b",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm130.7 57.9c-4.2-13.6 7.1-25.9 21.3-25.9H364.5c14.2 0 25.5 12.4 21.3 25.9C369 368.4 318.2 408 258.2 408s-110.8-39.6-127.5-94.1zm2.8-183.3l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5c0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6c0-9 9.6-14.7 17.5-10.5zM396 141.1c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6c0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9c7.9-4.2 17.5 1.5 17.5 10.5z"
    ]
};
var $7435a4b2c8a749a5$export$b206e700cf7084e1 = $7435a4b2c8a749a5$export$67ca89c1ca38d559;
var $7435a4b2c8a749a5$export$2f203616c892d415 = {
    prefix: "far",
    iconName: "face-laugh",
    icon: [
        512,
        512,
        [
            "laugh"
        ],
        "f599",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm130.7 57.9c-4.2-13.6 7.1-25.9 21.3-25.9H364.5c14.2 0 25.5 12.4 21.3 25.9C369 368.4 318.2 408 258.2 408s-110.8-39.6-127.5-94.1zM144.4 192a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $7435a4b2c8a749a5$export$6c74e314e801a4fe = $7435a4b2c8a749a5$export$2f203616c892d415;
var $7435a4b2c8a749a5$export$ff7e93418af88b78 = {
    prefix: "far",
    iconName: "folder-open",
    icon: [
        576,
        512,
        [
            128194,
            128449,
            61717
        ],
        "f07c",
        "M384 480h48c11.4 0 21.9-6 27.6-15.9l112-192c5.8-9.9 5.8-22.1 .1-32.1S555.5 224 544 224H144c-11.4 0-21.9 6-27.6 15.9L48 357.1V96c0-8.8 7.2-16 16-16H181.5c4.2 0 8.3 1.7 11.3 4.7l26.5 26.5c21 21 49.5 32.8 79.2 32.8H416c8.8 0 16 7.2 16 16v32h48V160c0-35.3-28.7-64-64-64H298.5c-17 0-33.3-6.7-45.3-18.7L226.7 50.7c-12-12-28.3-18.7-45.3-18.7H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H87.7 384z"
    ]
};
var $7435a4b2c8a749a5$export$97d84347d71ba297 = {
    prefix: "far",
    iconName: "clipboard",
    icon: [
        384,
        512,
        [
            128203
        ],
        "f328",
        "M280 64h40c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128C0 92.7 28.7 64 64 64h40 9.6C121 27.5 153.3 0 192 0s71 27.5 78.4 64H280zM64 112c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16H320c8.8 0 16-7.2 16-16V128c0-8.8-7.2-16-16-16H304v24c0 13.3-10.7 24-24 24H192 104c-13.3 0-24-10.7-24-24V112H64zm128-8a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
    ]
};
var $7435a4b2c8a749a5$export$7b8ce73615739d30 = {
    prefix: "far",
    iconName: "chess-queen",
    icon: [
        512,
        512,
        [
            9819
        ],
        "f445",
        "M256 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-95.2-8c-18.1 0-31.3 12.8-35.6 26.9c-8 26.2-32.4 45.2-61.2 45.2c-10 0-19.4-2.3-27.7-6.3c-7.6-3.7-16.7-3.3-24 1.2C.7 162.1-3.1 177.1 3.7 188.9L97.6 352H153l-83-144.1c40.5-2.2 75.3-25.9 93.1-59.8c22 26.8 55.4 43.9 92.8 43.9s70.8-17.1 92.8-43.9c17.8 34 52.6 57.7 93.1 59.8L359 352h55.4l93.9-163.1c6.8-11.7 3-26.7-8.6-33.8c-7.3-4.5-16.4-4.9-24-1.2c-8.4 4-17.7 6.3-27.7 6.3c-28.8 0-53.2-19-61.2-45.2C382.5 100.8 369.3 88 351.2 88c-14.5 0-26.3 8.5-32.4 19.3c-12.4 22-35.9 36.7-62.8 36.7s-50.4-14.8-62.8-36.7C187.1 96.5 175.4 88 160.8 88zM133.2 432H378.8l16.6 32H116.7l16.6-32zm283.7-30.7c-5.5-10.6-16.5-17.3-28.4-17.3h-265c-12 0-22.9 6.7-28.4 17.3L68.6 452.5c-3 5.8-4.6 12.2-4.6 18.7c0 22.5 18.2 40.8 40.8 40.8H407.2c22.5 0 40.8-18.2 40.8-40.8c0-6.5-1.6-12.9-4.6-18.7l-26.5-51.2z"
    ]
};
var $7435a4b2c8a749a5$export$be38a892fe9b4098 = {
    prefix: "far",
    iconName: "hand-back-fist",
    icon: [
        448,
        512,
        [
            "hand-rock"
        ],
        "f255",
        "M144 64c0-8.8 7.2-16 16-16s16 7.2 16 16c0 9.1 5.1 17.4 13.3 21.5s17.9 3.2 25.1-2.3c2.7-2 6-3.2 9.6-3.2c8.8 0 16 7.2 16 16c0 9.1 5.1 17.4 13.3 21.5s17.9 3.2 25.1-2.3c2.7-2 6-3.2 9.6-3.2c8.8 0 16 7.2 16 16c0 9.1 5.1 17.4 13.3 21.5s17.9 3.2 25.1-2.3c2.7-2 6-3.2 9.6-3.2c8.8 0 16 7.2 16 16V264c0 31.3-20 58-48 67.9c-9.6 3.4-16 12.5-16 22.6V488c0 13.3 10.7 24 24 24s24-10.7 24-24V370.2c38-20.1 64-60.1 64-106.2V160c0-35.3-28.7-64-64-64c-2.8 0-5.6 .2-8.3 .5C332.8 77.1 311.9 64 288 64c-2.8 0-5.6 .2-8.3 .5C268.8 45.1 247.9 32 224 32c-2.8 0-5.6 .2-8.3 .5C204.8 13.1 183.9 0 160 0C124.7 0 96 28.7 96 64v64.3c-11.7 7.4-22.5 16.4-32 26.9l17.8 16.1L64 155.2l-9.4 10.5C40 181.8 32 202.8 32 224.6v12.8c0 49.6 24.2 96.1 64.8 124.5l13.8-19.7L96.8 361.9l8.9 6.2c6.9 4.8 14.4 8.6 22.3 11.3V488c0 13.3 10.7 24 24 24s24-10.7 24-24V359.9c0-12.6-9.8-23.1-22.4-23.9c-7.3-.5-14.3-2.9-20.3-7.1l-13.1 18.7 13.1-18.7-8.9-6.2C96.6 303.1 80 271.3 80 237.4V224.6c0-9.9 3.7-19.4 10.3-26.8l9.4-10.5c3.8-4.2 7.9-8.1 12.3-11.6V208c0 8.8 7.2 16 16 16s16-7.2 16-16V142.3 128 64z"
    ]
};
var $7435a4b2c8a749a5$export$97a81eba394c8c44 = $7435a4b2c8a749a5$export$be38a892fe9b4098;
var $7435a4b2c8a749a5$export$66068918abb14406 = {
    prefix: "far",
    iconName: "square-caret-up",
    icon: [
        448,
        512,
        [
            "caret-square-up"
        ],
        "f151",
        "M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm224 64c6.7 0 13 2.8 17.6 7.7l104 112c6.5 7 8.2 17.2 4.4 25.9s-12.5 14.4-22 14.4l-208 0c-9.5 0-18.2-5.7-22-14.4s-2.1-18.9 4.4-25.9l104-112c4.5-4.9 10.9-7.7 17.6-7.7z"
    ]
};
var $7435a4b2c8a749a5$export$307ae80b26533ce5 = $7435a4b2c8a749a5$export$66068918abb14406;
var $7435a4b2c8a749a5$export$b532f5d25de97633 = {
    prefix: "far",
    iconName: "chart-bar",
    icon: [
        512,
        512,
        [
            "bar-chart"
        ],
        "f080",
        "M24 32c13.3 0 24 10.7 24 24V408c0 13.3 10.7 24 24 24H488c13.3 0 24 10.7 24 24s-10.7 24-24 24H72c-39.8 0-72-32.2-72-72V56C0 42.7 10.7 32 24 32zM128 136c0-13.3 10.7-24 24-24l208 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-208 0c-13.3 0-24-10.7-24-24zm24 72H296c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 96H424c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
    ]
};
var $7435a4b2c8a749a5$export$2d5f754a5e5738b = $7435a4b2c8a749a5$export$b532f5d25de97633;
var $7435a4b2c8a749a5$export$eccfff9bfd585652 = {
    prefix: "far",
    iconName: "window-restore",
    icon: [
        512,
        512,
        [],
        "f2d2",
        "M432 48H208c-17.7 0-32 14.3-32 32V96H128V80c0-44.2 35.8-80 80-80H432c44.2 0 80 35.8 80 80V304c0 44.2-35.8 80-80 80H416V336h16c17.7 0 32-14.3 32-32V80c0-17.7-14.3-32-32-32zM48 448c0 8.8 7.2 16 16 16H320c8.8 0 16-7.2 16-16V256H48V448zM64 128H320c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192c0-35.3 28.7-64 64-64z"
    ]
};
var $7435a4b2c8a749a5$export$eaf727acca5a35e4 = {
    prefix: "far",
    iconName: "square-plus",
    icon: [
        448,
        512,
        [
            61846,
            "plus-square"
        ],
        "f0fe",
        "M64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM200 344V280H136c-13.3 0-24-10.7-24-24s10.7-24 24-24h64V168c0-13.3 10.7-24 24-24s24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H248v64c0 13.3-10.7 24-24 24s-24-10.7-24-24z"
    ]
};
var $7435a4b2c8a749a5$export$b6359eebfe900c35 = $7435a4b2c8a749a5$export$eaf727acca5a35e4;
var $7435a4b2c8a749a5$export$7e9f0928967e03b = {
    prefix: "far",
    iconName: "image",
    icon: [
        512,
        512,
        [],
        "f03e",
        "M448 80c8.8 0 16 7.2 16 16V415.8l-5-6.5-136-176c-4.5-5.9-11.6-9.3-19-9.3s-14.4 3.4-19 9.3L202 340.7l-30.5-42.7C167 291.7 159.8 288 152 288s-15 3.7-19.5 10.1l-80 112L48 416.3l0-.3V96c0-8.8 7.2-16 16-16H448zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm80 192a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"
    ]
};
var $7435a4b2c8a749a5$export$5e30548b7f8eeb95 = {
    prefix: "far",
    iconName: "folder-closed",
    icon: [
        512,
        512,
        [],
        "e185",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H289.9L247 53.1C233.5 39.6 215.2 32 196.1 32H64zM48 96c0-8.8 7.2-16 16-16H196.1c6.4 0 12.5 2.5 17 7l45.3 45.3c7.5 7.5 17.7 11.7 28.3 11.7H448c8.8 0 16 7.2 16 16v32H48V96zm0 144H464V416c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V240z"
    ]
};
var $7435a4b2c8a749a5$export$4fbda8f64648f3b5 = {
    prefix: "far",
    iconName: "lemon",
    icon: [
        448,
        512,
        [
            127819
        ],
        "f094",
        "M368 80c-3.2 0-6.2 .4-8.9 1.3C340 86.8 313 91.9 284.8 84.6C227.4 69.7 160.2 92 110.1 142.1S37.7 259.4 52.6 316.8c7.3 28.2 2.2 55.2-3.3 74.3c-.8 2.8-1.3 5.8-1.3 8.9c0 17.7 14.3 32 32 32c3.2 0 6.2-.4 8.9-1.3c19.1-5.5 46.1-10.7 74.3-3.3c57.4 14.9 124.6-7.4 174.7-57.5s72.4-117.3 57.5-174.7c-7.3-28.2-2.2-55.2 3.3-74.3c.8-2.8 1.3-5.8 1.3-8.9c0-17.7-14.3-32-32-32zm0-48c44.2 0 80 35.8 80 80c0 7.7-1.1 15.2-3.1 22.3c-4.6 15.8-7.1 32.9-3 48.9c20.1 77.6-10.9 161.5-70 220.7s-143.1 90.2-220.7 70c-16-4.1-33-1.6-48.9 3c-7.1 2-14.6 3.1-22.3 3.1c-44.2 0-80-35.8-80-80c0-7.7 1.1-15.2 3.1-22.3c4.6-15.8 7.1-32.9 3-48.9C-14 251.3 17 167.3 76.2 108.2S219.3 18 296.8 38.1c16 4.1 33 1.6 48.9-3c7.1-2 14.6-3.1 22.3-3.1zM246.7 167c-52 15.2-96.5 59.7-111.7 111.7c-3.7 12.7-17.1 20-29.8 16.3s-20-17.1-16.3-29.8c19.8-67.7 76.6-124.5 144.3-144.3c12.7-3.7 26.1 3.6 29.8 16.3s-3.6 26.1-16.3 29.8z"
    ]
};
var $7435a4b2c8a749a5$export$b4c63e9bfc7906f1 = {
    prefix: "far",
    iconName: "handshake",
    icon: [
        640,
        512,
        [],
        "f2b5",
        "M272.2 64.6l-51.1 51.1c-15.3 4.2-29.5 11.9-41.5 22.5L153 161.9C142.8 171 129.5 176 115.8 176H96V304c20.4 .6 39.8 8.9 54.3 23.4l35.6 35.6 7 7 0 0L219.9 397c6.2 6.2 16.4 6.2 22.6 0c1.7-1.7 3-3.7 3.7-5.8c2.8-7.7 9.3-13.5 17.3-15.3s16.4 .6 22.2 6.5L296.5 393c11.6 11.6 30.4 11.6 41.9 0c5.4-5.4 8.3-12.3 8.6-19.4c.4-8.8 5.6-16.6 13.6-20.4s17.3-3 24.4 2.1c9.4 6.7 22.5 5.8 30.9-2.6c9.4-9.4 9.4-24.6 0-33.9L340.1 243l-35.8 33c-27.3 25.2-69.2 25.6-97 .9c-31.7-28.2-32.4-77.4-1.6-106.5l70.1-66.2C303.2 78.4 339.4 64 377.1 64c36.1 0 71 13.3 97.9 37.2L505.1 128H544h40 40c8.8 0 16 7.2 16 16V352c0 17.7-14.3 32-32 32H576c-11.8 0-22.2-6.4-27.7-16H463.4c-3.4 6.7-7.9 13.1-13.5 18.7c-17.1 17.1-40.8 23.8-63 20.1c-3.6 7.3-8.5 14.1-14.6 20.2c-27.3 27.3-70 30-100.4 8.1c-25.1 20.8-62.5 19.5-86-4.1L159 404l-7-7-35.6-35.6c-5.5-5.5-12.7-8.7-20.4-9.3C96 369.7 81.6 384 64 384H32c-17.7 0-32-14.3-32-32V144c0-8.8 7.2-16 16-16H56 96h19.8c2 0 3.9-.7 5.3-2l26.5-23.6C175.5 77.7 211.4 64 248.7 64H259c4.4 0 8.9 .2 13.2 .6zM544 320V176H496c-5.9 0-11.6-2.2-15.9-6.1l-36.9-32.8c-18.2-16.2-41.7-25.1-66.1-25.1c-25.4 0-49.8 9.7-68.3 27.1l-70.1 66.2c-10.3 9.8-10.1 26.3 .5 35.7c9.3 8.3 23.4 8.1 32.5-.3l71.9-66.4c9.7-9 24.9-8.4 33.9 1.4s8.4 24.9-1.4 33.9l-.8 .8 74.4 74.4c10 10 16.5 22.3 19.4 35.1H544zM64 336a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm528 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"
    ]
};
var $7435a4b2c8a749a5$export$31ee86ac717db552 = {
    prefix: "far",
    iconName: "gem",
    icon: [
        512,
        512,
        [
            128142
        ],
        "f3a5",
        "M168.5 72L256 165l87.5-93h-175zM383.9 99.1L311.5 176h129L383.9 99.1zm50 124.9H256 78.1L256 420.3 433.9 224zM71.5 176h129L128.1 99.1 71.5 176zm434.3 40.1l-232 256c-4.5 5-11 7.9-17.8 7.9s-13.2-2.9-17.8-7.9l-232-256c-7.7-8.5-8.3-21.2-1.5-30.4l112-152c4.5-6.1 11.7-9.8 19.3-9.8H376c7.6 0 14.8 3.6 19.3 9.8l112 152c6.8 9.2 6.1 21.9-1.5 30.4z"
    ]
};
var $7435a4b2c8a749a5$export$86c4e45dc3302d15 = {
    prefix: "far",
    iconName: "circle-play",
    icon: [
        512,
        512,
        [
            61469,
            "play-circle"
        ],
        "f144",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM188.3 147.1c7.6-4.2 16.8-4.1 24.3 .5l144 88c7.1 4.4 11.5 12.1 11.5 20.5s-4.4 16.1-11.5 20.5l-144 88c-7.4 4.5-16.7 4.7-24.3 .5s-12.3-12.2-12.3-20.9V168c0-8.7 4.7-16.7 12.3-20.9z"
    ]
};
var $7435a4b2c8a749a5$export$cf04333781061c5e = $7435a4b2c8a749a5$export$86c4e45dc3302d15;
var $7435a4b2c8a749a5$export$c2e9877668862374 = {
    prefix: "far",
    iconName: "circle-check",
    icon: [
        512,
        512,
        [
            61533,
            "check-circle"
        ],
        "f058",
        "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L369 209z"
    ]
};
var $7435a4b2c8a749a5$export$be9e388158c74f29 = $7435a4b2c8a749a5$export$c2e9877668862374;
var $7435a4b2c8a749a5$export$229de76dfef2687f = {
    prefix: "far",
    iconName: "circle-stop",
    icon: [
        512,
        512,
        [
            62094,
            "stop-circle"
        ],
        "f28d",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm192-96H320c17.7 0 32 14.3 32 32V320c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V192c0-17.7 14.3-32 32-32z"
    ]
};
var $7435a4b2c8a749a5$export$47af2aad60ab3e7c = $7435a4b2c8a749a5$export$229de76dfef2687f;
var $7435a4b2c8a749a5$export$a75288855ea05282 = {
    prefix: "far",
    iconName: "id-badge",
    icon: [
        384,
        512,
        [],
        "f2c1",
        "M256 48V64c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32V48H64c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16H320c8.8 0 16-7.2 16-16V64c0-8.8-7.2-16-16-16H256zM0 64C0 28.7 28.7 0 64 0H320c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM160 320h64c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80zm-32-96a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z"
    ]
};
var $7435a4b2c8a749a5$export$3f2d51c0547bf984 = {
    prefix: "far",
    iconName: "face-laugh-beam",
    icon: [
        512,
        512,
        [
            128513,
            "laugh-beam"
        ],
        "f59a",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm130.7 57.9c-4.2-13.6 7.1-25.9 21.3-25.9H364.5c14.2 0 25.5 12.4 21.3 25.9C369 368.4 318.2 408 258.2 408s-110.8-39.6-127.5-94.1zm86.9-85.1l0 0 0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0zm160 0l0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0 0 0z"
    ]
};
var $7435a4b2c8a749a5$export$a88d1f4073ea9369 = $7435a4b2c8a749a5$export$3f2d51c0547bf984;
var $7435a4b2c8a749a5$export$5f519e9ac15ab8c3 = {
    prefix: "far",
    iconName: "registered",
    icon: [
        512,
        512,
        [
            174
        ],
        "f25d",
        "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM160 152V264v96c0 13.3 10.7 24 24 24s24-10.7 24-24V288h60.9l37.2 81.9c5.5 12.1 19.7 17.4 31.8 11.9s17.4-19.7 11.9-31.8L315.7 275c21.8-14.3 36.3-39 36.3-67c0-44.2-35.8-80-80-80H184c-13.3 0-24 10.7-24 24zm48 88V176h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H208z"
    ]
};
var $7435a4b2c8a749a5$export$6ea408c7266ed557 = {
    prefix: "far",
    iconName: "address-card",
    icon: [
        576,
        512,
        [
            62140,
            "contact-card",
            "vcard"
        ],
        "f2bb",
        "M512 80c8.8 0 16 7.2 16 16V416c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16H512zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM208 256a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-32 32c-44.2 0-80 35.8-80 80c0 8.8 7.2 16 16 16H304c8.8 0 16-7.2 16-16c0-44.2-35.8-80-80-80H176zM376 144c-13.3 0-24 10.7-24 24s10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24H376zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24H376z"
    ]
};
var $7435a4b2c8a749a5$export$4ac51eb0b298b190 = $7435a4b2c8a749a5$export$6ea408c7266ed557;
var $7435a4b2c8a749a5$export$91228257deb1bf18 = $7435a4b2c8a749a5$export$6ea408c7266ed557;
var $7435a4b2c8a749a5$export$5352cbdc070ce8d = {
    prefix: "far",
    iconName: "face-tired",
    icon: [
        512,
        512,
        [
            128555,
            "tired"
        ],
        "f5c8",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm176.5 64.3C196.1 302.1 223.8 288 256 288s59.9 14.1 79.5 32.3C354.5 338.1 368 362 368 384c0 5.4-2.7 10.4-7.2 13.4s-10.2 3.4-15.2 1.3l-17.2-7.5c-22.8-10-47.5-15.1-72.4-15.1s-49.6 5.2-72.4 15.1l-17.2 7.5c-4.9 2.2-10.7 1.7-15.2-1.3s-7.2-8-7.2-13.4c0-22 13.5-45.9 32.5-63.7zm-43-173.6l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5c0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6c0-9 9.6-14.7 17.5-10.5zM396 157.1c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6c0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9c7.9-4.2 17.5 1.5 17.5 10.5z"
    ]
};
var $7435a4b2c8a749a5$export$3d016d62cda18371 = $7435a4b2c8a749a5$export$5352cbdc070ce8d;
var $7435a4b2c8a749a5$export$aa4baaed1c60f58d = {
    prefix: "far",
    iconName: "font-awesome",
    icon: [
        448,
        512,
        [
            62501,
            62694,
            "font-awesome-flag",
            "font-awesome-logo-full"
        ],
        "f2b4",
        "M48 56c0-13.3-10.7-24-24-24S0 42.7 0 56V456c0 13.3 10.7 24 24 24s24-10.7 24-24V124.2l12.5-2.4c16.7-3.2 31.5-8.5 44.2-13.1l0 0 0 0c3.7-1.3 7.1-2.6 10.4-3.7c15.2-5.2 30.4-9.1 51.2-9.1c25.6 0 43 6 63.5 13.3l.5 .2c20.9 7.4 44.8 15.9 79.1 15.9c32.4 0 53.7-6.8 90.5-19.6V342.9l-9.5 3.3c-41.5 14.4-55.2 19.2-81 19.2c-25.7 0-43.1-6-63.6-13.3l-.6-.2c-20.8-7.4-44.8-15.8-79-15.8c-16.8 0-31 2-43.9 5c-12.9 3-20.9 16-17.9 28.9s16 20.9 28.9 17.9c9.6-2.2 20.1-3.7 32.9-3.7c25.6 0 43 6 63.5 13.3l.5 .2c20.9 7.4 44.8 15.9 79.1 15.9c34.4 0 56.4-7.7 97.8-22.2c7.5-2.6 15.5-5.4 24.4-8.5l16.2-5.5V360 72 38.4L416.2 49.3c-9.7 3.3-18.2 6.3-25.7 8.9c-41.5 14.4-55.2 19.2-81 19.2c-25.7 0-43.1-6-63.6-13.3l-.6-.2c-20.8-7.4-44.8-15.8-79-15.8c-27.8 0-48.5 5.5-66.6 11.6c-4.9 1.7-9.3 3.3-13.6 4.8c-11.9 4.3-22 7.9-34.7 10.3L48 75.4V56z"
    ]
};
var $7435a4b2c8a749a5$export$102c25fde54d4843 = $7435a4b2c8a749a5$export$aa4baaed1c60f58d;
var $7435a4b2c8a749a5$export$6e20d421a2e0f320 = $7435a4b2c8a749a5$export$aa4baaed1c60f58d;
var $7435a4b2c8a749a5$export$6143da800b0e6626 = {
    prefix: "far",
    iconName: "face-smile-wink",
    icon: [
        512,
        512,
        [
            128521,
            "smile-wink"
        ],
        "f4da",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm177.6 62.1C192.8 334.5 218.8 352 256 352s63.2-17.5 78.4-33.9c9-9.7 24.2-10.4 33.9-1.4s10.4 24.2 1.4 33.9c-22 23.8-60 49.4-113.6 49.4s-91.7-25.5-113.6-49.4c-9-9.7-8.4-24.9 1.4-33.9s24.9-8.4 33.9 1.4zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm165.8 21.7c-7.6 8.1-20.2 8.5-28.3 .9s-8.5-20.2-.9-28.3c14.5-15.5 35.2-22.3 54.6-22.3s40.1 6.8 54.6 22.3c7.6 8.1 7.1 20.7-.9 28.3s-20.7 7.1-28.3-.9c-5.5-5.8-14.8-9.7-25.4-9.7s-19.9 3.8-25.4 9.7z"
    ]
};
var $7435a4b2c8a749a5$export$f5dbb37f6801ee3f = $7435a4b2c8a749a5$export$6143da800b0e6626;
var $7435a4b2c8a749a5$export$f0858dff6e769cf6 = {
    prefix: "far",
    iconName: "file-word",
    icon: [
        384,
        512,
        [],
        "f1c2",
        "M48 448V64c0-8.8 7.2-16 16-16H224v80c0 17.7 14.3 32 32 32h80V448c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V154.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0H64zm55 241.1c-3.8-12.7-17.2-19.9-29.9-16.1s-19.9 17.2-16.1 29.9l48 160c3 10.2 12.4 17.1 23 17.1s19.9-7 23-17.1l25-83.4 25 83.4c3 10.2 12.4 17.1 23 17.1s19.9-7 23-17.1l48-160c3.8-12.7-3.4-26.1-16.1-29.9s-26.1 3.4-29.9 16.1l-25 83.4-25-83.4c-3-10.2-12.4-17.1-23-17.1s-19.9 7-23 17.1l-25 83.4-25-83.4z"
    ]
};
var $7435a4b2c8a749a5$export$c341daeecdea449a = {
    prefix: "far",
    iconName: "file-powerpoint",
    icon: [
        384,
        512,
        [],
        "f1c4",
        "M64 464c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16H224v80c0 17.7 14.3 32 32 32h80V448c0 8.8-7.2 16-16 16H64zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V154.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0H64zm72 208c-13.3 0-24 10.7-24 24V336v56c0 13.3 10.7 24 24 24s24-10.7 24-24V360h44c42 0 76-34 76-76s-34-76-76-76H136zm68 104H160V256h44c15.5 0 28 12.5 28 28s-12.5 28-28 28z"
    ]
};
var $7435a4b2c8a749a5$export$c6c3bd5f7d9b8bf2 = {
    prefix: "far",
    iconName: "envelope-open",
    icon: [
        512,
        512,
        [
            62135
        ],
        "f2b6",
        "M255.4 48.2c.2-.1 .4-.2 .6-.2s.4 .1 .6 .2L460.6 194c2.1 1.5 3.4 3.9 3.4 6.5v13.6L291.5 355.7c-20.7 17-50.4 17-71.1 0L48 214.1V200.5c0-2.6 1.2-5 3.4-6.5L255.4 48.2zM48 276.2L190 392.8c38.4 31.5 93.7 31.5 132 0L464 276.2V456c0 4.4-3.6 8-8 8H56c-4.4 0-8-3.6-8-8V276.2zM256 0c-10.2 0-20.2 3.2-28.5 9.1L23.5 154.9C8.7 165.4 0 182.4 0 200.5V456c0 30.9 25.1 56 56 56H456c30.9 0 56-25.1 56-56V200.5c0-18.1-8.7-35.1-23.4-45.6L284.5 9.1C276.2 3.2 266.2 0 256 0z"
    ]
};
var $7435a4b2c8a749a5$export$7a4a0e4caa1e4e6f = {
    prefix: "far",
    iconName: "file-zipper",
    icon: [
        384,
        512,
        [
            "file-archive"
        ],
        "f1c6",
        "M64 464c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16h48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16h48v80c0 17.7 14.3 32 32 32h80V448c0 8.8-7.2 16-16 16H64zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V154.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0H64zm48 112c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H128c-8.8 0-16 7.2-16 16zm0 64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H128c-8.8 0-16 7.2-16 16zm-6.3 71.8L82.1 335.9c-1.4 5.4-2.1 10.9-2.1 16.4c0 35.2 28.8 63.7 64 63.7s64-28.5 64-63.7c0-5.5-.7-11.1-2.1-16.4l-23.5-88.2c-3.7-14-16.4-23.8-30.9-23.8H136.6c-14.5 0-27.2 9.7-30.9 23.8zM128 336h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H128c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
    ]
};
var $7435a4b2c8a749a5$export$bf2047a9946b5c3f = $7435a4b2c8a749a5$export$7a4a0e4caa1e4e6f;
var $7435a4b2c8a749a5$export$90b4406457aae8cc = {
    prefix: "far",
    iconName: "square",
    icon: [
        448,
        512,
        [
            9632,
            9723,
            9724,
            61590
        ],
        "f0c8",
        "M384 80c8.8 0 16 7.2 16 16V416c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16H384zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64z"
    ]
};
var $7435a4b2c8a749a5$export$bab8f3647c394f48 = {
    prefix: "far",
    iconName: "snowflake",
    icon: [
        448,
        512,
        [
            10052,
            10054
        ],
        "f2dc",
        "M224 0c13.3 0 24 10.7 24 24V70.1l23-23c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-57 57v76.5l66.2-38.2 20.9-77.8c3.4-12.8 16.6-20.4 29.4-17s20.4 16.6 17 29.4L373 142.2l37.1-21.4c11.5-6.6 26.2-2.7 32.8 8.8s2.7 26.2-8.8 32.8L397 183.8l31.5 8.4c12.8 3.4 20.4 16.6 17 29.4s-16.6 20.4-29.4 17l-77.8-20.9L272 256l66.2 38.2 77.8-20.9c12.8-3.4 26 4.2 29.4 17s-4.2 26-17 29.4L397 328.2l37.1 21.4c11.5 6.6 15.4 21.3 8.8 32.8s-21.3 15.4-32.8 8.8L373 369.8l8.4 31.5c3.4 12.8-4.2 26-17 29.4s-26-4.2-29.4-17l-20.9-77.8L248 297.6v76.5l57 57c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-23-23V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V441.9l-23 23c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l57-57V297.6l-66.2 38.2-20.9 77.8c-3.4 12.8-16.6 20.4-29.4 17s-20.4-16.6-17-29.4L75 369.8 37.9 391.2c-11.5 6.6-26.2 2.7-32.8-8.8s-2.7-26.2 8.8-32.8L51 328.2l-31.5-8.4c-12.8-3.4-20.4-16.6-17-29.4s16.6-20.4 29.4-17l77.8 20.9L176 256l-66.2-38.2L31.9 238.6c-12.8 3.4-26-4.2-29.4-17s4.2-26 17-29.4L51 183.8 13.9 162.4c-11.5-6.6-15.4-21.3-8.8-32.8s21.3-15.4 32.8-8.8L75 142.2l-8.4-31.5c-3.4-12.8 4.2-26 17-29.4s26 4.2 29.4 17l20.9 77.8L200 214.4V137.9L143 81c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l23 23V24c0-13.3 10.7-24 24-24z"
    ]
};
var $7435a4b2c8a749a5$export$d91b374112d4f8c1 = {
    prefix: "far",
    iconName: "newspaper",
    icon: [
        512,
        512,
        [
            128240
        ],
        "f1ea",
        "M168 80c-13.3 0-24 10.7-24 24V408c0 8.4-1.4 16.5-4.1 24H440c13.3 0 24-10.7 24-24V104c0-13.3-10.7-24-24-24H168zM72 480c-39.8 0-72-32.2-72-72V112C0 98.7 10.7 88 24 88s24 10.7 24 24V408c0 13.3 10.7 24 24 24s24-10.7 24-24V104c0-39.8 32.2-72 72-72H440c39.8 0 72 32.2 72 72V408c0 39.8-32.2 72-72 72H72zM176 136c0-13.3 10.7-24 24-24h96c13.3 0 24 10.7 24 24v80c0 13.3-10.7 24-24 24H200c-13.3 0-24-10.7-24-24V136zm200-24h32c13.3 0 24 10.7 24 24s-10.7 24-24 24H376c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 80h32c13.3 0 24 10.7 24 24s-10.7 24-24 24H376c-13.3 0-24-10.7-24-24s10.7-24 24-24zM200 272H408c13.3 0 24 10.7 24 24s-10.7 24-24 24H200c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 80H408c13.3 0 24 10.7 24 24s-10.7 24-24 24H200c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
    ]
};
var $7435a4b2c8a749a5$export$611ae61f02de0aa = {
    prefix: "far",
    iconName: "face-kiss-wink-heart",
    icon: [
        512,
        512,
        [
            128536,
            "kiss-wink-heart"
        ],
        "f598",
        "M338.9 446.8c-25.4 11-53.4 17.2-82.9 17.2C141.1 464 48 370.9 48 256S141.1 48 256 48s208 93.1 208 208c0 22.4-3.5 43.9-10.1 64.1c3.1 4.5 5.7 9.4 7.8 14.6c12.7-1.6 25.1 .4 36.2 5c9.1-26.2 14-54.4 14-83.7C512 114.6 397.4 0 256 0S0 114.6 0 256S114.6 512 256 512c35.4 0 69.1-7.2 99.7-20.2c-4.8-5.5-8.5-12.2-10.4-19.7l-6.5-25.3zM296 316c0-6.9-3.1-13.2-7.3-18.3c-4.3-5.2-10.1-9.7-16.7-13.4C258.7 276.9 241.4 272 224 272c-3.6 0-6.8 2.5-7.7 6s.6 7.2 3.8 9l0 0 0 0 0 0 .2 .1c.2 .1 .5 .3 .9 .5c.8 .5 2 1.2 3.4 2.1c2.8 1.9 6.5 4.5 10.2 7.6c3.7 3.1 7.2 6.6 9.6 10.1c2.5 3.5 3.5 6.4 3.5 8.6s-1 5-3.5 8.6c-2.5 3.5-5.9 6.9-9.6 10.1c-3.7 3.1-7.4 5.7-10.2 7.6c-1.4 .9-2.6 1.6-3.4 2.1c-.4 .2-.7 .4-.9 .5l-.2 .1 0 0 0 0 0 0 0 0 0 0c-2.5 1.4-4.1 4.1-4.1 7s1.6 5.6 4.1 7l0 0 0 0 0 0 .2 .1c.2 .1 .5 .3 .9 .5c.8 .5 2 1.2 3.4 2.1c2.8 1.9 6.5 4.5 10.2 7.6c3.7 3.1 7.2 6.6 9.6 10.1c2.5 3.5 3.5 6.4 3.5 8.6s-1 5-3.5 8.6c-2.5 3.5-5.9 6.9-9.6 10.1c-3.7 3.1-7.4 5.7-10.2 7.6c-1.4 .9-2.6 1.6-3.4 2.1c-.4 .2-.7 .4-.9 .5l-.2 .1 0 0 0 0 0 0 0 0c-3.2 1.8-4.7 5.5-3.8 9s4.1 6 7.7 6c17.4 0 34.7-4.9 47.9-12.3c6.6-3.7 12.5-8.2 16.7-13.4c4.3-5.1 7.3-11.4 7.3-18.3s-3.1-13.2-7.3-18.3c-4.3-5.2-10.1-9.7-16.7-13.4c-2.7-1.5-5.7-3-8.7-4.3c3.1-1.3 6-2.7 8.7-4.3c6.6-3.7 12.5-8.2 16.7-13.4c4.3-5.1 7.3-11.4 7.3-18.3zM176.4 240a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm159.3-20c10.6 0 19.9 3.8 25.4 9.7c7.6 8.1 20.2 8.5 28.3 .9s8.5-20.2 .9-28.3C375.7 186.8 355 180 335.6 180s-40.1 6.8-54.6 22.3c-7.6 8.1-7.1 20.7 .9 28.3s20.7 7.1 28.3-.9c5.5-5.8 14.8-9.7 25.4-9.7zM434 352.3c-6-23.2-28.8-37-51.1-30.8s-35.4 30.1-29.5 53.4l22.9 89.3c2.2 8.7 11.2 13.9 19.8 11.4l84.9-23.8c22.2-6.2 35.4-30.1 29.5-53.4s-28.8-37-51.1-30.8l-20.2 5.6-5.4-21z"
    ]
};
var $7435a4b2c8a749a5$export$ebba617701dfb917 = $7435a4b2c8a749a5$export$611ae61f02de0aa;
var $7435a4b2c8a749a5$export$3e4892d8bf919edd = {
    prefix: "far",
    iconName: "star-half-stroke",
    icon: [
        576,
        512,
        [
            "star-half-alt"
        ],
        "f5c0",
        "M309.5 13.5C305.5 5.2 297.1 0 287.9 0s-17.6 5.2-21.6 13.5L197.7 154.8 44.5 177.5c-9 1.3-16.5 7.6-19.3 16.3s-.5 18.1 5.9 24.5L142.2 328.4 116 483.9c-1.5 9 2.2 18.1 9.7 23.5s17.3 6 25.3 1.7l137-73.2 137 73.2c8.1 4.3 17.9 3.7 25.3-1.7s11.2-14.5 9.7-23.5L433.6 328.4 544.8 218.2c6.5-6.4 8.7-15.9 5.9-24.5s-10.3-14.9-19.3-16.3L378.1 154.8 309.5 13.5zM288 384.7V79.1l52.5 108.1c3.5 7.1 10.2 12.1 18.1 13.3l118.3 17.5L391 303c-5.5 5.5-8.1 13.3-6.8 21l20.2 119.6L299.2 387.5c-3.5-1.9-7.4-2.8-11.2-2.8z"
    ]
};
var $7435a4b2c8a749a5$export$c13575f42532efb3 = $7435a4b2c8a749a5$export$3e4892d8bf919edd;
var $7435a4b2c8a749a5$export$77cb1a465c4fe84 = {
    prefix: "far",
    iconName: "file-excel",
    icon: [
        384,
        512,
        [],
        "f1c3",
        "M48 448V64c0-8.8 7.2-16 16-16H224v80c0 17.7 14.3 32 32 32h80V448c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V154.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0H64zm90.9 233.3c-8.1-10.5-23.2-12.3-33.7-4.2s-12.3 23.2-4.2 33.7L161.6 320l-44.5 57.3c-8.1 10.5-6.3 25.5 4.2 33.7s25.5 6.3 33.7-4.2L192 359.1l37.1 47.6c8.1 10.5 23.2 12.3 33.7 4.2s12.3-23.2 4.2-33.7L222.4 320l44.5-57.3c8.1-10.5 6.3-25.5-4.2-33.7s-25.5-6.3-33.7 4.2L192 280.9l-37.1-47.6z"
    ]
};
var $7435a4b2c8a749a5$export$3de52eeb00462407 = {
    prefix: "far",
    iconName: "face-grin-beam",
    icon: [
        512,
        512,
        [
            128516,
            "grin-beam"
        ],
        "f582",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm349.5 52.4c18.7-4.4 35.9 12 25.5 28.1C350.4 374.6 306.3 400 255.9 400s-94.5-25.4-119.1-63.5c-10.4-16.1 6.8-32.5 25.5-28.1c28.9 6.8 60.5 10.5 93.6 10.5s64.7-3.7 93.6-10.5zM217.6 228.8l0 0 0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0zm160 0l0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0 0 0z"
    ]
};
var $7435a4b2c8a749a5$export$734da5249381ec7e = $7435a4b2c8a749a5$export$3de52eeb00462407;
var $7435a4b2c8a749a5$export$887f6345573abcac = {
    prefix: "far",
    iconName: "object-ungroup",
    icon: [
        640,
        512,
        [],
        "f248",
        "M48.2 66.8c-.1-.8-.2-1.7-.2-2.5c0-.1 0-.1 0-.2c0-8.8 7.2-16 16-16c.9 0 1.9 .1 2.8 .2C74.3 49.5 80 56.1 80 64c0 8.8-7.2 16-16 16c-7.9 0-14.5-5.7-15.8-13.2zM0 64c0 26.9 16.5 49.9 40 59.3V228.7C16.5 238.1 0 261.1 0 288c0 35.3 28.7 64 64 64c26.9 0 49.9-16.5 59.3-40H324.7c9.5 23.5 32.5 40 59.3 40c35.3 0 64-28.7 64-64c0-26.9-16.5-49.9-40-59.3V123.3c23.5-9.5 40-32.5 40-59.3c0-35.3-28.7-64-64-64c-26.9 0-49.9 16.5-59.3 40H123.3C113.9 16.5 90.9 0 64 0C28.7 0 0 28.7 0 64zm368 0a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM324.7 88c6.5 16 19.3 28.9 35.3 35.3V228.7c-16 6.5-28.9 19.3-35.3 35.3H123.3c-6.5-16-19.3-28.9-35.3-35.3V123.3c16-6.5 28.9-19.3 35.3-35.3H324.7zM384 272a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM80 288c0 7.9-5.7 14.5-13.2 15.8c-.8 .1-1.7 .2-2.5 .2l-.2 0c-8.8 0-16-7.2-16-16c0-.9 .1-1.9 .2-2.8C49.5 277.7 56.1 272 64 272c8.8 0 16 7.2 16 16zm391.3-40h45.4c6.5 16 19.3 28.9 35.3 35.3V388.7c-16 6.5-28.9 19.3-35.3 35.3H315.3c-6.5-16-19.3-28.9-35.3-35.3V352H232v36.7c-23.5 9.5-40 32.5-40 59.3c0 35.3 28.7 64 64 64c26.9 0 49.9-16.5 59.3-40H516.7c9.5 23.5 32.5 40 59.3 40c35.3 0 64-28.7 64-64c0-26.9-16.5-49.9-40-59.3V283.3c23.5-9.5 40-32.5 40-59.3c0-35.3-28.7-64-64-64c-26.9 0-49.9 16.5-59.3 40H448v16.4c9.8 8.8 17.8 19.5 23.3 31.6zm88.9-26.7a16 16 0 1 1 31.5 5.5 16 16 0 1 1 -31.5-5.5zM271.8 450.7a16 16 0 1 1 -31.5-5.5 16 16 0 1 1 31.5 5.5zm301.5 13c-7.5-1.3-13.2-7.9-13.2-15.8c0-8.8 7.2-16 16-16c7.9 0 14.5 5.7 15.8 13.2l0 .1c.1 .9 .2 1.8 .2 2.7c0 8.8-7.2 16-16 16c-.9 0-1.9-.1-2.8-.2z"
    ]
};
var $7435a4b2c8a749a5$export$1fec48c8bdd69c1d = {
    prefix: "far",
    iconName: "circle-right",
    icon: [
        512,
        512,
        [
            61838,
            "arrow-alt-circle-right"
        ],
        "f35a",
        "M464 256A208 208 0 1 1 48 256a208 208 0 1 1 416 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM294.6 135.1c-4.2-4.5-10.1-7.1-16.3-7.1C266 128 256 138 256 150.3V208H160c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32h96v57.7c0 12.3 10 22.3 22.3 22.3c6.2 0 12.1-2.6 16.3-7.1l99.9-107.1c3.5-3.8 5.5-8.7 5.5-13.8s-2-10.1-5.5-13.8L294.6 135.1z"
    ]
};
var $7435a4b2c8a749a5$export$88962ffdad8b856d = $7435a4b2c8a749a5$export$1fec48c8bdd69c1d;
var $7435a4b2c8a749a5$export$a6d72a9a068392b5 = {
    prefix: "far",
    iconName: "face-rolling-eyes",
    icon: [
        512,
        512,
        [
            128580,
            "meh-rolling-eyes"
        ],
        "f5a5",
        "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM168 376c0 13.3 10.7 24 24 24H320c13.3 0 24-10.7 24-24s-10.7-24-24-24H192c-13.3 0-24 10.7-24 24zm-8-104c-26.5 0-48-21.5-48-48c0-14.3 6.3-27.2 16.2-36c-.2 1.3-.2 2.6-.2 4c0 17.7 14.3 32 32 32s32-14.3 32-32c0-1.4-.1-2.7-.2-4c10 8.8 16.2 21.7 16.2 36c0 26.5-21.5 48-48 48zm0 32a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm192-32c-26.5 0-48-21.5-48-48c0-14.3 6.3-27.2 16.2-36c-.2 1.3-.2 2.6-.2 4c0 17.7 14.3 32 32 32s32-14.3 32-32c0-1.4-.1-2.7-.2-4c10 8.8 16.2 21.7 16.2 36c0 26.5-21.5 48-48 48zm0 32a80 80 0 1 0 0-160 80 80 0 1 0 0 160z"
    ]
};
var $7435a4b2c8a749a5$export$fdc62a1bea767cc2 = $7435a4b2c8a749a5$export$a6d72a9a068392b5;
var $7435a4b2c8a749a5$export$40cdac24aa94a57a = {
    prefix: "far",
    iconName: "object-group",
    icon: [
        576,
        512,
        [],
        "f247",
        "M48 115.8C38.2 107 32 94.2 32 80c0-26.5 21.5-48 48-48c14.2 0 27 6.2 35.8 16H460.2c8.8-9.8 21.6-16 35.8-16c26.5 0 48 21.5 48 48c0 14.2-6.2 27-16 35.8V396.2c9.8 8.8 16 21.6 16 35.8c0 26.5-21.5 48-48 48c-14.2 0-27-6.2-35.8-16H115.8c-8.8 9.8-21.6 16-35.8 16c-26.5 0-48-21.5-48-48c0-14.2 6.2-27 16-35.8V115.8zM125.3 96c-4.8 13.6-15.6 24.4-29.3 29.3V386.7c13.6 4.8 24.4 15.6 29.3 29.3H450.7c4.8-13.6 15.6-24.4 29.3-29.3V125.3c-13.6-4.8-24.4-15.6-29.3-29.3H125.3zm2.7 64c0-17.7 14.3-32 32-32H288c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32V160zM256 320h32c35.3 0 64-28.7 64-64V224h64c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H288c-17.7 0-32-14.3-32-32V320z"
    ]
};
var $7435a4b2c8a749a5$export$e4b51a47a2f8b9db = {
    prefix: "far",
    iconName: "heart",
    icon: [
        512,
        512,
        [
            128153,
            128154,
            128155,
            128156,
            128420,
            129293,
            129294,
            129505,
            9829,
            10084,
            61578
        ],
        "f004",
        "M225.8 468.2l-2.5-2.3L48.1 303.2C17.4 274.7 0 234.7 0 192.8v-3.3c0-70.4 50-130.8 119.2-144C158.6 37.9 198.9 47 231 69.6c9 6.4 17.4 13.8 25 22.3c4.2-4.8 8.7-9.2 13.5-13.3c3.7-3.2 7.5-6.2 11.5-9c0 0 0 0 0 0C313.1 47 353.4 37.9 392.8 45.4C462 58.6 512 119.1 512 189.5v3.3c0 41.9-17.4 81.9-48.1 110.4L288.7 465.9l-2.5 2.3c-8.2 7.6-19 11.9-30.2 11.9s-22-4.2-30.2-11.9zM239.1 145c-.4-.3-.7-.7-1-1.1l-17.8-20c0 0-.1-.1-.1-.1c0 0 0 0 0 0c-23.1-25.9-58-37.7-92-31.2C81.6 101.5 48 142.1 48 189.5v3.3c0 28.5 11.9 55.8 32.8 75.2L256 430.7 431.2 268c20.9-19.4 32.8-46.7 32.8-75.2v-3.3c0-47.3-33.6-88-80.1-96.9c-34-6.5-69 5.4-92 31.2c0 0 0 0-.1 .1s0 0-.1 .1l-17.8 20c-.3 .4-.7 .7-1 1.1c-4.5 4.5-10.6 7-16.9 7s-12.4-2.5-16.9-7z"
    ]
};
var $7435a4b2c8a749a5$export$c938968e28178994 = {
    prefix: "far",
    iconName: "face-surprise",
    icon: [
        512,
        512,
        [
            128558,
            "surprise"
        ],
        "f5c2",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm176.4-80a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM256 288a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"
    ]
};
var $7435a4b2c8a749a5$export$46647c72213f53ba = $7435a4b2c8a749a5$export$c938968e28178994;
var $7435a4b2c8a749a5$export$fbeef2513e05ad08 = {
    prefix: "far",
    iconName: "circle-pause",
    icon: [
        512,
        512,
        [
            62092,
            "pause-circle"
        ],
        "f28b",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm224-72V328c0 13.3-10.7 24-24 24s-24-10.7-24-24V184c0-13.3 10.7-24 24-24s24 10.7 24 24zm112 0V328c0 13.3-10.7 24-24 24s-24-10.7-24-24V184c0-13.3 10.7-24 24-24s24 10.7 24 24z"
    ]
};
var $7435a4b2c8a749a5$export$d8cf08a0362da8db = $7435a4b2c8a749a5$export$fbeef2513e05ad08;
var $7435a4b2c8a749a5$export$4280b2387fbdad12 = {
    prefix: "far",
    iconName: "circle",
    icon: [
        512,
        512,
        [
            128308,
            128309,
            128992,
            128993,
            128994,
            128995,
            128996,
            9679,
            9898,
            9899,
            11044,
            61708,
            61915
        ],
        "f111",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"
    ]
};
var $7435a4b2c8a749a5$export$72ea8a5e4e86cd69 = {
    prefix: "far",
    iconName: "circle-up",
    icon: [
        512,
        512,
        [
            61467,
            "arrow-alt-circle-up"
        ],
        "f35b",
        "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM135.1 217.4c-4.5 4.2-7.1 10.1-7.1 16.3c0 12.3 10 22.3 22.3 22.3H208v96c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V256h57.7c12.3 0 22.3-10 22.3-22.3c0-6.2-2.6-12.1-7.1-16.3L269.8 117.5c-3.8-3.5-8.7-5.5-13.8-5.5s-10.1 2-13.8 5.5L135.1 217.4z"
    ]
};
var $7435a4b2c8a749a5$export$3747a8ef0995eadf = $7435a4b2c8a749a5$export$72ea8a5e4e86cd69;
var $7435a4b2c8a749a5$export$b8d24c57c9e64933 = {
    prefix: "far",
    iconName: "file-audio",
    icon: [
        384,
        512,
        [],
        "f1c7",
        "M64 464H320c8.8 0 16-7.2 16-16V160H256c-17.7 0-32-14.3-32-32V48H64c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16zM0 64C0 28.7 28.7 0 64 0H229.5c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM192 272V400c0 6.5-3.9 12.3-9.9 14.8s-12.9 1.1-17.4-3.5L129.4 376H112c-8.8 0-16-7.2-16-16V312c0-8.8 7.2-16 16-16h17.4l35.3-35.3c4.6-4.6 11.5-5.9 17.4-3.5s9.9 8.3 9.9 14.8zm85.8-4c11.6 20 18.2 43.3 18.2 68s-6.6 48-18.2 68c-6.6 11.5-21.3 15.4-32.8 8.8s-15.4-21.3-8.8-32.8c7.5-12.9 11.8-27.9 11.8-44s-4.3-31.1-11.8-44c-6.6-11.5-2.7-26.2 8.8-32.8s26.2-2.7 32.8 8.8z"
    ]
};
var $7435a4b2c8a749a5$export$6440b286d3cbac9b = {
    prefix: "far",
    iconName: "file-image",
    icon: [
        384,
        512,
        [
            128443
        ],
        "f1c5",
        "M64 464c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16H224v80c0 17.7 14.3 32 32 32h80V448c0 8.8-7.2 16-16 16H64zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V154.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0H64zm96 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm69.2 46.9c-3-4.3-7.9-6.9-13.2-6.9s-10.2 2.6-13.2 6.9l-41.3 59.7-11.9-19.1c-2.9-4.7-8.1-7.5-13.6-7.5s-10.6 2.8-13.6 7.5l-40 64c-3.1 4.9-3.2 11.1-.4 16.2s8.2 8.2 14 8.2h48 32 40 72c6 0 11.4-3.3 14.2-8.6s2.4-11.6-1-16.5l-72-104z"
    ]
};
var $7435a4b2c8a749a5$export$d7cf0978afd90002 = {
    prefix: "far",
    iconName: "circle-question",
    icon: [
        512,
        512,
        [
            62108,
            "question-circle"
        ],
        "f059",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm169.8-90.7c7.9-22.3 29.1-37.3 52.8-37.3h58.3c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24V250.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1H222.6c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
    ]
};
var $7435a4b2c8a749a5$export$5ba67d7f2265c1a5 = $7435a4b2c8a749a5$export$d7cf0978afd90002;
var $7435a4b2c8a749a5$export$38c072b870a9e4ab = {
    prefix: "far",
    iconName: "face-meh-blank",
    icon: [
        512,
        512,
        [
            128566,
            "meh-blank"
        ],
        "f5a4",
        "M256 48a208 208 0 1 0 0 416 208 208 0 1 0 0-416zM512 256A256 256 0 1 1 0 256a256 256 0 1 1 512 0zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $7435a4b2c8a749a5$export$e945435725f71e88 = $7435a4b2c8a749a5$export$38c072b870a9e4ab;
var $7435a4b2c8a749a5$export$b8c3e79e8c99c95b = {
    prefix: "far",
    iconName: "eye",
    icon: [
        576,
        512,
        [
            128065
        ],
        "f06e",
        "M288 80c-65.2 0-118.8 29.6-159.9 67.7C89.6 183.5 63 226 49.4 256c13.6 30 40.2 72.5 78.6 108.3C169.2 402.4 222.8 432 288 432s118.8-29.6 159.9-67.7C486.4 328.5 513 286 526.6 256c-13.6-30-40.2-72.5-78.6-108.3C406.8 109.6 353.2 80 288 80zM95.4 112.6C142.5 68.8 207.2 32 288 32s145.5 36.8 192.6 80.6c46.8 43.5 78.1 95.4 93 131.1c3.3 7.9 3.3 16.7 0 24.6c-14.9 35.7-46.2 87.7-93 131.1C433.5 443.2 368.8 480 288 480s-145.5-36.8-192.6-80.6C48.6 356 17.3 304 2.5 268.3c-3.3-7.9-3.3-16.7 0-24.6C17.3 208 48.6 156 95.4 112.6zM288 336c44.2 0 80-35.8 80-80s-35.8-80-80-80c-.7 0-1.3 0-2 0c1.3 5.1 2 10.5 2 16c0 35.3-28.7 64-64 64c-5.5 0-10.9-.7-16-2c0 .7 0 1.3 0 2c0 44.2 35.8 80 80 80zm0-208a128 128 0 1 1 0 256 128 128 0 1 1 0-256z"
    ]
};
var $7435a4b2c8a749a5$export$e8ea88c55e55be7c = {
    prefix: "far",
    iconName: "face-sad-cry",
    icon: [
        512,
        512,
        [
            128557,
            "sad-cry"
        ],
        "f5b3",
        "M400 406.1V288c0-13.3-10.7-24-24-24s-24 10.7-24 24V440.6c-28.7 15-61.4 23.4-96 23.4s-67.3-8.5-96-23.4V288c0-13.3-10.7-24-24-24s-24 10.7-24 24V406.1C72.6 368.2 48 315 48 256C48 141.1 141.1 48 256 48s208 93.1 208 208c0 59-24.6 112.2-64 150.1zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM159.6 220c10.6 0 19.9 3.8 25.4 9.7c7.6 8.1 20.2 8.5 28.3 .9s8.5-20.2 .9-28.3C199.7 186.8 179 180 159.6 180s-40.1 6.8-54.6 22.3c-7.6 8.1-7.1 20.7 .9 28.3s20.7 7.1 28.3-.9c5.5-5.8 14.8-9.7 25.4-9.7zm166.6 9.7c5.5-5.8 14.8-9.7 25.4-9.7s19.9 3.8 25.4 9.7c7.6 8.1 20.2 8.5 28.3 .9s8.5-20.2 .9-28.3C391.7 186.8 371 180 351.6 180s-40.1 6.8-54.6 22.3c-7.6 8.1-7.1 20.7 .9 28.3s20.7 7.1 28.3-.9zM208 320v32c0 26.5 21.5 48 48 48s48-21.5 48-48V320c0-26.5-21.5-48-48-48s-48 21.5-48 48z"
    ]
};
var $7435a4b2c8a749a5$export$8e924e6bd422cef9 = $7435a4b2c8a749a5$export$e8ea88c55e55be7c;
var $7435a4b2c8a749a5$export$143d0ca7d2200f20 = {
    prefix: "far",
    iconName: "file-code",
    icon: [
        384,
        512,
        [],
        "f1c9",
        "M64 464c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16H224v80c0 17.7 14.3 32 32 32h80V448c0 8.8-7.2 16-16 16H64zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V154.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0H64zm97 289c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L79 303c-9.4 9.4-9.4 24.6 0 33.9l48 48c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-31-31 31-31zM257 255c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l31 31-31 31c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l48-48c9.4-9.4 9.4-24.6 0-33.9l-48-48z"
    ]
};
var $7435a4b2c8a749a5$export$703cd98be31ec905 = {
    prefix: "far",
    iconName: "window-maximize",
    icon: [
        512,
        512,
        [
            128470
        ],
        "f2d0",
        "M.3 89.5C.1 91.6 0 93.8 0 96V224 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64V224 96c0-35.3-28.7-64-64-64H64c-2.2 0-4.4 .1-6.5 .3c-9.2 .9-17.8 3.8-25.5 8.2C21.8 46.5 13.4 55.1 7.7 65.5c-3.9 7.3-6.5 15.4-7.4 24zM48 224H464l0 192c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16l0-192z"
    ]
};
var $7435a4b2c8a749a5$export$e5f78e87efbb0248 = {
    prefix: "far",
    iconName: "face-frown",
    icon: [
        512,
        512,
        [
            9785,
            "frown"
        ],
        "f119",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM174.6 384.1c-4.5 12.5-18.2 18.9-30.7 14.4s-18.9-18.2-14.4-30.7C146.9 319.4 198.9 288 256 288s109.1 31.4 126.6 79.9c4.5 12.5-2 26.2-14.4 30.7s-26.2-2-30.7-14.4C328.2 358.5 297.2 336 256 336s-72.2 22.5-81.4 48.1zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $7435a4b2c8a749a5$export$43b7108508aecc5f = $7435a4b2c8a749a5$export$e5f78e87efbb0248;
var $7435a4b2c8a749a5$export$f62f2879ccaea13f = {
    prefix: "far",
    iconName: "floppy-disk",
    icon: [
        448,
        512,
        [
            128190,
            128426,
            "save"
        ],
        "f0c7",
        "M48 96V416c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V170.5c0-4.2-1.7-8.3-4.7-11.3l33.9-33.9c12 12 18.7 28.3 18.7 45.3V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H309.5c17 0 33.3 6.7 45.3 18.7l74.5 74.5-33.9 33.9L320.8 84.7c-.3-.3-.5-.5-.8-.8V184c0 13.3-10.7 24-24 24H104c-13.3 0-24-10.7-24-24V80H64c-8.8 0-16 7.2-16 16zm80-16v80H272V80H128zm32 240a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z"
    ]
};
var $7435a4b2c8a749a5$export$1aaa83ff70706e1e = $7435a4b2c8a749a5$export$f62f2879ccaea13f;
var $7435a4b2c8a749a5$export$63ffcb3d4e94cb92 = {
    prefix: "far",
    iconName: "comment-dots",
    icon: [
        512,
        512,
        [
            128172,
            62075,
            "commenting"
        ],
        "f4ad",
        "M168.2 384.9c-15-5.4-31.7-3.1-44.6 6.4c-8.2 6-22.3 14.8-39.4 22.7c5.6-14.7 9.9-31.3 11.3-49.4c1-12.9-3.3-25.7-11.8-35.5C60.4 302.8 48 272 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160s-83.3 160-208 160c-31.6 0-61.3-5.5-87.8-15.1zM26.3 423.8c-1.6 2.7-3.3 5.4-5.1 8.1l-.3 .5c-1.6 2.3-3.2 4.6-4.8 6.9c-3.5 4.7-7.3 9.3-11.3 13.5c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c5.1 0 10.2-.3 15.3-.8l.7-.1c4.4-.5 8.8-1.1 13.2-1.9c.8-.1 1.6-.3 2.4-.5c17.8-3.5 34.9-9.5 50.1-16.1c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9zM144 272a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm144-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm80 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
var $7435a4b2c8a749a5$export$49ee382a2425e89c = $7435a4b2c8a749a5$export$63ffcb3d4e94cb92;
var $7435a4b2c8a749a5$export$5d53da7627754bc6 = {
    prefix: "far",
    iconName: "face-grin-squint",
    icon: [
        512,
        512,
        [
            128518,
            "grin-squint"
        ],
        "f585",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm349.5 52.4c18.7-4.4 35.9 12 25.5 28.1C350.4 374.6 306.3 400 255.9 400s-94.5-25.4-119.1-63.5c-10.4-16.1 6.8-32.5 25.5-28.1c28.9 6.8 60.5 10.5 93.6 10.5s64.7-3.7 93.6-10.5zm-216-161.7l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5c0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6c0-9 9.6-14.7 17.5-10.5zM396 157.1c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6c0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9c7.9-4.2 17.5 1.5 17.5 10.5z"
    ]
};
var $7435a4b2c8a749a5$export$243ae757907b1580 = $7435a4b2c8a749a5$export$5d53da7627754bc6;
var $7435a4b2c8a749a5$export$d97ff927c450c87f = {
    prefix: "far",
    iconName: "hand-pointer",
    icon: [
        448,
        512,
        [],
        "f25a",
        "M160 64c0-8.8 7.2-16 16-16s16 7.2 16 16V200c0 10.3 6.6 19.5 16.4 22.8s20.6-.1 26.8-8.3c3-3.9 7.6-6.4 12.8-6.4c8.8 0 16 7.2 16 16c0 10.3 6.6 19.5 16.4 22.8s20.6-.1 26.8-8.3c3-3.9 7.6-6.4 12.8-6.4c7.8 0 14.3 5.6 15.7 13c1.6 8.2 7.3 15.1 15.1 18s16.7 1.6 23.3-3.6c2.7-2.1 6.1-3.4 9.9-3.4c8.8 0 16 7.2 16 16l0 16V392c0 39.8-32.2 72-72 72H272 212.3h-.9c-37.4 0-72.4-18.7-93.2-49.9L50.7 312.9c-4.9-7.4-2.9-17.3 4.4-22.2s17.3-2.9 22.2 4.4L116 353.2c5.9 8.8 16.8 12.7 26.9 9.7s17-12.4 17-23V320 64zM176 0c-35.3 0-64 28.7-64 64V261.7C91.2 238 55.5 232.8 28.5 250.7C-.9 270.4-8.9 310.1 10.8 339.5L78.3 440.8c29.7 44.5 79.6 71.2 133.1 71.2h.9H272h56c66.3 0 120-53.7 120-120V288l0-16c0-35.3-28.7-64-64-64c-4.5 0-8.8 .5-13 1.3c-11.7-15.4-30.2-25.3-51-25.3c-6.9 0-13.5 1.1-19.7 3.1C288.7 170.7 269.6 160 248 160c-2.7 0-5.4 .2-8 .5V64c0-35.3-28.7-64-64-64zm48 304c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V304zm48-16c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V304c0-8.8-7.2-16-16-16zm80 16c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V304z"
    ]
};
var $7435a4b2c8a749a5$export$c578e919f2c5c135 = {
    prefix: "far",
    iconName: "hand-scissors",
    icon: [
        512,
        512,
        [],
        "f257",
        "M.2 276.3c-1.2-35.3 26.4-65 61.7-66.2l3.3-.1L57 208.1C22.5 200.5 .7 166.3 8.3 131.8S50.2 75.5 84.7 83.2l173 38.3c2.3-2.9 4.7-5.7 7.1-8.5l18.4-20.3C299.9 74.5 323.5 64 348.3 64l10.2 0c54.1 0 104.1 28.7 131.3 75.4l1.5 2.6c13.6 23.2 20.7 49.7 20.7 76.6L512 344c0 66.3-53.7 120-120 120l-8 0-96 0c-35.3 0-64-28.7-64-64c0-2.8 .2-5.6 .5-8.3c-19.4-11-32.5-31.8-32.5-55.7c0-.8 0-1.6 0-2.4L66.4 338c-35.3 1.2-65-26.4-66.2-61.7zm63.4-18.2c-8.8 .3-15.7 7.7-15.4 16.5s7.7 15.7 16.5 15.4l161.5-5.6c9.8-.3 18.7 5.3 22.7 14.2s2.2 19.3-4.5 26.4c-2.8 2.9-4.4 6.7-4.4 11c0 8.8 7.2 16 16 16c9.1 0 17.4 5.1 21.5 13.3s3.2 17.9-2.3 25.1c-2 2.7-3.2 6-3.2 9.6c0 8.8 7.2 16 16 16l96 0 8 0c39.8 0 72-32.2 72-72l0-125.4c0-18.4-4.9-36.5-14.2-52.4l-1.5-2.6c-18.6-32-52.8-51.6-89.8-51.6l-10.2 0c-11.3 0-22 4.8-29.6 13.1l-17.5-15.9 17.5 15.9-18.4 20.3c-.6 .6-1.1 1.3-1.7 1.9l57 13.2c8.6 2 14 10.6 12 19.2s-10.6 14-19.2 12l-85.6-19.7L74.3 130c-8.6-1.9-17.2 3.5-19.1 12.2s3.5 17.2 12.2 19.1l187.5 41.6c10.2 2.3 17.8 10.9 18.7 21.4l.1 1c.6 6.6-1.5 13.1-5.8 18.1s-10.6 7.9-17.2 8.2L63.6 258.1z"
    ]
};
var $7435a4b2c8a749a5$export$8ac6d81a3d5b40a1 = {
    prefix: "far",
    iconName: "face-grin-tears",
    icon: [
        640,
        512,
        [
            128514,
            "grin-tears"
        ],
        "f588",
        "M516.1 325.5c1 3 2.1 6 3.3 8.9c3.3 8.1 8.4 18.5 16.5 26.6c3.9 3.9 8.2 7.4 12.7 10.3C506.4 454.8 419.9 512 320 512s-186.4-57.2-228.6-140.6c4.5-2.9 8.7-6.3 12.7-10.3c8.1-8.1 13.2-18.6 16.5-26.6c1.2-2.9 2.3-5.9 3.3-8.9C152.5 406.2 229.5 464 320 464s167.5-57.8 196.1-138.5zM320 48c-101.4 0-185.8 72.5-204.3 168.5c-6.7-3.1-14.3-4.3-22.3-3.1c-6.8 .9-16.2 2.4-26.6 4.4C85.3 94.5 191.6 0 320 0S554.7 94.5 573.2 217.7c-10.3-2-19.8-3.5-26.6-4.4c-8-1.2-15.7 .1-22.3 3.1C505.8 120.5 421.4 48 320 48zM78.5 341.1C60 356.7 32 355.5 14.3 337.7c-18.7-18.7-19.1-48.8-.7-67.2c8.6-8.6 30.1-15.1 50.5-19.6c13-2.8 25.5-4.8 33.9-6c5.4-.8 9.9 3.7 9 9c-3.1 21.5-11.4 70.2-25.5 84.4c-.9 1-1.9 1.8-2.9 2.7zm483 0c-.8-.6-1.5-1.3-2.3-2c-.2-.2-.5-.4-.7-.7c-14.1-14.1-22.5-62.9-25.5-84.4c-.8-5.4 3.7-9.9 9-9c1 .1 2.2 .3 3.3 .5c8.2 1.2 19.2 3 30.6 5.5c20.4 4.4 41.9 10.9 50.5 19.6c18.4 18.4 18 48.5-.7 67.2c-17.7 17.7-45.7 19-64.2 3.4zM439 336.5C414.4 374.6 370.3 400 319.9 400s-94.5-25.4-119.1-63.5c-10.4-16.1 6.8-32.5 25.5-28.1c28.9 6.8 60.5 10.5 93.6 10.5s64.7-3.7 93.6-10.5c18.7-4.4 35.9 12 25.5 28.1zM281.6 228.8l0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0 0 0zm160 0l0 0 0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0z"
    ]
};
var $7435a4b2c8a749a5$export$b2f7512221512b5b = $7435a4b2c8a749a5$export$8ac6d81a3d5b40a1;
var $7435a4b2c8a749a5$export$3c70ffe5660af060 = {
    prefix: "far",
    iconName: "calendar-xmark",
    icon: [
        448,
        512,
        [
            "calendar-times"
        ],
        "f273",
        "M128 0c13.3 0 24 10.7 24 24V64H296V24c0-13.3 10.7-24 24-24s24 10.7 24 24V64h40c35.3 0 64 28.7 64 64v16 48V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192 144 128C0 92.7 28.7 64 64 64h40V24c0-13.3 10.7-24 24-24zM400 192H48V448c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V192zm-95 89l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"
    ]
};
var $7435a4b2c8a749a5$export$99b20d7352fbcf08 = $7435a4b2c8a749a5$export$3c70ffe5660af060;
var $7435a4b2c8a749a5$export$b44eb38345c6a964 = {
    prefix: "far",
    iconName: "file-video",
    icon: [
        384,
        512,
        [],
        "f1c8",
        "M320 464c8.8 0 16-7.2 16-16V160H256c-17.7 0-32-14.3-32-32V48H64c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16H320zM0 64C0 28.7 28.7 0 64 0H229.5c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM80 288c0-17.7 14.3-32 32-32h96c17.7 0 32 14.3 32 32v16l44.9-29.9c2-1.3 4.4-2.1 6.8-2.1c6.8 0 12.3 5.5 12.3 12.3V387.7c0 6.8-5.5 12.3-12.3 12.3c-2.4 0-4.8-.7-6.8-2.1L240 368v16c0 17.7-14.3 32-32 32H112c-17.7 0-32-14.3-32-32V288z"
    ]
};
var $7435a4b2c8a749a5$export$38611f1c776aba73 = {
    prefix: "far",
    iconName: "file-pdf",
    icon: [
        512,
        512,
        [],
        "f1c1",
        "M64 464l48 0 0 48-48 0c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L229.5 0c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3L384 304l-48 0 0-144-80 0c-17.7 0-32-14.3-32-32l0-80L64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16zM176 352l32 0c30.9 0 56 25.1 56 56s-25.1 56-56 56l-16 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48 0-80c0-8.8 7.2-16 16-16zm32 80c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0 0 48 16 0zm96-80l32 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-32 0c-8.8 0-16-7.2-16-16l0-128c0-8.8 7.2-16 16-16zm32 128c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-16 0 0 96 16 0zm80-112c0-8.8 7.2-16 16-16l48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 32 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64 0-64z"
    ]
};
var $7435a4b2c8a749a5$export$805cd88398a70581 = {
    prefix: "far",
    iconName: "comment",
    icon: [
        512,
        512,
        [
            128489,
            61669
        ],
        "f075",
        "M123.6 391.3c12.9-9.4 29.6-11.8 44.6-6.4c26.5 9.6 56.2 15.1 87.8 15.1c124.7 0 208-80.5 208-160s-83.3-160-208-160S48 160.5 48 240c0 32 12.4 62.8 35.7 89.2c8.6 9.7 12.8 22.5 11.8 35.5c-1.4 18.1-5.7 34.7-11.3 49.4c17-7.9 31.1-16.7 39.4-22.7zM21.2 431.9c1.8-2.7 3.5-5.4 5.1-8.1c10-16.6 19.5-38.4 21.4-62.9C17.7 326.8 0 285.1 0 240C0 125.1 114.6 32 256 32s256 93.1 256 208s-114.6 208-256 208c-37.1 0-72.3-6.4-104.1-17.9c-11.9 8.7-31.3 20.6-54.3 30.6c-15.1 6.6-32.3 12.6-50.1 16.1c-.8 .2-1.6 .3-2.4 .5c-4.4 .8-8.7 1.5-13.2 1.9c-.2 0-.5 .1-.7 .1c-5.1 .5-10.2 .8-15.3 .8c-6.5 0-12.3-3.9-14.8-9.9c-2.5-6-1.1-12.8 3.4-17.4c4.1-4.2 7.8-8.7 11.3-13.5c1.7-2.3 3.3-4.6 4.8-6.9c.1-.2 .2-.3 .3-.5z"
    ]
};
var $7435a4b2c8a749a5$export$6f095630677adc = {
    prefix: "far",
    iconName: "envelope",
    icon: [
        512,
        512,
        [
            128386,
            9993,
            61443
        ],
        "f0e0",
        "M64 112c-8.8 0-16 7.2-16 16v22.1L220.5 291.7c20.7 17 50.4 17 71.1 0L464 150.1V128c0-8.8-7.2-16-16-16H64zM48 212.2V384c0 8.8 7.2 16 16 16H448c8.8 0 16-7.2 16-16V212.2L322 328.8c-38.4 31.5-93.7 31.5-132 0L48 212.2zM0 128C0 92.7 28.7 64 64 64H448c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128z"
    ]
};
var $7435a4b2c8a749a5$export$b9098a890f61e022 = {
    prefix: "far",
    iconName: "hourglass",
    icon: [
        384,
        512,
        [
            9203,
            62032,
            "hourglass-empty"
        ],
        "f254",
        "M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48h8V67c0 40.3 16 79 44.5 107.5L158.1 256 76.5 337.5C48 366 32 404.7 32 445v19H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H360c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8V445c0-40.3-16-79-44.5-107.5L225.9 256l81.5-81.5C336 146 352 107.3 352 67V48h8c13.3 0 24-10.7 24-24s-10.7-24-24-24H24zM192 289.9l81.5 81.5C293 391 304 417.4 304 445v19H80V445c0-27.6 11-54 30.5-73.5L192 289.9zm0-67.9l-81.5-81.5C91 121 80 94.6 80 67V48H304V67c0 27.6-11 54-30.5 73.5L192 222.1z"
    ]
};
var $7435a4b2c8a749a5$export$a2f8176a0161e891 = $7435a4b2c8a749a5$export$b9098a890f61e022;
var $7435a4b2c8a749a5$export$5655108e1162ba45 = {
    prefix: "far",
    iconName: "calendar-check",
    icon: [
        448,
        512,
        [],
        "f274",
        "M128 0c13.3 0 24 10.7 24 24V64H296V24c0-13.3 10.7-24 24-24s24 10.7 24 24V64h40c35.3 0 64 28.7 64 64v16 48V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192 144 128C0 92.7 28.7 64 64 64h40V24c0-13.3 10.7-24 24-24zM400 192H48V448c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V192zM329 297L217 409c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47 95-95c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"
    ]
};
var $7435a4b2c8a749a5$export$4cb736b866cbb7ec = {
    prefix: "far",
    iconName: "hard-drive",
    icon: [
        512,
        512,
        [
            128436,
            "hdd"
        ],
        "f0a0",
        "M64 80c-8.8 0-16 7.2-16 16V258c5.1-1.3 10.5-2 16-2H448c5.5 0 10.9 .7 16 2V96c0-8.8-7.2-16-16-16H64zM48 320v96c0 8.8 7.2 16 16 16H448c8.8 0 16-7.2 16-16V320c0-8.8-7.2-16-16-16H64c-8.8 0-16 7.2-16 16zM0 320V96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V320v96c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V320zm280 48a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm120-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
    ]
};
var $7435a4b2c8a749a5$export$62551e9c5ba7093f = $7435a4b2c8a749a5$export$4cb736b866cbb7ec;
var $7435a4b2c8a749a5$export$8ff56f5ebb8416a0 = {
    prefix: "far",
    iconName: "face-grin-squint-tears",
    icon: [
        512,
        512,
        [
            129315,
            "grin-squint-tears"
        ],
        "f586",
        "M426.8 14.2C446-5 477.5-4.6 497.1 14.9s20 51 .7 70.3c-14.8 14.8-65.7 23.6-88.3 26.7c-5.6 .9-10.3-3.9-9.5-9.5C403.3 79.9 412 29 426.8 14.2zM75 75C158.2-8.3 284.5-22.2 382.2 33.2c-1.5 4.8-2.9 9.6-4.1 14.3c-3.1 12.2-5.5 24.6-7.3 35c-80.8-53.6-190.7-44.8-261.9 26.4C37.7 180.1 28.9 290 82.5 370.8c-10.5 1.8-22.9 4.2-35 7.3c-4.7 1.2-9.5 2.5-14.3 4.1C-22.2 284.5-8.2 158.2 75 75zm389.6 58.9c4.7-1.2 9.5-2.5 14.3-4.1C534.2 227.5 520.2 353.8 437 437c-83.2 83.2-209.5 97.2-307.2 41.8c1.5-4.8 2.8-9.6 4-14.3c3.1-12.2 5.5-24.6 7.3-35c80.8 53.6 190.7 44.8 261.9-26.4c71.2-71.2 80-181.1 26.4-261.9c10.5-1.8 22.9-4.2 35-7.3zm-105.4 93c10.1-16.3 33.9-16.9 37.9 1.9c9.5 44.4-3.7 93.5-39.3 129.1s-84.8 48.8-129.1 39.3c-18.7-4-18.2-27.8-1.9-37.9c25.2-15.7 50.2-35.4 73.6-58.8s43.1-48.4 58.8-73.6zM92 265.3l97.4-29.7c11.6-3.5 22.5 7.3 19 19l-29.7 97.4c-2.6 8.6-13.4 11.3-19.8 4.9c-2-2-3.2-4.6-3.4-7.3l-5.1-56.1-56.1-5.1c-2.8-.3-5.4-1.5-7.3-3.4c-6.3-6.3-3.6-17.2 4.9-19.8zm193-178.2c2 2 3.2 4.6 3.4 7.3l5.1 56.1 56.1 5.1c2.8 .3 5.4 1.5 7.3 3.4c6.3 6.3 3.6 17.2-4.9 19.8l-97.4 29.7c-11.6 3.5-22.5-7.3-19-19L265.3 92c2.6-8.6 13.4-11.3 19.8-4.9zM14.9 497.1c-19.6-19.6-20-51-.7-70.3C29 412 79.8 403.2 102.4 400.1c5.6-.9 10.3 3.9 9.5 9.5c-3.2 22.5-11.9 73.5-26.7 88.3C66 517 34.5 516.6 14.9 497.1z"
    ]
};
var $7435a4b2c8a749a5$export$542206d6a85f3b42 = $7435a4b2c8a749a5$export$8ff56f5ebb8416a0;
var $7435a4b2c8a749a5$export$1f7600fa9fdb3978 = {
    prefix: "far",
    iconName: "rectangle-list",
    icon: [
        576,
        512,
        [
            "list-alt"
        ],
        "f022",
        "M64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H512c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96C0 60.7 28.7 32 64 32H512c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm96 64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm104 0c0-13.3 10.7-24 24-24H448c13.3 0 24 10.7 24 24s-10.7 24-24 24H224c-13.3 0-24-10.7-24-24zm0 96c0-13.3 10.7-24 24-24H448c13.3 0 24 10.7 24 24s-10.7 24-24 24H224c-13.3 0-24-10.7-24-24zm0 96c0-13.3 10.7-24 24-24H448c13.3 0 24 10.7 24 24s-10.7 24-24 24H224c-13.3 0-24-10.7-24-24zm-72-64a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM96 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
    ]
};
var $7435a4b2c8a749a5$export$c6327a203ffc65a3 = $7435a4b2c8a749a5$export$1f7600fa9fdb3978;
var $7435a4b2c8a749a5$export$16768a660ae3ca9d = {
    prefix: "far",
    iconName: "calendar-plus",
    icon: [
        448,
        512,
        [],
        "f271",
        "M152 24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H64C28.7 64 0 92.7 0 128v16 48V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V192 144 128c0-35.3-28.7-64-64-64H344V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H152V24zM48 192H400V448c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V192zm176 40c-13.3 0-24 10.7-24 24v48H152c-13.3 0-24 10.7-24 24s10.7 24 24 24h48v48c0 13.3 10.7 24 24 24s24-10.7 24-24V352h48c13.3 0 24-10.7 24-24s-10.7-24-24-24H248V256c0-13.3-10.7-24-24-24z"
    ]
};
var $7435a4b2c8a749a5$export$5ae86b9da9cca3bd = {
    prefix: "far",
    iconName: "circle-left",
    icon: [
        512,
        512,
        [
            61840,
            "arrow-alt-circle-left"
        ],
        "f359",
        "M48 256a208 208 0 1 1 416 0A208 208 0 1 1 48 256zm464 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM217.4 376.9c4.2 4.5 10.1 7.1 16.3 7.1c12.3 0 22.3-10 22.3-22.3V304h96c17.7 0 32-14.3 32-32V240c0-17.7-14.3-32-32-32H256V150.3c0-12.3-10-22.3-22.3-22.3c-6.2 0-12.1 2.6-16.3 7.1L117.5 242.2c-3.5 3.8-5.5 8.7-5.5 13.8s2 10.1 5.5 13.8l99.9 107.1z"
    ]
};
var $7435a4b2c8a749a5$export$5460a5b11a24996f = $7435a4b2c8a749a5$export$5ae86b9da9cca3bd;
var $7435a4b2c8a749a5$export$a312c7d58dd44a75 = {
    prefix: "far",
    iconName: "money-bill-1",
    icon: [
        576,
        512,
        [
            "money-bill-alt"
        ],
        "f3d1",
        "M112 112c0 35.3-28.7 64-64 64V336c35.3 0 64 28.7 64 64H464c0-35.3 28.7-64 64-64V176c-35.3 0-64-28.7-64-64H112zM0 128C0 92.7 28.7 64 64 64H512c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zM176 256a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm80-48c0 8.8 7.2 16 16 16v64h-8c-8.8 0-16 7.2-16 16s7.2 16 16 16h24 24c8.8 0 16-7.2 16-16s-7.2-16-16-16h-8V208c0-8.8-7.2-16-16-16H272c-8.8 0-16 7.2-16 16z"
    ]
};
var $7435a4b2c8a749a5$export$a35d573395884c3d = $7435a4b2c8a749a5$export$a312c7d58dd44a75;
var $7435a4b2c8a749a5$export$95b9968e7fceb821 = {
    prefix: "far",
    iconName: "clock",
    icon: [
        512,
        512,
        [
            128339,
            "clock-four"
        ],
        "f017",
        "M464 256A208 208 0 1 1 48 256a208 208 0 1 1 416 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM232 120V256c0 8 4 15.5 10.7 20l96 64c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L280 243.2V120c0-13.3-10.7-24-24-24s-24 10.7-24 24z"
    ]
};
var $7435a4b2c8a749a5$export$9a575facf1cab48f = $7435a4b2c8a749a5$export$95b9968e7fceb821;
var $7435a4b2c8a749a5$export$fb61df5d98785fa8 = {
    prefix: "far",
    iconName: "keyboard",
    icon: [
        576,
        512,
        [
            9000
        ],
        "f11c",
        "M64 112c-8.8 0-16 7.2-16 16V384c0 8.8 7.2 16 16 16H512c8.8 0 16-7.2 16-16V128c0-8.8-7.2-16-16-16H64zM0 128C0 92.7 28.7 64 64 64H512c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zM176 320H400c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V336c0-8.8 7.2-16 16-16zm-72-72c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H120c-8.8 0-16-7.2-16-16V248zm16-96h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H120c-8.8 0-16-7.2-16-16V168c0-8.8 7.2-16 16-16zm64 96c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H200c-8.8 0-16-7.2-16-16V248zm16-96h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H200c-8.8 0-16-7.2-16-16V168c0-8.8 7.2-16 16-16zm64 96c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H280c-8.8 0-16-7.2-16-16V248zm16-96h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H280c-8.8 0-16-7.2-16-16V168c0-8.8 7.2-16 16-16zm64 96c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H360c-8.8 0-16-7.2-16-16V248zm16-96h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H360c-8.8 0-16-7.2-16-16V168c0-8.8 7.2-16 16-16zm64 96c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H440c-8.8 0-16-7.2-16-16V248zm16-96h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H440c-8.8 0-16-7.2-16-16V168c0-8.8 7.2-16 16-16z"
    ]
};
var $7435a4b2c8a749a5$export$8e047801a8603af7 = {
    prefix: "far",
    iconName: "closed-captioning",
    icon: [
        576,
        512,
        [],
        "f20a",
        "M512 80c8.8 0 16 7.2 16 16V416c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16H512zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM200 208c14.2 0 27 6.1 35.8 16c8.8 9.9 24 10.7 33.9 1.9s10.7-24 1.9-33.9c-17.5-19.6-43.1-32-71.5-32c-53 0-96 43-96 96s43 96 96 96c28.4 0 54-12.4 71.5-32c8.8-9.9 8-25-1.9-33.9s-25-8-33.9 1.9c-8.8 9.9-21.6 16-35.8 16c-26.5 0-48-21.5-48-48s21.5-48 48-48zm144 48c0-26.5 21.5-48 48-48c14.2 0 27 6.1 35.8 16c8.8 9.9 24 10.7 33.9 1.9s10.7-24 1.9-33.9c-17.5-19.6-43.1-32-71.5-32c-53 0-96 43-96 96s43 96 96 96c28.4 0 54-12.4 71.5-32c8.8-9.9 8-25-1.9-33.9s-25-8-33.9 1.9c-8.8 9.9-21.6 16-35.8 16c-26.5 0-48-21.5-48-48z"
    ]
};
var $7435a4b2c8a749a5$export$74f06b41ed2ca28a = {
    prefix: "far",
    iconName: "images",
    icon: [
        576,
        512,
        [],
        "f302",
        "M160 80H512c8.8 0 16 7.2 16 16V320c0 8.8-7.2 16-16 16H490.8L388.1 178.9c-4.4-6.8-12-10.9-20.1-10.9s-15.7 4.1-20.1 10.9l-52.2 79.8-12.4-16.9c-4.5-6.2-11.7-9.8-19.4-9.8s-14.8 3.6-19.4 9.8L175.6 336H160c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16zM96 96V320c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H160c-35.3 0-64 28.7-64 64zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120V344c0 75.1 60.9 136 136 136H456c13.3 0 24-10.7 24-24s-10.7-24-24-24H136c-48.6 0-88-39.4-88-88V120zm208 24a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"
    ]
};
var $7435a4b2c8a749a5$export$92292137ef3cf4c8 = {
    prefix: "far",
    iconName: "face-grin",
    icon: [
        512,
        512,
        [
            128512,
            "grin"
        ],
        "f580",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm349.5 52.4c18.7-4.4 35.9 12 25.5 28.1C350.4 374.6 306.3 400 255.9 400s-94.5-25.4-119.1-63.5c-10.4-16.1 6.8-32.5 25.5-28.1c28.9 6.8 60.5 10.5 93.6 10.5s64.7-3.7 93.6-10.5zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $7435a4b2c8a749a5$export$37e1f10b6de76621 = $7435a4b2c8a749a5$export$92292137ef3cf4c8;
var $7435a4b2c8a749a5$export$dc130582748497c6 = {
    prefix: "far",
    iconName: "face-meh",
    icon: [
        512,
        512,
        [
            128528,
            "meh"
        ],
        "f11a",
        "M464 256A208 208 0 1 1 48 256a208 208 0 1 1 416 0zM256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM176.4 240a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm192-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM184 328c-13.3 0-24 10.7-24 24s10.7 24 24 24H328c13.3 0 24-10.7 24-24s-10.7-24-24-24H184z"
    ]
};
var $7435a4b2c8a749a5$export$6d2db489aaeeecd2 = $7435a4b2c8a749a5$export$dc130582748497c6;
var $7435a4b2c8a749a5$export$782ac893fc22249b = {
    prefix: "far",
    iconName: "id-card",
    icon: [
        576,
        512,
        [
            62147,
            "drivers-license"
        ],
        "f2c2",
        "M528 160V416c0 8.8-7.2 16-16 16H320c0-44.2-35.8-80-80-80H176c-44.2 0-80 35.8-80 80H64c-8.8 0-16-7.2-16-16V160H528zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM272 256a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm104-48c-13.3 0-24 10.7-24 24s10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24H376zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24H376z"
    ]
};
var $7435a4b2c8a749a5$export$8359c70e609eff64 = $7435a4b2c8a749a5$export$782ac893fc22249b;
var $7435a4b2c8a749a5$export$2fa35dcbc038dbe9 = {
    prefix: "far",
    iconName: "sun",
    icon: [
        512,
        512,
        [
            9728
        ],
        "f185",
        "M375.7 19.7c-1.5-8-6.9-14.7-14.4-17.8s-16.1-2.2-22.8 2.4L256 61.1 173.5 4.2c-6.7-4.6-15.3-5.5-22.8-2.4s-12.9 9.8-14.4 17.8l-18.1 98.5L19.7 136.3c-8 1.5-14.7 6.9-17.8 14.4s-2.2 16.1 2.4 22.8L61.1 256 4.2 338.5c-4.6 6.7-5.5 15.3-2.4 22.8s9.8 13 17.8 14.4l98.5 18.1 18.1 98.5c1.5 8 6.9 14.7 14.4 17.8s16.1 2.2 22.8-2.4L256 450.9l82.5 56.9c6.7 4.6 15.3 5.5 22.8 2.4s12.9-9.8 14.4-17.8l18.1-98.5 98.5-18.1c8-1.5 14.7-6.9 17.8-14.4s2.2-16.1-2.4-22.8L450.9 256l56.9-82.5c4.6-6.7 5.5-15.3 2.4-22.8s-9.8-12.9-17.8-14.4l-98.5-18.1L375.7 19.7zM269.6 110l65.6-45.2 14.4 78.3c1.8 9.8 9.5 17.5 19.3 19.3l78.3 14.4L402 242.4c-5.7 8.2-5.7 19 0 27.2l45.2 65.6-78.3 14.4c-9.8 1.8-17.5 9.5-19.3 19.3l-14.4 78.3L269.6 402c-8.2-5.7-19-5.7-27.2 0l-65.6 45.2-14.4-78.3c-1.8-9.8-9.5-17.5-19.3-19.3L64.8 335.2 110 269.6c5.7-8.2 5.7-19 0-27.2L64.8 176.8l78.3-14.4c9.8-1.8 17.5-9.5 19.3-19.3l14.4-78.3L242.4 110c8.2 5.7 19 5.7 27.2 0zM256 368a112 112 0 1 0 0-224 112 112 0 1 0 0 224zM192 256a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z"
    ]
};
var $7435a4b2c8a749a5$export$600a1b26b33c3d47 = {
    prefix: "far",
    iconName: "face-laugh-wink",
    icon: [
        512,
        512,
        [
            "laugh-wink"
        ],
        "f59c",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm130.7 57.9c-4.2-13.6 7.1-25.9 21.3-25.9H364.5c14.2 0 25.5 12.4 21.3 25.9C369 368.4 318.2 408 258.2 408s-110.8-39.6-127.5-94.1zM144.4 192a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm165.8 21.7c-7.6 8.1-20.2 8.5-28.3 .9s-8.5-20.2-.9-28.3c14.5-15.5 35.2-22.3 54.6-22.3s40.1 6.8 54.6 22.3c7.6 8.1 7.1 20.7-.9 28.3s-20.7 7.1-28.3-.9c-5.5-5.8-14.8-9.7-25.4-9.7s-19.9 3.8-25.4 9.7z"
    ]
};
var $7435a4b2c8a749a5$export$77ac40095f39933e = $7435a4b2c8a749a5$export$600a1b26b33c3d47;
var $7435a4b2c8a749a5$export$531badb89cf01312 = {
    prefix: "far",
    iconName: "circle-down",
    icon: [
        512,
        512,
        [
            61466,
            "arrow-alt-circle-down"
        ],
        "f358",
        "M256 464a208 208 0 1 1 0-416 208 208 0 1 1 0 416zM256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM376.9 294.6c4.5-4.2 7.1-10.1 7.1-16.3c0-12.3-10-22.3-22.3-22.3H304V160c0-17.7-14.3-32-32-32l-32 0c-17.7 0-32 14.3-32 32v96H150.3C138 256 128 266 128 278.3c0 6.2 2.6 12.1 7.1 16.3l107.1 99.9c3.8 3.5 8.7 5.5 13.8 5.5s10.1-2 13.8-5.5l107.1-99.9z"
    ]
};
var $7435a4b2c8a749a5$export$ff3afbc8c0bc5d59 = $7435a4b2c8a749a5$export$531badb89cf01312;
var $7435a4b2c8a749a5$export$aba24ca305bbe8c1 = {
    prefix: "far",
    iconName: "thumbs-down",
    icon: [
        512,
        512,
        [
            128078,
            61576
        ],
        "f165",
        "M323.8 477.2c-38.2 10.9-78.1-11.2-89-49.4l-5.7-20c-3.7-13-10.4-25-19.5-35l-51.3-56.4c-8.9-9.8-8.2-25 1.6-33.9s25-8.2 33.9 1.6l51.3 56.4c14.1 15.5 24.4 34 30.1 54.1l5.7 20c3.6 12.7 16.9 20.1 29.7 16.5s20.1-16.9 16.5-29.7l-5.7-20c-5.7-19.9-14.7-38.7-26.6-55.5c-5.2-7.3-5.8-16.9-1.7-24.9s12.3-13 21.3-13L448 288c8.8 0 16-7.2 16-16c0-6.8-4.3-12.7-10.4-15c-7.4-2.8-13-9-14.9-16.7s.1-15.8 5.3-21.7c2.5-2.8 4-6.5 4-10.6c0-7.8-5.6-14.3-13-15.7c-8.2-1.6-15.1-7.3-18-15.2s-1.6-16.7 3.6-23.3c2.1-2.7 3.4-6.1 3.4-9.9c0-6.7-4.2-12.6-10.2-14.9c-11.5-4.5-17.7-16.9-14.4-28.8c.4-1.3 .6-2.8 .6-4.3c0-8.8-7.2-16-16-16H286.5c-12.6 0-25 3.7-35.5 10.7l-61.7 41.1c-11 7.4-25.9 4.4-33.3-6.7s-4.4-25.9 6.7-33.3l61.7-41.1c18.4-12.3 40-18.8 62.1-18.8H384c34.7 0 62.9 27.6 64 62c14.6 11.7 24 29.7 24 50c0 4.5-.5 8.8-1.3 13c15.4 11.7 25.3 30.2 25.3 51c0 6.5-1 12.8-2.8 18.7C504.8 238.3 512 254.3 512 272c0 35.3-28.6 64-64 64l-92.3 0c4.7 10.4 8.7 21.2 11.8 32.2l5.7 20c10.9 38.2-11.2 78.1-49.4 89zM32 384c-17.7 0-32-14.3-32-32V128c0-17.7 14.3-32 32-32H96c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H32z"
    ]
};
var $7435a4b2c8a749a5$export$3db75d5ac9e98468 = {
    prefix: "far",
    iconName: "chess-pawn",
    icon: [
        320,
        512,
        [
            9823
        ],
        "f443",
        "M232 152A72 72 0 1 0 88 152a72 72 0 1 0 144 0zm24 120H243.4l10.7 80H205.7L195 272H160 125l-10.7 80H65.9l10.7-80H64c-13.3 0-24-10.7-24-24s10.7-24 24-24c-15.1-20.1-24-45-24-72C40 85.7 93.7 32 160 32s120 53.7 120 120c0 27-8.9 51.9-24 72c13.3 0 24 10.7 24 24s-10.7 24-24 24zM52.7 464H267.3l-16.6-32H69.2L52.7 464zm207.9-80c12 0 22.9 6.7 28.4 17.3l26.5 51.2c3 5.8 4.6 12.2 4.6 18.7c0 22.5-18.2 40.8-40.8 40.8H40.8C18.2 512 0 493.8 0 471.2c0-6.5 1.6-12.9 4.6-18.7l26.5-51.2C36.5 390.7 47.5 384 59.5 384h201z"
    ]
};
var $7435a4b2c8a749a5$export$3e7437bf6535bef0 = {
    prefix: "far",
    iconName: "credit-card",
    icon: [
        576,
        512,
        [
            128179,
            62083,
            "credit-card-alt"
        ],
        "f09d",
        "M512 80c8.8 0 16 7.2 16 16v32H48V96c0-8.8 7.2-16 16-16H512zm16 144V416c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V224H528zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm56 304c-13.3 0-24 10.7-24 24s10.7 24 24 24h48c13.3 0 24-10.7 24-24s-10.7-24-24-24H120zm128 0c-13.3 0-24 10.7-24 24s10.7 24 24 24H360c13.3 0 24-10.7 24-24s-10.7-24-24-24H248z"
    ]
};
var $7435a4b2c8a749a5$export$5fffe8e3c36964a2 = $7435a4b2c8a749a5$export$3e7437bf6535bef0;
var $7435a4b2c8a749a5$export$9b6162797ab1b255 = {
    prefix: "far",
    iconName: "bell",
    icon: [
        448,
        512,
        [
            128276,
            61602
        ],
        "f0f3",
        "M224 0c-17.7 0-32 14.3-32 32V51.2C119 66 64 130.6 64 208v25.4c0 45.4-15.5 89.5-43.8 124.9L5.3 377c-5.8 7.2-6.9 17.1-2.9 25.4S14.8 416 24 416H424c9.2 0 17.6-5.3 21.6-13.6s2.9-18.2-2.9-25.4l-14.9-18.6C399.5 322.9 384 278.8 384 233.4V208c0-77.4-55-142-128-156.8V32c0-17.7-14.3-32-32-32zm0 96c61.9 0 112 50.1 112 112v25.4c0 47.9 13.9 94.6 39.7 134.6H72.3C98.1 328 112 281.3 112 233.4V208c0-61.9 50.1-112 112-112zm64 352H224 160c0 17 6.7 33.3 18.7 45.3s28.3 18.7 45.3 18.7s33.3-6.7 45.3-18.7s18.7-28.3 18.7-45.3z"
    ]
};
var $7435a4b2c8a749a5$export$cad54bead856a678 = {
    prefix: "far",
    iconName: "file",
    icon: [
        384,
        512,
        [
            128196,
            128459,
            61462
        ],
        "f15b",
        "M320 464c8.8 0 16-7.2 16-16V160H256c-17.7 0-32-14.3-32-32V48H64c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16H320zM0 64C0 28.7 28.7 0 64 0H229.5c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64z"
    ]
};
var $7435a4b2c8a749a5$export$7a76c9d35b42d691 = {
    prefix: "far",
    iconName: "hospital",
    icon: [
        640,
        512,
        [
            127973,
            62589,
            "hospital-alt",
            "hospital-wide"
        ],
        "f0f8",
        "M232 0c-39.8 0-72 32.2-72 72v8H72C32.2 80 0 112.2 0 152V440c0 39.8 32.2 72 72 72h.2 .2 .2 .2 .2H73h.2 .2 .2 .2 .2 .2 .2 .2 .2 .2H75h.2 .2 .2 .2 .2 .2 .2 .2 .2 .2H77h.2 .2 .2 .2 .2 .2 .2 .2 .2 .2H79h.2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2H82h.2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2H85h.2 .2 .2 .2H86h.2 .2 .2 .2H87h.2 .2 .2 .2H88h.2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2H98h.2 .2 .2 .2H99h.2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2v0H456h8v0H568c39.8 0 72-32.2 72-72V152c0-39.8-32.2-72-72-72H480V72c0-39.8-32.2-72-72-72H232zM480 128h88c13.3 0 24 10.7 24 24v40H536c-13.3 0-24 10.7-24 24s10.7 24 24 24h56v48H536c-13.3 0-24 10.7-24 24s10.7 24 24 24h56V440c0 13.3-10.7 24-24 24H480V336 128zM72 128h88V464h-.1-.2-.2-.2H159h-.2-.2-.2H158h-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2H154h-.2-.2-.2H153h-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2H150h-.2-.2-.2H149h-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2H146h-.2-.2-.2H145h-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2H142h-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2H139h-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2H136h-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2H133h-.2-.2-.2-.2-.2-.2-.2-.2H131h-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2H128h-.2-.2-.2-.2-.2-.2-.2-.2H126h-.2-.2-.2-.2-.2-.2-.2-.2H124h-.2-.2-.2-.2-.2-.2-.2-.2H122h-.2-.2-.2-.2-.2-.2-.2-.2H120h-.2-.2-.2-.2-.2-.2-.2-.2H118h-.2-.2-.2-.2-.2-.2-.2-.2H116h-.2-.2-.2-.2-.2-.2-.2-.2H114h-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2H111h-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2H108h-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2H105h-.2-.2-.2-.2H104h-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2H100h-.2-.2-.2-.2H99h-.2-.2-.2-.2H98h-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2H88h-.2-.2-.2-.2H87h-.2-.2-.2-.2H86h-.2-.2-.2-.2H85h-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2H82h-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2H79h-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2H77h-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2H75h-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2H73h-.2-.2-.2-.2-.2H72c-13.2 0-24-10.7-24-24V336h56c13.3 0 24-10.7 24-24s-10.7-24-24-24H48V240h56c13.3 0 24-10.7 24-24s-10.7-24-24-24H48V152c0-13.3 10.7-24 24-24zM208 72c0-13.3 10.7-24 24-24H408c13.3 0 24 10.7 24 24V336 464H368V400c0-26.5-21.5-48-48-48s-48 21.5-48 48v64H208V72zm88 24v24H272c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h24v24c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V168h24c8.8 0 16-7.2 16-16V136c0-8.8-7.2-16-16-16H344V96c0-8.8-7.2-16-16-16H312c-8.8 0-16 7.2-16 16z"
    ]
};
var $7435a4b2c8a749a5$export$cea7736417b94a3b = $7435a4b2c8a749a5$export$7a76c9d35b42d691;
var $7435a4b2c8a749a5$export$69c8cc0360f017e8 = $7435a4b2c8a749a5$export$7a76c9d35b42d691;
var $7435a4b2c8a749a5$export$5d65c40a109eb09c = {
    prefix: "far",
    iconName: "chess-rook",
    icon: [
        448,
        512,
        [
            9820
        ],
        "f447",
        "M80 80V192c0 2.5 1.2 4.9 3.2 6.4l51.2 38.4c6.8 5.1 10.4 13.4 9.5 21.9L133.5 352H85.2l9.4-85L54.4 236.8C40.3 226.2 32 209.6 32 192V72c0-22.1 17.9-40 40-40H376c22.1 0 40 17.9 40 40V192c0 17.6-8.3 34.2-22.4 44.8L353.4 267l9.4 85H314.5l-10.4-93.3c-.9-8.4 2.7-16.8 9.5-21.9l51.2-38.4c2-1.5 3.2-3.9 3.2-6.4V80H304v24c0 13.3-10.7 24-24 24s-24-10.7-24-24V80H192v24c0 13.3-10.7 24-24 24s-24-10.7-24-24V80H80zm4.7 384H363.3l-16.6-32H101.2L84.7 464zm271.9-80c12 0 22.9 6.7 28.4 17.3l26.5 51.2c3 5.8 4.6 12.2 4.6 18.7c0 22.5-18.2 40.8-40.8 40.8H72.8C50.2 512 32 493.8 32 471.2c0-6.5 1.6-12.9 4.6-18.7l26.5-51.2C68.5 390.7 79.5 384 91.5 384h265zM208 288c-8.8 0-16-7.2-16-16V224c0-17.7 14.3-32 32-32s32 14.3 32 32v48c0 8.8-7.2 16-16 16H208z"
    ]
};
var $7435a4b2c8a749a5$export$228008b5e11032fa = {
    prefix: "far",
    iconName: "star-half",
    icon: [
        576,
        512,
        [
            61731
        ],
        "f089",
        "M293.3 .6c10.9 2.5 18.6 12.2 18.6 23.4V408.7c0 8.9-4.9 17-12.7 21.2L151 509.1c-8.1 4.3-17.9 3.7-25.3-1.7s-11.2-14.5-9.7-23.5l26.2-155.6L31.1 218.3c-6.5-6.4-8.7-15.9-5.9-24.5s10.3-14.9 19.3-16.3l153.2-22.6L266.3 13.5c4.9-10.1 16.1-15.4 27-12.9zM263.9 128.4l-28.6 58.8c-3.5 7.1-10.2 12.1-18.1 13.3L99 217.9 184.9 303c5.5 5.5 8.1 13.3 6.8 21L171.4 443.7l92.5-49.4V128.4z"
    ]
};
var $7435a4b2c8a749a5$export$d5713874f8fefe1b = {
    prefix: "far",
    iconName: "chess-king",
    icon: [
        448,
        512,
        [
            9818
        ],
        "f43f",
        "M248 24c0-13.3-10.7-24-24-24s-24 10.7-24 24V56H168c-13.3 0-24 10.7-24 24s10.7 24 24 24h32v40H59.6C26.7 144 0 170.7 0 203.6c0 8.2 1.7 16.3 4.9 23.8L59.1 352h52.3L49 208.2c-.6-1.5-1-3-1-4.6c0-6.4 5.2-11.6 11.6-11.6H224 388.4c6.4 0 11.6 5.2 11.6 11.6c0 1.6-.3 3.2-1 4.6L336.5 352h52.3l54.2-124.6c3.3-7.5 4.9-15.6 4.9-23.8c0-32.9-26.7-59.6-59.6-59.6H248V104h32c13.3 0 24-10.7 24-24s-10.7-24-24-24H248V24zM101.2 432H346.8l16.6 32H84.7l16.6-32zm283.7-30.7c-5.5-10.6-16.5-17.3-28.4-17.3H91.5c-12 0-22.9 6.7-28.4 17.3L36.6 452.5c-3 5.8-4.6 12.2-4.6 18.7C32 493.8 50.2 512 72.8 512H375.2c22.5 0 40.8-18.2 40.8-40.8c0-6.5-1.6-12.9-4.6-18.7l-26.5-51.2z"
    ]
};
var $7435a4b2c8a749a5$export$9a5c11a5e3d7f1e7 = {
    prefix: "far",
    iconName: "circle-user",
    icon: [
        512,
        512,
        [
            62142,
            "user-circle"
        ],
        "f2bd",
        "M406.5 399.6C387.4 352.9 341.5 320 288 320H224c-53.5 0-99.4 32.9-118.5 79.6C69.9 362.2 48 311.7 48 256C48 141.1 141.1 48 256 48s208 93.1 208 208c0 55.7-21.9 106.2-57.5 143.6zm-40.1 32.7C334.4 452.4 296.6 464 256 464s-78.4-11.6-110.5-31.7c7.3-36.7 39.7-64.3 78.5-64.3h64c38.8 0 71.2 27.6 78.5 64.3zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-272a40 40 0 1 1 0-80 40 40 0 1 1 0 80zm-88-40a88 88 0 1 0 176 0 88 88 0 1 0 -176 0z"
    ]
};
var $7435a4b2c8a749a5$export$be7d974e9e0dba1a = $7435a4b2c8a749a5$export$9a5c11a5e3d7f1e7;
var $7435a4b2c8a749a5$export$e9bd786d30cb716c = {
    prefix: "far",
    iconName: "copy",
    icon: [
        448,
        512,
        [],
        "f0c5",
        "M384 336H192c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16l140.1 0L400 115.9V320c0 8.8-7.2 16-16 16zM192 384H384c35.3 0 64-28.7 64-64V115.9c0-12.7-5.1-24.9-14.1-33.9L366.1 14.1c-9-9-21.2-14.1-33.9-14.1H192c-35.3 0-64 28.7-64 64V320c0 35.3 28.7 64 64 64zM64 128c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H256c35.3 0 64-28.7 64-64V416H272v32c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V192c0-8.8 7.2-16 16-16H96V128H64z"
    ]
};
var $7435a4b2c8a749a5$export$928280bdd54fa173 = {
    prefix: "far",
    iconName: "share-from-square",
    icon: [
        576,
        512,
        [
            61509,
            "share-square"
        ],
        "f14d",
        "M400 255.4V240 208c0-8.8-7.2-16-16-16H352 336 289.5c-50.9 0-93.9 33.5-108.3 79.6c-3.3-9.4-5.2-19.8-5.2-31.6c0-61.9 50.1-112 112-112h48 16 32c8.8 0 16-7.2 16-16V80 64.6L506 160 400 255.4zM336 240h16v48c0 17.7 14.3 32 32 32h3.7c7.9 0 15.5-2.9 21.4-8.2l139-125.1c7.6-6.8 11.9-16.5 11.9-26.7s-4.3-19.9-11.9-26.7L409.9 8.9C403.5 3.2 395.3 0 386.7 0C367.5 0 352 15.5 352 34.7V80H336 304 288c-88.4 0-160 71.6-160 160c0 60.4 34.6 99.1 63.9 120.9c5.9 4.4 11.5 8.1 16.7 11.2c4.4 2.7 8.5 4.9 11.9 6.6c3.4 1.7 6.2 3 8.2 3.9c2.2 1 4.6 1.4 7.1 1.4h2.5c9.8 0 17.8-8 17.8-17.8c0-7.8-5.3-14.7-11.6-19.5l0 0c-.4-.3-.7-.5-1.1-.8c-1.7-1.1-3.4-2.5-5-4.1c-.8-.8-1.7-1.6-2.5-2.6s-1.6-1.9-2.4-2.9c-1.8-2.5-3.5-5.3-5-8.5c-2.6-6-4.3-13.3-4.3-22.4c0-36.1 29.3-65.5 65.5-65.5H304h32zM72 32C32.2 32 0 64.2 0 104V440c0 39.8 32.2 72 72 72H408c39.8 0 72-32.2 72-72V376c0-13.3-10.7-24-24-24s-24 10.7-24 24v64c0 13.3-10.7 24-24 24H72c-13.3 0-24-10.7-24-24V104c0-13.3 10.7-24 24-24h64c13.3 0 24-10.7 24-24s-10.7-24-24-24H72z"
    ]
};
var $7435a4b2c8a749a5$export$ae9e1434571f373c = $7435a4b2c8a749a5$export$928280bdd54fa173;
var $7435a4b2c8a749a5$export$da61665fff8aebfe = {
    prefix: "far",
    iconName: "copyright",
    icon: [
        512,
        512,
        [
            169
        ],
        "f1f9",
        "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM199.4 312.6c-31.2-31.2-31.2-81.9 0-113.1s81.9-31.2 113.1 0c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9c-50-50-131-50-181 0s-50 131 0 181s131 50 181 0c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0c-31.2 31.2-81.9 31.2-113.1 0z"
    ]
};
var $7435a4b2c8a749a5$export$fc82fb79180cd17c = {
    prefix: "far",
    iconName: "map",
    icon: [
        576,
        512,
        [
            128506,
            62072
        ],
        "f279",
        "M565.6 36.2C572.1 40.7 576 48.1 576 56V392c0 10-6.2 18.9-15.5 22.4l-168 64c-5.2 2-10.9 2.1-16.1 .3L192.5 417.5l-160 61c-7.4 2.8-15.7 1.8-22.2-2.7S0 463.9 0 456V120c0-10 6.1-18.9 15.5-22.4l168-64c5.2-2 10.9-2.1 16.1-.3L383.5 94.5l160-61c7.4-2.8 15.7-1.8 22.2 2.7zM48 136.5V421.2l120-45.7V90.8L48 136.5zM360 422.7V137.3l-144-48V374.7l144 48zm48-1.5l120-45.7V90.8L408 136.5V421.2z"
    ]
};
var $7435a4b2c8a749a5$export$6b31a1e5968b2378 = {
    prefix: "far",
    iconName: "bell-slash",
    icon: [
        640,
        512,
        [
            128277,
            61943
        ],
        "f1f6",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L542.6 400c2.7-7.8 1.3-16.5-3.9-23l-14.9-18.6C495.5 322.9 480 278.8 480 233.4V208c0-77.4-55-142-128-156.8V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V51.2c-42.6 8.6-79 34.2-102 69.3L38.8 5.1zM224 150.3C243.6 117.7 279.3 96 320 96c61.9 0 112 50.1 112 112v25.4c0 32.7 6.4 64.8 18.7 94.5L224 150.3zM406.2 416l-60.9-48H168.3c21.2-32.8 34.4-70.3 38.4-109.1L160 222.1v11.4c0 45.4-15.5 89.5-43.8 124.9L101.3 377c-5.8 7.2-6.9 17.1-2.9 25.4s12.4 13.6 21.6 13.6H406.2zM384 448H320 256c0 17 6.7 33.3 18.7 45.3s28.3 18.7 45.3 18.7s33.3-6.7 45.3-18.7s18.7-28.3 18.7-45.3z"
    ]
};
var $7435a4b2c8a749a5$export$54608d0a883fea4d = {
    prefix: "far",
    iconName: "hand-lizard",
    icon: [
        512,
        512,
        [],
        "f258",
        "M72 112c-13.3 0-24 10.7-24 24s10.7 24 24 24H240c35.3 0 64 28.7 64 64s-28.7 64-64 64H136c-13.3 0-24 10.7-24 24s10.7 24 24 24H288c4.5 0 8.9 1.3 12.7 3.6l64 40c7 4.4 11.3 12.1 11.3 20.4v24c0 13.3-10.7 24-24 24s-24-10.7-24-24V413.3L281.1 384H136c-39.8 0-72-32.2-72-72s32.2-72 72-72H240c8.8 0 16-7.2 16-16s-7.2-16-16-16H72c-39.8 0-72-32.2-72-72S32.2 64 72 64H281.6c46.7 0 90.9 21.5 119.7 58.3l78.4 100.1c20.9 26.7 32.3 59.7 32.3 93.7V424c0 13.3-10.7 24-24 24s-24-10.7-24-24V316.1c0-23.2-7.8-45.8-22.1-64.1L363.5 151.9c-19.7-25.2-49.9-39.9-81.9-39.9H72z"
    ]
};
var $7435a4b2c8a749a5$export$b5023c446f10324 = {
    prefix: "far",
    iconName: "face-smile",
    icon: [
        512,
        512,
        [
            128578,
            "smile"
        ],
        "f118",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm177.6 62.1C192.8 334.5 218.8 352 256 352s63.2-17.5 78.4-33.9c9-9.7 24.2-10.4 33.9-1.4s10.4 24.2 1.4 33.9c-22 23.8-60 49.4-113.6 49.4s-91.7-25.5-113.6-49.4c-9-9.7-8.4-24.9 1.4-33.9s24.9-8.4 33.9 1.4zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $7435a4b2c8a749a5$export$c632b2334f0913bc = $7435a4b2c8a749a5$export$b5023c446f10324;
var $7435a4b2c8a749a5$export$e49e3cfceea441cc = {
    prefix: "far",
    iconName: "hand-peace",
    icon: [
        512,
        512,
        [
            9996
        ],
        "f25b",
        "M250.8 1.4c-35.2-3.7-66.6 21.8-70.3 57L174 119 156.7 69.6C145 36.3 108.4 18.8 75.1 30.5S24.2 78.8 35.9 112.1L88.7 262.2C73.5 276.7 64 297.3 64 320v0 24c0 92.8 75.2 168 168 168h48c92.8 0 168-75.2 168-168V272 256 224c0-35.3-28.7-64-64-64c-7.9 0-15.4 1.4-22.4 4c-10.4-21.3-32.3-36-57.6-36c-.7 0-1.5 0-2.2 0l5.9-56.3c3.7-35.2-21.8-66.6-57-70.3zm-.2 155.4C243.9 166.9 240 179 240 192v48c0 .7 0 1.4 0 2c-5.1-1.3-10.5-2-16-2h-7.4l-5.4-15.3 17-161.3c.9-8.8 8.8-15.2 17.6-14.2s15.2 8.8 14.2 17.6l-9.5 90.1zM111.4 85.6L165.7 240H144c-4 0-8 .3-11.9 .9L81.2 96.2c-2.9-8.3 1.5-17.5 9.8-20.4s17.5 1.5 20.4 9.8zM288 192c0-8.8 7.2-16 16-16s16 7.2 16 16v32 16c0 8.8-7.2 16-16 16s-16-7.2-16-16V192zm38.4 108c10.4 21.3 32.3 36 57.6 36c5.5 0 10.9-.7 16-2v10c0 66.3-53.7 120-120 120H232c-66.3 0-120-53.7-120-120l0-24 0 0c0-17.7 14.3-32 32-32h80c8.8 0 16 7.2 16 16s-7.2 16-16 16H184c-13.3 0-24 10.7-24 24s10.7 24 24 24h40c35.3 0 64-28.7 64-64c0-.7 0-1.4 0-2c5.1 1.3 10.5 2 16 2c7.9 0 15.4-1.4 22.4-4zM400 272c0 8.8-7.2 16-16 16s-16-7.2-16-16V240 224c0-8.8 7.2-16 16-16s16 7.2 16 16v32 16z"
    ]
};
var $7435a4b2c8a749a5$export$fbb22081b65e4f33 = {
    prefix: "far",
    iconName: "face-grin-hearts",
    icon: [
        512,
        512,
        [
            128525,
            "grin-hearts"
        ],
        "f584",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm349.5 52.4c18.7-4.4 35.9 12 25.5 28.1C350.4 374.6 306.3 400 255.9 400s-94.5-25.4-119.1-63.5c-10.4-16.1 6.8-32.5 25.5-28.1c28.9 6.8 60.5 10.5 93.6 10.5s64.7-3.7 93.6-10.5zM215.3 137.1c17.8 4.8 28.4 23.1 23.6 40.8l-17.4 65c-2.3 8.5-11.1 13.6-19.6 11.3l-65.1-17.4c-17.8-4.8-28.4-23.1-23.6-40.8s23.1-28.4 40.8-23.6l16.1 4.3 4.3-16.1c4.8-17.8 23.1-28.4 40.8-23.6zm122.3 23.6l4.3 16.1 16.1-4.3c17.8-4.8 36.1 5.8 40.8 23.6s-5.8 36.1-23.6 40.8l-65.1 17.4c-8.5 2.3-17.3-2.8-19.6-11.3l-17.4-65c-4.8-17.8 5.8-36.1 23.6-40.8s36.1 5.8 40.9 23.6z"
    ]
};
var $7435a4b2c8a749a5$export$c56cf0e0c3bc5ed2 = $7435a4b2c8a749a5$export$fbb22081b65e4f33;
var $7435a4b2c8a749a5$export$f26673f8b10c3d46 = {
    prefix: "far",
    iconName: "building",
    icon: [
        384,
        512,
        [
            127970,
            61687
        ],
        "f1ad",
        "M64 48c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16h80V400c0-26.5 21.5-48 48-48s48 21.5 48 48v64h80c8.8 0 16-7.2 16-16V64c0-8.8-7.2-16-16-16H64zM0 64C0 28.7 28.7 0 64 0H320c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm88 40c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16v48c0 8.8-7.2 16-16 16H104c-8.8 0-16-7.2-16-16V104zM232 88h48c8.8 0 16 7.2 16 16v48c0 8.8-7.2 16-16 16H232c-8.8 0-16-7.2-16-16V104c0-8.8 7.2-16 16-16zM88 232c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16v48c0 8.8-7.2 16-16 16H104c-8.8 0-16-7.2-16-16V232zm144-16h48c8.8 0 16 7.2 16 16v48c0 8.8-7.2 16-16 16H232c-8.8 0-16-7.2-16-16V232c0-8.8 7.2-16 16-16z"
    ]
};
var $7435a4b2c8a749a5$export$2ff38f330c834084 = {
    prefix: "far",
    iconName: "face-grin-beam-sweat",
    icon: [
        512,
        512,
        [
            128517,
            "grin-beam-sweat"
        ],
        "f583",
        "M476.8 126.3C497.1 120.8 512 102.7 512 81c0-20-28.6-60.4-41.6-77.7c-3.2-4.4-9.6-4.4-12.8 0c-9.5 12.6-27.1 37.2-36 57.5c-.3 .7-.6 1.4-.9 2.1C417.8 69.7 416 76 416 81c0 26 21.5 47 48 47c4.4 0 8.7-.6 12.8-1.7zM395.4 41.2C355.3 15.2 307.4 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512s256-114.6 256-256c0-35.8-7.3-69.9-20.6-100.8c-8.6 3.1-17.8 4.8-27.4 4.8c-8.9 0-17.6-1.5-25.7-4.2C454.7 185.5 464 219.7 464 256c0 114.9-93.1 208-208 208S48 370.9 48 256S141.1 48 256 48c48.7 0 93.4 16.7 128.9 44.7c-.6-3.8-.9-7.7-.9-11.7c0-11.4 3.8-22.4 7.1-30.5c1.3-3.1 2.7-6.2 4.3-9.3zM375 336.5c10.4-16.1-6.8-32.5-25.5-28.1c-28.9 6.8-60.5 10.5-93.6 10.5s-64.7-3.7-93.6-10.5c-18.7-4.4-35.9 12-25.5 28.1c24.6 38.1 68.7 63.5 119.1 63.5s94.5-25.4 119.1-63.5zM217.6 228.8l0 0 0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C126.7 188.4 120 206.1 120 224c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8l0 0 0 0 0 0 .2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2 0 0zm160 0l0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C286.7 188.4 280 206.1 280 224c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8l0 0 0 0 0 0 .2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2 0 0 0 0z"
    ]
};
var $7435a4b2c8a749a5$export$14d0ccc54c5b6826 = $7435a4b2c8a749a5$export$2ff38f330c834084;
var $7435a4b2c8a749a5$export$c4c2f69a53bab720 = {
    prefix: "far",
    iconName: "moon",
    icon: [
        384,
        512,
        [
            127769,
            9214
        ],
        "f186",
        "M144.7 98.7c-21 34.1-33.1 74.3-33.1 117.3c0 98 62.8 181.4 150.4 211.7c-12.4 2.8-25.3 4.3-38.6 4.3C126.6 432 48 353.3 48 256c0-68.9 39.4-128.4 96.8-157.3zm62.1-66C91.1 41.2 0 137.9 0 256C0 379.7 100 480 223.5 480c47.8 0 92-15 128.4-40.6c1.9-1.3 3.7-2.7 5.5-4c4.8-3.6 9.4-7.4 13.9-11.4c2.7-2.4 5.3-4.8 7.9-7.3c5-4.9 6.3-12.5 3.1-18.7s-10.1-9.7-17-8.5c-3.7 .6-7.4 1.2-11.1 1.6c-5 .5-10.1 .9-15.3 1c-1.2 0-2.5 0-3.7 0c-.1 0-.2 0-.3 0c-96.8-.2-175.2-78.9-175.2-176c0-54.8 24.9-103.7 64.1-136c1-.9 2.1-1.7 3.2-2.6c4-3.2 8.2-6.2 12.5-9c3.1-2 6.3-4 9.6-5.8c6.1-3.5 9.2-10.5 7.7-17.3s-7.3-11.9-14.3-12.5c-3.6-.3-7.1-.5-10.7-.6c-2.7-.1-5.5-.1-8.2-.1c-3.3 0-6.5 .1-9.8 .2c-2.3 .1-4.6 .2-6.9 .4z"
    ]
};
var $7435a4b2c8a749a5$export$34f5c36a3e80efa2 = {
    prefix: "far",
    iconName: "calendar",
    icon: [
        448,
        512,
        [
            128197,
            128198
        ],
        "f133",
        "M152 24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H64C28.7 64 0 92.7 0 128v16 48V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V192 144 128c0-35.3-28.7-64-64-64H344V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H152V24zM48 192H400V448c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V192z"
    ]
};
var $7435a4b2c8a749a5$export$4272e56f2429da88 = {
    prefix: "far",
    iconName: "face-grin-tongue-wink",
    icon: [
        512,
        512,
        [
            128540,
            "grin-tongue-wink"
        ],
        "f58b",
        "M348.3 442.4c2.4-8.4 3.7-17.3 3.7-26.4V363.5c8.8-8 16.6-17.1 23-27c10.4-16.1-6.8-32.5-25.5-28.1c-28.9 6.8-60.5 10.5-93.6 10.5s-64.7-3.7-93.6-10.5c-18.7-4.4-35.9 12-25.5 28.1c6.5 10 14.3 19.1 23.1 27.1V416c0 9.2 1.3 18 3.7 26.4C95.1 408.4 48 337.7 48 256C48 141.1 141.1 48 256 48s208 93.1 208 208c0 81.7-47.1 152.4-115.7 186.4zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM159.6 220c10.6 0 19.9 3.8 25.4 9.7c7.6 8.1 20.2 8.5 28.3 .9s8.5-20.2 .9-28.3C199.7 186.8 179 180 159.6 180s-40.1 6.8-54.6 22.3c-7.6 8.1-7.1 20.7 .9 28.3s20.7 7.1 28.3-.9c5.5-5.8 14.8-9.7 25.4-9.7zm176.7 12a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-.4-72a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 128a80 80 0 1 0 0-160 80 80 0 1 0 0 160zM320 416c0 35.3-28.7 64-64 64s-64-28.7-64-64V378.6c0-14.7 11.9-26.6 26.6-26.6h2c11.3 0 21.1 7.9 23.6 18.9c2.8 12.6 20.8 12.6 23.6 0c2.5-11.1 12.3-18.9 23.6-18.9h2c14.7 0 26.6 11.9 26.6 26.6V416z"
    ]
};
var $7435a4b2c8a749a5$export$58099903d50aefb3 = $7435a4b2c8a749a5$export$4272e56f2429da88;
var $7435a4b2c8a749a5$export$76c1aa4bf9a39458 = {
    prefix: "far",
    iconName: "clone",
    icon: [
        512,
        512,
        [],
        "f24d",
        "M64 464H288c8.8 0 16-7.2 16-16V384h48v64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V224c0-35.3 28.7-64 64-64h64v48H64c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16zM224 304H448c8.8 0 16-7.2 16-16V64c0-8.8-7.2-16-16-16H224c-8.8 0-16 7.2-16 16V288c0 8.8 7.2 16 16 16zm-64-16V64c0-35.3 28.7-64 64-64H448c35.3 0 64 28.7 64 64V288c0 35.3-28.7 64-64 64H224c-35.3 0-64-28.7-64-64z"
    ]
};
var $7435a4b2c8a749a5$export$67a047c738fb34da = {
    prefix: "far",
    iconName: "face-angry",
    icon: [
        512,
        512,
        [
            128544,
            "angry"
        ],
        "f556",
        "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm72.4-118.5c9.7-9 10.2-24.2 1.2-33.9C315.3 344.3 290.6 328 256 328s-59.3 16.3-73.5 31.6c-9 9.7-8.5 24.9 1.2 33.9s24.9 8.5 33.9-1.2c7.4-7.9 20-16.4 38.5-16.4s31.1 8.5 38.5 16.4c9 9.7 24.2 10.2 33.9 1.2zM176.4 272c17.7 0 32-14.3 32-32c0-1.5-.1-3-.3-4.4l10.9 3.6c8.4 2.8 17.4-1.7 20.2-10.1s-1.7-17.4-10.1-20.2l-96-32c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2l30.7 10.2c-5.8 5.8-9.3 13.8-9.3 22.6c0 17.7 14.3 32 32 32zm192-32c0-8.9-3.6-17-9.5-22.8l30.2-10.1c8.4-2.8 12.9-11.9 10.1-20.2s-11.9-12.9-20.2-10.1l-96 32c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l11.7-3.9c-.2 1.5-.3 3.1-.3 4.7c0 17.7 14.3 32 32 32s32-14.3 32-32z"
    ]
};
var $7435a4b2c8a749a5$export$3c96c08e234498c5 = $7435a4b2c8a749a5$export$67a047c738fb34da;
var $7435a4b2c8a749a5$export$3896694b3e81fba7 = {
    prefix: "far",
    iconName: "rectangle-xmark",
    icon: [
        512,
        512,
        [
            62164,
            "rectangle-times",
            "times-rectangle",
            "window-close"
        ],
        "f410",
        "M64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H448c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm175 79c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"
    ]
};
var $7435a4b2c8a749a5$export$eaaf26416a51dc1 = $7435a4b2c8a749a5$export$3896694b3e81fba7;
var $7435a4b2c8a749a5$export$10147c0014152a3f = $7435a4b2c8a749a5$export$3896694b3e81fba7;
var $7435a4b2c8a749a5$export$18b7775f78a3e16 = $7435a4b2c8a749a5$export$3896694b3e81fba7;
var $7435a4b2c8a749a5$export$b5378818301da1be = {
    prefix: "far",
    iconName: "paper-plane",
    icon: [
        512,
        512,
        [
            61913
        ],
        "f1d8",
        "M16.1 260.2c-22.6 12.9-20.5 47.3 3.6 57.3L160 376V479.3c0 18.1 14.6 32.7 32.7 32.7c9.7 0 18.9-4.3 25.1-11.8l62-74.3 123.9 51.6c18.9 7.9 40.8-4.5 43.9-24.7l64-416c1.9-12.1-3.4-24.3-13.5-31.2s-23.3-7.5-34-1.4l-448 256zm52.1 25.5L409.7 90.6 190.1 336l1.2 1L68.2 285.7zM403.3 425.4L236.7 355.9 450.8 116.6 403.3 425.4z"
    ]
};
var $7435a4b2c8a749a5$export$53dd2cacf674142a = {
    prefix: "far",
    iconName: "life-ring",
    icon: [
        512,
        512,
        [],
        "f1cd",
        "M385.1 419.1C349.7 447.2 304.8 464 256 464s-93.7-16.8-129.1-44.9l80.4-80.4c14.3 8.4 31 13.3 48.8 13.3s34.5-4.8 48.8-13.3l80.4 80.4zm68.1 .2C489.9 374.9 512 318.1 512 256s-22.1-118.9-58.8-163.3L465 81c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L419.3 58.8C374.9 22.1 318.1 0 256 0S137.1 22.1 92.7 58.8L81 47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L58.8 92.7C22.1 137.1 0 193.9 0 256s22.1 118.9 58.8 163.3L47 431c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l11.8-11.8C137.1 489.9 193.9 512 256 512s118.9-22.1 163.3-58.8L431 465c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-11.8-11.8zm-34.1-34.1l-80.4-80.4c8.4-14.3 13.3-31 13.3-48.8s-4.8-34.5-13.3-48.8l80.4-80.4C447.2 162.3 464 207.2 464 256s-16.8 93.7-44.9 129.1zM385.1 92.9l-80.4 80.4c-14.3-8.4-31-13.3-48.8-13.3s-34.5 4.8-48.8 13.3L126.9 92.9C162.3 64.8 207.2 48 256 48s93.7 16.8 129.1 44.9zM173.3 304.8L92.9 385.1C64.8 349.7 48 304.8 48 256s16.8-93.7 44.9-129.1l80.4 80.4c-8.4 14.3-13.3 31-13.3 48.8s4.8 34.5 13.3 48.8zM208 256a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z"
    ]
};
var $7435a4b2c8a749a5$export$bd5bd2ef56b793b1 = {
    prefix: "far",
    iconName: "face-grimace",
    icon: [
        512,
        512,
        [
            128556,
            "grimace"
        ],
        "f57f",
        "M256 48a208 208 0 1 0 0 416 208 208 0 1 0 0-416zM512 256A256 256 0 1 1 0 256a256 256 0 1 1 512 0zM168 320c-13.3 0-24 10.7-24 24s10.7 24 24 24h8V320h-8zm40 48h32V320H208v48zm96 0V320H272v48h32zm32 0h8c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8v48zM168 288H344c30.9 0 56 25.1 56 56s-25.1 56-56 56H168c-30.9 0-56-25.1-56-56s25.1-56 56-56zm-23.6-80a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $7435a4b2c8a749a5$export$3d08cd36ac1ef231 = $7435a4b2c8a749a5$export$bd5bd2ef56b793b1;
var $7435a4b2c8a749a5$export$23e8b4955c2d951b = {
    prefix: "far",
    iconName: "calendar-minus",
    icon: [
        448,
        512,
        [],
        "f272",
        "M128 0c13.3 0 24 10.7 24 24V64H296V24c0-13.3 10.7-24 24-24s24 10.7 24 24V64h40c35.3 0 64 28.7 64 64v16 48V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192 144 128C0 92.7 28.7 64 64 64h40V24c0-13.3 10.7-24 24-24zM400 192H48V448c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V192zM296 352H152c-13.3 0-24-10.7-24-24s10.7-24 24-24H296c13.3 0 24 10.7 24 24s-10.7 24-24 24z"
    ]
};
var $7435a4b2c8a749a5$export$30262489773a79a3 = {
    prefix: "far",
    iconName: "circle-xmark",
    icon: [
        512,
        512,
        [
            61532,
            "times-circle",
            "xmark-circle"
        ],
        "f057",
        "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0z"
    ]
};
var $7435a4b2c8a749a5$export$ab0ec50720a747eb = $7435a4b2c8a749a5$export$30262489773a79a3;
var $7435a4b2c8a749a5$export$90ac4096df8efdee = $7435a4b2c8a749a5$export$30262489773a79a3;
var $7435a4b2c8a749a5$export$47e4e0d519d33497 = {
    prefix: "far",
    iconName: "thumbs-up",
    icon: [
        512,
        512,
        [
            128077,
            61575
        ],
        "f164",
        "M323.8 34.8c-38.2-10.9-78.1 11.2-89 49.4l-5.7 20c-3.7 13-10.4 25-19.5 35l-51.3 56.4c-8.9 9.8-8.2 25 1.6 33.9s25 8.2 33.9-1.6l51.3-56.4c14.1-15.5 24.4-34 30.1-54.1l5.7-20c3.6-12.7 16.9-20.1 29.7-16.5s20.1 16.9 16.5 29.7l-5.7 20c-5.7 19.9-14.7 38.7-26.6 55.5c-5.2 7.3-5.8 16.9-1.7 24.9s12.3 13 21.3 13L448 224c8.8 0 16 7.2 16 16c0 6.8-4.3 12.7-10.4 15c-7.4 2.8-13 9-14.9 16.7s.1 15.8 5.3 21.7c2.5 2.8 4 6.5 4 10.6c0 7.8-5.6 14.3-13 15.7c-8.2 1.6-15.1 7.3-18 15.2s-1.6 16.7 3.6 23.3c2.1 2.7 3.4 6.1 3.4 9.9c0 6.7-4.2 12.6-10.2 14.9c-11.5 4.5-17.7 16.9-14.4 28.8c.4 1.3 .6 2.8 .6 4.3c0 8.8-7.2 16-16 16H286.5c-12.6 0-25-3.7-35.5-10.7l-61.7-41.1c-11-7.4-25.9-4.4-33.3 6.7s-4.4 25.9 6.7 33.3l61.7 41.1c18.4 12.3 40 18.8 62.1 18.8H384c34.7 0 62.9-27.6 64-62c14.6-11.7 24-29.7 24-50c0-4.5-.5-8.8-1.3-13c15.4-11.7 25.3-30.2 25.3-51c0-6.5-1-12.8-2.8-18.7C504.8 273.7 512 257.7 512 240c0-35.3-28.6-64-64-64l-92.3 0c4.7-10.4 8.7-21.2 11.8-32.2l5.7-20c10.9-38.2-11.2-78.1-49.4-89zM32 192c-17.7 0-32 14.3-32 32V448c0 17.7 14.3 32 32 32H96c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32H32z"
    ]
};
var $7435a4b2c8a749a5$export$26a3f9d2784b90d8 = {
    prefix: "far",
    iconName: "window-minimize",
    icon: [
        512,
        512,
        [
            128469
        ],
        "f2d1",
        "M24 432c-13.3 0-24 10.7-24 24s10.7 24 24 24H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H24z"
    ]
};
var $7435a4b2c8a749a5$export$7ec6541fee081990 = {
    prefix: "far",
    iconName: "square-full",
    icon: [
        512,
        512,
        [
            128997,
            128998,
            128999,
            129000,
            129001,
            129002,
            129003,
            11035,
            11036
        ],
        "f45c",
        "M464 48V464H48V48H464zM48 0H0V48 464v48H48 464h48V464 48 0H464 48z"
    ]
};
var $7435a4b2c8a749a5$export$4a4e034527c933f5 = {
    prefix: "far",
    iconName: "note-sticky",
    icon: [
        448,
        512,
        [
            62026,
            "sticky-note"
        ],
        "f249",
        "M64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H288V352c0-17.7 14.3-32 32-32h80V96c0-8.8-7.2-16-16-16H64zM288 480H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V320v5.5c0 17-6.7 33.3-18.7 45.3l-90.5 90.5c-12 12-28.3 18.7-45.3 18.7H288z"
    ]
};
var $7435a4b2c8a749a5$export$80889adc5d98bf4a = $7435a4b2c8a749a5$export$4a4e034527c933f5;
var $7435a4b2c8a749a5$export$8a5a0dbb2a17e253 = {
    prefix: "far",
    iconName: "face-sad-tear",
    icon: [
        512,
        512,
        [
            128546,
            "sad-tear"
        ],
        "f5b4",
        "M175.9 448c-35-.1-65.5-22.6-76-54.6C67.6 356.8 48 308.7 48 256C48 141.1 141.1 48 256 48s208 93.1 208 208s-93.1 208-208 208c-28.4 0-55.5-5.7-80.1-16zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM128 369c0 26 21.5 47 48 47s48-21 48-47c0-20-28.4-60.4-41.6-77.7c-3.2-4.4-9.6-4.4-12.8 0C156.6 308.6 128 349 128 369zm128-65c-13.3 0-24 10.7-24 24s10.7 24 24 24c30.7 0 58.7 11.5 80 30.6c9.9 8.8 25 8 33.9-1.9s8-25-1.9-33.9C338.3 320.2 299 304 256 304zm47.6-96a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm-128 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
var $7435a4b2c8a749a5$export$4b5241926f692f91 = $7435a4b2c8a749a5$export$8a5a0dbb2a17e253;
var $7435a4b2c8a749a5$export$b276ec3dc9760d39 = {
    prefix: "far",
    iconName: "hand-point-left",
    icon: [
        512,
        512,
        [],
        "f0a5",
        "M64 128l177.6 0c-1 5.2-1.6 10.5-1.6 16l0 16-32 0L64 160c-8.8 0-16-7.2-16-16s7.2-16 16-16zm224 16c0-17.7 14.3-32 32-32c0 0 0 0 0 0l24 0c66.3 0 120 53.7 120 120l0 48c0 52.5-33.7 97.1-80.7 113.4c.5-3.1 .7-6.2 .7-9.4c0-20-9.2-37.9-23.6-49.7c4.9-9 7.6-19.4 7.6-30.3c0-15.1-5.3-29-14-40c8.8-11 14-24.9 14-40l0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-40 0-40zm32-80s0 0 0 0c-18 0-34.6 6-48 16L64 80C28.7 80 0 108.7 0 144s28.7 64 64 64l82 0c-1.3 5.1-2 10.5-2 16c0 25.3 14.7 47.2 36 57.6c-2.6 7-4 14.5-4 22.4c0 20 9.2 37.9 23.6 49.7c-4.9 9-7.6 19.4-7.6 30.3c0 35.3 28.7 64 64 64l64 0 24 0c92.8 0 168-75.2 168-168l0-48c0-92.8-75.2-168-168-168l-24 0zM256 400c-8.8 0-16-7.2-16-16s7.2-16 16-16l48 0 16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0zM240 224c0 5.5 .7 10.9 2 16l-2 0-32 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l32 0 0 16zm24 64l40 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0-16 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l24 0z"
    ]
};
var $7435a4b2c8a749a5$export$f9059ea71e16fa16 = {
    faTrashCan: $7435a4b2c8a749a5$export$864bb8d6c21fb792,
    faTrashAlt: $7435a4b2c8a749a5$export$88df7ff7eb32f9dc,
    faMessage: $7435a4b2c8a749a5$export$6563a67224e7f879,
    faCommentAlt: $7435a4b2c8a749a5$export$6e96904d9af0ec4a,
    faFileLines: $7435a4b2c8a749a5$export$ef565d07efe2b5e9,
    faFileAlt: $7435a4b2c8a749a5$export$243b47dca32bf0b8,
    faFileText: $7435a4b2c8a749a5$export$f466100bf9bf37a5,
    faCalendarDays: $7435a4b2c8a749a5$export$31c6cf6f5d38dc0,
    faCalendarAlt: $7435a4b2c8a749a5$export$cbc139f33cff356,
    faHandPointRight: $7435a4b2c8a749a5$export$f7bc8714c970afa4,
    faFaceSmileBeam: $7435a4b2c8a749a5$export$e3c56ed54f074063,
    faSmileBeam: $7435a4b2c8a749a5$export$54ada6dc9690e0ca,
    faFaceGrinStars: $7435a4b2c8a749a5$export$1d1fbac384a76a12,
    faGrinStars: $7435a4b2c8a749a5$export$64347a5c8c402ef4,
    faAddressBook: $7435a4b2c8a749a5$export$853fd1561789e3bb,
    faContactBook: $7435a4b2c8a749a5$export$594b5a5d4d2e156b,
    faComments: $7435a4b2c8a749a5$export$932912e74adb8939,
    faPaste: $7435a4b2c8a749a5$export$6f95f90dd1f6d86b,
    faFileClipboard: $7435a4b2c8a749a5$export$ca3229c47de163fa,
    faFaceGrinTongueSquint: $7435a4b2c8a749a5$export$8eee2c17ff89e724,
    faGrinTongueSquint: $7435a4b2c8a749a5$export$4edf34c3def09a31,
    faFaceFlushed: $7435a4b2c8a749a5$export$ba5dc4287853ecbd,
    faFlushed: $7435a4b2c8a749a5$export$dfd2bd012685aeac,
    faSquareCaretRight: $7435a4b2c8a749a5$export$5b1d41cdd118ea6d,
    faCaretSquareRight: $7435a4b2c8a749a5$export$ae86c9de7e0f62fa,
    faSquareMinus: $7435a4b2c8a749a5$export$814c9edba7b84aa4,
    faMinusSquare: $7435a4b2c8a749a5$export$ffe9387966b3e681,
    faCompass: $7435a4b2c8a749a5$export$b4d344633433e50e,
    faSquareCaretDown: $7435a4b2c8a749a5$export$a1ab39cd66c4e50e,
    faCaretSquareDown: $7435a4b2c8a749a5$export$61aea18df1c84401,
    faFaceKissBeam: $7435a4b2c8a749a5$export$eca99665af566fe1,
    faKissBeam: $7435a4b2c8a749a5$export$d6ff8a73c0812e63,
    faLightbulb: $7435a4b2c8a749a5$export$1e80f89fe84a215b,
    faFlag: $7435a4b2c8a749a5$export$6591b1ea509be9da,
    faSquareCheck: $7435a4b2c8a749a5$export$5bb6a0c94ad2f4bb,
    faCheckSquare: $7435a4b2c8a749a5$export$f0c8040f596df7fe,
    faCircleDot: $7435a4b2c8a749a5$export$aa13d9234890e8d3,
    faDotCircle: $7435a4b2c8a749a5$export$92bc269cb244d66a,
    faFaceDizzy: $7435a4b2c8a749a5$export$635e4d8cc8428961,
    faDizzy: $7435a4b2c8a749a5$export$89a2b10dabc487e8,
    faFutbol: $7435a4b2c8a749a5$export$65a345b33858a655,
    faFutbolBall: $7435a4b2c8a749a5$export$51a344ca0a215620,
    faSoccerBall: $7435a4b2c8a749a5$export$f4a29712c724ba2d,
    faPenToSquare: $7435a4b2c8a749a5$export$ba236543926e3569,
    faEdit: $7435a4b2c8a749a5$export$7be713e57d023733,
    faHourglassHalf: $7435a4b2c8a749a5$export$703272eebf5e3eea,
    faHourglass2: $7435a4b2c8a749a5$export$f1052bbf6bf361c0,
    faEyeSlash: $7435a4b2c8a749a5$export$ed3f2918429d029a,
    faHand: $7435a4b2c8a749a5$export$f69db0b876f7d753,
    faHandPaper: $7435a4b2c8a749a5$export$6e6216c8b50471bb,
    faHandSpock: $7435a4b2c8a749a5$export$2262d6b626de1120,
    faFaceKiss: $7435a4b2c8a749a5$export$5a54c83033a0a56a,
    faKiss: $7435a4b2c8a749a5$export$c762a77aabf64fd0,
    faFaceGrinTongue: $7435a4b2c8a749a5$export$95a7394c24f57943,
    faGrinTongue: $7435a4b2c8a749a5$export$ef222816a43a4b3a,
    faChessBishop: $7435a4b2c8a749a5$export$a831eedd2f59c62f,
    faFaceGrinWink: $7435a4b2c8a749a5$export$1dd161850c5bc64e,
    faGrinWink: $7435a4b2c8a749a5$export$2397fcd34eb12177,
    faFaceGrinWide: $7435a4b2c8a749a5$export$bdbabf493c478cde,
    faGrinAlt: $7435a4b2c8a749a5$export$b4abebfe416d36ba,
    faFaceFrownOpen: $7435a4b2c8a749a5$export$c8a28356e07b9ccb,
    faFrownOpen: $7435a4b2c8a749a5$export$c4775e66bed5d96,
    faHandPointUp: $7435a4b2c8a749a5$export$cdc9f5e7e94e76da,
    faBookmark: $7435a4b2c8a749a5$export$4ed9da5c3cca0ef1,
    faHandPointDown: $7435a4b2c8a749a5$export$f6dcbf0a940428f4,
    faFolder: $7435a4b2c8a749a5$export$72b780186370e953,
    faFolderBlank: $7435a4b2c8a749a5$export$9ef114244d26da0,
    faUser: $7435a4b2c8a749a5$export$f5699fa0844e0188,
    faSquareCaretLeft: $7435a4b2c8a749a5$export$2c5163541229363,
    faCaretSquareLeft: $7435a4b2c8a749a5$export$d0c8ba444f1f9581,
    faStar: $7435a4b2c8a749a5$export$a3b0eb2cd7942125,
    faChessKnight: $7435a4b2c8a749a5$export$861b1f13085cf122,
    faFaceLaughSquint: $7435a4b2c8a749a5$export$67ca89c1ca38d559,
    faLaughSquint: $7435a4b2c8a749a5$export$b206e700cf7084e1,
    faFaceLaugh: $7435a4b2c8a749a5$export$2f203616c892d415,
    faLaugh: $7435a4b2c8a749a5$export$6c74e314e801a4fe,
    faFolderOpen: $7435a4b2c8a749a5$export$ff7e93418af88b78,
    faClipboard: $7435a4b2c8a749a5$export$97d84347d71ba297,
    faChessQueen: $7435a4b2c8a749a5$export$7b8ce73615739d30,
    faHandBackFist: $7435a4b2c8a749a5$export$be38a892fe9b4098,
    faHandRock: $7435a4b2c8a749a5$export$97a81eba394c8c44,
    faSquareCaretUp: $7435a4b2c8a749a5$export$66068918abb14406,
    faCaretSquareUp: $7435a4b2c8a749a5$export$307ae80b26533ce5,
    faChartBar: $7435a4b2c8a749a5$export$b532f5d25de97633,
    faBarChart: $7435a4b2c8a749a5$export$2d5f754a5e5738b,
    faWindowRestore: $7435a4b2c8a749a5$export$eccfff9bfd585652,
    faSquarePlus: $7435a4b2c8a749a5$export$eaf727acca5a35e4,
    faPlusSquare: $7435a4b2c8a749a5$export$b6359eebfe900c35,
    faImage: $7435a4b2c8a749a5$export$7e9f0928967e03b,
    faFolderClosed: $7435a4b2c8a749a5$export$5e30548b7f8eeb95,
    faLemon: $7435a4b2c8a749a5$export$4fbda8f64648f3b5,
    faHandshake: $7435a4b2c8a749a5$export$b4c63e9bfc7906f1,
    faGem: $7435a4b2c8a749a5$export$31ee86ac717db552,
    faCirclePlay: $7435a4b2c8a749a5$export$86c4e45dc3302d15,
    faPlayCircle: $7435a4b2c8a749a5$export$cf04333781061c5e,
    faCircleCheck: $7435a4b2c8a749a5$export$c2e9877668862374,
    faCheckCircle: $7435a4b2c8a749a5$export$be9e388158c74f29,
    faCircleStop: $7435a4b2c8a749a5$export$229de76dfef2687f,
    faStopCircle: $7435a4b2c8a749a5$export$47af2aad60ab3e7c,
    faIdBadge: $7435a4b2c8a749a5$export$a75288855ea05282,
    faFaceLaughBeam: $7435a4b2c8a749a5$export$3f2d51c0547bf984,
    faLaughBeam: $7435a4b2c8a749a5$export$a88d1f4073ea9369,
    faRegistered: $7435a4b2c8a749a5$export$5f519e9ac15ab8c3,
    faAddressCard: $7435a4b2c8a749a5$export$6ea408c7266ed557,
    faContactCard: $7435a4b2c8a749a5$export$4ac51eb0b298b190,
    faVcard: $7435a4b2c8a749a5$export$91228257deb1bf18,
    faFaceTired: $7435a4b2c8a749a5$export$5352cbdc070ce8d,
    faTired: $7435a4b2c8a749a5$export$3d016d62cda18371,
    faFontAwesome: $7435a4b2c8a749a5$export$aa4baaed1c60f58d,
    faFontAwesomeFlag: $7435a4b2c8a749a5$export$102c25fde54d4843,
    faFontAwesomeLogoFull: $7435a4b2c8a749a5$export$6e20d421a2e0f320,
    faFaceSmileWink: $7435a4b2c8a749a5$export$6143da800b0e6626,
    faSmileWink: $7435a4b2c8a749a5$export$f5dbb37f6801ee3f,
    faFileWord: $7435a4b2c8a749a5$export$f0858dff6e769cf6,
    faFilePowerpoint: $7435a4b2c8a749a5$export$c341daeecdea449a,
    faEnvelopeOpen: $7435a4b2c8a749a5$export$c6c3bd5f7d9b8bf2,
    faFileZipper: $7435a4b2c8a749a5$export$7a4a0e4caa1e4e6f,
    faFileArchive: $7435a4b2c8a749a5$export$bf2047a9946b5c3f,
    faSquare: $7435a4b2c8a749a5$export$90b4406457aae8cc,
    faSnowflake: $7435a4b2c8a749a5$export$bab8f3647c394f48,
    faNewspaper: $7435a4b2c8a749a5$export$d91b374112d4f8c1,
    faFaceKissWinkHeart: $7435a4b2c8a749a5$export$611ae61f02de0aa,
    faKissWinkHeart: $7435a4b2c8a749a5$export$ebba617701dfb917,
    faStarHalfStroke: $7435a4b2c8a749a5$export$3e4892d8bf919edd,
    faStarHalfAlt: $7435a4b2c8a749a5$export$c13575f42532efb3,
    faFileExcel: $7435a4b2c8a749a5$export$77cb1a465c4fe84,
    faFaceGrinBeam: $7435a4b2c8a749a5$export$3de52eeb00462407,
    faGrinBeam: $7435a4b2c8a749a5$export$734da5249381ec7e,
    faObjectUngroup: $7435a4b2c8a749a5$export$887f6345573abcac,
    faCircleRight: $7435a4b2c8a749a5$export$1fec48c8bdd69c1d,
    faArrowAltCircleRight: $7435a4b2c8a749a5$export$88962ffdad8b856d,
    faFaceRollingEyes: $7435a4b2c8a749a5$export$a6d72a9a068392b5,
    faMehRollingEyes: $7435a4b2c8a749a5$export$fdc62a1bea767cc2,
    faObjectGroup: $7435a4b2c8a749a5$export$40cdac24aa94a57a,
    faHeart: $7435a4b2c8a749a5$export$e4b51a47a2f8b9db,
    faFaceSurprise: $7435a4b2c8a749a5$export$c938968e28178994,
    faSurprise: $7435a4b2c8a749a5$export$46647c72213f53ba,
    faCirclePause: $7435a4b2c8a749a5$export$fbeef2513e05ad08,
    faPauseCircle: $7435a4b2c8a749a5$export$d8cf08a0362da8db,
    faCircle: $7435a4b2c8a749a5$export$4280b2387fbdad12,
    faCircleUp: $7435a4b2c8a749a5$export$72ea8a5e4e86cd69,
    faArrowAltCircleUp: $7435a4b2c8a749a5$export$3747a8ef0995eadf,
    faFileAudio: $7435a4b2c8a749a5$export$b8d24c57c9e64933,
    faFileImage: $7435a4b2c8a749a5$export$6440b286d3cbac9b,
    faCircleQuestion: $7435a4b2c8a749a5$export$d7cf0978afd90002,
    faQuestionCircle: $7435a4b2c8a749a5$export$5ba67d7f2265c1a5,
    faFaceMehBlank: $7435a4b2c8a749a5$export$38c072b870a9e4ab,
    faMehBlank: $7435a4b2c8a749a5$export$e945435725f71e88,
    faEye: $7435a4b2c8a749a5$export$b8c3e79e8c99c95b,
    faFaceSadCry: $7435a4b2c8a749a5$export$e8ea88c55e55be7c,
    faSadCry: $7435a4b2c8a749a5$export$8e924e6bd422cef9,
    faFileCode: $7435a4b2c8a749a5$export$143d0ca7d2200f20,
    faWindowMaximize: $7435a4b2c8a749a5$export$703cd98be31ec905,
    faFaceFrown: $7435a4b2c8a749a5$export$e5f78e87efbb0248,
    faFrown: $7435a4b2c8a749a5$export$43b7108508aecc5f,
    faFloppyDisk: $7435a4b2c8a749a5$export$f62f2879ccaea13f,
    faSave: $7435a4b2c8a749a5$export$1aaa83ff70706e1e,
    faCommentDots: $7435a4b2c8a749a5$export$63ffcb3d4e94cb92,
    faCommenting: $7435a4b2c8a749a5$export$49ee382a2425e89c,
    faFaceGrinSquint: $7435a4b2c8a749a5$export$5d53da7627754bc6,
    faGrinSquint: $7435a4b2c8a749a5$export$243ae757907b1580,
    faHandPointer: $7435a4b2c8a749a5$export$d97ff927c450c87f,
    faHandScissors: $7435a4b2c8a749a5$export$c578e919f2c5c135,
    faFaceGrinTears: $7435a4b2c8a749a5$export$8ac6d81a3d5b40a1,
    faGrinTears: $7435a4b2c8a749a5$export$b2f7512221512b5b,
    faCalendarXmark: $7435a4b2c8a749a5$export$3c70ffe5660af060,
    faCalendarTimes: $7435a4b2c8a749a5$export$99b20d7352fbcf08,
    faFileVideo: $7435a4b2c8a749a5$export$b44eb38345c6a964,
    faFilePdf: $7435a4b2c8a749a5$export$38611f1c776aba73,
    faComment: $7435a4b2c8a749a5$export$805cd88398a70581,
    faEnvelope: $7435a4b2c8a749a5$export$6f095630677adc,
    faHourglass: $7435a4b2c8a749a5$export$b9098a890f61e022,
    faHourglassEmpty: $7435a4b2c8a749a5$export$a2f8176a0161e891,
    faCalendarCheck: $7435a4b2c8a749a5$export$5655108e1162ba45,
    faHardDrive: $7435a4b2c8a749a5$export$4cb736b866cbb7ec,
    faHdd: $7435a4b2c8a749a5$export$62551e9c5ba7093f,
    faFaceGrinSquintTears: $7435a4b2c8a749a5$export$8ff56f5ebb8416a0,
    faGrinSquintTears: $7435a4b2c8a749a5$export$542206d6a85f3b42,
    faRectangleList: $7435a4b2c8a749a5$export$1f7600fa9fdb3978,
    faListAlt: $7435a4b2c8a749a5$export$c6327a203ffc65a3,
    faCalendarPlus: $7435a4b2c8a749a5$export$16768a660ae3ca9d,
    faCircleLeft: $7435a4b2c8a749a5$export$5ae86b9da9cca3bd,
    faArrowAltCircleLeft: $7435a4b2c8a749a5$export$5460a5b11a24996f,
    faMoneyBill1: $7435a4b2c8a749a5$export$a312c7d58dd44a75,
    faMoneyBillAlt: $7435a4b2c8a749a5$export$a35d573395884c3d,
    faClock: $7435a4b2c8a749a5$export$95b9968e7fceb821,
    faClockFour: $7435a4b2c8a749a5$export$9a575facf1cab48f,
    faKeyboard: $7435a4b2c8a749a5$export$fb61df5d98785fa8,
    faClosedCaptioning: $7435a4b2c8a749a5$export$8e047801a8603af7,
    faImages: $7435a4b2c8a749a5$export$74f06b41ed2ca28a,
    faFaceGrin: $7435a4b2c8a749a5$export$92292137ef3cf4c8,
    faGrin: $7435a4b2c8a749a5$export$37e1f10b6de76621,
    faFaceMeh: $7435a4b2c8a749a5$export$dc130582748497c6,
    faMeh: $7435a4b2c8a749a5$export$6d2db489aaeeecd2,
    faIdCard: $7435a4b2c8a749a5$export$782ac893fc22249b,
    faDriversLicense: $7435a4b2c8a749a5$export$8359c70e609eff64,
    faSun: $7435a4b2c8a749a5$export$2fa35dcbc038dbe9,
    faFaceLaughWink: $7435a4b2c8a749a5$export$600a1b26b33c3d47,
    faLaughWink: $7435a4b2c8a749a5$export$77ac40095f39933e,
    faCircleDown: $7435a4b2c8a749a5$export$531badb89cf01312,
    faArrowAltCircleDown: $7435a4b2c8a749a5$export$ff3afbc8c0bc5d59,
    faThumbsDown: $7435a4b2c8a749a5$export$aba24ca305bbe8c1,
    faChessPawn: $7435a4b2c8a749a5$export$3db75d5ac9e98468,
    faCreditCard: $7435a4b2c8a749a5$export$3e7437bf6535bef0,
    faCreditCardAlt: $7435a4b2c8a749a5$export$5fffe8e3c36964a2,
    faBell: $7435a4b2c8a749a5$export$9b6162797ab1b255,
    faFile: $7435a4b2c8a749a5$export$cad54bead856a678,
    faHospital: $7435a4b2c8a749a5$export$7a76c9d35b42d691,
    faHospitalAlt: $7435a4b2c8a749a5$export$cea7736417b94a3b,
    faHospitalWide: $7435a4b2c8a749a5$export$69c8cc0360f017e8,
    faChessRook: $7435a4b2c8a749a5$export$5d65c40a109eb09c,
    faStarHalf: $7435a4b2c8a749a5$export$228008b5e11032fa,
    faChessKing: $7435a4b2c8a749a5$export$d5713874f8fefe1b,
    faCircleUser: $7435a4b2c8a749a5$export$9a5c11a5e3d7f1e7,
    faUserCircle: $7435a4b2c8a749a5$export$be7d974e9e0dba1a,
    faCopy: $7435a4b2c8a749a5$export$e9bd786d30cb716c,
    faShareFromSquare: $7435a4b2c8a749a5$export$928280bdd54fa173,
    faShareSquare: $7435a4b2c8a749a5$export$ae9e1434571f373c,
    faCopyright: $7435a4b2c8a749a5$export$da61665fff8aebfe,
    faMap: $7435a4b2c8a749a5$export$fc82fb79180cd17c,
    faBellSlash: $7435a4b2c8a749a5$export$6b31a1e5968b2378,
    faHandLizard: $7435a4b2c8a749a5$export$54608d0a883fea4d,
    faFaceSmile: $7435a4b2c8a749a5$export$b5023c446f10324,
    faSmile: $7435a4b2c8a749a5$export$c632b2334f0913bc,
    faHandPeace: $7435a4b2c8a749a5$export$e49e3cfceea441cc,
    faFaceGrinHearts: $7435a4b2c8a749a5$export$fbb22081b65e4f33,
    faGrinHearts: $7435a4b2c8a749a5$export$c56cf0e0c3bc5ed2,
    faBuilding: $7435a4b2c8a749a5$export$f26673f8b10c3d46,
    faFaceGrinBeamSweat: $7435a4b2c8a749a5$export$2ff38f330c834084,
    faGrinBeamSweat: $7435a4b2c8a749a5$export$14d0ccc54c5b6826,
    faMoon: $7435a4b2c8a749a5$export$c4c2f69a53bab720,
    faCalendar: $7435a4b2c8a749a5$export$34f5c36a3e80efa2,
    faFaceGrinTongueWink: $7435a4b2c8a749a5$export$4272e56f2429da88,
    faGrinTongueWink: $7435a4b2c8a749a5$export$58099903d50aefb3,
    faClone: $7435a4b2c8a749a5$export$76c1aa4bf9a39458,
    faFaceAngry: $7435a4b2c8a749a5$export$67a047c738fb34da,
    faAngry: $7435a4b2c8a749a5$export$3c96c08e234498c5,
    faRectangleXmark: $7435a4b2c8a749a5$export$3896694b3e81fba7,
    faRectangleTimes: $7435a4b2c8a749a5$export$eaaf26416a51dc1,
    faTimesRectangle: $7435a4b2c8a749a5$export$10147c0014152a3f,
    faWindowClose: $7435a4b2c8a749a5$export$18b7775f78a3e16,
    faPaperPlane: $7435a4b2c8a749a5$export$b5378818301da1be,
    faLifeRing: $7435a4b2c8a749a5$export$53dd2cacf674142a,
    faFaceGrimace: $7435a4b2c8a749a5$export$bd5bd2ef56b793b1,
    faGrimace: $7435a4b2c8a749a5$export$3d08cd36ac1ef231,
    faCalendarMinus: $7435a4b2c8a749a5$export$23e8b4955c2d951b,
    faCircleXmark: $7435a4b2c8a749a5$export$30262489773a79a3,
    faTimesCircle: $7435a4b2c8a749a5$export$ab0ec50720a747eb,
    faXmarkCircle: $7435a4b2c8a749a5$export$90ac4096df8efdee,
    faThumbsUp: $7435a4b2c8a749a5$export$47e4e0d519d33497,
    faWindowMinimize: $7435a4b2c8a749a5$export$26a3f9d2784b90d8,
    faSquareFull: $7435a4b2c8a749a5$export$7ec6541fee081990,
    faNoteSticky: $7435a4b2c8a749a5$export$4a4e034527c933f5,
    faStickyNote: $7435a4b2c8a749a5$export$80889adc5d98bf4a,
    faFaceSadTear: $7435a4b2c8a749a5$export$8a5a0dbb2a17e253,
    faSadTear: $7435a4b2c8a749a5$export$4b5241926f692f91,
    faHandPointLeft: $7435a4b2c8a749a5$export$b276ec3dc9760d39
};




var $f1q41 = parcelRequire("f1q41");



var $777d0014849a8f55$exports = {};

$parcel$export($777d0014849a8f55$exports, "shiftStableKeys", () => $777d0014849a8f55$export$b510f7bffe56700b);
$parcel$export($777d0014849a8f55$exports, "shiftStableKeysRegex", () => $777d0014849a8f55$export$3e4fa4e2da976575);
$parcel$export($777d0014849a8f55$exports, "getFullKey", () => $777d0014849a8f55$export$ebf72dfe5a040886);
$parcel$export($777d0014849a8f55$exports, "classed", () => $777d0014849a8f55$export$2d100aab7348fb0a);
$parcel$export($777d0014849a8f55$exports, "findScrollableAncestor", () => $777d0014849a8f55$export$1c9360146059a2c0);
$parcel$export($777d0014849a8f55$exports, "TextInput", () => $777d0014849a8f55$export$c86715117507e8e5);
$parcel$export($777d0014849a8f55$exports, "Button", () => $777d0014849a8f55$export$353f5b6fc5456de1);
$parcel$export($777d0014849a8f55$exports, "IconToggleButton", () => $777d0014849a8f55$export$8c371e86c75349bc);
$parcel$export($777d0014849a8f55$exports, "IconForButton", () => $777d0014849a8f55$export$28e87d06cd5fda5e);
$parcel$export($777d0014849a8f55$exports, "selectFile", () => $777d0014849a8f55$export$195947546eb716de);
$parcel$export($777d0014849a8f55$exports, "LoadFileButton", () => $777d0014849a8f55$export$b346deb0efaa17bd);
$parcel$export($777d0014849a8f55$exports, "SaveFileButton", () => $777d0014849a8f55$export$a2003232d6cefe25);
$parcel$export($777d0014849a8f55$exports, "saveFile", () => $777d0014849a8f55$export$e620933a198f7bc);
$parcel$export($777d0014849a8f55$exports, "findParent", () => $777d0014849a8f55$export$25245567f53f158f);
$parcel$export($777d0014849a8f55$exports, "isInsideInput", () => $777d0014849a8f55$export$b3053c7afe37670c);
$parcel$export($777d0014849a8f55$exports, "focusWithKeyboard", () => $777d0014849a8f55$export$67289be57e41ecc);


var $acw62 = parcelRequire("acw62");


const $777d0014849a8f55$export$b510f7bffe56700b = [
    "[A-Z]",
    " ",
    "Tab",
    "Enter",
    "Backspace",
    "Delete",
    "Escape",
    "Arrow(Up|Down|Left|Right)",
    "Home",
    "End",
    "Page(Up|Down)"
];
const $777d0014849a8f55$export$3e4fa4e2da976575 = new RegExp("^(" + $777d0014849a8f55$export$b510f7bffe56700b.join("|") + ")$");
function $777d0014849a8f55$export$ebf72dfe5a040886(event) {
    const keyName = event.key.length > 1 ? event.key : event.key.toUpperCase();
    const shiftStable = $777d0014849a8f55$export$3e4fa4e2da976575.test(keyName);
    return [
        event.ctrlKey || event.metaKey ? "C-" : "",
        shiftStable && event.shiftKey ? "Shift-" : "",
        event.altKey ? "Alt-" : "",
        keyName === " " ? "Space" : keyName
    ].join("");
}
const $777d0014849a8f55$export$2d100aab7348fb0a = (elem)=>(strings, ...interpolations)=>/*#__PURE__*/ $acw62.forwardRef((props, ref)=>/*#__PURE__*/ $acw62.createElement(elem, {
                ...props,
                ref: ref,
                className: `${(0, $512ec8d668819b2f$export$89e29e4ab65e70a9)(strings, interpolations, props)} ${props.className ?? ""}`
            }));
function $777d0014849a8f55$export$1c9360146059a2c0(element) {
    if (!element) return null;
    const isScrollable = element.scrollHeight > element.clientHeight;
    const style = window.getComputedStyle(element);
    const overflowScroll = style.overflowY === "auto" || style.overflowY === "scroll";
    if (isScrollable && overflowScroll) return element;
    return $777d0014849a8f55$export$1c9360146059a2c0(element.parentElement);
}
const $777d0014849a8f55$var$textInputChildStyle = {
    margin: "0px",
    border: "0px",
    background: "none",
    boxSizing: "inherit",
    display: "inherit",
    fontFamily: "inherit",
    fontSize: "inherit",
    fontStyle: "inherit",
    fontVariantLigatures: "inherit",
    fontWeight: "inherit",
    letterSpacing: "inherit",
    lineHeight: "inherit",
    tabSize: "inherit",
    textIndent: "inherit",
    textRendering: "inherit",
    textTransform: "inherit",
    whiteSpace: "pre-wrap",
    wordBreak: "keep-all",
    overflowWrap: "break-word",
    padding: "0px",
    paddingInline: "2px"
};
const $777d0014849a8f55$export$c86715117507e8e5 = /*#__PURE__*/ $acw62.forwardRef(function TextInput({ value: value, onUpdate: onUpdate, placeholder: placeholder, style: style, ...props }, ref) {
    function onChange(event) {
        onUpdate(event.target.value);
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        style: {
            display: "inline-block",
            position: "relative",
            textAlign: "left",
            boxSizing: "border-box",
            padding: "0px",
            ...style
        },
        ...props,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                ref: ref,
                type: "text",
                placeholder: placeholder,
                autoCapitalize: "off",
                autoComplete: "off",
                autoCorrect: "off",
                spellCheck: "false",
                "data-gramm": "false",
                onChange: onChange,
                style: {
                    ...$777d0014849a8f55$var$textInputChildStyle,
                    position: "absolute",
                    inset: "0px",
                    resize: "none",
                    color: "inherit"
                },
                value: value
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                "aria-hidden": "true",
                style: {
                    ...$777d0014849a8f55$var$textInputChildStyle,
                    textOverflow: "clip",
                    textWrap: "nowrap",
                    position: "relative",
                    pointerEvents: "none",
                    color: "transparent"
                },
                children: value || placeholder
            })
        ]
    });
});
const $777d0014849a8f55$export$353f5b6fc5456de1 = $777d0014849a8f55$export$2d100aab7348fb0a("button")`
    text-left
    text-slate-800

    hover:bg-gray-200
    focus:bg-gray-300

    transition-colors

    outline-none
    h-7 px-1 space-x-1
`;
const $777d0014849a8f55$export$8c371e86c75349bc = ({ className: className, isActive: isActive, icon: icon, iconDisabled: iconDisabled, onUpdate: onUpdate, label: label = "", ...props })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($777d0014849a8f55$export$353f5b6fc5456de1, {
        className: (className ?? "") + (isActive ? "" : " text-slate-400"),
        onClick: onUpdate,
        ...props,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($777d0014849a8f55$export$28e87d06cd5fda5e, {
                icon: isActive ? icon : iconDisabled || icon
            }),
            label && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                children: label
            })
        ]
    });
const $777d0014849a8f55$export$28e87d06cd5fda5e = ({ icon: icon })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "inline-block w-5 text-center",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e4ec753f5c716375$export$2b9260d4a45c8710), {
            size: "xs",
            icon: icon
        })
    });
function $777d0014849a8f55$export$195947546eb716de() {
    return new Promise((resolve)=>{
        const fileInput = document.createElement("input");
        fileInput.type = "file";
        fileInput.onchange = ()=>{
            resolve(fileInput.files[0]);
            fileInput.remove();
        };
        fileInput.click();
    });
}
const $777d0014849a8f55$export$b346deb0efaa17bd = /*#__PURE__*/ $acw62.forwardRef(function LoadFileButton({ onLoad: onLoad, children: children, ...props }, ref) {
    async function loadFile(event) {
        onLoad(await $777d0014849a8f55$export$195947546eb716de());
        // Workaround for headlessui Menu.Item:
        //  Menu.Item seems to inject an onClick handler, which closes the menu.
        //  If the menu is closed, this fileInput doesn't work anymore, so we defer
        //  the handler until the File Dialog is closed.
        props.onClick?.(event);
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
        ref: ref,
        ...props,
        onClick: loadFile,
        children: children
    });
});
const $777d0014849a8f55$export$a2003232d6cefe25 = ({ mimeType: mimeType, textContent: textContent, filename: filename, children: children, ...props })=>{
    const dataStr = `data:${mimeType};charset=utf-8,${encodeURIComponent(textContent)}`;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
        href: dataStr,
        download: filename,
        ...props,
        children: children
    });
};
function $777d0014849a8f55$export$e620933a198f7bc(filename, blob) {
    const downloadButton = document.createElement("a");
    const url = URL.createObjectURL(blob);
    downloadButton.href = url;
    downloadButton.download = filename;
    downloadButton.click();
    downloadButton.remove();
    URL.revokeObjectURL(url);
}
function $777d0014849a8f55$export$25245567f53f158f(predicate, elem) {
    if (!elem) return null;
    if (predicate(elem)) return elem;
    return $777d0014849a8f55$export$25245567f53f158f(predicate, elem.parentElement);
}
function $777d0014849a8f55$export$b3053c7afe37670c(elem) {
    return elem instanceof HTMLTextAreaElement || elem instanceof HTMLInputElement || elem instanceof HTMLElement && !!$777d0014849a8f55$export$25245567f53f158f((parent)=>parent.isContentEditable, elem);
}
function $777d0014849a8f55$export$67289be57e41ecc(elem, options) {
    elem.focus(options);
    // Also setting the range makes sure that copy/paste events get fired on `elem`
    const range = document.createRange();
    range.setStart(elem, 0);
    range.setEnd(elem, 0);
    document.getSelection().removeAllRanges();
    document.getSelection().addRange(range);
}


function $97abc9ea0b65aa17$export$20c1ba2f5deaef1e(page) {
    return "Untitled_" + page.id;
}
function $97abc9ea0b65aa17$export$7d9f7e9c1c02b41e(page) {
    if (page.name.length === 0) return $97abc9ea0b65aa17$export$20c1ba2f5deaef1e(page);
    return page.name;
}


var $303c1b51f19a20e4$exports = {};

$parcel$export($303c1b51f19a20e4$exports, "addValidator", () => $303c1b51f19a20e4$export$136de4b706fa579);
$parcel$export($303c1b51f19a20e4$exports, "addRevision", () => $303c1b51f19a20e4$export$471c540adb39cb81);


function $303c1b51f19a20e4$export$136de4b706fa579(schema, parseValidated) {
    function withValidator(input) {
        (0, $dc2e80b7ebe4adb5$export$d855ff590c973c92)(schema, input);
        return parseValidated(input);
    }
    withValidator.toString = ()=>`addValidator(${(0, $512ec8d668819b2f$export$fac44ee5b035f737)(schema)}, ${parseValidated})`;
    return withValidator;
}
function $303c1b51f19a20e4$export$471c540adb39cb81(before, revision) {
    function deserializeRevision(input) {
        try {
            (0, $dc2e80b7ebe4adb5$export$d855ff590c973c92)(revision.schema, input);
            return revision.parse(input);
        } catch (currentError) {
            try {
                return revision.upgrade(before(input));
            } catch (beforeError) {
                throw new Error([
                    `Could not deserialize revision`,
                    `  ${(0, $512ec8d668819b2f$export$fac44ee5b035f737)(revision.schema)}`,
                    $303c1b51f19a20e4$var$indent("  ", currentError.toString()),
                    beforeError.toString()
                ].join("\n"));
            }
        }
    }
    deserializeRevision.toString = ()=>`addRevision(${before}, ${(0, $512ec8d668819b2f$export$fac44ee5b035f737)(revision)})`;
    return deserializeRevision;
}
function $303c1b51f19a20e4$var$indent(indentation, str) {
    return str.split("\n").map((line)=>indentation + line).join("\n");
}



function $6a3a116a0ad443ab$export$519f616c41a1c711(version, obj) {
    return {
        t: "resheet.document",
        v: version,
        ...obj
    };
}
function $6a3a116a0ad443ab$export$5fcf3708531ce6d(version, obj) {
    return {
        t: "tables.document",
        v: version,
        ...obj
    };
}








const $2a520e369aee0276$var$pageSchema = {
    id: (0, $dc2e80b7ebe4adb5$export$98e628dec113755e),
    name: (0, $dc2e80b7ebe4adb5$export$22b082955e083ec3),
    state: (0, $dc2e80b7ebe4adb5$export$4154a199d7d90455),
    children: (0, $dc2e80b7ebe4adb5$export$2f23118c22fb2630)((0, $dc2e80b7ebe4adb5$export$488013bae63b21da)(()=>$2a520e369aee0276$var$pageSchema)),
    isCollapsed: (0, $dc2e80b7ebe4adb5$export$4a21f16c33752377)
};
const $2a520e369aee0276$var$documentSchema = {
    pages: (0, $dc2e80b7ebe4adb5$export$2f23118c22fb2630)($2a520e369aee0276$var$pageSchema),
    template: (0, $dc2e80b7ebe4adb5$export$4154a199d7d90455),
    viewState: {
        sidebarOpen: (0, $dc2e80b7ebe4adb5$export$4a21f16c33752377),
        openPage: (0, $dc2e80b7ebe4adb5$export$2f23118c22fb2630)((0, $dc2e80b7ebe4adb5$export$98e628dec113755e))
    }
};
const $2a520e369aee0276$var$vPre = (0, $303c1b51f19a20e4$export$136de4b706fa579)($2a520e369aee0276$var$documentSchema, (json)=>({ updatePageStateAt: updatePageStateAt, env: env, innerBlock: innerBlock })=>{
        return $2a520e369aee0276$var$parse(json, updatePageStateAt, env, innerBlock);
    });
// First parser with typing and versioning
function $2a520e369aee0276$var$parse(json, updatePageStateAt, env, innerBlock) {
    const { pages: pages, template: template, viewState: viewState } = json;
    const loadedTemplate = $2a520e369aee0276$var$parsePage(template, ()=>{}, env, innerBlock, []);
    const loadedPages = $2a520e369aee0276$var$parseSiblingPages(pages, updatePageStateAt, env, innerBlock, []);
    return {
        pages: loadedPages,
        template: loadedTemplate,
        viewState: viewState
    };
}
function $2a520e369aee0276$var$parsePage(json, updatePageStateAt, env, innerBlock, path) {
    const { id: id, name: name, state: state, children: children, isCollapsed: isCollapsed } = json;
    const pathHere = [
        ...path,
        id
    ];
    function localDispatch(action) {
        updatePageStateAt(pathHere, action);
    }
    const loadedChildren = $2a520e369aee0276$var$parseSiblingPages(children, updatePageStateAt, env, innerBlock, pathHere);
    const pageEnv = getSiblingsEnv(children, env);
    const loadedState = innerBlock.fromJSON(state, localDispatch, pageEnv);
    const page = {
        id: id,
        name: name,
        state: loadedState,
        isCollapsed: isCollapsed,
        children: loadedChildren
    };
    return page;
    function getSiblingsEnv(siblings, env) {
        return Object.assign({}, env, ...siblings.map((sibling)=>({
                [(0, $97abc9ea0b65aa17$export$7d9f7e9c1c02b41e)(sibling)]: innerBlock.getResult(sibling.state)
            })));
    }
}
function $2a520e369aee0276$var$parseSiblingPages(json, updatePageStateAt, env, innerBlock, path) {
    return $6f23581c0aef6dc2$export$7ebd55fd2b28b5a(json, (jsonEntry, localEnv)=>{
        const page = $2a520e369aee0276$var$parsePage(jsonEntry, updatePageStateAt, localEnv, innerBlock, path);
        return {
            out: page,
            env: {
                [(0, $97abc9ea0b65aa17$export$7d9f7e9c1c02b41e)(page)]: innerBlock.getResult(page.state)
            }
        };
    }, env);
}
const $2a520e369aee0276$export$21625637effda04 = (0, $303c1b51f19a20e4$export$471c540adb39cb81)($2a520e369aee0276$var$vPre, {
    schema: (0, $6a3a116a0ad443ab$export$5fcf3708531ce6d)(0, $2a520e369aee0276$var$documentSchema),
    parse: (json)=>({ updatePageStateAt: updatePageStateAt, env: env, innerBlock: innerBlock })=>{
            return $2a520e369aee0276$var$parse(json, updatePageStateAt, env, innerBlock);
        },
    upgrade: (before)=>before
});
function $2a520e369aee0276$export$54fd2c36b5cc6731(state, innerBlock) {
    const { viewState: viewState } = state;
    const template = $2a520e369aee0276$var$pageToJSON(state.template, innerBlock);
    const pages = $2a520e369aee0276$var$pagesToJSON(state.pages, innerBlock);
    return {
        pages: pages,
        viewState: viewState,
        template: template
    };
}
function $2a520e369aee0276$var$pagesToJSON(pages, innerBlock) {
    return pages.map((page)=>$2a520e369aee0276$var$pageToJSON(page, innerBlock));
}
function $2a520e369aee0276$var$pageToJSON(page, innerBlock) {
    return {
        id: page.id,
        name: page.name,
        state: innerBlock.toJSON(page.state),
        isCollapsed: page.isCollapsed,
        children: $2a520e369aee0276$var$pagesToJSON(page.children, innerBlock)
    };
}


const $9d7e60768dbfb647$var$pageSchema = {
    id: (0, $dc2e80b7ebe4adb5$export$98e628dec113755e),
    name: (0, $dc2e80b7ebe4adb5$export$22b082955e083ec3),
    state: (0, $dc2e80b7ebe4adb5$export$4154a199d7d90455),
    children: (0, $dc2e80b7ebe4adb5$export$2f23118c22fb2630)((0, $dc2e80b7ebe4adb5$export$488013bae63b21da)(()=>$9d7e60768dbfb647$var$pageSchema)),
    isCollapsed: (0, $dc2e80b7ebe4adb5$export$4a21f16c33752377)
};
const $9d7e60768dbfb647$var$documentSchema = {
    pages: (0, $dc2e80b7ebe4adb5$export$2f23118c22fb2630)($9d7e60768dbfb647$var$pageSchema),
    template: (0, $dc2e80b7ebe4adb5$export$4154a199d7d90455),
    viewState: {
        sidebarOpen: (0, $dc2e80b7ebe4adb5$export$4a21f16c33752377),
        openPage: (0, $dc2e80b7ebe4adb5$export$2f23118c22fb2630)((0, $dc2e80b7ebe4adb5$export$98e628dec113755e))
    }
};
function $9d7e60768dbfb647$var$parse(json, updatePageStateAt, env, innerBlock) {
    const { pages: pages, template: template, viewState: viewState } = json;
    const loadedTemplate = $9d7e60768dbfb647$export$24bd15d4096a8848(template, ()=>{}, env, innerBlock, []);
    const loadedPages = $9d7e60768dbfb647$var$parseSiblingPages(pages, updatePageStateAt, env, innerBlock, []);
    return {
        pages: loadedPages,
        template: loadedTemplate,
        viewState: viewState
    };
}
function $9d7e60768dbfb647$export$24bd15d4096a8848(json, updatePageStateAt, env, innerBlock, path) {
    const { id: id, name: name, state: state, children: children, isCollapsed: isCollapsed } = json;
    const pathHere = [
        ...path,
        id
    ];
    function localDispatch(action) {
        updatePageStateAt(pathHere, action);
    }
    const loadedChildren = $9d7e60768dbfb647$var$parseSiblingPages(children, updatePageStateAt, env, innerBlock, pathHere);
    const pageEnv = {
        ...env,
        ...$9d7e60768dbfb647$var$pagesToEnv(loadedChildren, innerBlock)
    };
    const loadedState = innerBlock.fromJSON(state, localDispatch, pageEnv);
    const page = {
        id: id,
        name: name,
        state: loadedState,
        isCollapsed: isCollapsed,
        children: loadedChildren
    };
    return page;
}
function $9d7e60768dbfb647$var$parseSiblingPages(json, updatePageStateAt, env, innerBlock, path) {
    const { pages: pages } = json.reduce(({ pages: pages, localEnv: localEnv }, jsonEntry)=>{
        const page = $9d7e60768dbfb647$export$24bd15d4096a8848(jsonEntry, updatePageStateAt, localEnv, innerBlock, path);
        return {
            pages: [
                ...pages,
                page
            ],
            localEnv: {
                ...localEnv,
                [(0, $97abc9ea0b65aa17$export$7d9f7e9c1c02b41e)(page)]: innerBlock.getResult(page.state)
            }
        };
    }, {
        pages: [],
        localEnv: env
    });
    return pages;
}
function $9d7e60768dbfb647$var$pagesToEnv(siblings, innerBlock) {
    return Object.assign({}, ...siblings.map((sibling)=>({
            [(0, $97abc9ea0b65aa17$export$7d9f7e9c1c02b41e)(sibling)]: innerBlock.getResult(sibling.state)
        })));
}
const $9d7e60768dbfb647$export$21625637effda04 = (0, $303c1b51f19a20e4$export$471c540adb39cb81)($2a520e369aee0276$export$21625637effda04, {
    schema: (0, $6a3a116a0ad443ab$export$519f616c41a1c711)(1, $9d7e60768dbfb647$var$documentSchema),
    parse: (json)=>({ updatePageStateAt: updatePageStateAt, env: env, innerBlock: innerBlock })=>{
            return $9d7e60768dbfb647$var$parse(json, updatePageStateAt, env, innerBlock);
        },
    upgrade: (before)=>before
});
function $9d7e60768dbfb647$export$54fd2c36b5cc6731(state, innerBlock) {
    const { viewState: viewState } = state;
    const template = $9d7e60768dbfb647$export$b5298ef9fe6bcf1(state.template, innerBlock);
    const pages = $9d7e60768dbfb647$var$pagesToJSON(state.pages, innerBlock);
    return (0, $6a3a116a0ad443ab$export$519f616c41a1c711)(1, {
        pages: pages,
        viewState: viewState,
        template: template
    });
}
function $9d7e60768dbfb647$var$pagesToJSON(pages, innerBlock) {
    return pages.map((page)=>$9d7e60768dbfb647$export$b5298ef9fe6bcf1(page, innerBlock));
}
function $9d7e60768dbfb647$export$b5298ef9fe6bcf1(page, innerBlock) {
    return {
        id: page.id,
        name: page.name,
        state: innerBlock.toJSON(page.state),
        isCollapsed: page.isCollapsed,
        children: $9d7e60768dbfb647$var$pagesToJSON(page.children, innerBlock)
    };
}




function $ea3d541d2f2fc6fe$export$2cd8252107eb640b(id, initState) {
    return {
        id: id,
        name: "",
        state: initState,
        isCollapsed: true,
        children: []
    };
}
function $ea3d541d2f2fc6fe$export$9d6acabda8b45309(page, innerBlock) {
    return {
        [(0, $97abc9ea0b65aa17$export$7d9f7e9c1c02b41e)(page)]: innerBlock.getResult(page.state)
    };
}
function $ea3d541d2f2fc6fe$export$a12370985d3b367(path, pages) {
    if (path.length === 0) return null;
    const page = pages.find((page)=>page.id === path[0]);
    if (page === undefined) return null;
    if (path.length === 1) return page;
    return $ea3d541d2f2fc6fe$export$a12370985d3b367(path.slice(1), page.children);
}
function $ea3d541d2f2fc6fe$export$d42c447bd3fad192(pages) {
    return pages.flatMap((page)=>[
            [
                page.id
            ],
            ...$ea3d541d2f2fc6fe$export$d42c447bd3fad192(page.children).map((path)=>[
                    page.id,
                    ...path
                ])
        ]);
}
function $ea3d541d2f2fc6fe$export$65bbd8e473548251(pages, currentPath = []) {
    return pages.flatMap((page)=>{
        const isInPath = page.id === currentPath[0];
        const childPath = isInPath ? currentPath.slice(1) : [];
        const areChildrenVisible = !page.isCollapsed || childPath.length > 0;
        const childPaths = areChildrenVisible ? $ea3d541d2f2fc6fe$export$65bbd8e473548251(page.children, childPath) : [];
        return [
            [
                page.id
            ],
            ...childPaths.map((path)=>[
                    page.id,
                    ...path
                ])
        ];
    });
}
function $ea3d541d2f2fc6fe$export$6a032b865f6fa31d(id, pages) {
    const selfIndex = Math.min(Number.MAX_SAFE_INTEGER, pages.findIndex((page)=>page.id === id));
    const siblingsBefore = pages.slice(0, selfIndex);
    const siblingsAfter = pages.slice(selfIndex + 1);
    return [
        siblingsBefore,
        pages[selfIndex],
        siblingsAfter
    ];
}
function $ea3d541d2f2fc6fe$export$399e9750aa264c82(path, pages) {
    const siblings = path.length <= 1 ? pages : $ea3d541d2f2fc6fe$export$a12370985d3b367(path.slice(0, -1), pages).children;
    const selfId = path.slice(-1)[0] ?? -1;
    const selfIndex = Math.min(Number.MAX_SAFE_INTEGER, siblings.findIndex((page)=>page.id === selfId));
    const siblingsBefore = siblings.slice(0, selfIndex);
    const siblingsAfter = siblings.slice(selfIndex + 1);
    return [
        siblingsBefore,
        siblingsAfter
    ];
}
function $ea3d541d2f2fc6fe$export$7d76a0b6947ec50f(path, pages) {
    const parentPath = path.slice(0, -1);
    const [siblingsBefore, siblingsAfter] = $ea3d541d2f2fc6fe$export$399e9750aa264c82(path, pages);
    if (siblingsAfter.length > 0) return [
        ...parentPath,
        siblingsAfter[0].id
    ];
    else if (siblingsBefore.length > 0) return [
        ...parentPath,
        siblingsBefore.slice(-1)[0].id
    ];
    else return parentPath;
}
function $ea3d541d2f2fc6fe$export$6d5fb87801f9083b(pages, innerBlock) {
    return Object.assign({}, ...pages.map((page)=>$ea3d541d2f2fc6fe$export$9d6acabda8b45309(page, innerBlock)));
}
function $ea3d541d2f2fc6fe$export$71b7cddbb772ef8c(path, pages) {
    if (path.length === 0) return pages;
    const [siblingsBefore, page, _siblingsAfter] = $ea3d541d2f2fc6fe$export$6a032b865f6fa31d(path[0], pages);
    return [
        ...siblingsBefore,
        ...$ea3d541d2f2fc6fe$export$71b7cddbb772ef8c(path.slice(1), page.children)
    ];
}
function $ea3d541d2f2fc6fe$export$3966830784117211(path, pages, env, innerBlock, dispatchPagesState) {
    if (path.length <= 1) return [
        path,
        pages
    ];
    const pageToMove = $ea3d541d2f2fc6fe$export$a12370985d3b367(path, pages);
    if (pageToMove === null) return [
        path,
        pages
    ];
    const newParentPath = path.slice(0, -2);
    const currentParentPath = path.slice(0, -1);
    const currentParentId = currentParentPath.slice(-1)[0];
    const pageToMoveId = path.slice(-1)[0];
    let newPath = path;
    let recomputePath = path;
    const newPages = $ea3d541d2f2fc6fe$export$8860063974dfcb99(pages, (path, siblings)=>{
        if ((0, $512ec8d668819b2f$export$22d6d01dd47e89dd)(path, currentParentPath)) {
            const pageToMoveIndex = siblings.findIndex((sibling)=>sibling.id === pageToMoveId);
            if (pageToMoveIndex >= siblings.length - 1) // if we're the last sibling, start recomputing the parent
            recomputePath = path.slice(0, -1);
            else {
                const siblingAfter = siblings[pageToMoveIndex + 1];
                recomputePath = [
                    ...currentParentPath,
                    siblingAfter.id
                ];
            }
            return [
                ...siblings.slice(0, pageToMoveIndex),
                ...siblings.slice(pageToMoveIndex + 1)
            ];
        }
        if ((0, $512ec8d668819b2f$export$22d6d01dd47e89dd)(path, newParentPath)) {
            const index = siblings.findIndex((page)=>page.id === currentParentId);
            const newId = $9d52f07a71ba7cea$export$fba3009e3ea7651a(siblings);
            const newPageToMove = {
                ...pageToMove,
                id: newId
            };
            newPath = [
                ...newParentPath,
                newId
            ];
            return [
                ...siblings.slice(0, index + 1),
                newPageToMove,
                ...siblings.slice(index + 1)
            ];
        }
        return siblings;
    });
    return [
        newPath,
        $ea3d541d2f2fc6fe$export$7f76e9ee07028bf0(recomputePath, newPages, env, (0, $e6de90c09d008aae$export$bdf4ff5a442cbbc5)([
            (0, $97abc9ea0b65aa17$export$7d9f7e9c1c02b41e)(pageToMove)
        ]), innerBlock, dispatchPagesState).state
    ];
}
function $ea3d541d2f2fc6fe$export$ba53fb6ee6a1097f(path, pages, env, innerBlock, dispatchPagesState) {
    if (path.length === 0) return [
        path,
        pages
    ];
    const pageToMove = $ea3d541d2f2fc6fe$export$a12370985d3b367(path, pages);
    if (pageToMove === null) return [
        path,
        pages
    ];
    const parentPath = path.slice(0, -1);
    const childId = path.slice(-1)[0];
    let newPath = path;
    const newPages = $ea3d541d2f2fc6fe$export$e065bdcd47f54c29(parentPath, pages, (siblings)=>{
        const childIndex = siblings.findIndex((page)=>page.id === childId);
        if (childIndex === 0) return siblings;
        const child = siblings[childIndex];
        const newParent = siblings[childIndex - 1];
        const newChild = {
            ...child,
            id: $9d52f07a71ba7cea$export$fba3009e3ea7651a(newParent.children)
        };
        newPath = [
            ...parentPath,
            newParent.id,
            newChild.id
        ];
        return [
            ...siblings.slice(0, childIndex - 1),
            {
                ...newParent,
                children: [
                    ...newParent.children,
                    newChild
                ]
            },
            ...siblings.slice(childIndex + 1)
        ];
    });
    return [
        newPath,
        $ea3d541d2f2fc6fe$export$7f76e9ee07028bf0(newPath, newPages, env, (0, $e6de90c09d008aae$export$bdf4ff5a442cbbc5)([
            (0, $97abc9ea0b65aa17$export$7d9f7e9c1c02b41e)(pageToMove)
        ]), innerBlock, dispatchPagesState).state
    ];
}
function $ea3d541d2f2fc6fe$export$c90f31335c54e820(delta, path, pages, innerBlock, env, dispatchPagesState) {
    if (path.length === 0) return pages;
    const pageToMove = $ea3d541d2f2fc6fe$export$a12370985d3b367(path, pages);
    const parentPath = path.slice(0, -1);
    const childId = path.slice(-1)[0];
    let recomputePath = path;
    function moveSibling(id, siblings) {
        const index = siblings.findIndex((page)=>page.id === id);
        if (index < 0) return siblings;
        const pageToMove = siblings[index];
        const newIndex = (0, $512ec8d668819b2f$export$d17171af8942fb21)(0, siblings.length, index + delta);
        const siblingsWithout = siblings.filter((page)=>page.id !== pageToMove.id);
        if (delta < 0) {
            if (index === siblings.length - 1) recomputePath = parentPath;
            else {
                const siblingAfterPageToMove = siblings[index + 1];
                recomputePath = [
                    ...parentPath,
                    siblingAfterPageToMove.id
                ];
            }
        }
        const newSiblings = [
            ...siblingsWithout.slice(0, newIndex),
            pageToMove,
            ...siblingsWithout.slice(newIndex)
        ];
        return newSiblings;
    }
    return $ea3d541d2f2fc6fe$export$7f76e9ee07028bf0(recomputePath, $ea3d541d2f2fc6fe$export$e065bdcd47f54c29(parentPath, pages, (siblings)=>moveSibling(childId, siblings)), env, (0, $e6de90c09d008aae$export$bdf4ff5a442cbbc5)([
        (0, $97abc9ea0b65aa17$export$7d9f7e9c1c02b41e)(pageToMove)
    ]), innerBlock, dispatchPagesState).state;
}
function $ea3d541d2f2fc6fe$export$8860063974dfcb99(siblings, update, currentPath = []) {
    const newSiblings = update(currentPath, siblings);
    return newSiblings.map((page)=>{
        const pathHere = [
            ...currentPath,
            page.id
        ];
        const children = $ea3d541d2f2fc6fe$export$8860063974dfcb99(page.children, update, pathHere);
        return {
            ...page,
            children: children
        };
    });
}
function $ea3d541d2f2fc6fe$export$e065bdcd47f54c29(parentPath, siblings, update) {
    return $ea3d541d2f2fc6fe$export$8860063974dfcb99(siblings, (path, siblings)=>{
        if (!(0, $512ec8d668819b2f$export$22d6d01dd47e89dd)(path, parentPath)) return siblings;
        return update(siblings);
    });
}
function $ea3d541d2f2fc6fe$export$99c419afdb002672(pages, update, currentPath = []) {
    return pages.map((page)=>{
        const pathHere = [
            ...currentPath,
            page.id
        ];
        const children = $ea3d541d2f2fc6fe$export$99c419afdb002672(page.children, update, pathHere);
        return update({
            ...page,
            children: children
        }, pathHere);
    });
}
function $ea3d541d2f2fc6fe$export$f009d12f262e197f(path, dispatchPagesState, action, innerBlock) {
    dispatchPagesState((pages, context)=>(0, $6f23581c0aef6dc2$export$b6ca37fc03181c21)(action, (pureAction)=>{
            return $ea3d541d2f2fc6fe$export$7a67d5096c18e401(path, pages, (page, context)=>({
                    ...page,
                    state: pureAction(page.state, context)
                }), context.env, innerBlock, dispatchPagesState);
        }));
}
function $ea3d541d2f2fc6fe$export$7f76e9ee07028bf0(pathWithChanges, pages, env, changedVars, innerBlock, dispatchPagesState, currentPath = []) {
    const recomputeStartIndex = pathWithChanges === null ? 0 : pathWithChanges.length === 0 ? // pages are the children of the changed page -- they don't need to be recalculated
    pages.length : pathWithChanges.length === 1 ? // don't recalculate the page that changed
    1 + pages.findIndex((page)=>page.id === pathWithChanges[0]) : pages.findIndex((page)=>page.id === pathWithChanges[0]);
    let changedSiblings;
    if (pathWithChanges === null) changedSiblings = (0, $e6de90c09d008aae$export$bdf4ff5a442cbbc5)();
    else if (pathWithChanges.length === 1) {
        const changedPage = pages.find((page)=>page.id === pathWithChanges[0]);
        changedSiblings = changedPage ? (0, $e6de90c09d008aae$export$bdf4ff5a442cbbc5)([
            (0, $97abc9ea0b65aa17$export$7d9f7e9c1c02b41e)(changedPage)
        ]) : (0, $e6de90c09d008aae$export$bdf4ff5a442cbbc5)();
    } else changedSiblings = (0, $e6de90c09d008aae$export$bdf4ff5a442cbbc5)();
    const unaffectedPages = pages.slice(0, recomputeStartIndex);
    const affectedPages = pages.slice(recomputeStartIndex);
    const affectedPagesEnv = {
        ...env,
        ...$ea3d541d2f2fc6fe$export$6d5fb87801f9083b(unaffectedPages, innerBlock)
    };
    const recomputedPages = affectedPages.reduce(({ recomputed: recomputed, localEnv: localEnv, changedSiblings: changedSiblings }, page)=>{
        function localDispatch(action) {
            $ea3d541d2f2fc6fe$export$f009d12f262e197f(pathHere, dispatchPagesState, action, innerBlock);
        }
        const changedVarsWithSiblings = changedVars?.union(changedSiblings);
        const pathHere = [
            ...currentPath,
            page.id
        ];
        const children = $ea3d541d2f2fc6fe$export$7f76e9ee07028bf0(pathWithChanges?.[0] === page.id ? pathWithChanges.slice(1) : null, page.children, localEnv, changedVarsWithSiblings, innerBlock, dispatchPagesState, pathHere);
        const localEnvWithChildren = {
            ...localEnv,
            ...$ea3d541d2f2fc6fe$export$6d5fb87801f9083b(children.state, innerBlock)
        };
        const changedVarsWithChildren = changedVarsWithSiblings?.union(children.changedPages);
        const { state: state, invalidated: invalidated } = innerBlock.recompute(page.state, localDispatch, localEnvWithChildren, changedVarsWithChildren);
        const name = (0, $97abc9ea0b65aa17$export$7d9f7e9c1c02b41e)(page);
        const newChangedPages = invalidated ? changedSiblings.add(name) : changedSiblings.remove(name);
        const newPage = {
            ...page,
            children: children.state,
            state: state
        };
        return {
            recomputed: [
                ...recomputed,
                newPage
            ],
            localEnv: {
                ...localEnv,
                ...$ea3d541d2f2fc6fe$export$9d6acabda8b45309(newPage, innerBlock)
            },
            changedSiblings: newChangedPages
        };
    }, {
        recomputed: [],
        localEnv: affectedPagesEnv,
        changedSiblings: changedSiblings
    });
    return {
        state: [
            ...unaffectedPages,
            ...recomputedPages.recomputed
        ],
        changedPages: recomputedPages.changedSiblings
    };
}
function $ea3d541d2f2fc6fe$export$5813b750fe20a278(path, pages, action, env, innerBlock) {
    if (path.length === 0) return pages;
    const [siblingsBefore, page, siblingsAfter] = $ea3d541d2f2fc6fe$export$6a032b865f6fa31d(path[0], pages);
    const siblingsEnv = $ea3d541d2f2fc6fe$export$6d5fb87801f9083b(siblingsBefore, innerBlock);
    if (path.length === 1) {
        const childrenEnv = $ea3d541d2f2fc6fe$export$6d5fb87801f9083b(page.children, innerBlock);
        const newPage = action(page, {
            env: {
                ...env,
                ...siblingsEnv,
                ...childrenEnv
            }
        });
        return [
            ...siblingsBefore,
            newPage,
            ...siblingsAfter
        ];
    } else {
        const newChildren = $ea3d541d2f2fc6fe$export$5813b750fe20a278(path.slice(1), page.children, action, {
            ...env,
            ...siblingsEnv
        }, innerBlock);
        const newPage = {
            ...page,
            children: newChildren
        };
        return [
            ...siblingsBefore,
            newPage,
            ...siblingsAfter
        ];
    }
}
function $ea3d541d2f2fc6fe$export$7a67d5096c18e401(path, pages, action, env, innerBlock, dispatchPagesState) {
    if (path.length === 0) return pages;
    const pageBefore = $ea3d541d2f2fc6fe$export$a12370985d3b367(path, pages);
    if (!pageBefore) return pages;
    const nameBefore = (0, $97abc9ea0b65aa17$export$7d9f7e9c1c02b41e)(pageBefore);
    const updatedPages = $ea3d541d2f2fc6fe$export$5813b750fe20a278(path, pages, action, env, innerBlock);
    return $ea3d541d2f2fc6fe$export$7f76e9ee07028bf0(path, updatedPages, env, (0, $e6de90c09d008aae$export$bdf4ff5a442cbbc5)([
        nameBefore
    ]), innerBlock, dispatchPagesState).state;
}
const $ea3d541d2f2fc6fe$var$pageStyle = {
    paddingX: 0.5,
    indentDepth: 1,
    indentClass (depth) {
        const paddingLeft = $ea3d541d2f2fc6fe$var$pageStyle.paddingX + depth * $ea3d541d2f2fc6fe$var$pageStyle.indentDepth;
        return `pl-[${paddingLeft}rem] pr-[${$ea3d541d2f2fc6fe$var$pageStyle.paddingX}rem]`;
    }
};
function $ea3d541d2f2fc6fe$var$PageEntryComponent({ page: page, path: path = [], openPage: openPage, actions: actions, isNameEditing: isNameEditing, setIsNameEditing: setIsNameEditing, onFinishEditingName: onFinishEditingName }) {
    const depth = path.length;
    const pathHere = [
        ...path,
        page.id
    ];
    const pageInOpenPath = (0, $512ec8d668819b2f$export$28e46a10850766f0)(pathHere, openPage.slice(0, -1));
    const pageCollapsed = page.isCollapsed && !pageInOpenPath;
    function onChangeName(event) {
        actions.setPageName(pathHere, event.target.value);
    }
    function onInputKeyDown(event) {
        switch((0, $777d0014849a8f55$export$ebf72dfe5a040886)(event)){
            case "Enter":
            case "Escape":
                onCommitName();
                onFinishEditingName();
                event.stopPropagation();
                event.preventDefault();
                return;
        }
    }
    function onCommitName() {
        if (page.name !== page.name.trim()) actions.setPageName(pathHere, page.name.trim());
        setIsNameEditing(false);
    }
    function onAddChild(event) {
        actions.addPage(pathHere);
        event.stopPropagation();
    }
    function onDeleteChild(event) {
        actions.deletePage(pathHere);
        event.stopPropagation();
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: `
                    ${$ea3d541d2f2fc6fe$var$pageStyle.indentClass(depth)} py-1 text-left group cursor-pointer flex space-x-2
                    ${(0, $512ec8d668819b2f$export$22d6d01dd47e89dd)(pathHere, openPage) && "bg-gray-300 group-focus/document-ui:bg-blue-300"}
                `,
                onClick: ()=>actions.openPage(pathHere),
                children: [
                    page.children.length > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        onClick: (ev)=>{
                            ev.stopPropagation();
                            if (!page.isCollapsed && pageInOpenPath) actions.openPage(pathHere);
                            actions.toggleCollapsed(pathHere);
                        },
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e4ec753f5c716375$export$2b9260d4a45c8710), {
                            className: "text-gray-500 w-4",
                            icon: pageCollapsed ? $d8206b3ab2e65c05$export$6bce1afb61f2eb66 : $d8206b3ab2e65c05$export$4b5be0142d10f342
                        })
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "text-gray-400/50 w-4 text-center",
                        children: "\u2022"
                    }),
                    isNameEditing && (0, $512ec8d668819b2f$export$22d6d01dd47e89dd)(pathHere, openPage) ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                        className: "flex-1 min-w-0 w-full",
                        type: "text",
                        autoFocus: true,
                        value: page.name,
                        placeholder: (0, $97abc9ea0b65aa17$export$20c1ba2f5deaef1e)(page),
                        onChange: onChangeName,
                        onBlur: onCommitName,
                        onKeyDown: onInputKeyDown
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "truncate",
                                onDoubleClick: (ev)=>{
                                    ev.stopPropagation();
                                    setIsNameEditing(true);
                                },
                                children: (0, $97abc9ea0b65aa17$export$7d9f7e9c1c02b41e)(page)
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "flex-1"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                className: "hidden group-hover:inline-block text-gray-500 hover:text-blue-500",
                                onClick: onDeleteChild,
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e4ec753f5c716375$export$2b9260d4a45c8710), {
                                    icon: $7435a4b2c8a749a5$export$864bb8d6c21fb792
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                className: "hidden group-hover:inline-block text-gray-500 hover:text-blue-500",
                                onClick: onAddChild,
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e4ec753f5c716375$export$2b9260d4a45c8710), {
                                    icon: $d8206b3ab2e65c05$export$a105e7b44ca0eb9e
                                })
                            })
                        ]
                    })
                ]
            }),
            !pageCollapsed && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ea3d541d2f2fc6fe$export$ba4ce60cb663c13f, {
                page: page,
                path: pathHere,
                actions: actions,
                openPage: openPage,
                isNameEditing: isNameEditing,
                setIsNameEditing: setIsNameEditing,
                onFinishEditingName: onFinishEditingName
            })
        ]
    });
}
const $ea3d541d2f2fc6fe$export$2e3a14fa5b062651 = /*#__PURE__*/ $acw62.memo($ea3d541d2f2fc6fe$var$PageEntryComponent, ({ page: prevPage, path: prevPath, openPage: prevOpenPage, ...prevProps }, { page: nextPage, path: nextPath, openPage: nextOpenPage, ...nextProps })=>$ea3d541d2f2fc6fe$export$9aad1f9ca871fc45(prevPage, nextPage) && (0, $512ec8d668819b2f$export$22d6d01dd47e89dd)(prevPath, nextPath) && (0, $512ec8d668819b2f$export$22d6d01dd47e89dd)(prevOpenPage, nextOpenPage) && (0, $512ec8d668819b2f$export$1ffefdb29429119e)(prevProps, nextProps, 1));
function $ea3d541d2f2fc6fe$export$9aad1f9ca871fc45(page1, page2) {
    if (page1 === page2) return true;
    if (!page1 !== !page2) return false;
    return page1.name === page2.name && page1.id === page2.id && page1.isCollapsed === page2.isCollapsed && page1.children.length === page2.children.length && (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).zipWith(page1.children, page2.children, $ea3d541d2f2fc6fe$export$9aad1f9ca871fc45).every((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).identity);
}
function $ea3d541d2f2fc6fe$export$ba4ce60cb663c13f({ page: page, actions: actions, path: path, openPage: openPage, ...props }) {
    const keyHere = path.join(".");
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: page.children.map((child)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ea3d541d2f2fc6fe$export$2e3a14fa5b062651, {
                page: child,
                path: path,
                openPage: openPage,
                actions: actions,
                ...props
            }, keyHere + "." + child.id))
    });
}



function $ee99fa6430885fc2$export$2cd8252107eb640b(initInner) {
    return {
        viewState: {
            sidebarOpen: true,
            openPage: []
        },
        template: $ea3d541d2f2fc6fe$export$2cd8252107eb640b(-1, initInner),
        pages: []
    };
}
function $ee99fa6430885fc2$export$21625637effda04(json, dispatch, env, innerBlock) {
    const dispatchPages = (0, $d0f575b1326e7f91$export$f153e5abd026c378)("pages", dispatch);
    function updatePageStateAt(path, action) {
        $ea3d541d2f2fc6fe$export$f009d12f262e197f(path, dispatchPages, action, innerBlock);
    }
    return $9d7e60768dbfb647$export$21625637effda04(json)({
        updatePageStateAt: updatePageStateAt,
        env: env,
        innerBlock: innerBlock
    });
}
function $ee99fa6430885fc2$export$ec795fdf61e2a255(state, innerBlock) {
    return $9d52f07a71ba7cea$export$3024f7e3be75347b(state.pages, innerBlock);
}
function $ee99fa6430885fc2$export$1f297d8d0ce29e3(state, dispatch, env, changedVars, innerBlock) {
    const dispatchPages = (0, $d0f575b1326e7f91$export$f153e5abd026c378)("pages", dispatch);
    const { state: pages, changedPages: changedPages } = $ea3d541d2f2fc6fe$export$7f76e9ee07028bf0(null, state.pages, env, changedVars, innerBlock, dispatchPages);
    return {
        state: {
            ...state,
            pages: pages
        },
        invalidated: !changedPages.isEmpty()
    };
}
function $ee99fa6430885fc2$export$d99fd09303be89f2(state) {
    return $ea3d541d2f2fc6fe$export$a12370985d3b367(state.viewState.openPage, state.pages);
}
function $ee99fa6430885fc2$export$20827ed15e8882d8(state) {
    return $ea3d541d2f2fc6fe$export$71b7cddbb772ef8c(state.viewState.openPage, state.pages);
}
function $ee99fa6430885fc2$export$193537437f9d47dc(pageDeps, env, innerBlock) {
    return Object.assign({}, env, ...pageDeps.map((page)=>$ea3d541d2f2fc6fe$export$9d6acabda8b45309(page, innerBlock)));
}
function $ee99fa6430885fc2$export$c71f8f524af5213e(path, state) {
    return {
        ...state,
        viewState: {
            ...state.viewState,
            openPage: path
        }
    };
}
function $ee99fa6430885fc2$export$769f13194e872724(path, state, innerBlock, env, dispatchInner) {
    if (path.length === 0) return state;
    const dispatchPages = (0, $d0f575b1326e7f91$export$f153e5abd026c378)("pages", dispatchInner);
    const parentPath = path.slice(0, -1);
    const childIdToRemove = path.slice(-1)[0];
    const nextPath = $ea3d541d2f2fc6fe$export$7d76a0b6947ec50f(path, state.pages);
    const pageToRemove = $ea3d541d2f2fc6fe$export$a12370985d3b367(path, state.pages);
    const newPages = $ea3d541d2f2fc6fe$export$e065bdcd47f54c29(parentPath, state.pages, (siblings)=>siblings.filter((child)=>child.id !== childIdToRemove));
    return {
        ...state,
        pages: $ea3d541d2f2fc6fe$export$7f76e9ee07028bf0(nextPath, newPages, env, (0, $e6de90c09d008aae$export$bdf4ff5a442cbbc5)([
            $97abc9ea0b65aa17$export$7d9f7e9c1c02b41e(pageToRemove)
        ]), innerBlock, dispatchPages).state,
        viewState: {
            ...state.viewState,
            openPage: nextPath
        }
    };
}
function $ee99fa6430885fc2$export$bcc445b1fd74503c(path, state, newPage) {
    function addSibling(siblings) {
        const page = newPage ?? {
            ...state.template,
            id: $9d52f07a71ba7cea$export$fba3009e3ea7651a(siblings),
            name: ""
        };
        return [
            page.id,
            [
                ...siblings,
                page
            ]
        ];
    }
    let newId = null;
    const newPages = $ea3d541d2f2fc6fe$export$e065bdcd47f54c29(path, state.pages, (siblings)=>{
        const [id, newSiblings] = addSibling(siblings);
        newId = id;
        return newSiblings;
    });
    if (newId === null) return state;
    return {
        ...state,
        viewState: {
            ...state.viewState,
            openPage: [
                ...path,
                newId
            ]
        },
        pages: newPages
    };
}
function $ee99fa6430885fc2$export$5813b750fe20a278(path, state, action, env, innerBlock) {
    return {
        ...state,
        pages: $ea3d541d2f2fc6fe$export$5813b750fe20a278(path, state.pages, (page, context)=>{
            const state = action(page.state, context);
            const result = innerBlock.getResult(state);
            return {
                ...page,
                state: state,
                result: result
            };
        }, env, innerBlock)
    };
}
function $ee99fa6430885fc2$export$bb6ff48d725fca5e(path, state, env, innerBlock, dispatch) {
    const dispatchPages = (0, $d0f575b1326e7f91$export$f153e5abd026c378)("pages", dispatch);
    return {
        ...state,
        pages: $ea3d541d2f2fc6fe$export$7f76e9ee07028bf0(path, state.pages, env, (0, $e6de90c09d008aae$export$bdf4ff5a442cbbc5)(), innerBlock, dispatchPages).state
    };
}


var $70e75050ef1824a9$exports = {};

$parcel$export($70e75050ef1824a9$exports, "DocumentUi", () => $70e75050ef1824a9$export$7692dd7fce48b403);


var $acw62 = parcelRequire("acw62");


var $ef0249c5e48bf4e3$export$82e9f45cca5ba907 = "fab";
var $ef0249c5e48bf4e3$export$155bdf1ceac204e7 = {
    prefix: "fab",
    iconName: "monero",
    icon: [
        496,
        512,
        [],
        "f3d0",
        "M352 384h108.4C417 455.9 338.1 504 248 504S79 455.9 35.6 384H144V256.2L248 361l104-105v128zM88 336V128l159.4 159.4L408 128v208h74.8c8.5-25.1 13.2-52 13.2-80C496 119 385 8 248 8S0 119 0 256c0 28 4.6 54.9 13.2 80H88z"
    ]
};
var $ef0249c5e48bf4e3$export$3a040ca24382cf1c = {
    prefix: "fab",
    iconName: "hooli",
    icon: [
        640,
        512,
        [],
        "f427",
        "M144.5 352l38.3.8c-13.2-4.6-26-10.2-38.3-16.8zm57.7-5.3v5.3l-19.4.8c36.5 12.5 69.9 14.2 94.7 7.2-19.9.2-45.8-2.6-75.3-13.3zm408.9-115.2c15.9 0 28.9-12.9 28.9-28.9s-12.9-24.5-28.9-24.5c-15.9 0-28.9 8.6-28.9 24.5s12.9 28.9 28.9 28.9zm-29 120.5H640V241.5h-57.9zm-73.7 0h57.9V156.7L508.4 184zm-31-119.4c-18.2-18.2-50.4-17.1-50.4-17.1s-32.3-1.1-50.4 17.1c-18.2 18.2-16.8 33.9-16.8 52.6s-1.4 34.3 16.8 52.5 50.4 17.1 50.4 17.1 32.3 1.1 50.4-17.1c18.2-18.2 16.8-33.8 16.8-52.5-.1-18.8 1.3-34.5-16.8-52.6zm-39.8 71.9c0 3.6-1.8 12.5-10.7 12.5s-10.7-8.9-10.7-12.5v-40.4c0-8.7 7.3-10.9 10.7-10.9s10.7 2.1 10.7 10.9zm-106.2-71.9c-18.2-18.2-50.4-17.1-50.4-17.1s-32.2-1.1-50.4 17.1c-1.9 1.9-3.7 3.9-5.3 6-38.2-29.6-72.5-46.5-102.1-61.1v-20.7l-22.5 10.6c-54.4-22.1-89-18.2-97.3.1 0 0-24.9 32.8 61.8 110.8V352h57.9v-28.6c-6.5-4.2-13-8.7-19.4-13.6-14.8-11.2-27.4-21.6-38.4-31.4v-31c13.1 14.7 30.5 31.4 53.4 50.3l4.5 3.6v-29.8c0-6.9 1.7-18.2 10.8-18.2s10.6 6.9 10.6 15V317c18 12.2 37.3 22.1 57.7 29.6v-93.9c0-18.7-13.4-37.4-40.6-37.4-15.8-.1-30.5 8.2-38.5 21.9v-54.3c41.9 20.9 83.9 46.5 99.9 58.3-10.2 14.6-9.3 28.1-9.3 43.7 0 18.7-1.4 34.3 16.8 52.5s50.4 17.1 50.4 17.1 32.3 1.1 50.4-17.1c18.2-18.2 16.7-33.8 16.7-52.5 0-18.5 1.5-34.2-16.7-52.3zM65.2 184v63.3c-48.7-54.5-38.9-76-35.2-79.1 13.5-11.4 37.5-8 64.4 2.1zm226.5 120.5c0 3.6-1.8 12.5-10.7 12.5s-10.7-8.9-10.7-12.5v-40.4c0-8.7 7.3-10.9 10.7-10.9s10.7 2.1 10.7 10.9z"
    ]
};
var $ef0249c5e48bf4e3$export$2de47f03337052b6 = {
    prefix: "fab",
    iconName: "yelp",
    icon: [
        384,
        512,
        [],
        "f1e9",
        "M42.9 240.32l99.62 48.61c19.2 9.4 16.2 37.51-4.5 42.71L30.5 358.45a22.79 22.79 0 0 1-28.21-19.6 197.16 197.16 0 0 1 9-85.32 22.8 22.8 0 0 1 31.61-13.21zm44 239.25a199.45 199.45 0 0 0 79.42 32.11A22.78 22.78 0 0 0 192.94 490l3.9-110.82c.7-21.3-25.5-31.91-39.81-16.1l-74.21 82.4a22.82 22.82 0 0 0 4.09 34.09zm145.34-109.92l58.81 94a22.93 22.93 0 0 0 34 5.5 198.36 198.36 0 0 0 52.71-67.61A23 23 0 0 0 364.17 370l-105.42-34.26c-20.31-6.5-37.81 15.8-26.51 33.91zm148.33-132.23a197.44 197.44 0 0 0-50.41-69.31 22.85 22.85 0 0 0-34 4.4l-62 91.92c-11.9 17.7 4.7 40.61 25.2 34.71L366 268.63a23 23 0 0 0 14.61-31.21zM62.11 30.18a22.86 22.86 0 0 0-9.9 32l104.12 180.44c11.7 20.2 42.61 11.9 42.61-11.4V22.88a22.67 22.67 0 0 0-24.5-22.8 320.37 320.37 0 0 0-112.33 30.1z"
    ]
};
var $ef0249c5e48bf4e3$export$acc882c0b0e9e801 = {
    prefix: "fab",
    iconName: "cc-visa",
    icon: [
        576,
        512,
        [],
        "f1f0",
        "M470.1 231.3s7.6 37.2 9.3 45H446c3.3-8.9 16-43.5 16-43.5-.2.3 3.3-9.1 5.3-14.9l2.8 13.4zM576 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48zM152.5 331.2L215.7 176h-42.5l-39.3 106-4.3-21.5-14-71.4c-2.3-9.9-9.4-12.7-18.2-13.1H32.7l-.7 3.1c15.8 4 29.9 9.8 42.2 17.1l35.8 135h42.5zm94.4.2L272.1 176h-40.2l-25.1 155.4h40.1zm139.9-50.8c.2-17.7-10.6-31.2-33.7-42.3-14.1-7.1-22.7-11.9-22.7-19.2.2-6.6 7.3-13.4 23.1-13.4 13.1-.3 22.7 2.8 29.9 5.9l3.6 1.7 5.5-33.6c-7.9-3.1-20.5-6.6-36-6.6-39.7 0-67.6 21.2-67.8 51.4-.3 22.3 20 34.7 35.2 42.2 15.5 7.6 20.8 12.6 20.8 19.3-.2 10.4-12.6 15.2-24.1 15.2-16 0-24.6-2.5-37.7-8.3l-5.3-2.5-5.6 34.9c9.4 4.3 26.8 8.1 44.8 8.3 42.2.1 69.7-20.8 70-53zM528 331.4L495.6 176h-31.1c-9.6 0-16.9 2.8-21 12.9l-59.7 142.5H426s6.9-19.2 8.4-23.3H486c1.2 5.5 4.8 23.3 4.8 23.3H528z"
    ]
};
var $ef0249c5e48bf4e3$export$8226e5267dd86de3 = {
    prefix: "fab",
    iconName: "lastfm",
    icon: [
        512,
        512,
        [],
        "f202",
        "M225.8 367.1l-18.8-51s-30.5 34-76.2 34c-40.5 0-69.2-35.2-69.2-91.5 0-72.1 36.4-97.9 72.1-97.9 66.5 0 74.8 53.3 100.9 134.9 18.8 56.9 54 102.6 155.4 102.6 72.7 0 122-22.3 122-80.9 0-72.9-62.7-80.6-115-92.1-25.8-5.9-33.4-16.4-33.4-34 0-19.9 15.8-31.7 41.6-31.7 28.2 0 43.4 10.6 45.7 35.8l58.6-7c-4.7-52.8-41.1-74.5-100.9-74.5-52.8 0-104.4 19.9-104.4 83.9 0 39.9 19.4 65.1 68 76.8 44.9 10.6 79.8 13.8 79.8 45.7 0 21.7-21.1 30.5-61 30.5-59.2 0-83.9-31.1-97.9-73.9-32-96.8-43.6-163-161.3-163C45.7 113.8 0 168.3 0 261c0 89.1 45.7 137.2 127.9 137.2 66.2 0 97.9-31.1 97.9-31.1z"
    ]
};
var $ef0249c5e48bf4e3$export$c0b2d6cff425a846 = {
    prefix: "fab",
    iconName: "shopware",
    icon: [
        512,
        512,
        [],
        "f5b5",
        "M403.5 455.41A246.17 246.17 0 0 1 256 504C118.81 504 8 393 8 256 8 118.81 119 8 256 8a247.39 247.39 0 0 1 165.7 63.5 3.57 3.57 0 0 1-2.86 6.18A418.62 418.62 0 0 0 362.13 74c-129.36 0-222.4 53.47-222.4 155.35 0 109 92.13 145.88 176.83 178.73 33.64 13 65.4 25.36 87 41.59a3.58 3.58 0 0 1 0 5.72zM503 233.09a3.64 3.64 0 0 0-1.27-2.44c-51.76-43-93.62-60.48-144.48-60.48-84.13 0-80.25 52.17-80.25 53.63 0 42.6 52.06 62 112.34 84.49 31.07 11.59 63.19 23.57 92.68 39.93a3.57 3.57 0 0 0 5-1.82A249 249 0 0 0 503 233.09z"
    ]
};
var $ef0249c5e48bf4e3$export$e36098165f3fc869 = {
    prefix: "fab",
    iconName: "creative-commons-nc",
    icon: [
        496,
        512,
        [],
        "f4e8",
        "M247.6 8C387.4 8 496 115.9 496 256c0 147.2-118.5 248-248.4 248C113.1 504 0 393.2 0 256 0 123.1 104.7 8 247.6 8zM55.8 189.1c-7.4 20.4-11.1 42.7-11.1 66.9 0 110.9 92.1 202.4 203.7 202.4 122.4 0 177.2-101.8 178.5-104.1l-93.4-41.6c-7.7 37.1-41.2 53-68.2 55.4v38.1h-28.8V368c-27.5-.3-52.6-10.2-75.3-29.7l34.1-34.5c31.7 29.4 86.4 31.8 86.4-2.2 0-6.2-2.2-11.2-6.6-15.1-14.2-6-1.8-.1-219.3-97.4zM248.4 52.3c-38.4 0-112.4 8.7-170.5 93l94.8 42.5c10-31.3 40.4-42.9 63.8-44.3v-38.1h28.8v38.1c22.7 1.2 43.4 8.9 62 23L295 199.7c-42.7-29.9-83.5-8-70 11.1 53.4 24.1 43.8 19.8 93 41.6l127.1 56.7c4.1-17.4 6.2-35.1 6.2-53.1 0-57-19.8-105-59.3-143.9-39.3-39.9-87.2-59.8-143.6-59.8z"
    ]
};
var $ef0249c5e48bf4e3$export$a4ddb2c7f767be70 = {
    prefix: "fab",
    iconName: "aws",
    icon: [
        640,
        512,
        [],
        "f375",
        "M180.41 203.01c-.72 22.65 10.6 32.68 10.88 39.05a8.164 8.164 0 0 1-4.1 6.27l-12.8 8.96a10.66 10.66 0 0 1-5.63 1.92c-.43-.02-8.19 1.83-20.48-25.61a78.608 78.608 0 0 1-62.61 29.45c-16.28.89-60.4-9.24-58.13-56.21-1.59-38.28 34.06-62.06 70.93-60.05 7.1.02 21.6.37 46.99 6.27v-15.62c2.69-26.46-14.7-46.99-44.81-43.91-2.4.01-19.4-.5-45.84 10.11-7.36 3.38-8.3 2.82-10.75 2.82-7.41 0-4.36-21.48-2.94-24.2 5.21-6.4 35.86-18.35 65.94-18.18a76.857 76.857 0 0 1 55.69 17.28 70.285 70.285 0 0 1 17.67 52.36l-.01 69.29zM93.99 235.4c32.43-.47 46.16-19.97 49.29-30.47 2.46-10.05 2.05-16.41 2.05-27.4-9.67-2.32-23.59-4.85-39.56-4.87-15.15-1.14-42.82 5.63-41.74 32.26-1.24 16.79 11.12 31.4 29.96 30.48zm170.92 23.05c-7.86.72-11.52-4.86-12.68-10.37l-49.8-164.65c-.97-2.78-1.61-5.65-1.92-8.58a4.61 4.61 0 0 1 3.86-5.25c.24-.04-2.13 0 22.25 0 8.78-.88 11.64 6.03 12.55 10.37l35.72 140.83 33.16-140.83c.53-3.22 2.94-11.07 12.8-10.24h17.16c2.17-.18 11.11-.5 12.68 10.37l33.42 142.63L420.98 80.1c.48-2.18 2.72-11.37 12.68-10.37h19.72c.85-.13 6.15-.81 5.25 8.58-.43 1.85 3.41-10.66-52.75 169.9-1.15 5.51-4.82 11.09-12.68 10.37h-18.69c-10.94 1.15-12.51-9.66-12.68-10.75L328.67 110.7l-32.78 136.99c-.16 1.09-1.73 11.9-12.68 10.75h-18.3zm273.48 5.63c-5.88.01-33.92-.3-57.36-12.29a12.802 12.802 0 0 1-7.81-11.91v-10.75c0-8.45 6.2-6.9 8.83-5.89 10.04 4.06 16.48 7.14 28.81 9.6 36.65 7.53 52.77-2.3 56.72-4.48 13.15-7.81 14.19-25.68 5.25-34.95-10.48-8.79-15.48-9.12-53.13-21-4.64-1.29-43.7-13.61-43.79-52.36-.61-28.24 25.05-56.18 69.52-55.95 12.67-.01 46.43 4.13 55.57 15.62 1.35 2.09 2.02 4.55 1.92 7.04v10.11c0 4.44-1.62 6.66-4.87 6.66-7.71-.86-21.39-11.17-49.16-10.75-6.89-.36-39.89.91-38.41 24.97-.43 18.96 26.61 26.07 29.7 26.89 36.46 10.97 48.65 12.79 63.12 29.58 17.14 22.25 7.9 48.3 4.35 55.44-19.08 37.49-68.42 34.44-69.26 34.42zm40.2 104.86c-70.03 51.72-171.69 79.25-258.49 79.25A469.127 469.127 0 0 1 2.83 327.46c-6.53-5.89-.77-13.96 7.17-9.47a637.37 637.37 0 0 0 316.88 84.12 630.22 630.22 0 0 0 241.59-49.55c11.78-5 21.77 7.8 10.12 16.38zm29.19-33.29c-8.96-11.52-59.28-5.38-81.81-2.69-6.79.77-7.94-5.12-1.79-9.47 40.07-28.17 105.88-20.1 113.44-10.63 7.55 9.47-2.05 75.41-39.56 106.91-5.76 4.87-11.27 2.3-8.71-4.1 8.44-21.25 27.39-68.49 18.43-80.02z"
    ]
};
var $ef0249c5e48bf4e3$export$d65557a7abc2c5dc = {
    prefix: "fab",
    iconName: "redhat",
    icon: [
        512,
        512,
        [],
        "f7bc",
        "M341.52 285.56c33.65 0 82.34-6.94 82.34-47 .22-6.74.86-1.82-20.88-96.24-4.62-19.15-8.68-27.84-42.31-44.65-26.09-13.34-82.92-35.37-99.73-35.37-15.66 0-20.2 20.17-38.87 20.17-18 0-31.31-15.06-48.12-15.06-16.14 0-26.66 11-34.78 33.62-27.5 77.55-26.28 74.27-26.12 78.27 0 24.8 97.64 106.11 228.47 106.11M429 254.84c4.65 22 4.65 24.35 4.65 27.25 0 37.66-42.33 58.56-98 58.56-125.74.08-235.91-73.65-235.91-122.33a49.55 49.55 0 0 1 4.06-19.72C58.56 200.86 0 208.93 0 260.63c0 84.67 200.63 189 359.49 189 121.79 0 152.51-55.08 152.51-98.58 0-34.21-29.59-73.05-82.93-96.24"
    ]
};
var $ef0249c5e48bf4e3$export$73b6ef60226f6801 = {
    prefix: "fab",
    iconName: "yoast",
    icon: [
        448,
        512,
        [],
        "f2b1",
        "M91.3 76h186l-7 18.9h-179c-39.7 0-71.9 31.6-71.9 70.3v205.4c0 35.4 24.9 70.3 84 70.3V460H91.3C41.2 460 0 419.8 0 370.5V165.2C0 115.9 40.7 76 91.3 76zm229.1-56h66.5C243.1 398.1 241.2 418.9 202.2 459.3c-20.8 21.6-49.3 31.7-78.3 32.7v-51.1c49.2-7.7 64.6-49.9 64.6-75.3 0-20.1.6-12.6-82.1-223.2h61.4L218.2 299 320.4 20zM448 161.5V460H234c6.6-9.6 10.7-16.3 12.1-19.4h182.5V161.5c0-32.5-17.1-51.9-48.2-62.9l6.7-17.6c41.7 13.6 60.9 43.1 60.9 80.5z"
    ]
};
var $ef0249c5e48bf4e3$export$7a31e37b2189232c = {
    prefix: "fab",
    iconName: "cloudflare",
    icon: [
        640,
        512,
        [],
        "e07d",
        "M407.906,319.913l-230.8-2.928a4.58,4.58,0,0,1-3.632-1.926,4.648,4.648,0,0,1-.494-4.147,6.143,6.143,0,0,1,5.361-4.076L411.281,303.9c27.631-1.26,57.546-23.574,68.022-50.784l13.286-34.542a7.944,7.944,0,0,0,.524-2.936,7.735,7.735,0,0,0-.164-1.631A151.91,151.91,0,0,0,201.257,198.4,68.12,68.12,0,0,0,94.2,269.59C41.924,271.106,0,313.728,0,366.12a96.054,96.054,0,0,0,1.029,13.958,4.508,4.508,0,0,0,4.445,3.871l426.1.051c.043,0,.08-.019.122-.02a5.606,5.606,0,0,0,5.271-4l3.273-11.265c3.9-13.4,2.448-25.8-4.1-34.9C430.124,325.423,420.09,320.487,407.906,319.913ZM513.856,221.1c-2.141,0-4.271.062-6.391.164a3.771,3.771,0,0,0-3.324,2.653l-9.077,31.193c-3.9,13.4-2.449,25.786,4.1,34.89,6.02,8.4,16.054,13.323,28.238,13.9l49.2,2.939a4.491,4.491,0,0,1,3.51,1.894,4.64,4.64,0,0,1,.514,4.169,6.153,6.153,0,0,1-5.351,4.075l-51.125,2.939c-27.754,1.27-57.669,23.574-68.145,50.784l-3.695,9.606a2.716,2.716,0,0,0,2.427,3.68c.046,0,.088.017.136.017h175.91a4.69,4.69,0,0,0,4.539-3.37,124.807,124.807,0,0,0,4.682-34C640,277.3,583.524,221.1,513.856,221.1Z"
    ]
};
var $ef0249c5e48bf4e3$export$c6f6a1beb6102ac = {
    prefix: "fab",
    iconName: "ups",
    icon: [
        384,
        512,
        [],
        "f7e0",
        "M103.2 303c-5.2 3.6-32.6 13.1-32.6-19V180H37.9v102.6c0 74.9 80.2 51.1 97.9 39V180h-32.6zM4 74.82v220.9c0 103.7 74.9 135.2 187.7 184.1 112.4-48.9 187.7-80.2 187.7-184.1V74.82c-116.3-61.6-281.8-49.6-375.4 0zm358.1 220.9c0 86.6-53.2 113.6-170.4 165.3-117.5-51.8-170.5-78.7-170.5-165.3v-126.4c102.3-93.8 231.6-100 340.9-89.8zm-209.6-107.4v212.8h32.7v-68.7c24.4 7.3 71.7-2.6 71.7-78.5 0-97.4-80.7-80.92-104.4-65.6zm32.7 117.3v-100.3c8.4-4.2 38.4-12.7 38.4 49.3 0 67.9-36.4 51.8-38.4 51zm79.1-86.4c.1 47.3 51.6 42.5 52.2 70.4.6 23.5-30.4 23-50.8 4.9v30.1c36.2 21.5 81.9 8.1 83.2-33.5 1.7-51.5-54.1-46.6-53.4-73.2.6-20.3 30.6-20.5 48.5-2.2v-28.4c-28.5-22-79.9-9.2-79.7 31.9z"
    ]
};
var $ef0249c5e48bf4e3$export$b64ce7c5d150db12 = {
    prefix: "fab",
    iconName: "pixiv",
    icon: [
        448,
        512,
        [],
        "e640",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm171.5 84c41 0 76.3 12.9 101.4 35.2l0 0c25.2 22.2 39.8 54.1 39.8 88.8c.1 35.3-16.6 66.3-42.4 87c-25.9 20.8-60.6 32.4-98.8 32.4c-43.5 0-83.8-16.1-83.8-16.1v51.8c7.4 2.2 19.7 7 11.9 14.8H104.8c-7.7-7.8 3.6-12.4 12.1-14.8V175.5C97.1 190.9 87 204.3 81.8 214.2c6 19.4-5.3 18.5-5.3 18.5L56 199.7s72.7-83.7 179.5-83.7zm-3.6 222.9c30 0 56-11.3 73.9-29.2c17.9-18.1 27.9-41.6 28-70.2c-.1-29.3-9.5-54.6-26.7-73.6c-17.2-18.9-42.7-31.3-75.2-31.4c-26.7-.1-59.8 9-80.2 23.7V323.1c18.6 9.3 46.8 15.9 80.2 15.8z"
    ]
};
var $ef0249c5e48bf4e3$export$9ab35a48e8f904bf = {
    prefix: "fab",
    iconName: "wpexplorer",
    icon: [
        512,
        512,
        [],
        "f2de",
        "M512 256c0 141.2-114.7 256-256 256C114.8 512 0 397.3 0 256S114.7 0 256 0s256 114.7 256 256zm-32 0c0-123.2-100.3-224-224-224C132.5 32 32 132.5 32 256s100.5 224 224 224 224-100.5 224-224zM160.9 124.6l86.9 37.1-37.1 86.9-86.9-37.1 37.1-86.9zm110 169.1l46.6 94h-14.6l-50-100-48.9 100h-14l51.1-106.9-22.3-9.4 6-14 68.6 29.1-6 14.3-16.5-7.1zm-11.8-116.3l68.6 29.4-29.4 68.3L230 246l29.1-68.6zm80.3 42.9l54.6 23.1-23.4 54.3-54.3-23.1 23.1-54.3z"
    ]
};
var $ef0249c5e48bf4e3$export$1661cbacae81932b = {
    prefix: "fab",
    iconName: "dyalog",
    icon: [
        416,
        512,
        [],
        "f399",
        "M0 32v119.2h64V96h107.2C284.6 96 352 176.2 352 255.9 352 332 293.4 416 171.2 416H0v64h171.2C331.9 480 416 367.3 416 255.9c0-58.7-22.1-113.4-62.3-154.3C308.9 56 245.7 32 171.2 32H0z"
    ]
};
var $ef0249c5e48bf4e3$export$76a6a7e968d921fe = {
    prefix: "fab",
    iconName: "bity",
    icon: [
        496,
        512,
        [],
        "f37a",
        "M78.4 67.2C173.8-22 324.5-24 421.5 71c14.3 14.1-6.4 37.1-22.4 21.5-84.8-82.4-215.8-80.3-298.9-3.2-16.3 15.1-36.5-8.3-21.8-22.1zm98.9 418.6c19.3 5.7 29.3-23.6 7.9-30C73 421.9 9.4 306.1 37.7 194.8c5-19.6-24.9-28.1-30.2-7.1-32.1 127.4 41.1 259.8 169.8 298.1zm148.1-2c121.9-40.2 192.9-166.9 164.4-291-4.5-19.7-34.9-13.8-30 7.9 24.2 107.7-37.1 217.9-143.2 253.4-21.2 7-10.4 36 8.8 29.7zm-62.9-79l.2-71.8c0-8.2-6.6-14.8-14.8-14.8-8.2 0-14.8 6.7-14.8 14.8l-.2 71.8c0 8.2 6.6 14.8 14.8 14.8s14.8-6.6 14.8-14.8zm71-269c2.1 90.9 4.7 131.9-85.5 132.5-92.5-.7-86.9-44.3-85.5-132.5 0-21.8-32.5-19.6-32.5 0v71.6c0 69.3 60.7 90.9 118 90.1 57.3.8 118-20.8 118-90.1v-71.6c0-19.6-32.5-21.8-32.5 0z"
    ]
};
var $ef0249c5e48bf4e3$export$a14b012b76f98910 = {
    prefix: "fab",
    iconName: "stackpath",
    icon: [
        448,
        512,
        [],
        "f842",
        "M244.6 232.4c0 8.5-4.26 20.49-21.34 20.49h-19.61v-41.47h19.61c17.13 0 21.34 12.36 21.34 20.98zM448 32v448H0V32zM151.3 287.84c0-21.24-12.12-34.54-46.72-44.85-20.57-7.41-26-10.91-26-18.63s7-14.61 20.41-14.61c14.09 0 20.79 8.45 20.79 18.35h30.7l.19-.57c.5-19.57-15.06-41.65-51.12-41.65-23.37 0-52.55 10.75-52.55 38.29 0 19.4 9.25 31.29 50.74 44.37 17.26 6.15 21.91 10.4 21.91 19.48 0 15.2-19.13 14.23-19.47 14.23-20.4 0-25.65-9.1-25.65-21.9h-30.8l-.18.56c-.68 31.32 28.38 45.22 56.63 45.22 29.98 0 51.12-13.55 51.12-38.29zm125.38-55.63c0-25.3-18.43-45.46-53.42-45.46h-51.78v138.18h32.17v-47.36h19.61c30.25 0 53.42-15.95 53.42-45.36zM297.94 325L347 186.78h-31.09L268 325zm106.52-138.22h-31.09L325.46 325h29.94z"
    ]
};
var $ef0249c5e48bf4e3$export$6c0bc096306cebf8 = {
    prefix: "fab",
    iconName: "buysellads",
    icon: [
        448,
        512,
        [],
        "f20d",
        "M224 150.7l42.9 160.7h-85.8L224 150.7zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-65.3 325.3l-94.5-298.7H159.8L65.3 405.3H156l111.7-91.6 24.2 91.6h90.8z"
    ]
};
var $ef0249c5e48bf4e3$export$e0a21844bf49ca8e = {
    prefix: "fab",
    iconName: "first-order",
    icon: [
        448,
        512,
        [],
        "f2b0",
        "M12.9 229.2c.1-.1.2-.3.3-.4 0 .1 0 .3-.1.4h-.2zM224 96.6c-7.1 0-14.6.6-21.4 1.7l3.7 67.4-22-64c-14.3 3.7-27.7 9.4-40 16.6l29.4 61.4-45.1-50.9c-11.4 8.9-21.7 19.1-30.6 30.9l50.6 45.4-61.1-29.7c-7.1 12.3-12.9 25.7-16.6 40l64.3 22.6-68-4c-.9 7.1-1.4 14.6-1.4 22s.6 14.6 1.4 21.7l67.7-4-64 22.6c3.7 14.3 9.4 27.7 16.6 40.3l61.1-29.7L97.7 352c8.9 11.7 19.1 22.3 30.9 30.9l44.9-50.9-29.5 61.4c12.3 7.4 25.7 13.1 40 16.9l22.3-64.6-4 68c7.1 1.1 14.6 1.7 21.7 1.7 7.4 0 14.6-.6 21.7-1.7l-4-68.6 22.6 65.1c14.3-4 27.7-9.4 40-16.9L274.9 332l44.9 50.9c11.7-8.9 22-19.1 30.6-30.9l-50.6-45.1 61.1 29.4c7.1-12.3 12.9-25.7 16.6-40.3l-64-22.3 67.4 4c1.1-7.1 1.4-14.3 1.4-21.7s-.3-14.9-1.4-22l-67.7 4 64-22.3c-3.7-14.3-9.1-28-16.6-40.3l-60.9 29.7 50.6-45.4c-8.9-11.7-19.1-22-30.6-30.9l-45.1 50.9 29.4-61.1c-12.3-7.4-25.7-13.1-40-16.9L241.7 166l4-67.7c-7.1-1.2-14.3-1.7-21.7-1.7zM443.4 128v256L224 512 4.6 384V128L224 0l219.4 128zm-17.1 10.3L224 20.9 21.7 138.3v235.1L224 491.1l202.3-117.7V138.3zM224 37.1l187.7 109.4v218.9L224 474.9 36.3 365.4V146.6L224 37.1zm0 50.9c-92.3 0-166.9 75.1-166.9 168 0 92.6 74.6 167.7 166.9 167.7 92 0 166.9-75.1 166.9-167.7 0-92.9-74.9-168-166.9-168z"
    ]
};
var $ef0249c5e48bf4e3$export$fb06254b4488a5b6 = {
    prefix: "fab",
    iconName: "modx",
    icon: [
        448,
        512,
        [],
        "f285",
        "M356 241.8l36.7 23.7V480l-133-83.8L356 241.8zM440 75H226.3l-23 37.8 153.5 96.5L440 75zm-89 142.8L55.2 32v214.5l46 29L351 217.8zM97 294.2L8 437h213.7l125-200.5L97 294.2z"
    ]
};
var $ef0249c5e48bf4e3$export$b6ff6f33a85ee805 = {
    prefix: "fab",
    iconName: "guilded",
    icon: [
        448,
        512,
        [],
        "e07e",
        "M443.427,64H4.571c0,103.26,22.192,180.06,43.418,222.358C112.046,414.135,224,448,225.256,448a312.824,312.824,0,0,0,140.55-103.477c25.907-33.923,53.1-87.19,65.916-145.761H171.833c4.14,36.429,22.177,67.946,45.1,86.944h88.589c-17.012,28.213-48.186,54.4-80.456,69.482-31.232-13.259-69.09-46.544-96.548-98.362-26.726-53.833-27.092-105.883-27.092-105.883H437.573A625.91,625.91,0,0,0,443.427,64Z"
    ]
};
var $ef0249c5e48bf4e3$export$13bd8782a2ce17e7 = {
    prefix: "fab",
    iconName: "vnv",
    icon: [
        640,
        512,
        [],
        "f40b",
        "M104.9 352c-34.1 0-46.4-30.4-46.4-30.4L2.6 210.1S-7.8 192 13 192h32.8c10.4 0 13.2 8.7 18.8 18.1l36.7 74.5s5.2 13.1 21.1 13.1 21.1-13.1 21.1-13.1l36.7-74.5c5.6-9.5 8.4-18.1 18.8-18.1h32.8c20.8 0 10.4 18.1 10.4 18.1l-55.8 111.5S174.2 352 140 352h-35.1zm395 0c-34.1 0-46.4-30.4-46.4-30.4l-55.9-111.5S387.2 192 408 192h32.8c10.4 0 13.2 8.7 18.8 18.1l36.7 74.5s5.2 13.1 21.1 13.1 21.1-13.1 21.1-13.1l36.8-74.5c5.6-9.5 8.4-18.1 18.8-18.1H627c20.8 0 10.4 18.1 10.4 18.1l-55.9 111.5S569.3 352 535.1 352h-35.2zM337.6 192c34.1 0 46.4 30.4 46.4 30.4l55.9 111.5s10.4 18.1-10.4 18.1h-32.8c-10.4 0-13.2-8.7-18.8-18.1l-36.7-74.5s-5.2-13.1-21.1-13.1c-15.9 0-21.1 13.1-21.1 13.1l-36.7 74.5c-5.6 9.4-8.4 18.1-18.8 18.1h-32.9c-20.8 0-10.4-18.1-10.4-18.1l55.9-111.5s12.2-30.4 46.4-30.4h35.1z"
    ]
};
var $ef0249c5e48bf4e3$export$c989752ecb8b3fae = {
    prefix: "fab",
    iconName: "square-js",
    icon: [
        448,
        512,
        [
            "js-square"
        ],
        "f3b9",
        "M448 96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96zM180.9 444.9c-33.7 0-53.2-17.4-63.2-38.5L152 385.7c6.6 11.7 12.6 21.6 27.1 21.6c13.8 0 22.6-5.4 22.6-26.5V237.7h42.1V381.4c0 43.6-25.6 63.5-62.9 63.5zm85.8-43L301 382.1c9 14.7 20.8 25.6 41.5 25.6c17.4 0 28.6-8.7 28.6-20.8c0-14.4-11.4-19.5-30.7-28l-10.5-4.5c-30.4-12.9-50.5-29.2-50.5-63.5c0-31.6 24.1-55.6 61.6-55.6c26.8 0 46 9.3 59.8 33.7L368 290c-7.2-12.9-15-18-27.1-18c-12.3 0-20.1 7.8-20.1 18c0 12.6 7.8 17.7 25.9 25.6l10.5 4.5c35.8 15.3 55.9 31 55.9 66.2c0 37.8-29.8 58.6-69.7 58.6c-39.1 0-64.4-18.6-76.7-43z"
    ]
};
var $ef0249c5e48bf4e3$export$d9bf3211f885d573 = $ef0249c5e48bf4e3$export$c989752ecb8b3fae;
var $ef0249c5e48bf4e3$export$b3b8195c77f1f877 = {
    prefix: "fab",
    iconName: "microsoft",
    icon: [
        448,
        512,
        [],
        "f3ca",
        "M0 32h214.6v214.6H0V32zm233.4 0H448v214.6H233.4V32zM0 265.4h214.6V480H0V265.4zm233.4 0H448V480H233.4V265.4z"
    ]
};
var $ef0249c5e48bf4e3$export$39d59e523abf051d = {
    prefix: "fab",
    iconName: "qq",
    icon: [
        448,
        512,
        [],
        "f1d6",
        "M433.754 420.445c-11.526 1.393-44.86-52.741-44.86-52.741 0 31.345-16.136 72.247-51.051 101.786 16.842 5.192 54.843 19.167 45.803 34.421-7.316 12.343-125.51 7.881-159.632 4.037-34.122 3.844-152.316 8.306-159.632-4.037-9.045-15.25 28.918-29.214 45.783-34.415-34.92-29.539-51.059-70.445-51.059-101.792 0 0-33.334 54.134-44.859 52.741-5.37-.65-12.424-29.644 9.347-99.704 10.261-33.024 21.995-60.478 40.144-105.779C60.683 98.063 108.982.006 224 0c113.737.006 163.156 96.133 160.264 214.963 18.118 45.223 29.912 72.85 40.144 105.778 21.768 70.06 14.716 99.053 9.346 99.704z"
    ]
};
var $ef0249c5e48bf4e3$export$9bf8457cc97dd02e = {
    prefix: "fab",
    iconName: "orcid",
    icon: [
        512,
        512,
        [],
        "f8d2",
        "M294.75 188.19h-45.92V342h47.47c67.62 0 83.12-51.34 83.12-76.91 0-41.64-26.54-76.9-84.67-76.9zM256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm-80.79 360.76h-29.84v-207.5h29.84zm-14.92-231.14a19.57 19.57 0 1 1 19.57-19.57 19.64 19.64 0 0 1-19.57 19.57zM300 369h-81V161.26h80.6c76.73 0 110.44 54.83 110.44 103.85C410 318.39 368.38 369 300 369z"
    ]
};
var $ef0249c5e48bf4e3$export$25a84a6ff654acd1 = {
    prefix: "fab",
    iconName: "java",
    icon: [
        384,
        512,
        [],
        "f4e4",
        "M277.74 312.9c9.8-6.7 23.4-12.5 23.4-12.5s-38.7 7-77.2 10.2c-47.1 3.9-97.7 4.7-123.1 1.3-60.1-8 33-30.1 33-30.1s-36.1-2.4-80.6 19c-52.5 25.4 130 37 224.5 12.1zm-85.4-32.1c-19-42.7-83.1-80.2 0-145.8C296 53.2 242.84 0 242.84 0c21.5 84.5-75.6 110.1-110.7 162.6-23.9 35.9 11.7 74.4 60.2 118.2zm114.6-176.2c.1 0-175.2 43.8-91.5 140.2 24.7 28.4-6.5 54-6.5 54s62.7-32.4 33.9-72.9c-26.9-37.8-47.5-56.6 64.1-121.3zm-6.1 270.5a12.19 12.19 0 0 1-2 2.6c128.3-33.7 81.1-118.9 19.8-97.3a17.33 17.33 0 0 0-8.2 6.3 70.45 70.45 0 0 1 11-3c31-6.5 75.5 41.5-20.6 91.4zM348 437.4s14.5 11.9-15.9 21.2c-57.9 17.5-240.8 22.8-291.6.7-18.3-7.9 16-19 26.8-21.3 11.2-2.4 17.7-2 17.7-2-20.3-14.3-131.3 28.1-56.4 40.2C232.84 509.4 401 461.3 348 437.4zM124.44 396c-78.7 22 47.9 67.4 148.1 24.5a185.89 185.89 0 0 1-28.2-13.8c-44.7 8.5-65.4 9.1-106 4.5-33.5-3.8-13.9-15.2-13.9-15.2zm179.8 97.2c-78.7 14.8-175.8 13.1-233.3 3.6 0-.1 11.8 9.7 72.4 13.6 92.2 5.9 233.8-3.3 237.1-46.9 0 0-6.4 16.5-76.2 29.7zM260.64 353c-59.2 11.4-93.5 11.1-136.8 6.6-33.5-3.5-11.6-19.7-11.6-19.7-86.8 28.8 48.2 61.4 169.5 25.9a60.37 60.37 0 0 1-21.1-12.8z"
    ]
};
var $ef0249c5e48bf4e3$export$6e249797a4721568 = {
    prefix: "fab",
    iconName: "invision",
    icon: [
        448,
        512,
        [],
        "f7b0",
        "M407.4 32H40.6C18.2 32 0 50.2 0 72.6v366.8C0 461.8 18.2 480 40.6 480h366.8c22.4 0 40.6-18.2 40.6-40.6V72.6c0-22.4-18.2-40.6-40.6-40.6zM176.1 145.6c.4 23.4-22.4 27.3-26.6 27.4-14.9 0-27.1-12-27.1-27 .1-35.2 53.1-35.5 53.7-.4zM332.8 377c-65.6 0-34.1-74-25-106.6 14.1-46.4-45.2-59-59.9.7l-25.8 103.3H177l8.1-32.5c-31.5 51.8-94.6 44.4-94.6-4.3.1-14.3.9-14 23-104.1H81.7l9.7-35.6h76.4c-33.6 133.7-32.6 126.9-32.9 138.2 0 20.9 40.9 13.5 57.4-23.2l19.8-79.4h-32.3l9.7-35.6h68.8l-8.9 40.5c40.5-75.5 127.9-47.8 101.8 38-14.2 51.1-14.6 50.7-14.9 58.8 0 15.5 17.5 22.6 31.8-16.9L386 325c-10.5 36.7-29.4 52-53.2 52z"
    ]
};
var $ef0249c5e48bf4e3$export$d93ab92a56e88ce6 = {
    prefix: "fab",
    iconName: "creative-commons-pd-alt",
    icon: [
        496,
        512,
        [],
        "f4ed",
        "M247.6 8C104.7 8 0 123.1 0 256c0 138.5 113.6 248 247.6 248C377.5 504 496 403.1 496 256 496 118.1 389.4 8 247.6 8zm.8 450.8c-112.5 0-203.7-93-203.7-202.8 0-105.4 85.5-203.3 203.7-203.3 112.6 0 202.9 89.5 202.8 203.3 0 121.7-99.6 202.8-202.8 202.8zM316.7 186h-53.2v137.2h53.2c21.4 0 70-5.1 70-68.6 0-63.4-48.6-68.6-70-68.6zm.8 108.5h-19.9v-79.7l19.4-.1c3.8 0 35-2.1 35 39.9 0 24.6-10.5 39.9-34.5 39.9zM203.7 186h-68.2v137.3h34.6V279h27c54.1 0 57.1-37.5 57.1-46.5 0-31-16.8-46.5-50.5-46.5zm-4.9 67.3h-29.2v-41.6h28.3c30.9 0 28.8 41.6.9 41.6z"
    ]
};
var $ef0249c5e48bf4e3$export$961762d5b3aedd8d = {
    prefix: "fab",
    iconName: "centercode",
    icon: [
        512,
        512,
        [],
        "f380",
        "M329.2 268.6c-3.8 35.2-35.4 60.6-70.6 56.8-35.2-3.8-60.6-35.4-56.8-70.6 3.8-35.2 35.4-60.6 70.6-56.8 35.1 3.8 60.6 35.4 56.8 70.6zm-85.8 235.1C96.7 496-8.2 365.5 10.1 224.3c11.2-86.6 65.8-156.9 139.1-192 161-77.1 349.7 37.4 354.7 216.6 4.1 147-118.4 262.2-260.5 254.8zm179.9-180c27.9-118-160.5-205.9-237.2-234.2-57.5 56.3-69.1 188.6-33.8 344.4 68.8 15.8 169.1-26.4 271-110.2z"
    ]
};
var $ef0249c5e48bf4e3$export$91d5526742c32d42 = {
    prefix: "fab",
    iconName: "glide-g",
    icon: [
        448,
        512,
        [],
        "f2a6",
        "M407.1 211.2c-3.5-1.4-11.6-3.8-15.4-3.8-37.1 0-62.2 16.8-93.5 34.5l-.9-.9c7-47.3 23.5-91.9 23.5-140.4C320.8 29.1 282.6 0 212.4 0 97.3 0 39 113.7 39 198.4 39 286.3 90.3 335 177.6 335c12 0 11-1 11 3.8-16.9 128.9-90.8 133.1-90.8 94.6 0-39.2 45-58.6 45.5-61-.3-12.2-47-27.6-58.9-27.6-33.9.1-52.4 51.2-52.4 79.3C32 476 64.8 512 117.5 512c77.4 0 134-77.8 151.4-145.4 15.1-60.5 11.2-63.3 19.7-67.6 32.2-16.2 57.5-27 93.8-27 17.8 0 30.5 3.7 58.9 8.4 2.9 0 6.7-2.9 6.7-5.8 0-8-33.4-60.5-40.9-63.4zm-175.3-84.4c-9.3 44.7-18.6 89.6-27.8 134.3-2.3 10.2-13.3 7.8-22 7.8-38.3 0-49-41.8-49-73.1 0-47 18-109.3 61.8-133.4 7-4.1 14.8-6.7 22.6-6.7 18.6 0 20 13.3 20 28.7-.1 14.3-2.7 28.5-5.6 42.4z"
    ]
};
var $ef0249c5e48bf4e3$export$51e679e8d2e3f8c1 = {
    prefix: "fab",
    iconName: "drupal",
    icon: [
        448,
        512,
        [],
        "f1a9",
        "M303.973,108.136C268.2,72.459,234.187,38.35,224.047,0c-9.957,38.35-44.25,72.459-80.019,108.136C90.467,161.7,29.716,222.356,29.716,313.436c-2.337,107.3,82.752,196.18,190.053,198.517S415.948,429.2,418.285,321.9q.091-4.231,0-8.464C418.285,222.356,357.534,161.7,303.973,108.136Zm-174.326,223a130.282,130.282,0,0,0-15.211,24.153,4.978,4.978,0,0,1-3.319,2.766h-1.659c-4.333,0-9.219-8.481-9.219-8.481h0c-1.29-2.028-2.489-4.149-3.687-6.361l-.83-1.752c-11.247-25.72-1.475-62.318-1.475-62.318h0a160.585,160.585,0,0,1,23.231-49.873A290.8,290.8,0,0,1,138.5,201.613l9.219,9.219,43.512,44.434a4.979,4.979,0,0,1,0,6.638L145.78,312.33h0Zm96.612,127.311a67.2,67.2,0,0,1-49.781-111.915c14.2-16.871,31.528-33.464,50.334-55.313,22.309,23.785,36.875,40.1,51.164,57.986a28.413,28.413,0,0,1,2.95,4.425,65.905,65.905,0,0,1,11.984,37.981,66.651,66.651,0,0,1-66.466,66.836ZM352.371,351.6h0a7.743,7.743,0,0,1-6.176,5.347H344.9a11.249,11.249,0,0,1-6.269-5.07h0a348.21,348.21,0,0,0-39.456-48.952L281.387,284.49,222.3,223.185a497.888,497.888,0,0,1-35.4-36.322,12.033,12.033,0,0,0-.922-1.382,35.4,35.4,0,0,1-4.7-9.219V174.51a31.346,31.346,0,0,1,9.218-27.656c11.432-11.431,22.955-22.954,33.833-34.939,11.984,13.275,24.8,26,37.428,38.627h0a530.991,530.991,0,0,1,69.6,79.1,147.494,147.494,0,0,1,27.011,83.8A134.109,134.109,0,0,1,352.371,351.6Z"
    ]
};
var $ef0249c5e48bf4e3$export$66507f26cc60b31e = {
    prefix: "fab",
    iconName: "hire-a-helper",
    icon: [
        512,
        512,
        [],
        "f3b0",
        "M443.1 0H71.9C67.9 37.3 37.4 67.8 0 71.7v371.5c37.4 4.9 66 32.4 71.9 68.8h372.2c3-36.4 32.5-65.8 67.9-69.8V71.7c-36.4-5.9-65-35.3-68.9-71.7zm-37 404.9c-36.3 0-18.8-2-55.1-2-35.8 0-21 2-56.1 2-5.9 0-4.9-8.2 0-9.8 22.8-7.6 22.9-10.2 24.6-12.8 10.4-15.6 5.9-83 5.9-113 0-5.3-6.4-12.8-13.8-12.8H200.4c-7.4 0-13.8 7.5-13.8 12.8 0 30-4.5 97.4 5.9 113 1.7 2.5 1.8 5.2 24.6 12.8 4.9 1.6 6 9.8 0 9.8-35.1 0-20.3-2-56.1-2-36.3 0-18.8 2-55.1 2-7.9 0-5.8-10.8 0-10.8 10.2-3.4 13.5-3.5 21.7-13.8 7.7-12.9 7.9-44.4 7.9-127.8V151.3c0-22.2-12.2-28.3-28.6-32.4-8.8-2.2-4-11.8 1-11.8 36.5 0 20.6 2 57.1 2 32.7 0 16.5-2 49.2-2 3.3 0 8.5 8.3 1 10.8-4.9 1.6-27.6 3.7-27.6 39.3 0 45.6-.2 55.8 1 68.8 0 1.3 2.3 12.8 12.8 12.8h109.2c10.5 0 12.8-11.5 12.8-12.8 1.2-13 1-23.2 1-68.8 0-35.6-22.7-37.7-27.6-39.3-7.5-2.5-2.3-10.8 1-10.8 32.7 0 16.5 2 49.2 2 36.5 0 20.6-2 57.1-2 4.9 0 9.9 9.6 1 11.8-16.4 4.1-28.6 10.3-28.6 32.4v101.2c0 83.4.1 114.9 7.9 127.8 8.2 10.2 11.4 10.4 21.7 13.8 5.8 0 7.8 10.8 0 10.8z"
    ]
};
var $ef0249c5e48bf4e3$export$5040b13190e5beb7 = {
    prefix: "fab",
    iconName: "creative-commons-by",
    icon: [
        496,
        512,
        [],
        "f4e7",
        "M314.9 194.4v101.4h-28.3v120.5h-77.1V295.9h-28.3V194.4c0-4.4 1.6-8.2 4.6-11.3 3.1-3.1 6.9-4.7 11.3-4.7H299c4.1 0 7.8 1.6 11.1 4.7 3.1 3.2 4.8 6.9 4.8 11.3zm-101.5-63.7c0-23.3 11.5-35 34.5-35s34.5 11.7 34.5 35c0 23-11.5 34.5-34.5 34.5s-34.5-11.5-34.5-34.5zM247.6 8C389.4 8 496 118.1 496 256c0 147.1-118.5 248-248.4 248C113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8zm.8 44.7C130.2 52.7 44.7 150.6 44.7 256c0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8.1-113.8-90.2-203.3-202.8-203.3z"
    ]
};
var $ef0249c5e48bf4e3$export$72fd5838af249737 = {
    prefix: "fab",
    iconName: "unity",
    icon: [
        448,
        512,
        [],
        "e049",
        "M243.583 91.6027L323.695 138.384C326.575 140.026 326.68 144.583 323.695 146.225L228.503 201.854C225.623 203.55 222.22 203.444 219.549 201.854L124.357 146.225C121.425 144.636 121.373 139.973 124.357 138.384L204.417 91.6027V0L0 119.417V358.252L78.3843 312.477V218.914C78.3319 215.576 82.2066 213.192 85.0865 214.993L180.279 270.622C183.159 272.318 184.782 275.338 184.782 278.464V389.669C184.834 393.007 180.959 395.391 178.079 393.589L97.9673 346.808L19.583 392.583L224 512L428.417 392.583L350.033 346.808L269.921 393.589C267.093 395.338 263.114 393.06 263.218 389.669V278.464C263.218 275.126 265.051 272.159 267.721 270.622L362.914 214.993C365.741 213.245 369.72 215.47 369.616 218.914V312.477L448 358.252V119.417L243.583 0V91.6027Z"
    ]
};
var $ef0249c5e48bf4e3$export$4d4f65ec2f52482 = {
    prefix: "fab",
    iconName: "whmcs",
    icon: [
        448,
        512,
        [],
        "f40d",
        "M448 161v-21.3l-28.5-8.8-2.2-10.4 20.1-20.7L427 80.4l-29 7.5-7.2-7.5 7.5-28.2-19.1-11.6-21.3 21-10.7-3.2-7-26.4h-22.6l-6.2 26.4-12.1 3.2-19.7-21-19.4 11 8.1 27.7-8.1 8.4-28.5-7.5-11 19.1 20.7 21-2.9 10.4-28.5 7.8-.3 21.7 28.8 7.5 2.4 12.1-20.1 19.9 10.4 18.5 29.6-7.5 7.2 8.6-8.1 26.9 19.9 11.6 19.4-20.4 11.6 2.9 6.7 28.5 22.6.3 6.7-28.8 11.6-3.5 20.7 21.6 20.4-12.1-8.8-28 7.8-8.1 28.8 8.8 10.3-20.1-20.9-18.8 2.2-12.1 29.1-7zm-119.2 45.2c-31.3 0-56.8-25.4-56.8-56.8s25.4-56.8 56.8-56.8 56.8 25.4 56.8 56.8c0 31.5-25.4 56.8-56.8 56.8zm72.3 16.4l46.9 14.5V277l-55.1 13.4-4.1 22.7 38.9 35.3-19.2 37.9-54-16.7-14.6 15.2 16.7 52.5-38.3 22.7-38.9-40.5-21.7 6.6-12.6 54-42.4-.5-12.6-53.6-21.7-5.6-36.4 38.4-37.4-21.7 15.2-50.5-13.7-16.1-55.5 14.1-19.7-34.8 37.9-37.4-4.8-22.8-54-14.1.5-40.9L54 219.9l5.7-19.7-38.9-39.4L41.5 125l53.6 14.1 15.2-15.7-15.2-52 36.4-20.7 36.8 39.4L191 84l11.6-52H245l11.6 45.9L234 72l-6.3-1.7-3.3 5.7-11 19.1-3.3 5.6 4.6 4.6 17.2 17.4-.3 1-23.8 6.5-6.2 1.7-.1 6.4-.2 12.9C153.8 161.6 118 204 118 254.7c0 58.3 47.3 105.7 105.7 105.7 50.5 0 92.7-35.4 103.2-82.8l13.2.2 6.9.1 1.6-6.7 5.6-24 1.9-.6 17.1 17.8 4.7 4.9 5.8-3.4 20.4-12.1 5.8-3.5-2-6.5-6.8-21.2z"
    ]
};
var $ef0249c5e48bf4e3$export$193ac2f517f63e63 = {
    prefix: "fab",
    iconName: "rocketchat",
    icon: [
        576,
        512,
        [],
        "f3e8",
        "M284.046,224.8a34.114,34.114,0,1,0,34.317,34.113A34.217,34.217,0,0,0,284.046,224.8Zm-110.45,0a34.114,34.114,0,1,0,34.317,34.113A34.217,34.217,0,0,0,173.6,224.8Zm220.923,0a34.114,34.114,0,1,0,34.317,34.113A34.215,34.215,0,0,0,394.519,224.8Zm153.807-55.319c-15.535-24.172-37.31-45.57-64.681-63.618-52.886-34.817-122.374-54-195.666-54a405.975,405.975,0,0,0-72.032,6.357,238.524,238.524,0,0,0-49.51-36.588C99.684-11.7,40.859.711,11.135,11.421A14.291,14.291,0,0,0,5.58,34.782C26.542,56.458,61.222,99.3,52.7,138.252c-33.142,33.9-51.112,74.776-51.112,117.337,0,43.372,17.97,84.248,51.112,118.148,8.526,38.956-26.154,81.816-47.116,103.491a14.284,14.284,0,0,0,5.555,23.34c29.724,10.709,88.549,23.147,155.324-10.2a238.679,238.679,0,0,0,49.51-36.589A405.972,405.972,0,0,0,288,460.14c73.313,0,142.8-19.159,195.667-53.975,27.371-18.049,49.145-39.426,64.679-63.619,17.309-26.923,26.07-55.916,26.07-86.125C574.394,225.4,565.634,196.43,548.326,169.485ZM284.987,409.9a345.65,345.65,0,0,1-89.446-11.5l-20.129,19.393a184.366,184.366,0,0,1-37.138,27.585,145.767,145.767,0,0,1-52.522,14.87c.983-1.771,1.881-3.563,2.842-5.356q30.258-55.68,16.325-100.078c-32.992-25.962-52.778-59.2-52.778-95.4,0-83.1,104.254-150.469,232.846-150.469s232.867,67.373,232.867,150.469C517.854,342.525,413.6,409.9,284.987,409.9Z"
    ]
};
var $ef0249c5e48bf4e3$export$a6bf4d62e541f988 = {
    prefix: "fab",
    iconName: "vk",
    icon: [
        448,
        512,
        [],
        "f189",
        "M31.4907 63.4907C0 94.9813 0 145.671 0 247.04V264.96C0 366.329 0 417.019 31.4907 448.509C62.9813 480 113.671 480 215.04 480H232.96C334.329 480 385.019 480 416.509 448.509C448 417.019 448 366.329 448 264.96V247.04C448 145.671 448 94.9813 416.509 63.4907C385.019 32 334.329 32 232.96 32H215.04C113.671 32 62.9813 32 31.4907 63.4907ZM75.6 168.267H126.747C128.427 253.76 166.133 289.973 196 297.44V168.267H244.16V242C273.653 238.827 304.64 205.227 315.093 168.267H363.253C359.313 187.435 351.46 205.583 340.186 221.579C328.913 237.574 314.461 251.071 297.733 261.227C316.41 270.499 332.907 283.63 346.132 299.751C359.357 315.873 369.01 334.618 374.453 354.747H321.44C316.555 337.262 306.614 321.61 292.865 309.754C279.117 297.899 262.173 290.368 244.16 288.107V354.747H238.373C136.267 354.747 78.0267 284.747 75.6 168.267Z"
    ]
};
var $ef0249c5e48bf4e3$export$f1679625ed434576 = {
    prefix: "fab",
    iconName: "untappd",
    icon: [
        640,
        512,
        [],
        "f405",
        "M401.3 49.9c-79.8 160.1-84.6 152.5-87.9 173.2l-5.2 32.8c-1.9 12-6.6 23.5-13.7 33.4L145.6 497.1c-7.6 10.6-20.4 16.2-33.4 14.6-40.3-5-77.8-32.2-95.3-68.5-5.7-11.8-4.5-25.8 3.1-36.4l148.9-207.9c7.1-9.9 16.4-18 27.2-23.7l29.3-15.5c18.5-9.8 9.7-11.9 135.6-138.9 1-4.8 1-7.3 3.6-8 3-.7 6.6-1 6.3-4.6l-.4-4.6c-.2-1.9 1.3-3.6 3.2-3.6 4.5-.1 13.2 1.2 25.6 10 12.3 8.9 16.4 16.8 17.7 21.1.6 1.8-.6 3.7-2.4 4.2l-4.5 1.1c-3.4.9-2.5 4.4-2.3 7.4.1 2.8-2.3 3.6-6.5 6.1zM230.1 36.4c3.4.9 2.5 4.4 2.3 7.4-.2 2.7 2.1 3.5 6.4 6 7.9 15.9 15.3 30.5 22.2 44 .7 1.3 2.3 1.5 3.3.5 11.2-12 24.6-26.2 40.5-42.6 1.3-1.4 1.4-3.5.1-4.9-8-8.2-16.5-16.9-25.6-26.1-1-4.7-1-7.3-3.6-8-3-.8-6.6-1-6.3-4.6.3-3.3 1.4-8.1-2.8-8.2-4.5-.1-13.2 1.1-25.6 10-12.3 8.9-16.4 16.8-17.7 21.1-1.4 4.2 3.6 4.6 6.8 5.4zM620 406.7L471.2 198.8c-13.2-18.5-26.6-23.4-56.4-39.1-11.2-5.9-14.2-10.9-30.5-28.9-1-1.1-2.9-.9-3.6.5-46.3 88.8-47.1 82.8-49 94.8-1.7 10.7-1.3 20 .3 29.8 1.9 12 6.6 23.5 13.7 33.4l148.9 207.9c7.6 10.6 20.2 16.2 33.1 14.7 40.3-4.9 78-32 95.7-68.6 5.4-11.9 4.3-25.9-3.4-36.6z"
    ]
};
var $ef0249c5e48bf4e3$export$da9f5a873e107292 = {
    prefix: "fab",
    iconName: "mailchimp",
    icon: [
        448,
        512,
        [],
        "f59e",
        "M330.61 243.52a36.15 36.15 0 0 1 9.3 0c1.66-3.83 1.95-10.43.45-17.61-2.23-10.67-5.25-17.14-11.48-16.13s-6.47 8.74-4.24 19.42c1.26 6 3.49 11.14 6 14.32zM277.05 252c4.47 2 7.2 3.26 8.28 2.13 1.89-1.94-3.48-9.39-12.12-13.09a31.44 31.44 0 0 0-30.61 3.68c-3 2.18-5.81 5.22-5.41 7.06.85 3.74 10-2.71 22.6-3.48 7-.44 12.8 1.75 17.26 3.71zm-9 5.13c-9.07 1.42-15 6.53-13.47 10.1.9.34 1.17.81 5.21-.81a37 37 0 0 1 18.72-1.95c2.92.34 4.31.52 4.94-.49 1.46-2.22-5.71-8-15.39-6.85zm54.17 17.1c3.38-6.87-10.9-13.93-14.3-7s10.92 13.88 14.32 6.97zm15.66-20.47c-7.66-.13-7.95 15.8-.26 15.93s7.98-15.81.28-15.96zm-218.79 78.9c-1.32.31-6 1.45-8.47-2.35-5.2-8 11.11-20.38 3-35.77-9.1-17.47-27.82-13.54-35.05-5.54-8.71 9.6-8.72 23.54-5 24.08 4.27.57 4.08-6.47 7.38-11.63a12.83 12.83 0 0 1 17.85-3.72c11.59 7.59 1.37 17.76 2.28 28.62 1.39 16.68 18.42 16.37 21.58 9a2.08 2.08 0 0 0-.2-2.33c.03.89.68-1.3-3.35-.39zm299.72-17.07c-3.35-11.73-2.57-9.22-6.78-20.52 2.45-3.67 15.29-24-3.07-43.25-10.4-10.92-33.9-16.54-41.1-18.54-1.5-11.39 4.65-58.7-21.52-83 20.79-21.55 33.76-45.29 33.73-65.65-.06-39.16-48.15-51-107.42-26.47l-12.55 5.33c-.06-.05-22.71-22.27-23.05-22.57C169.5-18-41.77 216.81 25.78 273.85l14.76 12.51a72.49 72.49 0 0 0-4.1 33.5c3.36 33.4 36 60.42 67.53 60.38 57.73 133.06 267.9 133.28 322.29 3 1.74-4.47 9.11-24.61 9.11-42.38s-10.09-25.27-16.53-25.27zm-316 48.16c-22.82-.61-47.46-21.15-49.91-45.51-6.17-61.31 74.26-75.27 84-12.33 4.54 29.64-4.67 58.49-34.12 57.81zM84.3 249.55C69.14 252.5 55.78 261.09 47.6 273c-4.88-4.07-14-12-15.59-15-13.01-24.85 14.24-73 33.3-100.21C112.42 90.56 186.19 39.68 220.36 48.91c5.55 1.57 23.94 22.89 23.94 22.89s-34.15 18.94-65.8 45.35c-42.66 32.85-74.89 80.59-94.2 132.4zM323.18 350.7s-35.74 5.3-69.51-7.07c6.21-20.16 27 6.1 96.4-13.81 15.29-4.38 35.37-13 51-25.35a102.85 102.85 0 0 1 7.12 24.28c3.66-.66 14.25-.52 11.44 18.1-3.29 19.87-11.73 36-25.93 50.84A106.86 106.86 0 0 1 362.55 421a132.45 132.45 0 0 1-20.34 8.58c-53.51 17.48-108.3-1.74-126-43a66.33 66.33 0 0 1-3.55-9.74c-7.53-27.2-1.14-59.83 18.84-80.37 1.23-1.31 2.48-2.85 2.48-4.79a8.45 8.45 0 0 0-1.92-4.54c-7-10.13-31.19-27.4-26.33-60.83 3.5-24 24.49-40.91 44.07-39.91l5 .29c8.48.5 15.89 1.59 22.88 1.88 11.69.5 22.2-1.19 34.64-11.56 4.2-3.5 7.57-6.54 13.26-7.51a17.45 17.45 0 0 1 13.6 2.24c10 6.64 11.4 22.73 11.92 34.49.29 6.72 1.1 23 1.38 27.63.63 10.67 3.43 12.17 9.11 14 3.19 1.05 6.15 1.83 10.51 3.06 13.21 3.71 21 7.48 26 12.31a16.38 16.38 0 0 1 4.74 9.29c1.56 11.37-8.82 25.4-36.31 38.16-46.71 21.68-93.68 14.45-100.48 13.68-20.15-2.71-31.63 23.32-19.55 41.15 22.64 33.41 122.4 20 151.37-21.35.69-1 .12-1.59-.73-1-41.77 28.58-97.06 38.21-128.46 26-4.77-1.85-14.73-6.44-15.94-16.67 43.6 13.49 71 .74 71 .74s2.03-2.79-.56-2.53zm-68.47-5.7zm-83.4-187.5c16.74-19.35 37.36-36.18 55.83-45.63a.73.73 0 0 1 1 1c-1.46 2.66-4.29 8.34-5.19 12.65a.75.75 0 0 0 1.16.79c11.49-7.83 31.48-16.22 49-17.3a.77.77 0 0 1 .52 1.38 41.86 41.86 0 0 0-7.71 7.74.75.75 0 0 0 .59 1.19c12.31.09 29.66 4.4 41 10.74.76.43.22 1.91-.64 1.72-69.55-15.94-123.08 18.53-134.5 26.83a.76.76 0 0 1-1-1.12z"
    ]
};
var $ef0249c5e48bf4e3$export$928cd5ee6ccd55c0 = {
    prefix: "fab",
    iconName: "css3-alt",
    icon: [
        384,
        512,
        [],
        "f38b",
        "M0 32l34.9 395.8L192 480l157.1-52.2L384 32H0zm313.1 80l-4.8 47.3L193 208.6l-.3.1h111.5l-12.8 146.6-98.2 28.7-98.8-29.2-6.4-73.9h48.9l3.2 38.3 52.6 13.3 54.7-15.4 3.7-61.6-166.3-.5v-.1l-.2.1-3.6-46.3L193.1 162l6.5-2.7H76.7L70.9 112h242.2z"
    ]
};
var $ef0249c5e48bf4e3$export$307bcbd032fbb8d3 = {
    prefix: "fab",
    iconName: "square-reddit",
    icon: [
        448,
        512,
        [
            "reddit-square"
        ],
        "f1a2",
        "M64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32zM305.9 166.4c20.6 0 37.3-16.7 37.3-37.3s-16.7-37.3-37.3-37.3c-18 0-33.1 12.8-36.6 29.8c-30.2 3.2-53.8 28.8-53.8 59.9l0 .2c-32.8 1.4-62.8 10.7-86.6 25.5c-8.8-6.8-19.9-10.9-32-10.9c-28.9 0-52.3 23.4-52.3 52.3c0 21 12.3 39 30.1 47.4c1.7 60.7 67.9 109.6 149.3 109.6s147.6-48.9 149.3-109.7c17.7-8.4 29.9-26.4 29.9-47.3c0-28.9-23.4-52.3-52.3-52.3c-12 0-23 4-31.9 10.8c-24-14.9-54.3-24.2-87.5-25.4l0-.1c0-22.2 16.5-40.7 37.9-43.7l0 0c3.9 16.5 18.7 28.7 36.3 28.7zM155 248.1c14.6 0 25.8 15.4 25 34.4s-11.8 25.9-26.5 25.9s-27.5-7.7-26.6-26.7s13.5-33.5 28.1-33.5zm166.4 33.5c.9 19-12 26.7-26.6 26.7s-25.6-6.9-26.5-25.9c-.9-19 10.3-34.4 25-34.4s27.3 14.6 28.1 33.5zm-42.1 49.6c-9 21.5-30.3 36.7-55.1 36.7s-46.1-15.1-55.1-36.7c-1.1-2.6 .7-5.4 3.4-5.7c16.1-1.6 33.5-2.5 51.7-2.5s35.6 .9 51.7 2.5c2.7 .3 4.5 3.1 3.4 5.7z"
    ]
};
var $ef0249c5e48bf4e3$export$f8480c75bb6acc77 = $ef0249c5e48bf4e3$export$307bcbd032fbb8d3;
var $ef0249c5e48bf4e3$export$2ea137a3f22bc61 = {
    prefix: "fab",
    iconName: "vimeo-v",
    icon: [
        448,
        512,
        [],
        "f27d",
        "M447.8 153.6c-2 43.6-32.4 103.3-91.4 179.1-60.9 79.2-112.4 118.8-154.6 118.8-26.1 0-48.2-24.1-66.3-72.3C100.3 250 85.3 174.3 56.2 174.3c-3.4 0-15.1 7.1-35.2 21.1L0 168.2c51.6-45.3 100.9-95.7 131.8-98.5 34.9-3.4 56.3 20.5 64.4 71.5 28.7 181.5 41.4 208.9 93.6 126.7 18.7-29.6 28.8-52.1 30.2-67.6 4.8-45.9-35.8-42.8-63.3-31 22-72.1 64.1-107.1 126.2-105.1 45.8 1.2 67.5 31.1 64.9 89.4z"
    ]
};
var $ef0249c5e48bf4e3$export$d023cd407bbc3cab = {
    prefix: "fab",
    iconName: "contao",
    icon: [
        512,
        512,
        [],
        "f26d",
        "M45.4 305c14.4 67.1 26.4 129 68.2 175H34c-18.7 0-34-15.2-34-34V66c0-18.7 15.2-34 34-34h57.7C77.9 44.6 65.6 59.2 54.8 75.6c-45.4 70-27 146.8-9.4 229.4zM478 32h-90.2c21.4 21.4 39.2 49.5 52.7 84.1l-137.1 29.3c-14.9-29-37.8-53.3-82.6-43.9-24.6 5.3-41 19.3-48.3 34.6-8.8 18.7-13.2 39.8 8.2 140.3 21.1 100.2 33.7 117.7 49.5 131.2 12.9 11.1 33.4 17 58.3 11.7 44.5-9.4 55.7-40.7 57.4-73.2l137.4-29.6c3.2 71.5-18.7 125.2-57.4 163.6H478c18.7 0 34-15.2 34-34V66c0-18.8-15.2-34-34-34z"
    ]
};
var $ef0249c5e48bf4e3$export$128da80f2cbe244a = {
    prefix: "fab",
    iconName: "square-font-awesome",
    icon: [
        448,
        512,
        [],
        "e5ad",
        "M384.5,32.5h-320c-35.3,0-64,28.7-64,64v320c0,35.3,28.7,64,64,64h320c35.3,0,64-28.7,64-64v-320 C448.5,61.2,419.8,32.5,384.5,32.5z M336.5,312.5c-31.6,11.2-41.2,16-59.8,16c-31.4,0-43.2-16-74.6-16c-10.2,0-18.2,1.6-25.6,4v-32 c7.4-2.2,15.4-4,25.6-4c31.2,0,43.2,16,74.6,16c10.2,0,17.8-1.4,27.8-4.6v-96c-10,3.2-17.6,4.6-27.8,4.6c-31.4,0-43.2-16-74.6-16 c-25.4,0-37.4,10.4-57.6,14.4v153.6c0,8.8-7.2,16-16,16c-8.8,0-16-7.2-16-16v-192c0-8.8,7.2-16,16-16c8.8,0,16,7.2,16,16v6.4 c20.2-4,32.2-14.4,57.6-14.4c31.2,0,43.2,16,74.6,16c18.6,0,28.2-4.8,59.8-16V312.5z"
    ]
};
var $ef0249c5e48bf4e3$export$9005bf63ad3e3083 = {
    prefix: "fab",
    iconName: "deskpro",
    icon: [
        480,
        512,
        [],
        "f38f",
        "M205.9 512l31.1-38.4c12.3-.2 25.6-1.4 36.5-6.6 38.9-18.6 38.4-61.9 38.3-63.8-.1-5-.8-4.4-28.9-37.4H362c-.2 50.1-7.3 68.5-10.2 75.7-9.4 23.7-43.9 62.8-95.2 69.4-8.7 1.1-32.8 1.2-50.7 1.1zm200.4-167.7c38.6 0 58.5-13.6 73.7-30.9l-175.5-.3-17.4 31.3 119.2-.1zm-43.6-223.9v168.3h-73.5l-32.7 55.5H250c-52.3 0-58.1-56.5-58.3-58.9-1.2-13.2-21.3-11.6-20.1 1.8 1.4 15.8 8.8 40 26.4 57.1h-91c-25.5 0-110.8-26.8-107-114V16.9C0 .9 9.7.3 15 .1h82c.2 0 .3.1.5.1 4.3-.4 50.1-2.1 50.1 43.7 0 13.3 20.2 13.4 20.2 0 0-18.2-5.5-32.8-15.8-43.7h84.2c108.7-.4 126.5 79.4 126.5 120.2zm-132.5 56l64 29.3c13.3-45.5-42.2-71.7-64-29.3z"
    ]
};
var $ef0249c5e48bf4e3$export$ec6cecf928f83afa = {
    prefix: "fab",
    iconName: "brave",
    icon: [
        448,
        512,
        [],
        "e63c",
        "M145.5 0H224h78.5l44.7 50.8s39.3-10.9 57.8 7.6s33.8 34.9 33.8 34.9l-12 29.5 15.3 43.7s-44.9 170.2-50.1 191c-10.4 40.9-17.4 56.8-46.9 77.5s-82.9 56.8-91.6 62.2c-1.9 1.2-3.9 2.5-5.9 3.9c-7.5 5.1-15.8 10.8-23.5 10.8l0 0 0 0c-7.7 0-16.1-5.7-23.5-10.8c-2-1.4-4-2.8-5.9-3.9c-8.7-5.5-62.1-41.5-91.6-62.2s-36.5-36.6-46.9-77.5c-5.3-20.8-50.1-191-50.1-191l15.3-43.7L9.2 93.3s15.3-16.4 33.8-34.9s57.8-7.6 57.8-7.6L145.5 0zM224 407.6l0 0c3.7 0 8.9-4.7 13-8.4c.6-.5 1.2-1.1 1.7-1.5c4.2-3.7 47.8-37.5 51-39.8s5.4-6.5 1.9-8.7c-2.8-1.7-10-5.5-20.3-10.8c-3-1.6-6.3-3.2-9.7-5c-15.4-8-34.5-14.7-37.5-14.7l0 0 0 0c-3 0-22.1 6.8-37.5 14.7c-3.5 1.8-6.7 3.5-9.7 5c-10.3 5.3-17.6 9.1-20.3 10.8c-3.6 2.2-1.4 6.4 1.9 8.7s46.8 36.1 51 39.8c.5 .5 1.1 1 1.7 1.5c4.1 3.7 9.3 8.4 13 8.4l0 0zm0-165.7l0 0c4.7 0 17.6-3 26.4-5l0 0 2-.5c7.8-1.8 7.3-6.3 6.4-13c-.1-.8-.2-1.6-.3-2.4c-.6-6.1-5.8-33.1-9.1-50.3c-1.1-5.8-2-10.5-2.4-12.9c-1.5-8.1-.6-9.4 .7-11.3c.2-.3 .5-.7 .7-1.1c1.4-2.3 16-6.2 27.9-9.5l0 0c2.5-.7 4.8-1.3 6.9-1.9c10.6-3 32.4-.6 44.2 .6c1.8 .2 3.4 .4 4.7 .5c9.6 .9 10.4 2.3 7.2 3.8c-2.3 1.1-16.2 6.3-28.7 10.9l0 0 0 0c-4.7 1.8-9.2 3.5-12.8 4.8c-1.5 .5-3 1.1-4.5 1.7c-12.5 4.6-27.2 10-28.9 19.4c-1.5 8.3 5.2 19.9 11.3 30.3l0 0c1.6 2.8 3.2 5.5 4.6 8.1c6.3 11.9 6.5 13.3 6.1 18.1c-.4 3.9-14.5 12.7-22.4 17.6l0 0c-1.8 1.1-3.3 2.1-4.2 2.7c-.8 .5-2.1 1.4-3.8 2.4c-8.6 5.2-26.3 16-26.3 22.5c0 7.8 24.6 28.1 32.4 33.2s28.9 16.1 37.9 17.8s23-8.5 31.2-23.8c7.7-14.4 1.7-28.5-3.2-40l-.9-2.2c-4.5-10.6 1.9-17 6.2-21.3l0 0c.5-.5 1-1 1.4-1.4L377.7 194c1.3-1.3 2.5-2.6 3.7-3.8l0 0c5.8-5.7 10.8-10.5 10.8-22.8c0-14.9-57.5-84.5-57.5-84.5s-48.5 9.3-55.1 9.3c-5.2 0-15.3-3.5-25.8-7.1l0 0c-2.7-.9-5.4-1.9-8-2.7C232.8 78.1 224 78 224 78l0 0 0 0s-8.7 0-21.8 4.4c-2.7 .9-5.4 1.8-8 2.7l0 0c-10.5 3.6-20.6 7.1-25.8 7.1c-6.5 0-55.1-9.3-55.1-9.3s-57.5 69.6-57.5 84.5c0 12.3 4.9 17.1 10.8 22.8l0 0c1.2 1.2 2.5 2.4 3.7 3.8l43.1 45.8c.4 .5 .9 .9 1.4 1.4l0 0c4.3 4.3 10.6 10.7 6.2 21.3l-.9 2.2c-4.9 11.5-11 25.6-3.2 40c8.2 15.3 22.2 25.5 31.2 23.8s30.1-12.7 37.9-17.8s32.4-25.4 32.4-33.2c0-6.5-17.7-17.3-26.3-22.5c-1.7-1-3.1-1.9-3.8-2.4c-.9-.6-2.4-1.5-4.2-2.7c-7.9-4.9-22-13.7-22.4-17.6c-.4-4.8-.3-6.2 6.1-18.1c1.3-2.5 2.9-5.3 4.6-8.1c6-10.4 12.8-22 11.3-30.3c-1.7-9.4-16.4-14.8-28.9-19.4c-1.6-.6-3.1-1.1-4.5-1.7c-3.6-1.4-8.1-3.1-12.8-4.8l-.1 0c-12.5-4.7-26.4-9.9-28.7-10.9c-3.2-1.5-2.3-2.8 7.2-3.8c1.3-.1 2.9-.3 4.7-.5c11.8-1.3 33.6-3.6 44.2-.6c2.1 .6 4.4 1.2 6.9 1.9c11.9 3.2 26.5 7.2 27.9 9.5c.2 .4 .5 .7 .7 1.1c1.3 1.9 2.2 3.2 .7 11.3c-.4 2.4-1.3 7.1-2.4 12.9c-3.3 17.2-8.5 44.2-9.1 50.3c-.1 .8-.2 1.7-.3 2.4c-.8 6.7-1.4 11.2 6.4 13l2 .5 0 0c8.8 2 21.8 5 26.4 5l0 0z"
    ]
};
var $ef0249c5e48bf4e3$export$36ca6be2e064d2cd = {
    prefix: "fab",
    iconName: "sistrix",
    icon: [
        448,
        512,
        [],
        "f3ee",
        "M448 449L301.2 300.2c20-27.9 31.9-62.2 31.9-99.2 0-93.1-74.7-168.9-166.5-168.9C74.7 32 0 107.8 0 200.9s74.7 168.9 166.5 168.9c39.8 0 76.3-14.2 105-37.9l146 148.1 30.5-31zM166.5 330.8c-70.6 0-128.1-58.3-128.1-129.9S95.9 71 166.5 71s128.1 58.3 128.1 129.9-57.4 129.9-128.1 129.9z"
    ]
};
var $ef0249c5e48bf4e3$export$526087fb4de86dae = {
    prefix: "fab",
    iconName: "square-instagram",
    icon: [
        448,
        512,
        [
            "instagram-square"
        ],
        "e055",
        "M194.4 211.7a53.3 53.3 0 1 0 59.3 88.7 53.3 53.3 0 1 0 -59.3-88.7zm142.3-68.4c-5.2-5.2-11.5-9.3-18.4-12c-18.1-7.1-57.6-6.8-83.1-6.5c-4.1 0-7.9 .1-11.2 .1c-3.3 0-7.2 0-11.4-.1c-25.5-.3-64.8-.7-82.9 6.5c-6.9 2.7-13.1 6.8-18.4 12s-9.3 11.5-12 18.4c-7.1 18.1-6.7 57.7-6.5 83.2c0 4.1 .1 7.9 .1 11.1s0 7-.1 11.1c-.2 25.5-.6 65.1 6.5 83.2c2.7 6.9 6.8 13.1 12 18.4s11.5 9.3 18.4 12c18.1 7.1 57.6 6.8 83.1 6.5c4.1 0 7.9-.1 11.2-.1c3.3 0 7.2 0 11.4 .1c25.5 .3 64.8 .7 82.9-6.5c6.9-2.7 13.1-6.8 18.4-12s9.3-11.5 12-18.4c7.2-18 6.8-57.4 6.5-83c0-4.2-.1-8.1-.1-11.4s0-7.1 .1-11.4c.3-25.5 .7-64.9-6.5-83l0 0c-2.7-6.9-6.8-13.1-12-18.4zm-67.1 44.5A82 82 0 1 1 178.4 324.2a82 82 0 1 1 91.1-136.4zm29.2-1.3c-3.1-2.1-5.6-5.1-7.1-8.6s-1.8-7.3-1.1-11.1s2.6-7.1 5.2-9.8s6.1-4.5 9.8-5.2s7.6-.4 11.1 1.1s6.5 3.9 8.6 7s3.2 6.8 3.2 10.6c0 2.5-.5 5-1.4 7.3s-2.4 4.4-4.1 6.2s-3.9 3.2-6.2 4.2s-4.8 1.5-7.3 1.5l0 0c-3.8 0-7.5-1.1-10.6-3.2zM448 96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96zM357 389c-18.7 18.7-41.4 24.6-67 25.9c-26.4 1.5-105.6 1.5-132 0c-25.6-1.3-48.3-7.2-67-25.9s-24.6-41.4-25.8-67c-1.5-26.4-1.5-105.6 0-132c1.3-25.6 7.1-48.3 25.8-67s41.5-24.6 67-25.8c26.4-1.5 105.6-1.5 132 0c25.6 1.3 48.3 7.1 67 25.8s24.6 41.4 25.8 67c1.5 26.3 1.5 105.4 0 131.9c-1.3 25.6-7.1 48.3-25.8 67z"
    ]
};
var $ef0249c5e48bf4e3$export$ccb1f25058292a04 = $ef0249c5e48bf4e3$export$526087fb4de86dae;
var $ef0249c5e48bf4e3$export$fb3fd8e112e1fa28 = {
    prefix: "fab",
    iconName: "battle-net",
    icon: [
        512,
        512,
        [],
        "f835",
        "M448.61 225.62c26.87.18 35.57-7.43 38.92-12.37 12.47-16.32-7.06-47.6-52.85-71.33 17.76-33.58 30.11-63.68 36.34-85.3 3.38-11.83 1.09-19 .45-20.25-1.72 10.52-15.85 48.46-48.2 100.05-25-11.22-56.52-20.1-93.77-23.8-8.94-16.94-34.88-63.86-60.48-88.93C252.18 7.14 238.7 1.07 228.18.22h-.05c-13.83-1.55-22.67 5.85-27.4 11-17.2 18.53-24.33 48.87-25 84.07-7.24-12.35-17.17-24.63-28.5-25.93h-.18c-20.66-3.48-38.39 29.22-36 81.29-38.36 1.38-71 5.75-93 11.23-9.9 2.45-16.22 7.27-17.76 9.72 1-.38 22.4-9.22 111.56-9.22 5.22 53 29.75 101.82 26 93.19-9.73 15.4-38.24 62.36-47.31 97.7-5.87 22.88-4.37 37.61.15 47.14 5.57 12.75 16.41 16.72 23.2 18.26 25 5.71 55.38-3.63 86.7-21.14-7.53 12.84-13.9 28.51-9.06 39.34 7.31 19.65 44.49 18.66 88.44-9.45 20.18 32.18 40.07 57.94 55.7 74.12a39.79 39.79 0 0 0 8.75 7.09c5.14 3.21 8.58 3.37 8.58 3.37-8.24-6.75-34-38-62.54-91.78 22.22-16 45.65-38.87 67.47-69.27 122.82 4.6 143.29-24.76 148-31.64 14.67-19.88 3.43-57.44-57.32-93.69zm-77.85 106.22c23.81-37.71 30.34-67.77 29.45-92.33 27.86 17.57 47.18 37.58 49.06 58.83 1.14 12.93-8.1 29.12-78.51 33.5zM216.9 387.69c9.76-6.23 19.53-13.12 29.2-20.49 6.68 13.33 13.6 26.1 20.6 38.19-40.6 21.86-68.84 12.76-49.8-17.7zm215-171.35c-10.29-5.34-21.16-10.34-32.38-15.05a722.459 722.459 0 0 0 22.74-36.9c39.06 24.1 45.9 53.18 9.64 51.95zM279.18 398c-5.51-11.35-11-23.5-16.5-36.44 43.25 1.27 62.42-18.73 63.28-20.41 0 .07-25 15.64-62.53 12.25a718.78 718.78 0 0 0 85.06-84q13.06-15.31 24.93-31.11c-.36-.29-1.54-3-16.51-12-51.7 60.27-102.34 98-132.75 115.92-20.59-11.18-40.84-31.78-55.71-61.49-20-39.92-30-82.39-31.57-116.07 12.3.91 25.27 2.17 38.85 3.88-22.29 36.8-14.39 63-13.47 64.23 0-.07-.95-29.17 20.14-59.57a695.23 695.23 0 0 0 44.67 152.84c.93-.38 1.84.88 18.67-8.25-26.33-74.47-33.76-138.17-34-173.43 20-12.42 48.18-19.8 81.63-17.81 44.57 2.67 86.36 15.25 116.32 30.71q-10.69 15.66-23.33 32.47C365.63 152 339.1 145.84 337.5 146c.11 0 25.9 14.07 41.52 47.22a717.63 717.63 0 0 0-115.34-31.71 646.608 646.608 0 0 0-39.39-6.05c-.07.45-1.81 1.85-2.16 20.33C300 190.28 358.78 215.68 389.36 233c.74 23.55-6.95 51.61-25.41 79.57-24.6 37.31-56.39 67.23-84.77 85.43zm27.4-287c-44.56-1.66-73.58 7.43-94.69 20.67 2-52.3 21.31-76.38 38.21-75.28C267 52.15 305 108.55 306.58 111zm-130.65 3.1c.48 12.11 1.59 24.62 3.21 37.28-14.55-.85-28.74-1.25-42.4-1.26-.08 3.24-.12-51 24.67-49.59h.09c5.76 1.09 10.63 6.88 14.43 13.57zm-28.06 162c20.76 39.7 43.3 60.57 65.25 72.31-46.79 24.76-77.53 20-84.92 4.51-.2-.21-11.13-15.3 19.67-76.81zm210.06 74.8"
    ]
};
var $ef0249c5e48bf4e3$export$daa019c708da49e9 = {
    prefix: "fab",
    iconName: "the-red-yeti",
    icon: [
        512,
        512,
        [],
        "f69d",
        "M488.23 241.7l20.7 7.1c-9.6-23.9-23.9-37-31.7-44.8l7.1-18.2c.2 0 12.3-27.8-2.5-30.7-.6-11.3-6.6-27-18.4-27-7.6-10.6-17.7-12.3-30.7-5.9a122.2 122.2 0 0 0-25.3 16.5c-5.3-6.4-3 .4-3-29.8-37.1-24.3-45.4-11.7-74.8 3l.5.5a239.36 239.36 0 0 0-68.4-13.3c-5.5-8.7-18.6-19.1-25.1-25.1l24.8 7.1c-5.5-5.5-26.8-12.9-34.2-15.2 18.2-4.1 29.8-20.8 42.5-33-34.9-10.1-67.9-5.9-97.9 11.8l12-44.2L182 0c-31.6 24.2-33 41.9-33.7 45.5-.9-2.4-6.3-19.6-15.2-27a35.12 35.12 0 0 0-.5 25.3c3 8.4 5.9 14.8 8.4 18.9-16-3.3-28.3-4.9-49.2 0h-3.7l33 14.3a194.26 194.26 0 0 0-46.7 67.4l-1.7 8.4 1.7 1.7 7.6-4.7c-3.3 11.6-5.3 19.4-6.6 25.8a200.18 200.18 0 0 0-27.8 40.3c-15 1-31.8 10.8-40.3 14.3l3 3.4 28.8 1c-.5 1-.7 2.2-1.2 3.2-7.3 6.4-39.8 37.7-33 80.7l20.2-22.4c.5 1.7.7 3.4 1.2 5.2 0 25.5.4 89.6 64.9 150.5 43.6 40 96 60.2 157.5 60.2 121.7 0 223-87.3 223-211.5 6.8-9.7-1.2 3 16.7-25.1l13 14.3 2.5-.5A181.84 181.84 0 0 0 495 255a44.74 44.74 0 0 0-6.8-13.3zM398 111.2l-.5 21.9c5.5 18.1 16.9 17.2 22.4 17.2l-3.4-4.7 22.4-5.4a242.44 242.44 0 0 1-27 0c12.8-2.1 33.3-29 43-11.3 3.4 7.6 6.4 17.2 9.3 27.8l1.7-5.9a56.38 56.38 0 0 1-1.7-15.2c5.4.5 8.8 3.4 9.3 10.1.5 6.4 1.7 14.8 3.4 25.3l4.7-11.3c4.6 0 4.5-3.6-2.5 20.7-20.9-8.7-35.1-8.4-46.5-8.4l18.2-16c-25.3 8.2-33 10.8-54.8 20.9-1.1-5.4-5-13.5-16-19.9-3.2 3.8-2.8.9-.7 14.8h-2.5a62.32 62.32 0 0 0-8.4-23.1l4.2-3.4c8.4-7.1 11.8-14.3 10.6-21.9-.5-6.4-5.4-13.5-13.5-20.7 5.6-3.4 15.2-.4 28.3 8.5zm-39.6-10.1c2.7 1.9 11.4 5.4 18.9 17.2 4.2 8.4 4 9.8 3.4 11.1-.5 2.4-.5 4.3-3 7.1-1.7 2.5-5.4 4.7-11.8 7.6-7.6-13-16.5-23.6-27.8-31.2zM91 143.1l1.2-1.7c1.2-2.9 4.2-7.6 9.3-15.2l2.5-3.4-13 12.3 5.4-4.7-10.1 9.3-4.2 1.2c12.3-24.1 23.1-41.3 32.5-50.2 9.3-9.3 16-16 20.2-19.4l-6.4 1.2c-11.3-4.2-19.4-7.1-24.8-8.4 2.5-.5 3.7-.5 3.2-.5 10.3 0 17.5.5 20.9 1.2a52.35 52.35 0 0 0 16 2.5l.5-1.7-8.4-35.8 13.5 29a42.89 42.89 0 0 0 5.9-14.3c1.7-6.4 5.4-13 10.1-19.4s7.6-10.6 9.3-11.3a234.68 234.68 0 0 0-6.4 25.3l-1.7 7.1-.5 4.7 2.5 2.5C190.4 39.9 214 34 239.8 34.5l21.1.5c-11.8 13.5-27.8 21.9-48.5 24.8a201.26 201.26 0 0 1-23.4 2.9l-.2-.5-2.5-1.2a20.75 20.75 0 0 0-14 2c-2.5-.2-4.9-.5-7.1-.7l-2.5 1.7.5 1.2c2 .2 3.9.5 6.2.7l-2 3.4 3.4-.5-10.6 11.3c-4.2 3-5.4 6.4-4.2 9.3l5.4-3.4h1.2a39.4 39.4 0 0 1 25.3-15.2v-3c6.4.5 13 1 19.4 1.2 6.4 0 8.4.5 5.4 1.2a189.6 189.6 0 0 1 20.7 13.5c13.5 10.1 23.6 21.9 30 35.4 8.8 18.2 13.5 37.1 13.5 56.6a141.13 141.13 0 0 1-3 28.3 209.91 209.91 0 0 1-16 46l2.5.5c18.2-19.7 41.9-16 49.2-16l-6.4 5.9 22.4 17.7-1.7 30.7c-5.4-12.3-16.5-21.1-33-27.8 16.5 14.8 23.6 21.1 21.9 20.2-4.8-2.8-3.5-1.9-10.8-3.7 4.1 4.1 17.5 18.8 18.2 20.7l.2.2-.2.2c0 1.8 1.6-1.2-14 22.9-75.2-15.3-106.27-42.7-141.2-63.2l11.8 1.2c-11.8-18.5-15.6-17.7-38.4-26.1L149 225c-8.8-3-18.2-3-28.3.5l7.6-10.6-1.2-1.7c-14.9 4.3-19.8 9.2-22.6 11.3-1.1-5.5-2.8-12.4-12.3-28.8l-1.2 27-13.2-5c1.5-25.2 5.4-50.5 13.2-74.6zm276.5 330c-49.9 25-56.1 22.4-59 23.9-29.8-11.8-50.9-31.7-63.5-58.8l30 16.5c-9.8-9.3-18.3-16.5-38.4-44.3l11.8 23.1-17.7-7.6c14.2 21.1 23.5 51.7 66.6 73.5-120.8 24.2-199-72.1-200.9-74.3a262.57 262.57 0 0 0 35.4 24.8c3.4 1.7 7.1 2.5 10.1 1.2l-16-20.7c9.2 4.2 9.5 4.5 69.1 29-42.5-20.7-73.8-40.8-93.2-60.2-.5 6.4-1.2 10.1-1.2 10.1a80.25 80.25 0 0 1 20.7 26.6c-39-18.9-57.6-47.6-71.3-82.6 49.9 55.1 118.9 37.5 120.5 37.1 34.8 16.4 69.9 23.6 113.9 10.6 3.3 0 20.3 17 25.3 39.1l4.2-3-2.5-23.6c9 9 24.9 22.6 34.4 13-15.6-5.3-23.5-9.5-29.5-31.7 4.6 4.2 7.6 9 27.8 15l1.2-1.2-10.5-14.2c11.7-4.8-3.5 1 32-10.8 4.3 34.3 9 49.2.7 89.5zm115.3-214.4l-2.5.5 3 9.3c-3.5 5.9-23.7 44.3-71.6 79.7-39.5 29.8-76.6 39.1-80.9 40.3l-7.6-7.1-1.2 3 14.3 16-7.1-4.7 3.4 4.2h-1.2l-21.9-13.5 9.3 26.6-19-27.9-1.2 2.5 7.6 29c-6.1-8.2-21-32.6-56.8-39.6l32.5 21.2a214.82 214.82 0 0 1-93.2-6.4c-4.2-1.2-8.9-2.5-13.5-4.2l1.2-3-44.8-22.4 26.1 22.4c-57.7 9.1-113-25.4-126.4-83.4l-2.5-16.4-22.27 22.3c19.5-57.5 25.6-57.9 51.4-70.1-9.1-5.3-1.6-3.3-38.4-9.3 15.8-5.8 33-15.4 73 5.2a18.5 18.5 0 0 1 3.7-1.7c.6-3.2.4-.8 1-11.8 3.9 10 3.6 8.7 3 9.3l1.7.5c12.7-6.5 8.9-4.5 17-8.9l-5.4 13.5 22.3-5.8-8.4 8.4 2.5 2.5c4.5-1.8 30.3 3.4 40.8 16l-23.6-2.5c39.4 23 51.5 54 55.8 69.6l1.7-1.2c-2.8-22.3-12.4-33.9-16-40.1 4.2 5 39.2 34.6 110.4 46-11.3-.5-23.1 5.4-34.9 18.9l46.7-20.2-9.3 21.9c7.6-10.1 14.8-23.6 21.2-39.6v-.5l1.2-3-1.2 16c13.5-41.8 25.3-78.5 35.4-109.7l13.5-27.8v-2l-5.4-4.2h10.1l5.9 4.2 2.5-1.2-3.4-16 12.3 18.9 41.8-20.2-14.8 13 .5 2.9 17.7-.5a184 184 0 0 1 33 4.2l-23.6 2.5-1.2 3 26.6 23.1a254.21 254.21 0 0 1 27 32c-11.2-3.3-10.3-3.4-21.2-3.4l12.3 32.5zm-6.1-71.3l-3.9 13-14.3-11.8zm-254.8 7.1c1.7 10.6 4.7 17.7 8.8 21.9-9.3 6.6-27.5 13.9-46.5 16l.5 1.2a50.22 50.22 0 0 0 24.8-2.5l-7.1 13c4.2-1.7 10.1-7.1 17.7-14.8 11.9-5.5 12.7-5.1 20.2-16-12.7-6.4-15.7-13.7-18.4-18.8zm3.7-102.3c-6.4-3.4-10.6 3-12.3 18.9s2.5 29.5 11.8 39.6 18.2 10.6 26.1 3 3.4-23.6-11.3-47.7a39.57 39.57 0 0 0-14.27-13.8zm-4.7 46.3c5.4 2.2 10.5 1.9 12.3-10.6v-4.7l-1.2.5c-4.3-3.1-2.5-4.5-1.7-6.2l.5-.5c-.9-1.2-5-8.1-12.5 4.7-.5-13.5.5-21.9 3-24.8 1.2-2.5 4.7-1.2 11.3 4.2 6.4 5.4 11.3 16 15.2 32.5 6.5 28-19.8 26.2-26.9 4.9zm-45-5.5c1.6.3 9.3-1.1 9.3-14.8h-.5c-5.4-1.1-2.2-5.5-.7-5.9-1.7-3-3.4-4.2-5.4-4.7-8.1 0-11.6 12.7-8.1 21.2a7.51 7.51 0 0 0 5.43 4.2zM216 82.9l-2.5.5.5 3a48.94 48.94 0 0 1 26.1 5.9c-2.5-5.5-10-14.3-28.3-14.3l.5 2.5zm-71.8 49.4c21.7 16.8 16.5 21.4 46.5 23.6l-2.9-4.7a42.67 42.67 0 0 0 14.8-28.3c1.7-16-1.2-29.5-8.8-41.3l13-7.6a2.26 2.26 0 0 0-.5-1.7 14.21 14.21 0 0 0-13.5 1.7c-12.7 6.7-28 20.9-29 22.4-1.7 1.7-3.4 5.9-5.4 13.5a99.61 99.61 0 0 0-2.9 23.6c-4.7-8-10.5-6.4-19.9-5.9l7.1 7.6c-16.5 0-23.3 15.4-23.6 16 6.8 0 4.6-7.6 30-12.3-4.3-6.3-3.3-5-4.9-6.6zm18.7-18.7c1.2-7.6 3.4-13 6.4-17.2 5.4-6.4 10.6-10.1 16-11.8 4.2-1.7 7.1 1.2 10.1 9.3a72.14 72.14 0 0 1 3 25.3c-.5 9.3-3.4 17.2-8.4 23.1-2.9 3.4-5.4 5.9-6.4 7.6a39.21 39.21 0 0 1-11.3-.5l-7.1-3.4-5.4-6.4c.8-10 1.3-18.8 3.1-26zm42 56.1c-34.8 14.4-34.7 14-36.1 14.3-20.8 4.7-19-24.4-18.9-24.8l5.9-1.2-.5-2.5c-20.2-2.6-31 4.2-32.5 4.9.5.5 3 3.4 5.9 9.3 4.2-6.4 8.8-10.1 15.2-10.6a83.47 83.47 0 0 0 1.7 33.7c.1.5 2.6 17.4 27.5 24.1 11.3 3 27 1.2 48.9-5.4l-9.2.5c-4.2-14.8-6.4-24.8-5.9-29.5 11.3-8.8 21.9-11.3 30.7-7.6h2.5l-11.8-7.6-7.1.5c-5.9 1.2-12.3 4.2-19.4 8.4z"
    ]
};
var $ef0249c5e48bf4e3$export$ca115ee475bced67 = {
    prefix: "fab",
    iconName: "square-hacker-news",
    icon: [
        448,
        512,
        [
            "hacker-news-square"
        ],
        "f3af",
        "M448 96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96zM21 229.2c0 0 .1-.1 .1-.2s.1-.2 .2-.2c0 .1 0 .3-.1 .4H21zM239.2 384H207.8V281.3L128 128h37.3c41.5 77.7 48.1 95.8 54.1 112c1.6 4.3 3.1 8.5 5.2 13.6c3.2-7 5.1-11.9 7.1-17.3c5.9-15.3 12.8-33.2 53.5-108.3H320L239.2 283.1V384z"
    ]
};
var $ef0249c5e48bf4e3$export$310b7424f1f97fc = $ef0249c5e48bf4e3$export$ca115ee475bced67;
var $ef0249c5e48bf4e3$export$9c65bd68cbc68ec9 = {
    prefix: "fab",
    iconName: "edge",
    icon: [
        512,
        512,
        [],
        "f282",
        "M120.1 37.44C161.1 12.23 207.7-.7753 255 .0016C423 .0016 512 123.8 512 219.5C511.9 252.2 499 283.4 476.1 306.7C453.2 329.9 422.1 343.2 389.4 343.7C314.2 343.7 297.9 320.6 297.9 311.7C297.9 307.9 299.1 305.5 302.7 302.3L303.7 301.1L304.1 299.5C314.6 288 320 273.3 320 257.9C320 179.2 237.8 115.2 136 115.2C98.46 114.9 61.46 124.1 28.48 142.1C55.48 84.58 111.2 44.5 119.8 38.28C120.6 37.73 120.1 37.44 120.1 37.44V37.44zM135.7 355.5C134.3 385.5 140.3 415.5 152.1 442.7C165.7 469.1 184.8 493.7 208.6 512C149.1 500.5 97.11 468.1 59.2 422.7C21.12 376.3 0 318.4 0 257.9C0 206.7 62.4 163.5 136 163.5C172.6 162.9 208.4 174.4 237.8 196.2L234.2 197.4C182.7 215 135.7 288.1 135.7 355.5V355.5zM469.8 400L469.1 400.1C457.3 418.9 443.2 435.2 426.9 449.6C396.1 477.6 358.8 495.1 318.1 499.5C299.5 499.8 281.3 496.3 264.3 488.1C238.7 477.8 217.2 458.1 202.7 435.1C188.3 411.2 181.6 383.4 183.7 355.5C183.1 335.4 189.1 315.2 198.7 297.3C212.6 330.4 236.2 358.6 266.3 378.1C296.4 397.6 331.8 407.6 367.7 406.7C398.7 407 429.8 400 457.9 386.2L459.8 385.3C463.7 383 467.5 381.4 471.4 385.3C475.9 390.2 473.2 394.5 470.2 399.3C470 399.5 469.9 399.8 469.8 400V400z"
    ]
};
var $ef0249c5e48bf4e3$export$2a1c6a809b4fdc7f = {
    prefix: "fab",
    iconName: "threads",
    icon: [
        448,
        512,
        [],
        "e618",
        "M331.5 235.7c2.2 .9 4.2 1.9 6.3 2.8c29.2 14.1 50.6 35.2 61.8 61.4c15.7 36.5 17.2 95.8-30.3 143.2c-36.2 36.2-80.3 52.5-142.6 53h-.3c-70.2-.5-124.1-24.1-160.4-70.2c-32.3-41-48.9-98.1-49.5-169.6V256v-.2C17 184.3 33.6 127.2 65.9 86.2C102.2 40.1 156.2 16.5 226.4 16h.3c70.3 .5 124.9 24 162.3 69.9c18.4 22.7 32 50 40.6 81.7l-40.4 10.8c-7.1-25.8-17.8-47.8-32.2-65.4c-29.2-35.8-73-54.2-130.5-54.6c-57 .5-100.1 18.8-128.2 54.4C72.1 146.1 58.5 194.3 58 256c.5 61.7 14.1 109.9 40.3 143.3c28 35.6 71.2 53.9 128.2 54.4c51.4-.4 85.4-12.6 113.7-40.9c32.3-32.2 31.7-71.8 21.4-95.9c-6.1-14.2-17.1-26-31.9-34.9c-3.7 26.9-11.8 48.3-24.7 64.8c-17.1 21.8-41.4 33.6-72.7 35.3c-23.6 1.3-46.3-4.4-63.9-16c-20.8-13.8-33-34.8-34.3-59.3c-2.5-48.3 35.7-83 95.2-86.4c21.1-1.2 40.9-.3 59.2 2.8c-2.4-14.8-7.3-26.6-14.6-35.2c-10-11.7-25.6-17.7-46.2-17.8H227c-16.6 0-39 4.6-53.3 26.3l-34.4-23.6c19.2-29.1 50.3-45.1 87.8-45.1h.8c62.6 .4 99.9 39.5 103.7 107.7l-.2 .2zm-156 68.8c1.3 25.1 28.4 36.8 54.6 35.3c25.6-1.4 54.6-11.4 59.5-73.2c-13.2-2.9-27.8-4.4-43.4-4.4c-4.8 0-9.6 .1-14.4 .4c-42.9 2.4-57.2 23.2-56.2 41.8l-.1 .1z"
    ]
};
var $ef0249c5e48bf4e3$export$29d678db44edc00 = {
    prefix: "fab",
    iconName: "napster",
    icon: [
        496,
        512,
        [],
        "f3d2",
        "M298.3 373.6c-14.2 13.6-31.3 24.1-50.4 30.5-19-6.4-36.2-16.9-50.3-30.5h100.7zm44-199.6c20-16.9 43.6-29.2 69.6-36.2V299c0 219.4-328 217.6-328 .3V137.7c25.9 6.9 49.6 19.6 69.5 36.4 56.8-40 132.5-39.9 188.9-.1zm-208.8-58.5c64.4-60 164.3-60.1 228.9-.2-7.1 3.5-13.9 7.3-20.6 11.5-58.7-30.5-129.2-30.4-187.9.1-6.3-4-13.9-8.2-20.4-11.4zM43.8 93.2v69.3c-58.4 36.5-58.4 121.1.1 158.3 26.4 245.1 381.7 240.3 407.6 1.5l.3-1.7c58.7-36.3 58.9-121.7.2-158.2V93.2c-17.3.5-34 3-50.1 7.4-82-91.5-225.5-91.5-307.5.1-16.3-4.4-33.1-7-50.6-7.5zM259.2 352s36-.3 61.3-1.5c10.2-.5 21.1-4 25.5-6.5 26.3-15.1 25.4-39.2 26.2-47.4-79.5-.6-99.9-3.9-113 55.4zm-135.5-55.3c.8 8.2-.1 32.3 26.2 47.4 4.4 2.5 15.2 6 25.5 6.5 25.3 1.1 61.3 1.5 61.3 1.5-13.2-59.4-33.7-56.1-113-55.4zm169.1 123.4c-3.2-5.3-6.9-7.3-6.9-7.3-24.8 7.3-52.2 6.9-75.9 0 0 0-2.9 1.5-6.4 6.6-2.8 4.1-3.7 9.6-3.7 9.6 29.1 17.6 67.1 17.6 96.2 0-.1-.1-.3-4-3.3-8.9z"
    ]
};
var $ef0249c5e48bf4e3$export$8176f1a0ece4380c = {
    prefix: "fab",
    iconName: "square-snapchat",
    icon: [
        448,
        512,
        [
            "snapchat-square"
        ],
        "f2ad",
        "M384,32H64A64,64,0,0,0,0,96V416a64,64,0,0,0,64,64H384a64,64,0,0,0,64-64V96A64,64,0,0,0,384,32Zm-3.907,319.309-.083.1a32.364,32.364,0,0,1-8.717,6.823,90.26,90.26,0,0,1-20.586,8.2,12.694,12.694,0,0,0-3.852,1.76c-2.158,1.909-2.1,4.64-4.4,8.55a23.137,23.137,0,0,1-6.84,7.471c-6.707,4.632-14.244,4.923-22.23,5.23-7.214.274-15.39.581-24.729,3.669-3.761,1.245-7.753,3.694-12.377,6.533-11.265,6.9-26.68,16.353-52.3,16.353s-40.925-9.4-52.106-16.279c-4.657-2.888-8.675-5.362-12.543-6.64-9.339-3.08-17.516-3.4-24.729-3.67-7.986-.307-15.523-.6-22.231-5.229a23.085,23.085,0,0,1-6.01-6.11c-3.2-4.632-2.855-7.8-5.254-9.895a13.428,13.428,0,0,0-4.1-1.834,89.986,89.986,0,0,1-20.313-8.127,32.905,32.905,0,0,1-8.3-6.284c-6.583-6.757-8.276-14.776-5.686-21.824,3.436-9.338,11.571-12.111,19.4-16.262,14.776-8.027,26.348-18.055,34.433-29.884a68.236,68.236,0,0,0,5.985-10.567c.789-2.158.772-3.329.241-4.416a7.386,7.386,0,0,0-2.208-2.217c-2.532-1.676-5.113-3.353-6.882-4.5-3.27-2.141-5.868-3.818-7.529-4.98-6.267-4.383-10.65-9.04-13.4-14.245a28.4,28.4,0,0,1-1.369-23.584c4.134-10.924,14.469-17.706,26.978-17.706a37.141,37.141,0,0,1,7.845.83c.689.15,1.37.307,2.042.482-.108-7.43.058-15.357.722-23.119,2.358-27.261,11.912-41.589,21.874-52.994a86.836,86.836,0,0,1,22.28-17.931C188.254,100.383,205.312,96,224,96s35.828,4.383,50.944,13.016a87.169,87.169,0,0,1,22.239,17.9c9.961,11.406,19.516,25.709,21.874,52.995a231.194,231.194,0,0,1,.713,23.118c.673-.174,1.362-.332,2.051-.481a37.131,37.131,0,0,1,7.844-.83c12.5,0,22.82,6.782,26.971,17.706a28.37,28.37,0,0,1-1.4,23.559c-2.74,5.2-7.123,9.861-13.39,14.244-1.668,1.187-4.258,2.864-7.529,4.981-1.835,1.187-4.541,2.947-7.164,4.682a6.856,6.856,0,0,0-1.951,2.034c-.506,1.046-.539,2.191.166,4.208a69.015,69.015,0,0,0,6.085,10.792c8.268,12.1,20.188,22.313,35.454,30.407,1.486.772,2.98,1.5,4.441,2.258.722.332,1.569.763,2.491,1.3,4.9,2.723,9.2,6.01,11.455,12.153C387.821,336.915,386.269,344.7,380.093,351.309Zm-16.719-18.461c-50.313-24.314-58.332-61.918-58.689-64.749-.431-3.379-.921-6.035,2.806-9.472,3.594-3.328,19.541-13.19,23.965-16.278,7.33-5.114,10.534-10.219,8.16-16.495-1.66-4.316-5.686-5.976-9.961-5.976a18.5,18.5,0,0,0-3.993.448c-8.035,1.743-15.838,5.769-20.354,6.857a7.1,7.1,0,0,1-1.66.224c-2.408,0-3.279-1.071-3.088-3.968.564-8.783,1.759-25.925.373-41.937-1.884-22.032-8.99-32.948-17.432-42.6-4.051-4.624-23.135-24.654-59.536-24.654S168.53,134.359,164.479,139c-8.434,9.654-15.531,20.57-17.432,42.6-1.386,16.013-.141,33.147.373,41.937.166,2.756-.68,3.968-3.088,3.968a7.1,7.1,0,0,1-1.66-.224c-4.507-1.087-12.31-5.113-20.346-6.856a18.494,18.494,0,0,0-3.993-.449c-4.25,0-8.3,1.636-9.961,5.977-2.374,6.276.847,11.381,8.168,16.494,4.425,3.088,20.371,12.958,23.966,16.279,3.719,3.437,3.237,6.093,2.805,9.471-.356,2.79-8.384,40.394-58.689,64.749-2.946,1.428-7.96,4.45.88,9.331,13.88,7.628,23.111,6.807,30.3,11.43,6.093,3.927,2.5,12.394,6.923,15.449,5.454,3.76,21.583-.266,42.335,6.6,17.433,5.744,28.116,22.015,58.963,22.015s41.788-16.3,58.938-21.973c20.795-6.865,36.89-2.839,42.336-6.6,4.433-3.055.822-11.522,6.923-15.448,7.181-4.624,16.411-3.8,30.3-11.472C371.36,337.355,366.346,334.333,363.374,332.848Z"
    ]
};
var $ef0249c5e48bf4e3$export$20f908cf15afb04b = $ef0249c5e48bf4e3$export$8176f1a0ece4380c;
var $ef0249c5e48bf4e3$export$74ebd8f5ac37d070 = {
    prefix: "fab",
    iconName: "google-plus-g",
    icon: [
        640,
        512,
        [],
        "f0d5",
        "M386.061 228.496c1.834 9.692 3.143 19.384 3.143 31.956C389.204 370.205 315.599 448 204.8 448c-106.084 0-192-85.915-192-192s85.916-192 192-192c51.864 0 95.083 18.859 128.611 50.292l-52.126 50.03c-14.145-13.621-39.028-29.599-76.485-29.599-65.484 0-118.92 54.221-118.92 121.277 0 67.056 53.436 121.277 118.92 121.277 75.961 0 104.513-54.745 108.965-82.773H204.8v-66.009h181.261zm185.406 6.437V179.2h-56.001v55.733h-55.733v56.001h55.733v55.733h56.001v-55.733H627.2v-56.001h-55.733z"
    ]
};
var $ef0249c5e48bf4e3$export$4fb55b03537dc8e3 = {
    prefix: "fab",
    iconName: "artstation",
    icon: [
        512,
        512,
        [],
        "f77a",
        "M2 377.4l43 74.3A51.35 51.35 0 0 0 90.9 480h285.4l-59.2-102.6zM501.8 350L335.6 59.3A51.38 51.38 0 0 0 290.2 32h-88.4l257.3 447.6 40.7-70.5c1.9-3.2 21-29.7 2-59.1zM275 304.5l-115.5-200L44 304.5z"
    ]
};
var $ef0249c5e48bf4e3$export$4401a9960e402a1c = {
    prefix: "fab",
    iconName: "markdown",
    icon: [
        640,
        512,
        [],
        "f60f",
        "M593.8 59.1H46.2C20.7 59.1 0 79.8 0 105.2v301.5c0 25.5 20.7 46.2 46.2 46.2h547.7c25.5 0 46.2-20.7 46.1-46.1V105.2c0-25.4-20.7-46.1-46.2-46.1zM338.5 360.6H277v-120l-61.5 76.9-61.5-76.9v120H92.3V151.4h61.5l61.5 76.9 61.5-76.9h61.5v209.2zm135.3 3.1L381.5 256H443V151.4h61.5V256H566z"
    ]
};
var $ef0249c5e48bf4e3$export$fd6b8582f52b208a = {
    prefix: "fab",
    iconName: "sourcetree",
    icon: [
        448,
        512,
        [],
        "f7d3",
        "M427.2 203c0-112.1-90.9-203-203-203C112.1-.2 21.2 90.6 21 202.6A202.86 202.86 0 0 0 161.5 396v101.7a14.3 14.3 0 0 0 14.3 14.3h96.4a14.3 14.3 0 0 0 14.3-14.3V396.1A203.18 203.18 0 0 0 427.2 203zm-271.6 0c0-90.8 137.3-90.8 137.3 0-.1 89.9-137.3 91-137.3 0z"
    ]
};
var $ef0249c5e48bf4e3$export$384e1aaf24320a2d = {
    prefix: "fab",
    iconName: "google-plus",
    icon: [
        512,
        512,
        [],
        "f2b3",
        "M256,8C119.1,8,8,119.1,8,256S119.1,504,256,504,504,392.9,504,256,392.9,8,256,8ZM185.3,380a124,124,0,0,1,0-248c31.3,0,60.1,11,83,32.3l-33.6,32.6c-13.2-12.9-31.3-19.1-49.4-19.1-42.9,0-77.2,35.5-77.2,78.1S142.3,334,185.3,334c32.6,0,64.9-19.1,70.1-53.3H185.3V238.1H302.2a109.2,109.2,0,0,1,1.9,20.7c0,70.8-47.5,121.2-118.8,121.2ZM415.5,273.8v35.5H380V273.8H344.5V238.3H380V202.8h35.5v35.5h35.2v35.5Z"
    ]
};
var $ef0249c5e48bf4e3$export$f59fd74fa97e6ae5 = {
    prefix: "fab",
    iconName: "diaspora",
    icon: [
        512,
        512,
        [],
        "f791",
        "M251.64 354.55c-1.4 0-88 119.9-88.7 119.9S76.34 414 76 413.25s86.6-125.7 86.6-127.4c0-2.2-129.6-44-137.6-47.1-1.3-.5 31.4-101.8 31.7-102.1.6-.7 144.4 47 145.5 47 .4 0 .9-.6 1-1.3.4-2 1-148.6 1.7-149.6.8-1.2 104.5-.7 105.1-.3 1.5 1 3.5 156.1 6.1 156.1 1.4 0 138.7-47 139.3-46.3.8.9 31.9 102.2 31.5 102.6-.9.9-140.2 47.1-140.6 48.8-.3 1.4 82.8 122.1 82.5 122.9s-85.5 63.5-86.3 63.5c-1-.2-89-125.5-90.9-125.5z"
    ]
};
var $ef0249c5e48bf4e3$export$b14039dbb12386bc = {
    prefix: "fab",
    iconName: "foursquare",
    icon: [
        368,
        512,
        [],
        "f180",
        "M323.1 3H49.9C12.4 3 0 31.3 0 49.1v433.8c0 20.3 12.1 27.7 18.2 30.1 6.2 2.5 22.8 4.6 32.9-7.1C180 356.5 182.2 354 182.2 354c3.1-3.4 3.4-3.1 6.8-3.1h83.4c35.1 0 40.6-25.2 44.3-39.7l48.6-243C373.8 25.8 363.1 3 323.1 3zm-16.3 73.8l-11.4 59.7c-1.2 6.5-9.5 13.2-16.9 13.2H172.1c-12 0-20.6 8.3-20.6 20.3v13c0 12 8.6 20.6 20.6 20.6h90.4c8.3 0 16.6 9.2 14.8 18.2-1.8 8.9-10.5 53.8-11.4 58.8-.9 4.9-6.8 13.5-16.9 13.5h-73.5c-13.5 0-17.2 1.8-26.5 12.6 0 0-8.9 11.4-89.5 108.3-.9.9-1.8.6-1.8-.3V75.9c0-7.7 6.8-16.6 16.6-16.6h219c8.2 0 15.6 7.7 13.5 17.5z"
    ]
};
var $ef0249c5e48bf4e3$export$2c0cf6f85294daec = {
    prefix: "fab",
    iconName: "stack-overflow",
    icon: [
        384,
        512,
        [],
        "f16c",
        "M290.7 311L95 269.7 86.8 309l195.7 41zm51-87L188.2 95.7l-25.5 30.8 153.5 128.3zm-31.2 39.7L129.2 179l-16.7 36.5L293.7 300zM262 32l-32 24 119.3 160.3 32-24zm20.5 328h-200v39.7h200zm39.7 80H42.7V320h-40v160h359.5V320h-40z"
    ]
};
var $ef0249c5e48bf4e3$export$edfa6885dbf62839 = {
    prefix: "fab",
    iconName: "github-alt",
    icon: [
        480,
        512,
        [],
        "f113",
        "M186.1 328.7c0 20.9-10.9 55.1-36.7 55.1s-36.7-34.2-36.7-55.1 10.9-55.1 36.7-55.1 36.7 34.2 36.7 55.1zM480 278.2c0 31.9-3.2 65.7-17.5 95-37.9 76.6-142.1 74.8-216.7 74.8-75.8 0-186.2 2.7-225.6-74.8-14.6-29-20.2-63.1-20.2-95 0-41.9 13.9-81.5 41.5-113.6-5.2-15.8-7.7-32.4-7.7-48.8 0-21.5 4.9-32.3 14.6-51.8 45.3 0 74.3 9 108.8 36 29-6.9 58.8-10 88.7-10 27 0 54.2 2.9 80.4 9.2 34-26.7 63-35.2 107.8-35.2 9.8 19.5 14.6 30.3 14.6 51.8 0 16.4-2.6 32.7-7.7 48.2 27.5 32.4 39 72.3 39 114.2zm-64.3 50.5c0-43.9-26.7-82.6-73.5-82.6-18.9 0-37 3.4-56 6-14.9 2.3-29.8 3.2-45.1 3.2-15.2 0-30.1-.9-45.1-3.2-18.7-2.6-37-6-56-6-46.8 0-73.5 38.7-73.5 82.6 0 87.8 80.4 101.3 150.4 101.3h48.2c70.3 0 150.6-13.4 150.6-101.3zm-82.6-55.1c-25.8 0-36.7 34.2-36.7 55.1s10.9 55.1 36.7 55.1 36.7-34.2 36.7-55.1-10.9-55.1-36.7-55.1z"
    ]
};
var $ef0249c5e48bf4e3$export$699e806dfe31d90b = {
    prefix: "fab",
    iconName: "phoenix-squadron",
    icon: [
        512,
        512,
        [],
        "f511",
        "M96 63.38C142.49 27.25 201.55 7.31 260.51 8.81c29.58-.38 59.11 5.37 86.91 15.33-24.13-4.63-49-6.34-73.38-2.45C231.17 27 191 48.84 162.21 80.87c5.67-1 10.78-3.67 16-5.86 18.14-7.87 37.49-13.26 57.23-14.83 19.74-2.13 39.64-.43 59.28 1.92-14.42 2.79-29.12 4.57-43 9.59-34.43 11.07-65.27 33.16-86.3 62.63-13.8 19.71-23.63 42.86-24.67 67.13-.35 16.49 5.22 34.81 19.83 44a53.27 53.27 0 0 0 37.52 6.74c15.45-2.46 30.07-8.64 43.6-16.33 11.52-6.82 22.67-14.55 32-24.25 3.79-3.22 2.53-8.45 2.62-12.79-2.12-.34-4.38-1.11-6.3.3a203 203 0 0 1-35.82 15.37c-20 6.17-42.16 8.46-62.1.78 12.79 1.73 26.06.31 37.74-5.44 20.23-9.72 36.81-25.2 54.44-38.77a526.57 526.57 0 0 1 88.9-55.31c25.71-12 52.94-22.78 81.57-24.12-15.63 13.72-32.15 26.52-46.78 41.38-14.51 14-27.46 29.5-40.11 45.18-3.52 4.6-8.95 6.94-13.58 10.16a150.7 150.7 0 0 0-51.89 60.1c-9.33 19.68-14.5 41.85-11.77 63.65 1.94 13.69 8.71 27.59 20.9 34.91 12.9 8 29.05 8.07 43.48 5.1 32.8-7.45 61.43-28.89 81-55.84 20.44-27.52 30.52-62.2 29.16-96.35-.52-7.5-1.57-15-1.66-22.49 8 19.48 14.82 39.71 16.65 60.83 2 14.28.75 28.76-1.62 42.9-1.91 11-5.67 21.51-7.78 32.43a165 165 0 0 0 39.34-81.07 183.64 183.64 0 0 0-14.21-104.64c20.78 32 32.34 69.58 35.71 107.48.49 12.73.49 25.51 0 38.23A243.21 243.21 0 0 1 482 371.34c-26.12 47.34-68 85.63-117.19 108-78.29 36.23-174.68 31.32-248-14.68A248.34 248.34 0 0 1 25.36 366 238.34 238.34 0 0 1 0 273.08v-31.34C3.93 172 40.87 105.82 96 63.38m222 80.33a79.13 79.13 0 0 0 16-4.48c5-1.77 9.24-5.94 10.32-11.22-8.96 4.99-17.98 9.92-26.32 15.7z"
    ]
};
var $ef0249c5e48bf4e3$export$e4b095fb96bd3e1 = {
    prefix: "fab",
    iconName: "pagelines",
    icon: [
        384,
        512,
        [],
        "f18c",
        "M384 312.7c-55.1 136.7-187.1 54-187.1 54-40.5 81.8-107.4 134.4-184.6 134.7-16.1 0-16.6-24.4 0-24.4 64.4-.3 120.5-42.7 157.2-110.1-41.1 15.9-118.6 27.9-161.6-82.2 109-44.9 159.1 11.2 178.3 45.5 9.9-24.4 17-50.9 21.6-79.7 0 0-139.7 21.9-149.5-98.1 119.1-47.9 152.6 76.7 152.6 76.7 1.6-16.7 3.3-52.6 3.3-53.4 0 0-106.3-73.7-38.1-165.2 124.6 43 61.4 162.4 61.4 162.4.5 1.6.5 23.8 0 33.4 0 0 45.2-89 136.4-57.5-4.2 134-141.9 106.4-141.9 106.4-4.4 27.4-11.2 53.4-20 77.5 0 0 83-91.8 172-20z"
    ]
};
var $ef0249c5e48bf4e3$export$8819d592a12ec37e = {
    prefix: "fab",
    iconName: "algolia",
    icon: [
        512,
        512,
        [],
        "f36c",
        "M256 0C116.1 0 2 112.7 0 252.1C-2 393.6 112.9 510.8 254.5 511.6c43.7 .3 85.9-10.4 123.3-30.7c3.6-2 4.2-7 1.1-9.7l-24-21.2c-4.9-4.3-11.8-5.5-17.8-3c-26.1 11.1-54.5 16.8-83.7 16.4C139 461.9 46.5 366.8 48.3 252.4C50.1 139.5 142.6 48.2 256 48.2H463.7V417.2L345.9 312.5c-3.8-3.4-9.7-2.7-12.7 1.3c-18.9 25-49.7 40.6-83.9 38.2c-47.5-3.3-85.9-41.5-89.5-88.9c-4.2-56.6 40.6-103.9 96.3-103.9c50.4 0 91.9 38.8 96.2 88c.4 4.4 2.4 8.5 5.7 11.4l30.7 27.2c3.5 3.1 9 1.2 9.9-3.4c2.2-11.8 3-24.2 2.1-36.8c-4.9-72-63.3-130-135.4-134.4c-82.7-5.1-151.8 59.5-154 140.6c-2.1 78.9 62.6 147 141.6 148.7c33 .7 63.6-9.6 88.3-27.6L495 509.4c6.6 5.8 17 1.2 17-7.7V9.7c0-5.4-4.4-9.7-9.7-9.7H256z"
    ]
};
var $ef0249c5e48bf4e3$export$1052bcfc0bf56d5d = {
    prefix: "fab",
    iconName: "red-river",
    icon: [
        448,
        512,
        [],
        "f3e3",
        "M353.2 32H94.8C42.4 32 0 74.4 0 126.8v258.4C0 437.6 42.4 480 94.8 480h258.4c52.4 0 94.8-42.4 94.8-94.8V126.8c0-52.4-42.4-94.8-94.8-94.8zM144.9 200.9v56.3c0 27-21.9 48.9-48.9 48.9V151.9c0-13.2 10.7-23.9 23.9-23.9h154.2c0 27-21.9 48.9-48.9 48.9h-56.3c-12.3-.6-24.6 11.6-24 24zm176.3 72h-56.3c-12.3-.6-24.6 11.6-24 24v56.3c0 27-21.9 48.9-48.9 48.9V247.9c0-13.2 10.7-23.9 23.9-23.9h154.2c0 27-21.9 48.9-48.9 48.9z"
    ]
};
var $ef0249c5e48bf4e3$export$976ebfab93ea9362 = {
    prefix: "fab",
    iconName: "creative-commons-sa",
    icon: [
        496,
        512,
        [],
        "f4ef",
        "M247.6 8C389.4 8 496 118.1 496 256c0 147.1-118.5 248-248.4 248C113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8zm.8 44.7C130.2 52.7 44.7 150.6 44.7 256c0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8.1-113.8-90.2-203.3-202.8-203.3zM137.7 221c13-83.9 80.5-95.7 108.9-95.7 99.8 0 127.5 82.5 127.5 134.2 0 63.6-41 132.9-128.9 132.9-38.9 0-99.1-20-109.4-97h62.5c1.5 30.1 19.6 45.2 54.5 45.2 23.3 0 58-18.2 58-82.8 0-82.5-49.1-80.6-56.7-80.6-33.1 0-51.7 14.6-55.8 43.8h18.2l-49.2 49.2-49-49.2h19.4z"
    ]
};
var $ef0249c5e48bf4e3$export$3fbc2591308fa490 = {
    prefix: "fab",
    iconName: "safari",
    icon: [
        512,
        512,
        [],
        "f267",
        "M274.69,274.69l-37.38-37.38L166,346ZM256,8C119,8,8,119,8,256S119,504,256,504,504,393,504,256,393,8,256,8ZM411.85,182.79l14.78-6.13A8,8,0,0,1,437.08,181h0a8,8,0,0,1-4.33,10.46L418,197.57a8,8,0,0,1-10.45-4.33h0A8,8,0,0,1,411.85,182.79ZM314.43,94l6.12-14.78A8,8,0,0,1,331,74.92h0a8,8,0,0,1,4.33,10.45l-6.13,14.78a8,8,0,0,1-10.45,4.33h0A8,8,0,0,1,314.43,94ZM256,60h0a8,8,0,0,1,8,8V84a8,8,0,0,1-8,8h0a8,8,0,0,1-8-8V68A8,8,0,0,1,256,60ZM181,74.92a8,8,0,0,1,10.46,4.33L197.57,94a8,8,0,1,1-14.78,6.12l-6.13-14.78A8,8,0,0,1,181,74.92Zm-63.58,42.49h0a8,8,0,0,1,11.31,0L140,128.72A8,8,0,0,1,140,140h0a8,8,0,0,1-11.31,0l-11.31-11.31A8,8,0,0,1,117.41,117.41ZM60,256h0a8,8,0,0,1,8-8H84a8,8,0,0,1,8,8h0a8,8,0,0,1-8,8H68A8,8,0,0,1,60,256Zm40.15,73.21-14.78,6.13A8,8,0,0,1,74.92,331h0a8,8,0,0,1,4.33-10.46L94,314.43a8,8,0,0,1,10.45,4.33h0A8,8,0,0,1,100.15,329.21Zm4.33-136h0A8,8,0,0,1,94,197.57l-14.78-6.12A8,8,0,0,1,74.92,181h0a8,8,0,0,1,10.45-4.33l14.78,6.13A8,8,0,0,1,104.48,193.24ZM197.57,418l-6.12,14.78a8,8,0,0,1-14.79-6.12l6.13-14.78A8,8,0,1,1,197.57,418ZM264,444a8,8,0,0,1-8,8h0a8,8,0,0,1-8-8V428a8,8,0,0,1,8-8h0a8,8,0,0,1,8,8Zm67-6.92h0a8,8,0,0,1-10.46-4.33L314.43,418a8,8,0,0,1,4.33-10.45h0a8,8,0,0,1,10.45,4.33l6.13,14.78A8,8,0,0,1,331,437.08Zm63.58-42.49h0a8,8,0,0,1-11.31,0L372,383.28A8,8,0,0,1,372,372h0a8,8,0,0,1,11.31,0l11.31,11.31A8,8,0,0,1,394.59,394.59ZM286.25,286.25,110.34,401.66,225.75,225.75,401.66,110.34ZM437.08,331h0a8,8,0,0,1-10.45,4.33l-14.78-6.13a8,8,0,0,1-4.33-10.45h0A8,8,0,0,1,418,314.43l14.78,6.12A8,8,0,0,1,437.08,331ZM444,264H428a8,8,0,0,1-8-8h0a8,8,0,0,1,8-8h16a8,8,0,0,1,8,8h0A8,8,0,0,1,444,264Z"
    ]
};
var $ef0249c5e48bf4e3$export$4675affbae76524d = {
    prefix: "fab",
    iconName: "google",
    icon: [
        488,
        512,
        [],
        "f1a0",
        "M488 261.8C488 403.3 391.1 504 248 504 110.8 504 0 393.2 0 256S110.8 8 248 8c66.8 0 123 24.5 166.3 64.9l-67.5 64.9C258.5 52.6 94.3 116.6 94.3 256c0 86.5 69.1 156.6 153.7 156.6 98.2 0 135-70.4 140.8-106.9H248v-85.3h236.1c2.3 12.7 3.9 24.9 3.9 41.4z"
    ]
};
var $ef0249c5e48bf4e3$export$dda4448112663ba = {
    prefix: "fab",
    iconName: "square-font-awesome-stroke",
    icon: [
        448,
        512,
        [
            "font-awesome-alt"
        ],
        "f35c",
        "M201.6,152c-25.4,0-37.4,10.4-57.6,14.4V160c0-8.8-7.2-16-16-16s-16,7.2-16,16v192c0,0.8,0.1,1.6,0.2,2.4 c0.1,0.4,0.1,0.8,0.2,1.2c1.6,7.1,8,12.4,15.6,12.4s14-5.3,15.6-12.4c0.1-0.4,0.2-0.8,0.2-1.2c0.1-0.8,0.2-1.6,0.2-2.4V198.4 c4-0.8,7.7-1.8,11.2-3c14.3-4.7,26-11.4,46.4-11.4c31.4,0,43.2,16,74.6,16c8.9,0,15.9-1.1,24.2-3.5c1.2-0.3,2.4-0.7,3.6-1.1v96 c-10,3.2-17.6,4.6-27.8,4.6c-31.4,0-43.4-16-74.6-16c-10.2,0-18.2,1.8-25.6,4v32c7.4-2.4,15.4-4,25.6-4c31.4,0,43.2,16,74.6,16 c18.6,0,28.2-4.8,59.8-16V152c-31.6,11.2-41.2,16-59.8,16C244.8,168,232.8,152,201.6,152z M384,32H64C28.7,32,0,60.7,0,96v320 c0,35.3,28.7,64,64,64h320c35.3,0,64-28.7,64-64V96C448,60.7,419.3,32,384,32z M416,416c0,17.6-14.4,32-32,32H64 c-17.6,0-32-14.4-32-32V96c0-17.6,14.4-32,32-32h320c17.6,0,32,14.4,32,32V416z"
    ]
};
var $ef0249c5e48bf4e3$export$85f790d14ecf253e = $ef0249c5e48bf4e3$export$dda4448112663ba;
var $ef0249c5e48bf4e3$export$f200be919c1eaf0d = {
    prefix: "fab",
    iconName: "atlassian",
    icon: [
        512,
        512,
        [],
        "f77b",
        "M152.2 236.4c-7.7-8.2-19.7-7.7-24.8 2.8L1.6 490.2c-5 10 2.4 21.7 13.4 21.7h175c5.8.1 11-3.2 13.4-8.4 37.9-77.8 15.1-196.3-51.2-267.1zM244.4 8.1c-122.3 193.4-8.5 348.6 65 495.5 2.5 5.1 7.7 8.4 13.4 8.4H497c11.2 0 18.4-11.8 13.4-21.7 0 0-234.5-470.6-240.4-482.3-5.3-10.6-18.8-10.8-25.6.1z"
    ]
};
var $ef0249c5e48bf4e3$export$ed0a679f653cc1ec = {
    prefix: "fab",
    iconName: "linkedin-in",
    icon: [
        448,
        512,
        [],
        "f0e1",
        "M100.28 448H7.4V148.9h92.88zM53.79 108.1C24.09 108.1 0 83.5 0 53.8a53.79 53.79 0 0 1 107.58 0c0 29.7-24.1 54.3-53.79 54.3zM447.9 448h-92.68V302.4c0-34.7-.7-79.2-48.29-79.2-48.29 0-55.69 37.7-55.69 76.7V448h-92.78V148.9h89.08v40.8h1.3c12.4-23.5 42.69-48.3 87.88-48.3 94 0 111.28 61.9 111.28 142.3V448z"
    ]
};
var $ef0249c5e48bf4e3$export$c5c4219467aa9953 = {
    prefix: "fab",
    iconName: "digital-ocean",
    icon: [
        512,
        512,
        [],
        "f391",
        "M87 481.8h73.7v-73.6H87zM25.4 346.6v61.6H87v-61.6zm466.2-169.7c-23-74.2-82.4-133.3-156.6-156.6C164.9-32.8 8 93.7 8 255.9h95.8c0-101.8 101-180.5 208.1-141.7 39.7 14.3 71.5 46.1 85.8 85.7 39.1 107-39.7 207.8-141.4 208v.3h-.3V504c162.6 0 288.8-156.8 235.6-327.1zm-235.3 231v-95.3h-95.6v95.6H256v-.3z"
    ]
};
var $ef0249c5e48bf4e3$export$3f240983de3f5d10 = {
    prefix: "fab",
    iconName: "nimblr",
    icon: [
        384,
        512,
        [],
        "f5a8",
        "M246.6 299.29c15.57 0 27.15 11.46 27.15 27s-11.62 27-27.15 27c-15.7 0-27.15-11.57-27.15-27s11.55-27 27.15-27zM113 326.25c0-15.61 11.68-27 27.15-27s27.15 11.46 27.15 27-11.47 27-27.15 27c-15.44 0-27.15-11.31-27.15-27M191.76 159C157 159 89.45 178.77 59.25 227L14 0v335.48C14 433.13 93.61 512 191.76 512s177.76-78.95 177.76-176.52S290.13 159 191.76 159zm0 308.12c-73.27 0-132.51-58.9-132.51-131.59s59.24-131.59 132.51-131.59 132.51 58.86 132.51 131.54S265 467.07 191.76 467.07z"
    ]
};
var $ef0249c5e48bf4e3$export$8d89e361d79b386e = {
    prefix: "fab",
    iconName: "chromecast",
    icon: [
        512,
        512,
        [],
        "f838",
        "M447.8,64H64c-23.6,0-42.7,19.1-42.7,42.7v63.9H64v-63.9h383.8v298.6H298.6V448H448c23.6,0,42.7-19.1,42.7-42.7V106.7 C490.7,83.1,471.4,64,447.8,64z M21.3,383.6L21.3,383.6l0,63.9h63.9C85.2,412.2,56.6,383.6,21.3,383.6L21.3,383.6z M21.3,298.6V341 c58.9,0,106.6,48.1,106.6,107h42.7C170.7,365.6,103.7,298.7,21.3,298.6z M213.4,448h42.7c-0.5-129.5-105.3-234.3-234.8-234.6l0,42.4 C127.3,255.6,213.3,342,213.4,448z"
    ]
};
var $ef0249c5e48bf4e3$export$acd6dee6975fc503 = {
    prefix: "fab",
    iconName: "evernote",
    icon: [
        384,
        512,
        [],
        "f839",
        "M120.82 132.21c1.6 22.31-17.55 21.59-21.61 21.59-68.93 0-73.64-1-83.58 3.34-.56.22-.74 0-.37-.37L123.79 46.45c.38-.37.6-.22.38.37-4.35 9.99-3.35 15.09-3.35 85.39zm79 308c-14.68-37.08 13-76.93 52.52-76.62 17.49 0 22.6 23.21 7.95 31.42-6.19 3.3-24.95 1.74-25.14 19.2-.05 17.09 19.67 25 31.2 24.89A45.64 45.64 0 0 0 312 393.45v-.08c0-11.63-7.79-47.22-47.54-55.34-7.72-1.54-65-6.35-68.35-50.52-3.74 16.93-17.4 63.49-43.11 69.09-8.74 1.94-69.68 7.64-112.92-36.77 0 0-18.57-15.23-28.23-57.95-3.38-15.75-9.28-39.7-11.14-62 0-18 11.14-30.45 25.07-32.2 81 0 90 2.32 101-7.8 9.82-9.24 7.8-15.5 7.8-102.78 1-8.3 7.79-30.81 53.41-24.14 6 .86 31.91 4.18 37.48 30.64l64.26 11.15c20.43 3.71 70.94 7 80.6 57.94 22.66 121.09 8.91 238.46 7.8 238.46C362.15 485.53 267.06 480 267.06 480c-18.95-.23-54.25-9.4-67.27-39.83zm80.94-204.84c-1 1.92-2.2 6 .85 7 14.09 4.93 39.75 6.84 45.88 5.53 3.11-.25 3.05-4.43 2.48-6.65-3.53-21.85-40.83-26.5-49.24-5.92z"
    ]
};
var $ef0249c5e48bf4e3$export$5d439911ece032d6 = {
    prefix: "fab",
    iconName: "hacker-news",
    icon: [
        448,
        512,
        [],
        "f1d4",
        "M0 32v448h448V32H0zm21.2 197.2H21c.1-.1.2-.3.3-.4 0 .1 0 .3-.1.4zm218 53.9V384h-31.4V281.3L128 128h37.3c52.5 98.3 49.2 101.2 59.3 125.6 12.3-27 5.8-24.4 60.6-125.6H320l-80.8 155.1z"
    ]
};
var $ef0249c5e48bf4e3$export$e443cc965f82dd02 = {
    prefix: "fab",
    iconName: "creative-commons-sampling",
    icon: [
        496,
        512,
        [],
        "f4f0",
        "M247.6 8C389.4 8 496 118.1 496 256c0 147.1-118.5 248-248.4 248C113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8zm.8 44.7C130.2 52.7 44.7 150.6 44.7 256c0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8.1-113.8-90.2-203.3-202.8-203.3zm3.6 53.2c2.8-.3 11.5 1 11.5 11.5l6.6 107.2 4.9-59.3c0-6 4.7-10.6 10.6-10.6 5.9 0 10.6 4.7 10.6 10.6 0 2.5-.5-5.7 5.7 81.5l5.8-64.2c.3-2.9 2.9-9.3 10.2-9.3 3.8 0 9.9 2.3 10.6 8.9l11.5 96.5 5.3-12.8c1.8-4.4 5.2-6.6 10.2-6.6h58v21.3h-50.9l-18.2 44.3c-3.9 9.9-19.5 9.1-20.8-3.1l-4-31.9-7.5 92.6c-.3 3-3 9.3-10.2 9.3-3 0-9.8-2.1-10.6-9.3 0-1.9.6 5.8-6.2-77.9l-5.3 72.2c-1.1 4.8-4.8 9.3-10.6 9.3-2.9 0-9.8-2-10.6-9.3 0-1.9.5 6.7-5.8-87.7l-5.8 94.8c0 6.3-3.6 12.4-10.6 12.4-5.2 0-10.6-4.1-10.6-12l-5.8-87.7c-5.8 92.5-5.3 84-5.3 85.9-1.1 4.8-4.8 9.3-10.6 9.3-3 0-9.8-2.1-10.6-9.3 0-.7-.4-1.1-.4-2.6l-6.2-88.6L182 348c-.7 6.5-6.7 9.3-10.6 9.3-5.8 0-9.6-4.1-10.6-8.9L149.7 272c-2 4-3.5 8.4-11.1 8.4H87.2v-21.3H132l13.7-27.9c4.4-9.9 18.2-7.2 19.9 2.7l3.1 20.4 8.4-97.9c0-6 4.8-10.6 10.6-10.6.5 0 10.6-.2 10.6 12.4l4.9 69.1 6.6-92.6c0-10.1 9.5-10.6 10.2-10.6.6 0 10.6.7 10.6 10.6l5.3 80.6 6.2-97.9c.1-1.1-.6-10.3 9.9-11.5z"
    ]
};
var $ef0249c5e48bf4e3$export$1a30438e2bd95428 = {
    prefix: "fab",
    iconName: "adversal",
    icon: [
        512,
        512,
        [],
        "f36a",
        "M482.1 32H28.7C5.8 32 0 37.9 0 60.9v390.2C0 474.4 5.8 480 28.7 480h453.4c24.4 0 29.9-5.2 29.9-29.7V62.2c0-24.6-5.4-30.2-29.9-30.2zM178.4 220.3c-27.5-20.2-72.1-8.7-84.2 23.4-4.3 11.1-9.3 9.5-17.5 8.3-9.7-1.5-17.2-3.2-22.5-5.5-28.8-11.4 8.6-55.3 24.9-64.3 41.1-21.4 83.4-22.2 125.3-4.8 40.9 16.8 34.5 59.2 34.5 128.5 2.7 25.8-4.3 58.3 9.3 88.8 1.9 4.4.4 7.9-2.7 10.7-8.4 6.7-39.3 2.2-46.6-7.4-1.9-2.2-1.8-3.6-3.9-6.2-3.6-3.9-7.3-2.2-11.9 1-57.4 36.4-140.3 21.4-147-43.3-3.1-29.3 12.4-57.1 39.6-71 38.2-19.5 112.2-11.8 114-30.9 1.1-10.2-1.9-20.1-11.3-27.3zm286.7 222c0 15.1-11.1 9.9-17.8 9.9H52.4c-7.4 0-18.2 4.8-17.8-10.7.4-13.9 10.5-9.1 17.1-9.1 132.3-.4 264.5-.4 396.8 0 6.8 0 16.6-4.4 16.6 9.9zm3.8-340.5v291c0 5.7-.7 13.9-8.1 13.9-12.4-.4-27.5 7.1-36.1-5.6-5.8-8.7-7.8-4-12.4-1.2-53.4 29.7-128.1 7.1-144.4-85.2-6.1-33.4-.7-67.1 15.7-100 11.8-23.9 56.9-76.1 136.1-30.5v-71c0-26.2-.1-26.2 26-26.2 3.1 0 6.6.4 9.7 0 10.1-.8 13.6 4.4 13.6 14.3-.1.2-.1.3-.1.5zm-51.5 232.3c-19.5 47.6-72.9 43.3-90 5.2-15.1-33.3-15.5-68.2.4-101.5 16.3-34.1 59.7-35.7 81.5-4.8 20.6 28.8 14.9 84.6 8.1 101.1zm-294.8 35.3c-7.5-1.3-33-3.3-33.7-27.8-.4-13.9 7.8-23 19.8-25.8 24.4-5.9 49.3-9.9 73.7-14.7 8.9-2 7.4 4.4 7.8 9.5 1.4 33-26.1 59.2-67.6 58.8z"
    ]
};
var $ef0249c5e48bf4e3$export$cf9c9b2132d3672c = {
    prefix: "fab",
    iconName: "creative-commons",
    icon: [
        496,
        512,
        [],
        "f25e",
        "M245.83 214.87l-33.22 17.28c-9.43-19.58-25.24-19.93-27.46-19.93-22.13 0-33.22 14.61-33.22 43.84 0 23.57 9.21 43.84 33.22 43.84 14.47 0 24.65-7.09 30.57-21.26l30.55 15.5c-6.17 11.51-25.69 38.98-65.1 38.98-22.6 0-73.96-10.32-73.96-77.05 0-58.69 43-77.06 72.63-77.06 30.72-.01 52.7 11.95 65.99 35.86zm143.05 0l-32.78 17.28c-9.5-19.77-25.72-19.93-27.9-19.93-22.14 0-33.22 14.61-33.22 43.84 0 23.55 9.23 43.84 33.22 43.84 14.45 0 24.65-7.09 30.54-21.26l31 15.5c-2.1 3.75-21.39 38.98-65.09 38.98-22.69 0-73.96-9.87-73.96-77.05 0-58.67 42.97-77.06 72.63-77.06 30.71-.01 52.58 11.95 65.56 35.86zM247.56 8.05C104.74 8.05 0 123.11 0 256.05c0 138.49 113.6 248 247.56 248 129.93 0 248.44-100.87 248.44-248 0-137.87-106.62-248-248.44-248zm.87 450.81c-112.54 0-203.7-93.04-203.7-202.81 0-105.42 85.43-203.27 203.72-203.27 112.53 0 202.82 89.46 202.82 203.26-.01 121.69-99.68 202.82-202.84 202.82z"
    ]
};
var $ef0249c5e48bf4e3$export$17b7e34aba803644 = {
    prefix: "fab",
    iconName: "watchman-monitoring",
    icon: [
        512,
        512,
        [],
        "e087",
        "M256,16C123.452,16,16,123.452,16,256S123.452,496,256,496,496,388.548,496,256,388.548,16,256,16ZM121.69,429.122C70.056,388.972,36.741,326.322,36.741,256a218.519,218.519,0,0,1,9.587-64.122l102.9-17.895-.121,10.967-13.943,2.013s-.144,12.5-.144,19.549a12.778,12.778,0,0,0,4.887,10.349l9.468,7.4Zm105.692-283.27,8.48-7.618s6.934-5.38-.143-9.344c-7.188-4.024-39.53-34.5-39.53-34.5-5.348-5.477-8.257-7.347-15.46,0,0,0-32.342,30.474-39.529,34.5-7.078,3.964-.144,9.344-.144,9.344l8.481,7.618-.048,4.369L75.982,131.045c39.644-56.938,105.532-94.3,180.018-94.3A218.754,218.754,0,0,1,420.934,111.77l-193.512,37.7Zm34.063,329.269-33.9-250.857,9.467-7.4a12.778,12.778,0,0,0,4.888-10.349c0-7.044-.144-19.549-.144-19.549l-13.943-2.013-.116-10.474,241.711,31.391A218.872,218.872,0,0,1,475.259,256C475.259,375.074,379.831,472.212,261.445,475.121Z"
    ]
};
var $ef0249c5e48bf4e3$export$324e0175b7ef27f7 = {
    prefix: "fab",
    iconName: "fonticons",
    icon: [
        448,
        512,
        [],
        "f280",
        "M0 32v448h448V32zm187 140.9c-18.4 0-19 9.9-19 27.4v23.3c0 2.4-3.5 4.4-.6 4.4h67.4l-11.1 37.3H168v112.9c0 5.8-2 6.7 3.2 7.3l43.5 4.1v25.1H84V389l21.3-2c5.2-.6 6.7-2.3 6.7-7.9V267.7c0-2.3-2.9-2.3-5.8-2.3H84V228h28v-21c0-49.6 26.5-70 77.3-70 34.1 0 64.7 8.2 64.7 52.8l-50.7 6.1c.3-18.7-4.4-23-16.3-23zm74.3 241.8v-25.1l20.4-2.6c5.2-.6 7.6-1.7 7.6-7.3V271.8c0-4.1-2.9-6.7-6.7-7.9l-24.2-6.4 6.7-29.5h80.2v151.7c0 5.8-2.6 6.4 2.9 7.3l15.7 2.6v25.1zm80.8-255.5l9 33.2-7.3 7.3-31.2-16.6-31.2 16.6-7.3-7.3 9-33.2-21.8-24.2 3.5-9.6h27.7l15.5-28h9.3l15.5 28h27.7l3.5 9.6z"
    ]
};
var $ef0249c5e48bf4e3$export$5c0c3408fef47d33 = {
    prefix: "fab",
    iconName: "weixin",
    icon: [
        576,
        512,
        [],
        "f1d7",
        "M385.2 167.6c6.4 0 12.6.3 18.8 1.1C387.4 90.3 303.3 32 207.7 32 100.5 32 13 104.8 13 197.4c0 53.4 29.3 97.5 77.9 131.6l-19.3 58.6 68-34.1c24.4 4.8 43.8 9.7 68.2 9.7 6.2 0 12.1-.3 18.3-.8-4-12.9-6.2-26.6-6.2-40.8-.1-84.9 72.9-154 165.3-154zm-104.5-52.9c14.5 0 24.2 9.7 24.2 24.4 0 14.5-9.7 24.2-24.2 24.2-14.8 0-29.3-9.7-29.3-24.2.1-14.7 14.6-24.4 29.3-24.4zm-136.4 48.6c-14.5 0-29.3-9.7-29.3-24.2 0-14.8 14.8-24.4 29.3-24.4 14.8 0 24.4 9.7 24.4 24.4 0 14.6-9.6 24.2-24.4 24.2zM563 319.4c0-77.9-77.9-141.3-165.4-141.3-92.7 0-165.4 63.4-165.4 141.3S305 460.7 397.6 460.7c19.3 0 38.9-5.1 58.6-9.9l53.4 29.3-14.8-48.6C534 402.1 563 363.2 563 319.4zm-219.1-24.5c-9.7 0-19.3-9.7-19.3-19.6 0-9.7 9.7-19.3 19.3-19.3 14.8 0 24.4 9.7 24.4 19.3 0 10-9.7 19.6-24.4 19.6zm107.1 0c-9.7 0-19.3-9.7-19.3-19.6 0-9.7 9.7-19.3 19.3-19.3 14.5 0 24.4 9.7 24.4 19.3.1 10-9.9 19.6-24.4 19.6z"
    ]
};
var $ef0249c5e48bf4e3$export$621d1ced1e254c1c = {
    prefix: "fab",
    iconName: "shirtsinbulk",
    icon: [
        448,
        512,
        [],
        "f214",
        "M100 410.3l30.6 13.4 4.4-9.9-30.6-13.4zm39.4 17.5l30.6 13.4 4.4-9.9-30.6-13.4zm172.1-14l4.4 9.9 30.6-13.4-4.4-9.9zM179.1 445l30.3 13.7 4.4-9.9-30.3-13.4zM60.4 392.8L91 406.2l4.4-9.6-30.6-13.7zm211.4 38.5l4.4 9.9 30.6-13.4-4.4-9.9zm-39.3 17.5l4.4 9.9 30.6-13.7-4.4-9.6zm118.4-52.2l4.4 9.6 30.6-13.4-4.4-9.9zM170 46.6h-33.5v10.5H170zm-47.2 0H89.2v10.5h33.5zm-47.3 0H42.3v10.5h33.3zm141.5 0h-33.2v10.5H217zm94.5 0H278v10.5h33.5zm47.3 0h-33.5v10.5h33.5zm-94.6 0H231v10.5h33.2zm141.5 0h-33.3v10.5h33.3zM52.8 351.1H42v33.5h10.8zm70-215.9H89.2v10.5h33.5zm-70 10.6h22.8v-10.5H42v33.5h10.8zm168.9 228.6c50.5 0 91.3-40.8 91.3-91.3 0-50.2-40.8-91.3-91.3-91.3-50.2 0-91.3 41.1-91.3 91.3 0 50.5 41.1 91.3 91.3 91.3zm-48.2-111.1c0-25.4 29.5-31.8 49.6-31.8 16.9 0 29.2 5.8 44.3 12l-8.8 16.9h-.9c-6.4-9.9-24.8-13.1-35.6-13.1-9 0-29.8 1.8-29.8 14.9 0 21.6 78.5-10.2 78.5 37.9 0 25.4-31.5 31.2-51 31.2-18.1 0-32.4-2.9-47.2-12.2l9-18.4h.9c6.1 12.2 23.6 14.9 35.9 14.9 8.7 0 32.7-1.2 32.7-14.3 0-26.1-77.6 6.3-77.6-38zM52.8 178.4H42V212h10.8zm342.4 206.2H406v-33.5h-10.8zM52.8 307.9H42v33.5h10.8zM0 3.7v406l221.7 98.6L448 409.7V3.7zm418.8 387.1L222 476.5 29.2 390.8V120.7h389.7v270.1zm0-299.3H29.2V32.9h389.7v58.6zm-366 130.1H42v33.5h10.8zm0 43.2H42v33.5h10.8zM170 135.2h-33.5v10.5H170zm225.2 163.1H406v-33.5h-10.8zm0-43.2H406v-33.5h-10.8zM217 135.2h-33.2v10.5H217zM395.2 212H406v-33.5h-10.8zm0 129.5H406V308h-10.8zm-131-206.3H231v10.5h33.2zm47.3 0H278v10.5h33.5zm83.7 33.6H406v-33.5h-33.5v10.5h22.8zm-36.4-33.6h-33.5v10.5h33.5z"
    ]
};
var $ef0249c5e48bf4e3$export$f02422936d21d2f4 = {
    prefix: "fab",
    iconName: "codepen",
    icon: [
        512,
        512,
        [],
        "f1cb",
        "M502.285 159.704l-234-156c-7.987-4.915-16.511-4.96-24.571 0l-234 156C3.714 163.703 0 170.847 0 177.989v155.999c0 7.143 3.714 14.286 9.715 18.286l234 156.022c7.987 4.915 16.511 4.96 24.571 0l234-156.022c6-3.999 9.715-11.143 9.715-18.286V177.989c-.001-7.142-3.715-14.286-9.716-18.285zM278 63.131l172.286 114.858-76.857 51.429L278 165.703V63.131zm-44 0v102.572l-95.429 63.715-76.857-51.429L234 63.131zM44 219.132l55.143 36.857L44 292.846v-73.714zm190 229.715L61.714 333.989l76.857-51.429L234 346.275v102.572zm22-140.858l-77.715-52 77.715-52 77.715 52-77.715 52zm22 140.858V346.275l95.429-63.715 76.857 51.429L278 448.847zm190-156.001l-55.143-36.857L468 219.132v73.714z"
    ]
};
var $ef0249c5e48bf4e3$export$9ce7fda0737f89e7 = {
    prefix: "fab",
    iconName: "git-alt",
    icon: [
        448,
        512,
        [],
        "f841",
        "M439.55 236.05L244 40.45a28.87 28.87 0 0 0-40.81 0l-40.66 40.63 51.52 51.52c27.06-9.14 52.68 16.77 43.39 43.68l49.66 49.66c34.23-11.8 61.18 31 35.47 56.69-26.49 26.49-70.21-2.87-56-37.34L240.22 199v121.85c25.3 12.54 22.26 41.85 9.08 55a34.34 34.34 0 0 1-48.55 0c-17.57-17.6-11.07-46.91 11.25-56v-123c-20.8-8.51-24.6-30.74-18.64-45L142.57 101 8.45 235.14a28.86 28.86 0 0 0 0 40.81l195.61 195.6a28.86 28.86 0 0 0 40.8 0l194.69-194.69a28.86 28.86 0 0 0 0-40.81z"
    ]
};
var $ef0249c5e48bf4e3$export$c2221e2ed2fea622 = {
    prefix: "fab",
    iconName: "lyft",
    icon: [
        512,
        512,
        [],
        "f3c3",
        "M0 81.1h77.8v208.7c0 33.1 15 52.8 27.2 61-12.7 11.1-51.2 20.9-80.2-2.8C7.8 334 0 310.7 0 289V81.1zm485.9 173.5v-22h23.8v-76.8h-26.1c-10.1-46.3-51.2-80.7-100.3-80.7-56.6 0-102.7 46-102.7 102.7V357c16 2.3 35.4-.3 51.7-14 17.1-14 24.8-37.2 24.8-59v-6.7h38.8v-76.8h-38.8v-23.3c0-34.6 52.2-34.6 52.2 0v77.1c0 56.6 46 102.7 102.7 102.7v-76.5c-14.5 0-26.1-11.7-26.1-25.9zm-294.3-99v113c0 15.4-23.8 15.4-23.8 0v-113H91v132.7c0 23.8 8 54 45 63.9 37 9.8 58.2-10.6 58.2-10.6-2.1 13.4-14.5 23.3-34.9 25.3-15.5 1.6-35.2-3.6-45-7.8v70.3c25.1 7.5 51.5 9.8 77.6 4.7 47.1-9.1 76.8-48.4 76.8-100.8V155.1h-77.1v.5z"
    ]
};
var $ef0249c5e48bf4e3$export$344ccb7aebcc7cfa = {
    prefix: "fab",
    iconName: "rev",
    icon: [
        448,
        512,
        [],
        "f5b2",
        "M289.67 274.89a65.57 65.57 0 1 1-65.56-65.56 65.64 65.64 0 0 1 65.56 65.56zm139.55-5.05h-.13a204.69 204.69 0 0 0-74.32-153l-45.38 26.2a157.07 157.07 0 0 1 71.81 131.84C381.2 361.5 310.73 432 224.11 432S67 361.5 67 274.88c0-81.88 63-149.27 143-156.43v39.12l108.77-62.79L210 32v38.32c-106.7 7.25-191 96-191 204.57 0 111.59 89.12 202.29 200.06 205v.11h210.16V269.84z"
    ]
};
var $ef0249c5e48bf4e3$export$b138356c7d4344fd = {
    prefix: "fab",
    iconName: "windows",
    icon: [
        448,
        512,
        [],
        "f17a",
        "M0 93.7l183.6-25.3v177.4H0V93.7zm0 324.6l183.6 25.3V268.4H0v149.9zm203.8 28L448 480V268.4H203.8v177.9zm0-380.6v180.1H448V32L203.8 65.7z"
    ]
};
var $ef0249c5e48bf4e3$export$2c1079aeb76cd815 = {
    prefix: "fab",
    iconName: "wizards-of-the-coast",
    icon: [
        640,
        512,
        [],
        "f730",
        "M219.19 345.69c-1.9 1.38-11.07 8.44-.26 23.57 4.64 6.42 14.11 12.79 21.73 6.55 6.5-4.88 7.35-12.92.26-23.04-5.47-7.76-14.28-12.88-21.73-7.08zm336.75 75.94c-.34 1.7-.55 1.67.79 0 2.09-4.19 4.19-10.21 4.98-19.9 3.14-38.49-40.33-71.49-101.34-78.03-54.73-6.02-124.38 9.17-188.8 60.49l-.26 1.57c2.62 4.98 4.98 10.74 3.4 21.21l.79.26c63.89-58.4 131.19-77.25 184.35-73.85 58.4 3.67 100.03 34.04 100.03 68.08-.01 9.96-2.63 15.72-3.94 20.17zM392.28 240.42c.79 7.07 4.19 10.21 9.17 10.47 5.5.26 9.43-2.62 10.47-6.55.79-3.4 2.09-29.85 2.09-29.85s-11.26 6.55-14.93 10.47c-3.66 3.68-7.33 8.39-6.8 15.46zm-50.02-151.1C137.75 89.32 13.1 226.8.79 241.2c-1.05.52-1.31.79.79 1.31 60.49 16.5 155.81 81.18 196.13 202.16l1.05.26c55.25-69.92 140.88-128.05 236.99-128.05 80.92 0 130.15 42.16 130.15 80.39 0 18.33-6.55 33.52-22.26 46.35 0 .96-.2.79.79.79 14.66-10.74 27.5-28.8 27.5-48.18 0-22.78-12.05-38.23-12.05-38.23 7.07 7.07 10.74 16.24 10.74 16.24 5.76-40.85 26.97-62.32 26.97-62.32-2.36-9.69-6.81-17.81-6.81-17.81 7.59 8.12 14.4 27.5 14.4 41.37 0 10.47-3.4 22.78-12.57 31.95l.26.52c8.12-4.98 16.5-16.76 16.5-37.97 0-15.71-4.71-25.92-4.71-25.92 5.76-5.24 11.26-9.17 15.97-11.78.79 3.4 2.09 9.69 2.36 14.93 0 1.05.79 1.83 1.05 0 .79-5.76-.26-16.24-.26-16.5 6.02-3.14 9.69-4.45 9.69-4.45C617.74 176 489.43 89.32 342.26 89.32zm-99.24 289.62c-11.06 8.99-24.2 4.08-30.64-4.19-7.45-9.58-6.76-24.09 4.19-32.47 14.85-11.35 27.08-.49 31.16 5.5.28.39 12.13 16.57-4.71 31.16zm2.09-136.43l9.43-17.81 11.78 70.96-12.57 6.02-24.62-28.8 14.14-26.71 3.67 4.45-1.83-8.11zm18.59 117.58l-.26-.26c2.05-4.1-2.5-6.61-17.54-31.69-1.31-2.36-3.14-2.88-4.45-2.62l-.26-.52c7.86-5.76 15.45-10.21 25.4-15.71l.52.26c1.31 1.83 2.09 2.88 3.4 4.71l-.26.52c-1.05-.26-2.36-.79-5.24.26-2.09.79-7.86 3.67-12.31 7.59v1.31c1.57 2.36 3.93 6.55 5.76 9.69h.26c10.05-6.28 7.56-4.55 11.52-7.86h.26c.52 1.83.52 1.83 1.83 5.5l-.26.26c-3.06.61-4.65.34-11.52 5.5v.26c9.46 17.02 11.01 16.75 12.57 15.97l.26.26c-2.34 1.59-6.27 4.21-9.68 6.57zm55.26-32.47c-3.14 1.57-6.02 2.88-9.95 4.98l-.26-.26c1.29-2.59 1.16-2.71-11.78-32.47l-.26-.26c-.15 0-8.9 3.65-9.95 7.33h-.52l-1.05-5.76.26-.52c7.29-4.56 25.53-11.64 27.76-12.57l.52.26 3.14 4.98-.26.52c-3.53-1.76-7.35.76-12.31 2.62v.26c12.31 32.01 12.67 30.64 14.66 30.64v.25zm44.77-16.5c-4.19 1.05-5.24 1.31-9.69 2.88l-.26-.26.52-4.45c-1.05-3.4-3.14-11.52-3.67-13.62l-.26-.26c-3.4.79-8.9 2.62-12.83 3.93l-.26.26c.79 2.62 3.14 9.95 4.19 13.88.79 2.36 1.83 2.88 2.88 3.14v.52c-3.67 1.05-7.07 2.62-10.21 3.93l-.26-.26c1.05-1.31 1.05-2.88.26-4.98-1.05-3.14-8.12-23.83-9.17-27.23-.52-1.83-1.57-3.14-2.62-3.14v-.52c3.14-1.05 6.02-2.09 10.74-3.4l.26.26-.26 4.71c1.31 3.93 2.36 7.59 3.14 9.69h.26c3.93-1.31 9.43-2.88 12.83-3.93l.26-.26-2.62-9.43c-.52-1.83-1.05-3.4-2.62-3.93v-.26c4.45-1.05 7.33-1.83 10.74-2.36l.26.26c-1.05 1.31-1.05 2.88-.52 4.45 1.57 6.28 4.71 20.43 6.28 26.45.54 2.62 1.85 3.41 2.63 3.93zm32.21-6.81l-.26.26c-4.71.52-14.14 2.36-22.52 4.19l-.26-.26.79-4.19c-1.57-7.86-3.4-18.59-4.98-26.19-.26-1.83-.79-2.88-2.62-3.67l.79-.52c9.17-1.57 20.16-2.36 24.88-2.62l.26.26c.52 2.36.79 3.14 1.57 5.5l-.26.26c-1.14-1.14-3.34-3.2-16.24-.79l-.26.26c.26 1.57 1.05 6.55 1.57 9.95l.26.26c9.52-1.68 4.76-.06 10.74-2.36h.26c0 1.57-.26 1.83-.26 5.24h-.26c-4.81-1.03-2.15-.9-10.21 0l-.26.26c.26 2.09 1.57 9.43 2.09 12.57l.26.26c1.15.38 14.21-.65 16.24-4.71h.26c-.53 2.38-1.05 4.21-1.58 6.04zm10.74-44.51c-4.45 2.36-8.12 2.88-11 2.88-.25.02-11.41 1.09-17.54-9.95-6.74-10.79-.98-25.2 5.5-31.69 8.8-8.12 23.35-10.1 28.54-17.02 8.03-10.33-13.04-22.31-29.59-5.76l-2.62-2.88 5.24-16.24c25.59-1.57 45.2-3.04 50.02 16.24.79 3.14 0 9.43-.26 12.05 0 2.62-1.83 18.85-2.09 23.04-.52 4.19-.79 18.33-.79 20.69.26 2.36.52 4.19 1.57 5.5 1.57 1.83 5.76 1.83 5.76 1.83l-.79 4.71c-11.82-1.07-10.28-.59-20.43-1.05-3.22-5.15-2.23-3.28-4.19-7.86 0 .01-4.19 3.94-7.33 5.51zm37.18 21.21c-6.35-10.58-19.82-7.16-21.73 5.5-2.63 17.08 14.3 19.79 20.69 10.21l.26.26c-.52 1.83-1.83 6.02-1.83 6.28l-.52.52c-10.3 6.87-28.5-2.5-25.66-18.59 1.94-10.87 14.44-18.93 28.8-9.95l.26.52c0 1.06-.27 3.41-.27 5.25zm5.77-87.73v-6.55c.69 0 19.65 3.28 27.76 7.33l-1.57 17.54s10.21-9.43 15.45-10.74c5.24-1.57 14.93 7.33 14.93 7.33l-11.26 11.26c-12.07-6.35-19.59-.08-20.69.79-5.29 38.72-8.6 42.17 4.45 46.09l-.52 4.71c-17.55-4.29-18.53-4.5-36.92-7.33l.79-4.71c7.25 0 7.48-5.32 7.59-6.81 0 0 4.98-53.16 4.98-55.25-.02-2.87-4.99-3.66-4.99-3.66zm10.99 114.44c-8.12-2.09-14.14-11-10.74-20.69 3.14-9.43 12.31-12.31 18.85-10.21 9.17 2.62 12.83 11.78 10.74 19.38-2.61 8.9-9.42 13.87-18.85 11.52zm42.16 9.69c-2.36-.52-7.07-2.36-8.64-2.88v-.26l1.57-1.83c.59-8.24.59-7.27.26-7.59-4.82-1.81-6.66-2.36-7.07-2.36-1.31 1.83-2.88 4.45-3.67 5.5l-.79 3.4v.26c-1.31-.26-3.93-1.31-6.02-1.57v-.26l2.62-1.83c3.4-4.71 9.95-14.14 13.88-20.16v-2.09l.52-.26c2.09.79 5.5 2.09 7.59 2.88.48.48.18-1.87-1.05 25.14-.24 1.81.02 2.6.8 3.91zm-4.71-89.82c11.25-18.27 30.76-16.19 34.04-3.4L539.7 198c2.34-6.25-2.82-9.9-4.45-11.26l1.83-3.67c12.22 10.37 16.38 13.97 22.52 20.43-25.91 73.07-30.76 80.81-24.62 84.32l-1.83 4.45c-6.37-3.35-8.9-4.42-17.81-8.64l2.09-6.81c-.26-.26-3.93 3.93-9.69 3.67-19.06-1.3-22.89-31.75-9.67-52.9zm29.33 79.34c0-5.71-6.34-7.89-7.86-5.24-1.31 2.09 1.05 4.98 2.88 8.38 1.57 2.62 2.62 6.28 1.05 9.43-2.64 6.34-12.4 5.31-15.45-.79 0-.7-.27.09 1.83-4.71l.79-.26c-.57 5.66 6.06 9.61 8.38 4.98 1.05-2.09-.52-5.5-2.09-8.38-1.57-2.62-3.67-6.28-1.83-9.69 2.72-5.06 11.25-4.47 14.66 2.36v.52l-2.36 3.4zm21.21 13.36c-1.96-3.27-.91-2.14-4.45-4.71h-.26c-2.36 4.19-5.76 10.47-8.64 16.24-1.31 2.36-1.05 3.4-.79 3.93l-.26.26-5.76-4.45.26-.26 2.09-1.31c3.14-5.76 6.55-12.05 9.17-17.02v-.26c-2.64-1.98-1.22-1.51-6.02-1.83v-.26l3.14-3.4h.26c3.67 2.36 9.95 6.81 12.31 8.9l.26.26-1.31 3.91zm27.23-44.26l-2.88-2.88c.79-2.36 1.83-4.98 2.09-7.59.75-9.74-11.52-11.84-11.52-4.98 0 4.98 7.86 19.38 7.86 27.76 0 10.21-5.76 15.71-13.88 16.5-8.38.79-20.16-10.47-20.16-10.47l4.98-14.4 2.88 2.09c-2.97 17.8 17.68 20.37 13.35 5.24-1.06-4.02-18.75-34.2 2.09-38.23 13.62-2.36 23.04 16.5 23.04 16.5l-7.85 10.46zm35.62-10.21c-11-30.38-60.49-127.53-191.95-129.62-53.42-1.05-94.27 15.45-132.76 37.97l85.63-9.17-91.39 20.69 25.14 19.64-3.93-16.5c7.5-1.71 39.15-8.45 66.77-8.9l-22.26 80.39c13.61-.7 18.97-8.98 19.64-22.78l4.98-1.05.26 26.71c-22.46 3.21-37.3 6.69-49.49 9.95l13.09-43.21-61.54-36.66 2.36 8.12 10.21 4.98c6.28 18.59 19.38 56.56 20.43 58.66 1.95 4.28 3.16 5.78 12.05 4.45l1.05 4.98c-16.08 4.86-23.66 7.61-39.02 14.4l-2.36-4.71c4.4-2.94 8.73-3.94 5.5-12.83-23.7-62.5-21.48-58.14-22.78-59.44l2.36-4.45 33.52 67.3c-3.84-11.87 1.68 1.69-32.99-78.82l-41.9 88.51 4.71-13.88-35.88-42.16 27.76 93.48-11.78 8.38C95 228.58 101.05 231.87 93.23 231.52c-5.5-.26-13.62 5.5-13.62 5.5L74.63 231c30.56-23.53 31.62-24.33 58.4-42.68l4.19 7.07s-5.76 4.19-7.86 7.07c-5.9 9.28 1.67 13.28 61.8 75.68l-18.85-58.92 39.8-10.21 25.66 30.64 4.45-12.31-4.98-24.62 13.09-3.4.52 3.14 3.67-10.47-94.27 29.33 11.26-4.98-13.62-42.42 17.28-9.17 30.11 36.14 28.54-13.09c-1.41-7.47-2.47-14.5-4.71-19.64l17.28 13.88 4.71-2.09-59.18-42.68 23.08 11.5c18.98-6.07 25.23-7.47 32.21-9.69l2.62 11c-12.55 12.55 1.43 16.82 6.55 19.38l-13.62-61.01 12.05 28.28c4.19-1.31 7.33-2.09 7.33-2.09l2.62 8.64s-3.14 1.05-6.28 2.09l8.9 20.95 33.78-65.73-20.69 61.01c42.42-24.09 81.44-36.66 131.98-35.88 67.04 1.05 167.33 40.85 199.8 139.83.78 2.1-.01 2.63-.79.27zM203.48 152.43s1.83-.52 4.19-1.31l9.43 7.59c-.4 0-3.44-.25-11.26 2.36l-2.36-8.64zm143.76 38.5c-1.57-.6-26.46-4.81-33.26 20.69l21.73 17.02 11.53-37.71zM318.43 67.07c-58.4 0-106.05 12.05-114.96 14.4v.79c8.38 2.09 14.4 4.19 21.21 11.78l1.57.26c6.55-1.83 48.97-13.88 110.24-13.88 180.16 0 301.67 116.79 301.67 223.37v9.95c0 1.31.79 2.62 1.05.52.52-2.09.79-8.64.79-19.64.26-83.79-96.63-227.55-321.57-227.55zm211.06 169.68c1.31-5.76 0-12.31-7.33-13.09-9.62-1.13-16.14 23.79-17.02 33.52-.79 5.5-1.31 14.93 6.02 14.93 4.68-.01 9.72-.91 18.33-35.36zm-61.53 42.95c-2.62-.79-9.43-.79-12.57 10.47-1.83 6.81.52 13.35 6.02 14.66 3.67 1.05 8.9.52 11.78-10.74 2.62-9.94-1.83-13.61-5.23-14.39zM491 300.65c1.83.52 3.14 1.05 5.76 1.83 0-1.83.52-8.38.79-12.05-1.05 1.31-5.5 8.12-6.55 9.95v.27z"
    ]
};
var $ef0249c5e48bf4e3$export$d20d4c95d5790834 = {
    prefix: "fab",
    iconName: "square-viadeo",
    icon: [
        448,
        512,
        [
            "viadeo-square"
        ],
        "f2aa",
        "M448 96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96zM118.3 381.2c-68-73.6-19.8-196.1 81.2-196.1c13.3 0 26.6 2.1 39.1 6.7c-4.3 8.4-7.3 17.6-8.4 27.1c-9.7-4.1-20.2-6-30.7-6c-48.8 0-84.6 41.7-84.6 88.9c0 43 28.5 78.7 69.5 85.9c61.5-24 72.9-117.6 72.9-175v0c0-7.3 0-14.8-.6-22.1c-11.2-32.9-26.6-64.6-44.2-94.5c27.1 18.3 41.9 62.5 44.2 94.1v.4c7.7 22.5 11.8 46.2 11.8 70c0 54.1-21.9 99-68.3 128.2l-2.4 .2c50 1 86.2-38.6 86.2-87.2c0-12.2-2.1-24.3-6.9-35.7c9.5-1.9 18.5-5.6 26.4-10.5c15.3 36.6 12.6 87.3-22.8 125.6c-42.4 46.2-120 46.6-162.4 0zM274.6 217.6c21.9-12 49.6-30.7 62.3-53c1.5-3 4.1-8.6 4.5-12c-12.5 27.9-44.2 49.8-73.9 56.7c-4.7-7.3-7.5-15.5-7.5-24.3c0-10.3 5.2-24.1 12.9-31.6c8.3-7.9 18-10.9 27.9-14.1c16-5.1 32.5-10.3 44.5-35.9c32.5 46.2 13.1 130.3-36.3 130.3c-13.3 0-25.1-7.1-34.4-16.1z"
    ]
};
var $ef0249c5e48bf4e3$export$46c94e3313db0253 = $ef0249c5e48bf4e3$export$d20d4c95d5790834;
var $ef0249c5e48bf4e3$export$61e6f6fcefd81d6e = {
    prefix: "fab",
    iconName: "meetup",
    icon: [
        512,
        512,
        [],
        "f2e0",
        "M99 414.3c1.1 5.7-2.3 11.1-8 12.3-5.4 1.1-10.9-2.3-12-8-1.1-5.4 2.3-11.1 7.7-12.3 5.4-1.2 11.1 2.3 12.3 8zm143.1 71.4c-6.3 4.6-8 13.4-3.7 20 4.6 6.6 13.4 8.3 20 3.7 6.3-4.6 8-13.4 3.4-20-4.2-6.5-13.1-8.3-19.7-3.7zm-86-462.3c6.3-1.4 10.3-7.7 8.9-14-1.1-6.6-7.4-10.6-13.7-9.1-6.3 1.4-10.3 7.7-9.1 14 1.4 6.6 7.6 10.6 13.9 9.1zM34.4 226.3c-10-6.9-23.7-4.3-30.6 6-6.9 10-4.3 24 5.7 30.9 10 7.1 23.7 4.6 30.6-5.7 6.9-10.4 4.3-24.1-5.7-31.2zm272-170.9c10.6-6.3 13.7-20 7.7-30.3-6.3-10.6-19.7-14-30-7.7s-13.7 20-7.4 30.6c6 10.3 19.4 13.7 29.7 7.4zm-191.1 58c7.7-5.4 9.4-16 4.3-23.7s-15.7-9.4-23.1-4.3c-7.7 5.4-9.4 16-4.3 23.7 5.1 7.8 15.6 9.5 23.1 4.3zm372.3 156c-7.4 1.7-12.3 9.1-10.6 16.9 1.4 7.4 8.9 12.3 16.3 10.6 7.4-1.4 12.3-8.9 10.6-16.6-1.5-7.4-8.9-12.3-16.3-10.9zm39.7-56.8c-1.1-5.7-6.6-9.1-12-8-5.7 1.1-9.1 6.9-8 12.6 1.1 5.4 6.6 9.1 12.3 8 5.4-1.5 9.1-6.9 7.7-12.6zM447 138.9c-8.6 6-10.6 17.7-4.9 26.3 5.7 8.6 17.4 10.6 26 4.9 8.3-6 10.3-17.7 4.6-26.3-5.7-8.7-17.4-10.9-25.7-4.9zm-6.3 139.4c26.3 43.1 15.1 100-26.3 129.1-17.4 12.3-37.1 17.7-56.9 17.1-12 47.1-69.4 64.6-105.1 32.6-1.1.9-2.6 1.7-3.7 2.9-39.1 27.1-92.3 17.4-119.4-22.3-9.7-14.3-14.6-30.6-15.1-46.9-65.4-10.9-90-94-41.1-139.7-28.3-46.9.6-107.4 53.4-114.9C151.6 70 234.1 38.6 290.1 82c67.4-22.3 136.3 29.4 130.9 101.1 41.1 12.6 52.8 66.9 19.7 95.2zm-70 74.3c-3.1-20.6-40.9-4.6-43.1-27.1-3.1-32 43.7-101.1 40-128-3.4-24-19.4-29.1-33.4-29.4-13.4-.3-16.9 2-21.4 4.6-2.9 1.7-6.6 4.9-11.7-.3-6.3-6-11.1-11.7-19.4-12.9-12.3-2-17.7 2-26.6 9.7-3.4 2.9-12 12.9-20 9.1-3.4-1.7-15.4-7.7-24-11.4-16.3-7.1-40 4.6-48.6 20-12.9 22.9-38 113.1-41.7 125.1-8.6 26.6 10.9 48.6 36.9 47.1 11.1-.6 18.3-4.6 25.4-17.4 4-7.4 41.7-107.7 44.6-112.6 2-3.4 8.9-8 14.6-5.1 5.7 3.1 6.9 9.4 6 15.1-1.1 9.7-28 70.9-28.9 77.7-3.4 22.9 26.9 26.6 38.6 4 3.7-7.1 45.7-92.6 49.4-98.3 4.3-6.3 7.4-8.3 11.7-8 3.1 0 8.3.9 7.1 10.9-1.4 9.4-35.1 72.3-38.9 87.7-4.6 20.6 6.6 41.4 24.9 50.6 11.4 5.7 62.5 15.7 58.5-11.1zm5.7 92.3c-10.3 7.4-12.9 22-5.7 32.6 7.1 10.6 21.4 13.1 32 6 10.6-7.4 13.1-22 6-32.6-7.4-10.6-21.7-13.5-32.3-6z"
    ]
};
var $ef0249c5e48bf4e3$export$47b9420154e916ca = {
    prefix: "fab",
    iconName: "centos",
    icon: [
        448,
        512,
        [],
        "f789",
        "M289.6 97.5l31.6 31.7-76.3 76.5V97.5zm-162.4 31.7l76.3 76.5V97.5h-44.7zm41.5-41.6h44.7v127.9l10.8 10.8 10.8-10.8V87.6h44.7L224.2 32zm26.2 168.1l-10.8-10.8H55.5v-44.8L0 255.7l55.5 55.6v-44.8h128.6l10.8-10.8zm79.3-20.7h107.9v-44.8l-31.6-31.7zm173.3 20.7L392 200.1v44.8H264.3l-10.8 10.8 10.8 10.8H392v44.8l55.5-55.6zM65.4 176.2l32.5-31.7 90.3 90.5h15.3v-15.3l-90.3-90.5 31.6-31.7H65.4zm316.7-78.7h-78.5l31.6 31.7-90.3 90.5V235h15.3l90.3-90.5 31.6 31.7zM203.5 413.9V305.8l-76.3 76.5 31.6 31.7h44.7zM65.4 235h108.8l-76.3-76.5-32.5 31.7zm316.7 100.2l-31.6 31.7-90.3-90.5h-15.3v15.3l90.3 90.5-31.6 31.7h78.5zm0-58.8H274.2l76.3 76.5 31.6-31.7zm-60.9 105.8l-76.3-76.5v108.1h44.7zM97.9 352.9l76.3-76.5H65.4v44.8zm181.8 70.9H235V295.9l-10.8-10.8-10.8 10.8v127.9h-44.7l55.5 55.6zm-166.5-41.6l90.3-90.5v-15.3h-15.3l-90.3 90.5-32.5-31.7v78.7h79.4z"
    ]
};
var $ef0249c5e48bf4e3$export$64d8cc39326ee7a8 = {
    prefix: "fab",
    iconName: "adn",
    icon: [
        496,
        512,
        [],
        "f170",
        "M248 167.5l64.9 98.8H183.1l64.9-98.8zM496 256c0 136.9-111.1 248-248 248S0 392.9 0 256 111.1 8 248 8s248 111.1 248 248zm-99.8 82.7L248 115.5 99.8 338.7h30.4l33.6-51.7h168.6l33.6 51.7h30.2z"
    ]
};
var $ef0249c5e48bf4e3$export$616a6b084ab35801 = {
    prefix: "fab",
    iconName: "cloudsmith",
    icon: [
        512,
        512,
        [],
        "f384",
        "M512 227.6v56.9L284.4 512H227.6L0 284.4V227.6L227.6 0h56.9L512 227.6zm-256 162a133.6 133.6 0 1 0 0-267.1 133.6 133.6 0 1 0 0 267.1z"
    ]
};
var $ef0249c5e48bf4e3$export$d668d8d9da44b43e = {
    prefix: "fab",
    iconName: "opensuse",
    icon: [
        640,
        512,
        [],
        "e62b",
        "M471.1 102.7s-.3 18.3-.3 20.3c-9.1-3-74.4-24.1-135.7-26.3c-51.9-1.8-122.8-4.3-223 57.3c-19.4 12.4-73.9 46.1-99.6 109.7C7 277-.1 307 7 335.1c3.3 12.8 8.9 24.9 16.5 35.7c17.4 25 46.6 41.6 78.1 44.4c44.4 3.9 78.1-16 90-53.3c8.2-25.8 0-63.6-31.5-82.9c-25.6-15.7-53.3-12.1-69.2-1.6c-13.9 9.2-21.8 23.5-21.6 39.2c.3 27.8 24.3 42.6 41.5 42.6c5.4 0 10.7-.9 15.8-2.7c6.5-1.8 13.3-6.5 13.3-14.9c0-12.1-11.6-14.8-16.8-13.9c-2.9 .5-4.5 2-11.8 2.4c-2-.2-12-3.1-12-14V316c.2-12.3 13.2-18 25.5-16.9c32.3 2.8 47.7 40.7 28.5 65.7C135 388.5 76.7 388 53.6 344.4c-26-49.2 12.7-111.2 87-98.4c33.2 5.7 83.6 35.5 102.4 104.3h45.9c-5.7-17.6-8.9-68.3 42.7-68.3c56.7 0 63.9 39.9 79.8 68.3H460c-12.8-18.3-21.7-38.7-18.9-55.8c5.6-33.8 39.7-18.4 82.4-17.4c66.5 .4 102.1-27 103.1-28c3.7-3.1 6.5-15.8 7-17.7c1.3-5.1-3.2-2.4-3.2-2.4c-8.7 5.2-30.5 15.2-50.9 15.6c-25.3 .5-76.2-25.4-81.6-28.2c-.3-.4 .1 1.2-11-25.5c88.4 58.3 118.3 40.5 145.2 21.7c.8-.6 4.3-2.9 3.6-5.7c-13.8-48.1-22.4-62.7-34.5-69.6c-37-21.6-125-34.7-129.2-35.3c.1-.1-.9-.3-.9 .7l0 0zm135.6 75.4a37.6 37.6 0 1 1 -75.2-2.6 37.6 37.6 0 1 1 75.2 2.6zm-36.6-27.9a26.3 26.3 0 1 0 -1.7 52.5 26.3 26.3 0 1 0 1.7-52.5zm4.3 28.8c-15.4 0-15.4-15.6 0-15.6s15.4 15.6 0 15.6v0z"
    ]
};
var $ef0249c5e48bf4e3$export$ef7de58d3fe843ba = {
    prefix: "fab",
    iconName: "pied-piper-alt",
    icon: [
        576,
        512,
        [],
        "f1a8",
        "M244 246c-3.2-2-6.3-2.9-10.1-2.9-6.6 0-12.6 3.2-19.3 3.7l1.7 4.9zm135.9 197.9c-19 0-64.1 9.5-79.9 19.8l6.9 45.1c35.7 6.1 70.1 3.6 106-9.8-4.8-10-23.5-55.1-33-55.1zM340.8 177c6.6 2.8 11.5 9.2 22.7 22.1 2-1.4 7.5-5.2 7.5-8.6 0-4.9-11.8-13.2-13.2-23 11.2-5.7 25.2-6 37.6-8.9 68.1-16.4 116.3-52.9 146.8-116.7C548.3 29.3 554 16.1 554.6 2l-2 2.6c-28.4 50-33 63.2-81.3 100-31.9 24.4-69.2 40.2-106.6 54.6l-6.3-.3v-21.8c-19.6 1.6-19.7-14.6-31.6-23-18.7 20.6-31.6 40.8-58.9 51.1-12.7 4.8-19.6 10-25.9 21.8 34.9-16.4 91.2-13.5 98.8-10zM555.5 0l-.6 1.1-.3.9.6-.6zm-59.2 382.1c-33.9-56.9-75.3-118.4-150-115.5l-.3-6c-1.1-13.5 32.8 3.2 35.1-31l-14.4 7.2c-19.8-45.7-8.6-54.3-65.5-54.3-14.7 0-26.7 1.7-41.4 4.6 2.9 18.6 2.2 36.7-10.9 50.3l19.5 5.5c-1.7 3.2-2.9 6.3-2.9 9.8 0 21 42.8 2.9 42.8 33.6 0 18.4-36.8 60.1-54.9 60.1-8 0-53.7-50-53.4-60.1l.3-4.6 52.3-11.5c13-2.6 12.3-22.7-2.9-22.7-3.7 0-43.1 9.2-49.4 10.6-2-5.2-7.5-14.1-13.8-14.1-3.2 0-6.3 3.2-9.5 4-9.2 2.6-31 2.9-21.5 20.1L15.9 298.5c-5.5 1.1-8.9 6.3-8.9 11.8 0 6 5.5 10.9 11.5 10.9 8 0 131.3-28.4 147.4-32.2 2.6 3.2 4.6 6.3 7.8 8.6 20.1 14.4 59.8 85.9 76.4 85.9 24.1 0 58-22.4 71.3-41.9 3.2-4.3 6.9-7.5 12.4-6.9.6 13.8-31.6 34.2-33 43.7-1.4 10.2-1 35.2-.3 41.1 26.7 8.1 52-3.6 77.9-2.9 4.3-21 10.6-41.9 9.8-63.5l-.3-9.5c-1.4-34.2-10.9-38.5-34.8-58.6-1.1-1.1-2.6-2.6-3.7-4 2.2-1.4 1.1-1 4.6-1.7 88.5 0 56.3 183.6 111.5 229.9 33.1-15 72.5-27.9 103.5-47.2-29-25.6-52.6-45.7-72.7-79.9zm-196.2 46.1v27.2l11.8-3.4-2.9-23.8zm-68.7-150.4l24.1 61.2 21-13.8-31.3-50.9zm84.4 154.9l2 12.4c9-1.5 58.4-6.6 58.4-14.1 0-1.4-.6-3.2-.9-4.6-26.8 0-36.9 3.8-59.5 6.3z"
    ]
};
var $ef0249c5e48bf4e3$export$fc95d67ac3aa8c53 = {
    prefix: "fab",
    iconName: "square-dribbble",
    icon: [
        448,
        512,
        [
            "dribbble-square"
        ],
        "f397",
        "M165.9 132.5c-38.3 18-66.8 53.3-75.7 95.7c6.1 .1 62.4 .3 126.4-16.7c-22.7-40.2-47.1-74.1-50.7-79zm26.1-9.1c3.8 5.1 28.6 38.9 51 80c48.6-18.3 69.1-45.9 71.6-49.4C281 124.2 235.3 112.9 192 123.4zM277.4 382c-2-12-10-53.8-29.2-103.6c-55.1 18.8-93.8 56.4-108.1 85.6c40.5 31.6 93.3 36.7 137.3 18zM227.8 232.6C159.6 253 93.4 252.2 87.4 252c0 .7 0 1.4 0 2.1s0 1.4 0 2.1c0 35.1 13.3 67.1 35.1 91.4c22.2-37.9 67.1-77.9 116.5-91.8c-3.4-7.8-7.2-15.5-11.1-23.2zm72.5 136.9c30.7-20.7 52.5-53.6 58.6-91.6c-4.6-1.5-42.3-12.7-85.1-5.8c17.9 49.1 25.1 89.1 26.5 97.4zm-34.8-119c45.5-5.7 90.7 3.4 95.2 4.4c-.3-32.3-11.8-61.9-30.9-85.1c-2.9 3.9-25.8 33.2-76.3 53.9c4.8 9.8 8.3 17.8 12 26.8zM384 32H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64zM224 416a160 160 0 1 1 0-320 160 160 0 1 1 0 320z"
    ]
};
var $ef0249c5e48bf4e3$export$ff55221913bb3cd0 = $ef0249c5e48bf4e3$export$fc95d67ac3aa8c53;
var $ef0249c5e48bf4e3$export$248fddd2c856e8cc = {
    prefix: "fab",
    iconName: "codiepie",
    icon: [
        472,
        512,
        [],
        "f284",
        "M422.5 202.9c30.7 0 33.5 53.1-.3 53.1h-10.8v44.3h-26.6v-97.4h37.7zM472 352.6C429.9 444.5 350.4 504 248 504 111 504 0 393 0 256S111 8 248 8c97.4 0 172.8 53.7 218.2 138.4l-186 108.8L472 352.6zm-38.5 12.5l-60.3-30.7c-27.1 44.3-70.4 71.4-122.4 71.4-82.5 0-149.2-66.7-149.2-148.9 0-82.5 66.7-149.2 149.2-149.2 48.4 0 88.9 23.5 116.9 63.4l59.5-34.6c-40.7-62.6-104.7-100-179.2-100-121.2 0-219.5 98.3-219.5 219.5S126.8 475.5 248 475.5c78.6 0 146.5-42.1 185.5-110.4z"
    ]
};
var $ef0249c5e48bf4e3$export$4c16416edc1f091a = {
    prefix: "fab",
    iconName: "node",
    icon: [
        640,
        512,
        [],
        "f419",
        "M316.3 452c-2.1 0-4.2-.6-6.1-1.6L291 439c-2.9-1.6-1.5-2.2-.5-2.5 3.8-1.3 4.6-1.6 8.7-4 .4-.2 1-.1 1.4.1l14.8 8.8c.5.3 1.3.3 1.8 0L375 408c.5-.3.9-.9.9-1.6v-66.7c0-.7-.3-1.3-.9-1.6l-57.8-33.3c-.5-.3-1.2-.3-1.8 0l-57.8 33.3c-.6.3-.9 1-.9 1.6v66.7c0 .6.4 1.2.9 1.5l15.8 9.1c8.6 4.3 13.9-.8 13.9-5.8v-65.9c0-.9.7-1.7 1.7-1.7h7.3c.9 0 1.7.7 1.7 1.7v65.9c0 11.5-6.2 18-17.1 18-3.3 0-6 0-13.3-3.6l-15.2-8.7c-3.7-2.2-6.1-6.2-6.1-10.5v-66.7c0-4.3 2.3-8.4 6.1-10.5l57.8-33.4c3.7-2.1 8.5-2.1 12.1 0l57.8 33.4c3.7 2.2 6.1 6.2 6.1 10.5v66.7c0 4.3-2.3 8.4-6.1 10.5l-57.8 33.4c-1.7 1.1-3.8 1.7-6 1.7zm46.7-65.8c0-12.5-8.4-15.8-26.2-18.2-18-2.4-19.8-3.6-19.8-7.8 0-3.5 1.5-8.1 14.8-8.1 11.9 0 16.3 2.6 18.1 10.6.2.8.8 1.3 1.6 1.3h7.5c.5 0 .9-.2 1.2-.5.3-.4.5-.8.4-1.3-1.2-13.8-10.3-20.2-28.8-20.2-16.5 0-26.3 7-26.3 18.6 0 12.7 9.8 16.1 25.6 17.7 18.9 1.9 20.4 4.6 20.4 8.3 0 6.5-5.2 9.2-17.4 9.2-15.3 0-18.7-3.8-19.8-11.4-.1-.8-.8-1.4-1.7-1.4h-7.5c-.9 0-1.7.7-1.7 1.7 0 9.7 5.3 21.3 30.6 21.3 18.5 0 29-7.2 29-19.8zm54.5-50.1c0 6.1-5 11.1-11.1 11.1s-11.1-5-11.1-11.1c0-6.3 5.2-11.1 11.1-11.1 6-.1 11.1 4.8 11.1 11.1zm-1.8 0c0-5.2-4.2-9.3-9.4-9.3-5.1 0-9.3 4.1-9.3 9.3 0 5.2 4.2 9.4 9.3 9.4 5.2-.1 9.4-4.3 9.4-9.4zm-4.5 6.2h-2.6c-.1-.6-.5-3.8-.5-3.9-.2-.7-.4-1.1-1.3-1.1h-2.2v5h-2.4v-12.5h4.3c1.5 0 4.4 0 4.4 3.3 0 2.3-1.5 2.8-2.4 3.1 1.7.1 1.8 1.2 2.1 2.8.1 1 .3 2.7.6 3.3zm-2.8-8.8c0-1.7-1.2-1.7-1.8-1.7h-2v3.5h1.9c1.6 0 1.9-1.1 1.9-1.8zM137.3 191c0-2.7-1.4-5.1-3.7-6.4l-61.3-35.3c-1-.6-2.2-.9-3.4-1h-.6c-1.2 0-2.3.4-3.4 1L3.7 184.6C1.4 185.9 0 188.4 0 191l.1 95c0 1.3.7 2.5 1.8 3.2 1.1.7 2.5.7 3.7 0L42 268.3c2.3-1.4 3.7-3.8 3.7-6.4v-44.4c0-2.6 1.4-5.1 3.7-6.4l15.5-8.9c1.2-.7 2.4-1 3.7-1 1.3 0 2.6.3 3.7 1l15.5 8.9c2.3 1.3 3.7 3.8 3.7 6.4v44.4c0 2.6 1.4 5.1 3.7 6.4l36.4 20.9c1.1.7 2.6.7 3.7 0 1.1-.6 1.8-1.9 1.8-3.2l.2-95zM472.5 87.3v176.4c0 2.6-1.4 5.1-3.7 6.4l-61.3 35.4c-2.3 1.3-5.1 1.3-7.4 0l-61.3-35.4c-2.3-1.3-3.7-3.8-3.7-6.4v-70.8c0-2.6 1.4-5.1 3.7-6.4l61.3-35.4c2.3-1.3 5.1-1.3 7.4 0l15.3 8.8c1.7 1 3.9-.3 3.9-2.2v-94c0-2.8 3-4.6 5.5-3.2l36.5 20.4c2.3 1.2 3.8 3.7 3.8 6.4zm-46 128.9c0-.7-.4-1.3-.9-1.6l-21-12.2c-.6-.3-1.3-.3-1.9 0l-21 12.2c-.6.3-.9.9-.9 1.6v24.3c0 .7.4 1.3.9 1.6l21 12.1c.6.3 1.3.3 1.8 0l21-12.1c.6-.3.9-.9.9-1.6v-24.3zm209.8-.7c2.3-1.3 3.7-3.8 3.7-6.4V192c0-2.6-1.4-5.1-3.7-6.4l-60.9-35.4c-2.3-1.3-5.1-1.3-7.4 0l-61.3 35.4c-2.3 1.3-3.7 3.8-3.7 6.4v70.8c0 2.7 1.4 5.1 3.7 6.4l60.9 34.7c2.2 1.3 5 1.3 7.3 0l36.8-20.5c2.5-1.4 2.5-5 0-6.4L550 241.6c-1.2-.7-1.9-1.9-1.9-3.2v-22.2c0-1.3.7-2.5 1.9-3.2l19.2-11.1c1.1-.7 2.6-.7 3.7 0l19.2 11.1c1.1.7 1.9 1.9 1.9 3.2v17.4c0 2.8 3.1 4.6 5.6 3.2l36.7-21.3zM559 219c-.4.3-.7.7-.7 1.2v13.6c0 .5.3 1 .7 1.2l11.8 6.8c.4.3 1 .3 1.4 0L584 235c.4-.3.7-.7.7-1.2v-13.6c0-.5-.3-1-.7-1.2l-11.8-6.8c-.4-.3-1-.3-1.4 0L559 219zm-254.2 43.5v-70.4c0-2.6-1.6-5.1-3.9-6.4l-61.1-35.2c-2.1-1.2-5-1.4-7.4 0l-61.1 35.2c-2.3 1.3-3.9 3.7-3.9 6.4v70.4c0 2.8 1.9 5.2 4 6.4l61.2 35.2c2.4 1.4 5.2 1.3 7.4 0l61-35.2c1.8-1 3.1-2.7 3.6-4.7.1-.5.2-1.1.2-1.7zm-74.3-124.9l-.8.5h1.1l-.3-.5zm76.2 130.2l-.4-.7v.9l.4-.2z"
    ]
};
var $ef0249c5e48bf4e3$export$4176cb98e090fc09 = {
    prefix: "fab",
    iconName: "mix",
    icon: [
        448,
        512,
        [],
        "f3cb",
        "M0 64v348.9c0 56.2 88 58.1 88 0V174.3c7.9-52.9 88-50.4 88 6.5v175.3c0 57.9 96 58 96 0V240c5.3-54.7 88-52.5 88 4.3v23.8c0 59.9 88 56.6 88 0V64H0z"
    ]
};
var $ef0249c5e48bf4e3$export$7c80ad2689275b29 = {
    prefix: "fab",
    iconName: "steam",
    icon: [
        496,
        512,
        [],
        "f1b6",
        "M496 256c0 137-111.2 248-248.4 248-113.8 0-209.6-76.3-239-180.4l95.2 39.3c6.4 32.1 34.9 56.4 68.9 56.4 39.2 0 71.9-32.4 70.2-73.5l84.5-60.2c52.1 1.3 95.8-40.9 95.8-93.5 0-51.6-42-93.5-93.7-93.5s-93.7 42-93.7 93.5v1.2L176.6 279c-15.5-.9-30.7 3.4-43.5 12.1L0 236.1C10.2 108.4 117.1 8 247.6 8 384.8 8 496 119 496 256zM155.7 384.3l-30.5-12.6a52.79 52.79 0 0 0 27.2 25.8c26.9 11.2 57.8-1.6 69-28.4 5.4-13 5.5-27.3.1-40.3-5.4-13-15.5-23.2-28.5-28.6-12.9-5.4-26.7-5.2-38.9-.6l31.5 13c19.8 8.2 29.2 30.9 20.9 50.7-8.3 19.9-31 29.2-50.8 21zm173.8-129.9c-34.4 0-62.4-28-62.4-62.3s28-62.3 62.4-62.3 62.4 28 62.4 62.3-27.9 62.3-62.4 62.3zm.1-15.6c25.9 0 46.9-21 46.9-46.8 0-25.9-21-46.8-46.9-46.8s-46.9 21-46.9 46.8c.1 25.8 21.1 46.8 46.9 46.8z"
    ]
};
var $ef0249c5e48bf4e3$export$37af1170a8e0c21b = {
    prefix: "fab",
    iconName: "cc-apple-pay",
    icon: [
        576,
        512,
        [],
        "f416",
        "M302.2 218.4c0 17.2-10.5 27.1-29 27.1h-24.3v-54.2h24.4c18.4 0 28.9 9.8 28.9 27.1zm47.5 62.6c0 8.3 7.2 13.7 18.5 13.7 14.4 0 25.2-9.1 25.2-21.9v-7.7l-23.5 1.5c-13.3.9-20.2 5.8-20.2 14.4zM576 79v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V79c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48zM127.8 197.2c8.4.7 16.8-4.2 22.1-10.4 5.2-6.4 8.6-15 7.7-23.7-7.4.3-16.6 4.9-21.9 11.3-4.8 5.5-8.9 14.4-7.9 22.8zm60.6 74.5c-.2-.2-19.6-7.6-19.8-30-.2-18.7 15.3-27.7 16-28.2-8.8-13-22.4-14.4-27.1-14.7-12.2-.7-22.6 6.9-28.4 6.9-5.9 0-14.7-6.6-24.3-6.4-12.5.2-24.2 7.3-30.5 18.6-13.1 22.6-3.4 56 9.3 74.4 6.2 9.1 13.7 19.1 23.5 18.7 9.3-.4 13-6 24.2-6 11.3 0 14.5 6 24.3 5.9 10.2-.2 16.5-9.1 22.8-18.2 6.9-10.4 9.8-20.4 10-21zm135.4-53.4c0-26.6-18.5-44.8-44.9-44.8h-51.2v136.4h21.2v-46.6h29.3c26.8 0 45.6-18.4 45.6-45zm90 23.7c0-19.7-15.8-32.4-40-32.4-22.5 0-39.1 12.9-39.7 30.5h19.1c1.6-8.4 9.4-13.9 20-13.9 13 0 20.2 6 20.2 17.2v7.5l-26.4 1.6c-24.6 1.5-37.9 11.6-37.9 29.1 0 17.7 13.7 29.4 33.4 29.4 13.3 0 25.6-6.7 31.2-17.4h.4V310h19.6v-68zM516 210.9h-21.5l-24.9 80.6h-.4l-24.9-80.6H422l35.9 99.3-1.9 6c-3.2 10.2-8.5 14.2-17.9 14.2-1.7 0-4.9-.2-6.2-.3v16.4c1.2.4 6.5.5 8.1.5 20.7 0 30.4-7.9 38.9-31.8L516 210.9z"
    ]
};
var $ef0249c5e48bf4e3$export$d271dfaa2c63aec5 = {
    prefix: "fab",
    iconName: "scribd",
    icon: [
        384,
        512,
        [],
        "f28a",
        "M42.3 252.7c-16.1-19-24.7-45.9-24.8-79.9 0-100.4 75.2-153.1 167.2-153.1 98.6-1.6 156.8 49 184.3 70.6l-50.5 72.1-37.3-24.6 26.9-38.6c-36.5-24-79.4-36.5-123-35.8-50.7-.8-111.7 27.2-111.7 76.2 0 18.7 11.2 20.7 28.6 15.6 23.3-5.3 41.9.6 55.8 14 26.4 24.3 23.2 67.6-.7 91.9-29.2 29.5-85.2 27.3-114.8-8.4zm317.7 5.9c-15.5-18.8-38.9-29.4-63.2-28.6-38.1-2-71.1 28-70.5 67.2-.7 16.8 6 33 18.4 44.3 14.1 13.9 33 19.7 56.3 14.4 17.4-5.1 28.6-3.1 28.6 15.6 0 4.3-.5 8.5-1.4 12.7-16.7 40.9-59.5 64.4-121.4 64.4-51.9.2-102.4-16.4-144.1-47.3l33.7-39.4-35.6-27.4L0 406.3l15.4 13.8c52.5 46.8 120.4 72.5 190.7 72.2 51.4 0 94.4-10.5 133.6-44.1 57.1-51.4 54.2-149.2 20.3-189.6z"
    ]
};
var $ef0249c5e48bf4e3$export$b30079bac9ebcf2a = {
    prefix: "fab",
    iconName: "debian",
    icon: [
        448,
        512,
        [],
        "e60b",
        "M380.2 245.6c3-7.6 5.5-14 5.2-24.4l-4.3 9c4.4-13.2 4-27.1 3.6-40.4c-.2-6-.3-11.8 0-17.4l-1.8-.5c-1.5-45.2-40.6-93.1-75.3-109.4c-30-13.8-76.1-16.2-97.3-5.8c1.3-1.1 4.2-2 6.8-2.7l.3-.1c3.3-1 6-1.7 4-2.9c-19.2 1.9-24.9 5.5-31.1 9.4l-.1 0c-4.6 2.9-9.5 6-20.3 8.7c-3.5 3.4 1.7 2 5.8 .9l0 0c4.1-1.1 7.2-1.9-.1 2.4c-3.5 1-6.6 1.3-9.6 1.6l-.1 0c-8.3 .8-15.8 1.6-30.7 17c.8 1.3 3.4-.2 5.3-1.3l.1-.1c2.3-1.4 3.4-2-1.7 4.4c-19.1-2.4-60.3 43.7-69.1 59l4.6 .8c-3.2 8-6.8 14.8-10 20.8c-4.3 8.1-7.9 14.9-8.7 21.3c-.3 5.1-1 11-1.7 17.3l0 0c-.1 1-.2 2-.3 3l-.1 .6c-3 27.3-6.7 60.8 3.9 73l-1.3 13c.6 1.2 1.1 2.3 1.6 3.5c.2 .4 .4 .8 .5 1.1l0 0 0 0 0 0 0 0 0 0 0 0 0 0c1 2.1 2 4.2 3.3 6.2l-3 .2c7 22.1 10.8 22.5 15.1 22.9l0 0c4.4 .4 9.3 .9 18.7 24.2c-2.7-.9-5.5-1.9-9.4-7.2c-.5 4.1 5.8 16.3 13.1 25.8l-3.1 3.6c2.1 3.7 4.8 6.2 7.6 8.8l0 0 0 0c1 .9 2.1 1.9 3.1 2.9c-11.9-6.5 3.2 13.7 11.9 25.2c.8 1.1 1.5 2 2.2 2.9l0 0 0 0 0 0 0 0 0 0c1.4 1.9 2.5 3.4 2.9 4.1l2.4-4.2c-.3 6.1 4.3 13.9 13.1 24.7l7.3-.3c3 6 14 16.7 20.7 17.2l-4.4 5.8c8.1 2.6 10.3 4.3 12.7 6.2c2.6 2.1 5.4 4.3 16.1 8.1l-4.2-7.4c3.5 3 6.2 5.9 8.8 8.7l.1 .1c5.2 5.6 9.9 10.6 19.7 15.3c10.7 3.7 16.6 4.7 22.7 5.8c.3 0 .6 .1 .9 .1c5.4 .8 11.2 1.8 20.8 4.5c-1.1-.1-2.2-.1-3.3-.1h0c-2.3-.1-4.7-.1-7-.1l0 0 0 0 0 0 0 0 0 0 0 0 0 0c-14.4-.2-29.2-.4-42.7-5.2C107.8 480.5 19.5 367.2 26 250.6c-.6-9.9-.3-20.9 0-30.7c.4-13.5 .7-24.8-1.6-28.3l1-3.1c5.3-17.4 11.7-38.2 23.8-62.8l-.1-.2v-.1c.4 .4 3.4 3.4 8.8-5.8c.8-1.8 1.6-3.7 2.4-5.6c.5-1.1 .9-2.2 1.4-3.2c2.5-6.1 5.1-12.3 8.4-17.9l2.6-.6c1.7-10.1 17-23.8 29.8-35.2l1.1-1c5.7-5.1 10.7-9.7 13.6-13.1l.7 4.4c17-15.9 44.6-27.5 65.6-36.4l.5-.2c4.8-2 9.3-3.9 13.3-5.7c-3.4 3.8 2.2 2.7 10 1c4.8-1 10.4-2.1 15.3-2.4l-3.9 2.1c-2.7 1.4-5.4 2.8-8 4.6c8.1-2 11.7-1.4 15.7-.8l.3 0c3.5 .6 7.3 1.2 14.6 .2c-5.6 .8-12.3 3-11.2 3.8c7.9 .9 12.8-.1 17.2-1l.2 0c5.5-1.1 10.3-2 19.3 .9l-1-4.8c7.3 2.6 12.7 4.3 17.5 5.8l.5 .1c10 3 17.6 5.3 34.2 14.1c3.2 .2 5.3-.5 7.4-1.2l.1 0c3.6-1.1 7-2.1 15.2 1.2c.3 .5 .5 1 .7 1.4c.1 .2 .2 .5 .3 .7l0 .1c1 2.6 1.8 4.6 14.6 12.1c1.7-.7-2.7-4.7-6.4-8.2c0 0 0 0-.1-.1c-.2-.1-.3-.3-.5-.4c32.2 17.3 67.3 54.1 78 93.5c-6-11.1-5.2-5.5-4.3 .5c.6 4 1.2 8.1-.2 7.5c4.5 12.1 8.1 24.5 10.4 37.4l-.8-2.9-.1-.3c-3.3-11.9-9.6-34.3-19.9-49.3c-.4 4.3-2.8 3.9-5.2 3.5l-.1 0 0 0c-3.3-.6-6.2-1.1-1.9 12.6c2.6 3.8 3.1 2.4 3.5 1.1l0 0c.5-1.5 .9-2.7 4.7 5.2c.1 4.1 1 8.2 2.1 12.7l0 0 0 0 .1 .6c.1 .3 .1 .5 .2 .8l.1 .6c.6 2.6 1.3 5.4 1.8 8.4c-1.1-.2-2.3-2.2-3.4-4.2c-1.4-2.4-2.8-4.7-3.7-3.2c2.4 11.5 6.5 17.4 8 18.3c-.3 .6-.6 .7-1.1 .7c-.8 0-1.8 .1-1.9 5.3c.7 13.7 3.3 12.5 5.3 11.6l0 0c.6-.3 1.2-.6 1.7-.4c-.6 2.5-1.6 5.1-2.7 7.9c-2.8 7.1-6 15.4-3.4 26.1c-.8-3-2-6-3.1-8.9l-.1-.4c-.2-.5-.4-1-.6-1.5l0 0c-.3-.8-.6-1.6-.9-2.3c-.6 4.4-.3 7.7-.1 10.6c0 .2 0 .5 0 .7c.4 5.3 .7 10-3 19.9c4.3-14.2 3.8-26.9-.2-20.8c1 10.9-3.7 20.4-8 28.9l-.1 .2c-3.6 7.1-6.8 13.5-5.9 19.3l-5.2-7.1c-7.5 10.9-7 13.3-6.5 15.5l0 .1c.5 1.9 1 3.8-3.4 10.8c1.7-2.9 1.3-3.6 1-4.2l0 0c-.4-.8-.7-1.5 1.7-5.1c-1.6 .1-5.5 3.9-10.1 8.5c-3.9 3.9-8.5 8.4-12.8 11.8c-37.5 30.1-82.3 34-125.6 17.8c.2-1-.2-2.1-3.1-4.1c-36.8-28.2-58.5-52.1-50.9-107.5c2.1-1.6 3.6-5.8 5.3-10.8l0 0 0 0 .2-.4 .1-.3 0-.1c2.9-8.4 6.5-18.8 14.3-23.8c7.8-17.3 31.3-33.3 56.4-33.7c25.6-1.4 47.2 13.7 58.1 27.9c-19.8-18.4-52.1-24-79.7-10.4c-28.2 12.7-45 43.8-42.5 74.7c.3-.4 .6-.6 .9-.8l0 0s0 0 0 0c0 0 .1-.1 .1-.1l.1-.1c.6-.5 1.1-.9 1.4-3.3c-.9 60.2 64.8 104.3 112.1 82l.6 1.3c12.7-3.5 15.9-6.5 20.3-10.7l.1-.1 0 0c2.2-2.1 4.7-4.5 8.9-7.3c-.3 .7-1.3 1.7-2.4 2.7c-2.2 2.1-4.6 4.5-1.6 4.6c5-1.3 18.5-13.4 28.5-22.3l0 0 0 0c.6-.5 1.2-1 1.7-1.5c1.5-1.3 2.8-2.5 4-3.6l0 0 .3-.3c1.9-4.2 1.6-5.6 1.3-7l0-.1c-.4-1.6-.8-3.3 2.4-9.6l7.3-3.7c.8-2.1 1.5-4.1 2.2-6c.2-.6 .5-1.2 .7-1.8l-.4-.2zM349.3 34.3l-.2-.1 .2 .1 0 0zM247.8 334.1c-6-3-13.7-8.9-14.8-11.4l-.4 .3c-.3 .6-.5 1.3-.2 2.2c-12.2-5.7-23.4-14.3-32.6-24.9c4.9 7.1 10.1 14.1 17 19.5c-6.9-2.3-15.1-11.8-21.6-19.3l-.1-.1c-4.3-5-7.9-9.1-9.7-9.5c19.8 35.5 80.5 62.3 112.3 49c-14.7 .5-33.4 .3-49.9-5.8zm79.3-119.7l-.1-.2c-.5-1.5-1.1-3.1-1.7-3.4c1.4-5.8 5.4-10.7 4.4 4.6c-1 3.8-1.8 1.5-2.6-1zm-4.2 22.2c-1.3 7.9-5 15.5-10.1 22.5c.2-2-1.2-2.4-2.6-2.8l0 0c-2.9-.8-5.9-1.6 5.6-16.1c-.5 1.9-2.1 4.6-3.7 7.3l0 0 0 0-.3 .4c-3.6 5.9-6.7 11 4 4.3l1-1.8c2.6-4.5 5-8.8 6-13.8h.1zm-55.6 33.9c7.1 .6 14.1 .6 21-1.1c-2.5 2.4-5.2 4.8-8.3 7.2c-11.1-1.7-21.2-6-12.7-6.1zm-92.6 11.6c3.6 7.1 6.4 11.5 9 15.7l.1 .2c2.3 3.7 4.4 7.1 6.8 11.7c-5.1-4.2-8.7-9.5-12.5-15l-.3-.5c-1.4-2.1-2.8-4.2-4.4-6.2l1.2-5.9h.1zm7.5-9.6c1.6 3.3 3.2 6.4 5.7 9.1l2.6 7.7-1.3-2.1c-3.2-5.3-6.3-10.6-8-16.7l.8 1.6 .2 .4zm238.9-41.6c-2.3 17.4-7.7 34.6-16 50.3c7.6-14.9 12.5-30.9 14.8-47.2l1.2-3.1zM35.6 110.6c.4 .8 1.4 .5 2.3 .3c1.9-.5 3.6-.9-.1 7.6c-.5 .3-1 .7-1.5 1l0 0 0 0c-1.4 .9-2.8 1.9-3.9 3c1.9-3.8 3.5-7.4 3.2-11.9zM25.3 152.3c-.7 3.7-1.5 7.9-3.4 13.9c.2-1.9 0-3.5-.2-4.9l0-.1c-.4-3.4-.7-6.3 4.3-12.8c-.3 1.2-.5 2.5-.7 3.8v.1z"
    ]
};
var $ef0249c5e48bf4e3$export$b2dcd141e150a391 = {
    prefix: "fab",
    iconName: "openid",
    icon: [
        448,
        512,
        [],
        "f19b",
        "M271.5 432l-68 32C88.5 453.7 0 392.5 0 318.2c0-71.5 82.5-131 191.7-144.3v43c-71.5 12.5-124 53-124 101.3 0 51 58.5 93.3 135.7 103v-340l68-33.2v384zM448 291l-131.3-28.5 36.8-20.7c-19.5-11.5-43.5-20-70-24.8v-43c46.2 5.5 87.7 19.5 120.3 39.3l35-19.8L448 291z"
    ]
};
var $ef0249c5e48bf4e3$export$792bea9ca32c60da = {
    prefix: "fab",
    iconName: "instalod",
    icon: [
        512,
        512,
        [],
        "e081",
        "M153.384,480H387.113L502.554,275.765,204.229,333.211ZM504.726,240.078,387.113,32H155.669L360.23,267.9ZM124.386,48.809,7.274,256,123.236,461.154,225.627,165.561Z"
    ]
};
var $ef0249c5e48bf4e3$export$fe553f3645c5aefa = {
    prefix: "fab",
    iconName: "expeditedssl",
    icon: [
        496,
        512,
        [],
        "f23e",
        "M248 43.4C130.6 43.4 35.4 138.6 35.4 256S130.6 468.6 248 468.6 460.6 373.4 460.6 256 365.4 43.4 248 43.4zm-97.4 132.9c0-53.7 43.7-97.4 97.4-97.4s97.4 43.7 97.4 97.4v26.6c0 5-3.9 8.9-8.9 8.9h-17.7c-5 0-8.9-3.9-8.9-8.9v-26.6c0-82.1-124-82.1-124 0v26.6c0 5-3.9 8.9-8.9 8.9h-17.7c-5 0-8.9-3.9-8.9-8.9v-26.6zM389.7 380c0 9.7-8 17.7-17.7 17.7H124c-9.7 0-17.7-8-17.7-17.7V238.3c0-9.7 8-17.7 17.7-17.7h248c9.7 0 17.7 8 17.7 17.7V380zm-248-137.3v132.9c0 2.5-1.9 4.4-4.4 4.4h-8.9c-2.5 0-4.4-1.9-4.4-4.4V242.7c0-2.5 1.9-4.4 4.4-4.4h8.9c2.5 0 4.4 1.9 4.4 4.4zm141.7 48.7c0 13-7.2 24.4-17.7 30.4v31.6c0 5-3.9 8.9-8.9 8.9h-17.7c-5 0-8.9-3.9-8.9-8.9v-31.6c-10.5-6.1-17.7-17.4-17.7-30.4 0-19.7 15.8-35.4 35.4-35.4s35.5 15.8 35.5 35.4zM248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 478.3C121 486.3 17.7 383 17.7 256S121 25.7 248 25.7 478.3 129 478.3 256 375 486.3 248 486.3z"
    ]
};
var $ef0249c5e48bf4e3$export$23a4f18e8bd9f913 = {
    prefix: "fab",
    iconName: "sellcast",
    icon: [
        448,
        512,
        [],
        "f2da",
        "M353.4 32H94.7C42.6 32 0 74.6 0 126.6v258.7C0 437.4 42.6 480 94.7 480h258.7c52.1 0 94.7-42.6 94.7-94.6V126.6c0-52-42.6-94.6-94.7-94.6zm-50 316.4c-27.9 48.2-89.9 64.9-138.2 37.2-22.9 39.8-54.9 8.6-42.3-13.2l15.7-27.2c5.9-10.3 19.2-13.9 29.5-7.9 18.6 10.8-.1-.1 18.5 10.7 27.6 15.9 63.4 6.3 79.4-21.3 15.9-27.6 6.3-63.4-21.3-79.4-17.8-10.2-.6-.4-18.6-10.6-24.6-14.2-3.4-51.9 21.6-37.5 18.6 10.8-.1-.1 18.5 10.7 48.4 28 65.1 90.3 37.2 138.5zm21.8-208.8c-17 29.5-16.3 28.8-19 31.5-6.5 6.5-16.3 8.7-26.5 3.6-18.6-10.8.1.1-18.5-10.7-27.6-15.9-63.4-6.3-79.4 21.3s-6.3 63.4 21.3 79.4c0 0 18.5 10.6 18.6 10.6 24.6 14.2 3.4 51.9-21.6 37.5-18.6-10.8.1.1-18.5-10.7-48.2-27.8-64.9-90.1-37.1-138.4 27.9-48.2 89.9-64.9 138.2-37.2l4.8-8.4c14.3-24.9 52-3.3 37.7 21.5z"
    ]
};
var $ef0249c5e48bf4e3$export$58fc652e3c488143 = {
    prefix: "fab",
    iconName: "square-twitter",
    icon: [
        448,
        512,
        [
            "twitter-square"
        ],
        "f081",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM351.3 199.3v0c0 86.7-66 186.6-186.6 186.6c-37.2 0-71.7-10.8-100.7-29.4c5.3 .6 10.4 .8 15.8 .8c30.7 0 58.9-10.4 81.4-28c-28.8-.6-53-19.5-61.3-45.5c10.1 1.5 19.2 1.5 29.6-1.2c-30-6.1-52.5-32.5-52.5-64.4v-.8c8.7 4.9 18.9 7.9 29.6 8.3c-9-6-16.4-14.1-21.5-23.6s-7.8-20.2-7.7-31c0-12.2 3.2-23.4 8.9-33.1c32.3 39.8 80.8 65.8 135.2 68.6c-9.3-44.5 24-80.6 64-80.6c18.9 0 35.9 7.9 47.9 20.7c14.8-2.8 29-8.3 41.6-15.8c-4.9 15.2-15.2 28-28.8 36.1c13.2-1.4 26-5.1 37.8-10.2c-8.9 13.1-20.1 24.7-32.9 34c.2 2.8 .2 5.7 .2 8.5z"
    ]
};
var $ef0249c5e48bf4e3$export$270370f3feaf6b90 = $ef0249c5e48bf4e3$export$58fc652e3c488143;
var $ef0249c5e48bf4e3$export$f9a04980ef22b6b0 = {
    prefix: "fab",
    iconName: "r-project",
    icon: [
        581,
        512,
        [],
        "f4f7",
        "M581 226.6C581 119.1 450.9 32 290.5 32S0 119.1 0 226.6C0 322.4 103.3 402 239.4 418.1V480h99.1v-61.5c24.3-2.7 47.6-7.4 69.4-13.9L448 480h112l-67.4-113.7c54.5-35.4 88.4-84.9 88.4-139.7zm-466.8 14.5c0-73.5 98.9-133 220.8-133s211.9 40.7 211.9 133c0 50.1-26.5 85-70.3 106.4-2.4-1.6-4.7-2.9-6.4-3.7-10.2-5.2-27.8-10.5-27.8-10.5s86.6-6.4 86.6-92.7-90.6-87.9-90.6-87.9h-199V361c-74.1-21.5-125.2-67.1-125.2-119.9zm225.1 38.3v-55.6c57.8 0 87.8-6.8 87.8 27.3 0 36.5-38.2 28.3-87.8 28.3zm-.9 72.5H365c10.8 0 18.9 11.7 24 19.2-16.1 1.9-33 2.8-50.6 2.9v-22.1z"
    ]
};
var $ef0249c5e48bf4e3$export$fc15ee5b2eab0af4 = {
    prefix: "fab",
    iconName: "delicious",
    icon: [
        448,
        512,
        [],
        "f1a5",
        "M446.5 68c-.4-1.5-.9-3-1.4-4.5-.9-2.5-2-4.8-3.3-7.1-1.4-2.4-3-4.8-4.7-6.9-2.1-2.5-4.4-4.8-6.9-6.8-1.1-.9-2.2-1.7-3.3-2.5-1.3-.9-2.6-1.7-4-2.4-1.8-1-3.6-1.8-5.5-2.5-1.7-.7-3.5-1.3-5.4-1.7-3.8-1-7.9-1.5-12-1.5H48C21.5 32 0 53.5 0 80v352c0 4.1.5 8.2 1.5 12 2 7.7 5.8 14.6 11 20.3 1 1.1 2.1 2.2 3.3 3.3 5.7 5.2 12.6 9 20.3 11 3.8 1 7.9 1.5 12 1.5h352c26.5 0 48-21.5 48-48V80c-.1-4.1-.6-8.2-1.6-12zM416 432c0 8.8-7.2 16-16 16H224V256H32V80c0-8.8 7.2-16 16-16h176v192h192z"
    ]
};
var $ef0249c5e48bf4e3$export$1fa830857b3a4dc7 = {
    prefix: "fab",
    iconName: "freebsd",
    icon: [
        448,
        512,
        [],
        "f3a4",
        "M303.7 96.2c11.1-11.1 115.5-77 139.2-53.2 23.7 23.7-42.1 128.1-53.2 139.2-11.1 11.1-39.4.9-63.1-22.9-23.8-23.7-34.1-52-22.9-63.1zM109.9 68.1C73.6 47.5 22 24.6 5.6 41.1c-16.6 16.6 7.1 69.4 27.9 105.7 18.5-32.2 44.8-59.3 76.4-78.7zM406.7 174c3.3 11.3 2.7 20.7-2.7 26.1-20.3 20.3-87.5-27-109.3-70.1-18-32.3-11.1-53.4 14.9-48.7 5.7-3.6 12.3-7.6 19.6-11.6-29.8-15.5-63.6-24.3-99.5-24.3-119.1 0-215.6 96.5-215.6 215.6 0 119 96.5 215.6 215.6 215.6S445.3 380.1 445.3 261c0-38.4-10.1-74.5-27.7-105.8-3.9 7-7.6 13.3-10.9 18.8z"
    ]
};
var $ef0249c5e48bf4e3$export$3e0cc9b4555f8145 = {
    prefix: "fab",
    iconName: "vuejs",
    icon: [
        448,
        512,
        [],
        "f41f",
        "M356.9 64.3H280l-56 88.6-48-88.6H0L224 448 448 64.3h-91.1zm-301.2 32h53.8L224 294.5 338.4 96.3h53.8L224 384.5 55.7 96.3z"
    ]
};
var $ef0249c5e48bf4e3$export$233214294e90ff53 = {
    prefix: "fab",
    iconName: "accusoft",
    icon: [
        640,
        512,
        [],
        "f369",
        "M322.1 252v-1l-51.2-65.8s-12 1.6-25 15.1c-9 9.3-242.1 239.1-243.4 240.9-7 10 1.6 6.8 15.7 1.7.8 0 114.5-36.6 114.5-36.6.5-.6-.1-.1.6-.6-.4-5.1-.8-26.2-1-27.7-.6-5.2 2.2-6.9 7-8.9l92.6-33.8c.6-.8 88.5-81.7 90.2-83.3zm160.1 120.1c13.3 16.1 20.7 13.3 30.8 9.3 3.2-1.2 115.4-47.6 117.8-48.9 8-4.3-1.7-16.7-7.2-23.4-2.1-2.5-205.1-245.6-207.2-248.3-9.7-12.2-14.3-12.9-38.4-12.8-10.2 0-106.8.5-116.5.6-19.2.1-32.9-.3-19.2 16.9C250 75 476.5 365.2 482.2 372.1zm152.7 1.6c-2.3-.3-24.6-4.7-38-7.2 0 0-115 50.4-117.5 51.6-16 7.3-26.9-3.2-36.7-14.6l-57.1-74c-5.4-.9-60.4-9.6-65.3-9.3-3.1.2-9.6.8-14.4 2.9-4.9 2.1-145.2 52.8-150.2 54.7-5.1 2-11.4 3.6-11.1 7.6.2 2.5 2 2.6 4.6 3.5 2.7.8 300.9 67.6 308 69.1 15.6 3.3 38.5 10.5 53.6 1.7 2.1-1.2 123.8-76.4 125.8-77.8 5.4-4 4.3-6.8-1.7-8.2z"
    ]
};
var $ef0249c5e48bf4e3$export$d11e9e62a1442448 = {
    prefix: "fab",
    iconName: "ioxhost",
    icon: [
        640,
        512,
        [],
        "f208",
        "M616 160h-67.3C511.2 70.7 422.9 8 320 8 183 8 72 119 72 256c0 16.4 1.6 32.5 4.7 48H24c-13.3 0-24 10.8-24 24 0 13.3 10.7 24 24 24h67.3c37.5 89.3 125.8 152 228.7 152 137 0 248-111 248-248 0-16.4-1.6-32.5-4.7-48H616c13.3 0 24-10.8 24-24 0-13.3-10.7-24-24-24zm-96 96c0 110.5-89.5 200-200 200-75.7 0-141.6-42-175.5-104H424c13.3 0 24-10.8 24-24 0-13.3-10.7-24-24-24H125.8c-3.8-15.4-5.8-31.4-5.8-48 0-110.5 89.5-200 200-200 75.7 0 141.6 42 175.5 104H216c-13.3 0-24 10.8-24 24 0 13.3 10.7 24 24 24h298.2c3.8 15.4 5.8 31.4 5.8 48zm-304-24h208c13.3 0 24 10.7 24 24 0 13.2-10.7 24-24 24H216c-13.3 0-24-10.7-24-24 0-13.2 10.7-24 24-24z"
    ]
};
var $ef0249c5e48bf4e3$export$e6a0ac478bf76bf2 = {
    prefix: "fab",
    iconName: "fonticons-fi",
    icon: [
        384,
        512,
        [],
        "f3a2",
        "M114.4 224h92.4l-15.2 51.2h-76.4V433c0 8-2.8 9.2 4.4 10l59.6 5.6V483H0v-35.2l29.2-2.8c7.2-.8 9.2-3.2 9.2-10.8V278.4c0-3.2-4-3.2-8-3.2H0V224h38.4v-28.8c0-68 36.4-96 106-96 46.8 0 88.8 11.2 88.8 72.4l-69.6 8.4c.4-25.6-6-31.6-22.4-31.6-25.2 0-26 13.6-26 37.6v32c0 3.2-4.8 6-.8 6zM384 483H243.2v-34.4l28-3.6c7.2-.8 10.4-2.4 10.4-10V287c0-5.6-4-9.2-9.2-10.8l-33.2-8.8 9.2-40.4h110v208c0 8-3.6 8.8 4 10l21.6 3.6V483zm-30-347.2l12.4 45.6-10 10-42.8-22.8-42.8 22.8-10-10 12.4-45.6-30-36.4 4.8-10h38L307.2 51H320l21.2 38.4h38l4.8 13.2-30 33.2z"
    ]
};
var $ef0249c5e48bf4e3$export$500760921a1e1f4e = {
    prefix: "fab",
    iconName: "app-store",
    icon: [
        512,
        512,
        [],
        "f36f",
        "M255.9 120.9l9.1-15.7c5.6-9.8 18.1-13.1 27.9-7.5 9.8 5.6 13.1 18.1 7.5 27.9l-87.5 151.5h63.3c20.5 0 32 24.1 23.1 40.8H113.8c-11.3 0-20.4-9.1-20.4-20.4 0-11.3 9.1-20.4 20.4-20.4h52l66.6-115.4-20.8-36.1c-5.6-9.8-2.3-22.2 7.5-27.9 9.8-5.6 22.2-2.3 27.9 7.5l8.9 15.7zm-78.7 218l-19.6 34c-5.6 9.8-18.1 13.1-27.9 7.5-9.8-5.6-13.1-18.1-7.5-27.9l14.6-25.2c16.4-5.1 29.8-1.2 40.4 11.6zm168.9-61.7h53.1c11.3 0 20.4 9.1 20.4 20.4 0 11.3-9.1 20.4-20.4 20.4h-29.5l19.9 34.5c5.6 9.8 2.3 22.2-7.5 27.9-9.8 5.6-22.2 2.3-27.9-7.5-33.5-58.1-58.7-101.6-75.4-130.6-17.1-29.5-4.9-59.1 7.2-69.1 13.4 23 33.4 57.7 60.1 104zM256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm216 248c0 118.7-96.1 216-216 216-118.7 0-216-96.1-216-216 0-118.7 96.1-216 216-216 118.7 0 216 96.1 216 216z"
    ]
};
var $ef0249c5e48bf4e3$export$dd0d0d0b3b519db5 = {
    prefix: "fab",
    iconName: "cc-mastercard",
    icon: [
        576,
        512,
        [],
        "f1f1",
        "M482.9 410.3c0 6.8-4.6 11.7-11.2 11.7-6.8 0-11.2-5.2-11.2-11.7 0-6.5 4.4-11.7 11.2-11.7 6.6 0 11.2 5.2 11.2 11.7zm-310.8-11.7c-7.1 0-11.2 5.2-11.2 11.7 0 6.5 4.1 11.7 11.2 11.7 6.5 0 10.9-4.9 10.9-11.7-.1-6.5-4.4-11.7-10.9-11.7zm117.5-.3c-5.4 0-8.7 3.5-9.5 8.7h19.1c-.9-5.7-4.4-8.7-9.6-8.7zm107.8.3c-6.8 0-10.9 5.2-10.9 11.7 0 6.5 4.1 11.7 10.9 11.7 6.8 0 11.2-4.9 11.2-11.7 0-6.5-4.4-11.7-11.2-11.7zm105.9 26.1c0 .3.3.5.3 1.1 0 .3-.3.5-.3 1.1-.3.3-.3.5-.5.8-.3.3-.5.5-1.1.5-.3.3-.5.3-1.1.3-.3 0-.5 0-1.1-.3-.3 0-.5-.3-.8-.5-.3-.3-.5-.5-.5-.8-.3-.5-.3-.8-.3-1.1 0-.5 0-.8.3-1.1 0-.5.3-.8.5-1.1.3-.3.5-.3.8-.5.5-.3.8-.3 1.1-.3.5 0 .8 0 1.1.3.5.3.8.3 1.1.5s.2.6.5 1.1zm-2.2 1.4c.5 0 .5-.3.8-.3.3-.3.3-.5.3-.8 0-.3 0-.5-.3-.8-.3 0-.5-.3-1.1-.3h-1.6v3.5h.8V426h.3l1.1 1.4h.8l-1.1-1.3zM576 81v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V81c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48zM64 220.6c0 76.5 62.1 138.5 138.5 138.5 27.2 0 53.9-8.2 76.5-23.1-72.9-59.3-72.4-171.2 0-230.5-22.6-15-49.3-23.1-76.5-23.1-76.4-.1-138.5 62-138.5 138.2zm224 108.8c70.5-55 70.2-162.2 0-217.5-70.2 55.3-70.5 162.6 0 217.5zm-142.3 76.3c0-8.7-5.7-14.4-14.7-14.7-4.6 0-9.5 1.4-12.8 6.5-2.4-4.1-6.5-6.5-12.2-6.5-3.8 0-7.6 1.4-10.6 5.4V392h-8.2v36.7h8.2c0-18.9-2.5-30.2 9-30.2 10.2 0 8.2 10.2 8.2 30.2h7.9c0-18.3-2.5-30.2 9-30.2 10.2 0 8.2 10 8.2 30.2h8.2v-23zm44.9-13.7h-7.9v4.4c-2.7-3.3-6.5-5.4-11.7-5.4-10.3 0-18.2 8.2-18.2 19.3 0 11.2 7.9 19.3 18.2 19.3 5.2 0 9-1.9 11.7-5.4v4.6h7.9V392zm40.5 25.6c0-15-22.9-8.2-22.9-15.2 0-5.7 11.9-4.8 18.5-1.1l3.3-6.5c-9.4-6.1-30.2-6-30.2 8.2 0 14.3 22.9 8.3 22.9 15 0 6.3-13.5 5.8-20.7.8l-3.5 6.3c11.2 7.6 32.6 6 32.6-7.5zm35.4 9.3l-2.2-6.8c-3.8 2.1-12.2 4.4-12.2-4.1v-16.6h13.1V392h-13.1v-11.2h-8.2V392h-7.6v7.3h7.6V416c0 17.6 17.3 14.4 22.6 10.9zm13.3-13.4h27.5c0-16.2-7.4-22.6-17.4-22.6-10.6 0-18.2 7.9-18.2 19.3 0 20.5 22.6 23.9 33.8 14.2l-3.8-6c-7.8 6.4-19.6 5.8-21.9-4.9zm59.1-21.5c-4.6-2-11.6-1.8-15.2 4.4V392h-8.2v36.7h8.2V408c0-11.6 9.5-10.1 12.8-8.4l2.4-7.6zm10.6 18.3c0-11.4 11.6-15.1 20.7-8.4l3.8-6.5c-11.6-9.1-32.7-4.1-32.7 15 0 19.8 22.4 23.8 32.7 15l-3.8-6.5c-9.2 6.5-20.7 2.6-20.7-8.6zm66.7-18.3H408v4.4c-8.3-11-29.9-4.8-29.9 13.9 0 19.2 22.4 24.7 29.9 13.9v4.6h8.2V392zm33.7 0c-2.4-1.2-11-2.9-15.2 4.4V392h-7.9v36.7h7.9V408c0-11 9-10.3 12.8-8.4l2.4-7.6zm40.3-14.9h-7.9v19.3c-8.2-10.9-29.9-5.1-29.9 13.9 0 19.4 22.5 24.6 29.9 13.9v4.6h7.9v-51.7zm7.6-75.1v4.6h.8V302h1.9v-.8h-4.6v.8h1.9zm6.6 123.8c0-.5 0-1.1-.3-1.6-.3-.3-.5-.8-.8-1.1-.3-.3-.8-.5-1.1-.8-.5 0-1.1-.3-1.6-.3-.3 0-.8.3-1.4.3-.5.3-.8.5-1.1.8-.5.3-.8.8-.8 1.1-.3.5-.3 1.1-.3 1.6 0 .3 0 .8.3 1.4 0 .3.3.8.8 1.1.3.3.5.5 1.1.8.5.3 1.1.3 1.4.3.5 0 1.1 0 1.6-.3.3-.3.8-.5 1.1-.8.3-.3.5-.8.8-1.1.3-.6.3-1.1.3-1.4zm3.2-124.7h-1.4l-1.6 3.5-1.6-3.5h-1.4v5.4h.8v-4.1l1.6 3.5h1.1l1.4-3.5v4.1h1.1v-5.4zm4.4-80.5c0-76.2-62.1-138.3-138.5-138.3-27.2 0-53.9 8.2-76.5 23.1 72.1 59.3 73.2 171.5 0 230.5 22.6 15 49.5 23.1 76.5 23.1 76.4.1 138.5-61.9 138.5-138.4z"
    ]
};
var $ef0249c5e48bf4e3$export$a0c8448ba3e387bc = {
    prefix: "fab",
    iconName: "itunes-note",
    icon: [
        384,
        512,
        [],
        "f3b5",
        "M381.9 388.2c-6.4 27.4-27.2 42.8-55.1 48-24.5 4.5-44.9 5.6-64.5-10.2-23.9-20.1-24.2-53.4-2.7-74.4 17-16.2 40.9-19.5 76.8-25.8 6-1.1 11.2-2.5 15.6-7.4 6.4-7.2 4.4-4.1 4.4-163.2 0-11.2-5.5-14.3-17-12.3-8.2 1.4-185.7 34.6-185.7 34.6-10.2 2.2-13.4 5.2-13.4 16.7 0 234.7 1.1 223.9-2.5 239.5-4.2 18.2-15.4 31.9-30.2 39.5-16.8 9.3-47.2 13.4-63.4 10.4-43.2-8.1-58.4-58-29.1-86.6 17-16.2 40.9-19.5 76.8-25.8 6-1.1 11.2-2.5 15.6-7.4 10.1-11.5 1.8-256.6 5.2-270.2.8-5.2 3-9.6 7.1-12.9 4.2-3.5 11.8-5.5 13.4-5.5 204-38.2 228.9-43.1 232.4-43.1 11.5-.8 18.1 6 18.1 17.6.2 344.5 1.1 326-1.8 338.5z"
    ]
};
var $ef0249c5e48bf4e3$export$36cd41563937ec03 = {
    prefix: "fab",
    iconName: "golang",
    icon: [
        640,
        512,
        [],
        "e40f",
        "M400.1 194.8C389.2 197.6 380.2 199.1 371 202.4C363.7 204.3 356.3 206.3 347.8 208.5L347.2 208.6C343 209.8 342.6 209.9 338.7 205.4C334 200.1 330.6 196.7 324.1 193.5C304.4 183.9 285.4 186.7 267.7 198.2C246.5 211.9 235.6 232.2 235.9 257.4C236.2 282.4 253.3 302.9 277.1 306.3C299.1 309.1 316.9 301.7 330.9 285.8C333 283.2 334.9 280.5 337 277.5V277.5L337 277.5C337.8 276.5 338.5 275.4 339.3 274.2H279.2C272.7 274.2 271.1 270.2 273.3 264.9C277.3 255.2 284.8 239 289.2 230.9C290.1 229.1 292.3 225.1 296.1 225.1H397.2C401.7 211.7 409 198.2 418.8 185.4C441.5 155.5 468.1 139.9 506 133.4C537.8 127.8 567.7 130.9 594.9 149.3C619.5 166.1 634.7 188.9 638.8 218.8C644.1 260.9 631.9 295.1 602.1 324.4C582.4 345.3 557.2 358.4 528.2 364.3C522.6 365.3 517.1 365.8 511.7 366.3C508.8 366.5 506 366.8 503.2 367.1C474.9 366.5 449 358.4 427.2 339.7C411.9 326.4 401.3 310.1 396.1 291.2C392.4 298.5 388.1 305.6 382.1 312.3C360.5 341.9 331.2 360.3 294.2 365.2C263.6 369.3 235.3 363.4 210.3 344.7C187.3 327.2 174.2 304.2 170.8 275.5C166.7 241.5 176.7 210.1 197.2 184.2C219.4 155.2 248.7 136.8 284.5 130.3C313.8 124.1 341.8 128.4 367.1 145.6C383.6 156.5 395.4 171.4 403.2 189.5C405.1 192.3 403.8 193.9 400.1 194.8zM48.3 200.4C47.05 200.4 46.74 199.8 47.36 198.8L53.91 190.4C54.53 189.5 56.09 188.9 57.34 188.9H168.6C169.8 188.9 170.1 189.8 169.5 190.7L164.2 198.8C163.6 199.8 162 200.7 161.1 200.7L48.3 200.4zM1.246 229.1C0 229.1-.3116 228.4 .3116 227.5L6.855 219.1C7.479 218.2 9.037 217.5 10.28 217.5H152.4C153.6 217.5 154.2 218.5 153.9 219.4L151.4 226.9C151.1 228.1 149.9 228.8 148.6 228.8L1.246 229.1zM75.72 255.9C75.1 256.8 75.41 257.7 76.65 257.7L144.6 258C145.5 258 146.8 257.1 146.8 255.9L147.4 248.4C147.4 247.1 146.8 246.2 145.5 246.2H83.2C81.95 246.2 80.71 247.1 80.08 248.1L75.72 255.9zM577.2 237.9C577 235.3 576.9 233.1 576.5 230.9C570.9 200.1 542.5 182.6 512.9 189.5C483.9 196 465.2 214.4 458.4 243.7C452.8 268 464.6 292.6 487 302.6C504.2 310.1 521.3 309.2 537.8 300.7C562.4 287.1 575.8 268 577.4 241.2C577.3 240 577.3 238.9 577.2 237.9z"
    ]
};
var $ef0249c5e48bf4e3$export$f06b8625c0ebb13a = {
    prefix: "fab",
    iconName: "kickstarter",
    icon: [
        448,
        512,
        [],
        "f3bb",
        "M400 480H48c-26.4 0-48-21.6-48-48V80c0-26.4 21.6-48 48-48h352c26.4 0 48 21.6 48 48v352c0 26.4-21.6 48-48 48zM199.6 178.5c0-30.7-17.6-45.1-39.7-45.1-25.8 0-40 19.8-40 44.5v154.8c0 25.8 13.7 45.6 40.5 45.6 21.5 0 39.2-14 39.2-45.6v-41.8l60.6 75.7c12.3 14.9 39 16.8 55.8 0 14.6-15.1 14.8-36.8 4-50.4l-49.1-62.8 40.5-58.7c9.4-13.5 9.5-34.5-5.6-49.1-16.4-15.9-44.6-17.3-61.4 7l-44.8 64.7v-38.8z"
    ]
};
var $ef0249c5e48bf4e3$export$fdcdacf548a335ed = {
    prefix: "fab",
    iconName: "grav",
    icon: [
        512,
        512,
        [],
        "f2d6",
        "M301.1 212c4.4 4.4 4.4 11.9 0 16.3l-9.7 9.7c-4.4 4.7-11.9 4.7-16.6 0l-10.5-10.5c-4.4-4.7-4.4-11.9 0-16.6l9.7-9.7c4.4-4.4 11.9-4.4 16.6 0l10.5 10.8zm-30.2-19.7c3-3 3-7.8 0-10.5-2.8-3-7.5-3-10.5 0-2.8 2.8-2.8 7.5 0 10.5 3.1 2.8 7.8 2.8 10.5 0zm-26 5.3c-3 2.8-3 7.5 0 10.2 2.8 3 7.5 3 10.5 0 2.8-2.8 2.8-7.5 0-10.2-3-3-7.7-3-10.5 0zm72.5-13.3c-19.9-14.4-33.8-43.2-11.9-68.1 21.6-24.9 40.7-17.2 59.8.8 11.9 11.3 29.3 24.9 17.2 48.2-12.5 23.5-45.1 33.2-65.1 19.1zm47.7-44.5c-8.9-10-23.3 6.9-15.5 16.1 7.4 9 32.1 2.4 15.5-16.1zM504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zm-66.2 42.6c2.5-16.1-20.2-16.6-25.2-25.7-13.6-24.1-27.7-36.8-54.5-30.4 11.6-8 23.5-6.1 23.5-6.1.3-6.4 0-13-9.4-24.9 3.9-12.5.3-22.4.3-22.4 15.5-8.6 26.8-24.4 29.1-43.2 3.6-31-18.8-59.2-49.8-62.8-22.1-2.5-43.7 7.7-54.3 25.7-23.2 40.1 1.4 70.9 22.4 81.4-14.4-1.4-34.3-11.9-40.1-34.3-6.6-25.7 2.8-49.8 8.9-61.4 0 0-4.4-5.8-8-8.9 0 0-13.8 0-24.6 5.3 11.9-15.2 25.2-14.4 25.2-14.4 0-6.4-.6-14.9-3.6-21.6-5.4-11-23.8-12.9-31.7 2.8.1-.2.3-.4.4-.5-5 11.9-1.1 55.9 16.9 87.2-2.5 1.4-9.1 6.1-13 10-21.6 9.7-56.2 60.3-56.2 60.3-28.2 10.8-77.2 50.9-70.6 79.7.3 3 1.4 5.5 3 7.5-2.8 2.2-5.5 5-8.3 8.3-11.9 13.8-5.3 35.2 17.7 24.4 15.8-7.2 29.6-20.2 36.3-30.4 0 0-5.5-5-16.3-4.4 27.7-6.6 34.3-9.4 46.2-9.1 8 3.9 8-34.3 8-34.3 0-14.7-2.2-31-11.1-41.5 12.5 12.2 29.1 32.7 28 60.6-.8 18.3-15.2 23-15.2 23-9.1 16.6-43.2 65.9-30.4 106 0 0-9.7-14.9-10.2-22.1-17.4 19.4-46.5 52.3-24.6 64.5 26.6 14.7 108.8-88.6 126.2-142.3 34.6-20.8 55.4-47.3 63.9-65 22 43.5 95.3 94.5 101.1 59z"
    ]
};
var $ef0249c5e48bf4e3$export$75bd846ccb390b1e = {
    prefix: "fab",
    iconName: "weibo",
    icon: [
        512,
        512,
        [],
        "f18a",
        "M407 177.6c7.6-24-13.4-46.8-37.4-41.7-22 4.8-28.8-28.1-7.1-32.8 50.1-10.9 92.3 37.1 76.5 84.8-6.8 21.2-38.8 10.8-32-10.3zM214.8 446.7C108.5 446.7 0 395.3 0 310.4c0-44.3 28-95.4 76.3-143.7C176 67 279.5 65.8 249.9 161c-4 13.1 12.3 5.7 12.3 6 79.5-33.6 140.5-16.8 114 51.4-3.7 9.4 1.1 10.9 8.3 13.1 135.7 42.3 34.8 215.2-169.7 215.2zm143.7-146.3c-5.4-55.7-78.5-94-163.4-85.7-84.8 8.6-148.8 60.3-143.4 116s78.5 94 163.4 85.7c84.8-8.6 148.8-60.3 143.4-116zM347.9 35.1c-25.9 5.6-16.8 43.7 8.3 38.3 72.3-15.2 134.8 52.8 111.7 124-7.4 24.2 29.1 37 37.4 12 31.9-99.8-55.1-195.9-157.4-174.3zm-78.5 311c-17.1 38.8-66.8 60-109.1 46.3-40.8-13.1-58-53.4-40.3-89.7 17.7-35.4 63.1-55.4 103.4-45.1 42 10.8 63.1 50.2 46 88.5zm-86.3-30c-12.9-5.4-30 .3-38 12.9-8.3 12.9-4.3 28 8.6 34 13.1 6 30.8.3 39.1-12.9 8-13.1 3.7-28.3-9.7-34zm32.6-13.4c-5.1-1.7-11.4.6-14.3 5.4-2.9 5.1-1.4 10.6 3.7 12.9 5.1 2 11.7-.3 14.6-5.4 2.8-5.2 1.1-10.9-4-12.9z"
    ]
};
var $ef0249c5e48bf4e3$export$e1cced2e7ea20eff = {
    prefix: "fab",
    iconName: "uncharted",
    icon: [
        448,
        512,
        [],
        "e084",
        "M171.73,232.813A5.381,5.381,0,0,0,176.7,229.5,48.081,48.081,0,0,1,191.6,204.244c1.243-.828,1.657-2.484,1.657-4.141a4.22,4.22,0,0,0-2.071-3.312L74.429,128.473,148.958,85a9.941,9.941,0,0,0,4.968-8.281,9.108,9.108,0,0,0-4.968-8.281L126.6,55.6a9.748,9.748,0,0,0-9.523,0l-100.2,57.966a9.943,9.943,0,0,0-4.969,8.281V236.954a9.109,9.109,0,0,0,4.969,8.281L39.235,258.07a8.829,8.829,0,0,0,4.968,1.242,9.4,9.4,0,0,0,6.625-2.484,10.8,10.8,0,0,0,2.9-7.039V164.5L169.66,232.4A4.5,4.5,0,0,0,171.73,232.813ZM323.272,377.73a12.478,12.478,0,0,0-4.969,1.242l-74.528,43.062V287.882c0-2.9-2.9-5.8-6.211-4.555a53.036,53.036,0,0,1-28.984.414,4.86,4.86,0,0,0-6.21,4.555V421.619l-74.529-43.061a8.83,8.83,0,0,0-4.969-1.242,9.631,9.631,0,0,0-9.523,9.523v26.085a9.107,9.107,0,0,0,4.969,8.281l100.2,57.553A8.829,8.829,0,0,0,223.486,480a11.027,11.027,0,0,0,4.969-1.242l100.2-57.553a9.941,9.941,0,0,0,4.968-8.281V386.839C332.8,382.285,328.24,377.73,323.272,377.73ZM286.007,78a23,23,0,1,0-23-23A23,23,0,0,0,286.007,78Zm63.627-10.086a23,23,0,1,0,23,23A23,23,0,0,0,349.634,67.914ZM412.816,151.6a23,23,0,1,0-23-23A23,23,0,0,0,412.816,151.6Zm-63.182-9.2a23,23,0,1,0,23,23A23,23,0,0,0,349.634,142.4Zm-63.627,83.244a23,23,0,1,0-23-23A23,23,0,0,0,286.007,225.648Zm-62.074,36.358a23,23,0,1,0-23-23A23,23,0,0,0,223.933,262.006Zm188.883-82.358a23,23,0,1,0,23,23A23,23,0,0,0,412.816,179.648Zm0,72.272a23,23,0,1,0,23,23A23,23,0,0,0,412.816,251.92Z"
    ]
};
var $ef0249c5e48bf4e3$export$44a54556e145bddf = {
    prefix: "fab",
    iconName: "firstdraft",
    icon: [
        384,
        512,
        [],
        "f3a1",
        "M384 192h-64v128H192v128H0v-25.6h166.4v-128h128v-128H384V192zm-25.6 38.4v128h-128v128H64V512h192V384h128V230.4h-25.6zm25.6 192h-89.6V512H320v-64h64v-25.6zM0 0v384h128V256h128V128h128V0H0z"
    ]
};
var $ef0249c5e48bf4e3$export$1082b39fc1076b43 = {
    prefix: "fab",
    iconName: "square-youtube",
    icon: [
        448,
        512,
        [
            61798,
            "youtube-square"
        ],
        "f431",
        "M282 256.2l-95.2-54.1V310.3L282 256.2zM384 32H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64zm14.4 136.1c7.6 28.6 7.6 88.2 7.6 88.2s0 59.6-7.6 88.1c-4.2 15.8-16.5 27.7-32.2 31.9C337.9 384 224 384 224 384s-113.9 0-142.2-7.6c-15.7-4.2-28-16.1-32.2-31.9C42 315.9 42 256.3 42 256.3s0-59.7 7.6-88.2c4.2-15.8 16.5-28.2 32.2-32.4C110.1 128 224 128 224 128s113.9 0 142.2 7.7c15.7 4.2 28 16.6 32.2 32.4z"
    ]
};
var $ef0249c5e48bf4e3$export$8992da42b645c563 = $ef0249c5e48bf4e3$export$1082b39fc1076b43;
var $ef0249c5e48bf4e3$export$6657c749288c4042 = {
    prefix: "fab",
    iconName: "wikipedia-w",
    icon: [
        640,
        512,
        [],
        "f266",
        "M640 51.2l-.3 12.2c-28.1.8-45 15.8-55.8 40.3-25 57.8-103.3 240-155.3 358.6H415l-81.9-193.1c-32.5 63.6-68.3 130-99.2 193.1-.3.3-15 0-15-.3C172 352.3 122.8 243.4 75.8 133.4 64.4 106.7 26.4 63.4.2 63.7c0-3.1-.3-10-.3-14.2h161.9v13.9c-19.2 1.1-52.8 13.3-43.3 34.2 21.9 49.7 103.6 240.3 125.6 288.6 15-29.7 57.8-109.2 75.3-142.8-13.9-28.3-58.6-133.9-72.8-160-9.7-17.8-36.1-19.4-55.8-19.7V49.8l142.5.3v13.1c-19.4.6-38.1 7.8-29.4 26.1 18.9 40 30.6 68.1 48.1 104.7 5.6-10.8 34.7-69.4 48.1-100.8 8.9-20.6-3.9-28.6-38.6-29.4.3-3.6 0-10.3.3-13.6 44.4-.3 111.1-.3 123.1-.6v13.6c-22.5.8-45.8 12.8-58.1 31.7l-59.2 122.8c6.4 16.1 63.3 142.8 69.2 156.7L559.2 91.8c-8.6-23.1-36.4-28.1-47.2-28.3V49.6l127.8 1.1.2.5z"
    ]
};
var $ef0249c5e48bf4e3$export$66f88c21efa6f12d = {
    prefix: "fab",
    iconName: "wpressr",
    icon: [
        496,
        512,
        [
            "rendact"
        ],
        "f3e4",
        "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm171.33 158.6c-15.18 34.51-30.37 69.02-45.63 103.5-2.44 5.51-6.89 8.24-12.97 8.24-23.02-.01-46.03.06-69.05-.05-5.12-.03-8.25 1.89-10.34 6.72-10.19 23.56-20.63 47-30.95 70.5-1.54 3.51-4.06 5.29-7.92 5.29-45.94-.01-91.87-.02-137.81 0-3.13 0-5.63-1.15-7.72-3.45-11.21-12.33-22.46-24.63-33.68-36.94-2.69-2.95-2.79-6.18-1.21-9.73 8.66-19.54 17.27-39.1 25.89-58.66 12.93-29.35 25.89-58.69 38.75-88.08 1.7-3.88 4.28-5.68 8.54-5.65 14.24.1 28.48.02 42.72.05 6.24.01 9.2 4.84 6.66 10.59-13.6 30.77-27.17 61.55-40.74 92.33-5.72 12.99-11.42 25.99-17.09 39-3.91 8.95 7.08 11.97 10.95 5.6.23-.37-1.42 4.18 30.01-67.69 1.36-3.1 3.41-4.4 6.77-4.39 15.21.08 30.43.02 45.64.04 5.56.01 7.91 3.64 5.66 8.75-8.33 18.96-16.71 37.9-24.98 56.89-4.98 11.43 8.08 12.49 11.28 5.33.04-.08 27.89-63.33 32.19-73.16 2.02-4.61 5.44-6.51 10.35-6.5 26.43.05 52.86 0 79.29.05 12.44.02 13.93-13.65 3.9-13.64-25.26.03-50.52.02-75.78.02-6.27 0-7.84-2.47-5.27-8.27 5.78-13.06 11.59-26.11 17.3-39.21 1.73-3.96 4.52-5.79 8.84-5.78 23.09.06 25.98.02 130.78.03 6.08-.01 8.03 2.79 5.62 8.27z"
    ]
};
var $ef0249c5e48bf4e3$export$d06b08e37a8aaaec = $ef0249c5e48bf4e3$export$66f88c21efa6f12d;
var $ef0249c5e48bf4e3$export$65f66dc47afb97bd = {
    prefix: "fab",
    iconName: "angellist",
    icon: [
        448,
        512,
        [],
        "f209",
        "M347.1 215.4c11.7-32.6 45.4-126.9 45.4-157.1 0-26.6-15.7-48.9-43.7-48.9-44.6 0-84.6 131.7-97.1 163.1C242 144 196.6 0 156.6 0c-31.1 0-45.7 22.9-45.7 51.7 0 35.3 34.2 126.8 46.6 162-6.3-2.3-13.1-4.3-20-4.3-23.4 0-48.3 29.1-48.3 52.6 0 8.9 4.9 21.4 8 29.7-36.9 10-51.1 34.6-51.1 71.7C46 435.6 114.4 512 210.6 512c118 0 191.4-88.6 191.4-202.9 0-43.1-6.9-82-54.9-93.7zM311.7 108c4-12.3 21.1-64.3 37.1-64.3 8.6 0 10.9 8.9 10.9 16 0 19.1-38.6 124.6-47.1 148l-34-6 33.1-93.7zM142.3 48.3c0-11.9 14.5-45.7 46.3 47.1l34.6 100.3c-15.6-1.3-27.7-3-35.4 1.4-10.9-28.8-45.5-119.7-45.5-148.8zM140 244c29.3 0 67.1 94.6 67.1 107.4 0 5.1-4.9 11.4-10.6 11.4-20.9 0-76.9-76.9-76.9-97.7.1-7.7 12.7-21.1 20.4-21.1zm184.3 186.3c-29.1 32-66.3 48.6-109.7 48.6-59.4 0-106.3-32.6-128.9-88.3-17.1-43.4 3.8-68.3 20.6-68.3 11.4 0 54.3 60.3 54.3 73.1 0 4.9-7.7 8.3-11.7 8.3-16.1 0-22.4-15.5-51.1-51.4-29.7 29.7 20.5 86.9 58.3 86.9 26.1 0 43.1-24.2 38-42 3.7 0 8.3.3 11.7-.6 1.1 27.1 9.1 59.4 41.7 61.7 0-.9 2-7.1 2-7.4 0-17.4-10.6-32.6-10.6-50.3 0-28.3 21.7-55.7 43.7-71.7 8-6 17.7-9.7 27.1-13.1 9.7-3.7 20-8 27.4-15.4-1.1-11.2-5.7-21.1-16.9-21.1-27.7 0-120.6 4-120.6-39.7 0-6.7.1-13.1 17.4-13.1 32.3 0 114.3 8 138.3 29.1 18.1 16.1 24.3 113.2-31 174.7zm-98.6-126c9.7 3.1 19.7 4 29.7 6-7.4 5.4-14 12-20.3 19.1-2.8-8.5-6.2-16.8-9.4-25.1z"
    ]
};
var $ef0249c5e48bf4e3$export$ba5a2dfe23db8bb6 = {
    prefix: "fab",
    iconName: "galactic-republic",
    icon: [
        496,
        512,
        [],
        "f50c",
        "M248 504C111.25 504 0 392.75 0 256S111.25 8 248 8s248 111.25 248 248-111.25 248-248 248zm0-479.47C120.37 24.53 16.53 128.37 16.53 256S120.37 487.47 248 487.47 479.47 383.63 479.47 256 375.63 24.53 248 24.53zm27.62 21.81v24.62a185.933 185.933 0 0 1 83.57 34.54l17.39-17.36c-28.75-22.06-63.3-36.89-100.96-41.8zm-55.37.07c-37.64 4.94-72.16 19.8-100.88 41.85l17.28 17.36h.08c24.07-17.84 52.55-30.06 83.52-34.67V46.41zm12.25 50.17v82.87c-10.04 2.03-19.42 5.94-27.67 11.42l-58.62-58.59-21.93 21.93 58.67 58.67c-5.47 8.23-9.45 17.59-11.47 27.62h-82.9v31h82.9c2.02 10.02 6.01 19.31 11.47 27.54l-58.67 58.69 21.93 21.93 58.62-58.62a77.873 77.873 0 0 0 27.67 11.47v82.9h31v-82.9c10.05-2.03 19.37-6.06 27.62-11.55l58.67 58.69 21.93-21.93-58.67-58.69c5.46-8.23 9.47-17.52 11.5-27.54h82.87v-31h-82.87c-2.02-10.02-6.03-19.38-11.5-27.62l58.67-58.67-21.93-21.93-58.67 58.67c-8.25-5.49-17.57-9.47-27.62-11.5V96.58h-31zm183.24 30.72l-17.36 17.36a186.337 186.337 0 0 1 34.67 83.67h24.62c-4.95-37.69-19.83-72.29-41.93-101.03zm-335.55.13c-22.06 28.72-36.91 63.26-41.85 100.91h24.65c4.6-30.96 16.76-59.45 34.59-83.52l-17.39-17.39zM38.34 283.67c4.92 37.64 19.75 72.18 41.8 100.9l17.36-17.39c-17.81-24.07-29.92-52.57-34.51-83.52H38.34zm394.7 0c-4.61 30.99-16.8 59.5-34.67 83.6l17.36 17.36c22.08-28.74 36.98-63.29 41.93-100.96h-24.62zM136.66 406.38l-17.36 17.36c28.73 22.09 63.3 36.98 100.96 41.93v-24.64c-30.99-4.63-59.53-16.79-83.6-34.65zm222.53.05c-24.09 17.84-52.58 30.08-83.57 34.67v24.57c37.67-4.92 72.21-19.79 100.96-41.85l-17.31-17.39h-.08z"
    ]
};
var $ef0249c5e48bf4e3$export$d637dd7b404459cf = {
    prefix: "fab",
    iconName: "nfc-directional",
    icon: [
        512,
        512,
        [],
        "e530",
        "M211.8 488.6C213.4 491.1 213.9 494.2 213.2 497.1C212.6 500 210.8 502.6 208.3 504.2C205.7 505.8 202.7 506.3 199.7 505.7C138.3 491.8 84.1 455.8 47.53 404.5C10.97 353.2-5.395 290.3 1.57 227.7C8.536 165 38.34 107.2 85.29 65.21C132.2 23.2 193-.0131 256 0C257.5 0 258.1 .2931 260.3 .8627C261.7 1.432 262.1 2.267 264 3.319C265.1 4.371 265.9 5.619 266.5 6.993C267 8.367 267.3 9.839 267.3 11.32V112.3L291.8 86.39C292.8 85.31 294 84.44 295.4 83.84C296.7 83.23 298.2 82.9 299.7 82.86C301.2 82.81 302.6 83.06 304 83.59C305.4 84.12 306.7 84.92 307.8 85.94C308.8 86.96 309.7 88.18 310.3 89.54C310.9 90.89 311.3 92.35 311.3 93.84C311.3 95.32 311.1 96.8 310.6 98.18C310 99.57 309.2 100.8 308.2 101.9L264.2 148.5C263.1 149.6 261.9 150.5 260.5 151.1C259 151.7 257.5 152 255.1 152C254.5 152 252.9 151.7 251.5 151.1C250.1 150.5 248.8 149.6 247.8 148.5L203.7 101.9C201.7 99.74 200.6 96.83 200.7 93.84C200.7 90.84 202 87.1 204.2 85.94C206.4 83.88 209.3 82.77 212.3 82.86C215.3 82.94 218.1 84.21 220.2 86.39L244.7 112.4V22.89C188.3 25.64 134.9 48.73 94.23 87.87C53.58 127 28.49 179.6 23.61 235.8C18.73 292 34.38 348.1 67.68 393.7C100.1 439.2 149.7 471.2 204.7 483.6C207.6 484.3 210.2 486.1 211.8 488.6L211.8 488.6zM171.4 126.1C170.6 127.4 169.5 128.5 168.3 129.3C147.8 143.2 131.1 161.9 119.5 183.8C107.9 205.7 101.8 230.1 101.8 254.9C101.8 279.7 107.9 304.1 119.5 325.1C131.1 347.9 147.8 366.6 168.3 380.5C170.8 382.2 172.5 384.8 173 387.8C173.6 390.7 172.1 393.8 171.3 396.2C169.6 398.7 166.1 400.4 164 400.1C161.1 401.5 158 400.9 155.6 399.2C132 383.2 112.8 361.7 99.46 336.5C86.15 311.4 79.19 283.4 79.19 254.9C79.19 226.5 86.15 198.4 99.46 173.3C112.8 148.1 132 126.6 155.6 110.6C156.8 109.8 158.2 109.2 159.6 108.8C161.1 108.5 162.6 108.5 164.1 108.8C165.5 109 166.9 109.6 168.2 110.4C169.5 111.2 170.5 112.3 171.4 113.5C172.2 114.7 172.8 116.1 173.1 117.6C173.4 119.1 173.4 120.6 173.1 122C172.8 123.5 172.3 124.9 171.4 126.1H171.4zM340.9 383.5C341.7 382.3 342.8 381.2 343.1 380.4V380.3C364.4 366.3 381.1 347.6 392.7 325.7C404.2 303.9 410.2 279.5 410.2 254.8C410.2 230.1 404.2 205.7 392.7 183.8C381.1 161.1 364.4 143.3 343.1 129.3C342.8 128.5 341.7 127.4 340.9 126.2C340.1 124.9 339.5 123.5 339.3 122.1C338.1 120.6 339 119.1 339.3 117.7C339.6 116.2 340.2 114.8 341 113.6C341.9 112.4 342.1 111.3 344.2 110.5C345.4 109.7 346.8 109.2 348.3 108.9C349.8 108.6 351.2 108.6 352.7 108.9C354.2 109.2 355.5 109.8 356.8 110.7C380.2 126.7 399.5 148.2 412.7 173.3C426 198.4 432.1 226.4 432.1 254.8C432.1 283.3 426 311.3 412.7 336.4C399.5 361.5 380.2 383 356.8 399C355.5 399.9 354.2 400.5 352.7 400.8C351.2 401.1 349.8 401.1 348.3 400.8C346.8 400.5 345.4 399.1 344.2 399.2C342.1 398.4 341.9 397.3 341 396.1C340.2 394.9 339.6 393.5 339.3 392C339 390.6 338.1 389.1 339.3 387.6C339.5 386.2 340.1 384.8 340.9 383.5V383.5zM312.3 6.307C368.5 19.04 418.7 50.28 455 95.01C485.4 132.6 504.6 178 510.3 226C515.9 274 507.9 322.7 487.1 366.3C466.2 409.9 433.5 446.8 392.6 472.6C351.7 498.3 304.4 512 256 512C254.5 512 253.1 511.7 251.7 511.1C250.3 510.6 249.1 509.7 248 508.7C246.1 507.6 246.1 506.4 245.6 505C245 503.6 244.7 502.2 244.7 500.7V401.5L220.2 427.5C218.1 429.7 215.3 430.1 212.3 431.1C209.3 431.2 206.4 430 204.2 427.1C202 425.9 200.7 423.1 200.7 420.1C200.6 417.1 201.7 414.2 203.7 412L247.8 365.4C249.1 363.2 252.9 362 255.1 362C259.1 362 262 363.2 264.2 365.4L308.2 412C310.3 414.2 311.4 417.1 311.3 420.1C311.2 423.1 309.9 425.9 307.8 427.1C305.6 430 302.7 431.2 299.7 431.1C296.7 430.1 293.8 429.7 291.8 427.5L267.3 401.6V489.1C323.7 486.3 377.1 463.3 417.8 424.1C458.5 384.1 483.6 332.4 488.5 276.2C493.3 219.1 477.7 163.9 444.4 118.3C411.1 72.75 362.4 40.79 307.4 28.36C305.9 28.03 304.6 27.42 303.3 26.57C302.1 25.71 301.1 24.63 300.3 23.37C299.5 22.12 298.1 20.72 298.7 19.26C298.5 17.8 298.5 16.3 298.8 14.85C299.2 13.41 299.8 12.04 300.6 10.82C301.5 9.61 302.6 8.577 303.8 7.784C305.1 6.99 306.5 6.451 307.9 6.198C309.4 5.945 310.9 5.982 312.3 6.307L312.3 6.307zM353.1 256.1C353.1 287.5 335.6 317.2 303.8 339.6C301.7 341.1 299 341.9 296.4 341.6C293.7 341.4 291.2 340.3 289.4 338.4L219.3 268.6C217.1 266.5 215.1 263.6 215.9 260.6C215.9 257.6 217.1 254.7 219.2 252.6C221.4 250.5 224.2 249.3 227.2 249.3C230.2 249.3 233.1 250.5 235.2 252.6L298.3 315.4C319.1 298.3 330.5 277.5 330.5 256.1C330.5 232.2 316.4 209.1 290.8 191C288.3 189.3 286.7 186.7 286.2 183.7C285.7 180.8 286.3 177.7 288.1 175.3C289.8 172.8 292.4 171.2 295.4 170.7C298.3 170.2 301.4 170.8 303.8 172.6C335.6 195 353.1 224.7 353.1 256.1V256.1zM216.7 341.5C213.7 342 210.7 341.3 208.2 339.6C176.5 317.2 158.1 287.5 158.1 256.1C158.1 224.7 176.5 195 208.2 172.6C210.4 171 213.1 170.3 215.7 170.5C218.4 170.8 220.8 171.9 222.7 173.8L292.8 243.6C294.9 245.7 296.1 248.6 296.1 251.6C296.1 254.6 294.1 257.4 292.8 259.6C290.7 261.7 287.8 262.9 284.9 262.9C281.9 262.9 278.1 261.7 276.9 259.6L213.8 196.7C192.9 214 181.6 234.7 181.6 256.1C181.6 279.1 195.7 303.1 221.3 321.1C223.7 322.9 225.4 325.5 225.9 328.5C226.4 331.4 225.7 334.4 224 336.9C222.3 339.3 219.6 341 216.7 341.5L216.7 341.5z"
    ]
};
var $ef0249c5e48bf4e3$export$78370b1b91348c9e = {
    prefix: "fab",
    iconName: "skype",
    icon: [
        448,
        512,
        [],
        "f17e",
        "M424.7 299.8c2.9-14 4.7-28.9 4.7-43.8 0-113.5-91.9-205.3-205.3-205.3-14.9 0-29.7 1.7-43.8 4.7C161.3 40.7 137.7 32 112 32 50.2 32 0 82.2 0 144c0 25.7 8.7 49.3 23.3 68.2-2.9 14-4.7 28.9-4.7 43.8 0 113.5 91.9 205.3 205.3 205.3 14.9 0 29.7-1.7 43.8-4.7 19 14.6 42.6 23.3 68.2 23.3 61.8 0 112-50.2 112-112 .1-25.6-8.6-49.2-23.2-68.1zm-194.6 91.5c-65.6 0-120.5-29.2-120.5-65 0-16 9-30.6 29.5-30.6 31.2 0 34.1 44.9 88.1 44.9 25.7 0 42.3-11.4 42.3-26.3 0-18.7-16-21.6-42-28-62.5-15.4-117.8-22-117.8-87.2 0-59.2 58.6-81.1 109.1-81.1 55.1 0 110.8 21.9 110.8 55.4 0 16.9-11.4 31.8-30.3 31.8-28.3 0-29.2-33.5-75-33.5-25.7 0-42 7-42 22.5 0 19.8 20.8 21.8 69.1 33 41.4 9.3 90.7 26.8 90.7 77.6 0 59.1-57.1 86.5-112 86.5z"
    ]
};
var $ef0249c5e48bf4e3$export$ae307621d0877ba2 = {
    prefix: "fab",
    iconName: "joget",
    icon: [
        496,
        512,
        [],
        "f3b7",
        "M378.1 45C337.6 19.9 292.6 8 248.2 8 165 8 83.8 49.9 36.9 125.9c-71.9 116.6-35.6 269.3 81 341.2s269.3 35.6 341.2-80.9c71.9-116.6 35.6-269.4-81-341.2zm51.8 323.2c-40.4 65.5-110.4 101.5-182 101.5-6.8 0-13.6-.4-20.4-1-9-13.6-19.9-33.3-23.7-42.4-5.7-13.7-27.2-45.6 31.2-67.1 51.7-19.1 176.7-16.5 208.8-17.6-4 9-8.6 17.9-13.9 26.6zm-200.8-86.3c-55.5-1.4-81.7-20.8-58.5-48.2s51.1-40.7 68.9-51.2c17.9-10.5 27.3-33.7-23.6-29.7C87.3 161.5 48.6 252.1 37.6 293c-8.8-49.7-.1-102.7 28.5-149.1C128 43.4 259.6 12.2 360.1 74.1c74.8 46.1 111.2 130.9 99.3 212.7-24.9-.5-179.3-3.6-230.3-4.9zm183.8-54.8c-22.7-6-57 11.3-86.7 27.2-29.7 15.8-31.1 8.2-31.1 8.2s40.2-28.1 50.7-34.5 31.9-14 13.4-24.6c-3.2-1.8-6.7-2.7-10.4-2.7-17.8 0-41.5 18.7-67.5 35.6-31.5 20.5-65.3 31.3-65.3 31.3l169.5-1.6 46.5-23.4s3.6-9.5-19.1-15.5z"
    ]
};
var $ef0249c5e48bf4e3$export$8cf9f3ca16e668b0 = {
    prefix: "fab",
    iconName: "fedora",
    icon: [
        448,
        512,
        [],
        "f798",
        "M.0413 255.8C.1219 132.2 100.3 32 224 32C347.7 32 448 132.3 448 256C448 379.7 347.8 479.9 224.1 480H50.93C22.84 480 .0832 457.3 .0416 429.2H0V255.8H.0413zM342.6 192.7C342.6 153 307 124.2 269.4 124.2C234.5 124.2 203.6 150.5 199.3 184.1C199.1 187.9 198.9 189.1 198.9 192.6C198.8 213.7 198.9 235.4 198.1 257C199 283.1 199.1 309.1 198.1 333.6C198.1 360.7 178.7 379.1 153.4 379.1C128.1 379.1 107.6 358.9 107.6 333.6C108.1 305.9 130.2 288.3 156.1 287.5H156.3L182.6 287.3V250L156.3 250.2C109.2 249.8 71.72 286.7 70.36 333.6C70.36 379.2 107.9 416.5 153.4 416.5C196.4 416.5 232.1 382.9 236 340.9L236.2 287.4L268.8 287.1C294.1 287.3 293.8 249.3 268.6 249.8L236.2 250.1C236.2 243.7 236.3 237.3 236.3 230.9C236.4 218.2 236.4 205.5 236.2 192.7C236.3 176.2 252 161.5 269.4 161.5C286.9 161.5 305.3 170.2 305.3 192.7C305.3 195.9 305.2 197.8 305 199C303.1 209.5 310.2 219.4 320.7 220.9C331.3 222.4 340.9 214.8 341.9 204.3C342.5 200.1 342.6 196.4 342.6 192.7H342.6z"
    ]
};
var $ef0249c5e48bf4e3$export$4823078d958b443a = {
    prefix: "fab",
    iconName: "stripe-s",
    icon: [
        384,
        512,
        [],
        "f42a",
        "M155.3 154.6c0-22.3 18.6-30.9 48.4-30.9 43.4 0 98.5 13.3 141.9 36.7V26.1C298.3 7.2 251.1 0 203.8 0 88.1 0 11 60.4 11 161.4c0 157.9 216.8 132.3 216.8 200.4 0 26.4-22.9 34.9-54.7 34.9-47.2 0-108.2-19.5-156.1-45.5v128.5a396.09 396.09 0 0 0 156 32.4c118.6 0 200.3-51 200.3-153.6 0-170.2-218-139.7-218-203.9z"
    ]
};
var $ef0249c5e48bf4e3$export$75b94550e27ccec5 = {
    prefix: "fab",
    iconName: "meta",
    icon: [
        640,
        512,
        [],
        "e49b",
        "M640 317.9C640 409.2 600.6 466.4 529.7 466.4C467.1 466.4 433.9 431.8 372.8 329.8L341.4 277.2C333.1 264.7 326.9 253 320.2 242.2C300.1 276 273.1 325.2 273.1 325.2C206.1 441.8 168.5 466.4 116.2 466.4C43.42 466.4 0 409.1 0 320.5C0 177.5 79.78 42.4 183.9 42.4C234.1 42.4 277.7 67.08 328.7 131.9C365.8 81.8 406.8 42.4 459.3 42.4C558.4 42.4 640 168.1 640 317.9H640zM287.4 192.2C244.5 130.1 216.5 111.7 183 111.7C121.1 111.7 69.22 217.8 69.22 321.7C69.22 370.2 87.7 397.4 118.8 397.4C149 397.4 167.8 378.4 222 293.6C222 293.6 246.7 254.5 287.4 192.2V192.2zM531.2 397.4C563.4 397.4 578.1 369.9 578.1 322.5C578.1 198.3 523.8 97.08 454.9 97.08C421.7 97.08 393.8 123 360 175.1C369.4 188.9 379.1 204.1 389.3 220.5L426.8 282.9C485.5 377 500.3 397.4 531.2 397.4L531.2 397.4z"
    ]
};
var $ef0249c5e48bf4e3$export$bfe42001388ccf42 = {
    prefix: "fab",
    iconName: "laravel",
    icon: [
        512,
        512,
        [],
        "f3bd",
        "M504.4,115.83a5.72,5.72,0,0,0-.28-.68,8.52,8.52,0,0,0-.53-1.25,6,6,0,0,0-.54-.71,9.36,9.36,0,0,0-.72-.94c-.23-.22-.52-.4-.77-.6a8.84,8.84,0,0,0-.9-.68L404.4,55.55a8,8,0,0,0-8,0L300.12,111h0a8.07,8.07,0,0,0-.88.69,7.68,7.68,0,0,0-.78.6,8.23,8.23,0,0,0-.72.93c-.17.24-.39.45-.54.71a9.7,9.7,0,0,0-.52,1.25c-.08.23-.21.44-.28.68a8.08,8.08,0,0,0-.28,2.08V223.18l-80.22,46.19V63.44a7.8,7.8,0,0,0-.28-2.09c-.06-.24-.2-.45-.28-.68a8.35,8.35,0,0,0-.52-1.24c-.14-.26-.37-.47-.54-.72a9.36,9.36,0,0,0-.72-.94,9.46,9.46,0,0,0-.78-.6,9.8,9.8,0,0,0-.88-.68h0L115.61,1.07a8,8,0,0,0-8,0L11.34,56.49h0a6.52,6.52,0,0,0-.88.69,7.81,7.81,0,0,0-.79.6,8.15,8.15,0,0,0-.71.93c-.18.25-.4.46-.55.72a7.88,7.88,0,0,0-.51,1.24,6.46,6.46,0,0,0-.29.67,8.18,8.18,0,0,0-.28,2.1v329.7a8,8,0,0,0,4,6.95l192.5,110.84a8.83,8.83,0,0,0,1.33.54c.21.08.41.2.63.26a7.92,7.92,0,0,0,4.1,0c.2-.05.37-.16.55-.22a8.6,8.6,0,0,0,1.4-.58L404.4,400.09a8,8,0,0,0,4-6.95V287.88l92.24-53.11a8,8,0,0,0,4-7V117.92A8.63,8.63,0,0,0,504.4,115.83ZM111.6,17.28h0l80.19,46.15-80.2,46.18L31.41,63.44Zm88.25,60V278.6l-46.53,26.79-33.69,19.4V123.5l46.53-26.79Zm0,412.78L23.37,388.5V77.32L57.06,96.7l46.52,26.8V338.68a6.94,6.94,0,0,0,.12.9,8,8,0,0,0,.16,1.18h0a5.92,5.92,0,0,0,.38.9,6.38,6.38,0,0,0,.42,1v0a8.54,8.54,0,0,0,.6.78,7.62,7.62,0,0,0,.66.84l0,0c.23.22.52.38.77.58a8.93,8.93,0,0,0,.86.66l0,0,0,0,92.19,52.18Zm8-106.17-80.06-45.32,84.09-48.41,92.26-53.11,80.13,46.13-58.8,33.56Zm184.52,4.57L215.88,490.11V397.8L346.6,323.2l45.77-26.15Zm0-119.13L358.68,250l-46.53-26.79V131.79l33.69,19.4L392.37,178Zm8-105.28-80.2-46.17,80.2-46.16,80.18,46.15Zm8,105.28V178L455,151.19l33.68-19.4v91.39h0Z"
    ]
};
var $ef0249c5e48bf4e3$export$d309e8b75a17a518 = {
    prefix: "fab",
    iconName: "hotjar",
    icon: [
        512,
        512,
        [],
        "f3b1",
        "M361.5 0c0 131.6-80.7 176.8-140.2 209.4c-.6 .3-1.1 .6-1.6 .9c-53.8 30.2-88.7 49.8-89.6 122H32C32 200.8 112.7 155.6 172.2 123C227 93.2 262.5 73 262.5 0h98.9zM301 302.6c54.8-29.8 90.3-50 90.3-123h98c0 131.6-80.7 176.7-140.2 209.4c-54.8 29.8-90.3 50-90.3 123h-98c0-131.6 80.7-176.8 140.2-209.4z"
    ]
};
var $ef0249c5e48bf4e3$export$ad4174fe3fc4abe2 = {
    prefix: "fab",
    iconName: "bluetooth-b",
    icon: [
        320,
        512,
        [],
        "f294",
        "M196.48 260.023l92.626-103.333L143.125 0v206.33l-86.111-86.111-31.406 31.405 108.061 108.399L25.608 368.422l31.406 31.405 86.111-86.111L145.84 512l148.552-148.644-97.912-103.333zm40.86-102.996l-49.977 49.978-.338-100.295 50.315 50.317zM187.363 313.04l49.977 49.978-50.315 50.316.338-100.294z"
    ]
};
var $ef0249c5e48bf4e3$export$628b421165d7d11a = {
    prefix: "fab",
    iconName: "square-letterboxd",
    icon: [
        448,
        512,
        [],
        "e62e",
        "M384 32c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H384zM105.1 187C66.4 187 35 218.3 35 257s31.4 70 70.1 70c24.8 0 46.5-12.8 59-32.2l.5-.7-.4-.6c-6.5-10.6-10.2-23.1-10.2-36.5c0-13.6 3.9-26.3 10.6-37.1c-12.4-19.8-34.4-32.9-59.5-32.9zM224 187c-24.8 0-46.5 12.8-59 32.2l-.5 .7 .4 .6c6.5 10.6 10.2 23.1 10.2 36.5c0 13.6-3.9 26.3-10.6 37.1C176.9 313.8 198.9 327 224 327c24.8 0 46.5-12.8 59-32.2l.5-.7-.4-.6c-6.5-10.6-10.2-23.1-10.2-36.5c0-13.6 3.9-26.3 10.6-37.1C271.1 200.2 249.1 187 224 187zm118.9 0c-24.8 0-46.5 12.8-59 32.2l-.5 .7 .4 .6c6.5 10.6 10.2 23.1 10.2 36.5c0 13.6-3.9 26.3-10.6 37.1c12.4 19.8 34.4 32.9 59.5 32.9c38.7 0 70.1-31.3 70.1-70s-31.4-70-70.1-70z"
    ]
};
var $ef0249c5e48bf4e3$export$439612f87b462a40 = {
    prefix: "fab",
    iconName: "sticker-mule",
    icon: [
        576,
        512,
        [],
        "f3f7",
        "M561.7 199.6c-1.3.3.3 0 0 0zm-6.2-77.4c-7.7-22.3-5.1-7.2-13.4-36.9-1.6-6.5-3.6-14.5-6.2-20-4.4-8.7-4.6-7.5-4.6-9.5 0-5.3 30.7-45.3 19-46.9-5.7-.6-12.2 11.6-20.6 17-8.6 4.2-8 5-10.3 5-2.6 0-5.7-3-6.2-5-2-5.7 1.9-25.9-3.6-25.9-3.6 0-12.3 24.8-17 25.8-5.2 1.3-27.9-11.4-75.1 18-25.3 13.2-86.9 65.2-87 65.3-6.7 4.7-20 4.7-35.5 16-44.4 30.1-109.6 9.4-110.7 9-110.6-26.8-128-15.2-159 11.5-20.8 17.9-23.7 36.5-24.2 38.9-4.2 20.4 5.2 48.3 6.7 64.3 1.8 19.3-2.7 17.7 7.7 98.3.5 1 4.1 0 5.1 1.5 0 8.4-3.8 12.1-4.1 13-1.5 4.5-1.5 10.5 0 16 2.3 8.2 8.2 37.2 8.2 46.9 0 41.8.4 44 2.6 49.4 3.9 10 12.5 9.1 17 12 3.1 3.5-.5 8.5 1 12.5.5 2 3.6 4 6.2 5 9.2 3.6 27 .3 29.9-2.5 1.6-1.5.5-4.5 3.1-5 5.1 0 10.8-.5 14.4-2.5 5.1-2.5 4.1-6 1.5-10.5-.4-.8-7-13.3-9.8-16-2.1-2-5.1-3-7.2-4.5-5.8-4.9-10.3-19.4-10.3-19.5-4.6-19.4-10.3-46.3-4.1-66.8 4.6-17.2 39.5-87.7 39.6-87.8 4.1-6.5 17-11.5 27.3-7 6 1.9 19.3 22 65.4 30.9 47.9 8.7 97.4-2 112.2-2 2.8 2-1.9 13-.5 38.9 0 26.4-.4 13.7-4.1 29.9-2.2 9.7 3.4 23.2-1.5 46.9-1.4 9.8-9.9 32.7-8.2 43.4.5 1 1 2 1.5 3.5.5 4.5 1.5 8.5 4.6 10 7.3 3.6 12-3.5 9.8 11.5-.7 3.1-2.6 12 1.5 15 4.4 3.7 30.6 3.4 36.5.5 2.6-1.5 1.6-4.5 6.4-7.4 1.9-.9 11.3-.4 11.3-6.5.3-1.8-9.2-19.9-9.3-20-2.6-3.5-9.2-4.5-11.3-8-6.9-10.1-1.7-52.6.5-59.4 3-11 5.6-22.4 8.7-32.4 11-42.5 10.3-50.6 16.5-68.3.8-1.8 6.4-23.1 10.3-29.9 9.3-17 21.7-32.4 33.5-47.4 18-22.9 34-46.9 52-69.8 6.1-7 8.2-13.7 18-8 10.8 5.7 21.6 7 31.9 17 14.6 12.8 10.2 18.2 11.8 22.9 1.5 5 7.7 10.5 14.9 9.5 10.4-2 13-2.5 13.4-2.5 2.6-.5 5.7-5 7.2-8 3.1-5.5 7.2-9 7.2-16.5 0-7.7-.4-2.8-20.6-52.9z"
    ]
};
var $ef0249c5e48bf4e3$export$72df0aea6a5da9de = {
    prefix: "fab",
    iconName: "creative-commons-zero",
    icon: [
        496,
        512,
        [],
        "f4f3",
        "M247.6 8C389.4 8 496 118.1 496 256c0 147.1-118.5 248-248.4 248C113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8zm.8 44.7C130.2 52.7 44.7 150.6 44.7 256c0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8.1-113.8-90.2-203.3-202.8-203.3zm-.4 60.5c-81.9 0-102.5 77.3-102.5 142.8 0 65.5 20.6 142.8 102.5 142.8S350.5 321.5 350.5 256c0-65.5-20.6-142.8-102.5-142.8zm0 53.9c3.3 0 6.4.5 9.2 1.2 5.9 5.1 8.8 12.1 3.1 21.9l-54.5 100.2c-1.7-12.7-1.9-25.1-1.9-34.4 0-28.8 2-88.9 44.1-88.9zm40.8 46.2c2.9 15.4 3.3 31.4 3.3 42.7 0 28.9-2 88.9-44.1 88.9-13.5 0-32.6-7.7-20.1-26.4l60.9-105.2z"
    ]
};
var $ef0249c5e48bf4e3$export$51de6451f4c7b107 = {
    prefix: "fab",
    iconName: "hips",
    icon: [
        640,
        512,
        [],
        "f452",
        "M251.6 157.6c0-1.9-.9-2.8-2.8-2.8h-40.9c-1.6 0-2.7 1.4-2.7 2.8v201.8c0 1.4 1.1 2.8 2.7 2.8h40.9c1.9 0 2.8-.9 2.8-2.8zM156.5 168c-16.1-11.8-36.3-17.9-60.3-18-18.1-.1-34.6 3.7-49.8 11.4V80.2c0-1.8-.9-2.7-2.8-2.7H2.7c-1.8 0-2.7.9-2.7 2.7v279.2c0 1.9.9 2.8 2.7 2.8h41c1.9 0 2.8-.9 2.8-2.8V223.3c0-.8-2.8-27 45.8-27 48.5 0 45.8 26.1 45.8 27v122.6c0 9 7.3 16.3 16.4 16.3h27.3c1.8 0 2.7-.9 2.7-2.8V223.3c0-23.4-9.3-41.8-28-55.3zm478.4 110.1c-6.8-15.7-18.4-27-34.9-34.1l-57.6-25.3c-8.6-3.6-9.2-11.2-2.6-16.1 7.4-5.5 44.3-13.9 84 6.8 1.7 1 4-.3 4-2.4v-44.7c0-1.3-.6-2.1-1.9-2.6-17.7-6.6-36.1-9.9-55.1-9.9-26.5 0-45.3 5.8-58.5 15.4-.5.4-28.4 20-22.7 53.7 3.4 19.6 15.8 34.2 37.2 43.6l53.6 23.5c11.6 5.1 15.2 13.3 12.2 21.2-3.7 9.1-13.2 13.6-36.5 13.6-24.3 0-44.7-8.9-58.4-19.1-2.1-1.4-4.4.2-4.4 2.3v34.4c0 10.4 4.9 17.3 14.6 20.7 15.6 5.5 31.6 8.2 48.2 8.2 12.7 0 25.8-1.2 36.3-4.3.7-.3 36-8.9 45.6-45.8 3.5-13.5 2.4-26.5-3.1-39.1zM376.2 149.8c-31.7 0-104.2 20.1-104.2 103.5v183.5c0 .8.6 2.7 2.7 2.7h40.9c1.9 0 2.8-.9 2.8-2.7V348c16.5 12.7 35.8 19.1 57.7 19.1 60.5 0 108.7-48.5 108.7-108.7.1-60.3-48.2-108.6-108.6-108.6zm0 170.9c-17.2 0-31.9-6.1-44-18.2-12.2-12.2-18.2-26.8-18.2-44 0-34.5 27.6-62.2 62.2-62.2 34.5 0 62.2 27.6 62.2 62.2.1 34.3-27.3 62.2-62.2 62.2zM228.3 72.5c-15.9 0-28.8 12.9-28.9 28.9 0 15.6 12.7 28.9 28.9 28.9s28.9-13.1 28.9-28.9c0-16.2-13-28.9-28.9-28.9z"
    ]
};
var $ef0249c5e48bf4e3$export$907c17a7f1d6a0d3 = {
    prefix: "fab",
    iconName: "behance",
    icon: [
        576,
        512,
        [],
        "f1b4",
        "M232 237.2c31.8-15.2 48.4-38.2 48.4-74 0-70.6-52.6-87.8-113.3-87.8H0v354.4h171.8c64.4 0 124.9-30.9 124.9-102.9 0-44.5-21.1-77.4-64.7-89.7zM77.9 135.9H151c28.1 0 53.4 7.9 53.4 40.5 0 30.1-19.7 42.2-47.5 42.2h-79v-82.7zm83.3 233.7H77.9V272h84.9c34.3 0 56 14.3 56 50.6 0 35.8-25.9 47-57.6 47zm358.5-240.7H376V94h143.7v34.9zM576 305.2c0-75.9-44.4-139.2-124.9-139.2-78.2 0-131.3 58.8-131.3 135.8 0 79.9 50.3 134.7 131.3 134.7 61.3 0 101-27.6 120.1-86.3H509c-6.7 21.9-34.3 33.5-55.7 33.5-41.3 0-63-24.2-63-65.3h185.1c.3-4.2.6-8.7.6-13.2zM390.4 274c2.3-33.7 24.7-54.8 58.5-54.8 35.4 0 53.2 20.8 56.2 54.8H390.4z"
    ]
};
var $ef0249c5e48bf4e3$export$97dd0b04d798af1a = {
    prefix: "fab",
    iconName: "reddit",
    icon: [
        512,
        512,
        [],
        "f1a1",
        "M0 256C0 114.6 114.6 0 256 0S512 114.6 512 256s-114.6 256-256 256L37.1 512c-13.7 0-20.5-16.5-10.9-26.2L75 437C28.7 390.7 0 326.7 0 256zM349.6 153.6c23.6 0 42.7-19.1 42.7-42.7s-19.1-42.7-42.7-42.7c-20.6 0-37.8 14.6-41.8 34c-34.5 3.7-61.4 33-61.4 68.4l0 .2c-37.5 1.6-71.8 12.3-99 29.1c-10.1-7.8-22.8-12.5-36.5-12.5c-33 0-59.8 26.8-59.8 59.8c0 24 14.1 44.6 34.4 54.1c2 69.4 77.6 125.2 170.6 125.2s168.7-55.9 170.6-125.3c20.2-9.6 34.1-30.2 34.1-54c0-33-26.8-59.8-59.8-59.8c-13.7 0-26.3 4.6-36.4 12.4c-27.4-17-62.1-27.7-100-29.1l0-.2c0-25.4 18.9-46.5 43.4-49.9l0 0c4.4 18.8 21.3 32.8 41.5 32.8zM177.1 246.9c16.7 0 29.5 17.6 28.5 39.3s-13.5 29.6-30.3 29.6s-31.4-8.8-30.4-30.5s15.4-38.3 32.1-38.3zm190.1 38.3c1 21.7-13.7 30.5-30.4 30.5s-29.3-7.9-30.3-29.6c-1-21.7 11.8-39.3 28.5-39.3s31.2 16.6 32.1 38.3zm-48.1 56.7c-10.3 24.6-34.6 41.9-63 41.9s-52.7-17.3-63-41.9c-1.2-2.9 .8-6.2 3.9-6.5c18.4-1.9 38.3-2.9 59.1-2.9s40.7 1 59.1 2.9c3.1 .3 5.1 3.6 3.9 6.5z"
    ]
};
var $ef0249c5e48bf4e3$export$c8d4525a5e9ad3ad = {
    prefix: "fab",
    iconName: "discord",
    icon: [
        640,
        512,
        [],
        "f392",
        "M524.531,69.836a1.5,1.5,0,0,0-.764-.7A485.065,485.065,0,0,0,404.081,32.03a1.816,1.816,0,0,0-1.923.91,337.461,337.461,0,0,0-14.9,30.6,447.848,447.848,0,0,0-134.426,0,309.541,309.541,0,0,0-15.135-30.6,1.89,1.89,0,0,0-1.924-.91A483.689,483.689,0,0,0,116.085,69.137a1.712,1.712,0,0,0-.788.676C39.068,183.651,18.186,294.69,28.43,404.354a2.016,2.016,0,0,0,.765,1.375A487.666,487.666,0,0,0,176.02,479.918a1.9,1.9,0,0,0,2.063-.676A348.2,348.2,0,0,0,208.12,430.4a1.86,1.86,0,0,0-1.019-2.588,321.173,321.173,0,0,1-45.868-21.853,1.885,1.885,0,0,1-.185-3.126c3.082-2.309,6.166-4.711,9.109-7.137a1.819,1.819,0,0,1,1.9-.256c96.229,43.917,200.41,43.917,295.5,0a1.812,1.812,0,0,1,1.924.233c2.944,2.426,6.027,4.851,9.132,7.16a1.884,1.884,0,0,1-.162,3.126,301.407,301.407,0,0,1-45.89,21.83,1.875,1.875,0,0,0-1,2.611,391.055,391.055,0,0,0,30.014,48.815,1.864,1.864,0,0,0,2.063.7A486.048,486.048,0,0,0,610.7,405.729a1.882,1.882,0,0,0,.765-1.352C623.729,277.594,590.933,167.465,524.531,69.836ZM222.491,337.58c-28.972,0-52.844-26.587-52.844-59.239S193.056,219.1,222.491,219.1c29.665,0,53.306,26.82,52.843,59.239C275.334,310.993,251.924,337.58,222.491,337.58Zm195.38,0c-28.971,0-52.843-26.587-52.843-59.239S388.437,219.1,417.871,219.1c29.667,0,53.307,26.82,52.844,59.239C470.715,310.993,447.538,337.58,417.871,337.58Z"
    ]
};
var $ef0249c5e48bf4e3$export$430df45ec2fae593 = {
    prefix: "fab",
    iconName: "chrome",
    icon: [
        512,
        512,
        [],
        "f268",
        "M0 256C0 209.4 12.47 165.6 34.27 127.1L144.1 318.3C166 357.5 207.9 384 256 384C270.3 384 283.1 381.7 296.8 377.4L220.5 509.6C95.9 492.3 0 385.3 0 256zM365.1 321.6C377.4 302.4 384 279.1 384 256C384 217.8 367.2 183.5 340.7 160H493.4C505.4 189.6 512 222.1 512 256C512 397.4 397.4 511.1 256 512L365.1 321.6zM477.8 128H256C193.1 128 142.3 172.1 130.5 230.7L54.19 98.47C101 38.53 174 0 256 0C350.8 0 433.5 51.48 477.8 128V128zM168 256C168 207.4 207.4 168 256 168C304.6 168 344 207.4 344 256C344 304.6 304.6 344 256 344C207.4 344 168 304.6 168 256z"
    ]
};
var $ef0249c5e48bf4e3$export$e36cec8e481a3a4b = {
    prefix: "fab",
    iconName: "app-store-ios",
    icon: [
        448,
        512,
        [],
        "f370",
        "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM127 384.5c-5.5 9.6-17.8 12.8-27.3 7.3-9.6-5.5-12.8-17.8-7.3-27.3l14.3-24.7c16.1-4.9 29.3-1.1 39.6 11.4L127 384.5zm138.9-53.9H84c-11 0-20-9-20-20s9-20 20-20h51l65.4-113.2-20.5-35.4c-5.5-9.6-2.2-21.8 7.3-27.3 9.6-5.5 21.8-2.2 27.3 7.3l8.9 15.4 8.9-15.4c5.5-9.6 17.8-12.8 27.3-7.3 9.6 5.5 12.8 17.8 7.3 27.3l-85.8 148.6h62.1c20.2 0 31.5 23.7 22.7 40zm98.1 0h-29l19.6 33.9c5.5 9.6 2.2 21.8-7.3 27.3-9.6 5.5-21.8 2.2-27.3-7.3-32.9-56.9-57.5-99.7-74-128.1-16.7-29-4.8-58 7.1-67.8 13.1 22.7 32.7 56.7 58.9 102h52c11 0 20 9 20 20 0 11.1-9 20-20 20z"
    ]
};
var $ef0249c5e48bf4e3$export$4a929e0a1abf7e41 = {
    prefix: "fab",
    iconName: "cc-discover",
    icon: [
        576,
        512,
        [],
        "f1f2",
        "M520.4 196.1c0-7.9-5.5-12.1-15.6-12.1h-4.9v24.9h4.7c10.3 0 15.8-4.4 15.8-12.8zM528 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-44.1 138.9c22.6 0 52.9-4.1 52.9 24.4 0 12.6-6.6 20.7-18.7 23.2l25.8 34.4h-19.6l-22.2-32.8h-2.2v32.8h-16zm-55.9.1h45.3v14H444v18.2h28.3V217H444v22.2h29.3V253H428zm-68.7 0l21.9 55.2 22.2-55.2h17.5l-35.5 84.2h-8.6l-35-84.2zm-55.9-3c24.7 0 44.6 20 44.6 44.6 0 24.7-20 44.6-44.6 44.6-24.7 0-44.6-20-44.6-44.6 0-24.7 20-44.6 44.6-44.6zm-49.3 6.1v19c-20.1-20.1-46.8-4.7-46.8 19 0 25 27.5 38.5 46.8 19.2v19c-29.7 14.3-63.3-5.7-63.3-38.2 0-31.2 33.1-53 63.3-38zm-97.2 66.3c11.4 0 22.4-15.3-3.3-24.4-15-5.5-20.2-11.4-20.2-22.7 0-23.2 30.6-31.4 49.7-14.3l-8.4 10.8c-10.4-11.6-24.9-6.2-24.9 2.5 0 4.4 2.7 6.9 12.3 10.3 18.2 6.6 23.6 12.5 23.6 25.6 0 29.5-38.8 37.4-56.6 11.3l10.3-9.9c3.7 7.1 9.9 10.8 17.5 10.8zM55.4 253H32v-82h23.4c26.1 0 44.1 17 44.1 41.1 0 18.5-13.2 40.9-44.1 40.9zm67.5 0h-16v-82h16zM544 433c0 8.2-6.8 15-15 15H128c189.6-35.6 382.7-139.2 416-160zM74.1 191.6c-5.2-4.9-11.6-6.6-21.9-6.6H48v54.2h4.2c10.3 0 17-2 21.9-6.4 5.7-5.2 8.9-12.8 8.9-20.7s-3.2-15.5-8.9-20.5z"
    ]
};
var $ef0249c5e48bf4e3$export$a24323c111493948 = {
    prefix: "fab",
    iconName: "wpbeginner",
    icon: [
        512,
        512,
        [],
        "f297",
        "M462.799 322.374C519.01 386.682 466.961 480 370.944 480c-39.602 0-78.824-17.687-100.142-50.04-6.887.356-22.702.356-29.59 0C219.848 462.381 180.588 480 141.069 480c-95.49 0-148.348-92.996-91.855-157.626C-29.925 190.523 80.479 32 256.006 32c175.632 0 285.87 158.626 206.793 290.374zm-339.647-82.972h41.529v-58.075h-41.529v58.075zm217.18 86.072v-23.839c-60.506 20.915-132.355 9.198-187.589-33.971l.246 24.897c51.101 46.367 131.746 57.875 187.343 32.913zm-150.753-86.072h166.058v-58.075H189.579v58.075z"
    ]
};
var $ef0249c5e48bf4e3$export$259f76b402dd445f = {
    prefix: "fab",
    iconName: "confluence",
    icon: [
        512,
        512,
        [],
        "f78d",
        "M2.3 412.2c-4.5 7.6-2.1 17.5 5.5 22.2l105.9 65.2c7.7 4.7 17.7 2.4 22.4-5.3 0-.1.1-.2.1-.2 67.1-112.2 80.5-95.9 280.9-.7 8.1 3.9 17.8.4 21.7-7.7.1-.1.1-.3.2-.4l50.4-114.1c3.6-8.1-.1-17.6-8.1-21.3-22.2-10.4-66.2-31.2-105.9-50.3C127.5 179 44.6 345.3 2.3 412.2zm507.4-312.1c4.5-7.6 2.1-17.5-5.5-22.2L398.4 12.8c-7.5-5-17.6-3.1-22.6 4.4-.2.3-.4.6-.6 1-67.3 112.6-81.1 95.6-280.6.9-8.1-3.9-17.8-.4-21.7 7.7-.1.1-.1.3-.2.4L22.2 141.3c-3.6 8.1.1 17.6 8.1 21.3 22.2 10.4 66.3 31.2 106 50.4 248 120 330.8-45.4 373.4-112.9z"
    ]
};
var $ef0249c5e48bf4e3$export$b4e2b27ee3ee1821 = {
    prefix: "fab",
    iconName: "shoelace",
    icon: [
        512,
        512,
        [],
        "e60c",
        "M404.9 331c2.2-1.1 4.4-2.3 6.5-3.7l8.3-4.8c1.5-1.1 4.4-3.4 8.7-6.7l.5-.5c3.4-3.4 7.2-5 11.3-4.9c1.8 0 3.9 .5 6.4 1.5l31-27.5c.9-.7 1.7-1.3 2.6-1.8h.2c3.3-1.9 6-1.8 8.2 .4c3.9 2.1 4.2 5.6 .9 10.6L456.9 322c.2 .5 .4 1 .4 1.5c.5 2.2 .3 4.4-.5 6.6c-.7 1.5-1.8 2.9-3.1 4.2c-1.4 1.4-2.7 2.8-4.2 4.2l-18.8 13.7c-1.7 1.2-3.4 2.3-5.1 3.3c-2.1 1.3-4.3 2.5-6.6 3.6c-1 .4-1.9 .9-2.9 1.3c-5.9 2.5-11.9 4.2-18.2 5c-2.9 24.5-11.3 47.1-25.1 67.8c-17.5 25.7-41.4 45.4-71.8 58.8c-30.2 13.5-63 20.2-98.2 20.2c-48.6-.5-88-11.4-118.2-32.8C49.5 454.4 32 421.5 32 380.3v-5.6c1.2-28.1 9.5-54.6 24.8-79.8c15.1-24.9 37.1-41.7 66.1-50.5c14.9-4.4 29.9-6.6 45-6.6c15.5 0 31.6 2.9 48.1 8.6s35.2 15.5 55.9 29.5L326 312.2c15.1 9.8 28.8 16.5 41.2 20c-2.6-25.1-11.7-46.6-27.3-64.5c-15.7-18.1-35.6-31.3-59.9-39.7l-23.3-8c-21.4-7.5-37.3-14.9-47.7-22.2c-28.2-19.1-43.8-45.2-47-78.5l-.5-9.8c0-32.1 13-58.9 39-80.5C223.5 9.7 251.1 0 283 0c24 0 45.6 6.9 64.7 20.8c19.2 14 30.1 33.8 32.6 59.4l.5 10c0 18.6-4.8 34.5-14.4 47.7c-9.8 13.2-18.5 19.9-26 19.9c-1.6-.1-3.1-.3-4.5-.6l-34 32c-5.5 3-9.2 2.5-11.1-1.6c-1.9-2.2-1.8-4.9 .5-8.2l.2-.2c.5-.7 1.2-1.5 2-2.4l31.6-30c-.4-1.5-.6-3.1-.6-4.8c0-4.1 1.6-7.6 4.9-10.4c13.8-12.4 20.8-26.7 20.8-42.8c0-16-6.1-29.5-18.2-40.4s-28.7-16.5-49.7-16.8c-26.2 0-47.8 7.9-64.7 23.7S192.3 89.9 192.3 112c0 17.8 6.9 33.9 20.6 48.3c13.6 14.2 34.6 25.4 63 33.5c39.8 11.5 70.2 31 91.3 58.3c18.7 24.2 29.1 51.3 31.3 81.4c2.2-.7 4.3-1.5 6.5-2.6zM294.1 178.7c0 1.1 .6 1.6 1.8 1.6c.1 0 9.7-8.9 28.8-26.6c0-2.4-5.1 .9-15.3 10c-10.2 9.2-15.3 14.2-15.3 14.9zm8 6.4c0-1-.5-1.5-1.5-1.5c-1.1 0-2.1 .5-2.9 1.6c-1.9-.1-3.3 .1-4.2 .7c-.4 .2-.5 .5-.5 .7c0 .7 .5 1.3 1.5 1.6h3.3c2.9-1.1 4.4-2.2 4.4-3.3zm22.6-19.9c0-2.8-1.6-2.8-4.9 0c-1.6 1.5-3.6 3.5-6 6.2c-.8 .6-2.6 2.2-5.3 4.9c-2.8 2.9-4.2 4.7-4.2 5.3l.2 1.3c.7 .2 1.2 .4 1.5 .4c.1 0 3.3-2.9 9.5-8.7s9.3-8.9 9.3-9.3zm159.7 120l-30.6 27c1.8 1 3.2 2.4 4 4.2l30.2-27c.2-1.2 .1-2.2-.5-2.9c-.6-.5-1.6-.9-3.1-1.3zm-1.6-.9l-.7-.7-27 21.9 1.6 2 26-23.1zM366.6 363.9c-8-2.1-15.4-4.6-22.2-7.5c-15.3-6.2-34.3-17-57-32.4L250 298.7c-15.8-10.1-30.2-17.6-43.2-22.6c-13.1-4.9-26-7.3-38.6-7.3h-5.5c-32.2 1.7-57.2 13.8-75 36.2c-16.6 20.8-25 45.3-25 73.6c0 31.8 12.8 56.7 38.2 74.7c25.4 18.1 60.2 27.1 104.4 27.1c34.7 0 64-6.2 87.8-18.6c23.7-12.4 42.1-28.8 55.2-49.2c9.8-15.5 15.9-31.8 18.2-48.8z"
    ]
};
var $ef0249c5e48bf4e3$export$7add95166ef0248a = {
    prefix: "fab",
    iconName: "mdb",
    icon: [
        576,
        512,
        [],
        "f8ca",
        "M17.37 160.41L7 352h43.91l5.59-79.83L84.43 352h44.71l25.54-77.43 4.79 77.43H205l-12.79-191.59H146.7L106 277.74 63.67 160.41zm281 0h-47.9V352h47.9s95 .8 94.2-95.79c-.78-94.21-94.18-95.78-94.18-95.78zm-1.2 146.46V204.78s46 4.27 46.8 50.57-46.78 51.54-46.78 51.54zm238.29-74.24a56.16 56.16 0 0 0 8-38.31c-5.34-35.76-55.08-34.32-55.08-34.32h-51.9v191.58H482s87 4.79 87-63.85c0-43.14-33.52-55.08-33.52-55.08zm-51.9-31.94s13.57-1.59 16 9.59c1.43 6.66-4 12-4 12h-12v-21.57zm-.1 109.46l.1-24.92V267h.08s41.58-4.73 41.19 22.43c-.33 25.65-41.35 20.74-41.35 20.74z"
    ]
};
var $ef0249c5e48bf4e3$export$81d728fa770edbe1 = {
    prefix: "fab",
    iconName: "dochub",
    icon: [
        416,
        512,
        [],
        "f394",
        "M397.9 160H256V19.6L397.9 160zM304 192v130c0 66.8-36.5 100.1-113.3 100.1H96V84.8h94.7c12 0 23.1.8 33.1 2.5v-84C212.9 1.1 201.4 0 189.2 0H0v512h189.2C329.7 512 400 447.4 400 318.1V192h-96z"
    ]
};
var $ef0249c5e48bf4e3$export$3c152d640f62968e = {
    prefix: "fab",
    iconName: "accessible-icon",
    icon: [
        448,
        512,
        [
            62107
        ],
        "f368",
        "M423.9 255.8L411 413.1c-3.3 40.7-63.9 35.1-60.6-4.9l10-122.5-41.1 2.3c10.1 20.7 15.8 43.9 15.8 68.5 0 41.2-16.1 78.7-42.3 106.5l-39.3-39.3c57.9-63.7 13.1-167.2-74-167.2-25.9 0-49.5 9.9-67.2 26L73 243.2c22-20.7 50.1-35.1 81.4-40.2l75.3-85.7-42.6-24.8-51.6 46c-30 26.8-70.6-18.5-40.5-45.4l68-60.7c9.8-8.8 24.1-10.2 35.5-3.6 0 0 139.3 80.9 139.5 81.1 16.2 10.1 20.7 36 6.1 52.6L285.7 229l106.1-5.9c18.5-1.1 33.6 14.4 32.1 32.7zm-64.9-154c28.1 0 50.9-22.8 50.9-50.9C409.9 22.8 387.1 0 359 0c-28.1 0-50.9 22.8-50.9 50.9 0 28.1 22.8 50.9 50.9 50.9zM179.6 456.5c-80.6 0-127.4-90.6-82.7-156.1l-39.7-39.7C36.4 287 24 320.3 24 356.4c0 130.7 150.7 201.4 251.4 122.5l-39.7-39.7c-16 10.9-35.3 17.3-56.1 17.3z"
    ]
};
var $ef0249c5e48bf4e3$export$ddb611ff59fc9802 = {
    prefix: "fab",
    iconName: "ebay",
    icon: [
        640,
        512,
        [],
        "f4f4",
        "M606 189.5l-54.8 109.9-54.9-109.9h-37.5l10.9 20.6c-11.5-19-35.9-26-63.3-26-31.8 0-67.9 8.7-71.5 43.1h33.7c1.4-13.8 15.7-21.8 35-21.8 26 0 41 9.6 41 33v3.4c-12.7 0-28 .1-41.7.4-42.4.9-69.6 10-76.7 34.4 1-5.2 1.5-10.6 1.5-16.2 0-52.1-39.7-76.2-75.4-76.2-21.3 0-43 5.5-58.7 24.2v-80.6h-32.1v169.5c0 10.3-.6 22.9-1.1 33.1h31.5c.7-6.3 1.1-12.9 1.1-19.5 13.6 16.6 35.4 24.9 58.7 24.9 36.9 0 64.9-21.9 73.3-54.2-.5 2.8-.7 5.8-.7 9 0 24.1 21.1 45 60.6 45 26.6 0 45.8-5.7 61.9-25.5 0 6.6.3 13.3 1.1 20.2h29.8c-.7-8.2-1-17.5-1-26.8v-65.6c0-9.3-1.7-17.2-4.8-23.8l61.5 116.1-28.5 54.1h35.9L640 189.5zM243.7 313.8c-29.6 0-50.2-21.5-50.2-53.8 0-32.4 20.6-53.8 50.2-53.8 29.8 0 50.2 21.4 50.2 53.8 0 32.3-20.4 53.8-50.2 53.8zm200.9-47.3c0 30-17.9 48.4-51.6 48.4-25.1 0-35-13.4-35-25.8 0-19.1 18.1-24.4 47.2-25.3 13.1-.5 27.6-.6 39.4-.6zm-411.9 1.6h128.8v-8.5c0-51.7-33.1-75.4-78.4-75.4-56.8 0-83 30.8-83 77.6 0 42.5 25.3 74 82.5 74 31.4 0 68-11.7 74.4-46.1h-33.1c-12 35.8-87.7 36.7-91.2-21.6zm95-21.4H33.3c6.9-56.6 92.1-54.7 94.4 0z"
    ]
};
var $ef0249c5e48bf4e3$export$ebc1e565fd80a447 = {
    prefix: "fab",
    iconName: "amazon",
    icon: [
        448,
        512,
        [],
        "f270",
        "M257.2 162.7c-48.7 1.8-169.5 15.5-169.5 117.5 0 109.5 138.3 114 183.5 43.2 6.5 10.2 35.4 37.5 45.3 46.8l56.8-56S341 288.9 341 261.4V114.3C341 89 316.5 32 228.7 32 140.7 32 94 87 94 136.3l73.5 6.8c16.3-49.5 54.2-49.5 54.2-49.5 40.7-.1 35.5 29.8 35.5 69.1zm0 86.8c0 80-84.2 68-84.2 17.2 0-47.2 50.5-56.7 84.2-57.8v40.6zm136 163.5c-7.7 10-70 67-174.5 67S34.2 408.5 9.7 379c-6.8-7.7 1-11.3 5.5-8.3C88.5 415.2 203 488.5 387.7 401c7.5-3.7 13.3 2 5.5 12zm39.8 2.2c-6.5 15.8-16 26.8-21.2 31-5.5 4.5-9.5 2.7-6.5-3.8s19.3-46.5 12.7-55c-6.5-8.3-37-4.3-48-3.2-10.8 1-13 2-14-.3-2.3-5.7 21.7-15.5 37.5-17.5 15.7-1.8 41-.8 46 5.7 3.7 5.1 0 27.1-6.5 43.1z"
    ]
};
var $ef0249c5e48bf4e3$export$3997191a5880488f = {
    prefix: "fab",
    iconName: "unsplash",
    icon: [
        448,
        512,
        [],
        "e07c",
        "M448,230.17V480H0V230.17H141.13V355.09H306.87V230.17ZM306.87,32H141.13V156.91H306.87Z"
    ]
};
var $ef0249c5e48bf4e3$export$a67629e1d516967d = {
    prefix: "fab",
    iconName: "yarn",
    icon: [
        496,
        512,
        [],
        "f7e3",
        "M393.9 345.2c-39 9.3-48.4 32.1-104 47.4 0 0-2.7 4-10.4 5.8-13.4 3.3-63.9 6-68.5 6.1-12.4.1-19.9-3.2-22-8.2-6.4-15.3 9.2-22 9.2-22-8.1-5-9-9.9-9.8-8.1-2.4 5.8-3.6 20.1-10.1 26.5-8.8 8.9-25.5 5.9-35.3.8-10.8-5.7.8-19.2.8-19.2s-5.8 3.4-10.5-3.6c-6-9.3-17.1-37.3 11.5-62-1.3-10.1-4.6-53.7 40.6-85.6 0 0-20.6-22.8-12.9-43.3 5-13.4 7-13.3 8.6-13.9 5.7-2.2 11.3-4.6 15.4-9.1 20.6-22.2 46.8-18 46.8-18s12.4-37.8 23.9-30.4c3.5 2.3 16.3 30.6 16.3 30.6s13.6-7.9 15.1-5c8.2 16 9.2 46.5 5.6 65.1-6.1 30.6-21.4 47.1-27.6 57.5-1.4 2.4 16.5 10 27.8 41.3 10.4 28.6 1.1 52.7 2.8 55.3.8 1.4 13.7.8 36.4-13.2 12.8-7.9 28.1-16.9 45.4-17 16.7-.5 17.6 19.2 4.9 22.2zM496 256c0 136.9-111.1 248-248 248S0 392.9 0 256 111.1 8 248 8s248 111.1 248 248zm-79.3 75.2c-1.7-13.6-13.2-23-28-22.8-22 .3-40.5 11.7-52.8 19.2-4.8 3-8.9 5.2-12.4 6.8 3.1-44.5-22.5-73.1-28.7-79.4 7.8-11.3 18.4-27.8 23.4-53.2 4.3-21.7 3-55.5-6.9-74.5-1.6-3.1-7.4-11.2-21-7.4-9.7-20-13-22.1-15.6-23.8-1.1-.7-23.6-16.4-41.4 28-12.2.9-31.3 5.3-47.5 22.8-2 2.2-5.9 3.8-10.1 5.4h.1c-8.4 3-12.3 9.9-16.9 22.3-6.5 17.4.2 34.6 6.8 45.7-17.8 15.9-37 39.8-35.7 82.5-34 36-11.8 73-5.6 79.6-1.6 11.1 3.7 19.4 12 23.8 12.6 6.7 30.3 9.6 43.9 2.8 4.9 5.2 13.8 10.1 30 10.1 6.8 0 58-2.9 72.6-6.5 6.8-1.6 11.5-4.5 14.6-7.1 9.8-3.1 36.8-12.3 62.2-28.7 18-11.7 24.2-14.2 37.6-17.4 12.9-3.2 21-15.1 19.4-28.2z"
    ]
};
var $ef0249c5e48bf4e3$export$c334a5e9c1f73381 = {
    prefix: "fab",
    iconName: "square-steam",
    icon: [
        448,
        512,
        [
            "steam-square"
        ],
        "f1b7",
        "M165.6 309.1c18.6 7.7 27.3 28.9 19.6 47.4s-29 27.2-47.6 19.4l-28.5-11.8c5 10.6 13.8 19.4 25.4 24.2c25.2 10.5 54.1-1.4 64.6-26.5c5.1-12.1 5.1-25.5 .1-37.7c-5.1-12.1-14.5-21.6-26.7-26.7c-12.1-5-25-4.8-36.4-.5l29.5 12.2zM448 96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V240.7l116.6 48.1c12-8.2 26.2-12.1 40.7-11.3l55.4-80.2v-1.1c0-48.2 39.3-87.5 87.6-87.5s87.6 39.3 87.6 87.5c0 49.2-40.9 88.7-89.6 87.5l-79 56.3c1.6 38.5-29.1 68.8-65.7 68.8c-31.8 0-58.5-22.7-64.5-52.7L0 319.2V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96zM241.9 196.2a58.4 58.4 0 1 0 116.8 0 58.4 58.4 0 1 0 -116.8 0zm14.6-.1a43.9 43.9 0 1 1 87.8 0 43.9 43.9 0 1 1 -87.8 0z"
    ]
};
var $ef0249c5e48bf4e3$export$b0e9b012d636da0a = $ef0249c5e48bf4e3$export$c334a5e9c1f73381;
var $ef0249c5e48bf4e3$export$4adb509bb23593b0 = {
    prefix: "fab",
    iconName: "500px",
    icon: [
        448,
        512,
        [],
        "f26e",
        "M103.3 344.3c-6.5-14.2-6.9-18.3 7.4-23.1 25.6-8 8 9.2 43.2 49.2h.3v-93.9c1.2-50.2 44-92.2 97.7-92.2 53.9 0 97.7 43.5 97.7 96.8 0 63.4-60.8 113.2-128.5 93.3-10.5-4.2-2.1-31.7 8.5-28.6 53 0 89.4-10.1 89.4-64.4 0-61-77.1-89.6-116.9-44.6-23.5 26.4-17.6 42.1-17.6 157.6 50.7 31 118.3 22 160.4-20.1 24.8-24.8 38.5-58 38.5-93 0-35.2-13.8-68.2-38.8-93.3-24.8-24.8-57.8-38.5-93.3-38.5s-68.8 13.8-93.5 38.5c-.3.3-16 16.5-21.2 23.9l-.5.6c-3.3 4.7-6.3 9.1-20.1 6.1-6.9-1.7-14.3-5.8-14.3-11.8V20c0-5 3.9-10.5 10.5-10.5h241.3c8.3 0 8.3 11.6 8.3 15.1 0 3.9 0 15.1-8.3 15.1H130.3v132.9h.3c104.2-109.8 282.8-36 282.8 108.9 0 178.1-244.8 220.3-310.1 62.8zm63.3-260.8c-.5 4.2 4.6 24.5 14.6 20.6C306 56.6 384 144.5 390.6 144.5c4.8 0 22.8-15.3 14.3-22.8-93.2-89-234.5-57-238.3-38.2zM393 414.7C283 524.6 94 475.5 61 310.5c0-12.2-30.4-7.4-28.9 3.3 24 173.4 246 256.9 381.6 121.3 6.9-7.8-12.6-28.4-20.7-20.4zM213.6 306.6c0 4 4.3 7.3 5.5 8.5 3 3 6.1 4.4 8.5 4.4 3.8 0 2.6.2 22.3-19.5 19.6 19.3 19.1 19.5 22.3 19.5 5.4 0 18.5-10.4 10.7-18.2L265.6 284l18.2-18.2c6.3-6.8-10.1-21.8-16.2-15.7L249.7 268c-18.6-18.8-18.4-19.5-21.5-19.5-5 0-18 11.7-12.4 17.3L234 284c-18.1 17.9-20.4 19.2-20.4 22.6z"
    ]
};
var $ef0249c5e48bf4e3$export$8974793285f35ac8 = {
    prefix: "fab",
    iconName: "square-vimeo",
    icon: [
        448,
        512,
        [
            "vimeo-square"
        ],
        "f194",
        "M448 96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96zM318.5 309.5C275 366 238.2 394.3 208.1 394.3c-18.7 0-34.4-17.2-47.3-51.6c-3.8-13.9-7.3-26.9-10.5-39c-18.2-68.3-28.6-107.4-46.2-107.4c-2.4 0-10.8 5-25.1 15.1L64 192c7-6.1 13.9-12.4 20.6-18.5c29.1-26.3 55.6-50.3 73.5-51.9c24.9-2.4 40.2 14.6 46 51.1c20.5 129.6 29.6 149.2 66.8 90.5c13.4-21.2 20.6-37.2 21.5-48.3c3.4-32.8-25.6-30.6-45.2-22.2c15.7-51.5 45.8-76.5 90.1-75.1c32.9 1 48.4 22.4 46.5 64c-1.4 31.1-23.2 73.8-65.3 127.9z"
    ]
};
var $ef0249c5e48bf4e3$export$78628c2da1e685b5 = $ef0249c5e48bf4e3$export$8974793285f35ac8;
var $ef0249c5e48bf4e3$export$50ef858a08ddd1e5 = {
    prefix: "fab",
    iconName: "asymmetrik",
    icon: [
        576,
        512,
        [],
        "f372",
        "M517.5 309.2c38.8-40 58.1-80 58.5-116.1.8-65.5-59.4-118.2-169.4-135C277.9 38.4 118.1 73.6 0 140.5 52 114 110.6 92.3 170.7 82.3c74.5-20.5 153-25.4 221.3-14.8C544.5 91.3 588.8 195 490.8 299.2c-10.2 10.8-22 21.1-35 30.6L304.9 103.4 114.7 388.9c-65.6-29.4-76.5-90.2-19.1-151.2 20.8-22.2 48.3-41.9 79.5-58.1 20-12.2 39.7-22.6 62-30.7-65.1 20.3-122.7 52.9-161.6 92.9-27.7 28.6-41.4 57.1-41.7 82.9-.5 35.1 23.4 65.1 68.4 83l-34.5 51.7h101.6l22-34.4c22.2 1 45.3 0 68.6-2.7l-22.8 37.1h135.5L340 406.3c18.6-5.3 36.9-11.5 54.5-18.7l45.9 71.8H542L468.6 349c18.5-12.1 35-25.5 48.9-39.8zm-187.6 80.5l-25-40.6-32.7 53.3c-23.4 3.5-46.7 5.1-69.2 4.4l101.9-159.3 78.7 123c-17.2 7.4-35.3 13.9-53.7 19.2z"
    ]
};
var $ef0249c5e48bf4e3$export$aa4baaed1c60f58d = {
    prefix: "fab",
    iconName: "font-awesome",
    icon: [
        448,
        512,
        [
            62501,
            62694,
            "font-awesome-flag",
            "font-awesome-logo-full"
        ],
        "f2b4",
        "M448 48V384C385 407 366 416 329 416C266 416 242 384 179 384C159 384 143 388 128 392V328C143 324 159 320 179 320C242 320 266 352 329 352C349 352 364 349 384 343V135C364 141 349 144 329 144C266 144 242 112 179 112C128 112 104 133 64 141V448C64 466 50 480 32 480S0 466 0 448V64C0 46 14 32 32 32S64 46 64 64V77C104 69 128 48 179 48C242 48 266 80 329 80C366 80 385 71 448 48Z"
    ]
};
var $ef0249c5e48bf4e3$export$102c25fde54d4843 = $ef0249c5e48bf4e3$export$aa4baaed1c60f58d;
var $ef0249c5e48bf4e3$export$6e20d421a2e0f320 = $ef0249c5e48bf4e3$export$aa4baaed1c60f58d;
var $ef0249c5e48bf4e3$export$cf1aa567b9609235 = {
    prefix: "fab",
    iconName: "gratipay",
    icon: [
        496,
        512,
        [],
        "f184",
        "M248 8C111.1 8 0 119.1 0 256s111.1 248 248 248 248-111.1 248-248S384.9 8 248 8zm114.6 226.4l-113 152.7-112.7-152.7c-8.7-11.9-19.1-50.4 13.6-72 28.1-18.1 54.6-4.2 68.5 11.9 15.9 17.9 46.6 16.9 61.7 0 13.9-16.1 40.4-30 68.1-11.9 32.9 21.6 22.6 60 13.8 72z"
    ]
};
var $ef0249c5e48bf4e3$export$a649d390c50fd6df = {
    prefix: "fab",
    iconName: "apple",
    icon: [
        384,
        512,
        [],
        "f179",
        "M318.7 268.7c-.2-36.7 16.4-64.4 50-84.8-18.8-26.9-47.2-41.7-84.7-44.6-35.5-2.8-74.3 20.7-88.5 20.7-15 0-49.4-19.7-76.4-19.7C63.3 141.2 4 184.8 4 273.5q0 39.3 14.4 81.2c12.8 36.7 59 126.7 107.2 125.2 25.2-.6 43-17.9 75.8-17.9 31.8 0 48.3 17.9 76.4 17.9 48.6-.7 90.4-82.5 102.6-119.3-65.2-30.7-61.7-90-61.7-91.9zm-56.6-164.2c27.3-32.4 24.8-61.9 24-72.5-24.1 1.4-52 16.4-67.9 34.9-17.5 19.8-27.8 44.3-25.6 71.9 26.1 2 49.9-11.4 69.5-34.3z"
    ]
};
var $ef0249c5e48bf4e3$export$f5cdac644000a430 = {
    prefix: "fab",
    iconName: "hive",
    icon: [
        512,
        512,
        [],
        "e07f",
        "M260.353,254.878,131.538,33.1a2.208,2.208,0,0,0-3.829.009L.3,254.887A2.234,2.234,0,0,0,.3,257.122L129.116,478.9a2.208,2.208,0,0,0,3.83-.009L260.358,257.113A2.239,2.239,0,0,0,260.353,254.878Zm39.078-25.713a2.19,2.19,0,0,0,1.9,1.111h66.509a2.226,2.226,0,0,0,1.9-3.341L259.115,33.111a2.187,2.187,0,0,0-1.9-1.111H190.707a2.226,2.226,0,0,0-1.9,3.341ZM511.7,254.886,384.9,33.112A2.2,2.2,0,0,0,382.99,32h-66.6a2.226,2.226,0,0,0-1.906,3.34L440.652,256,314.481,476.66a2.226,2.226,0,0,0,1.906,3.34h66.6a2.2,2.2,0,0,0,1.906-1.112L511.7,257.114A2.243,2.243,0,0,0,511.7,254.886ZM366.016,284.917H299.508a2.187,2.187,0,0,0-1.9,1.111l-108.8,190.631a2.226,2.226,0,0,0,1.9,3.341h66.509a2.187,2.187,0,0,0,1.9-1.111l108.8-190.631A2.226,2.226,0,0,0,366.016,284.917Z"
    ]
};
var $ef0249c5e48bf4e3$export$cd2223c7b77bd41c = {
    prefix: "fab",
    iconName: "gitkraken",
    icon: [
        592,
        512,
        [],
        "f3a6",
        "M565.7 118.1c-2.3-6.1-9.3-9.2-15.3-6.6-5.7 2.4-8.5 8.9-6.3 14.6 10.9 29 16.9 60.5 16.9 93.3 0 134.6-100.3 245.7-230.2 262.7V358.4c7.9-1.5 15.5-3.6 23-6.2v104c106.7-25.9 185.9-122.1 185.9-236.8 0-91.8-50.8-171.8-125.8-213.3-5.7-3.2-13-.9-15.9 5-2.7 5.5-.6 12.2 4.7 15.1 67.9 37.6 113.9 110 113.9 193.2 0 93.3-57.9 173.1-139.8 205.4v-92.2c14.2-4.5 24.9-17.7 24.9-33.5 0-13.1-6.8-24.4-17.3-30.5 8.3-79.5 44.5-58.6 44.5-83.9V170c0-38-87.9-161.8-129-164.7-2.5-.2-5-.2-7.6 0C251.1 8.3 163.2 132 163.2 170v14.8c0 25.3 36.3 4.3 44.5 83.9-10.6 6.1-17.3 17.4-17.3 30.5 0 15.8 10.6 29 24.8 33.5v92.2c-81.9-32.2-139.8-112-139.8-205.4 0-83.1 46-155.5 113.9-193.2 5.4-3 7.4-9.6 4.7-15.1-2.9-5.9-10.1-8.2-15.9-5-75 41.5-125.8 121.5-125.8 213.3 0 114.7 79.2 210.8 185.9 236.8v-104c7.6 2.5 15.1 4.6 23 6.2v123.7C131.4 465.2 31 354.1 31 219.5c0-32.8 6-64.3 16.9-93.3 2.2-5.8-.6-12.2-6.3-14.6-6-2.6-13 .4-15.3 6.6C14.5 149.7 8 183.8 8 219.5c0 155.1 122.6 281.6 276.3 287.8V361.4c6.8.4 15 .5 23.4 0v145.8C461.4 501.1 584 374.6 584 219.5c0-35.7-6.5-69.8-18.3-101.4zM365.9 275.5c13 0 23.7 10.5 23.7 23.7 0 13.1-10.6 23.7-23.7 23.7-13 0-23.7-10.5-23.7-23.7 0-13.1 10.6-23.7 23.7-23.7zm-139.8 47.3c-13.2 0-23.7-10.7-23.7-23.7s10.5-23.7 23.7-23.7c13.1 0 23.7 10.6 23.7 23.7 0 13-10.5 23.7-23.7 23.7z"
    ]
};
var $ef0249c5e48bf4e3$export$c80d8749c6106849 = {
    prefix: "fab",
    iconName: "keybase",
    icon: [
        448,
        512,
        [],
        "f4f5",
        "M286.17 419a18 18 0 1 0 18 18 18 18 0 0 0-18-18zm111.92-147.6c-9.5-14.62-39.37-52.45-87.26-73.71q-9.1-4.06-18.38-7.27a78.43 78.43 0 0 0-47.88-104.13c-12.41-4.1-23.33-6-32.41-5.77-.6-2-1.89-11 9.4-35L198.66 32l-5.48 7.56c-8.69 12.06-16.92 23.55-24.34 34.89a51 51 0 0 0-8.29-1.25c-41.53-2.45-39-2.33-41.06-2.33-50.61 0-50.75 52.12-50.75 45.88l-2.36 36.68c-1.61 27 19.75 50.21 47.63 51.85l8.93.54a214 214 0 0 0-46.29 35.54C14 304.66 14 374 14 429.77v33.64l23.32-29.8a148.6 148.6 0 0 0 14.56 37.56c5.78 10.13 14.87 9.45 19.64 7.33 4.21-1.87 10-6.92 3.75-20.11a178.29 178.29 0 0 1-15.76-53.13l46.82-59.83-24.66 74.11c58.23-42.4 157.38-61.76 236.25-38.59 34.2 10.05 67.45.69 84.74-23.84.72-1 1.2-2.16 1.85-3.22a156.09 156.09 0 0 1 2.8 28.43c0 23.3-3.69 52.93-14.88 81.64-2.52 6.46 1.76 14.5 8.6 15.74 7.42 1.57 15.33-3.1 18.37-11.15C429 443 434 414 434 382.32c0-38.58-13-77.46-35.91-110.92zM142.37 128.58l-15.7-.93-1.39 21.79 13.13.78a93 93 0 0 0 .32 19.57l-22.38-1.34a12.28 12.28 0 0 1-11.76-12.79L107 119c1-12.17 13.87-11.27 13.26-11.32l29.11 1.73a144.35 144.35 0 0 0-7 19.17zm148.42 172.18a10.51 10.51 0 0 1-14.35-1.39l-9.68-11.49-34.42 27a8.09 8.09 0 0 1-11.13-1.08l-15.78-18.64a7.38 7.38 0 0 1 1.34-10.34l34.57-27.18-14.14-16.74-17.09 13.45a7.75 7.75 0 0 1-10.59-1s-3.72-4.42-3.8-4.53a7.38 7.38 0 0 1 1.37-10.34L214 225.19s-18.51-22-18.6-22.14a9.56 9.56 0 0 1 1.74-13.42 10.38 10.38 0 0 1 14.3 1.37l81.09 96.32a9.58 9.58 0 0 1-1.74 13.44zM187.44 419a18 18 0 1 0 18 18 18 18 0 0 0-18-18z"
    ]
};
var $ef0249c5e48bf4e3$export$fbfbf4eeb373a6ab = {
    prefix: "fab",
    iconName: "apple-pay",
    icon: [
        640,
        512,
        [],
        "f415",
        "M116.9 158.5c-7.5 8.9-19.5 15.9-31.5 14.9-1.5-12 4.4-24.8 11.3-32.6 7.5-9.1 20.6-15.6 31.3-16.1 1.2 12.4-3.7 24.7-11.1 33.8m10.9 17.2c-17.4-1-32.3 9.9-40.5 9.9-8.4 0-21-9.4-34.8-9.1-17.9.3-34.5 10.4-43.6 26.5-18.8 32.3-4.9 80 13.3 106.3 8.9 13 19.5 27.3 33.5 26.8 13.3-.5 18.5-8.6 34.5-8.6 16.1 0 20.8 8.6 34.8 8.4 14.5-.3 23.6-13 32.5-26 10.1-14.8 14.3-29.1 14.5-29.9-.3-.3-28-10.9-28.3-42.9-.3-26.8 21.9-39.5 22.9-40.3-12.5-18.6-32-20.6-38.8-21.1m100.4-36.2v194.9h30.3v-66.6h41.9c38.3 0 65.1-26.3 65.1-64.3s-26.4-64-64.1-64h-73.2zm30.3 25.5h34.9c26.3 0 41.3 14 41.3 38.6s-15 38.8-41.4 38.8h-34.8V165zm162.2 170.9c19 0 36.6-9.6 44.6-24.9h.6v23.4h28v-97c0-28.1-22.5-46.3-57.1-46.3-32.1 0-55.9 18.4-56.8 43.6h27.3c2.3-12 13.4-19.9 28.6-19.9 18.5 0 28.9 8.6 28.9 24.5v10.8l-37.8 2.3c-35.1 2.1-54.1 16.5-54.1 41.5.1 25.2 19.7 42 47.8 42zm8.2-23.1c-16.1 0-26.4-7.8-26.4-19.6 0-12.3 9.9-19.4 28.8-20.5l33.6-2.1v11c0 18.2-15.5 31.2-36 31.2zm102.5 74.6c29.5 0 43.4-11.3 55.5-45.4L640 193h-30.8l-35.6 115.1h-.6L537.4 193h-31.6L557 334.9l-2.8 8.6c-4.6 14.6-12.1 20.3-25.5 20.3-2.4 0-7-.3-8.9-.5v23.4c1.8.4 9.3.7 11.6.7z"
    ]
};
var $ef0249c5e48bf4e3$export$369427eba18eb826 = {
    prefix: "fab",
    iconName: "padlet",
    icon: [
        640,
        512,
        [],
        "e4a0",
        "M297.9 0L298 .001C305.6 .1078 312.4 4.72 315.5 11.78L447.5 320.3L447.8 320.2L448 320.6L445.2 330.6L402.3 488.6C398.6 504.8 382.6 514.9 366.5 511.2L298.1 495.6L229.6 511.2C213.5 514.9 197.5 504.8 193.8 488.6L150.9 330.6L148.2 320.6L148.3 320.2L280.4 11.78C283.4 4.797 290.3 .1837 297.9 .0006L297.9 0zM160.1 322.1L291.1 361.2L298 483.7L305.9 362.2L436.5 322.9L436.7 322.8L305.7 347.9L297.1 27.72L291.9 347.9L160.1 322.1zM426 222.6L520.4 181.6H594.2L437.2 429.2L468.8 320.2L426 222.6zM597.5 181.4L638.9 257.6C642.9 265.1 635 273.5 627.3 269.8L579.7 247.1L597.5 181.4zM127.3 318.5L158.7 430L1.61 154.5C-4.292 144.1 7.128 132.5 17.55 138.3L169.4 222.5L127.3 318.5z"
    ]
};
var $ef0249c5e48bf4e3$export$448eb0f9d8323c85 = {
    prefix: "fab",
    iconName: "amazon-pay",
    icon: [
        640,
        512,
        [],
        "f42c",
        "M14 325.3c2.3-4.2 5.2-4.9 9.7-2.5 10.4 5.6 20.6 11.4 31.2 16.7a595.88 595.88 0 0 0 127.4 46.3 616.61 616.61 0 0 0 63.2 11.8 603.33 603.33 0 0 0 95 5.2c17.4-.4 34.8-1.8 52.1-3.8a603.66 603.66 0 0 0 163.3-42.8c2.9-1.2 5.9-2 9.1-1.2 6.7 1.8 9 9 4.1 13.9a70 70 0 0 1-9.6 7.4c-30.7 21.1-64.2 36.4-99.6 47.9a473.31 473.31 0 0 1-75.1 17.6 431 431 0 0 1-53.2 4.8 21.3 21.3 0 0 0-2.5.3H308a21.3 21.3 0 0 0-2.5-.3c-3.6-.2-7.2-.3-10.7-.4a426.3 426.3 0 0 1-50.4-5.3A448.4 448.4 0 0 1 164 420a443.33 443.33 0 0 1-145.6-87c-1.8-1.6-3-3.8-4.4-5.7zM172 65.1l-4.3.6a80.92 80.92 0 0 0-38 15.1c-2.4 1.7-4.6 3.5-7.1 5.4a4.29 4.29 0 0 1-.4-1.4c-.4-2.7-.8-5.5-1.3-8.2-.7-4.6-3-6.6-7.6-6.6h-11.5c-6.9 0-8.2 1.3-8.2 8.2v209.3c0 1 0 2 .1 3 .2 3 2 4.9 4.9 5 7 .1 14.1.1 21.1 0 2.9 0 4.7-2 5-5 .1-1 .1-2 .1-3v-72.4c1.1.9 1.7 1.4 2.2 1.9 17.9 14.9 38.5 19.8 61 15.4 20.4-4 34.6-16.5 43.8-34.9 7-13.9 9.9-28.7 10.3-44.1.5-17.1-1.2-33.9-8.1-49.8-8.5-19.6-22.6-32.5-43.9-36.9-3.2-.7-6.5-1-9.8-1.5-2.8-.1-5.5-.1-8.3-.1zM124.6 107a3.48 3.48 0 0 1 1.7-3.3c13.7-9.5 28.8-14.5 45.6-13.2 14.9 1.1 27.1 8.4 33.5 25.9 3.9 10.7 4.9 21.8 4.9 33 0 10.4-.8 20.6-4 30.6-6.8 21.3-22.4 29.4-42.6 28.5-14-.6-26.2-6-37.4-13.9a3.57 3.57 0 0 1-1.7-3.3c.1-14.1 0-28.1 0-42.2s.1-28 0-42.1zm205.7-41.9c-1 .1-2 .3-2.9.4a148 148 0 0 0-28.9 4.1c-6.1 1.6-12 3.8-17.9 5.8-3.6 1.2-5.4 3.8-5.3 7.7.1 3.3-.1 6.6 0 9.9.1 4.8 2.1 6.1 6.8 4.9 7.8-2 15.6-4.2 23.5-5.7 12.3-2.3 24.7-3.3 37.2-1.4 6.5 1 12.6 2.9 16.8 8.4 3.7 4.8 5.1 10.5 5.3 16.4.3 8.3.2 16.6.3 24.9a7.84 7.84 0 0 1-.2 1.4c-.5-.1-.9 0-1.3-.1a180.56 180.56 0 0 0-32-4.9c-11.3-.6-22.5.1-33.3 3.9-12.9 4.5-23.3 12.3-29.4 24.9-4.7 9.8-5.4 20.2-3.9 30.7 2 14 9 24.8 21.4 31.7 11.9 6.6 24.8 7.4 37.9 5.4 15.1-2.3 28.5-8.7 40.3-18.4a7.36 7.36 0 0 1 1.6-1.1c.6 3.8 1.1 7.4 1.8 11 .6 3.1 2.5 5.1 5.4 5.2 5.4.1 10.9.1 16.3 0a4.84 4.84 0 0 0 4.8-4.7 26.2 26.2 0 0 0 .1-2.8v-106a80 80 0 0 0-.9-12.9c-1.9-12.9-7.4-23.5-19-30.4-6.7-4-14.1-6-21.8-7.1-3.6-.5-7.2-.8-10.8-1.3-3.9.1-7.9.1-11.9.1zm35 127.7a3.33 3.33 0 0 1-1.5 3c-11.2 8.1-23.5 13.5-37.4 14.9-5.7.6-11.4.4-16.8-1.8a20.08 20.08 0 0 1-12.4-13.3 32.9 32.9 0 0 1-.1-19.4c2.5-8.3 8.4-13 16.4-15.6a61.33 61.33 0 0 1 24.8-2.2c8.4.7 16.6 2.3 25 3.4 1.6.2 2.1 1 2.1 2.6-.1 4.8 0 9.5 0 14.3s-.2 9.4-.1 14.1zm259.9 129.4c-1-5-4.8-6.9-9.1-8.3a88.42 88.42 0 0 0-21-3.9 147.32 147.32 0 0 0-39.2 1.9c-14.3 2.7-27.9 7.3-40 15.6a13.75 13.75 0 0 0-3.7 3.5 5.11 5.11 0 0 0-.5 4c.4 1.5 2.1 1.9 3.6 1.8a16.2 16.2 0 0 0 2.2-.1c7.8-.8 15.5-1.7 23.3-2.5 11.4-1.1 22.9-1.8 34.3-.9a71.64 71.64 0 0 1 14.4 2.7c5.1 1.4 7.4 5.2 7.6 10.4.4 8-1.4 15.7-3.5 23.3-4.1 15.4-10 30.3-15.8 45.1a17.6 17.6 0 0 0-1 3c-.5 2.9 1.2 4.8 4.1 4.1a10.56 10.56 0 0 0 4.8-2.5 145.91 145.91 0 0 0 12.7-13.4c12.8-16.4 20.3-35.3 24.7-55.6.8-3.6 1.4-7.3 2.1-10.9v-17.3zM493.1 199q-19.35-53.55-38.7-107.2c-2-5.7-4.2-11.3-6.3-16.9-1.1-2.9-3.2-4.8-6.4-4.8-7.6-.1-15.2-.2-22.9-.1-2.5 0-3.7 2-3.2 4.5a43.1 43.1 0 0 0 1.9 6.1q29.4 72.75 59.1 145.5c1.7 4.1 2.1 7.6.2 11.8-3.3 7.3-5.9 15-9.3 22.3-3 6.5-8 11.4-15.2 13.3a42.13 42.13 0 0 1-15.4 1.1c-2.5-.2-5-.8-7.5-1-3.4-.2-5.1 1.3-5.2 4.8q-.15 5 0 9.9c.1 5.5 2 8 7.4 8.9a108.18 108.18 0 0 0 16.9 2c17.1.4 30.7-6.5 39.5-21.4a131.63 131.63 0 0 0 9.2-18.4q35.55-89.7 70.6-179.6a26.62 26.62 0 0 0 1.6-5.5c.4-2.8-.9-4.4-3.7-4.4-6.6-.1-13.3 0-19.9 0a7.54 7.54 0 0 0-7.7 5.2c-.5 1.4-1.1 2.7-1.6 4.1l-34.8 100c-2.5 7.2-5.1 14.5-7.7 22.2-.4-1.1-.6-1.7-.9-2.4z"
    ]
};
var $ef0249c5e48bf4e3$export$be5db653ba5b5871 = {
    prefix: "fab",
    iconName: "square-github",
    icon: [
        448,
        512,
        [
            "github-square"
        ],
        "f092",
        "M448 96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96zM265.8 407.7c0-1.8 0-6 .1-11.6c.1-11.4 .1-28.8 .1-43.7c0-15.6-5.2-25.5-11.3-30.7c37-4.1 76-9.2 76-73.1c0-18.2-6.5-27.3-17.1-39c1.7-4.3 7.4-22-1.7-45c-13.9-4.3-45.7 17.9-45.7 17.9c-13.2-3.7-27.5-5.6-41.6-5.6s-28.4 1.9-41.6 5.6c0 0-31.8-22.2-45.7-17.9c-9.1 22.9-3.5 40.6-1.7 45c-10.6 11.7-15.6 20.8-15.6 39c0 63.6 37.3 69 74.3 73.1c-4.8 4.3-9.1 11.7-10.6 22.3c-9.5 4.3-33.8 11.7-48.3-13.9c-9.1-15.8-25.5-17.1-25.5-17.1c-16.2-.2-1.1 10.2-1.1 10.2c10.8 5 18.4 24.2 18.4 24.2c9.7 29.7 56.1 19.7 56.1 19.7c0 9 .1 21.7 .1 30.6c0 4.8 .1 8.6 .1 10c0 4.3-3 9.5-11.5 8C106 393.6 59.8 330.8 59.8 257.4c0-91.8 70.2-161.5 162-161.5s166.2 69.7 166.2 161.5c.1 73.4-44.7 136.3-110.7 158.3c-8.4 1.5-11.5-3.7-11.5-8zm-90.5-54.8c-.2-1.5 1.1-2.8 3-3.2c1.9-.2 3.7 .6 3.9 1.9c.3 1.3-1 2.6-3 3c-1.9 .4-3.7-.4-3.9-1.7zm-9.1 3.2c-2.2 .2-3.7-.9-3.7-2.4c0-1.3 1.5-2.4 3.5-2.4c1.9-.2 3.7 .9 3.7 2.4c0 1.3-1.5 2.4-3.5 2.4zm-14.3-2.2c-1.9-.4-3.2-1.9-2.8-3.2s2.4-1.9 4.1-1.5c2 .6 3.3 2.1 2.8 3.4c-.4 1.3-2.4 1.9-4.1 1.3zm-12.5-7.3c-1.5-1.3-1.9-3.2-.9-4.1c.9-1.1 2.8-.9 4.3 .6c1.3 1.3 1.8 3.3 .9 4.1c-.9 1.1-2.8 .9-4.3-.6zm-8.5-10c-1.1-1.5-1.1-3.2 0-3.9c1.1-.9 2.8-.2 3.7 1.3c1.1 1.5 1.1 3.3 0 4.1c-.9 .6-2.6 0-3.7-1.5zm-6.3-8.8c-1.1-1.3-1.3-2.8-.4-3.5c.9-.9 2.4-.4 3.5 .6c1.1 1.3 1.3 2.8 .4 3.5c-.9 .9-2.4 .4-3.5-.6zm-6-6.4c-1.3-.6-1.9-1.7-1.5-2.6c.4-.6 1.5-.9 2.8-.4c1.3 .7 1.9 1.8 1.5 2.6c-.4 .9-1.7 1.1-2.8 .4z"
    ]
};
var $ef0249c5e48bf4e3$export$5fe0a956971aa3c2 = $ef0249c5e48bf4e3$export$be5db653ba5b5871;
var $ef0249c5e48bf4e3$export$7872bf6ac6945976 = {
    prefix: "fab",
    iconName: "stumbleupon",
    icon: [
        512,
        512,
        [],
        "f1a4",
        "M502.9 266v69.7c0 62.1-50.3 112.4-112.4 112.4-61.8 0-112.4-49.8-112.4-111.3v-70.2l34.3 16 51.1-15.2V338c0 14.7 12 26.5 26.7 26.5S417 352.7 417 338v-72h85.9zm-224.7-58.2l34.3 16 51.1-15.2V173c0-60.5-51.1-109-112.1-109-60.8 0-112.1 48.2-112.1 108.2v162.4c0 14.9-12 26.7-26.7 26.7S86 349.5 86 334.6V266H0v69.7C0 397.7 50.3 448 112.4 448c61.6 0 112.4-49.5 112.4-110.8V176.9c0-14.7 12-26.7 26.7-26.7s26.7 12 26.7 26.7v30.9z"
    ]
};
var $ef0249c5e48bf4e3$export$c9127779112e2ff8 = {
    prefix: "fab",
    iconName: "fedex",
    icon: [
        640,
        512,
        [],
        "f797",
        "M586 284.5l53.3-59.9h-62.4l-21.7 24.8-22.5-24.8H414v-16h56.1v-48.1H318.9V236h-.5c-9.6-11-21.5-14.8-35.4-14.8-28.4 0-49.8 19.4-57.3 44.9-18-59.4-97.4-57.6-121.9-14v-24.2H49v-26.2h60v-41.1H0V345h49v-77.5h48.9c-1.5 5.7-2.3 11.8-2.3 18.2 0 73.1 102.6 91.4 130.2 23.7h-42c-14.7 20.9-45.8 8.9-45.8-14.6h85.5c3.7 30.5 27.4 56.9 60.1 56.9 14.1 0 27-6.9 34.9-18.6h.5V345h212.2l22.1-25 22.3 25H640l-54-60.5zm-446.7-16.6c6.1-26.3 41.7-25.6 46.5 0h-46.5zm153.4 48.9c-34.6 0-34-62.8 0-62.8 32.6 0 34.5 62.8 0 62.8zm167.8 19.1h-94.4V169.4h95v30.2H405v33.9h55.5v28.1h-56.1v44.7h56.1v29.6zm-45.9-39.8v-24.4h56.1v-44l50.7 57-50.7 57v-45.6h-56.1zm138.6 10.3l-26.1 29.5H489l45.6-51.2-45.6-51.2h39.7l26.6 29.3 25.6-29.3h38.5l-45.4 51 46 51.4h-40.5l-26.3-29.5z"
    ]
};
var $ef0249c5e48bf4e3$export$3d9357caf53f9b59 = {
    prefix: "fab",
    iconName: "phoenix-framework",
    icon: [
        640,
        512,
        [],
        "f3dc",
        "M212.9 344.3c3.8-.1 22.8-1.4 25.6-2.2-2.4-2.6-43.6-1-68-49.6-4.3-8.6-7.5-17.6-6.4-27.6 2.9-25.5 32.9-30 52-18.5 36 21.6 63.3 91.3 113.7 97.5 37 4.5 84.6-17 108.2-45.4-.6-.1-.8-.2-1-.1-.4.1-.8.2-1.1.3-33.3 12.1-94.3 9.7-134.7-14.8-37.6-22.8-53.1-58.7-51.8-74.6 1.8-21.3 22.9-23.2 35.9-19.6 14.4 3.9 24.4 17.6 38.9 27.4 15.6 10.4 32.9 13.7 51.3 10.3 14.9-2.7 34.4-12.3 36.5-14.5-1.1-.1-1.8-.1-2.5-.2-6.2-.6-12.4-.8-18.5-1.7C279.8 194.5 262.1 47.4 138.5 37.9 94.2 34.5 39.1 46 2.2 72.9c-.8.6-1.5 1.2-2.2 1.8.1.2.1.3.2.5.8 0 1.6-.1 2.4-.2 6.3-1 12.5-.8 18.7.3 23.8 4.3 47.7 23.1 55.9 76.5 5.3 34.3-.7 50.8 8 86.1 19 77.1 91 107.6 127.7 106.4zM75.3 64.9c-.9-1-.9-1.2-1.3-2 12.1-2.6 24.2-4.1 36.6-4.8-1.1 14.7-22.2 21.3-35.3 6.8zm196.9 350.5c-42.8 1.2-92-26.7-123.5-61.4-4.6-5-16.8-20.2-18.6-23.4l.4-.4c6.6 4.1 25.7 18.6 54.8 27 24.2 7 48.1 6.3 71.6-3.3 22.7-9.3 41-.5 43.1 2.9-18.5 3.8-20.1 4.4-24 7.9-5.1 4.4-4.6 11.7 7 17.2 26.2 12.4 63-2.8 97.2 25.4 2.4 2 8.1 7.8 10.1 10.7-.1.2-.3.3-.4.5-4.8-1.5-16.4-7.5-40.2-9.3-24.7-2-46.3 5.3-77.5 6.2zm174.8-252c16.4-5.2 41.3-13.4 66.5-3.3 16.1 6.5 26.2 18.7 32.1 34.6 3.5 9.4 5.1 19.7 5.1 28.7-.2 0-.4 0-.6.1-.2-.4-.4-.9-.5-1.3-5-22-29.9-43.8-67.6-29.9-50.2 18.6-130.4 9.7-176.9-48-.7-.9-2.4-1.7-1.3-3.2.1-.2 2.1.6 3 1.3 18.1 13.4 38.3 21.9 60.3 26.2 30.5 6.1 54.6 2.9 79.9-5.2zm102.7 117.5c-32.4.2-33.8 50.1-103.6 64.4-18.2 3.7-38.7 4.6-44.9 4.2v-.4c2.8-1.5 14.7-2.6 29.7-16.6 7.9-7.3 15.3-15.1 22.8-22.9 19.5-20.2 41.4-42.2 81.9-39 23.1 1.8 29.3 8.2 36.1 12.7.3.2.4.5.7.9-.5 0-.7.1-.9 0-7-2.7-14.3-3.3-21.8-3.3zm-12.3-24.1c-.1.2-.1.4-.2.6-28.9-4.4-48-7.9-68.5 4-17 9.9-31.4 20.5-62 24.4-27.1 3.4-45.1 2.4-66.1-8-.3-.2-.6-.4-1-.6 0-.2.1-.3.1-.5 24.9 3.8 36.4 5.1 55.5-5.8 22.3-12.9 40.1-26.6 71.3-31 29.6-4.1 51.3 2.5 70.9 16.9zM268.6 97.3c-.6-.6-1.1-1.2-2.1-2.3 7.6 0 29.7-1.2 53.4 8.4 19.7 8 32.2 21 50.2 32.9 11.1 7.3 23.4 9.3 36.4 8.1 4.3-.4 8.5-1.2 12.8-1.7.4-.1.9 0 1.5.3-.6.4-1.2.9-1.8 1.2-8.1 4-16.7 6.3-25.6 7.1-26.1 2.6-50.3-3.7-73.4-15.4-19.3-9.9-36.4-22.9-51.4-38.6zM640 335.7c-3.5 3.1-22.7 11.6-42.7 5.3-12.3-3.9-19.5-14.9-31.6-24.1-10-7.6-20.9-7.9-28.1-8.4.6-.8.9-1.2 1.2-1.4 14.8-9.2 30.5-12.2 47.3-6.5 12.5 4.2 19.2 13.5 30.4 24.2 10.8 10.4 21 9.9 23.1 10.5.1-.1.2 0 .4.4zm-212.5 137c2.2 1.2 1.6 1.5 1.5 2-18.5-1.4-33.9-7.6-46.8-22.2-21.8-24.7-41.7-27.9-48.6-29.7.5-.2.8-.4 1.1-.4 13.1.1 26.1.7 38.9 3.9 25.3 6.4 35 25.4 41.6 35.3 3.2 4.8 7.3 8.3 12.3 11.1z"
    ]
};
var $ef0249c5e48bf4e3$export$c18d8940c93637ce = {
    prefix: "fab",
    iconName: "shopify",
    icon: [
        448,
        512,
        [],
        "e057",
        "M388.32,104.1a4.66,4.66,0,0,0-4.4-4c-2,0-37.23-.8-37.23-.8s-21.61-20.82-29.62-28.83V503.2L442.76,472S388.72,106.5,388.32,104.1ZM288.65,70.47a116.67,116.67,0,0,0-7.21-17.61C271,32.85,255.42,22,237,22a15,15,0,0,0-4,.4c-.4-.8-1.2-1.2-1.6-2C223.4,11.63,213,7.63,200.58,8c-24,.8-48,18-67.25,48.83-13.61,21.62-24,48.84-26.82,70.06-27.62,8.4-46.83,14.41-47.23,14.81-14,4.4-14.41,4.8-16,18-1.2,10-38,291.82-38,291.82L307.86,504V65.67a41.66,41.66,0,0,0-4.4.4S297.86,67.67,288.65,70.47ZM233.41,87.69c-16,4.8-33.63,10.4-50.84,15.61,4.8-18.82,14.41-37.63,25.62-50,4.4-4.4,10.41-9.61,17.21-12.81C232.21,54.86,233.81,74.48,233.41,87.69ZM200.58,24.44A27.49,27.49,0,0,1,215,28c-6.4,3.2-12.81,8.41-18.81,14.41-15.21,16.42-26.82,42-31.62,66.45-14.42,4.41-28.83,8.81-42,12.81C131.33,83.28,163.75,25.24,200.58,24.44ZM154.15,244.61c1.6,25.61,69.25,31.22,73.25,91.66,2.8,47.64-25.22,80.06-65.65,82.47-48.83,3.2-75.65-25.62-75.65-25.62l10.4-44s26.82,20.42,48.44,18.82c14-.8,19.22-12.41,18.81-20.42-2-33.62-57.24-31.62-60.84-86.86-3.2-46.44,27.22-93.27,94.47-97.68,26-1.6,39.23,4.81,39.23,4.81L221.4,225.39s-17.21-8-37.63-6.4C154.15,221,153.75,239.8,154.15,244.61ZM249.42,82.88c0-12-1.6-29.22-7.21-43.63,18.42,3.6,27.22,24,31.23,36.43Q262.63,78.68,249.42,82.88Z"
    ]
};
var $ef0249c5e48bf4e3$export$a38c2efcceaf5a01 = {
    prefix: "fab",
    iconName: "neos",
    icon: [
        512,
        512,
        [],
        "f612",
        "M415.44 512h-95.11L212.12 357.46v91.1L125.69 512H28V29.82L68.47 0h108.05l123.74 176.13V63.45L386.69 0h97.69v461.5zM38.77 35.27V496l72-52.88V194l215.5 307.64h84.79l52.35-38.17h-78.27L69 13zm82.54 466.61l80-58.78v-101l-79.76-114.4v220.94L49 501.89h72.34zM80.63 10.77l310.6 442.57h82.37V10.77h-79.75v317.56L170.91 10.77zM311 191.65l72 102.81V15.93l-72 53v122.72z"
    ]
};
var $ef0249c5e48bf4e3$export$75f15eb229650b3a = {
    prefix: "fab",
    iconName: "square-threads",
    icon: [
        448,
        512,
        [],
        "e619",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM294.2 244.3c19.5 9.3 33.7 23.5 41.2 40.9c10.4 24.3 11.4 63.9-20.2 95.4c-24.2 24.1-53.5 35-95.1 35.3h-.2c-46.8-.3-82.8-16.1-106.9-46.8C91.5 341.8 80.4 303.7 80 256v-.1-.1c.4-47.7 11.5-85.7 33-113.1c24.2-30.7 60.2-46.5 106.9-46.8h.2c46.9 .3 83.3 16 108.2 46.6c12.3 15.1 21.3 33.3 27 54.4l-26.9 7.2c-4.7-17.2-11.9-31.9-21.4-43.6c-19.4-23.9-48.7-36.1-87-36.4c-38 .3-66.8 12.5-85.5 36.2c-17.5 22.3-26.6 54.4-26.9 95.5c.3 41.1 9.4 73.3 26.9 95.5c18.7 23.8 47.4 36 85.5 36.2c34.3-.3 56.9-8.4 75.8-27.3c21.5-21.5 21.1-47.9 14.2-64c-4-9.4-11.4-17.3-21.3-23.3c-2.4 18-7.9 32.2-16.5 43.2c-11.4 14.5-27.7 22.4-48.4 23.5c-15.7 .9-30.8-2.9-42.6-10.7c-13.9-9.2-22-23.2-22.9-39.5c-1.7-32.2 23.8-55.3 63.5-57.6c14.1-.8 27.3-.2 39.5 1.9c-1.6-9.9-4.9-17.7-9.8-23.4c-6.7-7.8-17.1-11.8-30.8-11.9h-.4c-11 0-26 3.1-35.6 17.6l-23-15.8c12.8-19.4 33.6-30.1 58.5-30.1h.6c41.8 .3 66.6 26.3 69.1 71.8c1.4 .6 2.8 1.2 4.2 1.9l.1 .5zm-71.8 67.5c17-.9 36.4-7.6 39.7-48.8c-8.8-1.9-18.6-2.9-29-2.9c-3.2 0-6.4 .1-9.6 .3c-28.6 1.6-38.1 15.5-37.4 27.9c.9 16.7 19 24.5 36.4 23.6l-.1-.1z"
    ]
};
var $ef0249c5e48bf4e3$export$5fb7eeed7d5e4dea = {
    prefix: "fab",
    iconName: "hackerrank",
    icon: [
        512,
        512,
        [],
        "f5f7",
        "M477.5 128C463 103.05 285.13 0 256.16 0S49.25 102.79 34.84 128s-14.49 230.8 0 256 192.38 128 221.32 128S463 409.08 477.49 384s14.51-231 .01-256zM316.13 414.22c-4 0-40.91-35.77-38-38.69.87-.87 6.26-1.48 17.55-1.83 0-26.23.59-68.59.94-86.32 0-2-.44-3.43-.44-5.85h-79.93c0 7.1-.46 36.2 1.37 72.88.23 4.54-1.58 6-5.74 5.94-10.13 0-20.27-.11-30.41-.08-4.1 0-5.87-1.53-5.74-6.11.92-33.44 3-84-.15-212.67v-3.17c-9.67-.35-16.38-1-17.26-1.84-2.92-2.92 34.54-38.69 38.49-38.69s41.17 35.78 38.27 38.69c-.87.87-7.9 1.49-16.77 1.84v3.16c-2.42 25.75-2 79.59-2.63 105.39h80.26c0-4.55.39-34.74-1.2-83.64-.1-3.39.95-5.17 4.21-5.2 11.07-.08 22.15-.13 33.23-.06 3.46 0 4.57 1.72 4.5 5.38C333 354.64 336 341.29 336 373.69c8.87.35 16.82 1 17.69 1.84 2.88 2.91-33.62 38.69-37.58 38.69z"
    ]
};
var $ef0249c5e48bf4e3$export$5c5693a4f82cd9eb = {
    prefix: "fab",
    iconName: "researchgate",
    icon: [
        448,
        512,
        [],
        "f4f8",
        "M0 32v448h448V32H0zm262.2 334.4c-6.6 3-33.2 6-50-14.2-9.2-10.6-25.3-33.3-42.2-63.6-8.9 0-14.7 0-21.4-.6v46.4c0 23.5 6 21.2 25.8 23.9v8.1c-6.9-.3-23.1-.8-35.6-.8-13.1 0-26.1.6-33.6.8v-8.1c15.5-2.9 22-1.3 22-23.9V225c0-22.6-6.4-21-22-23.9V193c25.8 1 53.1-.6 70.9-.6 31.7 0 55.9 14.4 55.9 45.6 0 21.1-16.7 42.2-39.2 47.5 13.6 24.2 30 45.6 42.2 58.9 7.2 7.8 17.2 14.7 27.2 14.7v7.3zm22.9-135c-23.3 0-32.2-15.7-32.2-32.2V167c0-12.2 8.8-30.4 34-30.4s30.4 17.9 30.4 17.9l-10.7 7.2s-5.5-12.5-19.7-12.5c-7.9 0-19.7 7.3-19.7 19.7v26.8c0 13.4 6.6 23.3 17.9 23.3 14.1 0 21.5-10.9 21.5-26.8h-17.9v-10.7h30.4c0 20.5 4.7 49.9-34 49.9zm-116.5 44.7c-9.4 0-13.6-.3-20-.8v-69.7c6.4-.6 15-.6 22.5-.6 23.3 0 37.2 12.2 37.2 34.5 0 21.9-15 36.6-39.7 36.6z"
    ]
};
var $ef0249c5e48bf4e3$export$dcdf312747bb3471 = {
    prefix: "fab",
    iconName: "swift",
    icon: [
        448,
        512,
        [],
        "f8e1",
        "M448 156.09c0-4.51-.08-9-.2-13.52a196.31 196.31 0 0 0-2.58-29.42 99.62 99.62 0 0 0-9.22-28A94.08 94.08 0 0 0 394.84 44a99.17 99.17 0 0 0-28-9.22 195 195 0 0 0-29.43-2.59c-4.51-.12-9-.17-13.52-.2H124.14c-4.51 0-9 .08-13.52.2-2.45.07-4.91.15-7.37.27a171.68 171.68 0 0 0-22.06 2.32 103.06 103.06 0 0 0-21.21 6.1q-3.46 1.45-6.81 3.12a94.66 94.66 0 0 0-18.39 12.32c-1.88 1.61-3.69 3.28-5.43 5A93.86 93.86 0 0 0 12 85.17a99.45 99.45 0 0 0-9.22 28 196.31 196.31 0 0 0-2.54 29.4c-.13 4.51-.18 9-.21 13.52v199.83c0 4.51.08 9 .21 13.51a196.08 196.08 0 0 0 2.58 29.42 99.3 99.3 0 0 0 9.22 28A94.31 94.31 0 0 0 53.17 468a99.47 99.47 0 0 0 28 9.21 195 195 0 0 0 29.43 2.59c4.5.12 9 .17 13.52.2H323.91c4.51 0 9-.08 13.52-.2a196.59 196.59 0 0 0 29.44-2.59 99.57 99.57 0 0 0 28-9.21A94.22 94.22 0 0 0 436 426.84a99.3 99.3 0 0 0 9.22-28 194.79 194.79 0 0 0 2.59-29.42c.12-4.5.17-9 .2-13.51V172.14c-.01-5.35-.01-10.7-.01-16.05zm-69.88 241c-20-38.93-57.23-29.27-76.31-19.47-1.72 1-3.48 2-5.25 3l-.42.25c-39.5 21-92.53 22.54-145.85-.38A234.64 234.64 0 0 1 45 290.12a230.63 230.63 0 0 0 39.17 23.37c56.36 26.4 113 24.49 153 0-57-43.85-104.6-101-141.09-147.22a197.09 197.09 0 0 1-18.78-25.9c43.7 40 112.7 90.22 137.48 104.12-52.57-55.49-98.89-123.94-96.72-121.74 82.79 83.42 159.18 130.59 159.18 130.59 2.88 1.58 5 2.85 6.73 4a127.44 127.44 0 0 0 4.16-12.47c13.22-48.33-1.66-103.58-35.31-149.2C329.61 141.75 375 229.34 356.4 303.42c-.44 1.73-.95 3.4-1.44 5.09 38.52 47.4 28.04 98.17 23.13 88.59z"
    ]
};
var $ef0249c5e48bf4e3$export$9df3e2a7a3f59b3b = {
    prefix: "fab",
    iconName: "angular",
    icon: [
        448,
        512,
        [],
        "f420",
        "M185.7 268.1h76.2l-38.1-91.6-38.1 91.6zM223.8 32L16 106.4l31.8 275.7 176 97.9 176-97.9 31.8-275.7zM354 373.8h-48.6l-26.2-65.4H168.6l-26.2 65.4H93.7L223.8 81.5z"
    ]
};
var $ef0249c5e48bf4e3$export$90ae1a3824ece6f2 = {
    prefix: "fab",
    iconName: "speakap",
    icon: [
        448,
        512,
        [],
        "f3f3",
        "M64 391.78C-15.41 303.59-8 167.42 80.64 87.64s224.8-73 304.21 15.24 72 224.36-16.64 304.14c-18.74 16.87 64 43.09 42 52.26-82.06 34.21-253.91 35-346.23-67.5zm213.31-211.6l38.5-40.86c-9.61-8.89-32-26.83-76.17-27.6-52.33-.91-95.86 28.3-96.77 80-.2 11.33.29 36.72 29.42 54.83 34.46 21.42 86.52 21.51 86 52.26-.37 21.28-26.42 25.81-38.59 25.6-3-.05-30.23-.46-47.61-24.62l-40 42.61c28.16 27 59 32.62 83.49 33.05 10.23.18 96.42.33 97.84-81 .28-15.81-2.07-39.72-28.86-56.59-34.36-21.64-85-19.45-84.43-49.75.41-23.25 31-25.37 37.53-25.26.43 0 26.62.26 39.62 17.37z"
    ]
};
var $ef0249c5e48bf4e3$export$a9e7bf021125ee89 = {
    prefix: "fab",
    iconName: "angrycreative",
    icon: [
        640,
        512,
        [],
        "f36e",
        "M640 238.2l-3.2 28.2-34.5 2.3-2 18.1 34.5-2.3-3.2 28.2-34.4 2.2-2.3 20.1 34.4-2.2-3 26.1-64.7 4.1 12.7-113.2L527 365.2l-31.9 2-23.8-117.8 30.3-2 13.6 79.4 31.7-82.4 93.1-6.2zM426.8 371.5l28.3-1.8L468 249.6l-28.4 1.9-12.8 120zM162 388.1l-19.4-36-3.5 37.4-28.2 1.7 2.7-29.1c-11 18-32 34.3-56.9 35.8C23.9 399.9-3 377 .3 339.7c2.6-29.3 26.7-62.8 67.5-65.4 37.7-2.4 47.6 23.2 51.3 28.8l2.8-30.8 38.9-2.5c20.1-1.3 38.7 3.7 42.5 23.7l2.6-26.6 64.8-4.2-2.7 27.9-36.4 2.4-1.7 17.9 36.4-2.3-2.7 27.9-36.4 2.3-1.9 19.9 36.3-2.3-2.1 20.8 55-117.2 23.8-1.6L370.4 369l8.9-85.6-22.3 1.4 2.9-27.9 75-4.9-3 28-24.3 1.6-9.7 91.9-58 3.7-4.3-15.6-39.4 2.5-8 16.3-126.2 7.7zm-44.3-70.2l-26.4 1.7C84.6 307.2 76.9 303 65 303.8c-19 1.2-33.3 17.5-34.6 33.3-1.4 16 7.3 32.5 28.7 31.2 12.8-.8 21.3-8.6 28.9-18.9l27-1.7 2.7-29.8zm56.1-7.7c1.2-12.9-7.6-13.6-26.1-12.4l-2.7 28.5c14.2-.9 27.5-2.1 28.8-16.1zm21.1 70.8l5.8-60c-5 13.5-14.7 21.1-27.9 26.6l22.1 33.4zm135.4-45l-7.9-37.8-15.8 39.3 23.7-1.5zm-170.1-74.6l-4.3-17.5-39.6 2.6-8.1 18.2-31.9 2.1 57-121.9 23.9-1.6 30.7 102 9.9-104.7 27-1.8 37.8 63.6 6.5-66.6 28.5-1.9-4 41.2c7.4-13.5 22.9-44.7 63.6-47.5 40.5-2.8 52.4 29.3 53.4 30.3l3.3-32 39.3-2.7c12.7-.9 27.8.3 36.3 9.7l-4.4-11.9 32.2-2.2 12.9 43.2 23-45.7 31-2.2-43.6 78.4-4.8 44.3-28.4 1.9 4.8-44.3-15.8-43c1 22.3-9.2 40.1-32 49.6l25.2 38.8-36.4 2.4-19.2-36.8-4 38.3-28.4 1.9 3.3-31.5c-6.7 9.3-19.7 35.4-59.6 38-26.2 1.7-45.6-10.3-55.4-39.2l-4 40.3-25 1.6-37.6-63.3-6.3 66.2-56.8 3.7zm276.6-82.1c10.2-.7 17.5-2.1 21.6-4.3 4.5-2.4 7-6.4 7.6-12.1.6-5.3-.6-8.8-3.4-10.4-3.6-2.1-10.6-2.8-22.9-2l-2.9 28.8zM327.7 214c5.6 5.9 12.7 8.5 21.3 7.9 4.7-.3 9.1-1.8 13.3-4.1 5.5-3 10.6-8 15.1-14.3l-34.2 2.3 2.4-23.9 63.1-4.3 1.2-12-31.2 2.1c-4.1-3.7-7.8-6.6-11.1-8.1-4-1.7-8.1-2.8-12.2-2.5-8 .5-15.3 3.6-22 9.2-7.7 6.4-12 14.5-12.9 24.4-1.1 9.6 1.4 17.3 7.2 23.3zm-201.3 8.2l23.8-1.6-8.3-37.6-15.5 39.2z"
    ]
};
var $ef0249c5e48bf4e3$export$9ee2f35ed1fe0fd4 = {
    prefix: "fab",
    iconName: "y-combinator",
    icon: [
        448,
        512,
        [],
        "f23b",
        "M448 32v448H0V32h448zM236 287.5L313.5 142h-32.7L235 233c-4.7 9.3-9 18.3-12.8 26.8L210 233l-45.2-91h-35l76.7 143.8v94.5H236v-92.8z"
    ]
};
var $ef0249c5e48bf4e3$export$c966a5d80266ef06 = {
    prefix: "fab",
    iconName: "empire",
    icon: [
        496,
        512,
        [],
        "f1d1",
        "M287.6 54.2c-10.8-2.2-22.1-3.3-33.5-3.6V32.4c78.1 2.2 146.1 44 184.6 106.6l-15.8 9.1c-6.1-9.7-12.7-18.8-20.2-27.1l-18 15.5c-26-29.6-61.4-50.7-101.9-58.4l4.8-23.9zM53.4 322.4l23-7.7c-6.4-18.3-10-38.2-10-58.7s3.3-40.4 9.7-58.7l-22.7-7.7c3.6-10.8 8.3-21.3 13.6-31l-15.8-9.1C34 181 24.1 217.5 24.1 256s10 75 27.1 106.6l15.8-9.1c-5.3-10-9.7-20.3-13.6-31.1zM213.1 434c-40.4-8-75.8-29.1-101.9-58.7l-18 15.8c-7.5-8.6-14.4-17.7-20.2-27.4l-16 9.4c38.5 62.3 106.8 104.3 184.9 106.6v-18.3c-11.3-.3-22.7-1.7-33.5-3.6l4.7-23.8zM93.3 120.9l18 15.5c26-29.6 61.4-50.7 101.9-58.4l-4.7-23.8c10.8-2.2 22.1-3.3 33.5-3.6V32.4C163.9 34.6 95.9 76.4 57.4 139l15.8 9.1c6-9.7 12.6-18.9 20.1-27.2zm309.4 270.2l-18-15.8c-26 29.6-61.4 50.7-101.9 58.7l4.7 23.8c-10.8 1.9-22.1 3.3-33.5 3.6v18.3c78.1-2.2 146.4-44.3 184.9-106.6l-16.1-9.4c-5.7 9.7-12.6 18.8-20.1 27.4zM496 256c0 137-111 248-248 248S0 393 0 256 111 8 248 8s248 111 248 248zm-12.2 0c0-130.1-105.7-235.8-235.8-235.8S12.2 125.9 12.2 256 117.9 491.8 248 491.8 483.8 386.1 483.8 256zm-39-106.6l-15.8 9.1c5.3 9.7 10 20.2 13.6 31l-22.7 7.7c6.4 18.3 9.7 38.2 9.7 58.7s-3.6 40.4-10 58.7l23 7.7c-3.9 10.8-8.3 21-13.6 31l15.8 9.1C462 331 471.9 294.5 471.9 256s-9.9-75-27.1-106.6zm-183 177.7c16.3-3.3 30.4-11.6 40.7-23.5l51.2 44.8c11.9-13.6 21.3-29.3 27.1-46.8l-64.2-22.1c2.5-7.5 3.9-15.2 3.9-23.5s-1.4-16.1-3.9-23.5l64.5-22.1c-6.1-17.4-15.5-33.2-27.4-46.8l-51.2 44.8c-10.2-11.9-24.4-20.5-40.7-23.8l13.3-66.4c-8.6-1.9-17.7-2.8-27.1-2.8-9.4 0-18.5.8-27.1 2.8l13.3 66.4c-16.3 3.3-30.4 11.9-40.7 23.8l-51.2-44.8c-11.9 13.6-21.3 29.3-27.4 46.8l64.5 22.1c-2.5 7.5-3.9 15.2-3.9 23.5s1.4 16.1 3.9 23.5l-64.2 22.1c5.8 17.4 15.2 33.2 27.1 46.8l51.2-44.8c10.2 11.9 24.4 20.2 40.7 23.5l-13.3 66.7c8.6 1.7 17.7 2.8 27.1 2.8 9.4 0 18.5-1.1 27.1-2.8l-13.3-66.7z"
    ]
};
var $ef0249c5e48bf4e3$export$9e2c7c55d2fddd0 = {
    prefix: "fab",
    iconName: "envira",
    icon: [
        448,
        512,
        [],
        "f299",
        "M0 32c477.6 0 366.6 317.3 367.1 366.3L448 480h-26l-70.4-71.2c-39 4.2-124.4 34.5-214.4-37C47 300.3 52 214.7 0 32zm79.7 46c-49.7-23.5-5.2 9.2-5.2 9.2 45.2 31.2 66 73.7 90.2 119.9 31.5 60.2 79 139.7 144.2 167.7 65 28 34.2 12.5 6-8.5-28.2-21.2-68.2-87-91-130.2-31.7-60-61-118.6-144.2-158.1z"
    ]
};
var $ef0249c5e48bf4e3$export$ed92c068824a8084 = {
    prefix: "fab",
    iconName: "google-scholar",
    icon: [
        512,
        512,
        [],
        "e63b",
        "M390.9 298.5c0 0 0 .1 .1 .1c9.2 19.4 14.4 41.1 14.4 64C405.3 445.1 338.5 512 256 512s-149.3-66.9-149.3-149.3c0-22.9 5.2-44.6 14.4-64h0c1.7-3.6 3.6-7.2 5.6-10.7c4.4-7.6 9.4-14.7 15-21.3c27.4-32.6 68.5-53.3 114.4-53.3c33.6 0 64.6 11.1 89.6 29.9c9.1 6.9 17.4 14.7 24.8 23.5c5.6 6.6 10.6 13.8 15 21.3c2 3.4 3.8 7 5.5 10.5zm26.4-18.8c-30.1-58.4-91-98.4-161.3-98.4s-131.2 40-161.3 98.4L0 202.7 256 0 512 202.7l-94.7 77.1z"
    ]
};
var $ef0249c5e48bf4e3$export$1c14974e1904bc76 = {
    prefix: "fab",
    iconName: "square-gitlab",
    icon: [
        448,
        512,
        [
            "gitlab-square"
        ],
        "e5ae",
        "M0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96zm337.5 12.5l44.6 116.4 .4 1.2c5.6 16.8 7.2 35.2 2.3 52.5c-5 17.2-15.4 32.4-29.8 43.3l-.2 .1-68.4 51.2-54.1 40.9c-.5 .2-1.1 .5-1.7 .8c-2 1-4.4 2-6.7 2c-3 0-6.8-1.8-8.3-2.8l-54.2-40.9L93.5 322.3l-.4-.3-.2-.1c-14.3-10.8-24.8-26-29.7-43.3s-4.2-35.7 2.2-52.5l.5-1.2 44.7-116.4c.9-2.3 2.5-4.3 4.5-5.6c1.6-1 3.4-1.6 5.2-1.8c1.3-.7 2.1-.4 3.4 .1c.6 .2 1.2 .5 2 .7c1 .4 1.6 .9 2.4 1.5c.6 .4 1.2 1 2.1 1.5c1.2 1.4 2.2 3 2.7 4.8l29.2 92.2H285l30.2-92.2c.5-1.8 1.4-3.4 2.6-4.8s2.8-2.4 4.5-3.1c1.7-.6 3.6-.9 5.4-.7s3.6 .8 5.2 1.8c2 1.3 3.7 3.3 4.6 5.6z"
    ]
};
var $ef0249c5e48bf4e3$export$4459a47a802afa29 = $ef0249c5e48bf4e3$export$1c14974e1904bc76;
var $ef0249c5e48bf4e3$export$9d71d8f56add75cb = {
    prefix: "fab",
    iconName: "studiovinari",
    icon: [
        512,
        512,
        [],
        "f3f8",
        "M480.3 187.7l4.2 28v28l-25.1 44.1-39.8 78.4-56.1 67.5-79.1 37.8-17.7 24.5-7.7 12-9.6 4s17.3-63.6 19.4-63.6c2.1 0 20.3.7 20.3.7l66.7-38.6-92.5 26.1-55.9 36.8-22.8 28-6.6 1.4 20.8-73.6 6.9-5.5 20.7 12.9 88.3-45.2 56.8-51.5 14.8-68.4-125.4 23.3 15.2-18.2-173.4-53.3 81.9-10.5-166-122.9L133.5 108 32.2 0l252.9 126.6-31.5-38L378 163 234.7 64l18.7 38.4-49.6-18.1L158.3 0l194.6 122L310 66.2l108 96.4 12-8.9-21-16.4 4.2-37.8L451 89.1l29.2 24.7 11.5 4.2-7 6.2 8.5 12-13.1 7.4-10.3 20.2 10.5 23.9z"
    ]
};
var $ef0249c5e48bf4e3$export$13581f4cc240d7d9 = {
    prefix: "fab",
    iconName: "pied-piper",
    icon: [
        480,
        512,
        [],
        "f2ae",
        "M455.93,23.2C429.23,30,387.79,51.69,341.35,90.66A206,206,0,0,0,240,64C125.13,64,32,157.12,32,272s93.13,208,208,208,208-93.13,208-208a207.25,207.25,0,0,0-58.75-144.81,155.35,155.35,0,0,0-17,27.4A176.16,176.16,0,0,1,417.1,272c0,97.66-79.44,177.11-177.09,177.11a175.81,175.81,0,0,1-87.63-23.4c82.94-107.33,150.79-37.77,184.31-226.65,5.79-32.62,28-94.26,126.23-160.18C471,33.45,465.35,20.8,455.93,23.2ZM125,406.4A176.66,176.66,0,0,1,62.9,272C62.9,174.34,142.35,94.9,240,94.9a174,174,0,0,1,76.63,17.75C250.64,174.76,189.77,265.52,125,406.4Z"
    ]
};
var $ef0249c5e48bf4e3$export$8898e76262ada01d = {
    prefix: "fab",
    iconName: "wordpress",
    icon: [
        512,
        512,
        [],
        "f19a",
        "M61.7 169.4l101.5 278C92.2 413 43.3 340.2 43.3 256c0-30.9 6.6-60.1 18.4-86.6zm337.9 75.9c0-26.3-9.4-44.5-17.5-58.7-10.8-17.5-20.9-32.4-20.9-49.9 0-19.6 14.8-37.8 35.7-37.8.9 0 1.8.1 2.8.2-37.9-34.7-88.3-55.9-143.7-55.9-74.3 0-139.7 38.1-177.8 95.9 5 .2 9.7.3 13.7.3 22.2 0 56.7-2.7 56.7-2.7 11.5-.7 12.8 16.2 1.4 17.5 0 0-11.5 1.3-24.3 2l77.5 230.4L249.8 247l-33.1-90.8c-11.5-.7-22.3-2-22.3-2-11.5-.7-10.1-18.2 1.3-17.5 0 0 35.1 2.7 56 2.7 22.2 0 56.7-2.7 56.7-2.7 11.5-.7 12.8 16.2 1.4 17.5 0 0-11.5 1.3-24.3 2l76.9 228.7 21.2-70.9c9-29.4 16-50.5 16-68.7zm-139.9 29.3l-63.8 185.5c19.1 5.6 39.2 8.7 60.1 8.7 24.8 0 48.5-4.3 70.6-12.1-.6-.9-1.1-1.9-1.5-2.9l-65.4-179.2zm183-120.7c.9 6.8 1.4 14 1.4 21.9 0 21.6-4 45.8-16.2 76.2l-65 187.9C426.2 403 468.7 334.5 468.7 256c0-37-9.4-71.8-26-102.1zM504 256c0 136.8-111.3 248-248 248C119.2 504 8 392.7 8 256 8 119.2 119.2 8 256 8c136.7 0 248 111.2 248 248zm-11.4 0c0-130.5-106.2-236.6-236.6-236.6C125.5 19.4 19.4 125.5 19.4 256S125.6 492.6 256 492.6c130.5 0 236.6-106.1 236.6-236.6z"
    ]
};
var $ef0249c5e48bf4e3$export$91dcff48b72c75ce = {
    prefix: "fab",
    iconName: "product-hunt",
    icon: [
        512,
        512,
        [],
        "f288",
        "M326.3 218.8c0 20.5-16.7 37.2-37.2 37.2h-70.3v-74.4h70.3c20.5 0 37.2 16.7 37.2 37.2zM504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zm-128.1-37.2c0-47.9-38.9-86.8-86.8-86.8H169.2v248h49.6v-74.4h70.3c47.9 0 86.8-38.9 86.8-86.8z"
    ]
};
var $ef0249c5e48bf4e3$export$53a067e7149deea9 = {
    prefix: "fab",
    iconName: "firefox",
    icon: [
        512,
        512,
        [],
        "f269",
        "M503.52,241.48c-.12-1.56-.24-3.12-.24-4.68v-.12l-.36-4.68v-.12a245.86,245.86,0,0,0-7.32-41.15c0-.12,0-.12-.12-.24l-1.08-4c-.12-.24-.12-.48-.24-.6-.36-1.2-.72-2.52-1.08-3.72-.12-.24-.12-.6-.24-.84-.36-1.2-.72-2.4-1.08-3.48-.12-.36-.24-.6-.36-1-.36-1.2-.72-2.28-1.2-3.48l-.36-1.08c-.36-1.08-.84-2.28-1.2-3.36a8.27,8.27,0,0,0-.36-1c-.48-1.08-.84-2.28-1.32-3.36-.12-.24-.24-.6-.36-.84-.48-1.2-1-2.28-1.44-3.48,0-.12-.12-.24-.12-.36-1.56-3.84-3.24-7.68-5-11.4l-.36-.72c-.48-1-.84-1.8-1.32-2.64-.24-.48-.48-1.08-.72-1.56-.36-.84-.84-1.56-1.2-2.4-.36-.6-.6-1.2-1-1.8s-.84-1.44-1.2-2.28c-.36-.6-.72-1.32-1.08-1.92s-.84-1.44-1.2-2.16a18.07,18.07,0,0,0-1.2-2c-.36-.72-.84-1.32-1.2-2s-.84-1.32-1.2-2-.84-1.32-1.2-1.92-.84-1.44-1.32-2.16a15.63,15.63,0,0,0-1.2-1.8L463.2,119a15.63,15.63,0,0,0-1.2-1.8c-.48-.72-1.08-1.56-1.56-2.28-.36-.48-.72-1.08-1.08-1.56l-1.8-2.52c-.36-.48-.6-.84-1-1.32-1-1.32-1.8-2.52-2.76-3.72a248.76,248.76,0,0,0-23.51-26.64A186.82,186.82,0,0,0,412,62.46c-4-3.48-8.16-6.72-12.48-9.84a162.49,162.49,0,0,0-24.6-15.12c-2.4-1.32-4.8-2.52-7.2-3.72a254,254,0,0,0-55.43-19.56c-1.92-.36-3.84-.84-5.64-1.2h-.12c-1-.12-1.8-.36-2.76-.48a236.35,236.35,0,0,0-38-4H255.14a234.62,234.62,0,0,0-45.48,5c-33.59,7.08-63.23,21.24-82.91,39-1.08,1-1.92,1.68-2.4,2.16l-.48.48H124l-.12.12.12-.12a.12.12,0,0,0,.12-.12l-.12.12a.42.42,0,0,1,.24-.12c14.64-8.76,34.92-16,49.44-19.56l5.88-1.44c.36-.12.84-.12,1.2-.24,1.68-.36,3.36-.72,5.16-1.08.24,0,.6-.12.84-.12C250.94,20.94,319.34,40.14,367,85.61a171.49,171.49,0,0,1,26.88,32.76c30.36,49.2,27.48,111.11,3.84,147.59-34.44,53-111.35,71.27-159,24.84a84.19,84.19,0,0,1-25.56-59,74.05,74.05,0,0,1,6.24-31c1.68-3.84,13.08-25.67,18.24-24.59-13.08-2.76-37.55,2.64-54.71,28.19-15.36,22.92-14.52,58.2-5,83.28a132.85,132.85,0,0,1-12.12-39.24c-12.24-82.55,43.31-153,94.31-170.51-27.48-24-96.47-22.31-147.71,15.36-29.88,22-51.23,53.16-62.51,90.36,1.68-20.88,9.6-52.08,25.8-83.88-17.16,8.88-39,37-49.8,62.88-15.6,37.43-21,82.19-16.08,124.79.36,3.24.72,6.36,1.08,9.6,19.92,117.11,122,206.38,244.78,206.38C392.77,503.42,504,392.19,504,255,503.88,250.48,503.76,245.92,503.52,241.48Z"
    ]
};
var $ef0249c5e48bf4e3$export$fcbc58842fe8e217 = {
    prefix: "fab",
    iconName: "linode",
    icon: [
        448,
        512,
        [],
        "f2b8",
        "M366.036,186.867l-59.5,36.871-.838,36.871-29.329-19.273-39.384,24.3c2.238,55.211,2.483,59.271,2.51,59.5l-97.2,65.359L127.214,285.748l108.1-62.01L195.09,197.761l-75.417,38.547L98.723,93.015,227.771,43.574,136.432,0,10.737,39.385,38.39,174.3l41.9,32.681L48.445,222.062,69.394,323.457,98.723,351.11,77.774,363.679l16.76,78.769L160.733,512c-10.8-74.842-11.658-78.641-11.725-78.773l77.925-55.3c16.759-12.57,15.083-10.894,15.083-10.894l.838,24.3,33.519,28.491-.838-77.093,46.927-33.519,26.815-18.435-2.514,36.033,25.139,17.6,6.7-74.579,58.657-43.575Z"
    ]
};
var $ef0249c5e48bf4e3$export$cc058e4fd428aead = {
    prefix: "fab",
    iconName: "goodreads",
    icon: [
        448,
        512,
        [],
        "f3a8",
        "M299.9 191.2c5.1 37.3-4.7 79-35.9 100.7-22.3 15.5-52.8 14.1-70.8 5.7-37.1-17.3-49.5-58.6-46.8-97.2 4.3-60.9 40.9-87.9 75.3-87.5 46.9-.2 71.8 31.8 78.2 78.3zM448 88v336c0 30.9-25.1 56-56 56H56c-30.9 0-56-25.1-56-56V88c0-30.9 25.1-56 56-56h336c30.9 0 56 25.1 56 56zM330 313.2s-.1-34-.1-217.3h-29v40.3c-.8.3-1.2-.5-1.6-1.2-9.6-20.7-35.9-46.3-76-46-51.9.4-87.2 31.2-100.6 77.8-4.3 14.9-5.8 30.1-5.5 45.6 1.7 77.9 45.1 117.8 112.4 115.2 28.9-1.1 54.5-17 69-45.2.5-1 1.1-1.9 1.7-2.9.2.1.4.1.6.2.3 3.8.2 30.7.1 34.5-.2 14.8-2 29.5-7.2 43.5-7.8 21-22.3 34.7-44.5 39.5-17.8 3.9-35.6 3.8-53.2-1.2-21.5-6.1-36.5-19-41.1-41.8-.3-1.6-1.3-1.3-2.3-1.3h-26.8c.8 10.6 3.2 20.3 8.5 29.2 24.2 40.5 82.7 48.5 128.2 37.4 49.9-12.3 67.3-54.9 67.4-106.3z"
    ]
};
var $ef0249c5e48bf4e3$export$df58e66e423b11a0 = {
    prefix: "fab",
    iconName: "square-odnoklassniki",
    icon: [
        448,
        512,
        [
            "odnoklassniki-square"
        ],
        "f264",
        "M224 137.1a39.9 39.9 0 1 0 0 79.7 39.9 39.9 0 1 0 0-79.7zM384 32H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64zM224 95.9A81 81 0 1 1 224 258a81 81 0 1 1 0-162.1zm59.3 168.3c16.8-13.2 29.5-5.5 34.1 3.6c7.8 16-1.1 23.7-21.5 37c-17.1 10.9-40.7 15.2-56.2 16.8l13 12.9 47.7 47.7c17.4 17.9-11 45.8-28.6 28.6c-12-12.2-29.5-29.7-47.7-47.9l0 0-47.7 47.9c-17.7 17.2-46-11-28.4-28.6c3.7-3.7 7.9-7.9 12.5-12.5c10.4-10.4 22.6-22.7 35.2-35.2l12.9-12.9c-15.4-1.6-39.3-5.7-56.6-16.8c-20.3-13.3-29.3-20.9-21.4-37c4.6-9.1 17.3-16.8 34.1-3.6c0 0 22.7 18 59.3 18s59.3-18 59.3-18z"
    ]
};
var $ef0249c5e48bf4e3$export$8bab3f1c73ff1d0 = $ef0249c5e48bf4e3$export$df58e66e423b11a0;
var $ef0249c5e48bf4e3$export$49c67105b922997 = {
    prefix: "fab",
    iconName: "jsfiddle",
    icon: [
        576,
        512,
        [],
        "f1cc",
        "M510.634 237.462c-4.727-2.621-5.664-5.748-6.381-10.776-2.352-16.488-3.539-33.619-9.097-49.095-35.895-99.957-153.99-143.386-246.849-91.646-27.37 15.25-48.971 36.369-65.493 63.903-3.184-1.508-5.458-2.71-7.824-3.686-30.102-12.421-59.049-10.121-85.331 9.167-25.531 18.737-36.422 44.548-32.676 76.408.355 3.025-1.967 7.621-4.514 9.545-39.712 29.992-56.031 78.065-41.902 124.615 13.831 45.569 57.514 79.796 105.608 81.433 30.291 1.031 60.637.546 90.959.539 84.041-.021 168.09.531 252.12-.48 52.664-.634 96.108-36.873 108.212-87.293 11.54-48.074-11.144-97.3-56.832-122.634zm21.107 156.88c-18.23 22.432-42.343 35.253-71.28 35.65-56.874.781-113.767.23-170.652.23 0 .7-163.028.159-163.728.154-43.861-.332-76.739-19.766-95.175-59.995-18.902-41.245-4.004-90.848 34.186-116.106 9.182-6.073 12.505-11.566 10.096-23.136-5.49-26.361 4.453-47.956 26.42-62.981 22.987-15.723 47.422-16.146 72.034-3.083 10.269 5.45 14.607 11.564 22.198-2.527 14.222-26.399 34.557-46.727 60.671-61.294 97.46-54.366 228.37 7.568 230.24 132.697.122 8.15 2.412 12.428 9.848 15.894 57.56 26.829 74.456 96.122 35.142 144.497zm-87.789-80.499c-5.848 31.157-34.622 55.096-66.666 55.095-16.953-.001-32.058-6.545-44.079-17.705-27.697-25.713-71.141-74.98-95.937-93.387-20.056-14.888-41.99-12.333-60.272 3.782-49.996 44.071 15.859 121.775 67.063 77.188 4.548-3.96 7.84-9.543 12.744-12.844 8.184-5.509 20.766-.884 13.168 10.622-17.358 26.284-49.33 38.197-78.863 29.301-28.897-8.704-48.84-35.968-48.626-70.179 1.225-22.485 12.364-43.06 35.414-55.965 22.575-12.638 46.369-13.146 66.991 2.474C295.68 280.7 320.467 323.97 352.185 343.47c24.558 15.099 54.254 7.363 68.823-17.506 28.83-49.209-34.592-105.016-78.868-63.46-3.989 3.744-6.917 8.932-11.41 11.72-10.975 6.811-17.333-4.113-12.809-10.353 20.703-28.554 50.464-40.44 83.271-28.214 31.429 11.714 49.108 44.366 42.76 78.186z"
    ]
};
var $ef0249c5e48bf4e3$export$6b9a61f04a3c9eb4 = {
    prefix: "fab",
    iconName: "sith",
    icon: [
        448,
        512,
        [],
        "f512",
        "M0 32l69.71 118.75-58.86-11.52 69.84 91.03a146.741 146.741 0 0 0 0 51.45l-69.84 91.03 58.86-11.52L0 480l118.75-69.71-11.52 58.86 91.03-69.84c17.02 3.04 34.47 3.04 51.48 0l91.03 69.84-11.52-58.86L448 480l-69.71-118.78 58.86 11.52-69.84-91.03c3.03-17.01 3.04-34.44 0-51.45l69.84-91.03-58.86 11.52L448 32l-118.75 69.71 11.52-58.9-91.06 69.87c-8.5-1.52-17.1-2.29-25.71-2.29s-17.21.78-25.71 2.29l-91.06-69.87 11.52 58.9L0 32zm224 99.78c31.8 0 63.6 12.12 87.85 36.37 48.5 48.5 48.49 127.21 0 175.7s-127.2 48.46-175.7-.03c-48.5-48.5-48.49-127.21 0-175.7 24.24-24.25 56.05-36.34 87.85-36.34zm0 36.66c-22.42 0-44.83 8.52-61.92 25.61-34.18 34.18-34.19 89.68 0 123.87s89.65 34.18 123.84 0c34.18-34.18 34.19-89.68 0-123.87-17.09-17.09-39.5-25.61-61.92-25.61z"
    ]
};
var $ef0249c5e48bf4e3$export$9ce81750a9f73ac4 = {
    prefix: "fab",
    iconName: "themeisle",
    icon: [
        512,
        512,
        [],
        "f2b2",
        "M208 88.286c0-10 6.286-21.714 17.715-21.714 11.142 0 17.714 11.714 17.714 21.714 0 10.285-6.572 21.714-17.714 21.714C214.286 110 208 98.571 208 88.286zm304 160c0 36.001-11.429 102.286-36.286 129.714-22.858 24.858-87.428 61.143-120.857 70.572l-1.143.286v32.571c0 16.286-12.572 30.571-29.143 30.571-10 0-19.429-5.714-24.572-14.286-5.427 8.572-14.856 14.286-24.856 14.286-10 0-19.429-5.714-24.858-14.286-5.142 8.572-14.571 14.286-24.57 14.286-10.286 0-19.429-5.714-24.858-14.286-5.143 8.572-14.571 14.286-24.571 14.286-18.857 0-29.429-15.714-29.429-32.857-16.286 12.285-35.715 19.428-56.571 19.428-22 0-43.429-8.285-60.286-22.857 10.285-.286 20.571-2.286 30.285-5.714-20.857-5.714-39.428-18.857-52-36.286 21.37 4.645 46.209 1.673 67.143-11.143-22-22-56.571-58.857-68.572-87.428C1.143 321.714 0 303.714 0 289.429c0-49.714 20.286-160 86.286-160 10.571 0 18.857 4.858 23.143 14.857a158.792 158.792 0 0 1 12-15.428c2-2.572 5.714-5.429 7.143-8.286 7.999-12.571 11.714-21.142 21.714-34C182.571 45.428 232 17.143 285.143 17.143c6 0 12 .285 17.714 1.143C313.714 6.571 328.857 0 344.572 0c14.571 0 29.714 6 40 16.286.857.858 1.428 2.286 1.428 3.428 0 3.714-10.285 13.429-12.857 16.286 4.286 1.429 15.714 6.858 15.714 12 0 2.857-2.857 5.143-4.571 7.143 31.429 27.714 49.429 67.143 56.286 108 4.286-5.143 10.285-8.572 17.143-8.572 10.571 0 20.857 7.144 28.571 14.001C507.143 187.143 512 221.714 512 248.286zM188 89.428c0 18.286 12.571 37.143 32.286 37.143 19.714 0 32.285-18.857 32.285-37.143 0-18-12.571-36.857-32.285-36.857-19.715 0-32.286 18.858-32.286 36.857zM237.714 194c0-19.714 3.714-39.143 8.571-58.286-52.039 79.534-13.531 184.571 68.858 184.571 21.428 0 42.571-7.714 60-20 2-7.429 3.714-14.857 3.714-22.572 0-14.286-6.286-21.428-20.572-21.428-4.571 0-9.143.857-13.429 1.714-63.343 12.668-107.142 3.669-107.142-63.999zm-41.142 254.858c0-11.143-8.858-20.857-20.286-20.857-11.429 0-20 9.715-20 20.857v32.571c0 11.143 8.571 21.142 20 21.142 11.428 0 20.286-9.715 20.286-21.142v-32.571zm49.143 0c0-11.143-8.572-20.857-20-20.857-11.429 0-20.286 9.715-20.286 20.857v32.571c0 11.143 8.857 21.142 20.286 21.142 11.428 0 20-10 20-21.142v-32.571zm49.713 0c0-11.143-8.857-20.857-20.285-20.857-11.429 0-20.286 9.715-20.286 20.857v32.571c0 11.143 8.857 21.142 20.286 21.142 11.428 0 20.285-9.715 20.285-21.142v-32.571zm49.715 0c0-11.143-8.857-20.857-20.286-20.857-11.428 0-20.286 9.715-20.286 20.857v32.571c0 11.143 8.858 21.142 20.286 21.142 11.429 0 20.286-10 20.286-21.142v-32.571zM421.714 286c-30.857 59.142-90.285 102.572-158.571 102.572-96.571 0-160.571-84.572-160.571-176.572 0-16.857 2-33.429 6-49.714-20 33.715-29.714 72.572-29.714 111.429 0 60.286 24.857 121.715 71.429 160.857 5.143-9.714 14.857-16.286 26-16.286 10 0 19.428 5.714 24.571 14.286 5.429-8.571 14.571-14.286 24.858-14.286 10 0 19.428 5.714 24.571 14.286 5.429-8.571 14.857-14.286 24.858-14.286 10 0 19.428 5.714 24.857 14.286 5.143-8.571 14.571-14.286 24.572-14.286 10.857 0 20.857 6.572 25.714 16 43.427-36.286 68.569-92 71.426-148.286zm10.572-99.714c0-53.714-34.571-105.714-92.572-105.714-30.285 0-58.571 15.143-78.857 36.857C240.862 183.812 233.41 254 302.286 254c28.805 0 97.357-28.538 84.286 36.857 28.857-26 45.714-65.714 45.714-104.571z"
    ]
};
var $ef0249c5e48bf4e3$export$e504e93b36693690 = {
    prefix: "fab",
    iconName: "page4",
    icon: [
        496,
        512,
        [],
        "f3d7",
        "M248 504C111 504 0 393 0 256S111 8 248 8c20.9 0 41.3 2.6 60.7 7.5L42.3 392H248v112zm0-143.6V146.8L98.6 360.4H248zm96 31.6v92.7c45.7-19.2 84.5-51.7 111.4-92.7H344zm57.4-138.2l-21.2 8.4 21.2 8.3v-16.7zm-20.3 54.5c-6.7 0-8 6.3-8 12.9v7.7h16.2v-10c0-5.9-2.3-10.6-8.2-10.6zM496 256c0 37.3-8.2 72.7-23 104.4H344V27.3C433.3 64.8 496 153.1 496 256zM360.4 143.6h68.2V96h-13.9v32.6h-13.9V99h-13.9v29.6h-12.7V96h-13.9v47.6zm68.1 185.3H402v-11c0-15.4-5.6-25.2-20.9-25.2-15.4 0-20.7 10.6-20.7 25.9v25.3h68.2v-15zm0-103l-68.2 29.7V268l68.2 29.5v-16.6l-14.4-5.7v-26.5l14.4-5.9v-16.9zm-4.8-68.5h-35.6V184H402v-12.2h11c8.6 15.8 1.3 35.3-18.6 35.3-22.5 0-28.3-25.3-15.5-37.7l-11.6-10.6c-16.2 17.5-12.2 63.9 27.1 63.9 34 0 44.7-35.9 29.3-65.3z"
    ]
};
var $ef0249c5e48bf4e3$export$459e822cce028974 = {
    prefix: "fab",
    iconName: "hashnode",
    icon: [
        512,
        512,
        [],
        "e499",
        "M35.19 171.1C-11.72 217.1-11.72 294 35.19 340.9L171.1 476.8C217.1 523.7 294 523.7 340.9 476.8L476.8 340.9C523.7 294 523.7 217.1 476.8 171.1L340.9 35.19C294-11.72 217.1-11.72 171.1 35.19L35.19 171.1zM315.5 315.5C282.6 348.3 229.4 348.3 196.6 315.5C163.7 282.6 163.7 229.4 196.6 196.6C229.4 163.7 282.6 163.7 315.5 196.6C348.3 229.4 348.3 282.6 315.5 315.5z"
    ]
};
var $ef0249c5e48bf4e3$export$e62f4d94322d112c = {
    prefix: "fab",
    iconName: "react",
    icon: [
        512,
        512,
        [],
        "f41b",
        "M418.2 177.2c-5.4-1.8-10.8-3.5-16.2-5.1.9-3.7 1.7-7.4 2.5-11.1 12.3-59.6 4.2-107.5-23.1-123.3-26.3-15.1-69.2.6-112.6 38.4-4.3 3.7-8.5 7.6-12.5 11.5-2.7-2.6-5.5-5.2-8.3-7.7-45.5-40.4-91.1-57.4-118.4-41.5-26.2 15.2-34 60.3-23 116.7 1.1 5.6 2.3 11.1 3.7 16.7-6.4 1.8-12.7 3.8-18.6 5.9C38.3 196.2 0 225.4 0 255.6c0 31.2 40.8 62.5 96.3 81.5 4.5 1.5 9 3 13.6 4.3-1.5 6-2.8 11.9-4 18-10.5 55.5-2.3 99.5 23.9 114.6 27 15.6 72.4-.4 116.6-39.1 3.5-3.1 7-6.3 10.5-9.7 4.4 4.3 9 8.4 13.6 12.4 42.8 36.8 85.1 51.7 111.2 36.6 27-15.6 35.8-62.9 24.4-120.5-.9-4.4-1.9-8.9-3-13.5 3.2-.9 6.3-1.9 9.4-2.9 57.7-19.1 99.5-50 99.5-81.7 0-30.3-39.4-59.7-93.8-78.4zM282.9 92.3c37.2-32.4 71.9-45.1 87.7-36 16.9 9.7 23.4 48.9 12.8 100.4-.7 3.4-1.4 6.7-2.3 10-22.2-5-44.7-8.6-67.3-10.6-13-18.6-27.2-36.4-42.6-53.1 3.9-3.7 7.7-7.2 11.7-10.7zM167.2 307.5c5.1 8.7 10.3 17.4 15.8 25.9-15.6-1.7-31.1-4.2-46.4-7.5 4.4-14.4 9.9-29.3 16.3-44.5 4.6 8.8 9.3 17.5 14.3 26.1zm-30.3-120.3c14.4-3.2 29.7-5.8 45.6-7.8-5.3 8.3-10.5 16.8-15.4 25.4-4.9 8.5-9.7 17.2-14.2 26-6.3-14.9-11.6-29.5-16-43.6zm27.4 68.9c6.6-13.8 13.8-27.3 21.4-40.6s15.8-26.2 24.4-38.9c15-1.1 30.3-1.7 45.9-1.7s31 .6 45.9 1.7c8.5 12.6 16.6 25.5 24.3 38.7s14.9 26.7 21.7 40.4c-6.7 13.8-13.9 27.4-21.6 40.8-7.6 13.3-15.7 26.2-24.2 39-14.9 1.1-30.4 1.6-46.1 1.6s-30.9-.5-45.6-1.4c-8.7-12.7-16.9-25.7-24.6-39s-14.8-26.8-21.5-40.6zm180.6 51.2c5.1-8.8 9.9-17.7 14.6-26.7 6.4 14.5 12 29.2 16.9 44.3-15.5 3.5-31.2 6.2-47 8 5.4-8.4 10.5-17 15.5-25.6zm14.4-76.5c-4.7-8.8-9.5-17.6-14.5-26.2-4.9-8.5-10-16.9-15.3-25.2 16.1 2 31.5 4.7 45.9 8-4.6 14.8-10 29.2-16.1 43.4zM256.2 118.3c10.5 11.4 20.4 23.4 29.6 35.8-19.8-.9-39.7-.9-59.5 0 9.8-12.9 19.9-24.9 29.9-35.8zM140.2 57c16.8-9.8 54.1 4.2 93.4 39 2.5 2.2 5 4.6 7.6 7-15.5 16.7-29.8 34.5-42.9 53.1-22.6 2-45 5.5-67.2 10.4-1.3-5.1-2.4-10.3-3.5-15.5-9.4-48.4-3.2-84.9 12.6-94zm-24.5 263.6c-4.2-1.2-8.3-2.5-12.4-3.9-21.3-6.7-45.5-17.3-63-31.2-10.1-7-16.9-17.8-18.8-29.9 0-18.3 31.6-41.7 77.2-57.6 5.7-2 11.5-3.8 17.3-5.5 6.8 21.7 15 43 24.5 63.6-9.6 20.9-17.9 42.5-24.8 64.5zm116.6 98c-16.5 15.1-35.6 27.1-56.4 35.3-11.1 5.3-23.9 5.8-35.3 1.3-15.9-9.2-22.5-44.5-13.5-92 1.1-5.6 2.3-11.2 3.7-16.7 22.4 4.8 45 8.1 67.9 9.8 13.2 18.7 27.7 36.6 43.2 53.4-3.2 3.1-6.4 6.1-9.6 8.9zm24.5-24.3c-10.2-11-20.4-23.2-30.3-36.3 9.6.4 19.5.6 29.5.6 10.3 0 20.4-.2 30.4-.7-9.2 12.7-19.1 24.8-29.6 36.4zm130.7 30c-.9 12.2-6.9 23.6-16.5 31.3-15.9 9.2-49.8-2.8-86.4-34.2-4.2-3.6-8.4-7.5-12.7-11.5 15.3-16.9 29.4-34.8 42.2-53.6 22.9-1.9 45.7-5.4 68.2-10.5 1 4.1 1.9 8.2 2.7 12.2 4.9 21.6 5.7 44.1 2.5 66.3zm18.2-107.5c-2.8.9-5.6 1.8-8.5 2.6-7-21.8-15.6-43.1-25.5-63.8 9.6-20.4 17.7-41.4 24.5-62.9 5.2 1.5 10.2 3.1 15 4.7 46.6 16 79.3 39.8 79.3 58 0 19.6-34.9 44.9-84.8 61.4zm-149.7-15c25.3 0 45.8-20.5 45.8-45.8s-20.5-45.8-45.8-45.8c-25.3 0-45.8 20.5-45.8 45.8s20.5 45.8 45.8 45.8z"
    ]
};
var $ef0249c5e48bf4e3$export$c4a0e7e817efc4de = {
    prefix: "fab",
    iconName: "cc-paypal",
    icon: [
        576,
        512,
        [],
        "f1f4",
        "M186.3 258.2c0 12.2-9.7 21.5-22 21.5-9.2 0-16-5.2-16-15 0-12.2 9.5-22 21.7-22 9.3 0 16.3 5.7 16.3 15.5zM80.5 209.7h-4.7c-1.5 0-3 1-3.2 2.7l-4.3 26.7 8.2-.3c11 0 19.5-1.5 21.5-14.2 2.3-13.4-6.2-14.9-17.5-14.9zm284 0H360c-1.8 0-3 1-3.2 2.7l-4.2 26.7 8-.3c13 0 22-3 22-18-.1-10.6-9.6-11.1-18.1-11.1zM576 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48zM128.3 215.4c0-21-16.2-28-34.7-28h-40c-2.5 0-5 2-5.2 4.7L32 294.2c-.3 2 1.2 4 3.2 4h19c2.7 0 5.2-2.9 5.5-5.7l4.5-26.6c1-7.2 13.2-4.7 18-4.7 28.6 0 46.1-17 46.1-45.8zm84.2 8.8h-19c-3.8 0-4 5.5-4.2 8.2-5.8-8.5-14.2-10-23.7-10-24.5 0-43.2 21.5-43.2 45.2 0 19.5 12.2 32.2 31.7 32.2 9 0 20.2-4.9 26.5-11.9-.5 1.5-1 4.7-1 6.2 0 2.3 1 4 3.2 4H200c2.7 0 5-2.9 5.5-5.7l10.2-64.3c.3-1.9-1.2-3.9-3.2-3.9zm40.5 97.9l63.7-92.6c.5-.5.5-1 .5-1.7 0-1.7-1.5-3.5-3.2-3.5h-19.2c-1.7 0-3.5 1-4.5 2.5l-26.5 39-11-37.5c-.8-2.2-3-4-5.5-4h-18.7c-1.7 0-3.2 1.8-3.2 3.5 0 1.2 19.5 56.8 21.2 62.1-2.7 3.8-20.5 28.6-20.5 31.6 0 1.8 1.5 3.2 3.2 3.2h19.2c1.8-.1 3.5-1.1 4.5-2.6zm159.3-106.7c0-21-16.2-28-34.7-28h-39.7c-2.7 0-5.2 2-5.5 4.7l-16.2 102c-.2 2 1.3 4 3.2 4h20.5c2 0 3.5-1.5 4-3.2l4.5-29c1-7.2 13.2-4.7 18-4.7 28.4 0 45.9-17 45.9-45.8zm84.2 8.8h-19c-3.8 0-4 5.5-4.3 8.2-5.5-8.5-14-10-23.7-10-24.5 0-43.2 21.5-43.2 45.2 0 19.5 12.2 32.2 31.7 32.2 9.3 0 20.5-4.9 26.5-11.9-.3 1.5-1 4.7-1 6.2 0 2.3 1 4 3.2 4H484c2.7 0 5-2.9 5.5-5.7l10.2-64.3c.3-1.9-1.2-3.9-3.2-3.9zm47.5-33.3c0-2-1.5-3.5-3.2-3.5h-18.5c-1.5 0-3 1.2-3.2 2.7l-16.2 104-.3.5c0 1.8 1.5 3.5 3.5 3.5h16.5c2.5 0 5-2.9 5.2-5.7L544 191.2v-.3zm-90 51.8c-12.2 0-21.7 9.7-21.7 22 0 9.7 7 15 16.2 15 12 0 21.7-9.2 21.7-21.5.1-9.8-6.9-15.5-16.2-15.5z"
    ]
};
var $ef0249c5e48bf4e3$export$c1ba640907c93eb6 = {
    prefix: "fab",
    iconName: "squarespace",
    icon: [
        512,
        512,
        [],
        "f5be",
        "M186.12 343.34c-9.65 9.65-9.65 25.29 0 34.94 9.65 9.65 25.29 9.65 34.94 0L378.24 221.1c19.29-19.29 50.57-19.29 69.86 0s19.29 50.57 0 69.86L293.95 445.1c19.27 19.29 50.53 19.31 69.82.04l.04-.04 119.25-119.24c38.59-38.59 38.59-101.14 0-139.72-38.59-38.59-101.15-38.59-139.72 0l-157.22 157.2zm244.53-104.8c-9.65-9.65-25.29-9.65-34.93 0l-157.2 157.18c-19.27 19.29-50.53 19.31-69.82.05l-.05-.05c-9.64-9.64-25.27-9.65-34.92-.01l-.01.01c-9.65 9.64-9.66 25.28-.02 34.93l.02.02c38.58 38.57 101.14 38.57 139.72 0l157.2-157.2c9.65-9.65 9.65-25.29.01-34.93zm-261.99 87.33l157.18-157.18c9.64-9.65 9.64-25.29 0-34.94-9.64-9.64-25.27-9.64-34.91 0L133.72 290.93c-19.28 19.29-50.56 19.3-69.85.01l-.01-.01c-19.29-19.28-19.31-50.54-.03-69.84l.03-.03L218.03 66.89c-19.28-19.29-50.55-19.3-69.85-.02l-.02.02L28.93 186.14c-38.58 38.59-38.58 101.14 0 139.72 38.6 38.59 101.13 38.59 139.73.01zm-87.33-52.4c9.64 9.64 25.27 9.64 34.91 0l157.21-157.19c19.28-19.29 50.55-19.3 69.84-.02l.02.02c9.65 9.65 25.29 9.65 34.93 0 9.65-9.65 9.65-25.29 0-34.93-38.59-38.59-101.13-38.59-139.72 0L81.33 238.54c-9.65 9.64-9.65 25.28-.01 34.93h.01z"
    ]
};
var $ef0249c5e48bf4e3$export$235ca29d6ed8f50f = {
    prefix: "fab",
    iconName: "cc-stripe",
    icon: [
        576,
        512,
        [],
        "f1f5",
        "M492.4 220.8c-8.9 0-18.7 6.7-18.7 22.7h36.7c0-16-9.3-22.7-18-22.7zM375 223.4c-8.2 0-13.3 2.9-17 7l.2 52.8c3.5 3.7 8.5 6.7 16.8 6.7 13.1 0 21.9-14.3 21.9-33.4 0-18.6-9-33.2-21.9-33.1zM528 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM122.2 281.1c0 25.6-20.3 40.1-49.9 40.3-12.2 0-25.6-2.4-38.8-8.1v-33.9c12 6.4 27.1 11.3 38.9 11.3 7.9 0 13.6-2.1 13.6-8.7 0-17-54-10.6-54-49.9 0-25.2 19.2-40.2 48-40.2 11.8 0 23.5 1.8 35.3 6.5v33.4c-10.8-5.8-24.5-9.1-35.3-9.1-7.5 0-12.1 2.2-12.1 7.7 0 16 54.3 8.4 54.3 50.7zm68.8-56.6h-27V275c0 20.9 22.5 14.4 27 12.6v28.9c-4.7 2.6-13.3 4.7-24.9 4.7-21.1 0-36.9-15.5-36.9-36.5l.2-113.9 34.7-7.4v30.8H191zm74 2.4c-4.5-1.5-18.7-3.6-27.1 7.4v84.4h-35.5V194.2h30.7l2.2 10.5c8.3-15.3 24.9-12.2 29.6-10.5h.1zm44.1 91.8h-35.7V194.2h35.7zm0-142.9l-35.7 7.6v-28.9l35.7-7.6zm74.1 145.5c-12.4 0-20-5.3-25.1-9l-.1 40.2-35.5 7.5V194.2h31.3l1.8 8.8c4.9-4.5 13.9-11.1 27.8-11.1 24.9 0 48.4 22.5 48.4 63.8 0 45.1-23.2 65.5-48.6 65.6zm160.4-51.5h-69.5c1.6 16.6 13.8 21.5 27.6 21.5 14.1 0 25.2-3 34.9-7.9V312c-9.7 5.3-22.4 9.2-39.4 9.2-34.6 0-58.8-21.7-58.8-64.5 0-36.2 20.5-64.9 54.3-64.9 33.7 0 51.3 28.7 51.3 65.1 0 3.5-.3 10.9-.4 12.9z"
    ]
};
var $ef0249c5e48bf4e3$export$82bc9680d7d55560 = {
    prefix: "fab",
    iconName: "creative-commons-share",
    icon: [
        496,
        512,
        [],
        "f4f2",
        "M247.6 8C389.4 8 496 118.1 496 256c0 147.1-118.5 248-248.4 248C113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8zm.8 44.7C130.2 52.7 44.7 150.6 44.7 256c0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8.1-113.8-90.2-203.3-202.8-203.3zm101 132.4c7.8 0 13.7 6.1 13.7 13.7v182.5c0 7.7-6.1 13.7-13.7 13.7H214.3c-7.7 0-13.7-6-13.7-13.7v-54h-54c-7.8 0-13.7-6-13.7-13.7V131.1c0-8.2 6.6-12.7 12.4-13.7h136.4c7.7 0 13.7 6 13.7 13.7v54h54zM159.9 300.3h40.7V198.9c0-7.4 5.8-12.6 12-13.7h55.8v-40.3H159.9v155.4zm176.2-88.1H227.6v155.4h108.5V212.2z"
    ]
};
var $ef0249c5e48bf4e3$export$7bb8936d912f16ef = {
    prefix: "fab",
    iconName: "bitcoin",
    icon: [
        512,
        512,
        [],
        "f379",
        "M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zm-141.651-35.33c4.937-32.999-20.191-50.739-54.55-62.573l11.146-44.702-27.213-6.781-10.851 43.524c-7.154-1.783-14.502-3.464-21.803-5.13l10.929-43.81-27.198-6.781-11.153 44.686c-5.922-1.349-11.735-2.682-17.377-4.084l.031-.14-37.53-9.37-7.239 29.062s20.191 4.627 19.765 4.913c11.022 2.751 13.014 10.044 12.68 15.825l-12.696 50.925c.76.194 1.744.473 2.829.907-.907-.225-1.876-.473-2.876-.713l-17.796 71.338c-1.349 3.348-4.767 8.37-12.471 6.464.271.395-19.78-4.937-19.78-4.937l-13.51 31.147 35.414 8.827c6.588 1.651 13.045 3.379 19.4 5.006l-11.262 45.213 27.182 6.781 11.153-44.733a1038.209 1038.209 0 0 0 21.687 5.627l-11.115 44.523 27.213 6.781 11.262-45.128c46.404 8.781 81.299 5.239 95.986-36.727 11.836-33.79-.589-53.281-25.004-65.991 17.78-4.098 31.174-15.792 34.747-39.949zm-62.177 87.179c-8.41 33.79-65.308 15.523-83.755 10.943l14.944-59.899c18.446 4.603 77.6 13.717 68.811 48.956zm8.417-87.667c-7.673 30.736-55.031 15.12-70.393 11.292l13.548-54.327c15.363 3.828 64.836 10.973 56.845 43.035z"
    ]
};
var $ef0249c5e48bf4e3$export$644ebffaf375bd06 = {
    prefix: "fab",
    iconName: "keycdn",
    icon: [
        512,
        512,
        [],
        "f3ba",
        "M63.8 409.3l60.5-59c32.1 42.8 71.1 66 126.6 67.4 30.5.7 60.3-7 86.4-22.4 5.1 5.3 18.5 19.5 20.9 22-32.2 20.7-69.6 31.1-108.1 30.2-43.3-1.1-84.6-16.7-117.7-44.4.3-.6-38.2 37.5-38.6 37.9 9.5 29.8-13.1 62.4-46.3 62.4C20.7 503.3 0 481.7 0 454.9c0-34.3 33.1-56.6 63.8-45.6zm354.9-252.4c19.1 31.3 29.6 67.4 28.7 104-1.1 44.8-19 87.5-48.6 121 .3.3 23.8 25.2 24.1 25.5 9.6-1.3 19.2 2 25.9 9.1 11.3 12 10.9 30.9-1.1 42.4-12 11.3-30.9 10.9-42.4-1.1-6.7-7-9.4-16.8-7.6-26.3-24.9-26.6-44.4-47.2-44.4-47.2 42.7-34.1 63.3-79.6 64.4-124.2.7-28.9-7.2-57.2-21.1-82.2l22.1-21zM104 53.1c6.7 7 9.4 16.8 7.6 26.3l45.9 48.1c-4.7 3.8-13.3 10.4-22.8 21.3-25.4 28.5-39.6 64.8-40.7 102.9-.7 28.9 6.1 57.2 20 82.4l-22 21.5C72.7 324 63.1 287.9 64.2 250.9c1-44.6 18.3-87.6 47.5-121.1l-25.3-26.4c-9.6 1.3-19.2-2-25.9-9.1-11.3-12-10.9-30.9 1.1-42.4C73.5 40.7 92.2 41 104 53.1zM464.9 8c26 0 47.1 22.4 47.1 48.3S490.9 104 464.9 104c-6.3.1-14-1.1-15.9-1.8l-62.9 59.7c-32.7-43.6-76.7-65.9-126.9-67.2-30.5-.7-60.3 6.8-86.2 22.4l-21.1-22C184.1 74.3 221.5 64 260 64.9c43.3 1.1 84.6 16.7 117.7 44.6l41.1-38.6c-1.5-4.7-2.2-9.6-2.2-14.5C416.5 29.7 438.9 8 464.9 8zM256.7 113.4c5.5 0 10.9.4 16.4 1.1 78.1 9.8 133.4 81.1 123.8 159.1-9.8 78.1-81.1 133.4-159.1 123.8-78.1-9.8-133.4-81.1-123.8-159.2 9.3-72.4 70.1-124.6 142.7-124.8zm-59 119.4c.6 22.7 12.2 41.8 32.4 52.2l-11 51.7h73.7l-11-51.7c20.1-10.9 32.1-29 32.4-52.2-.4-32.8-25.8-57.5-58.3-58.3-32.1.8-57.3 24.8-58.2 58.3zM256 160"
    ]
};
var $ef0249c5e48bf4e3$export$76e4000ae88923a5 = {
    prefix: "fab",
    iconName: "opera",
    icon: [
        496,
        512,
        [],
        "f26a",
        "M313.9 32.7c-170.2 0-252.6 223.8-147.5 355.1 36.5 45.4 88.6 75.6 147.5 75.6 36.3 0 70.3-11.1 99.4-30.4-43.8 39.2-101.9 63-165.3 63-3.9 0-8 0-11.9-.3C104.6 489.6 0 381.1 0 248 0 111 111 0 248 0h.8c63.1.3 120.7 24.1 164.4 63.1-29-19.4-63.1-30.4-99.3-30.4zm101.8 397.7c-40.9 24.7-90.7 23.6-132-5.8 56.2-20.5 97.7-91.6 97.7-176.6 0-84.7-41.2-155.8-97.4-176.6 41.8-29.2 91.2-30.3 132.9-5 105.9 98.7 105.5 265.7-1.2 364z"
    ]
};
var $ef0249c5e48bf4e3$export$4ec4278290df08a8 = {
    prefix: "fab",
    iconName: "itch-io",
    icon: [
        512,
        512,
        [],
        "f83a",
        "M71.92 34.77C50.2 47.67 7.4 96.84 7 109.73v21.34c0 27.06 25.29 50.84 48.25 50.84 27.57 0 50.54-22.85 50.54-50 0 27.12 22.18 50 49.76 50s49-22.85 49-50c0 27.12 23.59 50 51.16 50h.5c27.57 0 51.16-22.85 51.16-50 0 27.12 21.47 50 49 50s49.76-22.85 49.76-50c0 27.12 23 50 50.54 50 23 0 48.25-23.78 48.25-50.84v-21.34c-.4-12.9-43.2-62.07-64.92-75C372.56 32.4 325.76 32 256 32S91.14 33.1 71.92 34.77zm132.32 134.39c-22 38.4-77.9 38.71-99.85.25-13.17 23.14-43.17 32.07-56 27.66-3.87 40.15-13.67 237.13 17.73 269.15 80 18.67 302.08 18.12 379.76 0 31.65-32.27 21.32-232 17.75-269.15-12.92 4.44-42.88-4.6-56-27.66-22 38.52-77.85 38.1-99.85-.24-7.1 12.49-23.05 28.94-51.76 28.94a57.54 57.54 0 0 1-51.75-28.94zm-41.58 53.77c16.47 0 31.09 0 49.22 19.78a436.91 436.91 0 0 1 88.18 0C318.22 223 332.85 223 349.31 223c52.33 0 65.22 77.53 83.87 144.45 17.26 62.15-5.52 63.67-33.95 63.73-42.15-1.57-65.49-32.18-65.49-62.79-39.25 6.43-101.93 8.79-155.55 0 0 30.61-23.34 61.22-65.49 62.79-28.42-.06-51.2-1.58-33.94-63.73 18.67-67 31.56-144.45 83.88-144.45zM256 270.79s-44.38 40.77-52.35 55.21l29-1.17v25.32c0 1.55 21.34.16 23.33.16 11.65.54 23.31 1 23.31-.16v-25.28l29 1.17c-8-14.48-52.35-55.24-52.35-55.24z"
    ]
};
var $ef0249c5e48bf4e3$export$b92d594113fd14c4 = {
    prefix: "fab",
    iconName: "umbraco",
    icon: [
        510,
        512,
        [],
        "f8e8",
        "M255.35 8C118.36 7.83 7.14 118.72 7 255.68c-.07 137 111 248.2 248 248.27 136.85 0 247.82-110.7 248-247.67S392.34 8.17 255.35 8zm145 266q-1.14 40.68-14 65t-43.51 35q-30.61 10.7-85.45 10.47h-4.6q-54.78.22-85.44-10.47t-43.52-35q-12.85-24.36-14-65a224.81 224.81 0 0 1 0-30.71 418.37 418.37 0 0 1 3.6-43.88c1.88-13.39 3.57-22.58 5.4-32 1-4.88 1.28-6.42 1.82-8.45a5.09 5.09 0 0 1 4.9-3.89h.69l32 5a5.07 5.07 0 0 1 4.16 5 5 5 0 0 1 0 .77l-1.7 8.78q-2.41 13.25-4.84 33.68a380.62 380.62 0 0 0-2.64 42.15q-.28 40.43 8.13 59.83a43.87 43.87 0 0 0 31.31 25.18A243 243 0 0 0 250 340.6h10.25a242.64 242.64 0 0 0 57.27-5.16 43.86 43.86 0 0 0 31.15-25.23q8.53-19.42 8.13-59.78a388 388 0 0 0-2.6-42.15q-2.48-20.38-4.89-33.68l-1.69-8.78a5 5 0 0 1 0-.77 5 5 0 0 1 4.2-5l32-5h.82a5 5 0 0 1 4.9 3.89c.55 2.05.81 3.57 1.83 8.45 1.82 9.62 3.52 18.78 5.39 32a415.71 415.71 0 0 1 3.61 43.88 228.06 228.06 0 0 1-.04 30.73z"
    ]
};
var $ef0249c5e48bf4e3$export$85ca259eee71d856 = {
    prefix: "fab",
    iconName: "galactic-senate",
    icon: [
        512,
        512,
        [],
        "f50d",
        "M249.86 33.48v26.07C236.28 80.17 226 168.14 225.39 274.9c11.74-15.62 19.13-33.33 19.13-48.24v-16.88c-.03-5.32.75-10.53 2.19-15.65.65-2.14 1.39-4.08 2.62-5.82 1.23-1.75 3.43-3.79 6.68-3.79 3.24 0 5.45 2.05 6.68 3.79 1.23 1.75 1.97 3.68 2.62 5.82 1.44 5.12 2.22 10.33 2.19 15.65v16.88c0 14.91 7.39 32.62 19.13 48.24-.63-106.76-10.91-194.73-24.49-215.35V33.48h-12.28zm-26.34 147.77c-9.52 2.15-18.7 5.19-27.46 9.08 8.9 16.12 9.76 32.64 1.71 37.29-8 4.62-21.85-4.23-31.36-19.82-11.58 8.79-21.88 19.32-30.56 31.09 14.73 9.62 22.89 22.92 18.32 30.66-4.54 7.7-20.03 7.14-35.47-.96-5.78 13.25-9.75 27.51-11.65 42.42 9.68.18 18.67 2.38 26.18 6.04 17.78-.3 32.77-1.96 40.49-4.22 5.55-26.35 23.02-48.23 46.32-59.51.73-25.55 1.88-49.67 3.48-72.07zm64.96 0c1.59 22.4 2.75 46.52 3.47 72.07 23.29 11.28 40.77 33.16 46.32 59.51 7.72 2.26 22.71 3.92 40.49 4.22 7.51-3.66 16.5-5.85 26.18-6.04-1.9-14.91-5.86-29.17-11.65-42.42-15.44 8.1-30.93 8.66-35.47.96-4.57-7.74 3.6-21.05 18.32-30.66-8.68-11.77-18.98-22.3-30.56-31.09-9.51 15.59-23.36 24.44-31.36 19.82-8.05-4.65-7.19-21.16 1.71-37.29a147.49 147.49 0 0 0-27.45-9.08zm-32.48 8.6c-3.23 0-5.86 8.81-6.09 19.93h-.05v16.88c0 41.42-49.01 95.04-93.49 95.04-52 0-122.75-1.45-156.37 29.17v2.51c9.42 17.12 20.58 33.17 33.18 47.97C45.7 380.26 84.77 360.4 141.2 360c45.68 1.02 79.03 20.33 90.76 40.87.01.01-.01.04 0 .05 7.67 2.14 15.85 3.23 24.04 3.21 8.19.02 16.37-1.07 24.04-3.21.01-.01-.01-.04 0-.05 11.74-20.54 45.08-39.85 90.76-40.87 56.43.39 95.49 20.26 108.02 41.35 12.6-14.8 23.76-30.86 33.18-47.97v-2.51c-33.61-30.62-104.37-29.17-156.37-29.17-44.48 0-93.49-53.62-93.49-95.04v-16.88h-.05c-.23-11.12-2.86-19.93-6.09-19.93zm0 96.59c22.42 0 40.6 18.18 40.6 40.6s-18.18 40.65-40.6 40.65-40.6-18.23-40.6-40.65c0-22.42 18.18-40.6 40.6-40.6zm0 7.64c-18.19 0-32.96 14.77-32.96 32.96S237.81 360 256 360s32.96-14.77 32.96-32.96-14.77-32.96-32.96-32.96zm0 6.14c14.81 0 26.82 12.01 26.82 26.82s-12.01 26.82-26.82 26.82-26.82-12.01-26.82-26.82 12.01-26.82 26.82-26.82zm-114.8 66.67c-10.19.07-21.6.36-30.5 1.66.43 4.42 1.51 18.63 7.11 29.76 9.11-2.56 18.36-3.9 27.62-3.9 41.28.94 71.48 34.35 78.26 74.47l.11 4.7c10.4 1.91 21.19 2.94 32.21 2.94 11.03 0 21.81-1.02 32.21-2.94l.11-4.7c6.78-40.12 36.98-73.53 78.26-74.47 9.26 0 18.51 1.34 27.62 3.9 5.6-11.13 6.68-25.34 7.11-29.76-8.9-1.3-20.32-1.58-30.5-1.66-18.76.42-35.19 4.17-48.61 9.67-12.54 16.03-29.16 30.03-49.58 33.07-.09.02-.17.04-.27.05-.05.01-.11.04-.16.05-5.24 1.07-10.63 1.6-16.19 1.6-5.55 0-10.95-.53-16.19-1.6-.05-.01-.11-.04-.16-.05-.1-.02-.17-.04-.27-.05-20.42-3.03-37.03-17.04-49.58-33.07-13.42-5.49-29.86-9.25-48.61-9.67z"
    ]
};
var $ef0249c5e48bf4e3$export$188bec0355fe7cb3 = {
    prefix: "fab",
    iconName: "ubuntu",
    icon: [
        576,
        512,
        [],
        "f7df",
        "M469.2 75A75.6 75.6 0 1 0 317.9 75a75.6 75.6 0 1 0 151.2 0zM154.2 240.7A75.6 75.6 0 1 0 3 240.7a75.6 75.6 0 1 0 151.2 0zM57 346C75.6 392.9 108 433 150 461.1s91.5 42.6 142 41.7c-14.7-18.6-22.9-41.5-23.2-65.2c-6.8-.9-13.3-2.1-19.5-3.4c-26.8-5.7-51.9-17.3-73.6-34s-39.3-38.1-51.7-62.5c-20.9 9.9-44.5 12.8-67.1 8.2zm395.1 89.8a75.6 75.6 0 1 0 -151.2 0 75.6 75.6 0 1 0 151.2 0zM444 351.6c18.5 14.8 31.6 35.2 37.2 58.2c33.3-41.3 52.6-92.2 54.8-145.2s-12.5-105.4-42.2-149.4c-8.6 21.5-24 39.6-43.8 51.6c15.4 28.6 22.9 60.8 21.9 93.2s-10.7 64-28 91.6zM101.1 135.4c12.4 2.7 24.3 7.5 35.1 14.3c16.6-24.2 38.9-44.1 64.8-58S255.8 70.4 285.2 70c.2-5.9 .9-11.9 2-17.7c3.6-16.7 11.1-32.3 21.8-45.5c-47.7-3.8-95.4 6-137.6 28.5S94.3 91.7 70.8 133.4c2.7-.2 5.3-.3 8-.3c7.5 0 15 .8 22.4 2.3z"
    ]
};
var $ef0249c5e48bf4e3$export$89aeef49dacedf59 = {
    prefix: "fab",
    iconName: "draft2digital",
    icon: [
        480,
        512,
        [],
        "f396",
        "M480 398.1l-144-82.2v64.7h-91.3c30.8-35 81.8-95.9 111.8-149.3 35.2-62.6 16.1-123.4-12.8-153.3-4.4-4.6-62.2-62.9-166-41.2-59.1 12.4-89.4 43.4-104.3 67.3-13.1 20.9-17 39.8-18.2 47.7-5.5 33 19.4 67.1 56.7 67.1 31.7 0 57.3-25.7 57.3-57.4 0-27.1-19.7-52.1-48-56.8 1.8-7.3 17.7-21.1 26.3-24.7 41.1-17.3 78 5.2 83.3 33.5 8.3 44.3-37.1 90.4-69.7 127.6C84.5 328.1 18.3 396.8 0 415.9l336-.1V480zM369.9 371l47.1 27.2-47.1 27.2zM134.2 161.4c0 12.4-10 22.4-22.4 22.4s-22.4-10-22.4-22.4 10-22.4 22.4-22.4 22.4 10.1 22.4 22.4zM82.5 380.5c25.6-27.4 97.7-104.7 150.8-169.9 35.1-43.1 40.3-82.4 28.4-112.7-7.4-18.8-17.5-30.2-24.3-35.7 45.3 2.1 68 23.4 82.2 38.3 0 0 42.4 48.2 5.8 113.3-37 65.9-110.9 147.5-128.5 166.7z"
    ]
};
var $ef0249c5e48bf4e3$export$4124a45a674b7b36 = {
    prefix: "fab",
    iconName: "stripe",
    icon: [
        640,
        512,
        [],
        "f429",
        "M165 144.7l-43.3 9.2-.2 142.4c0 26.3 19.8 43.3 46.1 43.3 14.6 0 25.3-2.7 31.2-5.9v-33.8c-5.7 2.3-33.7 10.5-33.7-15.7V221h33.7v-37.8h-33.7zm89.1 51.6l-2.7-13.1H213v153.2h44.3V233.3c10.5-13.8 28.2-11.1 33.9-9.3v-40.8c-6-2.1-26.7-6-37.1 13.1zm92.3-72.3l-44.6 9.5v36.2l44.6-9.5zM44.9 228.3c0-6.9 5.8-9.6 15.1-9.7 13.5 0 30.7 4.1 44.2 11.4v-41.8c-14.7-5.8-29.4-8.1-44.1-8.1-36 0-60 18.8-60 50.2 0 49.2 67.5 41.2 67.5 62.4 0 8.2-7.1 10.9-17 10.9-14.7 0-33.7-6.1-48.6-14.2v40c16.5 7.1 33.2 10.1 48.5 10.1 36.9 0 62.3-15.8 62.3-47.8 0-52.9-67.9-43.4-67.9-63.4zM640 261.6c0-45.5-22-81.4-64.2-81.4s-67.9 35.9-67.9 81.1c0 53.5 30.3 78.2 73.5 78.2 21.2 0 37.1-4.8 49.2-11.5v-33.4c-12.1 6.1-26 9.8-43.6 9.8-17.3 0-32.5-6.1-34.5-26.9h86.9c.2-2.3.6-11.6.6-15.9zm-87.9-16.8c0-20 12.3-28.4 23.4-28.4 10.9 0 22.5 8.4 22.5 28.4zm-112.9-64.6c-17.4 0-28.6 8.2-34.8 13.9l-2.3-11H363v204.8l44.4-9.4.1-50.2c6.4 4.7 15.9 11.2 31.4 11.2 31.8 0 60.8-23.2 60.8-79.6.1-51.6-29.3-79.7-60.5-79.7zm-10.6 122.5c-10.4 0-16.6-3.8-20.9-8.4l-.3-66c4.6-5.1 11-8.8 21.2-8.8 16.2 0 27.4 18.2 27.4 41.4.1 23.9-10.9 41.8-27.4 41.8zm-126.7 33.7h44.6V183.2h-44.6z"
    ]
};
var $ef0249c5e48bf4e3$export$f5c2efa520323804 = {
    prefix: "fab",
    iconName: "houzz",
    icon: [
        448,
        512,
        [],
        "f27c",
        "M275.9 330.7H171.3V480H17V32h109.5v104.5l305.1 85.6V480H275.9z"
    ]
};
var $ef0249c5e48bf4e3$export$5b7cd580ca5d0c32 = {
    prefix: "fab",
    iconName: "gg",
    icon: [
        512,
        512,
        [],
        "f260",
        "M179.2 230.4l102.4 102.4-102.4 102.4L0 256 179.2 76.8l44.8 44.8-25.6 25.6-19.2-19.2-128 128 128 128 51.5-51.5-77.1-76.5 25.6-25.6zM332.8 76.8L230.4 179.2l102.4 102.4 25.6-25.6-77.1-76.5 51.5-51.5 128 128-128 128-19.2-19.2-25.6 25.6 44.8 44.8L512 256 332.8 76.8z"
    ]
};
var $ef0249c5e48bf4e3$export$f3f333bdcc61afcd = {
    prefix: "fab",
    iconName: "dhl",
    icon: [
        640,
        512,
        [],
        "f790",
        "M238 301.2h58.7L319 271h-58.7L238 301.2zM0 282.9v6.4h81.8l4.7-6.4H0zM172.9 271c-8.7 0-6-3.6-4.6-5.5 2.8-3.8 7.6-10.4 10.4-14.1 2.8-3.7 2.8-5.9-2.8-5.9h-51l-41.1 55.8h100.1c33.1 0 51.5-22.5 57.2-30.3h-68.2zm317.5-6.9l39.3-53.4h-62.2l-39.3 53.4h62.2zM95.3 271H0v6.4h90.6l4.7-6.4zm111-26.6c-2.8 3.8-7.5 10.4-10.3 14.2-1.4 2-4.1 5.5 4.6 5.5h45.6s7.3-10 13.5-18.4c8.4-11.4.7-35-29.2-35H112.6l-20.4 27.8h111.4c5.6 0 5.5 2.2 2.7 5.9zM0 301.2h73.1l4.7-6.4H0v6.4zm323 0h58.7L404 271h-58.7c-.1 0-22.3 30.2-22.3 30.2zm222 .1h95v-6.4h-90.3l-4.7 6.4zm22.3-30.3l-4.7 6.4H640V271h-72.7zm-13.5 18.3H640v-6.4h-81.5l-4.7 6.4zm-164.2-78.6l-22.5 30.6h-26.2l22.5-30.6h-58.7l-39.3 53.4H409l39.3-53.4h-58.7zm33.5 60.3s-4.3 5.9-6.4 8.7c-7.4 10-.9 21.6 23.2 21.6h94.3l22.3-30.3H423.1z"
    ]
};
var $ef0249c5e48bf4e3$export$bfa4536fab29fa25 = {
    prefix: "fab",
    iconName: "square-pinterest",
    icon: [
        448,
        512,
        [
            "pinterest-square"
        ],
        "f0d3",
        "M384 32H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64h72.6l-2.2-.8c-5.4-48.1-3.1-57.5 15.7-134.7c3.9-16 8.5-35 13.9-57.9c0 0-7.3-14.8-7.3-36.5c0-70.7 75.5-78 75.5-25c0 13.5-5.4 31.1-11.2 49.8c-3.3 10.6-6.6 21.5-9.1 32c-5.7 24.5 12.3 44.4 36.4 44.4c43.7 0 77.2-46 77.2-112.4c0-58.8-42.3-99.9-102.6-99.9C153 139 112 191.4 112 245.6c0 21.1 8.2 43.7 18.3 56c2 2.4 2.3 4.5 1.7 7c-1.1 4.7-3.1 12.9-4.7 19.2c-1 4-1.8 7.3-2.1 8.6c-1.1 4.5-3.5 5.5-8.2 3.3c-30.6-14.3-49.8-59.1-49.8-95.1C67.2 167.1 123.4 96 229.4 96c85.2 0 151.4 60.7 151.4 141.8c0 84.6-53.3 152.7-127.4 152.7c-24.9 0-48.3-12.9-56.3-28.2c0 0-12.3 46.9-15.3 58.4c-5 19.3-17.6 42.9-27.4 59.3H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64z"
    ]
};
var $ef0249c5e48bf4e3$export$67aa35027cc046c7 = $ef0249c5e48bf4e3$export$bfa4536fab29fa25;
var $ef0249c5e48bf4e3$export$28ff226a626fb008 = {
    prefix: "fab",
    iconName: "xing",
    icon: [
        384,
        512,
        [],
        "f168",
        "M162.7 210c-1.8 3.3-25.2 44.4-70.1 123.5-4.9 8.3-10.8 12.5-17.7 12.5H9.8c-7.7 0-12.1-7.5-8.5-14.4l69-121.3c.2 0 .2-.1 0-.3l-43.9-75.6c-4.3-7.8.3-14.1 8.5-14.1H100c7.3 0 13.3 4.1 18 12.2l44.7 77.5zM382.6 46.1l-144 253v.3L330.2 466c3.9 7.1.2 14.1-8.5 14.1h-65.2c-7.6 0-13.6-4-18-12.2l-92.4-168.5c3.3-5.8 51.5-90.8 144.8-255.2 4.6-8.1 10.4-12.2 17.5-12.2h65.7c8 0 12.3 6.7 8.5 14.1z"
    ]
};
var $ef0249c5e48bf4e3$export$11c2ed8ca6d46555 = {
    prefix: "fab",
    iconName: "blackberry",
    icon: [
        512,
        512,
        [],
        "f37b",
        "M166 116.9c0 23.4-16.4 49.1-72.5 49.1H23.4l21-88.8h67.8c42.1 0 53.8 23.3 53.8 39.7zm126.2-39.7h-67.8L205.7 166h70.1c53.8 0 70.1-25.7 70.1-49.1.1-16.4-11.6-39.7-53.7-39.7zM88.8 208.1H21L0 296.9h70.1c56.1 0 72.5-23.4 72.5-49.1 0-16.3-11.7-39.7-53.8-39.7zm180.1 0h-67.8l-18.7 88.8h70.1c53.8 0 70.1-23.4 70.1-49.1 0-16.3-11.7-39.7-53.7-39.7zm189.3-53.8h-67.8l-18.7 88.8h70.1c53.8 0 70.1-23.4 70.1-49.1.1-16.3-11.6-39.7-53.7-39.7zm-28 137.9h-67.8L343.7 381h70.1c56.1 0 70.1-23.4 70.1-49.1 0-16.3-11.6-39.7-53.7-39.7zM240.8 346H173l-18.7 88.8h70.1c56.1 0 70.1-25.7 70.1-49.1.1-16.3-11.6-39.7-53.7-39.7z"
    ]
};
var $ef0249c5e48bf4e3$export$10c9e6deac1c2eeb = {
    prefix: "fab",
    iconName: "creative-commons-pd",
    icon: [
        496,
        512,
        [],
        "f4ec",
        "M248 8C111 8 0 119.1 0 256c0 137 111 248 248 248s248-111 248-248C496 119.1 385 8 248 8zm0 449.5c-139.2 0-235.8-138-190.2-267.9l78.8 35.1c-2.1 10.5-3.3 21.5-3.3 32.9 0 99 73.9 126.9 120.4 126.9 22.9 0 53.5-6.7 79.4-29.5L297 311.1c-5.5 6.3-17.6 16.7-36.3 16.7-37.8 0-53.7-39.9-53.9-71.9 230.4 102.6 216.5 96.5 217.9 96.8-34.3 62.4-100.6 104.8-176.7 104.8zm194.2-150l-224-100c18.8-34 54.9-30.7 74.7-11l40.4-41.6c-27.1-23.3-58-27.5-78.1-27.5-47.4 0-80.9 20.5-100.7 51.6l-74.9-33.4c36.1-54.9 98.1-91.2 168.5-91.2 111.1 0 201.5 90.4 201.5 201.5 0 18-2.4 35.4-6.8 52-.3-.1-.4-.2-.6-.4z"
    ]
};
var $ef0249c5e48bf4e3$export$6fcce83c026197c = {
    prefix: "fab",
    iconName: "playstation",
    icon: [
        576,
        512,
        [],
        "f3df",
        "M570.9 372.3c-11.3 14.2-38.8 24.3-38.8 24.3L327 470.2v-54.3l150.9-53.8c17.1-6.1 19.8-14.8 5.8-19.4-13.9-4.6-39.1-3.3-56.2 2.9L327 381.1v-56.4c23.2-7.8 47.1-13.6 75.7-16.8 40.9-4.5 90.9.6 130.2 15.5 44.2 14 49.2 34.7 38 48.9zm-224.4-92.5v-139c0-16.3-3-31.3-18.3-35.6-11.7-3.8-19 7.1-19 23.4v347.9l-93.8-29.8V32c39.9 7.4 98 24.9 129.2 35.4C424.1 94.7 451 128.7 451 205.2c0 74.5-46 102.8-104.5 74.6zM43.2 410.2c-45.4-12.8-53-39.5-32.3-54.8 19.1-14.2 51.7-24.9 51.7-24.9l134.5-47.8v54.5l-96.8 34.6c-17.1 6.1-19.7 14.8-5.8 19.4 13.9 4.6 39.1 3.3 56.2-2.9l46.4-16.9v48.8c-51.6 9.3-101.4 7.3-153.9-10z"
    ]
};
var $ef0249c5e48bf4e3$export$1079c541f45f51d0 = {
    prefix: "fab",
    iconName: "quinscape",
    icon: [
        512,
        512,
        [],
        "f459",
        "M313.6 474.6h-1a158.1 158.1 0 0 1 0-316.2c94.9 0 168.2 83.1 157 176.6 4 5.1 8.2 9.6 11.2 15.3 13.4-30.3 20.3-62.4 20.3-97.7C501.1 117.5 391.6 8 256.5 8S12 117.5 12 252.6s109.5 244.6 244.5 244.6a237.36 237.36 0 0 0 70.4-10.1c-5.2-3.5-8.9-8.1-13.3-12.5zm-.1-.1l.4.1zm78.4-168.9a99.2 99.2 0 1 0 99.2 99.2 99.18 99.18 0 0 0-99.2-99.2z"
    ]
};
var $ef0249c5e48bf4e3$export$df0a28abd4a08bff = {
    prefix: "fab",
    iconName: "less",
    icon: [
        640,
        512,
        [],
        "f41d",
        "M612.7 219c0-20.5 3.2-32.6 3.2-54.6 0-34.2-12.6-45.2-40.5-45.2h-20.5v24.2h6.3c14.2 0 17.3 4.7 17.3 22.1 0 16.3-1.6 32.6-1.6 51.5 0 24.2 7.9 33.6 23.6 37.3v1.6c-15.8 3.7-23.6 13.1-23.6 37.3 0 18.9 1.6 34.2 1.6 51.5 0 17.9-3.7 22.6-17.3 22.6v.5h-6.3V393h20.5c27.8 0 40.5-11 40.5-45.2 0-22.6-3.2-34.2-3.2-54.6 0-11 6.8-22.6 27.3-23.6v-27.3c-20.5-.7-27.3-12.3-27.3-23.3zm-105.6 32c-15.8-6.3-30.5-10-30.5-20.5 0-7.9 6.3-12.6 17.9-12.6s22.1 4.7 33.6 13.1l21-27.8c-13.1-10-31-20.5-55.2-20.5-35.7 0-59.9 20.5-59.9 49.4 0 25.7 22.6 38.9 41.5 46.2 16.3 6.3 32.1 11.6 32.1 22.1 0 7.9-6.3 13.1-20.5 13.1-13.1 0-26.3-5.3-40.5-16.3l-21 30.5c15.8 13.1 39.9 22.1 59.9 22.1 42 0 64.6-22.1 64.6-51s-22.5-41-43-47.8zm-358.9 59.4c-3.7 0-8.4-3.2-8.4-13.1V119.1H65.2c-28.4 0-41 11-41 45.2 0 22.6 3.2 35.2 3.2 54.6 0 11-6.8 22.6-27.3 23.6v27.3c20.5.5 27.3 12.1 27.3 23.1 0 19.4-3.2 31-3.2 53.6 0 34.2 12.6 45.2 40.5 45.2h20.5v-24.2h-6.3c-13.1 0-17.3-5.3-17.3-22.6s1.6-32.1 1.6-51.5c0-24.2-7.9-33.6-23.6-37.3v-1.6c15.8-3.7 23.6-13.1 23.6-37.3 0-18.9-1.6-34.2-1.6-51.5s3.7-22.1 17.3-22.1H93v150.8c0 32.1 11 53.1 43.1 53.1 10 0 17.9-1.6 23.6-3.7l-5.3-34.2c-3.1.8-4.6.8-6.2.8zM379.9 251c-16.3-6.3-31-10-31-20.5 0-7.9 6.3-12.6 17.9-12.6 11.6 0 22.1 4.7 33.6 13.1l21-27.8c-13.1-10-31-20.5-55.2-20.5-35.7 0-59.9 20.5-59.9 49.4 0 25.7 22.6 38.9 41.5 46.2 16.3 6.3 32.1 11.6 32.1 22.1 0 7.9-6.3 13.1-20.5 13.1-13.1 0-26.3-5.3-40.5-16.3l-20.5 30.5c15.8 13.1 39.9 22.1 59.9 22.1 42 0 64.6-22.1 64.6-51 .1-28.9-22.5-41-43-47.8zm-155-68.8c-38.4 0-75.1 32.1-74.1 82.5 0 52 34.2 82.5 79.3 82.5 18.9 0 39.9-6.8 56.2-17.9l-15.8-27.8c-11.6 6.8-22.6 10-34.2 10-21 0-37.3-10-41.5-34.2H290c.5-3.7 1.6-11 1.6-19.4.6-42.6-22.6-75.7-66.7-75.7zm-30 66.2c3.2-21 15.8-31 30.5-31 18.9 0 26.3 13.1 26.3 31h-56.8z"
    ]
};
var $ef0249c5e48bf4e3$export$fb78f7bb43feec45 = {
    prefix: "fab",
    iconName: "blogger-b",
    icon: [
        448,
        512,
        [],
        "f37d",
        "M446.6 222.7c-1.8-8-6.8-15.4-12.5-18.5-1.8-1-13-2.2-25-2.7-20.1-.9-22.3-1.3-28.7-5-10.1-5.9-12.8-12.3-12.9-29.5-.1-33-13.8-63.7-40.9-91.3-19.3-19.7-40.9-33-65.5-40.5-5.9-1.8-19.1-2.4-63.3-2.9-69.4-.8-84.8.6-108.4 10C45.9 59.5 14.7 96.1 3.3 142.9 1.2 151.7.7 165.8.2 246.8c-.6 101.5.1 116.4 6.4 136.5 15.6 49.6 59.9 86.3 104.4 94.3 14.8 2.7 197.3 3.3 216 .8 32.5-4.4 58-17.5 81.9-41.9 17.3-17.7 28.1-36.8 35.2-62.1 4.9-17.6 4.5-142.8 2.5-151.7zm-322.1-63.6c7.8-7.9 10-8.2 58.8-8.2 43.9 0 45.4.1 51.8 3.4 9.3 4.7 13.4 11.3 13.4 21.9 0 9.5-3.8 16.2-12.3 21.6-4.6 2.9-7.3 3.1-50.3 3.3-26.5.2-47.7-.4-50.8-1.2-16.6-4.7-22.8-28.5-10.6-40.8zm191.8 199.8l-14.9 2.4-77.5.9c-68.1.8-87.3-.4-90.9-2-7.1-3.1-13.8-11.7-14.9-19.4-1.1-7.3 2.6-17.3 8.2-22.4 7.1-6.4 10.2-6.6 97.3-6.7 89.6-.1 89.1-.1 97.6 7.8 12.1 11.3 9.5 31.2-4.9 39.4z"
    ]
};
var $ef0249c5e48bf4e3$export$b1b65e1549fc9915 = {
    prefix: "fab",
    iconName: "opencart",
    icon: [
        640,
        512,
        [],
        "f23d",
        "M423.3 440.7c0 25.3-20.3 45.6-45.6 45.6s-45.8-20.3-45.8-45.6 20.6-45.8 45.8-45.8c25.4 0 45.6 20.5 45.6 45.8zm-253.9-45.8c-25.3 0-45.6 20.6-45.6 45.8s20.3 45.6 45.6 45.6 45.8-20.3 45.8-45.6-20.5-45.8-45.8-45.8zm291.7-270C158.9 124.9 81.9 112.1 0 25.7c34.4 51.7 53.3 148.9 373.1 144.2 333.3-5 130 86.1 70.8 188.9 186.7-166.7 319.4-233.9 17.2-233.9z"
    ]
};
var $ef0249c5e48bf4e3$export$ff24f295c905f144 = {
    prefix: "fab",
    iconName: "vine",
    icon: [
        384,
        512,
        [],
        "f1ca",
        "M384 254.7v52.1c-18.4 4.2-36.9 6.1-52.1 6.1-36.9 77.4-103 143.8-125.1 156.2-14 7.9-27.1 8.4-42.7-.8C137 452 34.2 367.7 0 102.7h74.5C93.2 261.8 139 343.4 189.3 404.5c27.9-27.9 54.8-65.1 75.6-106.9-49.8-25.3-80.1-80.9-80.1-145.6 0-65.6 37.7-115.1 102.2-115.1 114.9 0 106.2 127.9 81.6 181.5 0 0-46.4 9.2-63.5-20.5 3.4-11.3 8.2-30.8 8.2-48.5 0-31.3-11.3-46.6-28.4-46.6-18.2 0-30.8 17.1-30.8 50 .1 79.2 59.4 118.7 129.9 101.9z"
    ]
};
var $ef0249c5e48bf4e3$export$95b71ec8a2f59bf0 = {
    prefix: "fab",
    iconName: "signal-messenger",
    icon: [
        512,
        512,
        [],
        "e663",
        "M194.6 7.5l5.8 23.3C177.7 36.3 156 45.3 136 57.4L123.7 36.8c22-13.3 45.9-23.2 70.9-29.3zm122.9 0l-5.8 23.3C334.3 36.3 356 45.3 376 57.4l12.4-20.6c-22-13.3-46-23.2-71-29.3zM36.8 123.7c-13.3 22-23.2 45.9-29.3 70.9l23.3 5.8C36.3 177.7 45.3 156 57.4 136L36.8 123.7zM24 256c0-11.6 .9-23.3 2.6-34.8L2.9 217.6c-3.8 25.4-3.8 51.3 0 76.7l23.7-3.6C24.9 279.3 24 267.6 24 256zM388.3 475.2L376 454.6c-20 12.1-41.6 21-64.2 26.6l5.8 23.3c24.9-6.2 48.8-16 70.8-29.3zM488 256c0 11.6-.9 23.3-2.6 34.8l23.7 3.6c3.8-25.4 3.8-51.3 0-76.7l-23.7 3.6c1.7 11.5 2.6 23.1 2.6 34.8zm16.5 61.4l-23.3-5.8c-5.6 22.7-14.5 44.3-26.6 64.3l20.6 12.4c13.3-22 23.2-46 29.3-71zm-213.8 168c-23 3.5-46.5 3.5-69.5 0l-3.6 23.7c25.4 3.8 51.3 3.8 76.7 0l-3.6-23.7zm152-91.8c-13.8 18.7-30.4 35.3-49.2 49.1l14.2 19.3c20.7-15.2 39-33.4 54.2-54.1l-19.3-14.4zM393.6 69.2c18.8 13.8 35.3 30.4 49.2 49.2L462.1 104C446.9 83.4 428.6 65.1 408 49.9L393.6 69.2zM69.2 118.4c13.8-18.8 30.4-35.3 49.2-49.2L104 49.9C83.4 65.1 65.1 83.4 49.9 104l19.3 14.4zm406 5.3L454.6 136c12.1 20 21 41.6 26.6 64.2l23.3-5.8c-6.2-24.9-16-48.8-29.3-70.8zm-254-97.1c23-3.5 46.5-3.5 69.5 0l3.6-23.7C268.9-1 243.1-1 217.6 2.9l3.6 23.7zM81.6 468.4L32 480l11.6-49.6L20.2 425 8.6 474.5c-.9 4-.8 8.1 .3 12.1s3.2 7.5 6.1 10.4s6.5 5 10.4 6.1s8.1 1.2 12.1 .3L87 492l-5.4-23.6zM25.2 403.6L48.6 409l8-34.4c-11.7-19.6-20.4-40.8-25.8-63L7.5 317.4c5.2 21.2 13.2 41.7 23.6 60.8l-5.9 25.3zm112 52l-34.4 8 5.4 23.4 25.3-5.9c19.2 10.4 39.6 18.4 60.8 23.6l5.8-23.3c-22.1-5.5-43.3-14.3-62.8-26l-.2 .2zM256 48c-37.2 0-73.6 10-105.6 28.9s-58.4 46-76.3 78.6s-26.9 69.3-25.8 106.4s12 73.3 31.8 104.8L60 452l85.3-20c27.3 17.2 58.2 27.8 90.3 31s64.5-1.1 94.6-12.6s57.2-29.8 79-53.6s37.8-52.2 46.8-83.2s10.5-63.6 4.7-95.3s-19-61.6-38.4-87.4s-44.5-46.7-73.4-61S288.3 48 256 48z"
    ]
};
var $ef0249c5e48bf4e3$export$1aaa7b292157aaf7 = {
    prefix: "fab",
    iconName: "paypal",
    icon: [
        384,
        512,
        [],
        "f1ed",
        "M111.4 295.9c-3.5 19.2-17.4 108.7-21.5 134-.3 1.8-1 2.5-3 2.5H12.3c-7.6 0-13.1-6.6-12.1-13.9L58.8 46.6c1.5-9.6 10.1-16.9 20-16.9 152.3 0 165.1-3.7 204 11.4 60.1 23.3 65.6 79.5 44 140.3-21.5 62.6-72.5 89.5-140.1 90.3-43.4.7-69.5-7-75.3 24.2zM357.1 152c-1.8-1.3-2.5-1.8-3 1.3-2 11.4-5.1 22.5-8.8 33.6-39.9 113.8-150.5 103.9-204.5 103.9-6.1 0-10.1 3.3-10.9 9.4-22.6 140.4-27.1 169.7-27.1 169.7-1 7.1 3.5 12.9 10.6 12.9h63.5c8.6 0 15.7-6.3 17.4-14.9.7-5.4-1.1 6.1 14.4-91.3 4.6-22 14.3-19.7 29.3-19.7 71 0 126.4-28.8 142.9-112.3 6.5-34.8 4.6-71.4-23.8-92.6z"
    ]
};
var $ef0249c5e48bf4e3$export$bc1566dfb0a3651b = {
    prefix: "fab",
    iconName: "gitlab",
    icon: [
        512,
        512,
        [],
        "f296",
        "M503.5 204.6L502.8 202.8L433.1 21.02C431.7 17.45 429.2 14.43 425.9 12.38C423.5 10.83 420.8 9.865 417.9 9.57C415 9.275 412.2 9.653 409.5 10.68C406.8 11.7 404.4 13.34 402.4 15.46C400.5 17.58 399.1 20.13 398.3 22.9L351.3 166.9H160.8L113.7 22.9C112.9 20.13 111.5 17.59 109.6 15.47C107.6 13.35 105.2 11.72 102.5 10.7C99.86 9.675 96.98 9.295 94.12 9.587C91.26 9.878 88.51 10.83 86.08 12.38C82.84 14.43 80.33 17.45 78.92 21.02L9.267 202.8L8.543 204.6C-1.484 230.8-2.72 259.6 5.023 286.6C12.77 313.5 29.07 337.3 51.47 354.2L51.74 354.4L52.33 354.8L158.3 434.3L210.9 474L242.9 498.2C246.6 500.1 251.2 502.5 255.9 502.5C260.6 502.5 265.2 500.1 268.9 498.2L300.9 474L353.5 434.3L460.2 354.4L460.5 354.1C482.9 337.2 499.2 313.5 506.1 286.6C514.7 259.6 513.5 230.8 503.5 204.6z"
    ]
};
var $ef0249c5e48bf4e3$export$26fe3ad1dc9d4c5b = {
    prefix: "fab",
    iconName: "typo3",
    icon: [
        448,
        512,
        [],
        "f42b",
        "M178.7 78.4c0-24.7 5.4-32.4 13.9-39.4-69.5 8.5-149.3 34-176.3 66.4-5.4 7.7-9.3 20.8-9.3 37.1C7 246 113.8 480 191.1 480c36.3 0 97.3-59.5 146.7-139-7 2.3-11.6 2.3-18.5 2.3-57.2 0-140.6-198.5-140.6-264.9zM301.5 32c-30.1 0-41.7 5.4-41.7 36.3 0 66.4 53.8 198.5 101.7 198.5 26.3 0 78.8-99.7 78.8-182.3 0-40.9-67-52.5-138.8-52.5z"
    ]
};
var $ef0249c5e48bf4e3$export$9fbf70587b6b0dcc = {
    prefix: "fab",
    iconName: "reddit-alien",
    icon: [
        512,
        512,
        [],
        "f281",
        "M373 138.6c-25.2 0-46.3-17.5-51.9-41l0 0c-30.6 4.3-54.2 30.7-54.2 62.4l0 .2c47.4 1.8 90.6 15.1 124.9 36.3c12.6-9.7 28.4-15.5 45.5-15.5c41.3 0 74.7 33.4 74.7 74.7c0 29.8-17.4 55.5-42.7 67.5c-2.4 86.8-97 156.6-213.2 156.6S45.5 410.1 43 323.4C17.6 311.5 0 285.7 0 255.7c0-41.3 33.4-74.7 74.7-74.7c17.2 0 33 5.8 45.7 15.6c34-21.1 76.8-34.4 123.7-36.4l0-.3c0-44.3 33.7-80.9 76.8-85.5C325.8 50.2 347.2 32 373 32c29.4 0 53.3 23.9 53.3 53.3s-23.9 53.3-53.3 53.3zM157.5 255.3c-20.9 0-38.9 20.8-40.2 47.9s17.1 38.1 38 38.1s36.6-9.8 37.8-36.9s-14.7-49.1-35.7-49.1zM395 303.1c-1.2-27.1-19.2-47.9-40.2-47.9s-36.9 22-35.7 49.1c1.2 27.1 16.9 36.9 37.8 36.9s39.3-11 38-38.1zm-60.1 70.8c1.5-3.6-1-7.7-4.9-8.1c-23-2.3-47.9-3.6-73.8-3.6s-50.8 1.3-73.8 3.6c-3.9 .4-6.4 4.5-4.9 8.1c12.9 30.8 43.3 52.4 78.7 52.4s65.8-21.6 78.7-52.4z"
    ]
};
var $ef0249c5e48bf4e3$export$d0632e92ebe1197f = {
    prefix: "fab",
    iconName: "yahoo",
    icon: [
        512,
        512,
        [],
        "f19e",
        "M223.69,141.06,167,284.23,111,141.06H14.93L120.76,390.19,82.19,480h94.17L317.27,141.06Zm105.4,135.79a58.22,58.22,0,1,0,58.22,58.22A58.22,58.22,0,0,0,329.09,276.85ZM394.65,32l-93,223.47H406.44L499.07,32Z"
    ]
};
var $ef0249c5e48bf4e3$export$9743e7788f64058a = {
    prefix: "fab",
    iconName: "dailymotion",
    icon: [
        448,
        512,
        [],
        "e052",
        "M298.93,267a48.4,48.4,0,0,0-24.36-6.21q-19.83,0-33.44,13.27t-13.61,33.42q0,21.16,13.28,34.6t33.43,13.44q20.5,0,34.11-13.78T322,307.47A47.13,47.13,0,0,0,315.9,284,44.13,44.13,0,0,0,298.93,267ZM0,32V480H448V32ZM374.71,405.26h-53.1V381.37h-.67q-15.79,26.2-55.78,26.2-27.56,0-48.89-13.1a88.29,88.29,0,0,1-32.94-35.77q-11.6-22.68-11.59-50.89,0-27.56,11.76-50.22a89.9,89.9,0,0,1,32.93-35.78q21.18-13.09,47.72-13.1a80.87,80.87,0,0,1,29.74,5.21q13.28,5.21,25,17V153l55.79-12.09Z"
    ]
};
var $ef0249c5e48bf4e3$export$c40f060084205fb6 = {
    prefix: "fab",
    iconName: "affiliatetheme",
    icon: [
        512,
        512,
        [],
        "f36b",
        "M159.7 237.4C108.4 308.3 43.1 348.2 14 326.6-15.2 304.9 2.8 230 54.2 159.1c51.3-70.9 116.6-110.8 145.7-89.2 29.1 21.6 11.1 96.6-40.2 167.5zm351.2-57.3C437.1 303.5 319 367.8 246.4 323.7c-25-15.2-41.3-41.2-49-73.8-33.6 64.8-92.8 113.8-164.1 133.2 49.8 59.3 124.1 96.9 207 96.9 150 0 271.6-123.1 271.6-274.9.1-8.5-.3-16.8-1-25z"
    ]
};
var $ef0249c5e48bf4e3$export$96d17626187f6e34 = {
    prefix: "fab",
    iconName: "pied-piper-pp",
    icon: [
        448,
        512,
        [],
        "f1a7",
        "M205.3 174.6c0 21.1-14.2 38.1-31.7 38.1-7.1 0-12.8-1.2-17.2-3.7v-68c4.4-2.7 10.1-4.2 17.2-4.2 17.5 0 31.7 16.9 31.7 37.8zm52.6 67c-7.1 0-12.8 1.5-17.2 4.2v68c4.4 2.5 10.1 3.7 17.2 3.7 17.4 0 31.7-16.9 31.7-37.8 0-21.1-14.3-38.1-31.7-38.1zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zM185 255.1c41 0 74.2-35.6 74.2-79.6 0-44-33.2-79.6-74.2-79.6-12 0-24.1 3.2-34.6 8.8h-45.7V311l51.8-10.1v-50.6c8.6 3.1 18.1 4.8 28.5 4.8zm158.4 25.3c0-44-33.2-79.6-73.9-79.6-3.2 0-6.4.2-9.6.7-3.7 12.5-10.1 23.8-19.2 33.4-13.8 15-32.2 23.8-51.8 24.8V416l51.8-10.1v-50.6c8.6 3.2 18.2 4.7 28.7 4.7 40.8 0 74-35.6 74-79.6z"
    ]
};
var $ef0249c5e48bf4e3$export$3de8f256f5aadacf = {
    prefix: "fab",
    iconName: "bootstrap",
    icon: [
        576,
        512,
        [],
        "f836",
        "M333.5,201.4c0-22.1-15.6-34.3-43-34.3h-50.4v71.2h42.5C315.4,238.2,333.5,225,333.5,201.4z M517,188.6 c-9.5-30.9-10.9-68.8-9.8-98.1c1.1-30.5-22.7-58.5-54.7-58.5H123.7c-32.1,0-55.8,28.1-54.7,58.5c1,29.3-0.3,67.2-9.8,98.1 c-9.6,31-25.7,50.6-52.2,53.1v28.5c26.4,2.5,42.6,22.1,52.2,53.1c9.5,30.9,10.9,68.8,9.8,98.1c-1.1,30.5,22.7,58.5,54.7,58.5h328.7 c32.1,0,55.8-28.1,54.7-58.5c-1-29.3,0.3-67.2,9.8-98.1c9.6-31,25.7-50.6,52.1-53.1v-28.5C542.7,239.2,526.5,219.6,517,188.6z M300.2,375.1h-97.9V136.8h97.4c43.3,0,71.7,23.4,71.7,59.4c0,25.3-19.1,47.9-43.5,51.8v1.3c33.2,3.6,55.5,26.6,55.5,58.3 C383.4,349.7,352.1,375.1,300.2,375.1z M290.2,266.4h-50.1v78.4h52.3c34.2,0,52.3-13.7,52.3-39.5 C344.7,279.6,326.1,266.4,290.2,266.4z"
    ]
};
var $ef0249c5e48bf4e3$export$f31d1294fef45f = {
    prefix: "fab",
    iconName: "odnoklassniki",
    icon: [
        320,
        512,
        [],
        "f263",
        "M275.1 334c-27.4 17.4-65.1 24.3-90 26.9l20.9 20.6 76.3 76.3c27.9 28.6-17.5 73.3-45.7 45.7-19.1-19.4-47.1-47.4-76.3-76.6L84 503.4c-28.2 27.5-73.6-17.6-45.4-45.7 19.4-19.4 47.1-47.4 76.3-76.3l20.6-20.6c-24.6-2.6-62.9-9.1-90.6-26.9-32.6-21-46.9-33.3-34.3-59 7.4-14.6 27.7-26.9 54.6-5.7 0 0 36.3 28.9 94.9 28.9s94.9-28.9 94.9-28.9c26.9-21.1 47.1-8.9 54.6 5.7 12.4 25.7-1.9 38-34.5 59.1zM30.3 129.7C30.3 58 88.6 0 160 0s129.7 58 129.7 129.7c0 71.4-58.3 129.4-129.7 129.4s-129.7-58-129.7-129.4zm66 0c0 35.1 28.6 63.7 63.7 63.7s63.7-28.6 63.7-63.7c0-35.4-28.6-64-63.7-64s-63.7 28.6-63.7 64z"
    ]
};
var $ef0249c5e48bf4e3$export$a64aa05b0287bdaf = {
    prefix: "fab",
    iconName: "nfc-symbol",
    icon: [
        576,
        512,
        [],
        "e531",
        "M392.9 32.43C400.6 31.1 408.6 32.89 414.1 37.41C498.2 96.14 544 173.7 544 255.1C544 338.2 498.2 415.9 414.1 474.6C409.3 478.6 402.4 480.5 395.5 479.9C388.5 479.3 382 476.3 377.1 471.4L193.7 288.7C188.1 283.2 185 275.7 184.1 267.8C184.1 260 188.1 252.5 193.6 246.9C199.2 241.4 206.7 238.2 214.5 238.2C222.4 238.2 229.9 241.3 235.4 246.8L400.5 411.2C455.1 366.5 484.8 312 484.8 255.1C484.8 193.5 447.9 132.9 380.9 85.76C374.5 81.24 370.1 74.35 368.8 66.62C367.4 58.89 369.2 50.94 373.8 44.53C378.3 38.12 385.2 33.77 392.9 32.43V32.43zM186.9 479.6C179.2 480.9 171.3 479.1 164.8 474.6C81.67 415.9 35.84 338.2 35.84 255.1C35.84 173.7 81.67 96.14 164.8 37.41C170.5 33.4 177.4 31.53 184.4 32.12C191.3 32.71 197.8 35.72 202.7 40.63L386.1 223.3C391.7 228.8 394.8 236.3 394.8 244.2C394.9 251.1 391.8 259.5 386.2 265.1C380.7 270.6 373.2 273.8 365.3 273.8C357.5 273.8 349.1 270.7 344.4 265.2L179.3 100.7C124.7 145.9 95.03 199.9 95.03 255.1C95.03 318.5 131.9 379.1 198.1 426.2C205.4 430.8 209.7 437.6 211.1 445.4C212.4 453.1 210.6 461.1 206.1 467.5C201.6 473.9 194.7 478.2 186.9 479.6V479.6z"
    ]
};
var $ef0249c5e48bf4e3$export$1aeaa8a5ac0e3463 = {
    prefix: "fab",
    iconName: "mintbit",
    icon: [
        512,
        512,
        [],
        "e62f",
        "M73.2 512V438.9H365.7V365.7h73.2V219.4H512V0H292.6V73.1H146.3v73.2H73.2V438.9H0V512H73.2zm73.1-219.4h73.2v73.1H146.3V292.6zm73.2-73.1h73.1v73.1H219.4V219.4zm73.1 0V146.3h73.2v73.1H292.6zM365.7 73.1h73.2v73.2H365.7V73.1z"
    ]
};
var $ef0249c5e48bf4e3$export$b5ebb163fdb5edfd = {
    prefix: "fab",
    iconName: "ethereum",
    icon: [
        320,
        512,
        [],
        "f42e",
        "M311.9 260.8L160 353.6 8 260.8 160 0l151.9 260.8zM160 383.4L8 290.6 160 512l152-221.4-152 92.8z"
    ]
};
var $ef0249c5e48bf4e3$export$7c461c4ee7c07c19 = {
    prefix: "fab",
    iconName: "speaker-deck",
    icon: [
        512,
        512,
        [],
        "f83c",
        "M213.86 296H100a100 100 0 0 1 0-200h132.84a40 40 0 0 1 0 80H98c-26.47 0-26.45 40 0 40h113.82a100 100 0 0 1 0 200H40a40 40 0 0 1 0-80h173.86c26.48 0 26.46-40 0-40zM298 416a120.21 120.21 0 0 0 51.11-80h64.55a19.83 19.83 0 0 0 19.66-20V196a19.83 19.83 0 0 0-19.66-20H296.42a60.77 60.77 0 0 0 0-80h136.93c43.44 0 78.65 35.82 78.65 80v160c0 44.18-35.21 80-78.65 80z"
    ]
};
var $ef0249c5e48bf4e3$export$bcf1858bdc40caa3 = {
    prefix: "fab",
    iconName: "creative-commons-nc-eu",
    icon: [
        496,
        512,
        [],
        "f4e9",
        "M247.7 8C103.6 8 0 124.8 0 256c0 136.3 111.7 248 247.7 248C377.9 504 496 403.1 496 256 496 117 388.4 8 247.7 8zm.6 450.7c-112 0-203.6-92.5-203.6-202.7 0-23.2 3.7-45.2 10.9-66l65.7 29.1h-4.7v29.5h23.3c0 6.2-.4 3.2-.4 19.5h-22.8v29.5h27c11.4 67 67.2 101.3 124.6 101.3 26.6 0 50.6-7.9 64.8-15.8l-10-46.1c-8.7 4.6-28.2 10.8-47.3 10.8-28.2 0-58.1-10.9-67.3-50.2h90.3l128.3 56.8c-1.5 2.1-56.2 104.3-178.8 104.3zm-16.7-190.6l-.5-.4.9.4h-.4zm77.2-19.5h3.7v-29.5h-70.3l-28.6-12.6c2.5-5.5 5.4-10.5 8.8-14.3 12.9-15.8 31.1-22.4 51.1-22.4 18.3 0 35.3 5.4 46.1 10l11.6-47.3c-15-6.6-37-12.4-62.3-12.4-39 0-72.2 15.8-95.9 42.3-5.3 6.1-9.8 12.9-13.9 20.1l-81.6-36.1c64.6-96.8 157.7-93.6 170.7-93.6 113 0 203 90.2 203 203.4 0 18.7-2.1 36.3-6.3 52.9l-136.1-60.5z"
    ]
};
var $ef0249c5e48bf4e3$export$a4dfebb823a477ff = {
    prefix: "fab",
    iconName: "patreon",
    icon: [
        512,
        512,
        [],
        "f3d9",
        "M489.7 153.8c-.1-65.4-51-119-110.7-138.3C304.8-8.5 207-5 136.1 28.4C50.3 68.9 23.3 157.7 22.3 246.2C21.5 319 28.7 510.6 136.9 512c80.3 1 92.3-102.5 129.5-152.3c26.4-35.5 60.5-45.5 102.4-55.9c72-17.8 121.1-74.7 121-150z"
    ]
};
var $ef0249c5e48bf4e3$export$862396e708985a99 = {
    prefix: "fab",
    iconName: "avianex",
    icon: [
        512,
        512,
        [],
        "f374",
        "M453.1 32h-312c-38.9 0-76.2 31.2-83.3 69.7L1.2 410.3C-5.9 448.8 19.9 480 58.9 480h312c38.9 0 76.2-31.2 83.3-69.7l56.7-308.5c7-38.6-18.8-69.8-57.8-69.8zm-58.2 347.3l-32 13.5-115.4-110c-14.7 10-29.2 19.5-41.7 27.1l22.1 64.2-17.9 12.7-40.6-61-52.4-48.1 15.7-15.4 58 31.1c9.3-10.5 20.8-22.6 32.8-34.9L203 228.9l-68.8-99.8 18.8-28.9 8.9-4.8L265 207.8l4.9 4.5c19.4-18.8 33.8-32.4 33.8-32.4 7.7-6.5 21.5-2.9 30.7 7.9 9 10.5 10.6 24.7 2.7 31.3-1.8 1.3-15.5 11.4-35.3 25.6l4.5 7.3 94.9 119.4-6.3 7.9z"
    ]
};
var $ef0249c5e48bf4e3$export$e644e4a8cae83fb3 = {
    prefix: "fab",
    iconName: "ello",
    icon: [
        496,
        512,
        [],
        "f5f1",
        "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm143.84 285.2C375.31 358.51 315.79 404.8 248 404.8s-127.31-46.29-143.84-111.6c-1.65-7.44 2.48-15.71 9.92-17.36 7.44-1.65 15.71 2.48 17.36 9.92 14.05 52.91 62 90.11 116.56 90.11s102.51-37.2 116.56-90.11c1.65-7.44 9.92-12.4 17.36-9.92 7.44 1.65 12.4 9.92 9.92 17.36z"
    ]
};
var $ef0249c5e48bf4e3$export$380164e9d6cdbec2 = {
    prefix: "fab",
    iconName: "gofore",
    icon: [
        400,
        512,
        [],
        "f3a7",
        "M324 319.8h-13.2v34.7c-24.5 23.1-56.3 35.8-89.9 35.8-73.2 0-132.4-60.2-132.4-134.4 0-74.1 59.2-134.4 132.4-134.4 35.3 0 68.6 14 93.6 39.4l62.3-63.3C335 55.3 279.7 32 220.7 32 98 32 0 132.6 0 256c0 122.5 97 224 220.7 224 63.2 0 124.5-26.2 171-82.5-2-27.6-13.4-77.7-67.7-77.7zm-12.1-112.5H205.6v89H324c33.5 0 60.5 15.1 76 41.8v-30.6c0-65.2-40.4-100.2-88.1-100.2z"
    ]
};
var $ef0249c5e48bf4e3$export$a219f36955efe01a = {
    prefix: "fab",
    iconName: "bimobject",
    icon: [
        448,
        512,
        [],
        "f378",
        "M416 32H32C14.4 32 0 46.4 0 64v384c0 17.6 14.4 32 32 32h384c17.6 0 32-14.4 32-32V64c0-17.6-14.4-32-32-32zm-64 257.4c0 49.4-11.4 82.6-103.8 82.6h-16.9c-44.1 0-62.4-14.9-70.4-38.8h-.9V368H96V136h64v74.7h1.1c4.6-30.5 39.7-38.8 69.7-38.8h17.3c92.4 0 103.8 33.1 103.8 82.5v35zm-64-28.9v22.9c0 21.7-3.4 33.8-38.4 33.8h-45.3c-28.9 0-44.1-6.5-44.1-35.7v-19c0-29.3 15.2-35.7 44.1-35.7h45.3c35-.2 38.4 12 38.4 33.7z"
    ]
};
var $ef0249c5e48bf4e3$export$3d9997b304f32d18 = {
    prefix: "fab",
    iconName: "brave-reverse",
    icon: [
        448,
        512,
        [],
        "e63d",
        "M298 0c3 0 5.8 1.3 7.8 3.6l38.1 44c.5-.1 1-.2 1.5-.3c9.2-1.6 18.6-2.2 27.7-1.2c11.6 1.4 21.5 5.4 28.9 12.9c7.7 7.8 15.4 15.8 22.6 23.6c2.5 2.7 4.9 5.2 6.9 7.4c.7 .8 1.4 1.5 1.9 2c3.4 3.7 4.2 8.1 2.7 11.9l-9.8 24.6 13.1 38.1c.7 2 .8 4.1 .2 6.2c-.1 .4-.1 .4-.5 2.1c-.6 2.3-.6 2.3-1.5 5.8c-1.6 6.3-3.5 13.3-5.4 20.9c-5.6 21.6-11.2 43.2-16.4 63.4c-12.9 49.9-21.4 82.7-23.4 90.9c-11.1 44.5-19.9 60-48.3 80.3c-24.9 17.8-76.8 53.6-86.8 60c-1 .6-2 1.3-3.4 2.3c-.5 .4-3.2 2.2-3.9 2.7c-4.9 3.3-8.3 5.5-12.1 7.3c-4.7 2.2-9.3 3.5-13.9 3.5s-9.1-1.2-13.9-3.5c-3.7-1.8-7.2-3.9-12.1-7.3c-.8-.5-3.4-2.4-3.9-2.7c-1.4-1-2.5-1.7-3.4-2.3c-10-6.4-61.9-42.1-86.8-60c-28.4-20.4-37.2-35.8-48.3-80.3c-2-8.2-10.5-41-23.3-90.5c-5.3-20.6-10.9-42.2-16.5-63.8c-2-7.6-3.8-14.6-5.4-20.9c-.9-3.5-.9-3.5-1.5-5.8c-.4-1.7-.4-1.7-.5-2.1c-.5-2-.4-4.2 .2-6.2l13.1-38.1L11.8 104c-1.5-3.8-.7-8.2 2-11.2c1.2-1.3 1.8-2 2.6-2.8c2-2.2 4.4-4.7 6.9-7.4C30.6 74.9 38.3 66.9 46 59.1c7.4-7.5 17.3-11.6 28.9-12.9c9.1-1.1 18.5-.5 27.7 1.2c.5 .1 1 .2 1.5 .3l38.1-44C144.2 1.3 147 0 150 0H298zm-4.7 21.1H154.7L115.6 66.2c-2.6 3-6.7 4.3-10.6 3.2c-.2-.1-.7-.2-1.5-.4c-1.3-.3-2.9-.6-4.5-.9c-7.4-1.3-14.9-1.8-21.7-1C70 68 64.3 70.3 60.7 74c-7.6 7.7-15.2 15.6-22.3 23.3c-1.7 1.8-3.3 3.5-4.8 5.1l8.8 22c1 2.4 1 5 .2 7.5L29.2 170.6c.4 1.4 .5 1.9 1.2 4.8c1.6 6.3 3.5 13.3 5.4 20.9c5.6 21.6 11.2 43.2 16.4 63.4c12.9 50 21.4 82.8 23.4 91C85.7 390.8 92 402 115.8 419c24.6 17.6 76.3 53.2 85.9 59.3c1.2 .8 2.5 1.6 4 2.7c.6 .4 3.2 2.2 3.9 2.7c4 2.8 6.7 4.4 9.2 5.6c2.2 1 3.9 1.5 5.1 1.5s2.9-.5 5.1-1.5c2.5-1.2 5.2-2.8 9.2-5.6c.7-.5 3.3-2.3 3.9-2.7c1.6-1.1 2.8-1.9 4-2.7c9.6-6.1 61.3-41.7 85.9-59.3c23.8-17.1 30.2-28.2 40.1-68.3c2.1-8.3 10.5-41.1 23.3-90.7c5.3-20.6 10.9-42.2 16.5-63.8c2-7.6 3.8-14.6 5.4-20.9c.7-2.9 .9-3.4 1.2-4.8l-13.3-38.8c-.8-2.4-.8-5.1 .2-7.5l8.8-22c-1.5-1.6-3.1-3.3-4.8-5.1c-7.2-7.6-14.7-15.5-22.3-23.3c-3.7-3.7-9.3-6-16.6-6.9c-6.8-.8-14.4-.3-21.7 1c-1.7 .3-3.2 .6-4.5 .9c-.8 .2-1.3 .3-1.5 .4c-3.8 1.1-7.9-.2-10.6-3.2L293.3 21.1zM224 316c2.8 0 20.9 6.5 35.4 14.1s25 13 28.3 15.2s1.3 6.2-1.7 8.4s-44.1 34.6-48.1 38.2s-9.8 9.5-13.8 9.5s-9.8-5.9-13.8-9.5s-45.1-36-48.1-38.2s-5.1-6.2-1.7-8.4s13.9-7.5 28.3-15.2s32.5-14.1 35.4-14.1zm.1-230.7c.7 0 8.8 .2 20.5 4.2c12.3 4.2 25.7 9.4 31.9 9.4s51.9-8.9 51.9-8.9s54.2 66.7 54.2 81s-6.8 18-13.7 25.4s-36.8 39.8-40.7 43.9s-11.9 10.5-7.1 21.8s11.7 25.8 3.9 40.4s-21 24.4-29.4 22.8s-28.4-12.2-35.7-17.1s-30.5-24.3-30.5-31.8s24-20.8 28.4-23.9s24.7-14.8 25.1-19.4s.3-6-5.7-17.4s-16.7-26.7-14.9-36.8s19.1-15.4 31.5-20.2s36.2-13.7 39.2-15.1s2.2-2.7-6.8-3.6s-34.6-4.3-46.1-1.1s-31.2 8.2-32.8 10.9s-3 2.7-1.4 11.8s10.1 52.8 10.9 60.6s2.4 12.9-5.8 14.8s-22.1 5.2-26.8 5.2s-18.6-3.3-26.8-5.2s-6.6-7-5.8-14.8s9.3-51.5 10.9-60.6s.2-9.2-1.4-11.8s-21.3-7.6-32.8-10.9s-37.1 .2-46.1 1.1s-9.8 2.2-6.8 3.6s26.8 10.4 39.2 15.1s29.7 10 31.5 20.2s-9 25.4-14.9 36.8s-6.1 12.8-5.7 17.4s20.6 16.4 25.1 19.4s28.4 16.4 28.4 23.9s-23.2 27-30.5 31.8s-27.2 15.4-35.7 17.1s-21.7-8.2-29.4-22.8s-.8-29.1 3.9-40.4s-3.3-17.7-7.1-21.8s-33.8-36.5-40.7-43.9s-13.7-11.2-13.7-25.4s54.2-81 54.2-81s45.8 8.9 51.9 8.9s19.5-5.2 31.9-9.4s20.6-4.2 20.6-4.2l.1 0z"
    ]
};
var $ef0249c5e48bf4e3$export$890714bb00316cc = {
    prefix: "fab",
    iconName: "facebook-f",
    icon: [
        320,
        512,
        [],
        "f39e",
        "M80 299.3V512H196V299.3h86.5l18-97.8H196V166.9c0-51.7 20.3-71.5 72.7-71.5c16.3 0 29.4 .4 37 1.2V7.9C291.4 4 256.4 0 236.2 0C129.3 0 80 50.5 80 159.4v42.1H14v97.8H80z"
    ]
};
var $ef0249c5e48bf4e3$export$e94511deb1df63ce = {
    prefix: "fab",
    iconName: "square-google-plus",
    icon: [
        448,
        512,
        [
            "google-plus-square"
        ],
        "f0d4",
        "M448 96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96zM64 256c0-55.3 44.7-100 100-100c27 0 49.5 9.8 67 26.2l-27.1 26.1c-7.4-7.1-20.3-15.4-39.8-15.4c-34.1 0-61.9 28.2-61.9 63.2c0 34.9 27.8 63.2 61.9 63.2c39.6 0 54.4-28.5 56.8-43.1H164V241.8h94.4c1 5 1.6 10.1 1.6 16.6c0 57.1-38.3 97.6-96 97.6c-55.3 0-100-44.7-100-100zm291 18.2v29H325.8v-29h-29V245h29V216H355v29h29v29.2H355z"
    ]
};
var $ef0249c5e48bf4e3$export$d546947149d9505a = $ef0249c5e48bf4e3$export$e94511deb1df63ce;
var $ef0249c5e48bf4e3$export$2a745e3ef2838c53 = {
    prefix: "fab",
    iconName: "mandalorian",
    icon: [
        448,
        512,
        [],
        "f50f",
        "M232.27 511.89c-1-3.26-1.69-15.83-1.39-24.58.55-15.89 1-24.72 1.4-28.76.64-6.2 2.87-20.72 3.28-21.38.6-1 .4-27.87-.24-33.13-.31-2.58-.63-11.9-.69-20.73-.13-16.47-.53-20.12-2.73-24.76-1.1-2.32-1.23-3.84-1-11.43a92.38 92.38 0 0 0-.34-12.71c-2-13-3.46-27.7-3.25-33.9s.43-7.15 2.06-9.67c3.05-4.71 6.51-14 8.62-23.27 2.26-9.86 3.88-17.18 4.59-20.74a109.54 109.54 0 0 1 4.42-15.05c2.27-6.25 2.49-15.39.37-15.39-.3 0-1.38 1.22-2.41 2.71s-4.76 4.8-8.29 7.36c-8.37 6.08-11.7 9.39-12.66 12.58s-1 7.23-.16 7.76c.34.21 1.29 2.4 2.11 4.88a28.83 28.83 0 0 1 .72 15.36c-.39 1.77-1 5.47-1.46 8.23s-1 6.46-1.25 8.22a9.85 9.85 0 0 1-1.55 4.26c-1 1-1.14.91-2.05-.53a14.87 14.87 0 0 1-1.44-4.75c-.25-1.74-1.63-7.11-3.08-11.93-3.28-10.9-3.52-16.15-1-21a14.24 14.24 0 0 0 1.67-4.61c0-2.39-2.2-5.32-7.41-9.89-7-6.18-8.63-7.92-10.23-11.3-1.71-3.6-3.06-4.06-4.54-1.54-1.78 3-2.6 9.11-3 22l-.34 12.19 2 2.25c3.21 3.7 12.07 16.45 13.78 19.83 3.41 6.74 4.34 11.69 4.41 23.56s.95 22.75 2 24.71c.36.66.51 1.35.34 1.52s.41 2.09 1.29 4.27a38.14 38.14 0 0 1 2.06 9 91 91 0 0 0 1.71 10.37c2.23 9.56 2.77 14.08 2.39 20.14-.2 3.27-.53 11.07-.73 17.32-1.31 41.76-1.85 58-2 61.21-.12 2-.39 11.51-.6 21.07-.36 16.3-1.3 27.37-2.42 28.65-.64.73-8.07-4.91-12.52-9.49-3.75-3.87-4-4.79-2.83-9.95.7-3 2.26-18.29 3.33-32.62.36-4.78.81-10.5 1-12.71.83-9.37 1.66-20.35 2.61-34.78.56-8.46 1.33-16.44 1.72-17.73s.89-9.89 1.13-19.11l.43-16.77-2.26-4.3c-1.72-3.28-4.87-6.94-13.22-15.34-6-6.07-11.84-12.3-12.91-13.85l-1.95-2.81.75-10.9c1.09-15.71 1.1-48.57 0-59.06l-.89-8.7-3.28-4.52c-5.86-8.08-5.8-7.75-6.22-33.27-.1-6.07-.38-11.5-.63-12.06-.83-1.87-3.05-2.66-8.54-3.05-8.86-.62-11-1.9-23.85-14.55-6.15-6-12.34-12-13.75-13.19-2.81-2.42-2.79-2-.56-9.63l1.35-4.65-1.69-3a32.22 32.22 0 0 0-2.59-4.07c-1.33-1.51-5.5-10.89-6-13.49a4.24 4.24 0 0 1 .87-3.9c2.23-2.86 3.4-5.68 4.45-10.73 2.33-11.19 7.74-26.09 10.6-29.22 3.18-3.47 7.7-1 9.41 5 1.34 4.79 1.37 9.79.1 18.55a101.2 101.2 0 0 0-1 11.11c0 4 .19 4.69 2.25 7.39 3.33 4.37 7.73 7.41 15.2 10.52a18.67 18.67 0 0 1 4.72 2.85c11.17 10.72 18.62 16.18 22.95 16.85 5.18.8 8 4.54 10 13.39 1.31 5.65 4 11.14 5.46 11.14a9.38 9.38 0 0 0 3.33-1.39c2-1.22 2.25-1.73 2.25-4.18a132.88 132.88 0 0 0-2-17.84c-.37-1.66-.78-4.06-.93-5.35s-.61-3.85-1-5.69c-2.55-11.16-3.65-15.46-4.1-16-1.55-2-4.08-10.2-4.93-15.92-1.64-11.11-4-14.23-12.91-17.39A43.15 43.15 0 0 1 165.24 78c-1.15-1-4-3.22-6.35-5.06s-4.41-3.53-4.6-3.76a22.7 22.7 0 0 0-2.69-2c-6.24-4.22-8.84-7-11.26-12l-2.44-5-.22-13-.22-13 6.91-6.55c3.95-3.75 8.48-7.35 10.59-8.43 3.31-1.69 4.45-1.89 11.37-2 8.53-.19 10.12 0 11.66 1.56s1.36 6.4-.29 8.5a6.66 6.66 0 0 0-1.34 2.32c0 .58-2.61 4.91-5.42 9a30.39 30.39 0 0 0-2.37 6.82c20.44 13.39 21.55 3.77 14.07 29L194 66.92c3.11-8.66 6.47-17.26 8.61-26.22.29-7.63-12-4.19-15.4-8.68-2.33-5.93 3.13-14.18 6.06-19.2 1.6-2.34 6.62-4.7 8.82-4.15.88.22 4.16-.35 7.37-1.28a45.3 45.3 0 0 1 7.55-1.68 29.57 29.57 0 0 0 6-1.29c3.65-1.11 4.5-1.17 6.35-.4a29.54 29.54 0 0 0 5.82 1.36 18.18 18.18 0 0 1 6 1.91 22.67 22.67 0 0 0 5 2.17c2.51.68 3 .57 7.05-1.67l4.35-2.4L268.32 5c10.44-.4 10.81-.47 15.26-2.68L288.16 0l2.46 1.43c1.76 1 3.14 2.73 4.85 6 2.36 4.51 2.38 4.58 1.37 7.37-.88 2.44-.89 3.3-.1 6.39a35.76 35.76 0 0 0 2.1 5.91 13.55 13.55 0 0 1 1.31 4c.31 4.33 0 5.3-2.41 6.92-2.17 1.47-7 7.91-7 9.34a14.77 14.77 0 0 1-1.07 3c-5 11.51-6.76 13.56-14.26 17-9.2 4.2-12.3 5.19-16.21 5.19-3.1 0-4 .25-4.54 1.26a18.33 18.33 0 0 1-4.09 3.71 13.62 13.62 0 0 0-4.38 4.78 5.89 5.89 0 0 1-2.49 2.91 6.88 6.88 0 0 0-2.45 1.71 67.62 67.62 0 0 1-7 5.38c-3.33 2.34-6.87 5-7.87 6A7.27 7.27 0 0 1 224 100a5.76 5.76 0 0 0-2.13 1.65c-1.31 1.39-1.49 2.11-1.14 4.6a36.45 36.45 0 0 0 1.42 5.88c1.32 3.8 1.31 7.86 0 10.57s-.89 6.65 1.35 9.59c2 2.63 2.16 4.56.71 8.84a33.45 33.45 0 0 0-1.06 8.91c0 4.88.22 6.28 1.46 8.38s1.82 2.48 3.24 2.32c2-.23 2.3-1.05 4.71-12.12 2.18-10 3.71-11.92 13.76-17.08 2.94-1.51 7.46-4 10-5.44s6.79-3.69 9.37-4.91a40.09 40.09 0 0 0 15.22-11.67c7.11-8.79 10-16.22 12.85-33.3a18.37 18.37 0 0 1 2.86-7.73 20.39 20.39 0 0 0 2.89-7.31c1-5.3 2.85-9.08 5.58-11.51 4.7-4.18 6-1.09 4.59 10.87-.46 3.86-1.1 10.33-1.44 14.38l-.61 7.36 4.45 4.09 4.45 4.09.11 8.42c.06 4.63.47 9.53.92 10.89l.82 2.47-6.43 6.28c-8.54 8.33-12.88 13.93-16.76 21.61-1.77 3.49-3.74 7.11-4.38 8-2.18 3.11-6.46 13-8.76 20.26l-2.29 7.22-7 6.49c-3.83 3.57-8 7.25-9.17 8.17-3.05 2.32-4.26 5.15-4.26 10a14.62 14.62 0 0 0 1.59 7.26 42 42 0 0 1 2.09 4.83 9.28 9.28 0 0 0 1.57 2.89c1.4 1.59 1.92 16.12.83 23.22-.68 4.48-3.63 12-4.7 12-1.79 0-4.06 9.27-5.07 20.74-.18 2-.62 5.94-1 8.7s-1 10-1.35 16.05c-.77 12.22-.19 18.77 2 23.15 3.41 6.69.52 12.69-11 22.84l-4 3.49.07 5.19a40.81 40.81 0 0 0 1.14 8.87c4.61 16 4.73 16.92 4.38 37.13-.46 26.4-.26 40.27.63 44.15a61.31 61.31 0 0 1 1.08 7c.17 2 .66 5.33 1.08 7.36.47 2.26.78 11 .79 22.74v19.06l-1.81 2.63c-2.71 3.91-15.11 13.54-15.49 12.29zm29.53-45.11c-.18-.3-.33-6.87-.33-14.59 0-14.06-.89-27.54-2.26-34.45-.4-2-.81-9.7-.9-17.06-.15-11.93-1.4-24.37-2.64-26.38-.66-1.07-3-17.66-3-21.3 0-4.23 1-6 5.28-9.13s4.86-3.14 5.48-.72c.28 1.1 1.45 5.62 2.6 10 3.93 15.12 4.14 16.27 4.05 21.74-.1 5.78-.13 6.13-1.74 17.73-1 7.07-1.17 12.39-1 28.43.17 19.4-.64 35.73-2 41.27-.71 2.78-2.8 5.48-3.43 4.43zm-71-37.58a101 101 0 0 1-1.73-10.79 100.5 100.5 0 0 0-1.73-10.79 37.53 37.53 0 0 1-1-6.49c-.31-3.19-.91-7.46-1.33-9.48-1-4.79-3.35-19.35-3.42-21.07 0-.74-.34-4.05-.7-7.36-.67-6.21-.84-27.67-.22-28.29 1-1 6.63 2.76 11.33 7.43l5.28 5.25-.45 6.47c-.25 3.56-.6 10.23-.78 14.83s-.49 9.87-.67 11.71-.61 9.36-.94 16.72c-.79 17.41-1.94 31.29-2.65 32a.62.62 0 0 1-1-.14zm-87.18-266.59c21.07 12.79 17.84 14.15 28.49 17.66 13 4.29 18.87 7.13 23.15 16.87C111.6 233.28 86.25 255 78.55 268c-31 52-6 101.59 62.75 87.21-14.18 29.23-78 28.63-98.68-4.9-24.68-39.95-22.09-118.3 61-187.66zm210.79 179c56.66 6.88 82.32-37.74 46.54-89.23 0 0-26.87-29.34-64.28-68 3-15.45 9.49-32.12 30.57-53.82 89.2 63.51 92 141.61 92.46 149.36 4.3 70.64-78.7 91.18-105.29 61.71z"
    ]
};
var $ef0249c5e48bf4e3$export$ea0bc2cd8d60b806 = {
    prefix: "fab",
    iconName: "first-order-alt",
    icon: [
        496,
        512,
        [],
        "f50a",
        "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm0 488.21C115.34 496.21 7.79 388.66 7.79 256S115.34 15.79 248 15.79 488.21 123.34 488.21 256 380.66 496.21 248 496.21zm0-459.92C126.66 36.29 28.29 134.66 28.29 256S126.66 475.71 248 475.71 467.71 377.34 467.71 256 369.34 36.29 248 36.29zm0 431.22c-116.81 0-211.51-94.69-211.51-211.51S131.19 44.49 248 44.49 459.51 139.19 459.51 256 364.81 467.51 248 467.51zm186.23-162.98a191.613 191.613 0 0 1-20.13 48.69l-74.13-35.88 61.48 54.82a193.515 193.515 0 0 1-37.2 37.29l-54.8-61.57 35.88 74.27a190.944 190.944 0 0 1-48.63 20.23l-27.29-78.47 4.79 82.93c-8.61 1.18-17.4 1.8-26.33 1.8s-17.72-.62-26.33-1.8l4.76-82.46-27.15 78.03a191.365 191.365 0 0 1-48.65-20.2l35.93-74.34-54.87 61.64a193.85 193.85 0 0 1-37.22-37.28l61.59-54.9-74.26 35.93a191.638 191.638 0 0 1-20.14-48.69l77.84-27.11-82.23 4.76c-1.16-8.57-1.78-17.32-1.78-26.21 0-9 .63-17.84 1.82-26.51l82.38 4.77-77.94-27.16a191.726 191.726 0 0 1 20.23-48.67l74.22 35.92-61.52-54.86a193.85 193.85 0 0 1 37.28-37.22l54.76 61.53-35.83-74.17a191.49 191.49 0 0 1 48.65-20.13l26.87 77.25-4.71-81.61c8.61-1.18 17.39-1.8 26.32-1.8s17.71.62 26.32 1.8l-4.74 82.16 27.05-77.76c17.27 4.5 33.6 11.35 48.63 20.17l-35.82 74.12 54.72-61.47a193.13 193.13 0 0 1 37.24 37.23l-61.45 54.77 74.12-35.86a191.515 191.515 0 0 1 20.2 48.65l-77.81 27.1 82.24-4.75c1.19 8.66 1.82 17.5 1.82 26.49 0 8.88-.61 17.63-1.78 26.19l-82.12-4.75 77.72 27.09z"
    ]
};
var $ef0249c5e48bf4e3$export$89cf1df24c6f1e2 = {
    prefix: "fab",
    iconName: "osi",
    icon: [
        512,
        512,
        [],
        "f41a",
        "M8 266.44C10.3 130.64 105.4 34 221.8 18.34c138.8-18.6 255.6 75.8 278 201.1 21.3 118.8-44 230-151.6 274-9.3 3.8-14.4 1.7-18-7.7q-26.7-69.45-53.4-139c-3.1-8.1-1-13.2 7-16.8 24.2-11 39.3-29.4 43.3-55.8a71.47 71.47 0 0 0-64.5-82.2c-39-3.4-71.8 23.7-77.5 59.7-5.2 33 11.1 63.7 41.9 77.7 9.6 4.4 11.5 8.6 7.8 18.4q-26.85 69.9-53.7 139.9c-2.6 6.9-8.3 9.3-15.5 6.5-52.6-20.3-101.4-61-130.8-119-24.9-49.2-25.2-87.7-26.8-108.7zm20.9-1.9c.4 6.6.6 14.3 1.3 22.1 6.3 71.9 49.6 143.5 131 183.1 3.2 1.5 4.4.8 5.6-2.3q22.35-58.65 45-117.3c1.3-3.3.6-4.8-2.4-6.7-31.6-19.9-47.3-48.5-45.6-86 1-21.6 9.3-40.5 23.8-56.3 30-32.7 77-39.8 115.5-17.6a91.64 91.64 0 0 1 45.2 90.4c-3.6 30.6-19.3 53.9-45.7 69.8-2.7 1.6-3.5 2.9-2.3 6q22.8 58.8 45.2 117.7c1.2 3.1 2.4 3.8 5.6 2.3 35.5-16.6 65.2-40.3 88.1-72 34.8-48.2 49.1-101.9 42.3-161-13.7-117.5-119.4-214.8-255.5-198-106.1 13-195.3 102.5-197.1 225.8z"
    ]
};
var $ef0249c5e48bf4e3$export$6fd7b581d1a20a14 = {
    prefix: "fab",
    iconName: "google-wallet",
    icon: [
        448,
        512,
        [],
        "f1ee",
        "M156.8 126.8c37.6 60.6 64.2 113.1 84.3 162.5-8.3 33.8-18.8 66.5-31.3 98.3-13.2-52.3-26.5-101.3-56-148.5 6.5-36.4 2.3-73.6 3-112.3zM109.3 200H16.1c-6.5 0-10.5 7.5-6.5 12.7C51.8 267 81.3 330.5 101.3 400h103.5c-16.2-69.7-38.7-133.7-82.5-193.5-3-4-8-6.5-13-6.5zm47.8-88c68.5 108 130 234.5 138.2 368H409c-12-138-68.4-265-143.2-368H157.1zm251.8-68.5c-1.8-6.8-8.2-11.5-15.2-11.5h-88.3c-5.3 0-9 5-7.8 10.3 13.2 46.5 22.3 95.5 26.5 146 48.2 86.2 79.7 178.3 90.6 270.8 15.8-60.5 25.3-133.5 25.3-203 0-73.6-12.1-145.1-31.1-212.6z"
    ]
};
var $ef0249c5e48bf4e3$export$8ffeba28c1feff0d = {
    prefix: "fab",
    iconName: "d-and-d-beyond",
    icon: [
        640,
        512,
        [],
        "f6ca",
        "M313.8 241.5c13.8 0 21-10.1 24.8-17.9-1-1.1-5-4.2-7.4-6.6-2.4 4.3-8.2 10.7-13.9 10.7-10.2 0-15.4-14.7-3.2-26.6-.5-.2-4.3-1.8-8 2.4 0-3 1-5.1 2.1-6.6-3.5 1.3-9.8 5.6-11.4 7.9.2-5.8 1.6-7.5.6-9l-.2-.2s-8.5 5.6-9.3 14.7c0 0 1.1-1.6 2.1-1.9.6-.3 1.3 0 .6 1.9-.2.6-5.8 15.7 5.1 26-.6-1.6-1.9-7.6 2.4-1.9-.3.1 5.8 7.1 15.7 7.1zm52.4-21.1c0-4-4.9-4.4-5.6-4.5 2 3.9.9 7.5.2 9 2.5-.4 5.4-1.6 5.4-4.5zm10.3 5.2c0-6.4-6.2-11.4-13.5-10.7 8 1.3 5.6 13.8-5 11.4 3.7-2.6 3.2-9.9-1.3-12.5 1.4 4.2-3 8.2-7.4 4.6-2.4-1.9-8-6.6-10.6-8.6-2.4-2.1-5.5-1-6.6-1.8-1.3-1.1-.5-3.8-2.2-5-1.6-.8-3-.3-4.8-1-1.6-.6-2.7-1.9-2.6-3.5-2.5 4.4 3.4 6.3 4.5 8.5 1 1.9-.8 4.8 4 8.5 14.8 11.6 9.1 8 10.4 18.1.6 4.3 4.2 6.7 6.4 7.4-2.1-1.9-2.9-6.4 0-9.3 0 13.9 19.2 13.3 23.1 6.4-2.4 1.1-7-.2-9-1.9 7.7 1 14.2-4.1 14.6-10.6zm-39.4-18.4c2 .8 1.6.7 6.4 4.5 10.2-24.5 21.7-15.7 22-15.5 2.2-1.9 9.8-3.8 13.8-2.7-2.4-2.7-7.5-6.2-13.3-6.2-4.7 0-7.4 2.2-8 1.3-.8-1.4 3.2-3.4 3.2-3.4-5.4.2-9.6 6.7-11.2 5.9-1.1-.5 1.4-3.7 1.4-3.7-5.1 2.9-9.3 9.1-10.2 13 4.6-5.8 13.8-9.8 19.7-9-10.5.5-19.5 9.7-23.8 15.8zm242.5 51.9c-20.7 0-40 1.3-50.3 2.1l7.4 8.2v77.2l-7.4 8.2c10.4.8 30.9 2.1 51.6 2.1 42.1 0 59.1-20.7 59.1-48.9 0-29.3-23.2-48.9-60.4-48.9zm-15.1 75.6v-53.3c30.1-3.3 46.8 3.8 46.8 26.3 0 25.6-21.4 30.2-46.8 27zM301.6 181c-1-3.4-.2-6.9 1.1-9.4 1 3 2.6 6.4 7.5 9-.5-2.4-.2-5.6.5-8-1.4-5.4 2.1-9.9 6.4-9.9 6.9 0 8.5 8.8 4.7 14.4 2.1 3.2 5.5 5.6 7.7 7.8 3.2-3.7 5.5-9.5 5.5-13.8 0-8.2-5.5-15.9-16.7-16.5-20-.9-20.2 16.6-20 18.9.5 5.2 3.4 7.8 3.3 7.5zm-.4 6c-.5 1.8-7 3.7-10.2 6.9 4.8-1 7-.2 7.8 1.8.5 1.4-.2 3.4-.5 5.6 1.6-1.8 7-5.5 11-6.2-1-.3-3.4-.8-4.3-.8 2.9-3.4 9.3-4.5 12.8-3.7-2.2-.2-6.7 1.1-8.5 2.6 1.6.3 3 .6 4.3 1.1-2.1.8-4.8 3.4-5.8 6.1 7-5 13.1 5.2 7 8.2.8.2 2.7 0 3.5-.5-.3 1.1-1.9 3-3 3.4 2.9 0 7-1.9 8.2-4.6 0 0-1.8.6-2.6-.2s.3-4.3.3-4.3c-2.3 2.9-3.4-1.3-1.3-4.2-1-.3-3.5-.6-4.6-.5 3.2-1.1 10.4-1.8 11.2-.3.6 1.1-1 3.4-1 3.4 4-.5 8.3 1.1 6.7 5.1 2.9-1.4 5.5-5.9 4.8-10.4-.3 1-1.6 2.4-2.9 2.7.2-1.4-1-2.2-1.9-2.6 1.7-9.6-14.6-14.2-14.1-23.9-1 1.3-1.8 5-.8 7.1 2.7 3.2 8.7 6.7 10.1 12.2-2.6-6.4-15.1-11.4-14.6-20.2-1.6 1.6-2.6 7.8-1.3 11 2.4 1.4 4.5 3.8 4.8 6.1-2.2-5.1-11.4-6.1-13.9-12.2-.6 2.2-.3 5 1 6.7 0 0-2.2-.8-7-.6 1.7.6 5.1 3.5 4.8 5.2zm25.9 7.4c-2.7 0-3.5-2.1-4.2-4.3 3.3 1.3 4.2 4.3 4.2 4.3zm38.9 3.7l-1-.6c-1.1-1-2.9-1.4-4.7-1.4-2.9 0-5.8 1.3-7.5 3.4-.8.8-1.4 1.8-2.1 2.6v15.7c3.5 2.6 7.1-2.9 3-7.2 1.5.3 4.6 2.7 5.1 3.2 0 0 2.6-.5 5-.5 2.1 0 3.9.3 5.6 1.1V196c-1.1.5-2.2 1-2.7 1.4zM79.9 305.9c17.2-4.6 16.2-18 16.2-19.9 0-20.6-24.1-25-37-25H3l8.3 8.6v29.5H0l11.4 14.6V346L3 354.6c61.7 0 73.8 1.5 86.4-5.9 6.7-4 9.9-9.8 9.9-17.6 0-5.1 2.6-18.8-19.4-25.2zm-41.3-27.5c20 0 29.6-.8 29.6 9.1v3c0 12.1-19 8.8-29.6 8.8zm0 59.2V315c12.2 0 32.7-2.3 32.7 8.8v4.5h.2c0 11.2-12.5 9.3-32.9 9.3zm101.2-19.3l23.1.2v-.2l14.1-21.2h-37.2v-14.9h52.4l-14.1-21v-.2l-73.5.2 7.4 8.2v77.1l-7.4 8.2h81.2l14.1-21.2-60.1.2zm214.7-60.1c-73.9 0-77.5 99.3-.3 99.3 77.9 0 74.1-99.3.3-99.3zm-.3 77.5c-37.4 0-36.9-55.3.2-55.3 36.8.1 38.8 55.3-.2 55.3zm-91.3-8.3l44.1-66.2h-41.7l6.1 7.2-20.5 37.2h-.3l-21-37.2 6.4-7.2h-44.9l44.1 65.8.2 19.4-7.7 8.2h42.6l-7.2-8.2zm-28.4-151.3c1.6 1.3 2.9 2.4 2.9 6.6v38.8c0 4.2-.8 5.3-2.7 6.4-.1.1-7.5 4.5-7.9 4.6h35.1c10 0 17.4-1.5 26-8.6-.6-5 .2-9.5.8-12 0-.2-1.8 1.4-2.7 3.5 0-5.7 1.6-15.4 9.6-20.5-.1 0-3.7-.8-9 1.1 2-3.1 10-7.9 10.4-7.9-8.2-26-38-22.9-32.2-22.9-30.9 0-32.6.3-39.9-4 .1.8.5 8.2 9.6 14.9zm21.5 5.5c4.6 0 23.1-3.3 23.1 17.3 0 20.7-18.4 17.3-23.1 17.3zm228.9 79.6l7 8.3V312h-.3c-5.4-14.4-42.3-41.5-45.2-50.9h-31.6l7.4 8.5v76.9l-7.2 8.3h39l-7.4-8.2v-47.4h.3c3.7 10.6 44.5 42.9 48.5 55.6h21.3v-85.2l7.4-8.3zm-106.7-96.1c-32.2 0-32.8.2-39.9-4 .1.7.5 8.3 9.6 14.9 3.1 2 2.9 4.3 2.9 9.5 1.8-1.1 3.8-2.2 6.1-3-1.1 1.1-2.7 2.7-3.5 4.5 1-1.1 7.5-5.1 14.6-3.5-1.6.3-4 1.1-6.1 2.9.1 0 2.1-1.1 7.5-.3v-4.3c4.7 0 23.1-3.4 23.1 17.3 0 20.5-18.5 17.3-19.7 17.3 5.7 4.4 5.8 12 2.2 16.3h.3c33.4 0 36.7-27.3 36.7-34 0-3.8-1.1-32-33.8-33.6z"
    ]
};
var $ef0249c5e48bf4e3$export$10deb29d7dbf2418 = {
    prefix: "fab",
    iconName: "periscope",
    icon: [
        448,
        512,
        [],
        "f3da",
        "M370 63.6C331.4 22.6 280.5 0 226.6 0 111.9 0 18.5 96.2 18.5 214.4c0 75.1 57.8 159.8 82.7 192.7C137.8 455.5 192.6 512 226.6 512c41.6 0 112.9-94.2 120.9-105 24.6-33.1 82-118.3 82-192.6 0-56.5-21.1-110.1-59.5-150.8zM226.6 493.9c-42.5 0-190-167.3-190-279.4 0-107.4 83.9-196.3 190-196.3 100.8 0 184.7 89 184.7 196.3.1 112.1-147.4 279.4-184.7 279.4zM338 206.8c0 59.1-51.1 109.7-110.8 109.7-100.6 0-150.7-108.2-92.9-181.8v.4c0 24.5 20.1 44.4 44.8 44.4 24.7 0 44.8-19.9 44.8-44.4 0-18.2-11.1-33.8-26.9-40.7 76.6-19.2 141 39.3 141 112.4z"
    ]
};
var $ef0249c5e48bf4e3$export$beb89eeaf726c65a = {
    prefix: "fab",
    iconName: "fulcrum",
    icon: [
        320,
        512,
        [],
        "f50b",
        "M95.75 164.14l-35.38 43.55L25 164.14l35.38-43.55zM144.23 0l-20.54 198.18L72.72 256l51 57.82L144.23 512V300.89L103.15 256l41.08-44.89zm79.67 164.14l35.38 43.55 35.38-43.55-35.38-43.55zm-48.48 47L216.5 256l-41.08 44.89V512L196 313.82 247 256l-51-57.82L175.42 0z"
    ]
};
var $ef0249c5e48bf4e3$export$fdf6053d73314ca6 = {
    prefix: "fab",
    iconName: "cloudscale",
    icon: [
        448,
        512,
        [],
        "f383",
        "M318.1 154l-9.4 7.6c-22.5-19.3-51.5-33.6-83.3-33.6C153.8 128 96 188.8 96 260.3c0 6.6.4 13.1 1.4 19.4-2-56 41.8-97.4 92.6-97.4 24.2 0 46.2 9.4 62.6 24.7l-25.2 20.4c-8.3-.9-16.8 1.8-23.1 8.1-11.1 11-11.1 28.9 0 40 11.1 11 28.9 11 40 0 6.3-6.3 9-14.9 8.1-23.1l75.2-88.8c6.3-6.5-3.3-15.9-9.5-9.6zm-83.8 111.5c-5.6 5.5-14.6 5.5-20.2 0-5.6-5.6-5.6-14.6 0-20.2s14.6-5.6 20.2 0 5.6 14.7 0 20.2zM224 32C100.5 32 0 132.5 0 256s100.5 224 224 224 224-100.5 224-224S347.5 32 224 32zm0 384c-88.2 0-160-71.8-160-160S135.8 96 224 96s160 71.8 160 160-71.8 160-160 160z"
    ]
};
var $ef0249c5e48bf4e3$export$e4fb88a0423b6fee = {
    prefix: "fab",
    iconName: "forumbee",
    icon: [
        448,
        512,
        [],
        "f211",
        "M5.8 309.7C2 292.7 0 275.5 0 258.3 0 135 99.8 35 223.1 35c16.6 0 33.3 2 49.3 5.5C149 87.5 51.9 186 5.8 309.7zm392.9-189.2C385 103 369 87.8 350.9 75.2c-149.6 44.3-266.3 162.1-309.7 312 12.5 18.1 28 35.6 45.2 49 43.1-151.3 161.2-271.7 312.3-315.7zm15.8 252.7c15.2-25.1 25.4-53.7 29.5-82.8-79.4 42.9-145 110.6-187.6 190.3 30-4.4 58.9-15.3 84.6-31.3 35 13.1 70.9 24.3 107 33.6-9.3-36.5-20.4-74.5-33.5-109.8zm29.7-145.5c-2.6-19.5-7.9-38.7-15.8-56.8C290.5 216.7 182 327.5 137.1 466c18.1 7.6 37 12.5 56.6 15.2C240 367.1 330.5 274.4 444.2 227.7z"
    ]
};
var $ef0249c5e48bf4e3$export$e6a3c752190fa3cb = {
    prefix: "fab",
    iconName: "mizuni",
    icon: [
        496,
        512,
        [],
        "f3cc",
        "M248 8C111 8 0 119.1 0 256c0 137 111 248 248 248s248-111 248-248C496 119.1 385 8 248 8zm-80 351.9c-31.4 10.6-58.8 27.3-80 48.2V136c0-22.1 17.9-40 40-40s40 17.9 40 40v223.9zm120-9.9c-12.9-2-26.2-3.1-39.8-3.1-13.8 0-27.2 1.1-40.2 3.1V136c0-22.1 17.9-40 40-40s40 17.9 40 40v214zm120 57.7c-21.2-20.8-48.6-37.4-80-48V136c0-22.1 17.9-40 40-40s40 17.9 40 40v271.7z"
    ]
};
var $ef0249c5e48bf4e3$export$3f1891b85805675f = {
    prefix: "fab",
    iconName: "schlix",
    icon: [
        448,
        512,
        [],
        "f3ea",
        "M350.5 157.7l-54.2-46.1 73.4-39 78.3 44.2-97.5 40.9zM192 122.1l45.7-28.2 34.7 34.6-55.4 29-25-35.4zm-65.1 6.6l31.9-22.1L176 135l-36.7 22.5-12.4-28.8zm-23.3 88.2l-8.8-34.8 29.6-18.3 13.1 35.3-33.9 17.8zm-21.2-83.7l23.9-18.1 8.9 24-26.7 18.3-6.1-24.2zM59 206.5l-3.6-28.4 22.3-15.5 6.1 28.7L59 206.5zm-30.6 16.6l20.8-12.8 3.3 33.4-22.9 12-1.2-32.6zM1.4 268l19.2-10.2.4 38.2-21 8.8L1.4 268zm59.1 59.3l-28.3 8.3-1.6-46.8 25.1-10.7 4.8 49.2zM99 263.2l-31.1 13-5.2-40.8L90.1 221l8.9 42.2zM123.2 377l-41.6 5.9-8.1-63.5 35.2-10.8 14.5 68.4zm28.5-139.9l21.2 57.1-46.2 13.6-13.7-54.1 38.7-16.6zm85.7 230.5l-70.9-3.3-24.3-95.8 55.2-8.6 40 107.7zm-84.9-279.7l42.2-22.4 28 45.9-50.8 21.3-19.4-44.8zm41 94.9l61.3-18.7 52.8 86.6-79.8 11.3-34.3-79.2zm51.4-85.6l67.3-28.8 65.5 65.4-88.6 26.2-44.2-62.8z"
    ]
};
var $ef0249c5e48bf4e3$export$ca49464b0602c8ef = {
    prefix: "fab",
    iconName: "square-xing",
    icon: [
        448,
        512,
        [
            "xing-square"
        ],
        "f169",
        "M448 96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96zM93.8 320.2c-5.5 0-8.7-5.3-6-10.3l49.3-86.7c.1 0 .1-.1 0-.2l-31.4-54c-3-5.6 .2-10.1 6-10.1h46.6c5.2 0 9.5 2.9 12.9 8.7l31.9 55.3c-1.3 2.3-18 31.7-50.1 88.2c-3.5 6.2-7.7 9.1-12.6 9.1H93.8zm163.5-33.4v.2l65.5 119c2.8 5.1 .1 10.1-6 10.1H270.2c-5.5 0-9.7-2.9-12.9-8.7l-66-120.3c1.8-3.2 22.9-40.4 63.3-111.6c11.7-20.7 25.1-44.3 40.1-70.8c3.3-5.8 7.4-8.7 12.5-8.7h46.9c5.7-.1 8.8 4.7 6 10L257.3 286.8z"
    ]
};
var $ef0249c5e48bf4e3$export$3f616d72d818a1a6 = $ef0249c5e48bf4e3$export$ca49464b0602c8ef;
var $ef0249c5e48bf4e3$export$cf8fa465ef81d073 = {
    prefix: "fab",
    iconName: "bandcamp",
    icon: [
        512,
        512,
        [],
        "f2d5",
        "M256,8C119,8,8,119,8,256S119,504,256,504,504,393,504,256,393,8,256,8Zm48.2,326.1h-181L207.9,178h181Z"
    ]
};
var $ef0249c5e48bf4e3$export$f70eba4216b4419a = {
    prefix: "fab",
    iconName: "wpforms",
    icon: [
        448,
        512,
        [],
        "f298",
        "M448 75.2v361.7c0 24.3-19 43.2-43.2 43.2H43.2C19.3 480 0 461.4 0 436.8V75.2C0 51.1 18.8 32 43.2 32h361.7c24 0 43.1 18.8 43.1 43.2zm-37.3 361.6V75.2c0-3-2.6-5.8-5.8-5.8h-9.3L285.3 144 224 94.1 162.8 144 52.5 69.3h-9.3c-3.2 0-5.8 2.8-5.8 5.8v361.7c0 3 2.6 5.8 5.8 5.8h361.7c3.2.1 5.8-2.7 5.8-5.8zM150.2 186v37H76.7v-37h73.5zm0 74.4v37.3H76.7v-37.3h73.5zm11.1-147.3l54-43.7H96.8l64.5 43.7zm210 72.9v37h-196v-37h196zm0 74.4v37.3h-196v-37.3h196zm-84.6-147.3l64.5-43.7H232.8l53.9 43.7zM371.3 335v37.3h-99.4V335h99.4z"
    ]
};
var $ef0249c5e48bf4e3$export$623057fac7dabd52 = {
    prefix: "fab",
    iconName: "cloudversify",
    icon: [
        616,
        512,
        [],
        "f385",
        "M148.6 304c8.2 68.5 67.4 115.5 146 111.3 51.2 43.3 136.8 45.8 186.4-5.6 69.2 1.1 118.5-44.6 131.5-99.5 14.8-62.5-18.2-132.5-92.1-155.1-33-88.1-131.4-101.5-186.5-85-57.3 17.3-84.3 53.2-99.3 109.7-7.8 2.7-26.5 8.9-45 24.1 11.7 0 15.2 8.9 15.2 19.5v20.4c0 10.7-8.7 19.5-19.5 19.5h-20.2c-10.7 0-19.5-6-19.5-16.7V240H98.8C95 240 88 244.3 88 251.9v40.4c0 6.4 5.3 11.8 11.7 11.8h48.9zm227.4 8c-10.7 46.3 21.7 72.4 55.3 86.8C324.1 432.6 259.7 348 296 288c-33.2 21.6-33.7 71.2-29.2 92.9-17.9-12.4-53.8-32.4-57.4-79.8-3-39.9 21.5-75.7 57-93.9C297 191.4 369.9 198.7 400 248c-14.1-48-53.8-70.1-101.8-74.8 30.9-30.7 64.4-50.3 114.2-43.7 69.8 9.3 133.2 82.8 67.7 150.5 35-16.3 48.7-54.4 47.5-76.9l10.5 19.6c11.8 22 15.2 47.6 9.4 72-9.2 39-40.6 68.8-79.7 76.5-32.1 6.3-83.1-5.1-91.8-59.2zM128 208H88.2c-8.9 0-16.2-7.3-16.2-16.2v-39.6c0-8.9 7.3-16.2 16.2-16.2H128c8.9 0 16.2 7.3 16.2 16.2v39.6c0 8.9-7.3 16.2-16.2 16.2zM10.1 168C4.5 168 0 163.5 0 157.9v-27.8c0-5.6 4.5-10.1 10.1-10.1h27.7c5.5 0 10.1 4.5 10.1 10.1v27.8c0 5.6-4.5 10.1-10.1 10.1H10.1zM168 142.7v-21.4c0-5.1 4.2-9.3 9.3-9.3h21.4c5.1 0 9.3 4.2 9.3 9.3v21.4c0 5.1-4.2 9.3-9.3 9.3h-21.4c-5.1 0-9.3-4.2-9.3-9.3zM56 235.5v25c0 6.3-5.1 11.5-11.4 11.5H19.4C13.1 272 8 266.8 8 260.5v-25c0-6.3 5.1-11.5 11.4-11.5h25.1c6.4 0 11.5 5.2 11.5 11.5z"
    ]
};
var $ef0249c5e48bf4e3$export$216644b0c66e66a5 = {
    prefix: "fab",
    iconName: "usps",
    icon: [
        576,
        512,
        [],
        "f7e1",
        "M460.3 241.7c25.8-41.3 15.2-48.8-11.7-48.8h-27c-.1 0-1.5-1.4-10.9 8-11.2 5.6-37.9 6.3-37.9 8.7 0 4.5 70.3-3.1 88.1 0 9.5 1.5-1.5 20.4-4.4 32-.5 4.5 2.4 2.3 3.8.1zm-112.1 22.6c64-21.3 97.3-23.9 102-26.2 4.4-2.9-4.4-6.6-26.2-5.8-51.7 2.2-137.6 37.1-172.6 53.9l-30.7-93.3h196.6c-2.7-28.2-152.9-22.6-337.9-22.6L27 415.8c196.4-97.3 258.9-130.3 321.2-151.5zM94.7 96c253.3 53.7 330 65.7 332.1 85.2 36.4 0 45.9 0 52.4 6.6 21.1 19.7-14.6 67.7-14.6 67.7-4.4 2.9-406.4 160.2-406.4 160.2h423.1L549 96z"
    ]
};
var $ef0249c5e48bf4e3$export$e7e4dbda4df6110f = {
    prefix: "fab",
    iconName: "megaport",
    icon: [
        496,
        512,
        [],
        "f5a3",
        "M214.5 209.6v66.2l33.5 33.5 33.3-33.3v-66.4l-33.4-33.4zM248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm145.1 414.4L367 441.6l-26-19.2v-65.5l-33.4-33.4-33.4 33.4v65.5L248 441.6l-26.1-19.2v-65.5l-33.4-33.4-33.5 33.4v65.5l-26.1 19.2-26.1-19.2v-87l59.5-59.5V188l59.5-59.5V52.9l26.1-19.2L274 52.9v75.6l59.5 59.5v87.6l59.7 59.7v87.1z"
    ]
};
var $ef0249c5e48bf4e3$export$9b8374b50472190d = {
    prefix: "fab",
    iconName: "magento",
    icon: [
        448,
        512,
        [],
        "f3c4",
        "M445.7 127.9V384l-63.4 36.5V164.7L223.8 73.1 65.2 164.7l.4 255.9L2.3 384V128.1L224.2 0l221.5 127.9zM255.6 420.5L224 438.9l-31.8-18.2v-256l-63.3 36.6.1 255.9 94.9 54.9 95.1-54.9v-256l-63.4-36.6v255.9z"
    ]
};
var $ef0249c5e48bf4e3$export$8218f3fbb2f89724 = {
    prefix: "fab",
    iconName: "spotify",
    icon: [
        496,
        512,
        [],
        "f1bc",
        "M248 8C111.1 8 0 119.1 0 256s111.1 248 248 248 248-111.1 248-248S384.9 8 248 8zm100.7 364.9c-4.2 0-6.8-1.3-10.7-3.6-62.4-37.6-135-39.2-206.7-24.5-3.9 1-9 2.6-11.9 2.6-9.7 0-15.8-7.7-15.8-15.8 0-10.3 6.1-15.2 13.6-16.8 81.9-18.1 165.6-16.5 237 26.2 6.1 3.9 9.7 7.4 9.7 16.5s-7.1 15.4-15.2 15.4zm26.9-65.6c-5.2 0-8.7-2.3-12.3-4.2-62.5-37-155.7-51.9-238.6-29.4-4.8 1.3-7.4 2.6-11.9 2.6-10.7 0-19.4-8.7-19.4-19.4s5.2-17.8 15.5-20.7c27.8-7.8 56.2-13.6 97.8-13.6 64.9 0 127.6 16.1 177 45.5 8.1 4.8 11.3 11 11.3 19.7-.1 10.8-8.5 19.5-19.4 19.5zm31-76.2c-5.2 0-8.4-1.3-12.9-3.9-71.2-42.5-198.5-52.7-280.9-29.7-3.6 1-8.1 2.6-12.9 2.6-13.2 0-23.3-10.3-23.3-23.6 0-13.6 8.4-21.3 17.4-23.9 35.2-10.3 74.6-15.2 117.5-15.2 73 0 149.5 15.2 205.4 47.8 7.8 4.5 12.9 10.7 12.9 22.6 0 13.6-11 23.3-23.2 23.3z"
    ]
};
var $ef0249c5e48bf4e3$export$5247a00f0c0b93a3 = {
    prefix: "fab",
    iconName: "optin-monster",
    icon: [
        576,
        512,
        [],
        "f23c",
        "M572.6 421.4c5.6-9.5 4.7-15.2-5.4-11.6-3-4.9-7-9.5-11.1-13.8 2.9-9.7-.7-14.2-10.8-9.2-4.6-3.2-10.3-6.5-15.9-9.2 0-15.1-11.6-11.6-17.6-5.7-10.4-1.5-18.7-.3-26.8 5.7.3-6.5.3-13 .3-19.7 12.6 0 40.2-11 45.9-36.2 1.4-6.8 1.6-13.8-.3-21.9-3-13.5-14.3-21.3-25.1-25.7-.8-5.9-7.6-14.3-14.9-15.9s-12.4 4.9-14.1 10.3c-8.5 0-19.2 2.8-21.1 8.4-5.4-.5-11.1-1.4-16.8-1.9 2.7-1.9 5.4-3.5 8.4-4.6 5.4-9.2 14.6-11.4 25.7-11.6V256c19.5-.5 43-5.9 53.8-18.1 12.7-13.8 14.6-37.3 12.4-55.1-2.4-17.3-9.7-37.6-24.6-48.1-8.4-5.9-21.6-.8-22.7 9.5-2.2 19.6 1.2 30-38.6 25.1-10.3-23.8-24.6-44.6-42.7-60C341 49.6 242.9 55.5 166.4 71.7c19.7 4.6 41.1 8.6 59.7 16.5-26.2 2.4-52.7 11.3-76.2 23.2-32.8 17-44 29.9-56.7 42.4 14.9-2.2 28.9-5.1 43.8-3.8-9.7 5.4-18.4 12.2-26.5 20-25.8.9-23.8-5.3-26.2-25.9-1.1-10.5-14.3-15.4-22.7-9.7-28.1 19.9-33.5 79.9-12.2 103.5 10.8 12.2 35.1 17.3 54.9 17.8-.3 1.1-.3 1.9-.3 2.7 10.8.5 19.5 2.7 24.6 11.6 3 1.1 5.7 2.7 8.1 4.6-5.4.5-11.1 1.4-16.5 1.9-3.3-6.6-13.7-8.1-21.1-8.1-1.6-5.7-6.5-12.2-14.1-10.3-6.8 1.9-14.1 10-14.9 15.9-22.5 9.5-30.1 26.8-25.1 47.6 5.3 24.8 33 36.2 45.9 36.2v19.7c-6.6-5-14.3-7.5-26.8-5.7-5.5-5.5-17.3-10.1-17.3 5.7-5.9 2.7-11.4 5.9-15.9 9.2-9.8-4.9-13.6-1.7-11.1 9.2-4.1 4.3-7.8 8.6-11.1 13.8-10.2-3.7-11 2.2-5.4 11.6-1.1 3.5-1.6 7-1.9 10.8-.5 31.6 44.6 64 73.5 65.1 17.3.5 34.6-8.4 43-23.5 113.2 4.9 226.7 4.1 340.2 0 8.1 15.1 25.4 24.3 42.7 23.5 29.2-1.1 74.3-33.5 73.5-65.1.2-3.7-.7-7.2-1.7-10.7zm-73.8-254c1.1-3 2.4-8.4 2.4-14.6 0-5.9 6.8-8.1 14.1-.8 11.1 11.6 14.9 40.5 13.8 51.1-4.1-13.6-13-29-30.3-35.7zm-4.6 6.7c19.5 6.2 28.6 27.6 29.7 48.9-1.1 2.7-3 5.4-4.9 7.6-5.7 5.9-15.4 10-26.2 12.2 4.3-21.3.3-47.3-12.7-63 4.9-.8 10.9-2.4 14.1-5.7zm-24.1 6.8c13.8 11.9 20 39.2 14.1 63.5-4.1.5-8.1.8-11.6.8-1.9-21.9-6.8-44-14.3-64.6 3.7.3 8.1.3 11.8.3zM47.5 203c-1.1-10.5 2.4-39.5 13.8-51.1 7-7.3 14.1-5.1 14.1.8 0 6.2 1.4 11.6 2.4 14.6-17.3 6.8-26.2 22.2-30.3 35.7zm9.7 27.6c-1.9-2.2-3.5-4.9-4.9-7.6 1.4-21.3 10.3-42.7 29.7-48.9 3.2 3.2 9.2 4.9 14.1 5.7-13 15.7-17 41.6-12.7 63-10.8-2.2-20.5-6-26.2-12.2zm47.9 14.6c-4.1 0-8.1-.3-12.7-.8-4.6-18.6-1.9-38.9 5.4-53v.3l12.2-5.1c4.9-1.9 9.7-3.8 14.9-4.9-10.7 19.7-17.4 41.3-19.8 63.5zm184-162.7c41.9 0 76.2 34 76.2 75.9 0 42.2-34.3 76.2-76.2 76.2s-76.2-34-76.2-76.2c0-41.8 34.3-75.9 76.2-75.9zm115.6 174.3c-.3 17.8-7 48.9-23 57-13.2 6.6-6.5-7.5-16.5-58.1 13.3.3 26.6.3 39.5 1.1zm-54-1.6c.8 4.9 3.8 40.3-1.6 41.9-11.6 3.5-40 4.3-51.1-1.1-4.1-3-4.6-35.9-4.3-41.1v.3c18.9-.3 38.1-.3 57 0zM278.3 309c-13 3.5-41.6 4.1-54.6-1.6-6.5-2.7-3.8-42.4-1.9-51.6 19.2-.5 38.4-.5 57.8-.8v.3c1.1 8.3 3.3 51.2-1.3 53.7zm-106.5-51.1c12.2-.8 24.6-1.4 36.8-1.6-2.4 15.4-3 43.5-4.9 52.2-1.1 6.8-4.3 6.8-9.7 4.3-21.9-9.8-27.6-35.2-22.2-54.9zm-35.4 31.3c7.8-1.1 15.7-1.9 23.5-2.7 1.6 6.2 3.8 11.9 7 17.6 10 17 44 35.7 45.1 7 6.2 14.9 40.8 12.2 54.9 10.8 15.7-1.4 23.8-1.4 26.8-14.3 12.4 4.3 30.8 4.1 44 3 11.3-.8 20.8-.5 24.6-8.9 1.1 5.1 1.9 11.6 4.6 16.8 10.8 21.3 37.3 1.4 46.8-31.6 8.6.8 17.6 1.9 26.5 2.7-.4 1.3-3.8 7.3 7.3 11.6-47.6 47-95.7 87.8-163.2 107-63.2-20.8-112.1-59.5-155.9-106.5 9.6-3.4 10.4-8.8 8-12.5zm-21.6 172.5c-3.8 17.8-21.9 29.7-39.7 28.9-19.2-.8-46.5-17-59.2-36.5-2.7-31.1 43.8-61.3 66.2-54.6 14.9 4.3 27.8 30.8 33.5 54 0 3-.3 5.7-.8 8.2zm-8.7-66c-.5-13.5-.5-27-.3-40.5h.3c2.7-1.6 5.7-3.8 7.8-6.5 6.5-1.6 13-5.1 15.1-9.2 3.3-7.1-7-7.5-5.4-12.4 2.7-1.1 5.7-2.2 7.8-3.5 29.2 29.2 58.6 56.5 97.3 77-36.8 11.3-72.4 27.6-105.9 47-1.2-18.6-7.7-35.9-16.7-51.9zm337.6 64.6c-103 3.5-206.2 4.1-309.4 0 0 .3 0 .3-.3.3v-.3h.3c35.1-21.6 72.2-39.2 112.4-50.8 11.6 5.1 23 9.5 34.9 13.2 2.2.8 2.2.8 4.3 0 14.3-4.1 28.4-9.2 42.2-15.4 41.5 11.7 78.8 31.7 115.6 53zm10.5-12.4c-35.9-19.5-73-35.9-111.9-47.6 38.1-20 71.9-47.3 103.5-76.7 2.2 1.4 4.6 2.4 7.6 3.2 0 .8.3 1.9.5 2.4-4.6 2.7-7.8 6.2-5.9 10.3 2.2 3.8 8.6 7.6 15.1 8.9 2.4 2.7 5.1 5.1 8.1 6.8 0 13.8-.3 27.6-.8 41.3l.3-.3c-9.3 15.9-15.5 37-16.5 51.7zm105.9 6.2c-12.7 19.5-40 35.7-59.2 36.5-19.3.9-40.5-13.2-40.5-37 5.7-23.2 18.9-49.7 33.5-54 22.7-6.9 69.2 23.4 66.2 54.5zM372.9 75.2c-3.8-72.1-100.8-79.7-126-23.5 44.6-24.3 90.3-15.7 126 23.5zM74.8 407.1c-15.7 1.6-49.5 25.4-49.5 43.2 0 11.6 15.7 19.5 32.2 14.9 12.2-3.2 31.1-17.6 35.9-27.3 6-11.6-3.7-32.7-18.6-30.8zm215.9-176.2c28.6 0 51.9-21.6 51.9-48.4 0-36.1-40.5-58.1-72.2-44.3 9.5 3 16.5 11.6 16.5 21.6 0 23.3-33.3 32-46.5 11.3-7.3 34.1 19.4 59.8 50.3 59.8zM68 474.1c.5 6.5 12.2 12.7 21.6 9.5 6.8-2.7 14.6-10.5 17.3-16.2 3-7-1.1-20-9.7-18.4-8.9 1.6-29.7 16.7-29.2 25.1zm433.2-67c-14.9-1.9-24.6 19.2-18.9 30.8 4.9 9.7 24.1 24.1 36.2 27.3 16.5 4.6 32.2-3.2 32.2-14.9 0-17.8-33.8-41.6-49.5-43.2zM478.8 449c-8.4-1.6-12.4 11.3-9.5 18.4 2.4 5.7 10.3 13.5 17.3 16.2 9.2 3.2 21.1-3 21.3-9.5.9-8.4-20.2-23.5-29.1-25.1z"
    ]
};
var $ef0249c5e48bf4e3$export$cfbbba1261e4e2d2 = {
    prefix: "fab",
    iconName: "fly",
    icon: [
        384,
        512,
        [],
        "f417",
        "M197.8 427.8c12.9 11.7 33.7 33.3 33.2 50.7 0 .8-.1 1.6-.1 2.5-1.8 19.8-18.8 31.1-39.1 31-25-.1-39.9-16.8-38.7-35.8 1-16.2 20.5-36.7 32.4-47.6 2.3-2.1 2.7-2.7 5.6-3.6 3.4 0 3.9.3 6.7 2.8zM331.9 67.3c-16.3-25.7-38.6-40.6-63.3-52.1C243.1 4.5 214-.2 192 0c-44.1 0-71.2 13.2-81.1 17.3C57.3 45.2 26.5 87.2 28 158.6c7.1 82.2 97 176 155.8 233.8 1.7 1.6 4.5 4.5 6.2 5.1l3.3.1c2.1-.7 1.8-.5 3.5-2.1 52.3-49.2 140.7-145.8 155.9-215.7 7-39.2 3.1-72.5-20.8-112.5zM186.8 351.9c-28-51.1-65.2-130.7-69.3-189-3.4-47.5 11.4-131.2 69.3-136.7v325.7zM328.7 180c-16.4 56.8-77.3 128-118.9 170.3C237.6 298.4 275 217 277 158.4c1.6-45.9-9.8-105.8-48-131.4 88.8 18.3 115.5 98.1 99.7 153z"
    ]
};
var $ef0249c5e48bf4e3$export$f731696770842fd2 = {
    prefix: "fab",
    iconName: "aviato",
    icon: [
        640,
        512,
        [],
        "f421",
        "M107.2 283.5l-19-41.8H36.1l-19 41.8H0l62.2-131.4 62.2 131.4h-17.2zm-45-98.1l-19.6 42.5h39.2l-19.6-42.5zm112.7 102.4l-62.2-131.4h17.1l45.1 96 45.1-96h17l-62.1 131.4zm80.6-4.3V156.4H271v127.1h-15.5zm209.1-115.6v115.6h-17.3V167.9h-41.2v-11.5h99.6v11.5h-41.1zM640 218.8c0 9.2-1.7 17.8-5.1 25.8-3.4 8-8.2 15.1-14.2 21.1-6 6-13.1 10.8-21.1 14.2-8 3.4-16.6 5.1-25.8 5.1s-17.8-1.7-25.8-5.1c-8-3.4-15.1-8.2-21.1-14.2-6-6-10.8-13-14.2-21.1-3.4-8-5.1-16.6-5.1-25.8s1.7-17.8 5.1-25.8c3.4-8 8.2-15.1 14.2-21.1 6-6 13-8.4 21.1-11.9 8-3.4 16.6-5.1 25.8-5.1s17.8 1.7 25.8 5.1c8 3.4 15.1 5.8 21.1 11.9 6 6 10.7 13.1 14.2 21.1 3.4 8 5.1 16.6 5.1 25.8zm-15.5 0c0-7.3-1.3-14-3.9-20.3-2.6-6.3-6.2-11.7-10.8-16.3-4.6-4.6-10-8.2-16.2-10.9-6.2-2.7-12.8-4-19.8-4s-13.6 1.3-19.8 4c-6.2 2.7-11.6 6.3-16.2 10.9-4.6 4.6-8.2 10-10.8 16.3-2.6 6.3-3.9 13.1-3.9 20.3 0 7.3 1.3 14 3.9 20.3 2.6 6.3 6.2 11.7 10.8 16.3 4.6 4.6 10 8.2 16.2 10.9 6.2 2.7 12.8 4 19.8 4s13.6-1.3 19.8-4c6.2-2.7 11.6-6.3 16.2-10.9 4.6-4.6 8.2-10 10.8-16.3 2.6-6.3 3.9-13.1 3.9-20.3zm-94.8 96.7v-6.3l88.9-10-242.9 13.4c.6-2.2 1.1-4.6 1.4-7.2.3-2 .5-4.2.6-6.5l64.8-8.1-64.9 1.9c0-.4-.1-.7-.1-1.1-2.8-17.2-25.5-23.7-25.5-23.7l-1.1-26.3h23.8l19 41.8h17.1L348.6 152l-62.2 131.4h17.1l19-41.8h23.6L345 268s-22.7 6.5-25.5 23.7c-.1.3-.1.7-.1 1.1l-64.9-1.9 64.8 8.1c.1 2.3.3 4.4.6 6.5.3 2.6.8 5 1.4 7.2L78.4 299.2l88.9 10v6.3c-5.9.9-10.5 6-10.5 12.2 0 6.8 5.6 12.4 12.4 12.4 6.8 0 12.4-5.6 12.4-12.4 0-6.2-4.6-11.3-10.5-12.2v-5.8l80.3 9v5.4c-5.7 1.1-9.9 6.2-9.9 12.1 0 6.8 5.6 10.2 12.4 10.2 6.8 0 12.4-3.4 12.4-10.2 0-6-4.3-11-9.9-12.1v-4.9l28.4 3.2v23.7h-5.9V360h5.9v-6.6h5v6.6h5.9v-13.8h-5.9V323l38.3 4.3c8.1 11.4 19 13.6 19 13.6l-.1 6.7-5.1.2-.1 12.1h4.1l.1-5h5.2l.1 5h4.1l-.1-12.1-5.1-.2-.1-6.7s10.9-2.1 19-13.6l38.3-4.3v23.2h-5.9V360h5.9v-6.6h5v6.6h5.9v-13.8h-5.9v-23.7l28.4-3.2v4.9c-5.7 1.1-9.9 6.2-9.9 12.1 0 6.8 5.6 10.2 12.4 10.2 6.8 0 12.4-3.4 12.4-10.2 0-6-4.3-11-9.9-12.1v-5.4l80.3-9v5.8c-5.9.9-10.5 6-10.5 12.2 0 6.8 5.6 12.4 12.4 12.4 6.8 0 12.4-5.6 12.4-12.4-.2-6.3-4.7-11.4-10.7-12.3zm-200.8-87.6l19.6-42.5 19.6 42.5h-17.9l-1.7-40.3-1.7 40.3h-17.9z"
    ]
};
var $ef0249c5e48bf4e3$export$5f69a5b38e12c984 = {
    prefix: "fab",
    iconName: "itunes",
    icon: [
        448,
        512,
        [],
        "f3b4",
        "M223.6 80.3C129 80.3 52.5 157 52.5 251.5S129 422.8 223.6 422.8s171.2-76.7 171.2-171.2c0-94.6-76.7-171.3-171.2-171.3zm79.4 240c-3.2 13.6-13.5 21.2-27.3 23.8-12.1 2.2-22.2 2.8-31.9-5-11.8-10-12-26.4-1.4-36.8 8.4-8 20.3-9.6 38-12.8 3-.5 5.6-1.2 7.7-3.7 3.2-3.6 2.2-2 2.2-80.8 0-5.6-2.7-7.1-8.4-6.1-4 .7-91.9 17.1-91.9 17.1-5 1.1-6.7 2.6-6.7 8.3 0 116.1.5 110.8-1.2 118.5-2.1 9-7.6 15.8-14.9 19.6-8.3 4.6-23.4 6.6-31.4 5.2-21.4-4-28.9-28.7-14.4-42.9 8.4-8 20.3-9.6 38-12.8 3-.5 5.6-1.2 7.7-3.7 5-5.7.9-127 2.6-133.7.4-2.6 1.5-4.8 3.5-6.4 2.1-1.7 5.8-2.7 6.7-2.7 101-19 113.3-21.4 115.1-21.4 5.7-.4 9 3 9 8.7-.1 170.6.4 161.4-1 167.6zM345.2 32H102.8C45.9 32 0 77.9 0 134.8v242.4C0 434.1 45.9 480 102.8 480h242.4c57 0 102.8-45.9 102.8-102.8V134.8C448 77.9 402.1 32 345.2 32zM223.6 444c-106.3 0-192.5-86.2-192.5-192.5S117.3 59 223.6 59s192.5 86.2 192.5 192.5S329.9 444 223.6 444z"
    ]
};
var $ef0249c5e48bf4e3$export$883d4844d275b117 = {
    prefix: "fab",
    iconName: "cuttlefish",
    icon: [
        440,
        512,
        [],
        "f38c",
        "M344 305.5c-17.5 31.6-57.4 54.5-96 54.5-56.6 0-104-47.4-104-104s47.4-104 104-104c38.6 0 78.5 22.9 96 54.5 13.7-50.9 41.7-93.3 87-117.8C385.7 39.1 320.5 8 248 8 111 8 0 119 0 256s111 248 248 248c72.5 0 137.7-31.1 183-80.7-45.3-24.5-73.3-66.9-87-117.8z"
    ]
};
var $ef0249c5e48bf4e3$export$eba2747efc67a397 = {
    prefix: "fab",
    iconName: "blogger",
    icon: [
        448,
        512,
        [],
        "f37c",
        "M162.4 196c4.8-4.9 6.2-5.1 36.4-5.1 27.2 0 28.1.1 32.1 2.1 5.8 2.9 8.3 7 8.3 13.6 0 5.9-2.4 10-7.6 13.4-2.8 1.8-4.5 1.9-31.1 2.1-16.4.1-29.5-.2-31.5-.8-10.3-2.9-14.1-17.7-6.6-25.3zm61.4 94.5c-53.9 0-55.8.2-60.2 4.1-3.5 3.1-5.7 9.4-5.1 13.9.7 4.7 4.8 10.1 9.2 12 2.2 1 14.1 1.7 56.3 1.2l47.9-.6 9.2-1.5c9-5.1 10.5-17.4 3.1-24.4-5.3-4.7-5-4.7-60.4-4.7zm223.4 130.1c-3.5 28.4-23 50.4-51.1 57.5-7.2 1.8-9.7 1.9-172.9 1.8-157.8 0-165.9-.1-172-1.8-8.4-2.2-15.6-5.5-22.3-10-5.6-3.8-13.9-11.8-17-16.4-3.8-5.6-8.2-15.3-10-22C.1 423 0 420.3 0 256.3 0 93.2 0 89.7 1.8 82.6 8.1 57.9 27.7 39 53 33.4c7.3-1.6 332.1-1.9 340-.3 21.2 4.3 37.9 17.1 47.6 36.4 7.7 15.3 7-1.5 7.3 180.6.2 115.8 0 164.5-.7 170.5zm-85.4-185.2c-1.1-5-4.2-9.6-7.7-11.5-1.1-.6-8-1.3-15.5-1.7-12.4-.6-13.8-.8-17.8-3.1-6.2-3.6-7.9-7.6-8-18.3 0-20.4-8.5-39.4-25.3-56.5-12-12.2-25.3-20.5-40.6-25.1-3.6-1.1-11.8-1.5-39.2-1.8-42.9-.5-52.5.4-67.1 6.2-27 10.7-46.3 33.4-53.4 62.4-1.3 5.4-1.6 14.2-1.9 64.3-.4 62.8 0 72.1 4 84.5 9.7 30.7 37.1 53.4 64.6 58.4 9.2 1.7 122.2 2.1 133.7.5 20.1-2.7 35.9-10.8 50.7-25.9 10.7-10.9 17.4-22.8 21.8-38.5 3.2-10.9 2.9-88.4 1.7-93.9z"
    ]
};
var $ef0249c5e48bf4e3$export$4fc2e88e3ac2b091 = {
    prefix: "fab",
    iconName: "flickr",
    icon: [
        448,
        512,
        [],
        "f16e",
        "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM144.5 319c-35.1 0-63.5-28.4-63.5-63.5s28.4-63.5 63.5-63.5 63.5 28.4 63.5 63.5-28.4 63.5-63.5 63.5zm159 0c-35.1 0-63.5-28.4-63.5-63.5s28.4-63.5 63.5-63.5 63.5 28.4 63.5 63.5-28.4 63.5-63.5 63.5z"
    ]
};
var $ef0249c5e48bf4e3$export$c16cb0c14aa5beed = {
    prefix: "fab",
    iconName: "viber",
    icon: [
        512,
        512,
        [],
        "f409",
        "M444 49.9C431.3 38.2 379.9.9 265.3.4c0 0-135.1-8.1-200.9 52.3C27.8 89.3 14.9 143 13.5 209.5c-1.4 66.5-3.1 191.1 117 224.9h.1l-.1 51.6s-.8 20.9 13 25.1c16.6 5.2 26.4-10.7 42.3-27.8 8.7-9.4 20.7-23.2 29.8-33.7 82.2 6.9 145.3-8.9 152.5-11.2 16.6-5.4 110.5-17.4 125.7-142 15.8-128.6-7.6-209.8-49.8-246.5zM457.9 287c-12.9 104-89 110.6-103 115.1-6 1.9-61.5 15.7-131.2 11.2 0 0-52 62.7-68.2 79-5.3 5.3-11.1 4.8-11-5.7 0-6.9.4-85.7.4-85.7-.1 0-.1 0 0 0-101.8-28.2-95.8-134.3-94.7-189.8 1.1-55.5 11.6-101 42.6-131.6 55.7-50.5 170.4-43 170.4-43 96.9.4 143.3 29.6 154.1 39.4 35.7 30.6 53.9 103.8 40.6 211.1zm-139-80.8c.4 8.6-12.5 9.2-12.9.6-1.1-22-11.4-32.7-32.6-33.9-8.6-.5-7.8-13.4.7-12.9 27.9 1.5 43.4 17.5 44.8 46.2zm20.3 11.3c1-42.4-25.5-75.6-75.8-79.3-8.5-.6-7.6-13.5.9-12.9 58 4.2 88.9 44.1 87.8 92.5-.1 8.6-13.1 8.2-12.9-.3zm47 13.4c.1 8.6-12.9 8.7-12.9.1-.6-81.5-54.9-125.9-120.8-126.4-8.5-.1-8.5-12.9 0-12.9 73.7.5 133 51.4 133.7 139.2zM374.9 329v.2c-10.8 19-31 40-51.8 33.3l-.2-.3c-21.1-5.9-70.8-31.5-102.2-56.5-16.2-12.8-31-27.9-42.4-42.4-10.3-12.9-20.7-28.2-30.8-46.6-21.3-38.5-26-55.7-26-55.7-6.7-20.8 14.2-41 33.3-51.8h.2c9.2-4.8 18-3.2 23.9 3.9 0 0 12.4 14.8 17.7 22.1 5 6.8 11.7 17.7 15.2 23.8 6.1 10.9 2.3 22-3.7 26.6l-12 9.6c-6.1 4.9-5.3 14-5.3 14s17.8 67.3 84.3 84.3c0 0 9.1.8 14-5.3l9.6-12c4.6-6 15.7-9.8 26.6-3.7 14.7 8.3 33.4 21.2 45.8 32.9 7 5.7 8.6 14.4 3.8 23.6z"
    ]
};
var $ef0249c5e48bf4e3$export$5803ef8c86f9786d = {
    prefix: "fab",
    iconName: "soundcloud",
    icon: [
        640,
        512,
        [],
        "f1be",
        "M111.4 256.3l5.8 65-5.8 68.3c-.3 2.5-2.2 4.4-4.4 4.4s-4.2-1.9-4.2-4.4l-5.6-68.3 5.6-65c0-2.2 1.9-4.2 4.2-4.2 2.2 0 4.1 2 4.4 4.2zm21.4-45.6c-2.8 0-4.7 2.2-5 5l-5 105.6 5 68.3c.3 2.8 2.2 5 5 5 2.5 0 4.7-2.2 4.7-5l5.8-68.3-5.8-105.6c0-2.8-2.2-5-4.7-5zm25.5-24.1c-3.1 0-5.3 2.2-5.6 5.3l-4.4 130 4.4 67.8c.3 3.1 2.5 5.3 5.6 5.3 2.8 0 5.3-2.2 5.3-5.3l5.3-67.8-5.3-130c0-3.1-2.5-5.3-5.3-5.3zM7.2 283.2c-1.4 0-2.2 1.1-2.5 2.5L0 321.3l4.7 35c.3 1.4 1.1 2.5 2.5 2.5s2.2-1.1 2.5-2.5l5.6-35-5.6-35.6c-.3-1.4-1.1-2.5-2.5-2.5zm23.6-21.9c-1.4 0-2.5 1.1-2.5 2.5l-6.4 57.5 6.4 56.1c0 1.7 1.1 2.8 2.5 2.8s2.5-1.1 2.8-2.5l7.2-56.4-7.2-57.5c-.3-1.4-1.4-2.5-2.8-2.5zm25.3-11.4c-1.7 0-3.1 1.4-3.3 3.3L47 321.3l5.8 65.8c.3 1.7 1.7 3.1 3.3 3.1 1.7 0 3.1-1.4 3.1-3.1l6.9-65.8-6.9-68.1c0-1.9-1.4-3.3-3.1-3.3zm25.3-2.2c-1.9 0-3.6 1.4-3.6 3.6l-5.8 70 5.8 67.8c0 2.2 1.7 3.6 3.6 3.6s3.6-1.4 3.9-3.6l6.4-67.8-6.4-70c-.3-2.2-2-3.6-3.9-3.6zm241.4-110.9c-1.1-.8-2.8-1.4-4.2-1.4-2.2 0-4.2.8-5.6 1.9-1.9 1.7-3.1 4.2-3.3 6.7v.8l-3.3 176.7 1.7 32.5 1.7 31.7c.3 4.7 4.2 8.6 8.9 8.6s8.6-3.9 8.6-8.6l3.9-64.2-3.9-177.5c-.4-3-2-5.8-4.5-7.2zm-26.7 15.3c-1.4-.8-2.8-1.4-4.4-1.4s-3.1.6-4.4 1.4c-2.2 1.4-3.6 3.9-3.6 6.7l-.3 1.7-2.8 160.8s0 .3 3.1 65.6v.3c0 1.7.6 3.3 1.7 4.7 1.7 1.9 3.9 3.1 6.4 3.1 2.2 0 4.2-1.1 5.6-2.5 1.7-1.4 2.5-3.3 2.5-5.6l.3-6.7 3.1-58.6-3.3-162.8c-.3-2.8-1.7-5.3-3.9-6.7zm-111.4 22.5c-3.1 0-5.8 2.8-5.8 6.1l-4.4 140.6 4.4 67.2c.3 3.3 2.8 5.8 5.8 5.8 3.3 0 5.8-2.5 6.1-5.8l5-67.2-5-140.6c-.2-3.3-2.7-6.1-6.1-6.1zm376.7 62.8c-10.8 0-21.1 2.2-30.6 6.1-6.4-70.8-65.8-126.4-138.3-126.4-17.8 0-35 3.3-50.3 9.4-6.1 2.2-7.8 4.4-7.8 9.2v249.7c0 5 3.9 8.6 8.6 9.2h218.3c43.3 0 78.6-35 78.6-78.3.1-43.6-35.2-78.9-78.5-78.9zm-296.7-60.3c-4.2 0-7.5 3.3-7.8 7.8l-3.3 136.7 3.3 65.6c.3 4.2 3.6 7.5 7.8 7.5 4.2 0 7.5-3.3 7.5-7.5l3.9-65.6-3.9-136.7c-.3-4.5-3.3-7.8-7.5-7.8zm-53.6-7.8c-3.3 0-6.4 3.1-6.4 6.7l-3.9 145.3 3.9 66.9c.3 3.6 3.1 6.4 6.4 6.4 3.6 0 6.4-2.8 6.7-6.4l4.4-66.9-4.4-145.3c-.3-3.6-3.1-6.7-6.7-6.7zm26.7 3.4c-3.9 0-6.9 3.1-6.9 6.9L227 321.3l3.9 66.4c.3 3.9 3.1 6.9 6.9 6.9s6.9-3.1 6.9-6.9l4.2-66.4-4.2-141.7c0-3.9-3-6.9-6.9-6.9z"
    ]
};
var $ef0249c5e48bf4e3$export$1902312a1701467c = {
    prefix: "fab",
    iconName: "digg",
    icon: [
        512,
        512,
        [],
        "f1a6",
        "M81.7 172.3H0v174.4h132.7V96h-51v76.3zm0 133.4H50.9v-92.3h30.8v92.3zm297.2-133.4v174.4h81.8v28.5h-81.8V416H512V172.3H378.9zm81.8 133.4h-30.8v-92.3h30.8v92.3zm-235.6 41h82.1v28.5h-82.1V416h133.3V172.3H225.1v174.4zm51.2-133.3h30.8v92.3h-30.8v-92.3zM153.3 96h51.3v51h-51.3V96zm0 76.3h51.3v174.4h-51.3V172.3z"
    ]
};
var $ef0249c5e48bf4e3$export$9ea61fa1ff3225c6 = {
    prefix: "fab",
    iconName: "tencent-weibo",
    icon: [
        384,
        512,
        [],
        "f1d5",
        "M72.3 495.8c1.4 19.9-27.6 22.2-29.7 2.9C31 368.8 73.7 259.2 144 185.5c-15.6-34 9.2-77.1 50.6-77.1 30.3 0 55.1 24.6 55.1 55.1 0 44-49.5 70.8-86.9 45.1-65.7 71.3-101.4 169.8-90.5 287.2zM192 .1C66.1.1-12.3 134.3 43.7 242.4 52.4 259.8 79 246.9 70 229 23.7 136.4 91 29.8 192 29.8c75.4 0 136.9 61.4 136.9 136.9 0 90.8-86.9 153.9-167.7 133.1-19.1-4.1-25.6 24.4-6.6 29.1 110.7 23.2 204-60 204-162.3C358.6 74.7 284 .1 192 .1z"
    ]
};
var $ef0249c5e48bf4e3$export$3d0320148c8ebcd6 = {
    prefix: "fab",
    iconName: "letterboxd",
    icon: [
        640,
        512,
        [],
        "e62d",
        "M521.3 128C586.9 128 640 181.1 640 246.6s-53.1 118.6-118.7 118.6c-42.5 0-79.7-22.3-100.7-55.8c11.4-18.2 18-39.7 18-62.8s-6.6-44.6-18-62.8l0 0 .8-1.2c20.8-32.3 56.8-53.9 97.9-54.6l2 0zM320 128c42.5 0 79.7 22.3 100.7 55.8c-11.4 18.2-18 39.7-18 62.8s6.6 44.6 18 62.8l0 0-.8 1.2c-20.8 32.3-56.8 53.9-97.9 54.6l-2 0c-42.5 0-79.7-22.3-100.7-55.8c11.4-18.2 18-39.7 18-62.8s-6.6-44.6-18-62.8l0 0 .8-1.2c20.8-32.3 56.8-53.9 97.9-54.6l2 0zm-201.3 0c42.5 0 79.7 22.3 100.7 55.8c-11.4 18.2-18 39.7-18 62.8s6.6 44.6 18 62.8l0 0-.8 1.2c-20.8 32.3-56.8 53.9-97.9 54.6l-2 0C53.1 365.1 0 312.1 0 246.6S53.1 128 118.7 128z"
    ]
};
var $ef0249c5e48bf4e3$export$5420457350c35845 = {
    prefix: "fab",
    iconName: "symfony",
    icon: [
        512,
        512,
        [],
        "f83d",
        "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm133.74 143.54c-11.47.41-19.4-6.45-19.77-16.87-.27-9.18 6.68-13.44 6.53-18.85-.23-6.55-10.16-6.82-12.87-6.67-39.78 1.29-48.59 57-58.89 113.85 21.43 3.15 36.65-.72 45.14-6.22 12-7.75-3.34-15.72-1.42-24.56 4-18.16 32.55-19 32 5.3-.36 17.86-25.92 41.81-77.6 35.7-10.76 59.52-18.35 115-58.2 161.72-29 34.46-58.4 39.82-71.58 40.26-24.65.85-41-12.31-41.58-29.84-.56-17 14.45-26.26 24.31-26.59 21.89-.75 30.12 25.67 14.88 34-12.09 9.71.11 12.61 2.05 12.55 10.42-.36 17.34-5.51 22.18-9 24-20 33.24-54.86 45.35-118.35 8.19-49.66 17-78 18.23-82-16.93-12.75-27.08-28.55-49.85-34.72-15.61-4.23-25.12-.63-31.81 7.83-7.92 10-5.29 23 2.37 30.7l12.63 14c15.51 17.93 24 31.87 20.8 50.62-5.06 29.93-40.72 52.9-82.88 39.94-36-11.11-42.7-36.56-38.38-50.62 7.51-24.15 42.36-11.72 34.62 13.6-2.79 8.6-4.92 8.68-6.28 13.07-4.56 14.77 41.85 28.4 51-1.39 4.47-14.52-5.3-21.71-22.25-39.85-28.47-31.75-16-65.49 2.95-79.67C204.23 140.13 251.94 197 262 205.29c37.17-109 100.53-105.46 102.43-105.53 25.16-.81 44.19 10.59 44.83 28.65.25 7.69-4.17 22.59-19.52 23.13z"
    ]
};
var $ef0249c5e48bf4e3$export$a33f03bc723e6603 = {
    prefix: "fab",
    iconName: "maxcdn",
    icon: [
        512,
        512,
        [],
        "f136",
        "M461.1 442.7h-97.4L415.6 200c2.3-10.2.9-19.5-4.4-25.7-5-6.1-13.7-9.6-24.2-9.6h-49.3l-59.5 278h-97.4l59.5-278h-83.4l-59.5 278H0l59.5-278-44.6-95.4H387c39.4 0 75.3 16.3 98.3 44.9 23.3 28.6 31.8 67.4 23.6 105.9l-47.8 222.6z"
    ]
};
var $ef0249c5e48bf4e3$export$c7956780474e39de = {
    prefix: "fab",
    iconName: "etsy",
    icon: [
        384,
        512,
        [],
        "f2d7",
        "M384 348c-1.75 10.75-13.75 110-15.5 132-117.879-4.299-219.895-4.743-368.5 0v-25.5c45.457-8.948 60.627-8.019 61-35.25 1.793-72.322 3.524-244.143 0-322-1.029-28.46-12.13-26.765-61-36v-25.5c73.886 2.358 255.933 8.551 362.999-3.75-3.5 38.25-7.75 126.5-7.75 126.5H332C320.947 115.665 313.241 68 277.25 68h-137c-10.25 0-10.75 3.5-10.75 9.75V241.5c58 .5 88.5-2.5 88.5-2.5 29.77-.951 27.56-8.502 40.75-65.251h25.75c-4.407 101.351-3.91 61.829-1.75 160.25H257c-9.155-40.086-9.065-61.045-39.501-61.5 0 0-21.5-2-88-2v139c0 26 14.25 38.25 44.25 38.25H263c63.636 0 66.564-24.996 98.751-99.75H384z"
    ]
};
var $ef0249c5e48bf4e3$export$6c28dada3398f534 = {
    prefix: "fab",
    iconName: "facebook-messenger",
    icon: [
        512,
        512,
        [],
        "f39f",
        "M256.55 8C116.52 8 8 110.34 8 248.57c0 72.3 29.71 134.78 78.07 177.94 8.35 7.51 6.63 11.86 8.05 58.23A19.92 19.92 0 0 0 122 502.31c52.91-23.3 53.59-25.14 62.56-22.7C337.85 521.8 504 423.7 504 248.57 504 110.34 396.59 8 256.55 8zm149.24 185.13l-73 115.57a37.37 37.37 0 0 1-53.91 9.93l-58.08-43.47a15 15 0 0 0-18 0l-78.37 59.44c-10.46 7.93-24.16-4.6-17.11-15.67l73-115.57a37.36 37.36 0 0 1 53.91-9.93l58.06 43.46a15 15 0 0 0 18 0l78.41-59.38c10.44-7.98 24.14 4.54 17.09 15.62z"
    ]
};
var $ef0249c5e48bf4e3$export$83a2d14204e40d9a = {
    prefix: "fab",
    iconName: "audible",
    icon: [
        640,
        512,
        [],
        "f373",
        "M640 199.9v54l-320 200L0 254v-54l320 200 320-200.1zm-194.5 72l47.1-29.4c-37.2-55.8-100.7-92.6-172.7-92.6-72 0-135.5 36.7-172.6 92.4h.3c2.5-2.3 5.1-4.5 7.7-6.7 89.7-74.4 219.4-58.1 290.2 36.3zm-220.1 18.8c16.9-11.9 36.5-18.7 57.4-18.7 34.4 0 65.2 18.4 86.4 47.6l45.4-28.4c-20.9-29.9-55.6-49.5-94.8-49.5-38.9 0-73.4 19.4-94.4 49zM103.6 161.1c131.8-104.3 318.2-76.4 417.5 62.1l.7 1 48.8-30.4C517.1 112.1 424.8 58.1 319.9 58.1c-103.5 0-196.6 53.5-250.5 135.6 9.9-10.5 22.7-23.5 34.2-32.6zm467 32.7z"
    ]
};
var $ef0249c5e48bf4e3$export$4c12ad86c5e9c2a9 = {
    prefix: "fab",
    iconName: "think-peaks",
    icon: [
        576,
        512,
        [],
        "f731",
        "M465.4 409.4l87.1-150.2-32-.3-55.1 95L259.2 0 23 407.4l32 .3L259.2 55.6zm-355.3-44.1h32.1l117.4-202.5L463 511.9l32.5.1-235.8-404.6z"
    ]
};
var $ef0249c5e48bf4e3$export$34797550194301d4 = {
    prefix: "fab",
    iconName: "bilibili",
    icon: [
        512,
        512,
        [],
        "e3d9",
        "M488.6 104.1C505.3 122.2 513 143.8 511.9 169.8V372.2C511.5 398.6 502.7 420.3 485.4 437.3C468.2 454.3 446.3 463.2 419.9 464H92.02C65.57 463.2 43.81 454.2 26.74 436.8C9.682 419.4 .7667 396.5 0 368.2V169.8C.7667 143.8 9.682 122.2 26.74 104.1C43.81 87.75 65.57 78.77 92.02 78H121.4L96.05 52.19C90.3 46.46 87.42 39.19 87.42 30.4C87.42 21.6 90.3 14.34 96.05 8.603C101.8 2.868 109.1 0 117.9 0C126.7 0 134 2.868 139.8 8.603L213.1 78H301.1L375.6 8.603C381.7 2.868 389.2 0 398 0C406.8 0 414.1 2.868 419.9 8.603C425.6 14.34 428.5 21.6 428.5 30.4C428.5 39.19 425.6 46.46 419.9 52.19L394.6 78L423.9 78C450.3 78.77 471.9 87.75 488.6 104.1H488.6zM449.8 173.8C449.4 164.2 446.1 156.4 439.1 150.3C433.9 144.2 425.1 140.9 416.4 140.5H96.05C86.46 140.9 78.6 144.2 72.47 150.3C66.33 156.4 63.07 164.2 62.69 173.8V368.2C62.69 377.4 65.95 385.2 72.47 391.7C78.99 398.2 86.85 401.5 96.05 401.5H416.4C425.6 401.5 433.4 398.2 439.7 391.7C446 385.2 449.4 377.4 449.8 368.2L449.8 173.8zM185.5 216.5C191.8 222.8 195.2 230.6 195.6 239.7V273C195.2 282.2 191.9 289.9 185.8 296.2C179.6 302.5 171.8 305.7 162.2 305.7C152.6 305.7 144.7 302.5 138.6 296.2C132.5 289.9 129.2 282.2 128.8 273V239.7C129.2 230.6 132.6 222.8 138.9 216.5C145.2 210.2 152.1 206.9 162.2 206.5C171.4 206.9 179.2 210.2 185.5 216.5H185.5zM377 216.5C383.3 222.8 386.7 230.6 387.1 239.7V273C386.7 282.2 383.4 289.9 377.3 296.2C371.2 302.5 363.3 305.7 353.7 305.7C344.1 305.7 336.3 302.5 330.1 296.2C323.1 289.9 320.7 282.2 320.4 273V239.7C320.7 230.6 324.1 222.8 330.4 216.5C336.7 210.2 344.5 206.9 353.7 206.5C362.9 206.9 370.7 210.2 377 216.5H377z"
    ]
};
var $ef0249c5e48bf4e3$export$c6087bbc62da6f90 = {
    prefix: "fab",
    iconName: "erlang",
    icon: [
        640,
        512,
        [],
        "f39d",
        "M87.2 53.5H0v405h100.4c-49.7-52.6-78.8-125.3-78.7-212.1-.1-76.7 24-142.7 65.5-192.9zm238.2 9.7c-45.9.1-85.1 33.5-89.2 83.2h169.9c-1.1-49.7-34.5-83.1-80.7-83.2zm230.7-9.6h.3l-.1-.1zm.3 0c31.4 42.7 48.7 97.5 46.2 162.7.5 6 .5 11.7 0 24.1H230.2c-.2 109.7 38.9 194.9 138.6 195.3 68.5-.3 118-51 151.9-106.1l96.4 48.2c-17.4 30.9-36.5 57.8-57.9 80.8H640v-405z"
    ]
};
var $ef0249c5e48bf4e3$export$fd0513a3aa908a67 = {
    prefix: "fab",
    iconName: "x-twitter",
    icon: [
        512,
        512,
        [],
        "e61b",
        "M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z"
    ]
};
var $ef0249c5e48bf4e3$export$8fc0685430a4202e = {
    prefix: "fab",
    iconName: "cotton-bureau",
    icon: [
        512,
        512,
        [],
        "f89e",
        "M474.31 330.41c-23.66 91.85-94.23 144.59-201.9 148.35V429.6c0-48 26.41-74.39 74.39-74.39 62 0 99.2-37.2 99.2-99.21 0-61.37-36.53-98.28-97.38-99.06-33-69.32-146.5-64.65-177.24 0C110.52 157.72 74 194.63 74 256c0 62.13 37.27 99.41 99.4 99.41 48 0 74.55 26.23 74.55 74.39V479c-134.43-5-211.1-85.07-211.1-223 0-141.82 81.35-223.2 223.2-223.2 114.77 0 189.84 53.2 214.69 148.81H500C473.88 71.51 388.22 8 259.82 8 105 8 12 101.19 12 255.82 12 411.14 105.19 504.34 259.82 504c128.27 0 213.87-63.81 239.67-173.59zM357 182.33c41.37 3.45 64.2 29 64.2 73.67 0 48-26.43 74.41-74.4 74.41-28.61 0-49.33-9.59-61.59-27.33 83.06-16.55 75.59-99.67 71.79-120.75zm-81.68 97.36c-2.46-10.34-16.33-87 56.23-97 2.27 10.09 16.52 87.11-56.26 97zM260 132c28.61 0 49 9.67 61.44 27.61-28.36 5.48-49.36 20.59-61.59 43.45-12.23-22.86-33.23-38-61.6-43.45 12.41-17.69 33.27-27.35 61.57-27.35zm-71.52 50.72c73.17 10.57 58.91 86.81 56.49 97-72.41-9.84-59-86.95-56.25-97zM173.2 330.41c-48 0-74.4-26.4-74.4-74.41 0-44.36 22.86-70 64.22-73.67-6.75 37.2-1.38 106.53 71.65 120.75-12.14 17.63-32.84 27.3-61.14 27.3zm53.21 12.39A80.8 80.8 0 0 0 260 309.25c7.77 14.49 19.33 25.54 33.82 33.55a80.28 80.28 0 0 0-33.58 33.83c-8-14.5-19.07-26.23-33.56-33.83z"
    ]
};
var $ef0249c5e48bf4e3$export$fc2c1db4698b6c91 = {
    prefix: "fab",
    iconName: "dashcube",
    icon: [
        448,
        512,
        [],
        "f210",
        "M326.6 104H110.4c-51.1 0-91.2 43.3-91.2 93.5V427c0 50.5 40.1 85 91.2 85h227.2c51.1 0 91.2-34.5 91.2-85V0L326.6 104zM153.9 416.5c-17.7 0-32.4-15.1-32.4-32.8V240.8c0-17.7 14.7-32.5 32.4-32.5h140.7c17.7 0 32 14.8 32 32.5v123.5l51.1 52.3H153.9z"
    ]
};
var $ef0249c5e48bf4e3$export$a02285afcee8b3ba = {
    prefix: "fab",
    iconName: "42-group",
    icon: [
        640,
        512,
        [
            "innosoft"
        ],
        "e080",
        "M320 96V416C341.011 416 361.818 411.861 381.23 403.821C400.641 395.78 418.28 383.995 433.138 369.138C447.995 354.28 459.78 336.641 467.821 317.23C475.861 297.818 480 277.011 480 256C480 234.989 475.861 214.182 467.821 194.771C459.78 175.359 447.995 157.72 433.138 142.863C418.28 128.005 400.641 116.22 381.23 108.179C361.818 100.139 341.011 96 320 96ZM0 256L160.002 416L320.003 256L160.002 96L0 256ZM480 256C480 277.011 484.138 297.818 492.179 317.23C500.219 336.643 512.005 354.28 526.862 369.138C541.72 383.995 559.357 395.781 578.77 403.821C598.182 411.862 618.989 416 640 416V96C597.565 96 556.869 112.858 526.862 142.863C496.857 172.869 480 213.565 480 256Z"
    ]
};
var $ef0249c5e48bf4e3$export$da8db9965333c744 = $ef0249c5e48bf4e3$export$a02285afcee8b3ba;
var $ef0249c5e48bf4e3$export$d511b4edf7fbac5a = {
    prefix: "fab",
    iconName: "stack-exchange",
    icon: [
        448,
        512,
        [],
        "f18d",
        "M17.7 332.3h412.7v22c0 37.7-29.3 68-65.3 68h-19L259.3 512v-89.7H83c-36 0-65.3-30.3-65.3-68v-22zm0-23.6h412.7v-85H17.7v85zm0-109.4h412.7v-85H17.7v85zM365 0H83C47 0 17.7 30.3 17.7 67.7V90h412.7V67.7C430.3 30.3 401 0 365 0z"
    ]
};
var $ef0249c5e48bf4e3$export$66726053c0c0ec32 = {
    prefix: "fab",
    iconName: "elementor",
    icon: [
        512,
        512,
        [],
        "f430",
        "M.361 256C.361 397 114 511 255 511C397 511 511 397 511 256C511 116 397 2.05 255 2.05C114 2.05 .361 116 .361 256zM192 150V363H149V150H192zM234 150H362V193H234V150zM362 235V278H234V235H362zM234 320H362V363H234V320z"
    ]
};
var $ef0249c5e48bf4e3$export$9d16a5780aab9cd3 = {
    prefix: "fab",
    iconName: "square-pied-piper",
    icon: [
        448,
        512,
        [
            "pied-piper-square"
        ],
        "e01e",
        "M32 419L0 479.2l.8-328C.8 85.3 54 32 120 32h327.2c-93 28.9-189.9 94.2-253.9 168.6C122.7 282 82.6 338 32 419M448 32S305.2 98.8 261.6 199.1c-23.2 53.6-28.9 118.1-71 158.6-28.9 27.8-69.8 38.2-105.3 56.3-23.2 12-66.4 40.5-84.9 66h328.4c66 0 119.3-53.3 119.3-119.2-.1 0-.1-328.8-.1-328.8z"
    ]
};
var $ef0249c5e48bf4e3$export$95ddae6b65597c6e = $ef0249c5e48bf4e3$export$9d16a5780aab9cd3;
var $ef0249c5e48bf4e3$export$157e4276d9138bda = {
    prefix: "fab",
    iconName: "creative-commons-nd",
    icon: [
        496,
        512,
        [],
        "f4eb",
        "M247.6 8C389.4 8 496 118.1 496 256c0 147.1-118.5 248-248.4 248C113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8zm.8 44.7C130.2 52.7 44.7 150.6 44.7 256c0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8.1-113.8-90.2-203.3-202.8-203.3zm94 144.3v42.5H162.1V197h180.3zm0 79.8v42.5H162.1v-42.5h180.3z"
    ]
};
var $ef0249c5e48bf4e3$export$a226dd96512e144 = {
    prefix: "fab",
    iconName: "palfed",
    icon: [
        576,
        512,
        [],
        "f3d8",
        "M384.9 193.9c0-47.4-55.2-44.2-95.4-29.8-1.3 39.4-2.5 80.7-3 119.8.7 2.8 2.6 6.2 15.1 6.2 36.8 0 83.4-42.8 83.3-96.2zm-194.5 72.2c.2 0 6.5-2.7 11.2-2.7 26.6 0 20.7 44.1-14.4 44.1-21.5 0-37.1-18.1-37.1-43 0-42 42.9-95.6 100.7-126.5 1-12.4 3-22 10.5-28.2 11.2-9 26.6-3.5 29.5 11.1 72.2-22.2 135.2 1 135.2 72 0 77.9-79.3 152.6-140.1 138.2-.1 39.4.9 74.4 2.7 100v.2c.2 3.4.6 12.5-5.3 19.1-9.6 10.6-33.4 10-36.4-22.3-4.1-44.4.2-206.1 1.4-242.5-21.5 15-58.5 50.3-58.5 75.9.2 2.5.4 4 .6 4.6zM8 181.1s-.1 37.4 38.4 37.4h30l22.4 217.2s0 44.3 44.7 44.3h288.9s44.7-.4 44.7-44.3l22.4-217.2h30s38.4 1.2 38.4-37.4c0 0 .1-37.4-38.4-37.4h-30.1c-7.3-25.6-30.2-74.3-119.4-74.3h-28V50.3s-2.7-18.4-21.1-18.4h-85.8s-21.1 0-21.1 18.4v19.1h-28.1s-105 4.2-120.5 74.3h-29S8 142.5 8 181.1z"
    ]
};
var $ef0249c5e48bf4e3$export$349f4fc9997a1bf0 = {
    prefix: "fab",
    iconName: "superpowers",
    icon: [
        448,
        512,
        [],
        "f2dd",
        "M448 32c-83.3 11-166.8 22-250 33-92 12.5-163.3 86.7-169 180-3.3 55.5 18 109.5 57.8 148.2L0 480c83.3-11 166.5-22 249.8-33 91.8-12.5 163.3-86.8 168.7-179.8 3.5-55.5-18-109.5-57.7-148.2L448 32zm-79.7 232.3c-4.2 79.5-74 139.2-152.8 134.5-79.5-4.7-140.7-71-136.3-151 4.5-79.2 74.3-139.3 153-134.5 79.3 4.7 140.5 71 136.1 151z"
    ]
};
var $ef0249c5e48bf4e3$export$e73a6c635a57ef10 = {
    prefix: "fab",
    iconName: "resolving",
    icon: [
        496,
        512,
        [],
        "f3e7",
        "M281.2 278.2c46-13.3 49.6-23.5 44-43.4L314 195.5c-6.1-20.9-18.4-28.1-71.1-12.8L54.7 236.8l28.6 98.6 197.9-57.2zM248.5 8C131.4 8 33.2 88.7 7.2 197.5l221.9-63.9c34.8-10.2 54.2-11.7 79.3-8.2 36.3 6.1 52.7 25 61.4 55.2l10.7 37.8c8.2 28.1 1 50.6-23.5 73.6-19.4 17.4-31.2 24.5-61.4 33.2L203 351.8l220.4 27.1 9.7 34.2-48.1 13.3-286.8-37.3 23 80.2c36.8 22 80.3 34.7 126.3 34.7 137 0 248.5-111.4 248.5-248.3C497 119.4 385.5 8 248.5 8zM38.3 388.6L0 256.8c0 48.5 14.3 93.4 38.3 131.8z"
    ]
};
var $ef0249c5e48bf4e3$export$2c743c09f4269e9c = {
    prefix: "fab",
    iconName: "xbox",
    icon: [
        512,
        512,
        [],
        "f412",
        "M369.9 318.2c44.3 54.3 64.7 98.8 54.4 118.7-7.9 15.1-56.7 44.6-92.6 55.9-29.6 9.3-68.4 13.3-100.4 10.2-38.2-3.7-76.9-17.4-110.1-39C93.3 445.8 87 438.3 87 423.4c0-29.9 32.9-82.3 89.2-142.1 32-33.9 76.5-73.7 81.4-72.6 9.4 2.1 84.3 75.1 112.3 109.5zM188.6 143.8c-29.7-26.9-58.1-53.9-86.4-63.4-15.2-5.1-16.3-4.8-28.7 8.1-29.2 30.4-53.5 79.7-60.3 122.4-5.4 34.2-6.1 43.8-4.2 60.5 5.6 50.5 17.3 85.4 40.5 120.9 9.5 14.6 12.1 17.3 9.3 9.9-4.2-11-.3-37.5 9.5-64 14.3-39 53.9-112.9 120.3-194.4zm311.6 63.5C483.3 127.3 432.7 77 425.6 77c-7.3 0-24.2 6.5-36 13.9-23.3 14.5-41 31.4-64.3 52.8C367.7 197 427.5 283.1 448.2 346c6.8 20.7 9.7 41.1 7.4 52.3-1.7 8.5-1.7 8.5 1.4 4.6 6.1-7.7 19.9-31.3 25.4-43.5 7.4-16.2 15-40.2 18.6-58.7 4.3-22.5 3.9-70.8-.8-93.4zM141.3 43C189 40.5 251 77.5 255.6 78.4c.7.1 10.4-4.2 21.6-9.7 63.9-31.1 94-25.8 107.4-25.2-63.9-39.3-152.7-50-233.9-11.7-23.4 11.1-24 11.9-9.4 11.2z"
    ]
};
var $ef0249c5e48bf4e3$export$e72de9688042e327 = {
    prefix: "fab",
    iconName: "searchengin",
    icon: [
        460,
        512,
        [],
        "f3eb",
        "M220.6 130.3l-67.2 28.2V43.2L98.7 233.5l54.7-24.2v130.3l67.2-209.3zm-83.2-96.7l-1.3 4.7-15.2 52.9C80.6 106.7 52 145.8 52 191.5c0 52.3 34.3 95.9 83.4 105.5v53.6C57.5 340.1 0 272.4 0 191.6c0-80.5 59.8-147.2 137.4-158zm311.4 447.2c-11.2 11.2-23.1 12.3-28.6 10.5-5.4-1.8-27.1-19.9-60.4-44.4-33.3-24.6-33.6-35.7-43-56.7-9.4-20.9-30.4-42.6-57.5-52.4l-9.7-14.7c-24.7 16.9-53 26.9-81.3 28.7l2.1-6.6 15.9-49.5c46.5-11.9 80.9-54 80.9-104.2 0-54.5-38.4-102.1-96-107.1V32.3C254.4 37.4 320 106.8 320 191.6c0 33.6-11.2 64.7-29 90.4l14.6 9.6c9.8 27.1 31.5 48 52.4 57.4s32.2 9.7 56.8 43c24.6 33.2 42.7 54.9 44.5 60.3s.7 17.3-10.5 28.5zm-9.9-17.9c0-4.4-3.6-8-8-8s-8 3.6-8 8 3.6 8 8 8 8-3.6 8-8z"
    ]
};
var $ef0249c5e48bf4e3$export$f310e79ae35a251f = {
    prefix: "fab",
    iconName: "tiktok",
    icon: [
        448,
        512,
        [],
        "e07b",
        "M448,209.91a210.06,210.06,0,0,1-122.77-39.25V349.38A162.55,162.55,0,1,1,185,188.31V278.2a74.62,74.62,0,1,0,52.23,71.18V0l88,0a121.18,121.18,0,0,0,1.86,22.17h0A122.18,122.18,0,0,0,381,102.39a121.43,121.43,0,0,0,67,20.14Z"
    ]
};
var $ef0249c5e48bf4e3$export$8545d76ecd01ec19 = {
    prefix: "fab",
    iconName: "square-facebook",
    icon: [
        448,
        512,
        [
            "facebook-square"
        ],
        "f082",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64h98.2V334.2H109.4V256h52.8V222.3c0-87.1 39.4-127.5 125-127.5c16.2 0 44.2 3.2 55.7 6.4V172c-6-.6-16.5-1-29.6-1c-42 0-58.2 15.9-58.2 57.2V256h83.6l-14.4 78.2H255V480H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64z"
    ]
};
var $ef0249c5e48bf4e3$export$cd6ab8ed6a9ec7a4 = $ef0249c5e48bf4e3$export$8545d76ecd01ec19;
var $ef0249c5e48bf4e3$export$36a9439e8de2df70 = {
    prefix: "fab",
    iconName: "renren",
    icon: [
        512,
        512,
        [],
        "f18b",
        "M214 169.1c0 110.4-61 205.4-147.6 247.4C30 373.2 8 317.7 8 256.6 8 133.9 97.1 32.2 214 12.5v156.6zM255 504c-42.9 0-83.3-11-118.5-30.4C193.7 437.5 239.9 382.9 255 319c15.5 63.9 61.7 118.5 118.8 154.7C338.7 493 298.3 504 255 504zm190.6-87.5C359 374.5 298 279.6 298 169.1V12.5c116.9 19.7 206 121.4 206 244.1 0 61.1-22 116.6-58.4 159.9z"
    ]
};
var $ef0249c5e48bf4e3$export$5cb68a24a0b7bdf6 = {
    prefix: "fab",
    iconName: "linux",
    icon: [
        448,
        512,
        [],
        "f17c",
        "M220.8 123.3c1 .5 1.8 1.7 3 1.7 1.1 0 2.8-.4 2.9-1.5.2-1.4-1.9-2.3-3.2-2.9-1.7-.7-3.9-1-5.5-.1-.4.2-.8.7-.6 1.1.3 1.3 2.3 1.1 3.4 1.7zm-21.9 1.7c1.2 0 2-1.2 3-1.7 1.1-.6 3.1-.4 3.5-1.6.2-.4-.2-.9-.6-1.1-1.6-.9-3.8-.6-5.5.1-1.3.6-3.4 1.5-3.2 2.9.1 1 1.8 1.5 2.8 1.4zM420 403.8c-3.6-4-5.3-11.6-7.2-19.7-1.8-8.1-3.9-16.8-10.5-22.4-1.3-1.1-2.6-2.1-4-2.9-1.3-.8-2.7-1.5-4.1-2 9.2-27.3 5.6-54.5-3.7-79.1-11.4-30.1-31.3-56.4-46.5-74.4-17.1-21.5-33.7-41.9-33.4-72C311.1 85.4 315.7.1 234.8 0 132.4-.2 158 103.4 156.9 135.2c-1.7 23.4-6.4 41.8-22.5 64.7-18.9 22.5-45.5 58.8-58.1 96.7-6 17.9-8.8 36.1-6.2 53.3-6.5 5.8-11.4 14.7-16.6 20.2-4.2 4.3-10.3 5.9-17 8.3s-14 6-18.5 14.5c-2.1 3.9-2.8 8.1-2.8 12.4 0 3.9.6 7.9 1.2 11.8 1.2 8.1 2.5 15.7.8 20.8-5.2 14.4-5.9 24.4-2.2 31.7 3.8 7.3 11.4 10.5 20.1 12.3 17.3 3.6 40.8 2.7 59.3 12.5 19.8 10.4 39.9 14.1 55.9 10.4 11.6-2.6 21.1-9.6 25.9-20.2 12.5-.1 26.3-5.4 48.3-6.6 14.9-1.2 33.6 5.3 55.1 4.1.6 2.3 1.4 4.6 2.5 6.7v.1c8.3 16.7 23.8 24.3 40.3 23 16.6-1.3 34.1-11 48.3-27.9 13.6-16.4 36-23.2 50.9-32.2 7.4-4.5 13.4-10.1 13.9-18.3.4-8.2-4.4-17.3-15.5-29.7zM223.7 87.3c9.8-22.2 34.2-21.8 44-.4 6.5 14.2 3.6 30.9-4.3 40.4-1.6-.8-5.9-2.6-12.6-4.9 1.1-1.2 3.1-2.7 3.9-4.6 4.8-11.8-.2-27-9.1-27.3-7.3-.5-13.9 10.8-11.8 23-4.1-2-9.4-3.5-13-4.4-1-6.9-.3-14.6 2.9-21.8zM183 75.8c10.1 0 20.8 14.2 19.1 33.5-3.5 1-7.1 2.5-10.2 4.6 1.2-8.9-3.3-20.1-9.6-19.6-8.4.7-9.8 21.2-1.8 28.1 1 .8 1.9-.2-5.9 5.5-15.6-14.6-10.5-52.1 8.4-52.1zm-13.6 60.7c6.2-4.6 13.6-10 14.1-10.5 4.7-4.4 13.5-14.2 27.9-14.2 7.1 0 15.6 2.3 25.9 8.9 6.3 4.1 11.3 4.4 22.6 9.3 8.4 3.5 13.7 9.7 10.5 18.2-2.6 7.1-11 14.4-22.7 18.1-11.1 3.6-19.8 16-38.2 14.9-3.9-.2-7-1-9.6-2.1-8-3.5-12.2-10.4-20-15-8.6-4.8-13.2-10.4-14.7-15.3-1.4-4.9 0-9 4.2-12.3zm3.3 334c-2.7 35.1-43.9 34.4-75.3 18-29.9-15.8-68.6-6.5-76.5-21.9-2.4-4.7-2.4-12.7 2.6-26.4v-.2c2.4-7.6.6-16-.6-23.9-1.2-7.8-1.8-15 .9-20 3.5-6.7 8.5-9.1 14.8-11.3 10.3-3.7 11.8-3.4 19.6-9.9 5.5-5.7 9.5-12.9 14.3-18 5.1-5.5 10-8.1 17.7-6.9 8.1 1.2 15.1 6.8 21.9 16l19.6 35.6c9.5 19.9 43.1 48.4 41 68.9zm-1.4-25.9c-4.1-6.6-9.6-13.6-14.4-19.6 7.1 0 14.2-2.2 16.7-8.9 2.3-6.2 0-14.9-7.4-24.9-13.5-18.2-38.3-32.5-38.3-32.5-13.5-8.4-21.1-18.7-24.6-29.9s-3-23.3-.3-35.2c5.2-22.9 18.6-45.2 27.2-59.2 2.3-1.7.8 3.2-8.7 20.8-8.5 16.1-24.4 53.3-2.6 82.4.6-20.7 5.5-41.8 13.8-61.5 12-27.4 37.3-74.9 39.3-112.7 1.1.8 4.6 3.2 6.2 4.1 4.6 2.7 8.1 6.7 12.6 10.3 12.4 10 28.5 9.2 42.4 1.2 6.2-3.5 11.2-7.5 15.9-9 9.9-3.1 17.8-8.6 22.3-15 7.7 30.4 25.7 74.3 37.2 95.7 6.1 11.4 18.3 35.5 23.6 64.6 3.3-.1 7 .4 10.9 1.4 13.8-35.7-11.7-74.2-23.3-84.9-4.7-4.6-4.9-6.6-2.6-6.5 12.6 11.2 29.2 33.7 35.2 59 2.8 11.6 3.3 23.7.4 35.7 16.4 6.8 35.9 17.9 30.7 34.8-2.2-.1-3.2 0-4.2 0 3.2-10.1-3.9-17.6-22.8-26.1-19.6-8.6-36-8.6-38.3 12.5-12.1 4.2-18.3 14.7-21.4 27.3-2.8 11.2-3.6 24.7-4.4 39.9-.5 7.7-3.6 18-6.8 29-32.1 22.9-76.7 32.9-114.3 7.2zm257.4-11.5c-.9 16.8-41.2 19.9-63.2 46.5-13.2 15.7-29.4 24.4-43.6 25.5s-26.5-4.8-33.7-19.3c-4.7-11.1-2.4-23.1 1.1-36.3 3.7-14.2 9.2-28.8 9.9-40.6.8-15.2 1.7-28.5 4.2-38.7 2.6-10.3 6.6-17.2 13.7-21.1.3-.2.7-.3 1-.5.8 13.2 7.3 26.6 18.8 29.5 12.6 3.3 30.7-7.5 38.4-16.3 9-.3 15.7-.9 22.6 5.1 9.9 8.5 7.1 30.3 17.1 41.6 10.6 11.6 14 19.5 13.7 24.6zM173.3 148.7c2 1.9 4.7 4.5 8 7.1 6.6 5.2 15.8 10.6 27.3 10.6 11.6 0 22.5-5.9 31.8-10.8 4.9-2.6 10.9-7 14.8-10.4s5.9-6.3 3.1-6.6-2.6 2.6-6 5.1c-4.4 3.2-9.7 7.4-13.9 9.8-7.4 4.2-19.5 10.2-29.9 10.2s-18.7-4.8-24.9-9.7c-3.1-2.5-5.7-5-7.7-6.9-1.5-1.4-1.9-4.6-4.3-4.9-1.4-.1-1.8 3.7 1.7 6.5z"
    ]
};
var $ef0249c5e48bf4e3$export$c4c84939b8784e10 = {
    prefix: "fab",
    iconName: "glide",
    icon: [
        448,
        512,
        [],
        "f2a5",
        "M252.8 148.6c0 8.8-1.6 17.7-3.4 26.4-5.8 27.8-11.6 55.8-17.3 83.6-1.4 6.3-8.3 4.9-13.7 4.9-23.8 0-30.5-26-30.5-45.5 0-29.3 11.2-68.1 38.5-83.1 4.3-2.5 9.2-4.2 14.1-4.2 11.4 0 12.3 8.3 12.3 17.9zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-64 187c0-5.1-20.8-37.7-25.5-39.5-2.2-.9-7.2-2.3-9.6-2.3-23.1 0-38.7 10.5-58.2 21.5l-.5-.5c4.3-29.4 14.6-57.2 14.6-87.4 0-44.6-23.8-62.7-67.5-62.7-71.7 0-108 70.8-108 123.5 0 54.7 32 85 86.3 85 7.5 0 6.9-.6 6.9 2.3-10.5 80.3-56.5 82.9-56.5 58.9 0-24.4 28-36.5 28.3-38-.2-7.6-29.3-17.2-36.7-17.2-21.1 0-32.7 33-32.7 50.6 0 32.3 20.4 54.7 53.3 54.7 48.2 0 83.4-49.7 94.3-91.7 9.4-37.7 7-39.4 12.3-42.1 20-10.1 35.8-16.8 58.4-16.8 11.1 0 19 2.3 36.7 5.2 1.8.1 4.1-1.7 4.1-3.5z"
    ]
};
var $ef0249c5e48bf4e3$export$b38fbe0cd1e4c67d = {
    prefix: "fab",
    iconName: "linkedin",
    icon: [
        448,
        512,
        [],
        "f08c",
        "M416 32H31.9C14.3 32 0 46.5 0 64.3v383.4C0 465.5 14.3 480 31.9 480H416c17.6 0 32-14.5 32-32.3V64.3c0-17.8-14.4-32.3-32-32.3zM135.4 416H69V202.2h66.5V416zm-33.2-243c-21.3 0-38.5-17.3-38.5-38.5S80.9 96 102.2 96c21.2 0 38.5 17.3 38.5 38.5 0 21.3-17.2 38.5-38.5 38.5zm282.1 243h-66.4V312c0-24.8-.5-56.7-34.5-56.7-34.6 0-39.9 27-39.9 54.9V416h-66.4V202.2h63.7v29.2h.9c8.9-16.8 30.6-34.5 62.9-34.5 67.2 0 79.7 44.3 79.7 101.9V416z"
    ]
};
var $ef0249c5e48bf4e3$export$418b99079caf9b9b = {
    prefix: "fab",
    iconName: "hubspot",
    icon: [
        512,
        512,
        [],
        "f3b2",
        "M267.4 211.6c-25.1 23.7-40.8 57.3-40.8 94.6 0 29.3 9.7 56.3 26 78L203.1 434c-4.4-1.6-9.1-2.5-14-2.5-10.8 0-20.9 4.2-28.5 11.8-7.6 7.6-11.8 17.8-11.8 28.6s4.2 20.9 11.8 28.5c7.6 7.6 17.8 11.6 28.5 11.6 10.8 0 20.9-3.9 28.6-11.6 7.6-7.6 11.8-17.8 11.8-28.5 0-4.2-.6-8.2-1.9-12.1l50-50.2c22 16.9 49.4 26.9 79.3 26.9 71.9 0 130-58.3 130-130.2 0-65.2-47.7-119.2-110.2-128.7V116c17.5-7.4 28.2-23.8 28.2-42.9 0-26.1-20.9-47.9-47-47.9S311.2 47 311.2 73.1c0 19.1 10.7 35.5 28.2 42.9v61.2c-15.2 2.1-29.6 6.7-42.7 13.6-27.6-20.9-117.5-85.7-168.9-124.8 1.2-4.4 2-9 2-13.8C129.8 23.4 106.3 0 77.4 0 48.6 0 25.2 23.4 25.2 52.2c0 28.9 23.4 52.3 52.2 52.3 9.8 0 18.9-2.9 26.8-7.6l163.2 114.7zm89.5 163.6c-38.1 0-69-30.9-69-69s30.9-69 69-69 69 30.9 69 69-30.9 69-69 69z"
    ]
};
var $ef0249c5e48bf4e3$export$bd9dbf3c3b0bdc5e = {
    prefix: "fab",
    iconName: "deploydog",
    icon: [
        512,
        512,
        [],
        "f38e",
        "M382.2 136h51.7v239.6h-51.7v-20.7c-19.8 24.8-52.8 24.1-73.8 14.7-26.2-11.7-44.3-38.1-44.3-71.8 0-29.8 14.8-57.9 43.3-70.8 20.2-9.1 52.7-10.6 74.8 12.9V136zm-64.7 161.8c0 18.2 13.6 33.5 33.2 33.5 19.8 0 33.2-16.4 33.2-32.9 0-17.1-13.7-33.2-33.2-33.2-19.6 0-33.2 16.4-33.2 32.6zM188.5 136h51.7v239.6h-51.7v-20.7c-19.8 24.8-52.8 24.1-73.8 14.7-26.2-11.7-44.3-38.1-44.3-71.8 0-29.8 14.8-57.9 43.3-70.8 20.2-9.1 52.7-10.6 74.8 12.9V136zm-64.7 161.8c0 18.2 13.6 33.5 33.2 33.5 19.8 0 33.2-16.4 33.2-32.9 0-17.1-13.7-33.2-33.2-33.2-19.7 0-33.2 16.4-33.2 32.6zM448 96c17.5 0 32 14.4 32 32v256c0 17.5-14.4 32-32 32H64c-17.5 0-32-14.4-32-32V128c0-17.5 14.4-32 32-32h384m0-32H64C28.8 64 0 92.8 0 128v256c0 35.2 28.8 64 64 64h384c35.2 0 64-28.8 64-64V128c0-35.2-28.8-64-64-64z"
    ]
};
var $ef0249c5e48bf4e3$export$154857d90d308f7c = {
    prefix: "fab",
    iconName: "twitch",
    icon: [
        512,
        512,
        [],
        "f1e8",
        "M391.17,103.47H352.54v109.7h38.63ZM285,103H246.37V212.75H285ZM120.83,0,24.31,91.42V420.58H140.14V512l96.53-91.42h77.25L487.69,256V0ZM449.07,237.75l-77.22,73.12H294.61l-67.6,64v-64H140.14V36.58H449.07Z"
    ]
};
var $ef0249c5e48bf4e3$export$cab2db22e59af947 = {
    prefix: "fab",
    iconName: "ravelry",
    icon: [
        512,
        512,
        [],
        "f2d9",
        "M498.252,234.223c-1.208-10.34-1.7-20.826-3.746-31a310.306,310.306,0,0,0-9.622-36.6,184.068,184.068,0,0,0-30.874-57.5,251.154,251.154,0,0,0-18.818-21.689,237.362,237.362,0,0,0-47.113-36.116A240.8,240.8,0,0,0,331.356,26.65c-11.018-3.1-22.272-5.431-33.515-7.615-6.78-1.314-13.749-1.667-20.627-2.482-.316-.036-.6-.358-.9-.553q-16.143.009-32.288.006c-2.41.389-4.808.925-7.236,1.15a179.331,179.331,0,0,0-34.256,7.1,221.5,221.5,0,0,0-39.768,16.355,281.385,281.385,0,0,0-38.08,24.158c-6.167,4.61-12.268,9.36-17.974,14.518C96.539,88.494,86.34,97.72,76.785,107.555a243.878,243.878,0,0,0-33.648,43.95,206.488,206.488,0,0,0-20.494,44.6,198.2,198.2,0,0,0-7.691,34.759A201.13,201.13,0,0,0,13.4,266.385a299.716,299.716,0,0,0,4.425,40.24,226.865,226.865,0,0,0,16.73,53.3,210.543,210.543,0,0,0,24,39.528,213.589,213.589,0,0,0,26.358,28.416A251.313,251.313,0,0,0,126.7,458.455a287.831,287.831,0,0,0,55.9,25.277,269.5,269.5,0,0,0,40.641,9.835c6.071,1.01,12.275,1.253,18.412,1.873a4.149,4.149,0,0,1,1.19.56h32.289c2.507-.389,5-.937,7.527-1.143,16.336-1.332,32.107-5.335,47.489-10.717A219.992,219.992,0,0,0,379.1,460.322c9.749-6.447,19.395-13.077,28.737-20.1,5.785-4.348,10.988-9.5,16.3-14.457,3.964-3.7,7.764-7.578,11.51-11.5a232.162,232.162,0,0,0,31.427-41.639c9.542-16.045,17.355-32.905,22.3-50.926,2.859-10.413,4.947-21.045,7.017-31.652,1.032-5.279,1.251-10.723,1.87-16.087.036-.317.358-.6.552-.9V236.005A9.757,9.757,0,0,1,498.252,234.223Zm-161.117-1.15s-16.572-2.98-28.47-2.98c-27.2,0-33.57,14.9-33.57,37.04V360.8H201.582V170.062H275.1v31.931c8.924-26.822,26.771-36.189,62.04-36.189Z"
    ]
};
var $ef0249c5e48bf4e3$export$83d047b1c09d253 = {
    prefix: "fab",
    iconName: "mixer",
    icon: [
        512,
        512,
        [],
        "e056",
        "M114.57,76.07a45.71,45.71,0,0,0-67.51-6.41c-17.58,16.18-19,43.52-4.75,62.77l91.78,123L41.76,379.58c-14.23,19.25-13.11,46.59,4.74,62.77A45.71,45.71,0,0,0,114,435.94L242.89,262.7a12.14,12.14,0,0,0,0-14.23ZM470.24,379.58,377.91,255.45l91.78-123c14.22-19.25,12.83-46.59-4.75-62.77a45.71,45.71,0,0,0-67.51,6.41l-128,172.12a12.14,12.14,0,0,0,0,14.23L398,435.94a45.71,45.71,0,0,0,67.51,6.41C483.35,426.17,484.47,398.83,470.24,379.58Z"
    ]
};
var $ef0249c5e48bf4e3$export$37794c0b0ffc1e44 = {
    prefix: "fab",
    iconName: "square-lastfm",
    icon: [
        448,
        512,
        [
            "lastfm-square"
        ],
        "f203",
        "M448 96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96zM210.7 280.8c-1.8-5.5-3.4-10.8-5-15.9c-12.9-41.9-21-68.4-58-68.4c-22.4 0-45.1 16.1-45.1 61.2c0 35.2 18 57.2 43.3 57.2c28.6 0 47.6-21.3 47.6-21.3l11.7 31.9s-19.8 19.4-61.2 19.4c-51.3 0-79.9-30.1-79.9-85.8c0-57.9 28.6-92 82.5-92c67.9 0 79.3 35.3 96.4 88.4c1.4 4.4 2.9 8.9 4.4 13.5c8.8 26.8 24.2 46.2 61.2 46.2c24.9 0 38.1-5.5 38.1-19.1c0-17.5-16.9-21.2-40-26.4c-3.2-.7-6.5-1.4-9.9-2.2c-30.4-7.3-42.5-23.1-42.5-48c0-40 32.3-52.4 65.2-52.4c37.4 0 60.1 13.6 63 46.6l-36.7 4.4c-1.5-15.8-11-22.4-28.6-22.4c-16.1 0-26 7.3-26 19.8c0 11 4.8 17.6 20.9 21.3c2.2 .5 4.5 1 6.7 1.4c31.1 6.5 65.1 13.7 65.1 56.1c.1 36.7-30.7 50.6-76.1 50.6c-63.4 0-85.4-28.6-97.1-64.1z"
    ]
};
var $ef0249c5e48bf4e3$export$c2f59587d6a3a574 = $ef0249c5e48bf4e3$export$37794c0b0ffc1e44;
var $ef0249c5e48bf4e3$export$b73c31bd90a3782e = {
    prefix: "fab",
    iconName: "vimeo",
    icon: [
        448,
        512,
        [],
        "f40a",
        "M403.2 32H44.8C20.1 32 0 52.1 0 76.8v358.4C0 459.9 20.1 480 44.8 480h358.4c24.7 0 44.8-20.1 44.8-44.8V76.8c0-24.7-20.1-44.8-44.8-44.8zM377 180.8c-1.4 31.5-23.4 74.7-66 129.4-44 57.2-81.3 85.8-111.7 85.8-18.9 0-34.8-17.4-47.9-52.3-25.5-93.3-36.4-148-57.4-148-2.4 0-10.9 5.1-25.4 15.2l-15.2-19.6c37.3-32.8 72.9-69.2 95.2-71.2 25.2-2.4 40.7 14.8 46.5 51.7 20.7 131.2 29.9 151 67.6 91.6 13.5-21.4 20.8-37.7 21.8-48.9 3.5-33.2-25.9-30.9-45.8-22.4 15.9-52.1 46.3-77.4 91.2-76 33.3.9 49 22.5 47.1 64.7z"
    ]
};
var $ef0249c5e48bf4e3$export$a580d86d20b50be3 = {
    prefix: "fab",
    iconName: "mendeley",
    icon: [
        640,
        512,
        [],
        "f7b3",
        "M624.6 325.2c-12.3-12.4-29.7-19.2-48.4-17.2-43.3-1-49.7-34.9-37.5-98.8 22.8-57.5-14.9-131.5-87.4-130.8-77.4.7-81.7 82-130.9 82-48.1 0-54-81.3-130.9-82-72.9-.8-110.1 73.3-87.4 130.8 12.2 63.9 5.8 97.8-37.5 98.8-21.2-2.3-37 6.5-53 22.5-19.9 19.7-19.3 94.8 42.6 102.6 47.1 5.9 81.6-42.9 61.2-87.8-47.3-103.7 185.9-106.1 146.5-8.2-.1.1-.2.2-.3.4-26.8 42.8 6.8 97.4 58.8 95.2 52.1 2.1 85.4-52.6 58.8-95.2-.1-.2-.2-.3-.3-.4-39.4-97.9 193.8-95.5 146.5 8.2-4.6 10-6.7 21.3-5.7 33 4.9 53.4 68.7 74.1 104.9 35.2 17.8-14.8 23.1-65.6 0-88.3zm-303.9-19.1h-.6c-43.4 0-62.8-37.5-62.8-62.8 0-34.7 28.2-62.8 62.8-62.8h.6c34.7 0 62.8 28.1 62.8 62.8 0 25-19.2 62.8-62.8 62.8z"
    ]
};
var $ef0249c5e48bf4e3$export$6fb93399039178f9 = {
    prefix: "fab",
    iconName: "uniregistry",
    icon: [
        384,
        512,
        [],
        "f404",
        "M192 480c39.5 0 76.2-11.8 106.8-32.2H85.3C115.8 468.2 152.5 480 192 480zm-89.1-193.1v-12.4H0v12.4c0 2.5 0 5 .1 7.4h103.1c-.2-2.4-.3-4.9-.3-7.4zm20.5 57H8.5c2.6 8.5 5.8 16.8 9.6 24.8h138.3c-12.9-5.7-24.1-14.2-33-24.8zm-17.7-34.7H1.3c.9 7.6 2.2 15 3.9 22.3h109.7c-4-6.9-7.2-14.4-9.2-22.3zm-2.8-69.3H0v17.3h102.9zm0-173.2H0v4.9h102.9zm0-34.7H0v2.5h102.9zm0 69.3H0v7.4h102.9zm0 104H0v14.8h102.9zm0-69.3H0v9.9h102.9zm0 34.6H0V183h102.9zm166.2 160.9h109.7c1.8-7.3 3.1-14.7 3.9-22.3H278.3c-2.1 7.9-5.2 15.4-9.2 22.3zm12-185.7H384V136H281.1zm0 37.2H384v-12.4H281.1zm0-74.3H384v-7.4H281.1zm0-76.7v2.5H384V32zm-203 410.9h227.7c11.8-8.7 22.7-18.6 32.2-29.7H44.9c9.6 11 21.4 21 33.2 29.7zm203-371.3H384v-4.9H281.1zm0 148.5H384v-14.8H281.1zM38.8 405.7h305.3c6.7-8.5 12.6-17.6 17.8-27.2H23c5.2 9.6 9.2 18.7 15.8 27.2zm188.8-37.1H367c3.7-8 5.8-16.2 8.5-24.8h-115c-8.8 10.7-20.1 19.2-32.9 24.8zm53.5-81.7c0 2.5-.1 5-.4 7.4h103.1c.1-2.5.2-4.9.2-7.4v-12.4H281.1zm0-29.7H384v-17.3H281.1z"
    ]
};
var $ef0249c5e48bf4e3$export$e71a35e82f13ad7f = {
    prefix: "fab",
    iconName: "figma",
    icon: [
        384,
        512,
        [],
        "f799",
        "M14 95.7924C14 42.8877 56.8878 0 109.793 0H274.161C327.066 0 369.954 42.8877 369.954 95.7924C369.954 129.292 352.758 158.776 326.711 175.897C352.758 193.019 369.954 222.502 369.954 256.002C369.954 308.907 327.066 351.795 274.161 351.795H272.081C247.279 351.795 224.678 342.369 207.666 326.904V415.167C207.666 468.777 163.657 512 110.309 512C57.5361 512 14 469.243 14 416.207C14 382.709 31.1945 353.227 57.2392 336.105C31.1945 318.983 14 289.5 14 256.002C14 222.502 31.196 193.019 57.2425 175.897C31.196 158.776 14 129.292 14 95.7924ZM176.288 191.587H109.793C74.2172 191.587 45.3778 220.427 45.3778 256.002C45.3778 291.44 73.9948 320.194 109.381 320.416C109.518 320.415 109.655 320.415 109.793 320.415H176.288V191.587ZM207.666 256.002C207.666 291.577 236.505 320.417 272.081 320.417H274.161C309.737 320.417 338.576 291.577 338.576 256.002C338.576 220.427 309.737 191.587 274.161 191.587H272.081C236.505 191.587 207.666 220.427 207.666 256.002ZM109.793 351.795C109.655 351.795 109.518 351.794 109.381 351.794C73.9948 352.015 45.3778 380.769 45.3778 416.207C45.3778 451.652 74.6025 480.622 110.309 480.622C146.591 480.622 176.288 451.186 176.288 415.167V351.795H109.793ZM109.793 31.3778C74.2172 31.3778 45.3778 60.2173 45.3778 95.7924C45.3778 131.368 74.2172 160.207 109.793 160.207H176.288V31.3778H109.793ZM207.666 160.207H274.161C309.737 160.207 338.576 131.368 338.576 95.7924C338.576 60.2173 309.737 31.3778 274.161 31.3778H207.666V160.207Z"
    ]
};
var $ef0249c5e48bf4e3$export$c02c848648d47b55 = {
    prefix: "fab",
    iconName: "creative-commons-remix",
    icon: [
        496,
        512,
        [],
        "f4ee",
        "M247.6 8C389.4 8 496 118.1 496 256c0 147.1-118.5 248-248.4 248C113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8zm.8 44.7C130.2 52.7 44.7 150.6 44.7 256c0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8.1-113.8-90.2-203.3-202.8-203.3zm161.7 207.7l4.9 2.2v70c-7.2 3.6-63.4 27.5-67.3 28.8-6.5-1.8-113.7-46.8-137.3-56.2l-64.2 26.6-63.3-27.5v-63.8l59.3-24.8c-.7-.7-.4 5-.4-70.4l67.3-29.7L361 178.5v61.6l49.1 20.3zm-70.4 81.5v-43.8h-.4v-1.8l-113.8-46.5V295l113.8 46.9v-.4l.4.4zm7.5-57.6l39.9-16.4-36.8-15.5-39 16.4 35.9 15.5zm52.3 38.1v-43L355.2 298v43.4l44.3-19z"
    ]
};
var $ef0249c5e48bf4e3$export$3f0dada7ec074193 = {
    prefix: "fab",
    iconName: "cc-amazon-pay",
    icon: [
        576,
        512,
        [],
        "f42d",
        "M124.7 201.8c.1-11.8 0-23.5 0-35.3v-35.3c0-1.3.4-2 1.4-2.7 11.5-8 24.1-12.1 38.2-11.1 12.5.9 22.7 7 28.1 21.7 3.3 8.9 4.1 18.2 4.1 27.7 0 8.7-.7 17.3-3.4 25.6-5.7 17.8-18.7 24.7-35.7 23.9-11.7-.5-21.9-5-31.4-11.7-.9-.8-1.4-1.6-1.3-2.8zm154.9 14.6c4.6 1.8 9.3 2 14.1 1.5 11.6-1.2 21.9-5.7 31.3-12.5.9-.6 1.3-1.3 1.3-2.5-.1-3.9 0-7.9 0-11.8 0-4-.1-8 0-12 0-1.4-.4-2-1.8-2.2-7-.9-13.9-2.2-20.9-2.9-7-.6-14-.3-20.8 1.9-6.7 2.2-11.7 6.2-13.7 13.1-1.6 5.4-1.6 10.8.1 16.2 1.6 5.5 5.2 9.2 10.4 11.2zM576 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48zm-207.5 23.9c.4 1.7.9 3.4 1.6 5.1 16.5 40.6 32.9 81.3 49.5 121.9 1.4 3.5 1.7 6.4.2 9.9-2.8 6.2-4.9 12.6-7.8 18.7-2.6 5.5-6.7 9.5-12.7 11.2-4.2 1.1-8.5 1.3-12.9.9-2.1-.2-4.2-.7-6.3-.8-2.8-.2-4.2 1.1-4.3 4-.1 2.8-.1 5.6 0 8.3.1 4.6 1.6 6.7 6.2 7.5 4.7.8 9.4 1.6 14.2 1.7 14.3.3 25.7-5.4 33.1-17.9 2.9-4.9 5.6-10.1 7.7-15.4 19.8-50.1 39.5-100.3 59.2-150.5.6-1.5 1.1-3 1.3-4.6.4-2.4-.7-3.6-3.1-3.7-5.6-.1-11.1 0-16.7 0-3.1 0-5.3 1.4-6.4 4.3-.4 1.1-.9 2.3-1.3 3.4l-29.1 83.7c-2.1 6.1-4.2 12.1-6.5 18.6-.4-.9-.6-1.4-.8-1.9-10.8-29.9-21.6-59.9-32.4-89.8-1.7-4.7-3.5-9.5-5.3-14.2-.9-2.5-2.7-4-5.4-4-6.4-.1-12.8-.2-19.2-.1-2.2 0-3.3 1.6-2.8 3.7zM242.4 206c1.7 11.7 7.6 20.8 18 26.6 9.9 5.5 20.7 6.2 31.7 4.6 12.7-1.9 23.9-7.3 33.8-15.5.4-.3.8-.6 1.4-1 .5 3.2.9 6.2 1.5 9.2.5 2.6 2.1 4.3 4.5 4.4 4.6.1 9.1.1 13.7 0 2.3-.1 3.8-1.6 4-3.9.1-.8.1-1.6.1-2.3v-88.8c0-3.6-.2-7.2-.7-10.8-1.6-10.8-6.2-19.7-15.9-25.4-5.6-3.3-11.8-5-18.2-5.9-3-.4-6-.7-9.1-1.1h-10c-.8.1-1.6.3-2.5.3-8.2.4-16.3 1.4-24.2 3.5-5.1 1.3-10 3.2-15 4.9-3 1-4.5 3.2-4.4 6.5.1 2.8-.1 5.6 0 8.3.1 4.1 1.8 5.2 5.7 4.1 6.5-1.7 13.1-3.5 19.7-4.8 10.3-1.9 20.7-2.7 31.1-1.2 5.4.8 10.5 2.4 14.1 7 3.1 4 4.2 8.8 4.4 13.7.3 6.9.2 13.9.3 20.8 0 .4-.1.7-.2 1.2-.4 0-.8 0-1.1-.1-8.8-2.1-17.7-3.6-26.8-4.1-9.5-.5-18.9.1-27.9 3.2-10.8 3.8-19.5 10.3-24.6 20.8-4.1 8.3-4.6 17-3.4 25.8zM98.7 106.9v175.3c0 .8 0 1.7.1 2.5.2 2.5 1.7 4.1 4.1 4.2 5.9.1 11.8.1 17.7 0 2.5 0 4-1.7 4.1-4.1.1-.8.1-1.7.1-2.5v-60.7c.9.7 1.4 1.2 1.9 1.6 15 12.5 32.2 16.6 51.1 12.9 17.1-3.4 28.9-13.9 36.7-29.2 5.8-11.6 8.3-24.1 8.7-37 .5-14.3-1-28.4-6.8-41.7-7.1-16.4-18.9-27.3-36.7-30.9-2.7-.6-5.5-.8-8.2-1.2h-7c-1.2.2-2.4.3-3.6.5-11.7 1.4-22.3 5.8-31.8 12.7-2 1.4-3.9 3-5.9 4.5-.1-.5-.3-.8-.4-1.2-.4-2.3-.7-4.6-1.1-6.9-.6-3.9-2.5-5.5-6.4-5.6h-9.7c-5.9-.1-6.9 1-6.9 6.8zM493.6 339c-2.7-.7-5.1 0-7.6 1-43.9 18.4-89.5 30.2-136.8 35.8-14.5 1.7-29.1 2.8-43.7 3.2-26.6.7-53.2-.8-79.6-4.3-17.8-2.4-35.5-5.7-53-9.9-37-8.9-72.7-21.7-106.7-38.8-8.8-4.4-17.4-9.3-26.1-14-3.8-2.1-6.2-1.5-8.2 2.1v1.7c1.2 1.6 2.2 3.4 3.7 4.8 36 32.2 76.6 56.5 122 72.9 21.9 7.9 44.4 13.7 67.3 17.5 14 2.3 28 3.8 42.2 4.5 3 .1 6 .2 9 .4.7 0 1.4.2 2.1.3h17.7c.7-.1 1.4-.3 2.1-.3 14.9-.4 29.8-1.8 44.6-4 21.4-3.2 42.4-8.1 62.9-14.7 29.6-9.6 57.7-22.4 83.4-40.1 2.8-1.9 5.7-3.8 8-6.2 4.3-4.4 2.3-10.4-3.3-11.9zm50.4-27.7c-.8-4.2-4-5.8-7.6-7-5.7-1.9-11.6-2.8-17.6-3.3-11-.9-22-.4-32.8 1.6-12 2.2-23.4 6.1-33.5 13.1-1.2.8-2.4 1.8-3.1 3-.6.9-.7 2.3-.5 3.4.3 1.3 1.7 1.6 3 1.5.6 0 1.2 0 1.8-.1l19.5-2.1c9.6-.9 19.2-1.5 28.8-.8 4.1.3 8.1 1.2 12 2.2 4.3 1.1 6.2 4.4 6.4 8.7.3 6.7-1.2 13.1-2.9 19.5-3.5 12.9-8.3 25.4-13.3 37.8-.3.8-.7 1.7-.8 2.5-.4 2.5 1 4 3.4 3.5 1.4-.3 3-1.1 4-2.1 3.7-3.6 7.5-7.2 10.6-11.2 10.7-13.8 17-29.6 20.7-46.6.7-3 1.2-6.1 1.7-9.1.2-4.7.2-9.6.2-14.5z"
    ]
};
var $ef0249c5e48bf4e3$export$e4589d83245ae1b2 = {
    prefix: "fab",
    iconName: "dropbox",
    icon: [
        528,
        512,
        [],
        "f16b",
        "M264.4 116.3l-132 84.3 132 84.3-132 84.3L0 284.1l132.3-84.3L0 116.3 132.3 32l132.1 84.3zM131.6 395.7l132-84.3 132 84.3-132 84.3-132-84.3zm132.8-111.6l132-84.3-132-83.6L395.7 32 528 116.3l-132.3 84.3L528 284.8l-132.3 84.3-131.3-85z"
    ]
};
var $ef0249c5e48bf4e3$export$8256451a9905291a = {
    prefix: "fab",
    iconName: "instagram",
    icon: [
        448,
        512,
        [],
        "f16d",
        "M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"
    ]
};
var $ef0249c5e48bf4e3$export$f4e59d0d43aeb784 = {
    prefix: "fab",
    iconName: "cmplid",
    icon: [
        640,
        512,
        [],
        "e360",
        "M226.119,388.165a3.816,3.816,0,0,0-2.294-3.5,3.946,3.946,0,0,0-1.629-.385L72.6,384.3a19.243,19.243,0,0,1-17.924-26.025L81.585,255.692a35.72,35.72,0,0,1,32.373-26H262.525a7.07,7.07,0,0,0,6.392-5.194l10.769-41.131a3.849,3.849,0,0,0-2.237-4.937,3.755,3.755,0,0,0-1.377-.261c-.063,0-.126,0-.189.005H127.38a106.8,106.8,0,0,0-96.99,77.1L3.483,358.824A57.469,57.469,0,0,0,57.314,436q1.43,0,2.86-.072H208.742a7.131,7.131,0,0,0,6.391-5.193L225.839,389.6A3.82,3.82,0,0,0,226.119,388.165ZM306.658,81.2a3.861,3.861,0,0,0,.251-1.367A3.813,3.813,0,0,0,303.079,76c-.064,0-.128,0-.192,0h-41A7.034,7.034,0,0,0,255.5,81.2l-21.347,80.915h51.131ZM180.364,368.249H231.5L263.452,245.69H212.321ZM511.853,79.723a3.809,3.809,0,0,0-3.8-3.661c-.058,0-.137,0-.23.007h-41a7.1,7.1,0,0,0-6.584,5.129L368.91,430.634a3.54,3.54,0,0,0-.262,1.335,3.873,3.873,0,0,0,3.864,3.863c.056,0,.112,0,.169,0h41a7.068,7.068,0,0,0,6.392-5.193L511.533,81.2A3.624,3.624,0,0,0,511.853,79.723ZM324.649,384.47h-41a7.2,7.2,0,0,0-6.392,5.194L266.52,430.8a3.662,3.662,0,0,0-.268,1.374A3.783,3.783,0,0,0,270.023,436c.06,0,.166,0,.3-.012h40.905a7.036,7.036,0,0,0,6.391-5.193l10.769-41.131a3.75,3.75,0,0,0-3.445-5.208c-.108,0-.217,0-.326.014Zm311.324-308.4h-41a7.066,7.066,0,0,0-6.392,5.129l-91.46,349.436a4.073,4.073,0,0,0-.229,1.347,3.872,3.872,0,0,0,3.863,3.851c.056,0,.112,0,.169,0h40.968a7.1,7.1,0,0,0,6.392-5.193L639.68,81.2a3.624,3.624,0,0,0,.32-1.475,3.841,3.841,0,0,0-3.821-3.564c-.068,0-.137,0-.206.006ZM371.562,225.236l10.8-41.1a4.369,4.369,0,0,0,.227-1.388,3.869,3.869,0,0,0-3.861-3.842c-.057,0-.113,0-.169,0h-41.1a7.292,7.292,0,0,0-6.391,5.226l-10.834,41.1a4.417,4.417,0,0,0-.26,1.493c0,.069,0,.138,0,.206a3.776,3.776,0,0,0,3.757,3.507c.076,0,.18,0,.3-.012h41.129A7.034,7.034,0,0,0,371.562,225.236Z"
    ]
};
var $ef0249c5e48bf4e3$export$f32e8672931b41ff = {
    prefix: "fab",
    iconName: "upwork",
    icon: [
        448,
        512,
        [],
        "e641",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM270.8 274.3c5.2 8.4 23.6 29.9 51.5 29.9v0c25.2 0 44.9-20.2 44.9-49.7s-19.4-49.7-44.9-49.7s-44.9 16.7-51.5 69.5zm-26.7-41.8c7.3-30.5 32.7-60.1 78.2-60.1l0 0c45.1 0 80.9 35.2 80.9 82.2s-35.9 81.9-80.9 81.9c-.6 0-1.1 0-1.7 0c-.5 0-1.1 0-1.6 0h-.1c-14.5-.5-28.7-4.8-40.9-12.6c-4.7-2.8-9.1-6-13.4-9.5l-12.8 78.4H214.9l19.4-110.6c-20.8-29.1-31.6-62.4-36.2-79.7V255c0 48-30.5 81.5-74.2 81.5c-22 0-41-8-54.8-23.3c-13.4-14.8-20.8-35.5-20.8-58.3V176.8H84.5l-.3 78.2c0 28.4 14.5 49.3 39.8 49.3s38.2-20.9 38.2-49.3V176.8h62.8c4.8 19.3 10.9 40.1 19.2 55.6z"
    ]
};
var $ef0249c5e48bf4e3$export$86108d0b79007794 = {
    prefix: "fab",
    iconName: "facebook",
    icon: [
        512,
        512,
        [
            62000
        ],
        "f09a",
        "M512 256C512 114.6 397.4 0 256 0S0 114.6 0 256C0 376 82.7 476.8 194.2 504.5V334.2H141.4V256h52.8V222.3c0-87.1 39.4-127.5 125-127.5c16.2 0 44.2 3.2 55.7 6.4V172c-6-.6-16.5-1-29.6-1c-42 0-58.2 15.9-58.2 57.2V256h83.6l-14.4 78.2H287V510.1C413.8 494.8 512 386.9 512 256h0z"
    ]
};
var $ef0249c5e48bf4e3$export$957b7296da5b4490 = {
    prefix: "fab",
    iconName: "gripfire",
    icon: [
        384,
        512,
        [],
        "f3ac",
        "M112.5 301.4c0-73.8 105.1-122.5 105.1-203 0-47.1-34-88-39.1-90.4.4 3.3.6 6.7.6 10C179.1 110.1 32 171.9 32 286.6c0 49.8 32.2 79.2 66.5 108.3 65.1 46.7 78.1 71.4 78.1 86.6 0 10.1-4.8 17-4.8 22.3 13.1-16.7 17.4-31.9 17.5-46.4 0-29.6-21.7-56.3-44.2-86.5-16-22.3-32.6-42.6-32.6-69.5zm205.3-39c-12.1-66.8-78-124.4-94.7-130.9l4 7.2c2.4 5.1 3.4 10.9 3.4 17.1 0 44.7-54.2 111.2-56.6 116.7-2.2 5.1-3.2 10.5-3.2 15.8 0 20.1 15.2 42.1 17.9 42.1 2.4 0 56.6-55.4 58.1-87.7 6.4 11.7 9.1 22.6 9.1 33.4 0 41.2-41.8 96.9-41.8 96.9 0 11.6 31.9 53.2 35.5 53.2 1 0 2.2-1.4 3.2-2.4 37.9-39.3 67.3-85 67.3-136.8 0-8-.7-16.2-2.2-24.6z"
    ]
};
var $ef0249c5e48bf4e3$export$3a376d0f2ecfb7d0 = {
    prefix: "fab",
    iconName: "jedi-order",
    icon: [
        448,
        512,
        [],
        "f50e",
        "M398.5 373.6c95.9-122.1 17.2-233.1 17.2-233.1 45.4 85.8-41.4 170.5-41.4 170.5 105-171.5-60.5-271.5-60.5-271.5 96.9 72.7-10.1 190.7-10.1 190.7 85.8 158.4-68.6 230.1-68.6 230.1s-.4-16.9-2.2-85.7c4.3 4.5 34.5 36.2 34.5 36.2l-24.2-47.4 62.6-9.1-62.6-9.1 20.2-55.5-31.4 45.9c-2.2-87.7-7.8-305.1-7.9-306.9v-2.4 1-1 2.4c0 1-5.6 219-7.9 306.9l-31.4-45.9 20.2 55.5-62.6 9.1 62.6 9.1-24.2 47.4 34.5-36.2c-1.8 68.8-2.2 85.7-2.2 85.7s-154.4-71.7-68.6-230.1c0 0-107-118.1-10.1-190.7 0 0-165.5 99.9-60.5 271.5 0 0-86.8-84.8-41.4-170.5 0 0-78.7 111 17.2 233.1 0 0-26.2-16.1-49.4-77.7 0 0 16.9 183.3 222 185.7h4.1c205-2.4 222-185.7 222-185.7-23.6 61.5-49.9 77.7-49.9 77.7z"
    ]
};
var $ef0249c5e48bf4e3$export$27afc16078b5f3ac = {
    prefix: "fab",
    iconName: "uikit",
    icon: [
        448,
        512,
        [],
        "f403",
        "M443.9 128v256L218 512 0 384V169.7l87.6 45.1v117l133.5 75.5 135.8-75.5v-151l-101.1-57.6 87.6-53.1L443.9 128zM308.6 49.1L223.8 0l-88.6 54.8 86 47.3 87.4-53z"
    ]
};
var $ef0249c5e48bf4e3$export$a5097e0b1bb080b7 = {
    prefix: "fab",
    iconName: "fort-awesome-alt",
    icon: [
        512,
        512,
        [],
        "f3a3",
        "M208 237.4h-22.2c-2.1 0-3.7 1.6-3.7 3.7v51.7c0 2.1 1.6 3.7 3.7 3.7H208c2.1 0 3.7-1.6 3.7-3.7v-51.7c0-2.1-1.6-3.7-3.7-3.7zm118.2 0H304c-2.1 0-3.7 1.6-3.7 3.7v51.7c0 2.1 1.6 3.7 3.7 3.7h22.2c2.1 0 3.7-1.6 3.7-3.7v-51.7c-.1-2.1-1.7-3.7-3.7-3.7zm132-125.1c-2.3-3.2-4.6-6.4-7.1-9.5-9.8-12.5-20.8-24-32.8-34.4-4.5-3.9-9.1-7.6-13.9-11.2-1.6-1.2-3.2-2.3-4.8-3.5C372 34.1 340.3 20 306 13c-16.2-3.3-32.9-5-50-5s-33.9 1.7-50 5c-34.3 7.1-66 21.2-93.3 40.8-1.6 1.1-3.2 2.3-4.8 3.5-4.8 3.6-9.4 7.3-13.9 11.2-3 2.6-5.9 5.3-8.8 8s-5.7 5.5-8.4 8.4c-5.5 5.7-10.7 11.8-15.6 18-2.4 3.1-4.8 6.3-7.1 9.5C25.2 153 8.3 202.5 8.3 256c0 2 .1 4 .1 6 .1.7.1 1.3.1 2 .1 1.3.1 2.7.2 4 0 .8.1 1.5.1 2.3 0 1.3.1 2.5.2 3.7.1.8.1 1.6.2 2.4.1 1.1.2 2.3.3 3.5 0 .8.1 1.6.2 2.4.1 1.2.3 2.4.4 3.6.1.8.2 1.5.3 2.3.1 1.3.3 2.6.5 3.9.1.6.2 1.3.3 1.9l.9 5.7c.1.6.2 1.1.3 1.7.3 1.3.5 2.7.8 4 .2.8.3 1.6.5 2.4.2 1 .5 2.1.7 3.2.2.9.4 1.7.6 2.6.2 1 .4 2 .7 3 .2.9.5 1.8.7 2.7.3 1 .5 1.9.8 2.9.3.9.5 1.8.8 2.7.2.9.5 1.9.8 2.8s.5 1.8.8 2.7c.3 1 .6 1.9.9 2.8.6 1.6 1.1 3.3 1.7 4.9.4 1 .7 1.9 1 2.8.3 1 .7 2 1.1 3 .3.8.6 1.5.9 2.3l1.2 3c.3.7.6 1.5.9 2.2.4 1 .9 2 1.3 3l.9 2.1c.5 1 .9 2 1.4 3 .3.7.6 1.3.9 2 .5 1 1 2.1 1.5 3.1.2.6.5 1.1.8 1.7.6 1.1 1.1 2.2 1.7 3.3.1.2.2.3.3.5 2.2 4.1 4.4 8.2 6.8 12.2.2.4.5.8.7 1.2.7 1.1 1.3 2.2 2 3.3.3.5.6.9.9 1.4.6 1.1 1.3 2.1 2 3.2.3.5.6.9.9 1.4.7 1.1 1.4 2.1 2.1 3.2.2.4.5.8.8 1.2.7 1.1 1.5 2.2 2.3 3.3.2.2.3.5.5.7 37.5 51.7 94.4 88.5 160 99.4.9.1 1.7.3 2.6.4 1 .2 2.1.4 3.1.5s1.9.3 2.8.4c1 .2 2 .3 3 .4.9.1 1.9.2 2.9.3s1.9.2 2.9.3 2.1.2 3.1.3c.9.1 1.8.1 2.7.2 1.1.1 2.3.1 3.4.2.8 0 1.7.1 2.5.1 1.3 0 2.6.1 3.9.1.7.1 1.4.1 2.1.1 2 .1 4 .1 6 .1s4-.1 6-.1c.7 0 1.4-.1 2.1-.1 1.3 0 2.6 0 3.9-.1.8 0 1.7-.1 2.5-.1 1.1-.1 2.3-.1 3.4-.2.9 0 1.8-.1 2.7-.2 1-.1 2.1-.2 3.1-.3s1.9-.2 2.9-.3c.9-.1 1.9-.2 2.9-.3s2-.3 3-.4 1.9-.3 2.8-.4c1-.2 2.1-.3 3.1-.5.9-.1 1.7-.3 2.6-.4 65.6-11 122.5-47.7 160.1-102.4.2-.2.3-.5.5-.7.8-1.1 1.5-2.2 2.3-3.3.2-.4.5-.8.8-1.2.7-1.1 1.4-2.1 2.1-3.2.3-.5.6-.9.9-1.4.6-1.1 1.3-2.1 2-3.2.3-.5.6-.9.9-1.4.7-1.1 1.3-2.2 2-3.3.2-.4.5-.8.7-1.2 2.4-4 4.6-8.1 6.8-12.2.1-.2.2-.3.3-.5.6-1.1 1.1-2.2 1.7-3.3.2-.6.5-1.1.8-1.7.5-1 1-2.1 1.5-3.1.3-.7.6-1.3.9-2 .5-1 1-2 1.4-3l.9-2.1c.5-1 .9-2 1.3-3 .3-.7.6-1.5.9-2.2l1.2-3c.3-.8.6-1.5.9-2.3.4-1 .7-2 1.1-3s.7-1.9 1-2.8c.6-1.6 1.2-3.3 1.7-4.9.3-1 .6-1.9.9-2.8s.5-1.8.8-2.7c.2-.9.5-1.9.8-2.8s.6-1.8.8-2.7c.3-1 .5-1.9.8-2.9.2-.9.5-1.8.7-2.7.2-1 .5-2 .7-3 .2-.9.4-1.7.6-2.6.2-1 .5-2.1.7-3.2.2-.8.3-1.6.5-2.4.3-1.3.6-2.7.8-4 .1-.6.2-1.1.3-1.7l.9-5.7c.1-.6.2-1.3.3-1.9.1-1.3.3-2.6.5-3.9.1-.8.2-1.5.3-2.3.1-1.2.3-2.4.4-3.6 0-.8.1-1.6.2-2.4.1-1.1.2-2.3.3-3.5.1-.8.1-1.6.2-2.4.1 1.7.1.5.2-.7 0-.8.1-1.5.1-2.3.1-1.3.2-2.7.2-4 .1-.7.1-1.3.1-2 .1-2 .1-4 .1-6 0-53.5-16.9-103-45.8-143.7zM448 371.5c-9.4 15.5-20.6 29.9-33.6 42.9-20.6 20.6-44.5 36.7-71.2 48-13.9 5.8-28.2 10.3-42.9 13.2v-75.8c0-58.6-88.6-58.6-88.6 0v75.8c-14.7-2.9-29-7.3-42.9-13.2-26.7-11.3-50.6-27.4-71.2-48-13-13-24.2-27.4-33.6-42.9v-71.3c0-2.1 1.6-3.7 3.7-3.7h22.1c2.1 0 3.7 1.6 3.7 3.7V326h29.6V182c0-2.1 1.6-3.7 3.7-3.7h22.1c2.1 0 3.7 1.6 3.7 3.7v25.9h29.5V182c0-2.1 1.6-3.7 3.7-3.7H208c2.1 0 3.7 1.6 3.7 3.7v25.9h29.5V182c0-4.8 6.5-3.7 9.5-3.7V88.1c-4.4-2-7.4-6.7-7.4-11.5 0-16.8 25.4-16.8 25.4 0 0 4.8-3 9.4-7.4 11.5V92c6.3-1.4 12.7-2.3 19.2-2.3 9.4 0 18.4 3.5 26.3 3.5 7.2 0 15.2-3.5 19.4-3.5 2.1 0 3.7 1.6 3.7 3.7v48.4c0 5.6-18.7 6.5-22.4 6.5-8.6 0-16.6-3.5-25.4-3.5-7 0-14.1 1.2-20.8 2.8v30.7c3 0 9.5-1.1 9.5 3.7v25.9h29.5V182c0-2.1 1.6-3.7 3.7-3.7h22.2c2.1 0 3.7 1.6 3.7 3.7v25.9h29.5V182c0-2.1 1.6-3.7 3.7-3.7h22.1c2.1 0 3.7 1.6 3.7 3.7v144h29.5v-25.8c0-2.1 1.6-3.7 3.7-3.7h22.2c2.1 0 3.7 1.6 3.7 3.7z"
    ]
};
var $ef0249c5e48bf4e3$export$cc29519275365076 = {
    prefix: "fab",
    iconName: "phabricator",
    icon: [
        496,
        512,
        [],
        "f3db",
        "M323 262.1l-.1-13s21.7-19.8 21.1-21.2l-9.5-20c-.6-1.4-29.5-.5-29.5-.5l-9.4-9.3s.2-28.5-1.2-29.1l-20.1-9.2c-1.4-.6-20.7 21-20.7 21l-13.1-.2s-20.5-21.4-21.9-20.8l-20 8.3c-1.4.5.2 28.9.2 28.9l-9.1 9.1s-29.2-.9-29.7.4l-8.1 19.8c-.6 1.4 21 21 21 21l.1 12.9s-21.7 19.8-21.1 21.2l9.5 20c.6 1.4 29.5.5 29.5.5l9.4 9.3s-.2 31.8 1.2 32.3l20.1 8.3c1.4.6 20.7-23.5 20.7-23.5l13.1.2s20.5 23.8 21.8 23.3l20-7.5c1.4-.6-.2-32.1-.2-32.1l9.1-9.1s29.2.9 29.7-.5l8.1-19.8c.7-1.1-20.9-20.7-20.9-20.7zm-44.9-8.7c.7 17.1-12.8 31.6-30.1 32.4-17.3.8-32.1-12.5-32.8-29.6-.7-17.1 12.8-31.6 30.1-32.3 17.3-.8 32.1 12.5 32.8 29.5zm201.2-37.9l-97-97-.1.1c-75.1-73.3-195.4-72.8-269.8 1.6-50.9 51-27.8 27.9-95.7 95.3-22.3 22.3-22.3 58.7 0 81 69.9 69.4 46.4 46 97.4 97l.1-.1c75.1 73.3 195.4 72.9 269.8-1.6 51-50.9 27.9-27.9 95.3-95.3 22.3-22.3 22.3-58.7 0-81zM140.4 363.8c-59.6-59.5-59.6-156 0-215.5 59.5-59.6 156-59.5 215.6 0 59.5 59.5 59.6 156 0 215.6-59.6 59.5-156 59.4-215.6-.1z"
    ]
};
var $ef0249c5e48bf4e3$export$d0ceedb643a91662 = {
    prefix: "fab",
    iconName: "ussunnah",
    icon: [
        482,
        512,
        [],
        "f407",
        "M481.9 268.1A240.9 240.9 0 1 1 .1 268a240.9 240.9 0 1 1 481.9 0zM24.5 268a216.5 216.5 0 1 0 432.9 0A216.5 216.5 0 1 0 24.5 268zm385.9 63.3c-12.7 0-21.6-1.9-26.7-5.9c-5.5-4.3-8.2-12.3-8.2-23.8V205.1c0-6.5-5.2-20.2-15.7-41.2c7 0 17-9.1 30-27.2V284.5c0 11 2.4 19.4 7 25.3c3.7 4.7 10.1 8.9 19 12.6c1.2 .4 2.6 .9 4.1 1.4c2.9 .9 6.3 2.1 10.3 3.5c-1.8 2.7-8.3 4-19.9 4zm-219 0c-1.3 2.4-3.6 5.5-6.8 9.4l-18.5 22.5c-1-6.1-4-13-9.3-20.6s-9.7-11.4-13.4-11.4h-8.3H53.6c3.3-5.3 4.9-8.8 4.9-10.8c0-2-.8-5.3-2.4-9.7c-1.5-4.4-2.4-8.5-2.4-12.4c0-7.4 2.1-13.9 6.3-19.3L80 253.4l-7.1-17.7L89 215.9l6.7 16.8 8-10.3c-1.8 6.4-2.6 12.3-2.6 17.7c0 4.2 2.8 13.3 8.3 27.3l16.2 40.7H135h8 .3c2.8 .4 7.7 5 14.6 13.9c1.8 2.4 4.3 5.8 7.7 10.2c1.4 1.9 2.9 3.9 4.6 6.1c1.3-2.3 2-4.6 2-7.1c0-2-1.3-6.6-4-13.4L163 304.1c-4-10.6-6.1-17.7-6.1-21.3c0-6.3 1.9-12.3 5.8-17.9c.5-.6 1-1.3 1.5-1.9c4.4-5.6 8.8-11.1 13.3-16.5c-1.1 4.6-1.7 8.7-1.7 12c0 3.7 1.7 9.9 5.1 18.8l7.9 20.4c1.9 4.7 3 8.2 3.7 10.3h17.6 8.3l-.9-2.6c-1.4-3.9-4-7-7.7-9.3l15.6-20.1 12.3 32h13.4L245 292.2c-1.5-3.9-4-7-7.7-9.3L253 262.8 270.3 308h13.4l-11.4-29.4c-1.5-3.9-4-7-7.7-9.3l15.6-20L302.6 308h10.3 8.3 7.6c1.5 0 3-1.1 4.5-3.1s2.2-4.1 2.2-6.3V205.1c0-6.5-4.5-20.3-13.7-41.2c5.4 0 14.1-9.1 26.2-27.2V300.2c0 7.2 .6 12 1.7 14.6c1.6 3.4 5.3 6.2 11.1 8.2c-3.9 5.6-8.7 8.5-14.5 8.5H321.1h-8.3H210.5h-19zM93.4 287.3c-2.7-6.7-4-11.7-4-15c-.6 1.2-2.4 3.7-5.4 7.6c-1.4 1.9-2.2 3.7-2.2 5.3c0 2.6 .8 5.7 2.2 9.3l5.6 13.9h0c5 0 9 0 11.9-.1l-8.2-20.9zm13.5-72.4c-3-5.2-7-9.3-11.9-11.9c-3.5-1.9-5.3-4.3-5.3-7.4c0-2.4 4.6-8.6 14-18.3c.2 3.8 1.9 7.6 4.9 11.2c3.1 3.6 4.6 7 4.6 10.1c0 2.6-2.1 8-6.2 16.3zm-27.6 0c-3-5.2-7-9.3-11.9-11.9c-3.5-1.9-5.3-4.3-5.3-7.4c0-2.4 4.6-8.6 14-18.3c.2 3.8 1.9 7.6 4.9 11.2c3.1 3.6 4.6 7 4.6 10.1c0 2.6-2.1 8-6.2 16.3zm87 27.5c-3-5.2-7-9.3-11.9-11.9c-3.5-1.9-5.3-4.3-5.3-7.4c0-2.4 4.6-8.6 14-18.3c.2 3.8 1.9 7.6 4.9 11.2c3.1 3.6 4.6 7 4.6 10.1c0 2.6-2.1 8-6.2 16.3z"
    ]
};
var $ef0249c5e48bf4e3$export$c30a6352a2a5e8ea = {
    prefix: "fab",
    iconName: "earlybirds",
    icon: [
        480,
        512,
        [],
        "f39a",
        "M313.2 47.5c1.2-13 21.3-14 36.6-8.7.9.3 26.2 9.7 19 15.2-27.9-7.4-56.4 18.2-55.6-6.5zm-201 6.9c30.7-8.1 62 20 61.1-7.1-1.3-14.2-23.4-15.3-40.2-9.6-1 .3-28.7 10.5-20.9 16.7zM319.4 160c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16zm-159.7 0c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16zm318.5 163.2c-9.9 24-40.7 11-63.9-1.2-13.5 69.1-58.1 111.4-126.3 124.2.3.9-2-.1 24 1 33.6 1.4 63.8-3.1 97.4-8-19.8-13.8-11.4-37.1-9.8-38.1 1.4-.9 14.7 1.7 21.6 11.5 8.6-12.5 28.4-14.8 30.2-13.6 1.6 1.1 6.6 20.9-6.9 34.6 4.7-.9 8.2-1.6 9.8-2.1 2.6-.8 17.7 11.3 3.1 13.3-14.3 2.3-22.6 5.1-47.1 10.8-45.9 10.7-85.9 11.8-117.7 12.8l1 11.6c3.8 18.1-23.4 24.3-27.6 6.2.8 17.9-27.1 21.8-28.4-1l-.5 5.3c-.7 18.4-28.4 17.9-28.3-.6-7.5 13.5-28.1 6.8-26.4-8.5l1.2-12.4c-36.7.9-59.7 3.1-61.8 3.1-20.9 0-20.9-31.6 0-31.6 2.4 0 27.7 1.3 63.2 2.8-61.1-15.5-103.7-55-114.9-118.2-25 12.8-57.5 26.8-68.2.8-10.5-25.4 21.5-42.6 66.8-73.4.7-6.6 1.6-13.3 2.7-19.8-14.4-19.6-11.6-36.3-16.1-60.4-16.8 2.4-23.2-9.1-23.6-23.1.3-7.3 2.1-14.9 2.4-15.4 1.1-1.8 10.1-2 12.7-2.6 6-31.7 50.6-33.2 90.9-34.5 19.7-21.8 45.2-41.5 80.9-48.3C203.3 29 215.2 8.5 216.2 8c1.7-.8 21.2 4.3 26.3 23.2 5.2-8.8 18.3-11.4 19.6-10.7 1.1.6 6.4 15-4.9 25.9 40.3 3.5 72.2 24.7 96 50.7 36.1 1.5 71.8 5.9 77.1 34 2.7.6 11.6.8 12.7 2.6.3.5 2.1 8.1 2.4 15.4-.5 13.9-6.8 25.4-23.6 23.1-3.2 17.3-2.7 32.9-8.7 47.7 2.4 11.7 4 23.8 4.8 36.4 37 25.4 70.3 42.5 60.3 66.9zM207.4 159.9c.9-44-37.9-42.2-78.6-40.3-21.7 1-38.9 1.9-45.5 13.9-11.4 20.9 5.9 92.9 23.2 101.2 9.8 4.7 73.4 7.9 86.3-7.1 8.2-9.4 15-49.4 14.6-67.7zm52 58.3c-4.3-12.4-6-30.1-15.3-32.7-2-.5-9-.5-11 0-10 2.8-10.8 22.1-17 37.2 15.4 0 19.3 9.7 23.7 9.7 4.3 0 6.3-11.3 19.6-14.2zm135.7-84.7c-6.6-12.1-24.8-12.9-46.5-13.9-40.2-1.9-78.2-3.8-77.3 40.3-.5 18.3 5 58.3 13.2 67.8 13 14.9 76.6 11.8 86.3 7.1 15.8-7.6 36.5-78.9 24.3-101.3z"
    ]
};
var $ef0249c5e48bf4e3$export$83b68077d321f3ad = {
    prefix: "fab",
    iconName: "trade-federation",
    icon: [
        496,
        512,
        [],
        "f513",
        "M248 8.8c-137 0-248 111-248 248s111 248 248 248 248-111 248-248-111-248-248-248zm0 482.8c-129.7 0-234.8-105.1-234.8-234.8S118.3 22 248 22s234.8 105.1 234.8 234.8S377.7 491.6 248 491.6zm155.1-328.5v-46.8H209.3V198H54.2l36.7 46h117.7v196.8h48.8V245h83.3v-47h-83.3v-34.8h145.7zm-73.3 45.1v23.9h-82.9v197.4h-26.8V232.1H96.3l-20.1-23.9h143.9v-80.6h171.8V152h-145v56.2zm-161.3-69l-12.4-20.7 2.1 23.8-23.5 5.4 23.3 5.4-2.1 24 12.3-20.5 22.2 9.5-15.7-18.1 15.8-18.1zm-29.6-19.7l9.3-11.5-12.7 5.9-8-12.4 1.7 13.9-14.3 3.8 13.7 2.7-.8 14.7 6.8-12.2 13.8 5.3zm165.4 145.2l-13.1 5.6-7.3-12.2 1.3 14.2-13.9 3.2 13.9 3.2-1.2 14.2 7.3-12.2 13.1 5.5-9.4-10.7zm106.9-77.2l-20.9 9.1-12-19.6 2.2 22.7-22.3 5.4 22.2 4.9-1.8 22.9 11.5-19.6 21.2 8.8-15.1-17zM248 29.9c-125.3 0-226.9 101.6-226.9 226.9S122.7 483.7 248 483.7s226.9-101.6 226.9-226.9S373.3 29.9 248 29.9zM342.6 196v51h-83.3v195.7h-52.7V245.9H89.9l-40-49.9h157.4v-81.6h197.8v50.7H259.4V196zM248 43.2c60.3 0 114.8 25 153.6 65.2H202.5V190H45.1C73.1 104.8 153.4 43.2 248 43.2zm0 427.1c-117.9 0-213.6-95.6-213.6-213.5 0-21.2 3.1-41.8 8.9-61.1L87.1 252h114.7v196.8h64.6V253h83.3v-62.7h-83.2v-19.2h145.6v-50.8c30.8 37 49.3 84.6 49.3 136.5.1 117.9-95.5 213.5-213.4 213.5zM178.8 275l-11-21.4 1.7 24.5-23.7 3.9 23.8 5.9-3.7 23.8 13-20.9 21.5 10.8-15.8-18.8 16.9-17.1z"
    ]
};
var $ef0249c5e48bf4e3$export$2ea4e300aa12cd0a = {
    prefix: "fab",
    iconName: "autoprefixer",
    icon: [
        640,
        512,
        [],
        "f41c",
        "M318.4 16l-161 480h77.5l25.4-81.4h119.5L405 496h77.5L318.4 16zm-40.3 341.9l41.2-130.4h1.5l40.9 130.4h-83.6zM640 405l-10-31.4L462.1 358l19.4 56.5L640 405zm-462.1-47L10 373.7 0 405l158.5 9.4 19.4-56.4z"
    ]
};
var $ef0249c5e48bf4e3$export$45bdf388845cdf99 = {
    prefix: "fab",
    iconName: "whatsapp",
    icon: [
        448,
        512,
        [],
        "f232",
        "M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z"
    ]
};
var $ef0249c5e48bf4e3$export$4dcd48fd9c0bdd2d = {
    prefix: "fab",
    iconName: "slideshare",
    icon: [
        512,
        512,
        [],
        "f1e7",
        "M187.7 153.7c-34 0-61.7 25.7-61.7 57.7 0 31.7 27.7 57.7 61.7 57.7s61.7-26 61.7-57.7c0-32-27.7-57.7-61.7-57.7zm143.4 0c-34 0-61.7 25.7-61.7 57.7 0 31.7 27.7 57.7 61.7 57.7 34.3 0 61.7-26 61.7-57.7.1-32-27.4-57.7-61.7-57.7zm156.6 90l-6 4.3V49.7c0-27.4-20.6-49.7-46-49.7H76.6c-25.4 0-46 22.3-46 49.7V248c-2-1.4-4.3-2.9-6.3-4.3-15.1-10.6-25.1 4-16 17.7 18.3 22.6 53.1 50.3 106.3 72C58.3 525.1 252 555.7 248.9 457.5c0-.7.3-56.6.3-96.6 5.1 1.1 9.4 2.3 13.7 3.1 0 39.7.3 92.8.3 93.5-3.1 98.3 190.6 67.7 134.3-124 53.1-21.7 88-49.4 106.3-72 9.1-13.8-.9-28.3-16.1-17.8zm-30.5 19.2c-68.9 37.4-128.3 31.1-160.6 29.7-23.7-.9-32.6 9.1-33.7 24.9-10.3-7.7-18.6-15.5-20.3-17.1-5.1-5.4-13.7-8-27.1-7.7-31.7 1.1-89.7 7.4-157.4-28V72.3c0-34.9 8.9-45.7 40.6-45.7h317.7c30.3 0 40.9 12.9 40.9 45.7v190.6z"
    ]
};
var $ef0249c5e48bf4e3$export$cfa707f90d6b79ec = {
    prefix: "fab",
    iconName: "google-play",
    icon: [
        512,
        512,
        [],
        "f3ab",
        "M325.3 234.3L104.6 13l280.8 161.2-60.1 60.1zM47 0C34 6.8 25.3 19.2 25.3 35.3v441.3c0 16.1 8.7 28.5 21.7 35.3l256.6-256L47 0zm425.2 225.6l-58.9-34.1-65.7 64.5 65.7 64.5 60.1-34.1c18-14.3 18-46.5-1.2-60.8zM104.6 499l280.8-161.2-60.1-60.1L104.6 499z"
    ]
};
var $ef0249c5e48bf4e3$export$6f9febfcc8ac97d4 = {
    prefix: "fab",
    iconName: "viadeo",
    icon: [
        448,
        512,
        [],
        "f2a9",
        "M276.2 150.5v.7C258.3 98.6 233.6 47.8 205.4 0c43.3 29.2 67 100 70.8 150.5zm32.7 121.7c7.6 18.2 11 37.5 11 57 0 77.7-57.8 141-137.8 139.4l3.8-.3c74.2-46.7 109.3-118.6 109.3-205.1 0-38.1-6.5-75.9-18.9-112 1 11.7 1 23.7 1 35.4 0 91.8-18.1 241.6-116.6 280C95 455.2 49.4 398 49.4 329.2c0-75.6 57.4-142.3 135.4-142.3 16.8 0 33.7 3.1 49.1 9.6 1.7-15.1 6.5-29.9 13.4-43.3-19.9-7.2-41.2-10.7-62.5-10.7-161.5 0-238.7 195.9-129.9 313.7 67.9 74.6 192 73.9 259.8 0 56.6-61.3 60.9-142.4 36.4-201-12.7 8-27.1 13.9-42.2 17zM418.1 11.7c-31 66.5-81.3 47.2-115.8 80.1-12.4 12-20.6 34-20.6 50.5 0 14.1 4.5 27.1 12 38.8 47.4-11 98.3-46 118.2-90.7-.7 5.5-4.8 14.4-7.2 19.2-20.3 35.7-64.6 65.6-99.7 84.9 14.8 14.4 33.7 25.8 55 25.8 79 0 110.1-134.6 58.1-208.6z"
    ]
};
var $ef0249c5e48bf4e3$export$c5b04bbf0f48913a = {
    prefix: "fab",
    iconName: "line",
    icon: [
        512,
        512,
        [],
        "f3c0",
        "M311 196.8v81.3c0 2.1-1.6 3.7-3.7 3.7h-13c-1.3 0-2.4-.7-3-1.5l-37.3-50.3v48.2c0 2.1-1.6 3.7-3.7 3.7h-13c-2.1 0-3.7-1.6-3.7-3.7V196.9c0-2.1 1.6-3.7 3.7-3.7h12.9c1.1 0 2.4 .6 3 1.6l37.3 50.3V196.9c0-2.1 1.6-3.7 3.7-3.7h13c2.1-.1 3.8 1.6 3.8 3.5zm-93.7-3.7h-13c-2.1 0-3.7 1.6-3.7 3.7v81.3c0 2.1 1.6 3.7 3.7 3.7h13c2.1 0 3.7-1.6 3.7-3.7V196.8c0-1.9-1.6-3.7-3.7-3.7zm-31.4 68.1H150.3V196.8c0-2.1-1.6-3.7-3.7-3.7h-13c-2.1 0-3.7 1.6-3.7 3.7v81.3c0 1 .3 1.8 1 2.5c.7 .6 1.5 1 2.5 1h52.2c2.1 0 3.7-1.6 3.7-3.7v-13c0-1.9-1.6-3.7-3.5-3.7zm193.7-68.1H327.3c-1.9 0-3.7 1.6-3.7 3.7v81.3c0 1.9 1.6 3.7 3.7 3.7h52.2c2.1 0 3.7-1.6 3.7-3.7V265c0-2.1-1.6-3.7-3.7-3.7H344V247.7h35.5c2.1 0 3.7-1.6 3.7-3.7V230.9c0-2.1-1.6-3.7-3.7-3.7H344V213.5h35.5c2.1 0 3.7-1.6 3.7-3.7v-13c-.1-1.9-1.7-3.7-3.7-3.7zM512 93.4V419.4c-.1 51.2-42.1 92.7-93.4 92.6H92.6C41.4 511.9-.1 469.8 0 418.6V92.6C.1 41.4 42.2-.1 93.4 0H419.4c51.2 .1 92.7 42.1 92.6 93.4zM441.6 233.5c0-83.4-83.7-151.3-186.4-151.3s-186.4 67.9-186.4 151.3c0 74.7 66.3 137.4 155.9 149.3c21.8 4.7 19.3 12.7 14.4 42.1c-.8 4.7-3.8 18.4 16.1 10.1s107.3-63.2 146.5-108.2c27-29.7 39.9-59.8 39.9-93.1z"
    ]
};
var $ef0249c5e48bf4e3$export$631c05505a17faa8 = {
    prefix: "fab",
    iconName: "google-drive",
    icon: [
        512,
        512,
        [],
        "f3aa",
        "M339 314.9L175.4 32h161.2l163.6 282.9H339zm-137.5 23.6L120.9 480h310.5L512 338.5H201.5zM154.1 67.4L0 338.5 80.6 480 237 208.8 154.1 67.4z"
    ]
};
var $ef0249c5e48bf4e3$export$c2417738aeefe7e6 = {
    prefix: "fab",
    iconName: "servicestack",
    icon: [
        496,
        512,
        [],
        "f3ec",
        "M88 216c81.7 10.2 273.7 102.3 304 232H0c99.5-8.1 184.5-137 88-232zm32-152c32.3 35.6 47.7 83.9 46.4 133.6C249.3 231.3 373.7 321.3 400 448h96C455.3 231.9 222.8 79.5 120 64z"
    ]
};
var $ef0249c5e48bf4e3$export$8b48c2e6e01a12e0 = {
    prefix: "fab",
    iconName: "simplybuilt",
    icon: [
        512,
        512,
        [],
        "f215",
        "M481.2 64h-106c-14.5 0-26.6 11.8-26.6 26.3v39.6H163.3V90.3c0-14.5-12-26.3-26.6-26.3h-106C16.1 64 4.3 75.8 4.3 90.3v331.4c0 14.5 11.8 26.3 26.6 26.3h450.4c14.8 0 26.6-11.8 26.6-26.3V90.3c-.2-14.5-12-26.3-26.7-26.3zM149.8 355.8c-36.6 0-66.4-29.7-66.4-66.4 0-36.9 29.7-66.6 66.4-66.6 36.9 0 66.6 29.7 66.6 66.6 0 36.7-29.7 66.4-66.6 66.4zm212.4 0c-36.9 0-66.6-29.7-66.6-66.6 0-36.6 29.7-66.4 66.6-66.4 36.6 0 66.4 29.7 66.4 66.4 0 36.9-29.8 66.6-66.4 66.6z"
    ]
};
var $ef0249c5e48bf4e3$export$de75f8fcf71dfed9 = {
    prefix: "fab",
    iconName: "bitbucket",
    icon: [
        512,
        512,
        [
            61810
        ],
        "f171",
        "M22.2 32A16 16 0 0 0 6 47.8a26.35 26.35 0 0 0 .2 2.8l67.9 412.1a21.77 21.77 0 0 0 21.3 18.2h325.7a16 16 0 0 0 16-13.4L505 50.7a16 16 0 0 0-13.2-18.3 24.58 24.58 0 0 0-2.8-.2L22.2 32zm285.9 297.8h-104l-28.1-147h157.3l-25.2 147z"
    ]
};
var $ef0249c5e48bf4e3$export$c85bcd118a7a17ff = {
    prefix: "fab",
    iconName: "imdb",
    icon: [
        448,
        512,
        [],
        "f2d8",
        "M89.5 323.6H53.93V186.2H89.5V323.6zM156.1 250.5L165.2 186.2H211.5V323.6H180.5V230.9L167.1 323.6H145.8L132.8 232.9L132.7 323.6H101.5V186.2H147.6C148.1 194.5 150.4 204.3 151.9 215.6L156.1 250.5zM223.7 323.6V186.2H250.3C267.3 186.2 277.3 187.1 283.3 188.6C289.4 190.3 294 192.8 297.2 196.5C300.3 199.8 302.3 203.1 303 208.5C303.9 212.9 304.4 221.6 304.4 234.7V282.9C304.4 295.2 303.7 303.4 302.5 307.6C301.4 311.7 299.4 315 296.5 317.3C293.7 319.7 290.1 321.4 285.8 322.3C281.6 323.1 275.2 323.6 266.7 323.6H223.7zM259.2 209.7V299.1C264.3 299.1 267.5 298.1 268.6 296.8C269.7 294.8 270.4 289.2 270.4 280.1V226.8C270.4 220.6 270.3 216.6 269.7 214.8C269.4 213 268.5 211.8 267.1 210.1C265.7 210.1 263 209.7 259.2 209.7V209.7zM316.5 323.6V186.2H350.6V230.1C353.5 227.7 356.7 225.2 360.1 223.5C363.7 222 368.9 221.1 372.9 221.1C377.7 221.1 381.8 221.9 385.2 223.3C388.6 224.8 391.2 226.8 393.2 229.5C394.9 232.1 395.9 234.8 396.3 237.3C396.7 239.9 396.1 245.3 396.1 253.5V292.1C396.1 300.3 396.3 306.4 395.3 310.5C394.2 314.5 391.5 318.1 387.5 320.1C383.4 324 378.6 325.4 372.9 325.4C368.9 325.4 363.7 324.5 360.2 322.9C356.7 321.1 353.5 318.4 350.6 314.9L348.5 323.6L316.5 323.6zM361.6 302.9C362.3 301.1 362.6 296.9 362.6 290.4V255C362.6 249.4 362.3 245.5 361.5 243.8C360.8 241.9 357.8 241.1 355.7 241.1C353.7 241.1 352.3 241.9 351.6 243.4C351 244.9 350.6 248.8 350.6 255V291.4C350.6 297.5 351 301.4 351.8 303C352.4 304.7 353.9 305.5 355.9 305.5C358.1 305.5 360.1 304.7 361.6 302.9L361.6 302.9zM418.4 32.04C434.1 33.27 447.1 47.28 447.1 63.92V448.1C447.1 464.5 435.2 478.5 418.9 479.1C418.6 479.1 418.4 480 418.1 480H29.88C29.6 480 29.32 479.1 29.04 479.9C13.31 478.5 1.093 466.1 0 449.7L.0186 61.78C1.081 45.88 13.82 33.09 30.26 31.1H417.7C417.9 31.1 418.2 32.01 418.4 32.04L418.4 32.04zM30.27 41.26C19 42.01 10.02 51.01 9.257 62.4V449.7C9.63 455.1 11.91 460.2 15.7 464C19.48 467.9 24.51 470.3 29.89 470.7H418.1C429.6 469.7 438.7 459.1 438.7 448.1V63.91C438.7 58.17 436.6 52.65 432.7 48.45C428.8 44.24 423.4 41.67 417.7 41.26L30.27 41.26z"
    ]
};
var $ef0249c5e48bf4e3$export$17ab471305a2654c = {
    prefix: "fab",
    iconName: "deezer",
    icon: [
        576,
        512,
        [],
        "e077",
        "M451.46,244.71H576V172H451.46Zm0-173.89v72.67H576V70.82Zm0,275.06H576V273.2H451.46ZM0,447.09H124.54V374.42H0Zm150.47,0H275V374.42H150.47Zm150.52,0H425.53V374.42H301Zm150.47,0H576V374.42H451.46ZM301,345.88H425.53V273.2H301Zm-150.52,0H275V273.2H150.47Zm0-101.17H275V172H150.47Z"
    ]
};
var $ef0249c5e48bf4e3$export$910e018904f54b08 = {
    prefix: "fab",
    iconName: "raspberry-pi",
    icon: [
        407,
        512,
        [],
        "f7bb",
        "M372 232.5l-3.7-6.5c.1-46.4-21.4-65.3-46.5-79.7 7.6-2 15.4-3.6 17.6-13.2 13.1-3.3 15.8-9.4 17.1-15.8 3.4-2.3 14.8-8.7 13.6-19.7 6.4-4.4 10-10.1 8.1-18.1 6.9-7.5 8.7-13.7 5.8-19.4 8.3-10.3 4.6-15.6 1.1-20.9 6.2-11.2.7-23.2-16.6-21.2-6.9-10.1-21.9-7.8-24.2-7.8-2.6-3.2-6-6-16.5-4.7-6.8-6.1-14.4-5-22.3-2.1-9.3-7.3-15.5-1.4-22.6.8C271.6.6 269 5.5 263.5 7.6c-12.3-2.6-16.1 3-22 8.9l-6.9-.1c-18.6 10.8-27.8 32.8-31.1 44.1-3.3-11.3-12.5-33.3-31.1-44.1l-6.9.1c-5.9-5.9-9.7-11.5-22-8.9-5.6-2-8.1-7-19.4-3.4-4.6-1.4-8.9-4.4-13.9-4.3-2.6.1-5.5 1-8.7 3.5-7.9-3-15.5-4-22.3 2.1-10.5-1.3-14 1.4-16.5 4.7-2.3 0-17.3-2.3-24.2 7.8C21.2 16 15.8 28 22 39.2c-3.5 5.4-7.2 10.7 1.1 20.9-2.9 5.7-1.1 11.9 5.8 19.4-1.8 8 1.8 13.7 8.1 18.1-1.2 11 10.2 17.4 13.6 19.7 1.3 6.4 4 12.4 17.1 15.8 2.2 9.5 10 11.2 17.6 13.2-25.1 14.4-46.6 33.3-46.5 79.7l-3.7 6.5c-28.8 17.2-54.7 72.7-14.2 117.7 2.6 14.1 7.1 24.2 11 35.4 5.9 45.2 44.5 66.3 54.6 68.8 14.9 11.2 30.8 21.8 52.2 29.2C159 504.2 181 512 203 512h1c22.1 0 44-7.8 64.2-28.4 21.5-7.4 37.3-18 52.2-29.2 10.2-2.5 48.7-23.6 54.6-68.8 3.9-11.2 8.4-21.3 11-35.4 40.6-45.1 14.7-100.5-14-117.7zm-22.2-8c-1.5 18.7-98.9-65.1-82.1-67.9 45.7-7.5 83.6 19.2 82.1 67.9zm-43 93.1c-24.5 15.8-59.8 5.6-78.8-22.8s-14.6-64.2 9.9-80c24.5-15.8 59.8-5.6 78.8 22.8s14.6 64.2-9.9 80zM238.9 29.3c.8 4.2 1.8 6.8 2.9 7.6 5.4-5.8 9.8-11.7 16.8-17.3 0 3.3-1.7 6.8 2.5 9.4 3.7-5 8.8-9.5 15.5-13.3-3.2 5.6-.6 7.3 1.2 9.6 5.1-4.4 10-8.8 19.4-12.3-2.6 3.1-6.2 6.2-2.4 9.8 5.3-3.3 10.6-6.6 23.1-8.9-2.8 3.1-8.7 6.3-5.1 9.4 6.6-2.5 14-4.4 22.1-5.4-3.9 3.2-7.1 6.3-3.9 8.8 7.1-2.2 16.9-5.1 26.4-2.6l-6 6.1c-.7.8 14.1.6 23.9.8-3.6 5-7.2 9.7-9.3 18.2 1 1 5.8.4 10.4 0-4.7 9.9-12.8 12.3-14.7 16.6 2.9 2.2 6.8 1.6 11.2.1-3.4 6.9-10.4 11.7-16 17.3 1.4 1 3.9 1.6 9.7.9-5.2 5.5-11.4 10.5-18.8 15 1.3 1.5 5.8 1.5 10 1.6-6.7 6.5-15.3 9.9-23.4 14.2 4 2.7 6.9 2.1 10 2.1-5.7 4.7-15.4 7.1-24.4 10 1.7 2.7 3.4 3.4 7.1 4.1-9.5 5.3-23.2 2.9-27 5.6.9 2.7 3.6 4.4 6.7 5.8-15.4.9-57.3-.6-65.4-32.3 15.7-17.3 44.4-37.5 93.7-62.6-38.4 12.8-73 30-102 53.5-34.3-15.9-10.8-55.9 5.8-71.8zm-34.4 114.6c24.2-.3 54.1 17.8 54 34.7-.1 15-21 27.1-53.8 26.9-32.1-.4-53.7-15.2-53.6-29.8 0-11.9 26.2-32.5 53.4-31.8zm-123-12.8c3.7-.7 5.4-1.5 7.1-4.1-9-2.8-18.7-5.3-24.4-10 3.1 0 6 .7 10-2.1-8.1-4.3-16.7-7.7-23.4-14.2 4.2-.1 8.7 0 10-1.6-7.4-4.5-13.6-9.5-18.8-15 5.8.7 8.3.1 9.7-.9-5.6-5.6-12.7-10.4-16-17.3 4.3 1.5 8.3 2 11.2-.1-1.9-4.2-10-6.7-14.7-16.6 4.6.4 9.4 1 10.4 0-2.1-8.5-5.8-13.3-9.3-18.2 9.8-.1 24.6 0 23.9-.8l-6-6.1c9.5-2.5 19.3.4 26.4 2.6 3.2-2.5-.1-5.6-3.9-8.8 8.1 1.1 15.4 2.9 22.1 5.4 3.5-3.1-2.3-6.3-5.1-9.4 12.5 2.3 17.8 5.6 23.1 8.9 3.8-3.6.2-6.7-2.4-9.8 9.4 3.4 14.3 7.9 19.4 12.3 1.7-2.3 4.4-4 1.2-9.6 6.7 3.8 11.8 8.3 15.5 13.3 4.1-2.6 2.5-6.2 2.5-9.4 7 5.6 11.4 11.5 16.8 17.3 1.1-.8 2-3.4 2.9-7.6 16.6 15.9 40.1 55.9 6 71.8-29-23.5-63.6-40.7-102-53.5 49.3 25 78 45.3 93.7 62.6-8 31.8-50 33.2-65.4 32.3 3.1-1.4 5.8-3.2 6.7-5.8-4-2.8-17.6-.4-27.2-5.6zm60.1 24.1c16.8 2.8-80.6 86.5-82.1 67.9-1.5-48.7 36.5-75.5 82.1-67.9zM38.2 342c-23.7-18.8-31.3-73.7 12.6-98.3 26.5-7 9 107.8-12.6 98.3zm91 98.2c-13.3 7.9-45.8 4.7-68.8-27.9-15.5-27.4-13.5-55.2-2.6-63.4 16.3-9.8 41.5 3.4 60.9 25.6 16.9 20 24.6 55.3 10.5 65.7zm-26.4-119.7c-24.5-15.8-28.9-51.6-9.9-80s54.3-38.6 78.8-22.8 28.9 51.6 9.9 80c-19.1 28.4-54.4 38.6-78.8 22.8zM205 496c-29.4 1.2-58.2-23.7-57.8-32.3-.4-12.7 35.8-22.6 59.3-22 23.7-1 55.6 7.5 55.7 18.9.5 11-28.8 35.9-57.2 35.4zm58.9-124.9c.2 29.7-26.2 53.8-58.8 54-32.6.2-59.2-23.8-59.4-53.4v-.6c-.2-29.7 26.2-53.8 58.8-54 32.6-.2 59.2 23.8 59.4 53.4v.6zm82.2 42.7c-25.3 34.6-59.6 35.9-72.3 26.3-13.3-12.4-3.2-50.9 15.1-72 20.9-23.3 43.3-38.5 58.9-26.6 10.5 10.3 16.7 49.1-1.7 72.3zm22.9-73.2c-21.5 9.4-39-105.3-12.6-98.3 43.9 24.7 36.3 79.6 12.6 98.3z"
    ]
};
var $ef0249c5e48bf4e3$export$78c2aea9064d90bd = {
    prefix: "fab",
    iconName: "jira",
    icon: [
        496,
        512,
        [],
        "f7b1",
        "M490 241.7C417.1 169 320.6 71.8 248.5 0 83 164.9 6 241.7 6 241.7c-7.9 7.9-7.9 20.7 0 28.7C138.8 402.7 67.8 331.9 248.5 512c379.4-378 15.7-16.7 241.5-241.7 8-7.9 8-20.7 0-28.6zm-241.5 90l-76-75.7 76-75.7 76 75.7-76 75.7z"
    ]
};
var $ef0249c5e48bf4e3$export$b29e4ebead927988 = {
    prefix: "fab",
    iconName: "docker",
    icon: [
        640,
        512,
        [],
        "f395",
        "M349.9 236.3h-66.1v-59.4h66.1v59.4zm0-204.3h-66.1v60.7h66.1V32zm78.2 144.8H362v59.4h66.1v-59.4zm-156.3-72.1h-66.1v60.1h66.1v-60.1zm78.1 0h-66.1v60.1h66.1v-60.1zm276.8 100c-14.4-9.7-47.6-13.2-73.1-8.4-3.3-24-16.7-44.9-41.1-63.7l-14-9.3-9.3 14c-18.4 27.8-23.4 73.6-3.7 103.8-8.7 4.7-25.8 11.1-48.4 10.7H2.4c-8.7 50.8 5.8 116.8 44 162.1 37.1 43.9 92.7 66.2 165.4 66.2 157.4 0 273.9-72.5 328.4-204.2 21.4.4 67.6.1 91.3-45.2 1.5-2.5 6.6-13.2 8.5-17.1l-13.3-8.9zm-511.1-27.9h-66v59.4h66.1v-59.4zm78.1 0h-66.1v59.4h66.1v-59.4zm78.1 0h-66.1v59.4h66.1v-59.4zm-78.1-72.1h-66.1v60.1h66.1v-60.1z"
    ]
};
var $ef0249c5e48bf4e3$export$63c4c3c3c5975c3e = {
    prefix: "fab",
    iconName: "screenpal",
    icon: [
        512,
        512,
        [],
        "e570",
        "M233.5 22.49C233.5 10.07 243.6 0 256 0C268.4 0 278.5 10.07 278.5 22.49C278.5 34.91 268.4 44.98 256 44.98C243.6 44.98 233.5 34.91 233.5 22.49zM313.4 259C313.4 290.7 287.7 316.4 256 316.4C224.3 316.4 198.6 290.7 198.6 259C198.6 227.3 224.3 201.6 256 201.6C287.7 201.6 313.4 227.3 313.4 259zM337.2 350C359.5 330.1 373.7 302.7 377.1 273H496.6C493.1 334.4 466.2 392.2 421.4 434.4C376.7 476.6 317.5 500.2 256 500.2C194.5 500.2 135.3 476.6 90.56 434.4C45.83 392.2 18.94 334.4 15.39 273H135.1C138.5 302.7 152.7 330.1 175 350C197.3 369.9 226.2 380.9 256.1 380.9C285.1 380.9 314.8 369.9 337.2 350zM73.14 140.3C73.54 152.7 63.81 163.1 51.39 163.5C38.97 163.9 28.59 154.2 28.18 141.8C27.78 129.3 37.52 118.9 49.94 118.5C62.35 118.1 72.74 127.9 73.14 140.3zM438.9 141C438.9 128.6 448.9 118.5 461.4 118.5C473.8 118.5 483.8 128.6 483.8 141C483.8 153.5 473.8 163.5 461.4 163.5C448.9 163.5 438.9 153.5 438.9 141zM317.9 95.27C300.6 109.1 278.7 118.1 256 118.1C233.3 118.1 211.4 109.1 194.1 95.27C176.8 80.55 165.3 60.18 161.7 37.78C176.8 31.37 192.5 26.52 208.6 23.31C208.6 35.88 213.6 47.93 222.5 56.82C231.4 65.7 243.4 70.7 256 70.7C268.6 70.7 280.6 65.7 289.5 56.82C298.4 47.93 303.4 35.88 303.4 23.31C319.5 26.52 335.2 31.37 350.3 37.78C346.7 60.18 335.2 80.55 317.9 95.27H317.9zM82.78 231C61.42 238.6 38.06 238.4 16.86 230.4C18.82 214.1 22.46 198.1 27.71 182.5C33.1 185.6 39.05 187.6 45.22 188.5C51.39 189.3 57.67 188.9 63.68 187.3C69.69 185.6 75.33 182.9 80.27 179.1C85.21 175.3 89.36 170.6 92.47 165.2C95.58 159.8 97.61 153.8 98.42 147.7C99.23 141.5 98.83 135.2 97.22 129.2C95.61 123.2 92.83 117.6 89.04 112.6C85.25 107.7 80.53 103.5 75.14 100.4C85.96 88.11 98.01 76.94 111.1 67.07C128.7 81.42 140.6 101.6 144.7 123.9C148.8 146.2 144.8 169.3 133.5 188.9C122.1 208.5 104.1 223.4 82.78 231V231zM429.2 231.1C407.9 223.5 389.9 208.5 378.5 188.9C367.2 169.3 363.3 146.2 367.4 123.9C371.5 101.7 383.4 81.54 400.9 67.19C414 77.04 426.1 88.21 436.9 100.5C426.2 106.9 418.5 117.2 415.4 129.3C412.2 141.3 413.1 154.1 420.2 164.9C426.4 175.7 436.6 183.6 448.6 186.9C460.6 190.2 473.5 188.6 484.3 182.6C489.6 198.1 493.2 214.2 495.2 230.4C473.1 238.5 450.6 238.7 429.2 231.1L429.2 231.1z"
    ]
};
var $ef0249c5e48bf4e3$export$f77d9ddfdff1e2a7 = {
    prefix: "fab",
    iconName: "bluetooth",
    icon: [
        448,
        512,
        [],
        "f293",
        "M292.6 171.1L249.7 214l-.3-86 43.2 43.1m-43.2 219.8l43.1-43.1-42.9-42.9-.2 86zM416 259.4C416 465 344.1 512 230.9 512S32 465 32 259.4 115.4 0 228.6 0 416 53.9 416 259.4zm-158.5 0l79.4-88.6L211.8 36.5v176.9L138 139.6l-27 26.9 92.7 93-92.7 93 26.9 26.9 73.8-73.8 2.3 170 127.4-127.5-83.9-88.7z"
    ]
};
var $ef0249c5e48bf4e3$export$56aff378d7858517 = {
    prefix: "fab",
    iconName: "gitter",
    icon: [
        384,
        512,
        [],
        "f426",
        "M66.4 322.5H16V0h50.4v322.5zM166.9 76.1h-50.4V512h50.4V76.1zm100.6 0h-50.4V512h50.4V76.1zM368 76h-50.4v247H368V76z"
    ]
};
var $ef0249c5e48bf4e3$export$8fb5b89b3d7583de = {
    prefix: "fab",
    iconName: "d-and-d",
    icon: [
        576,
        512,
        [],
        "f38d",
        "M82.5 98.9c-.6-17.2 2-33.8 12.7-48.2.3 7.4 1.2 14.5 4.2 21.6 5.9-27.5 19.7-49.3 42.3-65.5-1.9 5.9-3.5 11.8-3 17.7 8.7-7.4 18.8-17.8 44.4-22.7 14.7-2.8 29.7-2 42.1 1 38.5 9.3 61 34.3 69.7 72.3 5.3 23.1.7 45-8.3 66.4-5.2 12.4-12 24.4-20.7 35.1-2-1.9-3.9-3.8-5.8-5.6-42.8-40.8-26.8-25.2-37.4-37.4-1.1-1.2-1-2.2-.1-3.6 8.3-13.5 11.8-28.2 10-44-1.1-9.8-4.3-18.9-11.3-26.2-14.5-15.3-39.2-15-53.5.6-11.4 12.5-14.1 27.4-10.9 43.6.2 1.3.4 2.7 0 3.9-3.4 13.7-4.6 27.6-2.5 41.6.1.5.1 1.1.1 1.6 0 .3-.1.5-.2 1.1-21.8-11-36-28.3-43.2-52.2-8.3 17.8-11.1 35.5-6.6 54.1-15.6-15.2-21.3-34.3-22-55.2zm469.6 123.2c-11.6-11.6-25-20.4-40.1-26.6-12.8-5.2-26-7.9-39.9-7.1-10 .6-19.6 3.1-29 6.4-2.5.9-5.1 1.6-7.7 2.2-4.9 1.2-7.3-3.1-4.7-6.8 3.2-4.6 3.4-4.2 15-12 .6-.4 1.2-.8 2.2-1.5h-2.5c-.6 0-1.2.2-1.9.3-19.3 3.3-30.7 15.5-48.9 29.6-10.4 8.1-13.8 3.8-12-.5 1.4-3.5 3.3-6.7 5.1-10 1-1.8 2.3-3.4 3.5-5.1-.2-.2-.5-.3-.7-.5-27 18.3-46.7 42.4-57.7 73.3.3.3.7.6 1 .9.3-.6.5-1.2.9-1.7 10.4-12.1 22.8-21.8 36.6-29.8 18.2-10.6 37.5-18.3 58.7-20.2 4.3-.4 8.7-.1 13.1-.1-1.8.7-3.5.9-5.3 1.1-18.5 2.4-35.5 9-51.5 18.5-30.2 17.9-54.5 42.2-75.1 70.4-.3.4-.4.9-.7 1.3 14.5 5.3 24 17.3 36.1 25.6.2-.1.3-.2.4-.4l1.2-2.7c12.2-26.9 27-52.3 46.7-74.5 16.7-18.8 38-25.3 62.5-20 5.9 1.3 11.4 4.4 17.2 6.8 2.3-1.4 5.1-3.2 8-4.7 8.4-4.3 17.4-7 26.7-9 14.7-3.1 29.5-4.9 44.5-1.3v-.5c-.5-.4-1.2-.8-1.7-1.4zM316.7 397.6c-39.4-33-22.8-19.5-42.7-35.6-.8.9 0-.2-1.9 3-11.2 19.1-25.5 35.3-44 47.6-10.3 6.8-21.5 11.8-34.1 11.8-21.6 0-38.2-9.5-49.4-27.8-12-19.5-13.3-40.7-8.2-62.6 7.8-33.8 30.1-55.2 38.6-64.3-18.7-6.2-33 1.7-46.4 13.9.8-13.9 4.3-26.2 11.8-37.3-24.3 10.6-45.9 25-64.8 43.9-.3-5.8 5.4-43.7 5.6-44.7.3-2.7-.6-5.3-3-7.4-24.2 24.7-44.5 51.8-56.1 84.6 7.4-5.9 14.9-11.4 23.6-16.2-8.3 22.3-19.6 52.8-7.8 101.1 4.6 19 11.9 36.8 24.1 52.3 2.9 3.7 6.3 6.9 9.5 10.3.2-.2.4-.3.6-.5-1.4-7-2.2-14.1-1.5-21.9 2.2 3.2 3.9 6 5.9 8.6 12.6 16 28.7 27.4 47.2 35.6 25 11.3 51.1 13.3 77.9 8.6 54.9-9.7 90.7-48.6 116-98.8 1-1.8.6-2.9-.9-4.2zm172-46.4c-9.5-3.1-22.2-4.2-28.7-2.9 9.9 4 14.1 6.6 18.8 12 12.6 14.4 10.4 34.7-5.4 45.6-11.7 8.1-24.9 10.5-38.9 9.1-1.2-.1-2.3-.4-3-.6 2.8-3.7 6-7 8.1-10.8 9.4-16.8 5.4-42.1-8.7-56.1-2.1-2.1-4.6-3.9-7-5.9-.3 1.3-.1 2.1.1 2.8 4.2 16.6-8.1 32.4-24.8 31.8-7.6-.3-13.9-3.8-19.6-8.5-19.5-16.1-39.1-32.1-58.5-48.3-5.9-4.9-12.5-8.1-20.1-8.7-4.6-.4-9.3-.6-13.9-.9-5.9-.4-8.8-2.8-10.4-8.4-.9-3.4-1.5-6.8-2.2-10.2-1.5-8.1-6.2-13-14.3-14.2-4.4-.7-8.9-1-13.3-1.5-13-1.4-19.8-7.4-22.6-20.3-5 11-1.6 22.4 7.3 29.9 4.5 3.8 9.3 7.3 13.8 11.2 4.6 3.8 7.4 8.7 7.9 14.8.4 4.7.8 9.5 1.8 14.1 2.2 10.6 8.9 18.4 17 25.1 16.5 13.7 33 27.3 49.5 41.1 17.9 15 13.9 32.8 13 56-.9 22.9 12.2 42.9 33.5 51.2 1 .4 2 .6 3.6 1.1-15.7-18.2-10.1-44.1.7-52.3.3 2.2.4 4.3.9 6.4 9.4 44.1 45.4 64.2 85 56.9 16-2.9 30.6-8.9 42.9-19.8 2-1.8 3.7-4.1 5.9-6.5-19.3 4.6-35.8.1-50.9-10.6.7-.3 1.3-.3 1.9-.3 21.3 1.8 40.6-3.4 57-17.4 19.5-16.6 26.6-42.9 17.4-66-8.3-20.1-23.6-32.3-43.8-38.9zM99.4 179.3c-5.3-9.2-13.2-15.6-22.1-21.3 13.7-.5 26.6.2 39.6 3.7-7-12.2-8.5-24.7-5-38.7 5.3 11.9 13.7 20.1 23.6 26.8 19.7 13.2 35.7 19.6 46.7 30.2 3.4 3.3 6.3 7.1 9.6 10.9-.8-2.1-1.4-4.1-2.2-6-5-10.6-13-18.6-22.6-25-1.8-1.2-2.8-2.5-3.4-4.5-3.3-12.5-3-25.1-.7-37.6 1-5.5 2.8-10.9 4.5-16.3.8-2.4 2.3-4.6 4-6.6.6 6.9 0 25.5 19.6 46 10.8 11.3 22.4 21.9 33.9 32.7 9 8.5 18.3 16.7 25.5 26.8 1.1 1.6 2.2 3.3 3.8 4.7-5-13-14.2-24.1-24.2-33.8-9.6-9.3-19.4-18.4-29.2-27.4-3.3-3-4.6-6.7-5.1-10.9-1.2-10.4 0-20.6 4.3-30.2.5-1 1.1-2 1.9-3.3.5 4.2.6 7.9 1.4 11.6 4.8 23.1 20.4 36.3 49.3 63.5 10 9.4 19.3 19.2 25.6 31.6 4.8 9.3 7.3 19 5.7 29.6-.1.6.5 1.7 1.1 2 6.2 2.6 10 6.9 9.7 14.3 7.7-2.6 12.5-8 16.4-14.5 4.2 20.2-9.1 50.3-27.2 58.7.4-4.5 5-23.4-16.5-27.7-6.8-1.3-12.8-1.3-22.9-2.1 4.7-9 10.4-20.6.5-22.4-24.9-4.6-52.8 1.9-57.8 4.6 8.2.4 16.3 1 23.5 3.3-2 6.5-4 12.7-5.8 18.9-1.9 6.5 2.1 14.6 9.3 9.6 1.2-.9 2.3-1.9 3.3-2.7-3.1 17.9-2.9 15.9-2.8 18.3.3 10.2 9.5 7.8 15.7 7.3-2.5 11.8-29.5 27.3-45.4 25.8 7-4.7 12.7-10.3 15.9-17.9-6.5.8-12.9 1.6-19.2 2.4l-.3-.9c4.7-3.4 8-7.8 10.2-13.1 8.7-21.1-3.6-38-25-39.9-9.1-.8-17.8.8-25.9 5.5 6.2-15.6 17.2-26.6 32.6-34.5-15.2-4.3-8.9-2.7-24.6-6.3 14.6-9.3 30.2-13.2 46.5-14.6-5.2-3.2-48.1-3.6-70.2 20.9 7.9 1.4 15.5 2.8 23.2 4.2-23.8 7-44 19.7-62.4 35.6 1.1-4.8 2.7-9.5 3.3-14.3.6-4.5.8-9.2.1-13.6-1.5-9.4-8.9-15.1-19.7-16.3-7.9-.9-15.6.1-23.3 1.3-.9.1-1.7.3-2.9 0 15.8-14.8 36-21.7 53.1-33.5 6-4.5 6.8-8.2 3-14.9zm128.4 26.8c3.3 16 12.6 25.5 23.8 24.3-4.6-11.3-12.1-19.5-23.8-24.3z"
    ]
};
var $ef0249c5e48bf4e3$export$d5808a1a9747be4c = {
    prefix: "fab",
    iconName: "microblog",
    icon: [
        448,
        512,
        [],
        "e01a",
        "M399.36,362.23c29.49-34.69,47.1-78.34,47.1-125.79C446.46,123.49,346.86,32,224,32S1.54,123.49,1.54,236.44,101.14,440.87,224,440.87a239.28,239.28,0,0,0,79.44-13.44,7.18,7.18,0,0,1,8.12,2.56c18.58,25.09,47.61,42.74,79.89,49.92a4.42,4.42,0,0,0,5.22-3.43,4.37,4.37,0,0,0-.85-3.62,87,87,0,0,1,3.69-110.69ZM329.52,212.4l-57.3,43.49L293,324.75a6.5,6.5,0,0,1-9.94,7.22L224,290.92,164.94,332a6.51,6.51,0,0,1-9.95-7.22l20.79-68.86-57.3-43.49a6.5,6.5,0,0,1,3.8-11.68l71.88-1.51,23.66-67.92a6.5,6.5,0,0,1,12.28,0l23.66,67.92,71.88,1.51a6.5,6.5,0,0,1,3.88,11.68Z"
    ]
};
var $ef0249c5e48bf4e3$export$e24e559a44f492e1 = {
    prefix: "fab",
    iconName: "cc-diners-club",
    icon: [
        576,
        512,
        [],
        "f24c",
        "M239.7 79.9c-96.9 0-175.8 78.6-175.8 175.8 0 96.9 78.9 175.8 175.8 175.8 97.2 0 175.8-78.9 175.8-175.8 0-97.2-78.6-175.8-175.8-175.8zm-39.9 279.6c-41.7-15.9-71.4-56.4-71.4-103.8s29.7-87.9 71.4-104.1v207.9zm79.8.3V151.6c41.7 16.2 71.4 56.7 71.4 104.1s-29.7 87.9-71.4 104.1zM528 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM329.7 448h-90.3c-106.2 0-193.8-85.5-193.8-190.2C45.6 143.2 133.2 64 239.4 64h90.3c105 0 200.7 79.2 200.7 193.8 0 104.7-95.7 190.2-200.7 190.2z"
    ]
};
var $ef0249c5e48bf4e3$export$6d2eed3a88c7ed1a = {
    prefix: "fab",
    iconName: "gg-circle",
    icon: [
        512,
        512,
        [],
        "f261",
        "M257 8C120 8 9 119 9 256s111 248 248 248 248-111 248-248S394 8 257 8zm-49.5 374.8L81.8 257.1l125.7-125.7 35.2 35.4-24.2 24.2-11.1-11.1-77.2 77.2 77.2 77.2 26.6-26.6-53.1-52.9 24.4-24.4 77.2 77.2-75 75.2zm99-2.2l-35.2-35.2 24.1-24.4 11.1 11.1 77.2-77.2-77.2-77.2-26.5 26.5 53.1 52.9-24.4 24.4-77.2-77.2 75-75L432.2 255 306.5 380.6z"
    ]
};
var $ef0249c5e48bf4e3$export$238a02799aabf743 = {
    prefix: "fab",
    iconName: "pied-piper-hat",
    icon: [
        640,
        512,
        [],
        "f4e5",
        "M640 24.9c-80.8 53.6-89.4 92.5-96.4 104.4-6.7 12.2-11.7 60.3-23.3 83.6-11.7 23.6-54.2 42.2-66.1 50-11.7 7.8-28.3 38.1-41.9 64.2-108.1-4.4-167.4 38.8-259.2 93.6 29.4-9.7 43.3-16.7 43.3-16.7 94.2-36 139.3-68.3 281.1-49.2 1.1 0 1.9.6 2.8.8 3.9 2.2 5.3 6.9 3.1 10.8l-53.9 95.8c-2.5 4.7-7.8 7.2-13.1 6.1-126.8-23.8-226.9 17.3-318.9 18.6C24.1 488 0 453.4 0 451.8c0-1.1.6-1.7 1.7-1.7 0 0 38.3 0 103.1-15.3C178.4 294.5 244 245.4 315.4 245.4c0 0 71.7 0 90.6 61.9 22.8-39.7 28.3-49.2 28.3-49.2 5.3-9.4 35-77.2 86.4-141.4 51.5-64 90.4-79.9 119.3-91.8z"
    ]
};
var $ef0249c5e48bf4e3$export$36ebae5de28f5e9e = {
    prefix: "fab",
    iconName: "kickstarter-k",
    icon: [
        384,
        512,
        [],
        "f3bc",
        "M147.3 114.4c0-56.2-32.5-82.4-73.4-82.4C26.2 32 0 68.2 0 113.4v283c0 47.3 25.3 83.4 74.9 83.4 39.8 0 72.4-25.6 72.4-83.4v-76.5l112.1 138.3c22.7 27.2 72.1 30.7 103.2 0 27-27.6 27.3-67.4 7.4-92.2l-90.8-114.8 74.9-107.4c17.4-24.7 17.5-63.1-10.4-89.8-30.3-29-82.4-31.6-113.6 12.8L147.3 185v-70.6z"
    ]
};
var $ef0249c5e48bf4e3$export$d51f17330f9046ea = {
    prefix: "fab",
    iconName: "yandex",
    icon: [
        256,
        512,
        [],
        "f413",
        "M153.1 315.8L65.7 512H2l96-209.8c-45.1-22.9-75.2-64.4-75.2-141.1C22.7 53.7 90.8 0 171.7 0H254v512h-55.1V315.8h-45.8zm45.8-269.3h-29.4c-44.4 0-87.4 29.4-87.4 114.6 0 82.3 39.4 108.8 87.4 108.8h29.4V46.5z"
    ]
};
var $ef0249c5e48bf4e3$export$7dcb0372cc290c0e = {
    prefix: "fab",
    iconName: "readme",
    icon: [
        576,
        512,
        [],
        "f4d5",
        "M528.3 46.5H388.5c-48.1 0-89.9 33.3-100.4 80.3-10.6-47-52.3-80.3-100.4-80.3H48c-26.5 0-48 21.5-48 48v245.8c0 26.5 21.5 48 48 48h89.7c102.2 0 132.7 24.4 147.3 75 .7 2.8 5.2 2.8 6 0 14.7-50.6 45.2-75 147.3-75H528c26.5 0 48-21.5 48-48V94.6c0-26.4-21.3-47.9-47.7-48.1zM242 311.9c0 1.9-1.5 3.5-3.5 3.5H78.2c-1.9 0-3.5-1.5-3.5-3.5V289c0-1.9 1.5-3.5 3.5-3.5h160.4c1.9 0 3.5 1.5 3.5 3.5v22.9zm0-60.9c0 1.9-1.5 3.5-3.5 3.5H78.2c-1.9 0-3.5-1.5-3.5-3.5v-22.9c0-1.9 1.5-3.5 3.5-3.5h160.4c1.9 0 3.5 1.5 3.5 3.5V251zm0-60.9c0 1.9-1.5 3.5-3.5 3.5H78.2c-1.9 0-3.5-1.5-3.5-3.5v-22.9c0-1.9 1.5-3.5 3.5-3.5h160.4c1.9 0 3.5 1.5 3.5 3.5v22.9zm259.3 121.7c0 1.9-1.5 3.5-3.5 3.5H337.5c-1.9 0-3.5-1.5-3.5-3.5v-22.9c0-1.9 1.5-3.5 3.5-3.5h160.4c1.9 0 3.5 1.5 3.5 3.5v22.9zm0-60.9c0 1.9-1.5 3.5-3.5 3.5H337.5c-1.9 0-3.5-1.5-3.5-3.5V228c0-1.9 1.5-3.5 3.5-3.5h160.4c1.9 0 3.5 1.5 3.5 3.5v22.9zm0-60.9c0 1.9-1.5 3.5-3.5 3.5H337.5c-1.9 0-3.5-1.5-3.5-3.5v-22.8c0-1.9 1.5-3.5 3.5-3.5h160.4c1.9 0 3.5 1.5 3.5 3.5V190z"
    ]
};
var $ef0249c5e48bf4e3$export$d1a4948b9a07ae7c = {
    prefix: "fab",
    iconName: "html5",
    icon: [
        384,
        512,
        [],
        "f13b",
        "M0 32l34.9 395.8L191.5 480l157.6-52.2L384 32H0zm308.2 127.9H124.4l4.1 49.4h175.6l-13.6 148.4-97.9 27v.3h-1.1l-98.7-27.3-6-75.8h47.7L138 320l53.5 14.5 53.7-14.5 6-62.2H84.3L71.5 112.2h241.1l-4.4 47.7z"
    ]
};
var $ef0249c5e48bf4e3$export$cb60511a0f837c82 = {
    prefix: "fab",
    iconName: "sellsy",
    icon: [
        640,
        512,
        [],
        "f213",
        "M539.71 237.308c3.064-12.257 4.29-24.821 4.29-37.384C544 107.382 468.618 32 376.076 32c-77.22 0-144.634 53.012-163.02 127.781-15.322-13.176-34.934-20.53-55.157-20.53-46.271 0-83.962 37.69-83.962 83.961 0 7.354.92 15.015 3.065 22.369-42.9 20.225-70.785 63.738-70.785 111.234C6.216 424.843 61.68 480 129.401 480h381.198c67.72 0 123.184-55.157 123.184-123.184.001-56.384-38.916-106.025-94.073-119.508zM199.88 401.554c0 8.274-7.048 15.321-15.321 15.321H153.61c-8.274 0-15.321-7.048-15.321-15.321V290.626c0-8.273 7.048-15.321 15.321-15.321h30.949c8.274 0 15.321 7.048 15.321 15.321v110.928zm89.477 0c0 8.274-7.048 15.321-15.322 15.321h-30.949c-8.274 0-15.321-7.048-15.321-15.321V270.096c0-8.274 7.048-15.321 15.321-15.321h30.949c8.274 0 15.322 7.048 15.322 15.321v131.458zm89.477 0c0 8.274-7.047 15.321-15.321 15.321h-30.949c-8.274 0-15.322-7.048-15.322-15.321V238.84c0-8.274 7.048-15.321 15.322-15.321h30.949c8.274 0 15.321 7.048 15.321 15.321v162.714zm87.027 0c0 8.274-7.048 15.321-15.322 15.321h-28.497c-8.274 0-15.321-7.048-15.321-15.321V176.941c0-8.579 7.047-15.628 15.321-15.628h28.497c8.274 0 15.322 7.048 15.322 15.628v224.613z"
    ]
};
var $ef0249c5e48bf4e3$export$5afc94dc87b38719 = {
    prefix: "fab",
    iconName: "sass",
    icon: [
        640,
        512,
        [],
        "f41e",
        "M301.84 378.92c-.3.6-.6 1.08 0 0zm249.13-87a131.16 131.16 0 0 0-58 13.5c-5.9-11.9-12-22.3-13-30.1-1.2-9.1-2.5-14.5-1.1-25.3s7.7-26.1 7.6-27.2-1.4-6.6-14.3-6.7-24 2.5-25.29 5.9a122.83 122.83 0 0 0-5.3 19.1c-2.3 11.7-25.79 53.5-39.09 75.3-4.4-8.5-8.1-16-8.9-22-1.2-9.1-2.5-14.5-1.1-25.3s7.7-26.1 7.6-27.2-1.4-6.6-14.29-6.7-24 2.5-25.3 5.9-2.7 11.4-5.3 19.1-33.89 77.3-42.08 95.4c-4.2 9.2-7.8 16.6-10.4 21.6-.4.8-.7 1.3-.9 1.7.3-.5.5-1 .5-.8-2.2 4.3-3.5 6.7-3.5 6.7v.1c-1.7 3.2-3.6 6.1-4.5 6.1-.6 0-1.9-8.4.3-19.9 4.7-24.2 15.8-61.8 15.7-63.1-.1-.7 2.1-7.2-7.3-10.7-9.1-3.3-12.4 2.2-13.2 2.2s-1.4 2-1.4 2 10.1-42.4-19.39-42.4c-18.4 0-44 20.2-56.58 38.5-7.9 4.3-25 13.6-43 23.5-6.9 3.8-14 7.7-20.7 11.4-.5-.5-.9-1-1.4-1.5-35.79-38.2-101.87-65.2-99.07-116.5 1-18.7 7.5-67.8 127.07-127.4 98-48.8 176.35-35.4 189.84-5.6 19.4 42.5-41.89 121.6-143.66 133-38.79 4.3-59.18-10.7-64.28-16.3-5.3-5.9-6.1-6.2-8.1-5.1-3.3 1.8-1.2 7 0 10.1 3 7.9 15.5 21.9 36.79 28.9 18.7 6.1 64.18 9.5 119.17-11.8 61.78-23.8 109.87-90.1 95.77-145.6C386.52 18.32 293-.18 204.57 31.22c-52.69 18.7-109.67 48.1-150.66 86.4-48.69 45.6-56.48 85.3-53.28 101.9 11.39 58.9 92.57 97.3 125.06 125.7-1.6.9-3.1 1.7-4.5 2.5-16.29 8.1-78.18 40.5-93.67 74.7-17.5 38.8 2.9 66.6 16.29 70.4 41.79 11.6 84.58-9.3 107.57-43.6s20.2-79.1 9.6-99.5c-.1-.3-.3-.5-.4-.8 4.2-2.5 8.5-5 12.8-7.5 8.29-4.9 16.39-9.4 23.49-13.3-4 10.8-6.9 23.8-8.4 42.6-1.8 22 7.3 50.5 19.1 61.7 5.2 4.9 11.49 5 15.39 5 13.8 0 20-11.4 26.89-25 8.5-16.6 16-35.9 16-35.9s-9.4 52.2 16.3 52.2c9.39 0 18.79-12.1 23-18.3v.1s.2-.4.7-1.2c1-1.5 1.5-2.4 1.5-2.4v-.3c3.8-6.5 12.1-21.4 24.59-46 16.2-31.8 31.69-71.5 31.69-71.5a201.24 201.24 0 0 0 6.2 25.8c2.8 9.5 8.7 19.9 13.4 30-3.8 5.2-6.1 8.2-6.1 8.2a.31.31 0 0 0 .1.2c-3 4-6.4 8.3-9.9 12.5-12.79 15.2-28 32.6-30 37.6-2.4 5.9-1.8 10.3 2.8 13.7 3.4 2.6 9.4 3 15.69 2.5 11.5-.8 19.6-3.6 23.5-5.4a82.2 82.2 0 0 0 20.19-10.6c12.5-9.2 20.1-22.4 19.4-39.8-.4-9.6-3.5-19.2-7.3-28.2 1.1-1.6 2.3-3.3 3.4-5C434.8 301.72 450.1 270 450.1 270a201.24 201.24 0 0 0 6.2 25.8c2.4 8.1 7.09 17 11.39 25.7-18.59 15.1-30.09 32.6-34.09 44.1-7.4 21.3-1.6 30.9 9.3 33.1 4.9 1 11.9-1.3 17.1-3.5a79.46 79.46 0 0 0 21.59-11.1c12.5-9.2 24.59-22.1 23.79-39.6-.3-7.9-2.5-15.8-5.4-23.4 15.7-6.6 36.09-10.2 62.09-7.2 55.68 6.5 66.58 41.3 64.48 55.8s-13.8 22.6-17.7 25-5.1 3.3-4.8 5.1c.5 2.6 2.3 2.5 5.6 1.9 4.6-.8 29.19-11.8 30.29-38.7 1.6-34-31.09-71.4-89-71.1zm-429.18 144.7c-18.39 20.1-44.19 27.7-55.28 21.3C54.61 451 59.31 421.42 82 400c13.8-13 31.59-25 43.39-32.4 2.7-1.6 6.6-4 11.4-6.9.8-.5 1.2-.7 1.2-.7.9-.6 1.9-1.1 2.9-1.7 8.29 30.4.3 57.2-19.1 78.3zm134.36-91.4c-6.4 15.7-19.89 55.7-28.09 53.6-7-1.8-11.3-32.3-1.4-62.3 5-15.1 15.6-33.1 21.9-40.1 10.09-11.3 21.19-14.9 23.79-10.4 3.5 5.9-12.2 49.4-16.2 59.2zm111 53c-2.7 1.4-5.2 2.3-6.4 1.6-.9-.5 1.1-2.4 1.1-2.4s13.9-14.9 19.4-21.7c3.2-4 6.9-8.7 10.89-13.9 0 .5.1 1 .1 1.6-.13 17.9-17.32 30-25.12 34.8zm85.58-19.5c-2-1.4-1.7-6.1 5-20.7 2.6-5.7 8.59-15.3 19-24.5a36.18 36.18 0 0 1 1.9 10.8c-.1 22.5-16.2 30.9-25.89 34.4z"
    ]
};
var $ef0249c5e48bf4e3$export$304e26e1efc5b1a4 = {
    prefix: "fab",
    iconName: "wirsindhandwerk",
    icon: [
        512,
        512,
        [
            "wsh"
        ],
        "e2d0",
        "M50.77161,479.81213h83.36071V367.84741l-83.36071,47.009Zm329.04675,0h82.35022V414.85645l-82.35022-47.009Zm.00568-448V251.568L256.1759,179.1861,134.50378,251.568V31.81213H50.77161V392.60565L256.1759,270.31909,462.16858,392.60565V31.81213Z"
    ]
};
var $ef0249c5e48bf4e3$export$c6d19319c89c1ce4 = $ef0249c5e48bf4e3$export$304e26e1efc5b1a4;
var $ef0249c5e48bf4e3$export$25d99c8ee7e610e5 = {
    prefix: "fab",
    iconName: "buromobelexperte",
    icon: [
        448,
        512,
        [],
        "f37f",
        "M0 32v128h128V32H0zm120 120H8V40h112v112zm40-120v128h128V32H160zm120 120H168V40h112v112zm40-120v128h128V32H320zm120 120H328V40h112v112zM0 192v128h128V192H0zm120 120H8V200h112v112zm40-120v128h128V192H160zm120 120H168V200h112v112zm40-120v128h128V192H320zm120 120H328V200h112v112zM0 352v128h128V352H0zm120 120H8V360h112v112zm40-120v128h128V352H160zm120 120H168V360h112v112zm40-120v128h128V352H320z"
    ]
};
var $ef0249c5e48bf4e3$export$fb5e089c1f25c80c = {
    prefix: "fab",
    iconName: "salesforce",
    icon: [
        640,
        512,
        [],
        "f83b",
        "M248.89 245.64h-26.35c.69-5.16 3.32-14.12 13.64-14.12 6.75 0 11.97 3.82 12.71 14.12zm136.66-13.88c-.47 0-14.11-1.77-14.11 20s13.63 20 14.11 20c13 0 14.11-13.54 14.11-20 0-21.76-13.66-20-14.11-20zm-243.22 23.76a8.63 8.63 0 0 0-3.29 7.29c0 4.78 2.08 6.05 3.29 7.05 4.7 3.7 15.07 2.12 20.93.95v-16.94c-5.32-1.07-16.73-1.96-20.93 1.65zM640 232c0 87.58-80 154.39-165.36 136.43-18.37 33-70.73 70.75-132.2 41.63-41.16 96.05-177.89 92.18-213.81-5.17C8.91 428.78-50.19 266.52 53.36 205.61 18.61 126.18 76 32 167.67 32a124.24 124.24 0 0 1 98.56 48.7c20.7-21.4 49.4-34.81 81.15-34.81 42.34 0 79 23.52 98.8 58.57C539 63.78 640 132.69 640 232zm-519.55 31.8c0-11.76-11.69-15.17-17.87-17.17-5.27-2.11-13.41-3.51-13.41-8.94 0-9.46 17-6.66 25.17-2.12 0 0 1.17.71 1.64-.47.24-.7 2.36-6.58 2.59-7.29a1.13 1.13 0 0 0-.7-1.41c-12.33-7.63-40.7-8.51-40.7 12.7 0 12.46 11.49 15.44 17.88 17.17 4.72 1.58 13.17 3 13.17 8.7 0 4-3.53 7.06-9.17 7.06a31.76 31.76 0 0 1-19-6.35c-.47-.23-1.42-.71-1.65.71l-2.4 7.47c-.47.94.23 1.18.23 1.41 1.75 1.4 10.3 6.59 22.82 6.59 13.17 0 21.4-7.06 21.4-18.11zm32-42.58c-10.13 0-18.66 3.17-21.4 5.18a1 1 0 0 0-.24 1.41l2.59 7.06a1 1 0 0 0 1.18.7c.65 0 6.8-4 16.93-4 4 0 7.06.71 9.18 2.36 3.6 2.8 3.06 8.29 3.06 10.58-4.79-.3-19.11-3.44-29.41 3.76a16.92 16.92 0 0 0-7.34 14.54c0 5.9 1.51 10.4 6.59 14.35 12.24 8.16 36.28 2 38.1 1.41 1.58-.32 3.53-.66 3.53-1.88v-33.88c.04-4.61.32-21.64-22.78-21.64zM199 200.24a1.11 1.11 0 0 0-1.18-1.18H188a1.11 1.11 0 0 0-1.17 1.18v79a1.11 1.11 0 0 0 1.17 1.18h9.88a1.11 1.11 0 0 0 1.18-1.18zm55.75 28.93c-2.1-2.31-6.79-7.53-17.65-7.53-3.51 0-14.16.23-20.7 8.94-6.35 7.63-6.58 18.11-6.58 21.41 0 3.12.15 14.26 7.06 21.17 2.64 2.91 9.06 8.23 22.81 8.23 10.82 0 16.47-2.35 18.58-3.76.47-.24.71-.71.24-1.88l-2.35-6.83a1.26 1.26 0 0 0-1.41-.7c-2.59.94-6.35 2.82-15.29 2.82-17.42 0-16.85-14.74-16.94-16.7h37.17a1.23 1.23 0 0 0 1.17-.94c-.29 0 2.07-14.7-6.09-24.23zm36.69 52.69c13.17 0 21.41-7.06 21.41-18.11 0-11.76-11.7-15.17-17.88-17.17-4.14-1.66-13.41-3.38-13.41-8.94 0-3.76 3.29-6.35 8.47-6.35a38.11 38.11 0 0 1 16.7 4.23s1.18.71 1.65-.47c.23-.7 2.35-6.58 2.58-7.29a1.13 1.13 0 0 0-.7-1.41c-7.91-4.9-16.74-4.94-20.23-4.94-12 0-20.46 7.29-20.46 17.64 0 12.46 11.48 15.44 17.87 17.17 6.11 2 13.17 3.26 13.17 8.7 0 4-3.52 7.06-9.17 7.06a31.8 31.8 0 0 1-19-6.35 1 1 0 0 0-1.65.71l-2.35 7.52c-.47.94.23 1.18.23 1.41 1.72 1.4 10.33 6.59 22.79 6.59zM357.09 224c0-.71-.24-1.18-1.18-1.18h-11.76c0-.14.94-8.94 4.47-12.47 4.16-4.15 11.76-1.64 12-1.64 1.17.47 1.41 0 1.64-.47l2.83-7.77c.7-.94 0-1.17-.24-1.41-5.09-2-17.35-2.87-24.46 4.24-5.48 5.48-7 13.92-8 19.52h-8.47a1.28 1.28 0 0 0-1.17 1.18l-1.42 7.76c0 .7.24 1.17 1.18 1.17h8.23c-8.51 47.9-8.75 50.21-10.35 55.52-1.08 3.62-3.29 6.9-5.88 7.76-.09 0-3.88 1.68-9.64-.24 0 0-.94-.47-1.41.71-.24.71-2.59 6.82-2.83 7.53s0 1.41.47 1.41c5.11 2 13 1.77 17.88 0 6.28-2.28 9.72-7.89 11.53-12.94 2.75-7.71 2.81-9.79 11.76-59.74h12.23a1.29 1.29 0 0 0 1.18-1.18zm53.39 16c-.56-1.68-5.1-18.11-25.17-18.11-15.25 0-23 10-25.16 18.11-1 3-3.18 14 0 23.52.09.3 4.41 18.12 25.16 18.12 14.95 0 22.9-9.61 25.17-18.12 3.21-9.61 1.01-20.52 0-23.52zm45.4-16.7c-5-1.65-16.62-1.9-22.11 5.41v-4.47a1.11 1.11 0 0 0-1.18-1.17h-9.4a1.11 1.11 0 0 0-1.18 1.17v55.28a1.12 1.12 0 0 0 1.18 1.18h9.64a1.12 1.12 0 0 0 1.18-1.18v-27.77c0-2.91.05-11.37 4.46-15.05 4.9-4.9 12-3.36 13.41-3.06a1.57 1.57 0 0 0 1.41-.94 74 74 0 0 0 3.06-8 1.16 1.16 0 0 0-.47-1.41zm46.81 54.1l-2.12-7.29c-.47-1.18-1.41-.71-1.41-.71-4.23 1.82-10.15 1.89-11.29 1.89-4.64 0-17.17-1.13-17.17-19.76 0-6.23 1.85-19.76 16.47-19.76a34.85 34.85 0 0 1 11.52 1.65s.94.47 1.18-.71c.94-2.59 1.64-4.47 2.59-7.53.23-.94-.47-1.17-.71-1.17-11.59-3.87-22.34-2.53-27.76 0-1.59.74-16.23 6.49-16.23 27.52 0 2.9-.58 30.11 28.94 30.11a44.45 44.45 0 0 0 15.52-2.83 1.3 1.3 0 0 0 .47-1.42zm53.87-39.52c-.8-3-5.37-16.23-22.35-16.23-16 0-23.52 10.11-25.64 18.59a38.58 38.58 0 0 0-1.65 11.76c0 25.87 18.84 29.4 29.88 29.4 10.82 0 16.46-2.35 18.58-3.76.47-.24.71-.71.24-1.88l-2.36-6.83a1.26 1.26 0 0 0-1.41-.7c-2.59.94-6.35 2.82-15.29 2.82-17.42 0-16.85-14.74-16.93-16.7h37.16a1.25 1.25 0 0 0 1.18-.94c-.24-.01.94-7.07-1.41-15.54zm-23.29-6.35c-10.33 0-13 9-13.64 14.12H546c-.88-11.92-7.62-14.13-12.73-14.13z"
    ]
};
var $ef0249c5e48bf4e3$export$4a726382b32e57cc = {
    prefix: "fab",
    iconName: "octopus-deploy",
    icon: [
        512,
        512,
        [],
        "e082",
        "M455.6,349.2c-45.891-39.09-36.67-77.877-16.095-128.11C475.16,134.04,415.967,34.14,329.93,8.3,237.04-19.6,134.252,24.341,99.677,117.147a180.862,180.862,0,0,0-10.988,73.544c1.733,29.543,14.717,52.97,24.09,80.3,17.2,50.161-28.1,92.743-66.662,117.582-46.806,30.2-36.319,39.857-8.428,41.858,23.378,1.68,44.478-4.548,65.265-15.045,9.2-4.647,40.687-18.931,45.13-28.588C135.9,413.388,111.122,459.5,126.621,488.9c19.1,36.229,67.112-31.77,76.709-45.812,8.591-12.572,42.963-81.279,63.627-46.926,18.865,31.361,8.6,76.391,35.738,104.622,32.854,34.2,51.155-18.312,51.412-44.221.163-16.411-6.1-95.852,29.9-59.944C405.428,418,436.912,467.8,472.568,463.642c38.736-4.516-22.123-67.967-28.262-78.695,5.393,4.279,53.665,34.128,53.818,9.52C498.234,375.678,468.039,359.8,455.6,349.2Z"
    ]
};
var $ef0249c5e48bf4e3$export$86efffc3e85d2a9 = {
    prefix: "fab",
    iconName: "medapps",
    icon: [
        320,
        512,
        [],
        "f3c6",
        "M118.3 238.4c3.5-12.5 6.9-33.6 13.2-33.6 8.3 1.8 9.6 23.4 18.6 36.6 4.6-23.5 5.3-85.1 14.1-86.7 9-.7 19.7 66.5 22 77.5 9.9 4.1 48.9 6.6 48.9 6.6 1.9 7.3-24 7.6-40 7.8-4.6 14.8-5.4 27.7-11.4 28-4.7.2-8.2-28.8-17.5-49.6l-9.4 65.5c-4.4 13-15.5-22.5-21.9-39.3-3.3-.1-62.4-1.6-47.6-7.8l31-5zM228 448c21.2 0 21.2-32 0-32H92c-21.2 0-21.2 32 0 32h136zm-24 64c21.2 0 21.2-32 0-32h-88c-21.2 0-21.2 32 0 32h88zm34.2-141.5c3.2-18.9 5.2-36.4 11.9-48.8 7.9-14.7 16.1-28.1 24-41 24.6-40.4 45.9-75.2 45.9-125.5C320 69.6 248.2 0 160 0S0 69.6 0 155.2c0 50.2 21.3 85.1 45.9 125.5 7.9 12.9 16 26.3 24 41 6.7 12.5 8.7 29.8 11.9 48.9 3.5 21 36.1 15.7 32.6-5.1-3.6-21.7-5.6-40.7-15.3-58.6C66.5 246.5 33 211.3 33 155.2 33 87.3 90 32 160 32s127 55.3 127 123.2c0 56.1-33.5 91.3-66.1 151.6-9.7 18-11.7 37.4-15.3 58.6-3.4 20.6 29 26.4 32.6 5.1z"
    ]
};
var $ef0249c5e48bf4e3$export$ffa3f5d32fe6bc0e = {
    prefix: "fab",
    iconName: "ns8",
    icon: [
        640,
        512,
        [],
        "f3d5",
        "M104.324,269.172h26.067V242.994H104.324Zm52.466-26.178-.055-26.178v-.941a39.325,39.325,0,0,0-78.644.941v.166h26.4v-.166a12.98,12.98,0,0,1,25.956,0v26.178Zm52.356,25.846a91.1,91.1,0,0,1-91.1,91.1h-.609a91.1,91.1,0,0,1-91.1-91.1H0v.166A117.33,117.33,0,0,0,117.44,386.28h.775A117.331,117.331,0,0,0,235.49,268.84V242.828H209.146Zm-157.233,0a65.362,65.362,0,0,0,130.723,0H156.292a39.023,39.023,0,0,1-78.035,0V242.883H51.968v-26.62A65.42,65.42,0,0,1,182.8,217.48v25.293h26.344V217.48a91.761,91.761,0,0,0-183.522,0v25.4H51.913Zm418.4-71.173c13.67,0,24.573,6.642,30.052,18.264l.719,1.549,23.245-11.511-.609-1.439c-8.025-19.26-28.5-31.27-53.407-31.27-23.134,0-43.611,11.4-50.972,28.447-.123,26.876-.158,23.9,0,24.85,4.7,11.013,14.555,19.37,28.668,24.241a102.033,102.033,0,0,0,19.813,3.984c5.479.72,10.626,1.384,15.829,3.1,6.364,2.1,10.46,5.257,12.84,9.851v9.851c-3.708,7.527-13.781,12.342-25.791,12.342-14.334,0-25.956-6.918-31.933-19.039l-.72-1.494L415.026,280.9l.553,1.439c7.915,19.426,29.609,32.044,55.289,32.044,23.632,0,44.608-11.4,52.3-28.447l.166-25.9-.166-.664c-4.87-11.014-15.219-19.647-28.944-24.241-7.693-2.712-14.335-3.6-20.7-4.427a83.777,83.777,0,0,1-14.832-2.878c-6.31-1.937-10.4-5.092-12.619-9.63v-8.412C449.45,202.427,458.969,197.667,470.315,197.667ZM287.568,311.344h26.067v-68.4H287.568Zm352.266-53.3c-2.933-6.254-8.3-12.01-15.441-16.714A37.99,37.99,0,0,0,637.4,226l.166-25.347-.166-.664C630.038,184,610.667,173.26,589.25,173.26S548.461,184,541.1,199.992l-.166,25.347.166.664a39.643,39.643,0,0,0,13.006,15.331c-7.2,4.7-12.508,10.46-15.441,16.714l-.166,28.889.166.72c7.582,15.994,27.893,26.731,50.585,26.731s43.057-10.737,50.584-26.731l.166-28.89Zm-73.22-50.806c3.6-6.31,12.563-10.516,22.58-10.516s19.038,4.206,22.636,10.516v13.725c-3.542,6.2-12.563,10.349-22.636,10.349s-19.094-4.15-22.58-10.349Zm47.319,72.169c-3.764,6.641-13.338,10.9-24.683,10.9-11.125,0-20.976-4.372-24.684-10.9V263.25c3.708-6.309,13.5-10.515,24.684-10.515,11.345,0,20.919,4.15,24.683,10.515ZM376.4,265.962l-59.827-89.713h-29v40.623h26.51v.387l62.539,94.085H402.3V176.249H376.4Z"
    ]
};
var $ef0249c5e48bf4e3$export$e1681fe8211dd475 = {
    prefix: "fab",
    iconName: "pinterest-p",
    icon: [
        384,
        512,
        [],
        "f231",
        "M204 6.5C101.4 6.5 0 74.9 0 185.6 0 256 39.6 296 63.6 296c9.9 0 15.6-27.6 15.6-35.4 0-9.3-23.7-29.1-23.7-67.8 0-80.4 61.2-137.4 140.4-137.4 68.1 0 118.5 38.7 118.5 109.8 0 53.1-21.3 152.7-90.3 152.7-24.9 0-46.2-18-46.2-43.8 0-37.8 26.4-74.4 26.4-113.4 0-66.2-93.9-54.2-93.9 25.8 0 16.8 2.1 35.4 9.6 50.7-13.8 59.4-42 147.9-42 209.1 0 18.9 2.7 37.5 4.5 56.4 3.4 3.8 1.7 3.4 6.9 1.5 50.4-69 48.6-82.5 71.4-172.8 12.3 23.4 44.1 36 69.3 36 106.2 0 153.9-103.5 153.9-196.8C384 71.3 298.2 6.5 204 6.5z"
    ]
};
var $ef0249c5e48bf4e3$export$aa79881dfcf87a16 = {
    prefix: "fab",
    iconName: "apper",
    icon: [
        640,
        512,
        [],
        "f371",
        "M42.1 239.1c22.2 0 29 2.8 33.5 14.6h.8v-22.9c0-11.3-4.8-15.4-17.9-15.4-11.3 0-14.4 2.5-15.1 12.8H4.8c.3-13.9 1.5-19.1 5.8-24.4C17.9 195 29.5 192 56.7 192c33 0 47.1 5 53.9 18.9 2 4.3 4 15.6 4 23.7v76.3H76.3l1.3-19.1h-1c-5.3 15.6-13.6 20.4-35.5 20.4-30.3 0-41.1-10.1-41.1-37.3 0-25.2 12.3-35.8 42.1-35.8zm17.1 48.1c13.1 0 16.9-3 16.9-13.4 0-9.1-4.3-11.6-19.6-11.6-13.1 0-17.9 3-17.9 12.1-.1 10.4 3.7 12.9 20.6 12.9zm77.8-94.9h38.3l-1.5 20.6h.8c9.1-17.1 15.9-20.9 37.5-20.9 14.4 0 24.7 3 31.5 9.1 9.8 8.6 12.8 20.4 12.8 48.1 0 30-3 43.1-12.1 52.9-6.8 7.3-16.4 10.1-33.2 10.1-20.4 0-29.2-5.5-33.8-21.2h-.8v70.3H137v-169zm80.9 60.7c0-27.5-3.3-32.5-20.7-32.5-16.9 0-20.7 5-20.7 28.7 0 28 3.5 33.5 21.2 33.5 16.4 0 20.2-5.6 20.2-29.7zm57.9-60.7h38.3l-1.5 20.6h.8c9.1-17.1 15.9-20.9 37.5-20.9 14.4 0 24.7 3 31.5 9.1 9.8 8.6 12.8 20.4 12.8 48.1 0 30-3 43.1-12.1 52.9-6.8 7.3-16.4 10.1-33.3 10.1-20.4 0-29.2-5.5-33.8-21.2h-.8v70.3h-39.5v-169zm80.9 60.7c0-27.5-3.3-32.5-20.7-32.5-16.9 0-20.7 5-20.7 28.7 0 28 3.5 33.5 21.2 33.5 16.4 0 20.2-5.6 20.2-29.7zm53.8-3.8c0-25.4 3.3-37.8 12.3-45.8 8.8-8.1 22.2-11.3 45.1-11.3 42.8 0 55.7 12.8 55.7 55.7v11.1h-75.3c-.3 2-.3 4-.3 4.8 0 16.9 4.5 21.9 20.1 21.9 13.9 0 17.9-3 17.9-13.9h37.5v2.3c0 9.8-2.5 18.9-6.8 24.7-7.3 9.8-19.6 13.6-44.3 13.6-27.5 0-41.6-3.3-50.6-12.3-8.5-8.5-11.3-21.3-11.3-50.8zm76.4-11.6c-.3-1.8-.3-3.3-.3-3.8 0-12.3-3.3-14.6-19.6-14.6-14.4 0-17.1 3-18.1 15.1l-.3 3.3h38.3zm55.6-45.3h38.3l-1.8 19.9h.7c6.8-14.9 14.4-20.2 29.7-20.2 10.8 0 19.1 3.3 23.4 9.3 5.3 7.3 6.8 14.4 6.8 34 0 1.5 0 5 .2 9.3h-35c.3-1.8.3-3.3.3-4 0-15.4-2-19.4-10.3-19.4-6.3 0-10.8 3.3-13.1 9.3-1 3-1 4.3-1 12.3v68h-38.3V192.3z"
    ]
};
var $ef0249c5e48bf4e3$export$c2ee281dce8eb9d5 = {
    prefix: "fab",
    iconName: "fort-awesome",
    icon: [
        512,
        512,
        [],
        "f286",
        "M489.2 287.9h-27.4c-2.6 0-4.6 2-4.6 4.6v32h-36.6V146.2c0-2.6-2-4.6-4.6-4.6h-27.4c-2.6 0-4.6 2-4.6 4.6v32h-36.6v-32c0-2.6-2-4.6-4.6-4.6h-27.4c-2.6 0-4.6 2-4.6 4.6v32h-36.6v-32c0-6-8-4.6-11.7-4.6v-38c8.3-2 17.1-3.4 25.7-3.4 10.9 0 20.9 4.3 31.4 4.3 4.6 0 27.7-1.1 27.7-8v-60c0-2.6-2-4.6-4.6-4.6-5.1 0-15.1 4.3-24 4.3-9.7 0-20.9-4.3-32.6-4.3-8 0-16 1.1-23.7 2.9v-4.9c5.4-2.6 9.1-8.3 9.1-14.3 0-20.7-31.4-20.8-31.4 0 0 6 3.7 11.7 9.1 14.3v111.7c-3.7 0-11.7-1.4-11.7 4.6v32h-36.6v-32c0-2.6-2-4.6-4.6-4.6h-27.4c-2.6 0-4.6 2-4.6 4.6v32H128v-32c0-2.6-2-4.6-4.6-4.6H96c-2.6 0-4.6 2-4.6 4.6v178.3H54.8v-32c0-2.6-2-4.6-4.6-4.6H22.8c-2.6 0-4.6 2-4.6 4.6V512h182.9v-96c0-72.6 109.7-72.6 109.7 0v96h182.9V292.5c.1-2.6-1.9-4.6-4.5-4.6zm-288.1-4.5c0 2.6-2 4.6-4.6 4.6h-27.4c-2.6 0-4.6-2-4.6-4.6v-64c0-2.6 2-4.6 4.6-4.6h27.4c2.6 0 4.6 2 4.6 4.6v64zm146.4 0c0 2.6-2 4.6-4.6 4.6h-27.4c-2.6 0-4.6-2-4.6-4.6v-64c0-2.6 2-4.6 4.6-4.6h27.4c2.6 0 4.6 2 4.6 4.6v64z"
    ]
};
var $ef0249c5e48bf4e3$export$8d560f87da34bcc1 = {
    prefix: "fab",
    iconName: "waze",
    icon: [
        512,
        512,
        [],
        "f83f",
        "M502.17 201.67C516.69 287.53 471.23 369.59 389 409.8c13 34.1-12.4 70.2-48.32 70.2a51.68 51.68 0 0 1-51.57-49c-6.44.19-64.2 0-76.33-.64A51.69 51.69 0 0 1 159 479.92c-33.86-1.36-57.95-34.84-47-67.92-37.21-13.11-72.54-34.87-99.62-70.8-13-17.28-.48-41.8 20.84-41.8 46.31 0 32.22-54.17 43.15-110.26C94.8 95.2 193.12 32 288.09 32c102.48 0 197.15 70.67 214.08 169.67zM373.51 388.28c42-19.18 81.33-56.71 96.29-102.14 40.48-123.09-64.15-228-181.71-228-83.45 0-170.32 55.42-186.07 136-9.53 48.91 5 131.35-68.75 131.35C58.21 358.6 91.6 378.11 127 389.54c24.66-21.8 63.87-15.47 79.83 14.34 14.22 1 79.19 1.18 87.9.82a51.69 51.69 0 0 1 78.78-16.42zM205.12 187.13c0-34.74 50.84-34.75 50.84 0s-50.84 34.74-50.84 0zm116.57 0c0-34.74 50.86-34.75 50.86 0s-50.86 34.75-50.86 0zm-122.61 70.69c-3.44-16.94 22.18-22.18 25.62-5.21l.06.28c4.14 21.42 29.85 44 64.12 43.07 35.68-.94 59.25-22.21 64.11-42.77 4.46-16.05 28.6-10.36 25.47 6-5.23 22.18-31.21 62-91.46 62.9-42.55 0-80.88-27.84-87.9-64.25z"
    ]
};
var $ef0249c5e48bf4e3$export$4f0eff72b7493340 = {
    prefix: "fab",
    iconName: "cc-jcb",
    icon: [
        576,
        512,
        [],
        "f24b",
        "M431.5 244.3V212c41.2 0 38.5.2 38.5.2 7.3 1.3 13.3 7.3 13.3 16 0 8.8-6 14.5-13.3 15.8-1.2.4-3.3.3-38.5.3zm42.8 20.2c-2.8-.7-3.3-.5-42.8-.5v35c39.6 0 40 .2 42.8-.5 7.5-1.5 13.5-8 13.5-17 0-8.7-6-15.5-13.5-17zM576 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48zM182 192.3h-57c0 67.1 10.7 109.7-35.8 109.7-19.5 0-38.8-5.7-57.2-14.8v28c30 8.3 68 8.3 68 8.3 97.9 0 82-47.7 82-131.2zm178.5 4.5c-63.4-16-165-14.9-165 59.3 0 77.1 108.2 73.6 165 59.2V287C312.9 311.7 253 309 253 256s59.8-55.6 107.5-31.2v-28zM544 286.5c0-18.5-16.5-30.5-38-32v-.8c19.5-2.7 30.3-15.5 30.3-30.2 0-19-15.7-30-37-31 0 0 6.3-.3-120.3-.3v127.5h122.7c24.3.1 42.3-12.9 42.3-33.2z"
    ]
};
var $ef0249c5e48bf4e3$export$3770724b51125ef1 = {
    prefix: "fab",
    iconName: "snapchat",
    icon: [
        512,
        512,
        [
            62124,
            "snapchat-ghost"
        ],
        "f2ab",
        "M496.926,366.6c-3.373-9.176-9.8-14.086-17.112-18.153-1.376-.806-2.641-1.451-3.72-1.947-2.182-1.128-4.414-2.22-6.634-3.373-22.8-12.09-40.609-27.341-52.959-45.42a102.889,102.889,0,0,1-9.089-16.12c-1.054-3.013-1-4.724-.248-6.287a10.221,10.221,0,0,1,2.914-3.038c3.918-2.591,7.96-5.22,10.7-6.993,4.885-3.162,8.754-5.667,11.246-7.44,9.362-6.547,15.909-13.5,20-21.278a42.371,42.371,0,0,0,2.1-35.191c-6.2-16.318-21.613-26.449-40.287-26.449a55.543,55.543,0,0,0-11.718,1.24c-1.029.224-2.059.459-3.063.72.174-11.16-.074-22.94-1.066-34.534-3.522-40.758-17.794-62.123-32.674-79.16A130.167,130.167,0,0,0,332.1,36.443C309.515,23.547,283.91,17,256,17S202.6,23.547,180,36.443a129.735,129.735,0,0,0-33.281,26.783c-14.88,17.038-29.152,38.44-32.673,79.161-.992,11.594-1.24,23.435-1.079,34.533-1-.26-2.021-.5-3.051-.719a55.461,55.461,0,0,0-11.717-1.24c-18.687,0-34.125,10.131-40.3,26.449a42.423,42.423,0,0,0,2.046,35.228c4.105,7.774,10.652,14.731,20.014,21.278,2.48,1.736,6.361,4.24,11.246,7.44,2.641,1.711,6.5,4.216,10.28,6.72a11.054,11.054,0,0,1,3.3,3.311c.794,1.624.818,3.373-.36,6.6a102.02,102.02,0,0,1-8.94,15.785c-12.077,17.669-29.363,32.648-51.434,44.639C32.355,348.608,20.2,352.75,15.069,366.7c-3.868,10.528-1.339,22.506,8.494,32.6a49.137,49.137,0,0,0,12.4,9.387,134.337,134.337,0,0,0,30.342,12.139,20.024,20.024,0,0,1,6.126,2.741c3.583,3.137,3.075,7.861,7.849,14.78a34.468,34.468,0,0,0,8.977,9.127c10.019,6.919,21.278,7.353,33.207,7.811,10.776.41,22.989.881,36.939,5.481,5.778,1.91,11.78,5.605,18.736,9.92C194.842,480.951,217.707,495,255.973,495s61.292-14.123,78.118-24.428c6.907-4.24,12.872-7.9,18.489-9.758,13.949-4.613,26.163-5.072,36.939-5.481,11.928-.459,23.187-.893,33.206-7.812a34.584,34.584,0,0,0,10.218-11.16c3.434-5.84,3.348-9.919,6.572-12.771a18.971,18.971,0,0,1,5.753-2.629A134.893,134.893,0,0,0,476.02,408.71a48.344,48.344,0,0,0,13.019-10.193l.124-.149C498.389,388.5,500.708,376.867,496.926,366.6Zm-34.013,18.277c-20.745,11.458-34.533,10.23-45.259,17.137-9.114,5.865-3.72,18.513-10.342,23.076-8.134,5.617-32.177-.4-63.239,9.858-25.618,8.469-41.961,32.822-88.038,32.822s-62.036-24.3-88.076-32.884c-31-10.255-55.092-4.241-63.239-9.858-6.609-4.563-1.24-17.211-10.341-23.076-10.739-6.907-24.527-5.679-45.26-17.075-13.206-7.291-5.716-11.8-1.314-13.937,75.143-36.381,87.133-92.552,87.666-96.719.645-5.046,1.364-9.014-4.191-14.148-5.369-4.96-29.189-19.7-35.8-24.316-10.937-7.638-15.748-15.264-12.2-24.638,2.48-6.485,8.531-8.928,14.879-8.928a27.643,27.643,0,0,1,5.965.67c12,2.6,23.659,8.617,30.392,10.242a10.749,10.749,0,0,0,2.48.335c3.6,0,4.86-1.811,4.612-5.927-.768-13.132-2.628-38.725-.558-62.644,2.84-32.909,13.442-49.215,26.04-63.636,6.051-6.932,34.484-36.976,88.857-36.976s82.88,29.92,88.931,36.827c12.611,14.421,23.225,30.727,26.04,63.636,2.071,23.919.285,49.525-.558,62.644-.285,4.327,1.017,5.927,4.613,5.927a10.648,10.648,0,0,0,2.48-.335c6.745-1.624,18.4-7.638,30.4-10.242a27.641,27.641,0,0,1,5.964-.67c6.386,0,12.4,2.48,14.88,8.928,3.546,9.374-1.24,17-12.189,24.639-6.609,4.612-30.429,19.343-35.8,24.315-5.568,5.134-4.836,9.1-4.191,14.149.533,4.228,12.511,60.4,87.666,96.718C468.629,373.011,476.119,377.524,462.913,384.877Z"
    ]
};
var $ef0249c5e48bf4e3$export$e6e855f745e10958 = $ef0249c5e48bf4e3$export$3770724b51125ef1;
var $ef0249c5e48bf4e3$export$318074701514e1 = {
    prefix: "fab",
    iconName: "fantasy-flight-games",
    icon: [
        512,
        512,
        [],
        "f6dc",
        "M256 32.86L32.86 256 256 479.14 479.14 256 256 32.86zM88.34 255.83c1.96-2 11.92-12.3 96.49-97.48 41.45-41.75 86.19-43.77 119.77-18.69 24.63 18.4 62.06 58.9 62.15 59 .68.74 1.07 2.86.58 3.38-11.27 11.84-22.68 23.54-33.5 34.69-34.21-32.31-40.52-38.24-48.51-43.95-17.77-12.69-41.4-10.13-56.98 5.1-2.17 2.13-1.79 3.43.12 5.35 2.94 2.95 28.1 28.33 35.09 35.78-11.95 11.6-23.66 22.97-35.69 34.66-12.02-12.54-24.48-25.53-36.54-38.11-21.39 21.09-41.69 41.11-61.85 60.99zm234.82 101.6c-35.49 35.43-78.09 38.14-106.99 20.47-22.08-13.5-39.38-32.08-72.93-66.84 12.05-12.37 23.79-24.42 35.37-36.31 33.02 31.91 37.06 36.01 44.68 42.09 18.48 14.74 42.52 13.67 59.32-1.8 3.68-3.39 3.69-3.64.14-7.24-10.59-10.73-21.19-21.44-31.77-32.18-1.32-1.34-3.03-2.48-.8-4.69 10.79-10.71 21.48-21.52 32.21-32.29.26-.26.65-.38 1.91-1.07 12.37 12.87 24.92 25.92 37.25 38.75 21.01-20.73 41.24-40.68 61.25-60.42 13.68 13.4 27.13 26.58 40.86 40.03-20.17 20.86-81.68 82.71-100.5 101.5zM256 0L0 256l256 256 256-256L256 0zM16 256L256 16l240 240-240 240L16 256z"
    ]
};
var $ef0249c5e48bf4e3$export$8a8ef141dcbeda7b = {
    prefix: "fab",
    iconName: "rust",
    icon: [
        512,
        512,
        [],
        "e07a",
        "M508.52,249.75,486.7,236.24c-.17-2-.34-3.93-.55-5.88l18.72-17.5a7.35,7.35,0,0,0-2.44-12.25l-24-9c-.54-1.88-1.08-3.78-1.67-5.64l15-20.83a7.35,7.35,0,0,0-4.79-11.54l-25.42-4.15c-.9-1.73-1.79-3.45-2.73-5.15l10.68-23.42a7.35,7.35,0,0,0-6.95-10.39l-25.82.91q-1.79-2.22-3.61-4.4L439,81.84A7.36,7.36,0,0,0,430.16,73L405,78.93q-2.17-1.83-4.4-3.61l.91-25.82a7.35,7.35,0,0,0-10.39-7L367.7,53.23c-1.7-.94-3.43-1.84-5.15-2.73L358.4,25.08a7.35,7.35,0,0,0-11.54-4.79L326,35.26c-1.86-.59-3.75-1.13-5.64-1.67l-9-24a7.35,7.35,0,0,0-12.25-2.44l-17.5,18.72c-1.95-.21-3.91-.38-5.88-.55L262.25,3.48a7.35,7.35,0,0,0-12.5,0L236.24,25.3c-2,.17-3.93.34-5.88.55L212.86,7.13a7.35,7.35,0,0,0-12.25,2.44l-9,24c-1.89.55-3.79,1.08-5.66,1.68l-20.82-15a7.35,7.35,0,0,0-11.54,4.79l-4.15,25.41c-1.73.9-3.45,1.79-5.16,2.73L120.88,42.55a7.35,7.35,0,0,0-10.39,7l.92,25.81c-1.49,1.19-3,2.39-4.42,3.61L81.84,73A7.36,7.36,0,0,0,73,81.84L78.93,107c-1.23,1.45-2.43,2.93-3.62,4.41l-25.81-.91a7.42,7.42,0,0,0-6.37,3.26,7.35,7.35,0,0,0-.57,7.13l10.66,23.41c-.94,1.7-1.83,3.43-2.73,5.16L25.08,153.6a7.35,7.35,0,0,0-4.79,11.54l15,20.82c-.59,1.87-1.13,3.77-1.68,5.66l-24,9a7.35,7.35,0,0,0-2.44,12.25l18.72,17.5c-.21,1.95-.38,3.91-.55,5.88L3.48,249.75a7.35,7.35,0,0,0,0,12.5L25.3,275.76c.17,2,.34,3.92.55,5.87L7.13,299.13a7.35,7.35,0,0,0,2.44,12.25l24,9c.55,1.89,1.08,3.78,1.68,5.65l-15,20.83a7.35,7.35,0,0,0,4.79,11.54l25.42,4.15c.9,1.72,1.79,3.45,2.73,5.14L42.56,391.12a7.35,7.35,0,0,0,.57,7.13,7.13,7.13,0,0,0,6.37,3.26l25.83-.91q1.77,2.22,3.6,4.4L73,430.16A7.36,7.36,0,0,0,81.84,439L107,433.07q2.18,1.83,4.41,3.61l-.92,25.82a7.35,7.35,0,0,0,10.39,6.95l23.43-10.68c1.69.94,3.42,1.83,5.14,2.73l4.15,25.42a7.34,7.34,0,0,0,11.54,4.78l20.83-15c1.86.6,3.76,1.13,5.65,1.68l9,24a7.36,7.36,0,0,0,12.25,2.44l17.5-18.72c1.95.21,3.92.38,5.88.55l13.51,21.82a7.35,7.35,0,0,0,12.5,0l13.51-21.82c2-.17,3.93-.34,5.88-.56l17.5,18.73a7.36,7.36,0,0,0,12.25-2.44l9-24c1.89-.55,3.78-1.08,5.65-1.68l20.82,15a7.34,7.34,0,0,0,11.54-4.78l4.15-25.42c1.72-.9,3.45-1.79,5.15-2.73l23.42,10.68a7.35,7.35,0,0,0,10.39-6.95l-.91-25.82q2.22-1.79,4.4-3.61L430.16,439a7.36,7.36,0,0,0,8.84-8.84L433.07,405q1.83-2.17,3.61-4.4l25.82.91a7.23,7.23,0,0,0,6.37-3.26,7.35,7.35,0,0,0,.58-7.13L458.77,367.7c.94-1.7,1.83-3.43,2.73-5.15l25.42-4.15a7.35,7.35,0,0,0,4.79-11.54l-15-20.83c.59-1.87,1.13-3.76,1.67-5.65l24-9a7.35,7.35,0,0,0,2.44-12.25l-18.72-17.5c.21-1.95.38-3.91.55-5.87l21.82-13.51a7.35,7.35,0,0,0,0-12.5Zm-151,129.08A13.91,13.91,0,0,0,341,389.51l-7.64,35.67A187.51,187.51,0,0,1,177,424.44l-7.64-35.66a13.87,13.87,0,0,0-16.46-10.68l-31.51,6.76a187.38,187.38,0,0,1-16.26-19.21H258.3c1.72,0,2.89-.29,2.89-1.91V309.55c0-1.57-1.17-1.91-2.89-1.91H213.47l.05-34.35H262c4.41,0,23.66,1.28,29.79,25.87,1.91,7.55,6.17,32.14,9.06,40,2.89,8.82,14.6,26.46,27.1,26.46H407a187.3,187.3,0,0,1-17.34,20.09Zm25.77,34.49A15.24,15.24,0,1,1,368,398.08h.44A15.23,15.23,0,0,1,383.24,413.32Zm-225.62-.68a15.24,15.24,0,1,1-15.25-15.25h.45A15.25,15.25,0,0,1,157.62,412.64ZM69.57,234.15l32.83-14.6a13.88,13.88,0,0,0,7.06-18.33L102.69,186h26.56V305.73H75.65A187.65,187.65,0,0,1,69.57,234.15ZM58.31,198.09a15.24,15.24,0,0,1,15.23-15.25H74a15.24,15.24,0,1,1-15.67,15.24Zm155.16,24.49.05-35.32h63.26c3.28,0,23.07,3.77,23.07,18.62,0,12.29-15.19,16.7-27.68,16.7ZM399,306.71c-9.8,1.13-20.63-4.12-22-10.09-5.78-32.49-15.39-39.4-30.57-51.4,18.86-11.95,38.46-29.64,38.46-53.26,0-25.52-17.49-41.59-29.4-49.48-16.76-11-35.28-13.23-40.27-13.23H116.32A187.49,187.49,0,0,1,221.21,70.06l23.47,24.6a13.82,13.82,0,0,0,19.6.44l26.26-25a187.51,187.51,0,0,1,128.37,91.43l-18,40.57A14,14,0,0,0,408,220.43l34.59,15.33a187.12,187.12,0,0,1,.4,32.54H423.71c-1.91,0-2.69,1.27-2.69,3.13v8.82C421,301,409.31,305.58,399,306.71ZM240,60.21A15.24,15.24,0,0,1,255.21,45h.45A15.24,15.24,0,1,1,240,60.21ZM436.84,214a15.24,15.24,0,1,1,0-30.48h.44a15.24,15.24,0,0,1-.44,30.48Z"
    ]
};
var $ef0249c5e48bf4e3$export$423f2efa0d73b5f9 = {
    prefix: "fab",
    iconName: "wix",
    icon: [
        640,
        512,
        [],
        "f5cf",
        "M393.38 131.69c0 13.03 2.08 32.69-28.68 43.83-9.52 3.45-15.95 9.66-15.95 9.66 0-31 4.72-42.22 17.4-48.86 9.75-5.11 27.23-4.63 27.23-4.63zm-115.8 35.54l-34.24 132.66-28.48-108.57c-7.69-31.99-20.81-48.53-48.43-48.53-27.37 0-40.66 16.18-48.43 48.53L89.52 299.89 55.28 167.23C49.73 140.51 23.86 128.96 0 131.96l65.57 247.93s21.63 1.56 32.46-3.96c14.22-7.25 20.98-12.84 29.59-46.57 7.67-30.07 29.11-118.41 31.12-124.7 4.76-14.94 11.09-13.81 15.4 0 1.97 6.3 23.45 94.63 31.12 124.7 8.6 33.73 15.37 39.32 29.59 46.57 10.82 5.52 32.46 3.96 32.46 3.96l65.57-247.93c-24.42-3.07-49.82 8.93-55.3 35.27zm115.78 5.21s-4.1 6.34-13.46 11.57c-6.01 3.36-11.78 5.64-17.97 8.61-15.14 7.26-13.18 13.95-13.18 35.2v152.07s16.55 2.09 27.37-3.43c13.93-7.1 17.13-13.95 17.26-44.78V181.41l-.02.01v-8.98zm163.44 84.08L640 132.78s-35.11-5.98-52.5 9.85c-13.3 12.1-24.41 29.55-54.18 72.47-.47.73-6.25 10.54-13.07 0-29.29-42.23-40.8-60.29-54.18-72.47-17.39-15.83-52.5-9.85-52.5-9.85l83.2 123.74-82.97 123.36s36.57 4.62 53.95-11.21c11.49-10.46 17.58-20.37 52.51-70.72 6.81-10.52 12.57-.77 13.07 0 29.4 42.38 39.23 58.06 53.14 70.72 17.39 15.83 53.32 11.21 53.32 11.21L556.8 256.52z"
    ]
};
var $ef0249c5e48bf4e3$export$3a09eb8c07c8379f = {
    prefix: "fab",
    iconName: "square-behance",
    icon: [
        448,
        512,
        [
            "behance-square"
        ],
        "f1b5",
        "M155.3 318.4c17.2 0 31.2-6.1 31.2-25.4c0-19.7-11.7-27.4-30.3-27.5h-46v52.9h45.1zm-5.4-129.6H110.3v44.8H153c15.1 0 25.8-6.6 25.8-22.9c0-17.7-13.7-21.9-28.9-21.9zm129.5 74.8h62.2c-1.7-18.5-11.3-29.7-30.5-29.7c-18.3 0-30.5 11.4-31.7 29.7zM384 32H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64zM349.5 185H271.7V166.1h77.8V185zM193.7 243.7c23.6 6.7 35 27.5 35 51.6c0 39-32.7 55.7-67.6 55.9H68v-192h90.5c32.9 0 61.4 9.3 61.4 47.5c0 19.3-9 28.8-26.2 37zm118.7-38.6c43.5 0 67.6 34.3 67.6 75.4c0 1.6-.1 3.3-.2 5c0 .8-.1 1.5-.1 2.2H279.5c0 22.2 11.7 35.3 34.1 35.3c11.6 0 26.5-6.2 30.2-18.1h33.7c-10.4 31.9-31.9 46.8-65.1 46.8c-43.8 0-71.1-29.7-71.1-73c0-41.8 28.7-73.6 71.1-73.6z"
    ]
};
var $ef0249c5e48bf4e3$export$bb4b7fb598656746 = $ef0249c5e48bf4e3$export$3a09eb8c07c8379f;
var $ef0249c5e48bf4e3$export$9be373796460fb80 = {
    prefix: "fab",
    iconName: "supple",
    icon: [
        640,
        512,
        [],
        "f3f9",
        "M640 262.5c0 64.1-109 116.1-243.5 116.1-24.8 0-48.6-1.8-71.1-5 7.7.4 15.5.6 23.4.6 134.5 0 243.5-56.9 243.5-127.1 0-29.4-19.1-56.4-51.2-78 60 21.1 98.9 55.1 98.9 93.4zM47.7 227.9c-.1-70.2 108.8-127.3 243.3-127.6 7.9 0 15.6.2 23.3.5-22.5-3.2-46.3-4.9-71-4.9C108.8 96.3-.1 148.5 0 212.6c.1 38.3 39.1 72.3 99.3 93.3-32.3-21.5-51.5-48.6-51.6-78zm60.2 39.9s10.5 13.2 29.3 13.2c17.9 0 28.4-11.5 28.4-25.1 0-28-40.2-25.1-40.2-39.7 0-5.4 5.3-9.1 12.5-9.1 5.7 0 11.3 2.6 11.3 6.6v3.9h14.2v-7.9c0-12.1-15.4-16.8-25.4-16.8-16.5 0-28.5 10.2-28.5 24.1 0 26.6 40.2 25.4 40.2 39.9 0 6.6-5.8 10.1-12.3 10.1-11.9 0-20.7-10.1-20.7-10.1l-8.8 10.9zm120.8-73.6v54.4c0 11.3-7.1 17.8-17.8 17.8-10.7 0-17.8-6.5-17.8-17.7v-54.5h-15.8v55c0 18.9 13.4 31.9 33.7 31.9 20.1 0 33.4-13 33.4-31.9v-55h-15.7zm34.4 85.4h15.8v-29.5h15.5c16 0 27.2-11.5 27.2-28.1s-11.2-27.8-27.2-27.8h-39.1v13.4h7.8v72zm15.8-43v-29.1h12.9c8.7 0 13.7 5.7 13.7 14.4 0 8.9-5.1 14.7-14 14.7h-12.6zm57 43h15.8v-29.5h15.5c16 0 27.2-11.5 27.2-28.1s-11.2-27.8-27.2-27.8h-39.1v13.4h7.8v72zm15.7-43v-29.1h12.9c8.7 0 13.7 5.7 13.7 14.4 0 8.9-5 14.7-14 14.7h-12.6zm57.1 34.8c0 5.8 2.4 8.2 8.2 8.2h37.6c5.8 0 8.2-2.4 8.2-8.2v-13h-14.3v5.2c0 1.7-1 2.6-2.6 2.6h-18.6c-1.7 0-2.6-1-2.6-2.6v-61.2c0-5.7-2.4-8.2-8.2-8.2H401v13.4h5.2c1.7 0 2.6 1 2.6 2.6v61.2zm63.4 0c0 5.8 2.4 8.2 8.2 8.2H519c5.7 0 8.2-2.4 8.2-8.2v-13h-14.3v5.2c0 1.7-1 2.6-2.6 2.6h-19.7c-1.7 0-2.6-1-2.6-2.6v-20.3h27.7v-13.4H488v-22.4h19.2c1.7 0 2.6 1 2.6 2.6v5.2H524v-13c0-5.7-2.5-8.2-8.2-8.2h-51.6v13.4h7.8v63.9zm58.9-76v5.9h1.6v-5.9h2.7v-1.2h-7v1.2h2.7zm5.7-1.2v7.1h1.5v-5.7l2.3 5.7h1.3l2.3-5.7v5.7h1.5v-7.1h-2.3l-2.1 5.1-2.1-5.1h-2.4z"
    ]
};
var $ef0249c5e48bf4e3$export$b4c5293ffb331d6a = {
    prefix: "fab",
    iconName: "webflow",
    icon: [
        640,
        512,
        [],
        "e65c",
        "M640 64L435.8 463.2H244l85.5-165.5h-3.8C255.1 389.3 149.9 449.5 0 463.2V300.1s95.9-5.7 152.3-64.9H0V64H171.1V204.8l3.8 0L244.9 64H374.3V203.9l3.8 0L450.7 64H640z"
    ]
};
var $ef0249c5e48bf4e3$export$50bb8725ea3b3e34 = {
    prefix: "fab",
    iconName: "rebel",
    icon: [
        512,
        512,
        [],
        "f1d0",
        "M256.5 504C117.2 504 9 387.8 13.2 249.9 16 170.7 56.4 97.7 129.7 49.5c.3 0 1.9-.6 1.1.8-5.8 5.5-111.3 129.8-14.1 226.4 49.8 49.5 90 2.5 90 2.5 38.5-50.1-.6-125.9-.6-125.9-10-24.9-45.7-40.1-45.7-40.1l28.8-31.8c24.4 10.5 43.2 38.7 43.2 38.7.8-29.6-21.9-61.4-21.9-61.4L255.1 8l44.3 50.1c-20.5 28.8-21.9 62.6-21.9 62.6 13.8-23 43.5-39.3 43.5-39.3l28.5 31.8c-27.4 8.9-45.4 39.9-45.4 39.9-15.8 28.5-27.1 89.4.6 127.3 32.4 44.6 87.7-2.8 87.7-2.8 102.7-91.9-10.5-225-10.5-225-6.1-5.5.8-2.8.8-2.8 50.1 36.5 114.6 84.4 116.2 204.8C500.9 400.2 399 504 256.5 504z"
    ]
};
var $ef0249c5e48bf4e3$export$f32e22910f9b44 = {
    prefix: "fab",
    iconName: "css3",
    icon: [
        512,
        512,
        [],
        "f13c",
        "M480 32l-64 368-223.3 80L0 400l19.6-94.8h82l-8 40.6L210 390.2l134.1-44.4 18.8-97.1H29.5l16-82h333.7l10.5-52.7H56.3l16.3-82H480z"
    ]
};
var $ef0249c5e48bf4e3$export$ffbc7f79ed77f082 = {
    prefix: "fab",
    iconName: "staylinked",
    icon: [
        440,
        512,
        [],
        "f3f5",
        "M382.7 292.5l2.7 2.7-170-167.3c-3.5-3.5-9.7-3.7-13.8-.5L144.3 171c-4.2 3.2-4.6 8.7-1.1 12.2l68.1 64.3c3.6 3.5 9.9 3.7 14 .5l.1-.1c4.1-3.2 10.4-3 14 .5l84 81.3c3.6 3.5 3.2 9-.9 12.2l-93.2 74c-4.2 3.3-10.5 3.1-14.2-.4L63.2 268c-3.5-3.5-9.7-3.7-13.9-.5L3.5 302.4c-4.2 3.2-4.7 8.7-1.2 12.2L211 510.7s7.4 6.8 17.3-.8l198-163.9c4-3.2 4.4-8.7.7-12.2zm54.5-83.4L226.7 2.5c-1.5-1.2-8-5.5-16.3 1.1L3.6 165.7c-4.2 3.2-4.8 8.7-1.2 12.2l42.3 41.7 171.7 165.1c3.7 3.5 10.1 3.7 14.3.4l50.2-38.8-.3-.3 7.7-6c4.2-3.2 4.6-8.7.9-12.2l-57.1-54.4c-3.6-3.5-10-3.7-14.2-.5l-.1.1c-4.2 3.2-10.5 3.1-14.2-.4L109 180.8c-3.6-3.5-3.1-8.9 1.1-12.2l92.2-71.5c4.1-3.2 10.3-3 13.9.5l160.4 159c3.7 3.5 10 3.7 14.1.5l45.8-35.8c4.1-3.2 4.4-8.7.7-12.2z"
    ]
};
var $ef0249c5e48bf4e3$export$a03842279a704aae = {
    prefix: "fab",
    iconName: "kaggle",
    icon: [
        320,
        512,
        [],
        "f5fa",
        "M304.2 501.5L158.4 320.3 298.2 185c2.6-2.7 1.7-10.5-5.3-10.5h-69.2c-3.5 0-7 1.8-10.5 5.3L80.9 313.5V7.5q0-7.5-7.5-7.5H21.5Q14 0 14 7.5v497q0 7.5 7.5 7.5h51.9q7.5 0 7.5-7.5v-109l30.8-29.3 110.5 140.6c3 3.5 6.5 5.3 10.5 5.3h66.9q5.25 0 6-3z"
    ]
};
var $ef0249c5e48bf4e3$export$1aecd37105f38798 = {
    prefix: "fab",
    iconName: "space-awesome",
    icon: [
        512,
        512,
        [],
        "e5ac",
        "M96 256H128V512H0V352H32V320H64V288H96V256zM512 352V512H384V256H416V288H448V320H480V352H512zM320 64H352V448H320V416H192V448H160V64H192V32H224V0H288V32H320V64zM288 128H224V192H288V128z"
    ]
};
var $ef0249c5e48bf4e3$export$36a61c57a904744e = {
    prefix: "fab",
    iconName: "deviantart",
    icon: [
        320,
        512,
        [],
        "f1bd",
        "M320 93.2l-98.2 179.1 7.4 9.5H320v127.7H159.1l-13.5 9.2-43.7 84c-.3 0-8.6 8.6-9.2 9.2H0v-93.2l93.2-179.4-7.4-9.2H0V102.5h156l13.5-9.2 43.7-84c.3 0 8.6-8.6 9.2-9.2H320v93.1z"
    ]
};
var $ef0249c5e48bf4e3$export$4b1cbad29e4915c6 = {
    prefix: "fab",
    iconName: "cpanel",
    icon: [
        640,
        512,
        [],
        "f388",
        "M210.3 220.2c-5.6-24.8-26.9-41.2-51-41.2h-37c-7.1 0-12.5 4.5-14.3 10.9L73.1 320l24.7-.1c6.8 0 12.3-4.5 14.2-10.7l25.8-95.7h19.8c8.4 0 16.2 5.6 18.3 14.8 2.5 10.9-5.9 22.6-18.3 22.6h-10.3c-7 0-12.5 4.6-14.3 10.8l-6.4 23.8h32c37.2 0 58.3-36.2 51.7-65.3zm-156.5 28h18.6c6.9 0 12.4-4.4 14.3-10.9l6.2-23.6h-40C30 213.7 9 227.8 1.7 254.8-7 288.6 18.5 320 52 320h12.4l7.1-26.1c1.2-4.4-2.2-8.3-6.4-8.3H53.8c-24.7 0-24.9-37.4 0-37.4zm247.5-34.8h-77.9l-3.5 13.4c-2.4 9.6 4.5 18.5 14.2 18.5h57.5c4 0 2.4 4.3 2.1 5.3l-8.6 31.8c-.4 1.4-.9 5.3-5.5 5.3h-34.9c-5.3 0-5.3-7.9 0-7.9h21.6c6.8 0 12.3-4.6 14.2-10.8l3.5-13.2h-48.4c-39.2 0-43.6 63.8-.7 63.8l57.5.2c11.2 0 20.6-7.2 23.4-17.8l14-51.8c4.8-19.2-9.7-36.8-28.5-36.8zM633.1 179h-18.9c-4.9 0-9.2 3.2-10.4 7.9L568.2 320c20.7 0 39.8-13.8 44.9-34.5l26.5-98.2c1.2-4.3-2-8.3-6.5-8.3zm-236.3 34.7v.1h-48.3l-26.2 98c-1.2 4.4 2.2 8.3 6.4 8.3h18.9c4.8 0 9.2-3 10.4-7.8l17.2-64H395c12.5 0 21.4 11.8 18.1 23.4l-10.6 40c-1.2 4.3 1.9 8.3 6.4 8.3H428c4.6 0 9.1-2.9 10.3-7.8l8.8-33.1c9-33.1-15.9-65.4-50.3-65.4zm98.3 74.6c-3.6 0-6-3.4-5.1-6.7l8-30c.9-3.9 3.7-6 7.8-6h32.9c2.6 0 4.6 2.4 3.9 5.1l-.7 2.6c-.6 2-1.9 3-3.9 3h-21.6c-7 0-12.6 4.6-14.2 10.8l-3.5 13h53.4c10.5 0 20.3-6.6 23.2-17.6l3.2-12c4.9-19.1-9.3-36.8-28.3-36.8h-47.3c-17.9 0-33.8 12-38.6 29.6l-10.8 40c-5 17.7 8.3 36.7 28.3 36.7h66.7c6.8 0 12.3-4.5 14.2-10.7l5.7-21z"
    ]
};
var $ef0249c5e48bf4e3$export$659cd0fc2157d001 = {
    prefix: "fab",
    iconName: "goodreads-g",
    icon: [
        384,
        512,
        [],
        "f3a9",
        "M42.6 403.3h2.8c12.7 0 25.5 0 38.2.1 1.6 0 3.1-.4 3.6 2.1 7.1 34.9 30 54.6 62.9 63.9 26.9 7.6 54.1 7.8 81.3 1.8 33.8-7.4 56-28.3 68-60.4 8-21.5 10.7-43.8 11-66.5.1-5.8.3-47-.2-52.8l-.9-.3c-.8 1.5-1.7 2.9-2.5 4.4-22.1 43.1-61.3 67.4-105.4 69.1-103 4-169.4-57-172-176.2-.5-23.7 1.8-46.9 8.3-69.7C58.3 47.7 112.3.6 191.6 0c61.3-.4 101.5 38.7 116.2 70.3.5 1.1 1.3 2.3 2.4 1.9V10.6h44.3c0 280.3.1 332.2.1 332.2-.1 78.5-26.7 143.7-103 162.2-69.5 16.9-159 4.8-196-57.2-8-13.5-11.8-28.3-13-44.5zM188.9 36.5c-52.5-.5-108.5 40.7-115 133.8-4.1 59 14.8 122.2 71.5 148.6 27.6 12.9 74.3 15 108.3-8.7 47.6-33.2 62.7-97 54.8-154-9.7-71.1-47.8-120-119.6-119.7z"
    ]
};
var $ef0249c5e48bf4e3$export$ccce513bbd3bef1d = {
    prefix: "fab",
    iconName: "square-git",
    icon: [
        448,
        512,
        [
            "git-square"
        ],
        "f1d2",
        "M120.8 335.5c-5.9-.4-12.6-.8-20.2-1.3c-3.3 4.1-6.6 8.4-6.6 13.5c0 18.5 65.5 18.5 65.5-1.5c0-8.3-7.4-8.7-38.8-10.7zm7.8-117.9c-32.3 0-33.7 44.5-.7 44.5c32.5 0 31.7-44.5 .7-44.5zM384 32H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64zM243.9 172.2c-14.5 0-22.9-8.4-22.9-22.9c0-14.5 8.4-22.3 22.9-22.3c14.7 0 23.1 7.8 23.1 22.3s-8.4 22.9-23.1 22.9zM149.6 195h49.5l0 21.6-23.4 1.8c4.6 5.8 9.4 14 9.4 25.7c0 48.7-57.2 47.2-74.2 42.4l-8.4 13.4c5 .3 9.8 .6 14.3 .8c56.3 3.2 80.5 4.6 80.5 38.5c0 29.2-25.7 45.7-69.9 45.7c-46 0-63.5-11.6-63.5-31.7c0-11.4 5.1-17.5 14-25.9c-8.4-3.5-11.2-9.9-11.2-16.8c0-9.6 7.4-16.3 23-30.6l.2-.2c-12.4-6.1-21.8-19.3-21.8-38.1c0-51.6 56.6-53.3 81.6-46.8zM270.5 303.1l13 1.8 0 20.1H211.1V304.9c2.7-.4 5-.7 6.9-.9c9.9-1.2 10.1-1.3 10.1-6V223.3c0-4.4-.9-4.7-10.1-7.8c-1.9-.7-4.2-1.4-6.9-2.4l2.8-20.6h52.6V298c0 4.1 .2 4.6 4.1 5.1zm106.6-10.4L384 315c-10.9 5.4-26.9 10.2-41.4 10.2c-30.2 0-41.7-12.2-41.7-40.9V217.7c0-.8 0-1.4-.2-1.8c-.8-1.2-4.2-.7-19.6-.7V192.6c22.3-2.5 31.2-13.7 34-41.4h24.2c0 33.3-.6 38 .7 38.6c.3 .1 .7 0 1.3 0h35.8v25.4H339.3v60.7c0 .2 0 .5 0 .9c-.2 6.3-.9 30.4 37.9 15.9z"
    ]
};
var $ef0249c5e48bf4e3$export$545247d36a0c2435 = $ef0249c5e48bf4e3$export$ccce513bbd3bef1d;
var $ef0249c5e48bf4e3$export$b22e93e631701aa0 = {
    prefix: "fab",
    iconName: "square-tumblr",
    icon: [
        448,
        512,
        [
            "tumblr-square"
        ],
        "f174",
        "M448 96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96zM256.8 416c-75.5 0-91.9-55.5-91.9-87.9v-90H135.2c-3.4 0-6.2-2.8-6.2-6.2V189.4c0-4.5 2.8-8.5 7.1-10c38.8-13.7 50.9-47.5 52.7-73.2c.5-6.9 4.1-10.2 10-10.2h44.3c3.4 0 6.2 2.8 6.2 6.2v72h51.9c3.4 0 6.2 2.8 6.2 6.2v51.1c0 3.4-2.8 6.2-6.2 6.2H249.1V321c0 21.4 14.8 33.5 42.5 22.4c3-1.2 5.6-2 8-1.4c2.2 .5 3.6 2.1 4.6 4.9L318 387.1c1 3.2 2 6.7-.3 9.1c-8.5 9.1-31.2 19.8-60.9 19.8z"
    ]
};
var $ef0249c5e48bf4e3$export$b3979340ece626fe = $ef0249c5e48bf4e3$export$b22e93e631701aa0;
var $ef0249c5e48bf4e3$export$33a1efa865dd0849 = {
    prefix: "fab",
    iconName: "trello",
    icon: [
        448,
        512,
        [],
        "f181",
        "M392.3 32H56.1C25.1 32 0 57.1 0 88c-.1 0 0-4 0 336 0 30.9 25.1 56 56 56h336.2c30.8-.2 55.7-25.2 55.7-56V88c.1-30.8-24.8-55.8-55.6-56zM197 371.3c-.2 14.7-12.1 26.6-26.9 26.6H87.4c-14.8.1-26.9-11.8-27-26.6V117.1c0-14.8 12-26.9 26.9-26.9h82.9c14.8 0 26.9 12 26.9 26.9v254.2zm193.1-112c0 14.8-12 26.9-26.9 26.9h-81c-14.8 0-26.9-12-26.9-26.9V117.2c0-14.8 12-26.9 26.8-26.9h81.1c14.8 0 26.9 12 26.9 26.9v142.1z"
    ]
};
var $ef0249c5e48bf4e3$export$e119d42c61b568e2 = {
    prefix: "fab",
    iconName: "creative-commons-nc-jp",
    icon: [
        496,
        512,
        [],
        "f4ea",
        "M247.7 8C103.6 8 0 124.8 0 256c0 136.4 111.8 248 247.7 248C377.9 504 496 403.2 496 256 496 117.2 388.5 8 247.7 8zm.6 450.7c-112 0-203.6-92.5-203.6-202.7 0-21.1 3-41.2 9-60.3l127 56.5h-27.9v38.6h58.1l5.7 11.8v18.7h-63.8V360h63.8v56h61.7v-56h64.2v-35.7l81 36.1c-1.5 2.2-57.1 98.3-175.2 98.3zm87.6-137.3h-57.6v-18.7l2.9-5.6 54.7 24.3zm6.5-51.4v-17.8h-38.6l63-116H301l-43.4 96-23-10.2-39.6-85.7h-65.8l27.3 51-81.9-36.5c27.8-44.1 82.6-98.1 173.7-98.1 112.8 0 203 90 203 203.4 0 21-2.7 40.6-7.9 59l-101-45.1z"
    ]
};
var $ef0249c5e48bf4e3$export$17e9384897437d5a = {
    prefix: "fab",
    iconName: "get-pocket",
    icon: [
        448,
        512,
        [],
        "f265",
        "M407.6 64h-367C18.5 64 0 82.5 0 104.6v135.2C0 364.5 99.7 464 224.2 464c124 0 223.8-99.5 223.8-224.2V104.6c0-22.4-17.7-40.6-40.4-40.6zm-162 268.5c-12.4 11.8-31.4 11.1-42.4 0C89.5 223.6 88.3 227.4 88.3 209.3c0-16.9 13.8-30.7 30.7-30.7 17 0 16.1 3.8 105.2 89.3 90.6-86.9 88.6-89.3 105.5-89.3 16.9 0 30.7 13.8 30.7 30.7 0 17.8-2.9 15.7-114.8 123.2z"
    ]
};
var $ef0249c5e48bf4e3$export$53e7f606db333d60 = {
    prefix: "fab",
    iconName: "perbyte",
    icon: [
        448,
        512,
        [],
        "e083",
        "M305.314,284.578H246.6V383.3h58.711q24.423,0,38.193-13.77t13.77-36.11q0-21.826-14.032-35.335T305.314,284.578ZM149.435,128.7H90.724v98.723h58.711q24.42,0,38.19-13.773t13.77-36.107q0-21.826-14.029-35.338T149.435,128.7ZM366.647,32H81.353A81.445,81.445,0,0,0,0,113.352V398.647A81.445,81.445,0,0,0,81.353,480H366.647A81.445,81.445,0,0,0,448,398.647V113.352A81.445,81.445,0,0,0,366.647,32Zm63.635,366.647a63.706,63.706,0,0,1-63.635,63.635H81.353a63.706,63.706,0,0,1-63.635-63.635V113.352A63.706,63.706,0,0,1,81.353,49.718H366.647a63.706,63.706,0,0,1,63.635,63.634ZM305.314,128.7H246.6v98.723h58.711q24.423,0,38.193-13.773t13.77-36.107q0-21.826-14.032-35.338T305.314,128.7Z"
    ]
};
var $ef0249c5e48bf4e3$export$b84863db58925c09 = {
    prefix: "fab",
    iconName: "grunt",
    icon: [
        384,
        512,
        [],
        "f3ad",
        "M61.3 189.3c-1.1 10 5.2 19.1 5.2 19.1.7-7.5 2.2-12.8 4-16.6.4 10.3 3.2 23.5 12.8 34.1 6.9 7.6 35.6 23.3 54.9 6.1 1 2.4 2.1 5.3 3 8.5 2.9 10.3-2.7 25.3-2.7 25.3s15.1-17.1 13.9-32.5c10.8-.5 21.4-8.4 21.1-19.5 0 0-18.9 10.4-35.5-8.8-9.7-11.2-40.9-42-83.1-31.8 4.3 1 8.9 2.4 13.5 4.1h-.1c-4.2 2-6.5 7.1-7 12zm28.3-1.8c19.5 11 37.4 25.7 44.9 37-5.7 3.3-21.7 10.4-38-1.7-10.3-7.6-9.8-26.2-6.9-35.3zm142.1 45.8c-1.2 15.5 13.9 32.5 13.9 32.5s-5.6-15-2.7-25.3c.9-3.2 2-6 3-8.5 19.3 17.3 48 1.5 54.8-6.1 9.6-10.6 12.3-23.8 12.8-34.1 1.8 3.8 3.4 9.1 4 16.6 0 0 6.4-9.1 5.2-19.1-.6-5-2.9-10-7-11.8h-.1c4.6-1.8 9.2-3.2 13.5-4.1-42.3-10.2-73.4 20.6-83.1 31.8-16.7 19.2-35.5 8.8-35.5 8.8-.2 10.9 10.4 18.9 21.2 19.3zm62.7-45.8c3 9.1 3.4 27.7-7 35.4-16.3 12.1-32.2 5-37.9 1.6 7.5-11.4 25.4-26 44.9-37zM160 418.5h-29.4c-5.5 0-8.2 1.6-9.5 2.9-1.9 2-2.2 4.7-.9 8.1 3.5 9.1 11.4 16.5 13.7 18.6 3.1 2.7 7.5 4.3 11.8 4.3 4.4 0 8.3-1.7 11-4.6 7.5-8.2 11.9-17.1 13-19.8.6-1.5 1.3-4.5-.9-6.8-1.8-1.8-4.7-2.7-8.8-2.7zm189.2-101.2c-2.4 17.9-13 33.8-24.6 43.7-3.1-22.7-3.7-55.5-3.7-62.4 0-14.7 9.5-24.5 12.2-26.1 2.5-1.5 5.4-3 8.3-4.6 18-9.6 40.4-21.6 40.4-43.7 0-16.2-9.3-23.2-15.4-27.8-.8-.6-1.5-1.1-2.2-1.7-2.1-1.7-3.7-3-4.3-4.4-4.4-9.8-3.6-34.2-1.7-37.6.6-.6 16.7-20.9 11.8-39.2-2-7.4-6.9-13.3-14.1-17-5.3-2.7-11.9-4.2-19.5-4.5-.1-2-.5-3.9-.9-5.9-.6-2.6-1.1-5.3-.9-8.1.4-4.7.8-9 2.2-11.3 8.4-13.3 28.8-17.6 29-17.6l12.3-2.4-8.1-9.5c-.1-.2-17.3-17.5-46.3-17.5-7.9 0-16 1.3-24.1 3.9-24.2 7.8-42.9 30.5-49.4 39.3-3.1-1-6.3-1.9-9.6-2.7-4.2-15.8 9-38.5 9-38.5s-13.6-3-33.7 15.2c-2.6-6.5-8.1-20.5-1.8-37.2C184.6 10.1 177.2 26 175 40.4c-7.6-5.4-6.7-23.1-7.2-27.6-7.5.9-29.2 21.9-28.2 48.3-2 .5-3.9 1.1-5.9 1.7-6.5-8.8-25.1-31.5-49.4-39.3-7.9-2.2-16-3.5-23.9-3.5-29 0-46.1 17.3-46.3 17.5L6 46.9l12.3 2.4c.2 0 20.6 4.3 29 17.6 1.4 2.2 1.8 6.6 2.2 11.3.2 2.8-.4 5.5-.9 8.1-.4 1.9-.8 3.9-.9 5.9-7.7.3-14.2 1.8-19.5 4.5-7.2 3.7-12.1 9.6-14.1 17-5 18.2 11.2 38.5 11.8 39.2 1.9 3.4 2.7 27.8-1.7 37.6-.6 1.4-2.2 2.7-4.3 4.4-.7.5-1.4 1.1-2.2 1.7-6.1 4.6-15.4 11.7-15.4 27.8 0 22.1 22.4 34.1 40.4 43.7 3 1.6 5.8 3.1 8.3 4.6 2.7 1.6 12.2 11.4 12.2 26.1 0 6.9-.6 39.7-3.7 62.4-11.6-9.9-22.2-25.9-24.6-43.8 0 0-29.2 22.6-20.6 70.8 5.2 29.5 23.2 46.1 47 54.7 8.8 19.1 29.4 45.7 67.3 49.6C143 504.3 163 512 192.2 512h.2c29.1 0 49.1-7.7 63.6-19.5 37.9-3.9 58.5-30.5 67.3-49.6 23.8-8.7 41.7-25.2 47-54.7 8.2-48.4-21.1-70.9-21.1-70.9zM305.7 37.7c5.6-1.8 11.6-2.7 17.7-2.7 11 0 19.9 3 24.7 5-3.1 1.4-6.4 3.2-9.7 5.3-2.4-.4-5.6-.8-9.2-.8-10.5 0-20.5 3.1-28.7 8.9-12.3 8.7-18 16.9-20.7 22.4-2.2-1.3-4.5-2.5-7.1-3.7-1.6-.8-3.1-1.5-4.7-2.2 6.1-9.1 19.9-26.5 37.7-32.2zm21 18.2c-.8 1-1.6 2.1-2.3 3.2-3.3 5.2-3.9 11.6-4.4 17.8-.5 6.4-1.1 12.5-4.4 17-4.2.8-8.1 1.7-11.5 2.7-2.3-3.1-5.6-7-10.5-11.2 1.4-4.8 5.5-16.1 13.5-22.5 5.6-4.3 12.2-6.7 19.6-7zM45.6 45.3c-3.3-2.2-6.6-4-9.7-5.3 4.8-2 13.7-5 24.7-5 6.1 0 12 .9 17.7 2.7 17.8 5.8 31.6 23.2 37.7 32.1-1.6.7-3.2 1.4-4.8 2.2-2.5 1.2-4.9 2.5-7.1 3.7-2.6-5.4-8.3-13.7-20.7-22.4-8.3-5.8-18.2-8.9-28.8-8.9-3.4.1-6.6.5-9 .9zm44.7 40.1c-4.9 4.2-8.3 8-10.5 11.2-3.4-.9-7.3-1.9-11.5-2.7C65 89.5 64.5 83.4 64 77c-.5-6.2-1.1-12.6-4.4-17.8-.7-1.1-1.5-2.2-2.3-3.2 7.4.3 14 2.6 19.5 7 8 6.3 12.1 17.6 13.5 22.4zM58.1 259.9c-2.7-1.6-5.6-3.1-8.4-4.6-14.9-8-30.2-16.3-30.2-30.5 0-11.1 4.3-14.6 8.9-18.2l.5-.4c.7-.6 1.4-1.2 2.2-1.8-.9 7.2-1.9 13.3-2.7 14.9 0 0 12.1-15 15.7-44.3 1.4-11.5-1.1-34.3-5.1-43 .2 4.9 0 9.8-.3 14.4-.4-.8-.8-1.6-1.3-2.2-3.2-4-11.8-17.5-9.4-26.6.9-3.5 3.1-6 6.7-7.8 3.8-1.9 8.8-2.9 15.1-2.9 12.3 0 25.9 3.7 32.9 6 25.1 8 55.4 30.9 64.1 37.7.2.2.4.3.4.3l5.6 3.9-3.5-5.8c-.2-.3-19.1-31.4-53.2-46.5 2-2.9 7.4-8.1 21.6-15.1 21.4-10.5 46.5-15.8 74.3-15.8 27.9 0 52.9 5.3 74.3 15.8 14.2 6.9 19.6 12.2 21.6 15.1-34 15.1-52.9 46.2-53.1 46.5l-3.5 5.8 5.6-3.9s.2-.1.4-.3c8.7-6.8 39-29.8 64.1-37.7 7-2.2 20.6-6 32.9-6 6.3 0 11.3 1 15.1 2.9 3.5 1.8 5.7 4.4 6.7 7.8 2.5 9.1-6.1 22.6-9.4 26.6-.5.6-.9 1.3-1.3 2.2-.3-4.6-.5-9.5-.3-14.4-4 8.8-6.5 31.5-5.1 43 3.6 29.3 15.7 44.3 15.7 44.3-.8-1.6-1.8-7.7-2.7-14.9.7.6 1.5 1.2 2.2 1.8l.5.4c4.6 3.7 8.9 7.1 8.9 18.2 0 14.2-15.4 22.5-30.2 30.5-2.9 1.5-5.7 3.1-8.4 4.6-8.7 5-18 16.7-19.1 34.2-.9 14.6.9 49.9 3.4 75.9-12.4 4.8-26.7 6.4-39.7 6.8-2-4.1-3.9-8.5-5.5-13.1-.7-2-19.6-51.1-26.4-62.2 5.5 39 17.5 73.7 23.5 89.6-3.5-.5-7.3-.7-11.7-.7h-117c-4.4 0-8.3.3-11.7.7 6-15.9 18.1-50.6 23.5-89.6-6.8 11.2-25.7 60.3-26.4 62.2-1.6 4.6-3.5 9-5.5 13.1-13-.4-27.2-2-39.7-6.8 2.5-26 4.3-61.2 3.4-75.9-.9-17.4-10.3-29.2-19-34.2zM34.8 404.6c-12.1-20-8.7-54.1-3.7-59.1 10.9 34.4 47.2 44.3 74.4 45.4-2.7 4.2-5.2 7.6-7 10l-1.4 1.4c-7.2 7.8-8.6 18.5-4.1 31.8-22.7-.1-46.3-9.8-58.2-29.5zm45.7 43.5c6 1.1 12.2 1.9 18.6 2.4 3.5 8 7.4 15.9 12.3 23.1-14.4-5.9-24.4-16-30.9-25.5zM192 498.2c-60.6-.1-78.3-45.8-84.9-64.7-3.7-10.5-3.4-18.2.9-23.1 2.9-3.3 9.5-7.2 24.6-7.2h118.8c15.1 0 21.8 3.9 24.6 7.2 4.2 4.8 4.5 12.6.9 23.1-6.6 18.8-24.3 64.6-84.9 64.7zm80.6-24.6c4.9-7.2 8.8-15.1 12.3-23.1 6.4-.5 12.6-1.3 18.6-2.4-6.5 9.5-16.5 19.6-30.9 25.5zm76.6-69c-12 19.7-35.6 29.3-58.1 29.7 4.5-13.3 3.1-24.1-4.1-31.8-.4-.5-.9-1-1.4-1.5-1.8-2.4-4.3-5.8-7-10 27.2-1.2 63.5-11 74.4-45.4 5 5 8.4 39.1-3.8 59zM191.9 187.7h.2c12.7-.1 27.2-17.8 27.2-17.8-9.9 6-18.8 8.1-27.3 8.3-8.5-.2-17.4-2.3-27.3-8.3 0 0 14.5 17.6 27.2 17.8zm61.7 230.7h-29.4c-4.2 0-7.2.9-8.9 2.7-2.2 2.3-1.5 5.2-.9 6.7 1 2.6 5.5 11.3 13 19.3 2.7 2.9 6.6 4.5 11 4.5s8.7-1.6 11.8-4.2c2.3-2 10.2-9.2 13.7-18.1 1.3-3.3 1-6-.9-7.9-1.3-1.3-4-2.9-9.4-3z"
    ]
};
var $ef0249c5e48bf4e3$export$33e64266c9adb232 = {
    prefix: "fab",
    iconName: "weebly",
    icon: [
        512,
        512,
        [],
        "f5cc",
        "M425.09 65.83c-39.88 0-73.28 25.73-83.66 64.33-18.16-58.06-65.5-64.33-84.95-64.33-19.78 0-66.8 6.28-85.28 64.33-10.38-38.6-43.45-64.33-83.66-64.33C38.59 65.83 0 99.72 0 143.03c0 28.96 4.18 33.27 77.17 233.48 22.37 60.57 67.77 69.35 92.74 69.35 39.23 0 70.04-19.46 85.93-53.98 15.89 34.83 46.69 54.29 85.93 54.29 24.97 0 70.36-9.1 92.74-69.67 76.55-208.65 77.5-205.58 77.5-227.2.63-48.32-36.01-83.47-86.92-83.47zm26.34 114.81l-65.57 176.44c-7.92 21.49-21.22 37.22-46.24 37.22-23.44 0-37.38-12.41-44.03-33.9l-39.28-117.42h-.95L216.08 360.4c-6.96 21.5-20.9 33.6-44.02 33.6-25.02 0-38.33-15.74-46.24-37.22L60.88 181.55c-5.38-14.83-7.92-23.91-7.92-34.5 0-16.34 15.84-29.36 38.33-29.36 18.69 0 31.99 11.8 36.11 29.05l44.03 139.82h.95l44.66-136.79c6.02-19.67 16.47-32.08 38.96-32.08s32.94 12.11 38.96 32.08l44.66 136.79h.95l44.03-139.82c4.12-17.25 17.42-29.05 36.11-29.05 22.17 0 38.33 13.32 38.33 35.71-.32 7.87-4.12 16.04-7.61 27.24z"
    ]
};
var $ef0249c5e48bf4e3$export$38091cf7f8c68318 = {
    prefix: "fab",
    iconName: "connectdevelop",
    icon: [
        576,
        512,
        [],
        "f20e",
        "M550.5 241l-50.089-86.786c1.071-2.142 1.875-4.553 1.875-7.232 0-8.036-6.696-14.733-14.732-15.001l-55.447-95.893c.536-1.607 1.071-3.214 1.071-4.821 0-8.571-6.964-15.268-15.268-15.268-4.821 0-8.839 2.143-11.786 5.625H299.518C296.839 18.143 292.821 16 288 16s-8.839 2.143-11.518 5.625H170.411C167.464 18.143 163.447 16 158.625 16c-8.303 0-15.268 6.696-15.268 15.268 0 1.607.536 3.482 1.072 4.821l-55.983 97.233c-5.356 2.41-9.107 7.5-9.107 13.661 0 .535.268 1.071.268 1.607l-53.304 92.143c-7.232 1.339-12.59 7.5-12.59 15 0 7.232 5.089 13.393 12.054 15l55.179 95.358c-.536 1.607-.804 2.946-.804 4.821 0 7.232 5.089 13.393 12.054 14.732l51.697 89.732c-.536 1.607-1.071 3.482-1.071 5.357 0 8.571 6.964 15.268 15.268 15.268 4.821 0 8.839-2.143 11.518-5.357h106.875C279.161 493.857 283.447 496 288 496s8.839-2.143 11.518-5.357h107.143c2.678 2.946 6.696 4.821 10.982 4.821 8.571 0 15.268-6.964 15.268-15.268 0-1.607-.267-2.946-.803-4.285l51.697-90.268c6.964-1.339 12.054-7.5 12.054-14.732 0-1.607-.268-3.214-.804-4.821l54.911-95.358c6.964-1.339 12.322-7.5 12.322-15-.002-7.232-5.092-13.393-11.788-14.732zM153.535 450.732l-43.66-75.803h43.66v75.803zm0-83.839h-43.66c-.268-1.071-.804-2.142-1.339-3.214l44.999-47.41v50.624zm0-62.411l-50.357 53.304c-1.339-.536-2.679-1.34-4.018-1.607L43.447 259.75c.535-1.339.535-2.679.535-4.018s0-2.41-.268-3.482l51.965-90c2.679-.268 5.357-1.072 7.768-2.679l50.089 51.965v92.946zm0-102.322l-45.803-47.41c1.339-2.143 2.143-4.821 2.143-7.767 0-.268-.268-.804-.268-1.072l43.928-15.804v72.053zm0-80.625l-43.66 15.804 43.66-75.536v59.732zm326.519 39.108l.804 1.339L445.5 329.125l-63.75-67.232 98.036-101.518.268.268zM291.75 355.107l11.518 11.786H280.5l11.25-11.786zm-.268-11.25l-83.303-85.446 79.553-84.375 83.036 87.589-79.286 82.232zm5.357 5.893l79.286-82.232 67.5 71.25-5.892 28.125H313.714l-16.875-17.143zM410.411 44.393c1.071.536 2.142 1.072 3.482 1.34l57.857 100.714v.536c0 2.946.803 5.624 2.143 7.767L376.393 256l-83.035-87.589L410.411 44.393zm-9.107-2.143L287.732 162.518l-57.054-60.268 166.339-60h4.287zm-123.483 0c2.678 2.678 6.16 4.285 10.179 4.285s7.5-1.607 10.179-4.285h75L224.786 95.821 173.893 42.25h103.928zm-116.249 5.625l1.071-2.142a33.834 33.834 0 0 0 2.679-.804l51.161 53.84-54.911 19.821V47.875zm0 79.286l60.803-21.964 59.732 63.214-79.553 84.107-40.982-42.053v-83.304zm0 92.678L198 257.607l-36.428 38.304v-76.072zm0 87.858l42.053-44.464 82.768 85.982-17.143 17.678H161.572v-59.196zm6.964 162.053c-1.607-1.607-3.482-2.678-5.893-3.482l-1.071-1.607v-89.732h99.91l-91.607 94.821h-1.339zm129.911 0c-2.679-2.41-6.428-4.285-10.447-4.285s-7.767 1.875-10.447 4.285h-96.429l91.607-94.821h38.304l91.607 94.821H298.447zm120-11.786l-4.286 7.5c-1.339.268-2.41.803-3.482 1.339l-89.196-91.875h114.376l-17.412 83.036zm12.856-22.232l12.858-60.803h21.964l-34.822 60.803zm34.822-68.839h-20.357l4.553-21.16 17.143 18.214c-.535.803-1.071 1.874-1.339 2.946zm66.161-107.411l-55.447 96.697c-1.339.535-2.679 1.071-4.018 1.874l-20.625-21.964 34.554-163.928 45.803 79.286c-.267 1.339-.803 2.678-.803 4.285 0 1.339.268 2.411.536 3.75z"
    ]
};
var $ef0249c5e48bf4e3$export$c6c358b395e9032d = {
    prefix: "fab",
    iconName: "leanpub",
    icon: [
        576,
        512,
        [],
        "f212",
        "M386.539 111.485l15.096 248.955-10.979-.275c-36.232-.824-71.64 8.783-102.657 27.997-31.016-19.214-66.424-27.997-102.657-27.997-45.564 0-82.07 10.705-123.516 27.723L93.117 129.6c28.546-11.803 61.484-18.115 92.226-18.115 41.173 0 73.836 13.175 102.657 42.544 27.723-28.271 59.013-41.721 98.539-42.544zM569.07 448c-25.526 0-47.485-5.215-70.542-15.645-34.31-15.645-69.993-24.978-107.871-24.978-38.977 0-74.934 12.901-102.657 40.623-27.723-27.723-63.68-40.623-102.657-40.623-37.878 0-73.561 9.333-107.871 24.978C55.239 442.236 32.731 448 8.303 448H6.93L49.475 98.859C88.726 76.626 136.486 64 181.775 64 218.83 64 256.984 71.685 288 93.095 319.016 71.685 357.17 64 394.225 64c45.289 0 93.049 12.626 132.3 34.859L569.07 448zm-43.368-44.741l-34.036-280.246c-30.742-13.999-67.248-21.41-101.009-21.41-38.428 0-74.385 12.077-102.657 38.702-28.272-26.625-64.228-38.702-102.657-38.702-33.761 0-70.267 7.411-101.009 21.41L50.298 403.259c47.211-19.487 82.894-33.486 135.045-33.486 37.604 0 70.817 9.606 102.657 29.644 31.84-20.038 65.052-29.644 102.657-29.644 52.151 0 87.834 13.999 135.045 33.486z"
    ]
};
var $ef0249c5e48bf4e3$export$161a3454c1d6abdb = {
    prefix: "fab",
    iconName: "black-tie",
    icon: [
        448,
        512,
        [],
        "f27e",
        "M0 32v448h448V32H0zm316.5 325.2L224 445.9l-92.5-88.7 64.5-184-64.5-86.6h184.9L252 173.2l64.5 184z"
    ]
};
var $ef0249c5e48bf4e3$export$ec9cce37001091c7 = {
    prefix: "fab",
    iconName: "themeco",
    icon: [
        448,
        512,
        [],
        "f5c6",
        "M202.9 8.43c9.9-5.73 26-5.82 35.95-.21L430 115.85c10 5.6 18 19.44 18 30.86V364c0 11.44-8.06 25.29-18 31L238.81 503.74c-9.93 5.66-26 5.57-35.85-.21L17.86 395.12C8 389.34 0 375.38 0 364V146.71c0-11.44 8-25.36 17.91-31.08zm-77.4 199.83c-15.94 0-31.89.14-47.83.14v101.45H96.8V280h28.7c49.71 0 49.56-71.74 0-71.74zm140.14 100.29l-30.73-34.64c37-7.51 34.8-65.23-10.87-65.51-16.09 0-32.17-.14-48.26-.14v101.59h19.13v-33.91h18.41l29.56 33.91h22.76zm-41.59-82.32c23.34 0 23.26 32.46 0 32.46h-29.13v-32.46zm-95.56-1.6c21.18 0 21.11 38.85 0 38.85H96.18v-38.84zm192.65-18.25c-68.46 0-71 105.8 0 105.8 69.48-.01 69.41-105.8 0-105.8zm0 17.39c44.12 0 44.8 70.86 0 70.86s-44.43-70.86 0-70.86z"
    ]
};
var $ef0249c5e48bf4e3$export$15d5df18b87754e3 = {
    prefix: "fab",
    iconName: "python",
    icon: [
        448,
        512,
        [],
        "f3e2",
        "M439.8 200.5c-7.7-30.9-22.3-54.2-53.4-54.2h-40.1v47.4c0 36.8-31.2 67.8-66.8 67.8H172.7c-29.2 0-53.4 25-53.4 54.3v101.8c0 29 25.2 46 53.4 54.3 33.8 9.9 66.3 11.7 106.8 0 26.9-7.8 53.4-23.5 53.4-54.3v-40.7H226.2v-13.6h160.2c31.1 0 42.6-21.7 53.4-54.2 11.2-33.5 10.7-65.7 0-108.6zM286.2 404c11.1 0 20.1 9.1 20.1 20.3 0 11.3-9 20.4-20.1 20.4-11 0-20.1-9.2-20.1-20.4.1-11.3 9.1-20.3 20.1-20.3zM167.8 248.1h106.8c29.7 0 53.4-24.5 53.4-54.3V91.9c0-29-24.4-50.7-53.4-55.6-35.8-5.9-74.7-5.6-106.8.1-45.2 8-53.4 24.7-53.4 55.6v40.7h106.9v13.6h-147c-31.1 0-58.3 18.7-66.8 54.2-9.8 40.7-10.2 66.1 0 108.6 7.6 31.6 25.7 54.2 56.8 54.2H101v-48.8c0-35.3 30.5-66.4 66.8-66.4zm-6.7-142.6c-11.1 0-20.1-9.1-20.1-20.3.1-11.3 9-20.4 20.1-20.4 11 0 20.1 9.2 20.1 20.4s-9 20.3-20.1 20.3z"
    ]
};
var $ef0249c5e48bf4e3$export$d3988148e7ca3c41 = {
    prefix: "fab",
    iconName: "android",
    icon: [
        576,
        512,
        [],
        "f17b",
        "M420.55,301.93a24,24,0,1,1,24-24,24,24,0,0,1-24,24m-265.1,0a24,24,0,1,1,24-24,24,24,0,0,1-24,24m273.7-144.48,47.94-83a10,10,0,1,0-17.27-10h0l-48.54,84.07a301.25,301.25,0,0,0-246.56,0L116.18,64.45a10,10,0,1,0-17.27,10h0l47.94,83C64.53,202.22,8.24,285.55,0,384H576c-8.24-98.45-64.54-181.78-146.85-226.55"
    ]
};
var $ef0249c5e48bf4e3$export$d367d9d00bf47408 = {
    prefix: "fab",
    iconName: "bots",
    icon: [
        640,
        512,
        [],
        "e340",
        "M86.344,197.834a51.767,51.767,0,0,0-41.57,20.058V156.018a8.19,8.19,0,0,0-8.19-8.19H8.19A8.19,8.19,0,0,0,0,156.018V333.551a8.189,8.189,0,0,0,8.19,8.189H36.584a8.189,8.189,0,0,0,8.19-8.189v-8.088c11.628,13.373,25.874,19.769,41.573,19.769,34.6,0,61.922-26.164,61.922-73.843C148.266,225.452,121.229,197.834,86.344,197.834ZM71.516,305.691c-9.593,0-21.221-4.942-26.745-12.5V250.164c5.528-7.558,17.152-12.791,26.745-12.791,17.734,0,31.107,13.082,31.107,34.013C102.623,292.609,89.25,305.691,71.516,305.691Zm156.372-59.032a17.4,17.4,0,1,0,17.4,17.4A17.4,17.4,0,0,0,227.888,246.659ZM273.956,156.7V112.039a13.308,13.308,0,1,0-10.237,0V156.7a107.49,107.49,0,1,0,10.237,0Zm85.993,107.367c0,30.531-40.792,55.281-91.112,55.281s-91.111-24.75-91.111-55.281,40.792-55.281,91.111-55.281S359.949,233.532,359.949,264.062Zm-50.163,17.4a17.4,17.4,0,1,0-17.4-17.4h0A17.4,17.4,0,0,0,309.786,281.466ZM580.7,250.455c-14.828-2.617-22.387-3.78-22.387-9.885,0-5.523,7.268-9.884,17.735-9.884a65.56,65.56,0,0,1,34.484,10.1,8.171,8.171,0,0,0,11.288-2.468c.07-.11.138-.221.2-.333l8.611-14.886a8.2,8.2,0,0,0-2.867-11.123,99.863,99.863,0,0,0-52.014-14.138c-38.956,0-60.179,21.514-60.179,46.225,0,36.342,33.725,41.864,57.563,45.642,13.373,2.326,24.13,4.361,24.13,11.048,0,6.4-5.523,10.757-18.9,10.757-13.552,0-30.994-6.222-42.623-13.579a8.206,8.206,0,0,0-11.335,2.491c-.035.054-.069.108-.1.164l-10.2,16.891a8.222,8.222,0,0,0,2.491,11.066c15.224,10.3,37.663,16.692,59.441,16.692,40.409,0,63.957-19.769,63.957-46.515C640,260.63,604.537,254.816,580.7,250.455Zm-95.928,60.787a8.211,8.211,0,0,0-9.521-5.938,23.168,23.168,0,0,1-4.155.387c-7.849,0-12.5-6.106-12.5-14.245V240.28h20.349a8.143,8.143,0,0,0,8.141-8.143V209.466a8.143,8.143,0,0,0-8.141-8.143H458.594V171.091a8.143,8.143,0,0,0-8.143-8.143H422.257a8.143,8.143,0,0,0-8.143,8.143h0v30.232H399a8.143,8.143,0,0,0-8.143,8.143h0v22.671A8.143,8.143,0,0,0,399,240.28h15.115v63.667c0,27.037,15.408,41.282,43.9,41.282,12.183,0,21.383-2.2,27.6-5.446a8.161,8.161,0,0,0,4.145-9.278Z"
    ]
};
var $ef0249c5e48bf4e3$export$8190ad5ab3a607e2 = {
    prefix: "fab",
    iconName: "free-code-camp",
    icon: [
        576,
        512,
        [],
        "f2c5",
        "M97.22,96.21c10.36-10.65,16-17.12,16-21.9,0-2.76-1.92-5.51-3.83-7.42A14.81,14.81,0,0,0,101,64.05c-8.48,0-20.92,8.79-35.84,25.69C23.68,137,2.51,182.81,3.37,250.34s17.47,117,54.06,161.87C76.22,435.86,90.62,448,100.9,448a13.55,13.55,0,0,0,8.37-3.84c1.91-2.76,3.81-5.63,3.81-8.38,0-5.63-3.86-12.2-13.2-20.55-44.45-42.33-67.32-97-67.48-165C32.25,188.8,54,137.83,97.22,96.21ZM239.47,420.07c.58.37.91.55.91.55Zm93.79.55.17-.13C333.24,420.62,333.17,420.67,333.26,420.62Zm3.13-158.18c-16.24-4.15,50.41-82.89-68.05-177.17,0,0,15.54,49.38-62.83,159.57-74.27,104.35,23.46,168.73,34,175.23-6.73-4.35-47.4-35.7,9.55-128.64,11-18.3,25.53-34.87,43.5-72.16,0,0,15.91,22.45,7.6,71.13C287.7,364,354,342.91,355,343.94c22.75,26.78-17.72,73.51-21.58,76.55,5.49-3.65,117.71-78,33-188.1C360.43,238.4,352.62,266.59,336.39,262.44ZM510.88,89.69C496,72.79,483.52,64,475,64a14.81,14.81,0,0,0-8.39,2.84c-1.91,1.91-3.83,4.66-3.83,7.42,0,4.78,5.6,11.26,16,21.9,43.23,41.61,65,92.59,64.82,154.06-.16,68-23,122.63-67.48,165-9.34,8.35-13.18,14.92-13.2,20.55,0,2.75,1.9,5.62,3.81,8.38A13.61,13.61,0,0,0,475.1,448c10.28,0,24.68-12.13,43.47-35.79,36.59-44.85,53.14-94.38,54.06-161.87S552.32,137,510.88,89.69Z"
    ]
};
var $ef0249c5e48bf4e3$export$906602f6a1e50bdd = {
    prefix: "fab",
    iconName: "hornbill",
    icon: [
        512,
        512,
        [],
        "f592",
        "M76.38 370.3a37.8 37.8 0 1 1-32.07-32.42c-78.28-111.35 52-190.53 52-190.53-5.86 43-8.24 91.16-8.24 91.16-67.31 41.49.93 64.06 39.81 72.87a140.38 140.38 0 0 0 131.66 91.94c1.92 0 3.77-.21 5.67-.28l.11 18.86c-99.22 1.39-158.7-29.14-188.94-51.6zm108-327.7A37.57 37.57 0 0 0 181 21.45a37.95 37.95 0 1 0-31.17 54.22c-22.55 29.91-53.83 89.57-52.42 190l21.84-.15c0-.9-.14-1.77-.14-2.68A140.42 140.42 0 0 1 207 132.71c8-37.71 30.7-114.3 73.8-44.29 0 0 48.14 2.38 91.18 8.24 0 0-77.84-128-187.59-54.06zm304.19 134.17a37.94 37.94 0 1 0-53.84-28.7C403 126.13 344.89 99 251.28 100.33l.14 22.5c2.7-.15 5.39-.41 8.14-.41a140.37 140.37 0 0 1 130.49 88.76c39.1 9 105.06 31.58 38.46 72.54 0 0-2.34 48.13-8.21 91.16 0 0 133.45-81.16 49-194.61a37.45 37.45 0 0 0 19.31-3.5zM374.06 436.24c21.43-32.46 46.42-89.69 45.14-179.66l-19.52.14c.08 2.06.3 4.07.3 6.15a140.34 140.34 0 0 1-91.39 131.45c-8.85 38.95-31.44 106.66-72.77 39.49 0 0-48.12-2.34-91.19-8.22 0 0 79.92 131.34 191.9 51a37.5 37.5 0 0 0 3.64 14 37.93 37.93 0 1 0 33.89-54.29z"
    ]
};
var $ef0249c5e48bf4e3$export$530d32089c3347d5 = {
    prefix: "fab",
    iconName: "js",
    icon: [
        448,
        512,
        [],
        "f3b8",
        "M0 32v448h448V32H0zm243.8 349.4c0 43.6-25.6 63.5-62.9 63.5-33.7 0-53.2-17.4-63.2-38.5l34.3-20.7c6.6 11.7 12.6 21.6 27.1 21.6 13.8 0 22.6-5.4 22.6-26.5V237.7h42.1v143.7zm99.6 63.5c-39.1 0-64.4-18.6-76.7-43l34.3-19.8c9 14.7 20.8 25.6 41.5 25.6 17.4 0 28.6-8.7 28.6-20.8 0-14.4-11.4-19.5-30.7-28l-10.5-4.5c-30.4-12.9-50.5-29.2-50.5-63.5 0-31.6 24.1-55.6 61.6-55.6 26.8 0 46 9.3 59.8 33.7L368 290c-7.2-12.9-15-18-27.1-18-12.3 0-20.1 7.8-20.1 18 0 12.6 7.8 17.7 25.9 25.6l10.5 4.5c35.8 15.3 55.9 31 55.9 66.2 0 37.8-29.8 58.6-69.7 58.6z"
    ]
};
var $ef0249c5e48bf4e3$export$4ee0aea9bb537f01 = {
    prefix: "fab",
    iconName: "ideal",
    icon: [
        576,
        512,
        [],
        "e013",
        "M125.61,165.48a49.07,49.07,0,1,0,49.06,49.06A49.08,49.08,0,0,0,125.61,165.48ZM86.15,425.84h78.94V285.32H86.15Zm151.46-211.6c0-20-10-22.53-18.74-22.53H204.82V237.5h14.05C228.62,237.5,237.61,234.69,237.61,214.24Zm201.69,46V168.93h22.75V237.5h33.69C486.5,113.08,388.61,86.19,299.67,86.19H204.84V169h14c25.6,0,41.5,17.35,41.5,45.26,0,28.81-15.52,46-41.5,46h-14V425.88h94.83c144.61,0,194.94-67.16,196.72-165.64Zm-109.75,0H273.3V169h54.43v22.73H296v10.58h30V225H296V237.5h33.51Zm74.66,0-5.16-17.67H369.31l-5.18,17.67H340.47L368,168.92h32.35l27.53,91.34ZM299.65,32H32V480H299.65c161.85,0,251-79.73,251-224.52C550.62,172,518,32,299.65,32Zm0,426.92H53.07V53.07H299.65c142.1,0,229.9,64.61,229.9,202.41C529.55,389.57,448.55,458.92,299.65,458.92Zm83.86-264.85L376,219.88H392.4l-7.52-25.81Z"
    ]
};
var $ef0249c5e48bf4e3$export$61f81190d1a8b4b = {
    prefix: "fab",
    iconName: "git",
    icon: [
        512,
        512,
        [],
        "f1d3",
        "M216.29 158.39H137C97 147.9 6.51 150.63 6.51 233.18c0 30.09 15 51.23 35 61-25.1 23-37 33.85-37 49.21 0 11 4.47 21.14 17.89 26.81C8.13 383.61 0 393.35 0 411.65c0 32.11 28.05 50.82 101.63 50.82 70.75 0 111.79-26.42 111.79-73.18 0-58.66-45.16-56.5-151.63-63l13.43-21.55c27.27 7.58 118.7 10 118.7-67.89 0-18.7-7.73-31.71-15-41.07l37.41-2.84zm-63.42 241.9c0 32.06-104.89 32.1-104.89 2.43 0-8.14 5.27-15 10.57-21.54 77.71 5.3 94.32 3.37 94.32 19.11zm-50.81-134.58c-52.8 0-50.46-71.16 1.2-71.16 49.54 0 50.82 71.16-1.2 71.16zm133.3 100.51v-32.1c26.75-3.66 27.24-2 27.24-11V203.61c0-8.5-2.05-7.38-27.24-16.26l4.47-32.92H324v168.71c0 6.51.4 7.32 6.51 8.14l20.73 2.84v32.1zm52.45-244.31c-23.17 0-36.59-13.43-36.59-36.61s13.42-35.77 36.59-35.77c23.58 0 37 12.62 37 35.77s-13.42 36.61-37 36.61zM512 350.46c-17.49 8.53-43.1 16.26-66.28 16.26-48.38 0-66.67-19.5-66.67-65.46V194.75c0-5.42 1.05-4.06-31.71-4.06V154.5c35.78-4.07 50-22 54.47-66.27h38.63c0 65.83-1.34 61.81 3.26 61.81H501v40.65h-60.56v97.15c0 6.92-4.92 51.41 60.57 26.84z"
    ]
};
var $ef0249c5e48bf4e3$export$dad56877d4f4a953 = {
    prefix: "fab",
    iconName: "dev",
    icon: [
        448,
        512,
        [],
        "f6cc",
        "M120.12 208.29c-3.88-2.9-7.77-4.35-11.65-4.35H91.03v104.47h17.45c3.88 0 7.77-1.45 11.65-4.35 3.88-2.9 5.82-7.25 5.82-13.06v-69.65c-.01-5.8-1.96-10.16-5.83-13.06zM404.1 32H43.9C19.7 32 .06 51.59 0 75.8v360.4C.06 460.41 19.7 480 43.9 480h360.2c24.21 0 43.84-19.59 43.9-43.8V75.8c-.06-24.21-19.7-43.8-43.9-43.8zM154.2 291.19c0 18.81-11.61 47.31-48.36 47.25h-46.4V172.98h47.38c35.44 0 47.36 28.46 47.37 47.28l.01 70.93zm100.68-88.66H201.6v38.42h32.57v29.57H201.6v38.41h53.29v29.57h-62.18c-11.16.29-20.44-8.53-20.72-19.69V193.7c-.27-11.15 8.56-20.41 19.71-20.69h63.19l-.01 29.52zm103.64 115.29c-13.2 30.75-36.85 24.63-47.44 0l-38.53-144.8h32.57l29.71 113.72 29.57-113.72h32.58l-38.46 144.8z"
    ]
};
var $ef0249c5e48bf4e3$export$e999ee7aa7883e37 = {
    prefix: "fab",
    iconName: "sketch",
    icon: [
        512,
        512,
        [],
        "f7c6",
        "M27.5 162.2L9 187.1h90.5l6.9-130.7-78.9 105.8zM396.3 45.7L267.7 32l135.7 147.2-7.1-133.5zM112.2 218.3l-11.2-22H9.9L234.8 458zm2-31.2h284l-81.5-88.5L256.3 33zm297.3 9.1L277.6 458l224.8-261.7h-90.9zM415.4 69L406 56.4l.9 17.3 6.1 113.4h90.3zM113.5 93.5l-4.6 85.6L244.7 32 116.1 45.7zm287.7 102.7h-290l42.4 82.9L256.3 480l144.9-283.8z"
    ]
};
var $ef0249c5e48bf4e3$export$6bf616a61d0b7bf3 = {
    prefix: "fab",
    iconName: "yandex-international",
    icon: [
        320,
        512,
        [],
        "f414",
        "M129.5 512V345.9L18.5 48h55.8l81.8 229.7L250.2 0h51.3L180.8 347.8V512h-51.3z"
    ]
};
var $ef0249c5e48bf4e3$export$2bcb24672b4bf6e6 = {
    prefix: "fab",
    iconName: "cc-amex",
    icon: [
        576,
        512,
        [],
        "f1f3",
        "M0 432c0 26.5 21.5 48 48 48H528c26.5 0 48-21.5 48-48v-1.1H514.3l-31.9-35.1-31.9 35.1H246.8V267.1H181L262.7 82.4h78.6l28.1 63.2V82.4h97.2L483.5 130l17-47.6H576V80c0-26.5-21.5-48-48-48H48C21.5 32 0 53.5 0 80V432zm440.4-21.7L482.6 364l42 46.3H576l-68-72.1 68-72.1H525.4l-42 46.7-41.5-46.7H390.5L458 338.6l-67.4 71.6V377.1h-83V354.9h80.9V322.6H307.6V300.2h83V267.1h-122V410.3H440.4zm96.3-72L576 380.2V296.9l-39.3 41.4zm-36.3-92l36.9-100.6V246.3H576V103H515.8l-32.2 89.3L451.7 103H390.5V246.1L327.3 103H276.1L213.7 246.3h43l11.9-28.7h65.9l12 28.7h82.7V146L466 246.3h34.4zM282 185.4l19.5-46.9 19.4 46.9H282z"
    ]
};
var $ef0249c5e48bf4e3$export$2b557426f8d6820b = {
    prefix: "fab",
    iconName: "uber",
    icon: [
        448,
        512,
        [],
        "f402",
        "M414.1 32H33.9C15.2 32 0 47.2 0 65.9V446c0 18.8 15.2 34 33.9 34H414c18.7 0 33.9-15.2 33.9-33.9V65.9C448 47.2 432.8 32 414.1 32zM237.6 391.1C163 398.6 96.4 344.2 88.9 269.6h94.4V290c0 3.7 3 6.8 6.8 6.8H258c3.7 0 6.8-3 6.8-6.8v-67.9c0-3.7-3-6.8-6.8-6.8h-67.9c-3.7 0-6.8 3-6.8 6.8v20.4H88.9c7-69.4 65.4-122.2 135.1-122.2 69.7 0 128.1 52.8 135.1 122.2 7.5 74.5-46.9 141.1-121.5 148.6z"
    ]
};
var $ef0249c5e48bf4e3$export$64e4bc4b496fbbdf = {
    prefix: "fab",
    iconName: "github",
    icon: [
        496,
        512,
        [],
        "f09b",
        "M165.9 397.4c0 2-2.3 3.6-5.2 3.6-3.3.3-5.6-1.3-5.6-3.6 0-2 2.3-3.6 5.2-3.6 3-.3 5.6 1.3 5.6 3.6zm-31.1-4.5c-.7 2 1.3 4.3 4.3 4.9 2.6 1 5.6 0 6.2-2s-1.3-4.3-4.3-5.2c-2.6-.7-5.5.3-6.2 2.3zm44.2-1.7c-2.9.7-4.9 2.6-4.6 4.9.3 2 2.9 3.3 5.9 2.6 2.9-.7 4.9-2.6 4.6-4.6-.3-1.9-3-3.2-5.9-2.9zM244.8 8C106.1 8 0 113.3 0 252c0 110.9 69.8 205.8 169.5 239.2 12.8 2.3 17.3-5.6 17.3-12.1 0-6.2-.3-40.4-.3-61.4 0 0-70 15-84.7-29.8 0 0-11.4-29.1-27.8-36.6 0 0-22.9-15.7 1.6-15.4 0 0 24.9 2 38.6 25.8 21.9 38.6 58.6 27.5 72.9 20.9 2.3-16 8.8-27.1 16-33.7-55.9-6.2-112.3-14.3-112.3-110.5 0-27.5 7.6-41.3 23.6-58.9-2.6-6.5-11.1-33.3 2.6-67.9 20.9-6.5 69 27 69 27 20-5.6 41.5-8.5 62.8-8.5s42.8 2.9 62.8 8.5c0 0 48.1-33.6 69-27 13.7 34.7 5.2 61.4 2.6 67.9 16 17.7 25.8 31.5 25.8 58.9 0 96.5-58.9 104.2-114.8 110.5 9.2 7.9 17 22.9 17 46.4 0 33.7-.3 75.4-.3 83.6 0 6.5 4.6 14.4 17.3 12.1C428.2 457.8 496 362.9 496 252 496 113.3 383.5 8 244.8 8zM97.2 352.9c-1.3 1-1 3.3.7 5.2 1.6 1.6 3.9 2.3 5.2 1 1.3-1 1-3.3-.7-5.2-1.6-1.6-3.9-2.3-5.2-1zm-10.8-8.1c-.7 1.3.3 2.9 2.3 3.9 1.6 1 3.6.7 4.3-.7.7-1.3-.3-2.9-2.3-3.9-2-.6-3.6-.3-4.3.7zm32.4 35.6c-1.6 1.3-1 4.3 1.3 6.2 2.3 2.3 5.2 2.6 6.5 1 1.3-1.3.7-4.3-1.3-6.2-2.2-2.3-5.2-2.6-6.5-1zm-11.4-14.7c-1.6 1-1.6 3.6 0 5.9 1.6 2.3 4.3 3.3 5.6 2.3 1.6-1.3 1.6-3.9 0-6.2-1.4-2.3-4-3.3-5.6-2z"
    ]
};
var $ef0249c5e48bf4e3$export$e1ae2a8de48825fb = {
    prefix: "fab",
    iconName: "php",
    icon: [
        640,
        512,
        [],
        "f457",
        "M320 104.5c171.4 0 303.2 72.2 303.2 151.5S491.3 407.5 320 407.5c-171.4 0-303.2-72.2-303.2-151.5S148.7 104.5 320 104.5m0-16.8C143.3 87.7 0 163 0 256s143.3 168.3 320 168.3S640 349 640 256 496.7 87.7 320 87.7zM218.2 242.5c-7.9 40.5-35.8 36.3-70.1 36.3l13.7-70.6c38 0 63.8-4.1 56.4 34.3zM97.4 350.3h36.7l8.7-44.8c41.1 0 66.6 3 90.2-19.1 26.1-24 32.9-66.7 14.3-88.1-9.7-11.2-25.3-16.7-46.5-16.7h-70.7L97.4 350.3zm185.7-213.6h36.5l-8.7 44.8c31.5 0 60.7-2.3 74.8 10.7 14.8 13.6 7.7 31-8.3 113.1h-37c15.4-79.4 18.3-86 12.7-92-5.4-5.8-17.7-4.6-47.4-4.6l-18.8 96.6h-36.5l32.7-168.6zM505 242.5c-8 41.1-36.7 36.3-70.1 36.3l13.7-70.6c38.2 0 63.8-4.1 56.4 34.3zM384.2 350.3H421l8.7-44.8c43.2 0 67.1 2.5 90.2-19.1 26.1-24 32.9-66.7 14.3-88.1-9.7-11.2-25.3-16.7-46.5-16.7H417l-32.8 168.7z"
    ]
};
var $ef0249c5e48bf4e3$export$994c329bc073af57 = {
    prefix: "fab",
    iconName: "alipay",
    icon: [
        448,
        512,
        [],
        "f642",
        "M377.74 32H70.26C31.41 32 0 63.41 0 102.26v307.48C0 448.59 31.41 480 70.26 480h307.48c38.52 0 69.76-31.08 70.26-69.6-45.96-25.62-110.59-60.34-171.6-88.44-32.07 43.97-84.14 81-148.62 81-70.59 0-93.73-45.3-97.04-76.37-3.97-39.01 14.88-81.5 99.52-81.5 35.38 0 79.35 10.25 127.13 24.96 16.53-30.09 26.45-60.34 26.45-60.34h-178.2v-16.7h92.08v-31.24H88.28v-19.01h109.44V92.34h50.92v50.42h109.44v19.01H248.63v31.24h88.77s-15.21 46.62-38.35 90.92c48.93 16.7 100.01 36.04 148.62 52.74V102.26C447.83 63.57 416.43 32 377.74 32zM47.28 322.95c.99 20.17 10.25 53.73 69.93 53.73 52.07 0 92.58-39.68 117.87-72.9-44.63-18.68-84.48-31.41-109.44-31.41-67.45 0-79.35 33.06-78.36 50.58z"
    ]
};
var $ef0249c5e48bf4e3$export$2373b132177332f8 = {
    prefix: "fab",
    iconName: "youtube",
    icon: [
        576,
        512,
        [
            61802
        ],
        "f167",
        "M549.655 124.083c-6.281-23.65-24.787-42.276-48.284-48.597C458.781 64 288 64 288 64S117.22 64 74.629 75.486c-23.497 6.322-42.003 24.947-48.284 48.597-11.412 42.867-11.412 132.305-11.412 132.305s0 89.438 11.412 132.305c6.281 23.65 24.787 41.5 48.284 47.821C117.22 448 288 448 288 448s170.78 0 213.371-11.486c23.497-6.321 42.003-24.171 48.284-47.821 11.412-42.867 11.412-132.305 11.412-132.305s0-89.438-11.412-132.305zm-317.51 213.508V175.185l142.739 81.205-142.739 81.201z"
    ]
};
var $ef0249c5e48bf4e3$export$b2254aecfa43ac3e = {
    prefix: "fab",
    iconName: "skyatlas",
    icon: [
        640,
        512,
        [],
        "f216",
        "M640 329.3c0 65.9-52.5 114.4-117.5 114.4-165.9 0-196.6-249.7-359.7-249.7-146.9 0-147.1 212.2 5.6 212.2 42.5 0 90.9-17.8 125.3-42.5 5.6-4.1 16.9-16.3 22.8-16.3s10.9 5 10.9 10.9c0 7.8-13.1 19.1-18.7 24.1-40.9 35.6-100.3 61.2-154.7 61.2-83.4.1-154-59-154-144.9s67.5-149.1 152.8-149.1c185.3 0 222.5 245.9 361.9 245.9 99.9 0 94.8-139.7 3.4-139.7-17.5 0-35 11.6-46.9 11.6-8.4 0-15.9-7.2-15.9-15.6 0-11.6 5.3-23.7 5.3-36.3 0-66.6-50.9-114.7-116.9-114.7-53.1 0-80 36.9-88.8 36.9-6.2 0-11.2-5-11.2-11.2 0-5.6 4.1-10.3 7.8-14.4 25.3-28.8 64.7-43.7 102.8-43.7 79.4 0 139.1 58.4 139.1 137.8 0 6.9-.3 13.7-1.2 20.6 11.9-3.1 24.1-4.7 35.9-4.7 60.7 0 111.9 45.3 111.9 107.2z"
    ]
};
var $ef0249c5e48bf4e3$export$db16178b6453c842 = {
    prefix: "fab",
    iconName: "firefox-browser",
    icon: [
        512,
        512,
        [],
        "e007",
        "M130.22 127.548C130.38 127.558 130.3 127.558 130.22 127.548V127.548ZM481.64 172.898C471.03 147.398 449.56 119.898 432.7 111.168C446.42 138.058 454.37 165.048 457.4 185.168C457.405 185.306 457.422 185.443 457.45 185.578C429.87 116.828 383.098 89.1089 344.9 28.7479C329.908 5.05792 333.976 3.51792 331.82 4.08792L331.7 4.15792C284.99 30.1109 256.365 82.5289 249.12 126.898C232.503 127.771 216.219 131.895 201.19 139.035C199.838 139.649 198.736 140.706 198.066 142.031C197.396 143.356 197.199 144.87 197.506 146.323C197.7 147.162 198.068 147.951 198.586 148.639C199.103 149.327 199.76 149.899 200.512 150.318C201.264 150.737 202.096 150.993 202.954 151.071C203.811 151.148 204.676 151.045 205.491 150.768L206.011 150.558C221.511 143.255 238.408 139.393 255.541 139.238C318.369 138.669 352.698 183.262 363.161 201.528C350.161 192.378 326.811 183.338 304.341 187.248C392.081 231.108 368.541 381.784 246.951 376.448C187.487 373.838 149.881 325.467 146.421 285.648C146.421 285.648 157.671 243.698 227.041 243.698C234.541 243.698 255.971 222.778 256.371 216.698C256.281 214.698 213.836 197.822 197.281 181.518C188.434 172.805 184.229 168.611 180.511 165.458C178.499 163.75 176.392 162.158 174.201 160.688C168.638 141.231 168.399 120.638 173.51 101.058C148.45 112.468 128.96 130.508 114.8 146.428H114.68C105.01 134.178 105.68 93.7779 106.25 85.3479C106.13 84.8179 99.022 89.0159 98.1 89.6579C89.5342 95.7103 81.5528 102.55 74.26 110.088C57.969 126.688 30.128 160.242 18.76 211.318C14.224 231.701 12 255.739 12 263.618C12 398.318 121.21 507.508 255.92 507.508C376.56 507.508 478.939 420.281 496.35 304.888C507.922 228.192 481.64 173.82 481.64 172.898Z"
    ]
};
var $ef0249c5e48bf4e3$export$a51c205a2c2f1780 = {
    prefix: "fab",
    iconName: "replyd",
    icon: [
        448,
        512,
        [],
        "f3e6",
        "M320 480H128C57.6 480 0 422.4 0 352V160C0 89.6 57.6 32 128 32h192c70.4 0 128 57.6 128 128v192c0 70.4-57.6 128-128 128zM193.4 273.2c-6.1-2-11.6-3.1-16.4-3.1-7.2 0-13.5 1.9-18.9 5.6-5.4 3.7-9.6 9-12.8 15.8h-1.1l-4.2-18.3h-28v138.9h36.1v-89.7c1.5-5.4 4.4-9.8 8.7-13.2 4.3-3.4 9.8-5.1 16.2-5.1 4.6 0 9.8 1 15.6 3.1l4.8-34zm115.2 103.4c-3.2 2.4-7.7 4.8-13.7 7.1-6 2.3-12.8 3.5-20.4 3.5-12.2 0-21.1-3-26.5-8.9-5.5-5.9-8.5-14.7-9-26.4h83.3c.9-4.8 1.6-9.4 2.1-13.9.5-4.4.7-8.6.7-12.5 0-10.7-1.6-19.7-4.7-26.9-3.2-7.2-7.3-13-12.5-17.2-5.2-4.3-11.1-7.3-17.8-9.2-6.7-1.8-13.5-2.8-20.6-2.8-21.1 0-37.5 6.1-49.2 18.3s-17.5 30.5-17.5 55c0 22.8 5.2 40.7 15.6 53.7 10.4 13.1 26.8 19.6 49.2 19.6 10.7 0 20.9-1.5 30.4-4.6 9.5-3.1 17.1-6.8 22.6-11.2l-12-23.6zm-21.8-70.3c3.8 5.4 5.3 13.1 4.6 23.1h-51.7c.9-9.4 3.7-17 8.2-22.6 4.5-5.6 11.5-8.5 21-8.5 8.2-.1 14.1 2.6 17.9 8zm79.9 2.5c4.1 3.9 9.4 5.8 16.1 5.8 7 0 12.6-1.9 16.7-5.8s6.1-9.1 6.1-15.6-2-11.6-6.1-15.4c-4.1-3.8-9.6-5.7-16.7-5.7-6.7 0-12 1.9-16.1 5.7-4.1 3.8-6.1 8.9-6.1 15.4s2 11.7 6.1 15.6zm0 100.5c4.1 3.9 9.4 5.8 16.1 5.8 7 0 12.6-1.9 16.7-5.8s6.1-9.1 6.1-15.6-2-11.6-6.1-15.4c-4.1-3.8-9.6-5.7-16.7-5.7-6.7 0-12 1.9-16.1 5.7-4.1 3.8-6.1 8.9-6.1 15.4 0 6.6 2 11.7 6.1 15.6z"
    ]
};
var $ef0249c5e48bf4e3$export$fd2c25240484ff41 = {
    prefix: "fab",
    iconName: "suse",
    icon: [
        640,
        512,
        [],
        "f7d6",
        "M593.1 192.6A10.4 10.4 0 1 1 604.5 210a10.4 10.4 0 1 1 -11.4-17.4zm-47.1 12.2a38.5 38.5 0 1 1 75-17.6 38.5 38.5 0 1 1 -75 17.6zM433.7 336.7c3.2 4.6 5.8 9 7.3 13.4c1 3.1 2.4 7.3 5.5 8.9c.2 .1 .3 .2 .5 .2c5.7 2.1 20.3 1.7 20.3 1.7h26.8c2.3 0 22.4 0 21.9-2.3c-2.4-10.8-14.9-12.7-24.4-18.3c-8.7-5.2-17-11.1-20.8-21.3c-2-5.2-.8-17.4 2.6-21.8c2.5-3.2 6.1-5.3 10-6.2c4.3-.9 8.8-.1 13.1 .3c5.3 .5 10.6 1.5 15.9 2.2c10.3 1.3 20.6 1.9 31 1.6c17.1-.5 34.2-3.2 50.4-8.7c11.3-3.8 22.4-8.9 32-16.1c10.9-8.1 8.1-7.4-3-6.2c-13.3 1.4-26.6 1.6-39.9 .8c-12.4-.7-24.7-2.2-35.9-7.9c-8.8-4.6-16.4-9.1-23.4-16.2c-1-1.1-1.7-4.2 .2-6.2c1.9-1.9 5.8-.8 7 .2c12.2 10.2 30.5 18.6 49.3 19.5c10.2 .5 20.1 .7 30.4 .3c5.1-.2 12.8-.2 17.9-.3c2.6 0 9.8 .7 11.2-2.1c.4-.8 .4-1.8 .3-2.7c-1.5-40.9-4.5-86.9-47.3-106.5c-31.9-14.6-79.7-37.2-99.9-46.6c-4.7-2.2-10.2 1.3-10.2 6.5c0 13.6 .7 33.3 .7 51.1c-9.7-9.9-26-16.1-38.4-21.8c-14.1-6.5-28.7-12-43.5-16.6c-29.8-9.2-60.7-14.9-91.7-18c-35.2-3.5-71-1.8-105.7 5.3C147 115.1 90.8 142.6 48.2 182.7C22.1 207.3 1.6 242.4 .2 277.9c-2 50.3 12.1 77.3 38 105.2c41.3 44.4 130.2 50.6 166.2-2c16.2-23.7 19.7-55.8 8-82c-11.8-26.2-38.8-45.1-67.4-46c-22.2-.7-45.9 10.6-54.5 31.1c-6.5 15.7-2.8 35.1 9 47.3c4.6 4.8 10.9 8.7 17.7 7.1c4-.9 7.4-3.9 8-8c.9-6-4.4-9.9-7.6-14.5c-5.8-8.3-4.7-20.9 2.7-27.9c6.2-6 15.3-7.8 23.9-7.7c8 0 16.2 1.4 23.1 5.5c9.7 5.7 16.2 16.2 18.4 27.2c6.7 33-20.2 59.9-56.6 62c-18.6 1.1-37.6-3.8-52.1-15.5C40.1 329.9 31.1 269.4 73.2 237c40-30.7 90.4-22.8 120.2-6.8c23.8 12.8 41.5 33.6 55 56.7c6.7 11.6 12.5 23.7 17.8 36.1c5.1 11.8 9.9 23.8 20.2 32.5c6.8 5.8 15.2 5.6 24.1 5.6h50.8c6.9 0 5.2-4.6 2.2-7.7c-6.7-6.9-16.4-8.4-25.4-10.9c-20.5-5.6-18.4-32.8-12.7-32.8c18.3 0 18.9 .6 34.9 .3c23.2-.3 30.2-1.7 48.3 5c9.7 3.6 19 13.1 25.1 21.7z"
    ]
};
var $ef0249c5e48bf4e3$export$595f8e07121dc03e = {
    prefix: "fab",
    iconName: "jenkins",
    icon: [
        512,
        512,
        [],
        "f3b6",
        "M487.1 425c-1.4-11.2-19-23.1-28.2-31.9-5.1-5-29-23.1-30.4-29.9-1.4-6.6 9.7-21.5 13.3-28.9 5.1-10.7 8.8-23.7 11.3-32.6 18.8-66.1 20.7-156.9-6.2-211.2-10.2-20.6-38.6-49-56.4-62.5-42-31.7-119.6-35.3-170.1-16.6-14.1 5.2-27.8 9.8-40.1 17.1-33.1 19.4-68.3 32.5-78.1 71.6-24.2 10.8-31.5 41.8-30.3 77.8.2 7 4.1 15.8 2.7 22.4-.7 3.3-5.2 7.6-6.1 9.8-11.6 27.7-2.3 64 11.1 83.7 8.1 11.9 21.5 22.4 39.2 25.2.7 10.6 3.3 19.7 8.2 30.4 3.1 6.8 14.7 19 10.4 27.7-2.2 4.4-21 13.8-27.3 17.6C89 407.2 73.7 415 54.2 429c-12.6 9-32.3 10.2-29.2 31.1 2.1 14.1 10.1 31.6 14.7 45.8.7 2 1.4 4.1 2.1 6h422c4.9-15.3 9.7-30.9 14.6-47.2 3.4-11.4 10.2-27.8 8.7-39.7zM205.9 33.7c1.8-.5 3.4.7 4.9 2.4-.2 5.2-5.4 5.1-8.9 6.8-5.4 6.7-13.4 9.8-20 17.2-6.8 7.5-14.4 27.7-23.4 30-4.5 1.1-9.7-.8-13.6-.5-10.4.7-17.7 6-28.3 7.5 13.6-29.9 56.1-54 89.3-63.4zm-104.8 93.6c13.5-14.9 32.1-24.1 54.8-25.9 11.7 29.7-8.4 65-.9 97.6 2.3 9.9 10.2 25.4-2.4 25.7.3-28.3-34.8-46.3-61.3-29.6-1.8-21.5-4.9-51.7 9.8-67.8zm36.7 200.2c-1-4.1-2.7-12.9-2.3-15.1 1.6-8.7 17.1-12.5 11-24.7-11.3-.1-13.8 10.2-24.1 11.3-26.7 2.6-45.6-35.4-44.4-58.4 1-19.5 17.6-38.2 40.1-35.8 16 1.8 21.4 19.2 24.5 34.7 9.2.5 22.5-.4 26.9-7.6-.6-17.5-8.8-31.6-8.2-47.7 1-30.3 17.5-57.6 4.8-87.4 13.6-30.9 53.5-55.3 83.1-70 36.6-18.3 94.9-3.7 129.3 15.8 19.7 11.1 34.4 32.7 48.3 50.7-19.5-5.8-36.1 4.2-33.1 20.3 16.3-14.9 44.2-.2 52.5 16.4 7.9 15.8 7.8 39.3 9 62.8 2.9 57-10.4 115.9-39.1 157.1-7.7 11-14.1 23-24.9 30.6-26 18.2-65.4 34.7-99.2 23.4-44.7-15-65-44.8-89.5-78.8.7 18.7 13.8 34.1 26.8 48.4 11.3 12.5 25 26.6 39.7 32.4-12.3-2.9-31.1-3.8-36.2 7.2-28.6-1.9-55.1-4.8-68.7-24.2-10.6-15.4-21.4-41.4-26.3-61.4zm222 124.1c4.1-3 11.1-2.9 17.4-3.6-5.4-2.7-13-3.7-19.3-2.2-.1-4.2-2-6.8-3.2-10.2 10.6-3.8 35.5-28.5 49.6-20.3 6.7 3.9 9.5 26.2 10.1 37 .4 9-.8 18-4.5 22.8-18.8-.6-35.8-2.8-50.7-7 .9-6.1-1-12.1.6-16.5zm-17.2-20c-16.8.8-26-1.2-38.3-10.8.2-.8 1.4-.5 1.5-1.4 18 8 40.8-3.3 59-4.9-7.9 5.1-14.6 11.6-22.2 17.1zm-12.1 33.2c-1.6-9.4-3.5-12-2.8-20.2 25-16.6 29.7 28.6 2.8 20.2zM226 438.6c-11.6-.7-48.1-14-38.5-23.7 9.4 6.5 27.5 4.9 41.3 7.3.8 4.4-2.8 10.2-2.8 16.4zM57.7 497.1c-4.3-12.7-9.2-25.1-14.8-36.9 30.8-23.8 65.3-48.9 102.2-63.5 2.8-1.1 23.2 25.4 26.2 27.6 16.5 11.7 37 21 56.2 30.2 1.2 8.8 3.9 20.2 8.7 35.5.7 2.3 1.4 4.7 2.2 7.2H57.7zm240.6 5.7h-.8c.3-.2.5-.4.8-.5v.5zm7.5-5.7c2.1-1.4 4.3-2.8 6.4-4.3 1.1 1.4 2.2 2.8 3.2 4.3h-9.6zm15.1-24.7c-10.8 7.3-20.6 18.3-33.3 25.2-6 3.3-27 11.7-33.4 10.2-3.6-.8-3.9-5.3-5.4-9.5-3.1-9-10.1-23.4-10.8-37-.8-17.2-2.5-46 16-42.4 14.9 2.9 32.3 9.7 43.9 16.1 7.1 3.9 11.1 8.6 21.9 9.5-.1 1.4-.1 2.8-.2 4.3-5.9 3.9-15.3 3.8-21.8 7.1 9.5.4 17 2.7 23.5 5.9-.1 3.4-.3 7-.4 10.6zm53.4 24.7h-14c-.1-3.2-2.8-5.8-6.1-5.8s-5.9 2.6-6.1 5.8h-17.4c-2.8-4.4-5.7-8.6-8.9-12.5 2.1-2.2 4-4.7 6-6.9 9 3.7 14.8-4.9 21.7-4.2 7.9.8 14.2 11.7 25.4 11l-.6 12.6zm8.7 0c.2-4 .4-7.8.6-11.5 15.6-7.3 29 1.3 35.7 11.5H383zm83.4-37c-2.3 11.2-5.8 24-9.9 37.1-.2-.1-.4-.1-.6-.1H428c.6-1.1 1.2-2.2 1.9-3.3-2.6-6.1-9-8.7-10.9-15.5 12.1-22.7 6.5-93.4-24.2-78.5 4.3-6.3 15.6-11.5 20.8-19.3 13 10.4 20.8 20.3 33.2 31.4 6.8 6 20 13.3 21.4 23.1.8 5.5-2.6 18.9-3.8 25.1zM222.2 130.5c5.4-14.9 27.2-34.7 45-32 7.7 1.2 18 8.2 12.2 17.7-30.2-7-45.2 12.6-54.4 33.1-8.1-2-4.9-13.1-2.8-18.8zm184.1 63.1c8.2-3.6 22.4-.7 29.6-5.3-4.2-11.5-10.3-21.4-9.3-37.7.5 0 1 0 1.4.1 6.8 14.2 12.7 29.2 21.4 41.7-5.7 13.5-43.6 25.4-43.1 1.2zm20.4-43zm-117.2 45.7c-6.8-10.9-19-32.5-14.5-45.3 6.5 11.9 8.6 24.4 17.8 33.3 4.1 4 12.2 9 8.2 20.2-.9 2.7-7.8 8.6-11.7 9.7-14.4 4.3-47.9.9-36.6-17.1 11.9.7 27.9 7.8 36.8-.8zm27.3 70c3.8 6.6 1.4 18.7 12.1 20.6 20.2 3.4 43.6-12.3 58.1-17.8 9-15.2-.8-20.7-8.9-30.5-16.6-20-38.8-44.8-38-74.7 6.7-4.9 7.3 7.4 8.2 9.7 8.7 20.3 30.4 46.2 46.3 63.5 3.9 4.3 10.3 8.4 11 11.2 2.1 8.2-5.4 18-4.5 23.5-21.7 13.9-45.8 29.1-81.4 25.6-7.4-6.7-10.3-21.4-2.9-31.1zm-201.3-9.2c-6.8-3.9-8.4-21-16.4-21.4-11.4-.7-9.3 22.2-9.3 35.5-7.8-7.1-9.2-29.1-3.5-40.3-6.6-3.2-9.5 3.6-13.1 5.9 4.7-34.1 49.8-15.8 42.3 20.3zm299.6 28.8c-10.1 19.2-24.4 40.4-54 41-.6-6.2-1.1-15.6 0-19.4 22.7-2.2 36.6-13.7 54-21.6zm-141.9 12.4c18.9 9.9 53.6 11 79.3 10.2 1.4 5.6 1.3 12.6 1.4 19.4-33 1.8-72-6.4-80.7-29.6zm92.2 46.7c-1.7 4.3-5.3 9.3-9.8 11.1-12.1 4.9-45.6 8.7-62.4-.3-10.7-5.7-17.5-18.5-23.4-26-2.8-3.6-16.9-12.9-.2-12.9 13.1 32.7 58 29 95.8 28.1z"
    ]
};
var $ef0249c5e48bf4e3$export$ca61170983a00686 = {
    prefix: "fab",
    iconName: "twitter",
    icon: [
        512,
        512,
        [],
        "f099",
        "M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z"
    ]
};
var $ef0249c5e48bf4e3$export$b86b24e51d58f6b5 = {
    prefix: "fab",
    iconName: "rockrms",
    icon: [
        496,
        512,
        [],
        "f3e9",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm157.4 419.5h-90l-112-131.3c-17.9-20.4-3.9-56.1 26.6-56.1h75.3l-84.6-99.3-84.3 98.9h-90L193.5 67.2c14.4-18.4 41.3-17.3 54.5 0l157.7 185.1c19 22.8 2 57.2-27.6 56.1-.6 0-74.2.2-74.2.2l101.5 118.9z"
    ]
};
var $ef0249c5e48bf4e3$export$d42c613d35559431 = {
    prefix: "fab",
    iconName: "pinterest",
    icon: [
        496,
        512,
        [],
        "f0d2",
        "M496 256c0 137-111 248-248 248-25.6 0-50.2-3.9-73.4-11.1 10.1-16.5 25.2-43.5 30.8-65 3-11.6 15.4-59 15.4-59 8.1 15.4 31.7 28.5 56.8 28.5 74.8 0 128.7-68.8 128.7-154.3 0-81.9-66.9-143.2-152.9-143.2-107 0-163.9 71.8-163.9 150.1 0 36.4 19.4 81.7 50.3 96.1 4.7 2.2 7.2 1.2 8.3-3.3.8-3.4 5-20.3 6.9-28.1.6-2.5.3-4.7-1.7-7.1-10.1-12.5-18.3-35.3-18.3-56.6 0-54.7 41.4-107.6 112-107.6 60.9 0 103.6 41.5 103.6 100.9 0 67.1-33.9 113.6-78 113.6-24.3 0-42.6-20.1-36.7-44.8 7-29.5 20.5-61.3 20.5-82.6 0-19-10.2-34.9-31.4-34.9-24.9 0-44.9 25.7-44.9 60.2 0 22 7.4 36.8 7.4 36.8s-24.5 103.8-29 123.2c-5 21.4-3 51.6-.9 71.2C65.4 450.9 0 361.1 0 256 0 119 111 8 248 8s248 111 248 248z"
    ]
};
var $ef0249c5e48bf4e3$export$de04abdf8e0bcc15 = {
    prefix: "fab",
    iconName: "buffer",
    icon: [
        448,
        512,
        [],
        "f837",
        "M427.84 380.67l-196.5 97.82a18.6 18.6 0 0 1-14.67 0L20.16 380.67c-4-2-4-5.28 0-7.29L67.22 350a18.65 18.65 0 0 1 14.69 0l134.76 67a18.51 18.51 0 0 0 14.67 0l134.76-67a18.62 18.62 0 0 1 14.68 0l47.06 23.43c4.05 1.96 4.05 5.24 0 7.24zm0-136.53l-47.06-23.43a18.62 18.62 0 0 0-14.68 0l-134.76 67.08a18.68 18.68 0 0 1-14.67 0L81.91 220.71a18.65 18.65 0 0 0-14.69 0l-47.06 23.43c-4 2-4 5.29 0 7.31l196.51 97.8a18.6 18.6 0 0 0 14.67 0l196.5-97.8c4.05-2.02 4.05-5.3 0-7.31zM20.16 130.42l196.5 90.29a20.08 20.08 0 0 0 14.67 0l196.51-90.29c4-1.86 4-4.89 0-6.74L231.33 33.4a19.88 19.88 0 0 0-14.67 0l-196.5 90.28c-4.05 1.85-4.05 4.88 0 6.74z"
    ]
};
var $ef0249c5e48bf4e3$export$2002216d2d7747f0 = {
    prefix: "fab",
    iconName: "npm",
    icon: [
        576,
        512,
        [],
        "f3d4",
        "M288 288h-32v-64h32v64zm288-128v192H288v32H160v-32H0V160h576zm-416 32H32v128h64v-96h32v96h32V192zm160 0H192v160h64v-32h64V192zm224 0H352v128h64v-96h32v96h32v-96h32v96h32V192z"
    ]
};
var $ef0249c5e48bf4e3$export$a5122f6c6ec2779c = {
    prefix: "fab",
    iconName: "yammer",
    icon: [
        512,
        512,
        [],
        "f840",
        "M500.676,159.486a12.779,12.779,0,0,0-6.4-8.282,13.954,13.954,0,0,0-10.078-1.125L457.8,156.7l-.043-.2-22.3,5.785-1.243.333-.608-2.17A369.037,369.037,0,0,0,347.538,4.289a14.1,14.1,0,0,0-19.784-.463l-102.9,102.747H24.947A24.9,24.9,0,0,0,0,131.417V380.38a24.963,24.963,0,0,0,24.918,24.9H224.986L328.072,508a13.667,13.667,0,0,0,19.327,0c.126-.126.249-.255.37-.385a368.025,368.025,0,0,0,69.577-107.374,403.45,403.45,0,0,0,17.3-50.8v-.028l20.406,5.336.029-.073L483.345,362a20.253,20.253,0,0,0,2.619.5,13.359,13.359,0,0,0,4.139-.072,13.5,13.5,0,0,0,10.515-9.924,415.855,415.855,0,0,0,.058-193.013ZM337.125,24.65l.013.014h-.013Zm-110.2,165.161L174.311,281.1a11.338,11.338,0,0,0-1.489,5.655v46.189a22.04,22.04,0,0,1-22.041,22h-3.4A22.068,22.068,0,0,1,125.3,332.962V287.294a11.532,11.532,0,0,0-1.388-5.51l-51.6-92.2a21.988,21.988,0,0,1,19.264-32.726h3.268a22.059,22.059,0,0,1,19.611,11.916l36.357,70.281,37.515-70.512a22.066,22.066,0,0,1,38.556-.695,21.7,21.7,0,0,1,0,21.967ZM337.145,24.673a348.147,348.147,0,0,1,75.8,141.335l.564,1.952-114.134,29.6V131.417a25.006,25.006,0,0,0-24.947-24.9H255.067Zm60.5,367.305v-.043l-.014.014a347.19,347.19,0,0,1-60.177,95.227l-82.2-81.893h19.177a24.978,24.978,0,0,0,24.947-24.9v-66.2l114.6,29.862A385.191,385.191,0,0,1,397.648,391.978Zm84-52.45.015.014-50.618-13.131L299.379,292.1V219.572l119.746-30.99,4.468-1.157,39.54-10.253,18.511-4.816A393,393,0,0,1,481.644,339.528Z"
    ]
};
var $ef0249c5e48bf4e3$export$fcf54005da871608 = {
    prefix: "fab",
    iconName: "btc",
    icon: [
        384,
        512,
        [],
        "f15a",
        "M310.204 242.638c27.73-14.18 45.377-39.39 41.28-81.3-5.358-57.351-52.458-76.573-114.85-81.929V0h-48.528v77.203c-12.605 0-25.525.315-38.444.63V0h-48.528v79.409c-17.842.539-38.622.276-97.37 0v51.678c38.314-.678 58.417-3.14 63.023 21.427v217.429c-2.925 19.492-18.524 16.685-53.255 16.071L3.765 443.68c88.481 0 97.37.315 97.37.315V512h48.528v-67.06c13.234.315 26.154.315 38.444.315V512h48.528v-68.005c81.299-4.412 135.647-24.894 142.895-101.467 5.671-61.446-23.32-88.862-69.326-99.89zM150.608 134.553c27.415 0 113.126-8.507 113.126 48.528 0 54.515-85.71 48.212-113.126 48.212v-96.74zm0 251.776V279.821c32.772 0 133.127-9.138 133.127 53.255-.001 60.186-100.355 53.253-133.127 53.253z"
    ]
};
var $ef0249c5e48bf4e3$export$657a51e82ea8ac80 = {
    prefix: "fab",
    iconName: "dribbble",
    icon: [
        512,
        512,
        [],
        "f17d",
        "M256 8C119.252 8 8 119.252 8 256s111.252 248 248 248 248-111.252 248-248S392.748 8 256 8zm163.97 114.366c29.503 36.046 47.369 81.957 47.835 131.955-6.984-1.477-77.018-15.682-147.502-6.818-5.752-14.041-11.181-26.393-18.617-41.614 78.321-31.977 113.818-77.482 118.284-83.523zM396.421 97.87c-3.81 5.427-35.697 48.286-111.021 76.519-34.712-63.776-73.185-116.168-79.04-124.008 67.176-16.193 137.966 1.27 190.061 47.489zm-230.48-33.25c5.585 7.659 43.438 60.116 78.537 122.509-99.087 26.313-186.36 25.934-195.834 25.809C62.38 147.205 106.678 92.573 165.941 64.62zM44.17 256.323c0-2.166.043-4.322.108-6.473 9.268.19 111.92 1.513 217.706-30.146 6.064 11.868 11.857 23.915 17.174 35.949-76.599 21.575-146.194 83.527-180.531 142.306C64.794 360.405 44.17 310.73 44.17 256.323zm81.807 167.113c22.127-45.233 82.178-103.622 167.579-132.756 29.74 77.283 42.039 142.053 45.189 160.638-68.112 29.013-150.015 21.053-212.768-27.882zm248.38 8.489c-2.171-12.886-13.446-74.897-41.152-151.033 66.38-10.626 124.7 6.768 131.947 9.055-9.442 58.941-43.273 109.844-90.795 141.978z"
    ]
};
var $ef0249c5e48bf4e3$export$ef143c65b9462290 = {
    prefix: "fab",
    iconName: "stumbleupon-circle",
    icon: [
        496,
        512,
        [],
        "f1a3",
        "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 177.5c-9.8 0-17.8 8-17.8 17.8v106.9c0 40.9-33.9 73.9-74.9 73.9-41.4 0-74.9-33.5-74.9-74.9v-46.5h57.3v45.8c0 10 8 17.8 17.8 17.8s17.8-7.9 17.8-17.8V200.1c0-40 34.2-72.1 74.7-72.1 40.7 0 74.7 32.3 74.7 72.6v23.7l-34.1 10.1-22.9-10.7v-20.6c.1-9.6-7.9-17.6-17.7-17.6zm167.6 123.6c0 41.4-33.5 74.9-74.9 74.9-41.2 0-74.9-33.2-74.9-74.2V263l22.9 10.7 34.1-10.1v47.1c0 9.8 8 17.6 17.8 17.6s17.8-7.9 17.8-17.6v-48h57.3c-.1 45.9-.1 46.4-.1 46.4z"
    ]
};
var $ef0249c5e48bf4e3$export$26bd7ea5833d2643 = {
    prefix: "fab",
    iconName: "internet-explorer",
    icon: [
        512,
        512,
        [],
        "f26b",
        "M483.049 159.706c10.855-24.575 21.424-60.438 21.424-87.871 0-72.722-79.641-98.371-209.673-38.577-107.632-7.181-211.221 73.67-237.098 186.457 30.852-34.862 78.271-82.298 121.977-101.158C125.404 166.85 79.128 228.002 43.992 291.725 23.246 329.651 0 390.94 0 436.747c0 98.575 92.854 86.5 180.251 42.006 31.423 15.43 66.559 15.573 101.695 15.573 97.124 0 184.249-54.294 216.814-146.022H377.927c-52.509 88.593-196.819 52.996-196.819-47.436H509.9c6.407-43.581-1.655-95.715-26.851-141.162zM64.559 346.877c17.711 51.15 53.703 95.871 100.266 123.304-88.741 48.94-173.267 29.096-100.266-123.304zm115.977-108.873c2-55.151 50.276-94.871 103.98-94.871 53.418 0 101.981 39.72 103.981 94.871H180.536zm184.536-187.6c21.425-10.287 48.563-22.003 72.558-22.003 31.422 0 54.274 21.717 54.274 53.722 0 20.003-7.427 49.007-14.569 67.867-26.28-42.292-65.986-81.584-112.263-99.586z"
    ]
};
var $ef0249c5e48bf4e3$export$28d0d3c268c6e8c2 = {
    prefix: "fab",
    iconName: "stubber",
    icon: [
        448,
        512,
        [],
        "e5c7",
        "M136.5 294.2l58.8 22.9c9.1-36.8 25.4-61.1 55-61.1c49.4 0 71.4 63.6 142.4 63.6c15.6 0 35.9-2.8 55.3-13.3V368c0 61.8-50.4 112-112.3 112H0l41.8-56L0 368l41.7-56L0 256.1l41.8-56L0 144.1 41.8 88 0 32H335.7C397.6 32 448 82.3 448 144.1v51.3c-9.2 36.3-25.9 60.6-55 60.6c-49.6 0-71.6-63.5-142.4-63.5c-35.9 0-95.2 14.6-114.1 101.6h0z"
    ]
};
var $ef0249c5e48bf4e3$export$b508fd54409de914 = {
    prefix: "fab",
    iconName: "telegram",
    icon: [
        496,
        512,
        [
            62462,
            "telegram-plane"
        ],
        "f2c6",
        "M248,8C111.033,8,0,119.033,0,256S111.033,504,248,504,496,392.967,496,256,384.967,8,248,8ZM362.952,176.66c-3.732,39.215-19.881,134.378-28.1,178.3-3.476,18.584-10.322,24.816-16.948,25.425-14.4,1.326-25.338-9.517-39.287-18.661-21.827-14.308-34.158-23.215-55.346-37.177-24.485-16.135-8.612-25,5.342-39.5,3.652-3.793,67.107-61.51,68.335-66.746.153-.655.3-3.1-1.154-4.384s-3.59-.849-5.135-.5q-3.283.746-104.608,69.142-14.845,10.194-26.894,9.934c-8.855-.191-25.888-5.006-38.551-9.123-15.531-5.048-27.875-7.717-26.8-16.291q.84-6.7,18.45-13.7,108.446-47.248,144.628-62.3c68.872-28.647,83.183-33.623,92.511-33.789,2.052-.034,6.639.474,9.61,2.885a10.452,10.452,0,0,1,3.53,6.716A43.765,43.765,0,0,1,362.952,176.66Z"
    ]
};
var $ef0249c5e48bf4e3$export$dd32dc1ad06228ec = $ef0249c5e48bf4e3$export$b508fd54409de914;
var $ef0249c5e48bf4e3$export$39ef7a19d18012df = {
    prefix: "fab",
    iconName: "old-republic",
    icon: [
        496,
        512,
        [],
        "f510",
        "M235.76 10.23c7.5-.31 15-.28 22.5-.09 3.61.14 7.2.4 10.79.73 4.92.27 9.79 1.03 14.67 1.62 2.93.43 5.83.98 8.75 1.46 7.9 1.33 15.67 3.28 23.39 5.4 12.24 3.47 24.19 7.92 35.76 13.21 26.56 12.24 50.94 29.21 71.63 49.88 20.03 20.09 36.72 43.55 48.89 69.19 1.13 2.59 2.44 5.1 3.47 7.74 2.81 6.43 5.39 12.97 7.58 19.63 4.14 12.33 7.34 24.99 9.42 37.83.57 3.14 1.04 6.3 1.4 9.47.55 3.83.94 7.69 1.18 11.56.83 8.34.84 16.73.77 25.1-.07 4.97-.26 9.94-.75 14.89-.24 3.38-.51 6.76-.98 10.12-.39 2.72-.63 5.46-1.11 8.17-.9 5.15-1.7 10.31-2.87 15.41-4.1 18.5-10.3 36.55-18.51 53.63-15.77 32.83-38.83 62.17-67.12 85.12a246.503 246.503 0 0 1-56.91 34.86c-6.21 2.68-12.46 5.25-18.87 7.41-3.51 1.16-7.01 2.38-10.57 3.39-6.62 1.88-13.29 3.64-20.04 5-4.66.91-9.34 1.73-14.03 2.48-5.25.66-10.5 1.44-15.79 1.74-6.69.66-13.41.84-20.12.81-6.82.03-13.65-.12-20.45-.79-3.29-.23-6.57-.5-9.83-.95-2.72-.39-5.46-.63-8.17-1.11-4.12-.72-8.25-1.37-12.35-2.22-4.25-.94-8.49-1.89-12.69-3.02-8.63-2.17-17.08-5.01-25.41-8.13-10.49-4.12-20.79-8.75-30.64-14.25-2.14-1.15-4.28-2.29-6.35-3.57-11.22-6.58-21.86-14.1-31.92-22.34-34.68-28.41-61.41-66.43-76.35-108.7-3.09-8.74-5.71-17.65-7.8-26.68-1.48-6.16-2.52-12.42-3.58-18.66-.4-2.35-.61-4.73-.95-7.09-.6-3.96-.75-7.96-1.17-11.94-.8-9.47-.71-18.99-.51-28.49.14-3.51.34-7.01.7-10.51.31-3.17.46-6.37.92-9.52.41-2.81.65-5.65 1.16-8.44.7-3.94 1.3-7.9 2.12-11.82 3.43-16.52 8.47-32.73 15.26-48.18 1.15-2.92 2.59-5.72 3.86-8.59 8.05-16.71 17.9-32.56 29.49-47.06 20-25.38 45.1-46.68 73.27-62.47 7.5-4.15 15.16-8.05 23.07-11.37 15.82-6.88 32.41-11.95 49.31-15.38 3.51-.67 7.04-1.24 10.56-1.85 2.62-.47 5.28-.7 7.91-1.08 3.53-.53 7.1-.68 10.65-1.04 2.46-.24 4.91-.36 7.36-.51m8.64 24.41c-9.23.1-18.43.99-27.57 2.23-7.3 1.08-14.53 2.6-21.71 4.3-13.91 3.5-27.48 8.34-40.46 14.42-10.46 4.99-20.59 10.7-30.18 17.22-4.18 2.92-8.4 5.8-12.34 9.03-5.08 3.97-9.98 8.17-14.68 12.59-2.51 2.24-4.81 4.7-7.22 7.06-28.22 28.79-48.44 65.39-57.5 104.69-2.04 8.44-3.54 17.02-4.44 25.65-1.1 8.89-1.44 17.85-1.41 26.8.11 7.14.38 14.28 1.22 21.37.62 7.12 1.87 14.16 3.2 21.18 1.07 4.65 2.03 9.32 3.33 13.91 6.29 23.38 16.5 45.7 30.07 65.75 8.64 12.98 18.78 24.93 29.98 35.77 16.28 15.82 35.05 29.04 55.34 39.22 7.28 3.52 14.66 6.87 22.27 9.63 5.04 1.76 10.06 3.57 15.22 4.98 11.26 3.23 22.77 5.6 34.39 7.06 2.91.29 5.81.61 8.72.9 13.82 1.08 27.74 1 41.54-.43 4.45-.6 8.92-.99 13.35-1.78 3.63-.67 7.28-1.25 10.87-2.1 4.13-.98 8.28-1.91 12.36-3.07 26.5-7.34 51.58-19.71 73.58-36.2 15.78-11.82 29.96-25.76 42.12-41.28 3.26-4.02 6.17-8.31 9.13-12.55 3.39-5.06 6.58-10.25 9.6-15.54 2.4-4.44 4.74-8.91 6.95-13.45 5.69-12.05 10.28-24.62 13.75-37.49 2.59-10.01 4.75-20.16 5.9-30.45 1.77-13.47 1.94-27.1 1.29-40.65-.29-3.89-.67-7.77-1-11.66-2.23-19.08-6.79-37.91-13.82-55.8-5.95-15.13-13.53-29.63-22.61-43.13-12.69-18.8-28.24-35.68-45.97-49.83-25.05-20-54.47-34.55-85.65-42.08-7.78-1.93-15.69-3.34-23.63-4.45-3.91-.59-7.85-.82-11.77-1.24-7.39-.57-14.81-.72-22.22-.58zM139.26 83.53c13.3-8.89 28.08-15.38 43.3-20.18-3.17 1.77-6.44 3.38-9.53 5.29-11.21 6.68-21.52 14.9-30.38 24.49-6.8 7.43-12.76 15.73-17.01 24.89-3.29 6.86-5.64 14.19-6.86 21.71-.93 4.85-1.3 9.81-1.17 14.75.13 13.66 4.44 27.08 11.29 38.82 5.92 10.22 13.63 19.33 22.36 27.26 4.85 4.36 10.24 8.09 14.95 12.6 2.26 2.19 4.49 4.42 6.43 6.91 2.62 3.31 4.89 6.99 5.99 11.1.9 3.02.66 6.2.69 9.31.02 4.1-.04 8.2.03 12.3.14 3.54-.02 7.09.11 10.63.08 2.38.02 4.76.05 7.14.16 5.77.06 11.53.15 17.3.11 2.91.02 5.82.13 8.74.03 1.63.13 3.28-.03 4.91-.91.12-1.82.18-2.73.16-10.99 0-21.88-2.63-31.95-6.93-6-2.7-11.81-5.89-17.09-9.83-5.75-4.19-11.09-8.96-15.79-14.31-6.53-7.24-11.98-15.39-16.62-23.95-1.07-2.03-2.24-4.02-3.18-6.12-1.16-2.64-2.62-5.14-3.67-7.82-4.05-9.68-6.57-19.94-8.08-30.31-.49-4.44-1.09-8.88-1.2-13.35-.7-15.73.84-31.55 4.67-46.82 2.12-8.15 4.77-16.18 8.31-23.83 6.32-14.2 15.34-27.18 26.3-38.19 6.28-6.2 13.13-11.84 20.53-16.67zm175.37-20.12c2.74.74 5.41 1.74 8.09 2.68 6.36 2.33 12.68 4.84 18.71 7.96 13.11 6.44 25.31 14.81 35.82 24.97 10.2 9.95 18.74 21.6 25.14 34.34 1.28 2.75 2.64 5.46 3.81 8.26 6.31 15.1 10 31.26 11.23 47.57.41 4.54.44 9.09.45 13.64.07 11.64-1.49 23.25-4.3 34.53-1.97 7.27-4.35 14.49-7.86 21.18-3.18 6.64-6.68 13.16-10.84 19.24-6.94 10.47-15.6 19.87-25.82 27.22-10.48 7.64-22.64 13.02-35.4 15.38-3.51.69-7.08 1.08-10.66 1.21-1.85.06-3.72.16-5.56-.1-.28-2.15 0-4.31-.01-6.46-.03-3.73.14-7.45.1-11.17.19-7.02.02-14.05.21-21.07.03-2.38-.03-4.76.03-7.14.17-5.07-.04-10.14.14-15.21.1-2.99-.24-6.04.51-8.96.66-2.5 1.78-4.86 3.09-7.08 4.46-7.31 11.06-12.96 17.68-18.26 5.38-4.18 10.47-8.77 15.02-13.84 7.68-8.37 14.17-17.88 18.78-28.27 2.5-5.93 4.52-12.1 5.55-18.46.86-4.37 1.06-8.83 1.01-13.27-.02-7.85-1.4-15.65-3.64-23.17-1.75-5.73-4.27-11.18-7.09-16.45-3.87-6.93-8.65-13.31-13.96-19.2-9.94-10.85-21.75-19.94-34.6-27.1-1.85-1.02-3.84-1.82-5.63-2.97zm-100.8 58.45c.98-1.18 1.99-2.33 3.12-3.38-.61.93-1.27 1.81-1.95 2.68-3.1 3.88-5.54 8.31-7.03 13.06-.87 3.27-1.68 6.6-1.73 10-.07 2.52-.08 5.07.32 7.57 1.13 7.63 4.33 14.85 8.77 21.12 2 2.7 4.25 5.27 6.92 7.33 1.62 1.27 3.53 2.09 5.34 3.05 3.11 1.68 6.32 3.23 9.07 5.48 2.67 2.09 4.55 5.33 4.4 8.79-.01 73.67 0 147.34-.01 221.02 0 1.35-.08 2.7.04 4.04.13 1.48.82 2.83 1.47 4.15.86 1.66 1.78 3.34 3.18 4.62.85.77 1.97 1.4 3.15 1.24 1.5-.2 2.66-1.35 3.45-2.57.96-1.51 1.68-3.16 2.28-4.85.76-2.13.44-4.42.54-6.63.14-4.03-.02-8.06.14-12.09.03-5.89.03-11.77.06-17.66.14-3.62.03-7.24.11-10.86.15-4.03-.02-8.06.14-12.09.03-5.99.03-11.98.07-17.97.14-3.62.02-7.24.11-10.86.14-3.93-.02-7.86.14-11.78.03-5.99.03-11.98.06-17.97.16-3.94-.01-7.88.19-11.82.29 1.44.13 2.92.22 4.38.19 3.61.42 7.23.76 10.84.32 3.44.44 6.89.86 10.32.37 3.1.51 6.22.95 9.31.57 4.09.87 8.21 1.54 12.29 1.46 9.04 2.83 18.11 5.09 26.99 1.13 4.82 2.4 9.61 4 14.3 2.54 7.9 5.72 15.67 10.31 22.62 1.73 2.64 3.87 4.98 6.1 7.21.27.25.55.51.88.71.6.25 1.31-.07 1.7-.57.71-.88 1.17-1.94 1.7-2.93 4.05-7.8 8.18-15.56 12.34-23.31.7-1.31 1.44-2.62 2.56-3.61 1.75-1.57 3.84-2.69 5.98-3.63 2.88-1.22 5.9-2.19 9.03-2.42 6.58-.62 13.11.75 19.56 1.85 3.69.58 7.4 1.17 11.13 1.41 3.74.1 7.48.05 11.21-.28 8.55-.92 16.99-2.96 24.94-6.25 5.3-2.24 10.46-4.83 15.31-7.93 11.46-7.21 21.46-16.57 30.04-27.01 1.17-1.42 2.25-2.9 3.46-4.28-1.2 3.24-2.67 6.37-4.16 9.48-1.25 2.9-2.84 5.61-4.27 8.42-5.16 9.63-11.02 18.91-17.75 27.52-4.03 5.21-8.53 10.05-13.33 14.57-6.64 6.05-14.07 11.37-22.43 14.76-8.21 3.37-17.31 4.63-26.09 3.29-3.56-.58-7.01-1.69-10.41-2.88-2.79-.97-5.39-2.38-8.03-3.69-3.43-1.71-6.64-3.81-9.71-6.08 2.71 3.06 5.69 5.86 8.7 8.61 4.27 3.76 8.74 7.31 13.63 10.23 3.98 2.45 8.29 4.4 12.84 5.51 1.46.37 2.96.46 4.45.6-1.25 1.1-2.63 2.04-3.99 2.98-9.61 6.54-20.01 11.86-30.69 16.43-20.86 8.7-43.17 13.97-65.74 15.34-4.66.24-9.32.36-13.98.36-4.98-.11-9.97-.13-14.92-.65-11.2-.76-22.29-2.73-33.17-5.43-10.35-2.71-20.55-6.12-30.3-10.55-8.71-3.86-17.12-8.42-24.99-13.79-1.83-1.31-3.74-2.53-5.37-4.08 6.6-1.19 13.03-3.39 18.99-6.48 5.74-2.86 10.99-6.66 15.63-11.07 2.24-2.19 4.29-4.59 6.19-7.09-3.43 2.13-6.93 4.15-10.62 5.78-4.41 2.16-9.07 3.77-13.81 5.02-5.73 1.52-11.74 1.73-17.61 1.14-8.13-.95-15.86-4.27-22.51-8.98-4.32-2.94-8.22-6.43-11.96-10.06-9.93-10.16-18.2-21.81-25.66-33.86-3.94-6.27-7.53-12.75-11.12-19.22-1.05-2.04-2.15-4.05-3.18-6.1 2.85 2.92 5.57 5.97 8.43 8.88 8.99 8.97 18.56 17.44 29.16 24.48 7.55 4.9 15.67 9.23 24.56 11.03 3.11.73 6.32.47 9.47.81 2.77.28 5.56.2 8.34.3 5.05.06 10.11.04 15.16-.16 3.65-.16 7.27-.66 10.89-1.09 2.07-.25 4.11-.71 6.14-1.2 3.88-.95 8.11-.96 11.83.61 4.76 1.85 8.44 5.64 11.38 9.71 2.16 3.02 4.06 6.22 5.66 9.58 1.16 2.43 2.46 4.79 3.55 7.26 1 2.24 2.15 4.42 3.42 6.52.67 1.02 1.4 2.15 2.62 2.55 1.06-.75 1.71-1.91 2.28-3.03 2.1-4.16 3.42-8.65 4.89-13.05 2.02-6.59 3.78-13.27 5.19-20.02 2.21-9.25 3.25-18.72 4.54-28.13.56-3.98.83-7.99 1.31-11.97.87-10.64 1.9-21.27 2.24-31.94.08-1.86.24-3.71.25-5.57.01-4.35.25-8.69.22-13.03-.01-2.38-.01-4.76 0-7.13.05-5.07-.2-10.14-.22-15.21-.2-6.61-.71-13.2-1.29-19.78-.73-5.88-1.55-11.78-3.12-17.51-2.05-7.75-5.59-15.03-9.8-21.82-3.16-5.07-6.79-9.88-11.09-14.03-3.88-3.86-8.58-7.08-13.94-8.45-1.5-.41-3.06-.45-4.59-.64.07-2.99.7-5.93 1.26-8.85 1.59-7.71 3.8-15.3 6.76-22.6 1.52-4.03 3.41-7.9 5.39-11.72 3.45-6.56 7.62-12.79 12.46-18.46zm31.27 1.7c.35-.06.71-.12 1.07-.19.19 1.79.09 3.58.1 5.37v38.13c-.01 1.74.13 3.49-.15 5.22-.36-.03-.71-.05-1.06-.05-.95-3.75-1.72-7.55-2.62-11.31-.38-1.53-.58-3.09-1.07-4.59-1.7-.24-3.43-.17-5.15-.2-5.06-.01-10.13 0-15.19-.01-1.66-.01-3.32.09-4.98-.03-.03-.39-.26-.91.16-1.18 1.28-.65 2.72-.88 4.06-1.35 3.43-1.14 6.88-2.16 10.31-3.31 1.39-.48 2.9-.72 4.16-1.54.04-.56.02-1.13-.05-1.68-1.23-.55-2.53-.87-3.81-1.28-3.13-1.03-6.29-1.96-9.41-3.02-1.79-.62-3.67-1-5.41-1.79-.03-.37-.07-.73-.11-1.09 5.09-.19 10.2.06 15.3-.12 3.36-.13 6.73.08 10.09-.07.12-.39.26-.77.37-1.16 1.08-4.94 2.33-9.83 3.39-14.75zm5.97-.2c.36.05.72.12 1.08.2.98 3.85 1.73 7.76 2.71 11.61.36 1.42.56 2.88 1.03 4.27 2.53.18 5.07-.01 7.61.05 5.16.12 10.33.12 15.49.07.76-.01 1.52.03 2.28.08-.04.36-.07.72-.1 1.08-1.82.83-3.78 1.25-5.67 1.89-3.73 1.23-7.48 2.39-11.22 3.57-.57.17-1.12.42-1.67.64-.15.55-.18 1.12-.12 1.69.87.48 1.82.81 2.77 1.09 4.88 1.52 9.73 3.14 14.63 4.6.38.13.78.27 1.13.49.4.27.23.79.15 1.18-1.66.13-3.31.03-4.97.04-5.17.01-10.33-.01-15.5.01-1.61.03-3.22-.02-4.82.21-.52 1.67-.72 3.42-1.17 5.11-.94 3.57-1.52 7.24-2.54 10.78-.36.01-.71.02-1.06.06-.29-1.73-.15-3.48-.15-5.22v-38.13c.02-1.78-.08-3.58.11-5.37zM65.05 168.33c1.12-2.15 2.08-4.4 3.37-6.46-1.82 7.56-2.91 15.27-3.62 23-.8 7.71-.85 15.49-.54 23.23 1.05 19.94 5.54 39.83 14.23 57.88 2.99 5.99 6.35 11.83 10.5 17.11 6.12 7.47 12.53 14.76 19.84 21.09 4.8 4.1 9.99 7.78 15.54 10.8 3.27 1.65 6.51 3.39 9.94 4.68 5.01 2.03 10.19 3.61 15.42 4.94 3.83.96 7.78 1.41 11.52 2.71 5 1.57 9.47 4.61 13.03 8.43 4.93 5.23 8.09 11.87 10.2 18.67.99 2.9 1.59 5.91 2.17 8.92.15.75.22 1.52.16 2.29-6.5 2.78-13.26 5.06-20.26 6.18-4.11.78-8.29.99-12.46 1.08-10.25.24-20.47-1.76-30.12-5.12-3.74-1.42-7.49-2.85-11.03-4.72-8.06-3.84-15.64-8.7-22.46-14.46-2.92-2.55-5.83-5.13-8.4-8.03-9.16-9.83-16.3-21.41-21.79-33.65-2.39-5.55-4.61-11.18-6.37-16.96-1.17-3.94-2.36-7.89-3.26-11.91-.75-2.94-1.22-5.95-1.87-8.92-.46-2.14-.69-4.32-1.03-6.48-.85-5.43-1.28-10.93-1.33-16.43.11-6.18.25-12.37 1.07-18.5.4-2.86.67-5.74 1.15-8.6.98-5.7 2.14-11.37 3.71-16.93 3.09-11.65 7.48-22.95 12.69-33.84zm363.73-6.44c1.1 1.66 1.91 3.48 2.78 5.26 2.1 4.45 4.24 8.9 6.02 13.49 7.61 18.76 12.3 38.79 13.04 59.05.02 1.76.07 3.52.11 5.29.13 9.57-1.27 19.09-3.18 28.45-.73 3.59-1.54 7.17-2.58 10.69-4.04 14.72-10 29-18.41 41.78-8.21 12.57-19.01 23.55-31.84 31.41-5.73 3.59-11.79 6.64-18.05 9.19-5.78 2.19-11.71 4.03-17.8 5.11-6.4 1.05-12.91 1.52-19.4 1.23-7.92-.48-15.78-2.07-23.21-4.85-1.94-.8-3.94-1.46-5.84-2.33-.21-1.51.25-2.99.53-4.46 1.16-5.74 3.03-11.36 5.7-16.58 2.37-4.51 5.52-8.65 9.46-11.9 2.43-2.05 5.24-3.61 8.16-4.83 3.58-1.5 7.47-1.97 11.24-2.83 7.23-1.71 14.37-3.93 21.15-7 10.35-4.65 19.71-11.38 27.65-19.46 1.59-1.61 3.23-3.18 4.74-4.87 3.37-3.76 6.71-7.57 9.85-11.53 7.48-10.07 12.82-21.59 16.71-33.48 1.58-5.3 3.21-10.6 4.21-16.05.63-2.87 1.04-5.78 1.52-8.68.87-6.09 1.59-12.22 1.68-18.38.12-6.65.14-13.32-.53-19.94-.73-7.99-1.87-15.96-3.71-23.78z"
    ]
};
var $ef0249c5e48bf4e3$export$4001fe5db20c0fd2 = {
    prefix: "fab",
    iconName: "odysee",
    icon: [
        512,
        512,
        [],
        "e5c6",
        "M406.7 463c-42.3 30.8-94.4 49-150.7 49C144.9 512 50.3 441.2 14.9 342.2c2.4 1.7 5.9 3.6 7.9 4.4c16.3 7.4 40.1-5.4 62.9-28.7c6.9-6.9 14.4-12.4 22.8-17.3c18.3-11.9 37.6-20.8 58.4-27.2c0 0 22.3 34.2 43.1 74.8s-22.3 54-27.2 54c-.3 0-.8 0-1.5-.1c-11-.5-70-3-56 51.1c14.9 57.4 97.5 36.6 139.6 8.9s31.7-118.3 31.7-118.3c41.1-6.4 54 37.1 57.9 59.4c.8 4.6 1.1 9.9 1.4 15.5c1.1 21.2 2.3 45.6 35.3 46.4c5.3 0 10.6-.8 15.5-2zm-95.3-23.7c-2-.5-3.5-2.5-3-5c1-2.5 3-3.5 5-3s3.5 3 3 5s-2.5 3.5-5 3zm-207-95.6c1.5-.5 3.5 1 4 3c0 2-1 4-3 4c-1.5 .5-3.5-1-4-3c-.5-1.5 1-3.5 3-4zM451.8 421C489.3 376.4 512 318.8 512 256c0-67.5-26.1-128.9-68.8-174.7c-.1 23.5-6.1 48.2-16.8 69.2c-11.9 20.3-49 58.9-69.8 78.7c-.7 .3-1.1 .9-1.5 1.4c-.2 .2-.3 .4-.5 .6c-5 6.9-4 16.8 3 21.8c21.3 15.8 56.4 45.6 59.4 72.8c3.5 34.9 27.9 75.6 34.2 86.2l0 0c.8 1.3 1.3 2.1 1.4 2.4c0 2.2-.4 4.3-.8 6.5zM390.7 251c-.5 3 1 5.9 4 6.4s5.9-1 6.4-4s-1-5.9-4-6.4c-3-1-5.9 1-6.4 4zm61.4-60.9l-11.4 5.4-3 12.9-5.4-11.4-12.9-3 11.4-5.4 3-12.9 5.4 11.4 12.9 3zM395.5 41.3c-16.2 8.2-22.1 32.8-29 61.4l0 0c-.3 1.4-.7 2.8-1 4.2c-9.5 38.5-30.6 37.6-41.7 37.2c-1.1 0-2-.1-2.9-.1c-5.1 0-6-4-8.9-17.1c-2.6-12.1-6.9-32-17.9-63.6C271.4-2.5 211.4 13.9 165.9 41.1C110.6 74.2 131.5 143 146.1 190.5c.7 2.2 1.4 4.4 2 6.6c-4 4-13.8 7.5-26 11.9c-12.1 4.3-26.6 9.5-40.3 16.9C47.9 243.9 11.5 274.9 2 288.5C.7 277.8 0 267 0 256C0 114.6 114.6 0 256 0c51.4 0 99.4 15.2 139.5 41.3zM58.9 189.6c-1.5-2-4.5-3-6.4-1.5s-3 4.5-1.5 6.4s4.5 3 6.4 1.5c2.5-1.5 3-4.5 1.5-6.4zM327.3 64.9c2-1.5 5-.5 6.4 1.5c1.5 2.5 1 5.4-1.5 6.4c-2 1.5-5 .5-6.4-1.5s-.5-5 1.5-6.4zM95.1 105c-.5 1.5 .5 3 2 3c1.5 .5 3-.5 3-2c.5-1.5-.5-3-2-3s-3 .5-3 2zm84.7-.5c-3.5-43.1 37.1-54 37.1-54c44.1-15.4 56 5.9 66.4 37.6s3 42.6-38.6 58.9s-61.9-4.5-64.9-42.6zm89.6 14.9h1c2.5 0 5-2 5-5c2-6.9 1-14.4-2-20.8c-1.5-2-4-3.5-6.4-2.5c-3 1-4.5 4-3.5 6.9c2 4.5 3 9.9 1.5 14.9c-.5 3 1.5 5.9 4.5 6.4zm-9.9-41.6c-2 0-4-1-5-3s-2-3.5-3-5c-2-2-2-5.4 0-7.4s5.4-2 7.4 0c2 2.5 3.5 5 5 7.4s.5 5.9-2.5 7.4c-.6 0-1 .2-1.3 .3c-.2 .1-.4 .2-.6 .2z"
    ]
};
var $ef0249c5e48bf4e3$export$ee0c07b824da892f = {
    prefix: "fab",
    iconName: "square-whatsapp",
    icon: [
        448,
        512,
        [
            "whatsapp-square"
        ],
        "f40c",
        "M92.1 254.6c0 24.9 7 49.2 20.2 70.1l3.1 5-13.3 48.6L152 365.2l4.8 2.9c20.2 12 43.4 18.4 67.1 18.4h.1c72.6 0 133.3-59.1 133.3-131.8c0-35.2-15.2-68.3-40.1-93.2c-25-25-58-38.7-93.2-38.7c-72.7 0-131.8 59.1-131.9 131.8zM274.8 330c-12.6 1.9-22.4 .9-47.5-9.9c-36.8-15.9-61.8-51.5-66.9-58.7c-.4-.6-.7-.9-.8-1.1c-2-2.6-16.2-21.5-16.2-41c0-18.4 9-27.9 13.2-32.3c.3-.3 .5-.5 .7-.8c3.6-4 7.9-5 10.6-5c2.6 0 5.3 0 7.6 .1c.3 0 .5 0 .8 0c2.3 0 5.2 0 8.1 6.8c1.2 2.9 3 7.3 4.9 11.8c3.3 8 6.7 16.3 7.3 17.6c1 2 1.7 4.3 .3 6.9c-3.4 6.8-6.9 10.4-9.3 13c-3.1 3.2-4.5 4.7-2.3 8.6c15.3 26.3 30.6 35.4 53.9 47.1c4 2 6.3 1.7 8.6-1c2.3-2.6 9.9-11.6 12.5-15.5c2.6-4 5.3-3.3 8.9-2s23.1 10.9 27.1 12.9c.8 .4 1.5 .7 2.1 1c2.8 1.4 4.7 2.3 5.5 3.6c.9 1.9 .9 9.9-2.4 19.1c-3.3 9.3-19.1 17.7-26.7 18.8zM448 96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96zM148.1 393.9L64 416l22.5-82.2c-13.9-24-21.2-51.3-21.2-79.3C65.4 167.1 136.5 96 223.9 96c42.4 0 82.2 16.5 112.2 46.5c29.9 30 47.9 69.8 47.9 112.2c0 87.4-72.7 158.5-160.1 158.5c-26.6 0-52.7-6.7-75.8-19.3z"
    ]
};
var $ef0249c5e48bf4e3$export$6fd1d044d66a938d = $ef0249c5e48bf4e3$export$ee0c07b824da892f;
var $ef0249c5e48bf4e3$export$ad65a356f9456393 = {
    prefix: "fab",
    iconName: "node-js",
    icon: [
        448,
        512,
        [],
        "f3d3",
        "M224 508c-6.7 0-13.5-1.8-19.4-5.2l-61.7-36.5c-9.2-5.2-4.7-7-1.7-8 12.3-4.3 14.8-5.2 27.9-12.7 1.4-.8 3.2-.5 4.6.4l47.4 28.1c1.7 1 4.1 1 5.7 0l184.7-106.6c1.7-1 2.8-3 2.8-5V149.3c0-2.1-1.1-4-2.9-5.1L226.8 37.7c-1.7-1-4-1-5.7 0L36.6 144.3c-1.8 1-2.9 3-2.9 5.1v213.1c0 2 1.1 4 2.9 4.9l50.6 29.2c27.5 13.7 44.3-2.4 44.3-18.7V167.5c0-3 2.4-5.3 5.4-5.3h23.4c2.9 0 5.4 2.3 5.4 5.3V378c0 36.6-20 57.6-54.7 57.6-10.7 0-19.1 0-42.5-11.6l-48.4-27.9C8.1 389.2.7 376.3.7 362.4V149.3c0-13.8 7.4-26.8 19.4-33.7L204.6 9c11.7-6.6 27.2-6.6 38.8 0l184.7 106.7c12 6.9 19.4 19.8 19.4 33.7v213.1c0 13.8-7.4 26.7-19.4 33.7L243.4 502.8c-5.9 3.4-12.6 5.2-19.4 5.2zm149.1-210.1c0-39.9-27-50.5-83.7-58-57.4-7.6-63.2-11.5-63.2-24.9 0-11.1 4.9-25.9 47.4-25.9 37.9 0 51.9 8.2 57.7 33.8.5 2.4 2.7 4.2 5.2 4.2h24c1.5 0 2.9-.6 3.9-1.7s1.5-2.6 1.4-4.1c-3.7-44.1-33-64.6-92.2-64.6-52.7 0-84.1 22.2-84.1 59.5 0 40.4 31.3 51.6 81.8 56.6 60.5 5.9 65.2 14.8 65.2 26.7 0 20.6-16.6 29.4-55.5 29.4-48.9 0-59.6-12.3-63.2-36.6-.4-2.6-2.6-4.5-5.3-4.5h-23.9c-3 0-5.3 2.4-5.3 5.3 0 31.1 16.9 68.2 97.8 68.2 58.4-.1 92-23.2 92-63.4z"
    ]
};
var $ef0249c5e48bf4e3$export$68bace18bdcdfc53 = {
    prefix: "fab",
    iconName: "edge-legacy",
    icon: [
        512,
        512,
        [],
        "e078",
        "M25.71,228.16l.35-.48c0,.16,0,.32-.07.48Zm460.58,15.51c0-44-7.76-84.46-28.81-122.4C416.5,47.88,343.91,8,258.89,8,119,7.72,40.62,113.21,26.06,227.68c42.42-61.31,117.07-121.38,220.37-125,0,0,109.67,0,99.42,105H170c6.37-37.39,18.55-59,34.34-78.93-75.05,34.9-121.85,96.1-120.75,188.32.83,71.45,50.13,144.84,120.75,172,83.35,31.84,192.77,7.2,240.13-21.33V363.31C363.6,419.8,173.6,424.23,172.21,295.74H486.29V243.67Z"
    ]
};
var $ef0249c5e48bf4e3$export$c597531345e00f14 = {
    prefix: "fab",
    iconName: "slack",
    icon: [
        448,
        512,
        [
            62447,
            "slack-hash"
        ],
        "f198",
        "M94.12 315.1c0 25.9-21.16 47.06-47.06 47.06S0 341 0 315.1c0-25.9 21.16-47.06 47.06-47.06h47.06v47.06zm23.72 0c0-25.9 21.16-47.06 47.06-47.06s47.06 21.16 47.06 47.06v117.84c0 25.9-21.16 47.06-47.06 47.06s-47.06-21.16-47.06-47.06V315.1zm47.06-188.98c-25.9 0-47.06-21.16-47.06-47.06S139 32 164.9 32s47.06 21.16 47.06 47.06v47.06H164.9zm0 23.72c25.9 0 47.06 21.16 47.06 47.06s-21.16 47.06-47.06 47.06H47.06C21.16 243.96 0 222.8 0 196.9s21.16-47.06 47.06-47.06H164.9zm188.98 47.06c0-25.9 21.16-47.06 47.06-47.06 25.9 0 47.06 21.16 47.06 47.06s-21.16 47.06-47.06 47.06h-47.06V196.9zm-23.72 0c0 25.9-21.16 47.06-47.06 47.06-25.9 0-47.06-21.16-47.06-47.06V79.06c0-25.9 21.16-47.06 47.06-47.06 25.9 0 47.06 21.16 47.06 47.06V196.9zM283.1 385.88c25.9 0 47.06 21.16 47.06 47.06 0 25.9-21.16 47.06-47.06 47.06-25.9 0-47.06-21.16-47.06-47.06v-47.06h47.06zm0-23.72c-25.9 0-47.06-21.16-47.06-47.06 0-25.9 21.16-47.06 47.06-47.06h117.84c25.9 0 47.06 21.16 47.06 47.06 0 25.9-21.16 47.06-47.06 47.06H283.1z"
    ]
};
var $ef0249c5e48bf4e3$export$46ef626e3b64d22 = $ef0249c5e48bf4e3$export$c597531345e00f14;
var $ef0249c5e48bf4e3$export$2d7cd04bce6afc11 = {
    prefix: "fab",
    iconName: "medrt",
    icon: [
        544,
        512,
        [],
        "f3c8",
        "M113.7 256c0 121.8 83.9 222.8 193.5 241.1-18.7 4.5-38.2 6.9-58.2 6.9C111.4 504 0 393 0 256S111.4 8 248.9 8c20.1 0 39.6 2.4 58.2 6.9C197.5 33.2 113.7 134.2 113.7 256m297.4 100.3c-77.7 55.4-179.6 47.5-240.4-14.6 5.5 14.1 12.7 27.7 21.7 40.5 61.6 88.2 182.4 109.3 269.7 47 87.3-62.3 108.1-184.3 46.5-272.6-9-12.9-19.3-24.3-30.5-34.2 37.4 78.8 10.7 178.5-67 233.9m-218.8-244c-1.4 1-2.7 2.1-4 3.1 64.3-17.8 135.9 4 178.9 60.5 35.7 47 42.9 106.6 24.4 158 56.7-56.2 67.6-142.1 22.3-201.8-50-65.5-149.1-74.4-221.6-19.8M296 224c-4.4 0-8-3.6-8-8v-40c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v40c0 4.4-3.6 8-8 8h-40c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h40c4.4 0 8 3.6 8 8v40c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-40c0-4.4 3.6-8 8-8h40c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8h-40z"
    ]
};
var $ef0249c5e48bf4e3$export$701b05aa394c8392 = {
    prefix: "fab",
    iconName: "usb",
    icon: [
        640,
        512,
        [],
        "f287",
        "M641.5 256c0 3.1-1.7 6.1-4.5 7.5L547.9 317c-1.4.8-2.8 1.4-4.5 1.4-1.4 0-3.1-.3-4.5-1.1-2.8-1.7-4.5-4.5-4.5-7.8v-35.6H295.7c25.3 39.6 40.5 106.9 69.6 106.9H392V354c0-5 3.9-8.9 8.9-8.9H490c5 0 8.9 3.9 8.9 8.9v89.1c0 5-3.9 8.9-8.9 8.9h-89.1c-5 0-8.9-3.9-8.9-8.9v-26.7h-26.7c-75.4 0-81.1-142.5-124.7-142.5H140.3c-8.1 30.6-35.9 53.5-69 53.5C32 327.3 0 295.3 0 256s32-71.3 71.3-71.3c33.1 0 61 22.8 69 53.5 39.1 0 43.9 9.5 74.6-60.4C255 88.7 273 95.7 323.8 95.7c7.5-20.9 27-35.6 50.4-35.6 29.5 0 53.5 23.9 53.5 53.5s-23.9 53.5-53.5 53.5c-23.4 0-42.9-14.8-50.4-35.6H294c-29.1 0-44.3 67.4-69.6 106.9h310.1v-35.6c0-3.3 1.7-6.1 4.5-7.8 2.8-1.7 6.4-1.4 8.9.3l89.1 53.5c2.8 1.1 4.5 4.1 4.5 7.2z"
    ]
};
var $ef0249c5e48bf4e3$export$ae279e8a7a5b9476 = {
    prefix: "fab",
    iconName: "tumblr",
    icon: [
        320,
        512,
        [],
        "f173",
        "M309.8 480.3c-13.6 14.5-50 31.7-97.4 31.7-120.8 0-147-88.8-147-140.6v-144H17.9c-5.5 0-10-4.5-10-10v-68c0-7.2 4.5-13.6 11.3-16 62-21.8 81.5-76 84.3-117.1.8-11 6.5-16.3 16.1-16.3h70.9c5.5 0 10 4.5 10 10v115.2h83c5.5 0 10 4.4 10 9.9v81.7c0 5.5-4.5 10-10 10h-83.4V360c0 34.2 23.7 53.6 68 35.8 4.8-1.9 9-3.2 12.7-2.2 3.5.9 5.8 3.4 7.4 7.9l22 64.3c1.8 5 3.3 10.6-.4 14.5z"
    ]
};
var $ef0249c5e48bf4e3$export$f796d2c05c7c6dbd = {
    prefix: "fab",
    iconName: "vaadin",
    icon: [
        448,
        512,
        [],
        "f408",
        "M224.5 140.7c1.5-17.6 4.9-52.7 49.8-52.7h98.6c20.7 0 32.1-7.8 32.1-21.6V54.1c0-12.2 9.3-22.1 21.5-22.1S448 41.9 448 54.1v36.5c0 42.9-21.5 62-66.8 62H280.7c-30.1 0-33 14.7-33 27.1 0 1.3-.1 2.5-.2 3.7-.7 12.3-10.9 22.2-23.4 22.2s-22.7-9.8-23.4-22.2c-.1-1.2-.2-2.4-.2-3.7 0-12.3-3-27.1-33-27.1H66.8c-45.3 0-66.8-19.1-66.8-62V54.1C0 41.9 9.4 32 21.6 32s21.5 9.9 21.5 22.1v12.3C43.1 80.2 54.5 88 75.2 88h98.6c44.8 0 48.3 35.1 49.8 52.7h.9zM224 456c11.5 0 21.4-7 25.7-16.3 1.1-1.8 97.1-169.6 98.2-171.4 11.9-19.6-3.2-44.3-27.2-44.3-13.9 0-23.3 6.4-29.8 20.3L224 362l-66.9-117.7c-6.4-13.9-15.9-20.3-29.8-20.3-24 0-39.1 24.6-27.2 44.3 1.1 1.9 97.1 169.6 98.2 171.4 4.3 9.3 14.2 16.3 25.7 16.3z"
    ]
};
var $ef0249c5e48bf4e3$export$e9b10b4b8b90dca5 = {
    prefix: "fab",
    iconName: "quora",
    icon: [
        448,
        512,
        [],
        "f2c4",
        "M440.5 386.7h-29.3c-1.5 13.5-10.5 30.8-33 30.8-20.5 0-35.3-14.2-49.5-35.8 44.2-34.2 74.7-87.5 74.7-153C403.5 111.2 306.8 32 205 32 105.3 32 7.3 111.7 7.3 228.7c0 134.1 131.3 221.6 249 189C276 451.3 302 480 351.5 480c81.8 0 90.8-75.3 89-93.3zM297 329.2C277.5 300 253.3 277 205.5 277c-30.5 0-54.3 10-69 22.8l12.2 24.3c6.2-3 13-4 19.8-4 35.5 0 53.7 30.8 69.2 61.3-10 3-20.7 4.2-32.7 4.2-75 0-107.5-53-107.5-156.7C97.5 124.5 130 71 205 71c76.2 0 108.7 53.5 108.7 157.7.1 41.8-5.4 75.6-16.7 100.5z"
    ]
};
var $ef0249c5e48bf4e3$export$e42e88e46d22eb98 = {
    prefix: "fab",
    iconName: "square-x-twitter",
    icon: [
        448,
        512,
        [],
        "e61a",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm297.1 84L257.3 234.6 379.4 396H283.8L209 298.1 123.3 396H75.8l111-126.9L69.7 116h98l67.7 89.5L313.6 116h47.5zM323.3 367.6L153.4 142.9H125.1L296.9 367.6h26.3z"
    ]
};
var $ef0249c5e48bf4e3$export$1bc30ca2ce539d7f = {
    prefix: "fab",
    iconName: "reacteurope",
    icon: [
        576,
        512,
        [],
        "f75d",
        "M250.6 211.74l5.8-4.1 5.8 4.1-2.1-6.8 5.7-4.3-7.1-.1-2.3-6.8-2.3 6.8-7.2.1 5.7 4.3zm63.7 0l5.8-4.1 5.8 4.1-2.1-6.8 5.7-4.3-7.2-.1-2.3-6.8-2.3 6.8-7.2.1 5.7 4.3zm-91.3 50.5h-3.4c-4.8 0-3.8 4-3.8 12.1 0 4.7-2.3 6.1-5.8 6.1s-5.8-1.4-5.8-6.1v-36.6c0-4.7 2.3-6.1 5.8-6.1s5.8 1.4 5.8 6.1c0 7.2-.7 10.5 3.8 10.5h3.4c4.7-.1 3.8-3.9 3.8-12.3 0-9.9-6.7-14.1-16.8-14.1h-.2c-10.1 0-16.8 4.2-16.8 14.1V276c0 10.4 6.7 14.1 16.8 14.1h.2c10.1 0 16.8-3.8 16.8-14.1 0-9.86 1.1-13.76-3.8-13.76zm-80.7 17.4h-14.7v-19.3H139c2.5 0 3.8-1.3 3.8-3.8v-2.1c0-2.5-1.3-3.8-3.8-3.8h-11.4v-18.3H142c2.5 0 3.8-1.3 3.8-3.8v-2.1c0-2.5-1.3-3.8-3.8-3.8h-21.7c-2.4-.1-3.7 1.3-3.7 3.8v59.1c0 2.5 1.3 3.8 3.8 3.8h21.9c2.5 0 3.8-1.3 3.8-3.8v-2.1c0-2.5-1.3-3.8-3.8-3.8zm-42-18.5c4.6-2 7.3-6 7.3-12.4v-11.9c0-10.1-6.7-14.1-16.8-14.1H77.4c-2.5 0-3.8 1.3-3.8 3.8v59.1c0 2.5 1.3 3.8 3.8 3.8h3.4c2.5 0 3.8-1.3 3.8-3.8v-22.9h5.6l7.4 23.5a4.1 4.1 0 0 0 4.3 3.2h3.3c2.8 0 4-1.8 3.2-4.4zm-3.8-14c0 4.8-2.5 6.1-6.1 6.1h-5.8v-20.9h5.8c3.6 0 6.1 1.3 6.1 6.1zM176 226a3.82 3.82 0 0 0-4.2-3.4h-6.9a3.68 3.68 0 0 0-4 3.4l-11 59.2c-.5 2.7.9 4.1 3.4 4.1h3a3.74 3.74 0 0 0 4.1-3.5l1.8-11.3h12.2l1.8 11.3a3.74 3.74 0 0 0 4.1 3.5h3.5c2.6 0 3.9-1.4 3.4-4.1zm-12.3 39.3l4.7-29.7 4.7 29.7zm89.3 20.2v-53.2h7.5c2.5 0 3.8-1.3 3.8-3.8v-2.1c0-2.5-1.3-3.8-3.8-3.8h-25.8c-2.5 0-3.8 1.3-3.8 3.8v2.1c0 2.5 1.3 3.8 3.8 3.8h7.3v53.2c0 2.5 1.3 3.8 3.8 3.8h3.4c2.5.04 3.8-1.3 3.8-3.76zm248-.8h-19.4V258h16.1a1.89 1.89 0 0 0 2-2v-.8a1.89 1.89 0 0 0-2-2h-16.1v-25.8h19.1a1.89 1.89 0 0 0 2-2v-.8a1.77 1.77 0 0 0-2-1.9h-22.2a1.62 1.62 0 0 0-2 1.8v63a1.81 1.81 0 0 0 2 1.9H501a1.81 1.81 0 0 0 2-1.9v-.8a1.84 1.84 0 0 0-2-1.96zm-93.1-62.9h-.8c-10.1 0-15.3 4.7-15.3 14.1V276c0 9.3 5.2 14.1 15.3 14.1h.8c10.1 0 15.3-4.8 15.3-14.1v-40.1c0-9.36-5.2-14.06-15.3-14.06zm10.2 52.4c-.1 8-3 11.1-10.5 11.1s-10.5-3.1-10.5-11.1v-36.6c0-7.9 3-11.1 10.5-11.1s10.5 3.2 10.5 11.1zm-46.5-14.5c6.1-1.6 9.2-6.1 9.2-13.3v-9.7c0-9.4-5.2-14.1-15.3-14.1h-13.7a1.81 1.81 0 0 0-2 1.9v63a1.81 1.81 0 0 0 2 1.9h1.2a1.74 1.74 0 0 0 1.9-1.9v-26.9h11.6l10.4 27.2a2.32 2.32 0 0 0 2.3 1.5h1.5c1.4 0 2-1 1.5-2.3zm-6.4-3.9H355v-28.5h10.2c7.5 0 10.5 3.1 10.5 11.1v6.4c0 7.84-3 11.04-10.5 11.04zm85.9-33.1h-13.7a1.62 1.62 0 0 0-2 1.8v63a1.81 1.81 0 0 0 2 1.9h1.2a1.74 1.74 0 0 0 1.9-1.9v-26.1h10.6c10.1 0 15.3-4.8 15.3-14.1v-10.5c0-9.4-5.2-14.1-15.3-14.1zm10.2 22.8c0 7.9-3 11.1-10.5 11.1h-10.2v-29.2h10.2c7.5-.1 10.5 3.1 10.5 11zM259.5 308l-2.3-6.8-2.3 6.8-7.1.1 5.7 4.3-2.1 6.8 5.8-4.1 5.8 4.1-2.1-6.8 5.7-4.3zm227.6-136.1a364.42 364.42 0 0 0-35.6-11.3c19.6-78 11.6-134.7-22.3-153.9C394.7-12.66 343.3 11 291 61.94q5.1 4.95 10.2 10.2c82.5-80 119.6-53.5 120.9-52.8 22.4 12.7 36 55.8 15.5 137.8a587.83 587.83 0 0 0-84.6-13C281.1 43.64 212.4 2 170.8 2 140 2 127 23 123.2 29.74c-18.1 32-13.3 84.2.1 133.8-70.5 20.3-120.7 54.1-120.3 95 .5 59.6 103.2 87.8 122.1 92.8-20.5 81.9-10.1 135.6 22.3 153.9 28 15.8 75.1 6 138.2-55.2q-5.1-4.95-10.2-10.2c-82.5 80-119.7 53.5-120.9 52.8-22.3-12.6-36-55.6-15.5-137.9 12.4 2.9 41.8 9.5 84.6 13 71.9 100.4 140.6 142 182.1 142 30.8 0 43.8-21 47.6-27.7 18-31.9 13.3-84.1-.1-133.8 152.3-43.8 156.2-130.2 33.9-176.3zM135.9 36.84c2.9-5.1 11.9-20.3 34.9-20.3 36.8 0 98.8 39.6 163.3 126.2a714 714 0 0 0-93.9.9 547.76 547.76 0 0 1 42.2-52.4Q277.3 86 272.2 81a598.25 598.25 0 0 0-50.7 64.2 569.69 569.69 0 0 0-84.4 14.6c-.2-1.4-24.3-82.2-1.2-123zm304.8 438.3c-2.9 5.1-11.8 20.3-34.9 20.3-36.7 0-98.7-39.4-163.3-126.2a695.38 695.38 0 0 0 93.9-.9 547.76 547.76 0 0 1-42.2 52.4q5.1 5.25 10.2 10.2a588.47 588.47 0 0 0 50.7-64.2c47.3-4.7 80.3-13.5 84.4-14.6 22.7 84.4 4.5 117 1.2 123zm9.1-138.6c-3.6-11.9-7.7-24.1-12.4-36.4a12.67 12.67 0 0 1-10.7-5.7l-.1.1a19.61 19.61 0 0 1-5.4 3.6c5.7 14.3 10.6 28.4 14.7 42.2a535.3 535.3 0 0 1-72 13c3.5-5.3 17.2-26.2 32.2-54.2a24.6 24.6 0 0 1-6-3.2c-1.1 1.2-3.6 4.2-10.9 4.2-6.2 11.2-17.4 30.9-33.9 55.2a711.91 711.91 0 0 1-112.4 1c-7.9-11.2-21.5-31.1-36.8-57.8a21 21 0 0 1-3-1.5c-1.9 1.6-3.9 3.2-12.6 3.2 6.3 11.2 17.5 30.7 33.8 54.6a548.81 548.81 0 0 1-72.2-11.7q5.85-21 14.1-42.9c-3.2 0-5.4.2-8.4-1a17.58 17.58 0 0 1-6.9 1c-4.9 13.4-9.1 26.5-12.7 39.4C-31.7 297-12.1 216 126.7 175.64c3.6 11.9 7.7 24.1 12.4 36.4 10.4 0 12.9 3.4 14.4 5.3a12 12 0 0 1 2.3-2.2c-5.8-14.7-10.9-29.2-15.2-43.3 7-1.8 32.4-8.4 72-13-15.9 24.3-26.7 43.9-32.8 55.3a14.22 14.22 0 0 1 6.4 8 23.42 23.42 0 0 1 10.2-8.4c6.5-11.7 17.9-31.9 34.8-56.9a711.72 711.72 0 0 1 112.4-1c31.5 44.6 28.9 48.1 42.5 64.5a21.42 21.42 0 0 1 10.4-7.4c-6.4-11.4-17.6-31-34.3-55.5 40.4 4.1 65 10 72.2 11.7-4 14.4-8.9 29.2-14.6 44.2a20.74 20.74 0 0 1 6.8 4.3l.1.1a12.72 12.72 0 0 1 8.9-5.6c4.9-13.4 9.2-26.6 12.8-39.5a359.71 359.71 0 0 1 34.5 11c106.1 39.9 74 87.9 72.6 90.4-19.8 35.1-80.1 55.2-105.7 62.5zm-114.4-114h-1.2a1.74 1.74 0 0 0-1.9 1.9v49.8c0 7.9-2.6 11.1-10.1 11.1s-10.1-3.1-10.1-11.1v-49.8a1.69 1.69 0 0 0-1.9-1.9H309a1.81 1.81 0 0 0-2 1.9v51.5c0 9.6 5 14.1 15.1 14.1h.4c10.1 0 15.1-4.6 15.1-14.1v-51.5a2 2 0 0 0-2.2-1.9zM321.7 308l-2.3-6.8-2.3 6.8-7.1.1 5.7 4.3-2.1 6.8 5.8-4.1 5.8 4.1-2.1-6.8 5.7-4.3zm-31.1 7.4l-2.3-6.8-2.3 6.8-7.1.1 5.7 4.3-2.1 6.8 5.8-4.1 5.8 4.1-2.1-6.8 5.7-4.3zm5.1-30.8h-19.4v-26.7h16.1a1.89 1.89 0 0 0 2-2v-.8a1.89 1.89 0 0 0-2-2h-16.1v-25.8h19.1a1.89 1.89 0 0 0 2-2v-.8a1.77 1.77 0 0 0-2-1.9h-22.2a1.81 1.81 0 0 0-2 1.9v63a1.81 1.81 0 0 0 2 1.9h22.5a1.77 1.77 0 0 0 2-1.9v-.8a1.83 1.83 0 0 0-2-2.06zm-7.4-99.4L286 192l-7.1.1 5.7 4.3-2.1 6.8 5.8-4.1 5.8 4.1-2.1-6.8 5.7-4.3-7.1-.1z"
    ]
};
var $ef0249c5e48bf4e3$export$c1f031b95dadaa21 = {
    prefix: "fab",
    iconName: "medium",
    icon: [
        640,
        512,
        [
            62407,
            "medium-m"
        ],
        "f23a",
        "M180.5,74.262C80.813,74.262,0,155.633,0,256S80.819,437.738,180.5,437.738,361,356.373,361,256,280.191,74.262,180.5,74.262Zm288.25,10.646c-49.845,0-90.245,76.619-90.245,171.095s40.406,171.1,90.251,171.1,90.251-76.619,90.251-171.1H559C559,161.5,518.6,84.908,468.752,84.908Zm139.506,17.821c-17.526,0-31.735,68.628-31.735,153.274s14.2,153.274,31.735,153.274S640,340.631,640,256C640,171.351,625.785,102.729,608.258,102.729Z"
    ]
};
var $ef0249c5e48bf4e3$export$a29b11db7eed2052 = $ef0249c5e48bf4e3$export$c1f031b95dadaa21;
var $ef0249c5e48bf4e3$export$2ffb27c42275836a = {
    prefix: "fab",
    iconName: "amilia",
    icon: [
        448,
        512,
        [],
        "f36d",
        "M240.1 32c-61.9 0-131.5 16.9-184.2 55.4-5.1 3.1-9.1 9.2-7.2 19.4 1.1 5.1 5.1 27.4 10.2 39.6 4.1 10.2 14.2 10.2 20.3 6.1 32.5-22.3 96.5-47.7 152.3-47.7 57.9 0 58.9 28.4 58.9 73.1v38.5C203 227.7 78.2 251 46.7 264.2 11.2 280.5 16.3 357.7 16.3 376s15.2 104 124.9 104c47.8 0 113.7-20.7 153.3-42.1v25.4c0 3 2.1 8.2 6.1 9.1 3.1 1 50.7 2 59.9 2s62.5.3 66.5-.7c4.1-1 5.1-6.1 5.1-9.1V168c-.1-80.3-57.9-136-192-136zm50.2 348c-21.4 13.2-48.7 24.4-79.1 24.4-52.8 0-58.9-33.5-59-44.7 0-12.2-3-42.7 18.3-52.9 24.3-13.2 75.1-29.4 119.8-33.5z"
    ]
};
var $ef0249c5e48bf4e3$export$642f133169ca9ebe = {
    prefix: "fab",
    iconName: "mixcloud",
    icon: [
        640,
        512,
        [],
        "f289",
        "M212.98 346.566H179.789V195.114L185.973 173.47H175.262L137.127 346.566H76.1069L37.7323 173.47H27.276L33.1913 195.114V346.566H0V165H65.6506L102.248 338.096H110.747L147.329 165H212.98L212.98 346.566ZM544.459 283.589L458.434 345.655V307.534L531.329 255.776L458.434 204.017V165.896L544.459 228.231H553.721L640 165.896V204.017L566.866 255.776L640 307.549V345.655L553.721 283.589H544.459ZM430.157 272.311H248.113V239.255H430.157V272.311Z"
    ]
};
var $ef0249c5e48bf4e3$export$5193bd9feb923609 = {
    prefix: "fab",
    iconName: "flipboard",
    icon: [
        448,
        512,
        [],
        "f44d",
        "M0 32v448h448V32H0zm358.4 179.2h-89.6v89.6h-89.6v89.6H89.6V121.6h268.8v89.6z"
    ]
};
var $ef0249c5e48bf4e3$export$e75485903cf50ab7 = {
    prefix: "fab",
    iconName: "viacoin",
    icon: [
        384,
        512,
        [],
        "f237",
        "M384 32h-64l-80.7 192h-94.5L64 32H0l48 112H0v48h68.5l13.8 32H0v48h102.8L192 480l89.2-208H384v-48h-82.3l13.8-32H384v-48h-48l48-112zM192 336l-27-64h54l-27 64z"
    ]
};
var $ef0249c5e48bf4e3$export$19d8e57a729f8d94 = {
    prefix: "fab",
    iconName: "critical-role",
    icon: [
        448,
        512,
        [],
        "f6c9",
        "M225.82 0c.26.15 216.57 124.51 217.12 124.72 3 1.18 3.7 3.46 3.7 6.56q-.11 125.17 0 250.36a5.88 5.88 0 0 1-3.38 5.78c-21.37 12-207.86 118.29-218.93 124.58h-3C142 466.34 3.08 386.56 2.93 386.48a3.29 3.29 0 0 1-1.88-3.24c0-.87 0-225.94-.05-253.1a5 5 0 0 1 2.93-4.93C27.19 112.11 213.2 6 224.07 0zM215.4 20.42l-.22-.16Q118.06 75.55 21 130.87c0 .12.08.23.13.35l30.86 11.64c-7.71 6-8.32 6-10.65 5.13-.1 0-24.17-9.28-26.8-10v230.43c.88-1.41 64.07-110.91 64.13-111 1.62-2.82 3-1.92 9.12-1.52 1.4.09 1.48.22.78 1.42-41.19 71.33-36.4 63-67.48 116.94-.81 1.4-.61 1.13 1.25 1.13h186.5c1.44 0 1.69-.23 1.7-1.64v-8.88c0-1.34 2.36-.81-18.37-1-7.46-.07-14.14-3.22-21.38-12.7-7.38-9.66-14.62-19.43-21.85-29.21-2.28-3.08-3.45-2.38-16.76-2.38-1.75 0-1.78 0-1.76 1.82.29 26.21.15 25.27 1 32.66.52 4.37 2.16 4.2 9.69 4.81 3.14.26 3.88 4.08.52 4.92-1.57.39-31.6.51-33.67-.1a2.42 2.42 0 0 1 .3-4.73c3.29-.76 6.16.81 6.66-4.44 1.3-13.66 1.17-9 1.1-79.42 0-10.82-.35-12.58-5.36-13.55-1.22-.24-3.54-.16-4.69-.55-2.88-1-2-4.84 1.77-4.85 33.67 0 46.08-1.07 56.06 4.86 7.74 4.61 12 11.48 12.51 20.4.88 14.59-6.51 22.35-15 32.59a1.46 1.46 0 0 0 0 2.22c2.6 3.25 5 6.63 7.71 9.83 27.56 33.23 24.11 30.54 41.28 33.06.89.13 1-.42 1-1.15v-11c0-1 .32-1.43 1.41-1.26a72.37 72.37 0 0 0 23.58-.3c1.08-.15 1.5.2 1.48 1.33 0 .11.88 26.69.87 26.8-.05 1.52.67 1.62 1.89 1.62h186.71Q386.51 304.6 346 234.33c2.26-.66-.4 0 6.69-1.39 2-.39 2.05-.41 3.11 1.44 7.31 12.64 77.31 134 77.37 134.06V138c-1.72.5-103.3 38.72-105.76 39.68-1.08.42-1.55.2-1.91-.88-.63-1.9-1.34-3.76-2.09-5.62-.32-.79-.09-1.13.65-1.39.1 0 95.53-35.85 103-38.77-65.42-37.57-130.56-75-196-112.6l86.82 150.39-.28.33c-9.57-.9-10.46-1.6-11.8-3.94-1-1.69-73.5-127.71-82-142.16-9.1 14.67-83.56 146.21-85.37 146.32-2.93.17-5.88.08-9.25.08q43.25-74.74 86.18-149zm51.93 129.92a37.68 37.68 0 0 0 5.54-.85c1.69-.3 2.53.2 2.6 1.92 0 .11.07 19.06-.86 20.45s-1.88 1.22-2.6-.19c-5-9.69 6.22-9.66-39.12-12-.7 0-1 .23-1 .93 0 .13 3.72 122 3.73 122.11 0 .89.52 1.2 1.21 1.51a83.92 83.92 0 0 1 8.7 4.05c7.31 4.33 11.38 10.84 12.41 19.31 1.44 11.8-2.77 35.77-32.21 37.14-2.75.13-28.26 1.08-34.14-23.25-4.66-19.26 8.26-32.7 19.89-36.4a2.45 2.45 0 0 0 2-2.66c.1-5.63 3-107.1 3.71-121.35.05-1.08-.62-1.16-1.35-1.15-32.35.52-36.75-.34-40.22 8.52-2.42 6.18-4.14 1.32-3.95.23q1.59-9 3.31-18c.4-2.11 1.43-2.61 3.43-1.86 5.59 2.11 6.72 1.7 37.25 1.92 1.73 0 1.78-.08 1.82-1.85.68-27.49.58-22.59 1-29.55a2.69 2.69 0 0 0-1.63-2.8c-5.6-2.91-8.75-7.55-8.9-13.87-.35-14.81 17.72-21.67 27.38-11.51 6.84 7.19 5.8 18.91-2.45 24.15a4.35 4.35 0 0 0-2.22 4.34c0 .59-.11-4.31 1 30.05 0 .9.43 1.12 1.24 1.11.1 0 23-.09 34.47-.37zM68.27 141.7c19.84-4.51 32.68-.56 52.49 1.69 2.76.31 3.74 1.22 3.62 4-.21 5-1.16 22.33-1.24 23.15a2.65 2.65 0 0 1-1.63 2.34c-4.06 1.7-3.61-4.45-4-7.29-3.13-22.43-73.87-32.7-74.63 25.4-.31 23.92 17 53.63 54.08 50.88 27.24-2 19-20.19 24.84-20.47a2.72 2.72 0 0 1 3 3.36c-1.83 10.85-3.42 18.95-3.45 19.15-1.54 9.17-86.7 22.09-93.35-42.06-2.71-25.85 10.44-53.37 40.27-60.15zm80 87.67h-19.49a2.57 2.57 0 0 1-2.66-1.79c2.38-3.75 5.89.92 5.86-6.14-.08-25.75.21-38 .23-40.1 0-3.42-.53-4.65-3.32-4.94-7-.72-3.11-3.37-1.11-3.38 11.84-.1 22.62-.18 30.05.72 8.77 1.07 16.71 12.63 7.93 22.62-2 2.25-4 4.42-6.14 6.73.95 1.15 6.9 8.82 17.28 19.68 2.66 2.78 6.15 3.51 9.88 3.13a2.21 2.21 0 0 0 2.23-2.12c.3-3.42.26 4.73.45-40.58 0-5.65-.34-6.58-3.23-6.83-3.95-.35-4-2.26-.69-3.37l19.09-.09c.32 0 4.49.53 1 3.38 0 .05-.16 0-.24 0-3.61.26-3.94 1-4 4.62-.27 43.93.07 40.23.41 42.82.11.84.27 2.23 5.1 2.14 2.49 0 3.86 3.37 0 3.4-10.37.08-20.74 0-31.11.07-10.67 0-13.47-6.2-24.21-20.82-1.6-2.18-8.31-2.36-8.2-.37.88 16.47 0 17.78 4 17.67 4.75-.1 4.73 3.57.83 3.55zm275-10.15c-1.21 7.13.17 10.38-5.3 10.34-61.55-.42-47.82-.22-50.72-.31a18.4 18.4 0 0 1-3.63-.73c-2.53-.6 1.48-1.23-.38-5.6-1.43-3.37-2.78-6.78-4.11-10.19a1.94 1.94 0 0 0-2-1.44 138 138 0 0 0-14.58.07 2.23 2.23 0 0 0-1.62 1.06c-1.58 3.62-3.07 7.29-4.51 11-1.27 3.23 7.86 1.32 12.19 2.16 3 .57 4.53 3.72.66 3.73H322.9c-2.92 0-3.09-3.15-.74-3.21a6.3 6.3 0 0 0 5.92-3.47c1.5-3 2.8-6 4.11-9.09 18.18-42.14 17.06-40.17 18.42-41.61a1.83 1.83 0 0 1 3 0c2.93 3.34 18.4 44.71 23.62 51.92 2 2.7 5.74 2 6.36 2 3.61.13 4-1.11 4.13-4.29.09-1.87.08 1.17.07-41.24 0-4.46-2.36-3.74-5.55-4.27-.26 0-2.56-.63-.08-3.06.21-.2-.89-.24 21.7-.15 2.32 0 5.32 2.75-1.21 3.45a2.56 2.56 0 0 0-2.66 2.83c-.07 1.63-.19 38.89.29 41.21a3.06 3.06 0 0 0 3.23 2.43c13.25.43 14.92.44 16-3.41 1.67-5.78 4.13-2.52 3.73-.19zm-104.72 64.37c-4.24 0-4.42-3.39-.61-3.41 35.91-.16 28.11.38 37.19-.65 1.68-.19 2.38.24 2.25 1.89-.26 3.39-.64 6.78-1 10.16-.25 2.16-3.2 2.61-3.4-.15-.38-5.31-2.15-4.45-15.63-5.08-1.58-.07-1.64 0-1.64 1.52V304c0 1.65 0 1.6 1.62 1.47 3.12-.25 10.31.34 15.69-1.52.47-.16 3.3-1.79 3.07 1.76 0 .21-.76 10.35-1.18 11.39-.53 1.29-1.88 1.51-2.58.32-1.17-2 0-5.08-3.71-5.3-15.42-.9-12.91-2.55-12.91 6 0 12.25-.76 16.11 3.89 16.24 16.64.48 14.4 0 16.43-5.71.84-2.37 3.5-1.77 3.18.58-.44 3.21-.85 6.43-1.23 9.64 0 .36-.16 2.4-4.66 2.39-37.16-.08-34.54-.19-35.21-.31-2.72-.51-2.2-3 .22-3.45 1.1-.19 4 .54 4.16-2.56 2.44-56.22-.07-51.34-3.91-51.33zm-.41-109.52c2.46.61 3.13 1.76 2.95 4.65-.33 5.3-.34 9-.55 9.69-.66 2.23-3.15 2.12-3.34-.27-.38-4.81-3.05-7.82-7.57-9.15-26.28-7.73-32.81 15.46-27.17 30.22 5.88 15.41 22 15.92 28.86 13.78 5.92-1.85 5.88-6.5 6.91-7.58 1.23-1.3 2.25-1.84 3.12 1.1 0 .1.57 11.89-6 12.75-1.6.21-19.38 3.69-32.68-3.39-21-11.19-16.74-35.47-6.88-45.33 14-14.06 39.91-7.06 42.32-6.47zM289.8 280.14c3.28 0 3.66 3 .16 3.43-2.61.32-5-.42-5 5.46 0 2-.19 29.05.4 41.45.11 2.29 1.15 3.52 3.44 3.65 22 1.21 14.95-1.65 18.79-6.34 1.83-2.24 2.76.84 2.76 1.08.35 13.62-4 12.39-5.19 12.4l-38.16-.19c-1.93-.23-2.06-3-.42-3.38 2-.48 4.94.4 5.13-2.8 1-15.87.57-44.65.34-47.81-.27-3.77-2.8-3.27-5.68-3.71-2.47-.38-2-3.22.34-3.22 1.45-.02 17.97-.03 23.09-.02zm-31.63-57.79c.07 4.08 2.86 3.46 6 3.58 2.61.1 2.53 3.41-.07 3.43-6.48 0-13.7 0-21.61-.06-3.84 0-3.38-3.35 0-3.37 4.49 0 3.24 1.61 3.41-45.54 0-5.08-3.27-3.54-4.72-4.23-2.58-1.23-1.36-3.09.41-3.15 1.29 0 20.19-.41 21.17.21s1.87 1.65-.42 2.86c-1 .52-3.86-.28-4.15 2.47 0 .21-.82 1.63-.07 43.8zm-36.91 274.27a2.93 2.93 0 0 0 3.26 0c17-9.79 182-103.57 197.42-112.51-.14-.43 11.26-.18-181.52-.27-1.22 0-1.57.37-1.53 1.56 0 .1 1.25 44.51 1.22 50.38a28.33 28.33 0 0 1-1.36 7.71c-.55 1.83.38-.5-13.5 32.23-.73 1.72-1 2.21-2-.08-4.19-10.34-8.28-20.72-12.57-31a23.6 23.6 0 0 1-2-10.79c.16-2.46.8-16.12 1.51-48 0-1.95 0-2-2-2h-183c2.58 1.63 178.32 102.57 196 112.76zm-90.9-188.75c0 2.4.36 2.79 2.76 3 11.54 1.17 21 3.74 25.64-7.32 6-14.46 2.66-34.41-12.48-38.84-2-.59-16-2.76-15.94 1.51.05 8.04.01 11.61.02 41.65zm105.75-15.05c0 2.13 1.07 38.68 1.09 39.13.34 9.94-25.58 5.77-25.23-2.59.08-2 1.37-37.42 1.1-39.43-14.1 7.44-14.42 40.21 6.44 48.8a17.9 17.9 0 0 0 22.39-7.07c4.91-7.76 6.84-29.47-5.43-39a2.53 2.53 0 0 1-.36.12zm-12.28-198c-9.83 0-9.73 14.75-.07 14.87s10.1-14.88.07-14.91zm-80.15 103.83c0 1.8.41 2.4 2.17 2.58 13.62 1.39 12.51-11 12.16-13.36-1.69-11.22-14.38-10.2-14.35-7.81.05 4.5-.03 13.68.02 18.59zm212.32 6.4l-6.1-15.84c-2.16 5.48-4.16 10.57-6.23 15.84z"
    ]
};
var $ef0249c5e48bf4e3$export$b431c4dc6e2095fc = {
    prefix: "fab",
    iconName: "sitrox",
    icon: [
        448,
        512,
        [],
        "e44a",
        "M212.439 0.00846128V0H448V128H64C64 57.6008 141.755 0.475338 212.439 0.00846128ZM237.256 192V192.007C307.135 192.475 384 249.6 384 320H210.809V319.995C140.915 319.563 64 262.424 64 192H237.256ZM235.565 511.993C306.251 511.521 384 454.399 384 384H0V512H235.565V511.993Z"
    ]
};
var $ef0249c5e48bf4e3$export$5311546a7fb29bad = {
    prefix: "fab",
    iconName: "discourse",
    icon: [
        448,
        512,
        [],
        "f393",
        "M225.9 32C103.3 32 0 130.5 0 252.1 0 256 .1 480 .1 480l225.8-.2c122.7 0 222.1-102.3 222.1-223.9C448 134.3 348.6 32 225.9 32zM224 384c-19.4 0-37.9-4.3-54.4-12.1L88.5 392l22.9-75c-9.8-18.1-15.4-38.9-15.4-61 0-70.7 57.3-128 128-128s128 57.3 128 128-57.3 128-128 128z"
    ]
};
var $ef0249c5e48bf4e3$export$4c7981055454786f = {
    prefix: "fab",
    iconName: "joomla",
    icon: [
        448,
        512,
        [],
        "f1aa",
        "M.6 92.1C.6 58.8 27.4 32 60.4 32c30 0 54.5 21.9 59.2 50.2 32.6-7.6 67.1.6 96.5 30l-44.3 44.3c-20.5-20.5-42.6-16.3-55.4-3.5-14.3 14.3-14.3 37.9 0 52.2l99.5 99.5-44 44.3c-87.7-87.2-49.7-49.7-99.8-99.7-26.8-26.5-35-64.8-24.8-98.9C20.4 144.6.6 120.7.6 92.1zm129.5 116.4l44.3 44.3c10-10 89.7-89.7 99.7-99.8 14.3-14.3 37.6-14.3 51.9 0 12.8 12.8 17 35-3.5 55.4l44 44.3c31.2-31.2 38.5-67.6 28.9-101.2 29.2-4.1 51.9-29.2 51.9-59.5 0-33.2-26.8-60.1-59.8-60.1-30.3 0-55.4 22.5-59.5 51.6-33.8-9.9-71.7-1.5-98.3 25.1-18.3 19.1-71.1 71.5-99.6 99.9zm266.3 152.2c8.2-32.7-.9-68.5-26.3-93.9-11.8-12.2 5 4.7-99.5-99.7l-44.3 44.3 99.7 99.7c14.3 14.3 14.3 37.6 0 51.9-12.8 12.8-35 17-55.4-3.5l-44 44.3c27.6 30.2 68 38.8 102.7 28 5.5 27.4 29.7 48.1 58.9 48.1 33 0 59.8-26.8 59.8-60.1 0-30.2-22.5-55-51.6-59.1zm-84.3-53.1l-44-44.3c-87 86.4-50.4 50.4-99.7 99.8-14.3 14.3-37.6 14.3-51.9 0-13.1-13.4-16.9-35.3 3.2-55.4l-44-44.3c-30.2 30.2-38 65.2-29.5 98.3-26.7 6-46.2 29.9-46.2 58.2C0 453.2 26.8 480 59.8 480c28.6 0 52.5-19.8 58.6-46.7 32.7 8.2 68.5-.6 94.2-26 32.1-32 12.2-12.4 99.5-99.7z"
    ]
};
var $ef0249c5e48bf4e3$export$1dd6c03244d1cf01 = {
    prefix: "fab",
    iconName: "mastodon",
    icon: [
        448,
        512,
        [],
        "f4f6",
        "M433 179.11c0-97.2-63.71-125.7-63.71-125.7-62.52-28.7-228.56-28.4-290.48 0 0 0-63.72 28.5-63.72 125.7 0 115.7-6.6 259.4 105.63 289.1 40.51 10.7 75.32 13 103.33 11.4 50.81-2.8 79.32-18.1 79.32-18.1l-1.7-36.9s-36.31 11.4-77.12 10.1c-40.41-1.4-83-4.4-89.63-54a102.54 102.54 0 0 1-.9-13.9c85.63 20.9 158.65 9.1 178.75 6.7 56.12-6.7 105-41.3 111.23-72.9 9.8-49.8 9-121.5 9-121.5zm-75.12 125.2h-46.63v-114.2c0-49.7-64-51.6-64 6.9v62.5h-46.33V197c0-58.5-64-56.6-64-6.9v114.2H90.19c0-122.1-5.2-147.9 18.41-175 25.9-28.9 79.82-30.8 103.83 6.1l11.6 19.5 11.6-19.5c24.11-37.1 78.12-34.8 103.83-6.1 23.71 27.3 18.4 53 18.4 175z"
    ]
};
var $ef0249c5e48bf4e3$export$a8bcb0976aa786fb = {
    prefix: "fab",
    iconName: "airbnb",
    icon: [
        448,
        512,
        [],
        "f834",
        "M224 373.12c-25.24-31.67-40.08-59.43-45-83.18-22.55-88 112.61-88 90.06 0-5.45 24.25-20.29 52-45 83.18zm138.15 73.23c-42.06 18.31-83.67-10.88-119.3-50.47 103.9-130.07 46.11-200-18.85-200-54.92 0-85.16 46.51-73.28 100.5 6.93 29.19 25.23 62.39 54.43 99.5-32.53 36.05-60.55 52.69-85.15 54.92-50 7.43-89.11-41.06-71.3-91.09 15.1-39.16 111.72-231.18 115.87-241.56 15.75-30.07 25.56-57.4 59.38-57.4 32.34 0 43.4 25.94 60.37 59.87 36 70.62 89.35 177.48 114.84 239.09 13.17 33.07-1.37 71.29-37.01 86.64zm47-136.12C280.27 35.93 273.13 32 224 32c-45.52 0-64.87 31.67-84.66 72.79C33.18 317.1 22.89 347.19 22 349.81-3.22 419.14 48.74 480 111.63 480c21.71 0 60.61-6.06 112.37-62.4 58.68 63.78 101.26 62.4 112.37 62.4 62.89.05 114.85-60.86 89.61-130.19.02-3.89-16.82-38.9-16.82-39.58z"
    ]
};
var $ef0249c5e48bf4e3$export$568095dca08f5ff3 = {
    prefix: "fab",
    iconName: "wolf-pack-battalion",
    icon: [
        512,
        512,
        [],
        "f514",
        "M267.73 471.53l10.56 15.84 5.28-12.32 5.28 7V512c21.06-7.92 21.11-66.86 25.51-97.21 4.62-31.89-.88-92.81 81.37-149.11-8.88-23.61-12-49.43-2.64-80.05C421 189 447 196.21 456.43 239.73l-30.35 8.36c11.15 23 17 46.76 13.2 72.14L412 313.18l-6.16 33.43-18.47-7-8.8 33.39-19.35-7 26.39 21.11 8.8-28.15L419 364.2l7-35.63 26.39 14.52c.25-20 7-58.06-8.8-84.45l26.39 5.28c4-22.07-2.38-39.21-7.92-56.74l22.43 9.68c-.44-25.07-29.94-56.79-61.58-58.5-20.22-1.09-56.74-25.17-54.1-51.9 2-19.87 17.45-42.62 43.11-49.7-44 36.51-9.68 67.3 5.28 73.46 4.4-11.44 17.54-69.08 0-130.2-40.39 22.87-89.65 65.1-93.2 147.79l-58 38.71-3.52 93.25L369.78 220l7 7-17.59 3.52-44 38.71-15.84-5.28-28.1 49.25-3.52 119.64 21.11 15.84-32.55 15.84-32.55-15.84 21.11-15.84-3.52-119.64-28.15-49.26-15.84 5.28-44-38.71-17.58-3.51 7-7 107.33 59.82-3.52-93.25-58.06-38.71C185 65.1 135.77 22.87 95.3 0c-17.54 61.12-4.4 118.76 0 130.2 15-6.16 49.26-36.95 5.28-73.46 25.66 7.08 41.15 29.83 43.11 49.7 2.63 26.74-33.88 50.81-54.1 51.9-31.65 1.72-61.15 33.44-61.59 58.51l22.43-9.68c-5.54 17.53-11.91 34.67-7.92 56.74l26.39-5.28c-15.76 26.39-9.05 64.43-8.8 84.45l26.39-14.52 7 35.63 24.63-5.28 8.8 28.15L153.35 366 134 373l-8.8-33.43-18.47 7-6.16-33.43-27.27 7c-3.82-25.38 2-49.1 13.2-72.14l-30.35-8.36c9.4-43.52 35.47-50.77 63.34-54.1 9.36 30.62 6.24 56.45-2.64 80.05 82.25 56.3 76.75 117.23 81.37 149.11 4.4 30.35 4.45 89.29 25.51 97.21v-29.83l5.28-7 5.28 12.32 10.56-15.84 11.44 21.11 11.43-21.1zm79.17-95L331.06 366c7.47-4.36 13.76-8.42 19.35-12.32-.6 7.22-.27 13.84-3.51 22.84zm28.15-49.26c-.4 10.94-.9 21.66-1.76 31.67-7.85-1.86-15.57-3.8-21.11-7 8.24-7.94 15.55-16.32 22.87-24.68zm24.63 5.28c0-13.43-2.05-24.21-5.28-33.43a235 235 0 0 1-18.47 27.27zm3.52-80.94c19.44 12.81 27.8 33.66 29.91 56.3-12.32-4.53-24.63-9.31-36.95-10.56 5.06-12 6.65-28.14 7-45.74zm-1.76-45.74c.81 14.3 1.84 28.82 1.76 42.23 19.22-8.11 29.78-9.72 44-14.08-10.61-18.96-27.2-25.53-45.76-28.16zM165.68 376.52L181.52 366c-7.47-4.36-13.76-8.42-19.35-12.32.6 7.26.27 13.88 3.51 22.88zm-28.15-49.26c.4 10.94.9 21.66 1.76 31.67 7.85-1.86 15.57-3.8 21.11-7-8.24-7.93-15.55-16.31-22.87-24.67zm-24.64 5.28c0-13.43 2-24.21 5.28-33.43a235 235 0 0 0 18.47 27.27zm-3.52-80.94c-19.44 12.81-27.8 33.66-29.91 56.3 12.32-4.53 24.63-9.31 37-10.56-5-12-6.65-28.14-7-45.74zm1.76-45.74c-.81 14.3-1.84 28.82-1.76 42.23-19.22-8.11-29.78-9.72-44-14.08 10.63-18.95 27.23-25.52 45.76-28.15z"
    ]
};
var $ef0249c5e48bf4e3$export$e08e0c43c651f28e = {
    prefix: "fab",
    iconName: "buy-n-large",
    icon: [
        576,
        512,
        [],
        "f8a6",
        "M288 32C133.27 32 7.79 132.32 7.79 256S133.27 480 288 480s280.21-100.32 280.21-224S442.73 32 288 32zm-85.39 357.19L64.1 390.55l77.25-290.74h133.44c63.15 0 84.93 28.65 78 72.84a60.24 60.24 0 0 1-1.5 6.85 77.39 77.39 0 0 0-17.21-1.93c-42.35 0-76.69 33.88-76.69 75.65 0 37.14 27.14 68 62.93 74.45-18.24 37.16-56.16 60.92-117.71 61.52zM358 207.11h32l-22.16 90.31h-35.41l-11.19-35.63-7.83 35.63h-37.83l26.63-90.31h31.34l15 36.75zm145.86 182.08H306.79L322.63 328a78.8 78.8 0 0 0 11.47.83c42.34 0 76.69-33.87 76.69-75.65 0-32.65-21-60.46-50.38-71.06l21.33-82.35h92.5l-53.05 205.36h103.87zM211.7 269.39H187l-13.8 56.47h24.7c16.14 0 32.11-3.18 37.94-26.65 5.56-22.31-7.99-29.82-24.14-29.82zM233 170h-21.34L200 217.71h21.37c18 0 35.38-14.64 39.21-30.14C265.23 168.71 251.07 170 233 170z"
    ]
};
var $ef0249c5e48bf4e3$export$100b84dda223030b = {
    prefix: "fab",
    iconName: "gulp",
    icon: [
        256,
        512,
        [],
        "f3ae",
        "M209.8 391.1l-14.1 24.6-4.6 80.2c0 8.9-28.3 16.1-63.1 16.1s-63.1-7.2-63.1-16.1l-5.8-79.4-14.9-25.4c41.2 17.3 126 16.7 165.6 0zm-196-253.3l13.6 125.5c5.9-20 20.8-47 40-55.2 6.3-2.7 12.7-2.7 18.7.9 5.2 3 9.6 9.3 10.1 11.8 1.2 6.5-2 9.1-4.5 9.1-3 0-5.3-4.6-6.8-7.3-4.1-7.3-10.3-7.6-16.9-2.8-6.9 5-12.9 13.4-17.1 20.7-5.1 8.8-9.4 18.5-12 28.2-1.5 5.6-2.9 14.6-.6 19.9 1 2.2 2.5 3.6 4.9 3.6 5 0 12.3-6.6 15.8-10.1 4.5-4.5 10.3-11.5 12.5-16l5.2-15.5c2.6-6.8 9.9-5.6 9.9 0 0 10.2-3.7 13.6-10 34.7-5.8 19.5-7.6 25.8-7.6 25.8-.7 2.8-3.4 7.5-6.3 7.5-1.2 0-2.1-.4-2.6-1.2-1-1.4-.9-5.3-.8-6.3.2-3.2 6.3-22.2 7.3-25.2-2 2.2-4.1 4.4-6.4 6.6-5.4 5.1-14.1 11.8-21.5 11.8-3.4 0-5.6-.9-7.7-2.4l7.6 79.6c2 5 39.2 17.1 88.2 17.1 49.1 0 86.3-12.2 88.2-17.1l10.9-94.6c-5.7 5.2-12.3 11.6-19.6 14.8-5.4 2.3-17.4 3.8-17.4-5.7 0-5.2 9.1-14.8 14.4-21.5 1.4-1.7 4.7-5.9 4.7-8.1 0-2.9-6-2.2-11.7 2.5-3.2 2.7-6.2 6.3-8.7 9.7-4.3 6-6.6 11.2-8.5 15.5-6.2 14.2-4.1 8.6-9.1 22-5 13.3-4.2 11.8-5.2 14-.9 1.9-2.2 3.5-4 4.5-1.9 1-4.5.9-6.1-.3-.9-.6-1.3-1.9-1.3-3.7 0-.9.1-1.8.3-2.7 1.5-6.1 7.8-18.1 15-34.3 1.6-3.7 1-2.6.8-2.3-6.2 6-10.9 8.9-14.4 10.5-5.8 2.6-13 2.6-14.5-4.1-.1-.4-.1-.8-.2-1.2-11.8 9.2-24.3 11.7-20-8.1-4.6 8.2-12.6 14.9-22.4 14.9-4.1 0-7.1-1.4-8.6-5.1-2.3-5.5 1.3-14.9 4.6-23.8 1.7-4.5 4-9.9 7.1-16.2 1.6-3.4 4.2-5.4 7.6-4.5.6.2 1.1.4 1.6.7 2.6 1.8 1.6 4.5.3 7.2-3.8 7.5-7.1 13-9.3 20.8-.9 3.3-2 9 1.5 9 2.4 0 4.7-.8 6.9-2.4 4.6-3.4 8.3-8.5 11.1-13.5 2-3.6 4.4-8.3 5.6-12.3.5-1.7 1.1-3.3 1.8-4.8 1.1-2.5 2.6-5.1 5.2-5.1 1.3 0 2.4.5 3.2 1.5 1.7 2.2 1.3 4.5.4 6.9-2 5.6-4.7 10.6-6.9 16.7-1.3 3.5-2.7 8-2.7 11.7 0 3.4 3.7 2.6 6.8 1.2 2.4-1.1 4.8-2.8 6.8-4.5 1.2-4.9.9-3.8 26.4-68.2 1.3-3.3 3.7-4.7 6.1-4.7 1.2 0 2.2.4 3.2 1.1 1.7 1.3 1.7 4.1 1 6.2-.7 1.9-.6 1.3-4.5 10.5-5.2 12.1-8.6 20.8-13.2 31.9-1.9 4.6-7.7 18.9-8.7 22.3-.6 2.2-1.3 5.8 1 5.8 5.4 0 19.3-13.1 23.1-17 .2-.3.5-.4.9-.6.6-1.9 1.2-3.7 1.7-5.5 1.4-3.8 2.7-8.2 5.3-11.3.8-1 1.7-1.6 2.7-1.6 2.8 0 4.2 1.2 4.2 4 0 1.1-.7 5.1-1.1 6.2 1.4-1.5 2.9-3 4.5-4.5 15-13.9 25.7-6.8 25.7.2 0 7.4-8.9 17.7-13.8 23.4-1.6 1.9-4.9 5.4-5 6.4 0 1.3.9 1.8 2.2 1.8 2 0 6.4-3.5 8-4.7 5-3.9 11.8-9.9 16.6-14.1l14.8-136.8c-30.5 17.1-197.6 17.2-228.3.2zm229.7-8.5c0 21-231.2 21-231.2 0 0-8.8 51.8-15.9 115.6-15.9 9 0 17.8.1 26.3.4l12.6-48.7L228.1.6c1.4-1.4 5.8-.2 9.9 3.5s6.6 7.9 5.3 9.3l-.1.1L185.9 74l-10 40.7c39.9 2.6 67.6 8.1 67.6 14.6zm-69.4 4.6c0-.8-.9-1.5-2.5-2.1l-.2.8c0 1.3-5 2.4-11.1 2.4s-11.1-1.1-11.1-2.4c0-.1 0-.2.1-.3l.2-.7c-1.8.6-3 1.4-3 2.3 0 2.1 6.2 3.7 13.7 3.7 7.7.1 13.9-1.6 13.9-3.7z"
    ]
};
var $ef0249c5e48bf4e3$export$f7edf083e5c27672 = {
    prefix: "fab",
    iconName: "creative-commons-sampling-plus",
    icon: [
        496,
        512,
        [],
        "f4f1",
        "M247.6 8C389.4 8 496 118.1 496 256c0 147.1-118.5 248-248.4 248C113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8zm.8 44.7C130.2 52.7 44.7 150.6 44.7 256c0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8.1-113.8-90.2-203.3-202.8-203.3zm107 205.6c-4.7 0-9 2.8-10.7 7.2l-4 9.5-11-92.8c-1.7-13.9-22-13.4-23.1.4l-4.3 51.4-5.2-68.8c-1.1-14.3-22.1-14.2-23.2 0l-3.5 44.9-5.9-94.3c-.9-14.5-22.3-14.4-23.2 0l-5.1 83.7-4.3-66.3c-.9-14.4-22.2-14.4-23.2 0l-5.3 80.2-4.1-57c-1.1-14.3-22-14.3-23.2-.2l-7.7 89.8-1.8-12.2c-1.7-11.4-17.1-13.6-22-3.3l-13.2 27.7H87.5v23.2h51.3c4.4 0 8.4-2.5 10.4-6.4l10.7 73.1c2 13.5 21.9 13 23.1-.7l3.8-43.6 5.7 78.3c1.1 14.4 22.3 14.2 23.2-.1l4.6-70.4 4.8 73.3c.9 14.4 22.3 14.4 23.2-.1l4.9-80.5 4.5 71.8c.9 14.3 22.1 14.5 23.2.2l4.6-58.6 4.9 64.4c1.1 14.3 22 14.2 23.1.1l6.8-83 2.7 22.3c1.4 11.8 17.7 14.1 22.3 3.1l18-43.4h50.5V258l-58.4.3zm-78 5.2h-21.9v21.9c0 4.1-3.3 7.5-7.5 7.5-4.1 0-7.5-3.3-7.5-7.5v-21.9h-21.9c-4.1 0-7.5-3.3-7.5-7.5 0-4.1 3.4-7.5 7.5-7.5h21.9v-21.9c0-4.1 3.4-7.5 7.5-7.5s7.5 3.3 7.5 7.5v21.9h21.9c4.1 0 7.5 3.3 7.5 7.5 0 4.1-3.4 7.5-7.5 7.5z"
    ]
};
var $ef0249c5e48bf4e3$export$7ea49f2cb08b52c1 = {
    prefix: "fab",
    iconName: "strava",
    icon: [
        384,
        512,
        [],
        "f428",
        "M158.4 0L7 292h89.2l62.2-116.1L220.1 292h88.5zm150.2 292l-43.9 88.2-44.6-88.2h-67.6l112.2 220 111.5-220z"
    ]
};
var $ef0249c5e48bf4e3$export$c09ea58a6f21cb3c = {
    prefix: "fab",
    iconName: "ember",
    icon: [
        640,
        512,
        [],
        "f423",
        "M639.9 254.6c-1.1-10.7-10.7-6.8-10.7-6.8s-15.6 12.1-29.3 10.7c-13.7-1.3-9.4-32-9.4-32s3-28.1-5.1-30.4c-8.1-2.4-18 7.3-18 7.3s-12.4 13.7-18.3 31.2l-1.6.5s1.9-30.6-.3-37.6c-1.6-3.5-16.4-3.2-18.8 3s-14.2 49.2-15 67.2c0 0-23.1 19.6-43.3 22.8s-25-9.4-25-9.4 54.8-15.3 52.9-59.1-44.2-27.6-49-24c-4.6 3.5-29.4 18.4-36.6 59.7-.2 1.4-.7 7.5-.7 7.5s-21.2 14.2-33 18c0 0 33-55.6-7.3-80.9-11.4-6.8-21.3-.5-27.2 5.3 13.6-17.3 46.4-64.2 36.9-105.2-5.8-24.4-18-27.1-29.2-23.1-17 6.7-23.5 16.7-23.5 16.7s-22 32-27.1 79.5-12.6 105.1-12.6 105.1-10.5 10.2-20.2 10.7-5.4-28.7-5.4-28.7 7.5-44.6 7-52.1-1.1-11.6-9.9-14.2c-8.9-2.7-18.5 8.6-18.5 8.6s-25.5 38.7-27.7 44.6l-1.3 2.4-1.3-1.6s18-52.7.8-53.5-28.5 18.8-28.5 18.8-19.6 32.8-20.4 36.5l-1.3-1.6s8.1-38.2 6.4-47.6c-1.6-9.4-10.5-7.5-10.5-7.5s-11.3-1.3-14.2 5.9-13.7 55.3-15 70.7c0 0-28.2 20.2-46.8 20.4-18.5.3-16.7-11.8-16.7-11.8s68-23.3 49.4-69.2c-8.3-11.8-18-15.5-31.7-15.3-13.7.3-30.3 8.6-41.3 33.3-5.3 11.8-6.8 23-7.8 31.5 0 0-12.3 2.4-18.8-2.9s-10 0-10 0-11.2 14-.1 18.3 28.1 6.1 28.1 6.1c1.6 7.5 6.2 19.5 19.6 29.7 20.2 15.3 58.8-1.3 58.8-1.3l15.9-8.8s.5 14.6 12.1 16.7 16.4 1 36.5-47.9c11.8-25 12.6-23.6 12.6-23.6l1.3-.3s-9.1 46.8-5.6 59.7C187.7 319.4 203 318 203 318s8.3 2.4 15-21.2 19.6-49.9 19.6-49.9h1.6s-5.6 48.1 3 63.7 30.9 5.3 30.9 5.3 15.6-7.8 18-10.2c0 0 18.5 15.8 44.6 12.9 58.3-11.5 79.1-25.9 79.1-25.9s10 24.4 41.1 26.7c35.5 2.7 54.8-18.6 54.8-18.6s-.3 13.5 12.1 18.6 20.7-22.8 20.7-22.8l20.7-57.2h1.9s1.1 37.3 21.5 43.2 47-13.7 47-13.7 6.4-3.5 5.3-14.3zm-578 5.3c.8-32 21.8-45.9 29-39 7.3 7 4.6 22-9.1 31.4-13.7 9.5-19.9 7.6-19.9 7.6zm272.8-123.8s19.1-49.7 23.6-25.5-40 96.2-40 96.2c.5-16.2 16.4-70.7 16.4-70.7zm22.8 138.4c-12.6 33-43.3 19.6-43.3 19.6s-3.5-11.8 6.4-44.9 33.3-20.2 33.3-20.2 16.2 12.4 3.6 45.5zm84.6-14.6s-3-10.5 8.1-30.6c11-20.2 19.6-9.1 19.6-9.1s9.4 10.2-1.3 25.5-26.4 14.2-26.4 14.2z"
    ]
};
var $ef0249c5e48bf4e3$export$c9a287a4ab49306f = {
    prefix: "fab",
    iconName: "canadian-maple-leaf",
    icon: [
        512,
        512,
        [],
        "f785",
        "M383.8 351.7c2.5-2.5 105.2-92.4 105.2-92.4l-17.5-7.5c-10-4.9-7.4-11.5-5-17.4 2.4-7.6 20.1-67.3 20.1-67.3s-47.7 10-57.7 12.5c-7.5 2.4-10-2.5-12.5-7.5s-15-32.4-15-32.4-52.6 59.9-55.1 62.3c-10 7.5-20.1 0-17.6-10 0-10 27.6-129.6 27.6-129.6s-30.1 17.4-40.1 22.4c-7.5 5-12.6 5-17.6-5C293.5 72.3 255.9 0 255.9 0s-37.5 72.3-42.5 79.8c-5 10-10 10-17.6 5-10-5-40.1-22.4-40.1-22.4S183.3 182 183.3 192c2.5 10-7.5 17.5-17.6 10-2.5-2.5-55.1-62.3-55.1-62.3S98.1 167 95.6 172s-5 9.9-12.5 7.5C73 177 25.4 167 25.4 167s17.6 59.7 20.1 67.3c2.4 6 5 12.5-5 17.4L23 259.3s102.6 89.9 105.2 92.4c5.1 5 10 7.5 5.1 22.5-5.1 15-10.1 35.1-10.1 35.1s95.2-20.1 105.3-22.6c8.7-.9 18.3 2.5 18.3 12.5S241 512 241 512h30s-5.8-102.7-5.8-112.8 9.5-13.4 18.4-12.5c10 2.5 105.2 22.6 105.2 22.6s-5-20.1-10-35.1 0-17.5 5-22.5z"
    ]
};
var $ef0249c5e48bf4e3$export$619d787387e2c15e = {
    prefix: "fab",
    iconName: "teamspeak",
    icon: [
        576,
        512,
        [],
        "f4f9",
        "M152.8 37.2c-32.2 38.1-56.1 82.6-69.9 130.5c0 .2-.1 .3-.1 .5C43.5 184.4 16 223 16 268c0 59.6 48.4 108 108 108s108-48.4 108-108c0-53.5-38.9-97.9-90-106.5c15.7-41.8 40.4-79.6 72.3-110.7c1.8-1.6 4-2.6 6.3-3.1c37.2-11.5 76.7-13.3 114.8-5.2C454.7 67.6 534 180.7 517.1 301.3c-8.4 62.6-38.6 112.7-87.7 151.4c-50.1 39.7-107.5 54.3-170.2 52.2l-24-1c12.4 2.8 25 4.9 37.6 6.3c40.7 4.2 81.4 2.1 120.1-12.5c94-35.5 149.3-102.3 162.9-202.5c4.8-52.6-5.8-105.4-30.8-152C454.6 11.3 290.8-38.4 159 32c-2.4 1.4-4.5 3.1-6.3 5.2zM309.4 433.9c-2.1 11.5-4.2 21.9-14.6 31.3c53.2-1 123.2-29.2 161.8-97.1c39.7-69.9 37.6-139.9-6.3-207.8C413.8 105 360.5 77.9 293.7 73.7c1.5 2.3 3.2 4.4 5.2 6.3l5.2 6.3c25.1 31.3 37.6 67.9 42.8 107.5c2.1 15.7-1 30.3-13.6 41.8c-4.2 3.1-5.2 6.3-4.2 10.4l7.3 17.7L365.7 318c5.2 11.5 4.2 19.8-6.3 28.2c-3.2 2.5-6.7 4.6-10.4 6.3l-18.8 8.4 3.1 13.6c3.1 6.3 1 12.5-3.1 17.7c-2.5 2.4-3.8 5.9-3.1 9.4c2.1 11.5-2.1 19.8-12.5 25.1c-2.1 1-4.2 5.2-5.2 7.3zm-133.6-3.1c16.7 11.5 34.5 20.9 53.2 26.1c24 5.2 41.8-6.3 44.9-30.3c1-8.4 5.2-14.6 12.5-17.7c7.3-4.2 8.4-7.3 2.1-13.6l-9.4-8.4 13.6-4.2c6.3-2.1 7.3-5.2 5.2-11.5c-1.4-3-2.4-6.2-3.1-9.4c-3.1-14.6-2.1-15.7 11.5-18.8c8.4-3.1 15.7-6.3 21.9-12.5c3.1-2.1 3.1-4.2 1-8.4l-16.7-30.3c-1-1.9-2.1-3.8-3.1-5.7c-6.4-11.7-13-23.6-15.7-37.1c-2.1-9.4-1-17.7 8.4-24c5.2-4.2 8.4-9.4 8.4-16.7c-.4-10.1-1.5-20.3-3.1-30.3c-6.3-37.6-23-68.9-51.2-95c-5.2-4.2-9.4-6.3-16.7-4.2L203.9 91.5c2 1.2 4 2.4 6 3.6l0 0c6.3 3.7 12.2 7.3 17 12.1c30.3 26.1 41.8 61.6 45.9 100.2c1 8.4 0 16.7-7.3 21.9c-8.4 5.2-10.4 12.5-7.3 20.9c4.9 13.2 10.4 26 16.7 38.6L291.6 318c-6.3 8.4-13.6 11.5-21.9 14.6c-12.5 3.1-14.6 7.3-10.4 20.9c.6 1.5 1.4 2.8 2.1 4.2c2.1 5.2 1 8.4-4.2 10.4l-12.5 3.1 5.2 4.2 4.2 4.2c4.2 5.2 4.2 8.4-2.1 10.4c-7.3 4.2-11.5 9.4-11.5 17.7c0 12.5-7.3 19.8-18.8 24c-3.8 1-7.6 1.5-11.5 1l-34.5-2.1z"
    ]
};
var $ef0249c5e48bf4e3$export$72c88c198f2680b = {
    prefix: "fab",
    iconName: "pushed",
    icon: [
        432,
        512,
        [],
        "f3e1",
        "M407 111.9l-98.5-9 14-33.4c10.4-23.5-10.8-40.4-28.7-37L22.5 76.9c-15.1 2.7-26 18.3-21.4 36.6l105.1 348.3c6.5 21.3 36.7 24.2 47.7 7l35.3-80.8 235.2-231.3c16.4-16.8 4.3-42.9-17.4-44.8zM297.6 53.6c5.1-.7 7.5 2.5 5.2 7.4L286 100.9 108.6 84.6l189-31zM22.7 107.9c-3.1-5.1 1-10 6.1-9.1l248.7 22.7-96.9 230.7L22.7 107.9zM136 456.4c-2.6 4-7.9 3.1-9.4-1.2L43.5 179.7l127.7 197.6c-7 15-35.2 79.1-35.2 79.1zm272.8-314.5L210.1 337.3l89.7-213.7 106.4 9.7c4 1.1 5.7 5.3 2.6 8.6z"
    ]
};
var $ef0249c5e48bf4e3$export$1e35be7b9c7acc1f = {
    prefix: "fab",
    iconName: "wordpress-simple",
    icon: [
        512,
        512,
        [],
        "f411",
        "M256 8C119.3 8 8 119.2 8 256c0 136.7 111.3 248 248 248s248-111.3 248-248C504 119.2 392.7 8 256 8zM33 256c0-32.3 6.9-63 19.3-90.7l106.4 291.4C84.3 420.5 33 344.2 33 256zm223 223c-21.9 0-43-3.2-63-9.1l66.9-194.4 68.5 187.8c.5 1.1 1 2.1 1.6 3.1-23.1 8.1-48 12.6-74 12.6zm30.7-327.5c13.4-.7 25.5-2.1 25.5-2.1 12-1.4 10.6-19.1-1.4-18.4 0 0-36.1 2.8-59.4 2.8-21.9 0-58.7-2.8-58.7-2.8-12-.7-13.4 17.7-1.4 18.4 0 0 11.4 1.4 23.4 2.1l34.7 95.2L200.6 393l-81.2-241.5c13.4-.7 25.5-2.1 25.5-2.1 12-1.4 10.6-19.1-1.4-18.4 0 0-36.1 2.8-59.4 2.8-4.2 0-9.1-.1-14.4-.3C109.6 73 178.1 33 256 33c58 0 110.9 22.2 150.6 58.5-1-.1-1.9-.2-2.9-.2-21.9 0-37.4 19.1-37.4 39.6 0 18.4 10.6 33.9 21.9 52.3 8.5 14.8 18.4 33.9 18.4 61.5 0 19.1-7.3 41.2-17 72.1l-22.2 74.3-80.7-239.6zm81.4 297.2l68.1-196.9c12.7-31.8 17-57.2 17-79.9 0-8.2-.5-15.8-1.5-22.9 17.4 31.8 27.3 68.2 27.3 107 0 82.3-44.6 154.1-110.9 192.7z"
    ]
};
var $ef0249c5e48bf4e3$export$cb3944b58accd310 = {
    prefix: "fab",
    iconName: "nutritionix",
    icon: [
        400,
        512,
        [],
        "f3d6",
        "M88 8.1S221.4-.1 209 112.5c0 0 19.1-74.9 103-40.6 0 0-17.7 74-88 56 0 0 14.6-54.6 66.1-56.6 0 0-39.9-10.3-82.1 48.8 0 0-19.8-94.5-93.6-99.7 0 0 75.2 19.4 77.6 107.5 0 .1-106.4 7-104-119.8zm312 315.6c0 48.5-9.7 95.3-32 132.3-42.2 30.9-105 48-168 48-62.9 0-125.8-17.1-168-48C9.7 419 0 372.2 0 323.7 0 275.3 17.7 229 40 192c42.2-30.9 97.1-48.6 160-48.6 63 0 117.8 17.6 160 48.6 22.3 37 40 83.3 40 131.7zM120 428c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm0-66.2c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm0-66.2c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zM192 428c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm0-66.2c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm0-66.2c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zM264 428c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm0-66.2c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm0-66.2c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zM336 428c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm0-66.2c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm0-66.2c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm24-39.6c-4.8-22.3-7.4-36.9-16-56-38.8-19.9-90.5-32-144-32S94.8 180.1 56 200c-8.8 19.5-11.2 33.9-16 56 42.2-7.9 98.7-14.8 160-14.8s117.8 6.9 160 14.8z"
    ]
};
var $ef0249c5e48bf4e3$export$d30ca94800bf542b = {
    prefix: "fab",
    iconName: "wodu",
    icon: [
        640,
        512,
        [],
        "e088",
        "M178.414 339.706H141.1L112.166 223.475h-.478L83.228 339.706H45.2L0 168.946H37.548L64.574 285.177h.478L94.707 168.946h35.157l29.178 117.667h.479L187.5 168.946h36.831zM271.4 212.713c38.984 0 64.1 25.828 64.1 65.291 0 39.222-25.111 65.05-64.1 65.05-38.743 0-63.855-25.828-63.855-65.05C207.547 238.541 232.659 212.713 271.4 212.713zm0 104.753c23.2 0 30.133-19.852 30.133-39.462 0-19.852-6.934-39.7-30.133-39.7-27.7 0-29.894 19.85-29.894 39.7C241.508 297.614 248.443 317.466 271.4 317.466zM435.084 323.922h-.478c-7.893 13.392-21.765 19.132-37.548 19.132-37.31 0-55.485-32.045-55.485-66.246 0-33.243 18.415-64.095 54.767-64.095 14.589 0 28.938 6.218 36.831 18.416h.24V168.946h33.96v170.76H435.084zM405.428 238.3c-22.24 0-29.894 19.134-29.894 39.463 0 19.371 8.848 39.7 29.894 39.7 22.482 0 29.178-19.613 29.178-39.94C434.606 257.436 427.432 238.3 405.428 238.3zM592.96 339.706H560.673V322.487h-.718c-8.609 13.87-23.436 20.567-37.786 20.567-36.113 0-45.2-20.328-45.2-50.941V216.061h33.959V285.9c0 20.329 5.979 30.372 21.765 30.372 18.415 0 26.306-10.283 26.306-35.393V216.061H592.96zM602.453 302.876H640v36.83H602.453z"
    ]
};
var $ef0249c5e48bf4e3$export$6d89c09f17c54b19 = {
    prefix: "fab",
    iconName: "google-pay",
    icon: [
        640,
        512,
        [],
        "e079",
        "M105.72,215v41.25h57.1a49.66,49.66,0,0,1-21.14,32.6c-9.54,6.55-21.72,10.28-36,10.28-27.6,0-50.93-18.91-59.3-44.22a65.61,65.61,0,0,1,0-41l0,0c8.37-25.46,31.7-44.37,59.3-44.37a56.43,56.43,0,0,1,40.51,16.08L176.47,155a101.24,101.24,0,0,0-70.75-27.84,105.55,105.55,0,0,0-94.38,59.11,107.64,107.64,0,0,0,0,96.18v.15a105.41,105.41,0,0,0,94.38,59c28.47,0,52.55-9.53,70-25.91,20-18.61,31.41-46.15,31.41-78.91A133.76,133.76,0,0,0,205.38,215Zm389.41-4c-10.13-9.38-23.93-14.14-41.39-14.14-22.46,0-39.34,8.34-50.5,24.86l20.85,13.26q11.45-17,31.26-17a34.05,34.05,0,0,1,22.75,8.79A28.14,28.14,0,0,1,487.79,248v5.51c-9.1-5.07-20.55-7.75-34.64-7.75-16.44,0-29.65,3.88-39.49,11.77s-14.82,18.31-14.82,31.56a39.74,39.74,0,0,0,13.94,31.27c9.25,8.34,21,12.51,34.79,12.51,16.29,0,29.21-7.3,39-21.89h1v17.72h22.61V250C510.25,233.45,505.26,220.34,495.13,211ZM475.9,300.3a37.32,37.32,0,0,1-26.57,11.16A28.61,28.61,0,0,1,431,305.21a19.41,19.41,0,0,1-7.77-15.63c0-7,3.22-12.81,9.54-17.42s14.53-7,24.07-7C470,265,480.3,268,487.64,273.94,487.64,284.07,483.68,292.85,475.9,300.3Zm-93.65-142A55.71,55.71,0,0,0,341.74,142H279.07V328.74H302.7V253.1h39c16,0,29.5-5.36,40.51-15.93.88-.89,1.76-1.79,2.65-2.68A54.45,54.45,0,0,0,382.25,158.26Zm-16.58,62.23a30.65,30.65,0,0,1-23.34,9.68H302.7V165h39.63a32,32,0,0,1,22.6,9.23A33.18,33.18,0,0,1,365.67,220.49ZM614.31,201,577.77,292.7h-.45L539.9,201H514.21L566,320.55l-29.35,64.32H561L640,201Z"
    ]
};
var $ef0249c5e48bf4e3$export$fd8d76c5b86b3d2b = {
    prefix: "fab",
    iconName: "intercom",
    icon: [
        448,
        512,
        [],
        "f7af",
        "M392 32H56C25.1 32 0 57.1 0 88v336c0 30.9 25.1 56 56 56h336c30.9 0 56-25.1 56-56V88c0-30.9-25.1-56-56-56zm-108.3 82.1c0-19.8 29.9-19.8 29.9 0v199.5c0 19.8-29.9 19.8-29.9 0V114.1zm-74.6-7.5c0-19.8 29.9-19.8 29.9 0v216.5c0 19.8-29.9 19.8-29.9 0V106.6zm-74.7 7.5c0-19.8 29.9-19.8 29.9 0v199.5c0 19.8-29.9 19.8-29.9 0V114.1zM59.7 144c0-19.8 29.9-19.8 29.9 0v134.3c0 19.8-29.9 19.8-29.9 0V144zm323.4 227.8c-72.8 63-241.7 65.4-318.1 0-15-12.8 4.4-35.5 19.4-22.7 65.9 55.3 216.1 53.9 279.3 0 14.9-12.9 34.3 9.8 19.4 22.7zm5.2-93.5c0 19.8-29.9 19.8-29.9 0V144c0-19.8 29.9-19.8 29.9 0v134.3z"
    ]
};
var $ef0249c5e48bf4e3$export$16e69e0d77404518 = {
    prefix: "fab",
    iconName: "zhihu",
    icon: [
        640,
        512,
        [],
        "f63f",
        "M170.54 148.13v217.54l23.43.01 7.71 26.37 42.01-26.37h49.53V148.13H170.54zm97.75 193.93h-27.94l-27.9 17.51-5.08-17.47-11.9-.04V171.75h72.82v170.31zm-118.46-94.39H97.5c1.74-27.1 2.2-51.59 2.2-73.46h51.16s1.97-22.56-8.58-22.31h-88.5c3.49-13.12 7.87-26.66 13.12-40.67 0 0-24.07 0-32.27 21.57-3.39 8.9-13.21 43.14-30.7 78.12 5.89-.64 25.37-1.18 36.84-22.21 2.11-5.89 2.51-6.66 5.14-14.53h28.87c0 10.5-1.2 66.88-1.68 73.44H20.83c-11.74 0-15.56 23.62-15.56 23.62h65.58C66.45 321.1 42.83 363.12 0 396.34c20.49 5.85 40.91-.93 51-9.9 0 0 22.98-20.9 35.59-69.25l53.96 64.94s7.91-26.89-1.24-39.99c-7.58-8.92-28.06-33.06-36.79-41.81L87.9 311.95c4.36-13.98 6.99-27.55 7.87-40.67h61.65s-.09-23.62-7.59-23.62v.01zm412.02-1.6c20.83-25.64 44.98-58.57 44.98-58.57s-18.65-14.8-27.38-4.06c-6 8.15-36.83 48.2-36.83 48.2l19.23 14.43zm-150.09-59.09c-9.01-8.25-25.91 2.13-25.91 2.13s39.52 55.04 41.12 57.45l19.46-13.73s-25.67-37.61-34.66-45.86h-.01zM640 258.35c-19.78 0-130.91.93-131.06.93v-101c4.81 0 12.42-.4 22.85-1.2 40.88-2.41 70.13-4 87.77-4.81 0 0 12.22-27.19-.59-33.44-3.07-1.18-23.17 4.58-23.17 4.58s-165.22 16.49-232.36 18.05c1.6 8.82 7.62 17.08 15.78 19.55 13.31 3.48 22.69 1.7 49.15.89 24.83-1.6 43.68-2.43 56.51-2.43v99.81H351.41s2.82 22.31 25.51 22.85h107.94v70.92c0 13.97-11.19 21.99-24.48 21.12-14.08.11-26.08-1.15-41.69-1.81 1.99 3.97 6.33 14.39 19.31 21.84 9.88 4.81 16.17 6.57 26.02 6.57 29.56 0 45.67-17.28 44.89-45.31v-73.32h122.36c9.68 0 8.7-23.78 8.7-23.78l.03-.01z"
    ]
};
var $ef0249c5e48bf4e3$export$80de216c9d46bac = {
    prefix: "fab",
    iconName: "korvue",
    icon: [
        446,
        512,
        [],
        "f42f",
        "M386.5 34h-327C26.8 34 0 60.8 0 93.5v327.1C0 453.2 26.8 480 59.5 480h327.1c33 0 59.5-26.8 59.5-59.5v-327C446 60.8 419.2 34 386.5 34zM87.1 120.8h96v116l61.8-116h110.9l-81.2 132H87.1v-132zm161.8 272.1l-65.7-113.6v113.6h-96V262.1h191.5l88.6 130.8H248.9z"
    ]
};
var $ef0249c5e48bf4e3$export$4fe14f0ab3be9a3 = {
    prefix: "fab",
    iconName: "pix",
    icon: [
        512,
        512,
        [],
        "e43a",
        "M242.4 292.5C247.8 287.1 257.1 287.1 262.5 292.5L339.5 369.5C353.7 383.7 372.6 391.5 392.6 391.5H407.7L310.6 488.6C280.3 518.1 231.1 518.1 200.8 488.6L103.3 391.2H112.6C132.6 391.2 151.5 383.4 165.7 369.2L242.4 292.5zM262.5 218.9C256.1 224.4 247.9 224.5 242.4 218.9L165.7 142.2C151.5 127.1 132.6 120.2 112.6 120.2H103.3L200.7 22.76C231.1-7.586 280.3-7.586 310.6 22.76L407.8 119.9H392.6C372.6 119.9 353.7 127.7 339.5 141.9L262.5 218.9zM112.6 142.7C126.4 142.7 139.1 148.3 149.7 158.1L226.4 234.8C233.6 241.1 243 245.6 252.5 245.6C261.9 245.6 271.3 241.1 278.5 234.8L355.5 157.8C365.3 148.1 378.8 142.5 392.6 142.5H430.3L488.6 200.8C518.9 231.1 518.9 280.3 488.6 310.6L430.3 368.9H392.6C378.8 368.9 365.3 363.3 355.5 353.5L278.5 276.5C264.6 262.6 240.3 262.6 226.4 276.6L149.7 353.2C139.1 363 126.4 368.6 112.6 368.6H80.78L22.76 310.6C-7.586 280.3-7.586 231.1 22.76 200.8L80.78 142.7H112.6z"
    ]
};
var $ef0249c5e48bf4e3$export$c2ce1e5693cbcd01 = {
    prefix: "fab",
    iconName: "steam-symbol",
    icon: [
        448,
        512,
        [],
        "f3f6",
        "M395.5 177.5c0 33.8-27.5 61-61 61-33.8 0-61-27.3-61-61s27.3-61 61-61c33.5 0 61 27.2 61 61zm52.5.2c0 63-51 113.8-113.7 113.8L225 371.3c-4 43-40.5 76.8-84.5 76.8-40.5 0-74.7-28.8-83-67L0 358V250.7L97.2 290c15.1-9.2 32.2-13.3 52-11.5l71-101.7c.5-62.3 51.5-112.8 114-112.8C397 64 448 115 448 177.7zM203 363c0-34.7-27.8-62.5-62.5-62.5-4.5 0-9 .5-13.5 1.5l26 10.5c25.5 10.2 38 39 27.7 64.5-10.2 25.5-39.2 38-64.7 27.5-10.2-4-20.5-8.3-30.7-12.2 10.5 19.7 31.2 33.2 55.2 33.2 34.7 0 62.5-27.8 62.5-62.5zm207.5-185.3c0-42-34.3-76.2-76.2-76.2-42.3 0-76.5 34.2-76.5 76.2 0 42.2 34.3 76.2 76.5 76.2 41.9.1 76.2-33.9 76.2-76.2z"
    ]
};
var $ef0249c5e48bf4e3$export$3fa11687d7bc6a48 = {
    faMonero: $ef0249c5e48bf4e3$export$155bdf1ceac204e7,
    faHooli: $ef0249c5e48bf4e3$export$3a040ca24382cf1c,
    faYelp: $ef0249c5e48bf4e3$export$2de47f03337052b6,
    faCcVisa: $ef0249c5e48bf4e3$export$acc882c0b0e9e801,
    faLastfm: $ef0249c5e48bf4e3$export$8226e5267dd86de3,
    faShopware: $ef0249c5e48bf4e3$export$c0b2d6cff425a846,
    faCreativeCommonsNc: $ef0249c5e48bf4e3$export$e36098165f3fc869,
    faAws: $ef0249c5e48bf4e3$export$a4ddb2c7f767be70,
    faRedhat: $ef0249c5e48bf4e3$export$d65557a7abc2c5dc,
    faYoast: $ef0249c5e48bf4e3$export$73b6ef60226f6801,
    faCloudflare: $ef0249c5e48bf4e3$export$7a31e37b2189232c,
    faUps: $ef0249c5e48bf4e3$export$c6f6a1beb6102ac,
    faPixiv: $ef0249c5e48bf4e3$export$b64ce7c5d150db12,
    faWpexplorer: $ef0249c5e48bf4e3$export$9ab35a48e8f904bf,
    faDyalog: $ef0249c5e48bf4e3$export$1661cbacae81932b,
    faBity: $ef0249c5e48bf4e3$export$76a6a7e968d921fe,
    faStackpath: $ef0249c5e48bf4e3$export$a14b012b76f98910,
    faBuysellads: $ef0249c5e48bf4e3$export$6c0bc096306cebf8,
    faFirstOrder: $ef0249c5e48bf4e3$export$e0a21844bf49ca8e,
    faModx: $ef0249c5e48bf4e3$export$fb06254b4488a5b6,
    faGuilded: $ef0249c5e48bf4e3$export$b6ff6f33a85ee805,
    faVnv: $ef0249c5e48bf4e3$export$13bd8782a2ce17e7,
    faSquareJs: $ef0249c5e48bf4e3$export$c989752ecb8b3fae,
    faJsSquare: $ef0249c5e48bf4e3$export$d9bf3211f885d573,
    faMicrosoft: $ef0249c5e48bf4e3$export$b3b8195c77f1f877,
    faQq: $ef0249c5e48bf4e3$export$39d59e523abf051d,
    faOrcid: $ef0249c5e48bf4e3$export$9bf8457cc97dd02e,
    faJava: $ef0249c5e48bf4e3$export$25a84a6ff654acd1,
    faInvision: $ef0249c5e48bf4e3$export$6e249797a4721568,
    faCreativeCommonsPdAlt: $ef0249c5e48bf4e3$export$d93ab92a56e88ce6,
    faCentercode: $ef0249c5e48bf4e3$export$961762d5b3aedd8d,
    faGlideG: $ef0249c5e48bf4e3$export$91d5526742c32d42,
    faDrupal: $ef0249c5e48bf4e3$export$51e679e8d2e3f8c1,
    faHireAHelper: $ef0249c5e48bf4e3$export$66507f26cc60b31e,
    faCreativeCommonsBy: $ef0249c5e48bf4e3$export$5040b13190e5beb7,
    faUnity: $ef0249c5e48bf4e3$export$72fd5838af249737,
    faWhmcs: $ef0249c5e48bf4e3$export$4d4f65ec2f52482,
    faRocketchat: $ef0249c5e48bf4e3$export$193ac2f517f63e63,
    faVk: $ef0249c5e48bf4e3$export$a6bf4d62e541f988,
    faUntappd: $ef0249c5e48bf4e3$export$f1679625ed434576,
    faMailchimp: $ef0249c5e48bf4e3$export$da9f5a873e107292,
    faCss3Alt: $ef0249c5e48bf4e3$export$928cd5ee6ccd55c0,
    faSquareReddit: $ef0249c5e48bf4e3$export$307bcbd032fbb8d3,
    faRedditSquare: $ef0249c5e48bf4e3$export$f8480c75bb6acc77,
    faVimeoV: $ef0249c5e48bf4e3$export$2ea137a3f22bc61,
    faContao: $ef0249c5e48bf4e3$export$d023cd407bbc3cab,
    faSquareFontAwesome: $ef0249c5e48bf4e3$export$128da80f2cbe244a,
    faDeskpro: $ef0249c5e48bf4e3$export$9005bf63ad3e3083,
    faBrave: $ef0249c5e48bf4e3$export$ec6cecf928f83afa,
    faSistrix: $ef0249c5e48bf4e3$export$36ca6be2e064d2cd,
    faSquareInstagram: $ef0249c5e48bf4e3$export$526087fb4de86dae,
    faInstagramSquare: $ef0249c5e48bf4e3$export$ccb1f25058292a04,
    faBattleNet: $ef0249c5e48bf4e3$export$fb3fd8e112e1fa28,
    faTheRedYeti: $ef0249c5e48bf4e3$export$daa019c708da49e9,
    faSquareHackerNews: $ef0249c5e48bf4e3$export$ca115ee475bced67,
    faHackerNewsSquare: $ef0249c5e48bf4e3$export$310b7424f1f97fc,
    faEdge: $ef0249c5e48bf4e3$export$9c65bd68cbc68ec9,
    faThreads: $ef0249c5e48bf4e3$export$2a1c6a809b4fdc7f,
    faNapster: $ef0249c5e48bf4e3$export$29d678db44edc00,
    faSquareSnapchat: $ef0249c5e48bf4e3$export$8176f1a0ece4380c,
    faSnapchatSquare: $ef0249c5e48bf4e3$export$20f908cf15afb04b,
    faGooglePlusG: $ef0249c5e48bf4e3$export$74ebd8f5ac37d070,
    faArtstation: $ef0249c5e48bf4e3$export$4fb55b03537dc8e3,
    faMarkdown: $ef0249c5e48bf4e3$export$4401a9960e402a1c,
    faSourcetree: $ef0249c5e48bf4e3$export$fd6b8582f52b208a,
    faGooglePlus: $ef0249c5e48bf4e3$export$384e1aaf24320a2d,
    faDiaspora: $ef0249c5e48bf4e3$export$f59fd74fa97e6ae5,
    faFoursquare: $ef0249c5e48bf4e3$export$b14039dbb12386bc,
    faStackOverflow: $ef0249c5e48bf4e3$export$2c0cf6f85294daec,
    faGithubAlt: $ef0249c5e48bf4e3$export$edfa6885dbf62839,
    faPhoenixSquadron: $ef0249c5e48bf4e3$export$699e806dfe31d90b,
    faPagelines: $ef0249c5e48bf4e3$export$e4b095fb96bd3e1,
    faAlgolia: $ef0249c5e48bf4e3$export$8819d592a12ec37e,
    faRedRiver: $ef0249c5e48bf4e3$export$1052bcfc0bf56d5d,
    faCreativeCommonsSa: $ef0249c5e48bf4e3$export$976ebfab93ea9362,
    faSafari: $ef0249c5e48bf4e3$export$3fbc2591308fa490,
    faGoogle: $ef0249c5e48bf4e3$export$4675affbae76524d,
    faSquareFontAwesomeStroke: $ef0249c5e48bf4e3$export$dda4448112663ba,
    faFontAwesomeAlt: $ef0249c5e48bf4e3$export$85f790d14ecf253e,
    faAtlassian: $ef0249c5e48bf4e3$export$f200be919c1eaf0d,
    faLinkedinIn: $ef0249c5e48bf4e3$export$ed0a679f653cc1ec,
    faDigitalOcean: $ef0249c5e48bf4e3$export$c5c4219467aa9953,
    faNimblr: $ef0249c5e48bf4e3$export$3f240983de3f5d10,
    faChromecast: $ef0249c5e48bf4e3$export$8d89e361d79b386e,
    faEvernote: $ef0249c5e48bf4e3$export$acd6dee6975fc503,
    faHackerNews: $ef0249c5e48bf4e3$export$5d439911ece032d6,
    faCreativeCommonsSampling: $ef0249c5e48bf4e3$export$e443cc965f82dd02,
    faAdversal: $ef0249c5e48bf4e3$export$1a30438e2bd95428,
    faCreativeCommons: $ef0249c5e48bf4e3$export$cf9c9b2132d3672c,
    faWatchmanMonitoring: $ef0249c5e48bf4e3$export$17b7e34aba803644,
    faFonticons: $ef0249c5e48bf4e3$export$324e0175b7ef27f7,
    faWeixin: $ef0249c5e48bf4e3$export$5c0c3408fef47d33,
    faShirtsinbulk: $ef0249c5e48bf4e3$export$621d1ced1e254c1c,
    faCodepen: $ef0249c5e48bf4e3$export$f02422936d21d2f4,
    faGitAlt: $ef0249c5e48bf4e3$export$9ce7fda0737f89e7,
    faLyft: $ef0249c5e48bf4e3$export$c2221e2ed2fea622,
    faRev: $ef0249c5e48bf4e3$export$344ccb7aebcc7cfa,
    faWindows: $ef0249c5e48bf4e3$export$b138356c7d4344fd,
    faWizardsOfTheCoast: $ef0249c5e48bf4e3$export$2c1079aeb76cd815,
    faSquareViadeo: $ef0249c5e48bf4e3$export$d20d4c95d5790834,
    faViadeoSquare: $ef0249c5e48bf4e3$export$46c94e3313db0253,
    faMeetup: $ef0249c5e48bf4e3$export$61e6f6fcefd81d6e,
    faCentos: $ef0249c5e48bf4e3$export$47b9420154e916ca,
    faAdn: $ef0249c5e48bf4e3$export$64d8cc39326ee7a8,
    faCloudsmith: $ef0249c5e48bf4e3$export$616a6b084ab35801,
    faOpensuse: $ef0249c5e48bf4e3$export$d668d8d9da44b43e,
    faPiedPiperAlt: $ef0249c5e48bf4e3$export$ef7de58d3fe843ba,
    faSquareDribbble: $ef0249c5e48bf4e3$export$fc95d67ac3aa8c53,
    faDribbbleSquare: $ef0249c5e48bf4e3$export$ff55221913bb3cd0,
    faCodiepie: $ef0249c5e48bf4e3$export$248fddd2c856e8cc,
    faNode: $ef0249c5e48bf4e3$export$4c16416edc1f091a,
    faMix: $ef0249c5e48bf4e3$export$4176cb98e090fc09,
    faSteam: $ef0249c5e48bf4e3$export$7c80ad2689275b29,
    faCcApplePay: $ef0249c5e48bf4e3$export$37af1170a8e0c21b,
    faScribd: $ef0249c5e48bf4e3$export$d271dfaa2c63aec5,
    faDebian: $ef0249c5e48bf4e3$export$b30079bac9ebcf2a,
    faOpenid: $ef0249c5e48bf4e3$export$b2dcd141e150a391,
    faInstalod: $ef0249c5e48bf4e3$export$792bea9ca32c60da,
    faExpeditedssl: $ef0249c5e48bf4e3$export$fe553f3645c5aefa,
    faSellcast: $ef0249c5e48bf4e3$export$23a4f18e8bd9f913,
    faSquareTwitter: $ef0249c5e48bf4e3$export$58fc652e3c488143,
    faTwitterSquare: $ef0249c5e48bf4e3$export$270370f3feaf6b90,
    faRProject: $ef0249c5e48bf4e3$export$f9a04980ef22b6b0,
    faDelicious: $ef0249c5e48bf4e3$export$fc15ee5b2eab0af4,
    faFreebsd: $ef0249c5e48bf4e3$export$1fa830857b3a4dc7,
    faVuejs: $ef0249c5e48bf4e3$export$3e0cc9b4555f8145,
    faAccusoft: $ef0249c5e48bf4e3$export$233214294e90ff53,
    faIoxhost: $ef0249c5e48bf4e3$export$d11e9e62a1442448,
    faFonticonsFi: $ef0249c5e48bf4e3$export$e6a0ac478bf76bf2,
    faAppStore: $ef0249c5e48bf4e3$export$500760921a1e1f4e,
    faCcMastercard: $ef0249c5e48bf4e3$export$dd0d0d0b3b519db5,
    faItunesNote: $ef0249c5e48bf4e3$export$a0c8448ba3e387bc,
    faGolang: $ef0249c5e48bf4e3$export$36cd41563937ec03,
    faKickstarter: $ef0249c5e48bf4e3$export$f06b8625c0ebb13a,
    faGrav: $ef0249c5e48bf4e3$export$fdcdacf548a335ed,
    faWeibo: $ef0249c5e48bf4e3$export$75bd846ccb390b1e,
    faUncharted: $ef0249c5e48bf4e3$export$e1cced2e7ea20eff,
    faFirstdraft: $ef0249c5e48bf4e3$export$44a54556e145bddf,
    faSquareYoutube: $ef0249c5e48bf4e3$export$1082b39fc1076b43,
    faYoutubeSquare: $ef0249c5e48bf4e3$export$8992da42b645c563,
    faWikipediaW: $ef0249c5e48bf4e3$export$6657c749288c4042,
    faWpressr: $ef0249c5e48bf4e3$export$66f88c21efa6f12d,
    faRendact: $ef0249c5e48bf4e3$export$d06b08e37a8aaaec,
    faAngellist: $ef0249c5e48bf4e3$export$65f66dc47afb97bd,
    faGalacticRepublic: $ef0249c5e48bf4e3$export$ba5a2dfe23db8bb6,
    faNfcDirectional: $ef0249c5e48bf4e3$export$d637dd7b404459cf,
    faSkype: $ef0249c5e48bf4e3$export$78370b1b91348c9e,
    faJoget: $ef0249c5e48bf4e3$export$ae307621d0877ba2,
    faFedora: $ef0249c5e48bf4e3$export$8cf9f3ca16e668b0,
    faStripeS: $ef0249c5e48bf4e3$export$4823078d958b443a,
    faMeta: $ef0249c5e48bf4e3$export$75b94550e27ccec5,
    faLaravel: $ef0249c5e48bf4e3$export$bfe42001388ccf42,
    faHotjar: $ef0249c5e48bf4e3$export$d309e8b75a17a518,
    faBluetoothB: $ef0249c5e48bf4e3$export$ad4174fe3fc4abe2,
    faSquareLetterboxd: $ef0249c5e48bf4e3$export$628b421165d7d11a,
    faStickerMule: $ef0249c5e48bf4e3$export$439612f87b462a40,
    faCreativeCommonsZero: $ef0249c5e48bf4e3$export$72df0aea6a5da9de,
    faHips: $ef0249c5e48bf4e3$export$51de6451f4c7b107,
    faBehance: $ef0249c5e48bf4e3$export$907c17a7f1d6a0d3,
    faReddit: $ef0249c5e48bf4e3$export$97dd0b04d798af1a,
    faDiscord: $ef0249c5e48bf4e3$export$c8d4525a5e9ad3ad,
    faChrome: $ef0249c5e48bf4e3$export$430df45ec2fae593,
    faAppStoreIos: $ef0249c5e48bf4e3$export$e36cec8e481a3a4b,
    faCcDiscover: $ef0249c5e48bf4e3$export$4a929e0a1abf7e41,
    faWpbeginner: $ef0249c5e48bf4e3$export$a24323c111493948,
    faConfluence: $ef0249c5e48bf4e3$export$259f76b402dd445f,
    faShoelace: $ef0249c5e48bf4e3$export$b4e2b27ee3ee1821,
    faMdb: $ef0249c5e48bf4e3$export$7add95166ef0248a,
    faDochub: $ef0249c5e48bf4e3$export$81d728fa770edbe1,
    faAccessibleIcon: $ef0249c5e48bf4e3$export$3c152d640f62968e,
    faEbay: $ef0249c5e48bf4e3$export$ddb611ff59fc9802,
    faAmazon: $ef0249c5e48bf4e3$export$ebc1e565fd80a447,
    faUnsplash: $ef0249c5e48bf4e3$export$3997191a5880488f,
    faYarn: $ef0249c5e48bf4e3$export$a67629e1d516967d,
    faSquareSteam: $ef0249c5e48bf4e3$export$c334a5e9c1f73381,
    faSteamSquare: $ef0249c5e48bf4e3$export$b0e9b012d636da0a,
    fa500px: $ef0249c5e48bf4e3$export$4adb509bb23593b0,
    faSquareVimeo: $ef0249c5e48bf4e3$export$8974793285f35ac8,
    faVimeoSquare: $ef0249c5e48bf4e3$export$78628c2da1e685b5,
    faAsymmetrik: $ef0249c5e48bf4e3$export$50ef858a08ddd1e5,
    faFontAwesome: $ef0249c5e48bf4e3$export$aa4baaed1c60f58d,
    faFontAwesomeFlag: $ef0249c5e48bf4e3$export$102c25fde54d4843,
    faFontAwesomeLogoFull: $ef0249c5e48bf4e3$export$6e20d421a2e0f320,
    faGratipay: $ef0249c5e48bf4e3$export$cf1aa567b9609235,
    faApple: $ef0249c5e48bf4e3$export$a649d390c50fd6df,
    faHive: $ef0249c5e48bf4e3$export$f5cdac644000a430,
    faGitkraken: $ef0249c5e48bf4e3$export$cd2223c7b77bd41c,
    faKeybase: $ef0249c5e48bf4e3$export$c80d8749c6106849,
    faApplePay: $ef0249c5e48bf4e3$export$fbfbf4eeb373a6ab,
    faPadlet: $ef0249c5e48bf4e3$export$369427eba18eb826,
    faAmazonPay: $ef0249c5e48bf4e3$export$448eb0f9d8323c85,
    faSquareGithub: $ef0249c5e48bf4e3$export$be5db653ba5b5871,
    faGithubSquare: $ef0249c5e48bf4e3$export$5fe0a956971aa3c2,
    faStumbleupon: $ef0249c5e48bf4e3$export$7872bf6ac6945976,
    faFedex: $ef0249c5e48bf4e3$export$c9127779112e2ff8,
    faPhoenixFramework: $ef0249c5e48bf4e3$export$3d9357caf53f9b59,
    faShopify: $ef0249c5e48bf4e3$export$c18d8940c93637ce,
    faNeos: $ef0249c5e48bf4e3$export$a38c2efcceaf5a01,
    faSquareThreads: $ef0249c5e48bf4e3$export$75f15eb229650b3a,
    faHackerrank: $ef0249c5e48bf4e3$export$5fb7eeed7d5e4dea,
    faResearchgate: $ef0249c5e48bf4e3$export$5c5693a4f82cd9eb,
    faSwift: $ef0249c5e48bf4e3$export$dcdf312747bb3471,
    faAngular: $ef0249c5e48bf4e3$export$9df3e2a7a3f59b3b,
    faSpeakap: $ef0249c5e48bf4e3$export$90ae1a3824ece6f2,
    faAngrycreative: $ef0249c5e48bf4e3$export$a9e7bf021125ee89,
    faYCombinator: $ef0249c5e48bf4e3$export$9ee2f35ed1fe0fd4,
    faEmpire: $ef0249c5e48bf4e3$export$c966a5d80266ef06,
    faEnvira: $ef0249c5e48bf4e3$export$9e2c7c55d2fddd0,
    faGoogleScholar: $ef0249c5e48bf4e3$export$ed92c068824a8084,
    faSquareGitlab: $ef0249c5e48bf4e3$export$1c14974e1904bc76,
    faGitlabSquare: $ef0249c5e48bf4e3$export$4459a47a802afa29,
    faStudiovinari: $ef0249c5e48bf4e3$export$9d71d8f56add75cb,
    faPiedPiper: $ef0249c5e48bf4e3$export$13581f4cc240d7d9,
    faWordpress: $ef0249c5e48bf4e3$export$8898e76262ada01d,
    faProductHunt: $ef0249c5e48bf4e3$export$91dcff48b72c75ce,
    faFirefox: $ef0249c5e48bf4e3$export$53a067e7149deea9,
    faLinode: $ef0249c5e48bf4e3$export$fcbc58842fe8e217,
    faGoodreads: $ef0249c5e48bf4e3$export$cc058e4fd428aead,
    faSquareOdnoklassniki: $ef0249c5e48bf4e3$export$df58e66e423b11a0,
    faOdnoklassnikiSquare: $ef0249c5e48bf4e3$export$8bab3f1c73ff1d0,
    faJsfiddle: $ef0249c5e48bf4e3$export$49c67105b922997,
    faSith: $ef0249c5e48bf4e3$export$6b9a61f04a3c9eb4,
    faThemeisle: $ef0249c5e48bf4e3$export$9ce81750a9f73ac4,
    faPage4: $ef0249c5e48bf4e3$export$e504e93b36693690,
    faHashnode: $ef0249c5e48bf4e3$export$459e822cce028974,
    faReact: $ef0249c5e48bf4e3$export$e62f4d94322d112c,
    faCcPaypal: $ef0249c5e48bf4e3$export$c4a0e7e817efc4de,
    faSquarespace: $ef0249c5e48bf4e3$export$c1ba640907c93eb6,
    faCcStripe: $ef0249c5e48bf4e3$export$235ca29d6ed8f50f,
    faCreativeCommonsShare: $ef0249c5e48bf4e3$export$82bc9680d7d55560,
    faBitcoin: $ef0249c5e48bf4e3$export$7bb8936d912f16ef,
    faKeycdn: $ef0249c5e48bf4e3$export$644ebffaf375bd06,
    faOpera: $ef0249c5e48bf4e3$export$76e4000ae88923a5,
    faItchIo: $ef0249c5e48bf4e3$export$4ec4278290df08a8,
    faUmbraco: $ef0249c5e48bf4e3$export$b92d594113fd14c4,
    faGalacticSenate: $ef0249c5e48bf4e3$export$85ca259eee71d856,
    faUbuntu: $ef0249c5e48bf4e3$export$188bec0355fe7cb3,
    faDraft2digital: $ef0249c5e48bf4e3$export$89aeef49dacedf59,
    faStripe: $ef0249c5e48bf4e3$export$4124a45a674b7b36,
    faHouzz: $ef0249c5e48bf4e3$export$f5c2efa520323804,
    faGg: $ef0249c5e48bf4e3$export$5b7cd580ca5d0c32,
    faDhl: $ef0249c5e48bf4e3$export$f3f333bdcc61afcd,
    faSquarePinterest: $ef0249c5e48bf4e3$export$bfa4536fab29fa25,
    faPinterestSquare: $ef0249c5e48bf4e3$export$67aa35027cc046c7,
    faXing: $ef0249c5e48bf4e3$export$28ff226a626fb008,
    faBlackberry: $ef0249c5e48bf4e3$export$11c2ed8ca6d46555,
    faCreativeCommonsPd: $ef0249c5e48bf4e3$export$10c9e6deac1c2eeb,
    faPlaystation: $ef0249c5e48bf4e3$export$6fcce83c026197c,
    faQuinscape: $ef0249c5e48bf4e3$export$1079c541f45f51d0,
    faLess: $ef0249c5e48bf4e3$export$df0a28abd4a08bff,
    faBloggerB: $ef0249c5e48bf4e3$export$fb78f7bb43feec45,
    faOpencart: $ef0249c5e48bf4e3$export$b1b65e1549fc9915,
    faVine: $ef0249c5e48bf4e3$export$ff24f295c905f144,
    faSignalMessenger: $ef0249c5e48bf4e3$export$95b71ec8a2f59bf0,
    faPaypal: $ef0249c5e48bf4e3$export$1aaa7b292157aaf7,
    faGitlab: $ef0249c5e48bf4e3$export$bc1566dfb0a3651b,
    faTypo3: $ef0249c5e48bf4e3$export$26fe3ad1dc9d4c5b,
    faRedditAlien: $ef0249c5e48bf4e3$export$9fbf70587b6b0dcc,
    faYahoo: $ef0249c5e48bf4e3$export$d0632e92ebe1197f,
    faDailymotion: $ef0249c5e48bf4e3$export$9743e7788f64058a,
    faAffiliatetheme: $ef0249c5e48bf4e3$export$c40f060084205fb6,
    faPiedPiperPp: $ef0249c5e48bf4e3$export$96d17626187f6e34,
    faBootstrap: $ef0249c5e48bf4e3$export$3de8f256f5aadacf,
    faOdnoklassniki: $ef0249c5e48bf4e3$export$f31d1294fef45f,
    faNfcSymbol: $ef0249c5e48bf4e3$export$a64aa05b0287bdaf,
    faMintbit: $ef0249c5e48bf4e3$export$1aeaa8a5ac0e3463,
    faEthereum: $ef0249c5e48bf4e3$export$b5ebb163fdb5edfd,
    faSpeakerDeck: $ef0249c5e48bf4e3$export$7c461c4ee7c07c19,
    faCreativeCommonsNcEu: $ef0249c5e48bf4e3$export$bcf1858bdc40caa3,
    faPatreon: $ef0249c5e48bf4e3$export$a4dfebb823a477ff,
    faAvianex: $ef0249c5e48bf4e3$export$862396e708985a99,
    faEllo: $ef0249c5e48bf4e3$export$e644e4a8cae83fb3,
    faGofore: $ef0249c5e48bf4e3$export$380164e9d6cdbec2,
    faBimobject: $ef0249c5e48bf4e3$export$a219f36955efe01a,
    faBraveReverse: $ef0249c5e48bf4e3$export$3d9997b304f32d18,
    faFacebookF: $ef0249c5e48bf4e3$export$890714bb00316cc,
    faSquareGooglePlus: $ef0249c5e48bf4e3$export$e94511deb1df63ce,
    faGooglePlusSquare: $ef0249c5e48bf4e3$export$d546947149d9505a,
    faMandalorian: $ef0249c5e48bf4e3$export$2a745e3ef2838c53,
    faFirstOrderAlt: $ef0249c5e48bf4e3$export$ea0bc2cd8d60b806,
    faOsi: $ef0249c5e48bf4e3$export$89cf1df24c6f1e2,
    faGoogleWallet: $ef0249c5e48bf4e3$export$6fd7b581d1a20a14,
    faDAndDBeyond: $ef0249c5e48bf4e3$export$8ffeba28c1feff0d,
    faPeriscope: $ef0249c5e48bf4e3$export$10deb29d7dbf2418,
    faFulcrum: $ef0249c5e48bf4e3$export$beb89eeaf726c65a,
    faCloudscale: $ef0249c5e48bf4e3$export$fdf6053d73314ca6,
    faForumbee: $ef0249c5e48bf4e3$export$e4fb88a0423b6fee,
    faMizuni: $ef0249c5e48bf4e3$export$e6a3c752190fa3cb,
    faSchlix: $ef0249c5e48bf4e3$export$3f1891b85805675f,
    faSquareXing: $ef0249c5e48bf4e3$export$ca49464b0602c8ef,
    faXingSquare: $ef0249c5e48bf4e3$export$3f616d72d818a1a6,
    faBandcamp: $ef0249c5e48bf4e3$export$cf8fa465ef81d073,
    faWpforms: $ef0249c5e48bf4e3$export$f70eba4216b4419a,
    faCloudversify: $ef0249c5e48bf4e3$export$623057fac7dabd52,
    faUsps: $ef0249c5e48bf4e3$export$216644b0c66e66a5,
    faMegaport: $ef0249c5e48bf4e3$export$e7e4dbda4df6110f,
    faMagento: $ef0249c5e48bf4e3$export$9b8374b50472190d,
    faSpotify: $ef0249c5e48bf4e3$export$8218f3fbb2f89724,
    faOptinMonster: $ef0249c5e48bf4e3$export$5247a00f0c0b93a3,
    faFly: $ef0249c5e48bf4e3$export$cfbbba1261e4e2d2,
    faAviato: $ef0249c5e48bf4e3$export$f731696770842fd2,
    faItunes: $ef0249c5e48bf4e3$export$5f69a5b38e12c984,
    faCuttlefish: $ef0249c5e48bf4e3$export$883d4844d275b117,
    faBlogger: $ef0249c5e48bf4e3$export$eba2747efc67a397,
    faFlickr: $ef0249c5e48bf4e3$export$4fc2e88e3ac2b091,
    faViber: $ef0249c5e48bf4e3$export$c16cb0c14aa5beed,
    faSoundcloud: $ef0249c5e48bf4e3$export$5803ef8c86f9786d,
    faDigg: $ef0249c5e48bf4e3$export$1902312a1701467c,
    faTencentWeibo: $ef0249c5e48bf4e3$export$9ea61fa1ff3225c6,
    faLetterboxd: $ef0249c5e48bf4e3$export$3d0320148c8ebcd6,
    faSymfony: $ef0249c5e48bf4e3$export$5420457350c35845,
    faMaxcdn: $ef0249c5e48bf4e3$export$a33f03bc723e6603,
    faEtsy: $ef0249c5e48bf4e3$export$c7956780474e39de,
    faFacebookMessenger: $ef0249c5e48bf4e3$export$6c28dada3398f534,
    faAudible: $ef0249c5e48bf4e3$export$83a2d14204e40d9a,
    faThinkPeaks: $ef0249c5e48bf4e3$export$4c12ad86c5e9c2a9,
    faBilibili: $ef0249c5e48bf4e3$export$34797550194301d4,
    faErlang: $ef0249c5e48bf4e3$export$c6087bbc62da6f90,
    faXTwitter: $ef0249c5e48bf4e3$export$fd0513a3aa908a67,
    faCottonBureau: $ef0249c5e48bf4e3$export$8fc0685430a4202e,
    faDashcube: $ef0249c5e48bf4e3$export$fc2c1db4698b6c91,
    fa42Group: $ef0249c5e48bf4e3$export$a02285afcee8b3ba,
    faInnosoft: $ef0249c5e48bf4e3$export$da8db9965333c744,
    faStackExchange: $ef0249c5e48bf4e3$export$d511b4edf7fbac5a,
    faElementor: $ef0249c5e48bf4e3$export$66726053c0c0ec32,
    faSquarePiedPiper: $ef0249c5e48bf4e3$export$9d16a5780aab9cd3,
    faPiedPiperSquare: $ef0249c5e48bf4e3$export$95ddae6b65597c6e,
    faCreativeCommonsNd: $ef0249c5e48bf4e3$export$157e4276d9138bda,
    faPalfed: $ef0249c5e48bf4e3$export$a226dd96512e144,
    faSuperpowers: $ef0249c5e48bf4e3$export$349f4fc9997a1bf0,
    faResolving: $ef0249c5e48bf4e3$export$e73a6c635a57ef10,
    faXbox: $ef0249c5e48bf4e3$export$2c743c09f4269e9c,
    faSearchengin: $ef0249c5e48bf4e3$export$e72de9688042e327,
    faTiktok: $ef0249c5e48bf4e3$export$f310e79ae35a251f,
    faSquareFacebook: $ef0249c5e48bf4e3$export$8545d76ecd01ec19,
    faFacebookSquare: $ef0249c5e48bf4e3$export$cd6ab8ed6a9ec7a4,
    faRenren: $ef0249c5e48bf4e3$export$36a9439e8de2df70,
    faLinux: $ef0249c5e48bf4e3$export$5cb68a24a0b7bdf6,
    faGlide: $ef0249c5e48bf4e3$export$c4c84939b8784e10,
    faLinkedin: $ef0249c5e48bf4e3$export$b38fbe0cd1e4c67d,
    faHubspot: $ef0249c5e48bf4e3$export$418b99079caf9b9b,
    faDeploydog: $ef0249c5e48bf4e3$export$bd9dbf3c3b0bdc5e,
    faTwitch: $ef0249c5e48bf4e3$export$154857d90d308f7c,
    faRavelry: $ef0249c5e48bf4e3$export$cab2db22e59af947,
    faMixer: $ef0249c5e48bf4e3$export$83d047b1c09d253,
    faSquareLastfm: $ef0249c5e48bf4e3$export$37794c0b0ffc1e44,
    faLastfmSquare: $ef0249c5e48bf4e3$export$c2f59587d6a3a574,
    faVimeo: $ef0249c5e48bf4e3$export$b73c31bd90a3782e,
    faMendeley: $ef0249c5e48bf4e3$export$a580d86d20b50be3,
    faUniregistry: $ef0249c5e48bf4e3$export$6fb93399039178f9,
    faFigma: $ef0249c5e48bf4e3$export$e71a35e82f13ad7f,
    faCreativeCommonsRemix: $ef0249c5e48bf4e3$export$c02c848648d47b55,
    faCcAmazonPay: $ef0249c5e48bf4e3$export$3f0dada7ec074193,
    faDropbox: $ef0249c5e48bf4e3$export$e4589d83245ae1b2,
    faInstagram: $ef0249c5e48bf4e3$export$8256451a9905291a,
    faCmplid: $ef0249c5e48bf4e3$export$f4e59d0d43aeb784,
    faUpwork: $ef0249c5e48bf4e3$export$f32e8672931b41ff,
    faFacebook: $ef0249c5e48bf4e3$export$86108d0b79007794,
    faGripfire: $ef0249c5e48bf4e3$export$957b7296da5b4490,
    faJediOrder: $ef0249c5e48bf4e3$export$3a376d0f2ecfb7d0,
    faUikit: $ef0249c5e48bf4e3$export$27afc16078b5f3ac,
    faFortAwesomeAlt: $ef0249c5e48bf4e3$export$a5097e0b1bb080b7,
    faPhabricator: $ef0249c5e48bf4e3$export$cc29519275365076,
    faUssunnah: $ef0249c5e48bf4e3$export$d0ceedb643a91662,
    faEarlybirds: $ef0249c5e48bf4e3$export$c30a6352a2a5e8ea,
    faTradeFederation: $ef0249c5e48bf4e3$export$83b68077d321f3ad,
    faAutoprefixer: $ef0249c5e48bf4e3$export$2ea4e300aa12cd0a,
    faWhatsapp: $ef0249c5e48bf4e3$export$45bdf388845cdf99,
    faSlideshare: $ef0249c5e48bf4e3$export$4dcd48fd9c0bdd2d,
    faGooglePlay: $ef0249c5e48bf4e3$export$cfa707f90d6b79ec,
    faViadeo: $ef0249c5e48bf4e3$export$6f9febfcc8ac97d4,
    faLine: $ef0249c5e48bf4e3$export$c5b04bbf0f48913a,
    faGoogleDrive: $ef0249c5e48bf4e3$export$631c05505a17faa8,
    faServicestack: $ef0249c5e48bf4e3$export$c2417738aeefe7e6,
    faSimplybuilt: $ef0249c5e48bf4e3$export$8b48c2e6e01a12e0,
    faBitbucket: $ef0249c5e48bf4e3$export$de75f8fcf71dfed9,
    faImdb: $ef0249c5e48bf4e3$export$c85bcd118a7a17ff,
    faDeezer: $ef0249c5e48bf4e3$export$17ab471305a2654c,
    faRaspberryPi: $ef0249c5e48bf4e3$export$910e018904f54b08,
    faJira: $ef0249c5e48bf4e3$export$78c2aea9064d90bd,
    faDocker: $ef0249c5e48bf4e3$export$b29e4ebead927988,
    faScreenpal: $ef0249c5e48bf4e3$export$63c4c3c3c5975c3e,
    faBluetooth: $ef0249c5e48bf4e3$export$f77d9ddfdff1e2a7,
    faGitter: $ef0249c5e48bf4e3$export$56aff378d7858517,
    faDAndD: $ef0249c5e48bf4e3$export$8fb5b89b3d7583de,
    faMicroblog: $ef0249c5e48bf4e3$export$d5808a1a9747be4c,
    faCcDinersClub: $ef0249c5e48bf4e3$export$e24e559a44f492e1,
    faGgCircle: $ef0249c5e48bf4e3$export$6d2eed3a88c7ed1a,
    faPiedPiperHat: $ef0249c5e48bf4e3$export$238a02799aabf743,
    faKickstarterK: $ef0249c5e48bf4e3$export$36ebae5de28f5e9e,
    faYandex: $ef0249c5e48bf4e3$export$d51f17330f9046ea,
    faReadme: $ef0249c5e48bf4e3$export$7dcb0372cc290c0e,
    faHtml5: $ef0249c5e48bf4e3$export$d1a4948b9a07ae7c,
    faSellsy: $ef0249c5e48bf4e3$export$cb60511a0f837c82,
    faSass: $ef0249c5e48bf4e3$export$5afc94dc87b38719,
    faWirsindhandwerk: $ef0249c5e48bf4e3$export$304e26e1efc5b1a4,
    faWsh: $ef0249c5e48bf4e3$export$c6d19319c89c1ce4,
    faBuromobelexperte: $ef0249c5e48bf4e3$export$25d99c8ee7e610e5,
    faSalesforce: $ef0249c5e48bf4e3$export$fb5e089c1f25c80c,
    faOctopusDeploy: $ef0249c5e48bf4e3$export$4a726382b32e57cc,
    faMedapps: $ef0249c5e48bf4e3$export$86efffc3e85d2a9,
    faNs8: $ef0249c5e48bf4e3$export$ffa3f5d32fe6bc0e,
    faPinterestP: $ef0249c5e48bf4e3$export$e1681fe8211dd475,
    faApper: $ef0249c5e48bf4e3$export$aa79881dfcf87a16,
    faFortAwesome: $ef0249c5e48bf4e3$export$c2ee281dce8eb9d5,
    faWaze: $ef0249c5e48bf4e3$export$8d560f87da34bcc1,
    faCcJcb: $ef0249c5e48bf4e3$export$4f0eff72b7493340,
    faSnapchat: $ef0249c5e48bf4e3$export$3770724b51125ef1,
    faSnapchatGhost: $ef0249c5e48bf4e3$export$e6e855f745e10958,
    faFantasyFlightGames: $ef0249c5e48bf4e3$export$318074701514e1,
    faRust: $ef0249c5e48bf4e3$export$8a8ef141dcbeda7b,
    faWix: $ef0249c5e48bf4e3$export$423f2efa0d73b5f9,
    faSquareBehance: $ef0249c5e48bf4e3$export$3a09eb8c07c8379f,
    faBehanceSquare: $ef0249c5e48bf4e3$export$bb4b7fb598656746,
    faSupple: $ef0249c5e48bf4e3$export$9be373796460fb80,
    faWebflow: $ef0249c5e48bf4e3$export$b4c5293ffb331d6a,
    faRebel: $ef0249c5e48bf4e3$export$50bb8725ea3b3e34,
    faCss3: $ef0249c5e48bf4e3$export$f32e22910f9b44,
    faStaylinked: $ef0249c5e48bf4e3$export$ffbc7f79ed77f082,
    faKaggle: $ef0249c5e48bf4e3$export$a03842279a704aae,
    faSpaceAwesome: $ef0249c5e48bf4e3$export$1aecd37105f38798,
    faDeviantart: $ef0249c5e48bf4e3$export$36a61c57a904744e,
    faCpanel: $ef0249c5e48bf4e3$export$4b1cbad29e4915c6,
    faGoodreadsG: $ef0249c5e48bf4e3$export$659cd0fc2157d001,
    faSquareGit: $ef0249c5e48bf4e3$export$ccce513bbd3bef1d,
    faGitSquare: $ef0249c5e48bf4e3$export$545247d36a0c2435,
    faSquareTumblr: $ef0249c5e48bf4e3$export$b22e93e631701aa0,
    faTumblrSquare: $ef0249c5e48bf4e3$export$b3979340ece626fe,
    faTrello: $ef0249c5e48bf4e3$export$33a1efa865dd0849,
    faCreativeCommonsNcJp: $ef0249c5e48bf4e3$export$e119d42c61b568e2,
    faGetPocket: $ef0249c5e48bf4e3$export$17e9384897437d5a,
    faPerbyte: $ef0249c5e48bf4e3$export$53e7f606db333d60,
    faGrunt: $ef0249c5e48bf4e3$export$b84863db58925c09,
    faWeebly: $ef0249c5e48bf4e3$export$33e64266c9adb232,
    faConnectdevelop: $ef0249c5e48bf4e3$export$38091cf7f8c68318,
    faLeanpub: $ef0249c5e48bf4e3$export$c6c358b395e9032d,
    faBlackTie: $ef0249c5e48bf4e3$export$161a3454c1d6abdb,
    faThemeco: $ef0249c5e48bf4e3$export$ec9cce37001091c7,
    faPython: $ef0249c5e48bf4e3$export$15d5df18b87754e3,
    faAndroid: $ef0249c5e48bf4e3$export$d3988148e7ca3c41,
    faBots: $ef0249c5e48bf4e3$export$d367d9d00bf47408,
    faFreeCodeCamp: $ef0249c5e48bf4e3$export$8190ad5ab3a607e2,
    faHornbill: $ef0249c5e48bf4e3$export$906602f6a1e50bdd,
    faJs: $ef0249c5e48bf4e3$export$530d32089c3347d5,
    faIdeal: $ef0249c5e48bf4e3$export$4ee0aea9bb537f01,
    faGit: $ef0249c5e48bf4e3$export$61f81190d1a8b4b,
    faDev: $ef0249c5e48bf4e3$export$dad56877d4f4a953,
    faSketch: $ef0249c5e48bf4e3$export$e999ee7aa7883e37,
    faYandexInternational: $ef0249c5e48bf4e3$export$6bf616a61d0b7bf3,
    faCcAmex: $ef0249c5e48bf4e3$export$2bcb24672b4bf6e6,
    faUber: $ef0249c5e48bf4e3$export$2b557426f8d6820b,
    faGithub: $ef0249c5e48bf4e3$export$64e4bc4b496fbbdf,
    faPhp: $ef0249c5e48bf4e3$export$e1ae2a8de48825fb,
    faAlipay: $ef0249c5e48bf4e3$export$994c329bc073af57,
    faYoutube: $ef0249c5e48bf4e3$export$2373b132177332f8,
    faSkyatlas: $ef0249c5e48bf4e3$export$b2254aecfa43ac3e,
    faFirefoxBrowser: $ef0249c5e48bf4e3$export$db16178b6453c842,
    faReplyd: $ef0249c5e48bf4e3$export$a51c205a2c2f1780,
    faSuse: $ef0249c5e48bf4e3$export$fd2c25240484ff41,
    faJenkins: $ef0249c5e48bf4e3$export$595f8e07121dc03e,
    faTwitter: $ef0249c5e48bf4e3$export$ca61170983a00686,
    faRockrms: $ef0249c5e48bf4e3$export$b86b24e51d58f6b5,
    faPinterest: $ef0249c5e48bf4e3$export$d42c613d35559431,
    faBuffer: $ef0249c5e48bf4e3$export$de04abdf8e0bcc15,
    faNpm: $ef0249c5e48bf4e3$export$2002216d2d7747f0,
    faYammer: $ef0249c5e48bf4e3$export$a5122f6c6ec2779c,
    faBtc: $ef0249c5e48bf4e3$export$fcf54005da871608,
    faDribbble: $ef0249c5e48bf4e3$export$657a51e82ea8ac80,
    faStumbleuponCircle: $ef0249c5e48bf4e3$export$ef143c65b9462290,
    faInternetExplorer: $ef0249c5e48bf4e3$export$26bd7ea5833d2643,
    faStubber: $ef0249c5e48bf4e3$export$28d0d3c268c6e8c2,
    faTelegram: $ef0249c5e48bf4e3$export$b508fd54409de914,
    faTelegramPlane: $ef0249c5e48bf4e3$export$dd32dc1ad06228ec,
    faOldRepublic: $ef0249c5e48bf4e3$export$39ef7a19d18012df,
    faOdysee: $ef0249c5e48bf4e3$export$4001fe5db20c0fd2,
    faSquareWhatsapp: $ef0249c5e48bf4e3$export$ee0c07b824da892f,
    faWhatsappSquare: $ef0249c5e48bf4e3$export$6fd1d044d66a938d,
    faNodeJs: $ef0249c5e48bf4e3$export$ad65a356f9456393,
    faEdgeLegacy: $ef0249c5e48bf4e3$export$68bace18bdcdfc53,
    faSlack: $ef0249c5e48bf4e3$export$c597531345e00f14,
    faSlackHash: $ef0249c5e48bf4e3$export$46ef626e3b64d22,
    faMedrt: $ef0249c5e48bf4e3$export$2d7cd04bce6afc11,
    faUsb: $ef0249c5e48bf4e3$export$701b05aa394c8392,
    faTumblr: $ef0249c5e48bf4e3$export$ae279e8a7a5b9476,
    faVaadin: $ef0249c5e48bf4e3$export$f796d2c05c7c6dbd,
    faQuora: $ef0249c5e48bf4e3$export$e9b10b4b8b90dca5,
    faSquareXTwitter: $ef0249c5e48bf4e3$export$e42e88e46d22eb98,
    faReacteurope: $ef0249c5e48bf4e3$export$1bc30ca2ce539d7f,
    faMedium: $ef0249c5e48bf4e3$export$c1f031b95dadaa21,
    faMediumM: $ef0249c5e48bf4e3$export$a29b11db7eed2052,
    faAmilia: $ef0249c5e48bf4e3$export$2ffb27c42275836a,
    faMixcloud: $ef0249c5e48bf4e3$export$642f133169ca9ebe,
    faFlipboard: $ef0249c5e48bf4e3$export$5193bd9feb923609,
    faViacoin: $ef0249c5e48bf4e3$export$e75485903cf50ab7,
    faCriticalRole: $ef0249c5e48bf4e3$export$19d8e57a729f8d94,
    faSitrox: $ef0249c5e48bf4e3$export$b431c4dc6e2095fc,
    faDiscourse: $ef0249c5e48bf4e3$export$5311546a7fb29bad,
    faJoomla: $ef0249c5e48bf4e3$export$4c7981055454786f,
    faMastodon: $ef0249c5e48bf4e3$export$1dd6c03244d1cf01,
    faAirbnb: $ef0249c5e48bf4e3$export$a8bcb0976aa786fb,
    faWolfPackBattalion: $ef0249c5e48bf4e3$export$568095dca08f5ff3,
    faBuyNLarge: $ef0249c5e48bf4e3$export$e08e0c43c651f28e,
    faGulp: $ef0249c5e48bf4e3$export$100b84dda223030b,
    faCreativeCommonsSamplingPlus: $ef0249c5e48bf4e3$export$f7edf083e5c27672,
    faStrava: $ef0249c5e48bf4e3$export$7ea49f2cb08b52c1,
    faEmber: $ef0249c5e48bf4e3$export$c09ea58a6f21cb3c,
    faCanadianMapleLeaf: $ef0249c5e48bf4e3$export$c9a287a4ab49306f,
    faTeamspeak: $ef0249c5e48bf4e3$export$619d787387e2c15e,
    faPushed: $ef0249c5e48bf4e3$export$72c88c198f2680b,
    faWordpressSimple: $ef0249c5e48bf4e3$export$1e35be7b9c7acc1f,
    faNutritionix: $ef0249c5e48bf4e3$export$cb3944b58accd310,
    faWodu: $ef0249c5e48bf4e3$export$d30ca94800bf542b,
    faGooglePay: $ef0249c5e48bf4e3$export$6d89c09f17c54b19,
    faIntercom: $ef0249c5e48bf4e3$export$fd8d76c5b86b3d2b,
    faZhihu: $ef0249c5e48bf4e3$export$16e69e0d77404518,
    faKorvue: $ef0249c5e48bf4e3$export$80de216c9d46bac,
    faPix: $ef0249c5e48bf4e3$export$4fe14f0ab3be9a3,
    faSteamSymbol: $ef0249c5e48bf4e3$export$c2ce1e5693cbcd01
};


var $c9bfa4e2da6232f7$exports = {};

$parcel$export($c9bfa4e2da6232f7$exports, "Menu", () => $c9bfa4e2da6232f7$export$d9b273488cd8ce6f);

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
function $aba927e9b3929756$export$a5ff0d6a738703ca(e) {
    typeof queueMicrotask == "function" ? queueMicrotask(e) : Promise.resolve().then(e).catch((o)=>setTimeout(()=>{
            throw o;
        }));
}


function $12f0e1633d904536$export$12b26c28a05aa001() {
    let n = [], r = {
        addEventListener (e, t, s, a) {
            return e.addEventListener(t, s, a), r.add(()=>e.removeEventListener(t, s, a));
        },
        requestAnimationFrame (...e) {
            let t = requestAnimationFrame(...e);
            return r.add(()=>cancelAnimationFrame(t));
        },
        nextFrame (...e) {
            return r.requestAnimationFrame(()=>r.requestAnimationFrame(...e));
        },
        setTimeout (...e) {
            let t = setTimeout(...e);
            return r.add(()=>clearTimeout(t));
        },
        microTask (...e) {
            let t = {
                current: !0
            };
            return (0, $aba927e9b3929756$export$a5ff0d6a738703ca)(()=>{
                t.current && e[0]();
            }), r.add(()=>{
                t.current = !1;
            });
        },
        style (e, t, s) {
            let a = e.style.getPropertyValue(t);
            return Object.assign(e.style, {
                [t]: s
            }), this.add(()=>{
                Object.assign(e.style, {
                    [t]: a
                });
            });
        },
        group (e) {
            let t = $12f0e1633d904536$export$12b26c28a05aa001();
            return e(t), this.add(()=>t.dispose());
        },
        add (e) {
            return n.push(e), ()=>{
                let t = n.indexOf(e);
                if (t >= 0) for (let s of n.splice(t, 1))s();
            };
        },
        dispose () {
            for (let e of n.splice(0))e();
        }
    };
    return r;
}


function $410e668b7f520622$export$fd183955ff4b45d9() {
    let [e] = (0, $acw62.useState)((0, $12f0e1633d904536$export$12b26c28a05aa001));
    return (0, $acw62.useEffect)(()=>()=>e.dispose(), [
        e
    ]), e;
}



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
var $085e96034c813fbf$var$i = Object.defineProperty;
var $085e96034c813fbf$var$d = (t, e, n)=>e in t ? $085e96034c813fbf$var$i(t, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: n
    }) : t[e] = n;
var $085e96034c813fbf$var$r = (t, e, n)=>($085e96034c813fbf$var$d(t, typeof e != "symbol" ? e + "" : e, n), n);
class $085e96034c813fbf$var$o {
    constructor(){
        $085e96034c813fbf$var$r(this, "current", this.detect());
        $085e96034c813fbf$var$r(this, "handoffState", "pending");
        $085e96034c813fbf$var$r(this, "currentId", 0);
    }
    set(e) {
        this.current !== e && (this.handoffState = "pending", this.currentId = 0, this.current = e);
    }
    reset() {
        this.set(this.detect());
    }
    nextId() {
        return ++this.currentId;
    }
    get isServer() {
        return this.current === "server";
    }
    get isClient() {
        return this.current === "client";
    }
    detect() {
        return typeof window == "undefined" || typeof document == "undefined" ? "server" : "client";
    }
    handoff() {
        this.handoffState === "pending" && (this.handoffState = "complete");
    }
    get isHandoffComplete() {
        return this.handoffState === "complete";
    }
}
let $085e96034c813fbf$export$a7b6bc01c63cdfc3 = new $085e96034c813fbf$var$o;


let $65df95ec9b1bb6a8$export$ce5ed857c741fd71 = (e, f)=>{
    (0, $085e96034c813fbf$export$a7b6bc01c63cdfc3).isServer ? (0, $acw62.useEffect)(e, f) : (0, $acw62.useLayoutEffect)(e, f);
};


function $fa1923261638cacc$export$86c4283a11f23f95(e) {
    let r = (0, $acw62.useRef)(e);
    return (0, $65df95ec9b1bb6a8$export$ce5ed857c741fd71)(()=>{
        r.current = e;
    }, [
        e
    ]), r;
}


let $0bd9972698c32399$export$90fc3a17d93f704c = function(t) {
    let e = (0, $fa1923261638cacc$export$86c4283a11f23f95)(t);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((...r)=>e.current(...r), [
        e
    ]);
};



var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");

function $81b1abbf8717f9cc$var$s() {
    let r = typeof document == "undefined";
    return "useSyncExternalStore" in $acw62 ? ((o)=>o.useSyncExternalStore)($acw62)(()=>()=>{}, ()=>!1, ()=>!r) : !1;
}
function $81b1abbf8717f9cc$export$44ab2b9f2d09b0fa() {
    let r = $81b1abbf8717f9cc$var$s(), [e, n] = $acw62.useState((0, $085e96034c813fbf$export$a7b6bc01c63cdfc3).isHandoffComplete);
    return e && (0, $085e96034c813fbf$export$a7b6bc01c63cdfc3).isHandoffComplete === !1 && n(!1), $acw62.useEffect(()=>{
        e !== !0 && n(!0);
    }, [
        e
    ]), $acw62.useEffect(()=>(0, $085e96034c813fbf$export$a7b6bc01c63cdfc3).handoff(), []), r ? !1 : e;
}


var $f2a0dea4caee12c6$var$o;
let $f2a0dea4caee12c6$export$f680877a34711e37 = ($f2a0dea4caee12c6$var$o = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useId) != null ? $f2a0dea4caee12c6$var$o : function() {
    let n = (0, $81b1abbf8717f9cc$export$44ab2b9f2d09b0fa)(), [e, u] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(n ? ()=>(0, $085e96034c813fbf$export$a7b6bc01c63cdfc3).nextId() : null);
    return (0, $65df95ec9b1bb6a8$export$ce5ed857c741fd71)(()=>{
        e === null && u((0, $085e96034c813fbf$export$a7b6bc01c63cdfc3).nextId());
    }, [
        e
    ]), e != null ? "" + e : void 0;
};




var $acw62 = parcelRequire("acw62");

function $4f240e1aafd2c298$export$4659b591c19bdf3d(r, n, ...a) {
    if (r in n) {
        let e = n[r];
        return typeof e == "function" ? e(...a) : e;
    }
    let t = new Error(`Tried to handle "${r}" but there is no handler defined. Only defined handlers are: ${Object.keys(n).map((e)=>`"${e}"`).join(", ")}.`);
    throw Error.captureStackTrace && Error.captureStackTrace(t, $4f240e1aafd2c298$export$4659b591c19bdf3d), t;
}



function $c0a913ecfa4bf5e5$export$b204af158042fbac(r) {
    return (0, $085e96034c813fbf$export$a7b6bc01c63cdfc3).isServer ? null : r instanceof Node ? r.ownerDocument : r != null && r.hasOwnProperty("current") && r.current instanceof Node ? r.current.ownerDocument : document;
}


let $cb6dceb64e6c0606$var$c = [
    "[contentEditable=true]",
    "[tabindex]",
    "a[href]",
    "area[href]",
    "button:not([disabled])",
    "iframe",
    "input:not([disabled])",
    "select:not([disabled])",
    "textarea:not([disabled])"
].map((e)=>`${e}:not([tabindex='-1'])`).join(",");
var $cb6dceb64e6c0606$export$807a7eae502106e7 = ((n)=>(n[n.First = 1] = "First", n[n.Previous = 2] = "Previous", n[n.Next = 4] = "Next", n[n.Last = 8] = "Last", n[n.WrapAround = 16] = "WrapAround", n[n.NoScroll = 32] = "NoScroll", n))($cb6dceb64e6c0606$export$807a7eae502106e7 || {}), $cb6dceb64e6c0606$export$abf286375dfa6dbd = ((o)=>(o[o.Error = 0] = "Error", o[o.Overflow = 1] = "Overflow", o[o.Success = 2] = "Success", o[o.Underflow = 3] = "Underflow", o))($cb6dceb64e6c0606$export$abf286375dfa6dbd || {}), $cb6dceb64e6c0606$var$F = ((t)=>(t[t.Previous = -1] = "Previous", t[t.Next = 1] = "Next", t))($cb6dceb64e6c0606$var$F || {});
function $cb6dceb64e6c0606$export$433aaa1f216cf32d(e = document.body) {
    return e == null ? [] : Array.from(e.querySelectorAll($cb6dceb64e6c0606$var$c)).sort((r, t)=>Math.sign((r.tabIndex || Number.MAX_SAFE_INTEGER) - (t.tabIndex || Number.MAX_SAFE_INTEGER)));
}
var $cb6dceb64e6c0606$export$27112a34f2f8402d = ((t)=>(t[t.Strict = 0] = "Strict", t[t.Loose = 1] = "Loose", t))($cb6dceb64e6c0606$export$27112a34f2f8402d || {});
function $cb6dceb64e6c0606$export$ff1ec1c740b3c8d5(e, r = 0) {
    var t;
    return e === ((t = (0, $c0a913ecfa4bf5e5$export$b204af158042fbac)(e)) == null ? void 0 : t.body) ? !1 : (0, $4f240e1aafd2c298$export$4659b591c19bdf3d)(r, {
        [0] () {
            return e.matches($cb6dceb64e6c0606$var$c);
        },
        [1] () {
            let l = e;
            for(; l !== null;){
                if (l.matches($cb6dceb64e6c0606$var$c)) return !0;
                l = l.parentElement;
            }
            return !1;
        }
    });
}
function $cb6dceb64e6c0606$export$46388676ec35ab85(e) {
    let r = (0, $c0a913ecfa4bf5e5$export$b204af158042fbac)(e);
    (0, $12f0e1633d904536$export$12b26c28a05aa001)().nextFrame(()=>{
        r && !$cb6dceb64e6c0606$export$ff1ec1c740b3c8d5(r.activeElement, 0) && $cb6dceb64e6c0606$export$5fed9cc43865dc7e(e);
    });
}
var $cb6dceb64e6c0606$var$w = ((t)=>(t[t.Keyboard = 0] = "Keyboard", t[t.Mouse = 1] = "Mouse", t))($cb6dceb64e6c0606$var$w || {});
typeof window != "undefined" && typeof document != "undefined" && (document.addEventListener("keydown", (e)=>{
    e.metaKey || e.altKey || e.ctrlKey || (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0), document.addEventListener("click", (e)=>{
    e.detail === 1 ? delete document.documentElement.dataset.headlessuiFocusVisible : e.detail === 0 && (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0));
function $cb6dceb64e6c0606$export$5fed9cc43865dc7e(e) {
    e == null || e.focus({
        preventScroll: !0
    });
}
let $cb6dceb64e6c0606$var$S = [
    "textarea",
    "input"
].join(",");
function $cb6dceb64e6c0606$var$H(e) {
    var r, t;
    return (t = (r = e == null ? void 0 : e.matches) == null ? void 0 : r.call(e, $cb6dceb64e6c0606$var$S)) != null ? t : !1;
}
function $cb6dceb64e6c0606$export$20305e96f91bf103(e, r = (t)=>t) {
    return e.slice().sort((t, l)=>{
        let o = r(t), i = r(l);
        if (o === null || i === null) return 0;
        let n = o.compareDocumentPosition(i);
        return n & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : n & Node.DOCUMENT_POSITION_PRECEDING ? 1 : 0;
    });
}
function $cb6dceb64e6c0606$export$7fb6c844b485e870(e, r) {
    return $cb6dceb64e6c0606$export$82e1f4f412218a1d($cb6dceb64e6c0606$export$433aaa1f216cf32d(), r, {
        relativeTo: e
    });
}
function $cb6dceb64e6c0606$export$82e1f4f412218a1d(e, r, { sorted: t = !0, relativeTo: l = null, skipElements: o = [] } = {}) {
    let i = Array.isArray(e) ? e.length > 0 ? e[0].ownerDocument : document : e.ownerDocument, n = Array.isArray(e) ? t ? $cb6dceb64e6c0606$export$20305e96f91bf103(e) : e : $cb6dceb64e6c0606$export$433aaa1f216cf32d(e);
    o.length > 0 && n.length > 1 && (n = n.filter((s)=>!o.includes(s))), l = l != null ? l : i.activeElement;
    let E = (()=>{
        if (r & 5) return 1;
        if (r & 10) return -1;
        throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
    })(), x = (()=>{
        if (r & 1) return 0;
        if (r & 2) return Math.max(0, n.indexOf(l)) - 1;
        if (r & 4) return Math.max(0, n.indexOf(l)) + 1;
        if (r & 8) return n.length - 1;
        throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
    })(), p = r & 32 ? {
        preventScroll: !0
    } : {}, d = 0, a = n.length, u;
    do {
        if (d >= a || d + a <= 0) return 0;
        let s = x + d;
        if (r & 16) s = (s + a) % a;
        else {
            if (s < 0) return 3;
            if (s >= a) return 1;
        }
        u = n[s], u == null || u.focus(p), d += E;
    }while (u !== i.activeElement);
    return r & 6 && $cb6dceb64e6c0606$var$H(u) && u.select(), 2;
}


function $67c26d51fee0b51a$export$fedb369cb70207f1() {
    return /iPhone/gi.test(window.navigator.platform) || /Mac/gi.test(window.navigator.platform) && window.navigator.maxTouchPoints > 0;
}
function $67c26d51fee0b51a$export$a11b0059900ceec8() {
    return /Android/gi.test(window.navigator.userAgent);
}
function $67c26d51fee0b51a$export$d0a8044dce8ff2fc() {
    return $67c26d51fee0b51a$export$fedb369cb70207f1() || $67c26d51fee0b51a$export$a11b0059900ceec8();
}



var $acw62 = parcelRequire("acw62");

function $b57d0f015e93db3a$export$55d2b5df396a097b(e, r, n) {
    let o = (0, $fa1923261638cacc$export$86c4283a11f23f95)(r);
    (0, $acw62.useEffect)(()=>{
        function t(u) {
            o.current(u);
        }
        return document.addEventListener(e, t, n), ()=>document.removeEventListener(e, t, n);
    }, [
        e,
        n
    ]);
}



var $acw62 = parcelRequire("acw62");

function $40320926a37dc1cc$export$ee579bb285b8d4aa(e, r, n) {
    let o = (0, $fa1923261638cacc$export$86c4283a11f23f95)(r);
    (0, $acw62.useEffect)(()=>{
        function t(i) {
            o.current(i);
        }
        return window.addEventListener(e, t, n), ()=>window.removeEventListener(e, t, n);
    }, [
        e,
        n
    ]);
}


function $17eff26b89e4b024$export$71b2224f1ce5e08e(s, m, a = !0) {
    let i = (0, $acw62.useRef)(!1);
    (0, $acw62.useEffect)(()=>{
        requestAnimationFrame(()=>{
            i.current = a;
        });
    }, [
        a
    ]);
    function c(e, r) {
        if (!i.current || e.defaultPrevented) return;
        let t = r(e);
        if (t === null || !t.getRootNode().contains(t) || !t.isConnected) return;
        let E = function u(n) {
            return typeof n == "function" ? u(n()) : Array.isArray(n) || n instanceof Set ? n : [
                n
            ];
        }(s);
        for (let u of E){
            if (u === null) continue;
            let n = u instanceof HTMLElement ? u : u.current;
            if (n != null && n.contains(t) || e.composed && e.composedPath().includes(n)) return;
        }
        return !(0, $cb6dceb64e6c0606$export$ff1ec1c740b3c8d5)(t, (0, $cb6dceb64e6c0606$export$27112a34f2f8402d).Loose) && t.tabIndex !== -1 && e.preventDefault(), m(e, t);
    }
    let o = (0, $acw62.useRef)(null);
    (0, $b57d0f015e93db3a$export$55d2b5df396a097b)("pointerdown", (e)=>{
        var r, t;
        i.current && (o.current = ((t = (r = e.composedPath) == null ? void 0 : r.call(e)) == null ? void 0 : t[0]) || e.target);
    }, !0), (0, $b57d0f015e93db3a$export$55d2b5df396a097b)("mousedown", (e)=>{
        var r, t;
        i.current && (o.current = ((t = (r = e.composedPath) == null ? void 0 : r.call(e)) == null ? void 0 : t[0]) || e.target);
    }, !0), (0, $b57d0f015e93db3a$export$55d2b5df396a097b)("click", (e)=>{
        (0, $67c26d51fee0b51a$export$d0a8044dce8ff2fc)() || o.current && (c(e, ()=>o.current), o.current = null);
    }, !0), (0, $b57d0f015e93db3a$export$55d2b5df396a097b)("touchend", (e)=>c(e, ()=>e.target instanceof HTMLElement ? e.target : null), !0), (0, $40320926a37dc1cc$export$ee579bb285b8d4aa)("blur", (e)=>c(e, ()=>window.document.activeElement instanceof HTMLIFrameElement ? window.document.activeElement : null), !0);
}



var $acw62 = parcelRequire("acw62");

function $42a08b28a285ca8e$export$dd9fbcea3de0ae36(...e) {
    return (0, $acw62.useMemo)(()=>(0, $c0a913ecfa4bf5e5$export$b204af158042fbac)(...e), [
        ...e
    ]);
}



var $acw62 = parcelRequire("acw62");

function $be828d8bf9bb25ca$var$i(t) {
    var n;
    if (t.type) return t.type;
    let e = (n = t.as) != null ? n : "button";
    if (typeof e == "string" && e.toLowerCase() === "button") return "button";
}
function $be828d8bf9bb25ca$export$53652b2b272efe9c(t, e) {
    let [n, u] = (0, $acw62.useState)(()=>$be828d8bf9bb25ca$var$i(t));
    return (0, $65df95ec9b1bb6a8$export$ce5ed857c741fd71)(()=>{
        u($be828d8bf9bb25ca$var$i(t));
    }, [
        t.type,
        t.as
    ]), (0, $65df95ec9b1bb6a8$export$ce5ed857c741fd71)(()=>{
        n || e.current && e.current instanceof HTMLButtonElement && !e.current.hasAttribute("type") && u("button");
    }, [
        n,
        e
    ]), n;
}



var $acw62 = parcelRequire("acw62");

let $4a1854c6a3ad5196$var$u = Symbol();
function $4a1854c6a3ad5196$export$7029785b750eb74(t, n = !0) {
    return Object.assign(t, {
        [$4a1854c6a3ad5196$var$u]: n
    });
}
function $4a1854c6a3ad5196$export$f6a25a78204acc7e(...t) {
    let n = (0, $acw62.useRef)(t);
    (0, $acw62.useEffect)(()=>{
        n.current = t;
    }, [
        t
    ]);
    let c = (0, $0bd9972698c32399$export$90fc3a17d93f704c)((e)=>{
        for (let o of n.current)o != null && (typeof o == "function" ? o(e) : o.current = e);
    });
    return t.every((e)=>e == null || (e == null ? void 0 : e[$4a1854c6a3ad5196$var$u])) ? void 0 : c;
}



var $acw62 = parcelRequire("acw62");
let $9e36c641751eb2c7$var$a = /([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g;
function $9e36c641751eb2c7$var$o(e) {
    var r, i;
    let n = (r = e.innerText) != null ? r : "", t = e.cloneNode(!0);
    if (!(t instanceof HTMLElement)) return n;
    let u = !1;
    for (let f of t.querySelectorAll('[hidden],[aria-hidden],[role="img"]'))f.remove(), u = !0;
    let l = u ? (i = t.innerText) != null ? i : "" : n;
    return $9e36c641751eb2c7$var$a.test(l) && (l = l.replace($9e36c641751eb2c7$var$a, "")), l;
}
function $9e36c641751eb2c7$export$6ca03cb7b75bfa13(e) {
    let n = e.getAttribute("aria-label");
    if (typeof n == "string") return n.trim();
    let t = e.getAttribute("aria-labelledby");
    if (t) {
        let u = t.split(" ").map((l)=>{
            let r = document.getElementById(l);
            if (r) {
                let i = r.getAttribute("aria-label");
                return typeof i == "string" ? i.trim() : $9e36c641751eb2c7$var$o(r).trim();
            }
            return null;
        }).filter(Boolean);
        if (u.length > 0) return u.join(", ");
    }
    return $9e36c641751eb2c7$var$o(e).trim();
}



function $e688621b6eb177ca$export$f6862afd851a1cf4(c) {
    let t = (0, $acw62.useRef)(""), r = (0, $acw62.useRef)("");
    return (0, $0bd9972698c32399$export$90fc3a17d93f704c)(()=>{
        let e = c.current;
        if (!e) return "";
        let u = e.innerText;
        if (t.current === u) return r.current;
        let n = (0, $9e36c641751eb2c7$export$6ca03cb7b75bfa13)(e).trim().toLowerCase();
        return t.current = u, r.current = n, n;
    });
}



var $acw62 = parcelRequire("acw62");
function $d668e4b1d0c2f85c$var$t(e) {
    return [
        e.screenX,
        e.screenY
    ];
}
function $d668e4b1d0c2f85c$export$24ebee078bde85c3() {
    let e = (0, $acw62.useRef)([
        -1,
        -1
    ]);
    return {
        wasMoved (r) {
            let n = $d668e4b1d0c2f85c$var$t(r);
            return e.current[0] === n[0] && e.current[1] === n[1] ? !1 : (e.current = n, !0);
        },
        update (r) {
            e.current = $d668e4b1d0c2f85c$var$t(r);
        }
    };
}



var $acw62 = parcelRequire("acw62");


function $101ef4628501ab0d$export$b0abce39eb34b36({ container: e, accept: t, walk: r, enabled: c = !0 }) {
    let o = (0, $acw62.useRef)(t), l = (0, $acw62.useRef)(r);
    (0, $acw62.useEffect)(()=>{
        o.current = t, l.current = r;
    }, [
        t,
        r
    ]), (0, $65df95ec9b1bb6a8$export$ce5ed857c741fd71)(()=>{
        if (!e || !c) return;
        let n = (0, $c0a913ecfa4bf5e5$export$b204af158042fbac)(e);
        if (!n) return;
        let f = o.current, p = l.current, d = Object.assign((i)=>f(i), {
            acceptNode: f
        }), u = n.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, d, !1);
        for(; u.nextNode();)p(u.currentNode);
    }, [
        e,
        c,
        o,
        l
    ]);
}



var $acw62 = parcelRequire("acw62");
let $7a3499b4b3c6f184$var$n = (0, $acw62.createContext)(null);
$7a3499b4b3c6f184$var$n.displayName = "OpenClosedContext";
var $7a3499b4b3c6f184$export$7254cc27399e90bd = ((e)=>(e[e.Open = 1] = "Open", e[e.Closed = 2] = "Closed", e[e.Closing = 4] = "Closing", e[e.Opening = 8] = "Opening", e))($7a3499b4b3c6f184$export$7254cc27399e90bd || {});
function $7a3499b4b3c6f184$export$fc6fdf0ecf360e() {
    return (0, $acw62.useContext)($7a3499b4b3c6f184$var$n);
}
function $7a3499b4b3c6f184$export$2a0ed818b175f558({ value: o, children: r }) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($7a3499b4b3c6f184$var$n.Provider, {
        value: o
    }, r);
}


function $3d3d670dbe2ceed6$export$db61f031a278447c(n) {
    let e = n.parentElement, l = null;
    for(; e && !(e instanceof HTMLFieldSetElement);)e instanceof HTMLLegendElement && (l = e), e = e.parentElement;
    let t = (e == null ? void 0 : e.getAttribute("disabled")) === "";
    return t && $3d3d670dbe2ceed6$var$i(l) ? !1 : t;
}
function $3d3d670dbe2ceed6$var$i(n) {
    if (!n) return !1;
    let e = n.previousElementSibling;
    for(; e !== null;){
        if (e instanceof HTMLLegendElement) return !1;
        e = e.previousElementSibling;
    }
    return !0;
}


function $b7a0b87cd8a0fa3d$var$u(l) {
    throw new Error("Unexpected object: " + l);
}
var $b7a0b87cd8a0fa3d$export$807a7eae502106e7 = ((i)=>(i[i.First = 0] = "First", i[i.Previous = 1] = "Previous", i[i.Next = 2] = "Next", i[i.Last = 3] = "Last", i[i.Specific = 4] = "Specific", i[i.Nothing = 5] = "Nothing", i))($b7a0b87cd8a0fa3d$export$807a7eae502106e7 || {});
function $b7a0b87cd8a0fa3d$export$c6b4626b54936d5e(l, n) {
    let t = n.resolveItems();
    if (t.length <= 0) return null;
    let r = n.resolveActiveIndex(), s = r != null ? r : -1;
    switch(l.focus){
        case 0:
            for(let e = 0; e < t.length; ++e)if (!n.resolveDisabled(t[e], e, t)) return e;
            return r;
        case 1:
            for(let e = s - 1; e >= 0; --e)if (!n.resolveDisabled(t[e], e, t)) return e;
            return r;
        case 2:
            for(let e = s + 1; e < t.length; ++e)if (!n.resolveDisabled(t[e], e, t)) return e;
            return r;
        case 3:
            for(let e = t.length - 1; e >= 0; --e)if (!n.resolveDisabled(t[e], e, t)) return e;
            return r;
        case 4:
            for(let e = 0; e < t.length; ++e)if (n.resolveId(t[e], e, t) === l.id) return e;
            return r;
        case 5:
            return null;
        default:
            $b7a0b87cd8a0fa3d$var$u(l);
    }
}






var $acw62 = parcelRequire("acw62");
function $37ab6efe1f53a2e0$export$ce4ab0c55987d1ff(...r) {
    return Array.from(new Set(r.flatMap((n)=>typeof n == "string" ? n.split(" ") : []))).filter(Boolean).join(" ");
}



var $a54bdd13402af126$export$617d79dae526d2cf = ((n)=>(n[n.None = 0] = "None", n[n.RenderStrategy = 1] = "RenderStrategy", n[n.Static = 2] = "Static", n))($a54bdd13402af126$export$617d79dae526d2cf || {}), $a54bdd13402af126$export$80c0a745e59f7989 = ((e)=>(e[e.Unmount = 0] = "Unmount", e[e.Hidden = 1] = "Hidden", e))($a54bdd13402af126$export$80c0a745e59f7989 || {});
function $a54bdd13402af126$export$b3890eb0ae9dca99({ ourProps: r, theirProps: t, slot: e, defaultTag: n, features: o, visible: a = !0, name: f, mergeRefs: l }) {
    l = l != null ? l : $a54bdd13402af126$var$k;
    let s = $a54bdd13402af126$var$R(t, r);
    if (a) return $a54bdd13402af126$var$m(s, e, n, f, l);
    let y = o != null ? o : 0;
    if (y & 2) {
        let { static: u = !1, ...d } = s;
        if (u) return $a54bdd13402af126$var$m(d, e, n, f, l);
    }
    if (y & 1) {
        let { unmount: u = !0, ...d } = s;
        return (0, $4f240e1aafd2c298$export$4659b591c19bdf3d)(u ? 0 : 1, {
            [0] () {
                return null;
            },
            [1] () {
                return $a54bdd13402af126$var$m({
                    ...d,
                    hidden: !0,
                    style: {
                        display: "none"
                    }
                }, e, n, f, l);
            }
        });
    }
    return $a54bdd13402af126$var$m(s, e, n, f, l);
}
function $a54bdd13402af126$var$m(r, t = {}, e, n, o) {
    let { as: a = e, children: f, refName: l = "ref", ...s } = $a54bdd13402af126$var$F(r, [
        "unmount",
        "static"
    ]), y = r.ref !== void 0 ? {
        [l]: r.ref
    } : {}, u = typeof f == "function" ? f(t) : f;
    "className" in s && s.className && typeof s.className == "function" && (s.className = s.className(t));
    let d = {};
    if (t) {
        let i = !1, c = [];
        for (let [T, p] of Object.entries(t))typeof p == "boolean" && (i = !0), p === !0 && c.push(T);
        i && (d["data-headlessui-state"] = c.join(" "));
    }
    if (a === (0, $acw62.Fragment) && Object.keys($a54bdd13402af126$export$8e16b83750b44988(s)).length > 0) {
        if (!(0, $acw62.isValidElement)(u) || Array.isArray(u) && u.length > 1) throw new Error([
            'Passing props on "Fragment"!',
            "",
            `The current component <${n} /> is rendering a "Fragment".`,
            "However we need to passthrough the following props:",
            Object.keys(s).map((p)=>`  - ${p}`).join(`
`),
            "",
            "You can apply a few solutions:",
            [
                'Add an `as="..."` prop, to ensure that we render an actual element instead of a "Fragment".',
                "Render a single element as the child so that we can forward the props onto that element."
            ].map((p)=>`  - ${p}`).join(`
`)
        ].join(`
`));
        let i = u.props, c = typeof (i == null ? void 0 : i.className) == "function" ? (...p)=>(0, $37ab6efe1f53a2e0$export$ce4ab0c55987d1ff)(i == null ? void 0 : i.className(...p), s.className) : (0, $37ab6efe1f53a2e0$export$ce4ab0c55987d1ff)(i == null ? void 0 : i.className, s.className), T = c ? {
            className: c
        } : {};
        return (0, $acw62.cloneElement)(u, Object.assign({}, $a54bdd13402af126$var$R(u.props, $a54bdd13402af126$export$8e16b83750b44988($a54bdd13402af126$var$F(s, [
            "ref"
        ]))), d, y, {
            ref: o(u.ref, y.ref)
        }, T));
    }
    return (0, $acw62.createElement)(a, Object.assign({}, $a54bdd13402af126$var$F(s, [
        "ref"
    ]), a !== (0, $acw62.Fragment) && y, a !== (0, $acw62.Fragment) && d), u);
}
function $a54bdd13402af126$export$81218df071161f0a() {
    let r = (0, $acw62.useRef)([]), t = (0, $acw62.useCallback)((e)=>{
        for (let n of r.current)n != null && (typeof n == "function" ? n(e) : n.current = e);
    }, []);
    return (...e)=>{
        if (!e.every((n)=>n == null)) return r.current = e, t;
    };
}
function $a54bdd13402af126$var$k(...r) {
    return r.every((t)=>t == null) ? void 0 : (t)=>{
        for (let e of r)e != null && (typeof e == "function" ? e(t) : e.current = t);
    };
}
function $a54bdd13402af126$var$R(...r) {
    var n;
    if (r.length === 0) return {};
    if (r.length === 1) return r[0];
    let t = {}, e = {};
    for (let o of r)for(let a in o)a.startsWith("on") && typeof o[a] == "function" ? ((n = e[a]) != null || (e[a] = []), e[a].push(o[a])) : t[a] = o[a];
    if (t.disabled || t["aria-disabled"]) return Object.assign(t, Object.fromEntries(Object.keys(e).map((o)=>[
            o,
            void 0
        ])));
    for(let o in e)Object.assign(t, {
        [o] (a, ...f) {
            let l = e[o];
            for (let s of l){
                if ((a instanceof Event || (a == null ? void 0 : a.nativeEvent) instanceof Event) && a.defaultPrevented) return;
                s(a, ...f);
            }
        }
    });
    return t;
}
function $a54bdd13402af126$export$e43f39796049410c(r) {
    var t;
    return Object.assign((0, $acw62.forwardRef)(r), {
        displayName: (t = r.displayName) != null ? t : r.name
    });
}
function $a54bdd13402af126$export$8e16b83750b44988(r) {
    let t = Object.assign({}, r);
    for(let e in t)t[e] === void 0 && delete t[e];
    return t;
}
function $a54bdd13402af126$var$F(r, t = []) {
    let e = Object.assign({}, r);
    for (let n of t)n in e && delete e[n];
    return e;
}


var $4cca0dbc68b0507a$export$4b0075e5ea5e1f26 = ((r)=>(r.Space = " ", r.Enter = "Enter", r.Escape = "Escape", r.Backspace = "Backspace", r.Delete = "Delete", r.ArrowLeft = "ArrowLeft", r.ArrowUp = "ArrowUp", r.ArrowRight = "ArrowRight", r.ArrowDown = "ArrowDown", r.Home = "Home", r.End = "End", r.PageUp = "PageUp", r.PageDown = "PageDown", r.Tab = "Tab", r))($4cca0dbc68b0507a$export$4b0075e5ea5e1f26 || {});


var $c9bfa4e2da6232f7$var$me = ((r)=>(r[r.Open = 0] = "Open", r[r.Closed = 1] = "Closed", r))($c9bfa4e2da6232f7$var$me || {}), $c9bfa4e2da6232f7$var$de = ((r)=>(r[r.Pointer = 0] = "Pointer", r[r.Other = 1] = "Other", r))($c9bfa4e2da6232f7$var$de || {}), $c9bfa4e2da6232f7$var$fe = ((a)=>(a[a.OpenMenu = 0] = "OpenMenu", a[a.CloseMenu = 1] = "CloseMenu", a[a.GoToItem = 2] = "GoToItem", a[a.Search = 3] = "Search", a[a.ClearSearch = 4] = "ClearSearch", a[a.RegisterItem = 5] = "RegisterItem", a[a.UnregisterItem = 6] = "UnregisterItem", a))($c9bfa4e2da6232f7$var$fe || {});
function $c9bfa4e2da6232f7$var$w(e, u = (r)=>r) {
    let r = e.activeItemIndex !== null ? e.items[e.activeItemIndex] : null, s = (0, $cb6dceb64e6c0606$export$20305e96f91bf103)(u(e.items.slice()), (t)=>t.dataRef.current.domRef.current), i = r ? s.indexOf(r) : null;
    return i === -1 && (i = null), {
        items: s,
        activeItemIndex: i
    };
}
let $c9bfa4e2da6232f7$var$Te = {
    [1] (e) {
        return e.menuState === 1 ? e : {
            ...e,
            activeItemIndex: null,
            menuState: 1
        };
    },
    [0] (e) {
        return e.menuState === 0 ? e : {
            ...e,
            __demoMode: !1,
            menuState: 0
        };
    },
    [2]: (e, u)=>{
        var i;
        let r = $c9bfa4e2da6232f7$var$w(e), s = (0, $b7a0b87cd8a0fa3d$export$c6b4626b54936d5e)(u, {
            resolveItems: ()=>r.items,
            resolveActiveIndex: ()=>r.activeItemIndex,
            resolveId: (t)=>t.id,
            resolveDisabled: (t)=>t.dataRef.current.disabled
        });
        return {
            ...e,
            ...r,
            searchQuery: "",
            activeItemIndex: s,
            activationTrigger: (i = u.trigger) != null ? i : 1
        };
    },
    [3]: (e, u)=>{
        let s = e.searchQuery !== "" ? 0 : 1, i = e.searchQuery + u.value.toLowerCase(), o = (e.activeItemIndex !== null ? e.items.slice(e.activeItemIndex + s).concat(e.items.slice(0, e.activeItemIndex + s)) : e.items).find((l)=>{
            var m;
            return ((m = l.dataRef.current.textValue) == null ? void 0 : m.startsWith(i)) && !l.dataRef.current.disabled;
        }), a = o ? e.items.indexOf(o) : -1;
        return a === -1 || a === e.activeItemIndex ? {
            ...e,
            searchQuery: i
        } : {
            ...e,
            searchQuery: i,
            activeItemIndex: a,
            activationTrigger: 1
        };
    },
    [4] (e) {
        return e.searchQuery === "" ? e : {
            ...e,
            searchQuery: "",
            searchActiveItemIndex: null
        };
    },
    [5]: (e, u)=>{
        let r = $c9bfa4e2da6232f7$var$w(e, (s)=>[
                ...s,
                {
                    id: u.id,
                    dataRef: u.dataRef
                }
            ]);
        return {
            ...e,
            ...r
        };
    },
    [6]: (e, u)=>{
        let r = $c9bfa4e2da6232f7$var$w(e, (s)=>{
            let i = s.findIndex((t)=>t.id === u.id);
            return i !== -1 && s.splice(i, 1), s;
        });
        return {
            ...e,
            ...r,
            activationTrigger: 1
        };
    }
}, $c9bfa4e2da6232f7$var$U = (0, $acw62.createContext)(null);
$c9bfa4e2da6232f7$var$U.displayName = "MenuContext";
function $c9bfa4e2da6232f7$var$C(e) {
    let u = (0, $acw62.useContext)($c9bfa4e2da6232f7$var$U);
    if (u === null) {
        let r = new Error(`<${e} /> is missing a parent <Menu /> component.`);
        throw Error.captureStackTrace && Error.captureStackTrace(r, $c9bfa4e2da6232f7$var$C), r;
    }
    return u;
}
function $c9bfa4e2da6232f7$var$ye(e, u) {
    return (0, $4f240e1aafd2c298$export$4659b591c19bdf3d)(u.type, $c9bfa4e2da6232f7$var$Te, e, u);
}
let $c9bfa4e2da6232f7$var$Ie = (0, $acw62.Fragment);
function $c9bfa4e2da6232f7$var$Me(e, u) {
    let { __demoMode: r = !1, ...s } = e, i = (0, $acw62.useReducer)($c9bfa4e2da6232f7$var$ye, {
        __demoMode: r,
        menuState: r ? 0 : 1,
        buttonRef: (0, $acw62.createRef)(),
        itemsRef: (0, $acw62.createRef)(),
        items: [],
        searchQuery: "",
        activeItemIndex: null,
        activationTrigger: 1
    }), [{ menuState: t, itemsRef: o, buttonRef: a }, l] = i, m = (0, $4a1854c6a3ad5196$export$f6a25a78204acc7e)(u);
    (0, $17eff26b89e4b024$export$71b2224f1ce5e08e)([
        a,
        o
    ], (g, R)=>{
        var p;
        l({
            type: 1
        }), (0, $cb6dceb64e6c0606$export$ff1ec1c740b3c8d5)(R, (0, $cb6dceb64e6c0606$export$27112a34f2f8402d).Loose) || (g.preventDefault(), (p = a.current) == null || p.focus());
    }, t === 0);
    let I = (0, $0bd9972698c32399$export$90fc3a17d93f704c)(()=>{
        l({
            type: 1
        });
    }), A = (0, $acw62.useMemo)(()=>({
            open: t === 0,
            close: I
        }), [
        t,
        I
    ]), f = {
        ref: m
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c9bfa4e2da6232f7$var$U.Provider, {
        value: i
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7a3499b4b3c6f184$export$2a0ed818b175f558), {
        value: (0, $4f240e1aafd2c298$export$4659b591c19bdf3d)(t, {
            [0]: (0, $7a3499b4b3c6f184$export$7254cc27399e90bd).Open,
            [1]: (0, $7a3499b4b3c6f184$export$7254cc27399e90bd).Closed
        })
    }, (0, $a54bdd13402af126$export$b3890eb0ae9dca99)({
        ourProps: f,
        theirProps: s,
        slot: A,
        defaultTag: $c9bfa4e2da6232f7$var$Ie,
        name: "Menu"
    })));
}
let $c9bfa4e2da6232f7$var$ge = "button";
function $c9bfa4e2da6232f7$var$Re(e, u) {
    var R;
    let r = (0, $f2a0dea4caee12c6$export$f680877a34711e37)(), { id: s = `headlessui-menu-button-${r}`, ...i } = e, [t, o] = $c9bfa4e2da6232f7$var$C("Menu.Button"), a = (0, $4a1854c6a3ad5196$export$f6a25a78204acc7e)(t.buttonRef, u), l = (0, $410e668b7f520622$export$fd183955ff4b45d9)(), m = (0, $0bd9972698c32399$export$90fc3a17d93f704c)((p)=>{
        switch(p.key){
            case (0, $4cca0dbc68b0507a$export$4b0075e5ea5e1f26).Space:
            case (0, $4cca0dbc68b0507a$export$4b0075e5ea5e1f26).Enter:
            case (0, $4cca0dbc68b0507a$export$4b0075e5ea5e1f26).ArrowDown:
                p.preventDefault(), p.stopPropagation(), o({
                    type: 0
                }), l.nextFrame(()=>o({
                        type: 2,
                        focus: (0, $b7a0b87cd8a0fa3d$export$807a7eae502106e7).First
                    }));
                break;
            case (0, $4cca0dbc68b0507a$export$4b0075e5ea5e1f26).ArrowUp:
                p.preventDefault(), p.stopPropagation(), o({
                    type: 0
                }), l.nextFrame(()=>o({
                        type: 2,
                        focus: (0, $b7a0b87cd8a0fa3d$export$807a7eae502106e7).Last
                    }));
                break;
        }
    }), I = (0, $0bd9972698c32399$export$90fc3a17d93f704c)((p)=>{
        switch(p.key){
            case (0, $4cca0dbc68b0507a$export$4b0075e5ea5e1f26).Space:
                p.preventDefault();
                break;
        }
    }), A = (0, $0bd9972698c32399$export$90fc3a17d93f704c)((p)=>{
        if ((0, $3d3d670dbe2ceed6$export$db61f031a278447c)(p.currentTarget)) return p.preventDefault();
        e.disabled || (t.menuState === 0 ? (o({
            type: 1
        }), l.nextFrame(()=>{
            var M;
            return (M = t.buttonRef.current) == null ? void 0 : M.focus({
                preventScroll: !0
            });
        })) : (p.preventDefault(), o({
            type: 0
        })));
    }), f = (0, $acw62.useMemo)(()=>({
            open: t.menuState === 0
        }), [
        t
    ]), g = {
        ref: a,
        id: s,
        type: (0, $be828d8bf9bb25ca$export$53652b2b272efe9c)(e, t.buttonRef),
        "aria-haspopup": "menu",
        "aria-controls": (R = t.itemsRef.current) == null ? void 0 : R.id,
        "aria-expanded": t.menuState === 0,
        onKeyDown: m,
        onKeyUp: I,
        onClick: A
    };
    return (0, $a54bdd13402af126$export$b3890eb0ae9dca99)({
        ourProps: g,
        theirProps: i,
        slot: f,
        defaultTag: $c9bfa4e2da6232f7$var$ge,
        name: "Menu.Button"
    });
}
let $c9bfa4e2da6232f7$var$Ae = "div", $c9bfa4e2da6232f7$var$be = (0, $a54bdd13402af126$export$617d79dae526d2cf).RenderStrategy | (0, $a54bdd13402af126$export$617d79dae526d2cf).Static;
function $c9bfa4e2da6232f7$var$Ee(e, u) {
    var M, b;
    let r = (0, $f2a0dea4caee12c6$export$f680877a34711e37)(), { id: s = `headlessui-menu-items-${r}`, ...i } = e, [t, o] = $c9bfa4e2da6232f7$var$C("Menu.Items"), a = (0, $4a1854c6a3ad5196$export$f6a25a78204acc7e)(t.itemsRef, u), l = (0, $42a08b28a285ca8e$export$dd9fbcea3de0ae36)(t.itemsRef), m = (0, $410e668b7f520622$export$fd183955ff4b45d9)(), I = (0, $7a3499b4b3c6f184$export$fc6fdf0ecf360e)(), A = (()=>I !== null ? (I & (0, $7a3499b4b3c6f184$export$7254cc27399e90bd).Open) === (0, $7a3499b4b3c6f184$export$7254cc27399e90bd).Open : t.menuState === 0)();
    (0, $acw62.useEffect)(()=>{
        let n = t.itemsRef.current;
        n && t.menuState === 0 && n !== (l == null ? void 0 : l.activeElement) && n.focus({
            preventScroll: !0
        });
    }, [
        t.menuState,
        t.itemsRef,
        l
    ]), (0, $101ef4628501ab0d$export$b0abce39eb34b36)({
        container: t.itemsRef.current,
        enabled: t.menuState === 0,
        accept (n) {
            return n.getAttribute("role") === "menuitem" ? NodeFilter.FILTER_REJECT : n.hasAttribute("role") ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT;
        },
        walk (n) {
            n.setAttribute("role", "none");
        }
    });
    let f = (0, $0bd9972698c32399$export$90fc3a17d93f704c)((n)=>{
        var E, x;
        switch(m.dispose(), n.key){
            case (0, $4cca0dbc68b0507a$export$4b0075e5ea5e1f26).Space:
                if (t.searchQuery !== "") return n.preventDefault(), n.stopPropagation(), o({
                    type: 3,
                    value: n.key
                });
            case (0, $4cca0dbc68b0507a$export$4b0075e5ea5e1f26).Enter:
                if (n.preventDefault(), n.stopPropagation(), o({
                    type: 1
                }), t.activeItemIndex !== null) {
                    let { dataRef: S } = t.items[t.activeItemIndex];
                    (x = (E = S.current) == null ? void 0 : E.domRef.current) == null || x.click();
                }
                (0, $cb6dceb64e6c0606$export$46388676ec35ab85)(t.buttonRef.current);
                break;
            case (0, $4cca0dbc68b0507a$export$4b0075e5ea5e1f26).ArrowDown:
                return n.preventDefault(), n.stopPropagation(), o({
                    type: 2,
                    focus: (0, $b7a0b87cd8a0fa3d$export$807a7eae502106e7).Next
                });
            case (0, $4cca0dbc68b0507a$export$4b0075e5ea5e1f26).ArrowUp:
                return n.preventDefault(), n.stopPropagation(), o({
                    type: 2,
                    focus: (0, $b7a0b87cd8a0fa3d$export$807a7eae502106e7).Previous
                });
            case (0, $4cca0dbc68b0507a$export$4b0075e5ea5e1f26).Home:
            case (0, $4cca0dbc68b0507a$export$4b0075e5ea5e1f26).PageUp:
                return n.preventDefault(), n.stopPropagation(), o({
                    type: 2,
                    focus: (0, $b7a0b87cd8a0fa3d$export$807a7eae502106e7).First
                });
            case (0, $4cca0dbc68b0507a$export$4b0075e5ea5e1f26).End:
            case (0, $4cca0dbc68b0507a$export$4b0075e5ea5e1f26).PageDown:
                return n.preventDefault(), n.stopPropagation(), o({
                    type: 2,
                    focus: (0, $b7a0b87cd8a0fa3d$export$807a7eae502106e7).Last
                });
            case (0, $4cca0dbc68b0507a$export$4b0075e5ea5e1f26).Escape:
                n.preventDefault(), n.stopPropagation(), o({
                    type: 1
                }), (0, $12f0e1633d904536$export$12b26c28a05aa001)().nextFrame(()=>{
                    var S;
                    return (S = t.buttonRef.current) == null ? void 0 : S.focus({
                        preventScroll: !0
                    });
                });
                break;
            case (0, $4cca0dbc68b0507a$export$4b0075e5ea5e1f26).Tab:
                n.preventDefault(), n.stopPropagation(), o({
                    type: 1
                }), (0, $12f0e1633d904536$export$12b26c28a05aa001)().nextFrame(()=>{
                    (0, $cb6dceb64e6c0606$export$7fb6c844b485e870)(t.buttonRef.current, n.shiftKey ? (0, $cb6dceb64e6c0606$export$807a7eae502106e7).Previous : (0, $cb6dceb64e6c0606$export$807a7eae502106e7).Next);
                });
                break;
            default:
                n.key.length === 1 && (o({
                    type: 3,
                    value: n.key
                }), m.setTimeout(()=>o({
                        type: 4
                    }), 350));
                break;
        }
    }), g = (0, $0bd9972698c32399$export$90fc3a17d93f704c)((n)=>{
        switch(n.key){
            case (0, $4cca0dbc68b0507a$export$4b0075e5ea5e1f26).Space:
                n.preventDefault();
                break;
        }
    }), R = (0, $acw62.useMemo)(()=>({
            open: t.menuState === 0
        }), [
        t
    ]), p = {
        "aria-activedescendant": t.activeItemIndex === null || (M = t.items[t.activeItemIndex]) == null ? void 0 : M.id,
        "aria-labelledby": (b = t.buttonRef.current) == null ? void 0 : b.id,
        id: s,
        onKeyDown: f,
        onKeyUp: g,
        role: "menu",
        tabIndex: 0,
        ref: a
    };
    return (0, $a54bdd13402af126$export$b3890eb0ae9dca99)({
        ourProps: p,
        theirProps: i,
        slot: R,
        defaultTag: $c9bfa4e2da6232f7$var$Ae,
        features: $c9bfa4e2da6232f7$var$be,
        visible: A,
        name: "Menu.Items"
    });
}
let $c9bfa4e2da6232f7$var$Se = (0, $acw62.Fragment);
function $c9bfa4e2da6232f7$var$xe(e, u) {
    let r = (0, $f2a0dea4caee12c6$export$f680877a34711e37)(), { id: s = `headlessui-menu-item-${r}`, disabled: i = !1, ...t } = e, [o, a] = $c9bfa4e2da6232f7$var$C("Menu.Item"), l = o.activeItemIndex !== null ? o.items[o.activeItemIndex].id === s : !1, m = (0, $acw62.useRef)(null), I = (0, $4a1854c6a3ad5196$export$f6a25a78204acc7e)(u, m);
    (0, $65df95ec9b1bb6a8$export$ce5ed857c741fd71)(()=>{
        if (o.__demoMode || o.menuState !== 0 || !l || o.activationTrigger === 0) return;
        let T = (0, $12f0e1633d904536$export$12b26c28a05aa001)();
        return T.requestAnimationFrame(()=>{
            var P, B;
            (B = (P = m.current) == null ? void 0 : P.scrollIntoView) == null || B.call(P, {
                block: "nearest"
            });
        }), T.dispose;
    }, [
        o.__demoMode,
        m,
        l,
        o.menuState,
        o.activationTrigger,
        o.activeItemIndex
    ]);
    let A = (0, $e688621b6eb177ca$export$f6862afd851a1cf4)(m), f = (0, $acw62.useRef)({
        disabled: i,
        domRef: m,
        get textValue () {
            return A();
        }
    });
    (0, $65df95ec9b1bb6a8$export$ce5ed857c741fd71)(()=>{
        f.current.disabled = i;
    }, [
        f,
        i
    ]), (0, $65df95ec9b1bb6a8$export$ce5ed857c741fd71)(()=>(a({
            type: 5,
            id: s,
            dataRef: f
        }), ()=>a({
                type: 6,
                id: s
            })), [
        f,
        s
    ]);
    let g = (0, $0bd9972698c32399$export$90fc3a17d93f704c)(()=>{
        a({
            type: 1
        });
    }), R = (0, $0bd9972698c32399$export$90fc3a17d93f704c)((T)=>{
        if (i) return T.preventDefault();
        a({
            type: 1
        }), (0, $cb6dceb64e6c0606$export$46388676ec35ab85)(o.buttonRef.current);
    }), p = (0, $0bd9972698c32399$export$90fc3a17d93f704c)(()=>{
        if (i) return a({
            type: 2,
            focus: (0, $b7a0b87cd8a0fa3d$export$807a7eae502106e7).Nothing
        });
        a({
            type: 2,
            focus: (0, $b7a0b87cd8a0fa3d$export$807a7eae502106e7).Specific,
            id: s
        });
    }), M = (0, $d668e4b1d0c2f85c$export$24ebee078bde85c3)(), b = (0, $0bd9972698c32399$export$90fc3a17d93f704c)((T)=>M.update(T)), n = (0, $0bd9972698c32399$export$90fc3a17d93f704c)((T)=>{
        M.wasMoved(T) && (i || l || a({
            type: 2,
            focus: (0, $b7a0b87cd8a0fa3d$export$807a7eae502106e7).Specific,
            id: s,
            trigger: 0
        }));
    }), E = (0, $0bd9972698c32399$export$90fc3a17d93f704c)((T)=>{
        M.wasMoved(T) && (i || l && a({
            type: 2,
            focus: (0, $b7a0b87cd8a0fa3d$export$807a7eae502106e7).Nothing
        }));
    }), x = (0, $acw62.useMemo)(()=>({
            active: l,
            disabled: i,
            close: g
        }), [
        l,
        i,
        g
    ]);
    return (0, $a54bdd13402af126$export$b3890eb0ae9dca99)({
        ourProps: {
            id: s,
            ref: I,
            role: "menuitem",
            tabIndex: i === !0 ? void 0 : -1,
            "aria-disabled": i === !0 ? !0 : void 0,
            disabled: void 0,
            onClick: R,
            onFocus: p,
            onPointerEnter: b,
            onMouseEnter: b,
            onPointerMove: n,
            onMouseMove: n,
            onPointerLeave: E,
            onMouseLeave: E
        },
        theirProps: t,
        slot: x,
        defaultTag: $c9bfa4e2da6232f7$var$Se,
        name: "Menu.Item"
    });
}
let $c9bfa4e2da6232f7$var$Pe = (0, $a54bdd13402af126$export$e43f39796049410c)($c9bfa4e2da6232f7$var$Me), $c9bfa4e2da6232f7$var$ve = (0, $a54bdd13402af126$export$e43f39796049410c)($c9bfa4e2da6232f7$var$Re), $c9bfa4e2da6232f7$var$he = (0, $a54bdd13402af126$export$e43f39796049410c)($c9bfa4e2da6232f7$var$Ee), $c9bfa4e2da6232f7$var$De = (0, $a54bdd13402af126$export$e43f39796049410c)($c9bfa4e2da6232f7$var$xe), $c9bfa4e2da6232f7$export$d9b273488cd8ce6f = Object.assign($c9bfa4e2da6232f7$var$Pe, {
    Button: $c9bfa4e2da6232f7$var$ve,
    Items: $c9bfa4e2da6232f7$var$he,
    Item: $c9bfa4e2da6232f7$var$De
});

var $030a82c6b2bb6f00$exports = {};

$parcel$export($030a82c6b2bb6f00$exports, "Transition", () => $030a82c6b2bb6f00$export$be58926105124dd4);

var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

function $854f77de70ff8db2$export$80c2a3957bcb42ea() {
    let e = (0, $acw62.useRef)(!1);
    return (0, $65df95ec9b1bb6a8$export$ce5ed857c741fd71)(()=>(e.current = !0, ()=>{
            e.current = !1;
        }), []), e;
}


function $805c30fc151c4831$export$2879604e6aec4ab(a = 0) {
    let [l, r] = (0, $acw62.useState)(a), t = (0, $854f77de70ff8db2$export$80c2a3957bcb42ea)(), o = (0, $acw62.useCallback)((e)=>{
        t.current && r((u)=>u | e);
    }, [
        l,
        t
    ]), m = (0, $acw62.useCallback)((e)=>Boolean(l & e), [
        l
    ]), s = (0, $acw62.useCallback)((e)=>{
        t.current && r((u)=>u & ~e);
    }, [
        r,
        t
    ]), g = (0, $acw62.useCallback)((e)=>{
        t.current && r((u)=>u ^ e);
    }, [
        r
    ]);
    return {
        flags: l,
        addFlag: o,
        hasFlag: m,
        removeFlag: s,
        toggleFlag: g
    };
}









function $7716801ecfdbcff6$export$d2de3aaeafa91619(r) {
    let e = {
        called: !1
    };
    return (...t)=>{
        if (!e.called) return e.called = !0, r(...t);
    };
}


function $d94e61505c2ccd73$var$g(t, ...e) {
    t && e.length > 0 && t.classList.add(...e);
}
function $d94e61505c2ccd73$var$v(t, ...e) {
    t && e.length > 0 && t.classList.remove(...e);
}
function $d94e61505c2ccd73$var$b(t, e) {
    let n = (0, $12f0e1633d904536$export$12b26c28a05aa001)();
    if (!t) return n.dispose;
    let { transitionDuration: m, transitionDelay: a } = getComputedStyle(t), [u, p] = [
        m,
        a
    ].map((l)=>{
        let [r = 0] = l.split(",").filter(Boolean).map((i)=>i.includes("ms") ? parseFloat(i) : parseFloat(i) * 1e3).sort((i, T)=>T - i);
        return r;
    }), o = u + p;
    if (o !== 0) {
        n.group((r)=>{
            r.setTimeout(()=>{
                e(), r.dispose();
            }, o), r.addEventListener(t, "transitionrun", (i)=>{
                i.target === i.currentTarget && r.dispose();
            });
        });
        let l = n.addEventListener(t, "transitionend", (r)=>{
            r.target === r.currentTarget && (e(), l());
        });
    } else e();
    return n.add(()=>e()), n.dispose;
}
function $d94e61505c2ccd73$export$66bb15e2994e6a26(t, e, n, m) {
    let a = n ? "enter" : "leave", u = (0, $12f0e1633d904536$export$12b26c28a05aa001)(), p = m !== void 0 ? (0, $7716801ecfdbcff6$export$d2de3aaeafa91619)(m) : ()=>{};
    a === "enter" && (t.removeAttribute("hidden"), t.style.display = "");
    let o = (0, $4f240e1aafd2c298$export$4659b591c19bdf3d)(a, {
        enter: ()=>e.enter,
        leave: ()=>e.leave
    }), l = (0, $4f240e1aafd2c298$export$4659b591c19bdf3d)(a, {
        enter: ()=>e.enterTo,
        leave: ()=>e.leaveTo
    }), r = (0, $4f240e1aafd2c298$export$4659b591c19bdf3d)(a, {
        enter: ()=>e.enterFrom,
        leave: ()=>e.leaveFrom
    });
    return $d94e61505c2ccd73$var$v(t, ...e.base, ...e.enter, ...e.enterTo, ...e.enterFrom, ...e.leave, ...e.leaveFrom, ...e.leaveTo, ...e.entered), $d94e61505c2ccd73$var$g(t, ...e.base, ...o, ...r), u.nextFrame(()=>{
        $d94e61505c2ccd73$var$v(t, ...e.base, ...o, ...r), $d94e61505c2ccd73$var$g(t, ...e.base, ...o, ...l), $d94e61505c2ccd73$var$b(t, ()=>($d94e61505c2ccd73$var$v(t, ...e.base, ...o), $d94e61505c2ccd73$var$g(t, ...e.base, ...e.entered), p()));
    }), u.dispose;
}







function $82a0b6c20b323075$export$7b286972b8d8ccbf({ immediate: t, container: s, direction: n, classes: u, onStart: a, onStop: c }) {
    let l = (0, $854f77de70ff8db2$export$80c2a3957bcb42ea)(), d = (0, $410e668b7f520622$export$fd183955ff4b45d9)(), e = (0, $fa1923261638cacc$export$86c4283a11f23f95)(n);
    (0, $65df95ec9b1bb6a8$export$ce5ed857c741fd71)(()=>{
        t && (e.current = "enter");
    }, [
        t
    ]), (0, $65df95ec9b1bb6a8$export$ce5ed857c741fd71)(()=>{
        let r = (0, $12f0e1633d904536$export$12b26c28a05aa001)();
        d.add(r.dispose);
        let i = s.current;
        if (i && e.current !== "idle" && l.current) return r.dispose(), a.current(e.current), r.add((0, $d94e61505c2ccd73$export$66bb15e2994e6a26)(i, u.current, e.current === "enter", ()=>{
            r.dispose(), c.current(e.current);
        })), r.dispose;
    }, [
        n
    ]);
}






function $030a82c6b2bb6f00$var$S(t = "") {
    return t.split(/\s+/).filter((n)=>n.length > 1);
}
let $030a82c6b2bb6f00$var$I = (0, $acw62.createContext)(null);
$030a82c6b2bb6f00$var$I.displayName = "TransitionContext";
var $030a82c6b2bb6f00$var$Se = ((r)=>(r.Visible = "visible", r.Hidden = "hidden", r))($030a82c6b2bb6f00$var$Se || {});
function $030a82c6b2bb6f00$var$ye() {
    let t = (0, $acw62.useContext)($030a82c6b2bb6f00$var$I);
    if (t === null) throw new Error("A <Transition.Child /> is used but it is missing a parent <Transition /> or <Transition.Root />.");
    return t;
}
function $030a82c6b2bb6f00$var$xe() {
    let t = (0, $acw62.useContext)($030a82c6b2bb6f00$var$M);
    if (t === null) throw new Error("A <Transition.Child /> is used but it is missing a parent <Transition /> or <Transition.Root />.");
    return t;
}
let $030a82c6b2bb6f00$var$M = (0, $acw62.createContext)(null);
$030a82c6b2bb6f00$var$M.displayName = "NestingContext";
function $030a82c6b2bb6f00$var$U(t) {
    return "children" in t ? $030a82c6b2bb6f00$var$U(t.children) : t.current.filter(({ el: n })=>n.current !== null).filter(({ state: n })=>n === "visible").length > 0;
}
function $030a82c6b2bb6f00$var$se(t, n) {
    let r = (0, $fa1923261638cacc$export$86c4283a11f23f95)(t), s = (0, $acw62.useRef)([]), R = (0, $854f77de70ff8db2$export$80c2a3957bcb42ea)(), D = (0, $410e668b7f520622$export$fd183955ff4b45d9)(), p = (0, $0bd9972698c32399$export$90fc3a17d93f704c)((i, e = (0, $a54bdd13402af126$export$80c0a745e59f7989).Hidden)=>{
        let a = s.current.findIndex(({ el: o })=>o === i);
        a !== -1 && ((0, $4f240e1aafd2c298$export$4659b591c19bdf3d)(e, {
            [(0, $a54bdd13402af126$export$80c0a745e59f7989).Unmount] () {
                s.current.splice(a, 1);
            },
            [(0, $a54bdd13402af126$export$80c0a745e59f7989).Hidden] () {
                s.current[a].state = "hidden";
            }
        }), D.microTask(()=>{
            var o;
            !$030a82c6b2bb6f00$var$U(s) && R.current && ((o = r.current) == null || o.call(r));
        }));
    }), x = (0, $0bd9972698c32399$export$90fc3a17d93f704c)((i)=>{
        let e = s.current.find(({ el: a })=>a === i);
        return e ? e.state !== "visible" && (e.state = "visible") : s.current.push({
            el: i,
            state: "visible"
        }), ()=>p(i, (0, $a54bdd13402af126$export$80c0a745e59f7989).Unmount);
    }), h = (0, $acw62.useRef)([]), v = (0, $acw62.useRef)(Promise.resolve()), u = (0, $acw62.useRef)({
        enter: [],
        leave: [],
        idle: []
    }), g = (0, $0bd9972698c32399$export$90fc3a17d93f704c)((i, e, a)=>{
        h.current.splice(0), n && (n.chains.current[e] = n.chains.current[e].filter(([o])=>o !== i)), n == null || n.chains.current[e].push([
            i,
            new Promise((o)=>{
                h.current.push(o);
            })
        ]), n == null || n.chains.current[e].push([
            i,
            new Promise((o)=>{
                Promise.all(u.current[e].map(([f, N])=>N)).then(()=>o());
            })
        ]), e === "enter" ? v.current = v.current.then(()=>n == null ? void 0 : n.wait.current).then(()=>a(e)) : a(e);
    }), d = (0, $0bd9972698c32399$export$90fc3a17d93f704c)((i, e, a)=>{
        Promise.all(u.current[e].splice(0).map(([o, f])=>f)).then(()=>{
            var o;
            (o = h.current.shift()) == null || o();
        }).then(()=>a(e));
    });
    return (0, $acw62.useMemo)(()=>({
            children: s,
            register: x,
            unregister: p,
            onStart: g,
            onStop: d,
            wait: v,
            chains: u
        }), [
        x,
        p,
        s,
        g,
        d,
        u,
        v
    ]);
}
function $030a82c6b2bb6f00$var$Ne() {}
let $030a82c6b2bb6f00$var$Pe = [
    "beforeEnter",
    "afterEnter",
    "beforeLeave",
    "afterLeave"
];
function $030a82c6b2bb6f00$var$ae(t) {
    var r;
    let n = {};
    for (let s of $030a82c6b2bb6f00$var$Pe)n[s] = (r = t[s]) != null ? r : $030a82c6b2bb6f00$var$Ne;
    return n;
}
function $030a82c6b2bb6f00$var$Re(t) {
    let n = (0, $acw62.useRef)($030a82c6b2bb6f00$var$ae(t));
    return (0, $acw62.useEffect)(()=>{
        n.current = $030a82c6b2bb6f00$var$ae(t);
    }, [
        t
    ]), n;
}
let $030a82c6b2bb6f00$var$De = "div", $030a82c6b2bb6f00$var$le = (0, $a54bdd13402af126$export$617d79dae526d2cf).RenderStrategy;
function $030a82c6b2bb6f00$var$He(t, n) {
    var Q, Y;
    let { beforeEnter: r, afterEnter: s, beforeLeave: R, afterLeave: D, enter: p, enterFrom: x, enterTo: h, entered: v, leave: u, leaveFrom: g, leaveTo: d, ...i } = t, e = (0, $acw62.useRef)(null), a = (0, $4a1854c6a3ad5196$export$f6a25a78204acc7e)(e, n), o = (Q = i.unmount) == null || Q ? (0, $a54bdd13402af126$export$80c0a745e59f7989).Unmount : (0, $a54bdd13402af126$export$80c0a745e59f7989).Hidden, { show: f, appear: N, initial: T } = $030a82c6b2bb6f00$var$ye(), [l, j] = (0, $acw62.useState)(f ? "visible" : "hidden"), z = $030a82c6b2bb6f00$var$xe(), { register: L, unregister: O } = z;
    (0, $acw62.useEffect)(()=>L(e), [
        L,
        e
    ]), (0, $acw62.useEffect)(()=>{
        if (o === (0, $a54bdd13402af126$export$80c0a745e59f7989).Hidden && e.current) {
            if (f && l !== "visible") {
                j("visible");
                return;
            }
            return (0, $4f240e1aafd2c298$export$4659b591c19bdf3d)(l, {
                ["hidden"]: ()=>O(e),
                ["visible"]: ()=>L(e)
            });
        }
    }, [
        l,
        e,
        L,
        O,
        f,
        o
    ]);
    let k = (0, $fa1923261638cacc$export$86c4283a11f23f95)({
        base: $030a82c6b2bb6f00$var$S(i.className),
        enter: $030a82c6b2bb6f00$var$S(p),
        enterFrom: $030a82c6b2bb6f00$var$S(x),
        enterTo: $030a82c6b2bb6f00$var$S(h),
        entered: $030a82c6b2bb6f00$var$S(v),
        leave: $030a82c6b2bb6f00$var$S(u),
        leaveFrom: $030a82c6b2bb6f00$var$S(g),
        leaveTo: $030a82c6b2bb6f00$var$S(d)
    }), V = $030a82c6b2bb6f00$var$Re({
        beforeEnter: r,
        afterEnter: s,
        beforeLeave: R,
        afterLeave: D
    }), G = (0, $81b1abbf8717f9cc$export$44ab2b9f2d09b0fa)();
    (0, $acw62.useEffect)(()=>{
        if (G && l === "visible" && e.current === null) throw new Error("Did you forget to passthrough the `ref` to the actual DOM node?");
    }, [
        e,
        l,
        G
    ]);
    let Te = T && !N, K = N && f && T, de = (()=>!G || Te ? "idle" : f ? "enter" : "leave")(), H = (0, $805c30fc151c4831$export$2879604e6aec4ab)(0), fe = (0, $0bd9972698c32399$export$90fc3a17d93f704c)((C)=>(0, $4f240e1aafd2c298$export$4659b591c19bdf3d)(C, {
            enter: ()=>{
                H.addFlag((0, $7a3499b4b3c6f184$export$7254cc27399e90bd).Opening), V.current.beforeEnter();
            },
            leave: ()=>{
                H.addFlag((0, $7a3499b4b3c6f184$export$7254cc27399e90bd).Closing), V.current.beforeLeave();
            },
            idle: ()=>{}
        })), me = (0, $0bd9972698c32399$export$90fc3a17d93f704c)((C)=>(0, $4f240e1aafd2c298$export$4659b591c19bdf3d)(C, {
            enter: ()=>{
                H.removeFlag((0, $7a3499b4b3c6f184$export$7254cc27399e90bd).Opening), V.current.afterEnter();
            },
            leave: ()=>{
                H.removeFlag((0, $7a3499b4b3c6f184$export$7254cc27399e90bd).Closing), V.current.afterLeave();
            },
            idle: ()=>{}
        })), w = $030a82c6b2bb6f00$var$se(()=>{
        j("hidden"), O(e);
    }, z), B = (0, $acw62.useRef)(!1);
    (0, $82a0b6c20b323075$export$7b286972b8d8ccbf)({
        immediate: K,
        container: e,
        classes: k,
        direction: de,
        onStart: (0, $fa1923261638cacc$export$86c4283a11f23f95)((C)=>{
            B.current = !0, w.onStart(e, C, fe);
        }),
        onStop: (0, $fa1923261638cacc$export$86c4283a11f23f95)((C)=>{
            B.current = !1, w.onStop(e, C, me), C === "leave" && !$030a82c6b2bb6f00$var$U(w) && (j("hidden"), O(e));
        })
    });
    let P = i, ce = {
        ref: a
    };
    return K ? P = {
        ...P,
        className: (0, $37ab6efe1f53a2e0$export$ce4ab0c55987d1ff)(i.className, ...k.current.enter, ...k.current.enterFrom)
    } : B.current && (P.className = (0, $37ab6efe1f53a2e0$export$ce4ab0c55987d1ff)(i.className, (Y = e.current) == null ? void 0 : Y.className), P.className === "" && delete P.className), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($030a82c6b2bb6f00$var$M.Provider, {
        value: w
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7a3499b4b3c6f184$export$2a0ed818b175f558), {
        value: (0, $4f240e1aafd2c298$export$4659b591c19bdf3d)(l, {
            ["visible"]: (0, $7a3499b4b3c6f184$export$7254cc27399e90bd).Open,
            ["hidden"]: (0, $7a3499b4b3c6f184$export$7254cc27399e90bd).Closed
        }) | H.flags
    }, (0, $a54bdd13402af126$export$b3890eb0ae9dca99)({
        ourProps: ce,
        theirProps: P,
        defaultTag: $030a82c6b2bb6f00$var$De,
        features: $030a82c6b2bb6f00$var$le,
        visible: l === "visible",
        name: "Transition.Child"
    })));
}
function $030a82c6b2bb6f00$var$Fe(t, n) {
    let { show: r, appear: s = !1, unmount: R = !0, ...D } = t, p = (0, $acw62.useRef)(null), x = (0, $4a1854c6a3ad5196$export$f6a25a78204acc7e)(p, n);
    (0, $81b1abbf8717f9cc$export$44ab2b9f2d09b0fa)();
    let h = (0, $7a3499b4b3c6f184$export$fc6fdf0ecf360e)();
    if (r === void 0 && h !== null && (r = (h & (0, $7a3499b4b3c6f184$export$7254cc27399e90bd).Open) === (0, $7a3499b4b3c6f184$export$7254cc27399e90bd).Open), ![
        !0,
        !1
    ].includes(r)) throw new Error("A <Transition /> is used but it is missing a `show={true | false}` prop.");
    let [v, u] = (0, $acw62.useState)(r ? "visible" : "hidden"), g = $030a82c6b2bb6f00$var$se(()=>{
        u("hidden");
    }), [d, i] = (0, $acw62.useState)(!0), e = (0, $acw62.useRef)([
        r
    ]);
    (0, $65df95ec9b1bb6a8$export$ce5ed857c741fd71)(()=>{
        d !== !1 && e.current[e.current.length - 1] !== r && (e.current.push(r), i(!1));
    }, [
        e,
        r
    ]);
    let a = (0, $acw62.useMemo)(()=>({
            show: r,
            appear: s,
            initial: d
        }), [
        r,
        s,
        d
    ]);
    (0, $acw62.useEffect)(()=>{
        if (r) u("visible");
        else if (!$030a82c6b2bb6f00$var$U(g)) u("hidden");
        else {
            let T = p.current;
            if (!T) return;
            let l = T.getBoundingClientRect();
            l.x === 0 && l.y === 0 && l.width === 0 && l.height === 0 && u("hidden");
        }
    }, [
        r,
        g
    ]);
    let o = {
        unmount: R
    }, f = (0, $0bd9972698c32399$export$90fc3a17d93f704c)(()=>{
        var T;
        d && i(!1), (T = t.beforeEnter) == null || T.call(t);
    }), N = (0, $0bd9972698c32399$export$90fc3a17d93f704c)(()=>{
        var T;
        d && i(!1), (T = t.beforeLeave) == null || T.call(t);
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($030a82c6b2bb6f00$var$M.Provider, {
        value: g
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($030a82c6b2bb6f00$var$I.Provider, {
        value: a
    }, (0, $a54bdd13402af126$export$b3890eb0ae9dca99)({
        ourProps: {
            ...o,
            as: (0, $acw62.Fragment),
            children: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($030a82c6b2bb6f00$var$ue, {
                ref: x,
                ...o,
                ...D,
                beforeEnter: f,
                beforeLeave: N
            })
        },
        theirProps: {},
        defaultTag: (0, $acw62.Fragment),
        features: $030a82c6b2bb6f00$var$le,
        visible: v === "visible",
        name: "Transition"
    })));
}
function $030a82c6b2bb6f00$var$_e(t, n) {
    let r = (0, $acw62.useContext)($030a82c6b2bb6f00$var$I) !== null, s = (0, $7a3499b4b3c6f184$export$fc6fdf0ecf360e)() !== null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, !r && s ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($030a82c6b2bb6f00$var$q, {
        ref: n,
        ...t
    }) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($030a82c6b2bb6f00$var$ue, {
        ref: n,
        ...t
    }));
}
let $030a82c6b2bb6f00$var$q = (0, $a54bdd13402af126$export$e43f39796049410c)($030a82c6b2bb6f00$var$Fe), $030a82c6b2bb6f00$var$ue = (0, $a54bdd13402af126$export$e43f39796049410c)($030a82c6b2bb6f00$var$He), $030a82c6b2bb6f00$var$Le = (0, $a54bdd13402af126$export$e43f39796049410c)($030a82c6b2bb6f00$var$_e), $030a82c6b2bb6f00$export$be58926105124dd4 = Object.assign($030a82c6b2bb6f00$var$q, {
    Child: $030a82c6b2bb6f00$var$Le,
    Root: $030a82c6b2bb6f00$var$q
});




var $f1q41 = parcelRequire("f1q41");











var $acw62 = parcelRequire("acw62");



var $dfcd2f458918c5ae$exports = {};

$parcel$export($dfcd2f458918c5ae$exports, "matchSearch", () => $dfcd2f458918c5ae$export$87f5c7a0305c2dc7);
$parcel$export($dfcd2f458918c5ae$exports, "fuzzyMatch", () => $dfcd2f458918c5ae$export$3ace64ce5180d918);
$parcel$export($dfcd2f458918c5ae$exports, "renderMatch", () => $dfcd2f458918c5ae$export$2484ee4456d34df7);
$parcel$export($dfcd2f458918c5ae$exports, "rankMatch", () => $dfcd2f458918c5ae$export$491288c476195500);
$parcel$export($dfcd2f458918c5ae$exports, "filterSortFuzzyMatch", () => $dfcd2f458918c5ae$export$ecb52968166e22ca);
$parcel$export($dfcd2f458918c5ae$exports, "useSearchResults", () => $dfcd2f458918c5ae$export$deb5cc6ef1318024);


var $acw62 = parcelRequire("acw62");

function $dfcd2f458918c5ae$export$87f5c7a0305c2dc7(match) {
    return match.map(({ match: match })=>match).join("");
}
function $dfcd2f458918c5ae$export$3ace64ce5180d918(search, text) {
    if (search.length === 0) return [
        {
            prefix: text,
            match: ""
        }
    ];
    const matchStart = text.indexOf(search[0]);
    if (matchStart < 0) return null;
    const prefix = text.slice(0, matchStart);
    const textFromMatch = text.slice(matchStart);
    const maxMatchLength = Math.min(search.length, textFromMatch.length);
    let matchLength = 1;
    while(matchLength < maxMatchLength && search[matchLength] === textFromMatch[matchLength])matchLength++;
    const fullMatch = textFromMatch.slice(0, matchLength);
    const restText = textFromMatch.slice(matchLength);
    const restSearch = search.slice(matchLength);
    const restMatch = $dfcd2f458918c5ae$export$3ace64ce5180d918(restSearch, restText);
    if (restMatch === null) return null;
    return [
        {
            prefix: prefix,
            match: fullMatch
        },
        ...restMatch
    ];
}
function $dfcd2f458918c5ae$export$2484ee4456d34df7(match) {
    return match.map(({ prefix: prefix, match: match }, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($acw62.Fragment, {
            children: [
                prefix,
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("b", {
                    children: match
                })
            ]
        }, index));
}
function $dfcd2f458918c5ae$export$491288c476195500(match) {
    const joinedMatch = match.map(({ match: match })=>match).join("");
    const joinedFull = match.flat().join("");
    const matchRatio = joinedMatch.length / joinedFull.length;
    const wordFit = match.map(({ prefix: prefix, match: match })=>prefix.length === 0 || prefix.endsWith(" ") ? 0.8 : match.includes(" ") ? 0.9 : 1).reduce((a, b)=>a + b, 0);
    return wordFit * (2 - matchRatio);
}
function $dfcd2f458918c5ae$export$ecb52968166e22ca(search, candidates, getText) {
    return candidates.flatMap((candidate, index)=>{
        const match = $dfcd2f458918c5ae$export$3ace64ce5180d918(search, getText(candidate));
        if (match === null) return [];
        return [
            {
                id: index,
                candidate: candidate,
                match: match,
                rank: $dfcd2f458918c5ae$export$491288c476195500(match)
            }
        ];
    }).sort((a, b)=>a.rank - b.rank);
}
function $dfcd2f458918c5ae$export$deb5cc6ef1318024(search, candidates, getText, scrollTo) {
    const [selected, setSelected] = $acw62.useState(0);
    const [setScrollRef, refMap] = (0, $ff99259e85546794$export$a4bd4d7d17a12a52)();
    const setRef = $acw62.useCallback((id)=>(element)=>{
            setScrollRef(id)({
                scrollIntoView () {
                    element.scrollIntoView({
                        block: "nearest"
                    });
                }
            });
        }, [
        setScrollRef
    ]);
    const results = $acw62.useMemo(()=>$dfcd2f458918c5ae$export$ecb52968166e22ca(search, candidates, getText), [
        search,
        candidates,
        getText
    ]);
    const resultsRef = (0, $ff99259e85546794$export$4debdb1a3f0fa79e)(results);
    const scrollToFocus = $acw62.useCallback(function scrollToFocus(filteredIndex) {
        refMap.get(resultsRef.current[filteredIndex]?.id)?.scrollIntoView();
    }, [
        refMap,
        resultsRef
    ]);
    scrollTo = scrollTo ?? scrollToFocus;
    const moveSelection = $acw62.useCallback(function moveSelection(delta) {
        setSelected((selected)=>{
            const newSelected = (selected + delta + /* so we don't get negative values: */ resultsRef.current.length) % resultsRef.current.length;
            scrollTo(newSelected);
            return newSelected;
        });
    }, [
        scrollTo,
        resultsRef
    ]);
    const select = $acw62.useCallback(function select(index, scroll = true) {
        scroll && scrollTo(index);
        setSelected(index);
    }, [
        scrollTo
    ]);
    $acw62.useEffect(()=>{
        select(0);
    }, [
        search
    ]);
    return {
        results: results,
        selected: selected,
        moveSelection: moveSelection,
        select: select,
        setRef: setRef
    };
}


function $32a31d0dc687709a$export$82e214bd55812f44({ bindings: bindings, close: close }) {
    const inputRef = $acw62.useRef();
    const focusBefore = $acw62.useMemo(()=>document.activeElement, []);
    const [searchText, setSearchText] = $acw62.useState("");
    const queueEffect = (0, $ff99259e85546794$export$4ed76960a7e92ef6)();
    const flatBindings = bindings.flatMap((binding)=>binding.bindings.map(([keys, _condition, description, action])=>({
                group: binding.description,
                keys: keys,
                description: description,
                action: action
            }))).map((binding, index)=>({
            ...binding,
            id: index
        }));
    const { setRef: setRef, results: results, selected: selected, moveSelection: moveSelection, select: select } = (0, $dfcd2f458918c5ae$export$deb5cc6ef1318024)(searchText, flatBindings, (binding)=>binding.description);
    function runBindingAndClose(filteredIndex) {
        if (results[filteredIndex] !== undefined) {
            close();
            if (focusBefore instanceof HTMLElement) focusBefore.focus();
            results[filteredIndex].candidate.action();
        }
    }
    function runBinding(filteredIndex) {
        if (results[filteredIndex] !== undefined) {
            results[filteredIndex].candidate.action();
            queueEffect(()=>{
                inputRef.current?.focus();
            });
        }
    }
    function dismiss() {
        if (searchText === "") {
            close();
            if (focusBefore instanceof HTMLElement) focusBefore.focus();
        } else setSearchText("");
    }
    const localBindings = [
        {
            bindings: [
                [
                    [
                        "ArrowUp",
                        "C-P"
                    ],
                    "none",
                    "prev result",
                    ()=>{
                        moveSelection(-1);
                    }
                ],
                [
                    [
                        "ArrowDown",
                        "C-N"
                    ],
                    "none",
                    "next result",
                    ()=>{
                        moveSelection(1);
                    }
                ]
            ]
        },
        {
            bindings: [
                [
                    [
                        "Enter"
                    ],
                    "none",
                    "run & close",
                    ()=>{
                        runBindingAndClose(selected);
                    }
                ],
                [
                    [
                        "Alt-Enter"
                    ],
                    "none",
                    "run",
                    ()=>{
                        runBinding(selected);
                    }
                ]
            ]
        },
        {
            bindings: [
                [
                    [
                        "Escape"
                    ],
                    "none",
                    "dismiss",
                    ()=>{
                        dismiss();
                    }
                ]
            ]
        }
    ];
    const handleKeybindings = (0, $5bc960417406f657$export$a54803f24a0921f3)(localBindings);
    function onClickDismiss(ev) {
        if (ev.currentTarget === ev.target) dismiss();
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "absolute z-50 inset-0 h-full bg-gray-300/30 py-10 px-2 overflow-hidden print:hidden",
        onClick: onClickDismiss,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "w-full md:w-2/3 mx-auto max-h-full overflow-auto shadow-xl border border-gray-200 bg-white rounded-lg min-h-0 flex flex-col items-stretch",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                    ref: inputRef,
                    type: "text",
                    autoFocus: true,
                    placeholder: "Search commands",
                    className: "p-5 bg-transparent focus:outline-none border-b border-gray-200",
                    value: searchText,
                    onChange: (ev)=>setSearchText(ev.target.value),
                    onKeyDown: handleKeybindings
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "overflow-y-auto divide-y divide-gray-200",
                    children: [
                        results.length === 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "text-gray-700 px-5 py-3",
                            children: "No results for the current focus"
                        }),
                        results.map((result, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                ref: setRef(result.id),
                                className: `
                                space-x-3 px-5 py-3
                                cursor-pointer text-left ${index === selected && "bg-gray-200"}
                            `,
                                onPointerEnter: ()=>select(index),
                                onClick: ()=>{
                                    runBindingAndClose(index);
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "text-gray-500 text-sm",
                                        children: result.candidate.group
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: (0, $dfcd2f458918c5ae$export$2484ee4456d34df7)(result.match)
                                    }),
                                    index === selected && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5bc960417406f657$export$95fe205332e7931c), {
                                        className: "text-sm",
                                        keyName: "Enter"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "space-x-1 text-sm float-end",
                                        children: (0, $512ec8d668819b2f$export$af200dcf8b7cb5de)(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            children: "/"
                                        }), result.candidate.keys.map((k)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5bc960417406f657$export$299640fc954ba1db), {
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5bc960417406f657$export$214722d3fd34b95f), {
                                                    shortcut: k
                                                })
                                            })))
                                    })
                                ]
                            }, result.id))
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "flex flex-row items-center justify-between h-8 space-x-6 px-5 py-1 border-t border-gray-200 bg-gray-100 overflow-x-auto",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5bc960417406f657$export$a9a3fd41d8e3fc63), {
                        flat: true,
                        allbindings: localBindings
                    })
                })
            ]
        })
    });
}




var $acw62 = parcelRequire("acw62");



function $d16c6eb40739a961$export$4354f8b0f0e23ee4(initState) {
    return {
        mode: {
            type: "current"
        },
        history: [
            {
                time: new Date(),
                state: initState
            }
        ],
        inner: initState
    };
}
function $d16c6eb40739a961$export$5511957981ea5d3d(dispatch, env, fromJSON) {
    return function dispatchInner(action) {
        dispatch((state, context)=>(0, $6f23581c0aef6dc2$export$b6ca37fc03181c21)(action, (pureAction)=>$d16c6eb40739a961$export$b4dce3aba232bc77(state, (inner)=>pureAction(inner, context), env, fromJSON)));
    };
}
function $d16c6eb40739a961$export$b4dce3aba232bc77(state, action, env, fromJSON) {
    switch(state.mode.type){
        case "current":
            {
                const newInner = action(state.inner);
                return {
                    ...state,
                    history: $d16c6eb40739a961$export$74eed7e39355de3d([
                        ...state.history,
                        {
                            time: new Date(),
                            state: newInner,
                            prev: state.history[0]?.time
                        }
                    ]),
                    inner: newInner
                };
            }
        case "history":
            {
                const entryInHistory = state.history[state.mode.position];
                if (entryInHistory === undefined) return state;
                const stateInHistory = $d16c6eb40739a961$export$1bf2d76e8fd88dc0(entryInHistory, env, fromJSON);
                const newInner = action(stateInHistory);
                return {
                    mode: {
                        type: "current"
                    },
                    history: $d16c6eb40739a961$export$74eed7e39355de3d([
                        ...state.history,
                        {
                            time: new Date(),
                            state: newInner,
                            prev: entryInHistory.time
                        }
                    ]),
                    inner: newInner
                };
            }
    }
}
function $d16c6eb40739a961$export$d533be0028bf978d(state, env, fromJSON) {
    switch(state.mode.type){
        case "current":
            return state.inner;
        case "history":
            {
                const entryInHistory = state.history[state.mode.position];
                if (entryInHistory === undefined) return state.inner;
                const stateInHistory = $d16c6eb40739a961$export$1bf2d76e8fd88dc0(entryInHistory, env, fromJSON);
                return stateInHistory;
            }
    }
}
function $d16c6eb40739a961$export$3e14a276c7f0d479(state) {
    if (state.history.length <= 1) return state;
    return {
        ...state,
        mode: {
            type: "history",
            position: state.history.length - 2
        }
    };
}
function $d16c6eb40739a961$export$181a649d919c589e(state) {
    return {
        ...state,
        mode: {
            type: "current"
        }
    };
}
function $d16c6eb40739a961$export$41b5b6a2bef3753b(steps, state) {
    if (state.mode.type !== "history") return state;
    return {
        ...state,
        mode: {
            ...state.mode,
            position: (0, $512ec8d668819b2f$export$d17171af8942fb21)(0, state.history.length, state.mode.position + steps)
        }
    };
}
function $d16c6eb40739a961$export$2f0af4fc22122d93(state, env, fromJSON) {
    if (state.mode.type === "current") return state;
    const historicState = {
        ...state.history[state.mode.position],
        time: new Date()
    };
    return {
        ...state,
        mode: {
            type: "current"
        },
        history: [
            ...state.history,
            historicState
        ],
        inner: $d16c6eb40739a961$export$1bf2d76e8fd88dc0(historicState, env, fromJSON)
    };
}
function $d16c6eb40739a961$export$1bf2d76e8fd88dc0(entry, env, fromJSON) {
    return entry.state;
}
function $d16c6eb40739a961$export$97d9bbfce4fb52e9(historyWrapper, toJSON) {
    return {
        history: [],
        inner: toJSON(historyWrapper.inner)
    };
}
function $d16c6eb40739a961$export$cf051384706afd3b(json, env, fromJSON) {
    return $d16c6eb40739a961$export$4354f8b0f0e23ee4(fromJSON(json.inner, env));
}
function $d16c6eb40739a961$export$74eed7e39355de3d(history) {
    const now = Date.now();
    let entries = [
        ...history
    ].reverse();
    let currentEntry = entries.splice(0, 1)[0];
    const reducedEntries = [
        currentEntry
    ];
    while(entries.length > 0){
        const optimalNextEntryTime = currentEntry.time.getTime() - (now - currentEntry.time.getTime()) / 12;
        const lastEntryBeforeOptimalTime = entries.filter((entry)=>entry.time.getTime() > optimalNextEntryTime).slice(-1)[0];
        const lastEntryBeforeTimeDiff = lastEntryBeforeOptimalTime === undefined ? Number.POSITIVE_INFINITY : lastEntryBeforeOptimalTime.time.getTime() - optimalNextEntryTime;
        const firstEntryAfterOptimalTime = entries.find((entry)=>entry.time.getTime() < optimalNextEntryTime) ?? entries.slice(-1)[0] // fall back to just keeping the last (oldest/first) history entry
        ;
        const firstEntryAfterTimeDiff = optimalNextEntryTime - firstEntryAfterOptimalTime.time.getTime();
        const nextEntry = lastEntryBeforeTimeDiff < firstEntryAfterTimeDiff ? lastEntryBeforeOptimalTime : firstEntryAfterOptimalTime;
        const nextEntryIndex = entries.findIndex((entry)=>entry.time.getTime() === nextEntry.time.getTime());
        currentEntry = nextEntry;
        entries.splice(0, nextEntryIndex + 1);
        reducedEntries.push(nextEntry);
    }
    return reducedEntries.reverse();
}
function $d16c6eb40739a961$export$7302fe062d1000a6({ state: state, dispatch: dispatch, children: viewInner, env: env, fromJSON: fromJSON }) {
    // capture undo/redo, so no other component starts its own undo/redo logic
    function onKeyDownHistory(event) {
        switch((0, $777d0014849a8f55$export$ebf72dfe5a040886)(event)){
            case "C-Z":
                dispatch((state)=>({
                        state: $d16c6eb40739a961$export$41b5b6a2bef3753b(-1, state),
                        description: "undo"
                    }));
                event.stopPropagation();
                event.preventDefault();
                return;
            case "C-Shift-Z":
            case "C-Y":
                dispatch((state)=>({
                        state: $d16c6eb40739a961$export$41b5b6a2bef3753b(1, state),
                        description: "redo"
                    }));
                event.stopPropagation();
                event.preventDefault();
                return;
        }
    }
    function onKeyDownCurrent(event) {
        switch((0, $777d0014849a8f55$export$ebf72dfe5a040886)(event)){
            case "C-Z":
                dispatch((state)=>({
                        state: $d16c6eb40739a961$export$3e14a276c7f0d479(state),
                        description: "undo"
                    }));
                event.stopPropagation();
                event.preventDefault();
                return;
        }
    }
    const dispatchInner = $acw62.useMemo(()=>$d16c6eb40739a961$export$5511957981ea5d3d(dispatch, env, fromJSON), [
        env,
        fromJSON
    ]);
    switch(state.mode.type){
        case "current":
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "h-full w-full print:h-fit",
                onKeyDownCapture: onKeyDownCurrent,
                children: viewInner({
                    state: state.inner,
                    dispatch: dispatchInner,
                    dispatchHistory: dispatch
                })
            });
        case "history":
            const entryInHistory = state.history[state.mode.position];
            if (entryInHistory === undefined) return null;
            const stateInHistory = $d16c6eb40739a961$export$1bf2d76e8fd88dc0(entryInHistory, env, fromJSON);
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "h-full w-full print:h-fit",
                onKeyDownCapture: onKeyDownHistory,
                children: viewInner({
                    state: stateInHistory,
                    dispatch: dispatchInner,
                    dispatchHistory: dispatch
                })
            });
    }
}



var $3c46c1595c7e1ab8$exports = {};
$3c46c1595c7e1ab8$exports = new URL("logo-small.95cfdde8.svg", import.meta.url).toString();


const $70e75050ef1824a9$var$logoSmallSvg = new URL($3c46c1595c7e1ab8$exports);
function $70e75050ef1824a9$var$ACTIONS(dispatch, dispatchHistory, innerBlock, queryRecompute) {
    const dispatchPages = (0, $d0f575b1326e7f91$export$f153e5abd026c378)("pages", dispatch);
    return {
        dispatchPage (path, action) {
            dispatch((doc, context)=>(0, $6f23581c0aef6dc2$export$b6ca37fc03181c21)(action, (pureAction)=>$ee99fa6430885fc2$export$5813b750fe20a278(path, doc, pureAction, context.env, innerBlock)));
            queryRecompute(path);
        },
        reset () {
            dispatch(()=>({
                    state: $ee99fa6430885fc2$export$2cd8252107eb640b(innerBlock.init),
                    description: "cleared file"
                }));
        },
        save () {
            dispatchHistory((state)=>{
                const content = JSON.stringify($d16c6eb40739a961$export$97d9bbfce4fb52e9(state, (doc)=>$9d7e60768dbfb647$export$54fd2c36b5cc6731(doc, innerBlock)));
                (0, $777d0014849a8f55$export$e620933a198f7bc)("ReSheet.json", new Blob([
                    content
                ], {
                    type: "application/json"
                }));
                return {
                    state: state,
                    description: "saved file"
                };
            });
        },
        async loadLocalFile (file) {
            const content = JSON.parse(await file.text());
            dispatchHistory((_state, { env: env })=>{
                try {
                    const newState = $d16c6eb40739a961$export$cf051384706afd3b(content, env, (json, env)=>$ee99fa6430885fc2$export$21625637effda04(json, dispatch, env, innerBlock));
                    return {
                        state: newState,
                        description: `loaded document from local file "${file.name}"`
                    };
                } catch (e) {
                    window.alert(`Could not load file: ${e}`);
                }
            });
        },
        async loadRemoteFile () {
            const url = window.prompt("Which URL should be loaded?");
            if (url === null) return;
            try {
                const response = await fetch(url);
                const content = await response.json();
                dispatchHistory((_state, { env: env })=>{
                    try {
                        const newState = $d16c6eb40739a961$export$cf051384706afd3b(content, env, (json, env)=>$ee99fa6430885fc2$export$21625637effda04(json, dispatch, env, innerBlock));
                        return {
                            state: newState,
                            description: `loaded document from url "${url}"`
                        };
                    } catch (e) {
                        window.alert(`Could not parse file from URL: ${e}`);
                    }
                });
            } catch (e) {
                window.alert(`Could not load file from URL: ${e}`);
            }
        },
        useAsTempate (path) {
            dispatch((doc)=>({
                    state: {
                        ...doc,
                        template: $ea3d541d2f2fc6fe$export$a12370985d3b367(path, doc.pages) ?? doc.template
                    },
                    description: "saved current page as template"
                }));
        },
        addPage (path) {
            dispatch((doc)=>({
                    state: $ee99fa6430885fc2$export$bcc445b1fd74503c(path, doc),
                    description: "added new page"
                }));
        },
        deletePage (path) {
            dispatch((doc, { env: env })=>({
                    state: $ee99fa6430885fc2$export$769f13194e872724(path, doc, innerBlock, env, dispatch),
                    description: "deleted page"
                }));
        },
        setPageName (path, name) {
            dispatch((doc, { env: env })=>{
                return {
                    state: {
                        ...doc,
                        pages: $ea3d541d2f2fc6fe$export$7a67d5096c18e401(path, doc.pages, (page)=>({
                                ...page,
                                name: name
                            }), env, innerBlock, dispatchPages)
                    }
                };
            });
        },
        nestPage (path) {
            dispatch((doc, { env: env })=>{
                const [newPath, pages] = $ea3d541d2f2fc6fe$export$ba53fb6ee6a1097f(path, doc.pages, env, innerBlock, dispatchPages);
                return {
                    state: {
                        ...doc,
                        pages: pages,
                        viewState: {
                            ...doc.viewState,
                            openPage: newPath
                        }
                    }
                };
            });
        },
        unnestPage (path) {
            dispatch((doc, { env: env })=>{
                const [newPath, pages] = $ea3d541d2f2fc6fe$export$3966830784117211(path, doc.pages, env, innerBlock, dispatchPages);
                return {
                    state: {
                        ...doc,
                        pages: pages,
                        viewState: {
                            ...doc.viewState,
                            openPage: newPath
                        }
                    }
                };
            });
        },
        movePage (delta, path) {
            dispatch((doc, { env: env })=>{
                return {
                    state: {
                        ...doc,
                        pages: $ea3d541d2f2fc6fe$export$c90f31335c54e820(delta, path, doc.pages, innerBlock, env, dispatchPages)
                    }
                };
            });
        },
        openPage (path) {
            dispatch((doc)=>({
                    state: $ee99fa6430885fc2$export$c71f8f524af5213e(path, doc)
                }));
        },
        openFirstChild (currentPath) {
            dispatch((doc)=>{
                const parent = $ea3d541d2f2fc6fe$export$a12370985d3b367(currentPath, doc.pages);
                if (parent === null || parent.children.length === 0) return {
                    state: doc
                };
                const path = [
                    ...currentPath,
                    parent.children[0].id
                ];
                return {
                    state: $ee99fa6430885fc2$export$c71f8f524af5213e(path, doc)
                };
            });
        },
        openParent (currentPath) {
            if (currentPath.length > 1) dispatch((inner)=>({
                    state: $ee99fa6430885fc2$export$c71f8f524af5213e(currentPath.slice(0, -1), inner)
                }));
        },
        openNextPage (currentPath) {
            dispatch((state)=>{
                const allPaths = $ea3d541d2f2fc6fe$export$65bbd8e473548251(state.pages, currentPath);
                const openPageIndex = allPaths.findIndex((somePath)=>(0, $512ec8d668819b2f$export$22d6d01dd47e89dd)(somePath, currentPath));
                const nextPageIndex = (0, $512ec8d668819b2f$export$d17171af8942fb21)(0, allPaths.length, openPageIndex + 1);
                const newPath = allPaths[nextPageIndex];
                if (!newPath) return {
                    state: state
                };
                return {
                    state: $ee99fa6430885fc2$export$c71f8f524af5213e(newPath, state)
                };
            });
        },
        openPrevPage (currentPath) {
            dispatch((state)=>{
                const allPaths = $ea3d541d2f2fc6fe$export$65bbd8e473548251(state.pages, currentPath);
                const openPageIndex = allPaths.findIndex((somePath)=>(0, $512ec8d668819b2f$export$22d6d01dd47e89dd)(somePath, currentPath));
                const prevPageIndex = (0, $512ec8d668819b2f$export$d17171af8942fb21)(0, allPaths.length, openPageIndex - 1);
                const newPath = allPaths[prevPageIndex];
                if (!newPath) return {
                    state: state
                };
                return {
                    state: $ee99fa6430885fc2$export$c71f8f524af5213e(newPath, state)
                };
            });
        },
        toggleCollapsed (path) {
            dispatch((state, { env: env })=>{
                return {
                    state: {
                        ...state,
                        pages: $ea3d541d2f2fc6fe$export$7a67d5096c18e401(path, state.pages, (page)=>({
                                ...page,
                                isCollapsed: !page.isCollapsed
                            }), env, innerBlock, dispatchPages)
                    }
                };
            });
        },
        toggleSidebar () {
            dispatch((state)=>({
                    state: (0, $f32fb19553378b7c$export$f3e3cd1fc9c33ca1)(state, [
                        "viewState",
                        "sidebarOpen"
                    ], (open)=>!open)
                }));
        },
        setSidebarOpen (open) {
            dispatch((state)=>({
                    state: (0, $417ec453c2fca3b4$export$e6bdf135a54e021b)(state, [
                        "viewState",
                        "sidebarOpen"
                    ], open)
                }));
        },
        copy (page, innerBlock, putIntoClipboard) {
            putIntoClipboard("application/x.resheet-page", JSON.stringify($9d7e60768dbfb647$export$b5298ef9fe6bcf1(page, innerBlock)));
        },
        paste (json, innerBlock) {
            const dispatchPages = (0, $d0f575b1326e7f91$export$f153e5abd026c378)("pages", dispatch);
            dispatch((state, { env: env })=>{
                try {
                    const openPage = $ee99fa6430885fc2$export$d99fd09303be89f2(state);
                    const newId = $9d52f07a71ba7cea$export$fba3009e3ea7651a(openPage.children);
                    function updateInsertedPageState(path, action) {
                        // monkey-patch the path to use the new assigned `newId` instead of the id from the loaded json
                        const fullPath = [
                            ...state.viewState.openPage,
                            newId,
                            ...path.slice(1)
                        ];
                        $ea3d541d2f2fc6fe$export$f009d12f262e197f(fullPath, dispatchPages, action, innerBlock);
                    }
                    const loadedPage = $9d7e60768dbfb647$export$24bd15d4096a8848(json, updateInsertedPageState, env, innerBlock, []);
                    const page = {
                        ...loadedPage,
                        id: newId
                    };
                    return {
                        state: $ee99fa6430885fc2$export$bcc445b1fd74503c(state.viewState.openPage, state, page)
                    };
                } catch (error) {
                    console.error("Could not paste Page", {
                        error: error,
                        state: state
                    });
                    return {
                        state: state
                    };
                }
            });
        }
    };
}
const $70e75050ef1824a9$var$commandSearchBinding = (localActions)=>[
        [
            "C-K",
            "C-Shift-P"
        ],
        "none",
        "search commands",
        ()=>{
            localActions.toggleSearch();
        }
    ];
function $70e75050ef1824a9$var$DocumentKeyBindings(state, actions, containerRef, innerRef, localActions) {
    return [
        {
            description: "create / delete pages",
            bindings: [
                [
                    // not sure about capturing this...
                    [
                        "C-KeyN"
                    ],
                    "!inputFocused",
                    "new page",
                    ()=>{
                        actions.addPage(state.viewState.openPage.slice(0, -1));
                        localActions.setIsNameEditing(true);
                    }
                ],
                [
                    [
                        "C-Shift-KeyN"
                    ],
                    "none",
                    "new child page",
                    ()=>{
                        actions.addPage(state.viewState.openPage);
                        localActions.setIsNameEditing(true);
                    }
                ],
                [
                    [
                        "C-Backspace"
                    ],
                    "selfFocused",
                    "delete page",
                    ()=>{
                        actions.deletePage(state.viewState.openPage);
                    }
                ]
            ]
        },
        {
            description: "move pages",
            bindings: [
                [
                    [
                        "C-Shift-KeyK",
                        "C-Shift-ArrowUp"
                    ],
                    "selfFocused",
                    "move page up",
                    ()=>{
                        actions.movePage(-1, state.viewState.openPage);
                    }
                ],
                [
                    [
                        "C-Shift-KeyJ",
                        "C-Shift-ArrowDown"
                    ],
                    "selfFocused",
                    "move page down",
                    ()=>{
                        actions.movePage(1, state.viewState.openPage);
                    }
                ],
                [
                    [
                        "C-Shift-KeyH",
                        "C-Shift-ArrowLeft"
                    ],
                    "selfFocused",
                    "move page one level up",
                    ()=>{
                        actions.unnestPage(state.viewState.openPage);
                    }
                ],
                [
                    [
                        "C-Shift-KeyL",
                        "C-Shift-ArrowRight"
                    ],
                    "selfFocused",
                    "move page one level down",
                    ()=>{
                        actions.nestPage(state.viewState.openPage);
                    }
                ]
            ]
        },
        {
            description: "move between pages",
            bindings: [
                [
                    [
                        "KeyK",
                        "ArrowUp"
                    ],
                    "selfFocused",
                    "open prev page",
                    ()=>{
                        actions.openPrevPage(state.viewState.openPage);
                    }
                ],
                [
                    [
                        "KeyJ",
                        "ArrowDown"
                    ],
                    "selfFocused",
                    "open next page",
                    ()=>{
                        actions.openNextPage(state.viewState.openPage);
                    }
                ],
                [
                    [
                        "KeyL",
                        "ArrowRight"
                    ],
                    "selfFocused",
                    "open first child page",
                    ()=>{
                        actions.openFirstChild(state.viewState.openPage);
                    }
                ],
                [
                    [
                        "KeyH",
                        "ArrowLeft"
                    ],
                    "selfFocused",
                    "open parent page",
                    ()=>{
                        actions.openParent(state.viewState.openPage);
                    }
                ]
            ]
        },
        {
            description: "change page",
            bindings: [
                [
                    [
                        "C-Shift-KeyR"
                    ],
                    "selfFocused",
                    "edit page name",
                    ()=>{
                        localActions.setIsNameEditing(true);
                    }
                ],
                [
                    [
                        "Space"
                    ],
                    "selfFocused",
                    "toggle page collapsed",
                    ()=>{
                        actions.toggleCollapsed(state.viewState.openPage);
                    }
                ],
                [
                    [
                        "C-Shift-KeyD"
                    ],
                    "none",
                    "safe as default template",
                    ()=>{
                        actions.useAsTempate(state.viewState.openPage);
                    }
                ]
            ]
        },
        {
            description: "files",
            bindings: [
                [
                    [
                        "C-KeyO"
                    ],
                    "none",
                    "open local file",
                    async ()=>{
                        actions.loadLocalFile(await (0, $777d0014849a8f55$export$195947546eb716de)());
                    }
                ],
                [
                    [
                        "C-KeyS"
                    ],
                    "none",
                    "save file",
                    ()=>{
                        actions.save();
                    }
                ]
            ]
        },
        {
            description: "view",
            bindings: [
                $70e75050ef1824a9$var$commandSearchBinding(localActions),
                [
                    [
                        "C-KeyB"
                    ],
                    "none",
                    "toggle sidebar",
                    ()=>{
                        actions.toggleSidebar();
                    }
                ],
                [
                    [
                        "Escape"
                    ],
                    "!selfFocused",
                    "focus sidebar",
                    ()=>{
                        actions.setSidebarOpen(true);
                        containerRef.current?.focus();
                    }
                ],
                [
                    [
                        "Enter"
                    ],
                    "selfFocused",
                    "focus page content",
                    ()=>{
                        innerRef.current?.focus();
                    }
                ]
            ]
        },
        {
            description: "help",
            bindings: [
                [
                    [
                        "C-Shift-Slash"
                    ],
                    "none",
                    "toggle shortcut suggestions",
                    ()=>{
                        localActions.toggleShortcutsVisible();
                    }
                ]
            ]
        }
    ];
}
function $70e75050ef1824a9$export$7692dd7fce48b403({ state: state, dispatch: dispatch, env: env, dispatchHistory: dispatchHistory, innerBlock: innerBlock, blockRef: blockRef }) {
    const containerRef = $acw62.useRef();
    const mainScrollRef = $acw62.useRef();
    const innerRef = $acw62.useRef();
    $acw62.useImperativeHandle(blockRef, ()=>({
            focus (options) {
                containerRef.current?.focus(options);
            }
        }));
    const [isNameEditing, setIsNameEditing] = $acw62.useState(false);
    const [shortcutsViewMode, setShortcutsViewMode] = $acw62.useState("hidden");
    const [search, setSearch] = $acw62.useState();
    const { getBindings: getBindings } = (0, $5bc960417406f657$export$9914e7ca655daf12)();
    const localActions = $acw62.useMemo(()=>({
            setIsNameEditing: setIsNameEditing,
            toggleShortcutsVisible () {
                setShortcutsViewMode((mode)=>(0, $512ec8d668819b2f$export$77e0d221223292dc)(mode, $70e75050ef1824a9$var$SHORTCUTS_VIEW_MODES));
            },
            toggleSearch () {
                setSearch((bindings)=>bindings === undefined ? getBindings() : undefined);
            }
        }), []);
    function onPaste(ev) {
        if (ev.clipboardData.types.includes("application/x.resheet-page")) {
            const json = JSON.parse(ev.clipboardData.getData("application/x.resheet-page"));
            actions.paste(json, innerBlock);
            ev.stopPropagation();
            ev.preventDefault();
        }
    }
    function onCopy(ev) {
        const selection = document.getSelection();
        const isTextSelected = selection.rangeCount > 0 && !selection.getRangeAt(0).collapsed;
        if (isTextSelected) return;
        const page = $ee99fa6430885fc2$export$d99fd09303be89f2(state);
        actions.copy(page, innerBlock, (type, content)=>{
            ev.clipboardData.setData(type, content);
            dispatch((state)=>({
                    state: state,
                    description: `Copied page "${page.name}" to the clipboard`
                }));
            ev.stopPropagation();
            ev.preventDefault();
        });
    }
    function onCut(ev) {
        const selection = document.getSelection();
        const isTextSelected = selection.rangeCount > 0 && !selection.getRangeAt(0).collapsed;
        if (isTextSelected) return;
        const page = $ee99fa6430885fc2$export$d99fd09303be89f2(state);
        actions.copy(page, innerBlock, (type, content)=>{
            ev.clipboardData.setData(type, content);
            actions.deletePage(state.viewState.openPage);
            ev.stopPropagation();
            ev.preventDefault();
        });
    }
    function onFinishEditingName() {
        containerRef.current.focus();
    }
    const queryRecompute = $acw62.useMemo(()=>(0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).debounce((path)=>dispatch((state, { env: env })=>({
                    state: $ee99fa6430885fc2$export$bb6ff48d725fca5e(path, state, env, innerBlock, dispatch)
                })), 5000), [
        dispatch,
        innerBlock
    ]);
    $acw62.useEffect(()=>{
        return ()=>queryRecompute.flush();
    }, [
        queryRecompute,
        state.viewState.openPage
    ]);
    const actions = $acw62.useMemo(()=>$70e75050ef1824a9$var$ACTIONS(dispatch, dispatchHistory, innerBlock, queryRecompute), [
        dispatch,
        dispatchHistory,
        innerBlock,
        queryRecompute
    ]);
    const bindings = $70e75050ef1824a9$var$DocumentKeyBindings(state, actions, containerRef, innerRef, localActions);
    const bindingProps = (0, $5bc960417406f657$export$a1ca853c6e4bb6fb)(bindings);
    $acw62.useEffect(()=>{
        mainScrollRef.current && mainScrollRef.current.scroll({
            top: 0,
            behavior: "instant"
        });
    }, [
        state.viewState.openPage
    ]);
    const sidebarVisible = state.viewState.sidebarOpen || isNameEditing;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        ref: containerRef,
        tabIndex: -1,
        ...bindingProps,
        onCopy: onCopy,
        onPaste: onPaste,
        onCut: onCut,
        className: "group/document-ui relative h-full w-full overflow-hidden outline-none print:h-fit print:overflow-visible",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($70e75050ef1824a9$var$Sidebar, {
                state: state,
                actions: actions,
                isVisible: sidebarVisible,
                isNameEditing: isNameEditing,
                setIsNameEditing: setIsNameEditing,
                commandBinding: $70e75050ef1824a9$var$commandSearchBinding(localActions),
                onFinishEditingName: onFinishEditingName
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($70e75050ef1824a9$var$SidebarButton, {
                sidebarVisible: sidebarVisible,
                toggleSidebar: actions.toggleSidebar
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: `
                    h-full
                    transition-[margin-left] ${sidebarVisible ? "md:ml-56" : ""}
                    flex flex-col items-stretch overflow-hidden
                    bg-gray-50
                    print:h-fit print:ml-0 print:bg-white
                `,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        ref: mainScrollRef,
                        className: "flex-1 overflow-y-auto transition-all print:h-fit",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($70e75050ef1824a9$var$MainView, {
                            innerRef: innerRef,
                            state: state,
                            actions: actions,
                            innerBlock: innerBlock,
                            env: env,
                            sidebarVisible: sidebarVisible
                        }, state.viewState.openPage.join("."))
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($70e75050ef1824a9$var$ShortcutsSuggestionsPanel, {
                        mode: shortcutsViewMode,
                        toggle: localActions.toggleShortcutsVisible
                    }),
                    search !== undefined && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $32a31d0dc687709a$export$82e214bd55812f44), {
                        bindings: search,
                        close: ()=>setSearch(undefined)
                    })
                ]
            })
        ]
    });
}
const $70e75050ef1824a9$var$SHORTCUTS_VIEW_MODES = [
    "full",
    "flat",
    "hidden"
];
function $70e75050ef1824a9$var$ShortcutsSuggestionsPanel({ mode: mode, toggle: toggle }) {
    // prevent changing focus, so keybindings for previously focused Block are shown
    function preventDefault(ev) {
        ev.preventDefault();
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            mode !== "hidden" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex flex-row w-full overflow-hidden items-end space-x-1 border-t-2 border-gray-100 print:hidden",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: `
                            flex-1 flex flex-row justify-between
                            ${mode === "flat" ? "space-x-8" : "space-x-20"}
                            px-10 py-1 overflow-x-auto
                        `,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5bc960417406f657$export$a9a3fd41d8e3fc63), {
                            flat: mode === "flat"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        className: `
                            ${mode !== "flat" && "absolute bottom-0 right-0"}
                            px-1 bg-gray-100 opacity-50 hover:opacity-100 transition rounded
                        `,
                        onPointerDown: preventDefault,
                        onClick: toggle,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e4ec753f5c716375$export$2b9260d4a45c8710), {
                            icon: $d8206b3ab2e65c05$export$f9395ef707603e40
                        })
                    })
                ]
            }),
            mode === "hidden" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                className: `
                        absolute bottom-3 right-3 w-8 h-8
                        rounded-full border border-gray-100 shadow
                        bg-transparent opacity-50 hover:opacity-100 hover:bg-white transition
                        flex justify-center items-center
                        text-sm
                        print:hidden
                    `,
                onPointerDown: preventDefault,
                onClick: toggle,
                children: "\u2318"
            })
        ]
    });
}
function $70e75050ef1824a9$var$MainView({ innerRef: innerRef, actions: actions, state: state, innerBlock: innerBlock, env: env, sidebarVisible: sidebarVisible }) {
    const openPage = $ee99fa6430885fc2$export$d99fd09303be89f2(state);
    const pageDeps = (0, $ff99259e85546794$export$b540f128867fb8a2)($ee99fa6430885fc2$export$20827ed15e8882d8(state), (l, r)=>(0, $512ec8d668819b2f$export$1ffefdb29429119e)(l, r, 1));
    const pageEnv = $acw62.useMemo(()=>$ee99fa6430885fc2$export$193537437f9d47dc(pageDeps, env, innerBlock), [
        pageDeps,
        env,
        innerBlock
    ]);
    const dispatchOpenPage = $acw62.useCallback((action)=>actions.dispatchPage(state.viewState.openPage, action), [
        state.viewState.openPage
    ]);
    const onFocus = $acw62.useCallback(function onFocus(ev) {
        if (!ev.currentTarget.contains(ev.relatedTarget) && document.body.clientWidth < 768) actions.setSidebarOpen(false);
    }, []);
    if (!openPage) {
        function Link({ onClick: onClick, children: children }) {
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                className: "font-medium cursor-pointer text-blue-800 hover:text-blue-600",
                onClick: onClick,
                children: children
            });
        }
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "h-full w-full flex justify-center items-center",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "my-20 text-center text-lg text-gray-900",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Link, {
                        onClick: ()=>actions.addPage([]),
                        children: "Add new Page"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                    "or select one from the",
                    " ",
                    state.viewState.sidebarOpen ? "Sidebar" : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Link, {
                        onClick: actions.toggleSidebar,
                        children: "Sidebar"
                    })
                ]
            })
        });
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: `mb-[20cqh] bg-white relative px-1 ${!sidebarVisible && "md:px-10"} print:px-10 print:mb-0`,
        onFocus: onFocus,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($70e75050ef1824a9$var$Breadcrumbs, {
                className: `sticky top-0 inset-x-0 z-30 md:static bg-white ${!sidebarVisible && "pl-8 md:pl-0"} print:hidden`,
                openPage: state.viewState.openPage,
                pages: state.pages,
                onOpenPage: actions.openPage
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(innerBlock.Component, {
                ref: innerRef,
                state: openPage.state,
                dispatch: dispatchOpenPage,
                env: pageEnv
            })
        ]
    });
}
function $70e75050ef1824a9$var$Breadcrumbs({ className: className, openPage: openPage, pages: pages, onOpenPage: onOpenPage }) {
    function pathToPages(path, pages, currentPath = []) {
        if (path.length === 0) return [];
        const page = pages.find((p)=>p.id === path[0]);
        if (!page) return pathToPages(path.slice(1), pages);
        return [
            [
                currentPath,
                page,
                pages
            ],
            ...pathToPages(path.slice(1), page.children, [
                ...currentPath,
                page.id
            ])
        ];
    }
    const pathPages = pathToPages(openPage, pages);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: `flex flex-row items-baseline py-1.5 -ml-1 text-gray-800 ${className}`,
        children: [
            pathPages.map(([path, page, siblings])=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($acw62.Fragment, {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $c9bfa4e2da6232f7$export$d9b273488cd8ce6f), {
                            as: "div",
                            className: "relative",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c9bfa4e2da6232f7$export$d9b273488cd8ce6f).Button, {
                                    className: "rounded px-1.5 -mx-0.5 text-gray-400 hover:text-gray-600 hover:bg-gray-200",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e4ec753f5c716375$export$2b9260d4a45c8710), {
                                        size: "xs",
                                        icon: $d8206b3ab2e65c05$export$6bce1afb61f2eb66
                                    })
                                }),
                                siblingsMenuItems(siblings, path)
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            className: "rounded px-1.5 -mx-0.5 truncate hover:bg-gray-200",
                            onClick: ()=>{
                                onOpenPage([
                                    ...path,
                                    page.id
                                ]);
                            },
                            children: $97abc9ea0b65aa17$export$7d9f7e9c1c02b41e(page)
                        })
                    ]
                }, path.join("."))),
            pathPages.slice(-1).map(([path, currentPage])=>currentPage.children.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $c9bfa4e2da6232f7$export$d9b273488cd8ce6f), {
                    as: "div",
                    className: "relative",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c9bfa4e2da6232f7$export$d9b273488cd8ce6f).Button, {
                            className: "rounded px-1.5 -mx-0.5 text-gray-400 hover:text-gray-600 hover:bg-gray-200",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e4ec753f5c716375$export$2b9260d4a45c8710), {
                                size: "xs",
                                icon: $d8206b3ab2e65c05$export$6bce1afb61f2eb66
                            })
                        }),
                        siblingsMenuItems(currentPage.children, [
                            ...path,
                            currentPage.id
                        ])
                    ]
                }, path.join(".") + ".children"))
        ]
    });
    function siblingsMenuItems(siblings, path) {
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c9bfa4e2da6232f7$export$d9b273488cd8ce6f).Items, {
            className: `
                    absolute -top-1 -right-1 translate-x-full z-10
                    whitespace-nowrap
                    rounded bg-white shadow
                    focus:outline-none overflow-hidden
                `,
            children: siblings.map((page)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c9bfa4e2da6232f7$export$d9b273488cd8ce6f).Item, {
                    children: ({ active: active })=>{
                        const pathHere = [
                            ...path,
                            page.id
                        ];
                        const isOpen = (0, $512ec8d668819b2f$export$28e46a10850766f0)(pathHere, openPage);
                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            className: `
                                        block w-full
                                        px-2 py-1 hover:bg-gray-200
                                        ${isOpen && "bg-gray-100"} ${active && "bg-gray-200"}
                                        text-left
                                    `,
                            onClick: ()=>{
                                onOpenPage(pathHere);
                            },
                            children: $97abc9ea0b65aa17$export$7d9f7e9c1c02b41e(page)
                        });
                    }
                }, page.id))
        });
    }
}
function $70e75050ef1824a9$var$SidebarButton({ sidebarVisible: sidebarVisible, toggleSidebar: toggleSidebar }) {
    if (sidebarVisible) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "absolute top-1.5 left-2 z-40 print:hidden",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
            className: "text-gray-900/25 hover:text-gray-900/75 transition text-lg",
            onClick: toggleSidebar,
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e4ec753f5c716375$export$2b9260d4a45c8710), {
                icon: $d8206b3ab2e65c05$export$36e9cf7887265da2
            })
        })
    });
}
function $70e75050ef1824a9$var$Sidebar({ state: state, actions: actions, isVisible: isVisible, isNameEditing: isNameEditing, setIsNameEditing: setIsNameEditing, onFinishEditingName: onFinishEditingName, commandBinding: commandBinding }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            isVisible && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "md:hidden absolute z-40 inset-0 w-full h-full bg-gray-700/20 print:hidden",
                onClick: actions.toggleSidebar
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $030a82c6b2bb6f00$export$be58926105124dd4), {
                show: isVisible,
                className: `
                    absolute inset-y-0 h-full left-0 z-40
                    flex flex-col space-y-1
                    whitespace-nowrap overflow-auto
                    bg-gray-100 shadow-2xl md:shadow-none
                    w-56
                    print:hidden
                `,
                enter: "transition-transform",
                enterFrom: "-translate-x-full",
                enterTo: "translate-x-0",
                leave: "transition-transform",
                leaveFrom: "translate-x-0",
                leaveTo: "-translate-x-full",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        className: `
                        absolute top-0 right-0
                        px-2 py-1 text-gray-400
                        hover:text-gray-800 hover:bg-gray-200
                    `,
                        onClick: actions.toggleSidebar,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e4ec753f5c716375$export$2b9260d4a45c8710), {
                            icon: $d8206b3ab2e65c05$export$2ebd565813951f81
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "group/sidebar-header pl-2 flex items-baseline",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                src: $70e75050ef1824a9$var$logoSmallSvg.toString(),
                                alt: "ReSheet Logo",
                                className: "inline h-4 mr-1.5 saturate-0 group-hover/sidebar-header:saturate-100 transition-all"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                className: "text-xl font-bold text-gray-500",
                                children: [
                                    "ReSheet ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "text-xs font-normal",
                                        children: "beta"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                className: "ml-2 text-gray-400 hover:text-blue-600",
                                href: "https://github.com/keenbug/ReSheet",
                                target: "_blank",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e4ec753f5c716375$export$2b9260d4a45c8710), {
                                    icon: $ef0249c5e48bf4e3$export$64e4bc4b496fbbdf,
                                    size: "sm",
                                    title: "ReSheet on GitHub"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                className: "ml-1.5 text-gray-400 hover:text-blue-600",
                                href: "https://discord.gg/TQePmKJNQP",
                                target: "_blank",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e4ec753f5c716375$export$2b9260d4a45c8710), {
                                    icon: $ef0249c5e48bf4e3$export$c8d4525a5e9ad3ad,
                                    size: "sm",
                                    title: "ReSheet on Discord"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "h-2"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($70e75050ef1824a9$var$CommandSearchButton, {
                        commandBinding: commandBinding
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "h-3"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($70e75050ef1824a9$var$SidebarMenu, {
                        state: state,
                        actions: actions
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {}),
                    state.pages.map((page)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ea3d541d2f2fc6fe$export$2e3a14fa5b062651, {
                            page: page,
                            openPage: state.viewState.openPage,
                            actions: actions,
                            isNameEditing: isNameEditing,
                            setIsNameEditing: setIsNameEditing,
                            onFinishEditingName: onFinishEditingName
                        }, page.id)),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                        className: "px-2 py-0.5 w-full text-left text-xs text-gray-400 hover:text-blue-700",
                        onClick: ()=>actions.addPage([]),
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                className: "inline-block px-0.5 w-6",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e4ec753f5c716375$export$2b9260d4a45c8710), {
                                        icon: $d8206b3ab2e65c05$export$a105e7b44ca0eb9e
                                    }),
                                    " "
                                ]
                            }),
                            "Add Page"
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "flex-1"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex flex-col items-center py-1",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", {
                                className: "font-mono text-xs text-gray-400 hover:text-blue-600",
                                href: `https://github.com/keenbug/ReSheet/actions/runs/${"23506754518"}`,
                                target: "_blank",
                                children: [
                                    "build ",
                                    "9f34ae61bf64e5ef985d50481840e9a9867092f9".slice(0, 6)
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                className: "font-mono text-xs text-gray-400 hover:text-blue-600",
                                href: "/legal_notice.html",
                                target: "_blank",
                                children: "LEGAL NOTICE"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
const $70e75050ef1824a9$var$CommandSearchButton = /*#__PURE__*/ $acw62.memo(function CommandSearchButton({ commandBinding: commandBinding }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
        className: `
                rounded-full mx-2 px-3 py-0.5
                flex flex-row items-baseline space-x-2
                bg-gray-200 text-gray-400 border border-gray-300 
                text-sm cursor-pointer
                hover:bg-gray-100 hover:text-gray-900 hover:border-gray-400
                transition
                group
            `,
        onPointerDown: (ev)=>{
            ev.preventDefault();
            commandBinding[3]();
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e4ec753f5c716375$export$2b9260d4a45c8710), {
                className: "text-gray-600 self-center",
                size: "sm",
                icon: $d8206b3ab2e65c05$export$34c8b97060c09ff
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                children: "Commands"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "flex-1 text-right",
                children: (0, $512ec8d668819b2f$export$af200dcf8b7cb5de)("/", commandBinding[0].map((k)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5bc960417406f657$export$214722d3fd34b95f), {
                        shortcut: k,
                        Key: (0, $5bc960417406f657$export$e0ce128c4d56328a)
                    }, k)))
            })
        ]
    });
});
const $70e75050ef1824a9$var$SidebarMenu = /*#__PURE__*/ $acw62.memo(function SidebarMenu({ actions: actions }) {
    function MenuItem(props) {
        const { as: Element = "button", children: children = null, ...restProps } = props;
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c9bfa4e2da6232f7$export$d9b273488cd8ce6f).Item, {
            children: ({ active: active })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Element, {
                    className: `block w-full px-2 py-1 text-left ${active && "bg-blue-200"}`,
                    ...restProps,
                    children: children
                })
        });
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $c9bfa4e2da6232f7$export$d9b273488cd8ce6f), {
        as: "div",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c9bfa4e2da6232f7$export$d9b273488cd8ce6f).Button, {
                as: $acw62.Fragment,
                children: ({ open: open })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        className: `
                            px-2 py-0.5 w-full text-left
                            ring-0 ring-blue-500 focus:ring-1
                            ${open ? "text-blue-50 bg-blue-500 hover:bg-blue-500" : "hover:text-blue-950 hover:bg-blue-200"}
                        `,
                        children: "File"
                    })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $c9bfa4e2da6232f7$export$d9b273488cd8ce6f).Items, {
                className: "w-full bg-gray-200 text-sm",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(MenuItem, {
                        onClick: actions.reset,
                        children: "New File"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(MenuItem, {
                        onClick: actions.save,
                        children: "Save File"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(MenuItem, {
                        as: (0, $777d0014849a8f55$export$b346deb0efaa17bd),
                        onLoad: actions.loadLocalFile,
                        children: "Load local File ..."
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(MenuItem, {
                        onClick: actions.loadRemoteFile,
                        children: "Load File from URL ..."
                    })
                ]
            })
        ]
    });
});



var $b8f588c17e3c1433$exports = {};

$parcel$export($b8f588c17e3c1433$exports, "isSafeBlock", () => $b8f588c17e3c1433$export$eff0252ee3375215);
$parcel$export($b8f588c17e3c1433$exports, "safeBlock", () => $b8f588c17e3c1433$export$e255fd3f9a510304);


var $acw62 = parcelRequire("acw62");
var $b749c8e203b309f1$exports = {};

$parcel$export($b749c8e203b309f1$exports, "ViewResult", () => $b749c8e203b309f1$export$aafb8a44cb285d8d);
$parcel$export($b749c8e203b309f1$exports, "ValueInspector", () => $b749c8e203b309f1$export$93660df4be02febf);
$parcel$export($b749c8e203b309f1$exports, "PromiseView", () => $b749c8e203b309f1$export$72768de54fcb5edc);
$parcel$export($b749c8e203b309f1$exports, "ErrorInspector", () => $b749c8e203b309f1$export$2fc8a3f9f50cb2d6);
$parcel$export($b749c8e203b309f1$exports, "ErrorBoundary", () => $b749c8e203b309f1$export$e926676385687eaf);
$parcel$export($b749c8e203b309f1$exports, "PromiseValueInspector", () => $b749c8e203b309f1$export$23406d4a6d3f9299);
$parcel$export($b749c8e203b309f1$exports, "FunctionInspector", () => $b749c8e203b309f1$export$ee198e66fec66e9);


var $acw62 = parcelRequire("acw62");
var $8ded0b3da2a2e917$exports = {};

$parcel$export($8ded0b3da2a2e917$exports, "chromeDark", () => $8ded0b3da2a2e917$export$5529d9c8d8ea34e8);
$parcel$export($8ded0b3da2a2e917$exports, "chromeLight", () => $8ded0b3da2a2e917$export$9b8c68f2645bda6);
$parcel$export($8ded0b3da2a2e917$exports, "ObjectName", () => $8ded0b3da2a2e917$export$8e2f7a5ced0303a6);
$parcel$export($8ded0b3da2a2e917$exports, "ObjectValue", () => $8ded0b3da2a2e917$export$7b660e20faa35e02);
$parcel$export($8ded0b3da2a2e917$exports, "ObjectPreview", () => $8ded0b3da2a2e917$export$c09c4c234b3ce309);
$parcel$export($8ded0b3da2a2e917$exports, "ObjectRootLabel", () => $8ded0b3da2a2e917$export$1563f34270936445);
$parcel$export($8ded0b3da2a2e917$exports, "ObjectLabel", () => $8ded0b3da2a2e917$export$b4cc347f09904bef);
$parcel$export($8ded0b3da2a2e917$exports, "ObjectInspector", () => $8ded0b3da2a2e917$export$6e58e9313a6c4e66);
$parcel$export($8ded0b3da2a2e917$exports, "TableInspector", () => $8ded0b3da2a2e917$export$c86cf7731966ed43);
$parcel$export($8ded0b3da2a2e917$exports, "Inspector", () => $8ded0b3da2a2e917$export$b00d1c5d070816cc);

var $acw62 = parcelRequire("acw62");
var $8ded0b3da2a2e917$var$__create = Object.create;
var $8ded0b3da2a2e917$var$__defProp = Object.defineProperty;
var $8ded0b3da2a2e917$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $8ded0b3da2a2e917$var$__getOwnPropNames = Object.getOwnPropertyNames;
var $8ded0b3da2a2e917$var$__getProtoOf = Object.getPrototypeOf;
var $8ded0b3da2a2e917$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $8ded0b3da2a2e917$var$__commonJS = (cb, mod)=>function __require() {
        return mod || (0, cb[$8ded0b3da2a2e917$var$__getOwnPropNames(cb)[0]])((mod = {
            exports: {}
        }).exports, mod), mod.exports;
    };
var $8ded0b3da2a2e917$var$__export = (target, all)=>{
    for(var name in all)$8ded0b3da2a2e917$var$__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var $8ded0b3da2a2e917$var$__copyProps = (to, from, except, desc)=>{
    if (from && typeof from === "object" || typeof from === "function") {
        for (let key of $8ded0b3da2a2e917$var$__getOwnPropNames(from))if (!$8ded0b3da2a2e917$var$__hasOwnProp.call(to, key) && key !== except) $8ded0b3da2a2e917$var$__defProp(to, key, {
            get: ()=>from[key],
            enumerable: !(desc = $8ded0b3da2a2e917$var$__getOwnPropDesc(from, key)) || desc.enumerable
        });
    }
    return to;
};
var $8ded0b3da2a2e917$var$__toESM = (mod, isNodeMode, target)=>(target = mod != null ? $8ded0b3da2a2e917$var$__create($8ded0b3da2a2e917$var$__getProtoOf(mod)) : {}, $8ded0b3da2a2e917$var$__copyProps(isNodeMode || !mod || !mod.__esModule ? $8ded0b3da2a2e917$var$__defProp(target, "default", {
        value: mod,
        enumerable: true
    }) : target, mod));
// node_modules/is-object/index.js
var $8ded0b3da2a2e917$var$require_is_object = $8ded0b3da2a2e917$var$__commonJS({
    "node_modules/is-object/index.js" (exports, module) {
        "use strict";
        module.exports = function isObject(x) {
            return typeof x === "object" && x !== null;
        };
    }
});
// node_modules/is-window/index.js
var $8ded0b3da2a2e917$var$require_is_window = $8ded0b3da2a2e917$var$__commonJS({
    "node_modules/is-window/index.js" (exports, module) {
        "use strict";
        module.exports = function(obj) {
            if (obj == null) return false;
            var o = Object(obj);
            return o === o.window;
        };
    }
});
// node_modules/is-dom/index.js
var $8ded0b3da2a2e917$var$require_is_dom = $8ded0b3da2a2e917$var$__commonJS({
    "node_modules/is-dom/index.js" (exports, module) {
        var isObject = $8ded0b3da2a2e917$var$require_is_object();
        var isWindow = $8ded0b3da2a2e917$var$require_is_window();
        function isNode(val) {
            if (!isObject(val) || !isWindow(window) || typeof window.Node !== "function") return false;
            return typeof val.nodeType === "number" && typeof val.nodeName === "string";
        }
        module.exports = isNode;
    }
});
// src/styles/themes/index.tsx
var $8ded0b3da2a2e917$var$themes_exports = {};
$8ded0b3da2a2e917$var$__export($8ded0b3da2a2e917$var$themes_exports, {
    chromeDark: ()=>$8ded0b3da2a2e917$export$5529d9c8d8ea34e8,
    chromeLight: ()=>$8ded0b3da2a2e917$export$9b8c68f2645bda6
});
// src/styles/themes/chromeDark.tsx
var $8ded0b3da2a2e917$export$5529d9c8d8ea34e8 = {
    BASE_FONT_FAMILY: "Menlo, monospace",
    BASE_FONT_SIZE: "11px",
    BASE_LINE_HEIGHT: 1.2,
    BASE_BACKGROUND_COLOR: "rgb(36, 36, 36)",
    BASE_COLOR: "rgb(213, 213, 213)",
    OBJECT_PREVIEW_ARRAY_MAX_PROPERTIES: 10,
    OBJECT_PREVIEW_OBJECT_MAX_PROPERTIES: 5,
    OBJECT_NAME_COLOR: "rgb(227, 110, 236)",
    OBJECT_VALUE_NULL_COLOR: "rgb(127, 127, 127)",
    OBJECT_VALUE_UNDEFINED_COLOR: "rgb(127, 127, 127)",
    OBJECT_VALUE_REGEXP_COLOR: "rgb(233, 63, 59)",
    OBJECT_VALUE_STRING_COLOR: "rgb(233, 63, 59)",
    OBJECT_VALUE_SYMBOL_COLOR: "rgb(233, 63, 59)",
    OBJECT_VALUE_NUMBER_COLOR: "hsl(252, 100%, 75%)",
    OBJECT_VALUE_BOOLEAN_COLOR: "hsl(252, 100%, 75%)",
    OBJECT_VALUE_FUNCTION_PREFIX_COLOR: "rgb(85, 106, 242)",
    HTML_TAG_COLOR: "rgb(93, 176, 215)",
    HTML_TAGNAME_COLOR: "rgb(93, 176, 215)",
    HTML_TAGNAME_TEXT_TRANSFORM: "lowercase",
    HTML_ATTRIBUTE_NAME_COLOR: "rgb(155, 187, 220)",
    HTML_ATTRIBUTE_VALUE_COLOR: "rgb(242, 151, 102)",
    HTML_COMMENT_COLOR: "rgb(137, 137, 137)",
    HTML_DOCTYPE_COLOR: "rgb(192, 192, 192)",
    ARROW_COLOR: "rgb(145, 145, 145)",
    ARROW_MARGIN_RIGHT: 3,
    ARROW_FONT_SIZE: 12,
    ARROW_ANIMATION_DURATION: "0",
    TREENODE_FONT_FAMILY: "Menlo, monospace",
    TREENODE_FONT_SIZE: "11px",
    TREENODE_LINE_HEIGHT: 1.2,
    TREENODE_PADDING_LEFT: 12,
    TABLE_BORDER_COLOR: "rgb(85, 85, 85)",
    TABLE_TH_BACKGROUND_COLOR: "rgb(44, 44, 44)",
    TABLE_TH_HOVER_COLOR: "rgb(48, 48, 48)",
    TABLE_SORT_ICON_COLOR: "black",
    TABLE_DATA_BACKGROUND_IMAGE: "linear-gradient(rgba(255, 255, 255, 0), rgba(255, 255, 255, 0) 50%, rgba(51, 139, 255, 0.0980392) 50%, rgba(51, 139, 255, 0.0980392))",
    TABLE_DATA_BACKGROUND_SIZE: "128px 32px"
};
// src/styles/themes/chromeLight.tsx
var $8ded0b3da2a2e917$export$9b8c68f2645bda6 = {
    BASE_FONT_FAMILY: "Menlo, monospace",
    BASE_FONT_SIZE: "11px",
    BASE_LINE_HEIGHT: 1.2,
    BASE_BACKGROUND_COLOR: "white",
    BASE_COLOR: "black",
    OBJECT_PREVIEW_ARRAY_MAX_PROPERTIES: 10,
    OBJECT_PREVIEW_OBJECT_MAX_PROPERTIES: 5,
    OBJECT_NAME_COLOR: "rgb(136, 19, 145)",
    OBJECT_VALUE_NULL_COLOR: "rgb(128, 128, 128)",
    OBJECT_VALUE_UNDEFINED_COLOR: "rgb(128, 128, 128)",
    OBJECT_VALUE_REGEXP_COLOR: "rgb(196, 26, 22)",
    OBJECT_VALUE_STRING_COLOR: "rgb(196, 26, 22)",
    OBJECT_VALUE_SYMBOL_COLOR: "rgb(196, 26, 22)",
    OBJECT_VALUE_NUMBER_COLOR: "rgb(28, 0, 207)",
    OBJECT_VALUE_BOOLEAN_COLOR: "rgb(28, 0, 207)",
    OBJECT_VALUE_FUNCTION_PREFIX_COLOR: "rgb(13, 34, 170)",
    HTML_TAG_COLOR: "rgb(168, 148, 166)",
    HTML_TAGNAME_COLOR: "rgb(136, 18, 128)",
    HTML_TAGNAME_TEXT_TRANSFORM: "lowercase",
    HTML_ATTRIBUTE_NAME_COLOR: "rgb(153, 69, 0)",
    HTML_ATTRIBUTE_VALUE_COLOR: "rgb(26, 26, 166)",
    HTML_COMMENT_COLOR: "rgb(35, 110, 37)",
    HTML_DOCTYPE_COLOR: "rgb(192, 192, 192)",
    ARROW_COLOR: "#6e6e6e",
    ARROW_MARGIN_RIGHT: 3,
    ARROW_FONT_SIZE: 12,
    ARROW_ANIMATION_DURATION: "0",
    TREENODE_FONT_FAMILY: "Menlo, monospace",
    TREENODE_FONT_SIZE: "11px",
    TREENODE_LINE_HEIGHT: 1.2,
    TREENODE_PADDING_LEFT: 12,
    TABLE_BORDER_COLOR: "#aaa",
    TABLE_TH_BACKGROUND_COLOR: "#eee",
    TABLE_TH_HOVER_COLOR: "hsla(0, 0%, 90%, 1)",
    TABLE_SORT_ICON_COLOR: "#6e6e6e",
    TABLE_DATA_BACKGROUND_IMAGE: "linear-gradient(to bottom, white, white 50%, rgb(234, 243, 255) 50%, rgb(234, 243, 255))",
    TABLE_DATA_BACKGROUND_SIZE: "128px 32px"
};
var $8ded0b3da2a2e917$var$ExpandedPathsContext = (0, $acw62.createContext)([
    {},
    ()=>{}
]);
// src/styles/unselectable.tsx
var $8ded0b3da2a2e917$var$unselectable = {
    WebkitTouchCallout: "none",
    WebkitUserSelect: "none",
    KhtmlUserSelect: "none",
    MozUserSelect: "none",
    msUserSelect: "none",
    OUserSelect: "none",
    userSelect: "none"
};
// src/styles/base.tsx
var $8ded0b3da2a2e917$var$createTheme = (theme3)=>({
        DOMNodePreview: {
            htmlOpenTag: {
                base: {
                    color: theme3.HTML_TAG_COLOR
                },
                tagName: {
                    color: theme3.HTML_TAGNAME_COLOR,
                    textTransform: theme3.HTML_TAGNAME_TEXT_TRANSFORM
                },
                htmlAttributeName: {
                    color: theme3.HTML_ATTRIBUTE_NAME_COLOR
                },
                htmlAttributeValue: {
                    color: theme3.HTML_ATTRIBUTE_VALUE_COLOR
                }
            },
            htmlCloseTag: {
                base: {
                    color: theme3.HTML_TAG_COLOR
                },
                offsetLeft: {
                    marginLeft: -theme3.TREENODE_PADDING_LEFT
                },
                tagName: {
                    color: theme3.HTML_TAGNAME_COLOR,
                    textTransform: theme3.HTML_TAGNAME_TEXT_TRANSFORM
                }
            },
            htmlComment: {
                color: theme3.HTML_COMMENT_COLOR
            },
            htmlDoctype: {
                color: theme3.HTML_DOCTYPE_COLOR
            }
        },
        ObjectPreview: {
            objectDescription: {
                fontStyle: "italic"
            },
            preview: {
                fontStyle: "italic"
            },
            arrayMaxProperties: theme3.OBJECT_PREVIEW_ARRAY_MAX_PROPERTIES,
            objectMaxProperties: theme3.OBJECT_PREVIEW_OBJECT_MAX_PROPERTIES
        },
        ObjectName: {
            base: {
                color: theme3.OBJECT_NAME_COLOR
            },
            dimmed: {
                opacity: 0.6
            }
        },
        ObjectValue: {
            objectValueNull: {
                color: theme3.OBJECT_VALUE_NULL_COLOR
            },
            objectValueUndefined: {
                color: theme3.OBJECT_VALUE_UNDEFINED_COLOR
            },
            objectValueRegExp: {
                color: theme3.OBJECT_VALUE_REGEXP_COLOR
            },
            objectValueString: {
                color: theme3.OBJECT_VALUE_STRING_COLOR
            },
            objectValueSymbol: {
                color: theme3.OBJECT_VALUE_SYMBOL_COLOR
            },
            objectValueNumber: {
                color: theme3.OBJECT_VALUE_NUMBER_COLOR
            },
            objectValueBoolean: {
                color: theme3.OBJECT_VALUE_BOOLEAN_COLOR
            },
            objectValueFunctionPrefix: {
                color: theme3.OBJECT_VALUE_FUNCTION_PREFIX_COLOR,
                fontStyle: "italic"
            },
            objectValueFunctionName: {
                fontStyle: "italic"
            }
        },
        TreeView: {
            treeViewOutline: {
                padding: 0,
                margin: 0,
                listStyleType: "none"
            }
        },
        TreeNode: {
            treeNodeBase: {
                color: theme3.BASE_COLOR,
                backgroundColor: theme3.BASE_BACKGROUND_COLOR,
                lineHeight: theme3.TREENODE_LINE_HEIGHT,
                cursor: "default",
                boxSizing: "border-box",
                listStyle: "none",
                fontFamily: theme3.TREENODE_FONT_FAMILY,
                fontSize: theme3.TREENODE_FONT_SIZE
            },
            treeNodePreviewContainer: {},
            treeNodePlaceholder: {
                whiteSpace: "pre",
                fontSize: theme3.ARROW_FONT_SIZE,
                marginRight: theme3.ARROW_MARGIN_RIGHT,
                ...$8ded0b3da2a2e917$var$unselectable
            },
            treeNodeArrow: {
                base: {
                    color: theme3.ARROW_COLOR,
                    display: "inline-block",
                    fontSize: theme3.ARROW_FONT_SIZE,
                    marginRight: theme3.ARROW_MARGIN_RIGHT,
                    ...parseFloat(theme3.ARROW_ANIMATION_DURATION) > 0 ? {
                        transition: `transform ${theme3.ARROW_ANIMATION_DURATION} ease 0s`
                    } : {},
                    ...$8ded0b3da2a2e917$var$unselectable
                },
                expanded: {
                    WebkitTransform: "rotateZ(90deg)",
                    MozTransform: "rotateZ(90deg)",
                    transform: "rotateZ(90deg)"
                },
                collapsed: {
                    WebkitTransform: "rotateZ(0deg)",
                    MozTransform: "rotateZ(0deg)",
                    transform: "rotateZ(0deg)"
                }
            },
            treeNodeChildNodesContainer: {
                margin: 0,
                paddingLeft: theme3.TREENODE_PADDING_LEFT
            }
        },
        TableInspector: {
            base: {
                color: theme3.BASE_COLOR,
                position: "relative",
                border: `1px solid ${theme3.TABLE_BORDER_COLOR}`,
                fontFamily: theme3.BASE_FONT_FAMILY,
                fontSize: theme3.BASE_FONT_SIZE,
                lineHeight: "120%",
                boxSizing: "border-box",
                cursor: "default"
            }
        },
        TableInspectorHeaderContainer: {
            base: {
                top: 0,
                height: "17px",
                left: 0,
                right: 0,
                overflowX: "hidden"
            },
            table: {
                tableLayout: "fixed",
                borderSpacing: 0,
                borderCollapse: "separate",
                height: "100%",
                width: "100%",
                margin: 0
            }
        },
        TableInspectorDataContainer: {
            tr: {
                display: "table-row"
            },
            td: {
                boxSizing: "border-box",
                border: "none",
                height: "16px",
                verticalAlign: "top",
                padding: "1px 4px",
                WebkitUserSelect: "text",
                whiteSpace: "nowrap",
                textOverflow: "ellipsis",
                overflow: "hidden",
                lineHeight: "14px"
            },
            div: {
                position: "static",
                top: "17px",
                bottom: 0,
                overflowY: "overlay",
                transform: "translateZ(0)",
                left: 0,
                right: 0,
                overflowX: "hidden"
            },
            table: {
                positon: "static",
                left: 0,
                top: 0,
                right: 0,
                bottom: 0,
                borderTop: "0 none transparent",
                margin: 0,
                backgroundImage: theme3.TABLE_DATA_BACKGROUND_IMAGE,
                backgroundSize: theme3.TABLE_DATA_BACKGROUND_SIZE,
                tableLayout: "fixed",
                borderSpacing: 0,
                borderCollapse: "separate",
                width: "100%",
                fontSize: theme3.BASE_FONT_SIZE,
                lineHeight: "120%"
            }
        },
        TableInspectorTH: {
            base: {
                position: "relative",
                height: "auto",
                textAlign: "left",
                backgroundColor: theme3.TABLE_TH_BACKGROUND_COLOR,
                borderBottom: `1px solid ${theme3.TABLE_BORDER_COLOR}`,
                fontWeight: "normal",
                verticalAlign: "middle",
                padding: "0 4px",
                whiteSpace: "nowrap",
                textOverflow: "ellipsis",
                overflow: "hidden",
                lineHeight: "14px",
                ":hover": {
                    backgroundColor: theme3.TABLE_TH_HOVER_COLOR
                }
            },
            div: {
                whiteSpace: "nowrap",
                textOverflow: "ellipsis",
                overflow: "hidden",
                fontSize: theme3.BASE_FONT_SIZE,
                lineHeight: "120%"
            }
        },
        TableInspectorLeftBorder: {
            none: {
                borderLeft: "none"
            },
            solid: {
                borderLeft: `1px solid ${theme3.TABLE_BORDER_COLOR}`
            }
        },
        TableInspectorSortIcon: {
            display: "block",
            marginRight: 3,
            width: 8,
            height: 7,
            marginTop: -7,
            color: theme3.TABLE_SORT_ICON_COLOR,
            fontSize: 12,
            ...$8ded0b3da2a2e917$var$unselectable
        }
    });
// src/styles/styles.tsx
var $8ded0b3da2a2e917$var$DEFAULT_THEME_NAME = "chromeLight";
var $8ded0b3da2a2e917$var$ThemeContext = (0, $acw62.createContext)($8ded0b3da2a2e917$var$createTheme($8ded0b3da2a2e917$var$themes_exports[$8ded0b3da2a2e917$var$DEFAULT_THEME_NAME]));
var $8ded0b3da2a2e917$var$useStyles = (baseStylesKey)=>{
    const themeStyles = (0, $acw62.useContext)($8ded0b3da2a2e917$var$ThemeContext);
    return themeStyles[baseStylesKey];
};
var $8ded0b3da2a2e917$var$themeAcceptor = (WrappedComponent)=>{
    const ThemeAcceptor = ({ theme: theme3 = $8ded0b3da2a2e917$var$DEFAULT_THEME_NAME, ...restProps })=>{
        const themeStyles = (0, $acw62.useMemo)(()=>{
            switch(Object.prototype.toString.call(theme3)){
                case "[object String]":
                    return $8ded0b3da2a2e917$var$createTheme($8ded0b3da2a2e917$var$themes_exports[theme3]);
                case "[object Object]":
                    return $8ded0b3da2a2e917$var$createTheme(theme3);
                default:
                    return $8ded0b3da2a2e917$var$createTheme($8ded0b3da2a2e917$var$themes_exports[$8ded0b3da2a2e917$var$DEFAULT_THEME_NAME]);
            }
        }, [
            theme3
        ]);
        return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($8ded0b3da2a2e917$var$ThemeContext.Provider, {
            value: themeStyles
        }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(WrappedComponent, {
            ...restProps
        }));
    };
    return ThemeAcceptor;
};
// src/tree-view/TreeNode.tsx
var $8ded0b3da2a2e917$var$Arrow = ({ expanded: expanded, styles: styles })=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            ...styles.base,
            ...expanded ? styles.expanded : styles.collapsed
        }
    }, "\u25B6");
var $8ded0b3da2a2e917$var$TreeNode = (0, $acw62.memo)((props)=>{
    props = {
        expanded: true,
        nodeRenderer: ({ name: name })=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, name),
        onClick: ()=>{},
        shouldShowArrow: false,
        shouldShowPlaceholder: true,
        ...props
    };
    const { expanded: expanded, onClick: onClick, children: children, nodeRenderer: nodeRenderer, title: title, shouldShowArrow: shouldShowArrow, shouldShowPlaceholder: shouldShowPlaceholder } = props;
    const styles = $8ded0b3da2a2e917$var$useStyles("TreeNode");
    const NodeRenderer = nodeRenderer;
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
        "aria-expanded": expanded,
        role: "treeitem",
        style: styles.treeNodeBase,
        title: title
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: styles.treeNodePreviewContainer,
        onClick: onClick
    }, shouldShowArrow || (0, $acw62.Children).count(children) > 0 ? /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($8ded0b3da2a2e917$var$Arrow, {
        expanded: expanded,
        styles: styles.treeNodeArrow
    }) : shouldShowPlaceholder && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: styles.treeNodePlaceholder
    }, "\xa0"), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(NodeRenderer, {
        ...props
    })), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ol", {
        role: "group",
        style: styles.treeNodeChildNodesContainer
    }, expanded ? children : void 0));
});
// src/tree-view/pathUtils.ts
var $8ded0b3da2a2e917$var$DEFAULT_ROOT_PATH = "$";
var $8ded0b3da2a2e917$var$WILDCARD = "*";
function $8ded0b3da2a2e917$var$hasChildNodes(data, dataIterator) {
    return !dataIterator(data).next().done;
}
var $8ded0b3da2a2e917$var$wildcardPathsFromLevel = (level)=>{
    return Array.from({
        length: level
    }, (_, i)=>[
            $8ded0b3da2a2e917$var$DEFAULT_ROOT_PATH
        ].concat(Array.from({
            length: i
        }, ()=>"*")).join("."));
};
var $8ded0b3da2a2e917$var$getExpandedPaths = (data, dataIterator, expandPaths, expandLevel, prevExpandedPaths)=>{
    const wildcardPaths = [].concat($8ded0b3da2a2e917$var$wildcardPathsFromLevel(expandLevel)).concat(expandPaths).filter((path)=>typeof path === "string");
    const expandedPaths = [];
    wildcardPaths.forEach((wildcardPath)=>{
        const keyPaths = wildcardPath.split(".");
        const populatePaths = (curData, curPath, depth)=>{
            if (depth === keyPaths.length) {
                expandedPaths.push(curPath);
                return;
            }
            const key = keyPaths[depth];
            if (depth === 0) {
                if ($8ded0b3da2a2e917$var$hasChildNodes(curData, dataIterator) && (key === $8ded0b3da2a2e917$var$DEFAULT_ROOT_PATH || key === $8ded0b3da2a2e917$var$WILDCARD)) populatePaths(curData, $8ded0b3da2a2e917$var$DEFAULT_ROOT_PATH, depth + 1);
            } else if (key === $8ded0b3da2a2e917$var$WILDCARD) {
                for (const { name: name, data: data2 } of dataIterator(curData))if ($8ded0b3da2a2e917$var$hasChildNodes(data2, dataIterator)) populatePaths(data2, `${curPath}.${name}`, depth + 1);
            } else {
                const value = curData[key];
                if ($8ded0b3da2a2e917$var$hasChildNodes(value, dataIterator)) populatePaths(value, `${curPath}.${key}`, depth + 1);
            }
        };
        populatePaths(data, "", 0);
    });
    return expandedPaths.reduce((obj, path)=>{
        obj[path] = true;
        return obj;
    }, {
        ...prevExpandedPaths
    });
};
// src/tree-view/TreeView.tsx
var $8ded0b3da2a2e917$var$ConnectedTreeNode = (0, $acw62.memo)((props)=>{
    const { data: data, dataIterator: dataIterator, path: path, depth: depth, nodeRenderer: nodeRenderer } = props;
    const [expandedPaths, setExpandedPaths] = (0, $acw62.useContext)($8ded0b3da2a2e917$var$ExpandedPathsContext);
    const nodeHasChildNodes = $8ded0b3da2a2e917$var$hasChildNodes(data, dataIterator);
    const expanded = !!expandedPaths[path];
    const handleClick = (0, $acw62.useCallback)(()=>nodeHasChildNodes && setExpandedPaths((prevExpandedPaths)=>({
                ...prevExpandedPaths,
                [path]: !expanded
            })), [
        nodeHasChildNodes,
        setExpandedPaths,
        path,
        expanded
    ]);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($8ded0b3da2a2e917$var$TreeNode, {
        expanded: expanded,
        onClick: handleClick,
        shouldShowArrow: nodeHasChildNodes,
        shouldShowPlaceholder: depth > 0,
        nodeRenderer: nodeRenderer,
        ...props
    }, expanded ? [
        ...dataIterator(data)
    ].map(({ name: name, data: data2, ...renderNodeProps })=>{
        return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($8ded0b3da2a2e917$var$ConnectedTreeNode, {
            name: name,
            data: data2,
            depth: depth + 1,
            path: `${path}.${name}`,
            key: name,
            dataIterator: dataIterator,
            nodeRenderer: nodeRenderer,
            ...renderNodeProps
        });
    }) : null);
});
var $8ded0b3da2a2e917$var$TreeView = (0, $acw62.memo)(({ name: name, data: data, dataIterator: dataIterator, nodeRenderer: nodeRenderer, expandPaths: expandPaths, expandLevel: expandLevel })=>{
    const styles = $8ded0b3da2a2e917$var$useStyles("TreeView");
    const stateAndSetter = (0, $acw62.useState)({});
    const [, setExpandedPaths] = stateAndSetter;
    (0, $acw62.useLayoutEffect)(()=>setExpandedPaths((prevExpandedPaths)=>$8ded0b3da2a2e917$var$getExpandedPaths(data, dataIterator, expandPaths, expandLevel, prevExpandedPaths)), [
        data,
        dataIterator,
        expandPaths,
        expandLevel
    ]);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($8ded0b3da2a2e917$var$ExpandedPathsContext.Provider, {
        value: stateAndSetter
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ol", {
        role: "tree",
        style: styles.treeViewOutline
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($8ded0b3da2a2e917$var$ConnectedTreeNode, {
        name: name,
        data: data,
        dataIterator: dataIterator,
        depth: 0,
        path: $8ded0b3da2a2e917$var$DEFAULT_ROOT_PATH,
        nodeRenderer: nodeRenderer
    })));
});
var $8ded0b3da2a2e917$export$8e2f7a5ced0303a6 = ({ name: name, dimmed: dimmed = false, styles: styles = {} })=>{
    const themeStyles = $8ded0b3da2a2e917$var$useStyles("ObjectName");
    const appliedStyles = {
        ...themeStyles.base,
        ...dimmed ? themeStyles["dimmed"] : {},
        ...styles
    };
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: appliedStyles
    }, name);
};
var $8ded0b3da2a2e917$export$7b660e20faa35e02 = ({ object: object, styles: styles })=>{
    const themeStyles = $8ded0b3da2a2e917$var$useStyles("ObjectValue");
    const mkStyle = (key)=>({
            ...themeStyles[key],
            ...styles
        });
    switch(typeof object){
        case "bigint":
            return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                style: mkStyle("objectValueNumber")
            }, String(object), "n");
        case "number":
            return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                style: mkStyle("objectValueNumber")
            }, String(object));
        case "string":
            return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                style: mkStyle("objectValueString")
            }, '"', object, '"');
        case "boolean":
            return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                style: mkStyle("objectValueBoolean")
            }, String(object));
        case "undefined":
            return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                style: mkStyle("objectValueUndefined")
            }, "undefined");
        case "object":
            if (object === null) return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                style: mkStyle("objectValueNull")
            }, "null");
            if (object instanceof Date) return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, object.toString());
            if (object instanceof RegExp) return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                style: mkStyle("objectValueRegExp")
            }, object.toString());
            if (Array.isArray(object)) return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, `Array(${object.length})`);
            if (!object.constructor) return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, "Object");
            if (typeof object.constructor.isBuffer === "function" && object.constructor.isBuffer(object)) return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, `Buffer[${object.length}]`);
            return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, object.constructor.name);
        case "function":
            return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                style: mkStyle("objectValueFunctionPrefix")
            }, "\u0192\xa0"), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                style: mkStyle("objectValueFunctionName")
            }, object.name, "()"));
        case "symbol":
            return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                style: mkStyle("objectValueSymbol")
            }, object.toString());
        default:
            return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null);
    }
};
// src/utils/objectPrototype.tsx
var $8ded0b3da2a2e917$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $8ded0b3da2a2e917$var$propertyIsEnumerable = Object.prototype.propertyIsEnumerable;
// src/utils/propertyUtils.tsx
function $8ded0b3da2a2e917$var$getPropertyValue(object, propertyName) {
    const propertyDescriptor = Object.getOwnPropertyDescriptor(object, propertyName);
    if (propertyDescriptor.get) try {
        return propertyDescriptor.get();
    } catch  {
        return propertyDescriptor.get;
    }
    return object[propertyName];
}
// src/object-inspector/ObjectPreview.tsx
function $8ded0b3da2a2e917$var$intersperse(arr, sep) {
    if (arr.length === 0) return [];
    return arr.slice(1).reduce((xs, x)=>xs.concat([
            sep,
            x
        ]), [
        arr[0]
    ]);
}
var $8ded0b3da2a2e917$export$c09c4c234b3ce309 = ({ data: data })=>{
    const styles = $8ded0b3da2a2e917$var$useStyles("ObjectPreview");
    const object = data;
    if (typeof object !== "object" || object === null || object instanceof Date || object instanceof RegExp) return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($8ded0b3da2a2e917$export$7b660e20faa35e02, {
        object: object
    });
    if (Array.isArray(object)) {
        const maxProperties = styles.arrayMaxProperties;
        const previewArray = object.slice(0, maxProperties).map((element, index)=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($8ded0b3da2a2e917$export$7b660e20faa35e02, {
                key: index,
                object: element
            }));
        if (object.length > maxProperties) previewArray.push(/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            key: "ellipsis"
        }, "\u2026"));
        const arrayLength = object.length;
        return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: styles.objectDescription
        }, arrayLength === 0 ? `` : `(${arrayLength})\xA0`), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: styles.preview
        }, "[", $8ded0b3da2a2e917$var$intersperse(previewArray, ", "), "]"));
    } else {
        const maxProperties = styles.objectMaxProperties;
        const propertyNodes = [];
        for(const propertyName in object)if ($8ded0b3da2a2e917$var$hasOwnProperty.call(object, propertyName)) {
            let ellipsis;
            if (propertyNodes.length === maxProperties - 1 && Object.keys(object).length > maxProperties) ellipsis = /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                key: "ellipsis"
            }, "\u2026");
            const propertyValue = $8ded0b3da2a2e917$var$getPropertyValue(object, propertyName);
            propertyNodes.push(/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                key: propertyName
            }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($8ded0b3da2a2e917$export$8e2f7a5ced0303a6, {
                name: propertyName || `""`
            }), ":\xa0", /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($8ded0b3da2a2e917$export$7b660e20faa35e02, {
                object: propertyValue
            }), ellipsis));
            if (ellipsis) break;
        }
        const objectConstructorName = object.constructor ? object.constructor.name : "Object";
        return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: styles.objectDescription
        }, objectConstructorName === "Object" ? "" : `${objectConstructorName} `), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: styles.preview
        }, "{", $8ded0b3da2a2e917$var$intersperse(propertyNodes, ", "), "}"));
    }
};
// src/object-inspector/ObjectRootLabel.tsx
var $8ded0b3da2a2e917$export$1563f34270936445 = ({ name: name, data: data })=>{
    if (typeof name === "string") return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($8ded0b3da2a2e917$export$8e2f7a5ced0303a6, {
        name: name
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, ": "), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($8ded0b3da2a2e917$export$c09c4c234b3ce309, {
        data: data
    }));
    else return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($8ded0b3da2a2e917$export$c09c4c234b3ce309, {
        data: data
    });
};
var $8ded0b3da2a2e917$export$b4cc347f09904bef = ({ name: name, data: data, isNonenumerable: isNonenumerable = false })=>{
    const object = data;
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, typeof name === "string" ? /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($8ded0b3da2a2e917$export$8e2f7a5ced0303a6, {
        name: name,
        dimmed: isNonenumerable
    }) : /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($8ded0b3da2a2e917$export$c09c4c234b3ce309, {
        data: name
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, ": "), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($8ded0b3da2a2e917$export$7b660e20faa35e02, {
        object: object
    }));
};
// src/object-inspector/ObjectInspector.tsx
var $8ded0b3da2a2e917$var$createIterator = (showNonenumerable, sortObjectKeys)=>{
    const objectIterator = function*(data) {
        const shouldIterate = typeof data === "object" && data !== null || typeof data === "function";
        if (!shouldIterate) return;
        const dataIsArray = Array.isArray(data);
        if (!dataIsArray && data[Symbol.iterator]) {
            let i = 0;
            for (const entry of data){
                if (Array.isArray(entry) && entry.length === 2) {
                    const [k, v] = entry;
                    yield {
                        name: k,
                        data: v
                    };
                } else yield {
                    name: i.toString(),
                    data: entry
                };
                i++;
            }
        } else {
            const keys = Object.getOwnPropertyNames(data);
            if (sortObjectKeys === true && !dataIsArray) keys.sort();
            else if (typeof sortObjectKeys === "function") keys.sort(sortObjectKeys);
            for (const propertyName of keys){
                if ($8ded0b3da2a2e917$var$propertyIsEnumerable.call(data, propertyName)) {
                    const propertyValue = $8ded0b3da2a2e917$var$getPropertyValue(data, propertyName);
                    yield {
                        name: propertyName || `""`,
                        data: propertyValue
                    };
                } else if (showNonenumerable) {
                    let propertyValue;
                    try {
                        propertyValue = $8ded0b3da2a2e917$var$getPropertyValue(data, propertyName);
                    } catch (e) {}
                    if (propertyValue !== void 0) yield {
                        name: propertyName,
                        data: propertyValue,
                        isNonenumerable: true
                    };
                }
            }
            if (showNonenumerable && data !== Object.prototype) yield {
                name: "__proto__",
                data: Object.getPrototypeOf(data),
                isNonenumerable: true
            };
        }
    };
    return objectIterator;
};
var $8ded0b3da2a2e917$var$defaultNodeRenderer = ({ depth: depth, name: name, data: data, isNonenumerable: isNonenumerable })=>depth === 0 ? /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($8ded0b3da2a2e917$export$1563f34270936445, {
        name: name,
        data: data
    }) : /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($8ded0b3da2a2e917$export$b4cc347f09904bef, {
        name: name,
        data: data,
        isNonenumerable: isNonenumerable
    });
var $8ded0b3da2a2e917$var$ObjectInspector = ({ showNonenumerable: showNonenumerable = false, sortObjectKeys: sortObjectKeys, nodeRenderer: nodeRenderer, ...treeViewProps })=>{
    const dataIterator = $8ded0b3da2a2e917$var$createIterator(showNonenumerable, sortObjectKeys);
    const renderer = nodeRenderer ? nodeRenderer : $8ded0b3da2a2e917$var$defaultNodeRenderer;
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($8ded0b3da2a2e917$var$TreeView, {
        nodeRenderer: renderer,
        dataIterator: dataIterator,
        ...treeViewProps
    });
};
var $8ded0b3da2a2e917$export$6e58e9313a6c4e66 = $8ded0b3da2a2e917$var$themeAcceptor($8ded0b3da2a2e917$var$ObjectInspector);
// src/table-inspector/getHeaders.ts
function $8ded0b3da2a2e917$var$getHeaders(data) {
    if (typeof data === "object") {
        let rowHeaders = [];
        if (Array.isArray(data)) {
            const nRows = data.length;
            rowHeaders = [
                ...Array(nRows).keys()
            ];
        } else if (data !== null) rowHeaders = Object.keys(data);
        const colHeaders = rowHeaders.reduce((colHeaders2, rowHeader)=>{
            const row = data[rowHeader];
            if (typeof row === "object" && row !== null) {
                const cols = Object.keys(row);
                cols.reduce((xs, x)=>{
                    if (!xs.includes(x)) xs.push(x);
                    return xs;
                }, colHeaders2);
            }
            return colHeaders2;
        }, []);
        return {
            rowHeaders: rowHeaders,
            colHeaders: colHeaders
        };
    }
    return void 0;
}
var $8ded0b3da2a2e917$var$DataContainer = ({ rows: rows, columns: columns, rowsData: rowsData })=>{
    const styles = $8ded0b3da2a2e917$var$useStyles("TableInspectorDataContainer");
    const borderStyles = $8ded0b3da2a2e917$var$useStyles("TableInspectorLeftBorder");
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: styles.div
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("table", {
        style: styles.table
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("colgroup", null), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("tbody", null, rows.map((row, i)=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("tr", {
            key: row,
            style: styles.tr
        }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("td", {
            style: {
                ...styles.td,
                ...borderStyles.none
            }
        }, row), columns.map((column)=>{
            const rowData = rowsData[i];
            if (typeof rowData === "object" && rowData !== null && $8ded0b3da2a2e917$var$hasOwnProperty.call(rowData, column)) return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("td", {
                key: column,
                style: {
                    ...styles.td,
                    ...borderStyles.solid
                }
            }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($8ded0b3da2a2e917$export$7b660e20faa35e02, {
                object: rowData[column]
            }));
            else return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("td", {
                key: column,
                style: {
                    ...styles.td,
                    ...borderStyles.solid
                }
            });
        }))))));
};
var $8ded0b3da2a2e917$var$SortIconContainer = (props)=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            position: "absolute",
            top: 1,
            right: 0,
            bottom: 1,
            display: "flex",
            alignItems: "center"
        }
    }, props.children);
var $8ded0b3da2a2e917$var$SortIcon = ({ sortAscending: sortAscending })=>{
    const styles = $8ded0b3da2a2e917$var$useStyles("TableInspectorSortIcon");
    const glyph = sortAscending ? "\u25B2" : "\u25BC";
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: styles
    }, glyph);
};
var $8ded0b3da2a2e917$var$TH = ({ sortAscending: sortAscending = false, sorted: sorted = false, onClick: onClick, borderStyle: borderStyle = {}, children: children, ...thProps })=>{
    const styles = $8ded0b3da2a2e917$var$useStyles("TableInspectorTH");
    const [hovered, setHovered] = (0, $acw62.useState)(false);
    const handleMouseEnter = (0, $acw62.useCallback)(()=>setHovered(true), []);
    const handleMouseLeave = (0, $acw62.useCallback)(()=>setHovered(false), []);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("th", {
        ...thProps,
        style: {
            ...styles.base,
            ...borderStyle,
            ...hovered ? styles.base[":hover"] : {}
        },
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        onClick: onClick
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: styles.div
    }, children), sorted && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($8ded0b3da2a2e917$var$SortIconContainer, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($8ded0b3da2a2e917$var$SortIcon, {
        sortAscending: sortAscending
    })));
};
// src/table-inspector/HeaderContainer.tsx
var $8ded0b3da2a2e917$var$HeaderContainer = ({ indexColumnText: indexColumnText = "(index)", columns: columns = [], sorted: sorted, sortIndexColumn: sortIndexColumn, sortColumn: sortColumn, sortAscending: sortAscending, onTHClick: onTHClick, onIndexTHClick: onIndexTHClick })=>{
    const styles = $8ded0b3da2a2e917$var$useStyles("TableInspectorHeaderContainer");
    const borderStyles = $8ded0b3da2a2e917$var$useStyles("TableInspectorLeftBorder");
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: styles.base
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("table", {
        style: styles.table
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("tbody", null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("tr", null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($8ded0b3da2a2e917$var$TH, {
        borderStyle: borderStyles.none,
        sorted: sorted && sortIndexColumn,
        sortAscending: sortAscending,
        onClick: onIndexTHClick
    }, indexColumnText), columns.map((column)=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($8ded0b3da2a2e917$var$TH, {
            borderStyle: borderStyles.solid,
            key: column,
            sorted: sorted && sortColumn === column,
            sortAscending: sortAscending,
            onClick: onTHClick.bind(null, column)
        }, column))))));
};
// src/table-inspector/TableInspector.tsx
var $8ded0b3da2a2e917$var$TableInspector = ({ data: data, columns: columns })=>{
    const styles = $8ded0b3da2a2e917$var$useStyles("TableInspector");
    const [{ sorted: sorted, sortIndexColumn: sortIndexColumn, sortColumn: sortColumn, sortAscending: sortAscending }, setState] = (0, $acw62.useState)({
        sorted: false,
        sortIndexColumn: false,
        sortColumn: void 0,
        sortAscending: false
    });
    const handleIndexTHClick = (0, $acw62.useCallback)(()=>{
        setState(({ sortIndexColumn: sortIndexColumn2, sortAscending: sortAscending2 })=>({
                sorted: true,
                sortIndexColumn: true,
                sortColumn: void 0,
                sortAscending: sortIndexColumn2 ? !sortAscending2 : true
            }));
    }, []);
    const handleTHClick = (0, $acw62.useCallback)((col)=>{
        setState(({ sortColumn: sortColumn2, sortAscending: sortAscending2 })=>({
                sorted: true,
                sortIndexColumn: false,
                sortColumn: col,
                sortAscending: col === sortColumn2 ? !sortAscending2 : true
            }));
    }, []);
    if (typeof data !== "object" || data === null) return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null);
    let { rowHeaders: rowHeaders, colHeaders: colHeaders } = $8ded0b3da2a2e917$var$getHeaders(data);
    if (columns !== void 0) colHeaders = columns;
    let rowsData = rowHeaders.map((rowHeader)=>data[rowHeader]);
    let columnDataWithRowIndexes;
    if (sortColumn !== void 0) columnDataWithRowIndexes = rowsData.map((rowData, index)=>{
        if (typeof rowData === "object" && rowData !== null) {
            const columnData = rowData[sortColumn];
            return [
                columnData,
                index
            ];
        }
        return [
            void 0,
            index
        ];
    });
    else if (sortIndexColumn) columnDataWithRowIndexes = rowHeaders.map((rowData, index)=>{
        const columnData = rowHeaders[index];
        return [
            columnData,
            index
        ];
    });
    if (columnDataWithRowIndexes !== void 0) {
        const comparator = (mapper, ascending)=>{
            return (a, b)=>{
                const v1 = mapper(a);
                const v2 = mapper(b);
                const type1 = typeof v1;
                const type2 = typeof v2;
                const lt = (v12, v22)=>{
                    if (v12 < v22) return -1;
                    else if (v12 > v22) return 1;
                    else return 0;
                };
                let result;
                if (type1 === type2) result = lt(v1, v2);
                else {
                    const order = {
                        string: 0,
                        number: 1,
                        object: 2,
                        symbol: 3,
                        boolean: 4,
                        undefined: 5,
                        function: 6
                    };
                    result = lt(order[type1], order[type2]);
                }
                if (!ascending) result = -result;
                return result;
            };
        };
        const sortedRowIndexes = columnDataWithRowIndexes.sort(comparator((item)=>item[0], sortAscending)).map((item)=>item[1]);
        rowHeaders = sortedRowIndexes.map((i)=>rowHeaders[i]);
        rowsData = sortedRowIndexes.map((i)=>rowsData[i]);
    }
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: styles.base
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($8ded0b3da2a2e917$var$HeaderContainer, {
        columns: colHeaders,
        sorted: sorted,
        sortIndexColumn: sortIndexColumn,
        sortColumn: sortColumn,
        sortAscending: sortAscending,
        onTHClick: handleTHClick,
        onIndexTHClick: handleIndexTHClick
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($8ded0b3da2a2e917$var$DataContainer, {
        rows: rowHeaders,
        columns: colHeaders,
        rowsData: rowsData
    }));
};
var $8ded0b3da2a2e917$export$c86cf7731966ed43 = $8ded0b3da2a2e917$var$themeAcceptor($8ded0b3da2a2e917$var$TableInspector);
// src/dom-inspector/shouldInline.tsx
var $8ded0b3da2a2e917$var$TEXT_NODE_MAX_INLINE_CHARS = 80;
var $8ded0b3da2a2e917$var$shouldInline = (data)=>data.childNodes.length === 0 || data.childNodes.length === 1 && data.childNodes[0].nodeType === Node.TEXT_NODE && data.textContent.length < $8ded0b3da2a2e917$var$TEXT_NODE_MAX_INLINE_CHARS;
// src/dom-inspector/DOMNodePreview.tsx
var $8ded0b3da2a2e917$var$OpenTag = ({ tagName: tagName, attributes: attributes, styles: styles })=>{
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: styles.base
    }, "<", /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: styles.tagName
    }, tagName), (()=>{
        if (attributes) {
            const attributeNodes = [];
            for(let i = 0; i < attributes.length; i++){
                const attribute = attributes[i];
                attributeNodes.push(/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                    key: i
                }, " ", /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                    style: styles.htmlAttributeName
                }, attribute.name), '="', /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                    style: styles.htmlAttributeValue
                }, attribute.value), '"'));
            }
            return attributeNodes;
        }
    })(), ">");
};
var $8ded0b3da2a2e917$var$CloseTag = ({ tagName: tagName, isChildNode: isChildNode = false, styles: styles })=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: Object.assign({}, styles.base, isChildNode && styles.offsetLeft)
    }, "</", /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: styles.tagName
    }, tagName), ">");
var $8ded0b3da2a2e917$var$nameByNodeType = {
    1: "ELEMENT_NODE",
    3: "TEXT_NODE",
    7: "PROCESSING_INSTRUCTION_NODE",
    8: "COMMENT_NODE",
    9: "DOCUMENT_NODE",
    10: "DOCUMENT_TYPE_NODE",
    11: "DOCUMENT_FRAGMENT_NODE"
};
var $8ded0b3da2a2e917$var$DOMNodePreview = ({ isCloseTag: isCloseTag, data: data, expanded: expanded })=>{
    const styles = $8ded0b3da2a2e917$var$useStyles("DOMNodePreview");
    if (isCloseTag) return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($8ded0b3da2a2e917$var$CloseTag, {
        styles: styles.htmlCloseTag,
        isChildNode: true,
        tagName: data.tagName
    });
    switch(data.nodeType){
        case Node.ELEMENT_NODE:
            return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($8ded0b3da2a2e917$var$OpenTag, {
                tagName: data.tagName,
                attributes: data.attributes,
                styles: styles.htmlOpenTag
            }), $8ded0b3da2a2e917$var$shouldInline(data) ? data.textContent : !expanded && "\u2026", !expanded && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($8ded0b3da2a2e917$var$CloseTag, {
                tagName: data.tagName,
                styles: styles.htmlCloseTag
            }));
        case Node.TEXT_NODE:
            return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, data.textContent);
        case Node.CDATA_SECTION_NODE:
            return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, "<![CDATA[" + data.textContent + "]]>");
        case Node.COMMENT_NODE:
            return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                style: styles.htmlComment
            }, "<!--", data.textContent, "-->");
        case Node.PROCESSING_INSTRUCTION_NODE:
            return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, data.nodeName);
        case Node.DOCUMENT_TYPE_NODE:
            return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                style: styles.htmlDoctype
            }, "<!DOCTYPE ", data.name, data.publicId ? ` PUBLIC "${data.publicId}"` : "", !data.publicId && data.systemId ? " SYSTEM" : "", data.systemId ? ` "${data.systemId}"` : "", ">");
        case Node.DOCUMENT_NODE:
            return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, data.nodeName);
        case Node.DOCUMENT_FRAGMENT_NODE:
            return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, data.nodeName);
        default:
            return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, $8ded0b3da2a2e917$var$nameByNodeType[data.nodeType]);
    }
};
// src/dom-inspector/DOMInspector.tsx
var $8ded0b3da2a2e917$var$domIterator = function*(data) {
    if (data && data.childNodes) {
        const textInlined = $8ded0b3da2a2e917$var$shouldInline(data);
        if (textInlined) return;
        for(let i = 0; i < data.childNodes.length; i++){
            const node = data.childNodes[i];
            if (node.nodeType === Node.TEXT_NODE && node.textContent.trim().length === 0) continue;
            yield {
                name: `${node.tagName}[${i}]`,
                data: node
            };
        }
        if (data.tagName) yield {
            name: "CLOSE_TAG",
            data: {
                tagName: data.tagName
            },
            isCloseTag: true
        };
    }
};
var $8ded0b3da2a2e917$var$DOMInspector = (props)=>{
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($8ded0b3da2a2e917$var$TreeView, {
        nodeRenderer: $8ded0b3da2a2e917$var$DOMNodePreview,
        dataIterator: $8ded0b3da2a2e917$var$domIterator,
        ...props
    });
};
var $8ded0b3da2a2e917$var$themedDOMInspector = $8ded0b3da2a2e917$var$themeAcceptor($8ded0b3da2a2e917$var$DOMInspector);
// src/index.tsx
var $8ded0b3da2a2e917$var$import_is_dom = $8ded0b3da2a2e917$var$__toESM($8ded0b3da2a2e917$var$require_is_dom());
var $8ded0b3da2a2e917$export$b00d1c5d070816cc = ({ table: table = false, data: data, ...rest })=>{
    if (table) return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($8ded0b3da2a2e917$export$c86cf7731966ed43, {
        data: data,
        ...rest
    });
    if ((0, $8ded0b3da2a2e917$var$import_is_dom.default)(data)) return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($8ded0b3da2a2e917$var$themedDOMInspector, {
        data: data,
        ...rest
    });
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($8ded0b3da2a2e917$export$6e58e9313a6c4e66, {
        data: data,
        ...rest
    });
};





var $fuTml = parcelRequire("fuTml");

var $iQrBP = parcelRequire("iQrBP");

var $ardUq = parcelRequire("ardUq");
var $cb8a0fe0beecb480$exports = {};

$parcel$export($cb8a0fe0beecb480$exports, "CodeView", () => $cb8a0fe0beecb480$export$6a048cde9ca9b775);
$parcel$export($cb8a0fe0beecb480$exports, "CodeEditor", () => $cb8a0fe0beecb480$export$b7127187684f7150);
$parcel$export($cb8a0fe0beecb480$exports, "indentationHandlers", () => $cb8a0fe0beecb480$export$7154b0444fc054e2);
$parcel$export($cb8a0fe0beecb480$exports, "arrowHandler", () => $cb8a0fe0beecb480$export$731ef7f45a7717c0);


var $acw62 = parcelRequire("acw62");
var $0fdca79f03e679c4$exports = {};

$parcel$export($0fdca79f03e679c4$exports, "Prism", () => $0fdca79f03e679c4$export$dc7257ffb0972f87);
$parcel$export($0fdca79f03e679c4$exports, "themes", () => $0fdca79f03e679c4$export$d9a33280f07116d9);
$parcel$export($0fdca79f03e679c4$exports, "normalizeTokens", () => $0fdca79f03e679c4$export$2dc420fd853fdcc4);
$parcel$export($0fdca79f03e679c4$exports, "useTokenize", () => $0fdca79f03e679c4$export$7b94e077f7691ca1);
$parcel$export($0fdca79f03e679c4$exports, "Highlight", () => $0fdca79f03e679c4$export$39dbc3f558091353);

var $acw62 = parcelRequire("acw62");
function $f2ccb2ae3c8742b7$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $f2ccb2ae3c8742b7$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $f2ccb2ae3c8742b7$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $f2ccb2ae3c8742b7$export$2e2bcd8739ae039 = $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37;


var $0fdca79f03e679c4$var$__create = Object.create;
var $0fdca79f03e679c4$var$__defProp = Object.defineProperty;
var $0fdca79f03e679c4$var$__defProps = Object.defineProperties;
var $0fdca79f03e679c4$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $0fdca79f03e679c4$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $0fdca79f03e679c4$var$__getOwnPropNames = Object.getOwnPropertyNames;
var $0fdca79f03e679c4$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $0fdca79f03e679c4$var$__getProtoOf = Object.getPrototypeOf;
var $0fdca79f03e679c4$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $0fdca79f03e679c4$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $0fdca79f03e679c4$var$__defNormalProp = (obj, key, value)=>key in obj ? $0fdca79f03e679c4$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $0fdca79f03e679c4$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($0fdca79f03e679c4$var$__hasOwnProp.call(b, prop)) $0fdca79f03e679c4$var$__defNormalProp(a, prop, b[prop]);
    if ($0fdca79f03e679c4$var$__getOwnPropSymbols) {
        for (var prop of $0fdca79f03e679c4$var$__getOwnPropSymbols(b))if ($0fdca79f03e679c4$var$__propIsEnum.call(b, prop)) $0fdca79f03e679c4$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $0fdca79f03e679c4$var$__spreadProps = (a, b)=>$0fdca79f03e679c4$var$__defProps(a, $0fdca79f03e679c4$var$__getOwnPropDescs(b));
var $0fdca79f03e679c4$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($0fdca79f03e679c4$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $0fdca79f03e679c4$var$__getOwnPropSymbols) {
        for (var prop of $0fdca79f03e679c4$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $0fdca79f03e679c4$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
var $0fdca79f03e679c4$var$__commonJS = (cb, mod)=>function __require() {
        return mod || (0, cb[$0fdca79f03e679c4$var$__getOwnPropNames(cb)[0]])((mod = {
            exports: {}
        }).exports, mod), mod.exports;
    };
var $0fdca79f03e679c4$var$__export = (target, all)=>{
    for(var name in all)$0fdca79f03e679c4$var$__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var $0fdca79f03e679c4$var$__copyProps = (to, from, except, desc)=>{
    if (from && typeof from === "object" || typeof from === "function") {
        for (let key of $0fdca79f03e679c4$var$__getOwnPropNames(from))if (!$0fdca79f03e679c4$var$__hasOwnProp.call(to, key) && key !== except) $0fdca79f03e679c4$var$__defProp(to, key, {
            get: ()=>from[key],
            enumerable: !(desc = $0fdca79f03e679c4$var$__getOwnPropDesc(from, key)) || desc.enumerable
        });
    }
    return to;
};
var $0fdca79f03e679c4$var$__toESM = (mod, isNodeMode, target)=>(target = mod != null ? $0fdca79f03e679c4$var$__create($0fdca79f03e679c4$var$__getProtoOf(mod)) : {}, $0fdca79f03e679c4$var$__copyProps(// If the importer is in node compatibility mode or this is not an ESM
    // file that has been converted to a CommonJS file using a Babel-
    // compatible transform (i.e. "__esModule" has not been set), then set
    // "default" to the CommonJS "module.exports" for node compatibility.
    isNodeMode || !mod || !mod.__esModule ? $0fdca79f03e679c4$var$__defProp(target, "default", {
        value: mod,
        enumerable: true
    }) : target, mod));
// ../../node_modules/.pnpm/prismjs@1.29.0_patch_hash=vrxx3pzkik6jpmgpayxfjunetu/node_modules/prismjs/prism.js
var $0fdca79f03e679c4$var$require_prism = $0fdca79f03e679c4$var$__commonJS({
    "../../node_modules/.pnpm/prismjs@1.29.0_patch_hash=vrxx3pzkik6jpmgpayxfjunetu/node_modules/prismjs/prism.js" (exports, module) {
        var Prism2 = function() {
            var lang = /(?:^|\s)lang(?:uage)?-([\w-]+)(?=\s|$)/i;
            var uniqueId = 0;
            var plainTextGrammar = {};
            var _ = {
                /**
         * A namespace for utility methods.
         *
         * All function in this namespace that are not explicitly marked as _public_ are for __internal use only__ and may
         * change or disappear at any time.
         *
         * @namespace
         * @memberof Prism
         */ util: {
                    encode: function encode(tokens) {
                        if (tokens instanceof Token) return new Token(tokens.type, encode(tokens.content), tokens.alias);
                        else if (Array.isArray(tokens)) return tokens.map(encode);
                        else return tokens.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/\u00a0/g, " ");
                    },
                    /**
           * Returns the name of the type of the given value.
           *
           * @param {any} o
           * @returns {string}
           * @example
           * type(null)      === 'Null'
           * type(undefined) === 'Undefined'
           * type(123)       === 'Number'
           * type('foo')     === 'String'
           * type(true)      === 'Boolean'
           * type([1, 2])    === 'Array'
           * type({})        === 'Object'
           * type(String)    === 'Function'
           * type(/abc+/)    === 'RegExp'
           */ type: function(o) {
                        return Object.prototype.toString.call(o).slice(8, -1);
                    },
                    /**
           * Returns a unique number for the given object. Later calls will still return the same number.
           *
           * @param {Object} obj
           * @returns {number}
           */ objId: function(obj) {
                        if (!obj["__id"]) Object.defineProperty(obj, "__id", {
                            value: ++uniqueId
                        });
                        return obj["__id"];
                    },
                    /**
           * Creates a deep clone of the given object.
           *
           * The main intended use of this function is to clone language definitions.
           *
           * @param {T} o
           * @param {Record<number, any>} [visited]
           * @returns {T}
           * @template T
           */ clone: function deepClone(o, visited) {
                        visited = visited || {};
                        var clone;
                        var id;
                        switch(_.util.type(o)){
                            case "Object":
                                id = _.util.objId(o);
                                if (visited[id]) return visited[id];
                                clone = /** @type {Record<string, any>} */ {};
                                visited[id] = clone;
                                for(var key in o)if (o.hasOwnProperty(key)) clone[key] = deepClone(o[key], visited);
                                return /** @type {any} */ clone;
                            case "Array":
                                id = _.util.objId(o);
                                if (visited[id]) return visited[id];
                                clone = [];
                                visited[id] = clone;
                                /** @type {Array} */ /** @type {any} */ o.forEach(function(v, i) {
                                    clone[i] = deepClone(v, visited);
                                });
                                return /** @type {any} */ clone;
                            default:
                                return o;
                        }
                    },
                    /**
           * Returns the Prism language of the given element set by a `language-xxxx` or `lang-xxxx` class.
           *
           * If no language is set for the element or the element is `null` or `undefined`, `none` will be returned.
           *
           * @param {Element} element
           * @returns {string}
           */ getLanguage: function(element) {
                        while(element){
                            var m = lang.exec(element.className);
                            if (m) return m[1].toLowerCase();
                            element = element.parentElement;
                        }
                        return "none";
                    },
                    /**
           * Sets the Prism `language-xxxx` class of the given element.
           *
           * @param {Element} element
           * @param {string} language
           * @returns {void}
           */ setLanguage: function(element, language) {
                        element.className = element.className.replace(RegExp(lang, "gi"), "");
                        element.classList.add("language-" + language);
                    },
                    /**
           * Returns whether a given class is active for `element`.
           *
           * The class can be activated if `element` or one of its ancestors has the given class and it can be deactivated
           * if `element` or one of its ancestors has the negated version of the given class. The _negated version_ of the
           * given class is just the given class with a `no-` prefix.
           *
           * Whether the class is active is determined by the closest ancestor of `element` (where `element` itself is
           * closest ancestor) that has the given class or the negated version of it. If neither `element` nor any of its
           * ancestors have the given class or the negated version of it, then the default activation will be returned.
           *
           * In the paradoxical situation where the closest ancestor contains __both__ the given class and the negated
           * version of it, the class is considered active.
           *
           * @param {Element} element
           * @param {string} className
           * @param {boolean} [defaultActivation=false]
           * @returns {boolean}
           */ isActive: function(element, className, defaultActivation) {
                        var no = "no-" + className;
                        while(element){
                            var classList = element.classList;
                            if (classList.contains(className)) return true;
                            if (classList.contains(no)) return false;
                            element = element.parentElement;
                        }
                        return !!defaultActivation;
                    }
                },
                /**
         * This namespace contains all currently loaded languages and the some helper functions to create and modify languages.
         *
         * @namespace
         * @memberof Prism
         * @public
         */ languages: {
                    /**
           * The grammar for plain, unformatted text.
           */ plain: plainTextGrammar,
                    plaintext: plainTextGrammar,
                    text: plainTextGrammar,
                    txt: plainTextGrammar,
                    /**
           * Creates a deep copy of the language with the given id and appends the given tokens.
           *
           * If a token in `redef` also appears in the copied language, then the existing token in the copied language
           * will be overwritten at its original position.
           *
           * ## Best practices
           *
           * Since the position of overwriting tokens (token in `redef` that overwrite tokens in the copied language)
           * doesn't matter, they can technically be in any order. However, this can be confusing to others that trying to
           * understand the language definition because, normally, the order of tokens matters in Prism grammars.
           *
           * Therefore, it is encouraged to order overwriting tokens according to the positions of the overwritten tokens.
           * Furthermore, all non-overwriting tokens should be placed after the overwriting ones.
           *
           * @param {string} id The id of the language to extend. This has to be a key in `Prism.languages`.
           * @param {Grammar} redef The new tokens to append.
           * @returns {Grammar} The new language created.
           * @public
           * @example
           * Prism.languages['css-with-colors'] = Prism.languages.extend('css', {
           *     // Prism.languages.css already has a 'comment' token, so this token will overwrite CSS' 'comment' token
           *     // at its original position
           *     'comment': { ... },
           *     // CSS doesn't have a 'color' token, so this token will be appended
           *     'color': /\b(?:red|green|blue)\b/
           * });
           */ extend: function(id, redef) {
                        var lang2 = _.util.clone(_.languages[id]);
                        for(var key in redef)lang2[key] = redef[key];
                        return lang2;
                    },
                    /**
           * Inserts tokens _before_ another token in a language definition or any other grammar.
           *
           * ## Usage
           *
           * This helper method makes it easy to modify existing languages. For example, the CSS language definition
           * not only defines CSS highlighting for CSS documents, but also needs to define highlighting for CSS embedded
           * in HTML through `<style>` elements. To do this, it needs to modify `Prism.languages.markup` and add the
           * appropriate tokens. However, `Prism.languages.markup` is a regular JavaScript object literal, so if you do
           * this:
           *
           * ```js
           * Prism.languages.markup.style = {
           *     // token
           * };
           * ```
           *
           * then the `style` token will be added (and processed) at the end. `insertBefore` allows you to insert tokens
           * before existing tokens. For the CSS example above, you would use it like this:
           *
           * ```js
           * Prism.languages.insertBefore('markup', 'cdata', {
           *     'style': {
           *         // token
           *     }
           * });
           * ```
           *
           * ## Special cases
           *
           * If the grammars of `inside` and `insert` have tokens with the same name, the tokens in `inside`'s grammar
           * will be ignored.
           *
           * This behavior can be used to insert tokens after `before`:
           *
           * ```js
           * Prism.languages.insertBefore('markup', 'comment', {
           *     'comment': Prism.languages.markup.comment,
           *     // tokens after 'comment'
           * });
           * ```
           *
           * ## Limitations
           *
           * The main problem `insertBefore` has to solve is iteration order. Since ES2015, the iteration order for object
           * properties is guaranteed to be the insertion order (except for integer keys) but some browsers behave
           * differently when keys are deleted and re-inserted. So `insertBefore` can't be implemented by temporarily
           * deleting properties which is necessary to insert at arbitrary positions.
           *
           * To solve this problem, `insertBefore` doesn't actually insert the given tokens into the target object.
           * Instead, it will create a new object and replace all references to the target object with the new one. This
           * can be done without temporarily deleting properties, so the iteration order is well-defined.
           *
           * However, only references that can be reached from `Prism.languages` or `insert` will be replaced. I.e. if
           * you hold the target object in a variable, then the value of the variable will not change.
           *
           * ```js
           * var oldMarkup = Prism.languages.markup;
           * var newMarkup = Prism.languages.insertBefore('markup', 'comment', { ... });
           *
           * assert(oldMarkup !== Prism.languages.markup);
           * assert(newMarkup === Prism.languages.markup);
           * ```
           *
           * @param {string} inside The property of `root` (e.g. a language id in `Prism.languages`) that contains the
           * object to be modified.
           * @param {string} before The key to insert before.
           * @param {Grammar} insert An object containing the key-value pairs to be inserted.
           * @param {Object<string, any>} [root] The object containing `inside`, i.e. the object that contains the
           * object to be modified.
           *
           * Defaults to `Prism.languages`.
           * @returns {Grammar} The new grammar object.
           * @public
           */ insertBefore: function(inside, before, insert, root) {
                        root = root || /** @type {any} */ _.languages;
                        var grammar = root[inside];
                        var ret = {};
                        for(var token in grammar)if (grammar.hasOwnProperty(token)) {
                            if (token == before) {
                                for(var newToken in insert)if (insert.hasOwnProperty(newToken)) ret[newToken] = insert[newToken];
                            }
                            if (!insert.hasOwnProperty(token)) ret[token] = grammar[token];
                        }
                        var old = root[inside];
                        root[inside] = ret;
                        _.languages.DFS(_.languages, function(key, value) {
                            if (value === old && key != inside) this[key] = ret;
                        });
                        return ret;
                    },
                    // Traverse a language definition with Depth First Search
                    DFS: function DFS(o, callback, type, visited) {
                        visited = visited || {};
                        var objId = _.util.objId;
                        for(var i in o)if (o.hasOwnProperty(i)) {
                            callback.call(o, i, o[i], type || i);
                            var property = o[i];
                            var propertyType = _.util.type(property);
                            if (propertyType === "Object" && !visited[objId(property)]) {
                                visited[objId(property)] = true;
                                DFS(property, callback, null, visited);
                            } else if (propertyType === "Array" && !visited[objId(property)]) {
                                visited[objId(property)] = true;
                                DFS(property, callback, i, visited);
                            }
                        }
                    }
                },
                plugins: {},
                /**
         * Low-level function, only use if you know what you’re doing. It accepts a string of text as input
         * and the language definitions to use, and returns a string with the HTML produced.
         *
         * The following hooks will be run:
         * 1. `before-tokenize`
         * 2. `after-tokenize`
         * 3. `wrap`: On each {@link Token}.
         *
         * @param {string} text A string with the code to be highlighted.
         * @param {Grammar} grammar An object containing the tokens to use.
         *
         * Usually a language definition like `Prism.languages.markup`.
         * @param {string} language The name of the language definition passed to `grammar`.
         * @returns {string} The highlighted HTML.
         * @memberof Prism
         * @public
         * @example
         * Prism.highlight('var foo = true;', Prism.languages.javascript, 'javascript');
         */ highlight: function(text, grammar, language) {
                    var env = {
                        code: text,
                        grammar: grammar,
                        language: language
                    };
                    _.hooks.run("before-tokenize", env);
                    if (!env.grammar) throw new Error('The language "' + env.language + '" has no grammar.');
                    env.tokens = _.tokenize(env.code, env.grammar);
                    _.hooks.run("after-tokenize", env);
                    return Token.stringify(_.util.encode(env.tokens), env.language);
                },
                /**
         * This is the heart of Prism, and the most low-level function you can use. It accepts a string of text as input
         * and the language definitions to use, and returns an array with the tokenized code.
         *
         * When the language definition includes nested tokens, the function is called recursively on each of these tokens.
         *
         * This method could be useful in other contexts as well, as a very crude parser.
         *
         * @param {string} text A string with the code to be highlighted.
         * @param {Grammar} grammar An object containing the tokens to use.
         *
         * Usually a language definition like `Prism.languages.markup`.
         * @returns {TokenStream} An array of strings and tokens, a token stream.
         * @memberof Prism
         * @public
         * @example
         * let code = `var foo = 0;`;
         * let tokens = Prism.tokenize(code, Prism.languages.javascript);
         * tokens.forEach(token => {
         *     if (token instanceof Prism.Token && token.type === 'number') {
         *         console.log(`Found numeric literal: ${token.content}`);
         *     }
         * });
         */ tokenize: function(text, grammar) {
                    var rest = grammar.rest;
                    if (rest) {
                        for(var token in rest)grammar[token] = rest[token];
                        delete grammar.rest;
                    }
                    var tokenList = new LinkedList();
                    addAfter(tokenList, tokenList.head, text);
                    matchGrammar(text, tokenList, grammar, tokenList.head, 0);
                    return toArray(tokenList);
                },
                /**
         * @namespace
         * @memberof Prism
         * @public
         */ hooks: {
                    all: {},
                    /**
           * Adds the given callback to the list of callbacks for the given hook.
           *
           * The callback will be invoked when the hook it is registered for is run.
           * Hooks are usually directly run by a highlight function but you can also run hooks yourself.
           *
           * One callback function can be registered to multiple hooks and the same hook multiple times.
           *
           * @param {string} name The name of the hook.
           * @param {HookCallback} callback The callback function which is given environment variables.
           * @public
           */ add: function(name, callback) {
                        var hooks2 = _.hooks.all;
                        hooks2[name] = hooks2[name] || [];
                        hooks2[name].push(callback);
                    },
                    /**
           * Runs a hook invoking all registered callbacks with the given environment variables.
           *
           * Callbacks will be invoked synchronously and in the order in which they were registered.
           *
           * @param {string} name The name of the hook.
           * @param {Object<string, any>} env The environment variables of the hook passed to all callbacks registered.
           * @public
           */ run: function(name, env) {
                        var callbacks = _.hooks.all[name];
                        if (!callbacks || !callbacks.length) return;
                        for(var i = 0, callback; callback = callbacks[i++];)callback(env);
                    }
                },
                Token: Token
            };
            function Token(type, content, alias, matchedStr) {
                this.type = type;
                this.content = content;
                this.alias = alias;
                this.length = (matchedStr || "").length | 0;
            }
            Token.stringify = function stringify(o, language) {
                if (typeof o == "string") return o;
                if (Array.isArray(o)) {
                    var s = "";
                    o.forEach(function(e) {
                        s += stringify(e, language);
                    });
                    return s;
                }
                var env = {
                    type: o.type,
                    content: stringify(o.content, language),
                    tag: "span",
                    classes: [
                        "token",
                        o.type
                    ],
                    attributes: {},
                    language: language
                };
                var aliases = o.alias;
                if (aliases) {
                    if (Array.isArray(aliases)) Array.prototype.push.apply(env.classes, aliases);
                    else env.classes.push(aliases);
                }
                _.hooks.run("wrap", env);
                var attributes = "";
                for(var name in env.attributes)attributes += " " + name + '="' + (env.attributes[name] || "").replace(/"/g, "&quot;") + '"';
                return "<" + env.tag + ' class="' + env.classes.join(" ") + '"' + attributes + ">" + env.content + "</" + env.tag + ">";
            };
            function matchPattern(pattern, pos, text, lookbehind) {
                pattern.lastIndex = pos;
                var match = pattern.exec(text);
                if (match && lookbehind && match[1]) {
                    var lookbehindLength = match[1].length;
                    match.index += lookbehindLength;
                    match[0] = match[0].slice(lookbehindLength);
                }
                return match;
            }
            function matchGrammar(text, tokenList, grammar, startNode, startPos, rematch) {
                for(var token in grammar){
                    if (!grammar.hasOwnProperty(token) || !grammar[token]) continue;
                    var patterns = grammar[token];
                    patterns = Array.isArray(patterns) ? patterns : [
                        patterns
                    ];
                    for(var j = 0; j < patterns.length; ++j){
                        if (rematch && rematch.cause == token + "," + j) return;
                        var patternObj = patterns[j];
                        var inside = patternObj.inside;
                        var lookbehind = !!patternObj.lookbehind;
                        var greedy = !!patternObj.greedy;
                        var alias = patternObj.alias;
                        if (greedy && !patternObj.pattern.global) {
                            var flags = patternObj.pattern.toString().match(/[imsuy]*$/)[0];
                            patternObj.pattern = RegExp(patternObj.pattern.source, flags + "g");
                        }
                        var pattern = patternObj.pattern || patternObj;
                        for(var currentNode = startNode.next, pos = startPos; currentNode !== tokenList.tail; pos += currentNode.value.length, currentNode = currentNode.next){
                            if (rematch && pos >= rematch.reach) break;
                            var str = currentNode.value;
                            if (tokenList.length > text.length) return;
                            if (str instanceof Token) continue;
                            var removeCount = 1;
                            var match;
                            if (greedy) {
                                match = matchPattern(pattern, pos, text, lookbehind);
                                if (!match || match.index >= text.length) break;
                                var from = match.index;
                                var to = match.index + match[0].length;
                                var p = pos;
                                p += currentNode.value.length;
                                while(from >= p){
                                    currentNode = currentNode.next;
                                    p += currentNode.value.length;
                                }
                                p -= currentNode.value.length;
                                pos = p;
                                if (currentNode.value instanceof Token) continue;
                                for(var k = currentNode; k !== tokenList.tail && (p < to || typeof k.value === "string"); k = k.next){
                                    removeCount++;
                                    p += k.value.length;
                                }
                                removeCount--;
                                str = text.slice(pos, p);
                                match.index -= pos;
                            } else {
                                match = matchPattern(pattern, 0, str, lookbehind);
                                if (!match) continue;
                            }
                            var from = match.index;
                            var matchStr = match[0];
                            var before = str.slice(0, from);
                            var after = str.slice(from + matchStr.length);
                            var reach = pos + str.length;
                            if (rematch && reach > rematch.reach) rematch.reach = reach;
                            var removeFrom = currentNode.prev;
                            if (before) {
                                removeFrom = addAfter(tokenList, removeFrom, before);
                                pos += before.length;
                            }
                            removeRange(tokenList, removeFrom, removeCount);
                            var wrapped = new Token(token, inside ? _.tokenize(matchStr, inside) : matchStr, alias, matchStr);
                            currentNode = addAfter(tokenList, removeFrom, wrapped);
                            if (after) addAfter(tokenList, currentNode, after);
                            if (removeCount > 1) {
                                var nestedRematch = {
                                    cause: token + "," + j,
                                    reach: reach
                                };
                                matchGrammar(text, tokenList, grammar, currentNode.prev, pos, nestedRematch);
                                if (rematch && nestedRematch.reach > rematch.reach) rematch.reach = nestedRematch.reach;
                            }
                        }
                    }
                }
            }
            function LinkedList() {
                var head = {
                    value: null,
                    prev: null,
                    next: null
                };
                var tail = {
                    value: null,
                    prev: head,
                    next: null
                };
                head.next = tail;
                this.head = head;
                this.tail = tail;
                this.length = 0;
            }
            function addAfter(list, node, value) {
                var next = node.next;
                var newNode = {
                    value: value,
                    prev: node,
                    next: next
                };
                node.next = newNode;
                next.prev = newNode;
                list.length++;
                return newNode;
            }
            function removeRange(list, node, count) {
                var next = node.next;
                for(var i = 0; i < count && next !== list.tail; i++)next = next.next;
                node.next = next;
                next.prev = node;
                list.length -= i;
            }
            function toArray(list) {
                var array = [];
                var node = list.head.next;
                while(node !== list.tail){
                    array.push(node.value);
                    node = node.next;
                }
                return array;
            }
            return _;
        }();
        module.exports = Prism2;
        Prism2.default = Prism2;
    }
});
// src/prism-langs.ts
var $0fdca79f03e679c4$export$dc7257ffb0972f87 = $0fdca79f03e679c4$var$__toESM($0fdca79f03e679c4$var$require_prism());
$0fdca79f03e679c4$export$dc7257ffb0972f87.languages.markup = {
    comment: {
        pattern: /<!--(?:(?!<!--)[\s\S])*?-->/,
        greedy: true
    },
    prolog: {
        pattern: /<\?[\s\S]+?\?>/,
        greedy: true
    },
    doctype: {
        pattern: /<!DOCTYPE(?:[^>"'[\]]|"[^"]*"|'[^']*')+(?:\[(?:[^<"'\]]|"[^"]*"|'[^']*'|<(?!!--)|<!--(?:[^-]|-(?!->))*-->)*\]\s*)?>/i,
        greedy: true,
        inside: {
            "internal-subset": {
                pattern: /(^[^\[]*\[)[\s\S]+(?=\]>$)/,
                lookbehind: true,
                greedy: true,
                inside: null
            },
            string: {
                pattern: /"[^"]*"|'[^']*'/,
                greedy: true
            },
            punctuation: /^<!|>$|[[\]]/,
            "doctype-tag": /^DOCTYPE/i,
            name: /[^\s<>'"]+/
        }
    },
    cdata: {
        pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
        greedy: true
    },
    tag: {
        pattern: /<\/?(?!\d)[^\s>\/=$<%]+(?:\s(?:\s*[^\s>\/=]+(?:\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))|(?=[\s/>])))+)?\s*\/?>/,
        greedy: true,
        inside: {
            tag: {
                pattern: /^<\/?[^\s>\/]+/,
                inside: {
                    punctuation: /^<\/?/,
                    namespace: /^[^\s>\/:]+:/
                }
            },
            "special-attr": [],
            "attr-value": {
                pattern: /=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+)/,
                inside: {
                    punctuation: [
                        {
                            pattern: /^=/,
                            alias: "attr-equals"
                        },
                        {
                            pattern: /^(\s*)["']|["']$/,
                            lookbehind: true
                        }
                    ]
                }
            },
            punctuation: /\/?>/,
            "attr-name": {
                pattern: /[^\s>\/]+/,
                inside: {
                    namespace: /^[^\s>\/:]+:/
                }
            }
        }
    },
    entity: [
        {
            pattern: /&[\da-z]{1,8};/i,
            alias: "named-entity"
        },
        /&#x?[\da-f]{1,8};/i
    ]
}, $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.markup.tag.inside["attr-value"].inside.entity = $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.markup.entity, $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.markup.doctype.inside["internal-subset"].inside = $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.markup, $0fdca79f03e679c4$export$dc7257ffb0972f87.hooks.add("wrap", function(e) {
    "entity" === e.type && (e.attributes.title = e.content.replace(/&amp;/, "&"));
}), Object.defineProperty($0fdca79f03e679c4$export$dc7257ffb0972f87.languages.markup.tag, "addInlined", {
    value: function(e, n) {
        var t = {}, t = (t["language-" + n] = {
            pattern: /(^<!\[CDATA\[)[\s\S]+?(?=\]\]>$)/i,
            lookbehind: true,
            inside: $0fdca79f03e679c4$export$dc7257ffb0972f87.languages[n]
        }, t.cdata = /^<!\[CDATA\[|\]\]>$/i, {
            "included-cdata": {
                pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
                inside: t
            }
        }), n = (t["language-" + n] = {
            pattern: /[\s\S]+/,
            inside: $0fdca79f03e679c4$export$dc7257ffb0972f87.languages[n]
        }, {});
        n[e] = {
            pattern: RegExp(/(<__[^>]*>)(?:<!\[CDATA\[(?:[^\]]|\](?!\]>))*\]\]>|(?!<!\[CDATA\[)[\s\S])*?(?=<\/__>)/.source.replace(/__/g, function() {
                return e;
            }), "i"),
            lookbehind: true,
            greedy: true,
            inside: t
        }, $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.insertBefore("markup", "cdata", n);
    }
}), Object.defineProperty($0fdca79f03e679c4$export$dc7257ffb0972f87.languages.markup.tag, "addAttribute", {
    value: function(e, n) {
        $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.markup.tag.inside["special-attr"].push({
            pattern: RegExp(/(^|["'\s])/.source + "(?:" + e + ")" + /\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))/.source, "i"),
            lookbehind: true,
            inside: {
                "attr-name": /^[^\s=]+/,
                "attr-value": {
                    pattern: /=[\s\S]+/,
                    inside: {
                        value: {
                            pattern: /(^=\s*(["']|(?!["'])))\S[\s\S]*(?=\2$)/,
                            lookbehind: true,
                            alias: [
                                n,
                                "language-" + n
                            ],
                            inside: $0fdca79f03e679c4$export$dc7257ffb0972f87.languages[n]
                        },
                        punctuation: [
                            {
                                pattern: /^=/,
                                alias: "attr-equals"
                            },
                            /"|'/
                        ]
                    }
                }
            }
        });
    }
}), $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.html = $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.markup, $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.mathml = $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.markup, $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.svg = $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.markup, $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.xml = $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.extend("markup", {}), $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.ssml = $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.xml, $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.atom = $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.xml, $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.rss = $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.xml, function(e) {
    var n = {
        pattern: /\\[\\(){}[\]^$+*?|.]/,
        alias: "escape"
    }, t = /\\(?:x[\da-fA-F]{2}|u[\da-fA-F]{4}|u\{[\da-fA-F]+\}|0[0-7]{0,2}|[123][0-7]{2}|c[a-zA-Z]|.)/, a = "(?:[^\\\\-]|" + t.source + ")", a = RegExp(a + "-" + a), r = {
        pattern: /(<|')[^<>']+(?=[>']$)/,
        lookbehind: true,
        alias: "variable"
    };
    e.languages.regex = {
        "char-class": {
            pattern: /((?:^|[^\\])(?:\\\\)*)\[(?:[^\\\]]|\\[\s\S])*\]/,
            lookbehind: true,
            inside: {
                "char-class-negation": {
                    pattern: /(^\[)\^/,
                    lookbehind: true,
                    alias: "operator"
                },
                "char-class-punctuation": {
                    pattern: /^\[|\]$/,
                    alias: "punctuation"
                },
                range: {
                    pattern: a,
                    inside: {
                        escape: t,
                        "range-punctuation": {
                            pattern: /-/,
                            alias: "operator"
                        }
                    }
                },
                "special-escape": n,
                "char-set": {
                    pattern: /\\[wsd]|\\p\{[^{}]+\}/i,
                    alias: "class-name"
                },
                escape: t
            }
        },
        "special-escape": n,
        "char-set": {
            pattern: /\.|\\[wsd]|\\p\{[^{}]+\}/i,
            alias: "class-name"
        },
        backreference: [
            {
                pattern: /\\(?![123][0-7]{2})[1-9]/,
                alias: "keyword"
            },
            {
                pattern: /\\k<[^<>']+>/,
                alias: "keyword",
                inside: {
                    "group-name": r
                }
            }
        ],
        anchor: {
            pattern: /[$^]|\\[ABbGZz]/,
            alias: "function"
        },
        escape: t,
        group: [
            {
                pattern: /\((?:\?(?:<[^<>']+>|'[^<>']+'|[>:]|<?[=!]|[idmnsuxU]+(?:-[idmnsuxU]+)?:?))?/,
                alias: "punctuation",
                inside: {
                    "group-name": r
                }
            },
            {
                pattern: /\)/,
                alias: "punctuation"
            }
        ],
        quantifier: {
            pattern: /(?:[+*?]|\{\d+(?:,\d*)?\})[?+]?/,
            alias: "number"
        },
        alternation: {
            pattern: /\|/,
            alias: "keyword"
        }
    };
}($0fdca79f03e679c4$export$dc7257ffb0972f87), $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.clike = {
    comment: [
        {
            pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
            lookbehind: true,
            greedy: true
        },
        {
            pattern: /(^|[^\\:])\/\/.*/,
            lookbehind: true,
            greedy: true
        }
    ],
    string: {
        pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
        greedy: true
    },
    "class-name": {
        pattern: /(\b(?:class|extends|implements|instanceof|interface|new|trait)\s+|\bcatch\s+\()[\w.\\]+/i,
        lookbehind: true,
        inside: {
            punctuation: /[.\\]/
        }
    },
    keyword: /\b(?:break|catch|continue|do|else|finally|for|function|if|in|instanceof|new|null|return|throw|try|while)\b/,
    boolean: /\b(?:false|true)\b/,
    function: /\b\w+(?=\()/,
    number: /\b0x[\da-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?/i,
    operator: /[<>]=?|[!=]=?=?|--?|\+\+?|&&?|\|\|?|[?*/~^%]/,
    punctuation: /[{}[\];(),.:]/
}, $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.javascript = $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.extend("clike", {
    "class-name": [
        $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.clike["class-name"],
        {
            pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$A-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\.(?:constructor|prototype))/,
            lookbehind: true
        }
    ],
    keyword: [
        {
            pattern: /((?:^|\})\s*)catch\b/,
            lookbehind: true
        },
        {
            pattern: /(^|[^.]|\.\.\.\s*)\b(?:as|assert(?=\s*\{)|async(?=\s*(?:function\b|\(|[$\w\xA0-\uFFFF]|$))|await|break|case|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally(?=\s*(?:\{|$))|for|from(?=\s*(?:['"]|$))|function|(?:get|set)(?=\s*(?:[#\[$\w\xA0-\uFFFF]|$))|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)\b/,
            lookbehind: true
        }
    ],
    function: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*(?:\.\s*(?:apply|bind|call)\s*)?\()/,
    number: {
        pattern: RegExp(/(^|[^\w$])/.source + "(?:" + /NaN|Infinity/.source + "|" + /0[bB][01]+(?:_[01]+)*n?/.source + "|" + /0[oO][0-7]+(?:_[0-7]+)*n?/.source + "|" + /0[xX][\dA-Fa-f]+(?:_[\dA-Fa-f]+)*n?/.source + "|" + /\d+(?:_\d+)*n/.source + "|" + /(?:\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\.\d+(?:_\d+)*)(?:[Ee][+-]?\d+(?:_\d+)*)?/.source + ")" + /(?![\w$])/.source),
        lookbehind: true
    },
    operator: /--|\+\+|\*\*=?|=>|&&=?|\|\|=?|[!=]==|<<=?|>>>?=?|[-+*/%&|^!=<>]=?|\.{3}|\?\?=?|\?\.?|[~:]/
}), $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.javascript["class-name"][0].pattern = /(\b(?:class|extends|implements|instanceof|interface|new)\s+)[\w.\\]+/, $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.insertBefore("javascript", "keyword", {
    regex: {
        pattern: RegExp(/((?:^|[^$\w\xA0-\uFFFF."'\])\s]|\b(?:return|yield))\s*)/.source + /\//.source + "(?:" + /(?:\[(?:[^\]\\\r\n]|\\.)*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}/.source + "|" + /(?:\[(?:[^[\]\\\r\n]|\\.|\[(?:[^[\]\\\r\n]|\\.|\[(?:[^[\]\\\r\n]|\\.)*\])*\])*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}v[dgimyus]{0,7}/.source + ")" + /(?=(?:\s|\/\*(?:[^*]|\*(?!\/))*\*\/)*(?:$|[\r\n,.;:})\]]|\/\/))/.source),
        lookbehind: true,
        greedy: true,
        inside: {
            "regex-source": {
                pattern: /^(\/)[\s\S]+(?=\/[a-z]*$)/,
                lookbehind: true,
                alias: "language-regex",
                inside: $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.regex
            },
            "regex-delimiter": /^\/|\/$/,
            "regex-flags": /^[a-z]+$/
        }
    },
    "function-variable": {
        pattern: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*[=:]\s*(?:async\s*)?(?:\bfunction\b|(?:\((?:[^()]|\([^()]*\))*\)|(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)\s*=>))/,
        alias: "function"
    },
    parameter: [
        {
            pattern: /(function(?:\s+(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)?\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\))/,
            lookbehind: true,
            inside: $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.javascript
        },
        {
            pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$a-z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*=>)/i,
            lookbehind: true,
            inside: $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.javascript
        },
        {
            pattern: /(\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*=>)/,
            lookbehind: true,
            inside: $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.javascript
        },
        {
            pattern: /((?:\b|\s|^)(?!(?:as|async|await|break|case|catch|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally|for|from|function|get|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|set|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)(?![$\w\xA0-\uFFFF]))(?:(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*)\(\s*|\]\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*\{)/,
            lookbehind: true,
            inside: $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.javascript
        }
    ],
    constant: /\b[A-Z](?:[A-Z_]|\dx?)*\b/
}), $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.insertBefore("javascript", "string", {
    hashbang: {
        pattern: /^#!.*/,
        greedy: true,
        alias: "comment"
    },
    "template-string": {
        pattern: /`(?:\\[\s\S]|\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}|(?!\$\{)[^\\`])*`/,
        greedy: true,
        inside: {
            "template-punctuation": {
                pattern: /^`|`$/,
                alias: "string"
            },
            interpolation: {
                pattern: /((?:^|[^\\])(?:\\{2})*)\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}/,
                lookbehind: true,
                inside: {
                    "interpolation-punctuation": {
                        pattern: /^\$\{|\}$/,
                        alias: "punctuation"
                    },
                    rest: $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.javascript
                }
            },
            string: /[\s\S]+/
        }
    },
    "string-property": {
        pattern: /((?:^|[,{])[ \t]*)(["'])(?:\\(?:\r\n|[\s\S])|(?!\2)[^\\\r\n])*\2(?=\s*:)/m,
        lookbehind: true,
        greedy: true,
        alias: "property"
    }
}), $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.insertBefore("javascript", "operator", {
    "literal-property": {
        pattern: /((?:^|[,{])[ \t]*)(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*:)/m,
        lookbehind: true,
        alias: "property"
    }
}), $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.markup && ($0fdca79f03e679c4$export$dc7257ffb0972f87.languages.markup.tag.addInlined("script", "javascript"), $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.markup.tag.addAttribute(/on(?:abort|blur|change|click|composition(?:end|start|update)|dblclick|error|focus(?:in|out)?|key(?:down|up)|load|mouse(?:down|enter|leave|move|out|over|up)|reset|resize|scroll|select|slotchange|submit|unload|wheel)/.source, "javascript")), $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.js = $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.javascript, $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.actionscript = $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.extend("javascript", {
    keyword: /\b(?:as|break|case|catch|class|const|default|delete|do|dynamic|each|else|extends|final|finally|for|function|get|if|implements|import|in|include|instanceof|interface|internal|is|namespace|native|new|null|override|package|private|protected|public|return|set|static|super|switch|this|throw|try|typeof|use|var|void|while|with)\b/,
    operator: /\+\+|--|(?:[+\-*\/%^]|&&?|\|\|?|<<?|>>?>?|[!=]=?)=?|[~?@]/
}), $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.actionscript["class-name"].alias = "function", delete $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.actionscript.parameter, delete $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.actionscript["literal-property"], $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.markup && $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.insertBefore("actionscript", "string", {
    xml: {
        pattern: /(^|[^.])<\/?\w+(?:\s+[^\s>\/=]+=("|')(?:\\[\s\S]|(?!\2)[^\\])*\2)*\s*\/?>/,
        lookbehind: true,
        inside: $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.markup
    }
}), function(e) {
    var n = /#(?!\{).+/, t = {
        pattern: /#\{[^}]+\}/,
        alias: "variable"
    };
    e.languages.coffeescript = e.languages.extend("javascript", {
        comment: n,
        string: [
            {
                pattern: /'(?:\\[\s\S]|[^\\'])*'/,
                greedy: true
            },
            {
                pattern: /"(?:\\[\s\S]|[^\\"])*"/,
                greedy: true,
                inside: {
                    interpolation: t
                }
            }
        ],
        keyword: /\b(?:and|break|by|catch|class|continue|debugger|delete|do|each|else|extend|extends|false|finally|for|if|in|instanceof|is|isnt|let|loop|namespace|new|no|not|null|of|off|on|or|own|return|super|switch|then|this|throw|true|try|typeof|undefined|unless|until|when|while|window|with|yes|yield)\b/,
        "class-member": {
            pattern: /@(?!\d)\w+/,
            alias: "variable"
        }
    }), e.languages.insertBefore("coffeescript", "comment", {
        "multiline-comment": {
            pattern: /###[\s\S]+?###/,
            alias: "comment"
        },
        "block-regex": {
            pattern: /\/{3}[\s\S]*?\/{3}/,
            alias: "regex",
            inside: {
                comment: n,
                interpolation: t
            }
        }
    }), e.languages.insertBefore("coffeescript", "string", {
        "inline-javascript": {
            pattern: /`(?:\\[\s\S]|[^\\`])*`/,
            inside: {
                delimiter: {
                    pattern: /^`|`$/,
                    alias: "punctuation"
                },
                script: {
                    pattern: /[\s\S]+/,
                    alias: "language-javascript",
                    inside: e.languages.javascript
                }
            }
        },
        "multiline-string": [
            {
                pattern: /'''[\s\S]*?'''/,
                greedy: true,
                alias: "string"
            },
            {
                pattern: /"""[\s\S]*?"""/,
                greedy: true,
                alias: "string",
                inside: {
                    interpolation: t
                }
            }
        ]
    }), e.languages.insertBefore("coffeescript", "keyword", {
        property: /(?!\d)\w+(?=\s*:(?!:))/
    }), delete e.languages.coffeescript["template-string"], e.languages.coffee = e.languages.coffeescript;
}($0fdca79f03e679c4$export$dc7257ffb0972f87), function(l) {
    var e = l.languages.javadoclike = {
        parameter: {
            pattern: /(^[\t ]*(?:\/{3}|\*|\/\*\*)\s*@(?:arg|arguments|param)\s+)\w+/m,
            lookbehind: true
        },
        keyword: {
            pattern: /(^[\t ]*(?:\/{3}|\*|\/\*\*)\s*|\{)@[a-z][a-zA-Z-]+\b/m,
            lookbehind: true
        },
        punctuation: /[{}]/
    };
    Object.defineProperty(e, "addSupport", {
        value: function(e2, o) {
            (e2 = "string" == typeof e2 ? [
                e2
            ] : e2).forEach(function(e3) {
                var n = function(e4) {
                    e4.inside || (e4.inside = {}), e4.inside.rest = o;
                }, t = "doc-comment";
                if (a = l.languages[e3]) {
                    var a, r = a[t];
                    if ((r = r ? r : (a = l.languages.insertBefore(e3, "comment", {
                        "doc-comment": {
                            pattern: /(^|[^\\])\/\*\*[^/][\s\S]*?(?:\*\/|$)/,
                            lookbehind: true,
                            alias: "comment"
                        }
                    }))[t]) instanceof RegExp && (r = a[t] = {
                        pattern: r
                    }), Array.isArray(r)) for(var s = 0, i = r.length; s < i; s++)r[s] instanceof RegExp && (r[s] = {
                        pattern: r[s]
                    }), n(r[s]);
                    else n(r);
                }
            });
        }
    }), e.addSupport([
        "java",
        "javascript",
        "php"
    ], e);
}($0fdca79f03e679c4$export$dc7257ffb0972f87), function(e) {
    var n = /(?:"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"|'(?:\\(?:\r\n|[\s\S])|[^'\\\r\n])*')/, n = (e.languages.css = {
        comment: /\/\*[\s\S]*?\*\//,
        atrule: {
            pattern: RegExp("@[\\w-](?:" + /[^;{\s"']|\s+(?!\s)/.source + "|" + n.source + ")*?" + /(?:;|(?=\s*\{))/.source),
            inside: {
                rule: /^@[\w-]+/,
                "selector-function-argument": {
                    pattern: /(\bselector\s*\(\s*(?![\s)]))(?:[^()\s]|\s+(?![\s)])|\((?:[^()]|\([^()]*\))*\))+(?=\s*\))/,
                    lookbehind: true,
                    alias: "selector"
                },
                keyword: {
                    pattern: /(^|[^\w-])(?:and|not|only|or)(?![\w-])/,
                    lookbehind: true
                }
            }
        },
        url: {
            pattern: RegExp("\\burl\\((?:" + n.source + "|" + /(?:[^\\\r\n()"']|\\[\s\S])*/.source + ")\\)", "i"),
            greedy: true,
            inside: {
                function: /^url/i,
                punctuation: /^\(|\)$/,
                string: {
                    pattern: RegExp("^" + n.source + "$"),
                    alias: "url"
                }
            }
        },
        selector: {
            pattern: RegExp(`(^|[{}\\s])[^{}\\s](?:[^{};"'\\s]|\\s+(?![\\s{])|` + n.source + ")*(?=\\s*\\{)"),
            lookbehind: true
        },
        string: {
            pattern: n,
            greedy: true
        },
        property: {
            pattern: /(^|[^-\w\xA0-\uFFFF])(?!\s)[-_a-z\xA0-\uFFFF](?:(?!\s)[-\w\xA0-\uFFFF])*(?=\s*:)/i,
            lookbehind: true
        },
        important: /!important\b/i,
        function: {
            pattern: /(^|[^-a-z0-9])[-a-z0-9]+(?=\()/i,
            lookbehind: true
        },
        punctuation: /[(){};:,]/
    }, e.languages.css.atrule.inside.rest = e.languages.css, e.languages.markup);
    n && (n.tag.addInlined("style", "css"), n.tag.addAttribute("style", "css"));
}($0fdca79f03e679c4$export$dc7257ffb0972f87), function(e) {
    var n = /("|')(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/, n = (e.languages.css.selector = {
        pattern: e.languages.css.selector.pattern,
        lookbehind: true,
        inside: n = {
            "pseudo-element": /:(?:after|before|first-letter|first-line|selection)|::[-\w]+/,
            "pseudo-class": /:[-\w]+/,
            class: /\.[-\w]+/,
            id: /#[-\w]+/,
            attribute: {
                pattern: RegExp(`\\[(?:[^[\\]"']|` + n.source + ")*\\]"),
                greedy: true,
                inside: {
                    punctuation: /^\[|\]$/,
                    "case-sensitivity": {
                        pattern: /(\s)[si]$/i,
                        lookbehind: true,
                        alias: "keyword"
                    },
                    namespace: {
                        pattern: /^(\s*)(?:(?!\s)[-*\w\xA0-\uFFFF])*\|(?!=)/,
                        lookbehind: true,
                        inside: {
                            punctuation: /\|$/
                        }
                    },
                    "attr-name": {
                        pattern: /^(\s*)(?:(?!\s)[-\w\xA0-\uFFFF])+/,
                        lookbehind: true
                    },
                    "attr-value": [
                        n,
                        {
                            pattern: /(=\s*)(?:(?!\s)[-\w\xA0-\uFFFF])+(?=\s*$)/,
                            lookbehind: true
                        }
                    ],
                    operator: /[|~*^$]?=/
                }
            },
            "n-th": [
                {
                    pattern: /(\(\s*)[+-]?\d*[\dn](?:\s*[+-]\s*\d+)?(?=\s*\))/,
                    lookbehind: true,
                    inside: {
                        number: /[\dn]+/,
                        operator: /[+-]/
                    }
                },
                {
                    pattern: /(\(\s*)(?:even|odd)(?=\s*\))/i,
                    lookbehind: true
                }
            ],
            combinator: />|\+|~|\|\|/,
            punctuation: /[(),]/
        }
    }, e.languages.css.atrule.inside["selector-function-argument"].inside = n, e.languages.insertBefore("css", "property", {
        variable: {
            pattern: /(^|[^-\w\xA0-\uFFFF])--(?!\s)[-_a-z\xA0-\uFFFF](?:(?!\s)[-\w\xA0-\uFFFF])*/i,
            lookbehind: true
        }
    }), {
        pattern: /(\b\d+)(?:%|[a-z]+(?![\w-]))/,
        lookbehind: true
    }), t = {
        pattern: /(^|[^\w.-])-?(?:\d+(?:\.\d+)?|\.\d+)/,
        lookbehind: true
    };
    e.languages.insertBefore("css", "function", {
        operator: {
            pattern: /(\s)[+\-*\/](?=\s)/,
            lookbehind: true
        },
        hexcode: {
            pattern: /\B#[\da-f]{3,8}\b/i,
            alias: "color"
        },
        color: [
            {
                pattern: /(^|[^\w-])(?:AliceBlue|AntiqueWhite|Aqua|Aquamarine|Azure|Beige|Bisque|Black|BlanchedAlmond|Blue|BlueViolet|Brown|BurlyWood|CadetBlue|Chartreuse|Chocolate|Coral|CornflowerBlue|Cornsilk|Crimson|Cyan|DarkBlue|DarkCyan|DarkGoldenRod|DarkGr[ae]y|DarkGreen|DarkKhaki|DarkMagenta|DarkOliveGreen|DarkOrange|DarkOrchid|DarkRed|DarkSalmon|DarkSeaGreen|DarkSlateBlue|DarkSlateGr[ae]y|DarkTurquoise|DarkViolet|DeepPink|DeepSkyBlue|DimGr[ae]y|DodgerBlue|FireBrick|FloralWhite|ForestGreen|Fuchsia|Gainsboro|GhostWhite|Gold|GoldenRod|Gr[ae]y|Green|GreenYellow|HoneyDew|HotPink|IndianRed|Indigo|Ivory|Khaki|Lavender|LavenderBlush|LawnGreen|LemonChiffon|LightBlue|LightCoral|LightCyan|LightGoldenRodYellow|LightGr[ae]y|LightGreen|LightPink|LightSalmon|LightSeaGreen|LightSkyBlue|LightSlateGr[ae]y|LightSteelBlue|LightYellow|Lime|LimeGreen|Linen|Magenta|Maroon|MediumAquaMarine|MediumBlue|MediumOrchid|MediumPurple|MediumSeaGreen|MediumSlateBlue|MediumSpringGreen|MediumTurquoise|MediumVioletRed|MidnightBlue|MintCream|MistyRose|Moccasin|NavajoWhite|Navy|OldLace|Olive|OliveDrab|Orange|OrangeRed|Orchid|PaleGoldenRod|PaleGreen|PaleTurquoise|PaleVioletRed|PapayaWhip|PeachPuff|Peru|Pink|Plum|PowderBlue|Purple|RebeccaPurple|Red|RosyBrown|RoyalBlue|SaddleBrown|Salmon|SandyBrown|SeaGreen|SeaShell|Sienna|Silver|SkyBlue|SlateBlue|SlateGr[ae]y|Snow|SpringGreen|SteelBlue|Tan|Teal|Thistle|Tomato|Transparent|Turquoise|Violet|Wheat|White|WhiteSmoke|Yellow|YellowGreen)(?![\w-])/i,
                lookbehind: true
            },
            {
                pattern: /\b(?:hsl|rgb)\(\s*\d{1,3}\s*,\s*\d{1,3}%?\s*,\s*\d{1,3}%?\s*\)\B|\b(?:hsl|rgb)a\(\s*\d{1,3}\s*,\s*\d{1,3}%?\s*,\s*\d{1,3}%?\s*,\s*(?:0|0?\.\d+|1)\s*\)\B/i,
                inside: {
                    unit: n,
                    number: t,
                    function: /[\w-]+(?=\()/,
                    punctuation: /[(),]/
                }
            }
        ],
        entity: /\\[\da-f]{1,8}/i,
        unit: n,
        number: t
    });
}($0fdca79f03e679c4$export$dc7257ffb0972f87), function(e) {
    var n = /[*&][^\s[\]{},]+/, t = /!(?:<[\w\-%#;/?:@&=+$,.!~*'()[\]]+>|(?:[a-zA-Z\d-]*!)?[\w\-%#;/?:@&=+$.~*'()]+)?/, a = "(?:" + t.source + "(?:[ 	]+" + n.source + ")?|" + n.source + "(?:[ 	]+" + t.source + ")?)", r = /(?:[^\s\x00-\x08\x0e-\x1f!"#%&'*,\-:>?@[\]`{|}\x7f-\x84\x86-\x9f\ud800-\udfff\ufffe\uffff]|[?:-]<PLAIN>)(?:[ \t]*(?:(?![#:])<PLAIN>|:<PLAIN>))*/.source.replace(/<PLAIN>/g, function() {
        return /[^\s\x00-\x08\x0e-\x1f,[\]{}\x7f-\x84\x86-\x9f\ud800-\udfff\ufffe\uffff]/.source;
    }), s = /"(?:[^"\\\r\n]|\\.)*"|'(?:[^'\\\r\n]|\\.)*'/.source;
    function i(e2, n2) {
        n2 = (n2 || "").replace(/m/g, "") + "m";
        var t2 = /([:\-,[{]\s*(?:\s<<prop>>[ \t]+)?)(?:<<value>>)(?=[ \t]*(?:$|,|\]|\}|(?:[\r\n]\s*)?#))/.source.replace(/<<prop>>/g, function() {
            return a;
        }).replace(/<<value>>/g, function() {
            return e2;
        });
        return RegExp(t2, n2);
    }
    e.languages.yaml = {
        scalar: {
            pattern: RegExp(/([\-:]\s*(?:\s<<prop>>[ \t]+)?[|>])[ \t]*(?:((?:\r?\n|\r)[ \t]+)\S[^\r\n]*(?:\2[^\r\n]+)*)/.source.replace(/<<prop>>/g, function() {
                return a;
            })),
            lookbehind: true,
            alias: "string"
        },
        comment: /#.*/,
        key: {
            pattern: RegExp(/((?:^|[:\-,[{\r\n?])[ \t]*(?:<<prop>>[ \t]+)?)<<key>>(?=\s*:\s)/.source.replace(/<<prop>>/g, function() {
                return a;
            }).replace(/<<key>>/g, function() {
                return "(?:" + r + "|" + s + ")";
            })),
            lookbehind: true,
            greedy: true,
            alias: "atrule"
        },
        directive: {
            pattern: /(^[ \t]*)%.+/m,
            lookbehind: true,
            alias: "important"
        },
        datetime: {
            pattern: i(/\d{4}-\d\d?-\d\d?(?:[tT]|[ \t]+)\d\d?:\d{2}:\d{2}(?:\.\d*)?(?:[ \t]*(?:Z|[-+]\d\d?(?::\d{2})?))?|\d{4}-\d{2}-\d{2}|\d\d?:\d{2}(?::\d{2}(?:\.\d*)?)?/.source),
            lookbehind: true,
            alias: "number"
        },
        boolean: {
            pattern: i(/false|true/.source, "i"),
            lookbehind: true,
            alias: "important"
        },
        null: {
            pattern: i(/null|~/.source, "i"),
            lookbehind: true,
            alias: "important"
        },
        string: {
            pattern: i(s),
            lookbehind: true,
            greedy: true
        },
        number: {
            pattern: i(/[+-]?(?:0x[\da-f]+|0o[0-7]+|(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?|\.inf|\.nan)/.source, "i"),
            lookbehind: true
        },
        tag: t,
        important: n,
        punctuation: /---|[:[\]{}\-,|>?]|\.\.\./
    }, e.languages.yml = e.languages.yaml;
}($0fdca79f03e679c4$export$dc7257ffb0972f87), function(o) {
    var n = /(?:\\.|[^\\\n\r]|(?:\n|\r\n?)(?![\r\n]))/.source;
    function e(e2) {
        return e2 = e2.replace(/<inner>/g, function() {
            return n;
        }), RegExp(/((?:^|[^\\])(?:\\{2})*)/.source + "(?:" + e2 + ")");
    }
    var t = /(?:\\.|``(?:[^`\r\n]|`(?!`))+``|`[^`\r\n]+`|[^\\|\r\n`])+/.source, a = /\|?__(?:\|__)+\|?(?:(?:\n|\r\n?)|(?![\s\S]))/.source.replace(/__/g, function() {
        return t;
    }), r = /\|?[ \t]*:?-{3,}:?[ \t]*(?:\|[ \t]*:?-{3,}:?[ \t]*)+\|?(?:\n|\r\n?)/.source, l = (o.languages.markdown = o.languages.extend("markup", {}), o.languages.insertBefore("markdown", "prolog", {
        "front-matter-block": {
            pattern: /(^(?:\s*[\r\n])?)---(?!.)[\s\S]*?[\r\n]---(?!.)/,
            lookbehind: true,
            greedy: true,
            inside: {
                punctuation: /^---|---$/,
                "front-matter": {
                    pattern: /\S+(?:\s+\S+)*/,
                    alias: [
                        "yaml",
                        "language-yaml"
                    ],
                    inside: o.languages.yaml
                }
            }
        },
        blockquote: {
            pattern: /^>(?:[\t ]*>)*/m,
            alias: "punctuation"
        },
        table: {
            pattern: RegExp("^" + a + r + "(?:" + a + ")*", "m"),
            inside: {
                "table-data-rows": {
                    pattern: RegExp("^(" + a + r + ")(?:" + a + ")*$"),
                    lookbehind: true,
                    inside: {
                        "table-data": {
                            pattern: RegExp(t),
                            inside: o.languages.markdown
                        },
                        punctuation: /\|/
                    }
                },
                "table-line": {
                    pattern: RegExp("^(" + a + ")" + r + "$"),
                    lookbehind: true,
                    inside: {
                        punctuation: /\||:?-{3,}:?/
                    }
                },
                "table-header-row": {
                    pattern: RegExp("^" + a + "$"),
                    inside: {
                        "table-header": {
                            pattern: RegExp(t),
                            alias: "important",
                            inside: o.languages.markdown
                        },
                        punctuation: /\|/
                    }
                }
            }
        },
        code: [
            {
                pattern: /((?:^|\n)[ \t]*\n|(?:^|\r\n?)[ \t]*\r\n?)(?: {4}|\t).+(?:(?:\n|\r\n?)(?: {4}|\t).+)*/,
                lookbehind: true,
                alias: "keyword"
            },
            {
                pattern: /^```[\s\S]*?^```$/m,
                greedy: true,
                inside: {
                    "code-block": {
                        pattern: /^(```.*(?:\n|\r\n?))[\s\S]+?(?=(?:\n|\r\n?)^```$)/m,
                        lookbehind: true
                    },
                    "code-language": {
                        pattern: /^(```).+/,
                        lookbehind: true
                    },
                    punctuation: /```/
                }
            }
        ],
        title: [
            {
                pattern: /\S.*(?:\n|\r\n?)(?:==+|--+)(?=[ \t]*$)/m,
                alias: "important",
                inside: {
                    punctuation: /==+$|--+$/
                }
            },
            {
                pattern: /(^\s*)#.+/m,
                lookbehind: true,
                alias: "important",
                inside: {
                    punctuation: /^#+|#+$/
                }
            }
        ],
        hr: {
            pattern: /(^\s*)([*-])(?:[\t ]*\2){2,}(?=\s*$)/m,
            lookbehind: true,
            alias: "punctuation"
        },
        list: {
            pattern: /(^\s*)(?:[*+-]|\d+\.)(?=[\t ].)/m,
            lookbehind: true,
            alias: "punctuation"
        },
        "url-reference": {
            pattern: /!?\[[^\]]+\]:[\t ]+(?:\S+|<(?:\\.|[^>\\])+>)(?:[\t ]+(?:"(?:\\.|[^"\\])*"|'(?:\\.|[^'\\])*'|\((?:\\.|[^)\\])*\)))?/,
            inside: {
                variable: {
                    pattern: /^(!?\[)[^\]]+/,
                    lookbehind: true
                },
                string: /(?:"(?:\\.|[^"\\])*"|'(?:\\.|[^'\\])*'|\((?:\\.|[^)\\])*\))$/,
                punctuation: /^[\[\]!:]|[<>]/
            },
            alias: "url"
        },
        bold: {
            pattern: e(/\b__(?:(?!_)<inner>|_(?:(?!_)<inner>)+_)+__\b|\*\*(?:(?!\*)<inner>|\*(?:(?!\*)<inner>)+\*)+\*\*/.source),
            lookbehind: true,
            greedy: true,
            inside: {
                content: {
                    pattern: /(^..)[\s\S]+(?=..$)/,
                    lookbehind: true,
                    inside: {}
                },
                punctuation: /\*\*|__/
            }
        },
        italic: {
            pattern: e(/\b_(?:(?!_)<inner>|__(?:(?!_)<inner>)+__)+_\b|\*(?:(?!\*)<inner>|\*\*(?:(?!\*)<inner>)+\*\*)+\*/.source),
            lookbehind: true,
            greedy: true,
            inside: {
                content: {
                    pattern: /(^.)[\s\S]+(?=.$)/,
                    lookbehind: true,
                    inside: {}
                },
                punctuation: /[*_]/
            }
        },
        strike: {
            pattern: e(/(~~?)(?:(?!~)<inner>)+\2/.source),
            lookbehind: true,
            greedy: true,
            inside: {
                content: {
                    pattern: /(^~~?)[\s\S]+(?=\1$)/,
                    lookbehind: true,
                    inside: {}
                },
                punctuation: /~~?/
            }
        },
        "code-snippet": {
            pattern: /(^|[^\\`])(?:``[^`\r\n]+(?:`[^`\r\n]+)*``(?!`)|`[^`\r\n]+`(?!`))/,
            lookbehind: true,
            greedy: true,
            alias: [
                "code",
                "keyword"
            ]
        },
        url: {
            pattern: e(/!?\[(?:(?!\])<inner>)+\](?:\([^\s)]+(?:[\t ]+"(?:\\.|[^"\\])*")?\)|[ \t]?\[(?:(?!\])<inner>)+\])/.source),
            lookbehind: true,
            greedy: true,
            inside: {
                operator: /^!/,
                content: {
                    pattern: /(^\[)[^\]]+(?=\])/,
                    lookbehind: true,
                    inside: {}
                },
                variable: {
                    pattern: /(^\][ \t]?\[)[^\]]+(?=\]$)/,
                    lookbehind: true
                },
                url: {
                    pattern: /(^\]\()[^\s)]+/,
                    lookbehind: true
                },
                string: {
                    pattern: /(^[ \t]+)"(?:\\.|[^"\\])*"(?=\)$)/,
                    lookbehind: true
                }
            }
        }
    }), [
        "url",
        "bold",
        "italic",
        "strike"
    ].forEach(function(n2) {
        [
            "url",
            "bold",
            "italic",
            "strike",
            "code-snippet"
        ].forEach(function(e2) {
            n2 !== e2 && (o.languages.markdown[n2].inside.content.inside[e2] = o.languages.markdown[e2]);
        });
    }), o.hooks.add("after-tokenize", function(e2) {
        "markdown" !== e2.language && "md" !== e2.language || !function e3(n2) {
            if (n2 && "string" != typeof n2) for(var t2 = 0, a2 = n2.length; t2 < a2; t2++){
                var r2, s = n2[t2];
                "code" !== s.type ? e3(s.content) : (r2 = s.content[1], s = s.content[3], r2 && s && "code-language" === r2.type && "code-block" === s.type && "string" == typeof r2.content && (r2 = r2.content.replace(/\b#/g, "sharp").replace(/\b\+\+/g, "pp"), r2 = "language-" + (r2 = (/[a-z][\w-]*/i.exec(r2) || [
                    ""
                ])[0].toLowerCase()), s.alias ? "string" == typeof s.alias ? s.alias = [
                    s.alias,
                    r2
                ] : s.alias.push(r2) : s.alias = [
                    r2
                ]));
            }
        }(e2.tokens);
    }), o.hooks.add("wrap", function(e2) {
        if ("code-block" === e2.type) {
            for(var n2 = "", t2 = 0, a2 = e2.classes.length; t2 < a2; t2++){
                var r2 = e2.classes[t2], r2 = /language-(.+)/.exec(r2);
                if (r2) {
                    n2 = r2[1];
                    break;
                }
            }
            var s, i = o.languages[n2];
            i ? e2.content = o.highlight(function(e3) {
                e3 = e3.replace(l, "");
                return e3 = e3.replace(/&(\w{1,8}|#x?[\da-f]{1,8});/gi, function(e4, n3) {
                    var t3;
                    return "#" === (n3 = n3.toLowerCase())[0] ? (t3 = "x" === n3[1] ? parseInt(n3.slice(2), 16) : Number(n3.slice(1)), c(t3)) : u[n3] || e4;
                });
            }(e2.content), i, n2) : n2 && "none" !== n2 && o.plugins.autoloader && (s = "md-" + /* @__PURE__ */ new Date().valueOf() + "-" + Math.floor(1e16 * Math.random()), e2.attributes.id = s, o.plugins.autoloader.loadLanguages(n2, function() {
                var e3 = document.getElementById(s);
                e3 && (e3.innerHTML = o.highlight(e3.textContent, o.languages[n2], n2));
            }));
        }
    }), RegExp(o.languages.markup.tag.pattern.source, "gi")), u = {
        amp: "&",
        lt: "<",
        gt: ">",
        quot: '"'
    }, c = String.fromCodePoint || String.fromCharCode;
    o.languages.md = o.languages.markdown;
}($0fdca79f03e679c4$export$dc7257ffb0972f87), $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.graphql = {
    comment: /#.*/,
    description: {
        pattern: /(?:"""(?:[^"]|(?!""")")*"""|"(?:\\.|[^\\"\r\n])*")(?=\s*[a-z_])/i,
        greedy: true,
        alias: "string",
        inside: {
            "language-markdown": {
                pattern: /(^"(?:"")?)(?!\1)[\s\S]+(?=\1$)/,
                lookbehind: true,
                inside: $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.markdown
            }
        }
    },
    string: {
        pattern: /"""(?:[^"]|(?!""")")*"""|"(?:\\.|[^\\"\r\n])*"/,
        greedy: true
    },
    number: /(?:\B-|\b)\d+(?:\.\d+)?(?:e[+-]?\d+)?\b/i,
    boolean: /\b(?:false|true)\b/,
    variable: /\$[a-z_]\w*/i,
    directive: {
        pattern: /@[a-z_]\w*/i,
        alias: "function"
    },
    "attr-name": {
        pattern: /\b[a-z_]\w*(?=\s*(?:\((?:[^()"]|"(?:\\.|[^\\"\r\n])*")*\))?:)/i,
        greedy: true
    },
    "atom-input": {
        pattern: /\b[A-Z]\w*Input\b/,
        alias: "class-name"
    },
    scalar: /\b(?:Boolean|Float|ID|Int|String)\b/,
    constant: /\b[A-Z][A-Z_\d]*\b/,
    "class-name": {
        pattern: /(\b(?:enum|implements|interface|on|scalar|type|union)\s+|&\s*|:\s*|\[)[A-Z_]\w*/,
        lookbehind: true
    },
    fragment: {
        pattern: /(\bfragment\s+|\.{3}\s*(?!on\b))[a-zA-Z_]\w*/,
        lookbehind: true,
        alias: "function"
    },
    "definition-mutation": {
        pattern: /(\bmutation\s+)[a-zA-Z_]\w*/,
        lookbehind: true,
        alias: "function"
    },
    "definition-query": {
        pattern: /(\bquery\s+)[a-zA-Z_]\w*/,
        lookbehind: true,
        alias: "function"
    },
    keyword: /\b(?:directive|enum|extend|fragment|implements|input|interface|mutation|on|query|repeatable|scalar|schema|subscription|type|union)\b/,
    operator: /[!=|&]|\.{3}/,
    "property-query": /\w+(?=\s*\()/,
    object: /\w+(?=\s*\{)/,
    punctuation: /[!(){}\[\]:=,]/,
    property: /\w+/
}, $0fdca79f03e679c4$export$dc7257ffb0972f87.hooks.add("after-tokenize", function(e) {
    if ("graphql" === e.language) for(var i = e.tokens.filter(function(e2) {
        return "string" != typeof e2 && "comment" !== e2.type && "scalar" !== e2.type;
    }), o = 0; o < i.length;){
        var n = i[o++];
        if ("keyword" === n.type && "mutation" === n.content) {
            var t = [];
            if (p([
                "definition-mutation",
                "punctuation"
            ]) && "(" === c(1).content) {
                o += 2;
                var a = d(/^\($/, /^\)$/);
                if (-1 === a) continue;
                for(; o < a; o++){
                    var r = c(0);
                    "variable" === r.type && (g(r, "variable-input"), t.push(r.content));
                }
                o = a + 1;
            }
            if (p([
                "punctuation",
                "property-query"
            ]) && "{" === c(0).content && (o++, g(c(0), "property-mutation"), 0 < t.length)) {
                var s = d(/^\{$/, /^\}$/);
                if (-1 !== s) for(var l = o; l < s; l++){
                    var u = i[l];
                    "variable" === u.type && 0 <= t.indexOf(u.content) && g(u, "variable-input");
                }
            }
        }
    }
    function c(e2) {
        return i[o + e2];
    }
    function p(e2, n2) {
        n2 = n2 || 0;
        for(var t2 = 0; t2 < e2.length; t2++){
            var a2 = c(t2 + n2);
            if (!a2 || a2.type !== e2[t2]) return;
        }
        return 1;
    }
    function d(e2, n2) {
        for(var t2 = 1, a2 = o; a2 < i.length; a2++){
            var r2 = i[a2], s2 = r2.content;
            if ("punctuation" === r2.type && "string" == typeof s2) {
                if (e2.test(s2)) t2++;
                else if (n2.test(s2) && 0 === --t2) return a2;
            }
        }
        return -1;
    }
    function g(e2, n2) {
        var t2 = e2.alias;
        t2 ? Array.isArray(t2) || (e2.alias = t2 = [
            t2
        ]) : e2.alias = t2 = [], t2.push(n2);
    }
}), $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.sql = {
    comment: {
        pattern: /(^|[^\\])(?:\/\*[\s\S]*?\*\/|(?:--|\/\/|#).*)/,
        lookbehind: true
    },
    variable: [
        {
            pattern: /@(["'`])(?:\\[\s\S]|(?!\1)[^\\])+\1/,
            greedy: true
        },
        /@[\w.$]+/
    ],
    string: {
        pattern: /(^|[^@\\])("|')(?:\\[\s\S]|(?!\2)[^\\]|\2\2)*\2/,
        greedy: true,
        lookbehind: true
    },
    identifier: {
        pattern: /(^|[^@\\])`(?:\\[\s\S]|[^`\\]|``)*`/,
        greedy: true,
        lookbehind: true,
        inside: {
            punctuation: /^`|`$/
        }
    },
    function: /\b(?:AVG|COUNT|FIRST|FORMAT|LAST|LCASE|LEN|MAX|MID|MIN|MOD|NOW|ROUND|SUM|UCASE)(?=\s*\()/i,
    keyword: /\b(?:ACTION|ADD|AFTER|ALGORITHM|ALL|ALTER|ANALYZE|ANY|APPLY|AS|ASC|AUTHORIZATION|AUTO_INCREMENT|BACKUP|BDB|BEGIN|BERKELEYDB|BIGINT|BINARY|BIT|BLOB|BOOL|BOOLEAN|BREAK|BROWSE|BTREE|BULK|BY|CALL|CASCADED?|CASE|CHAIN|CHAR(?:ACTER|SET)?|CHECK(?:POINT)?|CLOSE|CLUSTERED|COALESCE|COLLATE|COLUMNS?|COMMENT|COMMIT(?:TED)?|COMPUTE|CONNECT|CONSISTENT|CONSTRAINT|CONTAINS(?:TABLE)?|CONTINUE|CONVERT|CREATE|CROSS|CURRENT(?:_DATE|_TIME|_TIMESTAMP|_USER)?|CURSOR|CYCLE|DATA(?:BASES?)?|DATE(?:TIME)?|DAY|DBCC|DEALLOCATE|DEC|DECIMAL|DECLARE|DEFAULT|DEFINER|DELAYED|DELETE|DELIMITERS?|DENY|DESC|DESCRIBE|DETERMINISTIC|DISABLE|DISCARD|DISK|DISTINCT|DISTINCTROW|DISTRIBUTED|DO|DOUBLE|DROP|DUMMY|DUMP(?:FILE)?|DUPLICATE|ELSE(?:IF)?|ENABLE|ENCLOSED|END|ENGINE|ENUM|ERRLVL|ERRORS|ESCAPED?|EXCEPT|EXEC(?:UTE)?|EXISTS|EXIT|EXPLAIN|EXTENDED|FETCH|FIELDS|FILE|FILLFACTOR|FIRST|FIXED|FLOAT|FOLLOWING|FOR(?: EACH ROW)?|FORCE|FOREIGN|FREETEXT(?:TABLE)?|FROM|FULL|FUNCTION|GEOMETRY(?:COLLECTION)?|GLOBAL|GOTO|GRANT|GROUP|HANDLER|HASH|HAVING|HOLDLOCK|HOUR|IDENTITY(?:COL|_INSERT)?|IF|IGNORE|IMPORT|INDEX|INFILE|INNER|INNODB|INOUT|INSERT|INT|INTEGER|INTERSECT|INTERVAL|INTO|INVOKER|ISOLATION|ITERATE|JOIN|KEYS?|KILL|LANGUAGE|LAST|LEAVE|LEFT|LEVEL|LIMIT|LINENO|LINES|LINESTRING|LOAD|LOCAL|LOCK|LONG(?:BLOB|TEXT)|LOOP|MATCH(?:ED)?|MEDIUM(?:BLOB|INT|TEXT)|MERGE|MIDDLEINT|MINUTE|MODE|MODIFIES|MODIFY|MONTH|MULTI(?:LINESTRING|POINT|POLYGON)|NATIONAL|NATURAL|NCHAR|NEXT|NO|NONCLUSTERED|NULLIF|NUMERIC|OFF?|OFFSETS?|ON|OPEN(?:DATASOURCE|QUERY|ROWSET)?|OPTIMIZE|OPTION(?:ALLY)?|ORDER|OUT(?:ER|FILE)?|OVER|PARTIAL|PARTITION|PERCENT|PIVOT|PLAN|POINT|POLYGON|PRECEDING|PRECISION|PREPARE|PREV|PRIMARY|PRINT|PRIVILEGES|PROC(?:EDURE)?|PUBLIC|PURGE|QUICK|RAISERROR|READS?|REAL|RECONFIGURE|REFERENCES|RELEASE|RENAME|REPEAT(?:ABLE)?|REPLACE|REPLICATION|REQUIRE|RESIGNAL|RESTORE|RESTRICT|RETURN(?:ING|S)?|REVOKE|RIGHT|ROLLBACK|ROUTINE|ROW(?:COUNT|GUIDCOL|S)?|RTREE|RULE|SAVE(?:POINT)?|SCHEMA|SECOND|SELECT|SERIAL(?:IZABLE)?|SESSION(?:_USER)?|SET(?:USER)?|SHARE|SHOW|SHUTDOWN|SIMPLE|SMALLINT|SNAPSHOT|SOME|SONAME|SQL|START(?:ING)?|STATISTICS|STATUS|STRIPED|SYSTEM_USER|TABLES?|TABLESPACE|TEMP(?:ORARY|TABLE)?|TERMINATED|TEXT(?:SIZE)?|THEN|TIME(?:STAMP)?|TINY(?:BLOB|INT|TEXT)|TOP?|TRAN(?:SACTIONS?)?|TRIGGER|TRUNCATE|TSEQUAL|TYPES?|UNBOUNDED|UNCOMMITTED|UNDEFINED|UNION|UNIQUE|UNLOCK|UNPIVOT|UNSIGNED|UPDATE(?:TEXT)?|USAGE|USE|USER|USING|VALUES?|VAR(?:BINARY|CHAR|CHARACTER|YING)|VIEW|WAITFOR|WARNINGS|WHEN|WHERE|WHILE|WITH(?: ROLLUP|IN)?|WORK|WRITE(?:TEXT)?|YEAR)\b/i,
    boolean: /\b(?:FALSE|NULL|TRUE)\b/i,
    number: /\b0x[\da-f]+\b|\b\d+(?:\.\d*)?|\B\.\d+\b/i,
    operator: /[-+*\/=%^~]|&&?|\|\|?|!=?|<(?:=>?|<|>)?|>[>=]?|\b(?:AND|BETWEEN|DIV|ILIKE|IN|IS|LIKE|NOT|OR|REGEXP|RLIKE|SOUNDS LIKE|XOR)\b/i,
    punctuation: /[;[\]()`,.]/
}, function(b) {
    var e = b.languages.javascript["template-string"], t = e.pattern.source, m = e.inside.interpolation, f = m.inside["interpolation-punctuation"], s = m.pattern.source;
    function n(e2, n2) {
        if (b.languages[e2]) return {
            pattern: RegExp("((?:" + n2 + ")\\s*)" + t),
            lookbehind: true,
            greedy: true,
            inside: {
                "template-punctuation": {
                    pattern: /^`|`$/,
                    alias: "string"
                },
                "embedded-code": {
                    pattern: /[\s\S]+/,
                    alias: e2
                }
            }
        };
    }
    function h(e2, n2, t2) {
        e2 = {
            code: e2,
            grammar: n2,
            language: t2
        };
        return b.hooks.run("before-tokenize", e2), e2.tokens = b.tokenize(e2.code, e2.grammar), b.hooks.run("after-tokenize", e2), e2.tokens;
    }
    function l(a2, e2, r) {
        var n2 = b.tokenize(a2, {
            interpolation: {
                pattern: RegExp(s),
                lookbehind: true
            }
        }), p = 0, d = {}, n2 = h(n2.map(function(e3) {
            if ("string" == typeof e3) return e3;
            for(var n3, t2, e3 = e3.content; -1 !== a2.indexOf((t2 = p++, n3 = "___" + r.toUpperCase() + "_" + t2 + "___")););
            return d[n3] = e3, n3;
        }).join(""), e2, r), g = Object.keys(d);
        return p = 0, function e3(n3) {
            for(var t2 = 0; t2 < n3.length; t2++){
                if (p >= g.length) return;
                var a3, r2, s2, i, o, l2, u2, c = n3[t2];
                "string" == typeof c || "string" == typeof c.content ? (a3 = g[p], -1 !== (u2 = (l2 = "string" == typeof c ? c : c.content).indexOf(a3)) && (++p, r2 = l2.substring(0, u2), o = d[a3], s2 = void 0, (i = {})["interpolation-punctuation"] = f, 3 === (i = b.tokenize(o, i)).length && ((s2 = [
                    1,
                    1
                ]).push.apply(s2, h(i[1], b.languages.javascript, "javascript")), i.splice.apply(i, s2)), s2 = new b.Token("interpolation", i, m.alias, o), i = l2.substring(u2 + a3.length), o = [], r2 && o.push(r2), o.push(s2), i && (e3(l2 = [
                    i
                ]), o.push.apply(o, l2)), "string" == typeof c ? (n3.splice.apply(n3, [
                    t2,
                    1
                ].concat(o)), t2 += o.length - 1) : c.content = o)) : (u2 = c.content, Array.isArray(u2) ? e3(u2) : e3([
                    u2
                ]));
            }
        }(n2), new b.Token(r, n2, "language-" + r, a2);
    }
    b.languages.javascript["template-string"] = [
        n("css", /\b(?:styled(?:\([^)]*\))?(?:\s*\.\s*\w+(?:\([^)]*\))*)*|css(?:\s*\.\s*(?:global|resolve))?|createGlobalStyle|keyframes)/.source),
        n("html", /\bhtml|\.\s*(?:inner|outer)HTML\s*\+?=/.source),
        n("svg", /\bsvg/.source),
        n("markdown", /\b(?:markdown|md)/.source),
        n("graphql", /\b(?:gql|graphql(?:\s*\.\s*experimental)?)/.source),
        n("sql", /\bsql/.source),
        e
    ].filter(Boolean);
    var a = {
        javascript: true,
        js: true,
        typescript: true,
        ts: true,
        jsx: true,
        tsx: true
    };
    function u(e2) {
        return "string" == typeof e2 ? e2 : Array.isArray(e2) ? e2.map(u).join("") : u(e2.content);
    }
    b.hooks.add("after-tokenize", function(e2) {
        e2.language in a && !function e3(n2) {
            for(var t2 = 0, a2 = n2.length; t2 < a2; t2++){
                var r, s2, i, o = n2[t2];
                "string" != typeof o && (r = o.content, Array.isArray(r) ? "template-string" === o.type ? (o = r[1], 3 === r.length && "string" != typeof o && "embedded-code" === o.type && (s2 = u(o), o = o.alias, o = Array.isArray(o) ? o[0] : o, i = b.languages[o]) && (r[1] = l(s2, i, o))) : e3(r) : "string" != typeof r && e3([
                    r
                ]));
            }
        }(e2.tokens);
    });
}($0fdca79f03e679c4$export$dc7257ffb0972f87), function(e) {
    e.languages.typescript = e.languages.extend("javascript", {
        "class-name": {
            pattern: /(\b(?:class|extends|implements|instanceof|interface|new|type)\s+)(?!keyof\b)(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?:\s*<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>)?/,
            lookbehind: true,
            greedy: true,
            inside: null
        },
        builtin: /\b(?:Array|Function|Promise|any|boolean|console|never|number|string|symbol|unknown)\b/
    }), e.languages.typescript.keyword.push(/\b(?:abstract|declare|is|keyof|readonly|require)\b/, /\b(?:asserts|infer|interface|module|namespace|type)\b(?=\s*(?:[{_$a-zA-Z\xA0-\uFFFF]|$))/, /\btype\b(?=\s*(?:[\{*]|$))/), delete e.languages.typescript.parameter, delete e.languages.typescript["literal-property"];
    var n = e.languages.extend("typescript", {});
    delete n["class-name"], e.languages.typescript["class-name"].inside = n, e.languages.insertBefore("typescript", "function", {
        decorator: {
            pattern: /@[$\w\xA0-\uFFFF]+/,
            inside: {
                at: {
                    pattern: /^@/,
                    alias: "operator"
                },
                function: /^[\s\S]+/
            }
        },
        "generic-function": {
            pattern: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>(?=\s*\()/,
            greedy: true,
            inside: {
                function: /^#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*/,
                generic: {
                    pattern: /<[\s\S]+/,
                    alias: "class-name",
                    inside: n
                }
            }
        }
    }), e.languages.ts = e.languages.typescript;
}($0fdca79f03e679c4$export$dc7257ffb0972f87), function(e) {
    var n = e.languages.javascript, t = /\{(?:[^{}]|\{(?:[^{}]|\{[^{}]*\})*\})+\}/.source, a = "(@(?:arg|argument|param|property)\\s+(?:" + t + "\\s+)?)";
    e.languages.jsdoc = e.languages.extend("javadoclike", {
        parameter: {
            pattern: RegExp(a + /(?:(?!\s)[$\w\xA0-\uFFFF.])+(?=\s|$)/.source),
            lookbehind: true,
            inside: {
                punctuation: /\./
            }
        }
    }), e.languages.insertBefore("jsdoc", "keyword", {
        "optional-parameter": {
            pattern: RegExp(a + /\[(?:(?!\s)[$\w\xA0-\uFFFF.])+(?:=[^[\]]+)?\](?=\s|$)/.source),
            lookbehind: true,
            inside: {
                parameter: {
                    pattern: /(^\[)[$\w\xA0-\uFFFF\.]+/,
                    lookbehind: true,
                    inside: {
                        punctuation: /\./
                    }
                },
                code: {
                    pattern: /(=)[\s\S]*(?=\]$)/,
                    lookbehind: true,
                    inside: n,
                    alias: "language-javascript"
                },
                punctuation: /[=[\]]/
            }
        },
        "class-name": [
            {
                pattern: RegExp(/(@(?:augments|class|extends|interface|memberof!?|template|this|typedef)\s+(?:<TYPE>\s+)?)[A-Z]\w*(?:\.[A-Z]\w*)*/.source.replace(/<TYPE>/g, function() {
                    return t;
                })),
                lookbehind: true,
                inside: {
                    punctuation: /\./
                }
            },
            {
                pattern: RegExp("(@[a-z]+\\s+)" + t),
                lookbehind: true,
                inside: {
                    string: n.string,
                    number: n.number,
                    boolean: n.boolean,
                    keyword: e.languages.typescript.keyword,
                    operator: /=>|\.\.\.|[&|?:*]/,
                    punctuation: /[.,;=<>{}()[\]]/
                }
            }
        ],
        example: {
            pattern: /(@example\s+(?!\s))(?:[^@\s]|\s+(?!\s))+?(?=\s*(?:\*\s*)?(?:@\w|\*\/))/,
            lookbehind: true,
            inside: {
                code: {
                    pattern: /^([\t ]*(?:\*\s*)?)\S.*$/m,
                    lookbehind: true,
                    inside: n,
                    alias: "language-javascript"
                }
            }
        }
    }), e.languages.javadoclike.addSupport("javascript", e.languages.jsdoc);
}($0fdca79f03e679c4$export$dc7257ffb0972f87), function(e) {
    e.languages.flow = e.languages.extend("javascript", {}), e.languages.insertBefore("flow", "keyword", {
        type: [
            {
                pattern: /\b(?:[Bb]oolean|Function|[Nn]umber|[Ss]tring|[Ss]ymbol|any|mixed|null|void)\b/,
                alias: "class-name"
            }
        ]
    }), e.languages.flow["function-variable"].pattern = /(?!\s)[_$a-z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*=\s*(?:function\b|(?:\([^()]*\)(?:\s*:\s*\w+)?|(?!\s)[_$a-z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)\s*=>))/i, delete e.languages.flow.parameter, e.languages.insertBefore("flow", "operator", {
        "flow-punctuation": {
            pattern: /\{\||\|\}/,
            alias: "punctuation"
        }
    }), Array.isArray(e.languages.flow.keyword) || (e.languages.flow.keyword = [
        e.languages.flow.keyword
    ]), e.languages.flow.keyword.unshift({
        pattern: /(^|[^$]\b)(?:Class|declare|opaque|type)\b(?!\$)/,
        lookbehind: true
    }, {
        pattern: /(^|[^$]\B)\$(?:Diff|Enum|Exact|Keys|ObjMap|PropertyType|Record|Shape|Subtype|Supertype|await)\b(?!\$)/,
        lookbehind: true
    });
}($0fdca79f03e679c4$export$dc7257ffb0972f87), $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.n4js = $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.extend("javascript", {
    keyword: /\b(?:Array|any|boolean|break|case|catch|class|const|constructor|continue|debugger|declare|default|delete|do|else|enum|export|extends|false|finally|for|from|function|get|if|implements|import|in|instanceof|interface|let|module|new|null|number|package|private|protected|public|return|set|static|string|super|switch|this|throw|true|try|typeof|var|void|while|with|yield)\b/
}), $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.insertBefore("n4js", "constant", {
    annotation: {
        pattern: /@+\w+/,
        alias: "operator"
    }
}), $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.n4jsd = $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.n4js, function(e) {
    function n(e2, n2) {
        return RegExp(e2.replace(/<ID>/g, function() {
            return /(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*/.source;
        }), n2);
    }
    e.languages.insertBefore("javascript", "function-variable", {
        "method-variable": {
            pattern: RegExp("(\\.\\s*)" + e.languages.javascript["function-variable"].pattern.source),
            lookbehind: true,
            alias: [
                "function-variable",
                "method",
                "function",
                "property-access"
            ]
        }
    }), e.languages.insertBefore("javascript", "function", {
        method: {
            pattern: RegExp("(\\.\\s*)" + e.languages.javascript.function.source),
            lookbehind: true,
            alias: [
                "function",
                "property-access"
            ]
        }
    }), e.languages.insertBefore("javascript", "constant", {
        "known-class-name": [
            {
                pattern: /\b(?:(?:Float(?:32|64)|(?:Int|Uint)(?:8|16|32)|Uint8Clamped)?Array|ArrayBuffer|BigInt|Boolean|DataView|Date|Error|Function|Intl|JSON|(?:Weak)?(?:Map|Set)|Math|Number|Object|Promise|Proxy|Reflect|RegExp|String|Symbol|WebAssembly)\b/,
                alias: "class-name"
            },
            {
                pattern: /\b(?:[A-Z]\w*)Error\b/,
                alias: "class-name"
            }
        ]
    }), e.languages.insertBefore("javascript", "keyword", {
        imports: {
            pattern: n(/(\bimport\b\s*)(?:<ID>(?:\s*,\s*(?:\*\s*as\s+<ID>|\{[^{}]*\}))?|\*\s*as\s+<ID>|\{[^{}]*\})(?=\s*\bfrom\b)/.source),
            lookbehind: true,
            inside: e.languages.javascript
        },
        exports: {
            pattern: n(/(\bexport\b\s*)(?:\*(?:\s*as\s+<ID>)?(?=\s*\bfrom\b)|\{[^{}]*\})/.source),
            lookbehind: true,
            inside: e.languages.javascript
        }
    }), e.languages.javascript.keyword.unshift({
        pattern: /\b(?:as|default|export|from|import)\b/,
        alias: "module"
    }, {
        pattern: /\b(?:await|break|catch|continue|do|else|finally|for|if|return|switch|throw|try|while|yield)\b/,
        alias: "control-flow"
    }, {
        pattern: /\bnull\b/,
        alias: [
            "null",
            "nil"
        ]
    }, {
        pattern: /\bundefined\b/,
        alias: "nil"
    }), e.languages.insertBefore("javascript", "operator", {
        spread: {
            pattern: /\.{3}/,
            alias: "operator"
        },
        arrow: {
            pattern: /=>/,
            alias: "operator"
        }
    }), e.languages.insertBefore("javascript", "punctuation", {
        "property-access": {
            pattern: n(/(\.\s*)#?<ID>/.source),
            lookbehind: true
        },
        "maybe-class-name": {
            pattern: /(^|[^$\w\xA0-\uFFFF])[A-Z][$\w\xA0-\uFFFF]+/,
            lookbehind: true
        },
        dom: {
            pattern: /\b(?:document|(?:local|session)Storage|location|navigator|performance|window)\b/,
            alias: "variable"
        },
        console: {
            pattern: /\bconsole(?=\s*\.)/,
            alias: "class-name"
        }
    });
    for(var t = [
        "function",
        "function-variable",
        "method",
        "method-variable",
        "property-access"
    ], a = 0; a < t.length; a++){
        var r = t[a], s = e.languages.javascript[r], r = (s = "RegExp" === e.util.type(s) ? e.languages.javascript[r] = {
            pattern: s
        } : s).inside || {};
        (s.inside = r)["maybe-class-name"] = /^[A-Z][\s\S]*/;
    }
}($0fdca79f03e679c4$export$dc7257ffb0972f87), function(s) {
    var e = s.util.clone(s.languages.javascript), t = /(?:\s|\/\/.*(?!.)|\/\*(?:[^*]|\*(?!\/))\*\/)/.source, a = /(?:\{(?:\{(?:\{[^{}]*\}|[^{}])*\}|[^{}])*\})/.source, r = /(?:\{<S>*\.{3}(?:[^{}]|<BRACES>)*\})/.source;
    function n(e2, n2) {
        return e2 = e2.replace(/<S>/g, function() {
            return t;
        }).replace(/<BRACES>/g, function() {
            return a;
        }).replace(/<SPREAD>/g, function() {
            return r;
        }), RegExp(e2, n2);
    }
    r = n(r).source, s.languages.jsx = s.languages.extend("markup", e), s.languages.jsx.tag.pattern = n(/<\/?(?:[\w.:-]+(?:<S>+(?:[\w.:$-]+(?:=(?:"(?:\\[\s\S]|[^\\"])*"|'(?:\\[\s\S]|[^\\'])*'|[^\s{'"/>=]+|<BRACES>))?|<SPREAD>))*<S>*\/?)?>/.source), s.languages.jsx.tag.inside.tag.pattern = /^<\/?[^\s>\/]*/, s.languages.jsx.tag.inside["attr-value"].pattern = /=(?!\{)(?:"(?:\\[\s\S]|[^\\"])*"|'(?:\\[\s\S]|[^\\'])*'|[^\s'">]+)/, s.languages.jsx.tag.inside.tag.inside["class-name"] = /^[A-Z]\w*(?:\.[A-Z]\w*)*$/, s.languages.jsx.tag.inside.comment = e.comment, s.languages.insertBefore("inside", "attr-name", {
        spread: {
            pattern: n(/<SPREAD>/.source),
            inside: s.languages.jsx
        }
    }, s.languages.jsx.tag), s.languages.insertBefore("inside", "special-attr", {
        script: {
            pattern: n(/=<BRACES>/.source),
            alias: "language-javascript",
            inside: {
                "script-punctuation": {
                    pattern: /^=(?=\{)/,
                    alias: "punctuation"
                },
                rest: s.languages.jsx
            }
        }
    }, s.languages.jsx.tag);
    function i(e2) {
        for(var n2 = [], t2 = 0; t2 < e2.length; t2++){
            var a2 = e2[t2], r2 = false;
            "string" != typeof a2 && ("tag" === a2.type && a2.content[0] && "tag" === a2.content[0].type ? "</" === a2.content[0].content[0].content ? 0 < n2.length && n2[n2.length - 1].tagName === o(a2.content[0].content[1]) && n2.pop() : "/>" !== a2.content[a2.content.length - 1].content && n2.push({
                tagName: o(a2.content[0].content[1]),
                openedBraces: 0
            }) : 0 < n2.length && "punctuation" === a2.type && "{" === a2.content ? n2[n2.length - 1].openedBraces++ : 0 < n2.length && 0 < n2[n2.length - 1].openedBraces && "punctuation" === a2.type && "}" === a2.content ? n2[n2.length - 1].openedBraces-- : r2 = true), (r2 || "string" == typeof a2) && 0 < n2.length && 0 === n2[n2.length - 1].openedBraces && (r2 = o(a2), t2 < e2.length - 1 && ("string" == typeof e2[t2 + 1] || "plain-text" === e2[t2 + 1].type) && (r2 += o(e2[t2 + 1]), e2.splice(t2 + 1, 1)), 0 < t2 && ("string" == typeof e2[t2 - 1] || "plain-text" === e2[t2 - 1].type) && (r2 = o(e2[t2 - 1]) + r2, e2.splice(t2 - 1, 1), t2--), e2[t2] = new s.Token("plain-text", r2, null, r2)), a2.content && "string" != typeof a2.content && i(a2.content);
        }
    }
    var o = function(e2) {
        return e2 ? "string" == typeof e2 ? e2 : "string" == typeof e2.content ? e2.content : e2.content.map(o).join("") : "";
    };
    s.hooks.add("after-tokenize", function(e2) {
        "jsx" !== e2.language && "tsx" !== e2.language || i(e2.tokens);
    });
}($0fdca79f03e679c4$export$dc7257ffb0972f87), function(e) {
    var n = e.util.clone(e.languages.typescript), n = (e.languages.tsx = e.languages.extend("jsx", n), delete e.languages.tsx.parameter, delete e.languages.tsx["literal-property"], e.languages.tsx.tag);
    n.pattern = RegExp(/(^|[^\w$]|(?=<\/))/.source + "(?:" + n.pattern.source + ")", n.pattern.flags), n.lookbehind = true;
}($0fdca79f03e679c4$export$dc7257ffb0972f87), $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.swift = {
    comment: {
        pattern: /(^|[^\\:])(?:\/\/.*|\/\*(?:[^/*]|\/(?!\*)|\*(?!\/)|\/\*(?:[^*]|\*(?!\/))*\*\/)*\*\/)/,
        lookbehind: true,
        greedy: true
    },
    "string-literal": [
        {
            pattern: RegExp(/(^|[^"#])/.source + "(?:" + /"(?:\\(?:\((?:[^()]|\([^()]*\))*\)|\r\n|[^(])|[^\\\r\n"])*"/.source + "|" + /"""(?:\\(?:\((?:[^()]|\([^()]*\))*\)|[^(])|[^\\"]|"(?!""))*"""/.source + ")" + /(?!["#])/.source),
            lookbehind: true,
            greedy: true,
            inside: {
                interpolation: {
                    pattern: /(\\\()(?:[^()]|\([^()]*\))*(?=\))/,
                    lookbehind: true,
                    inside: null
                },
                "interpolation-punctuation": {
                    pattern: /^\)|\\\($/,
                    alias: "punctuation"
                },
                punctuation: /\\(?=[\r\n])/,
                string: /[\s\S]+/
            }
        },
        {
            pattern: RegExp(/(^|[^"#])(#+)/.source + "(?:" + /"(?:\\(?:#+\((?:[^()]|\([^()]*\))*\)|\r\n|[^#])|[^\\\r\n])*?"/.source + "|" + /"""(?:\\(?:#+\((?:[^()]|\([^()]*\))*\)|[^#])|[^\\])*?"""/.source + ")\\2"),
            lookbehind: true,
            greedy: true,
            inside: {
                interpolation: {
                    pattern: /(\\#+\()(?:[^()]|\([^()]*\))*(?=\))/,
                    lookbehind: true,
                    inside: null
                },
                "interpolation-punctuation": {
                    pattern: /^\)|\\#+\($/,
                    alias: "punctuation"
                },
                string: /[\s\S]+/
            }
        }
    ],
    directive: {
        pattern: RegExp(/#/.source + "(?:" + /(?:elseif|if)\b/.source + "(?:[ 	]*" + /(?:![ \t]*)?(?:\b\w+\b(?:[ \t]*\((?:[^()]|\([^()]*\))*\))?|\((?:[^()]|\([^()]*\))*\))(?:[ \t]*(?:&&|\|\|))?/.source + ")+|" + /(?:else|endif)\b/.source + ")"),
        alias: "property",
        inside: {
            "directive-name": /^#\w+/,
            boolean: /\b(?:false|true)\b/,
            number: /\b\d+(?:\.\d+)*\b/,
            operator: /!|&&|\|\||[<>]=?/,
            punctuation: /[(),]/
        }
    },
    literal: {
        pattern: /#(?:colorLiteral|column|dsohandle|file(?:ID|Literal|Path)?|function|imageLiteral|line)\b/,
        alias: "constant"
    },
    "other-directive": {
        pattern: /#\w+\b/,
        alias: "property"
    },
    attribute: {
        pattern: /@\w+/,
        alias: "atrule"
    },
    "function-definition": {
        pattern: /(\bfunc\s+)\w+/,
        lookbehind: true,
        alias: "function"
    },
    label: {
        pattern: /\b(break|continue)\s+\w+|\b[a-zA-Z_]\w*(?=\s*:\s*(?:for|repeat|while)\b)/,
        lookbehind: true,
        alias: "important"
    },
    keyword: /\b(?:Any|Protocol|Self|Type|actor|as|assignment|associatedtype|associativity|async|await|break|case|catch|class|continue|convenience|default|defer|deinit|didSet|do|dynamic|else|enum|extension|fallthrough|fileprivate|final|for|func|get|guard|higherThan|if|import|in|indirect|infix|init|inout|internal|is|isolated|lazy|left|let|lowerThan|mutating|none|nonisolated|nonmutating|open|operator|optional|override|postfix|precedencegroup|prefix|private|protocol|public|repeat|required|rethrows|return|right|safe|self|set|some|static|struct|subscript|super|switch|throw|throws|try|typealias|unowned|unsafe|var|weak|where|while|willSet)\b/,
    boolean: /\b(?:false|true)\b/,
    nil: {
        pattern: /\bnil\b/,
        alias: "constant"
    },
    "short-argument": /\$\d+\b/,
    omit: {
        pattern: /\b_\b/,
        alias: "keyword"
    },
    number: /\b(?:[\d_]+(?:\.[\de_]+)?|0x[a-f0-9_]+(?:\.[a-f0-9p_]+)?|0b[01_]+|0o[0-7_]+)\b/i,
    "class-name": /\b[A-Z](?:[A-Z_\d]*[a-z]\w*)?\b/,
    function: /\b[a-z_]\w*(?=\s*\()/i,
    constant: /\b(?:[A-Z_]{2,}|k[A-Z][A-Za-z_]+)\b/,
    operator: /[-+*/%=!<>&|^~?]+|\.[.\-+*/%=!<>&|^~?]+/,
    punctuation: /[{}[\]();,.:\\]/
}, $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.swift["string-literal"].forEach(function(e) {
    e.inside.interpolation.inside = $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.swift;
}), function(e) {
    e.languages.kotlin = e.languages.extend("clike", {
        keyword: {
            pattern: /(^|[^.])\b(?:abstract|actual|annotation|as|break|by|catch|class|companion|const|constructor|continue|crossinline|data|do|dynamic|else|enum|expect|external|final|finally|for|fun|get|if|import|in|infix|init|inline|inner|interface|internal|is|lateinit|noinline|null|object|open|operator|out|override|package|private|protected|public|reified|return|sealed|set|super|suspend|tailrec|this|throw|to|try|typealias|val|var|vararg|when|where|while)\b/,
            lookbehind: true
        },
        function: [
            {
                pattern: /(?:`[^\r\n`]+`|\b\w+)(?=\s*\()/,
                greedy: true
            },
            {
                pattern: /(\.)(?:`[^\r\n`]+`|\w+)(?=\s*\{)/,
                lookbehind: true,
                greedy: true
            }
        ],
        number: /\b(?:0[xX][\da-fA-F]+(?:_[\da-fA-F]+)*|0[bB][01]+(?:_[01]+)*|\d+(?:_\d+)*(?:\.\d+(?:_\d+)*)?(?:[eE][+-]?\d+(?:_\d+)*)?[fFL]?)\b/,
        operator: /\+[+=]?|-[-=>]?|==?=?|!(?:!|==?)?|[\/*%<>]=?|[?:]:?|\.\.|&&|\|\||\b(?:and|inv|or|shl|shr|ushr|xor)\b/
    }), delete e.languages.kotlin["class-name"];
    var n = {
        "interpolation-punctuation": {
            pattern: /^\$\{?|\}$/,
            alias: "punctuation"
        },
        expression: {
            pattern: /[\s\S]+/,
            inside: e.languages.kotlin
        }
    };
    e.languages.insertBefore("kotlin", "string", {
        "string-literal": [
            {
                pattern: /"""(?:[^$]|\$(?:(?!\{)|\{[^{}]*\}))*?"""/,
                alias: "multiline",
                inside: {
                    interpolation: {
                        pattern: /\$(?:[a-z_]\w*|\{[^{}]*\})/i,
                        inside: n
                    },
                    string: /[\s\S]+/
                }
            },
            {
                pattern: /"(?:[^"\\\r\n$]|\\.|\$(?:(?!\{)|\{[^{}]*\}))*"/,
                alias: "singleline",
                inside: {
                    interpolation: {
                        pattern: /((?:^|[^\\])(?:\\{2})*)\$(?:[a-z_]\w*|\{[^{}]*\})/i,
                        lookbehind: true,
                        inside: n
                    },
                    string: /[\s\S]+/
                }
            }
        ],
        char: {
            pattern: /'(?:[^'\\\r\n]|\\(?:.|u[a-fA-F0-9]{0,4}))'/,
            greedy: true
        }
    }), delete e.languages.kotlin.string, e.languages.insertBefore("kotlin", "keyword", {
        annotation: {
            pattern: /\B@(?:\w+:)?(?:[A-Z]\w*|\[[^\]]+\])/,
            alias: "builtin"
        }
    }), e.languages.insertBefore("kotlin", "function", {
        label: {
            pattern: /\b\w+@|@\w+\b/,
            alias: "symbol"
        }
    }), e.languages.kt = e.languages.kotlin, e.languages.kts = e.languages.kotlin;
}($0fdca79f03e679c4$export$dc7257ffb0972f87), $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.c = $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.extend("clike", {
    comment: {
        pattern: /\/\/(?:[^\r\n\\]|\\(?:\r\n?|\n|(?![\r\n])))*|\/\*[\s\S]*?(?:\*\/|$)/,
        greedy: true
    },
    string: {
        pattern: /"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"/,
        greedy: true
    },
    "class-name": {
        pattern: /(\b(?:enum|struct)\s+(?:__attribute__\s*\(\([\s\S]*?\)\)\s*)?)\w+|\b[a-z]\w*_t\b/,
        lookbehind: true
    },
    keyword: /\b(?:_Alignas|_Alignof|_Atomic|_Bool|_Complex|_Generic|_Imaginary|_Noreturn|_Static_assert|_Thread_local|__attribute__|asm|auto|break|case|char|const|continue|default|do|double|else|enum|extern|float|for|goto|if|inline|int|long|register|return|short|signed|sizeof|static|struct|switch|typedef|typeof|union|unsigned|void|volatile|while)\b/,
    function: /\b[a-z_]\w*(?=\s*\()/i,
    number: /(?:\b0x(?:[\da-f]+(?:\.[\da-f]*)?|\.[\da-f]+)(?:p[+-]?\d+)?|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?)[ful]{0,4}/i,
    operator: />>=?|<<=?|->|([-+&|:])\1|[?:~]|[-+*/%&|^!=<>]=?/
}), $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.insertBefore("c", "string", {
    char: {
        pattern: /'(?:\\(?:\r\n|[\s\S])|[^'\\\r\n]){0,32}'/,
        greedy: true
    }
}), $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.insertBefore("c", "string", {
    macro: {
        pattern: /(^[\t ]*)#\s*[a-z](?:[^\r\n\\/]|\/(?!\*)|\/\*(?:[^*]|\*(?!\/))*\*\/|\\(?:\r\n|[\s\S]))*/im,
        lookbehind: true,
        greedy: true,
        alias: "property",
        inside: {
            string: [
                {
                    pattern: /^(#\s*include\s*)<[^>]+>/,
                    lookbehind: true
                },
                $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.c.string
            ],
            char: $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.c.char,
            comment: $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.c.comment,
            "macro-name": [
                {
                    pattern: /(^#\s*define\s+)\w+\b(?!\()/i,
                    lookbehind: true
                },
                {
                    pattern: /(^#\s*define\s+)\w+\b(?=\()/i,
                    lookbehind: true,
                    alias: "function"
                }
            ],
            directive: {
                pattern: /^(#\s*)[a-z]+/,
                lookbehind: true,
                alias: "keyword"
            },
            "directive-hash": /^#/,
            punctuation: /##|\\(?=[\r\n])/,
            expression: {
                pattern: /\S[\s\S]*/,
                inside: $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.c
            }
        }
    }
}), $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.insertBefore("c", "function", {
    constant: /\b(?:EOF|NULL|SEEK_CUR|SEEK_END|SEEK_SET|__DATE__|__FILE__|__LINE__|__TIMESTAMP__|__TIME__|__func__|stderr|stdin|stdout)\b/
}), delete $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.c.boolean, $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.objectivec = $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.extend("c", {
    string: {
        pattern: /@?"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"/,
        greedy: true
    },
    keyword: /\b(?:asm|auto|break|case|char|const|continue|default|do|double|else|enum|extern|float|for|goto|if|in|inline|int|long|register|return|self|short|signed|sizeof|static|struct|super|switch|typedef|typeof|union|unsigned|void|volatile|while)\b|(?:@interface|@end|@implementation|@protocol|@class|@public|@protected|@private|@property|@try|@catch|@finally|@throw|@synthesize|@dynamic|@selector)\b/,
    operator: /-[->]?|\+\+?|!=?|<<?=?|>>?=?|==?|&&?|\|\|?|[~^%?*\/@]/
}), delete $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.objectivec["class-name"], $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.objc = $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.objectivec, $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.reason = $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.extend("clike", {
    string: {
        pattern: /"(?:\\(?:\r\n|[\s\S])|[^\\\r\n"])*"/,
        greedy: true
    },
    "class-name": /\b[A-Z]\w*/,
    keyword: /\b(?:and|as|assert|begin|class|constraint|do|done|downto|else|end|exception|external|for|fun|function|functor|if|in|include|inherit|initializer|lazy|let|method|module|mutable|new|nonrec|object|of|open|or|private|rec|sig|struct|switch|then|to|try|type|val|virtual|when|while|with)\b/,
    operator: /\.{3}|:[:=]|\|>|->|=(?:==?|>)?|<=?|>=?|[|^?'#!~`]|[+\-*\/]\.?|\b(?:asr|land|lor|lsl|lsr|lxor|mod)\b/
}), $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.insertBefore("reason", "class-name", {
    char: {
        pattern: /'(?:\\x[\da-f]{2}|\\o[0-3][0-7][0-7]|\\\d{3}|\\.|[^'\\\r\n])'/,
        greedy: true
    },
    constructor: /\b[A-Z]\w*\b(?!\s*\.)/,
    label: {
        pattern: /\b[a-z]\w*(?=::)/,
        alias: "symbol"
    }
}), delete $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.reason.function, function(e) {
    for(var n = /\/\*(?:[^*/]|\*(?!\/)|\/(?!\*)|<self>)*\*\//.source, t = 0; t < 2; t++)n = n.replace(/<self>/g, function() {
        return n;
    });
    n = n.replace(/<self>/g, function() {
        return /[^\s\S]/.source;
    }), e.languages.rust = {
        comment: [
            {
                pattern: RegExp(/(^|[^\\])/.source + n),
                lookbehind: true,
                greedy: true
            },
            {
                pattern: /(^|[^\\:])\/\/.*/,
                lookbehind: true,
                greedy: true
            }
        ],
        string: {
            pattern: /b?"(?:\\[\s\S]|[^\\"])*"|b?r(#*)"(?:[^"]|"(?!\1))*"\1/,
            greedy: true
        },
        char: {
            pattern: /b?'(?:\\(?:x[0-7][\da-fA-F]|u\{(?:[\da-fA-F]_*){1,6}\}|.)|[^\\\r\n\t'])'/,
            greedy: true
        },
        attribute: {
            pattern: /#!?\[(?:[^\[\]"]|"(?:\\[\s\S]|[^\\"])*")*\]/,
            greedy: true,
            alias: "attr-name",
            inside: {
                string: null
            }
        },
        "closure-params": {
            pattern: /([=(,:]\s*|\bmove\s*)\|[^|]*\||\|[^|]*\|(?=\s*(?:\{|->))/,
            lookbehind: true,
            greedy: true,
            inside: {
                "closure-punctuation": {
                    pattern: /^\||\|$/,
                    alias: "punctuation"
                },
                rest: null
            }
        },
        "lifetime-annotation": {
            pattern: /'\w+/,
            alias: "symbol"
        },
        "fragment-specifier": {
            pattern: /(\$\w+:)[a-z]+/,
            lookbehind: true,
            alias: "punctuation"
        },
        variable: /\$\w+/,
        "function-definition": {
            pattern: /(\bfn\s+)\w+/,
            lookbehind: true,
            alias: "function"
        },
        "type-definition": {
            pattern: /(\b(?:enum|struct|trait|type|union)\s+)\w+/,
            lookbehind: true,
            alias: "class-name"
        },
        "module-declaration": [
            {
                pattern: /(\b(?:crate|mod)\s+)[a-z][a-z_\d]*/,
                lookbehind: true,
                alias: "namespace"
            },
            {
                pattern: /(\b(?:crate|self|super)\s*)::\s*[a-z][a-z_\d]*\b(?:\s*::(?:\s*[a-z][a-z_\d]*\s*::)*)?/,
                lookbehind: true,
                alias: "namespace",
                inside: {
                    punctuation: /::/
                }
            }
        ],
        keyword: [
            /\b(?:Self|abstract|as|async|await|become|box|break|const|continue|crate|do|dyn|else|enum|extern|final|fn|for|if|impl|in|let|loop|macro|match|mod|move|mut|override|priv|pub|ref|return|self|static|struct|super|trait|try|type|typeof|union|unsafe|unsized|use|virtual|where|while|yield)\b/,
            /\b(?:bool|char|f(?:32|64)|[ui](?:8|16|32|64|128|size)|str)\b/
        ],
        function: /\b[a-z_]\w*(?=\s*(?:::\s*<|\())/,
        macro: {
            pattern: /\b\w+!/,
            alias: "property"
        },
        constant: /\b[A-Z_][A-Z_\d]+\b/,
        "class-name": /\b[A-Z]\w*\b/,
        namespace: {
            pattern: /(?:\b[a-z][a-z_\d]*\s*::\s*)*\b[a-z][a-z_\d]*\s*::(?!\s*<)/,
            inside: {
                punctuation: /::/
            }
        },
        number: /\b(?:0x[\dA-Fa-f](?:_?[\dA-Fa-f])*|0o[0-7](?:_?[0-7])*|0b[01](?:_?[01])*|(?:(?:\d(?:_?\d)*)?\.)?\d(?:_?\d)*(?:[Ee][+-]?\d+)?)(?:_?(?:f32|f64|[iu](?:8|16|32|64|size)?))?\b/,
        boolean: /\b(?:false|true)\b/,
        punctuation: /->|\.\.=|\.{1,3}|::|[{}[\];(),:]/,
        operator: /[-+*\/%!^]=?|=[=>]?|&[&=]?|\|[|=]?|<<?=?|>>?=?|[@?]/
    }, e.languages.rust["closure-params"].inside.rest = e.languages.rust, e.languages.rust.attribute.inside.string = e.languages.rust.string;
}($0fdca79f03e679c4$export$dc7257ffb0972f87), $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.go = $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.extend("clike", {
    string: {
        pattern: /(^|[^\\])"(?:\\.|[^"\\\r\n])*"|`[^`]*`/,
        lookbehind: true,
        greedy: true
    },
    keyword: /\b(?:break|case|chan|const|continue|default|defer|else|fallthrough|for|func|go(?:to)?|if|import|interface|map|package|range|return|select|struct|switch|type|var)\b/,
    boolean: /\b(?:_|false|iota|nil|true)\b/,
    number: [
        /\b0(?:b[01_]+|o[0-7_]+)i?\b/i,
        /\b0x(?:[a-f\d_]+(?:\.[a-f\d_]*)?|\.[a-f\d_]+)(?:p[+-]?\d+(?:_\d+)*)?i?(?!\w)/i,
        /(?:\b\d[\d_]*(?:\.[\d_]*)?|\B\.\d[\d_]*)(?:e[+-]?[\d_]+)?i?(?!\w)/i
    ],
    operator: /[*\/%^!=]=?|\+[=+]?|-[=-]?|\|[=|]?|&(?:=|&|\^=?)?|>(?:>=?|=)?|<(?:<=?|=|-)?|:=|\.\.\./,
    builtin: /\b(?:append|bool|byte|cap|close|complex|complex(?:64|128)|copy|delete|error|float(?:32|64)|u?int(?:8|16|32|64)?|imag|len|make|new|panic|print(?:ln)?|real|recover|rune|string|uintptr)\b/
}), $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.insertBefore("go", "string", {
    char: {
        pattern: /'(?:\\.|[^'\\\r\n]){0,10}'/,
        greedy: true
    }
}), delete $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.go["class-name"], function(e) {
    var n = /\b(?:alignas|alignof|asm|auto|bool|break|case|catch|char|char16_t|char32_t|char8_t|class|co_await|co_return|co_yield|compl|concept|const|const_cast|consteval|constexpr|constinit|continue|decltype|default|delete|do|double|dynamic_cast|else|enum|explicit|export|extern|final|float|for|friend|goto|if|import|inline|int|int16_t|int32_t|int64_t|int8_t|long|module|mutable|namespace|new|noexcept|nullptr|operator|override|private|protected|public|register|reinterpret_cast|requires|return|short|signed|sizeof|static|static_assert|static_cast|struct|switch|template|this|thread_local|throw|try|typedef|typeid|typename|uint16_t|uint32_t|uint64_t|uint8_t|union|unsigned|using|virtual|void|volatile|wchar_t|while)\b/, t = /\b(?!<keyword>)\w+(?:\s*\.\s*\w+)*\b/.source.replace(/<keyword>/g, function() {
        return n.source;
    });
    e.languages.cpp = e.languages.extend("c", {
        "class-name": [
            {
                pattern: RegExp(/(\b(?:class|concept|enum|struct|typename)\s+)(?!<keyword>)\w+/.source.replace(/<keyword>/g, function() {
                    return n.source;
                })),
                lookbehind: true
            },
            /\b[A-Z]\w*(?=\s*::\s*\w+\s*\()/,
            /\b[A-Z_]\w*(?=\s*::\s*~\w+\s*\()/i,
            /\b\w+(?=\s*<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>\s*::\s*\w+\s*\()/
        ],
        keyword: n,
        number: {
            pattern: /(?:\b0b[01']+|\b0x(?:[\da-f']+(?:\.[\da-f']*)?|\.[\da-f']+)(?:p[+-]?[\d']+)?|(?:\b[\d']+(?:\.[\d']*)?|\B\.[\d']+)(?:e[+-]?[\d']+)?)[ful]{0,4}/i,
            greedy: true
        },
        operator: />>=?|<<=?|->|--|\+\+|&&|\|\||[?:~]|<=>|[-+*/%&|^!=<>]=?|\b(?:and|and_eq|bitand|bitor|not|not_eq|or|or_eq|xor|xor_eq)\b/,
        boolean: /\b(?:false|true)\b/
    }), e.languages.insertBefore("cpp", "string", {
        module: {
            pattern: RegExp(/(\b(?:import|module)\s+)/.source + "(?:" + /"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"|<[^<>\r\n]*>/.source + "|" + /<mod-name>(?:\s*:\s*<mod-name>)?|:\s*<mod-name>/.source.replace(/<mod-name>/g, function() {
                return t;
            }) + ")"),
            lookbehind: true,
            greedy: true,
            inside: {
                string: /^[<"][\s\S]+/,
                operator: /:/,
                punctuation: /\./
            }
        },
        "raw-string": {
            pattern: /R"([^()\\ ]{0,16})\([\s\S]*?\)\1"/,
            alias: "string",
            greedy: true
        }
    }), e.languages.insertBefore("cpp", "keyword", {
        "generic-function": {
            pattern: /\b(?!operator\b)[a-z_]\w*\s*<(?:[^<>]|<[^<>]*>)*>(?=\s*\()/i,
            inside: {
                function: /^\w+/,
                generic: {
                    pattern: /<[\s\S]+/,
                    alias: "class-name",
                    inside: e.languages.cpp
                }
            }
        }
    }), e.languages.insertBefore("cpp", "operator", {
        "double-colon": {
            pattern: /::/,
            alias: "punctuation"
        }
    }), e.languages.insertBefore("cpp", "class-name", {
        "base-clause": {
            pattern: /(\b(?:class|struct)\s+\w+\s*:\s*)[^;{}"'\s]+(?:\s+[^;{}"'\s]+)*(?=\s*[;{])/,
            lookbehind: true,
            greedy: true,
            inside: e.languages.extend("cpp", {})
        }
    }), e.languages.insertBefore("inside", "double-colon", {
        "class-name": /\b[a-z_]\w*\b(?!\s*::)/i
    }, e.languages.cpp["base-clause"]);
}($0fdca79f03e679c4$export$dc7257ffb0972f87), $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.python = {
    comment: {
        pattern: /(^|[^\\])#.*/,
        lookbehind: true,
        greedy: true
    },
    "string-interpolation": {
        pattern: /(?:f|fr|rf)(?:("""|''')[\s\S]*?\1|("|')(?:\\.|(?!\2)[^\\\r\n])*\2)/i,
        greedy: true,
        inside: {
            interpolation: {
                pattern: /((?:^|[^{])(?:\{\{)*)\{(?!\{)(?:[^{}]|\{(?!\{)(?:[^{}]|\{(?!\{)(?:[^{}])+\})+\})+\}/,
                lookbehind: true,
                inside: {
                    "format-spec": {
                        pattern: /(:)[^:(){}]+(?=\}$)/,
                        lookbehind: true
                    },
                    "conversion-option": {
                        pattern: /![sra](?=[:}]$)/,
                        alias: "punctuation"
                    },
                    rest: null
                }
            },
            string: /[\s\S]+/
        }
    },
    "triple-quoted-string": {
        pattern: /(?:[rub]|br|rb)?("""|''')[\s\S]*?\1/i,
        greedy: true,
        alias: "string"
    },
    string: {
        pattern: /(?:[rub]|br|rb)?("|')(?:\\.|(?!\1)[^\\\r\n])*\1/i,
        greedy: true
    },
    function: {
        pattern: /((?:^|\s)def[ \t]+)[a-zA-Z_]\w*(?=\s*\()/g,
        lookbehind: true
    },
    "class-name": {
        pattern: /(\bclass\s+)\w+/i,
        lookbehind: true
    },
    decorator: {
        pattern: /(^[\t ]*)@\w+(?:\.\w+)*/m,
        lookbehind: true,
        alias: [
            "annotation",
            "punctuation"
        ],
        inside: {
            punctuation: /\./
        }
    },
    keyword: /\b(?:_(?=\s*:)|and|as|assert|async|await|break|case|class|continue|def|del|elif|else|except|exec|finally|for|from|global|if|import|in|is|lambda|match|nonlocal|not|or|pass|print|raise|return|try|while|with|yield)\b/,
    builtin: /\b(?:__import__|abs|all|any|apply|ascii|basestring|bin|bool|buffer|bytearray|bytes|callable|chr|classmethod|cmp|coerce|compile|complex|delattr|dict|dir|divmod|enumerate|eval|execfile|file|filter|float|format|frozenset|getattr|globals|hasattr|hash|help|hex|id|input|int|intern|isinstance|issubclass|iter|len|list|locals|long|map|max|memoryview|min|next|object|oct|open|ord|pow|property|range|raw_input|reduce|reload|repr|reversed|round|set|setattr|slice|sorted|staticmethod|str|sum|super|tuple|type|unichr|unicode|vars|xrange|zip)\b/,
    boolean: /\b(?:False|None|True)\b/,
    number: /\b0(?:b(?:_?[01])+|o(?:_?[0-7])+|x(?:_?[a-f0-9])+)\b|(?:\b\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\B\.\d+(?:_\d+)*)(?:e[+-]?\d+(?:_\d+)*)?j?(?!\w)/i,
    operator: /[-+%=]=?|!=|:=|\*\*?=?|\/\/?=?|<[<=>]?|>[=>]?|[&|^~]/,
    punctuation: /[{}[\];(),.:]/
}, $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.python["string-interpolation"].inside.interpolation.inside.rest = $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.python, $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.py = $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.python;
// src/themes/index.ts
var $0fdca79f03e679c4$export$d9a33280f07116d9 = {};
$0fdca79f03e679c4$var$__export($0fdca79f03e679c4$export$d9a33280f07116d9, {
    dracula: ()=>$0fdca79f03e679c4$var$dracula_default,
    duotoneDark: ()=>$0fdca79f03e679c4$var$duotoneDark_default,
    duotoneLight: ()=>$0fdca79f03e679c4$var$duotoneLight_default,
    github: ()=>$0fdca79f03e679c4$var$github_default,
    jettwaveDark: ()=>$0fdca79f03e679c4$var$jettwaveDark_default,
    jettwaveLight: ()=>$0fdca79f03e679c4$var$jettwaveLight_default,
    nightOwl: ()=>$0fdca79f03e679c4$var$nightOwl_default,
    nightOwlLight: ()=>$0fdca79f03e679c4$var$nightOwlLight_default,
    oceanicNext: ()=>$0fdca79f03e679c4$var$oceanicNext_default,
    okaidia: ()=>$0fdca79f03e679c4$var$okaidia_default,
    oneDark: ()=>$0fdca79f03e679c4$var$oneDark_default,
    oneLight: ()=>$0fdca79f03e679c4$var$oneLight_default,
    palenight: ()=>$0fdca79f03e679c4$var$palenight_default,
    shadesOfPurple: ()=>$0fdca79f03e679c4$var$shadesOfPurple_default,
    synthwave84: ()=>$0fdca79f03e679c4$var$synthwave84_default,
    ultramin: ()=>$0fdca79f03e679c4$var$ultramin_default,
    vsDark: ()=>$0fdca79f03e679c4$var$vsDark_default,
    vsLight: ()=>$0fdca79f03e679c4$var$vsLight_default
});
// src/themes/dracula.ts
var $0fdca79f03e679c4$var$theme = {
    plain: {
        color: "#F8F8F2",
        backgroundColor: "#282A36"
    },
    styles: [
        {
            types: [
                "prolog",
                "constant",
                "builtin"
            ],
            style: {
                color: "rgb(189, 147, 249)"
            }
        },
        {
            types: [
                "inserted",
                "function"
            ],
            style: {
                color: "rgb(80, 250, 123)"
            }
        },
        {
            types: [
                "deleted"
            ],
            style: {
                color: "rgb(255, 85, 85)"
            }
        },
        {
            types: [
                "changed"
            ],
            style: {
                color: "rgb(255, 184, 108)"
            }
        },
        {
            types: [
                "punctuation",
                "symbol"
            ],
            style: {
                color: "rgb(248, 248, 242)"
            }
        },
        {
            types: [
                "string",
                "char",
                "tag",
                "selector"
            ],
            style: {
                color: "rgb(255, 121, 198)"
            }
        },
        {
            types: [
                "keyword",
                "variable"
            ],
            style: {
                color: "rgb(189, 147, 249)",
                fontStyle: "italic"
            }
        },
        {
            types: [
                "comment"
            ],
            style: {
                color: "rgb(98, 114, 164)"
            }
        },
        {
            types: [
                "attr-name"
            ],
            style: {
                color: "rgb(241, 250, 140)"
            }
        }
    ]
};
var $0fdca79f03e679c4$var$dracula_default = $0fdca79f03e679c4$var$theme;
// src/themes/duotoneDark.ts
var $0fdca79f03e679c4$var$theme2 = {
    plain: {
        backgroundColor: "#2a2734",
        color: "#9a86fd"
    },
    styles: [
        {
            types: [
                "comment",
                "prolog",
                "doctype",
                "cdata",
                "punctuation"
            ],
            style: {
                color: "#6c6783"
            }
        },
        {
            types: [
                "namespace"
            ],
            style: {
                opacity: 0.7
            }
        },
        {
            types: [
                "tag",
                "operator",
                "number"
            ],
            style: {
                color: "#e09142"
            }
        },
        {
            types: [
                "property",
                "function"
            ],
            style: {
                color: "#9a86fd"
            }
        },
        {
            types: [
                "tag-id",
                "selector",
                "atrule-id"
            ],
            style: {
                color: "#eeebff"
            }
        },
        {
            types: [
                "attr-name"
            ],
            style: {
                color: "#c4b9fe"
            }
        },
        {
            types: [
                "boolean",
                "string",
                "entity",
                "url",
                "attr-value",
                "keyword",
                "control",
                "directive",
                "unit",
                "statement",
                "regex",
                "atrule",
                "placeholder",
                "variable"
            ],
            style: {
                color: "#ffcc99"
            }
        },
        {
            types: [
                "deleted"
            ],
            style: {
                textDecorationLine: "line-through"
            }
        },
        {
            types: [
                "inserted"
            ],
            style: {
                textDecorationLine: "underline"
            }
        },
        {
            types: [
                "italic"
            ],
            style: {
                fontStyle: "italic"
            }
        },
        {
            types: [
                "important",
                "bold"
            ],
            style: {
                fontWeight: "bold"
            }
        },
        {
            types: [
                "important"
            ],
            style: {
                color: "#c4b9fe"
            }
        }
    ]
};
var $0fdca79f03e679c4$var$duotoneDark_default = $0fdca79f03e679c4$var$theme2;
// src/themes/duotoneLight.ts
var $0fdca79f03e679c4$var$theme3 = {
    plain: {
        backgroundColor: "#faf8f5",
        color: "#728fcb"
    },
    styles: [
        {
            types: [
                "comment",
                "prolog",
                "doctype",
                "cdata",
                "punctuation"
            ],
            style: {
                color: "#b6ad9a"
            }
        },
        {
            types: [
                "namespace"
            ],
            style: {
                opacity: 0.7
            }
        },
        {
            types: [
                "tag",
                "operator",
                "number"
            ],
            style: {
                color: "#063289"
            }
        },
        {
            types: [
                "property",
                "function"
            ],
            style: {
                color: "#b29762"
            }
        },
        {
            types: [
                "tag-id",
                "selector",
                "atrule-id"
            ],
            style: {
                color: "#2d2006"
            }
        },
        {
            types: [
                "attr-name"
            ],
            style: {
                color: "#896724"
            }
        },
        {
            types: [
                "boolean",
                "string",
                "entity",
                "url",
                "attr-value",
                "keyword",
                "control",
                "directive",
                "unit",
                "statement",
                "regex",
                "atrule"
            ],
            style: {
                color: "#728fcb"
            }
        },
        {
            types: [
                "placeholder",
                "variable"
            ],
            style: {
                color: "#93abdc"
            }
        },
        {
            types: [
                "deleted"
            ],
            style: {
                textDecorationLine: "line-through"
            }
        },
        {
            types: [
                "inserted"
            ],
            style: {
                textDecorationLine: "underline"
            }
        },
        {
            types: [
                "italic"
            ],
            style: {
                fontStyle: "italic"
            }
        },
        {
            types: [
                "important",
                "bold"
            ],
            style: {
                fontWeight: "bold"
            }
        },
        {
            types: [
                "important"
            ],
            style: {
                color: "#896724"
            }
        }
    ]
};
var $0fdca79f03e679c4$var$duotoneLight_default = $0fdca79f03e679c4$var$theme3;
// src/themes/github.ts
var $0fdca79f03e679c4$var$theme4 = {
    plain: {
        color: "#393A34",
        backgroundColor: "#f6f8fa"
    },
    styles: [
        {
            types: [
                "comment",
                "prolog",
                "doctype",
                "cdata"
            ],
            style: {
                color: "#999988",
                fontStyle: "italic"
            }
        },
        {
            types: [
                "namespace"
            ],
            style: {
                opacity: 0.7
            }
        },
        {
            types: [
                "string",
                "attr-value"
            ],
            style: {
                color: "#e3116c"
            }
        },
        {
            types: [
                "punctuation",
                "operator"
            ],
            style: {
                color: "#393A34"
            }
        },
        {
            types: [
                "entity",
                "url",
                "symbol",
                "number",
                "boolean",
                "variable",
                "constant",
                "property",
                "regex",
                "inserted"
            ],
            style: {
                color: "#36acaa"
            }
        },
        {
            types: [
                "atrule",
                "keyword",
                "attr-name",
                "selector"
            ],
            style: {
                color: "#00a4db"
            }
        },
        {
            types: [
                "function",
                "deleted",
                "tag"
            ],
            style: {
                color: "#d73a49"
            }
        },
        {
            types: [
                "function-variable"
            ],
            style: {
                color: "#6f42c1"
            }
        },
        {
            types: [
                "tag",
                "selector",
                "keyword"
            ],
            style: {
                color: "#00009f"
            }
        }
    ]
};
var $0fdca79f03e679c4$var$github_default = $0fdca79f03e679c4$var$theme4;
// src/themes/nightOwl.ts
var $0fdca79f03e679c4$var$theme5 = {
    plain: {
        color: "#d6deeb",
        backgroundColor: "#011627"
    },
    styles: [
        {
            types: [
                "changed"
            ],
            style: {
                color: "rgb(162, 191, 252)",
                fontStyle: "italic"
            }
        },
        {
            types: [
                "deleted"
            ],
            style: {
                color: "rgba(239, 83, 80, 0.56)",
                fontStyle: "italic"
            }
        },
        {
            types: [
                "inserted",
                "attr-name"
            ],
            style: {
                color: "rgb(173, 219, 103)",
                fontStyle: "italic"
            }
        },
        {
            types: [
                "comment"
            ],
            style: {
                color: "rgb(99, 119, 119)",
                fontStyle: "italic"
            }
        },
        {
            types: [
                "string",
                "url"
            ],
            style: {
                color: "rgb(173, 219, 103)"
            }
        },
        {
            types: [
                "variable"
            ],
            style: {
                color: "rgb(214, 222, 235)"
            }
        },
        {
            types: [
                "number"
            ],
            style: {
                color: "rgb(247, 140, 108)"
            }
        },
        {
            types: [
                "builtin",
                "char",
                "constant",
                "function"
            ],
            style: {
                color: "rgb(130, 170, 255)"
            }
        },
        {
            // This was manually added after the auto-generation
            // so that punctuations are not italicised
            types: [
                "punctuation"
            ],
            style: {
                color: "rgb(199, 146, 234)"
            }
        },
        {
            types: [
                "selector",
                "doctype"
            ],
            style: {
                color: "rgb(199, 146, 234)",
                fontStyle: "italic"
            }
        },
        {
            types: [
                "class-name"
            ],
            style: {
                color: "rgb(255, 203, 139)"
            }
        },
        {
            types: [
                "tag",
                "operator",
                "keyword"
            ],
            style: {
                color: "rgb(127, 219, 202)"
            }
        },
        {
            types: [
                "boolean"
            ],
            style: {
                color: "rgb(255, 88, 116)"
            }
        },
        {
            types: [
                "property"
            ],
            style: {
                color: "rgb(128, 203, 196)"
            }
        },
        {
            types: [
                "namespace"
            ],
            style: {
                color: "rgb(178, 204, 214)"
            }
        }
    ]
};
var $0fdca79f03e679c4$var$nightOwl_default = $0fdca79f03e679c4$var$theme5;
// src/themes/nightOwlLight.ts
var $0fdca79f03e679c4$var$theme6 = {
    plain: {
        color: "#403f53",
        backgroundColor: "#FBFBFB"
    },
    styles: [
        {
            types: [
                "changed"
            ],
            style: {
                color: "rgb(162, 191, 252)",
                fontStyle: "italic"
            }
        },
        {
            types: [
                "deleted"
            ],
            style: {
                color: "rgba(239, 83, 80, 0.56)",
                fontStyle: "italic"
            }
        },
        {
            types: [
                "inserted",
                "attr-name"
            ],
            style: {
                color: "rgb(72, 118, 214)",
                fontStyle: "italic"
            }
        },
        {
            types: [
                "comment"
            ],
            style: {
                color: "rgb(152, 159, 177)",
                fontStyle: "italic"
            }
        },
        {
            types: [
                "string",
                "builtin",
                "char",
                "constant",
                "url"
            ],
            style: {
                color: "rgb(72, 118, 214)"
            }
        },
        {
            types: [
                "variable"
            ],
            style: {
                color: "rgb(201, 103, 101)"
            }
        },
        {
            types: [
                "number"
            ],
            style: {
                color: "rgb(170, 9, 130)"
            }
        },
        {
            // This was manually added after the auto-generation
            // so that punctuations are not italicised
            types: [
                "punctuation"
            ],
            style: {
                color: "rgb(153, 76, 195)"
            }
        },
        {
            types: [
                "function",
                "selector",
                "doctype"
            ],
            style: {
                color: "rgb(153, 76, 195)",
                fontStyle: "italic"
            }
        },
        {
            types: [
                "class-name"
            ],
            style: {
                color: "rgb(17, 17, 17)"
            }
        },
        {
            types: [
                "tag"
            ],
            style: {
                color: "rgb(153, 76, 195)"
            }
        },
        {
            types: [
                "operator",
                "property",
                "keyword",
                "namespace"
            ],
            style: {
                color: "rgb(12, 150, 155)"
            }
        },
        {
            types: [
                "boolean"
            ],
            style: {
                color: "rgb(188, 84, 84)"
            }
        }
    ]
};
var $0fdca79f03e679c4$var$nightOwlLight_default = $0fdca79f03e679c4$var$theme6;
// src/themes/oceanicNext.ts
var $0fdca79f03e679c4$var$colors = {
    char: "#D8DEE9",
    comment: "#999999",
    keyword: "#c5a5c5",
    primitive: "#5a9bcf",
    string: "#8dc891",
    variable: "#d7deea",
    boolean: "#ff8b50",
    punctuation: "#5FB3B3",
    tag: "#fc929e",
    function: "#79b6f2",
    className: "#FAC863",
    method: "#6699CC",
    operator: "#fc929e"
};
var $0fdca79f03e679c4$var$theme7 = {
    plain: {
        backgroundColor: "#282c34",
        color: "#ffffff"
    },
    styles: [
        {
            types: [
                "attr-name"
            ],
            style: {
                color: $0fdca79f03e679c4$var$colors.keyword
            }
        },
        {
            types: [
                "attr-value"
            ],
            style: {
                color: $0fdca79f03e679c4$var$colors.string
            }
        },
        {
            types: [
                "comment",
                "block-comment",
                "prolog",
                "doctype",
                "cdata",
                "shebang"
            ],
            style: {
                color: $0fdca79f03e679c4$var$colors.comment
            }
        },
        {
            types: [
                "property",
                "number",
                "function-name",
                "constant",
                "symbol",
                "deleted"
            ],
            style: {
                color: $0fdca79f03e679c4$var$colors.primitive
            }
        },
        {
            types: [
                "boolean"
            ],
            style: {
                color: $0fdca79f03e679c4$var$colors.boolean
            }
        },
        {
            types: [
                "tag"
            ],
            style: {
                color: $0fdca79f03e679c4$var$colors.tag
            }
        },
        {
            types: [
                "string"
            ],
            style: {
                color: $0fdca79f03e679c4$var$colors.string
            }
        },
        {
            types: [
                "punctuation"
            ],
            style: {
                color: $0fdca79f03e679c4$var$colors.string
            }
        },
        {
            types: [
                "selector",
                "char",
                "builtin",
                "inserted"
            ],
            style: {
                color: $0fdca79f03e679c4$var$colors.char
            }
        },
        {
            types: [
                "function"
            ],
            style: {
                color: $0fdca79f03e679c4$var$colors.function
            }
        },
        {
            types: [
                "operator",
                "entity",
                "url",
                "variable"
            ],
            style: {
                color: $0fdca79f03e679c4$var$colors.variable
            }
        },
        {
            types: [
                "keyword"
            ],
            style: {
                color: $0fdca79f03e679c4$var$colors.keyword
            }
        },
        {
            types: [
                "atrule",
                "class-name"
            ],
            style: {
                color: $0fdca79f03e679c4$var$colors.className
            }
        },
        {
            types: [
                "important"
            ],
            style: {
                fontWeight: "400"
            }
        },
        {
            types: [
                "bold"
            ],
            style: {
                fontWeight: "bold"
            }
        },
        {
            types: [
                "italic"
            ],
            style: {
                fontStyle: "italic"
            }
        },
        {
            types: [
                "namespace"
            ],
            style: {
                opacity: 0.7
            }
        }
    ]
};
var $0fdca79f03e679c4$var$oceanicNext_default = $0fdca79f03e679c4$var$theme7;
// src/themes/okaidia.ts
var $0fdca79f03e679c4$var$theme8 = {
    plain: {
        color: "#f8f8f2",
        backgroundColor: "#272822"
    },
    styles: [
        {
            types: [
                "changed"
            ],
            style: {
                color: "rgb(162, 191, 252)",
                fontStyle: "italic"
            }
        },
        {
            types: [
                "deleted"
            ],
            style: {
                color: "#f92672",
                fontStyle: "italic"
            }
        },
        {
            types: [
                "inserted"
            ],
            style: {
                color: "rgb(173, 219, 103)",
                fontStyle: "italic"
            }
        },
        {
            types: [
                "comment"
            ],
            style: {
                color: "#8292a2",
                fontStyle: "italic"
            }
        },
        {
            types: [
                "string",
                "url"
            ],
            style: {
                color: "#a6e22e"
            }
        },
        {
            types: [
                "variable"
            ],
            style: {
                color: "#f8f8f2"
            }
        },
        {
            types: [
                "number"
            ],
            style: {
                color: "#ae81ff"
            }
        },
        {
            types: [
                "builtin",
                "char",
                "constant",
                "function",
                "class-name"
            ],
            style: {
                color: "#e6db74"
            }
        },
        {
            types: [
                "punctuation"
            ],
            style: {
                color: "#f8f8f2"
            }
        },
        {
            types: [
                "selector",
                "doctype"
            ],
            style: {
                color: "#a6e22e",
                fontStyle: "italic"
            }
        },
        {
            types: [
                "tag",
                "operator",
                "keyword"
            ],
            style: {
                color: "#66d9ef"
            }
        },
        {
            types: [
                "boolean"
            ],
            style: {
                color: "#ae81ff"
            }
        },
        {
            types: [
                "namespace"
            ],
            style: {
                color: "rgb(178, 204, 214)",
                opacity: 0.7
            }
        },
        {
            types: [
                "tag",
                "property"
            ],
            style: {
                color: "#f92672"
            }
        },
        {
            types: [
                "attr-name"
            ],
            style: {
                color: "#a6e22e !important"
            }
        },
        {
            types: [
                "doctype"
            ],
            style: {
                color: "#8292a2"
            }
        },
        {
            types: [
                "rule"
            ],
            style: {
                color: "#e6db74"
            }
        }
    ]
};
var $0fdca79f03e679c4$var$okaidia_default = $0fdca79f03e679c4$var$theme8;
// src/themes/palenight.ts
var $0fdca79f03e679c4$var$theme9 = {
    plain: {
        color: "#bfc7d5",
        backgroundColor: "#292d3e"
    },
    styles: [
        {
            types: [
                "comment"
            ],
            style: {
                color: "rgb(105, 112, 152)",
                fontStyle: "italic"
            }
        },
        {
            types: [
                "string",
                "inserted"
            ],
            style: {
                color: "rgb(195, 232, 141)"
            }
        },
        {
            types: [
                "number"
            ],
            style: {
                color: "rgb(247, 140, 108)"
            }
        },
        {
            types: [
                "builtin",
                "char",
                "constant",
                "function"
            ],
            style: {
                color: "rgb(130, 170, 255)"
            }
        },
        {
            types: [
                "punctuation",
                "selector"
            ],
            style: {
                color: "rgb(199, 146, 234)"
            }
        },
        {
            types: [
                "variable"
            ],
            style: {
                color: "rgb(191, 199, 213)"
            }
        },
        {
            types: [
                "class-name",
                "attr-name"
            ],
            style: {
                color: "rgb(255, 203, 107)"
            }
        },
        {
            types: [
                "tag",
                "deleted"
            ],
            style: {
                color: "rgb(255, 85, 114)"
            }
        },
        {
            types: [
                "operator"
            ],
            style: {
                color: "rgb(137, 221, 255)"
            }
        },
        {
            types: [
                "boolean"
            ],
            style: {
                color: "rgb(255, 88, 116)"
            }
        },
        {
            types: [
                "keyword"
            ],
            style: {
                fontStyle: "italic"
            }
        },
        {
            types: [
                "doctype"
            ],
            style: {
                color: "rgb(199, 146, 234)",
                fontStyle: "italic"
            }
        },
        {
            types: [
                "namespace"
            ],
            style: {
                color: "rgb(178, 204, 214)"
            }
        },
        {
            types: [
                "url"
            ],
            style: {
                color: "rgb(221, 221, 221)"
            }
        }
    ]
};
var $0fdca79f03e679c4$var$palenight_default = $0fdca79f03e679c4$var$theme9;
// src/themes/shadesOfPurple.ts
var $0fdca79f03e679c4$var$theme10 = {
    plain: {
        color: "#9EFEFF",
        backgroundColor: "#2D2A55"
    },
    styles: [
        {
            types: [
                "changed"
            ],
            style: {
                color: "rgb(255, 238, 128)"
            }
        },
        {
            types: [
                "deleted"
            ],
            style: {
                color: "rgba(239, 83, 80, 0.56)"
            }
        },
        {
            types: [
                "inserted"
            ],
            style: {
                color: "rgb(173, 219, 103)"
            }
        },
        {
            types: [
                "comment"
            ],
            style: {
                color: "rgb(179, 98, 255)",
                fontStyle: "italic"
            }
        },
        {
            types: [
                "punctuation"
            ],
            style: {
                color: "rgb(255, 255, 255)"
            }
        },
        {
            types: [
                "constant"
            ],
            style: {
                color: "rgb(255, 98, 140)"
            }
        },
        {
            types: [
                "string",
                "url"
            ],
            style: {
                color: "rgb(165, 255, 144)"
            }
        },
        {
            types: [
                "variable"
            ],
            style: {
                color: "rgb(255, 238, 128)"
            }
        },
        {
            types: [
                "number",
                "boolean"
            ],
            style: {
                color: "rgb(255, 98, 140)"
            }
        },
        {
            types: [
                "attr-name"
            ],
            style: {
                color: "rgb(255, 180, 84)"
            }
        },
        {
            types: [
                "keyword",
                "operator",
                "property",
                "namespace",
                "tag",
                "selector",
                "doctype"
            ],
            style: {
                color: "rgb(255, 157, 0)"
            }
        },
        {
            types: [
                "builtin",
                "char",
                "constant",
                "function",
                "class-name"
            ],
            style: {
                color: "rgb(250, 208, 0)"
            }
        }
    ]
};
var $0fdca79f03e679c4$var$shadesOfPurple_default = $0fdca79f03e679c4$var$theme10;
// src/themes/synthwave84.ts
var $0fdca79f03e679c4$var$theme11 = {
    plain: {
        backgroundColor: "linear-gradient(to bottom, #2a2139 75%, #34294f)",
        backgroundImage: "#34294f",
        color: "#f92aad",
        textShadow: "0 0 2px #100c0f, 0 0 5px #dc078e33, 0 0 10px #fff3"
    },
    styles: [
        {
            types: [
                "comment",
                "block-comment",
                "prolog",
                "doctype",
                "cdata"
            ],
            style: {
                color: "#495495",
                fontStyle: "italic"
            }
        },
        {
            types: [
                "punctuation"
            ],
            style: {
                color: "#ccc"
            }
        },
        {
            types: [
                "tag",
                "attr-name",
                "namespace",
                "number",
                "unit",
                "hexcode",
                "deleted"
            ],
            style: {
                color: "#e2777a"
            }
        },
        {
            types: [
                "property",
                "selector"
            ],
            style: {
                color: "#72f1b8",
                textShadow: "0 0 2px #100c0f, 0 0 10px #257c5575, 0 0 35px #21272475"
            }
        },
        {
            types: [
                "function-name"
            ],
            style: {
                color: "#6196cc"
            }
        },
        {
            types: [
                "boolean",
                "selector-id",
                "function"
            ],
            style: {
                color: "#fdfdfd",
                textShadow: "0 0 2px #001716, 0 0 3px #03edf975, 0 0 5px #03edf975, 0 0 8px #03edf975"
            }
        },
        {
            types: [
                "class-name",
                "maybe-class-name",
                "builtin"
            ],
            style: {
                color: "#fff5f6",
                textShadow: "0 0 2px #000, 0 0 10px #fc1f2c75, 0 0 5px #fc1f2c75, 0 0 25px #fc1f2c75"
            }
        },
        {
            types: [
                "constant",
                "symbol"
            ],
            style: {
                color: "#f92aad",
                textShadow: "0 0 2px #100c0f, 0 0 5px #dc078e33, 0 0 10px #fff3"
            }
        },
        {
            types: [
                "important",
                "atrule",
                "keyword",
                "selector-class"
            ],
            style: {
                color: "#f4eee4",
                textShadow: "0 0 2px #393a33, 0 0 8px #f39f0575, 0 0 2px #f39f0575"
            }
        },
        {
            types: [
                "string",
                "char",
                "attr-value",
                "regex",
                "variable"
            ],
            style: {
                color: "#f87c32"
            }
        },
        {
            types: [
                "parameter"
            ],
            style: {
                fontStyle: "italic"
            }
        },
        {
            types: [
                "entity",
                "url"
            ],
            style: {
                color: "#67cdcc"
            }
        },
        {
            types: [
                "operator"
            ],
            style: {
                color: "ffffffee"
            }
        },
        {
            types: [
                "important",
                "bold"
            ],
            style: {
                fontWeight: "bold"
            }
        },
        {
            types: [
                "italic"
            ],
            style: {
                fontStyle: "italic"
            }
        },
        {
            types: [
                "entity"
            ],
            style: {
                cursor: "help"
            }
        },
        {
            types: [
                "inserted"
            ],
            style: {
                color: "green"
            }
        }
    ]
};
var $0fdca79f03e679c4$var$synthwave84_default = $0fdca79f03e679c4$var$theme11;
// src/themes/ultramin.ts
var $0fdca79f03e679c4$var$theme12 = {
    plain: {
        color: "#282a2e",
        backgroundColor: "#ffffff"
    },
    styles: [
        {
            types: [
                "comment"
            ],
            style: {
                color: "rgb(197, 200, 198)"
            }
        },
        {
            types: [
                "string",
                "number",
                "builtin",
                "variable"
            ],
            style: {
                color: "rgb(150, 152, 150)"
            }
        },
        {
            types: [
                "class-name",
                "function",
                "tag",
                "attr-name"
            ],
            style: {
                color: "rgb(40, 42, 46)"
            }
        }
    ]
};
var $0fdca79f03e679c4$var$ultramin_default = $0fdca79f03e679c4$var$theme12;
// src/themes/vsDark.ts
var $0fdca79f03e679c4$var$theme13 = {
    plain: {
        color: "#9CDCFE",
        backgroundColor: "#1E1E1E"
    },
    styles: [
        {
            types: [
                "prolog"
            ],
            style: {
                color: "rgb(0, 0, 128)"
            }
        },
        {
            types: [
                "comment"
            ],
            style: {
                color: "rgb(106, 153, 85)"
            }
        },
        {
            types: [
                "builtin",
                "changed",
                "keyword",
                "interpolation-punctuation"
            ],
            style: {
                color: "rgb(86, 156, 214)"
            }
        },
        {
            types: [
                "number",
                "inserted"
            ],
            style: {
                color: "rgb(181, 206, 168)"
            }
        },
        {
            types: [
                "constant"
            ],
            style: {
                color: "rgb(100, 102, 149)"
            }
        },
        {
            types: [
                "attr-name",
                "variable"
            ],
            style: {
                color: "rgb(156, 220, 254)"
            }
        },
        {
            types: [
                "deleted",
                "string",
                "attr-value",
                "template-punctuation"
            ],
            style: {
                color: "rgb(206, 145, 120)"
            }
        },
        {
            types: [
                "selector"
            ],
            style: {
                color: "rgb(215, 186, 125)"
            }
        },
        {
            // Fix tag color
            types: [
                "tag"
            ],
            style: {
                color: "rgb(78, 201, 176)"
            }
        },
        {
            // Fix tag color for HTML
            types: [
                "tag"
            ],
            languages: [
                "markup"
            ],
            style: {
                color: "rgb(86, 156, 214)"
            }
        },
        {
            types: [
                "punctuation",
                "operator"
            ],
            style: {
                color: "rgb(212, 212, 212)"
            }
        },
        {
            // Fix punctuation color for HTML
            types: [
                "punctuation"
            ],
            languages: [
                "markup"
            ],
            style: {
                color: "#808080"
            }
        },
        {
            types: [
                "function"
            ],
            style: {
                color: "rgb(220, 220, 170)"
            }
        },
        {
            types: [
                "class-name"
            ],
            style: {
                color: "rgb(78, 201, 176)"
            }
        },
        {
            types: [
                "char"
            ],
            style: {
                color: "rgb(209, 105, 105)"
            }
        }
    ]
};
var $0fdca79f03e679c4$var$vsDark_default = $0fdca79f03e679c4$var$theme13;
// src/themes/vsLight.ts
var $0fdca79f03e679c4$var$theme14 = {
    plain: {
        color: "#000000",
        backgroundColor: "#ffffff"
    },
    styles: [
        {
            types: [
                "comment"
            ],
            style: {
                color: "rgb(0, 128, 0)"
            }
        },
        {
            types: [
                "builtin"
            ],
            style: {
                color: "rgb(0, 112, 193)"
            }
        },
        {
            types: [
                "number",
                "variable",
                "inserted"
            ],
            style: {
                color: "rgb(9, 134, 88)"
            }
        },
        {
            types: [
                "operator"
            ],
            style: {
                color: "rgb(0, 0, 0)"
            }
        },
        {
            types: [
                "constant",
                "char"
            ],
            style: {
                color: "rgb(129, 31, 63)"
            }
        },
        {
            types: [
                "tag"
            ],
            style: {
                color: "rgb(128, 0, 0)"
            }
        },
        {
            types: [
                "attr-name"
            ],
            style: {
                color: "rgb(255, 0, 0)"
            }
        },
        {
            types: [
                "deleted",
                "string"
            ],
            style: {
                color: "rgb(163, 21, 21)"
            }
        },
        {
            types: [
                "changed",
                "punctuation"
            ],
            style: {
                color: "rgb(4, 81, 165)"
            }
        },
        {
            types: [
                "function",
                "keyword"
            ],
            style: {
                color: "rgb(0, 0, 255)"
            }
        },
        {
            types: [
                "class-name"
            ],
            style: {
                color: "rgb(38, 127, 153)"
            }
        }
    ]
};
var $0fdca79f03e679c4$var$vsLight_default = $0fdca79f03e679c4$var$theme14;
// src/themes/jettwaveDark.ts
var $0fdca79f03e679c4$var$theme15 = {
    plain: {
        color: "#f8fafc",
        backgroundColor: "#011627"
    },
    styles: [
        {
            types: [
                "prolog"
            ],
            style: {
                color: "#000080"
            }
        },
        {
            types: [
                "comment"
            ],
            style: {
                color: "#6A9955"
            }
        },
        {
            types: [
                "builtin",
                "changed",
                "keyword",
                "interpolation-punctuation"
            ],
            style: {
                color: "#569CD6"
            }
        },
        {
            types: [
                "number",
                "inserted"
            ],
            style: {
                color: "#B5CEA8"
            }
        },
        {
            types: [
                "constant"
            ],
            style: {
                color: "#f8fafc"
            }
        },
        {
            types: [
                "attr-name",
                "variable"
            ],
            style: {
                color: "#9CDCFE"
            }
        },
        {
            types: [
                "deleted",
                "string",
                "attr-value",
                "template-punctuation"
            ],
            style: {
                color: "#cbd5e1"
            }
        },
        {
            types: [
                "selector"
            ],
            style: {
                color: "#D7BA7D"
            }
        },
        {
            types: [
                "tag"
            ],
            style: {
                color: "#0ea5e9"
            }
        },
        {
            types: [
                "tag"
            ],
            languages: [
                "markup"
            ],
            style: {
                color: "#0ea5e9"
            }
        },
        {
            types: [
                "punctuation",
                "operator"
            ],
            style: {
                color: "#D4D4D4"
            }
        },
        {
            types: [
                "punctuation"
            ],
            languages: [
                "markup"
            ],
            style: {
                color: "#808080"
            }
        },
        {
            types: [
                "function"
            ],
            style: {
                color: "#7dd3fc"
            }
        },
        {
            types: [
                "class-name"
            ],
            style: {
                color: "#0ea5e9"
            }
        },
        {
            types: [
                "char"
            ],
            style: {
                color: "#D16969"
            }
        }
    ]
};
var $0fdca79f03e679c4$var$jettwaveDark_default = $0fdca79f03e679c4$var$theme15;
// src/themes/jettwaveLight.ts
var $0fdca79f03e679c4$var$theme16 = {
    plain: {
        color: "#0f172a",
        backgroundColor: "#f1f5f9"
    },
    styles: [
        {
            types: [
                "prolog"
            ],
            style: {
                color: "#000080"
            }
        },
        {
            types: [
                "comment"
            ],
            style: {
                color: "#6A9955"
            }
        },
        {
            types: [
                "builtin",
                "changed",
                "keyword",
                "interpolation-punctuation"
            ],
            style: {
                color: "#0c4a6e"
            }
        },
        {
            types: [
                "number",
                "inserted"
            ],
            style: {
                color: "#B5CEA8"
            }
        },
        {
            types: [
                "constant"
            ],
            style: {
                color: "#0f172a"
            }
        },
        {
            types: [
                "attr-name",
                "variable"
            ],
            style: {
                color: "#0c4a6e"
            }
        },
        {
            types: [
                "deleted",
                "string",
                "attr-value",
                "template-punctuation"
            ],
            style: {
                color: "#64748b"
            }
        },
        {
            types: [
                "selector"
            ],
            style: {
                color: "#D7BA7D"
            }
        },
        {
            types: [
                "tag"
            ],
            style: {
                color: "#0ea5e9"
            }
        },
        {
            types: [
                "tag"
            ],
            languages: [
                "markup"
            ],
            style: {
                color: "#0ea5e9"
            }
        },
        {
            types: [
                "punctuation",
                "operator"
            ],
            style: {
                color: "#475569"
            }
        },
        {
            types: [
                "punctuation"
            ],
            languages: [
                "markup"
            ],
            style: {
                color: "#808080"
            }
        },
        {
            types: [
                "function"
            ],
            style: {
                color: "#0e7490"
            }
        },
        {
            types: [
                "class-name"
            ],
            style: {
                color: "#0ea5e9"
            }
        },
        {
            types: [
                "char"
            ],
            style: {
                color: "#D16969"
            }
        }
    ]
};
var $0fdca79f03e679c4$var$jettwaveLight_default = $0fdca79f03e679c4$var$theme16;
// src/themes/oneDark.ts
var $0fdca79f03e679c4$var$theme17 = {
    plain: {
        backgroundColor: "hsl(220, 13%, 18%)",
        color: "hsl(220, 14%, 71%)",
        textShadow: "0 1px rgba(0, 0, 0, 0.3)"
    },
    styles: [
        {
            types: [
                "comment",
                "prolog",
                "cdata"
            ],
            style: {
                color: "hsl(220, 10%, 40%)"
            }
        },
        {
            types: [
                "doctype",
                "punctuation",
                "entity"
            ],
            style: {
                color: "hsl(220, 14%, 71%)"
            }
        },
        {
            types: [
                "attr-name",
                "class-name",
                "maybe-class-name",
                "boolean",
                "constant",
                "number",
                "atrule"
            ],
            style: {
                color: "hsl(29, 54%, 61%)"
            }
        },
        {
            types: [
                "keyword"
            ],
            style: {
                color: "hsl(286, 60%, 67%)"
            }
        },
        {
            types: [
                "property",
                "tag",
                "symbol",
                "deleted",
                "important"
            ],
            style: {
                color: "hsl(355, 65%, 65%)"
            }
        },
        {
            types: [
                "selector",
                "string",
                "char",
                "builtin",
                "inserted",
                "regex",
                "attr-value"
            ],
            style: {
                color: "hsl(95, 38%, 62%)"
            }
        },
        {
            types: [
                "variable",
                "operator",
                "function"
            ],
            style: {
                color: "hsl(207, 82%, 66%)"
            }
        },
        {
            types: [
                "url"
            ],
            style: {
                color: "hsl(187, 47%, 55%)"
            }
        },
        {
            types: [
                "deleted"
            ],
            style: {
                textDecorationLine: "line-through"
            }
        },
        {
            types: [
                "inserted"
            ],
            style: {
                textDecorationLine: "underline"
            }
        },
        {
            types: [
                "italic"
            ],
            style: {
                fontStyle: "italic"
            }
        },
        {
            types: [
                "important",
                "bold"
            ],
            style: {
                fontWeight: "bold"
            }
        },
        {
            types: [
                "important"
            ],
            style: {
                color: "hsl(220, 14%, 71%)"
            }
        }
    ]
};
var $0fdca79f03e679c4$var$oneDark_default = $0fdca79f03e679c4$var$theme17;
// src/themes/oneLight.ts
var $0fdca79f03e679c4$var$theme18 = {
    plain: {
        backgroundColor: "hsl(230, 1%, 98%)",
        color: "hsl(230, 8%, 24%)"
    },
    styles: [
        {
            types: [
                "comment",
                "prolog",
                "cdata"
            ],
            style: {
                color: "hsl(230, 4%, 64%)"
            }
        },
        {
            types: [
                "doctype",
                "punctuation",
                "entity"
            ],
            style: {
                color: "hsl(230, 8%, 24%)"
            }
        },
        {
            types: [
                "attr-name",
                "class-name",
                "boolean",
                "constant",
                "number",
                "atrule"
            ],
            style: {
                color: "hsl(35, 99%, 36%)"
            }
        },
        {
            types: [
                "keyword"
            ],
            style: {
                color: "hsl(301, 63%, 40%)"
            }
        },
        {
            types: [
                "property",
                "tag",
                "symbol",
                "deleted",
                "important"
            ],
            style: {
                color: "hsl(5, 74%, 59%)"
            }
        },
        {
            types: [
                "selector",
                "string",
                "char",
                "builtin",
                "inserted",
                "regex",
                "attr-value",
                "punctuation"
            ],
            style: {
                color: "hsl(119, 34%, 47%)"
            }
        },
        {
            types: [
                "variable",
                "operator",
                "function"
            ],
            style: {
                color: "hsl(221, 87%, 60%)"
            }
        },
        {
            types: [
                "url"
            ],
            style: {
                color: "hsl(198, 99%, 37%)"
            }
        },
        {
            types: [
                "deleted"
            ],
            style: {
                textDecorationLine: "line-through"
            }
        },
        {
            types: [
                "inserted"
            ],
            style: {
                textDecorationLine: "underline"
            }
        },
        {
            types: [
                "italic"
            ],
            style: {
                fontStyle: "italic"
            }
        },
        {
            types: [
                "important",
                "bold"
            ],
            style: {
                fontWeight: "bold"
            }
        },
        {
            types: [
                "important"
            ],
            style: {
                color: "hsl(230, 8%, 24%)"
            }
        }
    ]
};
var $0fdca79f03e679c4$var$oneLight_default = $0fdca79f03e679c4$var$theme18;
// src/utils/themeToDict.ts
var $0fdca79f03e679c4$var$themeToDict = (theme19, language)=>{
    const { plain: plain } = theme19;
    const themeDict = theme19.styles.reduce((acc, themeEntry)=>{
        const { languages: languages2, style: style } = themeEntry;
        if (languages2 && !languages2.includes(language)) return acc;
        themeEntry.types.forEach((type)=>{
            const accStyle = $0fdca79f03e679c4$var$__spreadValues($0fdca79f03e679c4$var$__spreadValues({}, acc[type]), style);
            acc[type] = accStyle;
        });
        return acc;
    }, {});
    themeDict.root = plain;
    themeDict.plain = $0fdca79f03e679c4$var$__spreadProps($0fdca79f03e679c4$var$__spreadValues({}, plain), {
        backgroundColor: void 0
    });
    return themeDict;
};
var $0fdca79f03e679c4$var$themeToDict_default = $0fdca79f03e679c4$var$themeToDict;
// src/components/useThemeDictionary.ts
var $0fdca79f03e679c4$var$useThemeDictionary = (language, theme19)=>{
    const [themeDictionary, setThemeDictionary] = (0, $acw62.useState)($0fdca79f03e679c4$var$themeToDict_default(theme19, language));
    const previousTheme = (0, $acw62.useRef)();
    const previousLanguage = (0, $acw62.useRef)();
    (0, $acw62.useEffect)(()=>{
        if (theme19 !== previousTheme.current || language !== previousLanguage.current) {
            previousTheme.current = theme19;
            previousLanguage.current = language;
            setThemeDictionary($0fdca79f03e679c4$var$themeToDict_default(theme19, language));
        }
    }, [
        language,
        theme19
    ]);
    return themeDictionary;
};
var $0fdca79f03e679c4$var$useGetLineProps = (themeDictionary)=>(0, $acw62.useCallback)((_a)=>{
        var _b = _a, { className: className, style: style, line: line } = _b, rest = $0fdca79f03e679c4$var$__objRest(_b, [
            "className",
            "style",
            "line"
        ]);
        const output = $0fdca79f03e679c4$var$__spreadProps($0fdca79f03e679c4$var$__spreadValues({}, rest), {
            className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("token-line", className)
        });
        if (typeof themeDictionary === "object" && "plain" in themeDictionary) output.style = themeDictionary.plain;
        if (typeof style === "object") output.style = $0fdca79f03e679c4$var$__spreadValues($0fdca79f03e679c4$var$__spreadValues({}, output.style || {}), style);
        return output;
    }, [
        themeDictionary
    ]);
var $0fdca79f03e679c4$var$useGetTokenProps = (themeDictionary)=>{
    const styleForToken = (0, $acw62.useCallback)(({ types: types, empty: empty })=>{
        if (themeDictionary == null) return void 0;
        else if (types.length === 1 && types[0] === "plain") return empty != null ? {
            display: "inline-block"
        } : void 0;
        else if (types.length === 1 && empty != null) return themeDictionary[types[0]];
        return Object.assign(empty != null ? {
            display: "inline-block"
        } : {}, ...types.map((type)=>themeDictionary[type]));
    }, [
        themeDictionary
    ]);
    return (0, $acw62.useCallback)((_a)=>{
        var _b = _a, { token: token, className: className, style: style } = _b, rest = $0fdca79f03e679c4$var$__objRest(_b, [
            "token",
            "className",
            "style"
        ]);
        const output = $0fdca79f03e679c4$var$__spreadProps($0fdca79f03e679c4$var$__spreadValues({}, rest), {
            className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("token", ...token.types, className),
            children: token.content,
            style: styleForToken(token)
        });
        if (style != null) output.style = $0fdca79f03e679c4$var$__spreadValues($0fdca79f03e679c4$var$__spreadValues({}, output.style || {}), style);
        return output;
    }, [
        styleForToken
    ]);
};
// src/utils/normalizeTokens.ts
var $0fdca79f03e679c4$var$newlineRe = /\r\n|\r|\n/;
var $0fdca79f03e679c4$var$normalizeEmptyLines = (line)=>{
    if (line.length === 0) line.push({
        types: [
            "plain"
        ],
        content: "\n",
        empty: true
    });
    else if (line.length === 1 && line[0].content === "") {
        line[0].content = "\n";
        line[0].empty = true;
    }
};
var $0fdca79f03e679c4$var$appendTypes = (types, add)=>{
    const typesSize = types.length;
    if (typesSize > 0 && types[typesSize - 1] === add) return types;
    return types.concat(add);
};
var $0fdca79f03e679c4$var$normalizeTokens = (tokens)=>{
    const typeArrStack = [
        []
    ];
    const tokenArrStack = [
        tokens
    ];
    const tokenArrIndexStack = [
        0
    ];
    const tokenArrSizeStack = [
        tokens.length
    ];
    let i = 0;
    let stackIndex = 0;
    let currentLine = [];
    const acc = [
        currentLine
    ];
    while(stackIndex > -1){
        while((i = tokenArrIndexStack[stackIndex]++) < tokenArrSizeStack[stackIndex]){
            let content;
            let types = typeArrStack[stackIndex];
            const tokenArr = tokenArrStack[stackIndex];
            const token = tokenArr[i];
            if (typeof token === "string") {
                types = stackIndex > 0 ? types : [
                    "plain"
                ];
                content = token;
            } else {
                types = $0fdca79f03e679c4$var$appendTypes(types, token.type);
                if (token.alias) types = $0fdca79f03e679c4$var$appendTypes(types, token.alias);
                content = token.content;
            }
            if (typeof content !== "string") {
                stackIndex++;
                typeArrStack.push(types);
                tokenArrStack.push(content);
                tokenArrIndexStack.push(0);
                tokenArrSizeStack.push(content.length);
                continue;
            }
            const splitByNewlines = content.split($0fdca79f03e679c4$var$newlineRe);
            const newlineCount = splitByNewlines.length;
            currentLine.push({
                types: types,
                content: splitByNewlines[0]
            });
            for(let i2 = 1; i2 < newlineCount; i2++){
                $0fdca79f03e679c4$var$normalizeEmptyLines(currentLine);
                acc.push(currentLine = []);
                currentLine.push({
                    types: types,
                    content: splitByNewlines[i2]
                });
            }
        }
        stackIndex--;
        typeArrStack.pop();
        tokenArrStack.pop();
        tokenArrIndexStack.pop();
        tokenArrSizeStack.pop();
    }
    $0fdca79f03e679c4$var$normalizeEmptyLines(currentLine);
    return acc;
};
var $0fdca79f03e679c4$export$2dc420fd853fdcc4 = $0fdca79f03e679c4$var$normalizeTokens;
var $0fdca79f03e679c4$export$7b94e077f7691ca1 = ({ prism: prism, code: code, grammar: grammar, language: language })=>{
    const prismRef = (0, $acw62.useRef)(prism);
    return (0, $acw62.useMemo)(()=>{
        if (grammar == null) return $0fdca79f03e679c4$export$2dc420fd853fdcc4([
            code
        ]);
        const prismConfig = {
            code: code,
            grammar: grammar,
            language: language,
            tokens: []
        };
        prismRef.current.hooks.run("before-tokenize", prismConfig);
        prismConfig.tokens = prismRef.current.tokenize(code, grammar);
        prismRef.current.hooks.run("after-tokenize", prismConfig);
        return $0fdca79f03e679c4$export$2dc420fd853fdcc4(prismConfig.tokens);
    }, [
        code,
        grammar,
        language
    ]);
};
// src/components/highlight.ts
var $0fdca79f03e679c4$var$Highlight = ({ children: children, language: _language, code: code, theme: theme19, prism: prism })=>{
    const language = _language.toLowerCase();
    const themeDictionary = $0fdca79f03e679c4$var$useThemeDictionary(language, theme19);
    const getLineProps = $0fdca79f03e679c4$var$useGetLineProps(themeDictionary);
    const getTokenProps = $0fdca79f03e679c4$var$useGetTokenProps(themeDictionary);
    const grammar = prism.languages[language];
    const tokens = $0fdca79f03e679c4$export$7b94e077f7691ca1({
        prism: prism,
        language: language,
        code: code,
        grammar: grammar
    });
    return children({
        tokens: tokens,
        className: `prism-code language-${language}`,
        style: themeDictionary != null ? themeDictionary.root : {},
        getLineProps: getLineProps,
        getTokenProps: getTokenProps
    });
};
// src/index.ts
var $0fdca79f03e679c4$export$39dbc3f558091353 = (props)=>(0, $acw62.createElement)($0fdca79f03e679c4$var$Highlight, $0fdca79f03e679c4$var$__spreadProps($0fdca79f03e679c4$var$__spreadValues({}, props), {
        prism: props.prism || $0fdca79f03e679c4$export$dc7257ffb0972f87,
        theme: props.theme || $0fdca79f03e679c4$var$vsDark_default,
        code: props.code,
        language: props.language
    }));
 /*! Bundled license information:

prismjs/prism.js:
  (**
   * Prism: Lightweight, robust, elegant syntax highlighting
   *
   * @license MIT <https://opensource.org/licenses/MIT>
   * @author Lea Verou <https://lea.verou.me>
   * @namespace
   * @public
   *)
*/ 


var $c7bafeaa47337a49$exports = {};

$parcel$defineInteropFlag($c7bafeaa47337a49$exports);

$parcel$export($c7bafeaa47337a49$exports, "default", () => $c7bafeaa47337a49$export$2e2bcd8739ae039);
// Original: https://raw.githubusercontent.com/PrismJS/prism/master/themes/prism.css
const $c7bafeaa47337a49$var$theme = {
    plain: {
        color: "black"
    },
    styles: [
        {
            types: [
                "comment",
                "prolog",
                "doctype",
                "cdata"
            ],
            style: {
                color: "slategray"
            }
        },
        {
            types: [
                "punctuation"
            ],
            style: {
                color: "#999"
            }
        },
        {
            types: [
                "namespace"
            ],
            style: {
                opacity: .7
            }
        },
        {
            types: [
                "property",
                "tag",
                "boolean",
                "number",
                "constant",
                "symbol",
                "deleted"
            ],
            style: {
                color: "#905"
            }
        },
        {
            types: [
                "selector",
                "attr-name",
                "string",
                "char",
                "builtin",
                "inserted"
            ],
            style: {
                color: "#690"
            }
        },
        {
            types: [
                "operator",
                "entity",
                "url"
            ],
            style: {
                color: "#9a6e3a"
            }
        },
        {
            types: [
                "atrule",
                "attr-value",
                "keyword"
            ],
            style: {
                color: "#07a"
            }
        },
        {
            types: [
                "function",
                "class-name"
            ],
            style: {
                color: "#DD4A68"
            }
        },
        {
            types: [
                "regex",
                "important",
                "variable"
            ],
            style: {
                color: "#e90"
            }
        },
        {
            types: [
                "important",
                "bold"
            ],
            style: {
                fontWeight: "bold"
            }
        },
        {
            types: [
                "italic"
            ],
            style: {
                fontStyle: "italic"
            }
        },
        {
            types: [
                "entity"
            ],
            style: {
                cursor: "help"
            }
        }
    ]
};
var $c7bafeaa47337a49$export$2e2bcd8739ae039 = $c7bafeaa47337a49$var$theme;


var $0dbe0b62c1b2b006$exports = {};

$parcel$export($0dbe0b62c1b2b006$exports, "posToRowCol", () => $0dbe0b62c1b2b006$export$df9efe55b3ff4a53);
$parcel$export($0dbe0b62c1b2b006$exports, "rowColToPos", () => $0dbe0b62c1b2b006$export$6467afdf82d98fe3);
$parcel$export($0dbe0b62c1b2b006$exports, "selRangeToRowCol", () => $0dbe0b62c1b2b006$export$bc11c15168e79d51);
$parcel$export($0dbe0b62c1b2b006$exports, "selRangeToPos", () => $0dbe0b62c1b2b006$export$227358d41a3ea37f);
$parcel$export($0dbe0b62c1b2b006$exports, "getCurrentRange", () => $0dbe0b62c1b2b006$export$87f8d29b41989739);
$parcel$export($0dbe0b62c1b2b006$exports, "setCurrentRange", () => $0dbe0b62c1b2b006$export$32c95bae1cfc1026);
$parcel$export($0dbe0b62c1b2b006$exports, "splitByPosition", () => $0dbe0b62c1b2b006$export$3ac9a6ef6934ce61);
$parcel$export($0dbe0b62c1b2b006$exports, "getPosition", () => $0dbe0b62c1b2b006$export$1690e12b840569b9);
$parcel$export($0dbe0b62c1b2b006$exports, "makeRange", () => $0dbe0b62c1b2b006$export$5f2a9b5d50fcc2fb);
$parcel$export($0dbe0b62c1b2b006$exports, "findPositionInNodes", () => $0dbe0b62c1b2b006$export$e4c22611227e63b6);
$parcel$export($0dbe0b62c1b2b006$exports, "useEditable", () => $0dbe0b62c1b2b006$export$52a148af2bad544);
$parcel$export($0dbe0b62c1b2b006$exports, "changeLinesContainingSelection", () => $0dbe0b62c1b2b006$export$505b0bed59db103b);
// MIT License
// Copyright (c) 2020 Phil Plückthun,
// Copyright (c) 2021 Formidable,
// Copyright (c) 2024 Daniel Krüger
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
// SOFTWARE.
// Extracted from: https://github.com/FormidableLabs/use-editable

var $acw62 = parcelRequire("acw62");


function $0dbe0b62c1b2b006$export$df9efe55b3ff4a53(text, position) {
    const linesBefore = text.slice(0, position).split("\n");
    const row = linesBefore.length - 1;
    const col = linesBefore.slice(-1)[0]?.length ?? 0;
    return {
        row: row,
        col: col
    };
}
function $0dbe0b62c1b2b006$export$6467afdf82d98fe3(text, rowCol) {
    const row = Math.max(0, rowCol.row);
    const lines = text.split("\n");
    const linesBefore = lines.slice(0, row);
    const line = lines[row];
    const rowOffset = linesBefore.join("\n").length;
    const rowNewline = linesBefore.length > 0 ? 1 : 0;
    const colOffset = (0, $512ec8d668819b2f$export$d17171af8942fb21)(0, line.length + 1, rowCol.col);
    return rowOffset + rowNewline + colOffset;
}
function $0dbe0b62c1b2b006$export$bc11c15168e79d51(text, range) {
    const start = $0dbe0b62c1b2b006$export$df9efe55b3ff4a53(text, range.start);
    const end = $0dbe0b62c1b2b006$export$df9efe55b3ff4a53(text, range.end);
    return {
        start: start,
        end: end
    };
}
function $0dbe0b62c1b2b006$export$227358d41a3ea37f(text, range) {
    const start = $0dbe0b62c1b2b006$export$6467afdf82d98fe3(text, range.start);
    const end = $0dbe0b62c1b2b006$export$6467afdf82d98fe3(text, range.end);
    return {
        start: start,
        end: end
    };
}
const $0dbe0b62c1b2b006$var$observerSettings = {
    characterData: true,
    characterDataOldValue: true,
    childList: true,
    subtree: true
};
function $0dbe0b62c1b2b006$export$87f8d29b41989739() {
    if (window.getSelection().rangeCount === 0) return null;
    return window.getSelection().getRangeAt(0);
}
function $0dbe0b62c1b2b006$export$32c95bae1cfc1026(range) {
    const selection = window.getSelection();
    selection.empty();
    selection.addRange(range);
}
function $0dbe0b62c1b2b006$var$toString(element) {
    const queue = [
        element.firstChild
    ];
    let content = "";
    let node;
    while(node = queue.pop()){
        if (node.nodeType === Node.TEXT_NODE) content += node.textContent;
        else if (node.nodeType === Node.ELEMENT_NODE && node.nodeName === "BR") content += "\n";
        if (node.nextSibling) queue.push(node.nextSibling);
        if (node.firstChild) queue.push(node.firstChild);
    }
    // contenteditable Quirk: Without plaintext-only a pre/pre-wrap element must always
    // end with at least one newline character
    if (content[content.length - 1] !== "\n") content += "\n";
    return content;
}
function $0dbe0b62c1b2b006$export$3ac9a6ef6934ce61(text, position) {
    const allBefore = text.slice(0, position.start);
    const selection = text.slice(position.start, position.end);
    const allAfter = text.slice(position.end);
    const allLinesBefore = allBefore.split("\n");
    const allLinesAfter = allAfter.split("\n");
    const linesBefore = allLinesBefore.slice(0, -1);
    const lineBefore = allLinesBefore.slice(-1)[0] ?? "";
    const [lineAfter, linesAfter] = selection.slice(-1) === "\n" ? [
        "",
        allLinesAfter
    ] : [
        allLinesAfter[0] ?? "",
        allLinesAfter.slice(1)
    ];
    return {
        linesBefore: linesBefore,
        lineBefore: lineBefore,
        selection: selection.slice(-1) === "\n" ? selection.slice(0, -1) : selection,
        lineAfter: lineAfter,
        linesAfter: linesAfter
    };
}
function $0dbe0b62c1b2b006$export$1690e12b840569b9(element) {
    // Firefox Quirk: Since plaintext-only is unsupported the position
    // of the text here is retrieved via a range, rather than traversal
    // as seen in makeRange()
    const range = $0dbe0b62c1b2b006$export$87f8d29b41989739();
    if (!range) return {
        start: 0,
        end: 0
    };
    const untilStart = document.createRange();
    untilStart.setStart(element, 0);
    untilStart.setEnd(range.startContainer, range.startOffset);
    const start = untilStart.toString().length;
    const untilEnd = document.createRange();
    untilEnd.setStart(element, 0);
    untilEnd.setEnd(range.endContainer, range.endOffset);
    const end = untilEnd.toString().length;
    return {
        start: start,
        end: end
    };
}
function $0dbe0b62c1b2b006$export$5f2a9b5d50fcc2fb(element, start, end) {
    if (start <= 0) start = 0;
    const range = document.createRange();
    const startResult = $0dbe0b62c1b2b006$export$e4c22611227e63b6(start, element);
    if (startResult === null) {
        if (element.lastChild) range.setStartAfter(element.lastChild);
        else range.setStart(element, 0);
    } else {
        const [startNode, startNodeOffset] = startResult;
        range.setStart(startNode, startNodeOffset);
    }
    if (!end || end <= start) return range;
    const endResult = $0dbe0b62c1b2b006$export$e4c22611227e63b6(end, element);
    if (endResult === null) {
        if (element.lastChild) range.setEndAfter(element.lastChild);
        else range.setEnd(element, 0);
    } else {
        const [endNode, endNodeOffset] = endResult;
        range.setEnd(endNode, endNodeOffset);
    }
    return range;
}
function $0dbe0b62c1b2b006$var$lastTextDescendant(node) {
    if (node instanceof Text) return node;
    if (node.lastChild) return $0dbe0b62c1b2b006$var$lastTextDescendant(node.lastChild);
    return null;
}
function $0dbe0b62c1b2b006$export$e4c22611227e63b6(position, container) {
    const queue = [
        container.firstChild
    ];
    let node;
    let currentPosition = 0;
    while(node = queue.pop()){
        let nodeTextLength = 0;
        if (node.nodeType === Node.TEXT_NODE) nodeTextLength = node.textContent.length;
        else if (node.nodeType === Node.ELEMENT_NODE && node.nodeName === "BR") nodeTextLength = 1;
        if (nodeTextLength > 0) {
            const offset = position - currentPosition;
            // searched position inside this node?
            if (offset <= nodeTextLength) return [
                node,
                offset
            ];
            currentPosition += nodeTextLength;
        }
        if (node.nextSibling) queue.push(node.nextSibling);
        if (node.firstChild) queue.push(node.firstChild);
    }
    return null;
}
function $0dbe0b62c1b2b006$export$52a148af2bad544(elementRef, onChange) {
    const [, rerender] = (0, $acw62.useState)([]);
    const { current: state } = (0, $acw62.useRef)({
        observer: null,
        observerDisconnected: false,
        mutations: [],
        positionToUpdateTo: null,
        dontUpdate: false,
        lastRange: null,
        isMouseDown: false
    });
    const editable = (0, $acw62.useMemo)(()=>$0dbe0b62c1b2b006$var$editableActions(elementRef, state, onChange), [
        elementRef,
        state,
        onChange
    ]);
    // Only for SSR / server-side logic
    if (typeof navigator !== "object") return editable;
    const onChangeRef = (0, $ff99259e85546794$export$4debdb1a3f0fa79e)(onChange);
    const flushChanges = (0, $acw62.useCallback)(function flushChanges() {
        if (!elementRef.current) return;
        if (state.dontUpdate) return;
        state.mutations.push(...state.observer.takeRecords());
        const position = $0dbe0b62c1b2b006$export$1690e12b840569b9(elementRef.current);
        if (state.mutations.length > 0) {
            state.observer.disconnect();
            state.observerDisconnected = true;
            const content = $0dbe0b62c1b2b006$var$toString(elementRef.current);
            state.positionToUpdateTo = position;
            $0dbe0b62c1b2b006$var$rewindMutations(state.mutations);
            state.mutations.splice(0);
            onChangeRef.current(content, position);
        }
    }, []);
    // Setup MutationObserver once
    (0, $acw62.useLayoutEffect)(()=>{
        if (typeof MutationObserver !== "undefined") state.observer = new MutationObserver((batch)=>{
            state.mutations.push(...batch);
            flushChanges();
        });
        return ()=>{
            state.observerDisconnected = true;
            state.observer.disconnect();
        };
    }, []);
    // Setup element and its EventListeners
    (0, $acw62.useLayoutEffect)(()=>{
        if (!elementRef.current) return;
        const element = elementRef.current;
        if (element.contentEditable !== "plaintext-only" && element.contentEditable !== "true") try {
            // Firefox and IE11 do not support plaintext-only mode
            element.contentEditable = "plaintext-only";
        } catch (_error) {
            element.contentEditable = "true";
        }
        function onKeyDown(event) {
            if (event.defaultPrevented || event.isComposing) return;
            if (state.observerDisconnected) {
                // React Quirk: It's expected that we may lose events while disconnected, which is why
                // we'd like to block some inputs if they're unusually fast. However, this always
                // coincides with React not executing the update immediately and then getting stuck,
                // which can be prevented by issuing a dummy state change.
                event.preventDefault();
                rerender([]);
                return;
            }
            if (element.contentEditable !== "plaintext-only") $0dbe0b62c1b2b006$var$fixNonPlaintextKeyDown(event, editable, element);
        }
        function onPaste(event) {
            event.preventDefault();
            editable.edit(event.clipboardData.getData("text/plain"));
            flushChanges();
        }
        function onCompositionStart() {
            // don't update during composition, otherwise composition breaks
            state.dontUpdate = true;
        }
        function onCompositionEnd() {
            state.dontUpdate = false;
            flushChanges();
        }
        function onBlur() {
            state.isMouseDown = false;
            state.lastRange = $0dbe0b62c1b2b006$export$87f8d29b41989739();
            window.getSelection().removeAllRanges();
        }
        function onFocus() {
            if (state.lastRange) {
                state.lastRange.collapse();
                $0dbe0b62c1b2b006$export$32c95bae1cfc1026(state.lastRange);
                state.lastRange = null;
            } else {
                const lastText = $0dbe0b62c1b2b006$var$lastTextDescendant(element);
                if (lastText) {
                    const range = document.createRange();
                    const content = lastText.textContent;
                    // Don't include the invisible (but apparently required) '\n' at the end, otherwise:
                    //   On Safari: selection's BoundingBox is off by one character to the right
                    const offset = content.endsWith("\n") ? content.length - 1 : content.length;
                    range.setStart(lastText, offset);
                    $0dbe0b62c1b2b006$export$32c95bae1cfc1026(range);
                }
            }
        }
        function onMouseDown() {
            state.isMouseDown = true;
        }
        function onMousePositionCaret(event) {
            // The editable likely got created by a mousedown. We didn't see the
            // mousedown itself and want to set the mouse position
            const emptyOrOwnSelection = document.getSelection().rangeCount === 0 || element.contains(document.getSelection().getRangeAt(0).startContainer);
            if (!state.isMouseDown && emptyOrOwnSelection && (event.type === "mouseup" || event.buttons & 1)) {
                if (document.caretRangeFromPoint) $0dbe0b62c1b2b006$export$32c95bae1cfc1026(document.caretRangeFromPoint(event.clientX, event.clientY));
                else if (document.caretPositionFromPoint) {
                    const caretPosition = document.caretPositionFromPoint(event.clientX, event.clientY);
                    const range = document.createRange();
                    range.setStart(caretPosition.offsetNode, caretPosition.offset);
                    $0dbe0b62c1b2b006$export$32c95bae1cfc1026(range);
                }
            }
        }
        function onMouseUp(event) {
            onMousePositionCaret(event);
            state.isMouseDown = false;
        }
        element.addEventListener("keydown", onKeyDown);
        element.addEventListener("paste", onPaste);
        element.addEventListener("compositionstart", onCompositionStart);
        element.addEventListener("compositionend", onCompositionEnd);
        element.addEventListener("blur", onBlur);
        element.addEventListener("focus", onFocus);
        element.addEventListener("mousedown", onMouseDown);
        element.addEventListener("mousemove", onMousePositionCaret);
        element.addEventListener("mouseup", onMouseUp);
        return ()=>{
            element.removeEventListener("keydown", onKeyDown);
            element.removeEventListener("paste", onPaste);
            element.removeEventListener("compositionstart", onCompositionStart);
            element.removeEventListener("compositionend", onCompositionEnd);
            element.removeEventListener("blur", onBlur);
            element.removeEventListener("focus", onFocus);
            element.removeEventListener("mousedown", onMouseDown);
            element.removeEventListener("mousemove", onMousePositionCaret);
            element.removeEventListener("mouseup", onMouseUp);
        };
    }, [
        elementRef.current
    ]);
    // Restore editing state for user (observe edits and position)
    (0, $acw62.useLayoutEffect)(()=>{
        if (!elementRef.current) return;
        state.observerDisconnected = false;
        state.observer.observe(elementRef.current, $0dbe0b62c1b2b006$var$observerSettings);
        if (state.positionToUpdateTo) {
            const { start: start, end: end } = state.positionToUpdateTo;
            $0dbe0b62c1b2b006$export$32c95bae1cfc1026($0dbe0b62c1b2b006$export$5f2a9b5d50fcc2fb(elementRef.current, start, end));
            state.positionToUpdateTo = null;
        }
        return ()=>{
            // don't observe changes made by react
            state.observer.disconnect();
        };
    });
    return editable;
}
function $0dbe0b62c1b2b006$var$fixNonPlaintextKeyDown(event, editable, element) {
    // Fix backspace not working
    if (event.key === "Backspace") $0dbe0b62c1b2b006$var$defaultBackspaceBehavior(event, editable, element);
}
function $0dbe0b62c1b2b006$var$defaultBackspaceBehavior(event, editable, element) {
    const position = $0dbe0b62c1b2b006$export$1690e12b840569b9(element);
    if (position.start !== position.end) {
        // delete selection
        editable.edit("", 0);
        event.preventDefault();
        event.stopPropagation();
    } else if (position.start === 0) // Don't do anything, if the caret is at the beginning of the text.
    // Especially don't stop or prevent the event, so others still process this event.
    return;
    else {
        // default: delete one character
        let deleteCount = 1;
        // delete word
        if (event.altKey) {
            const text = $0dbe0b62c1b2b006$var$toString(element);
            const { lineBefore: lineBefore } = $0dbe0b62c1b2b006$export$3ac9a6ef6934ce61(text, position);
            const matchPreviousWord = /\S+\s*$/.exec(lineBefore);
            if (matchPreviousWord) deleteCount = matchPreviousWord[0].length;
            else deleteCount = lineBefore.length + 1;
        } else if (event.ctrlKey || event.metaKey) {
            const text = $0dbe0b62c1b2b006$var$toString(element);
            const { lineBefore: lineBefore } = $0dbe0b62c1b2b006$export$3ac9a6ef6934ce61(text, position);
            deleteCount = lineBefore.length || 1;
        }
        editable.edit("", -deleteCount);
        event.preventDefault();
        event.stopPropagation();
    }
}
function $0dbe0b62c1b2b006$var$editableActions(elementRef, state, onChange) {
    return {
        update (content, position) {
            const { current: element } = elementRef;
            if (!element) return;
            const prevContent = $0dbe0b62c1b2b006$var$toString(element);
            if (!position) {
                position = $0dbe0b62c1b2b006$export$1690e12b840569b9(element);
                const charDiffCount = content.length - prevContent.length;
                position.start += charDiffCount;
                position.end += charDiffCount;
            }
            state.positionToUpdateTo = position;
            onChange(content, position);
        },
        edit (append, deleteOffset = 0, editOffset = 0) {
            const { current: element } = elementRef;
            if (!element) return;
            // delete selection
            let range = $0dbe0b62c1b2b006$export$87f8d29b41989739();
            if (!range) return;
            range.deleteContents();
            range.collapse();
            // additionally delete `deleteOffset` chars around position
            const position = $0dbe0b62c1b2b006$export$1690e12b840569b9(element);
            const start = position.start + editOffset + (deleteOffset < 0 ? deleteOffset : 0);
            const end = position.start + editOffset + (deleteOffset > 0 ? deleteOffset : 0);
            range = $0dbe0b62c1b2b006$export$5f2a9b5d50fcc2fb(element, start, end);
            range.deleteContents();
            if (append) range.insertNode(document.createTextNode(append));
            const caret = position.start + (deleteOffset < 0 ? deleteOffset : 0) + append.length;
            $0dbe0b62c1b2b006$export$32c95bae1cfc1026($0dbe0b62c1b2b006$export$5f2a9b5d50fcc2fb(element, caret));
        },
        move (pos, extent = 0) {
            const { current: element } = elementRef;
            if (!element) return;
            element.focus();
            let position = 0;
            if (typeof pos === "number") position = pos;
            else {
                if (pos.row > 0) {
                    const lines = $0dbe0b62c1b2b006$var$toString(element).split("\n").slice(0, pos.row);
                    position += lines.join("\n").length + 1;
                }
                position += pos.column;
            }
            $0dbe0b62c1b2b006$export$32c95bae1cfc1026($0dbe0b62c1b2b006$export$5f2a9b5d50fcc2fb(element, position, position + extent));
        },
        getState () {
            const { current: element } = elementRef;
            if (!element) return {
                text: "",
                position: {
                    start: 0,
                    end: 0
                }
            };
            const text = $0dbe0b62c1b2b006$var$toString(element);
            const position = $0dbe0b62c1b2b006$export$1690e12b840569b9(element);
            return {
                text: text,
                position: position
            };
        }
    };
}
function $0dbe0b62c1b2b006$var$rewindMutations(mutations) {
    for (const mutation of [
        ...mutations
    ].reverse()){
        if (mutation.oldValue !== null) mutation.target.textContent = mutation.oldValue;
        for(let i = mutation.removedNodes.length - 1; i >= 0; i--)mutation.target.insertBefore(mutation.removedNodes[i], mutation.nextSibling);
        for(let i = mutation.addedNodes.length - 1; i >= 0; i--)if (mutation.addedNodes[i].parentNode) mutation.target.removeChild(mutation.addedNodes[i]);
    }
}
function $0dbe0b62c1b2b006$export$505b0bed59db103b(editable, changeLines) {
    const { text: text, position: position } = editable.getState();
    const splitText = $0dbe0b62c1b2b006$export$3ac9a6ef6934ce61(text, position);
    const positionRowCol = $0dbe0b62c1b2b006$export$bc11c15168e79d51(text, position);
    const selectionContainingLines = (splitText.lineBefore + splitText.selection + splitText.lineAfter).split("\n");
    const changed = changeLines(selectionContainingLines, positionRowCol.start.col, positionRowCol.end.col);
    const startDiff = changed[0].length - selectionContainingLines[0].length;
    const endRowDiff = changed.length - selectionContainingLines.length;
    const endColDiff = positionRowCol.end.col === 0 ? 0 : changed.slice(-1)[0].length - selectionContainingLines.slice(-1)[0].length;
    const outdentedText = [
        ...splitText.linesBefore,
        ...changed,
        ...splitText.linesAfter
    ].join("\n");
    positionRowCol.start.col += startDiff;
    positionRowCol.end.row += endRowDiff;
    positionRowCol.end.col += endColDiff;
    const outdentedPosition = $0dbe0b62c1b2b006$export$227358d41a3ea37f(outdentedText, positionRowCol);
    editable.update(outdentedText, outdentedPosition);
}


const $cb8a0fe0beecb480$export$6a048cde9ca9b775 = /*#__PURE__*/ $acw62.memo(/*#__PURE__*/ $acw62.forwardRef(function CodeView({ code: code, container: Container = "code", language: language = "jsx", className: className = "whitespace-pre outline-none", style: style = {}, ...props }, ref) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0fdca79f03e679c4$export$39dbc3f558091353), {
        code: code,
        theme: (0, $c7bafeaa47337a49$export$2e2bcd8739ae039),
        language: language ?? "jsx",
        children: ({ style: highlightStyle, tokens: tokens, getLineProps: getLineProps, getTokenProps: getTokenProps })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Container, {
                ref: ref,
                tabIndex: -1,
                spellCheck: false,
                className: className,
                style: {
                    ...highlightStyle,
                    ...style
                },
                ...props,
                children: tokens.map((line, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        ...getLineProps({
                            line: line
                        }),
                        children: [
                            line.filter((token)=>!token.empty).map((token, key)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    ...getTokenProps({
                                        token: token
                                    })
                                }, key)),
                            "\n"
                        ]
                    }, i))
            })
    });
}));
const $cb8a0fe0beecb480$export$b7127187684f7150 = /*#__PURE__*/ $acw62.forwardRef(function CodeEditor({ code: code, onUpdate: onUpdate, ...props }, ref) {
    const codeViewRef = $acw62.useRef();
    const onChange = $acw62.useCallback((code)=>// Contenteditable needs an extra newline at the end to work
        // CodeView inserts a newline at the end, but it's not part of the state (code), so remove it
        onUpdate(code.slice(0, -1)), [
        onUpdate
    ]);
    const editable = (0, $0dbe0b62c1b2b006$export$52a148af2bad544)(codeViewRef, onChange);
    $acw62.useImperativeHandle(ref, ()=>({
            editable: editable,
            element: codeViewRef.current
        }), [
        editable,
        codeViewRef.current
    ]);
    const onKeyDown = $acw62.useCallback(function onKeyDown(event) {
        $cb8a0fe0beecb480$var$combineHandlers(event, ()=>props.onKeyDown?.(event), ()=>$cb8a0fe0beecb480$export$7154b0444fc054e2(event, editable), ()=>$cb8a0fe0beecb480$export$731ef7f45a7717c0(event, editable));
    }, [
        editable,
        props.onKeyDown
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($cb8a0fe0beecb480$export$6a048cde9ca9b775, {
        ref: codeViewRef,
        code: code,
        ...props,
        onKeyDown: onKeyDown
    });
});
function $cb8a0fe0beecb480$var$combineHandlers(event, ...handlers) {
    for (const handler of handlers){
        handler();
        if (event.isPropagationStopped()) return;
    }
}
function $cb8a0fe0beecb480$export$7154b0444fc054e2(event, editable, indentation = "  ") {
    if (event.defaultPrevented) return;
    switch((0, $5bc960417406f657$export$ebf72dfe5a040886)(event)){
        case "Enter":
            {
                event.preventDefault();
                event.stopPropagation();
                const { position: position, text: text } = editable.getState();
                const { lineBefore: lineBefore } = (0, $0dbe0b62c1b2b006$export$3ac9a6ef6934ce61)(text, position);
                const indentationMatch = /^\s*/.exec(lineBefore);
                editable.edit("\n" + indentationMatch[0]);
                return;
            }
        case "Tab":
            event.preventDefault();
            event.stopPropagation();
            (0, $0dbe0b62c1b2b006$export$505b0bed59db103b)(editable, (lines)=>lines.map((line)=>indentation + line));
            return;
        case "Shift-Tab":
            event.preventDefault();
            event.stopPropagation();
            (0, $0dbe0b62c1b2b006$export$505b0bed59db103b)(editable, (lines)=>lines.map((line)=>line.startsWith(indentation) ? line.slice(indentation.length) : line));
            return;
    }
}
function $cb8a0fe0beecb480$export$731ef7f45a7717c0(event, editable) {
    switch(event.key){
        case "ArrowDown":
            {
                const { position: position, text: text } = editable.getState();
                if (position.start === position.end && position.end === text.length - 1) // there is no default action - some other handler is allowed to react to ArrowDown
                event.preventDefault();
                return;
            }
        case "ArrowUp":
            {
                const { position: position } = editable.getState();
                if (position.start === position.end && position.end === 0) // there is no default action - some other handler is allowed to react to ArrowUp
                event.preventDefault();
                return;
            }
    }
}


var $e7500bbe9a1dee8a$exports = {};

$parcel$export($e7500bbe9a1dee8a$exports, "Pending", () => $e7500bbe9a1dee8a$export$f01a785a5ae81e49);
$parcel$export($e7500bbe9a1dee8a$exports, "getResultValue", () => $e7500bbe9a1dee8a$export$b1f4a9e5cc3a8021);
$parcel$export($e7500bbe9a1dee8a$exports, "PromiseResult", () => $e7500bbe9a1dee8a$export$66aad414e2a6f5ad);
$parcel$export($e7500bbe9a1dee8a$exports, "ImmediateResult", () => $e7500bbe9a1dee8a$export$350454bf57833028);
$parcel$export($e7500bbe9a1dee8a$exports, "resultFrom", () => $e7500bbe9a1dee8a$export$e57bc0d30024f27d);

const $e7500bbe9a1dee8a$export$f01a785a5ae81e49 = Symbol("Pending");
function $e7500bbe9a1dee8a$export$b1f4a9e5cc3a8021(result) {
    switch(result.type){
        case "immediate":
            return result.value;
        case "promise":
            switch(result.state){
                case "pending":
                    return $e7500bbe9a1dee8a$export$f01a785a5ae81e49;
                case "failed":
                    return result.error;
                case "finished":
                    return result.value;
            }
    }
}
function $e7500bbe9a1dee8a$export$66aad414e2a6f5ad(promise, resultUpdateCallback) {
    let cancelled = false;
    function cancel() {
        cancelled = true;
    }
    promise.then((value)=>{
        if (cancelled) return;
        resultUpdateCallback({
            type: "promise",
            state: "finished",
            value: value,
            cancel: cancel
        });
    }, (error)=>{
        if (cancelled) return;
        resultUpdateCallback({
            type: "promise",
            state: "failed",
            error: error,
            cancel: cancel
        });
    });
    return {
        type: "promise",
        state: "pending",
        cancel: cancel
    };
}
function $e7500bbe9a1dee8a$export$350454bf57833028(value) {
    return {
        type: "immediate",
        value: value
    };
}
function $e7500bbe9a1dee8a$export$e57bc0d30024f27d(value, resultUpdateCallback) {
    if ((0, $512ec8d668819b2f$export$4369c812aac99591)(value)) return $e7500bbe9a1dee8a$export$66aad414e2a6f5ad(value, resultUpdateCallback);
    else return $e7500bbe9a1dee8a$export$350454bf57833028(value);
}


var $0461fd3484597965$exports = {};

$parcel$export($0461fd3484597965$exports, "ErrorView", () => $0461fd3484597965$export$8c68b6013ae44ca6);


var $acw62 = parcelRequire("acw62");


function $0461fd3484597965$export$8c68b6013ae44ca6({ title: title, error: error, children: children, className: className }) {
    const [isExpanded, setExpanded] = $acw62.useState(false);
    const [isStackVisible, setStackVisible] = $acw62.useState(false);
    const toggleStackVisible = ()=>setStackVisible((isExpanded)=>!isExpanded);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: `bg-red-50 px-1 space-y-1 ${className}`,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                className: "w-full text-red-900 flex flex-row justify-start items-baseline space-x-1",
                onClick: ()=>setExpanded((e)=>!e),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        className: "flex-1 text-left truncate",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e4ec753f5c716375$export$2b9260d4a45c8710), {
                                className: "text-red-400",
                                icon: $d8206b3ab2e65c05$export$1cbf6e649ce86166
                            }),
                            " ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                className: "font-medium",
                                children: [
                                    error.name,
                                    ":"
                                ]
                            }),
                            " ",
                            error.message
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e4ec753f5c716375$export$2b9260d4a45c8710), {
                            icon: isExpanded ? $d8206b3ab2e65c05$export$887340269e6d6cac : $d8206b3ab2e65c05$export$4b5be0142d10f342
                        })
                    })
                ]
            }),
            isExpanded && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "font-medium",
                        children: title
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "text-red-950",
                        children: error.name
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                        className: "text-left text-sm flex items-baseline",
                        onClick: toggleStackVisible,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e4ec753f5c716375$export$2b9260d4a45c8710), {
                                className: "mr-2",
                                icon: isStackVisible ? $d8206b3ab2e65c05$export$4b5be0142d10f342 : $d8206b3ab2e65c05$export$6bce1afb61f2eb66,
                                size: "sm"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                children: error.message
                            })
                        ]
                    }),
                    isStackVisible && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("pre", {
                        className: "ml-3 text-sm leading-loose",
                        children: error.stack
                    }),
                    children
                ]
            })
        ]
    });
}


function $b749c8e203b309f1$export$aafb8a44cb285d8d({ result: result }) {
    switch(result.type){
        case "immediate":
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($b749c8e203b309f1$export$93660df4be02febf, {
                value: result.value,
                expandLevel: 0
            });
        case "promise":
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($b749c8e203b309f1$export$72768de54fcb5edc, {
                promiseResult: result
            });
    }
}
const $b749c8e203b309f1$export$2fc8a3f9f50cb2d6 = ({ error: error })=>{
    const [showError, setShowError] = $acw62.useState(false);
    if (showError) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($b749c8e203b309f1$export$e926676385687eaf, {
        title: "There was an error displaying the error",
        viewError: (error)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($b749c8e203b309f1$export$2fc8a3f9f50cb2d6, {
                error: error
            }),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8ded0b3da2a2e917$export$b00d1c5d070816cc), {
            table: false,
            data: error
        })
    });
    else return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
        onClick: ()=>setShowError(true),
        children: "Inspect Error"
    });
};
const $b749c8e203b309f1$export$93660df4be02febf = /*#__PURE__*/ $acw62.forwardRef(function ValueInspector(props, ref) {
    const { value: value, expandLevel: expandLevel, table: table = false } = props;
    const valueFn = $acw62.useCallback(()=>value, [
        value
    ]);
    if (typeof value?.then === "function") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($b749c8e203b309f1$export$23406d4a6d3f9299, {
        ref: ref,
        ...props
    });
    if (value === (0, $e7500bbe9a1dee8a$export$f01a785a5ae81e49)) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e4ec753f5c716375$export$2b9260d4a45c8710), {
            spinPulse: true,
            icon: $d8206b3ab2e65c05$export$1025ad641edb49c2
        })
    });
    if (/*#__PURE__*/ $acw62.isValidElement(value)) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($b749c8e203b309f1$export$e926676385687eaf, {
        title: "There was an error in your React element",
        viewError: (error)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($b749c8e203b309f1$export$2fc8a3f9f50cb2d6, {
                error: error
            }),
        autoReset: true,
        children: /*#__PURE__*/ $acw62.createElement(valueFn)
    });
    if (value instanceof SyntaxError && value.frame !== undefined) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $0461fd3484597965$export$8c68b6013ae44ca6), {
        title: "Syntax Error in your code",
        error: value,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cb8a0fe0beecb480$export$6a048cde9ca9b775), {
                code: value.frame
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($b749c8e203b309f1$export$2fc8a3f9f50cb2d6, {
                error: value
            })
        ]
    });
    if (value instanceof Error) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0461fd3484597965$export$8c68b6013ae44ca6), {
        title: "Error in your code",
        error: value,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8ded0b3da2a2e917$export$b00d1c5d070816cc), {
            table: table,
            data: value
        })
    });
    if (typeof value === "function") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($b749c8e203b309f1$export$ee198e66fec66e9, {
        ref: ref,
        func: value
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8ded0b3da2a2e917$export$b00d1c5d070816cc), {
        table: table,
        data: value,
        expandLevel: expandLevel
    });
});
const $b749c8e203b309f1$export$ee198e66fec66e9 = /*#__PURE__*/ $acw62.forwardRef(function FunctionInspector({ func: func }, ref) {
    const [isExpanded, setIsExpanded] = $acw62.useState(false);
    let code = func.toString();
    if (code.length > 2000 || !isExpanded && !code.includes("[native code]")) try {
        const ast = $fuTml.parseExpression(code);
        if ($ardUq.isFunctionExpression(ast)) code = (0, (/*@__PURE__*/$parcel$interopDefault($iQrBP)))({
            ...ast,
            body: {
                ...ast.body,
                body: []
            }
        }).code;
        else if ($ardUq.isArrowFunctionExpression(ast)) code = (0, (/*@__PURE__*/$parcel$interopDefault($iQrBP)))({
            ...ast,
            body: $ardUq.identifier("...")
        }).code;
    } catch (e) {
        code = `function ${func.name}() {}`;
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cb8a0fe0beecb480$export$6a048cde9ca9b775), {
        ref: ref,
        className: "cursor-pointer ml-4 text-xs",
        code: code,
        onClick: ()=>setIsExpanded((expanded)=>!expanded)
    });
});
const $b749c8e203b309f1$export$23406d4a6d3f9299 = /*#__PURE__*/ $acw62.forwardRef(function PromiseValueInspector(props, ref) {
    const [promiseResult, setPromiseResult] = $acw62.useState({
        state: "pending"
    });
    $acw62.useEffect(()=>{
        setPromiseResult({
            state: "pending"
        });
        props.value.then((value)=>{
            setPromiseResult({
                state: "finished",
                value: value
            });
        }, (error)=>{
            setPromiseResult({
                state: "failed",
                error: error
            });
        });
    }, [
        props.value
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($b749c8e203b309f1$export$72768de54fcb5edc, {
        ref: ref,
        promiseResult: promiseResult
    });
});
const $b749c8e203b309f1$export$72768de54fcb5edc = /*#__PURE__*/ $acw62.forwardRef(function PromiseView({ promiseResult: promiseResult }, ref) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "group/promise-inspect",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($b749c8e203b309f1$var$PromiseIndicator, {
                promiseResult: promiseResult
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($b749c8e203b309f1$var$PromiseViewValue, {
                ref: ref,
                promiseResult: promiseResult
            })
        ]
    });
});
function $b749c8e203b309f1$var$PromiseIndicator({ promiseResult: promiseResult }) {
    switch(promiseResult.state){
        case "pending":
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e4ec753f5c716375$export$2b9260d4a45c8710), {
                        className: "mr-2",
                        icon: $d8206b3ab2e65c05$export$1025ad641edb49c2,
                        spinPulse: true
                    }),
                    "Promise pending..."
                ]
            });
        case "failed":
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "h-0 group-hover/promise-inspect:h-8 group-hover/promise-inspect:border-b-2 overflow-y-hidden transition-all text-red-900 px-1 border-t-4 border-red-100 bg-red-50",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e4ec753f5c716375$export$2b9260d4a45c8710), {
                        className: "mr-2 text-red-700",
                        icon: $d8206b3ab2e65c05$export$59573943f9eebbd5
                    }),
                    "Promise rejected"
                ]
            });
        case "finished":
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "h-0 group-hover/promise-inspect:h-8 overflow-y-hidden transition-all text-green-950 px-1 border-t-4 border-green-100 bg-green-50",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e4ec753f5c716375$export$2b9260d4a45c8710), {
                        className: "mr-2 text-green-500",
                        icon: $d8206b3ab2e65c05$export$c2e9877668862374
                    }),
                    "Promise resolved"
                ]
            });
    }
}
const $b749c8e203b309f1$var$PromiseViewValue = /*#__PURE__*/ $acw62.forwardRef(function PromiseViewValue({ promiseResult: promiseResult }, ref) {
    switch(promiseResult.state){
        case "pending":
            return null;
        case "failed":
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($b749c8e203b309f1$export$93660df4be02febf, {
                    ref: ref,
                    value: promiseResult.error
                })
            });
        case "finished":
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($b749c8e203b309f1$export$93660df4be02febf, {
                    ref: ref,
                    value: promiseResult.value
                })
            });
    }
});
class $b749c8e203b309f1$export$e926676385687eaf extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            caughtError: null
        };
    }
    static getDerivedStateFromError(error) {
        console.log("getDerivedStateFromError", error);
        return {
            caughtError: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.log("componentDidCatch", error, errorInfo);
    }
    componentDidUpdate(prevProps, prevState) {
        if (this.props.autoReset && this.props !== prevProps && this.state.caughtError && prevState.caughtError) this.retry();
    }
    retry() {
        this.setState({
            caughtError: null
        });
    }
    render() {
        if (this.state.caughtError) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $0461fd3484597965$export$8c68b6013ae44ca6), {
            title: this.props.title,
            error: this.state.caughtError,
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        onClick: this.retry.bind(this),
                        children: "Retry"
                    })
                }),
                this.props.viewError && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    children: this.props.viewError(this.state.caughtError)
                })
            ]
        });
        return this.props.children;
    }
}



const $b8f588c17e3c1433$var$SafeBlockTag = Symbol("SafeBlock");
function $b8f588c17e3c1433$export$eff0252ee3375215(value) {
    return value?.[$b8f588c17e3c1433$var$SafeBlockTag] === $b8f588c17e3c1433$var$SafeBlockTag;
}
function $b8f588c17e3c1433$export$e255fd3f9a510304(block) {
    if ($b8f588c17e3c1433$export$eff0252ee3375215(block)) return block;
    const errorRef = {
        lostError: null,
        reportError: null
    };
    function reportError(reason, error) {
        // prevent reporting inside a React update with setTimeout
        setTimeout(()=>{
            if (errorRef.reportError) errorRef.reportError({
                reason: reason,
                error: error
            });
            else {
                console.warn(reason, error, error?.stack);
                errorRef.lostError = {
                    reason: reason,
                    error: error
                };
            }
        });
    }
    const Component = /*#__PURE__*/ $acw62.forwardRef(function Component({ state: state, dispatch: dispatch, env: env }, ref) {
        const [lastError, setLastError] = $acw62.useState(null);
        $acw62.useEffect(()=>{
            const lostError = errorRef.lostError;
            errorRef.lostError = null;
            errorRef.reportError = setLastError;
            if (lostError) setLastError(lostError);
            return ()=>{
                errorRef.reportError = null;
            };
        }, []);
        const safeDispatch = $acw62.useCallback((action)=>{
            dispatch((state, context)=>{
                try {
                    return action(state, context);
                } catch (error) {
                    reportError("Block: Last action failed", error);
                    return {
                        state: state
                    };
                }
            });
        }, [
            dispatch,
            setLastError
        ]);
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($acw62.Fragment, {
            children: [
                lastError && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($b8f588c17e3c1433$var$ViewInternalError, {
                    title: lastError.reason,
                    error: lastError.error,
                    onDismiss: ()=>setLastError(null)
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b749c8e203b309f1$export$e926676385687eaf), {
                    title: "Block: Rendering failed",
                    children: block.view({
                        ref: ref,
                        state: state,
                        dispatch: safeDispatch,
                        env: env
                    })
                })
            ]
        });
    });
    return {
        ...block,
        [$b8f588c17e3c1433$var$SafeBlockTag]: $b8f588c17e3c1433$var$SafeBlockTag,
        $$UNSAFE_BLOCK: block,
        Component: Component,
        view (props) {
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, {
                ...props
            });
        },
        fromJSON (json, dispatch, env) {
            function safeDispatch(action) {
                dispatch((state, context)=>{
                    try {
                        return action(state, context);
                    } catch (e) {
                        reportError("Block: Could not update after fromJSON", e);
                        return {
                            state: state
                        };
                    }
                });
            }
            try {
                return block.fromJSON(json, safeDispatch, env);
            } catch (e) {
                // TODO: show more error details: `e instanceof ValidationError && { details: e.toString(), json }`
                reportError("Block: Could not load JSON", e);
                return block.init;
            }
        },
        toJSON (state) {
            try {
                return block.toJSON(state);
            } catch (e) {
                // TODO: show more error details: `{ state }`
                reportError("Block: Could not convert to JSON", e);
                return null;
            }
        },
        getResult (state) {
            try {
                return block.getResult(state);
            } catch (e) {
                reportError("Block: Could not get result", e);
                return e;
            }
        },
        recompute (state, dispatch, env, changedVars) {
            function safeDispatch(action) {
                dispatch((state, context)=>{
                    try {
                        return action(state, context);
                    } catch (e) {
                        reportError("Block: Could not update after recompute", e);
                        return {
                            state: state
                        };
                    }
                });
            }
            try {
                return block.recompute(state, safeDispatch, env, changedVars);
            } catch (e) {
                reportError("Block: Could not recompute block", e);
                return {
                    state: state,
                    invalidated: false
                };
            }
        }
    };
}
function $b8f588c17e3c1433$var$ViewInternalError({ title: title, error: error, onDismiss: onDismiss }) {
    if (error === null) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $0461fd3484597965$export$8c68b6013ae44ca6), {
        title: title,
        error: error,
        className: "sticky top-1 my-1 z-20 shadow-lg",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                onClick: onDismiss,
                children: "Dismiss"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b749c8e203b309f1$export$2fc8a3f9f50cb2d6), {
                error: error
            })
        ]
    });
}


function $2d38c60d8f38da78$export$e2d7b3be314ea7f1(innerBlock) {
    const safeInnerBlock = (0, $b8f588c17e3c1433$export$e255fd3f9a510304)(innerBlock);
    return $6f23581c0aef6dc2$export$185802fd694ee1f5({
        init: $d16c6eb40739a961$export$4354f8b0f0e23ee4($ee99fa6430885fc2$export$2cd8252107eb640b(safeInnerBlock.init)),
        view ({ state: state, dispatch: dispatch, env: env }, ref) {
            const fromJSON = $acw62.useCallback(function fromJSON(json, env) {
                const dispatchInner = $d16c6eb40739a961$export$5511957981ea5d3d(dispatch, env, fromJSON);
                return $ee99fa6430885fc2$export$21625637effda04(json, dispatchInner, env, safeInnerBlock);
            }, [
                safeInnerBlock
            ]);
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5bc960417406f657$export$38fa2c572343d169), {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5bc960417406f657$export$179b7008884d6e13), {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d16c6eb40739a961$export$7302fe062d1000a6), {
                        state: state,
                        dispatch: dispatch,
                        env: env,
                        fromJSON: fromJSON,
                        children: ({ state: state, dispatch: dispatch, dispatchHistory: dispatchHistory })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($70e75050ef1824a9$export$7692dd7fce48b403, {
                                state: state,
                                dispatch: dispatch,
                                dispatchHistory: dispatchHistory,
                                env: env,
                                innerBlock: safeInnerBlock,
                                blockRef: ref
                            })
                    })
                })
            });
        },
        recompute (state, dispatch, env, changedVars) {
            function fromJSON(json, env) {
                return $ee99fa6430885fc2$export$21625637effda04(json, dispatchInner, env, safeInnerBlock);
            }
            const dispatchInner = $d16c6eb40739a961$export$5511957981ea5d3d(dispatch, env, fromJSON);
            // Ugly, as usual. Hopefully this workaround disappears after
            // properly splitting off History
            let invalidated = false;
            const newState = $d16c6eb40739a961$export$b4dce3aba232bc77(state, (doc)=>{
                const { state: state, invalidated: inv } = $ee99fa6430885fc2$export$1f297d8d0ce29e3(doc, dispatchInner, env, changedVars, safeInnerBlock);
                invalidated = inv;
                return state;
            }, env, fromJSON);
            return {
                state: newState,
                invalidated: invalidated
            };
        },
        getResult (state) {
            // FIXME: Return the result of the current historic position
            // Problem: Needs env and fromJSON (-> dispatch) to load a not yet
            //          deserialized state from the history
            return $ee99fa6430885fc2$export$ec795fdf61e2a255(state.inner, safeInnerBlock);
        },
        fromJSON (json, dispatch, env) {
            function fromJSON(json, env) {
                return $ee99fa6430885fc2$export$21625637effda04(json, dispatchInner, env, safeInnerBlock);
            }
            const dispatchInner = $d16c6eb40739a961$export$5511957981ea5d3d(dispatch, env, fromJSON);
            return $d16c6eb40739a961$export$cf051384706afd3b(json, env, (json, env)=>$ee99fa6430885fc2$export$21625637effda04(json, dispatchInner, env, safeInnerBlock));
        },
        toJSON (state) {
            return $d16c6eb40739a961$export$97d9bbfce4fb52e9(state, (inner)=>$9d7e60768dbfb647$export$54fd2c36b5cc6731(inner, safeInnerBlock));
        }
    });
}


var $3cde51ebcb63af9c$exports = {};

$parcel$export($3cde51ebcb63af9c$exports, "BlockSelector", () => $3cde51ebcb63af9c$export$7ddf129dd8d5219f);

parcelRequire("acw62");


var $e26ee743ff8e9b71$exports = {};

$parcel$export($e26ee743ff8e9b71$exports, "parseReactOpts", () => $e26ee743ff8e9b71$export$781f96b776d12a10);
$parcel$export($e26ee743ff8e9b71$exports, "transformReactOpts", () => $e26ee743ff8e9b71$export$d3e856abbe388fd9);
$parcel$export($e26ee743ff8e9b71$exports, "parseJSExpr", () => $e26ee743ff8e9b71$export$f18e6236bf501d35);
$parcel$export($e26ee743ff8e9b71$exports, "transformJSAst", () => $e26ee743ff8e9b71$export$586db8feda877f8b);
$parcel$export($e26ee743ff8e9b71$exports, "programReturnExprAst", () => $e26ee743ff8e9b71$export$72dfcd1a8a332feb);
$parcel$export($e26ee743ff8e9b71$exports, "fileExprAst", () => $e26ee743ff8e9b71$export$c8cd61a56d6527d7);
$parcel$export($e26ee743ff8e9b71$exports, "transformJSExpr", () => $e26ee743ff8e9b71$export$2994de6e55d9afad);
$parcel$export($e26ee743ff8e9b71$exports, "RESERVED_JS_KEYWORDS", () => $e26ee743ff8e9b71$export$cf73bddf32967675);
$parcel$export($e26ee743ff8e9b71$exports, "isValidJSVarName", () => $e26ee743ff8e9b71$export$7b556d59e5af9774);
$parcel$export($e26ee743ff8e9b71$exports, "emptyCompiled", () => $e26ee743ff8e9b71$export$42b2ceb4792e5d2b);
$parcel$export($e26ee743ff8e9b71$exports, "compileExprAst", () => $e26ee743ff8e9b71$export$e959469147b73464);
$parcel$export($e26ee743ff8e9b71$exports, "freeVars", () => $e26ee743ff8e9b71$export$89bbee6221053207);
$parcel$export($e26ee743ff8e9b71$exports, "containsToplevelAsync", () => $e26ee743ff8e9b71$export$997fc224f08e3d6);
$parcel$export($e26ee743ff8e9b71$exports, "AsyncFunction", () => $e26ee743ff8e9b71$export$cb6ddc2b23bc63b2);
$parcel$export($e26ee743ff8e9b71$exports, "findVarIn", () => $e26ee743ff8e9b71$export$6bc3a4a8c9d602ce);
$parcel$export($e26ee743ff8e9b71$exports, "compileJSExpr", () => $e26ee743ff8e9b71$export$fbb86026bc177442);
$parcel$export($e26ee743ff8e9b71$exports, "compileJSExprSafe", () => $e26ee743ff8e9b71$export$c19cabcb7ba30452);
$parcel$export($e26ee743ff8e9b71$exports, "annotateCodeFrame", () => $e26ee743ff8e9b71$export$9e0f7ddfe8029a4c);
$parcel$export($e26ee743ff8e9b71$exports, "computeExpr", () => $e26ee743ff8e9b71$export$946ba5975ff1c976);
$parcel$export($e26ee743ff8e9b71$exports, "computeExprUNSAFE", () => $e26ee743ff8e9b71$export$6f349f186c49a218);
$parcel$export($e26ee743ff8e9b71$exports, "freeVarsExpr", () => $e26ee743ff8e9b71$export$f616ad0a3559dfff);
$parcel$export($e26ee743ff8e9b71$exports, "parseJSScript", () => $e26ee743ff8e9b71$export$46908aa9fab14968);
$parcel$export($e26ee743ff8e9b71$exports, "transformJSScript", () => $e26ee743ff8e9b71$export$64025573396b3640);
$parcel$export($e26ee743ff8e9b71$exports, "compileScript", () => $e26ee743ff8e9b71$export$e7f87faa5d06fe13);
$parcel$export($e26ee743ff8e9b71$exports, "compileScriptSafe", () => $e26ee743ff8e9b71$export$4495ab609416a46b);
$parcel$export($e26ee743ff8e9b71$exports, "computeScript", () => $e26ee743ff8e9b71$export$e696a2a6bb377f32);
$parcel$export($e26ee743ff8e9b71$exports, "freeVarsScript", () => $e26ee743ff8e9b71$export$38cd3a282912ac5);

var $7Ockm = parcelRequire("7Ockm");
var $ee632e633864f26f$exports = {};
"use strict";
Object.defineProperty($ee632e633864f26f$exports, "__esModule", {
    value: true
});
var $c75bf8fd9239ab48$exports = {};
"use strict";
Object.defineProperty($c75bf8fd9239ab48$exports, "__esModule", {
    value: true
});
$c75bf8fd9239ab48$exports.declare = $c75bf8fd9239ab48$var$declare;
$c75bf8fd9239ab48$exports.declarePreset = void 0;
const $c75bf8fd9239ab48$var$apiPolyfills = {
    assertVersion: (api)=>(range)=>{
            $c75bf8fd9239ab48$var$throwVersionError(range, api.version);
        }
};
Object.assign($c75bf8fd9239ab48$var$apiPolyfills, {
    targets: ()=>()=>{
            return {};
        },
    assumption: ()=>()=>{
            return undefined;
        }
});
function $c75bf8fd9239ab48$var$declare(builder) {
    return (api, options, dirname)=>{
        var _clonedApi2;
        let clonedApi;
        for (const name of Object.keys($c75bf8fd9239ab48$var$apiPolyfills)){
            var _clonedApi;
            if (api[name]) continue;
            (_clonedApi = clonedApi) != null ? _clonedApi : clonedApi = $c75bf8fd9239ab48$var$copyApiObject(api);
            clonedApi[name] = $c75bf8fd9239ab48$var$apiPolyfills[name](clonedApi);
        }
        return builder((_clonedApi2 = clonedApi) != null ? _clonedApi2 : api, options || {}, dirname);
    };
}
const $c75bf8fd9239ab48$var$declarePreset = $c75bf8fd9239ab48$exports.declarePreset = $c75bf8fd9239ab48$var$declare;
function $c75bf8fd9239ab48$var$copyApiObject(api) {
    let proto = null;
    if (typeof api.version === "string" && /^7\./.test(api.version)) {
        proto = Object.getPrototypeOf(api);
        if (proto && (!hasOwnProperty.call(proto, "version") || !hasOwnProperty.call(proto, "transform") || !hasOwnProperty.call(proto, "template") || !hasOwnProperty.call(proto, "types"))) proto = null;
    }
    return Object.assign({}, proto, api);
}
function $c75bf8fd9239ab48$var$throwVersionError(range, version) {
    if (typeof range === "number") {
        if (!Number.isInteger(range)) throw new Error("Expected string or integer value.");
        range = `^${range}.0.0-0`;
    }
    if (typeof range !== "string") throw new Error("Expected string or integer value.");
    const limit = Error.stackTraceLimit;
    if (typeof limit === "number" && limit < 25) Error.stackTraceLimit = 25;
    let err;
    if (version.slice(0, 2) === "7.") err = new Error(`Requires Babel "^7.0.0-beta.41", but was loaded with "${version}". ` + `You'll need to update your @babel/core version.`);
    else err = new Error(`Requires Babel "${range}", but was loaded with "${version}". ` + `If you are sure you have a compatible version of @babel/core, ` + `it is likely that something in your build process is loading the ` + `wrong version. Inspect the stack trace of this error to look for ` + `the first entry that doesn't mention "@babel/core" or "babel-core" ` + `to see what is calling Babel.`);
    if (typeof limit === "number") Error.stackTraceLimit = limit;
    throw Object.assign(err, {
        code: "BABEL_VERSION_UNSUPPORTED",
        version: version,
        range: range
    });
}


var $bd46ea0fdc2ab1a5$exports = {};
"use strict";
Object.defineProperty($bd46ea0fdc2ab1a5$exports, "__esModule", {
    value: true
});
$bd46ea0fdc2ab1a5$exports.default = void 0;
var $6ee3968088198c97$exports = {};
"use strict";
Object.defineProperty($6ee3968088198c97$exports, "__esModule", {
    value: true
});
$6ee3968088198c97$exports.default = $6ee3968088198c97$var$createPlugin;
var $171e20ff1a530e50$exports = {};
"use strict";
Object.defineProperty($171e20ff1a530e50$exports, "__esModule", {
    value: true
});
$171e20ff1a530e50$exports.default = void 0;

var $171e20ff1a530e50$var$_default = $171e20ff1a530e50$exports.default = (0, $c75bf8fd9239ab48$exports.declare)((api)=>{
    api.assertVersion(7);
    return {
        name: "syntax-jsx",
        manipulateOptions (opts, parserOpts) {
            if (parserOpts.plugins.some((p)=>(Array.isArray(p) ? p[0] : p) === "typescript")) return;
            parserOpts.plugins.push("jsx");
        }
    };
});




var $7Ockm = parcelRequire("7Ockm");

var $ePJIL = parcelRequire("ePJIL");
var $d41d12e27d93d183$exports = {};
"use strict";
Object.defineProperty($d41d12e27d93d183$exports, "__esModule", {
    value: true
});
$d41d12e27d93d183$exports.default = $d41d12e27d93d183$var$annotateAsPure;

var $ardUq = parcelRequire("ardUq");
const { addComment: $d41d12e27d93d183$var$addComment } = $ardUq;
const $d41d12e27d93d183$var$PURE_ANNOTATION = "#__PURE__";
const $d41d12e27d93d183$var$isPureAnnotated = ({ leadingComments: leadingComments })=>!!leadingComments && leadingComments.some((comment)=>/[@#]__PURE__/.test(comment.value));
function $d41d12e27d93d183$var$annotateAsPure(pathOrNode) {
    const node = pathOrNode["node"] || pathOrNode;
    if ($d41d12e27d93d183$var$isPureAnnotated(node)) return;
    $d41d12e27d93d183$var$addComment(node, "leading", $d41d12e27d93d183$var$PURE_ANNOTATION);
}


const $6ee3968088198c97$var$DEFAULT = {
    importSource: "react",
    runtime: "automatic",
    pragma: "React.createElement",
    pragmaFrag: "React.Fragment"
};
const $6ee3968088198c97$var$JSX_SOURCE_ANNOTATION_REGEX = /^\s*\*?\s*@jsxImportSource\s+([^\s]+)\s*$/m;
const $6ee3968088198c97$var$JSX_RUNTIME_ANNOTATION_REGEX = /^\s*\*?\s*@jsxRuntime\s+([^\s]+)\s*$/m;
const $6ee3968088198c97$var$JSX_ANNOTATION_REGEX = /^\s*\*?\s*@jsx\s+([^\s]+)\s*$/m;
const $6ee3968088198c97$var$JSX_FRAG_ANNOTATION_REGEX = /^\s*\*?\s*@jsxFrag\s+([^\s]+)\s*$/m;
const $6ee3968088198c97$var$get = (pass, name)=>pass.get(`@babel/plugin-react-jsx/${name}`);
const $6ee3968088198c97$var$set = (pass, name, v)=>pass.set(`@babel/plugin-react-jsx/${name}`, v);
function $6ee3968088198c97$var$hasProto(node) {
    return node.properties.some((value)=>$7Ockm.types.isObjectProperty(value, {
            computed: false,
            shorthand: false
        }) && ($7Ockm.types.isIdentifier(value.key, {
            name: "__proto__"
        }) || $7Ockm.types.isStringLiteral(value.key, {
            value: "__proto__"
        })));
}
function $6ee3968088198c97$var$createPlugin({ name: name, development: development }) {
    return (0, $c75bf8fd9239ab48$exports.declare)((_, options)=>{
        const { pure: PURE_ANNOTATION, throwIfNamespace: throwIfNamespace = true, filter: filter, runtime: RUNTIME_DEFAULT = development ? "automatic" : "classic", importSource: IMPORT_SOURCE_DEFAULT = $6ee3968088198c97$var$DEFAULT.importSource, pragma: PRAGMA_DEFAULT = $6ee3968088198c97$var$DEFAULT.pragma, pragmaFrag: PRAGMA_FRAG_DEFAULT = $6ee3968088198c97$var$DEFAULT.pragmaFrag } = options;
        var { useSpread: useSpread = false, useBuiltIns: useBuiltIns = false } = options;
        if (RUNTIME_DEFAULT === "classic") {
            if (typeof useSpread !== "boolean") throw new Error("transform-react-jsx currently only accepts a boolean option for useSpread (defaults to false)");
            if (typeof useBuiltIns !== "boolean") throw new Error("transform-react-jsx currently only accepts a boolean option for useBuiltIns (defaults to false)");
            if (useSpread && useBuiltIns) throw new Error("transform-react-jsx currently only accepts useBuiltIns or useSpread but not both");
        }
        const injectMetaPropertiesVisitor = {
            JSXOpeningElement (path, state) {
                const attributes = [];
                if (isThisAllowed(path.scope)) attributes.push($7Ockm.types.jsxAttribute($7Ockm.types.jsxIdentifier("__self"), $7Ockm.types.jsxExpressionContainer($7Ockm.types.thisExpression())));
                attributes.push($7Ockm.types.jsxAttribute($7Ockm.types.jsxIdentifier("__source"), $7Ockm.types.jsxExpressionContainer($6ee3968088198c97$var$makeSource(path, state))));
                path.pushContainer("attributes", attributes);
            }
        };
        return {
            name: name,
            inherits: $171e20ff1a530e50$exports.default,
            visitor: {
                JSXNamespacedName (path) {
                    if (throwIfNamespace) throw path.buildCodeFrameError(`Namespace tags are not supported by default. React's JSX doesn't support namespace tags. \
You can set \`throwIfNamespace: false\` to bypass this warning.`);
                },
                JSXSpreadChild (path) {
                    throw path.buildCodeFrameError("Spread children are not supported in React.");
                },
                Program: {
                    enter (path, state) {
                        const { file: file } = state;
                        let runtime = RUNTIME_DEFAULT;
                        let source = IMPORT_SOURCE_DEFAULT;
                        let pragma = PRAGMA_DEFAULT;
                        let pragmaFrag = PRAGMA_FRAG_DEFAULT;
                        let sourceSet = !!options.importSource;
                        let pragmaSet = !!options.pragma;
                        let pragmaFragSet = !!options.pragmaFrag;
                        if (file.ast.comments) for (const comment of file.ast.comments){
                            const sourceMatches = $6ee3968088198c97$var$JSX_SOURCE_ANNOTATION_REGEX.exec(comment.value);
                            if (sourceMatches) {
                                source = sourceMatches[1];
                                sourceSet = true;
                            }
                            const runtimeMatches = $6ee3968088198c97$var$JSX_RUNTIME_ANNOTATION_REGEX.exec(comment.value);
                            if (runtimeMatches) runtime = runtimeMatches[1];
                            const jsxMatches = $6ee3968088198c97$var$JSX_ANNOTATION_REGEX.exec(comment.value);
                            if (jsxMatches) {
                                pragma = jsxMatches[1];
                                pragmaSet = true;
                            }
                            const jsxFragMatches = $6ee3968088198c97$var$JSX_FRAG_ANNOTATION_REGEX.exec(comment.value);
                            if (jsxFragMatches) {
                                pragmaFrag = jsxFragMatches[1];
                                pragmaFragSet = true;
                            }
                        }
                        $6ee3968088198c97$var$set(state, "runtime", runtime);
                        if (runtime === "classic") {
                            if (sourceSet) throw path.buildCodeFrameError(`importSource cannot be set when runtime is classic.`);
                            const createElement = $6ee3968088198c97$var$toMemberExpression(pragma);
                            const fragment = $6ee3968088198c97$var$toMemberExpression(pragmaFrag);
                            $6ee3968088198c97$var$set(state, "id/createElement", ()=>$7Ockm.types.cloneNode(createElement));
                            $6ee3968088198c97$var$set(state, "id/fragment", ()=>$7Ockm.types.cloneNode(fragment));
                            $6ee3968088198c97$var$set(state, "defaultPure", pragma === $6ee3968088198c97$var$DEFAULT.pragma);
                        } else if (runtime === "automatic") {
                            if (pragmaSet || pragmaFragSet) throw path.buildCodeFrameError(`pragma and pragmaFrag cannot be set when runtime is automatic.`);
                            const define = (name, id)=>$6ee3968088198c97$var$set(state, name, createImportLazily(state, path, id, source));
                            define("id/jsx", development ? "jsxDEV" : "jsx");
                            define("id/jsxs", development ? "jsxDEV" : "jsxs");
                            define("id/createElement", "createElement");
                            define("id/fragment", "Fragment");
                            $6ee3968088198c97$var$set(state, "defaultPure", source === $6ee3968088198c97$var$DEFAULT.importSource);
                        } else throw path.buildCodeFrameError(`Runtime must be either "classic" or "automatic".`);
                        if (development) path.traverse(injectMetaPropertiesVisitor, state);
                    }
                },
                JSXFragment: {
                    exit (path, file) {
                        let callExpr;
                        if ($6ee3968088198c97$var$get(file, "runtime") === "classic") callExpr = buildCreateElementFragmentCall(path, file);
                        else callExpr = buildJSXFragmentCall(path, file);
                        path.replaceWith($7Ockm.types.inherits(callExpr, path.node));
                    }
                },
                JSXElement: {
                    exit (path, file) {
                        let callExpr;
                        if ($6ee3968088198c97$var$get(file, "runtime") === "classic" || shouldUseCreateElement(path)) callExpr = buildCreateElementCall(path, file);
                        else callExpr = buildJSXElementCall(path, file);
                        path.replaceWith($7Ockm.types.inherits(callExpr, path.node));
                    }
                },
                JSXAttribute (path) {
                    if ($7Ockm.types.isJSXElement(path.node.value)) path.node.value = $7Ockm.types.jsxExpressionContainer(path.node.value);
                }
            }
        };
        function isDerivedClass(classPath) {
            return classPath.node.superClass !== null;
        }
        function isThisAllowed(scope) {
            do {
                const { path: path } = scope;
                if (path.isFunctionParent() && !path.isArrowFunctionExpression()) {
                    if (!path.isMethod()) return true;
                    if (path.node.kind !== "constructor") return true;
                    return !isDerivedClass(path.parentPath.parentPath);
                }
                if (path.isTSModuleBlock()) return false;
            }while (scope = scope.parent);
            return true;
        }
        function call(pass, name, args) {
            const node = $7Ockm.types.callExpression($6ee3968088198c97$var$get(pass, `id/${name}`)(), args);
            if (PURE_ANNOTATION != null ? PURE_ANNOTATION : $6ee3968088198c97$var$get(pass, "defaultPure")) (0, $d41d12e27d93d183$exports.default)(node);
            return node;
        }
        function shouldUseCreateElement(path) {
            const openingPath = path.get("openingElement");
            const attributes = openingPath.node.attributes;
            let seenPropsSpread = false;
            for(let i = 0; i < attributes.length; i++){
                const attr = attributes[i];
                if (seenPropsSpread && $7Ockm.types.isJSXAttribute(attr) && attr.name.name === "key") return true;
                else if ($7Ockm.types.isJSXSpreadAttribute(attr)) seenPropsSpread = true;
            }
            return false;
        }
        function convertJSXIdentifier(node, parent) {
            if ($7Ockm.types.isJSXIdentifier(node)) {
                if (node.name === "this" && $7Ockm.types.isReferenced(node, parent)) return $7Ockm.types.thisExpression();
                else if ($7Ockm.types.isValidIdentifier(node.name, false)) {
                    node.type = "Identifier";
                    return node;
                } else return $7Ockm.types.stringLiteral(node.name);
            } else if ($7Ockm.types.isJSXMemberExpression(node)) return $7Ockm.types.memberExpression(convertJSXIdentifier(node.object, node), convertJSXIdentifier(node.property, node));
            else if ($7Ockm.types.isJSXNamespacedName(node)) return $7Ockm.types.stringLiteral(`${node.namespace.name}:${node.name.name}`);
            return node;
        }
        function convertAttributeValue(node) {
            if ($7Ockm.types.isJSXExpressionContainer(node)) return node.expression;
            else return node;
        }
        function accumulateAttribute(array, attribute) {
            if ($7Ockm.types.isJSXSpreadAttribute(attribute.node)) {
                const arg = attribute.node.argument;
                if ($7Ockm.types.isObjectExpression(arg) && !$6ee3968088198c97$var$hasProto(arg)) array.push(...arg.properties);
                else array.push($7Ockm.types.spreadElement(arg));
                return array;
            }
            const value = convertAttributeValue(attribute.node.name.name !== "key" ? attribute.node.value || $7Ockm.types.booleanLiteral(true) : attribute.node.value);
            if (attribute.node.name.name === "key" && value === null) throw attribute.buildCodeFrameError('Please provide an explicit key value. Using "key" as a shorthand for "key={true}" is not allowed.');
            if ($7Ockm.types.isStringLiteral(value) && !$7Ockm.types.isJSXExpressionContainer(attribute.node.value)) {
                var _value$extra;
                value.value = value.value.replace(/\n\s+/g, " ");
                (_value$extra = value.extra) == null || delete _value$extra.raw;
            }
            if ($7Ockm.types.isJSXNamespacedName(attribute.node.name)) attribute.node.name = $7Ockm.types.stringLiteral(attribute.node.name.namespace.name + ":" + attribute.node.name.name.name);
            else if ($7Ockm.types.isValidIdentifier(attribute.node.name.name, false)) attribute.node.name.type = "Identifier";
            else attribute.node.name = $7Ockm.types.stringLiteral(attribute.node.name.name);
            array.push($7Ockm.types.inherits($7Ockm.types.objectProperty(attribute.node.name, value), attribute.node));
            return array;
        }
        function buildChildrenProperty(children) {
            let childrenNode;
            if (children.length === 1) childrenNode = children[0];
            else if (children.length > 1) childrenNode = $7Ockm.types.arrayExpression(children);
            else return undefined;
            return $7Ockm.types.objectProperty($7Ockm.types.identifier("children"), childrenNode);
        }
        function buildJSXElementCall(path, file) {
            const openingPath = path.get("openingElement");
            const args = [
                getTag(openingPath)
            ];
            const attribsArray = [];
            const extracted = Object.create(null);
            for (const attr of openingPath.get("attributes"))if (attr.isJSXAttribute() && $7Ockm.types.isJSXIdentifier(attr.node.name)) {
                const { name: name } = attr.node.name;
                switch(name){
                    case "__source":
                    case "__self":
                        if (extracted[name]) throw $6ee3968088198c97$var$sourceSelfError(path, name);
                    case "key":
                        {
                            const keyValue = convertAttributeValue(attr.node.value);
                            if (keyValue === null) throw attr.buildCodeFrameError('Please provide an explicit key value. Using "key" as a shorthand for "key={true}" is not allowed.');
                            extracted[name] = keyValue;
                            break;
                        }
                    default:
                        attribsArray.push(attr);
                }
            } else attribsArray.push(attr);
            const children = $7Ockm.types.react.buildChildren(path.node);
            let attribs;
            if (attribsArray.length || children.length) attribs = buildJSXOpeningElementAttributes(attribsArray, children);
            else attribs = $7Ockm.types.objectExpression([]);
            args.push(attribs);
            if (development) {
                var _extracted$key;
                args.push((_extracted$key = extracted.key) != null ? _extracted$key : path.scope.buildUndefinedNode(), $7Ockm.types.booleanLiteral(children.length > 1));
                if (extracted.__source) {
                    args.push(extracted.__source);
                    if (extracted.__self) args.push(extracted.__self);
                } else if (extracted.__self) args.push(path.scope.buildUndefinedNode(), extracted.__self);
            } else if (extracted.key !== undefined) args.push(extracted.key);
            return call(file, children.length > 1 ? "jsxs" : "jsx", args);
        }
        function buildJSXOpeningElementAttributes(attribs, children) {
            const props = attribs.reduce(accumulateAttribute, []);
            if ((children == null ? void 0 : children.length) > 0) props.push(buildChildrenProperty(children));
            return $7Ockm.types.objectExpression(props);
        }
        function buildJSXFragmentCall(path, file) {
            const args = [
                $6ee3968088198c97$var$get(file, "id/fragment")()
            ];
            const children = $7Ockm.types.react.buildChildren(path.node);
            args.push($7Ockm.types.objectExpression(children.length > 0 ? [
                buildChildrenProperty(children)
            ] : []));
            if (development) args.push(path.scope.buildUndefinedNode(), $7Ockm.types.booleanLiteral(children.length > 1));
            return call(file, children.length > 1 ? "jsxs" : "jsx", args);
        }
        function buildCreateElementFragmentCall(path, file) {
            if (filter && !filter(path.node, file)) return;
            return call(file, "createElement", [
                $6ee3968088198c97$var$get(file, "id/fragment")(),
                $7Ockm.types.nullLiteral(),
                ...$7Ockm.types.react.buildChildren(path.node)
            ]);
        }
        function buildCreateElementCall(path, file) {
            const openingPath = path.get("openingElement");
            return call(file, "createElement", [
                getTag(openingPath),
                buildCreateElementOpeningElementAttributes(file, path, openingPath.get("attributes")),
                ...$7Ockm.types.react.buildChildren(path.node)
            ]);
        }
        function getTag(openingPath) {
            const tagExpr = convertJSXIdentifier(openingPath.node.name, openingPath.node);
            let tagName;
            if ($7Ockm.types.isIdentifier(tagExpr)) tagName = tagExpr.name;
            else if ($7Ockm.types.isStringLiteral(tagExpr)) tagName = tagExpr.value;
            if ($7Ockm.types.react.isCompatTag(tagName)) return $7Ockm.types.stringLiteral(tagName);
            else return tagExpr;
        }
        function buildCreateElementOpeningElementAttributes(file, path, attribs) {
            const runtime = $6ee3968088198c97$var$get(file, "runtime");
            if (runtime !== "automatic") {
                const objs = [];
                const props = attribs.reduce(accumulateAttribute, []);
                if (!useSpread) {
                    let start = 0;
                    props.forEach((prop, i)=>{
                        if ($7Ockm.types.isSpreadElement(prop)) {
                            if (i > start) objs.push($7Ockm.types.objectExpression(props.slice(start, i)));
                            objs.push(prop.argument);
                            start = i + 1;
                        }
                    });
                    if (props.length > start) objs.push($7Ockm.types.objectExpression(props.slice(start)));
                } else if (props.length) objs.push($7Ockm.types.objectExpression(props));
                if (!objs.length) return $7Ockm.types.nullLiteral();
                if (objs.length === 1) {
                    if (!($7Ockm.types.isSpreadElement(props[0]) && $7Ockm.types.isObjectExpression(props[0].argument))) return objs[0];
                }
                if (!$7Ockm.types.isObjectExpression(objs[0])) objs.unshift($7Ockm.types.objectExpression([]));
                const helper = useBuiltIns ? $7Ockm.types.memberExpression($7Ockm.types.identifier("Object"), $7Ockm.types.identifier("assign")) : file.addHelper("extends");
                return $7Ockm.types.callExpression(helper, objs);
            }
            const props = [];
            const found = Object.create(null);
            for (const attr of attribs){
                const { node: node } = attr;
                const name = $7Ockm.types.isJSXAttribute(node) && $7Ockm.types.isJSXIdentifier(node.name) && node.name.name;
                if (runtime === "automatic" && (name === "__source" || name === "__self")) {
                    if (found[name]) throw $6ee3968088198c97$var$sourceSelfError(path, name);
                    found[name] = true;
                }
                accumulateAttribute(props, attr);
            }
            return props.length === 1 && $7Ockm.types.isSpreadElement(props[0]) && !$7Ockm.types.isObjectExpression(props[0].argument) ? props[0].argument : props.length > 0 ? $7Ockm.types.objectExpression(props) : $7Ockm.types.nullLiteral();
        }
    });
    function getSource(source, importName) {
        switch(importName){
            case "Fragment":
                return `${source}/${development ? "jsx-dev-runtime" : "jsx-runtime"}`;
            case "jsxDEV":
                return `${source}/jsx-dev-runtime`;
            case "jsx":
            case "jsxs":
                return `${source}/jsx-runtime`;
            case "createElement":
                return source;
        }
    }
    function createImportLazily(pass, path, importName, source) {
        return ()=>{
            const actualSource = getSource(source, importName);
            if ((0, $ePJIL.isModule)(path)) {
                let reference = $6ee3968088198c97$var$get(pass, `imports/${importName}`);
                if (reference) return $7Ockm.types.cloneNode(reference);
                reference = (0, $ePJIL.addNamed)(path, importName, actualSource, {
                    importedInterop: "uncompiled",
                    importPosition: "after"
                });
                $6ee3968088198c97$var$set(pass, `imports/${importName}`, reference);
                return reference;
            } else {
                let reference = $6ee3968088198c97$var$get(pass, `requires/${actualSource}`);
                if (reference) reference = $7Ockm.types.cloneNode(reference);
                else {
                    reference = (0, $ePJIL.addNamespace)(path, actualSource, {
                        importedInterop: "uncompiled"
                    });
                    $6ee3968088198c97$var$set(pass, `requires/${actualSource}`, reference);
                }
                return $7Ockm.types.memberExpression(reference, $7Ockm.types.identifier(importName));
            }
        };
    }
}
function $6ee3968088198c97$var$toMemberExpression(id) {
    return id.split(".").map((name)=>$7Ockm.types.identifier(name)).reduce((object, property)=>$7Ockm.types.memberExpression(object, property));
}
function $6ee3968088198c97$var$makeSource(path, state) {
    const location = path.node.loc;
    if (!location) return path.scope.buildUndefinedNode();
    if (!state.fileNameIdentifier) {
        const { filename: filename = "" } = state;
        const fileNameIdentifier = path.scope.generateUidIdentifier("_jsxFileName");
        path.scope.getProgramParent().push({
            id: fileNameIdentifier,
            init: $7Ockm.types.stringLiteral(filename)
        });
        state.fileNameIdentifier = fileNameIdentifier;
    }
    return $6ee3968088198c97$var$makeTrace($7Ockm.types.cloneNode(state.fileNameIdentifier), location.start.line, location.start.column);
}
function $6ee3968088198c97$var$makeTrace(fileNameIdentifier, lineNumber, column0Based) {
    const fileLineLiteral = lineNumber != null ? $7Ockm.types.numericLiteral(lineNumber) : $7Ockm.types.nullLiteral();
    const fileColumnLiteral = column0Based != null ? $7Ockm.types.numericLiteral(column0Based + 1) : $7Ockm.types.nullLiteral();
    return $7Ockm.template.expression.ast`{
    fileName: ${fileNameIdentifier},
    lineNumber: ${fileLineLiteral},
    columnNumber: ${fileColumnLiteral},
  }`;
}
function $6ee3968088198c97$var$sourceSelfError(path, name) {
    const pluginName = `transform-react-jsx-${name.slice(2)}`;
    return path.buildCodeFrameError(`Duplicate ${name} prop found. You are most likely using the deprecated ${pluginName} Babel plugin. Both __source and __self are automatically set when using the automatic runtime. Please remove transform-react-jsx-source and transform-react-jsx-self from your Babel config.`);
}


var $bd46ea0fdc2ab1a5$var$_default = $bd46ea0fdc2ab1a5$exports.default = (0, $6ee3968088198c97$exports.default)({
    name: "transform-react-jsx",
    development: false
});


var $031e7bd29590fe4d$exports = {};
"use strict";
Object.defineProperty($031e7bd29590fe4d$exports, "__esModule", {
    value: true
});
Object.defineProperty($031e7bd29590fe4d$exports, "default", {
    enumerable: true,
    get: function() {
        return $7f53814d7a6ae492$exports.default;
    }
});
var $7f53814d7a6ae492$exports = {};
"use strict";
Object.defineProperty($7f53814d7a6ae492$exports, "__esModule", {
    value: true
});
$7f53814d7a6ae492$exports.default = void 0;

var $7f53814d7a6ae492$var$_default = $7f53814d7a6ae492$exports.default = (0, $6ee3968088198c97$exports.default)({
    name: "transform-react-jsx/development",
    development: true
});




var $d20797bb3a65112f$exports = {};
"use strict";
Object.defineProperty($d20797bb3a65112f$exports, "__esModule", {
    value: true
});
$d20797bb3a65112f$exports.default = void 0;


var $59kwG = parcelRequire("59kwG");

var $7Ockm = parcelRequire("7Ockm");
var $d20797bb3a65112f$var$_default = $d20797bb3a65112f$exports.default = (0, $c75bf8fd9239ab48$exports.declare)((api)=>{
    api.assertVersion(7);
    function addDisplayName(id, call) {
        const props = call.arguments[0].properties;
        let safe = true;
        for(let i = 0; i < props.length; i++){
            const prop = props[i];
            if ($7Ockm.types.isSpreadElement(prop)) continue;
            const key = $7Ockm.types.toComputedKey(prop);
            if ($7Ockm.types.isStringLiteral(key, {
                value: "displayName"
            })) {
                safe = false;
                break;
            }
        }
        if (safe) props.unshift($7Ockm.types.objectProperty($7Ockm.types.identifier("displayName"), $7Ockm.types.stringLiteral(id)));
    }
    const isCreateClassCallExpression = $7Ockm.types.buildMatchMemberExpression("React.createClass");
    const isCreateClassAddon = (callee)=>$7Ockm.types.isIdentifier(callee, {
            name: "createReactClass"
        });
    function isCreateClass(node) {
        if (!node || !$7Ockm.types.isCallExpression(node)) return false;
        if (!isCreateClassCallExpression(node.callee) && !isCreateClassAddon(node.callee)) return false;
        const args = node.arguments;
        if (args.length !== 1) return false;
        const first = args[0];
        if (!$7Ockm.types.isObjectExpression(first)) return false;
        return true;
    }
    return {
        name: "transform-react-display-name",
        visitor: {
            ExportDefaultDeclaration ({ node: node }, state) {
                if (isCreateClass(node.declaration)) {
                    const filename = state.filename || "unknown";
                    let displayName = $59kwG.basename(filename, $59kwG.extname(filename));
                    if (displayName === "index") displayName = $59kwG.basename($59kwG.dirname(filename));
                    addDisplayName(displayName, node.declaration);
                }
            },
            CallExpression (path) {
                const { node: node } = path;
                if (!isCreateClass(node)) return;
                let id;
                path.find(function(path) {
                    if (path.isAssignmentExpression()) id = path.node.left;
                    else if (path.isObjectProperty()) id = path.node.key;
                    else if (path.isVariableDeclarator()) id = path.node.id;
                    else if (path.isStatement()) return true;
                    if (id) return true;
                });
                if (!id) return;
                if ($7Ockm.types.isMemberExpression(id)) id = id.property;
                if ($7Ockm.types.isIdentifier(id)) addDisplayName(id.name, node);
            }
        }
    };
});


var $23fed2cc48dffbfa$exports = {};
"use strict";
Object.defineProperty($23fed2cc48dffbfa$exports, "__esModule", {
    value: true
});
$23fed2cc48dffbfa$exports.default = void 0;



var $7Ockm = parcelRequire("7Ockm");
const $23fed2cc48dffbfa$var$PURE_CALLS = [
    [
        "react",
        new Set([
            "cloneElement",
            "createContext",
            "createElement",
            "createFactory",
            "createRef",
            "forwardRef",
            "isValidElement",
            "memo",
            "lazy"
        ])
    ],
    [
        "react-dom",
        new Set([
            "createPortal"
        ])
    ]
];
var $23fed2cc48dffbfa$var$_default = $23fed2cc48dffbfa$exports.default = (0, $c75bf8fd9239ab48$exports.declare)((api)=>{
    api.assertVersion(7);
    return {
        name: "transform-react-pure-annotations",
        visitor: {
            CallExpression (path) {
                if ($23fed2cc48dffbfa$var$isReactCall(path)) (0, $d41d12e27d93d183$exports.default)(path);
            }
        }
    };
});
function $23fed2cc48dffbfa$var$isReactCall(path) {
    const calleePath = path.get("callee");
    if (!calleePath.isMemberExpression()) {
        for (const [module, methods] of $23fed2cc48dffbfa$var$PURE_CALLS)for (const method of methods){
            if (calleePath.referencesImport(module, method)) return true;
        }
        return false;
    }
    const object = calleePath.get("object");
    const callee = calleePath.node;
    if (!callee.computed && $7Ockm.types.isIdentifier(callee.property)) {
        const propertyName = callee.property.name;
        for (const [module, methods] of $23fed2cc48dffbfa$var$PURE_CALLS){
            if (object.referencesImport(module, "default") || object.referencesImport(module, "*")) return methods.has(propertyName);
        }
    }
    return false;
}



var $lRd6h = parcelRequire("lRd6h");
function $ee632e633864f26f$var$_interopDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
var $ee632e633864f26f$var$transformReactJSX__default = /*#__PURE__*/ $ee632e633864f26f$var$_interopDefault($bd46ea0fdc2ab1a5$exports);
var $ee632e633864f26f$var$transformReactJSXDevelopment__default = /*#__PURE__*/ $ee632e633864f26f$var$_interopDefault($031e7bd29590fe4d$exports);
var $ee632e633864f26f$var$transformReactDisplayName__default = /*#__PURE__*/ $ee632e633864f26f$var$_interopDefault($d20797bb3a65112f$exports);
var $ee632e633864f26f$var$transformReactPure__default = /*#__PURE__*/ $ee632e633864f26f$var$_interopDefault($23fed2cc48dffbfa$exports);
new $lRd6h.OptionValidator("@babel/preset-react");
function $ee632e633864f26f$var$normalizeOptions(options = {}) {
    {
        let { pragma: pragma, pragmaFrag: pragmaFrag } = options;
        const { pure: pure, throwIfNamespace: throwIfNamespace = true, runtime: runtime = "classic", importSource: importSource, useBuiltIns: useBuiltIns, useSpread: useSpread } = options;
        if (runtime === "classic") {
            pragma = pragma || "React.createElement";
            pragmaFrag = pragmaFrag || "React.Fragment";
        }
        const development = !!options.development;
        return {
            development: development,
            importSource: importSource,
            pragma: pragma,
            pragmaFrag: pragmaFrag,
            pure: pure,
            runtime: runtime,
            throwIfNamespace: throwIfNamespace,
            useBuiltIns: useBuiltIns,
            useSpread: useSpread
        };
    }
}
var $ee632e633864f26f$var$index = $c75bf8fd9239ab48$exports.declarePreset((api, opts)=>{
    api.assertVersion(7);
    const { development: development, importSource: importSource, pragma: pragma, pragmaFrag: pragmaFrag, pure: pure, runtime: runtime, throwIfNamespace: throwIfNamespace } = $ee632e633864f26f$var$normalizeOptions(opts);
    return {
        plugins: [
            [
                development ? $ee632e633864f26f$var$transformReactJSXDevelopment__default.default : $ee632e633864f26f$var$transformReactJSX__default.default,
                {
                    importSource: importSource,
                    pragma: pragma,
                    pragmaFrag: pragmaFrag,
                    runtime: runtime,
                    throwIfNamespace: throwIfNamespace,
                    pure: pure,
                    useBuiltIns: !!opts.useBuiltIns,
                    useSpread: opts.useSpread
                }
            ],
            $ee632e633864f26f$var$transformReactDisplayName__default.default,
            pure !== false && $ee632e633864f26f$var$transformReactPure__default.default
        ].filter(Boolean)
    };
});
$ee632e633864f26f$exports.default = $ee632e633864f26f$var$index;



var $fuTml = parcelRequire("fuTml");

var $aHxeO = parcelRequire("aHxeO");

var $ardUq = parcelRequire("ardUq");

var $frkOe = parcelRequire("frkOe");

const $e26ee743ff8e9b71$export$781f96b776d12a10 = {
    plugins: [
        "jsx"
    ]
};
const $e26ee743ff8e9b71$export$d3e856abbe388fd9 = {
    presets: [
        (0, (/*@__PURE__*/$parcel$interopDefault($ee632e633864f26f$exports)))
    ]
};
const $e26ee743ff8e9b71$export$f18e6236bf501d35 = (sourcecode)=>$fuTml.parseExpression(sourcecode, {
        ...$e26ee743ff8e9b71$export$781f96b776d12a10,
        allowAwaitOutsideFunction: true
    });
const $e26ee743ff8e9b71$export$586db8feda877f8b = (programAst, code)=>$7Ockm.transformFromAstSync(programAst, code, $e26ee743ff8e9b71$export$d3e856abbe388fd9).code;
function $e26ee743ff8e9b71$export$72dfcd1a8a332feb(exprAst) {
    return $ardUq.program([
        $ardUq.returnStatement(exprAst)
    ]);
}
function $e26ee743ff8e9b71$export$c8cd61a56d6527d7(exprAst) {
    // I don't know how else to create a traversable file/program:
    const file = $fuTml.parse("");
    file.program.body.push($ardUq.expressionStatement(exprAst));
    return file;
}
const $e26ee743ff8e9b71$export$2994de6e55d9afad = (sourcecode)=>$e26ee743ff8e9b71$export$586db8feda877f8b($e26ee743ff8e9b71$export$72dfcd1a8a332feb($e26ee743ff8e9b71$export$f18e6236bf501d35(sourcecode)), sourcecode);
const $e26ee743ff8e9b71$export$cf73bddf32967675 = new Set([
    "abstract",
    "arguments",
    "await",
    "boolean",
    "break",
    "byte",
    "case",
    "catch",
    "char",
    "class",
    "const",
    "continue",
    "debugger",
    "default",
    "delete",
    "do",
    "double",
    "else",
    "enum",
    "eval",
    "export",
    "extends",
    "false",
    "final",
    "finally",
    "float",
    "for",
    "function",
    "goto",
    "if",
    "implements",
    "import",
    "in",
    "instanceof",
    "int",
    "interface",
    "let",
    "long",
    "native",
    "new",
    "null",
    "package",
    "private",
    "protected",
    "public",
    "return",
    "short",
    "static",
    "super",
    "switch",
    "synchronized",
    "this",
    "throw",
    "throws",
    "transient",
    "true",
    "try",
    "typeof",
    "var",
    "void",
    "volatile",
    "while",
    "with",
    "yield"
]);
function $e26ee743ff8e9b71$export$7b556d59e5af9774(name) {
    return name.match(/^[a-zA-Z_$][\w\$]*$/) && !$e26ee743ff8e9b71$export$cf73bddf32967675.has(name);
}
const $e26ee743ff8e9b71$export$42b2ceb4792e5d2b = {
    run () {},
    runUNSAFE () {},
    deps: new Set()
};
function $e26ee743ff8e9b71$export$e959469147b73464(exprAst, exprSource) {
    const deps = $e26ee743ff8e9b71$export$89bbee6221053207($e26ee743ff8e9b71$export$c8cd61a56d6527d7(exprAst));
    const args = Array.from(deps).filter($e26ee743ff8e9b71$export$7b556d59e5af9774);
    const programAst = $e26ee743ff8e9b71$export$72dfcd1a8a332feb(exprAst);
    const isAsync = $e26ee743ff8e9b71$export$997fc224f08e3d6($ardUq.file(programAst));
    const FuncConstructor = isAsync ? $e26ee743ff8e9b71$export$cb6ddc2b23bc63b2 : Function;
    const exprFunc = FuncConstructor(...args, $e26ee743ff8e9b71$export$586db8feda877f8b(programAst, exprSource));
    function runUNSAFE(env) {
        if (Array.from(deps).some((dependency)=>env[dependency] === (0, $e7500bbe9a1dee8a$export$f01a785a5ae81e49))) return 0, $e7500bbe9a1dee8a$export$f01a785a5ae81e49;
        function $([name]) {
            if (!(name in env)) throw new ReferenceError(`"${name}" is not defined`);
            return env[name];
        }
        return exprFunc(...args.map((name)=>$e26ee743ff8e9b71$export$6bc3a4a8c9d602ce(name, env, {
                $: $
            }, globalThis)));
    }
    function run(env) {
        try {
            return runUNSAFE(env);
        } catch (e) {
            return e;
        }
    }
    return {
        run: run,
        runUNSAFE: runUNSAFE,
        deps: deps
    };
}
function $e26ee743ff8e9b71$export$fbb86026bc177442(code) {
    if (code.trim() === "") return $e26ee743ff8e9b71$export$42b2ceb4792e5d2b;
    const ast = $e26ee743ff8e9b71$export$f18e6236bf501d35(code);
    return $e26ee743ff8e9b71$export$e959469147b73464(ast, code);
}
function $e26ee743ff8e9b71$export$c19cabcb7ba30452(code) {
    try {
        return $e26ee743ff8e9b71$export$fbb86026bc177442(code);
    } catch (e) {
        $e26ee743ff8e9b71$export$9e0f7ddfe8029a4c(e, code);
        return {
            run () {
                return e;
            },
            runUNSAFE () {
                throw e;
            },
            deps: new Set()
        };
    }
}
const $e26ee743ff8e9b71$export$946ba5975ff1c976 = (code, env)=>{
    return $e26ee743ff8e9b71$export$c19cabcb7ba30452(code).run(env);
};
const $e26ee743ff8e9b71$export$6f349f186c49a218 = (code, env)=>{
    return $e26ee743ff8e9b71$export$fbb86026bc177442(code).runUNSAFE(env);
};
function $e26ee743ff8e9b71$export$f616ad0a3559dfff(code) {
    if (!code?.trim()) return new Set();
    try {
        return $e26ee743ff8e9b71$export$89bbee6221053207($e26ee743ff8e9b71$export$c8cd61a56d6527d7($e26ee743ff8e9b71$export$f18e6236bf501d35(code)));
    } catch (e) {
        if (e instanceof SyntaxError) return new Set();
        else throw e;
    }
}
function $e26ee743ff8e9b71$export$46908aa9fab14968(sourcecode) {
    const parserOpts = {
        ...$e26ee743ff8e9b71$export$781f96b776d12a10,
        allowReturnOutsideFunction: true,
        allowAwaitOutsideFunction: true
    };
    return $fuTml.parse(sourcecode, parserOpts);
}
function $e26ee743ff8e9b71$export$64025573396b3640(sourcecode) {
    const ast = $e26ee743ff8e9b71$export$46908aa9fab14968(sourcecode);
    const statements = ast.program.body;
    const astWithReturn = $ardUq.program([
        ...statements.slice(0, -1),
        ...statements.slice(-1).map((stmt)=>{
            if ($ardUq.isExpressionStatement(stmt)) return $ardUq.returnStatement(stmt.expression);
            if ($ardUq.isFunctionDeclaration(stmt)) return $ardUq.returnStatement({
                ...stmt,
                type: "FunctionExpression"
            });
            return stmt;
        })
    ]);
    return {
        transformedCode: $7Ockm.transformFromAstSync(astWithReturn, sourcecode, $e26ee743ff8e9b71$export$d3e856abbe388fd9).code,
        isAsync: $e26ee743ff8e9b71$export$997fc224f08e3d6(ast),
        ast: ast
    };
}
function $e26ee743ff8e9b71$export$6bc3a4a8c9d602ce(name, ...envChain) {
    for (const env of envChain){
        if (name in env) return env[name];
    }
    throw new ReferenceError(name + " is not defined");
}
function $e26ee743ff8e9b71$export$e7f87faa5d06fe13(code) {
    if (code.trim() === "") return $e26ee743ff8e9b71$export$42b2ceb4792e5d2b;
    const { transformedCode: transformedCode, isAsync: isAsync, ast: ast } = $e26ee743ff8e9b71$export$64025573396b3640(code);
    const deps = $e26ee743ff8e9b71$export$89bbee6221053207(ast);
    const args = Array.from(deps).filter($e26ee743ff8e9b71$export$7b556d59e5af9774);
    const FuncConstructor = isAsync ? $e26ee743ff8e9b71$export$cb6ddc2b23bc63b2 : Function;
    const exprFunc = FuncConstructor(...args, transformedCode);
    function runUNSAFE(env) {
        if (Array.from(deps).some((dependency)=>env[dependency] === (0, $e7500bbe9a1dee8a$export$f01a785a5ae81e49))) return 0, $e7500bbe9a1dee8a$export$f01a785a5ae81e49;
        function $([name]) {
            if (!(name in env)) throw new ReferenceError(`"${name}" is not defined`);
            return env[name];
        }
        return exprFunc(...args.map((name)=>$e26ee743ff8e9b71$export$6bc3a4a8c9d602ce(name, env, {
                $: $
            }, globalThis)));
    }
    function run(env) {
        try {
            return runUNSAFE(env);
        } catch (e) {
            return e;
        }
    }
    return {
        run: run,
        runUNSAFE: runUNSAFE,
        deps: deps
    };
}
function $e26ee743ff8e9b71$export$4495ab609416a46b(code) {
    try {
        return $e26ee743ff8e9b71$export$e7f87faa5d06fe13(code);
    } catch (e) {
        $e26ee743ff8e9b71$export$9e0f7ddfe8029a4c(e, code);
        return {
            run () {
                return e;
            },
            runUNSAFE () {
                throw e;
            },
            deps: new Set()
        };
    }
}
function $e26ee743ff8e9b71$export$e696a2a6bb377f32(code, env) {
    return $e26ee743ff8e9b71$export$4495ab609416a46b(code).run(env);
}
function $e26ee743ff8e9b71$export$38cd3a282912ac5(code) {
    if (!code?.trim()) return new Set();
    try {
        return $e26ee743ff8e9b71$export$89bbee6221053207($e26ee743ff8e9b71$export$46908aa9fab14968(code));
    } catch (e) {
        if (e instanceof SyntaxError) return new Set();
        else throw e;
    }
}
function $e26ee743ff8e9b71$export$997fc224f08e3d6(ast) {
    let hasToplevelAwait = false;
    (0, (/*@__PURE__*/$parcel$interopDefault($aHxeO)))(ast, {
        AwaitExpression (path) {
            const isInFunction = path.findParent((path)=>path.isFunction());
            if (!isInFunction) hasToplevelAwait = true;
        }
    });
    return hasToplevelAwait;
}
function $e26ee743ff8e9b71$export$89bbee6221053207(ast) {
    const freeVars = new Set([
        "React"
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($aHxeO)))(ast, {
        ReferencedIdentifier (path) {
            // Collect references like $`name with spaces`
            const parent = path.getAncestry()[1];
            if (path.node.name === "$" && parent && parent.isTaggedTemplateExpression() && parent.node.quasi.quasis.length === 1) freeVars.add(parent.node.quasi.quasis[0].value.raw);
            const identifier = path.node.name;
            if (!path.scope || !path.scope.hasBinding(identifier, true)) freeVars.add(identifier);
        }
    });
    return freeVars;
}
function $e26ee743ff8e9b71$export$9e0f7ddfe8029a4c(e, source) {
    if (e instanceof SyntaxError && e.loc !== undefined) e.frame = (0, $frkOe.codeFrameColumns)(source, {
        start: e.loc
    }, {});
}
const $e26ee743ff8e9b71$export$cb6ddc2b23bc63b2 = (async function() {}).constructor;



function $ea2d507bce2bc457$export$2cd8252107eb640b(expr = "", innerBlock) {
    return {
        expr: expr,
        mode: innerBlock ? "run" : "choose",
        innerBlock: (0, $b8f588c17e3c1433$export$e255fd3f9a510304)(innerBlock),
        innerBlockState: innerBlock?.init
    };
}
function $ea2d507bce2bc457$export$9a4d0b419ab59138(expr, state, blockEnv) {
    const blockCmdResult = (0, $e26ee743ff8e9b71$export$946ba5975ff1c976)(expr, blockEnv);
    if ($6f23581c0aef6dc2$export$de5a9e42c1dff8da(blockCmdResult)) return {
        ...state,
        expr: expr,
        mode: "run",
        innerBlock: (0, $b8f588c17e3c1433$export$e255fd3f9a510304)(blockCmdResult),
        innerBlockState: blockCmdResult.init
    };
    return state;
}
function $ea2d507bce2bc457$export$7dfc2a84d82d8ac7(dispatch) {
    return function dispatchBlock(action) {
        dispatch((state, context)=>{
            if (state.mode === "loading") return {
                state: state
            };
            const result = action(state.innerBlockState, context);
            return {
                state: {
                    ...state,
                    innerBlockState: result.state
                },
                description: result.description
            };
        });
    };
}
function $ea2d507bce2bc457$export$1f297d8d0ce29e3(state, dispatch, env, changedVars, blockLibrary) {
    const dispatchBlock = $ea2d507bce2bc457$export$7dfc2a84d82d8ac7(dispatch);
    const innerBlock = (0, $e26ee743ff8e9b71$export$946ba5975ff1c976)(state.expr, {
        ...blockLibrary,
        ...env
    });
    if (!$6f23581c0aef6dc2$export$de5a9e42c1dff8da(innerBlock)) return {
        state: state,
        invalidated: false
    };
    const safeInnerBlock = (0, $b8f588c17e3c1433$export$e255fd3f9a510304)(innerBlock);
    if (state.mode === "loading") return {
        state: {
            mode: state.modeAfter,
            expr: state.expr,
            innerBlock: safeInnerBlock,
            innerBlockState: safeInnerBlock.fromJSON(state.jsonToLoad, dispatchBlock, env)
        },
        invalidated: true
    };
    const { state: innerBlockState, invalidated: invalidated } = safeInnerBlock.recompute(state.innerBlockState, dispatchBlock, env, changedVars);
    return {
        state: {
            ...state,
            innerBlock: safeInnerBlock,
            innerBlockState: innerBlockState
        },
        invalidated: invalidated
    };
}




var $acw62 = parcelRequire("acw62");




var $5bd921a18e0690d7$exports = {};

$parcel$export($5bd921a18e0690d7$exports, "useCompletionsOverlay", () => $5bd921a18e0690d7$export$f478f6dc019df8a3);
$parcel$export($5bd921a18e0690d7$exports, "Completions", () => $5bd921a18e0690d7$export$2e5f1dd1efbe8ec5);
$parcel$export($5bd921a18e0690d7$exports, "EXCLUDED_PROTOTYPE_COMPLETIONS", () => $5bd921a18e0690d7$export$2eba122af18d1e96);
$parcel$export($5bd921a18e0690d7$exports, "propertyCompletions", () => $5bd921a18e0690d7$export$6ee1db3f87608989);
$parcel$export($5bd921a18e0690d7$exports, "getCompletionValue", () => $5bd921a18e0690d7$export$7e635f9b118b79b8);
$parcel$export($5bd921a18e0690d7$exports, "RenderCompletions", () => $5bd921a18e0690d7$export$2a2f9e00e6197911);


var $acw62 = parcelRequire("acw62");
var $37edcfa19f505e9c$exports = {};

$parcel$export($37edcfa19f505e9c$exports, "Tab", () => $37edcfa19f505e9c$export$3e41faf802a29e71);

var $acw62 = parcelRequire("acw62");








var $acw62 = parcelRequire("acw62");


let $eac0d614a77ee96b$var$p = "div";
var $eac0d614a77ee96b$export$617d79dae526d2cf = ((e)=>(e[e.None = 1] = "None", e[e.Focusable = 2] = "Focusable", e[e.Hidden = 4] = "Hidden", e))($eac0d614a77ee96b$export$617d79dae526d2cf || {});
function $eac0d614a77ee96b$var$l(d, o) {
    var n;
    let { features: t = 1, ...e } = d, r = {
        ref: o,
        "aria-hidden": (t & 2) === 2 ? !0 : (n = e["aria-hidden"]) != null ? n : void 0,
        style: {
            position: "fixed",
            top: 1,
            left: 1,
            width: 1,
            height: 0,
            padding: 0,
            margin: -1,
            overflow: "hidden",
            clip: "rect(0, 0, 0, 0)",
            whiteSpace: "nowrap",
            borderWidth: "0",
            ...(t & 4) === 4 && (t & 2) !== 2 && {
                display: "none"
            }
        }
    };
    return (0, $a54bdd13402af126$export$b3890eb0ae9dca99)({
        ourProps: r,
        theirProps: e,
        slot: {},
        defaultTag: $eac0d614a77ee96b$var$p,
        name: "Hidden"
    });
}
let $eac0d614a77ee96b$export$8dc98ba7eadeaa56 = (0, $a54bdd13402af126$export$e43f39796049410c)($eac0d614a77ee96b$var$l);


function $a9f43bcfca9020dc$export$d700fc5421f49f8f({ onFocus: n }) {
    let [r, o] = (0, $acw62.useState)(!0), u = (0, $854f77de70ff8db2$export$80c2a3957bcb42ea)();
    return r ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $eac0d614a77ee96b$export$8dc98ba7eadeaa56), {
        as: "button",
        type: "button",
        features: (0, $eac0d614a77ee96b$export$617d79dae526d2cf).Focusable,
        onFocus: (a)=>{
            a.preventDefault();
            let e, i = 50;
            function t() {
                if (i-- <= 0) {
                    e && cancelAnimationFrame(e);
                    return;
                }
                if (n()) {
                    if (cancelAnimationFrame(e), !u.current) return;
                    o(!1);
                    return;
                }
                e = requestAnimationFrame(t);
            }
            e = requestAnimationFrame(t);
        }
    }) : null;
}









var $acw62 = parcelRequire("acw62");
const $876ad9602ce347d8$var$s = $acw62.createContext(null);
function $876ad9602ce347d8$var$a() {
    return {
        groups: new Map,
        get (n, t) {
            var c;
            let e = this.groups.get(n);
            e || (e = new Map, this.groups.set(n, e));
            let l = (c = e.get(t)) != null ? c : 0;
            e.set(t, l + 1);
            let o = Array.from(e.keys()).indexOf(t);
            function i() {
                let u = e.get(t);
                u > 1 ? e.set(t, u - 1) : e.delete(t);
            }
            return [
                o,
                i
            ];
        }
    };
}
function $876ad9602ce347d8$export$a9f7b2abf715ece3({ children: n }) {
    let t = $acw62.useRef($876ad9602ce347d8$var$a());
    return $acw62.createElement($876ad9602ce347d8$var$s.Provider, {
        value: t
    }, n);
}
function $876ad9602ce347d8$export$4fba99d3e9fca1f0(n) {
    let t = $acw62.useContext($876ad9602ce347d8$var$s);
    if (!t) throw new Error("You must wrap your component in a <StableCollection>");
    let e = $876ad9602ce347d8$var$f(), [l, o] = t.current.get(n, e);
    return $acw62.useEffect(()=>o, []), l;
}
function $876ad9602ce347d8$var$f() {
    var l, o, i;
    let n = (i = (o = (l = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) == null ? void 0 : l.ReactCurrentOwner) == null ? void 0 : o.current) != null ? i : null;
    if (!n) return Symbol();
    let t = [], e = n;
    for(; e;)t.push(e.index), e = e.return;
    return "$." + t.join(".");
}


var $37edcfa19f505e9c$var$ue = ((t)=>(t[t.Forwards = 0] = "Forwards", t[t.Backwards = 1] = "Backwards", t))($37edcfa19f505e9c$var$ue || {}), $37edcfa19f505e9c$var$Te = ((o)=>(o[o.Less = -1] = "Less", o[o.Equal = 0] = "Equal", o[o.Greater = 1] = "Greater", o))($37edcfa19f505e9c$var$Te || {}), $37edcfa19f505e9c$var$de = ((r)=>(r[r.SetSelectedIndex = 0] = "SetSelectedIndex", r[r.RegisterTab = 1] = "RegisterTab", r[r.UnregisterTab = 2] = "UnregisterTab", r[r.RegisterPanel = 3] = "RegisterPanel", r[r.UnregisterPanel = 4] = "UnregisterPanel", r))($37edcfa19f505e9c$var$de || {});
let $37edcfa19f505e9c$var$ce = {
    [0] (e, n) {
        var u;
        let t = (0, $cb6dceb64e6c0606$export$20305e96f91bf103)(e.tabs, (T)=>T.current), o = (0, $cb6dceb64e6c0606$export$20305e96f91bf103)(e.panels, (T)=>T.current), s = t.filter((T)=>{
            var l;
            return !((l = T.current) != null && l.hasAttribute("disabled"));
        }), r = {
            ...e,
            tabs: t,
            panels: o
        };
        if (n.index < 0 || n.index > t.length - 1) {
            let T = (0, $4f240e1aafd2c298$export$4659b591c19bdf3d)(Math.sign(n.index - e.selectedIndex), {
                [-1]: ()=>1,
                [0]: ()=>(0, $4f240e1aafd2c298$export$4659b591c19bdf3d)(Math.sign(n.index), {
                        [-1]: ()=>0,
                        [0]: ()=>0,
                        [1]: ()=>1
                    }),
                [1]: ()=>0
            });
            if (s.length === 0) return r;
            let l = (0, $4f240e1aafd2c298$export$4659b591c19bdf3d)(T, {
                [0]: ()=>t.indexOf(s[0]),
                [1]: ()=>t.indexOf(s[s.length - 1])
            });
            return {
                ...r,
                selectedIndex: l === -1 ? e.selectedIndex : l
            };
        }
        let i = t.slice(0, n.index), b = [
            ...t.slice(n.index),
            ...i
        ].find((T)=>s.includes(T));
        if (!b) return r;
        let c = (u = t.indexOf(b)) != null ? u : e.selectedIndex;
        return c === -1 && (c = e.selectedIndex), {
            ...r,
            selectedIndex: c
        };
    },
    [1] (e, n) {
        var r;
        if (e.tabs.includes(n.tab)) return e;
        let t = e.tabs[e.selectedIndex], o = (0, $cb6dceb64e6c0606$export$20305e96f91bf103)([
            ...e.tabs,
            n.tab
        ], (i)=>i.current), s = (r = o.indexOf(t)) != null ? r : e.selectedIndex;
        return s === -1 && (s = e.selectedIndex), {
            ...e,
            tabs: o,
            selectedIndex: s
        };
    },
    [2] (e, n) {
        return {
            ...e,
            tabs: e.tabs.filter((t)=>t !== n.tab)
        };
    },
    [3] (e, n) {
        return e.panels.includes(n.panel) ? e : {
            ...e,
            panels: (0, $cb6dceb64e6c0606$export$20305e96f91bf103)([
                ...e.panels,
                n.panel
            ], (t)=>t.current)
        };
    },
    [4] (e, n) {
        return {
            ...e,
            panels: e.panels.filter((t)=>t !== n.panel)
        };
    }
}, $37edcfa19f505e9c$var$X = (0, $acw62.createContext)(null);
$37edcfa19f505e9c$var$X.displayName = "TabsDataContext";
function $37edcfa19f505e9c$var$h(e) {
    let n = (0, $acw62.useContext)($37edcfa19f505e9c$var$X);
    if (n === null) {
        let t = new Error(`<${e} /> is missing a parent <Tab.Group /> component.`);
        throw Error.captureStackTrace && Error.captureStackTrace(t, $37edcfa19f505e9c$var$h), t;
    }
    return n;
}
let $37edcfa19f505e9c$var$$ = (0, $acw62.createContext)(null);
$37edcfa19f505e9c$var$$.displayName = "TabsActionsContext";
function $37edcfa19f505e9c$var$q(e) {
    let n = (0, $acw62.useContext)($37edcfa19f505e9c$var$$);
    if (n === null) {
        let t = new Error(`<${e} /> is missing a parent <Tab.Group /> component.`);
        throw Error.captureStackTrace && Error.captureStackTrace(t, $37edcfa19f505e9c$var$q), t;
    }
    return n;
}
function $37edcfa19f505e9c$var$fe(e, n) {
    return (0, $4f240e1aafd2c298$export$4659b591c19bdf3d)(n.type, $37edcfa19f505e9c$var$ce, e, n);
}
let $37edcfa19f505e9c$var$be = (0, $acw62.Fragment);
function $37edcfa19f505e9c$var$me(e, n) {
    let { defaultIndex: t = 0, vertical: o = !1, manual: s = !1, onChange: r, selectedIndex: i = null, ...R } = e;
    const b = o ? "vertical" : "horizontal", c = s ? "manual" : "auto";
    let u = i !== null, T = (0, $4a1854c6a3ad5196$export$f6a25a78204acc7e)(n), [l, d] = (0, $acw62.useReducer)($37edcfa19f505e9c$var$fe, {
        selectedIndex: i != null ? i : t,
        tabs: [],
        panels: []
    }), x = (0, $acw62.useMemo)(()=>({
            selectedIndex: l.selectedIndex
        }), [
        l.selectedIndex
    ]), m = (0, $fa1923261638cacc$export$86c4283a11f23f95)(r || (()=>{})), g = (0, $fa1923261638cacc$export$86c4283a11f23f95)(l.tabs), E = (0, $acw62.useMemo)(()=>({
            orientation: b,
            activation: c,
            ...l
        }), [
        b,
        c,
        l
    ]), S = (0, $0bd9972698c32399$export$90fc3a17d93f704c)((p)=>(d({
            type: 1,
            tab: p
        }), ()=>d({
                type: 2,
                tab: p
            }))), A = (0, $0bd9972698c32399$export$90fc3a17d93f704c)((p)=>(d({
            type: 3,
            panel: p
        }), ()=>d({
                type: 4,
                panel: p
            }))), L = (0, $0bd9972698c32399$export$90fc3a17d93f704c)((p)=>{
        M.current !== p && m.current(p), u || d({
            type: 0,
            index: p
        });
    }), M = (0, $fa1923261638cacc$export$86c4283a11f23f95)(u ? e.selectedIndex : l.selectedIndex), N = (0, $acw62.useMemo)(()=>({
            registerTab: S,
            registerPanel: A,
            change: L
        }), []);
    (0, $65df95ec9b1bb6a8$export$ce5ed857c741fd71)(()=>{
        d({
            type: 0,
            index: i != null ? i : t
        });
    }, [
        i
    ]), (0, $65df95ec9b1bb6a8$export$ce5ed857c741fd71)(()=>{
        if (M.current === void 0 || l.tabs.length <= 0) return;
        let p = (0, $cb6dceb64e6c0606$export$20305e96f91bf103)(l.tabs, (a)=>a.current);
        p.some((a, f)=>l.tabs[f] !== a) && L(p.indexOf(l.tabs[M.current]));
    });
    let B = {
        ref: T
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $876ad9602ce347d8$export$a9f7b2abf715ece3), null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($37edcfa19f505e9c$var$$.Provider, {
        value: N
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($37edcfa19f505e9c$var$X.Provider, {
        value: E
    }, E.tabs.length <= 0 && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a9f43bcfca9020dc$export$d700fc5421f49f8f), {
        onFocus: ()=>{
            var p, I;
            for (let a of g.current)if (((p = a.current) == null ? void 0 : p.tabIndex) === 0) return (I = a.current) == null || I.focus(), !0;
            return !1;
        }
    }), (0, $a54bdd13402af126$export$b3890eb0ae9dca99)({
        ourProps: B,
        theirProps: R,
        slot: x,
        defaultTag: $37edcfa19f505e9c$var$be,
        name: "Tabs"
    }))));
}
let $37edcfa19f505e9c$var$Pe = "div";
function $37edcfa19f505e9c$var$ye(e, n) {
    let { orientation: t, selectedIndex: o } = $37edcfa19f505e9c$var$h("Tab.List"), s = (0, $4a1854c6a3ad5196$export$f6a25a78204acc7e)(n);
    return (0, $a54bdd13402af126$export$b3890eb0ae9dca99)({
        ourProps: {
            ref: s,
            role: "tablist",
            "aria-orientation": t
        },
        theirProps: e,
        slot: {
            selectedIndex: o
        },
        defaultTag: $37edcfa19f505e9c$var$Pe,
        name: "Tabs.List"
    });
}
let $37edcfa19f505e9c$var$xe = "button";
function $37edcfa19f505e9c$var$ge(e, n) {
    var p, I;
    let t = (0, $f2a0dea4caee12c6$export$f680877a34711e37)(), { id: o = `headlessui-tabs-tab-${t}`, ...s } = e, { orientation: r, activation: i, selectedIndex: R, tabs: b, panels: c } = $37edcfa19f505e9c$var$h("Tab"), u = $37edcfa19f505e9c$var$q("Tab"), T = $37edcfa19f505e9c$var$h("Tab"), l = (0, $acw62.useRef)(null), d = (0, $4a1854c6a3ad5196$export$f6a25a78204acc7e)(l, n);
    (0, $65df95ec9b1bb6a8$export$ce5ed857c741fd71)(()=>u.registerTab(l), [
        u,
        l
    ]);
    let x = (0, $876ad9602ce347d8$export$4fba99d3e9fca1f0)("tabs"), m = b.indexOf(l);
    m === -1 && (m = x);
    let g = m === R, E = (0, $0bd9972698c32399$export$90fc3a17d93f704c)((a)=>{
        var j;
        let f = a();
        if (f === (0, $cb6dceb64e6c0606$export$abf286375dfa6dbd).Success && i === "auto") {
            let W = (j = (0, $c0a913ecfa4bf5e5$export$b204af158042fbac)(l)) == null ? void 0 : j.activeElement, z = T.tabs.findIndex((te)=>te.current === W);
            z !== -1 && u.change(z);
        }
        return f;
    }), S = (0, $0bd9972698c32399$export$90fc3a17d93f704c)((a)=>{
        let f = b.map((W)=>W.current).filter(Boolean);
        if (a.key === (0, $4cca0dbc68b0507a$export$4b0075e5ea5e1f26).Space || a.key === (0, $4cca0dbc68b0507a$export$4b0075e5ea5e1f26).Enter) {
            a.preventDefault(), a.stopPropagation(), u.change(m);
            return;
        }
        switch(a.key){
            case (0, $4cca0dbc68b0507a$export$4b0075e5ea5e1f26).Home:
            case (0, $4cca0dbc68b0507a$export$4b0075e5ea5e1f26).PageUp:
                return a.preventDefault(), a.stopPropagation(), E(()=>(0, $cb6dceb64e6c0606$export$82e1f4f412218a1d)(f, (0, $cb6dceb64e6c0606$export$807a7eae502106e7).First));
            case (0, $4cca0dbc68b0507a$export$4b0075e5ea5e1f26).End:
            case (0, $4cca0dbc68b0507a$export$4b0075e5ea5e1f26).PageDown:
                return a.preventDefault(), a.stopPropagation(), E(()=>(0, $cb6dceb64e6c0606$export$82e1f4f412218a1d)(f, (0, $cb6dceb64e6c0606$export$807a7eae502106e7).Last));
        }
        if (E(()=>(0, $4f240e1aafd2c298$export$4659b591c19bdf3d)(r, {
                vertical () {
                    return a.key === (0, $4cca0dbc68b0507a$export$4b0075e5ea5e1f26).ArrowUp ? (0, $cb6dceb64e6c0606$export$82e1f4f412218a1d)(f, (0, $cb6dceb64e6c0606$export$807a7eae502106e7).Previous | (0, $cb6dceb64e6c0606$export$807a7eae502106e7).WrapAround) : a.key === (0, $4cca0dbc68b0507a$export$4b0075e5ea5e1f26).ArrowDown ? (0, $cb6dceb64e6c0606$export$82e1f4f412218a1d)(f, (0, $cb6dceb64e6c0606$export$807a7eae502106e7).Next | (0, $cb6dceb64e6c0606$export$807a7eae502106e7).WrapAround) : (0, $cb6dceb64e6c0606$export$abf286375dfa6dbd).Error;
                },
                horizontal () {
                    return a.key === (0, $4cca0dbc68b0507a$export$4b0075e5ea5e1f26).ArrowLeft ? (0, $cb6dceb64e6c0606$export$82e1f4f412218a1d)(f, (0, $cb6dceb64e6c0606$export$807a7eae502106e7).Previous | (0, $cb6dceb64e6c0606$export$807a7eae502106e7).WrapAround) : a.key === (0, $4cca0dbc68b0507a$export$4b0075e5ea5e1f26).ArrowRight ? (0, $cb6dceb64e6c0606$export$82e1f4f412218a1d)(f, (0, $cb6dceb64e6c0606$export$807a7eae502106e7).Next | (0, $cb6dceb64e6c0606$export$807a7eae502106e7).WrapAround) : (0, $cb6dceb64e6c0606$export$abf286375dfa6dbd).Error;
                }
            })) === (0, $cb6dceb64e6c0606$export$abf286375dfa6dbd).Success) return a.preventDefault();
    }), A = (0, $acw62.useRef)(!1), L = (0, $0bd9972698c32399$export$90fc3a17d93f704c)(()=>{
        var a;
        A.current || (A.current = !0, (a = l.current) == null || a.focus({
            preventScroll: !0
        }), u.change(m), (0, $aba927e9b3929756$export$a5ff0d6a738703ca)(()=>{
            A.current = !1;
        }));
    }), M = (0, $0bd9972698c32399$export$90fc3a17d93f704c)((a)=>{
        a.preventDefault();
    }), N = (0, $acw62.useMemo)(()=>({
            selected: g
        }), [
        g
    ]), B = {
        ref: d,
        onKeyDown: S,
        onMouseDown: M,
        onClick: L,
        id: o,
        role: "tab",
        type: (0, $be828d8bf9bb25ca$export$53652b2b272efe9c)(e, l),
        "aria-controls": (I = (p = c[m]) == null ? void 0 : p.current) == null ? void 0 : I.id,
        "aria-selected": g,
        tabIndex: g ? 0 : -1
    };
    return (0, $a54bdd13402af126$export$b3890eb0ae9dca99)({
        ourProps: B,
        theirProps: s,
        slot: N,
        defaultTag: $37edcfa19f505e9c$var$xe,
        name: "Tabs.Tab"
    });
}
let $37edcfa19f505e9c$var$Ee = "div";
function $37edcfa19f505e9c$var$Ae(e, n) {
    let { selectedIndex: t } = $37edcfa19f505e9c$var$h("Tab.Panels"), o = (0, $4a1854c6a3ad5196$export$f6a25a78204acc7e)(n), s = (0, $acw62.useMemo)(()=>({
            selectedIndex: t
        }), [
        t
    ]);
    return (0, $a54bdd13402af126$export$b3890eb0ae9dca99)({
        ourProps: {
            ref: o
        },
        theirProps: e,
        slot: s,
        defaultTag: $37edcfa19f505e9c$var$Ee,
        name: "Tabs.Panels"
    });
}
let $37edcfa19f505e9c$var$Re = "div", $37edcfa19f505e9c$var$Le = (0, $a54bdd13402af126$export$617d79dae526d2cf).RenderStrategy | (0, $a54bdd13402af126$export$617d79dae526d2cf).Static;
function $37edcfa19f505e9c$var$_e(e, n) {
    var E, S, A, L;
    let t = (0, $f2a0dea4caee12c6$export$f680877a34711e37)(), { id: o = `headlessui-tabs-panel-${t}`, tabIndex: s = 0, ...r } = e, { selectedIndex: i, tabs: R, panels: b } = $37edcfa19f505e9c$var$h("Tab.Panel"), c = $37edcfa19f505e9c$var$q("Tab.Panel"), u = (0, $acw62.useRef)(null), T = (0, $4a1854c6a3ad5196$export$f6a25a78204acc7e)(u, n);
    (0, $65df95ec9b1bb6a8$export$ce5ed857c741fd71)(()=>c.registerPanel(u), [
        c,
        u
    ]);
    let l = (0, $876ad9602ce347d8$export$4fba99d3e9fca1f0)("panels"), d = b.indexOf(u);
    d === -1 && (d = l);
    let x = d === i, m = (0, $acw62.useMemo)(()=>({
            selected: x
        }), [
        x
    ]), g = {
        ref: T,
        id: o,
        role: "tabpanel",
        "aria-labelledby": (S = (E = R[d]) == null ? void 0 : E.current) == null ? void 0 : S.id,
        tabIndex: x ? s : -1
    };
    return !x && ((A = r.unmount) == null || A) && !((L = r.static) != null && L) ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $eac0d614a77ee96b$export$8dc98ba7eadeaa56), {
        as: "span",
        "aria-hidden": "true",
        ...g
    }) : (0, $a54bdd13402af126$export$b3890eb0ae9dca99)({
        ourProps: g,
        theirProps: r,
        slot: m,
        defaultTag: $37edcfa19f505e9c$var$Re,
        features: $37edcfa19f505e9c$var$Le,
        visible: x,
        name: "Tabs.Panel"
    });
}
let $37edcfa19f505e9c$var$Se = (0, $a54bdd13402af126$export$e43f39796049410c)($37edcfa19f505e9c$var$ge), $37edcfa19f505e9c$var$Ie = (0, $a54bdd13402af126$export$e43f39796049410c)($37edcfa19f505e9c$var$me), $37edcfa19f505e9c$var$De = (0, $a54bdd13402af126$export$e43f39796049410c)($37edcfa19f505e9c$var$ye), $37edcfa19f505e9c$var$Fe = (0, $a54bdd13402af126$export$e43f39796049410c)($37edcfa19f505e9c$var$Ae), $37edcfa19f505e9c$var$he = (0, $a54bdd13402af126$export$e43f39796049410c)($37edcfa19f505e9c$var$_e), $37edcfa19f505e9c$export$3e41faf802a29e71 = Object.assign($37edcfa19f505e9c$var$Se, {
    Group: $37edcfa19f505e9c$var$Ie,
    List: $37edcfa19f505e9c$var$De,
    Panels: $37edcfa19f505e9c$var$Fe,
    Panel: $37edcfa19f505e9c$var$he
});




var $acw62 = parcelRequire("acw62");

"use client";
const $f7c9e5140289c67f$var$h = Math.min, $f7c9e5140289c67f$var$u = Math.max, $f7c9e5140289c67f$var$f = Math.abs, $f7c9e5140289c67f$var$d = Object.values, $f7c9e5140289c67f$var$_ = Array.isArray, $f7c9e5140289c67f$var$g = setTimeout, $f7c9e5140289c67f$var$p = (e, t, n)=>$f7c9e5140289c67f$var$h(n, $f7c9e5140289c67f$var$u(t, e)), $f7c9e5140289c67f$var$v = (e)=>null != e, $f7c9e5140289c67f$var$m = "function" == typeof queueMicrotask ? queueMicrotask : (e)=>{
    Promise.resolve().then(e);
}, $f7c9e5140289c67f$var$w = (e)=>{
    let t, n;
    return (...r)=>(t || (t = !0, n = e(...r)), n);
}, $f7c9e5140289c67f$var$S = -1, $f7c9e5140289c67f$var$b = (e, t, n)=>{
    const r = n ? "unshift" : "push";
    for(let n = 0; n < t; n++)e[r]($f7c9e5140289c67f$var$S);
    return e;
}, $f7c9e5140289c67f$var$y = (e, t)=>{
    const n = e.t[t];
    return n === $f7c9e5140289c67f$var$S ? e.o : n;
}, $f7c9e5140289c67f$var$z = (e, t)=>{
    if (!e.i) return 0;
    if (e.l >= t) return e.h[t];
    e.l < 0 && (e.h[0] = 0, e.l = 0);
    let n = e.l, r = e.h[n];
    for(; n < t;)r += $f7c9e5140289c67f$var$y(e, n), e.h[++n] = r;
    return e.l = t, r;
}, $f7c9e5140289c67f$var$x = (e, t, n)=>{
    let r = $f7c9e5140289c67f$var$z(e, n);
    for(; n >= 0 && n < e.i;)if (r <= t) {
        const o = $f7c9e5140289c67f$var$y(e, n);
        if (r + o > t) break;
        r += o, n++;
    } else r -= $f7c9e5140289c67f$var$y(e, --n);
    return $f7c9e5140289c67f$var$p(n, 0, e.i - 1);
}, $f7c9e5140289c67f$var$I = (e, t, n, r)=>{
    const o = $f7c9e5140289c67f$var$x(e, t, $f7c9e5140289c67f$var$h(n, e.i - 1));
    return [
        o,
        $f7c9e5140289c67f$var$x(e, t + r, o)
    ];
}, $f7c9e5140289c67f$var$R = (e, t, n)=>{
    const r = t - e.i, o = r > 0;
    let i;
    return o ? (i = e.o * r, $f7c9e5140289c67f$var$b(e.t, r, n), $f7c9e5140289c67f$var$b(e.h, r)) : (i = (n ? e.t.splice(0, -r) : e.t.splice(r)).reduce((t, n)=>t + (n === $f7c9e5140289c67f$var$S ? e.o : n), 0), e.h.splice(r)), e.l = n ? -1 : $f7c9e5140289c67f$var$h(t - 1, e.l), e.i = t, [
        i,
        o
    ];
}, $f7c9e5140289c67f$var$k = "undefined" != typeof window, $f7c9e5140289c67f$var$C = ()=>document.documentElement, $f7c9e5140289c67f$var$M = (e)=>e.ownerDocument, $f7c9e5140289c67f$var$T = (e)=>e.defaultView, $f7c9e5140289c67f$var$E = /*#__PURE__*/ $f7c9e5140289c67f$var$w(()=>!!$f7c9e5140289c67f$var$k && "rtl" === getComputedStyle($f7c9e5140289c67f$var$C()).direction), $f7c9e5140289c67f$var$O = /*#__PURE__*/ $f7c9e5140289c67f$var$w(()=>/iP(hone|od|ad)/.test(navigator.userAgent)), $f7c9e5140289c67f$var$H = /*#__PURE__*/ $f7c9e5140289c67f$var$w(()=>"scrollBehavior" in $f7c9e5140289c67f$var$C().style), $f7c9e5140289c67f$var$J = (e)=>$f7c9e5140289c67f$var$u(e.u(), e._()), $f7c9e5140289c67f$var$W = (e, t, n)=>$f7c9e5140289c67f$var$u(e - (1 === n ? 1 : $f7c9e5140289c67f$var$u(1, t)), 0), $f7c9e5140289c67f$var$B = (e, t, n, r)=>$f7c9e5140289c67f$var$h(e + (2 === n ? 1 : $f7c9e5140289c67f$var$u(1, t)), r - 1), $f7c9e5140289c67f$var$$ = (e, t, n)=>t.reduce((t, [r, o])=>{
        const i = o - $f7c9e5140289c67f$var$y(e, r);
        return (!n || i > 0) && (t += i), t;
    }, 0), $f7c9e5140289c67f$var$A = (e, t = 40, n = 0, r, o, i = 0, s = 0)=>{
    let l = !!n, c = [], a = 0, d = 0, _ = 0, g = 0, v = 0, m = !1, w = 0, x = 0, k = 0, C = l ? [
        0,
        $f7c9e5140289c67f$var$u(n - 1, 0)
    ] : null, M = [
        0,
        0
    ];
    const T = r || ((e, t)=>({
            o: t,
            i: e,
            l: -1,
            t: $f7c9e5140289c67f$var$b([], e),
            h: $f7c9e5140289c67f$var$b([], e)
        }))(e, t), E = new Set, H = ()=>((e)=>e.i ? $f7c9e5140289c67f$var$z(e, e.i - 1) + $f7c9e5140289c67f$var$y(e, e.i - 1) : 0)(T), J = ()=>H() + i + s, W = ()=>$f7c9e5140289c67f$var$u(0, J() - a), B = (e)=>{
        $f7c9e5140289c67f$var$O() && 0 !== x ? v += e : (g += e, _++);
    };
    return {
        p: ()=>c,
        v: ()=>JSON.parse(JSON.stringify(T)),
        m: ()=>C ? [
                $f7c9e5140289c67f$var$h(M[0], C[0]),
                $f7c9e5140289c67f$var$u(M[1], C[1])
            ] : w ? M : M = $f7c9e5140289c67f$var$I(T, d - i + v + g, M[0], a),
        S: (e)=>T.t[e] === $f7c9e5140289c67f$var$S,
        I: ()=>!!C && T.t.slice($f7c9e5140289c67f$var$u(0, C[0] - 1), $f7c9e5140289c67f$var$h(T.i - 1, C[1] + 1) + 1).includes($f7c9e5140289c67f$var$S),
        R: (e)=>$f7c9e5140289c67f$var$z(T, e) - v,
        k: (e)=>$f7c9e5140289c67f$var$y(T, e),
        C: ()=>T.i,
        M: ()=>d,
        T: ()=>x,
        _: ()=>a,
        O: ()=>i,
        H: ()=>s,
        u: H,
        J: ()=>_,
        W () {
            const e = g, t = m;
            return g = 0, m = !1, a > J() ? [
                0,
                !1
            ] : [
                w = e,
                t
            ];
        },
        B (e, t) {
            const n = [
                e,
                t
            ];
            return E.add(n), ()=>{
                E.delete(n);
            };
        },
        $ (e, t) {
            let n, r, i = 0;
            switch(e){
                case 1:
                    {
                        const e = t.filter(([e, t])=>T.t[e] !== t);
                        if (!e.length) break;
                        let n = 0;
                        if (0 === d) ;
                        else if (d > W() - 1.5) n = $f7c9e5140289c67f$var$$(T, e, !0);
                        else if (2 === k) n = $f7c9e5140289c67f$var$$(T, e);
                        else {
                            const [t] = M;
                            n = $f7c9e5140289c67f$var$$(T, e.filter(([e])=>e < t));
                        }
                        n && B(n);
                        let s = !1;
                        e.forEach(([e, t])=>{
                            ((e, t, n)=>{
                                const r = e.t[t] === $f7c9e5140289c67f$var$S;
                                return e.t[t] = n, e.l = $f7c9e5140289c67f$var$h(t, e.l), r;
                            })(T, e, t) && (s = !0);
                        }), o && s && !d && ((e)=>{
                            const t = e.t.filter((e)=>e !== $f7c9e5140289c67f$var$S), n = t[0];
                            e.o = t.every((e)=>e === n) ? n : ((e)=>{
                                const t = [
                                    ...e
                                ].sort((e, t)=>e - t), n = e.length / 2 | 0;
                                return t.length % 2 == 0 ? (t[n - 1] + t[n]) / 2 : t[n];
                            })(t);
                        })(T), i = 2, r = !0;
                        break;
                    }
                case 2:
                    a !== t && (a = t, i = 2);
                    break;
                case 3:
                    if (t[1]) {
                        const e = W() - d, [n, r] = $f7c9e5140289c67f$var$R(T, t[0], !0);
                        B(r ? n : -$f7c9e5140289c67f$var$h(n, e)), r && (k = 2, m = !0), i = 1;
                    } else $f7c9e5140289c67f$var$R(T, t[0]);
                    break;
                case 4:
                    {
                        const e = $f7c9e5140289c67f$var$p(t, 0, W()), n = w;
                        if (w = 0, e === d) break;
                        const o = e - d, s = $f7c9e5140289c67f$var$f(o);
                        n && s < $f7c9e5140289c67f$var$f(n) + 1 || 0 !== k || (x = o < 0 ? 2 : 1), l && (C = null, l = !1), r = s > a, d = e, i = 5;
                        break;
                    }
                case 5:
                    i = 8, 0 !== x && (n = !0, i += 1), x = 0, k = 0, C = null;
                    break;
                case 6:
                    k = 1;
                    break;
                case 7:
                    C = $f7c9e5140289c67f$var$I(T, t, M[0], a), i = 1;
            }
            i && (c = [], n && v && (g += v, v = 0, _++), E.forEach(([e, t])=>{
                i & e && t(r);
            }));
        }
    };
}, $f7c9e5140289c67f$var$L = $f7c9e5140289c67f$var$k ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect), $f7c9e5140289c67f$var$P = (e, t)=>t && $f7c9e5140289c67f$var$E() ? -e : e, $f7c9e5140289c67f$var$V = (e, t, n, r, o)=>{
    const i = Date.now;
    let s = 0, l = !1, c = !1, a = !1, h = !1;
    const u = (()=>{
        let t;
        const n = ()=>{
            $f7c9e5140289c67f$var$v(t) && clearTimeout(t);
        }, r = ()=>{
            n(), t = $f7c9e5140289c67f$var$g(()=>{
                t = null, (()=>{
                    if (l || c) return l = !1, void u();
                    a = !1, e.$(5);
                })();
            }, 150);
        };
        return r.A = n, r;
    })(), f = ()=>{
        s = i(), a && (h = !0), e.$(4, r()), u();
    }, d = (t)=>{
        if (l || 0 === e.T() || t.ctrlKey) return;
        const r = i() - s;
        150 > r && 50 < r && (n ? t.deltaX : t.deltaY) && (l = !0);
    }, _ = ()=>{
        c = !0, a = h = !1;
    }, p = ()=>{
        c = !1, $f7c9e5140289c67f$var$O() && (a = !0);
    };
    return t.addEventListener("scroll", f), t.addEventListener("wheel", d, {
        passive: !0
    }), t.addEventListener("touchstart", _, {
        passive: !0
    }), t.addEventListener("touchend", p, {
        passive: !0
    }), {
        L: ()=>{
            t.removeEventListener("scroll", f), t.removeEventListener("wheel", d), t.removeEventListener("touchstart", _), t.removeEventListener("touchend", p), u.A();
        },
        P: ()=>{
            const [t, n] = e.W();
            if (t) return o(t, h), h = !1, n;
        }
    };
}, $f7c9e5140289c67f$var$X = (e, t)=>{
    let n, r, o;
    const i = t ? "scrollLeft" : "scrollTop", s = t ? "overflowX" : "overflowY", l = async (r, s)=>{
        if (!n) return void $f7c9e5140289c67f$var$m(()=>l(r, s));
        o && o();
        const c = ()=>{
            let t;
            return [
                new Promise((e, n)=>{
                    t = e, $f7c9e5140289c67f$var$g(o = n, 150);
                }),
                e.B(2, ()=>{
                    t && t();
                })
            ];
        };
        if (s && $f7c9e5140289c67f$var$H()) {
            for(; e.$(7, r()), e.I();){
                const [e, t] = c();
                try {
                    await e;
                } catch (e) {
                    return;
                } finally{
                    t();
                }
            }
            n.scrollTo({
                [t ? "left" : "top"]: $f7c9e5140289c67f$var$P(r(), t),
                behavior: "smooth"
            });
        } else for(;;){
            const [o, s] = c();
            try {
                n[i] = $f7c9e5140289c67f$var$P(r(), t), e.$(6), await o;
            } catch (e) {
                return;
            } finally{
                s();
            }
        }
    };
    return {
        V (o) {
            n = o, r = $f7c9e5140289c67f$var$V(e, o, t, ()=>$f7c9e5140289c67f$var$P(o[i], t), (e, n)=>{
                if (n) {
                    const e = o.style, t = e[s];
                    e[s] = "hidden", $f7c9e5140289c67f$var$g(()=>{
                        e[s] = t;
                    });
                }
                o[i] += $f7c9e5140289c67f$var$P(e, t);
            });
        },
        L () {
            r && r.L();
        },
        X (e) {
            l(()=>e);
        },
        Y (t) {
            t += e.M(), l(()=>t);
        },
        j (t, { align: n, smooth: r } = {}) {
            if (t = $f7c9e5140289c67f$var$p(t, 0, e.C() - 1), "nearest" === n) {
                const r = e.R(t), o = e.M();
                if (r < o) n = "start";
                else {
                    if (!(r + e.k(t) > o + e._())) return;
                    n = "end";
                }
            }
            l(()=>e.O() + ("end" === n ? e.R(t) + e.k(t) - e._() : "center" === n ? e.R(t) + (e.k(t) - e._()) / 2 : e.R(t)), r);
        },
        P: ()=>{
            r && r.P() && o && o();
        }
    };
}, $f7c9e5140289c67f$var$Y = (e, t)=>{
    let n;
    return {
        V (r) {
            const o = t ? "scrollX" : "scrollY", i = $f7c9e5140289c67f$var$M(r), s = $f7c9e5140289c67f$var$T(i), l = i.body, c = (e, t, n, r = 0)=>{
                const o = n ? "offsetLeft" : "offsetTop", i = r + (n && $f7c9e5140289c67f$var$E() ? s.innerWidth - e[o] - e.offsetWidth : e[o]), l = e.offsetParent;
                return e !== t && l ? c(l, t, n, i) : i;
            };
            n = $f7c9e5140289c67f$var$V(e, s, t, ()=>$f7c9e5140289c67f$var$P(s[o], t) - c(r, l, t), (e)=>{
                s.scrollBy(t ? $f7c9e5140289c67f$var$P(e, t) : 0, t ? 0 : e);
            });
        },
        L () {
            n && n.L();
        },
        P: ()=>{
            n && n.P();
        }
    };
}, $f7c9e5140289c67f$var$j = "current", $f7c9e5140289c67f$var$q = (e, t)=>{
    if ($f7c9e5140289c67f$var$_(e)) for (const n of e)$f7c9e5140289c67f$var$q(n, t);
    else $f7c9e5140289c67f$var$v(e) && "boolean" != typeof e && t.push(e);
}, $f7c9e5140289c67f$var$D = (e, t)=>{
    const n = e.key;
    return $f7c9e5140289c67f$var$v(n) ? n : "_" + t;
}, $f7c9e5140289c67f$var$N = (e)=>{
    const t = (0, $acw62.useRef)();
    return t[$f7c9e5140289c67f$var$j] || (t[$f7c9e5140289c67f$var$j] = e());
}, $f7c9e5140289c67f$var$U = (e)=>{
    const t = (0, $acw62.useRef)(e);
    return $f7c9e5140289c67f$var$L(()=>{
        t[$f7c9e5140289c67f$var$j] = e;
    }, [
        e
    ]), t;
}, $f7c9e5140289c67f$var$F = (e)=>{
    let t;
    return {
        V (n) {
            (t || (t = new ($f7c9e5140289c67f$var$T($f7c9e5140289c67f$var$M(n))).ResizeObserver(e))).observe(n);
        },
        q (e) {
            t.unobserve(e);
        },
        L () {
            t && t.disconnect();
        }
    };
}, $f7c9e5140289c67f$var$G = (e, t)=>{
    let n;
    const r = t ? "width" : "height", o = new WeakMap, i = $f7c9e5140289c67f$var$F((t)=>{
        const i = [];
        for (const { target: s, contentRect: l } of t)if (s.offsetParent) {
            if (s === n) e.$(2, l[r]);
            else {
                const e = o.get(s);
                $f7c9e5140289c67f$var$v(e) && i.push([
                    e,
                    l[r]
                ]);
            }
        }
        i.length && e.$(1, i);
    });
    return {
        D (e) {
            i.V(n = e);
        },
        N: (e, t)=>(o.set(e, t), i.V(e), ()=>{
                o.delete(e), i.q(e);
            }),
        L: i.L
    };
}, $f7c9e5140289c67f$var$K = (e, t)=>{
    const n = t ? "width" : "height", r = t ? "innerWidth" : "innerHeight", o = new WeakMap, i = $f7c9e5140289c67f$var$F((t)=>{
        const r = [];
        for (const { target: e, contentRect: i } of t){
            if (!e.offsetParent) continue;
            const t = o.get(e);
            $f7c9e5140289c67f$var$v(t) && r.push([
                t,
                i[n]
            ]);
        }
        r.length && e.$(1, r);
    });
    let s;
    return {
        D (t) {
            const n = $f7c9e5140289c67f$var$T($f7c9e5140289c67f$var$M(t)), o = ()=>{
                e.$(2, n[r]);
            };
            n.addEventListener("resize", o), o(), s = ()=>{
                n.removeEventListener("resize", o);
            };
        },
        N: (e, t)=>(o.set(e, t), i.V(e), ()=>{
                o.delete(e), i.q(e);
            }),
        L () {
            s && s(), i.L();
        }
    };
}, $f7c9e5140289c67f$var$Q = (e, t)=>{
    let n;
    const r = "height", o = "width", i = new WeakMap, s = new Set, l = new Set, c = new Map, a = (e, t)=>`${e}-${t}`, h = $f7c9e5140289c67f$var$F((h)=>{
        const f = new Set, d = new Set;
        for (const { target: s, contentRect: l } of h)if (s.offsetParent) {
            if (s === n) e.$(2, l[r]), t.$(2, l[o]);
            else {
                const e = i.get(s);
                if (e) {
                    const [t, n] = e, i = a(t, n), s = c.get(i), h = [
                        l[r],
                        l[o]
                    ];
                    let u, _;
                    s ? (s[0] !== h[0] && (u = !0), s[1] !== h[1] && (_ = !0)) : u = _ = !0, u && f.add(t), _ && d.add(n), (u || _) && c.set(i, h);
                }
            }
        }
        if (f.size) {
            const t = [];
            f.forEach((e)=>{
                let n = 0;
                l.forEach((t)=>{
                    const r = c.get(a(e, t));
                    r && (n = $f7c9e5140289c67f$var$u(n, r[0]));
                }), n && t.push([
                    e,
                    n
                ]);
            }), e.$(1, t);
        }
        if (d.size) {
            const e = [];
            d.forEach((t)=>{
                let n = 0;
                s.forEach((e)=>{
                    const r = c.get(a(e, t));
                    r && (n = $f7c9e5140289c67f$var$u(n, r[1]));
                }), n && e.push([
                    t,
                    n
                ]);
            }), t.$(1, e);
        }
    });
    return {
        D (e) {
            h.V(n = e);
        },
        N: (e, t, n)=>(i.set(e, [
                t,
                n
            ]), s.add(t), l.add(n), h.V(e), ()=>{
                i.delete(e), h.q(e);
            }),
        L: h.L
    };
}, $f7c9e5140289c67f$var$Z = /*#__PURE__*/ (0, $acw62.memo)(({ U: t, F: n, G: o, K: s, Z: l, ee: c, te: a, ne: h })=>{
    const u = (0, $acw62.useRef)(null);
    $f7c9e5140289c67f$var$L(()=>n(u[$f7c9e5140289c67f$var$j], o), [
        o
    ]);
    const f = (0, $acw62.useMemo)(()=>{
        const e = {
            margin: 0,
            padding: 0,
            position: l && h ? void 0 : "absolute",
            [a ? "height" : "width"]: "100%",
            [a ? "top" : "left"]: 0,
            [a ? $f7c9e5140289c67f$var$E() ? "right" : "left" : "top"]: s,
            visibility: !l || h ? "visible" : "hidden"
        };
        return a && (e.display = "flex"), e;
    }, [
        s,
        l,
        h
    ]);
    return (0, $7b02d682eb115277$exports.jsx)(c, "string" == typeof c ? {
        ref: u,
        style: f,
        children: t
    } : {
        ref: u,
        style: f,
        index: o,
        children: t
    });
}), $f7c9e5140289c67f$var$ee = (e)=>(0, $acw62.useReducer)(e.p, void 0, e.p)[1], $f7c9e5140289c67f$var$te = (e, t)=>(0, $acw62.useMemo)(()=>{
        if ("function" == typeof e) return [
            e,
            t || 0
        ];
        const n = ((e)=>{
            const t = [];
            return $f7c9e5140289c67f$var$q(e, t), t;
        })(e);
        return [
            (e)=>n[e],
            n.length
        ];
    }, [
        e,
        t
    ]), $f7c9e5140289c67f$export$89be5a243e59c4b2 = /*#__PURE__*/ (0, $acw62.forwardRef)(({ children: t, count: o, overscan: i = 4, itemSize: s, shift: l, horizontal: h, reverse: f, cache: d, startMargin: _, endMargin: g, ssrCount: p, as: v = "div", item: w = "div", scrollRef: S, onScroll: b, onScrollEnd: y, onRangeChange: z }, x)=>{
    const [I, R] = $f7c9e5140289c67f$var$te(t, o), k = (0, $acw62.useRef)(null), C = (0, $acw62.useRef)(!!p), M = $f7c9e5140289c67f$var$U(b), T = $f7c9e5140289c67f$var$U(y), [E, O, H, $] = $f7c9e5140289c67f$var$N(()=>{
        const e = !!h, t = $f7c9e5140289c67f$var$A(R, s, p, d, !s, _, g);
        return [
            t,
            $f7c9e5140289c67f$var$G(t, e),
            $f7c9e5140289c67f$var$X(t, e),
            e
        ];
    });
    R !== E.C() && E.$(3, [
        R,
        l
    ]);
    const P = $f7c9e5140289c67f$var$ee(E), [V, Y] = E.m(), q = E.T(), F = E.J(), K = E.u(), Q = ((e)=>$f7c9e5140289c67f$var$u(e.u(), e._() - e.O() - e.H()))(E), ne = f ? $f7c9e5140289c67f$var$u(0, Q - K) : 0, re = [];
    $f7c9e5140289c67f$var$L(()=>{
        C[$f7c9e5140289c67f$var$j] = !1;
        const e = E.B(3, (e)=>{
            e ? (0, $11492dca620dcaa5$exports.flushSync)(P) : P();
        }), t = E.B(4, ()=>{
            M[$f7c9e5140289c67f$var$j] && M[$f7c9e5140289c67f$var$j](E.M());
        }), n = E.B(8, ()=>{
            T[$f7c9e5140289c67f$var$j] && T[$f7c9e5140289c67f$var$j]();
        }), r = (e)=>{
            O.D(e), H.V(e);
        };
        return S ? $f7c9e5140289c67f$var$m(()=>r(S[$f7c9e5140289c67f$var$j])) : r(k[$f7c9e5140289c67f$var$j].parentElement), ()=>{
            e(), t(), n(), O.L(), H.L();
        };
    }, []), $f7c9e5140289c67f$var$L(()=>{
        H.P();
    }, [
        F
    ]), (0, $acw62.useEffect)(()=>{
        z && z(V, Y);
    }, [
        V,
        Y
    ]), (0, $acw62.useImperativeHandle)(x, ()=>({
            get cache () {
                return E.v();
            },
            get scrollOffset () {
                return E.M();
            },
            get scrollSize () {
                return $f7c9e5140289c67f$var$J(E);
            },
            get viewportSize () {
                return E._();
            },
            scrollToIndex: H.j,
            scrollTo: H.X,
            scrollBy: H.Y
        }), []);
    for(let t = $f7c9e5140289c67f$var$W(V, i, q), n = $f7c9e5140289c67f$var$B(Y, i, q, R); t <= n; t++){
        const n = I(t);
        re.push((0, $7b02d682eb115277$exports.jsx)($f7c9e5140289c67f$var$Z, {
            F: O.N,
            G: t,
            K: E.R(t) + ne,
            Z: E.S(t),
            ee: w,
            U: n,
            te: $,
            ne: C[$f7c9e5140289c67f$var$j]
        }, $f7c9e5140289c67f$var$D(n, t)));
    }
    return (0, $7b02d682eb115277$exports.jsx)(v, {
        ref: k,
        style: {
            overflowAnchor: "none",
            flex: "none",
            position: "relative",
            visibility: "hidden",
            width: $ ? K : "100%",
            height: $ ? "100%" : K,
            [$ ? "minWidth" : "minHeight"]: Q,
            pointerEvents: 0 !== q ? "none" : "auto"
        },
        children: re
    });
}), $f7c9e5140289c67f$export$3b010b0401837103 = /*#__PURE__*/ (0, $acw62.forwardRef)(({ children: t, count: n, overscan: r, itemSize: o, shift: i, horizontal: s, reverse: l, cache: c, ssrCount: a, item: h, onScroll: u, onScrollEnd: f, onRangeChange: d, style: _, ...g }, p)=>(0, $7b02d682eb115277$exports.jsx)("div", {
        ...g,
        style: {
            display: s ? "inline-block" : "block",
            [s ? "overflowX" : "overflowY"]: "auto",
            contain: "strict",
            width: "100%",
            height: "100%",
            ..._
        },
        children: (0, $7b02d682eb115277$exports.jsx)($f7c9e5140289c67f$export$89be5a243e59c4b2, {
            ref: p,
            count: n,
            overscan: r,
            itemSize: o,
            shift: i,
            horizontal: s,
            reverse: l,
            cache: c,
            ssrCount: a,
            item: h,
            onScroll: u,
            onScrollEnd: f,
            onRangeChange: d,
            children: t
        })
    })), $f7c9e5140289c67f$export$4f803696e87a3aaf = /*#__PURE__*/ (0, $acw62.forwardRef)(({ children: t, count: o, overscan: i = 4, itemSize: s, shift: l, horizontal: h, cache: u, ssrCount: f, as: d = "div", item: _ = "div", onScrollEnd: g, onRangeChange: p }, v)=>{
    const [m, w] = $f7c9e5140289c67f$var$te(t, o), S = (0, $acw62.useRef)(null), b = $f7c9e5140289c67f$var$U(g), y = (0, $acw62.useRef)(!!f), [z, x, I, R] = $f7c9e5140289c67f$var$N(()=>{
        const e = !!h, t = $f7c9e5140289c67f$var$A(w, s, f, u, !s);
        return [
            t,
            $f7c9e5140289c67f$var$K(t, e),
            $f7c9e5140289c67f$var$Y(t, e),
            e
        ];
    });
    w !== z.C() && z.$(3, [
        w,
        l
    ]);
    const k = $f7c9e5140289c67f$var$ee(z), [C, M] = z.m(), T = z.T(), E = z.J(), O = z.u(), H = [];
    $f7c9e5140289c67f$var$L(()=>{
        y[$f7c9e5140289c67f$var$j] = !1;
        const e = z.B(3, (e)=>{
            e ? (0, $11492dca620dcaa5$exports.flushSync)(k) : k();
        }), t = z.B(8, ()=>{
            b[$f7c9e5140289c67f$var$j] && b[$f7c9e5140289c67f$var$j]();
        }), n = S[$f7c9e5140289c67f$var$j];
        return x.D(n), I.V(n), ()=>{
            e(), t(), x.L(), I.L();
        };
    }, []), $f7c9e5140289c67f$var$L(()=>{
        I.P();
    }, [
        E
    ]), (0, $acw62.useEffect)(()=>{
        p && p(C, M);
    }, [
        C,
        M
    ]), (0, $acw62.useImperativeHandle)(v, ()=>({
            get cache () {
                return z.v();
            }
        }), []);
    for(let t = $f7c9e5140289c67f$var$W(C, i, T), n = $f7c9e5140289c67f$var$B(M, i, T, w); t <= n; t++){
        const n = m(t);
        H.push((0, $7b02d682eb115277$exports.jsx)($f7c9e5140289c67f$var$Z, {
            F: x.N,
            G: t,
            K: z.R(t),
            Z: z.S(t),
            ee: _,
            U: n,
            te: R,
            ne: y[$f7c9e5140289c67f$var$j]
        }, $f7c9e5140289c67f$var$D(n, t)));
    }
    return (0, $7b02d682eb115277$exports.jsx)(d, {
        ref: S,
        style: {
            flex: "none",
            position: "relative",
            visibility: "hidden",
            width: R ? O : "100%",
            height: R ? "100%" : O,
            pointerEvents: 0 !== T ? "none" : "auto"
        },
        children: H
    });
}), $f7c9e5140289c67f$var$ie = /*#__PURE__*/ (0, $acw62.forwardRef)(({ children: t, attrs: n, width: r, height: o, scrolling: s }, l)=>(0, $7b02d682eb115277$exports.jsx)("div", {
        ref: l,
        ...n,
        children: (0, $7b02d682eb115277$exports.jsx)("div", {
            style: (0, $acw62.useMemo)(()=>({
                    position: "relative",
                    visibility: "hidden",
                    width: null != r ? r : "100%",
                    height: null != o ? o : "100%",
                    pointerEvents: s ? "none" : "auto"
                }), [
                r,
                o,
                s
            ]),
            children: t
        })
    })), $f7c9e5140289c67f$var$se = (e, t)=>`${e}-${t}`, $f7c9e5140289c67f$var$le = /*#__PURE__*/ (0, $acw62.memo)(({ U: t, F: n, re: o, oe: s, ie: l, se: c, le: a, ce: h, Z: u, ee: f })=>{
    const d = (0, $acw62.useRef)(null);
    return $f7c9e5140289c67f$var$L(()=>n.N(d[$f7c9e5140289c67f$var$j], o, s), [
        s,
        o
    ]), (0, $7b02d682eb115277$exports.jsx)(f, {
        ref: d,
        style: (0, $acw62.useMemo)(()=>({
                display: "grid",
                margin: 0,
                padding: 0,
                position: "absolute",
                top: l,
                [$f7c9e5140289c67f$var$E() ? "right" : "left"]: c,
                visibility: u ? "hidden" : "visible",
                minHeight: a,
                minWidth: h
            }), [
            l,
            c,
            h,
            a,
            u
        ]),
        children: t
    });
}), $f7c9e5140289c67f$export$f33bd25140a3a9b7 = /*#__PURE__*/ (0, $acw62.forwardRef)(({ children: t, row: n, col: o, cellHeight: s = 40, cellWidth: l = 100, overscan: h = 2, initialRowCount: u, initialColCount: f, components: { Root: _ = $f7c9e5140289c67f$var$ie, Cell: g = "div" } = {}, ...p }, v)=>{
    const [m, w, S, b, y] = $f7c9e5140289c67f$var$N(()=>{
        const e = $f7c9e5140289c67f$var$A(n, s, u), t = $f7c9e5140289c67f$var$A(o, l, f);
        return [
            e,
            t,
            $f7c9e5140289c67f$var$Q(e, t),
            $f7c9e5140289c67f$var$X(e, !1),
            $f7c9e5140289c67f$var$X(t, !0)
        ];
    });
    n !== m.C() && m.$(3, [
        n
    ]), o !== w.C() && w.$(3, [
        o
    ]);
    const z = $f7c9e5140289c67f$var$ee(m), x = $f7c9e5140289c67f$var$ee(w), [I, R] = m.m(), [k, C] = w.m(), M = m.T(), T = w.T(), E = m.J(), O = w.J(), H = $f7c9e5140289c67f$var$J(m), $ = $f7c9e5140289c67f$var$J(w), P = (0, $acw62.useRef)(null);
    $f7c9e5140289c67f$var$L(()=>{
        const e = P[$f7c9e5140289c67f$var$j], t = m.B(3, (e)=>{
            e ? (0, $11492dca620dcaa5$exports.flushSync)(z) : z();
        }), n = w.B(3, (e)=>{
            e ? (0, $11492dca620dcaa5$exports.flushSync)(x) : x();
        });
        return S.D(e), b.V(e), y.V(e), ()=>{
            t(), n(), S.L(), b.L(), y.L();
        };
    }, []), $f7c9e5140289c67f$var$L(()=>{
        b.P();
    }, [
        E
    ]), $f7c9e5140289c67f$var$L(()=>{
        y.P();
    }, [
        O
    ]), (0, $acw62.useImperativeHandle)(v, ()=>({
            get scrollOffset () {
                return [
                    w.M(),
                    m.M()
                ];
            },
            get scrollSize () {
                return [
                    $f7c9e5140289c67f$var$J(w),
                    $f7c9e5140289c67f$var$J(m)
                ];
            },
            get viewportSize () {
                return [
                    w._(),
                    m._()
                ];
            },
            scrollToIndex (e, t) {
                y.j(e), b.j(t);
            },
            scrollTo (e, t) {
                y.X(e), b.X(t);
            },
            scrollBy (e, t) {
                y.Y(e), b.Y(t);
            }
        }), []);
    const V = (0, $acw62.useMemo)(()=>{
        const e = new Map;
        return (n, r)=>{
            let o = e.get($f7c9e5140289c67f$var$se(n, r));
            return o || e.set($f7c9e5140289c67f$var$se(n, r), o = t({
                rowIndex: n,
                colIndex: r
            })), o;
        };
    }, [
        t
    ]), Y = $f7c9e5140289c67f$var$W(I, h, M), q = $f7c9e5140289c67f$var$B(R, h, M, n), D = $f7c9e5140289c67f$var$W(k, h, T), U = $f7c9e5140289c67f$var$B(C, h, T, o), F = [];
    for(let t = Y; t <= q; t++)for(let n = D; n <= U; n++)F.push((0, $7b02d682eb115277$exports.jsx)($f7c9e5140289c67f$var$le, {
        F: S,
        re: t,
        oe: n,
        ie: m.R(t),
        se: w.R(n),
        le: m.k(t),
        ce: w.k(n),
        Z: m.S(t) || w.S(n),
        ee: g,
        U: V(t, n)
    }, $f7c9e5140289c67f$var$se(t, n)));
    return (0, $7b02d682eb115277$exports.jsx)(_, {
        ref: P,
        width: $,
        height: H,
        scrolling: 0 !== M || 0 !== T,
        attrs: (0, $acw62.useMemo)(()=>({
                ...p,
                style: {
                    overflow: "auto",
                    overflowAnchor: "none",
                    flex: "none",
                    contain: "strict",
                    width: "100%",
                    height: "100%",
                    ...p.style
                }
            }), $f7c9e5140289c67f$var$d(p)),
        children: F
    });
});



var $iQrBP = parcelRequire("iQrBP");

var $aHxeO = parcelRequire("aHxeO");

var $ardUq = parcelRequire("ardUq");
class $2caebf5e38315544$export$3c9c7162a2a817d3 {
    get(key) {
        if (typeof key === "object" || typeof key === "function") return this.objects.get(key);
        else return this.other.get(key);
    }
    set(key, value) {
        if (typeof key === "object" || typeof key === "function") this.objects.set(key, value);
        else this.other.set(key, value);
    }
    constructor(){
        this.objects = new WeakMap();
        this.other = new Map();
    }
}
var $2caebf5e38315544$export$2e2bcd8739ae039 = new $2caebf5e38315544$export$3c9c7162a2a817d3();








function $5bd921a18e0690d7$export$f478f6dc019df8a3(codeEditor, code, env, codeOffset = 0) {
    const [completionVisibilty, setCompletionVisibility] = $acw62.useState(null);
    const completionsRef = $acw62.useRef(null);
    const containerRef = $acw62.useRef(null);
    function findDocsFor(value) {
        return (0, $2caebf5e38315544$export$2e2bcd8739ae039).get(value);
    }
    const shortcuts = [
        {
            description: "completions",
            bindings: [
                [
                    [
                        "C-Space"
                    ],
                    "none",
                    "toggle",
                    ()=>{
                        setCompletionVisibility((visibility)=>visibility !== "value" ? "value" : null);
                    }
                ],
                [
                    [
                        "C-KeyD"
                    ],
                    "none",
                    "docs",
                    ()=>{
                        setCompletionVisibility((visibility)=>visibility !== "docs" ? "docs" : null);
                    }
                ],
                ...completionVisibilty ? [
                    [
                        [
                            "ArrowUp",
                            "C-KeyP"
                        ],
                        "none",
                        "previous",
                        ()=>{
                            completionsRef.current?.moveSelection(-1);
                        }
                    ],
                    [
                        [
                            "ArrowDown",
                            "C-KeyN"
                        ],
                        "none",
                        "next",
                        ()=>{
                            completionsRef.current?.moveSelection(1);
                        }
                    ],
                    [
                        [
                            "Tab"
                        ],
                        "none",
                        "complete",
                        ()=>{
                            completionsRef.current && onComplete(completionsRef.current.selected, completionsRef.current.offset);
                        }
                    ],
                    [
                        [
                            "Enter"
                        ],
                        "none",
                        "use completion",
                        ()=>{
                            if (completionsRef.current) {
                                onComplete(completionsRef.current.selected, completionsRef.current.offset);
                                setCompletionVisibility(null);
                            }
                        }
                    ],
                    [
                        [
                            "Escape"
                        ],
                        "none",
                        "close",
                        ()=>{
                            setCompletionVisibility(null);
                        }
                    ]
                ] : []
            ]
        }
    ];
    const selectionRect = (0, $ff99259e85546794$export$4826a080e03186d9)(completionVisibilty !== null);
    const relativeRect = containerRef.current?.offsetParent && containerRef.current.offsetParent.getBoundingClientRect();
    const caretRect = selectionRect && relativeRect && new DOMRect(selectionRect.x - relativeRect.x, selectionRect.y - relativeRect.y, selectionRect.width, selectionRect.height);
    const position = codeEditor.current?.editable?.getState?.()?.position ?? {
        start: 0,
        end: 0
    };
    const correctedPosition = {
        start: position.start - codeOffset,
        end: position.end - codeOffset
    };
    const splitCode = (0, $0dbe0b62c1b2b006$export$3ac9a6ef6934ce61)(code, correctedPosition);
    function onComplete(searchResult, offset) {
        if (!codeEditor.current) return;
        // Important! The .edit() has to occur before any React state updates
        // (eg setCompletionVisible) is called, otherwise the DOM state and
        // React's Virtual DOM diverge. Somehow the React update interferes with
        // the MutationObserver inside the editable, which then doesn't register
        // the changes by .edit() and so can't do its magic. Probably because
        // the update triggers the useLayoutEffect, which disables the
        // MutationObserver. Normally in this phase there should only be changes
        // to the DOM made by React, which we really don't want to see. But in
        // this case we're making changes on our which should be observed. So we
        // have to make sure we do them outside of a React state update.
        codeEditor.current.editable.edit(searchResult.candidate.name, -(0, $dfcd2f458918c5ae$export$87f5c7a0305c2dc7)(searchResult.match).length, -offset);
    }
    function onBlur(event) {
        if (!event.currentTarget.contains(event.relatedTarget)) setCompletionVisibility(null);
    }
    let ui = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        ref: containerRef,
        style: {
            position: "absolute"
        }
    });
    if (completionVisibilty && caretRect) ui = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        ref: containerRef,
        className: "z-20 border border-gray-300 bg-gray-50 shadow shadow-gray-200",
        style: {
            position: "absolute",
            left: caretRect.left + "px",
            top: caretRect.bottom + "px"
        },
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5bd921a18e0690d7$export$2e5f1dd1efbe8ec5, {
            ref: completionsRef,
            splitCode: splitCode,
            env: env,
            onSelectSearchResult: onComplete,
            tab: completionVisibilty,
            onChangeTab: setCompletionVisibility,
            docs: findDocsFor,
            selectedMarker: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5bc960417406f657$export$299640fc954ba1db), {
                className: "absolute top-0 right-1 my-1 font-semibold text-[0.625rem] bg-gray-50",
                children: "Tab"
            })
        })
    });
    return {
        onBlur: onBlur,
        shortcuts: shortcuts,
        ui: ui
    };
}
const $5bd921a18e0690d7$export$2eba122af18d1e96 = new Set([
    Object.prototype
]);
function $5bd921a18e0690d7$export$6ee1db3f87608989(object) {
    if (object === null) return [];
    const proto = Object.getPrototypeOf(object);
    return Object.entries({
        ...proto === null || $5bd921a18e0690d7$export$2eba122af18d1e96.has(proto) ? {} : Object.getOwnPropertyDescriptors(proto),
        ...Object.getOwnPropertyDescriptors(object)
    }).map(([name, desc])=>({
            ...desc,
            name: name,
            object: object
        }));
}
function $5bd921a18e0690d7$export$7e635f9b118b79b8(completion) {
    try {
        if (Object.getOwnPropertyDescriptor(completion, "value") !== undefined) return completion.value;
        if (Object.getOwnPropertyDescriptor(completion, "get") !== undefined) return completion.get.apply(completion.object);
        return undefined;
    } catch (e) {
        return e;
    }
}
const $5bd921a18e0690d7$var$noCompletionOptions = {
    search: "",
    options: [],
    end: 0
};
function $5bd921a18e0690d7$var$findCompletions(expr, env) {
    try {
        if (expr.type === "MemberExpression" && expr.property.type === "Identifier") {
            const obj = (0, $e26ee743ff8e9b71$export$6f349f186c49a218)((0, (/*@__PURE__*/$parcel$interopDefault($iQrBP)))(expr.object).code, env);
            return {
                search: expr.property.name,
                options: $5bd921a18e0690d7$export$6ee1db3f87608989(obj),
                end: expr.end
            };
        }
        // Top-level variable access?
        if (expr.type === "Identifier") return {
            search: expr.name,
            options: [
                ...$5bd921a18e0690d7$export$6ee1db3f87608989(env),
                ...$5bd921a18e0690d7$export$6ee1db3f87608989(globalThis)
            ],
            end: expr.end
        };
        if (expr.type === "CallExpression" && expr.callee.type !== "V8IntrinsicIdentifier") return $5bd921a18e0690d7$var$findCompletions(expr.callee, env);
        if (expr.type === "NewExpression" && expr.callee.type !== "V8IntrinsicIdentifier") return $5bd921a18e0690d7$var$findCompletions(expr.callee, env);
        if (expr.type === "BinaryExpression") return $5bd921a18e0690d7$var$findCompletions(expr.right, env);
    } catch (e) {}
    return $5bd921a18e0690d7$var$noCompletionOptions;
}
const $5bd921a18e0690d7$export$2e5f1dd1efbe8ec5 = /*#__PURE__*/ $acw62.forwardRef(function Completions({ splitCode: splitCode, env: env, onSelectSearchResult: onSelectSearchResult, tab: tab, onChangeTab: onChangeTab, docs: docs, selectedMarker: selectedMarker }, ref) {
    const allBefore = [
        ...splitCode.linesBefore,
        splitCode.lineBefore
    ].join("\n");
    const parsed = $5bd921a18e0690d7$var$looseParseCode(allBefore);
    const search = (parsed && $5bd921a18e0690d7$var$findCompletions(parsed.ast, env)) ?? $5bd921a18e0690d7$var$noCompletionOptions;
    const offset = parsed === undefined || search.end === undefined ? 0 : parsed.str.length - search.end;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5bd921a18e0690d7$export$2a2f9e00e6197911, {
        ref: ref,
        completionOptions: search,
        offset: offset,
        onSelectSearchResult: onSelectSearchResult,
        tab: tab,
        onChangeTab: onChangeTab,
        docs: docs,
        selectedMarker: selectedMarker
    });
});
function $5bd921a18e0690d7$var$looseParseCode(code) {
    const missingDoubleQuote = $5bd921a18e0690d7$var$countNotInString(code, '"') ? '"' : "";
    const missingQuote = $5bd921a18e0690d7$var$countNotInString(code, `'`) ? `'` : "";
    const missingStringEnd = missingDoubleQuote + missingQuote;
    const leftParens = $5bd921a18e0690d7$var$countNotInString(code, "(");
    const rightParens = $5bd921a18e0690d7$var$countNotInString(code, ")");
    const missingParens = ")".repeat(Math.max(0, leftParens - rightParens));
    const parseWholeFunction = missingParens.length > 0 && /[\(,]\s*$/.test(code);
    for(let suffix = code; suffix.length > 0; suffix = suffix.slice(1)){
        if (parseWholeFunction) try {
            return {
                str: suffix,
                ast: $5bd921a18e0690d7$var$parseCurrentExpression(suffix + missingStringEnd + missingParens)
            };
        } catch (e) {}
        try {
            return {
                str: suffix,
                ast: $5bd921a18e0690d7$var$parseCurrentExpression(suffix + missingStringEnd)
            };
        } catch (e) {}
    }
}
const $5bd921a18e0690d7$var$RANDOM_CHARS_SELECTION = "abcdefghijklmnopqrstuvwxyzABCDEFJGHIjKLMNOPQRSTUVWXYZ0123456789";
const $5bd921a18e0690d7$var$RANDOM_SUFFIX = Array(30).fill(0).map(()=>$5bd921a18e0690d7$var$RANDOM_CHARS_SELECTION[Math.floor(Math.random() * $5bd921a18e0690d7$var$RANDOM_CHARS_SELECTION.length)]).join("");
const $5bd921a18e0690d7$var$EMPTY_IDENTIFIER_PLACEHOLDER = "$EMPTY_IDENTIFIER_PLACEHOLDER_" + $5bd921a18e0690d7$var$RANDOM_SUFFIX;
function $5bd921a18e0690d7$var$parseCurrentExpression(code) {
    if (code.trim() === "") return $ardUq.identifier("");
    else if (code.slice(-1) === ".") {
        const objExpr = (0, $e26ee743ff8e9b71$export$f18e6236bf501d35)(code + $5bd921a18e0690d7$var$EMPTY_IDENTIFIER_PLACEHOLDER);
        const program = $ardUq.program([
            $ardUq.expressionStatement(objExpr)
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($aHxeO)))(program, {
            MemberExpression (path) {
                if ($ardUq.isIdentifier(path.node.property) && path.node.property.name === $5bd921a18e0690d7$var$EMPTY_IDENTIFIER_PLACEHOLDER) {
                    path.node.property.name = "";
                    path.node.property.end = path.node.property.start;
                    path.node.end = path.node.property.start;
                }
            }
        });
        return program.body[0].expression;
    } else return (0, $e26ee743ff8e9b71$export$f18e6236bf501d35)(code);
}
const $5bd921a18e0690d7$export$2a2f9e00e6197911 = /*#__PURE__*/ $acw62.forwardRef(function RenderCompletions({ completionOptions: completionSearch, offset: offset, onSelectSearchResult: onSelectSearchResult, tab: tab, onChangeTab: onChangeTab, docs: docs = ()=>undefined, selectedMarker: selectedMarker = null }, ref) {
    const vlistRef = $acw62.useRef(null);
    const scrollTo = $acw62.useCallback(function scrollTo(index) {
        vlistRef.current?.scrollToIndex?.(index, {
            align: "nearest"
        });
    }, [
        vlistRef
    ]);
    const { setRef: setRef, results: results, selected: selected, moveSelection: moveSelection, select: select } = (0, $dfcd2f458918c5ae$export$deb5cc6ef1318024)(completionSearch.search, completionSearch.options, $5bd921a18e0690d7$var$completionName, scrollTo);
    $acw62.useImperativeHandle(ref, ()=>({
            select: select,
            moveSelection: moveSelection,
            selected: results[selected],
            offset: offset
        }), [
        moveSelection,
        select,
        results,
        selected,
        offset
    ]);
    const selectedDocs = results.length > selected && docs($5bd921a18e0690d7$export$7e635f9b118b79b8(results[selected].candidate));
    const selectedValue = results.length > selected ? $5bd921a18e0690d7$export$7e635f9b118b79b8(results[selected].candidate) : undefined;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex flex-row items-stretch",
        onPointerDown: (event)=>event.preventDefault(),
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $f7c9e5140289c67f$export$3b010b0401837103), {
                ref: vlistRef,
                style: {
                    height: "12rem",
                    width: "12rem"
                },
                className: "overflow-auto",
                children: [
                    results.length === 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "w-full italic text-gray-700 text-xs text-center",
                        children: "No completions"
                    }),
                    results.map((result, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            ref: setRef(result.id),
                            className: `w-full cursor-pointer px-1 ${index === selected && "bg-gray-200"}`,
                            onPointerDown: ()=>{
                                if (selected === index) onSelectSearchResult(results[index], offset);
                                else select(index, false);
                            },
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("code", {
                                    className: "text-xs",
                                    children: (0, $dfcd2f458918c5ae$export$2484ee4456d34df7)(result.match)
                                }),
                                selected === index && selectedMarker
                            ]
                        }, result.id))
                ]
            }),
            results.length > selected && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "w-96 flex flex-col max-h-[12rem] border-l border-gray-100",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5bd921a18e0690d7$var$CompletionTabs, {
                    selected: tab,
                    onChange: onChangeTab,
                    children: {
                        value: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b749c8e203b309f1$export$93660df4be02febf), {
                            value: selectedValue,
                            expandLevel: 1
                        }),
                        docs: selectedDocs ? /*#__PURE__*/ $acw62.createElement(selectedDocs) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "italic text-center text-sm text-gray-700",
                            children: "No documentation found"
                        })
                    }
                })
            })
        ]
    });
});
function $5bd921a18e0690d7$var$completionName(completion) {
    return completion.name;
}
function $5bd921a18e0690d7$var$countNotInString(str, char) {
    const findStringRegex = /"(\\.|[^\\"])*"|'(\\.|[^\\'])*'|`(\\.|[^\\`])*`/g;
    return str.replace(findStringRegex, "").split("").filter((c)=>c === char).length;
}
function $5bd921a18e0690d7$var$CompletionTabs({ selected: selected, onChange: onChange, children: tabs }) {
    const tabIndex = Object.keys(tabs).indexOf(selected);
    function onChangeTabIndex(index) {
        onChange(Object.keys(tabs)[index]);
    }
    function TabPanel({ tab: tab, children: children }) {
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $37edcfa19f505e9c$export$3e41faf802a29e71).Panel, {
            children: children
        });
    }
    function TabButton({ tab: tab, children: children }) {
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $37edcfa19f505e9c$export$3e41faf802a29e71), {
            className: ({ selected: selected })=>`
                    flex-1 rounded-lg text-center m-1
                    ${selected ? "bg-white shadow font-medium" : "text-gray-600 hover:shadow"}
                `,
            onClick: (ev)=>{
                ev.stopPropagation();
                ev.preventDefault();
                onChange(tab);
            },
            children: children
        });
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $37edcfa19f505e9c$export$3e41faf802a29e71).Group, {
        selectedIndex: tabIndex,
        onChange: onChangeTabIndex,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $37edcfa19f505e9c$export$3e41faf802a29e71).Panels, {
                className: "flex-1 p-1 overflow-auto bg-white",
                children: Object.entries(tabs).map(([tab, content])=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(TabPanel, {
                        tab: tab,
                        children: content
                    }, tab))
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $37edcfa19f505e9c$export$3e41faf802a29e71).List, {
                className: "flex flex-row items-stretch text-xs bg-gray-50",
                children: Object.keys(tabs).map((tab)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(TabButton, {
                        tab: tab,
                        children: tab
                    }, tab))
            })
        ]
    });
}








function $b7cf2cd7cb0d508e$var$ACTIONS(dispatch, codeEditor, innerBlockRef) {
    return {
        setExpr (expr) {
            dispatch((state)=>({
                    state: {
                        ...state,
                        expr: expr
                    }
                }));
        },
        setChooseMode () {
            dispatch((state)=>{
                if (state.mode === "loading") return {
                    state: state
                };
                return {
                    state: {
                        mode: "choose",
                        expr: state.expr,
                        innerBlock: state.innerBlock,
                        innerBlockState: state.innerBlockState
                    },
                    effect () {
                        codeEditor.current?.element?.focus();
                    }
                };
            });
        },
        cancelChoose () {
            dispatch((state)=>{
                if (state.mode === "loading" || !$6f23581c0aef6dc2$export$de5a9e42c1dff8da(state.innerBlock)) return {
                    state: state
                };
                return {
                    state: {
                        mode: "run",
                        expr: state.expr,
                        innerBlock: state.innerBlock,
                        innerBlockState: state.innerBlockState
                    },
                    effect () {
                        innerBlockRef.current?.focus();
                    }
                };
            });
        },
        cancelLoading () {
            dispatch((state)=>({
                    state: $ea2d507bce2bc457$export$2cd8252107eb640b(state.expr),
                    effect () {
                        codeEditor.current?.element?.focus();
                    }
                }));
        },
        chooseBlock (expr, blockEnv) {
            dispatch((state)=>({
                    state: $ea2d507bce2bc457$export$9a4d0b419ab59138(expr, state, blockEnv),
                    effect () {
                        innerBlockRef.current?.focus();
                    }
                }));
        },
        dispatchBlock: $ea2d507bce2bc457$export$7dfc2a84d82d8ac7(dispatch)
    };
}
const $b7cf2cd7cb0d508e$export$c71a8436d89af6a6 = /*#__PURE__*/ $acw62.forwardRef(function BlockSelectorUI(props, ref) {
    const { state: state, dispatch: dispatch, env: env } = props;
    const { blockLibrary: blockLibrary } = props;
    const dispatchWithEffect = (0, $ff99259e85546794$export$a902f8b72ad3dfd8)(dispatch);
    const codeEditor = $acw62.useRef();
    const innerBlockRef = $acw62.useRef();
    const [blockExpr, setBlockExpr] = $acw62.useState(state.expr);
    const blockEnv = {
        ...blockLibrary,
        ...env
    };
    const completions = (0, $5bd921a18e0690d7$export$f478f6dc019df8a3)(codeEditor, blockExpr, blockEnv);
    const actions = $acw62.useMemo(()=>$b7cf2cd7cb0d508e$var$ACTIONS(dispatchWithEffect, codeEditor, innerBlockRef), [
        dispatchWithEffect,
        codeEditor,
        innerBlockRef
    ]);
    $acw62.useImperativeHandle(ref, ()=>{
        switch(state.mode){
            case "choose":
                return {
                    focus (options) {
                        codeEditor.current?.element?.focus(options);
                    }
                };
            case "run":
                return {
                    focus (options) {
                        innerBlockRef.current?.focus(options);
                    }
                };
        }
    }, [
        state.mode
    ]);
    const chooseBindingProps = (0, $5bc960417406f657$export$a1ca853c6e4bb6fb)([
        ...completions.shortcuts,
        {
            description: "selector",
            bindings: [
                [
                    [
                        "C-Enter"
                    ],
                    "none",
                    "select block",
                    ()=>{
                        actions.chooseBlock(blockExpr, blockEnv);
                    }
                ],
                [
                    [
                        "Escape"
                    ],
                    "none",
                    "cancel",
                    ()=>{
                        actions.cancelChoose();
                    }
                ]
            ]
        }
    ], state.mode === "choose");
    const runBindingProps = (0, $5bc960417406f657$export$a1ca853c6e4bb6fb)([
        {
            description: "selector",
            bindings: [
                [
                    [
                        "C-Slash"
                    ],
                    "none",
                    "switch block",
                    ()=>{
                        setBlockExpr(state.expr);
                        actions.setChooseMode();
                    }
                ]
            ]
        }
    ], state.mode === "run");
    const loadingBindingProps = (0, $5bc960417406f657$export$a1ca853c6e4bb6fb)([
        {
            description: "selector",
            bindings: [
                [
                    [
                        "Escape"
                    ],
                    "none",
                    "cancel loading",
                    ()=>{
                        actions.cancelLoading();
                    }
                ]
            ]
        }
    ], state.mode === "loading");
    switch(state.mode){
        case "loading":
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                ...loadingBindingProps,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e4ec753f5c716375$export$2b9260d4a45c8710), {
                        icon: $d8206b3ab2e65c05$export$1025ad641edb49c2,
                        spinPulse: true
                    }),
                    " ",
                    "Waiting for ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cb8a0fe0beecb480$export$6a048cde9ca9b775), {
                        className: "inline-block bg-gray-100 rounded",
                        container: "span",
                        code: state.expr
                    }),
                    " ",
                    "to turn into a Block.",
                    " ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        className: "text-blue-500",
                        onClick: actions.cancelLoading,
                        children: "Cancel"
                    })
                ]
            });
        case "run":
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "space-y-1",
                ...runBindingProps,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        className: `
                                text-xs text-gray-400 rounded-full
                                hover:text-gray-700 hover:bg-gray-200 hover:px-1
                                transition-all duration-100
                                print:hidden
                            `,
                        onClick: ()=>actions.setChooseMode(),
                        children: state.expr
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(state.innerBlock.Component, {
                        ref: innerBlockRef,
                        state: state.innerBlockState,
                        dispatch: actions.dispatchBlock,
                        env: env
                    })
                ]
            });
        case "choose":
            const blockCmdResult = (0, $e26ee743ff8e9b71$export$946ba5975ff1c976)(blockExpr, blockEnv);
            function onBlur(event) {
                completions.onBlur(event);
                chooseBindingProps.onBlur(event);
            }
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "space-y-1",
                ...chooseBindingProps,
                onBlur: onBlur,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cb8a0fe0beecb480$export$b7127187684f7150), {
                        ref: codeEditor,
                        code: blockExpr,
                        onUpdate: setBlockExpr
                    }),
                    $6f23581c0aef6dc2$export$de5a9e42c1dff8da(blockCmdResult) ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($b7cf2cd7cb0d508e$export$724b9769e1194d75, {
                        env: env,
                        block: (0, $b8f588c17e3c1433$export$e255fd3f9a510304)(blockCmdResult),
                        onChooseBlock: ()=>actions.chooseBlock(blockExpr, blockEnv)
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b749c8e203b309f1$export$93660df4be02febf), {
                        value: blockCmdResult
                    }),
                    completions.ui
                ]
            });
    }
});
function $b7cf2cd7cb0d508e$export$724b9769e1194d75({ env: env, block: block, onChooseBlock: onChooseBlock }) {
    function BlockCmdResultView() {
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(block.Component, {
            state: block.init,
            dispatch: ()=>{},
            env: env
        });
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: `
                space-y-2 p-2 rounded shadow
                hover:shadow-lg hover:-translate-y-px transition
            `,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                className: "font-thin cursor-pointer",
                onClick: onChooseBlock,
                children: "Preview"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b749c8e203b309f1$export$e926676385687eaf), {
                title: "Could not show block",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "cursor-default shadow-sky-100 p-1 rounded",
                    style: {
                        boxShadow: "inset 0 0 4px 2px var(--tw-shadow-color)"
                    },
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(BlockCmdResultView, {})
                })
            })
        ]
    });
}







function $801c87da4cea119a$var$typed(version, obj) {
    return {
        t: "resheet.selector",
        v: version,
        ...obj
    };
}
function $801c87da4cea119a$var$typedTables(version, obj) {
    return {
        t: "tables.selector",
        v: version,
        ...obj
    };
}
const $801c87da4cea119a$var$vPre = (0, $303c1b51f19a20e4$export$136de4b706fa579)({
    mode: (0, $dc2e80b7ebe4adb5$export$a9a18ae5ba42aeab)("run", "choose"),
    expr: (0, $dc2e80b7ebe4adb5$export$22b082955e083ec3),
    inner: (0, $dc2e80b7ebe4adb5$export$4154a199d7d90455)
}, (json)=>({ dispatch: dispatch, env: env, blockLibrary: blockLibrary })=>{
        return $801c87da4cea119a$var$parseV0(json, dispatch, env, blockLibrary);
    });
function $801c87da4cea119a$var$parseV0({ mode: mode, inner: inner, expr: expr }, dispatch, env, blockLibrary) {
    function dispatchBlock(action) {
        dispatch((state, context)=>{
            if (state.mode === "loading") return {
                state: state
            };
            const result = action(state.innerBlockState, context);
            return {
                state: {
                    ...state,
                    innerBlockState: result.state
                },
                description: result.description
            };
        });
    }
    const value = (0, $e26ee743ff8e9b71$export$946ba5975ff1c976)(expr, {
        ...blockLibrary,
        ...env
    });
    if (!$6f23581c0aef6dc2$export$de5a9e42c1dff8da(value)) {
        if (mode === "run") return {
            mode: "loading",
            modeAfter: mode,
            expr: expr,
            jsonToLoad: inner
        };
        else return {
            mode: "choose",
            expr: expr
        };
    }
    const innerBlock = (0, $b8f588c17e3c1433$export$e255fd3f9a510304)(value);
    const innerBlockState = innerBlock.fromJSON(inner, dispatchBlock, env);
    return {
        mode: mode,
        expr: expr,
        innerBlock: innerBlock,
        innerBlockState: innerBlockState
    };
}
const $801c87da4cea119a$export$21625637effda04 = (0, $303c1b51f19a20e4$export$471c540adb39cb81)($801c87da4cea119a$var$vPre, {
    schema: $801c87da4cea119a$var$typedTables(0, {
        mode: (0, $dc2e80b7ebe4adb5$export$a9a18ae5ba42aeab)("run", "choose"),
        expr: (0, $dc2e80b7ebe4adb5$export$22b082955e083ec3),
        inner: (0, $dc2e80b7ebe4adb5$export$4154a199d7d90455)
    }),
    parse: (json)=>({ dispatch: dispatch, env: env, blockLibrary: blockLibrary })=>{
            return $801c87da4cea119a$var$parseV0(json, dispatch, env, blockLibrary);
        },
    upgrade: (before)=>before
});
const $801c87da4cea119a$var$v1 = (0, $303c1b51f19a20e4$export$471c540adb39cb81)($801c87da4cea119a$export$21625637effda04, {
    schema: $801c87da4cea119a$var$typed(1, {
        mode: (0, $dc2e80b7ebe4adb5$export$a9a18ae5ba42aeab)("run", "choose"),
        expr: (0, $dc2e80b7ebe4adb5$export$22b082955e083ec3),
        inner: (0, $dc2e80b7ebe4adb5$export$4154a199d7d90455)
    }),
    parse: (json)=>({ dispatch: dispatch, env: env, blockLibrary: blockLibrary })=>{
            return $801c87da4cea119a$var$parseV0(json, dispatch, env, blockLibrary);
        },
    upgrade: (before)=>before
});
function $801c87da4cea119a$export$54fd2c36b5cc6731(state) {
    if (state.mode === "loading") return $801c87da4cea119a$var$typed(0, {
        mode: state.modeAfter,
        expr: state.expr,
        inner: state.jsonToLoad
    });
    return $801c87da4cea119a$var$typed(0, {
        mode: state.mode,
        expr: state.expr,
        inner: state.innerBlock?.toJSON(state.innerBlockState)
    });
}


function $3cde51ebcb63af9c$export$7ddf129dd8d5219f(expr = "", innerBlockInit, blockLibrary) {
    return $6f23581c0aef6dc2$export$185802fd694ee1f5({
        init: $ea2d507bce2bc457$export$2cd8252107eb640b(expr, innerBlockInit),
        view ({ state: state, dispatch: dispatch, env: env }, ref) {
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($b7cf2cd7cb0d508e$export$c71a8436d89af6a6, {
                ref: ref,
                state: state,
                dispatch: dispatch,
                env: env,
                blockLibrary: blockLibrary
            });
        },
        recompute (state, dispatch, env, changedVars) {
            return $ea2d507bce2bc457$export$1f297d8d0ce29e3(state, dispatch, env, changedVars, blockLibrary);
        },
        getResult (state) {
            if (state.mode === "loading") return undefined;
            return state.innerBlock?.getResult(state.innerBlockState);
        },
        fromJSON (json, dispatch, env) {
            return $801c87da4cea119a$export$21625637effda04(json)({
                dispatch: dispatch,
                env: env,
                blockLibrary: blockLibrary
            });
        },
        toJSON (state) {
            return $801c87da4cea119a$export$54fd2c36b5cc6731(state);
        }
    });
}






var $acw62 = parcelRequire("acw62");

var $f46ed4009cb9c1cd$exports = {};

$parcel$export($f46ed4009cb9c1cd$exports, "version", () => $f46ed4009cb9c1cd$export$83d89fbfd8236492, (v) => $f46ed4009cb9c1cd$export$83d89fbfd8236492 = v);
$parcel$export($f46ed4009cb9c1cd$exports, "renderToString", () => $f46ed4009cb9c1cd$export$80e7718417253a51, (v) => $f46ed4009cb9c1cd$export$80e7718417253a51 = v);
$parcel$export($f46ed4009cb9c1cd$exports, "renderToStaticMarkup", () => $f46ed4009cb9c1cd$export$eb3a06aef9e6ee51, (v) => $f46ed4009cb9c1cd$export$eb3a06aef9e6ee51 = v);
$parcel$export($f46ed4009cb9c1cd$exports, "renderToNodeStream", () => $f46ed4009cb9c1cd$export$307591e98609eddd, (v) => $f46ed4009cb9c1cd$export$307591e98609eddd = v);
$parcel$export($f46ed4009cb9c1cd$exports, "renderToStaticNodeStream", () => $f46ed4009cb9c1cd$export$b23711c915539651, (v) => $f46ed4009cb9c1cd$export$b23711c915539651 = v);
$parcel$export($f46ed4009cb9c1cd$exports, "renderToReadableStream", () => $f46ed4009cb9c1cd$export$7020a3240b287705, (v) => $f46ed4009cb9c1cd$export$7020a3240b287705 = v);
var $f46ed4009cb9c1cd$export$83d89fbfd8236492;
var $f46ed4009cb9c1cd$export$80e7718417253a51;
var $f46ed4009cb9c1cd$export$eb3a06aef9e6ee51;
var $f46ed4009cb9c1cd$export$307591e98609eddd;
var $f46ed4009cb9c1cd$export$b23711c915539651;
var $f46ed4009cb9c1cd$export$7020a3240b287705;
"use strict";
var $f46ed4009cb9c1cd$var$l, $f46ed4009cb9c1cd$var$s;

$f46ed4009cb9c1cd$var$l = (parcelRequire("sBxfj"));

$f46ed4009cb9c1cd$var$s = (parcelRequire("3odmW"));
$f46ed4009cb9c1cd$export$83d89fbfd8236492 = $f46ed4009cb9c1cd$var$l.version;
$f46ed4009cb9c1cd$export$80e7718417253a51 = $f46ed4009cb9c1cd$var$l.renderToString;
$f46ed4009cb9c1cd$export$eb3a06aef9e6ee51 = $f46ed4009cb9c1cd$var$l.renderToStaticMarkup;
$f46ed4009cb9c1cd$export$307591e98609eddd = $f46ed4009cb9c1cd$var$l.renderToNodeStream;
$f46ed4009cb9c1cd$export$b23711c915539651 = $f46ed4009cb9c1cd$var$l.renderToStaticNodeStream;
$f46ed4009cb9c1cd$export$7020a3240b287705 = $f46ed4009cb9c1cd$var$s.renderToReadableStream;


var $834328a1cfd2af33$exports = {};

$parcel$export($834328a1cfd2af33$exports, "Portal", () => $a4e89ae9835d0556$export$602eac185826482c);


var $eaec5fceb04f7d33$exports = {};

$parcel$export($eaec5fceb04f7d33$exports, "Combobox", () => $eaec5fceb04f7d33$export$27957ad87354dd7e);

var $acw62 = parcelRequire("acw62");

function $af43570ba0a8567e$export$7c73462e0d25e514(getDeps, fn, opts) {
    let deps = opts.initialDeps ?? [];
    let result;
    return ()=>{
        var _a, _b, _c, _d;
        let depTime;
        if (opts.key && ((_a = opts.debug) == null ? void 0 : _a.call(opts))) depTime = Date.now();
        const newDeps = getDeps();
        const depsChanged = newDeps.length !== deps.length || newDeps.some((dep, index)=>deps[index] !== dep);
        if (!depsChanged) return result;
        deps = newDeps;
        let resultTime;
        if (opts.key && ((_b = opts.debug) == null ? void 0 : _b.call(opts))) resultTime = Date.now();
        result = fn(...newDeps);
        if (opts.key && ((_c = opts.debug) == null ? void 0 : _c.call(opts))) {
            const depEndTime = Math.round((Date.now() - depTime) * 100) / 100;
            const resultEndTime = Math.round((Date.now() - resultTime) * 100) / 100;
            const resultFpsPercentage = resultEndTime / 16;
            const pad = (str, num)=>{
                str = String(str);
                while(str.length < num)str = " " + str;
                return str;
            };
            console.info(`%c\u{23F1} ${pad(resultEndTime, 5)} /${pad(depEndTime, 5)} ms`, `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(0, Math.min(120 - 120 * resultFpsPercentage, 120))}deg 100% 31%);`, opts == null ? void 0 : opts.key);
        }
        (_d = opts == null ? void 0 : opts.onChange) == null || _d.call(opts, result);
        return result;
    };
}
function $af43570ba0a8567e$export$9a1adf421b69c6a(value, msg) {
    if (value === void 0) throw new Error(`Unexpected undefined${msg ? `: ${msg}` : ""}`);
    else return value;
}
const $af43570ba0a8567e$export$8a4f1dcc58a69dbd = (a, b)=>Math.abs(a - b) < 1;


const $ae8077da5dad972b$export$76974b428a49f15b = (index)=>index;
const $ae8077da5dad972b$export$7eb7cb13fd21e5e1 = (range)=>{
    const start = Math.max(range.startIndex - range.overscan, 0);
    const end = Math.min(range.endIndex + range.overscan, range.count - 1);
    const arr = [];
    for(let i = start; i <= end; i++)arr.push(i);
    return arr;
};
const $ae8077da5dad972b$export$5a50ff2cde8c3802 = (instance, cb)=>{
    const element = instance.scrollElement;
    if (!element) return;
    const handler = (rect)=>{
        const { width: width, height: height } = rect;
        cb({
            width: Math.round(width),
            height: Math.round(height)
        });
    };
    handler(element.getBoundingClientRect());
    if (typeof ResizeObserver === "undefined") return ()=>{};
    const observer = new ResizeObserver((entries)=>{
        const entry = entries[0];
        if (entry == null ? void 0 : entry.borderBoxSize) {
            const box = entry.borderBoxSize[0];
            if (box) {
                handler({
                    width: box.inlineSize,
                    height: box.blockSize
                });
                return;
            }
        }
        handler(element.getBoundingClientRect());
    });
    observer.observe(element, {
        box: "border-box"
    });
    return ()=>{
        observer.unobserve(element);
    };
};
const $ae8077da5dad972b$export$e911b82c7a99311 = (instance, cb)=>{
    const element = instance.scrollElement;
    if (!element) return;
    const handler = ()=>{
        cb({
            width: element.innerWidth,
            height: element.innerHeight
        });
    };
    handler();
    element.addEventListener("resize", handler, {
        passive: true
    });
    return ()=>{
        element.removeEventListener("resize", handler);
    };
};
const $ae8077da5dad972b$export$fbc040aee017375a = (instance, cb)=>{
    const element = instance.scrollElement;
    if (!element) return;
    const handler = ()=>{
        cb(element[instance.options.horizontal ? "scrollLeft" : "scrollTop"]);
    };
    handler();
    element.addEventListener("scroll", handler, {
        passive: true
    });
    return ()=>{
        element.removeEventListener("scroll", handler);
    };
};
const $ae8077da5dad972b$export$518998f8c5d09287 = (instance, cb)=>{
    const element = instance.scrollElement;
    if (!element) return;
    const handler = ()=>{
        cb(element[instance.options.horizontal ? "scrollX" : "scrollY"]);
    };
    handler();
    element.addEventListener("scroll", handler, {
        passive: true
    });
    return ()=>{
        element.removeEventListener("scroll", handler);
    };
};
const $ae8077da5dad972b$export$6aa9c23c0f5932af = (element, entry, instance)=>{
    if (entry == null ? void 0 : entry.borderBoxSize) {
        const box = entry.borderBoxSize[0];
        if (box) {
            const size = Math.round(box[instance.options.horizontal ? "inlineSize" : "blockSize"]);
            return size;
        }
    }
    return Math.round(element.getBoundingClientRect()[instance.options.horizontal ? "width" : "height"]);
};
const $ae8077da5dad972b$export$2162c5b3eeedd27 = (offset, { adjustments: adjustments = 0, behavior: behavior }, instance)=>{
    var _a, _b;
    const toOffset = offset + adjustments;
    (_b = (_a = instance.scrollElement) == null ? void 0 : _a.scrollTo) == null || _b.call(_a, {
        [instance.options.horizontal ? "left" : "top"]: toOffset,
        behavior: behavior
    });
};
const $ae8077da5dad972b$export$1cdb988e5ab69fe7 = (offset, { adjustments: adjustments = 0, behavior: behavior }, instance)=>{
    var _a, _b;
    const toOffset = offset + adjustments;
    (_b = (_a = instance.scrollElement) == null ? void 0 : _a.scrollTo) == null || _b.call(_a, {
        [instance.options.horizontal ? "left" : "top"]: toOffset,
        behavior: behavior
    });
};
class $ae8077da5dad972b$export$89be5a243e59c4b2 {
    constructor(opts){
        this.unsubs = [];
        this.scrollElement = null;
        this.isScrolling = false;
        this.isScrollingTimeoutId = null;
        this.scrollToIndexTimeoutId = null;
        this.measurementsCache = [];
        this.itemSizeCache = /* @__PURE__ */ new Map();
        this.pendingMeasuredCacheIndexes = [];
        this.scrollDirection = null;
        this.scrollAdjustments = 0;
        this.measureElementCache = /* @__PURE__ */ new Map();
        this.observer = /* @__PURE__ */ (()=>{
            let _ro = null;
            const get = ()=>{
                if (_ro) return _ro;
                else if (typeof ResizeObserver !== "undefined") return _ro = new ResizeObserver((entries)=>{
                    entries.forEach((entry)=>{
                        this._measureElement(entry.target, entry);
                    });
                });
                else return null;
            };
            return {
                disconnect: ()=>{
                    var _a;
                    return (_a = get()) == null ? void 0 : _a.disconnect();
                },
                observe: (target)=>{
                    var _a;
                    return (_a = get()) == null ? void 0 : _a.observe(target, {
                        box: "border-box"
                    });
                },
                unobserve: (target)=>{
                    var _a;
                    return (_a = get()) == null ? void 0 : _a.unobserve(target);
                }
            };
        })();
        this.range = null;
        this.setOptions = (opts2)=>{
            Object.entries(opts2).forEach(([key, value])=>{
                if (typeof value === "undefined") delete opts2[key];
            });
            this.options = {
                debug: false,
                initialOffset: 0,
                overscan: 1,
                paddingStart: 0,
                paddingEnd: 0,
                scrollPaddingStart: 0,
                scrollPaddingEnd: 0,
                horizontal: false,
                getItemKey: $ae8077da5dad972b$export$76974b428a49f15b,
                rangeExtractor: $ae8077da5dad972b$export$7eb7cb13fd21e5e1,
                onChange: ()=>{},
                measureElement: $ae8077da5dad972b$export$6aa9c23c0f5932af,
                initialRect: {
                    width: 0,
                    height: 0
                },
                scrollMargin: 0,
                gap: 0,
                scrollingDelay: 150,
                indexAttribute: "data-index",
                initialMeasurementsCache: [],
                lanes: 1,
                ...opts2
            };
        };
        this.notify = (sync)=>{
            var _a, _b;
            (_b = (_a = this.options).onChange) == null || _b.call(_a, this, sync);
        };
        this.maybeNotify = (0, $af43570ba0a8567e$export$7c73462e0d25e514)(()=>{
            this.calculateRange();
            return [
                this.isScrolling,
                this.range ? this.range.startIndex : null,
                this.range ? this.range.endIndex : null
            ];
        }, (isScrolling)=>{
            this.notify(isScrolling);
        }, {
            key: false,
            debug: ()=>this.options.debug,
            initialDeps: [
                this.isScrolling,
                this.range ? this.range.startIndex : null,
                this.range ? this.range.endIndex : null
            ]
        });
        this.cleanup = ()=>{
            this.unsubs.filter(Boolean).forEach((d)=>d());
            this.unsubs = [];
            this.scrollElement = null;
        };
        this._didMount = ()=>{
            this.measureElementCache.forEach(this.observer.observe);
            return ()=>{
                this.observer.disconnect();
                this.cleanup();
            };
        };
        this._willUpdate = ()=>{
            const scrollElement = this.options.getScrollElement();
            if (this.scrollElement !== scrollElement) {
                this.cleanup();
                this.scrollElement = scrollElement;
                this._scrollToOffset(this.scrollOffset, {
                    adjustments: void 0,
                    behavior: void 0
                });
                this.unsubs.push(this.options.observeElementRect(this, (rect)=>{
                    this.scrollRect = rect;
                    this.maybeNotify();
                }));
                this.unsubs.push(this.options.observeElementOffset(this, (offset)=>{
                    this.scrollAdjustments = 0;
                    if (this.scrollOffset === offset) return;
                    if (this.isScrollingTimeoutId !== null) {
                        clearTimeout(this.isScrollingTimeoutId);
                        this.isScrollingTimeoutId = null;
                    }
                    this.isScrolling = true;
                    this.scrollDirection = this.scrollOffset < offset ? "forward" : "backward";
                    this.scrollOffset = offset;
                    this.maybeNotify();
                    this.isScrollingTimeoutId = setTimeout(()=>{
                        this.isScrollingTimeoutId = null;
                        this.isScrolling = false;
                        this.scrollDirection = null;
                        this.maybeNotify();
                    }, this.options.scrollingDelay);
                }));
            }
        };
        this.getSize = ()=>{
            return this.scrollRect[this.options.horizontal ? "width" : "height"];
        };
        this.memoOptions = (0, $af43570ba0a8567e$export$7c73462e0d25e514)(()=>[
                this.options.count,
                this.options.paddingStart,
                this.options.scrollMargin,
                this.options.getItemKey
            ], (count, paddingStart, scrollMargin, getItemKey)=>{
            this.pendingMeasuredCacheIndexes = [];
            return {
                count: count,
                paddingStart: paddingStart,
                scrollMargin: scrollMargin,
                getItemKey: getItemKey
            };
        }, {
            key: false
        });
        this.getFurthestMeasurement = (measurements, index)=>{
            const furthestMeasurementsFound = /* @__PURE__ */ new Map();
            const furthestMeasurements = /* @__PURE__ */ new Map();
            for(let m = index - 1; m >= 0; m--){
                const measurement = measurements[m];
                if (furthestMeasurementsFound.has(measurement.lane)) continue;
                const previousFurthestMeasurement = furthestMeasurements.get(measurement.lane);
                if (previousFurthestMeasurement == null || measurement.end > previousFurthestMeasurement.end) furthestMeasurements.set(measurement.lane, measurement);
                else if (measurement.end < previousFurthestMeasurement.end) furthestMeasurementsFound.set(measurement.lane, true);
                if (furthestMeasurementsFound.size === this.options.lanes) break;
            }
            return furthestMeasurements.size === this.options.lanes ? Array.from(furthestMeasurements.values()).sort((a, b)=>{
                if (a.end === b.end) return a.index - b.index;
                return a.end - b.end;
            })[0] : void 0;
        };
        this.getMeasurements = (0, $af43570ba0a8567e$export$7c73462e0d25e514)(()=>[
                this.memoOptions(),
                this.itemSizeCache
            ], ({ count: count, paddingStart: paddingStart, scrollMargin: scrollMargin, getItemKey: getItemKey }, itemSizeCache)=>{
            const min = this.pendingMeasuredCacheIndexes.length > 0 ? Math.min(...this.pendingMeasuredCacheIndexes) : 0;
            this.pendingMeasuredCacheIndexes = [];
            const measurements = this.measurementsCache.slice(0, min);
            for(let i = min; i < count; i++){
                const key = getItemKey(i);
                const furthestMeasurement = this.options.lanes === 1 ? measurements[i - 1] : this.getFurthestMeasurement(measurements, i);
                const start = furthestMeasurement ? furthestMeasurement.end + this.options.gap : paddingStart + scrollMargin;
                const measuredSize = itemSizeCache.get(key);
                const size = typeof measuredSize === "number" ? measuredSize : this.options.estimateSize(i);
                const end = start + size;
                const lane = furthestMeasurement ? furthestMeasurement.lane : i % this.options.lanes;
                measurements[i] = {
                    index: i,
                    start: start,
                    size: size,
                    end: end,
                    key: key,
                    lane: lane
                };
            }
            this.measurementsCache = measurements;
            return measurements;
        }, {
            key: false,
            debug: ()=>this.options.debug
        });
        this.calculateRange = (0, $af43570ba0a8567e$export$7c73462e0d25e514)(()=>[
                this.getMeasurements(),
                this.getSize(),
                this.scrollOffset
            ], (measurements, outerSize, scrollOffset)=>{
            return this.range = measurements.length > 0 && outerSize > 0 ? $ae8077da5dad972b$var$calculateRange({
                measurements: measurements,
                outerSize: outerSize,
                scrollOffset: scrollOffset
            }) : null;
        }, {
            key: false,
            debug: ()=>this.options.debug
        });
        this.getIndexes = (0, $af43570ba0a8567e$export$7c73462e0d25e514)(()=>[
                this.options.rangeExtractor,
                this.calculateRange(),
                this.options.overscan,
                this.options.count
            ], (rangeExtractor, range, overscan, count)=>{
            return range === null ? [] : rangeExtractor({
                ...range,
                overscan: overscan,
                count: count
            });
        }, {
            key: false,
            debug: ()=>this.options.debug
        });
        this.indexFromElement = (node)=>{
            const attributeName = this.options.indexAttribute;
            const indexStr = node.getAttribute(attributeName);
            if (!indexStr) {
                console.warn(`Missing attribute name '${attributeName}={index}' on measured element.`);
                return -1;
            }
            return parseInt(indexStr, 10);
        };
        this._measureElement = (node, entry)=>{
            const item = this.measurementsCache[this.indexFromElement(node)];
            if (!item || !node.isConnected) {
                this.measureElementCache.forEach((cached, key)=>{
                    if (cached === node) {
                        this.observer.unobserve(node);
                        this.measureElementCache.delete(key);
                    }
                });
                return;
            }
            const prevNode = this.measureElementCache.get(item.key);
            if (prevNode !== node) {
                if (prevNode) this.observer.unobserve(prevNode);
                this.observer.observe(node);
                this.measureElementCache.set(item.key, node);
            }
            const measuredItemSize = this.options.measureElement(node, entry, this);
            this.resizeItem(item, measuredItemSize);
        };
        this.resizeItem = (item, size)=>{
            const itemSize = this.itemSizeCache.get(item.key) ?? item.size;
            const delta = size - itemSize;
            if (delta !== 0) {
                if (item.start < this.scrollOffset + this.scrollAdjustments) this._scrollToOffset(this.scrollOffset, {
                    adjustments: this.scrollAdjustments += delta,
                    behavior: void 0
                });
                this.pendingMeasuredCacheIndexes.push(item.index);
                this.itemSizeCache = new Map(this.itemSizeCache.set(item.key, size));
                this.notify(false);
            }
        };
        this.measureElement = (node)=>{
            if (!node) return;
            this._measureElement(node, void 0);
        };
        this.getVirtualItems = (0, $af43570ba0a8567e$export$7c73462e0d25e514)(()=>[
                this.getIndexes(),
                this.getMeasurements()
            ], (indexes, measurements)=>{
            const virtualItems = [];
            for(let k = 0, len = indexes.length; k < len; k++){
                const i = indexes[k];
                const measurement = measurements[i];
                virtualItems.push(measurement);
            }
            return virtualItems;
        }, {
            key: false,
            debug: ()=>this.options.debug
        });
        this.getVirtualItemForOffset = (offset)=>{
            const measurements = this.getMeasurements();
            return (0, $af43570ba0a8567e$export$9a1adf421b69c6a)(measurements[$ae8077da5dad972b$var$findNearestBinarySearch(0, measurements.length - 1, (index)=>(0, $af43570ba0a8567e$export$9a1adf421b69c6a)(measurements[index]).start, offset)]);
        };
        this.getOffsetForAlignment = (toOffset, align)=>{
            const size = this.getSize();
            if (align === "auto") {
                if (toOffset <= this.scrollOffset) align = "start";
                else if (toOffset >= this.scrollOffset + size) align = "end";
                else align = "start";
            }
            if (align === "start") toOffset;
            else if (align === "end") toOffset = toOffset - size;
            else if (align === "center") toOffset = toOffset - size / 2;
            const scrollSizeProp = this.options.horizontal ? "scrollWidth" : "scrollHeight";
            const scrollSize = this.scrollElement ? "document" in this.scrollElement ? this.scrollElement.document.documentElement[scrollSizeProp] : this.scrollElement[scrollSizeProp] : 0;
            const maxOffset = scrollSize - this.getSize();
            return Math.max(Math.min(maxOffset, toOffset), 0);
        };
        this.getOffsetForIndex = (index, align = "auto")=>{
            index = Math.max(0, Math.min(index, this.options.count - 1));
            const measurement = (0, $af43570ba0a8567e$export$9a1adf421b69c6a)(this.getMeasurements()[index]);
            if (align === "auto") {
                if (measurement.end >= this.scrollOffset + this.getSize() - this.options.scrollPaddingEnd) align = "end";
                else if (measurement.start <= this.scrollOffset + this.options.scrollPaddingStart) align = "start";
                else return [
                    this.scrollOffset,
                    align
                ];
            }
            const toOffset = align === "end" ? measurement.end + this.options.scrollPaddingEnd : measurement.start - this.options.scrollPaddingStart;
            return [
                this.getOffsetForAlignment(toOffset, align),
                align
            ];
        };
        this.isDynamicMode = ()=>this.measureElementCache.size > 0;
        this.cancelScrollToIndex = ()=>{
            if (this.scrollToIndexTimeoutId !== null) {
                clearTimeout(this.scrollToIndexTimeoutId);
                this.scrollToIndexTimeoutId = null;
            }
        };
        this.scrollToOffset = (toOffset, { align: align = "start", behavior: behavior } = {})=>{
            this.cancelScrollToIndex();
            if (behavior === "smooth" && this.isDynamicMode()) console.warn("The `smooth` scroll behavior is not fully supported with dynamic size.");
            this._scrollToOffset(this.getOffsetForAlignment(toOffset, align), {
                adjustments: void 0,
                behavior: behavior
            });
        };
        this.scrollToIndex = (index, { align: initialAlign = "auto", behavior: behavior } = {})=>{
            index = Math.max(0, Math.min(index, this.options.count - 1));
            this.cancelScrollToIndex();
            if (behavior === "smooth" && this.isDynamicMode()) console.warn("The `smooth` scroll behavior is not fully supported with dynamic size.");
            const [toOffset, align] = this.getOffsetForIndex(index, initialAlign);
            this._scrollToOffset(toOffset, {
                adjustments: void 0,
                behavior: behavior
            });
            if (behavior !== "smooth" && this.isDynamicMode()) this.scrollToIndexTimeoutId = setTimeout(()=>{
                this.scrollToIndexTimeoutId = null;
                const elementInDOM = this.measureElementCache.has(this.options.getItemKey(index));
                if (elementInDOM) {
                    const [toOffset2] = this.getOffsetForIndex(index, align);
                    if (!(0, $af43570ba0a8567e$export$8a4f1dcc58a69dbd)(toOffset2, this.scrollOffset)) this.scrollToIndex(index, {
                        align: align,
                        behavior: behavior
                    });
                } else this.scrollToIndex(index, {
                    align: align,
                    behavior: behavior
                });
            });
        };
        this.scrollBy = (delta, { behavior: behavior } = {})=>{
            this.cancelScrollToIndex();
            if (behavior === "smooth" && this.isDynamicMode()) console.warn("The `smooth` scroll behavior is not fully supported with dynamic size.");
            this._scrollToOffset(this.scrollOffset + delta, {
                adjustments: void 0,
                behavior: behavior
            });
        };
        this.getTotalSize = ()=>{
            var _a;
            const measurements = this.getMeasurements();
            let end;
            if (measurements.length === 0) end = this.options.paddingStart;
            else end = this.options.lanes === 1 ? ((_a = measurements[measurements.length - 1]) == null ? void 0 : _a.end) ?? 0 : Math.max(...measurements.slice(-this.options.lanes).map((m)=>m.end));
            return end - this.options.scrollMargin + this.options.paddingEnd;
        };
        this._scrollToOffset = (offset, { adjustments: adjustments, behavior: behavior })=>{
            this.options.scrollToFn(offset, {
                behavior: behavior,
                adjustments: adjustments
            }, this);
        };
        this.measure = ()=>{
            this.itemSizeCache = /* @__PURE__ */ new Map();
            this.notify(false);
        };
        this.setOptions(opts);
        this.scrollRect = this.options.initialRect;
        this.scrollOffset = this.options.initialOffset;
        this.measurementsCache = this.options.initialMeasurementsCache;
        this.measurementsCache.forEach((item)=>{
            this.itemSizeCache.set(item.key, item.size);
        });
        this.maybeNotify();
    }
}
const $ae8077da5dad972b$var$findNearestBinarySearch = (low, high, getCurrentValue, value)=>{
    while(low <= high){
        const middle = (low + high) / 2 | 0;
        const currentValue = getCurrentValue(middle);
        if (currentValue < value) low = middle + 1;
        else if (currentValue > value) high = middle - 1;
        else return middle;
    }
    if (low > 0) return low - 1;
    else return 0;
};
function $ae8077da5dad972b$var$calculateRange({ measurements: measurements, outerSize: outerSize, scrollOffset: scrollOffset }) {
    const count = measurements.length - 1;
    const getOffset = (index)=>measurements[index].start;
    const startIndex = $ae8077da5dad972b$var$findNearestBinarySearch(0, count, getOffset, scrollOffset);
    let endIndex = startIndex;
    while(endIndex < count && measurements[endIndex].end < scrollOffset + outerSize)endIndex++;
    return {
        startIndex: startIndex,
        endIndex: endIndex
    };
}


const $64d08e094a93fa77$var$useIsomorphicLayoutEffect = typeof document !== "undefined" ? $acw62.useLayoutEffect : $acw62.useEffect;
function $64d08e094a93fa77$var$useVirtualizerBase(options) {
    const rerender = $acw62.useReducer(()=>({}), {})[1];
    const resolvedOptions = {
        ...options,
        onChange: (instance2, sync)=>{
            var _a;
            if (sync) (0, $11492dca620dcaa5$exports.flushSync)(rerender);
            else rerender();
            (_a = options.onChange) == null || _a.call(options, instance2, sync);
        }
    };
    const [instance] = $acw62.useState(()=>new (0, $ae8077da5dad972b$export$89be5a243e59c4b2)(resolvedOptions));
    instance.setOptions(resolvedOptions);
    $acw62.useEffect(()=>{
        return instance._didMount();
    }, []);
    $64d08e094a93fa77$var$useIsomorphicLayoutEffect(()=>{
        return instance._willUpdate();
    });
    return instance;
}
function $64d08e094a93fa77$export$dd6d526d88b5a137(options) {
    return $64d08e094a93fa77$var$useVirtualizerBase({
        observeElementRect: $ae8077da5dad972b$export$5a50ff2cde8c3802,
        observeElementOffset: $ae8077da5dad972b$export$fbc040aee017375a,
        scrollToFn: (0, $ae8077da5dad972b$export$1cdb988e5ab69fe7),
        ...options
    });
}
function $64d08e094a93fa77$export$645722dcac657cb9(options) {
    return $64d08e094a93fa77$var$useVirtualizerBase({
        getScrollElement: ()=>typeof document !== "undefined" ? window : null,
        observeElementRect: (0, $ae8077da5dad972b$export$e911b82c7a99311),
        observeElementOffset: (0, $ae8077da5dad972b$export$518998f8c5d09287),
        scrollToFn: (0, $ae8077da5dad972b$export$2162c5b3eeedd27),
        initialOffset: typeof document !== "undefined" ? window.scrollY : void 0,
        ...options
    });
}



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");


function $d78e56d87e9d66e2$export$e3d20747ab930783(e, o) {
    let [u, t] = (0, $acw62.useState)(e), r = (0, $fa1923261638cacc$export$86c4283a11f23f95)(e);
    return (0, $65df95ec9b1bb6a8$export$ce5ed857c741fd71)(()=>t(r.current), [
        r,
        t,
        ...o
    ]), u;
}



var $acw62 = parcelRequire("acw62");

function $c6676ed1f400443a$export$454217e89aea72b(l, r, c) {
    let [i, s] = (0, $acw62.useState)(c), e = l !== void 0, t = (0, $acw62.useRef)(e), u = (0, $acw62.useRef)(!1), d = (0, $acw62.useRef)(!1);
    return e && !t.current && !u.current ? (u.current = !0, t.current = e, console.error("A component is changing from uncontrolled to controlled. This may be caused by the value changing from undefined to a defined value, which should not happen.")) : !e && t.current && !d.current && (d.current = !0, t.current = e, console.error("A component is changing from controlled to uncontrolled. This may be caused by the value changing from a defined value to undefined, which should not happen.")), [
        e ? l : i,
        (0, $0bd9972698c32399$export$90fc3a17d93f704c)((n)=>(e || s(n), r == null ? void 0 : r(n)))
    ];
}














var $acw62 = parcelRequire("acw62");

function $fc465b9f88c2456a$export$3c773aa2b84f29e0(u, t) {
    let e = (0, $acw62.useRef)([]), r = (0, $0bd9972698c32399$export$90fc3a17d93f704c)(u);
    (0, $acw62.useEffect)(()=>{
        let o = [
            ...e.current
        ];
        for (let [n, a] of t.entries())if (e.current[n] !== a) {
            let l = r(t, o);
            return e.current = t, l;
        }
    }, [
        r,
        ...t
    ]);
}




function $d807a76564ed2203$export$a6a2315df743a26b(n) {
    function e() {
        document.readyState !== "loading" && (n(), document.removeEventListener("DOMContentLoaded", e));
    }
    typeof window != "undefined" && typeof document != "undefined" && (document.addEventListener("DOMContentLoaded", e), e());
}


let $1e76a1cad0cb58a8$export$55abd4691b317664 = [];
(0, $d807a76564ed2203$export$a6a2315df743a26b)(()=>{
    function e(n) {
        n.target instanceof HTMLElement && n.target !== document.body && $1e76a1cad0cb58a8$export$55abd4691b317664[0] !== n.target && ($1e76a1cad0cb58a8$export$55abd4691b317664.unshift(n.target), $1e76a1cad0cb58a8$export$55abd4691b317664 = $1e76a1cad0cb58a8$export$55abd4691b317664.filter((r)=>r != null && r.isConnected), $1e76a1cad0cb58a8$export$55abd4691b317664.splice(10));
    }
    window.addEventListener("click", e, {
        capture: !0
    }), window.addEventListener("mousedown", e, {
        capture: !0
    }), window.addEventListener("focus", e, {
        capture: !0
    }), document.body.addEventListener("click", e, {
        capture: !0
    }), document.body.addEventListener("mousedown", e, {
        capture: !0
    }), document.body.addEventListener("focus", e, {
        capture: !0
    });
});






function $594e79751740d704$export$bc22b3e852574dab(i = {}, s = null, t = []) {
    for (let [r, n] of Object.entries(i))$594e79751740d704$var$o(t, $594e79751740d704$var$f(s, r), n);
    return t;
}
function $594e79751740d704$var$f(i, s) {
    return i ? i + "[" + s + "]" : s;
}
function $594e79751740d704$var$o(i, s, t) {
    if (Array.isArray(t)) for (let [r, n] of t.entries())$594e79751740d704$var$o(i, $594e79751740d704$var$f(s, r.toString()), n);
    else t instanceof Date ? i.push([
        s,
        t.toISOString()
    ]) : typeof t == "boolean" ? i.push([
        s,
        t ? "1" : "0"
    ]) : typeof t == "string" ? i.push([
        s,
        t
    ]) : typeof t == "number" ? i.push([
        s,
        `${t}`
    ]) : t == null ? i.push([
        s,
        ""
    ]) : $594e79751740d704$export$bc22b3e852574dab(t, s, i);
}
function $594e79751740d704$export$ee02894bdc79dd36(i) {
    var t, r;
    let s = (t = i == null ? void 0 : i.form) != null ? t : i.closest("form");
    if (s) {
        for (let n of s.elements)if (n !== i && (n.tagName === "INPUT" && n.type === "submit" || n.tagName === "BUTTON" && n.type === "submit" || n.nodeName === "INPUT" && n.type === "image")) {
            n.click();
            return;
        }
        (r = s.requestSubmit) == null || r.call(s);
    }
}







var $hPtJY = parcelRequire("hPtJY");
var $eaec5fceb04f7d33$var$$e = ((o)=>(o[o.Open = 0] = "Open", o[o.Closed = 1] = "Closed", o))($eaec5fceb04f7d33$var$$e || {}), $eaec5fceb04f7d33$var$qe = ((o)=>(o[o.Single = 0] = "Single", o[o.Multi = 1] = "Multi", o))($eaec5fceb04f7d33$var$qe || {}), $eaec5fceb04f7d33$var$ze = ((a)=>(a[a.Pointer = 0] = "Pointer", a[a.Focus = 1] = "Focus", a[a.Other = 2] = "Other", a))($eaec5fceb04f7d33$var$ze || {}), $eaec5fceb04f7d33$var$Ye = ((e)=>(e[e.OpenCombobox = 0] = "OpenCombobox", e[e.CloseCombobox = 1] = "CloseCombobox", e[e.GoToOption = 2] = "GoToOption", e[e.RegisterOption = 3] = "RegisterOption", e[e.UnregisterOption = 4] = "UnregisterOption", e[e.RegisterLabel = 5] = "RegisterLabel", e[e.SetActivationTrigger = 6] = "SetActivationTrigger", e[e.UpdateVirtualOptions = 7] = "UpdateVirtualOptions", e))($eaec5fceb04f7d33$var$Ye || {});
function $eaec5fceb04f7d33$var$de(t, r = (o)=>o) {
    let o = t.activeOptionIndex !== null ? t.options[t.activeOptionIndex] : null, a = r(t.options.slice()), i = a.length > 0 && a[0].dataRef.current.order !== null ? a.sort((p, c)=>p.dataRef.current.order - c.dataRef.current.order) : (0, $cb6dceb64e6c0606$export$20305e96f91bf103)(a, (p)=>p.dataRef.current.domRef.current), u = o ? i.indexOf(o) : null;
    return u === -1 && (u = null), {
        options: i,
        activeOptionIndex: u
    };
}
let $eaec5fceb04f7d33$var$Qe = {
    [1] (t) {
        var r;
        return (r = t.dataRef.current) != null && r.disabled || t.comboboxState === 1 ? t : {
            ...t,
            activeOptionIndex: null,
            comboboxState: 1
        };
    },
    [0] (t) {
        var r, o;
        if ((r = t.dataRef.current) != null && r.disabled || t.comboboxState === 0) return t;
        if ((o = t.dataRef.current) != null && o.value) {
            let a = t.dataRef.current.calculateIndex(t.dataRef.current.value);
            if (a !== -1) return {
                ...t,
                activeOptionIndex: a,
                comboboxState: 0
            };
        }
        return {
            ...t,
            comboboxState: 0
        };
    },
    [2] (t, r) {
        var u, p, c, e, l;
        if ((u = t.dataRef.current) != null && u.disabled || (p = t.dataRef.current) != null && p.optionsRef.current && !((c = t.dataRef.current) != null && c.optionsPropsRef.current.static) && t.comboboxState === 1) return t;
        if (t.virtual) {
            let T = r.focus === (0, $b7a0b87cd8a0fa3d$export$807a7eae502106e7).Specific ? r.idx : (0, $b7a0b87cd8a0fa3d$export$c6b4626b54936d5e)(r, {
                resolveItems: ()=>t.virtual.options,
                resolveActiveIndex: ()=>{
                    var f, v;
                    return (v = (f = t.activeOptionIndex) != null ? f : t.virtual.options.findIndex((S)=>!t.virtual.disabled(S))) != null ? v : null;
                },
                resolveDisabled: t.virtual.disabled,
                resolveId () {
                    throw new Error("Function not implemented.");
                }
            }), g = (e = r.trigger) != null ? e : 2;
            return t.activeOptionIndex === T && t.activationTrigger === g ? t : {
                ...t,
                activeOptionIndex: T,
                activationTrigger: g
            };
        }
        let o = $eaec5fceb04f7d33$var$de(t);
        if (o.activeOptionIndex === null) {
            let T = o.options.findIndex((g)=>!g.dataRef.current.disabled);
            T !== -1 && (o.activeOptionIndex = T);
        }
        let a = r.focus === (0, $b7a0b87cd8a0fa3d$export$807a7eae502106e7).Specific ? r.idx : (0, $b7a0b87cd8a0fa3d$export$c6b4626b54936d5e)(r, {
            resolveItems: ()=>o.options,
            resolveActiveIndex: ()=>o.activeOptionIndex,
            resolveId: (T)=>T.id,
            resolveDisabled: (T)=>T.dataRef.current.disabled
        }), i = (l = r.trigger) != null ? l : 2;
        return t.activeOptionIndex === a && t.activationTrigger === i ? t : {
            ...t,
            ...o,
            activeOptionIndex: a,
            activationTrigger: i
        };
    },
    [3]: (t, r)=>{
        var u, p, c;
        if ((u = t.dataRef.current) != null && u.virtual) return {
            ...t,
            options: [
                ...t.options,
                r.payload
            ]
        };
        let o = r.payload, a = $eaec5fceb04f7d33$var$de(t, (e)=>(e.push(o), e));
        t.activeOptionIndex === null && (p = t.dataRef.current) != null && p.isSelected(r.payload.dataRef.current.value) && (a.activeOptionIndex = a.options.indexOf(o));
        let i = {
            ...t,
            ...a,
            activationTrigger: 2
        };
        return (c = t.dataRef.current) != null && c.__demoMode && t.dataRef.current.value === void 0 && (i.activeOptionIndex = 0), i;
    },
    [4]: (t, r)=>{
        var a;
        if ((a = t.dataRef.current) != null && a.virtual) return {
            ...t,
            options: t.options.filter((i)=>i.id !== r.id)
        };
        let o = $eaec5fceb04f7d33$var$de(t, (i)=>{
            let u = i.findIndex((p)=>p.id === r.id);
            return u !== -1 && i.splice(u, 1), i;
        });
        return {
            ...t,
            ...o,
            activationTrigger: 2
        };
    },
    [5]: (t, r)=>t.labelId === r.id ? t : {
            ...t,
            labelId: r.id
        },
    [6]: (t, r)=>t.activationTrigger === r.trigger ? t : {
            ...t,
            activationTrigger: r.trigger
        },
    [7]: (t, r)=>{
        var a;
        if (((a = t.virtual) == null ? void 0 : a.options) === r.options) return t;
        let o = t.activeOptionIndex;
        if (t.activeOptionIndex !== null) {
            let i = r.options.indexOf(t.virtual.options[t.activeOptionIndex]);
            i !== -1 ? o = i : o = null;
        }
        return {
            ...t,
            activeOptionIndex: o,
            virtual: Object.assign({}, t.virtual, {
                options: r.options
            })
        };
    }
}, $eaec5fceb04f7d33$var$be = (0, $acw62.createContext)(null);
$eaec5fceb04f7d33$var$be.displayName = "ComboboxActionsContext";
function $eaec5fceb04f7d33$var$ee(t) {
    let r = (0, $acw62.useContext)($eaec5fceb04f7d33$var$be);
    if (r === null) {
        let o = new Error(`<${t} /> is missing a parent <Combobox /> component.`);
        throw Error.captureStackTrace && Error.captureStackTrace(o, $eaec5fceb04f7d33$var$ee), o;
    }
    return r;
}
let $eaec5fceb04f7d33$var$Ce = (0, $acw62.createContext)(null);
function $eaec5fceb04f7d33$var$Ze(t) {
    var c;
    let r = $eaec5fceb04f7d33$var$j("VirtualProvider"), [o, a] = (0, $acw62.useMemo)(()=>{
        let e = r.optionsRef.current;
        if (!e) return [
            0,
            0
        ];
        let l = window.getComputedStyle(e);
        return [
            parseFloat(l.paddingBlockStart || l.paddingTop),
            parseFloat(l.paddingBlockEnd || l.paddingBottom)
        ];
    }, [
        r.optionsRef.current
    ]), i = (0, $64d08e094a93fa77$export$dd6d526d88b5a137)({
        scrollPaddingStart: o,
        scrollPaddingEnd: a,
        count: r.virtual.options.length,
        estimateSize () {
            return 40;
        },
        getScrollElement () {
            var e;
            return (e = r.optionsRef.current) != null ? e : null;
        },
        overscan: 12
    }), [u, p] = (0, $acw62.useState)(0);
    return (0, $65df95ec9b1bb6a8$export$ce5ed857c741fd71)(()=>{
        p((e)=>e + 1);
    }, [
        (c = r.virtual) == null ? void 0 : c.options
    ]), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($eaec5fceb04f7d33$var$Ce.Provider, {
        value: i
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            position: "relative",
            width: "100%",
            height: `${i.getTotalSize()}px`
        },
        ref: (e)=>{
            if (e) {
                if (typeof $hPtJY, r.activationTrigger === 0) return;
                r.activeOptionIndex !== null && r.virtual.options.length > r.activeOptionIndex && i.scrollToIndex(r.activeOptionIndex);
            }
        }
    }, i.getVirtualItems().map((e)=>{
        var l;
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $acw62.Fragment), {
            key: e.key
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement((l = t.children) == null ? void 0 : l.call(t, {
            option: r.virtual.options[e.index],
            open: r.comboboxState === 0
        }), {
            key: `${u}-${e.key}`,
            "data-index": e.index,
            "aria-setsize": r.virtual.options.length,
            "aria-posinset": e.index + 1,
            style: {
                position: "absolute",
                top: 0,
                left: 0,
                transform: `translateY(${e.start}px)`,
                overflowAnchor: "none"
            }
        }));
    })));
}
let $eaec5fceb04f7d33$var$ce = (0, $acw62.createContext)(null);
$eaec5fceb04f7d33$var$ce.displayName = "ComboboxDataContext";
function $eaec5fceb04f7d33$var$j(t) {
    let r = (0, $acw62.useContext)($eaec5fceb04f7d33$var$ce);
    if (r === null) {
        let o = new Error(`<${t} /> is missing a parent <Combobox /> component.`);
        throw Error.captureStackTrace && Error.captureStackTrace(o, $eaec5fceb04f7d33$var$j), o;
    }
    return r;
}
function $eaec5fceb04f7d33$var$et(t, r) {
    return (0, $4f240e1aafd2c298$export$4659b591c19bdf3d)(r.type, $eaec5fceb04f7d33$var$Qe, t, r);
}
let $eaec5fceb04f7d33$var$tt = (0, $acw62.Fragment);
function $eaec5fceb04f7d33$var$ot(t, r) {
    var fe;
    let { value: o, defaultValue: a, onChange: i, form: u, name: p, by: c = null, disabled: e = !1, __demoMode: l = !1, nullable: T = !1, multiple: g = !1, immediate: f = !1, virtual: v = null, ...S } = t, R = !1, s = null, [I = g ? [] : void 0, V] = (0, $c6676ed1f400443a$export$454217e89aea72b)(o, i, a), [_, E] = (0, $acw62.useReducer)($eaec5fceb04f7d33$var$et, {
        dataRef: (0, $acw62.createRef)(),
        comboboxState: l ? 0 : 1,
        options: [],
        virtual: s ? {
            options: s.options,
            disabled: (fe = s.disabled) != null ? fe : ()=>!1
        } : null,
        activeOptionIndex: null,
        activationTrigger: 2,
        labelId: null
    }), k = (0, $acw62.useRef)(!1), J = (0, $acw62.useRef)({
        static: !1,
        hold: !1
    }), K = (0, $acw62.useRef)(null), z = (0, $acw62.useRef)(null), te = (0, $acw62.useRef)(null), X = (0, $acw62.useRef)(null), x = (0, $0bd9972698c32399$export$90fc3a17d93f704c)(typeof c == "string" ? (d, b)=>{
        let P = c;
        return (d == null ? void 0 : d[P]) === (b == null ? void 0 : b[P]);
    } : c != null ? c : (d, b)=>d === b), O = (0, $0bd9972698c32399$export$90fc3a17d93f704c)((d)=>s ? c === null ? s.options.indexOf(d) : s.options.findIndex((b)=>x(b, d)) : _.options.findIndex((b)=>x(b.dataRef.current.value, d))), L = (0, $acw62.useCallback)((d)=>(0, $4f240e1aafd2c298$export$4659b591c19bdf3d)(n.mode, {
            [1]: ()=>I.some((b)=>x(b, d)),
            [0]: ()=>x(I, d)
        }), [
        I
    ]), oe = (0, $0bd9972698c32399$export$90fc3a17d93f704c)((d)=>_.activeOptionIndex === O(d)), n = (0, $acw62.useMemo)(()=>({
            ..._,
            immediate: R,
            optionsPropsRef: J,
            labelRef: K,
            inputRef: z,
            buttonRef: te,
            optionsRef: X,
            value: I,
            defaultValue: a,
            disabled: e,
            mode: g ? 1 : 0,
            virtual: _.virtual,
            get activeOptionIndex () {
                if (k.current && _.activeOptionIndex === null && (s ? s.options.length > 0 : _.options.length > 0)) {
                    if (s) {
                        let b = s.options.findIndex((P)=>{
                            var G, Y;
                            return !((Y = (G = s == null ? void 0 : s.disabled) == null ? void 0 : G.call(s, P)) != null && Y);
                        });
                        if (b !== -1) return b;
                    }
                    let d = _.options.findIndex((b)=>!b.dataRef.current.disabled);
                    if (d !== -1) return d;
                }
                return _.activeOptionIndex;
            },
            calculateIndex: O,
            compare: x,
            isSelected: L,
            isActive: oe,
            nullable: T,
            __demoMode: l
        }), [
        I,
        a,
        e,
        g,
        T,
        l,
        _,
        s
    ]);
    (0, $65df95ec9b1bb6a8$export$ce5ed857c741fd71)(()=>{
        s && E({
            type: 7,
            options: s.options
        });
    }, [
        s,
        s == null ? void 0 : s.options
    ]), (0, $65df95ec9b1bb6a8$export$ce5ed857c741fd71)(()=>{
        _.dataRef.current = n;
    }, [
        n
    ]), (0, $17eff26b89e4b024$export$71b2224f1ce5e08e)([
        n.buttonRef,
        n.inputRef,
        n.optionsRef
    ], ()=>le.closeCombobox(), n.comboboxState === 0);
    let F = (0, $acw62.useMemo)(()=>{
        var d, b, P;
        return {
            open: n.comboboxState === 0,
            disabled: e,
            activeIndex: n.activeOptionIndex,
            activeOption: n.activeOptionIndex === null ? null : n.virtual ? n.virtual.options[(d = n.activeOptionIndex) != null ? d : 0] : (P = (b = n.options[n.activeOptionIndex]) == null ? void 0 : b.dataRef.current.value) != null ? P : null,
            value: I
        };
    }, [
        n,
        e,
        I
    ]), A = (0, $0bd9972698c32399$export$90fc3a17d93f704c)(()=>{
        if (n.activeOptionIndex !== null) {
            if (n.virtual) ae(n.virtual.options[n.activeOptionIndex]);
            else {
                let { dataRef: d } = n.options[n.activeOptionIndex];
                ae(d.current.value);
            }
            le.goToOption((0, $b7a0b87cd8a0fa3d$export$807a7eae502106e7).Specific, n.activeOptionIndex);
        }
    }), h = (0, $0bd9972698c32399$export$90fc3a17d93f704c)(()=>{
        E({
            type: 0
        }), k.current = !0;
    }), C = (0, $0bd9972698c32399$export$90fc3a17d93f704c)(()=>{
        E({
            type: 1
        }), k.current = !1;
    }), D = (0, $0bd9972698c32399$export$90fc3a17d93f704c)((d, b, P)=>(k.current = !1, d === (0, $b7a0b87cd8a0fa3d$export$807a7eae502106e7).Specific ? E({
            type: 2,
            focus: (0, $b7a0b87cd8a0fa3d$export$807a7eae502106e7).Specific,
            idx: b,
            trigger: P
        }) : E({
            type: 2,
            focus: d,
            trigger: P
        }))), N = (0, $0bd9972698c32399$export$90fc3a17d93f704c)((d, b)=>(E({
            type: 3,
            payload: {
                id: d,
                dataRef: b
            }
        }), ()=>{
            n.isActive(b.current.value) && (k.current = !0), E({
                type: 4,
                id: d
            });
        })), ye = (0, $0bd9972698c32399$export$90fc3a17d93f704c)((d)=>(E({
            type: 5,
            id: d
        }), ()=>E({
                type: 5,
                id: null
            }))), ae = (0, $0bd9972698c32399$export$90fc3a17d93f704c)((d)=>(0, $4f240e1aafd2c298$export$4659b591c19bdf3d)(n.mode, {
            [0] () {
                return V == null ? void 0 : V(d);
            },
            [1] () {
                let b = n.value.slice(), P = b.findIndex((G)=>x(G, d));
                return P === -1 ? b.push(d) : b.splice(P, 1), V == null ? void 0 : V(b);
            }
        })), Re = (0, $0bd9972698c32399$export$90fc3a17d93f704c)((d)=>{
        E({
            type: 6,
            trigger: d
        });
    }), le = (0, $acw62.useMemo)(()=>({
            onChange: ae,
            registerOption: N,
            registerLabel: ye,
            goToOption: D,
            closeCombobox: C,
            openCombobox: h,
            setActivationTrigger: Re,
            selectActiveOption: A
        }), []), Ae = r === null ? {} : {
        ref: r
    }, ne = (0, $acw62.useRef)(null), Se = (0, $410e668b7f520622$export$fd183955ff4b45d9)();
    return (0, $acw62.useEffect)(()=>{
        ne.current && a !== void 0 && Se.addEventListener(ne.current, "reset", ()=>{
            V == null || V(a);
        });
    }, [
        ne,
        V
    ]), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($eaec5fceb04f7d33$var$be.Provider, {
        value: le
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($eaec5fceb04f7d33$var$ce.Provider, {
        value: n
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7a3499b4b3c6f184$export$2a0ed818b175f558), {
        value: (0, $4f240e1aafd2c298$export$4659b591c19bdf3d)(n.comboboxState, {
            [0]: (0, $7a3499b4b3c6f184$export$7254cc27399e90bd).Open,
            [1]: (0, $7a3499b4b3c6f184$export$7254cc27399e90bd).Closed
        })
    }, p != null && I != null && (0, $594e79751740d704$export$bc22b3e852574dab)({
        [p]: I
    }).map(([d, b], P)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $eac0d614a77ee96b$export$8dc98ba7eadeaa56), {
            features: (0, $eac0d614a77ee96b$export$617d79dae526d2cf).Hidden,
            ref: P === 0 ? (G)=>{
                var Y;
                ne.current = (Y = G == null ? void 0 : G.closest("form")) != null ? Y : null;
            } : void 0,
            ...(0, $a54bdd13402af126$export$8e16b83750b44988)({
                key: d,
                as: "input",
                type: "hidden",
                hidden: !0,
                readOnly: !0,
                form: u,
                name: d,
                value: b
            })
        })), (0, $a54bdd13402af126$export$b3890eb0ae9dca99)({
        ourProps: Ae,
        theirProps: S,
        slot: F,
        defaultTag: $eaec5fceb04f7d33$var$tt,
        name: "Combobox"
    }))));
}
let $eaec5fceb04f7d33$var$nt = "input";
function $eaec5fceb04f7d33$var$rt(t, r) {
    var X, x, O, L, oe;
    let o = (0, $f2a0dea4caee12c6$export$f680877a34711e37)(), { id: a = `headlessui-combobox-input-${o}`, onChange: i, displayValue: u, type: p = "text", ...c } = t, e = $eaec5fceb04f7d33$var$j("Combobox.Input"), l = $eaec5fceb04f7d33$var$ee("Combobox.Input"), T = (0, $4a1854c6a3ad5196$export$f6a25a78204acc7e)(e.inputRef, r), g = (0, $42a08b28a285ca8e$export$dd9fbcea3de0ae36)(e.inputRef), f = (0, $acw62.useRef)(!1), v = (0, $410e668b7f520622$export$fd183955ff4b45d9)(), S = (0, $0bd9972698c32399$export$90fc3a17d93f704c)(()=>{
        l.onChange(null), e.optionsRef.current && (e.optionsRef.current.scrollTop = 0), l.goToOption((0, $b7a0b87cd8a0fa3d$export$807a7eae502106e7).Nothing);
    }), R = function() {
        var n;
        return typeof u == "function" && e.value !== void 0 ? (n = u(e.value)) != null ? n : "" : typeof e.value == "string" ? e.value : "";
    }();
    (0, $fc465b9f88c2456a$export$3c773aa2b84f29e0)(([n, F], [A, h])=>{
        if (f.current) return;
        let C = e.inputRef.current;
        C && ((h === 0 && F === 1 || n !== A) && (C.value = n), requestAnimationFrame(()=>{
            if (f.current || !C || (g == null ? void 0 : g.activeElement) !== C) return;
            let { selectionStart: D, selectionEnd: N } = C;
            Math.abs((N != null ? N : 0) - (D != null ? D : 0)) === 0 && D === 0 && C.setSelectionRange(C.value.length, C.value.length);
        }));
    }, [
        R,
        e.comboboxState,
        g
    ]), (0, $fc465b9f88c2456a$export$3c773aa2b84f29e0)(([n], [F])=>{
        if (n === 0 && F === 1) {
            if (f.current) return;
            let A = e.inputRef.current;
            if (!A) return;
            let h = A.value, { selectionStart: C, selectionEnd: D, selectionDirection: N } = A;
            A.value = "", A.value = h, N !== null ? A.setSelectionRange(C, D, N) : A.setSelectionRange(C, D);
        }
    }, [
        e.comboboxState
    ]);
    let s = (0, $acw62.useRef)(!1), I = (0, $0bd9972698c32399$export$90fc3a17d93f704c)(()=>{
        s.current = !0;
    }), V = (0, $0bd9972698c32399$export$90fc3a17d93f704c)(()=>{
        v.nextFrame(()=>{
            s.current = !1;
        });
    }), _ = (0, $0bd9972698c32399$export$90fc3a17d93f704c)((n)=>{
        switch(f.current = !0, n.key){
            case (0, $4cca0dbc68b0507a$export$4b0075e5ea5e1f26).Enter:
                if (f.current = !1, e.comboboxState !== 0 || s.current) return;
                if (n.preventDefault(), n.stopPropagation(), e.activeOptionIndex === null) {
                    l.closeCombobox();
                    return;
                }
                l.selectActiveOption(), e.mode === 0 && l.closeCombobox();
                break;
            case (0, $4cca0dbc68b0507a$export$4b0075e5ea5e1f26).ArrowDown:
                return f.current = !1, n.preventDefault(), n.stopPropagation(), (0, $4f240e1aafd2c298$export$4659b591c19bdf3d)(e.comboboxState, {
                    [0]: ()=>l.goToOption((0, $b7a0b87cd8a0fa3d$export$807a7eae502106e7).Next),
                    [1]: ()=>l.openCombobox()
                });
            case (0, $4cca0dbc68b0507a$export$4b0075e5ea5e1f26).ArrowUp:
                return f.current = !1, n.preventDefault(), n.stopPropagation(), (0, $4f240e1aafd2c298$export$4659b591c19bdf3d)(e.comboboxState, {
                    [0]: ()=>l.goToOption((0, $b7a0b87cd8a0fa3d$export$807a7eae502106e7).Previous),
                    [1]: ()=>{
                        l.openCombobox(), v.nextFrame(()=>{
                            e.value || l.goToOption((0, $b7a0b87cd8a0fa3d$export$807a7eae502106e7).Last);
                        });
                    }
                });
            case (0, $4cca0dbc68b0507a$export$4b0075e5ea5e1f26).Home:
                if (n.shiftKey) break;
                return f.current = !1, n.preventDefault(), n.stopPropagation(), l.goToOption((0, $b7a0b87cd8a0fa3d$export$807a7eae502106e7).First);
            case (0, $4cca0dbc68b0507a$export$4b0075e5ea5e1f26).PageUp:
                return f.current = !1, n.preventDefault(), n.stopPropagation(), l.goToOption((0, $b7a0b87cd8a0fa3d$export$807a7eae502106e7).First);
            case (0, $4cca0dbc68b0507a$export$4b0075e5ea5e1f26).End:
                if (n.shiftKey) break;
                return f.current = !1, n.preventDefault(), n.stopPropagation(), l.goToOption((0, $b7a0b87cd8a0fa3d$export$807a7eae502106e7).Last);
            case (0, $4cca0dbc68b0507a$export$4b0075e5ea5e1f26).PageDown:
                return f.current = !1, n.preventDefault(), n.stopPropagation(), l.goToOption((0, $b7a0b87cd8a0fa3d$export$807a7eae502106e7).Last);
            case (0, $4cca0dbc68b0507a$export$4b0075e5ea5e1f26).Escape:
                return f.current = !1, e.comboboxState !== 0 ? void 0 : (n.preventDefault(), e.optionsRef.current && !e.optionsPropsRef.current.static && n.stopPropagation(), e.nullable && e.mode === 0 && e.value === null && S(), l.closeCombobox());
            case (0, $4cca0dbc68b0507a$export$4b0075e5ea5e1f26).Tab:
                if (f.current = !1, e.comboboxState !== 0) return;
                e.mode === 0 && e.activationTrigger !== 1 && l.selectActiveOption(), l.closeCombobox();
                break;
        }
    }), E = (0, $0bd9972698c32399$export$90fc3a17d93f704c)((n)=>{
        i == null || i(n), e.nullable && e.mode === 0 && n.target.value === "" && S(), l.openCombobox();
    }), k = (0, $0bd9972698c32399$export$90fc3a17d93f704c)((n)=>{
        var A, h, C;
        let F = (A = n.relatedTarget) != null ? A : (0, $1e76a1cad0cb58a8$export$55abd4691b317664).find((D)=>D !== n.currentTarget);
        if (f.current = !1, !((h = e.optionsRef.current) != null && h.contains(F)) && !((C = e.buttonRef.current) != null && C.contains(F)) && e.comboboxState === 0) return n.preventDefault(), e.mode === 0 && (e.nullable && e.value === null ? S() : e.activationTrigger !== 1 && l.selectActiveOption()), l.closeCombobox();
    }), J = (0, $0bd9972698c32399$export$90fc3a17d93f704c)((n)=>{
        var A, h, C;
        let F = (A = n.relatedTarget) != null ? A : (0, $1e76a1cad0cb58a8$export$55abd4691b317664).find((D)=>D !== n.currentTarget);
        (h = e.buttonRef.current) != null && h.contains(F) || (C = e.optionsRef.current) != null && C.contains(F) || e.disabled || e.immediate && e.comboboxState !== 0 && (l.openCombobox(), v.nextFrame(()=>{
            l.setActivationTrigger(1);
        }));
    }), K = (0, $d78e56d87e9d66e2$export$e3d20747ab930783)(()=>{
        if (e.labelId) return [
            e.labelId
        ].join(" ");
    }, [
        e.labelId
    ]), z = (0, $acw62.useMemo)(()=>({
            open: e.comboboxState === 0,
            disabled: e.disabled
        }), [
        e
    ]), te = {
        ref: T,
        id: a,
        role: "combobox",
        type: p,
        "aria-controls": (X = e.optionsRef.current) == null ? void 0 : X.id,
        "aria-expanded": e.comboboxState === 0,
        "aria-activedescendant": e.activeOptionIndex === null ? void 0 : e.virtual ? (x = e.options.find((n)=>{
            var F;
            return !((F = e.virtual) != null && F.disabled(n.dataRef.current.value)) && e.compare(n.dataRef.current.value, e.virtual.options[e.activeOptionIndex]);
        })) == null ? void 0 : x.id : (O = e.options[e.activeOptionIndex]) == null ? void 0 : O.id,
        "aria-labelledby": K,
        "aria-autocomplete": "list",
        defaultValue: (oe = (L = t.defaultValue) != null ? L : e.defaultValue !== void 0 ? u == null ? void 0 : u(e.defaultValue) : null) != null ? oe : e.defaultValue,
        disabled: e.disabled,
        onCompositionStart: I,
        onCompositionEnd: V,
        onKeyDown: _,
        onChange: E,
        onFocus: J,
        onBlur: k
    };
    return (0, $a54bdd13402af126$export$b3890eb0ae9dca99)({
        ourProps: te,
        theirProps: c,
        slot: z,
        defaultTag: $eaec5fceb04f7d33$var$nt,
        name: "Combobox.Input"
    });
}
let $eaec5fceb04f7d33$var$at = "button";
function $eaec5fceb04f7d33$var$lt(t, r) {
    var S;
    let o = $eaec5fceb04f7d33$var$j("Combobox.Button"), a = $eaec5fceb04f7d33$var$ee("Combobox.Button"), i = (0, $4a1854c6a3ad5196$export$f6a25a78204acc7e)(o.buttonRef, r), u = (0, $f2a0dea4caee12c6$export$f680877a34711e37)(), { id: p = `headlessui-combobox-button-${u}`, ...c } = t, e = (0, $410e668b7f520622$export$fd183955ff4b45d9)(), l = (0, $0bd9972698c32399$export$90fc3a17d93f704c)((R)=>{
        switch(R.key){
            case (0, $4cca0dbc68b0507a$export$4b0075e5ea5e1f26).ArrowDown:
                return R.preventDefault(), R.stopPropagation(), o.comboboxState === 1 && a.openCombobox(), e.nextFrame(()=>{
                    var s;
                    return (s = o.inputRef.current) == null ? void 0 : s.focus({
                        preventScroll: !0
                    });
                });
            case (0, $4cca0dbc68b0507a$export$4b0075e5ea5e1f26).ArrowUp:
                return R.preventDefault(), R.stopPropagation(), o.comboboxState === 1 && (a.openCombobox(), e.nextFrame(()=>{
                    o.value || a.goToOption((0, $b7a0b87cd8a0fa3d$export$807a7eae502106e7).Last);
                })), e.nextFrame(()=>{
                    var s;
                    return (s = o.inputRef.current) == null ? void 0 : s.focus({
                        preventScroll: !0
                    });
                });
            case (0, $4cca0dbc68b0507a$export$4b0075e5ea5e1f26).Escape:
                return o.comboboxState !== 0 ? void 0 : (R.preventDefault(), o.optionsRef.current && !o.optionsPropsRef.current.static && R.stopPropagation(), a.closeCombobox(), e.nextFrame(()=>{
                    var s;
                    return (s = o.inputRef.current) == null ? void 0 : s.focus({
                        preventScroll: !0
                    });
                }));
            default:
                return;
        }
    }), T = (0, $0bd9972698c32399$export$90fc3a17d93f704c)((R)=>{
        if ((0, $3d3d670dbe2ceed6$export$db61f031a278447c)(R.currentTarget)) return R.preventDefault();
        o.comboboxState === 0 ? a.closeCombobox() : (R.preventDefault(), a.openCombobox()), e.nextFrame(()=>{
            var s;
            return (s = o.inputRef.current) == null ? void 0 : s.focus({
                preventScroll: !0
            });
        });
    }), g = (0, $d78e56d87e9d66e2$export$e3d20747ab930783)(()=>{
        if (o.labelId) return [
            o.labelId,
            p
        ].join(" ");
    }, [
        o.labelId,
        p
    ]), f = (0, $acw62.useMemo)(()=>({
            open: o.comboboxState === 0,
            disabled: o.disabled,
            value: o.value
        }), [
        o
    ]), v = {
        ref: i,
        id: p,
        type: (0, $be828d8bf9bb25ca$export$53652b2b272efe9c)(t, o.buttonRef),
        tabIndex: -1,
        "aria-haspopup": "listbox",
        "aria-controls": (S = o.optionsRef.current) == null ? void 0 : S.id,
        "aria-expanded": o.comboboxState === 0,
        "aria-labelledby": g,
        disabled: o.disabled,
        onClick: T,
        onKeyDown: l
    };
    return (0, $a54bdd13402af126$export$b3890eb0ae9dca99)({
        ourProps: v,
        theirProps: c,
        slot: f,
        defaultTag: $eaec5fceb04f7d33$var$at,
        name: "Combobox.Button"
    });
}
let $eaec5fceb04f7d33$var$it = "label";
function $eaec5fceb04f7d33$var$ut(t, r) {
    let o = (0, $f2a0dea4caee12c6$export$f680877a34711e37)(), { id: a = `headlessui-combobox-label-${o}`, ...i } = t, u = $eaec5fceb04f7d33$var$j("Combobox.Label"), p = $eaec5fceb04f7d33$var$ee("Combobox.Label"), c = (0, $4a1854c6a3ad5196$export$f6a25a78204acc7e)(u.labelRef, r);
    (0, $65df95ec9b1bb6a8$export$ce5ed857c741fd71)(()=>p.registerLabel(a), [
        a
    ]);
    let e = (0, $0bd9972698c32399$export$90fc3a17d93f704c)(()=>{
        var g;
        return (g = u.inputRef.current) == null ? void 0 : g.focus({
            preventScroll: !0
        });
    }), l = (0, $acw62.useMemo)(()=>({
            open: u.comboboxState === 0,
            disabled: u.disabled
        }), [
        u
    ]);
    return (0, $a54bdd13402af126$export$b3890eb0ae9dca99)({
        ourProps: {
            ref: c,
            id: a,
            onClick: e
        },
        theirProps: i,
        slot: l,
        defaultTag: $eaec5fceb04f7d33$var$it,
        name: "Combobox.Label"
    });
}
let $eaec5fceb04f7d33$var$pt = "ul", $eaec5fceb04f7d33$var$st = (0, $a54bdd13402af126$export$617d79dae526d2cf).RenderStrategy | (0, $a54bdd13402af126$export$617d79dae526d2cf).Static;
function $eaec5fceb04f7d33$var$dt(t, r) {
    let o = (0, $f2a0dea4caee12c6$export$f680877a34711e37)(), { id: a = `headlessui-combobox-options-${o}`, hold: i = !1, ...u } = t, p = $eaec5fceb04f7d33$var$j("Combobox.Options"), c = (0, $4a1854c6a3ad5196$export$f6a25a78204acc7e)(p.optionsRef, r), e = (0, $7a3499b4b3c6f184$export$fc6fdf0ecf360e)(), l = (()=>e !== null ? (e & (0, $7a3499b4b3c6f184$export$7254cc27399e90bd).Open) === (0, $7a3499b4b3c6f184$export$7254cc27399e90bd).Open : p.comboboxState === 0)();
    (0, $65df95ec9b1bb6a8$export$ce5ed857c741fd71)(()=>{
        var v;
        p.optionsPropsRef.current.static = (v = t.static) != null ? v : !1;
    }, [
        p.optionsPropsRef,
        t.static
    ]), (0, $65df95ec9b1bb6a8$export$ce5ed857c741fd71)(()=>{
        p.optionsPropsRef.current.hold = i;
    }, [
        p.optionsPropsRef,
        i
    ]), (0, $101ef4628501ab0d$export$b0abce39eb34b36)({
        container: p.optionsRef.current,
        enabled: p.comboboxState === 0,
        accept (v) {
            return v.getAttribute("role") === "option" ? NodeFilter.FILTER_REJECT : v.hasAttribute("role") ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT;
        },
        walk (v) {
            v.setAttribute("role", "none");
        }
    });
    let T = (0, $d78e56d87e9d66e2$export$e3d20747ab930783)(()=>{
        var v, S;
        return (S = p.labelId) != null ? S : (v = p.buttonRef.current) == null ? void 0 : v.id;
    }, [
        p.labelId,
        p.buttonRef.current
    ]), g = (0, $acw62.useMemo)(()=>({
            open: p.comboboxState === 0,
            option: void 0
        }), [
        p
    ]), f = {
        "aria-labelledby": T,
        role: "listbox",
        "aria-multiselectable": p.mode === 1 ? !0 : void 0,
        id: a,
        ref: c
    };
    return p.virtual && p.comboboxState === 0 && Object.assign(u, {
        children: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($eaec5fceb04f7d33$var$Ze, null, u.children)
    }), (0, $a54bdd13402af126$export$b3890eb0ae9dca99)({
        ourProps: f,
        theirProps: u,
        slot: g,
        defaultTag: $eaec5fceb04f7d33$var$pt,
        features: $eaec5fceb04f7d33$var$st,
        visible: l,
        name: "Combobox.Options"
    });
}
let $eaec5fceb04f7d33$var$bt = "li";
function $eaec5fceb04f7d33$var$ct(t, r) {
    var X;
    let o = (0, $f2a0dea4caee12c6$export$f680877a34711e37)(), { id: a = `headlessui-combobox-option-${o}`, disabled: i = !1, value: u, order: p = null, ...c } = t, e = $eaec5fceb04f7d33$var$j("Combobox.Option"), l = $eaec5fceb04f7d33$var$ee("Combobox.Option"), T = e.virtual ? e.activeOptionIndex === e.calculateIndex(u) : e.activeOptionIndex === null ? !1 : ((X = e.options[e.activeOptionIndex]) == null ? void 0 : X.id) === a, g = e.isSelected(u), f = (0, $acw62.useRef)(null), v = (0, $fa1923261638cacc$export$86c4283a11f23f95)({
        disabled: i,
        value: u,
        domRef: f,
        order: p
    }), S = (0, $acw62.useContext)($eaec5fceb04f7d33$var$Ce), R = (0, $4a1854c6a3ad5196$export$f6a25a78204acc7e)(r, f, S ? S.measureElement : null), s = (0, $0bd9972698c32399$export$90fc3a17d93f704c)(()=>l.onChange(u));
    (0, $65df95ec9b1bb6a8$export$ce5ed857c741fd71)(()=>l.registerOption(a, v), [
        v,
        a
    ]);
    let I = (0, $acw62.useRef)(!(e.virtual || e.__demoMode));
    (0, $65df95ec9b1bb6a8$export$ce5ed857c741fd71)(()=>{
        if (!e.virtual || !e.__demoMode) return;
        let x = (0, $12f0e1633d904536$export$12b26c28a05aa001)();
        return x.requestAnimationFrame(()=>{
            I.current = !0;
        }), x.dispose;
    }, [
        e.virtual,
        e.__demoMode
    ]), (0, $65df95ec9b1bb6a8$export$ce5ed857c741fd71)(()=>{
        if (!I.current || e.comboboxState !== 0 || !T || e.activationTrigger === 0) return;
        let x = (0, $12f0e1633d904536$export$12b26c28a05aa001)();
        return x.requestAnimationFrame(()=>{
            var O, L;
            (L = (O = f.current) == null ? void 0 : O.scrollIntoView) == null || L.call(O, {
                block: "nearest"
            });
        }), x.dispose;
    }, [
        f,
        T,
        e.comboboxState,
        e.activationTrigger,
        e.activeOptionIndex
    ]);
    let V = (0, $0bd9972698c32399$export$90fc3a17d93f704c)((x)=>{
        var O;
        if (i || (O = e.virtual) != null && O.disabled(u)) return x.preventDefault();
        s(), (0, $67c26d51fee0b51a$export$d0a8044dce8ff2fc)() || requestAnimationFrame(()=>{
            var L;
            return (L = e.inputRef.current) == null ? void 0 : L.focus({
                preventScroll: !0
            });
        }), e.mode === 0 && requestAnimationFrame(()=>l.closeCombobox());
    }), _ = (0, $0bd9972698c32399$export$90fc3a17d93f704c)(()=>{
        var O;
        if (i || (O = e.virtual) != null && O.disabled(u)) return l.goToOption((0, $b7a0b87cd8a0fa3d$export$807a7eae502106e7).Nothing);
        let x = e.calculateIndex(u);
        l.goToOption((0, $b7a0b87cd8a0fa3d$export$807a7eae502106e7).Specific, x);
    }), E = (0, $d668e4b1d0c2f85c$export$24ebee078bde85c3)(), k = (0, $0bd9972698c32399$export$90fc3a17d93f704c)((x)=>E.update(x)), J = (0, $0bd9972698c32399$export$90fc3a17d93f704c)((x)=>{
        var L;
        if (!E.wasMoved(x) || i || (L = e.virtual) != null && L.disabled(u) || T) return;
        let O = e.calculateIndex(u);
        l.goToOption((0, $b7a0b87cd8a0fa3d$export$807a7eae502106e7).Specific, O, 0);
    }), K = (0, $0bd9972698c32399$export$90fc3a17d93f704c)((x)=>{
        var O;
        E.wasMoved(x) && (i || (O = e.virtual) != null && O.disabled(u) || T && (e.optionsPropsRef.current.hold || l.goToOption((0, $b7a0b87cd8a0fa3d$export$807a7eae502106e7).Nothing)));
    }), z = (0, $acw62.useMemo)(()=>({
            active: T,
            selected: g,
            disabled: i
        }), [
        T,
        g,
        i
    ]);
    return (0, $a54bdd13402af126$export$b3890eb0ae9dca99)({
        ourProps: {
            id: a,
            ref: R,
            role: "option",
            tabIndex: i === !0 ? void 0 : -1,
            "aria-disabled": i === !0 ? !0 : void 0,
            "aria-selected": g,
            disabled: void 0,
            onClick: V,
            onFocus: _,
            onPointerEnter: k,
            onMouseEnter: k,
            onPointerMove: J,
            onMouseMove: J,
            onPointerLeave: K,
            onMouseLeave: K
        },
        theirProps: c,
        slot: z,
        defaultTag: $eaec5fceb04f7d33$var$bt,
        name: "Combobox.Option"
    });
}
let $eaec5fceb04f7d33$var$ft = (0, $a54bdd13402af126$export$e43f39796049410c)($eaec5fceb04f7d33$var$ot), $eaec5fceb04f7d33$var$mt = (0, $a54bdd13402af126$export$e43f39796049410c)($eaec5fceb04f7d33$var$lt), $eaec5fceb04f7d33$var$Tt = (0, $a54bdd13402af126$export$e43f39796049410c)($eaec5fceb04f7d33$var$rt), $eaec5fceb04f7d33$var$xt = (0, $a54bdd13402af126$export$e43f39796049410c)($eaec5fceb04f7d33$var$ut), $eaec5fceb04f7d33$var$gt = (0, $a54bdd13402af126$export$e43f39796049410c)($eaec5fceb04f7d33$var$dt), $eaec5fceb04f7d33$var$vt = (0, $a54bdd13402af126$export$e43f39796049410c)($eaec5fceb04f7d33$var$ct), $eaec5fceb04f7d33$export$27957ad87354dd7e = Object.assign($eaec5fceb04f7d33$var$ft, {
    Input: $eaec5fceb04f7d33$var$Tt,
    Button: $eaec5fceb04f7d33$var$mt,
    Label: $eaec5fceb04f7d33$var$xt,
    Options: $eaec5fceb04f7d33$var$gt,
    Option: $eaec5fceb04f7d33$var$vt
});


var $fd89a26ac969b4f3$exports = {};

$parcel$export($fd89a26ac969b4f3$exports, "Dialog", () => $fd89a26ac969b4f3$export$3ddf2d174ce01153);

var $acw62 = parcelRequire("acw62");
var $38ecc25572962dee$exports = {};

$parcel$export($38ecc25572962dee$exports, "FocusTrap", () => $38ecc25572962dee$export$34eba2437817a67b);

var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");

function $faafded37f338b1b$export$7080b3e976bc91ab(n, e, a, t) {
    let i = (0, $fa1923261638cacc$export$86c4283a11f23f95)(a);
    (0, $acw62.useEffect)(()=>{
        n = n != null ? n : window;
        function r(o) {
            i.current(o);
        }
        return n.addEventListener(e, r, t), ()=>n.removeEventListener(e, r, t);
    }, [
        n,
        e,
        t
    ]);
}




var $acw62 = parcelRequire("acw62");


function $2e29522f6fc857e9$export$cd059ee7fd0e9f3d(t) {
    let r = (0, $0bd9972698c32399$export$90fc3a17d93f704c)(t), e = (0, $acw62.useRef)(!1);
    (0, $acw62.useEffect)(()=>(e.current = !1, ()=>{
            e.current = !0, (0, $aba927e9b3929756$export$a5ff0d6a738703ca)(()=>{
                e.current && r();
            });
        }), [
        r
    ]);
}






var $acw62 = parcelRequire("acw62");

var $2766dc79ae4166c9$export$cacd6541cfeeb6c1 = ((r)=>(r[r.Forwards = 0] = "Forwards", r[r.Backwards = 1] = "Backwards", r))($2766dc79ae4166c9$export$cacd6541cfeeb6c1 || {});
function $2766dc79ae4166c9$export$19b797546aece48f() {
    let e = (0, $acw62.useRef)(0);
    return (0, $40320926a37dc1cc$export$ee579bb285b8d4aa)("keydown", (o)=>{
        o.key === "Tab" && (e.current = o.shiftKey ? 1 : 0);
    }, !0), e;
}









function $38ecc25572962dee$var$P(t) {
    if (!t) return new Set;
    if (typeof t == "function") return new Set(t());
    let n = new Set;
    for (let e of t.current)e.current instanceof HTMLElement && n.add(e.current);
    return n;
}
let $38ecc25572962dee$var$X = "div";
var $38ecc25572962dee$var$_ = ((r)=>(r[r.None = 1] = "None", r[r.InitialFocus = 2] = "InitialFocus", r[r.TabLock = 4] = "TabLock", r[r.FocusLock = 8] = "FocusLock", r[r.RestoreFocus = 16] = "RestoreFocus", r[r.All = 30] = "All", r))($38ecc25572962dee$var$_ || {});
function $38ecc25572962dee$var$z(t, n) {
    let e = (0, $acw62.useRef)(null), o = (0, $4a1854c6a3ad5196$export$f6a25a78204acc7e)(e, n), { initialFocus: l, containers: c, features: r = 30, ...s } = t;
    (0, $81b1abbf8717f9cc$export$44ab2b9f2d09b0fa)() || (r = 1);
    let i = (0, $42a08b28a285ca8e$export$dd9fbcea3de0ae36)(e);
    $38ecc25572962dee$var$Y({
        ownerDocument: i
    }, Boolean(r & 16));
    let u = $38ecc25572962dee$var$Z({
        ownerDocument: i,
        container: e,
        initialFocus: l
    }, Boolean(r & 2));
    $38ecc25572962dee$var$$({
        ownerDocument: i,
        container: e,
        containers: c,
        previousActiveElement: u
    }, Boolean(r & 8));
    let y = (0, $2766dc79ae4166c9$export$19b797546aece48f)(), R = (0, $0bd9972698c32399$export$90fc3a17d93f704c)((a)=>{
        let m = e.current;
        if (!m) return;
        ((B)=>B())(()=>{
            (0, $4f240e1aafd2c298$export$4659b591c19bdf3d)(y.current, {
                [(0, $2766dc79ae4166c9$export$cacd6541cfeeb6c1).Forwards]: ()=>{
                    (0, $cb6dceb64e6c0606$export$82e1f4f412218a1d)(m, (0, $cb6dceb64e6c0606$export$807a7eae502106e7).First, {
                        skipElements: [
                            a.relatedTarget
                        ]
                    });
                },
                [(0, $2766dc79ae4166c9$export$cacd6541cfeeb6c1).Backwards]: ()=>{
                    (0, $cb6dceb64e6c0606$export$82e1f4f412218a1d)(m, (0, $cb6dceb64e6c0606$export$807a7eae502106e7).Last, {
                        skipElements: [
                            a.relatedTarget
                        ]
                    });
                }
            });
        });
    }), h = (0, $410e668b7f520622$export$fd183955ff4b45d9)(), H = (0, $acw62.useRef)(!1), j = {
        ref: o,
        onKeyDown (a) {
            a.key == "Tab" && (H.current = !0, h.requestAnimationFrame(()=>{
                H.current = !1;
            }));
        },
        onBlur (a) {
            let m = $38ecc25572962dee$var$P(c);
            e.current instanceof HTMLElement && m.add(e.current);
            let T = a.relatedTarget;
            T instanceof HTMLElement && T.dataset.headlessuiFocusGuard !== "true" && ($38ecc25572962dee$var$S(m, T) || (H.current ? (0, $cb6dceb64e6c0606$export$82e1f4f412218a1d)(e.current, (0, $4f240e1aafd2c298$export$4659b591c19bdf3d)(y.current, {
                [(0, $2766dc79ae4166c9$export$cacd6541cfeeb6c1).Forwards]: ()=>(0, $cb6dceb64e6c0606$export$807a7eae502106e7).Next,
                [(0, $2766dc79ae4166c9$export$cacd6541cfeeb6c1).Backwards]: ()=>(0, $cb6dceb64e6c0606$export$807a7eae502106e7).Previous
            }) | (0, $cb6dceb64e6c0606$export$807a7eae502106e7).WrapAround, {
                relativeTo: a.target
            }) : a.target instanceof HTMLElement && (0, $cb6dceb64e6c0606$export$5fed9cc43865dc7e)(a.target)));
        }
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, Boolean(r & 4) && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $eac0d614a77ee96b$export$8dc98ba7eadeaa56), {
        as: "button",
        type: "button",
        "data-headlessui-focus-guard": !0,
        onFocus: R,
        features: (0, $eac0d614a77ee96b$export$617d79dae526d2cf).Focusable
    }), (0, $a54bdd13402af126$export$b3890eb0ae9dca99)({
        ourProps: j,
        theirProps: s,
        defaultTag: $38ecc25572962dee$var$X,
        name: "FocusTrap"
    }), Boolean(r & 4) && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $eac0d614a77ee96b$export$8dc98ba7eadeaa56), {
        as: "button",
        type: "button",
        "data-headlessui-focus-guard": !0,
        onFocus: R,
        features: (0, $eac0d614a77ee96b$export$617d79dae526d2cf).Focusable
    }));
}
let $38ecc25572962dee$var$D = (0, $a54bdd13402af126$export$e43f39796049410c)($38ecc25572962dee$var$z), $38ecc25572962dee$export$34eba2437817a67b = Object.assign($38ecc25572962dee$var$D, {
    features: $38ecc25572962dee$var$_
});
function $38ecc25572962dee$var$Q(t = !0) {
    let n = (0, $acw62.useRef)((0, $1e76a1cad0cb58a8$export$55abd4691b317664).slice());
    return (0, $fc465b9f88c2456a$export$3c773aa2b84f29e0)(([e], [o])=>{
        o === !0 && e === !1 && (0, $aba927e9b3929756$export$a5ff0d6a738703ca)(()=>{
            n.current.splice(0);
        }), o === !1 && e === !0 && (n.current = (0, $1e76a1cad0cb58a8$export$55abd4691b317664).slice());
    }, [
        t,
        (0, $1e76a1cad0cb58a8$export$55abd4691b317664),
        n
    ]), (0, $0bd9972698c32399$export$90fc3a17d93f704c)(()=>{
        var e;
        return (e = n.current.find((o)=>o != null && o.isConnected)) != null ? e : null;
    });
}
function $38ecc25572962dee$var$Y({ ownerDocument: t }, n) {
    let e = $38ecc25572962dee$var$Q(n);
    (0, $fc465b9f88c2456a$export$3c773aa2b84f29e0)(()=>{
        n || (t == null ? void 0 : t.activeElement) === (t == null ? void 0 : t.body) && (0, $cb6dceb64e6c0606$export$5fed9cc43865dc7e)(e());
    }, [
        n
    ]), (0, $2e29522f6fc857e9$export$cd059ee7fd0e9f3d)(()=>{
        n && (0, $cb6dceb64e6c0606$export$5fed9cc43865dc7e)(e());
    });
}
function $38ecc25572962dee$var$Z({ ownerDocument: t, container: n, initialFocus: e }, o) {
    let l = (0, $acw62.useRef)(null), c = (0, $854f77de70ff8db2$export$80c2a3957bcb42ea)();
    return (0, $fc465b9f88c2456a$export$3c773aa2b84f29e0)(()=>{
        if (!o) return;
        let r = n.current;
        r && (0, $aba927e9b3929756$export$a5ff0d6a738703ca)(()=>{
            if (!c.current) return;
            let s = t == null ? void 0 : t.activeElement;
            if (e != null && e.current) {
                if ((e == null ? void 0 : e.current) === s) {
                    l.current = s;
                    return;
                }
            } else if (r.contains(s)) {
                l.current = s;
                return;
            }
            e != null && e.current ? (0, $cb6dceb64e6c0606$export$5fed9cc43865dc7e)(e.current) : (0, $cb6dceb64e6c0606$export$82e1f4f412218a1d)(r, (0, $cb6dceb64e6c0606$export$807a7eae502106e7).First) === (0, $cb6dceb64e6c0606$export$abf286375dfa6dbd).Error && console.warn("There are no focusable elements inside the <FocusTrap />"), l.current = t == null ? void 0 : t.activeElement;
        });
    }, [
        o
    ]), l;
}
function $38ecc25572962dee$var$$({ ownerDocument: t, container: n, containers: e, previousActiveElement: o }, l) {
    let c = (0, $854f77de70ff8db2$export$80c2a3957bcb42ea)();
    (0, $faafded37f338b1b$export$7080b3e976bc91ab)(t == null ? void 0 : t.defaultView, "focus", (r)=>{
        if (!l || !c.current) return;
        let s = $38ecc25572962dee$var$P(e);
        n.current instanceof HTMLElement && s.add(n.current);
        let i = o.current;
        if (!i) return;
        let u = r.target;
        u && u instanceof HTMLElement ? $38ecc25572962dee$var$S(s, u) ? (o.current = u, (0, $cb6dceb64e6c0606$export$5fed9cc43865dc7e)(u)) : (r.preventDefault(), r.stopPropagation(), (0, $cb6dceb64e6c0606$export$5fed9cc43865dc7e)(i)) : (0, $cb6dceb64e6c0606$export$5fed9cc43865dc7e)(o.current);
    }, !0);
}
function $38ecc25572962dee$var$S(t, n) {
    for (let e of t)if (e.contains(n)) return !0;
    return !1;
}



var $acw62 = parcelRequire("acw62");








var $acw62 = parcelRequire("acw62");
let $7e5993dca17d6628$var$e = (0, $acw62.createContext)(!1);
function $7e5993dca17d6628$export$6ecd3efa4eebe261() {
    return (0, $acw62.useContext)($7e5993dca17d6628$var$e);
}
function $7e5993dca17d6628$export$8f2af6644e3a3c93(o) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($7e5993dca17d6628$var$e.Provider, {
        value: o.force
    }, o.children);
}




function $a4e89ae9835d0556$var$F(p) {
    let n = (0, $7e5993dca17d6628$export$6ecd3efa4eebe261)(), l = (0, $acw62.useContext)($a4e89ae9835d0556$var$_), e = (0, $42a08b28a285ca8e$export$dd9fbcea3de0ae36)(p), [a, o] = (0, $acw62.useState)(()=>{
        if (!n && l !== null || (0, $085e96034c813fbf$export$a7b6bc01c63cdfc3).isServer) return null;
        let t = e == null ? void 0 : e.getElementById("headlessui-portal-root");
        if (t) return t;
        if (e === null) return null;
        let r = e.createElement("div");
        return r.setAttribute("id", "headlessui-portal-root"), e.body.appendChild(r);
    });
    return (0, $acw62.useEffect)(()=>{
        a !== null && (e != null && e.body.contains(a) || e == null || e.body.appendChild(a));
    }, [
        a,
        e
    ]), (0, $acw62.useEffect)(()=>{
        n || l !== null && o(l.current);
    }, [
        l,
        o,
        n
    ]), a;
}
let $a4e89ae9835d0556$var$U = (0, $acw62.Fragment);
function $a4e89ae9835d0556$var$N(p, n) {
    let l = p, e = (0, $acw62.useRef)(null), a = (0, $4a1854c6a3ad5196$export$f6a25a78204acc7e)((0, $4a1854c6a3ad5196$export$7029785b750eb74)((u)=>{
        e.current = u;
    }), n), o = (0, $42a08b28a285ca8e$export$dd9fbcea3de0ae36)(e), t = $a4e89ae9835d0556$var$F(e), [r] = (0, $acw62.useState)(()=>{
        var u;
        return (0, $085e96034c813fbf$export$a7b6bc01c63cdfc3).isServer ? null : (u = o == null ? void 0 : o.createElement("div")) != null ? u : null;
    }), i = (0, $acw62.useContext)($a4e89ae9835d0556$var$f), v = (0, $81b1abbf8717f9cc$export$44ab2b9f2d09b0fa)();
    return (0, $65df95ec9b1bb6a8$export$ce5ed857c741fd71)(()=>{
        !t || !r || t.contains(r) || (r.setAttribute("data-headlessui-portal", ""), t.appendChild(r));
    }, [
        t,
        r
    ]), (0, $65df95ec9b1bb6a8$export$ce5ed857c741fd71)(()=>{
        if (r && i) return i.register(r);
    }, [
        i,
        r
    ]), (0, $2e29522f6fc857e9$export$cd059ee7fd0e9f3d)(()=>{
        var u;
        !t || !r || (r instanceof Node && t.contains(r) && t.removeChild(r), t.childNodes.length <= 0 && ((u = t.parentElement) == null || u.removeChild(t)));
    }), v ? !t || !r ? null : (0, $11492dca620dcaa5$exports.createPortal)((0, $a54bdd13402af126$export$b3890eb0ae9dca99)({
        ourProps: {
            ref: a
        },
        theirProps: l,
        defaultTag: $a4e89ae9835d0556$var$U,
        name: "Portal"
    }), r) : null;
}
let $a4e89ae9835d0556$var$S = (0, $acw62.Fragment), $a4e89ae9835d0556$var$_ = (0, $acw62.createContext)(null);
function $a4e89ae9835d0556$var$j(p, n) {
    let { target: l, ...e } = p, o = {
        ref: (0, $4a1854c6a3ad5196$export$f6a25a78204acc7e)(n)
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($a4e89ae9835d0556$var$_.Provider, {
        value: l
    }, (0, $a54bdd13402af126$export$b3890eb0ae9dca99)({
        ourProps: o,
        theirProps: e,
        defaultTag: $a4e89ae9835d0556$var$S,
        name: "Popover.Group"
    }));
}
let $a4e89ae9835d0556$var$f = (0, $acw62.createContext)(null);
function $a4e89ae9835d0556$export$26b8c35244a70b37() {
    let p = (0, $acw62.useContext)($a4e89ae9835d0556$var$f), n = (0, $acw62.useRef)([]), l = (0, $0bd9972698c32399$export$90fc3a17d93f704c)((o)=>(n.current.push(o), p && p.register(o), ()=>e(o))), e = (0, $0bd9972698c32399$export$90fc3a17d93f704c)((o)=>{
        let t = n.current.indexOf(o);
        t !== -1 && n.current.splice(t, 1), p && p.unregister(o);
    }), a = (0, $acw62.useMemo)(()=>({
            register: l,
            unregister: e,
            portals: n
        }), [
        l,
        e,
        n
    ]);
    return [
        n,
        (0, $acw62.useMemo)(()=>function({ children: t }) {
                return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($a4e89ae9835d0556$var$f.Provider, {
                    value: a
                }, t);
            }, [
            a
        ])
    ];
}
let $a4e89ae9835d0556$var$D = (0, $a54bdd13402af126$export$e43f39796049410c)($a4e89ae9835d0556$var$N), $a4e89ae9835d0556$var$I = (0, $a54bdd13402af126$export$e43f39796049410c)($a4e89ae9835d0556$var$j), $a4e89ae9835d0556$export$602eac185826482c = Object.assign($a4e89ae9835d0556$var$D, {
    Group: $a4e89ae9835d0556$var$I
});



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
function $065f25665c1f131a$var$i(e, t) {
    return e === t && (e !== 0 || 1 / e === 1 / t) || e !== e && t !== t;
}
const $065f25665c1f131a$var$d = typeof Object.is == "function" ? Object.is : $065f25665c1f131a$var$i, { useState: $065f25665c1f131a$var$u, useEffect: $065f25665c1f131a$var$h, useLayoutEffect: $065f25665c1f131a$var$f, useDebugValue: $065f25665c1f131a$var$p } = $acw62;
let $065f25665c1f131a$var$S = !1, $065f25665c1f131a$var$_ = !1;
function $065f25665c1f131a$export$306c0aa65ff9ec16(e, t, c) {
    const a = t(), [{ inst: n }, o] = $065f25665c1f131a$var$u({
        inst: {
            value: a,
            getSnapshot: t
        }
    });
    return $065f25665c1f131a$var$f(()=>{
        n.value = a, n.getSnapshot = t, $065f25665c1f131a$var$r(n) && o({
            inst: n
        });
    }, [
        e,
        a,
        t
    ]), $065f25665c1f131a$var$h(()=>($065f25665c1f131a$var$r(n) && o({
            inst: n
        }), e(()=>{
            $065f25665c1f131a$var$r(n) && o({
                inst: n
            });
        })), [
        e
    ]), $065f25665c1f131a$var$p(a), a;
}
function $065f25665c1f131a$var$r(e) {
    const t = e.getSnapshot, c = e.value;
    try {
        const a = t();
        return !$065f25665c1f131a$var$d(c, a);
    } catch  {
        return !0;
    }
}


function $9a84e3f71e58712c$export$306c0aa65ff9ec16(r, e, n) {
    return e();
}


const $fa48830851ba6572$var$r = typeof window != "undefined" && typeof window.document != "undefined" && typeof window.document.createElement != "undefined", $fa48830851ba6572$var$s = !$fa48830851ba6572$var$r, $fa48830851ba6572$var$c = $fa48830851ba6572$var$s ? (0, $9a84e3f71e58712c$export$306c0aa65ff9ec16) : (0, $065f25665c1f131a$export$306c0aa65ff9ec16), $fa48830851ba6572$export$306c0aa65ff9ec16 = "useSyncExternalStore" in $acw62 ? ((n)=>n.useSyncExternalStore)($acw62) : $fa48830851ba6572$var$c;


function $c194acc02d991b55$export$6ccbb43953eebf8(t) {
    return (0, $fa48830851ba6572$export$306c0aa65ff9ec16)(t.subscribe, t.getSnapshot, t.getSnapshot);
}




function $587828ac89f0168d$export$f51a9068ac82ea43(o, r) {
    let t = o(), n = new Set;
    return {
        getSnapshot () {
            return t;
        },
        subscribe (e) {
            return n.add(e), ()=>n.delete(e);
        },
        dispatch (e, ...s) {
            let i = r[e].call(t, ...s);
            i && (t = i, n.forEach((c)=>c()));
        }
    };
}


function $bb844292a519e22f$export$110627fb35ef9205() {
    let o;
    return {
        before ({ doc: e }) {
            var l;
            let n = e.documentElement;
            o = ((l = e.defaultView) != null ? l : window).innerWidth - n.clientWidth;
        },
        after ({ doc: e, d: n }) {
            let t = e.documentElement, l = t.clientWidth - t.offsetWidth, r = o - l;
            n.style(t, "paddingRight", `${r}px`);
        }
    };
}




function $bb2d57db10996691$export$e3a523dfabf27286() {
    return (0, $67c26d51fee0b51a$export$fedb369cb70207f1)() ? {
        before ({ doc: r, d: l, meta: c }) {
            function o(a) {
                return c.containers.flatMap((n)=>n()).some((n)=>n.contains(a));
            }
            l.microTask(()=>{
                var s;
                if (window.getComputedStyle(r.documentElement).scrollBehavior !== "auto") {
                    let t = (0, $12f0e1633d904536$export$12b26c28a05aa001)();
                    t.style(r.documentElement, "scrollBehavior", "auto"), l.add(()=>l.microTask(()=>t.dispose()));
                }
                let a = (s = window.scrollY) != null ? s : window.pageYOffset, n = null;
                l.addEventListener(r, "click", (t)=>{
                    if (t.target instanceof HTMLElement) try {
                        let e = t.target.closest("a");
                        if (!e) return;
                        let { hash: f } = new URL(e.href), i = r.querySelector(f);
                        i && !o(i) && (n = i);
                    } catch  {}
                }, !0), l.addEventListener(r, "touchstart", (t)=>{
                    if (t.target instanceof HTMLElement) {
                        if (o(t.target)) {
                            let e = t.target;
                            for(; e.parentElement && o(e.parentElement);)e = e.parentElement;
                            l.style(e, "overscrollBehavior", "contain");
                        } else l.style(t.target, "touchAction", "none");
                    }
                }), l.addEventListener(r, "touchmove", (t)=>{
                    if (t.target instanceof HTMLElement) {
                        if (o(t.target)) {
                            let e = t.target;
                            for(; e.parentElement && e.dataset.headlessuiPortal !== "" && !(e.scrollHeight > e.clientHeight || e.scrollWidth > e.clientWidth);)e = e.parentElement;
                            e.dataset.headlessuiPortal === "" && t.preventDefault();
                        } else t.preventDefault();
                    }
                }, {
                    passive: !1
                }), l.add(()=>{
                    var e;
                    let t = (e = window.scrollY) != null ? e : window.pageYOffset;
                    a !== t && window.scrollTo(0, a), n && n.isConnected && (n.scrollIntoView({
                        block: "nearest"
                    }), n = null);
                });
            });
        }
    } : {};
}


function $d5eee4b72f55118b$export$d8b6ff28805e84e9() {
    return {
        before ({ doc: e, d: o }) {
            o.style(e.documentElement, "overflow", "hidden");
        }
    };
}


function $189c7921f80dd74a$var$m(e) {
    let n = {};
    for (let t of e)Object.assign(n, t(n));
    return n;
}
let $189c7921f80dd74a$export$a4161f418919b5aa = (0, $587828ac89f0168d$export$f51a9068ac82ea43)(()=>new Map, {
    PUSH (e, n) {
        var o;
        let t = (o = this.get(e)) != null ? o : {
            doc: e,
            count: 0,
            d: (0, $12f0e1633d904536$export$12b26c28a05aa001)(),
            meta: new Set
        };
        return t.count++, t.meta.add(n), this.set(e, t), this;
    },
    POP (e, n) {
        let t = this.get(e);
        return t && (t.count--, t.meta.delete(n)), this;
    },
    SCROLL_PREVENT ({ doc: e, d: n, meta: t }) {
        let o = {
            doc: e,
            d: n,
            meta: $189c7921f80dd74a$var$m(t)
        }, c = [
            (0, $bb2d57db10996691$export$e3a523dfabf27286)(),
            (0, $bb844292a519e22f$export$110627fb35ef9205)(),
            (0, $d5eee4b72f55118b$export$d8b6ff28805e84e9)()
        ];
        c.forEach(({ before: r })=>r == null ? void 0 : r(o)), c.forEach(({ after: r })=>r == null ? void 0 : r(o));
    },
    SCROLL_ALLOW ({ d: e }) {
        e.dispose();
    },
    TEARDOWN ({ doc: e }) {
        this.delete(e);
    }
});
$189c7921f80dd74a$export$a4161f418919b5aa.subscribe(()=>{
    let e = $189c7921f80dd74a$export$a4161f418919b5aa.getSnapshot(), n = new Map;
    for (let [t] of e)n.set(t, t.documentElement.style.overflow);
    for (let t of e.values()){
        let o = n.get(t.doc) === "hidden", c = t.count !== 0;
        (c && !o || !c && o) && $189c7921f80dd74a$export$a4161f418919b5aa.dispatch(t.count > 0 ? "SCROLL_PREVENT" : "SCROLL_ALLOW", t), t.count === 0 && $189c7921f80dd74a$export$a4161f418919b5aa.dispatch("TEARDOWN", t);
    }
});


function $8e9ee35f9b752cd8$export$bb0ae4a42bcd9e0(e, r, n) {
    let f = (0, $c194acc02d991b55$export$6ccbb43953eebf8)((0, $189c7921f80dd74a$export$a4161f418919b5aa)), o = e ? f.get(e) : void 0, i = o ? o.count > 0 : !1;
    return (0, $65df95ec9b1bb6a8$export$ce5ed857c741fd71)(()=>{
        if (!(!e || !r)) return (0, $189c7921f80dd74a$export$a4161f418919b5aa).dispatch("PUSH", e, n), ()=>(0, $189c7921f80dd74a$export$a4161f418919b5aa).dispatch("POP", e, n);
    }, [
        r,
        e
    ]), i;
}






let $11805c0c83dbefad$var$u = new Map, $11805c0c83dbefad$var$t = new Map;
function $11805c0c83dbefad$export$bbe4e2927a3450da(r, l = !0) {
    (0, $65df95ec9b1bb6a8$export$ce5ed857c741fd71)(()=>{
        var o;
        if (!l) return;
        let e = typeof r == "function" ? r() : r.current;
        if (!e) return;
        function a() {
            var d;
            if (!e) return;
            let i = (d = $11805c0c83dbefad$var$t.get(e)) != null ? d : 1;
            if (i === 1 ? $11805c0c83dbefad$var$t.delete(e) : $11805c0c83dbefad$var$t.set(e, i - 1), i !== 1) return;
            let n = $11805c0c83dbefad$var$u.get(e);
            n && (n["aria-hidden"] === null ? e.removeAttribute("aria-hidden") : e.setAttribute("aria-hidden", n["aria-hidden"]), e.inert = n.inert, $11805c0c83dbefad$var$u.delete(e));
        }
        let f = (o = $11805c0c83dbefad$var$t.get(e)) != null ? o : 0;
        return $11805c0c83dbefad$var$t.set(e, f + 1), f !== 0 || ($11805c0c83dbefad$var$u.set(e, {
            "aria-hidden": e.getAttribute("aria-hidden"),
            inert: e.inert
        }), e.setAttribute("aria-hidden", "true"), e.inert = !0), a;
    }, [
        r,
        l
    ]);
}





var $acw62 = parcelRequire("acw62");



function $df81719180936f93$export$445f2d1a3d9b1b9f({ defaultContainers: o = [], portals: r, mainTreeNodeRef: u } = {}) {
    var f;
    let t = (0, $acw62.useRef)((f = u == null ? void 0 : u.current) != null ? f : null), l = (0, $42a08b28a285ca8e$export$dd9fbcea3de0ae36)(t), c = (0, $0bd9972698c32399$export$90fc3a17d93f704c)(()=>{
        var i, s, a;
        let n = [];
        for (let e of o)e !== null && (e instanceof HTMLElement ? n.push(e) : "current" in e && e.current instanceof HTMLElement && n.push(e.current));
        if (r != null && r.current) for (let e of r.current)n.push(e);
        for (let e of (i = l == null ? void 0 : l.querySelectorAll("html > *, body > *")) != null ? i : [])e !== document.body && e !== document.head && e instanceof HTMLElement && e.id !== "headlessui-portal-root" && (e.contains(t.current) || e.contains((a = (s = t.current) == null ? void 0 : s.getRootNode()) == null ? void 0 : a.host) || n.some((L)=>e.contains(L)) || n.push(e));
        return n;
    });
    return {
        resolveContainers: c,
        contains: (0, $0bd9972698c32399$export$90fc3a17d93f704c)((n)=>c().some((i)=>i.contains(n))),
        mainTreeNodeRef: t,
        MainTreeNode: (0, $acw62.useMemo)(()=>function() {
                return u != null ? null : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $eac0d614a77ee96b$export$8dc98ba7eadeaa56), {
                    features: (0, $eac0d614a77ee96b$export$617d79dae526d2cf).Hidden,
                    ref: t
                });
            }, [
            t,
            u
        ])
    };
}
function $df81719180936f93$export$64db24433d7f4942() {
    let o = (0, $acw62.useRef)(null);
    return {
        mainTreeNodeRef: o,
        MainTreeNode: (0, $acw62.useMemo)(()=>function() {
                return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $eac0d614a77ee96b$export$8dc98ba7eadeaa56), {
                    features: (0, $eac0d614a77ee96b$export$617d79dae526d2cf).Hidden,
                    ref: o
                });
            }, [
            o
        ])
    };
}







var $acw62 = parcelRequire("acw62");


let $1f71d3aaee714e67$var$a = (0, $acw62.createContext)(()=>{});
$1f71d3aaee714e67$var$a.displayName = "StackContext";
var $1f71d3aaee714e67$export$2dd25ef07fea092e = ((e)=>(e[e.Add = 0] = "Add", e[e.Remove = 1] = "Remove", e))($1f71d3aaee714e67$export$2dd25ef07fea092e || {});
function $1f71d3aaee714e67$export$59510f5936c4d8c4() {
    return (0, $acw62.useContext)($1f71d3aaee714e67$var$a);
}
function $1f71d3aaee714e67$export$4aac1a6640027f56({ children: i, onUpdate: r, type: e, element: n, enabled: u }) {
    let l = $1f71d3aaee714e67$export$59510f5936c4d8c4(), o = (0, $0bd9972698c32399$export$90fc3a17d93f704c)((...t)=>{
        r == null || r(...t), l(...t);
    });
    return (0, $65df95ec9b1bb6a8$export$ce5ed857c741fd71)(()=>{
        let t = u === void 0 || u === !0;
        return t && o(0, e, n), ()=>{
            t && o(1, e, n);
        };
    }, [
        o,
        e,
        n,
        u
    ]), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1f71d3aaee714e67$var$a.Provider, {
        value: o
    }, i);
}






var $acw62 = parcelRequire("acw62");





let $d994aee5798540d7$var$d = (0, $acw62.createContext)(null);
function $d994aee5798540d7$var$f() {
    let r = (0, $acw62.useContext)($d994aee5798540d7$var$d);
    if (r === null) {
        let t = new Error("You used a <Description /> component, but it is not inside a relevant parent.");
        throw Error.captureStackTrace && Error.captureStackTrace(t, $d994aee5798540d7$var$f), t;
    }
    return r;
}
function $d994aee5798540d7$export$babde88292020af7() {
    let [r, t] = (0, $acw62.useState)([]);
    return [
        r.length > 0 ? r.join(" ") : void 0,
        (0, $acw62.useMemo)(()=>function(e) {
                let i = (0, $0bd9972698c32399$export$90fc3a17d93f704c)((s)=>(t((o)=>[
                            ...o,
                            s
                        ]), ()=>t((o)=>{
                            let p = o.slice(), c = p.indexOf(s);
                            return c !== -1 && p.splice(c, 1), p;
                        }))), n = (0, $acw62.useMemo)(()=>({
                        register: i,
                        slot: e.slot,
                        name: e.name,
                        props: e.props
                    }), [
                    i,
                    e.slot,
                    e.name,
                    e.props
                ]);
                return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d994aee5798540d7$var$d.Provider, {
                    value: n
                }, e.children);
            }, [
            t
        ])
    ];
}
let $d994aee5798540d7$var$I = "p";
function $d994aee5798540d7$var$S(r, t) {
    let a = (0, $f2a0dea4caee12c6$export$f680877a34711e37)(), { id: e = `headlessui-description-${a}`, ...i } = r, n = $d994aee5798540d7$var$f(), s = (0, $4a1854c6a3ad5196$export$f6a25a78204acc7e)(t);
    (0, $65df95ec9b1bb6a8$export$ce5ed857c741fd71)(()=>n.register(e), [
        e,
        n.register
    ]);
    let o = {
        ref: s,
        ...n.props,
        id: e
    };
    return (0, $a54bdd13402af126$export$b3890eb0ae9dca99)({
        ourProps: o,
        theirProps: i,
        slot: n.slot || {},
        defaultTag: $d994aee5798540d7$var$I,
        name: n.name || "Description"
    });
}
let $d994aee5798540d7$var$h = (0, $a54bdd13402af126$export$e43f39796049410c)($d994aee5798540d7$var$S), $d994aee5798540d7$export$393edc798c47379d = Object.assign($d994aee5798540d7$var$h, {});



var $fd89a26ac969b4f3$var$Me = ((r)=>(r[r.Open = 0] = "Open", r[r.Closed = 1] = "Closed", r))($fd89a26ac969b4f3$var$Me || {}), $fd89a26ac969b4f3$var$we = ((e)=>(e[e.SetTitleId = 0] = "SetTitleId", e))($fd89a26ac969b4f3$var$we || {});
let $fd89a26ac969b4f3$var$He = {
    [0] (t, e) {
        return t.titleId === e.id ? t : {
            ...t,
            titleId: e.id
        };
    }
}, $fd89a26ac969b4f3$var$I = (0, $acw62.createContext)(null);
$fd89a26ac969b4f3$var$I.displayName = "DialogContext";
function $fd89a26ac969b4f3$var$b(t) {
    let e = (0, $acw62.useContext)($fd89a26ac969b4f3$var$I);
    if (e === null) {
        let r = new Error(`<${t} /> is missing a parent <Dialog /> component.`);
        throw Error.captureStackTrace && Error.captureStackTrace(r, $fd89a26ac969b4f3$var$b), r;
    }
    return e;
}
function $fd89a26ac969b4f3$var$Be(t, e, r = ()=>[
        document.body
    ]) {
    (0, $8e9ee35f9b752cd8$export$bb0ae4a42bcd9e0)(t, e, (i)=>{
        var n;
        return {
            containers: [
                ...(n = i.containers) != null ? n : [],
                r
            ]
        };
    });
}
function $fd89a26ac969b4f3$var$Ge(t, e) {
    return (0, $4f240e1aafd2c298$export$4659b591c19bdf3d)(e.type, $fd89a26ac969b4f3$var$He, t, e);
}
let $fd89a26ac969b4f3$var$Ne = "div", $fd89a26ac969b4f3$var$Ue = (0, $a54bdd13402af126$export$617d79dae526d2cf).RenderStrategy | (0, $a54bdd13402af126$export$617d79dae526d2cf).Static;
function $fd89a26ac969b4f3$var$We(t, e) {
    let r = (0, $f2a0dea4caee12c6$export$f680877a34711e37)(), { id: i = `headlessui-dialog-${r}`, open: n, onClose: l, initialFocus: s, role: a = "dialog", __demoMode: T = !1, ...m } = t, [M, f] = (0, $acw62.useState)(0), U = (0, $acw62.useRef)(!1);
    a = function() {
        return a === "dialog" || a === "alertdialog" ? a : (U.current || (U.current = !0, console.warn(`Invalid role [${a}] passed to <Dialog />. Only \`dialog\` and and \`alertdialog\` are supported. Using \`dialog\` instead.`)), "dialog");
    }();
    let E = (0, $7a3499b4b3c6f184$export$fc6fdf0ecf360e)();
    n === void 0 && E !== null && (n = (E & (0, $7a3499b4b3c6f184$export$7254cc27399e90bd).Open) === (0, $7a3499b4b3c6f184$export$7254cc27399e90bd).Open);
    let D = (0, $acw62.useRef)(null), ee = (0, $4a1854c6a3ad5196$export$f6a25a78204acc7e)(D, e), g = (0, $42a08b28a285ca8e$export$dd9fbcea3de0ae36)(D), W = t.hasOwnProperty("open") || E !== null, $ = t.hasOwnProperty("onClose");
    if (!W && !$) throw new Error("You have to provide an `open` and an `onClose` prop to the `Dialog` component.");
    if (!W) throw new Error("You provided an `onClose` prop to the `Dialog`, but forgot an `open` prop.");
    if (!$) throw new Error("You provided an `open` prop to the `Dialog`, but forgot an `onClose` prop.");
    if (typeof n != "boolean") throw new Error(`You provided an \`open\` prop to the \`Dialog\`, but the value is not a boolean. Received: ${n}`);
    if (typeof l != "function") throw new Error(`You provided an \`onClose\` prop to the \`Dialog\`, but the value is not a function. Received: ${l}`);
    let p = n ? 0 : 1, [h, te] = (0, $acw62.useReducer)($fd89a26ac969b4f3$var$Ge, {
        titleId: null,
        descriptionId: null,
        panelRef: (0, $acw62.createRef)()
    }), P = (0, $0bd9972698c32399$export$90fc3a17d93f704c)(()=>l(!1)), Y = (0, $0bd9972698c32399$export$90fc3a17d93f704c)((o)=>te({
            type: 0,
            id: o
        })), S = (0, $81b1abbf8717f9cc$export$44ab2b9f2d09b0fa)() ? T ? !1 : p === 0 : !1, x = M > 1, j = (0, $acw62.useContext)($fd89a26ac969b4f3$var$I) !== null, [oe, re] = (0, $a4e89ae9835d0556$export$26b8c35244a70b37)(), ne = {
        get current () {
            var o;
            return (o = h.panelRef.current) != null ? o : D.current;
        }
    }, { resolveContainers: w, mainTreeNodeRef: L, MainTreeNode: le } = (0, $df81719180936f93$export$445f2d1a3d9b1b9f)({
        portals: oe,
        defaultContainers: [
            ne
        ]
    }), ae = x ? "parent" : "leaf", J = E !== null ? (E & (0, $7a3499b4b3c6f184$export$7254cc27399e90bd).Closing) === (0, $7a3499b4b3c6f184$export$7254cc27399e90bd).Closing : !1, ie = (()=>j || J ? !1 : S)(), se = (0, $acw62.useCallback)(()=>{
        var o, c;
        return (c = Array.from((o = g == null ? void 0 : g.querySelectorAll("body > *")) != null ? o : []).find((d)=>d.id === "headlessui-portal-root" ? !1 : d.contains(L.current) && d instanceof HTMLElement)) != null ? c : null;
    }, [
        L
    ]);
    (0, $11805c0c83dbefad$export$bbe4e2927a3450da)(se, ie);
    let pe = (()=>x ? !0 : S)(), de = (0, $acw62.useCallback)(()=>{
        var o, c;
        return (c = Array.from((o = g == null ? void 0 : g.querySelectorAll("[data-headlessui-portal]")) != null ? o : []).find((d)=>d.contains(L.current) && d instanceof HTMLElement)) != null ? c : null;
    }, [
        L
    ]);
    (0, $11805c0c83dbefad$export$bbe4e2927a3450da)(de, pe);
    let ue = (()=>!(!S || x))();
    (0, $17eff26b89e4b024$export$71b2224f1ce5e08e)(w, P, ue);
    let fe = (()=>!(x || p !== 0))();
    (0, $faafded37f338b1b$export$7080b3e976bc91ab)(g == null ? void 0 : g.defaultView, "keydown", (o)=>{
        fe && (o.defaultPrevented || o.key === (0, $4cca0dbc68b0507a$export$4b0075e5ea5e1f26).Escape && (o.preventDefault(), o.stopPropagation(), P()));
    });
    let ge = (()=>!(J || p !== 0 || j))();
    $fd89a26ac969b4f3$var$Be(g, ge, w), (0, $acw62.useEffect)(()=>{
        if (p !== 0 || !D.current) return;
        let o = new ResizeObserver((c)=>{
            for (let d of c){
                let F = d.target.getBoundingClientRect();
                F.x === 0 && F.y === 0 && F.width === 0 && F.height === 0 && P();
            }
        });
        return o.observe(D.current), ()=>o.disconnect();
    }, [
        p,
        D,
        P
    ]);
    let [Te, ce] = (0, $d994aee5798540d7$export$babde88292020af7)(), De = (0, $acw62.useMemo)(()=>[
            {
                dialogState: p,
                close: P,
                setTitleId: Y
            },
            h
        ], [
        p,
        h,
        P,
        Y
    ]), X = (0, $acw62.useMemo)(()=>({
            open: p === 0
        }), [
        p
    ]), me = {
        ref: ee,
        id: i,
        role: a,
        "aria-modal": p === 0 ? !0 : void 0,
        "aria-labelledby": h.titleId,
        "aria-describedby": Te
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1f71d3aaee714e67$export$4aac1a6640027f56), {
        type: "Dialog",
        enabled: p === 0,
        element: D,
        onUpdate: (0, $0bd9972698c32399$export$90fc3a17d93f704c)((o, c)=>{
            c === "Dialog" && (0, $4f240e1aafd2c298$export$4659b591c19bdf3d)(o, {
                [(0, $1f71d3aaee714e67$export$2dd25ef07fea092e).Add]: ()=>f((d)=>d + 1),
                [(0, $1f71d3aaee714e67$export$2dd25ef07fea092e).Remove]: ()=>f((d)=>d - 1)
            });
        })
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7e5993dca17d6628$export$8f2af6644e3a3c93), {
        force: !0
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a4e89ae9835d0556$export$602eac185826482c), null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($fd89a26ac969b4f3$var$I.Provider, {
        value: De
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a4e89ae9835d0556$export$602eac185826482c).Group, {
        target: D
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7e5993dca17d6628$export$8f2af6644e3a3c93), {
        force: !1
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(ce, {
        slot: X,
        name: "Dialog.Description"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $38ecc25572962dee$export$34eba2437817a67b), {
        initialFocus: s,
        containers: w,
        features: S ? (0, $4f240e1aafd2c298$export$4659b591c19bdf3d)(ae, {
            parent: (0, $38ecc25572962dee$export$34eba2437817a67b).features.RestoreFocus,
            leaf: (0, $38ecc25572962dee$export$34eba2437817a67b).features.All & ~(0, $38ecc25572962dee$export$34eba2437817a67b).features.FocusLock
        }) : (0, $38ecc25572962dee$export$34eba2437817a67b).features.None
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(re, null, (0, $a54bdd13402af126$export$b3890eb0ae9dca99)({
        ourProps: me,
        theirProps: m,
        slot: X,
        defaultTag: $fd89a26ac969b4f3$var$Ne,
        features: $fd89a26ac969b4f3$var$Ue,
        visible: p === 0,
        name: "Dialog"
    }))))))))), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(le, null));
}
let $fd89a26ac969b4f3$var$$e = "div";
function $fd89a26ac969b4f3$var$Ye(t, e) {
    let r = (0, $f2a0dea4caee12c6$export$f680877a34711e37)(), { id: i = `headlessui-dialog-overlay-${r}`, ...n } = t, [{ dialogState: l, close: s }] = $fd89a26ac969b4f3$var$b("Dialog.Overlay"), a = (0, $4a1854c6a3ad5196$export$f6a25a78204acc7e)(e), T = (0, $0bd9972698c32399$export$90fc3a17d93f704c)((f)=>{
        if (f.target === f.currentTarget) {
            if ((0, $3d3d670dbe2ceed6$export$db61f031a278447c)(f.currentTarget)) return f.preventDefault();
            f.preventDefault(), f.stopPropagation(), s();
        }
    }), m = (0, $acw62.useMemo)(()=>({
            open: l === 0
        }), [
        l
    ]);
    return (0, $a54bdd13402af126$export$b3890eb0ae9dca99)({
        ourProps: {
            ref: a,
            id: i,
            "aria-hidden": !0,
            onClick: T
        },
        theirProps: n,
        slot: m,
        defaultTag: $fd89a26ac969b4f3$var$$e,
        name: "Dialog.Overlay"
    });
}
let $fd89a26ac969b4f3$var$je = "div";
function $fd89a26ac969b4f3$var$Je(t, e) {
    let r = (0, $f2a0dea4caee12c6$export$f680877a34711e37)(), { id: i = `headlessui-dialog-backdrop-${r}`, ...n } = t, [{ dialogState: l }, s] = $fd89a26ac969b4f3$var$b("Dialog.Backdrop"), a = (0, $4a1854c6a3ad5196$export$f6a25a78204acc7e)(e);
    (0, $acw62.useEffect)(()=>{
        if (s.panelRef.current === null) throw new Error("A <Dialog.Backdrop /> component is being used, but a <Dialog.Panel /> component is missing.");
    }, [
        s.panelRef
    ]);
    let T = (0, $acw62.useMemo)(()=>({
            open: l === 0
        }), [
        l
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7e5993dca17d6628$export$8f2af6644e3a3c93), {
        force: !0
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a4e89ae9835d0556$export$602eac185826482c), null, (0, $a54bdd13402af126$export$b3890eb0ae9dca99)({
        ourProps: {
            ref: a,
            id: i,
            "aria-hidden": !0
        },
        theirProps: n,
        slot: T,
        defaultTag: $fd89a26ac969b4f3$var$je,
        name: "Dialog.Backdrop"
    })));
}
let $fd89a26ac969b4f3$var$Xe = "div";
function $fd89a26ac969b4f3$var$Ke(t, e) {
    let r = (0, $f2a0dea4caee12c6$export$f680877a34711e37)(), { id: i = `headlessui-dialog-panel-${r}`, ...n } = t, [{ dialogState: l }, s] = $fd89a26ac969b4f3$var$b("Dialog.Panel"), a = (0, $4a1854c6a3ad5196$export$f6a25a78204acc7e)(e, s.panelRef), T = (0, $acw62.useMemo)(()=>({
            open: l === 0
        }), [
        l
    ]), m = (0, $0bd9972698c32399$export$90fc3a17d93f704c)((f)=>{
        f.stopPropagation();
    });
    return (0, $a54bdd13402af126$export$b3890eb0ae9dca99)({
        ourProps: {
            ref: a,
            id: i,
            onClick: m
        },
        theirProps: n,
        slot: T,
        defaultTag: $fd89a26ac969b4f3$var$Xe,
        name: "Dialog.Panel"
    });
}
let $fd89a26ac969b4f3$var$Ve = "h2";
function $fd89a26ac969b4f3$var$qe(t, e) {
    let r = (0, $f2a0dea4caee12c6$export$f680877a34711e37)(), { id: i = `headlessui-dialog-title-${r}`, ...n } = t, [{ dialogState: l, setTitleId: s }] = $fd89a26ac969b4f3$var$b("Dialog.Title"), a = (0, $4a1854c6a3ad5196$export$f6a25a78204acc7e)(e);
    (0, $acw62.useEffect)(()=>(s(i), ()=>s(null)), [
        i,
        s
    ]);
    let T = (0, $acw62.useMemo)(()=>({
            open: l === 0
        }), [
        l
    ]);
    return (0, $a54bdd13402af126$export$b3890eb0ae9dca99)({
        ourProps: {
            ref: a,
            id: i
        },
        theirProps: n,
        slot: T,
        defaultTag: $fd89a26ac969b4f3$var$Ve,
        name: "Dialog.Title"
    });
}
let $fd89a26ac969b4f3$var$ze = (0, $a54bdd13402af126$export$e43f39796049410c)($fd89a26ac969b4f3$var$We), $fd89a26ac969b4f3$var$Qe = (0, $a54bdd13402af126$export$e43f39796049410c)($fd89a26ac969b4f3$var$Je), $fd89a26ac969b4f3$var$Ze = (0, $a54bdd13402af126$export$e43f39796049410c)($fd89a26ac969b4f3$var$Ke), $fd89a26ac969b4f3$var$et = (0, $a54bdd13402af126$export$e43f39796049410c)($fd89a26ac969b4f3$var$Ye), $fd89a26ac969b4f3$var$tt = (0, $a54bdd13402af126$export$e43f39796049410c)($fd89a26ac969b4f3$var$qe), $fd89a26ac969b4f3$export$3ddf2d174ce01153 = Object.assign($fd89a26ac969b4f3$var$ze, {
    Backdrop: $fd89a26ac969b4f3$var$Qe,
    Panel: $fd89a26ac969b4f3$var$Ze,
    Overlay: $fd89a26ac969b4f3$var$et,
    Title: $fd89a26ac969b4f3$var$tt,
    Description: (0, $d994aee5798540d7$export$393edc798c47379d)
});


var $780306decd8ad6d8$exports = {};

$parcel$export($780306decd8ad6d8$exports, "Disclosure", () => $780306decd8ad6d8$export$74a362b31437ec83);

var $acw62 = parcelRequire("acw62");










var $acw62 = parcelRequire("acw62");
var $28eda363e18564ac$var$t;
let $28eda363e18564ac$export$7568632d0d33d16d = ($28eda363e18564ac$var$t = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).startTransition) != null ? $28eda363e18564ac$var$t : function(i) {
    i();
};



var $780306decd8ad6d8$var$Q = ((o)=>(o[o.Open = 0] = "Open", o[o.Closed = 1] = "Closed", o))($780306decd8ad6d8$var$Q || {}), $780306decd8ad6d8$var$V = ((t)=>(t[t.ToggleDisclosure = 0] = "ToggleDisclosure", t[t.CloseDisclosure = 1] = "CloseDisclosure", t[t.SetButtonId = 2] = "SetButtonId", t[t.SetPanelId = 3] = "SetPanelId", t[t.LinkPanel = 4] = "LinkPanel", t[t.UnlinkPanel = 5] = "UnlinkPanel", t))($780306decd8ad6d8$var$V || {});
let $780306decd8ad6d8$var$Y = {
    [0]: (e)=>({
            ...e,
            disclosureState: (0, $4f240e1aafd2c298$export$4659b591c19bdf3d)(e.disclosureState, {
                [0]: 1,
                [1]: 0
            })
        }),
    [1]: (e)=>e.disclosureState === 1 ? e : {
            ...e,
            disclosureState: 1
        },
    [4] (e) {
        return e.linkedPanel === !0 ? e : {
            ...e,
            linkedPanel: !0
        };
    },
    [5] (e) {
        return e.linkedPanel === !1 ? e : {
            ...e,
            linkedPanel: !1
        };
    },
    [2] (e, n) {
        return e.buttonId === n.buttonId ? e : {
            ...e,
            buttonId: n.buttonId
        };
    },
    [3] (e, n) {
        return e.panelId === n.panelId ? e : {
            ...e,
            panelId: n.panelId
        };
    }
}, $780306decd8ad6d8$var$M = (0, $acw62.createContext)(null);
$780306decd8ad6d8$var$M.displayName = "DisclosureContext";
function $780306decd8ad6d8$var$_(e) {
    let n = (0, $acw62.useContext)($780306decd8ad6d8$var$M);
    if (n === null) {
        let o = new Error(`<${e} /> is missing a parent <Disclosure /> component.`);
        throw Error.captureStackTrace && Error.captureStackTrace(o, $780306decd8ad6d8$var$_), o;
    }
    return n;
}
let $780306decd8ad6d8$var$v = (0, $acw62.createContext)(null);
$780306decd8ad6d8$var$v.displayName = "DisclosureAPIContext";
function $780306decd8ad6d8$var$K(e) {
    let n = (0, $acw62.useContext)($780306decd8ad6d8$var$v);
    if (n === null) {
        let o = new Error(`<${e} /> is missing a parent <Disclosure /> component.`);
        throw Error.captureStackTrace && Error.captureStackTrace(o, $780306decd8ad6d8$var$K), o;
    }
    return n;
}
let $780306decd8ad6d8$var$F = (0, $acw62.createContext)(null);
$780306decd8ad6d8$var$F.displayName = "DisclosurePanelContext";
function $780306decd8ad6d8$var$Z() {
    return (0, $acw62.useContext)($780306decd8ad6d8$var$F);
}
function $780306decd8ad6d8$var$ee(e, n) {
    return (0, $4f240e1aafd2c298$export$4659b591c19bdf3d)(n.type, $780306decd8ad6d8$var$Y, e, n);
}
let $780306decd8ad6d8$var$te = (0, $acw62.Fragment);
function $780306decd8ad6d8$var$ne(e, n) {
    let { defaultOpen: o = !1, ...i } = e, f = (0, $acw62.useRef)(null), l = (0, $4a1854c6a3ad5196$export$f6a25a78204acc7e)(n, (0, $4a1854c6a3ad5196$export$7029785b750eb74)((u)=>{
        f.current = u;
    }, e.as === void 0 || e.as === (0, $acw62.Fragment))), t = (0, $acw62.useRef)(null), d = (0, $acw62.useRef)(null), s = (0, $acw62.useReducer)($780306decd8ad6d8$var$ee, {
        disclosureState: o ? 0 : 1,
        linkedPanel: !1,
        buttonRef: d,
        panelRef: t,
        buttonId: null,
        panelId: null
    }), [{ disclosureState: c, buttonId: a }, D] = s, p = (0, $0bd9972698c32399$export$90fc3a17d93f704c)((u)=>{
        D({
            type: 1
        });
        let y = (0, $c0a913ecfa4bf5e5$export$b204af158042fbac)(f);
        if (!y || !a) return;
        let r = (()=>u ? u instanceof HTMLElement ? u : u.current instanceof HTMLElement ? u.current : y.getElementById(a) : y.getElementById(a))();
        r == null || r.focus();
    }), P = (0, $acw62.useMemo)(()=>({
            close: p
        }), [
        p
    ]), T = (0, $acw62.useMemo)(()=>({
            open: c === 0,
            close: p
        }), [
        c,
        p
    ]), C = {
        ref: l
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($780306decd8ad6d8$var$M.Provider, {
        value: s
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($780306decd8ad6d8$var$v.Provider, {
        value: P
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7a3499b4b3c6f184$export$2a0ed818b175f558), {
        value: (0, $4f240e1aafd2c298$export$4659b591c19bdf3d)(c, {
            [0]: (0, $7a3499b4b3c6f184$export$7254cc27399e90bd).Open,
            [1]: (0, $7a3499b4b3c6f184$export$7254cc27399e90bd).Closed
        })
    }, (0, $a54bdd13402af126$export$b3890eb0ae9dca99)({
        ourProps: C,
        theirProps: i,
        slot: T,
        defaultTag: $780306decd8ad6d8$var$te,
        name: "Disclosure"
    }))));
}
let $780306decd8ad6d8$var$le = "button";
function $780306decd8ad6d8$var$oe(e, n) {
    let o = (0, $f2a0dea4caee12c6$export$f680877a34711e37)(), { id: i = `headlessui-disclosure-button-${o}`, ...f } = e, [l, t] = $780306decd8ad6d8$var$_("Disclosure.Button"), d = $780306decd8ad6d8$var$Z(), s = d === null ? !1 : d === l.panelId, c = (0, $acw62.useRef)(null), a = (0, $4a1854c6a3ad5196$export$f6a25a78204acc7e)(c, n, s ? null : l.buttonRef), D = (0, $a54bdd13402af126$export$81218df071161f0a)();
    (0, $acw62.useEffect)(()=>{
        if (!s) return t({
            type: 2,
            buttonId: i
        }), ()=>{
            t({
                type: 2,
                buttonId: null
            });
        };
    }, [
        i,
        t,
        s
    ]);
    let p = (0, $0bd9972698c32399$export$90fc3a17d93f704c)((r)=>{
        var m;
        if (s) {
            if (l.disclosureState === 1) return;
            switch(r.key){
                case (0, $4cca0dbc68b0507a$export$4b0075e5ea5e1f26).Space:
                case (0, $4cca0dbc68b0507a$export$4b0075e5ea5e1f26).Enter:
                    r.preventDefault(), r.stopPropagation(), t({
                        type: 0
                    }), (m = l.buttonRef.current) == null || m.focus();
                    break;
            }
        } else switch(r.key){
            case (0, $4cca0dbc68b0507a$export$4b0075e5ea5e1f26).Space:
            case (0, $4cca0dbc68b0507a$export$4b0075e5ea5e1f26).Enter:
                r.preventDefault(), r.stopPropagation(), t({
                    type: 0
                });
                break;
        }
    }), P = (0, $0bd9972698c32399$export$90fc3a17d93f704c)((r)=>{
        switch(r.key){
            case (0, $4cca0dbc68b0507a$export$4b0075e5ea5e1f26).Space:
                r.preventDefault();
                break;
        }
    }), T = (0, $0bd9972698c32399$export$90fc3a17d93f704c)((r)=>{
        var m;
        (0, $3d3d670dbe2ceed6$export$db61f031a278447c)(r.currentTarget) || e.disabled || (s ? (t({
            type: 0
        }), (m = l.buttonRef.current) == null || m.focus()) : t({
            type: 0
        }));
    }), C = (0, $acw62.useMemo)(()=>({
            open: l.disclosureState === 0
        }), [
        l
    ]), u = (0, $be828d8bf9bb25ca$export$53652b2b272efe9c)(e, c), y = s ? {
        ref: a,
        type: u,
        onKeyDown: p,
        onClick: T
    } : {
        ref: a,
        id: i,
        type: u,
        "aria-expanded": l.disclosureState === 0,
        "aria-controls": l.linkedPanel ? l.panelId : void 0,
        onKeyDown: p,
        onKeyUp: P,
        onClick: T
    };
    return (0, $a54bdd13402af126$export$b3890eb0ae9dca99)({
        mergeRefs: D,
        ourProps: y,
        theirProps: f,
        slot: C,
        defaultTag: $780306decd8ad6d8$var$le,
        name: "Disclosure.Button"
    });
}
let $780306decd8ad6d8$var$re = "div", $780306decd8ad6d8$var$se = (0, $a54bdd13402af126$export$617d79dae526d2cf).RenderStrategy | (0, $a54bdd13402af126$export$617d79dae526d2cf).Static;
function $780306decd8ad6d8$var$ue(e, n) {
    let o = (0, $f2a0dea4caee12c6$export$f680877a34711e37)(), { id: i = `headlessui-disclosure-panel-${o}`, ...f } = e, [l, t] = $780306decd8ad6d8$var$_("Disclosure.Panel"), { close: d } = $780306decd8ad6d8$var$K("Disclosure.Panel"), s = (0, $a54bdd13402af126$export$81218df071161f0a)(), c = (0, $4a1854c6a3ad5196$export$f6a25a78204acc7e)(n, l.panelRef, (T)=>{
        (0, $28eda363e18564ac$export$7568632d0d33d16d)(()=>t({
                type: T ? 4 : 5
            }));
    });
    (0, $acw62.useEffect)(()=>(t({
            type: 3,
            panelId: i
        }), ()=>{
            t({
                type: 3,
                panelId: null
            });
        }), [
        i,
        t
    ]);
    let a = (0, $7a3499b4b3c6f184$export$fc6fdf0ecf360e)(), D = (()=>a !== null ? (a & (0, $7a3499b4b3c6f184$export$7254cc27399e90bd).Open) === (0, $7a3499b4b3c6f184$export$7254cc27399e90bd).Open : l.disclosureState === 0)(), p = (0, $acw62.useMemo)(()=>({
            open: l.disclosureState === 0,
            close: d
        }), [
        l,
        d
    ]), P = {
        ref: c,
        id: i
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($780306decd8ad6d8$var$F.Provider, {
        value: l.panelId
    }, (0, $a54bdd13402af126$export$b3890eb0ae9dca99)({
        mergeRefs: s,
        ourProps: P,
        theirProps: f,
        slot: p,
        defaultTag: $780306decd8ad6d8$var$re,
        features: $780306decd8ad6d8$var$se,
        visible: D,
        name: "Disclosure.Panel"
    }));
}
let $780306decd8ad6d8$var$ie = (0, $a54bdd13402af126$export$e43f39796049410c)($780306decd8ad6d8$var$ne), $780306decd8ad6d8$var$ae = (0, $a54bdd13402af126$export$e43f39796049410c)($780306decd8ad6d8$var$oe), $780306decd8ad6d8$var$pe = (0, $a54bdd13402af126$export$e43f39796049410c)($780306decd8ad6d8$var$ue), $780306decd8ad6d8$export$74a362b31437ec83 = Object.assign($780306decd8ad6d8$var$ie, {
    Button: $780306decd8ad6d8$var$ae,
    Panel: $780306decd8ad6d8$var$pe
});



var $df20442161b20eb0$exports = {};

$parcel$export($df20442161b20eb0$exports, "Listbox", () => $df20442161b20eb0$export$8bad31ff872c7659);

var $acw62 = parcelRequire("acw62");























var $df20442161b20eb0$var$Be = ((n)=>(n[n.Open = 0] = "Open", n[n.Closed = 1] = "Closed", n))($df20442161b20eb0$var$Be || {}), $df20442161b20eb0$var$He = ((n)=>(n[n.Single = 0] = "Single", n[n.Multi = 1] = "Multi", n))($df20442161b20eb0$var$He || {}), $df20442161b20eb0$var$Ge = ((n)=>(n[n.Pointer = 0] = "Pointer", n[n.Other = 1] = "Other", n))($df20442161b20eb0$var$Ge || {}), $df20442161b20eb0$var$Ne = ((i)=>(i[i.OpenListbox = 0] = "OpenListbox", i[i.CloseListbox = 1] = "CloseListbox", i[i.GoToOption = 2] = "GoToOption", i[i.Search = 3] = "Search", i[i.ClearSearch = 4] = "ClearSearch", i[i.RegisterOption = 5] = "RegisterOption", i[i.UnregisterOption = 6] = "UnregisterOption", i[i.RegisterLabel = 7] = "RegisterLabel", i))($df20442161b20eb0$var$Ne || {});
function $df20442161b20eb0$var$z(e, a = (n)=>n) {
    let n = e.activeOptionIndex !== null ? e.options[e.activeOptionIndex] : null, r = (0, $cb6dceb64e6c0606$export$20305e96f91bf103)(a(e.options.slice()), (t)=>t.dataRef.current.domRef.current), l = n ? r.indexOf(n) : null;
    return l === -1 && (l = null), {
        options: r,
        activeOptionIndex: l
    };
}
let $df20442161b20eb0$var$je = {
    [1] (e) {
        return e.dataRef.current.disabled || e.listboxState === 1 ? e : {
            ...e,
            activeOptionIndex: null,
            listboxState: 1
        };
    },
    [0] (e) {
        if (e.dataRef.current.disabled || e.listboxState === 0) return e;
        let a = e.activeOptionIndex, { isSelected: n } = e.dataRef.current, r = e.options.findIndex((l)=>n(l.dataRef.current.value));
        return r !== -1 && (a = r), {
            ...e,
            listboxState: 0,
            activeOptionIndex: a
        };
    },
    [2] (e, a) {
        var l;
        if (e.dataRef.current.disabled || e.listboxState === 1) return e;
        let n = $df20442161b20eb0$var$z(e), r = (0, $b7a0b87cd8a0fa3d$export$c6b4626b54936d5e)(a, {
            resolveItems: ()=>n.options,
            resolveActiveIndex: ()=>n.activeOptionIndex,
            resolveId: (t)=>t.id,
            resolveDisabled: (t)=>t.dataRef.current.disabled
        });
        return {
            ...e,
            ...n,
            searchQuery: "",
            activeOptionIndex: r,
            activationTrigger: (l = a.trigger) != null ? l : 1
        };
    },
    [3]: (e, a)=>{
        if (e.dataRef.current.disabled || e.listboxState === 1) return e;
        let r = e.searchQuery !== "" ? 0 : 1, l = e.searchQuery + a.value.toLowerCase(), p = (e.activeOptionIndex !== null ? e.options.slice(e.activeOptionIndex + r).concat(e.options.slice(0, e.activeOptionIndex + r)) : e.options).find((i)=>{
            var b;
            return !i.dataRef.current.disabled && ((b = i.dataRef.current.textValue) == null ? void 0 : b.startsWith(l));
        }), u = p ? e.options.indexOf(p) : -1;
        return u === -1 || u === e.activeOptionIndex ? {
            ...e,
            searchQuery: l
        } : {
            ...e,
            searchQuery: l,
            activeOptionIndex: u,
            activationTrigger: 1
        };
    },
    [4] (e) {
        return e.dataRef.current.disabled || e.listboxState === 1 || e.searchQuery === "" ? e : {
            ...e,
            searchQuery: ""
        };
    },
    [5]: (e, a)=>{
        let n = {
            id: a.id,
            dataRef: a.dataRef
        }, r = $df20442161b20eb0$var$z(e, (l)=>[
                ...l,
                n
            ]);
        return e.activeOptionIndex === null && e.dataRef.current.isSelected(a.dataRef.current.value) && (r.activeOptionIndex = r.options.indexOf(n)), {
            ...e,
            ...r
        };
    },
    [6]: (e, a)=>{
        let n = $df20442161b20eb0$var$z(e, (r)=>{
            let l = r.findIndex((t)=>t.id === a.id);
            return l !== -1 && r.splice(l, 1), r;
        });
        return {
            ...e,
            ...n,
            activationTrigger: 1
        };
    },
    [7]: (e, a)=>({
            ...e,
            labelId: a.id
        })
}, $df20442161b20eb0$var$J = (0, $acw62.createContext)(null);
$df20442161b20eb0$var$J.displayName = "ListboxActionsContext";
function $df20442161b20eb0$var$k(e) {
    let a = (0, $acw62.useContext)($df20442161b20eb0$var$J);
    if (a === null) {
        let n = new Error(`<${e} /> is missing a parent <Listbox /> component.`);
        throw Error.captureStackTrace && Error.captureStackTrace(n, $df20442161b20eb0$var$k), n;
    }
    return a;
}
let $df20442161b20eb0$var$q = (0, $acw62.createContext)(null);
$df20442161b20eb0$var$q.displayName = "ListboxDataContext";
function $df20442161b20eb0$var$w(e) {
    let a = (0, $acw62.useContext)($df20442161b20eb0$var$q);
    if (a === null) {
        let n = new Error(`<${e} /> is missing a parent <Listbox /> component.`);
        throw Error.captureStackTrace && Error.captureStackTrace(n, $df20442161b20eb0$var$w), n;
    }
    return a;
}
function $df20442161b20eb0$var$Ve(e, a) {
    return (0, $4f240e1aafd2c298$export$4659b591c19bdf3d)(a.type, $df20442161b20eb0$var$je, e, a);
}
let $df20442161b20eb0$var$Ke = (0, $acw62.Fragment);
function $df20442161b20eb0$var$Qe(e, a) {
    let { value: n, defaultValue: r, form: l, name: t, onChange: p, by: u = (s, c)=>s === c, disabled: i = !1, horizontal: b = !1, multiple: R = !1, ...m } = e;
    const P = b ? "horizontal" : "vertical";
    let S = (0, $4a1854c6a3ad5196$export$f6a25a78204acc7e)(a), [g = R ? [] : void 0, x] = (0, $c6676ed1f400443a$export$454217e89aea72b)(n, p, r), [T, o] = (0, $acw62.useReducer)($df20442161b20eb0$var$Ve, {
        dataRef: (0, $acw62.createRef)(),
        listboxState: 1,
        options: [],
        searchQuery: "",
        labelId: null,
        activeOptionIndex: null,
        activationTrigger: 1
    }), L = (0, $acw62.useRef)({
        static: !1,
        hold: !1
    }), U = (0, $acw62.useRef)(null), B = (0, $acw62.useRef)(null), W = (0, $acw62.useRef)(null), I = (0, $0bd9972698c32399$export$90fc3a17d93f704c)(typeof u == "string" ? (s, c)=>{
        let O = u;
        return (s == null ? void 0 : s[O]) === (c == null ? void 0 : c[O]);
    } : u), A = (0, $acw62.useCallback)((s)=>(0, $4f240e1aafd2c298$export$4659b591c19bdf3d)(d.mode, {
            [1]: ()=>g.some((c)=>I(c, s)),
            [0]: ()=>I(g, s)
        }), [
        g
    ]), d = (0, $acw62.useMemo)(()=>({
            ...T,
            value: g,
            disabled: i,
            mode: R ? 1 : 0,
            orientation: P,
            compare: I,
            isSelected: A,
            optionsPropsRef: L,
            labelRef: U,
            buttonRef: B,
            optionsRef: W
        }), [
        g,
        i,
        R,
        T
    ]);
    (0, $65df95ec9b1bb6a8$export$ce5ed857c741fd71)(()=>{
        T.dataRef.current = d;
    }, [
        d
    ]), (0, $17eff26b89e4b024$export$71b2224f1ce5e08e)([
        d.buttonRef,
        d.optionsRef
    ], (s, c)=>{
        var O;
        o({
            type: 1
        }), (0, $cb6dceb64e6c0606$export$ff1ec1c740b3c8d5)(c, (0, $cb6dceb64e6c0606$export$27112a34f2f8402d).Loose) || (s.preventDefault(), (O = d.buttonRef.current) == null || O.focus());
    }, d.listboxState === 0);
    let H = (0, $acw62.useMemo)(()=>({
            open: d.listboxState === 0,
            disabled: i,
            value: g
        }), [
        d,
        i,
        g
    ]), ie = (0, $0bd9972698c32399$export$90fc3a17d93f704c)((s)=>{
        let c = d.options.find((O)=>O.id === s);
        c && X(c.dataRef.current.value);
    }), re = (0, $0bd9972698c32399$export$90fc3a17d93f704c)(()=>{
        if (d.activeOptionIndex !== null) {
            let { dataRef: s, id: c } = d.options[d.activeOptionIndex];
            X(s.current.value), o({
                type: 2,
                focus: (0, $b7a0b87cd8a0fa3d$export$807a7eae502106e7).Specific,
                id: c
            });
        }
    }), ae = (0, $0bd9972698c32399$export$90fc3a17d93f704c)(()=>o({
            type: 0
        })), le = (0, $0bd9972698c32399$export$90fc3a17d93f704c)(()=>o({
            type: 1
        })), se = (0, $0bd9972698c32399$export$90fc3a17d93f704c)((s, c, O)=>s === (0, $b7a0b87cd8a0fa3d$export$807a7eae502106e7).Specific ? o({
            type: 2,
            focus: (0, $b7a0b87cd8a0fa3d$export$807a7eae502106e7).Specific,
            id: c,
            trigger: O
        }) : o({
            type: 2,
            focus: s,
            trigger: O
        })), pe = (0, $0bd9972698c32399$export$90fc3a17d93f704c)((s, c)=>(o({
            type: 5,
            id: s,
            dataRef: c
        }), ()=>o({
                type: 6,
                id: s
            }))), ue = (0, $0bd9972698c32399$export$90fc3a17d93f704c)((s)=>(o({
            type: 7,
            id: s
        }), ()=>o({
                type: 7,
                id: null
            }))), X = (0, $0bd9972698c32399$export$90fc3a17d93f704c)((s)=>(0, $4f240e1aafd2c298$export$4659b591c19bdf3d)(d.mode, {
            [0] () {
                return x == null ? void 0 : x(s);
            },
            [1] () {
                let c = d.value.slice(), O = c.findIndex((C)=>I(C, s));
                return O === -1 ? c.push(s) : c.splice(O, 1), x == null ? void 0 : x(c);
            }
        })), de = (0, $0bd9972698c32399$export$90fc3a17d93f704c)((s)=>o({
            type: 3,
            value: s
        })), ce = (0, $0bd9972698c32399$export$90fc3a17d93f704c)(()=>o({
            type: 4
        })), fe = (0, $acw62.useMemo)(()=>({
            onChange: X,
            registerOption: pe,
            registerLabel: ue,
            goToOption: se,
            closeListbox: le,
            openListbox: ae,
            selectActiveOption: re,
            selectOption: ie,
            search: de,
            clearSearch: ce
        }), []), Te = {
        ref: S
    }, G = (0, $acw62.useRef)(null), be = (0, $410e668b7f520622$export$fd183955ff4b45d9)();
    return (0, $acw62.useEffect)(()=>{
        G.current && r !== void 0 && be.addEventListener(G.current, "reset", ()=>{
            x == null || x(r);
        });
    }, [
        G,
        x
    ]), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($df20442161b20eb0$var$J.Provider, {
        value: fe
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($df20442161b20eb0$var$q.Provider, {
        value: d
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7a3499b4b3c6f184$export$2a0ed818b175f558), {
        value: (0, $4f240e1aafd2c298$export$4659b591c19bdf3d)(d.listboxState, {
            [0]: (0, $7a3499b4b3c6f184$export$7254cc27399e90bd).Open,
            [1]: (0, $7a3499b4b3c6f184$export$7254cc27399e90bd).Closed
        })
    }, t != null && g != null && (0, $594e79751740d704$export$bc22b3e852574dab)({
        [t]: g
    }).map(([s, c], O)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $eac0d614a77ee96b$export$8dc98ba7eadeaa56), {
            features: (0, $eac0d614a77ee96b$export$617d79dae526d2cf).Hidden,
            ref: O === 0 ? (C)=>{
                var Y;
                G.current = (Y = C == null ? void 0 : C.closest("form")) != null ? Y : null;
            } : void 0,
            ...(0, $a54bdd13402af126$export$8e16b83750b44988)({
                key: s,
                as: "input",
                type: "hidden",
                hidden: !0,
                readOnly: !0,
                form: l,
                name: s,
                value: c
            })
        })), (0, $a54bdd13402af126$export$b3890eb0ae9dca99)({
        ourProps: Te,
        theirProps: m,
        slot: H,
        defaultTag: $df20442161b20eb0$var$Ke,
        name: "Listbox"
    }))));
}
let $df20442161b20eb0$var$We = "button";
function $df20442161b20eb0$var$Xe(e, a) {
    var x;
    let n = (0, $f2a0dea4caee12c6$export$f680877a34711e37)(), { id: r = `headlessui-listbox-button-${n}`, ...l } = e, t = $df20442161b20eb0$var$w("Listbox.Button"), p = $df20442161b20eb0$var$k("Listbox.Button"), u = (0, $4a1854c6a3ad5196$export$f6a25a78204acc7e)(t.buttonRef, a), i = (0, $410e668b7f520622$export$fd183955ff4b45d9)(), b = (0, $0bd9972698c32399$export$90fc3a17d93f704c)((T)=>{
        switch(T.key){
            case (0, $4cca0dbc68b0507a$export$4b0075e5ea5e1f26).Space:
            case (0, $4cca0dbc68b0507a$export$4b0075e5ea5e1f26).Enter:
            case (0, $4cca0dbc68b0507a$export$4b0075e5ea5e1f26).ArrowDown:
                T.preventDefault(), p.openListbox(), i.nextFrame(()=>{
                    t.value || p.goToOption((0, $b7a0b87cd8a0fa3d$export$807a7eae502106e7).First);
                });
                break;
            case (0, $4cca0dbc68b0507a$export$4b0075e5ea5e1f26).ArrowUp:
                T.preventDefault(), p.openListbox(), i.nextFrame(()=>{
                    t.value || p.goToOption((0, $b7a0b87cd8a0fa3d$export$807a7eae502106e7).Last);
                });
                break;
        }
    }), R = (0, $0bd9972698c32399$export$90fc3a17d93f704c)((T)=>{
        switch(T.key){
            case (0, $4cca0dbc68b0507a$export$4b0075e5ea5e1f26).Space:
                T.preventDefault();
                break;
        }
    }), m = (0, $0bd9972698c32399$export$90fc3a17d93f704c)((T)=>{
        if ((0, $3d3d670dbe2ceed6$export$db61f031a278447c)(T.currentTarget)) return T.preventDefault();
        t.listboxState === 0 ? (p.closeListbox(), i.nextFrame(()=>{
            var o;
            return (o = t.buttonRef.current) == null ? void 0 : o.focus({
                preventScroll: !0
            });
        })) : (T.preventDefault(), p.openListbox());
    }), P = (0, $d78e56d87e9d66e2$export$e3d20747ab930783)(()=>{
        if (t.labelId) return [
            t.labelId,
            r
        ].join(" ");
    }, [
        t.labelId,
        r
    ]), S = (0, $acw62.useMemo)(()=>({
            open: t.listboxState === 0,
            disabled: t.disabled,
            value: t.value
        }), [
        t
    ]), g = {
        ref: u,
        id: r,
        type: (0, $be828d8bf9bb25ca$export$53652b2b272efe9c)(e, t.buttonRef),
        "aria-haspopup": "listbox",
        "aria-controls": (x = t.optionsRef.current) == null ? void 0 : x.id,
        "aria-expanded": t.listboxState === 0,
        "aria-labelledby": P,
        disabled: t.disabled,
        onKeyDown: b,
        onKeyUp: R,
        onClick: m
    };
    return (0, $a54bdd13402af126$export$b3890eb0ae9dca99)({
        ourProps: g,
        theirProps: l,
        slot: S,
        defaultTag: $df20442161b20eb0$var$We,
        name: "Listbox.Button"
    });
}
let $df20442161b20eb0$var$$e = "label";
function $df20442161b20eb0$var$ze(e, a) {
    let n = (0, $f2a0dea4caee12c6$export$f680877a34711e37)(), { id: r = `headlessui-listbox-label-${n}`, ...l } = e, t = $df20442161b20eb0$var$w("Listbox.Label"), p = $df20442161b20eb0$var$k("Listbox.Label"), u = (0, $4a1854c6a3ad5196$export$f6a25a78204acc7e)(t.labelRef, a);
    (0, $65df95ec9b1bb6a8$export$ce5ed857c741fd71)(()=>p.registerLabel(r), [
        r
    ]);
    let i = (0, $0bd9972698c32399$export$90fc3a17d93f704c)(()=>{
        var m;
        return (m = t.buttonRef.current) == null ? void 0 : m.focus({
            preventScroll: !0
        });
    }), b = (0, $acw62.useMemo)(()=>({
            open: t.listboxState === 0,
            disabled: t.disabled
        }), [
        t
    ]);
    return (0, $a54bdd13402af126$export$b3890eb0ae9dca99)({
        ourProps: {
            ref: u,
            id: r,
            onClick: i
        },
        theirProps: l,
        slot: b,
        defaultTag: $df20442161b20eb0$var$$e,
        name: "Listbox.Label"
    });
}
let $df20442161b20eb0$var$Je = "ul", $df20442161b20eb0$var$qe = (0, $a54bdd13402af126$export$617d79dae526d2cf).RenderStrategy | (0, $a54bdd13402af126$export$617d79dae526d2cf).Static;
function $df20442161b20eb0$var$Ye(e, a) {
    var T;
    let n = (0, $f2a0dea4caee12c6$export$f680877a34711e37)(), { id: r = `headlessui-listbox-options-${n}`, ...l } = e, t = $df20442161b20eb0$var$w("Listbox.Options"), p = $df20442161b20eb0$var$k("Listbox.Options"), u = (0, $4a1854c6a3ad5196$export$f6a25a78204acc7e)(t.optionsRef, a), i = (0, $410e668b7f520622$export$fd183955ff4b45d9)(), b = (0, $410e668b7f520622$export$fd183955ff4b45d9)(), R = (0, $7a3499b4b3c6f184$export$fc6fdf0ecf360e)(), m = (()=>R !== null ? (R & (0, $7a3499b4b3c6f184$export$7254cc27399e90bd).Open) === (0, $7a3499b4b3c6f184$export$7254cc27399e90bd).Open : t.listboxState === 0)();
    (0, $acw62.useEffect)(()=>{
        var L;
        let o = t.optionsRef.current;
        o && t.listboxState === 0 && o !== ((L = (0, $c0a913ecfa4bf5e5$export$b204af158042fbac)(o)) == null ? void 0 : L.activeElement) && o.focus({
            preventScroll: !0
        });
    }, [
        t.listboxState,
        t.optionsRef
    ]);
    let P = (0, $0bd9972698c32399$export$90fc3a17d93f704c)((o)=>{
        switch(b.dispose(), o.key){
            case (0, $4cca0dbc68b0507a$export$4b0075e5ea5e1f26).Space:
                if (t.searchQuery !== "") return o.preventDefault(), o.stopPropagation(), p.search(o.key);
            case (0, $4cca0dbc68b0507a$export$4b0075e5ea5e1f26).Enter:
                if (o.preventDefault(), o.stopPropagation(), t.activeOptionIndex !== null) {
                    let { dataRef: L } = t.options[t.activeOptionIndex];
                    p.onChange(L.current.value);
                }
                t.mode === 0 && (p.closeListbox(), (0, $12f0e1633d904536$export$12b26c28a05aa001)().nextFrame(()=>{
                    var L;
                    return (L = t.buttonRef.current) == null ? void 0 : L.focus({
                        preventScroll: !0
                    });
                }));
                break;
            case (0, $4f240e1aafd2c298$export$4659b591c19bdf3d)(t.orientation, {
                vertical: (0, $4cca0dbc68b0507a$export$4b0075e5ea5e1f26).ArrowDown,
                horizontal: (0, $4cca0dbc68b0507a$export$4b0075e5ea5e1f26).ArrowRight
            }):
                return o.preventDefault(), o.stopPropagation(), p.goToOption((0, $b7a0b87cd8a0fa3d$export$807a7eae502106e7).Next);
            case (0, $4f240e1aafd2c298$export$4659b591c19bdf3d)(t.orientation, {
                vertical: (0, $4cca0dbc68b0507a$export$4b0075e5ea5e1f26).ArrowUp,
                horizontal: (0, $4cca0dbc68b0507a$export$4b0075e5ea5e1f26).ArrowLeft
            }):
                return o.preventDefault(), o.stopPropagation(), p.goToOption((0, $b7a0b87cd8a0fa3d$export$807a7eae502106e7).Previous);
            case (0, $4cca0dbc68b0507a$export$4b0075e5ea5e1f26).Home:
            case (0, $4cca0dbc68b0507a$export$4b0075e5ea5e1f26).PageUp:
                return o.preventDefault(), o.stopPropagation(), p.goToOption((0, $b7a0b87cd8a0fa3d$export$807a7eae502106e7).First);
            case (0, $4cca0dbc68b0507a$export$4b0075e5ea5e1f26).End:
            case (0, $4cca0dbc68b0507a$export$4b0075e5ea5e1f26).PageDown:
                return o.preventDefault(), o.stopPropagation(), p.goToOption((0, $b7a0b87cd8a0fa3d$export$807a7eae502106e7).Last);
            case (0, $4cca0dbc68b0507a$export$4b0075e5ea5e1f26).Escape:
                return o.preventDefault(), o.stopPropagation(), p.closeListbox(), i.nextFrame(()=>{
                    var L;
                    return (L = t.buttonRef.current) == null ? void 0 : L.focus({
                        preventScroll: !0
                    });
                });
            case (0, $4cca0dbc68b0507a$export$4b0075e5ea5e1f26).Tab:
                o.preventDefault(), o.stopPropagation();
                break;
            default:
                o.key.length === 1 && (p.search(o.key), b.setTimeout(()=>p.clearSearch(), 350));
                break;
        }
    }), S = (0, $d78e56d87e9d66e2$export$e3d20747ab930783)(()=>{
        var o;
        return (o = t.buttonRef.current) == null ? void 0 : o.id;
    }, [
        t.buttonRef.current
    ]), g = (0, $acw62.useMemo)(()=>({
            open: t.listboxState === 0
        }), [
        t
    ]), x = {
        "aria-activedescendant": t.activeOptionIndex === null || (T = t.options[t.activeOptionIndex]) == null ? void 0 : T.id,
        "aria-multiselectable": t.mode === 1 ? !0 : void 0,
        "aria-labelledby": S,
        "aria-orientation": t.orientation,
        id: r,
        onKeyDown: P,
        role: "listbox",
        tabIndex: 0,
        ref: u
    };
    return (0, $a54bdd13402af126$export$b3890eb0ae9dca99)({
        ourProps: x,
        theirProps: l,
        slot: g,
        defaultTag: $df20442161b20eb0$var$Je,
        features: $df20442161b20eb0$var$qe,
        visible: m,
        name: "Listbox.Options"
    });
}
let $df20442161b20eb0$var$Ze = "li";
function $df20442161b20eb0$var$et(e, a) {
    let n = (0, $f2a0dea4caee12c6$export$f680877a34711e37)(), { id: r = `headlessui-listbox-option-${n}`, disabled: l = !1, value: t, ...p } = e, u = $df20442161b20eb0$var$w("Listbox.Option"), i = $df20442161b20eb0$var$k("Listbox.Option"), b = u.activeOptionIndex !== null ? u.options[u.activeOptionIndex].id === r : !1, R = u.isSelected(t), m = (0, $acw62.useRef)(null), P = (0, $e688621b6eb177ca$export$f6862afd851a1cf4)(m), S = (0, $fa1923261638cacc$export$86c4283a11f23f95)({
        disabled: l,
        value: t,
        domRef: m,
        get textValue () {
            return P();
        }
    }), g = (0, $4a1854c6a3ad5196$export$f6a25a78204acc7e)(a, m);
    (0, $65df95ec9b1bb6a8$export$ce5ed857c741fd71)(()=>{
        if (u.listboxState !== 0 || !b || u.activationTrigger === 0) return;
        let A = (0, $12f0e1633d904536$export$12b26c28a05aa001)();
        return A.requestAnimationFrame(()=>{
            var d, H;
            (H = (d = m.current) == null ? void 0 : d.scrollIntoView) == null || H.call(d, {
                block: "nearest"
            });
        }), A.dispose;
    }, [
        m,
        b,
        u.listboxState,
        u.activationTrigger,
        u.activeOptionIndex
    ]), (0, $65df95ec9b1bb6a8$export$ce5ed857c741fd71)(()=>i.registerOption(r, S), [
        S,
        r
    ]);
    let x = (0, $0bd9972698c32399$export$90fc3a17d93f704c)((A)=>{
        if (l) return A.preventDefault();
        i.onChange(t), u.mode === 0 && (i.closeListbox(), (0, $12f0e1633d904536$export$12b26c28a05aa001)().nextFrame(()=>{
            var d;
            return (d = u.buttonRef.current) == null ? void 0 : d.focus({
                preventScroll: !0
            });
        }));
    }), T = (0, $0bd9972698c32399$export$90fc3a17d93f704c)(()=>{
        if (l) return i.goToOption((0, $b7a0b87cd8a0fa3d$export$807a7eae502106e7).Nothing);
        i.goToOption((0, $b7a0b87cd8a0fa3d$export$807a7eae502106e7).Specific, r);
    }), o = (0, $d668e4b1d0c2f85c$export$24ebee078bde85c3)(), L = (0, $0bd9972698c32399$export$90fc3a17d93f704c)((A)=>o.update(A)), U = (0, $0bd9972698c32399$export$90fc3a17d93f704c)((A)=>{
        o.wasMoved(A) && (l || b || i.goToOption((0, $b7a0b87cd8a0fa3d$export$807a7eae502106e7).Specific, r, 0));
    }), B = (0, $0bd9972698c32399$export$90fc3a17d93f704c)((A)=>{
        o.wasMoved(A) && (l || b && i.goToOption((0, $b7a0b87cd8a0fa3d$export$807a7eae502106e7).Nothing));
    }), W = (0, $acw62.useMemo)(()=>({
            active: b,
            selected: R,
            disabled: l
        }), [
        b,
        R,
        l
    ]);
    return (0, $a54bdd13402af126$export$b3890eb0ae9dca99)({
        ourProps: {
            id: r,
            ref: g,
            role: "option",
            tabIndex: l === !0 ? void 0 : -1,
            "aria-disabled": l === !0 ? !0 : void 0,
            "aria-selected": R,
            disabled: void 0,
            onClick: x,
            onFocus: T,
            onPointerEnter: L,
            onMouseEnter: L,
            onPointerMove: U,
            onMouseMove: U,
            onPointerLeave: B,
            onMouseLeave: B
        },
        theirProps: p,
        slot: W,
        defaultTag: $df20442161b20eb0$var$Ze,
        name: "Listbox.Option"
    });
}
let $df20442161b20eb0$var$tt = (0, $a54bdd13402af126$export$e43f39796049410c)($df20442161b20eb0$var$Qe), $df20442161b20eb0$var$ot = (0, $a54bdd13402af126$export$e43f39796049410c)($df20442161b20eb0$var$Xe), $df20442161b20eb0$var$nt = (0, $a54bdd13402af126$export$e43f39796049410c)($df20442161b20eb0$var$ze), $df20442161b20eb0$var$it = (0, $a54bdd13402af126$export$e43f39796049410c)($df20442161b20eb0$var$Ye), $df20442161b20eb0$var$rt = (0, $a54bdd13402af126$export$e43f39796049410c)($df20442161b20eb0$var$et), $df20442161b20eb0$export$8bad31ff872c7659 = Object.assign($df20442161b20eb0$var$tt, {
    Button: $df20442161b20eb0$var$ot,
    Label: $df20442161b20eb0$var$nt,
    Options: $df20442161b20eb0$var$it,
    Option: $df20442161b20eb0$var$rt
});



var $77da6324ebaeb061$exports = {};

$parcel$export($77da6324ebaeb061$exports, "Popover", () => $77da6324ebaeb061$export$5b6b19405a83ff9d);

var $acw62 = parcelRequire("acw62");





















var $77da6324ebaeb061$var$he = ((u)=>(u[u.Open = 0] = "Open", u[u.Closed = 1] = "Closed", u))($77da6324ebaeb061$var$he || {}), $77da6324ebaeb061$var$He = ((e)=>(e[e.TogglePopover = 0] = "TogglePopover", e[e.ClosePopover = 1] = "ClosePopover", e[e.SetButton = 2] = "SetButton", e[e.SetButtonId = 3] = "SetButtonId", e[e.SetPanel = 4] = "SetPanel", e[e.SetPanelId = 5] = "SetPanelId", e))($77da6324ebaeb061$var$He || {});
let $77da6324ebaeb061$var$Ge = {
    [0]: (t)=>{
        let o = {
            ...t,
            popoverState: (0, $4f240e1aafd2c298$export$4659b591c19bdf3d)(t.popoverState, {
                [0]: 1,
                [1]: 0
            })
        };
        return o.popoverState === 0 && (o.__demoMode = !1), o;
    },
    [1] (t) {
        return t.popoverState === 1 ? t : {
            ...t,
            popoverState: 1
        };
    },
    [2] (t, o) {
        return t.button === o.button ? t : {
            ...t,
            button: o.button
        };
    },
    [3] (t, o) {
        return t.buttonId === o.buttonId ? t : {
            ...t,
            buttonId: o.buttonId
        };
    },
    [4] (t, o) {
        return t.panel === o.panel ? t : {
            ...t,
            panel: o.panel
        };
    },
    [5] (t, o) {
        return t.panelId === o.panelId ? t : {
            ...t,
            panelId: o.panelId
        };
    }
}, $77da6324ebaeb061$var$ue = (0, $acw62.createContext)(null);
$77da6324ebaeb061$var$ue.displayName = "PopoverContext";
function $77da6324ebaeb061$var$oe(t) {
    let o = (0, $acw62.useContext)($77da6324ebaeb061$var$ue);
    if (o === null) {
        let u = new Error(`<${t} /> is missing a parent <Popover /> component.`);
        throw Error.captureStackTrace && Error.captureStackTrace(u, $77da6324ebaeb061$var$oe), u;
    }
    return o;
}
let $77da6324ebaeb061$var$ie = (0, $acw62.createContext)(null);
$77da6324ebaeb061$var$ie.displayName = "PopoverAPIContext";
function $77da6324ebaeb061$var$fe(t) {
    let o = (0, $acw62.useContext)($77da6324ebaeb061$var$ie);
    if (o === null) {
        let u = new Error(`<${t} /> is missing a parent <Popover /> component.`);
        throw Error.captureStackTrace && Error.captureStackTrace(u, $77da6324ebaeb061$var$fe), u;
    }
    return o;
}
let $77da6324ebaeb061$var$Pe = (0, $acw62.createContext)(null);
$77da6324ebaeb061$var$Pe.displayName = "PopoverGroupContext";
function $77da6324ebaeb061$var$Ee() {
    return (0, $acw62.useContext)($77da6324ebaeb061$var$Pe);
}
let $77da6324ebaeb061$var$re = (0, $acw62.createContext)(null);
$77da6324ebaeb061$var$re.displayName = "PopoverPanelContext";
function $77da6324ebaeb061$var$Ne() {
    return (0, $acw62.useContext)($77da6324ebaeb061$var$re);
}
function $77da6324ebaeb061$var$ke(t, o) {
    return (0, $4f240e1aafd2c298$export$4659b591c19bdf3d)(o.type, $77da6324ebaeb061$var$Ge, t, o);
}
let $77da6324ebaeb061$var$we = "div";
function $77da6324ebaeb061$var$Ue(t, o) {
    var B;
    let { __demoMode: u = !1, ...M } = t, x = (0, $acw62.useRef)(null), n = (0, $4a1854c6a3ad5196$export$f6a25a78204acc7e)(o, (0, $4a1854c6a3ad5196$export$7029785b750eb74)((l)=>{
        x.current = l;
    })), e = (0, $acw62.useRef)([]), c = (0, $acw62.useReducer)($77da6324ebaeb061$var$ke, {
        __demoMode: u,
        popoverState: u ? 0 : 1,
        buttons: e,
        button: null,
        buttonId: null,
        panel: null,
        panelId: null,
        beforePanelSentinel: (0, $acw62.createRef)(),
        afterPanelSentinel: (0, $acw62.createRef)()
    }), [{ popoverState: f, button: s, buttonId: I, panel: a, panelId: v, beforePanelSentinel: y, afterPanelSentinel: A }, P] = c, p = (0, $42a08b28a285ca8e$export$dd9fbcea3de0ae36)((B = x.current) != null ? B : s), E = (0, $acw62.useMemo)(()=>{
        if (!s || !a) return !1;
        for (let W of document.querySelectorAll("body > *"))if (Number(W == null ? void 0 : W.contains(s)) ^ Number(W == null ? void 0 : W.contains(a))) return !0;
        let l = (0, $cb6dceb64e6c0606$export$433aaa1f216cf32d)(), S = l.indexOf(s), q = (S + l.length - 1) % l.length, U = (S + 1) % l.length, z = l[q], be = l[U];
        return !a.contains(z) && !a.contains(be);
    }, [
        s,
        a
    ]), F = (0, $fa1923261638cacc$export$86c4283a11f23f95)(I), D = (0, $fa1923261638cacc$export$86c4283a11f23f95)(v), _ = (0, $acw62.useMemo)(()=>({
            buttonId: F,
            panelId: D,
            close: ()=>P({
                    type: 1
                })
        }), [
        F,
        D,
        P
    ]), O = $77da6324ebaeb061$var$Ee(), L = O == null ? void 0 : O.registerPopover, $ = (0, $0bd9972698c32399$export$90fc3a17d93f704c)(()=>{
        var l;
        return (l = O == null ? void 0 : O.isFocusWithinPopoverGroup()) != null ? l : (p == null ? void 0 : p.activeElement) && ((s == null ? void 0 : s.contains(p.activeElement)) || (a == null ? void 0 : a.contains(p.activeElement)));
    });
    (0, $acw62.useEffect)(()=>L == null ? void 0 : L(_), [
        L,
        _
    ]);
    let [i, b] = (0, $a4e89ae9835d0556$export$26b8c35244a70b37)(), T = (0, $df81719180936f93$export$445f2d1a3d9b1b9f)({
        mainTreeNodeRef: O == null ? void 0 : O.mainTreeNodeRef,
        portals: i,
        defaultContainers: [
            s,
            a
        ]
    });
    (0, $faafded37f338b1b$export$7080b3e976bc91ab)(p == null ? void 0 : p.defaultView, "focus", (l)=>{
        var S, q, U, z;
        l.target !== window && l.target instanceof HTMLElement && f === 0 && ($() || s && a && (T.contains(l.target) || (q = (S = y.current) == null ? void 0 : S.contains) != null && q.call(S, l.target) || (z = (U = A.current) == null ? void 0 : U.contains) != null && z.call(U, l.target) || P({
            type: 1
        })));
    }, !0), (0, $17eff26b89e4b024$export$71b2224f1ce5e08e)(T.resolveContainers, (l, S)=>{
        P({
            type: 1
        }), (0, $cb6dceb64e6c0606$export$ff1ec1c740b3c8d5)(S, (0, $cb6dceb64e6c0606$export$27112a34f2f8402d).Loose) || (l.preventDefault(), s == null || s.focus());
    }, f === 0);
    let d = (0, $0bd9972698c32399$export$90fc3a17d93f704c)((l)=>{
        P({
            type: 1
        });
        let S = (()=>l ? l instanceof HTMLElement ? l : "current" in l && l.current instanceof HTMLElement ? l.current : s : s)();
        S == null || S.focus();
    }), r = (0, $acw62.useMemo)(()=>({
            close: d,
            isPortalled: E
        }), [
        d,
        E
    ]), m = (0, $acw62.useMemo)(()=>({
            open: f === 0,
            close: d
        }), [
        f,
        d
    ]), g = {
        ref: n
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($77da6324ebaeb061$var$re.Provider, {
        value: null
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($77da6324ebaeb061$var$ue.Provider, {
        value: c
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($77da6324ebaeb061$var$ie.Provider, {
        value: r
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7a3499b4b3c6f184$export$2a0ed818b175f558), {
        value: (0, $4f240e1aafd2c298$export$4659b591c19bdf3d)(f, {
            [0]: (0, $7a3499b4b3c6f184$export$7254cc27399e90bd).Open,
            [1]: (0, $7a3499b4b3c6f184$export$7254cc27399e90bd).Closed
        })
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(b, null, (0, $a54bdd13402af126$export$b3890eb0ae9dca99)({
        ourProps: g,
        theirProps: M,
        slot: m,
        defaultTag: $77da6324ebaeb061$var$we,
        name: "Popover"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(T.MainTreeNode, null))))));
}
let $77da6324ebaeb061$var$We = "button";
function $77da6324ebaeb061$var$Ke(t, o) {
    let u = (0, $f2a0dea4caee12c6$export$f680877a34711e37)(), { id: M = `headlessui-popover-button-${u}`, ...x } = t, [n, e] = $77da6324ebaeb061$var$oe("Popover.Button"), { isPortalled: c } = $77da6324ebaeb061$var$fe("Popover.Button"), f = (0, $acw62.useRef)(null), s = `headlessui-focus-sentinel-${(0, $f2a0dea4caee12c6$export$f680877a34711e37)()}`, I = $77da6324ebaeb061$var$Ee(), a = I == null ? void 0 : I.closeOthers, y = $77da6324ebaeb061$var$Ne() !== null;
    (0, $acw62.useEffect)(()=>{
        if (!y) return e({
            type: 3,
            buttonId: M
        }), ()=>{
            e({
                type: 3,
                buttonId: null
            });
        };
    }, [
        y,
        M,
        e
    ]);
    let [A] = (0, $acw62.useState)(()=>Symbol()), P = (0, $4a1854c6a3ad5196$export$f6a25a78204acc7e)(f, o, y ? null : (r)=>{
        if (r) n.buttons.current.push(A);
        else {
            let m = n.buttons.current.indexOf(A);
            m !== -1 && n.buttons.current.splice(m, 1);
        }
        n.buttons.current.length > 1 && console.warn("You are already using a <Popover.Button /> but only 1 <Popover.Button /> is supported."), r && e({
            type: 2,
            button: r
        });
    }), p = (0, $4a1854c6a3ad5196$export$f6a25a78204acc7e)(f, o), E = (0, $42a08b28a285ca8e$export$dd9fbcea3de0ae36)(f), F = (0, $0bd9972698c32399$export$90fc3a17d93f704c)((r)=>{
        var m, g, B;
        if (y) {
            if (n.popoverState === 1) return;
            switch(r.key){
                case (0, $4cca0dbc68b0507a$export$4b0075e5ea5e1f26).Space:
                case (0, $4cca0dbc68b0507a$export$4b0075e5ea5e1f26).Enter:
                    r.preventDefault(), (g = (m = r.target).click) == null || g.call(m), e({
                        type: 1
                    }), (B = n.button) == null || B.focus();
                    break;
            }
        } else switch(r.key){
            case (0, $4cca0dbc68b0507a$export$4b0075e5ea5e1f26).Space:
            case (0, $4cca0dbc68b0507a$export$4b0075e5ea5e1f26).Enter:
                r.preventDefault(), r.stopPropagation(), n.popoverState === 1 && (a == null || a(n.buttonId)), e({
                    type: 0
                });
                break;
            case (0, $4cca0dbc68b0507a$export$4b0075e5ea5e1f26).Escape:
                if (n.popoverState !== 0) return a == null ? void 0 : a(n.buttonId);
                if (!f.current || E != null && E.activeElement && !f.current.contains(E.activeElement)) return;
                r.preventDefault(), r.stopPropagation(), e({
                    type: 1
                });
                break;
        }
    }), D = (0, $0bd9972698c32399$export$90fc3a17d93f704c)((r)=>{
        y || r.key === (0, $4cca0dbc68b0507a$export$4b0075e5ea5e1f26).Space && r.preventDefault();
    }), _ = (0, $0bd9972698c32399$export$90fc3a17d93f704c)((r)=>{
        var m, g;
        (0, $3d3d670dbe2ceed6$export$db61f031a278447c)(r.currentTarget) || t.disabled || (y ? (e({
            type: 1
        }), (m = n.button) == null || m.focus()) : (r.preventDefault(), r.stopPropagation(), n.popoverState === 1 && (a == null || a(n.buttonId)), e({
            type: 0
        }), (g = n.button) == null || g.focus()));
    }), O = (0, $0bd9972698c32399$export$90fc3a17d93f704c)((r)=>{
        r.preventDefault(), r.stopPropagation();
    }), L = n.popoverState === 0, $ = (0, $acw62.useMemo)(()=>({
            open: L
        }), [
        L
    ]), i = (0, $be828d8bf9bb25ca$export$53652b2b272efe9c)(t, f), b = y ? {
        ref: p,
        type: i,
        onKeyDown: F,
        onClick: _
    } : {
        ref: P,
        id: n.buttonId,
        type: i,
        "aria-expanded": n.popoverState === 0,
        "aria-controls": n.panel ? n.panelId : void 0,
        onKeyDown: F,
        onKeyUp: D,
        onClick: _,
        onMouseDown: O
    }, T = (0, $2766dc79ae4166c9$export$19b797546aece48f)(), d = (0, $0bd9972698c32399$export$90fc3a17d93f704c)(()=>{
        let r = n.panel;
        if (!r) return;
        function m() {
            (0, $4f240e1aafd2c298$export$4659b591c19bdf3d)(T.current, {
                [(0, $2766dc79ae4166c9$export$cacd6541cfeeb6c1).Forwards]: ()=>(0, $cb6dceb64e6c0606$export$82e1f4f412218a1d)(r, (0, $cb6dceb64e6c0606$export$807a7eae502106e7).First),
                [(0, $2766dc79ae4166c9$export$cacd6541cfeeb6c1).Backwards]: ()=>(0, $cb6dceb64e6c0606$export$82e1f4f412218a1d)(r, (0, $cb6dceb64e6c0606$export$807a7eae502106e7).Last)
            }) === (0, $cb6dceb64e6c0606$export$abf286375dfa6dbd).Error && (0, $cb6dceb64e6c0606$export$82e1f4f412218a1d)((0, $cb6dceb64e6c0606$export$433aaa1f216cf32d)().filter((B)=>B.dataset.headlessuiFocusGuard !== "true"), (0, $4f240e1aafd2c298$export$4659b591c19bdf3d)(T.current, {
                [(0, $2766dc79ae4166c9$export$cacd6541cfeeb6c1).Forwards]: (0, $cb6dceb64e6c0606$export$807a7eae502106e7).Next,
                [(0, $2766dc79ae4166c9$export$cacd6541cfeeb6c1).Backwards]: (0, $cb6dceb64e6c0606$export$807a7eae502106e7).Previous
            }), {
                relativeTo: n.button
            });
        }
        m();
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (0, $a54bdd13402af126$export$b3890eb0ae9dca99)({
        ourProps: b,
        theirProps: x,
        slot: $,
        defaultTag: $77da6324ebaeb061$var$We,
        name: "Popover.Button"
    }), L && !y && c && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $eac0d614a77ee96b$export$8dc98ba7eadeaa56), {
        id: s,
        features: (0, $eac0d614a77ee96b$export$617d79dae526d2cf).Focusable,
        "data-headlessui-focus-guard": !0,
        as: "button",
        type: "button",
        onFocus: d
    }));
}
let $77da6324ebaeb061$var$je = "div", $77da6324ebaeb061$var$Ve = (0, $a54bdd13402af126$export$617d79dae526d2cf).RenderStrategy | (0, $a54bdd13402af126$export$617d79dae526d2cf).Static;
function $77da6324ebaeb061$var$$e(t, o) {
    let u = (0, $f2a0dea4caee12c6$export$f680877a34711e37)(), { id: M = `headlessui-popover-overlay-${u}`, ...x } = t, [{ popoverState: n }, e] = $77da6324ebaeb061$var$oe("Popover.Overlay"), c = (0, $4a1854c6a3ad5196$export$f6a25a78204acc7e)(o), f = (0, $7a3499b4b3c6f184$export$fc6fdf0ecf360e)(), s = (()=>f !== null ? (f & (0, $7a3499b4b3c6f184$export$7254cc27399e90bd).Open) === (0, $7a3499b4b3c6f184$export$7254cc27399e90bd).Open : n === 0)(), I = (0, $0bd9972698c32399$export$90fc3a17d93f704c)((y)=>{
        if ((0, $3d3d670dbe2ceed6$export$db61f031a278447c)(y.currentTarget)) return y.preventDefault();
        e({
            type: 1
        });
    }), a = (0, $acw62.useMemo)(()=>({
            open: n === 0
        }), [
        n
    ]);
    return (0, $a54bdd13402af126$export$b3890eb0ae9dca99)({
        ourProps: {
            ref: c,
            id: M,
            "aria-hidden": !0,
            onClick: I
        },
        theirProps: x,
        slot: a,
        defaultTag: $77da6324ebaeb061$var$je,
        features: $77da6324ebaeb061$var$Ve,
        visible: s,
        name: "Popover.Overlay"
    });
}
let $77da6324ebaeb061$var$Je = "div", $77da6324ebaeb061$var$Xe = (0, $a54bdd13402af126$export$617d79dae526d2cf).RenderStrategy | (0, $a54bdd13402af126$export$617d79dae526d2cf).Static;
function $77da6324ebaeb061$var$Ye(t, o) {
    let u = (0, $f2a0dea4caee12c6$export$f680877a34711e37)(), { id: M = `headlessui-popover-panel-${u}`, focus: x = !1, ...n } = t, [e, c] = $77da6324ebaeb061$var$oe("Popover.Panel"), { close: f, isPortalled: s } = $77da6324ebaeb061$var$fe("Popover.Panel"), I = `headlessui-focus-sentinel-before-${(0, $f2a0dea4caee12c6$export$f680877a34711e37)()}`, a = `headlessui-focus-sentinel-after-${(0, $f2a0dea4caee12c6$export$f680877a34711e37)()}`, v = (0, $acw62.useRef)(null), y = (0, $4a1854c6a3ad5196$export$f6a25a78204acc7e)(v, o, (i)=>{
        c({
            type: 4,
            panel: i
        });
    }), A = (0, $42a08b28a285ca8e$export$dd9fbcea3de0ae36)(v), P = (0, $a54bdd13402af126$export$81218df071161f0a)();
    (0, $65df95ec9b1bb6a8$export$ce5ed857c741fd71)(()=>(c({
            type: 5,
            panelId: M
        }), ()=>{
            c({
                type: 5,
                panelId: null
            });
        }), [
        M,
        c
    ]);
    let p = (0, $7a3499b4b3c6f184$export$fc6fdf0ecf360e)(), E = (()=>p !== null ? (p & (0, $7a3499b4b3c6f184$export$7254cc27399e90bd).Open) === (0, $7a3499b4b3c6f184$export$7254cc27399e90bd).Open : e.popoverState === 0)(), F = (0, $0bd9972698c32399$export$90fc3a17d93f704c)((i)=>{
        var b;
        switch(i.key){
            case (0, $4cca0dbc68b0507a$export$4b0075e5ea5e1f26).Escape:
                if (e.popoverState !== 0 || !v.current || A != null && A.activeElement && !v.current.contains(A.activeElement)) return;
                i.preventDefault(), i.stopPropagation(), c({
                    type: 1
                }), (b = e.button) == null || b.focus();
                break;
        }
    });
    (0, $acw62.useEffect)(()=>{
        var i;
        t.static || e.popoverState === 1 && ((i = t.unmount) == null || i) && c({
            type: 4,
            panel: null
        });
    }, [
        e.popoverState,
        t.unmount,
        t.static,
        c
    ]), (0, $acw62.useEffect)(()=>{
        if (e.__demoMode || !x || e.popoverState !== 0 || !v.current) return;
        let i = A == null ? void 0 : A.activeElement;
        v.current.contains(i) || (0, $cb6dceb64e6c0606$export$82e1f4f412218a1d)(v.current, (0, $cb6dceb64e6c0606$export$807a7eae502106e7).First);
    }, [
        e.__demoMode,
        x,
        v,
        e.popoverState
    ]);
    let D = (0, $acw62.useMemo)(()=>({
            open: e.popoverState === 0,
            close: f
        }), [
        e,
        f
    ]), _ = {
        ref: y,
        id: M,
        onKeyDown: F,
        onBlur: x && e.popoverState === 0 ? (i)=>{
            var T, d, r, m, g;
            let b = i.relatedTarget;
            b && v.current && ((T = v.current) != null && T.contains(b) || (c({
                type: 1
            }), ((r = (d = e.beforePanelSentinel.current) == null ? void 0 : d.contains) != null && r.call(d, b) || (g = (m = e.afterPanelSentinel.current) == null ? void 0 : m.contains) != null && g.call(m, b)) && b.focus({
                preventScroll: !0
            })));
        } : void 0,
        tabIndex: -1
    }, O = (0, $2766dc79ae4166c9$export$19b797546aece48f)(), L = (0, $0bd9972698c32399$export$90fc3a17d93f704c)(()=>{
        let i = v.current;
        if (!i) return;
        function b() {
            (0, $4f240e1aafd2c298$export$4659b591c19bdf3d)(O.current, {
                [(0, $2766dc79ae4166c9$export$cacd6541cfeeb6c1).Forwards]: ()=>{
                    var d;
                    (0, $cb6dceb64e6c0606$export$82e1f4f412218a1d)(i, (0, $cb6dceb64e6c0606$export$807a7eae502106e7).First) === (0, $cb6dceb64e6c0606$export$abf286375dfa6dbd).Error && ((d = e.afterPanelSentinel.current) == null || d.focus());
                },
                [(0, $2766dc79ae4166c9$export$cacd6541cfeeb6c1).Backwards]: ()=>{
                    var T;
                    (T = e.button) == null || T.focus({
                        preventScroll: !0
                    });
                }
            });
        }
        b();
    }), $ = (0, $0bd9972698c32399$export$90fc3a17d93f704c)(()=>{
        let i = v.current;
        if (!i) return;
        function b() {
            (0, $4f240e1aafd2c298$export$4659b591c19bdf3d)(O.current, {
                [(0, $2766dc79ae4166c9$export$cacd6541cfeeb6c1).Forwards]: ()=>{
                    var B;
                    if (!e.button) return;
                    let T = (0, $cb6dceb64e6c0606$export$433aaa1f216cf32d)(), d = T.indexOf(e.button), r = T.slice(0, d + 1), g = [
                        ...T.slice(d + 1),
                        ...r
                    ];
                    for (let l of g.slice())if (l.dataset.headlessuiFocusGuard === "true" || (B = e.panel) != null && B.contains(l)) {
                        let S = g.indexOf(l);
                        S !== -1 && g.splice(S, 1);
                    }
                    (0, $cb6dceb64e6c0606$export$82e1f4f412218a1d)(g, (0, $cb6dceb64e6c0606$export$807a7eae502106e7).First, {
                        sorted: !1
                    });
                },
                [(0, $2766dc79ae4166c9$export$cacd6541cfeeb6c1).Backwards]: ()=>{
                    var d;
                    (0, $cb6dceb64e6c0606$export$82e1f4f412218a1d)(i, (0, $cb6dceb64e6c0606$export$807a7eae502106e7).Previous) === (0, $cb6dceb64e6c0606$export$abf286375dfa6dbd).Error && ((d = e.button) == null || d.focus());
                }
            });
        }
        b();
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($77da6324ebaeb061$var$re.Provider, {
        value: M
    }, E && s && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $eac0d614a77ee96b$export$8dc98ba7eadeaa56), {
        id: I,
        ref: e.beforePanelSentinel,
        features: (0, $eac0d614a77ee96b$export$617d79dae526d2cf).Focusable,
        "data-headlessui-focus-guard": !0,
        as: "button",
        type: "button",
        onFocus: L
    }), (0, $a54bdd13402af126$export$b3890eb0ae9dca99)({
        mergeRefs: P,
        ourProps: _,
        theirProps: n,
        slot: D,
        defaultTag: $77da6324ebaeb061$var$Je,
        features: $77da6324ebaeb061$var$Xe,
        visible: E,
        name: "Popover.Panel"
    }), E && s && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $eac0d614a77ee96b$export$8dc98ba7eadeaa56), {
        id: a,
        ref: e.afterPanelSentinel,
        features: (0, $eac0d614a77ee96b$export$617d79dae526d2cf).Focusable,
        "data-headlessui-focus-guard": !0,
        as: "button",
        type: "button",
        onFocus: $
    }));
}
let $77da6324ebaeb061$var$qe = "div";
function $77da6324ebaeb061$var$ze(t, o) {
    let u = (0, $acw62.useRef)(null), M = (0, $4a1854c6a3ad5196$export$f6a25a78204acc7e)(u, o), [x, n] = (0, $acw62.useState)([]), e = (0, $df81719180936f93$export$64db24433d7f4942)(), c = (0, $0bd9972698c32399$export$90fc3a17d93f704c)((P)=>{
        n((p)=>{
            let E = p.indexOf(P);
            if (E !== -1) {
                let F = p.slice();
                return F.splice(E, 1), F;
            }
            return p;
        });
    }), f = (0, $0bd9972698c32399$export$90fc3a17d93f704c)((P)=>(n((p)=>[
                ...p,
                P
            ]), ()=>c(P))), s = (0, $0bd9972698c32399$export$90fc3a17d93f704c)(()=>{
        var E;
        let P = (0, $c0a913ecfa4bf5e5$export$b204af158042fbac)(u);
        if (!P) return !1;
        let p = P.activeElement;
        return (E = u.current) != null && E.contains(p) ? !0 : x.some((F)=>{
            var D, _;
            return ((D = P.getElementById(F.buttonId.current)) == null ? void 0 : D.contains(p)) || ((_ = P.getElementById(F.panelId.current)) == null ? void 0 : _.contains(p));
        });
    }), I = (0, $0bd9972698c32399$export$90fc3a17d93f704c)((P)=>{
        for (let p of x)p.buttonId.current !== P && p.close();
    }), a = (0, $acw62.useMemo)(()=>({
            registerPopover: f,
            unregisterPopover: c,
            isFocusWithinPopoverGroup: s,
            closeOthers: I,
            mainTreeNodeRef: e.mainTreeNodeRef
        }), [
        f,
        c,
        s,
        I,
        e.mainTreeNodeRef
    ]), v = (0, $acw62.useMemo)(()=>({}), []), y = t, A = {
        ref: M
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($77da6324ebaeb061$var$Pe.Provider, {
        value: a
    }, (0, $a54bdd13402af126$export$b3890eb0ae9dca99)({
        ourProps: A,
        theirProps: y,
        slot: v,
        defaultTag: $77da6324ebaeb061$var$qe,
        name: "Popover.Group"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(e.MainTreeNode, null));
}
let $77da6324ebaeb061$var$Qe = (0, $a54bdd13402af126$export$e43f39796049410c)($77da6324ebaeb061$var$Ue), $77da6324ebaeb061$var$Ze = (0, $a54bdd13402af126$export$e43f39796049410c)($77da6324ebaeb061$var$Ke), $77da6324ebaeb061$var$et = (0, $a54bdd13402af126$export$e43f39796049410c)($77da6324ebaeb061$var$$e), $77da6324ebaeb061$var$tt = (0, $a54bdd13402af126$export$e43f39796049410c)($77da6324ebaeb061$var$Ye), $77da6324ebaeb061$var$ot = (0, $a54bdd13402af126$export$e43f39796049410c)($77da6324ebaeb061$var$ze), $77da6324ebaeb061$export$5b6b19405a83ff9d = Object.assign($77da6324ebaeb061$var$Qe, {
    Button: $77da6324ebaeb061$var$Ze,
    Overlay: $77da6324ebaeb061$var$et,
    Panel: $77da6324ebaeb061$var$tt,
    Group: $77da6324ebaeb061$var$ot
});



var $2d8d7fe947ac67a8$exports = {};

$parcel$export($2d8d7fe947ac67a8$exports, "RadioGroup", () => $2d8d7fe947ac67a8$export$a98f0dcb43a68a25);

var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");





let $3f2bea42b2459559$var$d = (0, $acw62.createContext)(null);
function $3f2bea42b2459559$var$u() {
    let a = (0, $acw62.useContext)($3f2bea42b2459559$var$d);
    if (a === null) {
        let t = new Error("You used a <Label /> component, but it is not inside a relevant parent.");
        throw Error.captureStackTrace && Error.captureStackTrace(t, $3f2bea42b2459559$var$u), t;
    }
    return a;
}
function $3f2bea42b2459559$export$d6875122194c7b44() {
    let [a, t] = (0, $acw62.useState)([]);
    return [
        a.length > 0 ? a.join(" ") : void 0,
        (0, $acw62.useMemo)(()=>function(e) {
                let s = (0, $0bd9972698c32399$export$90fc3a17d93f704c)((r)=>(t((l)=>[
                            ...l,
                            r
                        ]), ()=>t((l)=>{
                            let n = l.slice(), p = n.indexOf(r);
                            return p !== -1 && n.splice(p, 1), n;
                        }))), o = (0, $acw62.useMemo)(()=>({
                        register: s,
                        slot: e.slot,
                        name: e.name,
                        props: e.props
                    }), [
                    s,
                    e.slot,
                    e.name,
                    e.props
                ]);
                return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($3f2bea42b2459559$var$d.Provider, {
                    value: o
                }, e.children);
            }, [
            t
        ])
    ];
}
let $3f2bea42b2459559$var$A = "label";
function $3f2bea42b2459559$var$h(a, t) {
    let i = (0, $f2a0dea4caee12c6$export$f680877a34711e37)(), { id: e = `headlessui-label-${i}`, passive: s = !1, ...o } = a, r = $3f2bea42b2459559$var$u(), l = (0, $4a1854c6a3ad5196$export$f6a25a78204acc7e)(t);
    (0, $65df95ec9b1bb6a8$export$ce5ed857c741fd71)(()=>r.register(e), [
        e,
        r.register
    ]);
    let n = {
        ref: l,
        ...r.props,
        id: e
    };
    return s && ("onClick" in n && (delete n.htmlFor, delete n.onClick), "onClick" in o && delete o.onClick), (0, $a54bdd13402af126$export$b3890eb0ae9dca99)({
        ourProps: n,
        theirProps: o,
        slot: r.slot || {},
        defaultTag: $3f2bea42b2459559$var$A,
        name: r.name || "Label"
    });
}
let $3f2bea42b2459559$var$v = (0, $a54bdd13402af126$export$e43f39796049410c)($3f2bea42b2459559$var$h), $3f2bea42b2459559$export$b04be29aa201d4f5 = Object.assign($3f2bea42b2459559$var$v, {});


















var $2d8d7fe947ac67a8$var$Ge = ((t)=>(t[t.RegisterOption = 0] = "RegisterOption", t[t.UnregisterOption = 1] = "UnregisterOption", t))($2d8d7fe947ac67a8$var$Ge || {});
let $2d8d7fe947ac67a8$var$Ce = {
    [0] (o, r) {
        let t = [
            ...o.options,
            {
                id: r.id,
                element: r.element,
                propsRef: r.propsRef
            }
        ];
        return {
            ...o,
            options: (0, $cb6dceb64e6c0606$export$20305e96f91bf103)(t, (p)=>p.element.current)
        };
    },
    [1] (o, r) {
        let t = o.options.slice(), p = o.options.findIndex((T)=>T.id === r.id);
        return p === -1 ? o : (t.splice(p, 1), {
            ...o,
            options: t
        });
    }
}, $2d8d7fe947ac67a8$var$B = (0, $acw62.createContext)(null);
$2d8d7fe947ac67a8$var$B.displayName = "RadioGroupDataContext";
function $2d8d7fe947ac67a8$var$oe(o) {
    let r = (0, $acw62.useContext)($2d8d7fe947ac67a8$var$B);
    if (r === null) {
        let t = new Error(`<${o} /> is missing a parent <RadioGroup /> component.`);
        throw Error.captureStackTrace && Error.captureStackTrace(t, $2d8d7fe947ac67a8$var$oe), t;
    }
    return r;
}
let $2d8d7fe947ac67a8$var$$ = (0, $acw62.createContext)(null);
$2d8d7fe947ac67a8$var$$.displayName = "RadioGroupActionsContext";
function $2d8d7fe947ac67a8$var$ne(o) {
    let r = (0, $acw62.useContext)($2d8d7fe947ac67a8$var$$);
    if (r === null) {
        let t = new Error(`<${o} /> is missing a parent <RadioGroup /> component.`);
        throw Error.captureStackTrace && Error.captureStackTrace(t, $2d8d7fe947ac67a8$var$ne), t;
    }
    return r;
}
function $2d8d7fe947ac67a8$var$ke(o, r) {
    return (0, $4f240e1aafd2c298$export$4659b591c19bdf3d)(r.type, $2d8d7fe947ac67a8$var$Ce, o, r);
}
let $2d8d7fe947ac67a8$var$Le = "div";
function $2d8d7fe947ac67a8$var$he(o, r) {
    let t = (0, $f2a0dea4caee12c6$export$f680877a34711e37)(), { id: p = `headlessui-radiogroup-${t}`, value: T, defaultValue: v, form: M, name: m, onChange: H, by: _ = (e, i)=>e === i, disabled: G = !1, ...N } = o, y = (0, $0bd9972698c32399$export$90fc3a17d93f704c)(typeof _ == "string" ? (e, i)=>{
        let n = _;
        return (e == null ? void 0 : e[n]) === (i == null ? void 0 : i[n]);
    } : _), [P, L] = (0, $acw62.useReducer)($2d8d7fe947ac67a8$var$ke, {
        options: []
    }), a = P.options, [h, R] = (0, $3f2bea42b2459559$export$d6875122194c7b44)(), [C, U] = (0, $d994aee5798540d7$export$babde88292020af7)(), k = (0, $acw62.useRef)(null), W = (0, $4a1854c6a3ad5196$export$f6a25a78204acc7e)(k, r), [l, s] = (0, $c6676ed1f400443a$export$454217e89aea72b)(T, H, v), b = (0, $acw62.useMemo)(()=>a.find((e)=>!e.propsRef.current.disabled), [
        a
    ]), x = (0, $acw62.useMemo)(()=>a.some((e)=>y(e.propsRef.current.value, l)), [
        a,
        l
    ]), d = (0, $0bd9972698c32399$export$90fc3a17d93f704c)((e)=>{
        var n;
        if (G || y(e, l)) return !1;
        let i = (n = a.find((f)=>y(f.propsRef.current.value, e))) == null ? void 0 : n.propsRef.current;
        return i != null && i.disabled ? !1 : (s == null || s(e), !0);
    });
    (0, $101ef4628501ab0d$export$b0abce39eb34b36)({
        container: k.current,
        accept (e) {
            return e.getAttribute("role") === "radio" ? NodeFilter.FILTER_REJECT : e.hasAttribute("role") ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT;
        },
        walk (e) {
            e.setAttribute("role", "none");
        }
    });
    let F = (0, $0bd9972698c32399$export$90fc3a17d93f704c)((e)=>{
        let i = k.current;
        if (!i) return;
        let n = (0, $c0a913ecfa4bf5e5$export$b204af158042fbac)(i), f = a.filter((u)=>u.propsRef.current.disabled === !1).map((u)=>u.element.current);
        switch(e.key){
            case (0, $4cca0dbc68b0507a$export$4b0075e5ea5e1f26).Enter:
                (0, $594e79751740d704$export$ee02894bdc79dd36)(e.currentTarget);
                break;
            case (0, $4cca0dbc68b0507a$export$4b0075e5ea5e1f26).ArrowLeft:
            case (0, $4cca0dbc68b0507a$export$4b0075e5ea5e1f26).ArrowUp:
                if (e.preventDefault(), e.stopPropagation(), (0, $cb6dceb64e6c0606$export$82e1f4f412218a1d)(f, (0, $cb6dceb64e6c0606$export$807a7eae502106e7).Previous | (0, $cb6dceb64e6c0606$export$807a7eae502106e7).WrapAround) === (0, $cb6dceb64e6c0606$export$abf286375dfa6dbd).Success) {
                    let g = a.find((K)=>K.element.current === (n == null ? void 0 : n.activeElement));
                    g && d(g.propsRef.current.value);
                }
                break;
            case (0, $4cca0dbc68b0507a$export$4b0075e5ea5e1f26).ArrowRight:
            case (0, $4cca0dbc68b0507a$export$4b0075e5ea5e1f26).ArrowDown:
                if (e.preventDefault(), e.stopPropagation(), (0, $cb6dceb64e6c0606$export$82e1f4f412218a1d)(f, (0, $cb6dceb64e6c0606$export$807a7eae502106e7).Next | (0, $cb6dceb64e6c0606$export$807a7eae502106e7).WrapAround) === (0, $cb6dceb64e6c0606$export$abf286375dfa6dbd).Success) {
                    let g = a.find((K)=>K.element.current === (n == null ? void 0 : n.activeElement));
                    g && d(g.propsRef.current.value);
                }
                break;
            case (0, $4cca0dbc68b0507a$export$4b0075e5ea5e1f26).Space:
                {
                    e.preventDefault(), e.stopPropagation();
                    let u = a.find((g)=>g.element.current === (n == null ? void 0 : n.activeElement));
                    u && d(u.propsRef.current.value);
                }
                break;
        }
    }), c = (0, $0bd9972698c32399$export$90fc3a17d93f704c)((e)=>(L({
            type: 0,
            ...e
        }), ()=>L({
                type: 1,
                id: e.id
            }))), w = (0, $acw62.useMemo)(()=>({
            value: l,
            firstOption: b,
            containsCheckedOption: x,
            disabled: G,
            compare: y,
            ...P
        }), [
        l,
        b,
        x,
        G,
        y,
        P
    ]), ie = (0, $acw62.useMemo)(()=>({
            registerOption: c,
            change: d
        }), [
        c,
        d
    ]), ae = {
        ref: W,
        id: p,
        role: "radiogroup",
        "aria-labelledby": h,
        "aria-describedby": C,
        onKeyDown: F
    }, pe = (0, $acw62.useMemo)(()=>({
            value: l
        }), [
        l
    ]), I = (0, $acw62.useRef)(null), le = (0, $410e668b7f520622$export$fd183955ff4b45d9)();
    return (0, $acw62.useEffect)(()=>{
        I.current && v !== void 0 && le.addEventListener(I.current, "reset", ()=>{
            d(v);
        });
    }, [
        I,
        d
    ]), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(U, {
        name: "RadioGroup.Description"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(R, {
        name: "RadioGroup.Label"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2d8d7fe947ac67a8$var$$.Provider, {
        value: ie
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2d8d7fe947ac67a8$var$B.Provider, {
        value: w
    }, m != null && l != null && (0, $594e79751740d704$export$bc22b3e852574dab)({
        [m]: l
    }).map(([e, i], n)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $eac0d614a77ee96b$export$8dc98ba7eadeaa56), {
            features: (0, $eac0d614a77ee96b$export$617d79dae526d2cf).Hidden,
            ref: n === 0 ? (f)=>{
                var u;
                I.current = (u = f == null ? void 0 : f.closest("form")) != null ? u : null;
            } : void 0,
            ...(0, $a54bdd13402af126$export$8e16b83750b44988)({
                key: e,
                as: "input",
                type: "radio",
                checked: i != null,
                hidden: !0,
                readOnly: !0,
                form: M,
                name: e,
                value: i
            })
        })), (0, $a54bdd13402af126$export$b3890eb0ae9dca99)({
        ourProps: ae,
        theirProps: N,
        slot: pe,
        defaultTag: $2d8d7fe947ac67a8$var$Le,
        name: "RadioGroup"
    })))));
}
var $2d8d7fe947ac67a8$var$xe = ((t)=>(t[t.Empty = 1] = "Empty", t[t.Active = 2] = "Active", t))($2d8d7fe947ac67a8$var$xe || {});
let $2d8d7fe947ac67a8$var$Fe = "div";
function $2d8d7fe947ac67a8$var$we(o, r) {
    var F;
    let t = (0, $f2a0dea4caee12c6$export$f680877a34711e37)(), { id: p = `headlessui-radiogroup-option-${t}`, value: T, disabled: v = !1, ...M } = o, m = (0, $acw62.useRef)(null), H = (0, $4a1854c6a3ad5196$export$f6a25a78204acc7e)(m, r), [_, G] = (0, $3f2bea42b2459559$export$d6875122194c7b44)(), [N, y] = (0, $d994aee5798540d7$export$babde88292020af7)(), { addFlag: P, removeFlag: L, hasFlag: a } = (0, $805c30fc151c4831$export$2879604e6aec4ab)(1), h = (0, $fa1923261638cacc$export$86c4283a11f23f95)({
        value: T,
        disabled: v
    }), R = $2d8d7fe947ac67a8$var$oe("RadioGroup.Option"), C = $2d8d7fe947ac67a8$var$ne("RadioGroup.Option");
    (0, $65df95ec9b1bb6a8$export$ce5ed857c741fd71)(()=>C.registerOption({
            id: p,
            element: m,
            propsRef: h
        }), [
        p,
        C,
        m,
        h
    ]);
    let U = (0, $0bd9972698c32399$export$90fc3a17d93f704c)((c)=>{
        var w;
        if ((0, $3d3d670dbe2ceed6$export$db61f031a278447c)(c.currentTarget)) return c.preventDefault();
        C.change(T) && (P(2), (w = m.current) == null || w.focus());
    }), k = (0, $0bd9972698c32399$export$90fc3a17d93f704c)((c)=>{
        if ((0, $3d3d670dbe2ceed6$export$db61f031a278447c)(c.currentTarget)) return c.preventDefault();
        P(2);
    }), W = (0, $0bd9972698c32399$export$90fc3a17d93f704c)(()=>L(2)), l = ((F = R.firstOption) == null ? void 0 : F.id) === p, s = R.disabled || v, b = R.compare(R.value, T), x = {
        ref: H,
        id: p,
        role: "radio",
        "aria-checked": b ? "true" : "false",
        "aria-labelledby": _,
        "aria-describedby": N,
        "aria-disabled": s ? !0 : void 0,
        tabIndex: (()=>s ? -1 : b || !R.containsCheckedOption && l ? 0 : -1)(),
        onClick: s ? void 0 : U,
        onFocus: s ? void 0 : k,
        onBlur: s ? void 0 : W
    }, d = (0, $acw62.useMemo)(()=>({
            checked: b,
            disabled: s,
            active: a(2)
        }), [
        b,
        s,
        a
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(y, {
        name: "RadioGroup.Description"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(G, {
        name: "RadioGroup.Label"
    }, (0, $a54bdd13402af126$export$b3890eb0ae9dca99)({
        ourProps: x,
        theirProps: M,
        slot: d,
        defaultTag: $2d8d7fe947ac67a8$var$Fe,
        name: "RadioGroup.Option"
    })));
}
let $2d8d7fe947ac67a8$var$Ie = (0, $a54bdd13402af126$export$e43f39796049410c)($2d8d7fe947ac67a8$var$he), $2d8d7fe947ac67a8$var$Se = (0, $a54bdd13402af126$export$e43f39796049410c)($2d8d7fe947ac67a8$var$we), $2d8d7fe947ac67a8$export$a98f0dcb43a68a25 = Object.assign($2d8d7fe947ac67a8$var$Ie, {
    Option: $2d8d7fe947ac67a8$var$Se,
    Label: (0, $3f2bea42b2459559$export$b04be29aa201d4f5),
    Description: (0, $d994aee5798540d7$export$393edc798c47379d)
});


var $8bce35f563baeffd$exports = {};

$parcel$export($8bce35f563baeffd$exports, "Switch", () => $8bce35f563baeffd$export$b5d5cf8927ab7262);

var $acw62 = parcelRequire("acw62");













let $8bce35f563baeffd$var$b = (0, $acw62.createContext)(null);
$8bce35f563baeffd$var$b.displayName = "GroupContext";
let $8bce35f563baeffd$var$Y = (0, $acw62.Fragment);
function $8bce35f563baeffd$var$Z(s) {
    var d;
    let [n, p] = (0, $acw62.useState)(null), [c, f] = (0, $3f2bea42b2459559$export$d6875122194c7b44)(), [r, h] = (0, $d994aee5798540d7$export$babde88292020af7)(), l = (0, $acw62.useMemo)(()=>({
            switch: n,
            setSwitch: p,
            labelledby: c,
            describedby: r
        }), [
        n,
        p,
        c,
        r
    ]), T = {}, y = s;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(h, {
        name: "Switch.Description"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(f, {
        name: "Switch.Label",
        props: {
            htmlFor: (d = l.switch) == null ? void 0 : d.id,
            onClick (t) {
                n && (t.currentTarget.tagName === "LABEL" && t.preventDefault(), n.click(), n.focus({
                    preventScroll: !0
                }));
            }
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($8bce35f563baeffd$var$b.Provider, {
        value: l
    }, (0, $a54bdd13402af126$export$b3890eb0ae9dca99)({
        ourProps: T,
        theirProps: y,
        defaultTag: $8bce35f563baeffd$var$Y,
        name: "Switch.Group"
    }))));
}
let $8bce35f563baeffd$var$ee = "button";
function $8bce35f563baeffd$var$te(s, n) {
    let p = (0, $f2a0dea4caee12c6$export$f680877a34711e37)(), { id: c = `headlessui-switch-${p}`, checked: f, defaultChecked: r = !1, onChange: h, name: l, value: T, form: y, ...d } = s, t = (0, $acw62.useContext)($8bce35f563baeffd$var$b), u = (0, $acw62.useRef)(null), g = (0, $4a1854c6a3ad5196$export$f6a25a78204acc7e)(u, n, t === null ? null : t.setSwitch), [o, a] = (0, $c6676ed1f400443a$export$454217e89aea72b)(f, h, r), S = (0, $0bd9972698c32399$export$90fc3a17d93f704c)(()=>a == null ? void 0 : a(!o)), D = (0, $0bd9972698c32399$export$90fc3a17d93f704c)((e)=>{
        if ((0, $3d3d670dbe2ceed6$export$db61f031a278447c)(e.currentTarget)) return e.preventDefault();
        e.preventDefault(), S();
    }), C = (0, $0bd9972698c32399$export$90fc3a17d93f704c)((e)=>{
        e.key === (0, $4cca0dbc68b0507a$export$4b0075e5ea5e1f26).Space ? (e.preventDefault(), S()) : e.key === (0, $4cca0dbc68b0507a$export$4b0075e5ea5e1f26).Enter && (0, $594e79751740d704$export$ee02894bdc79dd36)(e.currentTarget);
    }), L = (0, $0bd9972698c32399$export$90fc3a17d93f704c)((e)=>e.preventDefault()), x = (0, $acw62.useMemo)(()=>({
            checked: o
        }), [
        o
    ]), v = {
        id: c,
        ref: g,
        role: "switch",
        type: (0, $be828d8bf9bb25ca$export$53652b2b272efe9c)(s, u),
        tabIndex: 0,
        "aria-checked": o,
        "aria-labelledby": t == null ? void 0 : t.labelledby,
        "aria-describedby": t == null ? void 0 : t.describedby,
        onClick: D,
        onKeyUp: C,
        onKeyPress: L
    }, G = (0, $410e668b7f520622$export$fd183955ff4b45d9)();
    return (0, $acw62.useEffect)(()=>{
        var w;
        let e = (w = u.current) == null ? void 0 : w.closest("form");
        e && r !== void 0 && G.addEventListener(e, "reset", ()=>{
            a(r);
        });
    }, [
        u,
        a
    ]), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, l != null && o && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $eac0d614a77ee96b$export$8dc98ba7eadeaa56), {
        features: (0, $eac0d614a77ee96b$export$617d79dae526d2cf).Hidden,
        ...(0, $a54bdd13402af126$export$8e16b83750b44988)({
            as: "input",
            type: "checkbox",
            hidden: !0,
            readOnly: !0,
            form: y,
            checked: o,
            name: l,
            value: T
        })
    }), (0, $a54bdd13402af126$export$b3890eb0ae9dca99)({
        ourProps: v,
        theirProps: d,
        slot: x,
        defaultTag: $8bce35f563baeffd$var$ee,
        name: "Switch"
    }));
}
let $8bce35f563baeffd$var$ne = (0, $a54bdd13402af126$export$e43f39796049410c)($8bce35f563baeffd$var$te), $8bce35f563baeffd$var$re = $8bce35f563baeffd$var$Z, $8bce35f563baeffd$export$b5d5cf8927ab7262 = Object.assign($8bce35f563baeffd$var$ne, {
    Group: $8bce35f563baeffd$var$re,
    Label: (0, $3f2bea42b2459559$export$b04be29aa201d4f5),
    Description: (0, $d994aee5798540d7$export$393edc798c47379d)
});




$parcel$exportWildcard($834328a1cfd2af33$exports, $eaec5fceb04f7d33$exports);
$parcel$exportWildcard($834328a1cfd2af33$exports, $fd89a26ac969b4f3$exports);
$parcel$exportWildcard($834328a1cfd2af33$exports, $780306decd8ad6d8$exports);
$parcel$exportWildcard($834328a1cfd2af33$exports, $38ecc25572962dee$exports);
$parcel$exportWildcard($834328a1cfd2af33$exports, $df20442161b20eb0$exports);
$parcel$exportWildcard($834328a1cfd2af33$exports, $c9bfa4e2da6232f7$exports);
$parcel$exportWildcard($834328a1cfd2af33$exports, $77da6324ebaeb061$exports);
$parcel$exportWildcard($834328a1cfd2af33$exports, $2d8d7fe947ac67a8$exports);
$parcel$exportWildcard($834328a1cfd2af33$exports, $8bce35f563baeffd$exports);
$parcel$exportWildcard($834328a1cfd2af33$exports, $37edcfa19f505e9c$exports);
$parcel$exportWildcard($834328a1cfd2af33$exports, $030a82c6b2bb6f00$exports);







var $9ac152c824b2d089$exports = {};

$parcel$export($9ac152c824b2d089$exports, "defaultFallbackInView", () => $9ac152c824b2d089$export$2ef3a60ee1f37bec);
$parcel$export($9ac152c824b2d089$exports, "observe", () => $9ac152c824b2d089$export$d1203567a167490e);
$parcel$export($9ac152c824b2d089$exports, "InView", () => $9ac152c824b2d089$export$a62107ca74432f44);
$parcel$export($9ac152c824b2d089$exports, "useInView", () => $9ac152c824b2d089$export$2f62ee6831462844);

var $acw62 = parcelRequire("acw62");
"use client";
var $9ac152c824b2d089$var$__defProp = Object.defineProperty;
var $9ac152c824b2d089$var$__defNormalProp = (obj, key, value)=>key in obj ? $9ac152c824b2d089$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $9ac152c824b2d089$var$__publicField = (obj, key, value)=>{
    $9ac152c824b2d089$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
};
// src/observe.ts
var $9ac152c824b2d089$var$observerMap = /* @__PURE__ */ new Map();
var $9ac152c824b2d089$var$RootIds = /* @__PURE__ */ new WeakMap();
var $9ac152c824b2d089$var$rootId = 0;
var $9ac152c824b2d089$var$unsupportedValue = void 0;
function $9ac152c824b2d089$export$2ef3a60ee1f37bec(inView) {
    $9ac152c824b2d089$var$unsupportedValue = inView;
}
function $9ac152c824b2d089$var$getRootId(root) {
    if (!root) return "0";
    if ($9ac152c824b2d089$var$RootIds.has(root)) return $9ac152c824b2d089$var$RootIds.get(root);
    $9ac152c824b2d089$var$rootId += 1;
    $9ac152c824b2d089$var$RootIds.set(root, $9ac152c824b2d089$var$rootId.toString());
    return $9ac152c824b2d089$var$RootIds.get(root);
}
function $9ac152c824b2d089$var$optionsToId(options) {
    return Object.keys(options).sort().filter((key)=>options[key] !== void 0).map((key)=>{
        return `${key}_${key === "root" ? $9ac152c824b2d089$var$getRootId(options.root) : options[key]}`;
    }).toString();
}
function $9ac152c824b2d089$var$createObserver(options) {
    const id = $9ac152c824b2d089$var$optionsToId(options);
    let instance = $9ac152c824b2d089$var$observerMap.get(id);
    if (!instance) {
        const elements = /* @__PURE__ */ new Map();
        let thresholds;
        const observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                var _a;
                const inView = entry.isIntersecting && thresholds.some((threshold)=>entry.intersectionRatio >= threshold);
                if (options.trackVisibility && typeof entry.isVisible === "undefined") entry.isVisible = inView;
                (_a = elements.get(entry.target)) == null || _a.forEach((callback)=>{
                    callback(inView, entry);
                });
            });
        }, options);
        thresholds = observer.thresholds || (Array.isArray(options.threshold) ? options.threshold : [
            options.threshold || 0
        ]);
        instance = {
            id: id,
            observer: observer,
            elements: elements
        };
        $9ac152c824b2d089$var$observerMap.set(id, instance);
    }
    return instance;
}
function $9ac152c824b2d089$export$d1203567a167490e(element, callback, options = {}, fallbackInView = $9ac152c824b2d089$var$unsupportedValue) {
    if (typeof window.IntersectionObserver === "undefined" && fallbackInView !== void 0) {
        const bounds = element.getBoundingClientRect();
        callback(fallbackInView, {
            isIntersecting: fallbackInView,
            target: element,
            intersectionRatio: typeof options.threshold === "number" ? options.threshold : 0,
            time: 0,
            boundingClientRect: bounds,
            intersectionRect: bounds,
            rootBounds: bounds
        });
        return ()=>{};
    }
    const { id: id, observer: observer, elements: elements } = $9ac152c824b2d089$var$createObserver(options);
    const callbacks = elements.get(element) || [];
    if (!elements.has(element)) elements.set(element, callbacks);
    callbacks.push(callback);
    observer.observe(element);
    return function unobserve() {
        callbacks.splice(callbacks.indexOf(callback), 1);
        if (callbacks.length === 0) {
            elements.delete(element);
            observer.unobserve(element);
        }
        if (elements.size === 0) {
            observer.disconnect();
            $9ac152c824b2d089$var$observerMap.delete(id);
        }
    };
}
// src/InView.tsx
function $9ac152c824b2d089$var$isPlainChildren(props) {
    return typeof props.children !== "function";
}
var $9ac152c824b2d089$export$a62107ca74432f44 = class extends $acw62.Component {
    constructor(props){
        super(props);
        $9ac152c824b2d089$var$__publicField(this, "node", null);
        $9ac152c824b2d089$var$__publicField(this, "_unobserveCb", null);
        $9ac152c824b2d089$var$__publicField(this, "handleNode", (node)=>{
            if (this.node) {
                this.unobserve();
                if (!node && !this.props.triggerOnce && !this.props.skip) this.setState({
                    inView: !!this.props.initialInView,
                    entry: void 0
                });
            }
            this.node = node ? node : null;
            this.observeNode();
        });
        $9ac152c824b2d089$var$__publicField(this, "handleChange", (inView, entry)=>{
            if (inView && this.props.triggerOnce) this.unobserve();
            if (!$9ac152c824b2d089$var$isPlainChildren(this.props)) this.setState({
                inView: inView,
                entry: entry
            });
            if (this.props.onChange) this.props.onChange(inView, entry);
        });
        this.state = {
            inView: !!props.initialInView,
            entry: void 0
        };
    }
    componentDidMount() {
        this.unobserve();
        this.observeNode();
    }
    componentDidUpdate(prevProps) {
        if (prevProps.rootMargin !== this.props.rootMargin || prevProps.root !== this.props.root || prevProps.threshold !== this.props.threshold || prevProps.skip !== this.props.skip || prevProps.trackVisibility !== this.props.trackVisibility || prevProps.delay !== this.props.delay) {
            this.unobserve();
            this.observeNode();
        }
    }
    componentWillUnmount() {
        this.unobserve();
    }
    observeNode() {
        if (!this.node || this.props.skip) return;
        const { threshold: threshold, root: root, rootMargin: rootMargin, trackVisibility: trackVisibility, delay: delay, fallbackInView: fallbackInView } = this.props;
        this._unobserveCb = $9ac152c824b2d089$export$d1203567a167490e(this.node, this.handleChange, {
            threshold: threshold,
            root: root,
            rootMargin: rootMargin,
            trackVisibility: // @ts-ignore
            trackVisibility,
            delay: // @ts-ignore
            delay
        }, fallbackInView);
    }
    unobserve() {
        if (this._unobserveCb) {
            this._unobserveCb();
            this._unobserveCb = null;
        }
    }
    render() {
        const { children: children } = this.props;
        if (typeof children === "function") {
            const { inView: inView, entry: entry } = this.state;
            return children({
                inView: inView,
                entry: entry,
                ref: this.handleNode
            });
        }
        const { as: as, triggerOnce: triggerOnce, threshold: threshold, root: root, rootMargin: rootMargin, onChange: onChange, skip: skip, trackVisibility: trackVisibility, delay: delay, initialInView: initialInView, fallbackInView: fallbackInView, ...props } = this.props;
        return $acw62.createElement(as || "div", {
            ref: this.handleNode,
            ...props
        }, children);
    }
};
function $9ac152c824b2d089$export$2f62ee6831462844({ threshold: threshold, delay: delay, trackVisibility: trackVisibility, rootMargin: rootMargin, root: root, triggerOnce: triggerOnce, skip: skip, initialInView: initialInView, fallbackInView: fallbackInView, onChange: onChange } = {}) {
    var _a;
    const [ref, setRef] = $acw62.useState(null);
    const callback = $acw62.useRef();
    const [state, setState] = $acw62.useState({
        inView: !!initialInView,
        entry: void 0
    });
    callback.current = onChange;
    $acw62.useEffect(()=>{
        if (skip || !ref) return;
        let unobserve;
        unobserve = $9ac152c824b2d089$export$d1203567a167490e(ref, (inView, entry)=>{
            setState({
                inView: inView,
                entry: entry
            });
            if (callback.current) callback.current(inView, entry);
            if (entry.isIntersecting && triggerOnce && unobserve) {
                unobserve();
                unobserve = void 0;
            }
        }, {
            root: root,
            rootMargin: rootMargin,
            threshold: threshold,
            trackVisibility: // @ts-ignore
            trackVisibility,
            delay: // @ts-ignore
            delay
        }, fallbackInView);
        return ()=>{
            if (unobserve) unobserve();
        };
    }, // We break the rule here, because we aren't including the actual `threshold` variable
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        // If the threshold is an array, convert it to a string, so it won't change between renders.
        Array.isArray(threshold) ? threshold.toString() : threshold,
        ref,
        root,
        rootMargin,
        triggerOnce,
        skip,
        trackVisibility,
        fallbackInView,
        delay
    ]);
    const entryTarget = (_a = state.entry) == null ? void 0 : _a.target;
    const previousEntryTarget = $acw62.useRef();
    if (!ref && entryTarget && !triggerOnce && !skip && previousEntryTarget.current !== entryTarget) {
        previousEntryTarget.current = entryTarget;
        setState({
            inView: !!initialInView,
            entry: void 0
        });
    }
    const result = [
        setRef,
        state.inView,
        state.entry
    ];
    result.ref = result[0];
    result.inView = result[1];
    result.entry = result[2];
    return result;
}




var $f1q41 = parcelRequire("f1q41");

var $7Ockm = parcelRequire("7Ockm");


var $fuTml = parcelRequire("fuTml");

var $iQrBP = parcelRequire("iQrBP");

var $aHxeO = parcelRequire("aHxeO");

var $ardUq = parcelRequire("ardUq");










var $285e49985e5a39fa$exports = {};

$parcel$export($285e49985e5a39fa$exports, "Selector", () => $285e49985e5a39fa$export$d15f4cd5286f9b1e);
$parcel$export($285e49985e5a39fa$exports, "Sheet", () => $285e49985e5a39fa$export$a9bf29f8d87ebbee);
$parcel$export($285e49985e5a39fa$exports, "Code", () => $6d146131cf95401b$export$4e4e7267e6bca3a9);
$parcel$export($285e49985e5a39fa$exports, "JSExpr", () => $6d146131cf95401b$export$4e4e7267e6bca3a9);
$parcel$export($285e49985e5a39fa$exports, "BlockSelector", () => $3cde51ebcb63af9c$export$7ddf129dd8d5219f);
$parcel$export($285e49985e5a39fa$exports, "SheetOf", () => $2874ceca92f8bd68$export$8edc1c3b6e3ca47c);
$parcel$export($285e49985e5a39fa$exports, "DocumentOf", () => $2d38c60d8f38da78$export$e2d7b3be314ea7f1);
$parcel$export($285e49985e5a39fa$exports, "Note", () => $8c8e02836b046cc0$export$6c88bf799aca3d2b);
$parcel$export($285e49985e5a39fa$exports, "Debug", () => $73f95362102603c2$exports);
$parcel$export($285e49985e5a39fa$exports, "Util", () => $bb21728c877b3db6$exports);
var $2874ceca92f8bd68$exports = {};

$parcel$export($2874ceca92f8bd68$exports, "SheetOf", () => $2874ceca92f8bd68$export$8edc1c3b6e3ca47c);

parcelRequire("acw62");












function $0513784f1d78d6a9$var$typed(revision, obj) {
    return {
        t: "resheet.sheet",
        v: revision,
        ...obj
    };
}
function $0513784f1d78d6a9$var$typedTables(revision, obj) {
    return {
        t: "tables.sheet",
        v: revision,
        ...obj
    };
}
const $0513784f1d78d6a9$export$61f5628688eb54a9 = [
    "block",
    "result"
];
const $0513784f1d78d6a9$var$visibilitySchemaV0 = (0, $dc2e80b7ebe4adb5$export$a9a18ae5ba42aeab)(...$0513784f1d78d6a9$export$61f5628688eb54a9);
const $0513784f1d78d6a9$var$sheetLineSchemaV0 = (0, $dc2e80b7ebe4adb5$export$29be874c1daba180)($9d52f07a71ba7cea$export$313bdf01d4f71749((0, $dc2e80b7ebe4adb5$export$4154a199d7d90455), {
    visibility: $0513784f1d78d6a9$var$visibilitySchemaV0
}));
const $0513784f1d78d6a9$var$sheetSchemaV0 = (0, $dc2e80b7ebe4adb5$export$2f23118c22fb2630)($0513784f1d78d6a9$var$sheetLineSchemaV0);
const $0513784f1d78d6a9$var$vPre = (0, $303c1b51f19a20e4$export$136de4b706fa579)($0513784f1d78d6a9$var$sheetSchemaV0, $0513784f1d78d6a9$var$parseV0);
function $0513784f1d78d6a9$var$parseV0(json) {
    return (dispatch, env, innerBlock)=>{
        const dispatchLines = (0, $d0f575b1326e7f91$export$f153e5abd026c378)("lines", dispatch);
        return {
            lines: $9d52f07a71ba7cea$export$21625637effda04(json, dispatchLines, env, innerBlock, (entry, { visibility: visibility })=>({
                    ...entry,
                    visibility: $0513784f1d78d6a9$export$61f5628688eb54a9.includes(visibility) ? visibility : $0513784f1d78d6a9$export$61f5628688eb54a9[0]
                }))
        };
    };
}
const $0513784f1d78d6a9$var$v0 = (0, $303c1b51f19a20e4$export$471c540adb39cb81)($0513784f1d78d6a9$var$vPre, {
    schema: $0513784f1d78d6a9$var$typedTables(0, {
        lines: $0513784f1d78d6a9$var$sheetSchemaV0
    }),
    parse ({ lines: lines }) {
        return $0513784f1d78d6a9$var$parseV0(lines);
    },
    upgrade (before) {
        return before;
    }
});
const $0513784f1d78d6a9$export$11cb33cb3c138832 = (0, $303c1b51f19a20e4$export$471c540adb39cb81)($0513784f1d78d6a9$var$v0, {
    schema: $0513784f1d78d6a9$var$typed(1, {
        lines: $0513784f1d78d6a9$var$sheetSchemaV0
    }),
    parse ({ lines: lines }) {
        return $0513784f1d78d6a9$var$parseV0(lines);
    },
    upgrade (before) {
        return before;
    }
});
function $0513784f1d78d6a9$export$54fd2c36b5cc6731(state, innerBlock) {
    return $0513784f1d78d6a9$var$typed(1, {
        lines: state.lines.map(({ id: id, name: name, visibility: visibility, state: state })=>({
                id: id,
                name: name,
                visibility: visibility,
                state: innerBlock.toJSON(state)
            }))
    });
}


function $020dad93e2d78da8$var$typed(revision, obj) {
    return {
        t: "resheet.sheet",
        v: revision,
        ...obj
    };
}
const $020dad93e2d78da8$export$89ac0e24f357645c = [
    "narrow",
    "wide",
    "full"
];
const $020dad93e2d78da8$export$285aa6cd6e6400b7 = [
    "block",
    "result"
];
const $020dad93e2d78da8$var$lineWidthSchemaV2 = (0, $dc2e80b7ebe4adb5$export$a9a18ae5ba42aeab)(...$020dad93e2d78da8$export$89ac0e24f357645c);
const $020dad93e2d78da8$var$visibilitySchemaV2 = (0, $dc2e80b7ebe4adb5$export$a9a18ae5ba42aeab)(...$020dad93e2d78da8$export$285aa6cd6e6400b7);
const $020dad93e2d78da8$var$sheetLineSchemaV2 = (0, $dc2e80b7ebe4adb5$export$29be874c1daba180)($9d52f07a71ba7cea$export$313bdf01d4f71749((0, $dc2e80b7ebe4adb5$export$4154a199d7d90455), {
    width: $020dad93e2d78da8$var$lineWidthSchemaV2,
    visibility: $020dad93e2d78da8$var$visibilitySchemaV2
}));
const $020dad93e2d78da8$var$sheetSchemaV2 = (0, $dc2e80b7ebe4adb5$export$2f23118c22fb2630)($020dad93e2d78da8$var$sheetLineSchemaV2);
function $020dad93e2d78da8$var$parseV2(json) {
    return (dispatch, env, innerBlock)=>{
        const dispatchLines = (0, $d0f575b1326e7f91$export$f153e5abd026c378)("lines", dispatch);
        return {
            lines: $9d52f07a71ba7cea$export$21625637effda04(json, dispatchLines, env, innerBlock, (entry, { width: width, visibility: visibility })=>({
                    ...entry,
                    width: width,
                    visibility: visibility
                }))
        };
    };
}
function $020dad93e2d78da8$var$upgradeV2(before) {
    return (dispatch, env, innerBlock)=>{
        function dispatchV1(actionV1) {
            dispatch((stateV2, context)=>{
                const { state: newStateV1, ...output } = actionV1(stateV2, context);
                const newStateV2 = {
                    lines: newStateV1.lines.map((lineV1)=>({
                            ...lineV1,
                            width: stateV2.lines.find((lineV2)=>lineV2.id === lineV1.id)?.width ?? "narrow"
                        }))
                };
                return {
                    state: newStateV2,
                    ...output
                };
            });
        }
        const stateV1 = before(dispatchV1, env, innerBlock);
        return {
            lines: stateV1.lines.map((lineV1)=>({
                    ...lineV1,
                    width: "narrow"
                }))
        };
    };
}
const $020dad93e2d78da8$export$8815aa1d021a7d50 = (0, $303c1b51f19a20e4$export$471c540adb39cb81)((0, $0513784f1d78d6a9$export$11cb33cb3c138832), {
    schema: $020dad93e2d78da8$var$typed(2, {
        lines: $020dad93e2d78da8$var$sheetSchemaV2
    }),
    parse ({ lines: lines }) {
        return $020dad93e2d78da8$var$parseV2(lines);
    },
    upgrade (before) {
        return $020dad93e2d78da8$var$upgradeV2(before);
    }
});
function $020dad93e2d78da8$export$54fd2c36b5cc6731(state, innerBlock) {
    return $020dad93e2d78da8$var$typed(2, {
        lines: state.lines.map(({ id: id, name: name, visibility: visibility, width: width, state: state })=>({
                id: id,
                name: name,
                visibility: visibility,
                width: width,
                state: innerBlock.toJSON(state)
            }))
    });
}





function $f042fdc9cbbc2b08$export$2433b834a71dd0c8(visibility) {
    return (0, $512ec8d668819b2f$export$77e0d221223292dc)(visibility, (0, $020dad93e2d78da8$export$285aa6cd6e6400b7));
}
function $f042fdc9cbbc2b08$export$51e5fcbbd6d5bf18(width) {
    return (0, $512ec8d668819b2f$export$77e0d221223292dc)(width, (0, $020dad93e2d78da8$export$89ac0e24f357645c));
}
const $f042fdc9cbbc2b08$export$2cd8252107eb640b = {
    lines: []
};
const $f042fdc9cbbc2b08$export$d55ead31e9b19ee3 = $9d52f07a71ba7cea$export$3ef451a1310c1c34;
const $f042fdc9cbbc2b08$export$90e424595d6c2873 = $9d52f07a71ba7cea$export$dc55bda8be79296a;
const $f042fdc9cbbc2b08$export$526a230723648f1d = $9d52f07a71ba7cea$export$947e1a03252d3fb2;
function $f042fdc9cbbc2b08$export$fba3009e3ea7651a(state) {
    return $9d52f07a71ba7cea$export$fba3009e3ea7651a(state.lines);
}
function $f042fdc9cbbc2b08$export$d540f50abaed3adb(state, id, action) {
    return {
        ...state,
        lines: $9d52f07a71ba7cea$export$6000eb93d6447365(state.lines, id, action)
    };
}
function $f042fdc9cbbc2b08$export$661afaf0a7b1481e(state, id, action, dispatch, env, innerBlock) {
    const lineIndex = state.lines.findIndex((line)=>line.id === id);
    if (lineIndex < 0) return state;
    const line = state.lines[lineIndex];
    const newLine = action(line);
    return {
        ...state,
        lines: $9d52f07a71ba7cea$export$bb6ff48d725fca5e((0, $dc9f544fa111904d$export$adaa4cf7ef1b65be)(state.lines, lineIndex, newLine), id, env, (0, $e6de90c09d008aae$export$bdf4ff5a442cbbc5)([
            $f042fdc9cbbc2b08$export$90e424595d6c2873(line),
            $f042fdc9cbbc2b08$export$90e424595d6c2873(newLine)
        ]), innerBlock, (0, $d0f575b1326e7f91$export$f153e5abd026c378)("lines", dispatch), 1).state
    };
}
function $f042fdc9cbbc2b08$export$cc49eae3401c619b(state, id, newLine, dispatch, env, innerBlock) {
    return {
        ...state,
        lines: $9d52f07a71ba7cea$export$bb6ff48d725fca5e($9d52f07a71ba7cea$export$22e6c95d5bbbfd04(state.lines, id, newLine), id, env, (0, $e6de90c09d008aae$export$bdf4ff5a442cbbc5)([
            $f042fdc9cbbc2b08$export$90e424595d6c2873(newLine)
        ]), innerBlock, (0, $d0f575b1326e7f91$export$f153e5abd026c378)("lines", dispatch)).state
    };
}
function $f042fdc9cbbc2b08$export$81db1fdca5a72c2(state, id, newLine, dispatch, env, innerBlock) {
    return {
        ...state,
        lines: $9d52f07a71ba7cea$export$bb6ff48d725fca5e($9d52f07a71ba7cea$export$41ee562435ce1bbf(state.lines, id, newLine), newLine.id, env, (0, $e6de90c09d008aae$export$bdf4ff5a442cbbc5)([
            $f042fdc9cbbc2b08$export$90e424595d6c2873(newLine)
        ]), innerBlock, (0, $d0f575b1326e7f91$export$f153e5abd026c378)("lines", dispatch)).state
    };
}
function $f042fdc9cbbc2b08$export$5d2c014dfbff2767(state, newLine, dispatch, env, innerBlock) {
    return {
        ...state,
        lines: $9d52f07a71ba7cea$export$bb6ff48d725fca5e([
            ...state.lines,
            newLine
        ], newLine.id, env, (0, $e6de90c09d008aae$export$bdf4ff5a442cbbc5)([
            $f042fdc9cbbc2b08$export$90e424595d6c2873(newLine)
        ]), innerBlock, (0, $d0f575b1326e7f91$export$f153e5abd026c378)("lines", dispatch)).state
    };
}
function $f042fdc9cbbc2b08$export$ce256c4f2953eb9f(state, ids, dispatch, env, innerBlock) {
    const index = state.lines.findIndex((line)=>ids.includes(line.id));
    const deletedLines = state.lines.filter((line)=>ids.includes(line.id));
    const changedVars = (0, $e6de90c09d008aae$export$bdf4ff5a442cbbc5)(deletedLines.map($f042fdc9cbbc2b08$export$90e424595d6c2873));
    const linesWithoutIds = state.lines.filter((line)=>!ids.includes(line.id));
    const prevIndex = (0, $512ec8d668819b2f$export$d17171af8942fb21)(0, linesWithoutIds.length, index - 1);
    const prevId = linesWithoutIds[prevIndex]?.id;
    return [
        prevId,
        {
            ...state,
            lines: $9d52f07a71ba7cea$export$bb6ff48d725fca5e(linesWithoutIds, undefined, env, changedVars, innerBlock, (0, $d0f575b1326e7f91$export$f153e5abd026c378)("lines", dispatch), index).state
        }
    ];
}
function $f042fdc9cbbc2b08$export$1f297d8d0ce29e3(state, dispatch, env, changedVars, innerBlock) {
    const dispatchLines = (0, $d0f575b1326e7f91$export$f153e5abd026c378)("lines", dispatch);
    const { state: lines, invalidated: invalidated } = $9d52f07a71ba7cea$export$1f297d8d0ce29e3(state.lines, dispatchLines, env, changedVars, innerBlock);
    return {
        state: {
            ...state,
            lines: lines
        },
        invalidated: invalidated
    };
}
function $f042fdc9cbbc2b08$export$ec795fdf61e2a255(state, innerBlock) {
    return $9d52f07a71ba7cea$export$b0bda37006f1b949(state.lines, innerBlock);
}
function $f042fdc9cbbc2b08$export$f1a959c0cb168d75(line, innerBlock) {
    return innerBlock.getResult(line.state);
}
function $f042fdc9cbbc2b08$export$2a21b7cae538793e(state, id, action, innerBlock, env, dispatch) {
    const dispatchLines = (0, $d0f575b1326e7f91$export$f153e5abd026c378)("lines", dispatch);
    return {
        ...state,
        lines: $9d52f07a71ba7cea$export$853a2b6d97afe5a(state.lines, id, action, env, innerBlock, dispatchLines)
    };
}




var $acw62 = parcelRequire("acw62");



/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ // $FlowFixMe
function $e18645ac1956fbe6$var$sheetForTag(tag) {
    if (tag.sheet) // $FlowFixMe
    return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) // $FlowFixMe
        return document.styleSheets[i];
    }
}
function $e18645ac1956fbe6$var$createStyleElement(options) {
    var tag = document.createElement("style");
    tag.setAttribute("data-emotion", options.key);
    if (options.nonce !== undefined) tag.setAttribute("nonce", options.nonce);
    tag.appendChild(document.createTextNode(""));
    tag.setAttribute("data-s", "");
    return tag;
}
var $e18645ac1956fbe6$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? true : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($e18645ac1956fbe6$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        var isImportRule;
        if (this.isSpeedy) {
            var sheet = $e18645ac1956fbe6$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        // $FlowFixMe
        this.tags.forEach(function(tag) {
            return tag.parentNode && tag.parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();


var $298fb931ed4fbf8b$export$71ad59f2e432cfe8 = "-ms-";
var $298fb931ed4fbf8b$export$2c0f367103c8d01c = "-moz-";
var $298fb931ed4fbf8b$export$39dfd62a25e0fe93 = "-webkit-";
var $298fb931ed4fbf8b$export$a29989082612d0d9 = "comm";
var $298fb931ed4fbf8b$export$aa3a2e812ca8570d = "rule";
var $298fb931ed4fbf8b$export$527d108ccf083c2b = "decl";
var $298fb931ed4fbf8b$export$d3d35020fa5b54f0 = "@page";
var $298fb931ed4fbf8b$export$500415a86c544f73 = "@media";
var $298fb931ed4fbf8b$export$a763edbf796b780a = "@import";
var $298fb931ed4fbf8b$export$2790aeb8b4e5c826 = "@charset";
var $298fb931ed4fbf8b$export$1cc683e23b84b133 = "@viewport";
var $298fb931ed4fbf8b$export$9447a5efea57e862 = "@supports";
var $298fb931ed4fbf8b$export$ef011b4e114b1fba = "@document";
var $298fb931ed4fbf8b$export$6aad947bda0f3f46 = "@namespace";
var $298fb931ed4fbf8b$export$b44a8529a35fcb60 = "@keyframes";
var $298fb931ed4fbf8b$export$2c16de31893252e6 = "@font-face";
var $298fb931ed4fbf8b$export$3d846dd52e150c6f = "@counter-style";
var $298fb931ed4fbf8b$export$22314bfbb57653fe = "@font-feature-values";
var $298fb931ed4fbf8b$export$d773506282b3cfe6 = "@layer";
var $298fb931ed4fbf8b$export$2335f513bbd82c6d = Math.abs;
var $298fb931ed4fbf8b$export$6788812c4e6611e6 = String.fromCharCode;
var $298fb931ed4fbf8b$export$e6e34fd1f2686227 = Object.assign;
function $298fb931ed4fbf8b$export$d6af199866bfb566(e, r) {
    return $298fb931ed4fbf8b$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 0)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 1)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 2)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 3) : 0;
}
function $298fb931ed4fbf8b$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $298fb931ed4fbf8b$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $298fb931ed4fbf8b$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $298fb931ed4fbf8b$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $298fb931ed4fbf8b$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $298fb931ed4fbf8b$export$36776f635604f274(e) {
    return e.length;
}
function $298fb931ed4fbf8b$export$f9084667e487ed46(e) {
    return e.length;
}
function $298fb931ed4fbf8b$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $298fb931ed4fbf8b$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $298fb931ed4fbf8b$export$53f1d5ea8de3d7c = 1;
var $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1;
var $298fb931ed4fbf8b$export$f24224f1c91d8156 = 0;
var $298fb931ed4fbf8b$export$5880b8b5730aff45 = 0;
var $298fb931ed4fbf8b$export$c0306caf338ac095 = 0;
var $298fb931ed4fbf8b$export$30a86d91af8ff6e6 = "";
function $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $298fb931ed4fbf8b$export$53f1d5ea8de3d7c,
        column: $298fb931ed4fbf8b$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $298fb931ed4fbf8b$export$784d13d8ee351f07(e, r) {
    return $298fb931ed4fbf8b$export$e6e34fd1f2686227($298fb931ed4fbf8b$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $298fb931ed4fbf8b$export$eba6f6f03b0a92e7() {
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$232faf9add678146() {
    $298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$5880b8b5730aff45 > 0 ? $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, --$298fb931ed4fbf8b$export$5880b8b5730aff45) : 0;
    if ($298fb931ed4fbf8b$export$4e0c71f277ca26b3--, $298fb931ed4fbf8b$export$c0306caf338ac095 === 10) $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$53f1d5ea8de3d7c--;
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$48cfd1e771a65c4f() {
    $298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$5880b8b5730aff45 < $298fb931ed4fbf8b$export$f24224f1c91d8156 ? $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, $298fb931ed4fbf8b$export$5880b8b5730aff45++) : 0;
    if ($298fb931ed4fbf8b$export$4e0c71f277ca26b3++, $298fb931ed4fbf8b$export$c0306caf338ac095 === 10) $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$53f1d5ea8de3d7c++;
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$4d3fb11e950abb9e() {
    return $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, $298fb931ed4fbf8b$export$5880b8b5730aff45);
}
function $298fb931ed4fbf8b$export$e88cb2efb12ae807() {
    return $298fb931ed4fbf8b$export$5880b8b5730aff45;
}
function $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, r) {
    return $298fb931ed4fbf8b$export$2f35ab04d2335697($298fb931ed4fbf8b$export$30a86d91af8ff6e6, e, r);
}
function $298fb931ed4fbf8b$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $298fb931ed4fbf8b$export$2de70f21292aac9e(e) {
    return $298fb931ed4fbf8b$export$53f1d5ea8de3d7c = $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$f24224f1c91d8156 = $298fb931ed4fbf8b$export$36776f635604f274($298fb931ed4fbf8b$export$30a86d91af8ff6e6 = e), $298fb931ed4fbf8b$export$5880b8b5730aff45 = 0, [];
}
function $298fb931ed4fbf8b$export$45918ac1574455b1(e) {
    return $298fb931ed4fbf8b$export$30a86d91af8ff6e6 = "", e;
}
function $298fb931ed4fbf8b$export$410ac95b9ec204b8(e) {
    return $298fb931ed4fbf8b$export$87c2784dc9fc4ab($298fb931ed4fbf8b$export$58adb3bec8346d0f($298fb931ed4fbf8b$export$5880b8b5730aff45 - 1, $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $298fb931ed4fbf8b$export$660b2ee2d4fb4eff(e) {
    return $298fb931ed4fbf8b$export$45918ac1574455b1($298fb931ed4fbf8b$export$5f8c09e3ae6f64e1($298fb931ed4fbf8b$export$2de70f21292aac9e(e)));
}
function $298fb931ed4fbf8b$export$7af1228ff777d175(e) {
    while($298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$4d3fb11e950abb9e())if ($298fb931ed4fbf8b$export$c0306caf338ac095 < 33) $298fb931ed4fbf8b$export$48cfd1e771a65c4f();
    else break;
    return $298fb931ed4fbf8b$export$9e1725a4cfeada27(e) > 2 || $298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $298fb931ed4fbf8b$export$5f8c09e3ae6f64e1(e) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())switch($298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$c0306caf338ac095)){
        case 0:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$c2ab62c7bf24634($298fb931ed4fbf8b$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$410ac95b9ec204b8($298fb931ed4fbf8b$export$c0306caf338ac095), e);
            break;
        default:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$6788812c4e6611e6($298fb931ed4fbf8b$export$c0306caf338ac095), e);
    }
    return e;
}
function $298fb931ed4fbf8b$export$955ba06d119e085e(e, r) {
    while(--r && $298fb931ed4fbf8b$export$48cfd1e771a65c4f())if ($298fb931ed4fbf8b$export$c0306caf338ac095 < 48 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 102 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 57 && $298fb931ed4fbf8b$export$c0306caf338ac095 < 65 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 70 && $298fb931ed4fbf8b$export$c0306caf338ac095 < 97) break;
    return $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, $298fb931ed4fbf8b$export$e88cb2efb12ae807() + (r < 6 && $298fb931ed4fbf8b$export$4d3fb11e950abb9e() == 32 && $298fb931ed4fbf8b$export$48cfd1e771a65c4f() == 32));
}
function $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())switch($298fb931ed4fbf8b$export$c0306caf338ac095){
        case e:
            return $298fb931ed4fbf8b$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $298fb931ed4fbf8b$export$c889f2fcc19dbf12($298fb931ed4fbf8b$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $298fb931ed4fbf8b$export$48cfd1e771a65c4f();
            break;
    }
    return $298fb931ed4fbf8b$export$5880b8b5730aff45;
}
function $298fb931ed4fbf8b$export$4254d4e2b3745c4c(e, r) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())if (e + $298fb931ed4fbf8b$export$c0306caf338ac095 === 57) break;
    else if (e + $298fb931ed4fbf8b$export$c0306caf338ac095 === 84 && $298fb931ed4fbf8b$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $298fb931ed4fbf8b$export$58adb3bec8346d0f(r, $298fb931ed4fbf8b$export$5880b8b5730aff45 - 1) + "*" + $298fb931ed4fbf8b$export$6788812c4e6611e6(e === 47 ? e : $298fb931ed4fbf8b$export$48cfd1e771a65c4f());
}
function $298fb931ed4fbf8b$export$c2ab62c7bf24634(e) {
    while(!$298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$4d3fb11e950abb9e()))$298fb931ed4fbf8b$export$48cfd1e771a65c4f();
    return $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, $298fb931ed4fbf8b$export$5880b8b5730aff45);
}
function $298fb931ed4fbf8b$export$ef7acd7185315e22(e) {
    return $298fb931ed4fbf8b$export$45918ac1574455b1($298fb931ed4fbf8b$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $298fb931ed4fbf8b$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $298fb931ed4fbf8b$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = $298fb931ed4fbf8b$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $298fb931ed4fbf8b$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($298fb931ed4fbf8b$export$f8e21b1e77979a08(j += $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $298fb931ed4fbf8b$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $298fb931ed4fbf8b$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $298fb931ed4fbf8b$export$955ba06d119e085e($298fb931ed4fbf8b$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($298fb931ed4fbf8b$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$4a34f930e789283c($298fb931ed4fbf8b$export$4254d4e2b3745c4c($298fb931ed4fbf8b$export$48cfd1e771a65c4f(), $298fb931ed4fbf8b$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $298fb931ed4fbf8b$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $298fb931ed4fbf8b$export$36776f635604f274(j) - l) $298fb931ed4fbf8b$export$10d8903dec122b9d(p > 32 ? $298fb931ed4fbf8b$export$f8483753829ec8f3(j + ";", n, a, l - 1) : $298fb931ed4fbf8b$export$f8483753829ec8f3($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $298fb931ed4fbf8b$export$10d8903dec122b9d(y = $298fb931ed4fbf8b$export$3307ffa7023ede1e(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $298fb931ed4fbf8b$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $298fb931ed4fbf8b$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $298fb931ed4fbf8b$export$98e6a39c04603d36(e, y, y, n && $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $298fb931ed4fbf8b$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + $298fb931ed4fbf8b$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $298fb931ed4fbf8b$export$232faf9add678146() == 125) continue;
            }
            switch(j += $298fb931ed4fbf8b$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($298fb931ed4fbf8b$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($298fb931ed4fbf8b$export$4d3fb11e950abb9e() === 45) j += $298fb931ed4fbf8b$export$410ac95b9ec204b8($298fb931ed4fbf8b$export$48cfd1e771a65c4f());
                    v = $298fb931ed4fbf8b$export$4d3fb11e950abb9e(), o = l = $298fb931ed4fbf8b$export$36776f635604f274(g = j += $298fb931ed4fbf8b$export$c2ab62c7bf24634($298fb931ed4fbf8b$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $298fb931ed4fbf8b$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $298fb931ed4fbf8b$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $298fb931ed4fbf8b$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = $298fb931ed4fbf8b$export$2f35ab04d2335697(e, v + 1, v = $298fb931ed4fbf8b$export$2335f513bbd82c6d(w = u[b])), m = e; $ < h; ++$)if (m = $298fb931ed4fbf8b$export$87c2784dc9fc4ab(w > 0 ? p[$] + " " + k : $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(k, /&\f/g, p[$]))) f[d++] = m;
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, s === 0 ? $298fb931ed4fbf8b$export$aa3a2e812ca8570d : i, f, o, l);
}
function $298fb931ed4fbf8b$export$4a34f930e789283c(e, r, a) {
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, $298fb931ed4fbf8b$export$a29989082612d0d9, $298fb931ed4fbf8b$export$6788812c4e6611e6($298fb931ed4fbf8b$export$eba6f6f03b0a92e7()), $298fb931ed4fbf8b$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $298fb931ed4fbf8b$export$f8483753829ec8f3(e, r, a, n) {
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, $298fb931ed4fbf8b$export$527d108ccf083c2b, $298fb931ed4fbf8b$export$2f35ab04d2335697(e, 0, n), $298fb931ed4fbf8b$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $298fb931ed4fbf8b$export$82e9f45cca5ba907(n, c, s) {
    switch($298fb931ed4fbf8b$export$d6af199866bfb566(n, c)){
        case 5103:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $298fb931ed4fbf8b$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$2c0f367103c8d01c + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-$1$2" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-item-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$298fb931ed4fbf8b$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-row-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-line-pack" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-grow", "") + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-pack:$3" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$298fb931ed4fbf8b$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-column-align" + $298fb931ed4fbf8b$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $298fb931ed4fbf8b$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$298fb931ed4fbf8b$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$298fb931ed4fbf8b$export$f8e21b1e77979a08(s, "span") ? $298fb931ed4fbf8b$export$4659b591c19bdf3d(s, /\d+/) : +$298fb931ed4fbf8b$export$4659b591c19bdf3d(s, /\d+/) - +$298fb931ed4fbf8b$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $298fb931ed4fbf8b$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($298fb931ed4fbf8b$export$36776f635604f274(n) - 1 - c > 6) switch($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + ($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$298fb931ed4fbf8b$export$f8e21b1e77979a08(n, "stretch") ? $298fb931ed4fbf8b$export$82e9f45cca5ba907($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 6) === 121) return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, ":", ":" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($298fb931ed4fbf8b$export$a9db5e087081082d(n, $298fb931ed4fbf8b$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + ($298fb931ed4fbf8b$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, ":", ":" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $298fb931ed4fbf8b$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $298fb931ed4fbf8b$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $298fb931ed4fbf8b$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $298fb931ed4fbf8b$export$a763edbf796b780a:
        case $298fb931ed4fbf8b$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $298fb931ed4fbf8b$export$a29989082612d0d9:
            return "";
        case $298fb931ed4fbf8b$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $298fb931ed4fbf8b$export$36776f635604f274(a = $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $298fb931ed4fbf8b$export$5a7767152ae0305f(e) {
    var r = $298fb931ed4fbf8b$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $298fb931ed4fbf8b$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $298fb931ed4fbf8b$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $298fb931ed4fbf8b$export$527d108ccf083c2b:
                n.return = $298fb931ed4fbf8b$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $298fb931ed4fbf8b$export$b44a8529a35fcb60:
                return $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb([
                    $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                        value: $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
                if (n.length) return $298fb931ed4fbf8b$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($298fb931ed4fbf8b$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb([
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb([
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $298fb931ed4fbf8b$export$76a88f7de6507443(e) {
    switch(e.type){
        case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $298fb931ed4fbf8b$export$1be1fc439b849fdf($298fb931ed4fbf8b$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($298fb931ed4fbf8b$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $298fb931ed4fbf8b$export$2f35ab04d2335697(r, 1, $298fb931ed4fbf8b$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $298fb931ed4fbf8b$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $298fb931ed4fbf8b$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $298fb931ed4fbf8b$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}


var $d68ffb0773f38e18$export$2e2bcd8739ae039 = function weakMemoize(func) {
    // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // $FlowFixMe
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};


function $6bb1e54ce1bc6efa$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}


var $fc182b1f84212d3f$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $298fb931ed4fbf8b$export$4d3fb11e950abb9e)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $298fb931ed4fbf8b$export$9e1725a4cfeada27)(character)) break;
        (0, $298fb931ed4fbf8b$export$48cfd1e771a65c4f)();
    }
    return (0, $298fb931ed4fbf8b$export$58adb3bec8346d0f)(begin, (0, $298fb931ed4fbf8b$export$5880b8b5730aff45));
};
var $fc182b1f84212d3f$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $298fb931ed4fbf8b$export$9e1725a4cfeada27)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $298fb931ed4fbf8b$export$4d3fb11e950abb9e)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $fc182b1f84212d3f$var$identifierWithPointTracking((0, $298fb931ed4fbf8b$export$5880b8b5730aff45) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $298fb931ed4fbf8b$export$410ac95b9ec204b8)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $298fb931ed4fbf8b$export$4d3fb11e950abb9e)() === 58 ? "&\f" : "";
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $298fb931ed4fbf8b$export$6788812c4e6611e6)(character);
    }
    while (character = (0, $298fb931ed4fbf8b$export$48cfd1e771a65c4f)());
    return parsed;
};
var $fc182b1f84212d3f$var$getRules = function getRules(value, points) {
    return (0, $298fb931ed4fbf8b$export$45918ac1574455b1)($fc182b1f84212d3f$var$toRules((0, $298fb931ed4fbf8b$export$2de70f21292aac9e)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $fc182b1f84212d3f$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $fc182b1f84212d3f$var$compat = function compat(element) {
    if (element.type !== "rule" || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value, parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== "rule"){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$fc182b1f84212d3f$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $fc182b1f84212d3f$var$fixedElements.set(element, true);
    var points = [];
    var rules = $fc182b1f84212d3f$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $fc182b1f84212d3f$var$removeLabel = function removeLabel(element) {
    if (element.type === "decl") {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = "";
            element.value = "";
        }
    }
};
var $fc182b1f84212d3f$var$ignoreFlag = "emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason";
var $fc182b1f84212d3f$var$isIgnoringComment = function isIgnoringComment(element) {
    return element.type === "comm" && element.children.indexOf($fc182b1f84212d3f$var$ignoreFlag) > -1;
};
var $fc182b1f84212d3f$var$createUnsafeSelectorsAlarm = function createUnsafeSelectorsAlarm(cache) {
    return function(element, index, children) {
        if (element.type !== "rule" || cache.compat) return;
        var unsafePseudoClasses = element.value.match(/(:first|:nth|:nth-last)-child/g);
        if (unsafePseudoClasses) {
            var isNested = !!element.parent; // in nested rules comments become children of the "auto-inserted" rule and that's always the `element.parent`
            //
            // considering this input:
            // .a {
            //   .b /* comm */ {}
            //   color: hotpink;
            // }
            // we get output corresponding to this:
            // .a {
            //   & {
            //     /* comm */
            //     color: hotpink;
            //   }
            //   .b {}
            // }
            var commentContainer = isNested ? element.parent.children : children;
            for(var i = commentContainer.length - 1; i >= 0; i--){
                var node = commentContainer[i];
                if (node.line < element.line) break;
                 // it is quite weird but comments are *usually* put at `column: element.column - 1`
                // so we seek *from the end* for the node that is earlier than the rule's `element` and check that
                // this will also match inputs like this:
                // .a {
                //   /* comm */
                //   .b {}
                // }
                //
                // but that is fine
                //
                // it would be the easiest to change the placement of the comment to be the first child of the rule:
                // .a {
                //   .b { /* comm */ }
                // }
                // with such inputs we wouldn't have to search for the comment at all
                // TODO: consider changing this comment placement in the next major version
                if (node.column < element.column) {
                    if ($fc182b1f84212d3f$var$isIgnoringComment(node)) return;
                    break;
                }
            }
            unsafePseudoClasses.forEach(function(unsafePseudoClass) {
                console.error('The pseudo class "' + unsafePseudoClass + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + unsafePseudoClass.split("-child")[0] + '-of-type".');
            });
        }
    };
};
var $fc182b1f84212d3f$var$isImportRule = function isImportRule(element) {
    return element.type.charCodeAt(1) === 105 && element.type.charCodeAt(0) === 64;
};
var $fc182b1f84212d3f$var$isPrependedWithRegularRules = function isPrependedWithRegularRules(index, children) {
    for(var i = index - 1; i >= 0; i--){
        if (!$fc182b1f84212d3f$var$isImportRule(children[i])) return true;
    }
    return false;
}; // use this to remove incorrect elements from further processing
// so they don't get handed to the `sheet` (or anything else)
// as that could potentially lead to additional logs which in turn could be overhelming to the user
var $fc182b1f84212d3f$var$nullifyElement = function nullifyElement(element) {
    element.type = "";
    element.value = "";
    element["return"] = "";
    element.children = "";
    element.props = "";
};
var $fc182b1f84212d3f$var$incorrectImportAlarm = function incorrectImportAlarm(element, index, children) {
    if (!$fc182b1f84212d3f$var$isImportRule(element)) return;
    if (element.parent) {
        console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles.");
        $fc182b1f84212d3f$var$nullifyElement(element);
    } else if ($fc182b1f84212d3f$var$isPrependedWithRegularRules(index, children)) {
        console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules.");
        $fc182b1f84212d3f$var$nullifyElement(element);
    }
};
/* eslint-disable no-fallthrough */ function $fc182b1f84212d3f$var$prefix(value, length) {
    switch((0, $298fb931ed4fbf8b$export$d6af199866bfb566)(value, length)){
        // color-adjust
        case 5103:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + "print-" + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$2c0f367103c8d01c) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + value + value;
        // order
        case 6165:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + "flex-" + value + value;
        // align-items
        case 5187:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /(\w+).+(:[^]+)/, (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + "box-$1$2" + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + "flex-$1$2") + value;
        // align-self
        case 5443:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + "flex-item-" + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /flex-|-self/, "") + value;
        // align-content
        case 4675:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + "flex-line-pack" + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /align-content|flex-|-self/, "") + value;
        // flex-shrink
        case 5548:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, "shrink", "negative") + value;
        // flex-basis
        case 5292:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, "basis", "preferred-size") + value;
        // flex-grow
        case 6060:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + "box-" + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, "-grow", "") + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, "grow", "positive") + value;
        // transition
        case 4554:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /([^-])(transform)/g, "$1" + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + "$2") + value;
        // cursor
        case 6187:
            return (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)((0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)((0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /(zoom-|grab)/, (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + "$1"), /(image-set)/, (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + "$1"), value, "") + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /(image-set\([^]*)/, (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + "$1" + "$`$1");
        // justify-content
        case 4968:
            return (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)((0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /(.+:)(flex-)?(.*)/, (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + "box-pack:$3" + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /(.+)-inline(.+)/, (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + "$1$2") + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $298fb931ed4fbf8b$export$36776f635604f274)(value) - 1 - length > 6) switch((0, $298fb931ed4fbf8b$export$a9db5e087081082d)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $298fb931ed4fbf8b$export$a9db5e087081082d)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /(.+:)(.+)-([^]+)/, "$1" + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + "$2-$3" + "$1" + (0, $298fb931ed4fbf8b$export$2c0f367103c8d01c) + ((0, $298fb931ed4fbf8b$export$a9db5e087081082d)(value, length + 3) == 108 ? "$3" : "$2-$3")) + value;
                // (s)tretch
                case 115:
                    return ~(0, $298fb931ed4fbf8b$export$f8e21b1e77979a08)(value, "stretch") ? $fc182b1f84212d3f$var$prefix((0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, "stretch", "fill-available"), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $298fb931ed4fbf8b$export$a9db5e087081082d)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $298fb931ed4fbf8b$export$a9db5e087081082d)(value, (0, $298fb931ed4fbf8b$export$36776f635604f274)(value) - 3 - (~(0, $298fb931ed4fbf8b$export$f8e21b1e77979a08)(value, "!important") && 10))){
                // stic(k)y
                case 107:
                    return (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, ":", ":" + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /(.+:)([^;!]+)(;|!.+)?/, "$1" + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + ((0, $298fb931ed4fbf8b$export$a9db5e087081082d)(value, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + "$2$3" + "$1" + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + "$2box$3") + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $298fb931ed4fbf8b$export$a9db5e087081082d)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, "tb") + value;
                // vertical-r(l)
                case 108:
                    return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, "tb-rl") + value;
                // horizontal(-)tb
                case 45:
                    return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, "lr") + value;
            }
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + value + value;
    }
    return value;
}
var $fc182b1f84212d3f$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $298fb931ed4fbf8b$export$527d108ccf083c2b:
                element["return"] = $fc182b1f84212d3f$var$prefix(element.value, element.length);
                break;
            case 0, $298fb931ed4fbf8b$export$b44a8529a35fcb60:
                return (0, $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb)([
                    (0, $298fb931ed4fbf8b$export$784d13d8ee351f07)(element, {
                        value: (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(element.value, "@", "@" + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93))
                    })
                ], callback);
            case 0, $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
                if (element.length) return (0, $298fb931ed4fbf8b$export$1be1fc439b849fdf)(element.props, function(value) {
                    switch((0, $298fb931ed4fbf8b$export$4659b591c19bdf3d)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ":read-only":
                        case ":read-write":
                            return (0, $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb)([
                                (0, $298fb931ed4fbf8b$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /:(read-\w+)/, ":" + (0, $298fb931ed4fbf8b$export$2c0f367103c8d01c) + "$1")
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case "::placeholder":
                            return (0, $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb)([
                                (0, $298fb931ed4fbf8b$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ":" + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + "input-$1")
                                    ]
                                }),
                                (0, $298fb931ed4fbf8b$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ":" + (0, $298fb931ed4fbf8b$export$2c0f367103c8d01c) + "$1")
                                    ]
                                }),
                                (0, $298fb931ed4fbf8b$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + "input-$1")
                                    ]
                                })
                            ], callback);
                    }
                    return "";
                });
        }
    }
};
var $fc182b1f84212d3f$var$defaultStylisPlugins = [
    $fc182b1f84212d3f$var$prefixer
];
var $fc182b1f84212d3f$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if (key === "css") {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute("data-emotion");
            if (dataEmotionAttribute.indexOf(" ") === -1) return;
            document.head.appendChild(node);
            node.setAttribute("data-s", "");
        });
    }
    var stylisPlugins = options.stylisPlugins || $fc182b1f84212d3f$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    container = options.container || document.head;
    Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + key + ' "]'), function(node) {
        var attrib = node.getAttribute("data-emotion").split(" "); // $FlowFixMe
        for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
        nodesToHydrate.push(node);
    });
    var _insert;
    var omnipresentPlugins = [
        $fc182b1f84212d3f$var$compat,
        $fc182b1f84212d3f$var$removeLabel
    ];
    var currentSheet;
    var finalizingPlugins = [
        (0, $298fb931ed4fbf8b$export$fac44ee5b035f737),
        (0, $298fb931ed4fbf8b$export$38bcb760f1d4871c)(function(rule) {
            currentSheet.insert(rule);
        })
    ];
    var serializer = (0, $298fb931ed4fbf8b$export$5a7767152ae0305f)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
    var stylis = function stylis(styles) {
        return (0, $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb)((0, $298fb931ed4fbf8b$export$ef7acd7185315e22)(styles), serializer);
    };
    _insert = function insert(selector, serialized, sheet, shouldCache) {
        currentSheet = sheet;
        stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
        if (shouldCache) cache.inserted[serialized.name] = true;
    };
    var cache = {
        key: key,
        sheet: new (0, $e18645ac1956fbe6$export$9d753cd7ae895cce)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};


/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $3629985b3ecf741f$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}


var $936be3b045ab836e$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};



var $90ba2da1f62e5f1b$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $90ba2da1f62e5f1b$var$UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var $90ba2da1f62e5f1b$var$hyphenateRegex = /[A-Z]|^ms/g;
var $90ba2da1f62e5f1b$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $90ba2da1f62e5f1b$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $90ba2da1f62e5f1b$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== "boolean";
};
var $90ba2da1f62e5f1b$var$processStyleName = /* #__PURE__ */ (0, $6bb1e54ce1bc6efa$export$2e2bcd8739ae039)(function(styleName) {
    return $90ba2da1f62e5f1b$var$isCustomProperty(styleName) ? styleName : styleName.replace($90ba2da1f62e5f1b$var$hyphenateRegex, "-$&").toLowerCase();
});
var $90ba2da1f62e5f1b$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case "animation":
        case "animationName":
            if (typeof value === "string") return value.replace($90ba2da1f62e5f1b$var$animationRegex, function(match, p1, p2) {
                $90ba2da1f62e5f1b$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $90ba2da1f62e5f1b$var$cursor
                };
                return p1;
            });
    }
    if ((0, $936be3b045ab836e$export$2e2bcd8739ae039)[key] !== 1 && !$90ba2da1f62e5f1b$var$isCustomProperty(key) && typeof value === "number" && value !== 0) return value + "px";
    return value;
};
var $90ba2da1f62e5f1b$var$contentValuePattern, $90ba2da1f62e5f1b$var$contentValues, $90ba2da1f62e5f1b$var$oldProcessStyleValue, $90ba2da1f62e5f1b$var$msPattern, $90ba2da1f62e5f1b$var$hyphenPattern, $90ba2da1f62e5f1b$var$hyphenatedCache;
var $90ba2da1f62e5f1b$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $90ba2da1f62e5f1b$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return "";
    if (interpolation.__emotion_styles !== undefined) return interpolation;
    switch(typeof interpolation){
        case "boolean":
            return "";
        case "object":
            if (interpolation.anim === 1) {
                $90ba2da1f62e5f1b$var$cursor = {
                    name: interpolation.name,
                    styles: interpolation.styles,
                    next: $90ba2da1f62e5f1b$var$cursor
                };
                return interpolation.name;
            }
            if (interpolation.styles !== undefined) {
                var next = interpolation.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $90ba2da1f62e5f1b$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $90ba2da1f62e5f1b$var$cursor
                    };
                    next = next.next;
                }
                var styles = interpolation.styles + ";";
                return styles;
            }
            return $90ba2da1f62e5f1b$var$createStringFromObject(mergedProps, registered, interpolation);
        case "function":
            if (mergedProps !== undefined) {
                var previousCursor = $90ba2da1f62e5f1b$var$cursor;
                var result = interpolation(mergedProps);
                $90ba2da1f62e5f1b$var$cursor = previousCursor;
                return $90ba2da1f62e5f1b$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
        case "string":
            var matched, replaced;
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    if (registered == null) return interpolation;
    var cached = registered[interpolation];
    return cached !== undefined ? cached : interpolation;
}
function $90ba2da1f62e5f1b$var$createStringFromObject(mergedProps, registered, obj) {
    var string = "";
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $90ba2da1f62e5f1b$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var _key in obj){
        var value = obj[_key];
        if (typeof value !== "object") {
            if (registered != null && registered[value] !== undefined) string += _key + "{" + registered[value] + "}";
            else if ($90ba2da1f62e5f1b$var$isProcessableValue(value)) string += $90ba2da1f62e5f1b$var$processStyleName(_key) + ":" + $90ba2da1f62e5f1b$var$processStyleValue(_key, value) + ";";
        } else if (Array.isArray(value) && typeof value[0] === "string" && (registered == null || registered[value[0]] === undefined)) {
            for(var _i = 0; _i < value.length; _i++)if ($90ba2da1f62e5f1b$var$isProcessableValue(value[_i])) string += $90ba2da1f62e5f1b$var$processStyleName(_key) + ":" + $90ba2da1f62e5f1b$var$processStyleValue(_key, value[_i]) + ";";
        } else {
            var interpolated = $90ba2da1f62e5f1b$var$handleInterpolation(mergedProps, registered, value);
            switch(_key){
                case "animation":
                case "animationName":
                    string += $90ba2da1f62e5f1b$var$processStyleName(_key) + ":" + interpolated + ";";
                    break;
                default:
                    string += _key + "{" + interpolated + "}";
            }
        }
    }
    return string;
}
var $90ba2da1f62e5f1b$var$labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var $90ba2da1f62e5f1b$var$sourceMapPattern;
// keyframes are stored on the SerializedStyles object as a linked list
var $90ba2da1f62e5f1b$var$cursor;
var $90ba2da1f62e5f1b$export$6321afa313b251b5 = function serializeStyles(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === "object" && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = "";
    $90ba2da1f62e5f1b$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $90ba2da1f62e5f1b$var$handleInterpolation(mergedProps, registered, strings);
    } else styles += strings[0];
     // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $90ba2da1f62e5f1b$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) styles += strings[i];
    }
    var sourceMap;
    $90ba2da1f62e5f1b$var$labelPattern.lastIndex = 0;
    var identifierName = "";
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $90ba2da1f62e5f1b$var$labelPattern.exec(styles)) !== null)identifierName += "-" + // $FlowFixMe we know it's not null
    match[1];
    var name = (0, $3629985b3ecf741f$export$2e2bcd8739ae039)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $90ba2da1f62e5f1b$var$cursor
    };
};


var $1f6791d0a193b918$var$isBrowser = true;
function $1f6791d0a193b918$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = "";
    classNames.split(" ").forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else rawClassName += className + " ";
    });
    return rawClassName;
}
var $1f6791d0a193b918$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $1f6791d0a193b918$var$isBrowser === false) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $1f6791d0a193b918$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $1f6791d0a193b918$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var current = serialized;
        do {
            cache.insert(serialized === current ? "." + className : "", current, cache.sheet, true);
            current = current.next;
        }while (current !== undefined);
    }
};


function $f80ae5e019588f18$var$insertWithoutScoping(cache, serialized) {
    if (cache.inserted[serialized.name] === undefined) return cache.insert("", serialized, cache.sheet, true);
}
function $f80ae5e019588f18$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $1f6791d0a193b918$export$95d99596f328fd52)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $f80ae5e019588f18$export$2e2bcd8739ae039 = function createEmotion(options) {
    var cache = (0, $fc182b1f84212d3f$export$2e2bcd8739ae039)(options); // $FlowFixMe
    cache.sheet.speedy = function(value) {
        this.isSpeedy = value;
    };
    cache.compat = true;
    var css = function css() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $90ba2da1f62e5f1b$export$6321afa313b251b5)(args, cache.registered, undefined);
        (0, $1f6791d0a193b918$export$6f077d94b33a01aa)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var keyframes = function keyframes() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        var serialized = (0, $90ba2da1f62e5f1b$export$6321afa313b251b5)(args, cache.registered);
        var animation = "animation-" + serialized.name;
        $f80ae5e019588f18$var$insertWithoutScoping(cache, {
            name: serialized.name,
            styles: "@keyframes " + animation + "{" + serialized.styles + "}"
        });
        return animation;
    };
    var injectGlobal = function injectGlobal() {
        for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
        var serialized = (0, $90ba2da1f62e5f1b$export$6321afa313b251b5)(args, cache.registered);
        $f80ae5e019588f18$var$insertWithoutScoping(cache, serialized);
    };
    var cx = function cx() {
        for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
        return $f80ae5e019588f18$var$merge(cache.registered, css, $f80ae5e019588f18$var$classnames(args));
    };
    return {
        css: css,
        cx: cx,
        injectGlobal: injectGlobal,
        keyframes: keyframes,
        hydrate: function hydrate(ids) {
            ids.forEach(function(key) {
                cache.inserted[key] = true;
            });
        },
        flush: function flush() {
            cache.registered = {};
            cache.inserted = {};
            cache.sheet.flush();
        },
        // $FlowFixMe
        sheet: cache.sheet,
        cache: cache,
        getRegisteredStyles: (0, $1f6791d0a193b918$export$95d99596f328fd52).bind(null, cache.registered),
        merge: $f80ae5e019588f18$var$merge.bind(null, cache.registered, css)
    };
};
var $f80ae5e019588f18$var$classnames = function classnames(args) {
    var cls = "";
    for(var i = 0; i < args.length; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case "boolean":
                break;
            case "object":
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = "";
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += " ");
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += " ");
            cls += toAdd;
        }
    }
    return cls;
};





var $d4be60b58ad177a9$var$_createEmotion = (0, $f80ae5e019588f18$export$2e2bcd8739ae039)({
    key: "css"
}), $d4be60b58ad177a9$export$4909b86c8034bf73 = $d4be60b58ad177a9$var$_createEmotion.flush, $d4be60b58ad177a9$export$fa8d919ba61d84db = $d4be60b58ad177a9$var$_createEmotion.hydrate, $d4be60b58ad177a9$export$a274e22fb40f762e = $d4be60b58ad177a9$var$_createEmotion.cx, $d4be60b58ad177a9$export$4950aa0f605343fb = $d4be60b58ad177a9$var$_createEmotion.merge, $d4be60b58ad177a9$export$95d99596f328fd52 = $d4be60b58ad177a9$var$_createEmotion.getRegisteredStyles, $d4be60b58ad177a9$export$efb9f5caaa2ca0c7 = $d4be60b58ad177a9$var$_createEmotion.injectGlobal, $d4be60b58ad177a9$export$d25ddfdf17c3ad3e = $d4be60b58ad177a9$var$_createEmotion.keyframes, $d4be60b58ad177a9$export$dbf350e5966cf602 = $d4be60b58ad177a9$var$_createEmotion.css, $d4be60b58ad177a9$export$995990c5c04c46f0 = $d4be60b58ad177a9$var$_createEmotion.sheet, $d4be60b58ad177a9$export$69a3209f1a06c04d = $d4be60b58ad177a9$var$_createEmotion.cache;















function $34ceff2494805166$export$ea41ff3bf81eb809(node, refMap) {
    return Array.from(refMap.entries()).find(([, lineRef])=>lineRef.getElement()?.contains?.(node));
}
function $34ceff2494805166$export$792eb3d0bcf0c866(refMap) {
    if (!document.activeElement) return undefined;
    return $34ceff2494805166$export$ea41ff3bf81eb809(document.activeElement, refMap);
}
function $34ceff2494805166$var$findRelativeTo(lines, id, relativeIndex) {
    if (lines.length === 0) return null;
    const index = lines.findIndex((line)=>line.id === id);
    if (index < 0) return null;
    const newIndex = (0, $512ec8d668819b2f$export$d17171af8942fb21)(0, lines.length, index + relativeIndex);
    return lines[newIndex];
}
function $34ceff2494805166$export$9f3faf95cce2c200(ref, target) {
    switch(target){
        case "line":
            ref.focus();
            return;
        case "var":
            ref.focusVar();
            return;
        case "inner":
            ref.focusInner();
            return;
    }
}
/** Focus `ref` and keep the same FocusTarget as before or fall back to `fallbackTarget` */ function $34ceff2494805166$var$focusLineRefSameOr(refMap, ref, fallbackTarget) {
    const focus = $34ceff2494805166$export$792eb3d0bcf0c866(refMap);
    if (focus) {
        const [id, currentRef] = focus;
        const currentTarget = currentRef.isFocused() ? "line" : "inner";
        $34ceff2494805166$export$9f3faf95cce2c200(ref, currentTarget);
    } else $34ceff2494805166$export$9f3faf95cce2c200(ref, fallbackTarget);
}
function $34ceff2494805166$export$92a1a3b7554e9387(dispatch, container, refMap, innerBlock, selectedIds, setSelectionAnchorIds) {
    function insertBeforeCode(state, id, env, innerBlock, focusTarget = "line") {
        const newId = $f042fdc9cbbc2b08$export$fba3009e3ea7651a(state);
        const currentWidth = state.lines.find((line)=>line.id === id)?.width ?? "narrow";
        return {
            state: $f042fdc9cbbc2b08$export$cc49eae3401c619b(state, id, {
                id: newId,
                name: "",
                visibility: $020dad93e2d78da8$export$285aa6cd6e6400b7[0],
                width: currentWidth,
                state: innerBlock.init
            }, dispatch, env, innerBlock),
            effect () {
                $34ceff2494805166$export$9f3faf95cce2c200(refMap.get(newId), focusTarget);
            }
        };
    }
    function insertAfterCode(state, id, env, innerBlock, focusTarget = "line") {
        const newId = $f042fdc9cbbc2b08$export$fba3009e3ea7651a(state);
        const currentWidth = state.lines.find((line)=>line.id === id)?.width ?? "narrow";
        return {
            state: $f042fdc9cbbc2b08$export$81db1fdca5a72c2(state, id, {
                id: newId,
                name: "",
                visibility: $020dad93e2d78da8$export$285aa6cd6e6400b7[0],
                width: currentWidth,
                state: innerBlock.init
            }, dispatch, env, innerBlock),
            effect () {
                $34ceff2494805166$export$9f3faf95cce2c200(refMap.get(newId), focusTarget);
            }
        };
    }
    function insertEnd(state, env, innerBlock, focusTarget = "line") {
        const newId = $f042fdc9cbbc2b08$export$fba3009e3ea7651a(state);
        return {
            state: $f042fdc9cbbc2b08$export$5d2c014dfbff2767(state, {
                id: newId,
                name: "",
                visibility: $020dad93e2d78da8$export$285aa6cd6e6400b7[0],
                width: $020dad93e2d78da8$export$89ac0e24f357645c[0],
                state: innerBlock.init
            }, dispatch, env, innerBlock),
            effect () {
                $34ceff2494805166$export$9f3faf95cce2c200(refMap.get(newId), focusTarget);
            }
        };
    }
    return {
        scroll (amount) {
            const scrollableContainer = (0, $777d0014849a8f55$export$1c9360146059a2c0)(container.current);
            if (scrollableContainer) scrollableContainer.scrollBy({
                top: amount * scrollableContainer.clientHeight,
                behavior: "smooth"
            });
        },
        focusUp () {
            setSelectionAnchorIds(null);
            dispatch((state)=>({
                    state: state,
                    effect () {
                        const focused = $34ceff2494805166$export$792eb3d0bcf0c866(refMap);
                        if (focused === undefined) refMap.get(state.lines[0].id)?.focus();
                        else {
                            const [id, lineRef] = focused;
                            const focusTarget = lineRef.isFocused() ? "line" : "inner";
                            const prevId = $34ceff2494805166$var$findRelativeTo(state.lines, id, -1)?.id;
                            const prevLine = refMap.get(prevId);
                            prevLine && $34ceff2494805166$export$9f3faf95cce2c200(prevLine, focusTarget);
                        }
                    }
                }));
        },
        focusDown () {
            setSelectionAnchorIds(null);
            dispatch((state)=>({
                    state: state,
                    effect () {
                        const focused = $34ceff2494805166$export$792eb3d0bcf0c866(refMap);
                        if (focused === undefined) refMap.get(state.lines[state.lines.length - 1].id)?.focus();
                        else {
                            const [id, lineRef] = focused;
                            const focusTarget = lineRef.isFocused() ? "line" : "inner";
                            const nextId = $34ceff2494805166$var$findRelativeTo(state.lines, id, 1)?.id;
                            const nextLine = refMap.get(nextId);
                            nextLine && $34ceff2494805166$export$9f3faf95cce2c200(nextLine, focusTarget);
                        }
                    }
                }));
        },
        selectUp () {
            dispatch((state)=>({
                    state: state,
                    effect () {
                        const focused = $34ceff2494805166$export$792eb3d0bcf0c866(refMap);
                        if (focused === undefined) refMap.get(state.lines[0].id)?.focus();
                        else {
                            const [id, lineRef] = focused;
                            const focusTarget = lineRef.isFocused() ? "line" : "inner";
                            const prevId = $34ceff2494805166$var$findRelativeTo(state.lines, id, -1)?.id;
                            const prevLine = refMap.get(prevId);
                            setSelectionAnchorIds((selection)=>({
                                    start: selection?.start ?? id,
                                    end: prevId
                                }));
                            prevLine && $34ceff2494805166$export$9f3faf95cce2c200(prevLine, focusTarget);
                        }
                    }
                }));
        },
        selectDown () {
            dispatch((state)=>({
                    state: state,
                    effect () {
                        const focused = $34ceff2494805166$export$792eb3d0bcf0c866(refMap);
                        if (focused === undefined) refMap.get(state.lines[state.lines.length - 1].id)?.focus();
                        else {
                            const [id, lineRef] = focused;
                            const focusTarget = lineRef.isFocused() ? "line" : "inner";
                            const nextId = $34ceff2494805166$var$findRelativeTo(state.lines, id, 1)?.id;
                            const nextLine = refMap.get(nextId);
                            setSelectionAnchorIds((selection)=>({
                                    start: selection?.start ?? id,
                                    end: nextId
                                }));
                            nextLine && $34ceff2494805166$export$9f3faf95cce2c200(nextLine, focusTarget);
                        }
                    }
                }));
        },
        focusFirst () {
            setSelectionAnchorIds(null);
            dispatch((state)=>({
                    state: state,
                    effect () {
                        const firstId = state.lines[0].id;
                        refMap.get(firstId)?.focus();
                    }
                }));
        },
        focusLast () {
            setSelectionAnchorIds(null);
            dispatch((state)=>({
                    state: state,
                    effect () {
                        const lastId = state.lines.slice(-1)[0].id;
                        refMap.get(lastId)?.focus();
                    }
                }));
        },
        rename (id) {
            setSelectionAnchorIds(null);
            refMap.get(id)?.focusVar();
        },
        setName (id, name) {
            dispatch((state, { env: env })=>({
                    state: $f042fdc9cbbc2b08$export$661afaf0a7b1481e(state, id, (line)=>({
                            ...line,
                            name: name
                        }), dispatch, env, innerBlock)
                }));
        },
        switchCollapse (id) {
            dispatch((state)=>({
                    state: $f042fdc9cbbc2b08$export$d540f50abaed3adb(state, id, (line)=>({
                            ...line,
                            visibility: $f042fdc9cbbc2b08$export$2433b834a71dd0c8(line.visibility)
                        })),
                    effect () {
                        const line = refMap.get(id);
                        if (line && !line.getElement().contains(document.activeElement)) line.focus();
                    }
                }));
        },
        switchWidth (id) {
            dispatch((state)=>({
                    state: $f042fdc9cbbc2b08$export$d540f50abaed3adb(state, id, (line)=>({
                            ...line,
                            width: $f042fdc9cbbc2b08$export$51e5fcbbd6d5bf18(line.width)
                        }))
                }));
        },
        dispatchInner (id, action, innerBlock) {
            dispatch((state, context)=>(0, $6f23581c0aef6dc2$export$b6ca37fc03181c21)(action, (pureAction)=>$f042fdc9cbbc2b08$export$2a21b7cae538793e(state, id, pureAction, innerBlock, context.env, dispatch)));
        },
        copy (state, innerBlock, putIntoClipboard) {
            let selectedLines;
            if (selectedIds) selectedLines = selectedIds.map((id)=>state.lines.find((line)=>line.id === id));
            else {
                const focusedId = $34ceff2494805166$export$792eb3d0bcf0c866(refMap)?.[0];
                const focusedLine = focusedId !== undefined && state.lines.find((line)=>line.id === focusedId);
                if (focusedLine) selectedLines = [
                    focusedLine
                ];
            }
            if (selectedLines) putIntoClipboard("application/x.resheet-block", JSON.stringify($020dad93e2d78da8$export$54fd2c36b5cc6731({
                lines: selectedLines
            }, innerBlock)), selectedLines);
        },
        paste (json, innerBlock) {
            const dispatchLines = (0, $d0f575b1326e7f91$export$f153e5abd026c378)("lines", dispatch);
            dispatch((state, { env: env })=>{
                if (state.lines.length === 0) {
                    const newState = $020dad93e2d78da8$export$8815aa1d021a7d50(json)(dispatch, env, innerBlock);
                    return {
                        state: newState,
                        effect () {
                            const firstPastedId = newState.lines[0]?.id;
                            const lastPastedId = newState.lines.slice(-1)[0]?.id;
                            if (firstPastedId !== undefined && lastPastedId !== undefined) setSelectionAnchorIds({
                                start: firstPastedId,
                                end: lastPastedId
                            });
                            const lastPastedRef = refMap.get(lastPastedId);
                            lastPastedRef && $34ceff2494805166$var$focusLineRefSameOr(refMap, lastPastedRef, "line");
                        }
                    };
                }
                const lineId = (selectedIds && selectedIds.slice(-1)[0]) ?? $34ceff2494805166$export$792eb3d0bcf0c866(refMap)?.[0] ?? state.lines.slice(-1)[0]?.id;
                try {
                    const siblingsUntilId = $9d52f07a71ba7cea$export$3024f7e3be75347b($9d52f07a71ba7cea$export$8ff6683eaf414994(state.lines, lineId), innerBlock);
                    const envForPasted = {
                        ...env,
                        ...siblingsUntilId
                    };
                    const { lines: lines } = $020dad93e2d78da8$export$8815aa1d021a7d50(json)(()=>{}, envForPasted, innerBlock);
                    const nextId = $f042fdc9cbbc2b08$export$fba3009e3ea7651a(state);
                    const remappedLines = lines.map((line, index)=>({
                            ...line,
                            id: nextId + index
                        }));
                    const newState = {
                        ...state,
                        lines: $9d52f07a71ba7cea$export$bb6ff48d725fca5e($9d52f07a71ba7cea$export$41ee562435ce1bbf(state.lines, lineId, ...remappedLines), lineId, env, null, innerBlock, dispatchLines, 1).state
                    };
                    return {
                        state: newState,
                        effect () {
                            const firstPastedId = remappedLines[0]?.id;
                            const lastPastedId = remappedLines.slice(-1)[0]?.id;
                            if (firstPastedId !== undefined && lastPastedId !== undefined) setSelectionAnchorIds({
                                start: firstPastedId,
                                end: lastPastedId
                            });
                            const lastPastedRef = refMap.get(lastPastedId);
                            lastPastedRef && $34ceff2494805166$var$focusLineRefSameOr(refMap, lastPastedRef, "line");
                        }
                    };
                } catch (e) {
                    return {
                        state: state
                    };
                }
            });
        },
        insertBeforeCode (id, innerBlock, focusTarget = "line") {
            setSelectionAnchorIds(null);
            dispatch((state, { env: env })=>insertBeforeCode(state, id, env, innerBlock, focusTarget));
        },
        insertAfterCode (id, innerBlock, focusTarget = "line") {
            setSelectionAnchorIds(null);
            dispatch((state, { env: env })=>insertAfterCode(state, id, env, innerBlock, focusTarget));
        },
        insertEnd (innerBlock, focusTarget = "inner") {
            setSelectionAnchorIds(null);
            dispatch((state, { env: env })=>insertEnd(state, env, innerBlock, focusTarget));
        },
        focusOrCreatePrev (id, innerBlock) {
            setSelectionAnchorIds(null);
            dispatch((state, { env: env })=>{
                const currentIndex = state.lines.findIndex((line)=>line.id === id);
                if (currentIndex < 0) return {
                    state: state
                };
                if (currentIndex === 0) return insertBeforeCode(state, id, env, innerBlock, "inner");
                const prevLine = state.lines[currentIndex - 1];
                return {
                    state: state,
                    effect () {
                        refMap.get(prevLine.id)?.focusInner();
                    }
                };
            });
        },
        focusOrCreateNext (id, innerBlock) {
            setSelectionAnchorIds(null);
            dispatch((state, { env: env })=>{
                const currentIndex = state.lines.findIndex((line)=>line.id === id);
                if (currentIndex < 0) return {
                    state: state
                };
                if (currentIndex === state.lines.length - 1) return insertAfterCode(state, id, env, innerBlock, "inner");
                const nextLine = state.lines[currentIndex + 1];
                return {
                    state: state,
                    effect () {
                        refMap.get(nextLine.id)?.focusInner();
                    }
                };
            });
        },
        deleteCode (id, focusAfter = "line") {
            setSelectionAnchorIds(null);
            dispatch((state, { env: env })=>{
                const idsToDelete = selectedIds ?? [
                    id
                ];
                const [prevId, newState] = $f042fdc9cbbc2b08$export$ce256c4f2953eb9f(state, idsToDelete, dispatch, env, innerBlock);
                return {
                    state: newState,
                    effect () {
                        if (refMap.has(prevId)) $34ceff2494805166$export$9f3faf95cce2c200(refMap.get(prevId), focusAfter);
                        else container.current.focus();
                    }
                };
            });
        }
    };
}



var $acw62 = parcelRequire("acw62");


function $b5dfa942f3e5eb7f$export$a97c3cc4bf1da1ca(refMap) {
    const [selectionAnchorIds, setSelectionAnchorIds] = $acw62.useState(null);
    // Focus Handlers
    const onBlur = $acw62.useCallback(function onBlur(ev) {
        const isNewFocusOneOfMyLines = Array.from(refMap.values()).some((lineRef)=>lineRef.getElement() === ev.relatedTarget);
        if (!isNewFocusOneOfMyLines) setSelectionAnchorIds(null);
    }, [
        refMap,
        setSelectionAnchorIds
    ]);
    const onFocus = $acw62.useCallback(function onFocus(ev) {
        if (!(ev.target instanceof Node)) return;
        setSelectionAnchorIds((selection)=>{
            if (!selection) return selection;
            const target = (0, $34ceff2494805166$export$ea41ff3bf81eb809)(ev.target, refMap);
            if (!target) return null;
            const [targetId, targetLine] = target;
            if (targetLine.getVarInput().contains(ev.target)) return null;
            if (targetLine.getInnerContainer().contains(ev.target)) return null;
            return {
                ...selection,
                end: targetId
            };
        });
    }, [
        refMap,
        setSelectionAnchorIds
    ]);
    // Mouse Handlers
    // From which line.id did the mouse start dragging
    const mouseStartId = $acw62.useRef(null);
    const onMouseDown = $acw62.useCallback(function onMouseDown(ev) {
        if (!(ev.target instanceof Node)) return;
        if (ev.shiftKey) {
            // Update selection and move focus
            const currentFocusId = (0, $34ceff2494805166$export$792eb3d0bcf0c866)(refMap)?.[0];
            if (currentFocusId === undefined) return;
            const target = (0, $34ceff2494805166$export$ea41ff3bf81eb809)(ev.target, refMap);
            if (!target) return;
            const [targetFocusId, targetLine] = target;
            // Don't capture shift-click selection inside a line
            if (currentFocusId === targetFocusId && targetLine.getInnerContainer().contains(ev.target)) return;
            (0, $777d0014849a8f55$export$67289be57e41ecc)(targetLine.getElement(), {
                preventScroll: true
            });
            setSelectionAnchorIds((selection)=>({
                    start: selection?.start ?? currentFocusId,
                    end: targetFocusId
                }));
            ev.stopPropagation();
            ev.preventDefault();
        } else {
            // Reset selection and remember where the user started (probably
            // continues to drag and creates a selection)
            setSelectionAnchorIds(null);
            const target = (0, $34ceff2494805166$export$ea41ff3bf81eb809)(ev.target, refMap);
            if (target) {
                const [targetId, targetLine] = target;
                mouseStartId.current = targetId;
                // If the user didn't target the variable name input or the
                // inner block:
                // Prevent default action, which start selecting the text
                // contents, but still move the focus to the element.
                if (!targetLine.getInnerContainer().contains(ev.target) && !targetLine.getVarInput().contains(ev.target)) {
                    (0, $777d0014849a8f55$export$67289be57e41ecc)(targetLine.getElement(), {
                        preventScroll: true
                    });
                    ev.stopPropagation();
                    ev.preventDefault();
                }
            }
        }
    }, [
        refMap,
        mouseStartId,
        setSelectionAnchorIds
    ]);
    const onMouseMove = $acw62.useCallback(function onMouseMove(ev) {
        if (!(ev.buttons & 1)) return;
        if (!(ev.target instanceof Node)) return;
        const target = (0, $34ceff2494805166$export$ea41ff3bf81eb809)(ev.target, refMap);
        if (!target) return;
        const [targetId, targetLine] = target;
        if (document.getSelection().rangeCount > 0) {
            const range = document.getSelection().getRangeAt(0);
            const selectedLine = (0, $34ceff2494805166$export$ea41ff3bf81eb809)(range.startContainer, refMap)?.[1];
            if (selectedLine?.getVarInput().contains(range.startContainer)) return;
            if (selectedLine?.getInnerContainer().contains(range.startContainer)) return;
        }
        setSelectionAnchorIds((selection)=>{
            // Start selecting (selection === null) only when we:
            // - started in some line (mouseStartId.current !== null)
            // - and moved to another line (mouseStartId.current !== targetId)
            if (!selection && (mouseStartId.current === null || mouseStartId.current === targetId)) return null;
            // Queue action with setTimeout, so it doesn't trigger another React
            // update (because of .focus() -> FocusEvent Handlers) during this
            // update
            setTimeout(()=>(0, $777d0014849a8f55$export$67289be57e41ecc)(targetLine.getElement(), {
                    preventScroll: true
                }));
            const startId = mouseStartId.current;
            mouseStartId.current = null;
            return {
                start: selection?.start ?? startId,
                end: targetId
            };
        });
    }, [
        refMap,
        mouseStartId,
        setSelectionAnchorIds
    ]);
    return {
        selectionAnchorIds: selectionAnchorIds,
        setSelectionAnchorIds: setSelectionAnchorIds,
        selectionEventHandlers: {
            onBlur: onBlur,
            onFocus: onFocus,
            onMouseDown: onMouseDown,
            onMouseMove: onMouseMove
        }
    };
}


const $fa1f46f99eeebb37$export$a9bf29f8d87ebbee = /*#__PURE__*/ $acw62.forwardRef(function Sheet({ state: state, dispatch: dispatch, innerBlock: innerBlock, env: env }, ref) {
    const [setLineRef, refMap] = (0, $ff99259e85546794$export$a4bd4d7d17a12a52)();
    const lastFocus = $acw62.useRef(null);
    const containerRef = $acw62.useRef();
    const dispatchFX = (0, $ff99259e85546794$export$a902f8b72ad3dfd8)(dispatch);
    $acw62.useImperativeHandle(ref, ()=>({
            focus () {
                const lastIndex = lastFocus.current ?? 0;
                if (state.lines[lastIndex]) refMap.get(state.lines[lastIndex].id)?.focus?.();
                else containerRef.current?.focus?.();
            }
        }), [
        state
    ]);
    const { selectionAnchorIds: selectionAnchorIds, setSelectionAnchorIds: setSelectionAnchorIds, selectionEventHandlers: selectionEventHandlers } = (0, $b5dfa942f3e5eb7f$export$a97c3cc4bf1da1ca)(refMap);
    const lineIds = state.lines.map(({ id: id })=>id);
    const selectionAnchorIndices = selectionAnchorIds && [
        lineIds.indexOf(selectionAnchorIds.start),
        lineIds.indexOf(selectionAnchorIds.end)
    ].sort((a, b)=>a - b);
    const selectedIds = selectionAnchorIds && lineIds.slice(selectionAnchorIndices[0], selectionAnchorIndices[1] + 1);
    const actions = $acw62.useMemo(()=>(0, $34ceff2494805166$export$92a1a3b7554e9387)(dispatchFX, containerRef, refMap, innerBlock, selectedIds, setSelectionAnchorIds), [
        dispatchFX,
        containerRef,
        refMap,
        innerBlock,
        selectedIds,
        setSelectionAnchorIds
    ]);
    const shortcutProps = (0, $5bc960417406f657$export$a1ca853c6e4bb6fb)([
        {
            description: "sheet",
            bindings: [
                [
                    [
                        "Enter"
                    ],
                    "selfFocused",
                    "add line",
                    ()=>actions.insertEnd(innerBlock)
                ]
            ]
        }
    ]);
    function onBlur(ev) {
        const id = Array.from(refMap.entries()).find(([_id, lineRef])=>lineRef.getElement() === ev.target)?.[0];
        const index = state.lines.findIndex((line)=>line.id === id);
        if (index >= 0) lastFocus.current = index;
        else lastFocus.current = null;
        selectionEventHandlers.onBlur(ev);
        shortcutProps.onBlur(ev);
    }
    function onFocus(ev) {
        selectionEventHandlers.onFocus(ev);
        shortcutProps.onFocus(ev);
    }
    function onPaste(ev) {
        if (ev.clipboardData.types.includes("application/x.resheet-block")) {
            const json = JSON.parse(ev.clipboardData.getData("application/x.resheet-block"));
            actions.paste(json, innerBlock);
            ev.stopPropagation();
            ev.preventDefault();
        }
    }
    function onCopy(ev) {
        const selection = document.getSelection();
        const isTextSelected = selection.rangeCount > 0 && !selection.getRangeAt(0).collapsed;
        if (isTextSelected) return;
        actions.copy(state, innerBlock, (type, content, copiedLines)=>{
            ev.clipboardData.setData(type, content);
            dispatch((state)=>({
                    state: state,
                    description: `Copied ${copiedLines.length} line(s) to the clipboard`
                }));
            ev.stopPropagation();
            ev.preventDefault();
        });
    }
    function onCut(ev) {
        const selection = document.getSelection();
        const isTextSelected = selection.rangeCount > 0 && !selection.getRangeAt(0).collapsed;
        if (isTextSelected) return;
        actions.copy(state, innerBlock, (type, content)=>{
            ev.clipboardData.setData(type, content);
            actions.deleteCode((0, $34ceff2494805166$export$792eb3d0bcf0c866)(refMap)?.[0]);
            ev.stopPropagation();
            ev.preventDefault();
        });
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        ref: containerRef,
        tabIndex: -1,
        className: "group/sheet focus:border-b-2 focus:border-blue-300 outline-none",
        style: {
            containerType: "inline-size"
        },
        ...shortcutProps,
        onBlur: onBlur,
        onFocus: onFocus,
        onMouseDown: selectionEventHandlers.onMouseDown,
        onMouseMove: selectionEventHandlers.onMouseMove,
        onCopy: onCopy,
        onPaste: onPaste,
        onCut: onCut,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($fa1f46f99eeebb37$export$4b39a5d0d2833195, {
                setLineRef: setLineRef,
                lines: state.lines,
                actions: actions,
                block: innerBlock,
                env: env,
                selection: selectionAnchorIndices
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "relative print:hidden",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        className: `
                            peer z-10
                            absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2
                            px-1 rounded-full bg-gray-100 border-2 border-gray-100
                            text-gray-400 ${state.lines.length > 0 ? "text-xs" : "text-sm w-6 h-6"}
                            ${state.lines.length > 0 && "group-focus-within/sheet:opacity-50 hover:group-focus-within/sheet:opacity-100"}
                            transition-[opacity_color] hover:text-blue-600 hover:bg-blue-50 hover:border-blue-500/50
                        `,
                        onClick: ()=>actions.insertEnd(innerBlock),
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e4ec753f5c716375$export$2b9260d4a45c8710), {
                            icon: $d8206b3ab2e65c05$export$a105e7b44ca0eb9e
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "absolute top-0 left-0 right-0 border-t-2 border-blue-500 opacity-0 peer-hover:opacity-50 transition-[opacity]"
                    })
                ]
            })
        ]
    });
});
const $fa1f46f99eeebb37$export$4b39a5d0d2833195 = /*#__PURE__*/ $acw62.memo(function SheetLinesEnv({ lines: lines, ...props }) {
    if (lines.length === 0) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($fa1f46f99eeebb37$var$SheetLinesEnvHelper, {
        index: 0,
        lines: lines,
        siblingsEnv: $6f23581c0aef6dc2$export$ae0bd03227ec549f,
        aboveViewport: true,
        ...props
    });
});
function $fa1f46f99eeebb37$var$SheetLinesEnvHelperComponent({ setLineRef: setLineRef, index: index, lines: lines, actions: actions, block: block, siblingsEnv: siblingsEnv, env: env, selection: selection, aboveViewport: aboveViewport }) {
    const isSelected = selection && selection[0] <= index && index <= selection[1];
    const line = lines[index];
    const next = index + 1;
    const localSiblingsEnv = $acw62.useMemo(()=>({
            ...siblingsEnv,
            ...$f042fdc9cbbc2b08$export$526a230723648f1d(line, block)
        }), [
        siblingsEnv,
        line,
        block
    ]);
    const localEnv = $acw62.useMemo(()=>({
            ...env,
            ...siblingsEnv,
            $before: siblingsEnv
        }), [
        siblingsEnv,
        env
    ]);
    const [inViewRef, isInView] = (0, $9ac152c824b2d089$export$2f62ee6831462844)({
        initialInView: true,
        root: document.body,
        rootMargin: "20px"
    });
    const isBelowViewport = !aboveViewport && !isInView;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($fa1f46f99eeebb37$export$b25f334b2bd41010, {
                setLineRef: setLineRef,
                inViewRef: inViewRef,
                line: line,
                actions: actions,
                block: block,
                isSelected: isSelected,
                env: localEnv,
                skipRender: !isInView
            }, line.id),
            next < lines.length && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($fa1f46f99eeebb37$var$SheetLinesEnvHelper, {
                setLineRef: setLineRef,
                index: next,
                lines: lines,
                actions: actions,
                block: block,
                siblingsEnv: localSiblingsEnv,
                env: env,
                selection: selection,
                aboveViewport: aboveViewport && !isInView,
                skipRender: isBelowViewport
            })
        ]
    });
}
const $fa1f46f99eeebb37$var$SheetLinesEnvHelper = (0, $ff99259e85546794$export$3dcb0090454f7b27)($fa1f46f99eeebb37$var$SheetLinesEnvHelperComponent, "never");
const $fa1f46f99eeebb37$var$hiddenNameClass = (0, $d4be60b58ad177a9$export$dbf350e5966cf602)`
    opacity: 0;

    .group\\/sheet-line:focus-within > * > & {
        opacity: 1;
    }
    
    .group\\/sheet-line:hover > * > & {
        opacity: 1;
    }
`;
function $fa1f46f99eeebb37$var$SheetLineComponent({ block: block, line: line, env: env, actions: actions, isSelected: isSelected, setLineRef: setLineRef, inViewRef: inViewRef }) {
    const containerRef = $acw62.useRef();
    const varInputRef = $acw62.useRef();
    const innerContainerRef = $acw62.useRef();
    const innerBlockRef = $acw62.useRef();
    const resultRef = $acw62.useRef();
    const lineRef = $acw62.useMemo(()=>setLineRef(line.id), [
        setLineRef,
        line.id
    ]);
    $acw62.useImperativeHandle(inViewRef, ()=>containerRef.current, [
        containerRef
    ]);
    $acw62.useImperativeHandle(lineRef, ()=>({
            getElement () {
                return containerRef.current;
            },
            getInnerContainer () {
                return innerContainerRef.current;
            },
            getVarInput () {
                return varInputRef.current?.parentElement // get the container
                ;
            },
            isFocused () {
                return !!containerRef.current && document.activeElement === containerRef.current;
            },
            focus () {
                if (!containerRef.current) return;
                containerRef.current.scrollIntoView({
                    block: "nearest",
                    behavior: "auto"
                });
                (0, $777d0014849a8f55$export$67289be57e41ecc)(containerRef.current, {
                    preventScroll: true
                });
            },
            focusVar () {
                varInputRef.current?.focus();
            },
            focusInner () {
                innerBlockRef.current?.focus();
                // Workaround: Focus whole line if inner can't be focused
                // Problem: How to find out if inner didn't accept focus?
                //          Immediately checking misses cases, when inner first
                //          has to update, render and then sets focus. So even
                //          one setTimeout didn't suffice. Effects may not yet
                //          have run after an update and render. Therefore we
                //          queue setTimeout a second time before checking for
                //          focus.
                setTimeout(()=>{
                    setTimeout(()=>{
                        if (containerRef.current && !containerRef.current.contains(document.activeElement)) containerRef.current.focus();
                    });
                });
            }
        }));
    const bindings = $acw62.useMemo(()=>$fa1f46f99eeebb37$var$sheetLineBindings(actions, line, block, containerRef, innerBlockRef, resultRef), [
        actions,
        line,
        block,
        containerRef,
        innerBlockRef,
        resultRef,
        varInputRef
    ]);
    const bindingsProps = (0, $5bc960417406f657$export$a1ca853c6e4bb6fb)(bindings);
    const subdispatch = $acw62.useCallback(function subdispatch(action) {
        actions.dispatchInner(line.id, action, block);
    }, [
        block
    ]);
    function onDoubleClick(event) {
        if (event.target instanceof Element && (0, $777d0014849a8f55$export$b3053c7afe37670c)(event.target)) return;
        actions.switchCollapse(line.id);
        event.stopPropagation();
        event.preventDefault();
    }
    const varInputBindings = $acw62.useMemo(()=>$fa1f46f99eeebb37$var$assignmentLineBindings(line, innerBlockRef, actions), [
        line,
        innerBlockRef,
        actions
    ]);
    const shouldNameBeHidden = line.name === "";
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($fa1f46f99eeebb37$var$SheetLineLayout, {
        ref: containerRef,
        tabIndex: -1,
        ...bindingsProps,
        onDoubleClick: onDoubleClick,
        line: line,
        isSelected: isSelected,
        assignmentLine: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($fa1f46f99eeebb37$export$d207f57737a72ea3, {
            ref: varInputRef,
            line: line,
            actions: actions,
            bindings: varInputBindings,
            style: {
                display: undefined,
                breakAfter: "avoid-page"
            },
            className: shouldNameBeHidden && `print:hidden ${$fa1f46f99eeebb37$var$hiddenNameClass}`
        }, "name"),
        lineContentRef: innerContainerRef,
        lineContent: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                line.visibility === "block" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(block.Component, {
                    ref: innerBlockRef,
                    state: line.state,
                    dispatch: subdispatch,
                    env: env
                }, "block"),
                line.visibility === "result" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b749c8e203b309f1$export$93660df4be02febf), {
                    ref: resultRef,
                    value: $f042fdc9cbbc2b08$export$f1a959c0cb168d75(line, block),
                    expandLevel: 0
                }, "result")
            ]
        })
    });
}
const $fa1f46f99eeebb37$export$b25f334b2bd41010 = (0, $ff99259e85546794$export$3dcb0090454f7b27)($fa1f46f99eeebb37$var$SheetLineComponent);
const $fa1f46f99eeebb37$var$fullStyle = `
    grid-template:
        "indicator name"    auto
        "indicator content" auto
        / auto 1fr
    ;
    column-gap: 0.5rem;
`;
const $fa1f46f99eeebb37$var$narrowClass = (0, $d4be60b58ad177a9$export$dbf350e5966cf602)`
    grid-template:
        "name indicator content" auto
        / 1fr auto minmax(auto, 768px) 1fr
    ;
    column-gap: 0.5rem;

    @container (width < 768px) {
        ${$fa1f46f99eeebb37$var$fullStyle}
    }
`;
const $fa1f46f99eeebb37$var$wideClass = (0, $d4be60b58ad177a9$export$dbf350e5966cf602)`
    grid-template:
        "name indicator content" auto
        / 1fr auto minmax(auto, 1280px) 1fr
    ;
    column-gap: 0.5rem;

    @container (width < 768px) {
        ${$fa1f46f99eeebb37$var$fullStyle}
    }
`;
const $fa1f46f99eeebb37$var$fullClass = (0, $d4be60b58ad177a9$export$dbf350e5966cf602)`
    ${$fa1f46f99eeebb37$var$fullStyle}
`;
const $fa1f46f99eeebb37$var$nonFullNameClass = (0, $d4be60b58ad177a9$export$dbf350e5966cf602)`
    justify-content: end;

    @container (width < 768px) {
        justify-content: start;
    }
`;
const $fa1f46f99eeebb37$var$emptyNameClass = (0, $d4be60b58ad177a9$export$dbf350e5966cf602)`
    @container (width < 768px) {
        &:not(:focus-within) {
            height: 0;
            opacity: 0;
            overflow-y: hidden;
        }
    }
`;
const $fa1f46f99eeebb37$var$tailwindColors = {
    "gray-300": "rgb(209 213 219)",
    "blue-300": "rgb(147 197 253)",
    "blue-500": "rgb(59 130 246)",
    "yellow-300": "rgb(253 224 71)",
    "yellow-400": "rgb(250 204 21)",
    "yellow-500": "rgb(234 179 8)"
};
function $fa1f46f99eeebb37$var$indicatorCSS(colors) {
    return `
        border-width: 1px;
        border-color: ${$fa1f46f99eeebb37$var$tailwindColors[colors.hover]};
        opacity: 0;
        align-self: stretch;

        .group\\/sheet-line:focus > & {
            border-color: ${$fa1f46f99eeebb37$var$tailwindColors[colors.focus]};
            opacity: 1;
        }

        .group\\/sheet-line:not(:focus):focus-within > & {
            border-color: ${$fa1f46f99eeebb37$var$tailwindColors[colors.focusWithin]};
            opacity: 1;
        }

        .group\\/sheet-line:hover > & {
            opacity: 1;
        }
    `;
}
const $fa1f46f99eeebb37$var$indicatorClass = {
    block: (0, $d4be60b58ad177a9$export$dbf350e5966cf602)`${$fa1f46f99eeebb37$var$indicatorCSS({
        hover: "gray-300",
        focus: "blue-500",
        focusWithin: "blue-300"
    })}`,
    // yellow-400 is very similar to its neighbors, but this should happen
    // seldom and there should be another indication (by the result), that
    // focus is within
    result: (0, $d4be60b58ad177a9$export$dbf350e5966cf602)`${$fa1f46f99eeebb37$var$indicatorCSS({
        hover: "yellow-300",
        focus: "yellow-500",
        focusWithin: "yellow-400"
    })}`
};
const $fa1f46f99eeebb37$var$SheetLineLayout = /*#__PURE__*/ $acw62.forwardRef(function SheetLineLayout({ line: line, assignmentLine: assignmentLine, lineContent: lineContent, lineContentRef: lineContentRef, isSelected: isSelected, ...containerProps }, ref) {
    const focusIndicatorClass = $fa1f46f99eeebb37$var$indicatorClass[line.visibility];
    const [gridClass, nameClasses] = line.width === "narrow" ? [
        $fa1f46f99eeebb37$var$narrowClass,
        $fa1f46f99eeebb37$var$nonFullNameClass
    ] : line.width === "wide" ? [
        $fa1f46f99eeebb37$var$wideClass,
        $fa1f46f99eeebb37$var$nonFullNameClass
    ] : line.width === "full" ? [
        $fa1f46f99eeebb37$var$fullClass,
        "justify-start"
    ] : "";
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        ref: ref,
        className: `
                grid items-baseline
                py-1
                outline-none
                ${isSelected && "bg-blue-100"}
                group/sheet-line
                ${gridClass}
            `,
        ...containerProps,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    gridArea: "name"
                },
                className: `min-w-32 flex flex-row ${nameClasses} ${line.name === "" && $fa1f46f99eeebb37$var$emptyNameClass}`,
                children: assignmentLine
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    gridArea: "indicator"
                },
                className: `${focusIndicatorClass} print:hidden`
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                ref: lineContentRef,
                style: {
                    gridArea: "content"
                },
                className: "overflow-x-auto",
                children: lineContent
            })
        ]
    });
});
function $fa1f46f99eeebb37$var$sheetLineBindings(actions, line, block, containerRef, innerBlockRef, resultRef) {
    function insertBelowByEnter(event) {
        if (event && !event.defaultPrevented) return;
        actions.insertAfterCode(line.id, block, "inner");
        event?.preventDefault();
        event?.stopPropagation();
    }
    function deleteByBackspace(event) {
        if (event && !event.defaultPrevented) return;
        actions.deleteCode(line.id, "inner");
        event?.stopPropagation();
    }
    function moveUp(event) {
        if (event && event.target !== event.currentTarget && !event.defaultPrevented) return;
        actions.focusUp();
        event?.stopPropagation();
        event?.preventDefault();
    }
    function moveDown(event) {
        if (event && event.target !== event.currentTarget && !event.defaultPrevented) return;
        actions.focusDown();
        event?.stopPropagation();
        event?.preventDefault();
    }
    function selectUp(event) {
        if (event && event.target !== event.currentTarget && !event.defaultPrevented) return;
        actions.selectUp();
        event?.stopPropagation();
        event?.preventDefault();
    }
    function selectDown(event) {
        if (event && event.target !== event.currentTarget && !event.defaultPrevented) return;
        actions.selectDown();
        event?.stopPropagation();
        event?.preventDefault();
    }
    return [
        {
            description: "change lines",
            bindings: [
                [
                    [
                        "C-Enter",
                        "KeyO"
                    ],
                    "selfFocused",
                    "insert below",
                    ()=>actions.insertAfterCode(line.id, block, "inner")
                ],
                [
                    [
                        "C-Shift-Enter",
                        "Shift-KeyO"
                    ],
                    "selfFocused",
                    "insert above",
                    ()=>actions.insertBeforeCode(line.id, block, "inner")
                ],
                [
                    [
                        "C-Shift-KeyR"
                    ],
                    "none",
                    "rename",
                    ()=>actions.rename(line.id)
                ],
                [
                    [
                        "C-Backspace",
                        "Backspace"
                    ],
                    "selfFocused",
                    "delete line",
                    ()=>actions.deleteCode(line.id)
                ],
                [
                    [
                        "C-Backspace",
                        "Backspace"
                    ],
                    "hidden",
                    "delete line",
                    deleteByBackspace,
                    {
                        noAutoPrevent: true
                    }
                ],
                [
                    [
                        "Enter"
                    ],
                    "!selfFocused",
                    "insert below",
                    insertBelowByEnter,
                    {
                        noAutoPrevent: true
                    }
                ]
            ]
        },
        {
            description: "line view",
            bindings: [
                [
                    [
                        "KeyZ"
                    ],
                    "selfFocused",
                    "scroll into view",
                    ()=>containerRef.current?.scrollIntoView({
                            block: "center",
                            behavior: "smooth"
                        })
                ],
                [
                    [
                        "C-KeyM"
                    ],
                    "none",
                    "cycle visibility",
                    ()=>actions.switchCollapse(line.id)
                ],
                [
                    [
                        "C-Equal"
                    ],
                    "none",
                    "cycle width",
                    ()=>actions.switchWidth(line.id)
                ],
                [
                    [
                        "Escape"
                    ],
                    "!selfFocused",
                    "focus sheet line",
                    ()=>containerRef.current && (0, $777d0014849a8f55$export$67289be57e41ecc)(containerRef.current, {
                            preventScroll: true
                        })
                ],
                [
                    [
                        "Enter"
                    ],
                    "selfFocused",
                    "focus inner",
                    ()=>{
                        if (line.visibility === "block") innerBlockRef.current?.focus({
                            preventScroll: true
                        });
                        else if (line.visibility === "result") resultRef.current?.focus({
                            preventScroll: true
                        });
                    }
                ]
            ]
        },
        {
            description: "move between lines",
            bindings: [
                [
                    [
                        "ArrowUp",
                        "KeyK"
                    ],
                    "none",
                    "move up",
                    moveUp,
                    {
                        noAutoPrevent: true
                    }
                ],
                [
                    [
                        "ArrowDown",
                        "KeyJ"
                    ],
                    "none",
                    "move down",
                    moveDown,
                    {
                        noAutoPrevent: true
                    }
                ],
                [
                    [
                        "Shift-ArrowUp",
                        "Shift-KeyK"
                    ],
                    "none",
                    "select up",
                    selectUp,
                    {
                        noAutoPrevent: true
                    }
                ],
                [
                    [
                        "Shift-ArrowDown",
                        "Shift-KeyJ"
                    ],
                    "none",
                    "select down",
                    selectDown,
                    {
                        noAutoPrevent: true
                    }
                ],
                [
                    [
                        "C-Enter"
                    ],
                    "!selfFocused",
                    "jump next",
                    ()=>actions.insertAfterCode(line.id, block, "inner")
                ],
                [
                    [
                        "C-Shift-Enter"
                    ],
                    "!selfFocused",
                    "jump prev",
                    ()=>actions.insertBeforeCode(line.id, block, "inner")
                ],
                [
                    [
                        "KeyG"
                    ],
                    "!inputFocused",
                    "jump top",
                    ()=>actions.focusFirst()
                ],
                [
                    [
                        "Shift-KeyG"
                    ],
                    "!inputFocused",
                    "jump bottom",
                    ()=>actions.focusLast()
                ]
            ]
        },
        {
            description: "scroll sheet",
            bindings: [
                [
                    [
                        "C-Alt-ArrowUp",
                        "C-Alt-KeyK"
                    ],
                    "none",
                    "scroll UP",
                    ()=>actions.scroll(-0.5)
                ],
                [
                    [
                        "C-Alt-ArrowDown",
                        "C-Alt-KeyJ"
                    ],
                    "none",
                    "scroll DOWN",
                    ()=>actions.scroll(0.5)
                ],
                [
                    [
                        "C-Shift-Alt-ArrowUp",
                        "C-Shift-Alt-KeyK"
                    ],
                    "none",
                    "scroll up",
                    ()=>actions.scroll(-0.1)
                ],
                [
                    [
                        "C-Shift-Alt-ArrowDown",
                        "C-Shift-Alt-KeyJ"
                    ],
                    "none",
                    "scroll down",
                    ()=>actions.scroll(0.1)
                ]
            ]
        }
    ];
}
function $fa1f46f99eeebb37$var$assignmentLineBindings(line, innerBlockRef, actions) {
    return [
        {
            description: "line name",
            bindings: [
                [
                    [
                        "ArrowDown",
                        "Enter"
                    ],
                    "none",
                    "jump next",
                    ()=>{
                        if (line.visibility === "block") innerBlockRef.current?.focus({
                            preventScroll: true
                        });
                        else actions.focusDown();
                    }
                ]
            ]
        }
    ];
}
const $fa1f46f99eeebb37$export$d207f57737a72ea3 = /*#__PURE__*/ $acw62.forwardRef(function AssignmentLine(props, ref) {
    const { line: line, actions: actions, bindings: bindings, className: className, ...inputProps } = props;
    const bindingsProps = (0, $5bc960417406f657$export$a1ca853c6e4bb6fb)(bindings);
    function onUpdateName(name) {
        actions.setName(line.id, name);
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $777d0014849a8f55$export$c86715117507e8e5), {
        ref: ref,
        className: `
                    inline-block
                    text-slate-500 font-light text-xs truncate
                    hover:bg-gray-200 hover:text-slate-700
                    focus-within:bg-gray-200 focus-within:text-slate-700
                    outline-none
                    rounded -ml-0.5
                    ${className}
                `,
        value: line.name,
        onUpdate: onUpdateName,
        placeholder: $f042fdc9cbbc2b08$export$d55ead31e9b19ee3(line),
        ...inputProps,
        ...bindingsProps
    });
});




function $2874ceca92f8bd68$export$8edc1c3b6e3ca47c(innerBlock) {
    const safeInnerBlock = (0, $b8f588c17e3c1433$export$e255fd3f9a510304)(innerBlock);
    return $6f23581c0aef6dc2$export$185802fd694ee1f5({
        init: $f042fdc9cbbc2b08$export$2cd8252107eb640b,
        view ({ state: state, dispatch: dispatch, env: env }, ref) {
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($fa1f46f99eeebb37$export$a9bf29f8d87ebbee, {
                ref: ref,
                state: state,
                dispatch: dispatch,
                innerBlock: safeInnerBlock,
                env: env
            });
        },
        recompute (state, dispatch, env, changedVars) {
            return $f042fdc9cbbc2b08$export$1f297d8d0ce29e3(state, dispatch, env, changedVars, safeInnerBlock);
        },
        getResult (state) {
            return $f042fdc9cbbc2b08$export$ec795fdf61e2a255(state, safeInnerBlock);
        },
        fromJSON (json, dispatch, env) {
            return $020dad93e2d78da8$export$8815aa1d021a7d50(json)(dispatch, env, safeInnerBlock);
        },
        toJSON (state) {
            return $020dad93e2d78da8$export$54fd2c36b5cc6731(state, safeInnerBlock);
        }
    });
}



var $6d146131cf95401b$exports = {};

$parcel$export($6d146131cf95401b$exports, "JSExpr", () => $6d146131cf95401b$export$4e4e7267e6bca3a9);
$parcel$export($6d146131cf95401b$exports, "JSExprUi", () => $6d146131cf95401b$export$34758abbf03d546b);
$parcel$export($6d146131cf95401b$exports, "JSExprDoc", () => $6d146131cf95401b$export$ec7bfc99e712ff5d);
$parcel$export($6d146131cf95401b$exports, "allOverrides", () => $6d146131cf95401b$export$cb525752c37d2db8);
$parcel$export($6d146131cf95401b$exports, "gatherDocs", () => $6d146131cf95401b$export$3849b92fb7e12a24);
$parcel$export($6d146131cf95401b$exports, "Example", () => $6d146131cf95401b$export$2b8f26b427c15f);
$parcel$export($6d146131cf95401b$exports, "Example1", () => $6d146131cf95401b$export$75e78dcafdd92f43);
$parcel$export($6d146131cf95401b$exports, "Example2", () => $6d146131cf95401b$export$1ffb29a24a9c22e2);
$parcel$export($6d146131cf95401b$exports, "Example3", () => $6d146131cf95401b$export$cc0c1dbd0ff7eb48);
$parcel$export($6d146131cf95401b$exports, "Example4", () => $6d146131cf95401b$export$bc03dad28128351d);


var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");
function $185ac4d2d2286c00$var$n() {
    return $185ac4d2d2286c00$var$n = Object.assign ? Object.assign.bind() : function(e) {
        for(var n = 1; n < arguments.length; n++){
            var r = arguments[n];
            for(var t in r)Object.prototype.hasOwnProperty.call(r, t) && (e[t] = r[t]);
        }
        return e;
    }, $185ac4d2d2286c00$var$n.apply(this, arguments);
}
var $185ac4d2d2286c00$export$e0aa44767d8750d5, $185ac4d2d2286c00$var$t, $185ac4d2d2286c00$var$i = [
    "children",
    "options"
];
!function(e) {
    e.blockQuote = "0", e.breakLine = "1", e.breakThematic = "2", e.codeBlock = "3", e.codeFenced = "4", e.codeInline = "5", e.footnote = "6", e.footnoteReference = "7", e.gfmTask = "8", e.heading = "9", e.headingSetext = "10", e.htmlBlock = "11", e.htmlComment = "12", e.htmlSelfClosing = "13", e.image = "14", e.link = "15", e.linkAngleBraceStyleDetector = "16", e.linkBareUrlDetector = "17", e.linkMailtoDetector = "18", e.newlineCoalescer = "19", e.orderedList = "20", e.paragraph = "21", e.ref = "22", e.refImage = "23", e.refLink = "24", e.table = "25", e.tableSeparator = "26", e.text = "27", e.textBolded = "28", e.textEmphasized = "29", e.textEscaped = "30", e.textMarked = "31", e.textStrikethroughed = "32", e.unorderedList = "33";
}($185ac4d2d2286c00$export$e0aa44767d8750d5 || ($185ac4d2d2286c00$export$e0aa44767d8750d5 = {})), function(e) {
    e[e.MAX = 0] = "MAX", e[e.HIGH = 1] = "HIGH", e[e.MED = 2] = "MED", e[e.LOW = 3] = "LOW", e[e.MIN = 4] = "MIN";
}($185ac4d2d2286c00$var$t || ($185ac4d2d2286c00$var$t = {}));
var $185ac4d2d2286c00$var$a = [
    "allowFullScreen",
    "allowTransparency",
    "autoComplete",
    "autoFocus",
    "autoPlay",
    "cellPadding",
    "cellSpacing",
    "charSet",
    "className",
    "classId",
    "colSpan",
    "contentEditable",
    "contextMenu",
    "crossOrigin",
    "encType",
    "formAction",
    "formEncType",
    "formMethod",
    "formNoValidate",
    "formTarget",
    "frameBorder",
    "hrefLang",
    "inputMode",
    "keyParams",
    "keyType",
    "marginHeight",
    "marginWidth",
    "maxLength",
    "mediaGroup",
    "minLength",
    "noValidate",
    "radioGroup",
    "readOnly",
    "rowSpan",
    "spellCheck",
    "srcDoc",
    "srcLang",
    "srcSet",
    "tabIndex",
    "useMap"
].reduce(function(e, n) {
    return e[n.toLowerCase()] = n, e;
}, {
    for: "htmlFor"
}), $185ac4d2d2286c00$var$o = {
    amp: "&",
    apos: "'",
    gt: ">",
    lt: "<",
    nbsp: "\xa0",
    quot: "\u201C"
}, $185ac4d2d2286c00$var$c = [
    "style",
    "script"
], $185ac4d2d2286c00$var$l = /([-A-Z0-9_:]+)(?:\s*=\s*(?:(?:"((?:\\.|[^"])*)")|(?:'((?:\\.|[^'])*)')|(?:\{((?:\\.|{[^}]*?}|[^}])*)\})))?/gi, $185ac4d2d2286c00$var$u = /mailto:/i, $185ac4d2d2286c00$var$s = /\n{2,}$/, $185ac4d2d2286c00$var$f = /^(\s*>[\s\S]*?)(?=\n{2,})/, $185ac4d2d2286c00$var$d = /^ *> ?/gm, $185ac4d2d2286c00$var$p = /^ {2,}\n/, $185ac4d2d2286c00$var$h = /^(?:( *[-*_])){3,} *(?:\n *)+\n/, $185ac4d2d2286c00$var$m = /^\s*(`{3,}|~{3,}) *(\S+)?([^\n]*?)?\n([\s\S]+?)\s*\1 *(?:\n *)*\n?/, $185ac4d2d2286c00$var$g = /^(?: {4}[^\n]+\n*)+(?:\n *)+\n?/, $185ac4d2d2286c00$var$y = /^(`+)\s*([\s\S]*?[^`])\s*\1(?!`)/, $185ac4d2d2286c00$var$v = /^(?:\n *)*\n/, $185ac4d2d2286c00$var$k = /\r\n?/g, $185ac4d2d2286c00$var$x = /^\[\^([^\]]+)](:(.*)((\n+ {4,}.*)|(\n(?!\[\^).+))*)/, $185ac4d2d2286c00$var$b = /^\[\^([^\]]+)]/, $185ac4d2d2286c00$var$w = /\f/g, $185ac4d2d2286c00$var$E = /^---[ \t]*\n(.|\n)*\n---[ \t]*\n/, $185ac4d2d2286c00$var$S = /^\s*?\[(x|\s)\]/, $185ac4d2d2286c00$var$C = /^ *(#{1,6}) *([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/, $185ac4d2d2286c00$var$$ = /^ *(#{1,6}) +([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/, $185ac4d2d2286c00$var$A = /^([^\n]+)\n *(=|-){3,} *(?:\n *)+\n/, $185ac4d2d2286c00$var$O = /^ *(?!<[a-z][^ >/]* ?\/>)<([a-z][^ >/]*) ?([^>]*)>\n?(\s*(?:<\1[^>]*?>[\s\S]*?<\/\1>|(?!<\1\b)[\s\S])*?)<\/\1>(?!<\/\1>)\n*/i, $185ac4d2d2286c00$var$T = /&([a-z0-9]+|#[0-9]{1,6}|#x[0-9a-fA-F]{1,6});/gi, $185ac4d2d2286c00$var$L = /^<!--[\s\S]*?(?:-->)/, $185ac4d2d2286c00$var$R = /^(data|aria|x)-[a-z_][a-z\d_.-]*$/, $185ac4d2d2286c00$var$z = /^ *<([a-z][a-z0-9:]*)(?:\s+((?:<.*?>|[^>])*))?\/?>(?!<\/\1>)(\s*\n)?/i, $185ac4d2d2286c00$var$M = /^\{.*\}$/, $185ac4d2d2286c00$var$I = /^(https?:\/\/[^\s<]+[^<.,:;"')\]\s])/, $185ac4d2d2286c00$var$U = /^<([^ >]+@[^ >]+)>/, $185ac4d2d2286c00$var$j = /^<([^ >]+:\/[^ >]+)>/, $185ac4d2d2286c00$var$B = /-([a-z])?/gi, $185ac4d2d2286c00$var$N = /^(.*\|?.*)\n *(\|? *[-:]+ *\|[-| :]*)\n((?:.*\|.*\n)*)\n?/, $185ac4d2d2286c00$var$H = /^\[([^\]]*)\]:\s+<?([^\s>]+)>?\s*("([^"]*)")?/, $185ac4d2d2286c00$var$D = /^!\[([^\]]*)\] ?\[([^\]]*)\]/, $185ac4d2d2286c00$var$P = /^\[([^\]]*)\] ?\[([^\]]*)\]/, $185ac4d2d2286c00$var$_ = /(\[|\])/g, $185ac4d2d2286c00$var$F = /(\n|^[-*]\s|^#|^ {2,}|^-{2,}|^>\s)/, $185ac4d2d2286c00$var$W = /\t/g, $185ac4d2d2286c00$var$G = /^ *\| */, $185ac4d2d2286c00$var$Z = /(^ *\||\| *$)/g, $185ac4d2d2286c00$var$q = / *$/, $185ac4d2d2286c00$var$V = /^ *:-+: *$/, $185ac4d2d2286c00$var$X = /^ *:-+ *$/, $185ac4d2d2286c00$var$Q = /^ *-+: *$/, $185ac4d2d2286c00$var$J = "((?:\\[.*?\\][([].*?[)\\]]|<.*?>(?:.*?<.*?>)?|`.*?`|~~.*?~~|==.*?==|.|\\n)*?)", $185ac4d2d2286c00$var$K = new RegExp("^([*_])\\1" + $185ac4d2d2286c00$var$J + "\\1\\1(?!\\1)"), $185ac4d2d2286c00$var$Y = new RegExp("^([*_])" + $185ac4d2d2286c00$var$J + "\\1(?!\\1|\\w)"), $185ac4d2d2286c00$var$ee = new RegExp("^==" + $185ac4d2d2286c00$var$J + "=="), $185ac4d2d2286c00$var$ne = new RegExp("^~~" + $185ac4d2d2286c00$var$J + "~~"), $185ac4d2d2286c00$var$re = /^\\([^0-9A-Za-z\s])/, $185ac4d2d2286c00$var$te = /^[\s\S]+?(?=[^0-9A-Z\s\u00c0-\uffff&#;.()'"]|\d+\.|\n\n| {2,}\n|\w+:\S|$)/i, $185ac4d2d2286c00$var$ie = /^\n+/, $185ac4d2d2286c00$var$ae = /^([ \t]*)/, $185ac4d2d2286c00$var$oe = /\\([^\\])/g, $185ac4d2d2286c00$var$ce = / *\n+$/, $185ac4d2d2286c00$var$le = /(?:^|\n)( *)$/, $185ac4d2d2286c00$var$ue = "(?:\\d+\\.)", $185ac4d2d2286c00$var$se = "(?:[*+-])";
function $185ac4d2d2286c00$var$fe(e) {
    return "( *)(" + (1 === e ? $185ac4d2d2286c00$var$ue : $185ac4d2d2286c00$var$se) + ") +";
}
var $185ac4d2d2286c00$var$de = $185ac4d2d2286c00$var$fe(1), $185ac4d2d2286c00$var$pe = $185ac4d2d2286c00$var$fe(2);
function $185ac4d2d2286c00$var$he(e) {
    return new RegExp("^" + (1 === e ? $185ac4d2d2286c00$var$de : $185ac4d2d2286c00$var$pe));
}
var $185ac4d2d2286c00$var$me = $185ac4d2d2286c00$var$he(1), $185ac4d2d2286c00$var$ge = $185ac4d2d2286c00$var$he(2);
function $185ac4d2d2286c00$var$ye(e) {
    return new RegExp("^" + (1 === e ? $185ac4d2d2286c00$var$de : $185ac4d2d2286c00$var$pe) + "[^\\n]*(?:\\n(?!\\1" + (1 === e ? $185ac4d2d2286c00$var$ue : $185ac4d2d2286c00$var$se) + " )[^\\n]*)*(\\n|$)", "gm");
}
var $185ac4d2d2286c00$var$ve = $185ac4d2d2286c00$var$ye(1), $185ac4d2d2286c00$var$ke = $185ac4d2d2286c00$var$ye(2);
function $185ac4d2d2286c00$var$xe(e) {
    var n = 1 === e ? $185ac4d2d2286c00$var$ue : $185ac4d2d2286c00$var$se;
    return new RegExp("^( *)(" + n + ") [\\s\\S]+?(?:\\n{2,}(?! )(?!\\1" + n + " (?!" + n + " ))\\n*|\\s*\\n*$)");
}
var $185ac4d2d2286c00$var$be = $185ac4d2d2286c00$var$xe(1), $185ac4d2d2286c00$var$we = $185ac4d2d2286c00$var$xe(2);
function $185ac4d2d2286c00$var$Ee(e, n) {
    var r = 1 === n, t = r ? $185ac4d2d2286c00$var$be : $185ac4d2d2286c00$var$we, i = r ? $185ac4d2d2286c00$var$ve : $185ac4d2d2286c00$var$ke, a = r ? $185ac4d2d2286c00$var$me : $185ac4d2d2286c00$var$ge;
    return {
        match: function(e, n, r) {
            var i = $185ac4d2d2286c00$var$le.exec(r);
            return i && (n.list || !n.inline && !n.simple) ? t.exec(e = i[1] + e) : null;
        },
        order: 1,
        parse: function(e, n, t) {
            var o = r ? +e[2] : void 0, c = e[0].replace($185ac4d2d2286c00$var$s, "\n").match(i), l = !1;
            return {
                items: c.map(function(e, r) {
                    var i = a.exec(e)[0].length, o = new RegExp("^ {1," + i + "}", "gm"), u = e.replace(o, "").replace(a, ""), s = r === c.length - 1, f = -1 !== u.indexOf("\n\n") || s && l;
                    l = f;
                    var d, p = t.inline, h = t.list;
                    t.list = !0, f ? (t.inline = !1, d = u.replace($185ac4d2d2286c00$var$ce, "\n\n")) : (t.inline = !0, d = u.replace($185ac4d2d2286c00$var$ce, ""));
                    var m = n(d, t);
                    return t.inline = p, t.list = h, m;
                }),
                ordered: r,
                start: o
            };
        },
        render: function(n, r, t) {
            return e(n.ordered ? "ol" : "ul", {
                key: t.key,
                start: "20" === n.type ? n.start : void 0
            }, n.items.map(function(n, i) {
                return e("li", {
                    key: i
                }, r(n, t));
            }));
        }
    };
}
var $185ac4d2d2286c00$var$Se = new RegExp("^\\[((?:\\[[^\\]]*\\]|[^\\[\\]]|\\](?=[^\\[]*\\]))*)\\]\\(\\s*<?((?:\\([^)]*\\)|[^\\s\\\\]|\\\\.)*?)>?(?:\\s+['\"]([\\s\\S]*?)['\"])?\\s*\\)"), $185ac4d2d2286c00$var$Ce = /^!\[(.*?)\]\( *((?:\([^)]*\)|[^() ])*) *"?([^)"]*)?"?\)/, $185ac4d2d2286c00$var$$e = [
    $185ac4d2d2286c00$var$f,
    $185ac4d2d2286c00$var$m,
    $185ac4d2d2286c00$var$g,
    $185ac4d2d2286c00$var$C,
    $185ac4d2d2286c00$var$A,
    $185ac4d2d2286c00$var$$,
    $185ac4d2d2286c00$var$L,
    $185ac4d2d2286c00$var$N,
    $185ac4d2d2286c00$var$ve,
    $185ac4d2d2286c00$var$be,
    $185ac4d2d2286c00$var$ke,
    $185ac4d2d2286c00$var$we
], $185ac4d2d2286c00$var$Ae = [].concat($185ac4d2d2286c00$var$$e, [
    /^[^\n]+(?:  \n|\n{2,})/,
    $185ac4d2d2286c00$var$O,
    $185ac4d2d2286c00$var$z
]);
function $185ac4d2d2286c00$var$Oe(e) {
    return e.replace(/[ÀÁÂÃÄÅàáâãäåæÆ]/g, "a").replace(/[çÇ]/g, "c").replace(/[ðÐ]/g, "d").replace(/[ÈÉÊËéèêë]/g, "e").replace(/[ÏïÎîÍíÌì]/g, "i").replace(/[Ññ]/g, "n").replace(/[øØœŒÕõÔôÓóÒò]/g, "o").replace(/[ÜüÛûÚúÙù]/g, "u").replace(/[ŸÿÝý]/g, "y").replace(/[^a-z0-9- ]/gi, "").replace(/ /gi, "-").toLowerCase();
}
function $185ac4d2d2286c00$var$Te(e) {
    return $185ac4d2d2286c00$var$Q.test(e) ? "right" : $185ac4d2d2286c00$var$V.test(e) ? "center" : $185ac4d2d2286c00$var$X.test(e) ? "left" : null;
}
function $185ac4d2d2286c00$var$Le(e, n, r) {
    var t = r.inTable;
    r.inTable = !0;
    var i = n(e.trim(), r);
    r.inTable = t;
    var a = [
        []
    ];
    return i.forEach(function(e, n) {
        "26" === e.type ? 0 !== n && n !== i.length - 1 && a.push([]) : ("27" !== e.type || null != i[n + 1] && "26" !== i[n + 1].type || (e.text = e.text.replace($185ac4d2d2286c00$var$q, "")), a[a.length - 1].push(e));
    }), a;
}
function $185ac4d2d2286c00$var$Re(e, n, r) {
    r.inline = !0;
    var t = $185ac4d2d2286c00$var$Le(e[1], n, r), i = e[2].replace($185ac4d2d2286c00$var$Z, "").split("|").map($185ac4d2d2286c00$var$Te), a = function(e, n, r) {
        return e.trim().split("\n").map(function(e) {
            return $185ac4d2d2286c00$var$Le(e, n, r);
        });
    }(e[3], n, r);
    return r.inline = !1, {
        align: i,
        cells: a,
        header: t,
        type: "25"
    };
}
function $185ac4d2d2286c00$var$ze(e, n) {
    return null == e.align[n] ? {} : {
        textAlign: e.align[n]
    };
}
function $185ac4d2d2286c00$var$Me(e) {
    return function(n, r) {
        return r.inline ? e.exec(n) : null;
    };
}
function $185ac4d2d2286c00$var$Ie(e) {
    return function(n, r) {
        return r.inline || r.simple ? e.exec(n) : null;
    };
}
function $185ac4d2d2286c00$var$Ue(e) {
    return function(n, r) {
        return r.inline || r.simple ? null : e.exec(n);
    };
}
function $185ac4d2d2286c00$var$je(e) {
    return function(n) {
        return e.exec(n);
    };
}
function $185ac4d2d2286c00$var$Be(e, n, r) {
    if (n.inline || n.simple) return null;
    if (r && !r.endsWith("\n")) return null;
    var t = "";
    e.split("\n").every(function(e) {
        return !$185ac4d2d2286c00$var$$e.some(function(n) {
            return n.test(e);
        }) && (t += e + "\n", e.trim());
    });
    var i = t.trimEnd();
    return "" == i ? null : [
        t,
        i
    ];
}
function $185ac4d2d2286c00$var$Ne(e) {
    try {
        if (decodeURIComponent(e).replace(/[^A-Za-z0-9/:]/g, "").match(/^\s*(javascript|vbscript|data(?!:image)):/i)) return;
    } catch (e) {
        return null;
    }
    return e;
}
function $185ac4d2d2286c00$var$He(e) {
    return e.replace($185ac4d2d2286c00$var$oe, "$1");
}
function $185ac4d2d2286c00$var$De(e, n, r) {
    var t = r.inline || !1, i = r.simple || !1;
    r.inline = !0, r.simple = !0;
    var a = e(n, r);
    return r.inline = t, r.simple = i, a;
}
function $185ac4d2d2286c00$var$Pe(e, n, r) {
    var t = r.inline || !1, i = r.simple || !1;
    r.inline = !1, r.simple = !0;
    var a = e(n, r);
    return r.inline = t, r.simple = i, a;
}
function $185ac4d2d2286c00$var$_e(e, n, r) {
    return r.inline = !1, e(n, r);
}
var $185ac4d2d2286c00$var$Fe = function(e, n, r) {
    return {
        children: $185ac4d2d2286c00$var$De(n, e[1], r)
    };
};
function $185ac4d2d2286c00$var$We() {
    return {};
}
function $185ac4d2d2286c00$var$Ge() {
    return null;
}
function $185ac4d2d2286c00$var$Ze() {
    return [].slice.call(arguments).filter(Boolean).join(" ");
}
function $185ac4d2d2286c00$var$qe(e, n, r) {
    for(var t = e, i = n.split("."); i.length && void 0 !== (t = t[i[0]]);)i.shift();
    return t || r;
}
function $185ac4d2d2286c00$var$Ve(e, n) {
    var r = $185ac4d2d2286c00$var$qe(n, e);
    return r ? "function" == typeof r || "object" == typeof r && "render" in r ? r : $185ac4d2d2286c00$var$qe(n, e + ".component", e) : e;
}
function $185ac4d2d2286c00$export$69f434acfbdb0b32(r, t) {
    var i;
    void 0 === r && (r = ""), void 0 === t && (t = {}), t.overrides = t.overrides || {}, t.slugify = t.slugify || $185ac4d2d2286c00$var$Oe, t.namedCodesToUnicode = t.namedCodesToUnicode ? $185ac4d2d2286c00$var$n({}, $185ac4d2d2286c00$var$o, t.namedCodesToUnicode) : $185ac4d2d2286c00$var$o;
    var s = t.createElement || $acw62.createElement;
    function Z(e, r) {
        var i = $185ac4d2d2286c00$var$qe(t.overrides, e + ".props", {});
        return s.apply(void 0, [
            $185ac4d2d2286c00$var$Ve(e, t.overrides),
            $185ac4d2d2286c00$var$n({}, r, i, {
                className: $185ac4d2d2286c00$var$Ze(null == r ? void 0 : r.className, i.className) || void 0
            })
        ].concat([].slice.call(arguments, 2)));
    }
    function q(n) {
        n = n.replace($185ac4d2d2286c00$var$E, "");
        var r = !1;
        t.forceInline ? r = !0 : t.forceBlock || (r = !1 === $185ac4d2d2286c00$var$F.test(n));
        for(var i = le(ce(r ? n : n.trimEnd().replace($185ac4d2d2286c00$var$ie, "") + "\n\n", {
            inline: r
        })); "string" == typeof i[i.length - 1] && !i[i.length - 1].trim();)i.pop();
        if (null === t.wrapper) return i;
        var a, o = t.wrapper || (r ? "span" : "div");
        if (i.length > 1 || t.forceWrapper) a = i;
        else {
            if (1 === i.length) return "string" == typeof (a = i[0]) ? Z("span", {
                key: "outer"
            }, a) : a;
            a = null;
        }
        return $acw62.createElement(o, {
            key: "outer"
        }, a);
    }
    function V(n) {
        var r = n.match($185ac4d2d2286c00$var$l);
        return r ? r.reduce(function(n, r, t) {
            var i = r.indexOf("=");
            if (-1 !== i) {
                var o = (function(e) {
                    return -1 !== e.indexOf("-") && null === e.match($185ac4d2d2286c00$var$R) && (e = e.replace($185ac4d2d2286c00$var$B, function(e, n) {
                        return n.toUpperCase();
                    })), e;
                })(r.slice(0, i)).trim(), c = function(e) {
                    var n = e[0];
                    return ('"' === n || "'" === n) && e.length >= 2 && e[e.length - 1] === n ? e.slice(1, -1) : e;
                }(r.slice(i + 1).trim()), l = $185ac4d2d2286c00$var$a[o] || o, u = n[l] = function(e, n) {
                    return "style" === e ? n.split(/;\s?/).reduce(function(e, n) {
                        var r = n.slice(0, n.indexOf(":"));
                        return e[r.trim().replace(/(-[a-z])/g, function(e) {
                            return e[1].toUpperCase();
                        })] = n.slice(r.length + 1).trim(), e;
                    }, {}) : "href" === e || "src" === e ? $185ac4d2d2286c00$var$Ne(n) : (n.match($185ac4d2d2286c00$var$M) && (n = n.slice(1, n.length - 1)), "true" === n || "false" !== n && n);
                }(o, c);
                "string" == typeof u && ($185ac4d2d2286c00$var$O.test(u) || $185ac4d2d2286c00$var$z.test(u)) && (n[l] = $acw62.cloneElement(q(u.trim()), {
                    key: t
                }));
            } else "style" !== r && (n[$185ac4d2d2286c00$var$a[r] || r] = !0);
            return n;
        }, {}) : null;
    }
    var X = [], Q = {}, J = ((i = {})[0] = {
        match: $185ac4d2d2286c00$var$Ue($185ac4d2d2286c00$var$f),
        order: 1,
        parse: function(e, n, r) {
            return {
                children: n(e[0].replace($185ac4d2d2286c00$var$d, ""), r)
            };
        },
        render: function(e, n, r) {
            return Z("blockquote", {
                key: r.key
            }, n(e.children, r));
        }
    }, i[1] = {
        match: $185ac4d2d2286c00$var$je($185ac4d2d2286c00$var$p),
        order: 1,
        parse: $185ac4d2d2286c00$var$We,
        render: function(e, n, r) {
            return Z("br", {
                key: r.key
            });
        }
    }, i[2] = {
        match: $185ac4d2d2286c00$var$Ue($185ac4d2d2286c00$var$h),
        order: 1,
        parse: $185ac4d2d2286c00$var$We,
        render: function(e, n, r) {
            return Z("hr", {
                key: r.key
            });
        }
    }, i[3] = {
        match: $185ac4d2d2286c00$var$Ue($185ac4d2d2286c00$var$g),
        order: 0,
        parse: function(e) {
            return {
                lang: void 0,
                text: e[0].replace(/^ {4}/gm, "").replace(/\n+$/, "")
            };
        },
        render: function(e, r, t) {
            return Z("pre", {
                key: t.key
            }, Z("code", $185ac4d2d2286c00$var$n({}, e.attrs, {
                className: e.lang ? "lang-" + e.lang : ""
            }), e.text));
        }
    }, i[4] = {
        match: $185ac4d2d2286c00$var$Ue($185ac4d2d2286c00$var$m),
        order: 0,
        parse: function(e) {
            return {
                attrs: V(e[3] || ""),
                lang: e[2] || void 0,
                text: e[4],
                type: "3"
            };
        }
    }, i[5] = {
        match: $185ac4d2d2286c00$var$Ie($185ac4d2d2286c00$var$y),
        order: 3,
        parse: function(e) {
            return {
                text: e[2]
            };
        },
        render: function(e, n, r) {
            return Z("code", {
                key: r.key
            }, e.text);
        }
    }, i[6] = {
        match: $185ac4d2d2286c00$var$Ue($185ac4d2d2286c00$var$x),
        order: 0,
        parse: function(e) {
            return X.push({
                footnote: e[2],
                identifier: e[1]
            }), {};
        },
        render: $185ac4d2d2286c00$var$Ge
    }, i[7] = {
        match: $185ac4d2d2286c00$var$Me($185ac4d2d2286c00$var$b),
        order: 1,
        parse: function(e) {
            return {
                target: "#" + t.slugify(e[1]),
                text: e[1]
            };
        },
        render: function(e, n, r) {
            return Z("a", {
                key: r.key,
                href: $185ac4d2d2286c00$var$Ne(e.target)
            }, Z("sup", {
                key: r.key
            }, e.text));
        }
    }, i[8] = {
        match: $185ac4d2d2286c00$var$Me($185ac4d2d2286c00$var$S),
        order: 1,
        parse: function(e) {
            return {
                completed: "x" === e[1].toLowerCase()
            };
        },
        render: function(e, n, r) {
            return Z("input", {
                checked: e.completed,
                key: r.key,
                readOnly: !0,
                type: "checkbox"
            });
        }
    }, i[9] = {
        match: $185ac4d2d2286c00$var$Ue(t.enforceAtxHeadings ? $185ac4d2d2286c00$var$$ : $185ac4d2d2286c00$var$C),
        order: 1,
        parse: function(e, n, r) {
            return {
                children: $185ac4d2d2286c00$var$De(n, e[2], r),
                id: t.slugify(e[2]),
                level: e[1].length
            };
        },
        render: function(e, n, r) {
            return Z("h" + e.level, {
                id: e.id,
                key: r.key
            }, n(e.children, r));
        }
    }, i[10] = {
        match: $185ac4d2d2286c00$var$Ue($185ac4d2d2286c00$var$A),
        order: 0,
        parse: function(e, n, r) {
            return {
                children: $185ac4d2d2286c00$var$De(n, e[1], r),
                level: "=" === e[2] ? 1 : 2,
                type: "9"
            };
        }
    }, i[11] = {
        match: $185ac4d2d2286c00$var$je($185ac4d2d2286c00$var$O),
        order: 1,
        parse: function(e, n, r) {
            var t, i = e[3].match($185ac4d2d2286c00$var$ae), a = new RegExp("^" + i[1], "gm"), o = e[3].replace(a, ""), l = (t = o, $185ac4d2d2286c00$var$Ae.some(function(e) {
                return e.test(t);
            }) ? $185ac4d2d2286c00$var$_e : $185ac4d2d2286c00$var$De), u = e[1].toLowerCase(), s = -1 !== $185ac4d2d2286c00$var$c.indexOf(u), f = {
                attrs: V(e[2]),
                noInnerParse: s,
                tag: (s ? u : e[1]).trim()
            };
            return r.inAnchor = r.inAnchor || "a" === u, s ? f.text = e[3] : f.children = l(n, o, r), r.inAnchor = !1, f;
        },
        render: function(e, r, t) {
            return Z(e.tag, $185ac4d2d2286c00$var$n({
                key: t.key
            }, e.attrs), e.text || r(e.children, t));
        }
    }, i[13] = {
        match: $185ac4d2d2286c00$var$je($185ac4d2d2286c00$var$z),
        order: 1,
        parse: function(e) {
            return {
                attrs: V(e[2] || ""),
                tag: e[1].trim()
            };
        },
        render: function(e, r, t) {
            return Z(e.tag, $185ac4d2d2286c00$var$n({}, e.attrs, {
                key: t.key
            }));
        }
    }, i[12] = {
        match: $185ac4d2d2286c00$var$je($185ac4d2d2286c00$var$L),
        order: 1,
        parse: function() {
            return {};
        },
        render: $185ac4d2d2286c00$var$Ge
    }, i[14] = {
        match: $185ac4d2d2286c00$var$Ie($185ac4d2d2286c00$var$Ce),
        order: 1,
        parse: function(e) {
            return {
                alt: e[1],
                target: $185ac4d2d2286c00$var$He(e[2]),
                title: e[3]
            };
        },
        render: function(e, n, r) {
            return Z("img", {
                key: r.key,
                alt: e.alt || void 0,
                title: e.title || void 0,
                src: $185ac4d2d2286c00$var$Ne(e.target)
            });
        }
    }, i[15] = {
        match: $185ac4d2d2286c00$var$Me($185ac4d2d2286c00$var$Se),
        order: 3,
        parse: function(e, n, r) {
            return {
                children: $185ac4d2d2286c00$var$Pe(n, e[1], r),
                target: $185ac4d2d2286c00$var$He(e[2]),
                title: e[3]
            };
        },
        render: function(e, n, r) {
            return Z("a", {
                key: r.key,
                href: $185ac4d2d2286c00$var$Ne(e.target),
                title: e.title
            }, n(e.children, r));
        }
    }, i[16] = {
        match: $185ac4d2d2286c00$var$Me($185ac4d2d2286c00$var$j),
        order: 0,
        parse: function(e) {
            return {
                children: [
                    {
                        text: e[1],
                        type: "27"
                    }
                ],
                target: e[1],
                type: "15"
            };
        }
    }, i[17] = {
        match: function(e, n) {
            return n.inAnchor ? null : $185ac4d2d2286c00$var$Me($185ac4d2d2286c00$var$I)(e, n);
        },
        order: 0,
        parse: function(e) {
            return {
                children: [
                    {
                        text: e[1],
                        type: "27"
                    }
                ],
                target: e[1],
                title: void 0,
                type: "15"
            };
        }
    }, i[18] = {
        match: $185ac4d2d2286c00$var$Me($185ac4d2d2286c00$var$U),
        order: 0,
        parse: function(e) {
            var n = e[1], r = e[1];
            return $185ac4d2d2286c00$var$u.test(r) || (r = "mailto:" + r), {
                children: [
                    {
                        text: n.replace("mailto:", ""),
                        type: "27"
                    }
                ],
                target: r,
                type: "15"
            };
        }
    }, i[20] = $185ac4d2d2286c00$var$Ee(Z, 1), i[33] = $185ac4d2d2286c00$var$Ee(Z, 2), i[19] = {
        match: $185ac4d2d2286c00$var$Ue($185ac4d2d2286c00$var$v),
        order: 3,
        parse: $185ac4d2d2286c00$var$We,
        render: function() {
            return "\n";
        }
    }, i[21] = {
        match: $185ac4d2d2286c00$var$Be,
        order: 3,
        parse: $185ac4d2d2286c00$var$Fe,
        render: function(e, n, r) {
            return Z("p", {
                key: r.key
            }, n(e.children, r));
        }
    }, i[22] = {
        match: $185ac4d2d2286c00$var$Me($185ac4d2d2286c00$var$H),
        order: 0,
        parse: function(e) {
            return Q[e[1]] = {
                target: e[2],
                title: e[4]
            }, {};
        },
        render: $185ac4d2d2286c00$var$Ge
    }, i[23] = {
        match: $185ac4d2d2286c00$var$Ie($185ac4d2d2286c00$var$D),
        order: 0,
        parse: function(e) {
            return {
                alt: e[1] || void 0,
                ref: e[2]
            };
        },
        render: function(e, n, r) {
            return Q[e.ref] ? Z("img", {
                key: r.key,
                alt: e.alt,
                src: $185ac4d2d2286c00$var$Ne(Q[e.ref].target),
                title: Q[e.ref].title
            }) : null;
        }
    }, i[24] = {
        match: $185ac4d2d2286c00$var$Me($185ac4d2d2286c00$var$P),
        order: 0,
        parse: function(e, n, r) {
            return {
                children: n(e[1], r),
                fallbackChildren: n(e[0].replace($185ac4d2d2286c00$var$_, "\\$1"), r),
                ref: e[2]
            };
        },
        render: function(e, n, r) {
            return Q[e.ref] ? Z("a", {
                key: r.key,
                href: $185ac4d2d2286c00$var$Ne(Q[e.ref].target),
                title: Q[e.ref].title
            }, n(e.children, r)) : Z("span", {
                key: r.key
            }, n(e.fallbackChildren, r));
        }
    }, i[25] = {
        match: $185ac4d2d2286c00$var$Ue($185ac4d2d2286c00$var$N),
        order: 1,
        parse: $185ac4d2d2286c00$var$Re,
        render: function(e, n, r) {
            return Z("table", {
                key: r.key
            }, Z("thead", null, Z("tr", null, e.header.map(function(t, i) {
                return Z("th", {
                    key: i,
                    style: $185ac4d2d2286c00$var$ze(e, i)
                }, n(t, r));
            }))), Z("tbody", null, e.cells.map(function(t, i) {
                return Z("tr", {
                    key: i
                }, t.map(function(t, i) {
                    return Z("td", {
                        key: i,
                        style: $185ac4d2d2286c00$var$ze(e, i)
                    }, n(t, r));
                }));
            })));
        }
    }, i[26] = {
        match: function(e, n) {
            return n.inTable ? (n.inline = !0, $185ac4d2d2286c00$var$G.exec(e)) : null;
        },
        order: 1,
        parse: function() {
            return {
                type: "26"
            };
        },
        render: function() {
            return " | ";
        }
    }, i[27] = {
        match: $185ac4d2d2286c00$var$je($185ac4d2d2286c00$var$te),
        order: 4,
        parse: function(e) {
            return {
                text: e[0].replace($185ac4d2d2286c00$var$T, function(e, n) {
                    return t.namedCodesToUnicode[n] ? t.namedCodesToUnicode[n] : e;
                })
            };
        },
        render: function(e) {
            return e.text;
        }
    }, i[28] = {
        match: $185ac4d2d2286c00$var$Ie($185ac4d2d2286c00$var$K),
        order: 2,
        parse: function(e, n, r) {
            return {
                children: n(e[2], r)
            };
        },
        render: function(e, n, r) {
            return Z("strong", {
                key: r.key
            }, n(e.children, r));
        }
    }, i[29] = {
        match: $185ac4d2d2286c00$var$Ie($185ac4d2d2286c00$var$Y),
        order: 3,
        parse: function(e, n, r) {
            return {
                children: n(e[2], r)
            };
        },
        render: function(e, n, r) {
            return Z("em", {
                key: r.key
            }, n(e.children, r));
        }
    }, i[30] = {
        match: $185ac4d2d2286c00$var$Ie($185ac4d2d2286c00$var$re),
        order: 1,
        parse: function(e) {
            return {
                text: e[1],
                type: "27"
            };
        }
    }, i[31] = {
        match: $185ac4d2d2286c00$var$Ie($185ac4d2d2286c00$var$ee),
        order: 3,
        parse: $185ac4d2d2286c00$var$Fe,
        render: function(e, n, r) {
            return Z("mark", {
                key: r.key
            }, n(e.children, r));
        }
    }, i[32] = {
        match: $185ac4d2d2286c00$var$Ie($185ac4d2d2286c00$var$ne),
        order: 3,
        parse: $185ac4d2d2286c00$var$Fe,
        render: function(e, n, r) {
            return Z("del", {
                key: r.key
            }, n(e.children, r));
        }
    }, i);
    !0 === t.disableParsingRawHTML && (delete J[11], delete J[13]);
    var oe, ce = function(e) {
        var n = Object.keys(e);
        function r(t, i) {
            for(var a = [], o = ""; t;)for(var c = 0; c < n.length;){
                var l = n[c], u = e[l], s = u.match(t, i, o);
                if (s) {
                    var f = s[0];
                    t = t.substring(f.length);
                    var d = u.parse(s, r, i);
                    null == d.type && (d.type = l), a.push(d), o = f;
                    break;
                }
                c++;
            }
            return a;
        }
        return n.sort(function(n, r) {
            var t = e[n].order, i = e[r].order;
            return t !== i ? t - i : n < r ? -1 : 1;
        }), function(e, n) {
            return r(function(e) {
                return e.replace($185ac4d2d2286c00$var$k, "\n").replace($185ac4d2d2286c00$var$w, "").replace($185ac4d2d2286c00$var$W, "    ");
            }(e), n);
        };
    }(J), le = (oe = function(e, n) {
        return function(r, t, i) {
            var a = e[r.type].render;
            return n ? n(function() {
                return a(r, t, i);
            }, r, t, i) : a(r, t, i);
        };
    }(J, t.renderRule), function e(n, r) {
        if (void 0 === r && (r = {}), Array.isArray(n)) {
            for(var t = r.key, i = [], a = !1, o = 0; o < n.length; o++){
                r.key = o;
                var c = e(n[o], r), l = "string" == typeof c;
                l && a ? i[i.length - 1] += c : null !== c && i.push(c), a = l;
            }
            return r.key = t, i;
        }
        return oe(n, e, r);
    }), ue = q(r);
    return X.length ? Z("div", null, ue, Z("footer", {
        key: "footer"
    }, X.map(function(e) {
        return Z("div", {
            id: t.slugify(e.identifier),
            key: e.identifier
        }, e.identifier, le(ce(e.footnote, {
            inline: !0
        })));
    }))) : ue;
}
function $185ac4d2d2286c00$export$2e2bcd8739ae039(n) {
    var r = n.children, t = void 0 === r ? "" : r, a = n.options, o = function(e, n) {
        if (null == e) return {};
        var r, t, i = {}, a = Object.keys(e);
        for(t = 0; t < a.length; t++)n.indexOf(r = a[t]) >= 0 || (i[r] = e[r]);
        return i;
    }(n, $185ac4d2d2286c00$var$i);
    return $acw62.cloneElement($185ac4d2d2286c00$export$69f434acfbdb0b32(t, a), o);
}


const $c2cae7fb2285a0f2$export$1766d94b885a87cc = (0, $d4be60b58ad177a9$export$dbf350e5966cf602)`
    font-size: 0.75rem;


    /* Headers */

    & h1 {
        font-weight: 500;
        font-size: 1.25rem;
        margin-bottom: 0.375rem;
    }

    & h2 {
        font-weight: 500;
        font-size: 1rem;
        margin-top: 0.75rem;
        margin-bottom: 0.25rem;
    }

    & h3 {
        font-weight: 500;
        font-size: 0.875rem;
        margin-top: 0.75rem;
        margin-bottom: 0.25rem;
    }

    & h4 {
        font-weight: 500;
        font-size: 0.75rem;
        margin-top: 0.5rem;
        margin-bottom: 0.25rem;
    }

    & h5 {
        font-weight: 500;
        font-size: 0.75rem;
        margin-top: 0.5rem;
        margin-bottom: 0.25rem;
    }

    & h6 {
        font-weight: 500;
        font-size: 0.75rem;
        margin-top: 0.5rem;
        margin-bottom: 0.25rem;
    }


    /* Paragraphs */

    & p + p {
        margin: 0.625rem 0;
    }


    /* Lists */

    & ul ul {
        padding-inline-start: 1rem;
    }

    & li + li {
        margin-top: 0.5rem;
    }


    /* Tables */

    & table {
        margin: 1rem 0;
        overflow-x: auto;
    }

    & td,
    & th {
        text-align: start;
        padding: 0.25rem 0.5rem;
    }

    & th {
        background-color: rgb(243 244 246); /* gray-100 */
        font-weight: bold;
    }

    & tr:nth-child(even) {
        background-color: rgb(243 244 246); /* gray-100 */
    }


    /* Links */

    a {
        color: rgb(30 64 175); /* blue-800 */
    }
`;
function $c2cae7fb2285a0f2$export$d3b62677feddf368({ className: className, ...props }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $185ac4d2d2286c00$export$2e2bcd8739ae039), {
        className: `${$c2cae7fb2285a0f2$export$1766d94b885a87cc} ${className}`,
        ...props
    });
}















function $1123d3d37a1ef0d8$var$typed(revision, obj) {
    return {
        t: "resheet.jsexpr",
        v: revision,
        ...obj
    };
}
function $1123d3d37a1ef0d8$var$typedTables(revision, obj) {
    return {
        t: "tables.jsexpr",
        v: revision,
        ...obj
    };
}
const $1123d3d37a1ef0d8$var$vPre = (0, $303c1b51f19a20e4$export$136de4b706fa579)((0, $dc2e80b7ebe4adb5$export$22b082955e083ec3), (code)=>(env)=>({
            code: code,
            result: {
                type: "immediate",
                value: undefined
            },
            compiled: (0, $e26ee743ff8e9b71$export$4495ab609416a46b)(code)
        }));
const $1123d3d37a1ef0d8$var$v0 = (0, $303c1b51f19a20e4$export$471c540adb39cb81)($1123d3d37a1ef0d8$var$vPre, {
    schema: $1123d3d37a1ef0d8$var$typedTables(0, {
        code: (0, $dc2e80b7ebe4adb5$export$22b082955e083ec3)
    }),
    parse ({ code: code }) {
        return (env)=>({
                code: code,
                result: {
                    type: "immediate",
                    value: undefined
                },
                compiled: (0, $e26ee743ff8e9b71$export$4495ab609416a46b)(code)
            });
    },
    upgrade (before) {
        return before;
    }
});
const $1123d3d37a1ef0d8$export$21625637effda04 = (0, $303c1b51f19a20e4$export$471c540adb39cb81)($1123d3d37a1ef0d8$var$v0, {
    schema: $1123d3d37a1ef0d8$var$typed(1, {
        code: (0, $dc2e80b7ebe4adb5$export$22b082955e083ec3)
    }),
    parse ({ code: code }) {
        return (env)=>({
                code: code,
                result: {
                    type: "immediate",
                    value: undefined
                },
                compiled: (0, $e26ee743ff8e9b71$export$4495ab609416a46b)(code)
            });
    },
    upgrade (before) {
        return before;
    }
});
const $1123d3d37a1ef0d8$export$2cd8252107eb640b = {
    code: "",
    result: {
        type: "immediate",
        value: undefined
    },
    compiled: (0, $e26ee743ff8e9b71$export$42b2ceb4792e5d2b)
};
function $1123d3d37a1ef0d8$export$54fd2c36b5cc6731(state) {
    return $1123d3d37a1ef0d8$var$typed(1, {
        code: state.code
    });
}


const $6d146131cf95401b$export$4e4e7267e6bca3a9 = $6f23581c0aef6dc2$export$185802fd694ee1f5({
    init: $1123d3d37a1ef0d8$export$2cd8252107eb640b,
    view ({ env: env, state: state, dispatch: dispatch }, ref) {
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6d146131cf95401b$export$34758abbf03d546b, {
            ref: ref,
            state: state,
            dispatch: dispatch,
            env: env
        });
    },
    recompute (state, dispatch, env, changedVars) {
        if (changedVars && changedVars.intersect(state.compiled.deps).isEmpty()) return {
            state: state,
            invalidated: false
        };
        return {
            state: $6d146131cf95401b$var$updateResult(state, dispatch, env),
            invalidated: true
        };
    },
    getResult (state) {
        return (0, $e7500bbe9a1dee8a$export$b1f4a9e5cc3a8021)(state.result);
    },
    fromJSON (json, dispatch, env) {
        return $6d146131cf95401b$var$updateResult($1123d3d37a1ef0d8$export$21625637effda04(json)(env), dispatch, env);
    },
    toJSON (state) {
        return state.code;
    }
});
const $6d146131cf95401b$export$34758abbf03d546b = /*#__PURE__*/ $acw62.forwardRef(function JSExprUi({ state: state, dispatch: dispatch, env: env }, ref) {
    const codeEditor = $acw62.useRef();
    const completions = (0, $5bd921a18e0690d7$export$f478f6dc019df8a3)(codeEditor, state.code, env);
    $acw62.useImperativeHandle(ref, ()=>({
            focus () {
                codeEditor.current?.element?.focus();
            }
        }));
    const onUpdateCode = $acw62.useCallback(function onUpdateCode(code) {
        dispatch((state, { env: env })=>({
                state: $6d146131cf95401b$var$updateResult({
                    ...state,
                    code: code,
                    compiled: (0, $e26ee743ff8e9b71$export$4495ab609416a46b)(code)
                }, dispatch, env)
            }));
    }, [
        dispatch
    ]);
    const shortcutProps = (0, $5bc960417406f657$export$a1ca853c6e4bb6fb)([
        ...completions.shortcuts,
        {
            description: "jsexpr",
            bindings: [
                [
                    [
                        "Alt-Enter"
                    ],
                    "none",
                    "rerun computation",
                    ()=>{
                        dispatch((state, { env: env })=>({
                                state: $6d146131cf95401b$var$updateResult(state, dispatch, env),
                                description: "reran computation"
                            }));
                    }
                ]
            ]
        }
    ]);
    const codeLines = state.code.split("\n").length;
    const backgroundOpacity = (0, $512ec8d668819b2f$export$fc3e3729c0793f12)(0, 1, (codeLines - 3) / 5);
    const [indicatorWidth, indicatorColor] = codeLines > 3 ? [
        (0, $512ec8d668819b2f$export$fc3e3729c0793f12)(0, .25, codeLines / 40) + "rem",
        `rgba(125, 211, 252, ${(0, $512ec8d668819b2f$export$fc3e3729c0793f12)(0, 1, (codeLines - 3) / 20 + .4)})`
    ] : [
        "0",
        "transparent"
    ];
    const style = (0, $ff99259e85546794$export$b540f128867fb8a2)({
        fontFamily: 'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace',
        "--resheet-jsexpr-indicator-width": "-" + indicatorWidth,
        "--resheet-jsexpr-indicator-color": indicatorColor,
        "--tw-gradient-to": `rgb(240, 249, 255, ${backgroundOpacity}) var(--tw-gradient-to-position)`
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        onBlur: completions.onBlur,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cb8a0fe0beecb480$export$b7127187684f7150), {
                ref: codeEditor,
                code: state.code,
                onUpdate: onUpdateCode,
                style: style,
                className: `
                        block
                        whitespace-pre outline-none
                        border-b border-gray-100
                        focus-within/code-editor:bg-gradient-to-r
                        from-transparent from-10%
                        shadow-[inset_var(--resheet-jsexpr-indicator-width)_0_0_0_var(--resheet-jsexpr-indicator-color)]
                        overflow-x-auto
                        print:shadow-none print:bg-none print:whitespace-pre-wrap
                    `,
                ...shortcutProps
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b749c8e203b309f1$export$aafb8a44cb285d8d), {
                result: state.result
            }),
            completions.ui
        ]
    });
});
function $6d146131cf95401b$var$updateResult(state, dispatch, env) {
    const dispatchResult = (0, $d0f575b1326e7f91$export$f153e5abd026c378)("result", dispatch);
    function setResult(result) {
        dispatchResult(()=>({
                state: result
            }));
    }
    if (state.result.type === "promise") state.result.cancel();
    const value = state.compiled.run(env);
    const result = (0, $e7500bbe9a1dee8a$export$e57bc0d30024f27d)(value, setResult);
    return {
        ...state,
        result: result
    };
}
function $6d146131cf95401b$export$ec7bfc99e712ff5d() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c2cae7fb2285a0f2$export$d3b62677feddf368), {
        options: {
            overrides: $6d146131cf95401b$export$cb525752c37d2db8
        },
        children: `
A multiline JavaScript Block. Supports JSX and toplevel await. The Block's value is the value
of the last expression.

## Examples

<Example1 />

<Example2 />

<Example3 />

<Example4 />
            `.trim()
    });
}
function $6d146131cf95401b$export$3849b92fb7e12a24(docs) {
    docs.set($6d146131cf95401b$export$4e4e7267e6bca3a9, $6d146131cf95401b$export$ec7bfc99e712ff5d);
}
function $6d146131cf95401b$export$2b8f26b427c15f(code, env) {
    const initWithCode = {
        ...$1123d3d37a1ef0d8$export$2cd8252107eb640b,
        code: code
    };
    return function Example() {
        const safeJSExpr = $acw62.useMemo(()=>(0, $b8f588c17e3c1433$export$e255fd3f9a510304)($6d146131cf95401b$export$4e4e7267e6bca3a9), []);
        const [state, dispatch] = $6f23581c0aef6dc2$export$ece2d8b003194dcc(null, [
            {
                env: env
            }
        ]);
        $acw62.useEffect(()=>{
            dispatch(()=>({
                    state: $6d146131cf95401b$var$updateResult(initWithCode, dispatch, env)
                }));
        }, []);
        if (state === null) return null;
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "border rounded border-gray-100 my-4",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(safeJSExpr.Component, {
                state: state,
                dispatch: dispatch,
                env: env
            })
        });
    };
}
const $6d146131cf95401b$export$75e78dcafdd92f43 = $6d146131cf95401b$export$2b8f26b427c15f(`
const x = 1;
const y = 2;
Math.min(x, y);
    `.trim(), {
    React: $acw62
});
const $6d146131cf95401b$export$1ffb29a24a9c22e2 = $6d146131cf95401b$export$2b8f26b427c15f(`
<span className="text-xl font-bold text-red-900">
  Alert
</span>
    `.trim(), {
    React: $acw62
});
const $6d146131cf95401b$export$cc0c1dbd0ff7eb48 = $6d146131cf95401b$export$2b8f26b427c15f(`
function Test() {
  const [input, setInput] = React.useState("Hey there")

  function onChange(ev) {
    setInput(ev.target.value)
  }

  return (
    <div>
      <div>
        <input
          className="rounded outline outline-1 outline-sky-200 focus:outline-sky-500"
          type="text"
          value={input}
          onChange={onChange}
          />
      </div>
      <div>{input.toUpperCase()}</div>
    </div>
  )
}

<Test />
    `.trim(), {
    React: $acw62
});
const $6d146131cf95401b$export$bc03dad28128351d = $6d146131cf95401b$export$2b8f26b427c15f(`
function wait(ms) {
  return new Promise(resolve => {
    setTimeout(resolve, ms)
  })
}

await wait(5000);
<span className="text-xl">Done</span>
    `.trim(), {
    React: $acw62
});
const $6d146131cf95401b$export$cb525752c37d2db8 = {
    Example1: $6d146131cf95401b$export$75e78dcafdd92f43,
    Example2: $6d146131cf95401b$export$1ffb29a24a9c22e2,
    Example3: $6d146131cf95401b$export$cc0c1dbd0ff7eb48,
    Example4: $6d146131cf95401b$export$bc03dad28128351d
};



var $8c8e02836b046cc0$exports = {};

$parcel$export($8c8e02836b046cc0$exports, "Note", () => $8c8e02836b046cc0$export$6c88bf799aca3d2b);
$parcel$export($8c8e02836b046cc0$exports, "NoteUi", () => $8c8e02836b046cc0$export$368c4e38f6923143);
$parcel$export($8c8e02836b046cc0$exports, "recompute", () => $8c8e02836b046cc0$export$1f297d8d0ce29e3);
$parcel$export($8c8e02836b046cc0$exports, "updateNote", () => $8c8e02836b046cc0$export$747b07a192c3db9d);
$parcel$export($8c8e02836b046cc0$exports, "NoteEditor", () => $8c8e02836b046cc0$export$9939e67821493b95);


var $acw62 = parcelRequire("acw62");










var $92ca999eabf01e6c$exports = {};

$parcel$export($92ca999eabf01e6c$exports, "getCode", () => $92ca999eabf01e6c$export$9a0a9c75ccef13fb);
$parcel$export($92ca999eabf01e6c$exports, "getPrefix", () => $92ca999eabf01e6c$export$36e24695f02d4503);
$parcel$export($92ca999eabf01e6c$exports, "EXPR_REGEX", () => $92ca999eabf01e6c$export$76de675ca438bc97);
$parcel$export($92ca999eabf01e6c$exports, "BLOCK_REGEX", () => $92ca999eabf01e6c$export$a010a1059f002f2a);
$parcel$export($92ca999eabf01e6c$exports, "evaluateNote", () => $92ca999eabf01e6c$export$262cb2bb65c22c9);
$parcel$export($92ca999eabf01e6c$exports, "parseNote", () => $92ca999eabf01e6c$export$9946f9bc2dddfe44);
$parcel$export($92ca999eabf01e6c$exports, "recomputeNote", () => $92ca999eabf01e6c$export$1ebe6fe895a0083f);
$parcel$export($92ca999eabf01e6c$exports, "ViewNote", () => $92ca999eabf01e6c$export$c1071f579d5374c4);
$parcel$export($92ca999eabf01e6c$exports, "textClasses", () => $92ca999eabf01e6c$export$660145e999f4eb16);
$parcel$export($92ca999eabf01e6c$exports, "ViewBlockInstantiated", () => $92ca999eabf01e6c$export$cb90898ed73f4289);


var $acw62 = parcelRequire("acw62");









parcelRequire("acw62");




function $2e3654c3959f174f$export$5e8d04b39f0aa3f4({ title: title, href: href, children: children }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
        className: "relative group/mdlink text-blue-800",
        children: [
            children,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "absolute left-0 bottom-0",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", {
                    href: href,
                    title: title,
                    target: "_blank",
                    className: `
                        hidden group-hover/mdlink:block hover:block
                        rounded rounded-tl-none px-1.5 py-0.5 bg-gray-200 text-black text-xs whitespace-nowrap
                        absolute left-0 top-0 z-40
                    `,
                    onMouseDown: (ev)=>ev.preventDefault(),
                    children: [
                        "open link ",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e4ec753f5c716375$export$2b9260d4a45c8710), {
                            size: "sm",
                            icon: $d8206b3ab2e65c05$export$5ad84e891223f2c3
                        })
                    ]
                })
            })
        ]
    });
}
function $2e3654c3959f174f$export$5f1bbfa54c2ed43({ title: title, href: href, children: children }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
        href: href,
        title: title,
        target: "_blank",
        className: "text-blue-800",
        onMouseDown: (ev)=>{
            if (ev.ctrlKey || ev.metaKey) return;
            ev.preventDefault();
        },
        children: children
    });
}
const $2e3654c3959f174f$export$1591b5b8c61dbb9c = {
    a: $2e3654c3959f174f$export$5f1bbfa54c2ed43
};
function $2e3654c3959f174f$export$a6503a42d9d7bb48(content) {
    return (0, $185ac4d2d2286c00$export$69f434acfbdb0b32)(content, {
        overrides: $2e3654c3959f174f$export$1591b5b8c61dbb9c
    });
}
function $2e3654c3959f174f$export$1b088b5cabb1ce8a(props) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $185ac4d2d2286c00$export$2e2bcd8739ae039), {
        ...props,
        options: (0, $b8fe2d75c7583f49$export$dd702b3c8240390c)({
            overrides: $2e3654c3959f174f$export$1591b5b8c61dbb9c
        }, props.options ?? {})
    });
}


function $92ca999eabf01e6c$export$9a0a9c75ccef13fb(note) {
    switch(note.type){
        case "expr":
        case "block":
            return note.code;
        default:
            return null;
    }
}
function $92ca999eabf01e6c$export$36e24695f02d4503(type, input) {
    switch(type){
        case "expr":
            return input.match($92ca999eabf01e6c$export$76de675ca438bc97)[0];
        case "block":
            return input.match($92ca999eabf01e6c$export$a010a1059f002f2a)[0];
        default:
            return "";
    }
}
const $92ca999eabf01e6c$export$76de675ca438bc97 = /^\s*=/;
const $92ca999eabf01e6c$export$a010a1059f002f2a = /^\s*\//;
function $92ca999eabf01e6c$export$262cb2bb65c22c9(input, env, dispatchNote, lastNote) {
    const dispatchExprResult = $6f23581c0aef6dc2$export$574ac5a1d40355c9({
        type: "expr"
    }, "result", dispatchNote);
    const dispatchBlockResult = $6f23581c0aef6dc2$export$574ac5a1d40355c9({
        type: "block",
        isInstantiated: false
    }, "result", dispatchNote);
    const parsed = $92ca999eabf01e6c$export$9946f9bc2dddfe44(input);
    switch(parsed.type){
        case "expr":
            {
                const value = parsed.compiled.run(env);
                const result = (0, $e7500bbe9a1dee8a$export$e57bc0d30024f27d)(value, $6f23581c0aef6dc2$export$46fcd87d869db630(dispatchExprResult));
                return {
                    type: "expr",
                    code: parsed.code,
                    compiled: parsed.compiled,
                    result: result
                };
            }
        case "block":
            {
                const value = parsed.compiled.run(env);
                const result = (0, $e7500bbe9a1dee8a$export$e57bc0d30024f27d)(value, $6f23581c0aef6dc2$export$46fcd87d869db630(dispatchBlockResult));
                const lastState = lastNote?.lastState;
                return {
                    type: "block",
                    isInstantiated: false,
                    code: parsed.code,
                    compiled: parsed.compiled,
                    result: result,
                    lastState: lastState
                };
            }
        case "checkbox":
        case "text":
            return parsed;
    }
}
function $92ca999eabf01e6c$export$9946f9bc2dddfe44(input) {
    const exprMatch = input.match($92ca999eabf01e6c$export$76de675ca438bc97);
    if (exprMatch) {
        const expr = input.slice(exprMatch[0].length);
        const compiled = (0, $e26ee743ff8e9b71$export$c19cabcb7ba30452)(expr);
        return {
            type: "expr",
            code: expr,
            compiled: compiled
        };
    }
    const blockMatch = input.match($92ca999eabf01e6c$export$a010a1059f002f2a);
    if (blockMatch) {
        const expr = input.slice(blockMatch[0].length);
        const compiled = (0, $e26ee743ff8e9b71$export$c19cabcb7ba30452)(expr);
        return {
            type: "block",
            code: expr,
            compiled: compiled
        };
    }
    const headerMatch = input.match(/^(#{1,6})\s*/);
    if (headerMatch) {
        const level = headerMatch[1].length;
        return {
            type: "text",
            tag: `h${level}`,
            text: input.slice(headerMatch[0].length)
        };
    }
    const listMatch = input.match(/^[-*]\s+/);
    if (listMatch) return {
        type: "text",
        tag: "li",
        text: input.slice(listMatch[0].length)
    };
    const checkboxMatch = input.match(/^\[[ xX]?\]\s+/);
    if (checkboxMatch) return {
        type: "checkbox",
        checked: /^\[[xX]\]/.test(input),
        text: input.slice(checkboxMatch[0].length)
    };
    return {
        type: "text",
        tag: "p",
        text: input
    };
}
function $92ca999eabf01e6c$export$1ebe6fe895a0083f(note, dispatch, env, changedVars) {
    switch(note.type){
        case "block":
            if (note.isInstantiated === true) {
                const dispatchBlockState = $6f23581c0aef6dc2$export$574ac5a1d40355c9({
                    type: "block",
                    isInstantiated: true
                }, "state", dispatch);
                const changedDeps = changedVars?.intersect(note.compiled.deps);
                if (!changedDeps || !changedDeps.isEmpty()) {
                    const newBlock = note.compiled.run(env);
                    if ($6f23581c0aef6dc2$export$de5a9e42c1dff8da(newBlock) && newBlock !== note.block.$$UNSAFE_BLOCK) try {
                        const jsonState = note.block.toJSON(note.state);
                        const newSafeBlock = (0, $b8f588c17e3c1433$export$e255fd3f9a510304)(newBlock);
                        const newState = newSafeBlock.fromJSON(jsonState, dispatchBlockState, env);
                        return {
                            state: {
                                type: "block",
                                isInstantiated: true,
                                code: note.code,
                                compiled: note.compiled,
                                block: newSafeBlock,
                                state: newState
                            },
                            invalidated: true
                        };
                    } catch (e) {}
                }
                const { state: state, invalidated: invalidated } = note.block.recompute(note.state, dispatchBlockState, env, changedVars);
                return {
                    state: {
                        ...note,
                        state: state
                    },
                    invalidated: invalidated
                };
            } else {
                if (changedVars && changedVars.intersect(note.compiled.deps).isEmpty()) return {
                    state: note,
                    invalidated: false
                };
                if (note.result.type === "promise") note.result.cancel();
                const dispatchBlockResult = $6f23581c0aef6dc2$export$574ac5a1d40355c9({
                    type: "block",
                    isInstantiated: false
                }, "result", dispatch);
                const value = note.compiled.run(env);
                const result = (0, $e7500bbe9a1dee8a$export$e57bc0d30024f27d)(value, $6f23581c0aef6dc2$export$46fcd87d869db630(dispatchBlockResult));
                if ("loading" in note && $6f23581c0aef6dc2$export$de5a9e42c1dff8da(value)) {
                    const dispatchBlockState = $6f23581c0aef6dc2$export$574ac5a1d40355c9({
                        type: "block",
                        isInstantiated: true
                    }, "state", dispatch);
                    const loadedBlock = (0, $b8f588c17e3c1433$export$e255fd3f9a510304)(value);
                    const state = loadedBlock.fromJSON(note.loading, dispatchBlockState, env);
                    return {
                        state: {
                            type: "block",
                            isInstantiated: true,
                            code: note.code,
                            compiled: note.compiled,
                            block: loadedBlock,
                            state: state
                        },
                        invalidated: true
                    };
                }
                return {
                    state: {
                        ...note,
                        result: result
                    },
                    invalidated: true
                };
            }
        case "expr":
            if (changedVars && changedVars.intersect(note.compiled.deps).isEmpty()) return {
                state: note,
                invalidated: false
            };
            if (note.result.type === "promise") note.result.cancel();
            const dispatchExprResult = $6f23581c0aef6dc2$export$574ac5a1d40355c9({
                type: "expr"
            }, "result", dispatch);
            const value = note.compiled.run(env);
            const result = (0, $e7500bbe9a1dee8a$export$e57bc0d30024f27d)(value, $6f23581c0aef6dc2$export$46fcd87d869db630(dispatchExprResult));
            return {
                state: {
                    ...note,
                    result: result
                },
                invalidated: true
            };
        case "text":
        case "checkbox":
            return {
                state: note,
                invalidated: false
            };
    }
}
function $92ca999eabf01e6c$export$c1071f579d5374c4({ note: note, env: env, actions: actions }) {
    switch(note.type){
        case "text":
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($92ca999eabf01e6c$var$ViewText, {
                note: note
            });
        case "checkbox":
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($92ca999eabf01e6c$var$ViewCheckbox, {
                toggleCheckbox: actions.toggleCheckbox,
                note: note
            });
        case "expr":
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($92ca999eabf01e6c$var$ViewExprResult, {
                note: note
            });
        case "block":
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($92ca999eabf01e6c$var$ViewBlock, {
                instantiateBlock: actions.instantiateBlock,
                resetBlock: actions.resetBlock,
                note: note,
                env: env
            });
    }
}
const $92ca999eabf01e6c$var$ViewText = /*#__PURE__*/ $acw62.memo(function ViewText({ note: note }) {
    const content = note.text.trim() === "" ? "\u200B" : note.text;
    return /*#__PURE__*/ $acw62.createElement(note.tag, {
        className: `cursor-text whitespace-pre-wrap ${$92ca999eabf01e6c$export$660145e999f4eb16[note.tag]}`
    }, (0, $2e3654c3959f174f$export$a6503a42d9d7bb48)(content));
}, (before, after)=>before.note.tag === after.note.tag && before.note.text === after.note.text);
const $92ca999eabf01e6c$export$660145e999f4eb16 = {
    h1: "text-5xl mt-6 my-3",
    h2: "text-4xl mt-6 my-3",
    h3: "text-3xl mt-6 my-2",
    h4: "text-2xl mt-4 my-2",
    h5: "text-xl mt-4 my-2",
    h6: "text-lg mt-2 my-1",
    p: ""
};
const $92ca999eabf01e6c$var$ViewCheckbox = /*#__PURE__*/ $acw62.memo(function ViewCheckbox({ note: note, toggleCheckbox: toggleCheckbox }) {
    const preventFocus = $acw62.useCallback(function preventFocus(event) {
        event.stopPropagation();
        event.preventDefault();
    }, []);
    const clickCheckbox = $acw62.useCallback(function clickCheckbox(event) {
        event.stopPropagation();
        event.preventDefault();
        toggleCheckbox();
    }, [
        toggleCheckbox
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e4ec753f5c716375$export$2b9260d4a45c8710), {
                onPointerDown: preventFocus,
                onClick: clickCheckbox,
                className: `mr-2 cursor-pointer ${note.checked && "text-blue-400"}`,
                icon: note.checked ? $d8206b3ab2e65c05$export$5bb6a0c94ad2f4bb : $7435a4b2c8a749a5$export$90b4406457aae8cc
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2e3654c3959f174f$export$1b088b5cabb1ce8a), {
                options: {
                    wrapper: "span"
                },
                className: `cursor-text ${note.checked ? "text-gray-400 line-through" : ""}`,
                children: note.text
            })
        ]
    });
}, (before, after)=>before.note.checked === after.note.checked && before.note.text === after.note.text && before.toggleCheckbox === after.toggleCheckbox);
const $92ca999eabf01e6c$var$ViewBlock = /*#__PURE__*/ $acw62.memo(function ViewBlock({ note: note, env: env, instantiateBlock: instantiateBlock, resetBlock: resetBlock }) {
    if (note.isInstantiated === true) return null;
    const value = (0, $e7500bbe9a1dee8a$export$b1f4a9e5cc3a8021)(note.result);
    if (!$6f23581c0aef6dc2$export$de5a9e42c1dff8da(value)) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "bg-blue-100 px-1",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e4ec753f5c716375$export$2b9260d4a45c8710), {
                        className: "text-blue-400",
                        icon: $d8206b3ab2e65c05$export$317f99f46b39906e
                    }),
                    " ",
                    "Not a Block:"
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b749c8e203b309f1$export$aafb8a44cb285d8d), {
                result: note.result
            })
        ]
    });
    const innerBlock = (0, $b8f588c17e3c1433$export$e255fd3f9a510304)(value);
    let state = innerBlock.init;
    try {
        if (note.lastState !== undefined) // don't use innerBlock (a safeBlock), because we want to
        // handle errors ourselves here
        state = value.fromJSON(note.lastState, ()=>{}, env);
    } catch (e) {}
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "flex flex-col items-stretch rounded py-1 border border-t border-b border-gray-200 bg-gray-100",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "bg-white flex flex-col justify-center items-stretch min-h-14 overflow-x-auto relative",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(innerBlock.Component, {
                    state: state,
                    dispatch: ()=>{},
                    env: env
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                    className: `
                            absolute inset-0 w-full z-10
                            flex flex-col justify-center items-center
                            bg-gray-100/60 text-gray-400/60
                            hover:text-sky-400 hover:backdrop-blur-sm
                            transition-[backdrop-filter,color] duration-75
                        `,
                    onClick: instantiateBlock,
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "text-3xl font-bold tracking-[.3em]",
                            children: "PREVIEW"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "text-xs",
                            children: "Click to instantiate"
                        })
                    ]
                }),
                note.lastState && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                    className: "absolute z-10 top-2 right-2 rounded px-1 bg-gray-100 hover:bg-gray-200 hover:text-blue-700",
                    onClick: resetBlock,
                    children: "Reset"
                })
            ]
        })
    });
}, (before, after)=>{
    if (before.env !== after.env || before.instantiateBlock !== after.instantiateBlock) return false;
    if (after.note.isInstantiated === true) return before.note.isInstantiated && before.note.code === after.note.code && before.note.block === after.note.block && before.note.state === after.note.state;
    else return before.note.isInstantiated === false && before.note.code === after.note.code && before.note.lastState === after.note.lastState;
});
const $92ca999eabf01e6c$export$cb90898ed73f4289 = /*#__PURE__*/ $acw62.memo(/*#__PURE__*/ $acw62.forwardRef(function ViewBlockInstantiated({ note: note, dispatch: dispatch, env: env }, ref) {
    const dispatchBlock = $acw62.useMemo(()=>$6f23581c0aef6dc2$export$574ac5a1d40355c9({
            type: "block",
            isInstantiated: true
        }, "state", dispatch), [
        dispatch
    ]);
    function onChangeBlockType() {
        dispatch((state)=>{
            if (state.type !== "block" || !state.isInstantiated) return {
                state: state
            };
            return {
                state: {
                    type: "block",
                    isInstantiated: false,
                    code: state.code,
                    compiled: state.compiled,
                    result: {
                        type: "immediate",
                        value: state.block
                    },
                    lastState: state.block.toJSON(state.state)
                }
            };
        });
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex flex-col item-stretch rounded pb-1 border border-t border-b border-gray-200 bg-gray-100",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "flex flex-row justify-end",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                    className: "group/note-block-header px-2 py-1 text-xs text-gray-400 hover:text-gray-600",
                    onClick: onChangeBlockType,
                    children: [
                        note.code,
                        " ",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e4ec753f5c716375$export$2b9260d4a45c8710), {
                            className: "text-gray-300 group-hover/note-block-header:text-gray-500",
                            icon: $d8206b3ab2e65c05$export$d6298bbfd1912a78
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "bg-white flex flex-col justify-center items-stretch min-h-8 overflow-x-auto overflow-y-hidden",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(note.block.Component, {
                    ref: ref,
                    state: note.state,
                    dispatch: dispatchBlock,
                    env: env
                })
            })
        ]
    });
}), (before, after)=>{
    if (before.env !== after.env || before.dispatch !== after.dispatch) return false;
    if (after.note.isInstantiated) return before.note.isInstantiated && before.note.code === after.note.code && before.note.block === after.note.block && before.note.state === after.note.state;
    else return !before.note.isInstantiated && before.note.code === after.note.code;
});
const $92ca999eabf01e6c$var$ViewExprResult = /*#__PURE__*/ $acw62.memo(function ViewExprResult({ note: note }) {
    if (note.code.trim() === "") return null;
    if ($92ca999eabf01e6c$var$isLiteral(note.code)) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b749c8e203b309f1$export$aafb8a44cb285d8d), {
        result: note.result
    });
}, (before, after)=>before.note.code === after.note.code && before.note.result === after.note.result);
const $92ca999eabf01e6c$var$JS_LITERALS = [
    "StringLiteral",
    "NumericLiteral",
    "BigIntLiteral",
    "BooleanLiteral",
    "NullLiteral",
    "RegExpLiteral"
];
function $92ca999eabf01e6c$var$isLiteral(expr) {
    try {
        const type = (0, $e26ee743ff8e9b71$export$f18e6236bf501d35)(expr).type;
        return $92ca999eabf01e6c$var$JS_LITERALS.includes(type);
    } catch (e) {
        // Catch syntax errors
        return false;
    }
}









function $feef3babead966b4$var$typed(revision, obj) {
    return {
        t: "resheet.note",
        v: revision,
        ...obj
    };
}
function $feef3babead966b4$var$typedTables(revision, obj) {
    return {
        t: "tables.note",
        v: revision,
        ...obj
    };
}
function $feef3babead966b4$export$ab2cd67385eabc81(json, dispatch, env) {
    const dispatchExprResult = $6f23581c0aef6dc2$export$574ac5a1d40355c9({
        type: "expr"
    }, "result", dispatch);
    const dispatchBlockResult = $6f23581c0aef6dc2$export$574ac5a1d40355c9({
        type: "block",
        isInstantiated: false
    }, "result", dispatch);
    const dispatchBlockState = $6f23581c0aef6dc2$export$574ac5a1d40355c9({
        type: "block",
        isInstantiated: true
    }, "state", dispatch);
    return (0, $dc2e80b7ebe4adb5$export$6fc572fe80b0d49c)(json, [
        {
            type: "expr",
            code: (0, $dc2e80b7ebe4adb5$export$22b082955e083ec3)
        },
        ({ code: code })=>{
            const compiled = (0, $e26ee743ff8e9b71$export$c19cabcb7ba30452)(code);
            const result = (0, $e7500bbe9a1dee8a$export$e57bc0d30024f27d)(compiled.run(env), $6f23581c0aef6dc2$export$46fcd87d869db630(dispatchExprResult));
            return {
                type: "expr",
                code: code,
                compiled: compiled,
                result: result
            };
        }
    ], [
        {
            type: "block",
            isInstantiated: true,
            code: (0, $dc2e80b7ebe4adb5$export$22b082955e083ec3),
            state: (0, $dc2e80b7ebe4adb5$export$4154a199d7d90455)
        },
        ({ code: code, state: stateJson })=>{
            const compiled = (0, $e26ee743ff8e9b71$export$c19cabcb7ba30452)(code);
            function setBlockFromResult(result) {
                dispatch(()=>{
                    const value = (0, $e7500bbe9a1dee8a$export$b1f4a9e5cc3a8021)(result);
                    if ($6f23581c0aef6dc2$export$de5a9e42c1dff8da(value)) {
                        const loadedBlock = (0, $b8f588c17e3c1433$export$e255fd3f9a510304)(value);
                        const state = loadedBlock.fromJSON(stateJson, dispatchBlockState, env);
                        return {
                            state: {
                                type: "block",
                                isInstantiated: true,
                                code: code,
                                compiled: compiled,
                                block: loadedBlock,
                                state: state
                            }
                        };
                    }
                    return {
                        state: {
                            type: "block",
                            isInstantiated: false,
                            code: code,
                            compiled: compiled,
                            result: result
                        }
                    };
                });
            }
            const result = (0, $e7500bbe9a1dee8a$export$e57bc0d30024f27d)(compiled.run(env), setBlockFromResult);
            if (result.type === "immediate" && $6f23581c0aef6dc2$export$de5a9e42c1dff8da(result.value)) {
                const loadedBlock = (0, $b8f588c17e3c1433$export$e255fd3f9a510304)(result.value);
                const state = loadedBlock.fromJSON(stateJson, dispatchBlockState, env);
                return {
                    type: "block",
                    isInstantiated: true,
                    code: code,
                    compiled: compiled,
                    block: loadedBlock,
                    state: state
                };
            } else return {
                type: "block",
                isInstantiated: false,
                code: code,
                compiled: compiled,
                result: result,
                loading: stateJson
            };
        }
    ], [
        {
            type: "block",
            isInstantiated: false,
            code: (0, $dc2e80b7ebe4adb5$export$22b082955e083ec3)
        },
        ({ code: code })=>{
            const compiled = (0, $e26ee743ff8e9b71$export$c19cabcb7ba30452)(code);
            const result = (0, $e7500bbe9a1dee8a$export$e57bc0d30024f27d)(compiled.run(env), $6f23581c0aef6dc2$export$46fcd87d869db630(dispatchBlockResult));
            return {
                type: "block",
                isInstantiated: false,
                code: code,
                compiled: compiled,
                result: result
            };
        }
    ], [
        {
            type: "text",
            tag: (0, $dc2e80b7ebe4adb5$export$22b082955e083ec3),
            text: (0, $dc2e80b7ebe4adb5$export$22b082955e083ec3)
        },
        ({ tag: tag, text: text })=>{
            return {
                type: "text",
                tag: tag,
                text: text
            };
        }
    ], [
        {
            type: "checkbox",
            checked: (0, $dc2e80b7ebe4adb5$export$4a21f16c33752377),
            text: (0, $dc2e80b7ebe4adb5$export$22b082955e083ec3)
        },
        ({ checked: checked, text: text })=>{
            return {
                type: "checkbox",
                checked: checked,
                text: text
            };
        }
    ], [
        (0, $dc2e80b7ebe4adb5$export$4154a199d7d90455),
        (json)=>{
            return {
                type: "text",
                tag: "p",
                text: [
                    "Could not load note from JSON:",
                    "```",
                    JSON.stringify(json, undefined, 2),
                    "```"
                ].join("\n")
            };
        }
    ]);
}
const $feef3babead966b4$var$vPre0 = (0, $303c1b51f19a20e4$export$136de4b706fa579)({
    level: (0, $dc2e80b7ebe4adb5$export$98e628dec113755e),
    input: (0, $dc2e80b7ebe4adb5$export$22b082955e083ec3)
}, ({ level: level, input: input })=>(modelFromInput)=>{
        return modelFromInput(level, input);
    });
const $feef3babead966b4$var$vPre1 = (0, $303c1b51f19a20e4$export$471c540adb39cb81)($feef3babead966b4$var$vPre0, {
    schema: {
        level: (0, $dc2e80b7ebe4adb5$export$98e628dec113755e),
        input: (0, $dc2e80b7ebe4adb5$export$22b082955e083ec3),
        interpreted: (0, $dc2e80b7ebe4adb5$export$43f40ad3fa1d5c97)
    },
    parse: ({ level: level, input: input, interpreted: interpreted })=>({ dispatch: dispatch, env: env })=>{
            const dispatchNote = (0, $d0f575b1326e7f91$export$f153e5abd026c378)("note", dispatch);
            const note = $feef3babead966b4$export$ab2cd67385eabc81(interpreted, dispatchNote, env);
            return {
                level: level,
                input: input,
                note: note
            };
        },
    upgrade: (before)=>({ modelFromInput: modelFromInput })=>{
            return before(modelFromInput);
        }
});
const $feef3babead966b4$var$vPre2 = (0, $303c1b51f19a20e4$export$471c540adb39cb81)($feef3babead966b4$var$vPre1, {
    schema: {
        v: 0,
        level: (0, $dc2e80b7ebe4adb5$export$98e628dec113755e),
        input: (0, $dc2e80b7ebe4adb5$export$22b082955e083ec3),
        note: (0, $dc2e80b7ebe4adb5$export$43f40ad3fa1d5c97)
    },
    parse: ({ level: level, input: input, note: noteJson })=>({ dispatch: dispatch, env: env })=>{
            const dispatchNote = (0, $d0f575b1326e7f91$export$f153e5abd026c378)("note", dispatch);
            const note = $feef3babead966b4$export$ab2cd67385eabc81(noteJson, dispatchNote, env);
            return {
                level: level,
                input: input,
                note: note
            };
        },
    upgrade: (before)=>before
});
const $feef3babead966b4$var$v0 = (0, $303c1b51f19a20e4$export$471c540adb39cb81)($feef3babead966b4$var$vPre2, {
    schema: $feef3babead966b4$var$typedTables(0, {
        level: (0, $dc2e80b7ebe4adb5$export$98e628dec113755e),
        input: (0, $dc2e80b7ebe4adb5$export$22b082955e083ec3),
        note: (0, $dc2e80b7ebe4adb5$export$43f40ad3fa1d5c97)
    }),
    parse: ({ level: level, input: input, note: noteJson })=>({ dispatch: dispatch, env: env })=>{
            const dispatchNote = (0, $d0f575b1326e7f91$export$f153e5abd026c378)("note", dispatch);
            const note = $feef3babead966b4$export$ab2cd67385eabc81(noteJson, dispatchNote, env);
            return {
                level: level,
                input: input,
                note: note
            };
        },
    upgrade: (before)=>before
});
const $feef3babead966b4$export$21625637effda04 = (0, $303c1b51f19a20e4$export$471c540adb39cb81)($feef3babead966b4$var$v0, {
    schema: $feef3babead966b4$var$typed(1, {
        level: (0, $dc2e80b7ebe4adb5$export$98e628dec113755e),
        input: (0, $dc2e80b7ebe4adb5$export$22b082955e083ec3),
        note: (0, $dc2e80b7ebe4adb5$export$43f40ad3fa1d5c97)
    }),
    parse: ({ level: level, input: input, note: noteJson })=>({ dispatch: dispatch, env: env })=>{
            const dispatchNote = (0, $d0f575b1326e7f91$export$f153e5abd026c378)("note", dispatch);
            const note = $feef3babead966b4$export$ab2cd67385eabc81(noteJson, dispatchNote, env);
            return {
                level: level,
                input: input,
                note: note
            };
        },
    upgrade: (before)=>before
});
function $feef3babead966b4$export$54fd2c36b5cc6731(state) {
    function noteToJSON(note) {
        switch(note.type){
            case "expr":
                return {
                    type: "expr",
                    code: note.code
                };
            case "block":
                if (note.isInstantiated) return {
                    type: "block",
                    isInstantiated: true,
                    code: note.code,
                    state: note.block.toJSON(note.state)
                };
                else return {
                    type: "block",
                    isInstantiated: false,
                    code: note.code
                };
            case "text":
            case "checkbox":
                return note;
        }
    }
    return $feef3babead966b4$var$typed(1, {
        level: state.level,
        input: state.input,
        note: noteToJSON(state.note)
    });
}


const $8c8e02836b046cc0$var$init = {
    level: 0,
    input: "",
    note: (0, $92ca999eabf01e6c$export$262cb2bb65c22c9)("", $6f23581c0aef6dc2$export$ae0bd03227ec549f, ()=>{})
};
const $8c8e02836b046cc0$export$6c88bf799aca3d2b = $6f23581c0aef6dc2$export$185802fd694ee1f5({
    init: $8c8e02836b046cc0$var$init,
    view ({ env: env, state: state, dispatch: dispatch }, ref) {
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($8c8e02836b046cc0$export$368c4e38f6923143, {
            ref: ref,
            state: state,
            dispatch: dispatch,
            env: env
        });
    },
    recompute (state, dispatch, env, changedVars) {
        return $8c8e02836b046cc0$export$1f297d8d0ce29e3(state, dispatch, env, changedVars);
    },
    getResult (state) {
        switch(state.note.type){
            case "expr":
                return (0, $e7500bbe9a1dee8a$export$b1f4a9e5cc3a8021)(state.note.result);
            case "block":
                if (state.note.isInstantiated) return state.note.block.getResult(state.note.state);
                else return undefined;
            default:
                return state.note;
        }
    },
    fromJSON (json, dispatch, env) {
        return $feef3babead966b4$export$21625637effda04(json)({
            dispatch: dispatch,
            env: env,
            modelFromInput (level, input) {
                const dispatchNote = (0, $d0f575b1326e7f91$export$f153e5abd026c378)("note", dispatch);
                const note = (0, $92ca999eabf01e6c$export$262cb2bb65c22c9)(input, env, dispatchNote);
                return {
                    level: level,
                    input: input,
                    note: note
                };
            }
        });
    },
    toJSON (state) {
        return $feef3babead966b4$export$54fd2c36b5cc6731(state);
    }
});
const $8c8e02836b046cc0$export$368c4e38f6923143 = /*#__PURE__*/ $acw62.forwardRef(function NoteUi({ state: state, dispatch: dispatch, env: env }, ref) {
    const editorRef = $acw62.useRef();
    const blockRef = $acw62.useRef();
    const [isFocused, setFocused] = $acw62.useState(false);
    const completions = (0, $5bd921a18e0690d7$export$f478f6dc019df8a3)(editorRef, (0, $92ca999eabf01e6c$export$9a0a9c75ccef13fb)(state.note) ?? "", env, (0, $92ca999eabf01e6c$export$36e24695f02d4503)(state.note.type, state.input).length);
    $acw62.useEffect(()=>{
        if (isFocused) editorRef.current?.element?.focus();
    }, [
        isFocused,
        editorRef
    ]);
    $acw62.useImperativeHandle(ref, ()=>({
            focus (options) {
                if (state.note.type === "block" && state.note.isInstantiated === true) blockRef.current?.focus(options);
                else setFocused(true);
            }
        }));
    const dispatchNote = $acw62.useMemo(()=>(0, $d0f575b1326e7f91$export$f153e5abd026c378)("note", dispatch), [
        dispatch
    ]);
    const isCode = state.note.type === "expr" || state.note.type === "block" && !state.note.isInstantiated;
    const actions = $acw62.useMemo(()=>$8c8e02836b046cc0$var$ACTIONS(dispatch, blockRef), [
        dispatch,
        blockRef
    ]);
    const shortcutProps = (0, $5bc960417406f657$export$a1ca853c6e4bb6fb)([
        ...isCode ? completions.shortcuts : [],
        ...$8c8e02836b046cc0$var$keybindings(state, actions)
    ]);
    const onUpdateInput = $acw62.useCallback(function onUpdateInput(input) {
        dispatch((state, { env: env })=>({
                state: $8c8e02836b046cc0$export$747b07a192c3db9d(input, state, dispatch, env)
            }));
    }, [
        dispatch
    ]);
    const preventEnter = $acw62.useCallback(function preventEnter(event) {
        if ((0, $777d0014849a8f55$export$ebf72dfe5a040886)(event) === "Enter") event.preventDefault();
        shortcutProps.onKeyDown(event);
    }, [
        shortcutProps.onKeyDown
    ]);
    if (state.note.type === "block" && state.note.isInstantiated === true) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $92ca999eabf01e6c$export$cb90898ed73f4289), {
        ref: blockRef,
        note: state.note,
        dispatch: dispatchNote,
        env: env
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "space-y-1",
        tabIndex: -1,
        style: {
            paddingLeft: 1.5 * state.level + "rem"
        },
        onFocus: (event)=>{
            setFocused(true);
            shortcutProps.onFocus(event);
        },
        onBlur: (event)=>{
            if (!event.currentTarget.contains(event.relatedTarget)) setFocused(false);
            completions.onBlur(event);
            shortcutProps.onBlur(event);
        },
        children: [
            (isFocused || isCode) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($8c8e02836b046cc0$export$9939e67821493b95, {
                ref: editorRef,
                note: state.note,
                code: state.input,
                onUpdate: onUpdateInput,
                ...shortcutProps,
                onKeyDown: preventEnter,
                spellCheck: !isCode,
                className: isCode && "break-all"
            }),
            (!isFocused || isCode) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $92ca999eabf01e6c$export$c1071f579d5374c4), {
                note: state.note,
                env: env,
                actions: actions
            }),
            isCode && completions.ui
        ]
    });
});
function $8c8e02836b046cc0$var$keybindings(state, actions) {
    return [
        {
            description: "Note",
            bindings: [
                [
                    state.note.type === "checkbox" ? [
                        "C-Enter"
                    ] : [],
                    "none",
                    "toggle checkbox",
                    actions.toggleCheckbox
                ],
                [
                    state.note.type === "block" && !state.note.isInstantiated ? [
                        "C-Enter"
                    ] : [],
                    "none",
                    "use this block",
                    actions.instantiateBlock
                ],
                [
                    [
                        [
                            "block",
                            "expr"
                        ].includes(state.note.type) ? "Alt-Tab" : "Tab"
                    ],
                    "none",
                    "indent right",
                    actions.indentRight
                ],
                [
                    [
                        [
                            "block",
                            "expr"
                        ].includes(state.note.type) ? "Shift-Alt-Tab" : "Shift-Tab"
                    ],
                    "none",
                    "indent left",
                    actions.indentLeft
                ]
            ]
        }
    ];
}
function $8c8e02836b046cc0$var$ACTIONS(dispatch, blockRef) {
    return {
        toggleCheckbox () {
            dispatch((state)=>{
                if (state.note.type === "checkbox") return {
                    state: {
                        ...state,
                        input: state.input.replace(/^\[[ xX]?\] /, state.note.checked ? "[ ] " : "[x] "),
                        note: {
                            ...state.note,
                            checked: !state.note.checked
                        }
                    },
                    description: "toggled checkbox"
                };
                return {
                    state: state
                };
            });
        },
        instantiateBlock () {
            dispatch((state, { env: env })=>{
                if (state.note.type !== "block") return {
                    state: state
                };
                if (state.note.isInstantiated === true) return {
                    state: state
                };
                if (state.note.result.type !== "immediate") return {
                    state: state
                };
                if (!$6f23581c0aef6dc2$export$de5a9e42c1dff8da(state.note.result.value)) return {
                    state: state
                };
                const dispatchBlockState = $6f23581c0aef6dc2$export$574ac5a1d40355c9({
                    type: "block",
                    isInstantiated: true
                }, "state", dispatch);
                const value = state.note.result.value;
                const block = (0, $b8f588c17e3c1433$export$eff0252ee3375215)(value) ? value.$$UNSAFE_BLOCK : value;
                let innerState = block.init;
                try {
                    if ("lastState" in state.note) innerState = block.fromJSON(state.note.lastState, dispatchBlockState, env);
                } catch (e) {}
                // Focus the block after React rendered it
                setTimeout(()=>{
                    blockRef.current?.focus();
                });
                return {
                    state: {
                        ...state,
                        note: {
                            type: "block",
                            isInstantiated: true,
                            code: state.note.code,
                            compiled: state.note.compiled,
                            block: (0, $b8f588c17e3c1433$export$e255fd3f9a510304)(block),
                            state: innerState
                        }
                    }
                };
            });
        },
        resetBlock () {
            dispatch((state)=>{
                if (state.note.type !== "block") return {
                    state: state
                };
                if (state.note.isInstantiated === true) return {
                    state: state
                };
                return {
                    state: {
                        ...state,
                        note: (0, $cebde492a88f7762$export$cd7f480d6b8286c3)(state.note, "lastState")
                    }
                };
            });
        },
        indentRight () {
            dispatch((state)=>({
                    state: {
                        ...state,
                        level: state.level + 1
                    }
                }));
        },
        indentLeft () {
            dispatch((state)=>({
                    state: {
                        ...state,
                        level: Math.max(0, state.level - 1)
                    }
                }));
        }
    };
}
function $8c8e02836b046cc0$export$747b07a192c3db9d(input, state, dispatch, env) {
    const note = (0, $92ca999eabf01e6c$export$262cb2bb65c22c9)(input, env, (0, $d0f575b1326e7f91$export$f153e5abd026c378)("note", dispatch), state.note);
    return {
        ...state,
        input: input,
        note: note
    };
}
function $8c8e02836b046cc0$export$1f297d8d0ce29e3(state, dispatch, env, changedVars) {
    const { state: note, invalidated: invalidated } = (0, $92ca999eabf01e6c$export$1ebe6fe895a0083f)(state.note, (0, $d0f575b1326e7f91$export$f153e5abd026c378)("note", dispatch), env, changedVars);
    return {
        state: {
            ...state,
            note: note
        },
        invalidated: invalidated
    };
}
const $8c8e02836b046cc0$export$9939e67821493b95 = /*#__PURE__*/ $acw62.forwardRef(function NoteEditor({ note: note, code: code, onKeyDown: onKeyDown, className: className, ...props }, ref) {
    const [style, editorClassName, language] = $8c8e02836b046cc0$var$editorStyle(note);
    const ignoreEmptyBackspace = (0, $ff99259e85546794$export$1a8b1350915fe2e0)(function ignoreEmptyBackspace(event) {
        if (event.key === "Backspace" && code.length === 0) event.preventDefault();
        onKeyDown?.(event);
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "relative group/note-editor",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "float-end mt-1",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($8c8e02836b046cc0$var$NoteTypeIndicator, {
                    noteType: note.type
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cb8a0fe0beecb480$export$b7127187684f7150), {
                ref: ref,
                code: code,
                language: language,
                container: "div",
                className: `whitespace-pre-wrap outline-none ${editorClassName} ${className}`,
                style: style,
                onKeyDown: ignoreEmptyBackspace,
                ...props
            })
        ]
    });
});
function $8c8e02836b046cc0$var$NoteTypeIndicator({ noteType: noteType }) {
    switch(noteType){
        case "block":
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "text-xs rounded px-1 bg-sky-400 opacity-25 group-focus-within/note-editor:opacity-100 text-white cursor-default overflow-clip",
                children: "block"
            });
        case "expr":
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "bg-amber-300 opacity-25 group-focus-within/note-editor:opacity-100 text-white w-4 h-4 rounded text-center font-bold cursor-default overflow-clip",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "inline-block translate-y-[-.34rem]",
                    children: "="
                })
            });
        default:
            return null;
    }
}
const $8c8e02836b046cc0$var$codeStyle = {
    fontFamily: 'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace'
};
function $8c8e02836b046cc0$var$editorStyle(note) {
    switch(note.type){
        case "expr":
            return [
                $8c8e02836b046cc0$var$codeStyle,
                "",
                "jsx"
            ];
        case "block":
            return [
                $8c8e02836b046cc0$var$codeStyle,
                "",
                "jsx"
            ];
        case "text":
            return [
                {},
                (0, $92ca999eabf01e6c$export$660145e999f4eb16)[note.tag] ?? "",
                "markdown"
            ];
        case "checkbox":
            return [
                {},
                "",
                "markdown"
            ];
    }
}


var $593647a8a274cddc$exports = {};

$parcel$export($593647a8a274cddc$exports, "LoadFile", () => $593647a8a274cddc$export$59daebe6f5c4b354);


var $acw62 = parcelRequire("acw62");




const $593647a8a274cddc$export$59daebe6f5c4b354 = $6f23581c0aef6dc2$export$185802fd694ee1f5({
    init: {
        state: "init"
    },
    view ({ state: state, dispatch: dispatch }, ref) {
        const loadRef = $acw62.useRef();
        $acw62.useImperativeHandle(ref, ()=>({
                focus (options) {
                    loadRef.current?.focus(options);
                }
            }), [
            loadRef
        ]);
        const loadFileButtonStyle = `
            m-0.5 px-1
            rounded border border-gray-200
            text-gray-700
            bg-gray-100 hover:bg-gray-200
        `;
        async function loadFile(file) {
            const buffer = await file.arrayBuffer();
            const content = (0, $512ec8d668819b2f$export$36bac84b1c2da9c7)(new Uint8Array(buffer));
            dispatch(()=>({
                    state: {
                        state: "loaded",
                        file: file,
                        content: content
                    },
                    description: "loaded file into block"
                }));
        }
        function downloadFile(file) {
            (0, $777d0014849a8f55$export$e620933a198f7bc)(file.name, file);
        }
        function clear() {
            dispatch(()=>({
                    state: {
                        state: "init"
                    },
                    description: "cleared file block"
                }));
        }
        switch(state.state){
            case "init":
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $777d0014849a8f55$export$b346deb0efaa17bd), {
                    ref: loadRef,
                    className: loadFileButtonStyle,
                    onLoad: loadFile,
                    children: "Load File"
                });
            case "loaded":
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    children: [
                        "File ",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            className: "px-1 bg-gray-100 rounded-sm",
                            onClick: ()=>downloadFile(state.file),
                            children: state.file.name
                        }),
                        " ",
                        "loaded ",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                            className: "text-sm text-gray-700",
                            children: [
                                "(",
                                state.file.size,
                                " bytes)"
                            ]
                        }),
                        " ",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $777d0014849a8f55$export$b346deb0efaa17bd), {
                            ref: loadRef,
                            className: loadFileButtonStyle,
                            onLoad: loadFile,
                            children: "change"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            className: "m-0.5 px-1 rounded border border-red-100 text-red-700 hover:bg-red-100",
                            onClick: clear,
                            children: "clear"
                        })
                    ]
                });
        }
    },
    recompute (state, dispatch, env) {
        return {
            state: state,
            invalidated: false
        };
    },
    getResult (state) {
        switch(state.state){
            case "init":
                return null;
            case "loaded":
                return state.file;
        }
    },
    fromJSON (json, dispatch, env) {
        return (0, $dc2e80b7ebe4adb5$export$6fc572fe80b0d49c)(json, [
            (0, $dc2e80b7ebe4adb5$export$226b3eccf92c9ed9)(null),
            ()=>({
                    state: "init"
                })
        ], [
            (0, $dc2e80b7ebe4adb5$export$22b082955e083ec3),
            (textContent)=>{
                const uint8Array = new TextEncoder().encode(textContent);
                const content = (0, $512ec8d668819b2f$export$36bac84b1c2da9c7)(uint8Array);
                return {
                    state: "loaded",
                    file: new File([
                        uint8Array
                    ], "<unknown>"),
                    content: content
                };
            }
        ], [
            {
                state: "init"
            },
            (init)=>init
        ], [
            {
                state: "loaded",
                content: (0, $dc2e80b7ebe4adb5$export$22b082955e083ec3),
                filename: (0, $dc2e80b7ebe4adb5$export$22b082955e083ec3)
            },
            ({ content: content, filename: filename })=>{
                const uint8Array = new TextEncoder().encode(content);
                return {
                    state: "loaded",
                    file: new File([
                        uint8Array
                    ], filename),
                    content: content
                };
            }
        ], [
            {
                state: "loaded",
                file: {
                    content: (0, $dc2e80b7ebe4adb5$export$22b082955e083ec3),
                    name: (0, $dc2e80b7ebe4adb5$export$22b082955e083ec3),
                    options: {
                        type: (0, $dc2e80b7ebe4adb5$export$22b082955e083ec3),
                        lastModified: (0, $dc2e80b7ebe4adb5$export$98e628dec113755e)
                    }
                }
            },
            ({ file: { content: content, name: name, options: { type: type, lastModified: lastModified } } })=>{
                const uint8Array = (0, $512ec8d668819b2f$export$f01069a3c307e50e)(content);
                return {
                    state: "loaded",
                    file: new File([
                        uint8Array
                    ], name, {
                        type: type,
                        lastModified: lastModified
                    }),
                    content: content
                };
            }
        ], [
            (0, $dc2e80b7ebe4adb5$export$4154a199d7d90455),
            ()=>({
                    state: "init"
                })
        ]);
    },
    toJSON (state) {
        switch(state.state){
            case "init":
                return {
                    state: "init"
                };
            case "loaded":
                return {
                    state: "loaded",
                    file: {
                        content: state.content,
                        name: state.file.name,
                        options: {
                            type: state.file.type,
                            lastModified: state.file.lastModified
                        }
                    }
                };
        }
    }
});


var $73f95362102603c2$exports = {};

$parcel$export($73f95362102603c2$exports, "Inspect", () => $73f95362102603c2$export$d1a121333e17a5bb);
$parcel$export($73f95362102603c2$exports, "InterceptDispatch", () => $73f95362102603c2$export$b6b5377997ba9324);
$parcel$export($73f95362102603c2$exports, "Record", () => $73f95362102603c2$export$5b163c6d120341e7);


function $73f95362102603c2$export$d1a121333e17a5bb(block) {
    return $6f23581c0aef6dc2$export$185802fd694ee1f5({
        init: block.init,
        view: block.view,
        fromJSON: block.fromJSON,
        toJSON: block.toJSON,
        recompute: block.recompute,
        getResult (state) {
            return {
                block: block,
                state: state,
                result: block.getResult(state),
                derivedBlock: {
                    ...block,
                    init: state
                }
            };
        }
    });
}
function $73f95362102603c2$export$b6b5377997ba9324(block, intercept) {
    function interceptedDispatcher(dispatch) {
        return function interceptedDispatch(action) {
            dispatch((state, context)=>{
                const { state: newState, ...output } = action(state, context);
                return {
                    state: intercept(state, context, newState),
                    ...output
                };
            });
        };
    }
    return $6f23581c0aef6dc2$export$185802fd694ee1f5({
        init: block.init,
        view ({ state: state, dispatch: dispatch, env: env }, ref) {
            return block.view({
                ref: ref,
                state: state,
                dispatch: interceptedDispatcher(dispatch),
                env: env
            });
        },
        fromJSON (json, dispatch, env) {
            return block.fromJSON(json, interceptedDispatcher(dispatch), env);
        },
        toJSON: block.toJSON,
        recompute (state, dispatch, env, changed) {
            return block.recompute(state, interceptedDispatcher(dispatch), env, changed);
        },
        getResult: block.getResult
    });
}
function $73f95362102603c2$export$5b163c6d120341e7(block) {
    return $6f23581c0aef6dc2$export$185802fd694ee1f5({
        init: {
            past: [],
            now: block.init
        },
        view ({ state: state, dispatch: dispatch, env: env }, ref) {
            const dispatchNow = (0, $d0f575b1326e7f91$export$f153e5abd026c378)("now", dispatch);
            return block.view({
                state: state.now,
                dispatch: dispatchNow,
                env: env,
                ref: ref
            });
        },
        fromJSON (json, dispatch, env) {
            const dispatchNow = (0, $d0f575b1326e7f91$export$f153e5abd026c378)("now", dispatch);
            return {
                past: [],
                now: block.fromJSON(json, dispatchNow, env)
            };
        },
        toJSON (state) {
            return block.toJSON(state.now);
        },
        recompute (state, dispatch, env, changed) {
            const dispatchNow = (0, $d0f575b1326e7f91$export$f153e5abd026c378)("now", dispatch);
            const { state: newState, invalidated: invalidated } = block.recompute(state.now, dispatchNow, env, changed);
            return {
                state: {
                    past: [
                        ...state.past,
                        state.now
                    ],
                    now: newState
                },
                invalidated: invalidated
            };
        },
        getResult (state) {
            return {
                ...state,
                result: block.getResult(state.now)
            };
        }
    });
}


var $bb21728c877b3db6$exports = {};

$parcel$export($bb21728c877b3db6$exports, "WithEnv", () => $bb21728c877b3db6$export$61c72fb6d33db6bb);

function $bb21728c877b3db6$export$61c72fb6d33db6bb(changeEnv, block) {
    function changeDispatchEnv(dispatch) {
        return function dispatchChangedEnv(action) {
            dispatch((state, { env: env })=>action(state, {
                    env: changeEnv(env)
                }));
        };
    }
    return $6f23581c0aef6dc2$export$185802fd694ee1f5({
        init: block.init,
        view ({ state: state, dispatch: dispatch, env: env }, ref) {
            return block.view({
                state: state,
                ref: ref,
                dispatch: changeDispatchEnv(dispatch),
                env: changeEnv(env)
            });
        },
        fromJSON (json, dispatch, env) {
            return block.fromJSON(json, changeDispatchEnv(dispatch), changeEnv(env));
        },
        toJSON: block.toJSON,
        getResult: block.getResult,
        recompute (state, dispatch, env, changed) {
            return block.recompute(state, changeDispatchEnv(dispatch), changeEnv(env), changed);
        }
    });
}


const $285e49985e5a39fa$export$d15f4cd5286f9b1e = (blocks)=>(0, $3cde51ebcb63af9c$export$7ddf129dd8d5219f)("Note", (0, $8c8e02836b046cc0$export$6c88bf799aca3d2b), blocks);
const $285e49985e5a39fa$export$a9bf29f8d87ebbee = (blocks)=>(0, $2874ceca92f8bd68$export$8edc1c3b6e3ca47c)($285e49985e5a39fa$export$d15f4cd5286f9b1e(blocks));
$parcel$exportWildcard($285e49985e5a39fa$exports, $593647a8a274cddc$exports);





















var $72a6f9babb1bcec7$exports = {};

$parcel$export($72a6f9babb1bcec7$exports, "gatherDocs", () => $72a6f9babb1bcec7$export$3849b92fb7e12a24);
var $52e131b359010c40$exports = {};

$parcel$defineInteropFlag($52e131b359010c40$exports);

$parcel$export($52e131b359010c40$exports, "default", () => $52e131b359010c40$export$2e2bcd8739ae039);



var $27260dd5184212ee$export$2e2bcd8739ae039 = {
    "aggregateerror": {
        "aggregateerror": {
            "index.md": '---\ntitle: AggregateError() constructor\nslug: Web/JavaScript/Reference/Global_Objects/AggregateError/AggregateError\npage-type: javascript-constructor\nbrowser-compat: javascript.builtins.AggregateError.AggregateError\n---\n\n{{JSRef}}\n\nThe **`AggregateError()`** constructor creates {{jsxref("AggregateError")}} objects.\n\n## Syntax\n\n```js-nolint\nnew AggregateError(errors)\nnew AggregateError(errors, message)\nnew AggregateError(errors, message, options)\n\nAggregateError(errors)\nAggregateError(errors, message)\nAggregateError(errors, message, options)\n```\n\n> **Note:** `AggregateError()` can be called with or without [`new`](/en-US/docs/Web/JavaScript/Reference/Operators/new). Both create a new `AggregateError` instance.\n\n### Parameters\n\n- `errors`\n  - : An iterable of errors, may not actually be {{jsxref("Error")}} instances.\n- `message` {{optional_inline}}\n  - : An optional human-readable description of the aggregate error.\n- `options` {{optional_inline}}\n  - : An object that has the following properties:\n    - `cause` {{optional_inline}}\n      - : A property indicating the specific cause of the error.\n        When catching and re-throwing an error with a more-specific or useful error message, this property can be used to pass the original error.\n\n## Examples\n\n### Creating an AggregateError\n\n```js\ntry {\n  throw new AggregateError([new Error("some error")], "Hello");\n} catch (e) {\n  console.log(e instanceof AggregateError); // true\n  console.log(e.message); // "Hello"\n  console.log(e.name); // "AggregateError"\n  console.log(e.errors); // [ Error: "some error" ]\n}\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `AggregateError` in `core-js`](https://github.com/zloirock/core-js#ecmascript-promise)\n- {{jsxref("Promise.any")}}\n'
        },
        "errors": {
            "index.md": '---\ntitle: "AggregateError: errors"\nslug: Web/JavaScript/Reference/Global_Objects/AggregateError/errors\npage-type: javascript-instance-data-property\nbrowser-compat: javascript.builtins.AggregateError.errors\n---\n\n{{JSRef}}\n\nThe **`errors`** data property of an {{jsxref("AggregateError")}} instance contains an array representing the errors that were aggregated.\n\n## Value\n\nAn {{jsxref("Array")}} containing values in the same order as the iterable passed as the first argument of the {{jsxref("AggregateError/AggregateError", "AggregateError()")}} constructor.\n\n{{js_property_attributes(1, 0, 1)}}\n\n## Examples\n\n### Using errors\n\n```js\ntry {\n  throw new AggregateError(\n    // An iterable of errors\n    new Set([new Error("some error"), new Error("another error")]),\n    "Multiple errors thrown",\n  );\n} catch (err) {\n  console.log(err.errors);\n  // [\n  //   Error: some error,\n  //   Error: another error\n  // ]\n}\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Control flow and error handling](/en-US/docs/Web/JavaScript/Guide/Control_flow_and_error_handling) guide\n- {{jsxref("AggregateError")}}\n- [`Error`: `cause`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error/cause)\n'
        },
        "index.md": '---\ntitle: AggregateError\nslug: Web/JavaScript/Reference/Global_Objects/AggregateError\npage-type: javascript-class\nbrowser-compat: javascript.builtins.AggregateError\n---\n\n{{JSRef}}\n\nThe **`AggregateError`** object represents an error when several errors need to be wrapped in a single error. It is thrown when multiple errors need to be reported by an operation, for example by {{jsxref("Promise.any()")}}, when all promises passed to it reject.\n\n`AggregateError` is a subclass of {{jsxref("Error")}}.\n\n## Constructor\n\n- {{jsxref("AggregateError/AggregateError", "AggregateError()")}}\n  - : Creates a new `AggregateError` object.\n\n## Instance properties\n\n_Also inherits instance properties from its parent {{jsxref("Error")}}_.\n\nThese properties are defined on `AggregateError.prototype` and shared by all `AggregateError` instances.\n\n- {{jsxref("Object/constructor", "AggregateError.prototype.constructor")}}\n  - : The constructor function that created the instance object. For `AggregateError` instances, the initial value is the {{jsxref("AggregateError/AggregateError", "AggregateError")}} constructor.\n- {{jsxref("Error/name", "AggregateError.prototype.name")}}\n  - : Represents the name for the type of error. For `AggregateError.prototype.name`, the initial value is `"AggregateError"`.\n\nThese properties are own properties of each `AggregateError` instance.\n\n- {{jsxref("AggregateError/errors", "errors")}}\n  - : An array representing the errors that were aggregated.\n\n## Instance methods\n\n_Inherits instance methods from its parent {{jsxref("Error")}}_.\n\n## Examples\n\n### Catching an AggregateError\n\n```js\nPromise.any([Promise.reject(new Error("some error"))]).catch((e) => {\n  console.log(e instanceof AggregateError); // true\n  console.log(e.message); // "All Promises rejected"\n  console.log(e.name); // "AggregateError"\n  console.log(e.errors); // [ Error: "some error" ]\n});\n```\n\n### Creating an AggregateError\n\n```js\ntry {\n  throw new AggregateError([new Error("some error")], "Hello");\n} catch (e) {\n  console.log(e instanceof AggregateError); // true\n  console.log(e.message); // "Hello"\n  console.log(e.name); // "AggregateError"\n  console.log(e.errors); // [ Error: "some error" ]\n}\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `AggregateError` in `core-js`](https://github.com/zloirock/core-js#ecmascript-promise)\n- {{jsxref("Error")}}\n- {{jsxref("Promise.any")}}\n'
    },
    "array": {
        "@@iterator": {
            "index.md": '---\ntitle: Array.prototype[@@iterator]()\nslug: Web/JavaScript/Reference/Global_Objects/Array/@@iterator\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Array.@@iterator\n---\n\n{{JSRef}}\n\nThe **`[@@iterator]()`** method of {{jsxref("Array")}} instances implements the [iterable protocol](/en-US/docs/Web/JavaScript/Reference/Iteration_protocols) and allows arrays to be consumed by most syntaxes expecting iterables, such as the [spread syntax](/en-US/docs/Web/JavaScript/Reference/Operators/Spread_syntax) and {{jsxref("Statements/for...of", "for...of")}} loops. It returns an [array iterator object](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Iterator) that yields the value of each index in the array.\n\nThe initial value of this property is the same function object as the initial value of the {{jsxref("Array.prototype.values")}} property.\n\n{{EmbedInteractiveExample("pages/js/array-prototype-@@iterator.html")}}\n\n## Syntax\n\n```js-nolint\narray[Symbol.iterator]()\n```\n\n### Parameters\n\nNone.\n\n### Return value\n\nThe same return value as {{jsxref("Array.prototype.values()")}}: a new [iterable iterator object](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Iterator) that yields the value of each index in the array.\n\n## Examples\n\n### Iteration using for...of loop\n\nNote that you seldom need to call this method directly. The existence of the `@@iterator` method makes arrays [iterable](/en-US/docs/Web/JavaScript/Reference/Iteration_protocols#the_iterable_protocol), and iterating syntaxes like the `for...of` loop automatically call this method to obtain the iterator to loop over.\n\n#### HTML\n\n```html\n<ul id="letterResult"></ul>\n```\n\n#### JavaScript\n\n```js\nconst arr = ["a", "b", "c"];\nconst letterResult = document.getElementById("letterResult");\nfor (const letter of arr) {\n  const li = document.createElement("li");\n  li.textContent = letter;\n  letterResult.appendChild(li);\n}\n```\n\n#### Result\n\n{{EmbedLiveSample("Iteration_using_for...of_loop", "", "")}}\n\n### Manually hand-rolling the iterator\n\nYou may still manually call the `next()` method of the returned iterator object to achieve maximum control over the iteration process.\n\n```js\nconst arr = ["a", "b", "c", "d", "e"];\nconst arrIter = arr[Symbol.iterator]();\nconsole.log(arrIter.next().value); // a\nconsole.log(arrIter.next().value); // b\nconsole.log(arrIter.next().value); // c\nconsole.log(arrIter.next().value); // d\nconsole.log(arrIter.next().value); // e\n```\n\n### Handling strings and string arrays with the same function\n\nBecause both [strings](/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/@@iterator) and arrays implement the iterable protocol, a generic function can be designed to handle both inputs in the same fashion. This is better than calling {{jsxref("Array.prototype.values()")}} directly, which requires the input to be an array, or at least an object with such a method.\n\n```js\nfunction logIterable(it) {\n  if (typeof it[Symbol.iterator] !== "function") {\n    console.log(it, "is not iterable.");\n    return;\n  }\n  for (const letter of it) {\n    console.log(letter);\n  }\n}\n\n// Array\nlogIterable(["a", "b", "c"]);\n// a\n// b\n// c\n\n// String\nlogIterable("abc");\n// a\n// b\n// c\n\n// Number\nlogIterable(123);\n// 123 is not iterable.\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Array.prototype[@@iterator]` in `core-js`](https://github.com/zloirock/core-js#ecmascript-array)\n- [Indexed collections](/en-US/docs/Web/JavaScript/Guide/Indexed_collections) guide\n- {{jsxref("Array")}}\n- {{jsxref("Array.prototype.keys()")}}\n- {{jsxref("Array.prototype.entries()")}}\n- {{jsxref("Array.prototype.values()")}}\n- [`TypedArray.prototype[@@iterator]()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/TypedArray/@@iterator)\n- [`String.prototype[@@iterator]()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/@@iterator)\n- {{jsxref("Symbol.iterator")}}\n- [Iteration protocols](/en-US/docs/Web/JavaScript/Reference/Iteration_protocols)\n'
        },
        "@@species": {
            "index.md": "---\ntitle: Array[@@species]\nslug: Web/JavaScript/Reference/Global_Objects/Array/@@species\npage-type: javascript-static-accessor-property\nbrowser-compat: javascript.builtins.Array.@@species\n---\n\n{{JSRef}}\n\nThe **`Array[@@species]`** static accessor property returns the constructor used to construct return values from array methods.\n\n> **Warning:** The existence of `@@species` allows execution of arbitrary code and may create security vulnerabilities. It also makes certain optimizations much harder. Engine implementers are [investigating whether to remove this feature](https://github.com/tc39/proposal-rm-builtin-subclassing). Avoid relying on it if possible. Modern array methods, such as {{jsxref(\"Array/toReversed\", \"toReversed()\")}}, do not use `@@species` and always return a new `Array` base class instance.\n\n## Syntax\n\n```js-nolint\nArray[Symbol.species]\n```\n\n### Return value\n\nThe value of the constructor (`this`) on which `get @@species` was called. The return value is used to construct return values from array methods that create new arrays.\n\n## Description\n\nThe `@@species` accessor property returns the default constructor for `Array` objects. Subclass constructors may override it to change the constructor assignment. The default implementation is basically:\n\n```js\n// Hypothetical underlying implementation for illustration\nclass Array {\n  static get [Symbol.species]() {\n    return this;\n  }\n}\n```\n\nBecause of this polymorphic implementation, `@@species` of derived subclasses would also return the constructor itself by default.\n\n```js\nclass SubArray extends Array {}\nSubArray[Symbol.species] === SubArray; // true\n```\n\nWhen calling array methods that do not mutate the existing array but return a new array instance (for example, [`filter()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/filter) and [`map()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/map)), the array's `constructor[@@species]` will be accessed. The returned constructor will be used to construct the return value of the array method. This makes it technically possible to make array methods return objects unrelated to arrays.\n\n```js\nclass NotAnArray {\n  constructor(length) {\n    this.length = length;\n  }\n}\n\nconst arr = [0, 1, 2];\narr.constructor = { [Symbol.species]: NotAnArray };\narr.map((i) => i); // NotAnArray { '0': 0, '1': 1, '2': 2, length: 3 }\narr.filter((i) => i); // NotAnArray { '0': 1, '1': 2, length: 0 }\narr.concat([1, 2]); // NotAnArray { '0': 0, '1': 1, '2': 2, '3': 1, '4': 2, length: 5 }\n```\n\n## Examples\n\n### Species in ordinary objects\n\nThe `@@species` property returns the default constructor function, which is the `Array` constructor for `Array`.\n\n```js\nArray[Symbol.species]; // [Function: Array]\n```\n\n### Species in derived objects\n\nIn an instance of a custom `Array` subclass, such as `MyArray`, the `MyArray` species is the `MyArray` constructor. However, you might want to overwrite this, in order to return parent `Array` objects in your derived class methods:\n\n```js\nclass MyArray extends Array {\n  // Overwrite MyArray species to the parent Array constructor\n  static get [Symbol.species]() {\n    return Array;\n  }\n}\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Array[@@species]` and support of `@@species` in all affected `Array` methods in `core-js`](https://github.com/zloirock/core-js#ecmascript-array)\n- [Indexed collections](/en-US/docs/Web/JavaScript/Guide/Indexed_collections) guide\n- {{jsxref(\"Array\")}}\n- {{jsxref(\"Symbol.species\")}}\n"
        },
        "@@unscopables": {
            "index.md": '---\ntitle: Array.prototype[@@unscopables]\nslug: Web/JavaScript/Reference/Global_Objects/Array/@@unscopables\npage-type: javascript-instance-data-property\nbrowser-compat: javascript.builtins.Array.@@unscopables\n---\n\n{{JSRef}}\n\nThe **`@@unscopables`** data property of `Array.prototype` is shared by all {{jsxref("Array")}} instances. It contains property names that were not included in the ECMAScript standard prior to the ES2015 version and that are ignored for [`with`](/en-US/docs/Web/JavaScript/Reference/Statements/with) statement-binding purposes.\n\n## Value\n\nA [`null`-prototype object](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object#null-prototype_objects) with property names given below and their values set to `true`.\n\n{{js_property_attributes(0, 0, 1)}}\n\n## Description\n\nThe default `Array` properties that are ignored for `with` statement-binding purposes are:\n\n- [`at()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/at)\n- [`copyWithin()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/copyWithin)\n- [`entries()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/entries)\n- [`fill()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/fill)\n- [`find()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/find)\n- [`findIndex()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/findIndex)\n- [`findLast()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/findLast)\n- [`findLastIndex()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/findLastIndex)\n- [`flat()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/flat)\n- [`flatMap()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/flatMap)\n- [`includes()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/includes)\n- [`keys()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/keys)\n- [`toReversed()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/toReversed)\n- [`toSorted()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/toSorted)\n- [`toSpliced()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/toSpliced)\n- [`values()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/values)\n\n`Array.prototype[@@unscopables]` is an empty object only containing all the above property names with the value `true`. Its [prototype is `null`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object#null-prototype_objects), so `Object.prototype` properties like [`toString`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/toString) won\'t accidentally be made unscopable, and a `toString()` within the `with` statement will continue to be called on the array.\n\nSee {{jsxref("Symbol.unscopables")}} for how to set unscopable properties for your own objects.\n\n## Examples\n\nImagine the `keys.push(\'something\')` call below is in code that was written prior to ECMAScript 2015.\n\n```js\nvar keys = [];\n\nwith (Array.prototype) {\n  keys.push("something");\n}\n```\n\nWhen ECMAScript 2015 introduced the {{jsxref("Array.prototype.keys()")}} method, if the `@@unscopables` data property had not also been introduced, that `keys.push(\'something\')` call would break \u2014 because the JavaScript runtime would have interpreted `keys` as being the {{jsxref("Array.prototype.keys()")}} method, rather than the `keys` array defined in the example code.\n\nSo the `@@unscopables` data property for `Array.prototype` causes the `Array` properties introduced in ECMAScript 2015 to be ignored for `with` statement-binding purposes \u2014 allowing code that was written prior to ECMAScript 2015 to continue working as expected, rather than breaking.\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Array.prototype[@@unscopables]` in `core-js`](https://github.com/zloirock/core-js#ecmascript-array)\n- [Indexed collections](/en-US/docs/Web/JavaScript/Guide/Indexed_collections) guide\n- {{jsxref("Array")}}\n- {{jsxref("Statements/with", "with")}}\n- {{jsxref("Symbol.unscopables")}}\n'
        },
        "array": {
            "index.md": '---\ntitle: Array() constructor\nslug: Web/JavaScript/Reference/Global_Objects/Array/Array\npage-type: javascript-constructor\nbrowser-compat: javascript.builtins.Array.Array\n---\n\n{{JSRef}}\n\nThe **`Array()`** constructor creates {{jsxref("Array")}} objects.\n\n## Syntax\n\n```js-nolint\nnew Array()\nnew Array(element1)\nnew Array(element1, element2)\nnew Array(element1, element2, /* \u2026, */ elementN)\nnew Array(arrayLength)\n\nArray()\nArray(element1)\nArray(element1, element2)\nArray(element1, element2, /* \u2026, */ elementN)\nArray(arrayLength)\n```\n\n> **Note:** `Array()` can be called with or without [`new`](/en-US/docs/Web/JavaScript/Reference/Operators/new). Both create a new `Array` instance.\n\n### Parameters\n\n- `element1`, \u2026, `elementN`\n  - : A JavaScript array is initialized with the given elements, except in the case where\n    a single argument is passed to the `Array` constructor and that argument is\n    a number (see the `arrayLength` parameter below). Note that this special case only\n    applies to JavaScript arrays created with the `Array` constructor, not\n    array literals created with the square bracket syntax.\n- `arrayLength`\n  - : If the only argument passed to the `Array` constructor is an integer\n    between 0 and 2<sup>32</sup> - 1 (inclusive), this returns a new JavaScript array with\n    its `length` property set to that number (**Note:** this\n    implies an array of `arrayLength` empty slots, not slots with actual\n    `undefined` values \u2014 see [sparse arrays](/en-US/docs/Web/JavaScript/Guide/Indexed_collections#sparse_arrays)).\n\n### Exceptions\n\n- {{jsxref("RangeError")}}\n  - : Thrown if there\'s only one argument (`arrayLength`) that is a number, but its value is not an integer or not between 0 and 2<sup>32</sup> - 1 (inclusive).\n\n## Examples\n\n### Array literal notation\n\nArrays can be created using the [literal](/en-US/docs/Web/JavaScript/Guide/Grammar_and_types#array_literals)\nnotation:\n\n```js\nconst fruits = ["Apple", "Banana"];\n\nconsole.log(fruits.length); // 2\nconsole.log(fruits[0]); // "Apple"\n```\n\n### Array constructor with a single parameter\n\nArrays can be created using a constructor with a single number parameter. An array is created with\nits `length` property set to that number, and the array elements are empty\nslots.\n\n```js\nconst arrayEmpty = new Array(2);\n\nconsole.log(arrayEmpty.length); // 2\nconsole.log(arrayEmpty[0]); // undefined; actually, it is an empty slot\nconsole.log(0 in arrayEmpty); // false\nconsole.log(1 in arrayEmpty); // false\n```\n\n```js\nconst arrayOfOne = new Array("2"); // Not the number 2 but the string "2"\n\nconsole.log(arrayOfOne.length); // 1\nconsole.log(arrayOfOne[0]); // "2"\n```\n\n### Array constructor with multiple parameters\n\nIf more than one argument is passed to the constructor, a new {{jsxref("Array")}} with\nthe given elements is created.\n\n```js\nconst fruits = new Array("Apple", "Banana");\n\nconsole.log(fruits.length); // 2\nconsole.log(fruits[0]); // "Apple"\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Indexed collections](/en-US/docs/Web/JavaScript/Guide/Indexed_collections) guide\n- {{jsxref("Array")}}\n'
        },
        "at": {
            "index.md": '---\ntitle: Array.prototype.at()\nslug: Web/JavaScript/Reference/Global_Objects/Array/at\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Array.at\n---\n\n{{JSRef}}\n\nThe **`at()`** method of {{jsxref("Array")}} instances takes an integer value and returns the item at that index, allowing for positive and negative integers. Negative integers count back from the last item in the array.\n\n{{EmbedInteractiveExample("pages/js/array-at.html")}}\n\n## Syntax\n\n```js-nolint\nat(index)\n```\n\n### Parameters\n\n- `index`\n  - : Zero-based index of the array element to be returned, [converted to an integer](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number#integer_conversion). Negative index counts back from the end of the array \u2014 if `index < 0`, `index + array.length` is accessed.\n\n### Return value\n\nThe element in the array matching the given index. Always returns {{jsxref("undefined")}} if `index < -array.length` or `index >= array.length` without attempting to access the corresponding property.\n\n## Description\n\nThe `at()` method is equivalent to the bracket notation when `index` is non-negative. For example, `array[0]` and `array.at(0)` both return the first item. However, when counting elements from the end of the array, you cannot use `array[-1]` like you may in Python or R, because all values inside the square brackets are treated literally as string properties, so you will end up reading `array["-1"]`, which is just a normal string property instead of an array index.\n\nThe usual practice is to access {{jsxref("Array/length", "length")}} and calculate the index from that \u2014 for example, `array[array.length - 1]`. The `at()` method allows relative indexing, so this can be shortened to `array.at(-1)`.\n\nBy combining `at()` with {{jsxref("Array/with", "with()")}}, you can both read and write (respectively) an array using negative indices.\n\nThe `at()` method is [generic](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array#generic_array_methods). It only expects the `this` value to have a `length` property and integer-keyed properties.\n\n## Examples\n\n### Return the last value of an array\n\nThe following example provides a function which returns the last element found in a specified array.\n\n```js\n// Our array with items\nconst cart = ["apple", "banana", "pear"];\n\n// A function which returns the last item of a given array\nfunction returnLast(arr) {\n  return arr.at(-1);\n}\n\n// Get the last item of our array \'cart\'\nconst item1 = returnLast(cart);\nconsole.log(item1); // \'pear\'\n\n// Add an item to our \'cart\' array\ncart.push("orange");\nconst item2 = returnLast(cart);\nconsole.log(item2); // \'orange\'\n```\n\n### Comparing methods\n\nThis example compares different ways to select the penultimate (last but one) item of an {{jsxref("Array")}}. While all the methods shown below are valid, this example highlights the succinctness and readability of the `at()` method.\n\n```js\n// Our array with items\nconst colors = ["red", "green", "blue"];\n\n// Using length property\nconst lengthWay = colors[colors.length - 2];\nconsole.log(lengthWay); // \'green\'\n\n// Using slice() method. Note an array is returned\nconst sliceWay = colors.slice(-2, -1);\nconsole.log(sliceWay[0]); // \'green\'\n\n// Using at() method\nconst atWay = colors.at(-2);\nconsole.log(atWay); // \'green\'\n```\n\n### Calling at() on non-array objects\n\nThe `at()` method reads the `length` property of `this` and calculates the index to access.\n\n```js\nconst arrayLike = {\n  length: 2,\n  0: "a",\n  1: "b",\n  2: "c", // ignored by at() since length is 2\n};\nconsole.log(Array.prototype.at.call(arrayLike, 0)); // "a"\nconsole.log(Array.prototype.at.call(arrayLike, 2)); // undefined\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Array.prototype.at` in `core-js`](https://github.com/zloirock/core-js#relative-indexing-method)\n- [Indexed collections](/en-US/docs/Web/JavaScript/Guide/Indexed_collections) guide\n- {{jsxref("Array")}}\n- {{jsxref("Array.prototype.findIndex()")}}\n- {{jsxref("Array.prototype.indexOf()")}}\n- {{jsxref("Array.prototype.with()")}}\n- {{jsxref("TypedArray.prototype.at()")}}\n- {{jsxref("String.prototype.at()")}}\n'
        },
        "concat": {
            "index.md": '---\ntitle: Array.prototype.concat()\nslug: Web/JavaScript/Reference/Global_Objects/Array/concat\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Array.concat\n---\n\n{{JSRef}}\n\nThe **`concat()`** method of {{jsxref("Array")}} instances is used to merge two or more arrays.\nThis method does not change the existing arrays, but instead returns a new array.\n\n{{EmbedInteractiveExample("pages/js/array-concat.html", "shorter")}}\n\n## Syntax\n\n```js-nolint\nconcat()\nconcat(value1)\nconcat(value1, value2)\nconcat(value1, value2, /* \u2026, */ valueN)\n```\n\n### Parameters\n\n- `value1`, \u2026, `valueN` {{optional_inline}}\n  - : Arrays and/or values to concatenate into a new array. If all\n    `valueN` parameters are omitted, `concat` returns a\n    [shallow copy](/en-US/docs/Glossary/Shallow_copy) of the existing array on which it is called. See the description below\n    for more details.\n\n### Return value\n\nA new {{jsxref("Array")}} instance.\n\n## Description\n\nThe `concat` method creates a new array. The array will first be populated by the elements in the object on which it is called. Then, for each argument, its value will be concatenated into the array \u2014 for normal objects or primitives, the argument itself will become an element of the final array; for arrays or array-like objects with the property [`Symbol.isConcatSpreadable`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol/isConcatSpreadable) set to a truthy value, each element of the argument will be independently added to the final array. The `concat` method does not recurse into nested array arguments.\n\nThe `concat()` method is a [copying method](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array#copying_methods_and_mutating_methods). It does not alter `this` or any of the arrays provided as arguments but instead returns a [shallow copy](/en-US/docs/Glossary/Shallow_copy) that contains the same elements as the ones from the original arrays.\n\nThe `concat()` method preserves empty slots if any of the source arrays is [sparse](/en-US/docs/Web/JavaScript/Guide/Indexed_collections#sparse_arrays).\n\nThe `concat()` method is [generic](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array#generic_array_methods). The `this` value is treated in the same way as the other arguments (except it will be converted to an object first), which means plain objects will be directly prepended to the resulting array, while array-like objects with truthy `@@isConcatSpreadable` will be spread into the resulting array.\n\n## Examples\n\n### Concatenating two arrays\n\nThe following code concatenates two arrays:\n\n```js\nconst letters = ["a", "b", "c"];\nconst numbers = [1, 2, 3];\n\nconst alphaNumeric = letters.concat(numbers);\nconsole.log(alphaNumeric);\n// results in [\'a\', \'b\', \'c\', 1, 2, 3]\n```\n\n### Concatenating three arrays\n\nThe following code concatenates three arrays:\n\n```js\nconst num1 = [1, 2, 3];\nconst num2 = [4, 5, 6];\nconst num3 = [7, 8, 9];\n\nconst numbers = num1.concat(num2, num3);\n\nconsole.log(numbers);\n// results in [1, 2, 3, 4, 5, 6, 7, 8, 9]\n```\n\n### Concatenating values to an array\n\nThe following code concatenates three values to an array:\n\n```js\nconst letters = ["a", "b", "c"];\n\nconst alphaNumeric = letters.concat(1, [2, 3]);\n\nconsole.log(alphaNumeric);\n// results in [\'a\', \'b\', \'c\', 1, 2, 3]\n```\n\n### Concatenating nested arrays\n\nThe following code concatenates nested arrays and demonstrates retention of references:\n\n```js\nconst num1 = [[1]];\nconst num2 = [2, [3]];\n\nconst numbers = num1.concat(num2);\n\nconsole.log(numbers);\n// results in [[1], 2, [3]]\n\n// modify the first element of num1\nnum1[0].push(4);\n\nconsole.log(numbers);\n// results in [[1, 4], 2, [3]]\n```\n\n### Concatenating array-like objects with Symbol.isConcatSpreadable\n\n`concat` does not treat all array-like objects as arrays by default \u2014 only if `Symbol.isConcatSpreadable` is set to a truthy value (e.g. `true`).\n\n```js\nconst obj1 = { 0: 1, 1: 2, 2: 3, length: 3 };\nconst obj2 = { 0: 1, 1: 2, 2: 3, length: 3, [Symbol.isConcatSpreadable]: true };\nconsole.log([0].concat(obj1, obj2));\n// [ 0, { \'0\': 1, \'1\': 2, \'2\': 3, length: 3 }, 1, 2, 3 ]\n```\n\n### Using concat() on sparse arrays\n\nIf any of the source arrays is sparse, the resulting array will also be sparse:\n\n```js\nconsole.log([1, , 3].concat([4, 5])); // [1, empty, 3, 4, 5]\nconsole.log([1, 2].concat([3, , 5])); // [1, 2, 3, empty, 5]\n```\n\n### Calling concat() on non-array objects\n\nIf the `this` value is not an array, it is converted to an object and then treated in the same way as the arguments for `concat()`. In this case the return value is always a plain new array.\n\n```js\nconsole.log(Array.prototype.concat.call({}, 1, 2, 3)); // [{}, 1, 2, 3]\nconsole.log(Array.prototype.concat.call(1, 2, 3)); // [ [Number: 1], 2, 3 ]\nconst arrayLike = {\n  [Symbol.isConcatSpreadable]: true,\n  length: 2,\n  0: 1,\n  1: 2,\n  2: 99, // ignored by concat() since length is 2\n};\nconsole.log(Array.prototype.concat.call(arrayLike, 3, 4)); // [1, 2, 3, 4]\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Array.prototype.concat` in `core-js` with fixes and implementation of modern behavior like `Symbol.isConcatSpreadable` support](https://github.com/zloirock/core-js#ecmascript-array)\n- [Indexed collections](/en-US/docs/Web/JavaScript/Guide/Indexed_collections) guide\n- {{jsxref("Array")}}\n- {{jsxref("Array.prototype.push()")}}\n- {{jsxref("Array.prototype.unshift()")}}\n- {{jsxref("Array.prototype.splice()")}}\n- {{jsxref("String.prototype.concat()")}}\n- {{jsxref("Symbol.isConcatSpreadable")}}\n'
        },
        "copywithin": {
            "index.md": '---\ntitle: Array.prototype.copyWithin()\nslug: Web/JavaScript/Reference/Global_Objects/Array/copyWithin\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Array.copyWithin\n---\n\n{{JSRef}}\n\nThe **`copyWithin()`** method of {{jsxref("Array")}} instances shallow copies part of this array to another location in the same array and returns this array without modifying its length.\n\n{{EmbedInteractiveExample("pages/js/array-copywithin.html")}}\n\n## Syntax\n\n```js-nolint\ncopyWithin(target, start)\ncopyWithin(target, start, end)\n```\n\n### Parameters\n\n- `target`\n  - : Zero-based index at which to copy the sequence to, [converted to an integer](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number#integer_conversion). This corresponds to where the element at `start` will be copied to, and all elements between `start` and `end` are copied to succeeding indices.\n    - Negative index counts back from the end of the array \u2014 if `-array.length <= target < 0`, `target + array.length` is used.\n    - If `target < -array.length`, `0` is used.\n    - If `target >= array.length`, nothing is copied.\n    - If `target` is positioned after `start` after normalization, copying only happens until the end of `array.length` (in other words, `copyWithin()` never extends the array).\n- `start`\n  - : Zero-based index at which to start copying elements from, [converted to an integer](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number#integer_conversion).\n    - Negative index counts back from the end of the array \u2014 if `-array.length <= start < 0`, `start + array.length` is used.\n    - If `start < -array.length`, `0` is used.\n    - If `start >= array.length`, nothing is copied.\n- `end` {{optional_inline}}\n  - : Zero-based index at which to end copying elements from, [converted to an integer](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number#integer_conversion). `copyWithin()` copies up to but not including `end`.\n    - Negative index counts back from the end of the array \u2014 if `-array.length <= end < 0`, `end + array.length` is used.\n    - If `end < -array.length`, `0` is used.\n    - If `end >= array.length` or `end` is omitted, `array.length` is used, causing all elements until the end to be copied.\n    - If `end` implies a position before or at the position that `start` implies, nothing is copied.\n\n### Return value\n\nThe modified array.\n\n## Description\n\nThe `copyWithin()` method works like C and C++\'s `memmove`, and is a high-performance method to shift the data of an {{jsxref("Array")}}. This especially applies to the {{jsxref("TypedArray/copyWithin", "TypedArray")}} method of the same name. The sequence is copied and pasted as one operation; the pasted sequence will have the copied values even when the copy and paste region overlap.\n\nBecause `undefined` becomes `0` when converted to an integer, omitting the `start` parameter has the same effect as passing `0`, which copies the entire array to the target position, equivalent to a right shift where the right boundary is clipped off and the left boundary is duplicated. This behavior may confuse readers of your code, so you should explicitly pass `0` as `start` instead.\n\n```js\nconsole.log([1, 2, 3, 4, 5].copyWithin(2));\n// [1, 2, 1, 2, 3]; move all elements to the right by 2 positions\n```\n\nThe `copyWithin()` method is a [mutating method](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array#copying_methods_and_mutating_methods). It does not alter the length of `this`, but it will change the content of `this` and create new properties or delete existing properties, if necessary.\n\nThe `copyWithin()` method preserves empty slots. If the region to be copied from is [sparse](/en-US/docs/Web/JavaScript/Guide/Indexed_collections#sparse_arrays), the empty slots\' corresponding new indices are [deleted](/en-US/docs/Web/JavaScript/Reference/Operators/delete) and also become empty slots.\n\nThe `copyWithin()` method is [generic](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array#generic_array_methods). It only expects the `this` value to have a `length` property and integer-keyed properties. Although strings are also array-like, this method is not suitable to be applied on them, as strings are immutable.\n\n## Examples\n\n### Using copyWithin()\n\n```js\nconsole.log([1, 2, 3, 4, 5].copyWithin(0, 3));\n// [4, 5, 3, 4, 5]\n\nconsole.log([1, 2, 3, 4, 5].copyWithin(0, 3, 4));\n// [4, 2, 3, 4, 5]\n\nconsole.log([1, 2, 3, 4, 5].copyWithin(-2, -3, -1));\n// [1, 2, 3, 3, 4]\n```\n\n### Using copyWithin() on sparse arrays\n\n`copyWithin()` will propagate empty slots.\n\n```js\nconsole.log([1, , 3].copyWithin(2, 1, 2)); // [1, empty, empty]\n```\n\n### Calling copyWithin() on non-array objects\n\nThe `copyWithin()` method reads the `length` property of `this` and then manipulates the integer indices involved.\n\n```js\nconst arrayLike = {\n  length: 5,\n  3: 1,\n};\nconsole.log(Array.prototype.copyWithin.call(arrayLike, 0, 3));\n// { \'0\': 1, \'3\': 1, length: 5 }\nconsole.log(Array.prototype.copyWithin.call(arrayLike, 3, 1));\n// { \'0\': 1, length: 5 }\n// The \'3\' property is deleted because the copied source is an empty slot\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Array.prototype.copyWithin` in `core-js`](https://github.com/zloirock/core-js#ecmascript-array)\n- [Indexed collections](/en-US/docs/Web/JavaScript/Guide/Indexed_collections) guide\n- {{jsxref("Array")}}\n- {{jsxref("TypedArray.prototype.copyWithin()")}}\n'
        },
        "entries": {
            "index.md": '---\ntitle: Array.prototype.entries()\nslug: Web/JavaScript/Reference/Global_Objects/Array/entries\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Array.entries\n---\n\n{{JSRef}}\n\nThe **`entries()`** method of {{jsxref("Array")}} instances returns a new _[array iterator](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Iterator)_ object that contains the key/value pairs for each index in the array.\n\n{{EmbedInteractiveExample("pages/js/array-entries.html")}}\n\n## Syntax\n\n```js-nolint\nentries()\n```\n\n### Parameters\n\nNone.\n\n### Return value\n\nA new [iterable iterator object](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Iterator).\n\n## Description\n\nWhen used on [sparse arrays](/en-US/docs/Web/JavaScript/Guide/Indexed_collections#sparse_arrays), the `entries()` method iterates empty slots as if they have the value `undefined`.\n\nThe `entries()` method is [generic](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array#generic_array_methods). It only expects the `this` value to have a `length` property and integer-keyed properties.\n\n## Examples\n\n### Iterating with index and element\n\n```js\nconst a = ["a", "b", "c"];\n\nfor (const [index, element] of a.entries()) {\n  console.log(index, element);\n}\n\n// 0 \'a\'\n// 1 \'b\'\n// 2 \'c\'\n```\n\n### Using a for...of loop\n\n```js\nconst array = ["a", "b", "c"];\nconst arrayEntries = array.entries();\n\nfor (const element of arrayEntries) {\n  console.log(element);\n}\n\n// [0, \'a\']\n// [1, \'b\']\n// [2, \'c\']\n```\n\n### Iterating sparse arrays\n\n`entries()` will visit empty slots as if they are `undefined`.\n\n```js\nfor (const element of [, "a"].entries()) {\n  console.log(element);\n}\n// [0, undefined]\n// [1, \'a\']\n```\n\n### Calling entries() on non-array objects\n\nThe `entries()` method reads the `length` property of `this` and then accesses each property whose key is a nonnegative integer less than `length`.\n\n```js\nconst arrayLike = {\n  length: 3,\n  0: "a",\n  1: "b",\n  2: "c",\n  3: "d", // ignored by entries() since length is 3\n};\nfor (const entry of Array.prototype.entries.call(arrayLike)) {\n  console.log(entry);\n}\n// [ 0, \'a\' ]\n// [ 1, \'b\' ]\n// [ 2, \'c\' ]\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Array.prototype.entries` in `core-js`](https://github.com/zloirock/core-js#ecmascript-array)\n- [Indexed collections](/en-US/docs/Web/JavaScript/Guide/Indexed_collections) guide\n- {{jsxref("Array")}}\n- {{jsxref("Array.prototype.keys()")}}\n- {{jsxref("Array.prototype.values()")}}\n- [`Array.prototype[@@iterator]()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/@@iterator)\n- {{jsxref("TypedArray.prototype.entries()")}}\n- [Iteration protocols](/en-US/docs/Web/JavaScript/Reference/Iteration_protocols)\n'
        },
        "every": {
            "index.md": '---\ntitle: Array.prototype.every()\nslug: Web/JavaScript/Reference/Global_Objects/Array/every\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Array.every\n---\n\n{{JSRef}}\n\nThe **`every()`** method of {{jsxref("Array")}} instances tests whether\nall elements in the array pass the test implemented by the provided function. It\nreturns a Boolean value.\n\n{{EmbedInteractiveExample("pages/js/array-every.html", "shorter")}}\n\n## Syntax\n\n```js-nolint\nevery(callbackFn)\nevery(callbackFn, thisArg)\n```\n\n### Parameters\n\n- `callbackFn`\n  - : A function to execute for each element in the array. It should return a [truthy](/en-US/docs/Glossary/Truthy) value to indicate the element passes the test, and a [falsy](/en-US/docs/Glossary/Falsy) value otherwise. The function is called with the following arguments:\n    - `element`\n      - : The current element being processed in the array.\n    - `index`\n      - : The index of the current element being processed in the array.\n    - `array`\n      - : The array `every()` was called upon.\n- `thisArg` {{optional_inline}}\n  - : A value to use as `this` when executing `callbackFn`. See [iterative methods](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array#iterative_methods).\n\n### Return value\n\n`true` unless `callbackFn` returns a {{Glossary("falsy")}} value for an array element, in which case `false` is immediately returned.\n\n## Description\n\nThe `every()` method is an [iterative method](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array#iterative_methods). It calls a provided `callbackFn` function once for each element in an array, until the `callbackFn` returns a [falsy](/en-US/docs/Glossary/Falsy) value. If such an element is found, `every()` immediately returns `false` and stops iterating through the array. Otherwise, if `callbackFn` returns a [truthy](/en-US/docs/Glossary/Truthy) value for all elements, `every()` returns `true`. Read the [iterative methods](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array#iterative_methods) section for more information about how these methods work in general.\n\n`every` acts like the "for all" quantifier in mathematics. In particular, for an empty array, it returns `true`. (It is [vacuously true](https://en.wikipedia.org/wiki/Vacuous_truth) that all elements of the [empty set](https://en.wikipedia.org/wiki/Empty_set#Properties) satisfy any given condition.)\n\n`callbackFn` is invoked only for array indexes which have assigned values. It is not invoked for empty slots in [sparse arrays](/en-US/docs/Web/JavaScript/Guide/Indexed_collections#sparse_arrays).\n\nThe `every()` method is [generic](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array#generic_array_methods). It only expects the `this` value to have a `length` property and integer-keyed properties.\n\n## Examples\n\n### Testing size of all array elements\n\nThe following example tests whether all elements in the array are 10 or bigger.\n\n```js\nfunction isBigEnough(element, index, array) {\n  return element >= 10;\n}\n[12, 5, 8, 130, 44].every(isBigEnough); // false\n[12, 54, 18, 130, 44].every(isBigEnough); // true\n```\n\n### Check if one array is a subset of another array\n\nThe following example tests if all the elements of an array are present in another array.\n\n```js\nconst isSubset = (array1, array2) =>\n  array2.every((element) => array1.includes(element));\n\nconsole.log(isSubset([1, 2, 3, 4, 5, 6, 7], [5, 7, 6])); // true\nconsole.log(isSubset([1, 2, 3, 4, 5, 6, 7], [5, 8, 7])); // false\n```\n\n### Using the third argument of callbackFn\n\nThe `array` argument is useful if you want to access another element in the array. The following example first uses `filter()` to extract the positive values and then uses `every()` to check whether the array is strictly increasing.\n\n```js\nconst numbers = [-2, 4, -8, 16, -32];\nconst isIncreasing = numbers\n  .filter((num) => num > 0)\n  .every((num, idx, arr) => {\n    // Without the arr argument, there\'s no way to easily access the\n    // intermediate array without saving it to a variable.\n    if (idx === 0) return true;\n    return num > arr[idx - 1];\n  });\nconsole.log(isIncreasing); // true\n```\n\n### Using every() on sparse arrays\n\n`every()` will not run its predicate on empty slots.\n\n```js\nconsole.log([1, , 3].every((x) => x !== undefined)); // true\nconsole.log([2, , 2].every((x) => x === 2)); // true\n```\n\n### Calling every() on non-array objects\n\nThe `every()` method reads the `length` property of `this` and then accesses each property with a nonnegative integer key less than `length` until they all have been accessed or `callbackFn` returns `false`.\n\n```js\nconst arrayLike = {\n  length: 3,\n  0: "a",\n  1: "b",\n  2: "c",\n  3: 345, // ignored by every() since length is 3\n};\nconsole.log(\n  Array.prototype.every.call(arrayLike, (x) => typeof x === "string"),\n); // true\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Array.prototype.every` in `core-js`](https://github.com/zloirock/core-js#ecmascript-array)\n- [Indexed collections](/en-US/docs/Web/JavaScript/Guide/Indexed_collections) guide\n- {{jsxref("Array")}}\n- {{jsxref("Array.prototype.forEach()")}}\n- {{jsxref("Array.prototype.some()")}}\n- {{jsxref("Array.prototype.find()")}}\n- {{jsxref("TypedArray.prototype.every()")}}\n'
        },
        "fill": {
            "index.md": '---\ntitle: Array.prototype.fill()\nslug: Web/JavaScript/Reference/Global_Objects/Array/fill\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Array.fill\n---\n\n{{JSRef}}\n\nThe **`fill()`** method of {{jsxref("Array")}} instances changes all elements within a range of indices in an array to a static value. It returns the modified array.\n\n{{EmbedInteractiveExample("pages/js/array-fill.html")}}\n\n## Syntax\n\n```js-nolint\nfill(value)\nfill(value, start)\nfill(value, start, end)\n```\n\n### Parameters\n\n- `value`\n  - : Value to fill the array with. Note all elements in the array will be this exact value: if `value` is an object, each slot in the array will reference that object.\n- `start` {{optional_inline}}\n  - : Zero-based index at which to start filling, [converted to an integer](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number#integer_conversion).\n    - Negative index counts back from the end of the array \u2014 if `-array.length <= start < 0`, `start + array.length` is used.\n    - If `start < -array.length` or `start` is omitted, `0` is used.\n    - If `start >= array.length`, no index is filled.\n- `end` {{optional_inline}}\n  - : Zero-based index at which to end filling, [converted to an integer](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number#integer_conversion). `fill()` fills up to but not including `end`.\n    - Negative index counts back from the end of the array \u2014 if `-array.length <= end < 0`, `end + array.length` is used.\n    - If `end < -array.length`, `0` is used.\n    - If `end >= array.length` or `end` is omitted, `array.length` is used, causing all indices until the end to be filled.\n    - If `end` implies a position before or at the position that `start` implies, nothing is filled.\n\n### Return value\n\nThe modified array, filled with `value`.\n\n## Description\n\nThe `fill()` method is a [mutating method](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array#copying_methods_and_mutating_methods). It does not alter the length of `this`, but it will change the content of `this`.\n\nThe `fill()` method fills empty slots in [sparse](/en-US/docs/Web/JavaScript/Guide/Indexed_collections#sparse_arrays) arrays with `value` as well.\n\nThe `fill()` method is [generic](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array#generic_array_methods). It only expects the `this` value to have a `length` property. Although strings are also array-like, this method is not suitable to be applied on them, as strings are immutable.\n\n> **Note:** Using `Array.prototype.fill()` on an empty array (`length = 0`) would not modify it as the array has nothing to be modified.\n> To use `Array.prototype.fill()` when declaring an array, make sure the array has non-zero `length`.\n> [See example](#using_fill_to_populate_an_empty_array).\n\n## Examples\n\n### Using fill()\n\n```js\nconsole.log([1, 2, 3].fill(4)); // [4, 4, 4]\nconsole.log([1, 2, 3].fill(4, 1)); // [1, 4, 4]\nconsole.log([1, 2, 3].fill(4, 1, 2)); // [1, 4, 3]\nconsole.log([1, 2, 3].fill(4, 1, 1)); // [1, 2, 3]\nconsole.log([1, 2, 3].fill(4, 3, 3)); // [1, 2, 3]\nconsole.log([1, 2, 3].fill(4, -3, -2)); // [4, 2, 3]\nconsole.log([1, 2, 3].fill(4, NaN, NaN)); // [1, 2, 3]\nconsole.log([1, 2, 3].fill(4, 3, 5)); // [1, 2, 3]\nconsole.log(Array(3).fill(4)); // [4, 4, 4]\n\n// A single object, referenced by each slot of the array:\nconst arr = Array(3).fill({}); // [{}, {}, {}]\narr[0].hi = "hi"; // [{ hi: "hi" }, { hi: "hi" }, { hi: "hi" }]\n```\n\n### Using fill() to create a matrix of all 1\n\nThis example shows how to create a matrix of all 1, like the `ones()` function of Octave or MATLAB.\n\n```js\nconst arr = new Array(3);\nfor (let i = 0; i < arr.length; i++) {\n  arr[i] = new Array(4).fill(1); // Creating an array of size 4 and filled of 1\n}\narr[0][0] = 10;\nconsole.log(arr[0][0]); // 10\nconsole.log(arr[1][0]); // 1\nconsole.log(arr[2][0]); // 1\n```\n\n### Using fill() to populate an empty array\n\nThis example shows how to populate an array, setting all elements to a specific value.\nThe `end` parameter does not have to be specified.\n\n```js\nconst tempGirls = Array(5).fill("girl", 0);\n```\n\nNote that the array was initially a [sparse array](/en-US/docs/Web/JavaScript/Guide/Indexed_collections#sparse_arrays) with no assigned indices. `fill()` is still able to fill this array.\n\n### Calling fill() on non-array objects\n\nThe `fill()` method reads the `length` property of `this` and sets the value of each integer-keyed property from `start` to `end`.\n\n```js\nconst arrayLike = { length: 2 };\nconsole.log(Array.prototype.fill.call(arrayLike, 1));\n// { \'0\': 1, \'1\': 1, length: 2 }\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Array.prototype.fill` in `core-js`](https://github.com/zloirock/core-js#ecmascript-array)\n- [Indexed collections](/en-US/docs/Web/JavaScript/Guide/Indexed_collections) guide\n- {{jsxref("Array")}}\n- {{jsxref("TypedArray.prototype.fill()")}}\n'
        },
        "filter": {
            "index.md": '---\ntitle: Array.prototype.filter()\nslug: Web/JavaScript/Reference/Global_Objects/Array/filter\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Array.filter\n---\n\n{{JSRef}}\n\nThe **`filter()`** method of {{jsxref("Array")}} instances creates a [shallow copy](/en-US/docs/Glossary/Shallow_copy) of a portion of a given array, filtered down to just the elements from the given array that pass the test implemented by the provided function.\n\n{{EmbedInteractiveExample("pages/js/array-filter.html", "shorter")}}\n\n## Syntax\n\n```js-nolint\nfilter(callbackFn)\nfilter(callbackFn, thisArg)\n```\n\n### Parameters\n\n- `callbackFn`\n  - : A function to execute for each element in the array. It should return a [truthy](/en-US/docs/Glossary/Truthy) value to keep the element in the resulting array, and a [falsy](/en-US/docs/Glossary/Falsy) value otherwise. The function is called with the following arguments:\n    - `element`\n      - : The current element being processed in the array.\n    - `index`\n      - : The index of the current element being processed in the array.\n    - `array`\n      - : The array `filter()` was called upon.\n- `thisArg` {{optional_inline}}\n  - : A value to use as `this` when executing `callbackFn`. See [iterative methods](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array#iterative_methods).\n\n### Return value\n\nA [shallow copy](/en-US/docs/Glossary/Shallow_copy) of the given array containing just the elements that pass the test. If no elements pass the test, an empty array is returned.\n\n## Description\n\nThe `filter()` method is an [iterative method](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array#iterative_methods). It calls a provided `callbackFn` function once for each element in an array, and constructs a new array of all the values for which `callbackFn` returns a [truthy](/en-US/docs/Glossary/Truthy) value. Array elements which do not pass the `callbackFn` test are not included in the new array. Read the [iterative methods](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array#iterative_methods) section for more information about how these methods work in general.\n\n`callbackFn` is invoked only for array indexes which have assigned values. It is not invoked for empty slots in [sparse arrays](/en-US/docs/Web/JavaScript/Guide/Indexed_collections#sparse_arrays).\n\nThe `filter()` method is [generic](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array#generic_array_methods). It only expects the `this` value to have a `length` property and integer-keyed properties.\n\n## Examples\n\n### Filtering out all small values\n\nThe following example uses `filter()` to create a filtered array that has all elements with values less than 10 removed.\n\n```js\nfunction isBigEnough(value) {\n  return value >= 10;\n}\n\nconst filtered = [12, 5, 8, 130, 44].filter(isBigEnough);\n// filtered is [12, 130, 44]\n```\n\n### Find all prime numbers in an array\n\nThe following example returns all prime numbers in the array:\n\n```js\nconst array = [-3, -2, -1, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13];\n\nfunction isPrime(num) {\n  for (let i = 2; num > i; i++) {\n    if (num % i === 0) {\n      return false;\n    }\n  }\n  return num > 1;\n}\n\nconsole.log(array.filter(isPrime)); // [2, 3, 5, 7, 11, 13]\n```\n\n### Filtering invalid entries from JSON\n\nThe following example uses `filter()` to create a filtered JSON of all elements with non-zero, numeric `id`.\n\n```js\nconst arr = [\n  { id: 15 },\n  { id: -1 },\n  { id: 0 },\n  { id: 3 },\n  { id: 12.2 },\n  {},\n  { id: null },\n  { id: NaN },\n  { id: "undefined" },\n];\n\nlet invalidEntries = 0;\n\nfunction filterByID(item) {\n  if (Number.isFinite(item.id) && item.id !== 0) {\n    return true;\n  }\n  invalidEntries++;\n  return false;\n}\n\nconst arrByID = arr.filter(filterByID);\n\nconsole.log("Filtered Array\\n", arrByID);\n// Filtered Array\n// [{ id: 15 }, { id: -1 }, { id: 3 }, { id: 12.2 }]\n\nconsole.log("Number of Invalid Entries =", invalidEntries);\n// Number of Invalid Entries = 5\n```\n\n### Searching in array\n\nFollowing example uses `filter()` to filter array content based on search criteria.\n\n```js\nconst fruits = ["apple", "banana", "grapes", "mango", "orange"];\n\n/**\n * Filter array items based on search criteria (query)\n */\nfunction filterItems(arr, query) {\n  return arr.filter((el) => el.toLowerCase().includes(query.toLowerCase()));\n}\n\nconsole.log(filterItems(fruits, "ap")); // [\'apple\', \'grapes\']\nconsole.log(filterItems(fruits, "an")); // [\'banana\', \'mango\', \'orange\']\n```\n\n### Using the third argument of callbackFn\n\nThe `array` argument is useful if you want to access another element in the array, especially when you don\'t have an existing variable that refers to the array. The following example first uses `map()` to extract the numerical ID from each name and then uses `filter()` to select the ones that are greater than its neighbors.\n\n```js\nconst names = ["JC63", "Bob132", "Ursula89", "Ben96"];\nconst greatIDs = names\n  .map((name) => parseInt(name.match(/[0-9]+/)[0], 10))\n  .filter((id, idx, arr) => {\n    // Without the arr argument, there\'s no way to easily access the\n    // intermediate array without saving it to a variable.\n    if (idx > 0 && id <= arr[idx - 1]) return false;\n    if (idx < arr.length - 1 && id <= arr[idx + 1]) return false;\n    return true;\n  });\nconsole.log(greatIDs); // [132, 96]\n```\n\nThe `array` argument is _not_ the array that is being built \u2014 there is no way to access the array being built from the callback function.\n\n### Using filter() on sparse arrays\n\n`filter()` will skip empty slots.\n\n```js\nconsole.log([1, , undefined].filter((x) => x === undefined)); // [undefined]\nconsole.log([1, , undefined].filter((x) => x !== 2)); // [1, undefined]\n```\n\n### Calling filter() on non-array objects\n\nThe `filter()` method reads the `length` property of `this` and then accesses each property whose key is a nonnegative integer less than `length`.\n\n```js\nconst arrayLike = {\n  length: 3,\n  0: "a",\n  1: "b",\n  2: "c",\n  3: "a", // ignored by filter() since length is 3\n};\nconsole.log(Array.prototype.filter.call(arrayLike, (x) => x <= "b"));\n// [ \'a\', \'b\' ]\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Array.prototype.filter` in `core-js`](https://github.com/zloirock/core-js#ecmascript-array)\n- [Indexed collections](/en-US/docs/Web/JavaScript/Guide/Indexed_collections) guide\n- {{jsxref("Array")}}\n- {{jsxref("Array.prototype.forEach()")}}\n- {{jsxref("Array.prototype.every()")}}\n- {{jsxref("Array.prototype.map()")}}\n- {{jsxref("Array.prototype.some()")}}\n- {{jsxref("Array.prototype.reduce()")}}\n- {{jsxref("TypedArray.prototype.filter()")}}\n'
        },
        "find": {
            "index.md": '---\ntitle: Array.prototype.find()\nslug: Web/JavaScript/Reference/Global_Objects/Array/find\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Array.find\n---\n\n{{JSRef}}\n\nThe **`find()`** method of {{jsxref("Array")}} instances returns the first element in the provided array that satisfies the provided testing function.\nIf no values satisfy the testing function, {{jsxref("undefined")}} is returned.\n\n- If you need the **index** of the found element in the array, use {{jsxref("Array/findIndex", "findIndex()")}}.\n- If you need to find the **index of a value**, use {{jsxref("Array/indexOf", "indexOf()")}}.\n  (It\'s similar to {{jsxref("Array/findIndex", "findIndex()")}}, but checks each element for equality with the value instead of using a testing function.)\n- If you need to find if a value **exists** in an array, use {{jsxref("Array/includes", "includes()")}}.\n  Again, it checks each element for equality with the value instead of using a testing function.\n- If you need to find if any element satisfies the provided testing function, use {{jsxref("Array/some", "some()")}}.\n- If you need to find all elements that satisfy the provided testing function, use {{jsxref("Array/filter", "filter()")}}.\n\n{{EmbedInteractiveExample("pages/js/array-find.html", "shorter")}}\n\n## Syntax\n\n```js-nolint\nfind(callbackFn)\nfind(callbackFn, thisArg)\n```\n\n### Parameters\n\n- `callbackFn`\n  - : A function to execute for each element in the array. It should return a [truthy](/en-US/docs/Glossary/Truthy) value to indicate a matching element has been found, and a [falsy](/en-US/docs/Glossary/Falsy) value otherwise. The function is called with the following arguments:\n    - `element`\n      - : The current element being processed in the array.\n    - `index`\n      - : The index of the current element being processed in the array.\n    - `array`\n      - : The array `find()` was called upon.\n- `thisArg` {{optional_inline}}\n  - : A value to use as `this` when executing `callbackFn`. See [iterative methods](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array#iterative_methods).\n\n### Return value\n\nThe first element in the array that satisfies the provided testing function.\nOtherwise, {{jsxref("undefined")}} is returned.\n\n## Description\n\nThe `find()` method is an [iterative method](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array#iterative_methods). It calls a provided `callbackFn` function once for each element in an array in ascending-index order, until `callbackFn` returns a [truthy](/en-US/docs/Glossary/Truthy) value. `find()` then returns that element and stops iterating through the array. If `callbackFn` never returns a truthy value, `find()` returns {{jsxref("undefined")}}. Read the [iterative methods](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array#iterative_methods) section for more information about how these methods work in general.\n\n`callbackFn` is invoked for _every_ index of the array, not just those with assigned values. Empty slots in [sparse arrays](/en-US/docs/Web/JavaScript/Guide/Indexed_collections#sparse_arrays) behave the same as `undefined`.\n\nThe `find()` method is [generic](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array#generic_array_methods). It only expects the `this` value to have a `length` property and integer-keyed properties.\n\n## Examples\n\n### Find an object in an array by one of its properties\n\n```js\nconst inventory = [\n  { name: "apples", quantity: 2 },\n  { name: "bananas", quantity: 0 },\n  { name: "cherries", quantity: 5 },\n];\n\nfunction isCherries(fruit) {\n  return fruit.name === "cherries";\n}\n\nconsole.log(inventory.find(isCherries));\n// { name: \'cherries\', quantity: 5 }\n```\n\n#### Using arrow function and destructuring\n\n```js\nconst inventory = [\n  { name: "apples", quantity: 2 },\n  { name: "bananas", quantity: 0 },\n  { name: "cherries", quantity: 5 },\n];\n\nconst result = inventory.find(({ name }) => name === "cherries");\n\nconsole.log(result); // { name: \'cherries\', quantity: 5 }\n```\n\n### Find a prime number in an array\n\nThe following example finds an element in the array that is a prime number (or returns {{jsxref("undefined")}} if there is no prime number):\n\n```js\nfunction isPrime(element, index, array) {\n  let start = 2;\n  while (start <= Math.sqrt(element)) {\n    if (element % start++ < 1) {\n      return false;\n    }\n  }\n  return element > 1;\n}\n\nconsole.log([4, 6, 8, 12].find(isPrime)); // undefined, not found\nconsole.log([4, 5, 8, 12].find(isPrime)); // 5\n```\n\n### Using the third argument of callbackFn\n\nThe `array` argument is useful if you want to access another element in the array, especially when you don\'t have an existing variable that refers to the array. The following example first uses `filter()` to extract the positive values and then uses `find()` to find the first element that is less than its neighbors.\n\n```js\nconst numbers = [3, -1, 1, 4, 1, 5, 9, 2, 6];\nconst firstTrough = numbers\n  .filter((num) => num > 0)\n  .find((num, idx, arr) => {\n    // Without the arr argument, there\'s no way to easily access the\n    // intermediate array without saving it to a variable.\n    if (idx > 0 && num >= arr[idx - 1]) return false;\n    if (idx < arr.length - 1 && num >= arr[idx + 1]) return false;\n    return true;\n  });\nconsole.log(firstTrough); // 1\n```\n\n### Using find() on sparse arrays\n\nEmpty slots in sparse arrays _are_ visited, and are treated the same as `undefined`.\n\n```js\n// Declare array with no elements at indexes 2, 3, and 4\nconst array = [0, 1, , , , 5, 6];\n\n// Shows all indexes, not just those with assigned values\narray.find((value, index) => {\n  console.log("Visited index", index, "with value", value);\n});\n// Visited index 0 with value 0\n// Visited index 1 with value 1\n// Visited index 2 with value undefined\n// Visited index 3 with value undefined\n// Visited index 4 with value undefined\n// Visited index 5 with value 5\n// Visited index 6 with value 6\n\n// Shows all indexes, including deleted\narray.find((value, index) => {\n  // Delete element 5 on first iteration\n  if (index === 0) {\n    console.log("Deleting array[5] with value", array[5]);\n    delete array[5];\n  }\n  // Element 5 is still visited even though deleted\n  console.log("Visited index", index, "with value", value);\n});\n// Deleting array[5] with value 5\n// Visited index 0 with value 0\n// Visited index 1 with value 1\n// Visited index 2 with value undefined\n// Visited index 3 with value undefined\n// Visited index 4 with value undefined\n// Visited index 5 with value undefined\n// Visited index 6 with value 6\n```\n\n### Calling find() on non-array objects\n\nThe `find()` method reads the `length` property of `this` and then accesses each property whose key is a nonnegative integer less than `length`.\n\n```js\nconst arrayLike = {\n  length: 3,\n  "-1": 0.1, // ignored by find() since -1 < 0\n  0: 2,\n  1: 7.3,\n  2: 4,\n};\nconsole.log(Array.prototype.find.call(arrayLike, (x) => !Number.isInteger(x)));\n// 7.3\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Array.prototype.find` in `core-js`](https://github.com/zloirock/core-js#ecmascript-array)\n- [Indexed collections](/en-US/docs/Web/JavaScript/Guide/Indexed_collections) guide\n- {{jsxref("Array")}}\n- {{jsxref("Array.prototype.findIndex()")}}\n- {{jsxref("Array.prototype.findLast()")}}\n- {{jsxref("Array.prototype.findLastIndex()")}}\n- {{jsxref("Array.prototype.includes()")}}\n- {{jsxref("Array.prototype.filter()")}}\n- {{jsxref("Array.prototype.every()")}}\n- {{jsxref("Array.prototype.some()")}}\n- {{jsxref("TypedArray.prototype.find()")}}\n'
        },
        "findindex": {
            "index.md": '---\ntitle: Array.prototype.findIndex()\nslug: Web/JavaScript/Reference/Global_Objects/Array/findIndex\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Array.findIndex\n---\n\n{{JSRef}}\n\nThe **`findIndex()`** method of {{jsxref("Array")}} instances returns the index of the first element in an array that satisfies the provided testing function.\nIf no elements satisfy the testing function, -1 is returned.\n\nSee also the {{jsxref("Array/find", "find()")}} method, which returns the first element that satisfies the testing function (rather than its index).\n\n{{EmbedInteractiveExample("pages/js/array-findindex.html", "shorter")}}\n\n## Syntax\n\n```js-nolint\nfindIndex(callbackFn)\nfindIndex(callbackFn, thisArg)\n```\n\n### Parameters\n\n- `callbackFn`\n  - : A function to execute for each element in the array. It should return a [truthy](/en-US/docs/Glossary/Truthy) value to indicate a matching element has been found, and a [falsy](/en-US/docs/Glossary/Falsy) value otherwise. The function is called with the following arguments:\n    - `element`\n      - : The current element being processed in the array.\n    - `index`\n      - : The index of the current element being processed in the array.\n    - `array`\n      - : The array `findIndex()` was called upon.\n- `thisArg` {{optional_inline}}\n  - : A value to use as `this` when executing `callbackFn`. See [iterative methods](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array#iterative_methods).\n\n### Return value\n\nThe index of the first element in the array that passes the test. Otherwise, `-1`.\n\n## Description\n\nThe `findIndex()` is an [iterative method](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array#iterative_methods). It calls a provided `callbackFn` function once for each element in an array in ascending-index order, until `callbackFn` returns a [truthy](/en-US/docs/Glossary/Truthy) value. `findIndex()` then returns the index of that element and stops iterating through the array. If `callbackFn` never returns a truthy value, `findIndex()` returns `-1`. Read the [iterative methods](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array#iterative_methods) section for more information about how these methods work in general.\n\n`callbackFn` is invoked for _every_ index of the array, not just those with assigned values. Empty slots in [sparse arrays](/en-US/docs/Web/JavaScript/Guide/Indexed_collections#sparse_arrays) behave the same as `undefined`.\n\nThe `findIndex()` method is [generic](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array#generic_array_methods). It only expects the `this` value to have a `length` property and integer-keyed properties.\n\n## Examples\n\n### Find the index of a prime number in an array\n\nThe following example returns the index of the first element in the array that is a prime number, or `-1` if there is no prime number.\n\n```js\nfunction isPrime(element) {\n  if (element % 2 === 0 || element < 2) {\n    return false;\n  }\n  for (let factor = 3; factor <= Math.sqrt(element); factor += 2) {\n    if (element % factor === 0) {\n      return false;\n    }\n  }\n  return true;\n}\n\nconsole.log([4, 6, 8, 9, 12].findIndex(isPrime)); // -1, not found\nconsole.log([4, 6, 7, 9, 12].findIndex(isPrime)); // 2 (array[2] is 7)\n```\n\n### Using the third argument of callbackFn\n\nThe `array` argument is useful if you want to access another element in the array, especially when you don\'t have an existing variable that refers to the array. The following example first uses `filter()` to extract the positive values and then uses `findIndex()` to find the first element that is less than its neighbors.\n\n```js\nconst numbers = [3, -1, 1, 4, 1, 5, 9, 2, 6];\nconst firstTrough = numbers\n  .filter((num) => num > 0)\n  .findIndex((num, idx, arr) => {\n    // Without the arr argument, there\'s no way to easily access the\n    // intermediate array without saving it to a variable.\n    if (idx > 0 && num >= arr[idx - 1]) return false;\n    if (idx < arr.length - 1 && num >= arr[idx + 1]) return false;\n    return true;\n  });\nconsole.log(firstTrough); // 1\n```\n\n### Using findIndex() on sparse arrays\n\nYou can search for `undefined` in a sparse array and get the index of an empty slot.\n\n```js\nconsole.log([1, , 3].findIndex((x) => x === undefined)); // 1\n```\n\n### Calling findIndex() on non-array objects\n\nThe `findIndex()` method reads the `length` property of `this` and then accesses each property whose key is a nonnegative integer less than `length`.\n\n```js\nconst arrayLike = {\n  length: 3,\n  "-1": 0.1, // ignored by findIndex() since -1 < 0\n  0: 2,\n  1: 7.3,\n  2: 4,\n};\nconsole.log(\n  Array.prototype.findIndex.call(arrayLike, (x) => !Number.isInteger(x)),\n); // 1\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Array.prototype.findIndex` in `core-js`](https://github.com/zloirock/core-js#ecmascript-array)\n- [Indexed collections](/en-US/docs/Web/JavaScript/Guide/Indexed_collections) guide\n- {{jsxref("Array")}}\n- {{jsxref("Array.prototype.find()")}}\n- {{jsxref("Array.prototype.findLast()")}}\n- {{jsxref("Array.prototype.findLastIndex()")}}\n- {{jsxref("Array.prototype.indexOf()")}}\n- {{jsxref("Array.prototype.lastIndexOf()")}}\n- {{jsxref("TypedArray.prototype.findIndex()")}}\n'
        },
        "findlast": {
            "index.md": '---\ntitle: Array.prototype.findLast()\nslug: Web/JavaScript/Reference/Global_Objects/Array/findLast\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Array.findLast\n---\n\n{{JSRef}}\n\nThe **`findLast()`** method of {{jsxref("Array")}} instances iterates the array in reverse order and returns the value of the first element that satisfies the provided testing function.\nIf no elements satisfy the testing function, {{jsxref("undefined")}} is returned.\n\nIf you need to find:\n\n- the _first_ element that matches, use {{jsxref("Array/find", "find()")}}.\n- the _index_ of the last matching element in the array, use {{jsxref("Array/findLastIndex", "findLastIndex()")}}.\n- the _index of a value_, use {{jsxref("Array/indexOf", "indexOf()")}}.\n  (It\'s similar to {{jsxref("Array/findIndex", "findIndex()")}}, but checks each element for equality with the value instead of using a testing function.)\n- whether a value _exists_ in an array, use {{jsxref("Array/includes", "includes()")}}.\n  Again, it checks each element for equality with the value instead of using a testing function.\n- if any element satisfies the provided testing function, use {{jsxref("Array/some", "some()")}}.\n\n{{EmbedInteractiveExample("pages/js/array-findlast.html", "shorter")}}\n\n## Syntax\n\n```js-nolint\nfindLast(callbackFn)\nfindLast(callbackFn, thisArg)\n```\n\n### Parameters\n\n- `callbackFn`\n  - : A function to execute for each element in the array. It should return a [truthy](/en-US/docs/Glossary/Truthy) value to indicate a matching element has been found, and a [falsy](/en-US/docs/Glossary/Falsy) value otherwise. The function is called with the following arguments:\n    - `element`\n      - : The current element being processed in the array.\n    - `index`\n      - : The index of the current element being processed in the array.\n    - `array`\n      - : The array `findLast()` was called upon.\n- `thisArg` {{optional_inline}}\n  - : A value to use as `this` when executing `callbackFn`. See [iterative methods](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array#iterative_methods).\n\n### Return value\n\nThe last (highest-index) element in the array that satisfies the provided testing function; {{jsxref("undefined")}} if no matching element is found.\n\n## Description\n\nThe `findLast()` method is an [iterative method](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array#iterative_methods). It calls a provided `callbackFn` function once for each element in an array in descending-index order, until `callbackFn` returns a [truthy](/en-US/docs/Glossary/Truthy) value. `findLast()` then returns that element and stops iterating through the array. If `callbackFn` never returns a truthy value, `findLast()` returns {{jsxref("undefined")}}. Read the [iterative methods](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array#iterative_methods) section for more information about how these methods work in general.\n\n`callbackFn` is invoked for _every_ index of the array, not just those with assigned values. Empty slots in [sparse arrays](/en-US/docs/Web/JavaScript/Guide/Indexed_collections#sparse_arrays) behave the same as `undefined`.\n\nThe `findLast()` method is [generic](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array#generic_array_methods). It only expects the `this` value to have a `length` property and integer-keyed properties.\n\n## Examples\n\n### Find last object in an array matching on element properties\n\nThis example shows how you might create a test based on the properties of array elements.\n\n```js\nconst inventory = [\n  { name: "apples", quantity: 2 },\n  { name: "bananas", quantity: 0 },\n  { name: "fish", quantity: 1 },\n  { name: "cherries", quantity: 5 },\n];\n\n// return true inventory stock is low\nfunction isNotEnough(item) {\n  return item.quantity < 2;\n}\n\nconsole.log(inventory.findLast(isNotEnough));\n// { name: "fish", quantity: 1 }\n```\n\n#### Using arrow function and destructuring\n\nThe previous example might be written using an arrow function and [object destructuring](/en-US/docs/Web/JavaScript/Reference/Operators/Destructuring_assignment#object_destructuring):\n\n```js\nconst inventory = [\n  { name: "apples", quantity: 2 },\n  { name: "bananas", quantity: 0 },\n  { name: "fish", quantity: 1 },\n  { name: "cherries", quantity: 5 },\n];\n\nconst result = inventory.findLast(({ quantity }) => quantity < 2);\n\nconsole.log(result);\n// { name: "fish", quantity: 1 }\n```\n\n### Find the last prime number in an array\n\nThe following example returns the last element in the array that is a prime number, or {{jsxref("undefined")}} if there is no prime number.\n\n```js\nfunction isPrime(element) {\n  if (element % 2 === 0 || element < 2) {\n    return false;\n  }\n  for (let factor = 3; factor <= Math.sqrt(element); factor += 2) {\n    if (element % factor === 0) {\n      return false;\n    }\n  }\n  return true;\n}\n\nconsole.log([4, 6, 8, 12].findLast(isPrime)); // undefined, not found\nconsole.log([4, 5, 7, 8, 9, 11, 12].findLast(isPrime)); // 11\n```\n\n### Using the third argument of callbackFn\n\nThe `array` argument is useful if you want to access another element in the array, especially when you don\'t have an existing variable that refers to the array. The following example first uses `filter()` to extract the positive values and then uses `findLast()` to find the last element that is less than its neighbors.\n\n```js\nconst numbers = [3, -1, 1, 4, 1, 5, 9, 2, 6];\nconst lastTrough = numbers\n  .filter((num) => num > 0)\n  .findLast((num, idx, arr) => {\n    // Without the arr argument, there\'s no way to easily access the\n    // intermediate array without saving it to a variable.\n    if (idx > 0 && num >= arr[idx - 1]) return false;\n    if (idx < arr.length - 1 && num >= arr[idx + 1]) return false;\n    return true;\n  });\nconsole.log(lastTrough); // 2\n```\n\n### Using findLast() on sparse arrays\n\nEmpty slots in sparse arrays _are_ visited, and are treated the same as `undefined`.\n\n```js\n// Declare array with no elements at indexes 2, 3, and 4\nconst array = [0, 1, , , , 5, 6];\n\n// Shows all indexes, not just those with assigned values\narray.findLast((value, index) => {\n  console.log(`Visited index ${index} with value ${value}`);\n});\n// Visited index 6 with value 6\n// Visited index 5 with value 5\n// Visited index 4 with value undefined\n// Visited index 3 with value undefined\n// Visited index 2 with value undefined\n// Visited index 1 with value 1\n// Visited index 0 with value 0\n\n// Shows all indexes, including deleted\narray.findLast((value, index) => {\n  // Delete element 5 on first iteration\n  if (index === 6) {\n    console.log(`Deleting array[5] with value ${array[5]}`);\n    delete array[5];\n  }\n  // Element 5 is still visited even though deleted\n  console.log(`Visited index ${index} with value ${value}`);\n});\n// Deleting array[5] with value 5\n// Visited index 6 with value 6\n// Visited index 5 with value undefined\n// Visited index 4 with value undefined\n// Visited index 3 with value undefined\n// Visited index 2 with value undefined\n// Visited index 1 with value 1\n// Visited index 0 with value 0\n```\n\n### Calling findLast() on non-array objects\n\nThe `findLast()` method reads the `length` property of `this` and then accesses each property whose key is a nonnegative integer less than `length`.\n\n```js\nconst arrayLike = {\n  length: 3,\n  0: 2,\n  1: 7.3,\n  2: 4,\n  3: 3, // ignored by findLast() since length is 3\n};\nconsole.log(\n  Array.prototype.findLast.call(arrayLike, (x) => Number.isInteger(x)),\n); // 4\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Array.prototype.findLast` in `core-js`](https://github.com/zloirock/core-js#array-find-from-last)\n- [Indexed collections](/en-US/docs/Web/JavaScript/Guide/Indexed_collections) guide\n- {{jsxref("Array")}}\n- {{jsxref("Array.prototype.find()")}}\n- {{jsxref("Array.prototype.findIndex()")}}\n- {{jsxref("Array.prototype.findLastIndex()")}}\n- {{jsxref("Array.prototype.includes()")}}\n- {{jsxref("Array.prototype.filter()")}}\n- {{jsxref("Array.prototype.every()")}}\n- {{jsxref("Array.prototype.some()")}}\n- {{jsxref("TypedArray.prototype.findLast()")}}\n'
        },
        "findlastindex": {
            "index.md": '---\ntitle: Array.prototype.findLastIndex()\nslug: Web/JavaScript/Reference/Global_Objects/Array/findLastIndex\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Array.findLastIndex\n---\n\n{{JSRef}}\n\nThe **`findLastIndex()`** method of {{jsxref("Array")}} instances iterates the array in reverse order and returns the index of the first element that satisfies the provided testing function.\nIf no elements satisfy the testing function, -1 is returned.\n\nSee also the {{jsxref("Array/findLast", "findLast()")}} method, which returns the value of last element that satisfies the testing function (rather than its index).\n\n{{EmbedInteractiveExample("pages/js/array-findlastindex.html", "shorter")}}\n\n## Syntax\n\n```js-nolint\nfindLastIndex(callbackFn)\nfindLastIndex(callbackFn, thisArg)\n```\n\n### Parameters\n\n- `callbackFn`\n  - : A function to execute for each element in the array. It should return a [truthy](/en-US/docs/Glossary/Truthy) value to indicate a matching element has been found, and a [falsy](/en-US/docs/Glossary/Falsy) value otherwise. The function is called with the following arguments:\n    - `element`\n      - : The current element being processed in the array.\n    - `index`\n      - : The index of the current element being processed in the array.\n    - `array`\n      - : The array `findLastIndex()` was called upon.\n- `thisArg` {{optional_inline}}\n  - : A value to use as `this` when executing `callbackFn`. See [iterative methods](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array#iterative_methods).\n\n### Return value\n\nThe index of the last (highest-index) element in the array that passes the test.\nOtherwise `-1` if no matching element is found.\n\n## Description\n\nThe `findLastIndex()` method is an [iterative method](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array#iterative_methods). It calls a provided `callbackFn` function once for each element in an array in descending-index order, until `callbackFn` returns a [truthy](/en-US/docs/Glossary/Truthy) value. `findLastIndex()` then returns the index of that element and stops iterating through the array. If `callbackFn` never returns a truthy value, `findLastIndex()` returns `-1`. Read the [iterative methods](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array#iterative_methods) section for more information about how these methods work in general.\n\n`callbackFn` is invoked for _every_ index of the array, not just those with assigned values. Empty slots in [sparse arrays](/en-US/docs/Web/JavaScript/Guide/Indexed_collections#sparse_arrays) behave the same as `undefined`.\n\nThe `findLastIndex()` method is [generic](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array#generic_array_methods). It only expects the `this` value to have a `length` property and integer-keyed properties.\n\n## Examples\n\n### Find the index of the last prime number in an array\n\nThe following example returns the index of the last element in the array that is a prime number, or `-1` if there is no prime number.\n\n```js\nfunction isPrime(element) {\n  if (element % 2 === 0 || element < 2) {\n    return false;\n  }\n  for (let factor = 3; factor <= Math.sqrt(element); factor += 2) {\n    if (element % factor === 0) {\n      return false;\n    }\n  }\n  return true;\n}\n\nconsole.log([4, 6, 8, 12].findLastIndex(isPrime)); // -1, not found\nconsole.log([4, 5, 7, 8, 9, 11, 12].findLastIndex(isPrime)); // 5\n```\n\n### Using the third argument of callbackFn\n\nThe `array` argument is useful if you want to access another element in the array, especially when you don\'t have an existing variable that refers to the array. The following example first uses `filter()` to extract the positive values and then uses `findLastIndex()` to find the last element that is less than its neighbors.\n\n```js\nconst numbers = [3, -1, 1, 4, 1, 5, 9, 2, 6];\nconst lastTrough = numbers\n  .filter((num) => num > 0)\n  .findLastIndex((num, idx, arr) => {\n    // Without the arr argument, there\'s no way to easily access the\n    // intermediate array without saving it to a variable.\n    if (idx > 0 && num >= arr[idx - 1]) return false;\n    if (idx < arr.length - 1 && num >= arr[idx + 1]) return false;\n    return true;\n  });\nconsole.log(lastTrough); // 6\n```\n\n### Using findLastIndex() on sparse arrays\n\nYou can search for `undefined` in a sparse array and get the index of an empty slot.\n\n```js\nconsole.log([1, , 3].findLastIndex((x) => x === undefined)); // 1\n```\n\n### Calling findLastIndex() on non-array objects\n\nThe `findLastIndex()` method reads the `length` property of `this` and then accesses each property whose key is a nonnegative integer less than `length`.\n\n```js\nconst arrayLike = {\n  length: 3,\n  0: 2,\n  1: 7.3,\n  2: 4,\n  3: 3, // ignored by findLastIndex() since length is 3\n};\nconsole.log(\n  Array.prototype.findLastIndex.call(arrayLike, (x) => Number.isInteger(x)),\n); // 2\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Array.prototype.findLastIndex` in `core-js`](https://github.com/zloirock/core-js#array-find-from-last)\n- [Indexed collections](/en-US/docs/Web/JavaScript/Guide/Indexed_collections) guide\n- {{jsxref("Array")}}\n- {{jsxref("Array.prototype.find()")}}\n- {{jsxref("Array.prototype.findIndex()")}}\n- {{jsxref("Array.prototype.findLast()")}}\n- {{jsxref("Array.prototype.indexOf()")}}\n- {{jsxref("Array.prototype.lastIndexOf()")}}\n- {{jsxref("TypedArray.prototype.findLastIndex()")}}\n'
        },
        "flat": {
            "index.md": '---\ntitle: Array.prototype.flat()\nslug: Web/JavaScript/Reference/Global_Objects/Array/flat\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Array.flat\n---\n\n{{JSRef}}\n\nThe **`flat()`** method of {{jsxref("Array")}} instances creates a new array with all sub-array\nelements concatenated into it recursively up to the specified depth.\n\n{{EmbedInteractiveExample("pages/js/array-flat.html")}}\n\n## Syntax\n\n```js-nolint\nflat()\nflat(depth)\n```\n\n### Parameters\n\n- `depth` {{optional_inline}}\n  - : The depth level specifying how deep a nested array structure should be flattened.\n    Defaults to 1.\n\n### Return value\n\nA new array with the sub-array elements concatenated into it.\n\n## Description\n\nThe `flat()` method is a [copying method](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array#copying_methods_and_mutating_methods). It does not alter `this` but instead returns a [shallow copy](/en-US/docs/Glossary/Shallow_copy) that contains the same elements as the ones from the original array.\n\nThe `flat()` method ignores empty slots if the array being flattened is [sparse](/en-US/docs/Web/JavaScript/Guide/Indexed_collections#sparse_arrays). For example, if `depth` is 1, both empty slots in the root array and in the first level of nested arrays are ignored, but empty slots in further nested arrays are preserved with the arrays themselves.\n\nThe `flat()` method is [generic](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array#generic_array_methods). It only expects the `this` value to have a `length` property and integer-keyed properties. However, its elements must be arrays if they are to be flattened.\n\n## Examples\n\n### Flattening nested arrays\n\n```js\nconst arr1 = [1, 2, [3, 4]];\narr1.flat();\n// [1, 2, 3, 4]\n\nconst arr2 = [1, 2, [3, 4, [5, 6]]];\narr2.flat();\n// [1, 2, 3, 4, [5, 6]]\n\nconst arr3 = [1, 2, [3, 4, [5, 6]]];\narr3.flat(2);\n// [1, 2, 3, 4, 5, 6]\n\nconst arr4 = [1, 2, [3, 4, [5, 6, [7, 8, [9, 10]]]]];\narr4.flat(Infinity);\n// [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]\n```\n\n### Using flat() on sparse arrays\n\nThe `flat()` method removes empty slots in arrays:\n\n```js\nconst arr5 = [1, 2, , 4, 5];\nconsole.log(arr5.flat()); // [1, 2, 4, 5]\n\nconst array = [1, , 3, ["a", , "c"]];\nconsole.log(array.flat()); // [ 1, 3, "a", "c" ]\n\nconst array2 = [1, , 3, ["a", , ["d", , "e"]]];\nconsole.log(array2.flat()); // [ 1, 3, "a", ["d", empty, "e"] ]\nconsole.log(array2.flat(2)); // [ 1, 3, "a", "d", "e"]\n```\n\n### Calling flat() on non-array objects\n\nThe `flat()` method reads the `length` property of `this` and then accesses each property whose key is a nonnegative integer less than `length`. If the element is not an array, it\'s directly appended to the result. If the element is an array, it\'s flattened according to the `depth` parameter.\n\n```js\nconst arrayLike = {\n  length: 3,\n  0: [1, 2],\n  // Array-like objects aren\'t flattened\n  1: { length: 2, 0: 3, 1: 4 },\n  2: 5,\n  3: 3, // ignored by flat() since length is 3\n};\nconsole.log(Array.prototype.flat.call(arrayLike));\n// [ 1, 2, { \'0\': 3, \'1\': 4, length: 2 }, 5 ]\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Array.prototype.flat` in `core-js`](https://github.com/zloirock/core-js#ecmascript-array)\n- [Indexed collections](/en-US/docs/Web/JavaScript/Guide/Indexed_collections) guide\n- {{jsxref("Array")}}\n- {{jsxref("Array.prototype.concat()")}}\n- {{jsxref("Array.prototype.flatMap()")}}\n- {{jsxref("Array.prototype.map()")}}\n- {{jsxref("Array.prototype.reduce()")}}\n'
        },
        "flatmap": {
            "index.md": '---\ntitle: Array.prototype.flatMap()\nslug: Web/JavaScript/Reference/Global_Objects/Array/flatMap\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Array.flatMap\n---\n\n{{JSRef}}\n\nThe **`flatMap()`** method of {{jsxref("Array")}} instances returns a new array formed by applying a given callback function to each element of the array, and then flattening the result by one level. It is identical to a {{jsxref("Array/map", "map()")}} followed by a {{jsxref("Array/flat", "flat()")}} of depth 1 (`arr.map(...args).flat()`), but slightly more efficient than calling those two methods separately.\n\n{{EmbedInteractiveExample("pages/js/array-flatmap.html", "shorter")}}\n\n## Syntax\n\n```js-nolint\nflatMap(callbackFn)\nflatMap(callbackFn, thisArg)\n```\n\n### Parameters\n\n- `callbackFn`\n  - : A function to execute for each element in the array. It should return an array containing new elements of the new array, or a single non-array value to be added to the new array. The function is called with the following arguments:\n    - `element`\n      - : The current element being processed in the array.\n    - `index`\n      - : The index of the current element being processed in the array.\n    - `array`\n      - : The array `flatMap()` was called upon.\n- `thisArg` {{optional_inline}}\n  - : A value to use as `this` when executing `callbackFn`. See [iterative methods](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array#iterative_methods).\n\n### Return value\n\nA new array with each element being the result of the callback function and flattened\nby a depth of 1.\n\n## Description\n\nThe `flatMap()` method is an [iterative method](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array#iterative_methods). See {{jsxref("Array.prototype.map()")}} for a detailed description of the callback function. The `flatMap()` method is identical to [`map(callbackFn, thisArg)`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/map) followed by [`flat(1)`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/flat) \u2014 for each element, it produces an array of new elements, and concatenates the resulting arrays together to form a new array. Read the [iterative methods](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array#iterative_methods) section for more information about how these methods work in general.\n\nThe `flatMap()` method is [generic](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array#generic_array_methods). It only expects the `this` value to have a `length` property and integer-keyed properties. However, the value returned from `callbackFn` must be an array if it is to be flattened.\n\n### Alternative\n\n#### Pre-allocate and explicitly iterate\n\n```js\nconst arr = [1, 2, 3, 4];\n\narr.flatMap((x) => [x, x * 2]);\n// is equivalent to\nconst n = arr.length;\nconst acc = new Array(n * 2);\nfor (let i = 0; i < n; i++) {\n  const x = arr[i];\n  acc[i * 2] = x;\n  acc[i * 2 + 1] = x * 2;\n}\n// [1, 2, 2, 4, 3, 6, 4, 8]\n```\n\nNote that in this particular case the `flatMap` approach is slower than the\nfor-loop approach \u2014 due to the creation of temporary arrays that must be\ngarbage collected, as well as the return array not needing to be frequently\nresized. However, `flatMap` may still be the correct solution in cases where\nits flexibility and readability are desired.\n\n## Examples\n\n### map() and flatMap()\n\n```js\nconst arr1 = [1, 2, 3, 4];\n\narr1.map((x) => [x * 2]);\n// [[2], [4], [6], [8]]\n\narr1.flatMap((x) => [x * 2]);\n// [2, 4, 6, 8]\n\n// only one level is flattened\narr1.flatMap((x) => [[x * 2]]);\n// [[2], [4], [6], [8]]\n```\n\nWhile the above could have been achieved by using map itself, here is an example that\nbetter showcases the use of `flatMap()`.\n\nLet\'s generate a list of words from a list of sentences.\n\n```js\nconst arr1 = ["it\'s Sunny in", "", "California"];\n\narr1.map((x) => x.split(" "));\n// [["it\'s","Sunny","in"],[""],["California"]]\n\narr1.flatMap((x) => x.split(" "));\n// ["it\'s","Sunny","in", "", "California"]\n```\n\nNotice, the output list length can be different from the input list length.\n\n### For adding and removing items during a map()\n\n`flatMap` can be used as a way to add and remove items (modify the number of\nitems) during a `map`. In other words, it allows you to map _many items to\nmany items_ (by handling each input item separately), rather than always\n_one-to-one_. In this sense, it works like the opposite of [filter](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/filter).\nReturn a 1-element array to keep the item, a multiple-element array to add items, or a\n0-element array to remove the item.\n\n```js\n// Let\'s say we want to remove all the negative numbers\n// and split the odd numbers into an even number and a 1\nconst a = [5, 4, -3, 20, 17, -33, -4, 18];\n//         |\\  \\  x   |  | \\   x   x   |\n//        [4,1, 4,   20, 16, 1,       18]\n\nconst result = a.flatMap((n) => {\n  if (n < 0) {\n    return [];\n  }\n  return n % 2 === 0 ? [n] : [n - 1, 1];\n});\nconsole.log(result); // [4, 1, 4, 20, 16, 1, 18]\n```\n\n### Using the third argument of callbackFn\n\nThe `array` argument is useful if you want to access another element in the array, especially when you don\'t have an existing variable that refers to the array. The following example first uses `filter()` to extract operational stations and then uses `flatMap()` to create a new array where each element contains a station and its next station. On the last station, it returns an empty array to exclude it from the final array.\n\n```js\nconst stations = ["New Haven", "West Haven", "Milford (closed)", "Stratford"];\nconst line = stations\n  .filter((name) => !name.endsWith("(closed)"))\n  .flatMap((name, idx, arr) => {\n    // Without the arr argument, there\'s no way to easily access the\n    // intermediate array without saving it to a variable.\n    if (idx === arr.length - 1) return []; // last station has no next station\n    return [`${name} - ${arr[idx + 1]}`];\n  });\nconsole.log(line); // [\'New Haven - West Haven\', \'West Haven - Stratford\']\n```\n\nThe `array` argument is _not_ the array that is being built \u2014 there is no way to access the array being built from the callback function.\n\n### Using flatMap() on sparse arrays\n\nThe `callbackFn` won\'t be called for empty slots in the source array because `map()` doesn\'t, while `flat()` ignores empty slots in the returned arrays.\n\n```js\nconsole.log([1, 2, , 4, 5].flatMap((x) => [x, x * 2])); // [1, 2, 2, 4, 4, 8, 5, 10]\nconsole.log([1, 2, 3, 4].flatMap((x) => [, x * 2])); // [2, 4, 6, 8]\n```\n\n### Calling flatMap() on non-array objects\n\nThe `flatMap()` method reads the `length` property of `this` and then accesses each property whose key is a nonnegative integer less than `length`. If the return value of the callback function is not an array, it is always directly appended to the result array.\n\n```js\nconst arrayLike = {\n  length: 3,\n  0: 1,\n  1: 2,\n  2: 3,\n  3: 4, // ignored by flatMap() since length is 3\n};\nconsole.log(Array.prototype.flatMap.call(arrayLike, (x) => [x, x * 2]));\n// [1, 2, 2, 4, 3, 6]\n\n// Array-like objects returned from the callback won\'t be flattened\nconsole.log(\n  Array.prototype.flatMap.call(arrayLike, (x) => ({\n    length: 1,\n    0: x,\n  })),\n);\n// [ { \'0\': 1, length: 1 }, { \'0\': 2, length: 1 }, { \'0\': 3, length: 1 } ]\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Array.prototype.flatMap` in `core-js`](https://github.com/zloirock/core-js#ecmascript-array)\n- [Indexed collections](/en-US/docs/Web/JavaScript/Guide/Indexed_collections) guide\n- {{jsxref("Array")}}\n- {{jsxref("Array.prototype.concat()")}}\n- {{jsxref("Array.prototype.flat()")}}\n- {{jsxref("Array.prototype.map()")}}\n- {{jsxref("Array.prototype.reduce()")}}\n'
        },
        "foreach": {
            "index.md": '---\ntitle: Array.prototype.forEach()\nslug: Web/JavaScript/Reference/Global_Objects/Array/forEach\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Array.forEach\n---\n\n{{JSRef}}\n\nThe **`forEach()`** method of {{jsxref("Array")}} instances executes a provided function once\nfor each array element.\n\n{{EmbedInteractiveExample("pages/js/array-foreach.html")}}\n\n## Syntax\n\n```js-nolint\nforEach(callbackFn)\nforEach(callbackFn, thisArg)\n```\n\n### Parameters\n\n- `callbackFn`\n  - : A function to execute for each element in the array. Its return value is discarded. The function is called with the following arguments:\n    - `element`\n      - : The current element being processed in the array.\n    - `index`\n      - : The index of the current element being processed in the array.\n    - `array`\n      - : The array `forEach()` was called upon.\n- `thisArg` {{optional_inline}}\n  - : A value to use as `this` when executing `callbackFn`. See [iterative methods](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array#iterative_methods).\n\n### Return value\n\nNone ({{jsxref("undefined")}}).\n\n## Description\n\nThe `forEach()` method is an [iterative method](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array#iterative_methods). It calls a provided `callbackFn` function once for each element in an array in ascending-index order. Unlike {{jsxref("Array/map", "map()")}}, `forEach()` always returns {{jsxref("undefined")}} and is not chainable. The typical use case is to execute side effects at the end of a chain. Read the [iterative methods](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array#iterative_methods) section for more information about how these methods work in general.\n\n`callbackFn` is invoked only for array indexes which have assigned values. It is not invoked for empty slots in [sparse arrays](/en-US/docs/Web/JavaScript/Guide/Indexed_collections#sparse_arrays).\n\nThe `forEach()` method is [generic](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array#generic_array_methods). It only expects the `this` value to have a `length` property and integer-keyed properties.\n\nThere is no way to stop or break a `forEach()` loop other than by throwing an exception. If you need such behavior, the `forEach()` method is the wrong tool.\n\nEarly termination may be accomplished with looping statements like [`for`](/en-US/docs/Web/JavaScript/Reference/Statements/for), [`for...of`](/en-US/docs/Web/JavaScript/Reference/Statements/for...of), and [`for...in`](/en-US/docs/Web/JavaScript/Reference/Statements/for...in). Array methods like {{jsxref("Array/every", "every()")}}, {{jsxref("Array/some", "some()")}}, {{jsxref("Array/find", "find()")}}, and {{jsxref("Array/findIndex", "findIndex()")}} also stops iteration immediately when further iteration is not necessary.\n\n`forEach()` expects a synchronous function \u2014 it does not wait for promises. Make sure you are aware of the implications while using promises (or async functions) as `forEach` callbacks.\n\n```js\nconst ratings = [5, 4, 5];\nlet sum = 0;\n\nconst sumFunction = async (a, b) => a + b;\n\nratings.forEach(async (rating) => {\n  sum = await sumFunction(sum, rating);\n});\n\nconsole.log(sum);\n// Naively expected output: 14\n// Actual output: 0\n```\n\nTo run a series of asynchronous operations sequentially or concurrently, see [promise composition](/en-US/docs/Web/JavaScript/Guide/Using_promises#composition).\n\n## Examples\n\n### Converting a for loop to forEach\n\n```js\nconst items = ["item1", "item2", "item3"];\nconst copyItems = [];\n\n// before\nfor (let i = 0; i < items.length; i++) {\n  copyItems.push(items[i]);\n}\n\n// after\nitems.forEach((item) => {\n  copyItems.push(item);\n});\n```\n\n### Printing the contents of an array\n\n> **Note:** In order to display the content of an array in the console,\n> you can use {{domxref("console/table_static", "console.table()")}}, which prints a formatted\n> version of the array.\n>\n> The following example illustrates an alternative approach, using\n> `forEach()`.\n\nThe following code logs a line for each element in an array:\n\n```js\nconst logArrayElements = (element, index /*, array */) => {\n  console.log(`a[${index}] = ${element}`);\n};\n\n// Notice that index 2 is skipped, since there is no item at\n// that position in the array.\n[2, 5, , 9].forEach(logArrayElements);\n// Logs:\n// a[0] = 2\n// a[1] = 5\n// a[3] = 9\n```\n\n### Using thisArg\n\nThe following (contrived) example updates an object\'s properties from each entry in the\narray:\n\n```js\nclass Counter {\n  constructor() {\n    this.sum = 0;\n    this.count = 0;\n  }\n  add(array) {\n    // Only function expressions have their own this bindings.\n    array.forEach(function countEntry(entry) {\n      this.sum += entry;\n      ++this.count;\n    }, this);\n  }\n}\n\nconst obj = new Counter();\nobj.add([2, 5, 9]);\nconsole.log(obj.count); // 3\nconsole.log(obj.sum); // 16\n```\n\nSince the `thisArg` parameter (`this`) is provided to\n`forEach()`, it is passed to `callback` each time it\'s\ninvoked. The callback uses it as its `this` value.\n\n> **Note:** If passing the callback function used an\n> [arrow function expression](/en-US/docs/Web/JavaScript/Reference/Functions/Arrow_functions),\n> the `thisArg` parameter could be omitted,\n> since all arrow functions lexically bind the {{jsxref("Operators/this", "this")}}\n> value.\n\n### An object copy function\n\nThe following code creates a copy of a given object.\n\nThere are different ways to create a copy of an object. The following is just one way\nand is presented to explain how `Array.prototype.forEach()` works by using\n`Object.*` utility functions.\n\n```js\nconst copy = (obj) => {\n  const copy = Object.create(Object.getPrototypeOf(obj));\n  const propNames = Object.getOwnPropertyNames(obj);\n  propNames.forEach((name) => {\n    const desc = Object.getOwnPropertyDescriptor(obj, name);\n    Object.defineProperty(copy, name, desc);\n  });\n  return copy;\n};\n\nconst obj1 = { a: 1, b: 2 };\nconst obj2 = copy(obj1); // obj2 looks like obj1 now\n```\n\n### Flatten an array\n\nThe following example is only here for learning purpose. If you want to flatten an\narray using built-in methods, you can use {{jsxref("Array.prototype.flat()")}}.\n\n```js\nconst flatten = (arr) => {\n  const result = [];\n  arr.forEach((item) => {\n    if (Array.isArray(item)) {\n      result.push(...flatten(item));\n    } else {\n      result.push(item);\n    }\n  });\n  return result;\n};\n\n// Usage\nconst nested = [1, 2, 3, [4, 5, [6, 7], 8, 9]];\nconsole.log(flatten(nested)); // [1, 2, 3, 4, 5, 6, 7, 8, 9]\n```\n\n### Using the third argument of callbackFn\n\nThe `array` argument is useful if you want to access another element in the array, especially when you don\'t have an existing variable that refers to the array. The following example first uses `filter()` to extract the positive values and then uses `forEach()` to log its neighbors.\n\n```js\nconst numbers = [3, -1, 1, 4, 1, 5];\nnumbers\n  .filter((num) => num > 0)\n  .forEach((num, idx, arr) => {\n    // Without the arr argument, there\'s no way to easily access the\n    // intermediate array without saving it to a variable.\n    console.log(arr[idx - 1], num, arr[idx + 1]);\n  });\n// undefined 3 1\n// 3 1 4\n// 1 4 1\n// 4 1 5\n// 1 5 undefined\n```\n\n### Using forEach() on sparse arrays\n\n```js-nolint\nconst arraySparse = [1, 3, /* empty */, 7];\nlet numCallbackRuns = 0;\n\narraySparse.forEach((element) => {\n  console.log({ element });\n  numCallbackRuns++;\n});\n\nconsole.log({ numCallbackRuns });\n\n// { element: 1 }\n// { element: 3 }\n// { element: 7 }\n// { numCallbackRuns: 3 }\n```\n\nThe callback function is not invoked for the missing value at index 2.\n\n### Calling forEach() on non-array objects\n\nThe `forEach()` method reads the `length` property of `this` and then accesses each property whose key is a nonnegative integer less than `length`.\n\n```js\nconst arrayLike = {\n  length: 3,\n  0: 2,\n  1: 3,\n  2: 4,\n  3: 5, // ignored by forEach() since length is 3\n};\nArray.prototype.forEach.call(arrayLike, (x) => console.log(x));\n// 2\n// 3\n// 4\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Array.prototype.forEach` in `core-js`](https://github.com/zloirock/core-js#ecmascript-array)\n- [Indexed collections](/en-US/docs/Web/JavaScript/Guide/Indexed_collections) guide\n- {{jsxref("Array")}}\n- {{jsxref("Array.prototype.find()")}}\n- {{jsxref("Array.prototype.map()")}}\n- {{jsxref("Array.prototype.filter()")}}\n- {{jsxref("Array.prototype.every()")}}\n- {{jsxref("Array.prototype.some()")}}\n- {{jsxref("TypedArray.prototype.forEach()")}}\n- {{jsxref("Map.prototype.forEach()")}}\n- {{jsxref("Set.prototype.forEach()")}}\n'
        },
        "from": {
            "index.md": '---\ntitle: Array.from()\nslug: Web/JavaScript/Reference/Global_Objects/Array/from\npage-type: javascript-static-method\nbrowser-compat: javascript.builtins.Array.from\n---\n\n{{JSRef}}\n\nThe **`Array.from()`** static method creates a new, shallow-copied `Array` instance from an [iterable](/en-US/docs/Web/JavaScript/Reference/Iteration_protocols#the_iterable_protocol) or [array-like](/en-US/docs/Web/JavaScript/Guide/Indexed_collections#working_with_array-like_objects) object.\n\n{{EmbedInteractiveExample("pages/js/array-from.html", "shorter")}}\n\n## Syntax\n\n```js-nolint\nArray.from(arrayLike)\nArray.from(arrayLike, mapFn)\nArray.from(arrayLike, mapFn, thisArg)\n```\n\n### Parameters\n\n- `arrayLike`\n  - : An iterable or array-like object to convert to an array.\n- `mapFn` {{optional_inline}}\n  - : A function to call on every element of the array. If provided, every value to be added to the array is first passed through this function, and `mapFn`\'s return value is added to the array instead. The function is called with the following arguments:\n    - `element`\n      - : The current element being processed in the array.\n    - `index`\n      - : The index of the current element being processed in the array.\n- `thisArg` {{optional_inline}}\n  - : Value to use as `this` when executing `mapFn`.\n\n### Return value\n\nA new {{jsxref("Array")}} instance.\n\n## Description\n\n`Array.from()` lets you create `Array`s from:\n\n- [iterable objects](/en-US/docs/Web/JavaScript/Reference/Iteration_protocols) (objects such as {{jsxref("Map")}} and {{jsxref("Set")}}); or, if the object is not iterable,\n- array-like objects (objects with a `length` property and indexed elements).\n\nTo convert an ordinary object that\'s not iterable or array-like to an array (by enumerating its property keys, values, or both), use {{jsxref("Object.keys()")}}, {{jsxref("Object.values()")}}, or {{jsxref("Object.entries()")}}. To convert an [async iterable](/en-US/docs/Web/JavaScript/Reference/Iteration_protocols#the_async_iterator_and_async_iterable_protocols) to an array, use {{jsxref("Array.fromAsync()")}}.\n\n`Array.from()` never creates a sparse array. If the `arrayLike` object is missing some index properties, they become `undefined` in the new array.\n\n`Array.from()` has an optional parameter `mapFn`, which allows you to execute a function on each element of the array being created, similar to {{jsxref("Array/map", "map()")}}. More clearly, `Array.from(obj, mapFn, thisArg)` has the same result as `Array.from(obj).map(mapFn, thisArg)`, except that it does not create an intermediate array, and `mapFn` only receives two arguments (`element`, `index`) without the whole array, because the array is still under construction.\n\n> **Note:** This behavior is more important for [typed arrays](/en-US/docs/Web/JavaScript/Guide/Typed_arrays), since the intermediate array would necessarily have values truncated to fit into the appropriate type. `Array.from()` is implemented to have the same signature as {{jsxref("TypedArray.from()")}}.\n\nThe `Array.from()` method is a generic factory method. For example, if a subclass of `Array` inherits the `from()` method, the inherited `from()` method will return new instances of the subclass instead of `Array` instances. In fact, the `this` value can be any constructor function that accepts a single argument representing the length of the new array. When an iterable is passed as `arrayLike`, the constructor is called with no arguments; when an array-like object is passed, the constructor is called with the [normalized length](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array#normalization_of_the_length_property) of the array-like object. The final `length` will be set again when iteration finishes. If the `this` value is not a constructor function, the plain `Array` constructor is used instead.\n\n## Examples\n\n### Array from a String\n\n```js\nArray.from("foo");\n// [ "f", "o", "o" ]\n```\n\n### Array from a Set\n\n```js\nconst set = new Set(["foo", "bar", "baz", "foo"]);\nArray.from(set);\n// [ "foo", "bar", "baz" ]\n```\n\n### Array from a Map\n\n```js\nconst map = new Map([\n  [1, 2],\n  [2, 4],\n  [4, 8],\n]);\nArray.from(map);\n// [[1, 2], [2, 4], [4, 8]]\n\nconst mapper = new Map([\n  ["1", "a"],\n  ["2", "b"],\n]);\nArray.from(mapper.values());\n// [\'a\', \'b\'];\n\nArray.from(mapper.keys());\n// [\'1\', \'2\'];\n```\n\n### Array from a NodeList\n\n```js\n// Create an array based on a property of DOM Elements\nconst images = document.querySelectorAll("img");\nconst sources = Array.from(images, (image) => image.src);\nconst insecureSources = sources.filter((link) => link.startsWith("http://"));\n```\n\n### Array from an Array-like object (arguments)\n\n```js\nfunction f() {\n  return Array.from(arguments);\n}\n\nf(1, 2, 3);\n\n// [ 1, 2, 3 ]\n```\n\n### Using arrow functions and Array.from()\n\n```js\n// Using an arrow function as the map function to\n// manipulate the elements\nArray.from([1, 2, 3], (x) => x + x);\n// [2, 4, 6]\n\n// Generate a sequence of numbers\n// Since the array is initialized with `undefined` on each position,\n// the value of `v` below will be `undefined`\nArray.from({ length: 5 }, (v, i) => i);\n// [0, 1, 2, 3, 4]\n```\n\n### Sequence generator (range)\n\n```js\n// Sequence generator function (commonly referred to as "range", e.g. Clojure, PHP, etc.)\nconst range = (start, stop, step) =>\n  Array.from({ length: (stop - start) / step + 1 }, (_, i) => start + i * step);\n\n// Generate numbers range 0..4\nrange(0, 4, 1);\n// [0, 1, 2, 3, 4]\n\n// Generate numbers range 1..10 with step of 2\nrange(1, 10, 2);\n// [1, 3, 5, 7, 9]\n\n// Generate the alphabet using Array.from making use of it being ordered as a sequence\nrange("A".charCodeAt(0), "Z".charCodeAt(0), 1).map((x) =>\n  String.fromCharCode(x),\n);\n// ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"]\n```\n\n### Calling from() on non-array constructors\n\nThe `from()` method can be called on any constructor function that accepts a single argument representing the length of the new array.\n\n```js\nfunction NotArray(len) {\n  console.log("NotArray called with length", len);\n}\n\n// Iterable\nconsole.log(Array.from.call(NotArray, new Set(["foo", "bar", "baz"])));\n// NotArray called with length undefined\n// NotArray { \'0\': \'foo\', \'1\': \'bar\', \'2\': \'baz\', length: 3 }\n\n// Array-like\nconsole.log(Array.from.call(NotArray, { length: 1, 0: "foo" }));\n// NotArray called with length 1\n// NotArray { \'0\': \'foo\', length: 1 }\n```\n\nWhen the `this` value is not a constructor, a plain `Array` object is returned.\n\n```js\nconsole.log(Array.from.call({}, { length: 1, 0: "foo" })); // [ \'foo\' ]\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Array.from` in `core-js`](https://github.com/zloirock/core-js#ecmascript-array)\n- [Indexed collections](/en-US/docs/Web/JavaScript/Guide/Indexed_collections) guide\n- {{jsxref("Array")}}\n- {{jsxref("Array/Array", "Array()")}}\n- {{jsxref("Array.of()")}}\n- {{jsxref("Array.fromAsync()")}}\n- {{jsxref("Array.prototype.map()")}}\n- {{jsxref("TypedArray.from()")}}\n'
        },
        "fromasync": {
            "index.md": '---\ntitle: Array.fromAsync()\nslug: Web/JavaScript/Reference/Global_Objects/Array/fromAsync\npage-type: javascript-static-method\nbrowser-compat: javascript.builtins.Array.fromAsync\n---\n\n{{JSRef}}\n\nThe **`Array.fromAsync()`** static method creates a new, shallow-copied `Array` instance from an [async iterable](/en-US/docs/Web/JavaScript/Reference/Iteration_protocols#the_async_iterator_and_async_iterable_protocols), [iterable](/en-US/docs/Web/JavaScript/Reference/Iteration_protocols#the_iterable_protocol), or [array-like](/en-US/docs/Web/JavaScript/Guide/Indexed_collections#working_with_array-like_objects) object.\n\n## Syntax\n\n```js-nolint\nArray.fromAsync(arrayLike)\nArray.fromAsync(arrayLike, mapFn)\nArray.fromAsync(arrayLike, mapFn, thisArg)\n```\n\n### Parameters\n\n- `arrayLike`\n  - : An async iterable, iterable, or array-like object to convert to an array.\n- `mapFn` {{optional_inline}}\n  - : A function to call on every element of the array. If provided, every value to be added to the array is first passed through this function, and `mapFn`\'s return value is added to the array instead (after being [awaited](/en-US/docs/Web/JavaScript/Reference/Operators/await)). The function is called with the following arguments:\n    - `element`\n      - : The current element being processed in the array. Because all elements are first [awaited](/en-US/docs/Web/JavaScript/Reference/Operators/await), this value will never be a [thenable](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise#thenables).\n    - `index`\n      - : The index of the current element being processed in the array.\n- `thisArg` {{optional_inline}}\n  - : Value to use as `this` when executing `mapFn`.\n\n### Return value\n\nA new {{jsxref("Promise")}} whose fulfillment value is a new {{jsxref("Array")}} instance.\n\n## Description\n\n`Array.fromAsync()` lets you create arrays from:\n\n- [async iterable objects](/en-US/docs/Web/JavaScript/Reference/Iteration_protocols#the_async_iterator_and_async_iterable_protocols) (objects such as {{domxref("ReadableStream")}} and {{jsxref("AsyncGenerator")}}); or, if the object is not async iterable,\n- [iterable objects](/en-US/docs/Web/JavaScript/Reference/Iteration_protocols#the_iterable_protocol) (objects such as {{jsxref("Map")}} and {{jsxref("Set")}}); or, if the object is not iterable,\n- array-like objects (objects with a `length` property and indexed elements).\n\n`Array.fromAsync()` iterates the async iterable in a fashion very similar to {{jsxref("Statements/for-await...of", "for await...of")}}. `Array.fromAsync()` is almost equivalent to {{jsxref("Array.from()")}} in terms of behavior, except the following:\n\n- `Array.fromAsync()` handles async iterable objects.\n- `Array.fromAsync()` returns a {{jsxref("Promise")}} that fulfills to the array instance.\n- If `Array.fromAsync()` is called with a non-async iterable object, each element to be added to the array is first [awaited](/en-US/docs/Web/JavaScript/Reference/Operators/await).\n- If a `mapFn` is provided, its input and output are internally awaited.\n\n`Array.fromAsync()` and {{jsxref("Promise.all()")}} can both turn an iterable of promises into a promise of an array. However, there are two key differences:\n\n- `Array.fromAsync()` awaits each value yielded from the object sequentially. `Promise.all()` awaits all values concurrently.\n- `Array.fromAsync()` iterates the iterable lazily, and doesn\'t retrieve the next value until the current one is settled. `Promise.all()` retrieves all values in advance and awaits them all.\n\n## Examples\n\n### Array from an async iterable\n\n```js\nconst asyncIterable = (async function* () {\n  for (let i = 0; i < 5; i++) {\n    await new Promise((resolve) => setTimeout(resolve, 10 * i));\n    yield i;\n  }\n})();\n\nArray.fromAsync(asyncIterable).then((array) => console.log(array));\n// [0, 1, 2, 3, 4]\n```\n\n### Array from a sync iterable\n\n```js\nArray.fromAsync(\n  new Map([\n    [1, 2],\n    [3, 4],\n  ]),\n).then((array) => console.log(array));\n// [[1, 2], [3, 4]]\n```\n\n### Array from a sync iterable that yields promises\n\n```js\nArray.fromAsync(\n  new Set([Promise.resolve(1), Promise.resolve(2), Promise.resolve(3)]),\n).then((array) => console.log(array));\n// [1, 2, 3]\n```\n\n### Array from an array-like object of promises\n\n```js\nArray.fromAsync({\n  length: 3,\n  0: Promise.resolve(1),\n  1: Promise.resolve(2),\n  2: Promise.resolve(3),\n}).then((array) => console.log(array));\n// [1, 2, 3]\n```\n\n### Using mapFn\n\nBoth the input and output of `mapFn` are awaited internally by `Array.fromAsync()`.\n\n```js\nfunction delayedValue(v) {\n  return new Promise((resolve) => setTimeout(() => resolve(v), 100));\n}\n\nArray.fromAsync(\n  [delayedValue(1), delayedValue(2), delayedValue(3)],\n  (element) => delayedValue(element * 2),\n).then((array) => console.log(array));\n// [2, 4, 6]\n```\n\n### Comparison with Promise.all()\n\n`Array.fromAsync()` awaits each value yielded from the object sequentially. `Promise.all()` awaits all values concurrently.\n\n```js\nfunction* makeIterableOfPromises() {\n  for (let i = 0; i < 5; i++) {\n    yield new Promise((resolve) => setTimeout(resolve, 100));\n  }\n}\n\n(async () => {\n  console.time("Array.fromAsync() time");\n  await Array.fromAsync(makeIterableOfPromises());\n  console.timeEnd("Array.fromAsync() time");\n  // Array.fromAsync() time: 503.610ms\n\n  console.time("Promise.all() time");\n  await Promise.all(makeIterableOfPromises());\n  console.timeEnd("Promise.all() time");\n  // Promise.all() time: 101.728ms\n})();\n```\n\n### No error handling for sync iterables\n\nSimilar to [`for await...of`](/en-US/docs/Web/JavaScript/Reference/Statements/for-await...of#iterating_over_sync_iterables_and_generators), if the object being iterated is a sync iterable, and an error is thrown while iterating, the `return()` method of the underlying iterator will not be called, so the iterator is not closed.\n\n```js\nfunction* generatorWithRejectedPromises() {\n  try {\n    yield 0;\n    yield Promise.reject(3);\n  } finally {\n    console.log("called finally");\n  }\n}\n\n(async () => {\n  try {\n    await Array.fromAsync(generatorWithRejectedPromises());\n  } catch (e) {\n    console.log("caught", e);\n  }\n})();\n// caught 3\n// No "called finally" message\n```\n\nIf you need to close the iterator, you need to use a {{jsxref("Statements/for...of", "for...of")}} loop instead, and `await` each value yourself.\n\n```js\n(async () => {\n  const arr = [];\n  try {\n    for (const val of generatorWithRejectedPromises()) {\n      arr.push(await val);\n    }\n  } catch (e) {\n    console.log("caught", e);\n  }\n})();\n// called finally\n// caught 3\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Array.fromAsync` in `core-js`](https://github.com/zloirock/core-js#arrayfromasync)\n- [Indexed collections](/en-US/docs/Web/JavaScript/Guide/Indexed_collections) guide\n- {{jsxref("Array")}}\n- {{jsxref("Array/Array", "Array()")}}\n- {{jsxref("Array.of()")}}\n- {{jsxref("Array.from()")}}\n- {{jsxref("Statements/for-await...of", "for await...of")}}\n'
        },
        "includes": {
            "index.md": '---\ntitle: Array.prototype.includes()\nslug: Web/JavaScript/Reference/Global_Objects/Array/includes\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Array.includes\n---\n\n{{JSRef}}\n\nThe **`includes()`** method of {{jsxref("Array")}} instances determines whether an array\nincludes a certain value among its entries, returning `true` or\n`false` as appropriate.\n\n{{EmbedInteractiveExample("pages/js/array-includes.html")}}\n\n## Syntax\n\n```js-nolint\nincludes(searchElement)\nincludes(searchElement, fromIndex)\n```\n\n### Parameters\n\n- `searchElement`\n  - : The value to search for.\n- `fromIndex` {{optional_inline}}\n  - : Zero-based index at which to start searching, [converted to an integer](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number#integer_conversion).\n    - Negative index counts back from the end of the array \u2014 if `-array.length <= fromIndex < 0`, `fromIndex + array.length` is used. However, the array is still searched from front to back in this case.\n    - If `fromIndex < -array.length` or `fromIndex` is omitted, `0` is used, causing the entire array to be searched.\n    - If `fromIndex >= array.length`, the array is not searched and `false` is returned.\n\n### Return value\n\nA boolean value which is `true` if the value `searchElement` is found within the array (or the part of the array indicated by the index `fromIndex`, if specified).\n\n## Description\n\nThe `includes()` method compares `searchElement` to elements of the array using the [SameValueZero](/en-US/docs/Web/JavaScript/Equality_comparisons_and_sameness#same-value-zero_equality) algorithm. Values of zero are all considered to be equal, regardless of sign. (That is, `-0` is equal to `0`), but `false` is _not_ considered to be the same as `0`. [`NaN`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/NaN) can be correctly searched for.\n\nWhen used on [sparse arrays](/en-US/docs/Web/JavaScript/Guide/Indexed_collections#sparse_arrays), the `includes()` method iterates empty slots as if they have the value `undefined`.\n\nThe `includes()` method is [generic](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array#generic_array_methods). It only expects the `this` value to have a `length` property and integer-keyed properties.\n\n## Examples\n\n### Using includes()\n\n```js\n[1, 2, 3].includes(2); // true\n[1, 2, 3].includes(4); // false\n[1, 2, 3].includes(3, 3); // false\n[1, 2, 3].includes(3, -1); // true\n[1, 2, NaN].includes(NaN); // true\n["1", "2", "3"].includes(3); // false\n```\n\n### fromIndex is greater than or equal to the array length\n\nIf `fromIndex` is greater than or equal to the length of the\narray, `false` is returned. The array will not be searched.\n\n```js\nconst arr = ["a", "b", "c"];\n\narr.includes("c", 3); // false\narr.includes("c", 100); // false\n```\n\n### Computed index is less than 0\n\nIf `fromIndex` is negative, the computed index is calculated to\nbe used as a position in the array at which to begin searching for\n`searchElement`. If the computed index is less than or equal to\n`0`, the entire array will be searched.\n\n```js\n// array length is 3\n// fromIndex is -100\n// computed index is 3 + (-100) = -97\n\nconst arr = ["a", "b", "c"];\n\narr.includes("a", -100); // true\narr.includes("b", -100); // true\narr.includes("c", -100); // true\narr.includes("a", -2); // false\n```\n\n### Using includes() on sparse arrays\n\nYou can search for `undefined` in a sparse array and get `true`.\n\n```js\nconsole.log([1, , 3].includes(undefined)); // true\n```\n\n### Calling includes() on non-array objects\n\nThe `includes()` method reads the `length` property of `this` and then accesses each property whose key is a nonnegative integer less than `length`.\n\n```js\nconst arrayLike = {\n  length: 3,\n  0: 2,\n  1: 3,\n  2: 4,\n  3: 1, // ignored by includes() since length is 3\n};\nconsole.log(Array.prototype.includes.call(arrayLike, 2));\n// true\nconsole.log(Array.prototype.includes.call(arrayLike, 1));\n// false\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Array.prototype.includes` in `core-js`](https://github.com/zloirock/core-js#ecmascript-array)\n- [Indexed collections](/en-US/docs/Web/JavaScript/Guide/Indexed_collections) guide\n- {{jsxref("Array")}}\n- {{jsxref("Array.prototype.indexOf()")}}\n- {{jsxref("Array.prototype.find()")}}\n- {{jsxref("Array.prototype.findIndex()")}}\n- {{jsxref("TypedArray.prototype.includes()")}}\n- {{jsxref("String.prototype.includes()")}}\n'
        },
        "index.md": '---\ntitle: Array\nslug: Web/JavaScript/Reference/Global_Objects/Array\npage-type: javascript-class\nbrowser-compat: javascript.builtins.Array\n---\n\n{{JSRef}}\n\nThe **`Array`** object, as with arrays in other programming languages, enables [storing a collection of multiple items under a single variable name](/en-US/docs/Learn/JavaScript/First_steps/Arrays), and has members for [performing common array operations](#examples).\n\n## Description\n\nIn JavaScript, arrays aren\'t [primitives](/en-US/docs/Glossary/Primitive) but are instead `Array` objects with the following core characteristics:\n\n- **JavaScript arrays are resizable** and **can contain a mix of different [data types](/en-US/docs/Web/JavaScript/Data_structures)**. (When those characteristics are undesirable, use [typed arrays](/en-US/docs/Web/JavaScript/Guide/Typed_arrays) instead.)\n- **JavaScript arrays are not associative arrays** and so, array elements cannot be accessed using arbitrary strings as indexes, but must be accessed using nonnegative integers (or their respective string form) as indexes.\n- **JavaScript arrays are [zero-indexed](https://en.wikipedia.org/wiki/Zero-based_numbering)**: the first element of an array is at index `0`, the second is at index `1`, and so on \u2014 and the last element is at the value of the array\'s {{jsxref("Array/length", "length")}} property minus `1`.\n- **JavaScript [array-copy operations](#copy_an_array) create [shallow copies](/en-US/docs/Glossary/Shallow_copy)**. (All standard built-in copy operations with _any_ JavaScript objects create shallow copies, rather than [deep copies](/en-US/docs/Glossary/Deep_copy)).\n\n### Array indices\n\n`Array` objects cannot use arbitrary strings as element indexes (as in an [associative array](https://en.wikipedia.org/wiki/Associative_array)) but must use nonnegative integers (or their respective string form). Setting or accessing via non-integers will not set or retrieve an element from the array list itself, but will set or access a variable associated with that array\'s [object property collection](/en-US/docs/Web/JavaScript/Data_structures#properties). The array\'s object properties and list of array elements are separate, and the array\'s [traversal and mutation operations](/en-US/docs/Web/JavaScript/Guide/Indexed_collections#array_methods) cannot be applied to these named properties.\n\nArray elements are object properties in the same way that `toString` is a property (to be specific, however, `toString()` is a method). Nevertheless, trying to access an element of an array as follows throws a syntax error because the property name is not valid:\n\n```js-nolint example-bad\narr.0; // a syntax error\n```\n\nJavaScript syntax requires properties beginning with a digit to be accessed using [bracket notation](/en-US/docs/Web/JavaScript/Guide/Working_with_objects#objects_and_properties) instead of [dot notation](/en-US/docs/Web/JavaScript/Reference/Operators/Property_accessors). It\'s also possible to quote the array indices (e.g., `years[\'2\']` instead of `years[2]`), although usually not necessary.\n\nThe `2` in `years[2]` is coerced into a string by the JavaScript engine through an implicit `toString` conversion. As a result, `\'2\'` and `\'02\'` would refer to two different slots on the `years` object, and the following example could be `true`:\n\n```js\nconsole.log(years["2"] !== years["02"]);\n```\n\nOnly `years[\'2\']` is an actual array index. `years[\'02\']` is an arbitrary string property that will not be visited in array iteration.\n\n### Relationship between length and numerical properties\n\nA JavaScript array\'s {{jsxref("Array/length", "length")}} property and numerical properties are connected.\n\nSeveral of the built-in array methods (e.g., {{jsxref("Array/join", "join()")}}, {{jsxref("Array/slice", "slice()")}}, {{jsxref("Array/indexOf", "indexOf()")}}, etc.) take into account the value of an array\'s {{jsxref("Array/length", "length")}} property when they\'re called.\n\nOther methods (e.g., {{jsxref("Array/push", "push()")}}, {{jsxref("Array/splice", "splice()")}}, etc.) also result in updates to an array\'s {{jsxref("Array/length", "length")}} property.\n\n```js\nconst fruits = [];\nfruits.push("banana", "apple", "peach");\nconsole.log(fruits.length); // 3\n```\n\nWhen setting a property on a JavaScript array when the property is a valid array index and that index is outside the current bounds of the array, the engine will update the array\'s {{jsxref("Array/length", "length")}} property accordingly:\n\n```js\nfruits[5] = "mango";\nconsole.log(fruits[5]); // \'mango\'\nconsole.log(Object.keys(fruits)); // [\'0\', \'1\', \'2\', \'5\']\nconsole.log(fruits.length); // 6\n```\n\nIncreasing the {{jsxref("Array/length", "length")}} extends the array by adding empty slots without creating any new elements \u2014 not even `undefined`.\n\n```js\nfruits.length = 10;\nconsole.log(fruits); // [\'banana\', \'apple\', \'peach\', empty x 2, \'mango\', empty x 4]\nconsole.log(Object.keys(fruits)); // [\'0\', \'1\', \'2\', \'5\']\nconsole.log(fruits.length); // 10\nconsole.log(fruits[8]); // undefined\n```\n\nDecreasing the {{jsxref("Array/length", "length")}} property does, however, delete elements.\n\n```js\nfruits.length = 2;\nconsole.log(Object.keys(fruits)); // [\'0\', \'1\']\nconsole.log(fruits.length); // 2\n```\n\nThis is explained further on the {{jsxref("Array/length", "length")}} page.\n\n### Array methods and empty slots\n\nArray methods have different behaviors when encountering empty slots in [sparse arrays](/en-US/docs/Web/JavaScript/Guide/Indexed_collections#sparse_arrays). In general, older methods (e.g. `forEach`) treat empty slots differently from indices that contain `undefined`.\n\nMethods that have special treatment for empty slots include the following: {{jsxref("Array/concat", "concat()")}}, {{jsxref("Array/copyWithin", "copyWithin()")}}, {{jsxref("Array/every", "every()")}}, {{jsxref("Array/filter", "filter()")}}, {{jsxref("Array/flat", "flat()")}}, {{jsxref("Array/flatMap", "flatMap()")}}, {{jsxref("Array/forEach", "forEach()")}}, {{jsxref("Array/indexOf", "indexOf()")}}, {{jsxref("Array/lastIndexOf", "lastIndexOf()")}}, {{jsxref("Array/map", "map()")}}, {{jsxref("Array/reduce", "reduce()")}}, {{jsxref("Array/reduceRight", "reduceRight()")}}, {{jsxref("Array/reverse", "reverse()")}}, {{jsxref("Array/slice", "slice()")}}, {{jsxref("Array/some", "some()")}}, {{jsxref("Array/sort", "sort()")}}, and {{jsxref("Array/splice", "splice()")}}. Iteration methods such as `forEach` don\'t visit empty slots at all. Other methods, such as `concat`, `copyWithin`, etc., preserve empty slots when doing the copying, so in the end the array is still sparse.\n\n```js\nconst colors = ["red", "yellow", "blue"];\ncolors[5] = "purple";\ncolors.forEach((item, index) => {\n  console.log(`${index}: ${item}`);\n});\n// Output:\n// 0: red\n// 1: yellow\n// 2: blue\n// 5: purple\n\ncolors.reverse(); // [\'purple\', empty \xd7 2, \'blue\', \'yellow\', \'red\']\n```\n\nNewer methods (e.g. `keys`) do not treat empty slots specially and treat them as if they contain `undefined`. Methods that conflate empty slots with `undefined` elements include the following: {{jsxref("Array/entries", "entries()")}}, {{jsxref("Array/fill", "fill()")}}, {{jsxref("Array/find", "find()")}}, {{jsxref("Array/findIndex", "findIndex()")}}, {{jsxref("Array/findLast", "findLast()")}}, {{jsxref("Array/findLastIndex", "findLastIndex()")}}, {{jsxref("Array/includes", "includes()")}}, {{jsxref("Array/join", "join()")}}, {{jsxref("Array/keys", "keys()")}}, {{jsxref("Array/toLocaleString", "toLocaleString()")}}, {{jsxref("Array/toReversed", "toReversed()")}}, {{jsxref("Array/toSorted", "toSorted()")}}, {{jsxref("Array/toSpliced", "toSpliced()")}}, {{jsxref("Array/values", "values()")}}, and {{jsxref("Array/with", "with()")}}.\n\n```js\nconst colors = ["red", "yellow", "blue"];\ncolors[5] = "purple";\nconst iterator = colors.keys();\nfor (const key of iterator) {\n  console.log(`${key}: ${colors[key]}`);\n}\n// Output\n// 0: red\n// 1: yellow\n// 2: blue\n// 3: undefined\n// 4: undefined\n// 5: purple\n\nconst newColors = colors.toReversed(); // [\'purple\', undefined, undefined, \'blue\', \'yellow\', \'red\']\n```\n\n### Copying methods and mutating methods\n\nSome methods do not mutate the existing array that the method was called on, but instead return a new array. They do so by first constructing a new array and then populating it with elements. The copy always happens [_shallowly_](/en-US/docs/Glossary/Shallow_copy) \u2014 the method never copies anything beyond the initially created array. Elements of the original array(s) are copied into the new array as follows:\n\n- Objects: the object reference is copied into the new array. Both the original and new array refer to the same object. That is, if a referenced object is modified, the changes are visible to both the new and original arrays.\n- Primitive types such as strings, numbers and booleans (not {{jsxref("String")}}, {{jsxref("Number")}}, and {{jsxref("Boolean")}} objects): their values are copied into the new array.\n\nOther methods mutate the array that the method was called on, in which case their return value differs depending on the method: sometimes a reference to the same array, sometimes the length of the new array.\n\nThe following methods create new arrays by accessing [`this.constructor[Symbol.species]`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/@@species) to determine the constructor to use: {{jsxref("Array/concat", "concat()")}}, {{jsxref("Array/filter", "filter()")}}, {{jsxref("Array/flat", "flat()")}}, {{jsxref("Array/flatMap", "flatMap()")}}, {{jsxref("Array/map", "map()")}}, {{jsxref("Array/slice", "slice()")}}, and {{jsxref("Array/splice", "splice()")}} (to construct the array of removed elements that\'s returned).\n\nThe following methods always create new arrays with the `Array` base constructor: {{jsxref("Array/toReversed", "toReversed()")}}, {{jsxref("Array/toSorted", "toSorted()")}}, {{jsxref("Array/toSpliced", "toSpliced()")}}, and {{jsxref("Array/with", "with()")}}.\n\nThe following table lists the methods that mutate the original array, and the corresponding non-mutating alternative:\n\n| Mutating method                                | Non-mutating alternative                                 |\n| ---------------------------------------------- | -------------------------------------------------------- |\n| {{jsxref("Array/copyWithin", "copyWithin()")}} | No one-method alternative                                |\n| {{jsxref("Array/fill", "fill()")}}             | No one-method alternative                                |\n| {{jsxref("Array/pop", "pop()")}}               | {{jsxref("Array/slice", "slice(0, -1)")}}                |\n| {{jsxref("Array/push", "push(v1, v2)")}}       | {{jsxref("Array/concat", "concat([v1, v2])")}}           |\n| {{jsxref("Array/reverse", "reverse()")}}       | {{jsxref("Array/toReversed", "toReversed()")}}           |\n| {{jsxref("Array/shift", "shift()")}}           | {{jsxref("Array/slice", "slice(1)")}}                    |\n| {{jsxref("Array/sort", "sort()")}}             | {{jsxref("Array/toSorted", "toSorted()")}}               |\n| {{jsxref("Array/splice", "splice()")}}         | {{jsxref("Array/toSpliced", "toSpliced()")}}             |\n| {{jsxref("Array/unshift", "unshift(v1, v2)")}} | {{jsxref("Array/toSpliced", "toSpliced(0, 0, v1, v2)")}} |\n\nAn easy way to change a mutating method into a non-mutating alternative is to use the [spread syntax](/en-US/docs/Web/JavaScript/Reference/Operators/Spread_syntax) or {{jsxref("Array/slice", "slice()")}} to create a copy first:\n\n```js-nolint\narr.copyWithin(0, 1, 2); // mutates arr\nconst arr2 = arr.slice().copyWithin(0, 1, 2); // does not mutate arr\nconst arr3 = [...arr].copyWithin(0, 1, 2); // does not mutate arr\n```\n\n### Iterative methods\n\nMany array methods take a callback function as an argument. The callback function is called sequentially and at most once for each element in the array, and the return value of the callback function is used to determine the return value of the method. They all share the same signature:\n\n```js-nolint\nmethod(callbackFn, thisArg)\n```\n\nWhere `callbackFn` takes three arguments:\n\n- `element`\n  - : The current element being processed in the array.\n- `index`\n  - : The index of the current element being processed in the array.\n- `array`\n  - : The array that the method was called upon.\n\nWhat `callbackFn` is expected to return depends on the array method that was called.\n\nThe `thisArg` argument (defaults to `undefined`) will be used as the `this` value when calling `callbackFn`. The `this` value ultimately observable by `callbackFn` is determined according to [the usual rules](/en-US/docs/Web/JavaScript/Reference/Operators/this): if `callbackFn` is [non-strict](/en-US/docs/Web/JavaScript/Reference/Strict_mode#no_this_substitution), primitive `this` values are wrapped into objects, and `undefined`/`null` is substituted with [`globalThis`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/globalThis). The `thisArg` argument is irrelevant for any `callbackFn` defined with an [arrow function](/en-US/docs/Web/JavaScript/Reference/Functions/Arrow_functions), as arrow functions don\'t have their own `this` {{Glossary("binding")}}.\n\nThe `array` argument passed to `callbackFn` is most useful if you want to read another index during iteration, because you may not always have an existing variable that refers to the current array. You should generally not mutate the array during iteration (see [mutating initial array in iterative methods](#mutating_initial_array_in_iterative_methods)), but you can also use this argument to do so. The `array` argument is _not_ the array that is being built, in the case of methods like `map()`, `filter()`, and `flatMap()` \u2014 there is no way to access the array being built from the callback function.\n\nAll iterative methods are [copying](#copying_methods_and_mutating_methods) and [generic](#generic_array_methods), although they behave differently with [empty slots](#array_methods_and_empty_slots).\n\nThe following methods are iterative:{{jsxref("Array/every", "every()")}}, {{jsxref("Array/filter", "filter()")}}, {{jsxref("Array/find", "find()")}}, {{jsxref("Array/findIndex", "findIndex()")}}, {{jsxref("Array/findLast", "findLast()")}}, {{jsxref("Array/findLastIndex", "findLastIndex()")}}, {{jsxref("Array/flatMap", "flatMap()")}}, {{jsxref("Array/forEach", "forEach()")}}, {{jsxref("Array/map", "map()")}}, and {{jsxref("Array/some", "some()")}}.\n\nIn particular, {{jsxref("Array/every", "every()")}}, {{jsxref("Array/find", "find()")}}, {{jsxref("Array/findIndex", "findIndex()")}}, {{jsxref("Array/findLast", "findLast()")}}, {{jsxref("Array/findLastIndex", "findLastIndex()")}}, and {{jsxref("Array/some", "some()")}} do not always invoke `callbackFn` on every element \u2014 they stop iteration as soon as the return value is determined.\n\nThe {{jsxref("Array/reduce", "reduce()")}} and {{jsxref("Array/reduceRight", "reduceRight()")}} methods also take a callback function and run it at most once for each element in the array, but they have slightly different signatures from typical iterative methods (for example, they don\'t accept `thisArg`).\n\nThe {{jsxref("Array/sort", "sort()")}} method also takes a callback function, but it is not an iterative method. It mutates the array in-place, doesn\'t accept `thisArg`, and may invoke the callback multiple times on an index.\n\nIterative methods iterate the array like the following (with a lot of technical details omitted):\n\n```js\nfunction method(callbackFn, thisArg) {\n  const length = this.length;\n  for (let i = 0; i < length; i++) {\n    if (i in this) {\n      const result = callbackFn.call(thisArg, this[i], i, this);\n      // Do something with result; maybe return early\n    }\n  }\n}\n```\n\nNote the following:\n\n1. Not all methods do the `i in this` test. The `find`, `findIndex`, `findLast`, and `findLastIndex` methods do not, but other methods do.\n2. The `length` is memorized before the loop starts. This affects how insertions and deletions during iteration are handled (see [mutating initial array in iterative methods](#mutating_initial_array_in_iterative_methods)).\n3. The method doesn\'t memorize the array contents, so if any index is modified during iteration, the new value might be observed.\n4. The code above iterates the array in ascending order of index. Some methods iterate in descending order of index (`for (let i = length - 1; i >= 0; i--)`): `reduceRight()`, `findLast()`, and `findLastIndex()`.\n5. `reduce` and `reduceRight` have slightly different signatures and do not always start at the first/last element.\n\n### Generic array methods\n\nArray methods are always generic \u2014 they don\'t access any internal data of the array object. They only access the array elements through the `length` property and the indexed elements. This means that they can be called on array-like objects as well.\n\n```js\nconst arrayLike = {\n  0: "a",\n  1: "b",\n  length: 2,\n};\nconsole.log(Array.prototype.join.call(arrayLike, "+")); // \'a+b\'\n```\n\n#### Normalization of the length property\n\nThe `length` property is [converted to an integer](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number#integer_conversion) and then clamped to the range between 0 and 2<sup>53</sup> - 1. `NaN` becomes `0`, so even when `length` is not present or is `undefined`, it behaves as if it has value `0`.\n\nThe language avoids setting `length` to an [unsafe integer](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/MAX_SAFE_INTEGER). All built-in methods will throw a {{jsxref("TypeError")}} if `length` will be set to a number greater than 2<sup>53</sup> - 1. However, because the {{jsxref("Array/length", "length")}} property of arrays throws an error if it\'s set to greater than 2<sup>32</sup> - 1, the safe integer threshold is usually not reached unless the method is called on a non-array object.\n\n```js\nArray.prototype.flat.call({}); // []\n```\n\nSome array methods set the `length` property of the array object. They always set the value after normalization, so `length` always ends as an integer.\n\n```js\nconst a = { length: 0.7 };\nArray.prototype.push.call(a);\nconsole.log(a.length); // 0\n```\n\n#### Array-like objects\n\nThe term [_array-like object_](/en-US/docs/Web/JavaScript/Guide/Indexed_collections#working_with_array-like_objects) refers to any object that doesn\'t throw during the `length` conversion process described above. In practice, such object is expected to actually have a `length` property and to have indexed elements in the range `0` to `length - 1`. (If it doesn\'t have all indices, it will be functionally equivalent to a [sparse array](#array_methods_and_empty_slots).) Any integer index less than zero or greater than `length - 1` is ignored when an array method operates on an array-like object.\n\nMany DOM objects are array-like \u2014 for example, [`NodeList`](/en-US/docs/Web/API/NodeList) and [`HTMLCollection`](/en-US/docs/Web/API/HTMLCollection). The [`arguments`](/en-US/docs/Web/JavaScript/Reference/Functions/arguments) object is also array-like. You can call array methods on them even if they don\'t have these methods themselves.\n\n```js\nfunction f() {\n  console.log(Array.prototype.join.call(arguments, "+"));\n}\n\nf("a", "b"); // \'a+b\'\n```\n\n## Constructor\n\n- {{jsxref("Array/Array", "Array()")}}\n  - : Creates a new `Array` object.\n\n## Static properties\n\n- {{jsxref("Array/@@species", "Array[@@species]")}}\n  - : Returns the `Array` constructor.\n\n## Static methods\n\n- {{jsxref("Array.from()")}}\n  - : Creates a new `Array` instance from an iterable or array-like object.\n- {{jsxref("Array.fromAsync()")}}\n  - : Creates a new `Array` instance from an async iterable, iterable, or array-like object.\n- {{jsxref("Array.isArray()")}}\n  - : Returns `true` if the argument is an array, or `false` otherwise.\n- {{jsxref("Array.of()")}}\n  - : Creates a new `Array` instance with a variable number of arguments, regardless of number or type of the arguments.\n\n## Instance properties\n\nThese properties are defined on `Array.prototype` and shared by all `Array` instances.\n\n- {{jsxref("Object/constructor", "Array.prototype.constructor")}}\n  - : The constructor function that created the instance object. For `Array` instances, the initial value is the {{jsxref("Array/Array", "Array")}} constructor.\n- {{jsxref("Array/@@unscopables", "Array.prototype[@@unscopables]")}}\n  - : Contains property names that were not included in the ECMAScript standard prior to the ES2015 version and that are ignored for [`with`](/en-US/docs/Web/JavaScript/Reference/Statements/with) statement-binding purposes.\n\nThese properties are own properties of each `Array` instance.\n\n- {{jsxref("Array/length", "length")}}\n  - : Reflects the number of elements in an array.\n\n## Instance methods\n\n- {{jsxref("Array.prototype.at()")}}\n  - : Returns the array item at the given index. Accepts negative integers, which count back from the last item.\n- {{jsxref("Array.prototype.concat()")}}\n  - : Returns a new array that is the calling array joined with other array(s) and/or value(s).\n- {{jsxref("Array.prototype.copyWithin()")}}\n  - : Copies a sequence of array elements within an array.\n- {{jsxref("Array.prototype.entries()")}}\n  - : Returns a new [_array iterator_](/en-US/docs/Web/JavaScript/Guide/Iterators_and_generators) object that contains the key/value pairs for each index in an array.\n- {{jsxref("Array.prototype.every()")}}\n  - : Returns `true` if every element in the calling array satisfies the testing function.\n- {{jsxref("Array.prototype.fill()")}}\n  - : Fills all the elements of an array from a start index to an end index with a static value.\n- {{jsxref("Array.prototype.filter()")}}\n  - : Returns a new array containing all elements of the calling array for which the provided filtering function returns `true`.\n- {{jsxref("Array.prototype.find()")}}\n  - : Returns the value of the first element in the array that satisfies the provided testing function, or `undefined` if no appropriate element is found.\n- {{jsxref("Array.prototype.findIndex()")}}\n  - : Returns the index of the first element in the array that satisfies the provided testing function, or `-1` if no appropriate element was found.\n- {{jsxref("Array.prototype.findLast()")}}\n  - : Returns the value of the last element in the array that satisfies the provided testing function, or `undefined` if no appropriate element is found.\n- {{jsxref("Array.prototype.findLastIndex()")}}\n  - : Returns the index of the last element in the array that satisfies the provided testing function, or `-1` if no appropriate element was found.\n- {{jsxref("Array.prototype.flat()")}}\n  - : Returns a new array with all sub-array elements concatenated into it recursively up to the specified depth.\n- {{jsxref("Array.prototype.flatMap()")}}\n  - : Returns a new array formed by applying a given callback function to each element of the calling array, and then flattening the result by one level.\n- {{jsxref("Array.prototype.forEach()")}}\n  - : Calls a function for each element in the calling array.\n- {{jsxref("Array.prototype.includes()")}}\n  - : Determines whether the calling array contains a value, returning `true` or `false` as appropriate.\n- {{jsxref("Array.prototype.indexOf()")}}\n  - : Returns the first (least) index at which a given element can be found in the calling array.\n- {{jsxref("Array.prototype.join()")}}\n  - : Joins all elements of an array into a string.\n- {{jsxref("Array.prototype.keys()")}}\n  - : Returns a new [_array iterator_](/en-US/docs/Web/JavaScript/Guide/Iterators_and_generators) that contains the keys for each index in the calling array.\n- {{jsxref("Array.prototype.lastIndexOf()")}}\n  - : Returns the last (greatest) index at which a given element can be found in the calling array, or `-1` if none is found.\n- {{jsxref("Array.prototype.map()")}}\n  - : Returns a new array containing the results of invoking a function on every element in the calling array.\n- {{jsxref("Array.prototype.pop()")}}\n  - : Removes the last element from an array and returns that element.\n- {{jsxref("Array.prototype.push()")}}\n  - : Adds one or more elements to the end of an array, and returns the new `length` of the array.\n- {{jsxref("Array.prototype.reduce()")}}\n  - : Executes a user-supplied "reducer" callback function on each element of the array (from left to right), to reduce it to a single value.\n- {{jsxref("Array.prototype.reduceRight()")}}\n  - : Executes a user-supplied "reducer" callback function on each element of the array (from right to left), to reduce it to a single value.\n- {{jsxref("Array.prototype.reverse()")}}\n  - : Reverses the order of the elements of an array _in place_. (First becomes the last, last becomes first.)\n- {{jsxref("Array.prototype.shift()")}}\n  - : Removes the first element from an array and returns that element.\n- {{jsxref("Array.prototype.slice()")}}\n  - : Extracts a section of the calling array and returns a new array.\n- {{jsxref("Array.prototype.some()")}}\n  - : Returns `true` if at least one element in the calling array satisfies the provided testing function.\n- {{jsxref("Array.prototype.sort()")}}\n  - : Sorts the elements of an array in place and returns the array.\n- {{jsxref("Array.prototype.splice()")}}\n  - : Adds and/or removes elements from an array.\n- {{jsxref("Array.prototype.toLocaleString()")}}\n  - : Returns a localized string representing the calling array and its elements. Overrides the {{jsxref("Object.prototype.toLocaleString()")}} method.\n- {{jsxref("Array.prototype.toReversed()")}}\n  - : Returns a new array with the elements in reversed order, without modifying the original array.\n- {{jsxref("Array.prototype.toSorted()")}}\n  - : Returns a new array with the elements sorted in ascending order, without modifying the original array.\n- {{jsxref("Array.prototype.toSpliced()")}}\n  - : Returns a new array with some elements removed and/or replaced at a given index, without modifying the original array.\n- {{jsxref("Array.prototype.toString()")}}\n  - : Returns a string representing the calling array and its elements. Overrides the {{jsxref("Object.prototype.toString()")}} method.\n- {{jsxref("Array.prototype.unshift()")}}\n  - : Adds one or more elements to the front of an array, and returns the new `length` of the array.\n- {{jsxref("Array.prototype.values()")}}\n  - : Returns a new [_array iterator_](/en-US/docs/Web/JavaScript/Guide/Iterators_and_generators) object that contains the values for each index in the array.\n- {{jsxref("Array.prototype.with()")}}\n  - : Returns a new array with the element at the given index replaced with the given value, without modifying the original array.\n- [`Array.prototype[@@iterator]()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/@@iterator)\n  - : An alias for the [`values()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/values) method by default.\n\n## Examples\n\nThis section provides some examples of common array operations in JavaScript.\n\n> **Note:** If you\'re not yet familiar with array basics, consider first reading [JavaScript First Steps: Arrays](/en-US/docs/Learn/JavaScript/First_steps/Arrays), which [explains what arrays are](/en-US/docs/Learn/JavaScript/First_steps/Arrays#what_is_an_array), and includes other examples of common array operations.\n\n### Create an array\n\nThis example shows three ways to create new array: first using [array literal notation](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/Array#array_literal_notation), then using the [`Array()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/Array) constructor, and finally using [`String.prototype.split()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/split) to build the array from a string.\n\n```js\n// \'fruits\' array created using array literal notation.\nconst fruits = ["Apple", "Banana"];\nconsole.log(fruits.length);\n// 2\n\n// \'fruits2\' array created using the Array() constructor.\nconst fruits2 = new Array("Apple", "Banana");\nconsole.log(fruits2.length);\n// 2\n\n// \'fruits3\' array created using String.prototype.split().\nconst fruits3 = "Apple, Banana".split(", ");\nconsole.log(fruits3.length);\n// 2\n```\n\n### Create a string from an array\n\nThis example uses the [`join()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/join) method to create a string from the `fruits` array.\n\n```js\nconst fruits = ["Apple", "Banana"];\nconst fruitsString = fruits.join(", ");\nconsole.log(fruitsString);\n// "Apple, Banana"\n```\n\n### Access an array item by its index\n\nThis example shows how to access items in the `fruits` array by specifying the index number of their position in the array.\n\n```js\nconst fruits = ["Apple", "Banana"];\n\n// The index of an array\'s first element is always 0.\nfruits[0]; // Apple\n\n// The index of an array\'s second element is always 1.\nfruits[1]; // Banana\n\n// The index of an array\'s last element is always one\n// less than the length of the array.\nfruits[fruits.length - 1]; // Banana\n\n// Using an index number larger than the array\'s length\n// returns \'undefined\'.\nfruits[99]; // undefined\n```\n\n### Find the index of an item in an array\n\nThis example uses the [`indexOf()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/indexOf) method to find the position (index) of the string `"Banana"` in the `fruits` array.\n\n```js\nconst fruits = ["Apple", "Banana"];\nconsole.log(fruits.indexOf("Banana"));\n// 1\n```\n\n### Check if an array contains a certain item\n\nThis example shows two ways to check if the `fruits` array contains `"Banana"` and `"Cherry"`: first with the [`includes()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/includes) method, and then with the [`indexOf()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/indexOf) method to test for an index value that\'s not `-1`.\n\n```js\nconst fruits = ["Apple", "Banana"];\n\nfruits.includes("Banana"); // true\nfruits.includes("Cherry"); // false\n\n// If indexOf() doesn\'t return -1, the array contains the given item.\nfruits.indexOf("Banana") !== -1; // true\nfruits.indexOf("Cherry") !== -1; // false\n```\n\n### Append an item to an array\n\nThis example uses the [`push()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/push) method to append a new string to the `fruits` array.\n\n```js\nconst fruits = ["Apple", "Banana"];\nconst newLength = fruits.push("Orange");\nconsole.log(fruits);\n// ["Apple", "Banana", "Orange"]\nconsole.log(newLength);\n// 3\n```\n\n### Remove the last item from an array\n\nThis example uses the [`pop()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/pop) method to remove the last item from the `fruits` array.\n\n```js\nconst fruits = ["Apple", "Banana", "Orange"];\nconst removedItem = fruits.pop();\nconsole.log(fruits);\n// ["Apple", "Banana"]\nconsole.log(removedItem);\n// Orange\n```\n\n> **Note:** `pop()` can only be used to remove the last item from an array. To remove multiple items from the end of an array, see the next example.\n\n### Remove multiple items from the end of an array\n\nThis example uses the [`splice()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/splice) method to remove the last 3 items from the `fruits` array.\n\n```js\nconst fruits = ["Apple", "Banana", "Strawberry", "Mango", "Cherry"];\nconst start = -3;\nconst removedItems = fruits.splice(start);\nconsole.log(fruits);\n// ["Apple", "Banana"]\nconsole.log(removedItems);\n// ["Strawberry", "Mango", "Cherry"]\n```\n\n### Truncate an array down to just its first N items\n\nThis example uses the [`splice()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/splice) method to truncate the `fruits` array down to just its first 2 items.\n\n```js\nconst fruits = ["Apple", "Banana", "Strawberry", "Mango", "Cherry"];\nconst start = 2;\nconst removedItems = fruits.splice(start);\nconsole.log(fruits);\n// ["Apple", "Banana"]\nconsole.log(removedItems);\n// ["Strawberry", "Mango", "Cherry"]\n```\n\n### Remove the first item from an array\n\nThis example uses the [`shift()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/shift) method to remove the first item from the `fruits` array.\n\n```js\nconst fruits = ["Apple", "Banana"];\nconst removedItem = fruits.shift();\nconsole.log(fruits);\n// ["Banana"]\nconsole.log(removedItem);\n// Apple\n```\n\n> **Note:** `shift()` can only be used to remove the first item from an array. To remove multiple items from the beginning of an array, see the next example.\n\n### Remove multiple items from the beginning of an array\n\nThis example uses the [`splice()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/splice) method to remove the first 3 items from the `fruits` array.\n\n```js\nconst fruits = ["Apple", "Strawberry", "Cherry", "Banana", "Mango"];\nconst start = 0;\nconst deleteCount = 3;\nconst removedItems = fruits.splice(start, deleteCount);\nconsole.log(fruits);\n// ["Banana", "Mango"]\nconsole.log(removedItems);\n// ["Apple", "Strawberry", "Cherry"]\n```\n\n### Add a new first item to an array\n\nThis example uses the [`unshift()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/unshift) method to add, at index `0`, a new item to the `fruits` array \u2014 making it the new first item in the array.\n\n```js\nconst fruits = ["Banana", "Mango"];\nconst newLength = fruits.unshift("Strawberry");\nconsole.log(fruits);\n// ["Strawberry", "Banana", "Mango"]\nconsole.log(newLength);\n// 3\n```\n\n### Remove a single item by index\n\nThis example uses the [`splice()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/splice) method to remove the string `"Banana"` from the `fruits` array \u2014 by specifying the index position of `"Banana"`.\n\n```js\nconst fruits = ["Strawberry", "Banana", "Mango"];\nconst start = fruits.indexOf("Banana");\nconst deleteCount = 1;\nconst removedItems = fruits.splice(start, deleteCount);\nconsole.log(fruits);\n// ["Strawberry", "Mango"]\nconsole.log(removedItems);\n// ["Banana"]\n```\n\n### Remove multiple items by index\n\nThis example uses the [`splice()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/splice) method to remove the strings `"Banana"` and `"Strawberry"` from the `fruits` array \u2014 by specifying the index position of `"Banana"`, along with a count of the number of total items to remove.\n\n```js\nconst fruits = ["Apple", "Banana", "Strawberry", "Mango"];\nconst start = 1;\nconst deleteCount = 2;\nconst removedItems = fruits.splice(start, deleteCount);\nconsole.log(fruits);\n// ["Apple", "Mango"]\nconsole.log(removedItems);\n// ["Banana", "Strawberry"]\n```\n\n### Replace multiple items in an array\n\nThis example uses the [`splice()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/splice) method to replace the last 2 items in the `fruits` array with new items.\n\n```js\nconst fruits = ["Apple", "Banana", "Strawberry"];\nconst start = -2;\nconst deleteCount = 2;\nconst removedItems = fruits.splice(start, deleteCount, "Mango", "Cherry");\nconsole.log(fruits);\n// ["Apple", "Mango", "Cherry"]\nconsole.log(removedItems);\n// ["Banana", "Strawberry"]\n```\n\n### Iterate over an array\n\nThis example uses a [`for...of`](/en-US/docs/Web/JavaScript/Reference/Statements/for...of) loop to iterate over the `fruits` array, logging each item to the console.\n\n```js\nconst fruits = ["Apple", "Mango", "Cherry"];\nfor (const fruit of fruits) {\n  console.log(fruit);\n}\n// Apple\n// Mango\n// Cherry\n```\n\nBut `for...of` is just one of many ways to iterate over any array; for more ways, see [Loops and iteration](/en-US/docs/Web/JavaScript/Guide/Loops_and_iteration), and see the documentation for the [`every()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/every), [`filter()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/filter), [`flatMap()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/flatMap), [`map()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/map), [`reduce()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduce), and [`reduceRight()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduceRight) methods \u2014 and see the next example, which uses the [`forEach()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/forEach) method.\n\n### Call a function on each element in an array\n\nThis example uses the [`forEach()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/forEach) method to call a function on each element in the `fruits` array; the function causes each item to be logged to the console, along with the item\'s index number.\n\n```js\nconst fruits = ["Apple", "Mango", "Cherry"];\nfruits.forEach((item, index, array) => {\n  console.log(item, index);\n});\n// Apple 0\n// Mango 1\n// Cherry 2\n```\n\n### Merge multiple arrays together\n\nThis example uses the [`concat()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/concat) method to merge the `fruits` array with a `moreFruits` array, to produce a new `combinedFruits` array. Notice that `fruits` and `moreFruits` remain unchanged.\n\n```js\nconst fruits = ["Apple", "Banana", "Strawberry"];\nconst moreFruits = ["Mango", "Cherry"];\nconst combinedFruits = fruits.concat(moreFruits);\nconsole.log(combinedFruits);\n// ["Apple", "Banana", "Strawberry", "Mango", "Cherry"]\n\n// The \'fruits\' array remains unchanged.\nconsole.log(fruits);\n// ["Apple", "Banana", "Strawberry"]\n\n// The \'moreFruits\' array also remains unchanged.\nconsole.log(moreFruits);\n// ["Mango", "Cherry"]\n```\n\n### Copy an array\n\nThis example shows three ways to create a new array from the existing `fruits` array: first by using [spread syntax](/en-US/docs/Web/JavaScript/Reference/Operators/Spread_syntax), then by using the [`from()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/from) method, and then by using the [`slice()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/slice) method.\n\n```js\nconst fruits = ["Strawberry", "Mango"];\n\n// Create a copy using spread syntax.\nconst fruitsCopy = [...fruits];\n// ["Strawberry", "Mango"]\n\n// Create a copy using the from() method.\nconst fruitsCopy2 = Array.from(fruits);\n// ["Strawberry", "Mango"]\n\n// Create a copy using the slice() method.\nconst fruitsCopy3 = fruits.slice();\n// ["Strawberry", "Mango"]\n```\n\nAll built-in array-copy operations ([spread syntax](/en-US/docs/Web/JavaScript/Reference/Operators/Spread_syntax), [`Array.from()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/from), [`Array.prototype.slice()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/slice), and [`Array.prototype.concat()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/concat)) create [shallow copies](/en-US/docs/Glossary/Shallow_copy). If you instead want a [deep copy](/en-US/docs/Glossary/Deep_copy) of an array, you can use {{jsxref("JSON.stringify()")}} to convert the array to a JSON string, and then {{jsxref("JSON.parse()")}} to convert the string back into a new array that\'s completely independent from the original array.\n\n```js\nconst fruitsDeepCopy = JSON.parse(JSON.stringify(fruits));\n```\n\nYou can also create deep copies using the [`structuredClone()`](/en-US/docs/Web/API/structuredClone) method, which has the advantage of allowing [transferable objects](/en-US/docs/Web/API/Web_Workers_API/Transferable_objects) in the source to be _transferred_ to the new copy, rather than just cloned.\n\nFinally, it\'s important to understand that assigning an existing array to a new variable doesn\'t create a copy of either the array or its elements. Instead the new variable is just a reference, or alias, to the original array; that is, the original array\'s name and the new variable name are just two names for the exact same object (and so will always evaluate as [strictly equivalent](/en-US/docs/Web/JavaScript/Equality_comparisons_and_sameness#strict_equality_using)). Therefore, if you make any changes at all either to the value of the original array or to the value of the new variable, the other will change, too:\n\n```js\nconst fruits = ["Strawberry", "Mango"];\nconst fruitsAlias = fruits;\n// \'fruits\' and \'fruitsAlias\' are the same object, strictly equivalent.\nfruits === fruitsAlias; // true\n// Any changes to the \'fruits\' array change \'fruitsAlias\' too.\nfruits.unshift("Apple", "Banana");\nconsole.log(fruits);\n// [\'Apple\', \'Banana\', \'Strawberry\', \'Mango\']\nconsole.log(fruitsAlias);\n// [\'Apple\', \'Banana\', \'Strawberry\', \'Mango\']\n```\n\n### Creating a two-dimensional array\n\nThe following creates a chessboard as a two-dimensional array of strings. The first move is made by copying the `\'p\'` in `board[6][4]` to `board[4][4]`. The old position at `[6][4]` is made blank.\n\n```js\nconst board = [\n  ["R", "N", "B", "Q", "K", "B", "N", "R"],\n  ["P", "P", "P", "P", "P", "P", "P", "P"],\n  [" ", " ", " ", " ", " ", " ", " ", " "],\n  [" ", " ", " ", " ", " ", " ", " ", " "],\n  [" ", " ", " ", " ", " ", " ", " ", " "],\n  [" ", " ", " ", " ", " ", " ", " ", " "],\n  ["p", "p", "p", "p", "p", "p", "p", "p"],\n  ["r", "n", "b", "q", "k", "b", "n", "r"],\n];\n\nconsole.log(`${board.join("\\n")}\\n\\n`);\n\n// Move King\'s Pawn forward 2\nboard[4][4] = board[6][4];\nboard[6][4] = " ";\nconsole.log(board.join("\\n"));\n```\n\nHere is the output:\n\n```plain\nR,N,B,Q,K,B,N,R\nP,P,P,P,P,P,P,P\n , , , , , , ,\n , , , , , , ,\n , , , , , , ,\n , , , , , , ,\np,p,p,p,p,p,p,p\nr,n,b,q,k,b,n,r\n\nR,N,B,Q,K,B,N,R\nP,P,P,P,P,P,P,P\n , , , , , , ,\n , , , , , , ,\n , , , ,p, , ,\n , , , , , , ,\np,p,p,p, ,p,p,p\nr,n,b,q,k,b,n,r\n```\n\n### Using an array to tabulate a set of values\n\n```js\nconst values = [];\nfor (let x = 0; x < 10; x++) {\n  values.push([2 ** x, 2 * x ** 2]);\n}\nconsole.table(values);\n```\n\nResults in\n\n```plain\n// The first column is the index\n0  1    0\n1  2    2\n2  4    8\n3  8    18\n4  16   32\n5  32   50\n6  64   72\n7  128  98\n8  256  128\n9  512  162\n```\n\n### Creating an array using the result of a match\n\nThe result of a match between a {{jsxref("RegExp")}} and a string can create a JavaScript array that has properties and elements which provide information about the match. Such an array is returned by {{jsxref("RegExp.prototype.exec()")}} and {{jsxref("String.prototype.match()")}}.\n\nFor example:\n\n```js\n// Match one d followed by one or more b\'s followed by one d\n// Remember matched b\'s and the following d\n// Ignore case\n\nconst myRe = /d(b+)(d)/i;\nconst execResult = myRe.exec("cdbBdbsbz");\n\nconsole.log(execResult.input); // \'cdbBdbsbz\'\nconsole.log(execResult.index); // 1\nconsole.log(execResult); // [ "dbBd", "bB", "d" ]\n```\n\nFor more information about the result of a match, see the {{jsxref("RegExp.prototype.exec()")}} and {{jsxref("String.prototype.match()")}} pages.\n\n### Mutating initial array in iterative methods\n\n[Iterative methods](#iterative_methods) do not mutate the array on which it is called, but the function provided as `callbackFn` can. The key principle to remember is that only indexes between 0 and `arrayLength - 1` are visited, where `arrayLength` is the length of the array at the time the array method was first called, but the element passed to the callback is the value at the time the index is visited. Therefore:\n\n- `callbackFn` will not visit any elements added beyond the array\'s initial length when the call to the iterative method began.\n- Changes to already-visited indexes do not cause `callbackFn` to be invoked on them again.\n- If an existing, yet-unvisited element of the array is changed by `callbackFn`, its value passed to the `callbackFn` will be the value at the time that element gets visited. Removed elements are not visited.\n\n> **Warning:** Concurrent modifications of the kind described above frequently lead to hard-to-understand code and are generally to be avoided (except in special cases).\n\nThe following examples use the `forEach` method as an example, but other methods that visit indexes in ascending order work in the same way. We will first define a helper function:\n\n```js\nfunction testSideEffect(effect) {\n  const arr = ["e1", "e2", "e3", "e4"];\n  arr.forEach((elem, index, arr) => {\n    console.log(`array: [${arr.join(", ")}], index: ${index}, elem: ${elem}`);\n    effect(arr, index);\n  });\n  console.log(`Final array: [${arr.join(", ")}]`);\n}\n```\n\nModification to indexes not visited yet will be visible once the index is reached:\n\n```js\ntestSideEffect((arr, index) => {\n  if (index + 1 < arr.length) arr[index + 1] += "*";\n});\n// array: [e1, e2, e3, e4], index: 0, elem: e1\n// array: [e1, e2*, e3, e4], index: 1, elem: e2*\n// array: [e1, e2*, e3*, e4], index: 2, elem: e3*\n// array: [e1, e2*, e3*, e4*], index: 3, elem: e4*\n// Final array: [e1, e2*, e3*, e4*]\n```\n\nModification to already visited indexes does not change iteration behavior, although the array will be different afterwards:\n\n```js\ntestSideEffect((arr, index) => {\n  if (index > 0) arr[index - 1] += "*";\n});\n// array: [e1, e2, e3, e4], index: 0, elem: e1\n// array: [e1, e2, e3, e4], index: 1, elem: e2\n// array: [e1*, e2, e3, e4], index: 2, elem: e3\n// array: [e1*, e2*, e3, e4], index: 3, elem: e4\n// Final array: [e1*, e2*, e3*, e4]\n```\n\nInserting _n_ elements at unvisited indexes that are less than the initial array length will make them be visited. The last _n_ elements in the original array that now have index greater than the initial array length will not be visited:\n\n```js\ntestSideEffect((arr, index) => {\n  if (index === 1) arr.splice(2, 0, "new");\n});\n// array: [e1, e2, e3, e4], index: 0, elem: e1\n// array: [e1, e2, e3, e4], index: 1, elem: e2\n// array: [e1, e2, new, e3, e4], index: 2, elem: new\n// array: [e1, e2, new, e3, e4], index: 3, elem: e3\n// Final array: [e1, e2, new, e3, e4]\n// e4 is not visited because it now has index 4\n```\n\nInserting _n_ elements with index greater than the initial array length will not make them be visited:\n\n```js\ntestSideEffect((arr) => arr.push("new"));\n// array: [e1, e2, e3, e4], index: 0, elem: e1\n// array: [e1, e2, e3, e4, new], index: 1, elem: e2\n// array: [e1, e2, e3, e4, new, new], index: 2, elem: e3\n// array: [e1, e2, e3, e4, new, new, new], index: 3, elem: e4\n// Final array: [e1, e2, e3, e4, new, new, new, new]\n```\n\nInserting _n_ elements at already visited indexes will not make them be visited, but it shifts remaining elements back by _n_, so the current index and the _n - 1_ elements before it are visited again:\n\n```js\ntestSideEffect((arr, index) => arr.splice(index, 0, "new"));\n// array: [e1, e2, e3, e4], index: 0, elem: e1\n// array: [new, e1, e2, e3, e4], index: 1, elem: e1\n// array: [new, new, e1, e2, e3, e4], index: 2, elem: e1\n// array: [new, new, new, e1, e2, e3, e4], index: 3, elem: e1\n// Final array: [new, new, new, new, e1, e2, e3, e4]\n// e1 keeps getting visited because it keeps getting shifted back\n```\n\nDeleting _n_ elements at unvisited indexes will make them not be visited anymore. Because the array has shrunk, the last _n_ iterations will visit out-of-bounds indexes. If the method ignores non-existent indexes (see [array methods and empty slots](#array_methods_and_empty_slots)), the last _n_ iterations will be skipped; otherwise, they will receive `undefined`:\n\n```js\ntestSideEffect((arr, index) => {\n  if (index === 1) arr.splice(2, 1);\n});\n// array: [e1, e2, e3, e4], index: 0, elem: e1\n// array: [e1, e2, e3, e4], index: 1, elem: e2\n// array: [e1, e2, e4], index: 2, elem: e4\n// Final array: [e1, e2, e4]\n// Does not visit index 3 because it\'s out-of-bounds\n\n// Compare this with find(), which treats nonexistent indexes as undefined:\nconst arr2 = ["e1", "e2", "e3", "e4"];\narr2.find((elem, index, arr) => {\n  console.log(`array: [${arr.join(", ")}], index: ${index}, elem: ${elem}`);\n  if (index === 1) arr.splice(2, 1);\n  return false;\n});\n// array: [e1, e2, e3, e4], index: 0, elem: e1\n// array: [e1, e2, e3, e4], index: 1, elem: e2\n// array: [e1, e2, e4], index: 2, elem: e4\n// array: [e1, e2, e4], index: 3, elem: undefined\n```\n\nDeleting _n_ elements at already visited indexes does not change the fact that they were visited before they get deleted. Because the array has shrunk, the next _n_ elements after the current index are skipped. If the method ignores non-existent indexes, the last _n_ iterations will be skipped; otherwise, they will receive `undefined`:\n\n```js\ntestSideEffect((arr, index) => arr.splice(index, 1));\n// array: [e1, e2, e3, e4], index: 0, elem: e1\n// Does not visit e2 because e2 now has index 0, which has already been visited\n// array: [e2, e3, e4], index: 1, elem: e3\n// Does not visit e4 because e4 now has index 1, which has already been visited\n// Final array: [e2, e4]\n// Index 2 is out-of-bounds, so it\'s not visited\n\n// Compare this with find(), which treats nonexistent indexes as undefined:\nconst arr2 = ["e1", "e2", "e3", "e4"];\narr2.find((elem, index, arr) => {\n  console.log(`array: [${arr.join(", ")}], index: ${index}, elem: ${elem}`);\n  arr.splice(index, 1);\n  return false;\n});\n// array: [e1, e2, e3, e4], index: 0, elem: e1\n// array: [e2, e3, e4], index: 1, elem: e3\n// array: [e2, e4], index: 2, elem: undefined\n// array: [e2, e4], index: 3, elem: undefined\n```\n\nFor methods that iterate in descending order of index, insertion causes elements to be skipped, and deletion causes elements to be visited multiple times. Adjust the code above yourself to see the effects.\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Indexed collections](/en-US/docs/Web/JavaScript/Guide/Indexed_collections) guide\n- {{jsxref("TypedArray")}}\n- {{jsxref("ArrayBuffer")}}\n',
        "indexof": {
            "index.md": '---\ntitle: Array.prototype.indexOf()\nslug: Web/JavaScript/Reference/Global_Objects/Array/indexOf\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Array.indexOf\n---\n\n{{JSRef}}\n\nThe **`indexOf()`** method of {{jsxref("Array")}} instances returns the first index at which a\ngiven element can be found in the array, or -1 if it is not present.\n\n{{EmbedInteractiveExample("pages/js/array-indexof.html")}}\n\n## Syntax\n\n```js-nolint\nindexOf(searchElement)\nindexOf(searchElement, fromIndex)\n```\n\n### Parameters\n\n- `searchElement`\n  - : Element to locate in the array.\n- `fromIndex` {{optional_inline}}\n  - : Zero-based index at which to start searching, [converted to an integer](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number#integer_conversion).\n    - Negative index counts back from the end of the array \u2014 if `-array.length <= fromIndex < 0`, `fromIndex + array.length` is used. Note, the array is still searched from front to back in this case.\n    - If `fromIndex < -array.length` or `fromIndex` is omitted, `0` is used, causing the entire array to be searched.\n    - If `fromIndex >= array.length`, the array is not searched and `-1` is returned.\n\n### Return value\n\nThe first index of `searchElement` in the array; `-1` if not found.\n\n## Description\n\nThe `indexOf()` method compares `searchElement` to elements of the array using [strict equality](/en-US/docs/Web/JavaScript/Reference/Operators/Strict_equality) (the same algorithm used by the `===` operator). [`NaN`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/NaN) values are never compared as equal, so `indexOf()` always returns `-1` when `searchElement` is `NaN`.\n\nThe `indexOf()` method skips empty slots in [sparse arrays](/en-US/docs/Web/JavaScript/Guide/Indexed_collections#sparse_arrays).\n\nThe `indexOf()` method is [generic](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array#generic_array_methods). It only expects the `this` value to have a `length` property and integer-keyed properties.\n\n## Examples\n\n### Using indexOf()\n\nThe following example uses `indexOf()` to locate values in an array.\n\n```js\nconst array = [2, 9, 9];\narray.indexOf(2); // 0\narray.indexOf(7); // -1\narray.indexOf(9, 2); // 2\narray.indexOf(2, -1); // -1\narray.indexOf(2, -3); // 0\n```\n\nYou cannot use `indexOf()` to search for `NaN`.\n\n```js\nconst array = [NaN];\narray.indexOf(NaN); // -1\n```\n\n### Finding all the occurrences of an element\n\n```js\nconst indices = [];\nconst array = ["a", "b", "a", "c", "a", "d"];\nconst element = "a";\nlet idx = array.indexOf(element);\nwhile (idx !== -1) {\n  indices.push(idx);\n  idx = array.indexOf(element, idx + 1);\n}\nconsole.log(indices);\n// [0, 2, 4]\n```\n\n### Finding if an element exists in the array or not and updating the array\n\n```js\nfunction updateVegetablesCollection(veggies, veggie) {\n  if (veggies.indexOf(veggie) === -1) {\n    veggies.push(veggie);\n    console.log(`New veggies collection is: ${veggies}`);\n  } else {\n    console.log(`${veggie} already exists in the veggies collection.`);\n  }\n}\n\nconst veggies = ["potato", "tomato", "chillies", "green-pepper"];\n\nupdateVegetablesCollection(veggies, "spinach");\n// New veggies collection is: potato,tomato,chillies,green-pepper,spinach\nupdateVegetablesCollection(veggies, "spinach");\n// spinach already exists in the veggies collection.\n```\n\n### Using indexOf() on sparse arrays\n\nYou cannot use `indexOf()` to search for empty slots in sparse arrays.\n\n```js\nconsole.log([1, , 3].indexOf(undefined)); // -1\n```\n\n### Calling indexOf() on non-array objects\n\nThe `indexOf()` method reads the `length` property of `this` and then accesses each property whose key is a nonnegative integer less than `length`.\n\n```js\nconst arrayLike = {\n  length: 3,\n  0: 2,\n  1: 3,\n  2: 4,\n  3: 5, // ignored by indexOf() since length is 3\n};\nconsole.log(Array.prototype.indexOf.call(arrayLike, 2));\n// 0\nconsole.log(Array.prototype.indexOf.call(arrayLike, 5));\n// -1\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Array.prototype.indexOf` in `core-js`](https://github.com/zloirock/core-js#ecmascript-array)\n- [Indexed collections](/en-US/docs/Web/JavaScript/Guide/Indexed_collections) guide\n- {{jsxref("Array")}}\n- {{jsxref("Array.prototype.findIndex()")}}\n- {{jsxref("Array.prototype.findLastIndex()")}}\n- {{jsxref("Array.prototype.lastIndexOf()")}}\n- {{jsxref("TypedArray.prototype.indexOf()")}}\n- {{jsxref("String.prototype.indexOf()")}}\n'
        },
        "isarray": {
            "index.md": '---\ntitle: Array.isArray()\nslug: Web/JavaScript/Reference/Global_Objects/Array/isArray\npage-type: javascript-static-method\nbrowser-compat: javascript.builtins.Array.isArray\n---\n\n{{JSRef}}\n\nThe **`Array.isArray()`** static method determines whether the passed value is an {{jsxref("Array")}}.\n\n{{EmbedInteractiveExample("pages/js/array-isarray.html")}}\n\n## Syntax\n\n```js-nolint\nArray.isArray(value)\n```\n\n### Parameters\n\n- `value`\n  - : The value to be checked.\n\n### Return value\n\n`true` if `value` is an {{jsxref("Array")}}; otherwise, `false`. `false` is always returned if `value` is a {{jsxref("TypedArray")}} instance.\n\n## Description\n\n`Array.isArray()` checks if the passed value is an {{jsxref("Array")}}. It does not check the value\'s prototype chain, nor does it rely on the `Array` constructor it is attached to. It returns `true` for any value that was created using the array literal syntax or the `Array` constructor. This makes it safe to use with cross-realm objects, where the identity of the `Array` constructor is different and would therefore cause [`instanceof Array`](/en-US/docs/Web/JavaScript/Reference/Operators/instanceof) to fail.\n\nSee the article ["Determining with absolute accuracy whether or not a JavaScript object is an array"](https://web.mit.edu/jwalden/www/isArray.html) for more details.\n\n`Array.isArray()` also rejects objects with `Array.prototype` in its prototype chain but aren\'t actual arrays, which `instanceof Array` would accept.\n\n## Examples\n\n### Using Array.isArray()\n\n```js\n// all following calls return true\nArray.isArray([]);\nArray.isArray([1]);\nArray.isArray(new Array());\nArray.isArray(new Array("a", "b", "c", "d"));\nArray.isArray(new Array(3));\n// Little known fact: Array.prototype itself is an array:\nArray.isArray(Array.prototype);\n\n// all following calls return false\nArray.isArray();\nArray.isArray({});\nArray.isArray(null);\nArray.isArray(undefined);\nArray.isArray(17);\nArray.isArray("Array");\nArray.isArray(true);\nArray.isArray(false);\nArray.isArray(new Uint8Array(32));\n// This is not an array, because it was not created using the\n// array literal syntax or the Array constructor\nArray.isArray({ __proto__: Array.prototype });\n```\n\n### instanceof vs. Array.isArray()\n\nWhen checking for `Array` instance, `Array.isArray()` is preferred over `instanceof` because it works across realms.\n\n```js\nconst iframe = document.createElement("iframe");\ndocument.body.appendChild(iframe);\nconst xArray = window.frames[window.frames.length - 1].Array;\nconst arr = new xArray(1, 2, 3); // [1, 2, 3]\n\n// Correctly checking for Array\nArray.isArray(arr); // true\n// The prototype of arr is xArray.prototype, which is a\n// different object from Array.prototype\narr instanceof Array; // false\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Array.isArray` in `core-js`](https://github.com/zloirock/core-js#ecmascript-array)\n- [Indexed collections](/en-US/docs/Web/JavaScript/Guide/Indexed_collections) guide\n- {{jsxref("Array")}}\n'
        },
        "join": {
            "index.md": '---\ntitle: Array.prototype.join()\nslug: Web/JavaScript/Reference/Global_Objects/Array/join\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Array.join\n---\n\n{{JSRef}}\n\nThe **`join()`** method of {{jsxref("Array")}} instances creates and\nreturns a new string by concatenating all of the elements in this array,\nseparated by commas or a specified separator string. If the array has\nonly one item, then that item will be returned without using the separator.\n\n{{EmbedInteractiveExample("pages/js/array-join.html")}}\n\n## Syntax\n\n```js-nolint\njoin()\njoin(separator)\n```\n\n### Parameters\n\n- `separator` {{optional_inline}}\n  - : A string to separate each pair of adjacent elements of the array. If omitted, the array elements are separated with a comma (",").\n\n### Return value\n\nA string with all array elements joined. If `array.length` is `0`, the empty string is returned.\n\n## Description\n\nThe string conversions of all array elements are joined into one string. If an element is `undefined` or `null`, it is converted to an empty string instead of the string `"null"` or `"undefined"`.\n\nThe `join` method is accessed internally by [`Array.prototype.toString()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/toString) with no arguments. Overriding `join` of an array instance will override its `toString` behavior as well.\n\n`Array.prototype.join` recursively converts each element, including other arrays, to strings. Because the string returned by `Array.prototype.toString` (which is the same as calling `join()`) does not have delimiters, nested arrays look like they are flattened. You can only control the separator of the first level, while deeper levels always use the default comma.\n\n```js\nconst matrix = [\n  [1, 2, 3],\n  [4, 5, 6],\n  [7, 8, 9],\n];\n\nconsole.log(matrix.join()); // 1,2,3,4,5,6,7,8,9\nconsole.log(matrix.join(";")); // 1,2,3;4,5,6;7,8,9\n```\n\nWhen an array is cyclic (it contains an element that is itself), browsers avoid infinite recursion by ignoring the cyclic reference.\n\n```js\nconst arr = [];\narr.push(1, [3, arr, 4], 2);\nconsole.log(arr.join(";")); // 1;3,,4;2\n```\n\nWhen used on [sparse arrays](/en-US/docs/Web/JavaScript/Guide/Indexed_collections#sparse_arrays), the `join()` method iterates empty slots as if they have the value `undefined`.\n\nThe `join()` method is [generic](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array#generic_array_methods). It only expects the `this` value to have a `length` property and integer-keyed properties.\n\n## Examples\n\n### Joining an array four different ways\n\nThe following example creates an array, `a`, with three elements, then joins\nthe array four times: using the default separator, then a comma and a space, then a plus\nand an empty string.\n\n```js\nconst a = ["Wind", "Water", "Fire"];\na.join(); // \'Wind,Water,Fire\'\na.join(", "); // \'Wind, Water, Fire\'\na.join(" + "); // \'Wind + Water + Fire\'\na.join(""); // \'WindWaterFire\'\n```\n\n### Using join() on sparse arrays\n\n`join()` treats empty slots the same as `undefined` and produces an extra separator:\n\n```js\nconsole.log([1, , 3].join()); // \'1,,3\'\nconsole.log([1, undefined, 3].join()); // \'1,,3\'\n```\n\n### Calling join() on non-array objects\n\nThe `join()` method reads the `length` property of `this` and then accesses each property whose key is a nonnegative integer less than `length`.\n\n```js\nconst arrayLike = {\n  length: 3,\n  0: 2,\n  1: 3,\n  2: 4,\n  3: 5, // ignored by join() since length is 3\n};\nconsole.log(Array.prototype.join.call(arrayLike));\n// 2,3,4\nconsole.log(Array.prototype.join.call(arrayLike, "."));\n// 2.3.4\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Array.prototype.join` in `core-js`](https://github.com/zloirock/core-js#ecmascript-array)\n- [Indexed collections](/en-US/docs/Web/JavaScript/Guide/Indexed_collections) guide\n- {{jsxref("Array")}}\n- {{jsxref("Array.prototype.toString()")}}\n- {{jsxref("TypedArray.prototype.join()")}}\n- {{jsxref("String.prototype.split()")}}\n'
        },
        "keys": {
            "index.md": '---\ntitle: Array.prototype.keys()\nslug: Web/JavaScript/Reference/Global_Objects/Array/keys\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Array.keys\n---\n\n{{JSRef}}\n\nThe **`keys()`** method of {{jsxref("Array")}} instances returns a new _[array iterator](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Iterator)_ object that contains the keys for each index in the array.\n\n{{EmbedInteractiveExample("pages/js/array-keys.html")}}\n\n## Syntax\n\n```js-nolint\nkeys()\n```\n\n### Parameters\n\nNone.\n\n### Return value\n\nA new [iterable iterator object](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Iterator).\n\n## Description\n\nWhen used on [sparse arrays](/en-US/docs/Web/JavaScript/Guide/Indexed_collections#sparse_arrays), the `keys()` method iterates empty slots as if they have the value `undefined`.\n\nThe `keys()` method is [generic](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array#generic_array_methods). It only expects the `this` value to have a `length` property and integer-keyed properties.\n\n## Examples\n\n### Using keys() on sparse arrays\n\nUnlike {{jsxref("Object.keys()")}}, which only includes keys that actually exist in the array, the `keys()` iterator doesn\'t ignore holes representing missing properties.\n\n```js\nconst arr = ["a", , "c"];\nconst sparseKeys = Object.keys(arr);\nconst denseKeys = [...arr.keys()];\nconsole.log(sparseKeys); // [\'0\', \'2\']\nconsole.log(denseKeys); // [0, 1, 2]\n```\n\n### Calling keys() on non-array objects\n\nThe `keys()` method reads the `length` property of `this` and then yields all integer indices between 0 and `length - 1`. No index access actually happens.\n\n```js\nconst arrayLike = {\n  length: 3,\n};\nfor (const entry of Array.prototype.keys.call(arrayLike)) {\n  console.log(entry);\n}\n// 0\n// 1\n// 2\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Array.prototype.keys` in `core-js`](https://github.com/zloirock/core-js#ecmascript-array)\n- [Indexed collections](/en-US/docs/Web/JavaScript/Guide/Indexed_collections) guide\n- {{jsxref("Array")}}\n- {{jsxref("Array.prototype.entries()")}}\n- {{jsxref("Array.prototype.values()")}}\n- [`Array.prototype[@@iterator]()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/@@iterator)\n- {{jsxref("TypedArray.prototype.keys()")}}\n- [Iteration protocols](/en-US/docs/Web/JavaScript/Reference/Iteration_protocols)\n'
        },
        "lastindexof": {
            "index.md": '---\ntitle: Array.prototype.lastIndexOf()\nslug: Web/JavaScript/Reference/Global_Objects/Array/lastIndexOf\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Array.lastIndexOf\n---\n\n{{JSRef}}\n\nThe **`lastIndexOf()`** method of {{jsxref("Array")}} instances returns the last index at which\na given element can be found in the array, or -1 if it is not present. The array is\nsearched backwards, starting at `fromIndex`.\n\n{{EmbedInteractiveExample("pages/js/array-lastindexof.html")}}\n\n## Syntax\n\n```js-nolint\nlastIndexOf(searchElement)\nlastIndexOf(searchElement, fromIndex)\n```\n\n### Parameters\n\n- `searchElement`\n  - : Element to locate in the array.\n- `fromIndex` {{optional_inline}}\n  - : Zero-based index at which to start searching backwards, [converted to an integer](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number#integer_conversion).\n    - Negative index counts back from the end of the array \u2014 if `-array.length <= fromIndex < 0`, `fromIndex + array.length` is used.\n    - If `fromIndex < -array.length`, the array is not searched and `-1` is returned. You can think of it conceptually as starting at a nonexistent position before the beginning of the array and going backwards from there. There are no array elements on the way, so `searchElement` is never found.\n    - If `fromIndex >= array.length` or `fromIndex` is omitted, `array.length - 1` is used, causing the entire array to be searched. You can think of it conceptually as starting at a nonexistent position beyond the end of the array and going backwards from there. It eventually reaches the real end position of the array, at which point it starts searching backwards through the actual array elements.\n\n### Return value\n\nThe last index of `searchElement` in the array; `-1` if not found.\n\n## Description\n\nThe `lastIndexOf()` method compares `searchElement` to elements of the array using [strict equality](/en-US/docs/Web/JavaScript/Reference/Operators/Strict_equality) (the same algorithm used by the `===` operator). [`NaN`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/NaN) values are never compared as equal, so `lastIndexOf()` always returns `-1` when `searchElement` is `NaN`.\n\nThe `lastIndexOf()` method skips empty slots in [sparse arrays](/en-US/docs/Web/JavaScript/Guide/Indexed_collections#sparse_arrays).\n\nThe `lastIndexOf()` method is [generic](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array#generic_array_methods). It only expects the `this` value to have a `length` property and integer-keyed properties.\n\n## Examples\n\n### Using lastIndexOf()\n\nThe following example uses `lastIndexOf()` to locate values in an array.\n\n```js\nconst numbers = [2, 5, 9, 2];\nnumbers.lastIndexOf(2); // 3\nnumbers.lastIndexOf(7); // -1\nnumbers.lastIndexOf(2, 3); // 3\nnumbers.lastIndexOf(2, 2); // 0\nnumbers.lastIndexOf(2, -2); // 0\nnumbers.lastIndexOf(2, -1); // 3\n```\n\nYou cannot use `lastIndexOf()` to search for `NaN`.\n\n```js\nconst array = [NaN];\narray.lastIndexOf(NaN); // -1\n```\n\n### Finding all the occurrences of an element\n\nThe following example uses `lastIndexOf` to find all the indices of an\nelement in a given array, using {{jsxref("Array/push", "push()")}} to add them\nto another array as they are found.\n\n```js\nconst indices = [];\nconst array = ["a", "b", "a", "c", "a", "d"];\nconst element = "a";\nlet idx = array.lastIndexOf(element);\nwhile (idx !== -1) {\n  indices.push(idx);\n  idx = idx > 0 ? array.lastIndexOf(element, idx - 1) : -1;\n}\n\nconsole.log(indices);\n// [4, 2, 0]\n```\n\nNote that we have to handle the case `idx === 0` separately here because the\nelement will always be found regardless of the `fromIndex` parameter if it is\nthe first element of the array. This is different from the\n{{jsxref("Array/indexOf", "indexOf()")}} method.\n\n### Using lastIndexOf() on sparse arrays\n\nYou cannot use `lastIndexOf()` to search for empty slots in sparse arrays.\n\n```js\nconsole.log([1, , 3].lastIndexOf(undefined)); // -1\n```\n\n### Calling lastIndexOf() on non-array objects\n\nThe `lastIndexOf()` method reads the `length` property of `this` and then accesses each property whose key is a nonnegative integer less than `length`.\n\n```js\nconst arrayLike = {\n  length: 3,\n  0: 2,\n  1: 3,\n  2: 2,\n  3: 5, // ignored by lastIndexOf() since length is 3\n};\nconsole.log(Array.prototype.lastIndexOf.call(arrayLike, 2));\n// 2\nconsole.log(Array.prototype.lastIndexOf.call(arrayLike, 5));\n// -1\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Array.prototype.lastIndexOf` in `core-js`](https://github.com/zloirock/core-js#ecmascript-array)\n- [Indexed collections](/en-US/docs/Web/JavaScript/Guide/Indexed_collections) guide\n- {{jsxref("Array")}}\n- {{jsxref("Array.prototype.findIndex()")}}\n- {{jsxref("Array.prototype.findLastIndex()")}}\n- {{jsxref("Array.prototype.indexOf()")}}\n- {{jsxref("TypedArray.prototype.lastIndexOf()")}}\n- {{jsxref("String.prototype.lastIndexOf()")}}\n'
        },
        "length": {
            "index.md": '---\ntitle: "Array: length"\nslug: Web/JavaScript/Reference/Global_Objects/Array/length\npage-type: javascript-instance-data-property\nbrowser-compat: javascript.builtins.Array.length\n---\n\n{{JSRef}}\n\nThe **`length`** data property of an {{jsxref("Array")}} instance represents the number of elements in that array. The value is an unsigned, 32-bit integer that is always numerically greater than the highest index in the array.\n\n{{EmbedInteractiveExample("pages/js/array-length.html", "shorter")}}\n\n## Value\n\nA nonnegative integer less than 2<sup>32</sup>.\n\n{{js_property_attributes(1, 0, 0)}}\n\n## Description\n\nThe value of the `length` property is a nonnegative integer with a value less than 2<sup>32</sup>.\n\n```js\nconst listA = [1, 2, 3];\nconst listB = new Array(6);\n\nconsole.log(listA.length);\n// 3\n\nconsole.log(listB.length);\n// 6\n\nlistB.length = 2 ** 32; // 4294967296\n// RangeError: Invalid array length\n\nconst listC = new Array(-100); // Negative numbers are not allowed\n// RangeError: Invalid array length\n```\n\nThe array object observes the `length` property, and automatically syncs the `length` value with the array\'s content. This means:\n\n- Setting `length` to a value smaller than the current length truncates the array \u2014 elements beyond the new `length` are deleted.\n- Setting any array index (a nonnegative integer smaller than 2<sup>32</sup>) beyond the current `length` extends the array \u2014 the `length` property is increased to reflect the new highest index.\n- Setting `length` to an invalid value (e.g. a negative number or a non-integer) throws a `RangeError` exception.\n\nWhen `length` is set to a bigger value than the current length, the array is extended by adding [empty slots](/en-US/docs/Web/JavaScript/Guide/Indexed_collections#sparse_arrays), not actual `undefined` values. Empty slots have some special interactions with array methods; see [array methods and empty slots](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array#array_methods_and_empty_slots).\n\n```js\nconst arr = [1, 2];\nconsole.log(arr);\n// [ 1, 2 ]\n\narr.length = 5; // set array length to 5 while currently 2.\nconsole.log(arr);\n// [ 1, 2, <3 empty items> ]\n\narr.forEach((element) => console.log(element));\n// 1\n// 2\n```\n\nSee also [Relationship between `length` and numerical properties](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array#relationship_between_length_and_numerical_properties).\n\n## Examples\n\n### Iterating over an array\n\nIn the following example, the array `numbers` is iterated through by looking at the `length` property. The value in each element is then doubled.\n\n```js\nconst numbers = [1, 2, 3, 4, 5];\nconst length = numbers.length;\nfor (let i = 0; i < length; i++) {\n  numbers[i] *= 2;\n}\n// numbers is now [2, 4, 6, 8, 10]\n```\n\n### Shortening an array\n\nThe following example shortens the array `numbers` to a length of 3 if the current length is greater than 3.\n\n```js\nconst numbers = [1, 2, 3, 4, 5];\n\nif (numbers.length > 3) {\n  numbers.length = 3;\n}\n\nconsole.log(numbers); // [1, 2, 3]\nconsole.log(numbers.length); // 3\nconsole.log(numbers[3]); // undefined; the extra elements are deleted\n```\n\n### Create empty array of fixed length\n\nSetting `length` to a value greater than the current length creates a [sparse array](/en-US/docs/Web/JavaScript/Guide/Indexed_collections#sparse_arrays).\n\n```js\nconst numbers = [];\nnumbers.length = 3;\nconsole.log(numbers); // [empty x 3]\n```\n\n### Array with non-writable length\n\nThe `length` property is automatically updated by the array when elements are added beyond the current length. If the `length` property is made non-writable, the array will not be able to update it. This causes an error in [strict mode](/en-US/docs/Web/JavaScript/Reference/Strict_mode).\n\n```js\n"use strict";\n\nconst numbers = [1, 2, 3, 4, 5];\nObject.defineProperty(numbers, "length", { writable: false });\nnumbers[5] = 6; // TypeError: Cannot assign to read only property \'length\' of object \'[object Array]\'\nnumbers.push(5); // // TypeError: Cannot assign to read only property \'length\' of object \'[object Array]\'\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Indexed collections](/en-US/docs/Web/JavaScript/Guide/Indexed_collections) guide\n- {{jsxref("Array")}}\n- [`TypedArray.prototype.length`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/TypedArray/length)\n- [`String`: `length`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/length)\n- [RangeError: invalid array length](/en-US/docs/Web/JavaScript/Reference/Errors/Invalid_array_length)\n'
        },
        "map": {
            "index.md": '---\ntitle: Array.prototype.map()\nslug: Web/JavaScript/Reference/Global_Objects/Array/map\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Array.map\n---\n\n{{JSRef}}\n\nThe **`map()`** method of {{jsxref("Array")}} instances creates\na new array populated with the results of calling a provided function on\nevery element in the calling array.\n\n{{EmbedInteractiveExample("pages/js/array-map.html")}}\n\n## Syntax\n\n```js-nolint\nmap(callbackFn)\nmap(callbackFn, thisArg)\n```\n\n### Parameters\n\n- `callbackFn`\n  - : A function to execute for each element in the array. Its return value is added as a single element in the new array. The function is called with the following arguments:\n    - `element`\n      - : The current element being processed in the array.\n    - `index`\n      - : The index of the current element being processed in the array.\n    - `array`\n      - : The array `map()` was called upon.\n- `thisArg` {{optional_inline}}\n  - : A value to use as `this` when executing `callbackFn`. See [iterative methods](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array#iterative_methods).\n\n### Return value\n\nA new array with each element being the result of the callback function.\n\n## Description\n\nThe `map()` method is an [iterative method](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array#iterative_methods). It calls a provided `callbackFn` function once for each element in an array and constructs a new array from the results. Read the [iterative methods](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array#iterative_methods) section for more information about how these methods work in general.\n\n`callbackFn` is invoked only for array indexes which have assigned values. It is not invoked for empty slots in [sparse arrays](/en-US/docs/Web/JavaScript/Guide/Indexed_collections#sparse_arrays).\n\nThe `map()` method is [generic](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array#generic_array_methods). It only expects the `this` value to have a `length` property and integer-keyed properties.\n\nSince `map` builds a new array, calling it without using the returned array is an anti-pattern; use {{jsxref("Array/forEach", "forEach")}} or {{jsxref("Statements/for...of", "for...of")}} instead.\n\n## Examples\n\n### Mapping an array of numbers to an array of square roots\n\nThe following code takes an array of numbers and creates a new array containing the square roots of the numbers in the first array.\n\n```js\nconst numbers = [1, 4, 9];\nconst roots = numbers.map((num) => Math.sqrt(num));\n\n// roots is now     [1, 2, 3]\n// numbers is still [1, 4, 9]\n```\n\n### Using map to reformat objects in an array\n\nThe following code takes an array of objects and creates a new array containing the newly reformatted objects.\n\n```js\nconst kvArray = [\n  { key: 1, value: 10 },\n  { key: 2, value: 20 },\n  { key: 3, value: 30 },\n];\n\nconst reformattedArray = kvArray.map(({ key, value }) => ({ [key]: value }));\n\nconsole.log(reformattedArray); // [{ 1: 10 }, { 2: 20 }, { 3: 30 }]\nconsole.log(kvArray);\n// [\n//   { key: 1, value: 10 },\n//   { key: 2, value: 20 },\n//   { key: 3, value: 30 }\n// ]\n```\n\n### Using parseInt() with map()\n\nIt is common to use the callback with one argument (the element being traversed). Certain functions are also commonly used with one argument, even though they take additional optional arguments. These habits may lead to confusing behaviors. Consider:\n\n```js\n["1", "2", "3"].map(parseInt);\n```\n\nWhile one might expect `[1, 2, 3]`, the actual result is `[1, NaN, NaN]`.\n\n{{jsxref("parseInt")}} is often used with one argument, but takes two. The first is an expression and the second is the radix to the callback function, `Array.prototype.map` passes 3 arguments: the element, the index, and the array. The third argument is ignored by {{jsxref("parseInt")}} \u2014 but _not_ the second one! This is the source of possible confusion.\n\nHere is a concise example of the iteration steps:\n\n```js\n/* first iteration  (index is 0): */ parseInt("1", 0); // 1\n/* second iteration (index is 1): */ parseInt("2", 1); // NaN\n/* third iteration  (index is 2): */ parseInt("3", 2); // NaN\n```\n\nTo solve this, define another function that only takes one argument:\n\n```js\n["1", "2", "3"].map((str) => parseInt(str, 10)); // [1, 2, 3]\n```\n\nYou can also use the {{jsxref("Number")}} function, which only takes one argument:\n\n```js\n["1", "2", "3"].map(Number); // [1, 2, 3]\n\n// But unlike parseInt(), Number() will also return a float or (resolved) exponential notation:\n["1.1", "2.2e2", "3e300"].map(Number); // [1.1, 220, 3e+300]\n\n// For comparison, if we use parseInt() on the array above:\n["1.1", "2.2e2", "3e300"].map((str) => parseInt(str, 10)); // [1, 2, 3]\n```\n\nSee [A JavaScript optional argument hazard](https://wirfs-brock.com/allen/posts/166) by Allen Wirfs-Brock for more discussions.\n\n### Mapped array contains undefined\n\nWhen {{jsxref("undefined")}} or nothing is returned, the resulting array contains `undefined`. If you want to delete the element instead, chain a {{jsxref("Array/filter", "filter()")}} method, or use the {{jsxref("Array/flatMap", "flatMap()")}} method and return an empty array to signify deletion.\n\n```js\nconst numbers = [1, 2, 3, 4];\nconst filteredNumbers = numbers.map((num, index) => {\n  if (index < 3) {\n    return num;\n  }\n});\n\n// index goes from 0, so the filterNumbers are 1,2,3 and undefined.\n// filteredNumbers is [1, 2, 3, undefined]\n// numbers is still [1, 2, 3, 4]\n```\n\n### Side-effectful mapping\n\nThe callback can have side effects.\n\n```js\nconst cart = [5, 15, 25];\nlet total = 0;\nconst withTax = cart.map((cost) => {\n  total += cost;\n  return cost * 1.2;\n});\nconsole.log(withTax); // [6, 18, 30]\nconsole.log(total); // 45\n```\n\nThis is not recommended, because copying methods are best used with pure functions. In this case, we can choose to iterate the array twice.\n\n```js\nconst cart = [5, 15, 25];\nconst total = cart.reduce((acc, cost) => acc + cost, 0);\nconst withTax = cart.map((cost) => cost * 1.2);\n```\n\nSometimes this pattern goes to its extreme and the _only_ useful thing that `map()` does is causing side effects.\n\n```js\nconst products = [\n  { name: "sports car" },\n  { name: "laptop" },\n  { name: "phone" },\n];\n\nproducts.map((product) => {\n  product.price = 100;\n});\n```\n\nAs mentioned previously, this is an anti-pattern. If you don\'t use the return value of `map()`, use `forEach()` or a `for...of` loop instead.\n\n```js\nproducts.forEach((product) => {\n  product.price = 100;\n});\n```\n\nOr, if you want to create a new array instead:\n\n```js\nconst productsWithPrice = products.map((product) => {\n  return { ...product, price: 100 };\n});\n```\n\n### Using the third argument of callbackFn\n\nThe `array` argument is useful if you want to access another element in the array, especially when you don\'t have an existing variable that refers to the array. The following example first uses `filter()` to extract the positive values and then uses `map()` to create a new array where each element is the average of its neighbors and itself.\n\n```js\nconst numbers = [3, -1, 1, 4, 1, 5, 9, 2, 6];\nconst averaged = numbers\n  .filter((num) => num > 0)\n  .map((num, idx, arr) => {\n    // Without the arr argument, there\'s no way to easily access the\n    // intermediate array without saving it to a variable.\n    const prev = arr[idx - 1];\n    const next = arr[idx + 1];\n    let count = 1;\n    let total = num;\n    if (prev !== undefined) {\n      count++;\n      total += prev;\n    }\n    if (next !== undefined) {\n      count++;\n      total += next;\n    }\n    const average = total / count;\n    // Keep two decimal places\n    return Math.round(average * 100) / 100;\n  });\nconsole.log(averaged); // [2, 2.67, 2, 3.33, 5, 5.33, 5.67, 4]\n```\n\nThe `array` argument is _not_ the array that is being built \u2014 there is no way to access the array being built from the callback function.\n\n### Using map() on sparse arrays\n\nA sparse array remains sparse after `map()`. The indices of empty slots are still empty in the returned array, and the callback function won\'t be called on them.\n\n```js\nconsole.log(\n  [1, , 3].map((x, index) => {\n    console.log(`Visit ${index}`);\n    return x * 2;\n  }),\n);\n// Visit 0\n// Visit 2\n// [2, empty, 6]\n```\n\n### Calling map() on non-array objects\n\nThe `map()` method reads the `length` property of `this` and then accesses each property whose key is a nonnegative integer less than `length`.\n\n```js\nconst arrayLike = {\n  length: 3,\n  0: 2,\n  1: 3,\n  2: 4,\n  3: 5, // ignored by map() since length is 3\n};\nconsole.log(Array.prototype.map.call(arrayLike, (x) => x ** 2));\n// [ 4, 9, 16 ]\n```\n\nThis example shows how to iterate through a collection of objects collected by `querySelectorAll`. This is because `querySelectorAll` returns a `NodeList` (which is a collection of objects). In this case, we return all the selected `option`s\' values on the screen:\n\n```js\nconst elems = document.querySelectorAll("select option:checked");\nconst values = Array.prototype.map.call(elems, ({ value }) => value);\n```\n\nYou can also use {{jsxref("Array.from()")}} to transform `elems` to an array, and then access the `map()` method.\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Array.prototype.map` in `core-js`](https://github.com/zloirock/core-js#ecmascript-array)\n- [Indexed collections](/en-US/docs/Web/JavaScript/Guide/Indexed_collections) guide\n- {{jsxref("Array")}}\n- {{jsxref("Array.prototype.forEach()")}}\n- {{jsxref("Array.from()")}}\n- {{jsxref("TypedArray.prototype.map()")}}\n- {{jsxref("Map")}}\n'
        },
        "of": {
            "index.md": '---\ntitle: Array.of()\nslug: Web/JavaScript/Reference/Global_Objects/Array/of\npage-type: javascript-static-method\nbrowser-compat: javascript.builtins.Array.of\n---\n\n{{JSRef}}\n\nThe **`Array.of()`** static method creates a new `Array`\ninstance from a variable number of arguments, regardless of number or type of the\narguments.\n\n{{EmbedInteractiveExample("pages/js/array-of.html", "shorter")}}\n\n## Syntax\n\n```js-nolint\nArray.of()\nArray.of(element1)\nArray.of(element1, element2)\nArray.of(element1, element2, /* \u2026, */ elementN)\n```\n\n### Parameters\n\n- `element1`, \u2026, `elementN`\n  - : Elements used to create the array.\n\n### Return value\n\nA new {{jsxref("Array")}} instance.\n\n## Description\n\nThe difference between `Array.of()` and the [`Array()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/Array) constructor is in the handling of single arguments: `Array.of(7)` creates an array with a single element, `7`, whereas `Array(7)` creates an empty array with a `length` property of `7`. (That implies an array of 7 empty slots, not slots with actual {{jsxref("undefined")}} values.)\n\n```js\nArray.of(7); // [7]\nArray(7); // array of 7 empty slots\n\nArray.of(1, 2, 3); // [1, 2, 3]\nArray(1, 2, 3); // [1, 2, 3]\n```\n\nThe `Array.of()` method is a generic factory method. For example, if a subclass of `Array` inherits the `of()` method, the inherited `of()` method will return new instances of the subclass instead of `Array` instances. In fact, the `this` value can be any constructor function that accepts a single argument representing the length of the new array, and the constructor will be called with the number of arguments passed to `of()`. The final `length` will be set again when all elements are assigned. If the `this` value is not a constructor function, the plain `Array` constructor is used instead.\n\n## Examples\n\n### Using Array.of()\n\n```js\nArray.of(1); // [1]\nArray.of(1, 2, 3); // [1, 2, 3]\nArray.of(undefined); // [undefined]\n```\n\n### Calling of() on non-array constructors\n\nThe `of()` method can be called on any constructor function that accepts a single argument representing the length of the new array.\n\n```js\nfunction NotArray(len) {\n  console.log("NotArray called with length", len);\n}\n\nconsole.log(Array.of.call(NotArray, 1, 2, 3));\n// NotArray called with length 3\n// NotArray { \'0\': 1, \'1\': 2, \'2\': 3, length: 3 }\n\nconsole.log(Array.of.call(Object)); // [Number: 0] { length: 0 }\n```\n\nWhen the `this` value is not a constructor, a plain `Array` object is returned.\n\n```js\nconsole.log(Array.of.call({}, 1)); // [ 1 ]\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Array.of` in `core-js`](https://github.com/zloirock/core-js#ecmascript-array)\n- [Indexed collections](/en-US/docs/Web/JavaScript/Guide/Indexed_collections) guide\n- {{jsxref("Array")}}\n- {{jsxref("Array/Array", "Array()")}}\n- {{jsxref("Array.from()")}}\n- {{jsxref("TypedArray.of()")}}\n'
        },
        "pop": {
            "index.md": '---\ntitle: Array.prototype.pop()\nslug: Web/JavaScript/Reference/Global_Objects/Array/pop\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Array.pop\n---\n\n{{JSRef}}\n\nThe **`pop()`** method of {{jsxref("Array")}} instances removes the **last**\nelement from an array and returns that element. This method changes the length of the\narray.\n\n{{EmbedInteractiveExample("pages/js/array-pop.html")}}\n\n## Syntax\n\n```js-nolint\npop()\n```\n\n### Parameters\n\nNone.\n\n### Return value\n\nThe removed element from the array; {{jsxref("undefined")}} if the array is empty.\n\n## Description\n\nThe `pop()` method removes the last element from an array and returns that value to the caller. If you call `pop()` on an empty array, it returns {{jsxref("undefined")}}.\n\n{{jsxref("Array.prototype.shift()")}} has similar behavior to `pop()`, but applied to the first element in an array.\n\nThe `pop()` method is a mutating method. It changes the length and the content of `this`. In case you want the value of `this` to be the same, but return a new array with the last element removed, you can use [`arr.slice(0, -1)`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/slice) instead.\n\nThe `pop()` method is [generic](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array#generic_array_methods). It only expects the `this` value to have a `length` property and integer-keyed properties. Although strings are also array-like, this method is not suitable to be applied on them, as strings are immutable.\n\n## Examples\n\n### Removing the last element of an array\n\nThe following code creates the `myFish` array containing four elements, then\nremoves its last element.\n\n```js\nconst myFish = ["angel", "clown", "mandarin", "sturgeon"];\n\nconst popped = myFish.pop();\n\nconsole.log(myFish); // [\'angel\', \'clown\', \'mandarin\' ]\n\nconsole.log(popped); // \'sturgeon\'\n```\n\n### Calling pop() on non-array objects\n\nThe `pop()` method reads the `length` property of `this`. If the [normalized length](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array#normalization_of_the_length_property) is 0, `length` is set to `0` again (whereas it may be negative or `undefined` before). Otherwise, the property at `length - 1` is returned and [deleted](/en-US/docs/Web/JavaScript/Reference/Operators/delete).\n\n```js\nconst arrayLike = {\n  length: 3,\n  unrelated: "foo",\n  2: 4,\n};\nconsole.log(Array.prototype.pop.call(arrayLike));\n// 4\nconsole.log(arrayLike);\n// { length: 2, unrelated: \'foo\' }\n\nconst plainObj = {};\n// There\'s no length property, so the length is 0\nArray.prototype.pop.call(plainObj);\nconsole.log(plainObj);\n// { length: 0 }\n```\n\n### Using an object in an array-like fashion\n\n`push` and `pop` are intentionally generic, and we can use that to our advantage \u2014 as the following example shows.\n\nNote that in this example, we don\'t create an array to store a collection of objects. Instead, we store the collection on the object itself and use `call` on `Array.prototype.push` and `Array.prototype.pop` to trick those methods into thinking we\'re dealing with an array.\n\n```js\nconst collection = {\n  length: 0,\n  addElements(...elements) {\n    // obj.length will be incremented automatically\n    // every time an element is added.\n\n    // Returning what push returns; that is\n    // the new value of length property.\n    return [].push.call(this, ...elements);\n  },\n  removeElement() {\n    // obj.length will be decremented automatically\n    // every time an element is removed.\n\n    // Returning what pop returns; that is\n    // the removed element.\n    return [].pop.call(this);\n  },\n};\n\ncollection.addElements(10, 20, 30);\nconsole.log(collection.length); // 3\ncollection.removeElement();\nconsole.log(collection.length); // 2\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Indexed collections](/en-US/docs/Web/JavaScript/Guide/Indexed_collections) guide\n- {{jsxref("Array")}}\n- {{jsxref("Array.prototype.push()")}}\n- {{jsxref("Array.prototype.shift()")}}\n- {{jsxref("Array.prototype.unshift()")}}\n- {{jsxref("Array.prototype.concat()")}}\n- {{jsxref("Array.prototype.splice()")}}\n'
        },
        "push": {
            "index.md": '---\ntitle: Array.prototype.push()\nslug: Web/JavaScript/Reference/Global_Objects/Array/push\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Array.push\n---\n\n{{JSRef}}\n\nThe **`push()`** method of {{jsxref("Array")}} instances adds the specified elements to the end of\nan array and returns the new length of the array.\n\n{{EmbedInteractiveExample("pages/js/array-push.html")}}\n\n## Syntax\n\n```js-nolint\npush()\npush(element1)\npush(element1, element2)\npush(element1, element2, /* \u2026, */ elementN)\n```\n\n### Parameters\n\n- `element1`, \u2026, `elementN`\n  - : The element(s) to add to the end of the array.\n\n### Return value\n\nThe new {{jsxref("Array/length", "length")}} property of the object upon which the method was called.\n\n## Description\n\nThe `push()` method appends values to an array.\n\n{{jsxref("Array.prototype.unshift()")}} has similar behavior to `push()`, but applied to the start of an array.\n\nThe `push()` method is a [mutating method](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array#copying_methods_and_mutating_methods). It changes the length and the content of `this`. In case you want the value of `this` to be the same, but return a new array with elements appended to the end, you can use [`arr.concat([element0, element1, /* ... ,*/ elementN])`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/concat) instead. Notice that the elements are wrapped in an extra array \u2014 otherwise, if the element is an array itself, it would be spread instead of pushed as a single element due to the behavior of `concat()`.\n\nThe `push()` method is [generic](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array#generic_array_methods). It only expects the `this` value to have a `length` property and integer-keyed properties. Although strings are also array-like, this method is not suitable to be applied on them, as strings are immutable.\n\n## Examples\n\n### Adding elements to an array\n\nThe following code creates the `sports` array containing two elements, then\nappends two elements to it. The `total` variable contains the new length of\nthe array.\n\n```js\nconst sports = ["soccer", "baseball"];\nconst total = sports.push("football", "swimming");\n\nconsole.log(sports); // [\'soccer\', \'baseball\', \'football\', \'swimming\']\nconsole.log(total); // 4\n```\n\n### Merging two arrays\n\nThis example uses {{jsxref("Operators/Spread_syntax", "spread syntax", "", "1")}} to push all elements from a\nsecond array into the first one.\n\n```js\nconst vegetables = ["parsnip", "potato"];\nconst moreVegs = ["celery", "beetroot"];\n\n// Merge the second array into the first one\nvegetables.push(...moreVegs);\n\nconsole.log(vegetables); // [\'parsnip\', \'potato\', \'celery\', \'beetroot\']\n```\n\nMerging two arrays can also be done with the {{jsxref("Array/concat", "concat()")}} method.\n\n### Calling push() on non-array objects\n\nThe `push()` method reads the `length` property of `this`. It then sets each index of `this` starting at `length` with the arguments passed to `push()`. Finally, it sets the `length` to the previous length plus the number of pushed elements.\n\n```js\nconst arrayLike = {\n  length: 3,\n  unrelated: "foo",\n  2: 4,\n};\nArray.prototype.push.call(arrayLike, 1, 2);\nconsole.log(arrayLike);\n// { \'2\': 4, \'3\': 1, \'4\': 2, length: 5, unrelated: \'foo\' }\n\nconst plainObj = {};\n// There\'s no length property, so the length is 0\nArray.prototype.push.call(plainObj, 1, 2);\nconsole.log(plainObj);\n// { \'0\': 1, \'1\': 2, length: 2 }\n```\n\n### Using an object in an array-like fashion\n\nAs mentioned above, `push` is intentionally generic, and we can use that to\nour advantage. `Array.prototype.push` can work on an object just fine, as\nthis example shows.\n\nNote that we don\'t create an array to store a collection of objects. Instead, we store\nthe collection on the object itself and use `call` on\n`Array.prototype.push` to trick the method into thinking we are dealing with\nan array\u2014and it just works, thanks to the way JavaScript allows us to establish the\nexecution context in any way we want.\n\n```js\nconst obj = {\n  length: 0,\n\n  addElem(elem) {\n    // obj.length is automatically incremented\n    // every time an element is added.\n    [].push.call(this, elem);\n  },\n};\n\n// Let\'s add some empty objects just to illustrate.\nobj.addElem({});\nobj.addElem({});\nconsole.log(obj.length); // 2\n```\n\nNote that although `obj` is not an array, the method `push`\nsuccessfully incremented `obj`\'s `length` property just like if we\nwere dealing with an actual array.\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Array.prototype.push` in `core-js` with fixes of this method](https://github.com/zloirock/core-js#ecmascript-array)\n- [Indexed collections](/en-US/docs/Web/JavaScript/Guide/Indexed_collections) guide\n- {{jsxref("Array")}}\n- {{jsxref("Array.prototype.pop()")}}\n- {{jsxref("Array.prototype.shift()")}}\n- {{jsxref("Array.prototype.unshift()")}}\n- {{jsxref("Array.prototype.concat()")}}\n- {{jsxref("Array.prototype.splice()")}}\n'
        },
        "reduce": {
            "index.md": '---\ntitle: Array.prototype.reduce()\nslug: Web/JavaScript/Reference/Global_Objects/Array/reduce\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Array.reduce\n---\n\n{{JSRef}}\n\nThe **`reduce()`** method of {{jsxref("Array")}} instances executes a user-supplied "reducer" callback function on each element of the array, in order, passing in the return value from the calculation on the preceding element. The final result of running the reducer across all elements of the array is a single value.\n\nThe first time that the callback is run there is no "return value of the previous calculation". If supplied, an initial value may be used in its place. Otherwise the array element at index 0 is used as the initial value and iteration starts from the next element (index 1 instead of index 0).\n\n{{EmbedInteractiveExample("pages/js/array-reduce.html")}}\n\n## Syntax\n\n```js-nolint\nreduce(callbackFn)\nreduce(callbackFn, initialValue)\n```\n\n### Parameters\n\n- `callbackFn`\n  - : A function to execute for each element in the array. Its return value becomes the value of the `accumulator` parameter on the next invocation of `callbackFn`. For the last invocation, the return value becomes the return value of `reduce()`. The function is called with the following arguments:\n    - `accumulator`\n      - : The value resulting from the previous call to `callbackFn`. On the first call, its value is `initialValue` if the latter is specified; otherwise its value is `array[0]`.\n    - `currentValue`\n      - : The value of the current element. On the first call, its value is `array[0]` if `initialValue` is specified; otherwise its value is `array[1]`.\n    - `currentIndex`\n      - : The index position of `currentValue` in the array. On the first call, its value is `0` if `initialValue` is specified, otherwise `1`.\n    - `array`\n      - : The array `reduce()` was called upon.\n- `initialValue` {{optional_inline}}\n  - : A value to which `accumulator` is initialized the first time the callback is called.\n    If `initialValue` is specified, `callbackFn` starts executing with the first value in the array as `currentValue`.\n    If `initialValue` is _not_ specified, `accumulator` is initialized to the first value in the array, and `callbackFn` starts executing with the second value in the array as `currentValue`. In this case, if the array is empty (so that there\'s no first value to return as `accumulator`), an error is thrown.\n\n### Return value\n\nThe value that results from running the "reducer" callback function to completion over the entire array.\n\n### Exceptions\n\n- {{jsxref("TypeError")}}\n  - : Thrown if the array contains no elements and `initialValue` is not provided.\n\n## Description\n\nThe `reduce()` method is an [iterative method](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array#iterative_methods). It runs a "reducer" callback function over all elements in the array, in ascending-index order, and accumulates them into a single value. Every time, the return value of `callbackFn` is passed into `callbackFn` again on next invocation as `accumulator`. The final value of `accumulator` (which is the value returned from `callbackFn` on the final iteration of the array) becomes the return value of `reduce()`. Read the [iterative methods](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array#iterative_methods) section for more information about how these methods work in general.\n\n`callbackFn` is invoked only for array indexes which have assigned values. It is not invoked for empty slots in [sparse arrays](/en-US/docs/Web/JavaScript/Guide/Indexed_collections#sparse_arrays).\n\nUnlike other [iterative methods](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array#iterative_methods), `reduce()` does not accept a `thisArg` argument. `callbackFn` is always called with `undefined` as `this`, which gets substituted with `globalThis` if `callbackFn` is non-strict.\n\n`reduce()` is a central concept in [functional programming](https://en.wikipedia.org/wiki/Functional_programming), where it\'s not possible to mutate any value, so in order to accumulate all values in an array, one must return a new accumulator value on every iteration. This convention propagates to JavaScript\'s `reduce()`: you should use [spreading](/en-US/docs/Web/JavaScript/Reference/Operators/Spread_syntax) or other copying methods where possible to create new arrays and objects as the accumulator, rather than mutating the existing one. If you decided to mutate the accumulator instead of copying it, remember to still return the modified object in the callback, or the next iteration will receive undefined. However, note that copying the accumulator may in turn lead to increased memory usage and degraded performance \u2014 see [When to not use reduce()](#when_to_not_use_reduce) for more details. In such cases, to avoid bad performance and unreadable code, it\'s better to use a simple `for` loop instead.\n\nThe `reduce()` method is [generic](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array#generic_array_methods). It only expects the `this` value to have a `length` property and integer-keyed properties.\n\n### Edge cases\n\nIf the array only has one element (regardless of position) and no `initialValue` is provided, or if `initialValue` is provided but the array is empty, the solo value will be returned _without_ calling `callbackFn`.\n\nIf `initialValue` is provided and the array is not empty, then the reduce method will always invoke the callback function starting at index 0.\n\nIf `initialValue` is not provided then the reduce method will act differently for arrays with length larger than 1, equal to 1 and 0, as shown in the following example:\n\n```js\nconst getMax = (a, b) => Math.max(a, b);\n\n// callback is invoked for each element in the array starting at index 0\n[1, 100].reduce(getMax, 50); // 100\n[50].reduce(getMax, 10); // 50\n\n// callback is invoked once for element at index 1\n[1, 100].reduce(getMax); // 100\n\n// callback is not invoked\n[50].reduce(getMax); // 50\n[].reduce(getMax, 1); // 1\n\n[].reduce(getMax); // TypeError\n```\n\n## Examples\n\n### How reduce() works without an initial value\n\nThe code below shows what happens if we call `reduce()` with an array and no initial value.\n\n```js\nconst array = [15, 16, 17, 18, 19];\n\nfunction reducer(accumulator, currentValue, index) {\n  const returns = accumulator + currentValue;\n  console.log(\n    `accumulator: ${accumulator}, currentValue: ${currentValue}, index: ${index}, returns: ${returns}`,\n  );\n  return returns;\n}\n\narray.reduce(reducer);\n```\n\nThe callback would be invoked four times, with the arguments and return values in each call being as follows:\n\n|             | `accumulator` | `currentValue` | `index` | Return value |\n| ----------- | ------------- | -------------- | ------- | ------------ |\n| First call  | `15`          | `16`           | `1`     | `31`         |\n| Second call | `31`          | `17`           | `2`     | `48`         |\n| Third call  | `48`          | `18`           | `3`     | `66`         |\n| Fourth call | `66`          | `19`           | `4`     | `85`         |\n\nThe `array` parameter never changes through the process \u2014 it\'s always `[15, 16, 17, 18, 19]`. The value returned by `reduce()` would be that of the last callback invocation (`85`).\n\n### How reduce() works with an initial value\n\nHere we reduce the same array using the same algorithm, but with an `initialValue` of `10` passed as the second argument to `reduce()`:\n\n```js\n[15, 16, 17, 18, 19].reduce(\n  (accumulator, currentValue) => accumulator + currentValue,\n  10,\n);\n```\n\nThe callback would be invoked five times, with the arguments and return values in each call being as follows:\n\n|             | `accumulator` | `currentValue` | `index` | Return value |\n| ----------- | ------------- | -------------- | ------- | ------------ |\n| First call  | `10`          | `15`           | `0`     | `25`         |\n| Second call | `25`          | `16`           | `1`     | `41`         |\n| Third call  | `41`          | `17`           | `2`     | `58`         |\n| Fourth call | `58`          | `18`           | `3`     | `76`         |\n| Fifth call  | `76`          | `19`           | `4`     | `95`         |\n\nThe value returned by `reduce()` in this case would be `95`.\n\n### Sum of values in an object array\n\nTo sum up the values contained in an array of objects, you **must** supply\nan `initialValue`, so that each item passes through your function.\n\n```js\nconst objects = [{ x: 1 }, { x: 2 }, { x: 3 }];\nconst sum = objects.reduce(\n  (accumulator, currentValue) => accumulator + currentValue.x,\n  0,\n);\n\nconsole.log(sum); // 6\n```\n\n### Function sequential piping\n\nThe `pipe` function takes a sequence of functions and returns a new function. When the new function is called with an argument, the sequence of functions are called in order, which each one receiving the return value of the previous function.\n\n```js\nconst pipe =\n  (...functions) =>\n  (initialValue) =>\n    functions.reduce((acc, fn) => fn(acc), initialValue);\n\n// Building blocks to use for composition\nconst double = (x) => 2 * x;\nconst triple = (x) => 3 * x;\nconst quadruple = (x) => 4 * x;\n\n// Composed functions for multiplication of specific values\nconst multiply6 = pipe(double, triple);\nconst multiply9 = pipe(triple, triple);\nconst multiply16 = pipe(quadruple, quadruple);\nconst multiply24 = pipe(double, triple, quadruple);\n\n// Usage\nmultiply6(6); // 36\nmultiply9(9); // 81\nmultiply16(16); // 256\nmultiply24(10); // 240\n```\n\n### Running promises in sequence\n\n[Promise sequencing](/en-US/docs/Web/JavaScript/Guide/Using_promises#composition) is essentially function piping demonstrated in the previous section, except done asynchronously.\n\n```js\n// Compare this with pipe: fn(acc) is changed to acc.then(fn),\n// and initialValue is ensured to be a promise\nconst asyncPipe =\n  (...functions) =>\n  (initialValue) =>\n    functions.reduce((acc, fn) => acc.then(fn), Promise.resolve(initialValue));\n\n// Building blocks to use for composition\nconst p1 = async (a) => a * 5;\nconst p2 = async (a) => a * 2;\n// The composed functions can also return non-promises, because the values are\n// all eventually wrapped in promises\nconst f3 = (a) => a * 3;\nconst p4 = async (a) => a * 4;\n\nasyncPipe(p1, p2, f3, p4)(10).then(console.log); // 1200\n```\n\n`asyncPipe` can also be implemented using `async`/`await`, which better demonstrates its similarity with `pipe`:\n\n```js\nconst asyncPipe =\n  (...functions) =>\n  (initialValue) =>\n    functions.reduce(async (acc, fn) => fn(await acc), initialValue);\n```\n\n### Using reduce() with sparse arrays\n\n`reduce()` skips missing elements in sparse arrays, but it does not skip `undefined` values.\n\n```js\nconsole.log([1, 2, , 4].reduce((a, b) => a + b)); // 7\nconsole.log([1, 2, undefined, 4].reduce((a, b) => a + b)); // NaN\n```\n\n### Calling reduce() on non-array objects\n\nThe `reduce()` method reads the `length` property of `this` and then accesses each property whose key is a nonnegative integer less than `length`.\n\n```js\nconst arrayLike = {\n  length: 3,\n  0: 2,\n  1: 3,\n  2: 4,\n  3: 99, // ignored by reduce() since length is 3\n};\nconsole.log(Array.prototype.reduce.call(arrayLike, (x, y) => x + y));\n// 9\n```\n\n### When to not use reduce()\n\nMultipurpose higher-order functions like `reduce()` can be powerful but sometimes difficult to understand, especially for less-experienced JavaScript developers. If code becomes clearer when using other array methods, developers must weigh the readability tradeoff against the other benefits of using `reduce()`.\n\nNote that `reduce()` is always equivalent to a `for...of` loop, except that instead of mutating a variable in the upper scope, we now return the new value for each iteration:\n\n```js\nconst val = array.reduce((acc, cur) => update(acc, cur), initialValue);\n\n// Is equivalent to:\nlet val = initialValue;\nfor (const cur of array) {\n  val = update(val, cur);\n}\n```\n\nAs previously stated, the reason why people may want to use `reduce()` is to mimic functional programming practices of immutable data. Therefore, developers who uphold the immutability of the accumulator often copy the entire accumulator for each iteration, like this:\n\n```js example-bad\nconst names = ["Alice", "Bob", "Tiff", "Bruce", "Alice"];\nconst countedNames = names.reduce((allNames, name) => {\n  const currCount = Object.hasOwn(allNames, name) ? allNames[name] : 0;\n  return {\n    ...allNames,\n    [name]: currCount + 1,\n  };\n}, {});\n```\n\nThis code is ill-performing, because each iteration has to copy the entire `allNames` object, which could be big, depending how many unique names there are. This code has worst-case `O(N^2)` performance, where `N` is the length of `names`.\n\nA better alternative is to _mutate_ the `allNames` object on each iteration. However, if `allNames` gets mutated anyway, you may want to convert the `reduce()` to a simple `for` loop instead, which is much clearer:\n\n```js example-bad\nconst names = ["Alice", "Bob", "Tiff", "Bruce", "Alice"];\nconst countedNames = names.reduce((allNames, name) => {\n  const currCount = allNames[name] ?? 0;\n  allNames[name] = currCount + 1;\n  // return allNames, otherwise the next iteration receives undefined\n  return allNames;\n}, Object.create(null));\n```\n\n```js example-good\nconst names = ["Alice", "Bob", "Tiff", "Bruce", "Alice"];\nconst countedNames = Object.create(null);\nfor (const name of names) {\n  const currCount = countedNames[name] ?? 0;\n  countedNames[name] = currCount + 1;\n}\n```\n\nTherefore, if your accumulator is an array or an object and you are copying the array or object on each iteration, you may accidentally introduce quadratic complexity into your code, causing performance to quickly degrade on large data. This has happened in real-world code \u2014 see for example [Making Tanstack Table 1000x faster with a 1 line change](https://jpcamara.com/2023/03/07/making-tanstack-table.html).\n\nSome of the acceptable use cases of `reduce()` are given above (most notably, summing an array, promise sequencing, and function piping). There are other cases where better alternatives than `reduce()` exist.\n\n- Flattening an array of arrays. Use {{jsxref("Array/flat", "flat()")}} instead.\n\n  ```js example-bad\n  const flattened = array.reduce((acc, cur) => acc.concat(cur), []);\n  ```\n\n  ```js example-good\n  const flattened = array.flat();\n  ```\n\n- Grouping objects by a property. Use {{jsxref("Object.groupBy()")}} instead.\n\n  ```js example-bad\n  const groups = array.reduce((acc, obj) => {\n    const key = obj.name;\n    const curGroup = acc[key] ?? [];\n    return { ...acc, [key]: [...curGroup, obj] };\n  }, {});\n  ```\n\n  ```js example-good\n  const groups = Object.groupBy(array, (obj) => obj.name);\n  ```\n\n- Concatenating arrays contained in an array of objects. Use {{jsxref("Array/flatMap", "flatMap()")}} instead.\n\n  ```js example-bad\n  const friends = [\n    { name: "Anna", books: ["Bible", "Harry Potter"] },\n    { name: "Bob", books: ["War and peace", "Romeo and Juliet"] },\n    { name: "Alice", books: ["The Lord of the Rings", "The Shining"] },\n  ];\n  const allBooks = friends.reduce((acc, cur) => [...acc, ...cur.books], []);\n  ```\n\n  ```js example-good\n  const allBooks = friends.flatMap((person) => person.books);\n  ```\n\n- Removing duplicate items in an array. Use {{jsxref("Set")}} and {{jsxref("Array.from()")}} instead.\n\n  ```js example-bad\n  const uniqArray = array.reduce(\n    (acc, cur) => (acc.includes(cur) ? acc : [...acc, cur]),\n    [],\n  );\n  ```\n\n  ```js example-good\n  const uniqArray = Array.from(new Set(array));\n  ```\n\n- Eliminating or adding elements in an array. Use {{jsxref("Array/flatMap", "flatMap()")}} instead.\n\n  ```js example-bad\n  // Takes an array of numbers and splits perfect squares into its square roots\n  const roots = array.reduce((acc, cur) => {\n    if (cur < 0) return acc;\n    const root = Math.sqrt(cur);\n    if (Number.isInteger(root)) return [...acc, root, root];\n    return [...acc, cur];\n  }, []);\n  ```\n\n  ```js example-good\n  const roots = array.flatMap((val) => {\n    if (val < 0) return [];\n    const root = Math.sqrt(val);\n    if (Number.isInteger(root)) return [root, root];\n    return [val];\n  });\n  ```\n\n  If you are only eliminating elements from an array, you also can use {{jsxref("Array/filter", "filter()")}}.\n\n- Searching for elements or testing if elements satisfy a condition. Use {{jsxref("Array/find", "find()")}} and {{jsxref("Array/find", "findIndex()")}}, or {{jsxref("Array/some", "some()")}} and {{jsxref("Array/every", "every()")}} instead. These methods have the additional benefit that they return as soon as the result is certain, without iterating the entire array.\n\n  ```js example-bad\n  const allEven = array.reduce((acc, cur) => acc && cur % 2 === 0, true);\n  ```\n\n  ```js example-good\n  const allEven = array.every((val) => val % 2 === 0);\n  ```\n\nIn cases where `reduce()` is the best choice, documentation and semantic variable naming can help mitigate readability drawbacks.\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Array.prototype.reduce` in `core-js`](https://github.com/zloirock/core-js#ecmascript-array)\n- [Indexed collections](/en-US/docs/Web/JavaScript/Guide/Indexed_collections) guide\n- {{jsxref("Array")}}\n- {{jsxref("Array.prototype.map()")}}\n- {{jsxref("Array.prototype.flat()")}}\n- {{jsxref("Array.prototype.flatMap()")}}\n- {{jsxref("Array.prototype.reduceRight()")}}\n- {{jsxref("TypedArray.prototype.reduce()")}}\n- {{jsxref("Object.groupBy()")}}\n- {{jsxref("Map.groupBy()")}}\n'
        },
        "reduceright": {
            "index.md": '---\ntitle: Array.prototype.reduceRight()\nslug: Web/JavaScript/Reference/Global_Objects/Array/reduceRight\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Array.reduceRight\n---\n\n{{JSRef}}\n\nThe **`reduceRight()`** method of {{jsxref("Array")}} instances applies a function against an accumulator and each value of the array (from right-to-left) to reduce it to a single value.\n\nSee also {{jsxref("Array.prototype.reduce()")}} for left-to-right.\n\n{{EmbedInteractiveExample("pages/js/array-reduce-right.html")}}\n\n## Syntax\n\n```js-nolint\nreduceRight(callbackFn)\nreduceRight(callbackFn, initialValue)\n```\n\n### Parameters\n\n- `callbackFn`\n  - : A function to execute for each element in the array. Its return value becomes the value of the `accumulator` parameter on the next invocation of `callbackFn`. For the last invocation, the return value becomes the return value of `reduceRight()`. The function is called with the following arguments:\n    - `accumulator`\n      - : The value resulting from the previous call to `callbackFn`. On the first call, its value is `initialValue` if the latter is specified; otherwise its value is the last element of the array.\n    - `currentValue`\n      - : The value of the current element. On the first call, its value is the last element if `initialValue` is specified; otherwise its value is the second-to-last element.\n    - `currentIndex`\n      - : The index position of `currentValue` in the array. On the first call, its value is `array.length - 1` if `initialValue` is specified, otherwise `array.length - 2`.\n    - `array`\n      - : The array `reduceRight()` was called upon.\n- `initialValue` {{optional_inline}}\n  - : Value to use as accumulator to the first call of the `callbackFn`. If no initial value is supplied, the last element in the array will be used and skipped. Calling `reduceRight()` on an empty array without an initial value creates a `TypeError`.\n\n### Return value\n\nThe value that results from the reduction.\n\n## Description\n\nThe `reduceRight()` method is an [iterative method](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array#iterative_methods). It runs a "reducer" callback function over all elements in the array, in descending-index order, and accumulates them into a single value. Read the [iterative methods](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array#iterative_methods) section for more information about how these methods work in general.\n\n`callbackFn` is invoked only for array indexes which have assigned values. It is not invoked for empty slots in [sparse arrays](/en-US/docs/Web/JavaScript/Guide/Indexed_collections#sparse_arrays).\n\nUnlike other [iterative methods](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array#iterative_methods), `reduceRight()` does not accept a `thisArg` argument. `callbackFn` is always called with `undefined` as `this`, which gets substituted with `globalThis` if `callbackFn` is non-strict.\n\nThe `reduceRight()` method is [generic](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array#generic_array_methods). It only expects the `this` value to have a `length` property and integer-keyed properties.\n\nAll caveats about `reduce` discussed in [when not to use reduce()](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduce#when_not_to_use_reduce) apply to `reduceRight` as well. Because JavaScript has no lazy evaluation semantics, there is no performance difference between `reduce` and `reduceRight`.\n\n## Examples\n\n### How reduceRight() works without an initial value\n\nThe call to the reduceRight `callbackFn` would look something like this:\n\n```js\narr.reduceRight((accumulator, currentValue, index, array) => {\n  // \u2026\n});\n```\n\nThe first time the function is called, the `accumulator` and `currentValue` can be one of two values. If an `initialValue` was provided in the call to `reduceRight`, then `accumulator` will be equal to `initialValue` and `currentValue` will be equal to the last value in the array. If no `initialValue` was provided, then `accumulator` will be equal to the last value in the array and `currentValue` will be equal to the second-to-last value.\n\nIf the array is empty and no `initialValue` was provided, {{jsxref("TypeError")}} would be thrown. If the array has only one element (regardless of position) and no `initialValue` was provided, or if `initialValue` is provided but the array is empty, the solo value would be returned without calling `callbackFn`.\n\nSome example run-throughs of the function would look like this:\n\n```js\n[0, 1, 2, 3, 4].reduceRight(\n  (accumulator, currentValue, index, array) => accumulator + currentValue,\n);\n```\n\nThe callback would be invoked four times, with the arguments and return values in each call being as follows:\n\n|             | `accumulator` | `currentValue` | `index` | Return value |\n| ----------- | ------------- | -------------- | ------- | ------------ |\n| First call  | `4`           | `3`            | `3`     | `7`          |\n| Second call | `7`           | `2`            | `2`     | `9`          |\n| Third call  | `9`           | `1`            | `1`     | `10`         |\n| Fourth call | `10`          | `0`            | `0`     | `10`         |\n\nThe `array` parameter never changes through the process \u2014 it\'s always `[0, 1, 2, 3, 4]`. The value returned by `reduceRight` would be that of the last callback invocation (`10`).\n\n### How reduceRight() works with an initial value\n\nHere we reduce the same array using the same algorithm, but with an `initialValue` of `10` passed as the second argument to `reduceRight()`:\n\n```js\n[0, 1, 2, 3, 4].reduceRight(\n  (accumulator, currentValue, index, array) => accumulator + currentValue,\n  10,\n);\n```\n\n|             | `accumulator` | `currentValue` | `index` | Return value |\n| ----------- | ------------- | -------------- | ------- | ------------ |\n| First call  | `10`          | `4`            | `4`     | `14`         |\n| Second call | `14`          | `3`            | `3`     | `17`         |\n| Third call  | `17`          | `2`            | `2`     | `19`         |\n| Fourth call | `19`          | `1`            | `1`     | `20`         |\n| Fifth call  | `20`          | `0`            | `0`     | `20`         |\n\nThe value returned by `reduceRight` this time would be, of course, `20`.\n\n### Sum up all values within an array\n\n```js\nconst sum = [0, 1, 2, 3].reduceRight((a, b) => a + b);\n// sum is 6\n```\n\n### Run a list of asynchronous functions with callbacks in series each passing their results to the next\n\n```js\nconst waterfall =\n  (...functions) =>\n  (callback, ...args) =>\n    functions.reduceRight(\n      (composition, fn) =>\n        (...results) =>\n          fn(composition, ...results),\n      callback,\n    )(...args);\n\nconst randInt = (max) => Math.floor(Math.random() * max);\n\nconst add5 = (callback, x) => {\n  setTimeout(callback, randInt(1000), x + 5);\n};\nconst mult3 = (callback, x) => {\n  setTimeout(callback, randInt(1000), x * 3);\n};\nconst sub2 = (callback, x) => {\n  setTimeout(callback, randInt(1000), x - 2);\n};\nconst split = (callback, x) => {\n  setTimeout(callback, randInt(1000), x, x);\n};\nconst add = (callback, x, y) => {\n  setTimeout(callback, randInt(1000), x + y);\n};\nconst div4 = (callback, x) => {\n  setTimeout(callback, randInt(1000), x / 4);\n};\n\nconst computation = waterfall(add5, mult3, sub2, split, add, div4);\ncomputation(console.log, 5); // Logs 14\n\n// same as:\n\nconst computation2 = (input, callback) => {\n  const f6 = (x) => div4(callback, x);\n  const f5 = (x, y) => add(f6, x, y);\n  const f4 = (x) => split(f5, x);\n  const f3 = (x) => sub2(f4, x);\n  const f2 = (x) => mult3(f3, x);\n  add5(f2, input);\n};\n```\n\n### Difference between reduce and reduceRight\n\n```js\nconst a = ["1", "2", "3", "4", "5"];\nconst left = a.reduce((prev, cur) => prev + cur);\nconst right = a.reduceRight((prev, cur) => prev + cur);\n\nconsole.log(left); // "12345"\nconsole.log(right); // "54321"\n```\n\n### Defining composable functions\n\nFunction composition is a mechanism for combining functions, in which the output of each function is passed into the next one, and the output of the last function is the final result. In this example we use `reduceRight()` to implement function composition.\n\nSee also [Function composition](<https://en.wikipedia.org/wiki/Function_composition_(computer_science)>) on Wikipedia.\n\n```js\nconst compose =\n  (...args) =>\n  (value) =>\n    args.reduceRight((acc, fn) => fn(acc), value);\n\n// Increment passed number\nconst inc = (n) => n + 1;\n\n// Doubles the passed value\nconst double = (n) => n * 2;\n\n// using composition function\nconsole.log(compose(double, inc)(2)); // 6\n\n// using composition function\nconsole.log(compose(inc, double)(2)); // 5\n```\n\n### Using reduceRight() with sparse arrays\n\n`reduceRight()` skips missing elements in sparse arrays, but it does not skip `undefined` values.\n\n```js\nconsole.log([1, 2, , 4].reduceRight((a, b) => a + b)); // 7\nconsole.log([1, 2, undefined, 4].reduceRight((a, b) => a + b)); // NaN\n```\n\n### Calling reduceRight() on non-array objects\n\nThe `reduceRight()` method reads the `length` property of `this` and then accesses each property whose key is a nonnegative integer less than `length`.\n\n```js\nconst arrayLike = {\n  length: 3,\n  0: 2,\n  1: 3,\n  2: 4,\n  3: 99, // ignored by reduceRight() since length is 3\n};\nconsole.log(Array.prototype.reduceRight.call(arrayLike, (x, y) => x - y));\n// -1, which is 4 - 3 - 2\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Array.prototype.reduceRight` in `core-js`](https://github.com/zloirock/core-js#ecmascript-array)\n- [Indexed collections](/en-US/docs/Web/JavaScript/Guide/Indexed_collections) guide\n- {{jsxref("Array")}}\n- {{jsxref("Array.prototype.map()")}}\n- {{jsxref("Array.prototype.flat()")}}\n- {{jsxref("Array.prototype.flatMap()")}}\n- {{jsxref("Array.prototype.reduce()")}}\n- {{jsxref("TypedArray.prototype.reduceRight()")}}\n- {{jsxref("Object.groupBy()")}}\n- {{jsxref("Map.groupBy()")}}\n'
        },
        "reverse": {
            "index.md": '---\ntitle: Array.prototype.reverse()\nslug: Web/JavaScript/Reference/Global_Objects/Array/reverse\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Array.reverse\n---\n\n{{JSRef}}\n\nThe **`reverse()`** method of {{jsxref("Array")}} instances reverses an array _[in place](https://en.wikipedia.org/wiki/In-place_algorithm)_ and returns the reference to the same array, the first array element now becoming the last, and the last array element becoming the first. In other words, elements order in the array will be turned towards the direction opposite to that previously stated.\n\nTo reverse the elements in an array without mutating the original array, use {{jsxref("Array/toReversed", "toReversed()")}}.\n\n{{EmbedInteractiveExample("pages/js/array-reverse.html")}}\n\n## Syntax\n\n```js-nolint\nreverse()\n```\n\n### Parameters\n\nNone.\n\n### Return value\n\nThe reference to the original array, now reversed. Note that the array is reversed _[in place](https://en.wikipedia.org/wiki/In-place_algorithm)_, and no copy is made.\n\n## Description\n\nThe `reverse()` method transposes the elements of the calling array object in\nplace, mutating the array, and returning a reference to the array.\n\nThe `reverse()` method preserves empty slots. If the source array is [sparse](/en-US/docs/Web/JavaScript/Guide/Indexed_collections#sparse_arrays), the empty slots\' corresponding new indices are [deleted](/en-US/docs/Web/JavaScript/Reference/Operators/delete) and also become empty slots.\n\nThe `reverse()` method is [generic](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array#generic_array_methods). It only expects the `this` value to have a `length` property and integer-keyed properties. Although strings are also array-like, this method is not suitable to be applied on them, as strings are immutable.\n\n## Examples\n\n### Reversing the elements in an array\n\nThe following example creates an array `items`, containing three elements, then\nreverses the array. The call to `reverse()` returns a reference to the\nreversed array `items`.\n\n```js\nconst items = [1, 2, 3];\nconsole.log(items); // [1, 2, 3]\n\nitems.reverse();\nconsole.log(items); // [3, 2, 1]\n```\n\n### The reverse() method returns the reference to the same array\n\nThe `reverse()` method returns reference to the original array, so mutating the returned array will mutate the original array as well.\n\n```js\nconst numbers = [3, 2, 4, 1, 5];\nconst reversed = numbers.reverse();\n// numbers and reversed are both in reversed order [5, 1, 4, 2, 3]\nreversed[0] = 5;\nconsole.log(numbers[0]); // 5\n```\n\nIn case you want `reverse()` to not mutate the original array, but return a [shallow-copied](/en-US/docs/Glossary/Shallow_copy) array like other array methods (e.g. [`map()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/map)) do, use the {{jsxref("Array/toReversed", "toReversed()")}} method. Alternatively, you can do a shallow copy before calling `reverse()`, using the [spread syntax](/en-US/docs/Web/JavaScript/Reference/Operators/Spread_syntax) or [`Array.from()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/from).\n\n```js\nconst numbers = [3, 2, 4, 1, 5];\n// [...numbers] creates a shallow copy, so reverse() does not mutate the original\nconst reverted = [...numbers].reverse();\nreverted[0] = 5;\nconsole.log(numbers[0]); // 3\n```\n\n### Using reverse() on sparse arrays\n\nSparse arrays remain sparse after calling `reverse()`. Empty slots are copied over to their respective new indices as empty slots.\n\n```js\nconsole.log([1, , 3].reverse()); // [3, empty, 1]\nconsole.log([1, , 3, 4].reverse()); // [4, 3, empty, 1]\n```\n\n### Calling reverse() on non-array objects\n\nThe `reverse()` method reads the `length` property of `this`. It then visits each property having an integer key between `0` and `length / 2`, and swaps the two corresponding indices on both ends, [deleting](/en-US/docs/Web/JavaScript/Reference/Operators/delete) any destination property for which the source property did not exist.\n\n```js\nconst arrayLike = {\n  length: 3,\n  unrelated: "foo",\n  2: 4,\n  3: 33, // ignored by reverse() since length is 3\n};\nconsole.log(Array.prototype.reverse.call(arrayLike));\n// { 0: 4, 3: 33, length: 3, unrelated: \'foo\' }\n// The index 2 is deleted because there was no index 0 present originally\n// The index 3 is unchanged since the length is 3\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Array.prototype.reverse` in `core-js`](https://github.com/zloirock/core-js#ecmascript-array)\n- [Indexed collections](/en-US/docs/Web/JavaScript/Guide/Indexed_collections) guide\n- {{jsxref("Array")}}\n- {{jsxref("Array.prototype.join()")}}\n- {{jsxref("Array.prototype.sort()")}}\n- {{jsxref("Array.prototype.toReversed()")}}\n- {{jsxref("TypedArray.prototype.reverse()")}}\n'
        },
        "shift": {
            "index.md": '---\ntitle: Array.prototype.shift()\nslug: Web/JavaScript/Reference/Global_Objects/Array/shift\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Array.shift\n---\n\n{{JSRef}}\n\nThe **`shift()`** method of {{jsxref("Array")}} instances removes the **first**\nelement from an array and returns that removed element. This method changes the length\nof the array.\n\n{{EmbedInteractiveExample("pages/js/array-shift.html")}}\n\n## Syntax\n\n```js-nolint\nshift()\n```\n\n### Parameters\n\nNone.\n\n### Return value\n\nThe removed element from the array; {{jsxref("undefined")}} if the array is empty.\n\n## Description\n\nThe `shift()` method removes the element at the zeroth index and shifts the\nvalues at consecutive indexes down, then returns the removed value. If the\n{{jsxref("Array/length", "length")}} property is 0, {{jsxref("undefined")}} is returned.\n\nThe {{jsxref("Array/pop", "pop()")}} method has similar behavior to `shift()`, but applied to the last element in an array.\n\nThe `shift()` method is a [mutating method](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array#copying_methods_and_mutating_methods). It changes the length and the content of `this`. In case you want the value of `this` to be the same, but return a new array with the first element removed, you can use [`arr.slice(1)`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/slice) instead.\n\nThe `shift()` method is [generic](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array#generic_array_methods). It only expects the `this` value to have a `length` property and integer-keyed properties. Although strings are also array-like, this method is not suitable to be applied on them, as strings are immutable.\n\n## Examples\n\n### Removing an element from an array\n\nThe following code displays the `myFish` array before and after removing its\nfirst element. It also displays the removed element:\n\n```js\nconst myFish = ["angel", "clown", "mandarin", "surgeon"];\n\nconsole.log("myFish before:", myFish);\n// myFish before: [\'angel\', \'clown\', \'mandarin\', \'surgeon\']\n\nconst shifted = myFish.shift();\n\nconsole.log("myFish after:", myFish);\n// myFish after: [\'clown\', \'mandarin\', \'surgeon\']\n\nconsole.log("Removed this element:", shifted);\n// Removed this element: angel\n```\n\n### Using shift() method in while loop\n\nThe shift() method is often used in condition inside while loop. In the following\nexample every iteration will remove the next element from an array, until it is empty:\n\n```js\nconst names = ["Andrew", "Tyrone", "Paul", "Maria", "Gayatri"];\n\nwhile (typeof (i = names.shift()) !== "undefined") {\n  console.log(i);\n}\n// Andrew, Tyrone, Paul, Maria, Gayatri\n```\n\n### Calling shift() on non-array objects\n\nThe `shift()` method reads the `length` property of `this`. If the [normalized length](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array#normalization_of_the_length_property) is 0, `length` is set to `0` again (whereas it may be negative or `undefined` before). Otherwise, the property at `0` is returned, and the rest of the properties are shifted left by one. The `length` property is decremented by one.\n\n```js\nconst arrayLike = {\n  length: 3,\n  unrelated: "foo",\n  2: 4,\n};\nconsole.log(Array.prototype.shift.call(arrayLike));\n// undefined, because it is an empty slot\nconsole.log(arrayLike);\n// { \'1\': 4, length: 2, unrelated: \'foo\' }\n\nconst plainObj = {};\n// There\'s no length property, so the length is 0\nArray.prototype.shift.call(plainObj);\nconsole.log(plainObj);\n// { length: 0 }\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Indexed collections](/en-US/docs/Web/JavaScript/Guide/Indexed_collections) guide\n- {{jsxref("Array")}}\n- {{jsxref("Array.prototype.push()")}}\n- {{jsxref("Array.prototype.pop()")}}\n- {{jsxref("Array.prototype.unshift()")}}\n- {{jsxref("Array.prototype.concat()")}}\n- {{jsxref("Array.prototype.splice()")}}\n'
        },
        "slice": {
            "index.md": '---\ntitle: Array.prototype.slice()\nslug: Web/JavaScript/Reference/Global_Objects/Array/slice\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Array.slice\n---\n\n{{JSRef}}\n\nThe **`slice()`** method of {{jsxref("Array")}} instances returns a [shallow copy](/en-US/docs/Glossary/Shallow_copy) of a portion of\nan array into a new array object selected from `start` to `end`\n(`end` not included) where `start` and `end` represent\nthe index of items in that array. The original array will not be modified.\n\n{{EmbedInteractiveExample("pages/js/array-slice.html", "taller")}}\n\n## Syntax\n\n```js-nolint\nslice()\nslice(start)\nslice(start, end)\n```\n\n### Parameters\n\n- `start` {{optional_inline}}\n  - : Zero-based index at which to start extraction, [converted to an integer](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number#integer_conversion).\n    - Negative index counts back from the end of the array \u2014 if `-array.length <= start < 0`, `start + array.length` is used.\n    - If `start < -array.length` or `start` is omitted, `0` is used.\n    - If `start >= array.length`, nothing is extracted.\n- `end` {{optional_inline}}\n  - : Zero-based index at which to end extraction, [converted to an integer](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number#integer_conversion). `slice()` extracts up to but not including `end`.\n    - Negative index counts back from the end of the array \u2014 if `-array.length <= end < 0`, `end + array.length` is used.\n    - If `end < -array.length`, `0` is used.\n    - If `end >= array.length` or `end` is omitted, `array.length` is used, causing all elements until the end to be extracted.\n    - If `end` implies a position before or at the position that `start` implies, nothing is extracted.\n\n### Return value\n\nA new array containing the extracted elements.\n\n## Description\n\nThe `slice()` method is a [copying method](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array#copying_methods_and_mutating_methods). It does not alter `this` but instead returns a [shallow copy](/en-US/docs/Glossary/Shallow_copy) that contains some of the same elements as the ones from the original array.\n\nThe `slice()` method preserves empty slots. If the sliced portion is [sparse](/en-US/docs/Web/JavaScript/Guide/Indexed_collections#sparse_arrays), the returned array is sparse as well.\n\nThe `slice()` method is [generic](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array#generic_array_methods). It only expects the `this` value to have a `length` property and integer-keyed properties.\n\n## Examples\n\n### Return a portion of an existing array\n\n```js\nconst fruits = ["Banana", "Orange", "Lemon", "Apple", "Mango"];\nconst citrus = fruits.slice(1, 3);\n\n// fruits contains [\'Banana\', \'Orange\', \'Lemon\', \'Apple\', \'Mango\']\n// citrus contains [\'Orange\',\'Lemon\']\n```\n\n### Using slice\n\nIn the following example, `slice` creates a new array, `newCar`,\nfrom `myCar`. Both include a reference to the object `myHonda`.\nWhen the color of `myHonda` is changed to purple, both arrays reflect the\nchange.\n\n```js\n// Using slice, create newCar from myCar.\nconst myHonda = {\n  color: "red",\n  wheels: 4,\n  engine: { cylinders: 4, size: 2.2 },\n};\nconst myCar = [myHonda, 2, "cherry condition", "purchased 1997"];\nconst newCar = myCar.slice(0, 2);\n\nconsole.log("myCar =", myCar);\nconsole.log("newCar =", newCar);\nconsole.log("myCar[0].color =", myCar[0].color);\nconsole.log("newCar[0].color =", newCar[0].color);\n\n// Change the color of myHonda.\nmyHonda.color = "purple";\nconsole.log("The new color of my Honda is", myHonda.color);\n\nconsole.log("myCar[0].color =", myCar[0].color);\nconsole.log("newCar[0].color =", newCar[0].color);\n```\n\nThis script writes:\n\n```plain\nmyCar = [\n  { color: \'red\', wheels: 4, engine: { cylinders: 4, size: 2.2 } },\n  2,\n  \'cherry condition\',\n  \'purchased 1997\'\n]\nnewCar = [ { color: \'red\', wheels: 4, engine: { cylinders: 4, size: 2.2 } }, 2 ]\nmyCar[0].color = red\nnewCar[0].color = red\nThe new color of my Honda is purple\nmyCar[0].color = purple\nnewCar[0].color = purple\n```\n\n### Calling slice() on non-array objects\n\nThe `slice()` method reads the `length` property of `this`. It then reads the integer-keyed properties from `start` to `end` and defines them on a newly created array.\n\n```js\nconst arrayLike = {\n  length: 3,\n  0: 2,\n  1: 3,\n  2: 4,\n  3: 33, // ignored by slice() since length is 3\n};\nconsole.log(Array.prototype.slice.call(arrayLike, 1, 3));\n// [ 3, 4 ]\n```\n\n### Using slice() to convert array-like objects to arrays\n\nThe `slice()` method is often used with {{jsxref("Function/bind", "bind()")}} and {{jsxref("Function/call", "call()")}} to create a utility method that converts an array-like object into an array.\n\n```js\n// slice() is called with `this` passed as the first argument\nconst slice = Function.prototype.call.bind(Array.prototype.slice);\n\nfunction list() {\n  return slice(arguments);\n}\n\nconst list1 = list(1, 2, 3); // [1, 2, 3]\n```\n\n### Using slice() on sparse arrays\n\nThe array returned from `slice()` may be sparse if the source is sparse.\n\n```js\nconsole.log([1, 2, , 4, 5].slice(1, 4)); // [2, empty, 4]\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Array.prototype.slice` in `core-js`](https://github.com/zloirock/core-js#ecmascript-array)\n- [Indexed collections](/en-US/docs/Web/JavaScript/Guide/Indexed_collections) guide\n- {{jsxref("Array")}}\n- {{jsxref("Array.prototype.pop()")}}\n- {{jsxref("Array.prototype.shift()")}}\n- {{jsxref("Array.prototype.concat()")}}\n- {{jsxref("Array.prototype.splice()")}}\n- {{jsxref("TypedArray.prototype.slice()")}}\n- {{jsxref("String.prototype.slice()")}}\n'
        },
        "some": {
            "index.md": '---\ntitle: Array.prototype.some()\nslug: Web/JavaScript/Reference/Global_Objects/Array/some\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Array.some\n---\n\n{{JSRef}}\n\nThe **`some()`** method of {{jsxref("Array")}} instances tests whether\nat least one element in the array passes the test implemented by the provided\nfunction. It returns true if, in the array, it finds an element for which the provided function returns true; otherwise it returns false. It doesn\'t modify the array.\n\n{{EmbedInteractiveExample("pages/js/array-some.html")}}\n\n## Syntax\n\n```js-nolint\nsome(callbackFn)\nsome(callbackFn, thisArg)\n```\n\n### Parameters\n\n- `callbackFn`\n  - : A function to execute for each element in the array. It should return a [truthy](/en-US/docs/Glossary/Truthy) value to indicate the element passes the test, and a [falsy](/en-US/docs/Glossary/Falsy) value otherwise. The function is called with the following arguments:\n    - `element`\n      - : The current element being processed in the array.\n    - `index`\n      - : The index of the current element being processed in the array.\n    - `array`\n      - : The array `some()` was called upon.\n- `thisArg` {{optional_inline}}\n  - : A value to use as `this` when executing `callbackFn`. See [iterative methods](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array#iterative_methods).\n\n### Return value\n\n`false` unless `callbackFn` returns a {{Glossary("truthy")}} value for an array element, in which case `true` is immediately returned.\n\n## Description\n\nThe `some()` method is an [iterative method](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array#iterative_methods). It calls a provided `callbackFn` function once for each element in an array, until the `callbackFn` returns a [truthy](/en-US/docs/Glossary/Truthy) value. If such an element is found, `some()` immediately returns `true` and stops iterating through the array. Otherwise, if `callbackFn` returns a [falsy](/en-US/docs/Glossary/Falsy) value for all elements, `some()` returns `false`. Read the [iterative methods](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array#iterative_methods) section for more information about how these methods work in general.\n\n`some()` acts like the "there exists" quantifier in mathematics. In particular, for an empty array, it returns `false` for any condition.\n\n`callbackFn` is invoked only for array indexes which have assigned values. It is not invoked for empty slots in [sparse arrays](/en-US/docs/Web/JavaScript/Guide/Indexed_collections#sparse_arrays).\n\n`some()` does not mutate the array on which it is called, but the function provided as `callbackFn` can. Note, however, that the length of the array is saved _before_ the first invocation of `callbackFn`. Therefore:\n\n- `callbackFn` will not visit any elements added beyond the array\'s initial length when the call to `some()` began.\n- Changes to already-visited indexes do not cause `callbackFn` to be invoked on them again.\n- If an existing, yet-unvisited element of the array is changed by `callbackFn`, its value passed to the `callbackFn` will be the value at the time that element gets visited. [Deleted](/en-US/docs/Web/JavaScript/Reference/Operators/delete) elements are not visited.\n\n> **Warning:** Concurrent modifications of the kind described above frequently lead to hard-to-understand code and are generally to be avoided (except in special cases).\n\nThe `some()` method is [generic](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array#generic_array_methods). It only expects the `this` value to have a `length` property and integer-keyed properties.\n\n## Examples\n\n### Testing value of array elements\n\nThe following example tests whether any element in the array is bigger than 10.\n\n```js\nfunction isBiggerThan10(element, index, array) {\n  return element > 10;\n}\n\n[2, 5, 8, 1, 4].some(isBiggerThan10); // false\n[12, 5, 8, 1, 4].some(isBiggerThan10); // true\n```\n\n### Testing array elements using arrow functions\n\n[Arrow functions](/en-US/docs/Web/JavaScript/Reference/Functions/Arrow_functions)\nprovide a shorter syntax for the same test.\n\n```js\n[2, 5, 8, 1, 4].some((x) => x > 10); // false\n[12, 5, 8, 1, 4].some((x) => x > 10); // true\n```\n\n### Checking whether a value exists in an array\n\nTo mimic the function of the `includes()` method, this custom function returns `true` if the element exists in the array:\n\n```js\nconst fruits = ["apple", "banana", "mango", "guava"];\n\nfunction checkAvailability(arr, val) {\n  return arr.some((arrVal) => val === arrVal);\n}\n\ncheckAvailability(fruits, "kela"); // false\ncheckAvailability(fruits, "banana"); // true\n```\n\n### Converting any value to Boolean\n\n```js\nconst TRUTHY_VALUES = [true, "true", 1];\n\nfunction getBoolean(value) {\n  if (typeof value === "string") {\n    value = value.toLowerCase().trim();\n  }\n\n  return TRUTHY_VALUES.some((t) => t === value);\n}\n\ngetBoolean(false); // false\ngetBoolean("false"); // false\ngetBoolean(1); // true\ngetBoolean("true"); // true\n```\n\n### Using the third argument of callbackFn\n\nThe `array` argument is useful if you want to access another element in the array, especially when you don\'t have an existing variable that refers to the array. The following example first uses `filter()` to extract the positive values and then uses `some()` to check whether the array is strictly increasing.\n\n```js\nconst numbers = [3, -1, 1, 4, 1, 5];\nconst isIncreasing = !numbers\n  .filter((num) => num > 0)\n  .some((num, idx, arr) => {\n    // Without the arr argument, there\'s no way to easily access the\n    // intermediate array without saving it to a variable.\n    if (idx === 0) return false;\n    return num <= arr[idx - 1];\n  });\nconsole.log(isIncreasing); // false\n```\n\n### Using some() on sparse arrays\n\n`some()` will not run its predicate on empty slots.\n\n```js\nconsole.log([1, , 3].some((x) => x === undefined)); // false\nconsole.log([1, , 1].some((x) => x !== 1)); // false\nconsole.log([1, undefined, 1].some((x) => x !== 1)); // true\n```\n\n### Calling some() on non-array objects\n\nThe `some()` method reads the `length` property of `this` and then accesses each property whose key is a nonnegative integer less than `length` until they all have been accessed or `callbackFn` returns `true`.\n\n```js\nconst arrayLike = {\n  length: 3,\n  0: "a",\n  1: "b",\n  2: "c",\n  3: 3, // ignored by some() since length is 3\n};\nconsole.log(Array.prototype.some.call(arrayLike, (x) => typeof x === "number"));\n// false\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Array.prototype.some` in `core-js`](https://github.com/zloirock/core-js#ecmascript-array)\n- [Indexed collections](/en-US/docs/Web/JavaScript/Guide/Indexed_collections) guide\n- {{jsxref("Array")}}\n- {{jsxref("Array.prototype.every()")}}\n- {{jsxref("Array.prototype.forEach()")}}\n- {{jsxref("Array.prototype.find()")}}\n- {{jsxref("Array.prototype.includes()")}}\n- {{jsxref("TypedArray.prototype.some()")}}\n'
        },
        "sort": {
            "index.md": '---\ntitle: Array.prototype.sort()\nslug: Web/JavaScript/Reference/Global_Objects/Array/sort\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Array.sort\n---\n\n{{JSRef}}\n\nThe **`sort()`** method of {{jsxref("Array")}} instances sorts the elements of an array _[in place](https://en.wikipedia.org/wiki/In-place_algorithm)_ and returns the reference to the same array, now sorted. The default sort order is ascending, built upon converting the elements into strings, then comparing their sequences of UTF-16 code units values.\n\nThe time and space complexity of the sort cannot be guaranteed as it depends on the\nimplementation.\n\nTo sort the elements in an array without mutating the original array, use {{jsxref("Array/toSorted", "toSorted()")}}.\n\n{{EmbedInteractiveExample("pages/js/array-sort.html")}}\n\n## Syntax\n\n```js-nolint\nsort()\nsort(compareFn)\n```\n\n### Parameters\n\n- `compareFn` {{optional_inline}}\n\n  - : A function that defines the sort order. The return value should be a number whose sign indicates the relative order of the two elements: negative if `a` is less than `b`, positive if `a` is greater than `b`, and zero if they are equal. `NaN` is treated as `0`. The function is called with the following arguments:\n\n    - `a`\n      - : The first element for comparison. Will never be `undefined`.\n    - `b`\n      - : The second element for comparison. Will never be `undefined`.\n\n    If omitted, the array elements are converted to strings, then sorted according to each character\'s Unicode code point value.\n\n### Return value\n\nThe reference to the original array, now sorted. Note that the array is sorted _[in place](https://en.wikipedia.org/wiki/In-place_algorithm)_, and no copy is made.\n\n## Description\n\nIf `compareFn` is not supplied, all non-`undefined` array\nelements are sorted by converting them to strings and comparing strings in UTF-16 code\nunits order. For example, "banana" comes before "cherry". In a numeric sort, 9 comes\nbefore 80, but because numbers are converted to strings, "80" comes before "9" in the\nUnicode order. All `undefined` elements are sorted to the end of the array.\n\nThe `sort()` method preserves empty slots. If the source array is [sparse](/en-US/docs/Web/JavaScript/Guide/Indexed_collections#sparse_arrays), the empty slots are moved to the end of the array, and always come after all the `undefined`.\n\n> **Note:** In UTF-16, Unicode characters above `\\uFFFF` are\n> encoded as two surrogate code units, of the range\n> `\uD800` - `\uDFFF`. The value of each code unit is taken\n> separately into account for the comparison. Thus the character formed by the surrogate\n> pair `\uD855\uDE51` will be sorted before the character\n> `\\uFF3A`.\n\nIf `compareFn` is supplied, all non-`undefined` array\nelements are sorted according to the return value of the compare function (all\n`undefined` elements are sorted to the end of the array, with no call to\n`compareFn`).\n\n| `compareFn(a, b)` return value | sort order                         |\n| ------------------------------ | ---------------------------------- |\n| > 0                            | sort `a` after `b`, e.g. `[b, a]`  |\n| < 0                            | sort `a` before `b`, e.g. `[a, b]` |\n| === 0                          | keep original order of `a` and `b` |\n\nSo, the compare function has the following form:\n\n```js-nolint\nfunction compareFn(a, b) {\n  if (a is less than b by some ordering criterion) {\n    return -1;\n  } else if (a is greater than b by the ordering criterion) {\n    return 1;\n  }\n  // a must be equal to b\n  return 0;\n}\n```\n\nMore formally, the comparator is expected to have the following properties, in order to ensure proper sort behavior:\n\n- _Pure_: The comparator does not mutate the objects being compared or any external state. (This is important because there\'s no guarantee _when_ and _how_ the comparator will be called, so any particular call should not produce visible effects to the outside.)\n- _Stable_: The comparator returns the same result with the same pair of input.\n- _Reflexive_: `compareFn(a, a) === 0`.\n- _Anti-symmetric_: `compareFn(a, b)` and `compareFn(b, a)` must both be `0` or have opposite signs.\n- _Transitive_: If `compareFn(a, b)` and `compareFn(b, c)` are both positive, zero, or negative, then `compareFn(a, c)` has the same positivity as the previous two.\n\nA comparator conforming to the constraints above will always be able to return all of `1`, `0`, and `-1`, or consistently return `0`. For example, if a comparator only returns `1` and `0`, or only returns `0` and `-1`, it will not be able to sort reliably because _anti-symmetry_ is broken. A comparator that always returns `0` will cause the array to not be changed at all, but is reliable nonetheless.\n\nThe default lexicographic comparator satisfies all constraints above.\n\nTo compare numbers instead of strings, the compare function can subtract `b`\nfrom `a`. The following function will sort the array in ascending order (if\nit doesn\'t contain `NaN`):\n\n```js\nfunction compareNumbers(a, b) {\n  return a - b;\n}\n```\n\nThe `sort()` method is [generic](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array#generic_array_methods). It only expects the `this` value to have a `length` property and integer-keyed properties. Although strings are also array-like, this method is not suitable to be applied on them, as strings are immutable.\n\n## Examples\n\n### Creating, displaying, and sorting an array\n\nThe following example creates four arrays and displays the original array, then the\nsorted arrays. The numeric arrays are sorted without a compare function, then sorted\nusing one.\n\n```js\nconst stringArray = ["Blue", "Humpback", "Beluga"];\nconst numberArray = [40, 1, 5, 200];\nconst numericStringArray = ["80", "9", "700"];\nconst mixedNumericArray = ["80", "9", "700", 40, 1, 5, 200];\n\nfunction compareNumbers(a, b) {\n  return a - b;\n}\n\nstringArray.join(); // \'Blue,Humpback,Beluga\'\nstringArray.sort(); // [\'Beluga\', \'Blue\', \'Humpback\']\n\nnumberArray.join(); // \'40,1,5,200\'\nnumberArray.sort(); // [1, 200, 40, 5]\nnumberArray.sort(compareNumbers); // [1, 5, 40, 200]\n\nnumericStringArray.join(); // \'80,9,700\'\nnumericStringArray.sort(); // [\'700\', \'80\', \'9\']\nnumericStringArray.sort(compareNumbers); // [\'9\', \'80\', \'700\']\n\nmixedNumericArray.join(); // \'80,9,700,40,1,5,200\'\nmixedNumericArray.sort(); // [1, 200, 40, 5, \'700\', \'80\', \'9\']\nmixedNumericArray.sort(compareNumbers); // [1, 5, \'9\', 40, \'80\', 200, \'700\']\n```\n\n### Sorting array of objects\n\nArrays of objects can be sorted by comparing the value of one of their properties.\n\n```js\nconst items = [\n  { name: "Edward", value: 21 },\n  { name: "Sharpe", value: 37 },\n  { name: "And", value: 45 },\n  { name: "The", value: -12 },\n  { name: "Magnetic", value: 13 },\n  { name: "Zeros", value: 37 },\n];\n\n// sort by value\nitems.sort((a, b) => a.value - b.value);\n\n// sort by name\nitems.sort((a, b) => {\n  const nameA = a.name.toUpperCase(); // ignore upper and lowercase\n  const nameB = b.name.toUpperCase(); // ignore upper and lowercase\n  if (nameA < nameB) {\n    return -1;\n  }\n  if (nameA > nameB) {\n    return 1;\n  }\n\n  // names must be equal\n  return 0;\n});\n```\n\n### Sorting non-ASCII characters\n\nFor sorting strings with non-{{Glossary("ASCII")}} characters, i.e. strings with accented characters\n(e, \xe9, \xe8, a, \xe4, etc.), strings from languages other than English, use\n{{jsxref("String.prototype.localeCompare()")}}. This function can compare those characters so they\nappear in the right order.\n\n```js\nconst items = ["r\xe9serv\xe9", "premier", "communiqu\xe9", "caf\xe9", "adieu", "\xe9clair"];\nitems.sort((a, b) => a.localeCompare(b));\n\n// items is [\'adieu\', \'caf\xe9\', \'communiqu\xe9\', \'\xe9clair\', \'premier\', \'r\xe9serv\xe9\']\n```\n\n### Sorting with map\n\nThe `compareFn` can be invoked multiple times per element within the\narray. Depending on the `compareFn`\'s nature, this may yield a high\noverhead. The more work a `compareFn` does and the more elements there\nare to sort, it may be more efficient to use [`map()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/map) for\nsorting. The idea is to traverse the array once to extract the actual values used for\nsorting into a temporary array, sort the temporary array, and then traverse the\ntemporary array to achieve the right order.\n\n```js\n// the array to be sorted\nconst data = ["delta", "alpha", "charlie", "bravo"];\n\n// temporary array holds objects with position and sort-value\nconst mapped = data.map((v, i) => {\n  return { i, value: someSlowOperation(v) };\n});\n\n// sorting the mapped array containing the reduced values\nmapped.sort((a, b) => {\n  if (a.value > b.value) {\n    return 1;\n  }\n  if (a.value < b.value) {\n    return -1;\n  }\n  return 0;\n});\n\nconst result = mapped.map((v) => data[v.i]);\n```\n\nThere is an open source library available called [mapsort](https://github.com/Pimm/mapsort) which applies this approach.\n\n### sort() returns the reference to the same array\n\nThe `sort()` method returns a reference to the original array, so mutating the returned array will mutate the original array as well.\n\n```js\nconst numbers = [3, 1, 4, 1, 5];\nconst sorted = numbers.sort((a, b) => a - b);\n// numbers and sorted are both [1, 1, 3, 4, 5]\nsorted[0] = 10;\nconsole.log(numbers[0]); // 10\n```\n\nIn case you want `sort()` to not mutate the original array, but return a [shallow-copied](/en-US/docs/Glossary/Shallow_copy) array like other array methods (e.g. [`map()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/map)) do, use the {{jsxref("Array/toSorted", "toSorted()")}} method. Alternatively, you can do a shallow copy before calling `sort()`, using the [spread syntax](/en-US/docs/Web/JavaScript/Reference/Operators/Spread_syntax) or [`Array.from()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/from).\n\n```js\nconst numbers = [3, 1, 4, 1, 5];\n// [...numbers] creates a shallow copy, so sort() does not mutate the original\nconst sorted = [...numbers].sort((a, b) => a - b);\nsorted[0] = 10;\nconsole.log(numbers[0]); // 3\n```\n\n### Sort stability\n\nSince version 10 (or ECMAScript 2019), the specification dictates that `Array.prototype.sort` is stable.\n\nFor example, say you had a list of students alongside their grades. Note that the list of students is already pre-sorted by name in alphabetical order:\n\n```js\nconst students = [\n  { name: "Alex", grade: 15 },\n  { name: "Devlin", grade: 15 },\n  { name: "Eagle", grade: 13 },\n  { name: "Sam", grade: 14 },\n];\n```\n\nAfter sorting this array by `grade` in ascending order:\n\n```js\nstudents.sort((firstItem, secondItem) => firstItem.grade - secondItem.grade);\n```\n\nThe `students` variable will then have the following value:\n\n```js\n[\n  { name: "Eagle", grade: 13 },\n  { name: "Sam", grade: 14 },\n  { name: "Alex", grade: 15 }, // original maintained for similar grade (stable sorting)\n  { name: "Devlin", grade: 15 }, // original maintained for similar grade (stable sorting)\n];\n```\n\nIt\'s important to note that students that have the same grade (for example, Alex and Devlin), will remain in the same order as before calling the sort. This is what a stable sorting algorithm guarantees.\n\nBefore version 10 (or ECMAScript 2019), sort stability was not guaranteed, meaning that you could end up with the following:\n\n```js\n[\n  { name: "Eagle", grade: 13 },\n  { name: "Sam", grade: 14 },\n  { name: "Devlin", grade: 15 }, // original order not maintained\n  { name: "Alex", grade: 15 }, // original order not maintained\n];\n```\n\n### Sorting with non-well-formed comparator\n\nIf a comparing function does not satisfy all of purity, stability, reflexivity, anti-symmetry, and transitivity rules, as explained in the [description](#description), the program\'s behavior is not well-defined.\n\nFor example, consider this code:\n\n```js\nconst arr = [3, 1, 4, 1, 5, 9];\nconst compareFn = (a, b) => (a > b ? 1 : 0);\narr.sort(compareFn);\n```\n\nThe `compareFn` function here is not well-formed, because it does not satisfy anti-symmetry: if `a > b`, it returns `1`; but by swapping `a` and `b`, it returns `0` instead of a negative value. Therefore, the resulting array will be different across engines. For example, V8 (used by Chrome, Node.js, etc.) and JavaScriptCore (used by Safari) would not sort the array at all and return `[3, 1, 4, 1, 5, 9]`, while SpiderMonkey (used by Firefox) will return the array sorted ascendingly, as `[1, 1, 3, 4, 5, 9]`.\n\nHowever, if the `compareFn` function is changed slightly so that it returns `-1` or `0`:\n\n```js\nconst arr = [3, 1, 4, 1, 5, 9];\nconst compareFn = (a, b) => (a > b ? -1 : 0);\narr.sort(compareFn);\n```\n\nThen V8 and JavaScriptCore sorts it descendingly, as `[9, 5, 4, 3, 1, 1]`, while SpiderMonkey returns it as-is: `[3, 1, 4, 1, 5, 9]`.\n\nDue to this implementation inconsistency, you are always advised to make your comparator well-formed by following the five constraints.\n\n### Using sort() on sparse arrays\n\nEmpty slots are moved to the end of the array.\n\n```js\nconsole.log(["a", "c", , "b"].sort()); // [\'a\', \'b\', \'c\', empty]\nconsole.log([, undefined, "a", "b"].sort()); // ["a", "b", undefined, empty]\n```\n\n### Calling sort() on non-array objects\n\nThe `sort()` method reads the `length` property of `this`. It then collects all existing integer-keyed properties in the range of `0` to `length - 1`, sorts them, and writes them back. If there are missing properties in the range, the corresponding trailing properties are [deleted](/en-US/docs/Web/JavaScript/Reference/Operators/delete), as if the non-existent properties are sorted towards the end.\n\n```js\nconst arrayLike = {\n  length: 3,\n  unrelated: "foo",\n  0: 5,\n  2: 4,\n};\nconsole.log(Array.prototype.sort.call(arrayLike));\n// { \'0\': 4, \'1\': 5, length: 3, unrelated: \'foo\' }\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Array.prototype.sort` with modern behavior like stable sort in `core-js`](https://github.com/zloirock/core-js#ecmascript-array)\n- [Indexed collections](/en-US/docs/Web/JavaScript/Guide/Indexed_collections) guide\n- {{jsxref("Array")}}\n- {{jsxref("Array.prototype.reverse()")}}\n- {{jsxref("Array.prototype.toSorted()")}}\n- {{jsxref("String.prototype.localeCompare()")}}\n- {{jsxref("TypedArray.prototype.sort()")}}\n- [Getting things sorted in V8](https://v8.dev/blog/array-sort) on v8.dev (2018)\n- [Stable `Array.prototype.sort`](https://v8.dev/features/stable-sort) on v8.dev (2019)\n- [`Array.prototype.sort` stability](https://mathiasbynens.be/demo/sort-stability) by Mathias Bynens\n'
        },
        "splice": {
            "index.md": '---\ntitle: Array.prototype.splice()\nslug: Web/JavaScript/Reference/Global_Objects/Array/splice\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Array.splice\n---\n\n{{JSRef}}\n\nThe **`splice()`** method of {{jsxref("Array")}} instances changes the contents of an array by\nremoving or replacing existing elements and/or adding new elements [in place](https://en.wikipedia.org/wiki/In-place_algorithm).\n\nTo create a new array with a segment removed and/or replaced without mutating the original array, use {{jsxref("Array/toSpliced", "toSpliced()")}}. To access part of an array without modifying it, see {{jsxref("Array/slice", "slice()")}}.\n\n{{EmbedInteractiveExample("pages/js/array-splice.html")}}\n\n## Syntax\n\n```js-nolint\nsplice(start)\nsplice(start, deleteCount)\nsplice(start, deleteCount, item1)\nsplice(start, deleteCount, item1, item2)\nsplice(start, deleteCount, item1, item2, /* \u2026, */ itemN)\n```\n\n### Parameters\n\n- `start`\n\n  - : Zero-based index at which to start changing the array, [converted to an integer](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number#integer_conversion).\n    - Negative index counts back from the end of the array \u2014 if `-array.length <= start < 0`, `start + array.length` is used.\n    - If `start < -array.length`, `0` is used.\n    - If `start >= array.length`, no element will be deleted, but the method will behave as an adding function, adding as many elements as provided.\n    - If `start` is omitted (and `splice()` is called with no arguments), nothing is deleted. This is different from passing `undefined`, which is converted to `0`.\n\n- `deleteCount` {{optional_inline}}\n\n  - : An integer indicating the number of elements in the array to remove from `start`.\n\n    If `deleteCount` is omitted, or if its value is greater than or equal to the number of elements after the position specified by `start`, then all the elements from `start` to the end of the array will be deleted. However, if you wish to pass any `itemN` parameter, you should pass `Infinity` as `deleteCount` to delete all elements after `start`, because an explicit `undefined` gets [converted](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number#integer_conversion) to `0`.\n\n    If `deleteCount` is `0` or negative, no elements are removed.\n    In this case, you should specify at least one new element (see below).\n\n- `item1`, \u2026, `itemN` {{optional_inline}}\n\n  - : The elements to add to the array, beginning from `start`.\n\n    If you do not specify any elements, `splice()` will only remove elements from the array.\n\n### Return value\n\nAn array containing the deleted elements.\n\nIf only one element is removed, an array of one element is returned.\n\nIf no elements are removed, an empty array is returned.\n\n## Description\n\nThe `splice()` method is a [mutating method](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array#copying_methods_and_mutating_methods). It may change the content of `this`. If the specified number of elements to insert differs from the number of elements being removed, the array\'s `length` will be changed as well. At the same time, it uses [`@@species`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/@@species) to create a new array instance to be returned.\n\nIf the deleted portion is [sparse](/en-US/docs/Web/JavaScript/Guide/Indexed_collections#sparse_arrays), the array returned by `splice()` is sparse as well, with those corresponding indices being empty slots.\n\nThe `splice()` method is [generic](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array#generic_array_methods). It only expects the `this` value to have a `length` property and integer-keyed properties. Although strings are also array-like, this method is not suitable to be applied on them, as strings are immutable.\n\n## Examples\n\n### Remove 0 (zero) elements before index 2, and insert "drum"\n\n```js\nconst myFish = ["angel", "clown", "mandarin", "sturgeon"];\nconst removed = myFish.splice(2, 0, "drum");\n\n// myFish is ["angel", "clown", "drum", "mandarin", "sturgeon"]\n// removed is [], no elements removed\n```\n\n### Remove 0 (zero) elements before index 2, and insert "drum" and "guitar"\n\n```js\nconst myFish = ["angel", "clown", "mandarin", "sturgeon"];\nconst removed = myFish.splice(2, 0, "drum", "guitar");\n\n// myFish is ["angel", "clown", "drum", "guitar", "mandarin", "sturgeon"]\n// removed is [], no elements removed\n```\n\n### Remove 0 (zero) elements at index 0, and insert "angel"\n\n`splice(0, 0, ...elements)` inserts elements at the start of the array like {{jsxref("Array/unshift", "unshift()")}}.\n\n```js\nconst myFish = ["clown", "mandarin", "sturgeon"];\nconst removed = myFish.splice(0, 0, "angel");\n\n// myFish is ["angel", "clown", "mandarin", "sturgeon"]\n// no items removed\n```\n\n### Remove 0 (zero) elements at last index, and insert "sturgeon"\n\n`splice(array.length, 0, ...elements)` inserts elements at the end of the array like {{jsxref("Array/push", "push()")}}.\n\n```js\nconst myFish = ["angel", "clown", "mandarin"];\nconst removed = myFish.splice(myFish.length, 0, "sturgeon");\n\n// myFish is ["angel", "clown", "mandarin", "sturgeon"]\n// no items removed\n```\n\n### Remove 1 element at index 3\n\n```js\nconst myFish = ["angel", "clown", "drum", "mandarin", "sturgeon"];\nconst removed = myFish.splice(3, 1);\n\n// myFish is ["angel", "clown", "drum", "sturgeon"]\n// removed is ["mandarin"]\n```\n\n### Remove 1 element at index 2, and insert "trumpet"\n\n```js\nconst myFish = ["angel", "clown", "drum", "sturgeon"];\nconst removed = myFish.splice(2, 1, "trumpet");\n\n// myFish is ["angel", "clown", "trumpet", "sturgeon"]\n// removed is ["drum"]\n```\n\n### Remove 2 elements from index 0, and insert "parrot", "anemone" and "blue"\n\n```js\nconst myFish = ["angel", "clown", "trumpet", "sturgeon"];\nconst removed = myFish.splice(0, 2, "parrot", "anemone", "blue");\n\n// myFish is ["parrot", "anemone", "blue", "trumpet", "sturgeon"]\n// removed is ["angel", "clown"]\n```\n\n### Remove 2 elements, starting from index 2\n\n```js\nconst myFish = ["parrot", "anemone", "blue", "trumpet", "sturgeon"];\nconst removed = myFish.splice(2, 2);\n\n// myFish is ["parrot", "anemone", "sturgeon"]\n// removed is ["blue", "trumpet"]\n```\n\n### Remove 1 element from index -2\n\n```js\nconst myFish = ["angel", "clown", "mandarin", "sturgeon"];\nconst removed = myFish.splice(-2, 1);\n\n// myFish is ["angel", "clown", "sturgeon"]\n// removed is ["mandarin"]\n```\n\n### Remove all elements, starting from index 2\n\n```js\nconst myFish = ["angel", "clown", "mandarin", "sturgeon"];\nconst removed = myFish.splice(2);\n\n// myFish is ["angel", "clown"]\n// removed is ["mandarin", "sturgeon"]\n```\n\n### Using splice() on sparse arrays\n\nThe `splice()` method preserves the array\'s sparseness.\n\n```js\nconst arr = [1, , 3, 4, , 6];\nconsole.log(arr.splice(1, 2)); // [empty, 3]\nconsole.log(arr); // [1, 4, empty, 6]\n```\n\n### Calling splice() on non-array objects\n\nThe `splice()` method reads the `length` property of `this`. It then updates the integer-keyed properties and the `length` property as needed.\n\n```js\nconst arrayLike = {\n  length: 3,\n  unrelated: "foo",\n  0: 5,\n  2: 4,\n};\nconsole.log(Array.prototype.splice.call(arrayLike, 0, 1, 2, 3));\n// [ 5 ]\nconsole.log(arrayLike);\n// { \'0\': 2, \'1\': 3, \'3\': 4, length: 4, unrelated: \'foo\' }\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Indexed collections](/en-US/docs/Web/JavaScript/Guide/Indexed_collections) guide\n- {{jsxref("Array")}}\n- {{jsxref("Array.prototype.concat()")}}\n- {{jsxref("Array.prototype.push()")}}\n- {{jsxref("Array.prototype.pop()")}}\n- {{jsxref("Array.prototype.shift()")}}\n- {{jsxref("Array.prototype.slice()")}}\n- {{jsxref("Array.prototype.toSpliced()")}}\n- {{jsxref("Array.prototype.unshift()")}}\n'
        },
        "tolocalestring": {
            "index.md": '---\ntitle: Array.prototype.toLocaleString()\nslug: Web/JavaScript/Reference/Global_Objects/Array/toLocaleString\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Array.toLocaleString\n---\n\n{{JSRef}}\n\nThe **`toLocaleString()`** method of {{jsxref("Array")}} instances returns a string representing\nthe elements of the array. The elements are converted to strings using their\n`toLocaleString` methods and these strings are separated by a locale-specific\nstring (such as a comma ",").\n\n{{EmbedInteractiveExample("pages/js/array-tolocalestring.html", "shorter")}}\n\n## Syntax\n\n```js-nolint\ntoLocaleString()\ntoLocaleString(locales)\ntoLocaleString(locales, options)\n```\n\n### Parameters\n\n- `locales` {{optional_inline}}\n  - : A string with a BCP 47 language tag, or an array of such strings. For the general form and interpretation of the `locales` argument, see [the parameter description on the `Intl` main page](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl#locales_argument).\n- `options` {{optional_inline}}\n  - : An object with configuration properties. For numbers, see {{jsxref("Number.prototype.toLocaleString()")}}; for dates, see {{jsxref("Date.prototype.toLocaleString()")}}.\n\n### Return value\n\nA string representing the elements of the array.\n\n## Description\n\nThe `Array.prototype.toLocaleString` method traverses its content, calling the `toLocaleString` method of every element with the `locales` and `options` parameters provided, and concatenates them with an implementation-defined separator (such as a comma ","). Note that the method itself does not consume the two parameters \u2014 it only passes them to the `toLocaleString()` of each element. The choice of the separator string depends on the host\'s current locale, not the `locales` parameter.\n\nIf an element is `undefined`, `null`, it is converted to an empty string instead of the string `"null"` or `"undefined"`.\n\nWhen used on [sparse arrays](/en-US/docs/Web/JavaScript/Guide/Indexed_collections#sparse_arrays), the `toLocaleString()` method iterates empty slots as if they have the value `undefined`.\n\nThe `toLocaleString()` method is [generic](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array#generic_array_methods). It only expects the `this` value to have a `length` property and integer-keyed properties.\n\n## Examples\n\n### Using locales and options\n\nThe elements of the array are converted to strings using their\n`toLocaleString` methods.\n\n- `Object`: {{jsxref("Object.prototype.toLocaleString()")}}\n- `Number`: {{jsxref("Number.prototype.toLocaleString()")}}\n- `Date`: {{jsxref("Date.prototype.toLocaleString()")}}\n\nAlways display the currency for the strings and numbers in the `prices`\narray:\n\n```js\nconst prices = ["\uFFE57", 500, 8123, 12];\nprices.toLocaleString("ja-JP", { style: "currency", currency: "JPY" });\n\n// "\uFFE57,\uFFE5500,\uFFE58,123,\uFFE512"\n```\n\nFor more examples, see also the [`Intl.NumberFormat`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat) and [`Intl.DateTimeFormat`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat) pages.\n\n### Using toLocaleString() on sparse arrays\n\n`toLocaleString()` treats empty slots the same as `undefined` and produces an extra separator:\n\n```js\nconsole.log([1, , 3].toLocaleString()); // \'1,,3\'\n```\n\n### Calling toLocaleString() on non-array objects\n\nThe `toLocaleString()` method reads the `length` property of `this` and then accesses each property whose key is a nonnegative integer less than `length`.\n\n```js\nconst arrayLike = {\n  length: 3,\n  0: 1,\n  1: 2,\n  2: 3,\n  3: 4, // ignored by toLocaleString() since length is 3\n};\nconsole.log(Array.prototype.toLocaleString.call(arrayLike));\n// 1,2,3\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Indexed collections](/en-US/docs/Web/JavaScript/Guide/Indexed_collections) guide\n- {{jsxref("Array")}}\n- {{jsxref("Array.prototype.toString()")}}\n- {{jsxref("TypedArray.prototype.toLocaleString()")}}\n- {{jsxref("Intl")}}\n- {{jsxref("Intl.ListFormat")}}\n- {{jsxref("Object.prototype.toLocaleString()")}}\n- {{jsxref("Number.prototype.toLocaleString()")}}\n- {{jsxref("Date.prototype.toLocaleString()")}}\n'
        },
        "toreversed": {
            "index.md": '---\ntitle: Array.prototype.toReversed()\nslug: Web/JavaScript/Reference/Global_Objects/Array/toReversed\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Array.toReversed\n---\n\n{{JSRef}}\n\nThe **`toReversed()`** method of {{jsxref("Array")}} instances is the [copying](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array#copying_methods_and_mutating_methods) counterpart of the {{jsxref("Array/reverse", "reverse()")}} method. It returns a new array with the elements in reversed order.\n\n## Syntax\n\n```js-nolint\ntoReversed()\n```\n\n### Parameters\n\nNone.\n\n### Return value\n\nA new array containing the elements in reversed order.\n\n## Description\n\nThe `toReversed()` method transposes the elements of the calling array object in reverse order and returns a new array.\n\nWhen used on [sparse arrays](/en-US/docs/Web/JavaScript/Guide/Indexed_collections#sparse_arrays), the `toReversed()` method iterates empty slots as if they have the value `undefined`.\n\nThe `toReversed()` method is [generic](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array#generic_array_methods). It only expects the `this` value to have a `length` property and integer-keyed properties.\n\n## Examples\n\n### Reversing the elements in an array\n\nThe following example creates an array `items`, containing three elements, then creates a new array that\'s the reverse of `items`. The `items` array remains unchanged.\n\n```js\nconst items = [1, 2, 3];\nconsole.log(items); // [1, 2, 3]\n\nconst reversedItems = items.toReversed();\nconsole.log(reversedItems); // [3, 2, 1]\nconsole.log(items); // [1, 2, 3]\n```\n\n### Using toReversed() on sparse arrays\n\nThe return value of `toReversed()` is never sparse. Empty slots become `undefined` in the returned array.\n\n```js\nconsole.log([1, , 3].toReversed()); // [3, undefined, 1]\nconsole.log([1, , 3, 4].toReversed()); // [4, 3, undefined, 1]\n```\n\n### Calling toReversed() on non-array objects\n\nThe `toReversed()` method reads the `length` property of `this`. It then visits each property having an integer key between `length - 1` and `0` in descending order, adding the value of the current property to the end of the array to be returned.\n\n```js\nconst arrayLike = {\n  length: 3,\n  unrelated: "foo",\n  2: 4,\n};\nconsole.log(Array.prototype.toReversed.call(arrayLike));\n// [4, undefined, undefined]\n// The \'0\' and \'1\' indices are not present so they become undefined\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Array.prototype.toReversed` in `core-js`](https://github.com/zloirock/core-js#change-array-by-copy)\n- [Indexed collections](/en-US/docs/Web/JavaScript/Guide/Indexed_collections) guide\n- {{jsxref("Array.prototype.reverse()")}}\n- {{jsxref("Array.prototype.toSorted()")}}\n- {{jsxref("Array.prototype.toSpliced()")}}\n- {{jsxref("Array.prototype.with()")}}\n- {{jsxref("TypedArray.prototype.toReversed()")}}\n'
        },
        "tosorted": {
            "index.md": '---\ntitle: Array.prototype.toSorted()\nslug: Web/JavaScript/Reference/Global_Objects/Array/toSorted\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Array.toSorted\n---\n\n{{JSRef}}\n\nThe **`toSorted()`** method of {{jsxref("Array")}} instances is the [copying](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array#copying_methods_and_mutating_methods) version of the {{jsxref("Array/sort", "sort()")}} method. It returns a new array with the elements sorted in ascending order.\n\n## Syntax\n\n```js-nolint\ntoSorted()\ntoSorted(compareFn)\n```\n\n### Parameters\n\n- `compareFn` {{optional_inline}}\n\n  - : Specifies a function that defines the sort order. If omitted, the array elements are converted to strings, then sorted according to each character\'s Unicode code point value.\n\n    - `a`\n      - : The first element for comparison.\n    - `b`\n      - : The second element for comparison.\n\n### Return value\n\nA new array with the elements sorted in ascending order.\n\n## Description\n\nSee {{jsxref("Array/sort", "sort()")}} for more information on the `compareFn` parameter.\n\nWhen used on [sparse arrays](/en-US/docs/Web/JavaScript/Guide/Indexed_collections#sparse_arrays), the `toSorted()` method iterates empty slots as if they have the value `undefined`.\n\nThe `toSorted()` method is [generic](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array#generic_array_methods). It only expects the `this` value to have a `length` property and integer-keyed properties.\n\n## Examples\n\n### Sorting an array\n\n```js\nconst months = ["Mar", "Jan", "Feb", "Dec"];\nconst sortedMonths = months.toSorted();\nconsole.log(sortedMonths); // [\'Dec\', \'Feb\', \'Jan\', \'Mar\']\nconsole.log(months); // [\'Mar\', \'Jan\', \'Feb\', \'Dec\']\n\nconst values = [1, 10, 21, 2];\nconst sortedValues = values.toSorted((a, b) => a - b);\nconsole.log(sortedValues); // [1, 2, 10, 21]\nconsole.log(values); // [1, 10, 21, 2]\n```\n\nFor more usage examples, see {{jsxref("Array/sort", "sort()")}}.\n\n### Using toSorted() on sparse arrays\n\nEmpty slots are sorted as if they have the value `undefined`. They are always sorted to the end of the array and `compareFn` is not called for them.\n\n```js\nconsole.log(["a", "c", , "b"].toSorted()); // [\'a\', \'b\', \'c\', undefined]\nconsole.log([, undefined, "a", "b"].toSorted()); // ["a", "b", undefined, undefined]\n```\n\n### Calling toSorted() on non-array objects\n\nThe `toSorted()` method reads the `length` property of `this`. It then collects all existing integer-keyed properties in the range of `0` to `length - 1`, sorts them, and writes them into a new array.\n\n```js\nconst arrayLike = {\n  length: 3,\n  unrelated: "foo",\n  0: 5,\n  2: 4,\n  3: 3, // ignored by toSorted() since length is 3\n};\nconsole.log(Array.prototype.toSorted.call(arrayLike));\n// [4, 5, undefined]\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Array.prototype.toSorted` in `core-js`](https://github.com/zloirock/core-js#change-array-by-copy)\n- [Indexed collections](/en-US/docs/Web/JavaScript/Guide/Indexed_collections) guide\n- {{jsxref("Array.prototype.sort()")}}\n- {{jsxref("Array.prototype.toReversed()")}}\n- {{jsxref("Array.prototype.toSpliced()")}}\n- {{jsxref("Array.prototype.with()")}}\n- {{jsxref("TypedArray.prototype.toSorted()")}}\n'
        },
        "tospliced": {
            "index.md": '---\ntitle: Array.prototype.toSpliced()\nslug: Web/JavaScript/Reference/Global_Objects/Array/toSpliced\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Array.toSpliced\n---\n\n{{JSRef}}\n\nThe **`toSpliced()`** method of {{jsxref("Array")}} instances is the [copying](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array#copying_methods_and_mutating_methods) version of the {{jsxref("Array/splice", "splice()")}} method. It returns a new array with some elements removed and/or replaced at a given index.\n\n## Syntax\n\n```js-nolint\ntoSpliced(start)\ntoSpliced(start, deleteCount)\ntoSpliced(start, deleteCount, item1)\ntoSpliced(start, deleteCount, item1, item2)\ntoSpliced(start, deleteCount, item1, item2, /* \u2026, */ itemN)\n```\n\n### Parameters\n\n- `start`\n\n  - : Zero-based index at which to start changing the array, [converted to an integer](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number#integer_conversion).\n    - Negative index counts back from the end of the array \u2014 if `-array.length <= start < 0`, `start + array.length` is used.\n    - If `start < -array.length` or `start` is omitted, `0` is used.\n    - If `start >= array.length`, no element will be deleted, but the method will behave as an adding function, adding as many elements as provided.\n\n- `deleteCount` {{optional_inline}}\n\n  - : An integer indicating the number of elements in the array to remove from `start`.\n\n    If `deleteCount` is omitted, or if its value is greater than or equal to the number of elements after the position specified by `start`, then all the elements from `start` to the end of the array will be deleted. However, if you wish to pass any `itemN` parameter, you should pass `Infinity` as `deleteCount` to delete all elements after `start`, because an explicit `undefined` gets [converted](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number#integer_conversion) to `0`.\n\n    If `deleteCount` is `0` or negative, no elements are removed.\n    In this case, you should specify at least one new element (see below).\n\n- `item1`, \u2026, `itemN` {{optional_inline}}\n\n  - : The elements to add to the array, beginning from `start`.\n\n    If you do not specify any elements, `toSpliced()` will only remove elements from the array.\n\n### Return value\n\nA new array that consists of all elements before `start`, `item1`, `item2`, \u2026, `itemN`, and all elements after `start + deleteCount`.\n\n## Description\n\nThe `toSpliced()` method, like `splice()`, does multiple things at once: it removes the given number of elements from the array, starting at a given index, and then inserts the given elements at the same index. However, it returns a new array instead of modifying the original array. The deleted elements therefore are not returned from this method.\n\nThe `toSpliced()` method never produces a [sparse array](/en-US/docs/Web/JavaScript/Guide/Indexed_collections#sparse_arrays). If the source array is sparse, the empty slots will be replaced with `undefined` in the new array.\n\nThe `toSpliced()` method is [generic](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array#generic_array_methods). It only expects the `this` value to have a `length` property and integer-keyed properties.\n\n## Examples\n\n### Deleting, adding, and replacing elements\n\nYou can use `toSpliced()` to delete, add, and replace elements in an array and create a new array more efficiently than using `slice()` and `concat()`.\n\n```js\nconst months = ["Jan", "Mar", "Apr", "May"];\n\n// Inserting an element at index 1\nconst months2 = months.toSpliced(1, 0, "Feb");\nconsole.log(months2); // ["Jan", "Feb", "Mar", "Apr", "May"]\n\n// Deleting two elements starting from index 2\nconst months3 = months2.toSpliced(2, 2);\nconsole.log(months3); // ["Jan", "Feb", "May"]\n\n// Replacing one element at index 1 with two new elements\nconst months4 = months3.toSpliced(1, 1, "Feb", "Mar");\nconsole.log(months4); // ["Jan", "Feb", "Mar", "May"]\n\n// Original array is not modified\nconsole.log(months); // ["Jan", "Mar", "Apr", "May"]\n```\n\n### Using toSpliced() on sparse arrays\n\nThe `toSpliced()` method always creates a dense array.\n\n```js\nconst arr = [1, , 3, 4, , 6];\nconsole.log(arr.toSpliced(1, 2)); // [1, 4, undefined, 6]\n```\n\n### Calling toSpliced() on non-array objects\n\nThe `toSpliced()` method reads the `length` property of `this`. It then reads the integer-keyed properties needed and writes them into the new array.\n\n```js\nconst arrayLike = {\n  length: 3,\n  unrelated: "foo",\n  0: 5,\n  2: 4,\n};\nconsole.log(Array.prototype.toSpliced.call(arrayLike, 0, 1, 2, 3));\n// [2, 3, undefined, 4]\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Array.prototype.toSpliced` in `core-js`](https://github.com/zloirock/core-js#change-array-by-copy)\n- {{jsxref("Array.prototype.splice()")}}\n- {{jsxref("Array.prototype.toReversed()")}}\n- {{jsxref("Array.prototype.toSorted()")}}\n- {{jsxref("Array.prototype.with()")}}\n'
        },
        "tostring": {
            "index.md": '---\ntitle: Array.prototype.toString()\nslug: Web/JavaScript/Reference/Global_Objects/Array/toString\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Array.toString\n---\n\n{{JSRef}}\n\nThe **`toString()`** method of {{jsxref("Array")}} instances returns a string representing the\nspecified array and its elements.\n\n{{EmbedInteractiveExample("pages/js/array-tostring.html", "shorter")}}\n\n## Syntax\n\n```js-nolint\ntoString()\n```\n\n### Parameters\n\nNone.\n\n### Return value\n\nA string representing the elements of the array.\n\n## Description\n\nThe {{jsxref("Array")}} object overrides the `toString` method of {{jsxref("Object")}}. The `toString` method of arrays calls [`join()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/join) internally, which joins the array and returns one string containing each array element separated by commas. If the `join` method is unavailable or is not a function, [`Object.prototype.toString`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/toString) is used instead, returning `[object Array]`.\n\n```js\nconst arr = [];\narr.join = 1; // re-assign `join` with a non-function\nconsole.log(arr.toString()); // [object Array]\n\nconsole.log(Array.prototype.toString.call({ join: () => 1 })); // 1\n```\n\nJavaScript calls the `toString` method automatically when an array is to be represented as a text value or when an array is referred to in a string concatenation.\n\n`Array.prototype.toString` recursively converts each element, including other arrays, to strings. Because the string returned by `Array.prototype.toString` does not have delimiters, nested arrays look like they are flattened.\n\n```js\nconst matrix = [\n  [1, 2, 3],\n  [4, 5, 6],\n  [7, 8, 9],\n];\n\nconsole.log(matrix.toString()); // 1,2,3,4,5,6,7,8,9\n```\n\nWhen an array is cyclic (it contains an element that is itself), browsers avoid infinite recursion by ignoring the cyclic reference.\n\n```js\nconst arr = [];\narr.push(1, [3, arr, 4], 2);\nconsole.log(arr.toString()); // 1,3,,4,2\n```\n\n## Examples\n\n### Using toString()\n\n```js\nconst array1 = [1, 2, "a", "1a"];\n\nconsole.log(array1.toString()); // "1,2,a,1a"\n```\n\n### Using toString() on sparse arrays\n\nFollowing the behavior of `join()`, `toString()` treats empty slots the same as `undefined` and produces an extra separator:\n\n```js\nconsole.log([1, , 3].toString()); // \'1,,3\'\n```\n\n### Calling toString() on non-array objects\n\n`toString()` is [generic](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array#generic_array_methods). It expects `this` to have a `join()` method; or, failing that, uses `Object.prototype.toString()` instead.\n\n```js\nconsole.log(Array.prototype.toString.call({ join: () => 1 }));\n// 1; a number\nconsole.log(Array.prototype.toString.call({ join: () => undefined }));\n// undefined\nconsole.log(Array.prototype.toString.call({ join: "not function" }));\n// "[object Object]"\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Indexed collections](/en-US/docs/Web/JavaScript/Guide/Indexed_collections) guide\n- {{jsxref("Array")}}\n- {{jsxref("Array.prototype.join()")}}\n- {{jsxref("Array.prototype.toLocaleString()")}}\n- {{jsxref("TypedArray.prototype.toString()")}}\n- {{jsxref("String.prototype.toString()")}}\n'
        },
        "unshift": {
            "index.md": '---\ntitle: Array.prototype.unshift()\nslug: Web/JavaScript/Reference/Global_Objects/Array/unshift\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Array.unshift\n---\n\n{{JSRef}}\n\nThe **`unshift()`** method of {{jsxref("Array")}} instances adds the specified elements to the\nbeginning of an array and returns the new length of the array.\n\n{{EmbedInteractiveExample("pages/js/array-unshift.html")}}\n\n## Syntax\n\n```js-nolint\nunshift()\nunshift(element1)\nunshift(element1, element2)\nunshift(element1, element2, /* \u2026, */ elementN)\n```\n\n### Parameters\n\n- `element1`, \u2026, `elementN`\n  - : The elements to add to the front of the `arr`.\n\n### Return value\n\nThe new {{jsxref("Array/length", "length")}} property of the object upon which the\nmethod was called.\n\n## Description\n\nThe `unshift()` method inserts the given values to the beginning of an\narray-like object.\n\n{{jsxref("Array.prototype.push()")}} has similar behavior to `unshift()`, but applied to the end of an array.\n\nPlease note that, if multiple elements are passed as parameters, they\'re inserted in\nchunk at the beginning of the object, in the exact same order they were passed as\nparameters. Hence, calling `unshift()` with `n`\narguments **once**, or calling it `n` times with\n**1** argument (with a loop, for example), don\'t yield the same results.\n\nSee example:\n\n```js\nlet arr = [4, 5, 6];\n\narr.unshift(1, 2, 3);\nconsole.log(arr);\n// [1, 2, 3, 4, 5, 6]\n\narr = [4, 5, 6]; // resetting the array\n\narr.unshift(1);\narr.unshift(2);\narr.unshift(3);\n\nconsole.log(arr);\n// [3, 2, 1, 4, 5, 6]\n```\n\nThe `unshift()` method is [generic](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array#generic_array_methods). It only expects the `this` value to have a `length` property and integer-keyed properties. Although strings are also array-like, this method is not suitable to be applied on them, as strings are immutable.\n\n## Examples\n\n### Using unshift()\n\n```js\nconst arr = [1, 2];\n\narr.unshift(0); // result of the call is 3, which is the new array length\n// arr is [0, 1, 2]\n\narr.unshift(-2, -1); // the new array length is 5\n// arr is [-2, -1, 0, 1, 2]\n\narr.unshift([-4, -3]); // the new array length is 6\n// arr is [[-4, -3], -2, -1, 0, 1, 2]\n\narr.unshift([-7, -6], [-5]); // the new array length is 8\n// arr is [ [-7, -6], [-5], [-4, -3], -2, -1, 0, 1, 2 ]\n```\n\n### Calling unshift() on non-array objects\n\nThe `unshift()` method reads the `length` property of `this`. It shifts all indices in the range `0` to `length - 1` right by the number of arguments (incrementing their values by this number). Then, it sets each index starting at `0` with the arguments passed to `unshift()`. Finally, it sets the `length` to the previous length plus the number of prepended elements.\n\n```js\nconst arrayLike = {\n  length: 3,\n  unrelated: "foo",\n  2: 4,\n};\nArray.prototype.unshift.call(arrayLike, 1, 2);\nconsole.log(arrayLike);\n// { \'0\': 1, \'1\': 2, \'4\': 4, length: 5, unrelated: \'foo\' }\n\nconst plainObj = {};\n// There\'s no length property, so the length is 0\nArray.prototype.unshift.call(plainObj, 1, 2);\nconsole.log(plainObj);\n// { \'0\': 1, \'1\': 2, length: 2 }\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Array.prototype.unshift` in `core-js` with fixes of this method](https://github.com/zloirock/core-js#ecmascript-array)\n- [Indexed collections](/en-US/docs/Web/JavaScript/Guide/Indexed_collections) guide\n- {{jsxref("Array")}}\n- {{jsxref("Array.prototype.push()")}}\n- {{jsxref("Array.prototype.pop()")}}\n- {{jsxref("Array.prototype.shift()")}}\n- {{jsxref("Array.prototype.concat()")}}\n- {{jsxref("Array.prototype.splice()")}}\n'
        },
        "values": {
            "index.md": '---\ntitle: Array.prototype.values()\nslug: Web/JavaScript/Reference/Global_Objects/Array/values\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Array.values\n---\n\n{{JSRef}}\n\nThe **`values()`** method of {{jsxref("Array")}} instances returns a new _[array iterator](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Iterator)_ object that iterates the value of each item in the array.\n\n{{EmbedInteractiveExample("pages/js/array-values.html")}}\n\n## Syntax\n\n```js-nolint\nvalues()\n```\n\n### Parameters\n\nNone.\n\n### Return value\n\nA new [iterable iterator object](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Iterator).\n\n## Description\n\n`Array.prototype.values()` is the default implementation of [`Array.prototype[@@iterator]()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/@@iterator).\n\n```js\nArray.prototype.values === Array.prototype[Symbol.iterator]; // true\n```\n\nWhen used on [sparse arrays](/en-US/docs/Web/JavaScript/Guide/Indexed_collections#sparse_arrays), the `values()` method iterates empty slots as if they have the value `undefined`.\n\nThe `values()` method is [generic](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array#generic_array_methods). It only expects the `this` value to have a `length` property and integer-keyed properties.\n\n## Examples\n\n### Iteration using for...of loop\n\nBecause `values()` returns an iterable iterator, you can use a [`for...of`](/en-US/docs/Web/JavaScript/Reference/Statements/for...of) loop to iterate it.\n\n```js\nconst arr = ["a", "b", "c", "d", "e"];\nconst iterator = arr.values();\n\nfor (const letter of iterator) {\n  console.log(letter);\n} // "a" "b" "c" "d" "e"\n```\n\n### Iteration using next()\n\nBecause the return value is also an iterator, you can directly call its `next()` method.\n\n```js\nconst arr = ["a", "b", "c", "d", "e"];\nconst iterator = arr.values();\niterator.next(); // { value: "a", done: false }\niterator.next(); // { value: "b", done: false }\niterator.next(); // { value: "c", done: false }\niterator.next(); // { value: "d", done: false }\niterator.next(); // { value: "e", done: false }\niterator.next(); // { value: undefined, done: true }\nconsole.log(iterator.next().value); // undefined\n```\n\n### Reusing the iterable\n\n> **Warning:** The array iterator object should be a one-time use object. Do not reuse it.\n\nThe iterable returned from `values()` is not reusable. When `next().done = true` or `currentIndex > length`, [the `for...of` loop ends](/en-US/docs/Web/JavaScript/Reference/Iteration_protocols#interactions_between_the_language_and_iteration_protocols), and further iterating it has no effect.\n\n```js\nconst arr = ["a", "b", "c", "d", "e"];\nconst values = arr.values();\nfor (const letter of values) {\n  console.log(letter);\n}\n// "a" "b" "c" "d" "e"\nfor (const letter of values) {\n  console.log(letter);\n}\n// undefined\n```\n\nIf you use a [`break`](/en-US/docs/Web/JavaScript/Reference/Statements/break) statement to end the iteration early, the iterator can resume from the current position when continuing to iterate it.\n\n```js\nconst arr = ["a", "b", "c", "d", "e"];\nconst values = arr.values();\nfor (const letter of values) {\n  console.log(letter);\n  if (letter === "b") {\n    break;\n  }\n}\n// "a" "b"\n\nfor (const letter of values) {\n  console.log(letter);\n}\n// "c" "d" "e"\n```\n\n### Mutations during iteration\n\nThere are no values stored in the array iterator object returned from `values()`; instead, it stores the address of the array used in its creation, and reads the currently visited index on each iteration. Therefore, its iteration output depends on the value stored in that index at the time of stepping. If the values in the array changed, the array iterator object\'s values change too.\n\n```js\nconst arr = ["a", "b", "c", "d", "e"];\nconst iterator = arr.values();\nconsole.log(iterator); // Array Iterator { }\nconsole.log(iterator.next().value); // "a"\narr[1] = "n";\nconsole.log(iterator.next().value); // "n"\n```\n\n### Iterating sparse arrays\n\n`values()` will visit empty slots as if they are `undefined`.\n\n```js\nfor (const element of [, "a"].values()) {\n  console.log(element);\n}\n// undefined\n// \'a\'\n```\n\n### Calling values() on non-array objects\n\nThe `values()` method reads the `length` property of `this` and then accesses each property whose key is a nonnegative integer less than `length`.\n\n```js\nconst arrayLike = {\n  length: 3,\n  0: "a",\n  1: "b",\n  2: "c",\n  3: "d", // ignored by values() since length is 3\n};\nfor (const entry of Array.prototype.values.call(arrayLike)) {\n  console.log(entry);\n}\n// a\n// b\n// c\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Array.prototype.values` in `core-js`](https://github.com/zloirock/core-js#ecmascript-array)\n- [Indexed collections](/en-US/docs/Web/JavaScript/Guide/Indexed_collections) guide\n- {{jsxref("Array")}}\n- {{jsxref("Array.prototype.entries()")}}\n- {{jsxref("Array.prototype.keys()")}}\n- [`Array.prototype[@@iterator]()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/@@iterator)\n- {{jsxref("TypedArray.prototype.values()")}}\n- [Iteration protocols](/en-US/docs/Web/JavaScript/Reference/Iteration_protocols)\n'
        },
        "with": {
            "index.md": '---\ntitle: Array.prototype.with()\nslug: Web/JavaScript/Reference/Global_Objects/Array/with\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Array.with\n---\n\n{{JSRef}}\n\nThe **`with()`** method of {{jsxref("Array")}} instances is the [copying](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array#copying_methods_and_mutating_methods) version of using the [bracket notation](/en-US/docs/Web/JavaScript/Reference/Operators/Property_accessors#bracket_notation) to change the value of a given index. It returns a new array with the element at the given index replaced with the given value.\n\n## Syntax\n\n```js-nolint\narrayInstance.with(index, value)\n```\n\n### Parameters\n\n- `index`\n  - : Zero-based index at which to change the array, [converted to an integer](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number#integer_conversion).\n    - Negative index counts back from the end of the array \u2014 if `-array.length <= index < 0`, `index + array.length` is used.\n    - If the index after normalization is out of bounds, a {{jsxref("RangeError")}} is thrown.\n- `value`\n  - : Any value to be assigned to the given index.\n\n### Return value\n\nA new array with the element at `index` replaced with `value`.\n\n### Exceptions\n\n- {{jsxref("RangeError")}}\n  - : Thrown if `index >= array.length` or `index < -array.length`.\n\n## Description\n\nThe `with()` method changes the value of a given index in the array, returning a new array with the element at the given index replaced with the given value. The original array is not modified. This allows you to chain array methods while doing manipulations.\n\nBy combining `with()` with {{jsxref("Array/at", "at()")}}, you can both write and read (respectively) an array using negative indices.\n\nThe `with()` method never produces a [sparse array](/en-US/docs/Web/JavaScript/Guide/Indexed_collections#sparse_arrays). If the source array is sparse, the empty slots will be replaced with `undefined` in the new array.\n\nThe `with()` method is [generic](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array#generic_array_methods). It only expects the `this` value to have a `length` property and integer-keyed properties.\n\n## Examples\n\n### Creating a new array with a single element changed\n\n```js\nconst arr = [1, 2, 3, 4, 5];\nconsole.log(arr.with(2, 6)); // [1, 2, 6, 4, 5]\nconsole.log(arr); // [1, 2, 3, 4, 5]\n```\n\n### Chaining array methods\n\nWith the `with()` method, you can update a single element in an array and then apply other array methods.\n\n```js\nconst arr = [1, 2, 3, 4, 5];\nconsole.log(arr.with(2, 6).map((x) => x ** 2)); // [1, 4, 36, 16, 25]\n```\n\n### Using with() on sparse arrays\n\nThe `with()` method always creates a dense array.\n\n```js\nconst arr = [1, , 3, 4, , 6];\nconsole.log(arr.with(0, 2)); // [2, undefined, 3, 4, undefined, 6]\n```\n\n### Calling with() on non-array objects\n\nThe `with()` method creates and returns a new array. It reads the `length` property of `this` and then accesses each property whose key is a nonnegative integer less than `length`. As each property of `this` is accessed, the array element having an index equal to the key of the property is set to the value of the property. Finally, the array value at `index` is set to `value`.\n\n```js\nconst arrayLike = {\n  length: 3,\n  unrelated: "foo",\n  0: 5,\n  2: 4,\n  3: 3, // ignored by with() since length is 3\n};\nconsole.log(Array.prototype.with.call(arrayLike, 0, 1));\n// [ 1, undefined, 4 ]\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Array.prototype.with` in `core-js`](https://github.com/zloirock/core-js#change-array-by-copy)\n- [Indexed collections](/en-US/docs/Web/JavaScript/Guide/Indexed_collections) guide\n- {{jsxref("Array.prototype.toReversed()")}}\n- {{jsxref("Array.prototype.toSorted()")}}\n- {{jsxref("Array.prototype.toSpliced()")}}\n- {{jsxref("Array.prototype.at()")}}\n- {{jsxref("TypedArray.prototype.with()")}}\n'
        }
    },
    "arraybuffer": {
        "@@species": {
            "index.md": '---\ntitle: ArrayBuffer[@@species]\nslug: Web/JavaScript/Reference/Global_Objects/ArrayBuffer/@@species\npage-type: javascript-static-accessor-property\nbrowser-compat: javascript.builtins.ArrayBuffer.@@species\n---\n\n{{JSRef}}\n\nThe **`ArrayBuffer[@@species]`** static accessor property returns the constructor used to construct return values from array buffer methods.\n\n> **Warning:** The existence of `@@species` allows execution of arbitrary code and may create security vulnerabilities. It also makes certain optimizations much harder. Engine implementers are [investigating whether to remove this feature](https://github.com/tc39/proposal-rm-builtin-subclassing). Avoid relying on it if possible.\n\n## Syntax\n\n```js-nolint\nArrayBuffer[Symbol.species]\n```\n\n### Return value\n\nThe value of the constructor (`this`) on which `get @@species` was called. The return value is used to construct return values from array buffer methods that create new array buffers.\n\n## Description\n\nThe `@@species` accessor property returns the default constructor for `ArrayBuffer` objects. Subclass constructors may override it to change the constructor assignment. The default implementation is basically:\n\n```js\n// Hypothetical underlying implementation for illustration\nclass ArrayBuffer {\n  static get [Symbol.species]() {\n    return this;\n  }\n}\n```\n\nBecause of this polymorphic implementation, `@@species` of derived subclasses would also return the constructor itself by default.\n\n```js\nclass SubArrayBuffer extends ArrayBuffer {}\nSubArrayBuffer[Symbol.species] === SubArrayBuffer; // true\n```\n\nWhen calling array buffer methods that do not mutate the existing object but return a new array buffer instance (for example, [`slice()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/ArrayBuffer/slice)), the object\'s `constructor[@@species]` will be accessed. The returned constructor will be used to construct the return value of the array buffer method.\n\n## Examples\n\n### Species in ordinary objects\n\nThe `@@species` property returns the default constructor function, which is the `ArrayBuffer` constructor for `ArrayBuffer`.\n\n```js\nArrayBuffer[Symbol.species]; // function ArrayBuffer()\n```\n\n### Species in derived objects\n\nIn an instance of a custom `ArrayBuffer` subclass, such as `MyArrayBuffer`, the `MyArrayBuffer` species is the `MyArrayBuffer` constructor. However, you might want to overwrite this, in order to return parent `ArrayBuffer` objects in your derived class methods:\n\n```js\nclass MyArrayBuffer extends ArrayBuffer {\n  // Overwrite MyArrayBuffer species to the parent ArrayBuffer constructor\n  static get [Symbol.species]() {\n    return ArrayBuffer;\n  }\n}\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("ArrayBuffer")}}\n- {{jsxref("Symbol.species")}}\n'
        },
        "arraybuffer": {
            "index.md": '---\ntitle: ArrayBuffer() constructor\nslug: Web/JavaScript/Reference/Global_Objects/ArrayBuffer/ArrayBuffer\npage-type: javascript-constructor\nbrowser-compat: javascript.builtins.ArrayBuffer.ArrayBuffer\n---\n\n{{JSRef}}\n\nThe **`ArrayBuffer()`** constructor creates {{jsxref("ArrayBuffer")}} objects.\n\n{{EmbedInteractiveExample("pages/js/arraybuffer-constructor.html", "shorter")}}\n\n## Syntax\n\n```js-nolint\nnew ArrayBuffer(length)\nnew ArrayBuffer(length, options)\n```\n\n> **Note:** `ArrayBuffer()` can only be constructed with [`new`](/en-US/docs/Web/JavaScript/Reference/Operators/new). Attempting to call it without `new` throws a {{jsxref("TypeError")}}.\n\n### Parameters\n\n- `length`\n  - : The size, in bytes, of the array buffer to create.\n- `options` {{optional_inline}}\n  - : An object, which can contain the following properties:\n    - `maxByteLength` {{optional_inline}}\n      - : The maximum size, in bytes, that the array buffer can be resized to.\n\n### Return value\n\nA new `ArrayBuffer` object of the specified size, with its {{jsxref("ArrayBuffer/maxByteLength", "maxByteLength")}} property set to the specified `maxByteLength` if one was specified. Its contents are initialized to 0.\n\n### Exceptions\n\n- {{jsxref("RangeError")}}\n  - : Thrown in one of the following cases:\n    - `length` or `maxByteLength` is larger than {{jsxref("Number.MAX_SAFE_INTEGER")}} (\u2265 2<sup>53</sup>) or negative.\n    - `length` is larger than `maxByteLength`.\n\n## Examples\n\n### Creating an ArrayBuffer\n\nIn this example, we create a 8-byte buffer with a {{jsxref("Int32Array")}} view referring to the buffer:\n\n```js\nconst buffer = new ArrayBuffer(8);\nconst view = new Int32Array(buffer);\n```\n\n### Creating a resizable ArrayBuffer\n\nIn this example, we create a 8-byte buffer that is resizable to a max length of 16 bytes, then {{jsxref("ArrayBuffer/resize", "resize()")}} it to 12 bytes:\n\n```js\nconst buffer = new ArrayBuffer(8, { maxByteLength: 16 });\n\nbuffer.resize(12);\n```\n\n> **Note:** It is recommended that `maxByteLength` is set to the smallest value possible for your use case. It should never exceed `1073741824` (1GB) to reduce the risk of out-of-memory errors.\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `ArrayBuffer` in `core-js`](https://github.com/zloirock/core-js#ecmascript-typed-arrays)\n- [JavaScript typed arrays](/en-US/docs/Web/JavaScript/Guide/Typed_arrays) guide\n- {{jsxref("SharedArrayBuffer")}}\n'
        },
        "bytelength": {
            "index.md": '---\ntitle: ArrayBuffer.prototype.byteLength\nslug: Web/JavaScript/Reference/Global_Objects/ArrayBuffer/byteLength\npage-type: javascript-instance-accessor-property\nbrowser-compat: javascript.builtins.ArrayBuffer.byteLength\n---\n\n{{JSRef}}\n\nThe **`byteLength`** accessor property of {{jsxref("ArrayBuffer")}} instances returns the length (in bytes) of this array buffer.\n\n{{EmbedInteractiveExample("pages/js/arraybuffer-bytelength.html")}}\n\n## Description\n\nThe `byteLength` property is an accessor property whose set accessor function is `undefined`, meaning that you can only read this property. The value is established when the array is constructed and cannot be changed. This property returns 0 if this `ArrayBuffer` has been detached.\n\n## Examples\n\n### Using byteLength\n\n```js\nconst buffer = new ArrayBuffer(8);\nbuffer.byteLength; // 8\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("ArrayBuffer")}}\n'
        },
        "detached": {
            "index.md": '---\ntitle: ArrayBuffer.prototype.detached\nslug: Web/JavaScript/Reference/Global_Objects/ArrayBuffer/detached\npage-type: javascript-instance-accessor-property\nbrowser-compat: javascript.builtins.ArrayBuffer.detached\n---\n\n{{JSRef}}\n\nThe **`detached`** accessor property of {{jsxref("ArrayBuffer")}} instances returns a boolean indicating whether or not this buffer has been detached (transferred).\n\n## Description\n\nThe `detached` property is an accessor property whose set accessor function is `undefined`, meaning that you can only read this property. The value is `false` when the `ArrayBuffer` is first created. The value becomes `true` if the `ArrayBuffer` is [transferred](/en-US/docs/Web/JavaScript/Reference/Global_Objects/ArrayBuffer#transferring_arraybuffers), which detaches the instance from its underlying memory. Once a buffer becomes detached, it is no longer usable.\n\n## Examples\n\n### Using detached\n\n```js\nconst buffer = new ArrayBuffer(8);\nconsole.log(buffer.detached); // false\nconst newBuffer = buffer.transfer();\nconsole.log(buffer.detached); // true\nconsole.log(newBuffer.detached); // false\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `ArrayBuffer.prototype.detached` in `core-js`](https://github.com/zloirock/core-js#arraybufferprototypetransfer-and-friends)\n- {{jsxref("ArrayBuffer")}}\n- {{jsxref("ArrayBuffer.prototype.transfer()")}}\n- {{jsxref("ArrayBuffer.prototype.transferToFixedLength()")}}\n'
        },
        "index.md": '---\ntitle: ArrayBuffer\nslug: Web/JavaScript/Reference/Global_Objects/ArrayBuffer\npage-type: javascript-class\nbrowser-compat: javascript.builtins.ArrayBuffer\n---\n\n{{JSRef}}\n\nThe **`ArrayBuffer`** object is used to represent a generic raw binary data buffer.\n\nIt is an array of bytes, often referred to in other languages as a "byte array". You cannot directly manipulate the contents of an `ArrayBuffer`; instead, you create one of the [typed array objects](/en-US/docs/Web/JavaScript/Reference/Global_Objects/TypedArray) or a {{jsxref("DataView")}} object which represents the buffer in a specific format, and use that to read and write the contents of the buffer.\n\nThe [`ArrayBuffer()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/ArrayBuffer/ArrayBuffer) constructor creates a new `ArrayBuffer` of the given length in bytes. You can also get an array buffer from existing data, for example, from a [Base64](/en-US/docs/Glossary/Base64) string or [from a local file](/en-US/docs/Web/API/FileReader/readAsArrayBuffer).\n\n`ArrayBuffer` is a [transferable object](/en-US/docs/Web/API/Web_Workers_API/Transferable_objects).\n\n## Description\n\n### Resizing ArrayBuffers\n\n`ArrayBuffer` objects can be made resizable by including the `maxByteLength` option when calling the {{jsxref("ArrayBuffer/ArrayBuffer", "ArrayBuffer()")}} constructor. You can query whether an `ArrayBuffer` is resizable and what its maximum size is by accessing its {{jsxref("ArrayBuffer/resizable", "resizable")}} and {{jsxref("ArrayBuffer/maxByteLength", "maxByteLength")}} properties, respectively. You can assign a new size to a resizable `ArrayBuffer` with a {{jsxref("ArrayBuffer/resize", "resize()")}} call. New bytes are initialized to 0.\n\nThese features make resizing `ArrayBuffer`s more efficient \u2014 otherwise, you have to make a copy of the buffer with a new size. It also gives JavaScript parity with WebAssembly in this regard (Wasm linear memory can be resized with [`WebAssembly.Memory.prototype.grow()`](/en-US/docs/WebAssembly/JavaScript_interface/Memory/grow)).\n\n### Transferring ArrayBuffers\n\n`ArrayBuffer` objects can be transferred between different execution contexts, like [Web Workers](/en-US/docs/Web/API/Web_Workers_API) or [Service Workers](/en-US/docs/Web/API/Service_Worker_API), using the [structured clone algorithm](/en-US/docs/Web/API/Web_Workers_API/Structured_clone_algorithm). This is done by passing the `ArrayBuffer` as a [transferable object](/en-US/docs/Web/API/Web_Workers_API/Transferable_objects) in a call to {{domxref("Worker.postMessage()")}} or {{domxref("ServiceWorker.postMessage()")}}. In pure JavaScript, you can also transfer the ownership of memory from one `ArrayBuffer` to another using its {{jsxref("ArrayBuffer/transfer", "transfer()")}} or {{jsxref("ArrayBuffer/transferToFixedLength", "transferToFixedLength()")}} method.\n\nWhen an `ArrayBuffer` is transferred, its original copy becomes _detached_ \u2014 this means it is no longer usable. At any moment, there will only be one copy of the `ArrayBuffer` that actually has access to the underlying memory. Detached buffers have the following behaviors:\n\n- {{jsxref("ArrayBuffer/byteLength", "byteLength")}} becomes 0 (in both the buffer and the associated typed array views).\n- Methods, such as {{jsxref("ArrayBuffer/resize", "resize()")}} and {{jsxref("ArrayBuffer/slice", "slice()")}}, throw a {{jsxref("TypeError")}} when invoked. The associated typed array views\' methods also throw a `TypeError`.\n\nYou can check whether an `ArrayBuffer` is detached by its {{jsxref("ArrayBuffer/detached", "detached")}} property.\n\n## Constructor\n\n- {{jsxref("ArrayBuffer/ArrayBuffer", "ArrayBuffer()")}}\n  - : Creates a new `ArrayBuffer` object.\n\n## Static properties\n\n- {{jsxref("ArrayBuffer/@@species", "ArrayBuffer[@@species]")}}\n  - : The constructor function that is used to create derived objects.\n\n## Static methods\n\n- {{jsxref("ArrayBuffer.isView()")}}\n  - : Returns `true` if `arg` is one of the ArrayBuffer views, such as [typed array objects](/en-US/docs/Web/JavaScript/Reference/Global_Objects/TypedArray) or a {{jsxref("DataView")}}. Returns `false` otherwise.\n\n## Instance properties\n\nThese properties are defined on `ArrayBuffer.prototype` and shared by all `ArrayBuffer` instances.\n\n- {{jsxref("ArrayBuffer.prototype.byteLength")}}\n  - : The size, in bytes, of the `ArrayBuffer`. This is established when the array is constructed and can only be changed using the {{jsxref("ArrayBuffer.prototype.resize()")}} method if the `ArrayBuffer` is resizable.\n- {{jsxref("Object/constructor", "ArrayBuffer.prototype.constructor")}}\n  - : The constructor function that created the instance object. For `ArrayBuffer` instances, the initial value is the {{jsxref("ArrayBuffer/ArrayBuffer", "ArrayBuffer")}} constructor.\n- {{jsxref("ArrayBuffer.prototype.detached")}}\n  - : Read-only. Returns `true` if the `ArrayBuffer` has been detached (transferred), or `false` if not.\n- {{jsxref("ArrayBuffer.prototype.maxByteLength")}}\n  - : The read-only maximum length, in bytes, that the `ArrayBuffer` can be resized to. This is established when the array is constructed and cannot be changed.\n- {{jsxref("ArrayBuffer.prototype.resizable")}}\n  - : Read-only. Returns `true` if the `ArrayBuffer` can be resized, or `false` if not.\n- `ArrayBuffer.prototype[@@toStringTag]`\n  - : The initial value of the [`@@toStringTag`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol/toStringTag) property is the string `"ArrayBuffer"`. This property is used in {{jsxref("Object.prototype.toString()")}}.\n\n## Instance methods\n\n- {{jsxref("ArrayBuffer.prototype.resize()")}}\n  - : Resizes the `ArrayBuffer` to the specified size, in bytes.\n- {{jsxref("ArrayBuffer.prototype.slice()")}}\n  - : Returns a new `ArrayBuffer` whose contents are a copy of this `ArrayBuffer`\'s bytes from `begin` (inclusive) up to `end` (exclusive). If either `begin` or `end` is negative, it refers to an index from the end of the array, as opposed to from the beginning.\n- {{jsxref("ArrayBuffer.prototype.transfer()")}}\n  - : Creates a new `ArrayBuffer` with the same byte content as this buffer, then detaches this buffer.\n- {{jsxref("ArrayBuffer.prototype.transferToFixedLength()")}}\n  - : Creates a new non-resizable `ArrayBuffer` with the same byte content as this buffer, then detaches this buffer.\n\n## Examples\n\n### Creating an ArrayBuffer\n\nIn this example, we create a 8-byte buffer with a {{jsxref("Int32Array")}} view referring to the buffer:\n\n```js\nconst buffer = new ArrayBuffer(8);\nconst view = new Int32Array(buffer);\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `ArrayBuffer` in `core-js`](https://github.com/zloirock/core-js#ecmascript-typed-arrays)\n- [JavaScript typed arrays](/en-US/docs/Web/JavaScript/Guide/Typed_arrays) guide\n- {{jsxref("SharedArrayBuffer")}}\n- [RangeError: invalid array length](/en-US/docs/Web/JavaScript/Reference/Errors/Invalid_array_length)\n',
        "isview": {
            "index.md": '---\ntitle: ArrayBuffer.isView()\nslug: Web/JavaScript/Reference/Global_Objects/ArrayBuffer/isView\npage-type: javascript-static-method\nbrowser-compat: javascript.builtins.ArrayBuffer.isView\n---\n\n{{JSRef}}\n\nThe **`ArrayBuffer.isView()`** static method determines whether the\npassed value is one of the `ArrayBuffer` views,\nsuch as [typed array objects](/en-US/docs/Web/JavaScript/Reference/Global_Objects/TypedArray)\nor a {{jsxref("DataView")}}.\n\n{{EmbedInteractiveExample("pages/js/arraybuffer-isview.html", "shorter")}}\n\n## Syntax\n\n```js-nolint\nArrayBuffer.isView(value)\n```\n\n### Parameters\n\n- `value`\n  - : The value to be checked.\n\n### Return value\n\n`true` if the given argument is one of the {{jsxref("ArrayBuffer")}} views;\notherwise, `false`.\n\n## Examples\n\n### Using isView\n\n```js\nArrayBuffer.isView(); // false\nArrayBuffer.isView([]); // false\nArrayBuffer.isView({}); // false\nArrayBuffer.isView(null); // false\nArrayBuffer.isView(undefined); // false\nArrayBuffer.isView(new ArrayBuffer(10)); // false\n\nArrayBuffer.isView(new Uint8Array()); // true\nArrayBuffer.isView(new Float32Array()); // true\nArrayBuffer.isView(new Int8Array(10).subarray(0, 3)); // true\n\nconst buffer = new ArrayBuffer(2);\nconst dv = new DataView(buffer);\nArrayBuffer.isView(dv); // true\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [JavaScript typed arrays](/en-US/docs/Web/JavaScript/Guide/Typed_arrays) guide\n'
        },
        "maxbytelength": {
            "index.md": '---\ntitle: ArrayBuffer.prototype.maxByteLength\nslug: Web/JavaScript/Reference/Global_Objects/ArrayBuffer/maxByteLength\npage-type: javascript-instance-accessor-property\nbrowser-compat: javascript.builtins.ArrayBuffer.maxByteLength\n---\n\n{{JSRef}}\n\nThe **`maxByteLength`** accessor property of {{jsxref("ArrayBuffer")}} instances returns the maximum length (in bytes) that this array buffer can be resized to.\n\n{{EmbedInteractiveExample("pages/js/arraybuffer-maxbytelength.html")}}\n\n## Description\n\nThe `maxByteLength` property is an accessor property whose set accessor function is `undefined`, meaning that you can only read this property. The value is established when the array is constructed, set via the `maxByteLength` option of the {{jsxref("ArrayBuffer/ArrayBuffer", "ArrayBuffer()")}} constructor, and cannot be changed.\n\nThis property returns 0 if this `ArrayBuffer` has been detached. If this `ArrayBuffer` was constructed without specifying a `maxByteLength` value, this property returns a value equal to the value of the `ArrayBuffer`\'s {{jsxref("ArrayBuffer/byteLength", "byteLength")}}.\n\n## Examples\n\n### Using maxByteLength\n\nIn this example, we create an 8-byte buffer that is resizable to a max length of 16 bytes, then return its `maxByteLength`:\n\n```js\nconst buffer = new ArrayBuffer(8, { maxByteLength: 16 });\n\nbuffer.maxByteLength; // 16\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("ArrayBuffer")}}\n- {{jsxref("ArrayBuffer.prototype.byteLength")}}\n- {{jsxref("ArrayBuffer.prototype.resize()")}}\n'
        },
        "resizable": {
            "index.md": '---\ntitle: ArrayBuffer.prototype.resizable\nslug: Web/JavaScript/Reference/Global_Objects/ArrayBuffer/resizable\npage-type: javascript-instance-accessor-property\nbrowser-compat: javascript.builtins.ArrayBuffer.resizable\n---\n\n{{JSRef}}\n\nThe **`resizable`** accessor property of {{jsxref("ArrayBuffer")}} instances returns whether this array buffer can be resized or not.\n\n{{EmbedInteractiveExample("pages/js/arraybuffer-resizable.html")}}\n\n## Description\n\nThe `resizable` property is an accessor property whose set accessor function is `undefined`, meaning that you can only read this property. The value is established when the array is constructed. If the `maxByteLength` option was set in the constructor, `resizable` will return `true`; if not, it will return `false`.\n\n## Examples\n\n### Using resizable\n\nIn this example, we create a 8-byte buffer that is resizable to a max length of 16 bytes, then check its `resizable` property, resizing it if `resizable` returns `true`:\n\n```js\nconst buffer = new ArrayBuffer(8, { maxByteLength: 16 });\n\nif (buffer.resizable) {\n  console.log("Buffer is resizable!");\n  buffer.resize(12);\n}\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("ArrayBuffer")}}\n- {{jsxref("ArrayBuffer.prototype.maxByteLength")}}\n- {{jsxref("ArrayBuffer.prototype.resize()")}}\n'
        },
        "resize": {
            "index.md": '---\ntitle: ArrayBuffer.prototype.resize()\nslug: Web/JavaScript/Reference/Global_Objects/ArrayBuffer/resize\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.ArrayBuffer.resize\n---\n\n{{JSRef}}\n\nThe **`resize()`** method of {{jsxref("ArrayBuffer")}} instances resizes the `ArrayBuffer` to the specified size, in bytes.\n\n{{EmbedInteractiveExample("pages/js/arraybuffer-resize.html")}}\n\n## Syntax\n\n```js-nolint\nresize(newLength)\n```\n\n### Parameters\n\n- `newLength`\n  - : The new length, in bytes, to resize the `ArrayBuffer` to.\n\n### Return value\n\nNone ({{jsxref("undefined")}}).\n\n### Exceptions\n\n- {{jsxref("TypeError")}}\n  - : Thrown if the `ArrayBuffer` is detached or is not resizable.\n- {{jsxref("RangeError")}}\n  - : Thrown if `newLength` is larger than the {{jsxref("ArrayBuffer/maxByteLength", "maxByteLength")}} of the `ArrayBuffer`.\n\n## Description\n\nThe `resize()` method resizes an `ArrayBuffer` to the size specified by the `newLength` parameter, provided that the `ArrayBuffer` is [resizable](/en-US/docs/Web/JavaScript/Reference/Global_Objects/ArrayBuffer/resizable) and the new size is less than or equal to the {{jsxref("ArrayBuffer/maxByteLength", "maxByteLength")}} of the `ArrayBuffer`. New bytes are initialized to 0.\n\nNote that you can use `resize()` to shrink as well as grow an `ArrayBuffer` \u2014 it is permissible for `newLength` to be smaller than the `ArrayBuffer`\'s current {{jsxref("ArrayBuffer/byteLength", "byteLength")}}.\n\n## Examples\n\n### Using resize()\n\nIn this example, we create a 8-byte buffer that is resizable to a max length of 16 bytes, then check its `resizable` property, resizing it if `resizable` returns `true`:\n\n```js\nconst buffer = new ArrayBuffer(8, { maxByteLength: 16 });\n\nif (buffer.resizable) {\n  console.log("Buffer is resizable!");\n  buffer.resize(12);\n}\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("ArrayBuffer")}}\n- {{jsxref("ArrayBuffer.prototype.resizable")}}\n- {{jsxref("ArrayBuffer.prototype.maxByteLength")}}\n'
        },
        "slice": {
            "index.md": '---\ntitle: ArrayBuffer.prototype.slice()\nslug: Web/JavaScript/Reference/Global_Objects/ArrayBuffer/slice\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.ArrayBuffer.slice\n---\n\n{{JSRef}}\n\nThe **`slice()`** method of {{jsxref("ArrayBuffer")}} instances returns a new `ArrayBuffer` whose contents are a copy of this `ArrayBuffer`\'s bytes from `start`, inclusive, up to `end`, exclusive. If either `start` or `end` is negative, it refers to an index from the end of the array, as opposed to from the beginning.\n\n{{EmbedInteractiveExample("pages/js/arraybuffer-slice.html")}}\n\n## Syntax\n\n```js-nolint\nslice()\nslice(start)\nslice(start, end)\n```\n\n### Parameters\n\n- `start` {{optional_inline}}\n  - : Zero-based index at which to start extraction, [converted to an integer](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number#integer_conversion).\n    - Negative index counts back from the end of the buffer \u2014 if `-buffer.length <= start < 0`, `start + buffer.length` is used.\n    - If `start < -buffer.length` or `start` is omitted, `0` is used.\n    - If `start >= buffer.length`, nothing is extracted.\n- `end` {{optional_inline}}\n  - : Zero-based index at which to end extraction, [converted to an integer](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number#integer_conversion). `slice()` extracts up to but not including `end`.\n    - Negative index counts back from the end of the buffer \u2014 if `-buffer.length <= end < 0`, `end + buffer.length` is used.\n    - If `end < -buffer.length`, `0` is used.\n    - If `end >= buffer.length` or `end` is omitted, `buffer.length` is used, causing all elements until the end to be extracted.\n    - If `end` implies a position before or at the position that `start` implies, nothing is extracted.\n\n### Return value\n\nA new {{jsxref("ArrayBuffer")}} containing the extracted elements.\n\n## Examples\n\n### Copying an ArrayBuffer\n\n```js\nconst buf1 = new ArrayBuffer(8);\nconst buf2 = buf1.slice(0);\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("ArrayBuffer")}}\n- {{jsxref("SharedArrayBuffer.prototype.slice()")}}\n'
        },
        "transfer": {
            "index.md": '---\ntitle: ArrayBuffer.prototype.transfer()\nslug: Web/JavaScript/Reference/Global_Objects/ArrayBuffer/transfer\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.ArrayBuffer.transfer\n---\n\n{{JSRef}}\n\nThe **`transfer()`** method of {{jsxref("ArrayBuffer")}} instances creates a new `ArrayBuffer` with the same byte content as this buffer, then detaches this buffer.\n\n## Syntax\n\n```js-nolint\ntransfer()\ntransfer(newByteLength)\n```\n\n### Parameters\n\n- `newByteLength` {{optional_inline}}\n  - : The {{jsxref("ArrayBuffer/byteLength", "byteLength")}} of the new `ArrayBuffer`. Defaults to the `byteLength` of this `ArrayBuffer`.\n    - If `newByteLength` is smaller than the `byteLength` of this `ArrayBuffer`, the "overflowing" bytes are dropped.\n    - If `newByteLength` is larger than the `byteLength` of this `ArrayBuffer`, the extra bytes are filled with zeros.\n    - If this `ArrayBuffer` is resizable, `newByteLength` must not be greater than its {{jsxref("ArrayBuffer/maxByteLength", "maxByteLength")}}.\n\n### Return value\n\nA new {{jsxref("ArrayBuffer")}} object. Its contents are initialized to the contents of this `ArrayBuffer`, and extra bytes, if any, are filled with zeros. The new `ArrayBuffer` is resizable if and only if this `ArrayBuffer` is resizable, in which case its {{jsxref("ArrayBuffer/maxByteLength", "maxByteLength")}} is the same as this `ArrayBuffer`\'s. The original `ArrayBuffer` is detached.\n\n### Exceptions\n\n- {{jsxref("RangeError")}}\n  - : Thrown if this `ArrayBuffer` is resizable and `newByteLength` is greater than the {{jsxref("ArrayBuffer/maxByteLength", "maxByteLength")}} of this `ArrayBuffer`.\n- {{jsxref("TypeError")}}\n  - : Thrown if this `ArrayBuffer` is already detached.\n\n## Description\n\nThe `transfer()` method performs the same operation as the [structured clone algorithm](/en-US/docs/Web/API/Web_Workers_API/Structured_clone_algorithm). It copies the bytes of this `ArrayBuffer` into a new `ArrayBuffer` object, then detaches this `ArrayBuffer` object. See [transferring ArrayBuffers](/en-US/docs/Web/JavaScript/Reference/Global_Objects/ArrayBuffer#transferring_arraybuffers) for more information.\n\n`transfer()` preserves the resizability of this `ArrayBuffer`. If you want the new `ArrayBuffer` to be non-resizable, use {{jsxref("ArrayBuffer/transferToFixedLength", "transferToFixedLength()")}} instead. There\'s no way to transfer a buffer that makes a fixed-length buffer become resizable.\n\n`transfer()` is very efficient because implementations may implement this method as a zero-copy move or a `realloc` \u2014 there does not need to be an actual copy of the data.\n\n## Examples\n\n### Transferring an ArrayBuffer\n\n```js\n// Create an ArrayBuffer and write a few bytes\nconst buffer = new ArrayBuffer(8);\nconst view = new Uint8Array(buffer);\nview[1] = 2;\nview[7] = 4;\n\n// Copy the buffer to the same size\nconst buffer2 = buffer.transfer();\nconsole.log(buffer.detached); // true\nconsole.log(buffer2.byteLength); // 8\nconst view2 = new Uint8Array(buffer2);\nconsole.log(view2[1]); // 2\nconsole.log(view2[7]); // 4\n\n// Copy the buffer to a smaller size\nconst buffer3 = buffer2.transfer(4);\nconsole.log(buffer3.byteLength); // 4\nconst view3 = new Uint8Array(buffer3);\nconsole.log(view3[1]); // 2\nconsole.log(view3[7]); // undefined\n\n// Copy the buffer to a larger size\nconst buffer4 = buffer3.transfer(8);\nconsole.log(buffer4.byteLength); // 8\nconst view4 = new Uint8Array(buffer4);\nconsole.log(view4[1]); // 2\nconsole.log(view4[7]); // 0\n\n// Already detached, throws TypeError\nbuffer.transfer(); // TypeError: Cannot perform ArrayBuffer.prototype.transfer on a detached ArrayBuffer\n```\n\n### Transferring a resizable ArrayBuffer\n\n```js\nconst buffer = new ArrayBuffer(8, { maxByteLength: 16 });\nconst view = new Uint8Array(buffer);\nview[1] = 2;\nview[7] = 4;\n\n// Copy the buffer to a smaller size\nconst buffer2 = buffer.transfer(4);\nconsole.log(buffer2.byteLength); // 4\nconsole.log(buffer2.maxByteLength); // 16\nconst view2 = new Uint8Array(buffer2);\nconsole.log(view2[1]); // 2\nconsole.log(view2[7]); // undefined\nbuffer2.resize(8);\nconsole.log(view2[7]); // 0\n\n// Copy the buffer to a larger size within maxByteLength\nconst buffer3 = buffer2.transfer(12);\nconsole.log(buffer3.byteLength); // 12\n\n// Copy the buffer to a larger size than maxByteLength\nbuffer3.transfer(20); // RangeError: Invalid array buffer length\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `ArrayBuffer.prototype.transfer()` in `core-js`](https://github.com/zloirock/core-js#arraybufferprototypetransfer-and-friends)\n- {{jsxref("ArrayBuffer")}}\n- {{jsxref("ArrayBuffer.prototype.detached")}}\n- {{jsxref("ArrayBuffer.prototype.transferToFixedLength()")}}\n'
        },
        "transfertofixedlength": {
            "index.md": '---\ntitle: ArrayBuffer.prototype.transferToFixedLength()\nslug: Web/JavaScript/Reference/Global_Objects/ArrayBuffer/transferToFixedLength\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.ArrayBuffer.transferToFixedLength\n---\n\n{{JSRef}}\n\nThe **`transferToFixedLength()`** method of {{jsxref("ArrayBuffer")}} instances creates a new non-resizable `ArrayBuffer` with the same byte content as this buffer, then detaches this buffer.\n\n## Syntax\n\n```js-nolint\ntransferToFixedLength()\ntransferToFixedLength(newByteLength)\n```\n\n### Parameters\n\n- `newByteLength`\n  - : The {{jsxref("ArrayBuffer/byteLength", "byteLength")}} of the new `ArrayBuffer`. Defaults to the `byteLength` of this `ArrayBuffer`.\n    - If `newByteLength` is smaller than the `byteLength` of this `ArrayBuffer`, the "overflowing" bytes are dropped.\n    - If `newByteLength` is larger than the `byteLength` of this `ArrayBuffer`, the extra bytes are filled with zeros.\n\n### Return value\n\nA new {{jsxref("ArrayBuffer")}} object. Its contents are initialized to the contents of this `ArrayBuffer`, and extra bytes, if any, are filled with zeros. The new `ArrayBuffer` is always non-resizable. The original `ArrayBuffer` is detached.\n\n### Exceptions\n\n- {{jsxref("TypeError")}}\n  - : Thrown if this `ArrayBuffer` is already detached.\n\n## Description\n\nUnlike {{jsxref("ArrayBuffer/transfer", "transfer()")}}, `transferToFixedLength()` always creates a non-resizable `ArrayBuffer`. This means `newByteLength` can be larger than the `maxByteLength`, even if this `ArrayBuffer` is resizable. See [transferring ArrayBuffers](/en-US/docs/Web/JavaScript/Reference/Global_Objects/ArrayBuffer#transferring_arraybuffers) for more information.\n\n## Examples\n\n### Transferring a resizable ArrayBuffer to fixed-length\n\n```js\nconst buffer = new ArrayBuffer(8, { maxByteLength: 16 });\nconst view = new Uint8Array(buffer);\nview[1] = 2;\nview[7] = 4;\n\nconst buffer2 = buffer.transferToFixedLength();\nconsole.log(buffer2.byteLength); // 8\nconsole.log(buffer2.resizable); // false\nconst view2 = new Uint8Array(buffer2);\nconsole.log(view2[1]); // 2\nconsole.log(view2[7]); // 4\n```\n\nUsing `transferToFixedLength`, `newByteLength` can be larger than the `maxByteLength` of the original `ArrayBuffer`.\n\n```js\nconst buffer = new ArrayBuffer(8, { maxByteLength: 16 });\nconst view = new Uint8Array(buffer);\nview[1] = 2;\nview[7] = 4;\n\nconst buffer2 = buffer.transferToFixedLength(20);\nconsole.log(buffer2.byteLength); // 20\nconsole.log(buffer2.resizable); // false\nconst view2 = new Uint8Array(buffer2);\nconsole.log(view2[1]); // 2\nconsole.log(view2[7]); // 4\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `ArrayBuffer.prototype.transferToFixedLength()` in `core-js`](https://github.com/zloirock/core-js#arraybufferprototypetransfer-and-friends)\n- {{jsxref("ArrayBuffer")}}\n- {{jsxref("ArrayBuffer.prototype.detached")}}\n- {{jsxref("ArrayBuffer.prototype.transfer()")}}\n'
        }
    },
    "asyncfunction": {
        "asyncfunction": {
            "index.md": '---\ntitle: AsyncFunction() constructor\nslug: Web/JavaScript/Reference/Global_Objects/AsyncFunction/AsyncFunction\npage-type: javascript-constructor\nbrowser-compat: javascript.builtins.AsyncFunction.AsyncFunction\n---\n\n{{JSRef}}\n\nThe **`AsyncFunction()`** constructor creates {{jsxref("AsyncFunction")}} objects.\n\nNote that `AsyncFunction` is _not_ a global object. It can be obtained with the following code:\n\n```js\nconst AsyncFunction = async function () {}.constructor;\n```\n\nThe `AsyncFunction()` constructor is not intended to be used directly, and all caveats mentioned in the {{jsxref("Function/Function", "Function()")}} description apply to `AsyncFunction()`.\n\n## Syntax\n\n```js-nolint\nnew AsyncFunction(functionBody)\nnew AsyncFunction(arg1, functionBody)\nnew AsyncFunction(arg1, arg2, functionBody)\nnew AsyncFunction(arg1, arg2, /* \u2026, */ argN, functionBody)\n\nAsyncFunction(functionBody)\nAsyncFunction(arg1, functionBody)\nAsyncFunction(arg1, arg2, functionBody)\nAsyncFunction(arg1, arg2, /* \u2026, */ argN, functionBody)\n```\n\n> **Note:** `AsyncFunction()` can be called with or without [`new`](/en-US/docs/Web/JavaScript/Reference/Operators/new). Both create a new `AsyncFunction` instance.\n\n### Parameters\n\nSee {{jsxref("Function/Function", "Function()")}}.\n\n## Examples\n\n### Creating an async function from an AsyncFunction() constructor\n\n```js\nfunction resolveAfter2Seconds(x) {\n  return new Promise((resolve) => {\n    setTimeout(() => {\n      resolve(x);\n    }, 2000);\n  });\n}\n\nconst AsyncFunction = async function () {}.constructor;\n\nconst fn = new AsyncFunction(\n  "a",\n  "b",\n  "return await resolveAfter2Seconds(a) + await resolveAfter2Seconds(b);",\n);\n\nfn(10, 20).then((v) => {\n  console.log(v); // prints 30 after 4 seconds\n});\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [`async function`](/en-US/docs/Web/JavaScript/Reference/Statements/async_function)\n- [`async function` expression](/en-US/docs/Web/JavaScript/Reference/Operators/async_function)\n- [`Function()` constructor](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/Function)\n'
        },
        "index.md": '---\ntitle: AsyncFunction\nslug: Web/JavaScript/Reference/Global_Objects/AsyncFunction\npage-type: javascript-class\nbrowser-compat: javascript.builtins.AsyncFunction\n---\n\n{{JSRef}}\n\nThe **`AsyncFunction`** object provides methods for [async functions](/en-US/docs/Web/JavaScript/Reference/Statements/async_function). In JavaScript, every async function is actually an `AsyncFunction` object.\n\nNote that `AsyncFunction` is _not_ a global object. It can be obtained with the following code:\n\n```js\nconst AsyncFunction = async function () {}.constructor;\n```\n\n`AsyncFunction` is a subclass of {{jsxref("Function")}}.\n\n## Constructor\n\n- {{jsxref("AsyncFunction/AsyncFunction", "AsyncFunction()")}}\n  - : Creates a new `AsyncFunction` object.\n\n## Instance properties\n\n_Also inherits instance properties from its parent {{jsxref("Function")}}_.\n\nThese properties are defined on `AsyncFunction.prototype` and shared by all `AsyncFunction` instances.\n\n- {{jsxref("Object/constructor", "AsyncFunction.prototype.constructor")}}\n  - : The constructor function that created the instance object. For `AsyncFunction` instances, the initial value is the {{jsxref("AsyncFunction/AsyncFunction", "AsyncFunction")}} constructor.\n- `AsyncFunction.prototype[@@toStringTag]`\n  - : The initial value of the [`@@toStringTag`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol/toStringTag) property is the string `"AsyncFunction"`. This property is used in {{jsxref("Object.prototype.toString()")}}.\n\n> **Note:** `AsyncFunction` instances do not have the [`prototype`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/prototype) property.\n\n## Instance methods\n\n_Inherits instance methods from its parent {{jsxref("Function")}}_.\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [`async function`](/en-US/docs/Web/JavaScript/Reference/Statements/async_function)\n- [`async function` expression](/en-US/docs/Web/JavaScript/Reference/Operators/async_function)\n- {{jsxref("Function")}}\n- {{jsxref("AsyncGeneratorFunction")}}\n- {{jsxref("GeneratorFunction")}}\n- {{jsxref("Functions", "Functions", "", 1)}}\n'
    },
    "asyncgenerator": {
        "index.md": '---\ntitle: AsyncGenerator\nslug: Web/JavaScript/Reference/Global_Objects/AsyncGenerator\npage-type: javascript-class\nbrowser-compat: javascript.builtins.AsyncGenerator\n---\n\n{{JSRef}}\n\nThe **`AsyncGenerator`** object is returned by an {{jsxref("Statements/async_function*", "async generator function", "", 1)}} and it conforms to both the [async iterable protocol and the async iterator protocol](/en-US/docs/Web/JavaScript/Reference/Iteration_protocols#the_async_iterator_and_async_iterable_protocols).\n\nAsync generator methods always yield {{jsxref("Promise")}} objects.\n\n`AsyncGenerator` is a subclass of the hidden {{jsxref("AsyncIterator")}} class.\n\n{{EmbedInteractiveExample("pages/js/expressions-async-function-asterisk.html", "taller")}}\n\n## Constructor\n\nThe `AsyncGenerator` constructor is not available globally. Instances of `AsyncGenerator` must be returned from [async generator functions](/en-US/docs/Web/JavaScript/Reference/Statements/async_function*)\n\n```js\nasync function* createAsyncGenerator() {\n  yield await Promise.resolve(1);\n  yield await Promise.resolve(2);\n  yield await Promise.resolve(3);\n}\nconst asyncGen = createAsyncGenerator();\nasyncGen.next().then((res) => console.log(res.value)); // 1\nasyncGen.next().then((res) => console.log(res.value)); // 2\nasyncGen.next().then((res) => console.log(res.value)); // 3\n```\n\nIn fact, there\'s no JavaScript entity that corresponds to the `AsyncGenerator` constructor. There\'s only a hidden object which is the prototype object shared by all objects created by async generator functions. This object is often stylized as `AsyncGenerator.prototype` to make it look like a class, but it should be more appropriately called [`AsyncGeneratorFunction.prototype.prototype`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/AsyncGeneratorFunction), because `AsyncGeneratorFunction` is an actual JavaScript entity.\n\n## Instance properties\n\nThese properties are defined on `AsyncGenerator.prototype` and shared by all `AsyncGenerator` instances.\n\n- {{jsxref("Object/constructor", "AsyncGenerator.prototype.constructor")}}\n\n  - : The constructor function that created the instance object. For `AsyncGenerator` instances, the initial value is [`AsyncGeneratorFunction.prototype`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/AsyncGeneratorFunction).\n\n    > **Note:** `AsyncGenerator` objects do not store a reference to the async generator function that created them.\n\n- `AsyncGenerator.prototype[@@toStringTag]`\n  - : The initial value of the [`@@toStringTag`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol/toStringTag) property is the string `"AsyncGenerator"`. This property is used in {{jsxref("Object.prototype.toString()")}}.\n\n## Instance methods\n\n_Also inherits instance methods from its parent {{jsxref("AsyncIterator")}}_.\n\n- {{jsxref("AsyncGenerator.prototype.next()")}}\n  - : Returns a {{jsxref("Promise")}} which will be resolved with the given value yielded by the {{jsxref("Operators/yield", "yield")}} expression.\n- {{jsxref("AsyncGenerator.prototype.return()")}}\n  - : Acts as if a `return` statement is inserted in the generator\'s body at the current suspended position, which finishes the generator and allows the generator to perform any cleanup tasks when combined with a [`try...finally`](/en-US/docs/Web/JavaScript/Reference/Statements/try...catch#the_finally_block) block.\n- {{jsxref("AsyncGenerator.prototype.throw()")}}\n  - : Acts as if a `throw` statement is inserted in the generator\'s body at the current suspended position, which informs the generator of an error condition and allows it to handle the error, or perform cleanup and close itself.\n\n## Examples\n\n### Async generator iteration\n\nThe following example iterates over an async generator, logging values 1\u20136 to the console at decreasing time intervals. Notice how each time a Promise is yielded, but it\'s automatically resolved within the `for await...of` loop.\n\n```js\n// An async task. Pretend it\'s doing something more useful\n// in practice.\nfunction delayedValue(time, value) {\n  return new Promise((resolve /*, reject*/) => {\n    setTimeout(() => resolve(value), time);\n  });\n}\n\nasync function* generate() {\n  yield delayedValue(2000, 1);\n  yield delayedValue(100, 2);\n  yield delayedValue(500, 3);\n  yield delayedValue(250, 4);\n  yield delayedValue(125, 5);\n  yield delayedValue(50, 6);\n  console.log("All done!");\n}\n\nasync function main() {\n  for await (const value of generate()) {\n    console.log("value", value);\n  }\n}\n\nmain().catch((e) => console.error(e));\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Statements/function*", "function*", "", 1)}}\n- {{jsxref("Statements/async_function*", "async function*", "", 1)}}\n- [`function*` expression](/en-US/docs/Web/JavaScript/Reference/Operators/function*)\n- {{jsxref("GeneratorFunction", "Generator Function", "", 1)}}\n- {{jsxref("AsyncGeneratorFunction", "Async Generator Function", "", 1)}}\n- [Iterators and generators](/en-US/docs/Web/JavaScript/Guide/Iterators_and_generators) guide\n',
        "next": {
            "index.md": '---\ntitle: AsyncGenerator.prototype.next()\nslug: Web/JavaScript/Reference/Global_Objects/AsyncGenerator/next\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.AsyncGenerator.next\n---\n\n{{JSRef}}\n\nThe **`next()`** method of {{jsxref("AsyncGenerator")}} instances returns the next value in the sequence.\n\n## Syntax\n\n```js-nolint\nnext()\nnext(value)\n```\n\n### Parameters\n\n- `value` {{optional_inline}}\n  - : An optional value used to modify the internal state of the generator. A value passed to the `next()` method will be received by `yield`\n\n### Return value\n\nA {{jsxref("Promise")}} which when resolved returns an {{jsxref("Object")}} with two properties:\n\n- `done`\n  - : A boolean value:\n    - `true` if the generator is past the end of its control flow. In this case `value` specifies the _return value_ of the generator (which may be undefined).\n    - `false` if the generator is able to produce more values.\n- `value`\n  - : Any JavaScript value yielded or returned by the generator.\n\n## Examples\n\n### Using next()\n\nThe following example shows a simple generator and the object that the `next` method returns:\n\n```js\n// An async task. Pretend it\'s doing something more useful\n// in practice.\nfunction delayedValue(time, value) {\n  return new Promise((resolve, reject) => {\n    setTimeout(() => resolve(value), time);\n  });\n}\n\nasync function* createAsyncGenerator() {\n  yield delayedValue(500, 1);\n  yield delayedValue(500, 2);\n  yield delayedValue(500, 3);\n}\n\nconst asyncGen = createAsyncGenerator();\nasyncGen.next().then((res) => console.log(res)); // { value: 1, done: false }\nasyncGen.next().then((res) => console.log(res)); // { value: 2, done: false }\nasyncGen.next().then((res) => console.log(res)); // { value: 3, done: false }\nasyncGen.next().then((res) => console.log(res)); // { value: undefined, done: true }\n```\n\n### Sending values to the generator\n\nIn this example, `next` is called with a value.\n\n> **Note:** The first call does not log anything, because the generator was not yielding anything initially.\n\n```js\n// An async task. Pretend it\'s doing something more useful\n// in practice.\nfunction sleep(time) {\n  return new Promise((resolve, reject) => {\n    setTimeout(resolve, time);\n  });\n}\n\nasync function* createAsyncGenerator() {\n  while (true) {\n    await sleep(500);\n    const value = yield;\n    console.log(value);\n  }\n}\n\nasync function main() {\n  const asyncGen = createAsyncGenerator();\n  // No log at this step: the first value sent through `next` is lost\n  console.log(await asyncGen.next(1)); // { value: undefined, done: false }\n  // Logs 2: the value sent through `next`\n  console.log(await asyncGen.next(2)); // { value: undefined, done: false }\n}\n\nmain();\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Statements/async_function*", "async function*")}}\n- [Iterators and generators](/en-US/docs/Web/JavaScript/Guide/Iterators_and_generators) guide\n'
        },
        "return": {
            "index.md": '---\ntitle: AsyncGenerator.prototype.return()\nslug: Web/JavaScript/Reference/Global_Objects/AsyncGenerator/return\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.AsyncGenerator.return\n---\n\n{{JSRef}}\n\nThe **`return()`** method of {{jsxref("AsyncGenerator")}} instances acts as if a `return` statement is inserted in the generator\'s body at the current suspended position, which finishes the generator and allows the generator to perform any cleanup tasks when combined with a [`try...finally`](/en-US/docs/Web/JavaScript/Reference/Statements/try...catch#the_finally_block) block.\n\n## Syntax\n\n```js-nolint\nasyncGeneratorInstance.return()\nasyncGeneratorInstance.return(value)\n```\n\n### Parameters\n\n- `value` {{optional_inline}}\n  - : The value to return.\n\n### Return value\n\nA {{jsxref("Promise")}} which resolves with an {{jsxref("Object")}} with two properties:\n\n- `done`\n  - : A boolean value:\n    - `true` if the generator function\'s control flow has reached the end.\n    - `false` if the generator function\'s control flow hasn\'t reached the end and can produce more values. This can only happen if the `return` is captured in a [`try...finally`](/en-US/docs/Web/JavaScript/Reference/Statements/try...catch#the_finally_block) and there are more `yield` expressions in the `finally` block.\n- `value`\n  - : The value that is given as an argument, or, if the `yield` expression is wrapped in a [`try...finally`](/en-US/docs/Web/JavaScript/Reference/Statements/try...catch#the_finally_block), the value yielded/returned from the `finally` block.\n\n## Description\n\nThe `return()` method, when called, can be seen as if a `return value;` statement is inserted in the generator\'s body at the current suspended position, where `value` is the value passed to the `return()` method. Therefore, in a typical flow, calling `return(value)` will return `{ done: true, value: value }`. However, if the `yield` expression is wrapped in a `try...finally` block, the control flow doesn\'t exit the function body, but proceeds to the `finally` block instead. In this case, the value returned may be different, and `done` may even be `false`, if there are more `yield` expressions within the `finally` block.\n\n## Examples\n\n### Using return()\n\nThe following example shows a simple async generator and the `return` method.\n\n```js\n// An async task. Pretend it\'s doing something more useful\n// in practice.\nfunction delayedValue(time, value) {\n  return new Promise((resolve, reject) => {\n    setTimeout(() => resolve(value), time);\n  });\n}\n\nasync function* createAsyncGenerator() {\n  yield delayedValue(500, 1);\n  yield delayedValue(500, 2);\n  yield delayedValue(500, 3);\n}\n\nconst asyncGen = createAsyncGenerator();\nasyncGen.next().then((res) => console.log(res)); // { value: 1, done: false }\nasyncGen.return("foo").then((res) => console.log(res)); // { value: "foo", done: true }\nasyncGen.next().then((res) => console.log(res)); // { value: undefined, done: true }\n```\n\n### Using return() once a generator is complete\n\nIf no `value` argument is passed into the `return()` method, the promise will resolve as if the [next()](/en-US/docs/Web/JavaScript/Reference/Global_Objects/AsyncGenerator/next) method has been called. In this example the generator has completed, so the value returned is `undefined`.\n\n`return()` can still be called after the generator is in a "completed" state, however the generator will stay in this state.\n\n```js\nasync function* createAsyncGenerator() {\n  yield await Promise.resolve(1);\n  yield await Promise.resolve(2);\n  yield await Promise.resolve(3);\n}\nconst asyncGen = createAsyncGenerator();\nasyncGen.next().then((res) => console.log(res)); // { value: 1, done: false }\nasyncGen.next().then((res) => console.log(res)); // { value: 2, done: false }\nasyncGen.next().then((res) => console.log(res)); // { value: 3, done: false }\n// value is returned undefined, as no value is passed and generator is \'done\'\nasyncGen.return().then((res) => console.log(res)); // { value: undefined, done: true }\n// we can still return a value once the generator is complete\nasyncGen.return(1).then((res) => console.log(res)); // { value: 1, done: true }\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Statements/async_function*", "async function*")}}\n- [Iterators and generators](/en-US/docs/Web/JavaScript/Guide/Iterators_and_generators) guide\n'
        },
        "throw": {
            "index.md": '---\ntitle: AsyncGenerator.prototype.throw()\nslug: Web/JavaScript/Reference/Global_Objects/AsyncGenerator/throw\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.AsyncGenerator.throw\n---\n\n{{JSRef}}\n\nThe **`throw()`** method of {{jsxref("AsyncGenerator")}} instances acts as if a `throw` statement is inserted in the generator\'s body at the current suspended position, which informs the generator of an error condition and allows it to handle the error, or perform cleanup and close itself.\n\n## Syntax\n\n```js-nolint\nasyncGeneratorInstance.throw(exception)\n```\n\n### Parameters\n\n- `exception`\n  - : The exception to throw. For debugging purposes, it is useful to make it an `instanceof` {{jsxref("Error")}}.\n\n### Return value\n\nIf the thrown error is not caught, it will return a {{jsxref("Promise")}} which rejects with the exception passed in.\n\nIf the exception is caught by a [`try...catch`](/en-US/docs/Web/JavaScript/Reference/Statements/try...catch) and the generator resumes to yield more values, it will return a {{jsxref("Promise")}} which resolves with an {{jsxref("Object")}} with two properties:\n\n- `done`\n  - : A boolean value:\n    - `true` if the generator function\'s control flow has reached the end.\n    - `false` if the generator function is able to produce more values.\n- `value`\n  - : The value yielded from the next `yield` expression.\n\n## Examples\n\n### Using throw()\n\nThe following example shows a simple generator and an error that is thrown using the `throw` method. An error can be caught by a {{jsxref("Statements/try...catch", "try...catch")}} block as usual.\n\n```js\n// An async task. Pretend it\'s doing something more useful\n// in practice.\nfunction sleep(time) {\n  return new Promise((resolve, reject) => {\n    setTimeout(resolve, time);\n  });\n}\n\nasync function* createAsyncGenerator() {\n  while (true) {\n    try {\n      await sleep(500);\n      yield 42;\n    } catch (e) {\n      console.error(e);\n    }\n  }\n}\n\nconst asyncGen = createAsyncGenerator();\nasyncGen.next(1).then((res) => console.log(res)); // { value: 42, done: false }\nasyncGen\n  .throw(new Error("Something went wrong")) // Error: Something went wrong\n  .then((res) => console.log(res)); // { value: 42, done: false }\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Statements/async_function*", "async function*")}}\n- [Iterators and generators](/en-US/docs/Web/JavaScript/Guide/Iterators_and_generators) guide\n'
        }
    },
    "asyncgeneratorfunction": {
        "asyncgeneratorfunction": {
            "index.md": '---\ntitle: AsyncGeneratorFunction() constructor\nslug: Web/JavaScript/Reference/Global_Objects/AsyncGeneratorFunction/AsyncGeneratorFunction\npage-type: javascript-constructor\nbrowser-compat: javascript.builtins.AsyncGeneratorFunction.AsyncGeneratorFunction\n---\n\n{{JSRef}}\n\nThe **`AsyncGeneratorFunction()`** constructor creates {{jsxref("AsyncGeneratorFunction")}} objects.\n\nNote that `AsyncGeneratorFunction` is not a global object. It could be obtained by evaluating the following code.\n\n```js\nconst AsyncGeneratorFunction = async function* () {}.constructor;\n```\n\nThe `AsyncGeneratorFunction()` constructor is not intended to be used directly, and all caveats mentioned in the {{jsxref("Function/Function", "Function()")}} description apply to `AsyncGeneratorFunction()`.\n\n## Syntax\n\n```js-nolint\nnew AsyncGeneratorFunction(functionBody)\nnew AsyncGeneratorFunction(arg1, functionBody)\nnew AsyncGeneratorFunction(arg1, arg2, functionBody)\nnew AsyncGeneratorFunction(arg1, arg2, /* \u2026, */ argN, functionBody)\n\nAsyncGeneratorFunction(functionBody)\nAsyncGeneratorFunction(arg1, functionBody)\nAsyncGeneratorFunction(arg1, arg2, functionBody)\nAsyncGeneratorFunction(arg1, arg2, /* \u2026, */ argN, functionBody)\n```\n\n> **Note:** `AsyncGeneratorFunction()` can be called with or without [`new`](/en-US/docs/Web/JavaScript/Reference/Operators/new). Both create a new `AsyncGeneratorFunction` instance.\n\n### Parameters\n\nSee {{jsxref("Function/Function", "Function()")}}.\n\n## Examples\n\n### Using the constructor\n\nThe following example uses the `AsyncGeneratorFunction` constructor to create an async generator function.\n\n```js\nconst AsyncGeneratorFunction = async function* () {}.constructor;\nconst createAsyncGenerator = new AsyncGeneratorFunction("a", "yield a * 2");\nconst asyncGen = createAsyncGenerator(10);\nasyncGen.next().then((res) => console.log(res.value)); // 20\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [`async function*`](/en-US/docs/Web/JavaScript/Reference/Statements/async_function*)\n- [`async function*` expression](/en-US/docs/Web/JavaScript/Reference/Operators/async_function*)\n- [`Function()` constructor](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/Function)\n- [Iterators and generators](/en-US/docs/Web/JavaScript/Guide/Iterators_and_generators) guide\n- {{jsxref("Functions", "Functions", "", 1)}}\n'
        },
        "index.md": '---\ntitle: AsyncGeneratorFunction\nslug: Web/JavaScript/Reference/Global_Objects/AsyncGeneratorFunction\npage-type: javascript-class\nbrowser-compat: javascript.builtins.AsyncGeneratorFunction\n---\n\n{{JSRef}}\n\nThe **`AsyncGeneratorFunction`** object provides methods for [async generator functions](/en-US/docs/Web/JavaScript/Reference/Statements/async_function*). In JavaScript, every async generator function is actually an `AsyncGeneratorFunction` object.\n\nNote that `AsyncGeneratorFunction` is _not_ a global object. It can be obtained with the following code:\n\n```js\nconst AsyncGeneratorFunction = async function* () {}.constructor;\n```\n\n`AsyncGeneratorFunction` is a subclass of {{jsxref("Function")}}.\n\n{{EmbedInteractiveExample("pages/js/async-functionasterisk-function.html", "taller")}}\n\n## Constructor\n\n- {{jsxref("AsyncGeneratorFunction/AsyncGeneratorFunction", "AsyncGeneratorFunction()")}}\n  - : Creates a new `AsyncGeneratorFunction` object.\n\n## Instance properties\n\n_Also inherits instance properties from its parent {{jsxref("Function")}}_.\n\nThese properties are defined on `AsyncGeneratorFunction.prototype` and shared by all `AsyncGeneratorFunction` instances.\n\n- {{jsxref("Object/constructor", "AsyncGeneratorFunction.prototype.constructor")}}\n  - : The constructor function that created the instance object. For `AsyncGeneratorFunction` instances, the initial value is the {{jsxref("AsyncGeneratorFunction/AsyncGeneratorFunction", "AsyncGeneratorFunction")}} constructor.\n- `AsyncGeneratorFunction.prototype.prototype`\n  - : All async generator functions share the same [`prototype`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/prototype) property, which is [`AsyncGenerator.prototype`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/AsyncGenerator). Each async generator function instance also has its own `prototype` property. When the async generator function is called, the returned async generator object inherits from the async generator function\'s `prototype` property, which in turn inherits from `AsyncGeneratorFunction.prototype.prototype`.\n- `AsyncGeneratorFunction.prototype[@@toStringTag]`\n  - : The initial value of the [`@@toStringTag`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol/toStringTag) property is the string `"AsyncGeneratorFunction"`. This property is used in {{jsxref("Object.prototype.toString()")}}.\n\n## Instance methods\n\n_Inherits instance methods from its parent {{jsxref("Function")}}_.\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [`async function*`](/en-US/docs/Web/JavaScript/Reference/Statements/async_function*)\n- [`async function*` expression](/en-US/docs/Web/JavaScript/Reference/Operators/async_function*)\n- {{jsxref("Function")}}\n- {{jsxref("AsyncFunction")}}\n- {{jsxref("GeneratorFunction")}}\n- {{jsxref("Functions", "Functions", "", 1)}}\n'
    },
    "asynciterator": {
        "@@asynciterator": {
            "index.md": '---\ntitle: AsyncIterator.prototype[@@asyncIterator]()\nslug: Web/JavaScript/Reference/Global_Objects/AsyncIterator/@@asyncIterator\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.AsyncIterator.@@asyncIterator\n---\n\n{{JSRef}}\n\nThe **`[@@asyncIterator]()`** method of {{jsxref("AsyncIterator")}} instances implements the [async iterable protocol](/en-US/docs/Web/JavaScript/Reference/Iteration_protocols#the_async_iterator_and_async_iterable_protocols) and allows built-in async iterators to be consumed by most syntaxes expecting async iterables, such as [`for await...of`](/en-US/docs/Web/JavaScript/Reference/Statements/for-await...of) loops. It returns the value of [`this`](/en-US/docs/Web/JavaScript/Reference/Operators/this), which is the async iterator object itself.\n\n{{EmbedInteractiveExample("pages/js/map-prototype-@@iterator.html")}}\n\n## Syntax\n\n```js-nolint\nasyncIterator[Symbol.asyncIterator]()\n```\n\n### Parameters\n\nNone.\n\n### Return value\n\nThe value of [`this`](/en-US/docs/Web/JavaScript/Reference/Operators/this), which is the async iterator object itself.\n\n## Examples\n\n### Iteration using for await...of loop\n\nNote that you seldom need to call this method directly. The existence of the `@@asyncIterator` method makes all built-in async iterators [async iterable](/en-US/docs/Web/JavaScript/Reference/Iteration_protocols#the_async_iterator_and_async_iterable_protocols), and iterating syntaxes like the `for await...of` loop automatically calls this method to obtain the async iterator to loop over.\n\n```js\nconst asyncIterator = (async function* () {\n  yield 1;\n  yield 2;\n  yield 3;\n})();\n(async () => {\n  for await (const value of asyncIterator) {\n    console.log(value);\n  }\n})();\n// Logs: 1, 2, 3\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [`for await...of`](/en-US/docs/Web/JavaScript/Reference/Statements/for-await...of)\n'
        },
        "index.md": '---\ntitle: AsyncIterator\nslug: Web/JavaScript/Reference/Global_Objects/AsyncIterator\npage-type: javascript-class\nbrowser-compat: javascript.builtins.AsyncIterator\n---\n\n{{JSRef}}\n\nAn **`AsyncIterator`** object is an object that conforms to the [async iterator protocol](/en-US/docs/Web/JavaScript/Reference/Iteration_protocols#the_async_iterator_and_async_iterable_protocols) by providing a `next()` method that returns a promise fulfilling to an iterator result object. The `AsyncIterator.prototype` object is a hidden global object that all built-in async iterators inherit from. It provides an [`@@asyncIterator`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/AsyncIterator/@@asyncIterator) method that returns the async iterator object itself, making the async iterator also [async iterable](/en-US/docs/Web/JavaScript/Reference/Iteration_protocols#the_async_iterator_and_async_iterable_protocols).\n\nNote that `AsyncIterator` is _not_ a global object, although it will be in the future with the [async iterator helpers proposal](https://github.com/tc39/proposal-async-iterator-helpers). The `AsyncIterator.prototype` object shared by all built-in async iterators can be obtained with the following code:\n\n```js\nconst AsyncIteratorPrototype = Object.getPrototypeOf(\n  Object.getPrototypeOf(Object.getPrototypeOf((async function* () {})())),\n);\n```\n\n## Description\n\nCurrently, the only built-in JavaScript async iterator is the {{jsxref("AsyncGenerator")}} object returned by [async generator functions](/en-US/docs/Web/JavaScript/Reference/Statements/async_function*). There are some other built-in async iterators in web API, such as the one of a {{domxref("ReadableStream")}}.\n\nEach of these async iterators have a distinct prototype object, which defines the `next()` method used by the particular async iterator. All of these prototype objects inherit from `AsyncIterator.prototype`, which provides am [`@@asyncIterator`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol/asyncIterator) method that returns the async iterator object itself, making the async iterator also [async iterable](/en-US/docs/Web/JavaScript/Reference/Iteration_protocols#the_async_iterator_and_async_iterable_protocols).\n\n> **Note:** `AsyncIterator.prototype` does not implement [`@@iterator`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol/iterator), so async iterators are not [sync iterable](/en-US/docs/Web/JavaScript/Reference/Iteration_protocols#the_iterable_protocol) by default.\n\n## Instance methods\n\n- [`AsyncIterator.prototype[@@asyncIterator]()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/AsyncIterator/@@asyncIterator)\n  - : Returns the async iterator object itself. This allows async iterator objects to also be async iterable.\n\n## Examples\n\n### Using an async iterator as an async iterable\n\nAll built-in async iterators are also async iterable, so you can use them in a `for await...of` loop:\n\n```js\nconst asyncIterator = (async function* () {\n  yield 1;\n  yield 2;\n  yield 3;\n})();\n(async () => {\n  for await (const value of asyncIterator) {\n    console.log(value);\n  }\n})();\n// Logs: 1, 2, 3\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Statements/async_function*", "async function*")}}\n- [Iteration protocols](/en-US/docs/Web/JavaScript/Reference/Iteration_protocols)\n'
    },
    "atomics": {
        "add": {
            "index.md": '---\ntitle: Atomics.add()\nslug: Web/JavaScript/Reference/Global_Objects/Atomics/add\npage-type: javascript-static-method\nbrowser-compat: javascript.builtins.Atomics.add\n---\n\n{{JSRef}}\n\nThe **`Atomics.add()`** static\nmethod adds a given value at a given position in the array and returns the old value at\nthat position. This atomic operation guarantees that no other write happens until the\nmodified value is written back.\n\n{{EmbedInteractiveExample("pages/js/atomics-add.html")}}\n\n## Syntax\n\n```js-nolint\nAtomics.add(typedArray, index, value)\n```\n\n### Parameters\n\n- `typedArray`\n  - : An integer typed array. One of {{jsxref("Int8Array")}}, {{jsxref("Uint8Array")}},\n    {{jsxref("Int16Array")}}, {{jsxref("Uint16Array")}}, {{jsxref("Int32Array")}},\n    {{jsxref("Uint32Array")}}, {{jsxref("BigInt64Array")}}, or\n    {{jsxref("BigUint64Array")}}.\n- `index`\n  - : The position in the `typedArray` to add a\n    `value` to.\n- `value`\n  - : The number to add.\n\n### Return value\n\nThe old value at the given position\n(`typedArray[index]`).\n\n### Exceptions\n\n- {{jsxref("TypeError")}}\n  - : Thrown if `typedArray` is not one of the allowed integer types.\n- {{jsxref("RangeError")}}\n  - : Thrown if `index` is out of bounds in the `typedArray`.\n\n## Examples\n\n### Using add()\n\n```js\nconst sab = new SharedArrayBuffer(1024);\nconst ta = new Uint8Array(sab);\n\nAtomics.add(ta, 0, 12); // returns 0, the old value\nAtomics.load(ta, 0); // 12\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Atomics")}}\n- {{jsxref("Atomics.sub()")}}\n'
        },
        "and": {
            "index.md": '---\ntitle: Atomics.and()\nslug: Web/JavaScript/Reference/Global_Objects/Atomics/and\npage-type: javascript-static-method\nbrowser-compat: javascript.builtins.Atomics.and\n---\n\n{{JSRef}}\n\nThe **`Atomics.and()`** static\nmethod computes a bitwise AND with a given value at a given position in the array, and\nreturns the old value at that position. This atomic operation guarantees that no other\nwrite happens until the modified value is written back.\n\n{{EmbedInteractiveExample("pages/js/atomics-and.html")}}\n\n## Syntax\n\n```js-nolint\nAtomics.and(typedArray, index, value)\n```\n\n### Parameters\n\n- `typedArray`\n  - : An integer typed array. One of {{jsxref("Int8Array")}}, {{jsxref("Uint8Array")}},\n    {{jsxref("Int16Array")}}, {{jsxref("Uint16Array")}}, {{jsxref("Int32Array")}},\n    {{jsxref("Uint32Array")}}, {{jsxref("BigInt64Array")}}, or\n    {{jsxref("BigUint64Array")}}.\n- `index`\n  - : The position in the `typedArray` to compute the bitwise AND.\n- `value`\n  - : The number to compute the bitwise AND with.\n\n### Return value\n\nThe old value at the given position\n(`typedArray[index]`).\n\n### Exceptions\n\n- {{jsxref("TypeError")}}\n  - : Thrown if `typedArray` is not one of the allowed integer types.\n- {{jsxref("RangeError")}}\n  - : Thrown if `index` is out of bounds in the `typedArray`.\n\n## Description\n\nThe bitwise AND operation only yields 1, if both `a` and `b` are\n1\\. The truth table for the AND operation is:\n\n| `a` | `b` | `a & b` |\n| --- | --- | ------- |\n| 0   | 0   | 0       |\n| 0   | 1   | 0       |\n| 1   | 0   | 0       |\n| 1   | 1   | 1       |\n\nFor example, a bitwise AND of `5 & 1` results in `0001` which\nis 1 in decimal.\n\n```plain\n5  0101\n1  0001\n   ----\n1  0001\n```\n\n## Examples\n\n### Using and()\n\n```js\nconst sab = new SharedArrayBuffer(1024);\nconst ta = new Uint8Array(sab);\nta[0] = 5;\n\nAtomics.and(ta, 0, 1); // returns 5, the old value\nAtomics.load(ta, 0); // 1\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Atomics")}}\n- {{jsxref("Atomics.or()")}}\n- {{jsxref("Atomics.xor()")}}\n'
        },
        "compareexchange": {
            "index.md": '---\ntitle: Atomics.compareExchange()\nslug: Web/JavaScript/Reference/Global_Objects/Atomics/compareExchange\npage-type: javascript-static-method\nbrowser-compat: javascript.builtins.Atomics.compareExchange\n---\n\n{{JSRef}}\n\nThe **`Atomics.compareExchange()`** static method exchanges a given replacement value at a given position in the array, if a given expected value equals the old value. It returns the old value at that position whether it was equal to the expected value or not. This atomic operation guarantees that no other write happens until the modified value is written back.\n\n{{EmbedInteractiveExample("pages/js/atomics-compareexchange.html")}}\n\n## Syntax\n\n```js-nolint\nAtomics.compareExchange(typedArray, index, expectedValue, replacementValue)\n```\n\n### Parameters\n\n- `typedArray`\n  - : An integer typed array. One of {{jsxref("Int8Array")}}, {{jsxref("Uint8Array")}}, {{jsxref("Int16Array")}}, {{jsxref("Uint16Array")}}, {{jsxref("Int32Array")}}, {{jsxref("Uint32Array")}}, {{jsxref("BigInt64Array")}}, or {{jsxref("BigUint64Array")}}.\n- `index`\n  - : The position in the `typedArray` to exchange a `replacementValue`.\n- `expectedValue`\n  - : The value to check for equality.\n- `replacementValue`\n  - : The number to exchange.\n\n### Return value\n\nThe old value at the given position (`typedArray[index]`).\n\n### Exceptions\n\n- {{jsxref("TypeError")}}\n  - : Thrown if `typedArray` is not one of the allowed integer types.\n- {{jsxref("RangeError")}}\n  - : Thrown if `index` is out of bounds in the `typedArray`.\n\n## Examples\n\n### Using compareExchange()\n\n```js\nconst sab = new SharedArrayBuffer(1024);\nconst ta = new Uint8Array(sab);\nta[0] = 7;\n\nAtomics.compareExchange(ta, 0, 7, 12); // returns 7, the old value\nAtomics.load(ta, 0); // 12\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Atomics")}}\n- {{jsxref("Atomics.exchange()")}}\n'
        },
        "exchange": {
            "index.md": '---\ntitle: Atomics.exchange()\nslug: Web/JavaScript/Reference/Global_Objects/Atomics/exchange\npage-type: javascript-static-method\nbrowser-compat: javascript.builtins.Atomics.exchange\n---\n\n{{JSRef}}\n\nThe **`Atomics.exchange()`** static method exchanges a given value at a given position in the array and returns the old value at that position. This atomic operation guarantees that no other write happens between the read of the old value and the write of the new value.\n\n{{EmbedInteractiveExample("pages/js/atomics-exchange.html")}}\n\n## Syntax\n\n```js-nolint\nAtomics.exchange(typedArray, index, value)\n```\n\n### Parameters\n\n- `typedArray`\n  - : An integer typed array. One of {{jsxref("Int8Array")}}, {{jsxref("Uint8Array")}}, {{jsxref("Int16Array")}}, {{jsxref("Uint16Array")}}, {{jsxref("Int32Array")}}, {{jsxref("Uint32Array")}}, {{jsxref("BigInt64Array")}}, or {{jsxref("BigUint64Array")}}.\n- `index`\n  - : The position in the `typedArray` to exchange a `value`.\n- `value`\n  - : The number to exchange.\n\n### Return value\n\nThe old value at the given position (`typedArray[index]`).\n\n### Exceptions\n\n- {{jsxref("TypeError")}}\n  - : Thrown if `typedArray` is not one of the allowed integer types.\n- {{jsxref("RangeError")}}\n  - : Thrown if `index` is out of bounds in the `typedArray`.\n\n## Examples\n\n### Using exchange()\n\n```js\nconst sab = new SharedArrayBuffer(1024);\nconst ta = new Uint8Array(sab);\n\nAtomics.exchange(ta, 0, 12); // returns 0, the old value\nAtomics.load(ta, 0); // 12\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Atomics")}}\n- {{jsxref("Atomics.compareExchange()")}}\n'
        },
        "index.md": '---\ntitle: Atomics\nslug: Web/JavaScript/Reference/Global_Objects/Atomics\npage-type: javascript-namespace\nbrowser-compat: javascript.builtins.Atomics\n---\n\n{{JSRef}}\n\nThe **`Atomics`** namespace object contains static methods for carrying out atomic operations. They are used with {{jsxref("SharedArrayBuffer")}} and {{jsxref("ArrayBuffer")}} objects.\n\n## Description\n\nUnlike most global objects, `Atomics` is not a constructor. You cannot use it with the [`new` operator](/en-US/docs/Web/JavaScript/Reference/Operators/new) or invoke the `Atomics` object as a function. All properties and methods of `Atomics` are static (just like the {{jsxref("Math")}} object).\n\n### Atomic operations\n\nWhen memory is shared, multiple threads can read and write the same data in memory. Atomic operations make sure that predictable values are written and read, that operations are finished before the next operation starts and that operations are not interrupted.\n\n### Wait and notify\n\nThe `wait()` and `notify()` methods are modeled on Linux futexes ("fast user-space mutex") and provide ways for waiting until a certain condition becomes true and are typically used as blocking constructs.\n\n## Static properties\n\n- `Atomics[@@toStringTag]`\n  - : The initial value of the [`@@toStringTag`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol/toStringTag) property is the string `"Atomics"`. This property is used in {{jsxref("Object.prototype.toString()")}}.\n\n## Static methods\n\n- {{jsxref("Atomics.add()")}}\n  - : Adds the provided value to the existing value at the specified index of the array. Returns the old value at that index.\n- {{jsxref("Atomics.and()")}}\n  - : Computes a bitwise AND on the value at the specified index of the array with the provided value. Returns the old value at that index.\n- {{jsxref("Atomics.compareExchange()")}}\n  - : Stores a value at the specified index of the array, if it equals a value. Returns the old value.\n- {{jsxref("Atomics.exchange()")}}\n  - : Stores a value at the specified index of the array. Returns the old value.\n- {{jsxref("Atomics.isLockFree()")}}\n  - : An optimization primitive that can be used to determine whether to use locks or atomic operations. Returns `true` if an atomic operation on arrays of the given element size will be implemented using a hardware atomic operation (as opposed to a lock). Experts only.\n- {{jsxref("Atomics.load()")}}\n  - : Returns the value at the specified index of the array.\n- {{jsxref("Atomics.notify()")}}\n  - : Notifies agents that are waiting on the specified index of the array. Returns the number of agents that were notified.\n- {{jsxref("Atomics.or()")}}\n  - : Computes a bitwise OR on the value at the specified index of the array with the provided value. Returns the old value at that index.\n- {{jsxref("Atomics.store()")}}\n  - : Stores a value at the specified index of the array. Returns the value.\n- {{jsxref("Atomics.sub()")}}\n  - : Subtracts a value at the specified index of the array. Returns the old value at that index.\n- {{jsxref("Atomics.wait()")}}\n  - : Verifies that the specified index of the array still contains a value and sleeps awaiting or times out. Returns either `"ok"`, `"not-equal"`, or `"timed-out"`. If waiting is not allowed in the calling agent then it throws an exception. (Most browsers will not allow `wait()` on the browser\'s main thread.)\n- {{jsxref("Atomics.waitAsync()")}}\n  - : Waits asynchronously (i.e. without blocking, unlike `Atomics.wait`) on a shared memory location and returns a {{jsxref("Promise")}}.\n- {{jsxref("Atomics.xor()")}}\n  - : Computes a bitwise XOR on the value at the specified index of the array with the provided value. Returns the old value at that index.\n\n## Examples\n\n### Using Atomics\n\n```js\nconst sab = new SharedArrayBuffer(1024);\nconst ta = new Uint8Array(sab);\n\nta[0]; // 0\nta[0] = 5; // 5\n\nAtomics.add(ta, 0, 12); // 5\nAtomics.load(ta, 0); // 17\n\nAtomics.and(ta, 0, 1); // 17\nAtomics.load(ta, 0); // 1\n\nAtomics.compareExchange(ta, 0, 5, 12); // 1\nAtomics.load(ta, 0); // 1\n\nAtomics.exchange(ta, 0, 12); // 1\nAtomics.load(ta, 0); // 12\n\nAtomics.isLockFree(1); // true\nAtomics.isLockFree(2); // true\nAtomics.isLockFree(3); // false\nAtomics.isLockFree(4); // true\n\nAtomics.or(ta, 0, 1); // 12\nAtomics.load(ta, 0); // 13\n\nAtomics.store(ta, 0, 12); // 12\n\nAtomics.sub(ta, 0, 2); // 12\nAtomics.load(ta, 0); // 10\n\nAtomics.xor(ta, 0, 1); // 10\nAtomics.load(ta, 0); // 11\n```\n\n### Waiting and notifying\n\nGiven a shared `Int32Array`:\n\n```js\nconst sab = new SharedArrayBuffer(1024);\nconst int32 = new Int32Array(sab);\n```\n\nA reading thread is sleeping and waiting on location 0 which is expected to be 0. As long as that is true, it will not go on. However, once the writing thread has stored a new value, it will be notified by the writing thread and return the new value (123).\n\n```js\nAtomics.wait(int32, 0, 0);\nconsole.log(int32[0]); // 123\n```\n\nA writing thread stores a new value and notifies the waiting thread once it has written:\n\n```js\nconsole.log(int32[0]); // 0;\nAtomics.store(int32, 0, 123);\nAtomics.notify(int32, 0, 1);\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("ArrayBuffer")}}\n- [JavaScript typed arrays](/en-US/docs/Web/JavaScript/Guide/Typed_arrays) guide\n- [Web Workers](/en-US/docs/Web/API/Web_Workers_API)\n- [Shared Memory \u2013 a brief tutorial](https://github.com/tc39/proposal-ecmascript-sharedmem/blob/main/TUTORIAL.md) in the TC39 ecmascript-sharedmem proposal\n- [A Taste of JavaScript\'s New Parallel Primitives](https://hacks.mozilla.org/2016/05/a-taste-of-javascripts-new-parallel-primitives/) on hacks.mozilla.org (2016)\n',
        "islockfree": {
            "index.md": '---\ntitle: Atomics.isLockFree()\nslug: Web/JavaScript/Reference/Global_Objects/Atomics/isLockFree\npage-type: javascript-static-method\nbrowser-compat: javascript.builtins.Atomics.isLockFree\n---\n\n{{JSRef}}\n\nThe **`Atomics.isLockFree()`** static\nmethod is used to determine whether the `Atomics` methods use locks\nor atomic hardware operations when applied to typed arrays with the given element\nbyte size.\nIt returns `false` if the given size is not one of the [BYTES_PER_ELEMENT](/en-US/docs/Web/JavaScript/Reference/Global_Objects/TypedArray/BYTES_PER_ELEMENT)\nproperty of integer TypedArray types.\n\n{{EmbedInteractiveExample("pages/js/atomics-islockfree.html")}}\n\n## Syntax\n\n```js-nolint\nAtomics.isLockFree(size)\n```\n\n### Parameters\n\n- `size`\n  - : The size in bytes to check.\n\n### Return value\n\nA `true` or `false` value indicating whether the operation is lock free.\n\n## Examples\n\n### Using isLockFree\n\n```js\nAtomics.isLockFree(1); // true\nAtomics.isLockFree(2); // true\nAtomics.isLockFree(3); // false\nAtomics.isLockFree(4); // true\nAtomics.isLockFree(5); // false\nAtomics.isLockFree(6); // false\nAtomics.isLockFree(7); // false\nAtomics.isLockFree(8); // true\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Atomics")}}\n'
        },
        "load": {
            "index.md": '---\ntitle: Atomics.load()\nslug: Web/JavaScript/Reference/Global_Objects/Atomics/load\npage-type: javascript-static-method\nbrowser-compat: javascript.builtins.Atomics.load\n---\n\n{{JSRef}}\n\nThe **`Atomics.load()`** static\nmethod returns a value at a given position in the array.\n\n{{EmbedInteractiveExample("pages/js/atomics-load.html")}}\n\n## Syntax\n\n```js-nolint\nAtomics.load(typedArray, index)\n```\n\n### Parameters\n\n- `typedArray`\n  - : An integer typed array. One of {{jsxref("Int8Array")}}, {{jsxref("Uint8Array")}},\n    {{jsxref("Int16Array")}}, {{jsxref("Uint16Array")}}, {{jsxref("Int32Array")}},\n    {{jsxref("Uint32Array")}}, {{jsxref("BigInt64Array")}}, or\n    {{jsxref("BigUint64Array")}}.\n- `index`\n  - : The position in the `typedArray` to load from.\n\n### Return value\n\nThe value at the given position (`typedArray[index]`).\n\n### Exceptions\n\n- {{jsxref("TypeError")}}\n  - : Thrown if `typedArray` is not one of the allowed integer types.\n- {{jsxref("RangeError")}}\n  - : Thrown if `index` is out of bounds in the `typedArray`.\n\n## Examples\n\n### Using `load`\n\n```js\nconst sab = new SharedArrayBuffer(1024);\nconst ta = new Uint8Array(sab);\n\nAtomics.add(ta, 0, 12);\nAtomics.load(ta, 0); // 12\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Atomics")}}\n- {{jsxref("Atomics.store()")}}\n'
        },
        "notify": {
            "index.md": '---\ntitle: Atomics.notify()\nslug: Web/JavaScript/Reference/Global_Objects/Atomics/notify\npage-type: javascript-static-method\nbrowser-compat: javascript.builtins.Atomics.notify\n---\n\n{{JSRef}}\n\nThe **`Atomics.notify()`** static\nmethod notifies up some agents that are sleeping in the wait queue.\n\n> **Note:** This operation only works with an {{jsxref("Int32Array")}} or {{jsxref("BigInt64Array")}} that views a {{jsxref("SharedArrayBuffer")}}.\n> It will return `0` on non-shared `ArrayBuffer` objects.\n\n## Syntax\n\n```js-nolint\nAtomics.notify(typedArray, index, count)\n```\n\n### Parameters\n\n- `typedArray`\n  - : An {{jsxref("Int32Array")}} or {{jsxref("BigInt64Array")}} that views a {{jsxref("SharedArrayBuffer")}}.\n- `index`\n  - : The position in the `typedArray` to wake up on.\n- `count` {{optional_inline}}\n  - : The number of sleeping agents to notify. Defaults to {{jsxref("Infinity")}}.\n\n### Return value\n\n- Returns the number of woken up agents.\n- Returns `0`, if a non-shared {{jsxref("ArrayBuffer")}} object is used.\n\n### Exceptions\n\n- {{jsxref("TypeError")}}\n  - : Thrown if `typedArray` is not an {{jsxref("Int32Array")}} or {{jsxref("BigInt64Array")}} that views a {{jsxref("SharedArrayBuffer")}}.\n- {{jsxref("RangeError")}}\n  - : Thrown if `index` is out of bounds in the `typedArray`.\n\n## Examples\n\n### Using `notify`\n\nGiven a shared `Int32Array`:\n\n```js\nconst sab = new SharedArrayBuffer(1024);\nconst int32 = new Int32Array(sab);\n```\n\nA reading thread is sleeping and waiting on location 0 which is expected to be 0. As\nlong as that is true, it will not go on. However, once the writing thread has stored a\nnew value, it will be notified by the writing thread and return the new value (123).\n\n```js\nAtomics.wait(int32, 0, 0);\nconsole.log(int32[0]); // 123\n```\n\nA writing thread stores a new value and notifies the waiting thread once it has\nwritten:\n\n```js\nconsole.log(int32[0]); // 0;\nAtomics.store(int32, 0, 123);\nAtomics.notify(int32, 0, 1);\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Atomics")}}\n- {{jsxref("Atomics.wait()")}}\n- {{jsxref("Atomics.waitAsync()")}}\n'
        },
        "or": {
            "index.md": '---\ntitle: Atomics.or()\nslug: Web/JavaScript/Reference/Global_Objects/Atomics/or\npage-type: javascript-static-method\nbrowser-compat: javascript.builtins.Atomics.or\n---\n\n{{JSRef}}\n\nThe **`Atomics.or()`** static\nmethod computes a bitwise OR with a given value at a given position in the array, and\nreturns the old value at that position. This atomic operation guarantees that no other\nwrite happens until the modified value is written back.\n\n{{EmbedInteractiveExample("pages/js/atomics-or.html")}}\n\n## Syntax\n\n```js-nolint\nAtomics.or(typedArray, index, value)\n```\n\n### Parameters\n\n- `typedArray`\n  - : An integer typed array. One of {{jsxref("Int8Array")}}, {{jsxref("Uint8Array")}},\n    {{jsxref("Int16Array")}}, {{jsxref("Uint16Array")}}, {{jsxref("Int32Array")}},\n    {{jsxref("Uint32Array")}}, {{jsxref("BigInt64Array")}}, or\n    {{jsxref("BigUint64Array")}}.\n- `index`\n  - : The position in the `typedArray` to compute the bitwise OR.\n- `value`\n  - : The number to compute the bitwise OR with.\n\n### Return value\n\nThe old value at the given position\n(`typedArray[index]`).\n\n### Exceptions\n\n- {{jsxref("TypeError")}}\n  - : Thrown if `typedArray` is not one of the allowed integer types.\n- {{jsxref("RangeError")}}\n  - : Thrown if `index` is out of bounds in the `typedArray`.\n\n## Description\n\nThe bitwise OR operation yields 1, if either `a` or `b` are 1.\nThe truth table for the OR operation is:\n\n| `a` | `b` | `a \\| b` |\n| --- | --- | -------- |\n| 0   | 0   | 0        |\n| 0   | 1   | 1        |\n| 1   | 0   | 1        |\n| 1   | 1   | 1        |\n\nFor example, a bitwise OR of `5 | 1` results in `0101` which is 5\nin decimal.\n\n```plain\n5  0101\n1  0001\n   ----\n5  0101\n```\n\n## Examples\n\n### Using or\n\n```js\nconst sab = new SharedArrayBuffer(1024);\nconst ta = new Uint8Array(sab);\nta[0] = 2;\n\nAtomics.or(ta, 0, 1); // returns 2, the old value\nAtomics.load(ta, 0); // 3\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Atomics")}}\n- {{jsxref("Atomics.and()")}}\n- {{jsxref("Atomics.xor()")}}\n'
        },
        "store": {
            "index.md": '---\ntitle: Atomics.store()\nslug: Web/JavaScript/Reference/Global_Objects/Atomics/store\npage-type: javascript-static-method\nbrowser-compat: javascript.builtins.Atomics.store\n---\n\n{{JSRef}}\n\nThe **`Atomics.store()`** static\nmethod stores a given value at the given position in the array and returns that value.\n\n{{EmbedInteractiveExample("pages/js/atomics-store.html")}}\n\n## Syntax\n\n```js-nolint\nAtomics.store(typedArray, index, value)\n```\n\n### Parameters\n\n- `typedArray`\n  - : An integer typed array. One of {{jsxref("Int8Array")}}, {{jsxref("Uint8Array")}},\n    {{jsxref("Int16Array")}}, {{jsxref("Uint16Array")}}, {{jsxref("Int32Array")}},\n    {{jsxref("Uint32Array")}}, {{jsxref("BigInt64Array")}}, or\n    {{jsxref("BigUint64Array")}}.\n- `index`\n  - : The position in the `typedArray` to store a\n    `value` in.\n- `value`\n  - : The number to store.\n\n### Return value\n\nThe value that has been stored.\n\n### Exceptions\n\n- {{jsxref("TypeError")}}\n  - : Thrown if `typedArray` is not one of the allowed integer types.\n- {{jsxref("RangeError")}}\n  - : Thrown if `index` is out of bounds in the `typedArray`.\n\n## Examples\n\n### Using store()\n\n```js\nconst sab = new SharedArrayBuffer(1024);\nconst ta = new Uint8Array(sab);\n\nAtomics.store(ta, 0, 12); // 12\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Atomics")}}\n- {{jsxref("Atomics.load()")}}\n'
        },
        "sub": {
            "index.md": '---\ntitle: Atomics.sub()\nslug: Web/JavaScript/Reference/Global_Objects/Atomics/sub\npage-type: javascript-static-method\nbrowser-compat: javascript.builtins.Atomics.sub\n---\n\n{{JSRef}}\n\nThe **`Atomics.sub()`** static method subtracts a given value\nat a given position in the array and returns the old value at that position. This atomic\noperation guarantees that no other write happens until the modified value is written\nback.\n\n{{EmbedInteractiveExample("pages/js/atomics-sub.html")}}\n\n## Syntax\n\n```js-nolint\nAtomics.sub(typedArray, index, value)\n```\n\n### Parameters\n\n- `typedArray`\n  - : An integer typed array. One of {{jsxref("Int8Array")}}, {{jsxref("Uint8Array")}},\n    {{jsxref("Int16Array")}}, {{jsxref("Uint16Array")}}, {{jsxref("Int32Array")}},\n    {{jsxref("Uint32Array")}}, {{jsxref("BigInt64Array")}}, or\n    {{jsxref("BigUint64Array")}}.\n- `index`\n  - : The position in the `typedArray` to subtract a\n    `value` from.\n- `value`\n  - : The number to subtract.\n\n### Return value\n\nThe old value at the given position\n(`typedArray[index]`).\n\n### Exceptions\n\n- {{jsxref("TypeError")}}\n  - : Thrown if `typedArray` is not one of the allowed integer types.\n- {{jsxref("RangeError")}}\n  - : Thrown if `index` is out of bounds in the `typedArray`.\n\n## Examples\n\n### Using sub\n\n```js\nconst sab = new SharedArrayBuffer(1024);\nconst ta = new Uint8Array(sab);\nta[0] = 48;\n\nAtomics.sub(ta, 0, 12); // returns 48, the old value\nAtomics.load(ta, 0); // 36\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Atomics")}}\n- {{jsxref("Atomics.add()")}}\n'
        },
        "wait": {
            "index.md": '---\ntitle: Atomics.wait()\nslug: Web/JavaScript/Reference/Global_Objects/Atomics/wait\npage-type: javascript-static-method\nbrowser-compat: javascript.builtins.Atomics.wait\n---\n\n{{JSRef}}\n\nThe **`Atomics.wait()`** static\nmethod verifies that a shared memory location still contains a\ngiven value and if so sleeps, awaiting a wake-up notification or times out. It returns a string which\nis either `"ok"`, `"not-equal"`, or `"timed-out"`.\n\n> **Note:** This operation only works with an {{jsxref("Int32Array")}} or {{jsxref("BigInt64Array")}} that views a {{jsxref("SharedArrayBuffer")}}, and may not be allowed on the main thread.\n> For a non-blocking, asynchronous version of this method, see {{jsxref("Atomics.waitAsync()")}}.\n\n## Syntax\n\n```js-nolint\nAtomics.wait(typedArray, index, value)\nAtomics.wait(typedArray, index, value, timeout)\n```\n\n### Parameters\n\n- `typedArray`\n  - : An {{jsxref("Int32Array")}} or {{jsxref("BigInt64Array")}} that views a {{jsxref("SharedArrayBuffer")}}.\n- `index`\n  - : The position in the `typedArray` to wait on.\n- `value`\n  - : The expected value to test.\n- `timeout` {{optional_inline}}\n  - : Time to wait in milliseconds. {{jsxref("NaN")}} (and values that get converted to `NaN`, such as `undefined`) becomes {{jsxref("Infinity")}}. Negative values become `0`.\n\n### Return value\n\nA string which is either `"ok"`, `"not-equal"`, or `"timed-out"`.\n\n### Exceptions\n\n- {{jsxref("TypeError")}}\n  - : Thrown in one of the following cases:\n    - If `typedArray` is not an {{jsxref("Int32Array")}} or {{jsxref("BigInt64Array")}} that views a {{jsxref("SharedArrayBuffer")}}.\n    - If the current thread cannot be blocked (for example, because it\'s the main thread).\n- {{jsxref("RangeError")}}\n  - : Thrown if `index` is out of bounds in the `typedArray`.\n\n## Examples\n\n### Using wait()\n\nGiven a shared `Int32Array`:\n\n```js\nconst sab = new SharedArrayBuffer(1024);\nconst int32 = new Int32Array(sab);\n```\n\nA reading thread is sleeping and waiting on location 0 which is expected to be 0. As\nlong as that is true, it will not go on. However, once the writing thread has stored a\nnew value, it will be notified by the writing thread and return the new value (123).\n\n```js\nAtomics.wait(int32, 0, 0);\nconsole.log(int32[0]); // 123\n```\n\nA writing thread stores a new value and notifies the waiting thread once it has\nwritten:\n\n```js\nconsole.log(int32[0]); // 0;\nAtomics.store(int32, 0, 123);\nAtomics.notify(int32, 0, 1);\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Atomics")}}\n- {{jsxref("Atomics.waitAsync()")}}\n- {{jsxref("Atomics.notify()")}}\n'
        },
        "waitasync": {
            "index.md": '---\ntitle: Atomics.waitAsync()\nslug: Web/JavaScript/Reference/Global_Objects/Atomics/waitAsync\npage-type: javascript-static-method\nbrowser-compat: javascript.builtins.Atomics.waitAsync\n---\n\n{{JSRef}}\n\nThe **`Atomics.waitAsync()`** static method waits asynchronously on a shared memory location and returns a {{jsxref("Promise")}}.\n\nUnlike {{jsxref("Atomics.wait()")}}, `waitAsync` is non-blocking and usable on the main thread.\n\n> **Note:** This operation only works with an {{jsxref("Int32Array")}} or {{jsxref("BigInt64Array")}} that views a {{jsxref("SharedArrayBuffer")}}.\n\n## Syntax\n\n```js-nolint\nAtomics.waitAsync(typedArray, index, value)\nAtomics.waitAsync(typedArray, index, value, timeout)\n```\n\n### Parameters\n\n- `typedArray`\n  - : An {{jsxref("Int32Array")}} or {{jsxref("BigInt64Array")}} that views a {{jsxref("SharedArrayBuffer")}}.\n- `index`\n  - : The position in the `typedArray` to wait on.\n- `value`\n  - : The expected value to test.\n- `timeout` {{optional_inline}}\n  - : Time to wait in milliseconds. {{jsxref("NaN")}} (and values that get converted to `NaN`, such as `undefined`) becomes {{jsxref("Infinity")}}. Negative values become `0`.\n\n### Return value\n\nAn {{jsxref("Object")}} with the following properties:\n\n- `async`\n  - : A boolean indicating whether the `value` property is a {{jsxref("Promise")}} or not.\n- `value`\n  - : If `async` is `false`, it will be a string which is either `"not-equal"` or `"timed-out"` (only when the `timeout` parameter is `0`). If `async` is `true`, it will be a {{jsxref("Promise")}} which is fulfilled with a string value, either `"ok"` or `"timed-out"`. The promise is never rejected.\n\n### Exceptions\n\n- {{jsxref("TypeError")}}\n  - : Thrown if `typedArray` is not an {{jsxref("Int32Array")}} or {{jsxref("BigInt64Array")}} that views a {{jsxref("SharedArrayBuffer")}}.\n- {{jsxref("RangeError")}}\n  - : Thrown if `index` is out of bounds in the `typedArray`.\n\n## Examples\n\n### Using waitAsync()\n\nGiven a shared `Int32Array`.\n\n```js\nconst sab = new SharedArrayBuffer(1024);\nconst int32 = new Int32Array(sab);\n```\n\nA reading thread is sleeping and waiting on location 0 which is expected to be 0.\nThe `result.value` will be a promise.\n\n```js\nconst result = Atomics.waitAsync(int32, 0, 0, 1000);\n// { async: true, value: Promise {<pending>} }\n```\n\nIn the reading thread or in another thread, the memory location 0 is called and the promise can be resolved with `"ok"`.\n\n```js\nAtomics.notify(int32, 0);\n// { async: true, value: Promise {<fulfilled>: \'ok\'} }\n```\n\nIf it isn\'t resolving to `"ok"`, the value in the shared memory location wasn\'t the expected (the `value` would be `"not-equal"` instead of a promise) or the timeout was reached (the promise will resolve to `"time-out"`).\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Atomics")}}\n- {{jsxref("Atomics.wait()")}}\n- {{jsxref("Atomics.notify()")}}\n'
        },
        "xor": {
            "index.md": '---\ntitle: Atomics.xor()\nslug: Web/JavaScript/Reference/Global_Objects/Atomics/xor\npage-type: javascript-static-method\nbrowser-compat: javascript.builtins.Atomics.xor\n---\n\n{{JSRef}}\n\nThe **`Atomics.xor()`** static\nmethod computes a bitwise XOR with a given value at a given position in the array, and\nreturns the old value at that position. This atomic operation guarantees that no other\nwrite happens until the modified value is written back.\n\n{{EmbedInteractiveExample("pages/js/atomics-xor.html")}}\n\n## Syntax\n\n```js-nolint\nAtomics.xor(typedArray, index, value)\n```\n\n### Parameters\n\n- `typedArray`\n  - : An integer typed array. One of {{jsxref("Int8Array")}}, {{jsxref("Uint8Array")}},\n    {{jsxref("Int16Array")}}, {{jsxref("Uint16Array")}}, {{jsxref("Int32Array")}},\n    {{jsxref("Uint32Array")}}, {{jsxref("BigInt64Array")}}, or\n    {{jsxref("BigUint64Array")}}.\n- `index`\n  - : The position in the `typedArray` to compute the bitwise XOR.\n- `value`\n  - : The number to compute the bitwise XOR with.\n\n### Return value\n\nThe old value at the given position (`typedArray[index]`).\n\n### Exceptions\n\n- {{jsxref("TypeError")}}\n  - : Thrown if `typedArray` is not one of the allowed integer types.\n- {{jsxref("RangeError")}}\n  - : Thrown if `index` is out of bounds in the `typedArray`.\n\n## Description\n\nThe bitwise XOR operation yields 1, if `a` and `b` are different.\nThe truth table for the XOR operation is:\n\n| `a` | `b` | `a ^ b` |\n| --- | --- | ------- |\n| 0   | 0   | 0       |\n| 0   | 1   | 1       |\n| 1   | 0   | 1       |\n| 1   | 1   | 0       |\n\nFor example, a bitwise XOR of `5 ^ 1` results in `0100` which is\n4 in decimal.\n\n```plain\n5  0101\n1  0001\n   ----\n4  0100\n```\n\n## Examples\n\n### Using xor\n\n```js\nconst sab = new SharedArrayBuffer(1024);\nconst ta = new Uint8Array(sab);\nta[0] = 5;\n\nAtomics.xor(ta, 0, 1); // returns 5, the old value\nAtomics.load(ta, 0); // 4\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Atomics")}}\n- {{jsxref("Atomics.and()")}}\n- {{jsxref("Atomics.or()")}}\n'
        }
    },
    "bigint": {
        "asintn": {
            "index.md": '---\ntitle: BigInt.asIntN()\nslug: Web/JavaScript/Reference/Global_Objects/BigInt/asIntN\npage-type: javascript-static-method\nbrowser-compat: javascript.builtins.BigInt.asIntN\n---\n\n{{JSRef}}\n\nThe **`BigInt.asIntN()`** static method truncates a `BigInt` value to the given number of least significant bits and returns that value as a signed integer.\n\n{{EmbedInteractiveExample("pages/js/bigint-asintn.html")}}\n\n## Syntax\n\n```js-nolint\nBigInt.asIntN(bits, bigint)\n```\n\n### Parameters\n\n- `bits`\n  - : The amount of bits available for the returned BigInt. Should be an integer between 0 and 2<sup>53</sup> - 1, inclusive.\n- `bigint`\n  - : The BigInt value to truncate to fit into the supplied bits.\n\n### Return value\n\nThe value of `bigint` modulo 2^`bits`, as a signed integer.\n\n### Exceptions\n\n- {{jsxref("RangeError")}}\n  - : Thrown if `bits` is negative or greater than 2<sup>53</sup> - 1.\n\n## Description\n\nThe `BigInt.asIntN` method truncates a `BigInt` value to the given number of bits, and interprets the result as a signed integer. For example, for `BigInt.asIntN(3, 25n)`, the value `25n` is truncated to `1n`:\n\n```plain\n25n = 00011001 (base 2)\n          ^=== Use only the three remaining bits\n===>       001 (base 2) = 1n\n```\n\nIf the leading bit of the remaining number is `1`, the result is negative. For example, `BigInt.asIntN(4, 25n)` yields `-7n`, because `1001` is the encoding of `-7` under two\'s complement:\n\n```plain\n25n = 00011001 (base 2)\n         ^==== Use only the four remaining bits\n===>      1001 (base 2) = -7n\n```\n\n> **Note:** `BigInt` values are always encoded as two\'s complement in binary.\n\nUnlike similar language APIs such as {{jsxref("Number.prototype.toExponential()")}}, `asIntN` is a static property of {{jsxref("BigInt")}}, so you always use it as `BigInt.asIntN()`, rather than as a method of a BigInt value. Exposing `asIntN()` as a "standard library function" allows [interop with asm.js](https://github.com/tc39/proposal-bigint/blob/master/ADVANCED.md#dont-break-asmjs).\n\n## Examples\n\n### Staying in 64-bit ranges\n\nThe `BigInt.asIntN()` method can be useful to stay in the range of 64-bit arithmetic.\n\n```js\nconst max = 2n ** (64n - 1n) - 1n;\n\nBigInt.asIntN(64, max); // 9223372036854775807n\n\nBigInt.asIntN(64, max + 1n); // -9223372036854775808n\n// negative because the 64th bit of 2^63 is 1\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("BigInt")}}\n- {{jsxref("BigInt.asUintN()")}}\n'
        },
        "asuintn": {
            "index.md": '---\ntitle: BigInt.asUintN()\nslug: Web/JavaScript/Reference/Global_Objects/BigInt/asUintN\npage-type: javascript-static-method\nbrowser-compat: javascript.builtins.BigInt.asUintN\n---\n\n{{JSRef}}\n\nThe **`BigInt.asUintN()`** static method truncates a `BigInt` value to the given number of least significant bits and returns that value as an unsigned integer.\n\n{{EmbedInteractiveExample("pages/js/bigint-asuintn.html", "taller")}}\n\n## Syntax\n\n```js-nolint\nBigInt.asUintN(bits, bigint)\n```\n\n### Parameters\n\n- `bits`\n  - : The amount of bits available for the returned BigInt. Should be an integer between 0 and 2<sup>53</sup> - 1, inclusive.\n- `bigint`\n  - : The BigInt value to truncate to fit into the supplied bits.\n\n### Return value\n\nThe value of `bigint` modulo 2^`bits`, as an unsigned integer.\n\n### Exceptions\n\n- {{jsxref("RangeError")}}\n  - : Thrown if `bits` is negative or greater than 2<sup>53</sup> - 1.\n\n## Description\n\nThe `BigInt.asUintN` method truncates a `BigInt` value to the given number of bits, and interprets the result as an unsigned integer. Unsigned integers have no sign bits and are always non-negative. For example, for `BigInt.asUintN(4, 25n)`, the value `25n` is truncated to `9n`:\n\n```plain\n25n = 00011001 (base 2)\n         ^==== Use only the four remaining bits\n===>      1001 (base 2) = 9n\n```\n\n> **Note:** `BigInt` values are always encoded as two\'s complement in binary.\n\nUnlike similar language APIs such as {{jsxref("Number.prototype.toExponential()")}}, `asUintN` is a static property of {{jsxref("BigInt")}}, so you always use it as `BigInt.asUintN()`, rather than as a method of a BigInt value. Exposing `asUintN()` as a "standard library function" allows [interop with asm.js](https://github.com/tc39/proposal-bigint/blob/master/ADVANCED.md#dont-break-asmjs).\n\n## Examples\n\n### Staying in 64-bit ranges\n\nThe `BigInt.asUintN()` method can be useful to stay in the range of 64-bit arithmetic.\n\n```js\nconst max = 2n ** 64n - 1n;\n\nBigInt.asUintN(64, max); // 18446744073709551615n\n\nBigInt.asUintN(64, max + 1n); // 0n\n// zero because of overflow: the lowest 64 bits are all zeros\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("BigInt")}}\n- {{jsxref("BigInt.asIntN()")}}\n'
        },
        "bigint": {
            "index.md": '---\ntitle: BigInt() constructor\nslug: Web/JavaScript/Reference/Global_Objects/BigInt/BigInt\npage-type: javascript-constructor\nbrowser-compat: javascript.builtins.BigInt.BigInt\n---\n\n{{JSRef}}\n\nThe **`BigInt()`** function returns primitive values of type BigInt.\n\n## Syntax\n\n```js-nolint\nBigInt(value)\n```\n\n> **Note:** `BigInt()` can only be called without [`new`](/en-US/docs/Web/JavaScript/Reference/Operators/new). Attempting to construct it with `new` throws a {{jsxref("TypeError")}}.\n\n### Parameters\n\n- `value`\n  - : The value to be converted to a BigInt value. It may be a string, an integer, a boolean, or another `BigInt`.\n\n### Return value\n\nA {{jsxref("BigInt")}} value. Number values must be integers and are converted to BigInts. The boolean value `true` becomes `1n`, and `false` becomes `0n`. Strings are parsed as if they are source text for integer literals, which means they can have leading and trailing whitespaces and can be prefixed with `0b`, `0o`, or `0x`.\n\n### Exceptions\n\n- {{jsxref("RangeError")}}\n  - : Thrown if the parameter is a non-integral number.\n- {{jsxref("TypeError")}}\n  - : Thrown in one of the following cases:\n    - The parameter cannot be converted to a primitive.\n    - After conversion to a primitive, the result is {{jsxref("undefined")}}, {{jsxref("Operators/null", "null")}}, {{jsxref("symbol")}}.\n- {{jsxref("SyntaxError")}}\n  - : Thrown if the parameter is a string that cannot be parsed as a `BigInt`.\n\n## Examples\n\n### Using BigInt() to convert a number to a BigInt\n\n`BigInt()` is the only case where a number can be converted to a BigInt without throwing, because it\'s very explicit. However, only integers are allowed.\n\n```js\nBigInt(123); // 123n\nBigInt(123.3); // RangeError: The number 123.3 cannot be converted to a BigInt because it is not an integer\n```\n\n### Using string values\n\n```js\nBigInt("123"); // 123n\nBigInt("0b10101"); // 21n, which is 10101 in binary\nBigInt("0o123"); // 83n, which is 123 in octal\nBigInt("0x123"); // 291n, which is 123 in hexadecimal\nBigInt("  123  "); // 123n, leading and trailing whitespaces are allowed\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("BigInt")}}\n'
        },
        "index.md": '---\ntitle: BigInt\nslug: Web/JavaScript/Reference/Global_Objects/BigInt\npage-type: javascript-class\nbrowser-compat: javascript.builtins.BigInt\n---\n\n{{JSRef}}\n\n**`BigInt`** values represent numeric values which are [too large](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/MAX_SAFE_INTEGER) to be represented by the `number` {{Glossary("Primitive", "primitive")}}.\n\n## Description\n\nA **BigInt value**, also sometimes just called a **BigInt**, is a `bigint` {{Glossary("Primitive", "primitive")}}, created by appending `n` to the end of an integer literal, or by calling the {{jsxref("BigInt/BigInt", "BigInt()")}} function (without the `new` operator) and giving it an integer value or string value.\n\n```js\nconst previouslyMaxSafeInteger = 9007199254740991n;\n\nconst alsoHuge = BigInt(9007199254740991);\n// 9007199254740991n\n\nconst hugeString = BigInt("9007199254740991");\n// 9007199254740991n\n\nconst hugeHex = BigInt("0x1fffffffffffff");\n// 9007199254740991n\n\nconst hugeOctal = BigInt("0o377777777777777777");\n// 9007199254740991n\n\nconst hugeBin = BigInt(\n  "0b11111111111111111111111111111111111111111111111111111",\n);\n// 9007199254740991n\n```\n\nBigInt values are similar to Number values in some ways, but also differ in a few key matters: A BigInt value cannot be used with methods in the built-in [`Math`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math) object and cannot be mixed with a Number value in operations; they must be coerced to the same type. Be careful coercing values back and forth, however, as the precision of a BigInt value may be lost when it is coerced to a Number value.\n\n### Type information\n\nWhen tested against `typeof`, a BigInt value (`bigint` primitive) will give `"bigint"`:\n\n```js\ntypeof 1n === "bigint"; // true\ntypeof BigInt("1") === "bigint"; // true\n```\n\nA BigInt value can also be wrapped in an `Object`:\n\n```js\ntypeof Object(1n) === "object"; // true\n```\n\n### Operators\n\nMost operators support BigInts, however most do not permit operands to be of mixed types \u2014 both operands must be BigInt or neither:\n\n- [Arithmetic operators](/en-US/docs/Web/JavaScript/Reference/Operators#arithmetic_operators): `+`, `-`, `*`, `/`, `%`, `**`\n- [Bitwise operators](/en-US/docs/Web/JavaScript/Reference/Operators#bitwise_shift_operators): `>>`, `<<`, `&`, `|`, `^`, `~`\n- [Unary negation (`-`)](/en-US/docs/Web/JavaScript/Reference/Operators/Unary_negation)\n- [Increment/decrement](/en-US/docs/Web/JavaScript/Reference/Operators#increment_and_decrement): `++`, `--`\n\nThe boolean-returning operators allow mixing numbers and BigInts as operands:\n\n- [Relational operators](/en-US/docs/Web/JavaScript/Reference/Operators#relational_operators) and [equality operators](/en-US/docs/Web/JavaScript/Reference/Operators#equality_operators): `>`, `<`, `>=`, `<=`, `==`, `!=`, `===`, `!==`\n- [Logical operators](/en-US/docs/Web/JavaScript/Reference/Operators#binary_logical_operators) only rely on the [truthiness](/en-US/docs/Glossary/Truthy) of operands\n\nA couple of operators do not support BigInt at all:\n\n- [Unary plus (`+`)](/en-US/docs/Web/JavaScript/Reference/Operators/Unary_plus) cannot be supported due to conflicting usage in asm.js, so it has been left out [in order to not break asm.js](https://github.com/tc39/proposal-bigint/blob/master/ADVANCED.md#dont-break-asmjs).\n- [Unsigned right shift (`>>>`)](/en-US/docs/Web/JavaScript/Reference/Operators/Unsigned_right_shift) is the only bitwise operator that\'s unsupported, as every BigInt value is signed.\n\nSpecial cases:\n\n- Addition (`+`) involving a string and a BigInt returns a string.\n- Division (`/`) truncates fractional components towards zero, since BigInt is unable to represent fractional quantities.\n\n```js\nconst previousMaxSafe = BigInt(Number.MAX_SAFE_INTEGER); // 9007199254740991n\nconst maxPlusOne = previousMaxSafe + 1n; // 9007199254740992n\nconst theFuture = previousMaxSafe + 2n; // 9007199254740993n, this works now!\nconst multi = previousMaxSafe * 2n; // 18014398509481982n\nconst subtr = multi - 10n; // 18014398509481972n\nconst mod = multi % 10n; // 2n\nconst bigN = 2n ** 54n; // 18014398509481984n\nbigN * -1n; // -18014398509481984n\nconst expected = 4n / 2n; // 2n\nconst truncated = 5n / 2n; // 2n, not 2.5n\n```\n\n### Comparisons\n\nA BigInt value is not strictly equal to a Number value, but it _is_ loosely so:\n\n```js\n0n === 0; // false\n0n == 0; // true\n```\n\nA Number value and a BigInt value may be compared as usual:\n\n```js\n1n < 2; // true\n2n > 1; // true\n2 > 2; // false\n2n > 2; // false\n2n >= 2; // true\n```\n\nBigInt values and Number values may be mixed in arrays and sorted:\n\n```js\nconst mixed = [4n, 6, -12n, 10, 4, 0, 0n];\n// [4n, 6, -12n, 10, 4, 0, 0n]\n\nmixed.sort(); // default sorting behavior\n// [ -12n, 0, 0n, 10, 4n, 4, 6 ]\n\nmixed.sort((a, b) => a - b);\n// won\'t work since subtraction will not work with mixed types\n// TypeError: can\'t convert BigInt value to Number value\n\n// sort with an appropriate numeric comparator\nmixed.sort((a, b) => (a < b ? -1 : a > b ? 1 : 0));\n// [ -12n, 0, 0n, 4n, 4, 6, 10 ]\n```\n\nNote that comparisons with `Object`-wrapped BigInt values act as with other objects, only indicating equality when the same object instance is compared:\n\n```js\nObject(0n) === 0n; // false\nObject(0n) === Object(0n); // false\n\nconst o = Object(0n);\no === o; // true\n```\n\nBecause coercing between Number values and BigInt values can lead to loss of precision, the following are recommended:\n\n- Only use a BigInt value when values greater than 2<sup>53</sup> are reasonably expected.\n- Don\'t coerce between BigInt values and Number values.\n\n### Conditionals\n\nA BigInt value follows the same conversion rules as Numbers when:\n\n- it is converted to a [`Boolean`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Boolean): via the [`Boolean`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Boolean) function;\n- when used with [logical operators](/en-US/docs/Web/JavaScript/Reference/Operators) `||`, `&&`, and `!`; or\n- within a conditional test like an [`if`](/en-US/docs/Web/JavaScript/Reference/Statements/if...else) statement.\n\nNamely, only `0n` is [falsy](/en-US/docs/Glossary/Falsy); everything else is [truthy](/en-US/docs/Glossary/Truthy).\n\n```js\nif (0n) {\n  console.log("Hello from the if!");\n} else {\n  console.log("Hello from the else!");\n}\n// "Hello from the else!"\n\n0n || 12n; // 12n\n0n && 12n; // 0n\nBoolean(0n); // false\nBoolean(12n); // true\n!12n; // false\n!0n; // true\n```\n\n### Cryptography\n\nThe operations supported on BigInt values are not constant-time and are thus open to [timing attacks](https://en.wikipedia.org/wiki/Timing_attack). JavaScript BigInts therefore could be dangerous for use in cryptography without mitigating factors. As a very generic example, an attacker could measure the time difference between `101n ** 65537n` and `17n ** 9999n`, and deduce the magnitude of secrets, such as private keys, based on the time elapsed. If you still have to use BigInts, take a look at the [Timing attack FAQ](https://timing.attacks.cr.yp.to/programming.html) for general advice regarding the issue.\n\n### Use within JSON\n\nUsing [`JSON.stringify()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/JSON/stringify) with any BigInt value will raise a `TypeError`, as BigInt values aren\'t serialized in JSON by default. However, `JSON.stringify()` specifically leaves a backdoor for BigInt values: it would try to call the BigInt\'s `toJSON()` method. (It doesn\'t do so for any other primitive values.) Therefore, you can implement your own `toJSON()` method (which is one of the few cases where patching built-in objects is not explicitly discouraged):\n\n```js\nBigInt.prototype.toJSON = function () {\n  return this.toString();\n};\n```\n\nInstead of throwing, `JSON.stringify()` now produces a string like this:\n\n```js\nconsole.log(JSON.stringify({ a: 1n }));\n// {"a":"1"}\n```\n\nIf you do not wish to patch `BigInt.prototype`, you can use the [`replacer`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/JSON/stringify#the_replacer_parameter) parameter of `JSON.stringify` to serialize BigInt values:\n\n```js\nconst replacer = (key, value) =>\n  typeof value === "bigint" ? value.toString() : value;\n\nconst data = {\n  number: 1,\n  big: 18014398509481982n,\n};\nconst stringified = JSON.stringify(data, replacer);\n\nconsole.log(stringified);\n// {"number":1,"big":"18014398509481982"}\n```\n\nIf you have JSON data containing values you know will be large integers, you can use the [`reviver`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/JSON/parse#using_the_reviver_parameter) parameter of `JSON.parse` to handle them:\n\n```js\nconst reviver = (key, value) => (key === "big" ? BigInt(value) : value);\n\nconst payload = \'{"number":1,"big":"18014398509481982"}\';\nconst parsed = JSON.parse(payload, reviver);\n\nconsole.log(parsed);\n// { number: 1, big: 18014398509481982n }\n```\n\n> **Note:** While it\'s possible to make the replacer of `JSON.stringify()` generic and properly serialize BigInt values for all objects, the reviver of `JSON.parse()` must be specific to the payload shape you expect, because the serialization is _lossy_: it\'s not possible to distinguish between a string that represents a BigInt and a normal string.\n\n### BigInt coercion\n\nMany built-in operations that expect BigInts first coerce their arguments to BigInts. [The operation](https://tc39.es/ecma262/multipage/abstract-operations.html#sec-tobigint) can be summarized as follows:\n\n- BigInts are returned as-is.\n- [`undefined`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/undefined) and [`null`](/en-US/docs/Web/JavaScript/Reference/Operators/null) throw a {{jsxref("TypeError")}}.\n- `true` turns into `1n`; `false` turns into `0n`.\n- Strings are converted by parsing them as if they contain an integer literal. Any parsing failure results in a {{jsxref("SyntaxError")}}. The syntax is a subset of [string numeric literals](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number#number_coercion), where decimal points or exponent indicators are not allowed.\n- [Numbers](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number) throw a {{jsxref("TypeError")}} to prevent unintended implicit coercion causing loss of precision.\n- [Symbols](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol) throw a {{jsxref("TypeError")}}.\n- Objects are first [converted to a primitive](/en-US/docs/Web/JavaScript/Data_structures#primitive_coercion) by calling their [`[@@toPrimitive]()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol/toPrimitive) (with `"number"` as hint), `valueOf()`, and `toString()` methods, in that order. The resulting primitive is then converted to a BigInt.\n\nThe best way to achieve nearly the same effect in JavaScript is through the [`BigInt()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/BigInt/BigInt) function: `BigInt(x)` uses the same algorithm to convert `x`, except that [Numbers](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number) don\'t throw a {{jsxref("TypeError")}}, but are converted to BigInts if they are integers.\n\nNote that built-in operations expecting BigInts often truncate the BigInt to a fixed width after coercion. This includes {{jsxref("BigInt.asIntN()")}}, {{jsxref("BigInt.asUintN()")}}, and methods of {{jsxref("BigInt64Array")}} and {{jsxref("BigUint64Array")}}.\n\n## Constructor\n\n- {{jsxref("BigInt/BigInt", "BigInt()")}}\n  - : Creates a new BigInt value.\n\n## Static methods\n\n- {{jsxref("BigInt.asIntN()")}}\n  - : Clamps a BigInt value to a signed integer value, and returns that value.\n- {{jsxref("BigInt.asUintN()")}}\n  - : Clamps a BigInt value to an unsigned integer value, and returns that value.\n\n## Instance properties\n\nThese properties are defined on `BigInt.prototype` and shared by all `BigInt` instances.\n\n- {{jsxref("Object/constructor", "BigInt.prototype.constructor")}}\n  - : The constructor function that created the instance object. For `BigInt` instances, the initial value is the {{jsxref("BigInt/BigInt", "BigInt")}} constructor.\n- `BigInt.prototype[@@toStringTag]`\n  - : The initial value of the [`@@toStringTag`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol/toStringTag) property is the string `"BigInt"`. This property is used in {{jsxref("Object.prototype.toString()")}}. However, because `BigInt` also has its own [`toString()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/BigInt/toString) method, this property is not used unless you call [`Object.prototype.toString.call()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/call) with a BigInt as `thisArg`.\n\n## Instance methods\n\n- {{jsxref("BigInt.prototype.toLocaleString()")}}\n  - : Returns a string with a language-sensitive representation of this BigInt value. Overrides the [`Object.prototype.toLocaleString()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/toLocaleString) method.\n- {{jsxref("BigInt.prototype.toString()")}}\n  - : Returns a string representing this BigInt value in the specified radix (base). Overrides the [`Object.prototype.toString()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/toString) method.\n- {{jsxref("BigInt.prototype.valueOf()")}}\n  - : Returns this BigInt value. Overrides the [`Object.prototype.valueOf()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/valueOf) method.\n\n## Examples\n\n### Calculating Primes\n\n```js\n// Returns true if the passed BigInt value is a prime number\nfunction isPrime(p) {\n  for (let i = 2n; i * i <= p; i++) {\n    if (p % i === 0n) return false;\n  }\n  return true;\n}\n\n// Takes a BigInt value as an argument, returns nth prime number as a BigInt value\nfunction nthPrime(nth) {\n  let maybePrime = 2n;\n  let prime = 0n;\n\n  while (nth >= 0n) {\n    if (isPrime(maybePrime)) {\n      nth--;\n      prime = maybePrime;\n    }\n    maybePrime++;\n  }\n\n  return prime;\n}\n\nnthPrime(20n);\n// 73n\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [`Number`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number)\n- [`Number.MAX_SAFE_INTEGER`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/MAX_SAFE_INTEGER)\n',
        "tolocalestring": {
            "index.md": '---\ntitle: BigInt.prototype.toLocaleString()\nslug: Web/JavaScript/Reference/Global_Objects/BigInt/toLocaleString\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.BigInt.toLocaleString\n---\n\n{{JSRef}}\n\nThe **`toLocaleString()`** method of {{jsxref("BigInt")}} values returns a string with a language-sensitive representation of this BigInt. In implementations with [`Intl.NumberFormat` API](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat) support, this method simply calls `Intl.NumberFormat`.\n\nEvery time `toLocaleString` is called, it has to perform a search in a big database of localization strings, which is potentially inefficient. When the method is called many times with the same arguments, it is better to create a {{jsxref("Intl.NumberFormat")}} object and use its {{jsxref("Intl/NumberFormat/format", "format()")}} method, because a `NumberFormat` object remembers the arguments passed to it and may decide to cache a slice of the database, so future `format` calls can search for localization strings within a more constrained context.\n\n{{EmbedInteractiveExample("pages/js/bigint-tolocalestring.html")}}\n\n## Syntax\n\n```js-nolint\ntoLocaleString()\ntoLocaleString(locales)\ntoLocaleString(locales, options)\n```\n\n### Parameters\n\nThe `locales` and `options` parameters customize the behavior of the function and let applications specify the language whose formatting conventions should be used.\n\nIn implementations that support the [`Intl.NumberFormat` API](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat), these parameters correspond exactly to the [`Intl.NumberFormat()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/NumberFormat) constructor\'s parameters. Implementations without `Intl.NumberFormat` support are asked to ignore both parameters, making the locale used and the form of the string returned entirely implementation-dependent.\n\n- `locales` {{optional_inline}}\n\n  - : A string with a BCP 47 language tag, or an array of such strings. Corresponds to the [`locales`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/NumberFormat#locales) parameter of the `Intl.NumberFormat()` constructor.\n\n    In implementations without `Intl.NumberFormat` support, this parameter is ignored and the host\'s locale is usually used.\n\n- `options` {{optional_inline}}\n\n  - : An object adjusting the output format. Corresponds to the [`options`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/NumberFormat#options) parameter of the `Intl.NumberFormat()` constructor.\n\n    In implementations without `Intl.NumberFormat` support, this parameter is ignored.\n\nSee the [`Intl.NumberFormat()` constructor](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/NumberFormat) for details on these parameters and how to use them.\n\n### Return value\n\nA string representing the given BigInt according to language-specific conventions.\n\nIn implementations with `Intl.NumberFormat`, this is equivalent to `new Intl.NumberFormat(locales, options).format(number)`.\n\n> **Note:** Most of the time, the formatting returned by `toLocaleString()` is consistent. However, the output may vary with time, language, and implementation \u2014 output variations are by design and allowed by the specification. You should not compare the results of `toLocaleString()` to static values.\n\n## Examples\n\n### Using toLocaleString()\n\nBasic use of this method without specifying a `locale` returns a formatted string in the default locale and with default options.\n\n```js\nconst bigint = 3500n;\n\nconsole.log(bigint.toLocaleString());\n// "3,500" if in U.S. English locale\n```\n\n### Checking for support for locales and options parameters\n\nThe `locales` and `options` parameters may not be supported in all implementations, because support for the internationalization API is optional, and some systems may not have the necessary data. For implementations without internationalization support, `toLocaleString()` always uses the system\'s locale, which may not be what you want. Because any implementation that supports the `locales` and `options` parameters must support the {{jsxref("Intl")}} API, you can check the existence of the latter for support:\n\n```js\nfunction toLocaleStringSupportsLocales() {\n  return (\n    typeof Intl === "object" &&\n    !!Intl &&\n    typeof Intl.NumberFormat === "function"\n  );\n}\n```\n\n### Using locales\n\nThis example shows some of the variations in localized number formats. In order to get\nthe format of the language used in the user interface of your application, make sure to\nspecify that language (and possibly some fallback languages) using the\n`locales` argument:\n\n```js\nconst bigint = 123456789123456789n;\n\n// German uses period for thousands\nconsole.log(bigint.toLocaleString("de-DE"));\n// 123.456.789.123.456.789\n\n// Arabic in most Arabic speaking countries uses Eastern Arabic digits\nconsole.log(bigint.toLocaleString("ar-EG"));\n// \u0661\u0662\u0663\u066C\u0664\u0665\u0666\u066C\u0667\u0668\u0669\u066C\u0661\u0662\u0663\u066C\u0664\u0665\u0666\u066C\u0667\u0668\u0669\n\n// India uses thousands/lakh/crore separators\nconsole.log(bigint.toLocaleString("en-IN"));\n// 1,23,45,67,89,12,34,56,789\n\n// the nu extension key requests a numbering system, e.g. Chinese decimal\nconsole.log(bigint.toLocaleString("zh-Hans-CN-u-nu-hanidec"));\n// \u4E00\u4E8C\u4E09,\u56DB\u4E94\u516D,\u4E03\u516B\u4E5D,\u4E00\u4E8C\u4E09,\u56DB\u4E94\u516D,\u4E03\u516B\u4E5D\n\n// when requesting a language that may not be supported, such as\n// Balinese, include a fallback language, in this case Indonesian\nconsole.log(bigint.toLocaleString(["ban", "id"]));\n// 123.456.789.123.456.789\n```\n\n### Using options\n\nThe results provided by `toLocaleString()` can be customized using the `options` parameter:\n\n```js\nconst bigint = 123456789123456789n;\n\n// request a currency format\nconsole.log(\n  bigint.toLocaleString("de-DE", { style: "currency", currency: "EUR" }),\n);\n// 123.456.789.123.456.789,00 \u20AC\n\n// the Japanese yen doesn\'t use a minor unit\nconsole.log(\n  bigint.toLocaleString("ja-JP", { style: "currency", currency: "JPY" }),\n);\n// \uFFE5123,456,789,123,456,789\n\n// limit to three significant digits\nconsole.log(bigint.toLocaleString("en-IN", { maximumSignificantDigits: 3 }));\n// 1,23,00,00,00,00,00,00,000\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Intl.NumberFormat")}}\n- {{jsxref("BigInt.prototype.toString()")}}\n'
        },
        "tostring": {
            "index.md": '---\ntitle: BigInt.prototype.toString()\nslug: Web/JavaScript/Reference/Global_Objects/BigInt/toString\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.BigInt.toString\n---\n\n{{JSRef}}\n\nThe **`toString()`** method of {{jsxref("BigInt")}} values returns a string representing the specified {{jsxref("BigInt")}} value. The trailing "n" is not part of the string.\n\n{{EmbedInteractiveExample("pages/js/bigint-tostring.html")}}\n\n## Syntax\n\n```js-nolint\ntoString()\ntoString(radix)\n```\n\n### Parameters\n\n- `radix` {{optional_inline}}\n  - : An integer in the range 2 through 36 specifying the base to use for representing the BigInt value. Defaults to 10.\n\n### Return value\n\nA string representing the specified {{jsxref("BigInt")}} value.\n\n### Exceptions\n\n- {{jsxref("RangeError")}}\n  - : Thrown if `radix` is less than 2 or greater than 36.\n\n## Description\n\nThe {{jsxref("BigInt")}} object overrides the `toString` method of {{jsxref("Object")}}; it does not inherit\n{{jsxref("Object.prototype.toString()")}}. For {{jsxref("BigInt")}} values, the `toString()` method returns a string representation of the value in the specified radix.\n\nFor radixes above 10, the letters of the alphabet indicate digits greater than 9. For example, for hexadecimal numbers (base 16) `a` through `f` are used.\n\nIf the specified BigInt value is negative, the sign is preserved. This is the case even if the radix is 2; the string returned is the positive binary representation of the BigInt value preceded by a `-` sign, **not** the two\'s complement of the BigInt value.\n\nThe `toString()` method requires its `this` value to be a `BigInt` primitive or wrapper object. It throws a {{jsxref("TypeError")}} for other `this` values without attempting to coerce them to BigInt values.\n\nBecause `BigInt` doesn\'t have a [`[@@toPrimitive]()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol/toPrimitive) method, JavaScript calls the `toString()` method automatically when a `BigInt` _object_ is used in a context expecting a string, such as in a [template literal](/en-US/docs/Web/JavaScript/Reference/Template_literals). However, BigInt _primitive_ values do not consult the `toString()` method to be [coerced to strings](/en-US/docs/Web/JavaScript/Reference/Global_Objects/String#string_coercion) \u2014 rather, they are directly converted using the same algorithm as the initial `toString()` implementation.\n\n```js\nBigInt.prototype.toString = () => "Overridden";\nconsole.log(`${1n}`); // "1"\nconsole.log(`${Object(1n)}`); // "Overridden"\n```\n\n## Examples\n\n### Using toString()\n\n```js\n17n.toString(); // "17"\n66n.toString(2); // "1000010"\n254n.toString(16); // "fe"\n(-10n).toString(2); // "-1010"\n(-0xffn).toString(2); // "-11111111"\n```\n\n### Negative-zero BigInt\n\nThere is no negative-zero `BigInt` as there are no negative zeros in integers. `-0.0` is an IEEE floating-point concept that only appears in the JavaScript [`Number`](/en-US/docs/Web/JavaScript/Data_structures#number_type) type.\n\n```js\n(-0n).toString(); // "0"\nBigInt(-0).toString(); // "0"\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("BigInt.prototype.toLocaleString()")}}\n- {{jsxref("BigInt.prototype.valueOf()")}}\n- {{jsxref("Number.prototype.toString()")}}\n'
        },
        "valueof": {
            "index.md": '---\ntitle: BigInt.prototype.valueOf()\nslug: Web/JavaScript/Reference/Global_Objects/BigInt/valueOf\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.BigInt.valueOf\n---\n\n{{JSRef}}\n\nThe **`valueOf()`** method of {{jsxref("BigInt")}} values returns the wrapped primitive value\nof a {{jsxref("BigInt")}} object.\n\n{{EmbedInteractiveExample("pages/js/bigint-valueof.html", "shorter")}}\n\n## Syntax\n\n```js-nolint\nvalueOf()\n```\n\n### Parameters\n\nNone.\n\n### Return value\n\nA BigInt representing the primitive value of the specified {{jsxref("BigInt")}} object.\n\n## Examples\n\n### Using `valueOf`\n\n```js\ntypeof Object(1n); // object\ntypeof Object(1n).valueOf(); // bigint\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("BigInt.prototype.toString()")}}\n'
        }
    },
    "bigint64array": {
        "bigint64array": {
            "index.md": '---\ntitle: BigInt64Array() constructor\nslug: Web/JavaScript/Reference/Global_Objects/BigInt64Array/BigInt64Array\npage-type: javascript-constructor\nbrowser-compat: javascript.builtins.BigInt64Array.BigInt64Array\n---\n\n{{JSRef}}\n\nThe **`BigInt64Array()`** constructor creates {{jsxref("BigInt64Array")}} objects. The contents are initialized to `0n`.\n\n## Syntax\n\n```js-nolint\nnew BigInt64Array()\nnew BigInt64Array(length)\nnew BigInt64Array(typedArray)\nnew BigInt64Array(object)\n\nnew BigInt64Array(buffer)\nnew BigInt64Array(buffer, byteOffset)\nnew BigInt64Array(buffer, byteOffset, length)\n```\n\n> **Note:** `BigInt64Array()` can only be constructed with [`new`](/en-US/docs/Web/JavaScript/Reference/Operators/new). Attempting to call it without `new` throws a {{jsxref("TypeError")}}.\n\n### Parameters\n\nSee [`TypedArray`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/TypedArray#parameters).\n\n### Exceptions\n\nSee [`TypedArray`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/TypedArray#exceptions).\n\n## Examples\n\n### Different ways to create a BigInt64Array\n\n```js\n// From a length\nconst bigint64 = new BigInt64Array(2);\nbigint64[0] = 42n;\nconsole.log(bigint64[0]); // 42n\nconsole.log(bigint64.length); // 2\nconsole.log(bigint64.BYTES_PER_ELEMENT); // 8\n\n// From an array\nconst x = new BigInt64Array([21n, 31n]);\nconsole.log(x[1]); // 31n\n\n// From another TypedArray\nconst y = new BigInt64Array(x);\nconsole.log(y[0]); // 21n\n\n// From an ArrayBuffer\nconst buffer = new ArrayBuffer(64);\nconst z = new BigInt64Array(buffer, 8, 4);\nconsole.log(z.byteOffset); // 8\n\n// From an iterable\nconst iterable = (function* () {\n  yield* [1n, 2n, 3n];\n})();\nconst bigint64FromIterable = new BigInt64Array(iterable);\nconsole.log(bigint64FromIterable);\n// BigInt64Array [1n, 2n, 3n]\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [JavaScript typed arrays](/en-US/docs/Web/JavaScript/Guide/Typed_arrays) guide\n- {{jsxref("TypedArray")}}\n- {{jsxref("ArrayBuffer")}}\n- {{jsxref("DataView")}}\n'
        },
        "index.md": '---\ntitle: BigInt64Array\nslug: Web/JavaScript/Reference/Global_Objects/BigInt64Array\npage-type: javascript-class\nbrowser-compat: javascript.builtins.BigInt64Array\n---\n\n{{JSRef}}\n\nThe **`BigInt64Array`** typed array represents an array of 64-bit signed integers in the platform byte order. If control over byte order is needed, use {{jsxref("DataView")}} instead. The contents are initialized to `0n`. Once established, you can reference elements in the array using the object\'s methods, or using standard array index syntax (that is, using bracket notation).\n\n`BigInt64Array` is a subclass of the hidden {{jsxref("TypedArray")}} class.\n\n{{EmbedInteractiveExample("pages/js/typedarray-bigint64.html", "taller")}}\n\n## Constructor\n\n- {{jsxref("BigInt64Array/BigInt64Array", "BigInt64Array()")}}\n  - : Creates a new `BigInt64Array` object.\n\n## Static properties\n\n_Also inherits static properties from its parent {{jsxref("TypedArray")}}_.\n\n- {{jsxref("TypedArray/BYTES_PER_ELEMENT", "BigInt64Array.BYTES_PER_ELEMENT")}}\n  - : Returns a number value of the element size. `8` in the case of `BigInt64Array`.\n\n## Static methods\n\n_Inherits static methods from its parent {{jsxref("TypedArray")}}_.\n\n## Instance properties\n\n_Also inherits instance properties from its parent {{jsxref("TypedArray")}}_.\n\nThese properties are defined on `BigInt64Array.prototype` and shared by all `BigInt64Array` instances.\n\n- {{jsxref("TypedArray/BYTES_PER_ELEMENT", "BigInt64Array.prototype.BYTES_PER_ELEMENT")}}\n  - : Returns a number value of the element size. `8` in the case of a `BigInt64Array`.\n- {{jsxref("Object/constructor", "BigInt64Array.prototype.constructor")}}\n  - : The constructor function that created the instance object. For `BigInt64Array` instances, the initial value is the {{jsxref("BigInt64Array/BigInt64Array", "BigInt64Array")}} constructor.\n\n## Instance methods\n\n_Inherits instance methods from its parent {{jsxref("TypedArray")}}_.\n\n## Examples\n\n### Different ways to create a BigInt64Array\n\n```js\n// From a length\nconst bigint64 = new BigInt64Array(2);\nbigint64[0] = 42n;\nconsole.log(bigint64[0]); // 42n\nconsole.log(bigint64.length); // 2\nconsole.log(bigint64.BYTES_PER_ELEMENT); // 8\n\n// From an array\nconst x = new BigInt64Array([21n, 31n]);\nconsole.log(x[1]); // 31n\n\n// From another TypedArray\nconst y = new BigInt64Array(x);\nconsole.log(y[0]); // 21n\n\n// From an ArrayBuffer\nconst buffer = new ArrayBuffer(64);\nconst z = new BigInt64Array(buffer, 8, 4);\nconsole.log(z.byteOffset); // 8\n\n// From an iterable\nconst iterable = (function* () {\n  yield* [1n, 2n, 3n];\n})();\nconst bigint64FromIterable = new BigInt64Array(iterable);\nconsole.log(bigint64FromIterable);\n// BigInt64Array [1n, 2n, 3n]\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [JavaScript typed arrays](/en-US/docs/Web/JavaScript/Guide/Typed_arrays) guide\n- {{jsxref("TypedArray")}}\n- {{jsxref("ArrayBuffer")}}\n- {{jsxref("DataView")}}\n'
    },
    "biguint64array": {
        "biguint64array": {
            "index.md": '---\ntitle: BigUint64Array() constructor\nslug: Web/JavaScript/Reference/Global_Objects/BigUint64Array/BigUint64Array\npage-type: javascript-constructor\nbrowser-compat: javascript.builtins.BigUint64Array.BigUint64Array\n---\n\n{{JSRef}}\n\nThe **`BigUint64Array()`** constructor creates {{jsxref("BigUint64Array")}} objects. The contents are initialized to `0n`.\n\n## Syntax\n\n```js-nolint\nnew BigUint64Array()\nnew BigUint64Array(length)\nnew BigUint64Array(typedArray)\nnew BigUint64Array(object)\n\nnew BigUint64Array(buffer)\nnew BigUint64Array(buffer, byteOffset)\nnew BigUint64Array(buffer, byteOffset, length)\n```\n\n> **Note:** `BigUint64Array()` can only be constructed with [`new`](/en-US/docs/Web/JavaScript/Reference/Operators/new). Attempting to call it without `new` throws a {{jsxref("TypeError")}}.\n\n### Parameters\n\nSee [`TypedArray`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/TypedArray#parameters).\n\n### Exceptions\n\nSee [`TypedArray`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/TypedArray#exceptions).\n\n## Examples\n\n### Different ways to create a BigUint64Array\n\n```js\n// From a length\nconst biguint64 = new BigUint64Array(2);\nbiguint64[0] = 42n;\nconsole.log(biguint64[0]); // 42n\nconsole.log(biguint64.length); // 2\nconsole.log(biguint64.BYTES_PER_ELEMENT); // 8\n\n// From an array\nconst x = new BigUint64Array([21n, 31n]);\nconsole.log(x[1]); // 31n\n\n// From another TypedArray\nconst y = new BigUint64Array(x);\nconsole.log(y[0]); // 21n\n\n// From an ArrayBuffer\nconst buffer = new ArrayBuffer(64);\nconst z = new BigUint64Array(buffer, 8, 4);\nconsole.log(z.byteOffset); // 8\n\n// From an iterable\nconst iterable = (function* () {\n  yield* [1n, 2n, 3n];\n})();\nconst biguint64FromIterable = new BigUint64Array(iterable);\nconsole.log(biguint64FromIterable);\n// BigUint64Array [1n, 2n, 3n]\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [JavaScript typed arrays](/en-US/docs/Web/JavaScript/Guide/Typed_arrays) guide\n- {{jsxref("TypedArray")}}\n- {{jsxref("ArrayBuffer")}}\n- {{jsxref("DataView")}}\n'
        },
        "index.md": '---\ntitle: BigUint64Array\nslug: Web/JavaScript/Reference/Global_Objects/BigUint64Array\npage-type: javascript-class\nbrowser-compat: javascript.builtins.BigUint64Array\n---\n\n{{JSRef}}\n\nThe **`BigUint64Array`** typed array represents an array of 64-bit unsigned integers in the platform byte order. If control over byte order is needed, use {{jsxref("DataView")}} instead. The contents are initialized to `0n`. Once established, you can reference elements in the array using the object\'s methods, or using standard array index syntax (that is, using bracket notation).\n\n`BigUint64Array` is a subclass of the hidden {{jsxref("TypedArray")}} class.\n\n## Constructor\n\n- {{jsxref("BigUint64Array/BigUint64Array", "BigUint64Array()")}}\n  - : Creates a new `BigUint64Array` object.\n\n## Static properties\n\n_Also inherits static properties from its parent {{jsxref("TypedArray")}}_.\n\n- {{jsxref("TypedArray/BYTES_PER_ELEMENT", "BigUint64Array.BYTES_PER_ELEMENT")}}\n  - : Returns a number value of the element size. `8` in the case of `BigUint64Array`.\n\n## Static methods\n\n_Inherits static methods from its parent {{jsxref("TypedArray")}}_.\n\n## Instance properties\n\n_Also inherits instance properties from its parent {{jsxref("TypedArray")}}_.\n\nThese properties are defined on `BigUint64Array.prototype` and shared by all `BigUint64Array` instances.\n\n- {{jsxref("TypedArray/BYTES_PER_ELEMENT", "BigUint64Array.prototype.BYTES_PER_ELEMENT")}}\n  - : Returns a number value of the element size. `8` in the case of a `BigUint64Array`.\n- {{jsxref("Object/constructor", "BigUint64Array.prototype.constructor")}}\n  - : The constructor function that created the instance object. For `BigUint64Array` instances, the initial value is the {{jsxref("BigUint64Array/BigUint64Array", "BigUint64Array")}} constructor.\n\n## Instance methods\n\n_Inherits instance methods from its parent {{jsxref("TypedArray")}}_.\n\n## Examples\n\n### Different ways to create a BigUint64Array\n\n```js\n// From a length\nconst biguint64 = new BigUint64Array(2);\nbiguint64[0] = 42n;\nconsole.log(biguint64[0]); // 42n\nconsole.log(biguint64.length); // 2\nconsole.log(biguint64.BYTES_PER_ELEMENT); // 8\n\n// From an array\nconst x = new BigUint64Array([21n, 31n]);\nconsole.log(x[1]); // 31n\n\n// From another TypedArray\nconst y = new BigUint64Array(x);\nconsole.log(y[0]); // 21n\n\n// From an ArrayBuffer\nconst buffer = new ArrayBuffer(64);\nconst z = new BigUint64Array(buffer, 8, 4);\nconsole.log(z.byteOffset); // 8\n\n// From an iterable\nconst iterable = (function* () {\n  yield* [1n, 2n, 3n];\n})();\nconst biguint64FromIterable = new BigUint64Array(iterable);\nconsole.log(biguint64FromIterable);\n// BigUint64Array [1n, 2n, 3n]\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [JavaScript typed arrays](/en-US/docs/Web/JavaScript/Guide/Typed_arrays) guide\n- {{jsxref("TypedArray")}}\n- {{jsxref("ArrayBuffer")}}\n- {{jsxref("DataView")}}\n'
    },
    "boolean": {
        "boolean": {
            "index.md": '---\ntitle: Boolean() constructor\nslug: Web/JavaScript/Reference/Global_Objects/Boolean/Boolean\npage-type: javascript-constructor\nbrowser-compat: javascript.builtins.Boolean.Boolean\n---\n\n{{JSRef}}\n\nThe **`Boolean()`** constructor creates {{jsxref("Boolean")}} objects. When called as a function, it returns primitive values of type Boolean.\n\n{{EmbedInteractiveExample("pages/js/boolean-constructor.html", "shorter")}}\n\n## Syntax\n\n```js-nolint\nnew Boolean(value)\nBoolean(value)\n```\n\n> **Note:** `Boolean()` can be called with or without [`new`](/en-US/docs/Web/JavaScript/Reference/Operators/new), but with different effects. See [Return value](#return_value).\n\n### Parameters\n\n- `value`\n  - : The initial value of the `Boolean` object.\n\n### Return value\n\nWhen `Boolean()` is called as a constructor (with [`new`](/en-US/docs/Web/JavaScript/Reference/Operators/new)), it creates a {{jsxref("Boolean")}} object, which is **not** a primitive.\n\nWhen `Boolean()` is called as a function (without `new`), it coerces the parameter to a boolean primitive.\n\n> **Warning:** You should rarely find yourself using `Boolean` as a constructor.\n\n## Description\n\nThe value passed as the first parameter is [converted to a boolean value](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Boolean#boolean_coercion). If the value is omitted or is `0`, `-0`, `0n`, [`null`](/en-US/docs/Web/JavaScript/Reference/Operators/null), `false`, {{jsxref("NaN")}}, {{jsxref("undefined")}}, or the empty string (`""`), then the object has an initial value of `false`. All other values, including any object, an empty array (`[]`), or the string `"false"`, create an object with an initial value of `true`.\n\n> **Note:** When the non-standard property [`document.all`](/en-US/docs/Web/API/Document/all) is used as an argument for this constructor, the result is a `Boolean` object with the value `false`. This property is legacy and non-standard and should not be used.\n\n## Examples\n\n### Creating Boolean objects with an initial value of false\n\n```js\nconst bZero = new Boolean(0);\nconst bNull = new Boolean(null);\nconst bEmptyString = new Boolean("");\nconst bfalse = new Boolean(false);\n\ntypeof bfalse; // "object"\nBoolean(bfalse); // true\n```\n\nNote how converting a `Boolean` object to a primitive with `Boolean()` always yields `true`, even if the object holds a value of `false`. You are therefore always advised to avoid constructing `Boolean` wrapper objects.\n\nIf you need to take the primitive value out from the wrapper object, instead of using the `Boolean()` function, use the object\'s [`valueOf()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Boolean/valueOf) method instead.\n\n```js\nconst bfalse = new Boolean(false);\n\nbfalse.valueOf(); // false\n```\n\n### Creating `Boolean` objects with an initial value of `true`\n\n```js\nconst btrue = new Boolean(true);\nconst btrueString = new Boolean("true");\nconst bfalseString = new Boolean("false");\nconst bSuLin = new Boolean("Su Lin");\nconst bArrayProto = new Boolean([]);\nconst bObjProto = new Boolean({});\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Boolean](/en-US/docs/Glossary/Boolean)\n'
        },
        "index.md": '---\ntitle: Boolean\nslug: Web/JavaScript/Reference/Global_Objects/Boolean\npage-type: javascript-class\nbrowser-compat: javascript.builtins.Boolean\n---\n\n{{JSRef}}\n\nThe **`Boolean`** object represents a truth value: `true` or `false`.\n\n## Description\n\n### Boolean primitives and Boolean objects\n\nDo not confuse the {{Glossary("Primitive", "primitive")}} `Boolean` values `true` and `false` with the `true` and `false` values of the `Boolean` object.\n\n**Any** object, including a `Boolean` object whose value is `false`, evaluates to `true` when passed to a conditional statement. For example, the condition in the following {{jsxref("Statements/if...else", "if")}} statement evaluates to `true`:\n\n```js\nconst x = new Boolean(false);\nif (x) {\n  // this code is executed\n}\n```\n\nThis behavior does not apply to `Boolean` primitives. For example, the condition in the following {{jsxref("Statements/if...else", "if")}} statement evaluates to `false`:\n\n```js\nconst x = false;\nif (x) {\n  // this code is not executed\n}\n```\n\nDo not use the `Boolean()` constructor with `new` to convert a non-boolean value to a boolean value \u2014 use `Boolean` as a function or a [double NOT](/en-US/docs/Web/JavaScript/Reference/Operators/Logical_NOT#double_not_!!) instead:\n\n```js\nconst good = Boolean(expression); // use this\nconst good2 = !!expression; // or this\nconst bad = new Boolean(expression); // don\'t use this!\n```\n\nIf you specify any object, including a `Boolean` object whose value is `false`, as the initial value of a `Boolean` object, the new `Boolean` object has a value of `true`.\n\n```js\nconst myFalse = new Boolean(false); // initial value of false\nconst g = Boolean(myFalse); // initial value of true\nconst myString = new String("Hello"); // string object\nconst s = Boolean(myString); // initial value of true\n```\n\n> **Warning:** You should rarely find yourself using `Boolean` as a constructor.\n\n### Boolean coercion\n\nMany built-in operations that expect booleans first coerce their arguments to booleans. [The operation](https://tc39.es/ecma262/multipage/abstract-operations.html#sec-toboolean) can be summarized as follows:\n\n- Booleans are returned as-is.\n- [`undefined`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/undefined) turns into `false`.\n- [`null`](/en-US/docs/Web/JavaScript/Reference/Operators/null) turns into `false`.\n- `0`, `-0`, and `NaN` turn into `false`; other numbers turn into `true`.\n- `0n` turns into `false`; other [BigInts](/en-US/docs/Web/JavaScript/Reference/Global_Objects/BigInt) turn into `true`.\n- The empty string `""` turns into `false`; other strings turn into `true`.\n- [Symbols](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol) turn into `true`.\n- All objects become `true`.\n\n> **Note:** A legacy behavior makes [`document.all`](/en-US/docs/Web/API/Document/all) return `false` when used as a boolean, despite it being an object. This property is legacy and non-standard and should not be used.\n\n> **Note:** Unlike other type conversions like [string coercion](/en-US/docs/Web/JavaScript/Reference/Global_Objects/String#string_coercion) or [number coercion](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number#number_coercion), boolean coercion does not attempt to convert objects to primitives.\n\nIn other words, there are only a handful of values that get coerced to `false` \u2014 these are called [falsy](/en-US/docs/Glossary/Falsy) values. All other values are called [truthy](/en-US/docs/Glossary/Truthy) values. A value\'s truthiness is important when used with logical operators, conditional statements, or any boolean context.\n\nThere are two ways to achieve the same effect in JavaScript.\n\n- [Double NOT](/en-US/docs/Web/JavaScript/Reference/Operators/Logical_NOT#double_not_!!): `!!x` negates `x` twice, which converts `x` to a boolean using the same algorithm as above.\n- The [`Boolean()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Boolean/Boolean) function: `Boolean(x)` uses the same algorithm as above to convert `x`.\n\nNote that truthiness is not the same as being [loosely equal](/en-US/docs/Web/JavaScript/Reference/Operators/Equality) to `true` or `false`.\n\n```js\nif ([]) {\n  console.log("[] is truthy");\n}\nif ([] == false) {\n  console.log("[] == false");\n}\n// [] is truthy\n// [] == false\n```\n\n`[]` is truthy, but it\'s also loosely equal to `false`. It\'s truthy, because all objects are truthy. However, when comparing with `false`, which is a primitive, `[]` is also converted to a primitive, which is `""` via {{jsxref("Array.prototype.toString()")}}. Comparing strings and booleans results in both being [converted to numbers](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number#number_coercion), and they both become `0`, so `[] == false` is `true`. In general, falsiness and `== false` differ in the following cases:\n\n- `NaN`, `undefined`, and `null` are falsy but not loosely equal to `false`.\n- `"0"` (and other string literals that are not `""` but [get coerced to 0](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number#number_coercion)) is truthy but loosely equal to `false`.\n- Objects are always truthy, but their primitive representation may be loosely equal to `false`.\n\nTruthy values are even more unlikely to be loosely equal to `true`. All values are either truthy or falsy, but most values are loosely equal to neither `true` nor `false`.\n\n## Constructor\n\n- {{jsxref("Boolean/Boolean", "Boolean()")}}\n  - : Creates a new `Boolean` object.\n\n## Instance properties\n\nThese properties are defined on `Boolean.prototype` and shared by all `Boolean` instances.\n\n- {{jsxref("Object/constructor", "Boolean.prototype.constructor")}}\n  - : The constructor function that created the instance object. For `Boolean` instances, the initial value is the {{jsxref("Boolean/Boolean", "Boolean")}} constructor.\n\n## Instance methods\n\n- {{jsxref("Boolean.prototype.toString()")}}\n  - : Returns a string of either `true` or `false` depending upon the value of the object. Overrides the {{jsxref("Object.prototype.toString()")}} method.\n- {{jsxref("Boolean.prototype.valueOf()")}}\n  - : Returns the primitive value of the {{jsxref("Boolean")}} object. Overrides the {{jsxref("Object.prototype.valueOf()")}} method.\n\n## Examples\n\n### Creating Boolean objects with an initial value of false\n\n```js\nconst bNoParam = new Boolean();\nconst bZero = new Boolean(0);\nconst bNull = new Boolean(null);\nconst bEmptyString = new Boolean("");\nconst bfalse = new Boolean(false);\n```\n\n### Creating Boolean objects with an initial value of true\n\n```js\nconst btrue = new Boolean(true);\nconst btrueString = new Boolean("true");\nconst bfalseString = new Boolean("false");\nconst bSuLin = new Boolean("Su Lin");\nconst bArrayProto = new Boolean([]);\nconst bObjProto = new Boolean({});\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Boolean](/en-US/docs/Glossary/Boolean)\n- [Boolean primitives](/en-US/docs/Web/JavaScript/Data_structures#boolean_type)\n- [Boolean data type](https://en.wikipedia.org/wiki/Boolean_data_type) on Wikipedia\n',
        "tostring": {
            "index.md": '---\ntitle: Boolean.prototype.toString()\nslug: Web/JavaScript/Reference/Global_Objects/Boolean/toString\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Boolean.toString\n---\n\n{{JSRef}}\n\nThe **`toString()`** method of {{jsxref("Boolean")}} values returns a string representing the specified boolean value.\n\n{{EmbedInteractiveExample("pages/js/boolean-tostring.html")}}\n\n## Syntax\n\n```js-nolint\ntoString()\n```\n\n### Parameters\n\nNone.\n\n### Return value\n\nA string representing the specified boolean value.\n\n## Description\n\nThe {{jsxref("Boolean")}} object overrides the `toString` method of {{jsxref("Object")}}; it does not inherit\n{{jsxref("Object.prototype.toString()")}}. For `Boolean` values, the `toString` method returns a string representation of the boolean value, which is either `"true"` or `"false"`.\n\nThe `toString()` method requires its `this` value to be a `Boolean` primitive or wrapper object. It throws a {{jsxref("TypeError")}} for other `this` values without attempting to coerce them to boolean values.\n\nBecause `Boolean` doesn\'t have a [`[@@toPrimitive]()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol/toPrimitive) method, JavaScript calls the `toString()` method automatically when a `Boolean` _object_ is used in a context expecting a string, such as in a [template literal](/en-US/docs/Web/JavaScript/Reference/Template_literals). However, boolean _primitive_ values do not consult the `toString()` method to be [coerced to strings](/en-US/docs/Web/JavaScript/Reference/Global_Objects/String#string_coercion) \u2014 rather, they are directly converted using the same algorithm as the initial `toString()` implementation.\n\n```js\nBoolean.prototype.toString = () => "Overridden";\nconsole.log(`${true}`); // "true"\nconsole.log(`${new Boolean(true)}`); // "Overridden"\n```\n\n## Examples\n\n### Using toString()\n\n```js\nconst flag = new Boolean(true);\nconsole.log(flag.toString()); // "true"\nconsole.log(false.toString()); // "false"\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Object.prototype.toString()")}}\n'
        },
        "valueof": {
            "index.md": '---\ntitle: Boolean.prototype.valueOf()\nslug: Web/JavaScript/Reference/Global_Objects/Boolean/valueOf\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Boolean.valueOf\n---\n\n{{JSRef}}\n\nThe **`valueOf()`** method of {{jsxref("Boolean")}} values returns the primitive value of a\n{{jsxref("Boolean")}} object.\n\n{{EmbedInteractiveExample("pages/js/boolean-valueof.html")}}\n\n## Syntax\n\n```js-nolint\nvalueOf()\n```\n\n### Parameters\n\nNone.\n\n### Return value\n\nThe primitive value of the given {{jsxref("Boolean")}} object.\n\n## Description\n\nThe `valueOf()` method of {{jsxref("Boolean")}} returns the primitive value\nof a `Boolean` object or literal `Boolean` as a Boolean data type.\n\nThis method is usually called internally by JavaScript and not explicitly in code.\n\n## Examples\n\n### Using `valueOf()`\n\n```js\nx = new Boolean();\nmyVar = x.valueOf(); // assigns false to myVar\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Object.prototype.valueOf()")}}\n'
        }
    },
    "dataview": {
        "buffer": {
            "index.md": '---\ntitle: DataView.prototype.buffer\nslug: Web/JavaScript/Reference/Global_Objects/DataView/buffer\npage-type: javascript-instance-accessor-property\nbrowser-compat: javascript.builtins.DataView.buffer\n---\n\n{{JSRef}}\n\nThe **`buffer`** accessor property of {{jsxref("DataView")}} instances returns the {{jsxref("ArrayBuffer")}} or {{jsxref("SharedArrayBuffer")}} referenced by this view at construction time.\n\n{{EmbedInteractiveExample("pages/js/dataview-buffer.html")}}\n\n## Description\n\nThe `buffer` property is an accessor property whose set accessor function is `undefined`, meaning that you can only read this property. The value is established when the `DataView` is constructed and cannot be changed.\n\n## Examples\n\n### Using the buffer property\n\n```js\nconst buffer = new ArrayBuffer(8);\nconst dataview = new DataView(buffer);\ndataview.buffer; // ArrayBuffer { byteLength: 8 }\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("DataView")}}\n- {{jsxref("ArrayBuffer")}}\n- {{jsxref("SharedArrayBuffer")}}\n'
        },
        "bytelength": {
            "index.md": '---\ntitle: DataView.prototype.byteLength\nslug: Web/JavaScript/Reference/Global_Objects/DataView/byteLength\npage-type: javascript-instance-accessor-property\nbrowser-compat: javascript.builtins.DataView.byteLength\n---\n\n{{JSRef}}\n\nThe **`byteLength`** accessor property of {{jsxref("DataView")}} instances returns the length (in bytes) of this view.\n\n{{EmbedInteractiveExample("pages/js/dataview-bytelength.html")}}\n\n## Description\n\nThe `byteLength` property is an accessor property whose set accessor function is `undefined`, meaning that you can only read this property. The value is established when an `DataView` is constructed and cannot be changed. If the `DataView` is not specifying an offset or a `byteLength`, the `byteLength` of the referenced `ArrayBuffer` or `SharedArrayBuffer` will be returned.\n\n## Examples\n\n### Using the byteLength property\n\n```js\nconst buffer = new ArrayBuffer(8);\nconst dataview = new DataView(buffer);\ndataview.byteLength; // 8 (matches the byteLength of the buffer)\n\nconst dataview2 = new DataView(buffer, 1, 5);\ndataview2.byteLength; // 5 (as specified when constructing the DataView)\n\nconst dataview3 = new DataView(buffer, 2);\ndataview3.byteLength; // 6 (due to the offset of the constructed DataView)\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("DataView")}}\n- {{jsxref("ArrayBuffer")}}\n- {{jsxref("SharedArrayBuffer")}}\n'
        },
        "byteoffset": {
            "index.md": '---\ntitle: DataView.prototype.byteOffset\nslug: Web/JavaScript/Reference/Global_Objects/DataView/byteOffset\npage-type: javascript-instance-accessor-property\nbrowser-compat: javascript.builtins.DataView.byteOffset\n---\n\n{{JSRef}}\n\nThe **`byteOffset`** accessor property of {{jsxref("DataView")}} instances returns the offset (in bytes) of this view from the start of its {{jsxref("ArrayBuffer")}} or {{jsxref("SharedArrayBuffer")}}.\n\n{{EmbedInteractiveExample("pages/js/dataview-byteoffset.html")}}\n\n## Description\n\nThe `byteOffset` property is an accessor property whose set accessor function is `undefined`, meaning that you can only read this property. The value is established when an `DataView` is constructed and cannot be changed.\n\n## Examples\n\n### Using the byteOffset property\n\n```js\nconst buffer = new ArrayBuffer(8);\nconst dataview = new DataView(buffer);\ndataview.byteOffset; // 0 (no offset specified)\n\nconst dataview2 = new DataView(buffer, 3);\ndataview2.byteOffset; // 3 (as specified when constructing the DataView)\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("DataView")}}\n- {{jsxref("ArrayBuffer")}}\n- {{jsxref("SharedArrayBuffer")}}\n'
        },
        "dataview": {
            "index.md": '---\ntitle: DataView() constructor\nslug: Web/JavaScript/Reference/Global_Objects/DataView/DataView\npage-type: javascript-constructor\nbrowser-compat: javascript.builtins.DataView.DataView\n---\n\n{{JSRef}}\n\nThe **`DataView()`** constructor creates {{jsxref("DataView")}} objects.\n\n{{EmbedInteractiveExample("pages/js/dataview-constructor.html")}}\n\n## Syntax\n\n```js-nolint\nnew DataView(buffer)\nnew DataView(buffer, byteOffset)\nnew DataView(buffer, byteOffset, byteLength)\n```\n\n> **Note:** `DataView()` can only be constructed with [`new`](/en-US/docs/Web/JavaScript/Reference/Operators/new). Attempting to call it without `new` throws a {{jsxref("TypeError")}}.\n\n### Parameters\n\n- `buffer`\n  - : An existing {{jsxref("ArrayBuffer")}} or {{jsxref("SharedArrayBuffer")}} to use as\n    the storage backing the new `DataView` object.\n- `byteOffset` {{optional_inline}}\n  - : The offset, in bytes, to the first byte in the above buffer for the new view to\n    reference. If unspecified, the buffer view starts with the first byte.\n- `byteLength` {{optional_inline}}\n  - : The number of elements in the byte array. If unspecified, the view\'s length will\n    match the buffer\'s length.\n\n### Return value\n\nA new {{jsxref("DataView")}} object representing the specified data buffer.\n\n### Exceptions\n\n- {{jsxref("RangeError")}}\n  - : Thrown if the `byteOffset` or `byteLength` parameter values result in the view extending past the end of the buffer. In other words, `byteOffset + byteLength > buffer.byteLength`.\n\n## Examples\n\n### Using DataView\n\n```js\nconst buffer = new ArrayBuffer(16);\nconst view = new DataView(buffer, 0);\n\nview.setInt16(1, 42);\nview.getInt16(1); // 42\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `DataView` in `core-js`](https://github.com/zloirock/core-js#ecmascript-typed-arrays)\n- {{jsxref("DataView")}}\n'
        },
        "getbigint64": {
            "index.md": '---\ntitle: DataView.prototype.getBigInt64()\nslug: Web/JavaScript/Reference/Global_Objects/DataView/getBigInt64\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.DataView.getBigInt64\n---\n\n{{JSRef}}\n\nThe **`getBigInt64()`** method of {{jsxref("DataView")}} instances reads 8 bytes starting at the specified byte offset of this `DataView` and interprets them as a 64-bit signed integer. There is no alignment constraint; multi-byte values may be fetched from any offset within bounds.\n\n{{EmbedInteractiveExample("pages/js/dataview-getbigint64.html")}}\n\n## Syntax\n\n```js-nolint\ngetBigInt64(byteOffset)\ngetBigInt64(byteOffset, littleEndian)\n```\n\n### Parameters\n\n- `byteOffset`\n  - : The offset, in bytes, from the start of the view to read the data from.\n- `littleEndian` {{optional_inline}}\n  - : Indicates whether the data is stored in [little- or big-endian](/en-US/docs/Glossary/Endianness) format. If `false` or `undefined`, a big-endian value is read.\n\n### Return value\n\nA {{jsxref("BigInt")}} from -2<sup>63</sup> to 2<sup>63</sup>-1, inclusive.\n\n### Exceptions\n\n- {{jsxref("RangeError")}}\n  - : Thrown if the `byteOffset` is set such that it would read beyond the end of the view.\n\n## Examples\n\n### Using getBigInt64()\n\n```js\nconst { buffer } = new Uint8Array([0, 1, 2, 3, 4, 5, 6, 7, 8, 9]);\nconst dataview = new DataView(buffer);\nconsole.log(dataview.getBigInt64(1)); // 72623859790382856n\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [JavaScript typed arrays](/en-US/docs/Web/JavaScript/Guide/Typed_arrays) guide\n- {{jsxref("DataView")}}\n- {{jsxref("ArrayBuffer")}}\n- {{jsxref("BigInt64Array")}}\n'
        },
        "getbiguint64": {
            "index.md": '---\ntitle: DataView.prototype.getBigUint64()\nslug: Web/JavaScript/Reference/Global_Objects/DataView/getBigUint64\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.DataView.getBigUint64\n---\n\n{{JSRef}}\n\nThe **`getBigUint64()`** method of {{jsxref("DataView")}} instances reads 8 bytes starting at the specified byte offset of this `DataView` and interprets them as a 64-bit unsigned integer. There is no alignment constraint; multi-byte values may be fetched from any offset within bounds.\n\n{{EmbedInteractiveExample("pages/js/dataview-getbiguint64.html")}}\n\n## Syntax\n\n```js-nolint\ngetBigUint64(byteOffset)\ngetBigUint64(byteOffset, littleEndian)\n```\n\n### Parameters\n\n- `byteOffset`\n  - : The offset, in bytes, from the start of the view to read the data from.\n- `littleEndian` {{optional_inline}}\n  - : Indicates whether the data is stored in [little- or big-endian](/en-US/docs/Glossary/Endianness) format. If `false` or `undefined`, a big-endian value is read.\n\n### Return value\n\nA {{jsxref("BigInt")}} from 0 to 2<sup>64</sup>-1, inclusive.\n\n### Exceptions\n\n- {{jsxref("RangeError")}}\n  - : Thrown if the `byteOffset` is set such that it would read beyond the end of the view.\n\n## Examples\n\n### Using getBigUint64()\n\n```js\nconst { buffer } = new Uint8Array([0, 1, 2, 3, 4, 5, 6, 7, 8, 9]);\nconst dataview = new DataView(buffer);\nconsole.log(dataview.getBigUint64(1)); // 72623859790382856n\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [JavaScript typed arrays](/en-US/docs/Web/JavaScript/Guide/Typed_arrays) guide\n- {{jsxref("DataView")}}\n- {{jsxref("ArrayBuffer")}}\n- {{jsxref("BigUint64Array")}}\n'
        },
        "getfloat32": {
            "index.md": '---\ntitle: DataView.prototype.getFloat32()\nslug: Web/JavaScript/Reference/Global_Objects/DataView/getFloat32\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.DataView.getFloat32\n---\n\n{{JSRef}}\n\nThe **`getFloat32()`** method of {{jsxref("DataView")}} instances reads 4 bytes starting at the specified byte offset of this `DataView` and interprets them as a 32-bit floating point number. There is no alignment constraint; multi-byte values may be fetched from any offset within bounds.\n\n{{EmbedInteractiveExample("pages/js/dataview-getfloat32.html")}}\n\n## Syntax\n\n```js-nolint\ngetFloat32(byteOffset)\ngetFloat32(byteOffset, littleEndian)\n```\n\n### Parameters\n\n- `byteOffset`\n  - : The offset, in bytes, from the start of the view to read the data from.\n- `littleEndian` {{optional_inline}}\n  - : Indicates whether the data is stored in [little- or big-endian](/en-US/docs/Glossary/Endianness) format. If `false` or `undefined`, a big-endian value is read.\n\n### Return value\n\nA floating point number from `-3.4e38` to `3.4e38`.\n\n### Exceptions\n\n- {{jsxref("RangeError")}}\n  - : Thrown if the `byteOffset` is set such that it would read beyond the end of the view.\n\n## Examples\n\n### Using getFloat32()\n\n```js\nconst { buffer } = new Uint8Array([0, 1, 2, 3, 4, 5, 6, 7, 8, 9]);\nconst dataview = new DataView(buffer);\nconsole.log(dataview.getFloat32(1)); // 2.387939260590663e-38\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [JavaScript typed arrays](/en-US/docs/Web/JavaScript/Guide/Typed_arrays) guide\n- {{jsxref("DataView")}}\n- {{jsxref("ArrayBuffer")}}\n- {{jsxref("Float32Array")}}\n'
        },
        "getfloat64": {
            "index.md": '---\ntitle: DataView.prototype.getFloat64()\nslug: Web/JavaScript/Reference/Global_Objects/DataView/getFloat64\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.DataView.getFloat64\n---\n\n{{JSRef}}\n\nThe **`getFloat64()`** method of {{jsxref("DataView")}} instances reads 8 bytes starting at the specified byte offset of this `DataView` and interprets them as a 64-bit floating point number. There is no alignment constraint; multi-byte values may be fetched from any offset within bounds.\n\n{{EmbedInteractiveExample("pages/js/dataview-getfloat64.html")}}\n\n## Syntax\n\n```js-nolint\ngetFloat64(byteOffset)\ngetFloat64(byteOffset, littleEndian)\n```\n\n### Parameters\n\n- `byteOffset`\n  - : The offset, in bytes, from the start of the view to read the data from.\n- `littleEndian` {{optional_inline}}\n  - : Indicates whether the data is stored in [little- or big-endian](/en-US/docs/Glossary/Endianness) format. If `false` or `undefined`, a big-endian value is read.\n\n### Return value\n\nAny number value.\n\n### Exceptions\n\n- {{jsxref("RangeError")}}\n  - : Thrown if the `byteOffset` is set such that it would read beyond the end of the view.\n\n## Examples\n\n### Using getFloat64()\n\n```js\nconst { buffer } = new Uint8Array([0, 1, 2, 3, 4, 5, 6, 7, 8, 9]);\nconst dataview = new DataView(buffer);\nconsole.log(dataview.getFloat64(1)); // 8.20788039913184e-304\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [JavaScript typed arrays](/en-US/docs/Web/JavaScript/Guide/Typed_arrays) guide\n- {{jsxref("DataView")}}\n- {{jsxref("ArrayBuffer")}}\n- {{jsxref("Float64Array")}}\n'
        },
        "getint16": {
            "index.md": '---\ntitle: DataView.prototype.getInt16()\nslug: Web/JavaScript/Reference/Global_Objects/DataView/getInt16\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.DataView.getInt16\n---\n\n{{JSRef}}\n\nThe **`getInt16()`** method of {{jsxref("DataView")}} instances reads 2 bytes starting at the specified byte offset of this `DataView` and interprets them as a 16-bit signed integer. There is no alignment constraint; multi-byte values may be fetched from any offset within bounds.\n\n{{EmbedInteractiveExample("pages/js/dataview-getint16.html")}}\n\n## Syntax\n\n```js-nolint\ngetInt16(byteOffset)\ngetInt16(byteOffset, littleEndian)\n```\n\n### Parameters\n\n- `byteOffset`\n  - : The offset, in bytes, from the start of the view to read the data from.\n- `littleEndian` {{optional_inline}}\n  - : Indicates whether the data is stored in [little- or big-endian](/en-US/docs/Glossary/Endianness) format. If `false` or `undefined`, a big-endian value is read.\n\n### Return value\n\nAn integer from -32768 to 32767, inclusive.\n\n### Exceptions\n\n- {{jsxref("RangeError")}}\n  - : Thrown if the `byteOffset` is set such that it would read beyond the end of the view.\n\n## Examples\n\n### Using getInt16()\n\n```js\nconst { buffer } = new Uint8Array([0, 1, 2, 3, 4, 5, 6, 7, 8, 9]);\nconst dataview = new DataView(buffer);\nconsole.log(dataview.getInt16(1)); // 258\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [JavaScript typed arrays](/en-US/docs/Web/JavaScript/Guide/Typed_arrays) guide\n- {{jsxref("DataView")}}\n- {{jsxref("ArrayBuffer")}}\n- {{jsxref("Int16Array")}}\n'
        },
        "getint32": {
            "index.md": '---\ntitle: DataView.prototype.getInt32()\nslug: Web/JavaScript/Reference/Global_Objects/DataView/getInt32\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.DataView.getInt32\n---\n\n{{JSRef}}\n\nThe **`getInt32()`** method of {{jsxref("DataView")}} instances reads 4 bytes starting at the specified byte offset of this `DataView` and interprets them as a 32-bit signed integer. There is no alignment constraint; multi-byte values may be fetched from any offset within bounds.\n\n{{EmbedInteractiveExample("pages/js/dataview-getint32.html")}}\n\n## Syntax\n\n```js-nolint\ngetInt32(byteOffset)\ngetInt32(byteOffset, littleEndian)\n```\n\n### Parameters\n\n- `byteOffset`\n  - : The offset, in bytes, from the start of the view to read the data from.\n- `littleEndian` {{optional_inline}}\n  - : Indicates whether the data is stored in [little- or big-endian](/en-US/docs/Glossary/Endianness) format. If `false` or `undefined`, a big-endian value is read.\n\n### Return value\n\nAn integer from -2147483648 to 2147483647, inclusive.\n\n### Exceptions\n\n- {{jsxref("RangeError")}}\n  - : Thrown if the `byteOffset` is set such that it would read beyond the end of the view.\n\n## Examples\n\n### Using getInt32()\n\n```js\nconst { buffer } = new Uint8Array([0, 1, 2, 3, 4, 5, 6, 7, 8, 9]);\nconst dataview = new DataView(buffer);\nconsole.log(dataview.getInt32(1)); // 16909060\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [JavaScript typed arrays](/en-US/docs/Web/JavaScript/Guide/Typed_arrays) guide\n- {{jsxref("DataView")}}\n- {{jsxref("ArrayBuffer")}}\n- {{jsxref("Int32Array")}}\n'
        },
        "getint8": {
            "index.md": '---\ntitle: DataView.prototype.getInt8()\nslug: Web/JavaScript/Reference/Global_Objects/DataView/getInt8\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.DataView.getInt8\n---\n\n{{JSRef}}\n\nThe **`getInt8()`** method of {{jsxref("DataView")}} instances reads 1 byte at the specified byte offset of this `DataView` and interprets it as an 8-bit signed integer.\n\n{{EmbedInteractiveExample("pages/js/dataview-getint8.html")}}\n\n## Syntax\n\n```js-nolint\ngetInt8(byteOffset)\n```\n\n### Parameters\n\n- `byteOffset`\n  - : The offset, in bytes, from the start of the view to read the data from.\n\n### Return value\n\nAn integer from -128 to 127, inclusive.\n\n### Exceptions\n\n- {{jsxref("RangeError")}}\n  - : Thrown if the `byteOffset` is set such that it would read beyond the end of the view.\n\n## Examples\n\n### Using getInt8()\n\n```js\nconst { buffer } = new Uint8Array([0, 1, 2, 3, 4, 5, 6, 7, 8, 9]);\nconst dataview = new DataView(buffer);\nconsole.log(dataview.getInt8(1)); // 1\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [JavaScript typed arrays](/en-US/docs/Web/JavaScript/Guide/Typed_arrays) guide\n- {{jsxref("DataView")}}\n- {{jsxref("ArrayBuffer")}}\n- {{jsxref("Int8Array")}}\n'
        },
        "getuint16": {
            "index.md": '---\ntitle: DataView.prototype.getUint16()\nslug: Web/JavaScript/Reference/Global_Objects/DataView/getUint16\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.DataView.getUint16\n---\n\n{{JSRef}}\n\nThe **`getUint16()`** method of {{jsxref("DataView")}} instances reads 2 bytes starting at the specified byte offset of this `DataView` and interprets them as a 16-bit unsigned integer. There is no alignment constraint; multi-byte values may be fetched from any offset within bounds.\n\n{{EmbedInteractiveExample("pages/js/dataview-getuint16.html")}}\n\n## Syntax\n\n```js-nolint\ngetUint16(byteOffset)\ngetUint16(byteOffset, littleEndian)\n```\n\n### Parameters\n\n- `byteOffset`\n  - : The offset, in bytes, from the start of the view to read the data from.\n- `littleEndian` {{optional_inline}}\n  - : Indicates whether the data is stored in [little- or big-endian](/en-US/docs/Glossary/Endianness) format. If `false` or `undefined`, a big-endian value is read.\n\n### Return value\n\nAn integer from 0 to 65535, inclusive.\n\n### Exceptions\n\n- {{jsxref("RangeError")}}\n  - : Thrown if the `byteOffset` is set such that it would read beyond the end of the view.\n\n## Examples\n\n### Using getUint16()\n\n```js\nconst { buffer } = new Uint8Array([0, 1, 2, 3, 4, 5, 6, 7, 8, 9]);\nconst dataview = new DataView(buffer);\nconsole.log(dataview.getUint16(1)); // 258\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [JavaScript typed arrays](/en-US/docs/Web/JavaScript/Guide/Typed_arrays) guide\n- {{jsxref("DataView")}}\n- {{jsxref("ArrayBuffer")}}\n- {{jsxref("Uint16Array")}}\n'
        },
        "getuint32": {
            "index.md": '---\ntitle: DataView.prototype.getUint32()\nslug: Web/JavaScript/Reference/Global_Objects/DataView/getUint32\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.DataView.getUint32\n---\n\n{{JSRef}}\n\nThe **`getUint32()`** method of {{jsxref("DataView")}} instances reads 4 bytes starting at the specified byte offset of this `DataView` and interprets them as a 32-bit unsigned integer. There is no alignment constraint; multi-byte values may be fetched from any offset within bounds.\n\n{{EmbedInteractiveExample("pages/js/dataview-getuint32.html")}}\n\n## Syntax\n\n```js-nolint\ngetUint32(byteOffset)\ngetUint32(byteOffset, littleEndian)\n```\n\n### Parameters\n\n- `byteOffset`\n  - : The offset, in bytes, from the start of the view to read the data from.\n- `littleEndian` {{optional_inline}}\n  - : Indicates whether the data is stored in [little- or big-endian](/en-US/docs/Glossary/Endianness) format. If `false` or `undefined`, a big-endian value is read.\n\n### Return value\n\nAn integer from 0 to 4294967295, inclusive.\n\n### Exceptions\n\n- {{jsxref("RangeError")}}\n  - : Thrown if the `byteOffset` is set such that it would read beyond the end of the view.\n\n## Examples\n\n### Using getUint32()\n\n```js\nconst { buffer } = new Uint8Array([0, 1, 2, 3, 4, 5, 6, 7, 8, 9]);\nconst dataview = new DataView(buffer);\nconsole.log(dataview.getUint32(1)); // 16909060\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [JavaScript typed arrays](/en-US/docs/Web/JavaScript/Guide/Typed_arrays) guide\n- {{jsxref("DataView")}}\n- {{jsxref("ArrayBuffer")}}\n- {{jsxref("Uint32Array")}}\n'
        },
        "getuint8": {
            "index.md": '---\ntitle: DataView.prototype.getUint8()\nslug: Web/JavaScript/Reference/Global_Objects/DataView/getUint8\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.DataView.getUint8\n---\n\n{{JSRef}}\n\nThe **`getUint8()`** method of {{jsxref("DataView")}} instances reads 1 byte at the specified byte offset of this `DataView` and interprets it as an 8-bit unsigned integer.\n\n{{EmbedInteractiveExample("pages/js/dataview-getuint8.html")}}\n\n## Syntax\n\n```js-nolint\ngetUint8(byteOffset)\n```\n\n### Parameters\n\n- `byteOffset`\n  - : The offset, in bytes, from the start of the view to read the data from.\n\n### Return value\n\nAn integer from 0 to 255, inclusive.\n\n### Exceptions\n\n- {{jsxref("RangeError")}}\n  - : Thrown if the `byteOffset` is set such that it would read beyond the end of the view.\n\n## Examples\n\n### Using getUint8()\n\n```js\nconst { buffer } = new Uint8Array([0, 1, 2, 3, 4, 5, 6, 7, 8, 9]);\nconst dataview = new DataView(buffer);\nconsole.log(dataview.getUint8(1)); // 1\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [JavaScript typed arrays](/en-US/docs/Web/JavaScript/Guide/Typed_arrays) guide\n- {{jsxref("DataView")}}\n- {{jsxref("ArrayBuffer")}}\n- {{jsxref("Uint8Array")}}\n'
        },
        "index.md": '---\ntitle: DataView\nslug: Web/JavaScript/Reference/Global_Objects/DataView\npage-type: javascript-class\nbrowser-compat: javascript.builtins.DataView\n---\n\n{{JSRef}}\n\nThe **`DataView`** view provides a low-level interface for reading and writing multiple number types in a binary {{jsxref("ArrayBuffer")}}, without having to care about the platform\'s [endianness](/en-US/docs/Glossary/Endianness).\n\n## Description\n\n### Endianness\n\nMulti-byte number formats are represented in memory differently depending on machine architecture \u2014 see [Endianness](/en-US/docs/Glossary/Endianness) for an explanation. `DataView` accessors provide explicit control of how data is accessed, regardless of the executing computer\'s endianness.\n\n```js\nconst littleEndian = (() => {\n  const buffer = new ArrayBuffer(2);\n  new DataView(buffer).setInt16(0, 256, true /* littleEndian */);\n  // Int16Array uses the platform\'s endianness.\n  return new Int16Array(buffer)[0] === 256;\n})();\nconsole.log(littleEndian); // true or false\n```\n\n### 64-bit Integer Values\n\nSome browsers don\'t have support for {{jsxref("DataView.prototype.setBigInt64()")}} and {{jsxref("DataView.prototype.setBigUint64()")}}. So to enable 64-bit operations in your code that will work across browsers, you could implement your own `getUint64()` function, to obtain values with precision up to {{jsxref("Number.MAX_SAFE_INTEGER")}} \u2014 which could suffice for certain cases.\n\n```js\nfunction getUint64(dataview, byteOffset, littleEndian) {\n  // split 64-bit number into two 32-bit (4-byte) parts\n  const left = dataview.getUint32(byteOffset, littleEndian);\n  const right = dataview.getUint32(byteOffset + 4, littleEndian);\n\n  // combine the two 32-bit values\n  const combined = littleEndian\n    ? left + 2 ** 32 * right\n    : 2 ** 32 * left + right;\n\n  if (!Number.isSafeInteger(combined))\n    console.warn(combined, "exceeds MAX_SAFE_INTEGER. Precision may be lost");\n\n  return combined;\n}\n```\n\nAlternatively, if you need full 64-bit range, you can create a {{jsxref("BigInt")}}. Further, although native BigInts are much faster than user-land library equivalents, BigInts will always be much slower than 32-bit integers in JavaScript due to the nature of their variable size.\n\n```js\nconst BigInt = window.BigInt,\n  bigThirtyTwo = BigInt(32),\n  bigZero = BigInt(0);\nfunction getUint64BigInt(dataview, byteOffset, littleEndian) {\n  // split 64-bit number into two 32-bit (4-byte) parts\n  const left = BigInt(dataview.getUint32(byteOffset | 0, !!littleEndian) >>> 0);\n  const right = BigInt(\n    dataview.getUint32(((byteOffset | 0) + 4) | 0, !!littleEndian) >>> 0,\n  );\n\n  // combine the two 32-bit values and return\n  return littleEndian\n    ? (right << bigThirtyTwo) | left\n    : (left << bigThirtyTwo) | right;\n}\n```\n\n## Constructor\n\n- {{jsxref("DataView/DataView", "DataView()")}}\n  - : Creates a new `DataView` object.\n\n## Instance properties\n\nThese properties are defined on `DataView.prototype` and shared by all `DataView` instances.\n\n- {{jsxref("DataView.prototype.buffer")}}\n  - : The {{jsxref("ArrayBuffer")}} referenced by this view. Fixed at construction time and thus **read only.**\n- {{jsxref("DataView.prototype.byteLength")}}\n  - : The length (in bytes) of this view. Fixed at construction time and thus **read only.**\n- {{jsxref("DataView.prototype.byteOffset")}}\n  - : The offset (in bytes) of this view from the start of its {{jsxref("ArrayBuffer")}}. Fixed at construction time and thus **read only.**\n- {{jsxref("Object/constructor", "DataView.prototype.constructor")}}\n  - : The constructor function that created the instance object. For `DataView` instances, the initial value is the {{jsxref("DataView/DataView", "DataView")}} constructor.\n- `DataView.prototype[@@toStringTag]`\n  - : The initial value of the [`@@toStringTag`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol/toStringTag) property is the string `"DataView"`. This property is used in {{jsxref("Object.prototype.toString()")}}.\n\n## Instance methods\n\n- {{jsxref("DataView.prototype.getBigInt64()")}}\n  - : Reads 8 bytes starting at the specified byte offset of this `DataView` and interprets them as a 64-bit signed integer.\n- {{jsxref("DataView.prototype.getBigUint64()")}}\n  - : Reads 8 bytes starting at the specified byte offset of this `DataView` and interprets them as a 64-bit unsigned integer.\n- {{jsxref("DataView.prototype.getFloat32()")}}\n  - : Reads 4 bytes starting at the specified byte offset of this `DataView` and interprets them as a 32-bit floating point number.\n- {{jsxref("DataView.prototype.getFloat64()")}}\n  - : Reads 8 bytes starting at the specified byte offset of this `DataView` and interprets them as a 64-bit floating point number.\n- {{jsxref("DataView.prototype.getInt16()")}}\n  - : Reads 2 bytes starting at the specified byte offset of this `DataView` and interprets them as a 16-bit signed integer.\n- {{jsxref("DataView.prototype.getInt32()")}}\n  - : Reads 4 bytes starting at the specified byte offset of this `DataView` and interprets them as a 32-bit signed integer.\n- {{jsxref("DataView.prototype.getInt8()")}}\n  - : Reads 1 byte at the specified byte offset of this `DataView` and interprets it as an 8-bit signed integer.\n- {{jsxref("DataView.prototype.getUint16()")}}\n  - : Reads 2 bytes starting at the specified byte offset of this `DataView` and interprets them as a 16-bit unsigned integer.\n- {{jsxref("DataView.prototype.getUint32()")}}\n  - : Reads 4 bytes starting at the specified byte offset of this `DataView` and interprets them as a 32-bit unsigned integer.\n- {{jsxref("DataView.prototype.getUint8()")}}\n  - : Reads 1 byte at the specified byte offset of this `DataView` and interprets it as an 8-bit unsigned integer.\n- {{jsxref("DataView.prototype.setBigInt64()")}}\n  - : Takes a BigInt and stores it as a 64-bit signed integer in the 8 bytes starting at the specified byte offset of this `DataView`.\n- {{jsxref("DataView.prototype.setBigUint64()")}}\n  - : Takes a BigInt and stores it as a 64-bit unsigned integer in the 8 bytes starting at the specified byte offset of this `DataView`.\n- {{jsxref("DataView.prototype.setFloat32()")}}\n  - : Takes a number and stores it as a 32-bit float in the 4 bytes starting at the specified byte offset of this `DataView`.\n- {{jsxref("DataView.prototype.setFloat64()")}}\n  - : Takes a number and stores it as a 64-bit float in the 8 bytes starting at the specified byte offset of this `DataView`.\n- {{jsxref("DataView.prototype.setInt16()")}}\n  - : Takes a number and stores it as a 16-bit signed integer in the 2 bytes at the specified byte offset of this `DataView`.\n- {{jsxref("DataView.prototype.setInt32()")}}\n  - : Takes a number and stores it as a 32-bit signed integer in the 4 bytes at the specified byte offset of this `DataView`.\n- {{jsxref("DataView.prototype.setInt8()")}}\n  - : Takes a number and stores it as an 8-bit signed integer in the byte at the specified byte offset of this `DataView`.\n- {{jsxref("DataView.prototype.setUint16()")}}\n  - : Takes a number and stores it as a 16-bit unsigned integer in the 2 bytes at the specified byte offset of this `DataView`.\n- {{jsxref("DataView.prototype.setUint32()")}}\n  - : Takes a number and stores it as a 32-bit unsigned integer in the 4 bytes at the specified byte offset of this `DataView`.\n- {{jsxref("DataView.prototype.setUint8()")}}\n  - : Takes a number and stores it as an 8-bit unsigned integer in the byte at the specified byte offset of this `DataView`.\n\n## Examples\n\n### Using DataView\n\n```js\nconst buffer = new ArrayBuffer(16);\nconst view = new DataView(buffer, 0);\n\nview.setInt16(1, 42);\nview.getInt16(1); // 42\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `DataView` in `core-js`](https://github.com/zloirock/core-js#ecmascript-typed-arrays)\n- {{jsxref("ArrayBuffer")}}\n- {{jsxref("SharedArrayBuffer")}}\n',
        "setbigint64": {
            "index.md": '---\ntitle: DataView.prototype.setBigInt64()\nslug: Web/JavaScript/Reference/Global_Objects/DataView/setBigInt64\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.DataView.setBigInt64\n---\n\n{{JSRef}}\n\nThe **`setBigInt64()`** method of {{jsxref("DataView")}} instances takes a BigInt and stores it as a 64-bit signed integer in the 8 bytes starting at the specified byte offset of this `DataView`. There is no alignment constraint; multi-byte values may be stored at any offset within bounds.\n\n{{EmbedInteractiveExample("pages/js/dataview-setbigint64.html")}}\n\n## Syntax\n\n```js-nolint\nsetBigInt64(byteOffset, value)\nsetBigInt64(byteOffset, value, littleEndian)\n```\n\n### Parameters\n\n- `byteOffset`\n  - : The offset, in bytes, from the start of the view to store the data in.\n- `value`\n  - : The value to set as a {{jsxref("BigInt")}}. For how the value is encoded in bytes, see [Value encoding and normalization](/en-US/docs/Web/JavaScript/Reference/Global_Objects/TypedArray#value_encoding_and_normalization).\n- `littleEndian` {{optional_inline}}\n  - : Indicates whether the data is stored in [little- or big-endian](/en-US/docs/Glossary/Endianness) format. If `false` or `undefined`, a big-endian value is written.\n\n### Return value\n\n{{jsxref("undefined")}}.\n\n### Exceptions\n\n- {{jsxref("RangeError")}}\n  - : Thrown if the `byteOffset` is set such that it would store beyond the end of the view.\n\n## Examples\n\n### Using setBigInt64()\n\n```js\nconst buffer = new ArrayBuffer(10);\nconst dataview = new DataView(buffer);\ndataview.setBigInt64(0, 3n);\ndataview.getBigInt64(1); // 768n\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [JavaScript typed arrays](/en-US/docs/Web/JavaScript/Guide/Typed_arrays) guide\n- {{jsxref("DataView")}}\n- {{jsxref("ArrayBuffer")}}\n- {{jsxref("BigInt64Array")}}\n'
        },
        "setbiguint64": {
            "index.md": '---\ntitle: DataView.prototype.setBigUint64()\nslug: Web/JavaScript/Reference/Global_Objects/DataView/setBigUint64\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.DataView.setBigUint64\n---\n\n{{JSRef}}\n\nThe **`setBigUint64()`** method of {{jsxref("DataView")}} instances takes a BigInt and stores it as a 64-bit unsigned integer in the 8 bytes starting at the specified byte offset of this `DataView`. There is no alignment constraint; multi-byte values may be stored at any offset within bounds.\n\n{{EmbedInteractiveExample("pages/js/dataview-setbiguint64.html")}}\n\n## Syntax\n\n```js-nolint\nsetBigUint64(byteOffset, value)\nsetBigUint64(byteOffset, value, littleEndian)\n```\n\n### Parameters\n\n- `byteOffset`\n  - : The offset, in bytes, from the start of the view to store the data in.\n- `value`\n  - : The value to set as a {{jsxref("BigInt")}}. For how the value is encoded in bytes, see [Value encoding and normalization](/en-US/docs/Web/JavaScript/Reference/Global_Objects/TypedArray#value_encoding_and_normalization).\n- `littleEndian` {{optional_inline}}\n  - : Indicates whether the data is stored in [little- or big-endian](/en-US/docs/Glossary/Endianness) format. If `false` or `undefined`, a big-endian value is written.\n\n### Return value\n\n{{jsxref("undefined")}}.\n\n### Exceptions\n\n- {{jsxref("RangeError")}}\n  - : Thrown if the `byteOffset` is set such that it would store beyond the end of the view.\n\n## Examples\n\n### Using setBigUint64()\n\n```js\nconst buffer = new ArrayBuffer(10);\nconst dataview = new DataView(buffer);\ndataview.setBigUint64(0, 3n);\ndataview.getBigUint64(1); // 768n\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [JavaScript typed arrays](/en-US/docs/Web/JavaScript/Guide/Typed_arrays) guide\n- {{jsxref("DataView")}}\n- {{jsxref("ArrayBuffer")}}\n- {{jsxref("BigUint64Array")}}\n'
        },
        "setfloat32": {
            "index.md": '---\ntitle: DataView.prototype.setFloat32()\nslug: Web/JavaScript/Reference/Global_Objects/DataView/setFloat32\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.DataView.setFloat32\n---\n\n{{JSRef}}\n\nThe **`setFloat32()`** method of {{jsxref("DataView")}} instances takes a number and stores it as a 32-bit floating point number in the 4 bytes starting at the specified byte offset of this `DataView`. There is no alignment constraint; multi-byte values may be stored at any offset within bounds.\n\n{{EmbedInteractiveExample("pages/js/dataview-setfloat32.html")}}\n\n## Syntax\n\n```js-nolint\nsetFloat32(byteOffset, value)\nsetFloat32(byteOffset, value, littleEndian)\n```\n\n### Parameters\n\n- `byteOffset`\n  - : The offset, in bytes, from the start of the view to store the data in.\n- `value`\n  - : The value to set. For how the value is encoded in bytes, see [Value encoding and normalization](/en-US/docs/Web/JavaScript/Reference/Global_Objects/TypedArray#value_encoding_and_normalization).\n- `littleEndian` {{optional_inline}}\n  - : Indicates whether the data is stored in [little- or big-endian](/en-US/docs/Glossary/Endianness) format. If `false` or `undefined`, a big-endian value is written.\n\n### Return value\n\n{{jsxref("undefined")}}.\n\n### Exceptions\n\n- {{jsxref("RangeError")}}\n  - : Thrown if the `byteOffset` is set such that it would store beyond the end of the view.\n\n## Examples\n\n### Using setFloat32()\n\n```js\nconst buffer = new ArrayBuffer(10);\nconst dataview = new DataView(buffer);\ndataview.setFloat32(0, 3);\ndataview.getFloat32(1); // 2\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [JavaScript typed arrays](/en-US/docs/Web/JavaScript/Guide/Typed_arrays) guide\n- {{jsxref("DataView")}}\n- {{jsxref("ArrayBuffer")}}\n- {{jsxref("Float32Array")}}\n'
        },
        "setfloat64": {
            "index.md": '---\ntitle: DataView.prototype.setFloat64()\nslug: Web/JavaScript/Reference/Global_Objects/DataView/setFloat64\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.DataView.setFloat64\n---\n\n{{JSRef}}\n\nThe **`setFloat64()`** method of {{jsxref("DataView")}} instances takes a number and stores it as a 64-bit floating point number in the 8 bytes starting at the specified byte offset of this `DataView`. There is no alignment constraint; multi-byte values may be stored at any offset within bounds.\n\n{{EmbedInteractiveExample("pages/js/dataview-setfloat64.html")}}\n\n## Syntax\n\n```js-nolint\nsetFloat64(byteOffset, value)\nsetFloat64(byteOffset, value, littleEndian)\n```\n\n### Parameters\n\n- `byteOffset`\n  - : The offset, in bytes, from the start of the view to store the data in.\n- `value`\n  - : The value to set. For how the value is encoded in bytes, see [Value encoding and normalization](/en-US/docs/Web/JavaScript/Reference/Global_Objects/TypedArray#value_encoding_and_normalization).\n- `littleEndian` {{optional_inline}}\n  - : Indicates whether the data is stored in [little- or big-endian](/en-US/docs/Glossary/Endianness) format. If `false` or `undefined`, a big-endian value is written.\n\n### Return value\n\n{{jsxref("undefined")}}.\n\n### Exceptions\n\n- {{jsxref("RangeError")}}\n  - : Thrown if the `byteOffset` is set such that it would store beyond the end of the view.\n\n## Examples\n\n### Using setFloat64()\n\n```js\nconst buffer = new ArrayBuffer(10);\nconst dataview = new DataView(buffer);\ndataview.setFloat64(0, 3);\ndataview.getFloat64(1); // 3.785766995733679e-270\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [JavaScript typed arrays](/en-US/docs/Web/JavaScript/Guide/Typed_arrays) guide\n- {{jsxref("DataView")}}\n- {{jsxref("ArrayBuffer")}}\n- {{jsxref("Float64Array")}}\n'
        },
        "setint16": {
            "index.md": '---\ntitle: DataView.prototype.setInt16()\nslug: Web/JavaScript/Reference/Global_Objects/DataView/setInt16\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.DataView.setInt16\n---\n\n{{JSRef}}\n\nThe **`setInt16()`** method of {{jsxref("DataView")}} instances takes a number and stores it as a 16-bit signed integer in the 2 bytes starting at the specified byte offset of this `DataView`. There is no alignment constraint; multi-byte values may be stored at any offset within bounds.\n\n{{EmbedInteractiveExample("pages/js/dataview-setint16.html")}}\n\n## Syntax\n\n```js-nolint\nsetInt16(byteOffset, value)\nsetInt16(byteOffset, value, littleEndian)\n```\n\n### Parameters\n\n- `byteOffset`\n  - : The offset, in bytes, from the start of the view to store the data in.\n- `value`\n  - : The value to set. For how the value is encoded in bytes, see [Value encoding and normalization](/en-US/docs/Web/JavaScript/Reference/Global_Objects/TypedArray#value_encoding_and_normalization).\n- `littleEndian` {{optional_inline}}\n  - : Indicates whether the data is stored in [little- or big-endian](/en-US/docs/Glossary/Endianness) format. If `false` or `undefined`, a big-endian value is written.\n\n### Return value\n\n{{jsxref("undefined")}}.\n\n### Exceptions\n\n- {{jsxref("RangeError")}}\n  - : Thrown if the `byteOffset` is set such that it would store beyond the end of the view.\n\n## Examples\n\n### Using setInt16()\n\n```js\nconst buffer = new ArrayBuffer(10);\nconst dataview = new DataView(buffer);\ndataview.setInt16(0, 3);\ndataview.getInt16(1); // 768\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [JavaScript typed arrays](/en-US/docs/Web/JavaScript/Guide/Typed_arrays) guide\n- {{jsxref("DataView")}}\n- {{jsxref("ArrayBuffer")}}\n- {{jsxref("Int16Array")}}\n'
        },
        "setint32": {
            "index.md": '---\ntitle: DataView.prototype.setInt32()\nslug: Web/JavaScript/Reference/Global_Objects/DataView/setInt32\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.DataView.setInt32\n---\n\n{{JSRef}}\n\nThe **`setInt32()`** method of {{jsxref("DataView")}} instances takes a number and stores it as a 32-bit signed integer in the 4 bytes starting at the specified byte offset of this `DataView`. There is no alignment constraint; multi-byte values may be stored at any offset within bounds.\n\n{{EmbedInteractiveExample("pages/js/dataview-setint32.html")}}\n\n## Syntax\n\n```js-nolint\nsetInt32(byteOffset, value)\nsetInt32(byteOffset, value, littleEndian)\n```\n\n### Parameters\n\n- `byteOffset`\n  - : The offset, in bytes, from the start of the view to store the data in.\n- `value`\n  - : The value to set. For how the value is encoded in bytes, see [Value encoding and normalization](/en-US/docs/Web/JavaScript/Reference/Global_Objects/TypedArray#value_encoding_and_normalization).\n- `littleEndian` {{optional_inline}}\n  - : Indicates whether the data is stored in [little- or big-endian](/en-US/docs/Glossary/Endianness) format. If `false` or `undefined`, a big-endian value is written.\n\n### Return value\n\n{{jsxref("undefined")}}.\n\n### Exceptions\n\n- {{jsxref("RangeError")}}\n  - : Thrown if the `byteOffset` is set such that it would store beyond the end of the view.\n\n## Examples\n\n### Using setInt32()\n\n```js\nconst buffer = new ArrayBuffer(10);\nconst dataview = new DataView(buffer);\ndataview.setInt32(0, 3);\ndataview.getInt32(1); // 768\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [JavaScript typed arrays](/en-US/docs/Web/JavaScript/Guide/Typed_arrays) guide\n- {{jsxref("DataView")}}\n- {{jsxref("ArrayBuffer")}}\n- {{jsxref("Int32Array")}}\n'
        },
        "setint8": {
            "index.md": '---\ntitle: DataView.prototype.setInt8()\nslug: Web/JavaScript/Reference/Global_Objects/DataView/setInt8\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.DataView.setInt8\n---\n\n{{JSRef}}\n\nThe **`setInt8()`** method of {{jsxref("DataView")}} instances takes a number and stores it as an 8-bit signed integer in the byte at the specified byte offset of this `DataView`.\n\n{{EmbedInteractiveExample("pages/js/dataview-setint8.html")}}\n\n## Syntax\n\n```js-nolint\nsetInt8(byteOffset, value)\n```\n\n### Parameters\n\n- `byteOffset`\n  - : The offset, in bytes, from the start of the view to store the data in.\n- `value`\n  - : The value to set. For how the value is encoded in bytes, see [Value encoding and normalization](/en-US/docs/Web/JavaScript/Reference/Global_Objects/TypedArray#value_encoding_and_normalization).\n\n### Return value\n\n{{jsxref("undefined")}}.\n\n### Exceptions\n\n- {{jsxref("RangeError")}}\n  - : Thrown if the `byteOffset` is set such that it would store beyond the end of the view.\n\n## Examples\n\n### Using setInt8()\n\n```js\nconst buffer = new ArrayBuffer(10);\nconst dataview = new DataView(buffer);\ndataview.setInt8(0, 3);\ndataview.getInt8(0); // 3\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [JavaScript typed arrays](/en-US/docs/Web/JavaScript/Guide/Typed_arrays) guide\n- {{jsxref("DataView")}}\n- {{jsxref("ArrayBuffer")}}\n- {{jsxref("Int8Array")}}\n'
        },
        "setuint16": {
            "index.md": '---\ntitle: DataView.prototype.setUint16()\nslug: Web/JavaScript/Reference/Global_Objects/DataView/setUint16\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.DataView.setUint16\n---\n\n{{JSRef}}\n\nThe **`setUint16()`** method of {{jsxref("DataView")}} instances takes a number and stores it as a 16-bit unsigned integer in the 2 bytes starting at the specified byte offset of this `DataView`. There is no alignment constraint; multi-byte values may be stored at any offset within bounds.\n\n{{EmbedInteractiveExample("pages/js/dataview-setuint16.html")}}\n\n## Syntax\n\n```js-nolint\nsetUint16(byteOffset, value)\nsetUint16(byteOffset, value, littleEndian)\n```\n\n### Parameters\n\n- `byteOffset`\n  - : The offset, in bytes, from the start of the view to store the data in.\n- `value`\n  - : The value to set. For how the value is encoded in bytes, see [Value encoding and normalization](/en-US/docs/Web/JavaScript/Reference/Global_Objects/TypedArray#value_encoding_and_normalization).\n- `littleEndian` {{optional_inline}}\n  - : Indicates whether the data is stored in [little- or big-endian](/en-US/docs/Glossary/Endianness) format. If `false` or `undefined`, a big-endian value is written.\n\n### Return value\n\n{{jsxref("undefined")}}.\n\n### Exceptions\n\n- {{jsxref("RangeError")}}\n  - : Thrown if the `byteOffset` is set such that it would store beyond the end of the view.\n\n## Examples\n\n### Using setUint16()\n\n```js\nconst buffer = new ArrayBuffer(10);\nconst dataview = new DataView(buffer);\ndataview.setUint16(0, 3);\ndataview.getUint16(1); // 768\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [JavaScript typed arrays](/en-US/docs/Web/JavaScript/Guide/Typed_arrays) guide\n- {{jsxref("DataView")}}\n- {{jsxref("ArrayBuffer")}}\n- {{jsxref("Uint16Array")}}\n'
        },
        "setuint32": {
            "index.md": '---\ntitle: DataView.prototype.setUint32()\nslug: Web/JavaScript/Reference/Global_Objects/DataView/setUint32\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.DataView.setUint32\n---\n\n{{JSRef}}\n\nThe **`setUint32()`** method of {{jsxref("DataView")}} instances takes a number and stores it as a 32-bit unsigned integer in the 4 bytes starting at the specified byte offset of this `DataView`. There is no alignment constraint; multi-byte values may be stored at any offset within bounds.\n\n{{EmbedInteractiveExample("pages/js/dataview-setuint32.html")}}\n\n## Syntax\n\n```js-nolint\nsetUint32(byteOffset, value)\nsetUint32(byteOffset, value, littleEndian)\n```\n\n### Parameters\n\n- `byteOffset`\n  - : The offset, in bytes, from the start of the view to store the data in.\n- `value`\n  - : The value to set. For how the value is encoded in bytes, see [Value encoding and normalization](/en-US/docs/Web/JavaScript/Reference/Global_Objects/TypedArray#value_encoding_and_normalization).\n- `littleEndian` {{optional_inline}}\n  - : Indicates whether the data is stored in [little- or big-endian](/en-US/docs/Glossary/Endianness) format. If `false` or `undefined`, a big-endian value is written.\n\n### Return value\n\n{{jsxref("undefined")}}.\n\n### Exceptions\n\n- {{jsxref("RangeError")}}\n  - : Thrown if the `byteOffset` is set such that it would store beyond the end of the view.\n\n## Examples\n\n### Using setUint32()\n\n```js\nconst buffer = new ArrayBuffer(10);\nconst dataview = new DataView(buffer);\ndataview.setUint32(0, 3);\ndataview.getUint32(1); // 768\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [JavaScript typed arrays](/en-US/docs/Web/JavaScript/Guide/Typed_arrays) guide\n- {{jsxref("DataView")}}\n- {{jsxref("ArrayBuffer")}}\n- {{jsxref("Uint32Array")}}\n'
        },
        "setuint8": {
            "index.md": '---\ntitle: DataView.prototype.setUint8()\nslug: Web/JavaScript/Reference/Global_Objects/DataView/setUint8\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.DataView.setUint8\n---\n\n{{JSRef}}\n\nThe **`setUint8()`** method of {{jsxref("DataView")}} instances takes a number and stores it as an 8-bit unsigned integer in the byte at the specified byte offset of this `DataView`.\n\n{{EmbedInteractiveExample("pages/js/dataview-setuint8.html")}}\n\n## Syntax\n\n```js-nolint\nsetUint8(byteOffset, value)\n```\n\n### Parameters\n\n- `byteOffset`\n  - : The offset, in bytes, from the start of the view to store the data in.\n- `value`\n  - : The value to set. For how the value is encoded in bytes, see [Value encoding and normalization](/en-US/docs/Web/JavaScript/Reference/Global_Objects/TypedArray#value_encoding_and_normalization).\n\n### Return value\n\n{{jsxref("undefined")}}.\n\n### Exceptions\n\n- {{jsxref("RangeError")}}\n  - : Thrown if the `byteOffset` is set such that it would store beyond the end of the view.\n\n## Examples\n\n### Using setUint8()\n\n```js\nconst buffer = new ArrayBuffer(10);\nconst dataview = new DataView(buffer);\ndataview.setUint8(0, 3);\ndataview.getUint8(0); // 3\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [JavaScript typed arrays](/en-US/docs/Web/JavaScript/Guide/Typed_arrays) guide\n- {{jsxref("DataView")}}\n- {{jsxref("ArrayBuffer")}}\n- {{jsxref("Uint8Array")}}\n'
        }
    },
    "date": {
        "@@toprimitive": {
            "index.md": '---\ntitle: Date.prototype[@@toPrimitive]()\nslug: Web/JavaScript/Reference/Global_Objects/Date/@@toPrimitive\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Date.@@toPrimitive\n---\n\n{{JSRef}}\n\nThe **`[@@toPrimitive]()`** method of {{jsxref("Date")}} instances returns a primitive value representing this date. It may either be a string or a number, depending on the hint given.\n\n{{EmbedInteractiveExample("pages/js/date-toprimitive.html")}}\n\n## Syntax\n\n```js-nolint\ndate[Symbol.toPrimitive](hint)\n```\n\n### Parameters\n\n- `hint`\n  - : A string representing the type of the primitive value to return. The following values are valid:\n    - `"string"` or `"default"`: The method should return a string.\n    - `"number"`: The method should return a number.\n\n### Return value\n\nIf `hint` is `"string"` or `"default"`, this method returns a string by [coercing the `this` value to a string](/en-US/docs/Web/JavaScript/Reference/Global_Objects/String#string_coercion) (first trying `toString()` then trying `valueOf()`).\n\nIf `hint` is `"number"`, this method returns a number by [coercing the `this` value to a number](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number#number_coercion) (first trying `valueOf()` then trying `toString()`).\n\n### Exceptions\n\n- {{jsxref("TypeError")}}\n  - : Thrown if the `hint` argument is not one of the three valid values.\n\n## Description\n\nThe `[@@toPrimitive]()` method is part of the [type coercion protocol](/en-US/docs/Web/JavaScript/Data_structures#type_coercion). JavaScript always calls the `[@@toPrimitive]()` method in priority to convert an object to a primitive value. You rarely need to invoke the `[@@toPrimitive]()` method yourself; JavaScript automatically invokes it when encountering an object where a primitive value is expected.\n\nThe `[@@toPrimitive]()` method of the {{jsxref("Date")}} object returns a primitive value by either invoking {{jsxref("Date/valueOf", "this.valueOf()")}} and returning a number, or invoking {{jsxref("Date/toString", "this.toString()")}} and returning a string. It exists to override the default [primitive coercion](/en-US/docs/Web/JavaScript/Data_structures#primitive_coercion) process to return a string instead of a number, because primitive coercion, by default, calls {{jsxref("Date/valueOf", "valueOf()")}} before {{jsxref("Date/toString", "toString()")}}. With the custom `[@@toPrimitive]()`, `new Date(0) + 1` returns `"Thu Jan 01 1970 00:00:00 GMT+0000 (Coordinated Universal Time)1"` (a string) instead of `1` (a number).\n\n## Examples\n\n### Using \\[@@toPrimitive]()\n\n```js\nconst d = new Date(0); // 1970-01-01T00:00:00.000Z\n\nd[Symbol.toPrimitive]("string"); // "Thu Jan 01 1970 00:00:00 GMT+0000 (Coordinated Universal Time)"\nd[Symbol.toPrimitive]("number"); // 0\nd[Symbol.toPrimitive]("default"); // "Thu Jan 01 1970 00:00:00 GMT+0000 (Coordinated Universal Time)"\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Symbol.toPrimitive")}}\n'
        },
        "date": {
            "index.md": '---\ntitle: Date() constructor\nslug: Web/JavaScript/Reference/Global_Objects/Date/Date\npage-type: javascript-constructor\nbrowser-compat: javascript.builtins.Date.Date\n---\n\n{{JSRef}}\n\nThe **`Date()`** constructor creates {{jsxref("Date")}} objects. When called as a function, it returns a string representing the current time.\n\n{{EmbedInteractiveExample("pages/js/date-constructor.html")}}\n\n## Syntax\n\n```js-nolint\nnew Date()\nnew Date(value)\nnew Date(dateString)\nnew Date(dateObject)\n\nnew Date(year, monthIndex)\nnew Date(year, monthIndex, day)\nnew Date(year, monthIndex, day, hours)\nnew Date(year, monthIndex, day, hours, minutes)\nnew Date(year, monthIndex, day, hours, minutes, seconds)\nnew Date(year, monthIndex, day, hours, minutes, seconds, milliseconds)\n\nDate()\n```\n\n> **Note:** `Date()` can be called with or without [`new`](/en-US/docs/Web/JavaScript/Reference/Operators/new), but with different effects. See [Return value](#return_value).\n\n### Parameters\n\nThere are five basic forms for the `Date()` constructor:\n\n#### No parameters\n\nWhen no parameters are provided, the newly-created `Date` object represents the current date and time as of the time of instantiation. The returned date\'s [timestamp](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#the_epoch_timestamps_and_invalid_date) is the same as the number returned by {{jsxref("Date.now()")}}.\n\n#### Time value or timestamp number\n\n- `value`\n  - : An integer value representing the [timestamp](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#the_epoch_timestamps_and_invalid_date) (the number of milliseconds since midnight at the beginning of January 1, 1970, UTC \u2014 a.k.a. the [epoch](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#the_epoch_timestamps_and_invalid_date)).\n\n#### Date string\n\n- `dateString`\n  - : A string value representing a date, parsed and interpreted using the same algorithm implemented by {{jsxref("Date.parse()")}}. See [date time string format](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#date_time_string_format) for caveats on using different formats.\n\n#### Date object\n\n- `dateObject`\n  - : An existing `Date` object. This effectively makes a copy of the existing `Date` object with the same date and time. This is equivalent to `new Date(dateObject.valueOf())`, except the `valueOf()` method is not called.\n\nWhen one parameter is passed to the `Date()` constructor, `Date` instances are specially treated. All other values are [converted to primitives](/en-US/docs/Web/JavaScript/Data_structures#primitive_coercion). If the result is a string, it will be parsed as a date string. Otherwise, the resulting primitive is further coerced to a number and treated as a timestamp.\n\n#### Individual date and time component values\n\nGiven at least a year and month, this form of `Date()` returns a `Date` object whose component values (year, month, day, hour, minute, second, and millisecond) all come from the following parameters. Any missing fields are given the lowest possible value (`1` for `day` and `0` for every other component). The parameter values are all evaluated against the local time zone, rather than UTC. {{jsxref("Date.UTC()")}} accepts similar parameters but interprets the components as UTC and returns a timestamp.\n\nIf any parameter overflows its defined bounds, it "carries over". For example, if a `monthIndex` greater than `11` is passed in, those months will cause the year to increment; if a `minutes` greater than `59` is passed in, `hours` will increment accordingly, etc. Therefore, `new Date(1990, 12, 1)` will return January 1st, 1991; `new Date(2020, 5, 19, 25, 65)` will return 2:05 A.M. June 20th, 2020.\n\nSimilarly, if any parameter underflows, it "borrows" from the higher positions. For example, `new Date(2020, 5, 0)` will return May 31st, 2020.\n\n- `year`\n  - : Integer value representing the year. Values from `0` to `99` map to the years `1900` to `1999`. All other values are the actual year. See the [example](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#interpretation_of_two-digit_years).\n- `monthIndex`\n  - : Integer value representing the month, beginning with `0` for January to `11` for December.\n- `day` {{optional_inline}}\n  - : Integer value representing the day of the month. Defaults to `1`.\n- `hours` {{optional_inline}}\n  - : Integer value between `0` and `23` representing the hour of the day. Defaults to `0`.\n- `minutes` {{optional_inline}}\n  - : Integer value representing the minute segment of a time. Defaults to `0`.\n- `seconds` {{optional_inline}}\n  - : Integer value representing the second segment of a time. Defaults to `0`.\n- `milliseconds` {{optional_inline}}\n  - : Integer value representing the millisecond segment of a time. Defaults to `0`.\n\n### Return value\n\nCalling `new Date()` (the `Date()` constructor) returns a [`Date`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date) object. If called with an invalid date string, or if the date to be constructed will have a timestamp less than `-8,640,000,000,000,000` or greater than `8,640,000,000,000,000` milliseconds, it returns an [invalid date](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#the_epoch_timestamps_and_invalid_date) (a `Date` object whose {{jsxref("Date/toString", "toString()")}} method returns `"Invalid Date"` and {{jsxref("Date/valueOf", "valueOf()")}} method returns `NaN`).\n\nCalling the `Date()` function (without the `new` keyword) returns a string representation of the current date and time, exactly as `new Date().toString()` does. Any arguments given in a `Date()` function call (without the `new` keyword) are ignored; regardless of whether it\'s called with an invalid date string \u2014 or even called with any arbitrary object or other primitive as an argument \u2014 it always returns a string representation of the current date and time.\n\n## Examples\n\n### Several ways to create a Date object\n\nThe following examples show several ways to create JavaScript dates:\n\n```js\nconst today = new Date();\nconst birthday = new Date("December 17, 1995 03:24:00"); // DISCOURAGED: may not work in all runtimes\nconst birthday = new Date("1995-12-17T03:24:00"); // This is standardized and will work reliably\nconst birthday = new Date(1995, 11, 17); // the month is 0-indexed\nconst birthday = new Date(1995, 11, 17, 3, 24, 0);\nconst birthday = new Date(628021800000); // passing epoch timestamp\n```\n\n### Passing a non-Date, non-string, non-number value\n\nIf the `Date()` constructor is called with one parameter which is not a `Date` instance, it will be coerced to a primitive and then checked whether it\'s a string. For example, `new Date(undefined)` is different from `new Date()`:\n\n```js\nconsole.log(new Date(undefined)); // Invalid Date\n```\n\nThis is because `undefined` is already a primitive but not a string, so it will be coerced to a number, which is [`NaN`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/NaN) and therefore not a valid timestamp. On the other hand, `null` will be coerced to `0`.\n\n```js\nconsole.log(new Date(null)); // 1970-01-01T00:00:00.000Z\n```\n\n[Arrays](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array) would be coerced to a string via [`Array.prototype.toString()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/toString), which joins the elements with commas. However, the resulting string for any array with more than one element is not a valid ISO 8601 date string, so its parsing behavior would be implementation-defined. **Do not pass arrays to the `Date()` constructor.**\n\n```js\nconsole.log(new Date(["2020-06-19", "17:13"]));\n// 2020-06-19T17:13:00.000Z in Chrome, since it recognizes "2020-06-19,17:13"\n// "Invalid Date" in Firefox\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Date")}}\n'
        },
        "getdate": {
            "index.md": '---\ntitle: Date.prototype.getDate()\nslug: Web/JavaScript/Reference/Global_Objects/Date/getDate\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Date.getDate\n---\n\n{{JSRef}}\n\nThe **`getDate()`** method of {{jsxref("Date")}} instances returns the day of the month for this date according to local time.\n\n{{EmbedInteractiveExample("pages/js/date-getdate.html", "shorter")}}\n\n## Syntax\n\n```js-nolint\ngetDate()\n```\n\n### Parameters\n\nNone.\n\n### Return value\n\nAn integer, between 1 and 31, representing the day of the month for the given date according to local time. Returns `NaN` if the date is [invalid](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#the_epoch_timestamps_and_invalid_date).\n\n## Examples\n\n### Using getDate()\n\nThe `day` variable has value `25`, based on the value of the {{jsxref("Date")}} object `xmas95`.\n\n```js\nconst xmas95 = new Date("1995-12-25T23:15:30");\nconst day = xmas95.getDate();\n\nconsole.log(day); // 25\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Date.prototype.getUTCDate()")}}\n- {{jsxref("Date.prototype.getUTCDay()")}}\n- {{jsxref("Date.prototype.setDate()")}}\n'
        },
        "getday": {
            "index.md": '---\ntitle: Date.prototype.getDay()\nslug: Web/JavaScript/Reference/Global_Objects/Date/getDay\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Date.getDay\n---\n\n{{JSRef}}\n\nThe **`getDay()`** method of {{jsxref("Date")}} instances returns the day of the week for this date according to local time, where 0 represents Sunday. For the day of the month, see {{jsxref("Date.prototype.getDate()")}}.\n\n{{EmbedInteractiveExample("pages/js/date-getday.html", "shorter")}}\n\n## Syntax\n\n```js-nolint\ngetDay()\n```\n\n### Parameters\n\nNone.\n\n### Return value\n\nAn integer, between 0 and 6, representing the day of the week for the given date according to local time: 0 for Sunday, 1 for Monday, 2 for Tuesday, and so on. Returns `NaN` if the date is [invalid](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#the_epoch_timestamps_and_invalid_date).\n\n## Description\n\nThe return value of `getDay()` is zero-based, which is useful for indexing into arrays of days, for example:\n\n```js\nconst valentines = new Date("1995-02-14");\nconst day = valentines.getDay();\nconst dayNames = ["Sunday", "Monday", "Tuesday" /* , \u2026 */];\n\nconsole.log(dayNames[day]); // "Monday"\n```\n\nHowever, for the purpose of internationalization, you should prefer using {{jsxref("Intl.DateTimeFormat")}} with the `options` parameter instead.\n\n```js\nconst options = { weekday: "long" };\nconsole.log(new Intl.DateTimeFormat("en-US", options).format(valentines));\n// "Monday"\nconsole.log(new Intl.DateTimeFormat("de-DE", options).format(valentines));\n// "Montag"\n```\n\n## Examples\n\n### Using getDay()\n\nThe `weekday` variable has value `1`, based on the value of the {{jsxref("Date")}} object `xmas95`, because December 25, 1995 is a Monday.\n\n```js\nconst xmas95 = new Date("1995-12-25T23:15:30");\nconst weekday = xmas95.getDay();\n\nconsole.log(weekday); // 1\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Date.prototype.getUTCDate()")}}\n- {{jsxref("Date.prototype.getUTCDay()")}}\n- {{jsxref("Date.prototype.setDate()")}}\n'
        },
        "getfullyear": {
            "index.md": '---\ntitle: Date.prototype.getFullYear()\nslug: Web/JavaScript/Reference/Global_Objects/Date/getFullYear\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Date.getFullYear\n---\n\n{{JSRef}}\n\nThe **`getFullYear()`** method of {{jsxref("Date")}} instances returns the year for this date according to local time.\n\nUse this method instead of the {{jsxref("Date/getYear", "getYear()")}} method.\n\n{{EmbedInteractiveExample("pages/js/date-getfullyear.html", "shorter")}}\n\n## Syntax\n\n```js-nolint\ngetFullYear()\n```\n\n### Parameters\n\nNone.\n\n### Return value\n\nAn integer representing the year for the given date according to local time. Returns `NaN` if the date is [invalid](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#the_epoch_timestamps_and_invalid_date).\n\n## Description\n\nUnlike {{jsxref("Date/getYear", "getYear()")}}, the value returned by `getFullYear()` is an absolute number. For dates between the years 1000 and 9999, `getFullYear()` returns a four-digit number, for example, 1995. Use this function to make sure a year is compliant with years after 2000.\n\n## Examples\n\n### Using getFullYear()\n\nThe `fullYear` variable has value `1995`, based on the value of the {{jsxref("Date")}} object `xmas95`.\n\n```js\nconst xmas95 = new Date("1995-12-25T23:15:30");\nconst fullYear = xmas95.getFullYear();\n\nconsole.log(fullYear); // 1995\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Date.prototype.getUTCFullYear()")}}\n- {{jsxref("Date.prototype.setFullYear()")}}\n- {{jsxref("Date.prototype.getYear()")}}\n'
        },
        "gethours": {
            "index.md": '---\ntitle: Date.prototype.getHours()\nslug: Web/JavaScript/Reference/Global_Objects/Date/getHours\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Date.getHours\n---\n\n{{JSRef}}\n\nThe **`getHours()`** method of {{jsxref("Date")}} instances returns the hours for this date according to local time.\n\n{{EmbedInteractiveExample("pages/js/date-gethours.html", "shorter")}}\n\n## Syntax\n\n```js-nolint\ngetHours()\n```\n\n### Parameters\n\nNone.\n\n### Return value\n\nAn integer, between 0 and 23, representing the hours for the given date according to local time. Returns `NaN` if the date is [invalid](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#the_epoch_timestamps_and_invalid_date).\n\n## Examples\n\n### Using getHours()\n\nThe `hours` variable has value `23`, based on the value of the {{jsxref("Date")}} object `xmas95`.\n\n```js\nconst xmas95 = new Date("1995-12-25T23:15:30");\nconst hours = xmas95.getHours();\n\nconsole.log(hours); // 23\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Date.prototype.getUTCHours()")}}\n- {{jsxref("Date.prototype.setHours()")}}\n'
        },
        "getmilliseconds": {
            "index.md": '---\ntitle: Date.prototype.getMilliseconds()\nslug: Web/JavaScript/Reference/Global_Objects/Date/getMilliseconds\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Date.getMilliseconds\n---\n\n{{JSRef}}\n\nThe **`getMilliseconds()`** method of {{jsxref("Date")}} instances returns the milliseconds for this date according to local time.\n\n{{EmbedInteractiveExample("pages/js/date-getmilliseconds.html", "shorter")}}\n\n## Syntax\n\n```js-nolint\ngetMilliseconds()\n```\n\n### Parameters\n\nNone.\n\n### Return value\n\nAn integer, between 0 and 999, representing the milliseconds for the given date according to local time. Returns `NaN` if the date is [invalid](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#the_epoch_timestamps_and_invalid_date).\n\n## Examples\n\n### Using getMilliseconds()\n\nThe `milliseconds` variable has value `0`, based on the value of the {{jsxref("Date")}} object `xmas95`, which doesn\'t specify the milliseconds component, so it defaults to 0.\n\n```js\nconst xmas95 = new Date("1995-12-25T23:15:30");\nconst milliseconds = xmas95.getMilliseconds();\n\nconsole.log(milliseconds); // 0\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Date.prototype.getUTCMilliseconds()")}}\n- {{jsxref("Date.prototype.setMilliseconds()")}}\n'
        },
        "getminutes": {
            "index.md": '---\ntitle: Date.prototype.getMinutes()\nslug: Web/JavaScript/Reference/Global_Objects/Date/getMinutes\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Date.getMinutes\n---\n\n{{JSRef}}\n\nThe **`getMinutes()`** method of {{jsxref("Date")}} instances returns the minutes for this date according to local time.\n\n{{EmbedInteractiveExample("pages/js/date-getminutes.html", "shorter")}}\n\n## Syntax\n\n```js-nolint\ngetMinutes()\n```\n\n### Parameters\n\nNone.\n\n### Return value\n\nAn integer, between 0 and 59, representing the minutes for the given date according to local time. Returns `NaN` if the date is [invalid](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#the_epoch_timestamps_and_invalid_date).\n\n## Examples\n\n### Using getMinutes()\n\nThe `minutes` variable has value `15`, based on the value of the {{jsxref("Date")}} object `xmas95`.\n\n```js\nconst xmas95 = new Date("1995-12-25T23:15:30");\nconst minutes = xmas95.getMinutes();\n\nconsole.log(minutes); // 15\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Date.prototype.getUTCMinutes()")}}\n- {{jsxref("Date.prototype.setMinutes()")}}\n'
        },
        "getmonth": {
            "index.md": '---\ntitle: Date.prototype.getMonth()\nslug: Web/JavaScript/Reference/Global_Objects/Date/getMonth\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Date.getMonth\n---\n\n{{JSRef}}\n\nThe **`getMonth()`** method of {{jsxref("Date")}} instances returns the month for this date according to local time, as a zero-based value (where zero indicates the first month of the year).\n\n{{EmbedInteractiveExample("pages/js/date-getmonth.html", "shorter")}}\n\n## Syntax\n\n```js-nolint\ngetMonth()\n```\n\n### Parameters\n\nNone.\n\n### Return value\n\nAn integer, between 0 and 11, representing the month for the given date according to local time: 0 for January, 1 for February, and so on. Returns `NaN` if the date is [invalid](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#the_epoch_timestamps_and_invalid_date).\n\n## Description\n\nThe return value of `getMonth()` is zero-based, which is useful for indexing into arrays of months, for example:\n\n```js\nconst valentines = new Date("1995-02-14");\nconst month = valentines.getMonth();\nconst monthNames = ["January", "February", "March" /* , \u2026 */];\n\nconsole.log(monthNames[month]); // "February"\n```\n\nHowever, for the purpose of internationalization, you should prefer using {{jsxref("Intl.DateTimeFormat")}} with the `options` parameter instead.\n\n```js\nconst options = { month: "long" };\nconsole.log(new Intl.DateTimeFormat("en-US", options).format(valentines));\n// "February"\nconsole.log(new Intl.DateTimeFormat("de-DE", options).format(valentines));\n// "Februar"\n```\n\n## Examples\n\n### Using getMonth()\n\nThe `month` variable has value `11`, based on the value of the {{jsxref("Date")}} object `xmas95`.\n\n```js\nconst xmas95 = new Date("1995-12-25T23:15:30");\nconst month = xmas95.getMonth();\n\nconsole.log(month); // 11\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Date.prototype.getUTCMonth()")}}\n- {{jsxref("Date.prototype.setMonth()")}}\n'
        },
        "getseconds": {
            "index.md": '---\ntitle: Date.prototype.getSeconds()\nslug: Web/JavaScript/Reference/Global_Objects/Date/getSeconds\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Date.getSeconds\n---\n\n{{JSRef}}\n\nThe **`getSeconds()`** method of {{jsxref("Date")}} instances returns the seconds for this date according to local time.\n\n{{EmbedInteractiveExample("pages/js/date-getseconds.html", "shorter")}}\n\n## Syntax\n\n```js-nolint\ngetSeconds()\n```\n\n### Parameters\n\nNone.\n\n### Return value\n\nAn integer, between 0 and 59, representing the seconds for the given date according to local time. Returns `NaN` if the date is [invalid](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#the_epoch_timestamps_and_invalid_date).\n\n## Examples\n\n### Using getSeconds()\n\nThe `seconds` variable has value `30`, based on the value of the {{jsxref("Date")}} object `xmas95`.\n\n```js\nconst xmas95 = new Date("1995-12-25T23:15:30");\nconst seconds = xmas95.getSeconds();\n\nconsole.log(seconds); // 30\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Date.prototype.getUTCSeconds()")}}\n- {{jsxref("Date.prototype.setSeconds()")}}\n'
        },
        "gettime": {
            "index.md": '---\ntitle: Date.prototype.getTime()\nslug: Web/JavaScript/Reference/Global_Objects/Date/getTime\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Date.getTime\n---\n\n{{JSRef}}\n\nThe **`getTime()`** method of {{jsxref("Date")}} instances returns the number of milliseconds for this date since the [epoch](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#the_epoch_timestamps_and_invalid_date), which is defined as the midnight at the beginning of January 1, 1970, UTC.\n\n{{EmbedInteractiveExample("pages/js/date-gettime.html", "shorter")}}\n\n## Syntax\n\n```js-nolint\ngetTime()\n```\n\n### Parameters\n\nNone.\n\n### Return value\n\nA number representing the [timestamp](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#the_epoch_timestamps_and_invalid_date), in milliseconds, of this date. Returns `NaN` if the date is [invalid](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#the_epoch_timestamps_and_invalid_date).\n\n## Description\n\n`Date` objects are fundamentally represented by a [timestamp](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#the_epoch_timestamps_and_invalid_date), and this method allows you to retrieve the timestamp. You can use this method to help assign a date and time to another {{jsxref("Date")}} object. This method is functionally equivalent to the {{jsxref("Date/valueof", "valueOf()")}} method.\n\n### Reduced time precision\n\nTo offer protection against timing attacks and [fingerprinting](/en-US/docs/Glossary/Fingerprinting), the precision of `new Date().getTime()` might get rounded depending on browser settings. In Firefox, the `privacy.reduceTimerPrecision` preference is enabled by default and defaults to 2ms. You can also enable `privacy.resistFingerprinting`, in which case the precision will be 100ms or the value of `privacy.resistFingerprinting.reduceTimerPrecision.microseconds`, whichever is larger.\n\n```js\n// reduced time precision (2ms) in Firefox 60\nnew Date().getTime();\n// 1519211809934\n// 1519211810362\n// 1519211811670\n// \u2026\n\n// reduced time precision with `privacy.resistFingerprinting` enabled\nnew Date().getTime();\n// 1519129853500\n// 1519129858900\n// 1519129864400\n// \u2026\n```\n\n## Examples\n\n### Using getTime() for copying dates\n\nConstructing a date object with the identical time value.\n\n```js\n// Since month is zero based, birthday will be January 10, 1995\nconst birthday = new Date(1994, 12, 10);\nconst copy = new Date();\ncopy.setTime(birthday.getTime());\n```\n\n### Measuring execution time\n\nSubtracting two subsequent `getTime()` calls on newly generated {{jsxref("Date")}} objects, give the time span between these two calls. This can be used to calculate the executing time of some operations. See also {{jsxref("Date.now()")}} to prevent instantiating unnecessary {{jsxref("Date")}} objects.\n\n```js\nlet end, start;\n\nstart = new Date();\nfor (let i = 0; i < 1000; i++) {\n  Math.sqrt(i);\n}\nend = new Date();\n\nconsole.log(`Operation took ${end.getTime() - start.getTime()} msec`);\n```\n\n> **Note:** In browsers that support the {{domxref("performance_property", "Web Performance API", "", 1)}}\'s high-resolution time feature, {{domxref("Performance.now()")}} can provide more reliable and precise measurements of elapsed time than {{jsxref("Date.now()")}}.\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Date.prototype.setTime()")}}\n- {{jsxref("Date.prototype.valueOf()")}}\n- {{jsxref("Date.now()")}}\n'
        },
        "gettimezoneoffset": {
            "index.md": '---\ntitle: Date.prototype.getTimezoneOffset()\nslug: Web/JavaScript/Reference/Global_Objects/Date/getTimezoneOffset\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Date.getTimezoneOffset\n---\n\n{{JSRef}}\n\nThe **`getTimezoneOffset()`** method of {{jsxref("Date")}} instances returns the difference, in minutes, between this date as evaluated in the UTC time zone, and the same date as evaluated in the local time zone.\n\n{{EmbedInteractiveExample("pages/js/date-gettimezoneoffset.html")}}\n\n## Syntax\n\n```js-nolint\ngetTimezoneOffset()\n```\n\n### Parameters\n\nNone.\n\n### Return value\n\nA number representing the difference, in minutes, between the date as evaluated in the UTC time zone and as evaluated in the local time zone. The actual local time algorithm is implementation-defined, and the return value is allowed to be zero in runtimes without appropriate data. Returns `NaN` if the date is [invalid](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#the_epoch_timestamps_and_invalid_date).\n\n## Description\n\n`date.getTimezoneOffset()` returns the difference, in minutes, between `date` as evaluated in the UTC time zone and as evaluated in the local time zone \u2014 that is, the time zone of the host system in which the browser is being used (if the code is run from the Web in a browser), or otherwise the host system of whatever JavaScript runtime (for example, a Node.js environment) the code is executed in.\n\n### Negative values and positive values\n\nThe number of minutes returned by `getTimezoneOffset()` is positive if the local time zone is behind UTC, and negative if the local time zone is ahead of UTC. For example, for UTC+10, `-600` will be returned.\n\n| Current time zone | Return value |\n| ----------------- | ------------ |\n| UTC-8             | 480          |\n| UTC               | 0            |\n| UTC+3             | -180         |\n\n### Varied results in Daylight Saving Time (DST) regions\n\nIn a region that annually shifts in and out of Daylight Saving Time (DST), as `date` varies, the number of minutes returned by calling `getTimezoneOffset()` can be non-uniform.\n\n> **Note:** `getTimezoneOffset()`\'s behavior will never differ based on the time when the code is run \u2014 its behavior is always consistent when running in the same region. Only the value of `date` affects the result.\n\nIn most implementations, the [IANA time zone database](https://en.wikipedia.org/wiki/Daylight_saving_time#IANA_time_zone_database) (tzdata) is used to precisely determine the offset of the local timezone at the moment of the `date`. However, if such information is unavailable, an implementation may return zero.\n\n## Examples\n\n### Using getTimezoneOffset()\n\n```js\n// Create a Date instance for the current time\nconst currentLocalDate = new Date();\n// Create a Date instance for 03:24 GMT-0200 on May 1st in 2016\nconst laborDay2016at0324GMTminus2 = new Date("2016-05-01T03:24:00-02:00");\ncurrentLocalDate.getTimezoneOffset() ===\n  laborDay2016at0324GMTminus2.getTimezoneOffset();\n// true, always, in any timezone that doesn\'t annually shift in and out of DST\n// false, sometimes, in any timezone that annually shifts in and out of DST\n```\n\n### getTimezoneOffset() and DST\n\nIn regions that use DST, the return value may change based on the time of the year `date` is in. Below is the output in a runtime in New York, where the timezone is UTC-05:00.\n\n```js\nconst nyOffsetSummer = new Date("2022-02-01").getTimezoneOffset(); // 300\nconst nyOffsetWinter = new Date("2022-08-01").getTimezoneOffset(); // 240\n```\n\n### getTimezoneOffset() and historical data\n\nDue to historical reasons, the timezone a region is in can be constantly changing, even disregarding DST. For example, below is the output in a runtime in Shanghai, where the timezone is UTC+08:00.\n\n```js\nconst shModernOffset = new Date("2022-01-27").getTimezoneOffset(); // -480\nconst shHistoricalOffset = new Date("1943-01-27").getTimezoneOffset(); // -540\n```\n\nThis is because during the [Sino-Japanese War](https://en.wikipedia.org/wiki/Second_Sino-Japanese_War) when Shanghai was under Japanese control, the timezone was changed to UTC+09:00 to align with Japan\'s (in effect, it was a "year-round DST"), and this was recorded in the IANA database.\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Date")}}\n'
        },
        "getutcdate": {
            "index.md": '---\ntitle: Date.prototype.getUTCDate()\nslug: Web/JavaScript/Reference/Global_Objects/Date/getUTCDate\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Date.getUTCDate\n---\n\n{{JSRef}}\n\nThe **`getUTCDate()`** method of {{jsxref("Date")}} instances returns the day of the month for this date according to universal time.\n\n{{EmbedInteractiveExample("pages/js/date-getutcdate.html")}}\n\n## Syntax\n\n```js-nolint\ngetUTCDate()\n```\n\n### Parameters\n\nNone.\n\n### Return value\n\nAn integer, between 1 and 31, representing day of month for the given date according to universal time. Returns `NaN` if the date is [invalid](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#the_epoch_timestamps_and_invalid_date).\n\n## Examples\n\n### Using getUTCDate()\n\nThe following example assigns the day of month of the current date to the variable `dayOfMonth`.\n\n```js\nconst today = new Date();\nconst dayOfMonth = today.getUTCDate();\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Date.prototype.getUTCDate()")}}\n- {{jsxref("Date.prototype.getDay()")}}\n- {{jsxref("Date.prototype.setUTCDate()")}}\n'
        },
        "getutcday": {
            "index.md": '---\ntitle: Date.prototype.getUTCDay()\nslug: Web/JavaScript/Reference/Global_Objects/Date/getUTCDay\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Date.getUTCDay\n---\n\n{{JSRef}}\n\nThe **`getUTCDay()`** method of {{jsxref("Date")}} instances returns the day of the week for this date according to universal time, where 0 represents Sunday.\n\n{{EmbedInteractiveExample("pages/js/date-getutcday.html")}}\n\n## Syntax\n\n```js-nolint\ngetUTCDay()\n```\n\n### Parameters\n\nNone.\n\n### Return value\n\nAn integer corresponding to the day of the week for the given date according to universal time: 0 for Sunday, 1 for Monday, 2 for Tuesday, and so on. Returns `NaN` if the date is [invalid](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#the_epoch_timestamps_and_invalid_date).\n\n## Examples\n\n### Using getUTCDay()\n\nThe following example assigns the weekday portion of the current date to the variable `weekday`.\n\n```js\nconst today = new Date();\nconst weekday = today.getUTCDay();\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Date.prototype.getUTCDate()")}}\n- {{jsxref("Date.prototype.getDay()")}}\n- {{jsxref("Date.prototype.setUTCDate()")}}\n'
        },
        "getutcfullyear": {
            "index.md": '---\ntitle: Date.prototype.getUTCFullYear()\nslug: Web/JavaScript/Reference/Global_Objects/Date/getUTCFullYear\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Date.getUTCFullYear\n---\n\n{{JSRef}}\n\nThe **`getUTCFullYear()`** method of {{jsxref("Date")}} instances returns the year for this date according to universal time.\n\n{{EmbedInteractiveExample("pages/js/date-getutcfullyear.html")}}\n\n## Syntax\n\n```js-nolint\ngetUTCFullYear()\n```\n\n### Parameters\n\nNone.\n\n### Return value\n\nAn integer representing the year for the given date according to universal time. Returns `NaN` if the date is [invalid](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#the_epoch_timestamps_and_invalid_date).\n\n## Description\n\nUnlike {{jsxref("Date/getYear", "getYear()")}}, the value returned by `getUTCFullYear()` is an absolute number. For dates between the years 1000 and 9999, `getFullYear()` returns a four-digit number, for example, 1995. Use this function to make sure a year is compliant with years after 2000.\n\n## Examples\n\n### Using getUTCFullYear()\n\nThe following example assigns the four-digit value of the current year to the variable `year`.\n\n```js\nconst today = new Date();\nconst year = today.getUTCFullYear();\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Date.prototype.getFullYear()")}}\n- {{jsxref("Date.prototype.setFullYear()")}}\n'
        },
        "getutchours": {
            "index.md": '---\ntitle: Date.prototype.getUTCHours()\nslug: Web/JavaScript/Reference/Global_Objects/Date/getUTCHours\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Date.getUTCHours\n---\n\n{{JSRef}}\n\nThe **`getUTCHours()`** method of {{jsxref("Date")}} instances returns the hours for this date according to universal time.\n\n{{EmbedInteractiveExample("pages/js/date-getutchours.html")}}\n\n## Syntax\n\n```js-nolint\ngetUTCHours()\n```\n\n### Parameters\n\nNone.\n\n### Return value\n\nAn integer, between 0 and 23, representing the hours for the given date according to universal time. Returns `NaN` if the date is [invalid](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#the_epoch_timestamps_and_invalid_date).\n\n## Examples\n\n### Using getUTCHours()\n\nThe following example assigns the hours portion of the current time to the variable `hours`.\n\n```js\nconst today = new Date();\nconst hours = today.getUTCHours();\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Date.prototype.getHours()")}}\n- {{jsxref("Date.prototype.setUTCHours()")}}\n'
        },
        "getutcmilliseconds": {
            "index.md": '---\ntitle: Date.prototype.getUTCMilliseconds()\nslug: Web/JavaScript/Reference/Global_Objects/Date/getUTCMilliseconds\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Date.getUTCMilliseconds\n---\n\n{{JSRef}}\n\nThe **`getUTCMilliseconds()`** method of {{jsxref("Date")}} instances returns the milliseconds for this date according to universal time.\n\n{{EmbedInteractiveExample("pages/js/date-getutcmilliseconds.html", "shorter")}}\n\n## Syntax\n\n```js-nolint\ngetUTCMilliseconds()\n```\n\n### Parameters\n\nNone.\n\n### Return value\n\nAn integer, between 0 and 999, representing the milliseconds for the given date according to universal time. Returns `NaN` if the date is [invalid](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#the_epoch_timestamps_and_invalid_date).\n\nNot to be confused with the timestamp. To get the total milliseconds since the epoch, use the [`getTime()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/getTime) method.\n\n## Examples\n\n### Using getUTCMilliseconds()\n\nThe following example assigns the milliseconds portion of the current time to the variable `milliseconds`.\n\n```js\nconst today = new Date();\nconst milliseconds = today.getUTCMilliseconds();\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Date.prototype.getMilliseconds()")}}\n- {{jsxref("Date.prototype.setUTCMilliseconds()")}}\n'
        },
        "getutcminutes": {
            "index.md": '---\ntitle: Date.prototype.getUTCMinutes()\nslug: Web/JavaScript/Reference/Global_Objects/Date/getUTCMinutes\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Date.getUTCMinutes\n---\n\n{{JSRef}}\n\nThe **`getUTCMinutes()`** method of {{jsxref("Date")}} instances returns the minutes for this date according to universal time.\n\n{{EmbedInteractiveExample("pages/js/date-getutcminutes.html")}}\n\n## Syntax\n\n```js-nolint\ngetUTCMinutes()\n```\n\n### Parameters\n\nNone.\n\n### Return value\n\nAn integer, between 0 and 59, representing the minutes for the given date according to universal time. Returns `NaN` if the date is [invalid](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#the_epoch_timestamps_and_invalid_date).\n\n## Examples\n\n### Using getUTCMinutes()\n\nThe following example assigns the minutes portion of the current time to the variable `minutes`.\n\n```js\nconst today = new Date();\nconst minutes = today.getUTCMinutes();\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Date.prototype.getMinutes()")}}\n- {{jsxref("Date.prototype.setUTCMinutes()")}}\n'
        },
        "getutcmonth": {
            "index.md": '---\ntitle: Date.prototype.getUTCMonth()\nslug: Web/JavaScript/Reference/Global_Objects/Date/getUTCMonth\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Date.getUTCMonth\n---\n\n{{JSRef}}\n\nThe **`getUTCMonth()`** method of {{jsxref("Date")}} instances returns the month for this date according to universal time, as a zero-based value (where zero indicates the first month of the year).\n\n{{EmbedInteractiveExample("pages/js/date-getutcmonth.html")}}\n\n## Syntax\n\n```js-nolint\ngetUTCMonth()\n```\n\n### Parameters\n\nNone.\n\n### Return value\n\nAn integer, between 0 and 11, representing the month for the given date according to universal time: 0 for January, 1 for February, and so on. Returns `NaN` if the date is [invalid](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#the_epoch_timestamps_and_invalid_date).\n\n## Examples\n\n### Using getUTCMonth()\n\nThe following example assigns the month portion of the current date to the variable `month`.\n\n```js\nconst today = new Date();\nconst month = today.getUTCMonth();\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Date.prototype.getMonth()")}}\n- {{jsxref("Date.prototype.setUTCMonth()")}}\n'
        },
        "getutcseconds": {
            "index.md": '---\ntitle: Date.prototype.getUTCSeconds()\nslug: Web/JavaScript/Reference/Global_Objects/Date/getUTCSeconds\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Date.getUTCSeconds\n---\n\n{{JSRef}}\n\nThe **`getUTCSeconds()`** method of {{jsxref("Date")}} instances returns the seconds in the specified date according to universal time.\n\n{{EmbedInteractiveExample("pages/js/date-getutcseconds.html", "shorter")}}\n\n## Syntax\n\n```js-nolint\ngetUTCSeconds()\n```\n\n### Parameters\n\nNone.\n\n### Return value\n\nAn integer, between 0 and 59, representing the seconds for the given date according to universal time. Returns `NaN` if the date is [invalid](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#the_epoch_timestamps_and_invalid_date).\n\n## Examples\n\n### Using getUTCSeconds()\n\nThe following example assigns the seconds portion of the current time to the variable `seconds`.\n\n```js\nconst today = new Date();\nconst seconds = today.getUTCSeconds();\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Date.prototype.getSeconds()")}}\n- {{jsxref("Date.prototype.setUTCSeconds()")}}\n'
        },
        "getyear": {
            "index.md": '---\ntitle: Date.prototype.getYear()\nslug: Web/JavaScript/Reference/Global_Objects/Date/getYear\npage-type: javascript-instance-method\nstatus:\n  - deprecated\nbrowser-compat: javascript.builtins.Date.getYear\n---\n\n{{JSRef}} {{Deprecated_Header}}\n\nThe **`getYear()`** method of {{jsxref("Date")}} instances returns the year for this date according to local time. Because `getYear()` does not return full years ("year 2000 problem"), it is deprecated and has been replaced by the {{jsxref("Date/getFullYear", "getFullYear()")}} method.\n\n## Syntax\n\n```js-nolint\ngetYear()\n```\n\n### Parameters\n\nNone.\n\n### Return value\n\nAn integer representing the year for the given date according to local time, minus 1900. Returns `NaN` if the date is [invalid](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#the_epoch_timestamps_and_invalid_date).\n\n- For years greater than or equal to 2000, the value is 100 or greater. For example, if the year is 2026, `getYear()` returns 126.\n- For years between and including 1900 and 1999, the value returned by `getYear()` is between 0 and 99. For example, if the year is 1976, `getYear()` returns 76.\n- For years less than 1900, the value returned by `getYear()` is less than 0. For example, if the year is 1800, `getYear()` returns -100.\n\nThis method essentially returns the value of {{jsxref("Date/getFullYear", "getFullYear()")}} minus 1900. You should use `getFullYear()` instead, so that the year is specified in full.\n\n## Examples\n\n### Years between 1900 and 1999\n\nThe second statement assigns the value 95 to the variable `year`.\n\n```js\nconst xmas = new Date("1995-12-25");\nconst year = xmas.getYear(); // returns 95\n```\n\n### Years above 1999\n\nThe second statement assigns the value 100 to the variable `year`.\n\n```js\nconst xmas = new Date("2000-12-25");\nconst year = xmas.getYear(); // returns 100\n```\n\n### Years below 1900\n\nThe second statement assigns the value -100 to the variable `year`.\n\n```js\nconst xmas = new Date("1800-12-25");\nconst year = xmas.getYear(); // returns -100\n```\n\n### Setting and getting a year between 1900 and 1999\n\nThe third statement assigns the value 95 to the variable `year`, representing the year 1995.\n\n```js\nconst xmas = new Date("2015-12-25");\nxmas.setYear(95);\nconst year = xmas.getYear(); // returns 95\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Date.prototype.getYear` in `core-js`](https://github.com/zloirock/core-js#ecmascript-date)\n- {{jsxref("Date.prototype.getFullYear()")}}\n- {{jsxref("Date.prototype.getUTCFullYear()")}}\n- {{jsxref("Date.prototype.setYear()")}}\n'
        },
        "index.md": '---\ntitle: Date\nslug: Web/JavaScript/Reference/Global_Objects/Date\npage-type: javascript-class\nbrowser-compat: javascript.builtins.Date\n---\n\n{{JSRef}}\n\nJavaScript **`Date`** objects represent a single moment in time in a platform-independent format. `Date` objects encapsulate an integral number that represents milliseconds since the midnight at the beginning of January 1, 1970, UTC (the _epoch_).\n\n> **Note:** TC39 is working on [Temporal](https://tc39.es/proposal-temporal/docs/index.html), a new Date/Time API. Read more about it on the [Igalia blog](https://blogs.igalia.com/compilers/2020/06/23/dates-and-times-in-javascript/). It is not yet ready for production use!\n\n## Description\n\n### The epoch, timestamps, and invalid date\n\nA JavaScript date is fundamentally specified as the time in milliseconds that has elapsed since the [epoch](https://tc39.es/ecma262/multipage/numbers-and-dates.html#sec-time-values-and-time-range), which is defined as the midnight at the beginning of January 1, 1970, UTC (equivalent to the [UNIX epoch](/en-US/docs/Glossary/Unix_time)). This timestamp is _timezone-agnostic_ and uniquely defines an instant in history.\n\n> **Note:** While the time value at the heart of a Date object is UTC, the basic methods to fetch the date and time or its components all work in the local (i.e. host system) time zone and offset.\n\nThe maximum timestamp representable by a `Date` object is slightly smaller than the maximum safe integer ({{jsxref("Number.MAX_SAFE_INTEGER")}}, which is 9,007,199,254,740,991). A `Date` object can represent a maximum of \xb18,640,000,000,000,000 milliseconds, or \xb1100,000,000 (one hundred million) days, relative to the epoch. This is the range from April 20, 271821 BC to September 13, 275760 AD. Any attempt to represent a time outside this range results in the `Date` object holding a timestamp value of [`NaN`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/NaN), which is an "Invalid Date".\n\n```js\nconsole.log(new Date(8.64e15).toString()); // "Sat Sep 13 275760 00:00:00 GMT+0000 (Coordinated Universal Time)"\nconsole.log(new Date(8.64e15 + 1).toString()); // "Invalid Date"\n```\n\nThere are various methods that allow you to interact with the timestamp stored in the date:\n\n- You can interact with the timestamp value directly using the {{jsxref("Date/getTime", "getTime()")}} and {{jsxref("Date/setTime", "setTime()")}} methods.\n- The {{jsxref("Date/valueOf", "valueOf()")}} and [`[@@toPrimitive]()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/@@toPrimitive) (when passed `"number"`) methods \u2014 which are automatically called in [number coercion](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number#number_coercion) \u2014 return the timestamp, causing `Date` objects to behave like their timestamps when used in number contexts.\n- All static methods ({{jsxref("Date.now()")}}, {{jsxref("Date.parse()")}}, and {{jsxref("Date.UTC()")}}) return timestamps instead of `Date` objects.\n- The {{jsxref("Date/Date", "Date()")}} constructor can be called with a timestamp as the only argument.\n\n### Date components and time zones\n\nA date is represented internally as a single number, the _timestamp_. When interacting with it, the timestamp needs to be interpreted as a structured date-and-time representation. There are always two ways to interpret a timestamp: as a local time or as a Coordinated Universal Time (UTC), the global standard time defined by the World Time Standard. The local timezone is not stored in the date object, but is determined by the host environment (user\'s device).\n\n> **Note:** UTC should not be confused with the [Greenwich Mean Time](https://en.wikipedia.org/wiki/Greenwich_Mean_Time) (GMT), because they are not always equal \u2014 this is explained in more detail in the linked Wikipedia page.\n\nFor example, the timestamp 0 represents a unique instant in history, but it can be interpreted in two ways:\n\n- As a UTC time, it is midnight at the beginning of January 1, 1970, UTC,\n- As a local time in New York (UTC-5), it is 19:00:00 on December 31, 1969.\n\nThe {{jsxref("Date/getTimezoneOffset", "getTimezoneOffset()")}} method returns the difference between UTC and the local time in minutes. Note that the timezone offset does not only depend on the current timezone, but also on the time represented by the `Date` object, because of daylight saving time and historical changes. In essence, the timezone offset is the offset from UTC time, at the time represented by the `Date` object and at the location of the host environment.\n\nThere are two groups of `Date` methods: one group gets and sets various date components by interpreting the timestamp as a local time, while the other uses UTC.\n\n<table class="standard-table">\n  <thead>\n    <tr>\n      <th rowspan="2">Component</th>\n      <th colspan="2">Local</th>\n      <th colspan="2">UTC</th>\n    </tr>\n    <tr>\n      <th>Get</th>\n      <th>Set</th>\n      <th>Get</th>\n      <th>Set</th>\n    </tr>\n  </thead>\n  <tbody>\n    <tr>\n      <td>Year</td>\n      <td>{{jsxref("Date/getFullYear", "getFullYear()")}}</td>\n      <td>{{jsxref("Date/setFullYear", "setFullYear()")}}</td>\n      <td>{{jsxref("Date/getUTCFullYear", "getUTCFullYear()")}}</td>\n      <td>{{jsxref("Date/setUTCFullYear", "setUTCFullYear()")}}</td>\n    </tr>\n    <tr>\n      <td>Month</td>\n      <td>{{jsxref("Date/getMonth", "getMonth()")}}</td>\n      <td>{{jsxref("Date/setMonth", "setMonth()")}}</td>\n      <td>{{jsxref("Date/getUTCMonth", "getUTCMonth()")}}</td>\n      <td>{{jsxref("Date/setUTCMonth", "setUTCMonth()")}}</td>\n    </tr>\n    <tr>\n      <td>Date (of month)</td>\n      <td>{{jsxref("Date/getDate", "getDate()")}}</td>\n      <td>{{jsxref("Date/setDate", "setDate()")}}</td>\n      <td>{{jsxref("Date/getUTCDate", "getUTCDate()")}}</td>\n      <td>{{jsxref("Date/setUTCDate", "setUTCDate()")}}</td>\n    </tr>\n    <tr>\n      <td>Hours</td>\n      <td>{{jsxref("Date/getHours", "getHours()")}}</td>\n      <td>{{jsxref("Date/setHours", "setHours()")}}</td>\n      <td>{{jsxref("Date/getUTCHours", "getUTCHours()")}}</td>\n      <td>{{jsxref("Date/setUTCHours", "setUTCHours()")}}</td>\n    </tr>\n    <tr>\n      <td>Minutes</td>\n      <td>{{jsxref("Date/getMinutes", "getMinutes()")}}</td>\n      <td>{{jsxref("Date/setMinutes", "setMinutes()")}}</td>\n      <td>{{jsxref("Date/getUTCMinutes", "getUTCMinutes()")}}</td>\n      <td>{{jsxref("Date/setUTCMinutes", "setUTCMinutes()")}}</td>\n    </tr>\n    <tr>\n      <td>Seconds</td>\n      <td>{{jsxref("Date/getSeconds", "getSeconds()")}}</td>\n      <td>{{jsxref("Date/setSeconds", "setSeconds()")}}</td>\n      <td>{{jsxref("Date/getUTCSeconds", "getUTCSeconds()")}}</td>\n      <td>{{jsxref("Date/setUTCSeconds", "setUTCSeconds()")}}</td>\n    </tr>\n    <tr>\n      <td>Milliseconds</td>\n      <td>{{jsxref("Date/getMilliseconds", "getMilliseconds()")}}</td>\n      <td>{{jsxref("Date/setMilliseconds", "setMilliseconds()")}}</td>\n      <td>{{jsxref("Date/getUTCMilliseconds", "getUTCMilliseconds()")}}</td>\n      <td>{{jsxref("Date/setUTCMilliseconds", "setUTCMilliseconds()")}}</td>\n    </tr>\n    <tr>\n      <td>Day (of week)</td>\n      <td>{{jsxref("Date/getDay", "getDay()")}}</td>\n      <td>N/A</td>\n      <td>{{jsxref("Date/getUTCDay", "getUTCDay()")}}</td>\n      <td>N/A</td>\n    </tr>\n  </tbody>\n</table>\n\nThe {{jsxref("Date/Date", "Date()")}} constructor can be called with two or more arguments, in which case they are interpreted as the year, month, day, hour, minute, second, and millisecond, respectively, in local time. {{jsxref("Date.UTC()")}} works similarly, but it interprets the components as UTC time and also accepts a single argument representing the year.\n\n> **Note:** Some methods, including the `Date()` constructor, `Date.UTC()`, and the deprecated {{jsxref("Date/getYear", "getYear()")}}/{{jsxref("Date/setYear", "setYear()")}} methods, interpret a two-digit year as a year in the 1900s. For example, `new Date(99, 5, 24)` is interpreted as June 24, 1999, not June 24, 99. See [Interpretation of two-digit years](#interpretation_of_two-digit_years) for more information.\n\nWhen a segment overflows or underflows its expected range, it usually "carries over to" or "borrows from" the higher segment. For example, if the month is set to 12 (months are zero-based, so December is 11), it become the January of the next year. If the day of month is set to 0, it becomes the last day of the previous month. This also applies to dates specified with the [date time string format](#date_time_string_format).\n\n### Date time string format\n\nThere are many ways to format a date as a string. The JavaScript specification only specifies one format to be universally supported: the [_date time string format_](https://tc39.es/ecma262/multipage/numbers-and-dates.html#sec-date-time-string-format), a simplification of the ISO 8601 calendar date extended format. The format is as follows:\n\n```plain\nYYYY-MM-DDTHH:mm:ss.sssZ\n```\n\n- `YYYY` is the year, with four digits (`0000` to `9999`), or as an _expanded year_ of `+` or `-` followed by six digits. The sign is required for expanded years. `-000000` is explicitly disallowed as a valid year.\n- `MM` is the month, with two digits (`01` to `12`). Defaults to `01`.\n- `DD` is the day of the month, with two digits (`01` to `31`). Defaults to `01`.\n- `T` is a literal character, which indicates the beginning of the _time_ part of the string. The `T` is required when specifying the time part.\n- `HH` is the hour, with two digits (`00` to `23`). As a special case, `24:00:00` is allowed, and is interpreted as midnight at the beginning of the next day. Defaults to `00`.\n- `mm` is the minute, with two digits (`00` to `59`). Defaults to `00`.\n- `ss` is the second, with two digits (`00` to `59`). Defaults to `00`.\n- `sss` is the millisecond, with three digits (`000` to `999`). Defaults to `000`.\n- `Z` is the timezone offset, which can either be the literal character `Z` (indicating UTC), or `+` or `-` followed by `HH:mm`, the offset in hours and minutes from UTC.\n\nVarious components can be omitted, so the following are all valid:\n\n- Date-only form: `YYYY`, `YYYY-MM`, `YYYY-MM-DD`\n- Date-time form: one of the above date-only forms, followed by `T`, followed by `HH:mm`, `HH:mm:ss`, or `HH:mm:ss.sss`. Each combination can be followed by a time zone offset.\n\nFor example, `"2011-10-10"` (_date-only_ form), `"2011-10-10T14:48:00"` (_date-time_ form), or `"2011-10-10T14:48:00.000+09:00"` (_date-time_ form with milliseconds and time zone) are all valid date time strings.\n\nWhen the time zone offset is absent, **date-only forms are interpreted as a UTC time and date-time forms are interpreted as local time.** This is due to a historical spec error that was not consistent with ISO 8601 but could not be changed due to web compatibility. See [Broken Parser \u2013 A Web Reality Issue](https://maggiepint.com/2017/04/11/fixing-javascript-date-web-compatibility-and-reality/).\n\n{{jsxref("Date.parse()")}} and the {{jsxref("Date/Date", "Date()")}} constructor both accept strings in the date time string format as input. Furthermore, implementations are allowed to support other date formats when the input fails to match this format.\n\nThe {{jsxref("Date/toISOString", "toISOString()")}} method returns a string representation of the date in the date time string format, with the time zone offset always set to `Z` (UTC).\n\n> **Note:** You are encouraged to make sure your input conforms to the date time string format above for maximum compatibility, because support for other formats is not guaranteed. However, there are some formats that are supported in all major implementations \u2014 like {{rfc(2822)}} format \u2014 in which case their usage can be acceptable. Always conduct [cross-browser tests](/en-US/docs/Learn/Tools_and_testing/Cross_browser_testing) to ensure your code works in all target browsers. A library can help if many different formats are to be accommodated.\n\nNon-standard strings can be parsed in any way as desired by the implementation, including the time zone \u2014 most implementations use the local time zone by default. Implementations are not required to return invalid date for out-of-bounds date components, although they usually do. A string may have in-bounds date components (with the bounds defined above), but does not represent a date in reality (for example, "February 30"). Implementations behave inconsistently in this case. The [`Date.parse()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/parse#examples) page offers more examples about these non-standard cases.\n\n### Other ways to format a date\n\n- {{jsxref("Date/toISOString", "toISOString()")}} returns a string in the format `1970-01-01T00:00:00.000Z` (the date time string format introduced above, which is simplified [ISO 8601](https://en.wikipedia.org/wiki/ISO_8601)). {{jsxref("Date/toJSON", "toJSON()")}} calls `toISOString()` and returns the result.\n- {{jsxref("Date/toString", "toString()")}} returns a string in the format `Thu Jan 01 1970 00:00:00 GMT+0000 (Coordinated Universal Time)`, while {{jsxref("Date/toDateString", "toDateString()")}} and {{jsxref("Date/toTimeString", "toTimeString()")}} return the date and time parts of the string, respectively. [`[@@toPrimitive]()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/@@toPrimitive) (when passed `"string"` or `"default"`) calls `toString()` and returns the result.\n- {{jsxref("Date/toUTCString", "toUTCString()")}} returns a string in the format `Thu, 01 Jan 1970 00:00:00 GMT` (generalized {{rfc(7231)}}).\n- {{jsxref("Date/toLocaleDateString", "toLocaleDateString()")}}, {{jsxref("Date/toLocaleTimeString", "toLocaleTimeString()")}}, and {{jsxref("Date/toLocaleString", "toLocaleString()")}} use locale-specific date and time formats, usually provided by the [`Intl`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl) API.\n\nSee the [Formats of `toString` method return values](#formats_of_tostring_method_return_values) section for examples.\n\n## Constructor\n\n- {{jsxref("Date/Date", "Date()")}}\n  - : When called as a constructor, returns a new `Date` object. When called as a function, returns a string representation of the current date and time.\n\n## Static methods\n\n- {{jsxref("Date.now()")}}\n  - : Returns the numeric value corresponding to the current time\u2014the number of milliseconds elapsed since January 1, 1970 00:00:00 UTC, with leap seconds ignored.\n- {{jsxref("Date.parse()")}}\n  - : Parses a string representation of a date and returns the number of milliseconds since 1 January, 1970, 00:00:00 UTC, with leap seconds ignored.\n- {{jsxref("Date.UTC()")}}\n  - : Accepts the same parameters as the longest form of the constructor (i.e. 2 to 7) and returns the number of milliseconds since January 1, 1970, 00:00:00 UTC, with leap seconds ignored.\n\n## Instance properties\n\nThese properties are defined on `Date.prototype` and shared by all `Date` instances.\n\n- {{jsxref("Object/constructor", "Date.prototype.constructor")}}\n  - : The constructor function that created the instance object. For `Date` instances, the initial value is the {{jsxref("Date/Date", "Date")}} constructor.\n\n## Instance methods\n\n- {{jsxref("Date.prototype.getDate()")}}\n  - : Returns the day of the month (`1` \u2013 `31`) for the specified date according to local time.\n- {{jsxref("Date.prototype.getDay()")}}\n  - : Returns the day of the week (`0` \u2013 `6`) for the specified date according to local time.\n- {{jsxref("Date.prototype.getFullYear()")}}\n  - : Returns the year (4 digits for 4-digit years) of the specified date according to local time.\n- {{jsxref("Date.prototype.getHours()")}}\n  - : Returns the hour (`0` \u2013 `23`) in the specified date according to local time.\n- {{jsxref("Date.prototype.getMilliseconds()")}}\n  - : Returns the milliseconds (`0` \u2013 `999`) in the specified date according to local time.\n- {{jsxref("Date.prototype.getMinutes()")}}\n  - : Returns the minutes (`0` \u2013 `59`) in the specified date according to local time.\n- {{jsxref("Date.prototype.getMonth()")}}\n  - : Returns the month (`0` \u2013 `11`) in the specified date according to local time.\n- {{jsxref("Date.prototype.getSeconds()")}}\n  - : Returns the seconds (`0` \u2013 `59`) in the specified date according to local time.\n- {{jsxref("Date.prototype.getTime()")}}\n  - : Returns the numeric value of the specified date as the number of milliseconds since January 1, 1970, 00:00:00 UTC. (Negative values are returned for prior times.)\n- {{jsxref("Date.prototype.getTimezoneOffset()")}}\n  - : Returns the time-zone offset in minutes for the current locale.\n- {{jsxref("Date.prototype.getUTCDate()")}}\n  - : Returns the day (date) of the month (`1` \u2013 `31`) in the specified date according to universal time.\n- {{jsxref("Date.prototype.getUTCDay()")}}\n  - : Returns the day of the week (`0` \u2013 `6`) in the specified date according to universal time.\n- {{jsxref("Date.prototype.getUTCFullYear()")}}\n  - : Returns the year (4 digits for 4-digit years) in the specified date according to universal time.\n- {{jsxref("Date.prototype.getUTCHours()")}}\n  - : Returns the hours (`0` \u2013 `23`) in the specified date according to universal time.\n- {{jsxref("Date.prototype.getUTCMilliseconds()")}}\n  - : Returns the milliseconds (`0` \u2013 `999`) in the specified date according to universal time.\n- {{jsxref("Date.prototype.getUTCMinutes()")}}\n  - : Returns the minutes (`0` \u2013 `59`) in the specified date according to universal time.\n- {{jsxref("Date.prototype.getUTCMonth()")}}\n  - : Returns the month (`0` \u2013 `11`) in the specified date according to universal time.\n- {{jsxref("Date.prototype.getUTCSeconds()")}}\n  - : Returns the seconds (`0` \u2013 `59`) in the specified date according to universal time.\n- {{jsxref("Date.prototype.getYear()")}} {{deprecated_inline}}\n  - : Returns the year (usually 2\u20133 digits) in the specified date according to local time. Use {{jsxref("Date/getFullYear", "getFullYear()")}} instead.\n- {{jsxref("Date.prototype.setDate()")}}\n  - : Sets the day of the month for a specified date according to local time.\n- {{jsxref("Date.prototype.setFullYear()")}}\n  - : Sets the full year (e.g. 4 digits for 4-digit years) for a specified date according to local time.\n- {{jsxref("Date.prototype.setHours()")}}\n  - : Sets the hours for a specified date according to local time.\n- {{jsxref("Date.prototype.setMilliseconds()")}}\n  - : Sets the milliseconds for a specified date according to local time.\n- {{jsxref("Date.prototype.setMinutes()")}}\n  - : Sets the minutes for a specified date according to local time.\n- {{jsxref("Date.prototype.setMonth()")}}\n  - : Sets the month for a specified date according to local time.\n- {{jsxref("Date.prototype.setSeconds()")}}\n  - : Sets the seconds for a specified date according to local time.\n- {{jsxref("Date.prototype.setTime()")}}\n  - : Sets the {{jsxref("Date")}} object to the time represented by a number of milliseconds since January 1, 1970, 00:00:00 UTC. Use negative numbers for times prior.\n- {{jsxref("Date.prototype.setUTCDate()")}}\n  - : Sets the day of the month for a specified date according to universal time.\n- {{jsxref("Date.prototype.setUTCFullYear()")}}\n  - : Sets the full year (e.g. 4 digits for 4-digit years) for a specified date according to universal time.\n- {{jsxref("Date.prototype.setUTCHours()")}}\n  - : Sets the hour for a specified date according to universal time.\n- {{jsxref("Date.prototype.setUTCMilliseconds()")}}\n  - : Sets the milliseconds for a specified date according to universal time.\n- {{jsxref("Date.prototype.setUTCMinutes()")}}\n  - : Sets the minutes for a specified date according to universal time.\n- {{jsxref("Date.prototype.setUTCMonth()")}}\n  - : Sets the month for a specified date according to universal time.\n- {{jsxref("Date.prototype.setUTCSeconds()")}}\n  - : Sets the seconds for a specified date according to universal time.\n- {{jsxref("Date.prototype.setYear()")}} {{deprecated_inline}}\n  - : Sets the year (usually 2\u20133 digits) for a specified date according to local time. Use {{jsxref("Date/setFullYear", "setFullYear()")}} instead.\n- {{jsxref("Date.prototype.toDateString()")}}\n  - : Returns the "date" portion of the {{jsxref("Date")}} as a human-readable string like `\'Thu Apr 12 2018\'`.\n- {{jsxref("Date.prototype.toISOString()")}}\n  - : Converts a date to a string following the ISO 8601 Extended Format.\n- {{jsxref("Date.prototype.toJSON()")}}\n  - : Returns a string representing the {{jsxref("Date")}} using {{jsxref("Date/toISOString", "toISOString()")}}. Intended for use by {{jsxref("JSON.stringify()")}}.\n- {{jsxref("Date.prototype.toLocaleDateString()")}}\n  - : Returns a string with a locality sensitive representation of the date portion of this date based on system settings.\n- {{jsxref("Date.prototype.toLocaleString()")}}\n  - : Returns a string with a locality-sensitive representation of this date. Overrides the {{jsxref("Object.prototype.toLocaleString()")}} method.\n- {{jsxref("Date.prototype.toLocaleTimeString()")}}\n  - : Returns a string with a locality-sensitive representation of the time portion of this date, based on system settings.\n- {{jsxref("Date.prototype.toString()")}}\n  - : Returns a string representing the specified {{jsxref("Date")}} object. Overrides the {{jsxref("Object.prototype.toString()")}} method.\n- {{jsxref("Date.prototype.toTimeString()")}}\n  - : Returns the "time" portion of the {{jsxref("Date")}} as a human-readable string.\n- {{jsxref("Date.prototype.toUTCString()")}}\n  - : Converts a date to a string using the UTC timezone.\n- {{jsxref("Date.prototype.valueOf()")}}\n  - : Returns the primitive value of a {{jsxref("Date")}} object. Overrides the {{jsxref("Object.prototype.valueOf()")}} method.\n- [`Date.prototype[@@toPrimitive]()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/@@toPrimitive)\n  - : Converts this `Date` object to a primitive value.\n\n## Examples\n\n### Several ways to create a Date object\n\nThe following examples show several ways to create JavaScript dates:\n\n> **Note:** Creating a date from a string has a lot of behavior inconsistencies. See [date time string format](#date_time_string_format) for caveats on using different formats.\n\n```js\nconst today = new Date();\nconst birthday = new Date("December 17, 1995 03:24:00"); // DISCOURAGED: may not work in all runtimes\nconst birthday2 = new Date("1995-12-17T03:24:00"); // This is standardized and will work reliably\nconst birthday3 = new Date(1995, 11, 17); // the month is 0-indexed\nconst birthday4 = new Date(1995, 11, 17, 3, 24, 0);\nconst birthday5 = new Date(628021800000); // passing epoch timestamp\n```\n\n### Formats of toString method return values\n\n```js\nconst date = new Date("2020-05-12T23:50:21.817Z");\ndate.toString(); // Tue May 12 2020 18:50:21 GMT-0500 (Central Daylight Time)\ndate.toDateString(); // Tue May 12 2020\ndate.toTimeString(); // 18:50:21 GMT-0500 (Central Daylight Time)\ndate[Symbol.toPrimitive]("string"); // Tue May 12 2020 18:50:21 GMT-0500 (Central Daylight Time)\n\ndate.toISOString(); // 2020-05-12T23:50:21.817Z\ndate.toJSON(); // 2020-05-12T23:50:21.817Z\n\ndate.toUTCString(); // Tue, 12 May 2020 23:50:21 GMT\n\ndate.toLocaleString(); // 5/12/2020, 6:50:21 PM\ndate.toLocaleDateString(); // 5/12/2020\ndate.toLocaleTimeString(); // 6:50:21 PM\n```\n\n### To get Date, Month and Year or Time\n\n```js\nconst date = new Date("2000-01-17T16:45:30");\nconst [month, day, year] = [\n  date.getMonth(),\n  date.getDate(),\n  date.getFullYear(),\n];\n// [0, 17, 2000] as month are 0-indexed\nconst [hour, minutes, seconds] = [\n  date.getHours(),\n  date.getMinutes(),\n  date.getSeconds(),\n];\n// [16, 45, 30]\n```\n\n### Interpretation of two-digit years\n\n`new Date()` exhibits legacy undesirable, inconsistent behavior with two-digit year values; specifically, when a `new Date()` call is given a two-digit year value, that year value does not get treated as a literal year and used as-is but instead gets interpreted as a relative offset \u2014 in some cases as an offset from the year `1900`, but in other cases, as an offset from the year `2000`.\n\n```js\nlet date = new Date(98, 1); // Sun Feb 01 1998 00:00:00 GMT+0000 (GMT)\ndate = new Date(22, 1); // Wed Feb 01 1922 00:00:00 GMT+0000 (GMT)\ndate = new Date("2/1/22"); // Tue Feb 01 2022 00:00:00 GMT+0000 (GMT)\n\n// Legacy method; always interprets two-digit year values as relative to 1900\ndate.setYear(98);\ndate.toString(); // Sun Feb 01 1998 00:00:00 GMT+0000 (GMT)\ndate.setYear(22);\ndate.toString(); // Wed Feb 01 1922 00:00:00 GMT+0000 (GMT)\n```\n\nSo, to create and get dates between the years `0` and `99`, instead use the preferred {{jsxref("Date/setFullYear", "setFullYear()")}} and {{jsxref("Date/getFullYear", "getFullYear()")}} methods:.\n\n```js\n// Preferred method; never interprets any value as being a relative offset,\n// but instead uses the year value as-is\ndate.setFullYear(98);\ndate.getFullYear(); // 98 (not 1998)\ndate.setFullYear(22);\ndate.getFullYear(); // 22 (not 1922, not 2022)\n```\n\n### Calculating elapsed time\n\nThe following examples show how to determine the elapsed time between two JavaScript dates in milliseconds.\n\nDue to the differing lengths of days (due to daylight saving changeover), months, and years, expressing elapsed time in units greater than hours, minutes, and seconds requires addressing a number of issues, and should be thoroughly researched before being attempted.\n\n```js\n// Using Date objects\nconst start = Date.now();\n\n// The event to time goes here:\ndoSomethingForALongTime();\nconst end = Date.now();\nconst elapsed = end - start; // elapsed time in milliseconds\n```\n\n```js\n// Using built-in methods\nconst start = new Date();\n\n// The event to time goes here:\ndoSomethingForALongTime();\nconst end = new Date();\nconst elapsed = end.getTime() - start.getTime(); // elapsed time in milliseconds\n```\n\n```js\n// To test a function and get back its return\nfunction printElapsedTime(testFn) {\n  const startTime = Date.now();\n  const result = testFn();\n  const endTime = Date.now();\n\n  console.log(`Elapsed time: ${String(endTime - startTime)} milliseconds`);\n  return result;\n}\n\nconst yourFunctionReturn = printElapsedTime(yourFunction);\n```\n\n> **Note:** In browsers that support the {{domxref("performance_property", "Web Performance API", "", 1)}}\'s high-resolution time feature, {{domxref("Performance.now()")}} can provide more reliable and precise measurements of elapsed time than {{jsxref("Date.now()")}}.\n\n### Get the number of seconds since the ECMAScript Epoch\n\n```js\nconst seconds = Math.floor(Date.now() / 1000);\n```\n\nIn this case, it\'s important to return only an integer\u2014so a simple division won\'t do. It\'s also important to only return actually elapsed seconds. (That\'s why this code uses {{jsxref("Math.floor()")}}, and _not_ {{jsxref("Math.round()")}}.)\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Date/Date", "Date()")}}\n',
        "now": {
            "index.md": '---\ntitle: Date.now()\nslug: Web/JavaScript/Reference/Global_Objects/Date/now\npage-type: javascript-static-method\nbrowser-compat: javascript.builtins.Date.now\n---\n\n{{JSRef}}\n\nThe **`Date.now()`** static method returns the number of milliseconds elapsed since the [epoch](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#the_epoch_timestamps_and_invalid_date), which is defined as the midnight at the beginning of January 1, 1970, UTC.\n\n{{EmbedInteractiveExample("pages/js/date-now.html")}}\n\n## Syntax\n\n```js-nolint\nDate.now()\n```\n\n### Parameters\n\nNone.\n\n### Return value\n\nA number representing the [timestamp](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#the_epoch_timestamps_and_invalid_date), in milliseconds, of the current time.\n\n## Description\n\n### Reduced time precision\n\nTo offer protection against timing attacks and [fingerprinting](/en-US/docs/Glossary/Fingerprinting), the precision of `Date.now()` might get rounded depending on browser settings. In Firefox, the `privacy.reduceTimerPrecision` preference is enabled by default and defaults to 2ms. You can also enable `privacy.resistFingerprinting`, in which case the precision will be 100ms or the value of `privacy.resistFingerprinting.reduceTimerPrecision.microseconds`, whichever is larger.\n\n```js\n// reduced time precision (2ms) in Firefox 60\nDate.now();\n// 1519211809934\n// 1519211810362\n// 1519211811670\n// \u2026\n\n// reduced time precision with `privacy.resistFingerprinting` enabled\nDate.now();\n// 1519129853500\n// 1519129858900\n// 1519129864400\n// \u2026\n```\n\n## Examples\n\n### Measuring time elapsed\n\nYou can use `Date.now()` to get the current time in milliseconds, then subtract a previous time to find out how much time elapsed between the two calls.\n\n```js\nconst start = Date.now();\ndoSomeLongRunningProcess();\nconsole.log(`Time elapsed: ${Date.now() - start} ms`);\n```\n\nFor more complex scenarios, you may want to use the [performance API](/en-US/docs/Web/API/Performance_API/High_precision_timing) instead.\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Date.now` in `core-js`](https://github.com/zloirock/core-js#ecmascript-date)\n- {{domxref("Performance.now()")}}\n- {{domxref("console/time_static", "console.time()")}}\n- {{domxref("console/timeEnd_static", "console.timeEnd()")}}\n'
        },
        "parse": {
            "index.md": '---\ntitle: Date.parse()\nslug: Web/JavaScript/Reference/Global_Objects/Date/parse\npage-type: javascript-static-method\nbrowser-compat: javascript.builtins.Date.parse\n---\n\n{{JSRef}}\n\nThe **`Date.parse()`** static method parses a string representation of a date, and returns the date\'s [timestamp](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#the_epoch_timestamps_and_invalid_date).\n\nOnly the [date time string format](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#date_time_string_format) is explicitly specified to be supported. Other formats are implementation-defined and may not work across all browsers. A library can help if many different formats are to be accommodated.\n\n{{EmbedInteractiveExample("pages/js/date-parse.html")}}\n\n## Syntax\n\n```js-nolint\nDate.parse(dateString)\n```\n\n### Parameters\n\n- `dateString`\n  - : A string in [the date time string format](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#date_time_string_format). See the linked reference for caveats on using different formats.\n\n### Return value\n\nA number representing the [timestamp](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#the_epoch_timestamps_and_invalid_date) of the given date. If `dateString` fails to be parsed as a valid date, {{jsxref("NaN")}} is returned.\n\n## Description\n\nThis function is useful for setting date values based on string values, for example in conjunction with the {{jsxref("Date/setTime", "setTime()")}} method.\n\nBecause `parse()` is a static method of `Date`, you always use it as `Date.parse()`, rather than as a method of a `Date` object you created.\n\n## Examples\n\n### Using Date.parse()\n\nThe following calls all return `1546300800000`. The first will imply UTC time because it\'s date-only, and the others explicitly specify the UTC timezone.\n\n```js\nDate.parse("2019-01-01");\nDate.parse("2019-01-01T00:00:00.000Z");\nDate.parse("2019-01-01T00:00:00.000+00:00");\n```\n\nThe following call, which does not specify a time zone will be set to 2019-01-01 at 00:00:00 in the local timezone of the system, because it has both date and time.\n\n```js\nDate.parse("2019-01-01T00:00:00");\n```\n\n### Non-standard date strings\n\n> **Note:** This section contains implementation-specific behavior that can be inconsistent across implementations.\n\nImplementations usually default to the local time zone when the date string is non-standard. For consistency, we will assume that the code uses the UTC timezone.\n\n```js\nDate.parse("Jan 1, 1970"); // 0 in all implementations\n\nDate.parse("Thu, 01 Jan 1970 00:00:00"); // 0 in all implementations\n\nDate.parse("1970,1,1"); // 0 in Chrome and Firefox, NaN in Safari\n\nDate.parse("02 01 1970");\n// 2678400000 in Chrome and Firefox (Sun Feb 01 1970 00:00:00 GMT+0000);\n// NaN in Safari\n\n// With explicit timezone\nDate.parse("Thu, 01 Jan 1970 00:00:00 GMT+0300");\n// -10800000 in all implementations in all timezones\n\n// Single number\nDate.parse("0");\n// 946684800000 in Chrome (Sat Jan 01 2000 00:00:00 GMT+0000);\n// NaN in Firefox;\n// -62167219200000 in Safari (Sat Jan 01 0000 00:00:00 GMT+0000)\n\n// Two-digit number that may be a month\nDate.parse("28"); // NaN in all implementations\n\n// Two-digit year\nDate.parse("70/01/01"); // 0 in all implementations\n\n// Out-of-bounds date components\nDate.parse("2014-25-23"); // NaN in all implementations\nDate.parse("Mar 32, 2014"); // NaN in all implementations\nDate.parse("2014/25/23"); // NaN in all implementations\n\nDate.parse("2014-02-30");\n// NaN in Safari and Firefox;\n// 1393718400000 in Chrome (Sun Mar 02 2014 00:00:00 GMT+0000)\nDate.parse("02/30/2014"); // 1393718400000 in all implementations\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Date.UTC()")}}\n'
        },
        "setdate": {
            "index.md": '---\ntitle: Date.prototype.setDate()\nslug: Web/JavaScript/Reference/Global_Objects/Date/setDate\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Date.setDate\n---\n\n{{JSRef}}\n\nThe **`setDate()`** method of {{jsxref("Date")}} instances changes the day of the month for this date according to local time.\n\n{{EmbedInteractiveExample("pages/js/date-setdate.html")}}\n\n## Syntax\n\n```js-nolint\nsetDate(dateValue)\n```\n\n### Parameters\n\n- `dateValue`\n  - : An integer representing the day of the month.\n\n### Return value\n\nChanges the {{jsxref("Date")}} object in place, and returns its new [timestamp](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#the_epoch_timestamps_and_invalid_date). If `dateValue` is `NaN` (or other values that get [coerced](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number#number_coercion) to `NaN`, such as `undefined`), the date is set to [Invalid Date](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#the_epoch_timestamps_and_invalid_date) and `NaN` is returned.\n\n## Description\n\nIf you specify a number outside the expected range, the date information in the {{jsxref("Date")}} object is updated accordingly. For example, if the `Date` object holds June 1st, a `dateValue` of 40 changes the date to July 10th, while a `dateValue` of 0 changes the date to the last day of the previous month, May 31st.\n\n## Examples\n\n### Using setDate()\n\n```js\nconst theBigDay = new Date(1962, 6, 7, 12); // noon of 1962-07-07 (7th of July 1962, month is 0-indexed)\nconst theBigDay2 = new Date(theBigDay).setDate(24); // 1962-07-24 (24th of July 1962)\nconst theBigDay3 = new Date(theBigDay).setDate(32); // 1962-08-01 (1st of August 1962)\nconst theBigDay4 = new Date(theBigDay).setDate(22); // 1962-07-22 (22nd of July 1962)\nconst theBigDay5 = new Date(theBigDay).setDate(0); // 1962-06-30 (30th of June 1962)\nconst theBigDay6 = new Date(theBigDay).setDate(98); // 1962-10-06 (6th of October 1962)\nconst theBigDay7 = new Date(theBigDay).setDate(-50); // 1962-05-11 (11th of May 1962)\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Date/Date", "Date()")}}\n- {{jsxref("Date.prototype.getDate()")}}\n- {{jsxref("Date.prototype.setUTCDate()")}}\n'
        },
        "setfullyear": {
            "index.md": '---\ntitle: Date.prototype.setFullYear()\nslug: Web/JavaScript/Reference/Global_Objects/Date/setFullYear\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Date.setFullYear\n---\n\n{{JSRef}}\n\nThe **`setFullYear()`** method of {{jsxref("Date")}} instances changes the year, month, and/or day of month for this date according to local time.\n\n{{EmbedInteractiveExample("pages/js/date-setfullyear.html")}}\n\n## Syntax\n\n```js-nolint\nsetFullYear(yearValue)\nsetFullYear(yearValue, monthValue)\nsetFullYear(yearValue, monthValue, dateValue)\n```\n\n### Parameters\n\n- `yearValue`\n  - : An integer representing the year. For example, 1995.\n- `monthValue` {{optional_inline}}\n  - : An integer representing the month: 0 for January, 1 for February, and so on.\n- `dateValue` {{optional_inline}}\n  - : An integer between 1 and 31 representing the day of the month. If you specify `dateValue`, you must also specify `monthValue`.\n\n### Return value\n\nChanges the {{jsxref("Date")}} object in place, and returns its new [timestamp](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#the_epoch_timestamps_and_invalid_date). If a parameter is `NaN` (or other values that get [coerced](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number#number_coercion) to `NaN`, such as `undefined`), the date is set to [Invalid Date](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#the_epoch_timestamps_and_invalid_date) and `NaN` is returned.\n\n## Description\n\nIf you do not specify the `monthValue` and `dateValue` parameters, the same values as what are returned by {{jsxref("Date/getMonth", "getMonth()")}} and {{jsxref("Date/getDate", "getDate()")}} are used.\n\nIf a parameter you specify is outside of the expected range, other parameters and the date information in the {{jsxref("Date")}} object are updated accordingly. For example, if you specify 15 for `monthValue`, the year is incremented by 1 (`yearValue + 1`), and 3 is used for the month.\n\n## Examples\n\n### Using setFullYear()\n\n```js\nconst theBigDay = new Date();\ntheBigDay.setFullYear(1997);\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Date.prototype.getUTCFullYear()")}}\n- {{jsxref("Date.prototype.setUTCFullYear()")}}\n- {{jsxref("Date.prototype.setYear()")}}\n'
        },
        "sethours": {
            "index.md": '---\ntitle: Date.prototype.setHours()\nslug: Web/JavaScript/Reference/Global_Objects/Date/setHours\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Date.setHours\n---\n\n{{JSRef}}\n\nThe **`setHours()`** method of {{jsxref("Date")}} instances changes the hours, minutes, seconds, and/or milliseconds for this date according to local time.\n\n{{EmbedInteractiveExample("pages/js/date-sethours.html")}}\n\n## Syntax\n\n```js-nolint\nsetHours(hoursValue)\nsetHours(hoursValue, minutesValue)\nsetHours(hoursValue, minutesValue, secondsValue)\nsetHours(hoursValue, minutesValue, secondsValue, msValue)\n```\n\n### Parameters\n\n- `hoursValue`\n  - : An integer between 0 and 23 representing the hours.\n- `minutesValue` {{optional_inline}}\n  - : An integer between 0 and 59 representing the minutes.\n- `secondsValue` {{optional_inline}}\n  - : An integer between 0 and 59 representing the seconds. If you specify `secondsValue`, you must also specify `minutesValue`.\n- `msValue` {{optional_inline}}\n  - : An integer between 0 and 999 representing the milliseconds. If you specify `msValue`, you must also specify `minutesValue` and `secondsValue`.\n\n### Return value\n\nChanges the {{jsxref("Date")}} object in place, and returns its new [timestamp](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#the_epoch_timestamps_and_invalid_date). If a parameter is `NaN` (or other values that get [coerced](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number#number_coercion) to `NaN`, such as `undefined`), the date is set to [Invalid Date](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#the_epoch_timestamps_and_invalid_date) and `NaN` is returned.\n\n## Description\n\nIf you do not specify the `minutesValue`, `secondsValue`, and `msValue` parameters, the same values as what are returned by {{jsxref("Date/getMinutes", "getMinutes()")}}, {{jsxref("Date/getSeconds", "getSeconds()")}}, and {{jsxref("Date/getMilliseconds", "getMilliseconds()")}} are used.\n\nIf a parameter you specify is outside of the expected range, other parameters and the date information in the {{jsxref("Date")}} object are updated accordingly. For example, if you specify 100 for `secondsValue`, the minutes are incremented by 1 (`minutesValue + 1`), and 40 is used for seconds.\n\n## Examples\n\n### Using setHours()\n\n```js\nconst theBigDay = new Date();\ntheBigDay.setHours(7);\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Date.prototype.getHours()")}}\n- {{jsxref("Date.prototype.setUTCHours()")}}\n'
        },
        "setmilliseconds": {
            "index.md": '---\ntitle: Date.prototype.setMilliseconds()\nslug: Web/JavaScript/Reference/Global_Objects/Date/setMilliseconds\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Date.setMilliseconds\n---\n\n{{JSRef}}\n\nThe **`setMilliseconds()`** method of {{jsxref("Date")}} instances changes the milliseconds for this date according to local time.\n\n{{EmbedInteractiveExample("pages/js/date-setmilliseconds.html")}}\n\n## Syntax\n\n```js-nolint\nsetMilliseconds(millisecondsValue)\n```\n\n### Parameters\n\n- `millisecondsValue`\n  - : An integer between 0 and 999 representing the milliseconds.\n\n### Return value\n\nChanges the {{jsxref("Date")}} object in place, and returns its new [timestamp](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#the_epoch_timestamps_and_invalid_date). If `millisecondsValue` is `NaN` (or other values that get [coerced](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number#number_coercion) to `NaN`, such as `undefined`), the date is set to [Invalid Date](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#the_epoch_timestamps_and_invalid_date) and `NaN` is returned.\n\n## Description\n\nIf you specify a number outside the expected range, the date information in the {{jsxref("Date")}} object is updated accordingly. For example, if you specify 1005, the number of seconds is incremented by 1, and 5 is used for the milliseconds.\n\n## Examples\n\n### Using setMilliseconds()\n\n```js\nconst theBigDay = new Date();\ntheBigDay.setMilliseconds(100);\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Date.prototype.getMilliseconds()")}}\n- {{jsxref("Date.prototype.setUTCMilliseconds()")}}\n'
        },
        "setminutes": {
            "index.md": '---\ntitle: Date.prototype.setMinutes()\nslug: Web/JavaScript/Reference/Global_Objects/Date/setMinutes\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Date.setMinutes\n---\n\n{{JSRef}}\n\nThe **`setMinutes()`** method of {{jsxref("Date")}} instances changes the minutes for this date according to local time.\n\n{{EmbedInteractiveExample("pages/js/date-setminutes.html")}}\n\n## Syntax\n\n```js-nolint\nsetMinutes(minutesValue)\nsetMinutes(minutesValue, secondsValue)\nsetMinutes(minutesValue, secondsValue, msValue)\n```\n\n### Parameters\n\n- `minutesValue`\n  - : An integer between 0 and 59 representing the minutes.\n- `secondsValue` {{optional_inline}}\n  - : An integer between 0 and 59 representing the seconds. If you specify `secondsValue`, you must also specify `minutesValue`.\n- `msValue` {{optional_inline}}\n  - : An integer between 0 and 999 representing the milliseconds. If you specify `msValue`, you must also specify `minutesValue` and `secondsValue`.\n\n### Return value\n\nChanges the {{jsxref("Date")}} object in place, and returns its new [timestamp](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#the_epoch_timestamps_and_invalid_date). If a parameter is `NaN` (or other values that get [coerced](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number#number_coercion) to `NaN`, such as `undefined`), the date is set to [Invalid Date](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#the_epoch_timestamps_and_invalid_date) and `NaN` is returned.\n\n## Description\n\nIf you do not specify the `secondsValue` and `msValue` parameters, the same values as what are returned by {{jsxref("Date/getSeconds", "getSeconds()")}} and {{jsxref("Date/getMilliseconds", "getMilliseconds()")}} are used.\n\nIf a parameter you specify is outside of the expected range, other parameters and the date information in the {{jsxref("Date")}} object are updated accordingly. For example, if you specify 100 for `secondsValue`, the minutes is incremented by 1 (`minutesValue + 1`), and 40 is used for seconds.\n\n## Examples\n\n### Using setMinutes()\n\n```js\nconst theBigDay = new Date();\ntheBigDay.setMinutes(45);\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Date.prototype.getMinutes()")}}\n- {{jsxref("Date.prototype.setUTCMinutes()")}}\n'
        },
        "setmonth": {
            "index.md": '---\ntitle: Date.prototype.setMonth()\nslug: Web/JavaScript/Reference/Global_Objects/Date/setMonth\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Date.setMonth\n---\n\n{{JSRef}}\n\nThe **`setMonth()`** method of {{jsxref("Date")}} instances changes the month and/or day of the month for this date according to local time.\n\n{{EmbedInteractiveExample("pages/js/date-setmonth.html")}}\n\n## Syntax\n\n```js-nolint\nsetMonth(monthValue)\nsetMonth(monthValue, dateValue)\n```\n\n### Parameters\n\n- `monthValue`\n  - : An integer representing the month: 0 for January, 1 for February, and so on.\n- `dateValue` {{optional_inline}}\n  - : An integer from 1 to 31 representing the day of the month.\n\n### Return value\n\nChanges the {{jsxref("Date")}} object in place, and returns its new [timestamp](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#the_epoch_timestamps_and_invalid_date). If a parameter is `NaN` (or other values that get [coerced](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number#number_coercion) to `NaN`, such as `undefined`), the date is set to [Invalid Date](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#the_epoch_timestamps_and_invalid_date) and `NaN` is returned.\n\n## Description\n\nIf you do not specify the `dateValue` parameter, the same value as what is returned by {{jsxref("Date/getDate", "getDate()")}} is used.\n\nIf a parameter you specify is outside of the expected range, other parameters and the date information in the {{jsxref("Date")}} object are updated accordingly. For example, if you specify 15 for `monthValue`, the year is incremented by 1, and 3 is used for month.\n\nThe current day of month will have an impact on the behavior of this method.\nConceptually it will add the number of days given by the current day of the month to the\n1st day of the new month specified as the parameter, to return the new date.\nFor example, if the current value is 31st January 2016, calling setMonth with a value of 1 will return 2nd March 2016.\nThis is because in 2016 February had 29 days.\n\n## Examples\n\n### Using setMonth()\n\n```js\nconst theBigDay = new Date();\ntheBigDay.setMonth(6);\n\n//Watch out for end of month transitions\nconst endOfMonth = new Date(2016, 7, 31);\nendOfMonth.setMonth(1);\nconsole.log(endOfMonth); //Wed Mar 02 2016 00:00:00\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Date.prototype.getMonth()")}}\n- {{jsxref("Date.prototype.setUTCMonth()")}}\n'
        },
        "setseconds": {
            "index.md": '---\ntitle: Date.prototype.setSeconds()\nslug: Web/JavaScript/Reference/Global_Objects/Date/setSeconds\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Date.setSeconds\n---\n\n{{JSRef}}\n\nThe **`setSeconds()`** method of {{jsxref("Date")}} instances changes the seconds and/or milliseconds for this date according to local time.\n\n{{EmbedInteractiveExample("pages/js/date-setseconds.html")}}\n\n## Syntax\n\n```js-nolint\nsetSeconds(secondsValue)\nsetSeconds(secondsValue, msValue)\n```\n\n### Parameters\n\n- `secondsValue`\n  - : An integer between 0 and 59 representing the seconds.\n- `msValue` {{optional_inline}}\n  - : An integer between 0 and 999 representing the milliseconds.\n\n### Return value\n\nChanges the {{jsxref("Date")}} object in place, and returns its new [timestamp](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#the_epoch_timestamps_and_invalid_date). If a parameter is `NaN` (or other values that get [coerced](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number#number_coercion) to `NaN`, such as `undefined`), the date is set to [Invalid Date](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#the_epoch_timestamps_and_invalid_date) and `NaN` is returned.\n\n## Description\n\nIf you do not specify the `msValue` parameter, the value returned\nfrom the {{jsxref("Date/getMilliseconds", "getMilliseconds()")}} method is\nused.\n\nIf a parameter you specify is outside of the expected range, `setSeconds()`\nattempts to update the date information in the {{jsxref("Date")}} object accordingly.\nFor example, if you use 100 for `secondsValue`, the minutes stored\nin the {{jsxref("Date")}} object will be incremented by 1, and 40 will be used for\nseconds.\n\n## Examples\n\n### Using setSeconds()\n\n```js\nconst theBigDay = new Date();\ntheBigDay.setSeconds(30);\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Date.prototype.getSeconds()")}}\n- {{jsxref("Date.prototype.setUTCSeconds()")}}\n'
        },
        "settime": {
            "index.md": '---\ntitle: Date.prototype.setTime()\nslug: Web/JavaScript/Reference/Global_Objects/Date/setTime\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Date.setTime\n---\n\n{{JSRef}}\n\nThe **`setTime()`** method of {{jsxref("Date")}} instances changes the [timestamp](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#the_epoch_timestamps_and_invalid_date) for this date, which is the number of milliseconds since the [epoch](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#the_epoch_timestamps_and_invalid_date), defined as the midnight at the beginning of January 1, 1970, UTC.\n\n{{EmbedInteractiveExample("pages/js/date-settime.html", "taller")}}\n\n## Syntax\n\n```js-nolint\nsetTime(timeValue)\n```\n\n### Parameters\n\n- `timeValue`\n  - : An integer representing the new timestamp \u2014 the number of milliseconds since the midnight at the beginning of January 1, 1970, UTC.\n\n### Return value\n\nChanges the {{jsxref("Date")}} object in place, and returns its new [timestamp](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#the_epoch_timestamps_and_invalid_date). If `timeValue` is `NaN` (or other values that get [coerced](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number#number_coercion) to `NaN`, such as `undefined`), the date is set to [Invalid Date](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#the_epoch_timestamps_and_invalid_date) and `NaN` is returned.\n\n## Examples\n\n### Using setTime()\n\n```js\nconst theBigDay = new Date("1999-07-01");\nconst sameAsBigDay = new Date();\nsameAsBigDay.setTime(theBigDay.getTime());\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Date.prototype.getTime()")}}\n- {{jsxref("Date.prototype.setUTCHours()")}}\n'
        },
        "setutcdate": {
            "index.md": '---\ntitle: Date.prototype.setUTCDate()\nslug: Web/JavaScript/Reference/Global_Objects/Date/setUTCDate\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Date.setUTCDate\n---\n\n{{JSRef}}\n\nThe **`setUTCDate()`** method of {{jsxref("Date")}} instances changes the day of the month for this date according to universal time.\n\n{{EmbedInteractiveExample("pages/js/date-setutcdate.html")}}\n\n## Syntax\n\n```js-nolint\nsetUTCDate(dateValue)\n```\n\n### Parameters\n\n- `dateValue`\n  - : An integer from 1 to 31 representing the day of the month.\n\n### Return value\n\nChanges the {{jsxref("Date")}} object in place, and returns its new [timestamp](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#the_epoch_timestamps_and_invalid_date). If `dateValue` is `NaN` (or other values that get [coerced](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number#number_coercion) to `NaN`, such as `undefined`), the date is set to [Invalid Date](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#the_epoch_timestamps_and_invalid_date) and `NaN` is returned.\n\n## Description\n\nIf the `dateValue` is outside of the range of date values for the month, `setDate()` will update the {{jsxref("Date")}} object accordingly.\n\nFor example, if 0 is provided for `dateValue`, the date will be set to the last day of the previous month. If you use 40 for `dateValue`, and the month stored in the {{jsxref("Date")}} object is June, the day will be changed to 10 and the month will be incremented to July.\n\nIf a negative number is provided for `dateValue`, the date will be set counting backwards from the last day of the previous month. -1 would result in the date being set to 1 day before the last day of the previous month.\n\n## Examples\n\n### Using setUTCDate()\n\n```js\nconst theBigDay = new Date();\ntheBigDay.setUTCDate(20);\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Date.prototype.getUTCDate()")}}\n- {{jsxref("Date.prototype.setDate()")}}\n'
        },
        "setutcfullyear": {
            "index.md": '---\ntitle: Date.prototype.setUTCFullYear()\nslug: Web/JavaScript/Reference/Global_Objects/Date/setUTCFullYear\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Date.setUTCFullYear\n---\n\n{{JSRef}}\n\nThe **`setUTCFullYear()`** method of {{jsxref("Date")}} instances changes the year for this date according to universal time.\n\n{{EmbedInteractiveExample("pages/js/date-setutcfullyear.html")}}\n\n## Syntax\n\n```js-nolint\nsetUTCFullYear(yearValue)\nsetUTCFullYear(yearValue, monthValue)\nsetUTCFullYear(yearValue, monthValue, dateValue)\n```\n\n### Parameters\n\n- `yearValue`\n  - : An integer representing the year. For example, 1995.\n- `monthValue` {{optional_inline}}\n  - : An integer representing the month: 0 for January, 1 for February, and so on.\n- `dateValue` {{optional_inline}}\n  - : An integer between 1 and 31 representing the day of the month. If you specify `dateValue`, you must also specify `monthValue`.\n\n### Return value\n\nChanges the {{jsxref("Date")}} object in place, and returns its new [timestamp](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#the_epoch_timestamps_and_invalid_date). If a parameter is `NaN` (or other values that get [coerced](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number#number_coercion) to `NaN`, such as `undefined`), the date is set to [Invalid Date](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#the_epoch_timestamps_and_invalid_date) and `NaN` is returned.\n\n## Description\n\nIf you do not specify the `monthValue` and\n`dateValue` parameters, the values returned from the\n{{jsxref("Date/getUTCMonth", "getUTCMonth()")}} and\n{{jsxref("Date/getUTCDate", "getUTCDate()")}} methods are used.\n\nIf a parameter you specify is outside of the expected range,\n`setUTCFullYear()` attempts to update the other parameters and the date\ninformation in the {{jsxref("Date")}} object accordingly. For example, if you specify 15\nfor `monthValue`, the year is incremented by 1\n(`yearValue + 1`), and 3 is used for the month.\n\n## Examples\n\n### Using setUTCFullYear()\n\n```js\nconst theBigDay = new Date();\ntheBigDay.setUTCFullYear(1997);\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Date.prototype.getUTCFullYear()")}}\n- {{jsxref("Date.prototype.setFullYear()")}}\n'
        },
        "setutchours": {
            "index.md": '---\ntitle: Date.prototype.setUTCHours()\nslug: Web/JavaScript/Reference/Global_Objects/Date/setUTCHours\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Date.setUTCHours\n---\n\n{{JSRef}}\n\nThe **`setUTCHours()`** method of {{jsxref("Date")}} instances changes the hours, minutes, seconds, and/or milliseconds for this date according to universal time.\n\n{{EmbedInteractiveExample("pages/js/date-setutchours.html")}}\n\n## Syntax\n\n```js-nolint\nsetUTCHours(hoursValue)\nsetUTCHours(hoursValue, minutesValue)\nsetUTCHours(hoursValue, minutesValue, secondsValue)\nsetUTCHours(hoursValue, minutesValue, secondsValue, msValue)\n```\n\n### Parameters\n\n- `hoursValue`\n  - : An integer between 0 and 23 representing the hours.\n- `minutesValue` {{optional_inline}}\n  - : An integer between 0 and 59 representing the minutes.\n- `secondsValue` {{optional_inline}}\n  - : An integer between 0 and 59 representing the seconds. If you specify `secondsValue`, you must also specify `minutesValue`.\n- `msValue` {{optional_inline}}\n  - : An integer between 0 and 999 representing the milliseconds. If you specify `msValue`, you must also specify `minutesValue` and `secondsValue`.\n\n### Return value\n\nChanges the {{jsxref("Date")}} object in place, and returns its new [timestamp](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#the_epoch_timestamps_and_invalid_date). If a parameter is `NaN` (or other values that get [coerced](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number#number_coercion) to `NaN`, such as `undefined`), the date is set to [Invalid Date](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#the_epoch_timestamps_and_invalid_date) and `NaN` is returned.\n\n## Description\n\nIf you do not specify the `minutesValue`,\n`secondsValue`, and `msValue` parameters,\nthe values returned from the {{jsxref("Date/getUTCMinutes", "getUTCMinutes()")}}, {{jsxref("Date/getUTCSeconds", "getUTCSeconds()")}},\nand {{jsxref("Date/getUTCMilliseconds", "getUTCMilliseconds()")}} methods\nare used.\n\nIf a parameter you specify is outside of the expected range, `setUTCHours()`\nattempts to update the date information in the {{jsxref("Date")}} object accordingly.\nFor example, if you use 100 for `secondsValue`, the minutes will\nbe incremented by 1 (`minutesValue + 1`), and 40 will be used for seconds.\n\n## Examples\n\n### Using setUTCHours()\n\n```js\nconst theBigDay = new Date();\ntheBigDay.setUTCHours(8);\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Date.prototype.getUTCHours()")}}\n- {{jsxref("Date.prototype.setHours()")}}\n'
        },
        "setutcmilliseconds": {
            "index.md": '---\ntitle: Date.prototype.setUTCMilliseconds()\nslug: Web/JavaScript/Reference/Global_Objects/Date/setUTCMilliseconds\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Date.setUTCMilliseconds\n---\n\n{{JSRef}}\n\nThe **`setUTCMilliseconds()`** method of {{jsxref("Date")}} instances changes the milliseconds for this date according to universal time.\n\n{{EmbedInteractiveExample("pages/js/date-setutcmilliseconds.html")}}\n\n## Syntax\n\n```js-nolint\nsetUTCMilliseconds(millisecondsValue)\n```\n\n### Parameters\n\n- `millisecondsValue`\n  - : An integer between 0 and 999 representing the milliseconds.\n\n### Return value\n\nChanges the {{jsxref("Date")}} object in place, and returns its new [timestamp](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#the_epoch_timestamps_and_invalid_date). If `millisecondsValue` is `NaN` (or other values that get [coerced](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number#number_coercion) to `NaN`, such as `undefined`), the date is set to [Invalid Date](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#the_epoch_timestamps_and_invalid_date) and `NaN` is returned.\n\n## Description\n\nIf a parameter you specify is outside of the expected range,\n`setUTCMilliseconds()` attempts to update the date information in the\n{{jsxref("Date")}} object accordingly. For example, if you use 1100 for\n`millisecondsValue`, the seconds stored in the {{jsxref("Date")}}\nobject will be incremented by 1, and 100 will be used for milliseconds.\n\n## Examples\n\n### Using setUTCMilliseconds()\n\n```js\nconst theBigDay = new Date();\ntheBigDay.setUTCMilliseconds(500);\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Date.prototype.getUTCMilliseconds()")}}\n- {{jsxref("Date.prototype.setMilliseconds()")}}\n'
        },
        "setutcminutes": {
            "index.md": '---\ntitle: Date.prototype.setUTCMinutes()\nslug: Web/JavaScript/Reference/Global_Objects/Date/setUTCMinutes\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Date.setUTCMinutes\n---\n\n{{JSRef}}\n\nThe **`setUTCMinutes()`** method of {{jsxref("Date")}} instances changes the minutes for this date according to universal time.\n\n{{EmbedInteractiveExample("pages/js/date-setutcminutes.html")}}\n\n## Syntax\n\n```js-nolint\nsetUTCMinutes(minutesValue)\nsetUTCMinutes(minutesValue, secondsValue)\nsetUTCMinutes(minutesValue, secondsValue, msValue)\n```\n\n### Parameters\n\n- `minutesValue`\n  - : An integer between 0 and 59 representing the minutes.\n- `secondsValue` {{optional_inline}}\n  - : An integer between 0 and 59 representing the seconds. If you specify `secondsValue`, you must also specify `minutesValue`.\n- `msValue` {{optional_inline}}\n  - : An integer between 0 and 999 representing the milliseconds. If you specify `msValue`, you must also specify `minutesValue` and `secondsValue`.\n\n### Return value\n\nChanges the {{jsxref("Date")}} object in place, and returns its new [timestamp](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#the_epoch_timestamps_and_invalid_date). If a parameter is `NaN` (or other values that get [coerced](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number#number_coercion) to `NaN`, such as `undefined`), the date is set to [Invalid Date](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#the_epoch_timestamps_and_invalid_date) and `NaN` is returned.\n\n## Description\n\nIf you do not specify the `secondsValue` and\n`msValue` parameters, the values returned from\n{{jsxref("Date/getUTCSeconds", "getUTCSeconds()")}} and\n{{jsxref("Date/getUTCMilliseconds", "getUTCMilliseconds()")}} methods are\nused.\n\nIf a parameter you specify is outside of the expected range,\n`setUTCMinutes()` attempts to update the date information in the\n{{jsxref("Date")}} object accordingly. For example, if you use 100 for\n`secondsValue`, the minutes will be incremented by 1\n(`minutesValue + 1`), and 40 will be used for seconds.\n\n## Examples\n\n### Using setUTCMinutes()\n\n```js\nconst theBigDay = new Date();\ntheBigDay.setUTCMinutes(43);\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Date.prototype.getUTCMinutes()")}}\n- {{jsxref("Date.prototype.setMinutes()")}}\n'
        },
        "setutcmonth": {
            "index.md": '---\ntitle: Date.prototype.setUTCMonth()\nslug: Web/JavaScript/Reference/Global_Objects/Date/setUTCMonth\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Date.setUTCMonth\n---\n\n{{JSRef}}\n\nThe **`setUTCMonth()`** method of {{jsxref("Date")}} instances changes the month and/or day of the month for this date according to universal time.\n\n{{EmbedInteractiveExample("pages/js/date-setutcmonth.html")}}\n\n## Syntax\n\n```js-nolint\nsetUTCMonth(monthValue)\nsetUTCMonth(monthValue, dateValue)\n```\n\n### Parameters\n\n- `monthValue`\n  - : An integer representing the month: 0 for January, 1 for February, and so on.\n- `dateValue` {{optional_inline}}\n  - : An integer from 1 to 31 representing the day of the month.\n\n### Return value\n\nChanges the {{jsxref("Date")}} object in place, and returns its new [timestamp](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#the_epoch_timestamps_and_invalid_date). If a parameter is `NaN` (or other values that get [coerced](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number#number_coercion) to `NaN`, such as `undefined`), the date is set to [Invalid Date](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#the_epoch_timestamps_and_invalid_date) and `NaN` is returned.\n\n## Description\n\nIf you do not specify the `dateValue` parameter, the value returned from the\n{{jsxref("Date/getUTCDate", "getUTCDate()")}} method is used.\n\nIf a parameter you specify is outside of the expected range, `setUTCMonth()`\nattempts to update the date information in the {{jsxref("Date")}} object accordingly.\nFor example, if you use 15 for `monthValue`, the year will be incremented by\n1, and 3 will be used for month.\n\n## Examples\n\n### Using setUTCMonth()\n\n```js\nconst theBigDay = new Date();\ntheBigDay.setUTCMonth(11);\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Date.prototype.getUTCMonth()")}}\n- {{jsxref("Date.prototype.setMonth()")}}\n'
        },
        "setutcseconds": {
            "index.md": '---\ntitle: Date.prototype.setUTCSeconds()\nslug: Web/JavaScript/Reference/Global_Objects/Date/setUTCSeconds\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Date.setUTCSeconds\n---\n\n{{JSRef}}\n\nThe **`setUTCSeconds()`** method of {{jsxref("Date")}} instances changes the seconds and/or milliseconds for this date according to universal time.\n\n{{EmbedInteractiveExample("pages/js/date-setutcseconds.html")}}\n\n## Syntax\n\n```js-nolint\nsetUTCSeconds(secondsValue)\nsetUTCSeconds(secondsValue, msValue)\n```\n\n### Parameters\n\n- `secondsValue`\n  - : An integer between 0 and 59 representing the seconds.\n- `msValue` {{optional_inline}}\n  - : An integer between 0 and 999 representing the milliseconds.\n\n### Return value\n\nChanges the {{jsxref("Date")}} object in place, and returns its new [timestamp](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#the_epoch_timestamps_and_invalid_date). If a parameter is `NaN` (or other values that get [coerced](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number#number_coercion) to `NaN`, such as `undefined`), the date is set to [Invalid Date](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#the_epoch_timestamps_and_invalid_date) and `NaN` is returned.\n\n## Description\n\nIf you do not specify the `msValue` parameter, the value returned from the\n{{jsxref("Date/getUTCMilliseconds", "getUTCMilliseconds()")}} method is\nused.\n\nIf a parameter you specify is outside of the expected range,\n`setUTCSeconds()` attempts to update the date information in the\n{{jsxref("Date")}} object accordingly. For example, if you use 100 for\n`secondsValue`, the minutes stored in the {{jsxref("Date")}} object will be\nincremented by 1, and 40 will be used for seconds.\n\n## Examples\n\n### Using setUTCSeconds()\n\n```js\nconst theBigDay = new Date();\ntheBigDay.setUTCSeconds(20);\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Date.prototype.getUTCSeconds()")}}\n- {{jsxref("Date.prototype.setSeconds()")}}\n'
        },
        "setyear": {
            "index.md": '---\ntitle: Date.prototype.setYear()\nslug: Web/JavaScript/Reference/Global_Objects/Date/setYear\npage-type: javascript-instance-method\nstatus:\n  - deprecated\nbrowser-compat: javascript.builtins.Date.setYear\n---\n\n{{JSRef}} {{Deprecated_Header}}\n\nThe **`setYear()`** method of {{jsxref("Date")}} instances sets the year for a specified date according to local time.\n\nHowever, the way the legacy `setYear()` method sets year values is different from how the preferred {{jsxref("Date/setFullYear", "setFullYear()")}} method sets year values \u2014 and in some cases, also different from how `new Date()` and {{jsxref("Date.parse()")}} set year values. Specifically, given two-digit numbers, such as `22` and `61`:\n\n- `setYear()` interprets any two-digit number as an offset to `1900`; so `date.setYear(22)` results in the year value being set to `1922`, and `date.setYear(61)` results in the year value being set to `1961`. (In contrast, while `new Date(61, 1)` also results in the year value being set to `1961`, `new Date("2/1/22")` results in the year value being set to `2022`; and similarly for {{jsxref("Date.parse()")}}).\n\n- {{jsxref("Date/setFullYear", "setFullYear()")}} does no special interpretation but instead uses the literal two-digit value as-is to set the year; so `date.setFullYear(61)` results in the year value being set to `0061`, and `date.setFullYear(22)` results in the year value being set to `0022`.\n\nBecause of those differences in behavior, you should no longer use the legacy `setYear()` method, but should instead use the preferred {{jsxref("Date/setFullYear", "setFullYear()")}} method.\n\n## Syntax\n\n```js-nolint\nsetYear(yearValue)\n```\n\n### Parameters\n\n- `yearValue`\n  - : An integer.\n\n### Return value\n\nChanges the {{jsxref("Date")}} object in place, and returns its new [timestamp](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#the_epoch_timestamps_and_invalid_date). If `yearValue` is `NaN` (or other values that get [coerced](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number#number_coercion) to `NaN`, such as `undefined`), the date is set to [Invalid Date](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#the_epoch_timestamps_and_invalid_date) and `NaN` is returned.\n\n## Description\n\nIf `yearValue` is a number between 0 and 99 (inclusive), then the year for\n`dateObj` is set to `1900 + yearValue`. Otherwise, the year for\n`dateObj` is set to `yearValue`.\n\n## Examples\n\n### Using setYear()\n\nThe first two lines set the year to 1996. The third sets the year to 2000.\n\n```js\nconst theBigDay = new Date();\n\ntheBigDay.setYear(96);\ntheBigDay.setYear(1996);\ntheBigDay.setYear(2000);\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Date.prototype.setYear` in `core-js`](https://github.com/zloirock/core-js#ecmascript-date)\n- {{jsxref("Date.prototype.getFullYear()")}}\n- {{jsxref("Date.prototype.getUTCFullYear()")}}\n- {{jsxref("Date.prototype.setFullYear()")}}\n- {{jsxref("Date.prototype.setUTCFullYear()")}}\n'
        },
        "todatestring": {
            "index.md": '---\ntitle: Date.prototype.toDateString()\nslug: Web/JavaScript/Reference/Global_Objects/Date/toDateString\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Date.toDateString\n---\n\n{{JSRef}}\n\nThe **`toDateString()`** method of {{jsxref("Date")}} instances returns a string representing the date portion of this date interpreted in the local timezone.\n\n{{EmbedInteractiveExample("pages/js/date-todatestring.html")}}\n\n## Syntax\n\n```js-nolint\ntoDateString()\n```\n\n### Parameters\n\nNone.\n\n### Return value\n\nA string representing the date portion of the given date (see description for the format). Returns `"Invalid Date"` if the date is [invalid](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#the_epoch_timestamps_and_invalid_date).\n\n## Description\n\n{{jsxref("Date")}} instances refer to a specific point in time. `toDateString()` interprets the date in the local timezone and formats the _date_ part in English. It always uses the following format, separated by spaces:\n\n1. First three letters of the week day name\n2. First three letters of the month name\n3. Two-digit day of the month, padded on the left a zero if necessary\n4. Four-digit year (at least), padded on the left with zeros if necessary. May have a negative sign\n\nFor example: "Thu Jan 01 1970".\n\n- If you only want to get the _time_ part, use {{jsxref("Date/toTimeString", "toTimeString()")}}.\n- If you want to get both the date and time, use {{jsxref("Date/toString", "toString()")}}.\n- If you want to make the date interpreted as UTC instead of local timezone, use {{jsxref("Date/toUTCString", "toUTCString()")}}.\n- If you want to format the date in a more user-friendly format (e.g. localization), use {{jsxref("Date/toLocaleDateString", "toLocaleDateString()")}}.\n\n## Examples\n\n### Using toDateString()\n\n```js\nconst d = new Date(0);\n\nconsole.log(d.toString()); // "Thu Jan 01 1970 00:00:00 GMT+0000 (Coordinated Universal Time)"\nconsole.log(d.toDateString()); // "Thu Jan 01 1970"\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Date.prototype.toLocaleDateString()")}}\n- {{jsxref("Date.prototype.toTimeString()")}}\n- {{jsxref("Date.prototype.toString()")}}\n'
        },
        "toisostring": {
            "index.md": '---\ntitle: Date.prototype.toISOString()\nslug: Web/JavaScript/Reference/Global_Objects/Date/toISOString\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Date.toISOString\n---\n\n{{JSRef}}\n\nThe **`toISOString()`** method of {{jsxref("Date")}} instances returns a string representing this date in the [date time string format](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#date_time_string_format), a _simplified_ format based on [ISO 8601](https://en.wikipedia.org/wiki/ISO_8601), which is always 24 or 27 characters long (`YYYY-MM-DDTHH:mm:ss.sssZ` or `\xb1YYYYYY-MM-DDTHH:mm:ss.sssZ`, respectively). The timezone is always UTC, as denoted by the suffix `Z`.\n\n{{EmbedInteractiveExample("pages/js/date-toisostring.html")}}\n\n## Syntax\n\n```js-nolint\ntoISOString()\n```\n\n### Parameters\n\nNone.\n\n### Return value\n\nA string representing the given date in the [date time string format](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#date_time_string_format) according to universal time. It\'s the same format as the one required to be recognized by {{jsxref("Date.parse()")}}.\n\n### Exceptions\n\n- {{jsxref("RangeError")}}\n  - : Thrown if the date is [invalid](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#the_epoch_timestamps_and_invalid_date) or if it corresponds to a year that cannot be represented in the date string format.\n\n## Examples\n\n### Using toISOString()\n\n```js\nconst d = new Date(0);\n\nconsole.log(d.toISOString()); // "1970-01-01T00:00:00.000Z"\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Date.prototype.toLocaleDateString()")}}\n- {{jsxref("Date.prototype.toString()")}}\n- {{jsxref("Date.prototype.toUTCString()")}}\n'
        },
        "tojson": {
            "index.md": '---\ntitle: Date.prototype.toJSON()\nslug: Web/JavaScript/Reference/Global_Objects/Date/toJSON\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Date.toJSON\n---\n\n{{JSRef}}\n\nThe **`toJSON()`** method of {{jsxref("Date")}} instances returns a string representing this date in the same ISO format as {{jsxref("Date/toISOString", "toISOString()")}}.\n\n{{EmbedInteractiveExample("pages/js/date-tojson.html")}}\n\n## Syntax\n\n```js-nolint\ntoJSON()\n```\n\n### Parameters\n\nNone.\n\n### Return value\n\nA string representing the given date in the [date time string format](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#date_time_string_format) according to universal time, or `null` when the date is [invalid](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#the_epoch_timestamps_and_invalid_date). For valid dates, the return value is the same as that of {{jsxref("Date/toISOString", "toISOString()")}}.\n\n## Description\n\nThe `toJSON()` method is automatically called by {{jsxref("JSON.stringify()")}} when a `Date` object is stringified. This method is generally intended to, by default, usefully serialize {{jsxref("Date")}} objects during [JSON](/en-US/docs/Glossary/JSON) serialization, which can then be deserialized using the {{jsxref("Date/Date", "Date()")}} constructor as the reviver of {{jsxref("JSON.parse()")}}.\n\nThe method first attempts to convert its `this` value [to a primitive](/en-US/docs/Web/JavaScript/Data_structures#primitive_coercion) by calling its [`[@@toPrimitive]()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol/toPrimitive) (with `"number"` as hint), {{jsxref("Object/valueOf", "valueOf()")}}, and {{jsxref("Object/toString", "toString()")}} methods, in that order. If the result is a [non-finite](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/isFinite) number, `null` is returned. (This generally corresponds to an invalid date, whose {{jsxref("Date/valueOf", "valueOf()")}} returns {{jsxref("NaN")}}.) Otherwise, if the converted primitive is not a number or is a finite number, the return value of {{jsxref("Date/toISOString", "this.toISOString()")}} is returned.\n\nNote that the method does not check whether the `this` value is a valid {{jsxref("Date")}} object. However, calling `Date.prototype.toJSON()` on non-`Date` objects fails unless the object\'s number primitive representation is `NaN`, or the object also has a `toISOString()` method.\n\n## Examples\n\n### Using toJSON()\n\n```js\nconst jsonDate = new Date(0).toJSON(); // \'1970-01-01T00:00:00.000Z\'\nconst backToDate = new Date(jsonDate);\n\nconsole.log(jsonDate); // 1970-01-01T00:00:00.000Z\n```\n\n### Serialization round-tripping\n\nWhen parsing JSON containing date strings, you can use the {{jsxref("Date/Date", "Date()")}} constructor to revive them into the original date objects.\n\n```js\nconst fileData = {\n  author: "Maria",\n  title: "Date.prototype.toJSON()",\n  createdAt: new Date(2019, 3, 15),\n  updatedAt: new Date(2020, 6, 26),\n};\nconst response = JSON.stringify(fileData);\n\n// Imagine transmission through network\n\nconst data = JSON.parse(response, (key, value) => {\n  if (key === "createdAt" || key === "updatedAt") {\n    return new Date(value);\n  }\n  return value;\n});\n\nconsole.log(data);\n```\n\n> **Note:** The reviver of `JSON.parse()` must be specific to the payload shape you expect, because the serialization is _lossy_: it\'s not possible to distinguish between a string that represents a Date and a normal string.\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Date.prototype.toLocaleDateString()")}}\n- {{jsxref("Date.prototype.toTimeString()")}}\n- {{jsxref("Date.prototype.toUTCString()")}}\n'
        },
        "tolocaledatestring": {
            "index.md": '---\ntitle: Date.prototype.toLocaleDateString()\nslug: Web/JavaScript/Reference/Global_Objects/Date/toLocaleDateString\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Date.toLocaleDateString\n---\n\n{{JSRef}}\n\nThe **`toLocaleDateString()`** method of {{jsxref("Date")}} instances returns a string with a language-sensitive representation of the date portion of this date in the local timezone. In implementations with [`Intl.DateTimeFormat` API](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat) support, this method simply calls `Intl.DateTimeFormat`.\n\nEvery time `toLocaleString` is called, it has to perform a search in a big database of localization strings, which is potentially inefficient. When the method is called many times with the same arguments, it is better to create a {{jsxref("Intl.DateTimeFormat")}} object and use its {{jsxref("Intl/DateTimeFormat/format", "format()")}} method, because a `DateTimeFormat` object remembers the arguments passed to it and may decide to cache a slice of the database, so future `format` calls can search for localization strings within a more constrained context.\n\n{{EmbedInteractiveExample("pages/js/date-tolocaledatestring.html", "taller")}}\n\n## Syntax\n\n```js-nolint\ntoLocaleDateString()\ntoLocaleDateString(locales)\ntoLocaleDateString(locales, options)\n```\n\n### Parameters\n\nThe `locales` and `options` parameters customize the behavior of the function and let applications specify the language whose formatting conventions should be used.\n\nIn implementations that support the [`Intl.DateTimeFormat` API](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat), these parameters correspond exactly to the [`Intl.DateTimeFormat()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/DateTimeFormat) constructor\'s parameters. Implementations without `Intl.DateTimeFormat` support are asked to ignore both parameters, making the locale used and the form of the string returned entirely implementation-dependent.\n\n- `locales` {{optional_inline}}\n\n  - : A string with a BCP 47 language tag, or an array of such strings. Corresponds to the [`locales`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/DateTimeFormat#locales) parameter of the `Intl.DateTimeFormat()` constructor.\n\n    In implementations without `Intl.DateTimeFormat` support, this parameter is ignored and the host\'s locale is usually used.\n\n- `options` {{optional_inline}}\n\n  - : An object adjusting the output format. Corresponds to the [`options`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/DateTimeFormat#options) parameter of the `Intl.DateTimeFormat()` constructor. The `timeStyle` option must be undefined, or a {{jsxref("TypeError")}} would be thrown. If `weekday`, `year`, `month`, and `day` are all undefined, then `year`, `month`, and `day` will be set to `"numeric"`.\n\n    In implementations without `Intl.DateTimeFormat` support, this parameter is ignored.\n\nSee the [`Intl.DateTimeFormat()` constructor](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/DateTimeFormat) for details on these parameters and how to use them.\n\n### Return value\n\nA string representing the date portion of the given date according to language-specific conventions.\n\nIn implementations with `Intl.DateTimeFormat`, this is equivalent to `new Intl.DateTimeFormat(locales, options).format(date)`, where `options` has been normalized as described above.\n\n> **Note:** Most of the time, the formatting returned by `toLocaleDateString()` is consistent. However, the output may vary with time, language, and implementation \u2014 output variations are by design and allowed by the specification. You should not compare the results of `toLocaleDateString()` to static values.\n\n## Examples\n\n### Using toLocaleDateString()\n\nBasic use of this method without specifying a `locale` returns a formatted string in the default locale and with default options.\n\n```js\nconst date = new Date(Date.UTC(2012, 11, 12, 3, 0, 0));\n\n// toLocaleDateString() without arguments depends on the implementation,\n// the default locale, and the default time zone\nconsole.log(date.toLocaleDateString());\n// "12/11/2012" if run in en-US locale with time zone America/Los_Angeles\n```\n\n### Checking for support for locales and options parameters\n\nThe `locales` and `options` parameters may not be supported in all implementations, because support for the internationalization API is optional, and some systems may not have the necessary data. For implementations without internationalization support, `toLocaleDateString()` always uses the system\'s locale, which may not be what you want. Because any implementation that supports the `locales` and `options` parameters must support the {{jsxref("Intl")}} API, you can check the existence of the latter for support:\n\n```js\nfunction toLocaleDateStringSupportsLocales() {\n  return (\n    typeof Intl === "object" &&\n    !!Intl &&\n    typeof Intl.DateTimeFormat === "function"\n  );\n}\n```\n\n### Using locales\n\nThis example shows some of the variations in localized date formats. In order to get the format of the language used in the user interface of your application, make sure to specify that language (and possibly some fallback languages) using the `locales` argument:\n\n```js\nconst date = new Date(Date.UTC(2012, 11, 20, 3, 0, 0));\n\n// formats below assume the local time zone of the locale;\n// America/Los_Angeles for the US\n\n// US English uses month-day-year order\nconsole.log(date.toLocaleDateString("en-US"));\n// "12/20/2012"\n\n// British English uses day-month-year order\nconsole.log(date.toLocaleDateString("en-GB"));\n// "20/12/2012"\n\n// Korean uses year-month-day order\nconsole.log(date.toLocaleDateString("ko-KR"));\n// "2012. 12. 20."\n\n// Event for Persian, It\'s hard to manually convert date to Solar Hijri\nconsole.log(date.toLocaleDateString("fa-IR"));\n// "\u06F1\u06F3\u06F9\u06F1/\u06F9/\u06F3\u06F0"\n\n// Arabic in most Arabic speaking countries uses real Arabic digits\nconsole.log(date.toLocaleDateString("ar-EG"));\n// "\u0662\u0660\u200F/\u0661\u0662\u200F/\u0662\u0660\u0661\u0662"\n\n// for Japanese, applications may want to use the Japanese calendar,\n// where 2012 was the year 24 of the Heisei era\nconsole.log(date.toLocaleDateString("ja-JP-u-ca-japanese"));\n// "24/12/20"\n\n// when requesting a language that may not be supported, such as\n// Balinese, include a fallback language, in this case Indonesian\nconsole.log(date.toLocaleDateString(["ban", "id"]));\n// "20/12/2012"\n```\n\n### Using options\n\nThe results provided by `toLocaleDateString()` can be customized using the `options` parameter:\n\n```js\nconst date = new Date(Date.UTC(2012, 11, 20, 3, 0, 0));\n\n// Request a weekday along with a long date\nconst options = {\n  weekday: "long",\n  year: "numeric",\n  month: "long",\n  day: "numeric",\n};\nconsole.log(date.toLocaleDateString("de-DE", options));\n// "Donnerstag, 20. Dezember 2012"\n\n// An application may want to use UTC and make that visible\noptions.timeZone = "UTC";\noptions.timeZoneName = "short";\nconsole.log(date.toLocaleDateString("en-US", options));\n// "Thursday, December 20, 2012, UTC"\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Intl.DateTimeFormat")}}\n- {{jsxref("Date.prototype.toLocaleString()")}}\n- {{jsxref("Date.prototype.toLocaleTimeString()")}}\n- {{jsxref("Date.prototype.toString()")}}\n'
        },
        "tolocalestring": {
            "index.md": '---\ntitle: Date.prototype.toLocaleString()\nslug: Web/JavaScript/Reference/Global_Objects/Date/toLocaleString\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Date.toLocaleString\n---\n\n{{JSRef}}\n\nThe **`toLocaleString()`** method of {{jsxref("Date")}} instances returns a string with a language-sensitive representation of this date in the local timezone. In implementations with [`Intl.DateTimeFormat` API](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat) support, this method simply calls `Intl.DateTimeFormat`.\n\nEvery time `toLocaleString` is called, it has to perform a search in a big database of localization strings, which is potentially inefficient. When the method is called many times with the same arguments, it is better to create a {{jsxref("Intl.DateTimeFormat")}} object and use its {{jsxref("Intl/DateTimeFormat/format", "format()")}} method, because a `DateTimeFormat` object remembers the arguments passed to it and may decide to cache a slice of the database, so future `format` calls can search for localization strings within a more constrained context.\n\n{{EmbedInteractiveExample("pages/js/date-tolocalestring.html")}}\n\n## Syntax\n\n```js-nolint\ntoLocaleString()\ntoLocaleString(locales)\ntoLocaleString(locales, options)\n```\n\n### Parameters\n\nThe `locales` and `options` parameters customize the behavior of the function and let applications specify the language whose formatting conventions should be used.\n\nIn implementations that support the [`Intl.DateTimeFormat` API](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat), these parameters correspond exactly to the [`Intl.DateTimeFormat()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/DateTimeFormat) constructor\'s parameters. Implementations without `Intl.DateTimeFormat` support are asked to ignore both parameters, making the locale used and the form of the string returned entirely implementation-dependent.\n\n- `locales` {{optional_inline}}\n\n  - : A string with a BCP 47 language tag, or an array of such strings. Corresponds to the [`locales`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/DateTimeFormat#locales) parameter of the `Intl.DateTimeFormat()` constructor.\n\n    In implementations without `Intl.DateTimeFormat` support, this parameter is ignored and the host\'s locale is usually used.\n\n- `options` {{optional_inline}}\n\n  - : An object adjusting the output format. Corresponds to the [`options`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/DateTimeFormat#options) parameter of the `Intl.DateTimeFormat()` constructor. If `weekday`, `year`, `month`, `day`, `dayPeriod`, `hour`, `minute`, `second`, and `fractionalSecondDigits` are all undefined, then `year`, `month`, `day`, `hour`, `minute`, `second` will be set to `"numeric"`.\n\n    In implementations without `Intl.DateTimeFormat` support, this parameter is ignored.\n\nSee the [`Intl.DateTimeFormat()` constructor](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/DateTimeFormat) for details on these parameters and how to use them.\n\n### Return value\n\nA string representing the given date according to language-specific conventions.\n\nIn implementations with `Intl.DateTimeFormat`, this is equivalent to `new Intl.DateTimeFormat(locales, options).format(date)`.\n\n> **Note:** Most of the time, the formatting returned by `toLocaleString()` is consistent. However, the output may vary with time, language, and implementation \u2014 output variations are by design and allowed by the specification. You should not compare the results of `toLocaleString()` to static values.\n\n## Examples\n\n### Using toLocaleString()\n\nBasic use of this method without specifying a `locale` returns a formatted string in the default locale and with default options.\n\n```js\nconst date = new Date(Date.UTC(2012, 11, 12, 3, 0, 0));\n\n// toLocaleString() without arguments depends on the\n// implementation, the default locale, and the default time zone\nconsole.log(date.toLocaleString());\n// "12/11/2012, 7:00:00 PM" if run in en-US locale with time zone America/Los_Angeles\n```\n\n### Checking for support for locales and options parameters\n\nThe `locales` and `options` parameters may not be supported in all implementations, because support for the internationalization API is optional, and some systems may not have the necessary data. For implementations without internationalization support, `toLocaleString()` always uses the system\'s locale, which may not be what you want. Because any implementation that supports the `locales` and `options` parameters must support the {{jsxref("Intl")}} API, you can check the existence of the latter for support:\n\n```js\nfunction toLocaleStringSupportsLocales() {\n  return (\n    typeof Intl === "object" &&\n    !!Intl &&\n    typeof Intl.DateTimeFormat === "function"\n  );\n}\n```\n\n### Using locales\n\nThis example shows some of the variations in localized date and time formats. In order to get the format of the language used in the user interface of your application, make sure to specify that language (and possibly some fallback languages) using the `locales` argument:\n\n```js\nconst date = new Date(Date.UTC(2012, 11, 20, 3, 0, 0));\n\n// Formats below assume the local time zone of the locale;\n// America/Los_Angeles for the US\n\n// US English uses month-day-year order and 12-hour time with AM/PM\nconsole.log(date.toLocaleString("en-US"));\n// "12/19/2012, 7:00:00 PM"\n\n// British English uses day-month-year order and 24-hour time without AM/PM\nconsole.log(date.toLocaleString("en-GB"));\n// "20/12/2012 03:00:00"\n\n// Korean uses year-month-day order and 12-hour time with AM/PM\nconsole.log(date.toLocaleString("ko-KR"));\n// "2012. 12. 20. \uC624\uD6C4 12:00:00"\n\n// Arabic in most Arabic-speaking countries uses Eastern Arabic numerals\nconsole.log(date.toLocaleString("ar-EG"));\n// "\u0662\u0660\u200F/\u0661\u0662\u200F/\u0662\u0660\u0661\u0662 \u0665:\u0660\u0660:\u0660\u0660 \u0635"\n\n// For Japanese, applications may want to use the Japanese calendar,\n// where 2012 was the year 24 of the Heisei era\nconsole.log(date.toLocaleString("ja-JP-u-ca-japanese"));\n// "24/12/20 12:00:00"\n\n// When requesting a language that may not be supported, such as\n// Balinese, include a fallback language (in this case, Indonesian)\nconsole.log(date.toLocaleString(["ban", "id"]));\n// "20/12/2012 11.00.00"\n```\n\n### Using options\n\nThe results provided by `toLocaleString()` can be customized using the `options` parameter:\n\n```js\nconst date = new Date(Date.UTC(2012, 11, 20, 3, 0, 0));\n\n// Request a weekday along with a long date\nconst options = {\n  weekday: "long",\n  year: "numeric",\n  month: "long",\n  day: "numeric",\n};\nconsole.log(date.toLocaleString("de-DE", options));\n// "Donnerstag, 20. Dezember 2012"\n\n// An application may want to use UTC and make that visible\noptions.timeZone = "UTC";\noptions.timeZoneName = "short";\nconsole.log(date.toLocaleString("en-US", options));\n// "Thursday, December 20, 2012, GMT"\n\n// Sometimes even the US needs 24-hour time\nconsole.log(date.toLocaleString("en-US", { hour12: false }));\n// "12/19/2012, 19:00:00"\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Intl.DateTimeFormat")}}\n- {{jsxref("Date.prototype.toLocaleDateString()")}}\n- {{jsxref("Date.prototype.toLocaleTimeString()")}}\n- {{jsxref("Date.prototype.toString()")}}\n'
        },
        "tolocaletimestring": {
            "index.md": '---\ntitle: Date.prototype.toLocaleTimeString()\nslug: Web/JavaScript/Reference/Global_Objects/Date/toLocaleTimeString\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Date.toLocaleTimeString\n---\n\n{{JSRef}}\n\nThe **`toLocaleTimeString()`** method of {{jsxref("Date")}} instances returns a string with a language-sensitive representation of the time portion of this date in the local timezone. In implementations with [`Intl.DateTimeFormat` API](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat) support, this method simply calls `Intl.DateTimeFormat`.\n\nEvery time `toLocaleTimeString` is called, it has to perform a search in a big database of localization strings, which is potentially inefficient. When the method is called many times with the same arguments, it is better to create a {{jsxref("Intl.DateTimeFormat")}} object and use its {{jsxref("Intl/DateTimeFormat/format", "format()")}} method, because a `DateTimeFormat` object remembers the arguments passed to it and may decide to cache a slice of the database, so future `format` calls can search for localization strings within a more constrained context.\n\n{{EmbedInteractiveExample("pages/js/date-tolocaletimestring.html")}}\n\n## Syntax\n\n```js-nolint\ntoLocaleTimeString()\ntoLocaleTimeString(locales)\ntoLocaleTimeString(locales, options)\n```\n\n### Parameters\n\nThe `locales` and `options` parameters customize the behavior of the function and let applications specify the language whose formatting conventions should be used.\n\nIn implementations that support the [`Intl.DateTimeFormat` API](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat), these parameters correspond exactly to the [`Intl.DateTimeFormat()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/DateTimeFormat) constructor\'s parameters. Implementations without `Intl.DateTimeFormat` support are asked to ignore both parameters, making the locale used and the form of the string returned entirely implementation-dependent.\n\n- `locales` {{optional_inline}}\n\n  - : A string with a BCP 47 language tag, or an array of such strings. Corresponds to the [`locales`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/DateTimeFormat#locales) parameter of the `Intl.DateTimeFormat()` constructor.\n\n    In implementations without `Intl.DateTimeFormat` support, this parameter is ignored and the host\'s locale is usually used.\n\n- `options` {{optional_inline}}\n\n  - : An object adjusting the output format. Corresponds to the [`options`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/DateTimeFormat#options) parameter of the `Intl.DateTimeFormat()` constructor. If `dayPeriod`, `hour`, `minute`, `second`, and `fractionalSecondDigits` are all undefined, then `hour`, `minute`, `second` will be set to `"numeric"`.\n\n    In implementations without `Intl.DateTimeFormat` support, this parameter is ignored.\n\nSee the [`Intl.DateTimeFormat()` constructor](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/DateTimeFormat) for details on these parameters and how to use them.\n\n### Return value\n\nA string representing the time portion of the given date according to language-specific conventions.\n\nIn implementations with `Intl.DateTimeFormat`, this is equivalent to `new Intl.DateTimeFormat(locales, options).format(date)`, where `options` has been normalized as described above.\n\n> **Note:** Most of the time, the formatting returned by `toLocaleTimeString()` is consistent. However, the output may vary with time, language, and implementation \u2014 output variations are by design and allowed by the specification. You should not compare the results of `toLocaleTimeString()` to static values.\n\n## Examples\n\n### Using toLocaleTimeString()\n\nBasic use of this method without specifying a `locale` returns a formatted string in the default locale and with default options.\n\n```js\nconst date = new Date(Date.UTC(2012, 11, 12, 3, 0, 0));\n\n// toLocaleTimeString() without arguments depends on the implementation,\n// the default locale, and the default time zone\nconsole.log(date.toLocaleTimeString());\n// "7:00:00 PM" if run in en-US locale with time zone America/Los_Angeles\n```\n\n### Checking for support for locales and options parameters\n\nThe `locales` and `options` parameters may not be supported in all implementations, because support for the internationalization API is optional, and some systems may not have the necessary data. For implementations without internationalization support, `toLocaleTimeString()` always uses the system\'s locale, which may not be what you want. Because any implementation that supports the `locales` and `options` parameters must support the {{jsxref("Intl")}} API, you can check the existence of the latter for support:\n\n```js\nfunction toLocaleTimeStringSupportsLocales() {\n  return (\n    typeof Intl === "object" &&\n    !!Intl &&\n    typeof Intl.DateTimeFormat === "function"\n  );\n}\n```\n\n### Using locales\n\nThis example shows some of the variations in localized time formats. In order to get the format of the language used in the user interface of your application, make sure to specify that language (and possibly some fallback languages) using the `locales` argument:\n\n```js\nconst date = new Date(Date.UTC(2012, 11, 20, 3, 0, 0));\n\n// formats below assume the local time zone of the locale;\n// America/Los_Angeles for the US\n\n// US English uses 12-hour time with AM/PM\nconsole.log(date.toLocaleTimeString("en-US"));\n// "7:00:00 PM"\n\n// British English uses 24-hour time without AM/PM\nconsole.log(date.toLocaleTimeString("en-GB"));\n// "03:00:00"\n\n// Korean uses 12-hour time with AM/PM\nconsole.log(date.toLocaleTimeString("ko-KR"));\n// "\uC624\uD6C4 12:00:00"\n\n// Arabic in most Arabic speaking countries uses real Arabic digits\nconsole.log(date.toLocaleTimeString("ar-EG"));\n// "\u0667:\u0660\u0660:\u0660\u0660 \u0645"\n\n// when requesting a language that may not be supported, such as\n// Balinese, include a fallback language, in this case Indonesian\nconsole.log(date.toLocaleTimeString(["ban", "id"]));\n// "11.00.00"\n```\n\n### Using options\n\nThe results provided by `toLocaleTimeString()` can be customized using the `options` parameter:\n\n```js\nconst date = new Date(Date.UTC(2012, 11, 20, 3, 0, 0));\n\n// An application may want to use UTC and make that visible\nconst options = { timeZone: "UTC", timeZoneName: "short" };\nconsole.log(date.toLocaleTimeString("en-US", options));\n// "3:00:00 AM GMT"\n\n// Sometimes even the US needs 24-hour time\nconsole.log(date.toLocaleTimeString("en-US", { hour12: false }));\n// "19:00:00"\n\n// Show only hours and minutes, use options with the default locale - use an empty array\nconsole.log(\n  date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }),\n);\n// "20:01"\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Intl.DateTimeFormat")}}\n- {{jsxref("Date.prototype.toLocaleDateString()")}}\n- {{jsxref("Date.prototype.toLocaleString()")}}\n- {{jsxref("Date.prototype.toTimeString()")}}\n- {{jsxref("Date.prototype.toString()")}}\n'
        },
        "tostring": {
            "index.md": '---\ntitle: Date.prototype.toString()\nslug: Web/JavaScript/Reference/Global_Objects/Date/toString\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Date.toString\n---\n\n{{JSRef}}\n\nThe **`toString()`** method of {{jsxref("Date")}} instances returns a string representing this date interpreted in the local timezone.\n\n{{EmbedInteractiveExample("pages/js/date-tostring.html", "shorter")}}\n\n## Syntax\n\n```js-nolint\ntoString()\n```\n\n### Parameters\n\nNone.\n\n### Return value\n\nA string representing the given date (see description for the format). Returns `"Invalid Date"` if the date is [invalid](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#the_epoch_timestamps_and_invalid_date).\n\n## Description\n\nThe `toString()` method is part of the [type coercion protocol](/en-US/docs/Web/JavaScript/Data_structures#type_coercion). Because `Date` has a [`[@@toPrimitive]()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/@@toPrimitive) method, that method always takes priority over `toString()` when a `Date` object is implicitly [coerced to a string](/en-US/docs/Web/JavaScript/Reference/Global_Objects/String#string_coercion). However, `Date.prototype[@@toPrimitive]()` still calls `this.toString()` internally.\n\nThe {{jsxref("Date")}} object overrides the {{jsxref("Object/toString", "toString()")}} method of {{jsxref("Object")}}. `Date.prototype.toString()` returns a string representation of the Date as interpreted in the local timezone, containing both the date and the time \u2014 it joins the string representation specified in {{jsxref("Date/toDateString", "toDateString()")}} and {{jsxref("Date/toTimeString", "toTimeString()")}} together, adding a space in between. For example: "Thu Jan 01 1970 00:00:00 GMT+0000 (Coordinated Universal Time)".\n\n`Date.prototype.toString()` must be called on {{jsxref("Date")}} instances. If the `this` value does not inherit from `Date.prototype`, a {{jsxref("TypeError")}} is thrown.\n\n- If you only want to get the _date_ part, use {{jsxref("Date/toDateString", "toDateString()")}}.\n- If you only want to get the _time_ part, use {{jsxref("Date/toTimeString", "toTimeString()")}}.\n- If you want to make the date interpreted as UTC instead of local timezone, use {{jsxref("Date/toUTCString", "toUTCString()")}}.\n- If you want to format the date in a more user-friendly format (e.g. localization), use {{jsxref("Date/toLocaleString", "toLocaleString()")}}.\n\n## Examples\n\n### Using toString()\n\n```js\nconst d = new Date(0);\nconsole.log(d.toString()); // "Thu Jan 01 1970 00:00:00 GMT+0000 (Coordinated Universal Time)"\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Object.prototype.toString()")}}\n- {{jsxref("Date.prototype.toDateString()")}}\n- {{jsxref("Date.prototype.toLocaleString()")}}\n- {{jsxref("Date.prototype.toTimeString()")}}\n'
        },
        "totimestring": {
            "index.md": '---\ntitle: Date.prototype.toTimeString()\nslug: Web/JavaScript/Reference/Global_Objects/Date/toTimeString\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Date.toTimeString\n---\n\n{{JSRef}}\n\nThe **`toTimeString()`** method of {{jsxref("Date")}} instances returns a string representing the time portion of this date interpreted in the local timezone.\n\n{{EmbedInteractiveExample("pages/js/date-totimestring.html", "shorter")}}\n\n## Syntax\n\n```js-nolint\ntoTimeString()\n```\n\n### Parameters\n\nNone.\n\n### Return value\n\nA string representing the time portion of the given date (see description for the format). Returns `"Invalid Date"` if the date is [invalid](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#the_epoch_timestamps_and_invalid_date).\n\n## Description\n\n{{jsxref("Date")}} instances refer to a specific point in time. `toTimeString()` interprets the date in the local timezone and formats the _time_ part in English. It always uses the format of `hh:mm:ss GMT\xb1xxxx (TZ)`, where:\n\n| Format String | Description                                                                                           |\n| ------------- | ----------------------------------------------------------------------------------------------------- |\n| `hh`          | Hour, as two digits with leading zero if required                                                     |\n| `mm`          | Minute, as two digits with leading zero if required                                                   |\n| `ss`          | Seconds, as two digits with leading zero if required                                                  |\n| `\xb1xxxx`       | The local timezone\'s offset \u2014 two digits for hours and two digits for minutes (e.g. `-0500`, `+0800`) |\n| `TZ`          | The timezone\'s name (e.g. `PDT`, `PST`)                                                               |\n\nFor example: "04:42:04 GMT+0000 (Coordinated Universal Time)".\n\n- If you only want to get the _date_ part, use {{jsxref("Date/toDateString", "toDateString()")}}.\n- If you want to get both the date and time, use {{jsxref("Date/toString", "toString()")}}.\n- If you want to make the date interpreted as UTC instead of local timezone, use {{jsxref("Date/toUTCString", "toUTCString()")}}.\n- If you want to format the date in a more user-friendly format (e.g. localization), use {{jsxref("Date/toLocaleTimeString", "toLocaleTimeString()")}}.\n\n## Examples\n\n### Using toTimeString()\n\n```js\nconst d = new Date(0);\n\nconsole.log(d.toString()); // "Thu Jan 01 1970 00:00:00 GMT+0000 (Coordinated Universal Time)"\nconsole.log(d.toTimeString()); // "00:00:00 GMT+0000 (Coordinated Universal Time)"\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Date.prototype.toLocaleTimeString()")}}\n- {{jsxref("Date.prototype.toDateString()")}}\n- {{jsxref("Date.prototype.toString()")}}\n'
        },
        "toutcstring": {
            "index.md": '---\ntitle: Date.prototype.toUTCString()\nslug: Web/JavaScript/Reference/Global_Objects/Date/toUTCString\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Date.toUTCString\n---\n\n{{JSRef}}\n\nThe **`toUTCString()`** method of {{jsxref("Date")}} instances returns a string representing this date in the [RFC 7231](https://datatracker.ietf.org/doc/html/rfc7231#section-7.1.1.1) format, with negative years allowed. The timezone is always UTC. `toGMTString()` is an alias of this method.\n\n{{EmbedInteractiveExample("pages/js/date-toutcstring.html", "shorter")}}\n\n## Syntax\n\n```js-nolint\ntoUTCString()\n```\n\n### Parameters\n\nNone.\n\n### Return value\n\nA string representing the given date using the UTC time zone (see description for the format). Returns `"Invalid Date"` if the date is [invalid](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#the_epoch_timestamps_and_invalid_date).\n\n## Description\n\nThe value returned by `toUTCString()` is a string in the form `Www, dd Mmm yyyy hh:mm:ss GMT`, where:\n\n| Format String | Description                                                  |\n| ------------- | ------------------------------------------------------------ |\n| `Www`         | Day of week, as three letters (e.g. `Sun`, `Mon`)            |\n| `dd`          | Day of month, as two digits with leading zero if required    |\n| `Mmm`         | Month, as three letters (e.g. `Jan`, `Feb`)                  |\n| `yyyy`        | Year, as four or more digits with leading zeroes if required |\n| `hh`          | Hour, as two digits with leading zero if required            |\n| `mm`          | Minute, as two digits with leading zero if required          |\n| `ss`          | Seconds, as two digits with leading zero if required         |\n\n### Aliasing\n\nJavaScript\'s `Date` API was inspired by Java\'s `java.util.Date` library (while the latter had become de facto legacy since Java 1.1 in 1997). In particular, the Java `Date` class had a method called `toGMTString` \u2014 which was poorly named, because the [Greenwich Mean Time](https://en.wikipedia.org/wiki/Greenwich_Mean_Time) is not equivalent to the [Coordinated Universal Time](https://en.wikipedia.org/wiki/Coordinated_Universal_Time), while JavaScript dates always operate by UTC time. For web compatibility reasons, `toGMTString` remains as an alias to `toUTCString`, and they refer to the exact same function object. This means:\n\n```js\nDate.prototype.toGMTString.name === "toUTCString";\n```\n\n## Examples\n\n### Using toUTCString()\n\n```js\nconst d = new Date(0);\nconsole.log(d.toUTCString()); // \'Thu, 01 Jan 1970 00:00:00 GMT\'\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Date.prototype.toLocaleString()")}}\n- {{jsxref("Date.prototype.toString()")}}\n- {{jsxref("Date.prototype.toISOString()")}}\n'
        },
        "utc": {
            "index.md": '---\ntitle: Date.UTC()\nslug: Web/JavaScript/Reference/Global_Objects/Date/UTC\npage-type: javascript-static-method\nbrowser-compat: javascript.builtins.Date.UTC\n---\n\n{{JSRef}}\n\nThe **`Date.UTC()`** static method accepts parameters representing the date and time components similar to the {{jsxref("Date")}} constructor, but treats them as UTC. It returns the number of milliseconds since January 1, 1970, 00:00:00 UTC.\n\n{{EmbedInteractiveExample("pages/js/date-utc.html")}}\n\n## Syntax\n\n```js-nolint\nDate.UTC(year)\nDate.UTC(year, monthIndex)\nDate.UTC(year, monthIndex, day)\nDate.UTC(year, monthIndex, day, hour)\nDate.UTC(year, monthIndex, day, hour, minute)\nDate.UTC(year, monthIndex, day, hour, minute, second)\nDate.UTC(year, monthIndex, day, hour, minute, second, millisecond)\n```\n\n### Parameters\n\n- `year`\n  - : Integer value representing the year. Values from `0` to `99` map to the years `1900` to `1999`. All other values are the actual year. See the [example](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#interpretation_of_two-digit_years).\n- `monthIndex` {{optional_inline}}\n  - : Integer value representing the month, beginning with `0` for January to `11` for December. Defaults to `0`.\n- `day` {{optional_inline}}\n  - : Integer value representing the day of the month. Defaults to `1`.\n- `hours` {{optional_inline}}\n  - : Integer value between `0` and `23` representing the hour of the day. Defaults to `0`.\n- `minutes` {{optional_inline}}\n  - : Integer value representing the minute segment of a time. Defaults to `0`.\n- `seconds` {{optional_inline}}\n  - : Integer value representing the second segment of a time. Defaults to `0`.\n- `milliseconds` {{optional_inline}}\n  - : Integer value representing the millisecond segment of a time. Defaults to `0`.\n\n### Return value\n\nA number representing the [timestamp](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#the_epoch_timestamps_and_invalid_date) of the given date. Returns `NaN` if the date is [invalid](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#the_epoch_timestamps_and_invalid_date).\n\n## Description\n\nYears between `0` and `99` are converted to a year in the 20th century `(1900 + year)`. For example, `95` is converted to the year `1995`.\n\nThe `UTC()` method differs from the {{jsxref("Date/Date", "Date()")}} constructor in three ways:\n\n1. `Date.UTC()` uses universal time instead of the local time.\n2. `Date.UTC()` returns a time value as a number instead of creating a {{jsxref("Date")}} object.\n3. When passed a single number, `Date.UTC()` interprets it as a year instead of a timestamp.\n\nIf a parameter is outside of the expected range, the `UTC()` method updates the other parameters to accommodate the value. For example, if `15` is used for `monthIndex`, the year will be incremented by 1 `(year + 1)` and `3` will be used for the month.\n\nBecause `UTC()` is a static method of `Date`, you always use it as `Date.UTC()`, rather than as a method of a `Date` object you created.\n\n## Examples\n\n### Using Date.UTC()\n\nThe following statement creates a {{jsxref("Date")}} object with the arguments treated as UTC instead of local:\n\n```js\nconst utcDate = new Date(Date.UTC(2018, 11, 1, 0, 0, 0));\n```\n\n### Behavior of Date.UTC() with one argument\n\n`Date.UTC()` when passed one argument used to have inconsistent behavior, because implementations only kept the behavior consistent with the {{jsxref("Date/Date", "Date()")}} constructor, which does not interpret a single argument as the year number. Implementations are now required to treat omitted `monthIndex` as `0`, instead of coercing it to `NaN`.\n\n```js\nDate.UTC(2017); // 1483228800000\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Date.parse()")}}\n- {{jsxref("Date")}}\n'
        },
        "valueof": {
            "index.md": '---\ntitle: Date.prototype.valueOf()\nslug: Web/JavaScript/Reference/Global_Objects/Date/valueOf\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Date.valueOf\n---\n\n{{JSRef}}\n\nThe **`valueOf()`** method of {{jsxref("Date")}} instances returns the number of milliseconds for this date since the [epoch](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#the_epoch_timestamps_and_invalid_date), which is defined as the midnight at the beginning of January 1, 1970, UTC.\n\n{{EmbedInteractiveExample("pages/js/date-valueof.html")}}\n\n## Syntax\n\n```js-nolint\nvalueOf()\n```\n\n### Parameters\n\nNone.\n\n### Return value\n\nA number representing the [timestamp](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#the_epoch_timestamps_and_invalid_date), in milliseconds, of this date. Returns `NaN` if the date is [invalid](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#the_epoch_timestamps_and_invalid_date).\n\n## Description\n\nThe `valueOf()` method is part of the [type coercion protocol](/en-US/docs/Web/JavaScript/Data_structures#type_coercion). Because `Date` has a [`[@@toPrimitive]()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/@@toPrimitive) method, that method always takes priority over `valueOf()` when a `Date` object is implicitly [coerced to a number](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number#number_coercion). However, `Date.prototype[@@toPrimitive]()` still calls `this.valueOf()` internally.\n\nThe {{jsxref("Date")}} object overrides the {{jsxref("Object/valueOf", "valueOf()")}} method of {{jsxref("Object")}}. `Date.prototype.valueOf()` returns the timestamp of the date, which is functionally equivalent to the {{jsxref("Date.prototype.getTime()")}} method.\n\n## Examples\n\n### Using valueOf()\n\n```js\nconst d = new Date(0); // 1970-01-01T00:00:00.000Z\nconsole.log(d.valueOf()); // 0\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Object.prototype.valueOf()")}}\n- {{jsxref("Date.prototype.getTime()")}}\n'
        }
    },
    "decodeuri": {
        "index.md": '---\ntitle: decodeURI()\nslug: Web/JavaScript/Reference/Global_Objects/decodeURI\npage-type: javascript-function\nbrowser-compat: javascript.builtins.decodeURI\n---\n\n{{jsSidebar("Objects")}}\n\nThe **`decodeURI()`** function decodes a Uniform Resource Identifier (URI) previously created by {{jsxref("encodeURI()")}} or a similar routine.\n\n{{EmbedInteractiveExample("pages/js/globalprops-decodeuri.html")}}\n\n## Syntax\n\n```js-nolint\ndecodeURI(encodedURI)\n```\n\n### Parameters\n\n- `encodedURI`\n  - : A complete, encoded Uniform Resource Identifier.\n\n### Return value\n\nA new string representing the unencoded version of the given encoded Uniform Resource Identifier (URI).\n\n### Exceptions\n\n- {{jsxref("URIError")}}\n  - : Thrown if `encodedURI` contains a `%` not followed by two hexadecimal digits, or if the escape sequence does not encode a valid UTF-8 character.\n\n## Description\n\n`decodeURI()` is a function property of the global object.\n\nThe `decodeURI()` function decodes the URI by treating each escape sequence in the form `%XX` as one UTF-8 code unit (one byte). In UTF-8, the number of leading 1 bits in the first byte, which may be 0 (for 1-byte {{Glossary("ASCII")}} characters), 2, 3, or 4, indicates the number of bytes in the character. So by reading the first escape sequence, `decodeURI()` can determine how many more escape sequences to consume. If `decodeURI()` fails to find the expected number of sequences, or if the escape sequences don\'t encode a valid UTF-8 character, a {{jsxref("URIError")}} is thrown.\n\n`decodeURI()` decodes all escape sequences, but if the escape sequence encodes one of the following characters, the escape sequence is preserved in the output string (because they are part of the URI syntax):\n\n```plain\n; / ? : @ & = + $ , #\n```\n\n## Examples\n\n### Decoding a Cyrillic URL\n\n```js\ndecodeURI(\n  "https://developer.mozilla.org/ru/docs/JavaScript_%D1%88%D0%B5%D0%BB%D0%BB%D1%8B",\n);\n// "https://developer.mozilla.org/ru/docs/JavaScript_\u0448\u0435\u043B\u043B\u044B"\n```\n\n### decodeURI() vs. decodeURIComponent()\n\n`decodeURI()` assumes the input is a full URI, so it does not decode characters that are part of the URI syntax.\n\n```js\ndecodeURI(\n  "https://developer.mozilla.org/docs/JavaScript%3A%20a_scripting_language",\n);\n// "https://developer.mozilla.org/docs/JavaScript%3A a_scripting_language"\n\ndecodeURIComponent(\n  "https://developer.mozilla.org/docs/JavaScript%3A%20a_scripting_language",\n);\n// "https://developer.mozilla.org/docs/JavaScript: a_scripting_language"\n```\n\n### Catching errors\n\n```js\ntry {\n  const a = decodeURI("%E0%A4%A");\n} catch (e) {\n  console.error(e);\n}\n\n// URIError: malformed URI sequence\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("decodeURIComponent()")}}\n- {{jsxref("encodeURI()")}}\n- {{jsxref("encodeURIComponent()")}}\n'
    },
    "decodeuricomponent": {
        "index.md": '---\ntitle: decodeURIComponent()\nslug: Web/JavaScript/Reference/Global_Objects/decodeURIComponent\npage-type: javascript-function\nbrowser-compat: javascript.builtins.decodeURIComponent\n---\n\n{{jsSidebar("Objects")}}\n\nThe **`decodeURIComponent()`** function decodes a Uniform Resource Identifier (URI) component previously created by {{jsxref("encodeURIComponent()")}} or by a similar routine.\n\n{{EmbedInteractiveExample("pages/js/globalprops-decodeuricomponent.html")}}\n\n## Syntax\n\n```js-nolint\ndecodeURIComponent(encodedURI)\n```\n\n### Parameters\n\n- `encodedURI`\n  - : An encoded component of a Uniform Resource Identifier.\n\n### Return value\n\nA new string representing the decoded version of the given encoded Uniform Resource Identifier (URI) component.\n\n### Exceptions\n\n- {{jsxref("URIError")}}\n  - : Thrown if `encodedURI` contains a `%` not followed by two hexadecimal digits, or if the escape sequence does not encode a valid UTF-8 character.\n\n## Description\n\n`decodeURIComponent()` is a function property of the global object.\n\n`decodeURIComponent()` uses the same decoding algorithm as described in {{jsxref("decodeURI()")}}. It decodes _all_ escape sequences, including those that are not created by {{jsxref("encodeURIComponent")}}, like `-.!~*\'()`.\n\n## Examples\n\n### Decoding a Cyrillic URL component\n\n```js\ndecodeURIComponent("JavaScript_%D1%88%D0%B5%D0%BB%D0%BB%D1%8B");\n// "JavaScript_\u0448\u0435\u043B\u043B\u044B"\n```\n\n### Catching errors\n\n```js\ntry {\n  const a = decodeURIComponent("%E0%A4%A");\n} catch (e) {\n  console.error(e);\n}\n\n// URIError: malformed URI sequence\n```\n\n### Decoding query parameters from a URL\n\n`decodeURIComponent()` cannot be used directly to parse query parameters from a URL. It needs a bit of preparation.\n\n```js\nfunction decodeQueryParam(p) {\n  return decodeURIComponent(p.replace(/\\+/g, " "));\n}\n\ndecodeQueryParam("search+query%20%28correct%29");\n// \'search query (correct)\'\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("decodeURI")}}\n- {{jsxref("encodeURI")}}\n- {{jsxref("encodeURIComponent")}}\n'
    },
    "encodeuri": {
        "index.md": '---\ntitle: encodeURI()\nslug: Web/JavaScript/Reference/Global_Objects/encodeURI\npage-type: javascript-function\nbrowser-compat: javascript.builtins.encodeURI\n---\n\n{{jsSidebar("Objects")}}\n\nThe **`encodeURI()`** function encodes a {{Glossary("URI")}} by replacing each instance of certain characters by one, two, three, or four escape sequences representing the {{Glossary("UTF-8")}} encoding of the character (will only be four escape sequences for characters composed of two surrogate characters). Compared to {{jsxref("encodeURIComponent()")}}, this function encodes fewer characters, preserving those that are part of the URI syntax.\n\n{{EmbedInteractiveExample("pages/js/globalprops-encodeuri.html")}}\n\n## Syntax\n\n```js-nolint\nencodeURI(uri)\n```\n\n### Parameters\n\n- `uri`\n  - : A string to be encoded as a URI.\n\n### Return value\n\nA new string representing the provided string encoded as a URI.\n\n### Exceptions\n\n- {{jsxref("URIError")}}\n  - : Thrown if `uri` contains a [lone surrogate](/en-US/docs/Web/JavaScript/Reference/Global_Objects/String#utf-16_characters_unicode_code_points_and_grapheme_clusters).\n\n## Description\n\n`encodeURI()` is a function property of the global object.\n\nThe `encodeURI()` function escapes characters by UTF-8 code units, with each octet encoded in the format `%XX`, left-padded with 0 if necessary. Because lone surrogates in UTF-16 do not encode any valid Unicode character, they cause `encodeURI()` to throw a {{jsxref("URIError")}}.\n\n`encodeURI()` escapes all characters **except**:\n\n```plain\nA\u2013Z a\u2013z 0\u20139 - _ . ! ~ * \' ( )\n\n; / ? : @ & = + $ , #\n```\n\nThe characters on the second line are characters that may be part of the URI syntax, and are only escaped by `encodeURIComponent()`. Both `encodeURI()` and `encodeURIComponent()` do not encode the characters `-.!~*\'()`, known as "unreserved marks", which do not have a reserved purpose but are allowed in a URI "as is". (See [RFC2396](https://www.ietf.org/rfc/rfc2396.txt))\n\nThe `encodeURI()` function does not encode characters that have special meaning (reserved characters) for a URI. The following example shows all the parts that a URI can possibly contain. Note how certain characters are used to signify special meaning:\n\n```url\nhttp://username:password@www.example.com:80/path/to/file.php?foo=316&bar=this+has+spaces#anchor\n```\n\n`encodeURI`, as the name implies, is used to encode a URL as a whole, assuming it is already well-formed. If you want to dynamically assemble string values into a URL, you probably want to use {{jsxref("encodeURIComponent()")}} on each dynamic segment instead, to avoid URL syntax characters in unwanted places.\n\n```js\nconst name = "Ben & Jerry\'s";\n\n// This is bad:\nconst link = encodeURI(`https://example.com/?choice=${name}`); // "https://example.com/?choice=Ben%20&%20Jerry\'s"\nconsole.log([...new URL(link).searchParams]); // [[\'choice\', \'Ben \'], [" Jerry\'s", \'\']\n\n// Instead:\nconst link = encodeURI(\n  `https://example.com/?choice=${encodeURIComponent(name)}`,\n);\n// "https://example.com/?choice=Ben%2520%2526%2520Jerry\'s"\nconsole.log([...new URL(link).searchParams]); // [[\'choice\', "Ben%20%26%20Jerry\'s"]]\n```\n\n## Examples\n\n### encodeURI() vs. encodeURIComponent()\n\n`encodeURI()` differs from {{jsxref("encodeURIComponent()")}} as follows:\n\n```js\nconst set1 = ";/?:@&=+$,#"; // Reserved Characters\nconst set2 = "-.!~*\'()"; // Unreserved Marks\nconst set3 = "ABC abc 123"; // Alphanumeric Characters + Space\n\nconsole.log(encodeURI(set1)); // ;/?:@&=+$,#\nconsole.log(encodeURI(set2)); // -.!~*\'()\nconsole.log(encodeURI(set3)); // ABC%20abc%20123 (the space gets encoded as %20)\n\nconsole.log(encodeURIComponent(set1)); // %3B%2C%2F%3F%3A%40%26%3D%2B%24%23\nconsole.log(encodeURIComponent(set2)); // -.!~*\'()\nconsole.log(encodeURIComponent(set3)); // ABC%20abc%20123 (the space gets encoded as %20)\n```\n\n### Encoding a lone surrogate throws\n\nA {{jsxref("URIError")}} will be thrown if one attempts to encode a surrogate which is not part of a high-low pair. For example:\n\n```js\n// High-low pair OK\nencodeURI("\uD800\uDFFF"); // "%F0%90%8F%BF"\n\n// Lone high-surrogate code unit throws "URIError: malformed URI sequence"\nencodeURI("\uD800");\n\n// Lone low-surrogate code unit throws "URIError: malformed URI sequence"\nencodeURI("\uDFFF");\n```\n\nYou can use {{jsxref("String.prototype.toWellFormed()")}}, which replaces lone surrogates with the Unicode replacement character (U+FFFD), to avoid this error. You can also use {{jsxref("String.prototype.isWellFormed()")}} to check if a string contains lone surrogates before passing it to `encodeURI()`.\n\n### Encoding for RFC3986\n\nThe more recent [RFC3986](https://datatracker.ietf.org/doc/html/rfc3986) makes square brackets reserved (for {{Glossary("IPv6")}}) and thus not encoded when forming something which could be part of a URL (such as a host). It also reserves !, \', (, ), and \\*, even though these characters have no formalized URI delimiting uses. The following function encodes a string for RFC3986-compliant URL format.\n\n```js\nfunction encodeRFC3986URI(str) {\n  return encodeURI(str)\n    .replace(/%5B/g, "[")\n    .replace(/%5D/g, "]")\n    .replace(\n      /[!\'()*]/g,\n      (c) => `%${c.charCodeAt(0).toString(16).toUpperCase()}`,\n    );\n}\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("decodeURI()")}}\n- {{jsxref("encodeURIComponent()")}}\n- {{jsxref("decodeURIComponent()")}}\n'
    },
    "encodeuricomponent": {
        "index.md": '---\ntitle: encodeURIComponent()\nslug: Web/JavaScript/Reference/Global_Objects/encodeURIComponent\npage-type: javascript-function\nbrowser-compat: javascript.builtins.encodeURIComponent\n---\n\n{{jsSidebar("Objects")}}\n\nThe **`encodeURIComponent()`** function encodes a {{Glossary("URI")}} by replacing each instance of certain characters by one, two, three, or four escape sequences representing the {{Glossary("UTF-8")}} encoding of the character (will only be four escape sequences for characters composed of two surrogate characters). Compared to {{jsxref("encodeURI()")}}, this function encodes more characters, including those that are part of the URI syntax.\n\n{{EmbedInteractiveExample("pages/js/globalprops-encodeuricomponent.html", "shorter")}}\n\n## Syntax\n\n```js-nolint\nencodeURIComponent(uriComponent)\n```\n\n### Parameters\n\n- `uriComponent`\n  - : A string to be encoded as a URI component (a path, query string, fragment, etc.). Other values are [converted to strings](/en-US/docs/Web/JavaScript/Reference/Global_Objects/String#string_coercion).\n\n### Return value\n\nA new string representing the provided `uriComponent` encoded as a URI component.\n\n### Exceptions\n\n- {{jsxref("URIError")}}\n  - : Thrown if `uriComponent` contains a [lone surrogate](/en-US/docs/Web/JavaScript/Reference/Global_Objects/String#utf-16_characters_unicode_code_points_and_grapheme_clusters).\n\n## Description\n\n`encodeURIComponent()` is a function property of the global object.\n\n`encodeURIComponent()` uses the same encoding algorithm as described in {{jsxref("encodeURI()")}}. It escapes all characters **except**:\n\n```plain\nA\u2013Z a\u2013z 0\u20139 - _ . ! ~ * \' ( )\n```\n\nCompared to {{jsxref("encodeURI()")}}, `encodeURIComponent()` escapes a larger set of characters. Use `encodeURIComponent()` on user-entered fields from forms {{HTTPMethod("POST")}}\'d to the server \u2014 this will encode `&` symbols that may inadvertently be generated during data entry for special HTML entities or other characters that require encoding/decoding. For example, if a user writes `Jack & Jill`, without `encodeURIComponent()`, the ampersand could be interpreted on the server as the start of a new field and jeopardize the integrity of the data.\n\nFor [`application/x-www-form-urlencoded`](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#application/x-www-form-urlencoded-encoding-algorithm), spaces are to be replaced by `+`, so one may wish to follow a `encodeURIComponent()` replacement with an additional replacement of `%20` with `+`.\n\n## Examples\n\n### Encoding for Content-Disposition and Link headers\n\nThe following example provides the special encoding required within UTF-8 {{HTTPHeader("Content-Disposition")}} and {{HTTPHeader("Link")}} server response header parameters (e.g., UTF-8 filenames):\n\n```js\nconst fileName = "my file(2).txt";\nconst header = `Content-Disposition: attachment; filename*=UTF-8\'\'${encodeRFC5987ValueChars(\n  fileName,\n)}`;\n\nconsole.log(header);\n// "Content-Disposition: attachment; filename*=UTF-8\'\'my%20file%282%29.txt"\n\nfunction encodeRFC5987ValueChars(str) {\n  return (\n    encodeURIComponent(str)\n      // The following creates the sequences %27 %28 %29 %2A (Note that\n      // the valid encoding of "*" is %2A, which necessitates calling\n      // toUpperCase() to properly encode). Although RFC3986 reserves "!",\n      // RFC5987 does not, so we do not need to escape it.\n      .replace(\n        /[\'()*]/g,\n        (c) => `%${c.charCodeAt(0).toString(16).toUpperCase()}`,\n      )\n      // The following are not required for percent-encoding per RFC5987,\n      // so we can allow for a little better readability over the wire: |`^\n      .replace(/%(7C|60|5E)/g, (str, hex) =>\n        String.fromCharCode(parseInt(hex, 16)),\n      )\n  );\n}\n```\n\n### Encoding for RFC3986\n\nThe more recent [RFC3986](https://datatracker.ietf.org/doc/html/rfc3986) reserves !, \', (, ), and \\*, even though these characters have no formalized URI delimiting uses. The following function encodes a string for RFC3986-compliant URL component format. It also encodes [ and ], which are part of the {{Glossary("IPv6")}} URI syntax. An RFC3986-compliant `encodeURI` implementation should not escape them, which is demonstrated in the [`encodeURI()` example](/en-US/docs/Web/JavaScript/Reference/Global_Objects/encodeURI#encoding_for_rfc3986).\n\n```js\nfunction encodeRFC3986URIComponent(str) {\n  return encodeURIComponent(str).replace(\n    /[!\'()*]/g,\n    (c) => `%${c.charCodeAt(0).toString(16).toUpperCase()}`,\n  );\n}\n```\n\n### Encoding a lone surrogate throws\n\nA {{jsxref("URIError")}} will be thrown if one attempts to encode a surrogate which is not part of a high-low pair. For example:\n\n```js\n// High-low pair OK\nencodeURIComponent("\uD800\uDFFF"); // "%F0%90%8F%BF"\n\n// Lone high-surrogate code unit throws "URIError: malformed URI sequence"\nencodeURIComponent("\uD800");\n\n// Lone high-surrogate code unit throws "URIError: malformed URI sequence"\nencodeURIComponent("\uDFFF");\n```\n\nYou can use {{jsxref("String.prototype.toWellFormed()")}}, which replaces lone surrogates with the Unicode replacement character (U+FFFD), to avoid this error. You can also use {{jsxref("String.prototype.isWellFormed()")}} to check if a string contains lone surrogates before passing it to `encodeURIComponent()`.\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("decodeURI()")}}\n- {{jsxref("encodeURI()")}}\n- {{jsxref("decodeURIComponent()")}}\n'
    },
    "error": {
        "cause": {
            "index.md": '---\ntitle: "Error: cause"\nslug: Web/JavaScript/Reference/Global_Objects/Error/cause\npage-type: javascript-instance-data-property\nbrowser-compat: javascript.builtins.Error.cause\n---\n\n{{JSRef}}\n\nThe **`cause`** data property of an {{jsxref("Error")}} instance indicates the specific original cause of the error.\n\nIt is used when catching and re-throwing an error with a more-specific or useful error message in order to still have access to the original error.\n\n## Value\n\nThe value that was passed to the [`Error()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error/Error) constructor in the `options.cause` argument. It may not be present.\n\n{{js_property_attributes(1, 0, 1)}}\n\n## Description\n\nThe value of `cause` can be of any type. You should not make assumptions that the error you caught has an `Error` as its `cause`, in the same way that you cannot be sure the variable bound in the `catch` statement is an `Error` either. The "Providing structured data as the error cause" example below shows a case where a non-error is deliberately provided as the cause.\n\n## Examples\n\n### Rethrowing an error with a cause\n\nIt is sometimes useful to catch an error and re-throw it with a new message.\nIn this case you should pass the original error into the constructor for the new `Error`, as shown.\n\n```js\ntry {\n  connectToDatabase();\n} catch (err) {\n  throw new Error("Connecting to database failed.", { cause: err });\n}\n```\n\nFor a more detailed example see [Error > Differentiate between similar errors](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#differentiate_between_similar_errors).\n\n### Providing structured data as the error cause\n\nError messages written for human consumption may be inappropriate for machine parsing \u2014 since they\'re subject to rewording or punctuation changes that may break any existing parsing written to consume them. So when throwing an error from a function, as an alternative to a human-readable error message, you can instead provide the cause as structured data, for machine parsing.\n\n```js\nfunction makeRSA(p, q) {\n  if (!Number.isInteger(p) || !Number.isInteger(q)) {\n    throw new Error("RSA key generation requires integer inputs.", {\n      cause: { code: "NonInteger", values: [p, q] },\n    });\n  }\n  if (!areCoprime(p, q)) {\n    throw new Error("RSA key generation requires two co-prime integers.", {\n      cause: { code: "NonCoprime", values: [p, q] },\n    });\n  }\n  // rsa algorithm\u2026\n}\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Error.prototype.message")}}\n- {{jsxref("Error.prototype.toString()")}}\n'
        },
        "columnnumber": {
            "index.md": '---\ntitle: "Error: columnNumber"\nslug: Web/JavaScript/Reference/Global_Objects/Error/columnNumber\npage-type: javascript-instance-data-property\nstatus:\n  - non-standard\nbrowser-compat: javascript.builtins.Error.columnNumber\n---\n\n{{JSRef}} {{Non-standard_Header}}\n\nThe **`columnNumber`** data property of an {{jsxref("Error")}} instance contains the column number in the line of the file that raised this error.\n\n## Value\n\nA positive integer.\n\n{{js_property_attributes(1, 0, 1)}}\n\n## Examples\n\n### Using columnNumber\n\n```js\ntry {\n  throw new Error("Could not parse input");\n} catch (err) {\n  console.log(err.columnNumber); // 9\n}\n```\n\n## Specifications\n\nNot part of any standard.\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Error.prototype.stack")}}\n- {{jsxref("Error.prototype.lineNumber")}}\n- {{jsxref("Error.prototype.fileName")}}\n'
        },
        "error": {
            "index.md": '---\ntitle: Error() constructor\nslug: Web/JavaScript/Reference/Global_Objects/Error/Error\npage-type: javascript-constructor\nbrowser-compat: javascript.builtins.Error.Error\n---\n\n{{JSRef}}\n\nThe **`Error()`** constructor creates {{jsxref("Error")}} objects.\n\n## Syntax\n\n```js-nolint\nnew Error()\nnew Error(message)\nnew Error(message, options)\nnew Error(message, fileName)\nnew Error(message, fileName, lineNumber)\n\nError()\nError(message)\nError(message, options)\nError(message, fileName)\nError(message, fileName, lineNumber)\n```\n\n> **Note:** `Error()` can be called with or without [`new`](/en-US/docs/Web/JavaScript/Reference/Operators/new). Both create a new `Error` instance.\n\n### Parameters\n\n- `message` {{optional_inline}}\n  - : A human-readable description of the error.\n- `options` {{optional_inline}}\n  - : An object that has the following properties:\n    - `cause` {{optional_inline}}\n      - : A value indicating the specific cause of the error, reflected in the {{jsxref("Error/cause", "cause")}} property. When catching and re-throwing an error with a more-specific or useful error message, this property can be used to pass the original error.\n- `fileName` {{optional_inline}} {{non-standard_inline}}\n  - : The path to the file that raised this error, reflected in the {{jsxref("Error/fileName", "fileName")}} property. Defaults to the name of the file containing the code that called the `Error()` constructor.\n- `lineNumber` {{optional_inline}} {{non-standard_inline}}\n  - : The line number within the file on which the error was raised, reflected in the {{jsxref("Error/lineNumber", "lineNumber")}} property. Defaults to the line number containing the `Error()` constructor invocation.\n\n## Examples\n\n### Function call or new construction\n\nWhen `Error` is used like a function, that is without {{jsxref("Operators/new", "new")}}, it will return an `Error` object.\nTherefore, a mere call to `Error` will produce the same output that constructing an `Error` object via the `new` keyword would.\n\n```js\nconst x = Error("I was created using a function call!");\n\n// above has the same functionality as following\nconst y = new Error(\'I was constructed via the "new" keyword!\');\n```\n\n### Rethrowing an error with a cause\n\nIt is sometimes useful to catch an error and re-throw it with a new message.\nIn this case you should pass the original error into the constructor for the new `Error`, as shown.\n\n```js\ntry {\n  frameworkThatCanThrow();\n} catch (err) {\n  throw new Error("New error message", { cause: err });\n}\n```\n\nFor a more detailed example see [Error > Differentiate between similar errors](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#differentiate_between_similar_errors).\n\n### Omitting options argument\n\nJavaScript only tries to read `options.cause` if `options` is an object \u2014 this avoids ambiguity with the other non-standard `Error(message, fileName, lineNumber)` signature, which requires the second parameter to be a string. If you omit `options`, pass a primitive value as `options`, or pass an object without the `cause` property, then the created `Error` object will have no `cause` property.\n\n```js\n// Omitting options\nconst error1 = new Error("Error message");\nconsole.log("cause" in error1); // false\n\n// Passing a primitive value\nconst error2 = new Error("Error message", "");\nconsole.log("cause" in error2); // false\n\n// Passing an object without a cause property\nconst error3 = new Error("Error message", { details: "http error" });\nconsole.log("cause" in error3); // false\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Error` with `cause` support in `core-js`](https://github.com/zloirock/core-js#ecmascript-error)\n- {{jsxref("Statements/throw", "throw")}}\n- {{jsxref("Statements/try...catch", "try...catch")}}\n- [Error causes](https://v8.dev/features/error-cause) on v8.dev (2021)\n'
        },
        "filename": {
            "index.md": '---\ntitle: "Error: fileName"\nslug: Web/JavaScript/Reference/Global_Objects/Error/fileName\npage-type: javascript-instance-data-property\nstatus:\n  - non-standard\nbrowser-compat: javascript.builtins.Error.fileName\n---\n\n{{JSRef}} {{Non-standard_Header}}\n\nThe **`fileName`** data property of an {{jsxref("Error")}} instance contains the path to the file that raised this error.\n\n## Value\n\nA string.\n\n{{js_property_attributes(1, 0, 1)}}\n\n## Description\n\nThis non-standard property contains the path to the file that raised this error. If called from a debugger context, the Firefox Developer Tools for example, "debugger eval code" is returned.\n\n## Examples\n\n### Using fileName\n\n```js\nconst e = new Error("Could not parse input");\nthrow e;\n// e.fileName could look like "file:///C:/example.html"\n```\n\n## Specifications\n\nNot part of any standard.\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Error.prototype.stack")}}\n- {{jsxref("Error.prototype.columnNumber")}}\n- {{jsxref("Error.prototype.lineNumber")}}\n'
        },
        "index.md": '---\ntitle: Error\nslug: Web/JavaScript/Reference/Global_Objects/Error\npage-type: javascript-class\nbrowser-compat: javascript.builtins.Error\n---\n\n{{JSRef}}\n\n**`Error`** objects are thrown when runtime errors occur. The `Error` object can also be used as a base object for user-defined exceptions. See below for standard built-in error types.\n\n## Description\n\nRuntime errors result in new `Error` objects being created and thrown.\n\n`Error` is a {{Glossary("serializable object")}}, so it can be cloned with {{domxref("structuredClone()")}} or copied between [Workers](/en-US/docs/Web/API/Worker) using {{domxref("Worker/postMessage()", "postMessage()")}}.\n\n### Error types\n\nBesides the generic `Error` constructor, there are other core error constructors in JavaScript. For client-side exceptions, see [Exception handling statements](/en-US/docs/Web/JavaScript/Guide/Control_flow_and_error_handling#exception_handling_statements).\n\n- {{jsxref("EvalError")}}\n  - : Creates an instance representing an error that occurs regarding the global function {{jsxref("Global_Objects/eval", "eval()")}}.\n- {{jsxref("RangeError")}}\n  - : Creates an instance representing an error that occurs when a numeric variable or parameter is outside its valid range.\n- {{jsxref("ReferenceError")}}\n  - : Creates an instance representing an error that occurs when de-referencing an invalid reference.\n- {{jsxref("SyntaxError")}}\n  - : Creates an instance representing a syntax error.\n- {{jsxref("TypeError")}}\n  - : Creates an instance representing an error that occurs when a variable or parameter is not of a valid type.\n- {{jsxref("URIError")}}\n  - : Creates an instance representing an error that occurs when {{jsxref("encodeURI()")}} or {{jsxref("decodeURI()")}} are passed invalid parameters.\n- {{jsxref("AggregateError")}}\n  - : Creates an instance representing several errors wrapped in a single error when multiple errors need to be reported by an operation, for example by {{jsxref("Promise.any()")}}.\n- {{jsxref("InternalError")}} {{non-standard_inline}}\n  - : Creates an instance representing an error that occurs when an internal error in the JavaScript engine is thrown. E.g. "too much recursion".\n\n## Constructor\n\n- {{jsxref("Error/Error", "Error()")}}\n  - : Creates a new `Error` object.\n\n## Static methods\n\n- `Error.captureStackTrace()` {{non-standard_inline}}\n  - : A non-standard V8 function that creates the {{jsxref("Error/stack", "stack")}} property on an Error instance.\n- `Error.stackTraceLimit` {{non-standard_inline}}\n  - : A non-standard V8 numerical property that limits how many stack frames to include in an error stacktrace.\n- `Error.prepareStackTrace()` {{non-standard_inline}} {{optional_inline}}\n  - : A non-standard V8 function that, if provided by usercode, is called by the V8 JavaScript engine for thrown exceptions, allowing the user to provide custom formatting for stacktraces.\n\n## Instance properties\n\nThese properties are defined on `Error.prototype` and shared by all `Error` instances.\n\n- {{jsxref("Object/constructor", "Error.prototype.constructor")}}\n  - : The constructor function that created the instance object. For `Error` instances, the initial value is the {{jsxref("Error/Error", "Error")}} constructor.\n- {{jsxref("Error.prototype.name")}}\n  - : Represents the name for the type of error. For `Error.prototype.name`, the initial value is `"Error"`. Subclasses like {{jsxref("TypeError")}} and {{jsxref("SyntaxError")}} provide their own `name` properties.\n- {{jsxref("Error.prototype.stack")}} {{non-standard_inline}}\n  - : A non-standard property for a stack trace.\n\nThese properties are own properties of each `Error` instance.\n\n- {{jsxref("Error/cause", "cause")}}\n  - : Error cause indicating the reason why the current error is thrown \u2014 usually another caught error. For user-created `Error` objects, this is the value provided as the `cause` property of the constructor\'s second argument.\n- {{jsxref("Error/columnNumber", "columnNumber")}} {{non-standard_inline}}\n  - : A non-standard Mozilla property for the column number in the line that raised this error.\n- {{jsxref("Error/fileName", "fileName")}} {{non-standard_inline}}\n  - : A non-standard Mozilla property for the path to the file that raised this error.\n- {{jsxref("Error/lineNumber", "lineNumber")}} {{non-standard_inline}}\n  - : A non-standard Mozilla property for the line number in the file that raised this error.\n- {{jsxref("Error/message", "message")}}\n  - : Error message. For user-created `Error` objects, this is the string provided as the constructor\'s first argument.\n\n## Instance methods\n\n- {{jsxref("Error.prototype.toString()")}}\n  - : Returns a string representing the specified object. Overrides the {{jsxref("Object.prototype.toString()")}} method.\n\n## Examples\n\n### Throwing a generic error\n\nUsually you create an `Error` object with the intention of raising it using the {{jsxref("Statements/throw", "throw")}} keyword.\nYou can handle the error using the {{jsxref("Statements/try...catch", "try...catch")}} construct:\n\n```js\ntry {\n  throw new Error("Whoops!");\n} catch (e) {\n  console.error(`${e.name}: ${e.message}`);\n}\n```\n\n### Handling a specific error type\n\nYou can choose to handle only specific error types by testing the error type with the {{jsxref("Operators/instanceof", "instanceof")}} keyword:\n\n```js\ntry {\n  foo.bar();\n} catch (e) {\n  if (e instanceof EvalError) {\n    console.error(`${e.name}: ${e.message}`);\n  } else if (e instanceof RangeError) {\n    console.error(`${e.name}: ${e.message}`);\n  }\n  // etc.\n  else {\n    // If none of our cases matched leave the Error unhandled\n    throw e;\n  }\n}\n```\n\n### Differentiate between similar errors\n\nSometimes a block of code can fail for reasons that require different handling, but which throw very similar errors (i.e. with the same type and message).\n\nIf you don\'t have control over the original errors that are thrown, one option is to catch them and throw new `Error` objects that have more specific messages.\nThe original error should be passed to the new `Error` in the constructor\'s [`options`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error/Error#options) parameter as its `cause` property. This ensures that the original error and stack trace are available to higher-level try/catch blocks.\n\nThe example below shows this for two methods that would otherwise fail with similar errors (`doFailSomeWay()` and `doFailAnotherWay()`):\n\n```js\nfunction doWork() {\n  try {\n    doFailSomeWay();\n  } catch (err) {\n    throw new Error("Failed in some way", { cause: err });\n  }\n  try {\n    doFailAnotherWay();\n  } catch (err) {\n    throw new Error("Failed in another way", { cause: err });\n  }\n}\n\ntry {\n  doWork();\n} catch (err) {\n  switch (err.message) {\n    case "Failed in some way":\n      handleFailSomeWay(err.cause);\n      break;\n    case "Failed in another way":\n      handleFailAnotherWay(err.cause);\n      break;\n  }\n}\n```\n\n> **Note:** If you are making a library, you should prefer to use error cause to discriminate between different errors emitted \u2014 rather than asking your consumers to parse the error message. See the [error cause page](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error/cause#providing_structured_data_as_the_error_cause) for an example.\n\n[Custom error types](#custom_error_types) can also use the `cause` property, provided the subclasses\' constructor passes the `options` parameter when calling `super()`. The `Error()` base class constructor will read `options.cause` and define the `cause` property on the new error instance.\n\n```js\nclass MyError extends Error {\n  constructor(message, options) {\n    // Need to pass `options` as the second parameter to install the "cause" property.\n    super(message, options);\n  }\n}\n\nconsole.log(new MyError("test", { cause: new Error("cause") }).cause);\n// Error: cause\n```\n\n### Custom error types\n\nYou might want to define your own error types deriving from `Error` to be able to `throw new MyError()` and use `instanceof MyError` to check the kind of error in the exception handler. This results in cleaner and more consistent error handling code.\n\nSee ["What\'s a good way to extend Error in JavaScript?"](https://stackoverflow.com/questions/1382107/whats-a-good-way-to-extend-error-in-javascript) on StackOverflow for an in-depth discussion.\n\n> **Warning:** Builtin subclassing cannot be reliably transpiled to pre-ES6 code, because there\'s no way to construct the base class with a particular `new.target` without {{jsxref("Reflect.construct()")}}. You need [additional configuration](https://github.com/loganfsmyth/babel-plugin-transform-builtin-extend) or manually call {{jsxref("Object/setPrototypeOf", "Object.setPrototypeOf(this, CustomError.prototype)")}} at the end of the constructor; otherwise, the constructed instance will not be a `CustomError` instance. See [the TypeScript FAQ](https://github.com/microsoft/TypeScript/wiki/FAQ#why-doesnt-extending-built-ins-like-error-array-and-map-work) for more information.\n\n> **Note:** Some browsers include the `CustomError` constructor in the stack trace when using ES2015 classes.\n\n```js\nclass CustomError extends Error {\n  constructor(foo = "bar", ...params) {\n    // Pass remaining arguments (including vendor specific ones) to parent constructor\n    super(...params);\n\n    // Maintains proper stack trace for where our error was thrown (only available on V8)\n    if (Error.captureStackTrace) {\n      Error.captureStackTrace(this, CustomError);\n    }\n\n    this.name = "CustomError";\n    // Custom debugging information\n    this.foo = foo;\n    this.date = new Date();\n  }\n}\n\ntry {\n  throw new CustomError("baz", "bazMessage");\n} catch (e) {\n  console.error(e.name); // CustomError\n  console.error(e.foo); // baz\n  console.error(e.message); // bazMessage\n  console.error(e.stack); // stacktrace\n}\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Error` with `cause` support in `core-js`](https://github.com/zloirock/core-js#ecmascript-error)\n- {{jsxref("Statements/throw", "throw")}}\n- {{jsxref("Statements/try...catch", "try...catch")}}\n- [Stack trace API](https://v8.dev/docs/stack-trace-api) in the V8 docs\n',
        "linenumber": {
            "index.md": '---\ntitle: "Error: lineNumber"\nslug: Web/JavaScript/Reference/Global_Objects/Error/lineNumber\npage-type: javascript-instance-data-property\nstatus:\n  - non-standard\nbrowser-compat: javascript.builtins.Error.lineNumber\n---\n\n{{JSRef}} {{Non-standard_Header}}\n\nThe **`lineNumber`** data property of an {{jsxref("Error")}} instance contains the line number in the file that raised this error.\n\n## Value\n\nA positive integer.\n\n{{js_property_attributes(1, 0, 1)}}\n\n## Examples\n\n### Using lineNumber\n\n```js\ntry {\n  throw new Error("Could not parse input");\n} catch (err) {\n  console.log(err.lineNumber); // 2\n}\n```\n\n### Alternative example using error event\n\n```js\nwindow.addEventListener("error", (e) => {\n  console.log(e.lineNumber); // 5\n});\nconst e = new Error("Could not parse input");\nthrow e;\n```\n\nThis is not a standard feature and lacks widespread support. See the browser compatibility table below.\n\n## Specifications\n\nNot part of any standard.\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Error.prototype.stack")}}\n- {{jsxref("Error.prototype.columnNumber")}}\n- {{jsxref("Error.prototype.fileName")}}\n'
        },
        "message": {
            "index.md": '---\ntitle: "Error: message"\nslug: Web/JavaScript/Reference/Global_Objects/Error/message\npage-type: javascript-instance-data-property\nbrowser-compat: javascript.builtins.Error.message\n---\n\n{{JSRef}}\n\nThe **`message`** data property of an {{jsxref("Error")}} instance is a human-readable description of the error.\n\n## Value\n\nA string corresponding to the value passed to the [`Error()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error/Error) constructor as the first argument.\n\n{{js_property_attributes(1, 0, 1)}}\n\n## Description\n\nThis property contains a brief description of the error if one is available or has been set. The `message` property combined with the {{jsxref("Error/name", "name")}} property is used by the {{jsxref("Error.prototype.toString()")}} method to create a string representation of the Error.\n\nBy default, the `message` property is an empty string, but this behavior can be overridden for an instance by specifying a message as the first argument to the {{jsxref("Error/Error", "Error")}} constructor.\n\n## Examples\n\n### Throwing a custom error\n\n```js\nconst e = new Error("Could not parse input");\n// e.message is \'Could not parse input\'\nthrow e;\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Error.prototype.name")}}\n- {{jsxref("Error.prototype.toString()")}}\n'
        },
        "name": {
            "index.md": '---\ntitle: Error.prototype.name\nslug: Web/JavaScript/Reference/Global_Objects/Error/name\npage-type: javascript-instance-data-property\nbrowser-compat: javascript.builtins.Error.name\n---\n\n{{JSRef}}\n\nThe **`name`** data property of `Error.prototype` is shared by all {{jsxref("Error")}} instances. It represents the name for the type of error. For `Error.prototype.name`, the initial value is `"Error"`. Subclasses like {{jsxref("TypeError")}} and {{jsxref("SyntaxError")}} provide their own `name` properties.\n\n## Value\n\nA string. For `Error.prototype.name`, the initial value is `"Error"`.\n\n{{js_property_attributes(1, 0, 1)}}\n\n## Description\n\nBy default, {{jsxref("Error")}} instances are given the name "Error". The `name` property, in addition to the {{jsxref("Error/message", "message")}} property, is used by the {{jsxref("Error.prototype.toString()")}} method to create a string representation of the error.\n\n## Examples\n\n### Throwing a custom error\n\n```js\nconst e = new Error("Malformed input"); // e.name is \'Error\'\n\ne.name = "ParseError";\nthrow e;\n// e.toString() would return \'ParseError: Malformed input\'\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Error.prototype.message")}}\n- {{jsxref("Error.prototype.toString()")}}\n'
        },
        "stack": {
            "index.md": '---\ntitle: Error.prototype.stack\nslug: Web/JavaScript/Reference/Global_Objects/Error/stack\npage-type: javascript-instance-data-property\nstatus:\n  - non-standard\nbrowser-compat: javascript.builtins.Error.stack\n---\n\n{{JSRef}} {{Non-standard_Header}}\n\n> **Note:** The `stack` property is de facto implemented by all major JavaScript engines, and [the JavaScript standards committee is looking to standardize it](https://github.com/tc39/proposal-error-stacks). You cannot rely on the precise content of the stack string due to implementation inconsistencies, but you can generally assume it exists and use it for debugging purposes.\n\nThe non-standard **`stack`** property of an {{jsxref("Error")}} instance offers a trace of which functions were called, in what order, from which line and file, and with what arguments. The stack string proceeds from the most recent calls to earlier ones, leading back to the original global scope call.\n\n## Value\n\nA string.\n\nBecause the `stack` property is non-standard, implementations differ about where it\'s installed.\n\n- In Firefox, it\'s an accessor property on `Error.prototype`.\n- In Chrome and Safari, it\'s a data property on each `Error` instance, with the descriptor:\n\n{{js_property_attributes(1, 0, 1)}}\n\n## Description\n\nEach JavaScript engine uses its own format for stack traces, but they are fairly consistent in their high-level structure. Every implementation uses a separate line in the stack to represent each function call. The call that directly caused the error is placed at the top, and the call that started the whole call chain is placed at the bottom. Below are some examples of stack traces:\n\n```js\nfunction foo() {\n  bar();\n}\n\nfunction bar() {\n  baz();\n}\n\nfunction baz() {\n  console.log(new Error().stack);\n}\n\nfoo();\n```\n\n```plain\n#### JavaScriptCore\nbaz@filename.js:10:24\nbar@filename.js:6:6\nfoo@filename.js:2:6\nglobal code@filename.js:13:4\n\n#### SpiderMonkey\nbaz@filename.js:10:15\nbar@filename.js:6:3\nfoo@filename.js:2:3\n@filename.js:13:1\n\n#### V8\nError\n    at baz (filename.js:10:15)\n    at bar (filename.js:6:3)\n    at foo (filename.js:2:3)\n    at filename.js:13:1\n```\n\nDifferent engines set this value at different times. Most modern engines set it when the {{jsxref("Error")}} object is created. This means you can get the full call stack information within a function using the following:\n\n```js\nfunction foo() {\n  console.log(new Error().stack);\n}\n```\n\nWithout having to throw an error and then catch it.\n\nIn V8, the non-standard `Error.captureStackTrace()`, `Error.stackTraceLimit`, and `Error.prepareStackTrace()` APIs can be used to customize the stack trace. Read the [Stack trace API](https://v8.dev/docs/stack-trace-api) in the V8 docs for more information.\n\nStack frames can be things other than explicit function calls, too. For example, event listeners, timeout jobs, and promise handlers all begin their own call chain. Source code within {{jsxref("Global_Objects/eval", "eval()")}} and {{jsxref("Function")}} constructor calls also appear in the stack:\n\n```js\nconsole.log(new Function("return new Error(\'Function failed\')")().stack);\nconsole.log("====");\nconsole.log(eval("new Error(\'eval failed\')").stack);\n```\n\n```plain\n#### JavaScriptCore\nanonymous@\nglobal code@filename.js:1:65\n====\neval code@\neval@[native code]\nglobal code@filename.js:3:17\n\n#### SpiderMonkey\nanonymous@filename.js line 1 > Function:1:8\n@filename.js:1:65\n\n====\n@filename.js line 3 > eval:1:1\n@filename.js:3:13\n\n#### V8\nError: Function failed\n    at eval (eval at <anonymous> (filename.js:1:13), <anonymous>:1:8)\n    at filename.js:1:65\n====\nError: eval failed\n    at eval (eval at <anonymous> (filename.js:3:13), <anonymous>:1:1)\n    at filename.js:3:13\n```\n\nIn Firefox, you can use the `//# sourceURL` directive to name an eval source. See the Firefox [Debug eval sources](https://firefox-source-docs.mozilla.org/devtools-user/debugger/how_to/debug_eval_sources/index.html) docs and the [Naming `eval` Scripts with the `//# sourceURL` Directive](https://fitzgeraldnick.com/2014/12/05/name-eval-scripts.html) blog post for more details.\n\n## Examples\n\n### Using the stack property\n\nThe following script demonstrates how to use the `stack` property to output a stack trace into your browser window. You can use this to check what your browser\'s stack structure looks like.\n\n```html hidden\n<div id="output"></div>\n```\n\n```css hidden\n#output {\n  white-space: pre;\n  font-family: monospace;\n}\n```\n\n```js\nfunction trace() {\n  throw new Error("trace() failed");\n}\nfunction b() {\n  trace();\n}\nfunction a() {\n  b(3, 4, "\\n\\n", undefined, {});\n}\ntry {\n  a("first call, firstarg");\n} catch (e) {\n  document.getElementById("output").textContent = e.stack;\n}\n```\n\n{{EmbedLiveSample("Using_the_stack_property", "700", "200")}}\n\n## Specifications\n\nNot part of any standard.\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [TraceKit](https://github.com/csnover/TraceKit/) on GitHub\n- [stacktrace.js](https://github.com/stacktracejs/stacktrace.js) on GitHub\n- [Stack trace API](https://v8.dev/docs/stack-trace-api) in the V8 docs\n'
        },
        "tostring": {
            "index.md": '---\ntitle: Error.prototype.toString()\nslug: Web/JavaScript/Reference/Global_Objects/Error/toString\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Error.toString\n---\n\n{{JSRef}}\n\nThe **`toString()`** method of {{jsxref("Error")}} instances returns a string representing this error.\n\n## Syntax\n\n```js-nolint\ntoString()\n```\n\n### Parameters\n\nNone.\n\n### Return value\n\nA string representing the specified {{jsxref("Error")}} object.\n\n## Description\n\nThe {{jsxref("Error")}} object overrides the {{jsxref("Object.prototype.toString()")}}\nmethod inherited by all objects. Its semantics are as follows:\n\n```js\nError.prototype.toString = function () {\n  if (\n    this === null ||\n    (typeof this !== "object" && typeof this !== "function")\n  ) {\n    throw new TypeError();\n  }\n  let name = this.name;\n  name = name === undefined ? "Error" : `${name}`;\n  let msg = this.message;\n  msg = msg === undefined ? "" : `${msg}`;\n  if (name === "") {\n    return msg;\n  }\n  if (msg === "") {\n    return name;\n  }\n  return `${name}: ${msg}`;\n};\n```\n\n## Examples\n\n### Using toString()\n\n```js\nconst e1 = new Error("fatal error");\nconsole.log(e1.toString()); // "Error: fatal error"\n\nconst e2 = new Error("fatal error");\ne2.name = undefined;\nconsole.log(e2.toString()); // "Error: fatal error"\n\nconst e3 = new Error("fatal error");\ne3.name = "";\nconsole.log(e3.toString()); // "fatal error"\n\nconst e4 = new Error("fatal error");\ne4.name = "";\ne4.message = undefined;\nconsole.log(e4.toString()); // ""\n\nconst e5 = new Error("fatal error");\ne5.name = "hello";\ne5.message = undefined;\nconsole.log(e5.toString()); // "hello"\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Error.prototype.toString` with many bug fixes in `core-js`](https://github.com/zloirock/core-js#ecmascript-error)\n'
        }
    },
    "escape": {
        "index.md": '---\ntitle: escape()\nslug: Web/JavaScript/Reference/Global_Objects/escape\npage-type: javascript-function\nstatus:\n  - deprecated\nbrowser-compat: javascript.builtins.escape\n---\n\n{{jsSidebar("Objects")}}{{Deprecated_Header}}\n\n> **Note:** `escape()` is a non-standard function implemented by browsers and was only standardized for cross-engine compatibility. It is not required to be implemented by all JavaScript engines and may not work everywhere. Use {{jsxref("encodeURIComponent()")}} or {{jsxref("encodeURI()")}} if possible.\n\nThe **`escape()`** function computes a new string in which certain characters have been replaced by hexadecimal escape sequences.\n\n## Syntax\n\n```js-nolint\nescape(str)\n```\n\n### Parameters\n\n- `str`\n  - : A string to be encoded.\n\n### Return value\n\nA new string in which certain characters have been escaped.\n\n## Description\n\n`escape()` is a function property of the global object.\n\nThe `escape()` function replaces all characters with escape sequences, with the exception of {{Glossary("ASCII")}} word characters (A\u2013Z, a\u2013z, 0\u20139, \\_) and `@\\*_+-./`. Characters are escaped by UTF-16 code units. If the code unit\'s value is less than 256, it is represented by a two-digit hexadecimal number in the format `%XX`, left-padded with 0 if necessary. Otherwise, it is represented by a four-digit hexadecimal number in the format `%uXXXX`, left-padded with 0 if necessary.\n\n> **Note:** This function was used mostly for [URL encoding](https://en.wikipedia.org/wiki/URL_encoding) and is partly based on the escape format in {{rfc(1738)}}. The escape format is _not_ an [escape sequence](/en-US/docs/Web/JavaScript/Reference/Lexical_grammar#escape_sequences) in string literals. You can replace `%XX` with `\\xXX` and `%uXXXX` with `\\uXXXX` to get a string containing actual string-literal escape sequences.\n\n## Examples\n\n### Using escape()\n\n```js\nescape("abc123"); // "abc123"\nescape("\xe4\xf6\xfc"); // "%E4%F6%FC"\nescape("\u0107"); // "%u0107"\n\n// special characters\nescape("@*_+-./"); // "@*_+-./"\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `escape` in `core-js`](https://github.com/zloirock/core-js#ecmascript-string-and-regexp)\n- {{jsxref("encodeURI")}}\n- {{jsxref("encodeURIComponent")}}\n- {{jsxref("unescape")}}\n'
    },
    "eval": {
        "index.md": '---\ntitle: eval()\nslug: Web/JavaScript/Reference/Global_Objects/eval\npage-type: javascript-function\nbrowser-compat: javascript.builtins.eval\n---\n\n{{jsSidebar("Objects")}}\n\n> **Warning:** Executing JavaScript from a string is an enormous security risk. It is far too easy for a bad actor to run arbitrary code when you use `eval()`. See [Never use eval()!](#never_use_eval!), below.\n\nThe **`eval()`** function evaluates JavaScript code represented as a string and returns its completion value. The source is parsed as a script.\n\n{{EmbedInteractiveExample("pages/js/globalprops-eval.html")}}\n\n## Syntax\n\n```js-nolint\neval(script)\n```\n\n### Parameters\n\n- `script`\n  - : A string representing a JavaScript expression, statement, or sequence of statements. The expression can include variables and properties of existing objects. It will be parsed as a script, so [`import`](/en-US/docs/Web/JavaScript/Reference/Statements/import) declarations (which can only exist in modules) are not allowed.\n\n### Return value\n\nThe completion value of evaluating the given code. If the completion value is empty, {{jsxref("undefined")}} is returned. If `script` is not a string primitive, `eval()` returns the argument unchanged.\n\n### Exceptions\n\nThrows any exception that occurs during evaluation of the code, including {{jsxref("SyntaxError")}} if `script` fails to be parsed as a script.\n\n## Description\n\n`eval()` is a function property of the global object.\n\nThe argument of the `eval()` function is a string. It will evaluate the source string as a script body, which means both statements and expressions are allowed. It returns the completion value of the code. For expressions, it\'s the value the expression evaluates to. Many statements and declarations have completion values as well, but the result may be surprising (for example, the completion value of an assignment is the assigned value, but the completion value of [`let`](/en-US/docs/Web/JavaScript/Reference/Statements/let) is undefined), so it\'s recommended to not rely on statements\' completion values.\n\nIn strict mode, declaring a variable named `eval` or re-assigning `eval` is a {{jsxref("SyntaxError")}}.\n\n```js-nolint example-bad\n"use strict";\n\nconst eval = 1; // SyntaxError: Unexpected eval or arguments in strict mode\n```\n\nIf the argument of `eval()` is not a string, `eval()` returns the argument unchanged. In the following example, passing a `String` object instead of a primitive causes `eval()` to return the `String` object rather than evaluating the string.\n\n```js\neval(new String("2 + 2")); // returns a String object containing "2 + 2"\neval("2 + 2"); // returns 4\n```\n\nTo work around the issue in a generic fashion, you can [coerce the argument to a string](/en-US/docs/Web/JavaScript/Reference/Global_Objects/String#string_coercion) yourself before passing it to `eval()`.\n\n```js\nconst expression = new String("2 + 2");\neval(String(expression)); // returns 4\n```\n\n### Direct and indirect eval\n\nThere are two modes of `eval()` calls: _direct_ eval and _indirect_ eval. Direct eval, as the name implies, refers to _directly_ calling the global `eval` function with `eval(...)`. Everything else, including invoking it via an aliased variable, via a member access or other expression, or through the optional chaining [`?.`](/en-US/docs/Web/JavaScript/Reference/Operators/Optional_chaining) operator, is indirect.\n\n```js\n// Direct call\neval("x + y");\n\n// Indirect call using the comma operator to return eval\n(0, eval)("x + y");\n\n// Indirect call through optional chaining\neval?.("x + y");\n\n// Indirect call using a variable to store and return eval\nconst geval = eval;\ngeval("x + y");\n\n// Indirect call through member access\nconst obj = { eval };\nobj.eval("x + y");\n```\n\nIndirect eval can be seen as if the code is evaluated within a separate `<script>` tag. This means:\n\n- Indirect eval works in the global scope rather than the local scope, and the code being evaluated doesn\'t have access to local variables within the scope where it\'s being called.\n\n  ```js\n  function test() {\n    const x = 2;\n    const y = 4;\n    // Direct call, uses local scope\n    console.log(eval("x + y")); // Result is 6\n    console.log(eval?.("x + y")); // Uses global scope, throws because x is undefined\n  }\n  ```\n\n- Indirect `eval` would not inherit the strictness of the surrounding context, and would only be in [strict mode](/en-US/docs/Web/JavaScript/Reference/Strict_mode) if the source string itself has a `"use strict"` directive.\n\n  ```js\n  function strictContext() {\n    "use strict";\n    eval?.(`with (Math) console.log(PI);`);\n  }\n  function strictContextStrictEval() {\n    "use strict";\n    eval?.(`"use strict"; with (Math) console.log(PI);`);\n  }\n  strictContext(); // Logs 3.141592653589793\n  strictContextStrictEval(); // Throws a SyntaxError because the source string is in strict mode\n  ```\n\n  On the other hand, direct eval inherits the strictness of the invoking context.\n\n  ```js\n  function nonStrictContext() {\n    eval(`with (Math) console.log(PI);`);\n  }\n  function strictContext() {\n    "use strict";\n    eval(`with (Math) console.log(PI);`);\n  }\n  nonStrictContext(); // Logs 3.141592653589793\n  strictContext(); // Throws a SyntaxError because it\'s in strict mode\n  ```\n\n- `var`-declared variables and [function declarations](/en-US/docs/Web/JavaScript/Reference/Statements/function) would go into the surrounding scope if the source string is not interpreted in strict mode \u2014 for indirect eval, they become global variables. If it\'s a direct eval in a strict mode context, or if the `eval` source string itself is in strict mode, then `var` and function declarations do not "leak" into the surrounding scope.\n\n  ```js\n  // Neither context nor source string is strict,\n  // so var creates a variable in the surrounding scope\n  eval("var a = 1;");\n  console.log(a); // 1\n  // Context is not strict, but eval source is strict,\n  // so b is scoped to the evaluated script\n  eval("\'use strict\'; var b = 1;");\n  console.log(b); // ReferenceError: b is not defined\n\n  function strictContext() {\n    "use strict";\n    // Context is strict, but this is indirect and the source\n    // string is not strict, so c is still global\n    eval?.("var c = 1;");\n    // Direct eval in a strict context, so d is scoped\n    eval("var d = 1;");\n  }\n  strictContext();\n  console.log(c); // 1\n  console.log(d); // ReferenceError: d is not defined\n  ```\n\n  [`let`](/en-US/docs/Web/JavaScript/Reference/Statements/let) and [`const`](/en-US/docs/Web/JavaScript/Reference/Statements/const) declarations within the evaluated string are always scoped to that script.\n\n- Direct eval may have access to additional contextual expressions. For example, in a function\'s body, one can use [`new.target`](/en-US/docs/Web/JavaScript/Reference/Operators/new.target):\n\n  ```js\n  function Ctor() {\n    eval("console.log(new.target)");\n  }\n  new Ctor(); // [Function: Ctor]\n  ```\n\n### Never use eval()!\n\nUsing direct `eval()` suffers from multiple problems:\n\n- `eval()` executes the code it\'s passed with the privileges of the caller. If you run `eval()` with a string that could be affected by a malicious party, you may end up running malicious code on the user\'s machine with the permissions of your webpage / extension. More importantly, allowing third-party code to access the scope in which `eval()` was invoked (if it\'s a direct eval) can lead to possible attacks that reads or changes local variables.\n- `eval()` is slower than the alternatives, since it has to invoke the JavaScript interpreter, while many other constructs are optimized by modern JS engines.\n- Modern JavaScript interpreters convert JavaScript to machine code. This means that any concept of variable naming gets obliterated. Thus, any use of `eval()` will force the browser to do long expensive variable name lookups to figure out where the variable exists in the machine code and set its value. Additionally, new things can be introduced to that variable through `eval()`, such as changing the type of that variable, forcing the browser to re-evaluate all of the generated machine code to compensate.\n- Minifiers give up on any minification if the scope is transitively depended on by `eval()`, because otherwise `eval()` cannot read the correct variable at runtime.\n\nThere are many cases where the use of `eval()` or related methods can be optimized or avoided altogether.\n\n#### Using indirect eval()\n\nConsider this code:\n\n```js\nfunction looseJsonParse(obj) {\n  return eval(`(${obj})`);\n}\nconsole.log(looseJsonParse("{ a: 4 - 1, b: function () {}, c: new Date() }"));\n```\n\nSimply using indirect eval and forcing strict mode can make the code much better:\n\n```js\nfunction looseJsonParse(obj) {\n  return eval?.(`"use strict";(${obj})`);\n}\nconsole.log(looseJsonParse("{ a: 4 - 1, b: function () {}, c: new Date() }"));\n```\n\nThe two code snippets above may seem to work the same way, but they do not; the first one using direct eval suffers from multiple problems.\n\n- It is a great deal slower, due to more scope inspections. Notice `c: new Date()` in the evaluated string. In the indirect eval version, the object is being evaluated in the global scope, so it is safe for the interpreter to assume that `Date` refers to the global `Date()` constructor instead of a local variable called `Date`. However, in the code using direct eval, the interpreter cannot assume this. For example, in the following code, `Date` in the evaluated string doesn\'t refer to `window.Date()`.\n\n  ```js\n  function looseJsonParse(obj) {\n    function Date() {}\n    return eval(`(${obj})`);\n  }\n  console.log(looseJsonParse(`{ a: 4 - 1, b: function () {}, c: new Date() }`));\n  ```\n\n  Thus, in the `eval()` version of the code, the browser is forced to make the expensive lookup call to check to see if there are any local variables called `Date()`.\n\n- If not using strict mode, `var` declarations within the `eval()` source becomes variables in the surrounding scope. This leads to hard-to-debug issues if the string is acquired from external input, especially if there\'s an existing variable with the same name.\n- Direct eval can read and mutate bindings in the surrounding scope, which may lead to external input corrupting local data.\n- When using direct `eval`, especially when the eval source cannot be proven to be in strict mode, the engine \u2014 and build tools \u2014 have to disable all optimizations related to inlining, because the `eval()` source can depend on any variable name in its surrounding scope.\n\nHowever, using indirect `eval()` does not allow passing extra bindings other than existing global variables for the evaluated source to read. If you need to specify additional variables that the evaluated source should have access to, consider using the `Function()` constructor.\n\n#### Using the Function() constructor\n\nThe [`Function()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function) constructor is very similar to the indirect eval example above: it also evaluates the JavaScript source passed to it in the global scope without reading or mutating any local bindings, and therefore allows engines to do more optimizations than direct `eval()`.\n\nThe difference between `eval()` and `Function()` is that the source string passed to `Function()` is parsed as a function body, not as a script. There are a few nuances \u2014 for example, you can use `return` statements at the top level of a function body, but not in a script.\n\nThe `Function()` constructor is useful if you wish to create local bindings within your eval source, by passing the variables as parameter bindings.\n\n```js\nfunction Date(n) {\n  return [\n    "Monday",\n    "Tuesday",\n    "Wednesday",\n    "Thursday",\n    "Friday",\n    "Saturday",\n    "Sunday",\n  ][n % 7 || 0];\n}\nfunction runCodeWithDateFunction(obj) {\n  return Function("Date", `"use strict";return (${obj});`)(Date);\n}\nconsole.log(runCodeWithDateFunction("Date(5)")); // Saturday\n```\n\nBoth `eval()` and `Function()` implicitly evaluate arbitrary code, and are forbidden in strict [CSP](/en-US/docs/Web/HTTP/CSP) settings. There are also additional safer (and faster!) alternatives to `eval()` or `Function()` for common use-cases.\n\n#### Using bracket accessors\n\nYou should not use `eval()` to access properties dynamically. Consider the following example where the property of the object to be accessed is not known until the code is executed. This can be done with `eval()`:\n\n```js\nconst obj = { a: 20, b: 30 };\nconst propName = getPropName(); // returns "a" or "b"\n\nconst result = eval(`obj.${propName}`);\n```\n\nHowever, `eval()` is not necessary here \u2014 in fact, it\'s more error-prone, because if `propName` is not a valid identifier, it leads to a syntax error. Moreover, if `getPropName` is not a function you control, this may lead to execution of arbitrary code. Instead, use the [property accessors](/en-US/docs/Web/JavaScript/Reference/Operators/Property_accessors), which are much faster and safer:\n\n```js\nconst obj = { a: 20, b: 30 };\nconst propName = getPropName(); // returns "a" or "b"\nconst result = obj[propName]; // obj["a"] is the same as obj.a\n```\n\nYou can even use this method to access descendant properties. Using `eval()`, this would look like:\n\n```js\nconst obj = { a: { b: { c: 0 } } };\nconst propPath = getPropPath(); // suppose it returns "a.b.c"\n\nconst result = eval(`obj.${propPath}`); // 0\n```\n\nAvoiding `eval()` here could be done by splitting the property path and looping through the different properties:\n\n```js\nfunction getDescendantProp(obj, desc) {\n  const arr = desc.split(".");\n  while (arr.length) {\n    obj = obj[arr.shift()];\n  }\n  return obj;\n}\n\nconst obj = { a: { b: { c: 0 } } };\nconst propPath = getPropPath(); // suppose it returns "a.b.c"\nconst result = getDescendantProp(obj, propPath); // 0\n```\n\nSetting a property that way works similarly:\n\n```js\nfunction setDescendantProp(obj, desc, value) {\n  const arr = desc.split(".");\n  while (arr.length > 1) {\n    obj = obj[arr.shift()];\n  }\n  return (obj[arr[0]] = value);\n}\n\nconst obj = { a: { b: { c: 0 } } };\nconst propPath = getPropPath(); // suppose it returns "a.b.c"\nconst result = setDescendantProp(obj, propPath, 1); // obj.a.b.c is now 1\n```\n\nHowever, beware that using bracket accessors with unconstrained input is not safe either \u2014 it may lead to [object injection attacks](https://github.com/nodesecurity/eslint-plugin-security/blob/main/docs/the-dangers-of-square-bracket-notation.md).\n\n#### Using callbacks\n\nJavaScript has [first-class functions](/en-US/docs/Glossary/First-class_Function), which means you can pass functions as arguments to other APIs, store them in variables and objects\' properties, and so on. Many DOM APIs are designed with this in mind, so you can (and should) write:\n\n```js\n// Instead of setTimeout("\u2026", 1000) use:\nsetTimeout(() => {\n  // \u2026\n}, 1000);\n\n// Instead of elt.setAttribute("onclick", "\u2026") use:\nelt.addEventListener("click", () => {\n  // \u2026\n});\n```\n\n[Closures](/en-US/docs/Web/JavaScript/Closures) are also helpful as a way to create parameterized functions without concatenating strings.\n\n#### Using JSON\n\nIf the string you\'re calling `eval()` on contains data (for example, an array: `"[1, 2, 3]"`), as opposed to code, you should consider switching to {{Glossary("JSON")}}, which allows the string to use a subset of JavaScript syntax to represent data.\n\nNote that since JSON syntax is limited compared to JavaScript syntax, many valid JavaScript literals will not parse as JSON. For example, trailing commas are not allowed in JSON, and property names (keys) in object literals must be enclosed in quotes. Be sure to use a JSON serializer to generate strings that will be later parsed as JSON.\n\nPassing carefully constrained data instead of arbitrary code is a good idea in general. For example, an extension designed to scrape contents of web-pages could have the scraping rules defined in [XPath](/en-US/docs/Web/XPath) instead of JavaScript code.\n\n## Examples\n\n### Using eval()\n\nIn the following code, both of the statements containing `eval()` return 42.\nThe first evaluates the string `"x + y + 1"`; the second evaluates the string\n`"42"`.\n\n```js\nconst x = 2;\nconst y = 39;\nconst z = "42";\neval("x + y + 1"); // 42\neval(z); // 42\n```\n\n### eval() returns the completion value of statements\n\n`eval()` returns the completion value of statements. For `if`, it would be the last expression or statement evaluated.\n\n```js\nconst str = "if (a) { 1 + 1 } else { 1 + 2 }";\nlet a = true;\nlet b = eval(str);\n\nconsole.log(`b is: ${b}`); // b is: 2\n\na = false;\nb = eval(str);\n\nconsole.log(`b is: ${b}`); // b is: 3\n```\n\nThe following example uses `eval()` to evaluate the string `str`. This string consists of JavaScript statements that assign `z` a value of 42 if `x` is five, and assign 0 to `z` otherwise. When the second statement is executed, `eval()` will cause these statements to be performed, and it will also evaluate the set of statements and return the value that is assigned to `z`, because the completion value of an assignment is the assigned value.\n\n```js\nconst x = 5;\nconst str = `if (x === 5) {\n  console.log("z is 42");\n  z = 42;\n} else {\n  z = 0;\n}`;\n\nconsole.log("z is ", eval(str)); // z is 42  z is 42\n```\n\nIf you assign multiple values then the last value is returned.\n\n```js\nlet x = 5;\nconst str = `if (x === 5) {\n  console.log("z is 42");\n  z = 42;\n  x = 420;\n} else {\n  z = 0;\n}`;\n\nconsole.log("x is", eval(str)); // z is 42  x is 420\n```\n\n### eval() as a string defining function requires "(" and ")" as prefix and suffix\n\n```js\n// This is a function declaration\nconst fctStr1 = "function a() {}";\n// This is a function expression\nconst fctStr2 = "(function b() {})";\nconst fct1 = eval(fctStr1); // return undefined, but `a` is available as a global function now\nconst fct2 = eval(fctStr2); // return the function `b`\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Property accessors](/en-US/docs/Web/JavaScript/Reference/Operators/Property_accessors)\n- [WebExtensions: Using eval in content scripts](/en-US/docs/Mozilla/Add-ons/WebExtensions/Content_scripts#using_eval_in_content_scripts)\n'
    },
    "evalerror": {
        "evalerror": {
            "index.md": '---\ntitle: EvalError() constructor\nslug: Web/JavaScript/Reference/Global_Objects/EvalError/EvalError\npage-type: javascript-constructor\nbrowser-compat: javascript.builtins.EvalError.EvalError\n---\n\n{{JSRef}}\n\nThe **`EvalError()`** constructor creates {{jsxref("EvalError")}} objects.\n\n## Syntax\n\n```js-nolint\nnew EvalError()\nnew EvalError(message)\nnew EvalError(message, options)\nnew EvalError(message, fileName)\nnew EvalError(message, fileName, lineNumber)\n\nEvalError()\nEvalError(message)\nEvalError(message, options)\nEvalError(message, fileName)\nEvalError(message, fileName, lineNumber)\n```\n\n> **Note:** `EvalError()` can be called with or without [`new`](/en-US/docs/Web/JavaScript/Reference/Operators/new). Both create a new `EvalError` instance.\n\n### Parameters\n\n- `message` {{optional_inline}}\n  - : Human-readable description of the error.\n- `options` {{optional_inline}}\n  - : An object that has the following properties:\n    - `cause` {{optional_inline}}\n      - : A property indicating the specific cause of the error.\n        When catching and re-throwing an error with a more-specific or useful error message, this property can be used to pass the original error.\n- `fileName` {{optional_inline}} {{non-standard_inline}}\n  - : The name of the file containing the code that caused the exception\n- `lineNumber` {{optional_inline}} {{non-standard_inline}}\n  - : The line number of the code that caused the exception\n\n## Examples\n\n`EvalError` is not used in the current ECMAScript specification and will\nthus not be thrown by the runtime. However, the object itself remains for backwards\ncompatibility with earlier versions of the specification.\n\n### Creating an EvalError\n\n```js\ntry {\n  throw new EvalError("Hello");\n} catch (e) {\n  console.log(e instanceof EvalError); // true\n  console.log(e.message); // "Hello"\n  console.log(e.name); // "EvalError"\n  console.log(e.stack); // Stack of the error\n}\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Error")}}\n- {{jsxref("Global_Objects/eval", "eval()")}}\n'
        },
        "index.md": '---\ntitle: EvalError\nslug: Web/JavaScript/Reference/Global_Objects/EvalError\npage-type: javascript-class\nbrowser-compat: javascript.builtins.EvalError\n---\n\n{{JSRef}}\n\nThe **`EvalError`** object indicates an error regarding the global {{jsxref("Global_Objects/eval", "eval()")}} function. This exception is not thrown by JavaScript anymore, however the `EvalError` object remains for compatibility.\n\n`EvalError` is a {{Glossary("serializable object")}}, so it can be cloned with {{domxref("structuredClone()")}} or copied between [Workers](/en-US/docs/Web/API/Worker) using {{domxref("Worker/postMessage()", "postMessage()")}}.\n\n`EvalError` is a subclass of {{jsxref("Error")}}.\n\n## Constructor\n\n- {{jsxref("EvalError/EvalError", "EvalError()")}}\n  - : Creates a new `EvalError` object.\n\n## Instance properties\n\n_Also inherits instance properties from its parent {{jsxref("Error")}}_.\n\nThese properties are defined on `EvalError.prototype` and shared by all `EvalError` instances.\n\n- {{jsxref("Object/constructor", "EvalError.prototype.constructor")}}\n  - : The constructor function that created the instance object. For `EvalError` instances, the initial value is the {{jsxref("EvalError/EvalError", "EvalError")}} constructor.\n- {{jsxref("Error/name", "EvalError.prototype.name")}}\n  - : Represents the name for the type of error. For `EvalError.prototype.name`, the initial value is `"EvalError"`.\n\n## Instance methods\n\n_Inherits instance methods from its parent {{jsxref("Error")}}_.\n\n## Examples\n\n### Creating an EvalError\n\n```js\ntry {\n  throw new EvalError("Hello");\n} catch (e) {\n  console.log(e instanceof EvalError); // true\n  console.log(e.message); // "Hello"\n  console.log(e.name); // "EvalError"\n  console.log(e.stack); // Stack of the error\n}\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Error")}}\n- {{jsxref("Global_Objects/eval", "eval()")}}\n'
    },
    "finalizationregistry": {
        "finalizationregistry": {
            "index.md": '---\ntitle: FinalizationRegistry() constructor\nslug: Web/JavaScript/Reference/Global_Objects/FinalizationRegistry/FinalizationRegistry\npage-type: javascript-constructor\nbrowser-compat: javascript.builtins.FinalizationRegistry.FinalizationRegistry\n---\n\n{{JSRef}}\n\nThe **`FinalizationRegistry()`** constructor creates {{jsxref("FinalizationRegistry")}} objects.\n\n## Syntax\n\n```js-nolint\nnew FinalizationRegistry(callbackFn)\n```\n\n> **Note:** `FinalizationRegistry()` can only be constructed with [`new`](/en-US/docs/Web/JavaScript/Reference/Operators/new). Attempting to call it without `new` throws a {{jsxref("TypeError")}}.\n\n### Parameters\n\n- `callback`\n  - : A function to be invoked each time a registered target value is garbage collected. Its return value is ignored. The function is called with the following arguments:\n    - `heldValue`\n      - : The value that was passed to the second parameter of the {{jsxref("FinalizationRegistry/register", "register()")}} method when the `target` object was registered.\n\n## Examples\n\n### Creating a new registry\n\nYou create the registry passing in the callback:\n\n```js\nconst registry = new FinalizationRegistry((heldValue) => {\n  // \u2026\n});\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("FinalizationRegistry")}}\n'
        },
        "index.md": '---\ntitle: FinalizationRegistry\nslug: Web/JavaScript/Reference/Global_Objects/FinalizationRegistry\npage-type: javascript-class\nbrowser-compat: javascript.builtins.FinalizationRegistry\n---\n\n{{JSRef}}\n\nA **`FinalizationRegistry`** object lets you request a callback when a value is garbage-collected.\n\n## Description\n\n`FinalizationRegistry` provides a way to request that a _cleanup callback_ get called at some point when a value registered with the registry has been _reclaimed_ (garbage-collected). (Cleanup callbacks are sometimes called _finalizers_.)\n\n> **Note:** Cleanup callbacks should not be used for essential program logic. See [Notes on cleanup callbacks](#notes_on_cleanup_callbacks) for details.\n\nYou create the registry passing in the callback:\n\n```js\nconst registry = new FinalizationRegistry((heldValue) => {\n  // \u2026\n});\n```\n\nThen you register any value you want a cleanup callback for by calling the `register` method, passing in the value and a _held value_ for it:\n\n```js\nregistry.register(target, "some value");\n```\n\nThe registry does not keep a strong reference to the value, as that would defeat the purpose (if the registry held it strongly, the value would never be reclaimed). In JavaScript, objects and [non-registered symbols](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#shared_symbols_in_the_global_symbol_registry) are garbage collectable, so they can be registered in a `FinalizationRegistry` object as the target or the token.\n\nIf `target` is reclaimed, your cleanup callback may be called at some point with the _held value_ you provided for it (`"some value"` in the above). The held value can be any value you like: a primitive or an object, even `undefined`. If the held value is an object, the registry keeps a _strong_ reference to it (so it can pass it to your cleanup callback later).\n\nIf you might want to unregister a registered target value later, you pass a third value, which is the _unregistration token_ you\'ll use later when calling the registry\'s `unregister` function to unregister the value. The registry only keeps a weak reference to the unregister token.\n\nIt\'s common to use the target value itself as the unregister token, which is just fine:\n\n```js\nregistry.register(target, "some value", target);\n// \u2026\n\n// some time later, if you don\'t care about `target` anymore, unregister it\nregistry.unregister(target);\n```\n\nIt doesn\'t have to be the same value, though; it can be a different one:\n\n```js\nregistry.register(target, "some value", token);\n// \u2026\n\n// some time later\nregistry.unregister(token);\n```\n\n### Avoid where possible\n\nCorrect use of `FinalizationRegistry` takes careful thought, and it\'s best avoided if possible. It\'s also important to avoid relying on any specific behaviors not guaranteed by the specification. When, how, and whether garbage collection occurs is down to the implementation of any given JavaScript engine. Any behavior you observe in one engine may be different in another engine, in another version of the same engine, or even in a slightly different situation with the same version of the same engine. Garbage collection is a hard problem that JavaScript engine implementers are constantly refining and improving their solutions to.\n\nHere are some specific points included by the authors in the [proposal](https://github.com/tc39/proposal-weakrefs) that introduced `FinalizationRegistry`:\n\n> [Garbage collectors](<https://en.wikipedia.org/wiki/Garbage_collection_(computer_science)>) are complicated. If an application or library depends on GC cleaning up a WeakRef or calling a finalizer \\[cleanup callback] in a timely, predictable manner, it\'s likely to be disappointed: the cleanup may happen much later than expected, or not at all. Sources of variability include:\n>\n> - One object might be garbage-collected much sooner than another object, even if they become unreachable at the same time, e.g., due to generational collection.\n> - Garbage collection work can be split up over time using incremental and concurrent techniques.\n> - Various runtime heuristics can be used to balance memory usage, responsiveness.\n> - The JavaScript engine may hold references to things which look like they are unreachable (e.g., in closures, or inline caches).\n> - Different JavaScript engines may do these things differently, or the same engine may change its algorithms across versions.\n> - Complex factors may lead to objects being held alive for unexpected amounts of time, such as use with certain APIs.\n\n### Notes on cleanup callbacks\n\n- Developers shouldn\'t rely on cleanup callbacks for essential program logic. Cleanup callbacks may be useful for reducing memory usage across the course of a program, but are unlikely to be useful otherwise.\n- If your code has just registered a value to the registry, that target will not be reclaimed until the end of the current JavaScript [job](https://tc39.es/ecma262/multipage/executable-code-and-execution-contexts.html#job). See [notes on WeakRefs](/en-US/docs/Web/JavaScript/Reference/Global_Objects/WeakRef#notes_on_weakrefs) for details.\n- A conforming JavaScript implementation, even one that does garbage collection, is not required to call cleanup callbacks. When and whether it does so is entirely down to the implementation of the JavaScript engine. When a registered object is reclaimed, any cleanup callbacks for it may be called then, or some time later, or not at all.\n- It\'s likely that major implementations will call cleanup callbacks at some point during execution, but those calls may be substantially after the related object was reclaimed. Furthermore, if there is an object registered in two registries, there is no guarantee that the two callbacks are called next to each other \u2014 one may be called and the other never called, or the other may be called much later.\n- There are also situations where even implementations that normally call cleanup callbacks are unlikely to call them:\n  - When the JavaScript program shuts down entirely (for instance, closing a tab in a browser).\n  - When the `FinalizationRegistry` instance itself is no longer reachable by JavaScript code.\n- If the target of a `WeakRef` is also in a `FinalizationRegistry`, the `WeakRef`\'s target is cleared at the same time or before any cleanup callback associated with the registry is called; if your cleanup callback calls `deref` on a `WeakRef` for the object, it will receive `undefined`.\n\n## Constructor\n\n- {{jsxref("FinalizationRegistry/FinalizationRegistry", "FinalizationRegistry()")}}\n  - : Creates a new `FinalizationRegistry` object.\n\n## Instance properties\n\nThese properties are defined on `FinalizationRegistry.prototype` and shared by all `FinalizationRegistry` instances.\n\n- {{jsxref("Object/constructor", "FinalizationRegistry.prototype.constructor")}}\n  - : The constructor function that created the instance object. For `FinalizationRegistry` instances, the initial value is the {{jsxref("FinalizationRegistry/FinalizationRegistry", "FinalizationRegistry")}} constructor.\n- `FinalizationRegistry.prototype[@@toStringTag]`\n  - : The initial value of the [`@@toStringTag`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol/toStringTag) property is the string `"FinalizationRegistry"`. This property is used in {{jsxref("Object.prototype.toString()")}}.\n\n## Instance methods\n\n- {{jsxref("FinalizationRegistry.prototype.register()")}}\n  - : Registers an object with the registry in order to get a cleanup callback when/if the object is garbage-collected.\n- {{jsxref("FinalizationRegistry.prototype.unregister()")}}\n  - : Unregisters an object from the registry.\n\n## Examples\n\n### Creating a new registry\n\nYou create the registry passing in the callback:\n\n```js\nconst registry = new FinalizationRegistry((heldValue) => {\n  // \u2026\n});\n```\n\n### Registering objects for cleanup\n\nThen you register any objects you want a cleanup callback for by calling the `register` method, passing in the object and a _held value_ for it:\n\n```js\nregistry.register(theObject, "some value");\n```\n\n### Callbacks never called synchronously\n\nNo matter how much pressure you put on the garbage collector, the cleanup callback will never be called synchronously. The object may be reclaimed synchronously, but the callback will always be called sometime after the current job finishes:\n\n```js\nlet counter = 0;\nconst registry = new FinalizationRegistry(() => {\n  console.log(`Array gets garbage collected at ${counter}`);\n});\n\nregistry.register(["foo"]);\n\n(function allocateMemory() {\n  // Allocate 50000 functions \u2014 a lot of memory!\n  Array.from({ length: 50000 }, () => () => {});\n  if (counter > 5000) return;\n  counter++;\n  allocateMemory();\n})();\n\nconsole.log("Main job ends");\n// Logs:\n// Main job ends\n// Array gets garbage collected at 5001\n```\n\nHowever, if you allow a little break between each allocation, the callback may be called sooner:\n\n```js\nlet arrayCollected = false;\nlet counter = 0;\nconst registry = new FinalizationRegistry(() => {\n  console.log(`Array gets garbage collected at ${counter}`);\n  arrayCollected = true;\n});\n\nregistry.register(["foo"]);\n\n(function allocateMemory() {\n  // Allocate 50000 functions \u2014 a lot of memory!\n  Array.from({ length: 50000 }, () => () => {});\n  if (counter > 5000 || arrayCollected) return;\n  counter++;\n  // Use setTimeout to make each allocateMemory a different job\n  setTimeout(allocateMemory);\n})();\n\nconsole.log("Main job ends");\n```\n\nThere\'s no guarantee that the callback will be called sooner or if it will be called at all, but there\'s a possibility that the logged message has a counter value smaller than 5000.\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("WeakRef")}}\n- {{jsxref("WeakSet")}}\n- {{jsxref("WeakMap")}}\n',
        "register": {
            "index.md": '---\ntitle: FinalizationRegistry.prototype.register()\nslug: Web/JavaScript/Reference/Global_Objects/FinalizationRegistry/register\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.FinalizationRegistry.register\n---\n\n{{JSRef}}\n\nThe **`register()`** method of {{jsxref("FinalizationRegistry")}} instances registers an value with this `FinalizationRegistry` so that if the value is garbage-collected, the registry\'s callback may get called.\n\n## Syntax\n\n```js-nolint\nregister(target, heldValue)\nregister(target, heldValue, unregisterToken)\n```\n\n### Parameters\n\n- `target`\n  - : The target value to register.\n- `heldValue`\n  - : The value to pass to the finalizer for this `target`. This cannot be the `target` itself but can be anything else, including functions and primitives.\n- `unregisterToken` {{optional_inline}}\n  - : A token that may be used with the `unregister` method later to unregister the target value. If provided (and not `undefined`), this must be an object or a [non-registered symbol](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#shared_symbols_in_the_global_symbol_registry). If not provided, the target cannot be unregistered.\n\n### Return value\n\nNone ({{jsxref("undefined")}}).\n\n### Exceptions\n\n- {{jsxref("TypeError")}}\n  - : Thrown in one of the following cases:\n    - `target` is not an object or a [non-registered symbol](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#shared_symbols_in_the_global_symbol_registry) (object as opposed to primitives; functions are objects as well)\n    - `target` is the same as `heldvalue` (`target === heldValue`)\n    - `unregisterToken` is not an object or a [non-registered symbol](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#shared_symbols_in_the_global_symbol_registry)\n\n## Description\n\nSee the [Avoid where possible](/en-US/docs/Web/JavaScript/Reference/Global_Objects/FinalizationRegistry#avoid_where_possible)\nand [Notes on cleanup callbacks](/en-US/docs/Web/JavaScript/Reference/Global_Objects/FinalizationRegistry#notes_on_cleanup_callbacks)\nsections of the {{jsxref("FinalizationRegistry")}} page for important caveats.\n\n## Examples\n\n### Using register\n\nThe following registers the value referenced by `target`,\npassing in the held value `"some value"` and passing the target itself\nas the unregistration token:\n\n```js\nregistry.register(target, "some value", target);\n```\n\nThe following registers the value referenced by `target`,\npassing in another object as the held value, and not passing in any unregistration token\n(which means `target` can\'t be unregistered):\n\n```js\nregistry.register(target, { useful: "info about target" });\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("FinalizationRegistry")}}\n'
        },
        "unregister": {
            "index.md": '---\ntitle: FinalizationRegistry.prototype.unregister()\nslug: Web/JavaScript/Reference/Global_Objects/FinalizationRegistry/unregister\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.FinalizationRegistry.unregister\n---\n\n{{JSRef}}\n\nThe **`unregister()`** method of {{jsxref("FinalizationRegistry")}} instances unregisters a target value from this `FinalizationRegistry`.\n\n## Syntax\n\n```js-nolint\nunregister(unregisterToken)\n```\n\n### Parameters\n\n- `unregisterToken`\n  - : The token used with the {{jsxref("FinalizationRegistry/register", "register()")}} method when registering the target value. Multiple cells registered with the same `unregisterToken` will be unregistered together.\n\n### Return value\n\nA boolean value that is `true` if at least one cell was unregistered and `false` if no cell was unregistered.\n\n### Exceptions\n\n- {{jsxref("TypeError")}}\n  - : Thrown if `unregisterToken` is not an object or a [non-registered symbol](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#shared_symbols_in_the_global_symbol_registry).\n\n## Description\n\nWhen a target value has been reclaimed, it is no longer registered in the registry.\nThere is no need to call `unregister` in your cleanup callback. Only call\n`unregister` if you haven\'t received a cleanup callback and no longer need\nto receive one.\n\n## Examples\n\n### Using unregister\n\nThis example shows registering a target object using that same object as the unregister\ntoken, then later unregistering it via `unregister`:\n\n```js\nclass Thingy {\n  static #cleanup = (label) => {\n    //               ^^^^^\u2212\u2212\u2212\u2212\u2212 held value\n    console.error(\n      `The "release" method was never called for the object with the label "${label}"`,\n    );\n  };\n  #registry = new FinalizationRegistry(Thingy.#cleanup);\n\n  /**\n   * Constructs a `Thingy` instance.\n   * Be sure to call `release` when you\'re done with it.\n   *\n   * @param label A label for the `Thingy`.\n   */\n  constructor(label) {\n    //                            vvvvv\u2212\u2212\u2212\u2212\u2212 held value\n    this.#registry.register(this, label, this);\n    //          target \u2212\u2212\u2212\u2212\u2212^^^^         ^^^^\u2212\u2212\u2212\u2212\u2212 unregister token\n  }\n\n  /**\n   * Releases resources held by this `Thingy` instance.\n   */\n  release() {\n    this.#registry.unregister(this);\n    //                        ^^^^\u2212\u2212\u2212\u2212\u2212 unregister token\n  }\n}\n```\n\nThis example shows registering a target object using a different object as its\nunregister token:\n\n```js\nclass Thingy {\n  static #cleanup = (file) => {\n    //               ^^^^\u2212\u2212\u2212\u2212\u2212 held value\n    console.error(\n      `The "release" method was never called for the "Thingy" for the file "${file.name}"`,\n    );\n  };\n  #registry = new FinalizationRegistry(Thingy.#cleanup);\n  #file;\n\n  /**\n   * Constructs a `Thingy` instance for the given file.\n   * Be sure to call `release` when you\'re done with it.\n   *\n   * @param filename The name of the file.\n   */\n  constructor(filename) {\n    this.#file = File.open(filename);\n    //                            vvvvv\u2212\u2212\u2212\u2212\u2212 held value\n    this.#registry.register(this, label, this.#file);\n    //          target \u2212\u2212\u2212\u2212\u2212^^^^         ^^^^^^^^^^\u2212\u2212\u2212\u2212\u2212 unregister token\n  }\n\n  /**\n   * Releases resources held by this `Thingy` instance.\n   */\n  release() {\n    if (this.#file) {\n      this.#registry.unregister(this.#file);\n      //                        ^^^^^^^^^^\u2212\u2212\u2212\u2212\u2212 unregister token\n      File.close(this.#file);\n      this.#file = null;\n    }\n  }\n}\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("FinalizationRegistry")}}\n'
        }
    },
    "float32array": {
        "float32array": {
            "index.md": '---\ntitle: Float32Array() constructor\nslug: Web/JavaScript/Reference/Global_Objects/Float32Array/Float32Array\npage-type: javascript-constructor\nbrowser-compat: javascript.builtins.Float32Array.Float32Array\n---\n\n{{JSRef}}\n\nThe **`Float32Array()`** constructor creates {{jsxref("Float32Array")}} objects. The contents are initialized to `0`.\n\n## Syntax\n\n```js-nolint\nnew Float32Array()\nnew Float32Array(length)\nnew Float32Array(typedArray)\nnew Float32Array(object)\n\nnew Float32Array(buffer)\nnew Float32Array(buffer, byteOffset)\nnew Float32Array(buffer, byteOffset, length)\n```\n\n> **Note:** `Float32Array()` can only be constructed with [`new`](/en-US/docs/Web/JavaScript/Reference/Operators/new). Attempting to call it without `new` throws a {{jsxref("TypeError")}}.\n\n### Parameters\n\nSee [`TypedArray`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/TypedArray#parameters).\n\n### Exceptions\n\nSee [`TypedArray`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/TypedArray#exceptions).\n\n## Examples\n\n### Different ways to create a Float32Array\n\n```js\n// From a length\nconst float32 = new Float32Array(2);\nfloat32[0] = 42;\nconsole.log(float32[0]); // 42\nconsole.log(float32.length); // 2\nconsole.log(float32.BYTES_PER_ELEMENT); // 4\n\n// From an array\nconst x = new Float32Array([21, 31]);\nconsole.log(x[1]); // 31\n\n// From another TypedArray\nconst y = new Float32Array(x);\nconsole.log(y[0]); // 21\n\n// From an ArrayBuffer\nconst buffer = new ArrayBuffer(32);\nconst z = new Float32Array(buffer, 4, 4);\nconsole.log(z.byteOffset); // 4\n\n// From an iterable\nconst iterable = (function* () {\n  yield* [1, 2, 3];\n})();\nconst float32FromIterable = new Float32Array(iterable);\nconsole.log(float32FromIterable);\n// Float32Array [1, 2, 3]\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Float32Array` in `core-js`](https://github.com/zloirock/core-js#ecmascript-typed-arrays)\n- [JavaScript typed arrays](/en-US/docs/Web/JavaScript/Guide/Typed_arrays) guide\n- {{jsxref("TypedArray")}}\n- {{jsxref("ArrayBuffer")}}\n- {{jsxref("DataView")}}\n'
        },
        "index.md": '---\ntitle: Float32Array\nslug: Web/JavaScript/Reference/Global_Objects/Float32Array\npage-type: javascript-class\nbrowser-compat: javascript.builtins.Float32Array\n---\n\n{{JSRef}}\n\nThe **`Float32Array`** typed array represents an array of 32-bit floating point numbers in the platform byte order. If control over byte order is needed, use {{jsxref("DataView")}} instead. The contents are initialized to `0`. Once established, you can reference elements in the array using the object\'s methods, or using standard array index syntax (that is, using bracket notation).\n\n`Float32Array` is a subclass of the hidden {{jsxref("TypedArray")}} class.\n\n## Constructor\n\n- {{jsxref("Float32Array/Float32Array", "Float32Array()")}}\n  - : Creates a new `Float32Array` object.\n\n## Static properties\n\n_Also inherits static properties from its parent {{jsxref("TypedArray")}}_.\n\n- {{jsxref("TypedArray/BYTES_PER_ELEMENT", "Float32Array.BYTES_PER_ELEMENT")}}\n  - : Returns a number value of the element size. `4` in the case of `Float32Array`.\n\n## Static methods\n\n_Inherits static methods from its parent {{jsxref("TypedArray")}}_.\n\n## Instance properties\n\n_Also inherits instance properties from its parent {{jsxref("TypedArray")}}_.\n\nThese properties are defined on `Float32Array.prototype` and shared by all `Float32Array` instances.\n\n- {{jsxref("TypedArray/BYTES_PER_ELEMENT", "Float32Array.prototype.BYTES_PER_ELEMENT")}}\n  - : Returns a number value of the element size. `4` in the case of a `Float32Array`.\n- {{jsxref("Object/constructor", "Float32Array.prototype.constructor")}}\n  - : The constructor function that created the instance object. For `Float32Array` instances, the initial value is the {{jsxref("Float32Array/Float32Array", "Float32Array")}} constructor.\n\n## Instance methods\n\n_Inherits instance methods from its parent {{jsxref("TypedArray")}}_.\n\n## Examples\n\n### Different ways to create a Float32Array\n\n```js\n// From a length\nconst float32 = new Float32Array(2);\nfloat32[0] = 42;\nconsole.log(float32[0]); // 42\nconsole.log(float32.length); // 2\nconsole.log(float32.BYTES_PER_ELEMENT); // 4\n\n// From an array\nconst x = new Float32Array([21, 31]);\nconsole.log(x[1]); // 31\n\n// From another TypedArray\nconst y = new Float32Array(x);\nconsole.log(y[0]); // 21\n\n// From an ArrayBuffer\nconst buffer = new ArrayBuffer(32);\nconst z = new Float32Array(buffer, 4, 4);\nconsole.log(z.byteOffset); // 4\n\n// From an iterable\nconst iterable = (function* () {\n  yield* [1, 2, 3];\n})();\nconst float32FromIterable = new Float32Array(iterable);\nconsole.log(float32FromIterable);\n// Float32Array [1, 2, 3]\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Float32Array` in `core-js`](https://github.com/zloirock/core-js#ecmascript-typed-arrays)\n- [JavaScript typed arrays](/en-US/docs/Web/JavaScript/Guide/Typed_arrays) guide\n- {{jsxref("TypedArray")}}\n- {{jsxref("ArrayBuffer")}}\n- {{jsxref("DataView")}}\n'
    },
    "float64array": {
        "float64array": {
            "index.md": '---\ntitle: Float64Array() constructor\nslug: Web/JavaScript/Reference/Global_Objects/Float64Array/Float64Array\npage-type: javascript-constructor\nbrowser-compat: javascript.builtins.Float64Array.Float64Array\n---\n\n{{JSRef}}\n\nThe **`Float64Array()`** constructor creates {{jsxref("Float64Array")}} objects. The contents are initialized to `0`.\n\n## Syntax\n\n```js-nolint\nnew Float64Array()\nnew Float64Array(length)\nnew Float64Array(typedArray)\nnew Float64Array(object)\n\nnew Float64Array(buffer)\nnew Float64Array(buffer, byteOffset)\nnew Float64Array(buffer, byteOffset, length)\n```\n\n> **Note:** `Float64Array()` can only be constructed with [`new`](/en-US/docs/Web/JavaScript/Reference/Operators/new). Attempting to call it without `new` throws a {{jsxref("TypeError")}}.\n\n### Parameters\n\nSee [`TypedArray`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/TypedArray#parameters).\n\n### Exceptions\n\nSee [`TypedArray`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/TypedArray#exceptions).\n\n## Examples\n\n### Different ways to create a Float64Array\n\n```js\n// From a length\nconst float64 = new Float64Array(2);\nfloat64[0] = 42;\nconsole.log(float64[0]); // 42\nconsole.log(float64.length); // 2\nconsole.log(float64.BYTES_PER_ELEMENT); // 8\n\n// From an array\nconst x = new Float64Array([21, 31]);\nconsole.log(x[1]); // 31\n\n// From another TypedArray\nconst y = new Float64Array(x);\nconsole.log(y[0]); // 21\n\n// From an ArrayBuffer\nconst buffer = new ArrayBuffer(64);\nconst z = new Float64Array(buffer, 8, 4);\nconsole.log(z.byteOffset); // 8\n\n// From an iterable\nconst iterable = (function* () {\n  yield* [1, 2, 3];\n})();\nconst float64FromIterable = new Float64Array(iterable);\nconsole.log(float64FromIterable);\n// Float64Array [1, 2, 3]\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Float64Array` in `core-js`](https://github.com/zloirock/core-js#ecmascript-typed-arrays)\n- [JavaScript typed arrays](/en-US/docs/Web/JavaScript/Guide/Typed_arrays) guide\n- {{jsxref("TypedArray")}}\n- {{jsxref("ArrayBuffer")}}\n- {{jsxref("DataView")}}\n'
        },
        "index.md": '---\ntitle: Float64Array\nslug: Web/JavaScript/Reference/Global_Objects/Float64Array\npage-type: javascript-class\nbrowser-compat: javascript.builtins.Float64Array\n---\n\n{{JSRef}}\n\nThe **`Float64Array`** typed array represents an array of 64-bit floating point numbers in the platform byte order. If control over byte order is needed, use {{jsxref("DataView")}} instead. The contents are initialized to `0`. Once established, you can reference elements in the array using the object\'s methods, or using standard array index syntax (that is, using bracket notation).\n\n`Float64Array` is a subclass of the hidden {{jsxref("TypedArray")}} class.\n\n## Constructor\n\n- {{jsxref("Float64Array/Float64Array", "Float64Array()")}}\n  - : Creates a new `Float64Array` object.\n\n## Static properties\n\n_Also inherits static properties from its parent {{jsxref("TypedArray")}}_.\n\n- {{jsxref("TypedArray/BYTES_PER_ELEMENT", "Float64Array.BYTES_PER_ELEMENT")}}\n  - : Returns a number value of the element size. `8` in the case of `Float64Array`.\n\n## Static methods\n\n_Inherits static methods from its parent {{jsxref("TypedArray")}}_.\n\n## Instance properties\n\n_Also inherits instance properties from its parent {{jsxref("TypedArray")}}_.\n\nThese properties are defined on `Float64Array.prototype` and shared by all `Float64Array` instances.\n\n- {{jsxref("TypedArray/BYTES_PER_ELEMENT", "Float64Array.prototype.BYTES_PER_ELEMENT")}}\n  - : Returns a number value of the element size. `8` in the case of a `Float64Array`.\n- {{jsxref("Object/constructor", "Float64Array.prototype.constructor")}}\n  - : The constructor function that created the instance object. For `Float64Array` instances, the initial value is the {{jsxref("Float64Array/Float64Array", "Float64Array")}} constructor.\n\n## Instance methods\n\n_Inherits instance methods from its parent {{jsxref("TypedArray")}}_.\n\n## Examples\n\n### Different ways to create a Float64Array\n\n```js\n// From a length\nconst float64 = new Float64Array(2);\nfloat64[0] = 42;\nconsole.log(float64[0]); // 42\nconsole.log(float64.length); // 2\nconsole.log(float64.BYTES_PER_ELEMENT); // 8\n\n// From an array\nconst x = new Float64Array([21, 31]);\nconsole.log(x[1]); // 31\n\n// From another TypedArray\nconst y = new Float64Array(x);\nconsole.log(y[0]); // 21\n\n// From an ArrayBuffer\nconst buffer = new ArrayBuffer(64);\nconst z = new Float64Array(buffer, 8, 4);\nconsole.log(z.byteOffset); // 8\n\n// From an iterable\nconst iterable = (function* () {\n  yield* [1, 2, 3];\n})();\nconst float64FromIterable = new Float64Array(iterable);\nconsole.log(float64FromIterable);\n// Float64Array [1, 2, 3]\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Float64Array` in `core-js`](https://github.com/zloirock/core-js#ecmascript-typed-arrays)\n- [JavaScript typed arrays](/en-US/docs/Web/JavaScript/Guide/Typed_arrays) guide\n- {{jsxref("TypedArray")}}\n- {{jsxref("ArrayBuffer")}}\n- {{jsxref("DataView")}}\n'
    },
    "function": {
        "@@hasinstance": {
            "index.md": '---\ntitle: Function.prototype[@@hasInstance]()\nslug: Web/JavaScript/Reference/Global_Objects/Function/@@hasInstance\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Function.@@hasInstance\n---\n\n{{JSRef}}\n\nThe **`[@@hasInstance]()`** method of {{jsxref("Function")}} instances specifies the default procedure for determining if a constructor function recognizes an object as one of the constructor\'s instances. It is called by the [`instanceof`](/en-US/docs/Web/JavaScript/Reference/Operators/instanceof) operator.\n\n## Syntax\n\n```js-nolint\nfunc[Symbol.hasInstance](value)\n```\n\n### Parameters\n\n- `value`\n  - : The object to test. Primitive values always return `false`.\n\n### Return value\n\n`true` if `func.prototype` is in the prototype chain of `value`; otherwise, `false`. Always returns `false` if `value` is not an object or `this` is not a function. If `this` is a [bound function](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/bind), returns the result of a `instanceof` test on `value` and the underlying target function.\n\n### Exceptions\n\n- {{jsxref("TypeError")}}\n  - : Thrown if `this` is not a bound function and `this.prototype` is not an object.\n\n## Description\n\nThe [`instanceof`](/en-US/docs/Web/JavaScript/Reference/Operators/instanceof) operator calls the [`[@@hasInstance]()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol/hasInstance) method of the right-hand side whenever such a method exists. Because all functions inherit from `Function.prototype` by default, they would all have the `[@@hasInstance]()` method, so most of the time, the `Function.prototype[@@hasInstance]` method specifies the behavior of `instanceof` when the right-hand side is a function. This method implements the default behavior of the `instanceof` operator (the same algorithm when `constructor` has no `@@hasInstance` method).\n\nUnlike most methods, the `Function.prototype[@@hasInstance]()` property is non-configurable and non-writable. This is a security feature to prevent the underlying target function of a bound function from being obtainable. See [this StackOverflow answer](https://stackoverflow.com/questions/38215027/trying-to-understand-the-official-es6-spec-regarding-symbol-hasinstance/38215392#38215392) for an example.\n\n## Examples\n\n### Reverting to default instanceof behavior\n\nYou would rarely need to call this method directly. Instead, this method is called by the `instanceof` operator. You should expect the two results to usually be equivalent.\n\n```js\nclass Foo {}\nconst foo = new Foo();\nconsole.log(foo instanceof Foo === Foo[Symbol.hasInstance](foo)); // true\n```\n\nYou may want to use this method if you want to invoke the default `instanceof` behavior, but you don\'t know if a constructor has a overridden `[@@hasInstance]()` method.\n\n```js\nclass Foo {\n  static [Symbol.hasInstance](value) {\n    // A custom implementation\n    return false;\n  }\n}\n\nconst foo = new Foo();\nconsole.log(foo instanceof Foo); // false\nconsole.log(Function.prototype[Symbol.hasInstance].call(Foo, foo)); // true\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [`instanceof`](/en-US/docs/Web/JavaScript/Reference/Operators/instanceof)\n- {{jsxref("Symbol.hasInstance")}}\n'
        },
        "apply": {
            "index.md": '---\ntitle: Function.prototype.apply()\nslug: Web/JavaScript/Reference/Global_Objects/Function/apply\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Function.apply\n---\n\n{{JSRef}}\n\nThe **`apply()`** method of {{jsxref("Function")}} instances calls this function with a given `this` value, and `arguments` provided as an array (or an [array-like object](/en-US/docs/Web/JavaScript/Guide/Indexed_collections#working_with_array-like_objects)).\n\n{{EmbedInteractiveExample("pages/js/function-apply.html")}}\n\n## Syntax\n\n```js-nolint\napply(thisArg)\napply(thisArg, argsArray)\n```\n\n### Parameters\n\n- `thisArg`\n  - : The value of `this` provided for the call to `func`. If the function is not in [strict mode](/en-US/docs/Web/JavaScript/Reference/Strict_mode), [`null`](/en-US/docs/Web/JavaScript/Reference/Operators/null) and [`undefined`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/undefined) will be replaced with the global object, and primitive values will be converted to objects.\n- `argsArray` {{optional_inline}}\n  - : An array-like object, specifying the arguments with which `func` should be called, or [`null`](/en-US/docs/Web/JavaScript/Reference/Operators/null) or [`undefined`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/undefined) if no arguments should be provided to the function.\n\n### Return value\n\nThe result of calling the function with the specified `this` value and arguments.\n\n## Description\n\n> **Note:** This function is almost identical to {{jsxref("Function/call", "call()")}}, except that the function arguments are passed to `call()` individually as a list, while for `apply()` they are combined in one object, typically an array \u2014 for example, `func.call(this, "eat", "bananas")` vs. `func.apply(this, ["eat", "bananas"])`.\n\nNormally, when calling a function, the value of [`this`](/en-US/docs/Web/JavaScript/Reference/Operators/this) inside the function is the object that the function was accessed on. With `apply()`, you can assign an arbitrary value as `this` when calling an existing function, without first attaching the function to the object as a property. This allows you to use methods of one object as generic utility functions.\n\nYou can also use any kind of object which is array-like as the second parameter. In practice, this means that it needs to have a `length` property, and integer ("index") properties in the range `(0..length - 1)`. For example, you could use a {{domxref("NodeList")}}, or a custom object like `{ \'length\': 2, \'0\': \'eat\', \'1\': \'bananas\' }`. You can also use {{jsxref("Functions/arguments", "arguments")}}, for example:\n\n```js\nfunction wrapper() {\n  return anotherFn.apply(null, arguments);\n}\n```\n\nWith the [rest parameters](/en-US/docs/Web/JavaScript/Reference/Functions/rest_parameters) and parameter [spread syntax](/en-US/docs/Web/JavaScript/Reference/Operators/Spread_syntax), this can be rewritten as:\n\n```js\nfunction wrapper(...args) {\n  return anotherFn(...args);\n}\n```\n\nIn general, `fn.apply(null, args)` is equivalent to `fn(...args)` with the parameter spread syntax, except `args` is expected to be an array-like object in the former case with `apply()`, and an [iterable](/en-US/docs/Web/JavaScript/Reference/Iteration_protocols#the_iterable_protocol) object in the latter case with spread syntax.\n\n> **Warning:** Do not use `apply()` to chain constructors (for example, to implement inheritance). This invokes the constructor function as a plain function, which means [`new.target`](/en-US/docs/Web/JavaScript/Reference/Operators/new.target) is `undefined`, and classes throw an error because they can\'t be called without [`new`](/en-US/docs/Web/JavaScript/Reference/Operators/new). Use {{jsxref("Reflect.construct()")}} or [`extends`](/en-US/docs/Web/JavaScript/Reference/Classes/extends) instead.\n\n## Examples\n\n### Using apply() to append an array to another\n\nYou can use {{jsxref("Array.prototype.push()")}} to append an element to an array. Because `push()` accepts a variable number of arguments, you can also push multiple elements at once. But if you pass an array to `push()`, it will actually add that array as a single element, instead of adding the elements individually, ending up with an array inside an array. On the other hand, {{jsxref("Array.prototype.concat()")}} does have the desired behavior in this case, but it does not append to the _existing_ array \u2014 it creates and returns a new array.\n\nIn this case, you can use `apply` to implicitly "spread" an array as a series of arguments.\n\n```js\nconst array = ["a", "b"];\nconst elements = [0, 1, 2];\narray.push.apply(array, elements);\nconsole.info(array); // ["a", "b", 0, 1, 2]\n```\n\nThe same effect can be achieved with the spread syntax.\n\n```js\nconst array = ["a", "b"];\nconst elements = [0, 1, 2];\narray.push(...elements);\nconsole.info(array); // ["a", "b", 0, 1, 2]\n```\n\n### Using apply() and built-in functions\n\nClever usage of `apply()` allows you to use built-in functions for some tasks that would probably otherwise require manually looping over a collection (or using the spread syntax).\n\nFor example, we can use {{jsxref("Math.max()")}} and {{jsxref("Math.min()")}} to find out the maximum and minimum value in an array.\n\n```js\n// min/max number in an array\nconst numbers = [5, 6, 2, 3, 7];\n\n// using Math.min/Math.max apply\nlet max = Math.max.apply(null, numbers);\n// This about equal to Math.max(numbers[0], \u2026)\n// or Math.max(5, 6, \u2026)\n\nlet min = Math.min.apply(null, numbers);\n\n// vs. simple loop based algorithm\nmax = -Infinity;\nmin = +Infinity;\n\nfor (let i = 0; i < numbers.length; i++) {\n  if (numbers[i] > max) {\n    max = numbers[i];\n  }\n  if (numbers[i] < min) {\n    min = numbers[i];\n  }\n}\n```\n\nBut beware: by using `apply()` (or the spread syntax) with an arbitrarily long arguments list, you run the risk of exceeding the JavaScript engine\'s argument length limit.\n\nThe consequences of calling a function with too many arguments (that is, more than tens of thousands of arguments) is unspecified and varies across engines. (The JavaScriptCore engine has a hard-coded [argument limit of 65536](https://webkit.org/b/80797).) Most engines throw an exception; but there\'s no normative specification preventing other behaviors, such as arbitrarily limiting the number of arguments actually passed to the applied function. To illustrate this latter case: if such an engine had a limit of four arguments (actual limits are of course significantly higher), it would be as if the arguments `5, 6, 2, 3` had been passed to `apply` in the examples above, rather than the full array.\n\nIf your value array might grow into the tens of thousands, use a hybrid strategy: apply your function to chunks of the array at a time:\n\n```js\nfunction minOfArray(arr) {\n  let min = Infinity;\n  const QUANTUM = 32768;\n\n  for (let i = 0; i < arr.length; i += QUANTUM) {\n    const submin = Math.min.apply(\n      null,\n      arr.slice(i, Math.min(i + QUANTUM, arr.length)),\n    );\n    min = Math.min(submin, min);\n  }\n\n  return min;\n}\n\nconst min = minOfArray([5, 6, 2, 3, 7]);\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Functions/arguments", "arguments")}}\n- {{jsxref("Function.prototype.bind()")}}\n- {{jsxref("Function.prototype.call()")}}\n- {{jsxref("Reflect.apply()")}}\n- [Functions](/en-US/docs/Web/JavaScript/Reference/Functions)\n- [Spread syntax (`...`)](/en-US/docs/Web/JavaScript/Reference/Operators/Spread_syntax)\n'
        },
        "arguments": {
            "index.md": '---\ntitle: Function.prototype.arguments\nslug: Web/JavaScript/Reference/Global_Objects/Function/arguments\npage-type: javascript-instance-accessor-property\nstatus:\n  - deprecated\n  - non-standard\nbrowser-compat: javascript.builtins.Function.arguments\n---\n\n{{JSRef}}{{Deprecated_Header}}{{Non-standard_Header}}\n\n> **Note:** The `arguments` property of {{jsxref("Function")}} objects is deprecated. The recommended way to access the `arguments` object is to refer to the variable {{jsxref("Functions/arguments", "arguments")}} available within functions.\n\nThe **`arguments`** accessor property of {{jsxref("Function")}} instances returns the arguments passed to this function. For [strict](/en-US/docs/Web/JavaScript/Reference/Strict_mode), arrow, async, and generator functions, accessing the `arguments` property throws a {{jsxref("TypeError")}}.\n\n## Description\n\nThe value of `arguments` is an array-like object corresponding to the arguments passed to a function.\n\nIn the case of recursion, i.e. if function `f` appears several times on the call stack, the value of `f.arguments` represents the arguments corresponding to the most recent invocation of the function.\n\nThe value of the `arguments` property is normally {{jsxref("Operators/null", "null")}} if there is no outstanding invocation of the function in progress (that is, the function has been called but has not yet returned).\n\nNote that the only behavior specified by the ECMAScript specification is that `Function.prototype` has an initial `arguments` accessor that unconditionally throws a {{jsxref("TypeError")}} for any `get` or `set` request (known as a "poison pill accessor"), and that implementations are not allowed to change this semantic for any function except non-strict plain functions. The actual behavior of the `arguments` property, if it\'s anything other than throwing an error, is implementation-defined. For example, Chrome defines it as an own data property, while Firefox and Safari extend the initial poison-pill `Function.prototype.arguments` accessor to specially handle `this` values that are non-strict functions.\n\n```js\n(function f() {\n  if (Object.hasOwn(f, "arguments")) {\n    console.log(\n      "arguments is an own property with descriptor",\n      Object.getOwnPropertyDescriptor(f, "arguments"),\n    );\n  } else {\n    console.log(\n      "f doesn\'t have an own property named arguments. Trying to get f.[[Prototype]].arguments",\n    );\n    console.log(\n      Object.getOwnPropertyDescriptor(\n        Object.getPrototypeOf(f),\n        "arguments",\n      ).get.call(f),\n    );\n  }\n})();\n\n// In Chrome:\n// arguments is an own property with descriptor {value: Arguments(0), writable: false, enumerable: false, configurable: false}\n\n// In Firefox:\n// f doesn\'t have an own property named arguments. Trying to get f.[[Prototype]].arguments\n// Arguments { \u2026 }\n```\n\n## Examples\n\n### Using the arguments property\n\n```js\nfunction f(n) {\n  g(n - 1);\n}\n\nfunction g(n) {\n  console.log(`before: ${g.arguments[0]}`);\n  if (n > 0) {\n    f(n);\n  }\n  console.log(`after: ${g.arguments[0]}`);\n}\n\nf(2);\n\nconsole.log(`returned: ${g.arguments}`);\n\n// Logs:\n// before: 1\n// before: 0\n// after: 0\n// after: 1\n// returned: null\n```\n\n## Specifications\n\nNot part of any standard.\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Functions/arguments", "arguments")}}\n- [Functions](/en-US/docs/Web/JavaScript/Reference/Functions)\n'
        },
        "bind": {
            "index.md": '---\ntitle: Function.prototype.bind()\nslug: Web/JavaScript/Reference/Global_Objects/Function/bind\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Function.bind\n---\n\n{{JSRef}}\n\nThe **`bind()`** method of {{jsxref("Function")}} instances creates a new function that, when called, calls this function with its `this` keyword set to the provided value, and a given sequence of arguments preceding any provided when the new function is called.\n\n{{EmbedInteractiveExample("pages/js/function-bind.html", "taller")}}\n\n## Syntax\n\n```js-nolint\nbind(thisArg)\nbind(thisArg, arg1)\nbind(thisArg, arg1, arg2)\nbind(thisArg, arg1, arg2, /* \u2026, */ argN)\n```\n\n### Parameters\n\n- `thisArg`\n  - : The value to be passed as the `this` parameter to the target function `func` when the bound function is called. If the function is not in [strict mode](/en-US/docs/Web/JavaScript/Reference/Strict_mode), [`null`](/en-US/docs/Web/JavaScript/Reference/Operators/null) and [`undefined`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/undefined) will be replaced with the global object, and primitive values will be converted to objects. The value is ignored if the bound function is constructed using the {{jsxref("Operators/new", "new")}} operator.\n- `arg1`, \u2026, `argN` {{optional_inline}}\n  - : Arguments to prepend to arguments provided to the bound function when invoking `func`.\n\n### Return value\n\nA copy of the given function with the specified `this` value, and initial arguments (if provided).\n\n## Description\n\nThe `bind()` function creates a new _bound function_. Calling the bound function generally results in the execution of the function it wraps, which is also called the _target function_. The bound function will store the parameters passed \u2014 which include the value of `this` and the first few arguments \u2014 as its internal state. These values are stored in advance, instead of being passed at call time. You can generally see `const boundFn = fn.bind(thisArg, arg1, arg2)` as being equivalent to `const boundFn = (...restArgs) => fn.call(thisArg, arg1, arg2, ...restArgs)` for the effect when it\'s called (but not when `boundFn` is constructed).\n\nA bound function can be further bound by calling `boundFn.bind(thisArg, /* more args */)`, which creates another bound function `boundFn2`. The newly bound `thisArg` value is ignored, because the target function of `boundFn2`, which is `boundFn`, already has a bound `this`. When `boundFn2` is called, it would call `boundFn`, which in turn calls `fn`. The arguments that `fn` ultimately receives are, in order: the arguments bound by `boundFn`, arguments bound by `boundFn2`, and the arguments received by `boundFn2`.\n\n```js\n"use strict"; // prevent `this` from being boxed into the wrapper object\n\nfunction log(...args) {\n  console.log(this, ...args);\n}\nconst boundLog = log.bind("this value", 1, 2);\nconst boundLog2 = boundLog.bind("new this value", 3, 4);\nboundLog2(5, 6); // "this value", 1, 2, 3, 4, 5, 6\n```\n\nA bound function may also be constructed using the {{jsxref("Operators/new", "new")}} operator if its target function is constructable. Doing so acts as though the target function had instead been constructed. The prepended arguments are provided to the target function as usual, while the provided `this` value is ignored (because construction prepares its own `this`, as seen by the parameters of {{jsxref("Reflect.construct")}}). If the bound function is directly constructed, [`new.target`](/en-US/docs/Web/JavaScript/Reference/Operators/new.target) will be the target function instead. (That is, the bound function is transparent to `new.target`.)\n\n```js\nclass Base {\n  constructor(...args) {\n    console.log(new.target === Base);\n    console.log(args);\n  }\n}\n\nconst BoundBase = Base.bind(null, 1, 2);\n\nnew BoundBase(3, 4); // true, [1, 2, 3, 4]\n```\n\nHowever, because a bound function does not have the [`prototype`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/prototype) property, it cannot be used as a base class for [`extends`](/en-US/docs/Web/JavaScript/Reference/Classes/extends).\n\n```js example-bad\nclass Derived extends class {}.bind(null) {}\n// TypeError: Class extends value does not have valid prototype property undefined\n```\n\nWhen using a bound function as the right-hand side of [`instanceof`](/en-US/docs/Web/JavaScript/Reference/Operators/instanceof), `instanceof` would reach for the target function (which is stored internally in the bound function) and read its `prototype` instead.\n\n```js\nclass Base {}\nconst BoundBase = Base.bind(null, 1, 2);\nconsole.log(new Base() instanceof BoundBase); // true\n```\n\nThe bound function has the following properties:\n\n- [`length`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/length)\n  - : The `length` of the target function minus the number of arguments being bound (not counting the `thisArg` parameter), with 0 being the minimum value.\n- [`name`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/name)\n  - : The `name` of the target function plus a `"bound "` prefix.\n\nThe bound function also inherits the [prototype chain](/en-US/docs/Web/JavaScript/Inheritance_and_the_prototype_chain) of the target function. However, it doesn\'t have other own properties of the target function (such as [static properties](/en-US/docs/Web/JavaScript/Reference/Classes/static) if the target function is a class).\n\n## Examples\n\n### Creating a bound function\n\nThe simplest use of `bind()` is to make a function that, no matter how it is called, is called with a particular `this` value.\n\nA common mistake for new JavaScript programmers is to extract a method from an object, then to later call that function and expect it to use the original object as its `this` (e.g., by using the method in callback-based code).\n\nWithout special care, however, the original object is usually lost. Creating a bound function from the function, using the original object, neatly solves this problem:\n\n```js\n// Top-level \'this\' is bound to \'globalThis\' in scripts.\nthis.x = 9;\nconst module = {\n  x: 81,\n  getX() {\n    return this.x;\n  },\n};\n\n// The \'this\' parameter of \'getX\' is bound to \'module\'.\nconsole.log(module.getX()); // 81\n\nconst retrieveX = module.getX;\n// The \'this\' parameter of \'retrieveX\' is bound to \'globalThis\' in non-strict mode.\nconsole.log(retrieveX()); // 9\n\n// Create a new function \'boundGetX\' with the \'this\' parameter bound to \'module\'.\nconst boundGetX = retrieveX.bind(module);\nconsole.log(boundGetX()); // 81\n```\n\n> **Note:** If you run this example in [strict mode](/en-US/docs/Web/JavaScript/Reference/Strict_mode), the `this` parameter of `retrieveX` will be bound to `undefined` instead of `globalThis`, causing the `retrieveX()` call to fail.\n>\n> If you run this example in an ECMAScript module, top-level `this` will be bound to `undefined` instead of `globalThis`, causing the `this.x = 9` assignment to fail.\n>\n> If you run this example in a Node CommonJS module, top-level `this` will be bound to `module.exports` instead of `globalThis`. However, the `this` parameter of `retrieveX` will still be bound to `globalThis` in non-strict mode and to `undefined` in strict mode. Therefore, in non-strict mode (the default), the `retrieveX()` call will return `undefined` because `this.x = 9` is writing to a different object (`module.exports`) from what `getX` is reading from (`globalThis`).\n\nIn fact, some built-in "methods" are also getters that return bound functions \u2014 one notable example being [`Intl.NumberFormat.prototype.format()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/format#using_format_with_map), which, when accessed, returns a bound function that you can directly pass as a callback.\n\n### Partially applied functions\n\nThe next simplest use of `bind()` is to make a function with pre-specified initial arguments.\n\nThese arguments (if any) follow the provided `this` value and are then inserted at the start of the arguments passed to the target function, followed by whatever arguments are passed to the bound function at the time it is called.\n\n```js\nfunction list(...args) {\n  return args;\n}\n\nfunction addArguments(arg1, arg2) {\n  return arg1 + arg2;\n}\n\nconsole.log(list(1, 2, 3)); // [1, 2, 3]\n\nconsole.log(addArguments(1, 2)); // 3\n\n// Create a function with a preset leading argument\nconst leadingThirtySevenList = list.bind(null, 37);\n\n// Create a function with a preset first argument.\nconst addThirtySeven = addArguments.bind(null, 37);\n\nconsole.log(leadingThirtySevenList()); // [37]\nconsole.log(leadingThirtySevenList(1, 2, 3)); // [37, 1, 2, 3]\nconsole.log(addThirtySeven(5)); // 42\nconsole.log(addThirtySeven(5, 10)); // 42\n// (the last argument 10 is ignored)\n```\n\n### With setTimeout()\n\nBy default, within {{domxref("setTimeout()")}}, the `this` keyword will be set to [`globalThis`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/globalThis), which is {{domxref("window")}} in browsers. When working with class methods that require `this` to refer to class instances, you may explicitly bind `this` to the callback function, in order to maintain the instance.\n\n```js\nclass LateBloomer {\n  constructor() {\n    this.petalCount = Math.floor(Math.random() * 12) + 1;\n  }\n  bloom() {\n    // Declare bloom after a delay of 1 second\n    setTimeout(this.declare.bind(this), 1000);\n  }\n  declare() {\n    console.log(`I am a beautiful flower with ${this.petalCount} petals!`);\n  }\n}\n\nconst flower = new LateBloomer();\nflower.bloom();\n// After 1 second, calls \'flower.declare()\'\n```\n\nYou can also use [arrow functions](/en-US/docs/Web/JavaScript/Reference/Functions/Arrow_functions) for this purpose.\n\n```js\nclass LateBloomer {\n  bloom() {\n    // Declare bloom after a delay of 1 second\n    setTimeout(() => this.declare(), 1000);\n  }\n}\n```\n\n### Bound functions used as constructors\n\nBound functions are automatically suitable for use with the {{jsxref("Operators/new", "new")}} operator to construct new instances created by the target function. When a bound function is used to construct a value, the provided `this` is ignored. However, provided arguments are still prepended to the constructor call.\n\n```js\nfunction Point(x, y) {\n  this.x = x;\n  this.y = y;\n}\n\nPoint.prototype.toString = function () {\n  return `${this.x},${this.y}`;\n};\n\nconst p = new Point(1, 2);\np.toString();\n// \'1,2\'\n\n// The thisArg\'s value doesn\'t matter because it\'s ignored\nconst YAxisPoint = Point.bind(null, 0 /*x*/);\n\nconst axisPoint = new YAxisPoint(5);\naxisPoint.toString(); // \'0,5\'\n\naxisPoint instanceof Point; // true\naxisPoint instanceof YAxisPoint; // true\nnew YAxisPoint(17, 42) instanceof Point; // true\n```\n\nNote that you need not do anything special to create a bound function for use with {{jsxref("Operators/new", "new")}}. [`new.target`](/en-US/docs/Web/JavaScript/Reference/Operators/new.target), [`instanceof`](/en-US/docs/Web/JavaScript/Reference/Operators/instanceof), [`this`](/en-US/docs/Web/JavaScript/Reference/Operators/this) etc. all work as expected, as if the constructor was never bound. The only difference is that it can no longer be used for [`extends`](/en-US/docs/Web/JavaScript/Reference/Classes/extends).\n\nThe corollary is that you need not do anything special to create a bound function to be called plainly, even if you would rather require the bound function to only be called using {{jsxref("Operators/new", "new")}}. If you call it without `new`, the bound `this` is suddenly not ignored.\n\n```js\nconst emptyObj = {};\nconst YAxisPoint = Point.bind(emptyObj, 0 /*x*/);\n\n// Can still be called as a normal function\n// (although usually this is undesirable)\nYAxisPoint(13);\n\n// The modifications to `this` is now observable from the outside\nconsole.log(emptyObj); // { x: 0, y: 13 }\n```\n\nIf you wish to restrict a bound function to only be callable with {{jsxref("Operators/new", "new")}}, or only be callable without `new`, the target function must enforce that restriction, such as by checking `new.target !== undefined` or using a [class](/en-US/docs/Web/JavaScript/Reference/Classes) instead.\n\n### Binding classes\n\nUsing `bind()` on classes preserves most of the class\'s semantics, except that all static own properties of the current class are lost. However, because the prototype chain is preserved, you can still access static properties inherited from the parent class.\n\n```js\nclass Base {\n  static baseProp = "base";\n}\n\nclass Derived extends Base {\n  static derivedProp = "derived";\n}\n\nconst BoundDerived = Derived.bind(null);\nconsole.log(BoundDerived.baseProp); // "base"\nconsole.log(BoundDerived.derivedProp); // undefined\nconsole.log(new BoundDerived() instanceof Derived); // true\n```\n\n### Transforming methods to utility functions\n\n`bind()` is also helpful in cases where you want to transform a method which requires a specific `this` value to a plain utility function that accepts the previous `this` parameter as a normal parameter. This is similar to how general-purpose utility functions work: instead of calling `array.map(callback)`, you use `map(array, callback)`, which avoids mutating `Array.prototype`, and allows you to use `map` with array-like objects that are not arrays (for example, [`arguments`](/en-US/docs/Web/JavaScript/Reference/Functions/arguments)).\n\nTake {{jsxref("Array.prototype.slice()")}}, for example, which you want to use for converting an array-like object to a real array. You could create a shortcut like this:\n\n```js\nconst slice = Array.prototype.slice;\n\n// ...\n\nslice.call(arguments);\n```\n\nNote that you can\'t save `slice.call` and call it as a plain function, because the `call()` method also reads its `this` value, which is the function it should call. In this case, you can use `bind()` to bind the value of `this` for `call()`. In the following piece of code, `slice()` is a bound version of {{jsxref("Function.prototype.call()")}}, with the `this` value bound to {{jsxref("Array.prototype.slice()")}}. This means that additional `call()` calls can be eliminated:\n\n```js\n// Same as "slice" in the previous example\nconst unboundSlice = Array.prototype.slice;\nconst slice = Function.prototype.call.bind(unboundSlice);\n\n// ...\n\nslice(arguments);\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Function.prototype.bind` in `core-js`](https://github.com/zloirock/core-js#ecmascript-function)\n- {{jsxref("Function.prototype.apply()")}}\n- {{jsxref("Function.prototype.call()")}}\n- {{jsxref("Functions", "Functions", "", 1)}}\n'
        },
        "call": {
            "index.md": '---\ntitle: Function.prototype.call()\nslug: Web/JavaScript/Reference/Global_Objects/Function/call\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Function.call\n---\n\n{{JSRef}}\n\nThe **`call()`** method of {{jsxref("Function")}} instances calls this function with a given `this` value and arguments provided individually.\n\n{{EmbedInteractiveExample("pages/js/function-call.html")}}\n\n## Syntax\n\n```js-nolint\ncall(thisArg)\ncall(thisArg, arg1)\ncall(thisArg, arg1, arg2)\ncall(thisArg, arg1, arg2, /* \u2026, */ argN)\n```\n\n### Parameters\n\n- `thisArg`\n  - : The value to use as `this` when calling `func`. If the function is not in [strict mode](/en-US/docs/Web/JavaScript/Reference/Strict_mode), [`null`](/en-US/docs/Web/JavaScript/Reference/Operators/null) and [`undefined`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/undefined) will be replaced with the global object, and primitive values will be converted to objects.\n- `arg1`, \u2026, `argN` {{optional_inline}}\n  - : Arguments for the function.\n\n### Return value\n\nThe result of calling the function with the specified `this` value and arguments.\n\n## Description\n\n> **Note:** This function is almost identical to {{jsxref("Function/apply", "apply()")}}, except that the function arguments are passed to `call()` individually as a list, while for `apply()` they are combined in one object, typically an array \u2014 for example, `func.call(this, "eat", "bananas")` vs. `func.apply(this, ["eat", "bananas"])`.\n\nNormally, when calling a function, the value of [`this`](/en-US/docs/Web/JavaScript/Reference/Operators/this) inside the function is the object that the function was accessed on. With `call()`, you can assign an arbitrary value as `this` when calling an existing function, without first attaching the function to the object as a property. This allows you to use methods of one object as generic utility functions.\n\n> **Warning:** Do not use `call()` to chain constructors (for example, to implement inheritance). This invokes the constructor function as a plain function, which means [`new.target`](/en-US/docs/Web/JavaScript/Reference/Operators/new.target) is `undefined`, and classes throw an error because they can\'t be called without [`new`](/en-US/docs/Web/JavaScript/Reference/Operators/new). Use {{jsxref("Reflect.construct()")}} or [`extends`](/en-US/docs/Web/JavaScript/Reference/Classes/extends) instead.\n\n## Examples\n\n### Using call() to invoke a function and specifying the this value\n\nIn the example below, when we call `greet`, the value of `this` will be bound to object `obj`, even when `greet` is not a method of `obj`.\n\n```js\nfunction greet() {\n  console.log(this.animal, "typically sleep between", this.sleepDuration);\n}\n\nconst obj = {\n  animal: "cats",\n  sleepDuration: "12 and 16 hours",\n};\n\ngreet.call(obj); // cats typically sleep between 12 and 16 hours\n```\n\n### Using call() to invoke a function without specifying the first argument\n\nIf the first `thisArg` parameter is omitted, it defaults to `undefined`. In non-strict mode, the `this` value is then substituted with {{jsxref("globalThis")}} (which is akin to the global object).\n\n```js\nglobalThis.globProp = "Wisen";\n\nfunction display() {\n  console.log(`globProp value is ${this.globProp}`);\n}\n\ndisplay.call(); // Logs "globProp value is Wisen"\n```\n\nIn strict mode, the value of `this` is not substituted, so it stays as `undefined`.\n\n```js\n"use strict";\n\nglobalThis.globProp = "Wisen";\n\nfunction display() {\n  console.log(`globProp value is ${this.globProp}`);\n}\n\ndisplay.call(); // throws TypeError: Cannot read the property of \'globProp\' of undefined\n```\n\n### Transforming methods to utility functions\n\n`call()` is almost equivalent to a normal function call, except that `this` is passed as a normal parameter instead of as the value that the function was accessed on. This is similar to how general-purpose utility functions work: instead of calling `array.map(callback)`, you use `map(array, callback)`, which avoids mutating `Array.prototype`, and allows you to use `map` with array-like objects that are not arrays (for example, [`arguments`](/en-US/docs/Web/JavaScript/Reference/Functions/arguments)).\n\nTake {{jsxref("Array.prototype.slice()")}}, for example, which you want to use for converting an array-like object to a real array. You could create a shortcut like this:\n\n```js\nconst slice = Array.prototype.slice;\n\n// ...\n\nslice.call(arguments);\n```\n\nNote that you can\'t save `slice.call` and call it as a plain function, because the `call()` method also reads its `this` value, which is the function it should call. In this case, you can use {{jsxref("Function/bind", "bind()")}} to bind the value of `this` for `call()`. In the following piece of code, `slice()` is a bound version of {{jsxref("Function.prototype.call()")}}, with the `this` value bound to {{jsxref("Array.prototype.slice()")}}. This means that additional `call()` calls can be eliminated:\n\n```js\n// Same as "slice" in the previous example\nconst unboundSlice = Array.prototype.slice;\nconst slice = Function.prototype.call.bind(unboundSlice);\n\n// ...\n\nslice(arguments);\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Function.prototype.bind()")}}\n- {{jsxref("Function.prototype.apply()")}}\n- {{jsxref("Reflect.apply()")}}\n- [Spread syntax (`...`)](/en-US/docs/Web/JavaScript/Reference/Operators/Spread_syntax)\n- [Introduction to Object-Oriented JavaScript](/en-US/docs/Learn/JavaScript/Objects)\n'
        },
        "caller": {
            "index.md": '---\ntitle: Function.prototype.caller\nslug: Web/JavaScript/Reference/Global_Objects/Function/caller\npage-type: javascript-instance-accessor-property\nstatus:\n  - deprecated\n  - non-standard\nbrowser-compat: javascript.builtins.Function.caller\n---\n\n{{JSRef}}{{Non-standard_Header}}{{Deprecated_Header}}\n\n> **Note:** In [strict mode](/en-US/docs/Web/JavaScript/Reference/Strict_mode), accessing `caller` of a function throws an error \u2014 the API is removed with no replacement. This is to prevent code from being able to "walk the stack", which both poses security risks and severely limits the possibility of optimizations like inlining and tail-call optimization. For more explanation, you can read [the rationale for the deprecation of `arguments.callee`](/en-US/docs/Web/JavaScript/Reference/Functions/arguments/callee#description).\n\nThe **`caller`** accessor property of {{jsxref("Function")}} instances returns the function that invoked this function. For [strict](/en-US/docs/Web/JavaScript/Reference/Strict_mode), arrow, async, and generator functions, accessing the `caller` property throws a {{jsxref("TypeError")}}.\n\n## Description\n\nIf the function `f` was invoked by the top-level code, the value of `f.caller` is {{jsxref("Operators/null", "null")}}; otherwise it\'s the function that called `f`. If the function that called `f` is a strict mode function, the value of `f.caller` is also `null`.\n\nNote that the only behavior specified by the ECMAScript specification is that `Function.prototype` has an initial `caller` accessor that unconditionally throws a {{jsxref("TypeError")}} for any `get` or `set` request (known as a "poison pill accessor"), and that implementations are not allowed to change this semantic for any function except non-strict plain functions, in which case it must not have the value of a strict mode function. The actual behavior of the `caller` property, if it\'s anything other than throwing an error, is implementation-defined. For example, Chrome defines it as an own data property, while Firefox and Safari extend the initial poison-pill `Function.prototype.caller` accessor to specially handle `this` values that are non-strict functions.\n\n```js\n(function f() {\n  if (Object.hasOwn(f, "caller")) {\n    console.log(\n      "caller is an own property with descriptor",\n      Object.getOwnPropertyDescriptor(f, "caller"),\n    );\n  } else {\n    console.log(\n      "f doesn\'t have an own property named caller. Trying to get f.[[Prototype]].caller",\n    );\n    console.log(\n      Object.getOwnPropertyDescriptor(\n        Object.getPrototypeOf(f),\n        "caller",\n      ).get.call(f),\n    );\n  }\n})();\n\n// In Chrome:\n// caller is an own property with descriptor {value: null, writable: false, enumerable: false, configurable: false}\n\n// In Firefox:\n// f doesn\'t have an own property named caller. Trying to get f.[[Prototype]].caller\n// null\n```\n\nThis property replaces the obsolete `arguments.caller` property of the {{jsxref("Functions/arguments", "arguments")}} object.\n\nThe special property `__caller__`, which returned the activation object of the caller thus allowing to reconstruct the stack, was removed for security reasons.\n\n## Examples\n\n### Checking the value of a function\'s caller property\n\nThe following code checks the value a function\'s `caller` property.\n\n```js\nfunction myFunc() {\n  if (myFunc.caller === null) {\n    return "The function was called from the top!";\n  } else {\n    return `This function\'s caller was ${myFunc.caller}`;\n  }\n}\n```\n\n### Reconstructing the stack and recursion\n\nNote that in case of recursion, you can\'t reconstruct the call stack using this property. Consider:\n\n```js\nfunction f(n) {\n  g(n - 1);\n}\nfunction g(n) {\n  if (n > 0) {\n    f(n);\n  } else {\n    stop();\n  }\n}\nf(2);\n```\n\nAt the moment `stop()` is called the call stack will be:\n\n```plain\nf(2) -> g(1) -> f(1) -> g(0) -> stop()\n```\n\nThe following is true:\n\n```js\nstop.caller === g && f.caller === g && g.caller === f;\n```\n\nso if you tried to get the stack trace in the `stop()` function like this:\n\n```js\nlet f = stop;\nlet stack = "Stack trace:";\nwhile (f) {\n  stack += `\\n${f.name}`;\n  f = f.caller;\n}\n```\n\nthe loop would never stop.\n\n### Strict mode caller\n\nIf the caller is a strict mode function, the value of `caller` is `null`.\n\n```js\nfunction callerFunc() {\n  calleeFunc();\n}\n\nfunction strictCallerFunc() {\n  "use strict";\n  calleeFunc();\n}\n\nfunction calleeFunc() {\n  console.log(calleeFunc.caller);\n}\n\n(function () {\n  callerFunc();\n})();\n// Logs [Function: callerFunc]\n\n(function () {\n  strictCallerFunc();\n})();\n// Logs null\n```\n\n## Specifications\n\nNot part of any standard.\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Function.prototype.name")}}\n- {{jsxref("Functions/arguments", "arguments")}}\n'
        },
        "displayname": {
            "index.md": '---\ntitle: "Function: displayName"\nslug: Web/JavaScript/Reference/Global_Objects/Function/displayName\npage-type: javascript-instance-data-property\nstatus:\n  - non-standard\nbrowser-compat: javascript.builtins.Function.displayName\n---\n\n{{JSRef}} {{Non-standard_Header}}\n\nThe optional **`displayName`** property of a {{jsxref("Function")}} instance specifies the display name of the function.\n\n## Value\n\nThe `displayName` property is not initially present on any function \u2014 it\'s added by the code authors. For the purpose of display, it should be a string.\n\n## Description\n\nThe `displayName` property, if present, may be preferred by consoles and profilers over the {{jsxref("Function/name", "name")}} property to be displayed as the name of a function.\n\nAmong browsers, only the Firefox console utilizes this property. React devtools also use the [`displayName`](https://reactjs.org/docs/higher-order-components.html#convention-wrap-the-display-name-for-easy-debugging) property when displaying the component tree.\n\nFirefox does some basic attempts to decode the `displayName` that\'s possibly generated by the [anonymous JavaScript functions naming convention](https://johnjbarton.github.io/nonymous/index.html) algorithm. The following patterns are detected:\n\n- If `displayName` ends with a sequence of alphanumeric characters, `_`, and `$`, the longest such suffix is displayed.\n- If `displayName` ends with a sequence of `[]`-enclosed characters, that sequence is displayed without the square brackets.\n- If `displayName` ends with a sequence of alphanumeric characters and `_` followed by some `/`, `.`, or `<`, the sequence is returned without the trailing `/`, `.`, or `<` characters.\n- If `displayName` ends with a sequence of alphanumeric characters and `_` followed by `(^)`, the sequence is displayed without the `(^)`.\n\nIf none of the above patterns match, the entire `displayName` is displayed.\n\n## Examples\n\n### Setting a displayName\n\nBy entering the following in a Firefox console, it should display as something like `function MyFunction()`:\n\n```js\nconst a = function () {};\na.displayName = "MyFunction";\n\na; // function MyFunction()\n```\n\n### Changing displayName dynamically\n\nYou can dynamically change the `displayName` of a function:\n\n```js\nconst object = {\n  // anonymous\n  someMethod: function someMethod(value) {\n    someMethod.displayName = `someMethod (${value})`;\n  },\n};\n\nconsole.log(object.someMethod.displayName); // undefined\n\nobject.someMethod("123");\nconsole.log(object.someMethod.displayName); // "someMethod (123)"\n```\n\n### Cleaning of displayName\n\nFirefox devtools would clean up a few common patterns in the `displayName` property before displaying it.\n\n```js\nfunction foo() {}\n\nfunction testName(name) {\n  foo.displayName = name;\n  console.log(foo);\n}\n\ntestName("$foo$"); // function $foo$()\ntestName("foo bar"); // function bar()\ntestName("Foo.prototype.add"); // function add()\ntestName("foo ."); // function foo .()\ntestName("foo <"); // function foo <()\ntestName("foo?"); // function foo?()\ntestName("foo()"); // function foo()()\n\ntestName("[...]"); // function ...()\ntestName("foo<"); // function foo()\ntestName("foo..."); // function foo()\ntestName("foo(^)"); // function foo()\n```\n\n## Specifications\n\nNot part of any standard.\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Function.prototype.name")}}\n'
        },
        "function": {
            "index.md": '---\ntitle: Function() constructor\nslug: Web/JavaScript/Reference/Global_Objects/Function/Function\npage-type: javascript-constructor\nbrowser-compat: javascript.builtins.Function.Function\n---\n\n{{JSRef}}\n\nThe **`Function()`** constructor creates {{jsxref("Function")}} objects. Calling the constructor directly can create functions dynamically, but suffers from security and similar (but far less significant) performance issues as {{jsxref("Global_Objects/eval", "eval()")}}. However, unlike `eval` (which may have access to the local scope), the `Function` constructor creates functions which execute in the global scope only.\n\n{{EmbedInteractiveExample("pages/js/function-constructor.html", "shorter")}}\n\n## Syntax\n\n```js-nolint\nnew Function(functionBody)\nnew Function(arg1, functionBody)\nnew Function(arg1, arg2, functionBody)\nnew Function(arg1, arg2, /* \u2026, */ argN, functionBody)\n\nFunction(functionBody)\nFunction(arg1, functionBody)\nFunction(arg1, arg2, functionBody)\nFunction(arg1, arg2, /* \u2026, */ argN, functionBody)\n```\n\n> **Note:** `Function()` can be called with or without [`new`](/en-US/docs/Web/JavaScript/Reference/Operators/new). Both create a new `Function` instance.\n\n### Parameters\n\n- `arg1`, \u2026, `argN` {{optional_inline}}\n\n  - : Names to be used by the function as formal argument names. Each must be a string that corresponds to a valid JavaScript parameter (any of plain [identifier](/en-US/docs/Glossary/Identifier), [rest parameter](/en-US/docs/Web/JavaScript/Reference/Functions/rest_parameters), or [destructured](/en-US/docs/Web/JavaScript/Reference/Operators/Destructuring_assignment) parameter, optionally with a [default](/en-US/docs/Web/JavaScript/Reference/Functions/Default_parameters)), or a list of such strings separated with commas.\n\n    As the parameters are parsed in the same way as function expressions, whitespace and comments are accepted. For example: `"x", "theValue = 42", "[a, b] /* numbers */"` \u2014 or `"x, theValue = 42, [a, b] /* numbers */"`. (`"x, theValue = 42", "[a, b]"` is also correct, though very confusing to read.)\n\n- `functionBody`\n  - : A string containing the JavaScript statements comprising the function definition.\n\n## Description\n\n`Function` objects created with the `Function` constructor are parsed when the function is created. This is less efficient than creating a function with a [function expression](/en-US/docs/Web/JavaScript/Reference/Operators/function) or [function declaration](/en-US/docs/Web/JavaScript/Reference/Statements/function) and calling it within your code, because such functions are parsed with the rest of the code.\n\nAll arguments passed to the function, except the last, are treated as the names of the identifiers of the parameters in the function to be created, in the order in which they are passed. The function will be dynamically compiled as a function expression, with the source assembled in the following fashion:\n\n```js\n`function anonymous(${args.join(",")}\n) {\n${functionBody}\n}`;\n```\n\nThis is observable by calling the function\'s [`toString()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/toString) method.\n\nHowever, unlike normal [function expressions](/en-US/docs/Web/JavaScript/Reference/Operators/function), the name `anonymous` is not added to the `functionBody`\'s scope, since `functionBody` only has access the global scope. If `functionBody` is not in [strict mode](/en-US/docs/Web/JavaScript/Reference/Strict_mode) (the body itself needs to have the `"use strict"` directive since it doesn\'t inherit the strictness from the context), you may use [`arguments.callee`](/en-US/docs/Web/JavaScript/Reference/Functions/arguments/callee) to refer to the function itself. Alternatively, you can define the recursive part as an inner function:\n\n```js\nconst recursiveFn = new Function(\n  "count",\n  `\n(function recursiveFn(count) {\n  if (count < 0) {\n    return;\n  }\n  console.log(count);\n  recursiveFn(count - 1);\n})(count);\n`,\n);\n```\n\nNote that the two dynamic parts of the assembled source \u2014 the parameters list `args.join(",")` and `functionBody` \u2014 will first be parsed separately to ensure they are each syntactically valid. This prevents injection-like attempts.\n\n```js\nnew Function("/*", "*/) {");\n// SyntaxError: Unexpected end of arg string\n// Doesn\'t become "function anonymous(/*) {*/) {}"\n```\n\n## Examples\n\n### Specifying arguments with the Function constructor\n\nThe following code creates a `Function` object that takes two arguments.\n\n```js\n// Example can be run directly in your JavaScript console\n\n// Create a function that takes two arguments, and returns the sum of those arguments\nconst adder = new Function("a", "b", "return a + b");\n\n// Call the function\nadder(2, 6);\n// 8\n```\n\nThe arguments `a` and `b` are formal argument names that are used in the function body, `return a + b`.\n\n### Creating a function object from a function declaration or function expression\n\n```js\n// The function constructor can take in multiple statements separated by a semicolon. Function expressions require a return statement with the function\'s name\n\n// Observe that new Function is called. This is so we can call the function we created directly afterwards\nconst sumOfArray = new Function(\n  "const sumArray = (arr) => arr.reduce((previousValue, currentValue) => previousValue + currentValue); return sumArray",\n)();\n\n// call the function\nsumOfArray([1, 2, 3, 4]);\n// 10\n\n// If you don\'t call new Function at the point of creation, you can use the Function.call() method to call it\nconst findLargestNumber = new Function(\n  "function findLargestNumber (arr) { return Math.max(...arr) }; return findLargestNumber",\n);\n\n// call the function\nfindLargestNumber.call({}).call({}, [2, 4, 1, 8, 5]);\n// 8\n\n// Function declarations do not require a return statement\nconst sayHello = new Function(\n  "return function (name) { return `Hello, ${name}` }",\n)();\n\n// call the function\nsayHello("world");\n// Hello, world\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [`function`](/en-US/docs/Web/JavaScript/Reference/Statements/function)\n- [`function` expression](/en-US/docs/Web/JavaScript/Reference/Operators/function)\n- {{jsxref("Functions", "Functions", "", 1)}}\n'
        },
        "index.md": '---\ntitle: Function\nslug: Web/JavaScript/Reference/Global_Objects/Function\npage-type: javascript-class\nbrowser-compat: javascript.builtins.Function\n---\n\n{{JSRef}}\n\nThe **`Function`** object provides methods for [functions](/en-US/docs/Web/JavaScript/Reference/Functions). In JavaScript, every function is actually a `Function` object.\n\n## Constructor\n\n- {{jsxref("Function/Function", "Function()")}}\n  - : Creates a new `Function` object. Calling the constructor directly can create functions dynamically but suffers from security and similar (but far less significant) performance issues to {{jsxref("Global_Objects/eval", "eval()")}}. However, unlike `eval()`, the `Function` constructor creates functions that execute in the global scope only.\n\n## Instance properties\n\nThese properties are defined on `Function.prototype` and shared by all `Function` instances.\n\n- {{jsxref("Function.prototype.arguments")}} {{deprecated_inline}} {{non-standard_inline}}\n  - : Represents the arguments passed to this function. For [strict](/en-US/docs/Web/JavaScript/Reference/Strict_mode), arrow, async, and generator functions, accessing the `arguments` property throws a {{jsxref("TypeError")}}. Use the {{jsxref("Functions/arguments", "arguments")}} object inside function closures instead.\n- {{jsxref("Function.prototype.caller")}} {{deprecated_inline}} {{non-standard_inline}}\n  - : Represents the function that invoked this function. For [strict](/en-US/docs/Web/JavaScript/Reference/Strict_mode), arrow, async, and generator functions, accessing the `caller` property throws a {{jsxref("TypeError")}}.\n- {{jsxref("Object/constructor", "Function.prototype.constructor")}}\n  - : The constructor function that created the instance object. For `Function` instances, the initial value is the {{jsxref("Function/Function", "Function")}} constructor.\n\nThese properties are own properties of each `Function` instance.\n\n- {{jsxref("Function/displayName", "displayName")}} {{non-standard_inline}} {{optional_inline}}\n  - : The display name of the function.\n- {{jsxref("Function/length", "length")}}\n  - : Specifies the number of arguments expected by the function.\n- {{jsxref("Function/name", "name")}}\n  - : The name of the function.\n- {{jsxref("Function/prototype", "prototype")}}\n  - : Used when the function is used as a constructor with the [`new`](/en-US/docs/Web/JavaScript/Reference/Operators/new) operator. It will become the new object\'s prototype.\n\n## Instance methods\n\n- {{jsxref("Function.prototype.apply()")}}\n  - : Calls a function with a given `this` value and optional arguments provided as an array (or an [array-like object](/en-US/docs/Web/JavaScript/Guide/Indexed_collections#working_with_array-like_objects)).\n- {{jsxref("Function.prototype.bind()")}}\n  - : Creates a new function that, when called, has its `this` keyword set to a provided value, optionally with a given sequence of arguments preceding any provided when the new function is called.\n- {{jsxref("Function.prototype.call()")}}\n  - : Calls a function with a given `this` value and optional arguments.\n- {{jsxref("Function.prototype.toString()")}}\n  - : Returns a string representing the source code of the function.\n    Overrides the {{jsxref("Object.prototype.toString")}} method.\n- [`Function.prototype[@@hasInstance]()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/@@hasInstance)\n  - : Specifies the default procedure for determining if a constructor function recognizes an object as one of the constructor\'s instances. Called by the [`instanceof`](/en-US/docs/Web/JavaScript/Reference/Operators/instanceof) operator.\n\n## Examples\n\n### Difference between Function constructor and function declaration\n\nFunctions created with the `Function` constructor do not create closures to their creation contexts; they always are created in the global scope. When running them, they will only be able to access their own local variables and global ones, not the ones from the scope in which the `Function` constructor was created. This is different from using {{jsxref("Global_Objects/eval", "eval()")}} with code for a function expression.\n\n```js\n// Create a global property with `var`\nvar x = 10;\n\nfunction createFunction1() {\n  const x = 20;\n  return new Function("return x;"); // this `x` refers to global `x`\n}\n\nfunction createFunction2() {\n  const x = 20;\n  function f() {\n    return x; // this `x` refers to the local `x` above\n  }\n  return f;\n}\n\nconst f1 = createFunction1();\nconsole.log(f1()); // 10\nconst f2 = createFunction2();\nconsole.log(f2()); // 20\n```\n\nWhile this code works in web browsers, `f1()` will produce a `ReferenceError` in Node.js, as `x` will not be found. This is because the top-level scope in Node is not the global scope, and `x` will be local to the module.\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [`function`](/en-US/docs/Web/JavaScript/Reference/Statements/function)\n- [`function` expression](/en-US/docs/Web/JavaScript/Reference/Operators/function)\n- {{jsxref("AsyncFunction")}}\n- {{jsxref("AsyncGeneratorFunction")}}\n- {{jsxref("GeneratorFunction")}}\n- {{jsxref("Functions", "Functions", "", 1)}}\n',
        "length": {
            "index.md": '---\ntitle: "Function: length"\nslug: Web/JavaScript/Reference/Global_Objects/Function/length\npage-type: javascript-instance-data-property\nbrowser-compat: javascript.builtins.Function.length\n---\n\n{{JSRef}}\n\nThe **`length`** data property of a {{jsxref("Function")}} instance indicates the number of parameters expected by the function.\n\n{{EmbedInteractiveExample("pages/js/function-length.html")}}\n\n## Value\n\nA number.\n\n{{js_property_attributes(0, 0, 1)}}\n\n## Description\n\nA {{jsxref("Function")}} object\'s `length` property indicates how many arguments the function expects, i.e. the number of formal parameters. This number excludes the {{jsxref("Functions/rest_parameters", "rest parameter", "", 1)}} and only includes parameters before the first one with a default value. By contrast, {{jsxref("Functions/arguments/length", "arguments.length")}} is local to a function and provides the number of arguments actually passed to the function.\n\nThe {{jsxref("Function")}} constructor is itself a `Function` object. Its `length` data property has a value of `1`.\n\nDue to historical reasons, `Function.prototype` is a callable itself. The `length` property of `Function.prototype` has a value of `0`.\n\n## Examples\n\n### Using function length\n\n```js\nconsole.log(Function.length); // 1\n\nconsole.log((() => {}).length); // 0\nconsole.log(((a) => {}).length); // 1\nconsole.log(((a, b) => {}).length); // 2 etc.\n\nconsole.log(((...args) => {}).length);\n// 0, rest parameter is not counted\n\nconsole.log(((a, b = 1, c) => {}).length);\n// 1, only parameters before the first one with\n// a default value are counted\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Function")}}\n'
        },
        "name": {
            "index.md": '---\ntitle: "Function: name"\nslug: Web/JavaScript/Reference/Global_Objects/Function/name\npage-type: javascript-instance-data-property\nbrowser-compat: javascript.builtins.Function.name\n---\n\n{{JSRef}}\n\nThe **`name`** data property of a {{jsxref("Function")}} instance indicates the function\'s name as specified when it was created, or it may be either `anonymous` or `\'\'` (an empty string) for functions created anonymously.\n\n{{EmbedInteractiveExample("pages/js/function-name.html")}}\n\n## Value\n\nA string.\n\n{{js_property_attributes(0, 0, 1)}}\n\n> **Note:** In non-standard, pre-ES2015 implementations the `configurable` attribute was `false` as well.\n\n## Description\n\nThe function\'s `name` property can be used to identify the function in debugging tools or error messages. It has no semantic significance to the language itself.\n\nThe `name` property is read-only and cannot be changed by the assignment operator:\n\n```js\nfunction someFunction() {}\n\nsomeFunction.name = "otherFunction";\nconsole.log(someFunction.name); // someFunction\n```\n\nTo change it, use {{jsxref("Object.defineProperty()")}}.\n\nThe `name` property is typically inferred from how the function is defined. In the following sections, we will describe the various ways in which it can be inferred.\n\n### Function declaration\n\nThe `name` property returns the name of a function declaration.\n\n```js\nfunction doSomething() {}\ndoSomething.name; // "doSomething"\n```\n\n### Default-exported function declaration\n\nAn [`export default`](/en-US/docs/Web/JavaScript/Reference/Statements/export) declaration exports the function as a declaration instead of an expression. If the declaration is anonymous, the name is `"default"`.\n\n```js\n// -- someModule.js --\nexport default function () {}\n\n// -- main.js --\nimport someModule from "./someModule.js";\n\nsomeModule.name; // "default"\n```\n\n### Function constructor\n\nFunctions created with the [`Function()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/Function) constructor have name "anonymous".\n\n```js\nnew Function().name; // "anonymous"\n```\n\n### Function expression\n\nIf the function expression is named, that name is used as the `name` property.\n\n```js\nconst someFunction = function someFunctionName() {};\nsomeFunction.name; // "someFunctionName"\n```\n\nAnonymous function expressions created using the keyword `function` or arrow functions would have `""` (an empty string) as their name.\n\n```js\n(function () {}).name; // ""\n(() => {}).name; // ""\n```\n\nHowever, such cases are rare \u2014 usually, in order to refer to the expression elsewhere, the function expression is attached to an identifier when it\'s created (such as in a variable declaration). In such cases, the name can be inferred, as the following few subsections demonstrate.\n\nOne practical case where the name cannot be inferred is a function returned from another function:\n\n```js\nfunction getFoo() {\n  return () => {};\n}\ngetFoo().name; // ""\n```\n\n### Variable declaration and method\n\nVariables and methods can infer the name of an anonymous function from its syntactic position.\n\n```js\nconst f = function () {};\nconst object = {\n  someMethod: function () {},\n};\n\nconsole.log(f.name); // "f"\nconsole.log(object.someMethod.name); // "someMethod"\n```\n\nThe same applies to assignment:\n\n```js\nlet f;\nf = () => {};\nf.name; // "f"\n```\n\n### Initializer and default value\n\nFunctions in initializers (default values) of [destructuring](/en-US/docs/Web/JavaScript/Reference/Operators/Destructuring_assignment#default_value), [default parameters](/en-US/docs/Web/JavaScript/Reference/Functions/Default_parameters), [class fields](/en-US/docs/Web/JavaScript/Reference/Classes/Public_class_fields), etc., will inherit the name of the bound identifier as their `name`.\n\n```js\nconst [f = () => {}] = [];\nf.name; // "f"\n\nconst { someMethod: m = () => {} } = {};\nm.name; // "m"\n\nfunction foo(f = () => {}) {\n  console.log(f.name);\n}\nfoo(); // "f"\n\nclass Foo {\n  static someMethod = () => {};\n}\nFoo.someMethod.name; // someMethod\n```\n\n### Shorthand method\n\n```js\nconst o = {\n  foo() {},\n};\no.foo.name; // "foo";\n```\n\n### Bound function\n\n{{jsxref("Function.prototype.bind()")}} produces a function whose name is "bound " plus the function name.\n\n```js\nfunction foo() {}\nfoo.bind({}).name; // "bound foo"\n```\n\n### Getter and setter\n\nWhen using [`get`](/en-US/docs/Web/JavaScript/Reference/Functions/get) and [`set`](/en-US/docs/Web/JavaScript/Reference/Functions/set) accessor properties, "get" or "set" will appear in the function name.\n\n```js\nconst o = {\n  get foo() {},\n  set foo(x) {},\n};\n\nconst descriptor = Object.getOwnPropertyDescriptor(o, "foo");\ndescriptor.get.name; // "get foo"\ndescriptor.set.name; // "set foo";\n```\n\n### Class\n\nA class\'s name follows the same algorithm as function declarations and expressions.\n\n```js\nclass Foo {}\nFoo.name; // "Foo"\n```\n\n> **Warning:** JavaScript will set the function\'s `name` property only if a function does not have an own property called `name`. However, classes\' [static members](/en-US/docs/Web/JavaScript/Reference/Classes/static) will be set as own properties of the class constructor function, and thus prevent the built-in `name` from being applied. See [an example](#telling_the_constructor_name_of_an_object) below.\n\n### Symbol as function name\n\nIf a {{jsxref("Symbol")}} is used a function name and the symbol has a description, the method\'s name is the description in square brackets.\n\n```js\nconst sym1 = Symbol("foo");\nconst sym2 = Symbol();\n\nconst o = {\n  [sym1]() {},\n  [sym2]() {},\n};\n\no[sym1].name; // "[foo]"\no[sym2].name; // "[]"\n```\n\n### Private property\n\nPrivate fields and private methods have the hash (`#`) as part of their names.\n\n```js\nclass Foo {\n  #field = () => {};\n  #method() {}\n  getNames() {\n    console.log(this.#field.name);\n    console.log(this.#method.name);\n  }\n}\n\nnew Foo().getNames();\n// "#field"\n// "#method"\n```\n\n## Examples\n\n### Telling the constructor name of an object\n\nYou can use `obj.constructor.name` to check the "class" of an object.\n\n```js\nfunction Foo() {} // Or: class Foo {}\n\nconst fooInstance = new Foo();\nconsole.log(fooInstance.constructor.name); // "Foo"\n```\n\nHowever, because static members will become own properties of the class, we can\'t obtain the class name for virtually any class with a static method property `name()`:\n\n```js\nclass Foo {\n  constructor() {}\n  static name() {}\n}\n```\n\nWith a `static name()` method `Foo.name` no longer holds the actual class name but a reference to the `name()` function object. Trying to obtain the class of `fooInstance` via `fooInstance.constructor.name` won\'t give us the class name at all, but instead a reference to the static class method. Example:\n\n```js\nconst fooInstance = new Foo();\nconsole.log(fooInstance.constructor.name); // \u0192 name() {}\n```\n\nDue to the existence of static fields, `name` may not be a function either.\n\n```js\nclass Foo {\n  static name = 123;\n}\nconsole.log(new Foo().constructor.name); // 123\n```\n\nIf a class has a static property called `name`, it will also become _writable_. The built-in definition in the absence of a custom static definition is _read-only_:\n\n```js\nFoo.name = "Hello";\nconsole.log(Foo.name); // "Hello" if class Foo has a static "name" property, but "Foo" if not.\n```\n\nTherefore you may not rely on the built-in `name` property to always hold a class\'s name.\n\n### JavaScript compressors and minifiers\n\n> **Warning:** Be careful when using the `name` property with source-code transformations, such as those carried out by JavaScript compressors (minifiers) or obfuscators. These tools are often used as part of a JavaScript build pipeline to reduce the size of a program prior to deploying it to production. Such transformations often change a function\'s name at build time.\n\nSource code such as:\n\n```js\nfunction Foo() {}\nconst foo = new Foo();\n\nif (foo.constructor.name === "Foo") {\n  console.log("\'foo\' is an instance of \'Foo\'");\n} else {\n  console.log("Oops!");\n}\n```\n\nmay be compressed to:\n\n```js\nfunction a() {}\nconst b = new a();\nif (b.constructor.name === "Foo") {\n  console.log("\'foo\' is an instance of \'Foo\'");\n} else {\n  console.log("Oops!");\n}\n```\n\nIn the uncompressed version, the program runs into the truthy branch and logs "\'foo\' is an instance of \'Foo\'" \u2014 whereas, in the compressed version it behaves differently, and runs into the else branch. If you rely on the `name` property, like in the example above, make sure your build pipeline doesn\'t change function names, or don\'t assume a function has a particular name.\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill for `Function: name` in `core-js`](https://github.com/zloirock/core-js#ecmascript-function)\n- {{jsxref("Function")}}\n'
        },
        "prototype": {
            "index.md": '---\ntitle: "Function: prototype"\nslug: Web/JavaScript/Reference/Global_Objects/Function/prototype\npage-type: javascript-instance-data-property\nspec-urls: https://tc39.es/ecma262/multipage/fundamental-objects.html#sec-function-instances-prototype\n---\n\n{{JSRef}}\n\nThe **`prototype`** data property of a {{jsxref("Function")}} instance is used when the function is used as a constructor with the [`new`](/en-US/docs/Web/JavaScript/Reference/Operators/new) operator. It will become the new object\'s prototype.\n\n> **Note:** Not all {{jsxref("Function")}} objects have the `prototype` property \u2014 see [description](#description).\n\n## Value\n\nAn object.\n\n{{js_property_attributes(1, 0, 0)}}\n\n> **Note:** The `prototype` property of [classes](/en-US/docs/Web/JavaScript/Reference/Classes) is not writable.\n\n## Description\n\nWhen a function is called with [`new`](/en-US/docs/Web/JavaScript/Reference/Operators/new), the constructor\'s `prototype` property will become the resulting object\'s prototype.\n\n```js\nfunction Ctor() {}\nconst inst = new Ctor();\nconsole.log(Object.getPrototypeOf(inst) === Ctor.prototype); // true\n```\n\nYou can read [Inheritance and the prototype chain](/en-US/docs/Web/JavaScript/Inheritance_and_the_prototype_chain#constructors) for more information about the interactions between a constructor function\'s `prototype` property and the resulting object\'s prototype.\n\nA function having a `prototype` property is not sufficient for it to be eligible as a constructor. [Generator functions](/en-US/docs/Web/JavaScript/Reference/Statements/function*) have a `prototype` property, but cannot be called with `new`:\n\n```js\nasync function* asyncGeneratorFunction() {}\nfunction* generatorFunction() {}\n```\n\nInstead, generator functions\' `prototype` property is used when they are called _without_ `new`. The `prototype` property will become the returned [`Generator`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Generator) object\'s prototype.\n\nIn addition, some functions may have a `prototype` but throw unconditionally when called with `new`. For example, the [`Symbol()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol/Symbol) and [`BigInt()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/BigInt/BigInt) functions throw when called with `new`, because `Symbol.prototype` and `BigInt.prototype` are only intended to provide methods for the primitive values, but the wrapper objects should not be directly constructed.\n\nThe following functions do not have `prototype`, and are therefore ineligible as constructors, even if a `prototype` property is later manually assigned:\n\n```js\nconst method = { foo() {} }.foo;\nconst arrowFunction = () => {};\nasync function asyncFunction() {}\n```\n\nThe following are valid constructors that have `prototype`:\n\n```js\nclass Class {}\nfunction fn() {}\n```\n\nA [bound function](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/bind) does not have a `prototype` property, but may be constructable. When it\'s constructed, the target function is constructed instead, and if the target function is constructable, it would return a normal instance.\n\n```js\nconst boundFunction = function () {}.bind(null);\n```\n\nA function\'s `prototype` property, by default, is a plain object with one property: [`constructor`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/constructor), which is a reference to the function itself. The `constructor` property is writable, non-enumerable, and configurable.\n\nIf the `prototype` of a function is reassigned with something other than an {{jsxref("Object")}}, when the function is called with `new`, the returned object\'s prototype would be `Object.prototype` instead. (In other words, `new` ignores the `prototype` property and constructs a plain object.)\n\n```js\nfunction Ctor() {}\nCtor.prototype = 3;\nconsole.log(Object.getPrototypeOf(new Ctor()) === Object.prototype); // true\n```\n\n## Examples\n\n### Changing the prototype of all instances by mutating the prototype property\n\n```js\nfunction Ctor() {}\nconst p1 = new Ctor();\nconst p2 = new Ctor();\nCtor.prototype.prop = 1;\nconsole.log(p1.prop); // 1\nconsole.log(p2.prop); // 1\n```\n\n### Adding a non-method property to a class\'s prototype property\n\n[Class fields](/en-US/docs/Web/JavaScript/Reference/Classes/Public_class_fields) add properties to each instance. Class methods declare _function_ properties on the prototype. However, there\'s no way to add a non-function property to the prototype. In case you want to share static data between all instances (for example, [`Error.prototype.name`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error/name) is the same between all error instances), you can manually assign it on the `prototype` of a class.\n\n```js\nclass Dog {\n  constructor(name) {\n    this.name = name;\n  }\n}\n\nDog.prototype.species = "dog";\n\nconsole.log(new Dog("Jack").species); // "dog"\n```\n\nThis can be made more ergonomic using [static initialization blocks](/en-US/docs/Web/JavaScript/Reference/Classes/Static_initialization_blocks), which are called when the class is initialized.\n\n```js\nclass Dog {\n  static {\n    Dog.prototype.species = "dog";\n  }\n  constructor(name) {\n    this.name = name;\n  }\n}\n\nconsole.log(new Dog("Jack").species); // "dog"\n```\n\n## Specifications\n\n{{Specifications}}\n\n## See also\n\n- {{jsxref("Function")}}\n- [Inheritance and the prototype chain](/en-US/docs/Web/JavaScript/Inheritance_and_the_prototype_chain#constructors)\n'
        },
        "tostring": {
            "index.md": '---\ntitle: Function.prototype.toString()\nslug: Web/JavaScript/Reference/Global_Objects/Function/toString\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Function.toString\n---\n\n{{JSRef}}\n\nThe **`toString()`** method of {{jsxref("Function")}} instances returns a string representing the source code of this function.\n\n{{EmbedInteractiveExample("pages/js/function-tostring.html")}}\n\n## Syntax\n\n```js-nolint\ntoString()\n```\n\n### Parameters\n\nNone.\n\n### Return value\n\nA string representing the source code of the function.\n\n## Description\n\nThe {{jsxref("Function")}} object overrides the `toString()` method\ninherited from {{jsxref("Object")}}; it does not inherit\n{{jsxref("Object.prototype.toString")}}. For user-defined `Function`\nobjects, the `toString` method returns a string containing the source text\nsegment which was used to define the function.\n\nJavaScript calls the `toString` method automatically when a\n`Function` is to be represented as a text value, e.g. when a function is\nconcatenated with a string.\n\nThe `toString()` method will throw a {{jsxref("TypeError")}} exception\n("Function.prototype.toString called on incompatible object"), if its\n`this` value object is not a `Function` object.\n\n```js example-bad\nFunction.prototype.toString.call("foo"); // throws TypeError\n```\n\nIf the `toString()` method is called on built-in function objects, a\nfunction created by {{jsxref("Function.prototype.bind()")}}, or\nother non-JavaScript functions, then `toString()` returns a\n_native function string_ which looks like\n\n```plain\nfunction someName() { [native code] }\n```\n\nFor intrinsic object methods and functions, `someName` is the initial name of the function; otherwise its content may be implementation-defined, but will always be in property name syntax, like `[1 + 1]`, `someName`, or `1`.\n\n> **Note:** This means using [`eval()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/eval) on native function strings is a guaranteed syntax error.\n\nIf the `toString()` method is called on a function created by the `Function` constructor, `toString()` returns the source code of a synthesized function declaration named "anonymous" using the provided parameters and function body. For example, `Function("a", "b", "return a + b").toString()` will return:\n\n```plain\nfunction anonymous(a,b\n) {\nreturn a + b\n}\n```\n\nSince ES2018, the spec requires the return value of `toString()` to be the exact same source code as it was declared, including any whitespace and/or comments \u2014 or, if the host doesn\'t have the source code available for some reason, requires returning a native function string. Support for this revised behavior can be found in the [compatibility table](#browser_compatibility).\n\n## Examples\n\n### Comparing actual source code and toString results\n\n```js\nfunction test(fn) {\n  console.log(fn.toString());\n}\n\nfunction f() {}\nclass A {\n  a() {}\n}\nfunction* g() {}\n\ntest(f); // "function f() {}"\ntest(A); // "class A { a() {} }"\ntest(g); // "function* g() {}"\ntest((a) => a); // "(a) => a"\ntest({ a() {} }.a); // "a() {}"\ntest({ *a() {} }.a); // "*a() {}"\ntest({ [0]() {} }[0]); // "[0]() {}"\ntest(Object.getOwnPropertyDescriptor({ get a() {} }, "a").get); // "get a() {}"\ntest(Object.getOwnPropertyDescriptor({ set a(x) {} }, "a").set); // "set a(x) {}"\ntest(Function.prototype.toString); // "function toString() { [native code] }"\ntest(function f() {}.bind(0)); // "function () { [native code] }"\ntest(Function("a", "b")); // function anonymous(a\\n) {\\nb\\n}\n```\n\nNote that after the `Function.prototype.toString()` revision, when `toString()` is called, implementations are never allowed to synthesize a function\'s source that is not a native function string. The method always returns the exact source code used to create the function \u2014 including the [getter](/en-US/docs/Web/JavaScript/Reference/Functions/get) and [setter](/en-US/docs/Web/JavaScript/Reference/Functions/set) examples above. The [`Function`](/en-US/docs/Web/JavaScript/Reference/Functions) constructor itself has the capability of synthesizing the source code for the function (and is therefore a form of implicit [`eval()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/eval)).\n\n### Getting source text of a function\n\nIt is possible to get the source text of a function by coercing it to a string \u2014 for example, by wrapping it in a template literal:\n\n```js\nfunction foo() {\n  return "bar";\n}\nconsole.log(`${foo}`);\n// function foo() {\n//   return "bar";\n// }\n```\n\nThis source text is _exact_, including any interspersed comments (which won\'t be stored by the engine\'s internal representation otherwise).\n\n```js\nfunction foo /* a comment */() {\n  return "bar";\n}\nconsole.log(foo.toString());\n// function foo /* a comment */() {\n//   return "bar";\n// }\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Object.prototype.toString()")}}\n'
        }
    },
    "generator": {
        "index.md": '---\ntitle: Generator\nslug: Web/JavaScript/Reference/Global_Objects/Generator\npage-type: javascript-class\nbrowser-compat: javascript.builtins.Generator\n---\n\n{{JSRef}}\n\nThe **`Generator`** object is returned by a {{jsxref("Statements/function*", "generator function", "", 1)}} and it conforms to both the [iterable protocol](/en-US/docs/Web/JavaScript/Reference/Iteration_protocols#the_iterable_protocol) and the [iterator protocol](/en-US/docs/Web/JavaScript/Reference/Iteration_protocols#the_iterator_protocol).\n\n`Generator` is a subclass of the hidden {{jsxref("Iterator")}} class.\n\n{{EmbedInteractiveExample("pages/js/expressions-functionasteriskexpression.html", "taller")}}\n\n## Constructor\n\nThe `Generator` constructor is not available globally. Instances of `Generator` must be returned from [generator functions](/en-US/docs/Web/JavaScript/Reference/Statements/function*):\n\n```js\nfunction* generator() {\n  yield 1;\n  yield 2;\n  yield 3;\n}\n\nconst gen = generator(); // "Generator { }"\n\nconsole.log(gen.next().value); // 1\nconsole.log(gen.next().value); // 2\nconsole.log(gen.next().value); // 3\n```\n\nIn fact, there\'s no JavaScript entity that corresponds to the `Generator` constructor. There\'s only a hidden object which is the prototype object shared by all objects created by generator functions. This object is often stylized as `Generator.prototype` to make it look like a class, but it should be more appropriately called [`GeneratorFunction.prototype.prototype`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/GeneratorFunction), because `GeneratorFunction` is an actual JavaScript entity.\n\n## Instance properties\n\nThese properties are defined on `Generator.prototype` and shared by all `Generator` instances.\n\n- {{jsxref("Object/constructor", "Generator.prototype.constructor")}}\n\n  - : The constructor function that created the instance object. For `Generator` instances, the initial value is [`GeneratorFunction.prototype`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/GeneratorFunction).\n\n    > **Note:** `Generator` objects do not store a reference to the generator function that created them.\n\n- `Generator.prototype[@@toStringTag]`\n  - : The initial value of the [`@@toStringTag`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol/toStringTag) property is the string `"Generator"`. This property is used in {{jsxref("Object.prototype.toString()")}}.\n\n## Instance methods\n\n_Also inherits instance methods from its parent {{jsxref("Iterator")}}_.\n\n- {{jsxref("Generator.prototype.next()")}}\n  - : Returns a value yielded by the {{jsxref("Operators/yield", "yield")}} expression.\n- {{jsxref("Generator.prototype.return()")}}\n  - : Acts as if a `return` statement is inserted in the generator\'s body at the current suspended position, which finishes the generator and allows the generator to perform any cleanup tasks when combined with a [`try...finally`](/en-US/docs/Web/JavaScript/Reference/Statements/try...catch#the_finally_block) block.\n- {{jsxref("Generator.prototype.throw()")}}\n  - : Acts as if a `throw` statement is inserted in the generator\'s body at the current suspended position, which informs the generator of an error condition and allows it to handle the error, or perform cleanup and close itself.\n\n## Examples\n\n### An infinite iterator\n\nWith a generator function, values are not evaluated until they are needed. Therefore a generator allows us to define a potentially infinite data structure.\n\n```js\nfunction* infinite() {\n  let index = 0;\n\n  while (true) {\n    yield index++;\n  }\n}\n\nconst generator = infinite(); // "Generator { }"\n\nconsole.log(generator.next().value); // 0\nconsole.log(generator.next().value); // 1\nconsole.log(generator.next().value); // 2\n// \u2026\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Statements/function*", "function*")}}\n- [`function*` expression](/en-US/docs/Web/JavaScript/Reference/Operators/function*)\n- {{jsxref("GeneratorFunction")}}\n- [Iteration protocols](/en-US/docs/Web/JavaScript/Reference/Iteration_protocols)\n',
        "next": {
            "index.md": '---\ntitle: Generator.prototype.next()\nslug: Web/JavaScript/Reference/Global_Objects/Generator/next\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Generator.next\n---\n\n{{JSRef}}\n\nThe **`next()`** method of {{jsxref("Generator")}} instances returns an\nobject with two properties `done` and `value`. You can also\nprovide a parameter to the `next` method to send a value to the\ngenerator.\n\n## Syntax\n\n```js-nolint\nnext()\nnext(value)\n```\n\n### Parameters\n\n- `value` {{optional_inline}}\n\n  - : The value to send to the generator.\n\n    The value will be assigned as a result of a `yield` expression. For\n    example, in `variable = yield expression`, the value\n    passed to the `.next()` function will be assigned to\n    `variable`.\n\n### Return value\n\nAn {{jsxref("Object")}} with two properties:\n\n- `done`\n  - : A boolean value:\n    - `true` if the generator is past the end of its control flow. In this case `value` specifies the _return value_ of the generator (which may be undefined).\n    - `false` if the generator is able to produce more values.\n- `value`\n  - : Any JavaScript value yielded or returned by the generator.\n\n## Examples\n\n### Using next()\n\nThe following example shows a simple generator and the object that the\n`next` method returns:\n\n```js\nfunction* gen() {\n  yield 1;\n  yield 2;\n  yield 3;\n}\n\nconst g = gen(); // Generator { }\ng.next(); // { value: 1, done: false }\ng.next(); // { value: 2, done: false }\ng.next(); // { value: 3, done: false }\ng.next(); // { value: undefined, done: true }\n```\n\n### Using next() with a list\n\nIn this example, `getPage` takes a list and "paginates" it into chunks of size `pageSize`. Each call to `next` will yield one such chunk.\n\n```js\nfunction* getPage(list, pageSize = 1) {\n  for (let index = 0; index < list.length; index += pageSize) {\n    yield list.slice(index, index + pageSize);\n  }\n}\n\nconst list = [1, 2, 3, 4, 5, 6, 7, 8];\nconst page = getPage(list, 3); // Generator { }\n\npage.next(); // { value: [1, 2, 3], done: false }\npage.next(); // { value: [4, 5, 6], done: false }\npage.next(); // { value: [7, 8], done: false }\npage.next(); // { value: undefined, done: true }\n```\n\n### Sending values to the generator\n\nIn this example, `next` is called with a value.\n\n> **Note:** The first call does not log anything, because the generator was not yielding anything initially.\n\n```js\nfunction* gen() {\n  while (true) {\n    const value = yield;\n    console.log(value);\n  }\n}\n\nconst g = gen();\ng.next(1); // Returns { value: undefined, done: false }\n// No log at this step: the first value sent through `next` is lost\ng.next(2); // Returns { value: undefined, done: false }\n// Logs 2\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Statements/function*", "function*")}}\n- [Iterators and generators](/en-US/docs/Web/JavaScript/Guide/Iterators_and_generators) guide\n'
        },
        "return": {
            "index.md": '---\ntitle: Generator.prototype.return()\nslug: Web/JavaScript/Reference/Global_Objects/Generator/return\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Generator.return\n---\n\n{{JSRef}}\n\nThe **`return()`** method of {{jsxref("Generator")}} instances acts as if a `return` statement is inserted in the generator\'s body at the current suspended position, which finishes the generator and allows the generator to perform any cleanup tasks when combined with a [`try...finally`](/en-US/docs/Web/JavaScript/Reference/Statements/try...catch#the_finally_block) block.\n\n## Syntax\n\n<!-- We don\'t usually add the "generatorInstance" subject for methods. However, it is necessary here, because "return" is a keyword, so otherwise it\'s invalid syntax. -->\n\n```js-nolint\ngeneratorInstance.return()\ngeneratorInstance.return(value)\n```\n\n### Parameters\n\n- `value` {{optional_inline}}\n  - : The value to return.\n\n### Return value\n\nAn {{jsxref("Object")}} with two properties:\n\n- `done`\n  - : A boolean value:\n    - `true` if the generator function\'s control flow has reached the end.\n    - `false` if the generator function\'s control flow hasn\'t reached the end and can produce more values. This can only happen if the `return` is captured in a [`try...finally`](/en-US/docs/Web/JavaScript/Reference/Statements/try...catch#the_finally_block) and there are more `yield` expressions in the `finally` block.\n- `value`\n  - : The value that is given as an argument, or, if the `yield` expression is wrapped in a [`try...finally`](/en-US/docs/Web/JavaScript/Reference/Statements/try...catch#the_finally_block), the value yielded/returned from the `finally` block.\n\n## Description\n\nThe `return()` method, when called, can be seen as if a `return value;` statement is inserted in the generator\'s body at the current suspended position, where `value` is the value passed to the `return()` method. Therefore, in a typical flow, calling `return(value)` will return `{ done: true, value: value }`. However, if the `yield` expression is wrapped in a `try...finally` block, the control flow doesn\'t exit the function body, but proceeds to the `finally` block instead. In this case, the value returned may be different, and `done` may even be `false`, if there are more `yield` expressions within the `finally` block.\n\n## Examples\n\n### Using return()\n\nThe following example shows a simple generator and the `return` method.\n\n```js\nfunction* gen() {\n  yield 1;\n  yield 2;\n  yield 3;\n}\n\nconst g = gen();\n\ng.next(); // { value: 1, done: false }\ng.return("foo"); // { value: "foo", done: true }\ng.next(); // { value: undefined, done: true }\n```\n\nIf `return(value)` is called on a generator that is already in "completed" state, the generator will remain in "completed" state.\n\nIf no argument is provided, the `value` property of the returned object will be `undefined`. If an argument is provided, it will become the value of the `value` property of the returned object, unless the `yield` expression is wrapped in a `try...finally`.\n\n```js\nfunction* gen() {\n  yield 1;\n  yield 2;\n  yield 3;\n}\n\nconst g = gen();\ng.next(); // { value: 1, done: false }\ng.next(); // { value: 2, done: false }\ng.next(); // { value: 3, done: false }\ng.next(); // { value: undefined, done: true }\ng.return(); // { value: undefined, done: true }\ng.return(1); // { value: 1, done: true }\n```\n\n### Using return() with try...finally\n\nThe fact that the `return` method has been called can only be made known to the generator itself if the `yield` expression is wrapped in a `try...finally` block.\n\nWhen the `return` method is called on a generator that is suspended within a `try` block, execution in the generator proceeds to the `finally` block \u2014 since the `finally` block of `try...finally` statements always executes.\n\n```js\nfunction* gen() {\n  yield 1;\n  try {\n    yield 2;\n    yield 3;\n  } finally {\n    yield "cleanup";\n  }\n}\n\nconst g1 = gen();\ng1.next(); // { value: 1, done: false }\n\n// Execution is suspended before the try...finally.\ng1.return("early return"); // { value: \'early return\', done: true }\n\nconst g2 = gen();\ng2.next(); // { value: 1, done: false }\ng2.next(); // { value: 2, done: false }\n\n// Execution is suspended within the try...finally.\ng2.return("early return"); // { value: \'cleanup\', done: false }\n\n// The completion value is preserved\ng2.next(); // { value: \'early return\', done: true }\n\n// Generator is in the completed state\ng2.return("not so early return"); // { value: \'not so early return\', done: true }\n```\n\nThe return value of the finally block can also become the `value` of the result returned from the `return` call.\n\n```js\nfunction* gen() {\n  try {\n    yield 1;\n  } finally {\n    return "cleanup";\n  }\n}\n\nconst g1 = gen();\ng1.next(); // { value: 1, done: false }\ng1.return("early return"); // { value: \'cleanup\', done: true }\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Statements/function*", "function*")}}\n'
        },
        "throw": {
            "index.md": '---\ntitle: Generator.prototype.throw()\nslug: Web/JavaScript/Reference/Global_Objects/Generator/throw\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Generator.throw\n---\n\n{{JSRef}}\n\nThe **`throw()`** method of {{jsxref("Generator")}} instances acts as if a `throw` statement is inserted in the generator\'s body at the current suspended position, which informs the generator of an error condition and allows it to handle the error, or perform cleanup and close itself.\n\n## Syntax\n\n<!-- We don\'t usually add the "generatorInstance" subject for methods. However, it is necessary here, because "throw" is a keyword, so otherwise it\'s invalid syntax. -->\n\n```js-nolint\ngeneratorInstance.throw(exception)\n```\n\n### Parameters\n\n- `exception`\n  - : The exception to throw. For debugging purposes, it is useful to make it an `instanceof` {{jsxref("Error")}}.\n\n### Return value\n\nIf the thrown exception is caught by a [`try...catch`](/en-US/docs/Web/JavaScript/Reference/Statements/try...catch) and the generator resumes to yield more values, it will return an {{jsxref("Object")}} with two properties:\n\n- `done`\n  - : A boolean value:\n    - `true` if the generator function\'s control flow has reached the end.\n    - `false` if the generator function is able to produce more values.\n- `value`\n  - : The value yielded from the next `yield` expression.\n\n### Exceptions\n\nIf the thrown exception is not caught by a `try...catch`, the `exception` passed to `throw()` will be thrown out from the generator function.\n\n## Description\n\nThe `throw()` method, when called, can be seen as if a `throw exception;` statement is inserted in the generator\'s body at the current suspended position, where `exception` is the exception passed to the `throw()` method. Therefore, in a typical flow, calling `throw(exception)` will cause the generator to throw. However, if the `yield` expression is wrapped in a `try...catch` block, the error may be caught and control flow can either resume after error handling, or exit gracefully.\n\n## Examples\n\n### Using throw()\n\nThe following example shows a simple generator and an error that is thrown using the `throw` method. An error can be caught by a {{jsxref("Statements/try...catch", "try...catch")}} block as usual.\n\n```js\nfunction* gen() {\n  while (true) {\n    try {\n      yield 42;\n    } catch (e) {\n      console.log("Error caught!");\n    }\n  }\n}\n\nconst g = gen();\ng.next();\n// { value: 42, done: false }\ng.throw(new Error("Something went wrong"));\n// "Error caught!"\n// { value: 42, done: false }\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Statements/function*", "function*")}}\n'
        }
    },
    "generatorfunction": {
        "generatorfunction": {
            "index.md": '---\ntitle: GeneratorFunction() constructor\nslug: Web/JavaScript/Reference/Global_Objects/GeneratorFunction/GeneratorFunction\npage-type: javascript-constructor\nbrowser-compat: javascript.builtins.GeneratorFunction.GeneratorFunction\n---\n\n{{JSRef}}\n\nThe **`GeneratorFunction()`** constructor creates {{jsxref("GeneratorFunction")}} objects.\n\nNote that `GeneratorFunction` is _not_ a global object. It can be obtained with the following code:\n\n```js\nconst GeneratorFunction = function* () {}.constructor;\n```\n\nThe `GeneratorFunction()` constructor is not intended to be used directly, and all caveats mentioned in the {{jsxref("Function/Function", "Function()")}} description apply to `GeneratorFunction()`.\n\n## Syntax\n\n```js-nolint\nnew GeneratorFunction(functionBody)\nnew GeneratorFunction(arg1, functionBody)\nnew GeneratorFunction(arg1, arg2, functionBody)\nnew GeneratorFunction(arg1, arg2, /* \u2026, */ argN, functionBody)\n\nGeneratorFunction(functionBody)\nGeneratorFunction(arg1, functionBody)\nGeneratorFunction(arg1, arg2, functionBody)\nGeneratorFunction(arg1, arg2, /* \u2026, */ argN, functionBody)\n```\n\n> **Note:** `GeneratorFunction()` can be called with or without [`new`](/en-US/docs/Web/JavaScript/Reference/Operators/new). Both create a new `GeneratorFunction` instance.\n\n### Parameters\n\nSee {{jsxref("Function/Function", "Function()")}}.\n\n## Examples\n\n### Creating and using a GeneratorFunction() constructor\n\n```js\nconst GeneratorFunction = function* () {}.constructor;\nconst g = new GeneratorFunction("a", "yield a * 2");\nconst iterator = g(10);\nconsole.log(iterator.next().value); // 20\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [`function*`](/en-US/docs/Web/JavaScript/Reference/Statements/function*)\n- [`function*` expression](/en-US/docs/Web/JavaScript/Reference/Operators/function*)\n- [`Function()` constructor](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/Function)\n- [Iterators and generators](/en-US/docs/Web/JavaScript/Guide/Iterators_and_generators) guide\n- {{jsxref("Functions", "Functions", "", 1)}}\n'
        },
        "index.md": '---\ntitle: GeneratorFunction\nslug: Web/JavaScript/Reference/Global_Objects/GeneratorFunction\npage-type: javascript-class\nbrowser-compat: javascript.builtins.GeneratorFunction\n---\n\n{{JSRef}}\n\nThe **`GeneratorFunction`** object provides methods for [generator functions](/en-US/docs/Web/JavaScript/Reference/Statements/function*). In JavaScript, every generator function is actually a `GeneratorFunction` object.\n\nNote that `GeneratorFunction` is _not_ a global object. It can be obtained with the following code:\n\n```js\nconst GeneratorFunction = function* () {}.constructor;\n```\n\n`GeneratorFunction` is a subclass of {{jsxref("Function")}}.\n\n{{EmbedInteractiveExample("pages/js/functionasterisk-function.html", "taller")}}\n\n## Constructor\n\n- {{jsxref("GeneratorFunction/GeneratorFunction", "GeneratorFunction()")}}\n  - : Creates a new `GeneratorFunction` object.\n\n## Instance properties\n\n_Also inherits instance properties from its parent {{jsxref("Function")}}_.\n\nThese properties are defined on `GeneratorFunction.prototype` and shared by all `GeneratorFunction` instances.\n\n- {{jsxref("Object/constructor", "GeneratorFunction.prototype.constructor")}}\n  - : The constructor function that created the instance object. For `GeneratorFunction` instances, the initial value is the {{jsxref("GeneratorFunction/GeneratorFunction", "GeneratorFunction")}} constructor.\n- `GeneratorFunction.prototype.prototype`\n  - : All generator functions share the same [`prototype`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/prototype) property, which is [`Generator.prototype`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Generator). Each generator function instance also has its own `prototype` property. When the generator function is called, the returned generator object inherits from the generator function\'s `prototype` property, which in turn inherits from `GeneratorFunction.prototype.prototype`.\n- `GeneratorFunction.prototype[@@toStringTag]`\n  - : The initial value of the [`@@toStringTag`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol/toStringTag) property is the string `"GeneratorFunction"`. This property is used in {{jsxref("Object.prototype.toString()")}}.\n\n## Instance methods\n\n_Inherits instance methods from its parent {{jsxref("Function")}}_.\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [`function*`](/en-US/docs/Web/JavaScript/Reference/Statements/function*)\n- [`function*` expression](/en-US/docs/Web/JavaScript/Reference/Operators/function*)\n- {{jsxref("Function")}}\n- {{jsxref("AsyncFunction")}}\n- {{jsxref("AsyncGeneratorFunction")}}\n- {{jsxref("Functions", "Functions", "", 1)}}\n'
    },
    "globalthis": {
        "index.md": '---\ntitle: globalThis\nslug: Web/JavaScript/Reference/Global_Objects/globalThis\npage-type: javascript-global-property\nbrowser-compat: javascript.builtins.globalThis\n---\n\n{{jsSidebar("Objects")}}\n\nThe **`globalThis`** global property contains the [global `this`](/en-US/docs/Web/JavaScript/Reference/Operators/this#global_context) value, which is usually akin to the [global object](/en-US/docs/Glossary/Global_object).\n\n{{EmbedInteractiveExample("pages/js/globalprops-globalthis.html", "shorter")}}\n\n## Value\n\nThe global `this` object.\n\n{{js_property_attributes(1, 0, 1)}}\n\n> **Note:** The `globalThis` property is configurable and writable so that code authors can hide it when executing untrusted code and prevent exposing the global object.\n\n## Description\n\nHistorically, accessing the global object has required different syntax in different JavaScript environments. On the web you can use {{domxref("Window/window", "window")}}, {{domxref("Window/self", "self")}}, or {{domxref("Window/frames", "frames")}} - but in [Web Workers](/en-US/docs/Web/API/Worker) only `self` will work. In Node.js none of these work, and you must instead use `global`. The `this` keyword could be used inside functions running in non\u2013strict mode, but `this` will be `undefined` in modules and inside functions running in strict mode. You can also use `Function(\'return this\')()`, but environments that disable {{jsxref("Global_Objects/eval", "eval()")}}, like {{Glossary("CSP")}} in browsers, prevent use of {{jsxref("Function")}} in this way.\n\nThe `globalThis` property provides a standard way of accessing the global `this` value (and hence the global object itself) across environments. Unlike similar properties such as `window` and `self`, it\'s guaranteed to work in window and non-window contexts. In this way, you can access the global object in a consistent manner without having to know which environment the code is being run in. To help you remember the name, just remember that in global scope the `this` value is `globalThis`.\n\n> **Note:** `globalThis` is generally the same concept as the global object (i.e. adding properties to `globalThis` makes them global variables) \u2014 this is the case for browsers and Node \u2014 but hosts are allowed to provide a different value for `globalThis` that\'s unrelated to the global object.\n\n### HTML and the WindowProxy\n\nIn many engines `globalThis` will be a reference to the actual global object, but in web browsers, due to iframe and cross-window security considerations, it references a {{jsxref("Proxy")}} around the actual global object (which you can\'t directly access). This distinction is rarely relevant in common usage, but important to be aware of.\n\n### Naming\n\nSeveral other popular name choices such as `self` and `global` were removed from consideration because of their potential to break compatibility with existing code. See the [language proposal\'s "naming" document](https://github.com/tc39/proposal-global/blob/master/NAMING.md) for more details.\n\n`globalThis` is, quite literally, the global `this` value. It\'s the same value as the `this` value in a non-strict function called without an object. It\'s also the value of `this` in the global scope of a script.\n\n## Examples\n\n### Search for the global across environments\n\nUsually, the global object does not need to be explicitly specified \u2014 its properties are automatically accessible as global variables.\n\n```js\nconsole.log(window.Math === Math); // true\n```\n\nHowever, one case where one needs to explicitly access the global object is when _writing_ to it, usually for the purpose of [polyfills](/en-US/docs/Glossary/Polyfill).\n\nPrior to `globalThis`, the only reliable cross-platform way to get the global object for an environment was `Function(\'return this\')()`. However, this causes [CSP](/en-US/docs/Web/HTTP/CSP) violations in some settings, so authors would use a piecewise definition like this (slightly adapted from the [original core-js source](https://github.com/zloirock/core-js/blob/master/packages/core-js/internals/global.js)):\n\n```js\nfunction check(it) {\n  // Math is known to exist as a global in every environment.\n  return it && it.Math === Math && it;\n}\n\nconst globalObject =\n  check(typeof window === "object" && window) ||\n  check(typeof self === "object" && self) ||\n  check(typeof global === "object" && global) ||\n  // This returns undefined when running in strict mode\n  (function () {\n    return this;\n  })() ||\n  Function("return this")();\n```\n\nAfter obtaining the global object, we can define new globals on it. For example, adding an implementation for [`Intl`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl):\n\n```js\nif (typeof globalObject.Intl === "undefined") {\n  // No Intl in this environment; define our own on the global scope\n  Object.defineProperty(globalObject, "Intl", {\n    value: {\n      // Our Intl implementation\n    },\n    enumerable: false,\n    configurable: true,\n    writable: true,\n  });\n}\n```\n\nWith `globalThis` available, the additional search for the global across environments is not necessary anymore:\n\n```js\nif (typeof globalThis.Intl === "undefined") {\n  Object.defineProperty(globalThis, "Intl", {\n    value: {\n      // Our Intl implementation\n    },\n    enumerable: false,\n    configurable: true,\n    writable: true,\n  });\n}\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `globalThis` in `core-js`](https://github.com/zloirock/core-js#ecmascript-globalthis)\n- {{jsxref("Operators/this", "this")}}\n'
    },
    "index.md": '---\ntitle: Standard built-in objects\nslug: Web/JavaScript/Reference/Global_Objects\npage-type: landing-page\n---\n\n{{jsSidebar("Objects")}}\n\nThis chapter documents all of JavaScript\'s standard, built-in objects, including their methods and properties.\n\nThe term "global objects" (or standard built-in objects) here is not to be confused with **the global object**. Here, "global objects" refer to **objects in the global scope**.\n\nThe **global object** itself can be accessed using the {{jsxref("Operators/this", "this")}} operator in the global scope. In fact, the global scope **consists of** the properties of the global object, including inherited properties, if any.\n\nOther objects in the global scope are either [created by the user script](/en-US/docs/Web/JavaScript/Guide/Working_with_objects#creating_new_objects) or provided by the host application. The host objects available in browser contexts are documented in the [API reference](/en-US/docs/Web/API).\n\nFor more information about the distinction between the [DOM](/en-US/docs/Web/API/Document_Object_Model) and core [JavaScript](/en-US/docs/Web/JavaScript), see [JavaScript technologies overview](/en-US/docs/Web/JavaScript/JavaScript_technologies_overview).\n\n## Standard objects by category\n\n### Value properties\n\nThese global properties return a simple value. They have no properties or methods.\n\n- {{jsxref("globalThis")}}\n- {{jsxref("Infinity")}}\n- {{jsxref("NaN")}}\n- {{jsxref("undefined")}}\n\n### Function properties\n\nThese global functions\u2014functions which are called globally, rather than on an object\u2014directly return their results to the caller.\n\n- {{jsxref("Global_Objects/eval", "eval()")}}\n- {{jsxref("isFinite()")}}\n- {{jsxref("isNaN()")}}\n- {{jsxref("parseFloat()")}}\n- {{jsxref("parseInt()")}}\n- {{jsxref("decodeURI()")}}\n- {{jsxref("decodeURIComponent()")}}\n- {{jsxref("encodeURI()")}}\n- {{jsxref("encodeURIComponent()")}}\n- {{jsxref("escape()")}} {{deprecated_inline}}\n- {{jsxref("unescape()")}} {{deprecated_inline}}\n\n### Fundamental objects\n\nThese objects represent fundamental language constructs.\n\n- {{jsxref("Object")}}\n- {{jsxref("Function")}}\n- {{jsxref("Boolean")}}\n- {{jsxref("Symbol")}}\n\n### Error objects\n\nError objects are a special type of fundamental object. They include the basic {{jsxref("Error")}} type, as well as several specialized error types.\n\n- {{jsxref("Error")}}\n- {{jsxref("AggregateError")}}\n- {{jsxref("EvalError")}}\n- {{jsxref("RangeError")}}\n- {{jsxref("ReferenceError")}}\n- {{jsxref("SyntaxError")}}\n- {{jsxref("TypeError")}}\n- {{jsxref("URIError")}}\n- {{jsxref("InternalError")}} {{non-standard_inline}}\n\n### Numbers and dates\n\nThese are the base objects representing numbers, dates, and mathematical calculations.\n\n- {{jsxref("Number")}}\n- {{jsxref("BigInt")}}\n- {{jsxref("Math")}}\n- {{jsxref("Date")}}\n\n### Text processing\n\nThese objects represent strings and support manipulating them.\n\n- {{jsxref("String")}}\n- {{jsxref("RegExp")}}\n\n### Indexed collections\n\nThese objects represent collections of data which are ordered by an index value. This includes (typed) arrays and array-like constructs.\n\n- {{jsxref("Array")}}\n- {{jsxref("Int8Array")}}\n- {{jsxref("Uint8Array")}}\n- {{jsxref("Uint8ClampedArray")}}\n- {{jsxref("Int16Array")}}\n- {{jsxref("Uint16Array")}}\n- {{jsxref("Int32Array")}}\n- {{jsxref("Uint32Array")}}\n- {{jsxref("BigInt64Array")}}\n- {{jsxref("BigUint64Array")}}\n- {{jsxref("Float32Array")}}\n- {{jsxref("Float64Array")}}\n\n### Keyed collections\n\nThese objects represent collections which use keys. The iterable collections ({{jsxref("Map")}} and {{jsxref("Set")}}) contain elements which are easily iterated in the order of insertion.\n\n- {{jsxref("Map")}}\n- {{jsxref("Set")}}\n- {{jsxref("WeakMap")}}\n- {{jsxref("WeakSet")}}\n\n### Structured data\n\nThese objects represent and interact with structured data buffers and data coded using JavaScript Object Notation (JSON).\n\n- {{jsxref("ArrayBuffer")}}\n- {{jsxref("SharedArrayBuffer")}}\n- {{jsxref("DataView")}}\n- {{jsxref("Atomics")}}\n- {{jsxref("JSON")}}\n\n### Managing memory\n\nThese objects interact with the garbage collection mechanism.\n\n- {{jsxref("WeakRef")}}\n- {{jsxref("FinalizationRegistry")}}\n\n### Control abstraction objects\n\nControl abstractions can help to structure code, especially async code (without using deeply nested callbacks, for example).\n\n- {{jsxref("Iterator")}}\n- {{jsxref("AsyncIterator")}}\n- {{jsxref("Promise")}}\n- {{jsxref("GeneratorFunction")}}\n- {{jsxref("AsyncGeneratorFunction")}}\n- {{jsxref("Generator")}}\n- {{jsxref("AsyncGenerator")}}\n- {{jsxref("AsyncFunction")}}\n\n### Reflection\n\n- {{jsxref("Reflect")}}\n- {{jsxref("Proxy")}}\n\n### Internationalization\n\nAdditions to the ECMAScript core for language-sensitive functionalities.\n\n- {{jsxref("Intl")}}\n- {{jsxref("Intl.Collator")}}\n- {{jsxref("Intl.DateTimeFormat")}}\n- {{jsxref("Intl.DisplayNames")}}\n- {{jsxref("Intl.DurationFormat")}}\n- {{jsxref("Intl.ListFormat")}}\n- {{jsxref("Intl.Locale")}}\n- {{jsxref("Intl.NumberFormat")}}\n- {{jsxref("Intl.PluralRules")}}\n- {{jsxref("Intl.RelativeTimeFormat")}}\n- {{jsxref("Intl.Segmenter")}}\n',
    "infinity": {
        "index.md": '---\ntitle: Infinity\nslug: Web/JavaScript/Reference/Global_Objects/Infinity\npage-type: javascript-global-property\nbrowser-compat: javascript.builtins.Infinity\n---\n\n{{jsSidebar("Objects")}}\n\nThe **`Infinity`** global property is a numeric value representing infinity.\n\n{{EmbedInteractiveExample("pages/js/globalprops-infinity.html")}}\n\n## Value\n\nThe same number value as {{jsxref("Number.POSITIVE_INFINITY")}}.\n\n{{js_property_attributes(0, 0, 0)}}\n\n## Description\n\n`Infinity` is a property of the _global object_. In other words, it is a variable in global scope.\n\nThe value `Infinity` (positive infinity) is greater than any other number.\n\nThis value behaves slightly differently than mathematical infinity; see {{jsxref("Number.POSITIVE_INFINITY")}} for details.\n\n## Examples\n\n### Using Infinity\n\n```js\nconsole.log(Infinity); /* Infinity */\nconsole.log(Infinity + 1); /* Infinity */\nconsole.log(Math.pow(10, 1000)); /* Infinity */\nconsole.log(Math.log(0)); /* -Infinity */\nconsole.log(1 / Infinity); /* 0 */\nconsole.log(1 / 0); /* Infinity */\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Number.NEGATIVE_INFINITY")}}\n- {{jsxref("Number.POSITIVE_INFINITY")}}\n- {{jsxref("Number.isFinite")}}\n'
    },
    "int16array": {
        "index.md": '---\ntitle: Int16Array\nslug: Web/JavaScript/Reference/Global_Objects/Int16Array\npage-type: javascript-class\nbrowser-compat: javascript.builtins.Int16Array\n---\n\n{{JSRef}}\n\nThe **`Int16Array`** typed array represents an array of 16-bit signed integers in the platform byte order. If control over byte order is needed, use {{jsxref("DataView")}} instead. The contents are initialized to `0`. Once established, you can reference elements in the array using the object\'s methods, or using standard array index syntax (that is, using bracket notation).\n\n`Int16Array` is a subclass of the hidden {{jsxref("TypedArray")}} class.\n\n## Constructor\n\n- {{jsxref("Int16Array/Int16Array", "Int16Array()")}}\n  - : Creates a new `Int16Array` object.\n\n## Static properties\n\n_Also inherits static properties from its parent {{jsxref("TypedArray")}}_.\n\n- {{jsxref("TypedArray/BYTES_PER_ELEMENT", "Int16Array.BYTES_PER_ELEMENT")}}\n  - : Returns a number value of the element size. `2` in the case of `Int16Array`.\n\n## Static methods\n\n_Inherits static methods from its parent {{jsxref("TypedArray")}}_.\n\n## Instance properties\n\n_Also inherits instance properties from its parent {{jsxref("TypedArray")}}_.\n\nThese properties are defined on `Int16Array.prototype` and shared by all `Int16Array` instances.\n\n- {{jsxref("TypedArray/BYTES_PER_ELEMENT", "Int16Array.prototype.BYTES_PER_ELEMENT")}}\n  - : Returns a number value of the element size. `2` in the case of a `Int16Array`.\n- {{jsxref("Object/constructor", "Int16Array.prototype.constructor")}}\n  - : The constructor function that created the instance object. For `Int16Array` instances, the initial value is the {{jsxref("Int16Array/Int16Array", "Int16Array")}} constructor.\n\n## Instance methods\n\n_Inherits instance methods from its parent {{jsxref("TypedArray")}}_.\n\n## Examples\n\n### Different ways to create an Int16Array\n\n```js\n// From a length\nconst int16 = new Int16Array(2);\nint16[0] = 42;\nconsole.log(int16[0]); // 42\nconsole.log(int16.length); // 2\nconsole.log(int16.BYTES_PER_ELEMENT); // 2\n\n// From an array\nconst x = new Int16Array([21, 31]);\nconsole.log(x[1]); // 31\n\n// From another TypedArray\nconst y = new Int16Array(x);\nconsole.log(y[0]); // 21\n\n// From an ArrayBuffer\nconst buffer = new ArrayBuffer(16);\nconst z = new Int16Array(buffer, 2, 4);\nconsole.log(z.byteOffset); // 2\n\n// From an iterable\nconst iterable = (function* () {\n  yield* [1, 2, 3];\n})();\nconst int16FromIterable = new Int16Array(iterable);\nconsole.log(int16FromIterable);\n// Int16Array [1, 2, 3]\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Int16Array` in `core-js`](https://github.com/zloirock/core-js#ecmascript-typed-arrays)\n- [JavaScript typed arrays](/en-US/docs/Web/JavaScript/Guide/Typed_arrays) guide\n- {{jsxref("TypedArray")}}\n- {{jsxref("ArrayBuffer")}}\n- {{jsxref("DataView")}}\n',
        "int16array": {
            "index.md": '---\ntitle: Int16Array() constructor\nslug: Web/JavaScript/Reference/Global_Objects/Int16Array/Int16Array\npage-type: javascript-constructor\nbrowser-compat: javascript.builtins.Int16Array.Int16Array\n---\n\n{{JSRef}}\n\nThe **`Int16Array()`** constructor creates {{jsxref("Int16Array")}} objects. The contents are initialized to `0`.\n\n## Syntax\n\n```js-nolint\nnew Int16Array()\nnew Int16Array(length)\nnew Int16Array(typedArray)\nnew Int16Array(object)\n\nnew Int16Array(buffer)\nnew Int16Array(buffer, byteOffset)\nnew Int16Array(buffer, byteOffset, length)\n```\n\n> **Note:** `Int16Array()` can only be constructed with [`new`](/en-US/docs/Web/JavaScript/Reference/Operators/new). Attempting to call it without `new` throws a {{jsxref("TypeError")}}.\n\n### Parameters\n\nSee [`TypedArray`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/TypedArray#parameters).\n\n### Exceptions\n\nSee [`TypedArray`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/TypedArray#exceptions).\n\n## Examples\n\n### Different ways to create an Int16Array\n\n```js\n// From a length\nconst int16 = new Int16Array(2);\nint16[0] = 42;\nconsole.log(int16[0]); // 42\nconsole.log(int16.length); // 2\nconsole.log(int16.BYTES_PER_ELEMENT); // 2\n\n// From an array\nconst x = new Int16Array([21, 31]);\nconsole.log(x[1]); // 31\n\n// From another TypedArray\nconst y = new Int16Array(x);\nconsole.log(y[0]); // 21\n\n// From an ArrayBuffer\nconst buffer = new ArrayBuffer(16);\nconst z = new Int16Array(buffer, 2, 4);\nconsole.log(z.byteOffset); // 2\n\n// From an iterable\nconst iterable = (function* () {\n  yield* [1, 2, 3];\n})();\nconst int16FromIterable = new Int16Array(iterable);\nconsole.log(int16FromIterable);\n// Int16Array [1, 2, 3]\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Int16Array` in `core-js`](https://github.com/zloirock/core-js#ecmascript-typed-arrays)\n- [JavaScript typed arrays](/en-US/docs/Web/JavaScript/Guide/Typed_arrays) guide\n- {{jsxref("TypedArray")}}\n- {{jsxref("ArrayBuffer")}}\n- {{jsxref("DataView")}}\n'
        }
    },
    "int32array": {
        "index.md": '---\ntitle: Int32Array\nslug: Web/JavaScript/Reference/Global_Objects/Int32Array\npage-type: javascript-class\nbrowser-compat: javascript.builtins.Int32Array\n---\n\n{{JSRef}}\n\nThe **`Int32Array`** typed array represents an array of 32-bit signed integers in the platform byte order. If control over byte order is needed, use {{jsxref("DataView")}} instead. The contents are initialized to `0`. Once established, you can reference elements in the array using the object\'s methods, or using standard array index syntax (that is, using bracket notation).\n\n`Int32Array` is a subclass of the hidden {{jsxref("TypedArray")}} class.\n\n## Constructor\n\n- {{jsxref("Int32Array/Int32Array", "Int32Array()")}}\n  - : Creates a new `Int32Array` object.\n\n## Static properties\n\n_Also inherits static properties from its parent {{jsxref("TypedArray")}}_.\n\n- {{jsxref("TypedArray/BYTES_PER_ELEMENT", "Int32Array.BYTES_PER_ELEMENT")}}\n  - : Returns a number value of the element size. `4` in the case of `Int32Array`.\n\n## Static methods\n\n_Inherits static methods from its parent {{jsxref("TypedArray")}}_.\n\n## Instance properties\n\n_Also inherits instance properties from its parent {{jsxref("TypedArray")}}_.\n\nThese properties are defined on `Int32Array.prototype` and shared by all `Int32Array` instances.\n\n- {{jsxref("TypedArray/BYTES_PER_ELEMENT", "Int32Array.prototype.BYTES_PER_ELEMENT")}}\n  - : Returns a number value of the element size. `4` in the case of a `Int32Array`.\n- {{jsxref("Object/constructor", "Int32Array.prototype.constructor")}}\n  - : The constructor function that created the instance object. For `Int32Array` instances, the initial value is the {{jsxref("Int32Array/Int32Array", "Int32Array")}} constructor.\n\n## Instance methods\n\n_Inherits instance methods from its parent {{jsxref("TypedArray")}}_.\n\n## Examples\n\n### Different ways to create an Int32Array\n\n```js\n// From a length\nconst int32 = new Int32Array(2);\nint32[0] = 42;\nconsole.log(int32[0]); // 42\nconsole.log(int32.length); // 2\nconsole.log(int32.BYTES_PER_ELEMENT); // 4\n\n// From an array\nconst x = new Int32Array([21, 31]);\nconsole.log(x[1]); // 31\n\n// From another TypedArray\nconst y = new Int32Array(x);\nconsole.log(y[0]); // 21\n\n// From an ArrayBuffer\nconst buffer = new ArrayBuffer(32);\nconst z = new Int32Array(buffer, 4, 4);\nconsole.log(z.byteOffset); // 4\n\n// From an iterable\nconst iterable = (function* () {\n  yield* [1, 2, 3];\n})();\nconst int32FromIterable = new Int32Array(iterable);\nconsole.log(int32FromIterable);\n// Int32Array [1, 2, 3]\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Int32Array` in `core-js`](https://github.com/zloirock/core-js#ecmascript-typed-arrays)\n- [JavaScript typed arrays](/en-US/docs/Web/JavaScript/Guide/Typed_arrays) guide\n- {{jsxref("TypedArray")}}\n- {{jsxref("ArrayBuffer")}}\n- {{jsxref("DataView")}}\n',
        "int32array": {
            "index.md": '---\ntitle: Int32Array() constructor\nslug: Web/JavaScript/Reference/Global_Objects/Int32Array/Int32Array\npage-type: javascript-constructor\nbrowser-compat: javascript.builtins.Int32Array.Int32Array\n---\n\n{{JSRef}}\n\nThe **`Int32Array()`** constructor creates {{jsxref("Int32Array")}} objects. The contents are initialized to `0`.\n\n## Syntax\n\n```js-nolint\nnew Int32Array()\nnew Int32Array(length)\nnew Int32Array(typedArray)\nnew Int32Array(object)\n\nnew Int32Array(buffer)\nnew Int32Array(buffer, byteOffset)\nnew Int32Array(buffer, byteOffset, length)\n```\n\n> **Note:** `Int32Array()` can only be constructed with [`new`](/en-US/docs/Web/JavaScript/Reference/Operators/new). Attempting to call it without `new` throws a {{jsxref("TypeError")}}.\n\n### Parameters\n\nSee [`TypedArray`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/TypedArray#parameters).\n\n### Exceptions\n\nSee [`TypedArray`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/TypedArray#exceptions).\n\n## Examples\n\n### Different ways to create an Int32Array\n\n```js\n// From a length\nconst int32 = new Int32Array(2);\nint32[0] = 42;\nconsole.log(int32[0]); // 42\nconsole.log(int32.length); // 2\nconsole.log(int32.BYTES_PER_ELEMENT); // 4\n\n// From an array\nconst x = new Int32Array([21, 31]);\nconsole.log(x[1]); // 31\n\n// From another TypedArray\nconst y = new Int32Array(x);\nconsole.log(y[0]); // 21\n\n// From an ArrayBuffer\nconst buffer = new ArrayBuffer(32);\nconst z = new Int32Array(buffer, 4, 4);\nconsole.log(z.byteOffset); // 4\n\n// From an iterable\nconst iterable = (function* () {\n  yield* [1, 2, 3];\n})();\nconst int32FromIterable = new Int32Array(iterable);\nconsole.log(int32FromIterable);\n// Int32Array [1, 2, 3]\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Int32Array` in `core-js`](https://github.com/zloirock/core-js#ecmascript-typed-arrays)\n- [JavaScript typed arrays](/en-US/docs/Web/JavaScript/Guide/Typed_arrays) guide\n- {{jsxref("TypedArray")}}\n- {{jsxref("ArrayBuffer")}}\n- {{jsxref("DataView")}}\n'
        }
    },
    "int8array": {
        "index.md": '---\ntitle: Int8Array\nslug: Web/JavaScript/Reference/Global_Objects/Int8Array\npage-type: javascript-class\nbrowser-compat: javascript.builtins.Int8Array\n---\n\n{{JSRef}}\n\nThe **`Int8Array`** typed array represents an array of 8-bit signed integers. The contents are initialized to `0`. Once established, you can reference elements in the array using the object\'s methods, or using standard array index syntax (that is, using bracket notation).\n\n`Int8Array` is a subclass of the hidden {{jsxref("TypedArray")}} class.\n\n## Constructor\n\n- {{jsxref("Int8Array/Int8Array", "Int8Array()")}}\n  - : Creates a new `Int8Array` object.\n\n## Static properties\n\n_Also inherits static properties from its parent {{jsxref("TypedArray")}}_.\n\n- {{jsxref("TypedArray/BYTES_PER_ELEMENT", "Int8Array.BYTES_PER_ELEMENT")}}\n  - : Returns a number value of the element size. `1` in the case of `Int8Array`.\n\n## Static methods\n\n_Inherits static methods from its parent {{jsxref("TypedArray")}}_.\n\n## Instance properties\n\n_Also inherits instance properties from its parent {{jsxref("TypedArray")}}_.\n\nThese properties are defined on `Int8Array.prototype` and shared by all `Int8Array` instances.\n\n- {{jsxref("TypedArray/BYTES_PER_ELEMENT", "Int8Array.prototype.BYTES_PER_ELEMENT")}}\n  - : Returns a number value of the element size. `1` in the case of a `Int8Array`.\n- {{jsxref("Object/constructor", "Int8Array.prototype.constructor")}}\n  - : The constructor function that created the instance object. For `Int8Array` instances, the initial value is the {{jsxref("Int8Array/Int8Array", "Int8Array")}} constructor.\n\n## Instance methods\n\n_Inherits instance methods from its parent {{jsxref("TypedArray")}}_.\n\n## Examples\n\n### Different ways to create an Int8Array\n\n```js\n// From a length\nconst int8 = new Int8Array(2);\nint8[0] = 42;\nconsole.log(int8[0]); // 42\nconsole.log(int8.length); // 2\nconsole.log(int8.BYTES_PER_ELEMENT); // 1\n\n// From an array\nconst x = new Int8Array([21, 31]);\nconsole.log(x[1]); // 31\n\n// From another TypedArray\nconst y = new Int8Array(x);\nconsole.log(y[0]); // 21\n\n// From an ArrayBuffer\nconst buffer = new ArrayBuffer(8);\nconst z = new Int8Array(buffer, 1, 4);\nconsole.log(z.byteOffset); // 1\n\n// From an iterable\nconst iterable = (function* () {\n  yield* [1, 2, 3];\n})();\nconst int8FromIterable = new Int8Array(iterable);\nconsole.log(int8FromIterable);\n// Int8Array [1, 2, 3]\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Int8Array` in `core-js`](https://github.com/zloirock/core-js#ecmascript-typed-arrays)\n- [JavaScript typed arrays](/en-US/docs/Web/JavaScript/Guide/Typed_arrays) guide\n- {{jsxref("TypedArray")}}\n- {{jsxref("ArrayBuffer")}}\n- {{jsxref("DataView")}}\n',
        "int8array": {
            "index.md": '---\ntitle: Int8Array() constructor\nslug: Web/JavaScript/Reference/Global_Objects/Int8Array/Int8Array\npage-type: javascript-constructor\nbrowser-compat: javascript.builtins.Int8Array.Int8Array\n---\n\n{{JSRef}}\n\nThe **`Int8Array()`** constructor creates {{jsxref("Int8Array")}} objects. The contents are initialized to `0`.\n\n## Syntax\n\n```js-nolint\nnew Int8Array()\nnew Int8Array(length)\nnew Int8Array(typedArray)\nnew Int8Array(object)\n\nnew Int8Array(buffer)\nnew Int8Array(buffer, byteOffset)\nnew Int8Array(buffer, byteOffset, length)\n```\n\n> **Note:** `Int8Array()` can only be constructed with [`new`](/en-US/docs/Web/JavaScript/Reference/Operators/new). Attempting to call it without `new` throws a {{jsxref("TypeError")}}.\n\n### Parameters\n\nSee [`TypedArray`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/TypedArray#parameters).\n\n### Exceptions\n\nSee [`TypedArray`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/TypedArray#exceptions).\n\n## Examples\n\n### Different ways to create an Int8Array\n\n```js\n// From a length\nconst int8 = new Int8Array(2);\nint8[0] = 42;\nconsole.log(int8[0]); // 42\nconsole.log(int8.length); // 2\nconsole.log(int8.BYTES_PER_ELEMENT); // 1\n\n// From an array\nconst x = new Int8Array([21, 31]);\nconsole.log(x[1]); // 31\n\n// From another TypedArray\nconst y = new Int8Array(x);\nconsole.log(y[0]); // 21\n\n// From an ArrayBuffer\nconst buffer = new ArrayBuffer(8);\nconst z = new Int8Array(buffer, 1, 4);\nconsole.log(z.byteOffset); // 1\n\n// From an iterable\nconst iterable = (function* () {\n  yield* [1, 2, 3];\n})();\nconst int8FromIterable = new Int8Array(iterable);\nconsole.log(int8FromIterable);\n// Int8Array [1, 2, 3]\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Int8Array` in `core-js`](https://github.com/zloirock/core-js#ecmascript-typed-arrays)\n- [JavaScript typed arrays](/en-US/docs/Web/JavaScript/Guide/Typed_arrays) guide\n- {{jsxref("TypedArray")}}\n- {{jsxref("ArrayBuffer")}}\n- {{jsxref("DataView")}}\n'
        }
    },
    "internalerror": {
        "index.md": '---\ntitle: InternalError\nslug: Web/JavaScript/Reference/Global_Objects/InternalError\npage-type: javascript-class\nstatus:\n  - non-standard\nbrowser-compat: javascript.builtins.InternalError\n---\n\n{{JSRef}}{{Non-standard_Header}}\n\nThe **`InternalError`** object indicates an error that occurred internally in the JavaScript engine.\n\nExample cases are mostly when something is too large, e.g.:\n\n- "too many switch cases",\n- "too many parentheses in regular expression",\n- "array initializer too large",\n- "too much recursion".\n\n`InternalError` is a subclass of {{jsxref("Error")}}.\n\n## Constructor\n\n- {{jsxref("InternalError/InternalError", "InternalError()")}} {{non-standard_inline}}\n  - : Creates a new `InternalError` object.\n\n## Instance properties\n\n_Also inherits instance properties from its parent {{jsxref("Error")}}_.\n\nThese properties are defined on `InternalError.prototype` and shared by all `InternalError` instances.\n\n- {{jsxref("Object/constructor", "InternalError.prototype.constructor")}}\n  - : The constructor function that created the instance object. For `InternalError` instances, the initial value is the {{jsxref("InternalError/InternalError", "InternalError")}} constructor.\n- {{jsxref("Error/name", "InternalError.prototype.name")}}\n  - : Represents the name for the type of error. For `InternalError.prototype.name`, the initial value is `"InternalError"`.\n\n## Instance methods\n\n_Inherits instance methods from its parent {{jsxref("Error")}}_.\n\n## Examples\n\n### Too much recursion\n\nThis recursive function runs 10 times, as per the exit condition.\n\n```js\nfunction loop(x) {\n  // "x >= 10" is the exit condition\n  if (x >= 10) return;\n\n  // do stuff\n  loop(x + 1); // the recursive call\n}\nloop(0);\n```\n\nSetting this condition to an extremely high value, may not work:\n\n```js example-bad\nfunction loop(x) {\n  if (x >= 1000000000000) return;\n\n  // do stuff\n  loop(x + 1);\n}\nloop(0);\n\n// InternalError: too much recursion\n```\n\nFor more information, see [InternalError: too much recursion.](/en-US/docs/Web/JavaScript/Reference/Errors/Too_much_recursion)\n\n## Specifications\n\nNot part of any standard.\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Error")}}\n- [InternalError: too much recursion](/en-US/docs/Web/JavaScript/Reference/Errors/Too_much_recursion)\n',
        "internalerror": {
            "index.md": '---\ntitle: InternalError() constructor\nslug: Web/JavaScript/Reference/Global_Objects/InternalError/InternalError\npage-type: javascript-constructor\nstatus:\n  - non-standard\nbrowser-compat: javascript.builtins.InternalError.InternalError\n---\n\n{{JSRef}}{{Non-standard_Header}}\n\nThe **`InternalError()`** constructor creates {{jsxref("InternalError")}} objects.\n\n## Syntax\n\n```js-nolint\nnew InternalError()\nnew InternalError(message)\nnew InternalError(message, options)\nnew InternalError(message, fileName)\nnew InternalError(message, fileName, lineNumber)\n\nInternalError()\nInternalError(message)\nInternalError(message, options)\nInternalError(message, fileName)\nInternalError(message, fileName, lineNumber)\n```\n\n> **Note:** `InternalError()` can be called with or without [`new`](/en-US/docs/Web/JavaScript/Reference/Operators/new). Both create a new `InternalError` instance.\n\n### Parameters\n\n- `message` {{optional_inline}}\n  - : Human-readable description of the error.\n- `options` {{optional_inline}}\n  - : An object that has the following properties:\n    - `cause` {{optional_inline}}\n      - : A property indicating the specific cause of the error.\n        When catching and re-throwing an error with a more-specific or useful error message, this property can be used to pass the original error.\n- `fileName` {{optional_inline}} {{non-standard_inline}}\n  - : The name of the file containing the code that caused the exception\n- `lineNumber` {{optional_inline}} {{non-standard_inline}}\n  - : The line number of the code that caused the exception\n\n## Examples\n\n### Creating a new InternalError\n\n```js\nnew InternalError("Engine failure");\n```\n\n## Specifications\n\nNot part of any standard.\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Error")}}\n'
        }
    },
    "intl": {
        "collator": {
            "collator": {
                "index.md": '---\ntitle: Intl.Collator() constructor\nslug: Web/JavaScript/Reference/Global_Objects/Intl/Collator/Collator\npage-type: javascript-constructor\nbrowser-compat: javascript.builtins.Intl.Collator.Collator\n---\n\n{{JSRef}}\n\nThe **`Intl.Collator()`** constructor creates {{jsxref("Intl.Collator")}} objects.\n\n{{EmbedInteractiveExample("pages/js/intl-collator.html")}}\n\n## Syntax\n\n```js-nolint\nnew Intl.Collator()\nnew Intl.Collator(locales)\nnew Intl.Collator(locales, options)\n\nIntl.Collator()\nIntl.Collator(locales)\nIntl.Collator(locales, options)\n```\n\n> **Note:** `Intl.Collator()` can be called with or without [`new`](/en-US/docs/Web/JavaScript/Reference/Operators/new). Both create a new `Intl.Collator` instance.\n\n### Parameters\n\n- `locales` {{optional_inline}}\n\n  - : A string with a BCP 47 language tag or an {{jsxref("Intl.Locale")}} instance, or an array of such locale identifiers. For the general form and interpretation of the `locales` argument, see [the parameter description on the `Intl` main page](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl#locales_argument).\n\n    The following Unicode extension keys are allowed:\n\n    - `co`\n      - : See [`collation`](#collation).\n    - `kn`\n      - : See [`numeric`](#numeric).\n    - `kf`\n      - : See [`caseFirst`](#casefirst).\n\n    These keys can also be set with `options` (as listed below). When both are set, the `options` property takes precedence.\n\n- `options` {{optional_inline}}\n\n  - : An object containing the following properties, in the order they are retrieved (all of them are optional):\n\n    - `usage`\n      - : Whether the comparison is for sorting a list of strings or fuzzy (for the Latin script diacritic-insensitive and case-insensitive) filtering a list of strings by key. Possible values are:\n        - `"sort"` (default)\n          - : For sorting a list of strings.\n        - `"search"`\n          - : For filtering a list of strings by testing each list item for a full-string match against a key. With `"search"`, the caller should only pay attention to whether `compare()` returns zero or non-zero and should not distinguish the non-zero return values from each other. That is, it is inappropriate to use `"search"` for sorting/ordering.\n    - `localeMatcher`\n      - : The locale matching algorithm to use. Possible values are `"lookup"` and `"best fit"`; the default is `"best fit"`. For information about this option, see [Locale identification and negotiation](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl#locale_identification_and_negotiation).\n    - `collation`\n      - : Variant collations for certain locales, such as `"emoji"`, `"pinyin"`, `"stroke"`, and so on. For a list of supported collation types, see [`Intl.Locale.prototype.getCollations()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/getCollations#supported_collation_types); the default is `"default"`. This option can also be set through the `co` Unicode extension key; if both are provided, this `options` property takes precedence.\n    - `numeric`\n      - : Whether numeric collation should be used, such that "1" < "2" < "10". Possible values are `true` and `false`; the default is `false`. This option can also be set through the `kn` Unicode extension key; if both are provided, this `options` property takes precedence.\n    - `caseFirst`\n      - : Whether upper case or lower case should sort first. Possible values are `"upper"`, `"lower"`, and `"false"` (use the locale\'s default); the default is `"false"`. This option can also be set through the `kf` Unicode extension key; if both are provided, this `options` property takes precedence.\n    - `sensitivity`\n\n      - : Which differences in the strings should lead to non-zero result values. Possible values are:\n\n        - `"base"`\n          - : Only strings that differ in base letters compare as unequal. Examples: a \u2260 b, a = \xe1, a = A.\n        - `"accent"`\n          - : Only strings that differ in base letters or accents and other diacritic marks compare as unequal. Examples: a \u2260 b, a \u2260 \xe1, a = A.\n        - `"case"`\n          - : Only strings that differ in base letters or case compare as unequal. Examples: a \u2260 b, a = \xe1, a \u2260 A.\n        - `"variant"`\n          - : Strings that differ in base letters, accents and other diacritic marks, or case compare as unequal. Other differences may also be taken into consideration. Examples: a \u2260 b, a \u2260 \xe1, a \u2260 A.\n\n        The default is `"variant"` for usage `"sort"`; it\'s locale dependent for usage `"search"` per spec, but the core functionality of `"search"` is accent-insensitive and case-insensitive filtering, so `"base"` makes the most sense (and perhaps `"case"`).\n\n    - `ignorePunctuation`\n      - : Whether punctuation should be ignored. Possible values are `true` and `false`; the default is `false`.\n\n### Exceptions\n\n- {{jsxref("RangeError")}}\n  - : Thrown if `locales` or `options` contain invalid values.\n\n## Examples\n\n### Using Collator\n\nThe following example demonstrates the different potential results for a string\noccurring before, after, or at the same level as another:\n\n```js\nconsole.log(new Intl.Collator().compare("a", "c")); // -1, or some other negative value\nconsole.log(new Intl.Collator().compare("c", "a")); // 1, or some other positive value\nconsole.log(new Intl.Collator().compare("a", "a")); // 0\n```\n\nNote that the results shown in the code above can vary between browsers and browser\nversions. This is because the values are implementation-specific. That is, the\nspecification requires only that the before and after values are negative and\npositive.\n\nWhen usage is `"search"`, the caller should only pay attention to whether the return value of `compare()` is zero or non-zero. It is inappropriate to use a `Collator` with usage `"search"` for sorting.\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Intl.Collator")}}\n- {{jsxref("Intl")}}\n'
            },
            "compare": {
                "index.md": '---\ntitle: Intl.Collator.prototype.compare()\nslug: Web/JavaScript/Reference/Global_Objects/Intl/Collator/compare\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Intl.Collator.compare\n---\n\n{{JSRef}}\n\nThe **`compare()`** method of {{jsxref("Intl.Collator")}} instances compares two\nstrings according to the sort order of this collator object.\n\n{{EmbedInteractiveExample("pages/js/intl-collator-prototype-compare.html")}}\n\n## Syntax\n\n```js-nolint\ncompare(string1, string2)\n```\n\n### Parameters\n\n- `string1`, `string2`\n  - : The strings to compare against each other.\n\n### Return value\n\nA number indicating how `string1` and `string2` compare to each other according to the sort order of this {{jsxref("Intl.Collator")}} object:\n\n- A negative value if `string1` comes before `string2`;\n- A positive value if `string1` comes after `string2`;\n- 0 if they are considered equal.\n\n## Examples\n\n### Using compare for array sort\n\nUse the `compare` function for sorting arrays. Note that the function\nis bound to the collator from which it was obtained, so it can be passed directly to\n{{jsxref("Array.prototype.sort()")}}.\n\n```js\nconst a = ["Offenbach", "\xd6sterreich", "Odenwald"];\nconst collator = new Intl.Collator("de-u-co-phonebk");\na.sort(collator.compare);\nconsole.log(a.join(", ")); // "Odenwald, \xd6sterreich, Offenbach"\n```\n\n### Using compare for array search\n\nUse the `compare` function for finding matching strings in arrays:\n\n```js\nconst a = ["Congr\xe8s", "congres", "Assembl\xe9e", "poisson"];\nconst collator = new Intl.Collator("fr", {\n  usage: "search",\n  sensitivity: "base",\n});\nconst s = "congres";\nconst matches = a.filter((v) => collator.compare(v, s) === 0);\nconsole.log(matches.join(", ")); // "Congr\xe8s, congres"\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Intl.Collator")}}\n- {{jsxref("String.prototype.localeCompare()")}}\n'
            },
            "index.md": '---\ntitle: Intl.Collator\nslug: Web/JavaScript/Reference/Global_Objects/Intl/Collator\npage-type: javascript-class\nbrowser-compat: javascript.builtins.Intl.Collator\n---\n\n{{JSRef}}\n\nThe **`Intl.Collator`** object enables language-sensitive string comparison.\n\n{{EmbedInteractiveExample("pages/js/intl-collator.html")}}\n\n## Constructor\n\n- {{jsxref("Intl/Collator/Collator", "Intl.Collator()")}}\n  - : Creates a new `Collator` object.\n\n## Static methods\n\n- {{jsxref("Intl/Collator/supportedLocalesOf", "Intl.Collator.supportedLocalesOf()")}}\n  - : Returns an array containing those of the provided locales that are supported without having to fall back to the runtime\'s default locale.\n\n## Instance properties\n\nThese properties are defined on `Intl.Collator.prototype` and shared by all `Intl.Collator` instances.\n\n- {{jsxref("Object/constructor", "Intl.Collator.prototype.constructor")}}\n  - : The constructor function that created the instance object. For `Intl.Collator` instances, the initial value is the {{jsxref("Intl/Collator/Collator", "Intl.Collator")}} constructor.\n- `Intl.Collator.prototype[@@toStringTag]`\n  - : The initial value of the [`@@toStringTag`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol/toStringTag) property is the string `"Intl.Collator"`. This property is used in {{jsxref("Object.prototype.toString()")}}.\n\n## Instance methods\n\n- {{jsxref("Intl/Collator/compare", "Intl.Collator.prototype.compare()")}}\n  - : Getter function that compares two strings according to the sort order of this {{jsxref("Intl.Collator")}} object.\n- {{jsxref("Intl/Collator/resolvedOptions", "Intl.Collator.prototype.resolvedOptions()")}}\n  - : Returns a new object with properties reflecting the locale and collation options computed during initialization of the object.\n\n## Examples\n\n### Using Collator\n\nThe following example demonstrates the different potential results for a string occurring before, after, or at the same level as another:\n\n```js\nconsole.log(new Intl.Collator().compare("a", "c")); // -1, or some other negative value\nconsole.log(new Intl.Collator().compare("c", "a")); // 1, or some other positive value\nconsole.log(new Intl.Collator().compare("a", "a")); // 0\n```\n\nNote that the results shown in the code above can vary between browsers and browser versions. This is because the values are implementation-specific. That is, the specification requires only that the before and after values are negative and positive.\n\n### Using locales\n\nThe results provided by [`Intl.Collator.prototype.compare()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Collator/compare) vary between languages. In order to get the sort order of the language used in the user interface of your application, make sure to specify that language (and possibly some fallback languages) using the `locales` argument:\n\n```js\n// in German, \xe4 sorts with a\nconsole.log(new Intl.Collator("de").compare("\xe4", "z"));\n// -1, or some other negative value\n\n// in Swedish, \xe4 sorts after z\nconsole.log(new Intl.Collator("sv").compare("\xe4", "z"));\n// 1, or some other positive value\n```\n\n### Using options\n\nThe results provided by [`Intl.Collator.prototype.compare()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Collator/compare) can be customized using the `options` argument:\n\n```js\n// in German, \xe4 has a as the base letter\nconsole.log(new Intl.Collator("de", { sensitivity: "base" }).compare("\xe4", "a"));\n// 0\n\n// in Swedish, \xe4 and a are separate base letters\nconsole.log(new Intl.Collator("sv", { sensitivity: "base" }).compare("\xe4", "a"));\n// 1, or some other positive value\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Intl")}}\n',
            "resolvedoptions": {
                "index.md": '---\ntitle: Intl.Collator.prototype.resolvedOptions()\nslug: Web/JavaScript/Reference/Global_Objects/Intl/Collator/resolvedOptions\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Intl.Collator.resolvedOptions\n---\n\n{{JSRef}}\n\nThe **`resolvedOptions()`** method of {{jsxref("Intl.Collator")}} instances returns a new object with properties reflecting the locale and collation options\ncomputed during initialization of this collator object.\n\n{{EmbedInteractiveExample("pages/js/intl-collator-prototype-resolvedoptions.html")}}\n\n## Syntax\n\n```js-nolint\nresolvedOptions()\n```\n\n### Parameters\n\nNone.\n\n### Return value\n\nA new object with properties reflecting the locale and collation options computed\nduring the initialization of the given {{jsxref("Intl.Collator")}} object.\n\n## Description\n\nThe resulting object has the following properties:\n\n- `locale`\n  - : The BCP 47 language tag for the locale actually used. If any Unicode extension\n    values were requested in the input BCP 47 language tag that led to this locale,\n    the key-value pairs that were requested and are supported for this locale are\n    included in `locale`.\n- `usage`, `sensitivity`, `ignorePunctuation`\n  - : The values provided for these properties in the `options` argument or\n    filled in as defaults.\n- `collation`\n  - : The value requested using the Unicode extension key `"co"`, if it is\n    supported for `locale`, or `"default"`.\n- `numeric`, `caseFirst`\n  - : The values requested for these properties in the `options` argument or\n    using the Unicode extension keys `"kn"` and `"kf"` or filled\n    in as defaults. If the implementation does not support these properties, they are\n    omitted.\n\n## Examples\n\n### Using the resolvedOptions method\n\n```js\nconst de = new Intl.Collator("de", { sensitivity: "base" });\nconst usedOptions = de.resolvedOptions();\n\nusedOptions.locale; // "de"\nusedOptions.usage; // "sort"\nusedOptions.sensitivity; // "base"\nusedOptions.ignorePunctuation; // false\nusedOptions.collation; // "default"\nusedOptions.numeric; // false\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Intl.Collator")}}\n'
            },
            "supportedlocalesof": {
                "index.md": '---\ntitle: Intl.Collator.supportedLocalesOf()\nslug: Web/JavaScript/Reference/Global_Objects/Intl/Collator/supportedLocalesOf\npage-type: javascript-static-method\nbrowser-compat: javascript.builtins.Intl.Collator.supportedLocalesOf\n---\n\n{{JSRef}}\n\nThe **`Intl.Collator.supportedLocalesOf()`** static method returns an array containing those of the provided locales that are supported in collation without having to fall back to the runtime\'s default locale.\n\n{{EmbedInteractiveExample("pages/js/intl-collator-supportedlocalesof.html", "shorter")}}\n\n## Syntax\n\n```js-nolint\nIntl.Collator.supportedLocalesOf(locales)\nIntl.Collator.supportedLocalesOf(locales, options)\n```\n\n### Parameters\n\n- `locales`\n  - : A string with a BCP 47 language tag, or an array of such strings. For the general form and interpretation of the `locales` argument, see [the parameter description on the `Intl` main page](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl#locales_argument).\n- `options` {{optional_inline}}\n  - : An object that may have the following property:\n    - `localeMatcher`\n      - : The locale matching algorithm to use. Possible values are `"lookup"` and `"best fit"`; the default is `"best fit"`. For information about this option, see the {{jsxref("Intl", "Intl", "#locale_identification_and_negotiation", 1)}} page.\n\n### Return value\n\nAn array of strings representing a subset of the given locale tags that are supported in collation without having to fall back to the runtime\'s default locale.\n\n## Examples\n\n### Using supportedLocalesOf()\n\nAssuming a runtime that supports Indonesian and German but not Balinese in collation, `supportedLocalesOf` returns the Indonesian and German language tags unchanged, even though `pinyin` collation is not used with Indonesian, and a specialized German for Indonesia is unlikely to be supported. Note the specification of the `"lookup"` algorithm here \u2014 a `"best fit"` matcher might decide that Indonesian is an adequate match for Balinese since most Balinese speakers also understand Indonesian, and therefore return the Balinese language tag as well.\n\n```js\nconst locales = ["ban", "id-u-co-pinyin", "de-ID"];\nconst options = { localeMatcher: "lookup" };\nconsole.log(Intl.Collator.supportedLocalesOf(locales, options));\n// ["id-u-co-pinyin", "de-ID"]\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Intl.Collator")}}\n'
            }
        },
        "datetimeformat": {
            "datetimeformat": {
                "index.md": '---\ntitle: Intl.DateTimeFormat() constructor\nslug: Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/DateTimeFormat\npage-type: javascript-constructor\nbrowser-compat: javascript.builtins.Intl.DateTimeFormat.DateTimeFormat\n---\n\n{{JSRef}}\n\nThe **`Intl.DateTimeFormat()`** constructor creates {{jsxref("Intl.DateTimeFormat")}} objects.\n\n{{EmbedInteractiveExample("pages/js/intl-datetimeformat.html", "taller")}}\n\n## Syntax\n\n```js-nolint\nnew Intl.DateTimeFormat()\nnew Intl.DateTimeFormat(locales)\nnew Intl.DateTimeFormat(locales, options)\n\nIntl.DateTimeFormat()\nIntl.DateTimeFormat(locales)\nIntl.DateTimeFormat(locales, options)\n```\n\n> **Note:** `Intl.DateTimeFormat()` can be called with or without [`new`](/en-US/docs/Web/JavaScript/Reference/Operators/new). Both create a new `Intl.DateTimeFormat` instance. However, there\'s a special behavior when it\'s called without `new` and the `this` value is another `Intl.DateTimeFormat` instance; see [Return value](#return_value).\n\n### Parameters\n\n- `locales` {{optional_inline}}\n\n  - : A string with a BCP 47 language tag or an {{jsxref("Intl.Locale")}} instance, or an array of such locale identifiers. For the general form and interpretation of the `locales` argument, see [the parameter description on the `Intl` main page](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl#locales_argument).\n\n    The following Unicode extension key is allowed:\n\n    - `nu`\n      - : See [`numberingSystem`](#numberingsystem).\n    - `ca`\n      - : See [`calendar`](#calendar).\n    - `hc`\n      - : See [`hourCycle`](#hourcycle).\n\n    These keys can also be set with `options` (as listed below). When both are set, the `options` property takes precedence.\n\n- `options` {{optional_inline}}\n\n  - : An object. For ease of reading, the property list is broken into sections based on their purposes, including [locale options](#locale_options), [date-time component options](#date-time_component_options), and [style shortcuts](#style_shortcuts).\n\n#### Locale options\n\n- `localeMatcher`\n  - : The locale matching algorithm to use. Possible values are `"lookup"` and `"best fit"`; the default is `"best fit"`. For information about this option, see [Locale identification and negotiation](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl#locale_identification_and_negotiation).\n- `calendar`\n  - : The calendar to use, such as `"chinese"`, `"gregory"`, `"persian"`, and so on. For a list of supported calendar types, see [`Intl.Locale.prototype.getCalendars()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/getCalendars#supported_calendar_types). This option can also be set through the `ca` Unicode extension key; if both are provided, this `options` property takes precedence.\n- `numberingSystem`\n  - : The numbering system to use for number formatting, such as `"arab"`, `"hans"`, `"mathsans"`, and so on. For a list of supported numbering system types, see [`Intl.Locale.prototype.getNumberingSystems()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/getNumberingSystems#supported_numbering_system_types). This option can also be set through the `nu` Unicode extension key; if both are provided, this `options` property takes precedence.\n- `hour12`\n  - : Whether to use 12-hour time (as opposed to 24-hour time). Possible values are `true` and `false`; the default is locale dependent. This option overrides the `hc` locale extension tag and/or the `hourCycle` option in case both are present. It sets `hourCycle` to `"h11"` or `"h12"` when `true`, and `"h23"` or `"h24"` when `false`, the exact choice depending on the locale \u2014 for example, if the locale most prefers `"h23"` but `hour12` is `true`, then the final hour cycle is `"h11"`.\n- `hourCycle`\n  - : The hour cycle to use. Possible values are `"h11"`, `"h12"`, `"h23"`, and `"h24"`. This option can also be set through the `hc` Unicode extension key; if both are provided, this `options` property takes precedence.\n- `timeZone`\n  - : The time zone to use. The only value implementations must recognize is `"UTC"`; the default is the runtime\'s default time zone. Implementations may also recognize the time zone names of the [IANA time zone database](https://www.iana.org/time-zones), such as `"Asia/Shanghai"`, `"Asia/Kolkata"`, `"America/New_York"`.\n\n#### Date-time component options\n\n- `weekday`\n  - : The representation of the weekday. Possible values are:\n    - `"long"`\n      - : E.g., `Thursday`\n    - `"short"`\n      - : E.g., `Thu`\n    - `"narrow"`\n      - : E.g., `T`. Two weekdays may have the same narrow style for some locales (e.g. `Tuesday`\'s narrow style is also `T`).\n- `era`\n  - : The representation of the era. Possible values are:\n    - `"long"`\n      - : E.g., `Anno Domini`\n    - `"short"`\n      - : E.g., `AD`\n    - `"narrow"`\n      - : E.g., `A`\n- `year`\n  - : The representation of the year. Possible values are `"numeric"` and `"2-digit"`.\n- `month`\n  - : The representation of the month. Possible values are:\n    - `"numeric"`\n      - : E.g., `3`\n    - `"2-digit"`\n      - : E.g., `03`\n    - `"long"`\n      - : E.g., `March`\n    - `"short"`\n      - : E.g., `Mar`\n    - `"narrow"`\n      - : E.g., `M`). Two months may have the same narrow style for some locales (e.g. `May`\'s narrow style is also `M`).\n- `day`\n  - : The representation of the day. Possible values are `"numeric"` and `"2-digit"`.\n- `dayPeriod`\n\n  - : The formatting style used for day periods like "in the morning", "am", "noon", "n" etc. Possible values are\n    `"narrow"`, `"short"`, and `"long"`.\n\n    > **Note:** This option only has an effect if a 12-hour clock (`hourCycle: "h12"` or `hourCycle: "h11"`) is used. Many locales use the same string irrespective of the width specified.\n\n- `hour`\n  - : The representation of the hour. Possible values are `"numeric"` and `"2-digit"`.\n- `minute`\n  - : The representation of the minute. Possible values are `"numeric"` and `"2-digit"`.\n- `second`\n  - : The representation of the second. Possible values are `"numeric"` and `"2-digit"`.\n- `fractionalSecondDigits`\n  - : The number of digits used to represent fractions of a second (any additional digits are truncated). Possible values are from `1` to `3`.\n- `timeZoneName`\n\n  - : The localized representation of the time zone name. Possible values are:\n\n    - `"long"`\n      - : Long localized form (e.g., `Pacific Standard Time`, `Nordamerikanische Westk\xfcsten-Normalzeit`)\n    - `"short"`\n      - : Short localized form (e.g.: `PST`, `GMT-8`)\n    - `"shortOffset"`\n      - : Short localized GMT format (e.g., `GMT-8`)\n    - `"longOffset"`\n      - : Long localized GMT format (e.g., `GMT-08:00`)\n    - `"shortGeneric"`\n      - : Short generic non-location format (e.g.: `PT`, `Los Angeles Zeit`).\n    - `"longGeneric"`\n      - : Long generic non-location format (e.g.: `Pacific Time`, `Nordamerikanische Westk\xfcstenzeit`)\n\n    > **Note:** Timezone display may fall back to another format if a required string is unavailable. For example, the non-location formats should display the timezone without a specific country/city location like "Pacific Time", but may fall back to a timezone like "Los Angeles Time".\n\nThe default value for each date-time component option is {{jsxref("undefined")}}, but if all component properties are {{jsxref("undefined")}}, then `year`, `month`, and `day` default to `"numeric"`. If any of the date-time component options is specified, then `dateStyle` and `timeStyle` must be `undefined`.\n\n- `formatMatcher`\n\n  - : The format matching algorithm to use. Possible values are `"basic"` and `"best fit"`; the default is `"best fit"`. Implementations are required to support displaying at least the following subsets of date-time components:\n\n    - `weekday`, `year`, `month`, `day`, `hour`, `minute`, `second`\n    - `weekday`, `year`, `month`, `day`\n    - `year`, `month`, `day`\n    - `year`, `month`\n    - `month`, `day`\n    - `hour`, `minute`, `second`\n    - `hour`, `minute`\n\n    Implementations may support other subsets, and requests will be negotiated against all available subset-representation combinations to find the best match. The algorithm for `"best fit"` is implementation-defined, and `"basic"` is [defined by the spec](https://tc39.es/ecma402/#sec-basicformatmatcher). This option is only used when both `dateStyle` and `timeStyle` are `undefined` (so that each date-time component\'s format is individually customizable).\n\n#### Style shortcuts\n\n- `dateStyle`\n  - : The date formatting style to use when calling `format()`. Possible values are `"full"`, `"long"`, `"medium"`, and `"short"`.\n- `timeStyle`\n  - : The time formatting style to use when calling `format()`. Possible values are `"full"`, `"long"`, `"medium"`, and `"short"`.\n\n> **Note:** `dateStyle` and `timeStyle` can be used with each other, but not with other date-time component options (e.g. `weekday`, `hour`, `month`, etc.).\n\n### Return value\n\nA new `Intl.DateTimeFormat` object.\n\n> **Note:** The text below describes behavior that is marked by the specification as "optional". It may not work in all environments. Check the [browser compatibility table](#browser_compatibility).\n\nNormally, `Intl.DateTimeFormat()` can be called with or without [`new`](/en-US/docs/Web/JavaScript/Reference/Operators/new), and a new `Intl.DateTimeFormat` instance is returned in both cases. However, if the [`this`](/en-US/docs/Web/JavaScript/Reference/Operators/this) value is an object that is [`instanceof`](/en-US/docs/Web/JavaScript/Reference/Operators/instanceof) `Intl.DateTimeFormat` (doesn\'t necessarily mean it\'s created via `new Intl.DateTimeFormat`; just that it has `Intl.DateTimeFormat.prototype` in its prototype chain), then the value of `this` is returned instead, with the newly created `Intl.DateTimeFormat` object hidden in a `[Symbol(IntlLegacyConstructedSymbol)]` property (a unique symbol that\'s reused between instances).\n\n```js\nconst formatter = Intl.DateTimeFormat.call(\n  { __proto__: Intl.DateTimeFormat.prototype },\n  "en-US",\n  { dateStyle: "full" },\n);\nconsole.log(Object.getOwnPropertyDescriptors(formatter));\n// {\n//   [Symbol(IntlLegacyConstructedSymbol)]: {\n//     value: DateTimeFormat [Intl.DateTimeFormat] {},\n//     writable: false,\n//     enumerable: false,\n//     configurable: false\n//   }\n// }\n```\n\nNote that there\'s only one actual `Intl.DateTimeFormat` instance here: the one hidden in `[Symbol(IntlLegacyConstructedSymbol)]`. Calling the [`format()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/format) and [`resolvedOptions()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/resolvedOptions) methods on `formatter` would correctly use the options stored in that instance, but calling all other methods (e.g. [`formatRange()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/formatRange)) would fail: "TypeError: formatRange method called on incompatible Object", because those methods don\'t consult the hidden instance\'s options.\n\nThis behavior, called `ChainDateTimeFormat`, does not happen when `Intl.DateTimeFormat()` is called without `new` but with `this` set to anything else that\'s not an `instanceof Intl.DateTimeFormat`. If you call it directly as `Intl.DateTimeFormat()`, the `this` value is [`Intl`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl), and a new `Intl.DateTimeFormat` instance is created normally.\n\n### Exceptions\n\n- {{jsxref("RangeError")}}\n  - : Thrown if `locales` or `options` contain invalid values.\n\n## Examples\n\n### Using DateTimeFormat\n\nIn basic use without specifying a locale, `DateTimeFormat` uses the default\nlocale and default options.\n\n```js\nconst date = new Date(Date.UTC(2012, 11, 20, 3, 0, 0));\n\n// toLocaleString without arguments depends on the implementation,\n// the default locale, and the default time zone\nconsole.log(new Intl.DateTimeFormat().format(date));\n// "12/19/2012" if run with en-US locale (language) and time zone America/Los_Angeles (UTC-0800)\n```\n\n### Using timeStyle and dateStyle\n\n```js\nconst shortTime = new Intl.DateTimeFormat("en", {\n  timeStyle: "short",\n});\nconsole.log(shortTime.format(Date.now())); // "1:31 PM"\n\nconst shortDate = new Intl.DateTimeFormat("en", {\n  dateStyle: "short",\n});\nconsole.log(shortDate.format(Date.now())); // "07/07/20"\n\nconst mediumTime = new Intl.DateTimeFormat("en", {\n  timeStyle: "medium",\n  dateStyle: "short",\n});\nconsole.log(mediumTime.format(Date.now())); // "07/07/20, 1:31:55 PM"\n```\n\n### Using dayPeriod\n\nUse the `dayPeriod` option to output a string for the times of day ("in the morning", "at night", "noon", etc.). Note, that this only works when formatting for a 12 hour clock (`hourCycle: \'h12\'` or `hourCycle: \'h11\'`) and that for many locales the strings are the same irrespective of the value passed for the `dayPeriod`.\n\n```js\nconst date = Date.UTC(2012, 11, 17, 4, 0, 42);\n\nconsole.log(\n  new Intl.DateTimeFormat("en-GB", {\n    hour: "numeric",\n    hourCycle: "h12",\n    dayPeriod: "short",\n    timeZone: "UTC",\n  }).format(date),\n);\n// 4 at night"  (same formatting in en-GB for all dayPeriod values)\n\nconsole.log(\n  new Intl.DateTimeFormat("fr", {\n    hour: "numeric",\n    hourCycle: "h12",\n    dayPeriod: "narrow",\n    timeZone: "UTC",\n  }).format(date),\n);\n// "4 mat."  (same output in French for both narrow/short dayPeriod)\n\nconsole.log(\n  new Intl.DateTimeFormat("fr", {\n    hour: "numeric",\n    hourCycle: "h12",\n    dayPeriod: "long",\n    timeZone: "UTC",\n  }).format(date),\n);\n// "4 du matin"\n```\n\n### Using timeZoneName\n\nUse the `timeZoneName` option to output a string for the timezone ("GMT", "Pacific Time", etc.).\n\n```js\nconst date = Date.UTC(2021, 11, 17, 3, 0, 42);\nconst timezoneNames = [\n  "short",\n  "long",\n  "shortOffset",\n  "longOffset",\n  "shortGeneric",\n  "longGeneric",\n];\n\nfor (const zoneName of timezoneNames) {\n  // Do something with currentValue\n  const formatter = new Intl.DateTimeFormat("en-US", {\n    timeZone: "America/Los_Angeles",\n    timeZoneName: zoneName,\n  });\n  console.log(`${zoneName}: ${formatter.format(date)}`);\n}\n\n// Logs:\n// short: 12/16/2021, PST\n// long: 12/16/2021, Pacific Standard Time\n// shortOffset: 12/16/2021, GMT-8\n// longOffset: 12/16/2021, GMT-08:00\n// shortGeneric: 12/16/2021, PT\n// longGeneric: 12/16/2021, Pacific Time\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Intl.DateTimeFormat")}}\n- {{jsxref("Intl.supportedValuesOf()")}}\n- {{jsxref("Intl")}}\n'
            },
            "format": {
                "index.md": '---\ntitle: Intl.DateTimeFormat.prototype.format()\nslug: Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/format\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Intl.DateTimeFormat.format\n---\n\n{{JSRef}}\n\nThe **`format()`** method of {{jsxref("Intl.DateTimeFormat")}} instances formats a date according to the locale and formatting options of this `Intl.DateTimeFormat` object.\n\n{{EmbedInteractiveExample("pages/js/intl-datetimeformat-prototype-format.html", "taller")}}\n\n## Syntax\n\n```js-nolint\nformat(date)\n```\n\n### Parameters\n\n- `date`\n  - : The date to format.\n\n### Return value\n\nA string representing the given `date` formatted according to the locale and formatting options of this {{jsxref("Intl.DateTimeFormat")}} object.\n\n## Examples\n\n### Using format\n\nUse the `format` getter function for formatting a single date, here for\nSerbia:\n\n```js\nconst options = {\n  weekday: "long",\n  year: "numeric",\n  month: "long",\n  day: "numeric",\n};\nconst dateTimeFormat = new Intl.DateTimeFormat("sr-RS", options);\nconsole.log(dateTimeFormat.format(new Date()));\n// "\u043D\u0435\u0434\u0435\u0459\u0430, 7. \u0430\u043F\u0440\u0438\u043B 2013."\n```\n\n### Using format with map\n\nUse the `format` getter function for formatting all dates in an array. Note\nthat the function is bound to the {{jsxref("Intl.DateTimeFormat")}}\nfrom which it was obtained, so it can be passed directly to\n{{jsxref("Array.prototype.map()")}}.\n\n```js\nconst a = [new Date(2012, 8), new Date(2012, 11), new Date(2012, 3)];\nconst options = { year: "numeric", month: "long" };\nconst dateTimeFormat = new Intl.DateTimeFormat("pt-BR", options);\nconst formatted = a.map(dateTimeFormat.format);\nconsole.log(formatted.join("; "));\n// "setembro de 2012; dezembro de 2012; abril de 2012"\n```\n\n### Avoid comparing formatted date values to static values\n\nMost of the time, the formatting returned by `format()` is consistent.\nHowever, this might change in the future and isn\'t guaranteed for all the languages \u2014\noutput variations are by design and allowed by the specification. Most notably, the IE\nand Edge browsers insert bidirectional control characters around dates, so the output\ntext will flow properly when concatenated with other text.\n\nFor this reason you cannot expect to be able to compare the results of\n`format()` to a static value:\n\n```js example-bad\nlet d = new Date("2019-01-01T00:00:00.000000Z");\nlet formattedDate = Intl.DateTimeFormat(undefined, {\n  year: "numeric",\n  month: "numeric",\n  day: "numeric",\n  hour: "numeric",\n  minute: "numeric",\n  second: "numeric",\n}).format(d);\n\n"1.1.2019, 01:00:00" === formattedDate;\n// true in Firefox and others\n// false in IE and Edge\n```\n\n> **Note:** See also this [StackOverflow thread](https://stackoverflow.com/questions/25574963/ies-tolocalestring-has-strange-characters-in-results)\n> for more details and examples.\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Intl.DateTimeFormat")}}\n- {{jsxref("Date.prototype.toLocaleString()")}}\n- {{jsxref("Date.prototype.toLocaleDateString()")}}\n- {{jsxref("Date.prototype.toLocaleTimeString()")}}\n'
            },
            "formatrange": {
                "index.md": '---\ntitle: Intl.DateTimeFormat.prototype.formatRange()\nslug: Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/formatRange\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Intl.DateTimeFormat.formatRange\n---\n\n{{JSRef}}\n\nThe **`formatRange()`** method of {{jsxref("Intl.DateTimeFormat")}} instances formats a\ndate range in the most concise way based on the locales and\noptions provided when instantiating this\n`Intl.DateTimeFormat` object.\n\n{{EmbedInteractiveExample("pages/js/intl-datetimeformat-prototype-formatrange.html", "taller")}}\n\n## Syntax\n\n```js-nolint\nformatRange(startDate, endDate)\n```\n\n### Parameters\n\n- `startDate`\n  - : A {{jsxref("Date")}} object representing the start of the date range.\n- `endDate`\n  - : A {{jsxref("Date")}} object representing the end of the date range.\n\n### Return value\n\nA string representing the given date range formatted according to the locale and formatting options of this {{jsxref("Intl.DateTimeFormat")}} object.\n\n## Examples\n\n### Basic formatRange usage\n\nThis method receives two {{jsxref("Date")}}s and formats the date range in the most\nconcise way based on the `locale` and `options` provided when\ninstantiating {{jsxref("Intl.DateTimeFormat")}}.\n\n```js\nconst date1 = new Date(Date.UTC(1906, 0, 10, 10, 0, 0)); // Wed, 10 Jan 1906 10:00:00 GMT\nconst date2 = new Date(Date.UTC(1906, 0, 10, 11, 0, 0)); // Wed, 10 Jan 1906 11:00:00 GMT\nconst date3 = new Date(Date.UTC(1906, 0, 20, 10, 0, 0)); // Sat, 20 Jan 1906 10:00:00 GMT\n\nconst fmt1 = new Intl.DateTimeFormat("en", {\n  year: "2-digit",\n  month: "numeric",\n  day: "numeric",\n  hour: "numeric",\n  minute: "numeric",\n});\nconsole.log(fmt1.format(date1)); // \'1/10/06, 10:00 AM\'\nconsole.log(fmt1.formatRange(date1, date2)); // \'1/10/06, 10:00 \u2013 11:00 AM\'\nconsole.log(fmt1.formatRange(date1, date3)); // \'1/10/06, 10:00 AM \u2013 1/20/07, 10:00 AM\'\n\nconst fmt2 = new Intl.DateTimeFormat("en", {\n  year: "numeric",\n  month: "short",\n  day: "numeric",\n});\nconsole.log(fmt2.format(date1)); // \'Jan 10, 1906\'\nconsole.log(fmt2.formatRange(date1, date2)); // \'Jan 10, 1906\'\nconsole.log(fmt2.formatRange(date1, date3)); // \'Jan 10 \u2013 20, 1906\'\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Intl.DateTimeFormat")}}\n'
            },
            "formatrangetoparts": {
                "index.md": '---\ntitle: Intl.DateTimeFormat.prototype.formatRangeToParts()\nslug: Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/formatRangeToParts\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Intl.DateTimeFormat.formatRangeToParts\n---\n\n{{JSRef}}\n\nThe **`formatRangeToParts()`** method of {{jsxref("Intl.DateTimeFormat")}} instances returns an array of locale-specific tokens representing each part of the formatted date\nrange produced by this `Intl.DateTimeFormat` object.\n\n{{EmbedInteractiveExample("pages/js/intl-datetimeformat-prototype-formatrangetoparts.html", "taller")}}\n\n## Syntax\n\n```js-nolint\nformatRangeToParts(startDate, endDate)\n```\n\n## Examples\n\n### Basic formatRangeToParts usage\n\nThis method receives two {{jsxref("Date")}}s and returns an {{jsxref("Array")}} of\nobjects containing the _locale-specific_ tokens representing each part of the formatted date range.\n\n> **Note:** The return values shown in your locale may differ from those listed below.\n\n```js\nconst date1 = new Date(Date.UTC(1906, 0, 10, 10, 0, 0)); // Wed, 10 Jan 1906 10:00:00 GMT\nconst date2 = new Date(Date.UTC(1906, 0, 10, 11, 0, 0)); // Wed, 10 Jan 1906 11:00:00 GMT\n\nconst fmt = new Intl.DateTimeFormat("en", {\n  hour: "numeric",\n  minute: "numeric",\n});\n\nconsole.log(fmt.formatRange(date1, date2)); // \'10:00 \u2013 11:00 AM\'\n\nfmt.formatRangeToParts(date1, date2);\n// [\n//   { type: \'hour\',      value: \'10\',  source: "startRange" },\n//   { type: \'literal\',   value: \':\',   source: "startRange" },\n//   { type: \'minute\',    value: \'00\',  source: "startRange" },\n//   { type: \'literal\',   value: \' \u2013 \', source: "shared"     },\n//   { type: \'hour\',      value: \'11\',  source: "endRange"   },\n//   { type: \'literal\',   value: \':\',   source: "endRange"   },\n//   { type: \'minute\',    value: \'00\',  source: "endRange"   },\n//   { type: \'literal\',   value: \' \',   source: "shared"     },\n//   { type: \'dayPeriod\', value: \'AM\',  source: "shared"     }\n// ]\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Intl/DateTimeFormat/formatRange", "Intl.DateTimeFormat.prototype.formatRange()")}}\n- {{jsxref("Intl.DateTimeFormat")}}\n'
            },
            "formattoparts": {
                "index.md": '---\ntitle: Intl.DateTimeFormat.prototype.formatToParts()\nslug: Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/formatToParts\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Intl.DateTimeFormat.formatToParts\n---\n\n{{JSRef}}\n\nThe **`formatToParts()`** method of {{jsxref("Intl.DateTimeFormat")}} instances allows locale-aware formatting of strings produced by this `Intl.DateTimeFormat` object.\n\n{{EmbedInteractiveExample("pages/js/intl-datetimeformat-prototype-formattoparts.html", "taller")}}\n\n## Syntax\n\n```js-nolint\nformatToParts(date)\n```\n\n### Parameters\n\n- `date` {{optional_inline}}\n  - : The date to format.\n\n### Return value\n\nAn {{jsxref("Array")}} of objects containing the formatted date in parts.\n\n## Description\n\nThe `formatToParts()` method is useful for custom formatting of date\nstrings. It returns an {{jsxref("Array")}} of objects containing the locale-specific\ntokens from which it possible to build custom strings while preserving the\nlocale-specific parts. The structure the `formatToParts()` method returns,\nlooks like this:\n\n```js\n[\n  { type: "day", value: "17" },\n  { type: "weekday", value: "Monday" },\n];\n```\n\nPossible types are the following:\n\n- `day`\n  - : The string used for the day, for example `"17"`.\n- `dayPeriod`\n  - : The string used for the day period, for example, `"AM"`,\n    `"PM"`, `"in the morning"`, or `"noon"`\n- `era`\n  - : The string used for the era, for example `"BC"` or `"AD"`.\n- `fractionalSecond`\n  - : The string used for the fractional seconds, for example `"0"` or `"00"` or `"000"`.\n- `hour`\n  - : The string used for the hour, for example `"3"` or `"03"`.\n- `literal`\n  - : The string used for separating date and time values, for example `"/"`,\n    `","`, `"o\'clock"`, `"de"`, etc.\n- `minute`\n  - : The string used for the minute, for example `"00"`.\n- `month`\n  - : The string used for the month, for example `"12"`.\n- `relatedYear`\n  - : The string used for the related 4-digit Gregorian year, in the event that the\n    calendar\'s representation would be a yearName instead of a year, for example `"2019"`.\n- `second`\n  - : The string used for the second, for example `"07"` or `"42"`.\n- `timeZone`\n  - : The string used for the name of the time zone, for example `"UTC"`. Default is the timezone of the current environment.\n- `weekday`\n  - : The string used for the weekday, for example `"M"`, `"Monday"`, or `"Montag"`.\n- `year`\n  - : The string used for the year, for example `"2012"` or `"96"`.\n- `yearName`\n  - : The string used for the yearName in relevant contexts, for example `"geng-zi"`\n\n## Examples\n\n`DateTimeFormat` outputs localized, opaque strings that cannot be\nmanipulated directly:\n\n```js\nconst date = Date.UTC(2012, 11, 17, 3, 0, 42);\n\nconst formatter = new Intl.DateTimeFormat("en-us", {\n  weekday: "long",\n  year: "numeric",\n  month: "numeric",\n  day: "numeric",\n  hour: "numeric",\n  minute: "numeric",\n  second: "numeric",\n  fractionalSecondDigits: 3,\n  hour12: true,\n  timeZone: "UTC",\n});\n\nformatter.format(date);\n// "Monday, 12/17/2012, 3:00:42.000 AM"\n```\n\nHowever, in many User Interfaces there is a desire to customize the formatting of this\nstring. The `formatToParts` method enables locale-aware formatting of strings\nproduced by `DateTimeFormat` formatters by providing you the string in parts:\n\n```js\nformatter.formatToParts(date);\n\n// return value:\n[\n  { type: "weekday", value: "Monday" },\n  { type: "literal", value: ", " },\n  { type: "month", value: "12" },\n  { type: "literal", value: "/" },\n  { type: "day", value: "17" },\n  { type: "literal", value: "/" },\n  { type: "year", value: "2012" },\n  { type: "literal", value: ", " },\n  { type: "hour", value: "3" },\n  { type: "literal", value: ":" },\n  { type: "minute", value: "00" },\n  { type: "literal", value: ":" },\n  { type: "second", value: "42" },\n  { type: "fractionalSecond", value: "000" },\n  { type: "literal", value: " " },\n  { type: "dayPeriod", value: "AM" },\n];\n```\n\nNow the information is available separately and it can be formatted and concatenated\nagain in a customized way. For example by using {{jsxref("Array.prototype.map()")}},\n[arrow functions](/en-US/docs/Web/JavaScript/Reference/Functions/Arrow_functions),\na [switch statement](/en-US/docs/Web/JavaScript/Reference/Statements/switch),\n[template literals](/en-US/docs/Web/JavaScript/Reference/Template_literals),\nand {{jsxref("Array.prototype.join()")}}.\n\n```js\nconst dateString = formatter\n  .formatToParts(date)\n  .map(({ type, value }) => {\n    switch (type) {\n      case "dayPeriod":\n        return `<em>${value}</em>`;\n      default:\n        return value;\n    }\n  })\n  .join("");\n```\n\nThis will emphasize the day period when using the `formatToParts()` method.\n\n```js\nconsole.log(formatter.format(date));\n// "Monday, 12/17/2012, 3:00:42.000 AM"\n\nconsole.log(dateString);\n// "Monday, 12/17/2012, 3:00:42.000 <em>AM</em>"\n```\n\n### Named Years and Mixed calendars\n\nIn some cases, calendars use named years. Chinese and Tibetan calendars, for example,\nuse a 60-year [sexagenary cycle](https://en.wikipedia.org/wiki/Sexagenary_cycle) of named years.\nThese years are disambiguated by relationship to\ncorresponding years on the Gregorian calendar. When this is the case, the result of\n`formatToParts()` will contain an entry for `relatedYear` when a\nyear would normally be present, containing the 4-digit Gregorian year, instead of an\nentry for `year`. Setting an entry in the bag for `year` (with any\nvalue) will yield both the and the `yearName` Gregorian\n`relatedYear`:\n\n```js\nconst opts = { year: "numeric", month: "numeric", day: "numeric" };\nconst df = new Intl.DateTimeFormat("zh-u-ca-chinese", opts);\ndf.formatToParts(Date.UTC(2012, 11, 17, 3, 0, 42));\n\n// return value\n[\n  { type: "relatedYear", value: "2012" },\n  { type: "literal", value: "\u5E74" },\n  { type: "month", value: "\u5341\u4E00\u6708" },\n  { type: "day", value: "4" },\n];\n```\n\nIf the `year` option is not set in the bag (to any value), the result will\ninclude only the `relatedYear`:\n\n```js\nconst df = new Intl.DateTimeFormat("zh-u-ca-chinese");\ndf.formatToParts(Date.UTC(2012, 11, 17, 3, 0, 42));\n\n// return value\n[\n  { type: "relatedYear", value: "2012" },\n  { type: "literal", value: "\u5E74" },\n  { type: "month", value: "\u5341\u4E00\u6708" },\n  { type: "day", value: "4" },\n];\n```\n\nIn cases where the `year` would be output, `.format()` may\ncommonly present these side-by-side:\n\n```js\nconst df = new Intl.DateTimeFormat("zh-u-ca-chinese", { year: "numeric" });\ndf.format(Date.UTC(2012, 11, 17, 3, 0, 42)); // 2012\u58EC\u8FB0\u5E74\n```\n\nThis also makes it possible to mix locale and calendar in both `format`:\n\n```js\nconst df = new Intl.DateTimeFormat("en-u-ca-chinese", { year: "numeric" });\nconst date = Date.UTC(2012, 11, 17, 3, 0, 42);\ndf.format(date); // 2012(ren-chen)\n```\n\nAnd `formatToParts`:\n\n```js\nconst opts = { month: "numeric", day: "numeric", year: "numeric" };\nconst df = new Intl.DateTimeFormat("en-u-ca-chinese", opts);\nconst date = Date.UTC(2012, 11, 17, 3);\ndf.formatToParts(date);\n// [\n//   { type: \'month\', value: \'11\' },\n//   { type: \'literal\', value: \'/\' },\n//   { type: \'day\', value: \'4\' },\n//   { type: \'literal\', value: \'/\' },\n//   { type: \'relatedYear\', value: \'2012\' }\n// ]\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Intl.DateTimeFormat")}}\n- {{jsxref("Intl/DateTimeFormat/format", "Intl.DateTimeFormat.prototype.format()")}}\n- {{jsxref("Date.prototype.toLocaleString()")}}\n- {{jsxref("Date.prototype.toLocaleDateString()")}}\n- {{jsxref("Date.prototype.toLocaleTimeString()")}}\n'
            },
            "index.md": '---\ntitle: Intl.DateTimeFormat\nslug: Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat\npage-type: javascript-class\nbrowser-compat: javascript.builtins.Intl.DateTimeFormat\n---\n\n{{JSRef}}\n\nThe **`Intl.DateTimeFormat`** object enables language-sensitive date and time formatting.\n\n{{EmbedInteractiveExample("pages/js/intl-datetimeformat.html", "taller")}}\n\n## Constructor\n\n- {{jsxref("Intl/DateTimeFormat/DateTimeFormat", "Intl.DateTimeFormat()")}}\n  - : Creates a new `Intl.DateTimeFormat` object.\n\n## Static methods\n\n- {{jsxref("Intl/DateTimeFormat/supportedLocalesOf", "Intl.DateTimeFormat.supportedLocalesOf()")}}\n  - : Returns an array containing those of the provided locales that are supported without having to fall back to the runtime\'s default locale.\n\n## Instance properties\n\nThese properties are defined on `Intl.DateTimeFormat.prototype` and shared by all `Intl.DateTimeFormat` instances.\n\n- {{jsxref("Object/constructor", "Intl.DateTimeFormat.prototype.constructor")}}\n  - : The constructor function that created the instance object. For `Intl.DateTimeFormat` instances, the initial value is the {{jsxref("Intl/DateTimeFormat/DateTimeFormat", "Intl.DateTimeFormat")}} constructor.\n- `Intl.DateTimeFormat.prototype[@@toStringTag]`\n  - : The initial value of the [`@@toStringTag`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol/toStringTag) property is the string `"Intl.DateTimeFormat"`. This property is used in {{jsxref("Object.prototype.toString()")}}.\n\n## Instance methods\n\n- {{jsxref("Intl/DateTimeFormat/format", "Intl.DateTimeFormat.prototype.format()")}}\n  - : Getter function that formats a date according to the locale and formatting options of this `DateTimeFormat` object.\n- {{jsxref("Intl/DateTimeFormat/formatRange", "Intl.DateTimeFormat.prototype.formatRange()")}}\n  - : This method receives two [Dates](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date) and formats the date range in the most concise way based on the locale and options provided when instantiating `DateTimeFormat`.\n- {{jsxref("Intl/DateTimeFormat/formatRangeToParts", "Intl.DateTimeFormat.prototype.formatRangeToParts()")}}\n  - : This method receives two [Dates](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date) and returns an Array of objects containing the locale-specific tokens representing each part of the formatted date range.\n- {{jsxref("Intl/DateTimeFormat/formatToParts", "Intl.DateTimeFormat.prototype.formatToParts()")}}\n  - : Returns an {{jsxref("Array")}} of objects representing the date string in parts that can be used for custom locale-aware formatting.\n- {{jsxref("Intl/DateTimeFormat/resolvedOptions", "Intl.DateTimeFormat.prototype.resolvedOptions()")}}\n  - : Returns a new object with properties reflecting the locale and formatting options computed during initialization of the object.\n\n## Examples\n\n### Using DateTimeFormat\n\nIn basic use without specifying a locale, `DateTimeFormat` uses the default locale and default options.\n\n```js\nconst date = new Date(Date.UTC(2012, 11, 20, 3, 0, 0));\n\n// toLocaleString without arguments depends on the implementation,\n// the default locale, and the default time zone\nconsole.log(new Intl.DateTimeFormat().format(date));\n// "12/19/2012" if run with en-US locale (language) and time zone America/Los_Angeles (UTC-0800)\n```\n\n### Using locales\n\nThis example shows some of the variations in localized date and time formats. In order to get the format of the language used in the user interface of your application, make sure to specify that language (and possibly some fallback languages) using the `locales` argument:\n\n```js\nconst date = new Date(Date.UTC(2012, 11, 20, 3, 0, 0));\n\n// Results below use the time zone of America/Los_Angeles (UTC-0800, Pacific Standard Time)\n\n// US English uses month-day-year order\nconsole.log(new Intl.DateTimeFormat("en-US").format(date));\n// "12/19/2012"\n\n// British English uses day-month-year order\nconsole.log(new Intl.DateTimeFormat("en-GB").format(date));\n// "19/12/2012"\n\n// Korean uses year-month-day order\nconsole.log(new Intl.DateTimeFormat("ko-KR").format(date));\n// "2012. 12. 19."\n\n// Arabic in most Arabic speaking countries uses real Arabic digits\nconsole.log(new Intl.DateTimeFormat("ar-EG").format(date));\n// "\u0661\u0669\u200F/\u0661\u0662\u200F/\u0662\u0660\u0661\u0662"\n\n// for Japanese, applications may want to use the Japanese calendar,\n// where 2012 was the year 24 of the Heisei era\nconsole.log(new Intl.DateTimeFormat("ja-JP-u-ca-japanese").format(date));\n// "24/12/19"\n\n// when requesting a language that may not be supported, such as\n// Balinese, include a fallback language, in this case Indonesian\nconsole.log(new Intl.DateTimeFormat(["ban", "id"]).format(date));\n// "19/12/2012"\n```\n\n### Using options\n\nThe date and time formats can be customized using the `options` argument:\n\n```js\nconst date = new Date(Date.UTC(2012, 11, 20, 3, 0, 0, 200));\n\n// request a weekday along with a long date\nlet options = {\n  weekday: "long",\n  year: "numeric",\n  month: "long",\n  day: "numeric",\n};\nconsole.log(new Intl.DateTimeFormat("de-DE", options).format(date));\n// "Donnerstag, 20. Dezember 2012"\n\n// an application may want to use UTC and make that visible\noptions.timeZone = "UTC";\noptions.timeZoneName = "short";\nconsole.log(new Intl.DateTimeFormat("en-US", options).format(date));\n// "Thursday, December 20, 2012, GMT"\n\n// sometimes you want to be more precise\noptions = {\n  hour: "numeric",\n  minute: "numeric",\n  second: "numeric",\n  timeZone: "Australia/Sydney",\n  timeZoneName: "short",\n};\nconsole.log(new Intl.DateTimeFormat("en-AU", options).format(date));\n// "2:00:00 pm AEDT"\n\n// sometimes you want to be very precise\noptions.fractionalSecondDigits = 3; //number digits for fraction-of-seconds\nconsole.log(new Intl.DateTimeFormat("en-AU", options).format(date));\n// "2:00:00.200 pm AEDT"\n\n// sometimes even the US needs 24-hour time\noptions = {\n  year: "numeric",\n  month: "numeric",\n  day: "numeric",\n  hour: "numeric",\n  minute: "numeric",\n  second: "numeric",\n  hour12: false,\n  timeZone: "America/Los_Angeles",\n};\nconsole.log(new Intl.DateTimeFormat("en-US", options).format(date));\n// "12/19/2012, 19:00:00"\n\n// to specify options but use the browser\'s default locale, use undefined\nconsole.log(new Intl.DateTimeFormat(undefined, options).format(date));\n// "12/19/2012, 19:00:00"\n\n// sometimes it\'s helpful to include the period of the day\noptions = { hour: "numeric", dayPeriod: "short" };\nconsole.log(new Intl.DateTimeFormat("en-US", options).format(date));\n// 10 at night\n```\n\nThe used calendar and numbering formats can also be set independently via `options` arguments:\n\n```js\nconst options = { calendar: "chinese", numberingSystem: "arab" };\nconst dateFormat = new Intl.DateTimeFormat(undefined, options);\nconst usedOptions = dateFormat.resolvedOptions();\n\nconsole.log(usedOptions.calendar);\n// "chinese"\n\nconsole.log(usedOptions.numberingSystem);\n// "arab"\n\nconsole.log(usedOptions.timeZone);\n// "America/New_York" (the users default timezone)\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Intl.DateTimeFormat` in FormatJS](https://formatjs.io/docs/polyfills/intl-datetimeformat/)\n- {{jsxref("Intl")}}\n',
            "resolvedoptions": {
                "index.md": '---\ntitle: Intl.DateTimeFormat.prototype.resolvedOptions()\nslug: Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/resolvedOptions\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Intl.DateTimeFormat.resolvedOptions\n---\n\n{{JSRef}}\n\nThe **`resolvedOptions()`** method of {{jsxref("Intl.DateTimeFormat")}} instances returns a new object with properties reflecting the locale and date and time formatting options computed during initialization of this `Intl.DateTimeFormat` object.\n\n{{EmbedInteractiveExample("pages/js/intl-datetimeformat-prototype-resolvedoptions.html")}}\n\n## Syntax\n\n```js-nolint\nresolvedOptions()\n```\n\n### Parameters\n\nNone.\n\n### Return value\n\nA new object with properties reflecting the locale and date and time formatting options\ncomputed during the initialization of the given {{jsxref("Intl.DateTimeFormat")}} object.\n\n## Description\n\nThe resulting object has the following properties:\n\n- `locale`\n  - : The BCP 47 language tag for the locale actually used. If any Unicode extension\n    values were requested in the input BCP 47 language tag that led to this locale,\n    the key-value pairs that were requested and are supported for this locale are\n    included in `locale`.\n- `calendar`\n  - : E.g. "gregory"\n- `numberingSystem`\n  - : The values requested using the Unicode extension keys `"ca"` and\n    `"nu"` or filled in as default values.\n- `timeZone`\n  - : The value provided for this property in the `options` argument;\n    defaults to the runtime\'s default time zone. Should never be `undefined`.\n- `hour12`\n  - : The value provided for this property in the `options` argument or\n    filled in as a default.\n- `weekday`, `era`, `year`, `month`, `day`, `hour`, `minute`, `second`, `timeZoneName`\n  - : The values resulting from format matching between the corresponding properties in\n    the `options` argument and the available combinations and\n    representations for date-time formatting in the selected locale. Some of these\n    properties may not be present, indicating that the corresponding components will\n    not be represented in formatted output.\n\n## Examples\n\n### Using the resolvedOptions method\n\n```js\nconst germanFakeRegion = new Intl.DateTimeFormat("de-XX", { timeZone: "UTC" });\nconst usedOptions = germanFakeRegion.resolvedOptions();\n\nusedOptions.locale; // "de"\nusedOptions.calendar; // "gregory"\nusedOptions.numberingSystem; // "latn"\nusedOptions.timeZone; // "UTC"\nusedOptions.month; // "numeric"\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Intl.DateTimeFormat")}}\n'
            },
            "supportedlocalesof": {
                "index.md": '---\ntitle: Intl.DateTimeFormat.supportedLocalesOf()\nslug: Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/supportedLocalesOf\npage-type: javascript-static-method\nbrowser-compat: javascript.builtins.Intl.DateTimeFormat.supportedLocalesOf\n---\n\n{{JSRef}}\n\nThe **`Intl.DateTimeFormat.supportedLocalesOf()`** static method returns an array containing those of the provided locales that are supported in date and time formatting without having to fall back to the runtime\'s default locale.\n\n{{EmbedInteractiveExample("pages/js/intl-datetimeformat-supportedlocalesof.html", "shorter")}}\n\n## Syntax\n\n```js-nolint\nIntl.DateTimeFormat.supportedLocalesOf(locales)\nIntl.DateTimeFormat.supportedLocalesOf(locales, options)\n```\n\n### Parameters\n\n- `locales`\n  - : A string with a BCP 47 language tag, or an array of such strings. For the general form and interpretation of the `locales` argument, see [the parameter description on the `Intl` main page](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl#locales_argument).\n- `options` {{optional_inline}}\n  - : An object that may have the following property:\n    - `localeMatcher`\n      - : The locale matching algorithm to use. Possible values are `"lookup"` and `"best fit"`; the default is `"best fit"`. For information about this option, see the {{jsxref("Intl", "Intl", "#locale_identification_and_negotiation", 1)}} page.\n\n### Return value\n\nAn array of strings representing a subset of the given locale tags that are supported in date and time formatting without having to fall back to the runtime\'s default locale.\n\n## Examples\n\n### Using supportedLocalesOf()\n\nAssuming a runtime that supports Indonesian and German but not Balinese in date and time formatting, `supportedLocalesOf` returns the Indonesian and German language tags unchanged, even though `pinyin` collation is neither relevant to date and time formatting nor used with Indonesian, and a specialized German for Indonesia is unlikely to be supported. Note the specification of the `"lookup"` algorithm here \u2014 a `"best fit"` matcher might decide that Indonesian is an adequate match for Balinese since most Balinese speakers also understand Indonesian, and therefore return the Balinese language tag as well.\n\n```js\nconst locales = ["ban", "id-u-co-pinyin", "de-ID"];\nconst options = { localeMatcher: "lookup" };\nconsole.log(Intl.DateTimeFormat.supportedLocalesOf(locales, options));\n// ["id-u-co-pinyin", "de-ID"]\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Intl.DateTimeFormat")}}\n'
            }
        },
        "displaynames": {
            "displaynames": {
                "index.md": '---\ntitle: Intl.DisplayNames() constructor\nslug: Web/JavaScript/Reference/Global_Objects/Intl/DisplayNames/DisplayNames\npage-type: javascript-constructor\nbrowser-compat: javascript.builtins.Intl.DisplayNames.DisplayNames\n---\n\n{{JSRef}}\n\nThe **`Intl.DisplayNames()`** constructor creates {{jsxref("Intl.DisplayNames")}} objects.\n\n{{EmbedInteractiveExample("pages/js/intl-displaynames.html")}}\n\n## Syntax\n\n```js-nolint\nnew Intl.DisplayNames(locales, options)\n```\n\n> **Note:** `Intl.DisplayNames()` can only be constructed with [`new`](/en-US/docs/Web/JavaScript/Reference/Operators/new). Attempting to call it without `new` throws a {{jsxref("TypeError")}}.\n\n### Parameters\n\n- `locales`\n  - : A string with a BCP 47 language tag or an {{jsxref("Intl.Locale")}} instance, or an array of such locale identifiers. For the general form and interpretation of the `locales` argument, see [the parameter description on the `Intl` main page](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl#locales_argument).\n- `options`\n  - : An object containing the following properties, in the order they are retrieved:\n    - `localeMatcher` {{optional_inline}}\n      - : The locale matching algorithm to use. Possible values are `"lookup"` and `"best fit"`; the default is `"best fit"`. For information about this option, see [Locale identification and negotiation](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl#locale_identification_and_negotiation).\n    - `style` {{optional_inline}}\n      - : The formatting style to use. Possible values are `"narrow"`, `"short"`, and `"long"`; the default is `"long"`.\n    - `type`\n      - : The type of display names to return from [`of()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DisplayNames/of). Possible values are `"language"`, `"region"`, `"script"`, `"currency"`, `"calendar"`, and `"dateTimeField"`.\n    - `fallback` {{optional_inline}}\n      - : What to return from `of()` if the input is structurally valid but there\'s no matching display name. Possible values are:\n        - `"code"` (default)\n          - : Return the input code itself.\n        - `"none"`\n          - : Return `undefined`.\n    - `languageDisplay` {{optional_inline}}\n      - : How language names should be displayed. Only usable along with `type: "language"`. Possible values are:\n        - `"dialect"` (default)\n          - : Display special regional dialects using their own name. E.g. `"nl-BE"` will be displayed as `"Flemish"`.\n        - `"standard"`\n          - : Display all languages using standard format. E.g. `"nl-BE"` will be displayed as `"Dutch (Belgium)"`.\n\n### Exceptions\n\n- {{jsxref("TypeError")}}\n  - : Thrown if `options.type` is not provided.\n- {{jsxref("RangeError")}}\n  - : Thrown if `locales` or `options` contain invalid values.\n\n## Examples\n\n### Basic usage\n\nIn basic use without specifying a locale, a formatted string in the default locale and\nwith default options is returned.\n\n```js\nconsole.log(new Intl.DisplayNames([], { type: "language" }).of("US"));\n// \'us\'\n```\n\n### Using type `dateTimeField`\n\nExample using `dateTimeField` as a type option, will return the localized date time names strings.\n\n```js\nconst dn = new Intl.DisplayNames("pt", { type: "dateTimeField" });\nconsole.log(dn.of("era")); // \'era\'\nconsole.log(dn.of("year")); // \'ano\'\nconsole.log(dn.of("month")); // \'m\xeas\'\nconsole.log(dn.of("quarter")); // \'trimestre\'\nconsole.log(dn.of("weekOfYear")); // \'semana\'\nconsole.log(dn.of("weekday")); // \'dia da semana\'\nconsole.log(dn.of("dayPeriod")); // \'AM/PM\'\nconsole.log(dn.of("day")); // \'dia\'\nconsole.log(dn.of("hour")); // \'hora\'\nconsole.log(dn.of("minute")); // \'minuto\'\nconsole.log(dn.of("second")); // \'segundo\'\n```\n\n### Using type `calendar`\n\nExample using `calendar` as a type option, will return the localized calendar names strings.\n\n```js\nconst dn = new Intl.DisplayNames("en", { type: "calendar" });\nconsole.log(dn.of("roc")); // \'Minguo Calendar\'\nconsole.log(dn.of("gregory")); // \'Gregorian Calendar\'\nconsole.log(dn.of("chinese")); // \'Chinese Calendar\'\n```\n\n### Using type `language` with `languageDisplay`\n\nExample using `language` as a type with `languageDisplay` options.\n\n```js\n// Using `dialect` option\nconst dnDialect = new Intl.DisplayNames("en", {\n  type: "language",\n  languageDisplay: "dialect",\n});\nconsole.log(dnDialect.of("en-GB")); // \'British English\'\n\n// Using `standard` option\nconst dnStd = new Intl.DisplayNames("en", {\n  type: "language",\n  languageDisplay: "standard",\n});\nconsole.log(dnStd.of("en-GB")); // \'English (United Kingdom)\'\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Intl.DisplayNames")}}\n- {{jsxref("Intl.supportedValuesOf()")}}\n- {{jsxref("Intl")}}\n'
            },
            "index.md": '---\ntitle: Intl.DisplayNames\nslug: Web/JavaScript/Reference/Global_Objects/Intl/DisplayNames\npage-type: javascript-class\nbrowser-compat: javascript.builtins.Intl.DisplayNames\n---\n\n{{JSRef}}\n\nThe **`Intl.DisplayNames`** object enables the consistent translation of language, region and script display names.\n\n{{EmbedInteractiveExample("pages/js/intl-displaynames.html")}}\n\n## Constructor\n\n- {{jsxref("Intl/DisplayNames/DisplayNames", "Intl.DisplayNames()")}}\n  - : Creates a new `Intl.DisplayNames` object.\n\n## Static methods\n\n- {{jsxref("Intl/DisplayNames/supportedLocalesOf", "Intl.DisplayNames.supportedLocalesOf()")}}\n  - : Returns an array containing those of the provided locales that are supported without having to fall back to the runtime\'s default locale.\n\n## Instance properties\n\nThese properties are defined on `Intl.DisplayNames.prototype` and shared by all `Intl.DisplayNames` instances.\n\n- {{jsxref("Object/constructor", "Intl.DisplayNames.prototype.constructor")}}\n  - : The constructor function that created the instance object. For `Intl.DisplayNames` instances, the initial value is the {{jsxref("Intl/DisplayNames/DisplayNames", "Intl.DisplayNames")}} constructor.\n- `Intl.DisplayNames.prototype[@@toStringTag]`\n  - : The initial value of the [`@@toStringTag`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol/toStringTag) property is the string `"Intl.DisplayNames"`. This property is used in {{jsxref("Object.prototype.toString()")}}.\n\n## Instance methods\n\n- {{jsxref("Intl/DisplayNames/of", "Intl.DisplayNames.prototype.of()")}}\n  - : This method receives a `code` and returns a string based on the locale and options provided when instantiating `Intl.DisplayNames`.\n- {{jsxref("Intl/DisplayNames/resolvedOptions", "Intl.DisplayNames.prototype.resolvedOptions()")}}\n  - : Returns a new object with properties reflecting the locale and formatting options computed during initialization of the object.\n\n## Examples\n\n### Region Code Display Names\n\nTo create an `Intl.DisplayNames` for a locale and get the display name for a region code.\n\n```js\n// Get display names of region in English\nlet regionNames = new Intl.DisplayNames(["en"], { type: "region" });\nregionNames.of("419"); // "Latin America"\nregionNames.of("BZ"); // "Belize"\nregionNames.of("US"); // "United States"\nregionNames.of("BA"); // "Bosnia & Herzegovina"\nregionNames.of("MM"); // "Myanmar (Burma)"\n\n// Get display names of region in Traditional Chinese\nregionNames = new Intl.DisplayNames(["zh-Hant"], { type: "region" });\nregionNames.of("419"); // "\u62C9\u4E01\u7F8E\u6D32"\nregionNames.of("BZ"); // "\u8C9D\u91CC\u65AF"\nregionNames.of("US"); // "\u7F8E\u570B"\nregionNames.of("BA"); // "\u6CE2\u58EB\u5C3C\u4E9E\u8207\u8D6B\u585E\u54E5\u7DAD\u7D0D"\nregionNames.of("MM"); // "\u7DEC\u7538"\n```\n\n### Language Display Names\n\nTo create an `Intl.DisplayNames` for a locale and get the display name for a language-script-region sequence.\n\n```js\n// Get display names of language in English\nlet languageNames = new Intl.DisplayNames(["en"], { type: "language" });\nlanguageNames.of("fr"); // "French"\nlanguageNames.of("de"); // "German"\nlanguageNames.of("fr-CA"); // "Canadian French"\nlanguageNames.of("zh-Hant"); // "Traditional Chinese"\nlanguageNames.of("en-US"); // "American English"\nlanguageNames.of("zh-TW"); // "Chinese (Taiwan)"]\n\n// Get display names of language in Traditional Chinese\nlanguageNames = new Intl.DisplayNames(["zh-Hant"], { type: "language" });\nlanguageNames.of("fr"); // "\u6CD5\u6587"\nlanguageNames.of("zh"); // "\u4E2D\u6587"\nlanguageNames.of("de"); // "\u5FB7\u6587"\n```\n\n### Script Code Display Names\n\nTo create an `Intl.DisplayNames` for a locale and get the display name for a script code.\n\n```js\n// Get display names of script in English\nlet scriptNames = new Intl.DisplayNames(["en"], { type: "script" });\n// Get script names\nscriptNames.of("Latn"); // "Latin"\nscriptNames.of("Arab"); // "Arabic"\nscriptNames.of("Kana"); // "Katakana"\n\n// Get display names of script in Traditional Chinese\nscriptNames = new Intl.DisplayNames(["zh-Hant"], { type: "script" });\nscriptNames.of("Latn"); // "\u62C9\u4E01\u6587"\nscriptNames.of("Arab"); // "\u963F\u62C9\u4F2F\u6587"\nscriptNames.of("Kana"); // "\u7247\u5047\u540D"\n```\n\n### Currency Code Display Names\n\nTo create an `Intl.DisplayNames` for a locale and get the display name for currency code.\n\n```js\n// Get display names of currency code in English\nlet currencyNames = new Intl.DisplayNames(["en"], { type: "currency" });\n// Get currency names\ncurrencyNames.of("USD"); // "US Dollar"\ncurrencyNames.of("EUR"); // "Euro"\ncurrencyNames.of("TWD"); // "New Taiwan Dollar"\ncurrencyNames.of("CNY"); // "Chinese Yuan"\n\n// Get display names of currency code in Traditional Chinese\ncurrencyNames = new Intl.DisplayNames(["zh-Hant"], { type: "currency" });\ncurrencyNames.of("USD"); // "\u7F8E\u5143"\ncurrencyNames.of("EUR"); // "\u6B50\u5143"\ncurrencyNames.of("TWD"); // "\u65B0\u53F0\u5E63"\ncurrencyNames.of("CNY"); // "\u4EBA\u6C11\u5E63"\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Intl")}}\n',
            "of": {
                "index.md": '---\ntitle: Intl.DisplayNames.prototype.of()\nslug: Web/JavaScript/Reference/Global_Objects/Intl/DisplayNames/of\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Intl.DisplayNames.of\n---\n\n{{JSRef}}\n\nThe **`of()`** method of {{jsxref("Intl.DisplayNames")}} instances receives a code and returns a string based on the locale and options provided when instantiating this `Intl.DisplayNames` object.\n\n{{EmbedInteractiveExample("pages/js/intl-displaynames.html")}}\n\n## Syntax\n\n```js-nolint\nof(code)\n```\n\n### Parameters\n\n- `code`\n\n  - : The `code` to provide depends on the `type`:\n\n    - If the type is "region", `code` should be either an [two-letter ISO 3166 region code](https://www.iso.org/iso-3166-country-codes.html), or a [three-digit UN M49 geographic region](https://unstats.un.org/unsd/methodology/m49/). It is required to follow the [`unicode_region_subtag`](https://unicode.org/reports/tr35/#unicode_region_subtag) grammar.\n    - If the type is "script", `code` should be an [four-letter ISO 15924 script code](https://unicode.org/iso15924/iso15924-codes.html). It is required to follow the [`unicode_script_subtag`](https://unicode.org/reports/tr35/#unicode_script_subtag) grammar.\n    - If the type is "language", `code` should be a _languageCode_ \\["-" _scriptCode_] \\["-" _regionCode_ ] \\*("-" _variant_ ) subsequence of the [`unicode_language_id`](https://unicode.org/reports/tr35/#Unicode_language_identifier) grammar. _languageCode_ is either a two-letter ISO 639-1 language code or a three-letter ISO 639-2 language code.\n    - If the type is "currency", `code` should be a [three-letter ISO 4217 currency code](https://www.iso.org/iso-4217-currency-codes.html). It is required to have exactly three alphabetic characters.\n    - If the type is "dateTimeField", `code` should be one of: `"era"`, `"year"`, `"quarter"`, `"month"`, `"weekOfYear"`, `"weekday"`, `"day"`, `"dayPeriod"`, `"hour"`, `"minute"`, `"second"`, `"timeZoneName"`.\n    - If the type is "calendar", `code` should be a [calendar key](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/calendar). It is required to follow the `type` grammar of a [Unicode locale identifier](https://unicode.org/reports/tr35/#32-unicode-locale-identifier).\n\n### Return value\n\nA language-specific formatted string, or `undefined` if there\'s no data for the input and `fallback` is `"none"`.\n\n> **Note:** `fallback` is only used if `code` is structurally valid. See [using fallback](#using_fallback).\n\n### Exceptions\n\n- {{jsxref("RangeError")}}\n  - : Thrown if `code` is not structurally valid for the given `type`.\n\n## Examples\n\n### Using the of method\n\n```js\nconst regionNames = new Intl.DisplayNames("en", { type: "region" });\nregionNames.of("419"); // "Latin America"\n\nconst languageNames = new Intl.DisplayNames("en", { type: "language" });\nlanguageNames.of("fr"); // "French"\n\nconst currencyNames = new Intl.DisplayNames("en", { type: "currency" });\ncurrencyNames.of("EUR"); // "Euro"\n```\n\n### Using fallback\n\nWhen the `Intl.DisplayNames` is constructed with `fallback: "code"`, the `of()` method will return the `code` if the input looks structurally valid but there\'s no data for the input. If `fallback` is `"none"`, `undefined` is returned.\n\n```js\nconsole.log(\n  new Intl.DisplayNames("en", { type: "region", fallback: "code" }).of("ZL"),\n); // "ZL"\n\nconsole.log(\n  new Intl.DisplayNames("en", { type: "region", fallback: "none" }).of("ZL"),\n); // undefined\n```\n\nHowever, this only applies if the `code` is structurally valid. For example, if `type` is `"region"` but `code` does not follow the `unicode_region_subtag` grammar (2 alphabetic characters or 3 numeric characters), a {{jsxref("RangeError")}} is directly thrown instead of using the fallback.\n\n```js\nconsole.log(\n  new Intl.DisplayNames("en", { type: "region", fallback: "code" }).of("ZLC"),\n); // throws RangeError: invalid value "ZLC" for option region\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Intl.DisplayNames")}}\n'
            },
            "resolvedoptions": {
                "index.md": '---\ntitle: Intl.DisplayNames.prototype.resolvedOptions()\nslug: Web/JavaScript/Reference/Global_Objects/Intl/DisplayNames/resolvedOptions\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Intl.DisplayNames.resolvedOptions\n---\n\n{{JSRef}}\n\nThe **`resolvedOptions()`** method of {{jsxref("Intl.DisplayNames")}} instances\nreturns a new object with properties reflecting the locale and style formatting\noptions computed during the construction of this `Intl.DisplayNames`\nobject.\n\n## Syntax\n\n```js-nolint\nresolvedOptions()\n```\n\n### Parameters\n\nNone.\n\n### Return value\n\nAn object with properties reflecting the locale and formatting options computed during\nthe construction of the given {{jsxref("Intl.DisplayNames")}} object.\n\n## Description\n\nThe object returned by `resolvedOptions()` has the following properties:\n\n- `locale`\n  - : The BCP 47 language tag for the locale actually used. If any Unicode extension\n    values were requested in the input BCP 47 language tag that led to this locale,\n    the key-value pairs that were requested and are supported for this locale are\n    included in `locale`.\n- `style`\n  - : The value provided for this property in the `options` argument of the\n    constructor or the default value (`"long"`). Its value is either\n    `"long"`, `"short"`, or `"narrow"`.\n- `type`\n  - : The value provided for this property in the `options` argument of the\n    constructor or the default value (`"language"`). Its value is either\n    `"language"`, `"region"`, `"script"`, or\n    `"currency"`.\n- `fallback`\n  - : The value provided for this property in the options argument of the constructor or\n    the default value (`"code"`). Its value is either `"code"`\n    or `"none"`.\n\n## Examples\n\n### Using resolvedOptions\n\n```js\nconst displayNames = new Intl.DisplayNames(["de-DE"], { type: "region" });\n\nconst usedOptions = displayNames.resolvedOptions();\nconsole.log(usedOptions.locale); // "de-DE"\nconsole.log(usedOptions.style); // "long"\nconsole.log(usedOptions.type); // "region"\nconsole.log(usedOptions.fallback); // "code"\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Intl.DisplayNames")}}\n'
            },
            "supportedlocalesof": {
                "index.md": '---\ntitle: Intl.DisplayNames.supportedLocalesOf()\nslug: Web/JavaScript/Reference/Global_Objects/Intl/DisplayNames/supportedLocalesOf\npage-type: javascript-static-method\nbrowser-compat: javascript.builtins.Intl.DisplayNames.supportedLocalesOf\n---\n\n{{JSRef}}\n\nThe **`Intl.DisplayNames.supportedLocalesOf()`** static method returns an array containing those of the provided locales that are supported in display names without having to fall back to the runtime\'s default locale.\n\n## Syntax\n\n```js-nolint\nIntl.DisplayNames.supportedLocalesOf(locales)\nIntl.DisplayNames.supportedLocalesOf(locales, options)\n```\n\n### Parameters\n\n- `locales`\n  - : A string with a BCP 47 language tag, or an array of such strings. For the general form and interpretation of the `locales` argument, see [the parameter description on the `Intl` main page](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl#locales_argument).\n- `options` {{optional_inline}}\n  - : An object that may have the following property:\n    - `localeMatcher`\n      - : The locale matching algorithm to use. Possible values are `"lookup"` and `"best fit"`; the default is `"best fit"`. For information about this option, see the {{jsxref("Intl", "Intl", "#locale_identification_and_negotiation", 1)}} page.\n\n### Return value\n\nAn array of strings representing a subset of the given locale tags that are supported in display names without having to fall back to the runtime\'s default locale.\n\n## Examples\n\n### Using supportedLocalesOf()\n\nAssuming a runtime that supports Indonesian and German but not Balinese in display names, `supportedLocalesOf` returns the Indonesian and German language tags unchanged, even though `pinyin` collation is neither relevant to display names nor used with Indonesian, and a specialized German for Indonesia is unlikely to be supported. Note the specification of the `"lookup"` algorithm here \u2014 a `"best fit"` matcher might decide that Indonesian is an adequate match for Balinese since most Balinese speakers also understand Indonesian, and therefore return the Balinese language tag as well.\n\n```js\nconst locales = ["ban", "id-u-co-pinyin", "de-ID"];\nconst options = { localeMatcher: "lookup" };\nconsole.log(Intl.DisplayNames.supportedLocalesOf(locales, options));\n// ["id-u-co-pinyin", "de-ID"]\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Intl.DisplayNames")}}\n'
            }
        },
        "durationformat": {
            "durationformat": {
                "index.md": '---\ntitle: Intl.DurationFormat() constructor\nslug: Web/JavaScript/Reference/Global_Objects/Intl/DurationFormat/DurationFormat\npage-type: javascript-constructor\nstatus:\n  - experimental\nbrowser-compat: javascript.builtins.Intl.DurationFormat.DurationFormat\n---\n\n{{JSRef}} {{SeeCompatTable}}\n\nThe **`Intl.DurationFormat()`** constructor creates {{jsxref("Intl.DurationFormat")}} objects.\n\n## Syntax\n\n```js-nolint\nnew Intl.DurationFormat()\nnew Intl.DurationFormat(locales)\nnew Intl.DurationFormat(locales, options)\n```\n\n> **Note:** `Intl.DurationFormat()` can only be constructed with [`new`](/en-US/docs/Web/JavaScript/Reference/Operators/new). Attempting to call it without `new` throws a {{jsxref("TypeError")}}.\n\n### Parameters\n\n- `locales` {{optional_inline}}\n\n  - : A string with a BCP 47 language tag or an {{jsxref("Intl.Locale")}} instance, or an array of such locale identifiers. For the general form and interpretation of the `locales` argument, see [the parameter description on the `Intl` main page](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl#locales_argument).\n\n    The following Unicode extension key is allowed:\n\n    - `nu`\n      - : See [`numberingSystem`](#numberingsystem).\n\n    This key can also be set with `options` (as listed below). When both are set, the `options` property takes precedence.\n\n- `options` {{optional_inline}}\n\n  - : An object containing the following properties, in the order they are retrieved (all of them are optional):\n\n    - `localeMatcher`\n      - : The locale matching algorithm to use. Possible values are `"lookup"` and `"best fit"`; the default is `"best fit"`. For information about this option, see [Locale identification and negotiation](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl#locale_identification_and_negotiation).\n    - `numberingSystem`\n      - : The numbering system to use for number formatting, such as `"arab"`, `"hans"`, `"mathsans"`, and so on. For a list of supported numbering system types, see [`Intl.Locale.prototype.getNumberingSystems()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/getNumberingSystems#supported_numbering_system_types). This option can also be set through the `nu` Unicode extension key; if both are provided, this `options` property takes precedence.\n    - `style`\n      - : The style of the formatted duration. Possible values are:\n        - `"long"`\n          - : E.g., 1 hour and 50 minutes\n        - `"short"` (default)\n          - : E.g., 1 hr, 50 min\n        - `"narrow"`\n          - : E.g., 1h 50m\n        - `"digital"`\n          - : E.g., 1:50:00\n    - `years`\n      - : The style of the formatted years. Possible values are `"long"`, `"short"`, and `"narrow"`; the default is `options.style` if it\'s not `"digital"`, and `"short"` otherwise.\n    - `yearsDisplay`\n      - : Whether to always display years, or only if nonzero. Possible values are `"always"` and `"auto"`; the default is `"auto"` if `years` is unspecified, and `"always"` otherwise.\n    - `months`\n      - : The style of the formatted months. Possible values are `"long"`, `"short"`, and `"narrow"`; the default is `options.style` if it\'s not `"digital"`, and `"short"` otherwise.\n    - `monthsDisplay`\n      - : Whether to always display months, or only if nonzero. Possible values are `"always"` and `"auto"`; the default is `"auto"` if `months` is unspecified, and `"always"` otherwise.\n    - `weeks`\n      - : The style of the formatted weeks. Possible values are `"long"`, `"short"`, and `"narrow"`; the default is `options.style` if it\'s not `"digital"`, and `"short"` otherwise.\n    - `weeksDisplay`\n      - : Whether to always display weeks, or only if nonzero. Possible values are `"always"` and `"auto"`; the default is `"auto"` if `weeks` is unspecified, and `"always"` otherwise.\n    - `days`\n      - : The style of the formatted days. Possible values are `"long"`, `"short"`, and `"narrow"`; the default is `options.style` if it\'s not `"digital"`, and `"short"` otherwise.\n    - `daysDisplay`\n      - : Whether to always display days, or only if nonzero. Possible values are `"always"` and `"auto"`; the default is `"auto"` if `days` is unspecified, and `"always"` otherwise.\n    - `hours`\n      - : The style of the formatted hours. Possible values are `"long"`, `"short"`, `"narrow"`, `"numeric"`, and `"2-digit"`; the default is `options.style` if it\'s not `"digital"`, and `"numeric"` otherwise.\n    - `hoursDisplay`\n      - : Whether to always display hours, or only if nonzero. Possible values are `"always"` and `"auto"`; the default is `"auto"` if `hours` is unspecified and `options.style` is not `"digital"`, and `"always"` otherwise.\n    - `minutes`\n      - : The style of the formatted minutes.\n        - If `hours` is `"numeric"` or `"2-digit"`, possible values are `"numeric"` and `"2-digit"`, and `"numeric"` is normalized to `"2-digit"`; the default is `"numeric"`.\n        - Otherwise, possible values are `"long"`, `"short"`, `"narrow"`, `"numeric"`, and `"2-digit"`; the default is `options.style` if it\'s not `"digital"`, and `"numeric"` otherwise.\n    - `minutesDisplay`\n      - : Whether to always display minutes, or only if nonzero. Possible values are `"always"` and `"auto"`; the default is `"auto"` if `minutes` is unspecified and `options.style` is not `"digital"`, and `"always"` otherwise.\n    - `seconds`\n      - : The style of the formatted seconds.\n        - If `minutes` is `"numeric"` or `"2-digit"`, possible values are `"numeric"` and `"2-digit"`, and `"numeric"` is normalized to `"2-digit"`; the default is `"numeric"`.\n        - Otherwise, possible values are `"long"`, `"short"`, `"narrow"`, `"numeric"`, and `"2-digit"`; the default is `options.style` if it\'s not `"digital"`, and `"numeric"` otherwise.\n    - `secondsDisplay`\n      - : Whether to always display seconds, or only if nonzero. Possible values are `"always"` and `"auto"`; the default is `"auto"` if `seconds` is unspecified and `options.style` is not `"digital"`, and `"always"` otherwise.\n    - `milliseconds`\n      - : The style of the formatted milliseconds.\n        - If `seconds` is `"numeric"` or `"2-digit"`, the only possible value is `"numeric"`; the default is `"numeric"`.\n        - Otherwise, possible values are `"long"`, `"short"`, `"narrow"`, and `"numeric"`; the default is `options.style` if it\'s not `"digital"`, and `"numeric"` otherwise.\n    - `millisecondsDisplay`\n      - : Whether to always display milliseconds, or only if nonzero.\n        - If `seconds` is `"numeric"` or `"2-digit"`, the only possible value is `"auto"`; the default is only `"auto"` when `milliseconds` is unspecified.\n        - Otherwise, possible values are `"always"` and `"auto"`; the default is `"auto"` if `milliseconds` is unspecified, and `"always"` otherwise.\n    - `microseconds`\n      - : The style of the formatted microseconds.\n        - If `milliseconds` is `"numeric"`, the only possible value is `"numeric"`; the default is `"numeric"`.\n        - Otherwise, possible values are `"long"`, `"short"`, `"narrow"`, and `"numeric"`; the default is `options.style` if it\'s not `"digital"`, and `"numeric"` otherwise.\n    - `microsecondsDisplay`\n      - : Whether to always display microseconds, or only if nonzero.\n        - If `milliseconds` is `"numeric"`, the only possible value is `"auto"`; the default is only `"auto"` when `microseconds` is unspecified.\n        - Otherwise, possible values are `"always"` and `"auto"`; the default is `"auto"` if `microseconds` is unspecified, and `"always"` otherwise.\n    - `nanoseconds`\n      - : The style of the formatted nanoseconds.\n        - If `microseconds` is `"numeric"`, the only possible value is `"numeric"`; the default is `"numeric"`.\n        - Otherwise, possible values are `"long"`, `"short"`, `"narrow"`, and `"numeric"`; the default is `options.style` if it\'s not `"digital"`, and `"numeric"` otherwise.\n    - `nanosecondsDisplay`\n      - : Whether to always display nanoseconds, or only if nonzero.\n        - If `microseconds` is `"numeric"`, the only possible value is `"auto"`; the default is only `"auto"` when `nanoseconds` is unspecified.\n        - Otherwise, possible values are `"always"` and `"auto"`; the default is `"auto"` if `nanoseconds` is unspecified, and `"always"` otherwise.\n    - `fractionalDigits`\n      - : Number of how many fractional second digits to display in the output. Possible values are from `0` to `9`; the default is `undefined` (include as many fractional digits as necessary).\n\n### Exceptions\n\n- {{jsxref("RangeError")}}\n  - : Thrown if `locales` or `options` contain invalid values.\n\n## Description\n\nFor each time segment, an {{jsxref("Intl.NumberFormat")}} object is constructed under the hood. It uses the following options (see {{jsxref("Intl/NumberFormat/NumberFormat", "Intl.NumberFormat()")}} for details):\n\n- `numberingSystem`: the value of `options.numberingSystem`\n\nWhen `milliseconds`, `microseconds`, or `nanoseconds` uses the `"numeric"` style, the following options are also used:\n\n- `minimumFractionDigits`: `0` when `options.fractionalDigits` is `undefined`, `options.fractionalDigits` otherwise\n- `maximumFractionDigits`: `9` when `options.fractionalDigits` is `undefined`, `options.fractionalDigits` otherwise\n- `roundingMode`: `"trunc"`\n\nWhen the time segment uses the `"2-digit"` style, the following options are also used:\n\n- `minimumIntegerDigits`: `2`\n\nWhen the time segment uses the `"long"`, `"short"`, or `"narrow"` style, the following options are also used:\n\n- `style`: `"unit"` when `"long"`, `"short"`, or `"narrow"` is specified, `undefined` otherwise\n- `unit`: the currently formatted unit (`"years"`, `"days"`, `"nanoseconds"`, etc.)\n- `unitDisplay`: the value of the time segment style (`"long"`, `"short"`, or `"narrow"`)\n\n## Examples\n\n### Using the Intl.DurationFormat() constructor\n\n```js\nconst duration = {\n  hours: 2,\n  minutes: 20,\n  seconds: 35,\n};\n\nconsole.log(new Intl.DurationFormat("pt", { style: "long" }).format(duration));\n// "2 horas, 20 minutos e 35 segundos"\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Intl.DurationFormat")}}\n- {{jsxref("Intl.supportedValuesOf()")}}\n- {{jsxref("Intl")}}\n'
            },
            "format": {
                "index.md": '---\ntitle: Intl.DurationFormat.prototype.format()\nslug: Web/JavaScript/Reference/Global_Objects/Intl/DurationFormat/format\npage-type: javascript-instance-method\nstatus:\n  - experimental\nbrowser-compat: javascript.builtins.Intl.DurationFormat.format\n---\n\n{{JSRef}} {{SeeCompatTable}}\n\nThe **`format()`** method of {{jsxref("Intl.DurationFormat")}} instances formats a duration according to the locale and formatting options of this {{jsxref("Intl.DurationFormat")}} object.\n\n## Syntax\n\n```js-nolint\nformat(duration)\n```\n\n### Parameters\n\n- `duration`\n  - : The duration object to be formatted. It should include some or all of the following properties: `months`, `weeks`, `days`, `hours`, `minutes`, `seconds`, `milliseconds`, `microseconds`, `nanoseconds`.\n\n### Return value\n\nA string representing the given `duration` formatted according to the locale and formatting options of this {{jsxref("Intl.DurationFormat")}} object.\n\n## Examples\n\n### Using format()\n\nThe following example shows how to create a Duration formatter using the English language.\n\n```js\nconst duration = {\n  years: 1,\n  months: 2,\n  weeks: 3,\n  days: 3,\n  hours: 4,\n  minutes: 5,\n  seconds: 6,\n  milliseconds: 7,\n  microseconds: 8,\n  nanoseconds: 9,\n};\n\n// Without options, style defaults to "short"\nnew Intl.DurationFormat("en").format(duration);\n// "1 yr, 2 mths, 3 wks, 3 days, 4 hr, 5 min, 6 sec, 7 ms, 8 \u03BCs, 9 ns"\n\n// With style set to "long"\nnew Intl.DurationFormat("en", { style: "long" }).format(duration);\n// "1 year, 2 months, 3 weeks, 3 days, 4 hours, 5 minutes, 6 seconds, 7 milliseconds, 8 microseconds, 9 nanoseconds"\n\n// With style set to "narrow"\nnew Intl.DurationFormat("en", { style: "narrow" }).format(duration);\n// "1y 2mo 3w 3d 4h 5m 6s 7ms 8\u03BCs 9ns"\n```\n\n### Using format() with different locales and styles\n\n```js\nconst duration = {\n  hours: 1,\n  minutes: 46,\n  seconds: 40,\n};\n\n// With style set to "long" and locale "fr-FR"\nnew Intl.DurationFormat("fr-FR", { style: "long" }).format(duration);\n// "1 heure, 46 minutes et 40 secondes"\n\n// With style set to "short" and locale set to "en"\nnew Intl.DurationFormat("en", { style: "short" }).format(duration);\n// "1 hr, 46 min and 40 sec"\n\n// With style set to "short" and locale set to "pt"\nnew Intl.DurationFormat("pt", { style: "narrow" }).format(duration);\n// "1h 46min 40s"\n\n// With style set to "digital" and locale set to "en"\nnew Intl.DurationFormat("en", { style: "digital" }).format(duration);\n// "1:46:40"\n\n// With style set to "digital", locale set to "en", and hours set to "long"\nnew Intl.DurationFormat("en", { style: "digital", hours: "long" }).format(\n  duration,\n);\n// "1 hour, 46:40"\n```\n\n### Using format() with the fractionalDigits option\n\n```js\nconst duration = {\n  hours: 11,\n  minutes: 30,\n  seconds: 12,\n  milliseconds: 345,\n  microseconds: 600,\n};\n\nnew Intl.DurationFormat("en", { style: "digital" }).format(duration);\n// "11:30:12.3456"\n\nnew Intl.DurationFormat("en", { style: "digital", fractionalDigits: 5 }).format(\n  duration,\n);\n// "11:30:12.34560"\n\nnew Intl.DurationFormat("en", { style: "digital", fractionalDigits: 3 }).format(\n  duration,\n);\n// "11:30:12.346"\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Intl.DurationFormat")}}\n- {{jsxref("Intl.supportedValuesOf()")}}\n- {{jsxref("Intl")}}\n'
            },
            "formattoparts": {
                "index.md": '---\ntitle: Intl.DurationFormat.prototype.formatToParts()\nslug: Web/JavaScript/Reference/Global_Objects/Intl/DurationFormat/formatToParts\npage-type: javascript-instance-method\nstatus:\n  - experimental\nbrowser-compat: javascript.builtins.Intl.DurationFormat.formatToParts\n---\n\n{{JSRef}} {{SeeCompatTable}}\n\nThe **`formatToParts()`** method of {{jsxref("Intl.DurationFormat")}} instances allows locale-aware formatting of strings produced by {{jsxref("Intl.DurationFormat")}} formatters.\n\n## Syntax\n\n```js-nolint\nformatToParts(duration)\n```\n\n### Parameters\n\n- `duration` {{optional_inline}}\n  - : The duration object to be formatted. It should include some or all of the following properties: `"months"`, `"weeks"`, `"days"`, `"hours"`, `"minutes"`, `"seconds"`, `"milliseconds"`, `"microseconds"`, `"nanoseconds"`.\n\n### Return value\n\nAn {{jsxref("Array")}} of objects containing the formatted duration in parts.\n\n## Description\n\nThe `formatToParts()` method is useful for custom formatting of duration objects. It returns an {{jsxref("Array")}} of objects containing the locale-specific tokens from which it possible to build custom strings while preserving the locale-specific parts. The structure the `formatToParts()` method returns, looks like this:\n\n```js\n[\n  { type: "integer", value: "7", unit: "hour" },\n  { type: "literal", value: " ", unit: "hour" },\n  { type: "unit", value: "hr", unit: "hour" },\n  { type: "literal", value: ", " },\n  { type: "integer", value: "8", unit: "minute" },\n  { type: "literal", value: " ", unit: "minute" },\n  { type: "unit", value: "min", unit: "minute" },\n];\n```\n\n## Examples\n\nThe `formatToParts` method enables locale-aware formatting of strings produced by `DurationFormat` formatters by providing you the string in parts:\n\n```js\nconst duration = {\n  hours: 7,\n  minutes: 8,\n  seconds: 9,\n  milliseconds: 123,\n  microseconds: 456,\n  nanoseconds: 789,\n};\n\nnew Intl.DurationFormat("en", { style: "long" }).formatToParts(duration);\n\n// Returned value:\n[\n  { type: "integer", value: "7", unit: "hour" },\n  { type: "literal", value: " ", unit: "hour" },\n  { type: "unit", value: "hours", unit: "hour" },\n  { type: "literal", value: ", " },\n  { type: "integer", value: "8", unit: "minute" },\n  { type: "literal", value: " ", unit: "minute" },\n  { type: "unit", value: "minutes", unit: "minute" },\n  { type: "literal", value: ", " },\n  { type: "integer", value: "9", unit: "second" },\n  { type: "literal", value: " ", unit: "second" },\n  { type: "unit", value: "seconds", unit: "second" },\n  { type: "literal", value: ", " },\n  { type: "integer", value: "123", unit: "millisecond" },\n  { type: "literal", value: " ", unit: "millisecond" },\n  { type: "unit", value: "milliseconds", unit: "millisecond" },\n  { type: "literal", value: ", " },\n  { type: "integer", value: "456", unit: "microsecond" },\n  { type: "literal", value: " ", unit: "microsecond" },\n  { type: "unit", value: "microseconds", unit: "microsecond" },\n  { type: "literal", value: " and " },\n  { type: "integer", value: "789", unit: "nanosecond" },\n  { type: "literal", value: " ", unit: "nanosecond" },\n  { type: "unit", value: "nanoseconds", unit: "nanosecond" },\n];\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Intl.DurationFormat")}}\n- {{jsxref("Intl.supportedValuesOf()")}}\n- {{jsxref("Intl")}}\n'
            },
            "index.md": '---\ntitle: Intl.DurationFormat\nslug: Web/JavaScript/Reference/Global_Objects/Intl/DurationFormat\npage-type: javascript-class\nstatus:\n  - experimental\nbrowser-compat: javascript.builtins.Intl.DurationFormat\n---\n\n{{JSRef}} {{SeeCompatTable}}\n\nThe **`Intl.DurationFormat`** object enables language-sensitive duration formatting.\n\n## Constructor\n\n- {{jsxref("Intl/DurationFormat/DurationFormat", "Intl.DurationFormat()")}} {{experimental_inline}}\n  - : Creates a new `Intl.DurationFormat` object.\n\n## Static methods\n\n- {{jsxref("Intl/DurationFormat/supportedLocalesOf", "Intl.DurationFormat.supportedLocalesOf()")}} {{experimental_inline}}\n  - : Returns an array containing those of the provided locales that are supported without having to fall back to the runtime\'s default locale.\n\n## Instance properties\n\nThese properties are defined on `Intl.DurationFormat.prototype` and shared by all `Intl.DurationFormat` instances.\n\n- {{jsxref("Object/constructor", "Intl.DurationFormat.prototype.constructor")}}\n  - : The constructor function that created the instance object. For `Intl.DurationFormat` instances, the initial value is the {{jsxref("Intl/DurationFormat/DurationFormat", "Intl.DurationFormat")}} constructor.\n- `Intl.DurationFormat.prototype[@@toStringTag]`\n  - : The initial value of the [`@@toStringTag`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol/toStringTag) property is the string `"Intl.DurationFormat"`. This property is used in {{jsxref("Object.prototype.toString()")}}.\n\n## Instance methods\n\n- {{jsxref("Intl/DurationFormat/format", "Intl.DurationFormat.prototype.format()")}} {{experimental_inline}}\n  - : Getter function that formats a duration according to the locale and formatting options of this `DurationFormat` object.\n- {{jsxref("Intl/DurationFormat/formatToParts", "Intl.DurationFormat.prototype.formatToParts()")}} {{experimental_inline}}\n  - : Returns an {{jsxref("Array")}} of objects representing the formatted duration in parts.\n- {{jsxref("Intl/DurationFormat/resolvedOptions", "Intl.DurationFormat.prototype.resolvedOptions()")}} {{experimental_inline}}\n  - : Returns a new object with properties reflecting the locale and formatting options computed during initialization of the object.\n\n## Examples\n\n### Using Intl.DurationFormat\n\nThe examples below show how to use the `Intl.DurationFormat` object to format a duration object with various locales and styles.\n\n```js\nconst duration = {\n  hours: 1,\n  minutes: 46,\n  seconds: 40,\n};\n\n// With style set to "long" and locale "fr-FR"\nnew Intl.DurationFormat("fr-FR", { style: "long" }).format(duration);\n// "1 heure, 46 minutes et 40 secondes"\n\n// With style set to "short" and locale "en"\nnew Intl.DurationFormat("en", { style: "short" }).format(duration);\n// "1 hr, 46 min and 40 sec"\n\n// With style set to "short" and locale "pt"\nnew Intl.DurationFormat("pt", { style: "narrow" }).format(duration);\n// "1h 46min 40s"\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Intl")}}\n',
            "resolvedoptions": {
                "index.md": '---\ntitle: Intl.DurationFormat.prototype.resolvedOptions()\nslug: Web/JavaScript/Reference/Global_Objects/Intl/DurationFormat/resolvedOptions\npage-type: javascript-instance-method\nstatus:\n  - experimental\nbrowser-compat: javascript.builtins.Intl.DurationFormat.resolvedOptions\n---\n\n{{JSRef}} {{SeeCompatTable}}\n\nThe **`resolvedOptions()`** method of {{jsxref("Intl.DurationFormat")}} instances returns a new object with properties reflecting the locale and date and time formatting options computed during initialization of this {{jsxref("Intl.DurationFormat")}} object.\n\n## Syntax\n\n```js-nolint\nresolvedOptions()\n```\n\n### Parameters\n\nNone.\n\n### Return value\n\nA new object with properties reflecting the locale and date and time formatting options computed during the initialization of the given {{jsxref("Intl.DateTimeFormat")}} object.\n\n## Description\n\nThe resulting object has the following properties:\n\n- `locale`\n  - : The [BCP 47 language tag](https://datatracker.ietf.org/doc/html/rfc5646) for the locale used. If any Unicode extension values were requested in the input BCP 47 language tag that led to this locale, the key-value pairs that were requested and are supported for this locale are included in `locale`.\n- `style`\n  - : One of the strings `"long"`, `"short"`, `"narrow"`, or `"digital"` identifying the duration formatting style used.\n- `years`\n  - : One of the strings `"long"`, `"short"`, or `"narrow"` identifying the formatting style used for the `years` field.\n- `yearsDisplay`\n  - : One of the strings `"auto"` or `"always"` identifying when to display the `years` field.\n- `months`\n  - : One of the strings `"long"`, `"short"`, `and "narrow"` identifying the formatting style used for the `months` field.\n- `monthsDisplay`\n  - : One of the strings `"auto"` or `"always"` identifying when to display the `months` field.\n- `weeks`\n  - : One of the strings `"long"`, `"short"`, `and "narrow"` identifying the formatting style used for the `weeks` field.\n- `weeksDisplay`\n  - : One of the strings `"auto"` or `"always"` identifying when to display the `weeks` field.\n- `days`\n  - : One of the strings `"long"`, `"short"`, and `"narrow"` identifying the formatting style used for the `days` field.\n- `daysDisplay`\n  - : One of the strings `"auto"` or `"always"` identifying when to display the `days` field.\n- `hours`\n  - : One of the strings `"long"`, `"short"`, `"narrow"`, `"2-digit"`, or `"numeric"` identifying the formatting style used for the `hours` field.\n- `hoursDisplay`\n  - : One of the strings `"auto"` or `"always"` identifying when to display the `hours` field.\n- `minutes`\n  - : One of the strings `"long"`, `"short"`, `"narrow"`, `"2-digit"`, or `"numeric"` identifying the formatting style used for the `minutes` field.\n- `minutesDisplay`\n  - : One of the strings `"auto"` or `"always"` identifying when to display the `minutes` field.\n- `seconds`\n  - : One of the strings `"long"`, `"short"`, `"narrow"`, `"2-digit"`, or `"numeric"` identifying the formatting style used for the `seconds` field.\n- `secondsDisplay`\n  - : One of the strings `"auto"` or `"always"` identifying when to display the `seconds` field.\n- `milliseconds`\n  - : One of the strings `"long"`, `"short"`, `"narrow"`, or `"numeric"` identifying the formatting style used for the `milliseconds` field.\n- `millisecondsDisplay`\n  - : One of the strings `"auto"` or `"always"` identifying when to display the `millisecondsDisplay` field.\n- `microseconds`\n  - : One of the strings `"long"`, `"short"`, `"narrow"`, or `"numeric"` identifying the formatting style used for the `microseconds` field.\n- `microsecondsDisplay`\n  - : One of the strings `"auto"` or `"always"` identifying when to display the `microsecondsDisplay` field.\n- `nanoseconds`\n  - : One of the strings `"long"`, `"short"`, `"narrow"`, or `"numeric"` identifying the formatting style used for the `nanoseconds` field.\n- `nanosecondsDisplay`\n  - : One of the strings `"auto"` or `"always"` identifying when to display the `nanosecondsDisplay` field.\n- `fractionalDigits`\n  - : A number, identifying the number of fractional digits used with numeric styles.\n- `numberingSystem`\n  - : The value provided for this property in the options argument, if present, or the value requested using the Unicode extension key `nu` or filled in as a default.\n\n## Examples\n\n### Using the resolvedOptions method\n\n```js\nconst duration = new Intl.DurationFormat("en");\nconst usedOptions = duration.resolvedOptions();\n\nusedOptions.locale; // "en"\nusedOptions.numberingSystem; // "latn"\nusedOptions.years; // "long"\nusedOptions.yearsDisplay; // "auto"\nusedOptions.style; // "long"\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Intl.DurationFormat")}}\n- {{jsxref("Intl.supportedValuesOf()")}}\n- {{jsxref("Intl")}}\n'
            },
            "supportedlocalesof": {
                "index.md": '---\ntitle: Intl.DurationFormat.supportedLocalesOf()\nslug: Web/JavaScript/Reference/Global_Objects/Intl/DurationFormat/supportedLocalesOf\npage-type: javascript-static-method\nstatus:\n  - experimental\nbrowser-compat: javascript.builtins.Intl.DurationFormat.supportedLocalesOf\n---\n\n{{JSRef}}{{SeeCompatTable}}\n\nThe **`Intl.DurationFormat.supportedLocalesOf()`** static method returns an array containing those of the provided locales that are supported in duration formatting without having to fall back to the runtime\'s default locale.\n\n## Syntax\n\n```js-nolint\nIntl.DurationFormat.supportedLocalesOf(locales)\nIntl.DurationFormat.supportedLocalesOf(locales, options)\n```\n\n### Parameters\n\n- `locales`\n  - : A string with a BCP 47 language tag, or an array of such strings. For the general form and interpretation of the `locales` argument, see [the parameter description on the `Intl` main page](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl#locales_argument).\n- `options` {{optional_inline}}\n  - : An object that may have the following property:\n    - `localeMatcher`\n      - : The locale matching algorithm to use. Possible values are `"lookup"` and `"best fit"`; the default is `"best fit"`. For information about this option, see the {{jsxref("Intl", "Intl", "#locale_identification_and_negotiation", 1)}} page.\n\n### Return value\n\nAn array of strings representing a subset of the given locale tags that are supported in duration formatting without having to fall back to the runtime\'s default locale.\n\n## Examples\n\n### Using supportedLocalesOf()\n\nAssuming a runtime that supports Indonesian and German but not Balinese in duration formatting, `supportedLocalesOf` returns the Indonesian and German language tags unchanged, even though `pinyin` collation is neither relevant to duration formatting nor used with Indonesian, and a specialized German for Indonesia is unlikely to be supported. Note the specification of the `"lookup"` algorithm here \u2014 a `"best fit"` matcher might decide that Indonesian is an adequate match for Balinese since most Balinese speakers also understand Indonesian, and therefore return the Balinese language tag as well.\n\n```js\nconst locales = ["ban", "id-u-co-pinyin", "de-ID"];\nconst options = { localeMatcher: "lookup" };\nconsole.log(Intl.DurationFormat.supportedLocalesOf(locales, options));\n// ["id-u-co-pinyin", "de-ID"]\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Intl.DurationFormat")}}\n'
            }
        },
        "getcanonicallocales": {
            "index.md": '---\ntitle: Intl.getCanonicalLocales()\nslug: Web/JavaScript/Reference/Global_Objects/Intl/getCanonicalLocales\npage-type: javascript-static-method\nbrowser-compat: javascript.builtins.Intl.getCanonicalLocales\n---\n\n{{JSRef}}\n\nThe **`Intl.getCanonicalLocales()`** static method returns an array\ncontaining the canonical locale names. Duplicates will be omitted and elements will be\nvalidated as structurally valid language tags.\n\n{{EmbedInteractiveExample("pages/js/intl-getcanonicallocales.html")}}\n\n## Syntax\n\n```js-nolint\nIntl.getCanonicalLocales(locales)\n```\n\n### Parameters\n\n- `locales`\n  - : A list of {{jsxref("String")}} values for which to get the canonical locale names.\n\n### Return value\n\nAn array containing the canonical locale names.\n\n## Examples\n\n### Using getCanonicalLocales\n\n```js\nIntl.getCanonicalLocales("EN-US"); // ["en-US"]\nIntl.getCanonicalLocales(["EN-US", "Fr"]); // ["en-US", "fr"]\n\nIntl.getCanonicalLocales("EN_US");\n// RangeError:\'EN_US\' is not a structurally valid language tag\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Intl.getCanonicalLocales` in FormatJS](https://formatjs.io/docs/polyfills/intl-getcanonicallocales/)\n- {{jsxref("Intl/NumberFormat/supportedLocalesOf", "Intl.NumberFormat.supportedLocalesOf()")}}\n- {{jsxref("Intl/DateTimeFormat/supportedLocalesOf", "Intl.DateTimeFormat.supportedLocalesOf()")}}\n- {{jsxref("Intl/Collator/supportedLocalesOf", "Intl.Collator.supportedLocalesOf()")}}\n'
        },
        "index.md": '---\ntitle: Intl\nslug: Web/JavaScript/Reference/Global_Objects/Intl\npage-type: javascript-namespace\nbrowser-compat: javascript.builtins.Intl\n---\n\n{{JSRef}}\n\nThe **`Intl`** namespace object contains several constructors as well as functionality common to the internationalization constructors and other language sensitive functions. Collectively, they comprise the ECMAScript Internationalization API, which provides language sensitive string comparison, number formatting, date and time formatting, and more.\n\n## Description\n\nUnlike most global objects, `Intl` is not a constructor. You cannot use it with the [`new` operator](/en-US/docs/Web/JavaScript/Reference/Operators/new) or invoke the `Intl` object as a function. All properties and methods of `Intl` are static (just like the {{jsxref("Math")}} object).\n\nThe internationalization constructors as well as several language sensitive methods of other constructors (listed under [See also](#see_also)) use a common pattern for identifying locales and determining the one they will actually use: they all accept `locales` and `options` arguments, and negotiate the requested locale(s) against the locales they support using an algorithm specified in the `options.localeMatcher` property.\n\n### locales argument\n\nThe `locales` argument is used to determine the locale used in a given operation. The JavaScript implementation examines `locales`, and then computes a locale it understands that comes closest to satisfying the expressed preference. `locales` may be:\n\n- `undefined` (or omitted): The implementation\'s default locale will be used.\n- A locale: A locale identifier or an [`Intl.Locale`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale) object that wraps a locale identifier.\n- A list of locales: Any other value, that will be converted into an object and then treated as an array of locales.\n\nIn the latter two cases, the actual locale used is the best-supported locale determined by [locale negotiation](#locale_identification_and_negotiation). If a locale identifier is not a string or an object, a {{jsxref("TypeError")}} is thrown. If a locale identifier is a string that\'s syntactically invalid, a {{jsxref("RangeError")}} is thrown. If a locale identifier is well-formed but the implementation doesn\'t recognize it, it is ignored and the next locale in the list is considered, eventually falling back to the system\'s locale. However, you shouldn\'t rely on a particular locale name being ignored, because the implementation may add data for any locale in the future. For example, `new Intl.DateTimeFormat("default")` uses the implementation\'s default locale only because `"default"` is syntactically valid but not recognized as any locale.\n\nA locale identifier is a string that consists of:\n\n1. A language subtag with 2\u20133 or 5\u20138 letters\n2. A script subtag with 4 letters {{optional_inline}}\n3. A region subtag with either 2 letters or 3 digits {{optional_inline}}\n4. One or more variant subtags (all of which must be unique), each with either 5\u20138 alphanumerals or a digit followed by 3 alphanumerals {{optional_inline}}\n5. One or more BCP 47 extension sequences {{optional_inline}}\n6. A private-use extension sequence {{optional_inline}}\n\nEach subtag and sequence are separated by hyphens. Locale identifiers are case-insensitive {{Glossary("ASCII")}}. However, it\'s conventional to use title case (the first letter is capitalized, successive letters are lower case) for script subtags, upper case for region subtags, and lower case for everything else. For example:\n\n- `"hi"`: Hindi (language)\n- `"de-AT"`: German (language) as used in Austria (region)\n- `"zh-Hans-CN"`: Chinese (language) written in simplified characters (script) as used in China (region)\n- `"en-emodeng"`: English (language) in the "Early modern English" dialect (variant)\n\nSubtags identifying languages, scripts, regions (including countries), and (rarely used) variants are registered in the [IANA Language Subtag Registry](https://www.iana.org/assignments/language-subtag-registry/language-subtag-registry). This registry is periodically updated over time, and implementations may not always be up to date, so don\'t rely too much on subtags being universally supported.\n\nBCP 47 extension sequences consist of a single digit or letter (other than `"x"`) and one or more two- to eight-letter or digit subtags separated by hyphens. Only one sequence is permitted for each digit or letter: `"de-a-foo-a-foo"` is invalid. BCP 47 extension subtags are defined in the [Unicode CLDR Project](https://github.com/unicode-org/cldr/tree/main/common/bcp47). Currently only two extensions have defined semantics:\n\n- The `"u"` (Unicode) extension can be used to request additional customization of `Intl` API objects. Examples:\n\n  - `"de-DE-u-co-phonebk"`: Use the phonebook variant of the German sort order, which interprets umlauted vowels as corresponding character pairs: \xe4 \u2192 ae, \xf6 \u2192 oe, \xfc \u2192 ue.\n  - `"th-TH-u-nu-thai"`: Use Thai digits (\u0E50, \u0E51, \u0E52, \u0E53, \u0E54, \u0E55, \u0E56, \u0E57, \u0E58, \u0E59) in number formatting.\n  - `"ja-JP-u-ca-japanese"`: Use the Japanese calendar in date and time formatting, so that 2013 is expressed as the year 25 of the Heisei period, or \u5E73\u6210 25.\n  - `"en-GB-u-ca-islamic"`: use British English with the Islamic (Hijri) calendar, where the Gregorian date 14 October, 2017 is the Hijri date 24 Muharram, 1439.\n\n- The `"t"` (transformed) extension indicates transformed content: for example, text that was translated from another locale. No `Intl` functionality currently considers the `"t"` extension. However, this extension sometimes contains a nested locale (with no extensions): for example, the transformed extension in `"de-t-en"` contains the locale identifier for English. If a nested locale is present, it must be a valid locale identifier. For example, because `"en-emodeng-emodeng"` is invalid (because it contains a duplicate `emodeng` variant subtag), `"de-t-en-emodeng-emodeng"` is also invalid.\n\nFinally, a private-use extension sequence using the letter `"x"` may appear, followed by one or more one- to eight-letter or digit subtags separated by hyphens. This allows applications to encode information for their own private use, that will be ignored by all `Intl` operations.\n\n### options argument\n\nThe `options` argument must be an object with properties that vary between constructors and functions. If the `options` argument is not provided or is undefined, default values are used for all properties.\n\nOne property is supported by all language sensitive constructors and functions: The `localeMatcher` property, whose value must be a string `"lookup"` or `"best fit"` and which selects one of the locale matching algorithms described below.\n\n### Locale identification and negotiation\n\nThe list of locales specified by the `locales` argument, after Unicode extensions have been removed from them, is interpreted as a prioritized request from the application. The runtime compares it against the locales it has available and picks the best one available. Two matching algorithms exist: the `"lookup"` matcher follows the Lookup algorithm specified in [BCP 47](https://datatracker.ietf.org/doc/html/rfc4647#section-3.4); the `"best fit"` matcher lets the runtime provide a locale that\'s at least, but possibly more, suited for the request than the result of the Lookup algorithm. If the application doesn\'t provide a `locales` argument, or the runtime doesn\'t have a locale that matches the request, then the runtime\'s default locale is used. The matcher can be selected using a property of the `options` argument (see below).\n\nIf the selected locale identifier had a Unicode extension sequence, that extension is now used to customize the constructed object or the behavior of the function. Each constructor or function supports only a subset of the keys defined for the Unicode extension, and the supported values often depend on the locale identifier. For example, the `"co"` key (collation) is only supported by {{jsxref("Intl.Collator")}}, and its `"phonebk"` value is only supported for German.\n\n## Static properties\n\n- {{jsxref("Intl.Collator")}}\n  - : Constructor for collators, which are objects that enable language-sensitive string comparison.\n- {{jsxref("Intl.DateTimeFormat")}}\n  - : Constructor for objects that enable language-sensitive date and time formatting.\n- {{jsxref("Intl.DisplayNames")}}\n  - : Constructor for objects that enable the consistent translation of language, region and script display names.\n- {{jsxref("Intl.DurationFormat")}} {{experimental_inline}}\n  - : Constructor for objects that enable locale-sensitive duration formatting.\n- {{jsxref("Intl.ListFormat")}}\n  - : Constructor for objects that enable language-sensitive list formatting.\n- {{jsxref("Intl.Locale")}}\n  - : Constructor for objects that represents a Unicode locale identifier.\n- {{jsxref("Intl.NumberFormat")}}\n  - : Constructor for objects that enable language-sensitive number formatting.\n- {{jsxref("Intl.PluralRules")}}\n  - : Constructor for objects that enable plural-sensitive formatting and language-specific rules for plurals.\n- {{jsxref("Intl.RelativeTimeFormat")}}\n  - : Constructor for objects that enable language-sensitive relative time formatting.\n- {{jsxref("Intl.Segmenter")}}\n  - : Constructor for objects that enable locale-sensitive text segmentation.\n- `Intl[@@toStringTag]`\n  - : The initial value of the [`@@toStringTag`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol/toStringTag) property is the string `"Intl"`. This property is used in {{jsxref("Object.prototype.toString()")}}.\n\n## Static methods\n\n- {{jsxref("Intl.getCanonicalLocales()")}}\n  - : Returns canonical locale names.\n- {{jsxref("Intl.supportedValuesOf()")}}\n  - : Returns a sorted array containing the supported unique calendar, collation, currency, numbering systems, or unit values supported by the implementation.\n\n## Examples\n\n### Formatting dates and numbers\n\nYou can use `Intl` to format dates and numbers in a form that\'s conventional for a specific language and region:\n\n```js\nconst count = 26254.39;\nconst date = new Date("2012-05-24");\n\nfunction log(locale) {\n  console.log(\n    `${new Intl.DateTimeFormat(locale).format(date)} ${new Intl.NumberFormat(\n      locale,\n    ).format(count)}`,\n  );\n}\n\nlog("en-US"); // 5/24/2012 26,254.39\n\nlog("de-DE"); // 24.5.2012 26.254,39\n```\n\n### Using the browser\'s preferred language\n\nInstead of passing a hardcoded locale name to the `Intl` methods, you can use the user\'s preferred language provided by {{domxref("navigator.language")}}:\n\n```js\nconst date = new Date("2012-05-24");\n\nconst formattedDate = new Intl.DateTimeFormat(navigator.language).format(date);\n```\n\nAlternatively, the {{domxref("navigator.languages")}} property provides a sorted list of the user\'s preferred languages. This list can be passed directly to the `Intl` constructors to implement preference-based fallback selection of locales. The [locale negotiation](#locale_identification_and_negotiation) process is used to pick the most appropriate locale available:\n\n```js\nconst count = 26254.39;\n\nconst formattedCount = new Intl.NumberFormat(navigator.languages).format(count);\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("String.prototype.localeCompare()")}}\n- {{jsxref("Number.prototype.toLocaleString()")}}\n- {{jsxref("Date.prototype.toLocaleString()")}}\n- {{jsxref("Date.prototype.toLocaleDateString()")}}\n- {{jsxref("Date.prototype.toLocaleTimeString()")}}\n- {{domxref("navigator.language")}}\n- {{domxref("navigator.languages")}}\n- [The ECMAScript Internationalization API](https://norbertlindenberg.com/2012/12/ecmascript-internationalization-api/index.html) by Norbert Lindenberg (2012)\n',
        "listformat": {
            "format": {
                "index.md": '---\ntitle: Intl.ListFormat.prototype.format()\nslug: Web/JavaScript/Reference/Global_Objects/Intl/ListFormat/format\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Intl.ListFormat.format\n---\n\n{{JSRef}}\n\nThe **`format()`** method of {{jsxref("Intl.ListFormat")}} instances returns a string with a\nlanguage-specific representation of the list.\n\n{{EmbedInteractiveExample("pages/js/intl-listformat.html", "taller")}}\n\n## Syntax\n\n```js-nolint\nformat()\nformat(list)\n```\n\n### Parameters\n\n- `list`\n  - : An iterable object, such as an Array.\n\n### Return value\n\nA language-specific formatted string representing the elements of the list\n\n## Description\n\nThe **`format()`** method returns a string that has been\nformatted based on parameters provided in the `Intl.ListFormat` object. The\n`locales` and `options` parameters customize the behavior of\n`format()` and let applications specify the language conventions that\nshould be used to format the list.\n\n## Examples\n\n### Using format\n\nThe following example shows how to create a List formatter using the English language.\n\n```js\nconst list = ["Motorcycle", "Bus", "Car"];\n\nconsole.log(\n  new Intl.ListFormat("en-GB", { style: "long", type: "conjunction" }).format(\n    list,\n  ),\n);\n// Motorcycle, Bus and Car\n\nconsole.log(\n  new Intl.ListFormat("en-GB", { style: "short", type: "disjunction" }).format(\n    list,\n  ),\n);\n// Motorcycle, Bus or Car\n\nconsole.log(\n  new Intl.ListFormat("en-GB", { style: "narrow", type: "unit" }).format(list),\n);\n// Motorcycle Bus Car\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Intl.ListFormat")}}\n'
            },
            "formattoparts": {
                "index.md": '---\ntitle: Intl.ListFormat.prototype.formatToParts()\nslug: Web/JavaScript/Reference/Global_Objects/Intl/ListFormat/formatToParts\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Intl.ListFormat.formatToParts\n---\n\n{{JSRef}}\n\nThe **`formatToParts()`** method of {{jsxref("Intl.ListFormat")}} instances\nreturns an {{jsxref("Array")}} of objects representing the different components that\ncan be used to format a list of values in a locale-aware fashion.\n\n{{EmbedInteractiveExample("pages/js/intl-listformat-prototype-formattoparts.html", "taller")}}\n\n## Syntax\n\n```js-nolint\nformatToParts(list)\n```\n\n### Parameters\n\n- `list`\n  - : An iterable object, such as an {{jsxref("Array")}}, to be formatted according to a locale.\n\n### Return value\n\nAn {{jsxref("Array")}} of components which contains the formatted parts from the list.\n\n## Description\n\nWhereas {{jsxref("Intl/ListFormat/format", "Intl.ListFormat.prototype.format()")}} returns a string being the formatted version\nof the list (according to the given locale and style options),\n`formatToParts()` returns an array of the different components of the\nformatted string.\n\nEach element of the resulting array has two properties: `type` and\n`value`. The `type` property may be either\n`"element"`, which refers to a value from the list, or\n`"literal"` which refers to a linguistic construct. The `value`\nproperty gives the content, as a string, of the token.\n\nThe locale and style options used for formatting are given when constructing the\n{{jsxref("Intl.ListFormat")}} instance.\n\n## Examples\n\n### Using formatToParts\n\n```js\nconst fruits = ["Apple", "Orange", "Pineapple"];\nconst myListFormat = new Intl.ListFormat("en-GB", {\n  style: "long",\n  type: "conjunction",\n});\n\nconsole.table(myListFormat.formatToParts(fruits));\n// [\n//  { "type": "element", "value": "Apple" },\n//  { "type": "literal", "value": ", " },\n//  { "type": "element", "value": "Orange" },\n//  { "type": "literal", "value": ", and " },\n//  { "type": "element", "value": "Pineapple" }\n// ]\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Intl.ListFormat")}}\n- {{jsxref("Intl/ListFormat/format", "Intl.ListFormat.prototype.format()")}}\n- {{jsxref("Intl/RelativeTimeFormat/formatToParts", "Intl.RelativeTimeFormat.prototype.formatToParts()")}}\n- {{jsxref("Intl/NumberFormat/formatToParts", "Intl.NumberFormat.prototype.formatToParts()")}}\n- {{jsxref("Intl/DateTimeFormat/formatToParts", "Intl.DateTimeFormat.prototype.formatToParts()")}}\n'
            },
            "index.md": '---\ntitle: Intl.ListFormat\nslug: Web/JavaScript/Reference/Global_Objects/Intl/ListFormat\npage-type: javascript-class\nbrowser-compat: javascript.builtins.Intl.ListFormat\n---\n\n{{JSRef}}\n\nThe **`Intl.ListFormat`** object enables language-sensitive list formatting.\n\n{{EmbedInteractiveExample("pages/js/intl-listformat.html", "taller")}}\n\n## Constructor\n\n- {{jsxref("Intl/ListFormat/ListFormat", "Intl.ListFormat()")}}\n  - : Creates a new `Intl.ListFormat` object.\n\n## Static methods\n\n- {{jsxref("Intl/ListFormat/supportedLocalesOf", "Intl.ListFormat.supportedLocalesOf()")}}\n  - : Returns an array containing those of the provided locales that are supported without having to fall back to the runtime\'s default locale.\n\n## Instance properties\n\nThese properties are defined on `Intl.ListFormat.prototype` and shared by all `Intl.ListFormat` instances.\n\n- {{jsxref("Object/constructor", "Intl.ListFormat.prototype.constructor")}}\n  - : The constructor function that created the instance object. For `Intl.ListFormat` instances, the initial value is the {{jsxref("Intl/ListFormat/ListFormat", "Intl.ListFormat")}} constructor.\n- `Intl.ListFormat.prototype[@@toStringTag]`\n  - : The initial value of the [`@@toStringTag`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol/toStringTag) property is the string `"Intl.ListFormat"`. This property is used in {{jsxref("Object.prototype.toString()")}}.\n\n## Instance methods\n\n- {{jsxref("Intl/ListFormat/format", "Intl.ListFormat.prototype.format()")}}\n  - : Returns a language-specific formatted string representing the elements of the list.\n- {{jsxref("Intl/ListFormat/formatToParts", "Intl.ListFormat.prototype.formatToParts()")}}\n  - : Returns an array of objects representing the different components that can be used to format a list of values in a locale-aware fashion.\n- {{jsxref("Intl/ListFormat/resolvedOptions", "Intl.ListFormat.prototype.resolvedOptions()")}}\n  - : Returns a new object with properties reflecting the locale and style formatting options computed during the construction of the current {{jsxref("Intl.ListFormat")}} object.\n\n## Examples\n\n### Using format\n\nThe following example shows how to create a List formatter using the English language.\n\n```js\nconst list = ["Motorcycle", "Bus", "Car"];\n\nconsole.log(\n  new Intl.ListFormat("en-GB", { style: "long", type: "conjunction" }).format(\n    list,\n  ),\n);\n// Motorcycle, Bus and Car\n\nconsole.log(\n  new Intl.ListFormat("en-GB", { style: "short", type: "disjunction" }).format(\n    list,\n  ),\n);\n// Motorcycle, Bus or Car\n\nconsole.log(\n  new Intl.ListFormat("en-GB", { style: "narrow", type: "unit" }).format(list),\n);\n// Motorcycle Bus Car\n```\n\n### Using formatToParts\n\nThe following example shows how to create a List formatter returning formatted parts\n\n```js\nconst list = ["Motorcycle", "Bus", "Car"];\nconsole.log(\n  new Intl.ListFormat("en-GB", {\n    style: "long",\n    type: "conjunction",\n  }).formatToParts(list),\n);\n\n// [ { "type": "element", "value": "Motorcycle" },\n//   { "type": "literal", "value": ", " },\n//   { "type": "element", "value": "Bus" },\n//   { "type": "literal", "value": ", and " },\n//   { "type": "element", "value": "Car" } ];\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Intl.ListFormat` in FormatJS](https://formatjs.io/docs/polyfills/intl-listformat/)\n- {{jsxref("Intl")}}\n',
            "listformat": {
                "index.md": '---\ntitle: Intl.ListFormat() constructor\nslug: Web/JavaScript/Reference/Global_Objects/Intl/ListFormat/ListFormat\npage-type: javascript-constructor\nbrowser-compat: javascript.builtins.Intl.ListFormat.ListFormat\n---\n\n{{JSRef}}\n\nThe **`Intl.ListFormat()`** constructor creates {{jsxref("Intl.ListFormat")}} objects.\n\n{{EmbedInteractiveExample("pages/js/intl-listformat.html", "taller")}}\n\n## Syntax\n\n```js-nolint\nnew Intl.ListFormat()\nnew Intl.ListFormat(locales)\nnew Intl.ListFormat(locales, options)\n```\n\n> **Note:** `Intl.ListFormat()` can only be constructed with [`new`](/en-US/docs/Web/JavaScript/Reference/Operators/new). Attempting to call it without `new` throws a {{jsxref("TypeError")}}.\n\n### Parameters\n\n- `locales` {{optional_inline}}\n  - : A string with a BCP 47 language tag or an {{jsxref("Intl.Locale")}} instance, or an array of such locale identifiers. For the general form and interpretation of the `locales` argument, see [the parameter description on the `Intl` main page](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl#locales_argument).\n- `options` {{optional_inline}}\n  - : An object containing the following properties, in the order they are retrieved (all of them are optional):\n    - `localeMatcher`\n      - : The locale matching algorithm to use. Possible values are `"lookup"` and `"best fit"`; the default is `"best fit"`. For information about this option, see [Locale identification and negotiation](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl#locale_identification_and_negotiation).\n    - `type`\n      - : Indicates the type of grouping. Possible values are:\n        - `"conjunction"` (default)\n          - : For "and"-based grouping of the list items: "A, B, and C"\n        - `"disjunction"`\n          - : For "or"-based grouping of the list items: "A, B, or C"\n        - `"unit"`\n          - : For grouping the list items as a unit (neither "and"-based nor "or"-based): "A, B, C"\n    - `style`\n      - : The grouping style (for example, whether list separators and conjunctions are included). Possible values are:\n        - `"long"` (default)\n          - : E.g. "A, B, and C"\n        - `"short"`\n          - : E.g. "A, B, C"\n        - `"narrow"`\n          - : E.g. "A B C"\n\n### Exceptions\n\n- {{jsxref("RangeError")}}\n  - : Thrown if `locales` or `options` contain invalid values.\n\n## Examples\n\n### Using format\n\nThe following example shows how to create a List formatter using the English language.\n\n```js\nconst list = ["Motorcycle", "Bus", "Car"];\n\nconsole.log(\n  new Intl.ListFormat("en-GB", { style: "long", type: "conjunction" }).format(\n    list,\n  ),\n);\n// Motorcycle, Bus and Car\n\nconsole.log(new Intl.ListFormat("en-GB", { style: "long" }).format(list));\n// Motorcycle, Bus and Car\n\nconsole.log(new Intl.ListFormat("en-US", { style: "long" }).format(list));\n// Motorcycle, Bus, and Car\n\nconsole.log(\n  new Intl.ListFormat("en-GB", { style: "short", type: "conjunction" }).format(\n    list,\n  ),\n);\n// Motorcycle, Bus and Car\n\nconsole.log(\n  new Intl.ListFormat("en-US", { style: "short", type: "conjunction" }).format(\n    list,\n  ),\n);\n// Motorcycle, Bus, & Car\n\nconsole.log(\n  new Intl.ListFormat("en-GB", { style: "narrow", type: "conjunction" }).format(\n    list,\n  ),\n);\n// Motorcycle, Bus, Car\n\nconsole.log(\n  new Intl.ListFormat("en-GB", { style: "long", type: "disjunction" }).format(\n    list,\n  ),\n);\n// Motorcycle, Bus or Car\n\nconsole.log(\n  new Intl.ListFormat("en-GB", { style: "short", type: "disjunction" }).format(\n    list,\n  ),\n);\n// Motorcycle, Bus or Car\n\nconsole.log(\n  new Intl.ListFormat("en-GB", { style: "narrow", type: "disjunction" }).format(\n    list,\n  ),\n);\n// Motorcycle, Bus or Car\n\nconsole.log(new Intl.ListFormat("en-US", { style: "narrow" }).format(list));\n// Motorcycle, Bus, Car\n\nconsole.log(\n  new Intl.ListFormat("en-GB", { style: "narrow", type: "unit" }).format(list),\n);\n// Motorcycle Bus Car\n\nconsole.log(\n  new Intl.ListFormat("en-US", { style: "long" }).format([\n    "30 degrees",\n    "15 minutes",\n    "50 seconds",\n  ]),\n);\n// 30 degrees, 15 minutes, and 50 seconds\n\nconsole.log(\n  new Intl.ListFormat("en-US", { style: "narrow" }).format([\n    "30 degrees",\n    "15 minutes",\n    "50 seconds",\n  ]),\n);\n// 30 degrees, 15 minutes, 50 seconds\n\nconsole.log(\n  new Intl.ListFormat("en-US", { style: "narrow", type: "unit" }).format([\n    "30\xb0",\n    "15\u2032",\n    "50\u2033",\n  ]),\n);\n// 30\xb0 15\u2032 50\u2033\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Intl.ListFormat")}}\n- {{jsxref("Intl")}}\n'
            },
            "resolvedoptions": {
                "index.md": '---\ntitle: Intl.ListFormat.prototype.resolvedOptions()\nslug: Web/JavaScript/Reference/Global_Objects/Intl/ListFormat/resolvedOptions\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Intl.ListFormat.resolvedOptions\n---\n\n{{JSRef}}\n\nThe **`resolvedOptions()`** method of {{jsxref("Intl.ListFormat")}} instances\nreturns a new object with properties reflecting the locale and style formatting\noptions computed during the construction of this `Intl.ListFormat` object.\n\n{{EmbedInteractiveExample("pages/js/intl-listformat-prototype-resolvedoptions.html")}}\n\n## Syntax\n\n```js-nolint\nresolvedOptions()\n```\n\n### Parameters\n\nNone.\n\n### Return value\n\nAn object with properties reflecting the locale and formatting options computed during\nthe construction of the given {{jsxref("Intl.ListFormat")}} object.\n\n## Description\n\nThe object returned by `resolvedOptions()` has the following properties:\n\n- `locale`\n  - : The BCP 47 language tag for the locale actually used. If any Unicode extension\n    values were requested in the input BCP 47 language tag that led to this locale,\n    the key-value pairs that were requested and are supported for this locale are\n    included in `locale`.\n- `style`\n  - : The value provided for this property in the `options` argument of the\n    constructor or the default value (`"long"`). Its value is either\n    `"long"`, `"short"`, or `"narrow"`.\n- `type`\n  - : The value provided for this property in the `options` argument of the\n    constructor or the default value (`"conjunction"`). Its value is either\n    `"conjunction"`, `"disjunction"`, or `"unit"`.\n\n## Examples\n\n### Using resolvedOptions\n\n```js\nconst deListFormatter = new Intl.ListFormat("de-DE", { style: "short" });\n\nconst usedOptions = de.resolvedOptions();\nconsole.log(usedOptions.locale); // "de-DE"\nconsole.log(usedOptions.style); // "short"\nconsole.log(usedOptions.type); // "conjunction" (the default value)\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Intl.ListFormat")}}\n- {{jsxref("Intl/NumberFormat/resolvedOptions", "Intl.NumberFormat.prototype.resolvedOptions()")}}\n- {{jsxref("Intl/Collator/resolvedOptions", "Intl.Collator.prototype.resolvedOptions()")}}\n- {{jsxref("Intl/DateTimeFormat/resolvedOptions", "Intl.DateTimeFormat.prototype.resolvedOptions()")}}\n- {{jsxref("Intl/PluralRules/resolvedOptions", "Intl.PluralRules.prototype.resolvedOptions()")}}\n'
            },
            "supportedlocalesof": {
                "index.md": '---\ntitle: Intl.ListFormat.supportedLocalesOf()\nslug: Web/JavaScript/Reference/Global_Objects/Intl/ListFormat/supportedLocalesOf\npage-type: javascript-static-method\nbrowser-compat: javascript.builtins.Intl.ListFormat.supportedLocalesOf\n---\n\n{{JSRef}}\n\nThe **`Intl.ListFormat.supportedLocalesOf()`** static method returns an array containing those of the provided locales that are supported in list formatting without having to fall back to the runtime\'s default locale.\n\n## Syntax\n\n```js-nolint\nIntl.ListFormat.supportedLocalesOf(locales)\nIntl.ListFormat.supportedLocalesOf(locales, options)\n```\n\n### Parameters\n\n- `locales`\n  - : A string with a BCP 47 language tag, or an array of such strings. For the general form and interpretation of the `locales` argument, see [the parameter description on the `Intl` main page](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl#locales_argument).\n- `options` {{optional_inline}}\n  - : An object that may have the following property:\n    - `localeMatcher`\n      - : The locale matching algorithm to use. Possible values are `"lookup"` and `"best fit"`; the default is `"best fit"`. For information about this option, see the {{jsxref("Intl", "Intl", "#locale_identification_and_negotiation", 1)}} page.\n\n### Return value\n\nAn array of strings representing a subset of the given locale tags that are supported in list formatting without having to fall back to the runtime\'s default locale.\n\n## Examples\n\n### Using supportedLocalesOf()\n\nAssuming a runtime that supports Indonesian and German but not Balinese in list formatting, `supportedLocalesOf` returns the Indonesian and German language tags unchanged, even though `pinyin` collation is neither relevant to list formatting nor used with Indonesian, and a specialized German for Indonesia is unlikely to be supported. Note the specification of the `"lookup"` algorithm here \u2014 a `"best fit"` matcher might decide that Indonesian is an adequate match for Balinese since most Balinese speakers also understand Indonesian, and therefore return the Balinese language tag as well.\n\n```js\nconst locales = ["ban", "id-u-co-pinyin", "de-ID"];\nconst options = { localeMatcher: "lookup" };\nconsole.log(Intl.ListFormat.supportedLocalesOf(locales, options));\n// ["id-u-co-pinyin", "de-ID"]\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Intl.ListFormat")}}\n'
            }
        },
        "locale": {
            "basename": {
                "index.md": '---\ntitle: Intl.Locale.prototype.baseName\nslug: Web/JavaScript/Reference/Global_Objects/Intl/Locale/baseName\npage-type: javascript-instance-accessor-property\nbrowser-compat: javascript.builtins.Intl.Locale.baseName\n---\n\n{{JSRef}}\n\nThe **`baseName`** accessor property of {{jsxref("Intl.Locale")}} instances returns a substring of this locale\'s string representation, containing core information about this locale.\n\n## Description\n\nAn {{jsxref("Intl.Locale")}} object represents a parsed local and options for that locale. The `baseName` property returns basic, core information about the Locale in the form of a substring of the complete data string. Specifically, the property returns the substring containing the language, and the script and region if available.\n\n`baseName` returns the `language ["-" script] ["-" region] *("-" variant)` subsequence of the [unicode_language_id grammar](https://www.unicode.org/reports/tr35/#Identifiers).\n\n## Examples\n\n### Basic Example\n\n```js\nconst myLoc = new Intl.Locale("fr-Latn-CA"); // Sets locale to Canadian French\nconsole.log(myLoc.toString()); // Prints out "fr-Latn-CA-u-ca-gregory"\nconsole.log(myLoc.baseName); // Prints out "fr-Latn-CA"\n```\n\n### Example with options in the input string\n\n```js\n// Sets language to Japanese, region to Japan,\n\n// calendar to Gregorian, hour cycle to 24 hours\nconst japan = new Intl.Locale("ja-JP-u-ca-gregory-hc-24");\nconsole.log(japan.toString()); // Prints out "ja-JP-u-ca-gregory-hc-h24"\nconsole.log(japan.baseName); // Prints out "ja-JP"\n```\n\n### Example with options that override input string\n\n```js\n// Input string indicates language as Dutch and region as Belgium,\n\n// but options object overrides the region and sets it to the Netherlands\nconst dutch = new Intl.Locale("nl-Latn-BE", { region: "NL" });\n\nconsole.log(dutch.baseName); // Prints out "nl-Latn-NL"\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Intl.Locale")}}\n'
            },
            "calendar": {
                "index.md": '---\ntitle: Intl.Locale.prototype.calendar\nslug: Web/JavaScript/Reference/Global_Objects/Intl/Locale/calendar\npage-type: javascript-instance-accessor-property\nbrowser-compat: javascript.builtins.Intl.Locale.calendar\n---\n\n{{JSRef}}\n\nThe **`calendar`** accessor property of {{jsxref("Intl.Locale")}} instances returns the calendar type for this locale.\n\n## Description\n\nWhile most of the world uses the Gregorian calendar, there are several regional calendar eras used around the world. The `calendar` property\'s value is set at construction time, either through the `ca` key of the locale identifier or through the `calendar` option of the {{jsxref("Intl/Locale/Locale", "Intl.Locale()")}} constructor. The latter takes priority if they are both present; and if neither is present, the property has value `undefined`.\n\nFor a list of supported calendar types, see [`Intl.Locale.prototype.getCalendars()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/getCalendars#supported_calendar_types).\n\nThe set accessor of `calendar` is `undefined`. You cannot change this property directly.\n\n## Examples\n\nLike other locale subtags, the calendar type can be added to the {{jsxref("Intl.Locale")}} object via the locale string, or a configuration object argument to the constructor.\n\n### Adding a calendar type via the locale string\n\nIn the [Unicode locale string spec](https://www.unicode.org/reports/tr35/), calendar era types are locale key "extension subtags". These subtags add additional data about the locale, and are added to locale identifiers by using the `-u` extension. Thus, the calendar era type can be added to the initial locale identifier string that is passed into the {{jsxref("Intl/Locale/Locale", "Intl.Locale()")}} constructor. To add the calendar type, first add the `-u` extension to the string. Next, add the `-ca` extension to indicate that you are adding a calendar type. Finally, add the calendar era type to the string.\n\n```js\nconst locale = new Intl.Locale("fr-FR-u-ca-buddhist");\nconsole.log(locale.calendar); // Prints "buddhist"\n```\n\n### Adding a calendar type via the configuration object argument\n\nThe {{jsxref("Intl/Locale/Locale", "Intl.Locale()")}} constructor has an optional configuration object argument, which can contain any of several extension types, including calendars. Set the `calendar` property of the configuration object to your desired calendar era, and then pass it into the constructor.\n\n```js\nconst locale = new Intl.Locale("fr-FR", { calendar: "buddhist" });\nconsole.log(locale.calendar); // "buddhist"\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Intl.Locale")}}\n- [`Intl.Locale.prototype.getCalendars()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/getCalendars)\n- [Unicode Calendar Identifier](https://www.unicode.org/reports/tr35/#UnicodeCalendarIdentifier) in the Unicode locale data markup language spec\n'
            },
            "casefirst": {
                "index.md": '---\ntitle: Intl.Locale.prototype.caseFirst\nslug: Web/JavaScript/Reference/Global_Objects/Intl/Locale/caseFirst\npage-type: javascript-instance-accessor-property\nbrowser-compat: javascript.builtins.Intl.Locale.caseFirst\n---\n\n{{JSRef}}\n\nThe **`caseFirst`** accessor property of {{jsxref("Intl.Locale")}} instances returns whether case is taken into account for this locale\'s collation rules.\n\n## Description\n\nA locale\'s collation rules are used to determine how strings are ordered in that locale. Certain locales use a character\'s case (UPPERCASE or lowercase) in the collation process. This additional rule can be expressed in a {{jsxref("Intl.Locale")}} object\'s `caseFirst` property.\n\nThere are 3 values that the `caseFirst` property can have, outlined in the table below.\n\n### `caseFirst` values\n\n| Value   | Description                                |\n| ------- | ------------------------------------------ |\n| `upper` | Upper case to be sorted before lower case. |\n| `lower` | Lower case to be sorted before upper case. |\n| `false` | No special case ordering.                  |\n\n## Examples\n\n### Setting the caseFirst value via the locale string\n\nIn the [Unicode locale string spec](https://www.unicode.org/reports/tr35/), the values that `caseFirst` represents correspond to the key `kf`. `kf` is treated as a locale string "extension subtag". These subtags add additional data about the locale, and are added to locale identifiers by using the `-u` extension key. Thus, the `caseFirst` value can be added to the initial locale identifier string that is passed into the `Locale` constructor. To add the `caseFirst` value, first add the `-u` extension key to the string. Next, add the `-kf` extension key to indicate that you are adding a value for `caseFirst`. Finally, add the `caseFirst` value to the string.\n\n```js\nconst locale = new Intl.Locale("fr-Latn-FR-u-kf-upper");\nconsole.log(locale.caseFirst); // Prints "upper"\n```\n\n### Setting the caseFirst value via the configuration object argument\n\nThe {{jsxref("Intl/Locale/Locale", "Intl.Locale()")}} constructor has an optional configuration object argument, which can be used to pass extension types. Set the `caseFirst` property of the configuration object to your desired `caseFirst` value, and then pass it into the constructor.\n\n```js\nconst locale = new Intl.Locale("en-Latn-US", { caseFirst: "lower" });\nconsole.log(locale.caseFirst); // Prints "lower"\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Intl.Locale")}}\n- [Unicode case first collation spec](https://github.com/unicode-org/cldr/blob/main/common/bcp47/collation.xml#L49)\n'
            },
            "collation": {
                "index.md": '---\ntitle: Intl.Locale.prototype.collation\nslug: Web/JavaScript/Reference/Global_Objects/Intl/Locale/collation\npage-type: javascript-instance-accessor-property\nbrowser-compat: javascript.builtins.Intl.Locale.collation\n---\n\n{{JSRef}}\n\nThe **`collation`** accessor property of {{jsxref("Intl.Locale")}} instances returns the [collation type](https://www.unicode.org/reports/tr35/tr35-collation.html#CLDR_Collation) for this locale, which is used to order strings according to the locale\'s rules.\n\n## Description\n\nCollation is the process of ordering strings of characters. It is used whenever strings must be sorted and placed into a certain order, from search query results to ordering records in a database. While the idea of placing strings in order might seem trivial, the idea of order can vary from region to region and language to language. The `collation` property\'s value is set at construction time, either through the `co` key of the locale identifier or through the `collation` option of the {{jsxref("Intl/Locale/Locale", "Intl.Locale()")}} constructor. The latter takes priority if they are both present; and if neither is present, the property has value `undefined`.\n\nFor a list of supported collation types, see [`Intl.Locale.prototype.getCollations()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/getCollations#supported_collation_types).\n\nThe set accessor of `collation` is `undefined`. You cannot change this property directly.\n\n## Examples\n\nLike other locale subtags, the collation type can be added to the {{jsxref("Intl.Locale")}} object via the locale string, or a configuration object argument to the constructor.\n\n### Adding a collation type via the locale string\n\nIn the [Unicode locale string spec](https://www.unicode.org/reports/tr35/), collation types are locale key "extension subtags". These subtags add additional data about the locale, and are added to locale identifiers by using the `-u` extension. Thus, the collation type can be added to the initial locale identifier string that is passed into the {{jsxref("Intl/Locale/Locale", "Intl.Locale()")}} constructor. To add the collation type, first add the `-u` extension to the string. Next, add the `-co` extension to indicate that you are adding a collation type. Finally, add the collation type to the string.\n\n```js\nconst locale = new Intl.Locale("zh-Hant-u-co-zhuyin");\nconsole.log(locale.collation); // "zhuyin"\n```\n\n### Adding a collation type via the configuration object argument\n\nThe {{jsxref("Intl/Locale/Locale", "Intl.Locale()")}} constructor has an optional configuration object argument, which can contain any of several extension types, including collation types. Set the `collation` property of the configuration object to your desired collation type, and then pass it into the constructor.\n\n```js\nconst locale = new Intl.Locale("zh-Hant", { collation: "zhuyin" });\nconsole.log(locale.collation); // "zhuyin"\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Intl.Locale")}}\n- [`Intl.Locale.prototype.getCollations()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/getCollations)\n'
            },
            "getcalendars": {
                "index.md": '---\ntitle: Intl.Locale.prototype.getCalendars()\nslug: Web/JavaScript/Reference/Global_Objects/Intl/Locale/getCalendars\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Intl.Locale.getCalendars\n---\n\n{{JSRef}}\n\nThe **`getCalendars()`** method of {{jsxref("Intl.Locale")}} instances returns a list of one or more unique calendar identifiers for this locale.\n\n> **Note:** In some versions of some browsers, this method was implemented as an accessor property called `calendars`. However, because it returns a new array on each access, it is now implemented as a method to prevent the situation of `locale.calendars === locale.calendars` returning `false`. Check the [browser compatibility table](#browser_compatibility) for details.\n\n## Syntax\n\n```js-nolint\ngetCalendars()\n```\n\n### Parameters\n\nNone.\n\n### Return value\n\nAn array of strings representing all calendars commonly used for the `Locale`, sorted in descending preference. If the `Locale` already has a [`calendar`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/calendar), then the returned array contains that single value.\n\nBelow is a list of the supported calendar era types.\n\n### Supported calendar types\n\n- `buddhist`\n  - : Thai Buddhist calendar\n- `chinese`\n  - : Traditional Chinese calendar\n- `coptic`\n  - : Coptic calendar\n- `dangi`\n  - : Traditional Korean calendar\n- `ethioaa`\n  - : Ethiopic calendar, Amete Alem (epoch approx. 5493 B.C.E)\n- `ethiopic`\n  - : Ethiopic calendar, Amete Mihret (epoch approx, 8 C.E.)\n- `gregory`\n  - : Gregorian calendar\n- `hebrew`\n  - : Traditional Hebrew calendar\n- `indian`\n  - : Indian calendar\n- `islamic`\n  - : Islamic calendar\n- `islamic-umalqura`\n  - : Islamic calendar, Umm al-Qura\n- `islamic-tbla`\n  - : Islamic calendar, tabular (intercalary years [2,5,7,10,13,16,18,21,24,26,29] - astronomical epoch)\n- `islamic-civil`\n  - : Islamic calendar, tabular (intercalary years [2,5,7,10,13,16,18,21,24,26,29] - civil epoch)\n- `islamic-rgsa`\n  - : Islamic calendar, Saudi Arabia sighting\n- `iso8601`\n  - : ISO calendar (Gregorian calendar using the ISO 8601 calendar week rules)\n- `japanese`\n  - : Japanese Imperial calendar\n- `persian`\n  - : Persian calendar\n- `roc`\n  - : Civil (algorithmic) Arabic calendar\n- `islamicc`\n  - : Civil (algorithmic) Arabic calendar\n    > **Warning:** The `islamicc` calendar key has been deprecated. Please use `islamic-civil`.\n\n## Examples\n\n### Obtaining supported calendars\n\nIf the `Locale` object doesn\'t have a `calendar` already, `getCalendars()` lists all commonly-used calendars for the given `Locale`. For examples of explicitly setting a `calendar`, see [`calendar` examples](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/calendar#examples).\n\n```js\nconst arEG = new Intl.Locale("ar-EG");\nconsole.log(arEG.getCalendars()); // ["gregory", "coptic", "islamic", "islamic-civil", "islamic-tbla"]\n```\n\n```js\nconst jaJP = new Intl.Locale("ja-JP");\nconsole.log(jaJP.getCalendars()); // ["gregory", "japanese"]\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Intl.Locale")}}\n- [`Intl.Locale.prototype.calendar`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/calendar)\n- [Unicode Calendar Identifier](https://www.unicode.org/reports/tr35/#UnicodeCalendarIdentifier) in the Unicode locale data markup language spec\n'
            },
            "getcollations": {
                "index.md": '---\ntitle: Intl.Locale.prototype.getCollations()\nslug: Web/JavaScript/Reference/Global_Objects/Intl/Locale/getCollations\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Intl.Locale.getCollations\n---\n\n{{JSRef}}\n\nThe **`getCollations()`** method of {{jsxref("Intl.Locale")}} instances returns a list of one or more [collation types](https://www.unicode.org/reports/tr35/tr35-collation.html#CLDR_collation) for this locale.\n\n> **Note:** In some versions of some browsers, this method was implemented as an accessor property called `collations`. However, because it returns a new array on each access, it is now implemented as a method to prevent the situation of `locale.collations === locale.collations` returning `false`. Check the [browser compatibility table](#browser_compatibility) for details.\n\n## Syntax\n\n```js-nolint\ngetCollations()\n```\n\n### Parameters\n\nNone.\n\n### Return value\n\nAn array of strings representing all collation types commonly used for the `Locale`, sorted in alphabetical order, with the `standard` and `search` values always excluded. If the `Locale` already has a [`collation`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/collation), then the returned array contains that single value.\n\nBelow is a list of the supported collation types, adapted from the [Unicode collation specification](https://github.com/unicode-org/cldr/blob/2dd06669d833823e26872f249aa304bc9d9d2a90/common/bcp47/collation.xml).\n\n### Supported collation types\n\n- `big5han`\n  - : Pinyin ordering for Latin, big5 charset ordering for CJK characters (for Chinese)\n    > **Warning:** The `big5han` collation type is deprecated, not available in Firefox, Chrome or Edge.\n- `compat`\n  - : A previous version of the ordering, for compatibility (for Arabic)\n- `dict`\n  - : Dictionary style ordering (for Sinhala)\n- `direct`\n  - : Binary code point order\n    > **Warning:** The `direct` collation type has been deprecated. Do not use.\n- `ducet`\n  - : The default Unicode collation element table order\n    > **Warning:** The `ducet` collation type is not available to the Web. Use the `und` locale without a collation type specifier instead. `und` is the collation that is the closest to `ducet`.\n- `emoji`\n  - : Recommended ordering for emoji characters (for the `und` locale)\n- `eor`\n  - : European ordering rules (for the `und` locale)\n- `gb2312`\n  - : Pinyin ordering for Latin, gb2312han charset ordering for CJK characters (for Chinese)\n    > **Warning:** The `gb2312` collation type is deprecated, not available in Firefox, Chrome or Edge.\n- `phonebk`\n  - : Phonebook style ordering (for German)\n- `phonetic`\n  - : Phonetic ordering (sorting based on pronunciation; for Lingala)\n- `pinyin`\n  - : Pinyin ordering for Latin and for CJK characters (for Chinese)\n- `reformed`\n  - : Reformed ordering (formerly for Swedish)\n    > **Warning:** Do not use explicitly. This is the old name for the default ordering for Swedish [whose collation naming used to differ from other languages](https://unicode-org.atlassian.net/browse/CLDR-15603). Since this was the default, request `sv` instead of requesting `sv-u-co-reformed`.\n- `search`\n  - : Special collation type for string search\n    > **Warning:** Do not use as a collation type, since in [`Intl.Collator`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Collator), this collation is activated via the `"search"` value for the `usage` option. There is currently no API for substring search, so this is currently only good for filtering a list of strings by trying a full-string match of the key against each list item.\n- `searchjl`\n  - : Special collation type for Korean initial consonant search\n    > **Warning:** This collation is not for sorting, even though it is made available through [`Intl.Collator`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Collator) instantiated with usage `"sort"` as opposed to usage `"search"`.\n- `standard`\n  - : Default ordering for each language, except Chinese (and, previously, Swedish)\n    > **Warning:** Do not use explicitly. In general, it\'s unnecessary to specify this explicitly and specifying this for Swedish is problematic due to the different meaning for Swedish in the past.\n- `stroke`\n  - : Pinyin ordering for Latin, stroke order for CJK characters (for Chinese)\n- `trad`\n  - : Traditional style ordering (such as in Spanish)\n- `unihan`\n  - : Radical-stroke ordering for Han characters (for Chinese, Japanese, and Korean). Pinyin ordering for Latin in the case of Chinese.\n    > **Note:** The `unihan` collation type is not available in Chrome or Edge.\n- `zhuyin`\n  - : Pinyin ordering for Latin, zhuyin order for Bopomofo and CJK characters (for Chinese)\n\n## Examples\n\n### Obtaining supported collation types\n\nIf the `Locale` object doesn\'t have a `collation` already, `getCollations()` lists all commonly-used collation types for the given `Locale`. For examples of explicitly setting a `collation`, see [`collation` examples](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/collation#examples).\n\n```js\nconst locale = new Intl.Locale("zh");\nconsole.log(locale.getCollations()); // ["pinyin", "stroke", "zhuyin", "emoji", "eor"]\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Intl.Locale")}}\n- [`Intl.Locale.prototype.collation`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/collation)\n'
            },
            "gethourcycles": {
                "index.md": '---\ntitle: Intl.Locale.prototype.getHourCycles()\nslug: Web/JavaScript/Reference/Global_Objects/Intl/Locale/getHourCycles\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Intl.Locale.getHourCycles\n---\n\n{{JSRef}}\n\nThe **`getHourCycles()`** method of {{jsxref("Intl.Locale")}} instances returns a list of one or more unique hour cycle identifiers for this locale.\n\n> **Note:** In some versions of some browsers, this method was implemented as an accessor property called `hourCycles`. However, because it returns a new array on each access, it is now implemented as a method to prevent the situation of `locale.hourCycles === locale.hourCycles` returning `false`. Check the [browser compatibility table](#browser_compatibility) for details.\n\n## Syntax\n\n```js-nolint\ngetHourCycles()\n```\n\n### Parameters\n\nNone.\n\n### Return value\n\nAn array of strings representing all hour cycle types commonly used for the `Locale`, sorted in descending preference. If the `Locale` already has an [`hourCycle`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/hourCycle), then the returned array contains that single value.\n\nBelow is a list of supported hour cycle types.\n\n### Supported hour cycle types\n\n- `h12`\n  - : Hour system using 1\u201312; corresponds to \'h\' in patterns. The 12 hour clock, with midnight starting at 12:00 am. As used, for example, in the United States.\n- `h23`\n  - : Hour system using 0\u201323; corresponds to \'H\' in patterns. The 24 hour clock, with midnight starting at 0:00.\n- `h11`\n  - : Hour system using 0\u201311; corresponds to \'K\' in patterns. The 12 hour clock, with midnight starting at 0:00 am. Mostly used in Japan.\n- `h24`\n  - : Hour system using 1\u201324; corresponds to \'k\' in pattern. The 24 hour clock, with midnight starting at 24:00. Not used anywhere.\n\n## Examples\n\n### Obtaining supported hour cycles\n\nIf the `Locale` object doesn\'t have a `hourCycle` already, `getHourCycles()` lists all commonly-used collation types for the given `Locale`. For examples of explicitly setting a `hourCycle`, see [`hourCycle` examples](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/hourCycle#examples).\n\n```js\nconst arEG = new Intl.Locale("ar-EG");\nconsole.log(arEG.getHourCycles()); // ["h12"]\n```\n\n```js\nconst jaJP = new Intl.Locale("ja-JP");\nconsole.log(jaJP.getHourCycles()); // ["h23"]\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Intl.Locale")}}\n- [`Intl.Locale.prototype.hourCycle`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/hourCycle)\n- [Unicode Hour Cycle Identifier](https://www.unicode.org/reports/tr35/#UnicodeHourCycleIdentifier) in the Unicode locale data markup language spec\n'
            },
            "getnumberingsystems": {
                "index.md": '---\ntitle: Intl.Locale.prototype.getNumberingSystems()\nslug: Web/JavaScript/Reference/Global_Objects/Intl/Locale/getNumberingSystems\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Intl.Locale.getNumberingSystems\n---\n\n{{JSRef}}\n\nThe **`getNumberingSystems()`** method of {{jsxref("Intl.Locale")}} instances returns a list of one or more unique [numbering system](https://en.wikipedia.org/wiki/Numeral_system) identifiers for this locale.\n\n> **Note:** In some versions of some browsers, this method was implemented as an accessor property called `numberingSystems`. However, because it returns a new array on each access, it is now implemented as a method to prevent the situation of `locale.numberingSystems === locale.numberingSystems` returning `false`. Check the [browser compatibility table](#browser_compatibility) for details.\n\n## Syntax\n\n```js-nolint\ngetNumberingSystems()\n```\n\n### Parameters\n\nNone.\n\n### Return value\n\nAn array of strings representing all numbering systems commonly used for the `Locale`, sorted in descending preference. If the `Locale` already has a [`numberingSystem`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/numberingSystem), then the returned array contains that single value.\n\nA table of the standard Unicode numeral systems can be seen below.\n\n### Supported numbering system types\n\n| Value    | Description                                                                |\n| -------- | -------------------------------------------------------------------------- |\n| adlm     | Adlam digits                                                               |\n| ahom     | Ahom digits                                                                |\n| arab     | Arabic-Indic digits                                                        |\n| arabext  | Extended Arabic-Indic digits                                               |\n| armn     | Armenian upper case numerals \u2014 algorithmic                                 |\n| armnlow  | Armenian lower case numerals \u2014 algorithmic                                 |\n| bali     | Balinese digits                                                            |\n| beng     | Bengali digits                                                             |\n| bhks     | Bhaiksuki digits                                                           |\n| brah     | Brahmi digits                                                              |\n| cakm     | Chakma digits                                                              |\n| cham     | Cham digits                                                                |\n| cyrl     | Cyrillic numerals \u2014 algorithmic                                            |\n| deva     | Devanagari digits                                                          |\n| ethi     | Ethiopic numerals \u2014 algorithmic                                            |\n| finance  | Financial numerals \u2014 may be algorithmic                                    |\n| fullwide | Full width digits                                                          |\n| geor     | Georgian numerals \u2014 algorithmic                                            |\n| gong     | Gunjala Gondi digits                                                       |\n| gonm     | Masaram Gondi digits                                                       |\n| grek     | Greek upper case numerals \u2014 algorithmic                                    |\n| greklow  | Greek lower case numerals \u2014 algorithmic                                    |\n| gujr     | Gujarati digits                                                            |\n| guru     | Gurmukhi digits                                                            |\n| hanidays | Han-character day-of-month numbering for lunar/other traditional calendars |\n| hanidec  | Positional decimal system using Chinese number ideographs as digits        |\n| hans     | Simplified Chinese numerals \u2014 algorithmic                                  |\n| hansfin  | Simplified Chinese financial numerals \u2014 algorithmic                        |\n| hant     | Traditional Chinese numerals \u2014 algorithmic                                 |\n| hantfin  | Traditional Chinese financial numerals \u2014 algorithmic                       |\n| hebr     | Hebrew numerals \u2014 algorithmic                                              |\n| hmng     | Pahawh Hmong digits                                                        |\n| hmnp     | Nyiakeng Puachue Hmong digits                                              |\n| java     | Javanese digits                                                            |\n| jpan     | Japanese numerals \u2014 algorithmic                                            |\n| jpanfin  | Japanese financial numerals \u2014 algorithmic                                  |\n| jpanyear | Japanese first-year Gannen numbering for Japanese calendar                 |\n| kali     | Kayah Li digits                                                            |\n| khmr     | Khmer digits                                                               |\n| knda     | Kannada digits                                                             |\n| lana     | Tai Tham Hora (secular) digits                                             |\n| lanatham | Tai Tham (ecclesiastical) digits                                           |\n| laoo     | Lao digits                                                                 |\n| latn     | Latin digits                                                               |\n| lepc     | Lepcha digits                                                              |\n| limb     | Limbu digits                                                               |\n| mathbold | Mathematical bold digits                                                   |\n| mathdbl  | Mathematical double-struck digits                                          |\n| mathmono | Mathematical monospace digits                                              |\n| mathsanb | Mathematical sans-serif bold digits                                        |\n| mathsans | Mathematical sans-serif digits                                             |\n| mlym     | Malayalam digits                                                           |\n| modi     | Modi digits                                                                |\n| mong     | Mongolian digits                                                           |\n| mroo     | Mro digits                                                                 |\n| mtei     | Meetei Mayek digits                                                        |\n| mymr     | Myanmar digits                                                             |\n| mymrshan | Myanmar Shan digits                                                        |\n| mymrtlng | Myanmar Tai Laing digits                                                   |\n| native   | Native digits                                                              |\n| newa     | Newa digits                                                                |\n| nkoo     | N\'Ko digits                                                                |\n| olck     | Ol Chiki digits                                                            |\n| orya     | Oriya digits                                                               |\n| osma     | Osmanya digits                                                             |\n| rohg     | Hanifi Rohingya digits                                                     |\n| roman    | Roman upper case numerals \u2014 algorithmic                                    |\n| romanlow | Roman lowercase numerals \u2014 algorithmic                                     |\n| saur     | Saurashtra digits                                                          |\n| shrd     | Sharada digits                                                             |\n| sind     | Khudawadi digits                                                           |\n| sinh     | Sinhala Lith digits                                                        |\n| sora     | Sora_Sompeng digits                                                        |\n| sund     | Sundanese digits                                                           |\n| takr     | Takri digits                                                               |\n| talu     | New Tai Lue digits                                                         |\n| taml     | Tamil numerals \u2014 algorithmic                                               |\n| tamldec  | Modern Tamil decimal digits                                                |\n| telu     | Telugu digits                                                              |\n| thai     | Thai digits                                                                |\n| tirh     | Tirhuta digits                                                             |\n| tibt     | Tibetan digits                                                             |\n| traditio | Traditional numerals \u2014 may be algorithmic                                  |\n| vaii     | Vai digits                                                                 |\n| wara     | Warang Citi digits                                                         |\n| wcho     | Wancho digits                                                              |\n\n## Examples\n\n### Obtaining supported numbering systems\n\nIf the `Locale` object doesn\'t have a `numberingSystem` already, `getNumberingSystems()` lists all commonly-used numbering systems for the given `Locale`. For examples of explicitly setting a `numberingSystem`, see [`numberingSystem` examples](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/numberingSystem#examples).\n\n```js\nconst arEG = new Intl.Locale("ar-EG");\nconsole.log(arEG.getNumberingSystems()); // ["arab"]\n```\n\n```js\nconst ja = new Intl.Locale("ja");\nconsole.log(ja.getNumberingSystems()); // ["latn"]\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Intl.Locale")}}\n- [`Intl.Locale.prototype.numberingSystem`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/numberingSystem)\n- [Details on the standard Unicode numeral systems](https://github.com/unicode-org/cldr/blob/main/common/supplemental/numberingSystems.xml)\n'
            },
            "gettextinfo": {
                "index.md": '---\ntitle: Intl.Locale.prototype.getTextInfo()\nslug: Web/JavaScript/Reference/Global_Objects/Intl/Locale/getTextInfo\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Intl.Locale.getTextInfo\n---\n\n{{JSRef}}\n\nThe **`getTextInfo()`** method of {{jsxref("Intl.Locale")}} instances returns the ordering of characters indicated by either `ltr` (left-to-right) or by `rtl` (right-to-left) for this locale.\n\n> **Note:** In some versions of some browsers, this method was implemented as an accessor property called `textInfo`. However, because it returns a new object on each access, it is now implemented as a method to prevent the situation of `locale.textInfo === locale.textInfo` returning `false`. Check the [browser compatibility table](#browser_compatibility) for details.\n\n## Syntax\n\n```js-nolint\ngetTextInfo()\n```\n\n### Parameters\n\nNone.\n\n### Return value\n\nAn object representing text typesetting information associated with the Locale data specified in [UTS 35\'s Layouts Elements](https://www.unicode.org/reports/tr35/tr35-general.html#Layout_Elements). It has the following properties:\n\n- `direction`\n  - : A string indicating the direction of text for the locale. Can be either `"ltr"` (left-to-right) or `"rtl"` (right-to-left).\n\n## Examples\n\n### Obtaining text info\n\nReturn the supported text directions for a given `Locale`.\n\n```js\nconst ar = new Intl.Locale("ar");\nconsole.log(ar.getTextInfo()); // { direction: "rtl" }\nconsole.log(ar.getTextInfo().direction); // "rtl"\n```\n\n```js\nconst es = new Intl.Locale("es");\nconsole.log(es.getTextInfo()); // { direction: "ltr" }\nconsole.log(es.getTextInfo().direction); // "ltr"\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Intl.Locale")}}\n'
            },
            "gettimezones": {
                "index.md": '---\ntitle: Intl.Locale.prototype.getTimeZones()\nslug: Web/JavaScript/Reference/Global_Objects/Intl/Locale/getTimeZones\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Intl.Locale.getTimeZones\n---\n\n{{JSRef}}\n\nThe **`getTimeZones()`** method of {{jsxref("Intl.Locale")}} instances returns a list of supported time zones for this locale.\n\n> **Note:** In some versions of some browsers, this method was implemented as an accessor property called `timeZones`. However, because it returns a new array on each access, it is now implemented as a method to prevent the situation of `locale.timeZones === locale.timeZones` returning `false`. Check the [browser compatibility table](#browser_compatibility) for details.\n\n## Syntax\n\n```js-nolint\ngetTimeZones()\n```\n\n### Parameters\n\nNone.\n\n### Return value\n\nAn array of strings representing supported time zones for the associated `Locale`, where each value is an [IANA time zone canonical name](https://en.wikipedia.org/wiki/Daylight_saving_time#IANA_time_zone_database), sorted in alphabetical order. If the locale identifier does not contain a region subtag, the returned value is `undefined`.\n\n## Examples\n\n### Obtaining supported time zones\n\nList supported time zones for a given `Locale`.\n\n```js\nconst arEG = new Intl.Locale("ar-EG");\nconsole.log(arEG.getTimeZones()); // ["Africa/Cairo"]\n```\n\n```js\nconst jaJP = new Intl.Locale("ja-JP");\nconsole.log(jaJP.getTimeZones()); // ["Asia/Tokyo"]\n```\n\n```js\nconst ar = new Intl.Locale("ar");\nconsole.log(ar.getTimeZones()); // undefined\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Intl.Locale")}}\n- [IANA time zone database](https://en.wikipedia.org/wiki/Daylight_saving_time#IANA_time_zone_database) on Wikipedia\n'
            },
            "getweekinfo": {
                "index.md": '---\ntitle: Intl.Locale.prototype.getWeekInfo()\nslug: Web/JavaScript/Reference/Global_Objects/Intl/Locale/getWeekInfo\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Intl.Locale.getWeekInfo\n---\n\n{{JSRef}}\n\nThe **`getWeekInfo()`** method of {{jsxref("Intl.Locale")}} instances returns a `weekInfo` object with the properties `firstDay`, `weekend` and `minimalDays` for this locale.\n\n> **Note:** In some versions of some browsers, this method was implemented as an accessor property called `weekInfo`. However, because it returns a new object on each access, it is now implemented as a method to prevent the situation of `locale.weekInfo === locale.weekInfo` returning `false`. Check the [browser compatibility table](#browser_compatibility) for details.\n\n## Syntax\n\n```js-nolint\ngetWeekInfo()\n```\n\n### Parameters\n\nNone.\n\n### Return value\n\nAn object representing week information associated with the Locale data specified in [UTS 35\'s Week Elements](https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Patterns_Week_Elements). It has the following properties:\n\n- `firstDay`\n  - : An integer indicating the first day of the week for the locale. Can be either `1` (Monday) or `7` (Sunday).\n- `weekend`\n  - : An array of integers indicating the weekend days for the locale, where `1` is Monday and `7` is Sunday.\n- `minimalDays`\n  - : An integer between 1 and 7 indicating the minimal days required in the first week of a month or year, for calendar purposes.\n\n## Examples\n\n### Obtaining the Week Information\n\nReturn the week information for a given `Locale`.\n\n```js\nconst he = new Intl.Locale("he");\nconsole.log(he.getWeekInfo()); // { firstDay: 7, weekend: [5, 6], minimalDays: 1 }\n\nconst af = new Intl.Locale("af");\nconsole.log(af.getWeekInfo()); // { firstDay: 7, weekend: [6, 7], minimalDays: 1 }\n\nconst enGB = new Intl.Locale("en-GB");\nconsole.log(enGB.getWeekInfo()); // { firstDay: 1, weekend: [6, 7], minimalDays: 4 }\n\nconst msBN = new Intl.Locale("ms-BN");\nconsole.log(msBN.getWeekInfo()); // { firstDay: 7, weekend: [5, 7], minimalDays: 1 }\n// Brunei weekend is Friday and Sunday but not Saturday\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Intl.Locale")}}\n'
            },
            "hourcycle": {
                "index.md": '---\ntitle: Intl.Locale.prototype.hourCycle\nslug: Web/JavaScript/Reference/Global_Objects/Intl/Locale/hourCycle\npage-type: javascript-instance-accessor-property\nbrowser-compat: javascript.builtins.Intl.Locale.hourCycle\n---\n\n{{JSRef}}\n\nThe **`hourCycle`** accessor property of {{jsxref("Intl.Locale")}} instances returns the hour cycle type for this locale.\n\n## Description\n\nThere are 2 main types of time keeping conventions (clocks) used around the world: the 12 hour clock and the 24 hour clock. The `hourCycle` property\'s value is set at construction time, either through the `hc` key of the locale identifier or through the `hourCycle` option of the {{jsxref("Intl/Locale/Locale", "Intl.Locale()")}} constructor. The latter takes priority if they are both present; and if neither is present, the property has value `undefined`.\n\nFor a list of supported hour cycle types, see [`Intl.Locale.prototype.getHourCycles()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/getHourCycles#supported_hour_cycle_types).\n\nThe set accessor of `hourCycle` is `undefined`. You cannot change this property directly.\n\n## Examples\n\nLike other locale subtags, the hour cycle type can be added to the {{jsxref("Intl.Locale")}} object via the locale string, or a configuration object argument to the constructor.\n\n### Adding an hour cycle via the locale string\n\nIn the [Unicode locale string spec](https://www.unicode.org/reports/tr35/), hour cycle types are locale key "extension subtags". These subtags add additional data about the locale, and are added to locale identifiers by using the `-u` extension. Thus, the hour cycle type can be added to the initial locale identifier string that is passed into the {{jsxref("Intl/Locale/Locale", "Intl.Locale()")}} constructor. To add the hour cycle type, first add the `-u` extension key to the string. Next, add the `-hc` extension to indicate that you are adding an hour cycle. Finally, add the hour cycle type to the string.\n\n```js\nconst locale = new Intl.Locale("fr-FR-u-hc-h23");\nconsole.log(locale.hourCycle); // "h23"\n```\n\n### Adding an hour cycle via the configuration object argument\n\nThe {{jsxref("Intl/Locale/Locale", "Intl.Locale()")}} constructor has an optional configuration object argument, which can contain any of several extension types, including hour cycle types. Set the `hourCycle` property of the configuration object to your desired hour cycle type, and then pass it into the constructor.\n\n```js\nconst locale = new Intl.Locale("en-US", { hourCycle: "h12" });\nconsole.log(locale.hourCycle); // "h12"\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Intl.Locale")}}\n- [`Intl.Locale.prototype.getHourCycles()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/getHourCycles)\n- [Unicode Hour Cycle Identifier](https://www.unicode.org/reports/tr35/#UnicodeHourCycleIdentifier) in the Unicode locale data markup language spec\n'
            },
            "index.md": '---\ntitle: Intl.Locale\nslug: Web/JavaScript/Reference/Global_Objects/Intl/Locale\npage-type: javascript-class\nbrowser-compat: javascript.builtins.Intl.Locale\n---\n\n{{JSRef}}\n\nThe **`Intl.Locale`** object is a standard built-in property of the Intl object that represents a Unicode locale identifier.\n\n{{EmbedInteractiveExample("pages/js/intl-locale.html")}}\n\n## Description\n\nThe **`Intl.Locale`** object was created to allow for easier manipulation of Unicode locales. Unicode represents locales with a string, called a _locale identifier_. The locale identifier consists of a _language identifier_ and _extension tags_. Language identifiers are the core of the locale, consisting of _language_, _script_, and _region subtags_. Additional information about the locale is stored in the optional _extension tags_. Extension tags hold information about locale aspects such as calendar type, clock type, and numbering system type.\n\nTraditionally, the Intl API used strings to represent locales, just as Unicode does. This is a simple and lightweight solution that works well. Adding a Locale class, however, adds ease of parsing and manipulating the language, script, and region, as well as extension tags. The following properties of `Intl.Locale` correspond to Unicode locale identifier subtags:\n\n| Property                                                     | Corresponding subtag         |\n| ------------------------------------------------------------ | ---------------------------- |\n| {{jsxref("Intl/Locale/language", "language")}}               | `language` (first part)      |\n| {{jsxref("Intl/Locale/script", "script")}}                   | `script` (second part)       |\n| {{jsxref("Intl/Locale/region", "region")}}                   | `region` (second/third part) |\n| {{jsxref("Intl/Locale/calendar", "calendar")}}               | `ca` (extension)             |\n| {{jsxref("Intl/Locale/caseFirst", "caseFirst")}}             | `kf` (extension)             |\n| {{jsxref("Intl/Locale/collation", "collation")}}             | `co` (extension)             |\n| {{jsxref("Intl/Locale/hourCycle", "hourCycle")}}             | `hc` (extension)             |\n| {{jsxref("Intl/Locale/numberingSystem", "numberingSystem")}} | `nu` (extension)             |\n| {{jsxref("Intl/Locale/numeric", "numeric")}}                 | `kn` (extension)             |\n\nThe information above is exactly provided as-is when the `Locale` object is constructed, without consulting any external database. The `Intl.Locale` object additionally provides some methods that return information about the locale\'s real-world information, such as available calendars, collations, and numbering systems.\n\n## Constructor\n\n- {{jsxref("Intl/Locale/Locale", "Intl.Locale()")}}\n  - : Creates a new `Locale` object.\n\n## Instance properties\n\nThese properties are defined on `Intl.Locale.prototype` and shared by all `Intl.Locale` instances.\n\n- {{jsxref("Intl/Locale/baseName", "Intl.Locale.prototype.baseName")}}\n  - : Returns basic, core information about the `Locale` in the form of a substring of the complete data string.\n- {{jsxref("Intl/Locale/calendar", "Intl.Locale.prototype.calendar")}}\n  - : Returns the part of the `Locale` that indicates the Locale\'s calendar era.\n- {{jsxref("Intl/Locale/caseFirst", "Intl.Locale.prototype.caseFirst")}}\n  - : Returns whether case is taken into account for the locale\'s collation rules.\n- {{jsxref("Intl/Locale/collation", "Intl.Locale.prototype.collation")}}\n  - : Returns the collation type for the `Locale`, which is used to order strings according to the locale\'s rules.\n- {{jsxref("Object/constructor", "Intl.Locale.prototype.constructor")}}\n  - : The constructor function that created the instance object. For `Intl.Locale` instances, the initial value is the {{jsxref("Intl/Locale/Locale", "Intl.Locale")}} constructor.\n- {{jsxref("Intl/Locale/hourCycle", "Intl.Locale.prototype.hourCycle")}}\n  - : Returns the time keeping format convention used by the locale.\n- {{jsxref("Intl/Locale/language", "Intl.Locale.prototype.language")}}\n  - : Returns the language associated with the locale.\n- {{jsxref("Intl/Locale/numberingSystem", "Intl.Locale.prototype.numberingSystem")}}\n  - : Returns the numeral system used by the locale.\n- {{jsxref("Intl/Locale/numeric", "Intl.Locale.prototype.numeric")}}\n  - : Returns whether the locale has special collation handling for numeric characters.\n- {{jsxref("Intl/Locale/region", "Intl.Locale.prototype.region")}}\n  - : Returns the region of the world (usually a country) associated with the locale.\n- {{jsxref("Intl/Locale/script", "Intl.Locale.prototype.script")}}\n  - : Returns the script used for writing the particular language used in the locale.\n- `Intl.Locale.prototype[@@toStringTag]`\n  - : The initial value of the [`@@toStringTag`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol/toStringTag) property is the string `"Intl.Locale"`. This property is used in {{jsxref("Object.prototype.toString()")}}.\n\n## Instance methods\n\n- {{jsxref("Intl/Locale/getCalendars", "Intl.Locale.prototype.getCalendars()")}}\n  - : Returns an {{jsxref("Array")}} of available calendar identifiers, according to the locale\'s rules.\n- {{jsxref("Intl/Locale/getCollations", "Intl.Locale.prototype.getCollations()")}}\n  - : Returns an {{jsxref("Array")}} of the collation types for the `Locale`.\n- {{jsxref("Intl/Locale/getHourCycles", "Intl.Locale.prototype.getHourCycles()")}}\n  - : Returns an {{jsxref("Array")}} of hour cycle identifiers, indicating either the 12-hour clock ("h12"), the Japanese 12-hour clock ("h11"), the 24-hour clock ("h23"), or the unused format "h24".\n- {{jsxref("Intl/Locale/getNumberingSystems", "Intl.Locale.prototype.getNumberingSystems()")}}\n  - : Returns an {{jsxref("Array")}} of numbering system identifiers available according to the locale\'s rules.\n- {{jsxref("Intl/Locale/getTextInfo", "Intl.Locale.prototype.getTextInfo()")}}\n  - : Returns the part indicating the ordering of characters `ltr` (left-to-right) or `rtl` (right-to-left).\n- {{jsxref("Intl/Locale/getTimeZones", "Intl.Locale.prototype.getTimeZones()")}}\n  - : Returns an {{jsxref("Array")}} of time zone identifiers, associated with the `Locale`.\n- {{jsxref("Intl/Locale/getWeekInfo", "Intl.Locale.prototype.getWeekInfo()")}}\n  - : Returns [UTS 35\'s Week Elements](https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Patterns_Week_Elements) according to the locale rules.\n- {{jsxref("Intl/Locale/maximize", "Intl.Locale.prototype.maximize()")}}\n  - : Gets the most likely values for the language, script, and region of the locale based on existing values.\n- {{jsxref("Intl/Locale/minimize", "Intl.Locale.prototype.minimize()")}}\n  - : Attempts to remove information about the locale that would be added by calling {{jsxref("Intl/Locale/maximize", "maximize()")}}.\n- {{jsxref("Intl/Locale/toString", "Intl.Locale.prototype.toString()")}}\n  - : Returns the Locale\'s full locale identifier string.\n\n## Examples\n\n### Basic usage\n\nAt its very simplest, the {{jsxref("Intl/Locale/Locale", "Intl.Locale()")}} constructor takes a locale identifier string as its argument:\n\n```js\nconst us = new Intl.Locale("en-US");\n```\n\n### Using the Locale constructor with an options object\n\nThe constructor also takes an optional configuration object argument, which can contain any of several extension types. For example, set the {{jsxref("Intl/Locale/hourCycle", "hourCycle")}} property of the configuration object to your desired hour cycle type, and then pass it into the constructor:\n\n```js\nconst us12hour = new Intl.Locale("en-US", { hourCycle: "h12" });\nconsole.log(us12hour.hourCycle); // Prints "h12"\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Intl.Locale` in FormatJS](https://formatjs.io/docs/polyfills/intl-locale/)\n- {{jsxref("Intl")}}\n- [Canonical Unicode Locale Identifiers](https://www.unicode.org/reports/tr35/#Canonical_Unicode_Locale_Identifiers) in the Unicode locale data markup language spec\n',
            "language": {
                "index.md": '---\ntitle: Intl.Locale.prototype.language\nslug: Web/JavaScript/Reference/Global_Objects/Intl/Locale/language\npage-type: javascript-instance-accessor-property\nbrowser-compat: javascript.builtins.Intl.Locale.language\n---\n\n{{JSRef}}\n\nThe **`language`** accessor property of {{jsxref("Intl.Locale")}} instances returns the language associated with this locale.\n\n## Description\n\nLanguage is one of the core features of a locale. The Unicode specification treats the language identifier of a locale as the language and the region together (to make a distinction between dialects and variations, e.g. British English vs. American English). The `language` property of a {{jsxref("Intl.Locale")}} returns strictly the locale\'s language subtag.\n\n## Examples\n\n### Setting the language in the locale identifier string argument\n\nIn order to be a valid Unicode locale identifier, a string must start with the language subtag. The main argument to the {{jsxref("Intl/Locale/Locale", "Intl.Locale()")}} constructor must be a valid Unicode locale identifier, so whenever the constructor is used, it must be passed an identifier with a language subtag.\n\n```js\nconst locale = new Intl.Locale("en-Latn-US");\nconsole.log(locale.language); // Prints "en"\n```\n\n### Overriding language via the configuration object\n\nWhile the language subtag must be specified, the {{jsxref("Intl/Locale/Locale", "Intl.Locale()")}} constructor takes a configuration object, which can override the language subtag.\n\n```js\nconst locale = new Intl.Locale("en-Latn-US", { language: "es" });\nconsole.log(locale.language); // Prints "es"\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Intl.Locale")}}\n- [Unicode language subtag](https://www.unicode.org/reports/tr35/#unicode_language_subtag_validity) in the Unicode locale data markup language spec\n'
            },
            "locale": {
                "index.md": '---\ntitle: Intl.Locale() constructor\nslug: Web/JavaScript/Reference/Global_Objects/Intl/Locale/Locale\npage-type: javascript-constructor\nbrowser-compat: javascript.builtins.Intl.Locale.Locale\n---\n\n{{JSRef}}\n\nThe **`Intl.Locale()`** constructor creates {{jsxref("Intl.Locale")}} objects.\n\n{{EmbedInteractiveExample("pages/js/intl-locale.html")}}\n\n## Syntax\n\n```js-nolint\nnew Intl.Locale(tag)\nnew Intl.Locale(tag, options)\n```\n\n> **Note:** `Intl.Locale()` can only be constructed with [`new`](/en-US/docs/Web/JavaScript/Reference/Operators/new). Attempting to call it without `new` throws a {{jsxref("TypeError")}}.\n\n### Parameters\n\n- `tag`\n  - : The Unicode locale identifier string. For the syntax of locale identifier strings, see the [Intl main page](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl#locales_argument). Note that the `Intl.Locale` constructor, unlike most other `Intl` constructors, does not accept an array of locales or `undefined`.\n- `options`\n  - : An object that contains configuration for the Locale. Option values here take priority over extension keys in the locale identifier. Possible properties are:\n    - `language`\n      - : The language. Any syntactically valid string following the [`unicode_language_subtag`](https://unicode.org/reports/tr35/#unicode_language_subtag) grammar (2\u20133 or 5\u20138 letters) is accepted, but the implementation only recognizes certain kinds.\n    - `script`\n      - : The script. Any syntactically valid string following the [`unicode_script_subtag`](https://unicode.org/reports/tr35/#unicode_script_subtag) grammar (4 letters) is accepted, but the implementation only recognizes certain kinds.\n    - `region`\n      - : The region. Any syntactically valid string following the [`unicode_region_subtag`](https://unicode.org/reports/tr35/#unicode_region_subtag) grammar (either 2 letters or 3 digits) is accepted, but the implementation only recognizes certain kinds.\n    - `calendar`\n      - : The calendar. Any syntactically valid string following the [`type`](https://unicode.org/reports/tr35/#Unicode_locale_identifier) grammar (one or more segments of 3\u20138 alphanumerals, joined by hyphens) is accepted, but the implementation only recognizes certain kinds, which are listed in [`Intl.Locale.prototype.getCalendars`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/getCalendars#supported_calendar_types).\n    - `collation`\n      - : The collation. Any syntactically valid string following the `type` grammar is accepted, but the implementation only recognizes certain kinds, which are listed in [`Intl.Locale.prototype.getCollations`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/getCollations#supported_collation_types).\n    - `numberingSystem`\n      - : The numbering system. Any syntactically valid string following the `type` grammar is accepted, but the implementation only recognizes certain kinds, which are listed in [`Intl.Locale.prototype.getNumberingSystems`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/getNumberingSystems#supported_numbering_systems).\n    - `caseFirst`\n      - : The case-first sort option. Possible values are `"upper"`, `"lower"`, or `"false"`.\n    - `hourCycle`\n      - : The hour cycle. Possible values are `"h23"`, `"h12"`, `"h11"`, or the practically unused `"h24"`, which are explained in [`Intl.Locale.prototype.getHourCycles`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/getHourCycles#supported_hour_cycle_types)\n    - `numeric`\n      - : The numeric sort option. A boolean.\n\n## Examples\n\n### Basic usage\n\nAt its very simplest, the {{jsxref("Intl/Locale/Locale", "Intl.Locale()")}} constructor takes\na locale identifier string as its argument:\n\n```js\nconst us = new Intl.Locale("en-US");\n```\n\n### Using the Locale constructor with an options object\n\nThe constructor also takes an optional configuration object argument, which can contain\nany of several extension types. For example, set the\n[`hourCycle`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/hourCycle)\nproperty of the configuration object to your desired hour cycle type, and then pass it\ninto the constructor:\n\n```js\nconst locale = new Intl.Locale("en-US", { hourCycle: "h12" });\nconsole.log(locale.hourCycle); // "h12"\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Intl.Locale` in FormatJS](https://formatjs.io/docs/polyfills/intl-locale/)\n- {{jsxref("Intl.Collator")}}\n- [Canonical Unicode Locale Identifiers](https://www.unicode.org/reports/tr35/#Canonical_Unicode_Locale_Identifiers) in the Unicode locale data markup language spec\n'
            },
            "maximize": {
                "index.md": '---\ntitle: Intl.Locale.prototype.maximize()\nslug: Web/JavaScript/Reference/Global_Objects/Intl/Locale/maximize\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Intl.Locale.maximize\n---\n\n{{JSRef}}\n\nThe **`maximize()`** method of {{jsxref("Intl.Locale")}} instances gets the\nmost likely values for the language, script, and region of this locale based on\nexisting values.\n\n{{EmbedInteractiveExample("pages/js/intl-locale-prototype-maximize.html")}}\n\n## Syntax\n\n```js-nolint\nmaximize()\n```\n\n### Parameters\n\nNone.\n\n### Return value\n\nA {{jsxref("Intl.Locale")}} instance whose `baseName` property returns\nthe result of the [Add Likely Subtags](https://www.unicode.org/reports/tr35/#Likely_Subtags) algorithm executed against _{{jsxref("Intl/Locale/baseName", "locale.baseName")}}_.\n\n## Description\n\nSometimes, it is convenient to be able to identify the most likely locale language\nidentifier subtags based on an incomplete language ID. The Add Likely Subtags\nalgorithm gives us this functionality. For instance, given the language ID "en", the\nalgorithm would return "en-Latn-US", since English can only be written in the Latin\nscript, and is most likely to be used in the United States, as it is the largest\nEnglish-speaking country in the world. This functionality is provided to JavaScript\nprogrammers via the `maximize()` method. `maximize()` only\naffects the main subtags that comprise the [language identifier](https://www.unicode.org/reports/tr35/#Language_Locale_Field_Definitions): language, script, and region subtags.\nOther subtags after the "-u" in the locale identifier are called extension subtags and\nare not affected by the `maximize()` method. Examples of these subtags\ninclude {{jsxref("Intl/Locale/hourCycle", "hourCycle")}},\n{{jsxref("Intl/Locale/calendar", "calendar")}}, and {{jsxref("Intl/Locale/numeric", "numeric")}}.\n\n## Examples\n\n### Using maximize\n\n```js\nconst myLocale = new Intl.Locale("fr", {\n  hourCycle: "h12",\n  calendar: "gregory",\n});\nconsole.log(myLocale.baseName); // Prints "fr"\nconsole.log(myLocale.toString()); // Prints "fr-u-ca-gregory-hc-h12"\nconst myLocMaximized = myLocale.maximize();\n\n// Prints "fr-Latn-FR". The "Latn" and "FR" tags are added,\n// since French is only written in the Latin script and is most likely to be spoken in France.\nconsole.log(myLocMaximized.baseName);\n\n// Prints "fr-Latn-FR-u-ca-gregory-hc-h12".\n// Note that the extension tags (after "-u") remain unchanged.\nconsole.log(myLocMaximized.toString());\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Intl.Locale")}}\n- {{jsxref("Intl/Locale/baseName", "baseName")}}\n- [Likely Subtags](https://www.unicode.org/reports/tr35/#Likely_Subtags) in the Unicode locale data markup language spec\n'
            },
            "minimize": {
                "index.md": '---\ntitle: Intl.Locale.prototype.minimize()\nslug: Web/JavaScript/Reference/Global_Objects/Intl/Locale/minimize\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Intl.Locale.minimize\n---\n\n{{JSRef}}\n\nThe **`minimize()`** method of {{jsxref("Intl.Locale")}} instances attempts to\nremove information about this locale that would be added by calling\n{{jsxref("Intl/Locale/maximize", "maximize()")}}.\n\n{{EmbedInteractiveExample("pages/js/intl-locale-prototype-minimize.html")}}\n\n## Syntax\n\n```js-nolint\nminimize()\n```\n\n### Parameters\n\nNone.\n\n### Return value\n\nA {{jsxref("Intl.Locale")}} instance whose `baseName` property returns\nthe result of the [Remove Likely Subtags](https://www.unicode.org/reports/tr35/#Likely_Subtags) algorithm\nexecuted against _{{jsxref("Intl/Locale/baseName", "locale.baseName")}}_.\n\n## Description\n\nThis method carries out the reverse of {{jsxref("Intl/Locale/maximize", "maximize()")}},\nremoving any language, script, or region subtags from the locale language identifier\n(essentially the contents of `baseName`). This is useful when there are\nsuperfluous subtags in the language identifier; for instance, "en-Latn" can be\nsimplified to "en", since "Latn" is the only script used to write English.\n`minimize()` only affects the main subtags that comprise\nthe [language identifier](https://www.unicode.org/reports/tr35/#Language_Locale_Field_Definitions):\nlanguage, script, and region subtags. Other subtags after the "-u"\nin the locale identifier are called extension subtags and are not affected by the\n`minimize()` method. Examples of these subtags include\n{{jsxref("Intl/Locale/hourCycle", "hourCycle")}}, {{jsxref("Intl/Locale/calendar", "calendar")}}, and {{jsxref("Intl/Locale/numeric", "numeric")}}.\n\n## Examples\n\n### Using minimize\n\n```js\nconst myLocale = new Intl.Locale("fr-Latn-FR", {\n  hourCycle: "h12",\n  calendar: "gregory",\n});\nconsole.log(myLocale.baseName); // Prints "fr-Latn-FR"\nconsole.log(myLocale.toString()); // Prints "fr-Latn-FR-u-ca-gregory-hc-h12"\n\nconst myLocMinimized = myLocale.minimize();\n\n// Prints "fr", since French is only written in the Latin script\n// and is most likely to be spoken in France.\nconsole.log(myLocMinimized.baseName);\n\n// Prints "fr-u-ca-gregory-hc-h12".\n// Note that the extension tags (after "-u") remain unchanged.\nconsole.log(myLocMinimized.toString());\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Intl.Locale")}}\n- {{jsxref("Intl/Locale/baseName", "baseName")}}\n'
            },
            "numberingsystem": {
                "index.md": '---\ntitle: Intl.Locale.prototype.numberingSystem\nslug: Web/JavaScript/Reference/Global_Objects/Intl/Locale/numberingSystem\npage-type: javascript-instance-accessor-property\nbrowser-compat: javascript.builtins.Intl.Locale.numberingSystem\n---\n\n{{JSRef}}\n\nThe **`numberingSystem`** accessor property of {{jsxref("Intl.Locale")}} instances returns the [numeral system](https://en.wikipedia.org/wiki/Numeral_system) for this locale.\n\n## Description\n\nA numeral system is a system for expressing numbers. The `numberingSystem` property\'s value is set at construction time, either through the `nu` key of the locale identifier or through the `numberingSystem` option of the {{jsxref("Intl/Locale/Locale", "Intl.Locale()")}} constructor. The latter takes priority if they are both present; and if neither is present, the property has value `undefined`.\n\nFor a list of supported numbering system types, see [`Intl.Locale.prototype.getNumberingSystems()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/getNumberingSystems#supported_numbering_system_types).\n\n## Examples\n\nLike other locale subtags, the numbering system type can be added to the {{jsxref("Intl.Locale")}} object via the locale string, or a configuration object argument to the constructor.\n\n### Adding a numbering system via the locale string\n\nIn the [Unicode locale string spec](https://www.unicode.org/reports/tr35/), numbering system types are locale key "extension subtags". These subtags add additional data about the locale, and are added to locale identifiers by using the `-u` extension. Thus, the numbering system type can be added to the initial locale identifier string that is passed into the {{jsxref("Intl/Locale/Locale", "Intl.Locale()")}} constructor. To add the numbering system type, first add the `-u` extension key to the string. Next, add the `-nu` extension to indicate that you are adding a numbering system. Finally, add the numbering system type to the string.\n\n```js\nconst locale = new Intl.Locale("fr-Latn-FR-u-nu-mong");\nconsole.log(locale.numberingSystem); // "mong"\n```\n\n### Adding a numbering system via the configuration object argument\n\nThe {{jsxref("Intl/Locale/Locale", "Intl.Locale()")}} constructor has an optional configuration object argument, which can contain any of several extension types, including numbering system types. Set the `numberingSystem` property of the configuration object to your desired numbering system type, and then pass it into the constructor.\n\n```js\nconst locale = new Intl.Locale("en-Latn-US", { numberingSystem: "latn" });\nconsole.log(locale.numberingSystem); // "latn"\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Intl.Locale")}}\n- [`Intl.Locale.prototype.getNumberingSystems()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/getNumberingSystems)\n- [Details on the standard Unicode numeral systems](https://github.com/unicode-org/cldr/blob/main/common/supplemental/numberingSystems.xml)\n'
            },
            "numeric": {
                "index.md": '---\ntitle: Intl.Locale.prototype.numeric\nslug: Web/JavaScript/Reference/Global_Objects/Intl/Locale/numeric\npage-type: javascript-instance-accessor-property\nbrowser-compat: javascript.builtins.Intl.Locale.numeric\n---\n\n{{JSRef}}\n\nThe **`numeric`** accessor property of {{jsxref("Intl.Locale")}} instances returns whether this locale has special collation handling for numeric characters.\n\n## Description\n\nLike {{jsxref("Intl/Locale/caseFirst", "caseFirst")}}, `numeric` represents a modification to the collation rules utilized by the locale. `numeric` is a boolean value, which means that it can be either `true` or `false`. If `numeric` is set to `false`, there will be no special handling of numeric values in strings. If `numeric` is set to `true`, then the locale will take numeric characters into account when collating strings. This special numeric handling means that sequences of decimal digits will be compared as numbers. For example, the string "A-21" will be considered less than "A-123".\n\n## Examples\n\n### Setting the numeric value via the locale string\n\nIn the [Unicode locale string spec](https://www.unicode.org/reports/tr35/), the values that `numeric` represents correspond to the key `kn`. `kn` is considered a locale string "extension subtag". These subtags add additional data about the locale, and are added to locale identifiers by using the `-u` extension key. Thus, the `numeric` value can be added to the initial locale identifier string that is passed into the {{jsxref("Intl/Locale/Locale", "Intl.Locale()")}} constructor. To set the `numeric` value, first add the `-u` extension key to the string. Next, add the `-kn` extension key to indicate that you are adding a value for `numeric`. Finally, add the `numeric` value to the string. If you want to set `numeric` to `true`, adding the `kn` key will suffice. To set the value to `false`, you must specify in by adding `"false"` after the `kn` key.\n\n```js\nconst locale = new Intl.Locale("fr-Latn-FR-u-kn-false");\nconsole.log(locale.numeric); // Prints "false"\n```\n\n### Setting the numeric value via the configuration object argument\n\nThe {{jsxref("Intl/Locale/Locale", "Intl.Locale()")}} constructor has an optional configuration object argument, which can be used to pass extension types. Set the `numeric` property of the configuration object to your desired `numeric` value and pass it into the constructor.\n\n```js\nconst locale = new Intl.Locale("en-Latn-US", { numeric: true });\nconsole.log(locale.numeric); // Prints "true"\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Intl.Locale")}}\n'
            },
            "region": {
                "index.md": '---\ntitle: Intl.Locale.prototype.region\nslug: Web/JavaScript/Reference/Global_Objects/Intl/Locale/region\npage-type: javascript-instance-accessor-property\nbrowser-compat: javascript.builtins.Intl.Locale.region\n---\n\n{{JSRef}}\n\nThe **`region`** accessor property of {{jsxref("Intl.Locale")}} instances returns the region of the world (usually a country) associated with this locale.\n\n## Description\n\nThe region is an essential part of the locale identifier, as it places the locale in a specific area of the world. Knowing the locale\'s region is vital to identifying differences between locales. For example, English is spoken in the United Kingdom and the United States of America, but there are differences in spelling and other language conventions between those two countries. Knowing the locale\'s region helps JavaScript programmers make sure that the content from their sites and applications is correctly displayed when viewed from different areas of the world.\n\n## Examples\n\n### Setting the region in the locale identifier string argument\n\nThe region is the third part of a valid Unicode language identifier string, and can be set by adding it to the locale identifier string that is passed into the {{jsxref("Intl/Locale/Locale", "Intl.Locale()")}} constructor. The region is a mandatory part of a\n\n```js\nconst locale = new Intl.Locale("en-Latn-US");\nconsole.log(locale.region); // Prints "US"\n```\n\n### Setting the region via the configuration object\n\nThe {{jsxref("Intl/Locale/Locale", "Intl.Locale()")}} constructor takes a configuration object, which can be used to set the region subtag and property.\n\n```js\nconst locale = new Intl.Locale("fr-Latn", { region: "FR" });\nconsole.log(locale.region); // Prints "FR"\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Intl.Locale")}}\n- [Unicode region chart](https://unicode-org.github.io/cldr-staging/charts/latest/supplemental/territory_containment_un_m_49.html)\n'
            },
            "script": {
                "index.md": '---\ntitle: Intl.Locale.prototype.script\nslug: Web/JavaScript/Reference/Global_Objects/Intl/Locale/script\npage-type: javascript-instance-accessor-property\nbrowser-compat: javascript.builtins.Intl.Locale.script\n---\n\n{{JSRef}}\n\nThe **`script`** accessor property of {{jsxref("Intl.Locale")}} instances returns the script used for writing the particular language used in this locale.\n\n## Description\n\nA script, sometimes called writing system, is one of the core attributes of a locale. It indicates the set of symbols, or glyphs, that are used to write a particular language. For instance, the script associated with English is Latin, whereas the script typically associated with Korean is Hangul. In many cases, denoting a script is not strictly necessary, since the language (which is necessary) is only written in a single script. There are exceptions to this rule, however, and it is important to indicate the script whenever possible, in order to have a complete Unicode language identifier.\n\n## Examples\n\n### Setting the script in the locale identifier string argument\n\nThe script is the second part of a valid Unicode language identifier string, and can be set by adding it to the locale identifier string that is passed into the {{jsxref("Intl/Locale/Locale", "Intl.Locale()")}} constructor. Note that the script is not a required part of a locale identifier.\n\n```js\nconst locale = new Intl.Locale("en-Latn-US");\nconsole.log(locale.script); // Prints "Latn"\n```\n\n### Setting the script via the configuration object\n\nThe {{jsxref("Intl/Locale/Locale", "Intl.Locale()")}} constructor takes a configuration object, which can be used to set the script subtag and property.\n\n```js\nconst locale = new Intl.Locale("fr-FR", { script: "Latn" });\nconsole.log(locale.script); // Prints "Latn"\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Intl.Locale")}}\n- [Unicode script subtag](https://www.unicode.org/reports/tr35/#unicode_script_subtag_validity) in the Unicode locale data markup language spec\n'
            },
            "tostring": {
                "index.md": '---\ntitle: Intl.Locale.prototype.toString()\nslug: Web/JavaScript/Reference/Global_Objects/Intl/Locale/toString\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Intl.Locale.toString\n---\n\n{{JSRef}}\n\nThe **`toString()`** method of {{jsxref("Intl.Locale")}} instances returns this Locale\'s full [locale identifier string](https://www.unicode.org/reports/tr35/#Unicode_locale_identifier).\n\n{{EmbedInteractiveExample("pages/js/intl-locale-prototype-tostring.html", "taller")}}\n\n## Syntax\n\n```js-nolint\ntoString()\n```\n\n### Parameters\n\nNone.\n\n### Return value\n\nThe _locale_\'s Unicode locale identifier string.\n\n## Description\n\nThe `Locale` object is a JavaScript representation of a concept\nUnicode locale identifier. Information about a particular locale (language, script,\ncalendar type, etc.) can be encoded in a locale identifier string. To make it easier\nto work with these locale identifiers, the `Locale` object was\nintroduced to JavaScript. Calling the `toString` method on a Locale object\nwill return the identifier string for that particular Locale. The\n`toString` method allows `Locale` instances to be\nprovided as an argument to existing `Intl` constructors, serialized in\nJSON, or any other context where an exact string representation is useful.\n\n## Examples\n\n### Using toString\n\n```js\nconst myLocale = new Intl.Locale("fr-Latn-FR", {\n  hourCycle: "h12",\n  calendar: "gregory",\n});\nconsole.log(myLocale.baseName); // Prints "fr-Latn-FR"\nconsole.log(myLocale.toString()); // Prints "fr-Latn-FR-u-ca-gregory-hc-h12"\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Intl.Locale")}}\n- {{jsxref("Intl/Locale/baseName", "baseName")}}\n'
            }
        },
        "numberformat": {
            "format": {
                "index.md": '---\ntitle: Intl.NumberFormat.prototype.format()\nslug: Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/format\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Intl.NumberFormat.format\n---\n\n{{JSRef}}\n\nThe **`format()`** method of {{jsxref("Intl.NumberFormat")}} instances formats a number according to the [locale and formatting options](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/NumberFormat#parameters) of this `Intl.NumberFormat` object.\n\n{{EmbedInteractiveExample("pages/js/intl-numberformat-prototype-format.html", "taller")}}\n\n## Syntax\n\n```js-nolint\nformat(number)\n```\n\n### Parameters\n\n- `number`\n  - : A {{jsxref("Number")}}, {{jsxref("BigInt")}}, or string, to format. Strings are parsed in the same way as in [number conversion](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number#number_coercion), except that `format()` will use the exact value that the string represents, avoiding loss of precision during implicitly conversion to a number.\n\n> **Note:** Older versions of the specification parsed strings as a {{jsxref("Number")}}.\n> Check the compatibility table for your browser.\n\n### Return value\n\nA string representing the given `number` formatted according to the locale and formatting options of this {{jsxref("Intl.NumberFormat")}} object.\n\n## Description\n\n{{jsxref("Number")}} values in JavaScript suffer from loss of precision if they are too big or too small, making the text representation inaccurate.\nIf you are performing calculations with integers larger than {{jsxref("Number.MAX_SAFE_INTEGER")}} you should use a {{jsxref("BigInt")}} instead, which will format correctly:\n\n```js\nnew Intl.NumberFormat("en-US").format(1234567891234567891); // 1,234,567,891,234,568,000\nnew Intl.NumberFormat("en-US").format(1234567891234567891n); // 1,234,567,891,234,567,891\n```\n\nYou can also pass through very large strings to be formatted as an arbitrary-precision decimal string (if you\'re performing calculations on the data you will still need to work with `BigInt`):\n\n```js\nnew Intl.NumberFormat("en-US").format("1234567891234567891"); // 1,234,567,891,234,567,891\n```\n\n## Examples\n\n### Using format\n\nUse the `format` getter function for formatting a single currency value.\nThe code below shows how to format the roubles currency for a Russian locale:\n\n```js\nconst options = { style: "currency", currency: "RUB" };\nconst numberFormat = new Intl.NumberFormat("ru-RU", options);\nconsole.log(numberFormat.format(654321.987));\n// "654 321,99 \u20BD"\n```\n\n### Using format with map\n\nUse the `format` getter function for formatting all numbers in an array.\nNote that the function is bound to the {{jsxref("Intl.NumberFormat")}} from which it was obtained, so it can be passed directly to {{jsxref("Array.prototype.map")}}.\nThis is considered a historical artefact, as part of a convention which is no longer followed for new features, but is preserved to maintain compatibility with existing programs.\n\n```js\nconst a = [123456.789, 987654.321, 456789.123];\nconst numberFormat = new Intl.NumberFormat("es-ES");\nconst formatted = a.map((n) => numberFormat.format(n));\nconsole.log(formatted.join("; "));\n// "123.456,789; 987.654,321; 456.789,123"\n```\n\n### Using format with a string\n\nUsing a string we can specify very numbers that are larger than {{jsxref("Number.MAX_SAFE_INTEGER")}} without losing precision.\n\n```js\nconst numberFormat = new Intl.NumberFormat("en-US");\n\n// Here the value is converted to a Number\nconsole.log(numberFormat.format(987654321987654321));\n// 987,654,321,987,654,300\n\n// Here we use a string and don\'t lose precision\nconsole.log(numberFormat.format("987654321987654321"));\n// 987,654,321,987,654,321\n```\n\nWe can also use the general "E" exponent syntax for decimal strings: `#.#E#`.\nThe code below creates a {{jsxref("BigInt")}}, coerces it to a string with the suffix `E-6`, and then formats it.\n\n```js\nconst numberFormat = new Intl.NumberFormat("en-US");\nconst bigNum = 1000000000000000110000n;\nconsole.log(numberFormat.format(bigNum));\n// "1,000,000,000,000,000,110,000"\n\n// Format as a string using the `E` syntax:\nconsole.log(numberFormat.format(`${bigNum}E-6`));\n// "1,000,000,000,000,000.11"\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Intl.NumberFormat")}}\n- {{jsxref("Number.prototype.toLocaleString()")}}\n'
            },
            "formatrange": {
                "index.md": '---\ntitle: Intl.NumberFormat.prototype.formatRange()\nslug: Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/formatRange\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Intl.NumberFormat.formatRange\n---\n\n{{JSRef}}\n\nThe **`formatRange()`** method of {{jsxref("Intl.NumberFormat")}} instances formats a range of numbers according to the locale and formatting options of this `Intl.NumberFormat` object.\n\n## Syntax\n\n```js-nolint\nformatRange(startRange, endRange)\n```\n\n### Parameters\n\n- `startRange`\n  - : A {{jsxref("Number")}} or {{jsxref("BigInt")}}.\n- `endRange`\n  - : A {{jsxref("Number")}} or {{jsxref("BigInt")}}.\n\n### Return value\n\nA string representing the given range of numbers formatted according to the locale and formatting options of this {{jsxref("Intl.NumberFormat")}} object.\n\n### Exceptions\n\n- {{jsxref("RangeError")}}\n  - : Thrown if `startRange` is less than `endRange`, or either value is `NaN`.\n- {{jsxref("TypeError")}}\n  - : Thrown if either `startRange` or `endRange` is undefined.\n\n## Description\n\nThe `formatRange` getter function formats a range of numbers into a string according to the locale and formatting options of this {{jsxref("Intl.NumberFormat")}} object from which it is called.\n\n## Examples\n\n### Using formatRange\n\nUse the `formatRange` getter function for formatting a range of currency values:\n\n```js\nconst nf = new Intl.NumberFormat("en-US", {\n  style: "currency",\n  currency: "USD",\n  maximumFractionDigits: 0,\n});\n\nconsole.log(nf.formatRange(3, 5)); // "$3 \u2013 $5"\n\n// Note: the "approximately equals" symbol is added if\n// startRange and endRange round to the same values.\nconsole.log(nf.formatRange(2.9, 3.1)); // "~$3"\n```\n\n```js\nconst nf = new Intl.NumberFormat("es-ES", {\n  style: "currency",\n  currency: "EUR",\n  maximumFractionDigits: 0,\n});\n\nconsole.log(nf.formatRange(3, 5)); // "3-5 \u20AC"\nconsole.log(nf.formatRange(2.9, 3.1)); // "~3 \u20AC"\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Intl.NumberFormat")}}\n- {{jsxref("Number.prototype.toLocaleString()")}}\n'
            },
            "formatrangetoparts": {
                "index.md": '---\ntitle: Intl.NumberFormat.prototype.formatRangeToParts()\nslug: Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/formatRangeToParts\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Intl.NumberFormat.formatRangeToParts\n---\n\n{{JSRef}}\n\nThe **`formatRangeToParts()`** method of {{jsxref("Intl.NumberFormat")}} instances returns an {{jsxref("Array")}} of objects containing the locale-specific tokens from which it is possible to build custom strings while preserving the locale-specific parts. This makes it possible to provide locale-aware custom formatting ranges of number strings.\n\n## Syntax\n\n```js-nolint\nformatRangeToParts(startRange, endRange)\n```\n\n### Parameters\n\n- `startRange`\n\n  - : A {{jsxref("Number")}} or {{jsxref("BigInt")}}.\n\n- `endRange`\n  - : A {{jsxref("Number")}} or {{jsxref("BigInt")}}.\n\n### Return value\n\nAn {{jsxref("Array")}} of objects containing the formatted range of numbers in parts.\n\nThe structure of the returned looks like this:\n\n```js\n[\n  { type: "integer", value: "3", source: "startRange" },\n  { type: "literal", value: "-", source: "shared" },\n  { type: "integer", value: "5", source: "endRange" },\n  { type: "literal", value: " ", source: "shared" },\n  { type: "currency", value: "\u20AC", source: "shared" },\n];\n```\n\nPossible values for the `type` property include:\n\n- `currency`\n  - : The currency string, such as the symbols "$" and "\u20AC" or the name "Dollar", "Euro", depending on how `currencyDisplay` is specified.\n- `decimal`\n  - : The decimal separator string (".").\n- `fraction`\n  - : The fraction number.\n- `group`\n  - : The group separator string (",").\n- `infinity`\n  - : The {{jsxref("Infinity")}} string ("\u221E").\n- `integer`\n  - : The integer number.\n- `literal`\n  - : Any literal strings or whitespace in the formatted number.\n- `minusSign`\n  - : The minus sign string ("-").\n- `nan`\n  - : The {{jsxref("NaN")}} string ("NaN").\n- `plusSign`\n  - : The plus sign string ("+").\n- `percentSign`\n  - : The percent sign string ("%").\n- `unit`\n  - : The unit string, such as the "l" or "litres", depending on how `unitDisplay` is specified.\n\nPossible values for the `source` property include:\n\n- `startRange`\n  - : The object is the start part of the range.\n- `endRange`\n  - : The object is the end part of the range.\n- `shared`\n  - : The object is a "shared" part of the range, such as a separator or currency.\n\n### Exceptions\n\n- {{jsxref("RangeError")}}\n  - : Thrown if `startRange` is less than `endRange`, or either value is `NaN`.\n- {{jsxref("TypeError")}}\n  - : Thrown if either `startRange` or `endRange` is undefined.\n\n## Examples\n\n### Comparing formatRange and formatRangeToParts\n\n`NumberFormat` outputs localized, opaque strings that cannot be manipulated directly:\n\n```js\nconst startRange = 3500;\nconst endRange = 9500;\n\nconst formatter = new Intl.NumberFormat("de-DE", {\n  style: "currency",\n  currency: "EUR",\n});\n\nconsole.log(formatter.formatRange(startRange, endRange));\n// "3.500,00\u20139.500,00 \u20AC"\n```\n\nHowever, for many user interfaces there is a need to customize the formatting of this string.\nThe `formatRangeToParts` method enables locale-aware formatting of strings produced by `NumberFormat` formatters by providing you the string in parts:\n\n```js\nconsole.log(formatter.formatRangeToParts(startRange, endRange));\n\n// return value:\n[\n  { type: "integer", value: "3", source: "startRange" },\n  { type: "group", value: ".", source: "startRange" },\n  { type: "integer", value: "500", source: "startRange" },\n  { type: "decimal", value: ",", source: "startRange" },\n  { type: "fraction", value: "00", source: "startRange" },\n  { type: "literal", value: "\u2013", source: "shared" },\n  { type: "integer", value: "9", source: "endRange" },\n  { type: "group", value: ".", source: "endRange" },\n  { type: "integer", value: "500", source: "endRange" },\n  { type: "decimal", value: ",", source: "endRange" },\n  { type: "fraction", value: "00", source: "endRange" },\n  { type: "literal", value: " ", source: "shared" },\n  { type: "currency", value: "\u20AC", source: "shared" },\n];\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Intl.NumberFormat")}}\n- {{jsxref("Intl/NumberFormat/format", "Intl.NumberFormat.prototype.format()")}}\n- {{jsxref("Intl/DateTimeFormat/formatRangeToParts", "Intl.DateTimeFormat.prototype.formatRangeToParts()")}}\n'
            },
            "formattoparts": {
                "index.md": '---\ntitle: Intl.NumberFormat.prototype.formatToParts()\nslug: Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/formatToParts\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Intl.NumberFormat.formatToParts\n---\n\n{{JSRef}}\n\nThe **`formatToParts()`** method of {{jsxref("Intl.NumberFormat")}} instances allows locale-aware formatting of strings produced by this `Intl.NumberFormat` object.\n\n{{EmbedInteractiveExample("pages/js/intl-numberformat-prototype-formattoparts.html")}}\n\n## Syntax\n\n```js-nolint\nformatToParts()\nformatToParts(number)\n```\n\n### Parameters\n\n- `number` {{optional_inline}}\n  - : A {{jsxref("Number")}} or {{jsxref("BigInt")}} to format.\n\n### Return value\n\nAn {{jsxref("Array")}} of objects containing the formatted number in parts.\n\n## Description\n\nThe `formatToParts()` method is useful for custom formatting of number\nstrings. It returns an {{jsxref("Array")}} of objects containing the locale-specific\ntokens from which it possible to build custom strings while preserving the\nlocale-specific parts. The structure the `formatToParts()` method returns,\nlooks like this:\n\n```js\n[\n  { type: "integer", value: "3" },\n  { type: "group", value: "." },\n  { type: "integer", value: "500" },\n];\n```\n\nPossible types are the following:\n\n- `compact`\n  - : The exponent in `"long"` or `"short"` form, depending on how `compactDisplay` (which defaults to `short`) is specified when `notation` is set to `compact`.\n- `currency`\n  - : The currency string, such as the symbols "$" and "\u20AC" or the name "Dollar", "Euro", depending on how `currencyDisplay` is specified.\n- `decimal`\n  - : The decimal separator string (".").\n- `exponentInteger`\n  - : The exponent integer value, when `notation` is set to `scientific` or `engineering`.\n- `exponentMinusSign`\n  - : The exponent minus sign string ("-").\n- `exponentSeparator`\n  - : The exponent separator, when `notation` is set to `scientific` or `engineering`.\n- `fraction`\n  - : The fraction number.\n- `group`\n  - : The group separator string (",").\n- `infinity`\n  - : The {{jsxref("Infinity")}} string ("\u221E").\n- `integer`\n  - : The integer number.\n- `literal`\n  - : Any literal strings or whitespace in the formatted number.\n- `minusSign`\n  - : The minus sign string ("-").\n- `nan`\n  - : The {{jsxref("NaN")}} string ("NaN").\n- `plusSign`\n  - : The plus sign string ("+").\n- `percentSign`\n  - : The percent sign string ("%").\n- `unit`\n  - : The unit string, such as the "l" or "litres", depending on how `unitDisplay` is specified.\n- `unknown`\n  - : The string for `unknown` type results.\n\n## Examples\n\n### Comparing format and formatToParts\n\n`NumberFormat` outputs localized, opaque strings that cannot be manipulated\ndirectly:\n\n```js\nconst number = 3500;\n\nconst formatter = new Intl.NumberFormat("de-DE", {\n  style: "currency",\n  currency: "EUR",\n});\n\nformatter.format(number);\n// "3.500,00 \u20AC"\n```\n\nHowever, in many User Interfaces there is a desire to customize the formatting of this\nstring. The `formatToParts` method enables locale-aware formatting of\nstrings produced by `NumberFormat` formatters by providing you the string\nin parts:\n\n```js\nformatter.formatToParts(number);\n\n// return value:\n[\n  { type: "integer", value: "3" },\n  { type: "group", value: "." },\n  { type: "integer", value: "500" },\n  { type: "decimal", value: "," },\n  { type: "fraction", value: "00" },\n  { type: "literal", value: " " },\n  { type: "currency", value: "\u20AC" },\n];\n```\n\nNow the information is available separately and it can be formatted and concatenated\nagain in a customized way. For example by using {{jsxref("Array.prototype.map()")}},\n[arrow functions](/en-US/docs/Web/JavaScript/Reference/Functions/Arrow_functions),\na [switch statement](/en-US/docs/Web/JavaScript/Reference/Statements/switch),\n[template literals](/en-US/docs/Web/JavaScript/Reference/Template_literals), and {{jsxref("Array.prototype.reduce()")}}.\n\n```js\nconst numberString = formatter\n  .formatToParts(number)\n  .map(({ type, value }) => {\n    switch (type) {\n      case "currency":\n        return `<strong>${value}</strong>`;\n      default:\n        return value;\n    }\n  })\n  .reduce((string, part) => string + part);\n```\n\nThis will make the currency bold, when using the `formatToParts()` method.\n\n```js\nconsole.log(numberString);\n// "3.500,00 <strong>\u20AC</strong>"\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Intl.NumberFormat")}}\n- {{jsxref("Intl/NumberFormat/format", "Intl.NumberFormat.prototype.format()")}}\n- {{jsxref("Intl/DateTimeFormat/formatToParts", "Intl.DateTimeFormat.prototype.formatToParts()")}}\n'
            },
            "index.md": '---\ntitle: Intl.NumberFormat\nslug: Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat\npage-type: javascript-class\nbrowser-compat: javascript.builtins.Intl.NumberFormat\n---\n\n{{JSRef}}\n\nThe **`Intl.NumberFormat`** object enables language-sensitive number formatting.\n\n{{EmbedInteractiveExample("pages/js/intl-numberformat.html")}}\n\n## Constructor\n\n- {{jsxref("Intl/NumberFormat/NumberFormat", "Intl.NumberFormat()")}}\n  - : Creates a new `NumberFormat` object.\n\n## Static methods\n\n- {{jsxref("Intl/NumberFormat/supportedLocalesOf", "Intl.NumberFormat.supportedLocalesOf()")}}\n  - : Returns an array containing those of the provided locales that are supported without having to fall back to the runtime\'s default locale.\n\n## Instance properties\n\nThese properties are defined on `Intl.NumberFormat.prototype` and shared by all `Intl.NumberFormat` instances.\n\n- {{jsxref("Object/constructor", "Intl.NumberFormat.prototype.constructor")}}\n  - : The constructor function that created the instance object. For `Intl.NumberFormat` instances, the initial value is the {{jsxref("Intl/NumberFormat/NumberFormat", "Intl.NumberFormat")}} constructor.\n- `Intl.NumberFormat.prototype[@@toStringTag]`\n  - : The initial value of the [`@@toStringTag`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol/toStringTag) property is the string `"Intl.NumberFormat"`. This property is used in {{jsxref("Object.prototype.toString()")}}.\n\n## Instance methods\n\n- {{jsxref("Intl/NumberFormat/format", "Intl.NumberFormat.prototype.format()")}}\n  - : Getter function that formats a number according to the locale and formatting options of this {{jsxref("Intl.NumberFormat")}} object.\n- {{jsxref("Intl/NumberFormat/formatRange", "Intl.NumberFormat.prototype.formatRange()")}}\n  - : Getter function that formats a range of numbers according to the locale and formatting options of the {{jsxref("Intl.NumberFormat")}} object from which the method is called.\n- {{jsxref("Intl/NumberFormat/formatRangeToParts", "Intl.NumberFormat.prototype.formatRangeToParts()")}}\n  - : Returns an {{jsxref("Array")}} of objects representing the range of number strings in parts that can be used for custom locale-aware formatting.\n- {{jsxref("Intl/NumberFormat/formatToParts", "Intl.NumberFormat.prototype.formatToParts()")}}\n  - : Returns an {{jsxref("Array")}} of objects representing the number string in parts that can be used for custom locale-aware formatting.\n- {{jsxref("Intl/NumberFormat/resolvedOptions", "Intl.NumberFormat.prototype.resolvedOptions()")}}\n  - : Returns a new object with properties reflecting the locale and collation options computed during initialization of the object.\n\n## Examples\n\n### Basic usage\n\nIn basic use without specifying a locale, a formatted string in the default locale and with default options is returned.\n\n```js\nconst number = 3500;\n\nconsole.log(new Intl.NumberFormat().format(number));\n// \'3,500\' if in US English locale\n```\n\n### Using locales\n\nThis example shows some of the variations in localized number formats. In order to get the format of the language used in the user interface of your application, make sure to specify that language (and possibly some fallback languages) using the `locales` argument:\n\n```js\nconst number = 123456.789;\n\n// German uses comma as decimal separator and period for thousands\nconsole.log(new Intl.NumberFormat("de-DE").format(number));\n// 123.456,789\n\n// Arabic in most Arabic speaking countries uses real Arabic digits\nconsole.log(new Intl.NumberFormat("ar-EG").format(number));\n// \u0661\u0662\u0663\u0664\u0665\u0666\u066B\u0667\u0668\u0669\n\n// India uses thousands/lakh/crore separators\nconsole.log(new Intl.NumberFormat("en-IN").format(number));\n// 1,23,456.789\n\n// the nu extension key requests a numbering system, e.g. Chinese decimal\nconsole.log(new Intl.NumberFormat("zh-Hans-CN-u-nu-hanidec").format(number));\n// \u4E00\u4E8C\u4E09,\u56DB\u4E94\u516D.\u4E03\u516B\u4E5D\n\n// when requesting a language that may not be supported, such as\n// Balinese, include a fallback language, in this case Indonesian\nconsole.log(new Intl.NumberFormat(["ban", "id"]).format(number));\n// 123.456,789\n```\n\n### Using options\n\nThe results can be customized using the [`options`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/NumberFormat#options) argument:\n\n```js\nconst number = 123456.789;\n\n// request a currency format\nconsole.log(\n  new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format(\n    number,\n  ),\n);\n// 123.456,79 \u20AC\n\n// the Japanese yen doesn\'t use a minor unit\nconsole.log(\n  new Intl.NumberFormat("ja-JP", { style: "currency", currency: "JPY" }).format(\n    number,\n  ),\n);\n// \uFFE5123,457\n\n// limit to three significant digits\nconsole.log(\n  new Intl.NumberFormat("en-IN", { maximumSignificantDigits: 3 }).format(\n    number,\n  ),\n);\n// 1,23,000\n\n// Formatting with units\nconsole.log(\n  new Intl.NumberFormat("pt-PT", {\n    style: "unit",\n    unit: "kilometer-per-hour",\n  }).format(50),\n);\n// 50 km/h\n\nconsole.log(\n  (16).toLocaleString("en-GB", {\n    style: "unit",\n    unit: "liter",\n    unitDisplay: "long",\n  }),\n);\n// 16 litres\n```\n\nFor an exhaustive list of options, see the [`Intl.NumberFormat()` constructor](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/NumberFormat#options) page.\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Intl.NumberFormat` in FormatJS](https://formatjs.io/docs/polyfills/intl-numberformat/)\n- {{jsxref("Intl")}}\n',
            "numberformat": {
                "index.md": '---\ntitle: Intl.NumberFormat() constructor\nslug: Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/NumberFormat\npage-type: javascript-constructor\nbrowser-compat: javascript.builtins.Intl.NumberFormat.NumberFormat\n---\n\n{{JSRef}}\n\nThe **`Intl.NumberFormat()`** constructor creates {{jsxref("Intl.NumberFormat")}} objects.\n\n{{EmbedInteractiveExample("pages/js/intl-numberformat.html", "taller")}}\n\n## Syntax\n\n```js-nolint\nnew Intl.NumberFormat()\nnew Intl.NumberFormat(locales)\nnew Intl.NumberFormat(locales, options)\n\nIntl.NumberFormat()\nIntl.NumberFormat(locales)\nIntl.NumberFormat(locales, options)\n```\n\n> **Note:** `Intl.NumberFormat()` can be called with or without [`new`](/en-US/docs/Web/JavaScript/Reference/Operators/new). Both create a new `Intl.NumberFormat` instance. However, there\'s a special behavior when it\'s called without `new` and the `this` value is another `Intl.NumberFormat` instance; see [Return value](#return_value).\n\n### Parameters\n\n- `locales` {{optional_inline}}\n\n  - : A string with a BCP 47 language tag or an {{jsxref("Intl.Locale")}} instance, or an array of such locale identifiers. For the general form and interpretation of the `locales` argument, see [the parameter description on the `Intl` main page](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl#locales_argument).\n\n    The following Unicode extension key is allowed:\n\n    - `nu`\n      - : See [`numberingSystem`](#numberingsystem).\n\n    This key can also be set with `options` (as listed below). When both are set, the `options` property takes precedence.\n\n- `options` {{optional_inline}}\n\n  - : An object. For ease of reading, the property list is broken into sections based on their purposes, including [locale options](#locale_options), [style options](#style_options), [digit options](#digit_options), and [other options](#other_options).\n\n#### Locale options\n\n- `localeMatcher`\n  - : The locale matching algorithm to use. Possible values are `"lookup"` and `"best fit"`; the default is `"best fit"`.\n    For information about this option, see [Locale identification and negotiation](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl#locale_identification_and_negotiation).\n- `numberingSystem`\n  - : The numbering system to use for number formatting, such as `"arab"`, `"hans"`, `"mathsans"`, and so on. For a list of supported numbering system types, see [`Intl.Locale.prototype.getNumberingSystems()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/getNumberingSystems#supported_numbering_system_types). This option can also be set through the `nu` Unicode extension key; if both are provided, this `options` property takes precedence.\n\n#### Style options\n\nDepending on the `style` used, some of them may be ignored, and others may be required:\n\n- `style`\n  - : The formatting style to use.\n    - `"decimal"` (default)\n      - : For plain number formatting.\n    - `"currency"`\n      - : For currency formatting.\n    - `"percent"`\n      - : For percent formatting.\n    - `"unit"`\n      - : For unit formatting.\n- `currency`\n  - : The currency to use in currency formatting. Possible values are the ISO 4217 currency codes, such as `"USD"` for the US dollar, `"EUR"` for the euro, or `"CNY"` for the Chinese RMB \u2014 see the [Current currency & funds code list](https://en.wikipedia.org/wiki/ISO_4217#List_of_ISO_4217_currency_codes). There is no default value; if the `style` is `"currency"`, the `currency` property must be provided.\n- `currencyDisplay`\n  - : How to display the currency in currency formatting.\n    - `"code"`\n      - : Use the ISO currency code.\n    - `"symbol"` (default)\n      - : Use a localized currency symbol such as \u20AC.\n    - `"narrowSymbol"`\n      - : Use a narrow format symbol ("$100" rather than "US$100").\n    - `"name"`\n      - : Use a localized currency name such as `"dollar"`.\n- `currencySign`\n  - : In many locales, accounting format means to wrap the number with parentheses instead of appending a minus sign. Possible values are `"standard"` and `"accounting"`; the default is `"standard"`.\n- `unit`\n  - : The unit to use in `unit` formatting, Possible values are core unit identifiers, defined in [UTS #35, Part 2, Section 6](https://unicode.org/reports/tr35/tr35-general.html#Unit_Elements). A [subset](https://tc39.es/ecma402/#table-sanctioned-single-unit-identifiers) of units from the [full list](https://github.com/unicode-org/cldr/blob/main/common/validity/unit.xml) was selected for use in ECMAScript. Pairs of simple units can be concatenated with "-per-" to make a compound unit. There is no default value; if the `style` is `"unit"`, the `unit` property must be provided.\n- `unitDisplay`\n  - : The unit formatting style to use in `unit` formatting. Possible values are:\n    - `"short"` (default)\n      - : E.g., `16 l`.\n    - `"narrow"`\n      - : E.g., `16l`.\n    - `"long"`\n      - : E.g., `16 litres`.\n\n#### Digit options\n\nThe following properties are also supported by {{jsxref("Intl.PluralRules")}}.\n\n- `minimumIntegerDigits`\n  - : The minimum number of integer digits to use. A value with a smaller number of integer digits than this number will be left-padded with zeros (to the specified length) when formatted. Possible values are from `1` to `21`; the default is `1`.\n- `minimumFractionDigits`\n  - : The minimum number of fraction digits to use. Possible values are from `0` to `20`; the default for plain number and percent formatting is `0`; the default for currency formatting is the number of minor unit digits provided by the [ISO 4217 currency code list](https://www.six-group.com/dam/download/financial-information/data-center/iso-currrency/lists/list-one.xml) (2 if the list doesn\'t provide that information).\n- `maximumFractionDigits`\n  - : The maximum number of fraction digits to use. Possible values are from `0` to `20`; the default for plain number formatting is the larger of `minimumFractionDigits` and `3`; the default for currency formatting is the larger of `minimumFractionDigits` and the number of minor unit digits provided by the [ISO 4217 currency code list](https://www.six-group.com/dam/download/financial-information/data-center/iso-currrency/lists/list-one.xml) (2 if the list doesn\'t provide that information); the default for percent formatting is the larger of `minimumFractionDigits` and 0.\n- `minimumSignificantDigits`\n  - : The minimum number of significant digits to use. Possible values are from `1` to `21`; the default is `1`.\n- `maximumSignificantDigits`\n  - : The maximum number of significant digits to use. Possible values are from `1` to `21`; the default is `21`.\n\nThe above properties fall into two groups: `minimumIntegerDigits`, `minimumFractionDigits`, and `maximumFractionDigits` in one group, `minimumSignificantDigits` and `maximumSignificantDigits` in the other. If properties from both groups are specified, conflicts in the resulting display format are resolved based on th value of the [`roundingPriority`](#roundingpriority) property.\n\n- `roundingPriority`\n\n  - : Specify how rounding conflicts will be resolved if both "FractionDigits" ([`minimumFractionDigits`](#minimumfractiondigits)/[`maximumFractionDigits`](#maximumfractiondigits)) and "SignificantDigits" ([`minimumSignificantDigits`](#minimumsignificantdigits)/[`maximumSignificantDigits`](#maximumsignificantdigits)) are specified.\n    Possible values are:\n\n    - `"auto"` (default)\n      - : The result from the significant digits property is used.\n    - `"morePrecision"`\n      - : The result from the property that results in more precision is used.\n    - `"lessPrecision"`\n      - : The result from the property that results in less precision is used.\n\n    Note that for values other than `auto` the result with more precision is calculated from the [`maximumSignificantDigits`](#minimumsignificantdigits) and [`maximumFractionDigits`](#maximumfractiondigits) (minimum fractional and significant digit settings are ignored).\n\n- `roundingIncrement`\n\n  - : Indicates the increment at which rounding should take place relative to the calculated rounding magnitude. Possible values are `1`, `2`, `5`, `10`, `20`, `25`, `50`, `100`, `200`, `250`, `500`, `1000`, `2000`, `2500`, and `5000`. It cannot be mixed with significant-digits rounding or any setting of `roundingPriority` other than `auto`.\n\n- `roundingMode`\n\n  - : How decimals should be rounded. Possible values are:\n\n    - `"ceil"`\n      - : Round toward +\u221E. Positive values round up. Negative values round "more positive".\n    - `"floor"`\n      - : Round toward -\u221E. Positive values round down. Negative values round "more negative".\n    - `"expand"`\n      - : round away from 0. The _magnitude_ of the value is always increased by rounding. Positive values round up. Negative values round "more negative".\n    - `"trunc"`\n      - : Round toward 0. This _magnitude_ of the value is always reduced by rounding. Positive values round down. Negative values round "less negative".\n    - `"halfCeil"`\n      - : ties toward +\u221E. Values above the half-increment round like `"ceil"` (towards +\u221E), and below like `"floor"` (towards -\u221E). On the half-increment, values round like `"ceil"`.\n    - `"halfFloor"`\n      - : Ties toward -\u221E. Values above the half-increment round like `"ceil"` (towards +\u221E), and below like `"floor"` (towards -\u221E). On the half-increment, values round like `"floor"`.\n    - `"halfExpand"` (default)\n      - : Ties away from 0. Values above the half-increment round like `"expand"` (away from zero), and below like `"trunc"` (towards 0). On the half-increment, values round like `"expand"`.\n    - `"halfTrunc"`\n      - : Ties toward 0. Values above the half-increment round like `"expand"` (away from zero), and below like `"trunc"` (towards 0). On the half-increment, values round like `"trunc"`.\n    - `"halfEven"`\n      - : Ties towards the nearest even integer. Values above the half-increment round like `"expand"` (away from zero), and below like `"trunc"` (towards 0). On the half-increment values round towards the nearest even digit.\n\n    These options reflect the [ICU user guide](https://unicode-org.github.io/icu/userguide/format_parse/numbers/rounding-modes.html), where "expand" and "trunc" map to ICU "UP" and "DOWN", respectively.\n    The [rounding modes](#rounding_modes) example below demonstrates how each mode works.\n\n- `trailingZeroDisplay`\n  - : The strategy for displaying trailing zeros on whole numbers. Possible values are:\n    - `"auto"` (default)\n      - : Keep trailing zeros according to `minimumFractionDigits` and `minimumSignificantDigits`.\n    - `"stripIfInteger"`\n      - : Remove the fraction digits _if_ they are all zero. This is the same as `"auto"` if any of the fraction digits is non-zero.\n\n#### Other options\n\n- `notation`\n  - : The formatting that should be displayed for the number. Possible values are:\n    - `"standard"` (default)\n      - : Plain number formatting.\n    - `"scientific"`\n      - : Return the order-of-magnitude for formatted number.\n    - `"engineering"`\n      - : Return the exponent of ten when divisible by three.\n    - `"compact"`\n      - : String representing exponent; defaults to using the "short" form.\n- `compactDisplay`\n  - : Only used when `notation` is `"compact"`. Possible values are `"short"` and `"long"`; the default is `"short"`.\n- `useGrouping`\n\n  - : Whether to use grouping separators, such as thousands separators or thousand/lakh/crore separators.\n\n    - `"always"`\n      - : Display grouping separators even if the locale prefers otherwise.\n    - `"auto"`\n      - : Display grouping separators based on the locale preference, which may also be dependent on the currency.\n    - `"min2"`\n      - : Display grouping separators when there are at least 2 digits in a group.\n    - `true`\n      - : Same as `"always"`.\n    - `false`\n      - : Display no grouping separators.\n\n    The default is `"min2"` if `notation` is `"compact"`, and `"auto"` otherwise. The string values `"true"` and `"false"` are accepted, but are always converted to the default value.\n\n- `signDisplay`\n  - : When to display the sign for the number. Possible values are:\n    - `"auto"` (default)\n      - : Sign display for negative numbers only, including negative zero.\n    - `"always"`\n      - : Always display sign.\n    - `"exceptZero"`\n      - : Sign display for positive and negative numbers, but not zero.\n    - `"negative"`\n      - : Sign display for negative numbers only, excluding negative zero.\n    - `"never"`\n      - : Never display sign.\n\n### Return value\n\nA new `Intl.NumberFormat` object.\n\n> **Note:** The text below describes behavior that is marked by the specification as "optional". It may not work in all environments. Check the [browser compatibility table](#browser_compatibility).\n\nNormally, `Intl.NumberFormat()` can be called with or without [`new`](/en-US/docs/Web/JavaScript/Reference/Operators/new), and a new `Intl.NumberFormat` instance is returned in both cases. However, if the [`this`](/en-US/docs/Web/JavaScript/Reference/Operators/this) value is an object that is [`instanceof`](/en-US/docs/Web/JavaScript/Reference/Operators/instanceof) `Intl.NumberFormat` (doesn\'t necessarily mean it\'s created via `new Intl.NumberFormat`; just that it has `Intl.NumberFormat.prototype` in its prototype chain), then the value of `this` is returned instead, with the newly created `Intl.NumberFormat` object hidden in a `[Symbol(IntlLegacyConstructedSymbol)]` property (a unique symbol that\'s reused between instances).\n\n```js\nconst formatter = Intl.NumberFormat.call(\n  { __proto__: Intl.NumberFormat.prototype },\n  "en-US",\n  { notation: "scientific" },\n);\nconsole.log(Object.getOwnPropertyDescriptors(formatter));\n// {\n//   [Symbol(IntlLegacyConstructedSymbol)]: {\n//     value: NumberFormat [Intl.NumberFormat] {},\n//     writable: false,\n//     enumerable: false,\n//     configurable: false\n//   }\n// }\n```\n\nNote that there\'s only one actual `Intl.NumberFormat` instance here: the one hidden in `[Symbol(IntlLegacyConstructedSymbol)]`. Calling the [`format()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/format) and [`resolvedOptions()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/resolvedOptions) methods on `formatter` would correctly use the options stored in that instance, but calling all other methods (e.g. [`formatRange()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/formatRange)) would fail with "TypeError: formatRange method called on incompatible Object", because those methods don\'t consult the hidden instance\'s options.\n\nThis behavior, called `ChainNumberFormat`, does not happen when `Intl.NumberFormat()` is called without `new` but with `this` set to anything else that\'s not an `instanceof Intl.NumberFormat`. If you call it directly as `Intl.NumberFormat()`, the `this` value is [`Intl`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl), and a new `Intl.NumberFormat` instance is created normally.\n\n### Exceptions\n\n- {{jsxref("RangeError")}}\n  - : Thrown in one of the following cases:\n    - A property that takes enumerated values (such as `style`, `units`, `currency`, and so on) is set to an invalid value.\n    - Both `maximumFractionDigits` and `minimumFractionDigits` are set, and they are set to different values.\n      Note that depending on various formatting options, these properties can have default values.\n      It is therefore possible to get this error even if you only set one of the properties.\n- {{jsxref("TypeError")}}\n  - : Thrown if the `options.style` property is set to "unit" or "currency", and no value has been set for the corresponding property `options.unit` or `options.currency`.\n\n## Examples\n\n### Basic usage\n\nIn basic use without specifying a locale, a formatted string in the default locale and with default options is returned.\n\n```js\nconst amount = 3500;\n\nconsole.log(new Intl.NumberFormat().format(amount));\n// \'3,500\' if in US English locale\n```\n\n### Decimal and percent formatting\n\n```js\nconst amount = 3500;\n\nnew Intl.NumberFormat("en-US", {\n  style: "decimal",\n}).format(amount); // \'3,500\'\nnew Intl.NumberFormat("en-US", {\n  style: "percent",\n}).format(amount); // \'350,000%\'\n```\n\n### Unit formatting\n\nIf the `style` is `\'unit\'`, a `unit` property must be provided.\nOptionally, `unitDisplay` controls the unit formatting.\n\n```js\nconst amount = 3500;\n\nnew Intl.NumberFormat("en-US", {\n  style: "unit",\n  unit: "liter",\n}).format(amount); // \'3,500 L\'\n\nnew Intl.NumberFormat("en-US", {\n  style: "unit",\n  unit: "liter",\n  unitDisplay: "long",\n}).format(amount); // \'3,500 liters\'\n```\n\n### Currency formatting\n\nIf the `style` is `\'currency\'`, a `currency` property\nmust be provided. Optionally, `currencyDisplay` and\n`currencySign` control the unit formatting.\n\n```js\nconst amount = -3500;\nnew Intl.NumberFormat("en-US", {\n  style: "currency",\n  currency: "USD",\n}).format(amount); // \'-$3,500.00\'\n\nnew Intl.NumberFormat("bn", {\n  style: "currency",\n  currency: "USD",\n  currencyDisplay: "name",\n}).format(amount); // \'-3,500.00 US dollars\'\n\nnew Intl.NumberFormat("bn", {\n  style: "currency",\n  currency: "USD",\n  currencySign: "accounting",\n}).format(amount); // \'($3,500.00)\'\n```\n\n### Scientific, engineering or compact notations\n\nScientific and compact notation are represented by the `notation` option and can be formatted like this:\n\n```js\nnew Intl.NumberFormat("en-US", {\n  notation: "scientific",\n}).format(987654321);\n// 9.877E8\n\nnew Intl.NumberFormat("pt-PT", {\n  notation: "scientific",\n}).format(987654321);\n// 9,877E8\n\nnew Intl.NumberFormat("en-GB", {\n  notation: "engineering",\n}).format(987654321);\n// 987.654E6\n\nnew Intl.NumberFormat("de", {\n  notation: "engineering",\n}).format(987654321);\n// 987,654E6\n\nnew Intl.NumberFormat("zh-CN", {\n  notation: "compact",\n}).format(987654321);\n// 9.9\u4EBF\n\nnew Intl.NumberFormat("fr", {\n  notation: "compact",\n  compactDisplay: "long",\n}).format(987654321);\n// 988 millions\n\nnew Intl.NumberFormat("en-GB", {\n  notation: "compact",\n  compactDisplay: "short",\n}).format(987654321);\n// 988M\n```\n\n### Displaying signs\n\nDisplay a sign for positive and negative numbers, but not zero:\n\n```js\nnew Intl.NumberFormat("en-US", {\n  style: "percent",\n  signDisplay: "exceptZero",\n}).format(0.55);\n// \'+55%\'\n```\n\nNote that when the currency sign is "accounting", parentheses might be used instead of a minus sign:\n\n```js\nnew Intl.NumberFormat("bn", {\n  style: "currency",\n  currency: "USD",\n  currencySign: "accounting",\n  signDisplay: "always",\n}).format(-3500);\n// \'($3,500.00)\'\n```\n\n### FractionDigits, SignificantDigits and IntegerDigits\n\nYou can specify the minimum or maximum number of fractional, integer or significant digits to display when formatting a number.\n\n> **Note:** If both significant and fractional digit limits are specified, then the actual formatting depends on the [`roundingPriority`](#roundingpriority).\n\n#### Using FractionDigits and IntegerDigits\n\nThe integer and fraction digit properties indicate the number of digits to display before and after the decimal point, respectively.\nIf the value to display has fewer integer digits than specified, it will be left-padded with zeros to the expected number.\nIf it has fewer fractional digits, it will be right-padded with zeros.\nBoth cases are shown below:\n\n```js\n// Formatting adds zeros to display minimum integers and fractions\nconsole.log(\n  new Intl.NumberFormat("en", {\n    minimumIntegerDigits: 3,\n    minimumFractionDigits: 4,\n  }).format(4.33),\n);\n// "004.3300"\n```\n\nIf a value has more fractional digits than the specified maximum number, it will be rounded.\nThe _way_ that it is rounded depends on the [`roundingMode`](#roundingmode) property (more details are provided in the [rounding modes](#rounding_modes) section).\nBelow the value is rounded from five fractional digits (`4.33145`) to two (`4.33`):\n\n```js\n// Display value shortened to maximum number of digits\nconsole.log(\n  new Intl.NumberFormat("en", {\n    maximumFractionDigits: 2,\n  }).format(4.33145),\n);\n// "4.33"\n```\n\nThe minimum fractional digits have no effect if the value already has more than 2 fractional digits:\n\n```js\n// Minimum fractions have no effect if value is higher precision.\nconsole.log(\n  new Intl.NumberFormat("en", {\n    minimumFractionDigits: 2,\n  }).format(4.33145),\n);\n// "4.331"\n```\n\n> **Warning:** Watch out for default values as they may affect formatting even if not specified in your code.\n> The default maximum digit value is `3` for plain values, `2` for currency, and may have different values for other predefined types.\n\nThe formatted value above is rounded to 3 digits, even though we didn\'t specify the maximum digits!\nThis is because a default value of `maximumFractionDigits` is set when we specify `minimumFractionDigits`, and visa versa. The default values of `maximumFractionDigits` and `minimumFractionDigits` are `3` and `0`, respectively.\n\nYou can use [`resolvedOptions()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/resolvedOptions) to inspect the formatter.\n\n```js\nconsole.log(\n  new Intl.NumberFormat("en", {\n    maximumFractionDigits: 2,\n  }).resolvedOptions(),\n);\n// {\n//   \u2026\n//   minimumIntegerDigits: 1,\n//   minimumFractionDigits: 0,\n//   maximumFractionDigits: 2,\n//   \u2026\n// }\n\nconsole.log(\n  new Intl.NumberFormat("en", {\n    minimumFractionDigits: 2,\n  }).resolvedOptions(),\n);\n// {\n//   \u2026\n//   minimumIntegerDigits: 1,\n//   minimumFractionDigits: 2,\n//   maximumFractionDigits: 3,\n//   \u2026\n// }\n```\n\n#### Using SignificantDigits\n\nThe number of _significant digits_ is the total number of digits including both integer and fractional parts.\nThe `maximumSignificantDigits` is used to indicate the total number of digits from the original value to display.\n\nThe examples below show how this works.\nNote in particular the last case: only the first digit is retained and the others are discarded/set to zero.\n\n```js\n// Display 5 significant digits\nconsole.log(\n  new Intl.NumberFormat("en", {\n    maximumSignificantDigits: 5,\n  }).format(54.33145),\n);\n// "54.331"\n\n// Max 2 significant digits\nconsole.log(\n  new Intl.NumberFormat("en", {\n    maximumSignificantDigits: 2,\n  }).format(54.33145),\n);\n// "54"\n\n// Max 1 significant digits\nconsole.log(\n  new Intl.NumberFormat("en", {\n    maximumSignificantDigits: 1,\n  }).format(54.33145),\n);\n// "50"\n```\n\nThe `minimumSignificantDigits` ensures that at least the specified number of digits are displayed, adding zeros to the end of the value if needed.\n\n```js\n// Minimum 10 significant digits\nconsole.log(\n  new Intl.NumberFormat("en", {\n    minimumSignificantDigits: 10,\n  }).format(54.33145),\n);\n// "54.33145000"\n```\n\n> **Warning:** Watch out for default values as they may affect formatting.\n> If only one `SignificantDigits` property is used, then its counterpart will automatically be applied with the default value.\n> The default maximum and minimum significant digit values are 20 and 1, respectively.\n\n#### Specifying significant and fractional digits at the same time\n\nThe fraction digits ([`minimumFractionDigits`](#minimumfractiondigits)/[`maximumFractionDigits`](#maximumfractiondigits)) and significant digits ([`minimumSignificantDigits`](#minimumsignificantdigits)/[`maximumSignificantDigits`](#maximumsignificantdigits)) are both ways of controlling how many fractional and leading digits should be formatted.\nIf both are used at the same time, it is possible for them to conflict.\n\nThese conflicts are resolved using the [`roundingPriority`](#roundingpriority) property.\nBy default, this has a value of `"auto"`, which means that if either [`minimumSignificantDigits`](#minimumsignificantdigits) or [`maximumSignificantDigits`](#minimumsignificantdigits) is specified, the fractional and integer digit properties will be ignored.\n\nFor example, the code below formats the value of `4.33145` with `maximumFractionDigits: 3`, and then `maximumSignificantDigits: 2`, and then both.\nThe value with both is the one set with `maximumSignificantDigits`.\n\n```js\nconsole.log(\n  new Intl.NumberFormat("en", {\n    maximumFractionDigits: 3,\n  }).format(4.33145),\n);\n// "4.331"\nconsole.log(\n  new Intl.NumberFormat("en", {\n    maximumSignificantDigits: 2,\n  }).format(4.33145),\n);\n// "4.3"\nconsole.log(\n  new Intl.NumberFormat("en", {\n    maximumFractionDigits: 3,\n    maximumSignificantDigits: 2,\n  }).format(4.33145),\n);\n// "4.3"\n```\n\nUsing [`resolvedOptions()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/resolvedOptions) to inspect the formatter, we can see that the returned object does not include `maximumFractionDigits` when `maximumSignificantDigits` or `minimumSignificantDigits` are specified.\n\n```js\nconsole.log(\n  new Intl.NumberFormat("en", {\n    maximumFractionDigits: 3,\n    maximumSignificantDigits: 2,\n  }).resolvedOptions(),\n);\n// {\n//   \u2026\n//   minimumIntegerDigits: 1,\n//   minimumSignificantDigits: 1,\n//   maximumSignificantDigits: 2,\n//   \u2026\n// }\nconsole.log(\n  new Intl.NumberFormat("en", {\n    maximumFractionDigits: 3,\n    minimumSignificantDigits: 2,\n  }).resolvedOptions(),\n);\n// {\n//   \u2026\n//   minimumIntegerDigits: 1,\n//   minimumSignificantDigits: 2,\n//   maximumSignificantDigits: 21,\n//   \u2026\n// }\n```\n\nIn addition to `"auto"`, you can resolve conflicts by specifying [`roundingPriority`](#roundingpriority) as `"morePrecision"` or `"lessPrecision"`.\nThe formatter calculates the precision using the values of `maximumSignificantDigits` and `maximumFractionDigits`.\n\nThe code below shows the format being selected for the three different rounding priorities:\n\n```js\nconst maxFracNF = new Intl.NumberFormat("en", {\n  maximumFractionDigits: 3,\n});\nconsole.log(`maximumFractionDigits:3 - ${maxFracNF.format(1.23456)}`);\n// "maximumFractionDigits:2 - 1.235"\n\nconst maxSigNS = new Intl.NumberFormat("en", {\n  maximumSignificantDigits: 3,\n});\nconsole.log(`maximumSignificantDigits:3 - ${maxSigNS.format(1.23456)}`);\n// "maximumSignificantDigits:3 - 1.23"\n\nconst bothAuto = new Intl.NumberFormat("en", {\n  maximumSignificantDigits: 3,\n  maximumFractionDigits: 3,\n});\nconsole.log(`auto - ${bothAuto.format(1.23456)}`);\n// "auto - 1.23"\n\nconst bothLess = new Intl.NumberFormat("en", {\n  roundingPriority: "lessPrecision",\n  maximumSignificantDigits: 3,\n  maximumFractionDigits: 3,\n});\nconsole.log(`lessPrecision - ${bothLess.format(1.23456)}`);\n// "lessPrecision - 1.23"\n\nconst bothMore = new Intl.NumberFormat("en", {\n  roundingPriority: "morePrecision",\n  maximumSignificantDigits: 3,\n  maximumFractionDigits: 3,\n});\nconsole.log(`morePrecision - ${bothMore.format(1.23456)}`);\n// "morePrecision - 1.235"\n```\n\nNote that the algorithm can behave in an unintuitive way if a minimum value is specified without a maximum value.\nThe example below formats the value `1` specifying `minimumFractionDigits: 2` (formatting to `1.00`) and `minimumSignificantDigits: 2` (formatting to `1.0`).\nSince `1.00` has more digits than `1.0`, this should be the result when prioritizing `morePrecision`, but in fact the opposite is true:\n\n```js\nconst bothLess = new Intl.NumberFormat("en", {\n  roundingPriority: "lessPrecision",\n  minimumFractionDigits: 2,\n  minimumSignificantDigits: 2,\n});\nconsole.log(`lessPrecision - ${bothLess.format(1)}`);\n// "lessPrecision - 1.00"\n\nconst bothMore = new Intl.NumberFormat("en", {\n  roundingPriority: "morePrecision",\n  minimumFractionDigits: 2,\n  minimumSignificantDigits: 2,\n});\nconsole.log(`morePrecision - ${bothMore.format(1)}`);\n// "morePrecision - 1.0"\n```\n\nThe reason for this is that only the "maximum precision" values are used for the calculation, and the default value of `maximumSignificantDigits` is much higher than `maximumFractionDigits`.\n\n> **Note:** The working group have proposed a modification of the algorithm where the formatter should evaluate the result of using the specified fractional and significant digits independently (taking account of both minimum and maximum values).\n> It will then select the option that displays more fractional digits if `morePrecision` is set, and fewer if `lessPrecision` is set.\n> This will result in more intuitive behavior for this case.\n\n### Rounding modes\n\nIf a value has more fractional digits than allowed by the constructor options, the formatted value will be _rounded_ to the specified number of fractional digits.\nThe _way_ in which the value is rounded depends on the [`roundingMode`](#roundingmode) property.\n\nNumber formatters use `halfExpand` rounding by default, which rounds values "away from zero" at the half-increment (in other words, the _magnitude_ of the value is rounded up).\n\nFor a positive number, if the fractional digits to be removed are closer to the next increment (or on the half way point) then the remaining fractional digits will be rounded up, otherwise they are rounded down.\nThis is shown below: 2.23 rounded to two significant digits is truncated to 2.2 because 2.23 is less than the half increment 2.25, while values of 2.25 and greater are rounded up to 2.3:\n\n```js\n// Value below half-increment: round down.\nconsole.log(\n  new Intl.NumberFormat("en", {\n    maximumSignificantDigits: 2,\n  }).format(2.23),\n);\n// "2.2"\n\n// Value on or above half-increment: round up.\nconsole.log(\n  new Intl.NumberFormat("en", {\n    maximumSignificantDigits: 2,\n  }).format(2.25),\n);\nconsole.log(\n  new Intl.NumberFormat("en", {\n    maximumSignificantDigits: 2,\n  }).format(2.28),\n);\n// "2.3"\n// "2.3"\n```\n\nA negative number on or below the half-increment point is also rounded away from zero (becomes more negative):\n\n```js\n// Value below half-increment: round down.\nconsole.log(\n  new Intl.NumberFormat("en", {\n    maximumSignificantDigits: 2,\n  }).format(-2.23),\n);\n// "-2.2"\n\n// Value on or above half-increment: round up.\nconsole.log(\n  new Intl.NumberFormat("en", {\n    maximumSignificantDigits: 2,\n  }).format(-2.25),\n);\nconsole.log(\n  new Intl.NumberFormat("en", {\n    maximumSignificantDigits: 2,\n  }).format(-2.28),\n);\n// "-2.3"\n// "-2.3"\n```\n\nThe table below show the effect of different rounding modes for positive and negative values that are on and around the half-increment.\n\n| rounding mode | 2.23 | 2.25 | 2.28 | -2.23 | -2.25 | -2.28 |\n| ------------- | ---- | ---- | ---- | ----- | ----- | ----- |\n| `ceil`        | 2.3  | 2.3  | 2.3  | -2.2  | -2.2  | -2.2  |\n| `floor`       | 2.2  | 2.2  | 2.2  | -2.3  | -2.3  | -2.3  |\n| `expand`      | 2.3  | 2.3  | 2.3  | -2.3  | -2.3  | -2.3  |\n| `trunc`       | 2.2  | 2.2  | 2.2  | -2.2  | -2.2  | -2.2  |\n| `halfCeil`    | 2.2  | 2.3  | 2.3  | -2.2  | -2.2  | -2.3  |\n| `halfFloor`   | 2.2  | 2.2  | 2.3  | -2.2  | -2.3  | -2.3  |\n| `halfExpand`  | 2.2  | 2.3  | 2.3  | -2.2  | -2.3  | -2.3  |\n| `halfTrunc`   | 2.2  | 2.2  | 2.3  | -2.2  | -2.2  | -2.3  |\n| `halfEven`    | 2.2  | 2.2  | 2.3  | -2.2  | -2.2  | -2.3  |\n\nWhen using `halfEven`, its behavior also depends on the parity (odd or even) of the last digit of the rounded number. For example, the behavior of `halfEven` in the table above is the same as `halfTrunc`, because the magnitudes of all numbers are between a smaller "even" number (2.2) and a larger "odd" number (2.3). If the numbers are between \xb12.3 and \xb12.4, `halfEven` will behave like `halfExpand` instead. This behavior avoids consistently under- or over-estimating half-increments in a large data sample.\n\n### Using roundingIncrement\n\nSometimes we want to round the remaining fractional digits to some other increment than the next integer.\nFor example, currencies for which the smallest coin is 5 cents might want to round the value to increments of 5, reflecting amounts that can actually be paid in cash.\n\nThis kind of rounding can be achieved with the [`roundingIncrement`](#roundingincrement) property.\n\nFor example, if `maximumFractionDigits` is 2 and `roundingIncrement` is 5, then the number is rounded to the nearest 0.05:\n\n```js\nconst nf = new Intl.NumberFormat("en-US", {\n  style: "currency",\n  currency: "USD",\n  maximumFractionDigits: 2,\n  roundingIncrement: 5,\n});\n\nconsole.log(nf.format(11.29)); // "$11.30"\nconsole.log(nf.format(11.25)); // "$11.25"\nconsole.log(nf.format(11.22)); // "$11.20"\n```\n\nThis particular pattern is referred to as "nickel rounding", where nickel is the colloquial name for a USA 5 cent coin.\nTo round to the nearest 10 cents ("dime rounding"), you could change `roundingIncrement` to `10`.\n\n```js\nconst nf = new Intl.NumberFormat("en-US", {\n  style: "currency",\n  currency: "USD",\n  maximumFractionDigits: 2,\n  roundingIncrement: 5,\n});\n\nconsole.log(nf.format(11.29)); // "$11.30"\nconsole.log(nf.format(11.25)); // "$11.25"\nconsole.log(nf.format(11.22)); // "$11.20"\n```\n\nYou can also use [`roundingMode`](#roundingmode) to change the rounding algorithm.\nThe example below shows how `halfCeil` rounding can be used to round the value "less positive" below the half-rounding increment and "more positive" if above or on the half-increment.\nThe incremented digit is "0.05" so the half-increment is at .025 (below, this is shown at 11.225).\n\n```js\nconst nf = new Intl.NumberFormat("en-US", {\n  style: "currency",\n  currency: "USD",\n  maximumFractionDigits: 2,\n  roundingIncrement: 5,\n  roundingMode: "halfCeil",\n});\n\nconsole.log(nf.format(11.21)); // "$11.20"\nconsole.log(nf.format(11.22)); // "$11.20"\nconsole.log(nf.format(11.224)); // "$11.20"\nconsole.log(nf.format(11.225)); // "$11.25"\nconsole.log(nf.format(11.23)); // "$11.25"\n```\n\nIf you need to change the number of digits, remember that `minimumFractionDigits` and `maximumFractionDigits` must both be set to the same value, or a `RangeError` is thrown.\n\n`roundingIncrement` cannot be mixed with significant-digits rounding or any setting of `roundingPriority` other than `auto`.\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Intl.NumberFormat")}}\n- {{jsxref("Intl.supportedValuesOf()")}}\n- {{jsxref("Intl")}}\n'
            },
            "resolvedoptions": {
                "index.md": '---\ntitle: Intl.NumberFormat.prototype.resolvedOptions()\nslug: Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/resolvedOptions\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Intl.NumberFormat.resolvedOptions\n---\n\n{{JSRef}}\n\nThe **`resolvedOptions()`** method of {{jsxref("Intl.NumberFormat")}} instances returns a new object with properties reflecting the [locale and number formatting options](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/NumberFormat#parameters) computed during initialization of this `Intl.NumberFormat` object.\n\n{{EmbedInteractiveExample("pages/js/intl-numberformat-prototype-resolvedoptions.html")}}\n\n## Syntax\n\n```js-nolint\nresolvedOptions()\n```\n\n### Parameters\n\nNone.\n\n### Return value\n\nA new object with properties reflecting the [locale and number formatting options](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/NumberFormat#parameters) computed during the construction of the given {{jsxref("Intl.NumberFormat")}} object.\n\nThe resulting object has the following properties:\n\n- `compactDisplay`\n  - : Whether to use short or long form when using compact notation.\n    This is the value provided in the [`options.compactDisplay`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/NumberFormat#compactdisplay) argument of the constructor, or the default value: `"short"`.\n    The value is only present if `notation` is set to "compact", and otherwise is `undefined`.\n- `currency`\n  - : The currency to use in currency formatting.\n    The value is defined if `style` is `"currency"`, and is otherwise `undefined`.\n    This is the value provided in the [`options.currency`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/NumberFormat#currency) argument of the constructor.\n- `currencyDisplay`\n  - : The display format for the currency, such as a symbol, or currency code.\n    The value is defined if `style` is `"currency"`, and otherwise is `undefined`.\n    This is the value provided in the [`options.currencyDisplay`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/NumberFormat#currencydisplay) argument of the constructor, or the default value: `"symbol"`.\n- `currencySign`\n  - : The method used to specify the sign of the currency value: `standard` or `accounting`.\n    The value is present if `style` is `"currency"`, and otherwise is `undefined`.\n    This is the value provided in the [`options.currencySign`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/NumberFormat#currencysign) argument of the constructor, or the default value: `"standard"`.\n- `locale`\n  - : The BCP 47 language tag for the locale that was actually used.\n    The key-value pairs that were requested in the constructor [`locale`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/NumberFormat#local) and are supported for this locale are included.\n- `notation`\n  - : The formatting that should be applied to the number, such as `standard` or `engineering`.\n    This is the value provided in the [`options.notation`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/NumberFormat#notation) argument of the constructor, or the default value: `"standard"`.\n- `numberingSystem`\n  - : The numbering system.\n    This is the value provided in the [`options.numberingSystem`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/NumberFormat#numberingsystem) argument of the constructor, if present, or the value set using the Unicode extension key [`nu`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/NumberFormat#nu), or filled in as a default.\n- `roundingMode`\n  - : The rounding mode.\n    This is the value provided for the [`options.roundingMode`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/NumberFormat#roundingmode) argument in the constructor, or the default value: `halfExpand`.\n- `roundingPriority`\n  - : The priority for resolving rounding conflicts if both "FractionDigits" and "SignificantDigits" are specified.\n    This is the value provided for the [`options.roundingPriority`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/NumberFormat#roundingpriority) argument in the constructor, or the default value: `auto`.\n- `roundingIncrement`\n  - : The rounding-increment precision (the increment used when rounding numbers).\n    This is the value specified in the [`options.roundingIncrement`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/NumberFormat#roundingincrement) argument in the constructor.\n- `signDisplay`\n  - : Whether or not to display the positive/negative sign.\n    This is the value specified in the [`options.signDisplay`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/NumberFormat#signdisplay) argument in the constructor, or the default value: `"auto"`.\n- `unit`\n  - : The unit to use in unit formatting.\n    The value is only present if `style` is `"unit"`, and is otherwise `undefined`.\n    This is the value specified in the [`options.unit`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/NumberFormat#unit) argument in the constructor.\n- `unitDisplay`\n\n  - : The display format to use for units in unit formatting, such as "long", "short" or "narrow".\n    The value is only present if `style` is `"unit"`, and is otherwise `undefined`.\n    This is the value specified in the [`options.unitDisplay`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/NumberFormat#unitdisplay) argument in the constructor, or the default value: `short`.\n\n- `useGrouping`\n  - : Whether or not to use grouping separators to indicate "thousands", "millions" and son on.\n    This is the value specified in the [`options.useGrouping`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/NumberFormat#usegrouping) argument in the constructor, or the default value: `"auto"`.\n- `trailingZeroDisplay`\n  - : The strategy for displaying trailing zeros on whole numbers.\n    This is the value specified in the [`options.trailingZeroDisplay`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/NumberFormat#trailingzerodisplay) argument in the constructor, or the default value: `"auto"`.\n\nOnly one of the following two groups of properties is included:\n\n- `minimumIntegerDigits`, `minimumFractionDigits`, `maximumFractionDigits`\n  - : The values provided for these properties in the `options` argument or filled in as defaults.\n    These properties are present only if neither `minimumSignificantDigits` nor `maximumSignificantDigits` was provided in the `options` argument.\n- `minimumSignificantDigits`, `maximumSignificantDigits`\n  - : The values provided for these properties in the `options` argument or filled in as defaults.\n    These properties are present only if at least one of them was provided in the `options` argument.\n\n## Examples\n\n### Using the `resolvedOptions` method\n\n```js\n// Create a NumberFormat\nconst de = new Intl.NumberFormat("de-DE", {\n  style: "currency",\n  currency: "USD",\n  maximumFractionDigits: 2,\n  roundingIncrement: 5,\n  roundingMode: "halfCeil",\n});\n\n// Resolve the options\nconst usedOptions = de.resolvedOptions();\nconsole.log(usedOptions.locale); // "de-DE"\nconsole.log(usedOptions.numberingSystem); // "latn"\nconsole.log(usedOptions.compactDisplay); // undefined ("notation" not set to "compact")\nconsole.log(usedOptions.currency); // "USD"\nconsole.log(usedOptions.currencyDisplay); // "symbol"\nconsole.log(usedOptions.currencySign); // "standard"\nconsole.log(usedOptions.minimumIntegerDigits); // 1\nconsole.log(usedOptions.minimumFractionDigits); // 2\nconsole.log(usedOptions.maximumFractionDigits); // 2\nconsole.log(usedOptions.minimumSignificantDigits); // undefined (maximumFractionDigits is set)\nconsole.log(usedOptions.maximumSignificantDigits); // undefined (maximumFractionDigits is set)\nconsole.log(usedOptions.notation); // "standard"\nconsole.log(usedOptions.roundingIncrement); // 5\nconsole.log(usedOptions.roundingMode); // halfCeil\nconsole.log(usedOptions.roundingPriority); // auto\nconsole.log(usedOptions.signDisplay); // "auto"\nconsole.log(usedOptions.style); // "currency"\nconsole.log(usedOptions.trailingZeroDisplay); // auto\nconsole.log(usedOptions.useGrouping); // auto\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Intl.NumberFormat")}}\n'
            },
            "supportedlocalesof": {
                "index.md": '---\ntitle: Intl.NumberFormat.supportedLocalesOf()\nslug: Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/supportedLocalesOf\npage-type: javascript-static-method\nbrowser-compat: javascript.builtins.Intl.NumberFormat.supportedLocalesOf\n---\n\n{{JSRef}}\n\nThe **`Intl.NumberFormat.supportedLocalesOf()`** static method returns an array containing those of the provided locales that are supported in number formatting without having to fall back to the runtime\'s default locale.\n\n{{EmbedInteractiveExample("pages/js/intl-numberformat-supportedlocalesof.html", "shorter")}}\n\n## Syntax\n\n```js-nolint\nIntl.NumberFormat.supportedLocalesOf(locales)\nIntl.NumberFormat.supportedLocalesOf(locales, options)\n```\n\n### Parameters\n\n- `locales`\n  - : A string with a BCP 47 language tag, or an array of such strings. For the general form and interpretation of the `locales` argument, see [the parameter description on the `Intl` main page](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl#locales_argument).\n- `options` {{optional_inline}}\n  - : An object that may have the following property:\n    - `localeMatcher`\n      - : The locale matching algorithm to use. Possible values are `"lookup"` and `"best fit"`; the default is `"best fit"`. For information about this option, see the {{jsxref("Intl", "Intl", "#locale_identification_and_negotiation", 1)}} page.\n\n### Return value\n\nAn array of strings representing a subset of the given locale tags that are supported in number formatting without having to fall back to the runtime\'s default locale.\n\n## Examples\n\n### Using supportedLocalesOf()\n\nAssuming a runtime that supports Indonesian and German but not Balinese in number formatting, `supportedLocalesOf` returns the Indonesian and German language tags unchanged, even though `pinyin` collation is neither relevant to number formatting nor used with Indonesian, and a specialized German for Indonesia is unlikely to be supported. Note the specification of the `"lookup"` algorithm here \u2014 a `"best fit"` matcher might decide that Indonesian is an adequate match for Balinese since most Balinese speakers also understand Indonesian, and therefore return the Balinese language tag as well.\n\n```js\nconst locales = ["ban", "id-u-co-pinyin", "de-ID"];\nconst options = { localeMatcher: "lookup" };\nconsole.log(Intl.NumberFormat.supportedLocalesOf(locales, options));\n// ["id-u-co-pinyin", "de-ID"]\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Intl.NumberFormat")}}\n'
            }
        },
        "pluralrules": {
            "index.md": '---\ntitle: Intl.PluralRules\nslug: Web/JavaScript/Reference/Global_Objects/Intl/PluralRules\npage-type: javascript-class\nbrowser-compat: javascript.builtins.Intl.PluralRules\n---\n\n{{JSRef}}\n\nThe **`Intl.PluralRules`** object enables plural-sensitive formatting and plural-related language rules.\n\n## Description\n\nLanguages use different patterns for expressing both plural numbers of items (cardinal numbers) and for expressing the order of items (ordinal numbers).\nEnglish has two forms for expressing cardinal numbers: one for the singular "item" (1 hour, 1 dog, 1 fish) and the other for zero or any other number of "items" (0 hours, 2 lemmings, 100000.5 fish), while Chinese has only one form, and Arabic has six!\nSimilarly, English has four forms for expressing ordinal numbers: "th", "st", "nd", "rd", giving the sequence: 0th, 1st, 2nd, 3rd, 4th, 5th, ..., 21st, 22nd, 23rd, 24th, 25th, and so on, while both Chinese and Arabic only have one form for ordinal numbers.\n\nGiven a particular language and set of formatting options, the methods [`Intl.PluralRules.prototype.select()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/PluralRules/select) and [`Intl.PluralRules.prototype.selectRange()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/PluralRules/selectRange) return a _tag_ that represents the plural form of a single or a range of numbers, cardinal or ordinal.\nCode can use the returned tags to represent numbers appropriately for the given language.\nThe full set of tags that might be returned are: `zero`, `one`, `two`, `few`, `many`, and `other` (the "general" plural form, also used if the language only has one form).\n\nAs English only has two forms for cardinal numbers, the `select()` method returns only two tags: `"one"` for the singular case, and `"other"` for all other cardinal numbers.\nThis allows construction of sentences that make sense in English for each case, such as: "1 dog is happy; do you want to play with it?" and "10 dogs are happy; do you want to play with them?".\n\nCreating appropriate sentences for each form depends on the language, and even in English may not be as simple as just adding "s" to a noun to make the plural form.\nUsing the example above, we see that the form may affect:\n\n- **Nouns**: 1 dogs/2 dogs (but not "fish" or "sheep", which have the same singular and plural form).\n- **Verbs**: 1 dog _is_ happy, 2 dogs _are_ happy\n- **Pronouns** (and other referents): Do you want to play with _it_ / _them_.\n\nOther languages have more forms, and choosing appropriate sentences can be even more complex.\n\n`select()` can return any of four tags for ordinal numbers in English, representing each of the allowed forms: `one` for "st" numbers (1, 21, 31, ...), `two` for "nd" numbers (2, 22, 32, ...), `few` for "rd" numbers (3, 33, 43, ...), and `other` for "th" numbers (0, 4-20, etc.).\nAgain, the returned tags allow appropriate formatting of strings describing an ordinal number.\n\nFor more information about the rules and how they are used, see [Plural Rules](https://cldr.unicode.org/index/cldr-spec/plural-rules).\nFor a list of the rules and how they apply for different languages, see the [LDML Language Plural Rules](https://www.unicode.org/cldr/charts/43/supplemental/language_plural_rules.html).\n\n## Constructor\n\n- {{jsxref("Intl/PluralRules/PluralRules", "Intl.PluralRules()")}}\n  - : Creates a new `Intl.PluralRules` object.\n\n## Static methods\n\n- {{jsxref("Intl/PluralRules/supportedLocalesOf", "Intl.PluralRules.supportedLocalesOf()")}}\n  - : Returns an array containing those of the provided locales that are supported without having to fall back to the runtime\'s default locale.\n\n## Instance properties\n\nThese properties are defined on `Intl.PluralRules.prototype` and shared by all `Intl.PluralRules` instances.\n\n- {{jsxref("Object/constructor", "Intl.PluralRules.prototype.constructor")}}\n  - : The constructor function that created the instance object. For `Intl.PluralRules` instances, the initial value is the {{jsxref("Intl/PluralRules/PluralRules", "Intl.PluralRules")}} constructor.\n- `Intl.PluralRules.prototype[@@toStringTag]`\n  - : The initial value of the [`@@toStringTag`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol/toStringTag) property is the string `"Intl.PluralRules"`. This property is used in {{jsxref("Object.prototype.toString()")}}.\n\n## Instance methods\n\n- {{jsxref("Intl/PluralRules/resolvedOptions", "Intl.PluralRules.prototype.resolvedOptions()")}}\n  - : Returns a new object with properties reflecting the locale and collation options computed during initialization of the object.\n- {{jsxref("Intl/PluralRules/select", "Intl.PluralRules.prototype.select()")}}\n  - : Returns a string indicating which plural rule to use for locale-aware formatting.\n- {{jsxref("Intl/PluralRules/selectRange", "Intl.PluralRules.prototype.selectRange()")}}\n  - : This method receives two values and returns a string indicating which plural rule to use for locale-aware formatting.\n\n## Examples\n\n### Using locales\n\nThis example shows some of the variations in localized plural rules for cardinal numbers.\n\nIn order to get the format for the language used in the user interface of your application, make sure to specify that language (and possibly some fallback languages) using the [constructor `locales`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/PluralRules/PluralRules#locales) argument:\n\n```js\n// US English\nconst enCardinalRules = new Intl.PluralRules("en-US");\nconsole.log(enCardinalRules.select(0)); // "other"\nconsole.log(enCardinalRules.select(1)); // "one"\nconsole.log(enCardinalRules.select(2)); // "other"\nconsole.log(enCardinalRules.select(3)); // "other"\n\n// Arabic\nconst arCardinalRules = new Intl.PluralRules("ar-EG");\nconsole.log(arCardinalRules.select(0)); // "zero"\nconsole.log(arCardinalRules.select(1)); // "one"\nconsole.log(arCardinalRules.select(2)); // "two"\nconsole.log(arCardinalRules.select(6)); // "few"\nconsole.log(arCardinalRules.select(18)); // "many"\n```\n\n### Using options\n\nThe plural form of the specified number may also depend on [constructor `options`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/PluralRules/PluralRules#options), such as how the number is rounded, and whether it is cardinal or ordinal.\n\nThis example shows how you can set the type of rules to "ordinal", and how this affects the form for some numbers in US English.\n\n```js\n// US English - ordinal\nconst enOrdinalRules = new Intl.PluralRules("en-US", { type: "ordinal" });\nconsole.log(enOrdinalRules.select(0)); // "other" (0th)\nconsole.log(enOrdinalRules.select(1)); // "one"   (1st)\nconsole.log(enOrdinalRules.select(2)); // "two"   (2nd)\nconsole.log(enOrdinalRules.select(3)); // "few"   (3rd)\nconsole.log(enOrdinalRules.select(4)); // "other" (4th)\nconsole.log(enOrdinalRules.select(21)); // "one"  (21st)\n```\n\n### Formatting text using the returned tag\n\nThe code below extends the previous example, showing how you might use the returned tag for an ordinal number to format text in English.\n\n```js\nconst enOrdinalRules = new Intl.PluralRules("en-US", { type: "ordinal" });\n\nconst suffixes = new Map([\n  ["one", "st"],\n  ["two", "nd"],\n  ["few", "rd"],\n  ["other", "th"],\n]);\nconst formatOrdinals = (n) => {\n  const rule = enOrdinalRules.select(n);\n  const suffix = suffixes.get(rule);\n  return `${n}${suffix}`;\n};\n\nformatOrdinals(0); // \'0th\'\nformatOrdinals(1); // \'1st\'\nformatOrdinals(2); // \'2nd\'\nformatOrdinals(3); // \'3rd\'\nformatOrdinals(4); // \'4th\'\nformatOrdinals(11); // \'11th\'\nformatOrdinals(21); // \'21st\'\nformatOrdinals(42); // \'42nd\'\nformatOrdinals(103); // \'103rd\'\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Intl.PluralRules` in FormatJS](https://formatjs.io/docs/polyfills/intl-pluralrules/)\n- {{jsxref("Intl")}}\n',
            "pluralrules": {
                "index.md": '---\ntitle: Intl.PluralRules() constructor\nslug: Web/JavaScript/Reference/Global_Objects/Intl/PluralRules/PluralRules\npage-type: javascript-constructor\nbrowser-compat: javascript.builtins.Intl.PluralRules.PluralRules\n---\n\n{{JSRef}}\n\nThe **`Intl.PluralRules()`** constructor creates {{jsxref("Intl.PluralRules")}} objects.\n\n## Syntax\n\n```js-nolint\nnew Intl.PluralRules()\nnew Intl.PluralRules(locales)\nnew Intl.PluralRules(locales, options)\n```\n\n> **Note:** `Intl.PluralRules()` can only be constructed with [`new`](/en-US/docs/Web/JavaScript/Reference/Operators/new). Attempting to call it without `new` throws a {{jsxref("TypeError")}}.\n\n### Parameters\n\n- `locales` {{optional_inline}}\n  - : A string with a BCP 47 language tag or an {{jsxref("Intl.Locale")}} instance, or an array of such locale identifiers. For the general form and interpretation of the `locales` argument, see [the parameter description on the `Intl` main page](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl#locales_argument).\n- `options` {{optional_inline}}\n\n  - : An object containing the following properties, in the order they are retrieved (all of them are optional):\n\n    - `localeMatcher`\n      - : The locale matching algorithm to use. Possible values are `"lookup"` and `"best fit"`; the default is `"best fit"`. For information about this option, see [Locale identification and negotiation](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl#locale_identification_and_negotiation).\n    - `type`\n      - : The type to use. Possible values are:\n        - `"cardinal"` (default)\n          - : For cardinal numbers (referring to the quantity of things).\n        - `"ordinal"`\n          - : For ordinal number (referring to the ordering or ranking of things, e.g. "1st", "2nd", "3rd" in English).\n\n    `Intl.PluralRules` also supports the `Intl.NumberFormat()` [digit options](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/NumberFormat#digit_options) (see `Intl.NumberFormat()` for details):\n\n    - `minimumIntegerDigits`\n    - `minimumFractionDigits`\n    - `maximumFractionDigits`\n    - `minimumSignificantDigits`\n    - `maximumSignificantDigits`\n    - `roundingPriority`\n    - `roundingIncrement`\n    - `roundingMode`\n\n    These options are interpreted as if the `notation` option from `Intl.NumberFormat` is `"standard"` and `style` is `"decimal"`.\n\n### Exceptions\n\n- {{jsxref("RangeError")}}\n  - : Thrown if `locales` or `options` contain invalid values.\n\n## Examples\n\n### Basic usage\n\nIn basic use without specifying a locale, a formatted string in the default locale and with default options is returned.\nThis is useful to distinguish between singular and plural forms, e.g. "dog" and "dogs".\n\n```js\nconst pr = new Intl.PluralRules();\n\npr.select(0); // \'other\' if in US English locale\n\npr.select(1); // \'one\' if in US English locale\n\npr.select(2); // \'other\' if in US English locale\n```\n\n### Using options\n\nThe results can be customized using the `options` argument, which has one property called `type` which you can set to `ordinal`. This is useful to figure out the ordinal indicator, e.g. "1st", "2nd", "3rd", "4th", "42nd",\nand so forth.\n\n```js\nconst pr = new Intl.PluralRules("en-US", { type: "ordinal" });\n\nconst suffixes = new Map([\n  ["one", "st"],\n  ["two", "nd"],\n  ["few", "rd"],\n  ["other", "th"],\n]);\nconst formatOrdinals = (n) => {\n  const rule = pr.select(n);\n  const suffix = suffixes.get(rule);\n  return `${n}${suffix}`;\n};\n\nformatOrdinals(0); // \'0th\'\nformatOrdinals(1); // \'1st\'\nformatOrdinals(2); // \'2nd\'\nformatOrdinals(3); // \'3rd\'\nformatOrdinals(4); // \'4th\'\nformatOrdinals(11); // \'11th\'\nformatOrdinals(21); // \'21st\'\nformatOrdinals(42); // \'42nd\'\nformatOrdinals(103); // \'103rd\'\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Intl.PluralRules")}}\n- {{jsxref("Intl")}}\n'
            },
            "resolvedoptions": {
                "index.md": '---\ntitle: Intl.PluralRules.prototype.resolvedOptions()\nslug: Web/JavaScript/Reference/Global_Objects/Intl/PluralRules/resolvedOptions\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Intl.PluralRules.resolvedOptions\n---\n\n{{JSRef}}\n\nThe **`resolvedOptions()`** method of {{jsxref("Intl.PluralRules")}} instances returns a new object with properties reflecting the locale and plural formatting options computed during initialization of this `Intl.PluralRules` object.\n\n{{EmbedInteractiveExample("pages/js/intl-pluralrules-prototype-resolvedoptions.html")}}\n\n## Syntax\n\n```js-nolint\nresolvedOptions()\n```\n\n### Parameters\n\nNone.\n\n### Return value\n\nA new object with properties reflecting the locale and plural formatting options computed during the initialization of the given {{jsxref("Intl.PluralRules")}} object.\n\nThe object has the following properties:\n\n- `locale`\n  - : The BCP 47 language tag for the locale actually used. If any Unicode extension values were requested in the input BCP 47 language tag that led to this locale, the key-value pairs that were requested and are supported for this locale are included in `locale`.\n- `pluralCategories`\n  - : An {{jsxref("Array")}} of plural categories used by the given locale, selected from the list `"zero"`, `"one"`, `"two"`, `"few"`, `"many"` and `"other"`.\n- `type`\n\n  - : The type used (`cardinal` or `ordinal`).\n\n- `roundingMode` {{experimental_inline}}\n  - : The rounding mode.\n    This is the value provided for the [`options.roundingMode`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/PluralRules/PluralRules#roundingmode) argument in the constructor, or the default value: `halfExpand`.\n- `roundingPriority` {{experimental_inline}}\n  - : The priority for resolving rounding conflicts if both "FractionDigits" and "SignificantDigits" are specified.\n    This is the value provided for the [`options.roundingPriority`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/PluralRules/PluralRules#roundingpriority) argument in the constructor, or the default value: `auto`.\n- `roundingIncrement` {{experimental_inline}}\n  - : The rounding-increment precision (the increment used when rounding numbers).\n    This is the value specified in the [`options.roundingIncrement`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/PluralRules/PluralRules#roundingincrement) argument in the constructor.\n- `trailingZeroDisplay` {{experimental_inline}}\n  - : The strategy for displaying trailing zeros on whole numbers.\n    This is the value specified in the [`options.trailingZeroDisplay`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/PluralRules/PluralRules#trailingzerodisplay) argument in the constructor, or the default value: `"auto"`.\n\nOnly one of the following two groups of properties is included:\n\n- `minimumIntegerDigits`, `minimumFractionDigits`, `maximumFractionDigits`\n  - : The values provided for these properties in the `options` argument or filled in as defaults.\n    These properties are present only if neither `minimumSignificantDigits` nor `maximumSignificantDigits` was provided in the `options` argument.\n- `minimumSignificantDigits`, `maximumSignificantDigits`\n  - : The values provided for these properties in the `options` argument or filled in as defaults.\n    These properties are present only if at least one of them was provided in the `options` argument.\n\n## Examples\n\n### Using the resolvedOptions() method\n\nThe code below shows the construction of a `PluralRules` object, followed by logging of each of the resolved options.\n\n```js\n// Create a PluralRules instance\nconst de = new Intl.PluralRules("de-DE", {\n  maximumSignificantDigits: 2,\n  trailingZeroDisplay: "auto",\n});\n\n// Resolve the options\nconst usedOptions = de.resolvedOptions();\nconsole.log(usedOptions.locale); // "de-DE"\nconsole.log(usedOptions.pluralCategories); // Array ["one", "other"]\nconsole.log(usedOptions.type); // "cardinal"\nconsole.log(usedOptions.minimumIntegerDigits); // 1\nconsole.log(usedOptions.minimumFractionDigits); // undefined (maximumSignificantDigits is set)\nconsole.log(usedOptions.maximumFractionDigits); //undefined (maximumSignificantDigits is set)\nconsole.log(usedOptions.minimumSignificantDigits); // 1\nconsole.log(usedOptions.maximumSignificantDigits); //2\nconsole.log(usedOptions.roundingIncrement); // 1\nconsole.log(usedOptions.roundingMode); // "halfExpand"\nconsole.log(usedOptions.roundingPriority); // "auto"\nconsole.log(usedOptions.trailingZeroDisplay); // "auto"\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Intl.PluralRules")}}\n'
            },
            "select": {
                "index.md": "---\ntitle: Intl.PluralRules.prototype.select()\nslug: Web/JavaScript/Reference/Global_Objects/Intl/PluralRules/select\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Intl.PluralRules.select\n---\n\n{{JSRef}}\n\nThe **`select()`** method of {{jsxref(\"Intl.PluralRules\")}} instances returns a string indicating which plural rule to use for locale-aware formatting of a number.\n\n{{EmbedInteractiveExample(\"pages/js/intl-pluralrules-prototype-select.html\")}}\n\n## Syntax\n\n```js-nolint\nselect(number)\n```\n\n### Parameters\n\n- `number`\n  - : The number to get a plural rule for.\n\n### Return value\n\nA string representing the pluralization category of the `number`.\nThis can be one of `zero`, `one`, `two`, `few`, `many`, or `other`.\n\n## Description\n\nThis function selects a pluralization category according to the locale and formatting options of an {{jsxref(\"Intl.PluralRules\")}} object.\nThese options are set in the [`Intl.PluralRules()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/PluralRules/PluralRules) constructor.\n\n## Examples\n\n### Using select()\n\nFirst, create an `Intl.PluralRules` object, passing the appropriate `locales` and `options` parameters.\nHere we create a plural rules object for Arabic in the Egyptian dialect.\nBecause the `type` is not specified the rules object will provide formatting for cardinal numbers (the default).\n\n```js\nconst pr = new Intl.PluralRules(\"ar-EG\");\n```\n\nThen call `select()` on the rules object, specifying the number for which the plural form is required.\nNote that Arabic has 5 forms for cardinal numbers, as shown.\n\n```js\npr.select(0); // 'zero'\npr.select(1); // 'one'\npr.select(2); // 'two'\npr.select(6); // 'few'\npr.select(18); // 'many'\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref(\"Intl.PluralRules\")}}\n"
            },
            "selectrange": {
                "index.md": '---\ntitle: Intl.PluralRules.prototype.selectRange()\nslug: Web/JavaScript/Reference/Global_Objects/Intl/PluralRules/selectRange\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Intl.PluralRules.selectRange\n---\n\n{{JSRef}}\n\nThe **`selectRange()`** method of {{jsxref("Intl.PluralRules")}} instances receives two values and returns a string indicating which plural rule to use for locale-aware formatting of the indicated range.\n\n## Syntax\n\n```js-nolint\nselectRange(startRange, endRange)\n```\n\n### Parameters\n\n- `startRange`\n  - : A number representing the start of the range.\n- `endRange`\n  - : A number representing the end of the range.\n\n### Return value\n\nA string representing the pluralization category of the specified range.\nThis can be one of `zero`, `one`, `two`, `few`, `many` or `other`, that are relevant for the locale whose localization is specified in [LDML Language Plural Rules](https://www.unicode.org/cldr/charts/43/supplemental/language_plural_rules.html).\n\n## Description\n\nThis function selects a pluralization category according to the locale and formatting options of an {{jsxref("Intl.PluralRules")}} object.\n\nConceptually the behavior is the same as getting plural rules for a single cardinal or ordinal number.\nLanguages have one or more forms for describing ranges, and this method returns the appropriate form given the supplied locale and formatting options.\nIn English there is only one plural form, such as "1\u201310 apples", and the method will return `other`.\nOther languages can have many forms.\n\n## Examples\n\n### Using selectRange()\n\n```js\nnew Intl.PluralRules("sl").selectRange(102, 201); // \'few\'\n\nnew Intl.PluralRules("pt").selectRange(102, 102); // \'other\'\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Intl.PluralRules")}}\n'
            },
            "supportedlocalesof": {
                "index.md": '---\ntitle: Intl.PluralRules.supportedLocalesOf()\nslug: Web/JavaScript/Reference/Global_Objects/Intl/PluralRules/supportedLocalesOf\npage-type: javascript-static-method\nbrowser-compat: javascript.builtins.Intl.PluralRules.supportedLocalesOf\n---\n\n{{JSRef}}\n\nThe **`Intl.PluralRules.supportedLocalesOf()`** static method returns an array containing those of the provided locales that are supported in plural rules without having to fall back to the runtime\'s default locale.\n\n{{EmbedInteractiveExample("pages/js/intl-pluralrules-supportedlocalesof.html", "shorter")}}\n\n## Syntax\n\n```js-nolint\nIntl.PluralRules.supportedLocalesOf(locales)\nIntl.PluralRules.supportedLocalesOf(locales, options)\n```\n\n### Parameters\n\n- `locales`\n  - : A string with a BCP 47 language tag, or an array of such strings. For the general form and interpretation of the `locales` argument, see [the parameter description on the `Intl` main page](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl#locales_argument).\n- `options` {{optional_inline}}\n  - : An object that may have the following property:\n    - `localeMatcher`\n      - : The locale matching algorithm to use. Possible values are `"lookup"` and `"best fit"`; the default is `"best fit"`. For information about this option, see the {{jsxref("Intl", "Intl", "#locale_identification_and_negotiation", 1)}} page.\n\n### Return value\n\nAn array of strings representing a subset of the given locale tags that are supported in plural rules without having to fall back to the runtime\'s default locale.\n\n## Examples\n\n### Using supportedLocalesOf()\n\nAssuming a runtime that supports Indonesian and German but not Balinese in plural rules, `supportedLocalesOf` returns the Indonesian and German language tags unchanged, even though `pinyin` collation is neither relevant to plural rules nor used with Indonesian, and a specialized German for Indonesia is unlikely to be supported. Note the specification of the `"lookup"` algorithm here \u2014 a `"best fit"` matcher might decide that Indonesian is an adequate match for Balinese since most Balinese speakers also understand Indonesian, and therefore return the Balinese language tag as well.\n\n```js\nconst locales = ["ban", "id-u-co-pinyin", "de-ID"];\nconst options = { localeMatcher: "lookup" };\nconsole.log(Intl.PluralRules.supportedLocalesOf(locales, options));\n// ["id-u-co-pinyin", "de-ID"]\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Intl.PluralRules")}}\n'
            }
        },
        "relativetimeformat": {
            "format": {
                "index.md": '---\ntitle: Intl.RelativeTimeFormat.prototype.format()\nslug: Web/JavaScript/Reference/Global_Objects/Intl/RelativeTimeFormat/format\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Intl.RelativeTimeFormat.format\n---\n\n{{JSRef}}\n\nThe **`format()`** method of {{jsxref("Intl.RelativeTimeFormat")}} instances formats a `value` and `unit` according to the locale and formatting options of this `Intl.RelativeTimeFormat` object.\n\n{{EmbedInteractiveExample("pages/js/intl-relativetimeformat-prototype-format.html")}}\n\n## Syntax\n\n```js-nolint\nformat(value, unit)\n```\n\n### Parameters\n\n- `value`\n  - : Numeric value to use in the internationalized relative time message.\n- `unit`\n  - : Unit to use in the relative time internationalized message. Possible values are: `"year"`, `"quarter"`, `"month"`, `"week"`, `"day"`, `"hour"`, `"minute"`, `"second"`. Plural forms are also permitted.\n\n### Return value\n\nA string representing the given `value` and `unit` formatted according to the locale and formatting options of this {{jsxref("Intl.RelativeTimeFormat")}} object.\n\n## Examples\n\n### Basic format usage\n\nThe following example shows how to create a relative time formatter using the English language.\n\n```js\n// Create a relative time formatter in your locale\n// with default values explicitly passed in.\nconst rtf = new Intl.RelativeTimeFormat("en", {\n  localeMatcher: "best fit", // other values: "lookup"\n  numeric: "always", // other values: "auto"\n  style: "long", // other values: "short" or "narrow"\n});\n\n// Format relative time using negative value (-1).\nrtf.format(-1, "day"); // "1 day ago"\n\n// Format relative time using positive value (1).\nrtf.format(1, "day"); // "in 1 day"\n```\n\n### Using the auto option\n\nIf `numeric:auto` option is passed, it will produce the string `yesterday`, `today`, or `tomorrow` instead of `1 day ago`, `in 0 days`, or `in 1 day`. This allows to not always have to use numeric values in the output.\n\n```js\n// Create a relative time formatter in your locale\n// with numeric: "auto" option value passed in.\nconst rtf = new Intl.RelativeTimeFormat("en", { numeric: "auto" });\n\n// Format relative time using negative value (-1).\nrtf.format(-1, "day"); // "yesterday"\n\nrtf.format(0, "day"); // "today"\n\n// Format relative time using positive day unit (1).\nrtf.format(1, "day"); // "tomorrow"\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Intl.RelativeTimeFormat")}}\n'
            },
            "formattoparts": {
                "index.md": '---\ntitle: Intl.RelativeTimeFormat.prototype.formatToParts()\nslug: Web/JavaScript/Reference/Global_Objects/Intl/RelativeTimeFormat/formatToParts\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Intl.RelativeTimeFormat.formatToParts\n---\n\n{{JSRef}}\n\nThe **`formatToParts()`** method of {{jsxref("Intl.RelativeTimeFormat")}} instances returns an {{jsxref("Array")}} of objects representing the relative time format in parts that can be used for custom locale-aware formatting.\n\n{{EmbedInteractiveExample("pages/js/intl-relativetimeformat-prototype-formattoparts.html")}}\n\n## Syntax\n\n```js-nolint\nformatToParts(value, unit)\n```\n\n### Parameters\n\n- `value`\n  - : Numeric value to use in the internationalized relative time message.\n- `unit`\n  - : Unit to use in the relative time internationalized message. Possible values are: `"year"`, `"quarter"`, `"month"`, `"week"`, `"day"`, `"hour"`, `"minute"`, `"second"`. Plural forms are also permitted.\n\n### Return value\n\nAn {{jsxref("Array")}} of objects containing the formatted relative time in parts.\n\n## Description\n\nThe `Intl.RelativeTimeFormat.prototype.formatToParts` method is a version of the format method which it returns an array of objects which represent "parts" of the object, separating the formatted number into its constituent parts and separating it from other surrounding text. These objects have two properties: type a `NumberFormat` formatToParts type, and value, which is the String which is the component of the output. If a "part" came from `NumberFormat`, it will have a unit property which indicates the unit being formatted; literals which are part of the larger frame will not have this property.\n\n## Examples\n\n### Using formatToParts\n\n```js\nconst rtf = new Intl.RelativeTimeFormat("en", { numeric: "auto" });\n\n// Format relative time using the day unit\nrtf.formatToParts(-1, "day");\n// [{ type: "literal", value: "yesterday"}]\n\nrtf.formatToParts(100, "day");\n// [\n//   { type: "literal", value: "in " },\n//   { type: "integer", value: "100", unit: "day" },\n//   { type: "literal", value: " days" }\n// ]\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Intl.RelativeTimeFormat")}}\n'
            },
            "index.md": '---\ntitle: Intl.RelativeTimeFormat\nslug: Web/JavaScript/Reference/Global_Objects/Intl/RelativeTimeFormat\npage-type: javascript-class\nbrowser-compat: javascript.builtins.Intl.RelativeTimeFormat\n---\n\n{{JSRef}}\n\nThe **`Intl.RelativeTimeFormat`** object enables language-sensitive relative time formatting.\n\n{{EmbedInteractiveExample("pages/js/intl-relativetimeformat.html")}}\n\n## Constructor\n\n- {{jsxref("Intl/RelativeTimeFormat/RelativeTimeFormat", "Intl.RelativeTimeFormat()")}}\n  - : Creates a new `Intl.RelativeTimeFormat` object.\n\n## Static methods\n\n- {{jsxref("Intl/RelativeTimeFormat/supportedLocalesOf", "Intl.RelativeTimeFormat.supportedLocalesOf()")}}\n  - : Returns an array containing those of the provided locales that are supported without having to fall back to the runtime\'s default locale.\n\n## Instance properties\n\nThese properties are defined on `Intl.RelativeTimeFormat.prototype` and shared by all `Intl.RelativeTimeFormat` instances.\n\n- {{jsxref("Object/constructor", "Intl.RelativeTimeFormat.prototype.constructor")}}\n  - : The constructor function that created the instance object. For `Intl.RelativeTimeFormat` instances, the initial value is the {{jsxref("Intl/RelativeTimeFormat/RelativeTimeFormat", "Intl.RelativeTimeFormat")}} constructor.\n- `Intl.RelativeTimeFormat.prototype[@@toStringTag]`\n  - : The initial value of the [`@@toStringTag`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol/toStringTag) property is the string `"Intl.RelativeTimeFormat"`. This property is used in {{jsxref("Object.prototype.toString()")}}.\n\n## Instance methods\n\n- {{jsxref("Intl/RelativeTimeFormat/format", "Intl.RelativeTimeFormat.prototype.format()")}}\n  - : Formats a `value` and a `unit` according to the locale and formatting options of the given `Intl.RelativeTimeFormat` object.\n- {{jsxref("Intl/RelativeTimeFormat/formatToParts", "Intl.RelativeTimeFormat.prototype.formatToParts()")}}\n  - : Returns an {{jsxref("Array")}} of objects representing the relative time format in parts that can be used for custom locale-aware formatting.\n- {{jsxref("Intl/RelativeTimeFormat/resolvedOptions", "Intl.RelativeTimeFormat.prototype.resolvedOptions()")}}\n  - : Returns a new object with properties reflecting the locale and formatting options computed during initialization of the object.\n\n## Examples\n\n### Basic format usage\n\nThe following example shows how to use a relative time formatter for the English language.\n\n```js\n// Create a relative time formatter in your locale\n// with default values explicitly passed in.\nconst rtf = new Intl.RelativeTimeFormat("en", {\n  localeMatcher: "best fit", // other values: "lookup"\n  numeric: "always", // other values: "auto"\n  style: "long", // other values: "short" or "narrow"\n});\n\n// Format relative time using negative value (-1).\nrtf.format(-1, "day"); // "1 day ago"\n\n// Format relative time using positive value (1).\nrtf.format(1, "day"); // "in 1 day"\n```\n\n### Using formatToParts\n\nThe following example shows how to create a relative time formatter returning formatted parts.\n\n```js\nconst rtf = new Intl.RelativeTimeFormat("en", { numeric: "auto" });\n\n// Format relative time using the day unit.\nrtf.formatToParts(-1, "day");\n// [{ type: "literal", value: "yesterday"}]\n\nrtf.formatToParts(100, "day");\n// [\n//   { type: "literal", value: "in " },\n//   { type: "integer", value: "100", unit: "day" },\n//   { type: "literal", value: " days" }\n// ]\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Intl.RelativeTimeFormat` in FormatJS](https://formatjs.io/docs/polyfills/intl-relativetimeformat/)\n- {{jsxref("Intl")}}\n- [`Intl.RelativeTimeFormat`](https://v8.dev/features/intl-relativetimeformat) on v8.dev (2018)\n',
            "relativetimeformat": {
                "index.md": '---\ntitle: Intl.RelativeTimeFormat() constructor\nslug: Web/JavaScript/Reference/Global_Objects/Intl/RelativeTimeFormat/RelativeTimeFormat\npage-type: javascript-constructor\nbrowser-compat: javascript.builtins.Intl.RelativeTimeFormat.RelativeTimeFormat\n---\n\n{{JSRef}}\n\nThe **`Intl.RelativeTimeFormat()`** constructor creates {{jsxref("Intl.RelativeTimeFormat")}} objects.\n\n## Syntax\n\n```js-nolint\nnew Intl.RelativeTimeFormat()\nnew Intl.RelativeTimeFormat(locales)\nnew Intl.RelativeTimeFormat(locales, options)\n```\n\n> **Note:** `Intl.RelativeTimeFormat()` can only be constructed with [`new`](/en-US/docs/Web/JavaScript/Reference/Operators/new). Attempting to call it without `new` throws a {{jsxref("TypeError")}}.\n\n### Parameters\n\n- `locales` {{optional_inline}}\n\n  - : A string with a BCP 47 language tag or an {{jsxref("Intl.Locale")}} instance, or an array of such locale identifiers. For the general form and interpretation of the `locales` argument, see [the parameter description on the `Intl` main page](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl#locales_argument).\n\n    The following Unicode extension key is allowed:\n\n    - `nu`\n      - : See [`numberingSystem`](#numberingsystem).\n\n    This key can also be set with `options` (as listed below). When both are set, the `options` property takes precedence.\n\n- `options` {{optional_inline}}\n\n  - : An object containing the following properties, in the order they are retrieved (all of them are optional):\n\n    - `localeMatcher`\n      - : The locale matching algorithm to use. Possible values are `"lookup"` and `"best fit"`; the default is `"best fit"`. For information about this option, see [Locale identification and negotiation](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl#locale_identification_and_negotiation).\n    - `numberingSystem`\n      - : The numbering system to use for number formatting, such as `"arab"`, `"hans"`, `"mathsans"`, and so on. For a list of supported numbering system types, see [`Intl.Locale.prototype.getNumberingSystems()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/getNumberingSystems#supported_numbering_system_types). This option can also be set through the `nu` Unicode extension key; if both are provided, this `options` property takes precedence.\n    - `style`\n      - : The style of the formatted relative time. Possible values are:\n        - `"long"` (default)\n          - : E.g., "in 1 month"\n        - `"short"`\n          - : E.g., "in 1 mo."\n        - `"narrow"`\n          - : E.g., "in 1 mo.". The narrow style could be similar to the short style for some locales.\n    - `numeric`\n      - : Whether to use numeric values in the output. Possible values are `"always"` and `"auto"`; the default is `"always"`. When set to `"auto"`, the output may use more idiomatic phrasing such as `"yesterday"` instead of `"1 day ago"`.\n\n### Exceptions\n\n- {{jsxref("RangeError")}}\n  - : Thrown if `locales` or `options` contain invalid values.\n\n## Examples\n\n### Basic format usage\n\nThe following example shows how to create a relative time formatter using the English language.\n\n```js\n// Create a relative time formatter in your locale\n// with default values explicitly passed in.\nconst rtf = new Intl.RelativeTimeFormat("en", {\n  localeMatcher: "best fit", // other values: "lookup"\n  numeric: "always", // other values: "auto"\n  style: "long", // other values: "short" or "narrow"\n});\n\n// Format relative time using negative value (-1).\nrtf.format(-1, "day"); // "1 day ago"\n\n// Format relative time using positive value (1).\nrtf.format(1, "day"); // "in 1 day"\n```\n\n### Using the auto option\n\nIf `numeric:auto` option is passed, it will produce the string `yesterday` or `tomorrow` instead of `1 day ago` or `in 1 day`. This allows to not always have to use numeric values in the output.\n\n```js\n// Create a relative time formatter in your locale\n// with numeric: "auto" option value passed in.\nconst rtf = new Intl.RelativeTimeFormat("en", { numeric: "auto" });\n\n// Format relative time using negative value (-1).\nrtf.format(-1, "day"); // "yesterday"\n\n// Format relative time using positive day unit (1).\nrtf.format(1, "day"); // "tomorrow"\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Intl.RelativeTimeFormat")}}\n- {{jsxref("Intl")}}\n- [`Intl.RelativeTimeFormat`](https://v8.dev/features/intl-relativetimeformat) on v8.dev (2018)\n'
            },
            "resolvedoptions": {
                "index.md": '---\ntitle: Intl.RelativeTimeFormat.prototype.resolvedOptions()\nslug: Web/JavaScript/Reference/Global_Objects/Intl/RelativeTimeFormat/resolvedOptions\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Intl.RelativeTimeFormat.resolvedOptions\n---\n\n{{JSRef}}\n\nThe **`resolvedOptions()`** method of {{jsxref("Intl.RelativeTimeFormat")}} instances returns a new object with properties reflecting the locale and relative time formatting options computed during initialization of this `Intl.RelativeTimeFormat` object.\n\n{{EmbedInteractiveExample("pages/js/intl-relativetimeformat-prototype-resolvedoptions.html")}}\n\n## Syntax\n\n```js-nolint\nresolvedOptions()\n```\n\n### Parameters\n\nNone.\n\n### Return value\n\nA new object with properties reflecting the locale and number formatting options computed during the initialization of the given {{jsxref("Intl.RelativeTimeFormat")}} object.\n\n## Description\n\nThe resulting object has the following properties:\n\n- `locale`\n  - : The BCP 47 language tag for the locale actually used. If any Unicode extension values were requested in the input BCP 47 language tag that led to this locale, the key-value pairs that were requested and are supported for this locale are included in `locale`.\n- `style`\n\n  - : The length of the internationalized message. Possible values are:\n\n    - `"long"` (default, e.g., `in 1 month`)\n    - `"short"` (e.g., `in 1 mo.`),\n    - or `"narrow"` (e.g., `in 1 mo.`). The narrow style could be similar to the short style for some locales.\n\n- `numeric`\n\n  - : The format of output message. Possible values are:\n\n    - `"always"` (default, e.g., `1 day ago`),\n    - or `"auto"` (e.g., `yesterday`). The `"auto"` value allows to not always have to use numeric values in the output.\n\n- `numberingSystem`\n  - : The value requested using the Unicode extension key `"nu"` or filled in as a default.\n\n## Examples\n\n### Using the resolvedOptions() method\n\n```js\nconst de = new Intl.RelativeTimeFormat("de-DE");\nconst usedOptions = de.resolvedOptions();\n\nusedOptions.locale; // "de-DE"\nusedOptions.style; // "long"\nusedOptions.numeric; // "always"\nusedOptions.numberingSystem; // "latn"\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Intl.RelativeTimeFormat")}}\n'
            },
            "supportedlocalesof": {
                "index.md": '---\ntitle: Intl.RelativeTimeFormat.supportedLocalesOf()\nslug: Web/JavaScript/Reference/Global_Objects/Intl/RelativeTimeFormat/supportedLocalesOf\npage-type: javascript-static-method\nbrowser-compat: javascript.builtins.Intl.RelativeTimeFormat.supportedLocalesOf\n---\n\n{{JSRef}}\n\nThe **`Intl.RelativeTimeFormat.supportedLocalesOf()`** static method returns an array containing those of the provided locales that are supported in relative time formatting without having to fall back to the runtime\'s default locale.\n\n{{EmbedInteractiveExample("pages/js/intl-relativetimeformat-supportedlocalesof.html", "shorter")}}\n\n## Syntax\n\n```js-nolint\nIntl.RelativeTimeFormat.supportedLocalesOf(locales)\nIntl.RelativeTimeFormat.supportedLocalesOf(locales, options)\n```\n\n### Parameters\n\n- `locales`\n  - : A string with a BCP 47 language tag, or an array of such strings. For the general form and interpretation of the `locales` argument, see [the parameter description on the `Intl` main page](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl#locales_argument).\n- `options` {{optional_inline}}\n  - : An object that may have the following property:\n    - `localeMatcher`\n      - : The locale matching algorithm to use. Possible values are `"lookup"` and `"best fit"`; the default is `"best fit"`. For information about this option, see the {{jsxref("Intl", "Intl", "#locale_identification_and_negotiation", 1)}} page.\n\n### Return value\n\nAn array of strings representing a subset of the given locale tags that are supported in relative time formatting without having to fall back to the runtime\'s default locale.\n\n## Examples\n\n### Using supportedLocalesOf()\n\nAssuming a runtime that supports Indonesian and German but not Balinese in relative time formatting, `supportedLocalesOf` returns the Indonesian and German language tags unchanged, even though `pinyin` collation is neither relevant to relative time formatting nor used with Indonesian, and a specialized German for Indonesia is unlikely to be supported. Note the specification of the `"lookup"` algorithm here \u2014 a `"best fit"` matcher might decide that Indonesian is an adequate match for Balinese since most Balinese speakers also understand Indonesian, and therefore return the Balinese language tag as well.\n\n```js\nconst locales = ["ban", "id-u-co-pinyin", "de-ID"];\nconst options = { localeMatcher: "lookup" };\nconsole.log(Intl.RelativeTimeFormat.supportedLocalesOf(locales, options));\n// ["id-u-co-pinyin", "de-ID"]\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Intl.RelativeTimeFormat")}}\n'
            }
        },
        "segmenter": {
            "index.md": '---\ntitle: Intl.Segmenter\nslug: Web/JavaScript/Reference/Global_Objects/Intl/Segmenter\npage-type: javascript-class\nbrowser-compat: javascript.builtins.Intl.Segmenter\n---\n\n{{JSRef}}\n\nThe **`Intl.Segmenter`** object enables locale-sensitive text segmentation, enabling you to get meaningful items (graphemes, words or sentences) from a string.\n\n{{EmbedInteractiveExample("pages/js/intl-segmenter.html")}}\n\n## Constructor\n\n- {{jsxref("Intl/Segmenter/Segmenter", "Intl.Segmenter()")}}\n  - : Creates a new `Intl.Segmenter` object.\n\n## Static methods\n\n- {{jsxref("Intl/Segmenter/supportedLocalesOf", "Intl.Segmenter.supportedLocalesOf()")}}\n  - : Returns an array containing those of the provided locales that are supported without having to fall back to the runtime\'s default locale.\n\n## Instance properties\n\nThese properties are defined on `Intl.Segmenter.prototype` and shared by all `Intl.Segmenter` instances.\n\n- {{jsxref("Object/constructor", "Intl.Segmenter.prototype.constructor")}}\n  - : The constructor function that created the instance object. For `Intl.Segmenter` instances, the initial value is the {{jsxref("Intl/Segmenter/Segmenter", "Intl.Segmenter")}} constructor.\n- `Intl.Segmenter.prototype[@@toStringTag]`\n  - : The initial value of the [`@@toStringTag`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol/toStringTag) property is the string `"Intl.Segmenter"`. This property is used in {{jsxref("Object.prototype.toString()")}}.\n\n## Instance methods\n\n- {{jsxref("Intl/Segmenter/resolvedOptions", "Intl.Segmenter.prototype.resolvedOptions()")}}\n  - : Returns a new object with properties reflecting the locale and granularity options computed during initialization of this `Intl.Segmenter` object.\n- {{jsxref("Intl/Segmenter/segment", "Intl.Segmenter.prototype.segment()")}}\n  - : Returns a new iterable [`Segments`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Segmenter/segment/Segments) instance representing the segments of a string according to the locale and granularity of this `Intl.Segmenter` instance.\n\n## Examples\n\n### Basic usage and difference from String.prototype.split()\n\nIf we were to use [`String.prototype.split(" ")`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/split) to segment a text in words, we would not get the correct result if the locale of the text does not use whitespaces between words (which is the case for Japanese, Chinese, Thai, Lao, Khmer, Myanmar, etc.).\n\n```js example-bad\nconst str = "\u543E\u8F29\u306F\u732B\u3067\u3042\u308B\u3002\u540D\u524D\u306F\u305F\u306C\u304D\u3002";\nconsole.table(str.split(" "));\n// [\'\u543E\u8F29\u306F\u732B\u3067\u3042\u308B\u3002\u540D\u524D\u306F\u305F\u306C\u304D\u3002\']\n// The two sentences are not correctly segmented.\n```\n\n```js example-good\nconst str = "\u543E\u8F29\u306F\u732B\u3067\u3042\u308B\u3002\u540D\u524D\u306F\u305F\u306C\u304D\u3002";\nconst segmenterJa = new Intl.Segmenter("ja-JP", { granularity: "word" });\n\nconst segments = segmenterJa.segment(str);\nconsole.table(Array.from(segments));\n// [{segment: \'\u543E\u8F29\', index: 0, input: \'\u543E\u8F29\u306F\u732B\u3067\u3042\u308B\u3002\u540D\u524D\u306F\u305F\u306C\u304D\u3002\', isWordLike: true},\n// etc.\n// ]\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n',
            "resolvedoptions": {
                "index.md": '---\ntitle: Intl.Segmenter.prototype.resolvedOptions()\nslug: Web/JavaScript/Reference/Global_Objects/Intl/Segmenter/resolvedOptions\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Intl.Segmenter.resolvedOptions\n---\n\n{{JSRef}}\n\nThe **`resolvedOptions()`** method of {{jsxref("Intl.Segmenter")}} instances returns a new object with properties reflecting the locale and granularity options computed during the initialization of this `Intl.Segmenter` object.\n\n{{EmbedInteractiveExample("pages/js/intl-segmenter-prototype-resolvedoptions.html")}}\n\n## Syntax\n\n```js-nolint\nresolvedOptions()\n```\n\n### Parameters\n\nNone.\n\n### Return value\n\nA new object with properties reflecting the locale and collation options computed\nduring the initialization of the given [`Intl.Segmenter`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Segmenter) object.\n\n## Description\n\nThe resulting object has the following properties:\n\n- `locale`\n  - : The BCP 47 language tag for the locale actually used. If any Unicode extension\n    values were requested in the input BCP 47 language tag that led to this locale,\n    the key-value pairs that were requested and are supported for this locale are\n    included in `locale`.\n- `granularity`\n  - : The value provided for this property in the `options` argument or filled\n    in as the default.\n\n## Examples\n\n### Basic usage\n\n```js\nconst spanishSegmenter = new Intl.Segmenter("es", { granularity: "sentence" });\nconst options = spanishSegmenter.resolvedOptions();\nconsole.log(options.locale); // "es"\nconsole.log(options.granularity); // "sentence"\n```\n\n### Default granularity\n\n```js\nconst spanishSegmenter = new Intl.Segmenter("es");\nconst options = spanishSegmenter.resolvedOptions();\nconsole.log(options.locale); // "es"\nconsole.log(options.granularity); // "grapheme"\n```\n\n### Fallback locale\n\n```js\nconst banSegmenter = new Intl.Segmenter("ban");\nconst options = banSegmenter.resolvedOptions();\nconsole.log(options.locale);\n// "fr" on a runtime where the Balinese locale\n// is not supported and French is the default locale\nconsole.log(options.granularity); // "grapheme"\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n'
            },
            "segment": {
                "index.md": '---\ntitle: Intl.Segmenter.prototype.segment()\nslug: Web/JavaScript/Reference/Global_Objects/Intl/Segmenter/segment\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Intl.Segmenter.segment\n---\n\n{{JSRef}}\n\nThe **`segment()`** method of {{jsxref("Intl.Segmenter")}} instances segments a string according to the locale and granularity of this `Intl.Segmenter` object.\n\n{{EmbedInteractiveExample("pages/js/intl-segmenter-prototype-segment.html")}}\n\n## Syntax\n\n```js-nolint\nsegment(input)\n```\n\n### Parameters\n\n- `input`\n  - : The text to be segmented as a string.\n\n### Return value\n\nA new iterable [`Segments`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Segmenter/segment/Segments) object containing the segments of the input string, using the segmenter\'s locale and granularity.\n\n## Examples\n\n```js\n// Create a locale-specific word segmenter\nconst segmenter = new Intl.Segmenter("fr", { granularity: "word" });\n\n// Use it to get an iterator over the segments of a string\nconst input = "Moi ? N\'est-ce pas ?";\nconst segments = segmenter.segment(input);\n\n// Use that for segmentation\nfor (const { segment, index, isWordLike } of segments) {\n  console.log(\n    "segment at code units [%d, %d]: \xab%s\xbb%s",\n    index,\n    index + segment.length,\n    segment,\n    isWordLike ? " (word-like)" : "",\n  );\n}\n// segment at code units [0, 3]: \xabMoi\xbb (word-like)\n// segment at code units [3, 4]: \xab \xbb\n// segment at code units [4, 5]: \xab?\xbb\n// segment at code units [5, 6]: \xab \xbb\n// segment at code units [6, 11]: \xabN\'est\xbb (word-like)\n// segment at code units [11, 12]: \xab-\xbb\n// segment at code units [12, 14]: \xabce\xbb (word-like)\n// segment at code units [14, 15]: \xab \xbb\n// segment at code units [15, 18]: \xabpas\xbb (word-like)\n// segment at code units [18, 19]: \xab \xbb\n// segment at code units [19, 20]: \xab?\xbb\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n',
                "segments": {
                    "@@iterator": {
                        "index.md": "---\ntitle: Segments.prototype[@@iterator]()\nslug: Web/JavaScript/Reference/Global_Objects/Intl/Segmenter/segment/Segments/@@iterator\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Intl.Segments.@@iterator\n---\n\n{{JSRef}}\n\nThe **`[@@iterator]()`** method of [`Segments`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Segmenter/segment/Segments) instances implements the [iterable protocol](/en-US/docs/Web/JavaScript/Reference/Iteration_protocols) and allows `Segments` objects to be consumed by most syntaxes expecting iterables, such as the [spread syntax](/en-US/docs/Web/JavaScript/Reference/Operators/Spread_syntax) and {{jsxref(\"Statements/for...of\", \"for...of\")}} loops. It returns a [segments iterator object](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Iterator) that yields data about each segment.\n\n{{EmbedInteractiveExample(\"pages/js/segments-prototype-@@iterator.html\")}}\n\n## Syntax\n\n```js-nolint\nsegments[Symbol.iterator]()\n```\n\n### Parameters\n\nNone.\n\n### Return value\n\nA new [iterable iterator object](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Iterator) that yields data about each segment. Each yielded object has the same properties as the object returned by the [`containing()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Segmenter/segment/Segments/containing) method.\n\n## Examples\n\n### Iteration using for...of loop\n\nNote that you seldom need to call this method directly. The existence of the `@@iterator` method makes `Segments` objects [iterable](/en-US/docs/Web/JavaScript/Reference/Iteration_protocols#the_iterable_protocol), and iterating syntaxes like the `for...of` loop automatically call this method to obtain the iterator to loop over.\n\n```js\nconst segmenter = new Intl.Segmenter(\"zh-CN\", { granularity: \"word\" });\nconst input = \"\u4F60\u597D\uFF0C\u4E16\u754C\uFF01\u6211\u7231\u7F16\u7A0B\u3002\";\n\nfor (const value of segmenter.segment(input)) {\n  console.log(value);\n}\n\n/*\n{segment: '\u4F60\u597D', index: 0, input: '\u4F60\u597D\uFF0C\u4E16\u754C\uFF01\u6211\u7231\u7F16\u7A0B\u3002', isWordLike: true}\n{segment: '\uFF0C', index: 2, input: '\u4F60\u597D\uFF0C\u4E16\u754C\uFF01\u6211\u7231\u7F16\u7A0B\u3002', isWordLike: false}\n{segment: '\u4E16\u754C', index: 3, input: '\u4F60\u597D\uFF0C\u4E16\u754C\uFF01\u6211\u7231\u7F16\u7A0B\u3002', isWordLike: true}\n{segment: '\uFF01', index: 5, input: '\u4F60\u597D\uFF0C\u4E16\u754C\uFF01\u6211\u7231\u7F16\u7A0B\u3002', isWordLike: false}\n{segment: '\u6211', index: 6, input: '\u4F60\u597D\uFF0C\u4E16\u754C\uFF01\u6211\u7231\u7F16\u7A0B\u3002', isWordLike: true}\n{segment: '\u7231', index: 7, input: '\u4F60\u597D\uFF0C\u4E16\u754C\uFF01\u6211\u7231\u7F16\u7A0B\u3002', isWordLike: true}\n{segment: '\u7F16', index: 8, input: '\u4F60\u597D\uFF0C\u4E16\u754C\uFF01\u6211\u7231\u7F16\u7A0B\u3002', isWordLike: true}\n{segment: '\u7A0B', index: 9, input: '\u4F60\u597D\uFF0C\u4E16\u754C\uFF01\u6211\u7231\u7F16\u7A0B\u3002', isWordLike: true}\n{segment: '\u3002', index: 10, input: '\u4F60\u597D\uFF0C\u4E16\u754C\uFF01\u6211\u7231\u7F16\u7A0B\u3002', isWordLike: false}\n*/\n```\n\n### Manually hand-rolling the iterator\n\nYou may still manually call the `next()` method of the returned iterator object to achieve maximum control over the iteration process.\n\n```js\nconst segmenter = new Intl.Segmenter(\"fr\", { granularity: \"word\" });\nconst input = \"Moi ? N'est-ce pas ?\";\nconst segments = segmenter.segment(input);\nconst iterator = segments[Symbol.iterator]();\n\nlet result = iterator.next();\n\nwhile (!result.done) {\n  console.log(result.value);\n  result = iterator.next();\n}\n\n/*\n{segment: 'Moi', index: 0, input: \"Moi ? N'est-ce pas ?\", isWordLike: true}\n{segment: ' ', index: 3, input: \"Moi ? N'est-ce pas ?\", isWordLike: false}\n{segment: '?', index: 4, input: \"Moi ? N'est-ce pas ?\", isWordLike: false}\n{segment: ' ', index: 5, input: \"Moi ? N'est-ce pas ?\", isWordLike: false}\n{segment: \"N'est\", index: 6, input: \"Moi ? N'est-ce pas ?\", isWordLike: true}\n{segment: '-', index: 11, input: \"Moi ? N'est-ce pas ?\", isWordLike: false}\n{segment: 'ce', index: 12, input: \"Moi ? N'est-ce pas ?\", isWordLike: true}\n{segment: ' ', index: 14, input: \"Moi ? N'est-ce pas ?\", isWordLike: false}\n{segment: 'pas', index: 15, input: \"Moi ? N'est-ce pas ?\", isWordLike: true}\n{segment: ' ', index: 18, input: \"Moi ? N'est-ce pas ?\", isWordLike: false}\n{segment: '?', index: 19, input: \"Moi ? N'est-ce pas ?\", isWordLike: false}\n*/\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [`Intl.Segmenter`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Segmenter)\n- [`Intl.Segmenter.prototype.segment()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Segmenter/segment)\n- {{jsxref(\"Symbol.iterator\")}}\n- [Iteration protocols](/en-US/docs/Web/JavaScript/Reference/Iteration_protocols)\n"
                    },
                    "containing": {
                        "index.md": '---\ntitle: Segments.prototype.containing()\nslug: Web/JavaScript/Reference/Global_Objects/Intl/Segmenter/segment/Segments/containing\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Intl.Segments.containing\n---\n\n{{JSRef}}\n\nThe **`containing()`** method of [`Segments`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Segmenter/segment/Segments) instances returns an object describing the segment in the string that includes the code unit at the specified index.\n\n{{EmbedInteractiveExample("pages/js/segments-prototype-containing.html")}}\n\n## Syntax\n\n```js-nolint\ncontaining(codeUnitIndex)\n```\n\n### Parameters\n\n- `codeUnitIndex` {{optional_inline}}\n  - : A number specifying the index of the code unit in the original input string. If the value is omitted, it defaults to `0`.\n\n### Return value\n\nAn object describing the segment of the original string with the following properties, or `undefined` if the supplied index value is out of bounds.\n\n- `segment`\n  - : A string containing the segment extracted from the original input string.\n- `index`\n  - : The code unit index in the original input string at which the segment begins.\n- `input`\n  - : The complete input string that was segmented.\n- `isWordLike`\n  - : A boolean value only if `granularity` is `"word"`; otherwise, `undefined`. If `granularity` is `"word"`, then `isWordLike` is `true` when the segment is word-like (i.e., consists of letters/numbers/ideographs/etc.); otherwise, `false`.\n\n## Examples\n\n```js\n// \u25030 1 2 3 4 5\u25036\u25037\u25038\u25039  \u2190 code unit index\n// \u2503A l l o n s\u2503-\u2503y\u2503!\u2503   \u2190 code unit\nconst input = "Allons-y!";\n\nconst segmenter = new Intl.Segmenter("fr", { granularity: "word" });\nconst segments = segmenter.segment(input);\n\nlet current = segments.containing();\n// { index: 0, segment: "Allons", isWordLike: true }\n\ncurrent = segments.containing(4);\n// { index: 0, segment: "Allons", isWordLike: true }\n\ncurrent = segments.containing(6);\n// { index: 6, segment: "-", isWordLike: false }\n\ncurrent = segments.containing(current.index + current.segment.length);\n// { index: 7, segment: "y", isWordLike: true }\n\ncurrent = segments.containing(current.index + current.segment.length);\n// { index: 8, segment: "!", isWordLike: false }\n\ncurrent = segments.containing(current.index + current.segment.length);\n// undefined\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [`Intl.Segmenter`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Segmenter)\n- [`Intl.Segmenter.prototype.segment()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Segmenter/segment)\n'
                    },
                    "index.md": '---\ntitle: Segments\nslug: Web/JavaScript/Reference/Global_Objects/Intl/Segmenter/segment/Segments\npage-type: javascript-class\nbrowser-compat: javascript.builtins.Intl.Segments\n---\n\n{{JSRef}}\n\nA **`Segments`** object is an iterable collection of the segments of a text string. It is returned by a call to the [`segment()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Segmenter/segment) method of an [`Intl.Segmenter`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Segmenter) object.\n\n{{EmbedInteractiveExample("pages/js/segments-prototype-containing.html")}}\n\n## Instance methods\n\n- [`Segments.prototype.containing()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Segmenter/segment/Segments/containing)\n  - : Returns an object describing the segment in the original string that includes the code unit at a specified index.\n- [`Segments.prototype[@@iterator]()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Segmenter/segment/Segments/@@iterator)\n  - : Returns an iterator to iterate over the segments.\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [`Intl.Segmenter`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Segmenter)\n- [`Intl.Segmenter.prototype.segment()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Segmenter/segment)\n'
                }
            },
            "segmenter": {
                "index.md": '---\ntitle: Intl.Segmenter() constructor\nslug: Web/JavaScript/Reference/Global_Objects/Intl/Segmenter/Segmenter\npage-type: javascript-constructor\nbrowser-compat: javascript.builtins.Intl.Segmenter.Segmenter\n---\n\n{{JSRef}}\n\nThe **`Intl.Segmenter()`** constructor creates {{jsxref("Intl.Segmenter")}} objects.\n\n{{EmbedInteractiveExample("pages/js/intl-segmenter.html")}}\n\n## Syntax\n\n```js-nolint\nnew Intl.Segmenter()\nnew Intl.Segmenter(locales)\nnew Intl.Segmenter(locales, options)\n```\n\n> **Note:** `Intl.Segmenter()` can only be constructed with [`new`](/en-US/docs/Web/JavaScript/Reference/Operators/new). Attempting to call it without `new` throws a {{jsxref("TypeError")}}.\n\n### Parameters\n\n- `locales` {{optional_inline}}\n  - : A string with a BCP 47 language tag or an {{jsxref("Intl.Locale")}} instance, or an array of such locale identifiers. For the general form and interpretation of the `locales` argument, see [the parameter description on the `Intl` main page](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl#locales_argument).\n- `options` {{optional_inline}}\n  - : An object containing the following properties, in the order they are retrieved (all of them are optional):\n    - `localeMatcher`\n      - : The locale matching algorithm to use. Possible values are `"lookup"` and `"best fit"`; the default is `"best fit"`. For information about this option, see [Locale identification and negotiation](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl#locale_identification_and_negotiation).\n    - `granularity`\n      - : How granularly should the input be split. Possible values are:\n        - `"grapheme"` (default)\n          - : Split the input into segments at grapheme cluster (user-perceived character) boundaries, as determined by the locale.\n        - `"word"`\n          - : Split the input into segments at word boundaries, as determined by the locale.\n        - `"sentence"`\n          - : Split the input into segments at sentence boundaries, as determined by the locale.\n\n### Return value\n\nA new [`Intl.Segmenter`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Segmenter) instance.\n\n### Exceptions\n\n- {{jsxref("RangeError")}}\n  - : Thrown if `locales` or `options` contain invalid values.\n\n## Examples\n\n### Basic usage\n\nThe following example shows how to count words in a string using the Japanese language (where splitting the string using `String` methods would have given an incorrect result).\n\n```js\nconst text = "\u543E\u8F29\u306F\u732B\u3067\u3042\u308B\u3002\u540D\u524D\u306F\u305F\u306C\u304D\u3002";\nconst japaneseSegmenter = new Intl.Segmenter("ja-JP", { granularity: "word" });\nconsole.log(\n  [...japaneseSegmenter.segment(text)].filter((segment) => segment.isWordLike)\n    .length,\n);\n// 8, as the text is segmented as \'\u543E\u8F29\'|\'\u306F\'|\'\u732B\'|\'\u3067\'|\'\u3042\u308B\'|\'\u3002\'|\'\u540D\u524D\'|\'\u306F\'|\'\u305F\u306C\u304D\'|\'\u3002\'\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n'
            },
            "supportedlocalesof": {
                "index.md": '---\ntitle: Intl.Segmenter.supportedLocalesOf()\nslug: Web/JavaScript/Reference/Global_Objects/Intl/Segmenter/supportedLocalesOf\npage-type: javascript-static-method\nbrowser-compat: javascript.builtins.Intl.Segmenter.supportedLocalesOf\n---\n\n{{JSRef}}\n\nThe **`Intl.Segmenter.supportedLocalesOf()`** static method returns an array containing those of the provided locales that are supported in segmentation without having to fall back to the runtime\'s default locale.\n\n{{EmbedInteractiveExample("pages/js/intl-segmenter-supportedlocalesof.html", "shorter")}}\n\n## Syntax\n\n```js-nolint\nIntl.Segmenter.supportedLocalesOf(locales)\nIntl.Segmenter.supportedLocalesOf(locales, options)\n```\n\n### Parameters\n\n- `locales`\n  - : A string with a BCP 47 language tag, or an array of such strings. For the general form and interpretation of the `locales` argument, see [the parameter description on the `Intl` main page](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl#locales_argument).\n- `options` {{optional_inline}}\n  - : An object that may have the following property:\n    - `localeMatcher`\n      - : The locale matching algorithm to use. Possible values are `"lookup"` and `"best fit"`; the default is `"best fit"`. For information about this option, see the {{jsxref("Intl", "Intl", "#locale_identification_and_negotiation", 1)}} page.\n\n### Return value\n\nAn array of strings representing a subset of the given locale tags that are supported in segmentation without having to fall back to the runtime\'s default locale.\n\n## Examples\n\n### Using supportedLocalesOf()\n\nAssuming a runtime that supports Indonesian and German but not Balinese in segmentation, `supportedLocalesOf` returns the Indonesian and German language tags unchanged, even though `pinyin` collation is neither relevant to segmentation nor used with Indonesian, and a specialized German for Indonesia is unlikely to be supported. Note the specification of the `"lookup"` algorithm here \u2014 a `"best fit"` matcher might decide that Indonesian is an adequate match for Balinese since most Balinese speakers also understand Indonesian, and therefore return the Balinese language tag as well.\n\n```js\nconst locales = ["ban", "id-u-co-pinyin", "de-ID"];\nconst options = { localeMatcher: "lookup" };\nconsole.log(Intl.Segmenter.supportedLocalesOf(locales, options));\n// ["id-u-co-pinyin", "de-ID"]\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Intl.Segmenter")}}\n'
            }
        },
        "supportedvaluesof": {
            "index.md": '---\ntitle: Intl.supportedValuesOf()\nslug: Web/JavaScript/Reference/Global_Objects/Intl/supportedValuesOf\npage-type: javascript-static-method\nbrowser-compat: javascript.builtins.Intl.supportedValuesOf\n---\n\n{{JSRef}}\n\nThe **`Intl.supportedValuesOf()`** static method returns an array containing the supported calendar, collation, currency, numbering systems, or unit values supported by the implementation.\n\nDuplicates are omitted and the array is sorted in ascending lexicographical order (or more precisely, using {{jsxref("Array/sort", "Array.prototype.sort()")}} with an `undefined` compare function).\n\nThe method can be used to feature-test whether values are supported in a particular implementation and download a polyfill only if necessary.\nIt can also be used to build UIs that allow users to select their preferred localized values, for example when the UI is created from WebGL or server-side.\n\n{{EmbedInteractiveExample("pages/js/intl-supportedvaluesof.html", "taller")}}\n\n## Syntax\n\n```js-nolint\nIntl.supportedValuesOf(key)\n```\n\n### Parameters\n\n- `key`\n  - : A key string indicating the category of values to be returned. This is one of: `"calendar"`, `"collation"`, `"currency"`, `"numberingSystem"`, `"timeZone"`, `"unit"`.\n\n### Return value\n\nA sorted array of unique string values indicating the values supported by the implementation for the given key.\n\n### Exceptions\n\n- {{jsxref("RangeError")}}\n  - : Thrown if an unsupported key was passed as a parameter.\n\n## Examples\n\n### Feature testing\n\nYou can check that the method is supported by comparing to `undefined`:\n\n```js\nif (typeof Intl.supportedValuesOf !== "undefined") {\n  // method is supported\n}\n```\n\n### Get all values for key\n\nTo get the supported values for calendar you call the method with the key `"calendar"`.\nYou can then iterate through the returned array as shown below:\n\n```js\nIntl.supportedValuesOf("calendar").forEach((calendar) => {\n  // "buddhist", "chinese", "coptic", "dangi", etc.\n});\n```\n\n> **Note:** The array returned for calendar values will always include the value "gregory" (gregorian).\n\nThe other values are all obtained in the same way:\n\n```js\nIntl.supportedValuesOf("collation").forEach((collation) => {\n  // "compat", "dict", "emoji", etc.\n});\n\nIntl.supportedValuesOf("currency").forEach((currency) => {\n  // "ADP", "AED", "AFA", "AFN", "ALK", "ALL", "AMD", etc.\n});\n\nIntl.supportedValuesOf("numberingSystem").forEach((numberingSystem) => {\n  // "adlm", "ahom", "arab", "arabext", "bali", etc.\n});\n\nIntl.supportedValuesOf("timeZone").forEach((timeZone) => {\n  // "Africa/Abidjan", "Africa/Accra", "Africa/Addis_Ababa", "Africa/Algiers", etc.\n});\n\nIntl.supportedValuesOf("unit").forEach((unit) => {\n  // "acre", "bit", "byte", "celsius", "centimeter", etc.\n});\n```\n\n### Invalid key throws RangeError\n\n```js\ntry {\n  Intl.supportedValuesOf("someInvalidKey");\n} catch (err) {\n  //Error: RangeError: invalid key: "someInvalidKey"\n}\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Intl.supportedValuesOf` in FormatJS](https://github.com/formatjs/formatjs/tree/main/packages/intl-enumerator)\n- {{jsxref("Intl")}}\n'
        }
    },
    "isfinite": {
        "index.md": '---\ntitle: isFinite()\nslug: Web/JavaScript/Reference/Global_Objects/isFinite\npage-type: javascript-function\nbrowser-compat: javascript.builtins.isFinite\n---\n\n{{jsSidebar("Objects")}}\n\nThe **`isFinite()`** function determines whether a value is finite, first converting the value to a number if necessary. A finite number is one that\'s not {{jsxref("NaN")}} or \xb1{{jsxref("Infinity")}}. Because coercion inside the `isFinite()` function can be [surprising](/en-US/docs/Web/JavaScript/Reference/Global_Objects/isNaN#description), you may prefer to use {{jsxref("Number.isFinite()")}}.\n\n{{EmbedInteractiveExample("pages/js/globalprops-isfinite.html")}}\n\n## Syntax\n\n```js-nolint\nisFinite(value)\n```\n\n### Parameters\n\n- `value`\n  - : The value to be tested.\n\n### Return value\n\n`false` if the given value is {{jsxref("NaN")}}, {{jsxref("Infinity")}}, or `-Infinity` after being [converted to a number](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number#number_coercion); otherwise, `true`.\n\n## Description\n\n`isFinite()` is a function property of the global object.\n\nWhen the argument to the `isFinite()` function is not of type [Number](/en-US/docs/Web/JavaScript/Data_structures#number_type), the value is first coerced to a number, and the resulting value is then compared against `NaN` and \xb1Infinity. This is as confusing as the behavior of {{jsxref("isNaN")}} \u2014 for example, `isFinite("1")` is `true`.\n\n{{jsxref("Number.isFinite()")}} is a more reliable way to test whether a value is a finite number value, because it returns `false` for any non-number input.\n\n## Examples\n\n### Using isFinite()\n\n```js\nisFinite(Infinity); // false\nisFinite(NaN); // false\nisFinite(-Infinity); // false\n\nisFinite(0); // true\nisFinite(2e64); // true\nisFinite(910); // true\n\n// Would\'ve been false with the more robust Number.isFinite():\nisFinite(null); // true\nisFinite("0"); // true\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Number.isFinite()")}}\n- {{jsxref("Number.NaN")}}\n- {{jsxref("Number.POSITIVE_INFINITY")}}\n- {{jsxref("Number.NEGATIVE_INFINITY")}}\n'
    },
    "isnan": {
        "index.md": '---\ntitle: isNaN()\nslug: Web/JavaScript/Reference/Global_Objects/isNaN\npage-type: javascript-function\nbrowser-compat: javascript.builtins.isNaN\n---\n\n{{jsSidebar("Objects")}}\n\nThe **`isNaN()`** function determines whether a value is {{jsxref("NaN")}}, first converting the value to a number if necessary. Because coercion inside the `isNaN()` function can be [surprising](#description), you may prefer to use {{jsxref("Number.isNaN()")}}.\n\n{{EmbedInteractiveExample("pages/js/globalprops-isnan.html")}}\n\n## Syntax\n\n```js-nolint\nisNaN(value)\n```\n\n### Parameters\n\n- `value`\n  - : The value to be tested.\n\n### Return value\n\n`true` if the given value is {{jsxref("NaN")}} after being [converted to a number](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number#number_coercion); otherwise, `false`.\n\n## Description\n\n`isNaN()` is a function property of the global object.\n\nFor number values, `isNaN()` tests if the number is the value [`NaN`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/NaN). When the argument to the `isNaN()` function is not of type [Number](/en-US/docs/Web/JavaScript/Data_structures#number_type), the value is first coerced to a number, and the resulting value is then compared against {{jsxref("NaN")}}.\n\nThis behavior of `isNaN()` for non-numeric arguments can be confusing! For example, an empty string is coerced to 0, while a boolean is coerced to 0 or 1; both values are intuitively "not numbers", but they don\'t evaluate to `NaN`, so `isNaN()` returns `false`. Therefore, `isNaN()` answers neither the question "is the input the floating point {{jsxref("NaN")}} value" nor the question "is the input not a number".\n\n{{jsxref("Number.isNaN()")}} is a more reliable way to test whether a value is the number value `NaN` or not. Alternatively, the expression `x !== x` can be used, and neither of the solutions is subject to the false positives that make the global `isNaN()` unreliable. To test if a value is a number, use [`typeof x === "number"`](/en-US/docs/Web/JavaScript/Reference/Operators/typeof).\n\nThe `isNaN()` function answers the question "is the input functionally equivalent to {{jsxref("NaN")}} when used in a number context". If `isNaN(x)` returns `false`, you can use `x` in an arithmetic expression as if it\'s a valid number that\'s not `NaN`. If `isNaN(x)` returns `true`, `x` will get coerced to `NaN` and make most arithmetic expressions return `NaN` (because `NaN` propagates). You can use this, for example, to test whether an argument to a function is arithmetically processable (usable "like" a number), and handle values that are not number-like by throwing an error, providing a default value, etc. This way, you can have a function that makes use of the full versatility JavaScript provides by implicitly converting values depending on context.\n\n> **Note:** The [`+` operator](/en-US/docs/Web/JavaScript/Reference/Operators/Addition) performs both number addition and string concatenation. Therefore, even if `isNaN()` returns `false` for both operands, the `+` operator may still return a string, because it\'s not used as an arithmetic operator. For example, `isNaN("1")` returns `false`, but `"1" + 1` returns `"11"`. To be sure that you are working with numbers, [coerce the value to a number](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number#number_coercion) and use {{jsxref("Number.isNaN()")}} to test the result.\n\n## Examples\n\nNote how `isNaN()` returns `true` for values that are not the value `NaN` but are not numbers either:\n\n```js\nisNaN(NaN); // true\nisNaN(undefined); // true\nisNaN({}); // true\n\nisNaN(true); // false\nisNaN(null); // false\nisNaN(37); // false\n\n// Strings\nisNaN("37"); // false: "37" is converted to the number 37 which is not NaN\nisNaN("37.37"); // false: "37.37" is converted to the number 37.37 which is not NaN\nisNaN("37,5"); // true\nisNaN("123ABC"); // true: Number("123ABC") is NaN\nisNaN(""); // false: the empty string is converted to 0 which is not NaN\nisNaN(" "); // false: a string with spaces is converted to 0 which is not NaN\n\n// Dates\nisNaN(new Date()); // false; Date objects can be converted to a number (timestamp)\nisNaN(new Date().toString()); // true; the string representation of a Date object cannot be parsed as a number\n\n// Arrays\nisNaN([]); // false; the primitive representation is "", which coverts to the number 0\nisNaN([1]); // false; the primitive representation is "1"\nisNaN([1, 2]); // true; the primitive representation is "1,2", which cannot be parsed as number\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("NaN")}}\n- {{jsxref("Number.isNaN()")}}\n'
    },
    "iterator": {
        "@@iterator": {
            "index.md": '---\ntitle: Iterator.prototype[@@iterator]()\nslug: Web/JavaScript/Reference/Global_Objects/Iterator/@@iterator\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Iterator.@@iterator\n---\n\n{{JSRef}}\n\nThe **`[@@iterator]()`** method of {{jsxref("Iterator")}} instances implements the [iterable protocol](/en-US/docs/Web/JavaScript/Reference/Iteration_protocols) and allows built-in iterators to be consumed by most syntaxes expecting iterables, such as the [spread syntax](/en-US/docs/Web/JavaScript/Reference/Operators/Spread_syntax) and {{jsxref("Statements/for...of", "for...of")}} loops. It returns the value of [`this`](/en-US/docs/Web/JavaScript/Reference/Operators/this), which is the iterator object itself.\n\n## Syntax\n\n```js-nolint\niterator[Symbol.iterator]()\n```\n\n### Parameters\n\nNone.\n\n### Return value\n\nThe value of [`this`](/en-US/docs/Web/JavaScript/Reference/Operators/this), which is the iterator object itself.\n\n## Examples\n\n### Iteration using for...of loop\n\nNote that you seldom need to call this method directly. The existence of the `@@iterator` method makes built-in iterators [iterable](/en-US/docs/Web/JavaScript/Reference/Iteration_protocols#the_iterable_protocol), and iterating syntaxes like the `for...of` loop automatically call this method to obtain the iterator to loop over.\n\n```js\nconst arrIterator = [1, 2, 3].values();\nfor (const value of arrIterator) {\n  console.log(value);\n}\n// Logs: 1, 2, 3\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Iterator")}}\n- {{jsxref("Symbol.iterator")}}\n- [Iteration protocols](/en-US/docs/Web/JavaScript/Reference/Iteration_protocols)\n'
        },
        "drop": {
            "index.md": '---\ntitle: Iterator.prototype.drop()\nslug: Web/JavaScript/Reference/Global_Objects/Iterator/drop\npage-type: javascript-instance-method\nstatus:\n  - experimental\nbrowser-compat: javascript.builtins.Iterator.drop\n---\n\n{{JSRef}}{{SeeCompatTable}}\n\nThe **`drop()`** method of {{jsxref("Iterator")}} instances returns a new [iterator helper](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Iterator#iterator_helpers) that skips the given number of elements at the start of this iterator.\n\n## Syntax\n\n```js-nolint\ndrop(limit)\n```\n\n### Parameters\n\n- `limit`\n  - : The number of elements to drop from the start of the iteration.\n\n### Return value\n\nA new [iterator helper](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Iterator#iterator_helpers). The first time the returned iterator helper\'s `next()` method is called, the current iterator is immediately advanced by `limit` elements, and then the next element (the `limit+1`-th element) is yielded. The iterator helper then yields the remaining elements one-by-one. If the current iterator has fewer than `limit` elements, the new iterator helper will be immediately completed the first time `next()` is called.\n\n### Exceptions\n\n- {{jsxref("RangeError")}}\n  - : Thrown if `limit` becomes {{jsxref("NaN")}} or negative when [converted to an integer](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number#integer_conversion).\n\n## Examples\n\n### Using drop()\n\nThe following example creates an iterator that yields terms in the Fibonacci sequence, starting from the 3rd term by dropping the first two terms:\n\n```js\nfunction* fibonacci() {\n  let current = 1;\n  let next = 1;\n  while (true) {\n    yield current;\n    [current, next] = [next, current + next];\n  }\n}\n\nconst seq = fibonacci().drop(2);\nconsole.log(seq.next().value); // 2\nconsole.log(seq.next().value); // 3\n```\n\nThis is equivalent to:\n\n```js\nconst seq = fibonacci();\nseq.next();\nseq.next();\n```\n\n### Using drop() with a for...of loop\n\n`drop()` is most convenient when you are not hand-rolling the iterator. Because iterators are also iterable, you can iterate the returned helper with a {{jsxref("Statements/for...of", "for...of")}} loop:\n\n```js\nfor (const n of fibonacci().drop(2)) {\n  console.log(n);\n  if (n > 30) {\n    break;\n  }\n}\n\n// Logs:\n// 2\n// 3\n// 5\n// 8\n// 13\n// 21\n// 34\n```\n\n### Combining drop() with take()\n\nYou can combine `drop()` with {{jsxref("Iterator.prototype.take()")}} to get a slice of an iterator:\n\n```js\nfor (const n of fibonacci().drop(2).take(5)) {\n  // Drops the first two elements, then takes the next five\n  console.log(n);\n}\n// Logs:\n// 2\n// 3\n// 5\n// 8\n// 13\n\nfor (const n of fibonacci().take(5).drop(2)) {\n  // Takes the first five elements, then drops the first two\n  console.log(n);\n}\n// Logs:\n// 2\n// 3\n// 5\n```\n\n### Lower and upper bounds of drop count\n\nWhen the `limit` is negative or {{jsxref("NaN")}}, a {{jsxref("RangeError")}} is thrown:\n\n```js\nfibonacci().drop(-1); // RangeError: -1 must be positive\nfibonacci().drop(undefined); // RangeError: undefined must be positive\n```\n\nWhen the `limit` is larger than the total number of elements the iterator can produce (such as {{jsxref("Infinity")}}), the returned iterator helper will instantly drop all elements and then be completed the first time `next()` is called. If the current iterator is infinite, the returned iterator helper will never complete.\n\n```js\nfibonacci().drop(Infinity).next(); // Never ends\nnew Set([1, 2, 3]).values().drop(Infinity).next(); // { value: undefined, done: true }\nnew Set([1, 2, 3]).values().drop(4).next(); // { value: undefined, done: true }\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Iterator.prototype.drop` in `core-js`](https://github.com/zloirock/core-js#iterator-helpers)\n- {{jsxref("Iterator")}}\n- {{jsxref("Iterator.prototype.take()")}}\n'
        },
        "every": {
            "index.md": '---\ntitle: Iterator.prototype.every()\nslug: Web/JavaScript/Reference/Global_Objects/Iterator/every\npage-type: javascript-instance-method\nstatus:\n  - experimental\nbrowser-compat: javascript.builtins.Iterator.every\n---\n\n{{JSRef}}{{SeeCompatTable}}\n\nThe **`every()`** method of {{jsxref("Iterator")}} instances is similar to {{jsxref("Array.prototype.every()")}}: it tests whether all elements produced by the iterator pass the test implemented by the provided function. It returns a boolean value.\n\n## Syntax\n\n```js-nolint\nevery(callbackFn)\n```\n\n### Parameters\n\n- `callbackFn`\n  - : A function to execute for each element produced by the iterator. It should return a [truthy](/en-US/docs/Glossary/Truthy) value to indicate the element passes the test, and a [falsy](/en-US/docs/Glossary/Falsy) value otherwise. The function is called with the following arguments:\n    - `element`\n      - : The current element being processed.\n    - `index`\n      - : The index of the current element being processed.\n\n### Return value\n\n`true` if `callbackFn` returns a {{Glossary("truthy")}} value for every element. Otherwise, `false`.\n\n## Description\n\n`every()` iterates the iterator and invokes the `callbackFn` function once for each element. It returns `false` immediately if the callback function returns a falsy value. Otherwise, it iterates until the end of the iterator and returns `true`. If `every()` returns `false`, the underlying iterator is closed by calling its `return()` method.\n\nThe main advantage of iterator helpers over array methods is their ability to work with infinite iterators. With infinite iterators, `every()` returns `false` as soon as the first falsy value is found. If the `callbackFn` always returns a truthy value, the method never returns.\n\n## Examples\n\n### Using every()\n\n```js\nfunction* fibonacci() {\n  let current = 1;\n  let next = 1;\n  while (true) {\n    yield current;\n    [current, next] = [next, current + next];\n  }\n}\n\nconst isEven = (x) => x % 2 === 0;\nconsole.log(fibonacci().every(isEven)); // false\n\nconst isPositive = (x) => x > 0;\nconsole.log(fibonacci().take(10).every(isPositive)); // true\nconsole.log(fibonacci().every(isPositive)); // Never completes\n```\n\nCalling `every()` always closes the underlying iterator, even if the method early-returns. The iterator is never left in a half-way state.\n\n```js\nconst seq = fibonacci();\nconsole.log(seq.every(isEven)); // false\nconsole.log(seq.next()); // { value: undefined, done: true }\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Iterator.prototype.every` in `core-js`](https://github.com/zloirock/core-js#iterator-helpers)\n- {{jsxref("Iterator")}}\n- {{jsxref("Iterator.prototype.find()")}}\n- {{jsxref("Iterator.prototype.some()")}}\n- {{jsxref("Array.prototype.every()")}}\n'
        },
        "filter": {
            "index.md": '---\ntitle: Iterator.prototype.filter()\nslug: Web/JavaScript/Reference/Global_Objects/Iterator/filter\npage-type: javascript-instance-method\nstatus:\n  - experimental\nbrowser-compat: javascript.builtins.Iterator.filter\n---\n\n{{JSRef}}{{SeeCompatTable}}\n\nThe **`filter()`** method of {{jsxref("Iterator")}} instances returns a new [iterator helper](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Iterator#iterator_helpers) that yields only those elements of the iterator for which the provided callback function returns `true`.\n\n## Syntax\n\n```js-nolint\nfilter(callbackFn)\n```\n\n### Parameters\n\n- `callbackFn`\n  - : A function to execute for each element produced by the iterator. It should return a [truthy](/en-US/docs/Glossary/Truthy) value to make the element yielded by the iterator helper, and a [falsy](/en-US/docs/Glossary/Falsy) value otherwise. The function is called with the following arguments:\n    - `element`\n      - : The current element being processed.\n    - `index`\n      - : The index of the current element being processed.\n\n### Return value\n\nA new [iterator helper](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Iterator#iterator_helpers). Each time the iterator helper\'s `next()` method is called, it returns the next element in the iterator for which the callback function returns `true`. When the underlying iterator is completed, the iterator helper is also completed (the `next()` method produces `{ value: undefined, done: true }`).\n\n## Description\n\nThe main advantage of iterator helpers over array methods is their ability to work with infinite iterators. With infinite iterators, `filter()` allows you to iterate over only those elements that satisfy a given condition.\n\n## Examples\n\n### Using filter()\n\nThe following example creates an iterator that yields terms in the Fibonacci sequence, and then reads the first few terms that are even:\n\n```js\nfunction* fibonacci() {\n  let current = 1;\n  let next = 1;\n  while (true) {\n    yield current;\n    [current, next] = [next, current + next];\n  }\n}\n\nconst seq = fibonacci().filter((x) => x % 2 === 0);\nconsole.log(seq.next().value); // 2\nconsole.log(seq.next().value); // 8\nconsole.log(seq.next().value); // 34\n```\n\n### Using filter() with a for...of loop\n\n`filter()` is most convenient when you are not hand-rolling the iterator. Because iterators are also iterable, you can iterate the returned helper with a {{jsxref("Statements/for...of", "for...of")}} loop:\n\n```js\nfor (const n of fibonacci().filter((x) => x % 2 === 0)) {\n  console.log(n);\n  if (n > 30) {\n    break;\n  }\n}\n\n// Logs:\n// 2\n// 8\n// 34\n```\n\nThis is equivalent to:\n\n```js\nfor (const n of fibonacci()) {\n  if (n % 2 !== 0) {\n    continue;\n  }\n  console.log(n);\n  if (n > 30) {\n    break;\n  }\n}\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Iterator.prototype.filter` in `core-js`](https://github.com/zloirock/core-js#iterator-helpers)\n- {{jsxref("Iterator")}}\n- {{jsxref("Iterator.prototype.forEach()")}}\n- {{jsxref("Iterator.prototype.every()")}}\n- {{jsxref("Iterator.prototype.map()")}}\n- {{jsxref("Iterator.prototype.some()")}}\n- {{jsxref("Iterator.prototype.reduce()")}}\n- {{jsxref("Array.prototype.filter()")}}\n'
        },
        "find": {
            "index.md": '---\ntitle: Iterator.prototype.find()\nslug: Web/JavaScript/Reference/Global_Objects/Iterator/find\npage-type: javascript-instance-method\nstatus:\n  - experimental\nbrowser-compat: javascript.builtins.Iterator.find\n---\n\n{{JSRef}}{{SeeCompatTable}}\n\nThe **`find()`** method of {{jsxref("Iterator")}} instances is similar to {{jsxref("Array.prototype.find()")}}: it returns the first element produced by the iterator that satisfies the provided testing function. If no values satisfy the testing function, {{jsxref("undefined")}} is returned.\n\n## Syntax\n\n```js-nolint\nfind(callbackFn)\n```\n\n### Parameters\n\n- `callbackFn`\n  - : A function to execute for each element produced by the iterator. It should return a [truthy](/en-US/docs/Glossary/Truthy) value to indicate a matching element has been found, and a [falsy](/en-US/docs/Glossary/Falsy) value otherwise. The function is called with the following arguments:\n    - `element`\n      - : The current element being processed.\n    - `index`\n      - : The index of the current element being processed.\n\n### Return value\n\nThe first element produced by the iterator that satisfies the provided testing function. Otherwise, {{jsxref("undefined")}} is returned.\n\n## Description\n\n`find()` iterates the iterator and invokes the `callbackFn` function once for each element. It returns the element immediately if the callback function returns a truthy value. Otherwise, it iterates until the end of the iterator and returns `undefined`. If `find()` returns an element, the underlying iterator is closed by calling its `return()` method.\n\nThe main advantage of iterator helpers over array methods is their ability to work with infinite iterators. With infinite iterators, `find()` returns the first satisfying element as soon as it is found. If the `callbackFn` always returns a falsy value, the method never returns.\n\n## Examples\n\n### Using find()\n\n```js\nfunction* fibonacci() {\n  let current = 1;\n  let next = 1;\n  while (true) {\n    yield current;\n    [current, next] = [next, current + next];\n  }\n}\n\nconst isEven = (x) => x % 2 === 0;\nconsole.log(fibonacci().find(isEven)); // 2\n\nconst isNegative = (x) => x < 0;\nconsole.log(fibonacci().take(10).find(isNegative)); // undefined\nconsole.log(fibonacci().find(isNegative)); // Never completes\n```\n\nCalling `find()` always closes the underlying iterator, even if the method early-returns. The iterator is never left in a half-way state.\n\n```js\nconst seq = fibonacci();\nconsole.log(seq.find(isEven)); // 2\nconsole.log(seq.next()); // { value: undefined, done: true }\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Iterator.prototype.find` in `core-js`](https://github.com/zloirock/core-js#iterator-helpers)\n'
        },
        "flatmap": {
            "index.md": '---\ntitle: Iterator.prototype.flatMap()\nslug: Web/JavaScript/Reference/Global_Objects/Iterator/flatMap\npage-type: javascript-instance-method\nstatus:\n  - experimental\nbrowser-compat: javascript.builtins.Iterator.flatMap\n---\n\n{{JSRef}}{{SeeCompatTable}}\n\nThe **`flatMap()`** method of {{jsxref("Iterator")}} instances returns a new [iterator helper](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Iterator#iterator_helpers) that takes each element in the original iterator, runs it through a mapping function, and yields elements returned by the mapping function (which are contained in another iterator or iterable).\n\n## Syntax\n\n```js-nolint\nflatMap(callbackFn)\n```\n\n### Parameters\n\n- `callbackFn`\n  - : A function to execute for each element produced by the iterator. It should return an iterator or iterable that yields elements to be yielded by `flatMap()`, or a single non-iterator/iterable value to be yielded. The function is called with the following arguments:\n    - `element`\n      - : The current element being processed in the array.\n    - `index`\n      - : The index of the current element being processed in the array.\n\n### Return value\n\nA new [iterator helper](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Iterator#iterator_helpers). The first time the iterator helper\'s `next()` method is called, it calls `callbackFn` on the first element produced by the underlying iterator, and the return value, which should be an iterator or iterable, is yielded one-by-one by the iterator helper (like {{jsxref("Operators/yield*", "yield*")}}). The next element is fetched from the underlying iterator when the previous one returned by `callbackFn` is completed. When the underlying iterator is completed, the iterator helper is also completed (the `next()` method produces `{ value: undefined, done: true }`).\n\n### Exceptions\n\n- {{jsxref("TypeError")}}\n  - : Thrown if `callbackFn` returns a non-iterator/iterable value or a string primitive.\n\n## Description\n\n`flatMap` accepts two kinds of return values from `callbackFn`: an iterator or iterable. They are handled in the same way as {{jsxref("Iterator.from()")}}: if the return value is iterable, the `@@iterator` method is called and the return value is used; otherwise, the return value is treated as an iterator and its `next()` method is called.\n\n```js\n[1, 2, 3]\n  .values()\n  .flatMap((x) => {\n    let itDone = false;\n    const it = {\n      next() {\n        if (itDone) {\n          return { value: undefined, done: true };\n        }\n        itDone = true;\n        return { value: x, done: false };\n      },\n    };\n    switch (x) {\n      case 1:\n        // An iterable that\'s not an iterator\n        return { [Symbol.iterator]: () => it };\n      case 2:\n        // An iterator that\'s not an iterable\n        return it;\n      case 3:\n        // An iterable iterator is treated as an iterable\n        return {\n          ...it,\n          [Symbol.iterator]() {\n            console.log("@@iterator called");\n            return it;\n          },\n        };\n    }\n  })\n  .toArray();\n// Logs "@@iterator called"\n// Returns [1, 2, 3]\n```\n\n## Examples\n\n### Merging maps\n\nThe following example merges two {{jsxref("Map")}} objects into one:\n\n```js\nconst map1 = new Map([\n  ["a", 1],\n  ["b", 2],\n  ["c", 3],\n]);\nconst map2 = new Map([\n  ["d", 4],\n  ["e", 5],\n  ["f", 6],\n]);\n\nconst merged = new Map([map1, map2].values().flatMap((x) => x));\nconsole.log(merged.get("a")); // 1\nconsole.log(merged.get("e")); // 5\n```\n\nThis avoids creating any temporary copies of the map\'s content. Note that the array `[map1, map2]` must first be converted to an iterator (using {{jsxref("Array.prototype.values()")}}), because {{jsxref("Array.prototype.flatMap()")}} only flattens arrays, not iterables.\n\n```js\nnew Map([map1, map2].flatMap((x) => x)); // Map(1) {undefined => undefined}\n```\n\n### Returning strings\n\nStrings are iterable, but `flatMap()` specifically rejects string primitives returned from `callbackFn`, this is because the behavior of iterating by code points is often not what you want.\n\n```js example-bad\n[1, 2, 3]\n  .values()\n  .flatMap((x) => String(x))\n  .toArray(); // TypeError: Iterator.prototype.flatMap called on non-object\n```\n\nYou may want to wrap it in an array instead so the entire string is yielded as one:\n\n```js\n[1, 2, 3]\n  .values()\n  .flatMap((x) => [String(x)])\n  .toArray(); // [\'1\', \'2\', \'3\']\n```\n\nOr, if the behavior of iterating by code points is intended, you can use {{jsxref("Iterator.from()")}} to convert it to a proper iterator:\n\n```js\n[1, 2, 3]\n  .values()\n  .flatMap((x) => Iterator.from(String(x * 10)))\n  .toArray();\n// [\'1\', \'0\', \'2\', \'0\', \'3\', \'0\']\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Iterator.prototype.flatMap` in `core-js`](https://github.com/zloirock/core-js#iterator-helpers)\n'
        },
        "foreach": {
            "index.md": '---\ntitle: Iterator.prototype.forEach()\nslug: Web/JavaScript/Reference/Global_Objects/Iterator/forEach\npage-type: javascript-instance-method\nstatus:\n  - experimental\nbrowser-compat: javascript.builtins.Iterator.forEach\n---\n\n{{JSRef}}{{SeeCompatTable}}\n\nThe **`forEach()`** method of {{jsxref("Iterator")}} instances is similar to {{jsxref("Array.prototype.forEach()")}}: it executes a provided function once for each element produced by the iterator.\n\n## Syntax\n\n```js-nolint\nforEach(callbackFn)\n```\n\n### Parameters\n\n- `callbackFn`\n  - : A function to execute for each element produced by the iterator. Its return value is discarded. The function is called with the following arguments:\n    - `element`\n      - : The current element being processed.\n    - `index`\n      - : The index of the current element being processed.\n\n### Return value\n\n{{jsxref("undefined")}}.\n\n## Description\n\n`forEach()` iterates the iterator and invokes the `callbackFn` function once for each element. Unlike most other iterator helper methods, it does not work well with infinite iterators, because it is not lazy.\n\n## Examples\n\n### Using forEach()\n\n```js\nnew Set([1, 2, 3]).values().forEach((v) => console.log(v));\n\n// Logs:\n// 1\n// 2\n// 3\n```\n\nThis is equivalent to:\n\n```js\nfor (const v of new Set([1, 2, 3]).values()) {\n  console.log(v);\n}\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Iterator.prototype.forEach` in `core-js`](https://github.com/zloirock/core-js#iterator-helpers)\n- {{jsxref("Iterator")}}\n- {{jsxref("Iterator.prototype.find()")}}\n- {{jsxref("Iterator.prototype.map()")}}\n- {{jsxref("Iterator.prototype.filter()")}}\n- {{jsxref("Iterator.prototype.every()")}}\n- {{jsxref("Iterator.prototype.some()")}}\n- {{jsxref("Array.prototype.forEach()")}}\n'
        },
        "from": {
            "index.md": '---\ntitle: Iterator.from()\nslug: Web/JavaScript/Reference/Global_Objects/Iterator/from\npage-type: javascript-static-method\nstatus:\n  - experimental\nbrowser-compat: javascript.builtins.Iterator.from\n---\n\n{{JSRef}}{{SeeCompatTable}}\n\nThe **`Iterator.from()`** static method creates a new {{jsxref("Iterator")}} object from an iterator or iterable object.\n\n## Syntax\n\n```js-nolint\nfrom(object)\n```\n\n### Parameters\n\n- `object`\n  - : An object that implements the [iterable](/en-US/docs/Web/JavaScript/Reference/Iteration_protocols#the_iterable_protocol) protocol or the [iterator](/en-US/docs/Web/JavaScript/Reference/Iteration_protocols#the_iterator_protocol) protocol.\n\n### Return value\n\nIf `object` is an iterable, its `@@iterator` method is called to obtain the iterator. Otherwise, `object` is assumed to be an iterator. If the iterator is already {{jsxref("Operators/instanceof", "instanceof")}} {{jsxref("Iterator")}} (which means it has `Iterator.prototype` in its prototype chain), it is returned directly. Otherwise, a new {{jsxref("Iterator")}} object is created that wraps the original iterator.\n\n## Description\n\nThis method exists to convert custom iterators, probably exported by libraries, to [proper iterators](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Iterator#proper_iterators). All iterator objects returned by `Iterator.from()` inherit from a common prototype object, which has the following methods:\n\n- `next()`\n  - : Calls the underlying iterator\'s `next()` method and returns the result.\n- `return()`\n  - : Calls the underlying iterator\'s `return()` method and returns the result, or returns `{ value: undefined, done: true }` if the underlying iterator doesn\'t have a `return()` method.\n\n## Examples\n\n### Converting an iterable to a proper iterator\n\nBecause `obj` is already an iterable that returns a proper iterator when its `@@iterator` method is called, `Iterator.from(obj)` returns the same iterator.\n\n```js\nconst iterator = (function* () {\n  yield 1;\n  yield 2;\n  yield 3;\n})();\n\nconst obj = {\n  [Symbol.iterator]() {\n    return iterator;\n  },\n};\n\nconst iterator2 = Iterator.from(obj);\nconsole.log(iterator2 === iterator); // true\n```\n\nBecause `obj2` is an iterable that returns a non-proper iterator when its `@@iterator` method is called, `Iterator.from(obj2)` returns a new iterator that wraps the original iterator.\n\n```js\nconst iterator = {\n  current: 0,\n  next() {\n    return { value: this.current++, done: false };\n  },\n};\n\nconst obj2 = {\n  [Symbol.iterator]() {\n    return iterator;\n  },\n};\n\nconst iterator2 = Iterator.from(obj2);\nconsole.log(iterator2 === iterator); // false\nconsole.log(iterator2.next()); // { value: 0, done: false }\nconsole.log(iterator.next()); // { value: 1, done: false }\n```\n\n### Converting an iterator to a proper iterator\n\nBecause `obj` is already a proper iterator, `Iterator.from(obj)` returns itself.\n\n```js\nconst obj = (function* () {\n  yield 1;\n  yield 2;\n  yield 3;\n})();\n\nconst iterator = Iterator.from(obj);\nconsole.log(iterator === obj); // true\n```\n\nBecause `obj2` is a non-proper iterator, `Iterator.from(obj2)` returns a new iterator that wraps the original iterator.\n\n```js\nconst obj2 = {\n  current: 0,\n  next() {\n    return { value: this.current++, done: false };\n  },\n};\n\nconst iterator = Iterator.from(obj2);\nconsole.log(iterator === obj2); // false\nconsole.log(iterator.next()); // { value: 0, done: false }\nconsole.log(obj2.next()); // { value: 1, done: false }\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Iterator.from` in `core-js`](https://github.com/zloirock/core-js#iterator-helpers)\n- {{jsxref("Iterator")}}\n- {{jsxref("Array.from()")}}\n'
        },
        "index.md": '---\ntitle: Iterator\nslug: Web/JavaScript/Reference/Global_Objects/Iterator\npage-type: javascript-class\nbrowser-compat: javascript.builtins.Iterator\n---\n\n{{JSRef}}\n\nAn **`Iterator`** object is an object that conforms to the [iterator protocol](/en-US/docs/Web/JavaScript/Reference/Iteration_protocols#the_iterator_protocol) by providing a `next()` method that returns an iterator result object. All built-in iterators inherit from the `Iterator` class. The `Iterator` class provides a [`@@iterator`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Iterator/@@iterator) method that returns the iterator object itself, making the iterator also [iterable](/en-US/docs/Web/JavaScript/Reference/Iteration_protocols#the_iterable_protocol). It also provides some helper methods for working with iterators.\n\n## Description\n\nThe following are all built-in JavaScript iterators:\n\n- The _Array Iterator_ returned by {{jsxref("Array.prototype.values()")}}, {{jsxref("Array.prototype.keys()")}}, {{jsxref("Array.prototype.entries()")}}, [`Array.prototype[@@iterator]()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/@@iterator), {{jsxref("TypedArray.prototype.values()")}}, {{jsxref("TypedArray.prototype.keys()")}}, {{jsxref("TypedArray.prototype.entries()")}}, [`TypedArray.prototype[@@iterator]()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/TypedArray/@@iterator), and [`arguments[@@iterator]()`](/en-US/docs/Web/JavaScript/Reference/Functions/arguments/@@iterator).\n- The _String Iterator_ returned by [`String.prototype[@@iterator]()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/@@iterator).\n- The _Map Iterator_ returned by {{jsxref("Map.prototype.values()")}}, {{jsxref("Map.prototype.keys()")}}, {{jsxref("Map.prototype.entries()")}}, and [`Map.prototype[@@iterator]()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map/@@iterator).\n- The _Set Iterator_ returned by {{jsxref("Set.prototype.values()")}}, {{jsxref("Set.prototype.keys()")}}, {{jsxref("Set.prototype.entries()")}}, and [`Set.prototype[@@iterator]()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Set/@@iterator).\n- The _RegExp String Iterator_ returned by [`RegExp.prototype[@@matchAll]()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/@@matchAll) and {{jsxref("String.prototype.matchAll()")}}.\n- The {{jsxref("Generator")}} object returned by [generator functions](/en-US/docs/Web/JavaScript/Reference/Statements/function*).\n- The _Segments Iterator_ returned by the [`[@@iterator]()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Segmenter/segment/Segments/@@iterator) method of the [`Segments`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Segmenter/segment/Segments) object returned by [`Intl.Segmenter.prototype.segment()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Segmenter/segment).\n- The _Iterator Helper_ returned by iterator helper methods such as {{jsxref("Iterator.prototype.filter()")}} and {{jsxref("Iterator.prototype.map()")}}.\n\nEach of these iterators have a distinct prototype object, which defines the `next()` method used by the particular iterator. For example, all string iterator objects inherit from a hidden object `StringIteratorPrototype`, which has a `next()` method that iterates this string by code points. `StringIteratorPrototype` also has a [`@@toStringTag`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol/toStringTag) property whose initial value is the string `"String Iterator"`. This property is used in {{jsxref("Object.prototype.toString()")}}. Similarly, other iterator prototypes also have their own `@@toStringTag` values, which are the same as the names given above.\n\nAll of these prototype objects inherit from `Iterator.prototype`, which provides a [`@@iterator`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol/iterator) method that returns the iterator object itself, making the iterator also [iterable](/en-US/docs/Web/JavaScript/Reference/Iteration_protocols#the_iterable_protocol).\n\n### Iterator helpers\n\n> **Note:** These methods are _iterator_ helpers, not _iterable_ helpers, because the only requirement for an object to be iterable is just the presence of a `@@iterator` method. There is no shared prototype to install these methods on.\n\nThe `Iterator` class itself provides some helper methods for working with iterators. For example, you may be tempted to do the following:\n\n```js\nconst nameToDeposit = new Map([\n  ["Anne", 1000],\n  ["Bert", 1500],\n  ["Carl", 2000],\n]);\n\nconst totalDeposit = [...nameToDeposit.values()].reduce((a, b) => a + b);\n```\n\nThis first converts the iterator returned by {{jsxref("Map.prototype.values()")}} to an array, then uses the {{jsxref("Array.prototype.reduce()")}} method to calculate the sum. However, this both creates an intermediate array and iterates the array twice. Instead, you can use the `reduce()` method of the iterator itself:\n\n```js\nconst totalDeposit = nameToDeposit.values().reduce((a, b) => a + b);\n```\n\nThis method is more efficient, because it only iterates the iterator once, without memorizing any intermediate values. Iterator helper methods are necessary to work with infinite iterators:\n\n```js\nfunction* fibonacci() {\n  let current = 1;\n  let next = 1;\n  while (true) {\n    yield current;\n    [current, next] = [next, current + next];\n  }\n}\n\nconst seq = fibonacci();\nconst firstThreeDigitTerm = seq.find((n) => n >= 100);\n```\n\nYou cannot convert `seq` to an array, because it is infinite. Instead, you can use the `find()` method of the iterator itself, which only iterates `seq` as far as necessary to find the first value that satisfies the condition.\n\nYou will find many iterator methods analogous to array methods, such as:\n\n| Iterator method                            | Array method                            |\n| ------------------------------------------ | --------------------------------------- |\n| {{jsxref("Iterator.prototype.every()")}}   | {{jsxref("Array.prototype.every()")}}   |\n| {{jsxref("Iterator.prototype.filter()")}}  | {{jsxref("Array.prototype.filter()")}}  |\n| {{jsxref("Iterator.prototype.find()")}}    | {{jsxref("Array.prototype.find()")}}    |\n| {{jsxref("Iterator.prototype.flatMap()")}} | {{jsxref("Array.prototype.flatMap()")}} |\n| {{jsxref("Iterator.prototype.forEach()")}} | {{jsxref("Array.prototype.forEach()")}} |\n| {{jsxref("Iterator.prototype.map()")}}     | {{jsxref("Array.prototype.map()")}}     |\n| {{jsxref("Iterator.prototype.reduce()")}}  | {{jsxref("Array.prototype.reduce()")}}  |\n| {{jsxref("Iterator.prototype.some()")}}    | {{jsxref("Array.prototype.some()")}}    |\n\n{{jsxref("Iterator.prototype.drop()")}} and {{jsxref("Iterator.prototype.take()")}} combined are somewhat analogous to {{jsxref("Array.prototype.slice()")}}.\n\nAmong these methods, {{jsxref("Iterator/filter", "filter()")}}, {{jsxref("Iterator/flatMap", "flatMap()")}}, {{jsxref("Iterator/map", "map()")}}, {{jsxref("Iterator/drop", "drop()")}}, and {{jsxref("Iterator/take", "take()")}} return a new _Iterator Helper_ object. The iterator helper is also an `Iterator` instance, making the helper methods chainable. All iterator helper objects inherit from a common prototype object, which implements the iterator protocol:\n\n- `next()`\n  - : Calls the `next()` method of the underlying iterator, applies the helper method to the result, and returns the result.\n- `return()`\n  - : Calls the `return()` method of the underlying iterator, and returns the result.\n\nThe iterator helper shares the same data source as the underlying iterator, so iterating the iterator helper causes the underlying iterator to be iterated as well. There is no way to "fork" an iterator to allow it to be iterated multiple times.\n\n```js\nconst it = [1, 2, 3].values();\nconst it2 = it.drop(0); // Essentially a copy\nconsole.log(it.next().value); // 1\nconsole.log(it2.next().value); // 2\nconsole.log(it.next().value); // 3\n```\n\n### Proper iterators\n\nThere are two kinds of "iterators": objects that conform to the [iterator protocol](/en-US/docs/Web/JavaScript/Reference/Iteration_protocols#the_iterator_protocol) (which, at its minimum, only requires the presence of a `next()` method), and objects that inherit from the `Iterator` class, which enjoy the helper methods. They do not entail each other \u2014 objects that inherit from `Iterator` do not automatically become iterators, because the `Iterator` class does not define a `next()` method. Instead, the object needs to define a `next()` method itself. A _proper iterator_ is one that both conforms to the iterator protocol and inherits from `Iterator`, and most code expect iterators to be proper iterators and iterables to return proper iterators. To create proper iterators, define a class that extends {{jsxref("Iterator/Iterator", "Iterator")}}, or use the {{jsxref("Iterator.from()")}} method.\n\n```js\nclass MyIterator extends Iterator {\n  next() {\n    // \u2026\n  }\n}\n\nconst myIterator = Iterator.from({\n  next() {\n    // \u2026\n  },\n});\n```\n\n## Constructor\n\n- {{jsxref("Iterator/Iterator", "Iterator()")}} {{experimental_inline}}\n  - : Intended to be [extended](/en-US/docs/Web/JavaScript/Reference/Classes/extends) by other classes that create iterators. Throws an error when constructed by itself.\n\n## Static methods\n\n- {{jsxref("Iterator.from()")}} {{experimental_inline}}\n  - : Creates a new `Iterator` object from an iterator or iterable object.\n\n## Instance properties\n\nThese properties are defined on `Iterator.prototype` and shared by all `Iterator` instances.\n\n- {{jsxref("Object/constructor", "Iterator.prototype.constructor")}}\n  - : The constructor function that created the instance object. For `Iterator` instances, the initial value is the {{jsxref("Iterator/Iterator", "Iterator")}} constructor.\n- `Iterator.prototype[@@toStringTag]`\n\n  - : The initial value of the [`@@toStringTag`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol/toStringTag) property is the string `"Iterator"`. This property is used in {{jsxref("Object.prototype.toString()")}}.\n\n    > **Note:** Unlike the `@@toStringTag` on most built-in classes, `Iterator.prototype[@@toStringTag]` is writable for web compatibility reasons.\n\n## Instance methods\n\n- {{jsxref("Iterator.prototype.drop()")}} {{experimental_inline}}\n  - : Returns a new iterator helper that skips the given number of elements at the start of this iterator.\n- {{jsxref("Iterator.prototype.every()")}} {{experimental_inline}}\n  - : Tests whether all elements produced by the iterator pass the test implemented by the provided function.\n- {{jsxref("Iterator.prototype.filter()")}} {{experimental_inline}}\n  - : Returns a new iterator helper that yields only those elements of the iterator for which the provided callback function returns `true`.\n- {{jsxref("Iterator.prototype.find()")}} {{experimental_inline}}\n  - : Returns the first element produced by the iterator that satisfies the provided testing function. If no values satisfy the testing function, {{jsxref("undefined")}} is returned.\n- {{jsxref("Iterator.prototype.flatMap()")}} {{experimental_inline}}\n  - : Returns a new iterator helper that takes each element in the original iterator, runs it through a mapping function, and yields elements returned by the mapping function (which are contained in another iterator or iterable).\n- {{jsxref("Iterator.prototype.forEach()")}} {{experimental_inline}}\n  - : Executes a provided function once for each element produced by the iterator.\n- {{jsxref("Iterator.prototype.map()")}} {{experimental_inline}}\n  - : Returns a new iterator helper that yields elements of the iterator, each transformed by a mapping function.\n- {{jsxref("Iterator.prototype.reduce()")}} {{experimental_inline}}\n  - : Executes a user-supplied "reducer" callback function on each element produced by the iterator, passing in the return value from the calculation on the preceding element. The final result of running the reducer across all elements is a single value.\n- {{jsxref("Iterator.prototype.some()")}} {{experimental_inline}}\n  - : Tests whether at least one element in the iterator passes the test implemented by the provided function. It returns a boolean value.\n- {{jsxref("Iterator.prototype.take()")}} {{experimental_inline}}\n  - : Returns a new iterator helper that yields the given number of elements in this iterator and then terminates.\n- {{jsxref("Iterator.prototype.toArray()")}} {{experimental_inline}}\n  - : Creates a new {{jsxref("Array")}} instance populated with the elements yielded from the iterator.\n- [`Iterator.prototype[@@iterator]()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Iterator/@@iterator)\n  - : Returns the iterator object itself. This allows iterator objects to also be iterable.\n\n## Examples\n\n### Using an iterator as an iterable\n\nAll built-in iterators are also iterable, so you can use them in a `for...of` loop:\n\n```js\nconst arrIterator = [1, 2, 3].values();\nfor (const value of arrIterator) {\n  console.log(value);\n}\n// Logs: 1, 2, 3\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Iterator` in `core-js`](https://github.com/zloirock/core-js#iterator-helpers)\n- {{jsxref("Statements/function*", "function*")}}\n- [Iteration protocols](/en-US/docs/Web/JavaScript/Reference/Iteration_protocols)\n',
        "iterator": {
            "index.md": '---\ntitle: Iterator() constructor\nslug: Web/JavaScript/Reference/Global_Objects/Iterator/Iterator\npage-type: javascript-constructor\nstatus:\n  - experimental\nbrowser-compat: javascript.builtins.Iterator.Iterator\n---\n\n{{JSRef}}{{SeeCompatTable}}\n\nThe **`Iterator()`** constructor is intended to be used as the [superclass](/en-US/docs/Web/JavaScript/Reference/Classes/extends) of other classes that create iterators. It throws an error when constructed by itself.\n\n## Syntax\n\n```js-nolint\nnew Iterator()\n```\n\n> **Note:** `Iterator()` can only be constructed with [`new`](/en-US/docs/Web/JavaScript/Reference/Operators/new). Attempting to call it without `new` throws a {{jsxref("TypeError")}}. In addition, `Iterator()` cannot actually be constructed itself \u2014 it\'s usually implicitly constructed through [`super()`](/en-US/docs/Web/JavaScript/Reference/Operators/super) calls inside the constructor of a subclass.\n\n### Parameters\n\nNone.\n\n### Return value\n\nA new {{jsxref("Iterator")}} object.\n\n### Exceptions\n\n- {{jsxref("TypeError")}}\n  - : When [`new.target`](/en-US/docs/Web/JavaScript/Reference/Operators/new.target) is the `Iterator` function itself, i.e. when the `Iterator` constructor itself is constructed.\n\n## Description\n\n`Iterator` represents an _abstract class_ \u2014 a class that provides common utilities for its subclasses, but is not intended to be instantiated itself. It is the superclass of all other iterator classes, and is used to create subclasses that implement specific iteration algorithms \u2014 namely, all subclasses of `Iterator` must implement a `next()` method as required by the [iterator protocol](/en-US/docs/Web/JavaScript/Reference/Iteration_protocols#the_iterator_protocol). Because `Iterator` doesn\'t actually provide the `next()` method, it doesn\'t make sense to construct an `Iterator` directly.\n\nYou can also use {{jsxref("Iterator.from()")}} to create an `Iterator` instance from an existing iterable or iterator object.\n\n## Examples\n\n### Subclassing Iterator\n\nThe following example defines a custom data structure, `Range`, which allows iteration. The simplest way to make an object iterable is to provide an [`[@@iterator]()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol/iterator) method in the form of a generator function:\n\n```js\nclass Range {\n  #start;\n  #end;\n  #step;\n\n  constructor(start, end, step = 1) {\n    this.#start = start;\n    this.#end = end;\n    this.#step = step;\n  }\n\n  *[Symbol.iterator]() {\n    for (let value = this.#start; value <= this.#end; value += this.#step) {\n      yield value;\n    }\n  }\n}\n\nconst range = new Range(1, 5);\nfor (const num of range) {\n  console.log(num);\n}\n```\n\nThis works, but it isn\'t as nice as how built-in iterators work. There are two problems:\n\n- The returned iterator inherits from {{jsxref("Generator")}}, which means modifications to `Generator.prototype` are going to affect the returned iterator, which is a leak of abstraction.\n- The returned iterator does not inherit from a custom prototype, which makes it harder if we intend to add extra methods to the iterator.\n\nWe can mimic the implementation of built-in iterators, such as [map iterators](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map/@@iterator), by subclassing `Iterator`. This enables us to define extra properties, such as [`@@toStringTag`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol/toStringTag), while making the iterator helper methods available on the returned iterator.\n\n```js\nclass Range {\n  #start;\n  #end;\n  #step;\n\n  constructor(start, end, step = 1) {\n    this.#start = start;\n    this.#end = end;\n    this.#step = step;\n  }\n\n  static #RangeIterator = class extends Iterator {\n    #cur;\n    #s;\n    #e;\n    constructor(range) {\n      super();\n      this.#cur = range.#start;\n      this.#s = range.#step;\n      this.#e = range.#end;\n    }\n    static {\n      Object.defineProperty(this.prototype, Symbol.toStringTag, {\n        value: "Range Iterator",\n        configurable: true,\n        enumerable: false,\n        writable: false,\n      });\n\n      // Avoid #RangeIterator from being accessible outside\n      delete this.prototype.constructor;\n    }\n    next() {\n      if (this.#cur > this.#e) {\n        return { value: undefined, done: true };\n      }\n      const res = { value: this.#cur, done: false };\n      this.#cur += this.#s;\n      return res;\n    }\n  };\n\n  [Symbol.iterator]() {\n    return new Range.#RangeIterator(this);\n  }\n}\n\nconst range = new Range(1, 5);\nfor (const num of range) {\n  console.log(num);\n}\n```\n\nThe subclassing pattern is useful if you want to create many custom iterators. If you have an existing iterable or iterator object which doesn\'t inherit from `Iterator`, and you just want to call iterator helper methods on it, you can use {{jsxref("Iterator.from()")}} to create a one-time `Iterator` instance.\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Iterator` in `core-js`](https://github.com/zloirock/core-js#iterator-helpers)\n- {{jsxref("Iterator")}}\n- {{jsxref("Iterator.from()")}}\n'
        },
        "map": {
            "index.md": '---\ntitle: Iterator.prototype.map()\nslug: Web/JavaScript/Reference/Global_Objects/Iterator/map\npage-type: javascript-instance-method\nstatus:\n  - experimental\nbrowser-compat: javascript.builtins.Iterator.map\n---\n\n{{JSRef}}{{SeeCompatTable}}\n\nThe **`map()`** method of {{jsxref("Iterator")}} instances returns a new [iterator helper](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Iterator#iterator_helpers) that yields elements of the iterator, each transformed by a mapping function.\n\n## Syntax\n\n```js-nolint\nmap(callbackFn)\n```\n\n### Parameters\n\n- `callbackFn`\n  - : A function to execute for each element produced by the iterator. Its return value is yielded by the iterator helper. The function is called with the following arguments:\n    - `element`\n      - : The current element being processed.\n    - `index`\n      - : The index of the current element being processed.\n\n### Return value\n\nA new [iterator helper](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Iterator#iterator_helpers). Each time the iterator helper\'s `next()` method is called, it gets the next element from the underlying iterator, applies `callbackFn`, and yields the return value. When the underlying iterator is completed, the iterator helper is also completed (the `next()` method produces `{ value: undefined, done: true }`).\n\n## Description\n\nThe main advantage of iterator helpers over array methods is their ability to work with infinite iterators. With infinite iterators, `map()` allows you to create a new iterator that, when iterated, produces transformed elements.\n\n## Examples\n\n### Using map()\n\nThe following example creates an iterator that yields terms in the Fibonacci sequence, transforms it into a new sequence with each term squared, and then reads the first few terms:\n\n```js\nfunction* fibonacci() {\n  let current = 1;\n  let next = 1;\n  while (true) {\n    yield current;\n    [current, next] = [next, current + next];\n  }\n}\n\nconst seq = fibonacci().map((x) => x ** 2);\nconsole.log(seq.next().value); // 1\nconsole.log(seq.next().value); // 1\nconsole.log(seq.next().value); // 4\n```\n\n### Using map() with a for...of loop\n\n`map()` is most convenient when you are not hand-rolling the iterator. Because iterators are also iterable, you can iterate the returned helper with a {{jsxref("Statements/for...of", "for...of")}} loop:\n\n```js\nfor (const n of fibonacci().map((x) => x ** 2)) {\n  console.log(n);\n  if (n > 30) {\n    break;\n  }\n}\n\n// Logs:\n// 1\n// 1\n// 4\n// 9\n// 25\n// 64\n```\n\nThis is equivalent to:\n\n```js\nfor (const n of fibonacci()) {\n  const n2 = n ** 2;\n  console.log(n2);\n  if (n2 > 30) {\n    break;\n  }\n}\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Iterator.prototype.map` in `core-js`](https://github.com/zloirock/core-js#iterator-helpers)\n'
        },
        "reduce": {
            "index.md": '---\ntitle: Iterator.prototype.reduce()\nslug: Web/JavaScript/Reference/Global_Objects/Iterator/reduce\npage-type: javascript-instance-method\nstatus:\n  - experimental\nbrowser-compat: javascript.builtins.Iterator.reduce\n---\n\n{{JSRef}}{{SeeCompatTable}}\n\nThe **`reduce()`** method of {{jsxref("Iterator")}} instances is similar to {{jsxref("Array.prototype.reduce")}}: it executes a user-supplied "reducer" callback function on each element produced by the iterator, passing in the return value from the calculation on the preceding element. The final result of running the reducer across all elements is a single value.\n\n## Syntax\n\n```js-nolint\nreduce(callbackFn)\nreduce(callbackFn, initialValue)\n```\n\n### Parameters\n\n- `callbackFn`\n  - : A function to execute for each element produced by the iterator. Its return value becomes the value of the `accumulator` parameter on the next invocation of `callbackFn`. For the last invocation, the return value becomes the return value of `reduce()`. The function is called with the following arguments:\n    - `accumulator`\n      - : The value resulting from the previous call to `callbackFn`. On the first call, its value is `initialValue` if the latter is specified; otherwise its value is the first element of the iterator.\n    - `currentValue`\n      - : The value of the current element. On the first call, its value is the first element of the iterator if `initialValue` is specified; otherwise its value is the second element.\n    - `currentIndex`\n      - : The index position of `currentValue`. On the first call, its value is `0` if `initialValue` is specified, otherwise `1`.\n- `initialValue` {{optional_inline}}\n  - : A value to which `accumulator` is initialized the first time the callback is called. If `initialValue` is specified, `callbackFn` starts executing with the first element as `currentValue`. If `initialValue` is _not_ specified, `accumulator` is initialized to the first element, and `callbackFn` starts executing with the second element as `currentValue`. In this case, if the iterator is empty (so that there\'s no first value to return as `accumulator`), an error is thrown.\n\n### Return value\n\nThe value that results from running the "reducer" callback function to completion over the entire iterator.\n\n### Exceptions\n\n- {{jsxref("TypeError")}}\n  - : Thrown if the iterator contains no elements and `initialValue` is not provided.\n\n## Description\n\nSee {{jsxref("Array.prototype.reduce()")}} for details about how `reduce()` works. Unlike most other iterator helper methods, it does not work well with infinite iterators, because it is not lazy.\n\n## Examples\n\n### Using reduce()\n\nThe following example creates an iterator that yields terms in the Fibonacci sequence, and then sums the first ten terms:\n\n```js\nfunction* fibonacci() {\n  let current = 1;\n  let next = 1;\n  while (true) {\n    yield current;\n    [current, next] = [next, current + next];\n  }\n}\n\nconsole.log(\n  fibonacci()\n    .take(10)\n    .reduce((a, b) => a + b),\n); // 143\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Iterator.prototype.reduce` in `core-js`](https://github.com/zloirock/core-js#iterator-helpers)\n- {{jsxref("Iterator")}}\n- {{jsxref("Iterator.prototype.map()")}}\n- {{jsxref("Iterator.prototype.flatMap()")}}\n- {{jsxref("Array.prototype.reduce()")}}\n'
        },
        "some": {
            "index.md": '---\ntitle: Iterator.prototype.some()\nslug: Web/JavaScript/Reference/Global_Objects/Iterator/some\npage-type: javascript-instance-method\nstatus:\n  - experimental\nbrowser-compat: javascript.builtins.Iterator.some\n---\n\n{{JSRef}}{{SeeCompatTable}}\n\nThe **`some()`** method of {{jsxref("Iterator")}} instances is similar to {{jsxref("Array.prototype.some()")}}: it tests whether at least one element produced by the iterator passes the test implemented by the provided function. It returns a boolean value.\n\n## Syntax\n\n```js-nolint\nsome(callbackFn)\n```\n\n### Parameters\n\n- `callbackFn`\n  - : A function to execute for each element produced by the iterator. It should return a [truthy](/en-US/docs/Glossary/Truthy) value to indicate the element passes the test, and a [falsy](/en-US/docs/Glossary/Falsy) value otherwise. The function is called with the following arguments:\n    - `element`\n      - : The current element being processed.\n    - `index`\n      - : The index of the current element being processed.\n\n### Return value\n\n`true` if the callback function returns a {{Glossary("truthy")}} value for at least one element. Otherwise, `false`.\n\n## Description\n\n`some()` iterates the iterator and invokes the `callbackFn` function once for each element. It returns `true` immediately if the callback function returns a truthy value. Otherwise, it iterates until the end of the iterator and returns `false`. If `some()` returns `true`, the underlying iterator is closed by calling its `return()` method.\n\nThe main advantage of iterator helpers over array methods is their ability to work with infinite iterators. With infinite iterators, `some()` returns `true` as soon as the first truthy value is found. If the `callbackFn` always returns a falsy value, the method never returns.\n\n## Examples\n\n### Using some()\n\n```js\nfunction* fibonacci() {\n  let current = 1;\n  let next = 1;\n  while (true) {\n    yield current;\n    [current, next] = [next, current + next];\n  }\n}\n\nconst isEven = (x) => x % 2 === 0;\nconsole.log(fibonacci().some(isEven)); // true\n\nconst isNegative = (x) => x < 0;\nconst isPositive = (x) => x > 0;\nconsole.log(fibonacci().take(10).some(isPositive)); // false\nconsole.log(fibonacci().some(isNegative)); // Never completes\n```\n\nCalling `some()` always closes the underlying iterator, even if the method early-returns. The iterator is never left in a half-way state.\n\n```js\nconst seq = fibonacci();\nconsole.log(seq.some(isEven)); // true\nconsole.log(seq.next()); // { value: undefined, done: true }\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Iterator.prototype.some` in `core-js`](https://github.com/zloirock/core-js#iterator-helpers)\n- {{jsxref("Iterator")}}\n- {{jsxref("Iterator.prototype.every()")}}\n- {{jsxref("Iterator.prototype.find()")}}\n- {{jsxref("Array.prototype.some()")}}\n'
        },
        "take": {
            "index.md": '---\ntitle: Iterator.prototype.take()\nslug: Web/JavaScript/Reference/Global_Objects/Iterator/take\npage-type: javascript-instance-method\nstatus:\n  - experimental\nbrowser-compat: javascript.builtins.Iterator.take\n---\n\n{{JSRef}}{{SeeCompatTable}}\n\nThe **`take()`** method of {{jsxref("Iterator")}} instances returns a new [iterator helper](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Iterator#iterator_helpers) that yields the given number of elements in this iterator and then terminates.\n\n## Syntax\n\n```js-nolint\ntake(limit)\n```\n\n### Parameters\n\n- `limit`\n  - : The number of elements to take from the start of the iteration.\n\n### Return value\n\nA new [iterator helper](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Iterator#iterator_helpers). The returned iterator helper yields the elements in the original iterator one-by-one, and then completes (the `next()` method produces `{ value: undefined, done: true }`) once `limit` elements have been yielded, or when the original iterator is exhausted, whichever comes first.\n\n### Exceptions\n\n- {{jsxref("RangeError")}}\n  - : Thrown if `limit` becomes {{jsxref("NaN")}} or negative when [converted to an integer](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number#integer_conversion).\n\n## Examples\n\n### Using take()\n\nThe following example creates an iterator that yields terms in the Fibonacci sequence, and then logs the first three terms:\n\n```js\nfunction* fibonacci() {\n  let current = 1;\n  let next = 1;\n  while (true) {\n    yield current;\n    [current, next] = [next, current + next];\n  }\n}\n\nconst seq = fibonacci().take(3);\nconsole.log(seq.next().value); // 1\nconsole.log(seq.next().value); // 1\nconsole.log(seq.next().value); // 2\nconsole.log(seq.next().value); // undefined\n```\n\n### Using take() with a for...of loop\n\n`take()` is most convenient when you are not hand-rolling the iterator. Because iterators are also iterable, you can iterate the returned helper with a {{jsxref("Statements/for...of", "for...of")}} loop:\n\n```js\nfor (const n of fibonacci().take(5)) {\n  console.log(n);\n}\n\n// Logs:\n// 1\n// 1\n// 2\n// 3\n// 5\n```\n\nBecause `fibonacci()` is an infinite iterator, you can\'t use a `for` loop to iterate it directly.\n\n### Combining drop() with take()\n\nYou can combine `take()` with {{jsxref("Iterator.prototype.drop()")}} to get a slice of an iterator:\n\n```js\nfor (const n of fibonacci().drop(2).take(5)) {\n  // Drops the first two elements, then takes the next five\n  console.log(n);\n}\n// Logs:\n// 2\n// 3\n// 5\n// 8\n// 13\n\nfor (const n of fibonacci().take(5).drop(2)) {\n  // Takes the first five elements, then drops the first two\n  console.log(n);\n}\n// Logs:\n// 2\n// 3\n// 5\n```\n\n### Lower and upper bounds of take count\n\nWhen the `limit` is negative or {{jsxref("NaN")}}, a {{jsxref("RangeError")}} is thrown:\n\n```js\nfibonacci().take(-1); // RangeError: -1 must be positive\nfibonacci().take(undefined); // RangeError: undefined must be positive\n```\n\nWhen the `limit` is larger than the total number of elements the iterator can produce (such as {{jsxref("Infinity")}}), the returned iterator helper has essentially the same behavior as the original iterator:\n\n```js\nfor (const n of new Set([1, 2, 3]).values().take(Infinity)) {\n  console.log(n);\n}\n\n// Logs:\n// 1\n// 2\n// 3\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Iterator.prototype.take` in `core-js`](https://github.com/zloirock/core-js#iterator-helpers)\n- {{jsxref("Iterator")}}\n- {{jsxref("Iterator.prototype.drop()")}}\n'
        },
        "toarray": {
            "index.md": '---\ntitle: Iterator.prototype.toArray()\nslug: Web/JavaScript/Reference/Global_Objects/Iterator/toArray\npage-type: javascript-instance-method\nstatus:\n  - experimental\nbrowser-compat: javascript.builtins.Iterator.toArray\n---\n\n{{JSRef}}{{SeeCompatTable}}\n\nThe **`toArray()`** method of {{jsxref("Iterator")}} instances creates a new {{jsxref("Array")}} instance populated with the elements yielded from the iterator.\n\n## Syntax\n\n```js-nolint\ntoArray()\n```\n\n### Parameters\n\nNone.\n\n### Return value\n\nA new {{jsxref("Array")}} instance containing the elements from the iterator in the order they were produced.\n\n## Examples\n\n### Using toArray()\n\n`iterator.toArray()` is equivalent to `Array.from(iterator)` and `[...iterator]`, except that it\'s easier to chain when multiple iterator helper methods are involved. The following example creates an iterator that yields terms in the Fibonacci sequence, takes the first 10 terms, filters out the odd numbers, and converts the result to an array:\n\n```js\nfunction* fibonacci() {\n  let current = 1;\n  let next = 1;\n  while (true) {\n    yield current;\n    [current, next] = [next, current + next];\n  }\n}\n\nconst array = fibonacci()\n  .take(10)\n  .filter((x) => x % 2 === 0)\n  .toArray();\n\nconsole.log(array); // [2, 8, 34]\n```\n\nNote that it\'s a good idea to call `toArray()` as a last step of your processing. For example, `fibonacci().take(10).toArray().filter(...)` is less efficient, because iterator helpers are lazy and avoids creating a temporary array.\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Iterator.prototype.toArray` in `core-js`](https://github.com/zloirock/core-js#iterator-helpers)\n- {{jsxref("Iterator")}}\n- {{jsxref("Array.from()")}}\n'
        }
    },
    "json": {
        "index.md": '---\ntitle: JSON\nslug: Web/JavaScript/Reference/Global_Objects/JSON\npage-type: javascript-namespace\nbrowser-compat: javascript.builtins.JSON\n---\n\n{{JSRef}}\n\nThe **`JSON`** namespace object contains static methods for parsing values from and converting values to [JavaScript Object Notation](https://json.org/) ({{Glossary("JSON")}}).\n\n## Description\n\nUnlike most global objects, `JSON` is not a constructor. You cannot use it with the [`new` operator](/en-US/docs/Web/JavaScript/Reference/Operators/new) or invoke the `JSON` object as a function. All properties and methods of `JSON` are static (just like the {{jsxref("Math")}} object).\n\n### JavaScript and JSON differences\n\nJSON is a syntax for serializing objects, arrays, numbers, strings, booleans, and [`null`](/en-US/docs/Web/JavaScript/Reference/Operators/null). It is based upon JavaScript syntax, but is distinct from JavaScript: most of JavaScript is _not_ JSON. For example:\n\n- Objects and Arrays\n  - : Property names must be double-quoted strings; [trailing commas](/en-US/docs/Web/JavaScript/Reference/Trailing_commas) are forbidden.\n- Numbers\n  - : Leading zeros are prohibited. A decimal point must be followed by at least one digit. `NaN` and `Infinity` are unsupported.\n\nAny JSON text is a valid JavaScript expression, but only after the [JSON superset](https://github.com/tc39/proposal-json-superset) revision. Before the revision, U+2028 LINE SEPARATOR and U+2029 PARAGRAPH SEPARATOR are allowed in string literals and property keys in JSON; but the same use in JavaScript string literals is a {{jsxref("SyntaxError")}}.\n\nOther differences include allowing only double-quoted strings and no support for {{jsxref("undefined")}} or comments. For those who wish to use a more human-friendly configuration format based on JSON, there is [JSON5](https://json5.org/), used by the Babel compiler, and the more commonly used [YAML](https://en.wikipedia.org/wiki/YAML).\n\nThe same text may represent different values in JavaScript object literals vs. JSON as well. For more information, see [Object literal syntax vs. JSON](/en-US/docs/Web/JavaScript/Reference/Operators/Object_initializer#object_literal_syntax_vs._json).\n\n### Full JSON grammar\n\nValid JSON syntax is formally defined by the following grammar, expressed in [ABNF](https://en.wikipedia.org/wiki/Augmented_Backus%E2%80%93Naur_form), and copied from [IETF JSON standard (RFC)](https://datatracker.ietf.org/doc/html/rfc8259):\n\n```plain\nJSON-text = object / array\nbegin-array     = ws %x5B ws  ; [ left square bracket\nbegin-object    = ws %x7B ws  ; { left curly bracket\nend-array       = ws %x5D ws  ; ] right square bracket\nend-object      = ws %x7D ws  ; } right curly bracket\nname-separator  = ws %x3A ws  ; : colon\nvalue-separator = ws %x2C ws  ; , comma\nws = *(\n     %x20 /              ; Space\n     %x09 /              ; Horizontal tab\n     %x0A /              ; Line feed or New line\n     %x0D                ; Carriage return\n     )\nvalue = false / null / true / object / array / number / string\nfalse = %x66.61.6c.73.65   ; false\nnull  = %x6e.75.6c.6c      ; null\ntrue  = %x74.72.75.65      ; true\nobject = begin-object [ member *( value-separator member ) ]\n         end-object\nmember = string name-separator value\narray = begin-array [ value *( value-separator value ) ] end-array\nnumber = [ minus ] int [ frac ] [ exp ]\ndecimal-point = %x2E       ; .\ndigit1-9 = %x31-39         ; 1-9\ne = %x65 / %x45            ; e E\nexp = e [ minus / plus ] 1*DIGIT\nfrac = decimal-point 1*DIGIT\nint = zero / ( digit1-9 *DIGIT )\nminus = %x2D               ; -\nplus = %x2B                ; +\nzero = %x30                ; 0\nstring = quotation-mark *char quotation-mark\nchar = unescaped /\n    escape (\n        %x22 /          ; "    quotation mark  U+0022\n        %x5C /          ; \\    reverse solidus U+005C\n        %x2F /          ; /    solidus         U+002F\n        %x62 /          ; b    backspace       U+0008\n        %x66 /          ; f    form feed       U+000C\n        %x6E /          ; n    line feed       U+000A\n        %x72 /          ; r    carriage return U+000D\n        %x74 /          ; t    tab             U+0009\n        %x75 4HEXDIG )  ; uXXXX                U+XXXX\nescape = %x5C              ; \\\nquotation-mark = %x22      ; "\nunescaped = %x20-21 / %x23-5B / %x5D-10FFFF\nHEXDIG = DIGIT / %x41-46 / %x61-66   ; 0-9, A-F, or a-f\n       ; HEXDIG equivalent to HEXDIG rule in [RFC5234]\nDIGIT = %x30-39            ; 0-9\n      ; DIGIT equivalent to DIGIT rule in [RFC5234]\n```\n\nInsignificant {{Glossary("whitespace")}} may be present anywhere except within a `JSONNumber` (numbers must contain no whitespace) or `JSONString` (where it is interpreted as the corresponding character in the string, or would cause an error). The tab character ([U+0009](https://unicode-table.com/en/0009/)), carriage return ([U+000D](https://unicode-table.com/en/000D/)), line feed ([U+000A](https://unicode-table.com/en/000A/)), and space ([U+0020](https://unicode-table.com/en/0020/)) characters are the only valid whitespace characters.\n\n## Static properties\n\n- `JSON[@@toStringTag]`\n  - : The initial value of the [`@@toStringTag`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol/toStringTag) property is the string `"JSON"`. This property is used in {{jsxref("Object.prototype.toString()")}}.\n\n## Static methods\n\n- {{jsxref("JSON.parse()")}}\n  - : Parse a piece of string text as JSON, optionally transforming the produced value and its properties, and return the value.\n- {{jsxref("JSON.stringify()")}}\n  - : Return a JSON string corresponding to the specified value, optionally including only certain properties or replacing property values in a user-defined manner.\n\n## Examples\n\n### Example JSON\n\n```json\n{\n  "browsers": {\n    "firefox": {\n      "name": "Firefox",\n      "pref_url": "about:config",\n      "releases": {\n        "1": {\n          "release_date": "2004-11-09",\n          "status": "retired",\n          "engine": "Gecko",\n          "engine_version": "1.7"\n        }\n      }\n    }\n  }\n}\n```\n\nYou can use the {{jsxref("JSON.parse()")}} method to convert the above JSON string into a JavaScript object:\n\n```js\nconst jsonText = `{\n  "browsers": {\n    "firefox": {\n      "name": "Firefox",\n      "pref_url": "about:config",\n      "releases": {\n        "1": {\n          "release_date": "2004-11-09",\n          "status": "retired",\n          "engine": "Gecko",\n          "engine_version": "1.7"\n        }\n      }\n    }\n  }\n}`;\n\nconsole.log(JSON.parse(jsonText));\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Date.prototype.toJSON()")}}\n- [JSON Diff](https://json-diff.com/)\n- [JSON Beautifier/editor](https://jsonbeautifier.org/)\n- [JSON Parser](https://jsonparser.org/)\n- [JSON Validator](https://tools.learningcontainer.com/json-validator/)\n',
        "parse": {
            "index.md": '---\ntitle: JSON.parse()\nslug: Web/JavaScript/Reference/Global_Objects/JSON/parse\npage-type: javascript-static-method\nbrowser-compat: javascript.builtins.JSON.parse\n---\n\n{{JSRef}}\n\nThe **`JSON.parse()`** static method parses a JSON string, constructing the JavaScript value or object described by the string. An optional _reviver_ function can be provided to perform a transformation on the resulting object before it is returned.\n\n{{EmbedInteractiveExample("pages/js/json-parse.html")}}\n\n## Syntax\n\n```js-nolint\nJSON.parse(text)\nJSON.parse(text, reviver)\n```\n\n### Parameters\n\n- `text`\n  - : The string to parse as JSON. See the {{jsxref("JSON")}} object for a description of JSON syntax.\n- `reviver` {{optional_inline}}\n  - : If a function, this prescribes how each value originally produced by parsing is transformed before being returned. Non-callable values are ignored. The function is called with the following arguments:\n    - `key`\n      - : The key associated with the value.\n    - `value`\n      - : The value produced by parsing.\n\n### Return value\n\nThe {{jsxref("Object")}}, {{jsxref("Array")}}, string, number, boolean, or `null` value corresponding to the given JSON `text`.\n\n### Exceptions\n\n- {{jsxref("SyntaxError")}}\n  - : Thrown if the string to parse is not valid JSON.\n\n## Description\n\n`JSON.parse()` parses a JSON string according to the [JSON grammar](/en-US/docs/Web/JavaScript/Reference/Global_Objects/JSON#full_json_grammar), then evaluates the string as if it\'s a JavaScript expression. The only instance where a piece of JSON text represents a different value from the same JavaScript expression is when dealing with the `"__proto__"` key \u2014 see [Object literal syntax vs. JSON](/en-US/docs/Web/JavaScript/Reference/Operators/Object_initializer#object_literal_syntax_vs._json).\n\n### The reviver parameter\n\nIf a `reviver` is specified, the value computed by parsing is _transformed_ before being returned. Specifically, the computed value and all its properties (in a [depth-first](https://en.wikipedia.org/wiki/Depth-first_search) fashion, beginning with the most nested properties and proceeding to the original value itself) are individually run through the `reviver`.\n\nThe `reviver` is called with the object containing the property being processed as `this` (unless you define the `reviver` as an arrow function, in which case there\'s no separate `this` binding) and two arguments: `key` and `value`, representing the property name as a string (even for arrays) and the property value. If the `reviver` function returns {{jsxref("undefined")}} (or returns no value \u2014 for example, if execution falls off the end of the function), the property is deleted from the object. Otherwise, the property is redefined to be the return value. If the `reviver` only transforms some values and not others, be certain to return all untransformed values as-is \u2014 otherwise, they will be deleted from the resulting object.\n\nSimilar to the `replacer` parameter of {{jsxref("JSON.stringify()")}}, for arrays and objects, `reviver` will be last called on the root value with an empty string as the `key` and the root object as the `value`. For other valid JSON values, `reviver` works similarly and is called once with an empty string as the `key` and the value itself as the `value`.\n\nIf you return another value from `reviver`, that value will completely replace the originally parsed value. This even applies to the root value. For example:\n\n```js\nconst transformedObj1 = JSON.parse(\'[1,5,{"s":1}]\', (key, value) => {\n  return typeof value === "object" ? undefined : value;\n});\n\nconsole.log(transformedObj1); // undefined\n```\n\nThere is no way to work around this generically. You cannot specially handle the case where `key` is an empty string, because JSON objects can also contain keys that are empty strings. You need to know very precisely what kind of transformation is needed for each key when implementing the reviver.\n\nNote that `reviver` is run after the value is parsed. So, for example, numbers in JSON text will have already been converted to JavaScript numbers, and may lose precision in the process. To transfer large numbers without loss of precision, serialize them as strings, and revive them to [BigInts](/en-US/docs/Web/JavaScript/Reference/Global_Objects/BigInt), or other appropriate arbitrary precision formats.\n\n## Examples\n\n### Using JSON.parse()\n\n```js\nJSON.parse("{}"); // {}\nJSON.parse("true"); // true\nJSON.parse(\'"foo"\'); // "foo"\nJSON.parse(\'[1, 5, "false"]\'); // [1, 5, "false"]\nJSON.parse("null"); // null\n```\n\n### Using the reviver parameter\n\n```js\nJSON.parse(\n  \'{"p": 5}\',\n  (key, value) =>\n    typeof value === "number"\n      ? value * 2 // return value * 2 for numbers\n      : value, // return everything else unchanged\n);\n// { p: 10 }\n\nJSON.parse(\'{"1": 1, "2": 2, "3": {"4": 4, "5": {"6": 6}}}\', (key, value) => {\n  console.log(key);\n  return value;\n});\n// 1\n// 2\n// 4\n// 6\n// 5\n// 3\n// ""\n```\n\n### Using reviver when paired with the replacer of JSON.stringify()\n\nIn order for a value to properly round-trip (that is, it gets deserialized to the same original object), the serialization process must preserve the type information. For example, you can use the `replacer` parameter of {{jsxref("JSON.stringify()")}} for this purpose:\n\n```js\n// Maps are normally serialized as objects with no properties.\n// We can use the replacer to specify the entries to be serialized.\nconst map = new Map([\n  [1, "one"],\n  [2, "two"],\n  [3, "three"],\n]);\n\nconst jsonText = JSON.stringify(map, (key, value) =>\n  value instanceof Map ? Array.from(value.entries()) : value,\n);\n\nconsole.log(jsonText);\n// [[1,"one"],[2,"two"],[3,"three"]]\n\nconst map2 = JSON.parse(jsonText, (key, value) =>\n  Array.isArray(value) ? new Map(value) : value,\n);\n\nconsole.log(map2);\n// Map { 1 => "one", 2 => "two", 3 => "three" }\n```\n\nBecause JSON has no syntax space for annotating type metadata, in order to revive values that are not plain objects, you have to consider one of the following:\n\n- Serialize the entire object to a string and prefix it with a type tag.\n- "Guess" based on the structure of the data (for example, an array of two-member arrays)\n- If the shape of the payload is fixed, based on the property name (for example, all properties called `registry` hold `Map` objects).\n\n### JSON.parse() does not allow trailing commas\n\n```js example-bad\n// both will throw a SyntaxError\nJSON.parse("[1, 2, 3, 4, ]");\nJSON.parse(\'{"foo" : 1, }\');\n```\n\n### JSON.parse() does not allow single quotes\n\n```js example-bad\n// will throw a SyntaxError\nJSON.parse("{\'foo\': 1}");\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("JSON.stringify()")}}\n'
        },
        "stringify": {
            "index.md": '---\ntitle: JSON.stringify()\nslug: Web/JavaScript/Reference/Global_Objects/JSON/stringify\npage-type: javascript-static-method\nbrowser-compat: javascript.builtins.JSON.stringify\n---\n\n{{JSRef}}\n\nThe **`JSON.stringify()`** static method converts a JavaScript value to a JSON string, optionally replacing values if a replacer function is specified or optionally including only the specified properties if a replacer array is specified.\n\n{{EmbedInteractiveExample("pages/js/json-stringify.html", "taller")}}\n\n## Syntax\n\n```js-nolint\nJSON.stringify(value)\nJSON.stringify(value, replacer)\nJSON.stringify(value, replacer, space)\n```\n\n### Parameters\n\n- `value`\n  - : The value to convert to a JSON string.\n- `replacer` {{optional_inline}}\n  - : A function that alters the behavior of the stringification process, or an array of strings and numbers that specifies properties of `value` to be included in the output. If `replacer` is an array, all elements in this array that are not strings or numbers (either primitives or wrapper objects), including {{jsxref("Symbol")}} values, are completely ignored. If `replacer` is anything other than a function or an array (e.g. [`null`](/en-US/docs/Web/JavaScript/Reference/Operators/null) or not provided), all string-keyed properties of the object are included in the resulting JSON string.\n- `space` {{optional_inline}}\n\n  - : A string or number that\'s used to insert white space (including indentation, line break characters, etc.) into the output JSON string for readability purposes.\n\n    If this is a number, it indicates the number of space characters to be used as indentation, clamped to 10 (that is, any number greater than `10` is treated as if it were `10`). Values less than 1 indicate that no space should be used.\n\n    If this is a string, the string (or the first 10 characters of the string, if it\'s longer than that) is inserted before every nested object or array.\n\n    If `space` is anything other than a string or number (can be either a primitive or a wrapper object) \u2014 for example, is [`null`](/en-US/docs/Web/JavaScript/Reference/Operators/null) or not provided \u2014 no white space is used.\n\n### Return value\n\nA JSON string representing the given value, or undefined.\n\n### Exceptions\n\n- {{jsxref("TypeError")}}\n  - : Thrown in one of the following cases:\n    - `value` contains a circular reference.\n    - A {{jsxref("BigInt")}} value is encountered.\n\n## Description\n\n`JSON.stringify()` converts a value to the JSON notation that the value represents. Values are stringified in the following manner:\n\n- {{jsxref("Boolean")}}, {{jsxref("Number")}}, {{jsxref("String")}}, and {{jsxref("BigInt")}} (obtainable via [`Object()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/Object)) objects are converted to the corresponding primitive values during stringification, in accordance with the traditional conversion semantics. {{jsxref("Symbol")}} objects (obtainable via [`Object()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/Object)) are treated as plain objects.\n- Attempting to serialize {{jsxref("BigInt")}} values will throw. However, if the BigInt has a `toJSON()` method (through monkey patching: `BigInt.prototype.toJSON = ...`), that method can provide the serialization result. This constraint ensures that a proper serialization (and, very likely, its accompanying deserialization) behavior is always explicitly provided by the user.\n- {{jsxref("undefined")}}, {{jsxref("Function")}}, and {{jsxref("Symbol")}} values are not valid JSON values. If any such values are encountered during conversion, they are either omitted (when found in an object) or changed to [`null`](/en-US/docs/Web/JavaScript/Reference/Operators/null) (when found in an array). `JSON.stringify()` can return `undefined` when passing in "pure" values like `JSON.stringify(() => {})` or `JSON.stringify(undefined)`.\n- The numbers {{jsxref("Infinity")}} and {{jsxref("NaN")}}, as well as the value [`null`](/en-US/docs/Web/JavaScript/Reference/Operators/null), are all considered `null`. (But unlike the values in the previous point, they would never be omitted.)\n- Arrays are serialized as arrays (enclosed by square brackets). Only array indices between 0 and `length - 1` (inclusive) are serialized; other properties are ignored.\n- For other objects:\n\n  - All {{jsxref("Symbol")}}-keyed properties will be completely ignored, even when using the [`replacer`](#the_replacer_parameter) parameter.\n\n  - If the value has a `toJSON()` method, it\'s responsible to define what data will be serialized. Instead of the object being serialized, the value returned by the `toJSON()` method when called will be serialized. `JSON.stringify()` calls `toJSON` with one parameter, the `key`, which has the same semantic as the `key` parameter of the [`replacer`](#the_replacer_parameter) function:\n\n    - if this object is a property value, the property name\n    - if it is in an array, the index in the array, as a string\n    - if `JSON.stringify()` was directly called on this object, an empty string\n\n    {{jsxref("Date")}} objects implement the [`toJSON()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/toJSON) method which returns a string (the same as [`date.toISOString()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/toISOString)). Thus, they will be stringified as strings.\n\n  - Only [enumerable own properties](/en-US/docs/Web/JavaScript/Enumerability_and_ownership_of_properties) are visited. This means {{jsxref("Map")}}, {{jsxref("Set")}}, etc. will become `"{}"`. You can use the [`replacer`](#the_replacer_parameter) parameter to serialize them to something more useful.\n\n    Properties are visited using the same algorithm as [`Object.keys()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/keys), which has a well-defined order and is stable across implementations. For example, `JSON.stringify` on the same object will always produce the same string, and `JSON.parse(JSON.stringify(obj))` would produce an object with the same key ordering as the original (assuming the object is completely JSON-serializable).\n\n### The replacer parameter\n\nThe `replacer` parameter can be either a function or an array.\n\nAs an array, its elements indicate the names of the properties in the object that should be included in the resulting JSON string. Only string and number values are taken into account; symbol keys are ignored.\n\nAs a function, it takes two parameters: the `key` and the `value` being stringified. The object in which the key was found is provided as the `replacer`\'s `this` context.\n\nThe `replacer` function is called for the initial object being stringified as well, in which case the `key` is an empty string (`""`). It is then called for each property on the object or array being stringified. Array indices will be provided in its string form as `key`. The current property value will be replaced with the `replacer`\'s return value for stringification. This means:\n\n- If you return a number, string, boolean, or `null`, that value is directly serialized and used as the property\'s value. (Returning a BigInt will throw as well.)\n- If you return a {{jsxref("Function")}}, {{jsxref("Symbol")}}, or {{jsxref("undefined")}}, the property is not included in the output.\n- If you return any other object, the object is recursively stringified, calling the `replacer` function on each property.\n\n> **Note:** When parsing JSON generated with `replacer` functions, you would likely want to use the [`reviver`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/JSON/parse#using_the_reviver_parameter) parameter to perform the reverse operation.\n\nTypically, array elements\' index would never shift (even when the element is an invalid value like a function, it will become `null` instead of omitted). Using the `replacer` function allows you to control the order of the array elements by returning a different array.\n\n### The space parameter\n\nThe `space` parameter may be used to control spacing in the final string.\n\n- If it is a number, successive levels in the stringification will each be indented by this many space characters.\n- If it is a string, successive levels will be indented by this string.\n\nEach level of indentation will never be longer than 10. Number values of `space` are clamped to 10, and string values are truncated to 10 characters.\n\n## Examples\n\n### Using JSON.stringify\n\n```js\nJSON.stringify({}); // \'{}\'\nJSON.stringify(true); // \'true\'\nJSON.stringify("foo"); // \'"foo"\'\nJSON.stringify([1, "false", false]); // \'[1,"false",false]\'\nJSON.stringify([NaN, null, Infinity]); // \'[null,null,null]\'\nJSON.stringify({ x: 5 }); // \'{"x":5}\'\n\nJSON.stringify(new Date(1906, 0, 2, 15, 4, 5));\n// \'"1906-01-02T15:04:05.000Z"\'\n\nJSON.stringify({ x: 5, y: 6 });\n// \'{"x":5,"y":6}\'\nJSON.stringify([new Number(3), new String("false"), new Boolean(false)]);\n// \'[3,"false",false]\'\n\n// String-keyed array elements are not enumerable and make no sense in JSON\nconst a = ["foo", "bar"];\na["baz"] = "quux"; // a: [ 0: \'foo\', 1: \'bar\', baz: \'quux\' ]\nJSON.stringify(a);\n// \'["foo","bar"]\'\n\nJSON.stringify({ x: [10, undefined, function () {}, Symbol("")] });\n// \'{"x":[10,null,null,null]}\'\n\n// Standard data structures\nJSON.stringify([\n  new Set([1]),\n  new Map([[1, 2]]),\n  new WeakSet([{ a: 1 }]),\n  new WeakMap([[{ a: 1 }, 2]]),\n]);\n// \'[{},{},{},{}]\'\n\n// TypedArray\nJSON.stringify([new Int8Array([1]), new Int16Array([1]), new Int32Array([1])]);\n// \'[{"0":1},{"0":1},{"0":1}]\'\nJSON.stringify([\n  new Uint8Array([1]),\n  new Uint8ClampedArray([1]),\n  new Uint16Array([1]),\n  new Uint32Array([1]),\n]);\n// \'[{"0":1},{"0":1},{"0":1},{"0":1}]\'\nJSON.stringify([new Float32Array([1]), new Float64Array([1])]);\n// \'[{"0":1},{"0":1}]\'\n\n// toJSON()\nJSON.stringify({\n  x: 5,\n  y: 6,\n  toJSON() {\n    return this.x + this.y;\n  },\n});\n// \'11\'\n\n// Symbols:\nJSON.stringify({ x: undefined, y: Object, z: Symbol("") });\n// \'{}\'\nJSON.stringify({ [Symbol("foo")]: "foo" });\n// \'{}\'\nJSON.stringify({ [Symbol.for("foo")]: "foo" }, [Symbol.for("foo")]);\n// \'{}\'\nJSON.stringify({ [Symbol.for("foo")]: "foo" }, (k, v) => {\n  if (typeof k === "symbol") {\n    return "a symbol";\n  }\n});\n// undefined\n\n// Non-enumerable properties:\nJSON.stringify(\n  Object.create(null, {\n    x: { value: "x", enumerable: false },\n    y: { value: "y", enumerable: true },\n  }),\n);\n// \'{"y":"y"}\'\n\n// BigInt values throw\nJSON.stringify({ x: 2n });\n// TypeError: BigInt value can\'t be serialized in JSON\n```\n\n### Using a function as replacer\n\n```js\nfunction replacer(key, value) {\n  // Filtering out properties\n  if (typeof value === "string") {\n    return undefined;\n  }\n  return value;\n}\n\nconst foo = {\n  foundation: "Mozilla",\n  model: "box",\n  week: 45,\n  transport: "car",\n  month: 7,\n};\nJSON.stringify(foo, replacer);\n// \'{"week":45,"month":7}\'\n```\n\nIf you wish the `replacer` to distinguish an initial object from a key with an empty string property (since both would give the empty string as key and potentially an object as value), you will have to keep track of the iteration count (if it is beyond the first iteration, it is a genuine empty string key).\n\n```js\nfunction makeReplacer() {\n  let isInitial = true;\n\n  return (key, value) => {\n    if (isInitial) {\n      isInitial = false;\n      return value;\n    }\n    if (key === "") {\n      // Omit all properties with name "" (except the initial object)\n      return undefined;\n    }\n    return value;\n  };\n}\n\nconst replacer = makeReplacer();\nconsole.log(JSON.stringify({ "": 1, b: 2 }, replacer)); // "{"b":2}"\n```\n\n### Using an array as replacer\n\n```js\nconst foo = {\n  foundation: "Mozilla",\n  model: "box",\n  week: 45,\n  transport: "car",\n  month: 7,\n};\n\nJSON.stringify(foo, ["week", "month"]);\n// \'{"week":45,"month":7}\', only keep "week" and "month" properties\n```\n\n### Using the space parameter\n\nIndent the output with one space:\n\n```js\nconsole.log(JSON.stringify({ a: 2 }, null, " "));\n/*\n{\n "a": 2\n}\n*/\n```\n\nUsing a tab character mimics standard pretty-print appearance:\n\n<!-- markdownlint-disable MD010 -->\n\n```js\nconsole.log(JSON.stringify({ uno: 1, dos: 2 }, null, "\\t"));\n/*\n{\n	"uno": 1,\n	"dos": 2\n}\n*/\n```\n\n<!-- markdownlint-enable MD010 -->\n\n### toJSON() behavior\n\nDefining `toJSON()` for an object allows overriding its serialization behavior.\n\n```js\nconst obj = {\n  data: "data",\n\n  toJSON(key) {\n    return key ? `Now I am a nested object under key \'${key}\'` : this;\n  },\n};\n\nJSON.stringify(obj);\n// \'{"data":"data"}\'\n\nJSON.stringify({ obj });\n// \'{"obj":"Now I am a nested object under key \'obj\'"}\'\n\nJSON.stringify([obj]);\n// \'["Now I am a nested object under key \'0\'"]\'\n```\n\n### Issue with serializing circular references\n\nSince the [JSON format](https://www.json.org/) doesn\'t support object references (although an [IETF draft exists](https://datatracker.ietf.org/doc/html/draft-pbryan-zyp-json-ref-03)), a {{jsxref("TypeError")}} will be thrown if one attempts to encode an object with circular references.\n\n```js example-bad\nconst circularReference = {};\ncircularReference.myself = circularReference;\n\n// Serializing circular references throws "TypeError: cyclic object value"\nJSON.stringify(circularReference);\n```\n\nTo serialize circular references, you can use a library that supports them (e.g. [cycle.js](https://github.com/douglascrockford/JSON-js/blob/master/cycle.js) by Douglas Crockford) or implement a solution yourself, which will require finding and replacing (or removing) the cyclic references by serializable values.\n\nIf you are using `JSON.stringify()` to deep-copy an object, you may instead want to use [`structuredClone()`](/en-US/docs/Web/API/structuredClone), which supports circular references. JavaScript engine APIs for binary serialization, such as [`v8.serialize()`](https://nodejs.org/api/v8.html#v8serializevalue), also support circular references.\n\n### Using JSON.stringify() with localStorage\n\nIn a case where you want to store an object created by your user and allow it to be restored even after the browser has been closed, the following example is a model for the applicability of `JSON.stringify()`:\n\n```js\n// Creating an example of JSON\nconst session = {\n  screens: [],\n  state: true,\n};\nsession.screens.push({ name: "screenA", width: 450, height: 250 });\nsession.screens.push({ name: "screenB", width: 650, height: 350 });\nsession.screens.push({ name: "screenC", width: 750, height: 120 });\nsession.screens.push({ name: "screenD", width: 250, height: 60 });\nsession.screens.push({ name: "screenE", width: 390, height: 120 });\nsession.screens.push({ name: "screenF", width: 1240, height: 650 });\n\n// Converting the JSON string with JSON.stringify()\n// then saving with localStorage in the name of session\nlocalStorage.setItem("session", JSON.stringify(session));\n\n// Example of how to transform the String generated through\n// JSON.stringify() and saved in localStorage in JSON object again\nconst restoredSession = JSON.parse(localStorage.getItem("session"));\n\n// Now restoredSession variable contains the object that was saved\n// in localStorage\nconsole.log(restoredSession);\n```\n\n### Well-formed JSON.stringify()\n\nEngines implementing the [well-formed JSON.stringify specification](https://github.com/tc39/proposal-well-formed-stringify) will stringify lone surrogates (any code point from U+D800 to U+DFFF) using Unicode escape sequences rather than literally (outputting lone surrogates). Before this change, such strings could not be encoded in valid UTF-8 or UTF-16:\n\n```js\nJSON.stringify("\uD800"); // \'"\uFFFD"\'\n```\n\nBut with this change `JSON.stringify()` represents lone surrogates using JSON escape sequences that _can_ be encoded in valid UTF-8 or UTF-16:\n\n```js\nJSON.stringify("\uD800"); // \'"\\\ud800"\'\n```\n\nThis change should be backwards-compatible as long as you pass the result of `JSON.stringify()` to APIs such as `JSON.parse()` that will accept any valid JSON text, because they will treat Unicode escapes of lone surrogates as identical to the lone surrogates themselves. _Only_ if you are directly interpreting the result of `JSON.stringify()` do you need to carefully handle `JSON.stringify()`\'s two possible encodings of these code points.\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of modern `JSON.stringify` behavior (symbol and well-formed unicode) in `core-js`](https://github.com/zloirock/core-js#ecmascript-json)\n- {{jsxref("JSON.parse()")}}\n'
        }
    },
    "map": {
        "@@iterator": {
            "index.md": '---\ntitle: Map.prototype[@@iterator]()\nslug: Web/JavaScript/Reference/Global_Objects/Map/@@iterator\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Map.@@iterator\n---\n\n{{JSRef}}\n\nThe **`[@@iterator]()`** method of {{jsxref("Map")}} instances implements the [iterable protocol](/en-US/docs/Web/JavaScript/Reference/Iteration_protocols) and allows `Map` objects to be consumed by most syntaxes expecting iterables, such as the [spread syntax](/en-US/docs/Web/JavaScript/Reference/Operators/Spread_syntax) and {{jsxref("Statements/for...of", "for...of")}} loops. It returns a [map iterator object](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Iterator) that yields the key-value pairs of the map in insertion order.\n\nThe initial value of this property is the same function object as the initial value of the {{jsxref("Map.prototype.entries")}} property.\n\n{{EmbedInteractiveExample("pages/js/map-prototype-@@iterator.html")}}\n\n## Syntax\n\n```js-nolint\nmap[Symbol.iterator]()\n```\n\n### Parameters\n\nNone.\n\n### Return value\n\nThe same return value as {{jsxref("Map.prototype.entries()")}}: a new [iterable iterator object](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Iterator) that yields the key-value pairs of the map.\n\n## Examples\n\n### Iteration using for...of loop\n\nNote that you seldom need to call this method directly. The existence of the `@@iterator` method makes `Map` objects [iterable](/en-US/docs/Web/JavaScript/Reference/Iteration_protocols#the_iterable_protocol), and iterating syntaxes like the `for...of` loop automatically call this method to obtain the iterator to loop over.\n\n```js\nconst myMap = new Map();\nmyMap.set("0", "foo");\nmyMap.set(1, "bar");\nmyMap.set({}, "baz");\n\nfor (const entry of myMap) {\n  console.log(entry);\n}\n// ["0", "foo"]\n// [1, "bar"]\n// [{}, "baz"]\n\nfor (const [key, value] of myMap) {\n  console.log(`${key}: ${value}`);\n}\n// 0: foo\n// 1: bar\n// [Object]: baz\n```\n\n### Manually hand-rolling the iterator\n\nYou may still manually call the `next()` method of the returned iterator object to achieve maximum control over the iteration process.\n\n```js\nconst myMap = new Map();\nmyMap.set("0", "foo");\nmyMap.set(1, "bar");\nmyMap.set({}, "baz");\n\nconst mapIter = myMap[Symbol.iterator]();\n\nconsole.log(mapIter.next().value); // ["0", "foo"]\nconsole.log(mapIter.next().value); // [1, "bar"]\nconsole.log(mapIter.next().value); // [Object, "baz"]\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Map")}}\n- {{jsxref("Map.prototype.entries()")}}\n- {{jsxref("Map.prototype.keys()")}}\n- {{jsxref("Map.prototype.values()")}}\n- {{jsxref("Symbol.iterator")}}\n- [Iteration protocols](/en-US/docs/Web/JavaScript/Reference/Iteration_protocols)\n'
        },
        "@@species": {
            "index.md": '---\ntitle: Map[@@species]\nslug: Web/JavaScript/Reference/Global_Objects/Map/@@species\npage-type: javascript-static-accessor-property\nbrowser-compat: javascript.builtins.Map.@@species\n---\n\n{{JSRef}}\n\nThe **`Map[@@species]`** static accessor property is an unused accessor property specifying how to copy `Map` objects.\n\n## Syntax\n\n```js-nolint\nMap[Symbol.species]\n```\n\n### Return value\n\nThe value of the constructor (`this`) on which `get @@species` was called. The return value is used to construct copied `Map` instances.\n\n## Description\n\nThe `@@species` accessor property returns the default constructor for `Map` objects. Subclass constructors may override it to change the constructor assignment.\n\n> **Note:** This property is currently unused by all `Map` methods.\n\n## Examples\n\n### Species in ordinary objects\n\nThe `@@species` property returns the default constructor function, which is the `Map` constructor for `Map`.\n\n```js\nMap[Symbol.species]; // function Map()\n```\n\n### Species in derived objects\n\nIn an instance of a custom `Map` subclass, such as `MyMap`, the `MyMap` species is the `MyMap` constructor. However, you might want to overwrite this, in order to return parent `Map` objects in your derived class methods:\n\n```js\nclass MyMap extends Map {\n  // Overwrite MyMap species to the parent Map constructor\n  static get [Symbol.species]() {\n    return Map;\n  }\n}\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Map")}}\n- {{jsxref("Symbol.species")}}\n'
        },
        "clear": {
            "index.md": '---\ntitle: Map.prototype.clear()\nslug: Web/JavaScript/Reference/Global_Objects/Map/clear\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Map.clear\n---\n\n{{JSRef}}\n\nThe **`clear()`** method of {{jsxref("Map")}} instances removes all elements from this map.\n\n{{EmbedInteractiveExample("pages/js/map-prototype-clear.html")}}\n\n## Syntax\n\n```js-nolint\nclear()\n```\n\n### Parameters\n\nNone.\n\n### Return value\n\nNone ({{jsxref("undefined")}}).\n\n## Examples\n\n### Using clear()\n\n```js\nconst myMap = new Map();\nmyMap.set("bar", "baz");\nmyMap.set(1, "foo");\n\nconsole.log(myMap.size); // 2\nconsole.log(myMap.has("bar")); // true\n\nmyMap.clear();\n\nconsole.log(myMap.size); // 0\nconsole.log(myMap.has("bar")); // false\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Map")}}\n'
        },
        "delete": {
            "index.md": '---\ntitle: Map.prototype.delete()\nslug: Web/JavaScript/Reference/Global_Objects/Map/delete\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Map.delete\n---\n\n{{JSRef}}\n\nThe **`delete()`** method of {{jsxref("Map")}} instances removes the specified element from this map by\nkey.\n\n{{EmbedInteractiveExample("pages/js/map-prototype-delete.html")}}\n\n## Syntax\n\n```js-nolint\nmapInstance.delete(key)\n```\n\n### Parameters\n\n- `key`\n  - : The key of the element to remove from the `Map` object.\n\n### Return value\n\n`true` if an element in the `Map` object existed and has been removed, or\n`false` if the element does not exist.\n\n## Examples\n\n### Using delete()\n\n```js\nconst myMap = new Map();\nmyMap.set("bar", "foo");\n\nconsole.log(myMap.delete("bar")); // Returns true. Successfully removed.\nconsole.log(myMap.has("bar")); // Returns false. The "bar" element is no longer present.\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Map")}}\n'
        },
        "entries": {
            "index.md": '---\ntitle: Map.prototype.entries()\nslug: Web/JavaScript/Reference/Global_Objects/Map/entries\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Map.entries\n---\n\n{{JSRef}}\n\nThe **`entries()`** method of {{jsxref("Map")}} instances returns a new _[map iterator](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Iterator)_ object that contains the `[key, value]` pairs for each element in this map in insertion order.\n\n{{EmbedInteractiveExample("pages/js/map-prototype-entries.html")}}\n\n## Syntax\n\n```js-nolint\nentries()\n```\n\n### Parameters\n\nNone.\n\n### Return value\n\nA new [iterable iterator object](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Iterator).\n\n## Examples\n\n### Using entries()\n\n```js\nconst myMap = new Map();\nmyMap.set("0", "foo");\nmyMap.set(1, "bar");\nmyMap.set({}, "baz");\n\nconst mapIter = myMap.entries();\n\nconsole.log(mapIter.next().value); // ["0", "foo"]\nconsole.log(mapIter.next().value); // [1, "bar"]\nconsole.log(mapIter.next().value); // [Object, "baz"]\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Map.prototype.keys()")}}\n- {{jsxref("Map.prototype.values()")}}\n'
        },
        "foreach": {
            "index.md": '---\ntitle: Map.prototype.forEach()\nslug: Web/JavaScript/Reference/Global_Objects/Map/forEach\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Map.forEach\n---\n\n{{JSRef}}\n\nThe **`forEach()`** method of {{jsxref("Map")}} instances executes a provided function once per each key/value\npair in this map, in insertion order.\n\n{{EmbedInteractiveExample("pages/js/map-prototype-foreach.html")}}\n\n## Syntax\n\n```js-nolint\nforEach(callbackFn)\nforEach(callbackFn, thisArg)\n```\n\n### Parameters\n\n- `callbackFn`\n  - : A function to execute for each entry in the map. The function is called with the following arguments:\n    - `value`\n      - : Value of each iteration.\n    - `key`\n      - : Key of each iteration.\n    - `map`\n      - : The map being iterated.\n- `thisArg` {{optional_inline}}\n  - : A value to use as `this` when executing `callbackFn`.\n\n### Return value\n\nNone ({{jsxref("undefined")}}).\n\n## Description\n\nThe `forEach` method executes the provided `callback` once for each key of the\nmap which actually exist. It is not invoked for keys which have been deleted.\nHowever, it is executed for values which are present but have the value\n`undefined`.\n\n`callback` is invoked with **three arguments**:\n\n- the entry\'s `value`\n- the entry\'s `key`\n- the **`Map` object** being traversed\n\nIf a `thisArg` parameter is provided to `forEach`, it will be passed to\n`callback` when invoked, for use as its `this` value. Otherwise, the value\n`undefined` will be passed for use as its `this` value. The `this` value\nultimately observable by `callback` is determined according to\n[the usual rules for determining the `this` seen by a function](/en-US/docs/Web/JavaScript/Reference/Operators/this).\n\nEach value is visited once, except in the case when it was deleted and re-added\nbefore `forEach` has finished. `callback` is not invoked for values deleted\nbefore being visited. New values added before `forEach` has finished will be\nvisited.\n\n## Examples\n\n### Printing the contents of a Map object\n\nThe following code logs a line for each element in an `Map` object:\n\n```js\nfunction logMapElements(value, key, map) {\n  console.log(`map.get(\'${key}\') = ${value}`);\n}\nnew Map([\n  ["foo", 3],\n  ["bar", {}],\n  ["baz", undefined],\n]).forEach(logMapElements);\n// Logs:\n// "map.get(\'foo\') = 3"\n// "map.get(\'bar\') = [object Object]"\n// "map.get(\'baz\') = undefined"\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Array.prototype.forEach()")}}\n- {{jsxref("Set.prototype.forEach()")}}\n'
        },
        "get": {
            "index.md": '---\ntitle: Map.prototype.get()\nslug: Web/JavaScript/Reference/Global_Objects/Map/get\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Map.get\n---\n\n{{JSRef}}\n\nThe **`get()`** method of {{jsxref("Map")}} instances returns a specified element from this map. If the\nvalue that is associated to the provided key is an object, then you will get a\nreference to that object and any change made to that object will effectively\nmodify it inside the `Map` object.\n\n{{EmbedInteractiveExample("pages/js/map-prototype-get.html")}}\n\n## Syntax\n\n```js-nolint\nget(key)\n```\n\n### Parameters\n\n- `key`\n  - : The key of the element to return from the `Map` object.\n\n### Return value\n\nThe element associated with the specified key, or\n{{jsxref("undefined")}} if the key can\'t be found in the `Map` object.\n\n## Examples\n\n### Using get()\n\n```js\nconst myMap = new Map();\nmyMap.set("bar", "foo");\n\nconsole.log(myMap.get("bar")); // Returns "foo"\nconsole.log(myMap.get("baz")); // Returns undefined\n```\n\n### Using get() to retrieve a reference to an object\n\n```js\nconst arr = [];\nconst myMap = new Map();\nmyMap.set("bar", arr);\n\nmyMap.get("bar").push("foo");\n\nconsole.log(arr); // ["foo"]\nconsole.log(myMap.get("bar")); // ["foo"]\n```\n\nNote that the map holding a reference to the original object effectively means the object cannot be garbage-collected, which may lead to unexpected memory issues. If you want the object stored in the map to have the same lifespan as the original one, consider using a {{jsxref("WeakMap")}}.\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Map")}}\n- {{jsxref("Map.prototype.set()")}}\n- {{jsxref("Map.prototype.has()")}}\n'
        },
        "groupby": {
            "index.md": '---\ntitle: Map.groupBy()\nslug: Web/JavaScript/Reference/Global_Objects/Map/groupBy\npage-type: javascript-static-method\nbrowser-compat: javascript.builtins.Map.groupBy\n---\n\n{{JSRef}}\n\n> **Note:** In some versions of some browsers, this method was implemented as the method `Array.prototype.groupToMap()`. Due to web compatibility issues, it is now implemented as a static method. Check the [browser compatibility table](#browser_compatibility) for details.\n\nThe **`Map.groupBy()`** static method groups the elements of a given iterable using the values returned by a provided callback function. The final returned {{jsxref("Map")}} uses the unique values from the test function as keys, which can be used to get the array of elements in each group.\n\nThe method is primarily useful when grouping elements that are associated with an object, and in particular when that object might change over time. If the object is invariant, you might instead represent it using a string, and group elements with {{jsxref("Object.groupBy()")}}.\n\n{{EmbedInteractiveExample("pages/js/map-groupby.html", "taller")}}\n\n## Syntax\n\n```js-nolint\nMap.groupBy(items, callbackFn)\n```\n\n### Parameters\n\n- `items`\n  - : An [iterable](/en-US/docs/Web/JavaScript/Reference/Iteration_protocols#the_iterable_protocol) (such as an {{jsxref("Array")}}) whose elements will be grouped.\n- `callbackFn`\n  - : A function to execute for each element in the iterable. It should return a value ({{Glossary("object")}} or {{Glossary("primitive")}}) indicating the group of the current element. The function is called with the following arguments:\n    - `element`\n      - : The current element being processed.\n    - `index`\n      - : The index of the current element being processed.\n\n### Return value\n\nA {{jsxref("Map")}} object with keys for each group, each assigned to an array containing the elements of the associated group.\n\n## Description\n\n`Map.groupBy()` calls a provided `callbackFn` function once for each element in an iterable. The callback function should return a value indicating the group of the associated element. The values returned by `callbackFn` are used as keys for the {{jsxref("Map")}} returned by `Map.groupBy()`. Each key has an associated array containing all the elements for which the callback returned the same value.\n\nThe elements in the returned {{jsxref("Map")}} and the original iterable are the same (not {{Glossary("deep copy", "deep copies")}}). Changing the internal structure of the elements will be reflected in both the original iterable and the returned {{jsxref("Map")}}.\n\nThis method is useful when you need to group information that is related to a particular object that might potentially change over time. This is because even if the object is modified, it will continue to work as a key to the returned `Map`. If you instead create a string representation for the object and use that as a grouping key in {{jsxref("Object.groupBy()")}}, you must maintain the mapping between the original object and its representation as the object changes.\n\n> **Note:** To access the groups in the returned `Map`, you must use the same object that was originally used as a key in the `Map` (although you may modify its properties). You can\'t use another object that just happens to have the same name and properties.\n\n`Map.groupBy` does not read the value of `this`. It can be called on any object and a new {{jsxref("Map")}} instance will be returned.\n\n## Examples\n\n### Using Map.groupBy()\n\nFirst we define an array containing objects representing an inventory of different foodstuffs. Each food has a `type` and a `quantity`.\n\n```js\nconst inventory = [\n  { name: "asparagus", type: "vegetables", quantity: 9 },\n  { name: "bananas", type: "fruit", quantity: 5 },\n  { name: "goat", type: "meat", quantity: 23 },\n  { name: "cherries", type: "fruit", quantity: 12 },\n  { name: "fish", type: "meat", quantity: 22 },\n];\n```\n\nThe code below uses `Map.groupBy()` with an arrow function that returns the object keys named `restock` or `sufficient`, depending on whether the element has `quantity < 6`. The returned `result` object is a `Map` so we need to call `get()` with the key to obtain the array.\n\n```js\nconst restock = { restock: true };\nconst sufficient = { restock: false };\nconst result = Map.groupBy(inventory, ({ quantity }) =>\n  quantity < 6 ? restock : sufficient,\n);\nconsole.log(result.get(restock));\n// [{ name: "bananas", type: "fruit", quantity: 5 }]\n```\n\nNote that the function argument `{ quantity }` is a basic example of [object destructuring syntax for function arguments](/en-US/docs/Web/JavaScript/Reference/Operators/Destructuring_assignment#unpacking_properties_from_objects_passed_as_a_function_parameter). This unpacks the `quantity` property of an object passed as a parameter, and assigns it to a variable named `quantity` in the body of the function. This is a very succinct way to access the relevant values of elements within a function.\n\nThe key to a `Map` can be modified and still used. However you can\'t recreate the key and still use it. For this reason it is important that anything that needs to use the map keeps a reference to its keys.\n\n```js\n// The key can be modified and still used\nrestock["fast"] = true;\nconsole.log(result.get(restock));\n// [{ name: "bananas", type: "fruit", quantity: 5 }]\n\n// A new key can\'t be used, even if it has the same structure!\nconst restock2 = { restock: true };\nconsole.log(result.get(restock2)); // undefined\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Map.groupBy` in `core-js`](https://github.com/zloirock/core-js#array-grouping)\n- [Indexed collections](/en-US/docs/Web/JavaScript/Guide/Indexed_collections) guide\n- {{jsxref("Array.prototype.reduce()")}}\n- {{jsxref("Map/Map", "Map()")}}\n- {{jsxref("Object.groupBy()")}}\n'
        },
        "has": {
            "index.md": '---\ntitle: Map.prototype.has()\nslug: Web/JavaScript/Reference/Global_Objects/Map/has\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Map.has\n---\n\n{{JSRef}}\n\nThe **`has()`** method of {{jsxref("Map")}} instances returns a boolean indicating whether an element with the\nspecified key exists in this map or not.\n\n{{EmbedInteractiveExample("pages/js/map-prototype-has.html")}}\n\n## Syntax\n\n```js-nolint\nhas(key)\n```\n\n### Parameters\n\n- `key`\n  - : The key of the element to test for presence in the `Map` object.\n\n### Return value\n\n`true` if an element with the specified key exists in the `Map` object;\notherwise `false`.\n\n## Examples\n\n### Using has()\n\n```js\nconst myMap = new Map();\nmyMap.set("bar", "foo");\n\nconsole.log(myMap.has("bar")); // true\nconsole.log(myMap.has("baz")); // false\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Map")}}\n- {{jsxref("Map.prototype.set()")}}\n- {{jsxref("Map.prototype.get()")}}\n'
        },
        "index.md": '---\ntitle: Map\nslug: Web/JavaScript/Reference/Global_Objects/Map\npage-type: javascript-class\nbrowser-compat: javascript.builtins.Map\n---\n\n{{JSRef}}\n\nThe **`Map`** object holds key-value pairs and remembers the original insertion order of the keys.\nAny value (both objects and {{Glossary("Primitive", "primitive values")}}) may be used as either a key or a value.\n\n{{EmbedInteractiveExample("pages/js/map.html", "taller")}}\n\n## Description\n\n`Map` objects are collections of key-value pairs. A key in the `Map` **may only occur once**; it is unique in the `Map`\'s collection. A `Map` object is iterated by key-value pairs \u2014 a {{jsxref("Statements/for...of", "for...of")}} loop returns a 2-member array of `[key, value]` for each iteration. Iteration happens in _insertion order_, which corresponds to the order in which each key-value pair was first inserted into the map by the [`set()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map/set) method (that is, there wasn\'t a key with the same value already in the map when `set()` was called).\n\nThe specification requires maps to be implemented "that, on average, provide access times that are sublinear on the number of elements in the collection". Therefore, it could be represented internally as a hash table (with O(1) lookup), a search tree (with O(log(N)) lookup), or any other data structure, as long as the complexity is better than O(N).\n\n### Key equality\n\nValue equality is based on the [SameValueZero](/en-US/docs/Web/JavaScript/Equality_comparisons_and_sameness#same-value-zero_equality) algorithm. (It used to use [SameValue](/en-US/docs/Web/JavaScript/Equality_comparisons_and_sameness#same-value_equality_using_object.is), which treated `0` and `-0` as different. Check [browser compatibility](#browser_compatibility).) This means {{jsxref("NaN")}} is considered the same as `NaN` (even though `NaN !== NaN`) and all other values are considered equal according to the semantics of the `===` operator.\n\n### Objects vs. Maps\n\n{{jsxref("Object")}} is similar to `Map`\u2014both let you set keys to\nvalues, retrieve those values, delete keys, and detect whether something is\nstored at a key. For this reason (and because there were no built-in\nalternatives), `Object` has been used as `Map` historically.\n\nHowever, there are important differences that make `Map` preferable in some\ncases:\n\n<table class="standard-table">\n  <thead>\n    <tr>\n      <th scope="row"></th>\n      <th scope="col">Map</th>\n      <th scope="col">Object</th>\n    </tr>\n  </thead>\n  <tbody>\n    <tr>\n      <th scope="row">Accidental Keys</th>\n      <td>\n        A <code>Map</code> does not contain any keys by default. It only\n        contains what is explicitly put into it.\n      </td>\n      <td>\n        <p>\n          An <code>Object</code> has a prototype, so it contains default keys\n          that could collide with your own keys if you\'re not careful.\n        </p>\n        <div class="notecard note">\n          <p>\n            <strong>Note:</strong> This can be bypassed by using\n            {{jsxref("Object.create", "Object.create(null)")}},\n            but this is seldom done.\n          </p>\n        </div>\n      </td>\n    </tr>\n    <tr>\n      <th scope="row">Security</th>\n      <td>\n        A <code>Map</code> is safe to use with user-provided keys and values.\n      </td>\n      <td>\n        <p>\n          Setting user-provided key-value pairs on an <code>Object</code> may allow\n          an attacker to override the object\'s prototype, which can lead to\n          <a href="https://github.com/eslint-community/eslint-plugin-security/blob/main/docs/the-dangers-of-square-bracket-notation.md">\n            object injection attacks\n          </a>. Like the accidental keys issue, this can also be mitigated by using\n          a <code>null</code>-prototype object.\n        </p>\n      </td>\n    </tr>\n    <tr>\n      <th scope="row">Key Types</th>\n      <td>\n        A <code>Map</code>\'s keys can be any value (including functions,\n        objects, or any primitive).\n      </td>\n      <td>\n        The keys of an <code>Object</code> must be either a\n        {{jsxref("String")}} or a {{jsxref("Symbol")}}.\n      </td>\n    </tr>\n    <tr>\n      <th scope="row">Key Order</th>\n      <td>\n        <p>\n          The keys in <code>Map</code> are ordered in a simple, straightforward\n          way: A <code>Map</code> object iterates entries, keys, and values in\n          the order of entry insertion.\n        </p>\n      </td>\n      <td>\n        <p>\n          Although the keys of an ordinary <code>Object</code> are ordered now,\n          this was not always the case, and the order is complex. As a result,\n          it\'s best not to rely on property order.\n        </p>\n        <p>\n          The order was first defined for own properties only in ECMAScript\n          2015; ECMAScript 2020 defines order for inherited properties as well.\n          But note that no single mechanism\n          iterates\n          <strong>all</strong> of an object\'s properties; the various mechanisms\n          each include different subsets of properties.\n          ({{jsxref("Statements/for...in",\n          "for-in")}}\n          includes only enumerable string-keyed properties;\n          {{jsxref("Object.keys")}} includes only own, enumerable,\n          string-keyed properties;\n          {{jsxref("Object.getOwnPropertyNames")}} includes own,\n          string-keyed properties even if non-enumerable;\n          {{jsxref("Object.getOwnPropertySymbols")}} does the same\n          for just <code>Symbol</code>-keyed properties, etc.)\n        </p>\n      </td>\n    </tr>\n    <tr>\n      <th scope="row"><p>Size</p></th>\n      <td>\n        The number of items in a <code>Map</code> is easily retrieved from its\n        {{jsxref("Map.prototype.size", "size")}} property.\n      </td>\n      <td>\n        Determining the number of items in an <code>Object</code> is more roundabout and less efficient. A common way to do it is through the {{jsxref("Array/length", "length")}} of the array returned from {{jsxref("Object.keys()")}}.\n      </td>\n    </tr>\n    <tr>\n      <th scope="row">Iteration</th>\n      <td>\n        A <code>Map</code> is an\n        <a href="/en-US/docs/Web/JavaScript/Reference/Iteration_protocols"\n          >iterable</a\n        >, so it can be directly iterated.\n      </td>\n      <td>\n        <p>\n          <code>Object</code> does not implement an <a\n            href="/en-US/docs/Web/JavaScript/Reference/Iteration_protocols#the_iterable_protocol"\n            >iteration protocol</a\n          >, and so objects are not directly iterable using the JavaScript\n          <a href="/en-US/docs/Web/JavaScript/Reference/Statements/for...of"\n            >for...of</a\n          >\n          statement (by default).\n        </p>\n        <div class="notecard note">\n          <p><strong>Note:</strong></p>\n          <ul>\n            <li>\n              An object can implement the iteration protocol, or you can get an\n              iterable for an object using <a\n                href="/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/keys"\n                ><code>Object.keys</code></a\n              > or <a\n                href="/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/entries"\n                ><code>Object.entries</code></a\n              >.\n            </li>\n            <li>\n              The\n              <a href="/en-US/docs/Web/JavaScript/Reference/Statements/for...in"\n                >for...in</a\n              >\n              statement allows you to iterate over the\n              <em>enumerable</em> properties of an object.\n            </li>\n          </ul>\n        </div>\n      </td>\n    </tr>\n    <tr>\n      <th scope="row">Performance</th>\n      <td>\n        <p>\n          Performs better in scenarios involving frequent additions and removals\n          of key-value pairs.\n        </p>\n      </td>\n      <td>\n        <p>\n          Not optimized for frequent additions and removals of key-value pairs.\n        </p>\n      </td>\n    </tr>\n    <tr>\n      <th scope="row">Serialization and parsing</th>\n      <td>\n        <p>No native support for serialization or parsing.</p>\n        <p>\n          (But you can build your own serialization and parsing support for\n          <code>Map</code> by using {{jsxref("JSON.stringify()")}}\n          with its <em>replacer</em> argument, and by using\n          {{jsxref("JSON.parse()")}} with its\n          <em>reviver</em> argument. See the Stack Overflow question\n          <a href="https://stackoverflow.com/q/29085197/"\n            >How do you JSON.stringify an ES6 Map?</a\n          >).\n        </p>\n      </td>\n      <td>\n        <p>\n          Native support for serialization from {{jsxref("Object")}} to\n          JSON, using {{jsxref("JSON.stringify()")}}.\n        </p>\n        <p>\n          Native support for parsing from JSON to {{jsxref("Object")}},\n          using {{jsxref("JSON.parse()")}}.\n        </p>\n      </td>\n    </tr>\n  </tbody>\n</table>\n\n### Setting object properties\n\nSetting Object properties works for Map objects as well, and can cause\nconsiderable confusion.\n\nTherefore, this appears to work in a way:\n\n```js example-bad\nconst wrongMap = new Map();\nwrongMap["bla"] = "blaa";\nwrongMap["bla2"] = "blaaa2";\n\nconsole.log(wrongMap); // Map { bla: \'blaa\', bla2: \'blaaa2\' }\n```\n\nBut that way of setting a property does not interact with the Map data\nstructure. It uses the feature of the generic object. The value of \'bla\' is not\nstored in the Map for queries. Other operations on the data fail:\n\n```js example-bad\nwrongMap.has("bla"); // false\nwrongMap.delete("bla"); // false\nconsole.log(wrongMap); // Map { bla: \'blaa\', bla2: \'blaaa2\' }\n```\n\nThe correct usage for storing data in the Map is through the `set(key, value)`\nmethod.\n\n```js example-good\nconst contacts = new Map();\ncontacts.set("Jessie", { phone: "213-555-1234", address: "123 N 1st Ave" });\ncontacts.has("Jessie"); // true\ncontacts.get("Hilary"); // undefined\ncontacts.set("Hilary", { phone: "617-555-4321", address: "321 S 2nd St" });\ncontacts.get("Jessie"); // {phone: "213-555-1234", address: "123 N 1st Ave"}\ncontacts.delete("Raymond"); // false\ncontacts.delete("Jessie"); // true\nconsole.log(contacts.size); // 1\n```\n\n### Map-like browser APIs\n\n**Browser `Map`-like objects** (or "maplike objects") are [Web API](/en-US/docs/Web/API) interfaces that behave in many ways like a `Map`.\n\nJust like `Map`, entries can be iterated in the same order that they were added to the object.\n`Map`-like objects and `Map` also have properties and methods that share the same name and behavior.\nHowever unlike `Map` they only allow specific predefined types for the keys and values of each entry.\n\nThe allowed types are set in the specification IDL definition.\nFor example, {{domxref("RTCStatsReport")}} is a `Map`-like object that must use strings for keys and objects for values.\nThis is defined in the specification IDL below:\n\n```webidl\ninterface RTCStatsReport {\n  readonly maplike<DOMString, object>;\n};\n```\n\n`Map`-like objects are either read-only or read-writable (see the `readonly` keyword in the IDL above).\n\n- Read-only `Map`-like objects have the property [`size`](#map.prototype.size), and the methods: [`entries()`](#map.prototype.entries), [`forEach()`](#map.prototype.foreach), [`get()`](#map.prototype.get), [`has()`](#map.prototype.has), [`keys()`](#map.prototype.keys), [`values()`](#map.prototype.values), and [`@@iterator`](#map.prototypeiterator).\n- Writeable `Map`-like objects additionally have the methods: [`clear()`](#map.prototype.clear), [`delete()`](#map.prototype.delete), and [`set()`](#map.prototype.set).\n\nThe methods and properties have the same behavior as the equivalent entities in `Map`, except for the restriction on the types of the keys and values.\n\nThe following are examples of read-only `Map`-like browser objects:\n\n- {{domxref("AudioParamMap")}}\n- {{domxref("RTCStatsReport")}}\n- {{domxref("EventCounts")}}\n- {{domxref("KeyboardLayoutMap")}}\n- {{domxref("MIDIInputMap")}}\n- {{domxref("MIDIOutputMap")}}\n\n## Constructor\n\n- {{jsxref("Map/Map", "Map()")}}\n  - : Creates a new `Map` object.\n\n## Static properties\n\n- {{jsxref("Map/@@species", "Map[@@species]")}}\n  - : The constructor function that is used to create derived objects.\n\n## Static methods\n\n- {{jsxref("Map.groupBy()")}}\n  - : Groups the elements of a given iterable using the values returned by a provided callback function. The final returned `Map` uses the unique values from the test function as keys, which can be used to get the array of elements in each group.\n\n## Instance properties\n\nThese properties are defined on `Map.prototype` and shared by all `Map` instances.\n\n- {{jsxref("Object/constructor", "Map.prototype.constructor")}}\n  - : The constructor function that created the instance object. For `Map` instances, the initial value is the {{jsxref("Map/Map", "Map")}} constructor.\n- {{jsxref("Map.prototype.size")}}\n  - : Returns the number of key/value pairs in the `Map` object.\n- `Map.prototype[@@toStringTag]`\n  - : The initial value of the [`@@toStringTag`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol/toStringTag) property is the string `"Map"`. This property is used in {{jsxref("Object.prototype.toString()")}}.\n\n## Instance methods\n\n- {{jsxref("Map.prototype.clear()")}}\n  - : Removes all key-value pairs from the `Map` object.\n- {{jsxref("Map.prototype.delete()")}}\n  - : Returns `true` if an element in the `Map` object existed and has been\n    removed, or `false` if the element does not exist. `map.has(key)`\n    will return `false` afterwards.\n- {{jsxref("Map.prototype.entries()")}}\n  - : Returns a new Iterator object that contains a two-member array of `[key, value]` for each element in the `Map` object in insertion order.\n- {{jsxref("Map.prototype.forEach()")}}\n  - : Calls `callbackFn` once for each key-value pair present in the `Map` object, in insertion order. If a `thisArg` parameter is provided to `forEach`, it will be used as the `this` value for each callback.\n- {{jsxref("Map.prototype.get()")}}\n  - : Returns the value associated to the passed key, or `undefined` if there is none.\n- {{jsxref("Map.prototype.has()")}}\n  - : Returns a boolean indicating whether a value has been associated with the passed key in the `Map` object or not.\n- {{jsxref("Map.prototype.keys()")}}\n  - : Returns a new Iterator object that contains the keys for each element in the `Map` object in insertion order.\n- {{jsxref("Map.prototype.set()")}}\n  - : Sets the value for the passed key in the `Map` object. Returns the `Map` object.\n- {{jsxref("Map.prototype.values()")}}\n  - : Returns a new Iterator object that contains the values for each element in the `Map` object in insertion order.\n- [`Map.prototype[@@iterator]()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map/@@iterator)\n  - : Returns a new Iterator object that contains a two-member array of `[key, value]` for each element in the `Map` object in insertion order.\n\n## Examples\n\n### Using the Map object\n\n```js\nconst myMap = new Map();\n\nconst keyString = "a string";\nconst keyObj = {};\nconst keyFunc = function () {};\n\n// setting the values\nmyMap.set(keyString, "value associated with \'a string\'");\nmyMap.set(keyObj, "value associated with keyObj");\nmyMap.set(keyFunc, "value associated with keyFunc");\n\nconsole.log(myMap.size); // 3\n\n// getting the values\nconsole.log(myMap.get(keyString)); // "value associated with \'a string\'"\nconsole.log(myMap.get(keyObj)); // "value associated with keyObj"\nconsole.log(myMap.get(keyFunc)); // "value associated with keyFunc"\n\nconsole.log(myMap.get("a string")); // "value associated with \'a string\'", because keyString === \'a string\'\nconsole.log(myMap.get({})); // undefined, because keyObj !== {}\nconsole.log(myMap.get(function () {})); // undefined, because keyFunc !== function () {}\n```\n\n### Using NaN as Map keys\n\n{{jsxref("NaN")}} can also be used as a key. Even though every `NaN` is\nnot equal to itself (`NaN !== NaN` is true), the following example works because\n`NaN`s are indistinguishable from each other:\n\n```js\nconst myMap = new Map();\nmyMap.set(NaN, "not a number");\n\nmyMap.get(NaN);\n// "not a number"\n\nconst otherNaN = Number("foo");\nmyMap.get(otherNaN);\n// "not a number"\n```\n\n### Iterating Map with for...of\n\nMaps can be iterated using a `for...of` loop:\n\n```js\nconst myMap = new Map();\nmyMap.set(0, "zero");\nmyMap.set(1, "one");\n\nfor (const [key, value] of myMap) {\n  console.log(`${key} = ${value}`);\n}\n// 0 = zero\n// 1 = one\n\nfor (const key of myMap.keys()) {\n  console.log(key);\n}\n// 0\n// 1\n\nfor (const value of myMap.values()) {\n  console.log(value);\n}\n// zero\n// one\n\nfor (const [key, value] of myMap.entries()) {\n  console.log(`${key} = ${value}`);\n}\n// 0 = zero\n// 1 = one\n```\n\n### Iterating Map with forEach()\n\nMaps can be iterated using the\n{{jsxref("Map/forEach", "forEach()")}} method:\n\n```js\nmyMap.forEach((value, key) => {\n  console.log(`${key} = ${value}`);\n});\n// 0 = zero\n// 1 = one\n```\n\n### Relation with Array objects\n\n```js\nconst kvArray = [\n  ["key1", "value1"],\n  ["key2", "value2"],\n];\n\n// Use the regular Map constructor to transform a 2D key-value Array into a map\nconst myMap = new Map(kvArray);\n\nconsole.log(myMap.get("key1")); // "value1"\n\n// Use Array.from() to transform a map into a 2D key-value Array\nconsole.log(Array.from(myMap)); // Will show you exactly the same Array as kvArray\n\n// A succinct way to do the same, using the spread syntax\nconsole.log([...myMap]);\n\n// Or use the keys() or values() iterators, and convert them to an array\nconsole.log(Array.from(myMap.keys())); // ["key1", "key2"]\n```\n\n### Cloning and merging Maps\n\nJust like `Array`s, `Map`s can be cloned:\n\n```js\nconst original = new Map([[1, "one"]]);\n\nconst clone = new Map(original);\n\nconsole.log(clone.get(1)); // one\nconsole.log(original === clone); // false (useful for shallow comparison)\n```\n\n> **Note:** Keep in mind that _the data itself_ is not cloned.\n\nMaps can be merged, maintaining key uniqueness:\n\n```js\nconst first = new Map([\n  [1, "one"],\n  [2, "two"],\n  [3, "three"],\n]);\n\nconst second = new Map([\n  [1, "uno"],\n  [2, "dos"],\n]);\n\n// Merge two maps. The last repeated key wins.\n// Spread syntax essentially converts a Map to an Array\nconst merged = new Map([...first, ...second]);\n\nconsole.log(merged.get(1)); // uno\nconsole.log(merged.get(2)); // dos\nconsole.log(merged.get(3)); // three\n```\n\nMaps can be merged with Arrays, too:\n\n```js\nconst first = new Map([\n  [1, "one"],\n  [2, "two"],\n  [3, "three"],\n]);\n\nconst second = new Map([\n  [1, "uno"],\n  [2, "dos"],\n]);\n\n// Merge maps with an array. The last repeated key wins.\nconst merged = new Map([...first, ...second, [1, "eins"]]);\n\nconsole.log(merged.get(1)); // eins\nconsole.log(merged.get(2)); // dos\nconsole.log(merged.get(3)); // three\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill for `Map` in `core-js`](https://github.com/zloirock/core-js#map)\n- {{jsxref("Set")}}\n- {{jsxref("WeakMap")}}\n- {{jsxref("WeakSet")}}\n',
        "keys": {
            "index.md": '---\ntitle: Map.prototype.keys()\nslug: Web/JavaScript/Reference/Global_Objects/Map/keys\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Map.keys\n---\n\n{{JSRef}}\n\nThe **`keys()`** method of {{jsxref("Map")}} instances returns a new _[map iterator](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Iterator)_ object that contains the keys for each element in this map in insertion order.\n\n{{EmbedInteractiveExample("pages/js/map-prototype-keys.html")}}\n\n## Syntax\n\n```js-nolint\nkeys()\n```\n\n### Parameters\n\nNone.\n\n### Return value\n\nA new [iterable iterator object](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Iterator).\n\n## Examples\n\n### Using keys()\n\n```js\nconst myMap = new Map();\nmyMap.set("0", "foo");\nmyMap.set(1, "bar");\nmyMap.set({}, "baz");\n\nconst mapIter = myMap.keys();\n\nconsole.log(mapIter.next().value); // "0"\nconsole.log(mapIter.next().value); // 1\nconsole.log(mapIter.next().value); // {}\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Map.prototype.entries()")}}\n- {{jsxref("Map.prototype.values()")}}\n'
        },
        "map": {
            "index.md": '---\ntitle: Map() constructor\nslug: Web/JavaScript/Reference/Global_Objects/Map/Map\npage-type: javascript-constructor\nbrowser-compat: javascript.builtins.Map.Map\n---\n\n{{JSRef}}\n\nThe **`Map()`** constructor creates {{jsxref("Map")}} objects.\n\n## Syntax\n\n```js-nolint\nnew Map()\nnew Map(iterable)\n```\n\n> **Note:** `Map()` can only be constructed with [`new`](/en-US/docs/Web/JavaScript/Reference/Operators/new). Attempting to call it without `new` throws a {{jsxref("TypeError")}}.\n\n### Parameters\n\n- `iterable` {{optional_inline}}\n  - : An {{jsxref("Array")}} or other\n    [iterable](/en-US/docs/Web/JavaScript/Reference/Iteration_protocols) object\n    whose elements are key-value pairs. (For example, arrays with two elements,\n    such as `[[ 1, \'one\' ],[ 2, \'two\' ]]`.) Each key-value pair is added to the\n    new `Map`.\n\n## Examples\n\n### Creating a new Map\n\n```js\nconst myMap = new Map([\n  [1, "one"],\n  [2, "two"],\n  [3, "three"],\n]);\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill for `Map` in `core-js`](https://github.com/zloirock/core-js#map)\n- {{jsxref("Set")}}\n- {{jsxref("WeakMap")}}\n- {{jsxref("WeakSet")}}\n'
        },
        "set": {
            "index.md": '---\ntitle: Map.prototype.set()\nslug: Web/JavaScript/Reference/Global_Objects/Map/set\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Map.set\n---\n\n{{JSRef}}\n\nThe **`set()`** method of {{jsxref("Map")}} instances adds or updates an entry in this map with a specified key and a value.\n\n{{EmbedInteractiveExample("pages/js/map-prototype-set.html")}}\n\n## Syntax\n\n```js-nolint\nset(key, value)\n```\n\n### Parameters\n\n- `key`\n  - : The key of the element to add to the `Map` object. The key may be any [JavaScript type](/en-US/docs/Web/JavaScript/Data_structures) (any [primitive value](/en-US/docs/Web/JavaScript/Data_structures#primitive_values) or any type of [JavaScript object](/en-US/docs/Web/JavaScript/Data_structures#objects)).\n- `value`\n  - : The value of the element to add to the `Map` object. The value may be any [JavaScript type](/en-US/docs/Web/JavaScript/Data_structures) (any [primitive value](/en-US/docs/Web/JavaScript/Data_structures#primitive_values) or any type of [JavaScript object](/en-US/docs/Web/JavaScript/Data_structures#objects)).\n\n### Return value\n\nThe `Map` object.\n\n## Examples\n\n### Using set()\n\n```js\nconst myMap = new Map();\n\n// Add new elements to the map\nmyMap.set("bar", "foo");\nmyMap.set(1, "foobar");\n\n// Update an element in the map\nmyMap.set("bar", "baz");\n```\n\n### Using the set() with chaining\n\nSince the `set()` method returns back the same `Map` object, you can chain the\nmethod call like below:\n\n```js\n// Add new elements to the map with chaining.\nmyMap.set("bar", "foo").set(1, "foobar").set(2, "baz");\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Map")}}\n- {{jsxref("Map.prototype.get()")}}\n- {{jsxref("Map.prototype.has()")}}\n'
        },
        "size": {
            "index.md": '---\ntitle: Map.prototype.size\nslug: Web/JavaScript/Reference/Global_Objects/Map/size\npage-type: javascript-instance-accessor-property\nbrowser-compat: javascript.builtins.Map.size\n---\n\n{{JSRef}}\n\nThe **`size`** accessor property of {{jsxref("Map")}} instances returns the number of elements in this map.\n\n{{EmbedInteractiveExample("pages/js/map-prototype-size.html")}}\n\n## Description\n\nThe value of `size` is an integer representing how many entries the `Map` object\nhas. A set accessor function for `size` is `undefined`; you can not change this\nproperty.\n\n## Examples\n\n### Using size\n\n```js\nconst myMap = new Map();\nmyMap.set("a", "alpha");\nmyMap.set("b", "beta");\nmyMap.set("g", "gamma");\n\nconsole.log(myMap.size); // 3\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Map")}}\n'
        },
        "values": {
            "index.md": '---\ntitle: Map.prototype.values()\nslug: Web/JavaScript/Reference/Global_Objects/Map/values\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Map.values\n---\n\n{{JSRef}}\n\nThe **`values()`** method of {{jsxref("Map")}} instances returns a new _[map iterator](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Iterator)_ object that contains the values for each element in this map in insertion order.\n\n{{EmbedInteractiveExample("pages/js/map-prototype-values.html")}}\n\n## Syntax\n\n```js-nolint\nvalues()\n```\n\n### Parameters\n\nNone.\n\n### Return value\n\nA new [iterable iterator object](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Iterator).\n\n## Examples\n\n### Using values()\n\n```js\nconst myMap = new Map();\nmyMap.set("0", "foo");\nmyMap.set(1, "bar");\nmyMap.set({}, "baz");\n\nconst mapIter = myMap.values();\n\nconsole.log(mapIter.next().value); // "foo"\nconsole.log(mapIter.next().value); // "bar"\nconsole.log(mapIter.next().value); // "baz"\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Map.prototype.entries()")}}\n- {{jsxref("Map.prototype.keys()")}}\n'
        }
    },
    "math": {
        "abs": {
            "index.md": '---\ntitle: Math.abs()\nslug: Web/JavaScript/Reference/Global_Objects/Math/abs\npage-type: javascript-static-method\nbrowser-compat: javascript.builtins.Math.abs\n---\n\n{{JSRef}}\n\nThe **`Math.abs()`** static method returns the absolute value of a number.\n\n{{EmbedInteractiveExample("pages/js/math-abs.html")}}\n\n## Syntax\n\n```js-nolint\nMath.abs(x)\n```\n\n### Parameters\n\n- `x`\n  - : A number.\n\n### Return value\n\nThe absolute value of `x`. If `x` is negative (including `-0`), returns `-x`. Otherwise, returns `x`. The result is therefore always a positive number or `0`.\n\n## Description\n\nBecause `abs()` is a static method of `Math`, you always use it as `Math.abs()`, rather than as a method of a `Math` object you created (`Math` is not a constructor).\n\n## Examples\n\n### Using Math.abs()\n\n```js\nMath.abs(-Infinity); // Infinity\nMath.abs(-1); // 1\nMath.abs(-0); // 0\nMath.abs(0); // 0\nMath.abs(1); // 1\nMath.abs(Infinity); // Infinity\n```\n\n### Coercion of parameter\n\n`Math.abs()` [coerces its parameter to a number](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number#number_coercion). Non-coercible values will become `NaN`, making `Math.abs()` also return `NaN`.\n\n```js\nMath.abs("-1"); // 1\nMath.abs(-2); // 2\nMath.abs(null); // 0\nMath.abs(""); // 0\nMath.abs([]); // 0\nMath.abs([2]); // 2\nMath.abs([1, 2]); // NaN\nMath.abs({}); // NaN\nMath.abs("string"); // NaN\nMath.abs(); // NaN\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Math.ceil()")}}\n- {{jsxref("Math.floor()")}}\n- {{jsxref("Math.round()")}}\n- {{jsxref("Math.sign()")}}\n- {{jsxref("Math.trunc()")}}\n'
        },
        "acos": {
            "index.md": '---\ntitle: Math.acos()\nslug: Web/JavaScript/Reference/Global_Objects/Math/acos\npage-type: javascript-static-method\nbrowser-compat: javascript.builtins.Math.acos\n---\n\n{{JSRef}}\n\nThe **`Math.acos()`** static method returns the inverse cosine (in radians) of a number. That is,\n\n<math display="block"><semantics><mrow><mo>\u2200</mo><mi>x</mi><mo>\u220A</mo><mo stretchy="false">[</mo><mrow><mo>\u2212</mo><mn>1</mn></mrow><mo>,</mo><mn>1</mn><mo stretchy="false">]</mo><mo>,</mo><mspace width="0.2777777777777778em"></mspace><mrow><mo lspace="0em" rspace="0.16666666666666666em">\uD835\uDE7C\uD835\uDE8A\uD835\uDE9D\uD835\uDE91.\uD835\uDE8A\uD835\uDE8C\uD835\uDE98\uD835\uDE9C</mo><mo stretchy="false">(</mo><mi>\uD835\uDEA1</mi><mo stretchy="false">)</mo></mrow><mo>=</mo><mo lspace="0em" rspace="0em">arccos</mo><mo stretchy="false">(</mo><mi>x</mi><mo stretchy="false">)</mo><mo>=</mo><mtext>the unique&nbsp;</mtext><mi>y</mi><mo>\u220A</mo><mo stretchy="false">[</mo><mn>0</mn><mo>,</mo><mi>\u03C0</mi><mo stretchy="false">]</mo><mtext>&nbsp;such that&nbsp;</mtext><mo lspace="0em" rspace="0em">cos</mo><mo stretchy="false">(</mo><mi>y</mi><mo stretchy="false">)</mo><mo>=</mo><mi>x</mi></mrow><annotation encoding="TeX">\\forall x \\in [{-1}, 1],\\;\\mathtt{\\operatorname{Math.acos}(x)} = \\arccos(x) = \\text{the unique } y \\in [0, \\pi] \\text{ such that } \\cos(y) = x</annotation></semantics></math>\n\n{{EmbedInteractiveExample("pages/js/math-acos.html")}}\n\n## Syntax\n\n```js-nolint\nMath.acos(x)\n```\n\n### Parameters\n\n- `x`\n  - : A number between -1 and 1, inclusive, representing the angle\'s cosine value.\n\n### Return value\n\nThe inverse cosine (angle in radians between 0 and \u03C0, inclusive) of `x`. If `x` is less than -1 or greater than 1, returns {{jsxref("NaN")}}.\n\n## Description\n\nBecause `acos()` is a static method of `Math`, you always use it as `Math.acos()`, rather than as a method of a `Math` object you created (`Math` is not a constructor).\n\n## Examples\n\n### Using Math.acos()\n\n```js\nMath.acos(-2); // NaN\nMath.acos(-1); // 3.141592653589793 (\u03C0)\nMath.acos(0); // 1.5707963267948966 (\u03C0/2)\nMath.acos(0.5); // 1.0471975511965979 (\u03C0/3)\nMath.acos(1); // 0\nMath.acos(2); // NaN\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Math.asin()")}}\n- {{jsxref("Math.atan()")}}\n- {{jsxref("Math.atan2()")}}\n- {{jsxref("Math.cos()")}}\n- {{jsxref("Math.sin()")}}\n- {{jsxref("Math.tan()")}}\n'
        },
        "acosh": {
            "index.md": '---\ntitle: Math.acosh()\nslug: Web/JavaScript/Reference/Global_Objects/Math/acosh\npage-type: javascript-static-method\nbrowser-compat: javascript.builtins.Math.acosh\n---\n\n{{JSRef}}\n\nThe **`Math.acosh()`** static method returns the inverse hyperbolic cosine of a number. That is,\n\n<math display="block"><semantics><mtable columnalign="right left right left right left right left right left" columnspacing="0em" displaystyle="true"><mtr><mtd><mo>\u2200</mo><mi>x</mi><mo>\u2265</mo><mn>1</mn><mo>,</mo><mspace width="0.2777777777777778em"></mspace><mrow><mo lspace="0em" rspace="0.16666666666666666em">\uD835\uDE7C\uD835\uDE8A\uD835\uDE9D\uD835\uDE91.\uD835\uDE8A\uD835\uDE8C\uD835\uDE98\uD835\uDE9C\uD835\uDE91</mo><mo stretchy="false">(</mo><mi>\uD835\uDEA1</mi><mo stretchy="false">)</mo></mrow></mtd><mtd><mo>=</mo><mo lspace="0em" rspace="0.16666666666666666em">arcosh</mo><mo stretchy="false">(</mo><mi>x</mi><mo stretchy="false">)</mo><mo>=</mo><mtext>the unique&nbsp;</mtext><mi>y</mi><mo>\u2265</mo><mn>0</mn><mtext>&nbsp;such that&nbsp;</mtext><mo lspace="0em" rspace="0em">cosh</mo><mo stretchy="false">(</mo><mi>y</mi><mo stretchy="false">)</mo><mo>=</mo><mi>x</mi></mtd></mtr><mtr><mtd></mtd><mtd><mo>=</mo><mo lspace="0em" rspace="0em">ln</mo><mrow><mo>(</mo><mrow><mi>x</mi><mo>+</mo><msqrt><mrow><msup><mi>x</mi><mn>2</mn></msup><mo>\u2212</mo><mn>1</mn></mrow></msqrt></mrow><mo>)</mo></mrow></mtd></mtr></mtable><annotation encoding="TeX">\\begin{aligned}\\forall x \\geq 1,\\;\\mathtt{\\operatorname{Math.acosh}(x)} &amp;= \\operatorname{arcosh}(x) = \\text{the unique } y \\geq 0 \\text{ such that } \\cosh(y) = x\\\\&amp;= \\ln\\left(x + \\sqrt{x^2 - 1}\\right)\\end{aligned}</annotation></semantics></math>\n\n{{EmbedInteractiveExample("pages/js/math-acosh.html")}}\n\n## Syntax\n\n```js-nolint\nMath.acosh(x)\n```\n\n### Parameters\n\n- `x`\n  - : A number greater than or equal to 1.\n\n### Return value\n\nThe inverse hyperbolic cosine of `x`. If `x` is less than 1, returns {{jsxref("NaN")}}.\n\n## Description\n\nBecause `acosh()` is a static method of `Math`, you always use it as `Math.acosh()`, rather than as a method of a `Math` object you created (`Math` is no constructor).\n\n## Examples\n\n### Using Math.acosh()\n\n```js\nMath.acosh(0); // NaN\nMath.acosh(1); // 0\nMath.acosh(2); // 1.3169578969248166\nMath.acosh(Infinity); // Infinity\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Math.acosh` in `core-js`](https://github.com/zloirock/core-js#ecmascript-math)\n- {{jsxref("Math.asinh()")}}\n- {{jsxref("Math.atanh()")}}\n- {{jsxref("Math.cosh()")}}\n- {{jsxref("Math.sinh()")}}\n- {{jsxref("Math.tanh()")}}\n'
        },
        "asin": {
            "index.md": '---\ntitle: Math.asin()\nslug: Web/JavaScript/Reference/Global_Objects/Math/asin\npage-type: javascript-static-method\nbrowser-compat: javascript.builtins.Math.asin\n---\n\n{{JSRef}}\n\nThe **`Math.asin()`** static method returns the inverse sine (in radians) of a number. That is,\n\n<math display="block" xmlns="http://www.w3.org/1998/Math/MathML"><semantics><mrow><mo>\u2200</mo><mi>x</mi><mo>\u220A</mo><mo stretchy="false">[</mo><mrow><mo>\u2212</mo><mn>1</mn></mrow><mo>,</mo><mn>1</mn><mo stretchy="false">]</mo><mo>,</mo><mspace width="0.2777777777777778em"></mspace><mrow><mo lspace="0em" rspace="0.16666666666666666em">\uD835\uDE7C\uD835\uDE8A\uD835\uDE9D\uD835\uDE91.\uD835\uDE8A\uD835\uDE9C\uD835\uDE92\uD835\uDE97</mo><mo stretchy="false">(</mo><mi>\uD835\uDEA1</mi><mo stretchy="false">)</mo></mrow><mo>=</mo><mo lspace="0em" rspace="0em">arcsin</mo><mo stretchy="false">(</mo><mi>x</mi><mo stretchy="false">)</mo><mo>=</mo><mtext>the unique&nbsp;</mtext><mi>y</mi><mo>\u220A</mo><mrow><mo>[</mo><mrow><mo>\u2212</mo><mfrac><mi>\u03C0</mi><mn>2</mn></mfrac><mo>,</mo><mfrac><mi>\u03C0</mi><mn>2</mn></mfrac></mrow><mo>]</mo></mrow><mtext>&nbsp;such that&nbsp;</mtext><mo lspace="0em" rspace="0em">sin</mo><mo stretchy="false">(</mo><mi>y</mi><mo stretchy="false">)</mo><mo>=</mo><mi>x</mi></mrow><annotation encoding="TeX">\\forall x \\in [{-1}, 1],\\;\\mathtt{\\operatorname{Math.asin}(x)} = \\arcsin(x) = \\text{the unique } y \\in \\left[-\\frac{\\pi}{2}, \\frac{\\pi}{2}\\right] \\text{ such that } \\sin(y) = x</annotation></semantics></math>\n\n{{EmbedInteractiveExample("pages/js/math-asin.html")}}\n\n## Syntax\n\n```js-nolint\nMath.asin(x)\n```\n\n### Parameters\n\n- `x`\n  - : A number between -1 and 1, inclusive, representing the angle\'s sine value.\n\n### Return value\n\nThe inverse sine (angle in radians between <math><semantics><mrow><mo>-</mo><mfrac><mi>\u03C0</mi><mn>2</mn></mfrac></mrow><annotation encoding="TeX">-\\frac{\\pi}{2}</annotation></semantics></math> and <math><semantics><mfrac><mi>\u03C0</mi><mn>2</mn></mfrac><annotation encoding="TeX">\\frac{\\pi}{2}</annotation></semantics></math>, inclusive) of `x`. If `x` is less than -1 or greater than 1, returns {{jsxref("NaN")}}.\n\n## Description\n\nBecause `asin()` is a static method of `Math`, you always use it as `Math.asin()`, rather than as a method of a `Math` object you created (`Math` is not a constructor).\n\n## Examples\n\n### Using Math.asin()\n\n```js\nMath.asin(-2); // NaN\nMath.asin(-1); // -1.5707963267948966 (-\u03C0/2)\nMath.asin(-0); // -0\nMath.asin(0); // 0\nMath.asin(0.5); // 0.5235987755982989 (\u03C0/6)\nMath.asin(1); // 1.5707963267948966 (\u03C0/2)\nMath.asin(2); // NaN\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Math.acos()")}}\n- {{jsxref("Math.atan()")}}\n- {{jsxref("Math.atan2()")}}\n- {{jsxref("Math.cos()")}}\n- {{jsxref("Math.sin()")}}\n- {{jsxref("Math.tan()")}}\n'
        },
        "asinh": {
            "index.md": '---\ntitle: Math.asinh()\nslug: Web/JavaScript/Reference/Global_Objects/Math/asinh\npage-type: javascript-static-method\nbrowser-compat: javascript.builtins.Math.asinh\n---\n\n{{JSRef}}\n\nThe **`Math.asinh()`** static method returns the inverse hyperbolic sine of a number. That is,\n\n<math display="block"><semantics><mtable columnalign="right left right left right left right left right left" columnspacing="0em" displaystyle="true"><mtr><mtd><mrow><mo lspace="0em" rspace="0.16666666666666666em">\uD835\uDE7C\uD835\uDE8A\uD835\uDE9D\uD835\uDE91.\uD835\uDE8A\uD835\uDE9C\uD835\uDE92\uD835\uDE97\uD835\uDE91</mo><mo stretchy="false">(</mo><mi>\uD835\uDEA1</mi><mo stretchy="false">)</mo></mrow></mtd><mtd><mo>=</mo><mo lspace="0em" rspace="0.16666666666666666em">arsinh</mo><mo stretchy="false">(</mo><mi>x</mi><mo stretchy="false">)</mo><mo>=</mo><mtext>the unique&nbsp;</mtext><mi>y</mi><mtext>&nbsp;such that&nbsp;</mtext><mo lspace="0em" rspace="0em">sinh</mo><mo stretchy="false">(</mo><mi>y</mi><mo stretchy="false">)</mo><mo>=</mo><mi>x</mi></mtd></mtr><mtr><mtd></mtd><mtd><mo>=</mo><mo lspace="0em" rspace="0em">ln</mo><mrow><mo>(</mo><mrow><mi>x</mi><mo>+</mo><msqrt><mrow><msup><mi>x</mi><mn>2</mn></msup><mo>+</mo><mn>1</mn></mrow></msqrt></mrow><mo>)</mo></mrow></mtd></mtr></mtable><annotation encoding="TeX">\\begin{aligned}\\mathtt{\\operatorname{Math.asinh}(x)} &amp;= \\operatorname{arsinh}(x) = \\text{the unique } y \\text{ such that } \\sinh(y) = x \\\\&amp;= \\ln\\left(x + \\sqrt{x^2 + 1}\\right)\\end{aligned}\n</annotation></semantics></math>\n\n{{EmbedInteractiveExample("pages/js/math-asinh.html")}}\n\n## Syntax\n\n```js-nolint\nMath.asinh(x)\n```\n\n### Parameters\n\n- `x`\n  - : A number.\n\n### Return value\n\nThe inverse hyperbolic sine of `x`.\n\n## Description\n\nBecause `asinh()` is a static method of `Math`, you always use it as `Math.asinh()`, rather than as a method of a `Math` object you created (`Math` is not a constructor).\n\n## Examples\n\n### Using Math.asinh()\n\n```js\nMath.asinh(-Infinity); // -Infinity\nMath.asinh(-1); // -0.881373587019543\nMath.asinh(-0); // -0\nMath.asinh(0); // 0\nMath.asinh(1); // 0.881373587019543\nMath.asinh(Infinity); // Infinity\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Math.asinh` in `core-js`](https://github.com/zloirock/core-js#ecmascript-math)\n- {{jsxref("Math.acosh()")}}\n- {{jsxref("Math.atanh()")}}\n- {{jsxref("Math.cosh()")}}\n- {{jsxref("Math.sinh()")}}\n- {{jsxref("Math.tanh()")}}\n'
        },
        "atan": {
            "index.md": '---\ntitle: Math.atan()\nslug: Web/JavaScript/Reference/Global_Objects/Math/atan\npage-type: javascript-static-method\nbrowser-compat: javascript.builtins.Math.atan\n---\n\n{{JSRef}}\n\nThe **`Math.atan()`** static method returns the inverse tangent (in radians) of a number, that is\n\n<math display="block"><semantics><mrow><mrow><mo lspace="0em" rspace="0.16666666666666666em">\uD835\uDE7C\uD835\uDE8A\uD835\uDE9D\uD835\uDE91.\uD835\uDE8A\uD835\uDE9D\uD835\uDE8A\uD835\uDE97</mo><mo stretchy="false">(</mo><mi>\uD835\uDEA1</mi><mo stretchy="false">)</mo></mrow><mo>=</mo><mo lspace="0em" rspace="0em">arctan</mo><mo stretchy="false">(</mo><mi>x</mi><mo stretchy="false">)</mo><mo>=</mo><mtext>the unique&nbsp;</mtext><mi>y</mi><mo>\u220A</mo><mrow><mo>[</mo><mrow><mo>\u2212</mo><mfrac><mi>\u03C0</mi><mn>2</mn></mfrac><mo>,</mo><mfrac><mi>\u03C0</mi><mn>2</mn></mfrac></mrow><mo>]</mo></mrow><mtext>&nbsp;such that&nbsp;</mtext><mo lspace="0em" rspace="0em">tan</mo><mo stretchy="false">(</mo><mi>y</mi><mo stretchy="false">)</mo><mo>=</mo><mi>x</mi></mrow><annotation encoding="TeX">\\mathtt{\\operatorname{Math.atan}(x)} = \\arctan(x) = \\text{the unique } y \\in \\left[-\\frac{\\pi}{2}, \\frac{\\pi}{2}\\right] \\text{ such that } \\tan(y) = x</annotation></semantics></math>\n\n{{EmbedInteractiveExample("pages/js/math-atan.html")}}\n\n## Syntax\n\n```js-nolint\nMath.atan(x)\n```\n\n### Parameters\n\n- `x`\n  - : A number.\n\n### Return value\n\nThe inverse tangent (angle in radians between <math><semantics><mrow><mo>-</mo><mfrac><mi>\u03C0</mi><mn>2</mn></mfrac></mrow><annotation encoding="TeX">-\\frac{\\pi}{2}</annotation></semantics></math> and <math><semantics><mfrac><mi>\u03C0</mi><mn>2</mn></mfrac><annotation encoding="TeX">\\frac{\\pi}{2}</annotation></semantics></math>, inclusive) of `x`. If `x` is {{jsxref("Infinity")}}, it returns <math><semantics><mfrac><mi>\u03C0</mi><mn>2</mn></mfrac><annotation encoding="TeX">\\frac{\\pi}{2}</annotation></semantics></math>. If `x` is `-Infinity`, it returns <math><semantics><mrow><mo>-</mo><mfrac><mi>\u03C0</mi><mn>2</mn></mfrac></mrow><annotation encoding="TeX">-\\frac{\\pi}{2}</annotation></semantics></math>.\n\n## Description\n\nBecause `atan()` is a static method of `Math`, you always use it as `Math.atan()`, rather than as a method of a `Math` object you created (`Math` is not a constructor).\n\n## Examples\n\n### Using Math.atan()\n\n```js\nMath.atan(-Infinity); // -1.5707963267948966 (-\u03C0/2)\nMath.atan(-0); // -0\nMath.atan(0); // 0\nMath.atan(1); // 0.7853981633974483  (\u03C0/4)\nMath.atan(Infinity); // 1.5707963267948966  (\u03C0/2)\n\n// The angle that the line (0,0) -- (x,y) forms with the x-axis in a Cartesian coordinate system\nconst theta = (x, y) => Math.atan(y / x);\n```\n\nNote that you may want to avoid the `theta` function and use {{jsxref("Math.atan2()")}} instead, which has a wider range (between -\u03C0 and \u03C0) and avoids outputting `NaN` for cases such as when `x` is `0`.\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Math.acos()")}}\n- {{jsxref("Math.asin()")}}\n- {{jsxref("Math.atan2()")}}\n- {{jsxref("Math.cos()")}}\n- {{jsxref("Math.sin()")}}\n- {{jsxref("Math.tan()")}}\n'
        },
        "atan2": {
            "atan2.png": '\uFFFDPNG\r\n\x1a\n\0\0\0\rIHDR\0\0\x01,\0\0\x01,\b\x03\0\0\0N\uFFFD~G\0\0\0\x04gAMA\0\0\uFFFD\uFFFD\v\uFFFDa\x05\0\0\0\x01sRGB\0\uFFFD\uFFFD\x1c\uFFFD\0\0\x02\uFFFDPLTEGpL\uFFFD\0\0\uFFFD\0\0\uFFFD\0\0\uFFFD\0\0\uFFFD\0\0\uFFFD\0\0\0\0\0\uFFFD\0\0\uFFFD\0\0\0\0\uFFFD\uFFFD\0\0\0\0\uFFFD\uFFFD\0\0\uFFFD\0\0\uFFFD\0\0\uFFFD\0\0\0\0\uFFFD\uFFFD\0\0\0\0\uFFFD\uFFFD\0\0\uFFFD\0\0\uFFFD\0\0\uFFFD\0\0\0\0\uFFFD\0\0\uFFFD\uFFFD\0\0\uFFFD\0\0\uFFFD\0\0\0\0\uFFFD\0\0\uFFFD\0\0\uFFFD\uFFFD\0\0\0\0\uFFFD\uFFFD\0\0\uFFFD\0\0\uFFFD\0\0\uFFFD\0\0\uFFFD\0\0\uFFFD\0\0\uFFFD\0\0\uFFFD\0\0\uFFFD\0\0\uFFFD\0\0\uFFFD\0\0\uFFFD\0\0\uFFFD\0\0\0\0\uFFFD\uFFFD\0\0\uFFFD\0\0\uFFFD\0\0\0\0\uFFFD\0\0\uFFFD\uFFFD\0\0\0\0\uFFFD\uFFFD\0\0\uFFFD\0\0\uFFFD\0\0\uFFFD\0\0\uFFFD\0\0\uFFFD\0\0\uFFFD\0\0\0\0\uFFFD\uFFFD\0\0\uFFFD\0\0\0\0\uFFFD\uFFFD\0\0\uFFFD\0\0\uFFFD\0\0\uFFFD\0\0\0\0\uFFFD\0\0\uFFFD\uFFFD\0\0\uFFFD\0\0\0\0\uFFFD\uFFFD\0\0\0\0\uFFFD\uFFFD\0\0\0\0\uFFFD\uFFFD\0\0\0\0\uFFFD\0\0\uFFFD\uFFFD\0\0\0\0\uFFFD\0\0\uFFFD\uFFFD\0\0\uFFFD\0\0\uFFFD\0\0\uFFFD\0\0\uFFFD\0\0\uFFFD\0\0\uFFFD\0\0\uFFFD\0\0\uFFFD\0\0\uFFFD\0\0\0\0\uFFFD\uFFFD\0\0\uFFFD\0\0\uFFFD\0\0\uFFFD\0\0\0\0\uFFFD\uFFFD\0\0\uFFFD\0\0\uFFFD\0\0\0\0\uFFFD\0\0\uFFFD\0\0\uFFFD\uFFFD\0\0\0\0\uFFFD\0\0\uFFFD\uFFFD\0\0\uFFFD\0\0\0\0\uFFFD\0\0\uFFFD\0\0\uFFFD\uFFFD\0\0\0\0\uFFFD\0\0\uFFFD\0\0\uFFFD\uFFFD\0\0\uFFFD\0\0\0\0\uFFFD\0\0\uFFFD\0\0\uFFFD\uFFFD\0\0\0\0\uFFFD\0\0\uFFFD\0\0\uFFFD\uFFFD\0\0\0\0\uFFFD\0\0\uFFFD\uFFFD\0\0\0\0\uFFFD\0\0\uFFFD\0\0\uFFFD\0\0\uFFFD\0\0\uFFFD\uFFFD\0\0\0\0\uFFFD\uFFFD\0\0\0\0\uFFFD\uFFFD\0\0\0\0\uFFFD\0\0\uFFFD\uFFFD\0\0\0\0\uFFFD\0\0\uFFFD\uFFFD\0\0\0\0\uFFFD\0\0\uFFFD\0\0\uFFFD\uFFFD\0\0\uFFFD\0\0\0\0\uFFFD\uFFFD\0\0\uFFFD\0\0\0\0\0\uFFFD\0\0\uFFFD\0\0\uFFFD\0\0\uFFFD\0\0\uFFFD\0\0\uFFFD\0\0\0\0\uFFFD\uFFFD\0\0\uFFFD\0\0\uFFFD\0\0\0\0\uFFFD\uFFFD\0\0\uFFFD\0\0\uFFFD\0\0\0\0\uFFFD\0\0\uFFFD\0\0\uFFFD\0\0\uFFFD\uFFFD\0\0\uFFFD\0\0\uFFFD\0\0\uFFFD\0\0\0\0\uFFFD\0\0\uFFFD\0\0\uFFFD\uFFFD\0\0\0\0\uFFFD\0\0\uFFFD\0\0\uFFFD\uFFFD\0\0\0\0\uFFFD\uFFFD\0\0\0\0\uFFFD\0\0\uFFFD\0\0\uFFFD\uFFFD\0\0\0\0\uFFFD\uFFFD\0\0\uFFFD\0\0\0\0\uFFFD\0\0\uFFFD\uFFFD\0\0\0\0\uFFFD\0\0\uFFFD\uFFFD\0\0\0\0\uFFFD\0\0\uFFFD\0\0\uFFFD\0\0\uFFFD\uFFFD\0\0\uFFFD\0\0\uFFFD\0\0\0\0\uFFFD\uFFFD\0\0\0\0\uFFFD\uFFFD\0\0\uFFFD\0\0\uFFFD\0\0\uFFFD\0\0\uFFFD\0\0\uFFFD\0\0\uFFFD\0\0\uFFFD\0\0\0\0\uFFFD\0\0\uFFFD\uFFFD\0\0\uFFFD\0\0\uFFFD\0\0\uFFFD\0=\uFFFD\0\x1c<\0\xb2\0L\uFFFD\0\0\x13\0\0\0\0\uFFFD\uFFFD\0\0)\0\0V\0\0u\0\0\uFFFD\0\0\0\0\uFFFD\0\0b\0\0\uFFFD\0\0\uFFFD\0\0C\0\0\uFFFD\0\0\uFFFD\0\0\uFFFD\0\0\uFFFD\0\0\0\uFFFD\0\0\0\0\uFFFD\x7f\0\0\0\0\x7f\x14\0\uFFFD?\0\0$\u01EAu\0\0\0\uFFFDtRNS\0\uFFFD\uFFFD\uFFFD\x02\x05\uFFFD\uFFFD\x01\uFFFD\uFFFD\x04\uFFFD\x03\x11\uFFFD\x07*\uFFFDf\uFFFD\x1e\uFFFD\x15\x01\uFFFD\x1bo\uFFFD\uFFFD\x02\x05\uFFFD\uFFFD\x17\uFFFD\bC\xee\x14\uFFFD\uFFFD\x1d\r\uFFFD:c\uFFFD \uFFFD\uFFFD\uFFFDK\uFFFD\n<>-"\uFFFDv\uFFFD@\uFFFDW\uFFFD`(\uFFFD\x03\uFFFD89S/\x18\uFFFDZ\uFFFDLl\uFFFD\uFFFD\x15S+\uFFFD\uFFFD5W\x1a\uFFFD\x13\uFFFD\uFFFD\f\uFFFDF&\f3^\uFFFD\rxA\uFFFD\x1d\uFFFDi\\q\uFFFD\x0fo#2bn\x0f\uFFFDgs\uFFFD}\uFFFD\uFFFD\uFFFD%\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD;\uFFFD\uFFFD\uFFFD\uFFFD\x0e\uFFFD&}\uFFFDs\uFFFD\uFFFD\xf7\uFFFD\uFFFD\vj\uFFFD\uFFFDxM\uFFFD|$\uFFFD\uFFFD\uFFFD~|\uFFFDZ\uFFFD \b\uFFFD^=\uFFFD\uFFFD_\uFFFD5\uFFFDU!PEJ\x1cN\u21D2P\x142\uFFFD\uFFFD\u077A?(\uFFFD\uFFFDO\uFFFD\x1e\uFFFD\uFFFDId-\uFFFDH\uFFFD\uFFFD\uFFFDrX\uFFFD\uFFFD\uFFFD0\uFFFD\uFFFDK\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u04D9\uFFFD\uFFFD\uFFFD\uFFFDvb\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\0\0\b\uFFFDIDATx\uFFFD\uFFFD\uFFFDwt\x14E\x1c\x07\uFFFD\\r^HHH\uFFFD\x12Bz\x03)	-!H\x15\r\uFFFD\x14\uFFFD\uFFFDQ@\uFFFDW\x05D\uFFFDH\x11A\uFFFD	\uFFFD\x1dAA\uFFFD\x14Q\uFFFD\r)\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD[~?\uFFFD?\uFFFD\uFFFD\u54BDx\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFDv\uFFFD\uFFFD?\uFFFD\uFFFDs\uFFFD\uFFFD\uFFFD}\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u036E\x10\uFFFD0\uFFFD\uFFFD\uFFFD\uFFFD&\x10`\x01\vX\uFFFD\x02\x16\uFFFD\x10`\x01\vX\uFFFD\x02\x16\uFFFD\x10`\x01\vX\uFFFD\x02\x16\uFFFD\x10`\x01\vX\uFFFD\x02\x16\uFFFD\x10`\x01K\x0f\uFFFD\x19	}\uFFFDr\x11\u0478\u3DB2\uFFFD\uFFFD\uFFFD\x1d\uFFFD\uFFFD^	[\uFFFD\uFFFD\x1a\uFFFD\uFFFD;\uFFFD\uFFFDOI\uFFFD	J\uFFFD\uFFFD\u0565\x7fK\x13\x15\uFFFD\uFFFD\u01BD\uFFFD\uFFFDz\uFFFD\uFFFDa@$\x11m\uFFFD=\uFFFDX\uFFFD\x18f?O\x14\uFFFD6V\uFFFD\uFFFD\uFFFD\uFFFD\uFFFDoL\uFFFD\x04\uFFFD\uFFFD\uFFFD\u0616n+\uFFFD\uFFFDM1\uFFFD\uFFFD\x1e\uFFFD\x19\uFFFDR6\x17U\x14d\uFFFD?\'[\uFFFDB\x1a\uFFFD1V\uFFFDR+\x19\uFFFD\uFFFDp\uFFFD\x07\uFFFD\x14\uFFFD\uFFFD\uFFFDX0\uFFFD\u0689\uFFFD\uFFFDi\uFFFDu\uFFFDk%s\uFFFDO\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u0673\x1dm\x14o\uFFFD\uFFFD\x1a\x1f\r[\uFFFD*\uFFFD"o5~\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD>\uFFFDn\uFFFD\uFFFDz\uFFFD\uFFFDPc\uFFFD\uFFFDdH\uFFFD\uFFFD\x1d\uFFFD\uFFFD\x18P\uFFFD\uFFFD,\uFFFD\'\uFFFDO\uFFFD2\uFFFD\uFFFDY\u04CDX\uFFFDS^\uFFFD\uFFFD\uFFFDF\uFFFDCG\uFFFD\uFFFD\uFFFD\b\uFFFDK\uFFFDeE)$\uFFFD-\uFFFD\uFFFD.0Z\uFFFDtz\uFFFDs\x12\uFFFD>-\x17WQ\x13\uFFFDw/5\uDA12\uDFA6\uFFFD\uFFFD\x1e\uFFFD\uFFFDp\x18\uFFFD\uFFFD\uFFFD*\f\uFFFD\uFFFDp/\uFFFD_\uFFFD\uFFFD\uFFFDM\uFFFD\uFFFD\uFFFDt\x1e]\uFFFD\uFFFD\uFFFDNc\uFFFD\uFFFD\x1d\uFFFDw	\v\uFFFDW\xfb\uFFFD\x14\uFFFD\uFFFD{\uFFFDl\uFFFD\uFFFD\uFFFD1\uFFFDn\uFFFD\uFFFD<E\x134?\uFFFD\uFFFD\uFFFDm\uFFFD4$\uFFFD\uFFFD\x1e\uFFFDcFyVn\uFFFDl\uFFFD7V\uFFFD\x1c\uFFFDv\uFFFDG9\uFFFD\uFFFD\uFFFD\uFFFD*v9\uFFFDlh\u057C\uFFFD-\uFFFD_\uFFFD\uFFFD\uFFFD\uFFFD~]\uFFFD*\uFFFD\x11V\uFFFD\uFFFD\uFFFD\x15\uFFFD$#QX2\uFFFDc\uFFFDv_t\x11\uFFFDR\u024C\uFFFD|a\u0658\uFFFD\uFFFDk\n\u014F\x05\uFFFDRb\uFFFD\x12}S\x04,\uFFFD8\x1b\x13\uFFFD\x15\uFFFD\x19*\uFFFDL\x1b\uFFFD.\x10\uFFFDRKa\uFFFD\x0f\x02X*q\uFFFD\uFFFDrE\x01K%\x11Cc\xc5\uFFFDc\x1e\u059DD\u02C0\uFFFD\uFFFD\uFFFD\uFFFD*\uFFFD5\x03+`\uFFFD\uFFFD.t\x02K)\uFFFD\uFFFD\uFFFDk.\uFFFD\uFFFD\uFFFD\uFFFD;\uFFFD\x06\v`\uFFFD\x1e\f\uFFFD	`\uFFFD\uFFFD\u02C9D\uFFFDC\uFFFD\uFFFD\x1a\uFFFD\uFFFDV\uFFFD\x07\uFFFDR\uFFFDd\u7FA5!\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD~&\uFFFD\uFFFDRr\uFFFDh\uFFFD\uFFFD\0\uFFFD\uFFFD\uFFFDs\uFFFD\uFFFD\uFFFDQ\x13;\uFFFD\uFFFD5\x02XJ\uFFFD\uFFFD\uFFFDB\uFFFD\uFFFD\uFFFD\uFFFDL\uFFFDd`\uFFFD\uFFFDG<\uFFFD\uFFFD\uFFFDRJb\x18Q\uFFFD\b`)\uFFFD>Qv3\uFFFDY\uFFFDC\uFFFD\u058E\uFFFD\x02X\uFFFDi\uFFFDW\0K%\x17wr\n\uFFFDRc\uFFFD\uFFFD\x04\x1a\x12\x03,\uFFFD\uFFFDC4\uFFFD=\uFFFD\uFFFDr\uFFFD<}>\x07\uFFFDP)\xda\x12\uFFFD\'\uFFFD\uFFFD6\x1c\uFFFDOg\uFFFD\0K1\x11\x13\\\x02X*\x19\uFFFD(\uFFFDLM\uFFFD\n\x1da\uFFFD\x02K-\x1dR\uFFFD\uFFFDx\bX\uFFFD\uFFFDQ\uFFFD\uFFFDo~2\rX\uFFFDg\x0fQ\uFFFD\u03D9\uFFFD\uFFFDD`U\x17\uFFFD\x04\x1b\uFFFD\x1c\uFFFDYj\uFFFD\x0e\x02V\uFFFDyl\uFFFD\x10\r\uFFFDf^;\x15X\uFFFD2j\uFFFDw\uFFFDE[\u60A5\uFFFD\uFFFD:\uFFFD\uFFFD#c\uFFFD\x17fz&1\uFFFD\x7f\x16XU&\uFFFD\uFFFDQ\uFFFD\u04E2\u0273\uFFFD\x17\uFFFD\x07V\x15qO\uFFFD\uFFFD]\uFFFD\uFFFDRj\x15L\x05\uFFFD\u07F8\uFFFDK\uFFFD]V\uFFFD\x1f\uFFFD\x1f\uFFFD\r,\x7fi\uFFFDM\x19g\uFFFD\uFFFD\x1c\u0314#\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\x05u\uFFFDO\u05F5\x196kT\uFFFD\uFFFD\uFFFD\x07\uFFFD1w\uFFFD;\uFFFD\x7ff \uFFFD\uFFFD+t\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\x16\uFFFD\uFFFDj?\uFFFD/-\uFFFD\uFFFD[\uFFFD]ym[\uFFFDNC\uFFFD\uFFFDS\uFFFD\uFFFD\uFFFD?q\uFFFD\uFFFDj\uFFFD\uFFFD\uFFFDc\uFFFD\uFFFD%\uFFFD\uFFFD?\uFFFDk\uFFFDa\uFFFD\uFFFD]\uFFFD\uFFFD\uFFFD4y\uFFFD4\uFFFDr\uFFFDi|e\uFFFD\u02B9\u01F9\uFFFDnX\x01\uFFFD]\u07BC\uFFFD\uFFFDx\u53A9+s\uFFFDg\uFFFDR\x1e\uFFFD\uFFFD\x19\uFFFDV\uFFFDz\uFFFD\uFFFD\x1c\u0655wo\uFFFD[v5\x0f,+\uFFFD\u027CN/\uFFFD\uFFFDG\uFFFD\uFFFDIN\uFFFD\uFFFDS\uFFFDT\uFFFD\uFFFD-Z\uFFFD\uFFFDek\uFFFD[\uFFFD\uFFFDR\uFFFDfE5\x19\x19`\uFFFD\u5972\u06CA\uFFFD)\uFFFD\uFFFDo\uFFFD\x0e\uFFFD\uFFFD\x7f\uFFFD	\uFFFD\uFFFD\uFFFD\uFFFDD\uFFFD\uFFFDa\uFFFD\uFFFD2\uFFFD9\uFFFDX\uFFFD\uFFFD\x7f\uFFFD\uFFFD\uFFFD7\uFFFD\uFFFD:a\uFFFDW\uFFFD-\uFFFD\uFFFDH~\uFFFD\uFFFD`\x13\x1br\uFFFDFX3\uFFFD\uCF6A\uFFFDgR\uFFFD\uFFFD\uFFFD\u029BN\uFFFDd\uFFFDV\u07EC\uFFFDS\uFFFD\x06TWM\uFFFD\r\uFFFD\uFFFD\uFFFDpD\uFFFD\uFFFD\uFFFD\uFFFD\x1a\uFFFDw\uFFFDjQ\uFFFD\uFFFD\u0748\uFFFDU?\uFFFD2N\uFFFD$v\uFFFD\uFFFD\uFFFD\uFFFD\uFFFDx?`\uFFFD\r\uFFFDp\x07\uFFFD]\uFFFDP\uFFFD<".\x1ag\uFFFD\uFFFDP\uFFFD\u05AF|x\uFFFDC3<\uFFFD\uFFFDJE\x13\uFFFD0?Q\uFFFDu>\uFFFD\x1c\uFFFD\u068B\uFFFD8]\x13\uFFFD\uFFFDB\uFFFDiX\x0f1g\x1e\uFFFDn\uFFFDn\uFFFD=\x06>o\uFFFD\uFFFD\x0e\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\x1fl\u0460\r\uFFFDE\uFFFD[\uFFFDy\u0260\uFFFD\uFFFDXO=\uFFFD"\x1a\x11\uFFFDQ\uFFFD\uFFFD \uFFFD9\u078DuI\uFFFD\uFFFD_\uF953\uFFFD|\x0e\uFFFDV\u01BA3\uFFFDi\uFFFD\x1f2?X\uFFFD\uFFFDB\uFFFDgD\uFFFD\uFFFD\uFFFD\uFFFD\x02\uFFFD\uFFFD\uFFFD\uFFFDw\uFFFD\uFFFDk_4G\uFFFD\x7f\uFFFD\uFFFD\uFFFD/\uFFFD\uFFFD|\uFFFDg+\uFFFD""\0V\uFFFD\'Do\x07\uFFFD[\uFFFD\x1b\uFFFD\uFFFD\uFFFD\uFFFD\uFFFDQX+\uFFFD\uFFFDY\rwv\uFFFD,\uFFFD\uFFFD&3/>"\uFFFD\uFFFD*\uFFFD\uFFFD\uFFFD0\x18\x11\uFFFD,&y@\uFFFDRG\uFFFD\uFFFD#\uFFFD\uFFFD\uFFFDM\x0e\x14\uFFFD\uB1F5\uFFFDN\x19\x1d\uFFFD\uFFFD-\uFFFDq+\r\uFFFDT\uFFFD\uFFFD^!\uFFFDY\uFFFDi\uFFFDw1\x7f\uFFFD\x1bV\uFFFDP\uFFFD\uFFFD5y\b\uFFFD\uFFFDr\uFFFD0U3\uFFFD\uFFFDD\uFFFD\uFFFD5\uFFFD\uFFFD\x0e\uFFFD=\uFFFDa\u054Du\uFFFD\uFFFD! ]\uFFFD\x1f\u046E\uFFFD\u03EF\uFFFD\uFFFD\uFFFD\x07fY\uFFFD\uFFFD\uFFFD\x02V\uFFFD\uFFFD\uFFFD\x10*\\a\uFFFDv\uFFFD\x07k#\uFFFD\uFFFD\u057CB\uFFFD\x0e\x1f\uFFFD\x07k^h\uFFFD.\uFFFDe2\uFFFD\uFFFD\x05\uFFFD\uFFFD\x10\uFFFD\uFFFDC\uFFFD\uFFFD:\uFFFD\x05\uFFFD`\uFFFDd\x10u\uFFFD\x17J\uFFFD\uFFFD\uFFFDW\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD:%\uFFFDW\uFFFD\uFFFD1oH\uFFFD\x04K\uFFFDB|+\\\uFFFD%\uFFFDsu\uFFFDzl\uFFFD	\x0f\uFFFDx\uFFFDy\uFFFD\x06X\uFFFD\uFFFD2\uFFFD\uFFFD\x16\v\uFFFD\uFFFDY\x1f\uFFFD=\uFFFDr\u0568\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\x10\uFFFD\uFFFD$\uFFFD*\u04D38\uFFFD\n\uFFFDc].G\uFFFD\uFFFD\uFFFD\uFFFD1\uFFFDy\uFFFD\u0571\x12\uFFFD\x07qG5P\uFFFD[\uFFFD\uFFFD76\xe8\uFFFD\uFFFD<\x04df\uFFFD;b\uFFFD\uFFFD\n\x7f\u067C\x07[\uFFFDc\uFFFDci\uFFFD\uFFFDd\uFFFD\x1b\uFFFD\uFFFD1\x17X\x19\uB403(\u05AC:\u04E7q\uFFFD\x03\uFFFD\uFFFDr\uFFFDT\uFFFDv\x19Z\n\uFFFD\uFFFDZ\x16\uFFFD=\x1a\uFFFD4\uFFFD2\uFFFD\uFFFDa^iY,g\'GS3_A\u045D\uFFFD\uFFFD\uFFFD\uFFFD\uFFFDBS\x1fI\uFFFD\u0722\uFFFD\uFFFD$\u05B7]\u032E\uFFFDE\uFFFD\uFFFD>Db}\x1fi\uFFFD\x1b\u046E\uFFFD?\x15\uFFFD\nX\x7f\uFFFDY&\uFFFD\uFFFD\uFFFD?\uFFFDV\u0172=er\uFFFD\uFFFD3/\x0f\uFFFD\x1f\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u032E\uFFFD\uFFFDS\uFFFD~\n\uFFFD\nQ\uFFFD(\x07X\uFFFD`\uFFFD\uFFFDfx[I\uFFFDm\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u05F3\x10`\x01\vX\uFFFD\x02\x16\uFFFD\x10`\x01\vX\uFFFD\x02\x16\uFFFD\x10`\x01\vX\uFFFD\x02\x16\uFFFD\x10`\x01\vX\uFFFD\x02\x16\uFFFD\x10`\x01\vX\uFFFD\x02\x16\uFFFD\x10`\x01\vX\uFFFD\x02\x16\uFFFD\x10`\x01\vX\uFFFD\x02\x16\uFFFD\x10`\x01\vX\uFFFD\x02\x16\uFFFD\x10`\x01\vX\uFFFD\x02\x16\uFFFD\x10`\x01\vX\uFFFD\x02\x16\uFFFD\x10`\x01\vX\uFFFD\x02\x16\uFFFD\x10`\x01\vX\uFFFD\x02\x16\uFFFD\x10`\x01\vX\uFFFD\x02\x16\uFFFD\x10`\x01\vX\uFFFD\x02\x16\uFFFD\x10`\x01\vX\uFFFD\x02\x16\uFFFD\x10`\x01\vX\uFFFD\x02\x16\uFFFD\x10`\x01\vX\uFFFD\x02\x16\uFFFD\x10`\x01\vX\uFFFD\x02\x16\uFFFD\x10`\x01\vX\uFFFD\x02\x16\uFFFD\x10`\x01\vX\uFFFD\x02\x16\uFFFD\x10`\x01\vX\uFFFD\x02\x16\uFFFD\x10`\x01\vX\uFFFD\x02\x16\uFFFD\x10`\x01\vX\uFFFD\x02\x16\uFFFD\x10`\x01\vX\uFFFD\x02\x16\uFFFD\x10`\x01\vX\uFFFD\uFFFD\v\uFFFD~bX\uFFFD\uFFFDg\x1d\0\0\0\0IEND\uFFFDB`\uFFFD',
            "index.md": '---\ntitle: Math.atan2()\nslug: Web/JavaScript/Reference/Global_Objects/Math/atan2\npage-type: javascript-static-method\nbrowser-compat: javascript.builtins.Math.atan2\n---\n\n{{JSRef}}\n\nThe **`Math.atan2()`** static method returns the angle in the plane (in radians) between the positive x-axis and the ray from (0, 0) to the point (x, y), for `Math.atan2(y, x)`.\n\n{{EmbedInteractiveExample("pages/js/math-atan2.html")}}\n\n## Syntax\n\n```js-nolint\nMath.atan2(y, x)\n```\n\n### Parameters\n\n- `y`\n  - : The y coordinate of the point.\n- `x`\n  - : The x coordinate of the point.\n\n### Return value\n\nThe angle in radians (between -\u03C0 and \u03C0, inclusive) between the positive x-axis and the ray from (0, 0) to the point (x, y).\n\n## Description\n\nThe `Math.atan2()` method measures the counterclockwise angle \u03B8, in radians, between the positive x-axis and the point `(x, y)`. Note that the arguments to this function pass the y-coordinate first and the x-coordinate second.\n\n![A simple diagram showing the angle returned by atan2(y, x)](atan2.png)\n\n`Math.atan2()` is passed separate `x` and `y` arguments, while [`Math.atan()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/atan) is passed the ratio of those two arguments. `Math.atan2(y, x)` differs from `Math.atan(y / x)` in the following cases:\n\n| `x`                  | `y`         | `Math.atan2(y, x)` | `Math.atan(y / x)` |\n| -------------------- | ----------- | ------------------ | ------------------ |\n| `Infinity`           | `Infinity`  | \u03C0 / 4              | `NaN`              |\n| `Infinity`           | `-Infinity` | -\u03C0 / 4             | `NaN`              |\n| `-Infinity`          | `Infinity`  | 3\u03C0 / 4             | `NaN`              |\n| `-Infinity`          | `-Infinity` | -3\u03C0 / 4            | `NaN`              |\n| 0                    | 0           | 0                  | `NaN`              |\n| 0                    | -0          | -0                 | `NaN`              |\n| < 0 (including `-0`) | 0           | \u03C0                  | 0                  |\n| < 0 (including `-0`) | -0          | -\u03C0                 | 0                  |\n| `-Infinity`          | > 0         | \u03C0                  | -0                 |\n| -0                   | > 0         | \u03C0 / 2              | -\u03C0 / 2             |\n| `-Infinity`          | < 0         | -\u03C0                 | 0                  |\n| -0                   | < 0         | -\u03C0 / 2             | \u03C0 / 2              |\n\nIn addition, for points in the second and third quadrants (`x < 0`), `Math.atan2()` would output an angle less than <math><semantics><mrow><mo>-</mo><mfrac><mi>\u03C0</mi><mn>2</mn></mfrac></mrow><annotation encoding="TeX">-\\frac{\\pi}{2}</annotation></semantics></math> or greater than <math><semantics><mfrac><mi>\u03C0</mi><mn>2</mn></mfrac><annotation encoding="TeX">\\frac{\\pi}{2}</annotation></semantics></math>.\n\nBecause `atan2()` is a static method of `Math`, you always use it as `Math.atan2()`, rather than as a method of a `Math` object you created (`Math` is not a constructor).\n\n## Examples\n\n### Using Math.atan2()\n\n```js\nMath.atan2(90, 15); // 1.4056476493802699\nMath.atan2(15, 90); // 0.16514867741462683\n```\n\n### Difference between Math.atan2(y, x) and Math.atan(y / x)\n\nThe following script prints all inputs that produce a difference between `Math.atan2(y, x)` and `Math.atan(y / x)`.\n\n```js\nconst formattedNumbers = new Map([\n  [-Math.PI, "-\u03C0"],\n  [(-3 * Math.PI) / 4, "-3\u03C0/4"],\n  [-Math.PI / 2, "-\u03C0/2"],\n  [-Math.PI / 4, "-\u03C0/4"],\n  [Math.PI / 4, "\u03C0/4"],\n  [Math.PI / 2, "\u03C0/2"],\n  [(3 * Math.PI) / 4, "3\u03C0/4"],\n  [Math.PI, "\u03C0"],\n  [-Infinity, "-\u221E"],\n  [Infinity, "\u221E"],\n]);\n\nfunction format(template, ...args) {\n  return String.raw(\n    { raw: template },\n    ...args.map((num) =>\n      (Object.is(num, -0)\n        ? "-0"\n        : formattedNumbers.get(num) ?? String(num)\n      ).padEnd(5),\n    ),\n  );\n}\n\nconsole.log(`| x     | y     | atan2 | atan  |\n|-------|-------|-------|-------|`);\n\nfor (const x of [-Infinity, -1, -0, 0, 1, Infinity]) {\n  for (const y of [-Infinity, -1, -0, 0, 1, Infinity]) {\n    const atan2 = Math.atan2(y, x);\n    const atan = Math.atan(y / x);\n    if (!Object.is(atan2, atan)) {\n      console.log(format`| ${x} | ${y} | ${atan2} | ${atan} |`);\n    }\n  }\n}\n```\n\nThe output is:\n\n```plain\n| x     | y     | atan2 | atan  |\n|-------|-------|-------|-------|\n| -\u221E    | -\u221E    | -3\u03C0/4 | NaN   |\n| -\u221E    | -1    | -\u03C0    | 0     |\n| -\u221E    | -0    | -\u03C0    | 0     |\n| -\u221E    | 0     | \u03C0     | -0    |\n| -\u221E    | 1     | \u03C0     | -0    |\n| -\u221E    | \u221E     | 3\u03C0/4  | NaN   |\n| -1    | -\u221E    | -\u03C0/2  | \u03C0/2   |\n| -1    | -1    | -3\u03C0/4 | \u03C0/4   |\n| -1    | -0    | -\u03C0    | 0     |\n| -1    | 0     | \u03C0     | -0    |\n| -1    | 1     | 3\u03C0/4  | -\u03C0/4  |\n| -1    | \u221E     | \u03C0/2   | -\u03C0/2  |\n| -0    | -\u221E    | -\u03C0/2  | \u03C0/2   |\n| -0    | -1    | -\u03C0/2  | \u03C0/2   |\n| -0    | -0    | -\u03C0    | NaN   |\n| -0    | 0     | \u03C0     | NaN   |\n| -0    | 1     | \u03C0/2   | -\u03C0/2  |\n| -0    | \u221E     | \u03C0/2   | -\u03C0/2  |\n| 0     | -0    | -0    | NaN   |\n| 0     | 0     | 0     | NaN   |\n| \u221E     | -\u221E    | -\u03C0/4  | NaN   |\n| \u221E     | \u221E     | \u03C0/4   | NaN   |\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Math.acos()")}}\n- {{jsxref("Math.asin()")}}\n- {{jsxref("Math.atan()")}}\n- {{jsxref("Math.cos()")}}\n- {{jsxref("Math.sin()")}}\n- {{jsxref("Math.tan()")}}\n'
        },
        "atanh": {
            "index.md": '---\ntitle: Math.atanh()\nslug: Web/JavaScript/Reference/Global_Objects/Math/atanh\npage-type: javascript-static-method\nbrowser-compat: javascript.builtins.Math.atanh\n---\n\n{{JSRef}}\n\nThe **`Math.atanh()`** static method returns the inverse hyperbolic tangent of a number. That is,\n\n<math display="block"><semantics><mtable columnalign="right left right left right left right left right left" columnspacing="0em" displaystyle="true"><mtr><mtd><mo>\u2200</mo><mi>x</mi><mo>\u220A</mo><mo stretchy="false">(</mo><mrow><mo>\u2212</mo><mn>1</mn></mrow><mo>,</mo><mn>1</mn><mo stretchy="false">)</mo><mo>,</mo><mspace width="0.2777777777777778em"></mspace><mrow><mo lspace="0em" rspace="0.16666666666666666em">\uD835\uDE7C\uD835\uDE8A\uD835\uDE9D\uD835\uDE91.\uD835\uDE8A\uD835\uDE9D\uD835\uDE8A\uD835\uDE97\uD835\uDE91</mo><mo stretchy="false">(</mo><mi>\uD835\uDEA1</mi><mo stretchy="false">)</mo></mrow></mtd><mtd><mo>=</mo><mo lspace="0em" rspace="0.16666666666666666em">artanh</mo><mo stretchy="false">(</mo><mi>x</mi><mo stretchy="false">)</mo><mo>=</mo><mtext>the unique&nbsp;</mtext><mi>y</mi><mtext>&nbsp;such that&nbsp;</mtext><mo lspace="0em" rspace="0em">tanh</mo><mo stretchy="false">(</mo><mi>y</mi><mo stretchy="false">)</mo><mo>=</mo><mi>x</mi></mtd></mtr><mtr><mtd></mtd><mtd><mo>=</mo><mfrac><mn>1</mn><mn>2</mn></mfrac><mspace width="0.16666666666666666em"></mspace><mo lspace="0em" rspace="0em">ln</mo><mrow><mo>(</mo><mfrac><mrow><mn>1</mn><mo>+</mo><mi>x</mi></mrow><mrow><mn>1</mn><mo>\u2212</mo><mi>x</mi></mrow></mfrac><mo>)</mo></mrow></mtd></mtr></mtable><annotation encoding="TeX">\\begin{aligned}\\forall x \\in ({-1}, 1),\\;\\mathtt{\\operatorname{Math.atanh}(x)} &amp;= \\operatorname{artanh}(x) = \\text{the unique } y \\text{ such that } \\tanh(y) = x \\\\&amp;= \\frac{1}{2}\\,\\ln\\left(\\frac{1+x}{1-x}\\right)\\end{aligned}\n</annotation></semantics></math>\n\n{{EmbedInteractiveExample("pages/js/math-atanh.html")}}\n\n## Syntax\n\n```js-nolint\nMath.atanh(x)\n```\n\n### Parameters\n\n- `x`\n  - : A number between -1 and 1, inclusive.\n\n### Return value\n\nThe inverse hyperbolic tangent of `x`. If `x` is 1, returns {{jsxref("Infinity")}}. If `x` is -1, returns `-Infinity`. If `x` is less than -1 or greater than 1, returns {{jsxref("NaN")}}.\n\n## Description\n\nBecause `atanh()` is a static method of `Math`, you always use it as `Math.atanh()`, rather than as a method of a `Math` object you created (`Math` is not a constructor).\n\n## Examples\n\n### Using Math.atanh()\n\n```js\nMath.atanh(-2); // NaN\nMath.atanh(-1); // -Infinity\nMath.atanh(-0); // -0\nMath.atanh(0); // 0\nMath.atanh(0.5); // 0.5493061443340548\nMath.atanh(1); // Infinity\nMath.atanh(2); // NaN\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Math.atanh` in `core-js`](https://github.com/zloirock/core-js#ecmascript-math)\n- {{jsxref("Math.acosh()")}}\n- {{jsxref("Math.asinh()")}}\n- {{jsxref("Math.cosh()")}}\n- {{jsxref("Math.sinh()")}}\n- {{jsxref("Math.tanh()")}}\n'
        },
        "cbrt": {
            "index.md": '---\ntitle: Math.cbrt()\nslug: Web/JavaScript/Reference/Global_Objects/Math/cbrt\npage-type: javascript-static-method\nbrowser-compat: javascript.builtins.Math.cbrt\n---\n\n{{JSRef}}\n\nThe **`Math.cbrt()`** static method returns the cube root of a number. That is\n\n<math display="block"><semantics><mrow><mrow><mo lspace="0em" rspace="0.16666666666666666em">\uD835\uDE7C\uD835\uDE8A\uD835\uDE9D\uD835\uDE91.\uD835\uDE8C\uD835\uDE8B\uD835\uDE9B\uD835\uDE9D</mo><mo stretchy="false">(</mo><mi>\uD835\uDEA1</mi><mo stretchy="false">)</mo></mrow><mo>=</mo><mroot><mi>x</mi><mn>3</mn></mroot><mo>=</mo><mtext>the unique&nbsp;</mtext><mi>y</mi><mtext>&nbsp;such that&nbsp;</mtext><msup><mi>y</mi><mn>3</mn></msup><mo>=</mo><mi>x</mi></mrow><annotation encoding="TeX">\\mathtt{\\operatorname{Math.cbrt}(x)} = \\sqrt[3]{x} = \\text{the unique } y \\text{ such that } y^3 = x</annotation></semantics></math>\n\n{{EmbedInteractiveExample("pages/js/math-cbrt.html")}}\n\n## Syntax\n\n```js-nolint\nMath.cbrt(x)\n```\n\n### Parameters\n\n- `x`\n  - : A number.\n\n### Return value\n\nThe cube root of `x`.\n\n## Description\n\nBecause `cbrt()` is a static method of `Math`, you always use it as `Math.cbrt()`, rather than as a method of a `Math` object you created (`Math` is not a constructor).\n\n## Examples\n\n### Using Math.cbrt()\n\n```js\nMath.cbrt(-Infinity); // -Infinity\nMath.cbrt(-1); // -1\nMath.cbrt(-0); // -0\nMath.cbrt(0); // 0\nMath.cbrt(1); // 1\nMath.cbrt(2); // 1.2599210498948732\nMath.cbrt(Infinity); // Infinity\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Math.cbrt` in `core-js`](https://github.com/zloirock/core-js#ecmascript-math)\n- {{jsxref("Math.pow()")}}\n- {{jsxref("Math.sqrt()")}}\n'
        },
        "ceil": {
            "index.md": '---\ntitle: Math.ceil()\nslug: Web/JavaScript/Reference/Global_Objects/Math/ceil\npage-type: javascript-static-method\nbrowser-compat: javascript.builtins.Math.ceil\n---\n\n{{JSRef}}\n\nThe **`Math.ceil()`** static method always rounds up and returns the smallest integer greater than or equal to a given number.\n\n{{EmbedInteractiveExample("pages/js/math-ceil.html")}}\n\n## Syntax\n\n```js-nolint\nMath.ceil(x)\n```\n\n### Parameters\n\n- `x`\n  - : A number.\n\n### Return value\n\nThe smallest integer greater than or equal to `x`. It\'s the same value as [`-Math.floor(-x)`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/floor).\n\n## Description\n\nBecause `ceil()` is a static method of `Math`, you always use it as `Math.ceil()`, rather than as a method of a `Math` object you created (`Math` is not a constructor).\n\n## Examples\n\n### Using Math.ceil()\n\n```js\nMath.ceil(-Infinity); // -Infinity\nMath.ceil(-7.004); // -7\nMath.ceil(-4); // -4\nMath.ceil(-0.95); // -0\nMath.ceil(-0); // -0\nMath.ceil(0); // 0\nMath.ceil(0.95); // 1\nMath.ceil(4); // 4\nMath.ceil(7.004); // 8\nMath.ceil(Infinity); // Infinity\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Math.abs()")}}\n- {{jsxref("Math.floor()")}}\n- {{jsxref("Math.round()")}}\n- {{jsxref("Math.sign()")}}\n- {{jsxref("Math.trunc()")}}\n'
        },
        "clz32": {
            "index.md": '---\ntitle: Math.clz32()\nslug: Web/JavaScript/Reference/Global_Objects/Math/clz32\npage-type: javascript-static-method\nbrowser-compat: javascript.builtins.Math.clz32\n---\n\n{{JSRef}}\n\nThe **`Math.clz32()`** static method returns the number of leading zero bits in the 32-bit binary representation of a number.\n\n{{EmbedInteractiveExample("pages/js/math-clz32.html")}}\n\n## Syntax\n\n```js-nolint\nMath.clz32(x)\n```\n\n### Parameters\n\n- `x`\n  - : A number.\n\n### Return value\n\nThe number of leading zero bits in the 32-bit binary representation of `x`.\n\n## Description\n\n`clz32` is short for **C**ount**L**eading**Z**eros**32**.\n\nIf `x` is not a number, it will be converted to a number first, then converted to a 32-bit unsigned integer.\n\nIf the converted 32-bit unsigned integer is `0`, `32` is returned, because all bits are `0`. If the most significant bit is `1` (i.e. the number is greater than or equal to 2<sup>31</sup>), `0` is returned.\n\nThis function is particularly useful for systems that compile to JS, like [Emscripten](https://emscripten.org).\n\n## Examples\n\n### Using Math.clz32()\n\n```js\nMath.clz32(1); // 31\nMath.clz32(1000); // 22\nMath.clz32(); // 32\n\nconst stuff = [\n  NaN,\n  Infinity,\n  -Infinity,\n  0,\n  -0,\n  false,\n  null,\n  undefined,\n  "foo",\n  {},\n  [],\n];\nstuff.every((n) => Math.clz32(n) === 32); // true\n\nMath.clz32(true); // 31\nMath.clz32(3.5); // 30\n```\n\n### Implementing Count Leading Ones and beyond\n\nAt present, there is no `Math.clon` for "Count Leading Ones" (named "clon", not "clo", because "clo" and "clz" are too similar especially for non-English-speaking people). However, a `clon` function can easily be created by inverting the bits of a number and passing the result to `Math.clz32`. Doing this will work because the inverse of 1 is 0 and vice versa. Thus, inverting the bits will inverse the measured quantity of 0\'s (from `Math.clz32`), thereby making `Math.clz32` count the number of ones instead of counting the number of zeros.\n\nConsider the following 32-bit word:\n\n```js\nconst a = 32776; // 00000000000000001000000000001000 (16 leading zeros)\nMath.clz32(a); // 16\n\nconst b = ~32776; // 11111111111111110111111111110111 (32776 inverted, 0 leading zeros)\nMath.clz32(b); // 0 (this is equal to how many leading one\'s there are in a)\n```\n\nUsing this logic, a `clon` function can be created as follows:\n\n```js\nconst clz = Math.clz32;\n\nfunction clon(integer) {\n  return clz(~integer);\n}\n```\n\nFurther, this technique could be extended to create a jumpless "Count Trailing Zeros" function, as seen below. The `ctrz` function takes a bitwise AND of the integer with its two\'s complement. By how two\'s complement works, all trailing zeros will be converted to ones, and then when adding 1, it would be carried over until the first `0` (which was originally a `1`) is reached. All bits higher than this one stay the same and are inverses of the original integer\'s bits. Therefore, when doing bitwise AND with the original integer, all higher bits become `0`, which can be counted with `clz`. The number of trailing zeros, plus the first `1` bit, plus the leading bits that were counted by `clz`, total to 32.\n\n```js\nfunction ctrz(integer) {\n  integer >>>= 0; // coerce to Uint32\n  if (integer === 0) {\n    // skipping this step would make it return -1\n    return 32;\n  }\n  integer &= -integer; // equivalent to `int = int & (~int + 1)`\n  return 31 - clz(integer);\n}\n```\n\nThen we can define a "Count Trailing Ones" function like so:\n\n```js\nfunction ctron(integer) {\n  return ctrz(~integer);\n}\n```\n\nThese helper functions can be made into an [asm.js](/en-US/docs/Games/Tools/asm.js) module for a potential performance improvement.\n\n```js\nconst countTrailsMethods = (function (stdlib, foreign, heap) {\n  "use asm";\n  const clz = stdlib.Math.clz32;\n\n  // count trailing zeros\n  function ctrz(integer) {\n    integer = integer | 0; // coerce to an integer\n    if ((integer | 0) == 0) {\n      // skipping this step would make it return -1\n      return 32;\n    }\n    // Note: asm.js doesn\'t have compound assignment operators such as &=\n    integer = integer & -integer; // equivalent to `int = int & (~int + 1)`\n    return (31 - clz(integer)) | 0;\n  }\n\n  // count trailing ones\n  function ctron(integer) {\n    integer = integer | 0; // coerce to an integer\n    return ctrz(~integer) | 0;\n  }\n\n  // asm.js demands plain objects:\n  return { ctrz: ctrz, ctron: ctron };\n})(window, null, null);\n\nconst { ctrz, ctron } = countTrailsMethods;\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Math.clz32` in `core-js`](https://github.com/zloirock/core-js#ecmascript-math)\n- {{jsxref("Math")}}\n- {{jsxref("Math.imul")}}\n'
        },
        "cos": {
            "index.md": '---\ntitle: Math.cos()\nslug: Web/JavaScript/Reference/Global_Objects/Math/cos\npage-type: javascript-static-method\nbrowser-compat: javascript.builtins.Math.cos\n---\n\n{{JSRef}}\n\nThe **`Math.cos()`** static method returns the cosine of a number in radians.\n\n{{EmbedInteractiveExample("pages/js/math-cos.html")}}\n\n## Syntax\n\n```js-nolint\nMath.cos(x)\n```\n\n### Parameters\n\n- `x`\n  - : A number representing an angle in radians.\n\n### Return value\n\nThe cosine of `x`, between -1 and 1, inclusive. If `x` is {{jsxref("Infinity")}}, `-Infinity`, or {{jsxref("NaN")}}, returns {{jsxref("NaN")}}.\n\n## Description\n\nBecause `cos()` is a static method of `Math`, you always use it as `Math.cos()`, rather than as a method of a `Math` object you created (`Math` is not a constructor).\n\n## Examples\n\n### Using Math.cos()\n\n```js\nMath.cos(-Infinity); // NaN\nMath.cos(-0); // 1\nMath.cos(0); // 1\nMath.cos(1); // 0.5403023058681398\nMath.cos(Math.PI); // -1\nMath.cos(2 * Math.PI); // 1\nMath.cos(Infinity); // NaN\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Math.acos()")}}\n- {{jsxref("Math.asin()")}}\n- {{jsxref("Math.atan()")}}\n- {{jsxref("Math.atan2()")}}\n- {{jsxref("Math.sin()")}}\n- {{jsxref("Math.tan()")}}\n'
        },
        "cosh": {
            "index.md": '---\ntitle: Math.cosh()\nslug: Web/JavaScript/Reference/Global_Objects/Math/cosh\npage-type: javascript-static-method\nbrowser-compat: javascript.builtins.Math.cosh\n---\n\n{{JSRef}}\n\nThe **`Math.cosh()`** static method returns the hyperbolic cosine of a number. That is,\n\n<math display="block"><semantics><mrow><mrow><mo lspace="0em" rspace="0.16666666666666666em">\uD835\uDE7C\uD835\uDE8A\uD835\uDE9D\uD835\uDE91.\uD835\uDE8C\uD835\uDE98\uD835\uDE9C\uD835\uDE91</mo><mo stretchy="false">(</mo><mi>\uD835\uDEA1</mi><mo stretchy="false">)</mo></mrow><mo>=</mo><mo lspace="0em" rspace="0em">cosh</mo><mo stretchy="false">(</mo><mi>x</mi><mo stretchy="false">)</mo><mo>=</mo><mfrac><mrow><msup><mi mathvariant="normal">e</mi><mi>x</mi></msup><mo>+</mo><msup><mi mathvariant="normal">e</mi><mrow><mo>\u2212</mo><mi>x</mi></mrow></msup></mrow><mn>2</mn></mfrac></mrow><annotation encoding="TeX">\\mathtt{\\operatorname{Math.cosh}(x)} = \\cosh(x) = \\frac{\\mathrm{e}^x + \\mathrm{e}^{-x}}{2}</annotation></semantics></math>\n\n{{EmbedInteractiveExample("pages/js/math-cosh.html")}}\n\n## Syntax\n\n```js-nolint\nMath.cosh(x)\n```\n\n### Parameters\n\n- `x`\n  - : A number.\n\n### Return value\n\nThe hyperbolic cosine of `x`.\n\n## Description\n\nBecause `cosh()` is a static method of `Math`, you always use it as `Math.cosh()`, rather than as a method of a `Math` object you created (`Math` is not a constructor).\n\n## Examples\n\n### Using Math.cosh()\n\n```js\nMath.cosh(-Infinity); // Infinity\nMath.cosh(-1); // 1.5430806348152437\nMath.cosh(-0); // 1\nMath.cosh(0); // 1\nMath.cosh(1); // 1.5430806348152437\nMath.cosh(Infinity); // Infinity\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Math.cosh` in `core-js`](https://github.com/zloirock/core-js#ecmascript-math)\n- {{jsxref("Math.acosh()")}}\n- {{jsxref("Math.asinh()")}}\n- {{jsxref("Math.atanh()")}}\n- {{jsxref("Math.sinh()")}}\n- {{jsxref("Math.tanh()")}}\n'
        },
        "e": {
            "index.md": '---\ntitle: Math.E\nslug: Web/JavaScript/Reference/Global_Objects/Math/E\npage-type: javascript-static-data-property\nbrowser-compat: javascript.builtins.Math.E\n---\n\n{{JSRef}}\n\nThe **`Math.E`** static data property represents Euler\'s number, the base of natural logarithms, e, which is approximately 2.718.\n\n{{EmbedInteractiveExample("pages/js/math-e.html")}}\n\n## Value\n\n<math display="block"><semantics><mrow><mi>\uD835\uDE7C\uD835\uDE8A\uD835\uDE9D\uD835\uDE91.\uD835\uDE74</mi><mo>=</mo><mi>e</mi><mo>\u2248</mo><mn>2.718</mn></mrow><annotation encoding="TeX">\\mathtt{\\mi{Math.E}} = e \\approx 2.718</annotation></semantics></math>\n\n{{js_property_attributes(0, 0, 0)}}\n\n## Description\n\nBecause `E` is a static property of `Math`, you always use it as `Math.E`, rather than as a property of a `Math` object you created (`Math` is not a constructor).\n\n## Examples\n\n### Using Math.E\n\nThe following function returns e:\n\n```js\nfunction getNapier() {\n  return Math.E;\n}\n\ngetNapier(); // 2.718281828459045\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Math.exp()")}}\n- {{jsxref("Math.log()")}}\n- {{jsxref("Math.log1p()")}}\n'
        },
        "exp": {
            "index.md": '---\ntitle: Math.exp()\nslug: Web/JavaScript/Reference/Global_Objects/Math/exp\npage-type: javascript-static-method\nbrowser-compat: javascript.builtins.Math.exp\n---\n\n{{JSRef}}\n\nThe **`Math.exp()`** static method returns [e](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/E) raised to the power of a number. That is\n\n<math display="block"><semantics><mrow><mrow><mo lspace="0em" rspace="0.16666666666666666em">\uD835\uDE7C\uD835\uDE8A\uD835\uDE9D\uD835\uDE91.\uD835\uDE8E\uD835\uDEA1\uD835\uDE99</mo><mo stretchy="false">(</mo><mi>\uD835\uDEA1</mi><mo stretchy="false">)</mo></mrow><mo>=</mo><msup><mi mathvariant="normal">e</mi><mi>x</mi></msup></mrow><annotation encoding="TeX">\\mathtt{\\operatorname{Math.exp}(x)} = \\mathrm{e}^x</annotation></semantics></math>\n\n{{EmbedInteractiveExample("pages/js/math-exp.html")}}\n\n## Syntax\n\n```js-nolint\nMath.exp(x)\n```\n\n### Parameters\n\n- `x`\n  - : A number.\n\n### Return value\n\nA nonnegative number representing e<sup>x</sup>, where e is [the base of the natural logarithm](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/E).\n\n## Description\n\nBecause `exp()` is a static method of `Math`, you always use it as `Math.exp()`, rather than as a method of a `Math` object you created (`Math` is not a constructor).\n\nBeware that `e` to the power of a number very close to 0 will be very close to 1 and suffer from loss of precision. In this case, you may want to use {{jsxref("Math.expm1")}} instead, and obtain a much higher-precision fractional part of the answer.\n\n## Examples\n\n### Using Math.exp()\n\n```js\nMath.exp(-Infinity); // 0\nMath.exp(-1); // 0.36787944117144233\nMath.exp(0); // 1\nMath.exp(1); // 2.718281828459045\nMath.exp(Infinity); // Infinity\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Math.E")}}\n- {{jsxref("Math.expm1()")}}\n- {{jsxref("Math.log()")}}\n- {{jsxref("Math.log10()")}}\n- {{jsxref("Math.log1p()")}}\n- {{jsxref("Math.log2()")}}\n- {{jsxref("Math.pow()")}}\n'
        },
        "expm1": {
            "index.md": '---\ntitle: Math.expm1()\nslug: Web/JavaScript/Reference/Global_Objects/Math/expm1\npage-type: javascript-static-method\nbrowser-compat: javascript.builtins.Math.expm1\n---\n\n{{JSRef}}\n\nThe **`Math.expm1()`** static method returns [e](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/E) raised to the power of a number, subtracted by 1. That is\n\n<math display="block"><semantics><mrow><mrow><mo lspace="0em" rspace="0.16666666666666666em">\uD835\uDE7C\uD835\uDE8A\uD835\uDE9D\uD835\uDE91.\uD835\uDE8E\uD835\uDEA1\uD835\uDE99\uD835\uDE96\uD835\uDFF7</mo><mo stretchy="false">(</mo><mi>\uD835\uDEA1</mi><mo stretchy="false">)</mo></mrow><mo>=</mo><msup><mi mathvariant="normal">e</mi><mi>x</mi></msup><mo>\u2212</mo><mn>1</mn></mrow><annotation encoding="TeX">\\mathtt{\\operatorname{Math.expm1}(x)} = \\mathrm{e}^x - 1</annotation></semantics></math>\n\n{{EmbedInteractiveExample("pages/js/math-expm1.html")}}\n\n## Syntax\n\n```js-nolint\nMath.expm1(x)\n```\n\n### Parameters\n\n- `x`\n  - : A number.\n\n### Return value\n\nA number representing e<sup>x</sup> - 1, where e is [the base of the natural logarithm](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/E).\n\n## Description\n\nFor very small values of _x_, adding 1 can reduce or eliminate precision. The double floats used in JS give you about 15 digits of precision. 1 + 1e-15 \\= 1.000000000000001, but 1 + 1e-16 = 1.000000000000000 and therefore exactly 1.0 in that arithmetic, because digits past 15 are rounded off.\n\nWhen you calculate <math display="inline"><semantics><msup><mi mathvariant="normal">e</mi><mi>x</mi></msup><annotation encoding="TeX">\\mathrm{e}^x</annotation></semantics></math> where x is a number very close to 0, you should get an answer very close to 1 + x, because <math display="inline"><semantics><mrow><munder><mo lspace="0em" rspace="0em">lim</mo><mrow><mi>x</mi><mo stretchy="false">\u2192</mo><mn>0</mn></mrow></munder><mfrac><mrow><msup><mi mathvariant="normal">e</mi><mi>x</mi></msup><mo>\u2212</mo><mn>1</mn></mrow><mi>x</mi></mfrac><mo>=</mo><mn>1</mn></mrow><annotation encoding="TeX">\\lim\\_{x \\to 0} \\frac{\\mathrm{e}^x - 1}{x} = 1</annotation></semantics></math>. If you calculate `Math.exp(1.1111111111e-15) - 1`, you should get an answer close to `1.1111111111e-15`. Instead, due to the highest significant figure in the result of `Math.exp` being the units digit `1`, the final value ends up being `1.1102230246251565e-15`, with only 3 correct digits. If, instead, you calculate `Math.exp1m(1.1111111111e-15)`, you will get a much more accurate answer `1.1111111111000007e-15`, with 11 correct digits of precision.\n\nBecause `expm1()` is a static method of `Math`, you always use it as `Math.expm1()`, rather than as a method of a `Math` object you created (`Math` is not a constructor).\n\n## Examples\n\n### Using Math.expm1()\n\n```js\nMath.expm1(-Infinity); // -1\nMath.expm1(-1); // -0.6321205588285577\nMath.expm1(-0); // -0\nMath.expm1(0); // 0\nMath.expm1(1); // 1.718281828459045\nMath.expm1(Infinity); // Infinity\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Math.expm1` in `core-js`](https://github.com/zloirock/core-js#ecmascript-math)\n- {{jsxref("Math.E")}}\n- {{jsxref("Math.exp()")}}\n- {{jsxref("Math.log()")}}\n- {{jsxref("Math.log10()")}}\n- {{jsxref("Math.log1p()")}}\n- {{jsxref("Math.log2()")}}\n- {{jsxref("Math.pow()")}}\n'
        },
        "floor": {
            "index.md": '---\ntitle: Math.floor()\nslug: Web/JavaScript/Reference/Global_Objects/Math/floor\npage-type: javascript-static-method\nbrowser-compat: javascript.builtins.Math.floor\n---\n\n{{JSRef}}\n\nThe **`Math.floor()`** static method always rounds down and returns the largest integer less than or equal to a given number.\n\n{{EmbedInteractiveExample("pages/js/math-floor.html")}}\n\n## Syntax\n\n```js-nolint\nMath.floor(x)\n```\n\n### Parameters\n\n- `x`\n  - : A number.\n\n### Return value\n\nThe largest integer smaller than or equal to `x`. It\'s the same value as [`-Math.ceil(-x)`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/ceil).\n\n## Description\n\nBecause `floor()` is a static method of `Math`, you always use it as `Math.floor()`, rather than as a method of a `Math` object you created (`Math` is not a constructor).\n\n## Examples\n\n### Using Math.floor()\n\n```js\nMath.floor(-Infinity); // -Infinity\nMath.floor(-45.95); // -46\nMath.floor(-45.05); // -46\nMath.floor(-0); // -0\nMath.floor(0); // 0\nMath.floor(4); // 4\nMath.floor(45.05); // 45\nMath.floor(45.95); // 45\nMath.floor(Infinity); // Infinity\n```\n\n### Decimal adjustment\n\nIn this example, we implement a method called `decimalAdjust()` that is an enhancement method of `Math.floor()`, {{jsxref("Math.ceil()")}}, and {{jsxref("Math.round()")}}. While the three `Math` functions always adjust the input to the units digit, `decimalAdjust` accepts an `exp` parameter that specifies the number of digits to the left of the decimal point to which the number should be adjusted. For example, `-1` means it would leave one digit after the decimal point (as in "\xd7 10<sup>-1</sup>"). In addition, it allows you to select the means of adjustment \u2014 `round`, `floor`, or `ceil` \u2014 through the `type` parameter.\n\nIt does so by multiplying the number by a power of 10, then rounding the result to the nearest integer, then dividing by the power of 10. To better preserve precision, it takes advantage of Number\'s [`toString()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/toString) method, which represents large or small numbers in scientific notation (like `6.02e23`).\n\n```js\n/**\n * Adjusts a number to the specified digit.\n *\n * @param {"round" | "floor" | "ceil"} type The type of adjustment.\n * @param {number} value The number.\n * @param {number} exp The exponent (the 10 logarithm of the adjustment base).\n * @returns {number} The adjusted value.\n */\nfunction decimalAdjust(type, value, exp) {\n  type = String(type);\n  if (!["round", "floor", "ceil"].includes(type)) {\n    throw new TypeError(\n      "The type of decimal adjustment must be one of \'round\', \'floor\', or \'ceil\'.",\n    );\n  }\n  exp = Number(exp);\n  value = Number(value);\n  if (exp % 1 !== 0 || Number.isNaN(value)) {\n    return NaN;\n  } else if (exp === 0) {\n    return Math[type](value);\n  }\n  const [magnitude, exponent = 0] = value.toString().split("e");\n  const adjustedValue = Math[type](`${magnitude}e${exponent - exp}`);\n  // Shift back\n  const [newMagnitude, newExponent = 0] = adjustedValue.toString().split("e");\n  return Number(`${newMagnitude}e${+newExponent + exp}`);\n}\n\n// Decimal round\nconst round10 = (value, exp) => decimalAdjust("round", value, exp);\n// Decimal floor\nconst floor10 = (value, exp) => decimalAdjust("floor", value, exp);\n// Decimal ceil\nconst ceil10 = (value, exp) => decimalAdjust("ceil", value, exp);\n\n// Round\nround10(55.55, -1); // 55.6\nround10(55.549, -1); // 55.5\nround10(55, 1); // 60\nround10(54.9, 1); // 50\nround10(-55.55, -1); // -55.5\nround10(-55.551, -1); // -55.6\nround10(-55, 1); // -50\nround10(-55.1, 1); // -60\n// Floor\nfloor10(55.59, -1); // 55.5\nfloor10(59, 1); // 50\nfloor10(-55.51, -1); // -55.6\nfloor10(-51, 1); // -60\n// Ceil\nceil10(55.51, -1); // 55.6\nceil10(51, 1); // 60\nceil10(-55.59, -1); // -55.5\nceil10(-59, 1); // -50\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Math.abs()")}}\n- {{jsxref("Math.ceil()")}}\n- {{jsxref("Math.round()")}}\n- {{jsxref("Math.sign()")}}\n- {{jsxref("Math.trunc()")}}\n'
        },
        "fround": {
            "index.md": '---\ntitle: Math.fround()\nslug: Web/JavaScript/Reference/Global_Objects/Math/fround\npage-type: javascript-static-method\nbrowser-compat: javascript.builtins.Math.fround\n---\n\n{{JSRef}}\n\nThe **`Math.fround()`** static method returns the nearest [32-bit single precision](https://en.wikipedia.org/wiki/Single-precision_floating-point_format) float representation of a number.\n\n{{EmbedInteractiveExample("pages/js/math-fround.html")}}\n\n## Syntax\n\n```js-nolint\nMath.fround(doubleFloat)\n```\n\n### Parameters\n\n- `doubleFloat`\n  - : A number.\n\n### Return value\n\nThe nearest [32-bit single precision](https://en.wikipedia.org/wiki/Single-precision_floating-point_format) float representation of `x`.\n\n## Description\n\nJavaScript uses 64-bit double floating-point numbers internally, which offer a very high precision. However, sometimes you may be working with 32-bit floating-point numbers, for example if you are reading values from a {{jsxref("Float32Array")}}. This can create confusion: checking a 64-bit float and a 32-bit float for equality may fail even though the numbers are seemingly identical.\n\nTo solve this, `Math.fround()` can be used to cast the 64-bit float to a 32-bit float. Internally, JavaScript continues to treat the number as a 64-bit float, it just performs a "round to even" on the 23rd bit of the mantissa, and sets all following mantissa bits to `0`. If the number is outside the range of a 32-bit float, {{jsxref("Infinity")}} or `-Infinity` is returned.\n\nBecause `fround()` is a static method of `Math`, you always use it as `Math.fround()`, rather than as a method of a `Math` object you created (`Math` is not a constructor).\n\n## Examples\n\n### Using Math.fround()\n\nThe number 1.5 can be precisely represented in the binary numeral system, and is identical in 32-bit and 64-bit:\n\n```js\nMath.fround(1.5); // 1.5\nMath.fround(1.5) === 1.5; // true\n```\n\nHowever, the number 1.337 cannot be precisely represented in the binary numeral system, so it differs in 32-bit and 64-bit:\n\n```js\nMath.fround(1.337); // 1.3370000123977661\nMath.fround(1.337) === 1.337; // false\n```\n\n<math><semantics><msup><mn>2</mn><mn>150</mn></msup><annotation encoding="TeX">2^150</annotation></semantics></math> is too big for a 32-bit float, so `Infinity` is returned:\n\n```js\n2 ** 150; // 1.42724769270596e+45\nMath.fround(2 ** 150); // Infinity\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Math.fround` in `core-js`](https://github.com/zloirock/core-js#ecmascript-math)\n- {{jsxref("Math.round()")}}\n'
        },
        "hypot": {
            "index.md": '---\ntitle: Math.hypot()\nslug: Web/JavaScript/Reference/Global_Objects/Math/hypot\npage-type: javascript-static-method\nbrowser-compat: javascript.builtins.Math.hypot\n---\n\n{{JSRef}}\n\nThe **`Math.hypot()`** static method returns the square root of the sum of squares of its arguments. That is,\n\n<math display="block"><semantics><mrow><mstyle mathvariant="monospace"><mo lspace="0em" rspace="0.16666666666666666em">\uD835\uDE7C\uD835\uDE8A\uD835\uDE9D\uD835\uDE91.\uD835\uDE91\uD835\uDEA2\uD835\uDE99\uD835\uDE98\uD835\uDE9D</mo><mo stretchy="false">(</mo><msub><mi>v</mi><mn>1</mn></msub><mo>,</mo><msub><mi>v</mi><mn>2</mn></msub><mo>,</mo><mo>\u2026</mo><mo>,</mo><msub><mi>v</mi><mi>n</mi></msub><mo stretchy="false">)</mo></mstyle><mo>=</mo><msqrt><mrow><munderover><mo>\u2211</mo><mrow><mi>i</mi><mo>=</mo><mn>1</mn></mrow><mi>n</mi></munderover><msubsup><mi>v</mi><mi>i</mi><mn>2</mn></msubsup></mrow></msqrt><mo>=</mo><msqrt><mrow><msubsup><mi>v</mi><mn>1</mn><mn>2</mn></msubsup><mo>+</mo><msubsup><mi>v</mi><mn>2</mn><mn>2</mn></msubsup><mo>+</mo><mo>\u2026</mo><mo>+</mo><msubsup><mi>v</mi><mi>n</mi><mn>2</mn></msubsup></mrow></msqrt></mrow><annotation encoding="TeX">\\mathtt{\\operatorname{Math.hypot}(v_1, v_2, \\dots, v_n)} = \\sqrt{\\sum\\_{i=1}^n v_i^2} = \\sqrt{v_1^2 + v_2^2 + \\dots + v_n^2}</annotation></semantics></math>\n\n{{EmbedInteractiveExample("pages/js/math-hypot.html")}}\n\n## Syntax\n\n```js-nolint\nMath.hypot()\nMath.hypot(value1)\nMath.hypot(value1, value2)\nMath.hypot(value1, value2, /* \u2026, */ valueN)\n```\n\n### Parameters\n\n- `value1`, \u2026, `valueN`\n  - : Numbers.\n\n### Return value\n\nThe square root of the sum of squares of the given arguments. Returns {{jsxref("Infinity")}} if any of the arguments is \xb1Infinity. Otherwise, if at least one of the arguments is or is converted to {{jsxref("NaN")}}, returns {{jsxref("NaN")}}. Returns `0` if no arguments are given or all arguments are \xb10.\n\n## Description\n\nCalculating the hypotenuse of a right triangle, or the magnitude of a complex number, uses the formula `Math.sqrt(v1*v1 + v2*v2)`, where v1 and v2 are the lengths of the triangle\'s legs, or the complex number\'s real and complex components. The corresponding distance in 2 or more dimensions can be calculated by adding more squares under the square root: `Math.sqrt(v1*v1 + v2*v2 + v3*v3 + v4*v4)`.\n\nThis function makes this calculation easier and faster; you call `Math.hypot(v1, v2)`, or `Math.hypot(v1, /* \u2026, */, vN)`.\n\n`Math.hypot` also avoids overflow/underflow problems if the magnitude of your numbers is very large. The largest number you can represent in JS is [`Number.MAX_VALUE`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/MAX_VALUE), which is around 10<sup>308</sup>. If your numbers are larger than about 10<sup>154</sup>, taking the square of them will result in Infinity. For example, `Math.sqrt(1e200*1e200 + 1e200*1e200) = Infinity`. If you use `hypot()` instead, you get a better answer: `Math.hypot(1e200, 1e200) = 1.4142...e+200` . This is also true with very small numbers. `Math.sqrt(1e-200*1e-200 + 1e-200*1e-200) = 0`, but `Math.hypot(1e-200, 1e-200) = 1.4142...e-200`.\n\nWith one argument, `Math.hypot()` is equivalent to [`Math.abs()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/abs). [`Math.hypot.length`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/length) is 2, which weakly signals that it\'s designed to handle at least two parameters.\n\nBecause `hypot()` is a static method of `Math`, you always use it as `Math.hypot()`, rather than as a method of a `Math` object you created (`Math` is not a constructor).\n\n## Examples\n\n### Using Math.hypot()\n\n```js\nMath.hypot(3, 4); // 5\nMath.hypot(3, 4, 5); // 7.0710678118654755\nMath.hypot(); // 0\nMath.hypot(NaN); // NaN\nMath.hypot(NaN, Infinity); // Infinity\nMath.hypot(3, 4, "foo"); // NaN, since +\'foo\' => NaN\nMath.hypot(3, 4, "5"); // 7.0710678118654755, +\'5\' => 5\nMath.hypot(-3); // 3, the same as Math.abs(-3)\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Math.hypot` in `core-js`](https://github.com/zloirock/core-js#ecmascript-math)\n- {{jsxref("Math.abs()")}}\n- {{jsxref("Math.pow()")}}\n- {{jsxref("Math.sqrt()")}}\n'
        },
        "imul": {
            "index.md": '---\ntitle: Math.imul()\nslug: Web/JavaScript/Reference/Global_Objects/Math/imul\npage-type: javascript-static-method\nbrowser-compat: javascript.builtins.Math.imul\n---\n\n{{JSRef}}\n\nThe **`Math.imul()`** static method returns the result of the C-like 32-bit multiplication of the two parameters.\n\n{{EmbedInteractiveExample("pages/js/math-imul.html")}}\n\n## Syntax\n\n```js-nolint\nMath.imul(a, b)\n```\n\n### Parameters\n\n- `a`\n  - : First number.\n- `b`\n  - : Second number.\n\n### Return value\n\nThe result of the C-like 32-bit multiplication of the given arguments.\n\n## Description\n\n`Math.imul()` allows for 32-bit integer multiplication with C-like semantics. This feature is useful for projects like [Emscripten](https://en.wikipedia.org/wiki/Emscripten).\n\nBecause `imul()` is a static method of `Math`, you always use it as `Math.imul()`, rather than as a method of a `Math` object you created (`Math` is not a constructor).\n\nIf you use normal JavaScript floating point numbers in `imul()`, you will experience a degrade in performance. This is because of the costly conversion from a floating point to an integer for multiplication, and then converting the multiplied integer back into a floating point. However, with [asm.js](/en-US/docs/Games/Tools/asm.js), which allows JIT-optimizers to more confidently use integers in JavaScript, multiplying two numbers stored internally as integers (which is only possible with asm.js) with `imul()` could be potentially more performant.\n\n## Examples\n\n### Using Math.imul()\n\n```js\nMath.imul(2, 4); // 8\nMath.imul(-1, 8); // -8\nMath.imul(-2, -2); // 4\nMath.imul(0xffffffff, 5); // -5\nMath.imul(0xfffffffe, 5); // -10\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Math.imul` in `core-js`](https://github.com/zloirock/core-js#ecmascript-math)\n- [Emscripten](https://en.wikipedia.org/wiki/Emscripten) on Wikipedia\n'
        },
        "index.md": '---\ntitle: Math\nslug: Web/JavaScript/Reference/Global_Objects/Math\npage-type: javascript-namespace\nbrowser-compat: javascript.builtins.Math\n---\n\n{{JSRef}}\n\nThe **`Math`** namespace object contains static properties and methods for mathematical constants and functions.\n\n`Math` works with the {{jsxref("Number")}} type. It doesn\'t work with {{jsxref("BigInt")}}.\n\n## Description\n\nUnlike most global objects, `Math` is not a constructor. You cannot use it with the [`new` operator](/en-US/docs/Web/JavaScript/Reference/Operators/new) or invoke the `Math` object as a function. All properties and methods of `Math` are static.\n\n> **Note:** Many `Math` functions have a precision that\'s _implementation-dependent_.\n>\n> This means that different browsers can give a different result. Even the same JavaScript engine on a different OS or architecture can give different results!\n\n## Static properties\n\n- {{jsxref("Math.E")}}\n  - : Euler\'s number and the base of natural logarithms; approximately `2.718`.\n- {{jsxref("Math.LN10")}}\n  - : Natural logarithm of `10`; approximately `2.303`.\n- {{jsxref("Math.LN2")}}\n  - : Natural logarithm of `2`; approximately `0.693`.\n- {{jsxref("Math.LOG10E")}}\n  - : Base-10 logarithm of `E`; approximately `0.434`.\n- {{jsxref("Math.LOG2E")}}\n  - : Base-2 logarithm of `E`; approximately `1.443`.\n- {{jsxref("Math.PI")}}\n  - : Ratio of a circle\'s circumference to its diameter; approximately `3.14159`.\n- {{jsxref("Math.SQRT1_2")}}\n  - : Square root of \xbd; approximately `0.707`.\n- {{jsxref("Math.SQRT2")}}\n  - : Square root of `2`; approximately `1.414`.\n- `Math[@@toStringTag]`\n  - : The initial value of the [`@@toStringTag`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol/toStringTag) property is the string `"Math"`. This property is used in {{jsxref("Object.prototype.toString()")}}.\n\n## Static methods\n\n- {{jsxref("Math.abs()")}}\n  - : Returns the absolute value of `x`.\n- {{jsxref("Math.acos()")}}\n  - : Returns the arccosine of `x`.\n- {{jsxref("Math.acosh()")}}\n  - : Returns the hyperbolic arccosine of `x`.\n- {{jsxref("Math.asin()")}}\n  - : Returns the arcsine of `x`.\n- {{jsxref("Math.asinh()")}}\n  - : Returns the hyperbolic arcsine of a number.\n- {{jsxref("Math.atan()")}}\n  - : Returns the arctangent of `x`.\n- {{jsxref("Math.atan2()")}}\n  - : Returns the arctangent of the quotient of its arguments.\n- {{jsxref("Math.atanh()")}}\n  - : Returns the hyperbolic arctangent of `x`.\n- {{jsxref("Math.cbrt()")}}\n  - : Returns the cube root of `x`.\n- {{jsxref("Math.ceil()")}}\n  - : Returns the smallest integer greater than or equal to `x`.\n- {{jsxref("Math.clz32()")}}\n  - : Returns the number of leading zero bits of the 32-bit integer `x`.\n- {{jsxref("Math.cos()")}}\n  - : Returns the cosine of `x`.\n- {{jsxref("Math.cosh()")}}\n  - : Returns the hyperbolic cosine of `x`.\n- {{jsxref("Math.exp()")}}\n  - : Returns e<sup>x</sup>, where x is the argument, and e is Euler\'s number (`2.718`\u2026, the base of the natural logarithm).\n- {{jsxref("Math.expm1()")}}\n  - : Returns subtracting `1` from `exp(x)`.\n- {{jsxref("Math.floor()")}}\n  - : Returns the largest integer less than or equal to `x`.\n- {{jsxref("Math.fround()")}}\n  - : Returns the nearest [single precision](https://en.wikipedia.org/wiki/Single-precision_floating-point_format) float representation of `x`.\n- {{jsxref("Math.hypot()")}}\n  - : Returns the square root of the sum of squares of its arguments.\n- {{jsxref("Math.imul()")}}\n  - : Returns the result of the 32-bit integer multiplication of `x` and `y`.\n- {{jsxref("Math.log()")}}\n  - : Returns the natural logarithm (\u33D2<sub>e</sub>; also, \u33D1) of `x`.\n- {{jsxref("Math.log10()")}}\n  - : Returns the base-10 logarithm of `x`.\n- {{jsxref("Math.log1p()")}}\n  - : Returns the natural logarithm (\u33D2<sub>e</sub>; also \u33D1) of `1 + x` for the number `x`.\n- {{jsxref("Math.log2()")}}\n  - : Returns the base-2 logarithm of `x`.\n- {{jsxref("Math.max()")}}\n  - : Returns the largest of zero or more numbers.\n- {{jsxref("Math.min()")}}\n  - : Returns the smallest of zero or more numbers.\n- {{jsxref("Math.pow()")}}\n  - : Returns base `x` to the exponent power `y` (that is, `x`<sup><code>y</code></sup>).\n- {{jsxref("Math.random()")}}\n  - : Returns a pseudo-random number between `0` and `1`.\n- {{jsxref("Math.round()")}}\n  - : Returns the value of the number `x` rounded to the nearest integer.\n- {{jsxref("Math.sign()")}}\n  - : Returns the sign of the `x`, indicating whether `x` is positive, negative, or zero.\n- {{jsxref("Math.sin()")}}\n  - : Returns the sine of `x`.\n- {{jsxref("Math.sinh()")}}\n  - : Returns the hyperbolic sine of `x`.\n- {{jsxref("Math.sqrt()")}}\n  - : Returns the positive square root of `x`.\n- {{jsxref("Math.tan()")}}\n  - : Returns the tangent of `x`.\n- {{jsxref("Math.tanh()")}}\n  - : Returns the hyperbolic tangent of `x`.\n- {{jsxref("Math.trunc()")}}\n  - : Returns the integer portion of `x`, removing any fractional digits.\n\n## Examples\n\n### Converting between degrees and radians\n\nThe trigonometric functions `sin()`, `cos()`, `tan()`, `asin()`, `acos()`, `atan()`, and `atan2()` expect (and return) angles in _radians_.\n\nSince humans tend to think in degrees, and some functions (such as CSS transforms) can accept degrees, it is a good idea to keep functions handy that convert between the two:\n\n```js\nfunction degToRad(degrees) {\n  return degrees * (Math.PI / 180);\n}\n\nfunction radToDeg(rad) {\n  return rad / (Math.PI / 180);\n}\n```\n\n### Calculating the height of an equilateral triangle\n\nIf we want to calculate the height of an equilateral triangle, and we know its side length is 100, we can use the formulae _length of the adjacent multiplied by the tangent of the angle is equal to the opposite._\n\n![An equilateral triangle where a perpendicular of one edge is drawn from the opposite vertex, forming a right triangle with three sides marked as "adjacent", "opposite", and "hypotenuse". The angle between the "adjacent" and "hypotenuse" sides is 60 degrees.](trigonometry.png)\n\nIn JavaScript, we can do this with the following:\n\n```js\n50 * Math.tan(degToRad(60));\n```\n\nWe use our `degToRad()` function to convert 60 degrees to radians, as {{jsxref("Math.tan()")}} expects an input value in radians.\n\n### Returning a random integer between two bounds\n\nThis can be achieved with a combination of {{jsxref("Math.random()")}} and {{jsxref("Math.floor()")}}:\n\n```js\nfunction random(min, max) {\n  const num = Math.floor(Math.random() * (max - min + 1)) + min;\n  return num;\n}\n\nrandom(1, 10);\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Number")}}\n',
        "ln10": {
            "index.md": '---\ntitle: Math.LN10\nslug: Web/JavaScript/Reference/Global_Objects/Math/LN10\npage-type: javascript-static-data-property\nbrowser-compat: javascript.builtins.Math.LN10\n---\n\n{{JSRef}}\n\nThe **`Math.LN10`** static data property represents the natural logarithm of 10, approximately 2.302.\n\n{{EmbedInteractiveExample("pages/js/math-ln10.html", "shorter")}}\n\n## Value\n\n<math display="block"><semantics><mrow><mi>\uD835\uDE7C\uD835\uDE8A\uD835\uDE9D\uD835\uDE91.\uD835\uDE7B\uD835\uDE7D\uD835\uDFF7\uD835\uDFF6</mi><mo>=</mo><mo lspace="0em" rspace="0em">ln</mo><mo stretchy="false">(</mo><mn>10</mn><mo stretchy="false">)</mo><mo>\u2248</mo><mn>2.302</mn></mrow><annotation encoding="TeX">\\mathtt{\\mi{Math.LN10}} = \\ln(10) \\approx 2.302</annotation></semantics></math>\n\n{{js_property_attributes(0, 0, 0)}}\n\n## Description\n\nBecause `LN10` is a static property of `Math`, you always use it as `Math.LN10`, rather than as a property of a `Math` object you created (`Math` is not a constructor).\n\n## Examples\n\n### Using Math.LN10\n\nThe following function returns the natural log of 10:\n\n```js\nfunction getNatLog10() {\n  return Math.LN10;\n}\n\ngetNatLog10(); // 2.302585092994046\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Math.exp()")}}\n- {{jsxref("Math.log()")}}\n- {{jsxref("Math.log10()")}}\n'
        },
        "ln2": {
            "index.md": '---\ntitle: Math.LN2\nslug: Web/JavaScript/Reference/Global_Objects/Math/LN2\npage-type: javascript-static-data-property\nbrowser-compat: javascript.builtins.Math.LN2\n---\n\n{{JSRef}}\n\nThe **`Math.LN2`** static data property represents the natural logarithm of 2, approximately 0.693:\n\n{{EmbedInteractiveExample("pages/js/math-ln2.html", "shorter")}}\n\n## Value\n\n<math display="block"><semantics><mrow><mi>\uD835\uDE7C\uD835\uDE8A\uD835\uDE9D\uD835\uDE91.\uD835\uDE7B\uD835\uDE7D\uD835\uDFF8</mi><mo>=</mo><mo lspace="0em" rspace="0em">ln</mo><mo stretchy="false">(</mo><mn>2</mn><mo stretchy="false">)</mo><mo>\u2248</mo><mn>0.693</mn></mrow><annotation encoding="TeX">\\mathtt{\\mi{Math.LN2}} = \\ln(2) \\approx 0.693</annotation></semantics></math>\n\n{{js_property_attributes(0, 0, 0)}}\n\n## Description\n\nBecause `LN2` is a static property of `Math`, you always use it as `Math.LN2`, rather than as a property of a `Math` object you created (`Math` is not a constructor).\n\n## Examples\n\n### Using Math.LN2\n\nThe following function returns the natural log of 2:\n\n```js\nfunction getNatLog2() {\n  return Math.LN2;\n}\n\ngetNatLog2(); // 0.6931471805599453\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Math.exp()")}}\n- {{jsxref("Math.log()")}}\n- {{jsxref("Math.log2()")}}\n'
        },
        "log": {
            "index.md": '---\ntitle: Math.log()\nslug: Web/JavaScript/Reference/Global_Objects/Math/log\npage-type: javascript-static-method\nbrowser-compat: javascript.builtins.Math.log\n---\n\n{{JSRef}}\n\nThe **`Math.log()`** static method returns the natural logarithm (base [e](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/E)) of a number. That is\n\n<math display="block"><semantics><mrow><mo>\u2200</mo><mi>x</mi><mo>&gt;</mo><mn>0</mn><mo>,</mo><mspace width="0.2777777777777778em"></mspace><mrow><mo lspace="0em" rspace="0.16666666666666666em">\uD835\uDE7C\uD835\uDE8A\uD835\uDE9D\uD835\uDE91.\uD835\uDE95\uD835\uDE98\uD835\uDE90</mo><mo stretchy="false">(</mo><mi>\uD835\uDEA1</mi><mo stretchy="false">)</mo></mrow><mo>=</mo><mo lspace="0em" rspace="0em">ln</mo><mo stretchy="false">(</mo><mi>x</mi><mo stretchy="false">)</mo><mo>=</mo><mtext>the unique&nbsp;</mtext><mi>y</mi><mtext>&nbsp;such that&nbsp;</mtext><msup><mi>e</mi><mi>y</mi></msup><mo>=</mo><mi>x</mi></mrow><annotation encoding="TeX">\\forall x &gt; 0,\\;\\mathtt{\\operatorname{Math.log}(x)} = \\ln(x) = \\text{the unique } y \\text{ such that } e^y = x</annotation></semantics></math>\n\n{{EmbedInteractiveExample("pages/js/math-log.html")}}\n\n## Syntax\n\n```js-nolint\nMath.log(x)\n```\n\n### Parameters\n\n- `x`\n  - : A number greater than or equal to 0.\n\n### Return value\n\nThe natural logarithm (base [e](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/E)) of `x`. If `x` is \xb10, returns [`-Infinity`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/NEGATIVE_INFINITY). If `x < 0`, returns {{jsxref("NaN")}}.\n\n## Description\n\nBecause `log()` is a static method of `Math`, you always use it as `Math.log()`, rather than as a method of a `Math` object you created (`Math` is not a constructor).\n\nIf you need the natural log of 2 or 10, use the constants {{jsxref("Math.LN2")}} or {{jsxref("Math.LN10")}}. If you need a logarithm to base 2 or 10, use {{jsxref("Math.log2()")}} or {{jsxref("Math.log10()")}}. If you need a logarithm to other bases, use `Math.log(x) / Math.log(otherBase)` as in the example below; you might want to precalculate `1 / Math.log(otherBase)` since multiplication in `Math.log(x) * constant` is much faster.\n\nBeware that positive numbers very close to 1 can suffer from loss of precision and make its natural logarithm less accurate. In this case, you may want to use {{jsxref("Math.log1p")}} instead.\n\n## Examples\n\n### Using Math.log()\n\n```js\nMath.log(-1); // NaN\nMath.log(-0); // -Infinity\nMath.log(0); // -Infinity\nMath.log(1); // 0\nMath.log(10); // 2.302585092994046\nMath.log(Infinity); // Infinity\n```\n\n### Using Math.log() with a different base\n\nThe following function returns the logarithm of `y` with base `x` (i.e. <math><semantics><mrow><msub><mo>log</mo><mi>x</mi></msub><mi>y</mi></mrow><annotation encoding="TeX">\\log_x y</annotation></semantics></math>):\n\n```js\nfunction getBaseLog(x, y) {\n  return Math.log(y) / Math.log(x);\n}\n```\n\nIf you run `getBaseLog(10, 1000)`, it returns `2.9999999999999996` due to floating-point rounding, but still very close to the actual answer of 3.\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Math.exp()")}}\n- {{jsxref("Math.log1p()")}}\n- {{jsxref("Math.log10()")}}\n- {{jsxref("Math.log2()")}}\n- {{jsxref("Math.pow()")}}\n'
        },
        "log10": {
            "index.md": '---\ntitle: Math.log10()\nslug: Web/JavaScript/Reference/Global_Objects/Math/log10\npage-type: javascript-static-method\nbrowser-compat: javascript.builtins.Math.log10\n---\n\n{{JSRef}}\n\nThe **`Math.log10()`** static method returns the base 10 logarithm of a number. That is\n\n<math display="block"><semantics><mrow><mo>\u2200</mo><mi>x</mi><mo>&gt;</mo><mn>0</mn><mo>,</mo><mspace width="0.2777777777777778em"></mspace><mrow><mo lspace="0em" rspace="0.16666666666666666em">\uD835\uDE7C\uD835\uDE8A\uD835\uDE9D\uD835\uDE91.\uD835\uDE95\uD835\uDE98\uD835\uDE90\uD835\uDFF7\uD835\uDFF6</mo><mo stretchy="false">(</mo><mi>\uD835\uDEA1</mi><mo stretchy="false">)</mo></mrow><mo>=</mo><msub><mo lspace="0em" rspace="0em">log</mo><mn>10</mn></msub><mo stretchy="false">(</mo><mi>x</mi><mo stretchy="false">)</mo><mo>=</mo><mtext>the unique&nbsp;</mtext><mi>y</mi><mtext>&nbsp;such that&nbsp;</mtext><msup><mn>10</mn><mi>y</mi></msup><mo>=</mo><mi>x</mi></mrow><annotation encoding="TeX">\\forall x &gt; 0,\\;\\mathtt{\\operatorname{Math.log10}(x)} = \\log\\_{10}(x) = \\text{the unique } y \\text{ such that } 10^y = x</annotation></semantics></math>\n\n{{EmbedInteractiveExample("pages/js/math-log10.html")}}\n\n## Syntax\n\n```js-nolint\nMath.log10(x)\n```\n\n### Parameters\n\n- `x`\n  - : A number greater than or equal to 0.\n\n### Return value\n\nThe base 10 logarithm of `x`. If `x < 0`, returns {{jsxref("NaN")}}.\n\n## Description\n\nBecause `log10()` is a static method of `Math`, you always use it as `Math.log10()`, rather than as a method of a `Math` object you created (`Math` is not a constructor).\n\nThis function is the equivalent of `Math.log(x) / Math.log(10)`. For `log10(e)`, use the constant {{jsxref("Math.LOG10E")}}, which is 1 / {{jsxref("Math.LN10")}}.\n\n## Examples\n\n### Using Math.log10()\n\n```js\nMath.log10(-2); // NaN\nMath.log10(-0); // -Infinity\nMath.log10(0); // -Infinity\nMath.log10(1); // 0\nMath.log10(2); // 0.3010299956639812\nMath.log10(100000); // 5\nMath.log10(Infinity); // Infinity\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Math.log10` in `core-js`](https://github.com/zloirock/core-js#ecmascript-math)\n- {{jsxref("Math.exp()")}}\n- {{jsxref("Math.log()")}}\n- {{jsxref("Math.log1p()")}}\n- {{jsxref("Math.log2()")}}\n- {{jsxref("Math.pow()")}}\n'
        },
        "log10e": {
            "index.md": '---\ntitle: Math.LOG10E\nslug: Web/JavaScript/Reference/Global_Objects/Math/LOG10E\npage-type: javascript-static-data-property\nbrowser-compat: javascript.builtins.Math.LOG10E\n---\n\n{{JSRef}}\n\nThe **`Math.LOG10E`** static data property represents the base 10 logarithm of [e](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/E), approximately 0.434.\n\n{{EmbedInteractiveExample("pages/js/math-log10e.html", "shorter")}}\n\n## Value\n\n<math display="block"><semantics><mrow><mi>\uD835\uDE7C\uD835\uDE8A\uD835\uDE9D\uD835\uDE91.\uD835\uDE7B\uD835\uDE7E\uD835\uDE76\uD835\uDFF7\uD835\uDFF6\uD835\uDE74</mi><mo>=</mo><msub><mo lspace="0em" rspace="0em">log</mo><mn>10</mn></msub><mo stretchy="false">(</mo><mi mathvariant="normal">e</mi><mo stretchy="false">)</mo><mo>\u2248</mo><mn>0.434</mn></mrow><annotation encoding="TeX">\\mathtt{\\mi{Math.LOG10E}} = \\log\\_{10}(\\mathrm{e}) \\approx 0.434</annotation></semantics></math>\n\n{{js_property_attributes(0, 0, 0)}}\n\n## Description\n\nBecause `LOG10E` is a static property of `Math`, you always use it as `Math.LOG10E`, rather than as a property of a `Math` object you created (`Math` is not a constructor).\n\n## Examples\n\n### Using Math.LOG10E\n\nThe following function returns the base 10 logarithm of e:\n\n```js\nfunction getLog10e() {\n  return Math.LOG10E;\n}\n\ngetLog10e(); // 0.4342944819032518\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Math.exp()")}}\n- {{jsxref("Math.log()")}}\n- {{jsxref("Math.log10()")}}\n'
        },
        "log1p": {
            "index.md": '---\ntitle: Math.log1p()\nslug: Web/JavaScript/Reference/Global_Objects/Math/log1p\npage-type: javascript-static-method\nbrowser-compat: javascript.builtins.Math.log1p\n---\n\n{{JSRef}}\n\nThe **`Math.log1p()`** static method returns the natural logarithm (base [e](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/E)) of `1 + x`, where `x` is the argument. That is:\n\n<math display="block"><semantics><mrow><mo>\u2200</mo><mi>x</mi><mo>&gt;</mo><mo>\u2212</mo><mn>1</mn><mo>,</mo><mspace width="0.2777777777777778em"></mspace><mrow><mo lspace="0em" rspace="0.16666666666666666em">\uD835\uDE7C\uD835\uDE8A\uD835\uDE9D\uD835\uDE91.\uD835\uDE95\uD835\uDE98\uD835\uDE90\uD835\uDFF7\uD835\uDE99</mo><mo stretchy="false">(</mo><mi>\uD835\uDEA1</mi><mo stretchy="false">)</mo></mrow><mo>=</mo><mo lspace="0em" rspace="0em">ln</mo><mo stretchy="false">(</mo><mn>1</mn><mo>+</mo><mi>x</mi><mo stretchy="false">)</mo></mrow><annotation encoding="TeX">\\forall x &gt; -1,\\;\\mathtt{\\operatorname{Math.log1p}(x)} = \\ln(1 + x)</annotation></semantics></math>\n\n{{EmbedInteractiveExample("pages/js/math-log1p.html")}}\n\n## Syntax\n\n```js-nolint\nMath.log1p(x)\n```\n\n### Parameters\n\n- `x`\n  - : A number greater than or equal to -1.\n\n### Return value\n\nThe natural logarithm (base [e](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/E)) of `x + 1`. If `x` is -1, returns [`-Infinity`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/NEGATIVE_INFINITY). If `x < -1`, returns {{jsxref("NaN")}}.\n\n## Description\n\nFor very small values of _x_, adding 1 can reduce or eliminate precision. The double floats used in JS give you about 15 digits of precision. 1 + 1e-15 \\= 1.000000000000001, but 1 + 1e-16 = 1.000000000000000 and therefore exactly 1.0 in that arithmetic, because digits past 15 are rounded off.\n\nWhen you calculate log(1 + _x_) where _x_ is a small positive number, you should get an answer very close to _x_, because <math display="inline"><semantics><mrow><munder><mo movablelimits="true" form="prefix">lim</mo><mrow ><mi>x</mi><mo stretchy="false">\u2192</mo><mn>0</mn></mrow></munder><mfrac><mrow><mi>log</mi><mo>\u2061</mo><mo stretchy="false">(</mo><mn>1</mn><mo>+</mo><mi>x</mi><mo stretchy="false">)</mo></mrow><mi>x</mi></mfrac><mo>=</mo><mn>1</mn></mrow><annotation encoding="TeX">\\lim\\_{x \\to 0} \\frac{\\log(1+x)}{x} = 1</annotation></semantics></math>. If you calculate `Math.log(1 + 1.1111111111e-15)`, you should get an answer close to `1.1111111111e-15`. Instead, you will end up taking the logarithm of `1.00000000000000111022` (the roundoff is in binary, so sometimes it gets ugly), and get the answer 1.11022\u2026e-15, with only 3 correct digits. If, instead, you calculate `Math.log1p(1.1111111111e-15)`, you will get a much more accurate answer `1.1111111110999995e-15`, with 15 correct digits of precision (actually 16 in this case).\n\nIf the value of `x` is less than -1, the return value is always {{jsxref("NaN")}}.\n\nBecause `log1p()` is a static method of `Math`, you always use it as `Math.log1p()`, rather than as a method of a `Math` object you created (`Math` is not a constructor).\n\n## Examples\n\n### Using Math.log1p()\n\n```js\nMath.log1p(-2); // NaN\nMath.log1p(-1); // -Infinity\nMath.log1p(-0); // -0\nMath.log1p(0); // 0\nMath.log1p(1); // 0.6931471805599453\nMath.log1p(Infinity); // Infinity\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Math.log1p` in `core-js`](https://github.com/zloirock/core-js#ecmascript-math)\n- {{jsxref("Math.exp()")}}\n- {{jsxref("Math.log()")}}\n- {{jsxref("Math.expm1()")}}\n- {{jsxref("Math.log10()")}}\n- {{jsxref("Math.log2()")}}\n- {{jsxref("Math.pow()")}}\n'
        },
        "log2": {
            "index.md": '---\ntitle: Math.log2()\nslug: Web/JavaScript/Reference/Global_Objects/Math/log2\npage-type: javascript-static-method\nbrowser-compat: javascript.builtins.Math.log2\n---\n\n{{JSRef}}\n\nThe **`Math.log2()`** static method returns the base 2 logarithm of a number. That is\n\n<math display="block"><semantics><mrow><mo>\u2200</mo><mi>x</mi><mo>&gt;</mo><mn>0</mn><mo>,</mo><mspace width="0.2777777777777778em"></mspace><mrow><mo lspace="0em" rspace="0.16666666666666666em">\uD835\uDE7C\uD835\uDE8A\uD835\uDE9D\uD835\uDE91.\uD835\uDE95\uD835\uDE98\uD835\uDE90\uD835\uDFF8</mo><mo stretchy="false">(</mo><mi>\uD835\uDEA1</mi><mo stretchy="false">)</mo></mrow><mo>=</mo><msub><mo lspace="0em" rspace="0em">log</mo><mn>2</mn></msub><mo stretchy="false">(</mo><mi>x</mi><mo stretchy="false">)</mo><mo>=</mo><mtext>the unique&nbsp;</mtext><mi>y</mi><mtext>&nbsp;such that&nbsp;</mtext><msup><mn>2</mn><mi>y</mi></msup><mo>=</mo><mi>x</mi></mrow><annotation encoding="TeX">\\forall x &gt; 0,\\;\\mathtt{\\operatorname{Math.log2}(x)} = \\log_2(x) = \\text{the unique } y \\text{ such that } 2^y = x</annotation></semantics></math>\n\n{{EmbedInteractiveExample("pages/js/math-log2.html")}}\n\n## Syntax\n\n```js-nolint\nMath.log2(x)\n```\n\n### Parameters\n\n- `x`\n  - : A number greater than or equal to 0.\n\n### Return value\n\nThe base 2 logarithm of `x`. If `x < 0`, returns {{jsxref("NaN")}}.\n\n## Description\n\nBecause `log2()` is a static method of `Math`, you always use it as `Math.log2()`, rather than as a method of a `Math` object you created (`Math` is not a constructor).\n\nThis function is the equivalent of `Math.log(x) / Math.log(2)`. For `log2(e)`, use the constant {{jsxref("Math.LOG2E")}}, which is 1 / {{jsxref("Math.LN2")}}.\n\n## Examples\n\n### Using Math.log2()\n\n```js\nMath.log2(-2); // NaN\nMath.log2(-0); // -Infinity\nMath.log2(0); // -Infinity\nMath.log2(1); // 0\nMath.log2(2); // 1\nMath.log2(3); // 1.584962500721156\nMath.log2(1024); // 10\nMath.log2(Infinity); // Infinity\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Math.log2` in `core-js`](https://github.com/zloirock/core-js#ecmascript-math)\n- {{jsxref("Math.exp()")}}\n- {{jsxref("Math.log()")}}\n- {{jsxref("Math.log10()")}}\n- {{jsxref("Math.log1p()")}}\n- {{jsxref("Math.pow()")}}\n'
        },
        "log2e": {
            "index.md": '---\ntitle: Math.LOG2E\nslug: Web/JavaScript/Reference/Global_Objects/Math/LOG2E\npage-type: javascript-static-data-property\nbrowser-compat: javascript.builtins.Math.LOG2E\n---\n\n{{JSRef}}\n\nThe **`Math.LOG2E`** static data property represents the base 2 logarithm of [e](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/E), approximately 1.442.\n\n{{EmbedInteractiveExample("pages/js/math-log2e.html", "shorter")}}\n\n## Value\n\n<math display="block"><semantics><mrow><mi>\uD835\uDE7C\uD835\uDE8A\uD835\uDE9D\uD835\uDE91.\uD835\uDE7B\uD835\uDE7E\uD835\uDE76\uD835\uDFF8\uD835\uDE74</mi><mo>=</mo><msub><mo lspace="0em" rspace="0em">log</mo><mn>2</mn></msub><mo stretchy="false">(</mo><mi mathvariant="normal">e</mi><mo stretchy="false">)</mo><mo>\u2248</mo><mn>1.442</mn></mrow><annotation encoding="TeX">\\mathtt{\\mi{Math.LOG2E}} = \\log_2(\\mathrm{e}) \\approx 1.442</annotation></semantics></math>\n\n{{js_property_attributes(0, 0, 0)}}\n\n## Description\n\nBecause `LOG2E` is a static property of `Math`, you always use it as `Math.LOG2E`, rather than as a property of a `Math` object you created (`Math` is not a constructor).\n\n## Examples\n\n### Using Math.LOG2E\n\nThe following function returns the base 2 logarithm of e:\n\n```js\nfunction getLog2e() {\n  return Math.LOG2E;\n}\n\ngetLog2e(); // 1.4426950408889634\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Math.exp()")}}\n- {{jsxref("Math.log()")}}\n- {{jsxref("Math.log2()")}}\n'
        },
        "max": {
            "index.md": '---\ntitle: Math.max()\nslug: Web/JavaScript/Reference/Global_Objects/Math/max\npage-type: javascript-static-method\nbrowser-compat: javascript.builtins.Math.max\n---\n\n{{JSRef}}\n\nThe **`Math.max()`** static method returns the largest of the numbers given as input parameters, or -{{jsxref("Infinity")}} if there are no parameters.\n\n{{EmbedInteractiveExample("pages/js/math-max.html")}}\n\n## Syntax\n\n```js-nolint\nMath.max()\nMath.max(value1)\nMath.max(value1, value2)\nMath.max(value1, value2, /* \u2026, */ valueN)\n```\n\n### Parameters\n\n- `value1`, \u2026, `valueN`\n  - : Zero or more numbers among which the largest value will be selected and returned.\n\n### Return value\n\nThe largest of the given numbers. Returns {{jsxref("NaN")}} if any of the parameters is or is converted into `NaN`. Returns -{{jsxref("Infinity")}} if no parameters are provided.\n\n## Description\n\nBecause `max()` is a static method of `Math`, you always use it as `Math.max()`, rather than as a method of a `Math` object you created (`Math` is not a constructor).\n\n[`Math.max.length`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/length) is 2, which weakly signals that it\'s designed to handle at least two parameters.\n\n## Examples\n\n### Using Math.max()\n\n```js\nMath.max(10, 20); // 20\nMath.max(-10, -20); // -10\nMath.max(-10, 20); // 20\n```\n\n### Getting the maximum element of an array\n\n{{jsxref("Array.prototype.reduce()")}} can be used to find the maximum\nelement in a numeric array, by comparing each value:\n\n```js\nconst arr = [1, 2, 3];\nconst max = arr.reduce((a, b) => Math.max(a, b), -Infinity);\n```\n\nThe following function uses {{jsxref("Function.prototype.apply()")}} to get the maximum of an array. `getMaxOfArray([1, 2, 3])` is equivalent to `Math.max(1, 2, 3)`, but you can use `getMaxOfArray()` on programmatically constructed arrays. This should only be used for arrays with relatively few elements.\n\n```js\nfunction getMaxOfArray(numArray) {\n  return Math.max.apply(null, numArray);\n}\n```\n\nThe [spread syntax](/en-US/docs/Web/JavaScript/Reference/Operators/Spread_syntax) is a shorter way of writing the `apply` solution to get the maximum of an array:\n\n```js\nconst arr = [1, 2, 3];\nconst max = Math.max(...arr);\n```\n\nHowever, both spread (`...`) and `apply` will either fail or return the wrong result if the array has too many elements, because they try to pass the array elements as function parameters. See [Using apply and built-in functions](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/apply#using_apply_and_built-in_functions) for more details. The `reduce` solution does not have this problem.\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Math.min()")}}\n'
        },
        "min": {
            "index.md": '---\ntitle: Math.min()\nslug: Web/JavaScript/Reference/Global_Objects/Math/min\npage-type: javascript-static-method\nbrowser-compat: javascript.builtins.Math.min\n---\n\n{{JSRef}}\n\nThe **`Math.min()`** static method returns the smallest of the numbers given as input parameters, or {{jsxref("Infinity")}} if there are no parameters.\n\n{{EmbedInteractiveExample("pages/js/math-min.html")}}\n\n## Syntax\n\n```js-nolint\nMath.min()\nMath.min(value1)\nMath.min(value1, value2)\nMath.min(value1, value2, /* \u2026, */ valueN)\n```\n\n### Parameters\n\n- `value1`, \u2026, `valueN`\n  - : Zero or more numbers among which the lowest value will be selected and returned.\n\n### Return value\n\nThe smallest of the given numbers. Returns {{jsxref("NaN")}} if any of the parameters is or is converted into `NaN`. Returns {{jsxref("Infinity")}} if no parameters are provided.\n\n## Description\n\nBecause `min()` is a static method of `Math`, you always use it as `Math.min()`, rather than as a method of a `Math` object you created (`Math` is not a constructor).\n\n[`Math.min.length`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/length) is 2, which weakly signals that it\'s designed to handle at least two parameters.\n\n## Examples\n\n### Using Math.min()\n\nThis finds the min of `x` and `y` and assigns it to `z`:\n\n```js\nconst x = 10;\nconst y = -20;\nconst z = Math.min(x, y); // -20\n```\n\n### Clipping a value with Math.min()\n\n`Math.min()` is often used to clip a value so that it is always less than or\nequal to a boundary. For instance, this\n\n```js\nlet x = f(foo);\n\nif (x > boundary) {\n  x = boundary;\n}\n```\n\nmay be written as this\n\n```js\nconst x = Math.min(f(foo), boundary);\n```\n\n{{jsxref("Math.max()")}} can be used in a similar way to clip a value at the other end.\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Math.max()")}}\n'
        },
        "pi": {
            "index.md": '---\ntitle: Math.PI\nslug: Web/JavaScript/Reference/Global_Objects/Math/PI\npage-type: javascript-static-data-property\nbrowser-compat: javascript.builtins.Math.PI\n---\n\n{{JSRef}}\n\nThe **`Math.PI`** static data property represents the ratio of the circumference of a circle to its diameter, approximately 3.14159.\n\n{{EmbedInteractiveExample("pages/js/math-pi.html")}}\n\n## Value\n\n<math display="block"><semantics><mrow><mi>\uD835\uDE7C\uD835\uDE8A\uD835\uDE9D\uD835\uDE91.\uD835\uDE7F\uD835\uDE78</mi><mo>=</mo><mi>\u03C0</mi><mo>\u2248</mo><mn>3.14159</mn></mrow><annotation encoding="TeX">\\mathtt{\\mi{Math.PI}} = \\pi \\approx 3.14159</annotation></semantics></math>\n\n{{js_property_attributes(0, 0, 0)}}\n\n## Description\n\nBecause `PI` is a static property of `Math`, you always use it as `Math.PI`, rather than as a property of a `Math` object you created (`Math` is not a constructor).\n\n## Examples\n\n### Using Math.PI\n\nThe following function uses `Math.PI` to calculate the circumference of a circle with a passed radius.\n\n```js\nfunction calculateCircumference(radius) {\n  return Math.PI * (radius + radius);\n}\n\ncalculateCircumference(1); // 6.283185307179586\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Math")}}\n'
        },
        "pow": {
            "index.md": '---\ntitle: Math.pow()\nslug: Web/JavaScript/Reference/Global_Objects/Math/pow\npage-type: javascript-static-method\nbrowser-compat: javascript.builtins.Math.pow\n---\n\n{{JSRef}}\n\nThe **`Math.pow()`** static method returns the value of a base raised to a power. That is\n\n<math display="block"><semantics><mrow><mrow><mo lspace="0em" rspace="0.16666666666666666em">\uD835\uDE7C\uD835\uDE8A\uD835\uDE9D\uD835\uDE91.\uD835\uDE99\uD835\uDE98\uD835\uDEA0</mo><mo stretchy="false">(</mo><mi>\uD835\uDEA1</mi><mo>,</mo><mi>\uD835\uDEA2</mi><mo stretchy="false">)</mo></mrow><mo>=</mo><msup><mi>x</mi><mi>y</mi></msup></mrow><annotation encoding="TeX">\\mathtt{\\operatorname{Math.pow}(x, y)} = x^y</annotation></semantics></math>\n\n{{EmbedInteractiveExample("pages/js/math-pow.html")}}\n\n## Syntax\n\n```js-nolint\nMath.pow(base, exponent)\n```\n\n### Parameters\n\n- `base`\n  - : The base number.\n- `exponent`\n  - : The exponent number.\n\n### Return value\n\nA number representing `base` taken to the power of `exponent`. Returns {{jsxref("NaN")}} in one of the following cases:\n\n- `exponent` is `NaN`.\n- `base` is `NaN` and `exponent` is not `0`.\n- `base` is \xb11 and `exponent` is \xb1`Infinity`.\n- `base < 0` and `exponent` is not an integer.\n\n## Description\n\n`Math.pow()` is equivalent to the [`**`](/en-US/docs/Web/JavaScript/Reference/Operators/Exponentiation) operator, except `Math.pow()` only accepts numbers.\n\n`Math.pow(NaN, 0)` (and the equivalent `NaN ** 0`) is the only case where {{jsxref("NaN")}} doesn\'t propagate through mathematical operations \u2014 it returns `1` despite the operand being `NaN`. In addition, the behavior where `base` is 1 and `exponent` is non-finite (\xb1Infinity or `NaN`) is different from IEEE 754, which specifies that the result should be 1, whereas JavaScript returns `NaN` to preserve backward compatibility with its original behavior.\n\nBecause `pow()` is a static method of `Math`, use it as `Math.pow()`, rather than as a method of a `Math` object you created (`Math` is not a constructor).\n\n## Examples\n\n### Using Math.pow()\n\n```js\n// Simple cases\nMath.pow(7, 2); // 49\nMath.pow(7, 3); // 343\nMath.pow(2, 10); // 1024\n\n// Fractional exponents\nMath.pow(4, 0.5); // 2 (square root of 4)\nMath.pow(8, 1 / 3); // 2 (cube root of 8)\nMath.pow(2, 0.5); // 1.4142135623730951 (square root of 2)\nMath.pow(2, 1 / 3); // 1.2599210498948732 (cube root of 2)\n\n// Signed exponents\nMath.pow(7, -2); // 0.02040816326530612 (1/49)\nMath.pow(8, -1 / 3); // 0.5\n\n// Signed bases\nMath.pow(-7, 2); // 49 (squares are positive)\nMath.pow(-7, 3); // -343 (cubes can be negative)\nMath.pow(-7, 0.5); // NaN (negative numbers don\'t have a real square root)\n// Due to "even" and "odd" roots laying close to each other,\n// and limits in the floating number precision,\n// negative bases with fractional exponents always return NaN,\n// even when the mathematical result is real\nMath.pow(-7, 1 / 3); // NaN\n\n// Zero and infinity\nMath.pow(0, 0); // 1 (anything ** \xb10 is 1)\nMath.pow(Infinity, 0.1); // Infinity (positive exponent)\nMath.pow(Infinity, -1); // 0 (negative exponent)\nMath.pow(-Infinity, 1); // -Infinity (positive odd integer exponent)\nMath.pow(-Infinity, 1.5); // Infinity (positive exponent)\nMath.pow(-Infinity, -1); // -0 (negative odd integer exponent)\nMath.pow(-Infinity, -1.5); // 0 (negative exponent)\nMath.pow(0, 1); // 0 (positive exponent)\nMath.pow(0, -1); // Infinity (negative exponent)\nMath.pow(-0, 1); // -0 (positive odd integer exponent)\nMath.pow(-0, 1.5); // 0 (positive exponent)\nMath.pow(-0, -1); // -Infinity (negative odd integer exponent)\nMath.pow(-0, -1.5); // Infinity (negative exponent)\nMath.pow(0.9, Infinity); // 0\nMath.pow(1, Infinity); // NaN\nMath.pow(1.1, Infinity); // Infinity\nMath.pow(0.9, -Infinity); // Infinity\nMath.pow(1, -Infinity); // NaN\nMath.pow(1.1, -Infinity); // 0\n\n// NaN: only Math.pow(NaN, 0) does not result in NaN\nMath.pow(NaN, 0); // 1\nMath.pow(NaN, 1); // NaN\nMath.pow(1, NaN); // NaN\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Math.cbrt()")}}\n- {{jsxref("Math.exp()")}}\n- {{jsxref("Math.log()")}}\n- {{jsxref("Math.sqrt()")}}\n- [Exponentiation (`**`)](/en-US/docs/Web/JavaScript/Reference/Operators/Exponentiation)\n'
        },
        "random": {
            "index.md": '---\ntitle: Math.random()\nslug: Web/JavaScript/Reference/Global_Objects/Math/random\npage-type: javascript-static-method\nbrowser-compat: javascript.builtins.Math.random\n---\n\n{{JSRef}}\n\nThe **`Math.random()`** static method returns a floating-point, pseudo-random number that\'s greater than or equal to 0 and less than 1, with approximately uniform distribution over that range \u2014 which you can then scale to your desired range. The implementation selects the initial seed to the random number generation algorithm; it cannot be chosen or reset by the user.\n\n> **Note:** `Math.random()` _does not_ provide cryptographically secure random numbers. Do not use them for anything related to security. Use the Web Crypto API instead, and more precisely the {{domxref("Crypto/getRandomValues", "window.crypto.getRandomValues()")}} method.\n\n{{EmbedInteractiveExample("pages/js/math-random.html")}}\n\n## Syntax\n\n```js-nolint\nMath.random()\n```\n\n### Parameters\n\nNone.\n\n### Return value\n\nA floating-point, pseudo-random number between 0 (inclusive) and 1 (exclusive).\n\n## Examples\n\nNote that as numbers in JavaScript are IEEE 754 floating point numbers with round-to-nearest-even behavior, the ranges claimed for the functions below (excluding the one for `Math.random()` itself) aren\'t exact. If extremely large bounds are chosen (2<sup>53</sup> or higher), it\'s possible in _extremely_ rare cases to reach the usually-excluded upper bound.\n\n### Getting a random number between 0 (inclusive) and 1 (exclusive)\n\n```js\nfunction getRandom() {\n  return Math.random();\n}\n```\n\n### Getting a random number between two values\n\nThis example returns a random number between the specified values. The returned value is no lower than (and may possibly equal) `min`, and is less than (and not equal) `max`.\n\n```js\nfunction getRandomArbitrary(min, max) {\n  return Math.random() * (max - min) + min;\n}\n```\n\n### Getting a random integer between two values\n\nThis example returns a random _integer_ between the specified values. The value is no lower than `min` (or the next integer greater than `min` if `min` isn\'t an integer), and is less than (but not equal to) `max`.\n\n```js\nfunction getRandomInt(min, max) {\n  const minCeiled = Math.ceil(min);\n  const maxFloored = Math.floor(max);\n  return Math.floor(Math.random() * (maxFloored - minCeiled) + minCeiled); // The maximum is exclusive and the minimum is inclusive\n}\n```\n\n> **Note:** It might be tempting to use [`Math.round()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/round) to accomplish that, but doing so would cause your random numbers to follow a non-uniform distribution, which may not be acceptable for your needs.\n\n### Getting a random integer between two values, inclusive\n\nWhile the `getRandomInt()` function above is inclusive at the minimum, it\'s exclusive at the maximum. What if you need the results to be inclusive at both the minimum and the maximum? The `getRandomIntInclusive()` function below accomplishes that.\n\n```js\nfunction getRandomIntInclusive(min, max) {\n  const minCeiled = Math.ceil(min);\n  const maxFloored = Math.floor(max);\n  return Math.floor(Math.random() * (maxFloored - minCeiled + 1) + minCeiled); // The maximum is inclusive and the minimum is inclusive\n}\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{domxref("Crypto/getRandomValues", "window.crypto.getRandomValues()")}}\n'
        },
        "round": {
            "index.md": '---\ntitle: Math.round()\nslug: Web/JavaScript/Reference/Global_Objects/Math/round\npage-type: javascript-static-method\nbrowser-compat: javascript.builtins.Math.round\n---\n\n{{JSRef}}\n\nThe **`Math.round()`** static method returns the value of a number rounded to the nearest integer.\n\n{{EmbedInteractiveExample("pages/js/math-round.html")}}\n\n## Syntax\n\n```js-nolint\nMath.round(x)\n```\n\n### Parameters\n\n- `x`\n  - : A number.\n\n### Return value\n\nThe value of `x` rounded to the nearest integer.\n\n## Description\n\nIf the fractional portion of the argument is greater than 0.5, the argument is rounded to the integer with the next higher absolute value. If it is less than 0.5, the argument is rounded to the integer with the lower absolute value. If the fractional portion is exactly 0.5, the argument is rounded to the next integer in the direction of +\u221E.\n\n> **Note:** This differs from many languages\' `round()` functions, which often round half-increments _away from zero_, giving a different result in the case of negative numbers with a fractional part of exactly 0.5.\n\n`Math.round(x)` is not exactly the same as [`Math.floor(x + 0.5)`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/floor). When `x` is -0, or -0.5 \u2264 x < 0, `Math.round(x)` returns -0, while `Math.floor(x + 0.5)` returns 0. However, neglecting that difference and potential precision errors, `Math.round(x)` and `Math.floor(x + 0.5)` are generally equivalent.\n\nBecause `round()` is a static method of `Math`, you always use it as `Math.round()`, rather than as a method of a `Math` object you created (`Math` has no constructor).\n\n## Examples\n\n### Using round\n\n```js\nMath.round(-Infinity); // -Infinity\nMath.round(-20.51); // -21\nMath.round(-20.5); // -20\nMath.round(-0.1); // -0\nMath.round(0); // 0\nMath.round(20.49); // 20\nMath.round(20.5); // 21\nMath.round(42); // 42\nMath.round(Infinity); // Infinity\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Number.prototype.toPrecision()")}}\n- {{jsxref("Number.prototype.toFixed()")}}\n- {{jsxref("Math.abs()")}}\n- {{jsxref("Math.ceil()")}}\n- {{jsxref("Math.floor()")}}\n- {{jsxref("Math.sign()")}}\n- {{jsxref("Math.trunc()")}}\n'
        },
        "sign": {
            "index.md": '---\ntitle: Math.sign()\nslug: Web/JavaScript/Reference/Global_Objects/Math/sign\npage-type: javascript-static-method\nbrowser-compat: javascript.builtins.Math.sign\n---\n\n{{JSRef}}\n\nThe **`Math.sign()`** static method returns 1 or -1, indicating the sign of the number passed as argument. If the input is 0 or -0, it will be returned as-is.\n\n{{EmbedInteractiveExample("pages/js/math-sign.html")}}\n\n## Syntax\n\n```js-nolint\nMath.sign(x)\n```\n\n### Parameters\n\n- `x`\n  - : A number.\n\n### Return value\n\nA number representing the sign of `x`:\n\n- If `x` is positive, returns `1`.\n- If `x` is negative, returns `-1`.\n- If `x` is positive zero, returns `0`.\n- If `x` is negative zero, returns `-0`.\n- Otherwise, returns {{jsxref("NaN")}}.\n\n## Description\n\nBecause `sign()` is a static method of `Math`, you always use it as `Math.sign()`, rather than as a method of a `Math` object you created (`Math` is not a constructor).\n\n## Examples\n\n### Using Math.sign()\n\n```js\nMath.sign(3); // 1\nMath.sign(-3); // -1\nMath.sign("-3"); // -1\nMath.sign(0); // 0\nMath.sign(-0); // -0\nMath.sign(NaN); // NaN\nMath.sign("foo"); // NaN\nMath.sign(); // NaN\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Math.sign` in `core-js`](https://github.com/zloirock/core-js#ecmascript-math)\n- {{jsxref("Math.abs()")}}\n- {{jsxref("Math.ceil()")}}\n- {{jsxref("Math.floor()")}}\n- {{jsxref("Math.round()")}}\n- {{jsxref("Math.trunc()")}}\n'
        },
        "sin": {
            "index.md": '---\ntitle: Math.sin()\nslug: Web/JavaScript/Reference/Global_Objects/Math/sin\npage-type: javascript-static-method\nbrowser-compat: javascript.builtins.Math.sin\n---\n\n{{JSRef}}\n\nThe **`Math.sin()`** static method returns the sine of a number in radians.\n\n{{EmbedInteractiveExample("pages/js/math-sin.html")}}\n\n## Syntax\n\n```js-nolint\nMath.sin(x)\n```\n\n### Parameters\n\n- `x`\n  - : A number representing an angle in radians.\n\n### Return value\n\nThe sine of `x`, between -1 and 1, inclusive. If `x` is {{jsxref("Infinity")}}, `-Infinity`, or {{jsxref("NaN")}}, returns {{jsxref("NaN")}}.\n\n## Description\n\nBecause `sin()` is a static method of `Math`, you always use it as `Math.sin()`, rather than as a method of a `Math` object you created (`Math` is not a constructor).\n\n## Examples\n\n### Using Math.sin()\n\n```js\nMath.sin(-Infinity); // NaN\nMath.sin(-0); // -0\nMath.sin(0); // 0\nMath.sin(1); // 0.8414709848078965\nMath.sin(Math.PI / 2); // 1\nMath.sin(Infinity); // NaN\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Math.acos()")}}\n- {{jsxref("Math.asin()")}}\n- {{jsxref("Math.atan()")}}\n- {{jsxref("Math.atan2()")}}\n- {{jsxref("Math.cos()")}}\n- {{jsxref("Math.tan()")}}\n'
        },
        "sinh": {
            "index.md": '---\ntitle: Math.sinh()\nslug: Web/JavaScript/Reference/Global_Objects/Math/sinh\npage-type: javascript-static-method\nbrowser-compat: javascript.builtins.Math.sinh\n---\n\n{{JSRef}}\n\nThe **`Math.sinh()`** static method returns the hyperbolic sine of a number. That is,\n\n<math display="block"><semantics><mrow><mrow><mo lspace="0em" rspace="0.16666666666666666em">\uD835\uDE7C\uD835\uDE8A\uD835\uDE9D\uD835\uDE91.\uD835\uDE9C\uD835\uDE92\uD835\uDE97\uD835\uDE91</mo><mo stretchy="false">(</mo><mi>\uD835\uDEA1</mi><mo stretchy="false">)</mo></mrow><mo>=</mo><mo lspace="0em" rspace="0em">sinh</mo><mo stretchy="false">(</mo><mi>x</mi><mo stretchy="false">)</mo><mo>=</mo><mfrac><mrow><msup><mi mathvariant="normal">e</mi><mi>x</mi></msup><mo>\u2212</mo><msup><mi mathvariant="normal">e</mi><mrow><mo>\u2212</mo><mi>x</mi></mrow></msup></mrow><mn>2</mn></mfrac></mrow><annotation encoding="TeX">\\mathtt{\\operatorname{Math.sinh}(x)} = \\sinh(x) = \\frac{\\mathrm{e}^x - \\mathrm{e}^{-x}}{2}</annotation></semantics></math>\n\n{{EmbedInteractiveExample("pages/js/math-sinh.html")}}\n\n## Syntax\n\n```js-nolint\nMath.sinh(x)\n```\n\n### Parameters\n\n- `x`\n  - : A number.\n\n### Return value\n\nThe hyperbolic sine of `x`.\n\n## Description\n\nBecause `sinh()` is a static method of `Math`, you always use it as `Math.sinh()`, rather than as a method of a `Math` object you created (`Math` is not a constructor).\n\n## Examples\n\n### Using Math.sinh()\n\n```js\nMath.sinh(-Infinity); // -Infinity\nMath.sinh(-0); // -0\nMath.sinh(0); // 0\nMath.sinh(1); // 1.1752011936438014\nMath.sinh(Infinity); // Infinity\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Math.sinh` in `core-js`](https://github.com/zloirock/core-js#ecmascript-math)\n- {{jsxref("Math.acosh()")}}\n- {{jsxref("Math.asinh()")}}\n- {{jsxref("Math.atanh()")}}\n- {{jsxref("Math.cosh()")}}\n- {{jsxref("Math.tanh()")}}\n'
        },
        "sqrt": {
            "index.md": '---\ntitle: Math.sqrt()\nslug: Web/JavaScript/Reference/Global_Objects/Math/sqrt\npage-type: javascript-static-method\nbrowser-compat: javascript.builtins.Math.sqrt\n---\n\n{{JSRef}}\n\nThe **`Math.sqrt()`** static method returns the square root of a number. That is\n\n<math display="block"><semantics><mrow><mo>\u2200</mo><mi>x</mi><mo>\u2265</mo><mn>0</mn><mo>,</mo><mspace width="0.2777777777777778em"></mspace><mrow><mo lspace="0em" rspace="0.16666666666666666em">\uD835\uDE7C\uD835\uDE8A\uD835\uDE9D\uD835\uDE91.\uD835\uDE9C\uD835\uDE9A\uD835\uDE9B\uD835\uDE9D</mo><mo stretchy="false">(</mo><mi>\uD835\uDEA1</mi><mo stretchy="false">)</mo></mrow><mo>=</mo><msqrt><mi>x</mi></msqrt><mo>=</mo><mtext>the unique&nbsp;</mtext><mi>y</mi><mo>\u2265</mo><mn>0</mn><mtext>&nbsp;such that&nbsp;</mtext><msup><mi>y</mi><mn>2</mn></msup><mo>=</mo><mi>x</mi></mrow><annotation encoding="TeX">\\forall x \\geq 0,\\;\\mathtt{\\operatorname{Math.sqrt}(x)} = \\sqrt{x} = \\text{the unique } y \\geq 0 \\text{ such that } y^2 = x</annotation></semantics></math>\n\n{{EmbedInteractiveExample("pages/js/math-sqrt.html")}}\n\n## Syntax\n\n```js-nolint\nMath.sqrt(x)\n```\n\n### Parameters\n\n- `x`\n  - : A number greater than or equal to 0.\n\n### Return value\n\nThe square root of `x`, a nonnegative number. If `x < 0`, returns {{jsxref("NaN")}}.\n\n## Description\n\nBecause `sqrt()` is a static method of `Math`, you always use it as `Math.sqrt()`, rather than as a method of a `Math` object you created (`Math` is not a constructor).\n\n## Examples\n\n### Using Math.sqrt()\n\n```js\nMath.sqrt(-1); // NaN\nMath.sqrt(-0); // -0\nMath.sqrt(0); // 0\nMath.sqrt(1); // 1\nMath.sqrt(2); // 1.414213562373095\nMath.sqrt(9); // 3\nMath.sqrt(Infinity); // Infinity\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Math.cbrt()")}}\n- {{jsxref("Math.exp()")}}\n- {{jsxref("Math.log()")}}\n- {{jsxref("Math.pow()")}}\n'
        },
        "sqrt1_2": {
            "index.md": '---\ntitle: Math.SQRT1_2\nslug: Web/JavaScript/Reference/Global_Objects/Math/SQRT1_2\npage-type: javascript-static-data-property\nbrowser-compat: javascript.builtins.Math.SQRT1_2\n---\n\n{{JSRef}}\n\nThe **`Math.SQRT1_2`** static data property represents the square root of 1/2, which is approximately 0.707.\n\n{{EmbedInteractiveExample("pages/js/math-sqrt1_2.html", "shorter")}}\n\n## Value\n\n<math display="block"><semantics><mrow><mi>\uD835\uDE7C\uD835\uDE8A\uD835\uDE9D\uD835\uDE91.\uD835\uDE82\uD835\uDE80\uD835\uDE81\uD835\uDE83\uD835\uDFF7_\uD835\uDFF8</mi><mo>=</mo><msqrt><mfrac><mn>1</mn><mn>2</mn></mfrac></msqrt><mo>\u2248</mo><mn>0.707</mn></mrow><annotation encoding="TeX">\\mathtt{\\mi{Math.SQRT1_2}} = \\sqrt{\\frac{1}{2}} \\approx 0.707</annotation></semantics></math>\n\n{{js_property_attributes(0, 0, 0)}}\n\n## Description\n\n`Math.SQRT1_2` is a constant and a more performant equivalent to [`Math.sqrt(0.5)`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/sqrt).\n\nBecause `SQRT1_2` is a static property of `Math`, you always use it as `Math.SQRT1_2`, rather than as a property of a `Math` object you created (`Math` is not a constructor).\n\n## Examples\n\n### Using Math.SQRT1_2\n\nThe following function returns 1 over the square root of 2:\n\n```js\nfunction getRoot1_2() {\n  return Math.SQRT1_2;\n}\n\ngetRoot1_2(); // 0.7071067811865476\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Math.pow()")}}\n- {{jsxref("Math.sqrt()")}}\n'
        },
        "sqrt2": {
            "index.md": '---\ntitle: Math.SQRT2\nslug: Web/JavaScript/Reference/Global_Objects/Math/SQRT2\npage-type: javascript-static-data-property\nbrowser-compat: javascript.builtins.Math.SQRT2\n---\n\n{{JSRef}}\n\nThe **`Math.SQRT2`** static data property represents the square root of 2, approximately 1.414.\n\n{{EmbedInteractiveExample("pages/js/math-sqrt2.html", "shorter")}}\n\n## Value\n\n<math display="block"><semantics><mrow><mi>\uD835\uDE7C\uD835\uDE8A\uD835\uDE9D\uD835\uDE91.\uD835\uDE82\uD835\uDE80\uD835\uDE81\uD835\uDE83\uD835\uDFF8</mi><mo>=</mo><msqrt><mn>2</mn></msqrt><mo>\u2248</mo><mn>1.414</mn></mrow><annotation encoding="TeX">\\mathtt{\\mi{Math.SQRT2}} = \\sqrt{2} \\approx 1.414</annotation></semantics></math>\n\n{{js_property_attributes(0, 0, 0)}}\n\n## Description\n\n`Math.SQRT2` is a constant and a more performant equivalent to [`Math.sqrt(2)`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/sqrt).\n\nBecause `SQRT2` is a static property of `Math`, you always use it as `Math.SQRT2`, rather than as a property of a `Math` object you created (`Math` is not a constructor).\n\n## Examples\n\n### Using Math.SQRT2\n\nThe following function returns the square root of 2:\n\n```js\nfunction getRoot2() {\n  return Math.SQRT2;\n}\n\ngetRoot2(); // 1.4142135623730951\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Math.pow()")}}\n- {{jsxref("Math.sqrt()")}}\n'
        },
        "tan": {
            "index.md": '---\ntitle: Math.tan()\nslug: Web/JavaScript/Reference/Global_Objects/Math/tan\npage-type: javascript-static-method\nbrowser-compat: javascript.builtins.Math.tan\n---\n\n{{JSRef}}\n\nThe **`Math.tan()`** static method returns the tangent of a number in radians.\n\n{{EmbedInteractiveExample("pages/js/math-tan.html")}}\n\n## Syntax\n\n```js-nolint\nMath.tan(x)\n```\n\n### Parameters\n\n- `x`\n  - : A number representing an angle in radians.\n\n### Return value\n\nThe tangent of `x`. If `x` is {{jsxref("Infinity")}}, `-Infinity`, or {{jsxref("NaN")}}, returns {{jsxref("NaN")}}.\n\n> **Note:** Due to floating point precision, it\'s not possible to obtain the exact value \u03C0/2, so the result is always finite if not `NaN`.\n\n## Description\n\nBecause `tan()` is a static method of `Math`, you always use it as `Math.tan()`, rather than as a method of a `Math` object you created (`Math` is not a constructor).\n\n## Examples\n\n### Using Math.tan()\n\n```js\nMath.tan(-Infinity); // NaN\nMath.tan(-0); // -0\nMath.tan(0); // 0\nMath.tan(1); // 1.5574077246549023\nMath.tan(Math.PI / 4); // 0.9999999999999999 (Floating point error)\nMath.tan(Infinity); // NaN\n```\n\n### Math.tan() and \u03C0/2\n\nIt\'s not possible to calculate `tan(\u03C0/2)` exactly.\n\n```js\nMath.tan(Math.PI / 2); // 16331239353195370\nMath.tan(Math.PI / 2 + Number.EPSILON); // -6218431163823738\n```\n\n### Using Math.tan() with a degree value\n\nBecause the `Math.tan()` function accepts radians, but it is often easier to work with degrees, the following function accepts a value in degrees, converts it to radians and returns the tangent.\n\n```js\nfunction getTanDeg(deg) {\n  const rad = (deg * Math.PI) / 180;\n  return Math.tan(rad);\n}\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Math.acos()")}}\n- {{jsxref("Math.asin()")}}\n- {{jsxref("Math.atan()")}}\n- {{jsxref("Math.atan2()")}}\n- {{jsxref("Math.cos()")}}\n- {{jsxref("Math.sin()")}}\n'
        },
        "tanh": {
            "index.md": '---\ntitle: Math.tanh()\nslug: Web/JavaScript/Reference/Global_Objects/Math/tanh\npage-type: javascript-static-method\nbrowser-compat: javascript.builtins.Math.tanh\n---\n\n{{JSRef}}\n\nThe **`Math.tanh()`** static method returns the hyperbolic tangent of a number. That is,\n\n<math display="block"><semantics><mrow><mrow><mo lspace="0em" rspace="0.16666666666666666em">\uD835\uDE7C\uD835\uDE8A\uD835\uDE9D\uD835\uDE91.\uD835\uDE9D\uD835\uDE8A\uD835\uDE97\uD835\uDE91</mo><mo stretchy="false">(</mo><mi>\uD835\uDEA1</mi><mo stretchy="false">)</mo></mrow><mo>=</mo><mo lspace="0em" rspace="0em">tanh</mo><mo stretchy="false">(</mo><mi>x</mi><mo stretchy="false">)</mo><mo>=</mo><mfrac><mrow><mo lspace="0em" rspace="0em">sinh</mo><mo stretchy="false">(</mo><mi>x</mi><mo stretchy="false">)</mo></mrow><mrow><mo lspace="0em" rspace="0em">cosh</mo><mo stretchy="false">(</mo><mi>x</mi><mo stretchy="false">)</mo></mrow></mfrac><mo>=</mo><mfrac><mrow><msup><mi mathvariant="normal">e</mi><mi>x</mi></msup><mo>\u2212</mo><msup><mi mathvariant="normal">e</mi><mrow><mo>\u2212</mo><mi>x</mi></mrow></msup></mrow><mrow><msup><mi mathvariant="normal">e</mi><mi>x</mi></msup><mo>+</mo><msup><mi mathvariant="normal">e</mi><mrow><mo>\u2212</mo><mi>x</mi></mrow></msup></mrow></mfrac><mo>=</mo><mfrac><mrow><msup><mi mathvariant="normal">e</mi><mrow><mn>2</mn><mi>x</mi></mrow></msup><mo>\u2212</mo><mn>1</mn></mrow><mrow><msup><mi mathvariant="normal">e</mi><mrow><mn>2</mn><mi>x</mi></mrow></msup><mo>+</mo><mn>1</mn></mrow></mfrac></mrow><annotation encoding="TeX">\\mathtt{\\operatorname{Math.tanh}(x)} = \\tanh(x) = \\frac{\\sinh(x)}{\\cosh(x)} = \\frac{\\mathrm{e}^x - \\mathrm{e}^{-x}}{\\mathrm{e}^x + \\mathrm{e}^{-x}} = \\frac{\\mathrm{e}^{2x} - 1}{\\mathrm{e}^{2x}+1}</annotation></semantics></math>\n\n{{EmbedInteractiveExample("pages/js/math-tanh.html")}}\n\n## Syntax\n\n```js-nolint\nMath.tanh(x)\n```\n\n### Parameters\n\n- `x`\n  - : A number.\n\n### Return value\n\nThe hyperbolic tangent of `x`.\n\n## Description\n\nBecause `tanh()` is a static method of `Math`, you always use it as `Math.tanh()`, rather than as a method of a `Math` object you created (`Math` is not a constructor).\n\n## Examples\n\n### Using Math.tanh()\n\n```js\nMath.tanh(-Infinity); // -1\nMath.tanh(-0); // -0\nMath.tanh(0); // 0\nMath.tanh(1); // 0.7615941559557649\nMath.tanh(Infinity); // 1\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Math.tanh` in `core-js`](https://github.com/zloirock/core-js#ecmascript-math)\n- {{jsxref("Math.acosh()")}}\n- {{jsxref("Math.asinh()")}}\n- {{jsxref("Math.atanh()")}}\n- {{jsxref("Math.cosh()")}}\n- {{jsxref("Math.sinh()")}}\n'
        },
        "trigonometry.png": '\uFFFDPNG\r\n\x1a\n\0\0\0\rIHDR\0\0\0\uFFFD\0\0\0\uFFFD\b\x03\0\0\0\uFFFDx0\uFFFD\0\0\0\x04gAMA\0\0\uFFFD\uFFFD\v\uFFFDa\x05\0\0\0\x01sRGB\0\uFFFD\uFFFD\x1c\uFFFD\0\0\x03\0PLTE\uFFFD\uFFFD\uFFFD___\x0f\x0f\x0f\x10\x10\x10\uFFFD\uFFFD\uFFFF\uFFFD\uFFFD\uFFFD\uFFFD\0\0\0\uFFFD\uFFFD\uFFFD\x7f\x7f\x7f\uFFFD\uFFFD\uFFFD\x1f\x1f\x1f???\uFFFD\uFFFD\uFFFD@@@   \uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFDOOO\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFDoooG\0\0O\0\0\uFFFD\uFFFD\uFFFD///000\uFFFD\uFFFD\uFFFDG\0G\0G\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\0\0G\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\0\0O\uFFFDG\0_\0\0\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u05E7G\0\0/\uFFFD/\0\0/\uFFFD\uFFFD/\0\uFFFDO\0\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u061EH\uFFFD\uFFFD\uFFFD\uFFFD\u0151\uFFFD\uFFFD\uFFFDM\uFFFD\u05E7\uFFFD\uFFFDo\0\0\uFFFD\uFFFD\uFFFD/\uFFFD\uFFFD\u073F\uFFFD\0\0\uFFFD\u05E7O\uFFFD\uFFFD\uFFFD\uFFFD\uAF53\0\0\0\0o\uFFFD\uFFFD\uFFFD\x17\x17\x17\0\0w\uFFFDJ\0\uFFFD\u07E7\uFFFD\u03D7\u038F/\u07E7M\uFFFD\uFFFD\uFFFD\uFFFDu\u04E6t\uFFFD\uFFFD\uF377\uFFFDG\uFFFD\uFFFD/\0/\0O\uFFFD\0/\uFFFDo\uFFFD\uFFFD/\0\0\uFFFD\uFFFD\uFFFD\u0559/\uFFFD\u07F9\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFDw\0\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFDK\0\uFFFDo\0\0/w\uFFFD\u04F9\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFDccc\uFFFD\0\0\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFDw\0\0\0s\uFFFD/\uFFFD\u03FA\uFFFD\uFFFD\uFFFD\u7B47/\0\uFFFD\u03F3\0_\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u05EF\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\0\0\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD/\uFFFD\uFFFD_\uFFFD\uFFFD\0\uFFFD\u01F2\uFFFD\uFFFD\0\0_\0\uFFFD\u0464\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u0371\uFFFD\u06A7_\uFFFD\uFFFDO_\uFFFD\uFFFDG\0/\u01E7w\uFFFD\uFFFD\uFFFDo\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u03D2\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD/Ol\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u05E4O\uFFFD\uFFFD\u0354G\uFFFD\uFFFD\u07CC|\uFFFD)))\x06\x06\x06\uFFFD\uFFFD\uFFFD\uFFFDO\0\0L\uFFFD\uFFFD\uFFFD|\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u017F\u03CC\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD/KO_/\0\uFFFDl?\u03DF_OG/\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFDO\uFFFD\uFFFD\u04FB\uFFFDw\x7fs\uFFFD\uFFFDg/\uFFFD\uFFFD\uFFFD\uFFFD\u32EB\u02C7kO\uFFFD\uFFFDGw/\0g\uFFFD\uFFFDwOw\uFFFD\uFFFD\uFFFDW\uFFFD\uFFFD\uFFFDOs\0//\0_\uFFFD\uFFFD\uFFFD\uFFFD\0/\uFFFDw\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u05E7GOW\0G\uFFFDWO_\u04F7\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\0o\uFFFD\0\0\uFFFD\uFFFD\xe7s\uFFFD\u7CE7\x7fO\uFFFD\uFFFDKK\0/\uFFFD\uFFFDw\uFFFD\uFFFDG/\0o\0_G\0oGOw\0\uFFFD\uFFFD/w\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFDo\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD/G/\uFFFD\uFFFD\uFFFD\0O\uFFFD\0Go\uFFFD\uFFFD\uFFFD_\0/\uFFFD\uFFFD\uFFFD_w\u01C7\0\uFFFD\uFFFD\uFFFDOGw\uFFFD\uFFFD\uFFFD\u01F7\uFFFD\uFFFD\uFFFDO\uFFFD\uFFFD\uFFFD__w\uFFFD\uFFFDwwGO\uFFFD\uFFFD\u07DF\uFFFDO\u01E7_/O\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD/\uFFFD\u03DF_\0oOG\u05D7\0\uFFFD\uFFFD_w\uFFFD\u03E7\uFFFD\uFFFDO_/\0/OO\uFFFD\uFFFDwO/o/\0\uFFFD\uFFFD\x1c\uFFFD\0\0\n\uFFFDIDATx\uFFFD\uFFFD\\\x07t\x13W\x16\uFFFDB#=\u0276d\uFFFD\x19\u0276lY\uFFFD-w\x1bc\uFFFDp\uFFFD\uFFFD@BM\uFFFDm\uFFFD\uFFFD\uFFFD\x02\uFFFD@BB\uFFFD5\x10\b\uFFFD\uFFFDIXJ\u0206$\uFFFD\u07B3{\u04B3\uFFFD}{\uFFFD\uFFFD\uFFFD\uFFFDG3\uFFFDdyF\u04FE\uFFFD?\uFFFD\uFFFD9V\x1b4\uFFFD\uFFFD\uFFFDw\uFFFD\uFFFDo\uFFFD|\uFFFD\uFFFDb(\uFFFDb(\uFFFD">\uFFFD\uFFFD\uFFFD\uFFFD_M(\uFFFDl\uFFFDK\uFFFD\x1fz\uFFFD;\uFFFD\x06r9\x04\uFFFD_?\uFFFDf\u065D!\uFFFD\x7fh\uFFFDb\uFFFDqxj7\uFFFD\u070C\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\x15\uFFFD\uFFFD\uFFFD\x18\uFFFD\uFFFD\uFFFD\x1fv \uFFFD>\uFFFDo:\uFFFD7W:*\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\x05\uFFFDr\uFFFD\uFFFDt\uFFFD\uFFFD\uFFFDk\x1c\uFFFD\x01\uFFFD\uFFFDi\uFFFDZ\uFFFD\uFFFD\x1f\uFFFD\uFFFD\uFFFD4\uFFFD\x1b\x0e\uFFFD\uFFFD[\x1aa\uFFFD\uFFFD\uFFFDO\uFFFD|\uFFFD\x03{\uFFFDo\uFFFD\uFFFDz+\uFFFD\u071AY\uFFFDx\x05\uFFFDx\uFFFD\uFFFDG\uFFFD\uFFFD\uFFFD\n]\uFFFD\uFFFDtxN\uFFFD,\uFFFDmBh\uFFFDo\uFFFDn\uFFFD\u053B\uFFFDM\uFFFDHd\uFFFD6\uFFFD\ni\uFFFD\uFFFD\x7f9\uFFFDh\uFFFD\uFFFD\uFFFD\x11\uFFFDd\uFFFD\uFFFD/\uFFFD\uFFFDE\x01o3K\uFFFD:vc\uFFFD\n]\x18H\uFFFD\uFFFD\uFFFDE1\uFFFDqU\uFFFD\x17/~\uFFFD\uFFFD\\\uFFFD\x16\uFFFD\uFFFD,\uFFFD\uFFFD\uFFFD\r\uFFFDL\u0379\uFFFDI\b\uFFFD>\uFFFD\uFFFD\x06\uFFFD\u64F6> 4\uFFFD\uFFFD\uFFFD\uFFFD\uFFFDU\u043C\uFFFD\uFFFD\uFFFD5\\\uFFFD\uFFFD4\uFFFDw\uFFFD\uFFFD\uFFFD\x0e\uFFFDm?4\v&\uFFFD\uFFFD\uFFFDz\uFFFD\uFFFDE<\uFFFD\uFFFDw\x13\uFFFD8l>|&PI\uFFFD\uFFFD\0\uFFFD\u063F\uFFFDa ]^\uFFFDG\uFFFD-\uFFFD\x1a\uFFFDk!\uFFFD\uFFFD\0KU\x04\uFFFD\uFFFD\u067F\uFFFD\uFFFDfn\uFFFD\x073\x03\uFFFD\uFFFD?\uFFFD\uFFFD8\uFFFD\x03\uFFFD\uFFFD\uFFFD\x19\uFFFD#F\uFFFDq\uFFFD\uFFFDX\x10,G\x17C\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFDb{\u7BDF_\uFFFDP\uFFFD\uFFFD\'\uFFFD\uFFFD?\uFFFD\uFFFD9z\uFFFD\uFFFD\b\uFFFDw\uFFFD\uFFFD\x15-k\uFFFD\uFFFD}\f5<4\uFFFD\u02DD:\uFFFDd7.\uFFFD\uFFFD\uFFFDg\uFFFD\uFFFD!4.X|rR\u0157\x04\uFFFD\x1c\uFFFD\uFFFD\uFFFD0\uFFFD\uFFFD\x18\uFFFD\uFFFD\uFFFD\uFFFD^\uFFFD:\uFFFD\x1ch\uFFFD\uFFFD\uFFFD\uFFFDa\uFFFD,\uFFFD\uFFFD\nt\uFFFD52\x1c\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD)\uFFFD\u02E3\uFFFDg\uFFFD\\0\uFFFDJ4\uFFFD\x7f\u05E0\uFFFD\uFFFDn\x18\uFFFDH\uFFFDgc\v\uFFFD\uFFFD\uFFFD\x15\uFFFD\uFFFD\uFFFD\uFFFD[\uFFFDK\uFFFD6\uFFFDq*\x132\uFFFD\uFFFD\x19\x04^\uFFFD\x1d3\uFFFD \uFFFD\f\uFFFDd0\uFFFD\uFFFDy\uFFFD\uFFFD\uFFFD|\u06C1z\uFFFDb\xff\x13\uFFFD\f%@\x103\f\f\x03?0\uFFFD3R&\uFFFDz\uFFFD5\uFFFD\uFFFD\v\uFFFD\uFFFD\uFFFD\uFFFD\uFFFDi\u024A\u0410\n (g\x18\uFFFD\u01BE\x1f\x0eY\uFFFD\uFFFD%O\x03\uFFFD\uFFFDD\x13\x01z\uFFFD\uFFFD\x1c\x003-@0\uFFFD"\uFFFD\uFFFD/\uFFFD\x01r\uFFFD\uFFFD\\Q6\uFFFD\uFFFDD&\uFFFD\0vj\uFFFD`\x115\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD1M\uFFFD\uFFFD&j\uFFFD\uFFFD\xda\u0757\uFFFD&\x18\uFFFD(<\n\uFFFD\uFFFD\0AQ\uFFFD\uFFFDV\uFFFD\uFFFD\uFFFD\x03S,\uFFFD@\uFFFD\uFFFD\uFFFD\x11*\x172\uFFFD~\uFFFDDP\uFFFDc\x06e\uFFFD{\uFFFD\uFFFDe\uFFFDW9\uFFFD`8\uFFFD3\uFFFD:\uFFFD\uFFFD\x0e\uFFFD\x06^z\x15E\uFFFD\uFFFDQ\0\x04\uFFFD\u0298\uFFFDrT\x18NL\uFFFD-$vb\0\uFFFDJ\uFFFD`	v\uFFFD\uFFFD@\uFFFDA\uFFFD\uFFFDF\uFFFDf6M@\uFFFD;\uFFFD\u3A8F\uFFFD\uFFFD\x1ej\uFFFDm\uFFFD\u06AFb	6\u04D2\uFFFD\uFFFDl\uFFFDPl\uFFFD\uFFFD\x156I\x05b\0\uFFFD\uFFFD\uFFFD\0DJ.\x12\uFFFD2i+\u022DD\uFFFD`-a\u05D6\uFFFD\uFFFD]\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\x1dd3\x14P\uFFFD\uFFFD\uFFFD|@I\uFFFD^\uFFFD\uFFFDnUSd\x11M22@\uFFFD\uFFFD\uFFFD&\uFFFD#D-"\xc0\uFFFD\uFFFD\uFFFDU\u024Aa$\x06f\uFFFD\x16Y\uFFFD\uFFFD\uFFFDP\uFFFD\uFFFDY\uFFFD5RK\uFFFD\uFFFD\x15sg\x1a]\uFFFD\uFFFDd\uFFFD[\uFFFD$B\uFFFD\uFFFD\uFFFD\x06d\uFFFDv\uFFFD\uFFFD\uFFFD\uFFFD\x1a%X\x13\uFFFD\bZn\u048DG\uFFFDE\uFFFD\uFFFD\uFFFD\u0398\uFFFDI\uFFFDI\uFFFD\uFFFDM\uFFFD\uFFFD\uFFFDB\uFFFDl\uFFFD\uFFFDBN\uFFFD\x15K9;\uFFFDAs\uFFFD[IIo\uFFFD\uFFFDUx\uFFFD\uFFFD\x01\uFFFD\uFFFD\uFFFDA\uFFFD@\x18#qNg)\u0339^\uFFFDui\uFFFD.nN\uFFFDzj\x19\uFFFDI\uFFFDZ\x15\uFFFD\uFFFD\x05U\u05E3\uFFFDF\uFFFDU\uFFFDE\uFFFD%E\x12|\uFFFD\uFFFDQ\uFFFD\u01CA\uFFFD}\uFFFD\uFFFD\uFFFD\uFFFD\x12\uFFFD\uFFFDR\uFFFDX^\x05\uFFFD\uFFFD\uFFFD!-\uFFFDr\uFFFD\uFFFD^\uFFFD\uFFFD\uFFFD\x7f\uFFFD\uFFFD\uFFFD!-\uFFFDN\uFFFD\uFFFD\n\uFFFD\uFFFD\uFFFD\uFFFD+{\uFFFDC\u0273.\r@\uFFFD\uFFFD\uFFFD\uFFFDAVv\uFFFD\uFFFD\x16\x06\u022Fz\x0e\uFFFD\uFFFD\uFFFD\u0658\uFFFDrB\uFFFD\uFFFD,\uFFFD\uFFFD/^5\uFFFD\x193F\u02EC2\x02\x1e\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\x0e\x7f+\uFFFDZy\x12\uFFFDk[\x15\uFFFDdX\uFFFD\uFFFDZI\uFFFD\uFFFD~\x1d\uFFFD\uFFFDz\x17\uFFFDYob\uFFFD\uFFFD\x15A\uFFFD|\uFFFDL&y@\uFFFD\uFFFDe\uFFFD\\K6\uFFFD]\uFFFDN\uFFFD\uFFFD_\\d%\uFFFDW+\uFFFD\uFFFD\uFFFD\nm\x07\uFFFD\x03\uFFFD\u0532\uFFFD/\uFFFD\uFFFDSPf\uFFFD3\uFFFDy\uFFFDp\v\uFFFDVYk\x11\uFFFD\uFFFDAB\x14+?\uFFFD\uFFFD\uFFFDD\uFFFDG\uFFFD-\uFFFDIw\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\x7f\uFFFDzY\x15\uFFFDL\uFFFD)\uFFFD\uFFFD\uFFFD+\uFFFD\uFFFD\uFFFDM\x15\uFFFD\uFFFD\uFFFD.\u0673\uFFFD)\uFFFD1\uFFFDW\uFFFD\uFFFD^\uFFFDk\uFFFD\uFFFD\uFFFD\x1b\uFFFD\uFFFD\x02\uFFFD%\uFFFDo\u014Ak9\x12\x1c\uFFFD\x1e{\x12\uFFFD\u0646\n\uFFFDE\uFFFD\uFFFD(%\uFFFD2\x1a\uFFFD\x13X\f\uFFFDp\uFFFD*\v\uFFFD\uFFFD\x12\x1c\uFFFD\f\uFFFD\uFFFD6\uFFFD\uFFFDZ\uFFFD\uFFFD\x12m-jw\uFFFD\x07\uFFFD\uFFFD#\uFFFD\xf0M9\uFFFD\uFFFD\uFFFD\uFFFDW\x11q\uFFFD{\u0622q\uFFFD\uFFFDdw\uFFFDBz\uFFFD\uFFFD"\uFFFD\uFFFDxd\uFFFDb\uFFFD&#E@H\uFFFD\x16\uFFFD$XR\uFFFDG{\x01\uFFFD\uFFFD\x03)\uFFFD\uFFFD55\uFFFD\x1b\uFFFDz%\uFFFD\uFFFD*\u0638\uFFFD\uFFFD\x1f\uFFFD*\uFFFD\uFFFD\uFFFD1\uFFFD\uFFFD].\uFFFDxlX\uFFFD:\u07A5\uFFFD\uFFFD\uFFFD[\uFFFD\x1ayp\x1a\x1eG\uFFFDK\uFFFD)\uFFFDVRZ\uFFFD\uFFFD\\o\x17|o\uFFFD\u03BB\u114C\uFFFD\uFFFD$\uFFFD=%EV\uFFFD\x04\'\uFFFDp\uFFFD^3\uFFFD\uFFFD\x06\uFFFD\uFFFD\u0797\x14\0\uFFFDH\uFFFD\uFFFDF\uFFFDS\uFFFD\uFFFD\uFFFD\x11\uFFFD\uFFFD\uFFFD\v$r\uFFFD\uFFFD\uFFFD\uFFFDb\uFFFDH\uFFFDx\uFFFD<\uFFFD\x0e\uFFFD\x0f*\uFFFDk~\x1apH4\x1e\uFFFD\uFFFD\uFFFD\x19\uFFFD\uFFFD\uFFFDUJ\x04\u0118\uFFFD+\uFFFD\uFFFDD\x12<\uFFFD\uFFFDi\u1B8F\u0224V\n\uFFFD\uFFFD\uFFFD\x11L\uFFFDz\uFFFD\uFFFD\uFFFD#\uFFFDz\uFFFDU\uFFFDK\x14\uFFFD\uFFFD\uFFFD\uFFFD\uFFFDM\uFFFD\uFFFD\uFFFD\uFFFDT\uFFFD]o/\uFFFD\uFFFD\uFFFD\uFFFD\x7f_|F.\x10~\uFFFDLe\r\v\uFFFD+\b\uFFFDo[\uFFFD$\uFFFD	\x1a\uFFFDK\uFFFD9\uFFFD}\uFFFD\uFFFD\\\uFFFDu\uFFFDLj\uFFFD\uFFFD\x16+\uFFFD\x10{\uFFFDa\uFFFD\uFFFD\x13x0\uFFFD\uFFFDO~\uFFFDsz)v\uFFFD\x13\x01\uFFFD\f5\x02\uFFFD\uFFFD-7\uFFFD\x1e}a\x01\uFFFDpT|\uFFFD\x18\uFFFD\uFFFD\x05\b\uFFFDG\uFFFD\x16\uFFFD\x12,Zr-\uFFFDi96[\uFFFDn\uFFFD[\uFFFD\x1dA\uFFFD\uFFFD=\uFFFDk\f\uFFFDPG\uFFFD\uFFFD\uFFFD\uFFFD\r{`\uFFFDn8\uFFFD\uFFFD{\uFFFD\vkNq\u02CDx\uFFFD\uFFFD\uFFFD\uFFFD!\uFFFD6\u0545\uFFFD\uFFFD\uFFFD\uFFFD\x1b~\x0f.n\uFFFD\uFFFDKX\uFFFD\uFFFD\uFFFDB\uFFFD{:\uFFFD\uFFFDP@S\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\x1f\x19\uFFFDT\uFFFD\uFFFDd\uFFFD\uFFFDc\uFFFDU\uFFFD}\x1f\uFFFD\uFFFD\uFFFD\uFFFD6\x0f\uFFFD\uFFFDHg\x19\uFFFD\uFFFDeM\uFFFD\x15\x15\n\u07E8[s\uFFFDg\uFFFD(~\vY\uFFFD{9\uFFFDessu\uFFFD\uFFFDk\uFFFD\uFFFD\u06AD\uFFFD\n>G\uFFFD\uFFFDm\uFFFD:\x1c\uFFFD\uFFFD\x1f\uFFFDK\uFFFD\x1c\x0f\uFFFD\x1a>\uFFFD\x1b9[]\uFFFD?\uFFFD\uFFFD\x01q\uFFFD\n\uFFFD\uFFFD\u3D94\uFFFD\uFFFD`\uFFFDj\uFFFDS\uFFFD\x14yn\uFFFD\uFFFDd\uFFFDVt\uFFFDL\x04\b{\x03\uFFFD\uFFFD\u037F\uFFFDq\uFFFDnra\uFFFD\uFFFDP\uFFFD\u023E3\uFFFD-7\uFFFD\uFFFD\uFFFD]A\uFFFD\uFFFD#\uFFFD\uFFFDQn\uFFFD\uFFFD\uFFFDK@\uFFFD=\uFFFD\uFFFD\uFFFDx\uFFFD\uFFFD\uFFFD\x07$\uFFFD\uFFFD\u062FZ\uFFFD\uFFFD\uFFFD.\uFFFD\uFFFD\uFFFD\x1c\uFFFD0o\u12C7\uFFFD/]\uFFFD\x1a\uFFFD\nq\u02CDp@\uFFFD\x02\u07BD%u\uFFFDg\uFFFDo@\uFFFDp=\uFFFDE\uFFFD\x04g\v\x01\uFFFDB\uFFFD\x19\uFFFD\uFFFD<j\u0174\x16\uFFFD;\u0539/\uFFFD\f\uFFFDk\uFFFD`\uFFFD\uFFFD@\uFFFD\uFFFD\x01^,Gg\uFFFD\uFFFD\uFFFDr#\uFFFD\b\uFFFD\uFFFDX1\uFFFDvi9V38\uFFFD\uFFFDm\uFFFD\uFFFDz\x05<\uFFFD\uFFFD\uFFFD\uFFFDHxOP\u07B2&\xad\uFFFD\x1f\uFFFD`W\x1b)\uFFFD\x16\x19a\uFFFD\uFFFD\uFFFD\uFFFD\uFFFDF\x1eX\x169p\u0328A[\x14\uFFFD`\uFFFD1\uFFFD\x02\x1bM+\uF19B\uFFFD\uFFFD\u06CA\x05\uFFFD]\uFFFDvH\uFFFD\n/\uFFFD\uFFFD\u01D2\uFFFD\uFFFD\x03\x1c\uFFFDV^\x19/\uFFFDZ,Yy\x17\uFFFDh\n\uFFFD\uFFFDz\uFFFD\uFFFD=\r\uFFFDV\uFFFD\uFFFD5\x01IakQR\uFFFD\x137\x1e-\x12I\uFFFD\x06\x7f+&:Zf<\uFFFD\uFFFD\uFFFD(%\uFFFD\uFFFD\x1fi\uDA9E\uDCAE\uFFFDQI-\u0198\uFFFD\uFFFD!\uFFFDTP\\\uFFFD\uFFFD-\x12_\x17\uFFFDD\uFFFD\x12\uFFFD2\u076E\uFFFDZih-JJ\uFFFD\uFFFD\uFFFDZ\x06=\uFFFD\x1b\uFFFDI*\uFFFD\uFFFDKSkQ\uFFFD\uFFFDMD-k\uFFFD\uFFFD\uFFFD*\uFFFD`\uFFFD\uFFFDdO\uFFFD\uFFFD\x19r\uFFFD7\x11\uFFFD\uFFFD\uFFFD\x16%$X\uFFFD\uFFFDh\x11\uFFFD\uFFFDf\x1a\uFFFD(\uFFFD\u03EF\uFFFD6\uFFFD\uFFFD\uFFFD e\uFFFD\uFFFD%y\uFFFD"q\uFFFD+F\uFFFD\uFFFDM\uFFFD!(\uFFFD \uFFFD\uFFFD\uFFFD\x12"\uFFFD\x15T\x19\uFFFD4K\uFFFD]&\uFFFD\uFFFDtJoL\uFFFD%o\uFFFD3\uFFFDWd\uFFFDK\uFFFD<\uFFFDK\uFFFD\uFFFD\x15s\uFFFD\uFFFD2\uFFFD\uFFFD\uFFFD\u06A93\uFFFD\\/P\uFFFDo\uFFFD$\uFFFD 	\uFFFD@\uFFFD\uFFFD&\uFFFDU\uFFFD<\uFFFD\uFFFD-\uFFFDg<R\uFFFDZ\uFFFD\uFFFD`\uFFFDD%C\uFFFD\uFFFD\u01B8\u0784\u0522\uFFFD\uFFFD\nG\uFFFDt\x1b\uFFFD\x1bj\uFFFDu\uFFFDc\uFFFD\uFFFD\x1d\0\u012C\x07\uFFFD\x15\uFFFD\x16y\uFFFD\uFFFDN	6\uFFFD\uFFFD-]Ho4\x0f\uFFFD\uFFFDk\uFFFD\x11\uFFFD8\uFFFDk\u0445\uFFFD\x15\uFFFD`F \u0653~W^r]/\uFFFDP.Kg8\x06$\uFFFDE\uFFFD\b\uFFFD\uFFFDz\uFFFDR\uFFFD\uFFFD\x13	\x1e\uFFFDz\uFFFDm-JIpA\x1c\uFFFD\n\uFFFD%\uFFFD\uFFFD]/\uFFFD\uFFFD\u07CA\uFFFD\uFFFD\uFFFD>\uFFFDu\uFFFD\x13H\uFFFDt\x1b\vo\uFFFD\uFFFDt\uFFFDc\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD(%\uFFFDv\uFFFD\uFFFD[Q\uFFFDk\uFFFDe\u048B\uFFFD\x15\x0en\uFFFD\r =\uFFFD\x16\uFFFD$\uFFFD\x1a\x01b\u056B\uFFFD\u01B8^\x06S\uFFFD1\uFFFD\u020A\uFFFD`\x03\uFFFDIkQ\uFFFD\uFFFD\uFFFD\u8975(\uFFFDz-v\uFFFD\x16Y\uFFFD\x12\f\uFFFD\uFFFD\u07A8\uFFFD\x05\uFFFD\uFFFD[\uFFFD\uFFFD\uFFFD\uFFFD/\n\x1c\u020C\uFFFDh(\uFFFD\uFFFD"\uFFFD\uFFFD\0\uFFFD\u02C7%\uFFFDU\uFFFD\uFFFD\0\0\0\0IEND\uFFFDB`\uFFFD',
        "trunc": {
            "index.md": '---\ntitle: Math.trunc()\nslug: Web/JavaScript/Reference/Global_Objects/Math/trunc\npage-type: javascript-static-method\nbrowser-compat: javascript.builtins.Math.trunc\n---\n\n{{JSRef}}\n\nThe **`Math.trunc()`** static method returns the integer part of a number by removing any fractional digits.\n\n{{EmbedInteractiveExample("pages/js/math-trunc.html")}}\n\n## Syntax\n\n```js-nolint\nMath.trunc(x)\n```\n\n### Parameters\n\n- `x`\n  - : A number.\n\n### Return value\n\nThe integer part of `x`.\n\n## Description\n\nUnlike the other three `Math` methods: {{jsxref("Math.floor()")}}, {{jsxref("Math.ceil()")}} and {{jsxref("Math.round()")}}, the way `Math.trunc()` works is very simple. It _truncates_ (cuts off) the dot and the digits to the right of it, no matter whether the argument is a positive or negative number.\n\nBecause `trunc()` is a static method of `Math`, you always use it as `Math.trunc()`, rather than as a method of a `Math` object you created (`Math` is not a constructor).\n\n## Examples\n\n### Using Math.trunc()\n\n```js\nMath.trunc(-Infinity); // -Infinity\nMath.trunc("-1.123"); // -1\nMath.trunc(-0.123); // -0\nMath.trunc(-0); // -0\nMath.trunc(0); // 0\nMath.trunc(0.123); // 0\nMath.trunc(13.37); // 13\nMath.trunc(42.84); // 42\nMath.trunc(Infinity); // Infinity\n```\n\n### Using bitwise no-ops to truncate numbers\n\n> **Warning:** This is not a polyfill for `Math.trunc()` because of non-negligible edge cases.\n\nBitwise operations convert their operands to 32-bit integers, which people have historically taken advantage of to truncate float-point numbers. Common techniques include:\n\n```js\nconst original = 3.14;\nconst truncated1 = ~~original; // Double negation\nconst truncated2 = original & -1; // Bitwise AND with -1\nconst truncated3 = original | 0; // Bitwise OR with 0\nconst truncated4 = original ^ 0; // Bitwise XOR with 0\nconst truncated5 = original >> 0; // Bitwise shifting by 0\n```\n\nBeware that this is essentially `toInt32`, which is not the same as `Math.trunc`. When the value does not satisfy -2<sup>31</sup> - 1 < `value` < 2<sup>31</sup> (-2147483649 < `value` < 2147483648), the conversion would overflow.\n\n```js\nconst a = ~~2147483648; // -2147483648\nconst b = ~~-2147483649; // 2147483647\nconst c = ~~4294967296; // 0\n```\n\nOnly use `~~` as a substitution for `Math.trunc()` when you are confident that the range of input falls within the range of 32-bit integers.\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Math.trunc` in `core-js`](https://github.com/zloirock/core-js#ecmascript-math)\n- {{jsxref("Math.abs()")}}\n- {{jsxref("Math.ceil()")}}\n- {{jsxref("Math.floor()")}}\n- {{jsxref("Math.round()")}}\n- {{jsxref("Math.sign()")}}\n'
        }
    },
    "nan": {
        "index.md": '---\ntitle: NaN\nslug: Web/JavaScript/Reference/Global_Objects/NaN\npage-type: javascript-global-property\nbrowser-compat: javascript.builtins.NaN\n---\n\n{{jsSidebar("Objects")}}\n\nThe **`NaN`** global property is a value representing Not-A-Number.\n\n{{EmbedInteractiveExample("pages/js/globalprops-nan.html")}}\n\n## Value\n\nThe same number value as {{jsxref("Number.NaN")}}.\n\n{{js_property_attributes(0, 0, 0)}}\n\n## Description\n\n`NaN` is a property of the _global object_. In other words, it is a variable in global scope.\n\nIn modern browsers, `NaN` is a non-configurable, non-writable property. Even when this is not the case, avoid overriding it.\n\nThere are five different types of operations that return `NaN`:\n\n- Failed number conversion (e.g. explicit ones like `parseInt("blabla")`, `Number(undefined)`, or implicit ones like `Math.abs(undefined)`)\n- Math operation where the result is not a real number (e.g. `Math.sqrt(-1)`)\n- Indeterminate form (e.g. `0 * Infinity`, `1 ** Infinity`, `Infinity / Infinity`, `Infinity - Infinity`)\n- A method or expression whose operand is or gets coerced to `NaN` (e.g. `7 ** NaN`, `7 * "blabla"`) \u2014 this means `NaN` is contagious\n- Other cases where an invalid value is to be represented as a number (e.g. an invalid [Date](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date) `new Date("blabla").getTime()`, `"".charCodeAt(1)`)\n\n`NaN` and its behaviors are not invented by JavaScript. Its semantics in floating point arithmetic (including that `NaN !== NaN`) are specified by [IEEE 754](https://en.wikipedia.org/wiki/Double_precision_floating-point_format). `NaN`\'s behaviors include:\n\n- If `NaN` is involved in a mathematical operation (but not [bitwise operations](/en-US/docs/Web/JavaScript/Reference/Operators#bitwise_shift_operators)), the result is usually also `NaN`. (See [counter-example](#silently_escaping_nan) below.)\n- When `NaN` is one of the operands of any relational comparison (`>`, `<`, `>=`, `<=`), the result is always `false`.\n- `NaN` compares unequal (via [`==`](/en-US/docs/Web/JavaScript/Reference/Operators/Equality), [`!=`](/en-US/docs/Web/JavaScript/Reference/Operators/Inequality), [`===`](/en-US/docs/Web/JavaScript/Reference/Operators/Strict_equality), and [`!==`](/en-US/docs/Web/JavaScript/Reference/Operators/Strict_inequality)) to any other value \u2014 including to another `NaN` value.\n\n`NaN` is also one of the [falsy](/en-US/docs/Glossary/Falsy) values in JavaScript.\n\n## Examples\n\n### Testing against NaN\n\nTo tell if a value is `NaN`, use {{jsxref("Number.isNaN()")}} or {{jsxref("isNaN()")}} to most clearly determine whether a value is `NaN` \u2014 or, since `NaN` is the only value that compares unequal to itself, you can perform a self-comparison like `x !== x`.\n\n```js\nNaN === NaN; // false\nNumber.NaN === NaN; // false\nisNaN(NaN); // true\nisNaN(Number.NaN); // true\nNumber.isNaN(NaN); // true\n\nfunction valueIsNaN(v) {\n  return v !== v;\n}\nvalueIsNaN(1); // false\nvalueIsNaN(NaN); // true\nvalueIsNaN(Number.NaN); // true\n```\n\nHowever, do note the difference between `isNaN()` and `Number.isNaN()`: the former will return `true` if the value is currently `NaN`, or if it is going to be `NaN` after it is coerced to a number, while the latter will return `true` only if the value is currently `NaN`:\n\n```js\nisNaN("hello world"); // true\nNumber.isNaN("hello world"); // false\n```\n\nFor the same reason, using a BigInt value will throw an error with `isNaN()` and not with `Number.isNaN()`:\n\n```js\nisNaN(1n); // TypeError: Conversion from \'BigInt\' to \'number\' is not allowed.\nNumber.isNaN(1n); // false\n```\n\nAdditionally, some array methods cannot find `NaN`, while others can. Namely, the index-finding ones ({{jsxref("Array/indexOf", "indexOf()")}}, {{jsxref("Array/lastIndexOf", "lastIndexOf()")}}) cannot find `NaN`, while the value-finding ones ({{jsxref("Array/includes", "includes()")}}) can:\n\n```js\nconst arr = [2, 4, NaN, 12];\narr.indexOf(NaN); // -1\narr.includes(NaN); // true\n\n// Methods accepting a properly defined predicate can always find NaN\narr.findIndex((n) => Number.isNaN(n)); // 2\n```\n\nFor more information about `NaN` and its comparison, see [Equality comparison and sameness](/en-US/docs/Web/JavaScript/Equality_comparisons_and_sameness).\n\n### Observably distinct NaN values\n\nThere\'s a motivation for `NaN` being unequal to itself. It\'s possible to produce two floating point numbers with different binary representations but are both `NaN`, because in [IEEE 754 encoding](https://en.wikipedia.org/wiki/NaN#Floating_point), any floating point number with exponent `0x7ff` and a non-zero mantissa is `NaN`. In JavaScript, you can do bit-level manipulation using [typed arrays](/en-US/docs/Web/JavaScript/Guide/Typed_arrays).\n\n```js\nconst f2b = (x) => new Uint8Array(new Float64Array([x]).buffer);\nconst b2f = (x) => new Float64Array(x.buffer)[0];\n// Get a byte representation of NaN\nconst n = f2b(NaN);\nconst m = f2b(NaN);\n// Change the sign bit, which doesn\'t matter for NaN\nn[7] += 2 ** 7;\n// n[0] += 2**7; for big endian processors\nconst nan2 = b2f(n);\nconsole.log(nan2); // NaN\nconsole.log(Object.is(nan2, NaN)); // true\nconsole.log(f2b(NaN)); // Uint8Array(8) [0, 0, 0, 0, 0, 0, 248, 127]\nconsole.log(f2b(nan2)); // Uint8Array(8) [0, 0, 0, 0, 0, 0, 248, 255]\n// Change the first bit, which is the least significant bit of the mantissa and doesn\'t matter for NaN\nm[0] = 1;\n// m[7] = 1; for big endian processors\nconst nan3 = b2f(m);\nconsole.log(nan3); // NaN\nconsole.log(Object.is(nan3, NaN)); // true\nconsole.log(f2b(NaN)); // Uint8Array(8) [0, 0, 0, 0, 0, 0, 248, 127]\nconsole.log(f2b(nan3)); // Uint8Array(8) [1, 0, 0, 0, 0, 0, 248, 127]\n```\n\n### Silently escaping NaN\n\n`NaN` propagates through mathematical operations, so it\'s usually sufficient to test for `NaN` once at the end of calculation to detect error conditions. The only case where `NaN` gets silently escaped is when using [exponentiation](/en-US/docs/Web/JavaScript/Reference/Operators/Exponentiation) with an exponent of `0`, which immediately returns `1` without testing the base\'s value.\n\n```js\nNaN ** 0 === 1; // true\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Number.NaN")}}\n- {{jsxref("Number.isNaN()")}}\n- {{jsxref("isNaN()")}}\n'
    },
    "number": {
        "epsilon": {
            "index.md": '---\ntitle: Number.EPSILON\nslug: Web/JavaScript/Reference/Global_Objects/Number/EPSILON\npage-type: javascript-static-data-property\nbrowser-compat: javascript.builtins.Number.EPSILON\n---\n\n{{JSRef}}\n\nThe **`Number.EPSILON`** static data property represents the difference between 1 and the smallest floating point number greater than 1.\n\n{{EmbedInteractiveExample("pages/js/number-epsilon.html")}}\n\n## Value\n\n2<sup>-52</sup>, or approximately `2.2204460492503130808472633361816E-16`.\n\n{{js_property_attributes(0, 0, 0)}}\n\n## Description\n\n`Number.EPSILON` is the difference between 1 and the next greater number representable in the Number format, because [double precision floating point format](https://en.wikipedia.org/wiki/Double_precision_floating-point_format) only has 52 bits to represent the [mantissa](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number#number_encoding), and the lowest bit has a significance of 2<sup>-52</sup>.\n\nNote that the absolute accuracy of floating numbers decreases as the number gets larger, because the exponent grows while the mantissa\'s accuracy stays the same. {{jsxref("Number.MIN_VALUE")}} is the smallest representable positive number, which is much smaller than `Number.EPSILON`.\n\nBecause `EPSILON` is a static property of {{jsxref("Number")}}, you always use it as `Number.EPSILON`, rather than as a property of a number value.\n\n## Examples\n\n### Testing equality\n\nAny number encoding system occupying a finite number of bits, of whatever base you choose (e.g. decimal or binary), will _necessarily_ be unable to represent all numbers exactly, because you are trying to represent an infinite number of points on the number line using a finite amount of memory. For example, a base-10 (decimal) system cannot represent 1/3 exactly, and a base-2 (binary) system cannot represent `0.1` exactly. Thus, for example, `0.1 + 0.2` is not exactly equal to `0.3`:\n\n```js\nconsole.log(0.1 + 0.2); // 0.30000000000000004\nconsole.log(0.1 + 0.2 === 0.3); // false\n```\n\nFor this reason, it is often advised that **floating point numbers should never be compared with `===`**. Instead, we can deem two numbers as equal if they are _close enough_ to each other. The `Number.EPSILON` constant is usually a reasonable threshold for errors if the arithmetic is around the magnitude of `1`, because `EPSILON`, in essence, specifies how accurate the number "1" is.\n\n```js\nfunction equal(x, y) {\n  return Math.abs(x - y) < Number.EPSILON;\n}\n\nconst x = 0.2;\nconst y = 0.3;\nconst z = 0.1;\nconsole.log(equal(x + z, y)); // true\n```\n\nHowever, `Number.EPSILON` is inappropriate for any arithmetic operating on a larger magnitude. If your data is on the 10<sup>3</sup> order of magnitude, the decimal part will have a much smaller accuracy than `Number.EPSILON`:\n\n```js\nfunction equal(x, y) {\n  return Math.abs(x - y) < Number.EPSILON;\n}\n\nconst x = 1000.1;\nconst y = 1000.2;\nconst z = 2000.3;\nconsole.log(x + y); // 2000.3000000000002; error of 10^-13 instead of 10^-16\nconsole.log(equal(x + y, z)); // false\n```\n\nIn this case, a larger tolerance is required. As the numbers compared have a magnitude of approximately `2000`, a multiplier such as `2000 * Number.EPSILON` creates enough tolerance for this instance.\n\n```js\nfunction equal(x, y, tolerance = Number.EPSILON) {\n  return Math.abs(x - y) < tolerance;\n}\n\nconst x = 1000.1;\nconst y = 1000.2;\nconst z = 2000.3;\nconsole.log(equal(x + y, z, 2000 * Number.EPSILON)); // true\n```\n\nIn addition to magnitude, it is important to consider the _accuracy_ of your input. For example, if the numbers are collected from a form input and the input value can only be adjusted by steps of `0.1` (i.e. [`<input type="number" step="0.1">`](/en-US/docs/Web/HTML/Attributes/step)), it usually makes sense to allow a much larger tolerance, such as `0.01`, since the data only has a precision of `0.1`.\n\n> **Note:** Important takeaway: do not simply use `Number.EPSILON` as a threshold for equality testing. Use a threshold that is appropriate for the magnitude and accuracy of the numbers you are comparing.\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Number.EPSILON` in `core-js`](https://github.com/zloirock/core-js#ecmascript-number)\n- {{jsxref("Number")}}\n'
        },
        "index.md": '---\ntitle: Number\nslug: Web/JavaScript/Reference/Global_Objects/Number\npage-type: javascript-class\nbrowser-compat: javascript.builtins.Number\n---\n\n{{JSRef}}\n\n**`Number`** values represent floating-point numbers like `37` or `-9.25`.\n\nThe `Number` constructor contains constants and methods for working with numbers. Values of other types can be converted to numbers using the `Number()` function.\n\n## Description\n\nNumbers are most commonly expressed in literal forms like `255` or `3.14159`. The [lexical grammar](/en-US/docs/Web/JavaScript/Reference/Lexical_grammar#numeric_literals) contains a more detailed reference.\n\n```js\n255; // two-hundred and fifty-five\n255.0; // same number\n255 === 255.0; // true\n255 === 0xff; // true (hexadecimal notation)\n255 === 0b11111111; // true (binary notation)\n255 === 0.255e3; // true (decimal exponential notation)\n```\n\nA number literal like `37` in JavaScript code is a floating-point value, not an integer. There is no separate integer type in common everyday use. (JavaScript also has a {{jsxref("BigInt")}} type, but it\'s not designed to replace Number for everyday uses. `37` is still a number, not a BigInt.)\n\nWhen used as a function, `Number(value)` converts a string or other value to the Number type. If the value can\'t be converted, it returns {{jsxref("NaN")}}.\n\n```js\nNumber("123"); // returns the number 123\nNumber("123") === 123; // true\n\nNumber("unicorn"); // NaN\nNumber(undefined); // NaN\n```\n\n### Number encoding\n\nThe JavaScript `Number` type is a [double-precision 64-bit binary format IEEE 754](https://en.wikipedia.org/wiki/Double_precision_floating-point_format) value, like `double` in Java or C#. This means it can represent fractional values, but there are some limits to the stored number\'s magnitude and precision. Very briefly, an IEEE 754 double-precision number uses 64 bits to represent 3 parts:\n\n- 1 bit for the _sign_ (positive or negative)\n- 11 bits for the _exponent_ (-1022 to 1023)\n- 52 bits for the _mantissa_ (representing a number between 0 and 1)\n\nThe mantissa (also called _significand_) is the part of the number representing the actual value (significant digits). The exponent is the power of 2 that the mantissa should be multiplied by. Thinking about it as scientific notation:\n\n<math display="block"><semantics><mrow><mtext>Number</mtext><mo>=</mo><mo stretchy="false">(</mo><mrow><mo>\u2212</mo><mn>1</mn></mrow><msup><mo stretchy="false">)</mo><mtext>sign</mtext></msup><mo>\u22C5</mo><mo stretchy="false">(</mo><mn>1</mn><mo>+</mo><mtext>mantissa</mtext><mo stretchy="false">)</mo><mo>\u22C5</mo><msup><mn>2</mn><mtext>exponent</mtext></msup></mrow><annotation encoding="TeX">\\text{Number} = ({-1})^{\\text{sign}} \\cdot (1 + \\text{mantissa}) \\cdot 2^{\\text{exponent}}</annotation></semantics></math>\n\nThe mantissa is stored with 52 bits, interpreted as digits after `1.\u2026` in a binary fractional number. Therefore, the mantissa\'s precision is 2<sup>-52</sup> (obtainable via {{jsxref("Number.EPSILON")}}), or about 15 to 17 decimal places; arithmetic above that level of precision is subject to [rounding](https://en.wikipedia.org/wiki/Floating-point_arithmetic#Representable_numbers,_conversion_and_rounding).\n\nThe largest value a number can hold is 2<sup>1023</sup> \xd7 (2 - 2<sup>-52</sup>) (with the exponent being 1023 and the mantissa being 0.1111\u2026 in base 2), which is obtainable via {{jsxref("Number.MAX_VALUE")}}. Values higher than that are replaced with the special number constant {{jsxref("Infinity")}}.\n\nIntegers can only be represented without loss of precision in the range -2<sup>53</sup> + 1 to 2<sup>53</sup> - 1, inclusive (obtainable via {{jsxref("Number.MIN_SAFE_INTEGER")}} and {{jsxref("Number.MAX_SAFE_INTEGER")}}), because the mantissa can only hold 53 bits (including the leading 1).\n\nMore details on this are described in the [ECMAScript standard](https://tc39.es/ecma262/multipage/ecmascript-data-types-and-values.html#sec-ecmascript-language-types-number-type).\n\n### Number coercion\n\nMany built-in operations that expect numbers first coerce their arguments to numbers (which is largely why `Number` objects behave similarly to number primitives). [The operation](https://tc39.es/ecma262/multipage/abstract-operations.html#sec-tonumber) can be summarized as follows:\n\n- Numbers are returned as-is.\n- [`undefined`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/undefined) turns into [`NaN`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/NaN).\n- [`null`](/en-US/docs/Web/JavaScript/Reference/Operators/null) turns into `0`.\n- `true` turns into `1`; `false` turns into `0`.\n- Strings are converted by parsing them as if they contain a [number literal](/en-US/docs/Web/JavaScript/Reference/Lexical_grammar#numeric_literals). Parsing failure results in `NaN`. There are some minor differences compared to an actual number literal:\n  - Leading and trailing whitespace/line terminators are ignored.\n  - A leading `0` digit does not cause the number to become an octal literal (or get rejected in strict mode).\n  - `+` and `-` are allowed at the start of the string to indicate its sign. (In actual code, they "look like" part of the literal, but are actually separate unary operators.) However, the sign can only appear once, and must not be followed by whitespace.\n  - `Infinity` and `-Infinity` are recognized as literals. In actual code, they are global variables.\n  - Empty or whitespace-only strings are converted to `0`.\n  - [Numeric separators](/en-US/docs/Web/JavaScript/Reference/Lexical_grammar#numeric_separators) are not allowed.\n- [BigInts](/en-US/docs/Web/JavaScript/Reference/Global_Objects/BigInt) throw a {{jsxref("TypeError")}} to prevent unintended implicit coercion causing loss of precision.\n- [Symbols](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol) throw a {{jsxref("TypeError")}}.\n- Objects are first [converted to a primitive](/en-US/docs/Web/JavaScript/Data_structures#primitive_coercion) by calling their [`[@@toPrimitive]()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol/toPrimitive) (with `"number"` as hint), `valueOf()`, and `toString()` methods, in that order. The resulting primitive is then converted to a number.\n\nThere are two ways to achieve nearly the same effect in JavaScript.\n\n- [Unary plus](/en-US/docs/Web/JavaScript/Reference/Operators/Unary_plus): `+x` does exactly the number coercion steps explained above to convert `x`.\n- The [`Number()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/Number) function: `Number(x)` uses the same algorithm to convert `x`, except that [BigInts](/en-US/docs/Web/JavaScript/Reference/Global_Objects/BigInt) don\'t throw a {{jsxref("TypeError")}}, but return their number value, with possible loss of precision.\n\n{{jsxref("Number.parseFloat()")}} and {{jsxref("Number.parseInt()")}} are similar to `Number()` but only convert strings, and have slightly different parsing rules. For example, `parseInt()` doesn\'t recognize the decimal point, and `parseFloat()` doesn\'t recognize the `0x` prefix.\n\n#### Integer conversion\n\nSome operations expect integers, most notably those that work with array/string indices, date/time components, and number radixes. After performing the number coercion steps above, the result is [truncated](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/trunc) to an integer (by discarding the fractional part). If the number is \xb1Infinity, it\'s returned as-is. If the number is `NaN` or `-0`, it\'s returned as `0`. The result is therefore always an integer (which is not `-0`) or \xb1Infinity.\n\nNotably, when converted to integers, both `undefined` and `null` become `0`, because `undefined` is converted to `NaN`, which also becomes `0`.\n\n#### Fixed-width number conversion\n\nJavaScript has some lower-level functions that deal with the binary encoding of integer numbers, most notably [bitwise operators](/en-US/docs/Web/JavaScript/Reference/Operators#bitwise_shift_operators) and {{jsxref("TypedArray")}} objects. Bitwise operators always convert the operands to 32-bit integers. In these cases, after converting the value to a number, the number is then normalized to the given width by first [truncating](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/trunc) the fractional part and then taking the lowest bits in the integer\'s two\'s complement encoding.\n\n```js\nnew Int32Array([1.1, 1.9, -1.1, -1.9]); // Int32Array(4) [ 1, 1, -1, -1 ]\n\nnew Int8Array([257, -257]); // Int8Array(2) [ 1, -1 ]\n// 257 = 0001 0000 0001\n//     =      0000 0001 (mod 2^8)\n//     = 1\n// -257 = 1110 1111 1111\n//      =      1111 1111 (mod 2^8)\n//      = -1 (as signed integer)\n\nnew Uint8Array([257, -257]); // Uint8Array(2) [ 1, 255 ]\n// -257 = 1110 1111 1111\n//      =      1111 1111 (mod 2^8)\n//      = 255 (as unsigned integer)\n```\n\n## Constructor\n\n- {{jsxref("Number/Number", "Number()")}}\n  - : Creates a new `Number` value.\n\nWhen `Number` is called as a constructor (with `new`), it creates a {{jsxref("Number")}} object, which is **not** a primitive. For example, `typeof new Number(42) === "object"`, and `new Number(42) !== 42` (although `new Number(42) == 42`).\n\n> **Warning:** You should rarely find yourself using `Number` as a constructor.\n\n## Static properties\n\n- {{jsxref("Number.EPSILON")}}\n  - : The smallest interval between two representable numbers.\n- {{jsxref("Number.MAX_SAFE_INTEGER")}}\n  - : The maximum safe integer in JavaScript (2<sup>53</sup> - 1).\n- {{jsxref("Number.MAX_VALUE")}}\n  - : The largest positive representable number.\n- {{jsxref("Number.MIN_SAFE_INTEGER")}}\n  - : The minimum safe integer in JavaScript (-(2<sup>53</sup> - 1)).\n- {{jsxref("Number.MIN_VALUE")}}\n  - : The smallest positive representable number\u2014that is, the positive number closest to zero (without actually being zero).\n- {{jsxref("Number.NaN")}}\n  - : Special "**N**ot **a** **N**umber" value.\n- {{jsxref("Number.NEGATIVE_INFINITY")}}\n  - : Special value representing negative infinity. Returned on overflow.\n- {{jsxref("Number.POSITIVE_INFINITY")}}\n  - : Special value representing infinity. Returned on overflow.\n\n## Static methods\n\n- {{jsxref("Number.isFinite()")}}\n  - : Determine whether the passed value is a finite number.\n- {{jsxref("Number.isInteger()")}}\n  - : Determine whether the passed value is an integer.\n- {{jsxref("Number.isNaN()")}}\n  - : Determine whether the passed value is `NaN`.\n- {{jsxref("Number.isSafeInteger()")}}\n  - : Determine whether the passed value is a safe integer (number between -(2<sup>53</sup> - 1) and 2<sup>53</sup> - 1).\n- {{jsxref("Number.parseFloat()")}}\n  - : This is the same as the global {{jsxref("parseFloat()")}} function.\n- {{jsxref("Number.parseInt()")}}\n  - : This is the same as the global {{jsxref("parseInt()")}} function.\n\n## Instance properties\n\nThese properties are defined on `Number.prototype` and shared by all `Number` instances.\n\n- {{jsxref("Object/constructor", "Number.prototype.constructor")}}\n  - : The constructor function that created the instance object. For `Number` instances, the initial value is the {{jsxref("Number/Number", "Number")}} constructor.\n\n## Instance methods\n\n- {{jsxref("Number.prototype.toExponential()")}}\n  - : Returns a string representing the number in exponential notation.\n- {{jsxref("Number.prototype.toFixed()")}}\n  - : Returns a string representing the number in fixed-point notation.\n- {{jsxref("Number.prototype.toLocaleString()")}}\n  - : Returns a string with a language sensitive representation of this number. Overrides the {{jsxref("Object.prototype.toLocaleString()")}} method.\n- {{jsxref("Number.prototype.toPrecision()")}}\n  - : Returns a string representing the number to a specified precision in fixed-point or exponential notation.\n- {{jsxref("Number.prototype.toString()")}}\n  - : Returns a string representing the specified object in the specified _radix_ ("base"). Overrides the {{jsxref("Object.prototype.toString()")}} method.\n- {{jsxref("Number.prototype.valueOf()")}}\n  - : Returns the primitive value of the specified object. Overrides the {{jsxref("Object.prototype.valueOf()")}} method.\n\n## Examples\n\n### Using the Number object to assign values to numeric variables\n\nThe following example uses the `Number` object\'s properties to assign values to several numeric variables:\n\n```js\nconst biggestNum = Number.MAX_VALUE;\nconst smallestNum = Number.MIN_VALUE;\nconst infiniteNum = Number.POSITIVE_INFINITY;\nconst negInfiniteNum = Number.NEGATIVE_INFINITY;\nconst notANum = Number.NaN;\n```\n\n### Integer range for Number\n\nThe following example shows the minimum and maximum integer values that can be represented as `Number` object.\n\n```js\nconst biggestInt = Number.MAX_SAFE_INTEGER; // (2**53 - 1) => 9007199254740991\nconst smallestInt = Number.MIN_SAFE_INTEGER; // -(2**53 - 1) => -9007199254740991\n```\n\nWhen parsing data that has been serialized to JSON, integer values falling outside of this range can be expected to become corrupted when JSON parser coerces them to `Number` type.\n\nA possible workaround is to use {{jsxref("String")}} instead.\n\nLarger numbers can be represented using the {{jsxref("BigInt")}} type.\n\n### Using Number() to convert a Date object\n\nThe following example converts the {{jsxref("Date")}} object to a numerical value using `Number` as a function:\n\n```js\nconst d = new Date("1995-12-17T03:24:00");\nconsole.log(Number(d));\n```\n\nThis logs `819199440000`.\n\n### Convert numeric strings and null to numbers\n\n```js\nNumber("123"); // 123\nNumber("123") === 123; // true\nNumber("12.3"); // 12.3\nNumber("12.00"); // 12\nNumber("123e-1"); // 12.3\nNumber(""); // 0\nNumber(null); // 0\nNumber("0x11"); // 17\nNumber("0b11"); // 3\nNumber("0o11"); // 9\nNumber("foo"); // NaN\nNumber("100a"); // NaN\nNumber("-Infinity"); // -Infinity\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of modern `Number` behavior (with support binary and octal literals) in `core-js`](https://github.com/zloirock/core-js#ecmascript-number)\n- {{jsxref("NaN")}}\n- [Arithmetic operators](/en-US/docs/Web/JavaScript/Reference/Operators#arithmetic_operators)\n- {{jsxref("Math")}}\n- {{jsxref("BigInt")}}\n',
        "isfinite": {
            "index.md": '---\ntitle: Number.isFinite()\nslug: Web/JavaScript/Reference/Global_Objects/Number/isFinite\npage-type: javascript-static-method\nbrowser-compat: javascript.builtins.Number.isFinite\n---\n\n{{JSRef}}\n\nThe **`Number.isFinite()`** static method determines whether the passed value is a finite number \u2014 that is, it checks that a given value is a number, and the number is neither positive {{jsxref("Infinity")}}, negative `Infinity`, nor {{jsxref("NaN")}}.\n\n{{EmbedInteractiveExample("pages/js/number-isfinite.html")}}\n\n## Syntax\n\n```js-nolint\nNumber.isFinite(value)\n```\n\n### Parameters\n\n- `value`\n  - : The value to be tested for finiteness.\n\n### Return value\n\nThe boolean value `true` if the given value is a finite number. Otherwise `false`.\n\n## Examples\n\n### Using isFinite()\n\n```js\nNumber.isFinite(Infinity); // false\nNumber.isFinite(NaN); // false\nNumber.isFinite(-Infinity); // false\n\nNumber.isFinite(0); // true\nNumber.isFinite(2e64); // true\n```\n\n### Difference between Number.isFinite() and global isFinite()\n\nIn comparison to the global {{jsxref("isFinite()")}} function, this method doesn\'t first convert the parameter to a number. This means only values of the type number _and_ are finite return `true`, and non-numbers always return `false`.\n\n```js\nisFinite("0"); // true; coerced to number 0\nNumber.isFinite("0"); // false\nisFinite(null); // true; coerced to number 0\nNumber.isFinite(null); // false\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Number.isFinite` in `core-js`](https://github.com/zloirock/core-js#ecmascript-number)\n- {{jsxref("Number")}}\n- {{jsxref("isFinite()")}}\n'
        },
        "isinteger": {
            "index.md": '---\ntitle: Number.isInteger()\nslug: Web/JavaScript/Reference/Global_Objects/Number/isInteger\npage-type: javascript-static-method\nbrowser-compat: javascript.builtins.Number.isInteger\n---\n\n{{JSRef}}\n\nThe **`Number.isInteger()`** static method determines whether the passed value is an integer.\n\n{{EmbedInteractiveExample("pages/js/number-isinteger.html")}}\n\n## Syntax\n\n```js-nolint\nNumber.isInteger(value)\n```\n\n### Parameters\n\n- `value`\n  - : The value to be tested for being an integer.\n\n### Return value\n\nThe boolean value `true` if the given value is an integer. Otherwise `false`.\n\n## Description\n\nIf the target value is an integer, return `true`, otherwise return `false`. If the value is {{jsxref("NaN")}} or {{jsxref("Infinity")}}, return `false`. The method will also return `true` for floating point numbers that can be represented as integer. It will always return `false` if the value is not a number.\n\nNote that some number literals, while looking like non-integers, actually represent integers \u2014 due to the precision limit of ECMAScript floating-point number encoding (IEEE-754). For example, `5.0000000000000001` only differs from `5` by `1e-16`, which is too small to be represented. (For reference, [`Number.EPSILON`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/EPSILON) stores the distance between 1 and the next representable floating-point number greater than 1, and that is about `2.22e-16`.) Therefore, `5.0000000000000001` will be represented with the same encoding as `5`, thus making `Number.isInteger(5.0000000000000001)` return `true`.\n\nIn a similar sense, numbers around the magnitude of [`Number.MAX_SAFE_INTEGER`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/MAX_SAFE_INTEGER) will suffer from loss of precision and make `Number.isInteger` return `true` even when it\'s not an integer. (The actual threshold varies based on how many bits are needed to represent the decimal \u2014 for example, `Number.isInteger(4500000000000000.1)` is `true`, but `Number.isInteger(4500000000000000.5)` is `false`.)\n\n## Examples\n\n### Using isInteger\n\n```js\nNumber.isInteger(0); // true\nNumber.isInteger(1); // true\nNumber.isInteger(-100000); // true\nNumber.isInteger(99999999999999999999999); // true\n\nNumber.isInteger(0.1); // false\nNumber.isInteger(Math.PI); // false\n\nNumber.isInteger(NaN); // false\nNumber.isInteger(Infinity); // false\nNumber.isInteger(-Infinity); // false\nNumber.isInteger("10"); // false\nNumber.isInteger(true); // false\nNumber.isInteger(false); // false\nNumber.isInteger([1]); // false\n\nNumber.isInteger(5.0); // true\nNumber.isInteger(5.000000000000001); // false\nNumber.isInteger(5.0000000000000001); // true, because of loss of precision\nNumber.isInteger(4500000000000000.1); // true, because of loss of precision\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Number.isInteger` in `core-js`](https://github.com/zloirock/core-js#ecmascript-number)\n- {{jsxref("Number")}}\n'
        },
        "isnan": {
            "index.md": '---\ntitle: Number.isNaN()\nslug: Web/JavaScript/Reference/Global_Objects/Number/isNaN\npage-type: javascript-static-method\nbrowser-compat: javascript.builtins.Number.isNaN\n---\n\n{{JSRef}}\n\nThe **`Number.isNaN()`** static method determines whether the passed value is the number value {{jsxref("NaN")}}, and returns `false` if the input is not of the Number type. It is a more robust version of the original, global {{jsxref("isNaN()")}} function.\n\n{{EmbedInteractiveExample("pages/js/number-isnan.html", "taller")}}\n\n## Syntax\n\n```js-nolint\nNumber.isNaN(value)\n```\n\n### Parameters\n\n- `value`\n  - : The value to be tested for {{jsxref("NaN")}}.\n\n### Return value\n\nThe boolean value `true` if the given value is a number with value {{jsxref("NaN")}}. Otherwise, `false`.\n\n## Description\n\nThe function `Number.isNaN()` provides a convenient way to check for equality with `NaN`. Note that you cannot test for equality with `NaN` using either the [`==`](/en-US/docs/Web/JavaScript/Reference/Operators/Equality) or [`===`](/en-US/docs/Web/JavaScript/Reference/Operators/Strict_equality) operators, because unlike all other value comparisons in JavaScript, these evaluate to `false` whenever one operand is {{jsxref("NaN")}}, even if the other operand is also {{jsxref("NaN")}}.\n\nSince `x !== x` is only true for `NaN` among all possible JavaScript values, `Number.isNaN(x)` can also be replaced with a test for `x !== x`, despite the latter being less readable.\n\nAs opposed to the global {{jsxref("isNaN()")}} function, the `Number.isNaN()` method doesn\'t force-convert the parameter to a number. This makes it safe to pass values that would normally convert to {{jsxref("NaN")}} but aren\'t actually the same value as {{jsxref("NaN")}}. This also means that only values of the Number type that are also {{jsxref("NaN")}} return `true`.\n\n## Examples\n\n### Using isNaN()\n\n```js\nNumber.isNaN(NaN); // true\nNumber.isNaN(Number.NaN); // true\nNumber.isNaN(0 / 0); // true\nNumber.isNaN(37); // false\n```\n\n### Difference between Number.isNaN() and global isNaN()\n\n`Number.isNaN()` doesn\'t attempt to convert the parameter to a number, so non-numbers always return `false`. The following are all `false`:\n\n```js\nNumber.isNaN("NaN");\nNumber.isNaN(undefined);\nNumber.isNaN({});\nNumber.isNaN("blabla");\nNumber.isNaN(true);\nNumber.isNaN(null);\nNumber.isNaN("37");\nNumber.isNaN("37.37");\nNumber.isNaN("");\nNumber.isNaN(" ");\n```\n\nThe global {{jsxref("isNaN()")}} coerces its parameter to a number:\n\n```js\nisNaN("NaN"); // true\nisNaN(undefined); // true\nisNaN({}); // true\nisNaN("blabla"); // true\nisNaN(true); // false, this is coerced to 1\nisNaN(null); // false, this is coerced to 0\nisNaN("37"); // false, this is coerced to 37\nisNaN("37.37"); // false, this is coerced to 37.37\nisNaN(""); // false, this is coerced to 0\nisNaN(" "); // false, this is coerced to 0\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Number.isNaN` in `core-js`](https://github.com/zloirock/core-js#ecmascript-number)\n- {{jsxref("Number")}}\n- {{jsxref("isNaN()")}}\n'
        },
        "issafeinteger": {
            "index.md": '---\ntitle: Number.isSafeInteger()\nslug: Web/JavaScript/Reference/Global_Objects/Number/isSafeInteger\npage-type: javascript-static-method\nbrowser-compat: javascript.builtins.Number.isSafeInteger\n---\n\n{{JSRef}}\n\nThe **`Number.isSafeInteger()`** static method determines whether the provided value is a number that is a _safe integer_.\n\n{{EmbedInteractiveExample("pages/js/number-issafeinteger.html")}}\n\n## Syntax\n\n```js-nolint\nNumber.isSafeInteger(testValue)\n```\n\n### Parameters\n\n- `testValue`\n  - : The value to be tested for being a safe integer.\n\n### Return value\n\nThe boolean value `true` if the given value is a number that is a safe integer. Otherwise `false`.\n\n## Description\n\nThe safe integers consist of all integers from -(2<sup>53</sup> - 1) to 2<sup>53</sup> - 1, inclusive (\xb19,007,199,254,740,991). A safe integer is an integer that:\n\n- can be exactly represented as an IEEE-754 double precision number, and\n- whose IEEE-754 representation cannot be the result of rounding any other integer to fit the IEEE-754 representation.\n\nFor example, 2<sup>53</sup> - 1 is a safe integer: it can be exactly represented, and no other integer rounds to it under any IEEE-754 rounding mode. In contrast, 2<sup>53</sup> is _not_ a safe integer: it can be exactly represented in IEEE-754, but the integer 2<sup>53</sup> + 1 can\'t be directly represented in IEEE-754 but instead rounds to 2<sup>53</sup> under round-to-nearest and round-to-zero rounding.\n\nHandling values larger or smaller than \\~9 quadrillion with full precision requires using an [arbitrary precision arithmetic library](https://en.wikipedia.org/wiki/Arbitrary-precision_arithmetic). See [What Every Programmer Needs to Know about Floating Point Arithmetic](https://floating-point-gui.de/) for more information on floating point representations of numbers.\n\nFor larger integers, consider using the {{jsxref("BigInt")}} type.\n\n## Examples\n\n### Using isSafeInteger()\n\n```js\nNumber.isSafeInteger(3); // true\nNumber.isSafeInteger(2 ** 53); // false\nNumber.isSafeInteger(2 ** 53 - 1); // true\nNumber.isSafeInteger(NaN); // false\nNumber.isSafeInteger(Infinity); // false\nNumber.isSafeInteger("3"); // false\nNumber.isSafeInteger(3.1); // false\nNumber.isSafeInteger(3.0); // true\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Number.isSafeInteger` in `core-js`](https://github.com/zloirock/core-js#ecmascript-number)\n- {{jsxref("Number")}}\n- {{jsxref("Number.MIN_SAFE_INTEGER")}}\n- {{jsxref("Number.MAX_SAFE_INTEGER")}}\n- {{jsxref("BigInt")}}\n'
        },
        "max_safe_integer": {
            "index.md": '---\ntitle: Number.MAX_SAFE_INTEGER\nslug: Web/JavaScript/Reference/Global_Objects/Number/MAX_SAFE_INTEGER\npage-type: javascript-static-data-property\nbrowser-compat: javascript.builtins.Number.MAX_SAFE_INTEGER\n---\n\n{{JSRef}}\n\nThe **`Number.MAX_SAFE_INTEGER`** static data property represents the maximum safe integer in JavaScript (2<sup>53</sup> \u2013 1).\n\nFor larger integers, consider using {{jsxref("BigInt")}}.\n\n{{EmbedInteractiveExample("pages/js/number-maxsafeinteger.html")}}\n\n## Value\n\n`9007199254740991` (9,007,199,254,740,991, or \\~9 quadrillion).\n\n{{js_property_attributes(0, 0, 0)}}\n\n## Description\n\n[Double precision floating point format](https://en.wikipedia.org/wiki/Double_precision_floating-point_format) only has 52 bits to represent the [mantissa](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number#number_encoding), so it can only safely represent integers between -(2<sup>53</sup> \u2013 1) and 2<sup>53</sup> \u2013 1. "Safe" in this context refers to the ability to represent integers exactly and to compare them correctly. For example, `Number.MAX_SAFE_INTEGER + 1 === Number.MAX_SAFE_INTEGER + 2` will evaluate to true, which is mathematically incorrect. See {{jsxref("Number.isSafeInteger()")}} for more information.\n\nBecause `MAX_SAFE_INTEGER` is a static property of {{jsxref("Number")}}, you always use it as `Number.MAX_SAFE_INTEGER`, rather than as a property of a number value.\n\n## Examples\n\n### Return value of MAX_SAFE_INTEGER\n\n```js\nNumber.MAX_SAFE_INTEGER; // 9007199254740991\n```\n\n### Relationship between MAX_SAFE_INTEGER and EPSILON\n\n{{jsxref("Number.EPSILON")}} is 2<sup>-52</sup>, while `MAX_SAFE_INTEGER` is 2<sup>53</sup> \u2013 1 \u2014 both of them are derived from the width of the mantissa, which is 53 bits (with the highest bit always being 1). Multiplying them will give a value very close \u2014 but not equal \u2014 to 2.\n\n```js\nNumber.MAX_SAFE_INTEGER * Number.EPSILON; // 1.9999999999999998\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Number.MAX_SAFE_INTEGER` in `core-js`](https://github.com/zloirock/core-js#ecmascript-number)\n- {{jsxref("Number.MIN_SAFE_INTEGER")}}\n- {{jsxref("Number.isSafeInteger()")}}\n- {{jsxref("BigInt")}}\n'
        },
        "max_value": {
            "index.md": '---\ntitle: Number.MAX_VALUE\nslug: Web/JavaScript/Reference/Global_Objects/Number/MAX_VALUE\npage-type: javascript-static-data-property\nbrowser-compat: javascript.builtins.Number.MAX_VALUE\n---\n\n{{JSRef}}\n\nThe **`Number.MAX_VALUE`** static data property represents the maximum numeric value representable in JavaScript.\n\n{{EmbedInteractiveExample("pages/js/number-maxvalue.html")}}\n\n## Value\n\n2<sup>1024</sup> - 2<sup>971</sup>, or approximately `1.7976931348623157E+308`.\n\n{{js_property_attributes(0, 0, 0)}}\n\n## Description\n\nValues larger than `MAX_VALUE` are represented as {{jsxref("Infinity")}} and will lose their actual value.\n\nBecause `MAX_VALUE` is a static property of {{jsxref("Number")}}, you always use it as `Number.MAX_VALUE`, rather than as a property of a number value.\n\n## Examples\n\n### Using MAX_VALUE\n\nThe following code multiplies two numeric values. If the result is less than or equal to `MAX_VALUE`, the `func1` function is called; otherwise, the `func2` function is called.\n\n```js\nif (num1 * num2 <= Number.MAX_VALUE) {\n  func1();\n} else {\n  func2();\n}\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Number.MIN_VALUE")}}\n- {{jsxref("Number")}}\n'
        },
        "min_safe_integer": {
            "index.md": '---\ntitle: Number.MIN_SAFE_INTEGER\nslug: Web/JavaScript/Reference/Global_Objects/Number/MIN_SAFE_INTEGER\npage-type: javascript-static-data-property\nbrowser-compat: javascript.builtins.Number.MIN_SAFE_INTEGER\n---\n\n{{JSRef}}\n\nThe **`Number.MIN_SAFE_INTEGER`** static data property represents the minimum safe integer in JavaScript, or -(2<sup>53</sup> - 1).\n\nTo represent integers smaller than this, consider using {{jsxref("BigInt")}}.\n\n{{EmbedInteractiveExample("pages/js/number-min-safe-integer.html")}}\n\n## Value\n\n`-9007199254740991` (-9,007,199,254,740,991, or about -9 quadrillion).\n\n{{js_property_attributes(0, 0, 0)}}\n\n## Description\n\n[Double precision floating point format](https://en.wikipedia.org/wiki/Double_precision_floating-point_format) only has 52 bits to represent the [mantissa](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number#number_encoding), so it can only safely represent integers between -(2<sup>53</sup> \u2013 1) and 2<sup>53</sup> \u2013 1. Safe in this context refers to the ability to represent integers exactly and to correctly compare them. For example, `Number.MIN_SAFE_INTEGER - 1 === Number.MIN_SAFE_INTEGER - 2` will evaluate to true, which is mathematically incorrect. See {{jsxref("Number.isSafeInteger()")}} for more information.\n\nBecause `MIN_SAFE_INTEGER` is a static property of {{jsxref("Number")}}, you always use it as `Number.MIN_SAFE_INTEGER`, rather than as a property of a number value.\n\n## Examples\n\n### Using MIN_SAFE_INTEGER\n\n```js\nNumber.MIN_SAFE_INTEGER; // -9007199254740991\n-(2 ** 53 - 1); // -9007199254740991\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Number.MIN_SAFE_INTEGER` in `core-js`](https://github.com/zloirock/core-js#ecmascript-number)\n- {{jsxref("Number.MAX_SAFE_INTEGER")}}\n- {{jsxref("Number.isSafeInteger()")}}\n- {{jsxref("BigInt")}}\n'
        },
        "min_value": {
            "index.md": '---\ntitle: Number.MIN_VALUE\nslug: Web/JavaScript/Reference/Global_Objects/Number/MIN_VALUE\npage-type: javascript-static-data-property\nbrowser-compat: javascript.builtins.Number.MIN_VALUE\n---\n\n{{JSRef}}\n\nThe **`Number.MIN_VALUE`** static data property represents the smallest positive numeric value representable in JavaScript.\n\n{{EmbedInteractiveExample("pages/js/number-min-value.html")}}\n\n## Value\n\n2<sup>-1074</sup>, or `5E-324`.\n\n{{js_property_attributes(0, 0, 0)}}\n\n## Description\n\n`Number.MIN_VALUE` is the smallest positive number (not the most negative number) that can be represented within float precision \u2014 in other words, the number closest to 0. The ECMAScript spec doesn\'t define a precise value that implementations are required to support \u2014 instead the spec says, _"must be the smallest non-zero positive value that can actually be represented by the implementation"_. This is because small IEEE-754 floating point numbers are [denormalized](https://en.wikipedia.org/wiki/Subnormal_number), but implementations are not required to support this representation, in which case `Number.MIN_VALUE` may be larger.\n\nIn practice, its precise value in mainstream engines like V8 (used by Chrome, Edge, Node.js), SpiderMonkey (used by Firefox), and JavaScriptCore (used by Safari) is 2<sup>-1074</sup>, or `5E-324`.\n\nBecause `MIN_VALUE` is a static property of {{jsxref("Number")}}, you always use it as `Number.MIN_VALUE`, rather than as a property of a number value.\n\n## Examples\n\n### Using MIN_VALUE\n\nThe following code divides two numeric values. If the result is greater than or equal to `MIN_VALUE`, the `func1` function is called; otherwise, the `func2` function is called.\n\n```js\nif (num1 / num2 >= Number.MIN_VALUE) {\n  func1();\n} else {\n  func2();\n}\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Number.MAX_VALUE")}}\n'
        },
        "nan": {
            "index.md": '---\ntitle: Number.NaN\nslug: Web/JavaScript/Reference/Global_Objects/Number/NaN\npage-type: javascript-static-data-property\nbrowser-compat: javascript.builtins.Number.NaN\n---\n\n{{JSRef}}\n\nThe **`Number.NaN`** static data property represents Not-A-Number, which is equivalent to {{jsxref("NaN")}}. For more information about the behaviors of `NaN`, see the [description for the global property](/en-US/docs/Web/JavaScript/Reference/Global_Objects/NaN).\n\n{{EmbedInteractiveExample("pages/js/number-nan.html", "taller")}}\n\n## Value\n\nThe number value {{jsxref("NaN")}}.\n\n{{js_property_attributes(0, 0, 0)}}\n\n## Description\n\nBecause `NaN` is a static property of {{jsxref("Number")}}, you always use it as `Number.NaN`, rather than as a property of a number value.\n\n## Examples\n\n### Checking whether values are numeric\n\n```js\nfunction sanitize(x) {\n  if (isNaN(x)) {\n    return Number.NaN;\n  }\n  return x;\n}\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("NaN")}}\n- {{jsxref("Number.isNaN()")}}\n'
        },
        "negative_infinity": {
            "index.md": '---\ntitle: Number.NEGATIVE_INFINITY\nslug: Web/JavaScript/Reference/Global_Objects/Number/NEGATIVE_INFINITY\npage-type: javascript-static-data-property\nbrowser-compat: javascript.builtins.Number.NEGATIVE_INFINITY\n---\n\n{{JSRef}}\n\nThe **`Number.NEGATIVE_INFINITY`** static data property represents the negative Infinity value.\n\n{{EmbedInteractiveExample("pages/js/number-negative-infinity.html")}}\n\n## Value\n\nThe same as the negative value of the global {{jsxref("Infinity")}} property.\n\n{{js_property_attributes(0, 0, 0)}}\n\n## Description\n\nThe `Number.NEGATIVE_INFINITY` value behaves slightly differently than mathematical infinity:\n\n- Any positive value, including {{jsxref("Number/POSITIVE_INFINITY", "POSITIVE_INFINITY")}}, multiplied by `NEGATIVE_INFINITY` is `NEGATIVE_INFINITY`.\n- Any negative value, including `NEGATIVE_INFINITY`, multiplied by `NEGATIVE_INFINITY` is {{jsxref("Number/POSITIVE_INFINITY", "POSITIVE_INFINITY")}}.\n- Any positive value divided by `NEGATIVE_INFINITY` is [negative zero](https://en.wikipedia.org/wiki/Signed_zero) (as defined in [IEEE 754](https://en.wikipedia.org/wiki/IEEE_754)).\n- Any negative value divided by `NEGATIVE_INFINITY` is [positive zero](https://en.wikipedia.org/wiki/Signed_zero) (as defined in [IEEE 754](https://en.wikipedia.org/wiki/IEEE_754)).\n- Zero multiplied by `NEGATIVE_INFINITY` is {{jsxref("NaN")}}.\n- {{jsxref("NaN")}} multiplied by `NEGATIVE_INFINITY` is {{jsxref("NaN")}}.\n- `NEGATIVE_INFINITY`, divided by any negative value except `NEGATIVE_INFINITY`, is {{jsxref("Number/POSITIVE_INFINITY", "POSITIVE_INFINITY")}}.\n- `NEGATIVE_INFINITY`, divided by any positive value except {{jsxref("Number/POSITIVE_INFINITY", "POSITIVE_INFINITY")}}, is `NEGATIVE_INFINITY`.\n- `NEGATIVE_INFINITY`, divided by either `NEGATIVE_INFINITY` or {{jsxref("Number/POSITIVE_INFINITY", "POSITIVE_INFINITY")}}, is {{jsxref("NaN")}}.\n- `x > Number.NEGATIVE_INFINITY` is true for any number _x_ that isn\'t `NEGATIVE_INFINITY`.\n\nYou might use the `Number.NEGATIVE_INFINITY` property to indicate an error condition that returns a finite number in case of success. Note, however, that {{jsxref("NaN")}} would be more appropriate in such a case.\n\nBecause `NEGATIVE_INFINITY` is a static property of {{jsxref("Number")}}, you always use it as `Number.NEGATIVE_INFINITY`, rather than as a property of a number value.\n\n## Examples\n\n### Using NEGATIVE_INFINITY\n\nIn the following example, the variable `smallNumber` is assigned a value that is smaller than the minimum value. When the {{jsxref("Statements/if...else", "if")}} statement executes, `smallNumber` has the value `-Infinity`, so `smallNumber` is set to a more manageable value before continuing.\n\n```js\nlet smallNumber = -Number.MAX_VALUE * 2;\n\nif (smallNumber === Number.NEGATIVE_INFINITY) {\n  smallNumber = returnFinite();\n}\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Number.POSITIVE_INFINITY")}}\n- {{jsxref("Number.isFinite()")}}\n- {{jsxref("Infinity")}}\n- {{jsxref("isFinite()")}}\n'
        },
        "number": {
            "index.md": '---\ntitle: Number() constructor\nslug: Web/JavaScript/Reference/Global_Objects/Number/Number\npage-type: javascript-constructor\nbrowser-compat: javascript.builtins.Number.Number\n---\n\n{{JSRef}}\n\nThe **`Number()`** constructor creates {{jsxref("Number")}} objects. When called as a function, it returns primitive values of type Number.\n\n## Syntax\n\n```js-nolint\nnew Number(value)\nNumber(value)\n```\n\n> **Note:** `Number()` can be called with or without [`new`](/en-US/docs/Web/JavaScript/Reference/Operators/new), but with different effects. See [Return value](#return_value).\n\n### Parameters\n\n- `value`\n  - : The numeric value of the object being created.\n\n### Return value\n\nWhen `Number` is called as a constructor (with [`new`](/en-US/docs/Web/JavaScript/Reference/Operators/new)), it creates a {{jsxref("Number")}} object, which is **not** a primitive.\n\nWhen `Number` is called as a function, it [coerces the parameter to a number primitive](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number#number_coercion). [BigInts](/en-US/docs/Web/JavaScript/Reference/Global_Objects/BigInt) are converted to numbers. If the value can\'t be converted, it returns {{jsxref("NaN")}}.\n\n> **Warning:** You should rarely find yourself using `Number` as a constructor.\n\n## Examples\n\n### Creating Number objects\n\n```js\nconst a = new Number("123"); // a === 123 is false\nconst b = Number("123"); // b === 123 is true\na instanceof Number; // is true\nb instanceof Number; // is false\ntypeof a; // "object"\ntypeof b; // "number"\n```\n\n### Using Number() to convert a BigInt to a number\n\n`Number()` is the only case where a BigInt can be converted to a number without throwing, because it\'s very explicit.\n\n```js example-bad\n+1n; // TypeError: Cannot convert a BigInt value to a number\n0 + 1n; // TypeError: Cannot mix BigInt and other types, use explicit conversions\n```\n\n```js example-good\nNumber(1n); // 1\n```\n\nNote that this may result in loss of precision, if the BigInt is too large to be [safely represented](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/isSafeInteger).\n\n```js\nBigInt(Number(2n ** 54n + 1n)) === 2n ** 54n + 1n; // false\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of modern `Number` behavior (with support binary and octal literals) in `core-js`](https://github.com/zloirock/core-js#ecmascript-number)\n- {{jsxref("NaN")}}\n- {{jsxref("Math")}}\n- {{jsxref("BigInt")}}\n'
        },
        "parsefloat": {
            "index.md": '---\ntitle: Number.parseFloat()\nslug: Web/JavaScript/Reference/Global_Objects/Number/parseFloat\npage-type: javascript-static-method\nbrowser-compat: javascript.builtins.Number.parseFloat\n---\n\n{{JSRef}}\n\nThe **`Number.parseFloat()`** static method parses an argument and returns a floating point number. If a number cannot be parsed from the argument, it returns {{jsxref("NaN")}}.\n\n{{EmbedInteractiveExample("pages/js/number-parsefloat.html")}}\n\n## Syntax\n\n```js-nolint\nNumber.parseFloat(string)\n```\n\n### Parameters\n\n- `string`\n  - : The value to parse, [coerced to a string](/en-US/docs/Web/JavaScript/Reference/Global_Objects/String#string_coercion). Leading {{Glossary("whitespace")}} in this argument is ignored.\n\n### Return value\n\nA floating point number parsed from the given `string`.\n\nOr {{jsxref("NaN")}} when the first non-whitespace character cannot be converted to a number.\n\n## Examples\n\n### Number.parseFloat vs. parseFloat\n\nThis method has the same functionality as the global {{jsxref("parseFloat()")}} function:\n\n```js\nNumber.parseFloat === parseFloat; // true\n```\n\nIts purpose is modularization of globals.\n\nSee {{jsxref("parseFloat()")}} for more detail and examples.\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Number.parseFloat` in `core-js`](https://github.com/zloirock/core-js#ecmascript-number)\n- {{jsxref("Number")}}\n- {{jsxref("parseFloat()")}}\n'
        },
        "parseint": {
            "index.md": '---\ntitle: Number.parseInt()\nslug: Web/JavaScript/Reference/Global_Objects/Number/parseInt\npage-type: javascript-static-method\nbrowser-compat: javascript.builtins.Number.parseInt\n---\n\n{{JSRef}}\n\nThe **`Number.parseInt()`** static method parses a string argument and\nreturns an integer of the specified radix or base.\n\n{{EmbedInteractiveExample("pages/js/number-parseint.html", "taller")}}\n\n## Syntax\n\n```js-nolint\nNumber.parseInt(string)\nNumber.parseInt(string, radix)\n```\n\n### Parameters\n\n- `string`\n  - : The value to parse, [coerced to a string](/en-US/docs/Web/JavaScript/Reference/Global_Objects/String#string_coercion). Leading whitespace in this argument is ignored.\n- `radix` {{optional_inline}}\n\n  - : An integer between `2` and `36` that represents the\n    _radix_ (the base in mathematical numeral systems) of the\n    `string`.\n\n    If `radix` is undefined or `0`, it is assumed to be `10` except when the number begins with the code unit pairs `0x` or `0X`, in which case a radix of `16` is assumed.\n\n### Return value\n\nAn integer parsed from the given `string`.\n\nIf the `radix` is smaller than `2` or bigger than\n`36`, or the first non-whitespace character cannot be converted to a number,\n{{jsxref("NaN")}} is returned.\n\n## Examples\n\n### Number.parseInt vs. parseInt\n\nThis method has the same functionality as the global {{jsxref("parseInt()")}} function:\n\n```js\nNumber.parseInt === parseInt; // true\n```\n\nIts purpose is modularization of globals. Please see\n{{jsxref("parseInt()")}} for more detail and examples.\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Number.parseInt` in `core-js`](https://github.com/zloirock/core-js#ecmascript-number)\n- {{jsxref("Number")}}\n- {{jsxref("parseInt()")}}\n'
        },
        "positive_infinity": {
            "index.md": '---\ntitle: Number.POSITIVE_INFINITY\nslug: Web/JavaScript/Reference/Global_Objects/Number/POSITIVE_INFINITY\npage-type: javascript-static-data-property\nbrowser-compat: javascript.builtins.Number.POSITIVE_INFINITY\n---\n\n{{JSRef}}\n\nThe **`Number.POSITIVE_INFINITY`** static data property represents the positive Infinity value.\n\n{{EmbedInteractiveExample("pages/js/number-positive-infinity.html")}}\n\n## Value\n\nThe same as the value of the global {{jsxref("Infinity")}} property.\n\n{{js_property_attributes(0, 0, 0)}}\n\n## Description\n\nThe `Number.POSITIVE_INFINITY` value behaves slightly differently than mathematical infinity:\n\n- Any positive value, including `POSITIVE_INFINITY`, multiplied by `POSITIVE_INFINITY` is `POSITIVE_INFINITY`.\n- Any negative value, including {{jsxref("Number/NEGATIVE_INFINITY", "NEGATIVE_INFINITY")}}, multiplied by `POSITIVE_INFINITY` is {{jsxref("Number/NEGATIVE_INFINITY", "NEGATIVE_INFINITY")}}.\n- Any positive number divided by `POSITIVE_INFINITY` is [positive zero](https://en.wikipedia.org/wiki/Signed_zero) (as defined in [IEEE 754](https://en.wikipedia.org/wiki/IEEE_754)).\n- Any negative number divided by `POSITIVE_INFINITY` is [negative zero](https://en.wikipedia.org/wiki/Signed_zero) (as defined in [IEEE 754](https://en.wikipedia.org/wiki/IEEE_754).\n- Zero multiplied by `POSITIVE_INFINITY` is {{jsxref("NaN")}}.\n- {{jsxref("NaN")}} multiplied by `POSITIVE_INFINITY` is {{jsxref("NaN")}}.\n- `POSITIVE_INFINITY`, divided by any negative value except {{jsxref("Number/NEGATIVE_INFINITY", "NEGATIVE_INFINITY")}}, is {{jsxref("Number/NEGATIVE_INFINITY", "NEGATIVE_INFINITY")}}.\n- `POSITIVE_INFINITY`, divided by any positive value except `POSITIVE_INFINITY`, is `POSITIVE_INFINITY`.\n- `POSITIVE_INFINITY`, divided by either {{jsxref("Number/NEGATIVE_INFINITY", "NEGATIVE_INFINITY")}} or `POSITIVE_INFINITY`, is {{jsxref("NaN")}}.\n- `Number.POSITIVE_INFINITY > x` is true for any number _x_ that isn\'t `POSITIVE_INFINITY`.\n\nYou might use the `Number.POSITIVE_INFINITY` property to indicate an error condition that returns a finite number in case of success. Note, however, that {{jsxref("NaN")}} would be more appropriate in such a case.\n\nBecause `POSITIVE_INFINITY` is a static property of {{jsxref("Number")}}, you always use it as `Number.POSITIVE_INFINITY`, rather than as a property of a number value.\n\n## Examples\n\n### Using POSITIVE_INFINITY\n\nIn the following example, the variable `bigNumber` is assigned a value that is larger than the maximum value. When the {{jsxref("Statements/if...else", "if")}} statement executes, `bigNumber` has the value `Infinity`, so `bigNumber` is set to a more manageable value before continuing.\n\n```js\nlet bigNumber = Number.MAX_VALUE * 2;\n\nif (bigNumber === Number.POSITIVE_INFINITY) {\n  bigNumber = returnFinite();\n}\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Number.NEGATIVE_INFINITY")}}\n- {{jsxref("Number.isFinite()")}}\n- {{jsxref("Infinity")}}\n- {{jsxref("isFinite()")}}\n'
        },
        "toexponential": {
            "index.md": '---\ntitle: Number.prototype.toExponential()\nslug: Web/JavaScript/Reference/Global_Objects/Number/toExponential\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Number.toExponential\n---\n\n{{JSRef}}\n\nThe **`toExponential()`** method of {{jsxref("Number")}} values returns a string representing\nthis number in exponential notation.\n\n{{EmbedInteractiveExample("pages/js/number-toexponential.html")}}\n\n## Syntax\n\n```js-nolint\ntoExponential()\ntoExponential(fractionDigits)\n```\n\n### Parameters\n\n- `fractionDigits` {{optional_inline}}\n  - : Optional. An integer specifying the number of digits after the decimal point.\n    Defaults to as many digits as necessary to specify the number.\n\n### Return value\n\nA string representing the given {{jsxref("Number")}} object in exponential notation\nwith one digit before the decimal point, rounded to\n`fractionDigits` digits after the decimal point.\n\n### Exceptions\n\n- {{jsxref("RangeError")}}\n  - : Thrown if `fractionDigits` is not between `0` and `100` (inclusive).\n- {{jsxref("TypeError")}}\n  - : Thrown if this method is invoked on an object that is not a {{jsxref("Number")}}.\n\n## Description\n\nIf the `fractionDigits` argument is omitted, the number of digits\nafter the decimal point defaults to the number of digits necessary to represent the\nvalue uniquely.\n\nIf you use the `toExponential()` method for a numeric literal and the\nnumeric literal has no exponent and no decimal point, leave whitespace(s) before the dot\nthat precedes the method call to prevent the dot from being interpreted as a decimal\npoint.\n\nIf a number has more digits than requested by the\n`fractionDigits` parameter, the number is rounded to the nearest\nnumber represented by `fractionDigits` digits. See the discussion\nof rounding in the description of the {{jsxref("Number/toFixed", "toFixed()")}} method, which also applies to `toExponential()`.\n\n## Examples\n\n### Using toExponential\n\n```js\nconst numObj = 77.1234;\n\nconsole.log(numObj.toExponential()); // 7.71234e+1\nconsole.log(numObj.toExponential(4)); // 7.7123e+1\nconsole.log(numObj.toExponential(2)); // 7.71e+1\nconsole.log((77.1234).toExponential()); // 7.71234e+1\nconsole.log((77).toExponential()); // 7.7e+1\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Number.prototype.toExponential` with many bug fixes in `core-js`](https://github.com/zloirock/core-js#ecmascript-number)\n- {{jsxref("Number.prototype.toFixed()")}}\n- {{jsxref("Number.prototype.toPrecision()")}}\n- {{jsxref("Number.prototype.toString()")}}\n'
        },
        "tofixed": {
            "index.md": "---\ntitle: Number.prototype.toFixed()\nslug: Web/JavaScript/Reference/Global_Objects/Number/toFixed\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Number.toFixed\n---\n\n{{JSRef}}\n\nThe **`toFixed()`** method of {{jsxref(\"Number\")}} values formats this number using [fixed-point notation](https://en.wikipedia.org/wiki/Fixed-point_arithmetic).\n\n{{EmbedInteractiveExample(\"pages/js/number-tofixed.html\")}}\n\n## Syntax\n\n```js-nolint\ntoFixed()\ntoFixed(digits)\n```\n\n### Parameters\n\n- `digits` {{optional_inline}}\n  - : The number of digits to appear after the decimal point; should be a value between `0` and `100`, inclusive. If this argument is omitted, it is treated as `0`.\n\n### Return value\n\nA string representing the given number using fixed-point notation.\n\n### Exceptions\n\n- {{jsxref(\"RangeError\")}}\n  - : Thrown if `digits` is not between `0` and `100` (inclusive).\n- {{jsxref(\"TypeError\")}}\n  - : Thrown if this method is invoked on an object that is not a {{jsxref(\"Number\")}}.\n\n## Description\n\nThe `toFixed()` method returns a string representation of a number without using [exponential notation](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/toExponential) and with exactly `digits` digits after the decimal point. The number is rounded if necessary, and the fractional part is padded with zeros if necessary so that it has the specified length.\n\nIf the absolute value of the number is greater or equal to 10<sup>21</sup>, this method uses the same algorithm as {{jsxref(\"Number.prototype.toString()\")}} and returns a string in exponential notation. `toFixed()` returns `\"Infinity\"`, `\"NaN\"`, or `\"-Infinity\"` if the value of the number is non-finite.\n\nThe output of `toFixed()` may be more precise than [`toString()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/toString) for some values, because `toString()` only prints enough significant digits to distinguish the number from adjacent number values. For example:\n\n```js\n(1000000000000000128).toString(); // '1000000000000000100'\n(1000000000000000128).toFixed(0); // '1000000000000000128'\n```\n\nHowever, choosing a `digits` precision that's too high can return unexpected results, because decimal fractional numbers cannot be represented precisely in floating point. For example:\n\n```js\n(0.3).toFixed(50); // '0.29999999999999998889776975374843459576368331909180'\n```\n\n## Examples\n\n### Using toFixed()\n\n```js\nconst numObj = 12345.6789;\n\nnumObj.toFixed(); // '12346'; rounding, no fractional part\nnumObj.toFixed(1); // '12345.7'; it rounds up\nnumObj.toFixed(6); // '12345.678900'; additional zeros\n(1.23e20).toFixed(2); // '123000000000000000000.00'\n(1.23e-10).toFixed(2); // '0.00'\n(2.34).toFixed(1); // '2.3'\n(2.35).toFixed(1); // '2.4'; it rounds up\n(2.55).toFixed(1); // '2.5'\n// it rounds down as it can't be represented exactly by a float and the\n// closest representable float is lower\n(2.449999999999999999).toFixed(1); // '2.5'\n// it rounds up as it's less than Number.EPSILON away from 2.45.\n// This literal actually encodes the same number value as 2.45\n\n(6.02 * 10 ** 23).toFixed(50); // 6.019999999999999e+23; large numbers still use exponential notation\n```\n\n### Using toFixed() with negative numbers\n\nBecause member access has higher [precedence](/en-US/docs/Web/JavaScript/Reference/Operators/Operator_precedence) than unary minus, you need to group the negative number expression to get a string.\n\n```js-nolint\n-2.34.toFixed(1); // -2.3, a number\n(-2.34).toFixed(1); // '-2.3'\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref(\"Number.prototype.toExponential()\")}}\n- {{jsxref(\"Number.prototype.toPrecision()\")}}\n- {{jsxref(\"Number.prototype.toString()\")}}\n- {{jsxref(\"Number.EPSILON\")}}\n"
        },
        "tolocalestring": {
            "index.md": '---\ntitle: Number.prototype.toLocaleString()\nslug: Web/JavaScript/Reference/Global_Objects/Number/toLocaleString\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Number.toLocaleString\n---\n\n{{JSRef}}\n\nThe **`toLocaleString()`** method of {{jsxref("Number")}} values returns a string with a language-sensitive representation of this number. In implementations with [`Intl.NumberFormat` API](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat) support, this method simply calls `Intl.NumberFormat`.\n\nEvery time `toLocaleString` is called, it has to perform a search in a big database of localization strings, which is potentially inefficient. When the method is called many times with the same arguments, it is better to create a {{jsxref("Intl.NumberFormat")}} object and use its {{jsxref("Intl/NumberFormat/format", "format()")}} method, because a `NumberFormat` object remembers the arguments passed to it and may decide to cache a slice of the database, so future `format` calls can search for localization strings within a more constrained context.\n\n{{EmbedInteractiveExample("pages/js/number-tolocalestring.html")}}\n\n## Syntax\n\n```js-nolint\ntoLocaleString()\ntoLocaleString(locales)\ntoLocaleString(locales, options)\n```\n\n### Parameters\n\nThe `locales` and `options` parameters customize the behavior of the function and let applications specify the language whose formatting conventions should be used.\n\nIn implementations that support the [`Intl.NumberFormat` API](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat), these parameters correspond exactly to the [`Intl.NumberFormat()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/NumberFormat) constructor\'s parameters. Implementations without `Intl.NumberFormat` support are asked to ignore both parameters, making the locale used and the form of the string returned entirely implementation-dependent.\n\n- `locales` {{optional_inline}}\n\n  - : A string with a BCP 47 language tag, or an array of such strings. Corresponds to the [`locales`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/NumberFormat#locales) parameter of the `Intl.NumberFormat()` constructor.\n\n    In implementations without `Intl.NumberFormat` support, this parameter is ignored and the host\'s locale is usually used.\n\n- `options` {{optional_inline}}\n\n  - : An object adjusting the output format. Corresponds to the [`options`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/NumberFormat#options) parameter of the `Intl.NumberFormat()` constructor.\n\n    In implementations without `Intl.NumberFormat` support, this parameter is ignored.\n\nSee the [`Intl.NumberFormat()` constructor](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/NumberFormat) for details on these parameters and how to use them.\n\n### Return value\n\nA string representing the given number according to language-specific conventions.\n\nIn implementations with `Intl.NumberFormat`, this is equivalent to `new Intl.NumberFormat(locales, options).format(number)`.\n\n> **Note:** Most of the time, the formatting returned by `toLocaleString()` is consistent. However, the output may vary with time, language, and implementation \u2014 output variations are by design and allowed by the specification. You should not compare the results of `toLocaleString()` to static values.\n\n## Examples\n\n### Using toLocaleString()\n\nBasic use of this method without specifying a `locale` returns a formatted string in the default locale and with default options.\n\n```js\nconst number = 3500;\n\nconsole.log(number.toLocaleString()); // "3,500" if in U.S. English locale\n```\n\n### Checking for support for locales and options parameters\n\nThe `locales` and `options` parameters may not be supported in all implementations, because support for the internationalization API is optional, and some systems may not have the necessary data. For implementations without internationalization support, `toLocaleString()` always uses the system\'s locale, which may not be what you want. Because any implementation that supports the `locales` and `options` parameters must support the {{jsxref("Intl")}} API, you can check the existence of the latter for support:\n\n```js\nfunction toLocaleStringSupportsLocales() {\n  return (\n    typeof Intl === "object" &&\n    !!Intl &&\n    typeof Intl.NumberFormat === "function"\n  );\n}\n```\n\n### Using locales\n\nThis example shows some of the variations in localized number formats. In order to get\nthe format of the language used in the user interface of your application, make sure to\nspecify that language (and possibly some fallback languages) using the\n`locales` argument:\n\n```js\nconst number = 123456.789;\n\n// German uses comma as decimal separator and period for thousands\nconsole.log(number.toLocaleString("de-DE"));\n// 123.456,789\n\n// Arabic in most Arabic speaking countries uses Eastern Arabic digits\nconsole.log(number.toLocaleString("ar-EG"));\n// \u0661\u0662\u0663\u0664\u0665\u0666\u066B\u0667\u0668\u0669\n\n// India uses thousands/lakh/crore separators\nconsole.log(number.toLocaleString("en-IN"));\n// 1,23,456.789\n\n// the nu extension key requests a numbering system, e.g. Chinese decimal\nconsole.log(number.toLocaleString("zh-Hans-CN-u-nu-hanidec"));\n// \u4E00\u4E8C\u4E09,\u56DB\u4E94\u516D.\u4E03\u516B\u4E5D\n\n// when requesting a language that may not be supported, such as\n// Balinese, include a fallback language, in this case Indonesian\nconsole.log(number.toLocaleString(["ban", "id"]));\n// 123.456,789\n```\n\n### Using options\n\nThe results provided by `toLocaleString()` can be customized using the `options` parameter:\n\n```js\nconst number = 123456.789;\n\n// request a currency format\nconsole.log(\n  number.toLocaleString("de-DE", { style: "currency", currency: "EUR" }),\n);\n// 123.456,79 \u20AC\n\n// the Japanese yen doesn\'t use a minor unit\nconsole.log(\n  number.toLocaleString("ja-JP", { style: "currency", currency: "JPY" }),\n);\n// \uFFE5123,457\n\n// limit to three significant digits\nconsole.log(number.toLocaleString("en-IN", { maximumSignificantDigits: 3 }));\n// 1,23,000\n\n// Use the host default language with options for number formatting\nconst num = 30000.65;\nconsole.log(\n  num.toLocaleString(undefined, {\n    minimumFractionDigits: 2,\n    maximumFractionDigits: 2,\n  }),\n);\n// "30,000.65" where English is the default language, or\n// "30.000,65" where German is the default language, or\n// "30 000,65" where French is the default language\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Intl.NumberFormat")}}\n- {{jsxref("Number.prototype.toString()")}}\n'
        },
        "toprecision": {
            "index.md": "---\ntitle: Number.prototype.toPrecision()\nslug: Web/JavaScript/Reference/Global_Objects/Number/toPrecision\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Number.toPrecision\n---\n\n{{JSRef}}\n\nThe **`toPrecision()`** method of {{jsxref(\"Number\")}} values returns a string representing\nthis number to the specified precision.\n\n{{EmbedInteractiveExample(\"pages/js/number-toprecision.html\")}}\n\n## Syntax\n\n```js-nolint\ntoPrecision()\ntoPrecision(precision)\n```\n\n### Parameters\n\n- `precision` {{optional_inline}}\n  - : An integer specifying the number of significant digits.\n\n### Return value\n\nA string representing a {{jsxref(\"Number\")}} object in fixed-point or exponential\nnotation rounded to `precision` significant digits. See the discussion of\nrounding in the description of the {{jsxref(\"Number.prototype.toFixed()\")}} method,\nwhich also applies to `toPrecision()`.\n\nIf the `precision` argument is omitted, behaves as\n{{jsxref(\"Number.prototype.toString()\")}}. If the `precision` argument is a\nnon-integer value, it is rounded to the nearest integer.\n\n### Exceptions\n\n- {{jsxref(\"RangeError\")}}\n  - : Thrown if `precision` is not between `1` and `100` (inclusive).\n\n## Examples\n\n### Using `toPrecision`\n\n```js\nlet num = 5.123456;\n\nconsole.log(num.toPrecision()); // '5.123456'\nconsole.log(num.toPrecision(5)); // '5.1235'\nconsole.log(num.toPrecision(2)); // '5.1'\nconsole.log(num.toPrecision(1)); // '5'\n\nnum = 0.000123;\n\nconsole.log(num.toPrecision()); // '0.000123'\nconsole.log(num.toPrecision(5)); // '0.00012300'\nconsole.log(num.toPrecision(2)); // '0.00012'\nconsole.log(num.toPrecision(1)); // '0.0001'\n\n// note that exponential notation might be returned in some circumstances\nconsole.log((1234.5).toPrecision(2)); // '1.2e+3'\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref(\"Number.prototype.toFixed()\")}}\n- {{jsxref(\"Number.prototype.toExponential()\")}}\n- {{jsxref(\"Number.prototype.toString()\")}}\n"
        },
        "tostring": {
            "index.md": '---\ntitle: Number.prototype.toString()\nslug: Web/JavaScript/Reference/Global_Objects/Number/toString\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Number.toString\n---\n\n{{JSRef}}\n\nThe **`toString()`** method of {{jsxref("Number")}} values returns a string representing this number value.\n\n{{EmbedInteractiveExample("pages/js/number-tostring.html")}}\n\n## Syntax\n\n```js-nolint\ntoString()\ntoString(radix)\n```\n\n### Parameters\n\n- `radix` {{optional_inline}}\n  - : An integer in the range `2` through `36` specifying the base to use for representing the number value. Defaults to 10.\n\n### Return value\n\nA string representing the specified number value.\n\n### Exceptions\n\n- {{jsxref("RangeError")}}\n  - : Thrown if `radix` is less than 2 or greater than 36.\n\n## Description\n\nThe {{jsxref("Number")}} object overrides the `toString` method of {{jsxref("Object")}}; it does not inherit\n{{jsxref("Object.prototype.toString()")}}. For `Number` values, the `toString` method returns a string representation of the value in the specified radix.\n\nFor radixes above 10, the letters of the alphabet indicate digits greater than 9. For example, for hexadecimal numbers (base 16) `a` through `f` are used.\n\nIf the specified number value is negative, the sign is preserved. This is the case even if the radix is 2; the string returned is the positive binary representation of the number value preceded by a `-` sign, **not** the two\'s complement of the number value.\n\nBoth `0` and `-0` have `"0"` as their string representation. {{jsxref("Infinity")}} returns `"Infinity"` and {{jsxref("NaN")}} returns `"NaN"`.\n\nIf the number is not a whole number, the decimal point `.` is used to separate the decimal places. [Scientific notation](/en-US/docs/Web/JavaScript/Reference/Lexical_grammar#exponential) is used if the radix is 10 and the number\'s magnitude (ignoring sign) is greater than or equal to 10<sup>21</sup> or less than 10<sup>-6</sup>. In this case, the returned string always explicitly specifies the sign of the exponent.\n\n```js\nconsole.log((10 ** 21.5).toString()); // "3.1622776601683794e+21"\nconsole.log((10 ** 21.5).toString(8)); // "526665530627250154000000"\n```\n\nThe `toString()` method requires its `this` value to be a `Number` primitive or wrapper object. It throws a {{jsxref("TypeError")}} for other `this` values without attempting to coerce them to number values.\n\nBecause `Number` doesn\'t have a [`[@@toPrimitive]()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol/toPrimitive) method, JavaScript calls the `toString()` method automatically when a `Number` _object_ is used in a context expecting a string, such as in a [template literal](/en-US/docs/Web/JavaScript/Reference/Template_literals). However, Number _primitive_ values do not consult the `toString()` method to be [coerced to strings](/en-US/docs/Web/JavaScript/Reference/Global_Objects/String#string_coercion) \u2014 rather, they are directly converted using the same algorithm as the initial `toString()` implementation.\n\n```js\nNumber.prototype.toString = () => "Overridden";\nconsole.log(`${1}`); // "1"\nconsole.log(`${new Number(1)}`); // "Overridden"\n```\n\n## Examples\n\n### Using toString()\n\n```js\nconst count = 10;\nconsole.log(count.toString()); // "10"\n\nconsole.log((17).toString()); // "17"\nconsole.log((17.2).toString()); // "17.2"\n\nconst x = 6;\nconsole.log(x.toString(2)); // "110"\nconsole.log((254).toString(16)); // "fe"\nconsole.log((-10).toString(2)); // "-1010"\nconsole.log((-0xff).toString(2)); // "-11111111"\n```\n\n### Converting radix of number strings\n\nIf you have a string representing a number in a non-decimal radix, you can use [`parseInt()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/parseInt) and `toString()` to convert it to a different radix.\n\n```js\nconst hex = "CAFEBABE";\nconst bin = parseInt(hex, 16).toString(2); // "11001010111111101011101010111110"\n```\n\nBeware of loss of precision: if the original number string is too large (larger than [`Number.MAX_SAFE_INTEGER`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/MAX_SAFE_INTEGER), for example), you should use a [`BigInt`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/BigInt/BigInt) instead. However, the `BigInt` constructor only has support for strings representing number literals (i.e. strings starting with `0b`, `0o`, `0x`). In case your original radix is not one of binary, octal, decimal, or hexadecimal, you may need to hand-write your radix converter, or use a library.\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Number.prototype.toFixed()")}}\n- {{jsxref("Number.prototype.toExponential()")}}\n- {{jsxref("Number.prototype.toPrecision()")}}\n'
        },
        "valueof": {
            "index.md": '---\ntitle: Number.prototype.valueOf()\nslug: Web/JavaScript/Reference/Global_Objects/Number/valueOf\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Number.valueOf\n---\n\n{{JSRef}}\n\nThe **`valueOf()`** method of {{jsxref("Number")}} values returns the value of this number.\n\n{{EmbedInteractiveExample("pages/js/number-valueof.html")}}\n\n## Syntax\n\n```js-nolint\nvalueOf()\n```\n\n### Parameters\n\nNone.\n\n### Return value\n\nA number representing the primitive value of the specified {{jsxref("Number")}} object.\n\n## Description\n\nThis method is usually called internally by JavaScript and not explicitly in web code.\n\n## Examples\n\n### Using valueOf\n\n```js\nconst numObj = new Number(10);\nconsole.log(typeof numObj); // object\n\nconst num = numObj.valueOf();\nconsole.log(num); // 10\nconsole.log(typeof num); // number\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Object.prototype.valueOf()")}}\n'
        }
    },
    "object": {
        "__definegetter__": {
            "index.md": '---\ntitle: Object.prototype.__defineGetter__()\nslug: Web/JavaScript/Reference/Global_Objects/Object/__defineGetter__\npage-type: javascript-instance-method\nstatus:\n  - deprecated\nbrowser-compat: javascript.builtins.Object.defineGetter\n---\n\n{{JSRef}}{{Deprecated_Header}}\n\n> **Note:** This feature is deprecated in favor of defining [getters](/en-US/docs/Web/JavaScript/Reference/Functions/get) using the [object initializer syntax](/en-US/docs/Web/JavaScript/Reference/Operators/Object_initializer) or the {{jsxref("Object.defineProperty()")}} API. This method\'s behavior is only specified for web compatibility, and is not required to be implemented in any platform. It may not work everywhere.\n\nThe **`__defineGetter__()`** method of {{jsxref("Object")}} instances binds an object\'s property to a function to be called when that property is looked up.\n\n## Syntax\n\n```js-nolint\n__defineGetter__(prop, func)\n```\n\n### Parameters\n\n- `prop`\n  - : A string containing the name of the property that the getter `func` is bound to.\n- `func`\n  - : A function to be bound to a lookup of the specified property.\n\n### Return value\n\nNone ({{jsxref("undefined")}}).\n\n### Exceptions\n\n- {{jsxref("TypeError")}}\n  - : Thrown if `func` is not a function.\n\n## Description\n\nAll objects that inherit from `Object.prototype` (that is, all except [`null`-prototype objects](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object#null-prototype_objects)) inherit the `__defineGetter__()` method. This method allows a [getter](/en-US/docs/Web/JavaScript/Reference/Functions/get) to be defined on a pre-existing object. This is equivalent to [`Object.defineProperty(obj, prop, { get: func, configurable: true, enumerable: true })`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/defineProperty), which means the property is enumerable and configurable, and any existing setter, if present, is preserved.\n\n`__defineGetter__()` is defined in the spec as "normative optional", which means no implementation is required to implement this. However, all major browsers implement it, and due to its continued usage, it\'s unlikely to be removed. If a browser implements `__defineGetter__()`, it also needs to implement the [`__lookupGetter__()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/__lookupGetter__), [`__lookupSetter__()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/__lookupSetter__), and [`__defineSetter__()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/__defineSetter__) methods.\n\n## Examples\n\n### Using \\_\\_defineGetter\\_\\_()\n\n```js\nconst o = {};\no.__defineGetter__("gimmeFive", function () {\n  return 5;\n});\nconsole.log(o.gimmeFive); // 5\n```\n\n### Defining a getter property in standard ways\n\nYou can use the `get` syntax to define a getter when the object is first initialized.\n\n```js\nconst o = {\n  get gimmeFive() {\n    return 5;\n  },\n};\nconsole.log(o.gimmeFive); // 5\n```\n\nYou may also use {{jsxref("Object.defineProperty()")}} to define a getter on an object after it\'s been created. Compared to `__defineGetter__()`, this method allows you to control the getter\'s enumerability and configurability, as well as defining [symbol](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol) properties. The `Object.defineProperty()` method also works with [`null`-prototype objects](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object#null-prototype_objects), which don\'t inherit from `Object.prototype` and therefore don\'t have the `__defineGetter__()` method.\n\n```js\nconst o = {};\nObject.defineProperty(o, "gimmeFive", {\n  get() {\n    return 5;\n  },\n  configurable: true,\n  enumerable: true,\n});\nconsole.log(o.gimmeFive); // 5\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Object.prototype.__defineGetter__` in `core-js`](https://github.com/zloirock/core-js#ecmascript-object)\n- [`Object.prototype.__defineSetter__()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/__defineSetter__)\n- {{jsxref("Functions/get", "get")}}\n- {{jsxref("Object.defineProperty()")}}\n- [`Object.prototype.__lookupGetter__()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/__lookupGetter__)\n- [`Object.prototype.__lookupSetter__()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/__lookupSetter__)\n- [JS Guide: Defining Getters and Setters](/en-US/docs/Web/JavaScript/Guide/Working_with_objects#defining_getters_and_setters)\n- [Firefox bug 647423](https://bugzil.la/647423)\n'
        },
        "__definesetter__": {
            "index.md": '---\ntitle: Object.prototype.__defineSetter__()\nslug: Web/JavaScript/Reference/Global_Objects/Object/__defineSetter__\npage-type: javascript-instance-method\nstatus:\n  - deprecated\nbrowser-compat: javascript.builtins.Object.defineSetter\n---\n\n{{JSRef}}{{Deprecated_Header}}\n\n> **Note:** This feature is deprecated in favor of defining [setters](/en-US/docs/Web/JavaScript/Reference/Functions/set) using the [object initializer syntax](/en-US/docs/Web/JavaScript/Reference/Operators/Object_initializer) or the {{jsxref("Object.defineProperty()")}} API. This method\'s behavior is only specified for web compatibility, and is not required to be implemented in any platform. It may not work everywhere.\n\nThe **`__defineSetter__()`** method of {{jsxref("Object")}} instances binds an object\'s property to a function to be called when an attempt is made to set that property.\n\n## Syntax\n\n```js-nolint\n__defineSetter__(prop, func)\n```\n\n### Parameters\n\n- `prop`\n  - : A string containing the name of the property that the setter `func` is bound to.\n- `func`\n  - : A function to be called when there is an attempt to set the specified property. This function receives the following parameter:\n    - `val`\n      - : The value attempted to be assigned to `prop`.\n\n### Return value\n\nNone ({{jsxref("undefined")}}).\n\n### Exceptions\n\n- {{jsxref("TypeError")}}\n  - : Thrown if `func` is not a function.\n\n## Description\n\nAll objects that inherit from `Object.prototype` (that is, all except [`null`-prototype objects](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object#null-prototype_objects)) inherit the `__defineSetter__()` method. This method allows a [setter](/en-US/docs/Web/JavaScript/Reference/Functions/set) to be defined on a pre-existing object. This is equivalent to [`Object.defineProperty(obj, prop, { set: func, configurable: true, enumerable: true })`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/defineProperty), which means the property is enumerable and configurable, and any existing getter, if present, is preserved.\n\n`__defineSetter__()` is defined in the spec as "normative optional", which means no implementation is required to implement this. However, all major browsers implement it, and due to its continued usage, it\'s unlikely to be removed. If a browser implements `__defineSetter__()`, it also needs to implement the [`__lookupGetter__()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/__lookupGetter__), [`__lookupSetter__()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/__lookupSetter__), and [`__defineGetter__()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/__defineGetter__) methods.\n\n## Examples\n\n### Using \\_\\_defineSetter\\_\\_()\n\n```js\nconst o = {};\no.__defineSetter__("value", function (val) {\n  this.anotherValue = val;\n});\no.value = 5;\nconsole.log(o.value); // undefined\nconsole.log(o.anotherValue); // 5\n```\n\n### Defining a setter property in standard ways\n\nYou can use the `set` syntax to define a setter when the object is first initialized.\n\n```js\nconst o = {\n  set value(val) {\n    this.anotherValue = val;\n  },\n};\no.value = 5;\nconsole.log(o.value); // undefined\nconsole.log(o.anotherValue); // 5\n```\n\nYou may also use {{jsxref("Object.defineProperty()")}} to define a setter on an object after it\'s been created. Compared to `__defineSetter__()`, this method allows you to control the setter\'s enumerability and configurability, as well as defining [symbol](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol) properties. The `Object.defineProperty()` method also works with [`null`-prototype objects](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object#null-prototype_objects), which don\'t inherit from `Object.prototype` and therefore don\'t have the `__defineSetter__()` method.\n\n```js\nconst o = {};\nObject.defineProperty(o, "value", {\n  set(val) {\n    this.anotherValue = val;\n  },\n  configurable: true,\n  enumerable: true,\n});\no.value = 5;\nconsole.log(o.value); // undefined\nconsole.log(o.anotherValue); // 5\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Object.prototype.__defineSetter__` in `core-js`](https://github.com/zloirock/core-js#ecmascript-object)\n- [`Object.prototype.__defineGetter__()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/__defineGetter__)\n- {{jsxref("Functions/set", "set")}}\n- {{jsxref("Object.defineProperty()")}}\n- [`Object.prototype.__lookupGetter__()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/__lookupGetter__)\n- [`Object.prototype.__lookupSetter__()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/__lookupSetter__)\n- [JS Guide: Defining Getters and Setters](/en-US/docs/Web/JavaScript/Guide/Working_with_objects#defining_getters_and_setters)\n- [Firefox bug 647423](https://bugzil.la/647423)\n'
        },
        "__lookupgetter__": {
            "index.md": '---\ntitle: Object.prototype.__lookupGetter__()\nslug: Web/JavaScript/Reference/Global_Objects/Object/__lookupGetter__\npage-type: javascript-instance-method\nstatus:\n  - deprecated\nbrowser-compat: javascript.builtins.Object.lookupGetter\n---\n\n{{JSRef}} {{Deprecated_Header}}\n\n> **Note:** This feature is deprecated in favor of the {{jsxref("Object.getOwnPropertyDescriptor()")}} API. This method\'s behavior is only specified for web compatibility, and is not required to be implemented in any platform. It may not work everywhere.\n\nThe **`__lookupGetter__()`** method of {{jsxref("Object")}} instances returns the function bound as a getter to the specified property.\n\n## Syntax\n\n```js-nolint\n__lookupGetter__(prop)\n```\n\n### Parameters\n\n- `prop`\n  - : A string containing the name of the property whose getter should be returned.\n\n### Return value\n\nThe function bound as a getter to the specified property. Returns `undefined` if no such property is found, or the property is a [data property](/en-US/docs/Web/JavaScript/Data_structures#data_property).\n\n## Description\n\nAll objects that inherit from `Object.prototype` (that is, all except [`null`-prototype objects](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object#null-prototype_objects)) inherit the `__lookupGetter__()` method. If a [getter](/en-US/docs/Web/JavaScript/Reference/Functions/get) has been defined for an object\'s property, it\'s not possible to reference the getter function through that property, because that property refers to the return value of that function. `__lookupGetter__()` can be used to obtain a reference to the getter function.\n\n`__lookupGetter__()` walks up the [prototype chain](/en-US/docs/Web/JavaScript/Inheritance_and_the_prototype_chain) to find the specified property. If any object along the prototype chain has the specified [own property](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/hasOwn), the `get` attribute of the [property descriptor](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/getOwnPropertyDescriptor) for that property is returned. If that property is a data property, `undefined` is returned. If the property is not found along the entire prototype chain, `undefined` is also returned.\n\n`__lookupGetter__()` is defined in the spec as "normative optional", which means no implementation is required to implement this. However, all major browsers implement it, and due to its continued usage, it\'s unlikely to be removed. If a browser implements `__lookupGetter__()`, it also needs to implement the [`__lookupSetter__()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/__lookupSetter__), [`__defineGetter__()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/__defineGetter__), and [`__defineSetter__()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/__defineSetter__) methods.\n\n## Examples\n\n### Using \\_\\_lookupGetter\\_\\_()\n\n```js\nconst obj = {\n  get foo() {\n    return Math.random() > 0.5 ? "foo" : "bar";\n  },\n};\n\nobj.__lookupGetter__("foo");\n// [Function: get foo]\n```\n\n### Looking up a property\'s getter in the standard way\n\nYou should use the {{jsxref("Object.getOwnPropertyDescriptor()")}} API to look up a property\'s getter. Compared to `__lookupGetter__()`, this method allows looking up [symbol](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol) properties. The `Object.getOwnPropertyDescriptor()` method also works with [`null`-prototype objects](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object#null-prototype_objects), which don\'t inherit from `Object.prototype` and therefore don\'t have the `__lookupGetter__()` method. If `__lookupGetter__()`\'s behavior of walking up the prototype chain is important, you may implement it yourself with {{jsxref("Object.getPrototypeOf()")}}.\n\n```js\nconst obj = {\n  get foo() {\n    return Math.random() > 0.5 ? "foo" : "bar";\n  },\n};\n\nObject.getOwnPropertyDescriptor(obj, "foo").get;\n// [Function: get foo]\n```\n\n```js\nconst obj2 = {\n  __proto__: {\n    get foo() {\n      return Math.random() > 0.5 ? "foo" : "bar";\n    },\n  },\n};\n\nfunction findGetter(obj, prop) {\n  while (obj) {\n    const desc = Object.getOwnPropertyDescriptor(obj, prop);\n    if (desc) {\n      return desc.get;\n    }\n    obj = Object.getPrototypeOf(obj);\n  }\n}\n\nconsole.log(findGetter(obj2, "foo")); // [Function: get foo]\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Object.prototype.__lookupGetter__` in `core-js`](https://github.com/zloirock/core-js#ecmascript-object)\n- [`Object.prototype.__lookupSetter__()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/__lookupSetter__)\n- {{jsxref("Functions/get", "get")}}\n- {{jsxref("Object.getOwnPropertyDescriptor()")}}\n- [`Object.prototype.__defineGetter__()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/__defineGetter__)\n- [`Object.prototype.__defineSetter__()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/__defineSetter__)\n- [JS Guide: Defining Getters and Setters](/en-US/docs/Web/JavaScript/Guide/Working_with_objects#defining_getters_and_setters)\n'
        },
        "__lookupsetter__": {
            "index.md": '---\ntitle: Object.prototype.__lookupSetter__()\nslug: Web/JavaScript/Reference/Global_Objects/Object/__lookupSetter__\npage-type: javascript-instance-method\nstatus:\n  - deprecated\nbrowser-compat: javascript.builtins.Object.lookupSetter\n---\n\n{{JSRef}} {{Deprecated_Header}}\n\n> **Note:** This feature is deprecated in favor of the {{jsxref("Object.getOwnPropertyDescriptor()")}} API. This method\'s behavior is only specified for web compatibility, and is not required to be implemented in any platform. It may not work everywhere.\n\nThe **`__lookupSetter__()`** method of {{jsxref("Object")}} instances returns the function bound as a setter to the specified property.\n\n## Syntax\n\n```js-nolint\n__lookupSetter__(prop)\n```\n\n### Parameters\n\n- `prop`\n  - : A string containing the name of the property whose setter should be returned.\n\n### Return value\n\nThe function bound as a setter to the specified property. Returns `undefined` if no such property is found, or the property is a [data property](/en-US/docs/Web/JavaScript/Data_structures#data_property).\n\n## Description\n\nAll objects that inherit from `Object.prototype` (that is, all except [`null`-prototype objects](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object#null-prototype_objects)) inherit the `__lookupSetter__()` method. If a [setter](/en-US/docs/Web/JavaScript/Reference/Functions/get) has been defined for an object\'s property, it\'s not possible to reference the setter function through that property, because that property only calls the function when it\'s being set. `__lookupSetter__()` can be used to obtain a reference to the setter function.\n\n`__lookupSetter__()` walks up the [prototype chain](/en-US/docs/Web/JavaScript/Inheritance_and_the_prototype_chain) to find the specified property. If any object along the prototype chain has the specified [own property](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/hasOwn), the `set` attribute of the [property descriptor](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/getOwnPropertyDescriptor) for that property is returned. If that property is a data property, `undefined` is returned. If the property is not found along the entire prototype chain, `undefined` is also returned.\n\n`__lookupSetter__()` is defined in the spec as "normative optional", which means no implementation is required to implement this. However, all major browsers implement it, and due to its continued usage, it\'s unlikely to be removed. If a browser implements `__lookupSetter__()`, it also needs to implement the [`__lookupGetter__()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/__lookupGetter__), [`__defineGetter__()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/__defineGetter__), and [`__defineSetter__()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/__defineSetter__) methods.\n\n## Examples\n\n### Using \\_\\_lookupSetter\\_\\_()\n\n```js\nconst obj = {\n  set foo(value) {\n    this.bar = value;\n  },\n};\n\nobj.__lookupSetter__("foo");\n// [Function: set foo]\n```\n\n### Looking up a property\'s setter in the standard way\n\nYou should use the {{jsxref("Object.getOwnPropertyDescriptor()")}} API to look up a property\'s setter. Compared to `__lookupSetter__()`, this method allows looking up [symbol](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol) properties. The `Object.getOwnPropertyDescriptor()` method also works with [`null`-prototype objects](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object#null-prototype_objects), which don\'t inherit from `Object.prototype` and therefore don\'t have the `__lookupSetter__()` method. If `__lookupSetter__()`\'s behavior of walking up the prototype chain is important, you may implement it yourself with {{jsxref("Object.getPrototypeOf()")}}.\n\n```js\nconst obj = {\n  set foo(value) {\n    this.bar = value;\n  },\n};\n\nObject.getOwnPropertyDescriptor(obj, "foo").set;\n// [Function: set foo]\n```\n\n```js\nconst obj2 = {\n  __proto__: {\n    set foo(value) {\n      this.bar = value;\n    },\n  },\n};\n\nfunction findSetter(obj, prop) {\n  while (obj) {\n    const desc = Object.getOwnPropertyDescriptor(obj, prop);\n    if (desc) {\n      return desc.set;\n    }\n    obj = Object.getPrototypeOf(obj);\n  }\n}\n\nconsole.log(findSetter(obj2, "foo")); // [Function: set foo]\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Object.prototype.__lookupSetter__` in `core-js`](https://github.com/zloirock/core-js#ecmascript-object)\n- [`Object.prototype.__lookupGetter__()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/__lookupGetter__)\n- {{jsxref("Functions/set", "set")}}\n- {{jsxref("Object.getOwnPropertyDescriptor()")}}\n- [`Object.prototype.__defineGetter__()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/__defineGetter__)\n- [`Object.prototype.__defineSetter__()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/__defineSetter__)\n- [JS Guide: Defining Getters and Setters](/en-US/docs/Web/JavaScript/Guide/Working_with_objects#defining_getters_and_setters)\n'
        },
        "assign": {
            "index.md": '---\ntitle: Object.assign()\nslug: Web/JavaScript/Reference/Global_Objects/Object/assign\npage-type: javascript-static-method\nbrowser-compat: javascript.builtins.Object.assign\n---\n\n{{JSRef}}\n\nThe **`Object.assign()`** static method\ncopies all {{jsxref("Object/propertyIsEnumerable", "enumerable", "", 1)}}\n{{jsxref("Object/hasOwn", "own properties", "", 1)}} from one or more\n_source objects_ to a _target object_. It returns the modified target\nobject.\n\n{{EmbedInteractiveExample("pages/js/object-assign.html")}}\n\n## Syntax\n\n```js-nolint\nObject.assign(target)\nObject.assign(target, source1)\nObject.assign(target, source1, source2)\nObject.assign(target, source1, source2, /* \u2026, */ sourceN)\n```\n\n### Parameters\n\n- `target`\n  - : The target object \u2014 what to apply the sources\' properties to, which is returned\n    after it is modified.\n- `source1`, \u2026, `sourceN`\n  - : The source object(s) \u2014 objects containing the properties you want to apply.\n\n### Return value\n\nThe target object.\n\n## Description\n\nProperties in the target object are overwritten by properties in the sources if they\nhave the same {{jsxref("Object/keys", "key", "", 1)}}. Later sources\' properties\noverwrite earlier ones.\n\nThe `Object.assign()` method only copies _enumerable_ and\n_own_ properties from a source object to a target object. It uses\n`[[Get]]` on the source and `[[Set]]` on the target, so it will\ninvoke [getters](/en-US/docs/Web/JavaScript/Reference/Functions/get) and [setters](/en-US/docs/Web/JavaScript/Reference/Functions/set). Therefore it\n_assigns_ properties, versus copying or defining new properties. This may make it\nunsuitable for merging new properties into a prototype if the merge sources contain\ngetters.\n\nFor copying property definitions (including their enumerability) into prototypes, use\n{{jsxref("Object.getOwnPropertyDescriptor()")}} and\n{{jsxref("Object.defineProperty()")}} instead.\n\nBoth {{jsxref("String")}} and {{jsxref("Symbol")}} properties are copied.\n\nIn case of an error, for example if a property is non-writable, a\n{{jsxref("TypeError")}} is raised, and the `target` object is\nchanged if any properties are added before the error is raised.\n\n> **Note:** `Object.assign()` does not throw on\n> [`null`](/en-US/docs/Web/JavaScript/Reference/Operators/null) or {{jsxref("undefined")}} sources.\n\n## Examples\n\n### Cloning an object\n\n```js\nconst obj = { a: 1 };\nconst copy = Object.assign({}, obj);\nconsole.log(copy); // { a: 1 }\n```\n\n### Warning for Deep Clone\n\nFor [deep cloning](/en-US/docs/Glossary/Deep_copy), we need to use alternatives like [`structuredClone()`](/en-US/docs/Web/API/structuredClone), because `Object.assign()`\ncopies property values.\n\nIf the source value is a reference to an object, it only copies the reference value.\n\n```js\nconst obj1 = { a: 0, b: { c: 0 } };\nconst obj2 = Object.assign({}, obj1);\nconsole.log(obj2); // { a: 0, b: { c: 0 } }\n\nobj1.a = 1;\nconsole.log(obj1); // { a: 1, b: { c: 0 } }\nconsole.log(obj2); // { a: 0, b: { c: 0 } }\n\nobj2.a = 2;\nconsole.log(obj1); // { a: 1, b: { c: 0 } }\nconsole.log(obj2); // { a: 2, b: { c: 0 } }\n\nobj2.b.c = 3;\nconsole.log(obj1); // { a: 1, b: { c: 3 } }\nconsole.log(obj2); // { a: 2, b: { c: 3 } }\n\n// Deep Clone\nconst obj3 = { a: 0, b: { c: 0 } };\nconst obj4 = structuredClone(obj3);\nobj3.a = 4;\nobj3.b.c = 4;\nconsole.log(obj4); // { a: 0, b: { c: 0 } }\n```\n\n### Merging objects\n\n```js\nconst o1 = { a: 1 };\nconst o2 = { b: 2 };\nconst o3 = { c: 3 };\n\nconst obj = Object.assign(o1, o2, o3);\nconsole.log(obj); // { a: 1, b: 2, c: 3 }\nconsole.log(o1); // { a: 1, b: 2, c: 3 }, target object itself is changed.\n```\n\n### Merging objects with same properties\n\n```js\nconst o1 = { a: 1, b: 1, c: 1 };\nconst o2 = { b: 2, c: 2 };\nconst o3 = { c: 3 };\n\nconst obj = Object.assign({}, o1, o2, o3);\nconsole.log(obj); // { a: 1, b: 2, c: 3 }\n```\n\nThe properties are overwritten by other objects that have the same properties later in\nthe parameters order.\n\n### Copying symbol-typed properties\n\n```js\nconst o1 = { a: 1 };\nconst o2 = { [Symbol("foo")]: 2 };\n\nconst obj = Object.assign({}, o1, o2);\nconsole.log(obj); // { a : 1, [Symbol("foo")]: 2 } (cf. bug 1207182 on Firefox)\nObject.getOwnPropertySymbols(obj); // [Symbol(foo)]\n```\n\n### Properties on the prototype chain and non-enumerable properties cannot be copied\n\n```js\nconst obj = Object.create(\n  // foo is on obj\'s prototype chain.\n  { foo: 1 },\n  {\n    bar: {\n      value: 2, // bar is a non-enumerable property.\n    },\n    baz: {\n      value: 3,\n      enumerable: true, // baz is an own enumerable property.\n    },\n  },\n);\n\nconst copy = Object.assign({}, obj);\nconsole.log(copy); // { baz: 3 }\n```\n\n### Primitives will be wrapped to objects\n\n```js\nconst v1 = "abc";\nconst v2 = true;\nconst v3 = 10;\nconst v4 = Symbol("foo");\n\nconst obj = Object.assign({}, v1, null, v2, undefined, v3, v4);\n// Primitives will be wrapped, null and undefined will be ignored.\n// Note, only string wrappers can have own enumerable properties.\nconsole.log(obj); // { "0": "a", "1": "b", "2": "c" }\n```\n\n### Exceptions will interrupt the ongoing copying task\n\n```js\nconst target = Object.defineProperty({}, "foo", {\n  value: 1,\n  writable: false,\n}); // target.foo is a read-only property\n\nObject.assign(target, { bar: 2 }, { foo2: 3, foo: 3, foo3: 3 }, { baz: 4 });\n// TypeError: "foo" is read-only\n// The Exception is thrown when assigning target.foo\n\nconsole.log(target.bar); // 2, the first source was copied successfully.\nconsole.log(target.foo2); // 3, the first property of the second source was copied successfully.\nconsole.log(target.foo); // 1, exception is thrown here.\nconsole.log(target.foo3); // undefined, assign method has finished, foo3 will not be copied.\nconsole.log(target.baz); // undefined, the third source will not be copied either.\n```\n\n### Copying accessors\n\n```js\nconst obj = {\n  foo: 1,\n  get bar() {\n    return 2;\n  },\n};\n\nlet copy = Object.assign({}, obj);\nconsole.log(copy);\n// { foo: 1, bar: 2 }\n// The value of copy.bar is obj.bar\'s getter\'s return value.\n\n// This is an assign function that copies full descriptors\nfunction completeAssign(target, ...sources) {\n  sources.forEach((source) => {\n    const descriptors = Object.keys(source).reduce((descriptors, key) => {\n      descriptors[key] = Object.getOwnPropertyDescriptor(source, key);\n      return descriptors;\n    }, {});\n\n    // By default, Object.assign copies enumerable Symbols, too\n    Object.getOwnPropertySymbols(source).forEach((sym) => {\n      const descriptor = Object.getOwnPropertyDescriptor(source, sym);\n      if (descriptor.enumerable) {\n        descriptors[sym] = descriptor;\n      }\n    });\n    Object.defineProperties(target, descriptors);\n  });\n  return target;\n}\n\ncopy = completeAssign({}, obj);\nconsole.log(copy);\n// { foo:1, get bar() { return 2 } }\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Object.assign` in `core-js`](https://github.com/zloirock/core-js#ecmascript-object)\n- {{jsxref("Object.defineProperties()")}}\n- [Enumerability and ownership of properties](/en-US/docs/Web/JavaScript/Enumerability_and_ownership_of_properties)\n- [Spread in object literals](/en-US/docs/Web/JavaScript/Reference/Operators/Spread_syntax#spread_in_object_literals)\n'
        },
        "constructor": {
            "index.md": '---\ntitle: Object.prototype.constructor\nslug: Web/JavaScript/Reference/Global_Objects/Object/constructor\npage-type: javascript-instance-data-property\nbrowser-compat: javascript.builtins.Object.constructor\n---\n\n{{JSRef}}\n\nThe **`constructor`** data property of an {{jsxref("Object")}} instance returns a reference to the constructor function that created the instance object. Note that the value of this property is a reference to _the function itself_, not a string containing the function\'s name.\n\n> **Note:** This is a property of JavaScript objects. For the `constructor` method in classes, see [its own reference page](/en-US/docs/Web/JavaScript/Reference/Classes/constructor).\n\n## Value\n\nA reference to the constructor function that created the instance object.\n\n{{js_property_attributes(1, 0, 1)}}\n\n> **Note:** This property is created by default on the [`prototype`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/prototype) property of every constructor function and is inherited by all objects created by that constructor.\n\n## Description\n\nAny object (with the exception of [`null` prototype objects](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object#null-prototype_objects)) will have a `constructor` property on its `[[Prototype]]`. Objects created with literals will also have a `constructor` property that points to the constructor type for that object \u2014 for example, array literals create {{jsxref("Array")}} objects, and [object literals](/en-US/docs/Web/JavaScript/Reference/Operators/Object_initializer) create plain objects.\n\n```js\nconst o1 = {};\no1.constructor === Object; // true\n\nconst o2 = new Object();\no2.constructor === Object; // true\n\nconst a1 = [];\na1.constructor === Array; // true\n\nconst a2 = new Array();\na2.constructor === Array; // true\n\nconst n = 3;\nn.constructor === Number; // true\n```\n\nNote that `constructor` usually comes from the constructor\'s [`prototype`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/prototype) property. If you have a longer prototype chain, you can usually expect every object in the chain to have a `constructor` property.\n\n```js\nconst o = new TypeError(); // Inheritance: TypeError -> Error -> Object\nconst proto = Object.getPrototypeOf;\nproto(o).constructor === TypeError; // true\nproto(proto(o)).constructor === Error; // true\nproto(proto(proto(o))).constructor === Object; // true\n```\n\n## Examples\n\n### Displaying the constructor of an object\n\nThe following example creates a constructor (`Tree`) and an object of that type (`theTree`). The example then displays the `constructor` property for the object `theTree`.\n\n```js\nfunction Tree(name) {\n  this.name = name;\n}\n\nconst theTree = new Tree("Redwood");\nconsole.log(`theTree.constructor is ${theTree.constructor}`);\n```\n\nThis example displays the following output:\n\n```plain\ntheTree.constructor is function Tree(name) {\n  this.name = name;\n}\n```\n\n### Assigning the constructor property to an object\n\nOne can assign the `constructor` property of non-primitives.\n\n```js\nconst arr = [];\narr.constructor = String;\narr.constructor === String; // true\narr instanceof String; // false\narr instanceof Array; // true\n\nconst foo = new Foo();\nfoo.constructor = "bar";\nfoo.constructor === "bar"; // true\n\n// etc.\n```\n\nThis does not overwrite the old `constructor` property \u2014 it was originally present on the instance\'s `[[Prototype]]`, not as its own property.\n\n```js\nconst arr = [];\nObject.hasOwn(arr, "constructor"); // false\nObject.hasOwn(Object.getPrototypeOf(arr), "constructor"); // true\n\narr.constructor = String;\nObject.hasOwn(arr, "constructor"); // true \u2014 the instance property shadows the one on its prototype\n```\n\nBut even when `Object.getPrototypeOf(a).constructor` is re-assigned, it won\'t change other behaviors of the object. For example, the behavior of `instanceof` is controlled by [`Symbol.hasInstance`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol/hasInstance), not `constructor`:\n\n```js\nconst arr = [];\narr.constructor = String;\narr instanceof String; // false\narr instanceof Array; // true\n```\n\nThere is nothing protecting the `constructor` property from being re-assigned or shadowed, so using it to detect the type of a variable should usually be avoided in favor of less fragile ways like `instanceof` and [`Symbol.toStringTag`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol/toStringTag) for objects, or [`typeof`](/en-US/docs/Web/JavaScript/Reference/Operators/typeof) for primitives.\n\n### Changing the constructor of a constructor function\'s prototype\n\nEvery constructor has a [`prototype`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/prototype) property, which will become the instance\'s `[[Prototype]]` when called via the [`new`](/en-US/docs/Web/JavaScript/Reference/Operators/new) operator. `ConstructorFunction.prototype.constructor` will therefore become a property on the instance\'s `[[Prototype]]`, as previously demonstrated.\n\nHowever, if `ConstructorFunction.prototype` is re-assigned, the `constructor` property will be lost. For example, the following is a common way to create an inheritance pattern:\n\n```js\nfunction Parent() {\n  // \u2026\n}\nParent.prototype.parentMethod = function () {};\n\nfunction Child() {\n  Parent.call(this); // Make sure everything is initialized properly\n}\n// Pointing the [[Prototype]] of Child.prototype to Parent.prototype\nChild.prototype = Object.create(Parent.prototype);\n```\n\nThe `constructor` of instances of `Child` will be `Parent` due to `Child.prototype` being re-assigned.\n\nThis is usually not a big deal \u2014 the language almost never reads the `constructor` property of an object. The only exception is when using [`@@species`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol/species) to create new instances of a class, but such cases are rare, and you should be using the [`extends`](/en-US/docs/Web/JavaScript/Reference/Classes/extends) syntax to subclass builtins anyway.\n\nHowever, ensuring that `Child.prototype.constructor` always points to `Child` itself is crucial when some caller is using `constructor` to access the original class from an instance. Take the following case: the object has the `create()` method to create itself.\n\n```js\nfunction Parent() {\n  // \u2026\n}\nfunction CreatedConstructor() {\n  Parent.call(this);\n}\n\nCreatedConstructor.prototype = Object.create(Parent.prototype);\n\nCreatedConstructor.prototype.create = function () {\n  return new this.constructor();\n};\n\nnew CreatedConstructor().create().create(); // TypeError: new CreatedConstructor().create().create is undefined, since constructor === Parent\n```\n\nIn the example above, an exception is thrown, since the `constructor` links to `Parent`. To avoid this, just assign the necessary constructor you are going to use.\n\n```js\nfunction Parent() {\n  // \u2026\n}\nfunction CreatedConstructor() {\n  // \u2026\n}\n\nCreatedConstructor.prototype = Object.create(Parent.prototype, {\n  // Return original constructor to Child\n  constructor: {\n    value: CreatedConstructor,\n    enumerable: false, // Make it non-enumerable, so it won\'t appear in `for...in` loop\n    writable: true,\n    configurable: true,\n  },\n});\n\nCreatedConstructor.prototype.create = function () {\n  return new this.constructor();\n};\n\nnew CreatedConstructor().create().create(); // it\'s pretty fine\n```\n\nNote that when manually adding the `constructor` property, it\'s crucial to make the property [non-enumerable](/en-US/docs/Web/JavaScript/Enumerability_and_ownership_of_properties), so `constructor` won\'t be visited in [`for...in`](/en-US/docs/Web/JavaScript/Reference/Statements/for...in) loops \u2014 as it normally isn\'t.\n\nIf the code above looks like too much boilerplate, you may also consider using [`Object.setPrototypeOf()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/setPrototypeOf) to manipulate the prototype chain.\n\n```js\nfunction Parent() {\n  // \u2026\n}\nfunction CreatedConstructor() {\n  // \u2026\n}\n\nObject.setPrototypeOf(CreatedConstructor.prototype, Parent.prototype);\n\nCreatedConstructor.prototype.create = function () {\n  return new this.constructor();\n};\n\nnew CreatedConstructor().create().create(); // still works without re-creating constructor property\n```\n\n`Object.setPrototypeOf()` comes with its potential performance downsides because all previously created objects involved in the prototype chain have to be re-compiled; but if the above initialization code happens before `Parent` or `CreatedConstructor` are constructed, the effect should be minimal.\n\nLet\'s consider one more involved case.\n\n```js\nfunction ParentWithStatic() {}\n\nParentWithStatic.startPosition = { x: 0, y: 0 }; // Static member property\nParentWithStatic.getStartPosition = function () {\n  return this.startPosition;\n};\n\nfunction Child(x, y) {\n  this.position = { x, y };\n}\n\nChild.prototype = Object.create(ParentWithStatic.prototype, {\n  // Return original constructor to Child\n  constructor: {\n    value: Child,\n    enumerable: false,\n    writable: true,\n    configurable: true,\n  },\n});\n\nChild.prototype.getOffsetByInitialPosition = function () {\n  const position = this.position;\n  // Using this.constructor, in hope that getStartPosition exists as a static method\n  const startPosition = this.constructor.getStartPosition();\n\n  return {\n    offsetX: startPosition.x - position.x,\n    offsetY: startPosition.y - position.y,\n  };\n};\n\nnew Child(1, 1).getOffsetByInitialPosition();\n// Error: this.constructor.getStartPosition is undefined, since the\n// constructor is Child, which doesn\'t have the getStartPosition static method\n```\n\nFor this example to work properly, we can reassign the `Parent`\'s static properties to `Child`:\n\n```js\n// \u2026\nObject.assign(Child, ParentWithStatic); // Notice that we assign it before we create() a prototype below\nChild.prototype = Object.create(ParentWithStatic.prototype, {\n  // Return original constructor to Child\n  constructor: {\n    value: Child,\n    enumerable: false,\n    writable: true,\n    configurable: true,\n  },\n});\n// \u2026\n```\n\nBut even better, we can make the constructor functions themselves extend each other, as classes\' [`extends`](/en-US/docs/Web/JavaScript/Reference/Classes/extends) do.\n\n```js\nfunction ParentWithStatic() {}\n\nParentWithStatic.startPosition = { x: 0, y: 0 }; // Static member property\nParentWithStatic.getStartPosition = function () {\n  return this.startPosition;\n};\n\nfunction Child(x, y) {\n  this.position = { x, y };\n}\n\n// Properly create inheritance!\nObject.setPrototypeOf(Child.prototype, ParentWithStatic.prototype);\nObject.setPrototypeOf(Child, ParentWithStatic);\n\nChild.prototype.getOffsetByInitialPosition = function () {\n  const position = this.position;\n  const startPosition = this.constructor.getStartPosition();\n\n  return {\n    offsetX: startPosition.x - position.x,\n    offsetY: startPosition.y - position.y,\n  };\n};\n\nconsole.log(new Child(1, 1).getOffsetByInitialPosition()); // { offsetX: -1, offsetY: -1 }\n```\n\nAgain, using `Object.setPrototypeOf()` may have adverse performance effects, so make sure it happens immediately after the constructor declaration and before any instances are created \u2014 to avoid objects being "tainted".\n\n> **Note:** Manually updating or setting the constructor can lead to different and sometimes confusing consequences. To prevent this, just define the role of `constructor` in each specific case. In most cases, `constructor` is not used and reassigning it is not necessary.\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Statements/class", "class")}}\n- {{jsxref("Classes/constructor", "constructor")}}\n- {{Glossary("Constructor")}}\n'
        },
        "create": {
            "index.md": '---\ntitle: Object.create()\nslug: Web/JavaScript/Reference/Global_Objects/Object/create\npage-type: javascript-static-method\nbrowser-compat: javascript.builtins.Object.create\n---\n\n{{JSRef}}\n\nThe **`Object.create()`** static method creates a new object, using an existing object as the prototype of the newly created object.\n\n{{EmbedInteractiveExample("pages/js/object-create.html", "taller")}}\n\n## Syntax\n\n```js-nolint\nObject.create(proto)\nObject.create(proto, propertiesObject)\n```\n\n### Parameters\n\n- `proto`\n  - : The object which should be the prototype of the newly-created object.\n- `propertiesObject` {{optional_inline}}\n  - : If specified and not {{jsxref("undefined")}}, an object whose [enumerable own properties](/en-US/docs/Web/JavaScript/Enumerability_and_ownership_of_properties) specify property descriptors to be added to the newly-created object, with the corresponding property names. These properties correspond to the second argument of {{jsxref("Object.defineProperties()")}}.\n\n### Return value\n\nA new object with the specified prototype object and properties.\n\n### Exceptions\n\n- {{jsxref("TypeError")}}\n  - : Thrown if `proto` is neither [`null`](/en-US/docs/Web/JavaScript/Reference/Operators/null) nor an {{jsxref("Object")}}.\n\n## Examples\n\n### Classical inheritance with Object.create()\n\nBelow is an example of how to use `Object.create()` to achieve classical inheritance. This is for a single inheritance, which is all that JavaScript supports.\n\n```js\n// Shape - superclass\nfunction Shape() {\n  this.x = 0;\n  this.y = 0;\n}\n\n// superclass method\nShape.prototype.move = function (x, y) {\n  this.x += x;\n  this.y += y;\n  console.info("Shape moved.");\n};\n\n// Rectangle - subclass\nfunction Rectangle() {\n  Shape.call(this); // call super constructor.\n}\n\n// subclass extends superclass\nRectangle.prototype = Object.create(Shape.prototype, {\n  // If you don\'t set Rectangle.prototype.constructor to Rectangle,\n  // it will take the prototype.constructor of Shape (parent).\n  // To avoid that, we set the prototype.constructor to Rectangle (child).\n  constructor: {\n    value: Rectangle,\n    enumerable: false,\n    writable: true,\n    configurable: true,\n  },\n});\n\nconst rect = new Rectangle();\n\nconsole.log("Is rect an instance of Rectangle?", rect instanceof Rectangle); // true\nconsole.log("Is rect an instance of Shape?", rect instanceof Shape); // true\nrect.move(1, 1); // Logs \'Shape moved.\'\n```\n\nNote that there are caveats to watch out for using `create()`, such as re-adding the [`constructor`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/constructor) property to ensure proper semantics. Although `Object.create()` is believed to have better performance than mutating the prototype with {{jsxref("Object.setPrototypeOf()")}}, the difference is in fact negligible if no instances have been created and property accesses haven\'t been optimized yet. In modern code, the [class](/en-US/docs/Web/JavaScript/Reference/Classes) syntax should be preferred in any case.\n\n### Using propertiesObject argument with Object.create()\n\n`Object.create()` allows fine-tuned control over the object creation process. The [object initializer syntax](/en-US/docs/Web/JavaScript/Reference/Operators/Object_initializer) is, in fact, a syntax sugar of `Object.create()`. With `Object.create()`, we can create objects with a designated prototype and also some properties. Note that the second parameter maps keys to _property descriptors_ \u2014 this means you can control each property\'s enumerability, configurability, etc. as well, which you can\'t do in object initializers.\n\n```js\no = {};\n// Is equivalent to:\no = Object.create(Object.prototype);\n\no = Object.create(Object.prototype, {\n  // foo is a regular data property\n  foo: {\n    writable: true,\n    configurable: true,\n    value: "hello",\n  },\n  // bar is an accessor property\n  bar: {\n    configurable: false,\n    get() {\n      return 10;\n    },\n    set(value) {\n      console.log("Setting `o.bar` to", value);\n    },\n  },\n});\n\n// Create a new object whose prototype is a new, empty\n// object and add a single property \'p\', with value 42.\no = Object.create({}, { p: { value: 42 } });\n```\n\nWith `Object.create()`, we can create an object [with `null` as prototype](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object#null-prototype_objects). The equivalent syntax in object initializers would be the [`__proto__`](/en-US/docs/Web/JavaScript/Reference/Operators/Object_initializer#prototype_setter) key.\n\n```js\no = Object.create(null);\n// Is equivalent to:\no = { __proto__: null };\n```\n\nBy default properties are _not_ writable, enumerable or configurable.\n\n```js\no.p = 24; // throws in strict mode\no.p; // 42\n\no.q = 12;\nfor (const prop in o) {\n  console.log(prop);\n}\n// \'q\'\n\ndelete o.p;\n// false; throws in strict mode\n```\n\nTo specify a property with the same attributes as in an initializer, explicitly specify `writable`, `enumerable` and `configurable`.\n\n```js\no2 = Object.create(\n  {},\n  {\n    p: {\n      value: 42,\n      writable: true,\n      enumerable: true,\n      configurable: true,\n    },\n  },\n);\n// This is not equivalent to:\n// o2 = Object.create({ p: 42 })\n// which will create an object with prototype { p: 42 }\n```\n\nYou can use `Object.create()` to mimic the behavior of the [`new`](/en-US/docs/Web/JavaScript/Reference/Operators/new) operator.\n\n```js\nfunction Constructor() {}\no = new Constructor();\n// Is equivalent to:\no = Object.create(Constructor.prototype);\n```\n\nOf course, if there is actual initialization code in the `Constructor` function, the `Object.create()` method cannot reflect it.\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Object.create` in `core-js`](https://github.com/zloirock/core-js#ecmascript-object)\n- {{jsxref("Object.defineProperty()")}}\n- {{jsxref("Object.defineProperties()")}}\n- {{jsxref("Object.prototype.isPrototypeOf()")}}\n- {{jsxref("Reflect.construct()")}}\n- [Object.getPrototypeOf](https://johnresig.com/blog/objectgetprototypeof/) by John Resig (2008)\n'
        },
        "defineproperties": {
            "index.md": '---\ntitle: Object.defineProperties()\nslug: Web/JavaScript/Reference/Global_Objects/Object/defineProperties\npage-type: javascript-static-method\nbrowser-compat: javascript.builtins.Object.defineProperties\n---\n\n{{JSRef}}\n\nThe **`Object.defineProperties()`** static method defines new or\nmodifies existing properties directly on an object, returning the object.\n\n{{EmbedInteractiveExample("pages/js/object-defineproperties.html")}}\n\n## Syntax\n\n```js-nolint\nObject.defineProperties(obj, props)\n```\n\n### Parameters\n\n- `obj`\n  - : The object on which to define or modify properties.\n- `props`\n\n  - : An object whose keys represent the names of properties to be defined or modified and\n    whose values are objects describing those properties. Each value in `props`\n    must be either a data descriptor or an accessor descriptor; it cannot be both (see\n    {{jsxref("Object.defineProperty()")}} for more details).\n\n    Data descriptors and accessor descriptors may optionally contain the following keys:\n\n    - `configurable`\n      - : `true` if and only if the type of this property descriptor may be\n        changed and if the property may be deleted from the corresponding object.\n        **Defaults to `false`.**\n    - `enumerable`\n      - : `true` if and only if this property shows up during enumeration of\n        the properties on the corresponding object.\n        **Defaults to `false`.**\n\n    A data descriptor also has the following optional keys:\n\n    - `value`\n      - : The value associated with the property. Can be any valid JavaScript value\n        (number, object, function, etc.).\n        **Defaults to {{jsxref("undefined")}}.**\n    - `writable`\n      - : `true` if and only if the value associated with the property may be\n        changed with an {{jsxref("Operators", "assignment operator", "assignment_operators", 1)}}.\n        **Defaults to `false`.**\n\n    An accessor descriptor also has the following optional keys:\n\n    - `get`\n      - : A function which serves as a getter for the property, or {{jsxref("undefined")}}\n        if there is no getter. The function\'s return value will be used as the value of\n        the property.\n        **Defaults to {{jsxref("undefined")}}.**\n    - `set`\n      - : A function which serves as a setter for the property, or {{jsxref("undefined")}}\n        if there is no setter. The function will receive as its only argument the new\n        value being assigned to the property.\n        **Defaults to {{jsxref("undefined")}}.**\n\n    If a descriptor has neither of `value`, `writable`,\n    `get` and `set` keys, it is treated as a data descriptor. If a\n    descriptor has both `value` or `writable` and `get`\n    or `set` keys, an exception is thrown.\n\n### Return value\n\nThe object that was passed to the function.\n\n## Examples\n\n### Using Object.defineProperties\n\n```js\nconst obj = {};\nObject.defineProperties(obj, {\n  property1: {\n    value: true,\n    writable: true,\n  },\n  property2: {\n    value: "Hello",\n    writable: false,\n  },\n  // etc. etc.\n});\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Object.defineProperties` in `core-js`](https://github.com/zloirock/core-js#ecmascript-object)\n- {{jsxref("Object.defineProperty()")}}\n- {{jsxref("Object.keys()")}}\n- [Enumerability and ownership of properties](/en-US/docs/Web/JavaScript/Enumerability_and_ownership_of_properties)\n'
        },
        "defineproperty": {
            "index.md": '---\ntitle: Object.defineProperty()\nslug: Web/JavaScript/Reference/Global_Objects/Object/defineProperty\npage-type: javascript-static-method\nbrowser-compat: javascript.builtins.Object.defineProperty\n---\n\n{{JSRef}}\n\nThe **`Object.defineProperty()`** static method defines a new property directly on an object, or modifies an existing property on an object, and returns the object.\n\n{{EmbedInteractiveExample("pages/js/object-defineproperty.html")}}\n\n## Syntax\n\n```js-nolint\nObject.defineProperty(obj, prop, descriptor)\n```\n\n### Parameters\n\n- `obj`\n  - : The object on which to define the property.\n- `prop`\n  - : A string or {{jsxref("Symbol")}} specifying the key of the property to be defined or modified.\n- `descriptor`\n  - : The descriptor for the property being defined or modified.\n\n### Return value\n\nThe object that was passed to the function, with the specified property added or modified.\n\n## Description\n\n`Object.defineProperty()` allows a precise addition to or modification of a property on an object. Normal property addition through [assignment](/en-US/docs/Web/JavaScript/Reference/Operators/Assignment) creates properties which show up during property enumeration ({{jsxref("Statements/for...in", "for...in")}}, {{jsxref("Object.keys()")}}, etc.), whose values may be changed and which may be {{jsxref("Operators/delete", "deleted", "", 1)}}. This method allows these extra details to be changed from their defaults. By default, properties added using `Object.defineProperty()` are not writable, not enumerable, and not configurable. In addition, `Object.defineProperty()` uses the [`[[DefineOwnProperty]]`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Proxy/Proxy/defineProperty) internal method, instead of [`[[Set]]`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Proxy/Proxy/set), so it does not invoke [setters](/en-US/docs/Web/JavaScript/Reference/Functions/set), even when the property is already present.\n\nProperty descriptors present in objects come in two main flavors: data descriptors and accessor descriptors. A **data descriptor** is a property with a value that may or may not be writable. An **accessor descriptor** is a property described by a getter-setter pair of functions. A descriptor must be one of these two flavors; it cannot be both.\n\nBoth data and accessor descriptors are objects. They share the following optional keys (please note: the **defaults** mentioned here are in the case of defining properties using `Object.defineProperty()`):\n\n- `configurable`\n\n  - : when this is set to `false`,\n\n    - the type of this property cannot be changed between data property and accessor property, and\n    - the property may not be deleted, and\n    - other attributes of its descriptor cannot be changed (however, if it\'s a data descriptor with `writable: true`, the `value` can be changed, and `writable` can be changed to `false`).\n\n    **Defaults to `false`.**\n\n- `enumerable`\n  - : `true` if and only if this property shows up during enumeration of the properties on the corresponding object. **Defaults to `false`.**\n\nA **data descriptor** also has the following optional keys:\n\n- `value`\n  - : The value associated with the property. Can be any valid JavaScript value (number, object, function, etc.). **Defaults to {{jsxref("undefined")}}.**\n- `writable`\n  - : `true` if the value associated with the property may be changed with an [assignment operator](/en-US/docs/Web/JavaScript/Reference/Operators#assignment_operators). **Defaults to `false`.**\n\nAn **accessor descriptor** also has the following optional keys:\n\n- `get`\n  - : A function which serves as a getter for the property, or {{jsxref("undefined")}} if there is no getter. When the property is accessed, this function is called without arguments and with `this` set to the object through which the property is accessed (this may not be the object on which the property is defined due to inheritance). The return value will be used as the value of the property. **Defaults to {{jsxref("undefined")}}.**\n- `set`\n  - : A function which serves as a setter for the property, or {{jsxref("undefined")}} if there is no setter. When the property is assigned, this function is called with one argument (the value being assigned to the property) and with `this` set to the object through which the property is assigned. **Defaults to {{jsxref("undefined")}}.**\n\nIf a descriptor doesn\'t have any of the `value`, `writable`, `get`, and `set` keys, it is treated as a data descriptor. If a descriptor has both \\[`value` or `writable`] and \\[`get` or `set`] keys, an exception is thrown.\n\nThese attributes are not necessarily the descriptor\'s own properties. Inherited properties will be considered as well. In order to ensure these defaults are preserved, you might freeze existing objects in the descriptor object\'s prototype chain upfront, specify all options explicitly, or create a [`null`-prototype object](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object#null-prototype_objects).\n\n```js\nconst obj = {};\n// 1. Using a null prototype: no inherited properties\nconst descriptor = Object.create(null);\ndescriptor.value = "static";\n\n// not enumerable, not configurable, not writable as defaults\nObject.defineProperty(obj, "key", descriptor);\n\n// 2. Being explicit by using a throw-away object literal with all attributes present\nObject.defineProperty(obj, "key2", {\n  enumerable: false,\n  configurable: false,\n  writable: false,\n  value: "static",\n});\n\n// 3. Recycling same object\nfunction withValue(value) {\n  const d =\n    withValue.d ||\n    (withValue.d = {\n      enumerable: false,\n      writable: false,\n      configurable: false,\n      value,\n    });\n\n  // avoiding duplicate operation for assigning value\n  if (d.value !== value) d.value = value;\n\n  return d;\n}\n// and\nObject.defineProperty(obj, "key", withValue("static"));\n\n// if freeze is available, prevents adding or\n// removing the object prototype properties\n// (value, get, set, enumerable, writable, configurable)\n(Object.freeze || Object)(Object.prototype);\n```\n\nWhen the property already exists, `Object.defineProperty()` attempts to modify the property according to the values in the descriptor and the property\'s current configuration.\n\nIf the old descriptor had its `configurable` attribute set to `false`, the property is said to be _non-configurable_. It is not possible to change any attribute of a non-configurable accessor property, and it is not possible to switch between data and accessor property types. For data properties with `writable: true`, it is possible to modify the value and change the `writable` attribute from `true` to `false`. A {{jsxref("TypeError")}} is thrown when attempts are made to change non-configurable property attributes (except `value` and `writable`, if permitted), except when defining a value same as the original value on a data property.\n\nWhen the current property is configurable, defining an attribute to `undefined` effectively deletes it. For example, if `o.k` is an accessor property, `Object.defineProperty(o, "k", { set: undefined })` will remove the setter, making `k` only have a getter and become readonly. If an attribute is absent from the new descriptor, the old descriptor attribute\'s value is kept (it won\'t be implicitly re-defined to `undefined`). It is possible to toggle between data and accessor property by giving a descriptor of a different "flavor". For example, if the new descriptor is a data descriptor (with `value` or `writable`), the original descriptor\'s `get` and `set` attributes will both be dropped.\n\n## Examples\n\n### Creating a property\n\nWhen the property specified doesn\'t exist in the object, `Object.defineProperty()` creates a new property as described. Fields may be omitted from the descriptor and default values for those fields are inputted.\n\n```js\nconst o = {}; // Creates a new object\n\n// Example of an object property added\n// with defineProperty with a data property descriptor\nObject.defineProperty(o, "a", {\n  value: 37,\n  writable: true,\n  enumerable: true,\n  configurable: true,\n});\n// \'a\' property exists in the o object and its value is 37\n\n// Example of an object property added\n// with defineProperty with an accessor property descriptor\nlet bValue = 38;\nObject.defineProperty(o, "b", {\n  get() {\n    return bValue;\n  },\n  set(newValue) {\n    bValue = newValue;\n  },\n  enumerable: true,\n  configurable: true,\n});\no.b; // 38\n// \'b\' property exists in the o object and its value is 38\n// The value of o.b is now always identical to bValue,\n// unless o.b is redefined\n\n// You cannot try to mix both:\nObject.defineProperty(o, "conflict", {\n  value: 0x9f91102,\n  get() {\n    return 0xdeadbeef;\n  },\n});\n// throws a TypeError: value appears\n// only in data descriptors,\n// get appears only in accessor descriptors\n```\n\n### Modifying a property\n\nWhen modifying an existing property, the current property configuration determines if the operator succeeds, does nothing, or throws a {{jsxref("TypeError")}}.\n\n#### Writable attribute\n\nWhen the `writable` property attribute is `false`, the property is said to be "non-writable". It cannot be reassigned. Trying to write to a non-writable property doesn\'t change it and results in an error in [strict mode](/en-US/docs/Web/JavaScript/Reference/Strict_mode).\n\n```js\nconst o = {}; // Creates a new object\n\nObject.defineProperty(o, "a", {\n  value: 37,\n  writable: false,\n});\n\nconsole.log(o.a); // 37\no.a = 25; // No error thrown\n// (it would throw in strict mode,\n// even if the value had been the same)\nconsole.log(o.a); // 37; the assignment didn\'t work\n\n// strict mode\n(() => {\n  "use strict";\n  const o = {};\n  Object.defineProperty(o, "b", {\n    value: 2,\n    writable: false,\n  });\n  o.b = 3; // throws TypeError: "b" is read-only\n  return o.b; // returns 2 without the line above\n})();\n```\n\n#### Enumerable attribute\n\nThe `enumerable` property attribute defines whether the property is considered by {{jsxref("Object.assign()")}} or the [spread](/en-US/docs/Web/JavaScript/Reference/Operators/Spread_syntax) operator. For non-{{jsxref("Symbol")}} properties, it also defines whether it shows up in a {{jsxref("Statements/for...in", "for...in")}} loop and {{jsxref("Object.keys()")}} or not. For more information, see [Enumerability and ownership of properties](/en-US/docs/Web/JavaScript/Enumerability_and_ownership_of_properties).\n\n```js\nconst o = {};\nObject.defineProperty(o, "a", {\n  value: 1,\n  enumerable: true,\n});\nObject.defineProperty(o, "b", {\n  value: 2,\n  enumerable: false,\n});\nObject.defineProperty(o, "c", {\n  value: 3,\n}); // enumerable defaults to false\no.d = 4; // enumerable defaults to true when creating a property by setting it\nObject.defineProperty(o, Symbol.for("e"), {\n  value: 5,\n  enumerable: true,\n});\nObject.defineProperty(o, Symbol.for("f"), {\n  value: 6,\n  enumerable: false,\n});\n\nfor (const i in o) {\n  console.log(i);\n}\n// Logs \'a\' and \'d\' (always in that order)\n\nObject.keys(o); // [\'a\', \'d\']\n\no.propertyIsEnumerable("a"); // true\no.propertyIsEnumerable("b"); // false\no.propertyIsEnumerable("c"); // false\no.propertyIsEnumerable("d"); // true\no.propertyIsEnumerable(Symbol.for("e")); // true\no.propertyIsEnumerable(Symbol.for("f")); // false\n\nconst p = { ...o };\np.a; // 1\np.b; // undefined\np.c; // undefined\np.d; // 4\np[Symbol.for("e")]; // 5\np[Symbol.for("f")]; // undefined\n```\n\n#### Configurable attribute\n\nThe `configurable` attribute controls whether the property can be deleted from the object and whether its attributes (other than `value` and `writable`) can be changed.\n\nThis example illustrates a non-configurable accessor property.\n\n```js\nconst o = {};\nObject.defineProperty(o, "a", {\n  get() {\n    return 1;\n  },\n  configurable: false,\n});\n\nObject.defineProperty(o, "a", {\n  configurable: true,\n}); // throws a TypeError\nObject.defineProperty(o, "a", {\n  enumerable: true,\n}); // throws a TypeError\nObject.defineProperty(o, "a", {\n  set() {},\n}); // throws a TypeError (set was undefined previously)\nObject.defineProperty(o, "a", {\n  get() {\n    return 1;\n  },\n}); // throws a TypeError\n// (even though the new get does exactly the same thing)\nObject.defineProperty(o, "a", {\n  value: 12,\n}); // throws a TypeError\n// (\'value\' can be changed when \'configurable\' is false, but only when the property is a writable data property)\n\nconsole.log(o.a); // 1\ndelete o.a; // Nothing happens; throws an error in strict mode\nconsole.log(o.a); // 1\n```\n\nIf the `configurable` attribute of `o.a` had been `true`, none of the errors would be thrown and the property would be deleted at the end.\n\nThis example illustrates a non-configurable but writable data property. The property\'s `value` can still be changed, and `writable` can still be toggled from `true` to `false`.\n\n```js\nconst o = {};\nObject.defineProperty(o, "b", {\n  writable: true,\n  configurable: false,\n});\nconsole.log(o.b); // undefined\nObject.defineProperty(o, "b", {\n  value: 1,\n}); // Even when configurable is false, because the object is writable, we may still replace the value\nconsole.log(o.b); // 1\no.b = 2; // We can change the value with assignment operators as well\nconsole.log(o.b); // 2\n// Toggle the property\'s writability\nObject.defineProperty(o, "b", {\n  writable: false,\n});\nObject.defineProperty(o, "b", {\n  value: 1,\n}); // TypeError: because the property is neither writable nor configurable, it cannot be modified\n// At this point, there\'s no way to further modify \'b\'\n// or restore its writability\n```\n\nThis example illustrates a configurable but non-writable data property. The property\'s `value` may still be replaced with `defineProperty` (but not with assignment operators), and `writable` may be toggled.\n\n```js\nconst o = {};\nObject.defineProperty(o, "b", {\n  writable: false,\n  configurable: true,\n});\nObject.defineProperty(o, "b", {\n  value: 1,\n}); // We can replace the value with defineProperty\nconsole.log(o.b); // 1\no.b = 2; // throws TypeError in strict mode: cannot change a non-writable property\'s value with assignment\n```\n\nThis example illustrates a non-configurable and non-writable data property. There\'s no way to update any attribute of the property, including its `value`.\n\n```js\nconst o = {};\nObject.defineProperty(o, "b", {\n  writable: false,\n  configurable: false,\n});\nObject.defineProperty(o, "b", {\n  value: 1,\n}); // TypeError: the property cannot be modified because it is neither writable nor configurable.\n```\n\n### Adding properties and default values\n\nIt is important to consider the way default values of attributes are applied. There is often a difference between using [property accessors](/en-US/docs/Web/JavaScript/Reference/Operators/Property_accessors) to assign a value and using `Object.defineProperty()`, as shown in the example below.\n\n```js\nconst o = {};\n\no.a = 1;\n// is equivalent to:\nObject.defineProperty(o, "a", {\n  value: 1,\n  writable: true,\n  configurable: true,\n  enumerable: true,\n});\n\n// On the other hand,\nObject.defineProperty(o, "a", { value: 1 });\n// is equivalent to:\nObject.defineProperty(o, "a", {\n  value: 1,\n  writable: false,\n  configurable: false,\n  enumerable: false,\n});\n```\n\n### Custom setters and getters\n\nThe example below shows how to implement a self-archiving object. When `temperature` property is set, the `archive` array gets a log entry.\n\n```js\nfunction Archiver() {\n  let temperature = null;\n  const archive = [];\n\n  Object.defineProperty(this, "temperature", {\n    get() {\n      console.log("get!");\n      return temperature;\n    },\n    set(value) {\n      temperature = value;\n      archive.push({ val: temperature });\n    },\n  });\n\n  this.getArchive = () => archive;\n}\n\nconst arc = new Archiver();\narc.temperature; // \'get!\'\narc.temperature = 11;\narc.temperature = 13;\narc.getArchive(); // [{ val: 11 }, { val: 13 }]\n```\n\nIn this example, a getter always returns the same value.\n\n```js\nconst pattern = {\n  get() {\n    return "I always return this string, whatever you have assigned";\n  },\n  set() {\n    this.myname = "this is my name string";\n  },\n};\n\nfunction TestDefineSetAndGet() {\n  Object.defineProperty(this, "myproperty", pattern);\n}\n\nconst instance = new TestDefineSetAndGet();\ninstance.myproperty = "test";\nconsole.log(instance.myproperty);\n// I always return this string, whatever you have assigned\n\nconsole.log(instance.myname); // this is my name string\n```\n\n### Inheritance of properties\n\nIf an accessor property is inherited, its `get` and `set` methods will be called when the property is accessed and modified on descendant objects. If these methods use a variable to store the value, this value will be shared by all objects.\n\n```js\nfunction MyClass() {}\n\nlet value;\nObject.defineProperty(MyClass.prototype, "x", {\n  get() {\n    return value;\n  },\n  set(x) {\n    value = x;\n  },\n});\n\nconst a = new MyClass();\nconst b = new MyClass();\na.x = 1;\nconsole.log(b.x); // 1\n```\n\nThis can be fixed by storing the value in another property. In `get` and `set` methods, `this` points to the object which is used to access or modify the property.\n\n```js\nfunction MyClass() {}\n\nObject.defineProperty(MyClass.prototype, "x", {\n  get() {\n    return this.storedX;\n  },\n  set(x) {\n    this.storedX = x;\n  },\n});\n\nconst a = new MyClass();\nconst b = new MyClass();\na.x = 1;\nconsole.log(b.x); // undefined\n```\n\nUnlike accessor properties, data properties are always set on the object itself, not on a prototype. However, if a non-writable data property is inherited, it is still prevented from being modified on the object.\n\n```js\nfunction MyClass() {}\n\nMyClass.prototype.x = 1;\nObject.defineProperty(MyClass.prototype, "y", {\n  writable: false,\n  value: 1,\n});\n\nconst a = new MyClass();\na.x = 2;\nconsole.log(a.x); // 2\nconsole.log(MyClass.prototype.x); // 1\na.y = 2; // Ignored, throws in strict mode\nconsole.log(a.y); // 1\nconsole.log(MyClass.prototype.y); // 1\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Enumerability and ownership of properties](/en-US/docs/Web/JavaScript/Enumerability_and_ownership_of_properties)\n- {{jsxref("Object.defineProperties()")}}\n- {{jsxref("Object.prototype.propertyIsEnumerable()")}}\n- {{jsxref("Object.getOwnPropertyDescriptor()")}}\n- {{jsxref("Functions/get", "get")}}\n- {{jsxref("Functions/set", "set")}}\n- {{jsxref("Object.create()")}}\n- {{jsxref("Reflect.defineProperty()")}}\n'
        },
        "entries": {
            "index.md": '---\ntitle: Object.entries()\nslug: Web/JavaScript/Reference/Global_Objects/Object/entries\npage-type: javascript-static-method\nbrowser-compat: javascript.builtins.Object.entries\n---\n\n{{JSRef}}\n\nThe **`Object.entries()`** static method returns an array of a given object\'s own enumerable string-keyed property key-value pairs.\n\n{{EmbedInteractiveExample("pages/js/object-entries.html")}}\n\n## Syntax\n\n```js-nolint\nObject.entries(obj)\n```\n\n### Parameters\n\n- `obj`\n  - : An object.\n\n### Return value\n\nAn array of the given object\'s own enumerable string-keyed property key-value pairs. Each key-value pair is an array with two elements: the first element is the property key (which is always a string), and the second element is the property value.\n\n## Description\n\n`Object.entries()` returns an array whose elements are arrays corresponding to the enumerable string-keyed property key-value pairs found directly upon `object`. This is the same as iterating with a {{jsxref("Statements/for...in", "for...in")}} loop, except that a `for...in` loop enumerates properties in the prototype chain as well. The order of the array returned by `Object.entries()` is the same as that provided by a {{jsxref("Statements/for...in", "for...in")}} loop.\n\nIf you only need the property keys, use {{jsxref("Object.keys()")}} instead. If you only need the property values, use {{jsxref("Object.values()")}} instead.\n\n## Examples\n\n### Using Object.entries()\n\n```js\nconst obj = { foo: "bar", baz: 42 };\nconsole.log(Object.entries(obj)); // [ [\'foo\', \'bar\'], [\'baz\', 42] ]\n\nconst arrayLike = { 0: "a", 1: "b", 2: "c" };\nconsole.log(Object.entries(arrayLike)); // [ [\'0\', \'a\'], [\'1\', \'b\'], [\'2\', \'c\'] ]\n\nconst randomKeyOrder = { 100: "a", 2: "b", 7: "c" };\nconsole.log(Object.entries(randomKeyOrder)); // [ [\'2\', \'b\'], [\'7\', \'c\'], [\'100\', \'a\'] ]\n\n// getFoo is a non-enumerable property\nconst myObj = Object.create(\n  {},\n  {\n    getFoo: {\n      value() {\n        return this.foo;\n      },\n    },\n  },\n);\nmyObj.foo = "bar";\nconsole.log(Object.entries(myObj)); // [ [\'foo\', \'bar\'] ]\n```\n\n### Using Object.entries() on primitives\n\nNon-object arguments are [coerced to objects](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object#object_coercion). [`undefined`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/undefined) and [`null`](/en-US/docs/Web/JavaScript/Reference/Operators/null) cannot be coerced to objects and throw a {{jsxref("TypeError")}} upfront. Only strings may have own enumerable properties, while all other primitives return an empty array.\n\n```js\n// Strings have indices as enumerable own properties\nconsole.log(Object.entries("foo")); // [ [\'0\', \'f\'], [\'1\', \'o\'], [\'2\', \'o\'] ]\n\n// Other primitives except undefined and null have no own properties\nconsole.log(Object.entries(100)); // []\n```\n\n### Converting an Object to a Map\n\nThe {{jsxref("Map/Map", "Map()")}} constructor accepts an iterable of `entries`. With `Object.entries`, you can easily convert from {{jsxref("Object")}} to {{jsxref("Map")}}:\n\n```js\nconst obj = { foo: "bar", baz: 42 };\nconst map = new Map(Object.entries(obj));\nconsole.log(map); // Map(2) {"foo" => "bar", "baz" => 42}\n```\n\n### Iterating through an Object\n\nUsing [array destructuring](/en-US/docs/Web/JavaScript/Reference/Operators/Destructuring_assignment#array_destructuring), you can iterate through objects easily.\n\n```js\n// Using for...of loop\nconst obj = { a: 5, b: 7, c: 9 };\nfor (const [key, value] of Object.entries(obj)) {\n  console.log(`${key} ${value}`); // "a 5", "b 7", "c 9"\n}\n\n// Using array methods\nObject.entries(obj).forEach(([key, value]) => {\n  console.log(`${key} ${value}`); // "a 5", "b 7", "c 9"\n});\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Object.entries` in `core-js`](https://github.com/zloirock/core-js#ecmascript-object)\n- [Enumerability and ownership of properties](/en-US/docs/Web/JavaScript/Enumerability_and_ownership_of_properties)\n- {{jsxref("Object.keys()")}}\n- {{jsxref("Object.values()")}}\n- {{jsxref("Object.prototype.propertyIsEnumerable()")}}\n- {{jsxref("Object.create()")}}\n- {{jsxref("Object.fromEntries()")}}\n- {{jsxref("Object.getOwnPropertyNames()")}}\n- {{jsxref("Map.prototype.entries()")}}\n'
        },
        "freeze": {
            "index.md": '---\ntitle: Object.freeze()\nslug: Web/JavaScript/Reference/Global_Objects/Object/freeze\npage-type: javascript-static-method\nbrowser-compat: javascript.builtins.Object.freeze\n---\n\n{{JSRef}}\n\nThe **`Object.freeze()`** static method _freezes_ an object. Freezing an object [prevents extensions](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/preventExtensions) and makes existing properties non-writable and non-configurable. A frozen object can no longer be changed: new properties cannot be added, existing properties cannot be removed, their enumerability, configurability, writability, or value cannot be changed, and the object\'s prototype cannot be re-assigned. `freeze()` returns the same object that was passed in.\n\nFreezing an object is the highest integrity level that JavaScript provides.\n\n{{EmbedInteractiveExample("pages/js/object-freeze.html")}}\n\n## Syntax\n\n```js-nolint\nObject.freeze(obj)\n```\n\n### Parameters\n\n- `obj`\n  - : The object to freeze.\n\n### Return value\n\nThe object that was passed to the function.\n\n## Description\n\nFreezing an object is equivalent to [preventing extensions](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/preventExtensions) and then changing all existing [properties\' descriptors\'](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/defineProperty#description) `configurable` to `false` \u2014 and for data properties, `writable` to `false` as well. Nothing can be added to or removed from the properties set of a frozen object. Any attempt to do so will fail, either silently or by throwing a {{jsxref("TypeError")}} exception (most commonly, but not exclusively, when in {{jsxref("Strict_mode", "strict mode", "", 1)}}).\n\nFor data properties of a frozen object, their values cannot be changed since the `writable` and\n`configurable` attributes are set to `false`. Accessor properties (getters and setters) work the same \u2014 the property value returned by the getter may still change, and the setter can still be called without throwing errors when setting the property. Note that values\nthat are objects can still be modified, unless they are also frozen. As an object, an\narray can be frozen; after doing so, its elements cannot be altered and no elements can\nbe added to or removed from the array.\n\n[Private properties](/en-US/docs/Web/JavaScript/Reference/Classes/Private_properties) do not have the concept of property descriptors. Freezing an object with private properties does not prevent the values of these private properties from being changed. (Freezing objects is usually meant as a security measure against external code, but external code cannot access private properties anyway.) Private properties cannot be added or removed from the object, whether the object is frozen or not.\n\n`freeze()` returns the same object that was passed into the function. It\n_does not_ create a frozen copy.\n\nA {{jsxref("TypedArray")}} or a {{jsxref("DataView")}} with elements will cause a {{jsxref("TypeError")}},\nas they are views over memory and will definitely cause other possible issues:\n\n```js\nObject.freeze(new Uint8Array(0)); // No elements\n// Uint8Array []\n\nObject.freeze(new Uint8Array(1)); // Has elements\n// TypeError: Cannot freeze array buffer views with elements\n\nObject.freeze(new DataView(new ArrayBuffer(32))); // No elements\n// DataView {}\n\nObject.freeze(new Float64Array(new ArrayBuffer(64), 63, 0)); // No elements\n// Float64Array []\n\nObject.freeze(new Float64Array(new ArrayBuffer(64), 32, 2)); // Has elements\n// TypeError: Cannot freeze array buffer views with elements\n```\n\nNote that as the standard three properties (`buf.byteLength`,\n`buf.byteOffset` and `buf.buffer`) are read-only (as are those of\nan {{jsxref("ArrayBuffer")}} or {{jsxref("SharedArrayBuffer")}}), there is no reason for\nattempting to freeze these properties.\n\nUnlike {{jsxref("Object.seal()")}}, existing properties in objects frozen with `Object.freeze()` are made immutable and data properties cannot be re-assigned.\n\n## Examples\n\n### Freezing objects\n\n```js\nconst obj = {\n  prop() {},\n  foo: "bar",\n};\n\n// Before freezing: new properties may be added,\n// and existing properties may be changed or removed\nobj.foo = "baz";\nobj.lumpy = "woof";\ndelete obj.prop;\n\n// Freeze.\nconst o = Object.freeze(obj);\n\n// The return value is just the same object we passed in.\no === obj; // true\n\n// The object has become frozen.\nObject.isFrozen(obj); // === true\n\n// Now any changes will fail\nobj.foo = "quux"; // silently does nothing\n// silently doesn\'t add the property\nobj.quaxxor = "the friendly duck";\n\n// In strict mode such attempts will throw TypeErrors\nfunction fail() {\n  "use strict";\n  obj.foo = "sparky"; // throws a TypeError\n  delete obj.foo; // throws a TypeError\n  delete obj.quaxxor; // returns true since attribute \'quaxxor\' was never added\n  obj.sparky = "arf"; // throws a TypeError\n}\n\nfail();\n\n// Attempted changes through Object.defineProperty;\n// both statements below throw a TypeError.\nObject.defineProperty(obj, "ohai", { value: 17 });\nObject.defineProperty(obj, "foo", { value: "eit" });\n\n// It\'s also impossible to change the prototype\n// both statements below will throw a TypeError.\nObject.setPrototypeOf(obj, { x: 20 });\nobj.__proto__ = { x: 20 };\n```\n\n### Freezing arrays\n\n```js\nconst a = [0];\nObject.freeze(a); // The array cannot be modified now.\n\na[0] = 1; // fails silently\n\n// In strict mode such attempt will throw a TypeError\nfunction fail() {\n  "use strict";\n  a[0] = 1;\n}\n\nfail();\n\n// Attempted to push\na.push(2); // throws a TypeError\n```\n\nThe object being frozen is _immutable_. However, it is not necessarily\n_constant_. The following example shows that a frozen object is not constant\n(freeze is shallow).\n\n```js\nconst obj1 = {\n  internal: {},\n};\n\nObject.freeze(obj1);\nobj1.internal.a = "aValue";\n\nobj1.internal.a; // \'aValue\'\n```\n\nTo be a constant object, the entire reference graph (direct and indirect references to\nother objects) must reference only immutable frozen objects. The object being frozen is\nsaid to be immutable because the entire object _state_ (values and references to\nother objects) within the whole object is fixed. Note that strings, numbers, and\nbooleans are always immutable and that Functions and Arrays are objects.\n\n#### What is "shallow freeze"?\n\nThe result of calling `Object.freeze(object)` only applies to the\nimmediate properties of `object` itself and will prevent future property\naddition, removal or value re-assignment operations _only_ on\n`object`. If the value of those properties are objects themselves, those\nobjects are not frozen and may be the target of property addition, removal or value\nre-assignment operations.\n\n```js\nconst employee = {\n  name: "Mayank",\n  designation: "Developer",\n  address: {\n    street: "Rohini",\n    city: "Delhi",\n  },\n};\n\nObject.freeze(employee);\n\nemployee.name = "Dummy"; // fails silently in non-strict mode\nemployee.address.city = "Noida"; // attributes of child object can be modified\n\nconsole.log(employee.address.city); // "Noida"\n```\n\nTo make an object immutable, recursively freeze each non-primitive property\n(deep freeze). Use the pattern on a case-by-case basis based on your design when you\nknow the object contains no [cycles](<https://en.wikipedia.org/wiki/Cycle_(graph_theory)>) in the reference\ngraph, otherwise an endless loop will be triggered. An enhancement to\n`deepFreeze()` would be to have an internal function that receives a path\n(e.g. an Array) argument so you can suppress calling `deepFreeze()`\nrecursively when an object is in the process of being made immutable. You still run a\nrisk of freezing an object that shouldn\'t be frozen, such as [`window`](/en-US/docs/Web/API/Window).\n\n```js\nfunction deepFreeze(object) {\n  // Retrieve the property names defined on object\n  const propNames = Reflect.ownKeys(object);\n\n  // Freeze properties before freezing self\n  for (const name of propNames) {\n    const value = object[name];\n\n    if ((value && typeof value === "object") || typeof value === "function") {\n      deepFreeze(value);\n    }\n  }\n\n  return Object.freeze(object);\n}\n\nconst obj2 = {\n  internal: {\n    a: null,\n  },\n};\n\ndeepFreeze(obj2);\n\nobj2.internal.a = "anotherValue"; // fails silently in non-strict mode\nobj2.internal.a; // null\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Object.isFrozen()")}}\n- {{jsxref("Object.preventExtensions()")}}\n- {{jsxref("Object.isExtensible()")}}\n- {{jsxref("Object.seal()")}}\n- {{jsxref("Object.isSealed()")}}\n'
        },
        "fromentries": {
            "index.md": '---\ntitle: Object.fromEntries()\nslug: Web/JavaScript/Reference/Global_Objects/Object/fromEntries\npage-type: javascript-static-method\nbrowser-compat: javascript.builtins.Object.fromEntries\n---\n\n{{JSRef}}\n\nThe **`Object.fromEntries()`** static method transforms a list of key-value pairs into an object.\n\n{{EmbedInteractiveExample("pages/js/object-fromentries.html")}}\n\n## Syntax\n\n```js-nolint\nObject.fromEntries(iterable)\n```\n\n### Parameters\n\n- `iterable`\n\n  - : An [iterable](/en-US/docs/Web/JavaScript/Reference/Iteration_protocols#the_iterable_protocol), such as an {{jsxref("Array")}} or {{jsxref("Map")}}, containing a list of objects. Each object should have two properties:\n\n    - `0`\n      - : A string or [symbol](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol) representing the property key.\n    - `1`\n      - : The property value.\n\n    Typically, this object is implemented as a two-element array, with the first element being the property key and the second element being the property value.\n\n### Return value\n\nA new object whose properties are given by the entries of the iterable.\n\n## Description\n\nThe `Object.fromEntries()` method takes a list of key-value pairs and returns a new object whose properties are given by those entries. The `iterable` argument is expected to be an object that implements an `@@iterator` method. The method returns an iterator object that produces two-element array-like objects. The first element is a value that will be used as a property key, and the second element is the value to associate with that property key.\n\n`Object.fromEntries()` performs the reverse of {{jsxref("Object.entries()")}}, except that `Object.entries()` only returns string-keyed properties, while `Object.fromEntries()` can also create symbol-keyed properties.\n\n> **Note:** Unlike {{jsxref("Array.from()")}}, `Object.fromEntries()` does not use the value of `this`, so calling it on another constructor does not create objects of that type.\n\n## Examples\n\n### Converting a Map to an Object\n\nWith `Object.fromEntries`, you can convert from {{jsxref("Map")}} to {{jsxref("Object")}}:\n\n```js\nconst map = new Map([\n  ["foo", "bar"],\n  ["baz", 42],\n]);\nconst obj = Object.fromEntries(map);\nconsole.log(obj); // { foo: "bar", baz: 42 }\n```\n\n### Converting an Array to an Object\n\nWith `Object.fromEntries`, you can convert from {{jsxref("Array")}} to {{jsxref("Object")}}:\n\n```js\nconst arr = [\n  ["0", "a"],\n  ["1", "b"],\n  ["2", "c"],\n];\nconst obj = Object.fromEntries(arr);\nconsole.log(obj); // { 0: "a", 1: "b", 2: "c" }\n```\n\n### Object transformations\n\nWith `Object.fromEntries`, its reverse method {{jsxref("Object.entries()")}}, and [array manipulation methods](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array#instance_methods), you are able to transform objects like this:\n\n```js\nconst object1 = { a: 1, b: 2, c: 3 };\n\nconst object2 = Object.fromEntries(\n  Object.entries(object1).map(([key, val]) => [key, val * 2]),\n);\n\nconsole.log(object2);\n// { a: 2, b: 4, c: 6 }\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Object.fromEntries` in `core-js`](https://github.com/zloirock/core-js#ecmascript-object)\n- {{jsxref("Object.entries()")}}\n- {{jsxref("Object.keys()")}}\n- {{jsxref("Object.values()")}}\n- {{jsxref("Object.prototype.propertyIsEnumerable()")}}\n- {{jsxref("Object.create()")}}\n- {{jsxref("Map.prototype.entries()")}}\n- {{jsxref("Map.prototype.keys()")}}\n- {{jsxref("Map.prototype.values()")}}\n'
        },
        "getownpropertydescriptor": {
            "index.md": '---\ntitle: Object.getOwnPropertyDescriptor()\nslug: Web/JavaScript/Reference/Global_Objects/Object/getOwnPropertyDescriptor\npage-type: javascript-static-method\nbrowser-compat: javascript.builtins.Object.getOwnPropertyDescriptor\n---\n\n{{JSRef}}\n\nThe **`Object.getOwnPropertyDescriptor()`** static method returns an\nobject describing the configuration of a specific property on a given object (that is,\none directly present on an object and not in the object\'s prototype chain). The object\nreturned is mutable but mutating it has no effect on the original property\'s\nconfiguration.\n\n{{EmbedInteractiveExample("pages/js/object-getownpropertydescriptor.html")}}\n\n## Syntax\n\n```js-nolint\nObject.getOwnPropertyDescriptor(obj, prop)\n```\n\n### Parameters\n\n- `obj`\n  - : The object in which to look for the property.\n- `prop`\n  - : The name or {{jsxref("Symbol")}} of the property whose description is to be\n    retrieved.\n\n### Return value\n\nA property descriptor of the given property if it exists on the object,\n{{jsxref("undefined")}} otherwise.\n\n## Description\n\nThis method permits examination of the precise description of a property. A\n_property_ in JavaScript consists of either a string-valued name or a\n{{jsxref("Symbol")}} and a property descriptor. Further information about property\ndescriptor types and their attributes can be found in\n{{jsxref("Object.defineProperty()")}}.\n\nA _property descriptor_ is a record with some of the following attributes:\n\n- `value`\n  - : The value associated with the property (data descriptors only).\n- `writable`\n  - : `true` if and only if the value associated with the property may be\n    changed (data descriptors only).\n- `get`\n  - : A function which serves as a getter for the property, or {{jsxref("undefined")}} if\n    there is no getter (accessor descriptors only).\n- `set`\n  - : A function which serves as a setter for the property, or {{jsxref("undefined")}} if\n    there is no setter (accessor descriptors only).\n- `configurable`\n  - : `true` if and only if the type of this property descriptor may be changed\n    and if the property may be deleted from the corresponding object.\n- `enumerable`\n  - : `true` if and only if this property shows up during enumeration of the\n    properties on the corresponding object.\n\n## Examples\n\n### Using Object.getOwnPropertyDescriptor()\n\n```js\nlet o, d;\n\no = {\n  get foo() {\n    return 17;\n  },\n};\nd = Object.getOwnPropertyDescriptor(o, "foo");\nconsole.log(d);\n// {\n//   configurable: true,\n//   enumerable: true,\n//   get: [Function: get foo],\n//   set: undefined\n// }\n\no = { bar: 42 };\nd = Object.getOwnPropertyDescriptor(o, "bar");\nconsole.log(d);\n// {\n//   configurable: true,\n//   enumerable: true,\n//   value: 42,\n//   writable: true\n// }\n\no = { [Symbol.for("baz")]: 73 };\nd = Object.getOwnPropertyDescriptor(o, Symbol.for("baz"));\nconsole.log(d);\n// {\n//   configurable: true,\n//   enumerable: true,\n//   value: 73,\n//   writable: true\n// }\n\no = {};\nObject.defineProperty(o, "qux", {\n  value: 8675309,\n  writable: false,\n  enumerable: false,\n});\nd = Object.getOwnPropertyDescriptor(o, "qux");\nconsole.log(d);\n// {\n//   value: 8675309,\n//   writable: false,\n//   enumerable: false,\n//   configurable: false\n// }\n```\n\n### Non-object coercion\n\nIn ES5, if the first argument to this method is not an object (a primitive), then it\nwill cause a {{jsxref("TypeError")}}. In ES2015, a non-object first argument will be\ncoerced to an object at first.\n\n```js\nObject.getOwnPropertyDescriptor("foo", 0);\n// TypeError: "foo" is not an object  // ES5 code\n\nObject.getOwnPropertyDescriptor("foo", 0);\n// Object returned by ES2015 code: {\n//   configurable: false,\n//   enumerable: true,\n//   value: "f",\n//   writable: false\n// }\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Object.defineProperty()")}}\n- {{jsxref("Reflect.getOwnPropertyDescriptor()")}}\n'
        },
        "getownpropertydescriptors": {
            "index.md": '---\ntitle: Object.getOwnPropertyDescriptors()\nslug: Web/JavaScript/Reference/Global_Objects/Object/getOwnPropertyDescriptors\npage-type: javascript-static-method\nbrowser-compat: javascript.builtins.Object.getOwnPropertyDescriptors\n---\n\n{{JSRef}}\n\nThe **`Object.getOwnPropertyDescriptors()`** static method returns all\nown property descriptors of a given object.\n\n{{EmbedInteractiveExample("pages/js/object-getownpropertydescriptors.html")}}\n\n## Syntax\n\n```js-nolint\nObject.getOwnPropertyDescriptors(obj)\n```\n\n### Parameters\n\n- `obj`\n  - : The object for which to get all own property descriptors.\n\n### Return value\n\nAn object containing all own property descriptors of an object. Might be an empty\nobject, if there are no properties.\n\n## Description\n\nThis method permits examination of the precise description of all own properties of an\nobject. A _property_ in JavaScript consists of either a string-valued name or a\n{{jsxref("Symbol")}} and a property descriptor. Further information about property\ndescriptor types and their attributes can be found in\n{{jsxref("Object.defineProperty()")}}.\n\nA _property descriptor_ is a record with some of the following attributes:\n\n- `value`\n  - : The value associated with the property (data descriptors only).\n- `writable`\n  - : `true` if and only if the value associated with the property may be\n    changed (data descriptors only).\n- `get`\n  - : A function which serves as a getter for the property, or {{jsxref("undefined")}} if\n    there is no getter (accessor descriptors only).\n- `set`\n  - : A function which serves as a setter for the property, or {{jsxref("undefined")}} if\n    there is no setter (accessor descriptors only).\n- `configurable`\n  - : `true` if and only if the type of this property descriptor may be changed\n    and if the property may be deleted from the corresponding object.\n- `enumerable`\n  - : `true` if and only if this property shows up during enumeration of the\n    properties on the corresponding object.\n\n## Examples\n\n### Creating a shallow copy\n\nWhereas the {{jsxref("Object.assign()")}} method will only copy enumerable and own\nproperties from a source object to a target object, you are able to use this method and\n{{jsxref("Object.create()")}} for a [shallow copy](/en-US/docs/Glossary/Shallow_copy) between two unknown objects:\n\n```js\nObject.create(\n  Object.getPrototypeOf(obj),\n  Object.getOwnPropertyDescriptors(obj),\n);\n```\n\n### Creating a subclass\n\nA typical way of creating a subclass is to define the subclass, set its prototype to an\ninstance of the superclass, and then define properties on that instance. This can get\nawkward especially for getters and setters. Instead, you can use this code to set the\nprototype:\n\n```js\nfunction superclass() {}\nsuperclass.prototype = {\n  // Define the superclass constructor, methods, and properties here\n};\nfunction subclass() {}\nsubclass.prototype = Object.create(superclass.prototype, {\n  // Define the subclass constructor, methods, and properties here\n});\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Object.getOwnPropertyDescriptors` in `core-js`](https://github.com/zloirock/core-js#ecmascript-object)\n- {{jsxref("Object.getOwnPropertyDescriptor()")}}\n- {{jsxref("Object.defineProperty()")}}\n'
        },
        "getownpropertynames": {
            "index.md": '---\ntitle: Object.getOwnPropertyNames()\nslug: Web/JavaScript/Reference/Global_Objects/Object/getOwnPropertyNames\npage-type: javascript-static-method\nbrowser-compat: javascript.builtins.Object.getOwnPropertyNames\n---\n\n{{JSRef}}\n\nThe **`Object.getOwnPropertyNames()`** static method returns an array of all properties (including non-enumerable properties except for those which use Symbol) found directly in a given object.\n\n{{EmbedInteractiveExample("pages/js/object-getownpropertynames.html")}}\n\n## Syntax\n\n```js-nolint\nObject.getOwnPropertyNames(obj)\n```\n\n### Parameters\n\n- `obj`\n  - : The object whose enumerable and non-enumerable properties are to be returned.\n\n### Return value\n\nAn array of strings that corresponds to the properties found directly in the given object.\n\n## Description\n\n`Object.getOwnPropertyNames()` returns an array whose elements are strings corresponding to the enumerable and non-enumerable properties found directly in a given object `obj`. The ordering of the enumerable properties in the array is consistent with the ordering exposed by a {{jsxref("Statements/for...in", "for...in")}} loop (or by {{jsxref("Object.keys()")}}) over the properties of the object. The non-negative integer keys of the object (both enumerable and non-enumerable) are added in ascending order to the array first, followed by the string keys in the order of insertion.\n\nIn ES5, if the argument to this method is not an object (a primitive), then it will cause a {{jsxref("TypeError")}}. In ES2015, a non-object argument will be coerced to an object.\n\n```js\nObject.getOwnPropertyNames("foo");\n// TypeError: "foo" is not an object (ES5 code)\n\nObject.getOwnPropertyNames("foo");\n// ["0", "1", "2", "length"]  (ES2015 code)\n```\n\n## Examples\n\n### Using Object.getOwnPropertyNames()\n\n```js\nconst arr = ["a", "b", "c"];\nconsole.log(Object.getOwnPropertyNames(arr).sort());\n// ["0", "1", "2", "length"]\n\n// Array-like object\nconst obj = { 0: "a", 1: "b", 2: "c" };\nconsole.log(Object.getOwnPropertyNames(obj).sort());\n// ["0", "1", "2"]\n\nObject.getOwnPropertyNames(obj).forEach((val, idx, array) => {\n  console.log(`${val} -> ${obj[val]}`);\n});\n// 0 -> a\n// 1 -> b\n// 2 -> c\n\n// non-enumerable property\nconst myObj = Object.create(\n  {},\n  {\n    getFoo: {\n      value() {\n        return this.foo;\n      },\n      enumerable: false,\n    },\n  },\n);\nmyObj.foo = 1;\n\nconsole.log(Object.getOwnPropertyNames(myObj).sort()); // ["foo", "getFoo"]\n```\n\nIf you want only the enumerable properties, see {{jsxref("Object.keys()")}} or use a {{jsxref("Statements/for...in", "for...in")}} loop (note that this will also return enumerable properties found along the prototype chain for the object unless the latter is filtered with {{jsxref("Object.hasOwn()")}}).\n\nItems on the prototype chain are not listed:\n\n```js\nfunction ParentClass() {}\nParentClass.prototype.inheritedMethod = function () {};\n\nfunction ChildClass() {\n  this.prop = 5;\n  this.method = function () {};\n}\nChildClass.prototype = new ParentClass();\nChildClass.prototype.prototypeMethod = function () {};\n\nconsole.log(Object.getOwnPropertyNames(new ChildClass()));\n// ["prop", "method"]\n```\n\n### Get non-enumerable properties only\n\nThis uses the {{jsxref("Array.prototype.filter()")}} function to remove the enumerable keys (obtained with {{jsxref("Object.keys()")}}) from a list of all keys (obtained with `Object.getOwnPropertyNames()`) thus giving only the non-enumerable keys as output.\n\n```js\nconst target = myObject;\nconst enumAndNonenum = Object.getOwnPropertyNames(target);\nconst enumOnly = new Set(Object.keys(target));\nconst nonenumOnly = enumAndNonenum.filter((key) => !enumOnly.has(key));\n\nconsole.log(nonenumOnly);\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Object.getOwnPropertyNames` in `core-js`](https://github.com/zloirock/core-js#ecmascript-object)\n- [Enumerability and ownership of properties](/en-US/docs/Web/JavaScript/Enumerability_and_ownership_of_properties)\n- {{jsxref("Object.hasOwn()")}}\n- {{jsxref("Object.prototype.propertyIsEnumerable()")}}\n- {{jsxref("Object.create()")}}\n- {{jsxref("Object.keys()")}}\n- {{jsxref("Array.prototype.forEach()")}}\n'
        },
        "getownpropertysymbols": {
            "index.md": '---\ntitle: Object.getOwnPropertySymbols()\nslug: Web/JavaScript/Reference/Global_Objects/Object/getOwnPropertySymbols\npage-type: javascript-static-method\nbrowser-compat: javascript.builtins.Object.getOwnPropertySymbols\n---\n\n{{JSRef}}\n\nThe **`Object.getOwnPropertySymbols()`** static method returns an array of all symbol properties found directly upon a given object.\n\n{{EmbedInteractiveExample("pages/js/object-getownpropertysymbols.html")}}\n\n## Syntax\n\n```js-nolint\nObject.getOwnPropertySymbols(obj)\n```\n\n### Parameters\n\n- `obj`\n  - : The object whose symbol properties are to be returned.\n\n### Return value\n\nAn array of all symbol properties found directly upon the given object.\n\n## Description\n\nSimilar to {{jsxref("Object.getOwnPropertyNames()")}}, you can get all symbol properties of a given object as an array of symbols. Note that {{jsxref("Object.getOwnPropertyNames()")}} itself does not contain the symbol properties of an object and only the string properties.\n\nAs all objects have no own symbol properties initially, `Object.getOwnPropertySymbols()` returns an empty array unless you have set symbol properties on your object.\n\n## Examples\n\n### Using Object.getOwnPropertySymbols()\n\n```js\nconst obj = {};\nconst a = Symbol("a");\nconst b = Symbol.for("b");\n\nobj[a] = "localSymbol";\nobj[b] = "globalSymbol";\n\nconst objectSymbols = Object.getOwnPropertySymbols(obj);\n\nconsole.log(objectSymbols.length); // 2\nconsole.log(objectSymbols); // [Symbol(a), Symbol(b)]\nconsole.log(objectSymbols[0]); // Symbol(a)\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Object.getOwnPropertySymbols` in `core-js`](https://github.com/zloirock/core-js#ecmascript-symbol)\n- {{jsxref("Object.getOwnPropertyNames()")}}\n- {{jsxref("Symbol")}}\n'
        },
        "getprototypeof": {
            "index.md": '---\ntitle: Object.getPrototypeOf()\nslug: Web/JavaScript/Reference/Global_Objects/Object/getPrototypeOf\npage-type: javascript-static-method\nbrowser-compat: javascript.builtins.Object.getPrototypeOf\n---\n\n{{JSRef}}\n\nThe **`Object.getPrototypeOf()`** static method returns the prototype\n(i.e. the value of the internal `[[Prototype]]` property) of the specified\nobject.\n\n{{EmbedInteractiveExample("pages/js/object-getprototypeof.html", "shorter")}}\n\n## Syntax\n\n```js-nolint\nObject.getPrototypeOf(obj)\n```\n\n### Parameters\n\n- `obj`\n  - : The object whose prototype is to be returned.\n\n### Return value\n\nThe prototype of the given object, which may be [`null`](/en-US/docs/Web/JavaScript/Reference/Operators/null).\n\n## Examples\n\n### Using getPrototypeOf\n\n```js\nconst proto = {};\nconst obj = Object.create(proto);\nObject.getPrototypeOf(obj) === proto; // true\n```\n\n### Non-object coercion\n\nIn ES5, it will throw a {{jsxref("TypeError")}} exception if the `obj`\nparameter isn\'t an object. In ES2015, the parameter will be coerced to an\n{{jsxref("Object")}}.\n\n```js\nObject.getPrototypeOf("foo");\n// TypeError: "foo" is not an object (ES5 code)\nObject.getPrototypeOf("foo");\n// String.prototype                  (ES2015 code)\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Object.getPrototypeOf` in `core-js`](https://github.com/zloirock/core-js#ecmascript-object)\n- {{jsxref("Object.prototype.isPrototypeOf()")}}\n- {{jsxref("Object.setPrototypeOf()")}}\n- [`Object.prototype.__proto__`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/proto)\n- {{jsxref("Reflect.getPrototypeOf()")}}\n- [Object.getPrototypeOf](https://johnresig.com/blog/objectgetprototypeof/) by John Resig (2008)\n'
        },
        "groupby": {
            "index.md": '---\ntitle: Object.groupBy()\nslug: Web/JavaScript/Reference/Global_Objects/Object/groupBy\npage-type: javascript-static-method\nbrowser-compat: javascript.builtins.Object.groupBy\n---\n\n{{JSRef}}\n\n> **Note:** In some versions of some browsers, this method was implemented as the method `Array.prototype.group()`. Due to web compatibility issues, it is now implemented as a static method. Check the [browser compatibility table](#browser_compatibility) for details.\n\nThe **`Object.groupBy()`** static method groups the elements of a given iterable according to the string values returned by a provided callback function. The returned object has separate properties for each group, containing arrays with the elements in the group.\n\nThis method should be used when group names can be represented by strings. If you need to group elements using a key that is some arbitrary value, use {{jsxref("Map.groupBy()")}} instead.\n\n<!-- {{EmbedInteractiveExample("pages/js/object-groupby.html")}} -->\n\n## Syntax\n\n```js-nolint\nObject.groupBy(items, callbackFn)\n```\n\n### Parameters\n\n- `items`\n  - : An [iterable](/en-US/docs/Web/JavaScript/Reference/Iteration_protocols#the_iterable_protocol) (such as an {{jsxref("Array")}}) whose elements will be grouped.\n- `callbackFn`\n  - : A function to execute for each element in the iterable. It should return a value that can get coerced into a property key (string or [symbol](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol)) indicating the group of the current element. The function is called with the following arguments:\n    - `element`\n      - : The current element being processed.\n    - `index`\n      - : The index of the current element being processed.\n\n### Return value\n\nA [`null`-prototype object](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object#null-prototype_objects) with properties for all groups, each assigned to an array containing the elements of the associated group.\n\n## Description\n\n`Object.groupBy()` calls a provided `callbackFn` function once for each element in an iterable. The callback function should return a string or symbol (values that are neither type are [coerced to strings](/en-US/docs/Web/JavaScript/Reference/Global_Objects/String#string_coercion)) indicating the group of the associated element. The values returned by `callbackFn` are used as keys for the object returned by `Map.groupBy()`. Each key has an associated array containing all the elements for which the callback returned the same value.\n\nThe elements in the returned object and the original iterable are the same (not {{Glossary("deep copy", "deep copies")}}). Changing the internal structure of the elements will be reflected in both the original iterable and the returned object.\n\n## Examples\n\n### Using Object.groupBy()\n\nFirst we define an array containing objects representing an inventory of different foodstuffs. Each food has a `type` and a `quantity`.\n\n```js\nconst inventory = [\n  { name: "asparagus", type: "vegetables", quantity: 5 },\n  { name: "bananas", type: "fruit", quantity: 0 },\n  { name: "goat", type: "meat", quantity: 23 },\n  { name: "cherries", type: "fruit", quantity: 5 },\n  { name: "fish", type: "meat", quantity: 22 },\n];\n```\n\nThe code below groups the elements by the value of their `type` property.\n\n```js\nconst result = Object.groupBy(inventory, ({ type }) => type);\n\n/* Result is:\n{\n  vegetables: [\n    { name: \'asparagus\', type: \'vegetables\', quantity: 5 },\n  ],\n  fruit: [\n    { name: "bananas", type: "fruit", quantity: 0 },\n    { name: "cherries", type: "fruit", quantity: 5 }\n  ],\n  meat: [\n    { name: "goat", type: "meat", quantity: 23 },\n    { name: "fish", type: "meat", quantity: 22 }\n  ]\n}\n*/\n```\n\nThe arrow function just returns the `type` of each array element each time it is called. Note that the function argument `{ type }` is a basic example of [object destructuring syntax for function arguments](/en-US/docs/Web/JavaScript/Reference/Operators/Destructuring_assignment#unpacking_properties_from_objects_passed_as_a_function_parameter). This unpacks the `type` property of an object passed as a parameter, and assigns it to a variable named `type` in the body of the function.\nThis is a very succinct way to access the relevant values of elements within a function.\n\nWe can also create groups inferred from values in one or more properties of the elements. Below is a very similar example that puts the items into `ok` or `restock` groups based on the value of the `quantity` field.\n\n```js\nfunction myCallback({ quantity }) {\n  return quantity > 5 ? "ok" : "restock";\n}\n\nconst result2 = Object.groupBy(inventory, myCallback);\n\n/* Result is:\n{\n  restock: [\n    { name: "asparagus", type: "vegetables", quantity: 5 },\n    { name: "bananas", type: "fruit", quantity: 0 },\n    { name: "cherries", type: "fruit", quantity: 5 }\n  ],\n  ok: [\n    { name: "goat", type: "meat", quantity: 23 },\n    { name: "fish", type: "meat", quantity: 22 }\n  ]\n}\n*/\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Object.groupBy` in `core-js`](https://github.com/zloirock/core-js#array-grouping)\n- [Indexed collections](/en-US/docs/Web/JavaScript/Guide/Indexed_collections) guide\n- {{jsxref("Array.prototype.reduce()")}}\n- {{jsxref("Object.fromEntries()")}}\n- {{jsxref("Map.groupBy()")}}\n'
        },
        "hasown": {
            "index.md": '---\ntitle: Object.hasOwn()\nslug: Web/JavaScript/Reference/Global_Objects/Object/hasOwn\npage-type: javascript-static-method\nbrowser-compat: javascript.builtins.Object.hasOwn\n---\n\n{{JSRef}}\n\nThe **`Object.hasOwn()`** static method returns `true` if the specified object has the indicated property as its _own_ property.\nIf the property is inherited, or does not exist, the method returns `false`.\n\n> **Note:** `Object.hasOwn()` is intended as a replacement for {{jsxref("Object.prototype.hasOwnProperty()")}}.\n\n{{EmbedInteractiveExample("pages/js/object-hasown.html")}}\n\n## Syntax\n\n```js-nolint\nObject.hasOwn(obj, prop)\n```\n\n### Parameters\n\n- `obj`\n  - : The JavaScript object instance to test.\n- `prop`\n  - : The {{jsxref("String")}} name or [Symbol](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol) of the property to test.\n\n### Return value\n\n`true` if the specified object has directly defined the specified property.\nOtherwise `false`\n\n## Description\n\nThe **`Object.hasOwn()`** method returns `true` if the specified property is a\ndirect property of the object \u2014 even if the property value is `null` or `undefined`.\nThe method returns `false` if the property is inherited, or has not been declared at all.\nUnlike the {{jsxref("Operators/in", "in")}} operator, this\nmethod does not check for the specified property in the object\'s prototype chain.\n\nIt is recommended over {{jsxref("Object.prototype.hasOwnProperty()")}} because\nit works for [`null`-prototype objects](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object#null-prototype_objects) and with objects that\nhave overridden the inherited `hasOwnProperty()` method. While it is possible to\nworkaround these problems by calling `Object.prototype.hasOwnProperty()` on an\nexternal object, `Object.hasOwn()` is more intuitive.\n\n## Examples\n\n### Using hasOwn to test for a property\'s existence\n\nThe following code shows how to determine whether the `example` object contains a property named `prop`.\n\n```js\nconst example = {};\nObject.hasOwn(example, "prop"); // false - \'prop\' has not been defined\n\nexample.prop = "exists";\nObject.hasOwn(example, "prop"); // true - \'prop\' has been defined\n\nexample.prop = null;\nObject.hasOwn(example, "prop"); // true - own property exists with value of null\n\nexample.prop = undefined;\nObject.hasOwn(example, "prop"); // true - own property exists with value of undefined\n```\n\n### Direct vs. inherited properties\n\nThe following example differentiates between direct properties and properties inherited through the prototype chain:\n\n```js\nconst example = {};\nexample.prop = "exists";\n\n// `hasOwn` will only return true for direct properties:\nObject.hasOwn(example, "prop"); // true\nObject.hasOwn(example, "toString"); // false\nObject.hasOwn(example, "hasOwnProperty"); // false\n\n// The `in` operator will return true for direct or inherited properties:\n"prop" in example; // true\n"toString" in example; // true\n"hasOwnProperty" in example; // true\n```\n\n### Iterating over the properties of an object\n\nTo iterate over the enumerable properties of an object, you _should_ use:\n\n```js\nconst example = { foo: true, bar: true };\nfor (const name of Object.keys(example)) {\n  // \u2026\n}\n```\n\nBut if you need to use `for...in`, you can use `Object.hasOwn()` to skip the inherited properties:\n\n```js\nconst example = { foo: true, bar: true };\nfor (const name in example) {\n  if (Object.hasOwn(example, name)) {\n    // \u2026\n  }\n}\n```\n\n### Checking if an Array index exists\n\nThe elements of an {{jsxref("Array")}} are defined as direct properties, so\nyou can use `hasOwn()` method to check whether a particular index exists:\n\n```js\nconst fruits = ["Apple", "Banana", "Watermelon", "Orange"];\nObject.hasOwn(fruits, 3); // true (\'Orange\')\nObject.hasOwn(fruits, 4); // false - not defined\n```\n\n### Problematic cases for hasOwnProperty\n\nThis section demonstrates that `hasOwn()` is immune to the problems that affect\n`hasOwnProperty`. Firstly, it can be used with objects that have reimplemented\n`hasOwnProperty()`:\n\n```js\nconst foo = {\n  hasOwnProperty() {\n    return false;\n  },\n  bar: "The dragons be out of office",\n};\n\nif (Object.hasOwn(foo, "bar")) {\n  console.log(foo.bar); // true - re-implementation of hasOwnProperty() does not affect Object\n}\n```\n\nIt can also be used with [`null`-prototype objects](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object#null-prototype_objects). These do\nnot inherit from `Object.prototype`, and so `hasOwnProperty()` is inaccessible.\n\n```js\nconst foo = Object.create(null);\nfoo.prop = "exists";\nif (Object.hasOwn(foo, "prop")) {\n  console.log(foo.prop); // true - works irrespective of how the object is created.\n}\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Object.hasOwn` in `core-js`](https://github.com/zloirock/core-js#ecmascript-object)\n- {{jsxref("Object.prototype.hasOwnProperty()")}}\n- [Enumerability and ownership of properties](/en-US/docs/Web/JavaScript/Enumerability_and_ownership_of_properties)\n- {{jsxref("Object.getOwnPropertyNames()")}}\n- {{jsxref("Statements/for...in", "for...in")}}\n- {{jsxref("Operators/in", "in")}}\n- [Inheritance and the prototype chain](/en-US/docs/Web/JavaScript/Inheritance_and_the_prototype_chain)\n'
        },
        "hasownproperty": {
            "index.md": '---\ntitle: Object.prototype.hasOwnProperty()\nslug: Web/JavaScript/Reference/Global_Objects/Object/hasOwnProperty\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Object.hasOwnProperty\n---\n\n{{JSRef}}\n\nThe **`hasOwnProperty()`** method of {{jsxref("Object")}} instances returns a boolean indicating whether this\nobject has the specified property as its own property (as opposed to inheriting\nit).\n\n> **Note:** {{jsxref("Object.hasOwn()")}} is recommended over\n> `hasOwnProperty()`, in browsers where it is supported.\n\n{{EmbedInteractiveExample("pages/js/object-prototype-hasownproperty.html")}}\n\n## Syntax\n\n```js-nolint\nhasOwnProperty(prop)\n```\n\n### Parameters\n\n- `prop`\n  - : The {{jsxref("String")}} name or [Symbol](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol) of the property to test.\n\n### Return value\n\nReturns `true` if the object has the specified property as own property; `false`\notherwise.\n\n## Description\n\nThe **`hasOwnProperty()`** method returns `true` if the specified property is a\ndirect property of the object \u2014 even if the value is `null` or `undefined`. The\nmethod returns `false` if the property is inherited, or has not been declared at\nall. Unlike the {{jsxref("Operators/in", "in")}} operator, this\nmethod does not check for the specified property in the object\'s prototype\nchain.\n\nThe method can be called on _most_ JavaScript objects, because most objects\ndescend from {{jsxref("Object")}}, and hence inherit its methods. For\nexample {{jsxref("Array")}} is an {{jsxref("Object")}}, so you can\nuse `hasOwnProperty()` method to check whether an index exists:\n\n```js\nconst fruits = ["Apple", "Banana", "Watermelon", "Orange"];\nfruits.hasOwnProperty(3); // true (\'Orange\')\nfruits.hasOwnProperty(4); // false - not defined\n```\n\nThe method will not be available in objects where it is reimplemented, or on\n[`null`-prototype objects](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object#null-prototype_objects) (as these don\'t inherit from\n`Object.prototype`). Examples for these cases are given below.\n\n## Examples\n\n### Using hasOwnProperty to test for an own property\'s existence\n\nThe following code shows how to determine whether the `example` object contains a property named `prop`.\n\n```js\nconst example = {};\nexample.hasOwnProperty("prop"); // false\n\nexample.prop = "exists";\nexample.hasOwnProperty("prop"); // true - \'prop\' has been defined\n\nexample.prop = null;\nexample.hasOwnProperty("prop"); // true - own property exists with value of null\n\nexample.prop = undefined;\nexample.hasOwnProperty("prop"); // true - own property exists with value of undefined\n```\n\n### Direct vs. inherited properties\n\nThe following example differentiates between direct properties and properties inherited through the prototype chain:\n\n```js\nconst example = {};\nexample.prop = "exists";\n\n// `hasOwnProperty` will only return true for direct properties:\nexample.hasOwnProperty("prop"); // true\nexample.hasOwnProperty("toString"); // false\nexample.hasOwnProperty("hasOwnProperty"); // false\n\n// The `in` operator will return true for direct or inherited properties:\n"prop" in example; // true\n"toString" in example; // true\n"hasOwnProperty" in example; // true\n```\n\n### Iterating over the properties of an object\n\nThe following example shows how to iterate over the enumerable properties of an\nobject without executing on inherited properties.\n\n```js\nconst buz = {\n  fog: "stack",\n};\n\nfor (const name in buz) {\n  if (buz.hasOwnProperty(name)) {\n    console.log(`this is fog (${name}) for sure. Value: ${buz[name]}`);\n  } else {\n    console.log(name); // toString or something else\n  }\n}\n```\n\nNote that the {{jsxref("Statements/for...in", "for...in")}} loop\nonly iterates enumerable items: the absence of non-enumerable properties emitted\nfrom the loop does not imply that `hasOwnProperty` itself is confined strictly\nto enumerable items. You can iterate over non-enumerable properties with\n{{jsxref("Object.getOwnPropertyNames()")}}.\n\n### Using hasOwnProperty as a property name\n\nJavaScript does not protect the property name `hasOwnProperty`; an object that\nhas a property with this name may return incorrect results:\n\n```js\nconst foo = {\n  hasOwnProperty() {\n    return false;\n  },\n  bar: "Here be dragons",\n};\n\nfoo.hasOwnProperty("bar"); // re-implementation always returns false\n```\n\nThe recommended way to overcome this problem is to instead use\n{{jsxref("Object.hasOwn()")}} (in browsers that support it). Other\nalternatives include using an _external_ `hasOwnProperty`:\n\n```js\nconst foo = { bar: "Here be dragons" };\n\n// Use Object.hasOwn() method - recommended\nObject.hasOwn(foo, "bar"); // true\n\n// Use the hasOwnProperty property from the Object prototype\nObject.prototype.hasOwnProperty.call(foo, "bar"); // true\n\n// Use another Object\'s hasOwnProperty\n// and call it with \'this\' set to foo\n({}).hasOwnProperty.call(foo, "bar"); // true\n```\n\nNote that in the first two cases there are no newly created objects.\n\n### Objects created with Object.create(null)\n\n[`null`-prototype objects](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object#null-prototype_objects) do not\ninherit from `Object.prototype`, making `hasOwnProperty()` inaccessible.\n\n```js\nconst foo = Object.create(null);\nfoo.prop = "exists";\nfoo.hasOwnProperty("prop"); // Uncaught TypeError: foo.hasOwnProperty is not a function\n```\n\nThe solutions in this case are the same as for the previous section: use\n{{jsxref("Object.hasOwn()")}} by preference, otherwise use an\nexternal object\'s `hasOwnProperty()`.\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Object.hasOwn()")}}\n- [Enumerability and ownership of properties](/en-US/docs/Web/JavaScript/Enumerability_and_ownership_of_properties)\n- {{jsxref("Object.getOwnPropertyNames()")}}\n- {{jsxref("Statements/for...in", "for...in")}}\n- {{jsxref("Operators/in", "in")}}\n- [Inheritance and the prototype chain](/en-US/docs/Web/JavaScript/Inheritance_and_the_prototype_chain)\n'
        },
        "index.md": '---\ntitle: Object\nslug: Web/JavaScript/Reference/Global_Objects/Object\npage-type: javascript-class\nbrowser-compat: javascript.builtins.Object\n---\n\n{{JSRef}}\n\nThe **`Object`** type represents one of [JavaScript\'s data types](/en-US/docs/Web/JavaScript/Data_structures). It is used to store various keyed collections and more complex entities. Objects can be created using the {{jsxref("Object/Object", "Object()")}} constructor or the [object initializer / literal syntax](/en-US/docs/Web/JavaScript/Reference/Operators/Object_initializer).\n\n## Description\n\nNearly all [objects](/en-US/docs/Web/JavaScript/Data_structures#objects) in JavaScript are instances of `Object`; a typical object inherits properties (including methods) from `Object.prototype`, although these properties may be shadowed (a.k.a. overridden). The only objects that don\'t inherit from `Object.prototype` are those with [`null` prototype](#null-prototype_objects), or descended from other `null` prototype objects.\n\nChanges to the `Object.prototype` object are seen by **all** objects through prototype chaining, unless the properties and methods subject to those changes are overridden further along the prototype chain. This provides a very powerful although potentially dangerous mechanism to override or extend object behavior. To make it more secure, `Object.prototype` is the only object in the core JavaScript language that has [immutable prototype](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/setPrototypeOf#description) \u2014 the prototype of `Object.prototype` is always `null` and not changeable.\n\n### Object prototype properties\n\nYou should avoid calling any `Object.prototype` method directly from the instance, especially those that are not intended to be polymorphic (i.e. only its initial behavior makes sense and no descending object could override it in a meaningful way). All objects descending from `Object.prototype` may define a custom own property that has the same name, but with entirely different semantics from what you expect. Furthermore, these properties are not inherited by [`null`-prototype objects](#null-prototype_objects). All modern JavaScript utilities for working with objects are [static](#static_methods). More specifically:\n\n- [`valueOf()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/valueOf), [`toString()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/toString), and [`toLocaleString()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/toLocaleString) exist to be polymorphic and you should expect the object to define its own implementation with sensible behaviors, so you can call them as instance methods. However, `valueOf()` and `toString()` are usually implicitly called through [type conversion](/en-US/docs/Web/JavaScript/Data_structures#type_coercion) and you don\'t need to call them yourself in your code.\n- [`__defineGetter__()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/__defineGetter__), [`__defineSetter__()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/__defineSetter__), [`__lookupGetter__()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/__lookupGetter__), and [`__lookupSetter__()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/__lookupSetter__) are deprecated and should not be used. Use the static alternatives {{jsxref("Object.defineProperty()")}} and {{jsxref("Object.getOwnPropertyDescriptor()")}} instead.\n- The [`__proto__`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/proto) property is deprecated and should not be used. The {{jsxref("Object.getPrototypeOf()")}} and {{jsxref("Object.setPrototypeOf()")}} alternatives are static methods.\n- The [`propertyIsEnumerable()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/propertyIsEnumerable) and [`hasOwnProperty()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/hasOwnProperty) methods can be replaced with the {{jsxref("Object.getOwnPropertyDescriptor()")}} and {{jsxref("Object.hasOwn()")}} static methods, respectively.\n- The [`isPrototypeOf()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/isPrototypeOf) method can usually be replaced with [`instanceof`](/en-US/docs/Web/JavaScript/Reference/Operators/instanceof), if you are checking the `prototype` property of a constructor.\n\nIn case where a semantically equivalent static method doesn\'t exist, or if you really want to use the `Object.prototype` method, you should directly [`call()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/call) the `Object.prototype` method on your target object instead, to prevent the object from having an overriding property that produces unexpected results.\n\n```js\nconst obj = {\n  foo: 1,\n  // You should not define such a method on your own object,\n  // but you may not be able to prevent it from happening if\n  // you are receiving the object from external input\n  propertyIsEnumerable() {\n    return false;\n  },\n};\n\nobj.propertyIsEnumerable("foo"); // false; unexpected result\nObject.prototype.propertyIsEnumerable.call(obj, "foo"); // true; expected result\n```\n\n### Deleting a property from an object\n\nThere isn\'t any method in an Object itself to delete its own properties (such as {{jsxref("Map.prototype.delete()")}}). To do so, one must use the {{jsxref("Operators/delete", "delete")}} operator.\n\n### null-prototype objects\n\nAlmost all objects in JavaScript ultimately inherit from `Object.prototype` (see [inheritance and the prototype chain](/en-US/docs/Web/JavaScript/Inheritance_and_the_prototype_chain)). However, you may create `null`-prototype objects using [`Object.create(null)`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/create) or the [object initializer syntax](/en-US/docs/Web/JavaScript/Reference/Operators/Object_initializer) with `__proto__: null` (note: the `__proto__` key in object literals is different from the deprecated [`Object.prototype.__proto__`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/proto) property). You can also change the prototype of an existing object to `null` by calling [`Object.setPrototypeOf(obj, null)`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/setPrototypeOf).\n\n```js\nconst obj = Object.create(null);\nconst obj2 = { __proto__: null };\n```\n\nAn object with a `null` prototype can behave in unexpected ways, because it doesn\'t inherit any object methods from `Object.prototype`. This is especially true when debugging, since common object-property converting/detecting utility functions may generate errors, or lose information (especially if using silent error-traps that ignore errors).\n\nFor example, the lack of [`Object.prototype.toString()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/toString) often makes debugging intractable:\n\n```js\nconst normalObj = {}; // create a normal object\nconst nullProtoObj = Object.create(null); // create an object with "null" prototype\n\nconsole.log(`normalObj is: ${normalObj}`); // shows "normalObj is: [object Object]"\nconsole.log(`nullProtoObj is: ${nullProtoObj}`); // throws error: Cannot convert object to primitive value\n\nalert(normalObj); // shows [object Object]\nalert(nullProtoObj); // throws error: Cannot convert object to primitive value\n```\n\nOther methods will fail as well.\n\n```js\nnormalObj.valueOf(); // shows {}\nnullProtoObj.valueOf(); // throws error: nullProtoObj.valueOf is not a function\n\nnormalObj.hasOwnProperty("p"); // shows "true"\nnullProtoObj.hasOwnProperty("p"); // throws error: nullProtoObj.hasOwnProperty is not a function\n\nnormalObj.constructor; // shows "Object() { [native code] }"\nnullProtoObj.constructor; // shows "undefined"\n```\n\nWe can add the `toString` method back to the null-prototype object by assigning it one:\n\n```js\nnullProtoObj.toString = Object.prototype.toString; // since new object lacks toString, add the original generic one back\n\nconsole.log(nullProtoObj.toString()); // shows "[object Object]"\nconsole.log(`nullProtoObj is: ${nullProtoObj}`); // shows "nullProtoObj is: [object Object]"\n```\n\nUnlike normal objects, in which `toString()` is on the object\'s prototype, the `toString()` method here is an own property of `nullProtoObj`. This is because `nullProtoObj` has no (`null`) prototype.\n\nYou can also revert a null-prototype object back to an ordinary object using [`Object.setPrototypeOf(nullProtoObj, Object.prototype)`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/setPrototypeOf).\n\nIn practice, objects with `null` prototype are usually used as a cheap substitute for [maps](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map). The presence of `Object.prototype` properties will cause some bugs:\n\n```js\nconst ages = { alice: 18, bob: 27 };\n\nfunction hasPerson(name) {\n  return name in ages;\n}\n\nfunction getAge(name) {\n  return ages[name];\n}\n\nhasPerson("hasOwnProperty"); // true\ngetAge("toString"); // [Function: toString]\n```\n\nUsing a null-prototype object removes this hazard without introducing too much complexity to the `hasPerson` and `getAge` functions:\n\n```js\nconst ages = Object.create(null, {\n  alice: { value: 18, enumerable: true },\n  bob: { value: 27, enumerable: true },\n});\n\nhasPerson("hasOwnProperty"); // false\ngetAge("toString"); // undefined\n```\n\nIn such case, the addition of any method should be done cautiously, as they can be confused with the other key-value pairs stored as data.\n\nMaking your object not inherit from `Object.prototype` also prevents prototype pollution attacks. If a malicious script adds a property to `Object.prototype`, it will be accessible on every object in your program, except objects that have null prototype.\n\n```js\nconst user = {};\n\n// A malicious script:\nObject.prototype.authenticated = true;\n\n// Unexpectedly allowing unauthenticated user to pass through\nif (user.authenticated) {\n  // access confidential data\n}\n```\n\nJavaScript also has built-in APIs that produce `null`-prototype objects, especially those that use objects as ad hoc key-value collections. For example:\n\n- The return value of {{jsxref("Object.groupBy()")}}\n- The `groups` and `indices.groups` properties of the result of {{jsxref("RegExp.prototype.exec()")}}\n- [`Array.prototype[@@unscopables]`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/@@unscopables) (all `@@unscopables` objects should have `null`-prototype)\n- [`import.meta`](/en-US/docs/Web/JavaScript/Reference/Operators/import.meta)\n- Module namespace objects, obtained through [`import * as ns from "module";`](/en-US/docs/Web/JavaScript/Reference/Statements/import#namespace_import) or [`import()`](/en-US/docs/Web/JavaScript/Reference/Operators/import)\n\nThe term "`null`-prototype object" often also includes any object without `Object.prototype` in its prototype chain. Such objects can be created with [`extends null`](/en-US/docs/Web/JavaScript/Reference/Classes/extends#extending_null) when using classes.\n\n### Object coercion\n\nMany built-in operations that expect objects first coerce their arguments to objects. [The operation](https://tc39.es/ecma262/multipage/abstract-operations.html#sec-toobject) can be summarized as follows:\n\n- Objects are returned as-is.\n- [`undefined`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/undefined) and [`null`](/en-US/docs/Web/JavaScript/Reference/Operators/null) throw a {{jsxref("TypeError")}}.\n- {{jsxref("Number")}}, {{jsxref("String")}}, {{jsxref("Boolean")}}, {{jsxref("Symbol")}}, {{jsxref("BigInt")}} primitives are wrapped into their corresponding object wrappers.\n\nThere are two ways to achieve nearly the same effect in JavaScript.\n\n- {{jsxref("Object.prototype.valueOf()")}}: `Object.prototype.valueOf.call(x)` does exactly the object coercion steps explained above to convert `x`.\n- The {{jsxref("Object/Object", "Object()")}} function: `Object(x)` uses the same algorithm to convert `x`, except that `undefined` and `null` don\'t throw a {{jsxref("TypeError")}}, but return a plain object.\n\nPlaces that use object coercion include:\n\n- The `object` parameter of [`for...in`](/en-US/docs/Web/JavaScript/Reference/Statements/for...in) loops.\n- The `this` value of {{jsxref("Array")}} methods.\n- Parameters of `Object` methods such as {{jsxref("Object.keys()")}}.\n- Auto-boxing when a property is accessed on a primitive value, since primitives do not have properties.\n- The [`this`](/en-US/docs/Web/JavaScript/Reference/Operators/this) value when calling a non-strict function. Primitives are boxed while `null` and `undefined` are replaced with the [global object](/en-US/docs/Glossary/Global_object).\n\nUnlike [conversion to primitives](/en-US/docs/Web/JavaScript/Data_structures#primitive_coercion), the object coercion process itself is not observable in any way, since it doesn\'t invoke custom code like `toString` or `valueOf` methods.\n\n## Constructor\n\n- {{jsxref("Object/Object", "Object()")}}\n  - : Turns the input into an object.\n\n## Static methods\n\n- {{jsxref("Object.assign()")}}\n  - : Copies the values of all enumerable own properties from one or more source objects to a target object.\n- {{jsxref("Object.create()")}}\n  - : Creates a new object with the specified prototype object and properties.\n- {{jsxref("Object.defineProperties()")}}\n  - : Adds the named properties described by the given descriptors to an object.\n- {{jsxref("Object.defineProperty()")}}\n  - : Adds the named property described by a given descriptor to an object.\n- {{jsxref("Object.entries()")}}\n  - : Returns an array containing all of the `[key, value]` pairs of a given object\'s **own** enumerable string properties.\n- {{jsxref("Object.freeze()")}}\n  - : Freezes an object. Other code cannot delete or change its properties.\n- {{jsxref("Object.fromEntries()")}}\n  - : Returns a new object from an iterable of `[key, value]` pairs. (This is the reverse of {{jsxref("Object.entries")}}).\n- {{jsxref("Object.getOwnPropertyDescriptor()")}}\n  - : Returns a property descriptor for a named property on an object.\n- {{jsxref("Object.getOwnPropertyDescriptors()")}}\n  - : Returns an object containing all own property descriptors for an object.\n- {{jsxref("Object.getOwnPropertyNames()")}}\n  - : Returns an array containing the names of all of the given object\'s **own** enumerable and non-enumerable properties.\n- {{jsxref("Object.getOwnPropertySymbols()")}}\n  - : Returns an array of all symbol properties found directly upon a given object.\n- {{jsxref("Object.getPrototypeOf()")}}\n  - : Returns the prototype (internal `[[Prototype]]` property) of the specified object.\n- {{jsxref("Object.groupBy()")}}\n  - : Groups the elements of a given iterable according to the string values returned by a provided callback function. The returned object has separate properties for each group, containing arrays with the elements in the group.\n- {{jsxref("Object.hasOwn()")}}\n  - : Returns `true` if the specified object has the indicated property as its _own_ property, or `false` if the property is inherited or does not exist.\n- {{jsxref("Object.is()")}}\n  - : Compares if two values are the same value. Equates all `NaN` values (which differs from both `IsLooselyEqual` used by [`==`](/en-US/docs/Web/JavaScript/Reference/Operators/Equality) and `IsStrictlyEqual` used by [`===`](/en-US/docs/Web/JavaScript/Reference/Operators/Strict_equality)).\n- {{jsxref("Object.isExtensible()")}}\n  - : Determines if extending of an object is allowed.\n- {{jsxref("Object.isFrozen()")}}\n  - : Determines if an object was frozen.\n- {{jsxref("Object.isSealed()")}}\n  - : Determines if an object is sealed.\n- {{jsxref("Object.keys()")}}\n  - : Returns an array containing the names of all of the given object\'s **own** enumerable string properties.\n- {{jsxref("Object.preventExtensions()")}}\n  - : Prevents any extensions of an object.\n- {{jsxref("Object.seal()")}}\n  - : Prevents other code from deleting properties of an object.\n- {{jsxref("Object.setPrototypeOf()")}}\n  - : Sets the object\'s prototype (its internal `[[Prototype]]` property).\n- {{jsxref("Object.values()")}}\n  - : Returns an array containing the values that correspond to all of a given object\'s **own** enumerable string properties.\n\n## Instance properties\n\nThese properties are defined on `Object.prototype` and shared by all `Object` instances.\n\n- [`Object.prototype.__proto__`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/proto) {{deprecated_inline}}\n  - : Points to the object which was used as prototype when the object was instantiated.\n- {{jsxref("Object.prototype.constructor")}}\n  - : The constructor function that created the instance object. For plain `Object` instances, the initial value is the {{jsxref("Object/Object", "Object")}} constructor. Instances of other constructors each inherit the `constructor` property from their respective `Constructor.prototype` object.\n\n## Instance methods\n\n- [`Object.prototype.__defineGetter__()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/__defineGetter__) {{deprecated_inline}}\n  - : Associates a function with a property that, when accessed, executes that function and returns its return value.\n- [`Object.prototype.__defineSetter__()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/__defineSetter__) {{deprecated_inline}}\n  - : Associates a function with a property that, when set, executes that function which modifies the property.\n- [`Object.prototype.__lookupGetter__()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/__lookupGetter__) {{deprecated_inline}}\n  - : Returns the function bound as a getter to the specified property.\n- [`Object.prototype.__lookupSetter__()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/__lookupSetter__) {{deprecated_inline}}\n  - : Returns the function bound as a setter to the specified property.\n- {{jsxref("Object.prototype.hasOwnProperty()")}}\n  - : Returns a boolean indicating whether an object contains the specified property as a direct property of that object and not inherited through the prototype chain.\n- {{jsxref("Object.prototype.isPrototypeOf()")}}\n  - : Returns a boolean indicating whether the object this method is called upon is in the prototype chain of the specified object.\n- {{jsxref("Object.prototype.propertyIsEnumerable()")}}\n  - : Returns a boolean indicating whether the specified property is the object\'s [enumerable own](/en-US/docs/Web/JavaScript/Enumerability_and_ownership_of_properties) property.\n- {{jsxref("Object.prototype.toLocaleString()")}}\n  - : Calls {{jsxref("Object/toString", "toString()")}}.\n- {{jsxref("Object.prototype.toString()")}}\n  - : Returns a string representation of the object.\n- {{jsxref("Object.prototype.valueOf()")}}\n  - : Returns the primitive value of the specified object.\n\n## Examples\n\n### Constructing empty objects\n\nThe following example creates empty objects using the `new` keyword with different arguments:\n\n```js\nconst o1 = new Object();\nconst o2 = new Object(undefined);\nconst o3 = new Object(null);\n```\n\n### Using Object() constructor to turn primitives into an Object of their respective type\n\nYou can use the {{jsxref("Object/Object", "Object()")}} constructor to create an object wrapper of a primitive value.\n\nThe following examples create variables `o1` and `o2` which are objects storing {{jsxref("Boolean")}} and {{jsxref("BigInt")}} values:\n\n```js\n// Equivalent to const o1 = new Boolean(true)\nconst o1 = new Object(true);\n\n// No equivalent because BigInt() can\'t be called as a constructor,\n// and calling it as a regular function won\'t create an object\nconst o2 = new Object(1n);\n```\n\n### Object prototypes\n\nWhen altering the behavior of existing `Object.prototype` methods, consider injecting code by wrapping your extension before or after the existing logic. For example, this (untested) code will pre-conditionally execute custom logic before the built-in logic or someone else\'s extension is executed.\n\nWhen modifying prototypes with hooks, pass `this` and the arguments (the call state) to the current behavior by calling `apply()` on the function. This pattern can be used for any prototype, such as `Node.prototype`, `Function.prototype`, etc.\n\n```js\nconst current = Object.prototype.valueOf;\n\n// Since my property "-prop-value" is cross-cutting and isn\'t always\n// on the same prototype chain, I want to modify Object.prototype:\nObject.prototype.valueOf = function (...args) {\n  if (Object.hasOwn(this, "-prop-value")) {\n    return this["-prop-value"];\n  } else {\n    // It doesn\'t look like one of my objects, so let\'s fall back on\n    // the default behavior by reproducing the current behavior as best we can.\n    // The apply behaves like "super" in some other languages.\n    // Even though valueOf() doesn\'t take arguments, some other hook may.\n    return current.apply(this, args);\n  }\n};\n```\n\n> **Warning:** Modifying the `prototype` property of any built-in constructor is considered a bad practice and risks forward compatibility.\n\nYou can read more about prototypes in [Inheritance and the prototype chain](/en-US/docs/Web/JavaScript/Inheritance_and_the_prototype_chain).\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Object initializer](/en-US/docs/Web/JavaScript/Reference/Operators/Object_initializer)\n',
        "is": {
            "index.md": '---\ntitle: Object.is()\nslug: Web/JavaScript/Reference/Global_Objects/Object/is\npage-type: javascript-static-method\nbrowser-compat: javascript.builtins.Object.is\n---\n\n{{JSRef}}\n\nThe **`Object.is()`** static method determines whether two values are [the same value](/en-US/docs/Web/JavaScript/Equality_comparisons_and_sameness#same-value_equality_using_object.is).\n\n{{EmbedInteractiveExample("pages/js/object-is.html")}}\n\n## Syntax\n\n```js-nolint\nObject.is(value1, value2)\n```\n\n### Parameters\n\n- `value1`\n  - : The first value to compare.\n- `value2`\n  - : The second value to compare.\n\n### Return value\n\nA boolean indicating whether or not the two arguments are the same value.\n\n## Description\n\n`Object.is()` determines whether two values are [the same value](/en-US/docs/Web/JavaScript/Equality_comparisons_and_sameness#same-value_equality_using_object.is). Two values are the same if one of the following holds:\n\n- both {{jsxref("undefined")}}\n- both [`null`](/en-US/docs/Web/JavaScript/Reference/Operators/null)\n- both `true` or both `false`\n- both strings of the same length with the same characters in the same order\n- both the same object (meaning both values reference the same object in memory)\n- both [BigInts](/en-US/docs/Web/JavaScript/Reference/Global_Objects/BigInt) with the same numeric value\n- both [symbols](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol) that reference the same symbol value\n- both numbers and\n\n  - both `+0`\n  - both `-0`\n  - both {{jsxref("NaN")}}\n  - or both non-zero, not {{jsxref("NaN")}}, and have the same value\n\n`Object.is()` is not equivalent to the [`==`](/en-US/docs/Web/JavaScript/Reference/Operators/Equality) operator. The `==` operator applies various coercions to both sides (if they are not the same type) before testing for equality (resulting in such behavior as `"" == false` being `true`), but `Object.is()` doesn\'t coerce either value.\n\n`Object.is()` is also _not_ equivalent to the [`===`](/en-US/docs/Web/JavaScript/Reference/Operators/Strict_equality) operator. The only difference between `Object.is()` and `===` is in their treatment of signed zeros and `NaN` values. The `===` operator (and the `==` operator) treats the number values `-0` and `+0` as equal, but treats {{jsxref("NaN")}} as not equal to each other.\n\n## Examples\n\n### Using Object.is()\n\n```js\n// Case 1: Evaluation result is the same as using ===\nObject.is(25, 25); // true\nObject.is("foo", "foo"); // true\nObject.is("foo", "bar"); // false\nObject.is(null, null); // true\nObject.is(undefined, undefined); // true\nObject.is(window, window); // true\nObject.is([], []); // false\nconst foo = { a: 1 };\nconst bar = { a: 1 };\nconst sameFoo = foo;\nObject.is(foo, foo); // true\nObject.is(foo, bar); // false\nObject.is(foo, sameFoo); // true\n\n// Case 2: Signed zero\nObject.is(0, -0); // false\nObject.is(+0, -0); // false\nObject.is(-0, -0); // true\n\n// Case 3: NaN\nObject.is(NaN, 0 / 0); // true\nObject.is(NaN, Number.NaN); // true\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Object.is` in `core-js`](https://github.com/zloirock/core-js#ecmascript-object)\n- [Equality comparisons and sameness](/en-US/docs/Web/JavaScript/Equality_comparisons_and_sameness)\n'
        },
        "isextensible": {
            "index.md": '---\ntitle: Object.isExtensible()\nslug: Web/JavaScript/Reference/Global_Objects/Object/isExtensible\npage-type: javascript-static-method\nbrowser-compat: javascript.builtins.Object.isExtensible\n---\n\n{{JSRef}}\n\nThe **`Object.isExtensible()`** static method determines if an object\nis extensible (whether it can have new properties added to it).\n\n{{EmbedInteractiveExample("pages/js/object-isextensible.html")}}\n\n## Syntax\n\n```js-nolint\nObject.isExtensible(obj)\n```\n\n### Parameters\n\n- `obj`\n  - : The object which should be checked.\n\n### Return value\n\nA {{jsxref("Boolean")}} indicating whether or not the given object is extensible.\n\n## Description\n\nObjects are extensible by default: they can have new properties added to them, and their `[[Prototype]]` can be re-assigned. An object can be marked as non-extensible using one of {{jsxref("Object.preventExtensions()")}}, {{jsxref("Object.seal()")}}, {{jsxref("Object.freeze()")}}, or {{jsxref("Reflect.preventExtensions()")}}.\n\n## Examples\n\n### Using Object.isExtensible\n\n```js\n// New objects are extensible.\nconst empty = {};\nObject.isExtensible(empty); // true\n\n// They can be made un-extensible\nObject.preventExtensions(empty);\nObject.isExtensible(empty); // false\n\n// Sealed objects are by definition non-extensible.\nconst sealed = Object.seal({});\nObject.isExtensible(sealed); // false\n\n// Frozen objects are also by definition non-extensible.\nconst frozen = Object.freeze({});\nObject.isExtensible(frozen); // false\n```\n\n### Non-object argument\n\nIn ES5, if the argument to this method is not an object (a primitive), then it will cause a {{jsxref("TypeError")}}. In ES2015, it will return `false` without any errors if a non-object argument is passed, since primitives are, by definition, immutable.\n\n```js\nObject.isExtensible(1);\n// TypeError: 1 is not an object (ES5 code)\n\nObject.isExtensible(1);\n// false                         (ES2015 code)\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Object.preventExtensions()")}}\n- {{jsxref("Object.seal()")}}\n- {{jsxref("Object.isSealed()")}}\n- {{jsxref("Object.freeze()")}}\n- {{jsxref("Object.isFrozen()")}}\n- {{jsxref("Reflect.isExtensible()")}}\n'
        },
        "isfrozen": {
            "index.md": '---\ntitle: Object.isFrozen()\nslug: Web/JavaScript/Reference/Global_Objects/Object/isFrozen\npage-type: javascript-static-method\nbrowser-compat: javascript.builtins.Object.isFrozen\n---\n\n{{JSRef}}\n\nThe **`Object.isFrozen()`** static method determines if an object is\n{{jsxref("Object/freeze", "frozen", "", 1)}}.\n\n{{EmbedInteractiveExample("pages/js/object-isfrozen.html")}}\n\n## Syntax\n\n```js-nolint\nObject.isFrozen(obj)\n```\n\n### Parameters\n\n- `obj`\n  - : The object which should be checked.\n\n### Return value\n\nA {{jsxref("Boolean")}} indicating whether or not the given object is frozen.\n\n## Description\n\nAn object is frozen if and only if it is not [extensible](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/isExtensible), all its properties are non-configurable, and all its data\nproperties (that is, properties which are not accessor properties with getter or setter\ncomponents) are non-writable.\n\n## Examples\n\n### Using Object.isFrozen\n\n```js\n// A new object is extensible, so it is not frozen.\nObject.isFrozen({}); // false\n\n// An empty object which is not extensible\n// is vacuously frozen.\nconst vacuouslyFrozen = Object.preventExtensions({});\nObject.isFrozen(vacuouslyFrozen); // true\n\n// A new object with one property is also extensible,\n// ergo not frozen.\nconst oneProp = { p: 42 };\nObject.isFrozen(oneProp); // false\n\n// Preventing extensions to the object still doesn\'t\n// make it frozen, because the property is still\n// configurable (and writable).\nObject.preventExtensions(oneProp);\nObject.isFrozen(oneProp); // false\n\n// Deleting that property makes the object vacuously frozen.\ndelete oneProp.p;\nObject.isFrozen(oneProp); // true\n\n// A non-extensible object with a non-writable\n// but still configurable property is not frozen.\nconst nonWritable = { e: "plep" };\nObject.preventExtensions(nonWritable);\nObject.defineProperty(nonWritable, "e", {\n  writable: false,\n}); // make non-writable\nObject.isFrozen(nonWritable); // false\n\n// Changing that property to non-configurable\n// then makes the object frozen.\nObject.defineProperty(nonWritable, "e", {\n  configurable: false,\n}); // make non-configurable\nObject.isFrozen(nonWritable); // true\n\n// A non-extensible object with a non-configurable\n// but still writable property also isn\'t frozen.\nconst nonConfigurable = { release: "the kraken!" };\nObject.preventExtensions(nonConfigurable);\nObject.defineProperty(nonConfigurable, "release", {\n  configurable: false,\n});\nObject.isFrozen(nonConfigurable); // false\n\n// Changing that property to non-writable\n// then makes the object frozen.\nObject.defineProperty(nonConfigurable, "release", {\n  writable: false,\n});\nObject.isFrozen(nonConfigurable); // true\n\n// A non-extensible object with a configurable\n// accessor property isn\'t frozen.\nconst accessor = {\n  get food() {\n    return "yum";\n  },\n};\nObject.preventExtensions(accessor);\nObject.isFrozen(accessor); // false\n\n// When we make that property non-configurable it becomes frozen.\nObject.defineProperty(accessor, "food", {\n  configurable: false,\n});\nObject.isFrozen(accessor); // true\n\n// But the easiest way for an object to be frozen\n// is if Object.freeze has been called on it.\nconst frozen = { 1: 81 };\nObject.isFrozen(frozen); // false\nObject.freeze(frozen);\nObject.isFrozen(frozen); // true\n\n// By definition, a frozen object is non-extensible.\nObject.isExtensible(frozen); // false\n\n// Also by definition, a frozen object is sealed.\nObject.isSealed(frozen); // true\n```\n\n### Non-object argument\n\nIn ES5, if the argument to this method is not an object (a primitive), then it will cause a {{jsxref("TypeError")}}. In ES2015, it will return `true` without any errors if a non-object argument is passed, since primitives are, by definition, immutable.\n\n```js\nObject.isFrozen(1);\n// TypeError: 1 is not an object (ES5 code)\n\nObject.isFrozen(1);\n// true                          (ES2015 code)\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Object.freeze()")}}\n- {{jsxref("Object.preventExtensions()")}}\n- {{jsxref("Object.isExtensible()")}}\n- {{jsxref("Object.seal()")}}\n- {{jsxref("Object.isSealed()")}}\n'
        },
        "isprototypeof": {
            "index.md": '---\ntitle: Object.prototype.isPrototypeOf()\nslug: Web/JavaScript/Reference/Global_Objects/Object/isPrototypeOf\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Object.isPrototypeOf\n---\n\n{{JSRef}}\n\nThe **`isPrototypeOf()`** method of {{jsxref("Object")}} instances checks if this object exists in another object\'s prototype chain.\n\n> **Note:** `isPrototypeOf()` differs from the [`instanceof`](/en-US/docs/Web/JavaScript/Reference/Operators/instanceof) operator. In the expression `object instanceof AFunction`, `object`\'s prototype chain is checked against `AFunction.prototype`, not against `AFunction` itself.\n\n{{EmbedInteractiveExample("pages/js/object-prototype-isprototypeof.html")}}\n\n## Syntax\n\n```js-nolint\nisPrototypeOf(object)\n```\n\n### Parameters\n\n- `object`\n  - : The object whose prototype chain will be searched.\n\n### Return value\n\nA boolean indicating whether the calling object (`this`) lies in the prototype chain of `object`. Directly returns `false` when `object` is not an object (i.e. a primitive).\n\n### Exceptions\n\n- {{jsxref("TypeError")}}\n  - : Thrown if `this` is `null` or `undefined` (because it can\'t be [converted to an object](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object#object_coercion)).\n\n## Description\n\nAll objects that inherit from `Object.prototype` (that is, all except [`null`-prototype objects](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object#null-prototype_objects)) inherit the `isPrototypeOf()` method. This method allows you to check whether or not the object exists within another object\'s prototype chain. If the `object` passed as the parameter is not an object (i.e. a primitive), the method directly returns `false`. Otherwise, the `this` value is [converted to an object](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object#object_coercion), and the prototype chain of `object` is searched for the `this` value, until the end of the chain is reached or the `this` value is found.\n\n## Examples\n\n### Using isPrototypeOf()\n\nThis example demonstrates that `Baz.prototype`, `Bar.prototype`, `Foo.prototype` and `Object.prototype` exist in the prototype chain for object `baz`:\n\n```js\nclass Foo {}\nclass Bar extends Foo {}\nclass Baz extends Bar {}\n\nconst foo = new Foo();\nconst bar = new Bar();\nconst baz = new Baz();\n\n// prototype chains:\n// foo: Foo --> Object\n// bar: Bar --> Foo --> Object\n// baz: Baz --> Bar --> Foo --> Object\nconsole.log(Baz.prototype.isPrototypeOf(baz)); // true\nconsole.log(Baz.prototype.isPrototypeOf(bar)); // false\nconsole.log(Baz.prototype.isPrototypeOf(foo)); // false\nconsole.log(Bar.prototype.isPrototypeOf(baz)); // true\nconsole.log(Bar.prototype.isPrototypeOf(foo)); // false\nconsole.log(Foo.prototype.isPrototypeOf(baz)); // true\nconsole.log(Foo.prototype.isPrototypeOf(bar)); // true\nconsole.log(Object.prototype.isPrototypeOf(baz)); // true\n```\n\nThe `isPrototypeOf()` method \u2014 along with the {{jsxref("Operators/instanceof", "instanceof")}} operator \u2014 comes in particularly handy if you have code that can only function when dealing with objects descended from a specific prototype chain; e.g., to guarantee that certain methods or properties will be present on that object.\n\nFor example, to execute some code that\'s only safe to run if a `baz` object has `Foo.prototype` in its prototype chain, you can do this:\n\n```js\nif (Foo.prototype.isPrototypeOf(baz)) {\n  // do something safe\n}\n```\n\nHowever, `Foo.prototype` existing in `baz`\'s prototype chain doesn\'t imply `baz` was created using `Foo` as its constructor. For example, `baz` could be directly assigned with `Foo.prototype` as its prototype. In this case, if your code reads [private fields](/en-US/docs/Web/JavaScript/Reference/Classes/Private_properties) of `Foo` from `baz`, it would still fail:\n\n```js\nclass Foo {\n  #value = "foo";\n  static getValue(x) {\n    return x.#value;\n  }\n}\n\nconst baz = { __proto__: Foo.prototype };\n\nif (Foo.prototype.isPrototypeOf(baz)) {\n  console.log(Foo.getValue(baz)); // TypeError: Cannot read private member #value from an object whose class did not declare it\n}\n```\n\nThe same applies to [`instanceof`](/en-US/docs/Web/JavaScript/Reference/Operators/instanceof). If you need to read private fields in a secure way, offer a branded check method using [`in`](/en-US/docs/Web/JavaScript/Reference/Operators/in) instead.\n\n```js\nclass Foo {\n  #value = "foo";\n  static getValue(x) {\n    return x.#value;\n  }\n  static isFoo(x) {\n    return #value in x;\n  }\n}\n\nconst baz = { __proto__: Foo.prototype };\n\nif (Foo.isFoo(baz)) {\n  // Doesn\'t run, because baz is not a Foo\n  console.log(Foo.getValue(baz));\n}\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Operators/instanceof", "instanceof")}}\n- {{jsxref("Object.getPrototypeOf()")}}\n- {{jsxref("Object.setPrototypeOf()")}}\n- [Inheritance and the prototype chain](/en-US/docs/Web/JavaScript/Inheritance_and_the_prototype_chain)\n'
        },
        "issealed": {
            "index.md": '---\ntitle: Object.isSealed()\nslug: Web/JavaScript/Reference/Global_Objects/Object/isSealed\npage-type: javascript-static-method\nbrowser-compat: javascript.builtins.Object.isSealed\n---\n\n{{JSRef}}\n\nThe **`Object.isSealed()`** static method determines if an object is\nsealed.\n\n{{EmbedInteractiveExample("pages/js/object-issealed.html")}}\n\n## Syntax\n\n```js-nolint\nObject.isSealed(obj)\n```\n\n### Parameters\n\n- `obj`\n  - : The object which should be checked.\n\n### Return value\n\nA {{jsxref("Boolean")}} indicating whether or not the given object is sealed.\n\n## Description\n\nReturns `true` if the object is sealed, otherwise `false`. An\nobject is sealed if it is not {{jsxref("Object/isExtensible", "extensible", "", 1)}} and\nif all its properties are non-configurable and therefore not removable (but not\nnecessarily non-writable).\n\n## Examples\n\n### Using Object.isSealed\n\n```js\n// Objects aren\'t sealed by default.\nconst empty = {};\nObject.isSealed(empty); // false\n\n// If you make an empty object non-extensible,\n// it is vacuously sealed.\nObject.preventExtensions(empty);\nObject.isSealed(empty); // true\n\n// The same is not true of a non-empty object,\n// unless its properties are all non-configurable.\nconst hasProp = { fee: "fie foe fum" };\nObject.preventExtensions(hasProp);\nObject.isSealed(hasProp); // false\n\n// But make them all non-configurable\n// and the object becomes sealed.\nObject.defineProperty(hasProp, "fee", {\n  configurable: false,\n});\nObject.isSealed(hasProp); // true\n\n// The easiest way to seal an object, of course,\n// is Object.seal.\nconst sealed = {};\nObject.seal(sealed);\nObject.isSealed(sealed); // true\n\n// A sealed object is, by definition, non-extensible.\nObject.isExtensible(sealed); // false\n\n// A sealed object might be frozen,\n// but it doesn\'t have to be.\nObject.isFrozen(sealed); // true\n// (all properties also non-writable)\n\nconst s2 = Object.seal({ p: 3 });\nObject.isFrozen(s2); // false\n// (\'p\' is still writable)\n\nconst s3 = Object.seal({\n  get p() {\n    return 0;\n  },\n});\nObject.isFrozen(s3); // true\n// (only configurability matters for accessor properties)\n```\n\n### Non-object argument\n\nIn ES5, if the argument to this method is not an object (a primitive), then it will cause a {{jsxref("TypeError")}}. In ES2015, it will return `true` without any errors if a non-object argument is passed, since primitives are, by definition, immutable.\n\n```js\nObject.isSealed(1);\n// TypeError: 1 is not an object (ES5 code)\n\nObject.isSealed(1);\n// true                          (ES2015 code)\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Object.seal()")}}\n- {{jsxref("Object.preventExtensions()")}}\n- {{jsxref("Object.isExtensible()")}}\n- {{jsxref("Object.freeze()")}}\n- {{jsxref("Object.isFrozen()")}}\n'
        },
        "keys": {
            "index.md": '---\ntitle: Object.keys()\nslug: Web/JavaScript/Reference/Global_Objects/Object/keys\npage-type: javascript-static-method\nbrowser-compat: javascript.builtins.Object.keys\n---\n\n{{JSRef}}\n\nThe **`Object.keys()`** static method returns an array of a given object\'s own enumerable string-keyed property names.\n\n{{EmbedInteractiveExample("pages/js/object-keys.html")}}\n\n## Syntax\n\n```js-nolint\nObject.keys(obj)\n```\n\n### Parameters\n\n- `obj`\n  - : An object.\n\n### Return value\n\nAn array of strings representing the given object\'s own enumerable string-keyed property keys.\n\n## Description\n\n`Object.keys()` returns an array whose elements are strings corresponding to the enumerable string-keyed property names found directly upon `object`. This is the same as iterating with a {{jsxref("Statements/for...in", "for...in")}} loop, except that a `for...in` loop enumerates properties in the prototype chain as well. The order of the array returned by `Object.keys()` is the same as that provided by a {{jsxref("Statements/for...in", "for...in")}} loop.\n\nIf you need the property values, use {{jsxref("Object.values()")}} instead. If you need both the property keys and values, use {{jsxref("Object.entries()")}} instead.\n\n## Examples\n\n### Using Object.keys()\n\n```js\n// Simple array\nconst arr = ["a", "b", "c"];\nconsole.log(Object.keys(arr)); // [\'0\', \'1\', \'2\']\n\n// Array-like object\nconst obj = { 0: "a", 1: "b", 2: "c" };\nconsole.log(Object.keys(obj)); // [\'0\', \'1\', \'2\']\n\n// Array-like object with random key ordering\nconst anObj = { 100: "a", 2: "b", 7: "c" };\nconsole.log(Object.keys(anObj)); // [\'2\', \'7\', \'100\']\n\n// getFoo is a non-enumerable property\nconst myObj = Object.create(\n  {},\n  {\n    getFoo: {\n      value() {\n        return this.foo;\n      },\n    },\n  },\n);\nmyObj.foo = 1;\nconsole.log(Object.keys(myObj)); // [\'foo\']\n```\n\nIf you want _all_ string-keyed own properties, including non-enumerable ones, see {{jsxref("Object.getOwnPropertyNames()")}}.\n\n### Using Object.keys() on primitives\n\nNon-object arguments are [coerced to objects](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object#object_coercion). [`undefined`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/undefined) and [`null`](/en-US/docs/Web/JavaScript/Reference/Operators/null) cannot be coerced to objects and throw a {{jsxref("TypeError")}} upfront. Only strings may have own enumerable properties, while all other primitives return an empty array.\n\n```js\n// Strings have indices as enumerable own properties\nconsole.log(Object.keys("foo")); // [\'0\', \'1\', \'2\']\n\n// Other primitives except undefined and null have no own properties\nconsole.log(Object.keys(100)); // []\n```\n\n> **Note:** In ES5, passing a non-object to `Object.keys()` threw a {{jsxref("TypeError")}}.\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Object.keys` in `core-js`](https://github.com/zloirock/core-js#ecmascript-object)\n- [Enumerability and ownership of properties](/en-US/docs/Web/JavaScript/Enumerability_and_ownership_of_properties)\n- {{jsxref("Object.entries()")}}\n- {{jsxref("Object.values()")}}\n- {{jsxref("Object.prototype.propertyIsEnumerable()")}}\n- {{jsxref("Object.create()")}}\n- {{jsxref("Object.getOwnPropertyNames()")}}\n- {{jsxref("Map.prototype.keys()")}}\n'
        },
        "object": {
            "index.md": '---\ntitle: Object() constructor\nslug: Web/JavaScript/Reference/Global_Objects/Object/Object\npage-type: javascript-constructor\nbrowser-compat: javascript.builtins.Object.Object\n---\n\n{{JSRef}}\n\nThe **`Object()`** constructor turns the input into an object. Its behavior depends on the input\'s type.\n\n## Syntax\n\n```js-nolint\nnew Object()\nnew Object(value)\n\nObject()\nObject(value)\n```\n\n> **Note:** `Object()` can be called with or without [`new`](/en-US/docs/Web/JavaScript/Reference/Operators/new), but sometimes with different effects. See [Return value](#return_value).\n\n### Parameters\n\n- `value` {{optional_inline}}\n  - : Any value.\n\n### Return value\n\nWhen the `Object()` constructor itself is called or constructed, its return value is an object:\n\n- If the value is [`null`](/en-US/docs/Web/JavaScript/Reference/Operators/null) or {{jsxref("undefined")}}, it creates and returns an empty object.\n- If the value is an object already, it returns the value.\n- Otherwise, it returns an object of a type that corresponds to the given value. For example, passing a {{jsxref("BigInt")}} primitive returns a `BigInt` wrapper object.\n\nWhen `Object()` is constructed but [`new.target`](/en-US/docs/Web/JavaScript/Reference/Operators/new.target) is not the `Object` constructor itself, the behavior is slightly different \u2014 it initializes a new object with `new.target.prototype` as its prototype. Any argument value is ignored. This may happen, for example, when `Object()` is implicitly called via [`super()`](/en-US/docs/Web/JavaScript/Reference/Operators/super) in the constructor of a class that [extends `Object`](/en-US/docs/Web/JavaScript/Reference/Classes/extends#extending_object). In this case, even if you pass a number to `super()`, the `this` value inside the constructor does not become a {{jsxref("Number")}} instance.\n\n## Examples\n\n### Creating a new Object\n\n```js\nconst o = new Object();\no.foo = 42;\n\nconsole.log(o);\n// { foo: 42 }\n```\n\n### Using Object given undefined and null types\n\nThe following examples store an empty `Object` object in `o`:\n\n```js\nconst o = new Object();\n```\n\n```js\nconst o = new Object(undefined);\n```\n\n```js\nconst o = new Object(null);\n```\n\n### Obtaining wrapper objects for BigInt and Symbol\n\nThe {{jsxref("BigInt/BigInt", "BigInt()")}} and {{jsxref("Symbol/Symbol", "Symbol()")}} constructors throw an error when called with `new`, to prevent the common mistake of creating a wrapper object instead of the primitive value. The only way to create a wrapper object for these types is to call `Object()` with them:\n\n```js\nconst numberObj = new Number(1);\nconsole.log(typeof numberObj); // "object"\n\nconst bigintObj = Object(1n);\nconsole.log(typeof bigintObj); // "object"\n\nconst symbolObj = Object(Symbol("foo"));\nconsole.log(typeof symbolObj); // "object"\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Object initializer](/en-US/docs/Web/JavaScript/Reference/Operators/Object_initializer)\n'
        },
        "preventextensions": {
            "index.md": '---\ntitle: Object.preventExtensions()\nslug: Web/JavaScript/Reference/Global_Objects/Object/preventExtensions\npage-type: javascript-static-method\nbrowser-compat: javascript.builtins.Object.preventExtensions\n---\n\n{{JSRef}}\n\nThe **`Object.preventExtensions()`** static method prevents new\nproperties from ever being added to an object (i.e. prevents future extensions to the\nobject). It also prevents the object\'s prototype from being re-assigned.\n\n{{EmbedInteractiveExample("pages/js/object-preventextensions.html")}}\n\n## Syntax\n\n```js-nolint\nObject.preventExtensions(obj)\n```\n\n### Parameters\n\n- `obj`\n  - : The object which should be made non-extensible.\n\n### Return value\n\nThe object being made non-extensible.\n\n## Description\n\nAn object is extensible if new properties can be added to it.\n`Object.preventExtensions()` marks an object as no longer extensible, so that\nit will never have properties beyond the ones it had at the time it was marked as\nnon-extensible. Note that the properties of a non-extensible object, in general, may\nstill be _deleted_. Attempting to add new properties to a non-extensible object\nwill fail, either silently or, in [strict mode](/en-US/docs/Web/JavaScript/Reference/Strict_mode), throwing a {{jsxref("TypeError")}}.\n\nUnlike [`Object.seal()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/seal) and [`Object.freeze()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/freeze), `Object.preventExtensions()` invokes an intrinsic JavaScript behavior and cannot be replaced with a composition of several other operations. It also has its `Reflect` counterpart (which only exists for intrinsic operations), [`Reflect.preventExtensions()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Reflect/preventExtensions).\n\n`Object.preventExtensions()` only prevents addition of own properties. Properties can still be added to the object prototype.\n\nThis method makes the `[[Prototype]]` of the target immutable; any `[[Prototype]]` re-assignment will throw a `TypeError`. This behavior is specific to the internal `[[Prototype]]` property; other properties of the target object will remain mutable.\n\nThere is no way to make an object extensible again once it has been made non-extensible.\n\n## Examples\n\n### Using Object.preventExtensions\n\n```js\n// Object.preventExtensions returns the object\n// being made non-extensible.\nconst obj = {};\nconst obj2 = Object.preventExtensions(obj);\nobj === obj2; // true\n\n// Objects are extensible by default.\nconst empty = {};\nObject.isExtensible(empty); // true\n\n// They can be made un-extensible\nObject.preventExtensions(empty);\nObject.isExtensible(empty); // false\n\n// Object.defineProperty throws when adding\n// a new property to a non-extensible object.\nconst nonExtensible = { removable: true };\nObject.preventExtensions(nonExtensible);\nObject.defineProperty(nonExtensible, "new", {\n  value: 8675309,\n}); // throws a TypeError\n\n// In strict mode, attempting to add new properties\n// to a non-extensible object throws a TypeError.\nfunction fail() {\n  "use strict";\n  // throws a TypeError\n  nonExtensible.newProperty = "FAIL";\n}\nfail();\n```\n\nA non-extensible object\'s prototype is immutable:\n\n```js\nconst fixed = Object.preventExtensions({});\n// throws a \'TypeError\'.\nfixed.__proto__ = { oh: "hai" };\n```\n\n### Non-object argument\n\nIn ES5, if the argument to this method is not an object (a primitive), then it will cause a {{jsxref("TypeError")}}. In ES2015, a non-object argument will be returned as-is without any errors, since primitives are already, by definition, immutable.\n\n```js\nObject.preventExtensions(1);\n// TypeError: 1 is not an object (ES5 code)\n\nObject.preventExtensions(1);\n// 1                             (ES2015 code)\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Object.isExtensible()")}}\n- {{jsxref("Object.seal()")}}\n- {{jsxref("Object.isSealed()")}}\n- {{jsxref("Object.freeze()")}}\n- {{jsxref("Object.isFrozen()")}}\n- {{jsxref("Reflect.preventExtensions()")}}\n'
        },
        "propertyisenumerable": {
            "index.md": '---\ntitle: Object.prototype.propertyIsEnumerable()\nslug: Web/JavaScript/Reference/Global_Objects/Object/propertyIsEnumerable\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Object.propertyIsEnumerable\n---\n\n{{JSRef}}\n\nThe **`propertyIsEnumerable()`** method of {{jsxref("Object")}} instances returns a boolean indicating whether the specified property is this object\'s [enumerable own](/en-US/docs/Web/JavaScript/Enumerability_and_ownership_of_properties) property.\n\n{{EmbedInteractiveExample("pages/js/object-prototype-propertyisenumerable.html", "taller")}}\n\n## Syntax\n\n```js-nolint\npropertyIsEnumerable(prop)\n```\n\n### Parameters\n\n- `prop`\n  - : The name of the property to test. Can be a string or a {{jsxref("Symbol")}}.\n\n### Return value\n\nA boolean value indicating whether the specified property is enumerable and is the object\'s own property.\n\n## Description\n\nAll objects that inherit from `Object.prototype` (that is, all except [`null`-prototype objects](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object#null-prototype_objects)) inherit the `propertyIsEnumerable()` method. This method determines if the specified property, string or symbol, is an enumerable own property of the object. If the object does not have the specified property, this method returns `false`.\n\nThis method is equivalent to [`Object.getOwnPropertyDescriptor(obj, prop)?.enumerable ?? false`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/getOwnPropertyDescriptor).\n\n## Examples\n\n### Using propertyIsEnumerable()\n\nThe following example shows the use of `propertyIsEnumerable()` on objects and arrays.\n\n```js\nconst o = {};\nconst a = [];\no.prop = "is enumerable";\na[0] = "is enumerable";\n\no.propertyIsEnumerable("prop"); // true\na.propertyIsEnumerable(0); // true\n```\n\n### User-defined vs. built-in objects\n\nMost built-in properties are non-enumerable by default, while user-created object properties are often enumerable, unless explicitly designated otherwise.\n\n```js\nconst a = ["is enumerable"];\n\na.propertyIsEnumerable(0); // true\na.propertyIsEnumerable("length"); // false\n\nMath.propertyIsEnumerable("random"); // false\nglobalThis.propertyIsEnumerable("Math"); // false\n```\n\n### Direct vs. inherited properties\n\nOnly enumerable own properties cause `propertyIsEnumerable()` to return `true`, although all enumerable properties, including inherited ones, are visited by the [`for...in`](/en-US/docs/Web/JavaScript/Reference/Statements/for...in) loop.\n\n```js\nconst o1 = {\n  enumerableInherited: "is enumerable",\n};\nObject.defineProperty(o1, "nonEnumerableInherited", {\n  value: "is non-enumerable",\n  enumerable: false,\n});\nconst o2 = {\n  // o1 is the prototype of o2\n  __proto__: o1,\n  enumerableOwn: "is enumerable",\n};\nObject.defineProperty(o2, "nonEnumerableOwn", {\n  value: "is non-enumerable",\n  enumerable: false,\n});\n\no2.propertyIsEnumerable("enumerableInherited"); // false\no2.propertyIsEnumerable("nonEnumerableInherited"); // false\no2.propertyIsEnumerable("enumerableOwn"); // true\no2.propertyIsEnumerable("nonEnumerableOwn"); // false\n```\n\n### Testing symbol properties\n\n{{jsxref("Symbol")}} properties are also supported by `propertyIsEnumerable()`. Note that most enumeration methods only visit string properties; enumerability of symbol properties is only useful when using {{jsxref("Object.assign()")}} or [spread syntax](/en-US/docs/Web/JavaScript/Reference/Operators/Spread_syntax). For more information, see [Enumerability and ownership of properties](/en-US/docs/Web/JavaScript/Enumerability_and_ownership_of_properties).\n\n```js\nconst sym = Symbol("enumerable");\nconst sym2 = Symbol("non-enumerable");\nconst o = {\n  [sym]: "is enumerable",\n};\nObject.defineProperty(o, sym2, {\n  value: "is non-enumerable",\n  enumerable: false,\n});\n\no.propertyIsEnumerable(sym); // true\no.propertyIsEnumerable(sym2); // false\n```\n\n### Usage with null-prototype objects\n\nBecause `null`-prototype objects do not inherit from `Object.prototype`, they do not inherit the `propertyIsEnumerable()` method. You must call `Object.prototype.propertyIsEnumerable` with the object as `this` instead.\n\n```js\nconst o = {\n  __proto__: null,\n  enumerableOwn: "is enumerable",\n};\n\no.propertyIsEnumerable("enumerableOwn"); // TypeError: o.propertyIsEnumerable is not a function\nObject.prototype.propertyIsEnumerable.call(o, "enumerableOwn"); // true\n```\n\nAlternatively, you may use {{jsxref("Object.getOwnPropertyDescriptor()")}} instead, which also helps to distinguish between non-existent properties and actually non-enumerable properties.\n\n```js\nconst o = {\n  __proto__: null,\n  enumerableOwn: "is enumerable",\n};\n\nObject.getOwnPropertyDescriptor(o, "enumerableOwn")?.enumerable; // true\nObject.getOwnPropertyDescriptor(o, "nonExistent")?.enumerable; // undefined\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Enumerability and ownership of properties](/en-US/docs/Web/JavaScript/Enumerability_and_ownership_of_properties)\n- {{jsxref("Statements/for...in", "for...in")}}\n- {{jsxref("Object.keys()")}}\n- {{jsxref("Object.defineProperty()")}}\n'
        },
        "proto": {
            "index.md": '---\ntitle: Object.prototype.__proto__\nslug: Web/JavaScript/Reference/Global_Objects/Object/proto\npage-type: javascript-instance-accessor-property\nstatus:\n  - deprecated\nbrowser-compat: javascript.builtins.Object.proto\n---\n\n{{JSRef}}{{Deprecated_Header}}\n\n> **Warning:** Changing the `[[Prototype]]` of an object is, by the nature of how modern JavaScript engines optimize property accesses, currently a very slow operation in every browser and JavaScript engine. In addition, the effects of altering inheritance are subtle and far-flung, and are not limited to the time spent in the `obj.__proto__ = ...` statement, but may extend to **_any_** code that has access to any object whose `[[Prototype]]` has been altered. You can read more in [JavaScript engine fundamentals: optimizing prototypes](https://mathiasbynens.be/notes/prototypes).\n\n> **Note:** The use of `__proto__` is controversial and discouraged. Its existence and exact behavior have only been standardized as a legacy feature to ensure web compatibility, while it presents several security issues and footguns. For better support, prefer {{jsxref("Object.getPrototypeOf()")}}/{{jsxref("Reflect.getPrototypeOf()")}} and {{jsxref("Object.setPrototypeOf()")}}/{{jsxref("Reflect.setPrototypeOf()")}} instead.\n\nThe **`__proto__`** accessor property of {{jsxref("Object")}} instances exposes the [`[[Prototype]]`](/en-US/docs/Web/JavaScript/Inheritance_and_the_prototype_chain) (either an object or {{jsxref("Operators/null", "null")}}) of this object.\n\nThe `__proto__` property can also be used in an object literal definition to set the object `[[Prototype]]` on creation, as an alternative to {{jsxref("Object.create()")}}. See: [object initializer / literal syntax](/en-US/docs/Web/JavaScript/Reference/Operators/Object_initializer). That syntax is standard and optimized for in implementations, and quite different from `Object.prototype.__proto__`.\n\n## Syntax\n\n```js-nolint\nobj.__proto__\n```\n\n### Return value\n\nIf used as a getter, returns the object\'s `[[Prototype]]`.\n\n### Exceptions\n\n- {{jsxref("TypeError")}}\n  - : Thrown if attempting to set the prototype of a [non-extensible](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/isExtensible) object or an [immutable prototype exotic object](https://tc39.es/ecma262/multipage/ordinary-and-exotic-objects-behaviours.html#sec-immutable-prototype-exotic-objects), such as `Object.prototype` or [`window`](/en-US/docs/Web/API/Window).\n\n## Description\n\nThe `__proto__` getter function exposes the value of the internal `[[Prototype]]` of an object. For objects created using an object literal (unless you use the [prototype setter](/en-US/docs/Web/JavaScript/Reference/Operators/Object_initializer#prototype_setter) syntax), this value is `Object.prototype`. For objects created using array literals, this value is [`Array.prototype`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array). For functions, this value is {{jsxref("Function.prototype")}}. You can read more about the prototype chain in [Inheritance and the prototype chain](/en-US/docs/Web/JavaScript/Inheritance_and_the_prototype_chain).\n\nThe `__proto__` setter allows the `[[Prototype]]` of an object to be mutated. The value provided must be an object or {{jsxref("Operators/null", "null")}}. Providing any other value will do nothing.\n\nUnlike {{jsxref("Object.getPrototypeOf()")}} and {{jsxref("Object.setPrototypeOf()")}}, which are always available on `Object` as static properties and always reflect the `[[Prototype]]` internal property, the `__proto__` property doesn\'t always exist as a property on all objects, and as a result doesn\'t reflect `[[Prototype]]` reliably.\n\nThe `__proto__` property is a simple accessor property on `Object.prototype` consisting of a getter and setter function. A property access for `__proto__` that eventually consults `Object.prototype` will find this property, but an access that does not consult `Object.prototype` will not. If some other `__proto__` property is found before `Object.prototype` is consulted, that property will hide the one found on `Object.prototype`.\n\n[`null`-prototype objects](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object#null-prototype_objects) don\'t inherit any property from `Object.prototype`, including the `__proto__` accessor property, so if you try to read `__proto__` on such an object, the value is always `undefined` regardless of the object\'s actual `[[Prototype]]`, and any assignment to `__proto__` would create a new property called `__proto__` instead of setting the object\'s prototype. Furthermore, `__proto__` can be redefined as an own property on any object instance through {{jsxref("Object.defineProperty()")}} without triggering the setter. In this case, `__proto__` will no longer be an accessor for `[[Prototype]]`. Therefore, always prefer {{jsxref("Object.getPrototypeOf()")}} and {{jsxref("Object.setPrototypeOf()")}} for setting and getting the `[[Prototype]]` of an object.\n\n## Examples\n\n### Using \\_\\_proto\\_\\_\n\n```js\nfunction Circle() {}\nconst shape = {};\nconst circle = new Circle();\n\n// Set the object prototype.\n// DEPRECATED. This is for example purposes only. DO NOT DO THIS in real code.\nshape.__proto__ = circle;\n\n// Get the object prototype\nconsole.log(shape.__proto__ === Circle); // false\n```\n\n```js\nconst ShapeA = function () {};\nconst ShapeB = {\n  a() {\n    console.log("aaa");\n  },\n};\n\nShapeA.prototype.__proto__ = ShapeB;\nconsole.log(ShapeA.prototype.__proto__); // { a: [Function: a] }\n\nconst shapeA = new ShapeA();\nshapeA.a(); // aaa\nconsole.log(ShapeA.prototype === shapeA.__proto__); // true\n```\n\n```js\nconst ShapeC = function () {};\nconst ShapeD = {\n  a() {\n    console.log("a");\n  },\n};\n\nconst shapeC = new ShapeC();\nshapeC.__proto__ = ShapeD;\nshapeC.a(); // a\nconsole.log(ShapeC.prototype === shapeC.__proto__); // false\n```\n\n```js\nfunction Test() {}\nTest.prototype.myName = function () {\n  console.log("myName");\n};\n\nconst test = new Test();\nconsole.log(test.__proto__ === Test.prototype); // true\ntest.myName(); // myName\n\nconst obj = {};\nobj.__proto__ = Test.prototype;\nobj.myName(); // myName\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Object.prototype.isPrototypeOf()")}}\n- {{jsxref("Object.getPrototypeOf()")}}\n- {{jsxref("Object.setPrototypeOf()")}}\n'
        },
        "seal": {
            "index.md": '---\ntitle: Object.seal()\nslug: Web/JavaScript/Reference/Global_Objects/Object/seal\npage-type: javascript-static-method\nbrowser-compat: javascript.builtins.Object.seal\n---\n\n{{JSRef}}\n\nThe **`Object.seal()`** static method _seals_ an object. Sealing an object [prevents extensions](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/preventExtensions) and makes existing properties non-configurable. A sealed object has a fixed set of properties: new properties cannot be added, existing properties cannot be removed, their enumerability and configurability cannot be changed, and its prototype cannot be re-assigned. Values of existing properties can still be changed as long as they are writable. `seal()` returns the same object that was passed in.\n\n{{EmbedInteractiveExample("pages/js/object-seal.html")}}\n\n## Syntax\n\n```js-nolint\nObject.seal(obj)\n```\n\n### Parameters\n\n- `obj`\n  - : The object which should be sealed.\n\n### Return value\n\nThe object being sealed.\n\n## Description\n\nSealing an object is equivalent to [preventing extensions](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/preventExtensions) and then changing all existing [properties\' descriptors](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/defineProperty#description) to `configurable: false`. This has the effect of making the set of properties on the object fixed. Making all properties non-configurable\nalso prevents them from being converted from data properties to accessor properties and\nvice versa, but it does not prevent the values of data properties from being changed.\nAttempting to delete or add properties to a sealed object, or to convert a data property\nto accessor or vice versa, will fail, either silently or by throwing a\n{{jsxref("TypeError")}} (most commonly, although not exclusively, when in\n{{jsxref("Strict_mode", "strict mode", "", 1)}} code).\n\n[Private properties](/en-US/docs/Web/JavaScript/Reference/Classes/Private_properties) do not have the concept of property descriptors. Private properties cannot be added or removed from the object, whether the object is sealed or not.\n\nThe prototype chain remains untouched. However, due to the effect of [preventing extensions](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/preventExtensions), the `[[Prototype]]` cannot be reassigned.\n\nUnlike {{jsxref("Object.freeze()")}}, objects sealed with `Object.seal()` may have their existing\nproperties changed, as long as they are writable.\n\n## Examples\n\n### Using Object.seal\n\n```js\nconst obj = {\n  prop() {},\n  foo: "bar",\n};\n\n// New properties may be added, existing properties\n// may be changed or removed.\nobj.foo = "baz";\nobj.lumpy = "woof";\ndelete obj.prop;\n\nconst o = Object.seal(obj);\n\no === obj; // true\nObject.isSealed(obj); // true\n\n// Changing property values on a sealed object\n// still works.\nobj.foo = "quux";\n\n// But you can\'t convert data properties to accessors,\n// or vice versa.\nObject.defineProperty(obj, "foo", {\n  get() {\n    return "g";\n  },\n}); // throws a TypeError\n\n// Now any changes, other than to property values,\n// will fail.\nobj.quaxxor = "the friendly duck";\n// silently doesn\'t add the property\ndelete obj.foo;\n// silently doesn\'t delete the property\n\n// ...and in strict mode such attempts\n// will throw TypeErrors.\nfunction fail() {\n  "use strict";\n  delete obj.foo; // throws a TypeError\n  obj.sparky = "arf"; // throws a TypeError\n}\nfail();\n\n// Attempted additions through\n// Object.defineProperty will also throw.\nObject.defineProperty(obj, "ohai", {\n  value: 17,\n}); // throws a TypeError\nObject.defineProperty(obj, "foo", {\n  value: "eit",\n}); // changes existing property value\n```\n\n### Non-object argument\n\nIn ES5, if the argument to this method is not an object (a primitive), then it will cause a {{jsxref("TypeError")}}. In ES2015, a non-object argument will be returned as-is without any errors, since primitives are already, by definition, immutable.\n\n```js\nObject.seal(1);\n// TypeError: 1 is not an object (ES5 code)\n\nObject.seal(1);\n// 1                             (ES2015 code)\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Object.isSealed()")}}\n- {{jsxref("Object.preventExtensions()")}}\n- {{jsxref("Object.isExtensible()")}}\n- {{jsxref("Object.freeze()")}}\n- {{jsxref("Object.isFrozen()")}}\n'
        },
        "setprototypeof": {
            "index.md": '---\ntitle: Object.setPrototypeOf()\nslug: Web/JavaScript/Reference/Global_Objects/Object/setPrototypeOf\npage-type: javascript-static-method\nbrowser-compat: javascript.builtins.Object.setPrototypeOf\n---\n\n{{JSRef}}\n\nThe **`Object.setPrototypeOf()`** static method sets the prototype (i.e., the internal `[[Prototype]]` property) of a specified object to another object or [`null`](/en-US/docs/Web/JavaScript/Reference/Operators/null).\n\n> **Warning:** Changing the `[[Prototype]]` of an object is, by the nature of how modern JavaScript engines optimize property accesses, currently a very slow operation in every browser and JavaScript engine. In addition, the effects of altering inheritance are subtle and far-flung, and are not limited to the time spent in the `Object.setPrototypeOf(...)` statement, but may extend to **_any_** code that has access to any object whose `[[Prototype]]` has been altered. You can read more in [JavaScript engine fundamentals: optimizing prototypes](https://mathiasbynens.be/notes/prototypes).\n>\n> Because this feature is a part of the language, it is still the burden on engine developers to implement that feature performantly (ideally). Until engine developers address this issue, if you are concerned about performance, you should avoid setting the `[[Prototype]]` of an object. Instead, create a new object with the desired `[[Prototype]]` using {{jsxref("Object.create()")}}.\n\n{{EmbedInteractiveExample("pages/js/object-setprototypeof.html")}}\n\n## Syntax\n\n```js-nolint\nObject.setPrototypeOf(obj, prototype)\n```\n\n### Parameters\n\n- `obj`\n  - : The object which is to have its prototype set.\n- `prototype`\n  - : The object\'s new prototype (an object or [`null`](/en-US/docs/Web/JavaScript/Reference/Operators/null)).\n\n### Return value\n\nThe specified object.\n\n### Exceptions\n\n- {{jsxref("TypeError")}}\n  - : Thrown in one of the following cases:\n    - The `obj` parameter is `undefined` or `null`.\n    - The `obj` parameter is [non-extensible](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/isExtensible), or it\'s an [immutable prototype exotic object](https://tc39.es/ecma262/multipage/ordinary-and-exotic-objects-behaviours.html#sec-immutable-prototype-exotic-objects), such as `Object.prototype` or [`window`](/en-US/docs/Web/API/Window). However, the error is not thrown if the new prototype is the same value as the original prototype of `obj`.\n    - The `prototype` parameter is not an object or [`null`](/en-US/docs/Web/JavaScript/Reference/Operators/null).\n\n## Description\n\n`Object.setPrototypeOf()` is generally considered the proper way to set the prototype of an object. You should always use it in favor of the deprecated [`Object.prototype.__proto__`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/proto) accessor.\n\nIf the `obj` parameter is not an object (e.g. number, string, etc.), this method does nothing \u2014 without coercing it to an object or attempting to set its prototype \u2014 and directly returns `obj` as a primitive value. If `prototype` is the same value as the prototype of `obj`, then `obj` is directly returned, without causing a `TypeError` even when `obj` has immutable prototype.\n\nFor security concerns, there are certain built-in objects that are designed to have an _immutable prototype_. This prevents prototype pollution attacks, especially [proxy-related ones](https://github.com/tc39/ecma262/issues/272). The core language only specifies `Object.prototype` as an immutable prototype exotic object, whose prototype is always `null`. In browsers, [`window`](/en-US/docs/Web/API/Window) and [`location`](/en-US/docs/Web/API/Window/location) are two other very common examples.\n\n```js\nObject.isExtensible(Object.prototype); // true; you can add more properties\nObject.setPrototypeOf(Object.prototype, {}); // TypeError: Immutable prototype object \'#<Object>\' cannot have their prototype set\nObject.setPrototypeOf(Object.prototype, null); // No error; the prototype of `Object.prototype` is already `null`\n```\n\n## Examples\n\n### Pseudoclassical inheritance using Object.setPrototypeOf()\n\nInheritance in JS using classes.\n\n```js\nclass Human {}\nclass SuperHero extends Human {}\n\nconst superMan = new SuperHero();\n```\n\nHowever, if we want to implement subclasses without using `class`, we can do the following:\n\n```js\nfunction Human(name, level) {\n  this.name = name;\n  this.level = level;\n}\n\nfunction SuperHero(name, level) {\n  Human.call(this, name, level);\n}\n\nObject.setPrototypeOf(SuperHero.prototype, Human.prototype);\n\n// Set the `[[Prototype]]` of `SuperHero.prototype`\n// to `Human.prototype`\n// To set the prototypal inheritance chain\n\nHuman.prototype.speak = function () {\n  return `${this.name} says hello.`;\n};\n\nSuperHero.prototype.fly = function () {\n  return `${this.name} is flying.`;\n};\n\nconst superMan = new SuperHero("Clark Kent", 1);\n\nconsole.log(superMan.fly());\nconsole.log(superMan.speak());\n```\n\nThe similarity between classical inheritance (with classes) and pseudoclassical inheritance (with constructors\' `prototype` property) as done above is mentioned in [Inheritance chains](/en-US/docs/Web/JavaScript/Inheritance_and_the_prototype_chain#building_longer_inheritance_chains).\n\nSince function constructors\' [`prototype`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/prototype) property is writable, you can reassign it to a new object created with [`Object.create()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/create#classical_inheritance_with_object.create) to achieve the same inheritance chain as well. There are caveats to watch out when using `create()`, such as remembering to re-add the [`constructor`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/constructor) property.\n\nIn the example below, which also uses classes, `SuperHero` is made to inherit from `Human` without using `extends` by using `setPrototypeOf()` instead.\n\n> **Warning:** It is not advisable to use `setPrototypeOf()` instead of `extends` due to performance and readability reasons.\n\n```js\nclass Human {}\nclass SuperHero {}\n\n// Set the instance properties\nObject.setPrototypeOf(SuperHero.prototype, Human.prototype);\n\n// Hook up the static properties\nObject.setPrototypeOf(SuperHero, Human);\n\nconst superMan = new SuperHero();\n```\n\nSubclassing without `extends` is mentioned in [ES-6 subclassing](https://hacks.mozilla.org/2015/08/es6-in-depth-subclassing/).\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Object.setPrototypeOf` in `core-js`](https://github.com/zloirock/core-js#ecmascript-object)\n- {{jsxref("Reflect.setPrototypeOf()")}}\n- {{jsxref("Object.prototype.isPrototypeOf()")}}\n- {{jsxref("Object.getPrototypeOf()")}}\n- [`Object.prototype.__proto__`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/proto)\n- [Inheritance chain](/en-US/docs/Web/JavaScript/Inheritance_and_the_prototype_chain#building_longer_inheritance_chains)\n- [ES6 In Depth: Subclassing](https://hacks.mozilla.org/2015/08/es6-in-depth-subclassing/) on hacks.mozilla.org (2015)\n'
        },
        "tolocalestring": {
            "index.md": '---\ntitle: Object.prototype.toLocaleString()\nslug: Web/JavaScript/Reference/Global_Objects/Object/toLocaleString\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Object.toLocaleString\n---\n\n{{JSRef}}\n\nThe **`toLocaleString()`** method of {{jsxref("Object")}} instances returns a string representing this object. This method is meant to be overridden by derived objects for locale-specific purposes.\n\n{{EmbedInteractiveExample("pages/js/object-prototype-tolocalestring.html")}}\n\n## Syntax\n\n```js-nolint\ntoLocaleString()\n```\n\n### Parameters\n\nNone. However, all objects that override this method are expected to accept at most two parameters, corresponding to `locales` and `options`, such as {{jsxref("Date.prototype.toLocaleString")}}. The parameter positions should not be used for any other purpose.\n\n### Return value\n\nThe return value of calling `this.toString()`.\n\n## Description\n\nAll objects that inherit from `Object.prototype` (that is, all except [`null`-prototype objects](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object#null-prototype_objects)) inherit the `toLocaleString()` method. {{jsxref("Object")}}\'s `toLocaleString` returns the result of calling {{jsxref("Object/toString", "this.toString()")}}.\n\nThis function is provided to give objects a generic `toLocaleString` method, even though not all may use it. In the core language, these built-in objects override `toLocaleString` to provide locale-specific formatting:\n\n- {{jsxref("Array")}}: {{jsxref("Array.prototype.toLocaleString()")}}\n- {{jsxref("Number")}}: {{jsxref("Number.prototype.toLocaleString()")}}\n- {{jsxref("Date")}}: {{jsxref("Date.prototype.toLocaleString()")}}\n- {{jsxref("TypedArray")}}: {{jsxref("TypedArray.prototype.toLocaleString()")}}\n- {{jsxref("BigInt")}}: {{jsxref("BigInt.prototype.toLocaleString()")}}\n\n## Examples\n\n### Using the base toLocaleString() method\n\nThe base `toLocaleString()` method simply calls `toString()`.\n\n```js\nconst obj = {\n  toString() {\n    return "My Object";\n  },\n};\nconsole.log(obj.toLocaleString()); // "My Object"\n```\n\n### Array toLocaleString() override\n\n{{jsxref("Array.prototype.toLocaleString()")}} is used to print array values as a string by invoking each element\'s `toLocaleString()` method and joining the results with a locale-specific separator. For example:\n\n```js\nconst testArray = [4, 7, 10];\n\nconst euroPrices = testArray.toLocaleString("fr", {\n  style: "currency",\n  currency: "EUR",\n});\n// "4,00 \u20AC,7,00 \u20AC,10,00 \u20AC"\n```\n\n### Date toLocaleString() override\n\n{{jsxref("Date.prototype.toLocaleString()")}} is used to print out date displays more suitable for specific locales. For example:\n\n```js\nconst testDate = new Date();\n// "Fri May 29 2020 18:04:24 GMT+0100 (British Summer Time)"\n\nconst deDate = testDate.toLocaleString("de");\n// "29.5.2020, 18:04:24"\n\nconst frDate = testDate.toLocaleString("fr");\n// "29/05/2020, 18:04:24"\n```\n\n### Number toLocaleString() override\n\n{{jsxref("Number.prototype.toLocaleString()")}} is used to print out number displays more suitable for specific locales, e.g. with the correct separators. For example:\n\n```js\nconst testNumber = 2901234564;\n// "2901234564"\n\nconst deNumber = testNumber.toLocaleString("de");\n// "2.901.234.564"\n\nconst frNumber = testNumber.toLocaleString("fr");\n// "2 901 234 564"\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Object.prototype.toString()")}}\n'
        },
        "tostring": {
            "index.md": '---\ntitle: Object.prototype.toString()\nslug: Web/JavaScript/Reference/Global_Objects/Object/toString\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Object.toString\n---\n\n{{JSRef}}\n\nThe **`toString()`** method of {{jsxref("Object")}} instances returns a string representing this object. This method is meant to be overridden by derived objects for custom [type coercion](/en-US/docs/Web/JavaScript/Data_structures#type_coercion) logic.\n\n{{EmbedInteractiveExample("pages/js/object-prototype-tostring.html")}}\n\n## Syntax\n\n```js-nolint\ntoString()\n```\n\n### Parameters\n\nBy default `toString()` takes no parameters. However, objects that inherit from `Object` may override it with their own implementations that do take parameters. For example, the [`Number.prototype.toString()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/toString) and [`BigInt.prototype.toString()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/BigInt/toString) methods take an optional `radix` parameter.\n\n### Return value\n\nA string representing the object.\n\n## Description\n\nJavaScript calls the `toString` method to [convert an object to a primitive value](/en-US/docs/Web/JavaScript/Data_structures#type_coercion). You rarely need to invoke the `toString` method yourself; JavaScript automatically invokes it when encountering an object where a primitive value is expected.\n\nThis method is called in priority by [string conversion](/en-US/docs/Web/JavaScript/Reference/Global_Objects/String#string_coercion), but [numeric conversion](/en-US/docs/Web/JavaScript/Data_structures#numeric_coercion) and [primitive conversion](/en-US/docs/Web/JavaScript/Data_structures#primitive_coercion) call `valueOf()` in priority. However, because the base [`valueOf()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/valueOf) method returns an object, the `toString()` method is usually called in the end, unless the object overrides `valueOf()`. For example, `+[1]` returns `1`, because its [`toString()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/toString) method returns `"1"`, which is then converted to a number.\n\nAll objects that inherit from `Object.prototype` (that is, all except [`null`-prototype objects](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object#null-prototype_objects)) inherit the `toString()` method. When you create a custom object, you can override `toString()` to call a custom method, so that your custom object can be converted to a string value. Alternatively, you can add a [`@@toPrimitive`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol/toPrimitive) method, which allows even more control over the conversion process, and will always be preferred over `valueOf` or `toString` for any type conversion.\n\nTo use the base `Object.prototype.toString()` with an object that has it overridden (or to invoke it on `null` or `undefined`), you need to call {{jsxref("Function.prototype.call()")}} or {{jsxref("Function.prototype.apply()")}} on it, passing the object you want to inspect as the first parameter (called `thisArg`).\n\n```js\nconst arr = [1, 2, 3];\n\narr.toString(); // "1,2,3"\nObject.prototype.toString.call(arr); // "[object Array]"\n```\n\n`Object.prototype.toString()` returns `"[object Type]"`, where `Type` is the object type. If the object has a [`Symbol.toStringTag`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol/toStringTag) property whose value is a string, that value will be used as the `Type`. Many built-in objects, including [`Map`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map) and [`Symbol`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol), have a `Symbol.toStringTag`. Some objects predating ES6 do not have `Symbol.toStringTag`, but have a special tag nonetheless. They include (the tag is the same as the type name given below):\n\n- [`Array`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array)\n- [`Function`](/en-US/docs/Web/JavaScript/Reference/Functions) (anything whose [`typeof`](/en-US/docs/Web/JavaScript/Reference/Operators/typeof) returns `"function"`)\n- [`Error`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error)\n- [`Boolean`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Boolean)\n- [`Number`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number)\n- [`String`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/String)\n- [`Date`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date)\n- [`RegExp`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp)\n\nThe [`arguments`](/en-US/docs/Web/JavaScript/Reference/Functions/arguments) object returns `"[object Arguments]"`. Everything else, including user-defined classes, unless with a custom `Symbol.toStringTag`, will return `"[object Object]"`.\n\n`Object.prototype.toString()` invoked on [`null`](/en-US/docs/Web/JavaScript/Reference/Operators/null) and {{jsxref("undefined")}} returns `[object Null]` and `[object Undefined]`, respectively.\n\n## Examples\n\n### Overriding toString for custom objects\n\nYou can create a function to be called in place of the default `toString()` method. The `toString()` function you create should return a string value. If it returns an object and the method is called implicitly during [type conversion](/en-US/docs/Web/JavaScript/Data_structures#type_coercion), then its result is ignored and the value of a related method, {{jsxref("Object/valueOf", "valueOf()")}}, is used instead, or a `TypeError` is thrown if none of these methods return a primitive.\n\nThe following code defines a `Dog` class.\n\n```js\nclass Dog {\n  constructor(name, breed, color, sex) {\n    this.name = name;\n    this.breed = breed;\n    this.color = color;\n    this.sex = sex;\n  }\n}\n```\n\nIf you call the `toString()` method, either explicitly or implicitly, on an instance of `Dog`, it returns the default value inherited from {{jsxref("Object")}}:\n\n```js\nconst theDog = new Dog("Gabby", "Lab", "chocolate", "female");\n\ntheDog.toString(); // "[object Object]"\n`${theDog}`; // "[object Object]"\n```\n\nThe following code overrides the default `toString()` method. This method generates a string containing the `name`, `breed`, `color`, and `sex` of the object.\n\n```js\nclass Dog {\n  constructor(name, breed, color, sex) {\n    this.name = name;\n    this.breed = breed;\n    this.color = color;\n    this.sex = sex;\n  }\n  toString() {\n    return `Dog ${this.name} is a ${this.sex} ${this.color} ${this.breed}`;\n  }\n}\n```\n\nWith the preceding code in place, any time an instance of `Dog` is used in a string context, JavaScript automatically calls the `toString()` method.\n\n```js\nconst theDog = new Dog("Gabby", "Lab", "chocolate", "female");\n\n`${theDog}`; // "Dog Gabby is a female chocolate Lab"\n```\n\n### Using toString() to detect object class\n\n`toString()` can be used with every object and (by default) allows you to get its class.\n\n```js\nconst toString = Object.prototype.toString;\n\ntoString.call(new Date()); // [object Date]\ntoString.call(new String()); // [object String]\n// Math has its Symbol.toStringTag\ntoString.call(Math); // [object Math]\n\ntoString.call(undefined); // [object Undefined]\ntoString.call(null); // [object Null]\n```\n\nUsing `toString()` in this way is unreliable; objects can change the behavior of `Object.prototype.toString()` by defining a {{jsxref("Symbol.toStringTag")}} property, leading to unexpected results. For example:\n\n```js\nconst myDate = new Date();\nObject.prototype.toString.call(myDate); // [object Date]\n\nmyDate[Symbol.toStringTag] = "myDate";\nObject.prototype.toString.call(myDate); // [object myDate]\n\nDate.prototype[Symbol.toStringTag] = "prototype polluted";\nObject.prototype.toString.call(new Date()); // [object prototype polluted]\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Object.prototype.toString` with `Symbol.toStringTag` support in `core-js`](https://github.com/zloirock/core-js#ecmascript-object)\n- {{jsxref("Object.prototype.valueOf()")}}\n- {{jsxref("Number.prototype.toString()")}}\n- {{jsxref("Symbol.toPrimitive")}}\n- {{jsxref("Symbol.toStringTag")}}\n'
        },
        "valueof": {
            "index.md": '---\ntitle: Object.prototype.valueOf()\nslug: Web/JavaScript/Reference/Global_Objects/Object/valueOf\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Object.valueOf\n---\n\n{{JSRef}}\n\nThe **`valueOf()`** method of {{jsxref("Object")}} instances converts the `this` value [to an object](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object#object_coercion). This method is meant to be overridden by derived objects for custom [type conversion](/en-US/docs/Web/JavaScript/Data_structures#type_coercion) logic.\n\n{{EmbedInteractiveExample("pages/js/object-prototype-valueof.html")}}\n\n## Syntax\n\n```js-nolint\nvalueOf()\n```\n\n### Parameters\n\nNone.\n\n### Return value\n\nThe `this` value, converted to an object.\n\n> **Note:** In order for `valueOf` to be useful during type conversion, it must return a primitive. Because all primitive types have their own `valueOf()` methods, calling `aPrimitiveValue.valueOf()` generally does not invoke `Object.prototype.valueOf()`.\n\n## Description\n\nJavaScript calls the `valueOf` method to [convert an object to a primitive value](/en-US/docs/Web/JavaScript/Data_structures#type_coercion). You rarely need to invoke the `valueOf` method yourself; JavaScript automatically invokes it when encountering an object where a primitive value is expected.\n\nThis method is called in priority by [numeric conversion](/en-US/docs/Web/JavaScript/Data_structures#numeric_coercion) and [primitive conversion](/en-US/docs/Web/JavaScript/Data_structures#primitive_coercion), but [string conversion](/en-US/docs/Web/JavaScript/Reference/Global_Objects/String#string_coercion) calls `toString()` in priority, and `toString()` is very likely to return a string value (even for the {{jsxref("Object.prototype.toString()")}} base implementation), so `valueOf()` is usually not called in this case.\n\nAll objects that inherit from `Object.prototype` (that is, all except [`null`-prototype objects](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object#null-prototype_objects)) inherit the `toString()` method. The `Object.prototype.valueOf()` base implementation is deliberately useless: by returning an object, its return value will never be used by any [primitive conversion algorithm](/en-US/docs/Web/JavaScript/Data_structures#type_coercion). Many built-in objects override this method to return an appropriate primitive value. When you create a custom object, you can override `valueOf()` to call a custom method, so that your custom object can be converted to a primitive value. Generally, `valueOf()` is used to return a value that is most meaningful for the object \u2014 unlike `toString()`, it does not need to be a string. Alternatively, you can add a [`@@toPrimitive`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol/toPrimitive) method, which allows even more control over the conversion process, and will always be preferred over `valueOf` or `toString` for any type conversion.\n\n## Examples\n\n### Using valueOf()\n\nThe base `valueOf()` method returns the `this` value itself, converted to an object if it isn\'t already. Therefore its return value will never be used by any primitive conversion algorithm.\n\n```js\nconst obj = { foo: 1 };\nconsole.log(obj.valueOf() === obj); // true\n\nconsole.log(Object.prototype.valueOf.call("primitive"));\n// [String: \'primitive\'] (a wrapper object)\n```\n\n### Overriding valueOf for custom objects\n\nYou can create a function to be called in place of the default `valueOf` method. Your function should take no arguments, since it won\'t be passed any when called during type conversion.\n\nFor example, you can add a `valueOf` method to your custom class `Box`.\n\n```js\nclass Box {\n  #value;\n  constructor(value) {\n    this.#value = value;\n  }\n  valueOf() {\n    return this.#value;\n  }\n}\n```\n\nWith the preceding code in place, any time an object of type `Box` is used in a context where it is to be represented as a primitive value (but not specifically a string), JavaScript automatically calls the function defined in the preceding code.\n\n```js\nconst box = new Box(123);\nconsole.log(box + 456); // 579\nconsole.log(box == 123); // true\n```\n\nAn object\'s `valueOf` method is usually invoked by JavaScript, but you can invoke it yourself as follows:\n\n```js\nbox.valueOf();\n```\n\n### Using unary plus on objects\n\n[Unary plus](/en-US/docs/Web/JavaScript/Reference/Operators/Unary_plus) performs [number coercion](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number#number_coercion) on its operand, which, for most objects without [`@@toPrimitive`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol/toPrimitive), means calling its `valueOf()`. However, if the object doesn\'t have a custom `valueOf()` method, the base implementation will cause `valueOf()` to be ignored and the return value of `toString()` to be used instead.\n\n```js\n+new Date(); // the current timestamp; same as new Date().getTime()\n+{}; // NaN (toString() returns "[object Object]")\n+[]; // 0 (toString() returns an empty string list)\n+[1]; // 1 (toString() returns "1")\n+[1, 2]; // NaN (toString() returns "1,2")\n+new Set([1]); // NaN (toString() returns "[object Set]")\n+{ valueOf: () => 42 }; // 42\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Object.prototype.toString()")}}\n- {{jsxref("parseInt()")}}\n- {{jsxref("Symbol.toPrimitive")}}\n'
        },
        "values": {
            "index.md": '---\ntitle: Object.values()\nslug: Web/JavaScript/Reference/Global_Objects/Object/values\npage-type: javascript-static-method\nbrowser-compat: javascript.builtins.Object.values\n---\n\n{{JSRef}}\n\nThe **`Object.values()`** static method returns an array of a given object\'s own enumerable string-keyed property values.\n\n{{EmbedInteractiveExample("pages/js/object-values.html")}}\n\n## Syntax\n\n```js-nolint\nObject.values(obj)\n```\n\n### Parameters\n\n- `obj`\n  - : An object.\n\n### Return value\n\nAn array containing the given object\'s own enumerable string-keyed property values.\n\n## Description\n\n`Object.values()` returns an array whose elements are values of enumerable string-keyed properties found directly upon `object`. This is the same as iterating with a {{jsxref("Statements/for...in", "for...in")}} loop, except that a `for...in` loop enumerates properties in the prototype chain as well. The order of the array returned by `Object.values()` is the same as that provided by a {{jsxref("Statements/for...in", "for...in")}} loop.\n\nIf you need the property keys, use {{jsxref("Object.keys()")}} instead. If you need both the property keys and values, use {{jsxref("Object.entries()")}} instead.\n\n## Examples\n\n### Using Object.values()\n\n```js\nconst obj = { foo: "bar", baz: 42 };\nconsole.log(Object.values(obj)); // [\'bar\', 42]\n\n// Array-like object\nconst arrayLikeObj1 = { 0: "a", 1: "b", 2: "c" };\nconsole.log(Object.values(arrayLikeObj1)); // [\'a\', \'b\', \'c\']\n\n// Array-like object with random key ordering\n// When using numeric keys, the values are returned in the keys\' numerical order\nconst arrayLikeObj2 = { 100: "a", 2: "b", 7: "c" };\nconsole.log(Object.values(arrayLikeObj2)); // [\'b\', \'c\', \'a\']\n\n// getFoo is a non-enumerable property\nconst myObj = Object.create(\n  {},\n  {\n    getFoo: {\n      value() {\n        return this.foo;\n      },\n    },\n  },\n);\nmyObj.foo = "bar";\nconsole.log(Object.values(myObj)); // [\'bar\']\n```\n\n### Using Object.values() on primitives\n\nNon-object arguments are [coerced to objects](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object#object_coercion). [`undefined`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/undefined) and [`null`](/en-US/docs/Web/JavaScript/Reference/Operators/null) cannot be coerced to objects and throw a {{jsxref("TypeError")}} upfront. Only strings may have own enumerable properties, while all other primitives return an empty array.\n\n```js\n// Strings have indices as enumerable own properties\nconsole.log(Object.values("foo")); // [\'f\', \'o\', \'o\']\n\n// Other primitives except undefined and null have no own properties\nconsole.log(Object.values(100)); // []\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Object.values` in `core-js`](https://github.com/zloirock/core-js#ecmascript-object)\n- [Enumerability and ownership of properties](/en-US/docs/Web/JavaScript/Enumerability_and_ownership_of_properties)\n- {{jsxref("Object.keys()")}}\n- {{jsxref("Object.entries()")}}\n- {{jsxref("Object.prototype.propertyIsEnumerable()")}}\n- {{jsxref("Object.create()")}}\n- {{jsxref("Object.getOwnPropertyNames()")}}\n- {{jsxref("Map.prototype.values()")}}\n'
        }
    },
    "parsefloat": {
        "index.md": '---\ntitle: parseFloat()\nslug: Web/JavaScript/Reference/Global_Objects/parseFloat\npage-type: javascript-function\nbrowser-compat: javascript.builtins.parseFloat\n---\n\n{{jsSidebar("Objects")}}\n\nThe **`parseFloat()`** function parses a string argument and returns a floating point number.\n\n{{EmbedInteractiveExample("pages/js/globalprops-parsefloat.html")}}\n\n## Syntax\n\n```js-nolint\nparseFloat(string)\n```\n\n### Parameters\n\n- `string`\n  - : The value to parse, [coerced to a string](/en-US/docs/Web/JavaScript/Reference/Global_Objects/String#string_coercion). Leading {{Glossary("whitespace")}} in this argument is ignored.\n\n### Return value\n\nA floating point number parsed from the given `string`, or {{jsxref("NaN")}} when the first non-whitespace character cannot be converted to a number.\n\n> **Note:** JavaScript does not have the distinction of "floating point numbers" and "integers" on the language level. [`parseInt()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/parseInt) and `parseFloat()` only differ in their parsing behavior, but not necessarily their return values. For example, `parseInt("42")` and `parseFloat("42")` would return the same value: a {{jsxref("Number")}} 42.\n\n## Description\n\nThe `parseFloat` function converts its first argument to a string, parses that string as a decimal number literal, then returns a number or `NaN`. The number syntax it accepts can be summarized as:\n\n- The characters accepted by `parseFloat()` are plus sign (`+`), minus sign (`-` U+002D HYPHEN-MINUS), decimal digits (`0` \u2013 `9`), decimal point (`.`), exponent indicator (`e` or `E`), and the `"Infinity"` literal.\n- The `+`/`-` signs can only appear strictly at the beginning of the string, or immediately following the `e`/`E` character. The decimal point can only appear once, and only before the `e`/`E` character. The `e`/`E` character can only appear once, and only if there is at least one digit before it.\n- Leading spaces in the argument are trimmed and ignored.\n- `parseFloat()` can also parse and return {{jsxref("Infinity")}} or `-Infinity` if the string starts with `"Infinity"` or `"-Infinity"` preceded by none or more white spaces.\n- `parseFloat()` picks the longest substring starting from the beginning that generates a valid number literal. If it encounters an invalid character, it returns the number represented up to that point, ignoring the invalid character and all characters following it.\n- If the argument\'s first character can\'t start a legal number literal per the syntax above, `parseFloat` returns {{jsxref("NaN")}}.\n\nSyntax-wise, `parseFloat()` parses a subset of the syntax that the [`Number()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/Number) function accepts. Namely, `parseFloat()` does not support non-decimal literals with `0x`, `0b`, or `0o` prefixes but supports everything else. However, `parseFloat()` is more lenient than `Number()` because it ignores trailing invalid characters, which would cause `Number()` to return `NaN`.\n\nSimilar to number literals and `Number()`, the number returned from `parseFloat()` may not be exactly equal to the number represented by the string, due to floating point range and inaccuracy. For numbers outside the `-1.7976931348623158e+308` \u2013 `1.7976931348623158e+308` range (see {{jsxref("Number.MAX_VALUE")}}), `-Infinity` or `Infinity` is returned.\n\n## Examples\n\n### Using parseFloat()\n\nThe following examples all return `3.14`:\n\n```js\nparseFloat(3.14);\nparseFloat("3.14");\nparseFloat("  3.14  ");\nparseFloat("314e-2");\nparseFloat("0.0314E+2");\nparseFloat("3.14some non-digit characters");\nparseFloat({\n  toString() {\n    return "3.14";\n  },\n});\n```\n\n### parseFloat() returning NaN\n\nThe following example returns `NaN`:\n\n```js\nparseFloat("FF2");\n```\n\nAnecdotally, because the string `NaN` itself is invalid syntax as accepted by `parseFloat()`, passing `"NaN"` returns `NaN` as well.\n\n```js\nparseFloat("NaN"); // NaN\n```\n\n### Returning Infinity\n\nInfinity values are returned when the number is outside the double-precision 64-bit IEEE 754-2019 format range:\n\n```js\nparseFloat("1.7976931348623159e+308"); // Infinity\nparseFloat("-1.7976931348623159e+308"); // -Infinity\n```\n\nInfinity is also returned when the string starts with `"Infinity"` or `"-Infinity"`:\n\n```js\nparseFloat("Infinity"); // Infinity\nparseFloat("-Infinity"); // -Infinity\n```\n\n### Interaction with BigInt values\n\n`parseFloat()` does not handle {{jsxref("BigInt")}} values. It stops at the `n` character, and treats the preceding string as a normal integer, with possible loss of precision. If a BigInt value is passed to `parseFloat()`, it will be converted to a string, and the string will be parsed as a floating-point number, which may result in loss of precision as well.\n\n```js example-bad\nparseFloat(900719925474099267n); // 900719925474099300\nparseFloat("900719925474099267n"); // 900719925474099300\n```\n\nYou should pass the string to the [`BigInt()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/BigInt/BigInt) function instead, without the trailing `n` character.\n\n```js example-good\nBigInt("900719925474099267");\n// 900719925474099267n\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("parseInt()")}}\n- {{jsxref("Number.parseFloat()")}}\n- {{jsxref("Number.parseInt()")}}\n- {{jsxref("Number.prototype.toFixed()")}}\n'
    },
    "parseint": {
        "index.md": '---\ntitle: parseInt()\nslug: Web/JavaScript/Reference/Global_Objects/parseInt\npage-type: javascript-function\nbrowser-compat: javascript.builtins.parseInt\n---\n\n{{jsSidebar("Objects")}}\n\nThe **`parseInt()`** function parses a string argument and returns an integer of the specified [radix](https://en.wikipedia.org/wiki/Radix) (the base in mathematical numeral systems).\n\n{{EmbedInteractiveExample("pages/js/globalprops-parseint.html")}}\n\n## Syntax\n\n```js-nolint\nparseInt(string)\nparseInt(string, radix)\n```\n\n### Parameters\n\n- `string`\n  - : A string starting with an integer. Leading {{Glossary("whitespace")}} in this argument is ignored.\n- `radix` {{optional_inline}}\n\n  - : An integer between `2` and `36` that represents the _radix_ (the base in mathematical numeral systems) of the `string`. It is converted to a [32-bit integer](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number#fixed-width_number_conversion); if it\'s nonzero and outside the range of \\[2, 36] after conversion, the function will always return `NaN`. If `0` or not provided, the radix will be inferred based on `string`\'s value. Be careful \u2014 this does _not_ always default to `10`! The [description below](#description) explains in more detail what happens when `radix` is not provided.\n\n### Return value\n\nAn integer parsed from the given `string`, or {{jsxref("NaN")}} when\n\n- the `radix` as a 32-bit integer is smaller than `2` or bigger than `36`, or\n- the first non-whitespace character cannot be converted to a number.\n\n> **Note:** JavaScript does not have the distinction of "floating point numbers" and "integers" on the language level. `parseInt()` and [`parseFloat()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/parseFloat) only differ in their parsing behavior, but not necessarily their return values. For example, `parseInt("42")` and `parseFloat("42")` would return the same value: a {{jsxref("Number")}} 42.\n\n## Description\n\nThe `parseInt` function [converts its first argument to a string](/en-US/docs/Web/JavaScript/Reference/Global_Objects/String#string_coercion), parses that string, then returns an integer or `NaN`.\n\nIf not `NaN`, the return value will be the integer that is the first argument taken as a number in the specified `radix`. (For example, a `radix` of `10` converts from a decimal number, `8` converts from octal, `16` from hexadecimal, and so on.)\n\nThe `radix` argument is [converted to a number](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number#number_coercion). If it\'s unprovided, or if the value becomes 0, `NaN` or `Infinity` (`undefined` is coerced to `NaN`), JavaScript assumes the following:\n\n1. If the input `string`, with leading whitespace and possible `+`/`-` signs removed, begins with `0x` or `0X` (a zero, followed by lowercase or uppercase X), `radix` is assumed to be `16` and the rest of the string is parsed as a hexadecimal number.\n2. If the input `string` begins with any other value, the radix is `10` (decimal).\n\n> **Note:** Other prefixes like `0b`, which are valid in [number literals](/en-US/docs/Web/JavaScript/Reference/Lexical_grammar#binary), are treated as normal digits by `parseInt()`. `parseInt()` does _not_ treat strings beginning with a `0` character as octal values either. The only prefix that `parseInt()` recognizes is `0x` or `0X` for hexadecimal values \u2014 everything else is parsed as a decimal value if `radix` is missing. [`Number()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/Number) or [`BigInt()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/BigInt/BigInt) can be used instead to parse these prefixes.\n\nIf the radix is `16`, `parseInt()` allows the string to be optionally prefixed by `0x` or `0X` after the optional sign character (`+`/`-`).\n\nIf the radix value (coerced if necessary) is not in range \\[2, 36] (inclusive) `parseInt` returns `NaN`.\n\nFor radices above `10`, letters of the English alphabet indicate numerals greater than `9`. For example, for hexadecimal numbers (base `16`), `A` through `F` are used. The letters are case-insensitive.\n\n`parseInt` understands exactly two signs: `+` for positive, and `-` for negative. It is done as an initial step in the parsing after whitespace is removed. If no signs are found, the algorithm moves to the following step; otherwise, it removes the sign and runs the number-parsing on the rest of the string.\n\nIf `parseInt` encounters a character that is not a numeral in the specified `radix`, it ignores it and all succeeding characters and returns the integer value parsed up to that point. For example, although `1e3` technically encodes an integer (and will be correctly parsed to the integer `1000` by [`parseFloat()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/parseFloat)), `parseInt("1e3", 10)` returns `1`, because `e` is not a valid numeral in base 10. Because `.` is not a numeral either, the return value will always be an integer.\n\nIf the first character cannot be converted to a number with the radix in use, `parseInt` returns `NaN`. Leading whitespace is allowed.\n\nFor arithmetic purposes, the `NaN` value is not a number in any radix. You can call the [`Number.isNaN`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/isNaN) function to determine if the result of `parseInt` is `NaN`. If `NaN` is passed on to arithmetic operations, the operation result will also be `NaN`.\n\nBecause large numbers use the `e` character in their string representation (e.g. `6.022e23` for 6.022 \xd7 10<sup>23</sup>), using `parseInt` to truncate numbers will produce unexpected results when used on very large or very small numbers. `parseInt` should _not_ be used as a substitute for {{jsxref("Math.trunc()")}}.\n\nTo convert a number to its string literal in a particular radix, use [`thatNumber.toString(radix)`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/toString).\n\nBecause `parseInt()` returns a number, it may suffer from loss of precision if the integer represented by the string is [outside the safe range](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/isSafeInteger). The [`BigInt()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/BigInt/BigInt) function supports parsing integers of arbitrary length accurately, by returning a {{jsxref("BigInt")}}.\n\n## Examples\n\n### Using parseInt()\n\nThe following examples all return `15`:\n\n```js\nparseInt("0xF", 16);\nparseInt("F", 16);\nparseInt("17", 8);\nparseInt("015", 10); // but `parseInt(\'015\', 8)` will return 13\nparseInt("15,123", 10);\nparseInt("FXX123", 16);\nparseInt("1111", 2);\nparseInt("15 * 3", 10);\nparseInt("15e2", 10);\nparseInt("15px", 10);\nparseInt("12", 13);\n```\n\nThe following examples all return `NaN`:\n\n```js\nparseInt("Hello", 8); // Not a number at all\nparseInt("546", 2); // Digits other than 0 or 1 are invalid for binary radix\n```\n\nThe following examples all return `-15`:\n\n```js\nparseInt("-F", 16);\nparseInt("-0F", 16);\nparseInt("-0XF", 16);\nparseInt("-17", 8);\nparseInt("-15", 10);\nparseInt("-1111", 2);\nparseInt("-15e1", 10);\nparseInt("-12", 13);\n```\n\nThe following example returns `224`:\n\n```js\nparseInt("0e0", 16);\n```\n\n`parseInt()` does not handle {{jsxref("BigInt")}} values. It stops at the `n` character, and treats the preceding string as a normal integer, with possible loss of precision.\n\n```js example-bad\nparseInt("900719925474099267n");\n// 900719925474099300\n```\n\nYou should pass the string to the [`BigInt()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/BigInt/BigInt) function instead, without the trailing `n` character.\n\n```js example-good\nBigInt("900719925474099267");\n// 900719925474099267n\n```\n\n`parseInt` doesn\'t work with [numeric separators](/en-US/docs/Web/JavaScript/Reference/Lexical_grammar#numeric_separators):\n\n```js example-bad\nparseInt("123_456"); // 123\n```\n\n### Using parseInt() on non-strings\n\n`parseInt()` can have interesting results when working on non-strings combined with a high radix; for example, `36` (which makes all alphanumeric characters valid numeric digits).\n\n```js\nparseInt(null, 36); // 1112745: The string "null" is 1112745 in base 36\nparseInt(undefined, 36); // 86464843759093: The string "undefined" is 86464843759093 in base 36\n```\n\nIn general, it\'s a bad idea to use `parseInt()` on non-strings, especially to use it as a substitution for {{jsxref("Math.trunc()")}}. It may work on small numbers:\n\n```js\nparseInt(15.99, 10); // 15\nparseInt(-15.1, 10); // -15\n```\n\nHowever, it only happens to work because the string representation of these numbers uses basic fractional notation (`"15.99"`, `"-15.1"`), where `parseInt()` stops at the decimal point. Numbers greater than or equal to 1e+21 or less than or equal to 1e-7 use exponential notation (`"1.5e+22"`, `"1.51e-8"`) in their string representation, and `parseInt()` will stop at the `e` character or decimal point, which always comes after the first digit. This means for large and small numbers, `parseInt()` will return a one-digit integer:\n\n```js example-bad\nparseInt(4.7 * 1e22, 10); // Very large number becomes 4\nparseInt(0.00000000000434, 10); // Very small number becomes 4\n\nparseInt(0.0000001, 10); // 1\nparseInt(0.000000123, 10); // 1\nparseInt(1e-7, 10); // 1\nparseInt(1000000000000000000000, 10); // 1\nparseInt(123000000000000000000000, 10); // 1\nparseInt(1e21, 10); // 1\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("parseFloat()")}}\n- [`Number()` constructor](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/Number)\n- {{jsxref("Number.parseFloat()")}}\n- {{jsxref("Number.parseInt()")}}\n- {{jsxref("isNaN()")}}\n- {{jsxref("Number.prototype.toString()")}}\n- {{jsxref("Object.prototype.valueOf()")}}\n- [`BigInt()` constructor](/en-US/docs/Web/JavaScript/Reference/Global_Objects/BigInt/BigInt)\n'
    },
    "promise": {
        "@@species": {
            "index.md": '---\ntitle: Promise[@@species]\nslug: Web/JavaScript/Reference/Global_Objects/Promise/@@species\npage-type: javascript-static-accessor-property\nbrowser-compat: javascript.builtins.Promise.@@species\n---\n\n{{JSRef}}\n\nThe **`Promise[@@species]`** static accessor property returns the constructor used to construct return values from promise methods.\n\n> **Warning:** The existence of `@@species` allows execution of arbitrary code and may create security vulnerabilities. It also makes certain optimizations much harder. Engine implementers are [investigating whether to remove this feature](https://github.com/tc39/proposal-rm-builtin-subclassing). Avoid relying on it if possible.\n\n## Syntax\n\n```js-nolint\nPromise[Symbol.species]\n```\n\n### Return value\n\nThe value of the constructor (`this`) on which `get @@species` was called. The return value is used to construct return values from promise chaining methods that create new promises.\n\n## Description\n\nThe `@@species` accessor property returns the default constructor for `Promise` objects. Subclass constructors may override it to change the constructor assignment. The default implementation is basically:\n\n```js\n// Hypothetical underlying implementation for illustration\nclass Promise {\n  static get [Symbol.species]() {\n    return this;\n  }\n}\n```\n\nBecause of this polymorphic implementation, `@@species` of derived subclasses would also return the constructor itself by default.\n\n```js\nclass SubPromise extends Promise {}\nSubPromise[Symbol.species] === SubPromise; // true\n```\n\nPromise chaining methods \u2014 [`then()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise/then), [`catch()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise/catch), and [`finally()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise/finally) \u2014 return new promise objects. They get the constructor to construct the new promise through `this.constructor[@@species]`. If `this.constructor` is `undefined`, or if `this.constructor[@@species]` is `undefined` or `null`, the default {{jsxref("Promise/Promise", "Promise()")}} constructor is used. Otherwise, the constructor returned by `this.constructor[@@species]` is used to construct the new promise object.\n\n## Examples\n\n### Species in ordinary objects\n\nThe `Symbol.species` property returns the default constructor function, which is the `Promise` constructor for `Promise`.\n\n```js\nPromise[Symbol.species]; // [Function: Promise]\n```\n\n### Species in derived objects\n\nIn an instance of a custom `Promise` subclass, such as `MyPromise`, the `MyPromise` species is the `MyPromise` constructor. However, you might want to override this, in order to return parent `Promise` objects in your derived class methods.\n\n```js\nclass MyPromise extends Promise {\n  // Override MyPromise species to the parent Promise constructor\n  static get [Symbol.species]() {\n    return Promise;\n  }\n}\n```\n\nBy default, promise methods would return promises with the type of the subclass.\n\n```js\nclass MyPromise extends Promise {\n  someValue = 1;\n}\n\nconsole.log(MyPromise.resolve(1).then(() => {}).someValue); // 1\n```\n\nBy overriding `@@species`, the promise methods will return the base `Promise` type.\n\n```js\nclass MyPromise extends Promise {\n  someValue = 1;\n  static get [Symbol.species]() {\n    return Promise;\n  }\n}\n\nconsole.log(MyPromise.resolve(1).then(() => {}).someValue); // undefined\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Promise")}}\n- {{jsxref("Symbol.species")}}\n'
        },
        "all": {
            "index.md": '---\ntitle: Promise.all()\nslug: Web/JavaScript/Reference/Global_Objects/Promise/all\npage-type: javascript-static-method\nbrowser-compat: javascript.builtins.Promise.all\n---\n\n{{JSRef}}\n\nThe **`Promise.all()`** static method takes an iterable of promises as input and returns a single {{jsxref("Promise")}}. This returned promise fulfills when all of the input\'s promises fulfill (including when an empty iterable is passed), with an array of the fulfillment values. It rejects when any of the input\'s promises rejects, with this first rejection reason.\n\n{{EmbedInteractiveExample("pages/js/promise-all.html")}}\n\n## Syntax\n\n```js-nolint\nPromise.all(iterable)\n```\n\n### Parameters\n\n- `iterable`\n  - : An [iterable](/en-US/docs/Web/JavaScript/Reference/Iteration_protocols#the_iterable_protocol) (such as an {{jsxref("Array")}}) of promises.\n\n### Return value\n\nA {{jsxref("Promise")}} that is:\n\n- **Already fulfilled**, if the `iterable` passed is empty.\n- **Asynchronously fulfilled**, when all the promises in the given `iterable` fulfill. The fulfillment value is an array of fulfillment values, in the order of the promises passed, regardless of completion order. If the `iterable` passed is non-empty but contains no pending promises, the returned promise is still asynchronously (instead of synchronously) fulfilled.\n- **Asynchronously rejected**, when any of the promises in the given `iterable` rejects. The rejection reason is the rejection reason of the first promise that was rejected.\n\n## Description\n\nThe `Promise.all()` method is one of the [promise concurrency](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise#promise_concurrency) methods. It can be useful for aggregating the results of multiple promises. It is typically used when there are multiple related asynchronous tasks that the overall code relies on to work successfully \u2014 all of whom we want to fulfill before the code execution continues.\n\n`Promise.all()` will reject immediately upon **any** of the input promises rejecting. In comparison, the promise returned by {{jsxref("Promise.allSettled()")}} will wait for all input promises to complete, regardless of whether or not one rejects. Use `allSettled()` if you need the final result of every promise in the input iterable.\n\n## Examples\n\n### Using Promise.all()\n\n`Promise.all` waits for all fulfillments (or the first rejection).\n\n```js\nconst p1 = Promise.resolve(3);\nconst p2 = 1337;\nconst p3 = new Promise((resolve, reject) => {\n  setTimeout(() => {\n    resolve("foo");\n  }, 100);\n});\n\nPromise.all([p1, p2, p3]).then((values) => {\n  console.log(values); // [3, 1337, "foo"]\n});\n```\n\nIf the `iterable` contains non-promise values, they will be ignored, but still counted in the returned promise array value (if the promise is fulfilled):\n\n```js\n// All values are non-promises, so the returned promise gets fulfilled\nconst p = Promise.all([1, 2, 3]);\n// The only input promise is already fulfilled,\n// so the returned promise gets fulfilled\nconst p2 = Promise.all([1, 2, 3, Promise.resolve(444)]);\n// One (and the only) input promise is rejected,\n// so the returned promise gets rejected\nconst p3 = Promise.all([1, 2, 3, Promise.reject(555)]);\n\n// Using setTimeout, we can execute code after the queue is empty\nsetTimeout(() => {\n  console.log(p);\n  console.log(p2);\n  console.log(p3);\n});\n\n// Logs:\n// Promise { <state>: "fulfilled", <value>: Array[3] }\n// Promise { <state>: "fulfilled", <value>: Array[4] }\n// Promise { <state>: "rejected", <reason>: 555 }\n```\n\n### Asynchronicity or synchronicity of Promise.all\n\nThis following example demonstrates the asynchronicity of `Promise.all` when a non-empty `iterable` is passed:\n\n```js\n// Passing an array of promises that are already resolved,\n// to trigger Promise.all as soon as possible\nconst resolvedPromisesArray = [Promise.resolve(33), Promise.resolve(44)];\n\nconst p = Promise.all(resolvedPromisesArray);\n// Immediately logging the value of p\nconsole.log(p);\n\n// Using setTimeout, we can execute code after the queue is empty\nsetTimeout(() => {\n  console.log("the queue is now empty");\n  console.log(p);\n});\n\n// Logs, in order:\n// Promise { <state>: "pending" }\n// the queue is now empty\n// Promise { <state>: "fulfilled", <value>: Array[2] }\n```\n\nThe same thing happens if `Promise.all` rejects:\n\n```js\nconst mixedPromisesArray = [Promise.resolve(33), Promise.reject(44)];\nconst p = Promise.all(mixedPromisesArray);\nconsole.log(p);\nsetTimeout(() => {\n  console.log("the queue is now empty");\n  console.log(p);\n});\n\n// Logs:\n// Promise { <state>: "pending" }\n// the queue is now empty\n// Promise { <state>: "rejected", <reason>: 44 }\n```\n\n`Promise.all` resolves synchronously if and only if the `iterable` passed is empty:\n\n```js\nconst p = Promise.all([]); // Will be immediately resolved\nconst p2 = Promise.all([1337, "hi"]); // Non-promise values are ignored, but the evaluation is done asynchronously\nconsole.log(p);\nconsole.log(p2);\nsetTimeout(() => {\n  console.log("the queue is now empty");\n  console.log(p2);\n});\n\n// Logs:\n// Promise { <state>: "fulfilled", <value>: Array[0] }\n// Promise { <state>: "pending" }\n// the queue is now empty\n// Promise { <state>: "fulfilled", <value>: Array[2] }\n```\n\n### Using Promise.all() with async functions\n\nWithin [async functions](/en-US/docs/Web/JavaScript/Reference/Statements/async_function), it\'s very common to "over-await" your code. For example, given the following functions:\n\n```js\nfunction promptForDishChoice() {\n  return new Promise((resolve, reject) => {\n    const dialog = document.createElement("dialog");\n    dialog.innerHTML = `\n<form method="dialog">\n  <p>What would you like to eat?</p>\n  <select>\n    <option value="pizza">Pizza</option>\n    <option value="pasta">Pasta</option>\n    <option value="salad">Salad</option>\n  </select>\n  <menu>\n    <li><button value="cancel">Cancel</button></li>\n    <li><button type="submit" value="ok">OK</button></li>\n  </menu>\n</form>\n    `;\n    dialog.addEventListener("close", () => {\n      if (dialog.returnValue === "ok") {\n        resolve(dialog.querySelector("select").value);\n      } else {\n        reject(new Error("User cancelled dialog"));\n      }\n    });\n    document.body.appendChild(dialog);\n    dialog.showModal();\n  });\n}\n\nasync function fetchPrices() {\n  const response = await fetch("/prices");\n  return await response.json();\n}\n```\n\nYou may write a function like this:\n\n```js example-bad\nasync function getPrice() {\n  const choice = await promptForDishChoice();\n  const prices = await fetchPrices();\n  return prices[choice];\n}\n```\n\nHowever, note that the execution of `promptForDishChoice` and `fetchPrices` don\'t depend on the result of each other. While the user is choosing their dish, it\'s fine for the prices to be fetched in the background, but in the code above, the [`await`](/en-US/docs/Web/JavaScript/Reference/Operators/await) operator causes the async function to pause until the choice is made, and then again until the prices are fetched. We can use `Promise.all` to run them concurrently, so that the user doesn\'t have to wait for the prices to be fetched before the result is given:\n\n```js example-good\nasync function getPrice() {\n  const [choice, prices] = await Promise.all([\n    promptForDishChoice(),\n    fetchPrices(),\n  ]);\n  return prices[choice];\n}\n```\n\n`Promise.all` is the best choice of [concurrency method](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise#promise_concurrency) here, because error handling is intuitive \u2014 if any of the promises reject, the result is no longer available, so the whole `await` expression throws.\n\n`Promise.all` accepts an iterable of promises, so if you are using it to run several async functions concurrently, you need to call the async functions and use the returned promises. Directly passing the functions to `Promise.all` does not work, since they are not promises.\n\n```js example-bad\nasync function getPrice() {\n  const [choice, prices] = await Promise.all([\n    promptForDishChoice,\n    fetchPrices,\n  ]);\n  // `choice` and `prices` are still the original async functions;\n  // Promise.all() does nothing to non-promises\n}\n```\n\n### Promise.all fail-fast behavior\n\n`Promise.all` is rejected if any of the elements are rejected. For example, if you pass in four promises that resolve after a timeout and one promise that rejects immediately, then `Promise.all` will reject immediately.\n\n```js\nconst p1 = new Promise((resolve, reject) => {\n  setTimeout(() => resolve("one"), 1000);\n});\nconst p2 = new Promise((resolve, reject) => {\n  setTimeout(() => resolve("two"), 2000);\n});\nconst p3 = new Promise((resolve, reject) => {\n  setTimeout(() => resolve("three"), 3000);\n});\nconst p4 = new Promise((resolve, reject) => {\n  setTimeout(() => resolve("four"), 4000);\n});\nconst p5 = new Promise((resolve, reject) => {\n  reject(new Error("reject"));\n});\n\n// Using .catch:\nPromise.all([p1, p2, p3, p4, p5])\n  .then((values) => {\n    console.log(values);\n  })\n  .catch((error) => {\n    console.error(error.message);\n  });\n\n// Logs:\n// "reject"\n```\n\nIt is possible to change this behavior by handling possible rejections:\n\n```js\nconst p1 = new Promise((resolve, reject) => {\n  setTimeout(() => resolve("p1_delayed_resolution"), 1000);\n});\n\nconst p2 = new Promise((resolve, reject) => {\n  reject(new Error("p2_immediate_rejection"));\n});\n\nPromise.all([p1.catch((error) => error), p2.catch((error) => error)]).then(\n  (values) => {\n    console.log(values[0]); // "p1_delayed_resolution"\n    console.error(values[1]); // "Error: p2_immediate_rejection"\n  },\n);\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Promise")}}\n- {{jsxref("Promise.allSettled()")}}\n- {{jsxref("Promise.any()")}}\n- {{jsxref("Promise.race()")}}\n'
        },
        "allsettled": {
            "index.md": '---\ntitle: Promise.allSettled()\nslug: Web/JavaScript/Reference/Global_Objects/Promise/allSettled\npage-type: javascript-static-method\nbrowser-compat: javascript.builtins.Promise.allSettled\n---\n\n{{JSRef}}\n\nThe **`Promise.allSettled()`** static method takes an iterable of promises as input and returns a single {{jsxref("Promise")}}. This returned promise fulfills when all of the input\'s promises settle (including when an empty iterable is passed), with an array of objects that describe the outcome of each promise.\n\n{{EmbedInteractiveExample("pages/js/promise-allsettled.html", "taller")}}\n\n## Syntax\n\n```js-nolint\nPromise.allSettled(iterable)\n```\n\n### Parameters\n\n- `iterable`\n  - : An [iterable](/en-US/docs/Web/JavaScript/Reference/Iteration_protocols#the_iterable_protocol) (such as an {{jsxref("Array")}}) of promises.\n\n### Return value\n\nA {{jsxref("Promise")}} that is:\n\n- **Already fulfilled**, if the `iterable` passed is empty.\n- **Asynchronously fulfilled**, when all promises in the given `iterable` have settled (either fulfilled or rejected). The fulfillment value is an array of objects, each describing the outcome of one promise in the `iterable`, in the order of the promises passed, regardless of completion order. Each outcome object has the following properties:\n\n  - `status`\n    - : A string, either `"fulfilled"` or `"rejected"`, indicating the eventual state of the promise.\n  - `value`\n    - : Only present if `status` is `"fulfilled"`. The value that the promise was fulfilled with.\n  - `reason`\n    - : Only present if `status` is `"rejected"`. The reason that the promise was rejected with.\n\n  If the `iterable` passed is non-empty but contains no pending promises, the returned promise is still asynchronously (instead of synchronously) fulfilled.\n\n## Description\n\nThe `Promise.allSettled()` method is one of the [promise concurrency](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise#promise_concurrency) methods. `Promise.allSettled()` is typically used when you have multiple asynchronous tasks that are not dependent on one another to complete successfully, or you\'d always like to know the result of each promise.\n\nIn comparison, the Promise returned by {{jsxref("Promise.all()")}} may be more appropriate if the tasks are dependent on each other, or if you\'d like to immediately reject upon any of them rejecting.\n\n## Examples\n\n### Using Promise.allSettled()\n\n```js\nPromise.allSettled([\n  Promise.resolve(33),\n  new Promise((resolve) => setTimeout(() => resolve(66), 0)),\n  99,\n  Promise.reject(new Error("an error")),\n]).then((values) => console.log(values));\n\n// [\n//   { status: \'fulfilled\', value: 33 },\n//   { status: \'fulfilled\', value: 66 },\n//   { status: \'fulfilled\', value: 99 },\n//   { status: \'rejected\', reason: Error: an error }\n// ]\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Promise.allSettled` in `core-js`](https://github.com/zloirock/core-js#ecmascript-promise)\n- [Using promises](/en-US/docs/Web/JavaScript/Guide/Using_promises) guide\n- [Graceful asynchronous programming with promises](/en-US/docs/Learn/JavaScript/Asynchronous/Promises)\n- {{jsxref("Promise")}}\n- {{jsxref("Promise.all()")}}\n- {{jsxref("Promise.any()")}}\n- {{jsxref("Promise.race()")}}\n'
        },
        "any": {
            "index.md": '---\ntitle: Promise.any()\nslug: Web/JavaScript/Reference/Global_Objects/Promise/any\npage-type: javascript-static-method\nbrowser-compat: javascript.builtins.Promise.any\n---\n\n{{JSRef}}\n\nThe **`Promise.any()`** static method takes an iterable of promises as input and returns a single {{jsxref("Promise")}}. This returned promise fulfills when any of the input\'s promises fulfills, with this first fulfillment value. It rejects when all of the input\'s promises reject (including when an empty iterable is passed), with an {{jsxref("AggregateError")}} containing an array of rejection reasons.\n\n{{EmbedInteractiveExample("pages/js/promise-any.html")}}\n\n## Syntax\n\n```js-nolint\nPromise.any(iterable)\n```\n\n### Parameters\n\n- `iterable`\n  - : An [iterable](/en-US/docs/Web/JavaScript/Reference/Iteration_protocols#the_iterable_protocol) (such as an {{jsxref("Array")}}) of promises.\n\n### Return value\n\nA {{jsxref("Promise")}} that is:\n\n- **Already rejected**, if the `iterable` passed is empty.\n- **Asynchronously fulfilled**, when any of the promises in the given `iterable` fulfills. The fulfillment value is the fulfillment value of the first promise that was fulfilled.\n- **Asynchronously rejected**, when all of the promises in the given `iterable` reject. The rejection reason is an {{jsxref("AggregateError")}} containing an array of rejection reasons in its `errors` property. The errors are in the order of the promises passed, regardless of completion order. If the `iterable` passed is non-empty but contains no pending promises, the returned promise is still asynchronously (instead of synchronously) rejected.\n\n## Description\n\nThe `Promise.any()` method is one of the [promise concurrency](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise#promise_concurrency) methods. This method is useful for returning the first promise that fulfills. It short-circuits after a promise fulfills, so it does not wait for the other promises to complete once it finds one.\n\nUnlike {{jsxref("Promise.all()")}}, which returns an _array_ of fulfillment values, we only get one fulfillment value (assuming at least one promise fulfills). This can be beneficial if we need only one promise to fulfill but we do not care which one does. Note another difference: this method rejects upon receiving an _empty iterable_, since, truthfully, the iterable contains no items that fulfill. You may compare `Promise.any()` and `Promise.all()` with {{jsxref("Array.prototype.some()")}} and {{jsxref("Array.prototype.every()")}}.\n\nAlso, unlike {{jsxref("Promise.race()")}}, which returns the first _settled_ value (either fulfillment or rejection), this method returns the first _fulfilled_ value. This method ignores all rejected promises up until the first promise that fulfills.\n\n## Examples\n\n### Using Promise.any()\n\n`Promise.any()` fulfills with the first promise to fulfill, even if a promise rejects first. This is in contrast to {{jsxref("Promise.race()")}}, which fulfills or rejects with the first promise to settle.\n\n```js\nconst pErr = new Promise((resolve, reject) => {\n  reject("Always fails");\n});\n\nconst pSlow = new Promise((resolve, reject) => {\n  setTimeout(resolve, 500, "Done eventually");\n});\n\nconst pFast = new Promise((resolve, reject) => {\n  setTimeout(resolve, 100, "Done quick");\n});\n\nPromise.any([pErr, pSlow, pFast]).then((value) => {\n  console.log(value);\n  // pFast fulfills first\n});\n// Logs:\n// Done quick\n```\n\n### Rejections with AggregateError\n\n`Promise.any()` rejects with an {{jsxref("AggregateError")}} if no promise fulfills.\n\n```js\nconst failure = new Promise((resolve, reject) => {\n  reject("Always fails");\n});\n\nPromise.any([failure]).catch((err) => {\n  console.log(err);\n});\n// AggregateError: No Promise in Promise.any was resolved\n```\n\n### Displaying the first image loaded\n\nIn this example, we have a function that fetches an image and returns a blob. We use `Promise.any()` to fetch a couple of images and display the first one available (i.e. whose promise has resolved).\n\n```js\nasync function fetchAndDecode(url, description) {\n  const res = await fetch(url);\n  if (!res.ok) {\n    throw new Error(`HTTP error! status: ${res.status}`);\n  }\n  const data = await res.blob();\n  return [data, description];\n}\n\nconst coffee = fetchAndDecode("coffee.jpg", "Coffee");\nconst tea = fetchAndDecode("tea.jpg", "Tea");\n\nPromise.any([coffee, tea])\n  .then(([blob, description]) => {\n    const objectURL = URL.createObjectURL(blob);\n    const image = document.createElement("img");\n    image.src = objectURL;\n    image.alt = description;\n    document.body.appendChild(image);\n  })\n  .catch((e) => {\n    console.error(e);\n  });\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Promise.any` in `core-js`](https://github.com/zloirock/core-js#ecmascript-promise)\n- {{jsxref("Promise")}}\n- {{jsxref("Promise.all()")}}\n- {{jsxref("Promise.allSettled()")}}\n- {{jsxref("Promise.race()")}}\n'
        },
        "catch": {
            "index.md": '---\ntitle: Promise.prototype.catch()\nslug: Web/JavaScript/Reference/Global_Objects/Promise/catch\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Promise.catch\n---\n\n{{JSRef}}\n\nThe **`catch()`** method of {{jsxref("Promise")}} instances schedules a function to be called when the promise is rejected. It immediately returns an equivalent {{jsxref("Promise")}} object, allowing you to [chain](/en-US/docs/Web/JavaScript/Guide/Using_promises#chaining) calls to other promise methods. It is a shortcut for {{jsxref("Promise/then", "Promise.prototype.then(undefined, onRejected)")}}.\n\n{{EmbedInteractiveExample("pages/js/promise-catch.html")}}\n\n## Syntax\n\n```js-nolint\npromiseInstance.catch(onRejected)\n```\n\n### Parameters\n\n- `onRejected`\n  - : A function to asynchronously execute when this promise becomes rejected. Its return value becomes the fulfillment value of the promise returned by `catch()`. The function is called with the following arguments:\n    - `reason`\n      - : The value that the promise was rejected with.\n\n### Return value\n\nReturns a new {{jsxref("Promise")}}. This new promise is always pending when returned, regardless of the current promise\'s status. If `onRejected` is called, the returned promise will resolve based on the return value of this call, or reject with the thrown error from this call. If the current promise fulfills, `onRejected` is not called and the returned promise fulfills to the same value.\n\n## Description\n\nThe `catch` method is used for error handling in promise composition. Since it returns a {{jsxref("Promise")}}, it [can be chained](/en-US/docs/Web/JavaScript/Guide/Using_promises#chaining_after_a_catch) in the same way as its sister method, {{jsxref("Promise/then", "then()")}}.\n\nIf a promise becomes rejected, and there are no rejection handlers to call (a handler can be attached through any of {{jsxref("Promise/then", "then()")}}, {{jsxref("Promise/catch", "catch()")}}, or {{jsxref("Promise/finally", "finally()")}}), then the rejection event is surfaced by the host. In the browser, this results in an [`unhandledrejection`](/en-US/docs/Web/API/Window/unhandledrejection_event) event. If a handler is attached to a rejected promise whose rejection has already caused an unhandled rejection event, then another [`rejectionhandled`](/en-US/docs/Web/API/Window/rejectionhandled_event) event is fired.\n\n`catch()` internally calls `then()` on the object upon which it was called, passing `undefined` and `onRejected` as arguments. The value of that call is directly returned. This is observable if you wrap the methods.\n\n```js\n// overriding original Promise.prototype.then/catch just to add some logs\n((Promise) => {\n  const originalThen = Promise.prototype.then;\n  const originalCatch = Promise.prototype.catch;\n\n  Promise.prototype.then = function (...args) {\n    console.log("Called .then on %o with arguments: %o", this, args);\n    return originalThen.apply(this, args);\n  };\n  Promise.prototype.catch = function (...args) {\n    console.error("Called .catch on %o with arguments: %o", this, args);\n    return originalCatch.apply(this, args);\n  };\n})(Promise);\n\n// calling catch on an already resolved promise\nPromise.resolve().catch(function XXX() {});\n\n// Logs:\n// Called .catch on Promise{} with arguments: Arguments{1} [0: function XXX()]\n// Called .then on Promise{} with arguments: Arguments{2} [0: undefined, 1: function XXX()]\n```\n\nThis means that passing `undefined` still causes the returned promise to be rejected, and you have to pass a function to prevent the final promise from being rejected.\n\nBecause `catch()` just calls `then()`, it supports subclassing.\n\n> **Note:** The examples below are throwing instances of [`Error`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error). As with synchronous [`throw`](/en-US/docs/Web/JavaScript/Reference/Statements/throw) statements, this is considered a good practice; otherwise, the part doing the catching would have to perform checks to see if the argument was a string or an error, and you might lose valuable information such as stack traces.\n\n## Examples\n\n### Using and chaining the catch() method\n\n```js\nconst p1 = new Promise((resolve, reject) => {\n  resolve("Success");\n});\n\np1.then((value) => {\n  console.log(value); // "Success!"\n  throw new Error("oh, no!");\n})\n  .catch((e) => {\n    console.error(e.message); // "oh, no!"\n  })\n  .then(\n    () => console.log("after a catch the chain is restored"), // "after a catch the chain is restored"\n    () => console.log("Not fired due to the catch"),\n  );\n\n// The following behaves the same as above\np1.then((value) => {\n  console.log(value); // "Success!"\n  return Promise.reject("oh, no!");\n})\n  .catch((e) => {\n    console.error(e); // "oh, no!"\n  })\n  .then(\n    () => console.log("after a catch the chain is restored"), // "after a catch the chain is restored"\n    () => console.log("Not fired due to the catch"),\n  );\n```\n\n### Gotchas when throwing errors\n\nThrowing an error will call the `catch()` method most of the time:\n\n```js\nconst p1 = new Promise((resolve, reject) => {\n  throw new Error("Uh-oh!");\n});\n\np1.catch((e) => {\n  console.error(e); // "Uh-oh!"\n});\n```\n\nErrors thrown inside asynchronous functions will act like uncaught errors:\n\n```js\nconst p2 = new Promise((resolve, reject) => {\n  setTimeout(() => {\n    throw new Error("Uncaught Exception!");\n  }, 1000);\n});\n\np2.catch((e) => {\n  console.error(e); // This is never called\n});\n```\n\nErrors thrown after `resolve` is called will be silenced:\n\n```js\nconst p3 = new Promise((resolve, reject) => {\n  resolve();\n  throw new Error("Silenced Exception!");\n});\n\np3.catch((e) => {\n  console.error(e); // This is never called\n});\n```\n\n### catch() is not called if the promise is fulfilled\n\n```js\n// Create a promise which would not call onReject\nconst p1 = Promise.resolve("calling next");\n\nconst p2 = p1.catch((reason) => {\n  // This is never called\n  console.error("catch p1!");\n  console.error(reason);\n});\n\np2.then(\n  (value) => {\n    console.log("next promise\'s onFulfilled");\n    console.log(value); // calling next\n  },\n  (reason) => {\n    console.log("next promise\'s onRejected");\n    console.log(reason);\n  },\n);\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Promise")}}\n- {{jsxref("Promise.prototype.then()")}}\n- {{jsxref("Promise.prototype.finally()")}}\n'
        },
        "finally": {
            "index.md": '---\ntitle: Promise.prototype.finally()\nslug: Web/JavaScript/Reference/Global_Objects/Promise/finally\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Promise.finally\n---\n\n{{JSRef}}\n\nThe **`finally()`** method of {{jsxref("Promise")}} instances schedules a function to be called when the promise is settled (either fulfilled or rejected). It immediately returns an equivalent {{jsxref("Promise")}} object, allowing you to [chain](/en-US/docs/Web/JavaScript/Guide/Using_promises#chaining) calls to other promise methods.\n\nThis lets you avoid duplicating code in both the promise\'s {{jsxref("Promise/then", "then()")}} and {{jsxref("Promise/catch", "catch()")}} handlers.\n\n{{EmbedInteractiveExample("pages/js/promise-finally.html", "taller")}}\n\n## Syntax\n\n```js-nolint\npromiseInstance.finally(onFinally)\n```\n\n### Parameters\n\n- `onFinally`\n  - : A function to asynchronously execute when this promise becomes settled. Its return value is ignored unless the returned value is a rejected promise. The function is called with no arguments.\n\n### Return value\n\nReturns an equivalent {{jsxref("Promise")}}. If the handler throws an error or returns a rejected promise, the promise returned by `finally()` will be rejected with that value instead. Otherwise, the return value of the handler does not affect the state of the original promise.\n\n## Description\n\nThe `finally()` method can be useful if you want to do some processing or cleanup once the promise is settled, regardless of its outcome.\n\nThe `finally()` method is very similar to calling {{jsxref("Promise/then", "then(onFinally, onFinally)")}}. However, there are a couple of differences:\n\n- When creating a function inline, you can pass it once, instead of being forced to either declare it twice, or create a variable for it.\n- The `onFinally` callback does not receive any argument. This use case is for precisely when you _do not care_ about the rejection reason or the fulfillment value, and so there\'s no need to provide it.\n- A `finally()` call is usually transparent and does not change the eventual state of the original promise. So for example:\n  - Unlike `Promise.resolve(2).then(() => 77, () => {})`, which returns a promise eventually fulfilled with the value `77`, `Promise.resolve(2).finally(() => 77)` returns a promise eventually fulfilled with the value `2`.\n  - Similarly, unlike `Promise.reject(3).then(() => {}, () => 88)`, which returns a promise eventually fulfilled with the value `88`, `Promise.reject(3).finally(() => 88)` returns a promise eventually rejected with the reason `3`.\n\n> **Note:** A `throw` (or returning a rejected promise) in the `finally` callback still rejects the returned promise. For example, both `Promise.reject(3).finally(() => { throw 99; })` and `Promise.reject(3).finally(() => Promise.reject(99))` reject the returned promise with the reason `99`.\n\nLike {{jsxref("Promise/catch", "catch()")}}, `finally()` internally calls the `then` method on the object upon which it was called. If `onFinally` is not a function, `then()` is called with `onFinally` as both arguments \u2014 which, for {{jsxref("Promise.prototype.then()")}}, means that no useful handler is attached. Otherwise, `then()` is called with two internally created functions, which behave like the following:\n\n> **Warning:** This is only for demonstration purposes and is not a polyfill.\n\n```js\npromise.then(\n  (value) => Promise.resolve(onFinally()).then(() => value),\n  (reason) =>\n    Promise.resolve(onFinally()).then(() => {\n      throw reason;\n    }),\n);\n```\n\nBecause `finally()` calls `then()`, it supports subclassing. Moreover, notice the {{jsxref("Promise.resolve()")}} call above \u2014 in reality, `onFinally()`\'s return value is resolved using the same algorithm as `Promise.resolve()`, but the actual constructor used to construct the resolved promise will be the subclass. `finally()` gets this constructor through [`promise.constructor[@@species]`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise/@@species).\n\n## Examples\n\n### Using finally()\n\n```js\nlet isLoading = true;\n\nfetch(myRequest)\n  .then((response) => {\n    const contentType = response.headers.get("content-type");\n    if (contentType && contentType.includes("application/json")) {\n      return response.json();\n    }\n    throw new TypeError("Oops, we haven\'t got JSON!");\n  })\n  .then((json) => {\n    /* process your JSON further */\n  })\n  .catch((error) => {\n    console.error(error); // this line can also throw, e.g. when console = {}\n  })\n  .finally(() => {\n    isLoading = false;\n  });\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Promise.prototype.finally` in `core-js`](https://github.com/zloirock/core-js#ecmascript-promise)\n- {{jsxref("Promise")}}\n- {{jsxref("Promise.prototype.then()")}}\n- {{jsxref("Promise.prototype.catch()")}}\n'
        },
        "index.md": '---\ntitle: Promise\nslug: Web/JavaScript/Reference/Global_Objects/Promise\npage-type: javascript-class\nbrowser-compat: javascript.builtins.Promise\n---\n\n{{JSRef}}\n\nThe **`Promise`** object represents the eventual completion (or failure) of an asynchronous operation and its resulting value.\n\nTo learn about the way promises work and how you can use them, we advise you to read [Using promises](/en-US/docs/Web/JavaScript/Guide/Using_promises) first.\n\n## Description\n\nA **`Promise`** is a proxy for a value not necessarily known when the promise is created. It allows you to associate handlers with an asynchronous action\'s eventual success value or failure reason. This lets asynchronous methods return values like synchronous methods: instead of immediately returning the final value, the asynchronous method returns a _promise_ to supply the value at some point in the future.\n\nA `Promise` is in one of these states:\n\n- _pending_: initial state, neither fulfilled nor rejected.\n- _fulfilled_: meaning that the operation was completed successfully.\n- _rejected_: meaning that the operation failed.\n\nThe _eventual state_ of a pending promise can either be _fulfilled_ with a value or _rejected_ with a reason (error).\nWhen either of these options occur, the associated handlers queued up by a promise\'s `then` method are called. If the promise has already been fulfilled or rejected when a corresponding handler is attached, the handler will be called, so there is no race condition between an asynchronous operation completing and its handlers being attached.\n\nA promise is said to be _settled_ if it is either fulfilled or rejected, but not pending.\n\n![Flowchart showing how the Promise state transitions between pending, fulfilled, and rejected via then/catch handlers. A pending promise can become either fulfilled or rejected. If fulfilled, the "on fulfillment" handler, or first parameter of the then() method, is executed and carries out further asynchronous actions. If rejected, the error handler, either passed as the second parameter of the then() method or as the sole parameter of the catch() method, gets executed.](promises.png)\n\nYou will also hear the term _resolved_ used with promises \u2014 this means that the promise is settled or "locked-in" to match the eventual state of another promise, and further resolving or rejecting it has no effect. The [States and fates](https://github.com/domenic/promises-unwrapping/blob/master/docs/states-and-fates.md) document from the original Promise proposal contains more details about promise terminology. Colloquially, "resolved" promises are often equivalent to "fulfilled" promises, but as illustrated in "States and fates", resolved promises can be pending or rejected as well. For example:\n\n```js\nnew Promise((resolveOuter) => {\n  resolveOuter(\n    new Promise((resolveInner) => {\n      setTimeout(resolveInner, 1000);\n    }),\n  );\n});\n```\n\nThis promise is already _resolved_ at the time when it\'s created (because the `resolveOuter` is called synchronously), but it is resolved with another promise, and therefore won\'t be _fulfilled_ until 1 second later, when the inner promise fulfills. In practice, the "resolution" is often done behind the scenes and not observable, and only its fulfillment or rejection are.\n\n> **Note:** Several other languages have mechanisms for lazy evaluation and deferring a computation, which they also call "promises", e.g. Scheme. Promises in JavaScript represent processes that are already happening, which can be chained with callback functions. If you are looking to lazily evaluate an expression, consider using a function with no arguments e.g. `f = () => expression` to create the lazily-evaluated expression, and `f()` to evaluate the expression immediately.\n\n### Chained Promises\n\nThe methods {{jsxref("Promise.prototype.then()")}}, {{jsxref("Promise.prototype.catch()")}}, and {{jsxref("Promise.prototype.finally()")}} are used to associate further action with a promise that becomes settled. As these methods return promises, they can be chained.\n\nThe `.then()` method takes up to two arguments; the first argument is a callback function for the fulfilled case of the promise, and the second argument is a callback function for the rejected case. Each `.then()` returns a newly generated promise object, which can optionally be used for chaining; for example:\n\n```js\nconst myPromise = new Promise((resolve, reject) => {\n  setTimeout(() => {\n    resolve("foo");\n  }, 300);\n});\n\nmyPromise\n  .then(handleFulfilledA, handleRejectedA)\n  .then(handleFulfilledB, handleRejectedB)\n  .then(handleFulfilledC, handleRejectedC);\n```\n\nProcessing continues to the next link of the chain even when a `.then()` lacks a callback function. Therefore, a chain can safely omit every _rejection_ callback function until the final `.catch()`.\n\nHandling a rejected promise in each `.then()` has consequences further down the promise chain. Sometimes there is no choice, because an error must be handled immediately. In such cases we must throw an error of some type to maintain error state down the chain. On the other hand, in the absence of an immediate need, it is simpler to leave out error handling until a final `.catch()` statement. A `.catch()` is really just a `.then()` without a slot for a callback function for the case when the promise is fulfilled.\n\n```js\nmyPromise\n  .then(handleFulfilledA)\n  .then(handleFulfilledB)\n  .then(handleFulfilledC)\n  .catch(handleRejectedAny);\n```\n\nUsing [arrow functions](/en-US/docs/Web/JavaScript/Reference/Functions/Arrow_functions) for the callback functions, implementation of the promise chain might look something like this:\n\n```js\nmyPromise\n  .then((value) => `${value} and bar`)\n  .then((value) => `${value} and bar again`)\n  .then((value) => `${value} and again`)\n  .then((value) => `${value} and again`)\n  .then((value) => {\n    console.log(value);\n  })\n  .catch((err) => {\n    console.error(err);\n  });\n```\n\n> **Note:** For faster execution, all synchronous actions should preferably be done within one handler, otherwise it would take several ticks to execute all handlers in sequence.\n\nThe termination condition of a promise determines the "settled" state of the next promise in the chain. A "fulfilled" state indicates a successful completion of the promise, while a "rejected" state indicates a lack of success. The return value of each fulfilled promise in the chain is passed along to the next `.then()`, while the reason for rejection is passed along to the next rejection-handler function in the chain.\n\nThe promises of a chain are nested in one another, but get popped like the top of a stack. The first promise in the chain is most deeply nested and is the first to pop.\n\n```plain\n(promise D, (promise C, (promise B, (promise A) ) ) )\n```\n\nWhen a `nextValue` is a promise, the effect is a dynamic replacement. The `return` causes a promise to be popped, but the `nextValue` promise is pushed into its place. For the nesting shown above, suppose the `.then()` associated with "promise B" returns a `nextValue` of "promise X". The resulting nesting would look like this:\n\n```plain\n(promise D, (promise C, (promise X) ) )\n```\n\nA promise can participate in more than one nesting. For the following code, the transition of `promiseA` into a "settled" state will cause both instances of `.then()` to be invoked.\n\n```js\nconst promiseA = new Promise(myExecutorFunc);\nconst promiseB = promiseA.then(handleFulfilled1, handleRejected1);\nconst promiseC = promiseA.then(handleFulfilled2, handleRejected2);\n```\n\nAn action can be assigned to an already "settled" promise. In that case, the action (if appropriate) will be performed at the first asynchronous opportunity. Note that promises are guaranteed to be asynchronous. Therefore, an action for an already "settled" promise will occur only after the stack has cleared and a clock-tick has passed. The effect is much like that of `setTimeout(action, 0)`.\n\n```js\nconst promiseA = new Promise((resolve, reject) => {\n  resolve(777);\n});\n// At this point, "promiseA" is already settled.\npromiseA.then((val) => console.log("asynchronous logging has val:", val));\nconsole.log("immediate logging");\n\n// produces output in this order:\n// immediate logging\n// asynchronous logging has val: 777\n```\n\n### Thenables\n\nThe JavaScript ecosystem had made multiple Promise implementations long before it became part of the language. Despite being represented differently internally, at the minimum, all Promise-like objects implement the _Thenable_ interface. A thenable implements the [`.then()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise/then) method, which is called with two callbacks: one for when the promise is fulfilled, one for when it\'s rejected. Promises are thenables as well.\n\nTo interoperate with the existing Promise implementations, the language allows using thenables in place of promises. For example, [`Promise.resolve`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise/resolve) will not only resolve promises, but also trace thenables.\n\n```js\nconst aThenable = {\n  then(onFulfilled, onRejected) {\n    onFulfilled({\n      // The thenable is fulfilled with another thenable\n      then(onFulfilled, onRejected) {\n        onFulfilled(42);\n      },\n    });\n  },\n};\n\nPromise.resolve(aThenable); // A promise fulfilled with 42\n```\n\n### Promise concurrency\n\nThe `Promise` class offers four static methods to facilitate async task [concurrency](https://en.wikipedia.org/wiki/Concurrent_computing):\n\n- {{jsxref("Promise.all()")}}\n  - : Fulfills when **all** of the promises fulfill; rejects when **any** of the promises rejects.\n- {{jsxref("Promise.allSettled()")}}\n  - : Fulfills when **all** promises settle.\n- {{jsxref("Promise.any()")}}\n  - : Fulfills when **any** of the promises fulfills; rejects when **all** of the promises reject.\n- {{jsxref("Promise.race()")}}\n  - : Settles when **any** of the promises settles. In other words, fulfills when any of the promises fulfills; rejects when any of the promises rejects.\n\nAll these methods take an [iterable](/en-US/docs/Web/JavaScript/Reference/Iteration_protocols#the_iterable_protocol) of promises ([thenables](#thenables), to be exact) and return a new promise. They all support subclassing, which means they can be called on subclasses of `Promise`, and the result will be a promise of the subclass type. To do so, the subclass\'s constructor must implement the same signature as the [`Promise()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise/Promise) constructor \u2014 accepting a single `executor` function that can be called with the `resolve` and `reject` callbacks as parameters. The subclass must also have a `resolve` static method that can be called like {{jsxref("Promise.resolve()")}} to resolve values to promises.\n\nNote that JavaScript is [single-threaded](/en-US/docs/Glossary/Thread) by nature, so at a given instant, only one task will be executing, although control can shift between different promises, making execution of the promises appear concurrent. [Parallel execution](https://en.wikipedia.org/wiki/Parallel_computing) in JavaScript can only be achieved through [worker threads](/en-US/docs/Web/API/Web_Workers_API).\n\n## Constructor\n\n- {{jsxref("Promise/Promise", "Promise()")}}\n  - : Creates a new `Promise` object. The constructor is primarily used to wrap functions that do not already support promises.\n\n## Static properties\n\n- {{jsxref("Promise/@@species", "Promise[@@species]")}}\n  - : Returns the constructor used to construct return values from promise methods.\n\n## Static methods\n\n- {{jsxref("Promise.all()")}}\n  - : Takes an iterable of promises as input and returns a single `Promise`. This returned promise fulfills when all of the input\'s promises fulfill (including when an empty iterable is passed), with an array of the fulfillment values. It rejects when any of the input\'s promises reject, with this first rejection reason.\n- {{jsxref("Promise.allSettled()")}}\n  - : Takes an iterable of promises as input and returns a single `Promise`. This returned promise fulfills when all of the input\'s promises settle (including when an empty iterable is passed), with an array of objects that describe the outcome of each promise.\n- {{jsxref("Promise.any()")}}\n  - : Takes an iterable of promises as input and returns a single `Promise`. This returned promise fulfills when any of the input\'s promises fulfill, with this first fulfillment value. It rejects when all of the input\'s promises reject (including when an empty iterable is passed), with an {{jsxref("AggregateError")}} containing an array of rejection reasons.\n- {{jsxref("Promise.race()")}}\n  - : Takes an iterable of promises as input and returns a single `Promise`. This returned promise settles with the eventual state of the first promise that settles.\n- {{jsxref("Promise.reject()")}}\n  - : Returns a new `Promise` object that is rejected with the given reason.\n- {{jsxref("Promise.resolve()")}}\n  - : Returns a `Promise` object that is resolved with the given value. If the value is a thenable (i.e. has a `then` method), the returned promise will "follow" that thenable, adopting its eventual state; otherwise, the returned promise will be fulfilled with the value.\n- {{jsxref("Promise.withResolvers()")}}\n  - : Returns an object containing a new `Promise` object and two functions to resolve or reject it, corresponding to the two parameters passed to the executor of the {{jsxref("Promise/Promise", "Promise()")}} constructor.\n\n## Instance properties\n\nThese properties are defined on `Promise.prototype` and shared by all `Promise` instances.\n\n- {{jsxref("Object/constructor", "Promise.prototype.constructor")}}\n  - : The constructor function that created the instance object. For `Promise` instances, the initial value is the {{jsxref("Promise/Promise", "Promise")}} constructor.\n- `Promise.prototype[@@toStringTag]`\n  - : The initial value of the [`@@toStringTag`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol/toStringTag) property is the string `"Promise"`. This property is used in {{jsxref("Object.prototype.toString()")}}.\n\n## Instance methods\n\n- {{jsxref("Promise.prototype.catch()")}}\n  - : Appends a rejection handler callback to the promise, and returns a new promise resolving to the return value of the callback if it is called, or to its original fulfillment value if the promise is instead fulfilled.\n- {{jsxref("Promise.prototype.finally()")}}\n  - : Appends a handler to the promise, and returns a new promise that is resolved when the original promise is resolved. The handler is called when the promise is settled, whether fulfilled or rejected.\n- {{jsxref("Promise.prototype.then()")}}\n  - : Appends fulfillment and rejection handlers to the promise, and returns a new promise resolving to the return value of the called handler, or to its original settled value if the promise was not handled (i.e. if the relevant handler `onFulfilled` or `onRejected` is not a function).\n\n## Examples\n\n### Basic Example\n\n```js\nconst myFirstPromise = new Promise((resolve, reject) => {\n  // We call resolve(...) when what we were doing asynchronously was successful, and reject(...) when it failed.\n  // In this example, we use setTimeout(...) to simulate async code.\n  // In reality, you will probably be using something like XHR or an HTML API.\n  setTimeout(() => {\n    resolve("Success!"); // Yay! Everything went well!\n  }, 250);\n});\n\nmyFirstPromise.then((successMessage) => {\n  // successMessage is whatever we passed in the resolve(...) function above.\n  // It doesn\'t have to be a string, but if it is only a succeed message, it probably will be.\n  console.log(`Yay! ${successMessage}`);\n});\n```\n\n### Example with diverse situations\n\nThis example shows diverse techniques for using Promise capabilities and diverse situations that can occur. To understand this, start by scrolling to the bottom of the code block, and examine the promise chain. Upon provision of an initial promise, a chain of promises can follow. The chain is composed of `.then()` calls, and typically (but not necessarily) has a single `.catch()` at the end, optionally followed by `.finally()`. In this example, the promise chain is initiated by a custom-written `new Promise()` construct; but in actual practice, promise chains more typically start with an API function (written by someone else) that returns a promise.\n\nThe example function `tetheredGetNumber()` shows that a promise generator will utilize `reject()` while setting up an asynchronous call, or within the call-back, or both. The function `promiseGetWord()` illustrates how an API function might generate and return a promise in a self-contained manner.\n\nNote that the function `troubleWithGetNumber()` ends with a `throw`. That is forced because a promise chain goes through all the `.then()` promises, even after an error, and without the `throw`, the error would seem "fixed". This is a hassle, and for this reason, it is common to omit `onRejected` throughout the chain of `.then()` promises, and just have a single `onRejected` in the final `catch()`.\n\nThis code can be run under NodeJS. Comprehension is enhanced by seeing the errors actually occur. To force more errors, change the `threshold` values.\n\n```js\n// To experiment with error handling, "threshold" values cause errors randomly\nconst THRESHOLD_A = 8; // can use zero 0 to guarantee error\n\nfunction tetheredGetNumber(resolve, reject) {\n  setTimeout(() => {\n    const randomInt = Date.now();\n    const value = randomInt % 10;\n    if (value < THRESHOLD_A) {\n      resolve(value);\n    } else {\n      reject(`Too large: ${value}`);\n    }\n  }, 500);\n}\n\nfunction determineParity(value) {\n  const isOdd = value % 2 === 1;\n  return { value, isOdd };\n}\n\nfunction troubleWithGetNumber(reason) {\n  const err = new Error("Trouble getting number", { cause: reason });\n  console.error(err);\n  throw err;\n}\n\nfunction promiseGetWord(parityInfo) {\n  return new Promise((resolve, reject) => {\n    const { value, isOdd } = parityInfo;\n    if (value >= THRESHOLD_A - 1) {\n      reject(`Still too large: ${value}`);\n    } else {\n      parityInfo.wordEvenOdd = isOdd ? "odd" : "even";\n      resolve(parityInfo);\n    }\n  });\n}\n\nnew Promise(tetheredGetNumber)\n  .then(determineParity, troubleWithGetNumber)\n  .then(promiseGetWord)\n  .then((info) => {\n    console.log(`Got: ${info.value}, ${info.wordEvenOdd}`);\n    return info;\n  })\n  .catch((reason) => {\n    if (reason.cause) {\n      console.error("Had previously handled error");\n    } else {\n      console.error(`Trouble with promiseGetWord(): ${reason}`);\n    }\n  })\n  .finally((info) => console.log("All done"));\n```\n\n### Advanced Example\n\nThis small example shows the mechanism of a `Promise`. The `testPromise()` method is called each time the {{HTMLElement("button")}} is clicked. It creates a promise that will be fulfilled, using {{domxref("setTimeout()")}}, to the promise count (number starting from 1) every 1-3 seconds, at random. The `Promise()` constructor is used to create the promise.\n\nThe fulfillment of the promise is logged, via a fulfill callback set using {{jsxref("Promise/then", "p1.then()")}}. A few logs show how the synchronous part of the method is decoupled from the asynchronous completion of the promise.\n\nBy clicking the button several times in a short amount of time, you\'ll even see the different promises being fulfilled one after another.\n\n#### HTML\n\n```html\n<button id="make-promise">Make a promise!</button>\n<div id="log"></div>\n```\n\n#### JavaScript\n\n```js\n"use strict";\n\nlet promiseCount = 0;\n\nfunction testPromise() {\n  const thisPromiseCount = ++promiseCount;\n  const log = document.getElementById("log");\n  // begin\n  log.insertAdjacentHTML("beforeend", `${thisPromiseCount}) Started<br>`);\n  // We make a new promise: we promise a numeric count of this promise,\n  // starting from 1 (after waiting 3s)\n  const p1 = new Promise((resolve, reject) => {\n    // The executor function is called with the ability\n    // to resolve or reject the promise\n    log.insertAdjacentHTML(\n      "beforeend",\n      `${thisPromiseCount}) Promise constructor<br>`,\n    );\n    // This is only an example to create asynchronism\n    setTimeout(\n      () => {\n        // We fulfill the promise\n        resolve(thisPromiseCount);\n      },\n      Math.random() * 2000 + 1000,\n    );\n  });\n\n  // We define what to do when the promise is resolved with the then() call,\n  // and what to do when the promise is rejected with the catch() call\n  p1.then((val) => {\n    // Log the fulfillment value\n    log.insertAdjacentHTML("beforeend", `${val}) Promise fulfilled<br>`);\n  }).catch((reason) => {\n    // Log the rejection reason\n    console.log(`Handle rejected promise (${reason}) here.`);\n  });\n  // end\n  log.insertAdjacentHTML("beforeend", `${thisPromiseCount}) Promise made<br>`);\n}\n\nconst btn = document.getElementById("make-promise");\nbtn.addEventListener("click", testPromise);\n```\n\n#### Result\n\n{{EmbedLiveSample("Advanced_Example", "500", "200")}}\n\n### Loading an image with XHR\n\nAnother simple example using `Promise` and {{domxref("XMLHttpRequest")}} to load an image is available at the MDN GitHub [js-examples](https://github.com/mdn/js-examples/tree/main/promises-test) repository. You can also [see it in action](https://mdn.github.io/js-examples/promises-test/). Each step is commented on and allows you to follow the Promise and XHR architecture closely.\n\n### Incumbent settings object tracking\n\nA settings object is an [environment](https://html.spec.whatwg.org/multipage/webappapis.html#environment-settings-object) that provides additional information when JavaScript code is running. This includes the realm and module map, as well as HTML specific information such as the origin. The incumbent settings object is tracked in order to ensure that the browser knows which one to use for a given piece of user code.\n\nTo better picture this, we can take a closer look at how the realm might be an issue. A **realm** can be roughly thought of as the global object. What is unique about realms is that they hold all of the necessary information to run JavaScript code. This includes objects like [`Array`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array) and [`Error`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error). Each settings object has its own "copy" of these and they are not shared. That can cause some unexpected behavior in relation to promises. In order to get around this, we track something called the **incumbent settings object**. This represents information specific to the context of the user code responsible for a certain function call.\n\nTo illustrate this a bit further we can take a look at how an [`<iframe>`](/en-US/docs/Web/HTML/Element/iframe) embedded in a document communicates with its host. Since all web APIs are aware of the incumbent settings object, the following will work in all browsers:\n\n```html\n<!doctype html> <iframe></iframe>\n<!-- we have a realm here -->\n<script>\n  // we have a realm here as well\n  const bound = frames[0].postMessage.bind(frames[0], "some data", "*");\n  // bound is a built-in function \u2014 there is no user\n  // code on the stack, so which realm do we use?\n  setTimeout(bound);\n  // this still works, because we use the youngest\n  // realm (the incumbent) on the stack\n</script>\n```\n\nThe same concept applies to promises. If we modify the above example a little bit, we get this:\n\n```html\n<!doctype html> <iframe></iframe>\n<!-- we have a realm here -->\n<script>\n  // we have a realm here as well\n  const bound = frames[0].postMessage.bind(frames[0], "some data", "*");\n  // bound is a built in function \u2014 there is no user\n  // code on the stack \u2014 which realm do we use?\n  Promise.resolve(undefined).then(bound);\n  // this still works, because we use the youngest\n  // realm (the incumbent) on the stack\n</script>\n```\n\nIf we change this so that the `<iframe>` in the document is listening to post messages, we can observe the effect of the incumbent settings object:\n\n```html\n<!-- y.html -->\n<!doctype html>\n<iframe src="x.html"></iframe>\n<script>\n  const bound = frames[0].postMessage.bind(frames[0], "some data", "*");\n  Promise.resolve(undefined).then(bound);\n</script>\n```\n\n```html\n<!-- x.html -->\n<!doctype html>\n<script>\n  window.addEventListener(\n    "message",\n    (event) => {\n      document.querySelector("#text").textContent = "hello";\n      // this code will only run in browsers that track the incumbent settings object\n      console.log(event);\n    },\n    false,\n  );\n</script>\n```\n\nIn the above example, the inner text of the `<iframe>` will be updated only if the incumbent settings object is tracked. This is because without tracking the incumbent, we may end up using the wrong environment to send the message.\n\n> **Note:** Currently, incumbent realm tracking is fully implemented in Firefox, and has partial implementations in Chrome and Safari.\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Promise` in `core-js`](https://github.com/zloirock/core-js#ecmascript-promise)\n- [Using promises](/en-US/docs/Web/JavaScript/Guide/Using_promises) guide\n- [Promises/A+ specification](https://promisesaplus.com/)\n- [JavaScript Promises: an introduction](https://web.dev/articles/promises) on web.dev (2013)\n- [Callbacks, Promises, and Coroutines: Asynchronous Programming Patterns in JavaScript](https://www.slideshare.net/domenicdenicola/callbacks-promises-and-coroutines-oh-my-the-evolution-of-asynchronicity-in-javascript) slide show by Domenic Denicola (2011)\n',
        "promise": {
            "index.md": '---\ntitle: Promise() constructor\nslug: Web/JavaScript/Reference/Global_Objects/Promise/Promise\npage-type: javascript-constructor\nbrowser-compat: javascript.builtins.Promise.Promise\n---\n\n{{JSRef}}\n\nThe **`Promise()`** constructor creates {{jsxref("Promise")}} objects. It is primarily used to wrap callback-based APIs that do not already support promises.\n\n{{EmbedInteractiveExample("pages/js/promise-constructor.html", "taller")}}\n\n## Syntax\n\n```js-nolint\nnew Promise(executor)\n```\n\n> **Note:** `Promise()` can only be constructed with [`new`](/en-US/docs/Web/JavaScript/Reference/Operators/new). Attempting to call it without `new` throws a {{jsxref("TypeError")}}.\n\n### Parameters\n\n- `executor`\n  - : A {{jsxref("function")}} to be executed by the constructor. It receives two functions as parameters: `resolveFunc` and `rejectFunc`. Any errors thrown in the `executor` will cause the promise to be rejected, and the return value will be neglected. The semantics of `executor` are detailed below.\n\n### Return value\n\nWhen called via `new`, the `Promise` constructor returns a promise object. The promise object will become _resolved_ when either of the functions `resolveFunc` or `rejectFunc` are invoked. Note that if you call `resolveFunc` or `rejectFunc` and pass another `Promise` object as an argument, it can be said to be "resolved", but still not "settled". See the [Promise description](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise#description) for more explanation.\n\n## Description\n\nTraditionally (before promises), asynchronous tasks were designed as callbacks.\n\n```js\nreadFile("./data.txt", (error, result) => {\n  // This callback will be called when the task is done, with the\n  // final `error` or `result`. Any operation dependent on the\n  // result must be defined within this callback.\n});\n// Code here is immediately executed after the `readFile` request\n// is fired. It does not wait for the callback to be called, hence\n// making `readFile` "asynchronous".\n```\n\nTo take advantage of the readability improvement and language features offered by promises, the `Promise()` constructor allows one to transform the callback-based API to a promise-based one.\n\n> **Note:** If your task is already promise-based, you likely do not need the `Promise()` constructor.\n\nThe `executor` is custom code that ties an outcome in a callback to a promise. You, the programmer, write the `executor`. Its signature is expected to be:\n\n```js\nfunction executor(resolveFunc, rejectFunc) {\n  // Typically, some asynchronous operation that accepts a callback,\n  // like the `readFile` function above\n}\n```\n\n`resolveFunc` and `rejectFunc` are also functions, and you can give them whatever actual names you want. Their signatures are simple: they accept a single parameter of any type.\n\n```js\nresolveFunc(value); // call on resolved\nrejectFunc(reason); // call on rejected\n```\n\nThe `value` parameter passed to `resolveFunc` can be another promise object, in which case the newly constructed promise\'s state will be "locked in" to the promise passed (as part of the [resolution](#the_resolve_function) promise). The `rejectFunc` has semantics close to the [`throw`](/en-US/docs/Web/JavaScript/Reference/Statements/throw) statement, so `reason` is typically an [`Error`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error) instance. If either `value` or `reason` is omitted, the promise is fulfilled/rejected with `undefined`.\n\nThe `executor`\'s completion state has limited effect on the promise\'s state:\n\n- The `executor` return value is ignored. `return` statements within the `executor` merely impact control flow and alter whether a part of the function is executed, but do not have any impact on the promise\'s fulfillment value. If `executor` exits and it\'s impossible for `resolveFunc` or `rejectFunc` to be called in the future (for example, there are no async tasks scheduled), then the promise remains pending forever.\n- If an error is thrown in the `executor`, the promise is rejected, unless `resolveFunc` or `rejectFunc` has already been called.\n\n> **Note:** The existence of pending promises does not prevent the program from exiting. If the event loop is empty, the program exits despite any pending promises (because those are necessarily forever-pending).\n\nHere\'s a summary of the typical flow:\n\n1. At the time when the constructor generates the new `Promise` object, it also generates a corresponding pair of functions for `resolveFunc` and `rejectFunc`; these are "tethered" to the `Promise` object.\n2. `executor` typically wraps some asynchronous operation which provides a callback-based API. The callback (the one passed to the original callback-based API) is defined within the `executor` code, so it has access to the `resolveFunc` and `rejectFunc`.\n3. The `executor` is called synchronously (as soon as the `Promise` is constructed) with the `resolveFunc` and `rejectFunc` functions as arguments.\n4. The code within the `executor` has the opportunity to perform some operation. The eventual completion of the asynchronous task is communicated with the promise instance via the side effect caused by `resolveFunc` or `rejectFunc`. The side effect is that the `Promise` object becomes "resolved".\n   - If `resolveFunc` is called first, the value passed will be [resolved](#the_resolve_function). The promise may stay pending (in case another [thenable](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise#thenables) is passed), become fulfilled (in most cases where a non-thenable value is passed), or become rejected (in case of an invalid resolution value).\n   - If `rejectFunc` is called first, the promise instantly becomes rejected.\n   - Once one of the resolving functions (`resolveFunc` or `rejectFunc`) is called, the promise stays resolved. Only the first call to `resolveFunc` or `rejectFunc` affects the promise\'s eventual state, and subsequent calls to either function can neither change the fulfillment value/rejection reason nor toggle its eventual state from "fulfilled" to "rejected" or opposite.\n   - If `executor` exits by throwing an error, then the promise is rejected. However, the error is ignored if one of the resolving functions has already been called (so that the promise is already resolved).\n   - Resolving the promise does not necessarily cause the promise to become fulfilled or rejected (i.e. settled). The promise may still be pending because it\'s resolved with another thenable, but its eventual state will match that of the resolved thenable.\n5. Once the promise settles, it (asynchronously) invokes any further handlers associated through {{jsxref("Promise/then", "then()")}}, {{jsxref("Promise/catch", "catch()")}}, or {{jsxref("Promise/finally", "finally()")}}. The eventual fulfillment value or rejection reason is passed to the invocation of fulfillment and rejection handlers as an input parameter (see [Chained Promises](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise#chained_promises)).\n\nFor example, the callback-based `readFile` API above can be transformed into a promise-based one.\n\n```js\nconst readFilePromise = (path) =>\n  new Promise((resolve, reject) => {\n    readFile(path, (error, result) => {\n      if (error) {\n        reject(error);\n      } else {\n        resolve(result);\n      }\n    });\n  });\n\nreadFilePromise("./data.txt")\n  .then((result) => console.log(result))\n  .catch((error) => console.error("Failed to read data"));\n```\n\nThe `resolve` and `reject` callbacks are only available within the scope of the executor function, which means you can\'t access them after the promise is constructed. If you want to construct the promise before deciding how to resolve it, you can use the {{jsxref("Promise.withResolvers()")}} method instead, which exposes the `resolve` and `reject` functions.\n\n### The resolve function\n\nThe `resolve` function has the following behaviors:\n\n- If it\'s called with the same value as the newly created promise (the promise it\'s "tethered to"), the promise is rejected with a {{jsxref("TypeError")}}.\n- If it\'s called with a non-[thenable](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise#thenables) value (a primitive, or an object whose `then` property is not callable, including when the property is not present), the promise is immediately fulfilled with that value.\n- If it\'s called with a thenable value (including another `Promise` instance), then the thenable\'s `then` method is saved and called in the future (it\'s always called asynchronously). The `then` method will be called with two callbacks, which are two new functions with the exact same behaviors as the `resolveFunc` and `rejectFunc` passed to the `executor` function. If calling the `then` method throws, then the current promise is rejected with the thrown error.\n\nIn the last case, it means code like:\n\n```js\nnew Promise((resolve, reject) => {\n  resolve(thenable);\n});\n```\n\nIs roughly equivalent to:\n\n```js\nnew Promise((resolve, reject) => {\n  try {\n    thenable.then(\n      (value) => resolve(value),\n      (reason) => reject(reason),\n    );\n  } catch (e) {\n    reject(e);\n  }\n});\n```\n\nExcept that in the `resolve(thenable)` case:\n\n1. `resolve` is called synchronously, so that calling `resolve` or `reject` again has no effect, even when the handlers attached through `anotherPromise.then()` are not called yet.\n2. The `then` method is called asynchronously, so that the promise will never be instantly resolved if a thenable is passed.\n\nBecause `resolve` is called again with whatever `thenable.then()` passes to it as `value`, the resolver function is able to flatten nested thenables, where a thenable calls its `onFulfilled` handler with another thenable. The effect is that the fulfillment handler of a real promise will never receive a thenable as its fulfillment value.\n\n## Examples\n\n### Turning a callback-based API into a promise-based one\n\nTo provide a function with promise functionality, have it return a promise by calling the `resolve` and `reject` functions at the correct times.\n\n```js\nfunction myAsyncFunction(url) {\n  return new Promise((resolve, reject) => {\n    const xhr = new XMLHttpRequest();\n    xhr.open("GET", url);\n    xhr.onload = () => resolve(xhr.responseText);\n    xhr.onerror = () => reject(xhr.statusText);\n    xhr.send();\n  });\n}\n```\n\n### Effect of calling resolveFunc\n\nCalling `resolveFunc` causes the promise to become resolved, so that calling `resolveFunc` or `rejectFunc` again has no effect. However, the promise may be in any of the states: pending, fulfilled, or rejected.\n\nThis `pendingResolved` promise is resolved the time it\'s created, because it has already been "locked in" to match the eventual state of the inner promise, and calling `resolveOuter` or `rejectOuter` or throwing an error later in the executor has no effect on its eventual state. However, the inner promise is still pending until 100ms later, so the outer promise is also pending:\n\n```js\nconst pendingResolved = new Promise((resolveOuter, rejectOuter) => {\n  resolveOuter(\n    new Promise((resolveInner) => {\n      setTimeout(() => {\n        resolveInner("inner");\n      }, 100);\n    }),\n  );\n});\n```\n\nThis `fulfilledResolved` promise becomes fulfilled the moment it\'s resolved, because it\'s resolved with a non-thenable value. However, when it\'s created, it\'s unresolved, because neither `resolve` nor `reject` has been called yet. An unresolved promise is necessarily pending:\n\n```js\nconst fulfilledResolved = new Promise((resolve, reject) => {\n  setTimeout(() => {\n    resolve("outer");\n  }, 100);\n});\n```\n\nCalling `rejectFunc` obviously causes the promise to reject. However, there are also two ways to cause the promise to instantly become rejected even when the `resolveFunc` callback is called.\n\n```js\n// 1. Resolving with the promise itself\nconst rejectedResolved1 = new Promise((resolve) => {\n  // Note: resolve has to be called asynchronously,\n  // so that the rejectedResolved1 variable is initialized\n  setTimeout(() => resolve(rejectedResolved1)); // TypeError: Chaining cycle detected for promise #<Promise>\n});\n\n// 2. Resolving with an object which throws when accessing the `then` property\nconst rejectedResolved2 = new Promise((resolve) => {\n  resolve({\n    get then() {\n      throw new Error("Can\'t get then property");\n    },\n  });\n});\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Promise` in `core-js`](https://github.com/zloirock/core-js#ecmascript-promise)\n- [Using promises](/en-US/docs/Web/JavaScript/Guide/Using_promises) guide\n- {{jsxref("Promise.withResolvers()")}}\n'
        },
        "promises.png": "\uFFFDPNG\r\n\x1a\n\0\0\0\rIHDR\0\0\x03!\0\0\x01)\b\x03\0\0\0\uFFFD\uFFFD\u0745\0\0\0\x04gAMA\0\0\uFFFD\uFFFD\v\uFFFDa\x05\0\0\0\x01sRGB\0\uFFFD\uFFFD\x1c\uFFFD\0\0\x03\0PLTE\uFFFD\uFFFD\uFFFD			  \x1f\uFFFD\uFFFD\uFFFD\x10\x10\x10\uFFFD\uFFFD\uFFFD*'t\0\0\0\uFFFD\uFFFD{\uFFFD\uFFFD\uFFFD\x19\x19\x19\x06\x04\x05\uFFFD\uFFFDi-,,\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\x14\x14\x14\uFFFD\uFFFDw\f\f\f\uFFFD\uFFFD\uD8C8\uDC82\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD'&&\"-\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD212%(z&%s\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD988\uFFFD\uFFFD\uFFFD|1\x0e\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u07CD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\x01\x03\x12[[[FFF\uFFFD\uFFFD\uFFFDqqqTTT\uFFFD\uFFFD\uFFFD~~}\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFDKJJvvv\uFFFD\uFFFD\u05A0\uFFFD\uFFFDjjj\uFFFD\uFFFD4\uFFFD\uFFFD\uFFFDzzz\uFFFD\uFFFD\uFFFD\0\0\x07E\x12>\uFFFD\uFFFDq\uFFFD\uFFFD\uFFFD``_\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uA6DB\uFFFD\uFFFD\uFFFD\uFFFD'\x0f;\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\x17T\uFFFD\uFFFD\uFFFD\uFFFDNNN\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFDBCC\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\x11/\uFFFDeee\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFDQQQ\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u06070\uFFFD\uFFFD\uFFFD<<<\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD.\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFDu#\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD*;\uFFFD\uFFFD\uFFFD\uFFFD#\x03\x12@@@\uFFFD\uFFFD\uFFFD!\x12P\x05\r-%\x0e\x02\\\x17\x1d9\uFFFD\uFFFD469\x0fD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFDF#\f\uFFFD\uFFFD\uFFFD\uFFFD<\uFFFD\uFFFD\uFFFD\u0622dU\uFFFD\uFFFD\uFFFD\uFFFDp\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFDl\uFFFD\uFFFD9\x17\n\uFFFD\u07B9\x04\x16:&x\uFFFDF\x115\uFFFD\uFFFD\uFFFD\x10D\uFFFD.\x0e\x03\uFFFD\uFFFD\uFFFD\u034DS\uFFFD\uFFFD\uFFFD\x0e\x1bd\uFFFD|G\uFFFD\uFFFD\uFFFD\uFFFD5 \uFFFDi\x1f\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\x0e8\uFFFD\x1ba\uFFFD\x10%u\uFFFD}/\uFFFDX\x17=\x7f\uFFFD\uFFFD\uFFFD\u024AG\x1b\uFFFD\uFFFD\uFFFD\uFFFDE\uFFFD\uFFFD\uFFFD.\"f\uFFFD\uFFFD\uFFFD\uFFFD[#\x03\x13RS\x1a:\x01\x07C\uFFFD7\r\uFFFD\uFFFD\uFFFDU\uFFFD\uFFFD'Y\uFFFD\uFFFDR>\x13,XXX\uFFFD\x7f\uFFFDf#4`\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u0585m#,\uFFFDv2\uFFFD\u070D.\r,\x170Y\uFFFD\u06AC\x177i\x1fAoc\uFFFD\uFFFD\x1el\uFFFD\uFFFD\u07FD\uFFFD\uFFFD\uFFFD\x15\x03\x034\x19U\uFFFDup\uFFFD\uFFFD\uFFFD\u0253\uFFFD\uFFFD\uFFFDY\x10\x04\x0e2\x7fF\x12\"\uFFFD\uFFFD\uFFFDF\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD=\x1bSr\uFFFD\u073A\uFFFD\uFFFDN~\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFDI\x1fQU7\x13\uFFFD\uFFFD\uFFFD*\x19V\x98j\uFFFD\uFFFD\uFFFD\uFFFD@\x18\uFFFD\uFFFD\uFFFD|>X\uFFFD\uFFFDs\uFFFD_8\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFDKB\uFFFD,g\uFFFD\u07F7\uFFFD\uFFFDc^\uFFFD\uFFFD\uFFFDC\x0e(A\uFFFD\uFFFDvK\uFFFD\uFFFD\uB00B\uFFFDD\uFFFD\u0230\uFFFD\uFFFD}\uFFFD\u04EB\uFFFD\uFFFDs\uFFFD\uFFFDWxu\uFFFD\uFFFD\uFFFDgX\uFFFD\uFFFD\x7fDEfW\uFFFD\uFFFD|`G&\uFFFD\uFFFD\uFFFDd\uFFFD|\u06B8\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFDu\uFFFDa9\x157\uFFFD\uFFFD\u03CF\uFFFD\uFFFD\uFFFD\uFFFDh\uFFFD\uFFFD\uFFFDye\uFFFD\uFFFD\u04D6V:m)R\uFFFD>\0\0\x1aaIDATx\uFFFD\uFFFDyXT\uFFFD\x19\uFFFD\uFFFD\uFFFD\\\uFFFDuXd\x13\uFFFD\0\uA222A\x02\uFFFD\uFFFDQ\x14)\b\x11A\x10\x14#\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD .\uFFFDX\uFFFD`\x017\u0105\uFFFD\uFFFD\u0448\uFFFD\uFFFD\x16M\u0723\uFFFD\uFFFD\uFFFD5\uFFFD\uFFFD\uFFFD\x18MZ\uFFFD\uFFFD<\uFFFD\x1f=w\x19`\uFFFD\x19'\x03\uFFFD\uFFFD\uFFFD{\uFFFD\uFFFDc\uFFFD\uFFFD\uFFFD{\uFFFD\uFFFD}\uFFFD\uFFFD\uFFFDs\uFFFDC\b\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0@[#icp\u01C1\uFFFD\x19b\u0517\x03\0\uFFFD\0\0C\0\uFFFD!\0\uFFFD\x10\x18\x02`\b\f\x010\x04\uFFFD\0\x18\x02C\0\uFFFD!\0\uFFFD\x10\0`\b\x000\x04\0\x18\x02\0\f\x01\uFFFD\uFFFD2\uFFFDu\uFFFD\uFFFDU'\x1b\x18\x02`\uFFFDZC6~+\uFFFD!\uFFFDM1\uFFFD\x7f\uFFFD\n\u0251;$c\uFFFD\x19\uFFFD\rQ\uFFFD'\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD&\uFFFD\uFFFDQ\uFFFD\uFFFDI\uFFFD`\uFFFD\uFFFDG\uFFFD\uFFFDp\uFFFD\u0552\uFFFD\x07\uFFFDl\uFFFD\uFFFD\uFFFD?%f\uFFFDH\uFFFD\uFFFDd\x18\x02\uFFFD\u0450\uFFFD\uFFFD\u0371\uFFFD\uFFFD**\uFFFD>\uFFFD\uFFFDgQeYt\uFFFD,\uFFFDl\u0286M\uFFFD\x12\uFFFD\x0fFn^*\uFFFD\uFFFDV7\uFFFDo\uFFFDYV\uFFFD\uFFFDOb\uFFFDe'	#\uFFFD\uFFFDa\b0FC\uFFFD\uFFFD\u85B6\uFFFDHZ\uFFFD\uFFFD\"^\uFFFD7P~\uFFFD\uFFFD\uFFFD\x04bgZ\uFFFD^\uFFFD`\uFFFD\uFFFDvS\x0e\uFFFD\uFFFD\u06DC!OS\uFFFDJIL\uFFFD\uFFFD\x1fi\uFFFD\x1f\fC\uFFFD1\x1a\uFFFD\uFFFD\uFFFDz\uFFFD\uFFFD\"i\uFFFDg\uFFFD/O\uFFFD_\uFFFDR.535'f\uFFFD\uFFFD\uFFFD\uFFFD\uFFFDQ?$\uFFFDo\uFFFDY\uFFFDFR\v\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD0\x04\x18\uFFFD!L\uFFFD\uFFFD{\uFFFD\uFFFDHz\uFFFD\x06sJ6\uFFFD=x\uFFFD,\uFFFD\b\uFFFD\uFFFD)W\uFFFD\v\uFFFD)\uFFFDC\uFFFD\uFFFDv\uFFFD\x18\uFFFDR.\x18\uFFFD\x1f\uFFFD\x04C\uFFFD\uFFFD\x19\"\n.[~J\uFFFD\uFFFD\uFFFDr\uFFFD\uFFFDR\uFFFD,\uFFFD\uFFFD+\uFFFD\uFFFD\x04C\uFFFD\uFFFD\"/n\uFFFD\uFFFDqC9\uFFFDo\uFFFD\x16\uFFFDi\x1drP\uFFFDCx\uFFFD\uFFFD\uFFFDa\b0\uFFFD,+U\uFFFDs\uFFFD%\uFFFDa\x15\uFFFD\uFFFD\uFFFD\uFFFD\x1c\x19\r\x0e\uFFFD!\uFFFD\vV\uFFFD\uFFFDZ?\uFFFDogTlo0\uFFFD\u014F\x14\x0e\uFFFD!\uFFFD\b\r\x11p\x17J\uFFFD\uFFFD\uFFFD\x06\x19X\uFFFDC\uFFFD\uFFFD\x19\uFFFD/\x07\uFFFD\uFFFD\x19\uFFFD\x13~\uFFFD_\x1b^\x0e\0\uFFFD2\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\x06C\0\f1\uFFFD\uFFFD\x01\0C\0\uFFFD!\0\uFFFD\x10\0`\b\f\x010\x04\uFFFD\0\x18\x02C\0\f\uFFFD!\0\uFFFD\x10\0`\b\x000\x04\0\x18\x02\0\f\x01@\uFFFD\f\uFFFD~\uFFFD\0\0\0\0\0\0\0\0\0\0\0\0\uFFFD\u0190\uFFFD\uFFFDA\uFFFD\uFFFD\uFFFD0\x1ew\x03\uFFFD\uFFFDt\uFFFD\uFFFD\uFFFD\x04\uFFFD\u012D\0\uFFFD9\uFFFD\uFFFDf\x05q\uFFFD\uFFFD\0\uFFFD\x19\uFFFD\x03\uD0E8 }q'\0h\uFFFD\x10gq\uFFFDP\"\uFFFD\uFFFD>\uFFFD{\x01@c\x0exZ\uFFFDc\uFFFDs\uFFFD\uFFFD{\uFFFD\x19\x004\xbd\uFFFD\u02788\uFFFD\uFFFDx\uFFFD\r\0\x1a\uFFFDim=M\uFFFD\x16w\x03\x18 \uFFFD\x03=\uFFFDkP\x17\uFFFD\uFFFD.&\uFFFDl+\uFFFD\uFFFD\uFFFD\uFFFDq&=\uFFFDq\uFFFD\uFFFD\uFFFD\x19BZ\uFFFD\x10\uFFFD~\x16\uFFFD\uFFFD\u0341\uFFFD\uFFFD\uFFFDq\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\v9\uFFFD5\uFFFDZ\uFFFD\uFFFDDR\uFFFD\uFFFD\uFFFD#\uFFFD&\uFFFD+gd\uFFFD\uFFFD\x1a{~\uFFFD\uFFFD\x15;w\uFFFD\uFFFD\x06\x06h\b\uFFFDYy\u0795\x13\uFFFD\uFFFD\u02E2\uFFFDb\uFFFD\u0436b\uFFFD8\uFFFDj\uFFFD!#\uFFFD\uFFFD\x03'\uFFFD^\x03\uFFFD4\uFFFD\u06EC<8;\uFFFD\uFFFD\x14\uFFFD\uFFFD\f\uFFFD\uFFFD;\u059FT\x10\uFFFD\uFFFD-4\uFFFD] \x1c\uFFFD;\r\f\x14n\uFFFD\uFFFD\uFFFD!b\uFFFD8\uFFFDXiH\uFFFD\uFFFD\uFFFDz\uFFFD\x13\uFFFDiY\x1d\uFFFD/\x10\x02`\uFFFD\uFFFD\uFFFD\x07\x0f\uFFFD\uFFFD\uFFFDw\uFFFD\uFFFD1\uFFFDkG\uFFFD8\uFFFD(\x17\b\x010PD\uFFFDf\uFFFD1{\uFFFD\uFFFD\x1eJ\uFFFDq\uFFFD\uFFFDV\uFFFD\uFFFD\x1a\"\uFFFD\uFFFD:\uFFFDZ\uFFFD:\uFFFD~\uFFFD\x10\0C\uFFFD\u07EC\\tn^\u0231\x1d$\uFFFDb\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\\\x16\uFFFDf\uFFFD\x1e\uFFFD\uFFFD\u0550\x06\v\uFFFD\0\x18M\uFFFD\u0174\u0489\uFFFD@\b\uFFFDz\uFFFD@\b\uFFFDz\uFFFD@\b\uFFFDz\uFFFD@\b\uFFFDz\uFFFD@\b\uFFFDz\uFFFD@\b\uFFFDz\uFFFD@\b\uFFFDz\uFFFD@\b\uFFFD\x06\uFFFD@\b\uFFFDz\uFFFD@\b\uFFFDz\uFFFD@\b\uFFFDz\uFFFD@\b\f\x14\uFFFD+\b\uFFFDFC\uFFFD\uFFFDj\0\uFFFD\x10\0`\b\x000\x04\0\x18\x02C\0\f\uFFFD!\0\uFFFD\uFFFD\x10\0C`\b\x000\x04\0\x18\x02\0\f\x01\0\uFFFD\0\0C\0\uFFFD!\0\uFFFD\x10\x18\x02`\b\f\x010\x04\uFFFD\0\x18\uFFFD\uFFFDW\x13\uFFFDy+>&\0C\u0512V\uFFFD\uFFFD\uFFFDx)\uFFFD\uFFFD\x1f\uFFFD\uFFFD\x17\uFFFD\uFFFD!\uFFFD\x03=\uFFFDL\u035B\uFFFD\x02_\uFFFDP\uFFFD#\uFFFD\x12\uFFFD\uFFFD\u0355\uFFFDN\r\uFFFD\u2636\uFFFD\u0FDDl\uFFFD\x1b\uFFFD=\uFFFDU\uFFFD\uFFFD\uFFFD\uFFFDN7\x1d\r\uFFFDYr\uFFFD\uFFFD\uFFFD-\uFFFD\uFFFDG\x13b\uFFFD\uFFFD\x06\uFFFD\x18\uFFFD+C\uFFFDl\uFFFDL\uFFFD\uFFFD\\\x18\x1f\x1f\uFFFD\u0469\u0390\uFFFD?\x14o\uFFFDV\uFFFDJC\uFFFD|\uE863!\uFFFD\x13\uFFFD>\uFFFD\x19}J\uFFFDL\uFFFD\uFFFDv\uFFFDS\uFFFD\\@g\uFFFD\uFFFD\uFFFD\x1a\uFFFDQ-\uFFFDz\uFFFD\uFFFDo3\n\x16:\uFFFD\uFFFD\uFFFD\v9\uFFFD\uFFFD\uFFFDM^\u0375Rf9\uFFFD\x16,\uFFFD\uFFFD\uFFFD\uFFFD'l\uFFFDb\uFFFD\b\uFFFD\uFFFD\u070A\r\x1dO\uFFFDK\uFFFD\uFFFDb\uFFFD\uFFFD\uFFFD\uFFFD3\uFFFD\uFFFD}\uFFFD\uFFFD$\uFFFD\u04F0\uFFFD\uFFFD\uFFFD\uFFFDI'C\uFFFD\uFFFDL\uFFFD\uFFFD\uFFFD`\uFFFD#?\uFFFDE\uFFFD\u024Eo.\uFFFD%\uFFFD/\uFFFD\uFFFD\uFFFD\x06\uFFFD^\uFFFD\uFFFD\uFFFD\uFFFD-\uFFFD!S6lZ\uFFFD\x18\uFFFDw\uFFFDD\uFFFD\uFFFD\uFFFDh\uFFFD\uFFFDV\uFFFD\uFFFD\uFFFD\x1c\uFFFD$v[v\uFFFD\uFFFD\uFFFD\uFFFD\x10\x1aC\uFFFDVu\uFFFDL\u0679QV\uFFFDc\uFFFD\uFFFDb\uFFFD\uFFFD\uFFFD\uFFFD\x13\uFFFD\uFFFD&\uFFFDdH\uFFFDlq\u060FI\uFFFD\uFFFD_\uFFFDS\uFFFD]\uFFFD/\x12\uFFFDq1\uFFFDw\uFFFD+\uFFFD\uFFFDx\uFFFD\uFFFD=\uFFFD(\uFFFD%\uFFFDLO v]\x1c\uFFFD\uFFFD\uFFFDIN\uFFFD\uFFFDk\uFFFD\uFFFD\uFFFD\uFFFDJ\x10\uFFFD\f\uFFFD\uFFFD\uFFFDHe\x0fW\uFFFD\uFFFD\u052A1d\uFFFD$Q\uFFFDI\u015C\uFFFD\x175:\r5$\u769FN\uFFFD\uFFFD\x7f\uFFFD<|\uFFFD\uFFFD\uFFFD}\uFFFDGv\uFFFD%\uFFFD\x17\uFFFD\uFFFD W\uFFFD\uFFFD\uFFFD%yg\uFFFDP\x03\x19\uFFFD\x1e/\uFFFD\u072F\uFFFDz\uFFFD\\\uFFFDha\x1db\u05A54=D,\x16g\x15s-S\uFFFD-\uFFFD\uFFFD\uFFFD,s#\uFFFD\uFFFD\u029E\uFFFD\uFFFD'\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\x18bj.J_\uFFFD\x1a\uFFFDz\x1a\uFFFD\x10:\uFFFD\u0790\uFFFD\uFFFDG\uFFFD\uFFFD\uFFFDv\x13S\uFFFDo\uFFFD\r{hr\u4F02\uFFFD[\uFFFD\uFFFD&J)W\uFFFD\uFFFD=nS\uFFFD\uFFFDn\uFFFD\uFFFD8\uFFFD\uFFFD!\uFFFD\uFFFD\xa3f\uFFFD\uFFFD\x15\uFFFD{\u054E\v\uFFFD\uFFFD\x1ei4Go\uFFFD!\uFFFD\uFFFD4b\uFFFD\uFFFD+\uFFFD7\uFFFD\uFFFD!/\uFFFDu\uFFFD(\uFFFD,\uFFFD2Q\uFFFD!\uFFFD\uFFFDibH\uFFFD\uFFFD\x1e\uFFFD}lM\uFFFD\uFFFD\x1f\x1b\uFFFD\uFFFD\uFFFDf\x18\uFFFD\uFFFDU\x7f\x13\uFFFD\uFFFD\uFFFD\uFFFD\uFFFDK\uFFFD\uFFFDz\uFFFD!9WvF=[k\u078A\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFDg\uFFFD\uFFFD!\uFFFD\uFFFD\x18\uFFFD\x1f\uFFFD\x0fw\uFFFD\x18\uFFFD\uFFFDX\uFFFD\uFFFD\uFFFD_[&\uFFFD\uFFFD3\bh\uFFFD\uFFFDT\x16%\uFFFDnn*\uFFFD\x15\uFFFD\uFFFD\uFFFD\x06\x06\x04\x1ch\u0590\uFFFD/\uFFFD\x16\uFFFD\x05Cb\uFFFD\uFFFD\uFFFD=\uFFFDh\uFFFD|\uFFFDo%\uFFFD\uFFFDB\x1d\uFFFDb\uFFFDY\uFFFD\uFFFDS2\r\uFFFD4:M\uFFFD\uFFFD\uFFFD,k\uFFFD(\uFFFD\uFFFD\uFFFD\uFFFDn#=\uFFFD:j\uFFFD\uFFFD\uFFFD_\uFFFDqR\uFFFD\uFFFD\uFFFD\uFFFD#\uFFFDl(\uFFFD\uFFFDD\x13\uFFFD\uFFFDZ\uFFFD\x10\uFFFDon\x1eZ\uFFFDZDYEn^*\uFFFD\uFFFD\f\uFFFD;\uFFFD\"/.\uFFFD\uFFFD\uFFFD!\uFFFD\uFFFD\uFFFD2lv\uFFFD\uFFFD\uFFFD\\\uFFFDG\uFFFD\uFFFD\x04\uFFFD\uFFFDG\uFFFD;;\uFFFD\uFFFD71$\uFFFDRnF\uFFFD\uFFFD\x07\uFFFD!\uFFFDs\uFFFDB\uFFFD\uFFFD \xa3\uFFFDV\uFFFD\u02B9,\x15C\uFFFD\uFFFD\uFFFD)\uFFFDi\uFFFDzCTOCO\uF86ER?\uFFFD5\uFFFDw\uFFFD\uFFFD\uFFFD\uFFFDw\uFFFD\b'\f\uFFFD\uFFFD\uFFFD\uFFFD\x7f&\uFFFD\uA770\u065F(\uFFFD\\\u046A\uFFFD\uFFFDu$\uFFFD3\uFFFD\uFFFDRD\uFFFD\uFFFD?\uFFFD V\uFFFD9C\uFFFD\uFFFD5'\x154n\uFFFD\x10\uFFFDN]\uFFFD_\uFFFDOx\x17s\uFFFD\uFFFDug\uFFFDz\x1a<\uFFFD\uFFFDl\uFFFD+\u04ECQ\uFFFD\uFFFD\uFFFD\x0e\uFFFD\uFFFDh\uFFFD\uFFFDE\uFFFD\x1cmk \uFFFD<\uFFFD\uFFFD\uFFFD4\uFFFDZ\uFFFD\x13\uFFFDV\uFFFD\uFFFD\x1c\x17\uFFFDm\uFFFDN\uFFFD!T\uFFFD\fY\uFFFDJ\x11\uFFFD\uFFFDk\uFFFD\x17\uFFFD\uFFFD\uFFFD\uFFFD\uFFFDR\uFFFDc\x10\uFFFD,\uFFFDN]\uFFFD\u0483\uFFFD&\uFFFD\x15\uFFFD\uFFFDgW5gi\x18\uFFFDJ\x06\u034A\uFFFDK$\x12KK\uFFFDP-\ri\uFFFDb\uFFFD+\u06AC\x18\uFFFD\uFFFD\x15\uFFFD;\uFFFD\uFFFD\x13\uFFFD^\uFFFD\uFFFDH\uFFFD\uFFFD9.\uFFFD\uFFFD\uFFFD6\uFFFD!\uFFFD4,\uFFFD\x1a\uFFFD\x10\uFFFD\uFFFD\uFFFD\x10\uFFFD\x18\uFFFD\u07E9+_z$\x116\uFFFD\uFFFD\uFFFD\uFFFDP=\uFFFD\uFFFD]\uFFFD|\uFFFD{\uFFFD\uFFFD.\uFFFD\uFFFD\x10\uFFFD\uFFFD\uFFFD\uFFFD\x10\uFFFD\uFFFD\uFFFD\uFFFDNt\uFFFD\x1bk\uFFFDS's\uFFFD9\uFFFDu\x11\uFFFD\v\uFFFD\b\x18\uFFFD9.\uFFFDp\uFFFD\uFFFD\x0f\uFFFD\\\uFFFD\uFFFDb?\uFFFD\uFFFDzC\uFFFD\x07\uFFFD\x0e\uFFFD\uFFFD\u0515/=\uFFFD\\<\uFFFD\u02EEh\uFFFD\u042C\uFFFD\uFFFD\uFFFD\uFFFD.\uFFFD\uFFFD{:\uFFFDK:\u030E'Z\x1b\uFFFD\uFFFDh}\uFFFD\uFFFD\x01\x11A\uFFFD\uFFFD.}\x1d2\uFFFD\uFFFD\uFFFD\xfc\\a\uFFFD&\x04*E\x14\uFFFD\x10<\uFFFD\uFFFD\uFFFD\x10\uFFFDQ\uFFFDV\uFFFD\"0nC\uFFFD!ueD|\uFFFD!%V\uFFFD\x1c9=\uFFFD5\uFFFD\uFFFD|\uFFFD\uFFFD}-\\\x06G\uFFFD\uFFFDU\uFFFD\uFFFD~p>\uFFFD\x7fC\x04\uFFFD3\uFFFDp\uFFFD\u0575m>\uFFFD\"-\nG\uFFFD\uFFFDi~\"\r\uFFFDo\uFFFD\uFFFD\b\uFFFD\x15\uFFFD\u0673H\uFFFD1\uFFFD\x1a\uFFFD\uFFFDpq7\uFFFD^\uFFFD\x11\uFFFD&\uFFFD\uFFFD-zf\uFFFD\uFFFD\x10\uFFFD\uFFFD\x10\uFFFD\u0245\x13\uFFFDis\uFFFD\uFFFD\x10b\uFFFDjkF\uFFFD2\x05\x1e~\uFFFDN]\uFFFD\uFFFDC\uFFFD`\uFFFD\x047\uFFFDz\uFFFD\x18\uFFFD\uFFFDY\uFFFD\uFFFD\uFFFD\uFFFD\r\uFFFD\uFFFDx\uFFFD(bh\uFFFD\uFFFDU\uFFFDw/\uFFFD\uFFFD&\uFFFDS}#\uFFFD\uFFFDooC\x9f\uFFFD\uFFFD\uFFFD\uFFFD*\uFFFD}\uFFFDN]\uFFFD\x1eLe\x07\uFFFD]\x01\x7fj~6\uFFFD{\uFFFD`\x17\uFFFD\uFFFD\uFFFD\x06\uFFFDv{\uFFFD\x12\uFFFD4\uFFFD\uFFFDc\uFFFD\uFFFD\uFFFDnb\uFFFD\u03A3>\uFFFD\uFFFDg0\uFFFD\uFFFDO\uFFFD\u0296\x1e\uFFFD\uFFFD7\u071A+;\x02z\x0e\uFFFD\uFFFD\x1e\uFFFD\xfb-\uFFFD\u06765\uFFFD\x0f'\uFFFDc\uFFFD\x19fb;\uFFFDw\uFFFD\x17v\uFFFD6\x16C^C\uFFFD\uFFFD\uFFFDV\f\uFFFD\uFFFD\u0710\uFFFD\uFFFD\uFFFDO\x15\uFFFD\v\u030Co\uFFFDg\uFFFD\uFFFD\uFFFD\uFFFD&\uFFFDp2[l\uFFFD\uFFFD\uFFFD\uFFFD\x11x\n\uFFFD\uFFFD\uFFFD\u05D4\uFFFD\uFFFD\b2\uFFFD\uFFFD k\uFFFD~\uFFFDq\x07\uFFFD\uFFFDm\uFFFD\uFFFD\r\b}\uFFFD\x7f?\x13\uFFFD>\uFFFD=\uFFFD\uFFFD7\uFFFD\uFFFDMsJ\uFFFD\uFFFD\uFFFD>\u07B3\uFFFD\uFFFD\uFFFD;\uFFFD\uFFFD6\uFFFD*\uFFFD_\uFFFD\uFFFDl\uFFFD\uFFFDREV#\uFFFDJ\x04\uFFFD,\u02D1%\uFFFD^\uFFFDb\uFFFD\u018A\x1f\uFFFDROl\uFFFD\u0631\x15l\uFFFD\x11\r\uFFFD\uFFFD\x0e	\uFFFD1\"`J\uFFFD\uFFFD\uFFFDniE\x03\uFFFDi3\x13\uFFFDL\x03\uFFFD\uFFFDL\x1b\x06&\uFFFD2\uFFFD\x87\uFFFD\x13\b\uFFFD\f\uFFFD\x06\uFFFD0@h\x19\x1e\uFFFD\uFFFD\x19\x1e\uFFFD\u0695,\uFFFDZY\uFFFD\uFFFDvW:\uFFFD\x19G\uFFFD\uFFFD\uFFFD^\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u0723s0\u0326\uFFFDh\uFFFD\uFFFD|\uFFFD\x16\uFFFD\uFFFD\r\u853A\uFFFDu!\uFFFD\uFFFDUv	\x14\uFFFD\uFFFD\x13\uFFFD\uFFFDf\uFFFD\uFFFD`\uFFFDz#tI\x01a\x1cPy\uFFFDr\uFFFD=&\uFFFD>\uFFFDCisf\uFFFD\uFFFDK\uFFFD\xc9=m8Ye\uFFFD\x0e\x13\uFFFD\uFFFD\uFFFD\\\x7f\uFFFDb\x16'6\uFFFDE]U\uFFFD\uFFFDTGp\uFFFDg\uFFFDN\uFFFD\uFFFD\x1b\uFFFD\uFFFDg\uFFFD(-\x14\uFFFD\uFFFD\uFFFDI<\uFFFD\x12\uFFFD\uFFFD\x1fu\uFFFD\uFFFD\x15\uFFFD\uFFFD\x1e\uFFFD*\uFFFD\uFFFD\u2CF4\uFFFD\uFFFD\uFFFD\uFFFDx\uFFFD\x1d2\uFFFD\x13\uFFFD\uFFFDY\x04\uFFFD\uFFFD\uFFFD\uFFFD+}lz4\uFFFD\uFFFD\uFFFD\x15#\uFFFDA!<\uFFFD\uFFFDF\x02\uFFFD\uFFFD6\uFFFD.Xm\uFFFD\n?\u0360\uFFFD\\\uFFFD\uFFFD\uFFFD\uFFFD\x12\uFFFD\f?d\uFFFD\uFFFD@;\uFFFD\uFFFD\uFFFD\uFFFD\x1e\uFFFD`\u066D\uFFFD\x1aj\x19\uFFFD\uFFFD?\uFFFD\uFFFD\uFFFD\uFFFDBr\b$\uFFFD\uFFFDb\uFFFDx\x05\v\x0f;k\uFFFDe\uFFFDa\uFFFD`q#\x01\uFFFD\uFFFD\v$\uFFFD;\u01D2\uFFFD\n\uFFFD\u07A9\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFDQ\uFFFD\x1b	(\uFFFDfu\u070A\uFFFDJ~\uFFFD%e\uFFFD\uFFFD\f\uFFFD\uFFFD\uFFFD\uFFFD\uFFFDH@!U\uFFFDQE\uFFFDv\uFFFD\uFFFD\x7f\x14\uFFFDFRh\uFFFD\uFFFD\u03BE\x14(\uFFFD\x1c\uFFFD\uFFFDd\uFFFD(\uFFFD\uFFFD\x04\0\uFFFDT\uFFFD4\x1e\uFFFD\x1f%\uFFFD\uFFFD\0\uFFFD\uFFFDJ\uFFFD\u0183\uFFFD\uFFFDU\uFFFD\x1b	\0\n\uFFFDdi\"\uFFFD\x7f\x005\uFFFD\uFFFD\\	\uFFFD\uFFFD L\uFFFD|\uFFFD\uFFFD\uFFFD\x0f\n\x11\uFFFDB\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD@~\uFFFD\x10\uFFFD\uFFFD\x15\uFFFD;\uFFFDX\uFFFDaeA!@U\uFFFD!l	\uFFFD\uFFFD\uFFFD_\uFFFD\x10\uFFFD\uFFFD\x15\x92@\f\uFFFDI)@!\0\uFFFDC\uFFFD&\x10Ctb#P\b\uFFFDI\uFFFD&r4>\uFFFDr\uFFFD\uFFFD\x1c\uFFFD&\uFFFD\uFFFDA!\uFFFD\x13\uFFFD\uFFFDB\0N\x15\uFFFD/\uFFFD\uFFFD\\?\uFFFD\uFFFD\uFFFD\uFFFD,4\x19Le\x14\"[#\uFFFD\x18\u0332\0N\x15\uFFFD\x18\uFFFD\uFFFD\uFFFD\u0406O?\uFFFD\uFFFD\x1b\uFFFD\uFFFD[\uFFFD\f\uFFFD\uFFFD\x18r\uFFFD\uFFFD\uFFFD[\uFFFD\uFFFD\uFFFD1\x18q\u0756\uFFFDhQ\x0fX#\uFFFD\x18\uFFFD\uFFFD\x01\uFFFD\x15R\uFFFD\uFFFD\uFFFDG7\x1c<\x7f#\uFFFD\uFFFD1\uFFFD!\uFFFDT\u020B\uFFFD\uFFFD\uFFFD\x1b\uFFFD\uFFFD2c0\uFFFD-#\u0480\uFFFD\uFFFD\uFFFD\0\uFFFD^\uFFFD\x1c\uB40F\uFFFD\uFFFDw\uFFFD\uFFFD\uFFFDY\uFFFDS\x19\uFFFD)\uFFFD<y\uFFFD-\uFFFD\uFFFD1\x18q\u0796*\\b\uFFFD\uFFFDr\uFFFD\x19`\uFFFD\x10\uFFFDz\f\uFFFDIs39)\u0670\uFFFD>-\uFFFD<\uFFFD\uFFFD\uFFFDTH\uFFFD\uFFFD\uFFFD=r\uFFFD}\uFFFD`\uFFFDy[\uFFFDip\\IX\uFFFD\uFFFDu\x06\uFFFD \uFFFDN\uFFFDe\uFFFD\0J^\uFFFD\uFFFD\x12\nI\uFFFD\"\uFFFD\uFFFD\uFFFDKo\uFFFD.5\uFFFDg\fFy\uFFFD\uFFFD.\uFFFD\uFFFD3\r\uFFFD?\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFDy\uFFFD-\uFFFDS%\uFFFD\x0f\uFFFDd\uFFFD\uFFFD\uFFFDB\u04B2\u0227\x14\uFFFD\uFFFD'\uFFFD\uFFFDu\uFFFD\uFFFD\x10c0\uFFFD-\uFFFD\uFFFDB$#3\x02\uFFFD\uFFFD\uFFFDz\uFFFD\uFFFD\x03\uFFFD\x1fq\uFFFD?\uFFFD\\\x04KQ\uFFFDr\x16\uFFFD\uFFFD1d\u01E9\uFFFD-\x17\uFFFD3\x06#\uFFFD\u06F2S\uFFFD+\u5792:\xe6\uFFFD\uFFFDUG\u04931\x7f\uFFFD\uFFFD\uFFFD*\uFFFD7\uFFFD\x07\uFFFD\uFFFDi)a\uFFFD\uFFFD\uFFFD.q\uFFFD)\uFFFD\uFFFD\xaeE\uFFFD*$\uFFFD\uFFFDz\uFFFD\uFFFD!\uFFFD\uFFFD?\uFFFD\\\fK\u0239\uFFFDR\u06A0\uFFFD\uFFFD@!\uFFFDJ\uFFFD\uFFFD\uFFFD\x07Pc\u0745\uFFFD\uFFFD'N\uFFFD\x17\x7fAy\uFFFD\uFFFDN\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFDo\uFFFD-\uFFFDBx\uFFFD\x7f\0\uFFFD%\uFFFD\b\uFFFD\uFFFD\fK*l\uFFFD\f\uFFFD\x14\uFFFD\0\uFFFD+;O\x1fk\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD{~\uFFFD\uFFFD\uFFFD\x1cC\uFFFD\uFFFD\xbd{\u02E9\x10\uFFFD\uFFFD\x1f@v\uFFFD3{\uFFFD\x07N\uFFFD\uFFFDkn@%oH\vm]\uFFFD\uFFFD\uFFFDu\uFFFD:\uFFFD&\uFFFD\uFFFD\uFFFD\uFFFD7\uFFFD\uFFFD\uFFFD\uFFFD\uFFFDo\uFFFD\uFFFD6}\uFFFD\uFFFD\uFFFD\x16\uFFFDwRf\uFFFD\uFFFDg\uFFFD(\uFFFD!E\x12\r\uFFFD=\uFFFD|\uFFFD\uFFFDK\uFFFD?\uFFFD\u0699\uFFFD'\uFFFD\uFFFD`\uFFFDJ\uFFFD]\x0eIZz\uFFFDjT\uFFFD\uFFFD\uFFFD\uFFFD\uFFFDB|\uFFFD)\uFFFD\uFFFDk	\uFFFD\uFFFD\uFFFDI?\uFFFD\uFFFD}\x17+\uFFFD\uFFFD\uFFFD\uFFFD?\x04\u0410e-\uFFFD\uFFFDw\uFFFD\uFFFD\uFFFD\u05E3G\uFFFD\uFFFD\u0403/\uFFFD\uFFFD\x9f\uFFFD}\uFFFD\uFFFD\uFFFDw\uFFFD\uFFFDy\uFFFDY?\uFFFD\uFFFD\uFFFD\uFFFD{\x11\u04A5\uFFFD\u0629\uFFFD1\u4653m\u837Fn\uFFFD\uFFFD+\uFFFDbB!\uFFFD\uFFFD\uFFFD\x14\"\uFFFD\uFFFD*\uFFFD\x0fx\uFFFD/?<F6\uFFFD\uFFFD\x1f~}\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\x1f\u033Ag\uFFFD\uFFFD^\u0384m\uFFFD\uFFFD\uFFFDB\u03EC\uFFFD+\u04B4U\uFFFDB(\uFFFD\uFFFD\r;\x7f\uFFFD\uFFFD\uFFFD\uFFFD\u06DE=~\uFFFD\uFFFD\uFFFD6=~/}\uFFFD(D\x10\uFFFD,PHyJ\uBFA9\uFFFD\uFFFD\uFFFD\x13g\uFFFD\\}\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD;GIul\uFFFDm\uFFFD\uFFFD&\uFFFD\uFFFDn\uFFFD\uFFFD\\\uFFFD}H\uFFFD\x05,\uFFFD\uFFFDq\x17\uFFFD\uFFFDjV\b\uFFFD\uFFFD\uFFFD\uFFFD\x89-\uFFFD\x7f\uFFFD`\u04D6\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\x0e\uFFFD:{;q\uFFFD(D\x10+uP\b\uFFFDskr\uFFFD\uFFFD\x99\uFFFD\uFFFDkW\uFFFD\x0f<\uFFFD\uFFFD\uFFFD\uFFFDC\x1b\uFFFD\uFFFD\uFFFDT\x07\uFFFD\uFFFD\x13\uFFFD\uFFFD\uFFFD\uFFFD=y\x1a'\x1drb\uFFFD\uFFFD\uFFFDz\uFFFD2\uFFFD\x07h\uFFFD\uFFFD!\uFFFD2\u0391 \uFFFD\uFFFDB\uFFFD\uFFFD\uFFFDX0\uFFFD\uFFFD#q~@j\uFFFD\uFFFD\u07D7\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u0251\uFFFDv\uFFFD\u0276\uFFFD?\uFFFD^O\uFFFD\uFFFD\u047F\u07CD\u072Bc\uFFFD\x19\uFFFD\uFFFD&E\uFFFD\uFFFDZ!\\k0\uFFFD\uFFFD\x10v\f\uFFFDP\uFFFDG\uFFFD\uFFFD\uFFFD\uFFFD\x14\"\uFFFD\uFFFD\x1c\uFFFD\uFFFD\uFFFD\uFFFD\u07877\uFFFD\u0591\uFFFD\uFFFD\uFFFD\uFFFD{\uFFFD\uFFFD\uFFFDG\uFFFD\u0511\uFFFD\uFFFD\x01\u0554\uFFFD_\uFFFD\u9A12\uFFFD\uFFFD\uFFFD\uFFFD\uFFFDK\uFFFD:\x11\uFFFDB(G\uFFFD\uFFFD\uFFFD\uFFFDH\uFFFD\uFFFD\x19\u01EF\uFFFD\x0e\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD|\uFFFD\uFFFD\"\uFFFDY\u02F6\uFFFD\u05BA\x19\uFFFD\x1b\uFFFD\uFFFD\uFFFDo~\uFFFD\x13mv\uFFFD\uFFFD\x05s\uFFFD\uFFFD\uFFFDEG\uFFFD\uFFFD\uFFFD\uFFFD>\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u02FB\uFFFD\x06\uFFFD\uFFFDF\x12&\uFFFD\uFFFD%\uFFFD\uFFFD\uFFFD\uFFFD\u07EE\uFFFD\x15r\uFFFD\uFFFD\uFFFDd|\uFFFDu\uFFFD\uFFFD\x11\uFFFD\uFFFDZ\uFFFD\x18\uFFFDg+;\uFFFDf\uFFFD\x14\uFFFDI\"\uFFFD\uFFFD\x12\u0544\uFFFD\uFFFD'&\uFFFD\x1cuO\uFFFD\uFFFDu\uFFFD\uFFFD\uFFFD\uFFFD\u022D\uFFFD{\uFFFD	v&\uFFFDz\uFFFDB\uFFFD\uEB7A.\x07\n\uFFFDJ!\x0f? K\uFFFDGZW\uFFFD\x1c\uFFFD;\uFFFD\x05+\uFFFD\uFFFD\uFFFD\uFFFD\xda\uFFFD\x16\x14kU\uFFFDw\"\\\uFFFD\uFFFD\u01EA\uFFFDl7\u0126\uFFFD\uFFFD1\uFFFD\nJ!v\"y\x13\uFFFD\x1ak\uFFFD\uFFFD\r\uFFFD'\uFFFD\uFFFD\x16\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u0512\uFFFD}S\uFFFD\uFFFD>\uFFFD\vb\uFFFD\0\uFFFD\uFFFD\x05\v\uFFFD]I%\uFFFDrT	\n\uFFFD[!\uFFFD\uFFFD\uFFFDR\uD905\uDC91\uFFFD\uFFFD\x1d\uFFFD\uFFFD\uFFFD\x10_\uFFFD\uFFFD\x019\uFFFD\uFFFD\uFFFD~\uFFFD\uFFFD\uFFFD\uFFFD.\uFFFD\uD191\uFFFDF_\x1fs\x05\uFFFDK\uFFFDYH\uFFFD\u013C\uFFFD9z\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD~-\uFFFD\uFFFD\uFFFD\x1dC\x12K\x0e\x19\uFFFDo\uFFFDc~\u02A4[D\uFFFD\b\uFFFDcX{\nY\uFFFD\uFFFDD\x1f\uFFFD\uFFFDwT\uFFFDS\uFFFD\uFFFDz\uFFFD\uFFFD}^\uFFFD\uFFFDF\uFFFDX\uFFFD5=\uFFFD4\uFFFD\uFFFDR\uFFFD\n\x1c5z\uFFFD\uFFFD\x05s\x13\uFFFD\f\uFFFD\uFFFDm\uFFFD\uFFFD\"\uFFFD\uFFFD\uFFFD\uFFFD\uFFFDv\uFFFD\b\uFFFD\uFFFD\uFFFD<\uFFFD\v\uFFFD\uFFFD\x14\uFFFD\uFFFD\uFFFD#1G\uFFFD\uFFFD\uFFFD\uFFFD-B!\uFFFD\x17i0\uFFFD\uFFFD8R\uFFFD\uFFFD($\uFFFDd\uFFFD \uFFFD\rb\uFFFD\uFFFDM\uFFFD\uFFFD4\uFFFD\uFFFD\uFFFD\u0535\uFFFDyG	\uFFFD9:\uFFFD\x1a\uFFFDz\uFFFD%d\uFFFD|\uAD67\uFFFD\uFFFD\uFFFDH\uFFFD\x11\uFFFD\uFFFDz\uFFFD\uFFFD\uFFFD\x02mYx\uFFFD\uFFFD\uFFFD}>\uFFFD\uFFFD\uFFFD\x1c\uBCA6p\uFFFD#gN\uFFFD\uFFFD\nA\uFFFD\uFFFD\uFFFDM\uFFFD+9\uFFFD\uFFFD\uFFFD\uFFFD'\uFFFD_\uFFFD\uFFFD\uDA4A\uDEF3\xe3\uFFFD\uFFFD\uFFFD<s%\uFFFDnP\x11\uFFFDXK\x0ecK\uFFFD\x10\uFFFD\u0374\x1dCY1E\uFFFD\uFFFD+a\x0ef\uFFFD%\uFFFD0\uFFFDc\uFFFD\x1a\uFFFD\r0Is\uFFFD\u0314d\uFFFD9M!K#\uFFFD\uFFFD\uFFFDWr\uFFFD\uFFFD3\uFFFDOL\uFFFD\x16\uFFFD\u06CB\uFFFD\uFFFD\uFFFD\uFFFDl\uFFFD\uFFFD\uFFFD\x1e\uFFFD`\x11\uFFFDs^\uFFFD\uFFFDT\uFFFD\x18\uFFFD\x1f\uFFFD\uFFFD\x7f\uFFFD\uFFFDr\uFFFDLH\uFFFDaJ\uFFFD9K\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\x17\uFFFD\x15\uFFFD\u017B\uFFFDEB\uFFFD\uFFFD*i\uFFFDC\uFFFD\uFFFD\"\r\uFFFD\uFFFD\uFFFD\uFFFDf\x14\"\x02\uFFFD\uFFFD\uFFFD\uFFFD\x7fn+K\u0344\x03+\uFFFD}\uFFFD\x1e\uFFFDk\uFFFD]\uFFFD\uFFFD\uFFFD\uFFFDv\x18\uFFFD\x040\u0350=\uFFFDe\r[\b[KWy\x1bQ\x1b\uFFFD\uFFFD`\xe8f\x14\"2\uFFFD\x07\uFFFD5#\uFFFD\uFFFD?\uFFFD\uFFFDC\uFFFD\u016F!l\uFFFD\x19\uFFFD?n\uFFFD:NH\uFFFD\uFFFD\x1d1	\u05AF7\uFFFD\uFFFDQ\uFFFD\uFFFD\uFFFD\x1fe\uFFFD\x19m\uFFFDk\uFFFD\uFFFDJ\uFFFD\x1d\uFFFD\uFFFD\x14N\uFFFD\x19\uFFFD8\"\uFFFD\uFFFD'\x1f\uFFFD\uFFFDvB>\uFFFD\uFFFD\uFFFD\uFFFD\uFFFDiOgT\uFFFD\x7f;\uFFFDR\uFFFD\x12m\uFFFD5h\x11 \x16x\uFFFD\x7f\x18g\f\vv\uFFFD\uFFFDak=\uFFFD)\x1b\b\uFFFDx_\uFFFD\uFFFD\uFFFDi\x190wuT\uFFFDB:\f\uFFFDV\uFFFDj`\x0e:\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD4\x18\uFFFDo\uFFFDQ;\x02}&\uFFFD\x02\uFFFDjL^\uFFFDC\uFFFD\x1f\uFFFDGb\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\x0e\uFFFD\x15b\uFFFD\x1dQ\x1c\uFFFD-\x18\uFFFD\uFFFD\uFFFD\x10\x01\uFFFD?\uFFFDA\uFFFD\uFFFDd\uFFFD\uFFFD>42%'\x1a\uFFFD\uFFFD\uFFFDu\uFFFD\uF6B5\f{\uFFFD\uFFFDv\uFFFD\x0e\nq\fi\uFFFDQ&\uFFFD(t5\uFFFD\"T\uFFFDGc\uFFFDg\uFFFD2\uFFFD\uFFFD/\uFFFD\uFFFD\x12\uFFFD\uFFFD\uFFFD\uFFFD\uFFFDvkxr\uFFFD\x1cd\uFFFD\uFFFDG\uFFFD*\uFFFD\uFFFD\x14\uFFFDe\x1f\xb0!{\x17\uFFFD2\uFFFD\u030C\uFFFD\"\uFFFD1j\uFFFD\uFFFD5i\uFFFD\uFFFDBc\uFFFD\v8\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFDt\uFFFD\x07UFlX^\x15\x12mq\uFFFD	[\u03AF\uFFFD\x03@Y\uFFFD\uFFFD2\x0f\uFFFD\uFFFD\x17_\uFFFDo\\C\uFFFD\uFFFD\x0e\uFFFDR\uFFFD\x17\uFFFD\uFFFD\uFFFDY\uFFFD2\uFFFD8o\n1.\uFFFD\x0e+Ff\uFFFD\uFFFDV\uFFFD\0f\uFFFD\uFFFD\uFFFDi\uFFFD\uFFFD\uFFFDwR\uFFFD\uFFFD\uFFFD9*xS\uFFFD\uFFFDUm\u8026\x01\x04\uFFFDse\uFFFD#HC\x07\0\uFFFDtJV\uFFFD\uFFFD\x03\uFFFD\0\uFFFD\uFFFD!$#\uFFFD*(\x04\0\u0487\x10e\uFFFD\uFFFDk\uFFFD\x05\uFFFD\0\uFFFD\uFFFD\x1c\u0363\uFFFDz3~\uFFFD\x115\uFFFD\uFFFD\x18Y)6\uFFFDB\0\uFFFD\uFFFD\x0f}\uFFFD\x195\uFFFD\uFFFD\x18Y\uFFFD\x10@\uFFFD\nI\u0138B\x1e\uFFFD\uFFFD\bS\uFFFD\uFFFD\uFFFD)\x1dA\uFFFD\uFFFD\uFFFDUR\uFFFD,P\b n\uFFFD\uFFFDe\uFFFD\uFFFDq\uFFFD\x19\uFFFD3(\uFFFD^\u0304\uFFFDJD\u0422\uFFFDf\uFFFD\x14#\v\x14\x02\uFFFD[!\x13\uFFFDB\uFFFD\x18WA\uFFFD\b\uFFFD\b\uFFFD\uFFFD\uFFFD\uFFFD2&\uFFFDf\uFFFD\x14#\vV\uFFFD\uFFFDgYt\uFFFD\uFFFDq}\uFFFD3\uFFFD\uFFFDT\uFFFD+&jVI1\uFFFD@!\uFFFD\uFFFD\x15B\u01F8R\x1a\uFFFDl8\x15\uFFFD	y\uFFFD\uFFFDQ\uFFFDJ\uFFFD\uFFFD\x05\n\x01\u012E\x10\uFFFD\uFFFDq\uFFFD\uFFFD\x12\uFFFDD\uFFFD,\uFFFDt9jVI1\uFFFD@!\uFFFD\uFFFD\u01D0\x1c\uFFFD\uFFFD\uFFFD\uFFFDF^1\uFFFD@!@U+dU\u052C4\uFFFD\x05\n\x01\uFFFD[!\uFFFD-\r\0@!\0\0\n\x01\0P\b\0\uFFFDB@!\0(\x04\x14\x02\uFFFDB@!\0(\x04\x14\x02\0\uFFFD\x10\0X\uFFFD\u03CA#K\x05\0\uFFFD\v\uFFFD_\uFFFD\uFFFDO\uFFFDBM\0\0\x1b\uFFFD\uFFFD^i\uFFFD:\x02\x15\x01\0l,\uFFFD}rbh,\x045\x01\0l\uFFFDz\uFFFD\n\uFFFD\uFFFD\x03\uFFFD\uFFFD\0\uFFFD\uFFFD\x0e\uFFFD\uFFFD0a\uFFFD\fBM\0\0\x1bA\uFFFD\uFFFD\u0435\uFFFDC\x16B\0`CkP\uFFFD+\uFFFD\uFFFD2\x07\0\u0609\uFFFD\ra\x1a\uFFFD\uFFFD(\uFFFD\x04\0\uFFFDa\uFFFD\uFFFDJ\uFFFD\uFFFD_\n\0\uFFFD1N;4\uFFFD\uFFFD\x05v\x14\x01\uFFFD\uFFFDf}\uFFFD\uFFFD_m\x0030\0\uFFFD\uFFFD\x14\uFFFD\u9200\x1dv\x14\x01\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD@^O\0`\uFFFD\xe32)\x16\xf0\uFFFD\b\0\uFFFD\uFFFD\uFFFD\x01B\uFFFD\uFFFD\uFFFD\uFFFD{\vi2\n\x008~t\uFFFDss^6\uFFFD\x12\uFFFD\uFFFD\u0564\uFFFD2\uFFFD.\uFFFD@k\uFFFD\uFFFD\uFFFD\uFFFD\b\uFFFD\uFFFD2\x11/\uFFFD\uFFFD\uFFFDX\uFFFD,4L\uFFFD\uFFFDjB\uFFFD\uFFFD\x15\uFFFD],*\uFFFD\x1b\uFFFD\u0405\uFFFD\x1e\uFFFD\uFFFD\x1e\uFFFD\bz\uFFFD\u01FEo\uFFFDWlm\uFFFDo\uFFFD\uFFFD\uFFFD\uFFFD\x07\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD?gg\x07\uFFFDeV\x02\uFFFD#.1z\uFFFDv\uFFFDln\x14\x01\uFFFD\uFFFD,\uFFFD\b\uFFFD\u0268\uFFFD\uFFFDJ\0\uFFFD\uFFFD\u06F3L\uFFFDp>7\uFFFD\uFFFD_\uFFFDJ\x16\uFFFD\x04\x16\uFFFDy\uFFFD6/w'\uFFFDo\uFFFDW\uFFFDFl\uFFFDQ<\uFFFD\u0232\0\x7f\uFFFD?\uFFFDr\uFFFD1%)O\x19\uFFFD\u05D2\b\uFFFD)')\uFFFD\u0620\uFFFD(\x06\x06\uFFFD\b\uFFFD-N\uFFFDQL]\uFFFDW\uFFFD\f\uFFFD\uFFFDD\0\x1f\uFFFD\uFFFD\x15\x1bC\uFFFD\u03F0\uFFFD\b\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\x10=\uFFFD\0\uFFFD\uFFFDX\uFFFD\x7f\uFFFDH\"\uFFFD\uFFFD@\uFFFD\x1d$\u0122\r\uFFFDX\uFFFDZ\0\x7f\uFFFD\uFFFD\x1a\uFFFDD/Z\uFFFD\uFFFDR\0>\uFFFD\x04\0\0\0\0\0\0\uFFFD&\uFFFD\uFFFD$\x1c\uFFFDBT\uFFFDv\0\uFFFD\0\x14\x02P\b@!\x14\x02\n\uFFFD\x10P\b\uFFFD\uFFFDB(\x04\uFFFD\x10\uFFFDB\0\n\x01(\x04\uFFFD\x10\uFFFDB\0\uFFFD\x16\x12\x1cd\uFFFD9\uFFFDk\uFFFD\uFFFD$;>\uFFFD43\uFFFDB@!>\uFFFD\n9\uFFFD9\uFFFDB\uFFFD\uFFFDB4\x17\uFFFD\uFFFDn\x0e\vsUO\uFFFD;\uFFFD\uFFFDknM\uFFFDz\uFFFD\x1cVJ\uFFFD\f}\uFFFDo\uFFFD\x17\uFFFDv\uFFFDK?\uFFFDJ\x04W\uFFFD\uFFFDF\uFFFDu_^\uFFFD\uFFFD\x10e\uFFFD\uFFFD\uFFFD\uFFFD\uFFFDP%\uFFFD@u\uFFFD\uFFFD<\uFFFD\uFFFD\x18\uFFFD/0W\uFFFD\x7f+?W\uFFFD=s\uFFFDi\uFFFD(\uFFFDi\uFFFD\n\uFFFD>~j\uFFFD\uFFFD`\uFFFD>\uFFFD\x18\u02F7\uFFFDG&\uFFFD`\uFFFDuD)\uFFFD5g\uFFFD?h\uFFFDvS\bTW\uFFFD.\uFFFD\uFFFDT\uFFFD\uFFFDL7\uFFFDn\x10\u04A3\u065C\x1f&\n\uFFFD\u03A1\uFFFD)K\uFFFD\uFFFD\uFFFD\uFFFD}\x1c[1p0\uFFFD9\n\uFFFD;6i\x13\uFFFDZ\uFFFD\x10\uFFFD\\\uFFFDM7J!P_!\uFFFD\uFFFDYZ\uFFFD\uFFFD\uFFFD9\uFFFD \uFFFD'\uFFFD\uFFFD#V\uFFFDw:\uFFFD\uFFFDsHp|dEOh\uFFFDK\uFFFD\x10y\x14\uFFFD\uFFFD\uFFFD\uFFFD(1\uFFFD\uFFFD\uFFFD]s}\uFFFD\\6\uFFFD\uFFFD\uFFFD\uFFFDB2\uFFFDM#wE\uFFFD\uFFFD\x10\uFFFD\x1e\uFFFD3\u0773\uFFFD\u0307o\uFFFDi\uFFFD\x10\uFFFD=\uFFFD5'\uFFFD!\uFFFD=\x04j<\uFFFD\x14^\uFFFD\uFFFDZ\x14\uFFFD.D(\uFFFD\x10\uFFFDB\uFFFD\x0f\u07366\uFFFD\uFFFDj0\uFFFD\u7433#\x1e\uFFFD\x18\uFFFD9\uFFFD@\uFFFD\uFFFDh\uFFFD5e\uFFFD8'\uFFFDB4\uFFFD\uFFFD<\n)\uFFFD&O|k}\uFFFDA\uFFFD.\uFFFD\uFFFD\v\uFFFDB\uFFFD\uFFFD\uFFFD\x1f	\x06\n\uFFFD\uFFFD\n\uFFFDE7\uFFFDi\uFFFD\uFFFD\uFFFDwb\uFFFDhQ\x01\uFFFD\uFFFD(d\uFFFDL\uFFFD\uFFFD;Nv\uFFFD(\x04\x14\uFFFDS\uFFFD\uFFFD\uFFFD\uFFFDKO\x05\uFFFD\uFFFDB\uFFFD\uFFFD\uFFFD\x01\x14\x02P\b@!\0\uFFFDP\b(\uFFFDB@!\x14\x02\n\uFFFD\x10\uFFFDB\0\n\x01(\x04\uFFFD\x10\uFFFDB\uFFFDiV\b\uFFFD\uFFFD\x0e\0\0\0\0\0\0\0\0\0\0\0\0\0\uFFFD\uFFFD_\u0398\uFFFD\uFFFD\uFFFD\uFFFD~6\0\0\0\0IEND\uFFFDB`\uFFFD",
        "race": {
            "index.md": '---\ntitle: Promise.race()\nslug: Web/JavaScript/Reference/Global_Objects/Promise/race\npage-type: javascript-static-method\nbrowser-compat: javascript.builtins.Promise.race\n---\n\n{{JSRef}}\n\nThe **`Promise.race()`** static method takes an iterable of promises as input and returns a single {{jsxref("Promise")}}. This returned promise settles with the eventual state of the first promise that settles.\n\n{{EmbedInteractiveExample("pages/js/promise-race.html", "taller")}}\n\n## Syntax\n\n```js-nolint\nPromise.race(iterable)\n```\n\n### Parameters\n\n- `iterable`\n  - : An [iterable](/en-US/docs/Web/JavaScript/Reference/Iteration_protocols#the_iterable_protocol) (such as an {{jsxref("Array")}}) of promises.\n\n### Return value\n\nA {{jsxref("Promise")}} that **asynchronously settles** with the eventual state of the first promise in the `iterable` to settle. In other words, it fulfills if the first promise to settle is fulfilled, and rejects if the first promise to settle is rejected. The returned promise remains pending forever if the `iterable` passed is empty. If the `iterable` passed is non-empty but contains no pending promises, the returned promise is still asynchronously (instead of synchronously) settled.\n\n## Description\n\nThe `Promise.race()` method is one of the [promise concurrency](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise#promise_concurrency) methods. It\'s useful when you want the first async task to complete, but do not care about its eventual state (i.e. it can either succeed or fail).\n\nIf the iterable contains one or more non-promise values and/or an already settled promise, then `Promise.race()` will settle to the first of these values found in the iterable.\n\n## Examples\n\n### Using Promise.race()\n\nThis example shows how `Promise.race()` can be used to race several timers implemented with [`setTimeout()`](/en-US/docs/Web/API/setTimeout). The timer with the shortest time always wins the race and becomes the resulting promise\'s state.\n\n```js\nfunction sleep(time, value, state) {\n  return new Promise((resolve, reject) => {\n    setTimeout(() => {\n      if (state === "fulfill") {\n        return resolve(value);\n      } else {\n        return reject(new Error(value));\n      }\n    }, time);\n  });\n}\n\nconst p1 = sleep(500, "one", "fulfill");\nconst p2 = sleep(100, "two", "fulfill");\n\nPromise.race([p1, p2]).then((value) => {\n  console.log(value); // "two"\n  // Both fulfill, but p2 is faster\n});\n\nconst p3 = sleep(100, "three", "fulfill");\nconst p4 = sleep(500, "four", "reject");\n\nPromise.race([p3, p4]).then(\n  (value) => {\n    console.log(value); // "three"\n    // p3 is faster, so it fulfills\n  },\n  (error) => {\n    // Not called\n  },\n);\n\nconst p5 = sleep(500, "five", "fulfill");\nconst p6 = sleep(100, "six", "reject");\n\nPromise.race([p5, p6]).then(\n  (value) => {\n    // Not called\n  },\n  (error) => {\n    console.error(error.message); // "six"\n    // p6 is faster, so it rejects\n  },\n);\n```\n\n### Asynchronicity of Promise.race\n\nThis following example demonstrates the asynchronicity of `Promise.race`. Unlike other promise concurrency methods, `Promise.race` is always asynchronous: it never settles synchronously, even when the `iterable` is empty.\n\n```js\n// Passing an array of promises that are already resolved,\n// to trigger Promise.race as soon as possible\nconst resolvedPromisesArray = [Promise.resolve(33), Promise.resolve(44)];\n\nconst p = Promise.race(resolvedPromisesArray);\n// Immediately logging the value of p\nconsole.log(p);\n\n// Using setTimeout, we can execute code after the stack is empty\nsetTimeout(() => {\n  console.log("the stack is now empty");\n  console.log(p);\n});\n\n// Logs, in order:\n// Promise { <state>: "pending" }\n// the stack is now empty\n// Promise { <state>: "fulfilled", <value>: 33 }\n```\n\nAn empty iterable causes the returned promise to be forever pending:\n\n```js\nconst foreverPendingPromise = Promise.race([]);\nconsole.log(foreverPendingPromise);\nsetTimeout(() => {\n  console.log("the stack is now empty");\n  console.log(foreverPendingPromise);\n});\n\n// Logs, in order:\n// Promise { <state>: "pending" }\n// the stack is now empty\n// Promise { <state>: "pending" }\n```\n\nIf the iterable contains one or more non-promise value and/or an already settled promise, then `Promise.race` will settle to the first of these values found in the array:\n\n```js\nconst foreverPendingPromise = Promise.race([]);\nconst alreadyFulfilledProm = Promise.resolve(100);\n\nconst arr = [foreverPendingPromise, alreadyFulfilledProm, "non-Promise value"];\nconst arr2 = [foreverPendingPromise, "non-Promise value", Promise.resolve(100)];\nconst p = Promise.race(arr);\nconst p2 = Promise.race(arr2);\n\nconsole.log(p);\nconsole.log(p2);\nsetTimeout(() => {\n  console.log("the stack is now empty");\n  console.log(p);\n  console.log(p2);\n});\n\n// Logs, in order:\n// Promise { <state>: "pending" }\n// Promise { <state>: "pending" }\n// the stack is now empty\n// Promise { <state>: "fulfilled", <value>: 100 }\n// Promise { <state>: "fulfilled", <value>: "non-Promise value" }\n```\n\n### Using Promise.race() to implement request timeout\n\nYou can race a potentially long-lasting request with a timer that rejects, so that when the time limit has elapsed, the resulting promise automatically rejects.\n\n```js\nconst data = Promise.race([\n  fetch("/api"),\n  new Promise((resolve, reject) => {\n    // Reject after 5 seconds\n    setTimeout(() => reject(new Error("Request timed out")), 5000);\n  }),\n])\n  .then((res) => res.json())\n  .catch((err) => displayError(err));\n```\n\nIf the `data` promise fulfills, it will contain the data fetched from `/api`; otherwise, it will reject if `fetch` remains pending for 5 seconds and loses the race with the `setTimeout` timer.\n\n### Using Promise.race() to detect the status of a promise\n\nBecause `Promise.race()` resolves to the first non-pending promise in the iterable, we can check a promise\'s state, including if it\'s pending. This example is adapted from [`promise-status-async`](https://github.com/kudla/promise-status-async/blob/master/lib/promiseState.js).\n\n```js\nfunction promiseState(promise) {\n  const pendingState = { status: "pending" };\n\n  return Promise.race([promise, pendingState]).then(\n    (value) =>\n      value === pendingState ? value : { status: "fulfilled", value },\n    (reason) => ({ status: "rejected", reason }),\n  );\n}\n```\n\nIn this function, if `promise` is pending, the second value, `pendingState`, which is a non-promise, becomes the result of the race; otherwise, if `promise` is already settled, we may know its state through the `onFulfilled` and `onRejected` handlers. For example:\n\n```js\nconst p1 = new Promise((res) => setTimeout(() => res(100), 100));\nconst p2 = new Promise((res) => setTimeout(() => res(200), 200));\nconst p3 = new Promise((res, rej) => setTimeout(() => rej(300), 100));\n\nasync function getStates() {\n  console.log(await promiseState(p1));\n  console.log(await promiseState(p2));\n  console.log(await promiseState(p3));\n}\n\nconsole.log("Immediately after initiation:");\ngetStates();\nsetTimeout(() => {\n  console.log("After waiting for 100ms:");\n  getStates();\n}, 100);\n\n// Logs:\n// Immediately after initiation:\n// { status: \'pending\' }\n// { status: \'pending\' }\n// { status: \'pending\' }\n// After waiting for 100ms:\n// { status: \'fulfilled\', value: 100 }\n// { status: \'pending\' }\n// { status: \'rejected\', reason: 300 }\n```\n\n> **Note:** The `promiseState` function still runs asynchronously, because there is no way to synchronously get a promise\'s value (i.e. without `then()` or `await`), even when it is already settled. However, `promiseState()` always fulfills within one tick and never actually waits for any promise\'s settlement.\n\n### Comparison with Promise.any()\n\n`Promise.race` takes the first settled {{jsxref("Promise")}}.\n\n```js\nconst promise1 = new Promise((resolve, reject) => {\n  setTimeout(resolve, 500, "one");\n});\n\nconst promise2 = new Promise((resolve, reject) => {\n  setTimeout(reject, 100, "two");\n});\n\nPromise.race([promise1, promise2])\n  .then((value) => {\n    console.log("succeeded with value:", value);\n  })\n  .catch((reason) => {\n    // Only promise1 is fulfilled, but promise2 is faster\n    console.error("failed with reason:", reason);\n  });\n// failed with reason: two\n```\n\n{{jsxref("Promise.any")}} takes the first fulfilled {{jsxref("Promise")}}.\n\n```js\nconst promise1 = new Promise((resolve, reject) => {\n  setTimeout(resolve, 500, "one");\n});\n\nconst promise2 = new Promise((resolve, reject) => {\n  setTimeout(reject, 100, "two");\n});\n\nPromise.any([promise1, promise2])\n  .then((value) => {\n    // Only promise1 is fulfilled, even though promise2 settled sooner\n    console.log("succeeded with value:", value);\n  })\n  .catch((reason) => {\n    console.error("failed with reason:", reason);\n  });\n// succeeded with value: one\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Promise")}}\n- {{jsxref("Promise.all()")}}\n- {{jsxref("Promise.allSettled()")}}\n- {{jsxref("Promise.any()")}}\n'
        },
        "reject": {
            "index.md": '---\ntitle: Promise.reject()\nslug: Web/JavaScript/Reference/Global_Objects/Promise/reject\npage-type: javascript-static-method\nbrowser-compat: javascript.builtins.Promise.reject\n---\n\n{{JSRef}}\n\nThe **`Promise.reject()`** static method returns a `Promise` object that is rejected with a given reason.\n\n{{EmbedInteractiveExample("pages/js/promise-reject.html")}}\n\n## Syntax\n\n```js-nolint\nPromise.reject(reason)\n```\n\n### Parameters\n\n- `reason`\n  - : Reason why this `Promise` rejected.\n\n### Return value\n\nA {{jsxref("Promise")}} that is rejected with the given reason.\n\n## Description\n\nThe static `Promise.reject` function returns a `Promise` that is rejected. For debugging purposes and selective error catching, it is useful to make `reason` an `instanceof` {{jsxref("Error")}}.\n\n`Promise.reject()` is generic and supports subclassing, which means it can be called on subclasses of `Promise`, and the result will be a promise of the subclass type. To do so, the subclass\'s constructor must implement the same signature as the [`Promise()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise/Promise) constructor \u2014 accepting a single `executor` function that can be called with the `resolve` and `reject` callbacks as parameters. `Promise.reject()` is essentially a shorthand for `new Promise((resolve, reject) => reject(reason))`.\n\nUnlike {{jsxref("Promise.resolve()")}}, `Promise.reject()` always wraps `reason` in a new `Promise` object, even when `reason` is already a `Promise`.\n\n## Examples\n\n### Using the static Promise.reject() method\n\n```js\nPromise.reject(new Error("fail")).then(\n  () => {\n    // not called\n  },\n  (error) => {\n    console.error(error); // Stacktrace\n  },\n);\n```\n\n### Rejecting with a promise\n\nUnlike {{jsxref("Promise.resolve")}}, the `Promise.reject` method does not reuse existing `Promise` instances. It always returns a new `Promise` instance that wraps `reason`.\n\n```js\nconst p = Promise.resolve(1);\nconst rejected = Promise.reject(p);\nconsole.log(rejected === p); // false\nrejected.catch((v) => {\n  console.log(v === p); // true\n});\n```\n\n### Calling reject() on a non-Promise constructor\n\n`Promise.reject()` is a generic method. It can be called on any constructor that implements the same signature as the `Promise()` constructor. For example, we can call it on a constructor that passes it `console.log` as `reject`:\n\n```js\nclass NotPromise {\n  constructor(executor) {\n    // The "resolve" and "reject" functions behave nothing like the\n    // native promise\'s, but Promise.reject() calls them in the same way.\n    executor(\n      (value) => console.log("Resolved", value),\n      (reason) => console.log("Rejected", reason),\n    );\n  }\n}\n\nPromise.reject.call(NotPromise, "foo"); // Logs "Rejected foo"\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Promise")}}\n'
        },
        "resolve": {
            "index.md": '---\ntitle: Promise.resolve()\nslug: Web/JavaScript/Reference/Global_Objects/Promise/resolve\npage-type: javascript-static-method\nbrowser-compat: javascript.builtins.Promise.resolve\n---\n\n{{JSRef}}\n\nThe **`Promise.resolve()`** static method "resolves" a given value to a {{jsxref("Promise")}}. If the value is a promise, that promise is returned; if the value is a [thenable](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise#thenables), `Promise.resolve()` will call the `then()` method with two callbacks it prepared; otherwise the returned promise will be fulfilled with the value.\n\nThis function flattens nested layers of promise-like objects (e.g. a promise that fulfills to a promise that fulfills to something) into a single layer \u2014 a promise that fulfills to a non-thenable value.\n\n{{EmbedInteractiveExample("pages/js/promise-resolve.html")}}\n\n## Syntax\n\n```js-nolint\nPromise.resolve(value)\n```\n\n### Parameters\n\n- `value`\n  - : Argument to be resolved by this `Promise`. Can also be a `Promise` or a thenable to resolve.\n\n### Return value\n\nA {{jsxref("Promise")}} that is resolved with the given value, or the promise passed as value, if the value was a promise object. A resolved promise can be in any of the states \u2014 fulfilled, rejected, or pending. For example, resolving a rejected promise will still result in a rejected promise.\n\n## Description\n\n`Promise.resolve()` _resolves_ a promise, which is not the same as fulfilling or rejecting the promise. See [Promise description](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise#description) for definitions of the terminology. In brief, `Promise.resolve()` returns a promise whose eventual state depends on another promise, thenable object, or other value.\n\n`Promise.resolve()` is generic and supports subclassing, which means it can be called on subclasses of `Promise`, and the result will be a promise of the subclass type. To do so, the subclass\'s constructor must implement the same signature as the [`Promise()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise/Promise) constructor \u2014 accepting a single `executor` function that can be called with the `resolve` and `reject` callbacks as parameters.\n\n`Promise.resolve()` special-cases native `Promise` instances. If `value` belongs to `Promise` or a subclass, and `value.constructor === Promise`, then `value` is directly returned by `Promise.resolve()`, without creating a new `Promise` instance. Otherwise, `Promise.resolve()` is essentially a shorthand for `new Promise((resolve) => resolve(value))`.\n\nThe bulk of the resolving logic is actually implemented by [the `resolve` function](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise/Promise#the_resolve_function) passed by the `Promise()` constructor. In summary:\n\n- If a non-[thenable](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise#thenables) value is passed, the returned promise is already fulfilled with that value.\n- If a thenable is passed, the returned promise will adopt the state of that thenable by calling the `then` method and passing a pair of resolving functions as arguments. (But because native promises directly pass through `Promise.resolve()` without creating a wrapper, the `then` method is not called on native promises.) If the `resolve` function receives another thenable object, it will be resolved again, so that the eventual fulfillment value of the promise will never be thenable.\n\n## Examples\n\n### Using the static Promise.resolve method\n\n```js\nPromise.resolve("Success").then(\n  (value) => {\n    console.log(value); // "Success"\n  },\n  (reason) => {\n    // not called\n  },\n);\n```\n\n### Resolving an array\n\n```js\nconst p = Promise.resolve([1, 2, 3]);\np.then((v) => {\n  console.log(v[0]); // 1\n});\n```\n\n### Resolving another Promise\n\n`Promise.resolve()` reuses existing `Promise` instances. If it\'s resolving a native promise, it returns the same promise instance without creating a wrapper.\n\n```js\nconst original = Promise.resolve(33);\nconst cast = Promise.resolve(original);\ncast.then((value) => {\n  console.log(`value: ${value}`);\n});\nconsole.log(`original === cast ? ${original === cast}`);\n\n// Logs, in order:\n// original === cast ? true\n// value: 33\n```\n\nThe inverted order of the logs is due to the fact that the `then` handlers are called asynchronously. See the {{jsxref("Promise/then", "then()")}} reference for more information.\n\n### Resolving thenables and throwing Errors\n\n```js\n// Resolving a thenable object\nconst p1 = Promise.resolve({\n  then(onFulfill, onReject) {\n    onFulfill("fulfilled!");\n  },\n});\nconsole.log(p1 instanceof Promise); // true, object casted to a Promise\n\np1.then(\n  (v) => {\n    console.log(v); // "fulfilled!"\n  },\n  (e) => {\n    // not called\n  },\n);\n\n// Thenable throws\n// Promise rejects\nconst p2 = Promise.resolve({\n  then() {\n    throw new TypeError("Throwing");\n  },\n});\np2.then(\n  (v) => {\n    // not called\n  },\n  (e) => {\n    console.error(e); // TypeError: Throwing\n  },\n);\n\n// Thenable throws after callback\n// Promise resolves\nconst p3 = Promise.resolve({\n  then(onFulfilled) {\n    onFulfilled("Resolving");\n    throw new TypeError("Throwing");\n  },\n});\np3.then(\n  (v) => {\n    console.log(v); // "Resolving"\n  },\n  (e) => {\n    // not called\n  },\n);\n```\n\nNested thenables will be "deeply flattened" to a single promise.\n\n```js\nconst thenable = {\n  then(onFulfilled, onRejected) {\n    onFulfilled({\n      // The thenable is fulfilled with another thenable\n      then(onFulfilled, onRejected) {\n        onFulfilled(42);\n      },\n    });\n  },\n};\n\nPromise.resolve(thenable).then((v) => {\n  console.log(v); // 42\n});\n```\n\n> **Warning:** Do not call `Promise.resolve()` on a thenable that resolves to itself. That leads to infinite recursion, because it attempts to flatten an infinitely-nested promise.\n\n```js example-bad\nconst thenable = {\n  then(onFulfilled, onRejected) {\n    onFulfilled(thenable);\n  },\n};\n\nPromise.resolve(thenable); // Will lead to infinite recursion.\n```\n\n### Calling resolve() on a non-Promise constructor\n\n`Promise.resolve()` is a generic method. It can be called on any constructor that implements the same signature as the `Promise()` constructor. For example, we can call it on a constructor that passes it `console.log` as `resolve`:\n\n```js\nclass NotPromise {\n  constructor(executor) {\n    // The "resolve" and "reject" functions behave nothing like the\n    // native promise\'s, but Promise.resolve() calls them in the same way.\n    executor(\n      (value) => console.log("Resolved", value),\n      (reason) => console.log("Rejected", reason),\n    );\n  }\n}\n\nPromise.resolve.call(NotPromise, "foo"); // Logs "Resolved foo"\n```\n\nThe ability to flatten nested thenables is implemented by the `resolve` function of the `Promise()` constructor, so if you call it on another constructor, nested thenables may not be flattened, depending on how that constructor implements its `resolve` function.\n\n```js\nconst thenable = {\n  then(onFulfilled, onRejected) {\n    onFulfilled({\n      // The thenable is fulfilled with another thenable\n      then(onFulfilled, onRejected) {\n        onFulfilled(42);\n      },\n    });\n  },\n};\n\nPromise.resolve.call(NotPromise, thenable); // Logs "Resolved { then: [Function: then] }"\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Promise")}}\n'
        },
        "then": {
            "index.md": '---\ntitle: Promise.prototype.then()\nslug: Web/JavaScript/Reference/Global_Objects/Promise/then\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Promise.then\n---\n\n{{JSRef}}\n\nThe **`then()`** method of {{jsxref("Promise")}} instances takes up to two arguments: callback functions for the fulfilled and rejected cases of the `Promise`. It immediately returns an equivalent {{jsxref("Promise")}} object, allowing you to [chain](/en-US/docs/Web/JavaScript/Guide/Using_promises#chaining) calls to other promise methods.\n\n{{EmbedInteractiveExample("pages/js/promise-then.html")}}\n\n## Syntax\n\n```js-nolint\nthen(onFulfilled)\nthen(onFulfilled, onRejected)\n```\n\n### Parameters\n\n- `onFulfilled`\n\n  - : A function to asynchronously execute when this promise becomes fulfilled. Its return value becomes the fulfillment value of the promise returned by `then()`. The function is called with the following arguments:\n\n    - `value`\n      - : The value that the promise was fulfilled with.\n\n    If it is not a function, it is internally replaced with an _identity_ function (`(x) => x`) which simply passes the fulfillment value forward.\n\n- `onRejected` {{optional_inline}}\n\n  - : A function to asynchronously execute when this promise becomes rejected. Its return value becomes the fulfillment value of the promise returned by `then()`. The function is called with the following arguments:\n\n    - `reason`\n      - : The value that the promise was rejected with.\n\n    If it is not a function, it is internally replaced with a _thrower_ function (`(x) => { throw x; }`) which throws the rejection reason it received.\n\n### Return value\n\nReturns a new {{jsxref("Promise")}} immediately. This new promise is always pending when returned, regardless of the current promise\'s status.\n\nOne of the `onFulfilled` and `onRejected` handlers will be executed to handle the current promise\'s fulfillment or rejection. The call always happens asynchronously, even when the current promise is already settled. The behavior of the returned promise (call it `p`) depends on the handler\'s execution result, following a specific set of rules. If the handler function:\n\n- returns a value: `p` gets fulfilled with the returned value as its value.\n- doesn\'t return anything: `p` gets fulfilled with `undefined` as its value.\n- throws an error: `p` gets rejected with the thrown error as its value.\n- returns an already fulfilled promise: `p` gets fulfilled with that promise\'s value as its value.\n- returns an already rejected promise: `p` gets rejected with that promise\'s value as its value.\n- returns another pending promise: `p` is pending and becomes fulfilled/rejected with that promise\'s value as its value immediately after that promise becomes fulfilled/rejected.\n\n## Description\n\nThe `then()` method schedules callback functions for the eventual completion of a Promise \u2014 either fulfillment or rejection. It is the primitive method of promises: the [thenable](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise#thenables) protocol expects all promise-like objects to expose a `then()` method, and the {{jsxref("Promise/catch", "catch()")}} and {{jsxref("Promise/finally", "finally()")}} methods both work by invoking the object\'s `then()` method.\n\nFor more information about the `onRejected` handler, see the {{jsxref("Promise/catch", "catch()")}} reference.\n\n`then()` returns a new promise object. If you call the `then()` method twice on the same promise object (instead of chaining), then this promise object will have two pairs of settlement handlers. All handlers attached to the same promise object are always called in the order they were added. Moreover, the two promises returned by each call of `then()` start separate chains and do not wait for each other\'s settlement.\n\n[Thenable](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise#thenables) objects that arise along the `then()` chain are always [resolved](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise/Promise#the_resolve_function) \u2014 the `onFulfilled` handler never receives a thenable object, and any thenable returned by either handler are always resolved before being passed to the next handler. This is because when constructing the new promise, the `resolve` and `reject` functions passed by the `executor` are saved, and when the current promise settles, the respective function will be called with the fulfillment value or rejection reason. The resolving logic comes from the `resolve` function passed by the {{jsxref("Promise/Promise", "Promise()")}} constructor.\n\n`then()` supports subclassing, which means it can be called on instances of subclasses of `Promise`, and the result will be a promise of the subclass type. You can customize the type of the return value through the [`@@species`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise/@@species) property.\n\n## Examples\n\n### Using the then() method\n\n```js\nconst p1 = new Promise((resolve, reject) => {\n  resolve("Success!");\n  // or\n  // reject(new Error("Error!"));\n});\n\np1.then(\n  (value) => {\n    console.log(value); // Success!\n  },\n  (reason) => {\n    console.error(reason); // Error!\n  },\n);\n```\n\n### Having a non-function as either parameter\n\n```js\nPromise.resolve(1).then(2).then(console.log); // 1\nPromise.reject(1).then(2, 2).then(console.log, console.log); // 1\n```\n\n### Chaining\n\nThe `then` method returns a new `Promise`, which allows for method chaining.\n\nIf the function passed as handler to `then` returns a `Promise`, an equivalent `Promise` will be exposed to the subsequent `then` in the method chain. The below snippet simulates asynchronous code with the `setTimeout` function.\n\n```js\nPromise.resolve("foo")\n  // 1. Receive "foo", concatenate "bar" to it, and resolve that to the next then\n  .then(\n    (string) =>\n      new Promise((resolve, reject) => {\n        setTimeout(() => {\n          string += "bar";\n          resolve(string);\n        }, 1);\n      }),\n  )\n  // 2. receive "foobar", register a callback function to work on that string\n  // and print it to the console, but not before returning the unworked on\n  // string to the next then\n  .then((string) => {\n    setTimeout(() => {\n      string += "baz";\n      console.log(string); // foobarbaz\n    }, 1);\n    return string;\n  })\n  // 3. print helpful messages about how the code in this section will be run\n  // before the string is actually processed by the mocked asynchronous code in the\n  // previous then block.\n  .then((string) => {\n    console.log(\n      "Last Then: oops... didn\'t bother to instantiate and return a promise in the prior then so the sequence may be a bit surprising",\n    );\n\n    // Note that `string` will not have the \'baz\' bit of it at this point. This\n    // is because we mocked that to happen asynchronously with a setTimeout function\n    console.log(string); // foobar\n  });\n\n// Logs, in order:\n// Last Then: oops... didn\'t bother to instantiate and return a promise in the prior then so the sequence may be a bit surprising\n// foobar\n// foobarbaz\n```\n\nThe value returned from `then()` is resolved in the same way as {{jsxref("Promise.resolve()")}}. This means [thenable objects](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise#thenables) are supported, and if the return value is not a promise, it\'s implicitly wrapped in a `Promise` and then resolved.\n\n```js\nconst p2 = new Promise((resolve, reject) => {\n  resolve(1);\n});\n\np2.then((value) => {\n  console.log(value); // 1\n  return value + 1;\n}).then((value) => {\n  console.log(value, "- A synchronous value works"); // 2 - A synchronous value works\n});\n\np2.then((value) => {\n  console.log(value); // 1\n});\n```\n\nA `then` call returns a promise that eventually rejects if the function throws an error or returns a rejected Promise.\n\n```js\nPromise.resolve()\n  .then(() => {\n    // Makes .then() return a rejected promise\n    throw new Error("Oh no!");\n  })\n  .then(\n    () => {\n      console.log("Not called.");\n    },\n    (error) => {\n      console.error(`onRejected function called: ${error.message}`);\n    },\n  );\n```\n\nIn practice, it is often desirable to [`catch()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise/catch) rejected promises rather than `then()`\'s two-case syntax, as demonstrated below.\n\n```js\nPromise.resolve()\n  .then(() => {\n    // Makes .then() return a rejected promise\n    throw new Error("Oh no!");\n  })\n  .catch((error) => {\n    console.error(`onRejected function called: ${error.message}`);\n  })\n  .then(() => {\n    console.log("I am always called even if the prior then\'s promise rejects");\n  });\n```\n\nIn all other cases, the returned promise eventually fulfills. In the following example, the first `then()` returns `42` wrapped in a fulfilled Promise, even though the previous Promise in the chain was rejected.\n\n```js\nPromise.reject()\n  .then(\n    () => 99,\n    () => 42,\n  ) // onRejected returns 42 which is wrapped in a fulfilled Promise\n  .then((solution) => console.log(`Resolved with ${solution}`)); // Fulfilled with 42\n```\n\nIf `onFulfilled` returns a promise, the return value of `then` will be fulfilled/rejected based on the eventual state of that promise.\n\n```js\nfunction resolveLater(resolve, reject) {\n  setTimeout(() => {\n    resolve(10);\n  }, 1000);\n}\nfunction rejectLater(resolve, reject) {\n  setTimeout(() => {\n    reject(new Error("Error"));\n  }, 1000);\n}\n\nconst p1 = Promise.resolve("foo");\nconst p2 = p1.then(() => {\n  // Return promise here, that will be resolved to 10 after 1 second\n  return new Promise(resolveLater);\n});\np2.then(\n  (v) => {\n    console.log("resolved", v); // "resolved", 10\n  },\n  (e) => {\n    // not called\n    console.error("rejected", e);\n  },\n);\n\nconst p3 = p1.then(() => {\n  // Return promise here, that will be rejected with \'Error\' after 1 second\n  return new Promise(rejectLater);\n});\np3.then(\n  (v) => {\n    // not called\n    console.log("resolved", v);\n  },\n  (e) => {\n    console.error("rejected", e); // "rejected", \'Error\'\n  },\n);\n```\n\nYou can use chaining to implement one function with a Promise-based API on top of another such function.\n\n```js\nfunction fetchCurrentData() {\n  // The fetch() API returns a Promise. This function\n  // exposes a similar API, except the fulfillment\n  // value of this function\'s Promise has had more\n  // work done on it.\n  return fetch("current-data.json").then((response) => {\n    if (response.headers.get("content-type") !== "application/json") {\n      throw new TypeError();\n    }\n    const j = response.json();\n    // maybe do something with j\n\n    // fulfillment value given to user of\n    // fetchCurrentData().then()\n    return j;\n  });\n}\n```\n\n### Asynchronicity of then()\n\nThe following is an example to demonstrate the asynchronicity of the `then` method.\n\n```js\n// Using a resolved promise \'resolvedProm\' for example,\n// the function call \'resolvedProm.then(...)\' returns a new promise immediately,\n// but its handler \'(value) => {...}\' will get called asynchronously as demonstrated by the console.logs.\n// the new promise is assigned to \'thenProm\',\n// and thenProm will be resolved with the value returned by handler\nconst resolvedProm = Promise.resolve(33);\nconsole.log(resolvedProm);\n\nconst thenProm = resolvedProm.then((value) => {\n  console.log(\n    `this gets called after the end of the main stack. the value received is: ${value}, the value returned is: ${\n      value + 1\n    }`,\n  );\n  return value + 1;\n});\nconsole.log(thenProm);\n\n// Using setTimeout, we can postpone the execution of a function to the moment the stack is empty\nsetTimeout(() => {\n  console.log(thenProm);\n});\n\n// Logs, in order:\n// Promise {[[PromiseStatus]]: "resolved", [[PromiseResult]]: 33}\n// Promise {[[PromiseStatus]]: "pending", [[PromiseResult]]: undefined}\n// "this gets called after the end of the main stack. the value received is: 33, the value returned is: 34"\n// Promise {[[PromiseStatus]]: "resolved", [[PromiseResult]]: 34}\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Promise")}}\n- {{jsxref("Promise.prototype.catch()")}}\n'
        },
        "withresolvers": {
            "index.md": '---\ntitle: Promise.withResolvers()\nslug: Web/JavaScript/Reference/Global_Objects/Promise/withResolvers\npage-type: javascript-static-method\nbrowser-compat: javascript.builtins.Promise.withResolvers\n---\n\n{{JSRef}}\n\nThe **`Promise.withResolvers()`** static method returns an object containing a new {{jsxref("Promise")}} object and two functions to resolve or reject it, corresponding to the two parameters passed to the executor of the {{jsxref("Promise/Promise", "Promise()")}} constructor.\n\n## Syntax\n\n```js-nolint\nPromise.withResolvers()\n```\n\n### Parameters\n\nNone.\n\n### Return value\n\nA plain object containing the following properties:\n\n- `promise`\n  - : A {{jsxref("Promise")}} object.\n- `resolve`\n  - : A function that resolves the promise. For its semantics, see the {{jsxref("Promise/Promise", "Promise()")}} constructor reference.\n- `reject`\n  - : A function that rejects the promise. For its semantics, see the {{jsxref("Promise/Promise", "Promise()")}} constructor reference.\n\n## Description\n\n`Promise.withResolvers()` is exactly equivalent to the following code:\n\n```js\nlet resolve, reject;\nconst promise = new Promise((res, rej) => {\n  resolve = res;\n  reject = rej;\n});\n```\n\nExcept that it is more concise and does not require the use of {{jsxref("Statements/let", "let")}}.\n\nThe key difference when using `Promise.withResolvers()` is that the resolution and rejection functions now live in the same scope as the promise itself, instead of being created and used once within the executor. This may enable some more advanced use cases, such as when reusing them for recurring events, particularly with streams and queues. This also generally results in less nesting than wrapping a lot of logic within the executor.\n\n`Promise.withResolvers()` is generic and supports subclassing, which means it can be called on subclasses of `Promise`, and the result will contain a promise of the subclass type. To do so, the subclass\'s constructor must implement the same signature as the [`Promise()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise/Promise) constructor \u2014 accepting a single `executor` function that can be called with the `resolve` and `reject` callbacks as parameters.\n\n## Examples\n\n### Transforming a stream to an async iterable\n\nThe use case of `Promise.withResolvers()` is when you have a promise that should be resolved or rejected by some event listener that cannot be wrapped inside the promise executor. The following example transforms a Node.js [readable stream](https://nodejs.org/api/stream.html#class-streamreadable) to an [async iterable](/en-US/docs/Web/JavaScript/Reference/Statements/async_function*). Each `promise` here represents a single batch of data available, and each time the current batch is read, a new promise is created for the next batch. Note how the event listeners are only attached once, but actually call a different version of the `resolve` and `reject` functions each time.\n\n```js\nasync function* readableToAsyncIterable(stream) {\n  let { promise, resolve, reject } = Promise.withResolvers();\n  stream.on("error", (error) => reject(error));\n  stream.on("end", () => resolve());\n  stream.on("readable", () => resolve());\n\n  while (stream.readable) {\n    await promise;\n    let chunk;\n    while ((chunk = stream.read())) {\n      yield chunk;\n    }\n    ({ promise, resolve, reject } = Promise.withResolvers());\n  }\n}\n```\n\n### Calling withResolvers() on a non-Promise constructor\n\n`Promise.withResolvers()` is a generic method. It can be called on any constructor that implements the same signature as the `Promise()` constructor. For example, we can call it on a constructor that passes `console.log` as the `resolve` and `reject` functions to `executor`:\n\n```js\nclass NotPromise {\n  constructor(executor) {\n    // The "resolve" and "reject" functions behave nothing like the native\n    // promise\'s, but Promise.withResolvers() just returns them, as is.\n    executor(\n      (value) => console.log("Resolved", value),\n      (reason) => console.log("Rejected", reason),\n    );\n  }\n}\n\nconst { promise, resolve, reject } = Promise.withResolvers.call(NotPromise);\nresolve("hello");\n// Logs: Resolved hello\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Promise.withResolvers` in `core-js`](https://github.com/zloirock/core-js#promisewithresolvers)\n- [Using promises](/en-US/docs/Web/JavaScript/Guide/Using_promises) guide\n- {{jsxref("Promise")}}\n- [`Promise()` constructor](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise/Promise)\n'
        }
    },
    "proxy": {
        "index.md": '---\ntitle: Proxy\nslug: Web/JavaScript/Reference/Global_Objects/Proxy\npage-type: javascript-class\nbrowser-compat: javascript.builtins.Proxy\n---\n\n{{JSRef}}\n\nThe **`Proxy`** object enables you to create a proxy for another object, which can intercept and redefine fundamental operations for that object.\n\n## Description\n\nThe `Proxy` object allows you to create an object that can be used in place of the original object, but which may redefine fundamental `Object` operations like getting, setting, and defining properties. Proxy objects are commonly used to log property accesses, validate, format, or sanitize inputs, and so on.\n\nYou create a `Proxy` with two parameters:\n\n- `target`: the original object which you want to proxy\n- `handler`: an object that defines which operations will be intercepted and how to redefine intercepted operations.\n\nFor example, this code creates a proxy for the `target` object.\n\n```js\nconst target = {\n  message1: "hello",\n  message2: "everyone",\n};\n\nconst handler1 = {};\n\nconst proxy1 = new Proxy(target, handler1);\n```\n\nBecause the handler is empty, this proxy behaves just like the original target:\n\n```js\nconsole.log(proxy1.message1); // hello\nconsole.log(proxy1.message2); // everyone\n```\n\nTo customize the proxy, we define functions on the handler object:\n\n```js\nconst target = {\n  message1: "hello",\n  message2: "everyone",\n};\n\nconst handler2 = {\n  get(target, prop, receiver) {\n    return "world";\n  },\n};\n\nconst proxy2 = new Proxy(target, handler2);\n```\n\nHere we\'ve provided an implementation of the {{jsxref("Proxy/Proxy/get", "get()")}} handler, which intercepts attempts to access properties in the target.\n\nHandler functions are sometimes called _traps_, presumably because they trap calls to the target object. The very simple trap in `handler2` above redefines all property accessors:\n\n```js\nconsole.log(proxy2.message1); // world\nconsole.log(proxy2.message2); // world\n```\n\nProxies are often used with the {{jsxref("Reflect")}} object, which provides some methods with the same names as the `Proxy` traps. The `Reflect` methods provide the reflective semantics for invoking the corresponding [object internal methods](#object_internal_methods). For example, we can call `Reflect.get` if we don\'t wish to redefine the object\'s behavior:\n\n```js\nconst target = {\n  message1: "hello",\n  message2: "everyone",\n};\n\nconst handler3 = {\n  get(target, prop, receiver) {\n    if (prop === "message2") {\n      return "world";\n    }\n    return Reflect.get(...arguments);\n  },\n};\n\nconst proxy3 = new Proxy(target, handler3);\n\nconsole.log(proxy3.message1); // hello\nconsole.log(proxy3.message2); // world\n```\n\nThe `Reflect` method still interacts with the object through object internal methods \u2014 it doesn\'t "de-proxify" the proxy if it\'s invoked on a proxy. If you use `Reflect` methods within a proxy trap, and the `Reflect` method call gets intercepted by the trap again, there may be infinite recursion.\n\n### Terminology\n\nThe following terms are used when talking about the functionality of proxies.\n\n- [handler](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Proxy/Proxy#handler_functions)\n  - : The object passed as the second argument to the `Proxy` constructor. It contains the traps which define the behavior of the proxy.\n- trap\n  - : The function that define the behavior for the corresponding [object internal method](#object_internal_methods). (This is analogous to the concept of _traps_ in operating systems.)\n- target\n  - : Object which the proxy virtualizes. It is often used as storage backend for the proxy. Invariants (semantics that remain unchanged) regarding object non-extensibility or non-configurable properties are verified against the target.\n- invariants\n  - : Semantics that remain unchanged when implementing custom operations. If your trap implementation violates the invariants of a handler, a {{jsxref("TypeError")}} will be thrown.\n\n### Object internal methods\n\n[Objects](/en-US/docs/Web/JavaScript/Data_structures#objects) are collections of properties. However, the language doesn\'t provide any machinery to _directly_ manipulate data stored in the object \u2014 rather, the object defines some internal methods specifying how it can be interacted with. For example, when you read `obj.x`, you may expect the following to happen:\n\n- The `x` property is searched up the [prototype chain](/en-US/docs/Web/JavaScript/Inheritance_and_the_prototype_chain) until it is found.\n- If `x` is a data property, the property descriptor\'s `value` attribute is returned.\n- If `x` is an accessor property, the getter is invoked, and the return value of the getter is returned.\n\nThere isn\'t anything special about this process in the language \u2014 it\'s just because ordinary objects, by default, have a `[[Get]]` internal method that is defined with this behavior. The `obj.x` property access syntax simply invokes the `[[Get]]` method on the object, and the object uses its own internal method implementation to determine what to return.\n\nAs another example, [arrays](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array) differ from normal objects, because they have a magic [`length`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/length) property that, when modified, automatically allocates empty slots or removes elements from the array. Similarly, adding array elements automatically changes the `length` property. This is because arrays have a `[[DefineOwnProperty]]` internal method that knows to update `length` when an integer index is written to, or update the array contents when `length` is written to. Such objects whose internal methods have different implementations from ordinary objects are called _exotic objects_. `Proxy` enable developers to define their own exotic objects with full capacity.\n\nAll objects have the following internal methods:\n\n| Internal method         | Corresponding trap                                                               |\n| ----------------------- | -------------------------------------------------------------------------------- |\n| `[[GetPrototypeOf]]`    | {{jsxref("Proxy/Proxy/getPrototypeOf", "getPrototypeOf()")}}                     |\n| `[[SetPrototypeOf]]`    | {{jsxref("Proxy/Proxy/setPrototypeOf", "setPrototypeOf()")}}                     |\n| `[[IsExtensible]]`      | {{jsxref("Proxy/Proxy/isExtensible", "isExtensible()")}}                         |\n| `[[PreventExtensions]]` | {{jsxref("Proxy/Proxy/preventExtensions", "preventExtensions()")}}               |\n| `[[GetOwnProperty]]`    | {{jsxref("Proxy/Proxy/getOwnPropertyDescriptor", "getOwnPropertyDescriptor()")}} |\n| `[[DefineOwnProperty]]` | {{jsxref("Proxy/Proxy/defineProperty", "defineProperty()")}}                     |\n| `[[HasProperty]]`       | {{jsxref("Proxy/Proxy/has", "has()")}}                                           |\n| `[[Get]]`               | {{jsxref("Proxy/Proxy/get", "get()")}}                                           |\n| `[[Set]]`               | {{jsxref("Proxy/Proxy/set", "set()")}}                                           |\n| `[[Delete]]`            | {{jsxref("Proxy/Proxy/deleteProperty", "deleteProperty()")}}                     |\n| `[[OwnPropertyKeys]]`   | {{jsxref("Proxy/Proxy/ownKeys", "ownKeys()")}}                                   |\n\nFunction objects also have the following internal methods:\n\n| Internal method | Corresponding trap                                 |\n| --------------- | -------------------------------------------------- |\n| `[[Call]]`      | {{jsxref("Proxy/Proxy/apply", "apply()")}}         |\n| `[[Construct]]` | {{jsxref("Proxy/Proxy/construct", "construct()")}} |\n\nIt\'s important to realize that all interactions with an object eventually boils down to the invocation of one of these internal methods, and that they are all customizable through proxies. This means almost no behavior (except certain critical invariants) is guaranteed in the language \u2014 everything is defined by the object itself. When you run [`delete obj.x`](/en-US/docs/Web/JavaScript/Reference/Operators/delete), there\'s no guarantee that [`"x" in obj`](/en-US/docs/Web/JavaScript/Reference/Operators/in) returns `false` afterwards \u2014 it depends on the object\'s implementations of `[[Delete]]` and `[[HasProperty]]`. A `delete obj.x` may log things to the console, modify some global state, or even define a new property instead of deleting the existing one, although these semantics should be avoided in your own code.\n\nAll internal methods are called by the language itself, and are not directly accessible in JavaScript code. The {{jsxref("Reflect")}} namespace offers methods that do little more than call the internal methods, besides some input normalization/validation. In each trap\'s page, we list several typical situations when the trap is invoked, but these internal methods are called in _a lot_ of places. For example, array methods read and write to array through these internal methods, so methods like [`push()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/push) would also invoke `get()` and `set()` traps.\n\nMost of the internal methods are straightforward in what they do. The only two that may be confusable are `[[Set]]` and `[[DefineOwnProperty]]`. For normal objects, the former invokes setters; the latter doesn\'t. (And `[[Set]]` calls `[[DefineOwnProperty]]` internally if there\'s no existing property or the property is a data property.) While you may know that the `obj.x = 1` syntax uses `[[Set]]`, and {{jsxref("Object.defineProperty()")}} uses `[[DefineOwnProperty]]`, it\'s not immediately apparent what semantics other built-in methods and syntaxes use. For example, [class fields](/en-US/docs/Web/JavaScript/Reference/Classes/Public_class_fields) use the `[[DefineOwnProperty]]` semantic, which is why setters defined in the superclass are not invoked when a field is declared on the derived class.\n\n## Constructor\n\n- {{jsxref("Proxy/Proxy", "Proxy()")}}\n  - : Creates a new `Proxy` object.\n\n> **Note:** There\'s no `Proxy.prototype` property, so `Proxy` instances do not have any special properties or methods.\n\n## Static methods\n\n- {{jsxref("Proxy.revocable()")}}\n  - : Creates a revocable `Proxy` object.\n\n## Examples\n\n### Basic example\n\nIn this simple example, the number `37` gets returned as the default value when the property name is not in the object. It is using the {{jsxref("Proxy/Proxy/get", "get()")}} handler.\n\n```js\nconst handler = {\n  get(obj, prop) {\n    return prop in obj ? obj[prop] : 37;\n  },\n};\n\nconst p = new Proxy({}, handler);\np.a = 1;\np.b = undefined;\n\nconsole.log(p.a, p.b); // 1, undefined\n\nconsole.log("c" in p, p.c); // false, 37\n```\n\n### No-op forwarding proxy\n\nIn this example, we are using a native JavaScript object to which our proxy will forward all operations that are applied to it.\n\n```js\nconst target = {};\nconst p = new Proxy(target, {});\n\np.a = 37; // Operation forwarded to the target\n\nconsole.log(target.a); // 37 (The operation has been properly forwarded!)\n```\n\nNote that while this "no-op" works for plain JavaScript objects, it does not work for native objects, such as DOM elements, [`Map`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map) objects, or anything that has internal slots. See [no private property forwarding](#no_private_property_forwarding) for more information.\n\n### No private property forwarding\n\nA proxy is still another object with a different identity \u2014 it\'s a _proxy_ that operates between the wrapped object and the outside. As such, the proxy does not have direct access to the original object\'s [private properties](/en-US/docs/Web/JavaScript/Reference/Classes/Private_properties).\n\n```js\nclass Secret {\n  #secret;\n  constructor(secret) {\n    this.#secret = secret;\n  }\n  get secret() {\n    return this.#secret.replace(/\\d+/, "[REDACTED]");\n  }\n}\n\nconst aSecret = new Secret("123456");\nconsole.log(aSecret.secret); // [REDACTED]\n// Looks like a no-op forwarding...\nconst proxy = new Proxy(aSecret, {});\nconsole.log(proxy.secret); // TypeError: Cannot read private member #secret from an object whose class did not declare it\n```\n\nThis is because when the proxy\'s `get` trap is invoked, the `this` value is the `proxy` instead of the original `secret`, so `#secret` is not accessible. To fix this, use the original `secret` as `this`:\n\n```js\nconst proxy = new Proxy(aSecret, {\n  get(target, prop, receiver) {\n    // By default, it looks like Reflect.get(target, prop, receiver)\n    // which has a different value of `this`\n    return target[prop];\n  },\n});\nconsole.log(proxy.secret);\n```\n\nFor methods, this means you have to redirect the method\'s `this` value to the original object as well:\n\n```js\nclass Secret {\n  #x = 1;\n  x() {\n    return this.#x;\n  }\n}\n\nconst aSecret = new Secret();\nconst proxy = new Proxy(aSecret, {\n  get(target, prop, receiver) {\n    const value = target[prop];\n    if (value instanceof Function) {\n      return function (...args) {\n        return value.apply(this === receiver ? target : this, args);\n      };\n    }\n    return value;\n  },\n});\nconsole.log(proxy.x());\n```\n\nSome native JavaScript objects have properties called _[internal slots](https://tc39.es/ecma262/multipage/ecmascript-data-types-and-values.html#sec-object-internal-methods-and-internal-slots)_, which are not accessible from JavaScript code. For example, [`Map`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map) objects have an internal slot called `[[MapData]]`, which stores the key-value pairs of the map. As such, you cannot trivially create a forwarding proxy for a map:\n\n```js\nconst proxy = new Proxy(new Map(), {});\nconsole.log(proxy.size); // TypeError: get size method called on incompatible Proxy\n```\n\nYou have to use the "`this`-recovering" proxy illustrated above to work around this.\n\n### Validation\n\nWith a `Proxy`, you can easily validate the passed value for an object. This example uses the {{jsxref("Proxy/Proxy/set", "set()")}} handler.\n\n```js\nconst validator = {\n  set(obj, prop, value) {\n    if (prop === "age") {\n      if (!Number.isInteger(value)) {\n        throw new TypeError("The age is not an integer");\n      }\n      if (value > 200) {\n        throw new RangeError("The age seems invalid");\n      }\n    }\n\n    // The default behavior to store the value\n    obj[prop] = value;\n\n    // Indicate success\n    return true;\n  },\n};\n\nconst person = new Proxy({}, validator);\n\nperson.age = 100;\nconsole.log(person.age); // 100\nperson.age = "young"; // Throws an exception\nperson.age = 300; // Throws an exception\n```\n\n### Manipulating DOM nodes\n\nIn this example we use `Proxy` to toggle an attribute of two different elements: so when we set the attribute on one element, the attribute is unset on the other one.\n\nWe create a `view` object which is a proxy for an object with a `selected` property. The proxy handler defines the {{jsxref("Proxy/Proxy/set", "set()")}} handler.\n\nWhen we assign an HTML element to `view.selected`, the element\'s `\'aria-selected\'` attribute is set to `true`. If we then assign a different element to `view.selected`, this element\'s `\'aria-selected\'` attribute is set to `true` and the previous element\'s `\'aria-selected\'` attribute is automatically set to `false`.\n\n```js\nconst view = new Proxy(\n  {\n    selected: null,\n  },\n  {\n    set(obj, prop, newval) {\n      const oldval = obj[prop];\n\n      if (prop === "selected") {\n        if (oldval) {\n          oldval.setAttribute("aria-selected", "false");\n        }\n        if (newval) {\n          newval.setAttribute("aria-selected", "true");\n        }\n      }\n\n      // The default behavior to store the value\n      obj[prop] = newval;\n\n      // Indicate success\n      return true;\n    },\n  },\n);\n\nconst item1 = document.getElementById("item-1");\nconst item2 = document.getElementById("item-2");\n\n// select item1:\nview.selected = item1;\n\nconsole.log(`item1: ${item1.getAttribute("aria-selected")}`);\n// item1: true\n\n// selecting item2 de-selects item1:\nview.selected = item2;\n\nconsole.log(`item1: ${item1.getAttribute("aria-selected")}`);\n// item1: false\n\nconsole.log(`item2: ${item2.getAttribute("aria-selected")}`);\n// item2: true\n```\n\n### Value correction and an extra property\n\nThe `products` proxy object evaluates the passed value and converts it to an array if needed. The object also supports an extra property called `latestBrowser` both as a getter and a setter.\n\n```js\nconst products = new Proxy(\n  {\n    browsers: ["Firefox", "Chrome"],\n  },\n  {\n    get(obj, prop) {\n      // An extra property\n      if (prop === "latestBrowser") {\n        return obj.browsers[obj.browsers.length - 1];\n      }\n\n      // The default behavior to return the value\n      return obj[prop];\n    },\n    set(obj, prop, value) {\n      // An extra property\n      if (prop === "latestBrowser") {\n        obj.browsers.push(value);\n        return true;\n      }\n\n      // Convert the value if it is not an array\n      if (typeof value === "string") {\n        value = [value];\n      }\n\n      // The default behavior to store the value\n      obj[prop] = value;\n\n      // Indicate success\n      return true;\n    },\n  },\n);\n\nconsole.log(products.browsers);\n//  [\'Firefox\', \'Chrome\']\n\nproducts.browsers = "Safari";\n//  pass a string (by mistake)\n\nconsole.log(products.browsers);\n//  [\'Safari\'] <- no problem, the value is an array\n\nproducts.latestBrowser = "Edge";\n\nconsole.log(products.browsers);\n//  [\'Safari\', \'Edge\']\n\nconsole.log(products.latestBrowser);\n//  \'Edge\'\n```\n\n### A complete traps list example\n\nNow in order to create a complete sample `traps` list, for didactic purposes, we will try to proxify a _non-native_ object that is particularly suited to this type of operation: the `docCookies` global object created by [a simple cookie framework](https://reference.codeproject.com/dom/document/cookie/simple_document.cookie_framework).\n\n```js\n/*\n  const docCookies = ... get the "docCookies" object here:\n  https://reference.codeproject.com/dom/document/cookie/simple_document.cookie_framework\n*/\n\nconst docCookies = new Proxy(docCookies, {\n  get(target, key) {\n    return target[key] ?? target.getItem(key) ?? undefined;\n  },\n  set(target, key, value) {\n    if (key in target) {\n      return false;\n    }\n    return target.setItem(key, value);\n  },\n  deleteProperty(target, key) {\n    if (!(key in target)) {\n      return false;\n    }\n    return target.removeItem(key);\n  },\n  ownKeys(target) {\n    return target.keys();\n  },\n  has(target, key) {\n    return key in target || target.hasItem(key);\n  },\n  defineProperty(target, key, descriptor) {\n    if (descriptor && "value" in descriptor) {\n      target.setItem(key, descriptor.value);\n    }\n    return target;\n  },\n  getOwnPropertyDescriptor(target, key) {\n    const value = target.getItem(key);\n    return value\n      ? {\n          value,\n          writable: true,\n          enumerable: true,\n          configurable: false,\n        }\n      : undefined;\n  },\n});\n\n/* Cookies test */\n\nconsole.log((docCookies.myCookie1 = "First value"));\nconsole.log(docCookies.getItem("myCookie1"));\n\ndocCookies.setItem("myCookie1", "Changed value");\nconsole.log(docCookies.myCookie1);\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Proxies are awesome](https://youtu.be/sClk6aB_CPk) presentation by Brendan Eich at JSConf (2014)\n',
        "proxy": {
            "apply": {
                "index.md": '---\ntitle: handler.apply()\nslug: Web/JavaScript/Reference/Global_Objects/Proxy/Proxy/apply\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Proxy.handler.apply\n---\n\n{{JSRef}}\n\nThe **`handler.apply()`** method is a trap for the `[[Call]]` [object internal method](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Proxy#object_internal_methods), which is used by operations such as function calls.\n\n{{EmbedInteractiveExample("pages/js/proxyhandler-apply.html", "taller")}}\n\n## Syntax\n\n```js-nolint\nnew Proxy(target, {\n  apply(target, thisArg, argumentsList) {\n  }\n});\n```\n\n### Parameters\n\nThe following parameters are passed to the `apply()` method. `this` is bound to the handler.\n\n- `target`\n  - : The target callable object.\n- `thisArg`\n  - : The `this` argument for the call.\n- `argumentsList`\n  - : The list of arguments for the call.\n\n### Return value\n\nThe `apply()` method can return any value.\n\n## Description\n\n### Interceptions\n\nThis trap can intercept these operations:\n\n- Function call: `proxy(...args)`\n- {{jsxref("Function.prototype.apply()")}} and {{jsxref("Function.prototype.call()")}}\n- {{jsxref("Reflect.apply()")}}\n\nOr any other operation that invokes the `[[Call]]` [internal method](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Proxy#object_internal_methods).\n\n### Invariants\n\nIf the following invariants are violated, the trap throws a {{jsxref("TypeError")}} when invoked.\n\n- The `target` must be a callable itself. That is, it must be a function object.\n\n## Examples\n\n### Trapping a function call\n\nThe following code traps a function call.\n\n```js\nconst p = new Proxy(function () {}, {\n  apply(target, thisArg, argumentsList) {\n    console.log(`called: ${argumentsList}`);\n    return argumentsList[0] + argumentsList[1] + argumentsList[2];\n  },\n});\n\nconsole.log(p(1, 2, 3)); // "called: 1,2,3"\n// 6\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Proxy")}}\n- [`Proxy()` constructor](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Proxy/Proxy)\n- {{jsxref("Function.prototype.apply()")}}\n- {{jsxref("Function.prototype.call()")}}\n- {{jsxref("Reflect.apply()")}}\n'
            },
            "construct": {
                "index.md": '---\ntitle: handler.construct()\nslug: Web/JavaScript/Reference/Global_Objects/Proxy/Proxy/construct\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Proxy.handler.construct\n---\n\n{{JSRef}}\n\nThe **`handler.construct()`** method is a trap for the `[[Construct]]` [object internal method](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Proxy#object_internal_methods), which is used by operations such as the {{jsxref("Operators/new", "new")}} operator. In order for the new operation to be valid on the resulting Proxy object, the target used to initialize the proxy must itself be a valid constructor.\n\n{{EmbedInteractiveExample("pages/js/proxyhandler-construct.html", "taller")}}\n\n## Syntax\n\n```js-nolint\nnew Proxy(target, {\n  construct(target, argumentsList, newTarget) {\n  }\n});\n```\n\n### Parameters\n\nThe following parameters are passed to the `construct()` method. `this` is bound to the handler.\n\n- `target`\n  - : The target object.\n- `argumentsList`\n  - : The list of arguments for the constructor.\n- `newTarget`\n  - : The constructor that was originally called.\n\n### Return value\n\nThe `construct` method must return an object.\n\n## Description\n\n### Interceptions\n\nThis trap can intercept these operations:\n\n- The [`new`](/en-US/docs/Web/JavaScript/Reference/Operators/new) operator: `new myFunction(...args)`\n- {{jsxref("Reflect.construct()")}}\n\nOr any other operation that invokes the `[[Construct]]` [internal method](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Proxy#object_internal_methods).\n\n### Invariants\n\nIf the following invariants are violated, the trap throws a {{jsxref("TypeError")}} when invoked.\n\n- The result must be an `Object`.\n\n## Examples\n\n### Trapping the new operator\n\nThe following code traps the {{jsxref("Operators/new", "new")}} operator.\n\n```js\nconst p = new Proxy(function () {}, {\n  construct(target, argumentsList, newTarget) {\n    console.log(`called: ${argumentsList}`);\n    return { value: argumentsList[0] * 10 };\n  },\n});\n\nconsole.log(new p(1).value); // "called: 1"\n// 10\n```\n\nThe following code violates the invariant.\n\n```js example-bad\nconst p = new Proxy(function () {}, {\n  construct(target, argumentsList, newTarget) {\n    return 1;\n  },\n});\n\nnew p(); // TypeError is thrown\n```\n\nThe following code improperly initializes the proxy. The `target` in Proxy initialization must itself be a valid constructor for the {{jsxref("Operators/new", "new")}} operator.\n\n```js example-bad\nconst p = new Proxy(\n  {},\n  {\n    construct(target, argumentsList, newTarget) {\n      return {};\n    },\n  },\n);\n\nnew p(); // TypeError is thrown, "p" is not a constructor\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Proxy")}}\n- [`Proxy()` constructor](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Proxy/Proxy)\n- {{jsxref("Operators/new", "new")}}\n- {{jsxref("Reflect.construct()")}}\n'
            },
            "defineproperty": {
                "index.md": '---\ntitle: handler.defineProperty()\nslug: Web/JavaScript/Reference/Global_Objects/Proxy/Proxy/defineProperty\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Proxy.handler.defineProperty\n---\n\n{{JSRef}}\n\nThe **`handler.defineProperty()`** method is a trap for the `[[DefineOwnProperty]]` [object internal method](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Proxy#object_internal_methods), which is used by operations such as {{jsxref("Object.defineProperty()")}}.\n\n{{EmbedInteractiveExample("pages/js/proxyhandler-defineproperty.html", "taller")}}\n\n## Syntax\n\n```js-nolint\nnew Proxy(target, {\n  defineProperty(target, property, descriptor) {\n  }\n});\n```\n\n### Parameters\n\nThe following parameters are passed to the `defineProperty()` method.\n`this` is bound to the handler.\n\n- `target`\n  - : The target object.\n- `property`\n  - : The name or {{jsxref("Symbol")}} of the property whose description is to be\n    retrieved.\n- `descriptor`\n  - : The descriptor for the property being defined or modified.\n\n### Return value\n\nThe `defineProperty()` method must return a {{jsxref("Boolean")}} indicating\nwhether or not the property has been successfully defined.\n\n## Description\n\n### Interceptions\n\nThis trap can intercept these operations:\n\n- {{jsxref("Object.defineProperty()")}}, {{jsxref("Object.defineProperties()")}}\n- {{jsxref("Reflect.defineProperty()")}}\n\nOr any other operation that invokes the `[[DefineOwnProperty]]` [internal method](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Proxy#object_internal_methods).\n\n### Invariants\n\nIf the following invariants are violated, the trap throws a {{jsxref("TypeError")}} when invoked.\n\n- A property cannot be added, if the target object is not extensible.\n- A property cannot be added as or modified to be non-configurable, if it does not\n  exists as a non-configurable own property of the target object.\n- A property may not be non-configurable, if a corresponding configurable property of\n  the target object exists.\n- If a property has a corresponding target object property then\n  `Object.defineProperty(target, prop, descriptor)`\n  will not throw an exception.\n- In strict mode, a `false` return value from the\n  `defineProperty()` handler will throw a {{jsxref("TypeError")}} exception.\n\n## Examples\n\n### Trapping of defineProperty\n\nThe following code traps {{jsxref("Object.defineProperty()")}}.\n\n```js\nconst p = new Proxy(\n  {},\n  {\n    defineProperty(target, prop, descriptor) {\n      console.log(`called: ${prop}`);\n      return true;\n    },\n  },\n);\n\nconst desc = { configurable: true, enumerable: true, value: 10 };\nObject.defineProperty(p, "a", desc); // "called: a"\n```\n\nWhen calling {{jsxref("Object.defineProperty()")}} or\n{{jsxref("Reflect.defineProperty()")}}, the `descriptor` passed to\n`defineProperty()` trap has one restriction\u2014only following properties are\nusable (non-standard properties will be ignored):\n\n- `enumerable`\n- `configurable`\n- `writable`\n- `value`\n- `get`\n- `set`\n\n```js\nconst p = new Proxy(\n  {},\n  {\n    defineProperty(target, prop, descriptor) {\n      console.log(descriptor);\n      return Reflect.defineProperty(target, prop, descriptor);\n    },\n  },\n);\n\nObject.defineProperty(p, "name", {\n  value: "proxy",\n  type: "custom",\n}); // { value: \'proxy\' }\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Proxy")}}\n- [`Proxy()` constructor](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Proxy/Proxy)\n- {{jsxref("Object.defineProperty()")}}\n- {{jsxref("Reflect.defineProperty()")}}\n'
            },
            "deleteproperty": {
                "index.md": '---\ntitle: handler.deleteProperty()\nslug: Web/JavaScript/Reference/Global_Objects/Proxy/Proxy/deleteProperty\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Proxy.handler.deleteProperty\n---\n\n{{JSRef}}\n\nThe **`handler.deleteProperty()`** method is a trap for the `[[Delete]]` [object internal method](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Proxy#object_internal_methods), which is used by operations such as the {{jsxref("Operators/delete", "delete")}} operator.\n\n{{EmbedInteractiveExample("pages/js/proxyhandler-deleteproperty.html", "taller")}}\n\n## Syntax\n\n```js-nolint\nnew Proxy(target, {\n  deleteProperty(target, property) {\n  }\n});\n```\n\n### Parameters\n\nThe following parameters are passed to the `deleteProperty()` method.\n`this` is bound to the handler.\n\n- `target`\n  - : The target object.\n- `property`\n  - : The name or {{jsxref("Symbol")}} of the property to delete.\n\n### Return value\n\nThe `deleteProperty()` method must return a boolean value indicating\nwhether or not the property has been successfully deleted.\n\n## Description\n\n### Interceptions\n\nThis trap can intercept these operations:\n\n- The [`delete`](/en-US/docs/Web/JavaScript/Reference/Operators/delete) operator: `delete proxy[foo]` and\n  `delete proxy.foo`\n- {{jsxref("Reflect.deleteProperty()")}}\n\nOr any other operation that invokes the `[[Delete]]` [internal method](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Proxy#object_internal_methods).\n\n### Invariants\n\nIf the following invariants are violated, the trap throws a {{jsxref("TypeError")}} when invoked.\n\n- A property cannot be deleted, if it exists as a non-configurable own property of the\n  target object.\n\n## Examples\n\n### Trapping the delete operator\n\nThe following code traps the {{jsxref("Operators/delete", "delete")}} operator.\n\n```js\nconst p = new Proxy(\n  {},\n  {\n    deleteProperty(target, prop) {\n      if (!(prop in target)) {\n        console.log(`property not found: ${prop}`);\n        return false;\n      }\n      delete target[prop];\n      console.log(`property removed: ${prop}`);\n      return true;\n    },\n  },\n);\n\np.a = 10;\nconsole.log("a" in p); // true\n\nconst result1 = delete p.a; // "property removed: a"\nconsole.log(result1); // true\nconsole.log("a" in p); // false\n\nconst result2 = delete p.a; // "property not found: a"\nconsole.log(result2); // false\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Proxy")}}\n- [`Proxy()` constructor](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Proxy/Proxy)\n- {{jsxref("Operators/delete", "delete")}}\n- {{jsxref("Reflect.deleteProperty()")}}\n'
            },
            "get": {
                "index.md": '---\ntitle: handler.get()\nslug: Web/JavaScript/Reference/Global_Objects/Proxy/Proxy/get\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Proxy.handler.get\n---\n\n{{JSRef}}\n\nThe **`handler.get()`** method is a trap for the `[[Get]]` [object internal method](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Proxy#object_internal_methods), which is used by operations such as [property accessors](/en-US/docs/Web/JavaScript/Reference/Operators/Property_accessors).\n\n{{EmbedInteractiveExample("pages/js/proxyhandler-get.html", "taller")}}\n\n## Syntax\n\n```js-nolint\nnew Proxy(target, {\n  get(target, property, receiver) {\n  }\n});\n```\n\n### Parameters\n\nThe following parameters are passed to the `get()` method. `this`\nis bound to the handler.\n\n- `target`\n  - : The target object.\n- `property`\n  - : The name or {{jsxref("Symbol")}} of the property to get.\n- `receiver`\n  - : Either the proxy or an object that inherits from the proxy.\n\n### Return value\n\nThe `get()` method can return any value.\n\n## Description\n\n### Interceptions\n\nThis trap can intercept these operations:\n\n- Property access: `proxy[foo]` and `proxy.bar`\n- {{jsxref("Reflect.get()")}}\n\nOr any other operation that invokes the `[[Get]]` [internal method](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Proxy#object_internal_methods).\n\n### Invariants\n\nIf the following invariants are violated, the trap throws a {{jsxref("TypeError")}} when invoked.\n\n- The value reported for a property must be the same as the value of the corresponding\n  target object property if the target object property is a non-writable,\n  non-configurable own data property.\n- The value reported for a property must be undefined if the corresponding target\n  object property is a non-configurable own accessor property that has\n  `undefined` as its `[[Get]]` attribute.\n\n## Examples\n\n### Trap for getting a property value\n\nThe following code traps getting a property value.\n\n```js\nconst p = new Proxy(\n  {},\n  {\n    get(target, property, receiver) {\n      console.log(`called: ${property}`);\n      return 10;\n    },\n  },\n);\n\nconsole.log(p.a);\n// "called: a"\n// 10\n```\n\nThe following code violates an invariant.\n\n```js\nconst obj = {};\nObject.defineProperty(obj, "a", {\n  configurable: false,\n  enumerable: false,\n  value: 10,\n  writable: false,\n});\n\nconst p = new Proxy(obj, {\n  get(target, property) {\n    return 20;\n  },\n});\n\np.a; // TypeError is thrown\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Proxy")}}\n- [`Proxy()` constructor](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Proxy/Proxy)\n- {{jsxref("Reflect.get()")}}\n'
            },
            "getownpropertydescriptor": {
                "index.md": '---\ntitle: handler.getOwnPropertyDescriptor()\nslug: Web/JavaScript/Reference/Global_Objects/Proxy/Proxy/getOwnPropertyDescriptor\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Proxy.handler.getOwnPropertyDescriptor\n---\n\n{{JSRef}}\n\nThe **`handler.getOwnPropertyDescriptor()`** method is a trap for the `[[GetOwnProperty]]` [object internal method](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Proxy#object_internal_methods), which is used by operations such as {{jsxref("Object.getOwnPropertyDescriptor()")}}.\n\n{{EmbedInteractiveExample("pages/js/proxyhandler-getownpropertydescriptor.html", "taller")}}\n\n## Syntax\n\n```js-nolint\nnew Proxy(target, {\n  getOwnPropertyDescriptor(target, prop) {\n  }\n});\n```\n\n### Parameters\n\nThe following parameters are passed to the `getOwnPropertyDescriptor()` method. `this` is bound to the handler.\n\n- `target`\n  - : The target object.\n- `prop`\n  - : The name of the property whose description should be retrieved.\n\n### Return value\n\nThe `getOwnPropertyDescriptor()` method must return an object or `undefined`.\n\n## Description\n\n### Interceptions\n\nThis trap can intercept these operations:\n\n- {{jsxref("Object.getOwnPropertyDescriptor()")}}\n- {{jsxref("Reflect.getOwnPropertyDescriptor()")}}\n\nOr any other operation that invokes the `[[GetOwnProperty]]` [internal method](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Proxy#object_internal_methods).\n\n### Invariants\n\nIf the following invariants are violated, the trap throws a {{jsxref("TypeError")}} when invoked.\n\n- `getOwnPropertyDescriptor()` must return an object or `undefined`.\n- A property cannot be reported as non-existent, if it exists as a non-configurable own property of the target object.\n- A property cannot be reported as non-existent, if it exists as an own property of the target object and the target object is not extensible.\n- A property cannot be reported as existent, if it does not exists as an own property of the target object and the target object is not extensible.\n- A property cannot be reported as non-configurable, if it does not exists as an own property of the target object or if it exists as a configurable own property of the target object.\n- The result of `Object.getOwnPropertyDescriptor(target)` can be applied to the target object using `Object.defineProperty()` and will not throw an exception.\n\n## Examples\n\n### Trapping of getOwnPropertyDescriptor\n\nThe following code traps {{jsxref("Object.getOwnPropertyDescriptor()")}}.\n\n```js\nconst p = new Proxy(\n  { a: 20 },\n  {\n    getOwnPropertyDescriptor(target, prop) {\n      console.log(`called: ${prop}`);\n      return { configurable: true, enumerable: true, value: 10 };\n    },\n  },\n);\n\nconsole.log(Object.getOwnPropertyDescriptor(p, "a").value);\n// "called: a"\n// 10\n```\n\nThe following code violates an invariant.\n\n```js example-bad\nconst obj = { a: 10 };\nObject.preventExtensions(obj);\nconst p = new Proxy(obj, {\n  getOwnPropertyDescriptor(target, prop) {\n    return undefined;\n  },\n});\n\nObject.getOwnPropertyDescriptor(p, "a"); // TypeError is thrown\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Proxy")}}\n- [`Proxy()` constructor](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Proxy/Proxy)\n- {{jsxref("Object.getOwnPropertyDescriptor()")}}\n- {{jsxref("Reflect.getOwnPropertyDescriptor()")}}\n'
            },
            "getprototypeof": {
                "index.md": '---\ntitle: handler.getPrototypeOf()\nslug: Web/JavaScript/Reference/Global_Objects/Proxy/Proxy/getPrototypeOf\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Proxy.handler.getPrototypeOf\n---\n\n{{JSRef}}\n\nThe **`handler.getPrototypeOf()`** method is a trap for the `[[GetPrototypeOf]]` [object internal method](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Proxy#object_internal_methods), which is used by operations such as {{jsxref("Object.getPrototypeOf()")}}.\n\n{{EmbedInteractiveExample("pages/js/proxyhandler-getprototypeof.html", "taller")}}\n\n## Syntax\n\n```js-nolint\nnew Proxy(obj, {\n  getPrototypeOf(target) {\n    // \u2026\n  }\n});\n```\n\n### Parameters\n\nThe following parameter is passed to the `getPrototypeOf()` method.\n`this` is bound to the handler.\n\n- `target`\n  - : The target object.\n\n### Return value\n\nThe `getPrototypeOf()` method must return an object or `null`.\n\n## Description\n\n### Interceptions\n\nThis trap can intercept these operations:\n\n- {{jsxref("Object.getPrototypeOf()")}}\n- {{jsxref("Reflect.getPrototypeOf()")}}\n- [`__proto__`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/proto)\n- {{jsxref("Object.prototype.isPrototypeOf()")}}\n- {{jsxref("Operators/instanceof", "instanceof")}}\n\nOr any other operation that invokes the `[[GetPrototypeOf]]` [internal method](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Proxy#object_internal_methods).\n\n### Invariants\n\nIf the following invariants are violated, the trap throws a {{jsxref("TypeError")}} when invoked.\n\n- `getPrototypeOf()` method must return an object or `null`.\n- If `target` is not extensible,\n  `Object.getPrototypeOf(proxy)` method must return the same\n  value as `Object.getPrototypeOf(target)`.\n\n## Examples\n\n### Basic usage\n\n```js\nconst obj = {};\nconst proto = {};\nconst handler = {\n  getPrototypeOf(target) {\n    console.log(target === obj); // true\n    console.log(this === handler); // true\n    return proto;\n  },\n};\n\nconst p = new Proxy(obj, handler);\nconsole.log(Object.getPrototypeOf(p) === proto); // true\n```\n\n### Five ways to trigger the getPrototypeOf trap\n\n```js\nconst obj = {};\nconst p = new Proxy(obj, {\n  getPrototypeOf(target) {\n    return Array.prototype;\n  },\n});\nconsole.log(\n  Object.getPrototypeOf(p) === Array.prototype, // true\n  Reflect.getPrototypeOf(p) === Array.prototype, // true\n  p.__proto__ === Array.prototype, // true\n  Array.prototype.isPrototypeOf(p), // true\n  p instanceof Array, // true\n);\n```\n\n### Two kinds of exceptions\n\n```js example-bad\nconst obj = {};\nconst p = new Proxy(obj, {\n  getPrototypeOf(target) {\n    return "foo";\n  },\n});\nObject.getPrototypeOf(p); // TypeError: "foo" is not an object or null\n\nconst obj2 = Object.preventExtensions({});\nconst p2 = new Proxy(obj2, {\n  getPrototypeOf(target) {\n    return {};\n  },\n});\nObject.getPrototypeOf(p2); // TypeError: expected same prototype value\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Proxy")}}\n- [`Proxy()` constructor](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Proxy/Proxy)\n- {{jsxref("Object.getPrototypeOf()")}}\n- {{jsxref("Reflect.getPrototypeOf()")}}\n'
            },
            "has": {
                "index.md": '---\ntitle: handler.has()\nslug: Web/JavaScript/Reference/Global_Objects/Proxy/Proxy/has\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Proxy.handler.has\n---\n\n{{JSRef}}\n\nThe **`handler.has()`** method is a trap for the `[[HasProperty]]` [object internal method](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Proxy#object_internal_methods), which is used by operations such as the {{jsxref("Operators/in", "in")}} operator.\n\n{{EmbedInteractiveExample("pages/js/proxyhandler-has.html", "taller")}}\n\n## Syntax\n\n```js-nolint\nnew Proxy(target, {\n  has(target, prop) {\n  }\n});\n```\n\n### Parameters\n\nThe following parameters are passed to `has()` method. `this` is\nbound to the handler.\n\n- `target`\n  - : The target object.\n- `prop`\n  - : The name or {{jsxref("Symbol")}} of the property to check for existence.\n\n### Return value\n\nThe `has()` method must return a boolean value.\n\n## Description\n\n### Interceptions\n\nThis trap can intercept these operations:\n\n- The [`in`](/en-US/docs/Web/JavaScript/Reference/Operators/in) operator: `foo in proxy`\n- [`with`](/en-US/docs/Web/JavaScript/Reference/Statements/with) check: `with(proxy) { (foo); }`\n- {{jsxref("Reflect.has()")}}\n\nOr any other operation that invokes the `[[HasProperty]]` [internal method](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Proxy#object_internal_methods).\n\n### Invariants\n\nIf the following invariants are violated, the trap throws a {{jsxref("TypeError")}} when invoked.\n\n- A property cannot be reported as non-existent, if it exists as a non-configurable\n  own property of the target object.\n- A property cannot be reported as non-existent, if it exists as an own property of\n  the target object and the target object is not extensible.\n\n## Examples\n\n### Trapping the in operator\n\nThe following code traps the {{jsxref("Operators/in", "in")}} operator.\n\n```js\nconst p = new Proxy(\n  {},\n  {\n    has(target, prop) {\n      console.log(`called: ${prop}`);\n      return true;\n    },\n  },\n);\n\nconsole.log("a" in p);\n// "called: a"\n// true\n```\n\nThe following code violates an invariant.\n\n```js example-bad\nconst obj = { a: 10 };\nObject.preventExtensions(obj);\n\nconst p = new Proxy(obj, {\n  has(target, prop) {\n    return false;\n  },\n});\n\n"a" in p; // TypeError is thrown\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Proxy")}}\n- [`Proxy()` constructor](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Proxy/Proxy)\n- {{jsxref("Operators/in", "in")}}\n- {{jsxref("Reflect.has()")}}\n'
            },
            "index.md": '---\ntitle: Proxy() constructor\nslug: Web/JavaScript/Reference/Global_Objects/Proxy/Proxy\npage-type: javascript-constructor\nbrowser-compat: javascript.builtins.Proxy.Proxy\n---\n\n{{JSRef}}\n\nThe **`Proxy()`** constructor creates {{jsxref("Proxy")}} objects.\n\n## Syntax\n\n```js-nolint\nnew Proxy(target, handler)\n```\n\n> **Note:** `Proxy()` can only be constructed with [`new`](/en-US/docs/Web/JavaScript/Reference/Operators/new). Attempting to call it without `new` throws a {{jsxref("TypeError")}}.\n\n### Parameters\n\n- `target`\n  - : A target object to wrap with `Proxy`. It can be any sort of object,\n    including a native array, a function, or even another proxy.\n- `handler`\n  - : An object whose properties are functions that define the behavior of the proxy when\n    an operation is performed on it.\n\n## Description\n\nUse the `Proxy()` constructor to create a new `Proxy` object.\nThis constructor takes two mandatory arguments:\n\n- `target` is the object for which you want to create the proxy\n- `handler` is the object that defines the custom behavior of the proxy.\n\nAn empty handler will create a proxy that behaves, in almost all respects, exactly like\nthe target. By defining any of a set group of functions on the `handler`\nobject, you can customize specific aspects of the proxy\'s behavior. For example, by\ndefining `get()` you can provide a customized version of the target\'s\n[property accessor](/en-US/docs/Web/JavaScript/Reference/Operators/Property_accessors).\n\n### Handler functions\n\nThis section lists all the handler functions you can define. Handler functions are\nsometimes called _traps_, because they trap calls to the underlying target\nobject.\n\n- {{jsxref("Proxy/Proxy/apply", "handler.apply()")}}\n  - : A trap for a function call.\n- {{jsxref("Proxy/Proxy/construct", "handler.construct()")}}\n  - : A trap for the {{jsxref("Operators/new", "new")}} operator.\n- {{jsxref("Proxy/Proxy/defineProperty", "handler.defineProperty()")}}\n  - : A trap for {{jsxref("Object.defineProperty")}}.\n- {{jsxref("Proxy/Proxy/deleteProperty", "handler.deleteProperty()")}}\n  - : A trap for the {{jsxref("Operators/delete", "delete")}} operator.\n- {{jsxref("Proxy/Proxy/get", "handler.get()")}}\n  - : A trap for getting property values.\n- {{jsxref("Proxy/Proxy/getOwnPropertyDescriptor", "handler.getOwnPropertyDescriptor()")}}\n  - : A trap for {{jsxref("Object.getOwnPropertyDescriptor")}}.\n- {{jsxref("Proxy/Proxy/getPrototypeOf", "handler.getPrototypeOf()")}}\n  - : A trap for {{jsxref("Object.getPrototypeOf")}}.\n- {{jsxref("Proxy/Proxy/has", "handler.has()")}}\n  - : A trap for the {{jsxref("Operators/in", "in")}} operator.\n- {{jsxref("Proxy/Proxy/isExtensible", "handler.isExtensible()")}}\n  - : A trap for {{jsxref("Object.isExtensible")}}.\n- {{jsxref("Proxy/Proxy/ownKeys", "handler.ownKeys()")}}\n  - : A trap for {{jsxref("Object.getOwnPropertyNames")}} and\n    {{jsxref("Object.getOwnPropertySymbols")}}.\n- {{jsxref("Proxy/Proxy/preventExtensions", "handler.preventExtensions()")}}\n  - : A trap for {{jsxref("Object.preventExtensions")}}.\n- {{jsxref("Proxy/Proxy/set", "handler.set()")}}\n  - : A trap for setting property values.\n- {{jsxref("Proxy/Proxy/setPrototypeOf", "handler.setPrototypeOf()")}}\n  - : A trap for {{jsxref("Object.setPrototypeOf")}}.\n\n## Examples\n\n### Selectively proxy property accessors\n\nIn this example the target has two properties, `notProxied` and\n`proxied`. We define a handler that returns a different value for\n`proxied`, and lets any other accesses through to the target.\n\n```js\nconst target = {\n  notProxied: "original value",\n  proxied: "original value",\n};\n\nconst handler = {\n  get(target, prop, receiver) {\n    if (prop === "proxied") {\n      return "replaced value";\n    }\n    return Reflect.get(...arguments);\n  },\n};\n\nconst proxy = new Proxy(target, handler);\n\nconsole.log(proxy.notProxied); // "original value"\nconsole.log(proxy.proxied); // "replaced value"\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Meta programming](/en-US/docs/Web/JavaScript/Guide/Meta_programming) guide\n- {{jsxref("Reflect")}}\n',
            "isextensible": {
                "index.md": '---\ntitle: handler.isExtensible()\nslug: Web/JavaScript/Reference/Global_Objects/Proxy/Proxy/isExtensible\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Proxy.handler.isExtensible\n---\n\n{{JSRef}}\n\nThe **`handler.isExtensible()`** method is a trap for the `[[IsExtensible]]` [object internal method](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Proxy#object_internal_methods), which is used by operations such as {{jsxref("Object.isExtensible()")}}.\n\n{{EmbedInteractiveExample("pages/js/proxyhandler-isextensible.html", "taller")}}\n\n## Syntax\n\n```js-nolint\nnew Proxy(target, {\n  isExtensible(target) {\n  }\n});\n```\n\n### Parameters\n\nThe following parameter is passed to the `isExtensible()` method.\n`this` is bound to the handler.\n\n- `target`\n  - : The target object.\n\n### Return value\n\nThe `isExtensible()` method must return a boolean value.\n\n## Description\n\n### Interceptions\n\nThis trap can intercept these operations:\n\n- {{jsxref("Object.isExtensible()")}}\n- {{jsxref("Reflect.isExtensible()")}}\n\nOr any other operation that invokes the `[[IsExtensible]]` [internal method](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Proxy#object_internal_methods).\n\n### Invariants\n\nIf the following invariants are violated, the trap throws a {{jsxref("TypeError")}} when invoked.\n\n- `Object.isExtensible(proxy)` must return the same value as\n  `Object.isExtensible(target)`.\n\n## Examples\n\n### Trapping of isExtensible\n\nThe following code traps {{jsxref("Object.isExtensible()")}}.\n\n```js\nconst p = new Proxy(\n  {},\n  {\n    isExtensible(target) {\n      console.log("called");\n      return true;\n    },\n  },\n);\n\nconsole.log(Object.isExtensible(p));\n// "called"\n// true\n```\n\nThe following code violates the invariant.\n\n```js example-bad\nconst p = new Proxy(\n  {},\n  {\n    isExtensible(target) {\n      return false;\n    },\n  },\n);\n\nObject.isExtensible(p); // TypeError is thrown\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Proxy")}}\n- [`Proxy()` constructor](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Proxy/Proxy)\n- {{jsxref("Object.isExtensible()")}}\n- {{jsxref("Reflect.isExtensible()")}}\n- {{jsxref("Reflect.preventExtensions()")}}\n'
            },
            "ownkeys": {
                "index.md": '---\ntitle: handler.ownKeys()\nslug: Web/JavaScript/Reference/Global_Objects/Proxy/Proxy/ownKeys\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Proxy.handler.ownKeys\n---\n\n{{JSRef}}\n\nThe **`handler.ownKeys()`** method is a trap for the `[[OwnPropertyKeys]]` [object internal method](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Proxy#object_internal_methods), which is used by operations such as {{jsxref("Object.keys()")}}, {{jsxref("Reflect.ownKeys()")}}, etc.\n\n{{EmbedInteractiveExample("pages/js/proxyhandler-ownkeys.html", "taller")}}\n\n## Syntax\n\n```js-nolint\nnew Proxy(target, {\n  ownKeys(target) {\n  }\n});\n```\n\n### Parameters\n\nThe following parameter is passed to the `ownKeys()` method.\n`this` is bound to the handler.\n\n- `target`\n  - : The target object.\n\n### Return value\n\nThe `ownKeys()` method must return an enumerable object.\n\n## Description\n\n### Interceptions\n\nThis trap can intercept these operations:\n\n- {{jsxref("Object.getOwnPropertyNames()")}}\n- {{jsxref("Object.getOwnPropertySymbols()")}}\n- {{jsxref("Object.keys()")}}\n- {{jsxref("Reflect.ownKeys()")}}\n\nOr any other operation that invokes the `[[OwnPropertyKeys]]` [internal method](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Proxy#object_internal_methods).\n\n### Invariants\n\nIf the following invariants are violated, the trap throws a {{jsxref("TypeError")}} when invoked.\n\n- The result of `ownKeys()` must be an array.\n- The type of each array element is either a {{jsxref("String")}} or a\n  {{jsxref("Symbol")}}.\n- The result List must contain the keys of all non-configurable own properties of the\n  target object.\n- If the target object is not extensible, then the result List must contain all the\n  keys of the own properties of the target object and no other values.\n\n## Examples\n\n### Trapping of getOwnPropertyNames\n\nThe following code traps {{jsxref("Object.getOwnPropertyNames()")}}.\n\n```js\nconst p = new Proxy(\n  {},\n  {\n    ownKeys(target) {\n      console.log("called");\n      return ["a", "b", "c"];\n    },\n  },\n);\n\nconsole.log(Object.getOwnPropertyNames(p));\n// "called"\n// [ \'a\', \'b\', \'c\' ]\n```\n\nThe following code violates an invariant.\n\n```js example-bad\nconst obj = {};\nObject.defineProperty(obj, "a", {\n  configurable: false,\n  enumerable: true,\n  value: 10,\n});\n\nconst p = new Proxy(obj, {\n  ownKeys(target) {\n    return [123, 12.5, true, false, undefined, null, {}, []];\n  },\n});\n\nconsole.log(Object.getOwnPropertyNames(p));\n\n// TypeError: proxy [[OwnPropertyKeys]] must return an array\n// with only string and symbol elements\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Proxy")}}\n- [`Proxy()` constructor](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Proxy/Proxy)\n- {{jsxref("Object.getOwnPropertyNames()")}}\n- {{jsxref("Reflect.ownKeys()")}}\n'
            },
            "preventextensions": {
                "index.md": '---\ntitle: handler.preventExtensions()\nslug: Web/JavaScript/Reference/Global_Objects/Proxy/Proxy/preventExtensions\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Proxy.handler.preventExtensions\n---\n\n{{JSRef}}\n\nThe **`handler.preventExtensions()`** method is a trap for the `[[PreventExtensions]]` [object internal method](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Proxy#object_internal_methods), which is used by operations such as {{jsxref("Object.preventExtensions()")}}.\n\n{{EmbedInteractiveExample("pages/js/proxyhandler-preventextensions.html", "taller")}}\n\n## Syntax\n\n```js-nolint\nnew Proxy(target, {\n  preventExtensions(target) {\n  }\n});\n```\n\n### Parameters\n\nThe following parameter is passed to the `preventExtensions()` method. `this` is bound to the handler.\n\n- `target`\n  - : The target object.\n\n### Return value\n\nThe `preventExtensions()` method must return a boolean value.\n\n## Description\n\n### Interceptions\n\nThis trap can intercept these operations:\n\n- {{jsxref("Object.preventExtensions()")}}\n- {{jsxref("Reflect.preventExtensions()")}}\n- {{jsxref("Object.seal()")}}\n- {{jsxref("Object.freeze()")}}\n\nOr any other operation that invokes the `[[PreventExtensions]]` [internal method](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Proxy#object_internal_methods).\n\n### Invariants\n\nIf the following invariants are violated, the trap throws a {{jsxref("TypeError")}} when invoked.\n\n- `Object.preventExtensions(proxy)` only returns `true` if `Object.isExtensible(proxy)` is `false`.\n\n## Examples\n\n### Trapping of preventExtensions\n\nThe following code traps {{jsxref("Object.preventExtensions()")}}.\n\n```js\nconst p = new Proxy(\n  {},\n  {\n    preventExtensions(target) {\n      console.log("called");\n      Object.preventExtensions(target);\n      return true;\n    },\n  },\n);\n\nconsole.log(Object.preventExtensions(p));\n// "called"\n// false\n```\n\nThe following code violates the invariant.\n\n```js example-bad\nconst p = new Proxy(\n  {},\n  {\n    preventExtensions(target) {\n      return true;\n    },\n  },\n);\n\nObject.preventExtensions(p); // TypeError is thrown\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Proxy")}}\n- [`Proxy()` constructor](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Proxy/Proxy)\n- {{jsxref("Object.preventExtensions()")}}\n- {{jsxref("Reflect.preventExtensions()")}}\n'
            },
            "set": {
                "index.md": '---\ntitle: handler.set()\nslug: Web/JavaScript/Reference/Global_Objects/Proxy/Proxy/set\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Proxy.handler.set\n---\n\n{{JSRef}}\n\nThe **`handler.set()`** method is a trap for the `[[Set]]` [object internal method](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Proxy#object_internal_methods), which is used by operations such as using [property accessors](/en-US/docs/Web/JavaScript/Reference/Operators/Property_accessors) to set a property\'s value.\n\n{{EmbedInteractiveExample("pages/js/proxyhandler-set.html", "taller")}}\n\n## Syntax\n\n```js-nolint\nnew Proxy(target, {\n  set(target, property, value, receiver) {\n  }\n});\n```\n\n### Parameters\n\nThe following parameters are passed to the `set()` method. `this`\nis bound to the handler.\n\n- `target`\n  - : The target object.\n- `property`\n  - : The name or {{jsxref("Symbol")}} of the property to set.\n- `value`\n  - : The new value of the property to set.\n- `receiver`\n\n  - : The object to which the assignment was originally directed. This is usually the\n    proxy itself. But a `set()` handler can also be called indirectly, via\n    the prototype chain or various other ways.\n\n    For example, suppose a script does\n    `obj.name = "jen"`, and `obj` is not a\n    proxy, and has no own property `.name`, but it has a proxy on its\n    prototype chain. That proxy\'s `set()` handler will be called, and\n    `obj` will be passed as the receiver.\n\n### Return value\n\nThe `set()` method should return a boolean value.\n\n- Return `true` to indicate that assignment succeeded.\n- If the `set()` method returns `false`, and the assignment\n  happened in strict-mode code, a {{jsxref("TypeError")}} will be thrown.\n\n## Description\n\n### Interceptions\n\nThis trap can intercept these operations:\n\n- Property assignment: `proxy[foo] = bar` and `proxy.foo = bar`\n- {{jsxref("Reflect.set()")}}\n\nOr any other operation that invokes the `[[Set]]` [internal method](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Proxy#object_internal_methods).\n\n### Invariants\n\nIf the following invariants are violated, the trap throws a {{jsxref("TypeError")}} when invoked.\n\n- Cannot change the value of a property to be different from the value of the\n  corresponding target object property if the corresponding target object property is a\n  non-writable, non-configurable data property.\n- Cannot set the value of a property if the corresponding target object property is a\n  non-configurable accessor property that has `undefined` as its\n  `[[Set]]` attribute.\n- In strict mode, a `false` return value from the `set()`\n  handler will throw a {{jsxref("TypeError")}} exception.\n\n## Examples\n\n### Trap setting of a property value\n\nThe following code traps setting a property value.\n\n```js\nconst p = new Proxy(\n  {},\n  {\n    set(target, prop, value, receiver) {\n      target[prop] = value;\n      console.log(`property set: ${prop} = ${value}`);\n      return true;\n    },\n  },\n);\n\nconsole.log("a" in p); // false\n\np.a = 10; // "property set: a = 10"\nconsole.log("a" in p); // true\nconsole.log(p.a); // 10\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Proxy")}}\n- [`Proxy()` constructor](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Proxy/Proxy)\n- {{jsxref("Reflect.set()")}}\n'
            },
            "setprototypeof": {
                "index.md": '---\ntitle: handler.setPrototypeOf()\nslug: Web/JavaScript/Reference/Global_Objects/Proxy/Proxy/setPrototypeOf\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Proxy.handler.setPrototypeOf\n---\n\n{{JSRef}}\n\nThe **`handler.setPrototypeOf()`** method is a trap for the `[[SetPrototypeOf]]` [object internal method](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Proxy#object_internal_methods), which is used by operations such as {{jsxref("Object.setPrototypeOf()")}}.\n\n{{EmbedInteractiveExample("pages/js/proxyhandler-setprototypeof.html", "taller")}}\n\n## Syntax\n\n```js-nolint\nnew Proxy(target, {\n  setPrototypeOf(target, prototype) {\n  }\n});\n```\n\n### Parameters\n\nThe following parameters are passed to the `setPrototypeOf()` method.\n`this` is bound to the handler.\n\n- `target`\n  - : The target object.\n- `prototype`\n  - : The object\'s new prototype or `null`.\n\n### Return value\n\nThe `setPrototypeOf()` method returns `true` if the\n`[[Prototype]]` was successfully changed, otherwise `false`.\n\n## Description\n\n### Interceptions\n\nThis trap can intercept these operations:\n\n- {{jsxref("Object.setPrototypeOf()")}}\n- {{jsxref("Reflect.setPrototypeOf()")}}\n\nOr any other operation that invokes the `[[SetPrototypeOf]]` [internal method](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Proxy#object_internal_methods).\n\n### Invariants\n\nIf the following invariants are violated, the trap throws a {{jsxref("TypeError")}} when invoked.\n\n- If `target` is not extensible, the `prototype`\n  parameter must be the same value as\n  `Object.getPrototypeOf(target)`.\n\n## Examples\n\nIf you want to disallow setting a new prototype for your object, your handler\'s\n`setPrototypeOf()` method can either return `false`, or it can\nthrow an exception.\n\n### Approach 1: Returning false\n\nThis approach means that any mutating operation that throws an exception on failure to\nmutate, must create the exception itself.\n\nFor example, {{jsxref("Object.setPrototypeOf()")}} will create and throw a\n{{jsxref("TypeError")}} itself. If the mutation is performed by an operation that\n_doesn\'t_ ordinarily throw in case of failure, such as\n{{jsxref("Reflect.setPrototypeOf()")}}, no exception will be thrown.\n\n```js\nconst handlerReturnsFalse = {\n  setPrototypeOf(target, newProto) {\n    return false;\n  },\n};\n\nconst newProto = {},\n  target = {};\n\nconst p1 = new Proxy(target, handlerReturnsFalse);\nObject.setPrototypeOf(p1, newProto); // throws a TypeError\nReflect.setPrototypeOf(p1, newProto); // returns false\n```\n\n### Approach 2: Throwing an Exception\n\nThe latter approach will cause _any_ operation that attempts to mutate, to\nthrow. This approach is best if you want even non-throwing operations to throw on\nfailure, or you want to throw a custom exception value.\n\n```js\nconst handlerThrows = {\n  setPrototypeOf(target, newProto) {\n    throw new Error("custom error");\n  },\n};\n\nconst newProto = {},\n  target = {};\n\nconst p2 = new Proxy(target, handlerThrows);\nObject.setPrototypeOf(p2, newProto); // throws new Error("custom error")\nReflect.setPrototypeOf(p2, newProto); // throws new Error("custom error")\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Proxy")}}\n- [`Proxy()` constructor](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Proxy/Proxy)\n- {{jsxref("Object.setPrototypeOf()")}}\n- {{jsxref("Reflect.setPrototypeOf()")}}\n'
            }
        },
        "revocable": {
            "index.md": '---\ntitle: Proxy.revocable()\nslug: Web/JavaScript/Reference/Global_Objects/Proxy/revocable\npage-type: javascript-static-method\nbrowser-compat: javascript.builtins.Proxy.revocable\n---\n\n{{JSRef}}\n\nThe **`Proxy.revocable()`** static method creates a revocable {{jsxref("Proxy")}} object.\n\n## Syntax\n\n```js-nolint\nProxy.revocable(target, handler)\n```\n\n### Parameters\n\n- `target`\n  - : A target object to wrap with `Proxy`. It can be any sort of object, including a native array, a function, or even another proxy.\n- `handler`\n  - : An object whose properties are functions defining the behavior of `proxy` when an operation is performed on it.\n\n### Return value\n\nA plain object with the following two properties:\n\n- `proxy`\n  - : A Proxy object exactly the same as one created with a [`new Proxy(target, handler)`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Proxy/Proxy) call.\n- `revoke`\n  - : A function with no parameters to revoke (switch off) the `proxy`.\n\n## Description\n\nThe `Proxy.revocable()` factory function is the same as the [`Proxy()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Proxy/Proxy) constructor, except that in addition to creating a proxy object, it also creates a `revoke` function that can be called to disable the proxy. The proxy object and the `revoke` function are wrapped in a plain object.\n\nThe `revoke` function does not take any parameters, nor does it rely on the `this` value. The created `proxy` object is attached to the `revoke` function as a [private property](/en-US/docs/Web/JavaScript/Reference/Classes/Private_properties) that the `revoke` function accesses on itself when called (the existence of the private property is not observable from the outside, but it has implications on how garbage collection happens). The `proxy` object is _not_ captured within the [closure](/en-US/docs/Web/JavaScript/Closures) of the `revoke` function (which will make garbage collection of `proxy` impossible if `revoke` is still alive).\n\nAfter the `revoke()` function gets called, the proxy becomes unusable: any trap to a handler throws a {{jsxref("TypeError")}}. Once a proxy is revoked, it remains revoked, and calling `revoke()` again has no effect \u2014 in fact, the call to `revoke()` detaches the `proxy` object from the `revoke` function, so the `revoke` function will not be able to access the proxy again at all. If the proxy is not referenced elsewhere, it will then be eligible for garbage collection. The `revoke` function also detaches `target` and `handler` from the `proxy`, so if `target` is not referenced elsewhere, it will also be eligible for garbage collection, even when its proxy is still alive, since there\'s no longer a way to meaningfully interact with the target object.\n\nLetting users interact with an object through a revocable proxy allows you to [control the lifetime](/en-US/docs/Web/JavaScript/Memory_management) of the object exposed to the user \u2014 you can make the object garbage-collectable even when the user is still holding a reference to its proxy.\n\n## Examples\n\n### Using Proxy.revocable()\n\n```js\nconst revocable = Proxy.revocable(\n  {},\n  {\n    get(target, name) {\n      return `[[${name}]]`;\n    },\n  },\n);\nconst proxy = revocable.proxy;\nconsole.log(proxy.foo); // "[[foo]]"\n\nrevocable.revoke();\n\nconsole.log(proxy.foo); // TypeError is thrown\nproxy.foo = 1; // TypeError again\ndelete proxy.foo; // still TypeError\ntypeof proxy; // "object", typeof doesn\'t trigger any trap\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Proxy")}}\n'
        }
    },
    "rangeerror": {
        "index.md": '---\ntitle: RangeError\nslug: Web/JavaScript/Reference/Global_Objects/RangeError\npage-type: javascript-class\nbrowser-compat: javascript.builtins.RangeError\n---\n\n{{JSRef}}\n\nThe **`RangeError`** object indicates an error when a value is not in the set or range of allowed values.\n\n## Description\n\nA `RangeError` is thrown when trying to pass a value as an argument to a function that does not allow a range that includes the value.\n\nThis can be encountered when:\n\n- passing a value that is not one of the allowed string values to {{jsxref("String.prototype.normalize()")}}, or\n- when attempting to create an array of an illegal length with the {{jsxref("Array")}} constructor, or\n- when passing bad values to the numeric methods {{jsxref("Number.prototype.toExponential()")}}, {{jsxref("Number.prototype.toFixed()")}} or {{jsxref("Number.prototype.toPrecision()")}}.\n\n`RangeError` is a {{Glossary("serializable object")}}, so it can be cloned with {{domxref("structuredClone()")}} or copied between [Workers](/en-US/docs/Web/API/Worker) using {{domxref("Worker/postMessage()", "postMessage()")}}.\n\n`RangeError` is a subclass of {{jsxref("Error")}}.\n\n## Constructor\n\n- {{jsxref("RangeError/RangeError", "RangeError()")}}\n  - : Creates a new `RangeError` object.\n\n## Instance properties\n\n_Also inherits instance properties from its parent {{jsxref("Error")}}_.\n\nThese properties are defined on `RangeError.prototype` and shared by all `RangeError` instances.\n\n- {{jsxref("Object/constructor", "RangeError.prototype.constructor")}}\n  - : The constructor function that created the instance object. For `RangeError` instances, the initial value is the {{jsxref("RangeError/RangeError", "RangeError")}} constructor.\n- {{jsxref("Error/name", "RangeError.prototype.name")}}\n  - : Represents the name for the type of error. For `RangeError.prototype.name`, the initial value is `"RangeError"`.\n\n## Instance methods\n\n_Inherits instance methods from its parent {{jsxref("Error")}}_.\n\n## Examples\n\n### Using RangeError (for numeric values)\n\n```js\nfunction check(n) {\n  if (!(n >= -500 && n <= 500)) {\n    throw new RangeError("The argument must be between -500 and 500.");\n  }\n}\n\ntry {\n  check(2000);\n} catch (error) {\n  if (error instanceof RangeError) {\n    // Handle the error\n  }\n}\n```\n\n### Using RangeError (for non-numeric values)\n\n```js\nfunction check(value) {\n  if (!["apple", "banana", "carrot"].includes(value)) {\n    throw new RangeError(\n      \'The argument must be an "apple", "banana", or "carrot".\',\n    );\n  }\n}\n\ntry {\n  check("cabbage");\n} catch (error) {\n  if (error instanceof RangeError) {\n    // Handle the error\n  }\n}\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Error")}}\n- {{jsxref("Array")}}\n- {{jsxref("Number.prototype.toExponential()")}}\n- {{jsxref("Number.prototype.toFixed()")}}\n- {{jsxref("Number.prototype.toPrecision()")}}\n- {{jsxref("String.prototype.normalize()")}}\n',
        "rangeerror": {
            "index.md": '---\ntitle: RangeError() constructor\nslug: Web/JavaScript/Reference/Global_Objects/RangeError/RangeError\npage-type: javascript-constructor\nbrowser-compat: javascript.builtins.RangeError.RangeError\n---\n\n{{JSRef}}\n\nThe **`RangeError()`** constructor creates {{jsxref("RangeError")}} objects.\n\n## Syntax\n\n```js-nolint\nnew RangeError()\nnew RangeError(message)\nnew RangeError(message, options)\nnew RangeError(message, fileName)\nnew RangeError(message, fileName, lineNumber)\n\nRangeError()\nRangeError(message)\nRangeError(message, options)\nRangeError(message, fileName)\nRangeError(message, fileName, lineNumber)\n```\n\n> **Note:** `RangeError()` can be called with or without [`new`](/en-US/docs/Web/JavaScript/Reference/Operators/new). Both create a new `RangeError` instance.\n\n### Parameters\n\n- `message` {{optional_inline}}\n  - : Human-readable description of the error.\n- `options` {{optional_inline}}\n  - : An object that has the following properties:\n    - `cause` {{optional_inline}}\n      - : A property indicating the specific cause of the error.\n        When catching and re-throwing an error with a more-specific or useful error message, this property can be used to pass the original error.\n- `fileName` {{optional_inline}} {{non-standard_inline}}\n  - : The name of the file containing the code that caused the exception\n- `lineNumber` {{optional_inline}} {{non-standard_inline}}\n  - : The line number of the code that caused the exception\n\n## Examples\n\n### Using RangeError (for numeric values)\n\n```js\nfunction check(n) {\n  if (!(n >= -500 && n <= 500)) {\n    throw new RangeError("The argument must be between -500 and 500.");\n  }\n}\n\ntry {\n  check(2000);\n} catch (error) {\n  if (error instanceof RangeError) {\n    // Handle the error\n  }\n}\n```\n\n### Using RangeError (for non-numeric values)\n\n```js\nfunction check(value) {\n  if (!["apple", "banana", "carrot"].includes(value)) {\n    throw new RangeError(\n      \'The argument must be an "apple", "banana", or "carrot".\',\n    );\n  }\n}\n\ntry {\n  check("cabbage");\n} catch (error) {\n  if (error instanceof RangeError) {\n    // Handle the error\n  }\n}\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Error")}}\n- {{jsxref("Array")}}\n- {{jsxref("Number.prototype.toExponential()")}}\n- {{jsxref("Number.prototype.toFixed()")}}\n- {{jsxref("Number.prototype.toPrecision()")}}\n- {{jsxref("String.prototype.normalize()")}}\n'
        }
    },
    "referenceerror": {
        "index.md": '---\ntitle: ReferenceError\nslug: Web/JavaScript/Reference/Global_Objects/ReferenceError\npage-type: javascript-class\nbrowser-compat: javascript.builtins.ReferenceError\n---\n\n{{JSRef}}\n\nThe **`ReferenceError`** object represents an error when a variable that doesn\'t exist (or hasn\'t yet been initialized) in the current scope is referenced.\n\n`ReferenceError` is a {{Glossary("serializable object")}}, so it can be cloned with {{domxref("structuredClone()")}} or copied between [Workers](/en-US/docs/Web/API/Worker) using {{domxref("Worker/postMessage()", "postMessage()")}}.\n\n`ReferenceError` is a subclass of {{jsxref("Error")}}.\n\n## Constructor\n\n- {{jsxref("ReferenceError/ReferenceError", "ReferenceError()")}}\n  - : Creates a new `ReferenceError` object.\n\n## Instance properties\n\n_Also inherits instance properties from its parent {{jsxref("Error")}}_.\n\nThese properties are defined on `ReferenceError.prototype` and shared by all `ReferenceError` instances.\n\n- {{jsxref("Object/constructor", "ReferenceError.prototype.constructor")}}\n  - : The constructor function that created the instance object. For `ReferenceError` instances, the initial value is the {{jsxref("ReferenceError/ReferenceError", "ReferenceError")}} constructor.\n- {{jsxref("Error/name", "ReferenceError.prototype.name")}}\n  - : Represents the name for the type of error. For `ReferenceError.prototype.name`, the initial value is `"ReferenceError"`.\n\n## Instance methods\n\n_Inherits instance methods from its parent {{jsxref("Error")}}_.\n\n## Examples\n\n### Catching a ReferenceError\n\n```js\ntry {\n  let a = undefinedVariable;\n} catch (e) {\n  console.log(e instanceof ReferenceError); // true\n  console.log(e.message); // "undefinedVariable is not defined"\n  console.log(e.name); // "ReferenceError"\n  console.log(e.stack); // Stack of the error\n}\n```\n\n### Creating a ReferenceError\n\n```js\ntry {\n  throw new ReferenceError("Hello");\n} catch (e) {\n  console.log(e instanceof ReferenceError); // true\n  console.log(e.message); // "Hello"\n  console.log(e.name); // "ReferenceError"\n  console.log(e.stack); // Stack of the error\n}\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Error")}}\n',
        "referenceerror": {
            "index.md": '---\ntitle: ReferenceError() constructor\nslug: Web/JavaScript/Reference/Global_Objects/ReferenceError/ReferenceError\npage-type: javascript-constructor\nbrowser-compat: javascript.builtins.ReferenceError.ReferenceError\n---\n\n{{JSRef}}\n\nThe **`ReferenceError()`** constructor creates {{jsxref("ReferenceError")}} objects.\n\n## Syntax\n\n```js-nolint\nnew ReferenceError()\nnew ReferenceError(message)\nnew ReferenceError(message, options)\nnew ReferenceError(message, fileName)\nnew ReferenceError(message, fileName, lineNumber)\n\nReferenceError()\nReferenceError(message)\nReferenceError(message, options)\nReferenceError(message, fileName)\nReferenceError(message, fileName, lineNumber)\n```\n\n> **Note:** `ReferenceError()` can be called with or without [`new`](/en-US/docs/Web/JavaScript/Reference/Operators/new). Both create a new `ReferenceError` instance.\n\n### Parameters\n\n- `message` {{optional_inline}}\n  - : Human-readable description of the error.\n- `options` {{optional_inline}}\n  - : An object that has the following properties:\n    - `cause` {{optional_inline}}\n      - : A property indicating the specific cause of the error.\n        When catching and re-throwing an error with a more-specific or useful error message, this property can be used to pass the original error.\n- `fileName` {{optional_inline}} {{non-standard_inline}}\n  - : The name of the file containing the code that caused the exception.\n- `lineNumber` {{optional_inline}} {{non-standard_inline}}\n  - : The line number of the code that caused the exception\n\n## Examples\n\n### Catching a ReferenceError\n\n```js\ntry {\n  let a = undefinedVariable;\n} catch (e) {\n  console.log(e instanceof ReferenceError); // true\n  console.log(e.message); // "undefinedVariable is not defined"\n  console.log(e.name); // "ReferenceError"\n  console.log(e.stack); // Stack of the error\n}\n```\n\n### Creating a ReferenceError\n\n```js\ntry {\n  throw new ReferenceError("Hello");\n} catch (e) {\n  console.log(e instanceof ReferenceError); // true\n  console.log(e.message); // "Hello"\n  console.log(e.name); // "ReferenceError"\n  console.log(e.stack); // Stack of the error\n}\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Error")}}\n'
        }
    },
    "reflect": {
        "apply": {
            "index.md": '---\ntitle: Reflect.apply()\nslug: Web/JavaScript/Reference/Global_Objects/Reflect/apply\npage-type: javascript-static-method\nbrowser-compat: javascript.builtins.Reflect.apply\n---\n\n{{JSRef}}\n\nThe **`Reflect.apply()`** static method calls a target function with arguments as specified.\n\n{{EmbedInteractiveExample("pages/js/reflect-apply.html", "taller")}}\n\n## Syntax\n\n```js-nolint\nReflect.apply(target, thisArgument, argumentsList)\n```\n\n### Parameters\n\n- `target`\n  - : The target function to call.\n- `thisArgument`\n  - : The value of `this` provided for the call to `target`.\n- `argumentsList`\n  - : An [array-like object](/en-US/docs/Web/JavaScript/Guide/Indexed_collections#working_with_array-like_objects) specifying the arguments with which `target` should be called.\n\n### Return value\n\nThe result of calling the given `target` function with the specified `this` value and arguments.\n\n### Exceptions\n\n- {{jsxref("TypeError")}}\n  - : Thrown if `target` is not a function or `argumentsList` is not an object.\n\n## Description\n\n`Reflect.apply()` provides the reflective semantic of a function call. That is, `Reflect.apply(target, thisArgument, argumentsList)` is semantically equivalent to:\n\n```js\nMath.floor.apply(null, [1.75]);\nReflect.apply(Math.floor, null, [1.75]);\n```\n\nThe only differences are:\n\n- `Reflect.apply()` takes the function to call as the `target` parameter instead of the `this` context.\n- `Reflect.apply()` throws if `argumentsList` is omitted instead of defaulting to calling with no parameters.\n\n`Reflect.apply()` invokes the `[[Call]]` [object internal method](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Proxy#object_internal_methods) of `target`.\n\n## Examples\n\n### Using Reflect.apply()\n\n```js\nReflect.apply(Math.floor, undefined, [1.75]);\n// 1;\n\nReflect.apply(String.fromCharCode, undefined, [104, 101, 108, 108, 111]);\n// "hello"\n\nReflect.apply(RegExp.prototype.exec, /ab/, ["confabulation"]).index;\n// 4\n\nReflect.apply("".charAt, "ponies", [3]);\n// "i"\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Reflect.apply` in `core-js`](https://github.com/zloirock/core-js#ecmascript-reflect)\n- {{jsxref("Reflect")}}\n- {{jsxref("Function.prototype.apply()")}}\n- [`handler.apply()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Proxy/Proxy/apply)\n'
        },
        "construct": {
            "index.md": '---\ntitle: Reflect.construct()\nslug: Web/JavaScript/Reference/Global_Objects/Reflect/construct\npage-type: javascript-static-method\nbrowser-compat: javascript.builtins.Reflect.construct\n---\n\n{{JSRef}}\n\nThe **`Reflect.construct()`** static method is like the {{jsxref("Operators/new", "new")}} operator, but as a function. It is equivalent to calling `new target(...args)`. It gives also the added option to specify a different [`new.target`](/en-US/docs/Web/JavaScript/Reference/Operators/new.target) value.\n\n{{EmbedInteractiveExample("pages/js/reflect-construct.html", "taller")}}\n\n## Syntax\n\n```js-nolint\nReflect.construct(target, argumentsList)\nReflect.construct(target, argumentsList, newTarget)\n```\n\n### Parameters\n\n- `target`\n  - : The target function to call.\n- `argumentsList`\n  - : An [array-like object](/en-US/docs/Web/JavaScript/Guide/Indexed_collections#working_with_array-like_objects) specifying the arguments with which `target` should be called.\n- `newTarget` {{optional_inline}}\n  - : The value of [`new.target`](/en-US/docs/Web/JavaScript/Reference/Operators/new.target) operator, which usually specifies the prototype of the returned object. If `newTarget` is not present, its value defaults to `target`.\n\n### Return value\n\nA new instance of `target` (or `newTarget`, if present), initialized by `target` as a constructor with the given `argumentsList`.\n\n### Exceptions\n\n- {{jsxref("TypeError")}}\n  - : Thrown if `target` or `newTarget` is not a constructor, or if `argumentsList` is not an object.\n\n## Description\n\n`Reflect.apply()` provides the reflective semantic of a constructor call. That is, `Reflect.construct(target, argumentsList, newTarget)` is semantically equivalent to:\n\n```js\nnew target(...argumentsList);\n```\n\nNote that when using the `new` operator, `target` and `newTarget` are always the same constructor \u2014 but `Reflect.construct()` allows you to pass a different [`new.target`](/en-US/docs/Web/JavaScript/Reference/Operators/new.target) value. Conceptually, `newTarget` is the function on which `new` was called, and `newTarget.prototype` will become the constructed object\'s prototype, while `target` is the constructor that is actually executed to initialize the object. For example, `new.target` may also be different from the currently executed constructor in class inheritance.\n\n```js\nclass A {\n  constructor() {\n    console.log(new.target.name);\n  }\n}\nclass B extends A {}\n\nnew B(); // "B"\n```\n\n`Reflect.construct()` allows you to invoke a constructor with a variable number of arguments. (This is also possible with the [spread syntax](/en-US/docs/Web/JavaScript/Reference/Operators/Spread_syntax) in a normal constructor call.)\n\n```js\nconst obj = new Foo(...args);\nconst obj = Reflect.construct(Foo, args);\n```\n\n`Reflect.construct()` invokes the `[[Construct]]` [object internal method](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Proxy#object_internal_methods) of `target`.\n\n## Examples\n\n### Using Reflect.construct()\n\n```js\nconst d = Reflect.construct(Date, [1776, 6, 4]);\nd instanceof Date; // true\nd.getFullYear(); // 1776\n```\n\n### Reflect.construct() vs. Object.create()\n\nPrior to the introduction of `Reflect`, objects could be constructed using an arbitrary combination of constructors and prototypes using {{jsxref("Object.create()")}}.\n\n```js\nfunction OneClass() {\n  this.name = "one";\n}\n\nfunction OtherClass() {\n  this.name = "other";\n}\n\nconst obj2 = Object.create(OtherClass.prototype);\nOneClass.apply(obj2, args);\n\nconsole.log(obj1.name); // \'one\'\nconsole.log(obj2.name); // \'one\'\n\nconsole.log(obj1 instanceof OneClass); // false\nconsole.log(obj2 instanceof OneClass); // false\n\nconsole.log(obj1 instanceof OtherClass); // true\nconsole.log(obj2 instanceof OtherClass); // true\n\n// Another example to demonstrate below:\n\nfunction func1(a, b, c, d) {\n  console.log(arguments[3]);\n}\n\nfunction func2(d, e, f, g) {\n  console.log(arguments[3]);\n}\n\nconst obj1 = Reflect.construct(func1, ["I", "Love", "my", "country"]);\n```\n\nHowever, while the end result is the same, there is one important difference in the process. When using `Object.create()` and {{jsxref("Function.prototype.apply()")}}, the `new.target` operator will point to `undefined` within the function used as the constructor, since the `new` keyword is not being used to create the object. (In fact, it uses the [`apply`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Reflect/apply) semantic, not `construct`, although normal functions happen to operate nearly the same.)\n\nWhen invoking `Reflect.construct()`, on the other hand, the `new.target` operator will point to the `newTarget` parameter if supplied, or `target` if not.\n\n```js\nfunction OneClass() {\n  console.log("OneClass");\n  console.log(new.target);\n}\nfunction OtherClass() {\n  console.log("OtherClass");\n  console.log(new.target);\n}\n\nconst obj1 = Reflect.construct(OneClass, args);\n// Logs:\n// OneClass\n// function OneClass { ... }\n\nconst obj2 = Reflect.construct(OneClass, args, OtherClass);\n// Logs:\n// OneClass\n// function OtherClass { ... }\n\nconst obj3 = Object.create(OtherClass.prototype);\nOneClass.apply(obj3, args);\n// Output:\n//     OneClass\n//     undefined\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Reflect.construct` in `core-js`](https://github.com/zloirock/core-js#ecmascript-reflect)\n- {{jsxref("Reflect")}}\n- {{jsxref("Operators/new", "new")}}\n- [`new.target`](/en-US/docs/Web/JavaScript/Reference/Operators/new.target)\n- [`handler.construct()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Proxy/Proxy/construct)\n'
        },
        "defineproperty": {
            "index.md": '---\ntitle: Reflect.defineProperty()\nslug: Web/JavaScript/Reference/Global_Objects/Reflect/defineProperty\npage-type: javascript-static-method\nbrowser-compat: javascript.builtins.Reflect.defineProperty\n---\n\n{{JSRef}}\n\nThe **`Reflect.defineProperty()`** static method is like {{jsxref("Object.defineProperty()")}} but returns a {{jsxref("Boolean")}}.\n\n{{EmbedInteractiveExample("pages/js/reflect-defineproperty.html")}}\n\n## Syntax\n\n```js-nolint\nReflect.defineProperty(target, propertyKey, attributes)\n```\n\n### Parameters\n\n- `target`\n  - : The target object on which to define the property.\n- `propertyKey`\n  - : The name of the property to be defined or modified.\n- `attributes`\n  - : The attributes for the property being defined or modified.\n\n### Return value\n\nA boolean indicating whether or not the property was successfully defined.\n\n### Exceptions\n\n- {{jsxref("TypeError")}}\n  - : Thrown if `target` or `attributes` is not an object.\n\n## Description\n\n`Reflect.defineProperty()` provides the reflective semantic of defining an own property on an object. At the very low level, defining a property returns a boolean (as is the case with [the proxy handler](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Proxy/Proxy/defineProperty)). {{jsxref("Object.defineProperty()")}} provides nearly the same semantic, but it throws a {{jsxref("TypeError")}} if the status is `false` (the operation was unsuccessful), while `Reflect.defineProperty()` directly returns the status.\n\nMany built-in operations would also define own properties on objects. The most significant difference between defining properties and [setting](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Reflect/set) them is that [setters](/en-US/docs/Web/JavaScript/Reference/Functions/set) aren\'t invoked. For example, [class fields](/en-US/docs/Web/JavaScript/Reference/Classes/Public_class_fields) directly define properties on the instance without invoking setters.\n\n```js\nclass B extends class A {\n  set a(v) {\n    console.log("Setter called");\n  }\n} {\n  a = 1; // Nothing logged\n}\n```\n\n`Reflect.defineProperty()` invokes the `[[DefineOwnProperty]]` [object internal method](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Proxy#object_internal_methods) of `target`.\n\n## Examples\n\n### Using Reflect.defineProperty()\n\n```js\nconst obj = {};\nReflect.defineProperty(obj, "x", { value: 7 }); // true\nconsole.log(obj.x); // 7\n```\n\n### Checking if property definition has been successful\n\nWith {{jsxref("Object.defineProperty()")}}, which returns an object if successful, or throws a {{jsxref("TypeError")}} otherwise, you would use a [`try...catch`](/en-US/docs/Web/JavaScript/Reference/Statements/try...catch) block to catch any error that occurred while defining a property.\n\nBecause `Reflect.defineProperty()` returns a Boolean success status, you can just use an [`if...else`](/en-US/docs/Web/JavaScript/Reference/Statements/if...else) block here:\n\n```js\nif (Reflect.defineProperty(target, property, attributes)) {\n  // success\n} else {\n  // failure\n}\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Reflect.defineProperty` in `core-js`](https://github.com/zloirock/core-js#ecmascript-reflect)\n- {{jsxref("Reflect")}}\n- {{jsxref("Object.defineProperty()")}}\n- [`handler.defineProperty()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Proxy/Proxy/defineProperty)\n'
        },
        "deleteproperty": {
            "index.md": '---\ntitle: Reflect.deleteProperty()\nslug: Web/JavaScript/Reference/Global_Objects/Reflect/deleteProperty\npage-type: javascript-static-method\nbrowser-compat: javascript.builtins.Reflect.deleteProperty\n---\n\n{{JSRef}}\n\nThe **`Reflect.deleteProperty()`** static method is like the {{jsxref("Operators/delete", "delete")}} operator, but as a function. It deletes a property from an object.\n\n{{EmbedInteractiveExample("pages/js/reflect-deleteproperty.html", "taller")}}\n\n## Syntax\n\n```js-nolint\nReflect.deleteProperty(target, propertyKey)\n```\n\n### Parameters\n\n- `target`\n  - : The target object on which to delete the property.\n- `propertyKey`\n  - : The name of the property to be deleted.\n\n### Return value\n\nA boolean indicating whether or not the property was successfully deleted.\n\n### Exceptions\n\n- {{jsxref("TypeError")}}\n  - : Thrown if `target` is not an object.\n\n## Description\n\n`Reflect.deleteProperty()` provides the reflective semantic of the [`delete`](/en-US/docs/Web/JavaScript/Reference/Operators/delete) operator. That is, `Reflect.deleteProperty(target, propertyKey)` is semantically equivalent to:\n\n```js\ndelete target.propertyKey;\n```\n\nAt the very low level, deleting a property returns a boolean (as is the case with [the proxy handler](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Proxy/Proxy/deleteProperty)). `Reflect.deleteProperty()` directly returns the status, while `delete` would throw a {{jsxref("TypeError")}} in [strict mode](/en-US/docs/Web/JavaScript/Reference/Strict_mode) if the status is `false`. In non-strict mode, `delete` and `Reflect.deleteProperty()` have the same behavior.\n\n`Reflect.deleteProperty()` invokes the `[[Delete]]` [object internal method](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Proxy#object_internal_methods) of `target`.\n\n## Examples\n\n### Using Reflect.deleteProperty()\n\n```js\nconst obj = { x: 1, y: 2 };\nReflect.deleteProperty(obj, "x"); // true\nconsole.log(obj); // { y: 2 }\n\nconst arr = [1, 2, 3, 4, 5];\nReflect.deleteProperty(arr, "3"); // true\nconsole.log(arr); // [1, 2, 3, undefined, 5]\n\n// Returns true if no such property exists\nReflect.deleteProperty({}, "foo"); // true\n\n// Returns false if a property is unconfigurable\nReflect.deleteProperty(Object.freeze({ foo: 1 }), "foo"); // false\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Reflect.deleteProperty` in `core-js`](https://github.com/zloirock/core-js#ecmascript-reflect)\n- {{jsxref("Reflect")}}\n- [`delete`](/en-US/docs/Web/JavaScript/Reference/Operators/delete)\n- [`handler.deleteProperty()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Proxy/Proxy/deleteProperty)\n'
        },
        "get": {
            "index.md": '---\ntitle: Reflect.get()\nslug: Web/JavaScript/Reference/Global_Objects/Reflect/get\npage-type: javascript-static-method\nbrowser-compat: javascript.builtins.Reflect.get\n---\n\n{{JSRef}}\n\nThe **`Reflect.get()`** static method is like the [property accessor](/en-US/docs/Web/JavaScript/Reference/Operators/Property_accessors) syntax, but as a function.\n\n{{EmbedInteractiveExample("pages/js/reflect-get.html")}}\n\n## Syntax\n\n```js-nolint\nReflect.get(target, propertyKey)\nReflect.get(target, propertyKey, receiver)\n```\n\n### Parameters\n\n- `target`\n  - : The target object on which to get the property.\n- `propertyKey`\n  - : The name of the property to get.\n- `receiver` {{optional_inline}}\n  - : The value of `this` provided for the call to `target` if a getter is encountered.\n\n### Return value\n\nThe value of the property.\n\n### Exceptions\n\n- {{jsxref("TypeError")}}\n  - : Thrown if `target` is not an object.\n\n## Description\n\n`Reflect.get()` provides the reflective semantic of a [property access](/en-US/docs/Web/JavaScript/Reference/Operators/Property_accessors). That is, `Reflect.get(target, propertyKey, receiver)` is semantically equivalent to:\n\n```js\ntarget[propertyKey];\n```\n\nNote that in a normal property access, `target` and `receiver` would observably be the same object.\n\n`Reflect.get()` invokes the `[[Get]]` [object internal method](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Proxy#object_internal_methods) of `target`.\n\n## Examples\n\n### Using Reflect.get()\n\n```js\n// Object\nconst obj1 = { x: 1, y: 2 };\nReflect.get(obj1, "x"); // 1\n\n// Array\nReflect.get(["zero", "one"], 1); // "one"\n\n// Proxy with a get handler\nconst obj2 = new Proxy(\n  { p: 1 },\n  {\n    get(t, k, r) {\n      return k + "bar";\n    },\n  },\n);\nReflect.get(obj2, "foo"); // "foobar"\n\n// Proxy with get handler and receiver\nconst obj3 = new Proxy(\n  { p: 1, foo: 2 },\n  {\n    get(t, prop, receiver) {\n      return receiver[prop] + "bar";\n    },\n  },\n);\nReflect.get(obj3, "foo", { foo: 3 }); // "3bar"\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Reflect.get` in `core-js`](https://github.com/zloirock/core-js#ecmascript-reflect)\n- {{jsxref("Reflect")}}\n- [Property accessors](/en-US/docs/Web/JavaScript/Reference/Operators/Property_accessors)\n- [`handler.get()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Proxy/Proxy/get)\n'
        },
        "getownpropertydescriptor": {
            "index.md": '---\ntitle: Reflect.getOwnPropertyDescriptor()\nslug: Web/JavaScript/Reference/Global_Objects/Reflect/getOwnPropertyDescriptor\npage-type: javascript-static-method\nbrowser-compat: javascript.builtins.Reflect.getOwnPropertyDescriptor\n---\n\n{{JSRef}}\n\nThe **`Reflect.getOwnPropertyDescriptor()`** static method is like {{jsxref("Object.getOwnPropertyDescriptor()")}}. It returns a property descriptor of the given property if it exists on the object, {{jsxref("undefined")}} otherwise.\n\n{{EmbedInteractiveExample("pages/js/reflect-getownpropertydescriptor.html")}}\n\n## Syntax\n\n```js-nolint\nReflect.getOwnPropertyDescriptor(target, propertyKey)\n```\n\n### Parameters\n\n- `target`\n  - : The target object in which to look for the property.\n- `propertyKey`\n  - : The name of the property to get an own property descriptor for.\n\n### Return value\n\nA property descriptor object if the property exists as an own property of `target`; otherwise, {{jsxref("undefined")}}.\n\n### Exceptions\n\n- {{jsxref("TypeError")}}\n  - : Thrown if `target` is not an object.\n\n## Description\n\n`Reflect.getOwnPropertyDescriptor()` provides the reflective semantic of retrieving the property descriptor of an object. The only difference with {{jsxref("Object.getOwnPropertyDescriptor()")}} is how non-object targets are handled. `Reflect.getOwnPropertyDescriptor()` throws a {{jsxref("TypeError")}} if the target is not an object, while `Object.getOwnPropertyDescriptor()` coerces it to an object.\n\n`Reflect.getOwnPropertyDescriptor()` invokes the `[[GetOwnProperty]]` [object internal method](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Proxy#object_internal_methods) of `target`.\n\n## Examples\n\n### Using Reflect.getOwnPropertyDescriptor()\n\n```js\nReflect.getOwnPropertyDescriptor({ x: "hello" }, "x");\n// {value: "hello", writable: true, enumerable: true, configurable: true}\n\nReflect.getOwnPropertyDescriptor({ x: "hello" }, "y");\n// undefined\n\nReflect.getOwnPropertyDescriptor([], "length");\n// {value: 0, writable: true, enumerable: false, configurable: false}\n```\n\n### Difference with Object.getOwnPropertyDescriptor()\n\nIf the `target` argument to this method is not an object (a primitive), then it will cause a {{jsxref("TypeError")}}. With {{jsxref("Object.getOwnPropertyDescriptor")}}, a non-object first argument will be coerced to an object at first.\n\n```js\nReflect.getOwnPropertyDescriptor("foo", 0);\n// TypeError: "foo" is not non-null object\n\nObject.getOwnPropertyDescriptor("foo", 0);\n// { value: "f", writable: false, enumerable: true, configurable: false }\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Reflect.getOwnPropertyDescriptor` in `core-js`](https://github.com/zloirock/core-js#ecmascript-reflect)\n- {{jsxref("Reflect")}}\n- {{jsxref("Object.getOwnPropertyDescriptor()")}}\n- [`handler.getOwnPropertyDescriptor()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Proxy/Proxy/getOwnPropertyDescriptor)\n'
        },
        "getprototypeof": {
            "index.md": '---\ntitle: Reflect.getPrototypeOf()\nslug: Web/JavaScript/Reference/Global_Objects/Reflect/getPrototypeOf\npage-type: javascript-static-method\nbrowser-compat: javascript.builtins.Reflect.getPrototypeOf\n---\n\n{{JSRef}}\n\nThe **`Reflect.getPrototypeOf()`** static method is like {{jsxref("Object.getPrototypeOf()")}}. It returns the prototype of the specified object.\n\n{{EmbedInteractiveExample("pages/js/reflect-getprototypeof.html")}}\n\n## Syntax\n\n```js-nolint\nReflect.getPrototypeOf(target)\n```\n\n### Parameters\n\n- `target`\n  - : The target object of which to get the prototype.\n\n### Return value\n\nThe prototype of the given object, which may be an object or `null`.\n\n### Exceptions\n\n- {{jsxref("TypeError")}}\n  - : Thrown if `target` is not an object.\n\n## Description\n\n`Reflect.getPrototypeOf()` provides the reflective semantic of retrieving the prototype of an object. The only difference with {{jsxref("Object.getPrototypeOf()")}} is how non-object targets are handled. `Reflect.getPrototypeOf()` throws a {{jsxref("TypeError")}} if the target is not an object, while `Object.getPrototypeOf()` coerces it to an object.\n\n`Reflect.getPrototypeOf()` invokes the `[[GetPrototypeOf]]` [object internal method](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Proxy#object_internal_methods) of `target`.\n\n## Examples\n\n### Using Reflect.getPrototypeOf()\n\n```js\nReflect.getPrototypeOf({}); // Object.prototype\nReflect.getPrototypeOf(Object.prototype); // null\nReflect.getPrototypeOf(Object.create(null)); // null\n```\n\n### Difference with Object.getPrototypeOf()\n\n```js\n// Same result for Objects\nObject.getPrototypeOf({}); // Object.prototype\nReflect.getPrototypeOf({}); // Object.prototype\n\n// Both throw in ES5 for non-Objects\nObject.getPrototypeOf("foo"); // Throws TypeError\nReflect.getPrototypeOf("foo"); // Throws TypeError\n\n// In ES2015 only Reflect throws, Object coerces non-Objects\nObject.getPrototypeOf("foo"); // String.prototype\nReflect.getPrototypeOf("foo"); // Throws TypeError\n\n// To mimic the Object ES2015 behavior you need to coerce\nReflect.getPrototypeOf(Object("foo")); // String.prototype\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Reflect.getPrototypeOf` in `core-js`](https://github.com/zloirock/core-js#ecmascript-reflect)\n- {{jsxref("Reflect")}}\n- {{jsxref("Object.getPrototypeOf()")}}\n- [`handler.getPrototypeOf()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Proxy/Proxy/getPrototypeOf)\n'
        },
        "has": {
            "index.md": '---\ntitle: Reflect.has()\nslug: Web/JavaScript/Reference/Global_Objects/Reflect/has\npage-type: javascript-static-method\nbrowser-compat: javascript.builtins.Reflect.has\n---\n\n{{JSRef}}\n\nThe **`Reflect.has()`** static method is like the [`in`](/en-US/docs/Web/JavaScript/Reference/Operators/in) operator, but\nas a function.\n\n{{EmbedInteractiveExample("pages/js/reflect-has.html")}}\n\n## Syntax\n\n```js-nolint\nReflect.has(target, propertyKey)\n```\n\n### Parameters\n\n- `target`\n  - : The target object in which to look for the property.\n- `propertyKey`\n  - : The name of the property to check.\n\n### Return value\n\nA {{jsxref("Boolean")}} indicating whether or not the `target` has the property.\n\n### Exceptions\n\n- {{jsxref("TypeError")}}\n  - : Thrown if `target` is not an object.\n\n## Description\n\n`Reflect.has()` provides the reflective semantic of checking if a property is in an object. That is, `Reflect.has(target, propertyKey)` is semantically equivalent to:\n\n```js\npropertyKey in target;\n```\n\n`Reflect.has()` invokes the `[[HasProperty]]` [object internal method](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Proxy#object_internal_methods) of `target`.\n\n## Examples\n\n### Using Reflect.has()\n\n```js\nReflect.has({ x: 0 }, "x"); // true\nReflect.has({ x: 0 }, "y"); // false\n\n// returns true for properties in the prototype chain\nReflect.has({ x: 0 }, "toString");\n\n// Proxy with .has() handler method\nobj = new Proxy(\n  {},\n  {\n    has(t, k) {\n      return k.startsWith("door");\n    },\n  },\n);\nReflect.has(obj, "doorbell"); // true\nReflect.has(obj, "dormitory"); // false\n```\n\n`Reflect.has` returns `true` for any inherited properties, like the [`in`](/en-US/docs/Web/JavaScript/Reference/Operators/in) operator:\n\n```js\nconst a = { foo: 123 };\nconst b = { __proto__: a };\nconst c = { __proto__: b };\n// The prototype chain is: c -> b -> a\nReflect.has(c, "foo"); // true\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Reflect.has` in `core-js`](https://github.com/zloirock/core-js#ecmascript-reflect)\n- {{jsxref("Reflect")}}\n- [`in`](/en-US/docs/Web/JavaScript/Reference/Operators/in)\n- [`handler.has()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Proxy/Proxy/has)\n'
        },
        "index.md": '---\ntitle: Reflect\nslug: Web/JavaScript/Reference/Global_Objects/Reflect\npage-type: javascript-namespace\nbrowser-compat: javascript.builtins.Reflect\n---\n\n{{JSRef}}\n\nThe **`Reflect`** namespace object contains static methods for invoking interceptable JavaScript object internal methods. The methods are the same as those of [proxy handlers](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Proxy/Proxy).\n\n## Description\n\nUnlike most global objects, `Reflect` is not a constructor. You cannot use it with the [`new` operator](/en-US/docs/Web/JavaScript/Reference/Operators/new) or invoke the `Reflect` object as a function. All properties and methods of `Reflect` are static (just like the {{jsxref("Math")}} object).\n\nThe `Reflect` object provides a collection of static functions which have the same names as the [proxy handler methods](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Proxy/Proxy).\n\nThe major use case of `Reflect` is to provide default forwarding behavior in `Proxy` handler traps. A [trap](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Proxy#terminology) is used to intercept an operation on an object \u2014 it provides a custom implementation for an [object internal method](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Proxy#object_internal_methods). The `Reflect` API is used to invoke the corresponding internal method. For example, the code below creates a proxy `p` with a [`deleteProperty`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Proxy/Proxy/deleteProperty) trap that intercepts the `[[Delete]]` internal method. `Reflect.deleteProperty()` is used to invoke the default `[[Delete]]` behavior on `targetObject` directly. You can replace it with [`delete`](/en-US/docs/Web/JavaScript/Reference/Operators/delete), but using `Reflect` saves you from having to remember the syntax that each internal method corresponds to.\n\n```js\nconst p = new Proxy(\n  {},\n  {\n    deleteProperty(targetObject, property) {\n      // Custom functionality: log the deletion\n      console.log("Deleting property:", property);\n\n      // Execute the default introspection behavior\n      return Reflect.deleteProperty(targetObject, property);\n    },\n  },\n);\n```\n\nThe `Reflect` methods also allow finer control of how the internal method is invoked. For example, {{jsxref("Reflect.construct()")}} is the only way to construct a target function with a specific [`new.target`](/en-US/docs/Web/JavaScript/Reference/Operators/new.target) value. If you use the [`new`](/en-US/docs/Web/JavaScript/Reference/Operators/new) operator to invoke a function, the `new.target` value is always the function itself. This has important effects with [subclassing](/en-US/docs/Web/JavaScript/Reference/Operators/new.target#new.target_using_reflect.construct). For another example, {{jsxref("Reflect.get()")}} allows you to run a [getter](/en-US/docs/Web/JavaScript/Reference/Functions/get) with a custom `this` value, while [property accessors](/en-US/docs/Web/JavaScript/Reference/Operators/Property_accessors) always use the current object as the `this` value.\n\nNearly every `Reflect` method\'s behavior can be done with some other syntax or method. Some of these methods have corresponding static methods of the same name on {{jsxref("Object")}}, although they do have some subtle differences. For the exact differences, see the description for each `Reflect` method.\n\n## Static properties\n\n- `Reflect[@@toStringTag]`\n  - : The initial value of the [`@@toStringTag`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol/toStringTag) property is the string `"Reflect"`. This property is used in {{jsxref("Object.prototype.toString()")}}.\n\n## Static methods\n\n- {{jsxref("Reflect.apply()")}}\n  - : Calls a `target` function with arguments as specified by the `argumentsList` parameter. See also {{jsxref("Function.prototype.apply()")}}.\n- {{jsxref("Reflect.construct()")}}\n  - : The [`new` operator](/en-US/docs/Web/JavaScript/Reference/Operators/new) as a function. Equivalent to calling `new target(...argumentsList)`. Also provides the option to specify a different prototype.\n- {{jsxref("Reflect.defineProperty()")}}\n  - : Similar to {{jsxref("Object.defineProperty()")}}. Returns a boolean that is `true` if the property was successfully defined.\n- {{jsxref("Reflect.deleteProperty()")}}\n  - : The [`delete` operator](/en-US/docs/Web/JavaScript/Reference/Operators/delete) as a function. Equivalent to calling `delete target[propertyKey]`.\n- {{jsxref("Reflect.get()")}}\n  - : Returns the value of the property. Works like getting a property from an object (`target[propertyKey]`) as a function.\n- {{jsxref("Reflect.getOwnPropertyDescriptor()")}}\n  - : Similar to {{jsxref("Object.getOwnPropertyDescriptor()")}}. Returns a property descriptor of the given property if it exists on the object, {{jsxref("undefined")}} otherwise.\n- {{jsxref("Reflect.getPrototypeOf()")}}\n  - : Same as {{jsxref("Object.getPrototypeOf()")}}.\n- {{jsxref("Reflect.has()")}}\n  - : Returns a boolean indicating whether the target has the property. Either as own or inherited. Works like the [`in` operator](/en-US/docs/Web/JavaScript/Reference/Operators/in) as a function.\n- {{jsxref("Reflect.isExtensible()")}}\n  - : Same as {{jsxref("Object.isExtensible()")}}. Returns a boolean that is `true` if the target is extensible.\n- {{jsxref("Reflect.ownKeys()")}}\n  - : Returns an array of the target object\'s own (not inherited) property keys.\n- {{jsxref("Reflect.preventExtensions()")}}\n  - : Similar to {{jsxref("Object.preventExtensions()")}}. Returns a boolean that is `true` if the update was successful.\n- {{jsxref("Reflect.set()")}}\n  - : A function that assigns values to properties. Returns a boolean that is `true` if the update was successful.\n- {{jsxref("Reflect.setPrototypeOf()")}}\n  - : A function that sets the prototype of an object. Returns a boolean that is `true` if the update was successful.\n\n## Examples\n\n### Detecting whether an object contains certain properties\n\n```js\nconst duck = {\n  name: "Maurice",\n  color: "white",\n  greeting() {\n    console.log(`Quaaaack! My name is ${this.name}`);\n  },\n};\n\nReflect.has(duck, "color");\n// true\nReflect.has(duck, "haircut");\n// false\n```\n\n### Returning the object\'s own keys\n\n```js\nReflect.ownKeys(duck);\n// [ "name", "color", "greeting" ]\n```\n\n### Adding a new property to the object\n\n```js\nReflect.set(duck, "eyes", "black");\n// returns "true" if successful\n// "duck" now contains the property "eyes: \'black\'"\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Proxy")}}\n',
        "isextensible": {
            "index.md": '---\ntitle: Reflect.isExtensible()\nslug: Web/JavaScript/Reference/Global_Objects/Reflect/isExtensible\npage-type: javascript-static-method\nbrowser-compat: javascript.builtins.Reflect.isExtensible\n---\n\n{{JSRef}}\n\nThe **`Reflect.isExtensible()`** static method is like {{jsxref("Object.isExtensible()")}}. It determines if an object is extensible (whether it can have new properties added to it).\n\n{{EmbedInteractiveExample("pages/js/reflect-isextensible.html", "taller")}}\n\n## Syntax\n\n```js-nolint\nReflect.isExtensible(target)\n```\n\n### Parameters\n\n- `target`\n  - : The target object which to check if it is extensible.\n\n### Return value\n\nA {{jsxref("Boolean")}} indicating whether or not the target is extensible.\n\n### Exceptions\n\n- {{jsxref("TypeError")}}\n  - : Thrown if `target` is not an object.\n\n## Description\n\n`Reflect.isExtensible()` provides the reflective semantic of checking if an object is extensible. The only difference with {{jsxref("Object.isExtensible()")}} is how non-object targets are handled. `Reflect.isExtensible()` throws a {{jsxref("TypeError")}} if the target is not an object, while `Object.isExtensible()` always returns `false` for non-object targets.\n\n`Reflect.isExtensible()` invokes the `[[IsExtensible]]` [object internal method](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Proxy#object_internal_methods) of `target`.\n\n## Examples\n\n### Using Reflect.isExtensible()\n\nSee also {{jsxref("Object.isExtensible()")}}.\n\n```js\n// New objects are extensible.\nconst empty = {};\nReflect.isExtensible(empty); // true\n\n// ...but that can be changed.\nReflect.preventExtensions(empty);\nReflect.isExtensible(empty); // false\n\n// Sealed objects are by definition non-extensible.\nconst sealed = Object.seal({});\nReflect.isExtensible(sealed); // false\n\n// Frozen objects are also by definition non-extensible.\nconst frozen = Object.freeze({});\nReflect.isExtensible(frozen); // false\n```\n\n### Difference with Object.isExtensible()\n\nIf the `target` argument to this method is not an object (a primitive), then it will cause a {{jsxref("TypeError")}}. With {{jsxref("Object.isExtensible()")}}, a non-object `target` will return false without any errors.\n\n```js\nReflect.isExtensible(1);\n// TypeError: 1 is not an object\n\nObject.isExtensible(1);\n// false\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Reflect.isExtensible` in `core-js`](https://github.com/zloirock/core-js#ecmascript-reflect)\n- {{jsxref("Reflect")}}\n- {{jsxref("Object.isExtensible()")}}\n- [`handler.isExtensible()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Proxy/Proxy/isExtensible)\n'
        },
        "ownkeys": {
            "index.md": '---\ntitle: Reflect.ownKeys()\nslug: Web/JavaScript/Reference/Global_Objects/Reflect/ownKeys\npage-type: javascript-static-method\nbrowser-compat: javascript.builtins.Reflect.ownKeys\n---\n\n{{JSRef}}\n\nThe **`Reflect.ownKeys()`** static method returns an array of the `target` object\'s own property keys.\n\n{{EmbedInteractiveExample("pages/js/reflect-ownkeys.html")}}\n\n## Syntax\n\n```js-nolint\nReflect.ownKeys(target)\n```\n\n### Parameters\n\n- `target`\n  - : The target object from which to get the own keys.\n\n### Return value\n\nAn {{jsxref("Array")}} of the `target` object\'s own property keys, including strings and symbols. For most objects, the array will be in the order of:\n\n1. Non-negative integer indexes in increasing numeric order (but as strings)\n2. Other string keys in the order of property creation\n3. Symbol keys in the order of property creation.\n\n### Exceptions\n\n- {{jsxref("TypeError")}}\n  - : Thrown if `target` is not an object.\n\n## Description\n\n`Reflect.ownKeys()` provides the reflective semantic of retrieving all property keys of an object. It is the only way to get all own properties \u2013 enumerable and not enumerable, strings and symbols \u2014 in one call, without extra filtering logic. For example, {{jsxref("Object.getOwnPropertyNames()")}} takes the return value of `Reflect.ownKeys()` and filters to only string values, while {{jsxref("Object.getOwnPropertySymbols()")}} filters to only symbol values. Because normal objects implement `[[OwnPropertyKeys]]` to return all string keys before symbol keys, `Reflect.ownKeys(target)` is usually equivalent to `Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target))`. However, if the object has a custom `[[OwnPropertyKeys]]` method (such as through a proxy\'s [`ownKeys`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Proxy/Proxy/ownKeys) handler), the order of the keys may be different.\n\n`Reflect.ownKeys()` invokes the `[[OwnPropertyKeys]]` [object internal method](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Proxy#object_internal_methods) of `target`.\n\n## Examples\n\n### Using Reflect.ownKeys()\n\n```js\nReflect.ownKeys({ z: 3, y: 2, x: 1 }); // [ "z", "y", "x" ]\nReflect.ownKeys([]); // ["length"]\n\nconst sym = Symbol.for("comet");\nconst sym2 = Symbol.for("meteor");\nconst obj = {\n  [sym]: 0,\n  str: 0,\n  773: 0,\n  0: 0,\n  [sym2]: 0,\n  "-1": 0,\n  8: 0,\n  "second str": 0,\n};\nReflect.ownKeys(obj);\n// [ "0", "8", "773", "str", "-1", "second str", Symbol(comet), Symbol(meteor) ]\n// Indexes in numeric order,\n// strings in insertion order,\n// symbols in insertion order\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Reflect.ownKeys` in `core-js`](https://github.com/zloirock/core-js#ecmascript-reflect)\n- {{jsxref("Reflect")}}\n- {{jsxref("Object.getOwnPropertyNames()")}}\n- {{jsxref("Object.getOwnPropertySymbols()")}}\n- [`handler.ownKeys()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Proxy/Proxy/ownKeys)\n'
        },
        "preventextensions": {
            "index.md": '---\ntitle: Reflect.preventExtensions()\nslug: Web/JavaScript/Reference/Global_Objects/Reflect/preventExtensions\npage-type: javascript-static-method\nbrowser-compat: javascript.builtins.Reflect.preventExtensions\n---\n\n{{JSRef}}\n\nThe **`Reflect.preventExtensions()`** static method is like {{jsxref("Object.preventExtensions()")}}. It prevents new properties from ever being added to an object (i.e., prevents future extensions to the object).\n\n{{EmbedInteractiveExample("pages/js/reflect-preventextensions.html")}}\n\n## Syntax\n\n```js-nolint\nReflect.preventExtensions(target)\n```\n\n### Parameters\n\n- `target`\n  - : The target object on which to prevent extensions.\n\n### Return value\n\nA {{jsxref("Boolean")}} indicating whether or not the target was successfully set to prevent extensions.\n\n### Exceptions\n\n- {{jsxref("TypeError")}}\n  - : Thrown if `target` is not an object.\n\n## Description\n\n`Reflect.preventExtensions()` provides the reflective semantic of preventing extensions of an object. The differences with {{jsxref("Object.preventExtensions()")}} are:\n\n- `Reflect.preventExtensions()` throws a {{jsxref("TypeError")}} if the target is not an object, while `Object.preventExtensions()` always returns non-object targets as-is.\n- `Reflect.preventExtensions()` returns a {{jsxref("Boolean")}} indicating whether or not the target was successfully set to prevent extensions, while `Object.preventExtensions()` returns the target object.\n\n`Reflect.preventExtensions()` invokes the `[[PreventExtensions]]` [object internal method](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Proxy#object_internal_methods) of `target`.\n\n## Examples\n\n### Using Reflect.preventExtensions()\n\nSee also {{jsxref("Object.preventExtensions()")}}.\n\n```js\n// Objects are extensible by default.\nconst empty = {};\nReflect.isExtensible(empty); // true\n\n// ...but that can be changed.\nReflect.preventExtensions(empty);\nReflect.isExtensible(empty); // false\n```\n\n### Difference with Object.preventExtensions()\n\nIf the `target` argument to this method is not an object (a primitive), then it will cause a {{jsxref("TypeError")}}. With {{jsxref("Object.preventExtensions()")}}, a non-object `target` will be returned as-is without any errors.\n\n```js\nReflect.preventExtensions(1);\n// TypeError: 1 is not an object\n\nObject.preventExtensions(1);\n// 1\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Reflect.preventExtensions` in `core-js`](https://github.com/zloirock/core-js#ecmascript-reflect)\n- {{jsxref("Reflect")}}\n- {{jsxref("Object.preventExtensions()")}}\n- [`handler.preventExtensions()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Proxy/Proxy/preventExtensions)\n'
        },
        "set": {
            "index.md": '---\ntitle: Reflect.set()\nslug: Web/JavaScript/Reference/Global_Objects/Reflect/set\npage-type: javascript-static-method\nbrowser-compat: javascript.builtins.Reflect.set\n---\n\n{{JSRef}}\n\nThe **`Reflect.set()`** static method is like the [property accessor](/en-US/docs/Web/JavaScript/Reference/Operators/Property_accessors) and [assignment](/en-US/docs/Web/JavaScript/Reference/Operators/Assignment) syntax, but as a function.\n\n{{EmbedInteractiveExample("pages/js/reflect-set.html")}}\n\n## Syntax\n\n```js-nolint\nReflect.set(target, propertyKey, value)\nReflect.set(target, propertyKey, value, receiver)\n```\n\n### Parameters\n\n- `target`\n  - : The target object on which to set the property.\n- `propertyKey`\n  - : The name of the property to set.\n- `value`\n  - : The value to set.\n- `receiver` {{optional_inline}}\n  - : The value of `this` provided for the call to the setter for `propertyKey` on `target`. If provided and `target` does not have a setter for `propertyKey`, the property will be set on `receiver` instead.\n\n### Return value\n\nA {{jsxref("Boolean")}} indicating whether or not setting the property was successful.\n\n### Exceptions\n\n- {{jsxref("TypeError")}}\n  - : Thrown if `target` is not an object.\n\n## Description\n\n`Reflect.set()` provides the reflective semantic of a [property access](/en-US/docs/Web/JavaScript/Reference/Operators/Property_accessors). That is, `Reflect.set(target, propertyKey, value, receiver)` is semantically equivalent to:\n\n```js\ntarget[propertyKey] = value;\n```\n\nNote that in a normal property access, `target` and `receiver` would observably be the same object.\n\n`Reflect.set()` invokes the `[[Set]]` [object internal method](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Proxy#object_internal_methods) of `target`.\n\n## Examples\n\n### Using Reflect.set()\n\n```js\n// Object\nconst obj = {};\nReflect.set(obj, "prop", "value"); // true\nobj.prop; // "value"\n\n// Array\nconst arr = ["duck", "duck", "duck"];\nReflect.set(arr, 2, "goose"); // true\narr[2]; // "goose"\n\n// It can truncate an array.\nReflect.set(arr, "length", 1); // true\narr; // ["duck"]\n\n// With just one argument, propertyKey and value are "undefined".\nReflect.set(obj); // true\nReflect.getOwnPropertyDescriptor(obj, "undefined");\n// { value: undefined, writable: true, enumerable: true, configurable: true }\n```\n\n### Different target and receiver\n\nWhen the `target` and `receiver` are different, `Reflect.set` will use the property descriptor of `target` (to find the setter or determine if the property is writable), but set the property on `receiver`.\n\n```js\nconst target = {};\nconst receiver = {};\nReflect.set(target, "a", 2, receiver); // true\n// target is {}; receiver is { a: 2 }\n\nconst target = { a: 1 };\nconst receiver = {};\nReflect.set(target, "a", 2, receiver); // true\n// target is { a: 1 }; receiver is { a: 2 }\n\nconst target = {\n  set a(v) {\n    this.b = v;\n  },\n};\nconst receiver = {};\nReflect.set(target, "a", 2, receiver); // true\n// target is { a: [Setter] }; receiver is { b: 2 }\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Reflect.set` in `core-js`](https://github.com/zloirock/core-js#ecmascript-reflect)\n- {{jsxref("Reflect")}}\n- [Property accessors](/en-US/docs/Web/JavaScript/Reference/Operators/Property_accessors)\n- [`handler.set()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Proxy/Proxy/set)\n'
        },
        "setprototypeof": {
            "index.md": '---\ntitle: Reflect.setPrototypeOf()\nslug: Web/JavaScript/Reference/Global_Objects/Reflect/setPrototypeOf\npage-type: javascript-static-method\nbrowser-compat: javascript.builtins.Reflect.setPrototypeOf\n---\n\n{{JSRef}}\n\nThe **`Reflect.setPrototypeOf()`** static method is like {{jsxref("Object.setPrototypeOf()")}} but returns a {{jsxref("Boolean")}}. It sets the prototype (i.e., the internal `[[Prototype]]` property) of a specified object.\n\n{{EmbedInteractiveExample("pages/js/reflect-setprototypeof.html")}}\n\n## Syntax\n\n```js-nolint\nReflect.setPrototypeOf(target, prototype)\n```\n\n### Parameters\n\n- `target`\n  - : The target object of which to set the prototype.\n- `prototype`\n  - : The object\'s new prototype (an object or [`null`](/en-US/docs/Web/JavaScript/Reference/Operators/null)).\n\n### Return value\n\nA {{jsxref("Boolean")}} indicating whether or not the prototype was successfully set.\n\n### Exceptions\n\n- {{jsxref("TypeError")}}\n  - : Thrown if `target` is not an object or if `prototype` is neither an object nor [`null`](/en-US/docs/Web/JavaScript/Reference/Operators/null).\n\n## Description\n\n`Reflect.setPrototypeOf()` provides the reflective semantic of setting the prototype of an object. At the very low level, setting the prototype returns a boolean (as is the case with [the proxy handler](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Proxy/Proxy/setPrototypeOf)). {{jsxref("Object.setPrototypeOf()")}} provides nearly the same semantic, but it throws a {{jsxref("TypeError")}} if the status is `false` (the operation was unsuccessful), while `Reflect.setPrototypeOf()` directly returns the status.\n\n`Reflect.setPrototypeOf()` invokes the `[[SetPrototypeOf]]` [object internal method](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Proxy#object_internal_methods) of `target`.\n\n## Examples\n\n### Using Reflect.setPrototypeOf()\n\n```js\nReflect.setPrototypeOf({}, Object.prototype); // true\n\n// It can change an object\'s [[Prototype]] to null.\nReflect.setPrototypeOf({}, null); // true\n\n// Returns false if target is not extensible.\nReflect.setPrototypeOf(Object.freeze({}), null); // false\n\n// Returns false if it cause a prototype chain cycle.\nconst target = {};\nconst proto = Object.create(target);\nReflect.setPrototypeOf(target, proto); // false\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Reflect.setPrototypeOf` in `core-js`](https://github.com/zloirock/core-js#ecmascript-reflect)\n- {{jsxref("Reflect")}}\n- {{jsxref("Object.setPrototypeOf()")}}\n- [`handler.setPrototypeOf()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Proxy/Proxy/setPrototypeOf)\n'
        }
    },
    "regexp": {
        "@@match": {
            "index.md": '---\ntitle: RegExp.prototype[@@match]()\nslug: Web/JavaScript/Reference/Global_Objects/RegExp/@@match\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.RegExp.@@match\n---\n\n{{JSRef}}\n\nThe **`[@@match]()`** method of {{jsxref("RegExp")}} instances specifies how [`String.prototype.match()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/match) should behave. In addition, its presence (or absence) can influence whether an object is regarded as a regular expression.\n\n{{EmbedInteractiveExample("pages/js/regexp-prototype-@@match.html")}}\n\n## Syntax\n\n```js-nolint\nregexp[Symbol.match](str)\n```\n\n### Parameters\n\n- `str`\n  - : A {{jsxref("String")}} that is a target of the match.\n\n### Return value\n\nAn {{jsxref("Array")}} whose contents depend on the presence or absence of the global (`g`) flag, or [`null`](/en-US/docs/Web/JavaScript/Reference/Operators/null) if no matches are found.\n\n- If the `g` flag is used, all results matching the complete regular expression will be returned, but capturing groups are not included.\n- If the `g` flag is not used, only the first complete match and its related capturing groups are returned. In this case, `match()` will return the same result as {{jsxref("RegExp.prototype.exec()")}} (an array with some extra properties).\n\n## Description\n\nThis method is called internally in {{jsxref("String.prototype.match()")}}.\n\nFor example, the following two examples return same result.\n\n```js\n"abc".match(/a/);\n\n/a/[Symbol.match]("abc");\n```\n\nIf the regex is global (with the `g` flag), the regex\'s [`exec()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/exec) method will be repeatedly called until `exec()` returns `null`. Otherwise, `exec()` would only be called once and its result becomes the return value of `@@match`.\n\nBecause `@@match` would keep calling `exec()` until it returns `null`, and `exec()` would automatically reset the regex\'s [`lastIndex`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/lastIndex) to 0 when the last match fails, `@@match` would typically not have side effects when it exits. However, when the regex is [sticky](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/sticky) but not global, `lastIndex` would not be reset. In this case, each call to `match()` may return a different result.\n\n```js\nconst re = /[abc]/y;\nfor (let i = 0; i < 5; i++) {\n  console.log("abc".match(re), re.lastIndex);\n}\n// [ \'a\' ] 1\n// [ \'b\' ] 2\n// [ \'c\' ] 3\n// null 0\n// [ \'a\' ] 1\n```\n\nWhen the regex is sticky and global, it would still perform sticky matches \u2014 i.e. it would fail to match any occurrences beyond the `lastIndex`.\n\n```js\nconsole.log("ab-c".match(/[abc]/gy)); // [ \'a\', \'b\' ]\n```\n\nIf the current match is an empty string, the `lastIndex` would still be advanced \u2014 if the regex is [Unicode-aware](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/unicode#unicode-aware_mode), it would advance by one Unicode code point; otherwise, it advances by one UTF-16 code unit.\n\n```js\nconsole.log("\uD83D\uDE04".match(/(?:)/g)); // [ \'\', \'\', \'\' ]\nconsole.log("\uD83D\uDE04".match(/(?:)/gu)); // [ \'\', \'\' ]\n```\n\nThis method exists for customizing match behavior within `RegExp` subclasses.\n\nIn addition, the `@@match` property is used to check [whether an object is a regular expression](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp#special_handling_for_regexes).\n\n## Examples\n\n### Direct call\n\nThis method can be used in _almost_ the same way as {{jsxref("String.prototype.match()")}}, except the different `this` and the different arguments order.\n\n```js\nconst re = /[0-9]+/g;\nconst str = "2016-01-02";\nconst result = re[Symbol.match](str);\nconsole.log(result); // ["2016", "01", "02"]\n```\n\n### Using @@match in subclasses\n\nSubclasses of {{jsxref("RegExp")}} can override the `[@@match]()` method to modify the default behavior.\n\n```js\nclass MyRegExp extends RegExp {\n  [Symbol.match](str) {\n    const result = RegExp.prototype[Symbol.match].call(this, str);\n    if (!result) return null;\n    return {\n      group(n) {\n        return result[n];\n      },\n    };\n  }\n}\n\nconst re = new MyRegExp("([0-9]+)-([0-9]+)-([0-9]+)");\nconst str = "2016-01-02";\nconst result = str.match(re); // String.prototype.match calls re[@@match].\nconsole.log(result.group(1)); // 2016\nconsole.log(result.group(2)); // 01\nconsole.log(result.group(3)); // 02\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `RegExp.prototype[@@match]` in `core-js`](https://github.com/zloirock/core-js#ecmascript-string-and-regexp)\n- {{jsxref("String.prototype.match()")}}\n- [`RegExp.prototype[@@matchAll]()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/@@matchAll)\n- [`RegExp.prototype[@@replace]()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/@@replace)\n- [`RegExp.prototype[@@search]()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/@@search)\n- [`RegExp.prototype[@@split]()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/@@split)\n- {{jsxref("RegExp.prototype.exec()")}}\n- {{jsxref("RegExp.prototype.test()")}}\n- {{jsxref("Symbol.match")}}\n'
        },
        "@@matchall": {
            "index.md": '---\ntitle: RegExp.prototype[@@matchAll]()\nslug: Web/JavaScript/Reference/Global_Objects/RegExp/@@matchAll\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.RegExp.@@matchAll\n---\n\n{{JSRef}}\n\nThe **`[@@matchAll]()`** method of {{jsxref("RegExp")}} instances specifies how [`String.prototype.matchAll`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/matchAll) should behave.\n\n{{EmbedInteractiveExample("pages/js/regexp-prototype-@@matchall.html", "taller")}}\n\n## Syntax\n\n```js-nolint\nregexp[Symbol.matchAll](str)\n```\n\n### Parameters\n\n- `str`\n  - : A {{jsxref("String")}} that is a target of the match.\n\n### Return value\n\nAn [iterable iterator object](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Iterator) (which is not restartable) of matches. Each match is an array with the same shape as the return value of {{jsxref("RegExp.prototype.exec()")}}.\n\n## Description\n\nThis method is called internally in {{jsxref("String.prototype.matchAll()")}}. For example, the following two examples return the same result.\n\n```js\n"abc".matchAll(/a/g);\n\n/a/g[Symbol.matchAll]("abc");\n```\n\nLike [`@@split`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/@@split), `@@matchAll` starts by using [`@@species`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/@@species) to construct a new regex, thus avoiding mutating the original regexp in any way. [`lastIndex`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/lastIndex) starts as the original regex\'s value.\n\n```js\nconst regexp = /[a-c]/g;\nregexp.lastIndex = 1;\nconst str = "abc";\nArray.from(str.matchAll(regexp), (m) => `${regexp.lastIndex} ${m[0]}`);\n// [ "1 b", "1 c" ]\n```\n\nThe validation that the input is a global regex happens in [`String.prototype.matchAll()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/matchAll). `@@matchAll` does not validate the input. If the regex is not global, the returned iterator yields the [`exec()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/exec) result once and then returns `undefined`. If the regexp is global, each time the returned iterator\'s `next()` method is called, the regex\'s [`exec()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/exec) is called and the result is yielded.\n\nWhen the regex is sticky and global, it will still perform sticky matches \u2014 i.e. it will not match any occurrences beyond the `lastIndex`.\n\n```js\nconsole.log(Array.from("ab-c".matchAll(/[abc]/gy)));\n// [ [ "a" ], [ "b" ] ]\n```\n\nIf the current match is an empty string, the [`lastIndex`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/lastIndex) will still be advanced. If the regex has the [`u`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/unicode) flag, it advances by one Unicode code point; otherwise, it advances by one UTF-16 code point.\n\n```js\nconsole.log(Array.from("\uD83D\uDE04".matchAll(/(?:)/g)));\n// [ [ "" ], [ "" ], [ "" ] ]\n\nconsole.log(Array.from("\uD83D\uDE04".matchAll(/(?:)/gu)));\n// [ [ "" ], [ "" ] ]\n```\n\nThis method exists for customizing the behavior of `matchAll()` in {{jsxref("RegExp")}} subclasses.\n\n## Examples\n\n### Direct call\n\nThis method can be used in almost the same way as {{jsxref("String.prototype.matchAll()")}}, except for the different value of `this` and the different order of arguments.\n\n```js\nconst re = /[0-9]+/g;\nconst str = "2016-01-02";\nconst result = re[Symbol.matchAll](str);\n\nconsole.log(Array.from(result, (x) => x[0]));\n// [ "2016", "01", "02" ]\n```\n\n### Using @@matchAll in subclasses\n\nSubclasses of {{jsxref("RegExp")}} can override the `[@@matchAll]()` method to modify the default behavior.\n\nFor example, to return an {{jsxref("Array")}} instead of an [iterator](/en-US/docs/Web/JavaScript/Guide/Iterators_and_generators):\n\n```js\nclass MyRegExp extends RegExp {\n  [Symbol.matchAll](str) {\n    const result = RegExp.prototype[Symbol.matchAll].call(this, str);\n    return result ? Array.from(result) : null;\n  }\n}\n\nconst re = new MyRegExp("([0-9]+)-([0-9]+)-([0-9]+)", "g");\nconst str = "2016-01-02|2019-03-07";\nconst result = str.matchAll(re);\n\nconsole.log(result[0]);\n// [ "2016-01-02", "2016", "01", "02" ]\n\nconsole.log(result[1]);\n// [ "2019-03-07", "2019", "03", "07" ]\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `RegExp.prototype[@@matchAll]` in `core-js`](https://github.com/zloirock/core-js#ecmascript-string-and-regexp)\n- {{jsxref("String.prototype.matchAll()")}}\n- [`RegExp.prototype[@@match]()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/@@match)\n- [`RegExp.prototype[@@replace]()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/@@replace)\n- [`RegExp.prototype[@@search]()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/@@search)\n- [`RegExp.prototype[@@split]()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/@@split)\n- {{jsxref("Symbol.matchAll")}}\n'
        },
        "@@replace": {
            "index.md": '---\ntitle: RegExp.prototype[@@replace]()\nslug: Web/JavaScript/Reference/Global_Objects/RegExp/@@replace\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.RegExp.@@replace\n---\n\n{{JSRef}}\n\nThe **`[@@replace]()`** method of {{jsxref("RegExp")}} instances specifies how [`String.prototype.replace()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/replace) and [`String.prototype.replaceAll()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/replaceAll) should behave when the regular expression is passed in as the pattern.\n\n{{EmbedInteractiveExample("pages/js/regexp-prototype-@@replace.html")}}\n\n## Syntax\n\n```js-nolint\nregexp[Symbol.replace](str, replacement)\n```\n\n### Parameters\n\n- `str`\n  - : A {{jsxref("String")}} that is a target of the replacement.\n- `replacement`\n  - : Can be a string or a function.\n    - If it\'s a string, it will replace the substring matched by the current regexp. A number of special replacement patterns are supported; see the [Specifying a string as the replacement](/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/replace#specifying_a_string_as_the_replacement) section of `String.prototype.replace`.\n    - If it\'s a function, it will be invoked for every match and the return value is used as the replacement text. The arguments supplied to this function are described in the [Specifying a function as the replacement](/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/replace#specifying_a_function_as_the_replacement) section of `String.prototype.replace`.\n\n### Return value\n\nA new string, with one, some, or all matches of the pattern replaced by the specified replacement.\n\n## Description\n\nThis method is called internally in {{jsxref("String.prototype.replace()")}} and {{jsxref("String.prototype.replaceAll()")}} if the `pattern` argument is a {{jsxref("RegExp")}} object. For example, the following two examples return the same result.\n\n```js\n"abc".replace(/a/, "A");\n\n/a/[Symbol.replace]("abc", "A");\n```\n\nIf the regex is global (with the `g` flag), the regex\'s [`exec()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/exec) method will be repeatedly called until `exec()` returns `null`. Otherwise, `exec()` would only be called once. For each `exec()` result, the substitution will be prepared based on the description in [`String.prototype.replace()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/replace#description).\n\nBecause `@@replace` would keep calling `exec()` until it returns `null`, and `exec()` would automatically reset the regex\'s [`lastIndex`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/lastIndex) to 0 when the last match fails, `@@replace` would typically not have side effects when it exits. However, when the regex is [sticky](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/sticky) but not global, `lastIndex` would not be reset. In this case, each call to `replace()` may return a different result.\n\n```js\nconst re = /a/y;\n\nfor (let i = 0; i < 5; i++) {\n  console.log("aaa".replace(re, "b"), re.lastIndex);\n}\n\n// baa 1\n// aba 2\n// aab 3\n// aaa 0\n// baa 1\n```\n\nWhen the regex is sticky and global, it would still perform sticky matches \u2014 i.e. it would fail to match any occurrences beyond the `lastIndex`.\n\n```js\nconsole.log("aa-a".replace(/a/gy, "b")); // "bb-a"\n```\n\nIf the current match is an empty string, the `lastIndex` would still be advanced \u2014 if the regex is [Unicode-aware](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/unicode#unicode-aware_mode), it would advance by one Unicode code point; otherwise, it advances by one UTF-16 code unit.\n\n```js\nconsole.log("\uD83D\uDE04".replace(/(?:)/g, " ")); // " \ud83d \ude04 "\nconsole.log("\uD83D\uDE04".replace(/(?:)/gu, " ")); // " \uD83D\uDE04 "\n```\n\nThis method exists for customizing replace behavior in `RegExp` subclasses.\n\n## Examples\n\n### Direct call\n\nThis method can be used in almost the same way as {{jsxref("String.prototype.replace()")}}, except the different `this` and the different arguments order.\n\n```js\nconst re = /-/g;\nconst str = "2016-01-01";\nconst newstr = re[Symbol.replace](str, ".");\nconsole.log(newstr); // 2016.01.01\n```\n\n### Using @@replace in subclasses\n\nSubclasses of {{jsxref("RegExp")}} can override the `[@@replace]()` method to modify the default behavior.\n\n```js\nclass MyRegExp extends RegExp {\n  constructor(pattern, flags, count) {\n    super(pattern, flags);\n    this.count = count;\n  }\n  [Symbol.replace](str, replacement) {\n    // Perform @@replace |count| times.\n    let result = str;\n    for (let i = 0; i < this.count; i++) {\n      result = RegExp.prototype[Symbol.replace].call(this, result, replacement);\n    }\n    return result;\n  }\n}\n\nconst re = new MyRegExp("\\\\d", "", 3);\nconst str = "01234567";\nconst newstr = str.replace(re, "#"); // String.prototype.replace calls re[@@replace].\nconsole.log(newstr); // ###34567\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `RegExp.prototype[@@replace]` in `core-js`](https://github.com/zloirock/core-js#ecmascript-string-and-regexp)\n- {{jsxref("String.prototype.replace()")}}\n- {{jsxref("String.prototype.replaceAll()")}}\n- [`RegExp.prototype[@@match]()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/@@match)\n- [`RegExp.prototype[@@matchAll]()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/@@matchAll)\n- [`RegExp.prototype[@@search]()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/@@search)\n- [`RegExp.prototype[@@split]()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/@@split)\n- {{jsxref("RegExp.prototype.exec()")}}\n- {{jsxref("RegExp.prototype.test()")}}\n- {{jsxref("Symbol.replace")}}\n'
        },
        "@@search": {
            "index.md": '---\ntitle: RegExp.prototype[@@search]()\nslug: Web/JavaScript/Reference/Global_Objects/RegExp/@@search\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.RegExp.@@search\n---\n\n{{JSRef}}\n\nThe **`[@@search]()`** method of {{jsxref("RegExp")}} instances specifies how [`String.prototype.search`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/search) should behave.\n\n{{EmbedInteractiveExample("pages/js/regexp-prototype-@@search.html")}}\n\n## Syntax\n\n```js-nolint\nregexp[Symbol.search](str)\n```\n\n### Parameters\n\n- `str`\n  - : A {{jsxref("String")}} that is a target of the search.\n\n### Return value\n\nThe index of the first match between the regular expression and the given string, or `-1` if no match was found.\n\n## Description\n\nThis method is called internally in {{jsxref("String.prototype.search()")}}. For example, the following two examples return the same result.\n\n```js\n"abc".search(/a/);\n\n/a/[Symbol.search]("abc");\n```\n\nThis method does not copy the regular expression, unlike [`@@split`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/@@split) or [`@@matchAll`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/@@matchAll). However, unlike [`@@match`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/@@match) or [`@@replace`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/@@replace), it will set [`lastIndex`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/lastIndex) to 0 when execution starts and restore it to the previous value when it exits, therefore generally avoiding side effects. This means that the `g` flag has no effect with this method, and it always returns the first match in the string even when `lastIndex` is non-zero. This also means sticky regexps will always search strictly at the beginning of the string.\n\n```js\nconst re = /[abc]/g;\nre.lastIndex = 2;\nconsole.log("abc".search(re)); // 0\n\nconst re2 = /[bc]/y;\nre2.lastIndex = 1;\nconsole.log("abc".search(re2)); // -1\nconsole.log("abc".match(re2)); // [ \'b\' ]\n```\n\n`@@search` always calls the regex\'s [`exec()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/exec) method exactly once, and returns the `index` property of the result, or `-1` if the result is `null`.\n\nThis method exists for customizing the search behavior in `RegExp` subclasses.\n\n## Examples\n\n### Direct call\n\nThis method can be used in almost the same way as {{jsxref("String.prototype.search()")}}, except for the different value of `this` and the different arguments order.\n\n```js\nconst re = /-/g;\nconst str = "2016-01-02";\nconst result = re[Symbol.search](str);\nconsole.log(result); // 4\n```\n\n### Using @@search in subclasses\n\nSubclasses of {{jsxref("RegExp")}} can override `[@@search]()` method to modify the behavior.\n\n```js\nclass MyRegExp extends RegExp {\n  constructor(str) {\n    super(str);\n    this.pattern = str;\n  }\n  [Symbol.search](str) {\n    return str.indexOf(this.pattern);\n  }\n}\n\nconst re = new MyRegExp("a+b");\nconst str = "ab a+b";\nconst result = str.search(re); // String.prototype.search calls re[@@search].\nconsole.log(result); // 3\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `RegExp.prototype[@@search]` in `core-js`](https://github.com/zloirock/core-js#ecmascript-string-and-regexp)\n- {{jsxref("String.prototype.search()")}}\n- [`RegExp.prototype[@@match]()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/@@match)\n- [`RegExp.prototype[@@matchAll]()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/@@matchAll)\n- [`RegExp.prototype[@@replace]()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/@@replace)\n- [`RegExp.prototype[@@split]()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/@@split)\n- {{jsxref("RegExp.prototype.exec()")}}\n- {{jsxref("RegExp.prototype.test()")}}\n- {{jsxref("Symbol.search")}}\n'
        },
        "@@species": {
            "index.md": '---\ntitle: RegExp[@@species]\nslug: Web/JavaScript/Reference/Global_Objects/RegExp/@@species\npage-type: javascript-static-accessor-property\nbrowser-compat: javascript.builtins.RegExp.@@species\n---\n\n{{JSRef}}\n\nThe **`RegExp[@@species]`** static accessor property returns the constructor used to construct copied regular expressions in certain `RegExp` methods.\n\n> **Warning:** The existence of `@@species` allows execution of arbitrary code and may create security vulnerabilities. It also makes certain optimizations much harder. Engine implementers are [investigating whether to remove this feature](https://github.com/tc39/proposal-rm-builtin-subclassing). Avoid relying on it if possible.\n\n{{EmbedInteractiveExample("pages/js/regexp-getregexp-@@species.html")}}\n\n## Syntax\n\n```js-nolint\nRegExp[Symbol.species]\n```\n\n### Return value\n\nThe value of the constructor (`this`) on which `get @@species` was called. The return value is used to construct copied `RegExp` instances.\n\n## Description\n\nThe `@@species` accessor property returns the default constructor for `RegExp` objects. Subclass constructors may override it to change the constructor assignment. The default implementation is basically:\n\n```js\n// Hypothetical underlying implementation for illustration\nclass RegExp {\n  static get [Symbol.species]() {\n    return this;\n  }\n}\n```\n\nBecause of this polymorphic implementation, `@@species` of derived subclasses would also return the constructor itself by default.\n\n```js\nclass SubRegExp extends SubRegExp {}\nSubRegExp[Symbol.species] === SubRegExp; // true\n```\n\nSome `RegExp` methods create a copy of the current regex instance before running {{jsxref("RegExp/exec", "exec()")}}, so that side effects such as changes to {{jsxref("RegExp/lastIndex", "lastIndex")}} are not retained. The `@@species` property is used to determine the constructor of the new instance. The methods that copy the current regex instance are:\n\n- [`[@@matchAll]()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/@@matchAll)\n- [`[@@split]()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/@@split)\n\n## Examples\n\n### Species in ordinary objects\n\nThe `@@species` property returns the default constructor function, which is the `RegExp` constructor for `RegExp` objects:\n\n```js\nRegExp[Symbol.species]; // function RegExp()\n```\n\n### Species in derived objects\n\nIn an instance of a custom `RegExp` subclass, such as `MyRegExp`, the `MyRegExp` species is the `MyRegExp` constructor. However, you might want to overwrite this, in order to return parent `RegExp` objects in your derived class methods:\n\n```js\nclass MyRegExp extends RegExp {\n  // Overwrite MyRegExp species to the parent RegExp constructor\n  static get [Symbol.species]() {\n    return RegExp;\n  }\n}\n```\n\nOr you can use this to observe the copying process:\n\n```js\nclass MyRegExp extends RegExp {\n  constructor(...args) {\n    console.log("Creating a new MyRegExp instance with args:", args);\n    super(...args);\n  }\n  static get [Symbol.species]() {\n    console.log("Copying MyRegExp");\n    return this;\n  }\n  exec(value) {\n    console.log("Executing with lastIndex:", this.lastIndex);\n    return super.exec(value);\n  }\n}\n\nArray.from("aabbccdd".matchAll(new MyRegExp("[ac]", "g")));\n// Creating a new MyRegExp instance with args: [ \'[ac]\', \'g\' ]\n// Copying MyRegExp\n// Creating a new MyRegExp instance with args: [ MyRegExp /[ac]/g, \'g\' ]\n// Executing with lastIndex: 0\n// Executing with lastIndex: 1\n// Executing with lastIndex: 2\n// Executing with lastIndex: 5\n// Executing with lastIndex: 6\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("RegExp")}}\n- {{jsxref("Symbol.species")}}\n'
        },
        "@@split": {
            "index.md": '---\ntitle: RegExp.prototype[@@split]()\nslug: Web/JavaScript/Reference/Global_Objects/RegExp/@@split\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.RegExp.@@split\n---\n\n{{JSRef}}\n\nThe **`[@@split]()`** method of {{jsxref("RegExp")}} instances specifies how [`String.prototype.split`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/split) should behave when the regular expression is passed in as the separator.\n\n{{EmbedInteractiveExample("pages/js/regexp-prototype-@@split.html")}}\n\n## Syntax\n\n```js-nolint\nregexp[Symbol.split](str)\nregexp[Symbol.split](str, limit)\n```\n\n### Parameters\n\n- `str`\n  - : The target of the split operation.\n- `limit` {{optional_inline}}\n  - : Integer specifying a limit on the number of splits to be found. The `[@@split]()` method still splits on every match of `this` RegExp pattern (or, in the Syntax above, `regexp`), until the number of split items match the `limit` or the string falls short of `this` pattern.\n\n### Return value\n\nAn {{jsxref("Array")}} containing substrings as its elements. Capturing groups are included.\n\n## Description\n\nThis method is called internally in {{jsxref("String.prototype.split()")}} when a `RegExp` is passed as the separator. For example, the following two examples return the same result.\n\n```js\n"a-b-c".split(/-/);\n\n/-/[Symbol.split]("a-b-c");\n```\n\nThis method exists for customizing the behavior of `split()` in `RegExp` subclasses.\n\nThe `RegExp.prototype[@@split]()` base method exhibits the following behaviors:\n\n- It starts by using [`@@species`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/@@species) to construct a new regexp, thus avoiding mutating the original regexp in any way.\n- The regexp\'s `g` ("global") flag is ignored, and the `y` ("sticky") flag is always applied even when it was not originally present.\n- If the target string is empty, and the regexp can match empty strings (for example, `/a?/`), an empty array is returned. Otherwise, if the regexp can\'t match an empty string, `[""]` is returned.\n- The matching proceeds by continuously calling `this.exec()`. Since the regexp is always sticky, this will move along the string, each time yielding a matching string, index, and any capturing groups.\n- For each match, the substring between the last matched string\'s end and the current matched string\'s beginning is first appended to the result array. Then, the capturing groups\' values are appended one-by-one.\n- If the current match is an empty string, or if the regexp doesn\'t match at the current position (since it\'s sticky), the `lastIndex` would still be advanced \u2014 if the regex is [Unicode-aware](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/unicode#unicode-aware_mode), it would advance by one Unicode code point; otherwise, it advances by one UTF-16 code unit.\n- If the regexp doesn\'t match the target string, the target string is returned as-is, wrapped in an array.\n- The returned array\'s length will never exceed the `limit` parameter, if provided, while trying to be as close as possible. Therefore, the last match and its capturing groups may not all be present in the returned array if the array is already filled.\n\n## Examples\n\n### Direct call\n\nThis method can be used in almost the same way as\n{{jsxref("String.prototype.split()")}}, except the different `this` and the\ndifferent order of arguments.\n\n```js\nconst re = /-/g;\nconst str = "2016-01-02";\nconst result = re[Symbol.split](str);\nconsole.log(result); // ["2016", "01", "02"]\n```\n\n### Using @@split in subclasses\n\nSubclasses of {{jsxref("RegExp")}} can override the `[@@split]()` method to\nmodify the default behavior.\n\n```js\nclass MyRegExp extends RegExp {\n  [Symbol.split](str, limit) {\n    const result = RegExp.prototype[Symbol.split].call(this, str, limit);\n    return result.map((x) => `(${x})`);\n  }\n}\n\nconst re = new MyRegExp("-");\nconst str = "2016-01-02";\nconst result = str.split(re); // String.prototype.split calls re[@@split].\nconsole.log(result); // ["(2016)", "(01)", "(02)"]\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `RegExp.prototype[@@split]` in `core-js`](https://github.com/zloirock/core-js#ecmascript-string-and-regexp)\n- {{jsxref("String.prototype.split()")}}\n- [`RegExp.prototype[@@match]()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/@@match)\n- [`RegExp.prototype[@@matchAll]()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/@@matchAll)\n- [`RegExp.prototype[@@replace]()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/@@replace)\n- [`RegExp.prototype[@@search]()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/@@search)\n- {{jsxref("RegExp.prototype.exec()")}}\n- {{jsxref("RegExp.prototype.test()")}}\n- {{jsxref("Symbol.split")}}\n'
        },
        "compile": {
            "index.md": '---\ntitle: RegExp.prototype.compile()\nslug: Web/JavaScript/Reference/Global_Objects/RegExp/compile\npage-type: javascript-instance-method\nstatus:\n  - deprecated\nbrowser-compat: javascript.builtins.RegExp.compile\n---\n\n{{JSRef}} {{Deprecated_Header}}\n\n> **Note:** The `compile()` method is only specified for compatibility reasons. Using `compile()` causes the otherwise immutable regex source and flags to become mutable, which may break user expectations. You can use the [`RegExp()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/RegExp) constructor to construct a new regular expression object instead.\n\nThe **`compile()`** method of {{jsxref("RegExp")}} instances is used to recompile a regular expression with new source and flags after the `RegExp` object has already been created.\n\n## Syntax\n\n```js-nolint\ncompile(pattern, flags)\n```\n\n### Parameters\n\n- `pattern`\n  - : The text of the regular expression.\n- `flags`\n  - : Any combination of [flag values](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/RegExp#flags).\n\n### Return value\n\nNone ({{jsxref("undefined")}}).\n\n## Examples\n\n### Using compile()\n\nThe following example shows how to recompile a regular expression with a new pattern and a new flag.\n\n```js\nconst regexObj = new RegExp("foo", "gi");\nregexObj.compile("new foo", "g");\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("RegExp")}}\n'
        },
        "dotall": {
            "index.md": '---\ntitle: RegExp.prototype.dotAll\nslug: Web/JavaScript/Reference/Global_Objects/RegExp/dotAll\npage-type: javascript-instance-accessor-property\nbrowser-compat: javascript.builtins.RegExp.dotAll\n---\n\n{{JSRef}}\n\nThe **`dotAll`** accessor property of {{jsxref("RegExp")}} instances returns whether or not the `s` flag is used with this regular expression.\n\n{{EmbedInteractiveExample("pages/js/regexp-prototype-dotall.html")}}\n\n## Description\n\n`RegExp.prototype.dotAll` has the value `true` if the `s` flag was used; otherwise, `false`. The `s` flag indicates that the dot special character (`.`) should additionally match the following line terminator ("newline") characters in a string, which it would not match otherwise:\n\n- U+000A LINE FEED (LF) (`\\n`)\n- U+000D CARRIAGE RETURN (CR) (`\\r`)\n- U+2028 LINE SEPARATOR\n- U+2029 PARAGRAPH SEPARATOR\n\nThis effectively means the dot will match any character on the Unicode Basic Multilingual Plane (BMP). To allow it to match astral characters, the `u` (unicode) flag should be used. Using both flags in conjunction allows the dot to match any Unicode character, without exceptions.\n\nThe set accessor of `dotAll` is `undefined`. You cannot change this property directly.\n\n## Examples\n\n### Using dotAll\n\n```js\nconst str1 = "bar\\nexample foo example";\n\nconst regex1 = /bar.example/s;\n\nconsole.log(regex1.dotAll); // true\n\nconsole.log(str1.replace(regex1, "")); // foo example\n\nconst str2 = "bar\\nexample foo example";\n\nconst regex2 = /bar.example/;\n\nconsole.log(regex2.dotAll); // false\n\nconsole.log(str2.replace(regex2, ""));\n// bar\n// example foo example\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of the `dotAll` flag in `core-js`](https://github.com/zloirock/core-js#ecmascript-string-and-regexp)\n- {{jsxref("RegExp.prototype.lastIndex")}}\n- {{jsxref("RegExp.prototype.global")}}\n- {{jsxref("RegExp.prototype.hasIndices")}}\n- {{jsxref("RegExp.prototype.ignoreCase")}}\n- {{jsxref("RegExp.prototype.multiline")}}\n- {{jsxref("RegExp.prototype.source")}}\n- {{jsxref("RegExp.prototype.sticky")}}\n- {{jsxref("RegExp.prototype.unicode")}}\n'
        },
        "exec": {
            "index.md": '---\ntitle: RegExp.prototype.exec()\nslug: Web/JavaScript/Reference/Global_Objects/RegExp/exec\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.RegExp.exec\n---\n\n{{JSRef}}\n\nThe **`exec()`** method of {{jsxref("RegExp")}} instances executes a search with this regular expression for a match in a specified string and returns a result array, or [`null`](/en-US/docs/Web/JavaScript/Reference/Operators/null).\n\n{{EmbedInteractiveExample("pages/js/regexp-prototype-exec.html")}}\n\n## Syntax\n\n```js-nolint\nexec(str)\n```\n\n### Parameters\n\n- `str`\n  - : The string against which to match the regular expression. All values are [coerced to strings](/en-US/docs/Web/JavaScript/Reference/Global_Objects/String#string_coercion), so omitting it or passing `undefined` causes `exec()` to search for the string `"undefined"`, which is rarely what you want.\n\n### Return value\n\nIf the match fails, the `exec()` method returns [`null`](/en-US/docs/Web/JavaScript/Reference/Operators/null), and sets the regex\'s [`lastIndex`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/lastIndex) to `0`.\n\nIf the match succeeds, the `exec()` method returns an array and updates the [`lastIndex`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/lastIndex) property of the regular expression object. The returned array has the matched text as the first item, and then one item for each capturing group of the matched text. The array also has the following additional properties:\n\n- `index`\n  - : The 0-based index of the match in the string.\n- `input`\n  - : The original string that was matched against.\n- `groups`\n  - : A [`null`-prototype object](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object#null-prototype_objects) of named capturing groups, whose keys are the names, and values are the capturing groups, or {{jsxref("undefined")}} if no named capturing groups were defined. See [capturing groups](/en-US/docs/Web/JavaScript/Guide/Regular_expressions/Groups_and_backreferences) for more information.\n- `indices` {{optional_inline}}\n\n  - : This property is only present when the [`d`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/hasIndices) flag is set. It is an array where each entry represents the bounds of a substring match. The index of each element in this array corresponds to the index of the respective substring match in the array returned by `exec()`. In other words, the first `indices` entry represents the entire match, the second `indices` entry represents the first capturing group, etc. Each entry itself is a two-element array, where the first number represents the match\'s start index, and the second number, its end index.\n\n    The `indices` array additionally has a `groups` property, which holds a [`null`-prototype object](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object#null-prototype_objects) of all named capturing groups. The keys are the names of the capturing groups, and each value is a two-element array, with the first number being the start index, and the second number being the end index of the capturing group. If the regular expression doesn\'t contain any named capturing groups, `groups` is `undefined`.\n\n## Description\n\nJavaScript {{jsxref("RegExp")}} objects are _stateful_ when they have the [global](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/global) or [sticky](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/sticky) flags set (e.g. `/foo/g` or `/foo/y`). They store a [`lastIndex`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/lastIndex) from the previous match. Using this internally, `exec()` can be used to iterate over multiple matches in a string of text (with capture groups), as opposed to getting just the matching strings with {{jsxref("String.prototype.match()")}}.\n\nWhen using `exec()`, the global flag has no effect when the sticky flag is set \u2014 the match is always sticky.\n\n`exec()` is the primitive method of regexps. Many other regexp methods call `exec()` internally \u2014 including those called by string methods, like [`@@replace`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/@@replace). While `exec()` itself is powerful (and is the most efficient), it often does not convey the intent most clearly.\n\n- If you only care whether the regex matches a string, but not what is actually being matched, use {{jsxref("RegExp.prototype.test()")}} instead.\n- If you are finding all occurrences of a global regex and you don\'t care about information like capturing groups, use {{jsxref("String.prototype.match()")}} instead. In addition, {{jsxref("String.prototype.matchAll()")}} helps to simplify matching multiple parts of a string (with capture groups) by allowing you to iterate over the matches.\n- If you are executing a match to find its index position in the string, use the {{jsxref("String.prototype.search()")}} method instead.\n\n## Examples\n\n### Using exec()\n\nConsider the following example:\n\n```js\n// Match "quick brown" followed by "jumps", ignoring characters in between\n// Remember "brown" and "jumps"\n// Ignore case\nconst re = /quick\\s(?<color>brown).+?(jumps)/dgi;\nconst result = re.exec("The Quick Brown Fox Jumps Over The Lazy Dog");\n```\n\nThe following table shows the state of `result` after running this script:\n\n| Property  | Value                                                              |\n| --------- | ------------------------------------------------------------------ |\n| `[0]`     | `"Quick Brown Fox Jumps"`                                          |\n| `[1]`     | `"Brown"`                                                          |\n| `[2]`     | `"Jumps"`                                                          |\n| `index`   | `4`                                                                |\n| `indices` | `[[4, 25], [10, 15], [20, 25]]`<br />`groups: { color: [10, 15 ]}` |\n| `input`   | `"The Quick Brown Fox Jumps Over The Lazy Dog"`                    |\n| `groups`  | `{ color: "brown" }`                                               |\n\nIn addition, `re.lastIndex` will be set to `25`, due to this regex being global.\n\n### Finding successive matches\n\nIf your regular expression uses the [`g`](/en-US/docs/Web/JavaScript/Guide/Regular_expressions#advanced_searching_with_flags) flag, you can use the `exec()` method multiple times to find successive matches in the same string. When you do so, the search starts at the substring of `str` specified by the regular expression\'s {{jsxref("RegExp/lastIndex", "lastIndex")}} property ({{jsxref("RegExp/test", "test()")}} will also advance the {{jsxref("RegExp/lastIndex", "lastIndex")}} property). Note that the {{jsxref("RegExp/lastIndex", "lastIndex")}} property will not be reset when searching a different string, it will start its search at its existing {{jsxref("RegExp/lastIndex", "lastIndex")}}.\n\nFor example, assume you have this script:\n\n```js\nconst myRe = /ab*/g;\nconst str = "abbcdefabh";\nlet myArray;\nwhile ((myArray = myRe.exec(str)) !== null) {\n  let msg = `Found ${myArray[0]}. `;\n  msg += `Next match starts at ${myRe.lastIndex}`;\n  console.log(msg);\n}\n```\n\nThis script displays the following text:\n\n```plain\nFound abb. Next match starts at 3\nFound ab. Next match starts at 9\n```\n\n> **Warning:** There are many pitfalls that can lead to this becoming an infinite loop!\n>\n> - Do _not_ place the regular expression literal (or {{jsxref("RegExp")}} constructor) within the `while` condition \u2014 it will recreate the regex for every iteration and reset {{jsxref("RegExp/lastIndex", "lastIndex")}}.\n> - Be sure that the [global (`g`) flag](/en-US/docs/Web/JavaScript/Guide/Regular_expressions#advanced_searching_with_flags) is set, or `lastIndex` will never be advanced.\n> - If the regex may match zero-length characters (e.g. `/^/gm`), increase its {{jsxref("RegExp/lastIndex", "lastIndex")}} manually each time to avoid being stuck in the same place.\n\nYou can usually replace this kind of code with {{jsxref("String.prototype.matchAll()")}} to make it less error-prone.\n\n### Using exec() with RegExp literals\n\nYou can also use `exec()` without creating a {{jsxref("RegExp")}} object\nexplicitly:\n\n```js\nconst matches = /(hello \\S+)/.exec("This is a hello world!");\nconsole.log(matches[1]);\n```\n\nThis will log a message containing `\'hello world!\'`.\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Regular expressions](/en-US/docs/Web/JavaScript/Guide/Regular_expressions) guide\n- {{jsxref("RegExp")}}\n'
        },
        "flags": {
            "index.md": '---\ntitle: RegExp.prototype.flags\nslug: Web/JavaScript/Reference/Global_Objects/RegExp/flags\npage-type: javascript-instance-accessor-property\nbrowser-compat: javascript.builtins.RegExp.flags\n---\n\n{{JSRef}}\n\nThe **`flags`** accessor property of {{jsxref("RegExp")}} instances returns the [flags](/en-US/docs/Web/JavaScript/Guide/Regular_expressions#advanced_searching_with_flags) of this regular expression.\n\n{{EmbedInteractiveExample("pages/js/regexp-prototype-flags.html")}}\n\n## Description\n\n`RegExp.prototype.flags` has a string as its value. Flags in the `flags` property are sorted alphabetically (from left to right, e.g. `"dgimsuvy"`). It actually invokes the other flag accessors ([`hasIndices`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/hasIndices), [`global`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/global), etc.) one-by-one and concatenates the results.\n\nAll built-in functions read the `flags` property instead of reading individual flag accessors.\n\nThe set accessor of `flags` is `undefined`. You cannot change this property directly.\n\n## Examples\n\n### Using flags\n\n```js-nolint\n/foo/ig.flags; // "gi"\n/bar/myu.flags; // "muy"\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `RegExp.prototype.flags` in `core-js`](https://github.com/zloirock/core-js#ecmascript-string-and-regexp)\n- [Advanced searching with flags](/en-US/docs/Web/JavaScript/Guide/Regular_expressions#advanced_searching_with_flags) in the Regular expressions guide\n- {{jsxref("RegExp.prototype.source")}}\n'
        },
        "global": {
            "index.md": '---\ntitle: RegExp.prototype.global\nslug: Web/JavaScript/Reference/Global_Objects/RegExp/global\npage-type: javascript-instance-accessor-property\nbrowser-compat: javascript.builtins.RegExp.global\n---\n\n{{JSRef}}\n\nThe **`global`** accessor property of {{jsxref("RegExp")}} instances returns whether or not the `g` flag is used with this regular expression.\n\n{{EmbedInteractiveExample("pages/js/regexp-prototype-global.html")}}\n\n## Description\n\n`RegExp.prototype.global` has the value `true` if the `g` flag was used; otherwise, `false`. The `g` flag indicates that the regular expression should be tested against all possible matches in a string. Each call to [`exec()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/exec) will update its [`lastIndex`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/lastIndex) property, so that the next call to `exec()` will start at the next character.\n\nSome methods, such as [`String.prototype.matchAll()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/matchAll) and [`String.prototype.replaceAll()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/replaceAll), will validate that, if the parameter is a regex, it is global. The regex\'s [`@@match`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/@@match) and [`@@replace`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/@@replace) methods (called by [`String.prototype.match()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/match) and [`String.prototype.replace()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/replace)) would also have different behaviors when the regex is global.\n\nThe set accessor of `global` is `undefined`. You cannot change this property directly.\n\n## Examples\n\n### Using global\n\n```js\nconst regex = /foo/g;\nconsole.log(regex.global); // true\n\nconst str = "fooexamplefoo";\nconst str1 = str.replace(regex, "");\nconsole.log(str1); // example\n\nconst regex1 = /foo/;\nconst str2 = str.replace(regex1, "");\nconsole.log(str2); // examplefoo\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("RegExp.prototype.lastIndex")}}\n- {{jsxref("RegExp.prototype.dotAll")}}\n- {{jsxref("RegExp.prototype.hasIndices")}}\n- {{jsxref("RegExp.prototype.ignoreCase")}}\n- {{jsxref("RegExp.prototype.multiline")}}\n- {{jsxref("RegExp.prototype.source")}}\n- {{jsxref("RegExp.prototype.sticky")}}\n- {{jsxref("RegExp.prototype.unicode")}}\n'
        },
        "hasindices": {
            "index.md": '---\ntitle: RegExp.prototype.hasIndices\nslug: Web/JavaScript/Reference/Global_Objects/RegExp/hasIndices\npage-type: javascript-instance-accessor-property\nbrowser-compat: javascript.builtins.RegExp.hasIndices\n---\n\n{{JSRef}}\n\nThe **`hasIndices`** accessor property of {{jsxref("RegExp")}} instances returns whether or not the `d` flag is used with this regular expression.\n\n{{EmbedInteractiveExample("pages/js/regexp-prototype-hasindices.html")}}\n\n## Description\n\n`RegExp.prototype.hasIndices` has the value `true` if the `d` flag was used; otherwise, `false`. The `d` flag indicates that the result of a regular expression match should contain the start and end indices of the substrings of each capture group. It does not change the regex\'s interpretation or matching behavior in any way, but only provides additional information in the matching result.\n\nThis flag primarily affects the return value of [`exec()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/exec). If the `d` flag is present, the array returned by `exec()` has an additional `indices` property as described in the `exec()` method\'s [return value](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/exec#return_value). Because all other regex-related methods (such as {{jsxref("String.prototype.match()")}}) call `exec()` internally, they will also return the indices if the regex has the `d` flag.\n\nThe set accessor of `hasIndices` is `undefined`. You cannot change this property directly.\n\n## Examples\n\nThere\'s a more detailed usage example at [Groups and backreferences > Using groups and match indices](/en-US/docs/Web/JavaScript/Guide/Regular_expressions/Groups_and_backreferences#using_groups_and_match_indices).\n\n### Using hasIndices\n\n```js\nconst str1 = "foo bar foo";\n\nconst regex1 = /foo/dg;\n\nconsole.log(regex1.hasIndices); // true\n\nconsole.log(regex1.exec(str1).indices[0]); // [0, 3]\nconsole.log(regex1.exec(str1).indices[0]); // [8, 11]\n\nconst str2 = "foo bar foo";\n\nconst regex2 = /foo/;\n\nconsole.log(regex2.hasIndices); // false\n\nconsole.log(regex2.exec(str2).indices); // undefined\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("RegExp.prototype.lastIndex")}}\n- {{jsxref("RegExp.prototype.exec()")}}\n- {{jsxref("RegExp.prototype.dotAll")}}\n- {{jsxref("RegExp.prototype.global")}}\n- {{jsxref("RegExp.prototype.ignoreCase")}}\n- {{jsxref("RegExp.prototype.multiline")}}\n- {{jsxref("RegExp.prototype.source")}}\n- {{jsxref("RegExp.prototype.sticky")}}\n- {{jsxref("RegExp.prototype.unicode")}}\n'
        },
        "ignorecase": {
            "index.md": '---\ntitle: RegExp.prototype.ignoreCase\nslug: Web/JavaScript/Reference/Global_Objects/RegExp/ignoreCase\npage-type: javascript-instance-accessor-property\nbrowser-compat: javascript.builtins.RegExp.ignoreCase\n---\n\n{{JSRef}}\n\nThe **`ignoreCase`** accessor property of {{jsxref("RegExp")}} instances returns whether or not the `i` flag is used with this regular expression.\n\n{{EmbedInteractiveExample("pages/js/regexp-prototype-ignorecase.html")}}\n\n## Description\n\n`RegExp.prototype.ignoreCase` has the value `true` if the `i` flag was used; otherwise, `false`. The `i` flag indicates that case should be ignored while attempting a match in a string. Case-insensitive matching is done by mapping both the expected character set and the matched string to the same casing.\n\nIf the regex is [Unicode-aware](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/unicode#unicode-aware_mode), the case mapping happens through _simple case folding_ specified in [`CaseFolding.txt`](https://unicode.org/Public/UCD/latest/ucd/CaseFolding.txt). The mapping always maps to a single code point, so it does not map, for example, `\xdf` (U+00DF LATIN SMALL LETTER SHARP S) to `ss` (which is _full case folding_, not _simple case folding_). It may however map code points outside the Basic Latin block to code points within it \u2014 for example, `\u017F` (U+017F LATIN SMALL LETTER LONG S) case-folds to `s` (U+0073 LATIN SMALL LETTER S) and `\u212A` (U+212A KELVIN SIGN) case-folds to `k` (U+006B LATIN SMALL LETTER K). Therefore, `\u017F` and `\u212A` can be matched by `/[a-z]/ui`.\n\nIf the regex is Unicode-unaware, case mapping uses the [Unicode Default Case Conversion](https://unicode-org.github.io/icu/userguide/transforms/casemappings.html) \u2014 the same algorithm used in {{jsxref("String.prototype.toUpperCase()")}}. For example, `\u2126` (U+2126 OHM SIGN) and `\u03A9` (U+03A9 GREEK CAPITAL LETTER OMEGA) are both mapped by Default Case Conversion to themselves but by simple case folding to `\u03C9` (U+03C9 GREEK SMALL LETTER OMEGA), so `"\u03C9"` is matched by `/[\\u2126]/ui` and `/[\\u03a9]/ui` but not by `/[\\u2126]/i` or `/[\\u03a9]/i`. This algorithm prevents code points outside the Basic Latin block to be mapped to code points within it, so `\u017F` and `\u212A` mentioned previously are not matched by `/[a-z]/i`.\n\nThe set accessor of `ignoreCase` is `undefined`. You cannot change this property directly.\n\n## Examples\n\n### Using ignoreCase\n\n```js\nconst regex = /foo/i;\n\nconsole.log(regex.ignoreCase); // true\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("RegExp.prototype.lastIndex")}}\n- {{jsxref("RegExp.prototype.dotAll")}}\n- {{jsxref("RegExp.prototype.global")}}\n- {{jsxref("RegExp.prototype.hasIndices")}}\n- {{jsxref("RegExp.prototype.multiline")}}\n- {{jsxref("RegExp.prototype.source")}}\n- {{jsxref("RegExp.prototype.sticky")}}\n- {{jsxref("RegExp.prototype.unicode")}}\n'
        },
        "index.md": '---\ntitle: RegExp\nslug: Web/JavaScript/Reference/Global_Objects/RegExp\npage-type: javascript-class\nbrowser-compat: javascript.builtins.RegExp\n---\n\n{{JSRef}}\n\nThe **`RegExp`** object is used for matching text with a pattern.\n\nFor an introduction to regular expressions, read the [Regular expressions chapter](/en-US/docs/Web/JavaScript/Guide/Regular_expressions) in the JavaScript guide. For detailed information of regular expression syntax, read the [regular expression reference](/en-US/docs/Web/JavaScript/Reference/Regular_expressions).\n\n## Description\n\n### Literal notation and constructor\n\nThere are two ways to create a `RegExp` object: a _literal notation_ and a _constructor_.\n\n- The _literal notation_ takes a pattern between two slashes, followed by optional [flags](/en-US/docs/Web/JavaScript/Guide/Regular_expressions#advanced_searching_with_flags), after the second slash.\n- The _constructor function_ takes either a string or a `RegExp` object as its first parameter and a string of optional [flags](/en-US/docs/Web/JavaScript/Guide/Regular_expressions#advanced_searching_with_flags) as its second parameter.\n\nThe following three expressions create the same regular expression object:\n\n```js\nconst re = /ab+c/i; // literal notation\n// OR\nconst re = new RegExp("ab+c", "i"); // constructor with string pattern as first argument\n// OR\nconst re = new RegExp(/ab+c/, "i"); // constructor with regular expression literal as first argument\n```\n\nBefore regular expressions can be used, they have to be compiled. This process allows them to perform matches more efficiently. More about the process can be found in [dotnet docs](https://docs.microsoft.com/dotnet/standard/base-types/compilation-and-reuse-in-regular-expressions).\n\nThe literal notation results in compilation of the regular expression when the expression is evaluated. On the other hand, the constructor of the `RegExp` object, `new RegExp(\'ab+c\')`, results in runtime compilation of the regular expression.\n\nUse a string as the first argument to the `RegExp()` constructor when you want to [build the regular expression from dynamic input](#building_a_regular_expression_from_dynamic_inputs).\n\n### Flags in constructor\n\nThe expression `new RegExp(/ab+c/, flags)` will create a new `RegExp` using the source of the first parameter and the [flags](/en-US/docs/Web/JavaScript/Guide/Regular_expressions#advanced_searching_with_flags) provided by the second.\n\nWhen using the constructor function, the normal string escape rules (preceding special characters with `\\` when included in a string) are necessary.\n\nFor example, the following are equivalent:\n\n```js\nconst re = /\\w+/;\n// OR\nconst re = new RegExp("\\\\w+");\n```\n\n### Special handling for regexes\n\n> **Note:** Whether something is a "regex" can be [duck-typed](https://en.wikipedia.org/wiki/Duck_typing). It doesn\'t have to be a `RegExp`!\n\nSome built-in methods would treat regexes specially. They decide whether `x` is a regex through [multiple steps](https://tc39.es/ecma262/multipage/abstract-operations.html#sec-isregexp):\n\n1. `x` must be an object (not a primitive).\n2. If [`x[Symbol.match]`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol/match) is not `undefined`, check if it\'s [truthy](/en-US/docs/Glossary/Truthy).\n3. Otherwise, if `x[Symbol.match]` is `undefined`, check if `x` had been created with the `RegExp` constructor. (This step should rarely happen, since if `x` is a `RegExp` object that have not been tampered with, it should have a `Symbol.match` property.)\n\nNote that in most cases, it would go through the `Symbol.match` check, which means:\n\n- An actual `RegExp` object whose `Symbol.match` property\'s value is [falsy](/en-US/docs/Glossary/Falsy) but not `undefined` (even with everything else intact, like [`exec`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/exec) and [`@@replace`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/@@replace)) can be used as if it\'s not a regex.\n- A non-`RegExp` object with a `Symbol.match` property will be treated as if it\'s a regex.\n\nThis choice was made because `@@match` is the most indicative property that something is intended to be used for matching. (`exec` could also be used, but because it\'s not a symbol property, there would be too many false positives.) The places that treat regexes specially include:\n\n- [`String.prototype.endsWith()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith), [`startsWith()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith), and [`includes()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes) throw a {{jsxref("TypeError")}} if the first argument is a regex.\n- [`String.prototype.matchAll()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/matchAll) and [`replaceAll()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/replaceAll) check whether the [global](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/global) flag is set if the first argument is a regex before invoking its [`@@matchAll`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol/matchAll) or [`@@replace`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol/replace) method.\n- The [`RegExp()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/RegExp) constructor directly returns the `pattern` argument only if `pattern` is a regex (among a few other conditions). If `pattern` is a regex, it would also interrogate `pattern`\'s `source` and `flags` properties instead of coercing `pattern` to a string.\n\nFor example, [`String.prototype.endsWith()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith) would coerce all inputs to strings, but it would throw if the argument is a regex, because it\'s only designed to match strings, and using a regex is likely a developer mistake.\n\n```js\n"foobar".endsWith({ toString: () => "bar" }); // true\n"foobar".endsWith(/bar/); // TypeError: First argument to String.prototype.endsWith must not be a regular expression\n```\n\nYou can get around the check by setting `@@match` to a [falsy](/en-US/docs/Glossary/Falsy) value that\'s not `undefined`. This would mean that the regex cannot be used for `String.prototype.match()` (since without `@@match`, `match()` would construct a new `RegExp` object with the two enclosing slashes added by [`re.toString()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/toString)), but it can be used for virtually everything else.\n\n```js\nconst re = /bar/g;\nre[Symbol.match] = false;\n"/bar/g".endsWith(re); // true\nre.exec("bar"); // [ \'bar\', index: 0, input: \'bar\', groups: undefined ]\n"bar & bar".replace(re, "foo"); // \'foo & foo\'\n```\n\n### Perl-like RegExp properties\n\nNote that several of the {{jsxref("RegExp")}} properties have both long and short (Perl-like) names. Both names always refer to the same value. (Perl is the programming language from which JavaScript modeled its regular expressions.) See also [deprecated `RegExp` properties](/en-US/docs/Web/JavaScript/Reference/Deprecated_and_obsolete_features#regexp).\n\n## Constructor\n\n- {{jsxref("RegExp/RegExp", "RegExp()")}}\n  - : Creates a new `RegExp` object.\n\n## Static properties\n\n- {{jsxref("RegExp/n", "RegExp.$1, \u2026, RegExp.$9")}} {{deprecated_inline}}\n  - : Static read-only properties that contain parenthesized substring matches.\n- {{jsxref("RegExp/input", "RegExp.input ($_)")}} {{deprecated_inline}}\n  - : A static property that contains the last string against which a regular expression was successfully matched.\n- {{jsxref("RegExp/lastMatch", "RegExp.lastMatch ($&)")}} {{deprecated_inline}}\n  - : A static read-only property that contains the last matched substring.\n- {{jsxref("RegExp/lastParen", "RegExp.lastParen ($+)")}} {{deprecated_inline}}\n  - : A static read-only property that contains the last parenthesized substring match.\n- {{jsxref("RegExp/leftContext", "RegExp.leftContext ($`)")}} {{deprecated_inline}}\n  - : A static read-only property that contains the substring preceding the most recent match.\n- {{jsxref("RegExp/rightContext", "RegExp.rightContext ($\')")}} {{deprecated_inline}}\n  - : A static read-only property that contains the substring following the most recent match.\n- {{jsxref("RegExp/@@species", "RegExp[@@species]")}}\n  - : The constructor function that is used to create derived objects.\n\n## Instance properties\n\nThese properties are defined on `RegExp.prototype` and shared by all `RegExp` instances.\n\n- {{jsxref("Object/constructor", "RegExp.prototype.constructor")}}\n  - : The constructor function that created the instance object. For `RegExp` instances, the initial value is the {{jsxref("RegExp/RegExp", "RegExp")}} constructor.\n- {{jsxref("RegExp.prototype.dotAll")}}\n  - : Whether `.` matches newlines or not.\n- {{jsxref("RegExp.prototype.flags")}}\n  - : A string that contains the flags of the `RegExp` object.\n- {{jsxref("RegExp.prototype.global")}}\n  - : Whether to test the regular expression against all possible matches in a string, or only against the first.\n- {{jsxref("RegExp.prototype.hasIndices")}}\n  - : Whether the regular expression result exposes the start and end indices of captured substrings.\n- {{jsxref("RegExp.prototype.ignoreCase")}}\n  - : Whether to ignore case while attempting a match in a string.\n- {{jsxref("RegExp.prototype.multiline")}}\n  - : Whether or not to search in strings across multiple lines.\n- {{jsxref("RegExp.prototype.source")}}\n  - : The text of the pattern.\n- {{jsxref("RegExp.prototype.sticky")}}\n  - : Whether or not the search is sticky.\n- {{jsxref("RegExp.prototype.unicode")}}\n  - : Whether or not Unicode features are enabled.\n- {{jsxref("RegExp.prototype.unicodeSets")}}\n  - : Whether or not the `v` flag, an upgrade to the `u` mode, is enabled.\n\nThese properties are own properties of each `RegExp` instance.\n\n- {{jsxref("RegExp/lastIndex", "lastIndex")}}\n  - : The index at which to start the next match.\n\n## Instance methods\n\n- {{jsxref("RegExp.prototype.compile()")}} {{deprecated_inline}}\n  - : (Re-)compiles a regular expression during execution of a script.\n- {{jsxref("RegExp.prototype.exec()")}}\n  - : Executes a search for a match in its string parameter.\n- {{jsxref("RegExp.prototype.test()")}}\n  - : Tests for a match in its string parameter.\n- {{jsxref("RegExp.prototype.toString()")}}\n  - : Returns a string representing the specified object. Overrides the {{jsxref("Object.prototype.toString()")}} method.\n- [`RegExp.prototype[@@match]()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/@@match)\n  - : Performs match to given string and returns match result.\n- [`RegExp.prototype[@@matchAll]()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/@@matchAll)\n  - : Returns all matches of the regular expression against a string.\n- [`RegExp.prototype[@@replace]()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/@@replace)\n  - : Replaces matches in given string with new substring.\n- [`RegExp.prototype[@@search]()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/@@search)\n  - : Searches the match in given string and returns the index the pattern found in the string.\n- [`RegExp.prototype[@@split]()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/@@split)\n  - : Splits given string into an array by separating the string into substrings.\n\n## Examples\n\n### Using a regular expression to change data format\n\nThe following script uses the {{jsxref("String.prototype.replace()")}} method to match a name in the format _first last_ and output it in the format _last, first_.\n\nIn the replacement text, the script uses `$1` and `$2` to indicate the results of the corresponding matching parentheses in the regular expression pattern.\n\n```js\nconst re = /(\\w+)\\s(\\w+)/;\nconst str = "Maria Cruz";\nconst newstr = str.replace(re, "$2, $1");\nconsole.log(newstr);\n```\n\nThis displays `"Cruz, Maria"`.\n\n### Using regular expression to split lines with different line endings/ends of line/line breaks\n\nThe default line ending varies depending on the platform (Unix, Windows, etc.). The line splitting provided in this example works on all platforms.\n\n```js\nconst text = "Some text\\nAnd some more\\r\\nAnd yet\\rThis is the end";\nconst lines = text.split(/\\r\\n|\\r|\\n/);\nconsole.log(lines); // [ \'Some text\', \'And some more\', \'And yet\', \'This is the end\' ]\n```\n\nNote that the order of the patterns in the regular expression matters.\n\n### Using regular expression on multiple lines\n\n```js\nconst s = "Please yes\\nmake my day!";\n\ns.match(/yes.*day/);\n// Returns null\n\ns.match(/yes[^]*day/);\n// Returns ["yes\\nmake my day"]\n```\n\n### Using a regular expression with the sticky flag\n\nThe {{jsxref("RegExp/sticky", "sticky")}} flag indicates that the regular expression performs sticky matching in the target string by attempting to match starting at {{jsxref("RegExp.prototype.lastIndex")}}.\n\n```js\nconst str = "#foo#";\nconst regex = /foo/y;\n\nregex.lastIndex = 1;\nregex.test(str); // true\nregex.lastIndex = 5;\nregex.test(str); // false (lastIndex is taken into account with sticky flag)\nregex.lastIndex; // 0 (reset after match failure)\n```\n\n### The difference between the sticky flag and the global flag\n\nWith the sticky flag `y`, the next match has to happen at the `lastIndex` position, while with the global flag `g`, the match can happen at the `lastIndex` position or later:\n\n```js\nconst re = /\\d/y;\nlet r;\nwhile ((r = re.exec("123 456"))) {\n  console.log(r, "AND re.lastIndex", re.lastIndex);\n}\n\n// [ \'1\', index: 0, input: \'123 456\', groups: undefined ] AND re.lastIndex 1\n// [ \'2\', index: 1, input: \'123 456\', groups: undefined ] AND re.lastIndex 2\n// [ \'3\', index: 2, input: \'123 456\', groups: undefined ] AND re.lastIndex 3\n//  \u2026 and no more match.\n```\n\nWith the global flag `g`, all 6 digits would be matched, not just 3.\n\n### Regular expression and Unicode characters\n\n`\\w` and `\\W` only matches ASCII based characters; for example, `a` to `z`, `A` to `Z`, `0` to `9`, and `_`.\n\nTo match characters from other languages such as Cyrillic or Hebrew, use `\\uhhhh`, where `hhhh` is the character\'s Unicode value in hexadecimal.\n\nThis example demonstrates how one can separate out Unicode characters from a word.\n\n```js\nconst text = "\u041E\u0431\u0440\u0430\u0437\u0435\u0446 text \u043D\u0430 \u0440\u0443\u0441\u0441\u043A\u043E\u043C \u044F\u0437\u044B\u043A\u0435";\nconst regex = /[\\u0400-\\u04FF]+/g;\n\nconst match = regex.exec(text);\nconsole.log(match[0]); // \'\u041E\u0431\u0440\u0430\u0437\u0435\u0446\'\nconsole.log(regex.lastIndex); // 7\n\nconst match2 = regex.exec(text);\nconsole.log(match2[0]); // \'\u043D\u0430\' (did not log \'text\')\nconsole.log(regex.lastIndex); // 15\n\n// and so on\n```\n\nThe [Unicode property escapes](/en-US/docs/Web/JavaScript/Reference/Regular_expressions/Unicode_character_class_escape) feature provides a simpler way to target particular Unicode ranges, by allowing for statements like `\\p{scx=Cyrl}` (to match any Cyrillic letter), or `\\p{L}/u` (to match a letter from any language).\n\n### Extracting subdomain name from URL\n\n```js\nconst url = "http://xxx.domain.com";\nconsole.log(/^https?:\\/\\/(.+?)\\./.exec(url)[1]); // \'xxx\'\n```\n\n> **Note:** Instead of using regular expressions for parsing URLs, it is usually better to use the browsers built-in URL parser by using the [URL API](/en-US/docs/Web/API/URL_API).\n\n### Building a regular expression from dynamic inputs\n\n```js\nconst breakfasts = ["bacon", "eggs", "oatmeal", "toast", "cereal"];\nconst order = "Let me get some bacon and eggs, please";\n\norder.match(new RegExp(`\\\\b(${breakfasts.join("|")})\\\\b`, "g"));\n// Returns [\'bacon\', \'eggs\']\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n### Firefox-specific notes\n\nStarting with Firefox 34, in the case of a capturing group with quantifiers preventing its exercise, the matched text for a capturing group is now `undefined` instead of an empty string:\n\n```js\n// Firefox 33 or older\n"x".replace(/x(.)?/g, (m, group) => {\n  console.log(`group: ${JSON.stringify(group)}`);\n});\n// group: ""\n\n// Firefox 34 or newer\n"x".replace(/x(.)?/g, (m, group) => {\n  console.log(`group: ${group}`);\n});\n// group: undefined\n```\n\nNote that due to web compatibility, `RegExp.$N` will still return an empty string instead of `undefined` ([bug 1053944](https://bugzil.la/1053944)).\n\n## See also\n\n- [Polyfill of many modern `RegExp` features (`dotAll`, `sticky` flags, named capture groups, etc.) in `core-js`](https://github.com/zloirock/core-js#ecmascript-string-and-regexp)\n- [Regular expressions](/en-US/docs/Web/JavaScript/Guide/Regular_expressions) guide\n- [Regular expressions](/en-US/docs/Web/JavaScript/Reference/Regular_expressions)\n- {{jsxref("String.prototype.match()")}}\n- {{jsxref("String.prototype.replace()")}}\n- {{jsxref("String.prototype.split()")}}\n',
        "input": {
            "index.md": '---\ntitle: RegExp.input ($_)\nslug: Web/JavaScript/Reference/Global_Objects/RegExp/input\npage-type: javascript-static-accessor-property\nstatus:\n  - deprecated\nbrowser-compat: javascript.builtins.RegExp.input\n---\n\n{{JSRef}} {{Deprecated_Header}}\n\n> **Note:** All `RegExp` static properties that expose the last match state globally are deprecated. See [deprecated RegExp features](/en-US/docs/Web/JavaScript/Reference/Deprecated_and_obsolete_features#regexp) for more information.\n\nThe **`RegExp.input`** static accessor property returns the string against which a regular expression is matched. `RegExp.$_` is an alias for this property.\n\n## Description\n\nBecause `input` is a static property of {{jsxref("RegExp")}}, you always use it as `RegExp.input` or `RegExp.$_`, rather than as a property of a `RegExp` object you created.\n\nThe value of `input` updates whenever a `RegExp` (but not a `RegExp` subclass) instance makes a successful match. If no matches have been made, `input` is an empty string. You can set the value of `input`, but this does not affect other behaviors of the regex, and the value will be overwritten again when the next successful match is made.\n\n## Examples\n\n### Using input and $\\_\n\n```js\nconst re = /hi/g;\nre.test("hi there!");\nRegExp.input; // "hi there!"\nre.test("foo"); // new test, non-matching\nRegExp.$_; // "hi there!"\nre.test("hi world!"); // new test, matching\nRegExp.$_; // "hi world!"\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("RegExp/lastMatch", "RegExp.lastMatch ($&amp;)")}}\n- {{jsxref("RegExp/lastParen", "RegExp.lastParen ($+)")}}\n- {{jsxref("RegExp/leftContext", "RegExp.leftContext ($`)")}}\n- {{jsxref("RegExp/rightContext", "RegExp.rightContext ($\')")}}\n- {{jsxref("RegExp/n", "RegExp.$1, \u2026, RegExp.$9")}}\n'
        },
        "lastindex": {
            "index.md": '---\ntitle: "RegExp: lastIndex"\nslug: Web/JavaScript/Reference/Global_Objects/RegExp/lastIndex\npage-type: javascript-instance-data-property\nbrowser-compat: javascript.builtins.RegExp.lastIndex\n---\n\n{{JSRef}}\n\nThe **`lastIndex`** data property of a {{jsxref("RegExp")}} instance specifies the index at which to start the next match.\n\n{{EmbedInteractiveExample("pages/js/regexp-lastindex.html")}}\n\n## Value\n\nA non-negative integer.\n\n{{js_property_attributes(1, 0, 0)}}\n\n## Description\n\nThis property is set only if the regular expression instance used the `g` flag to indicate a global search, or the `y` flag to indicate a sticky search. The following rules apply when {{jsxref("RegExp/exec", "exec()")}} is called on a given input:\n\n- If `lastIndex` is greater than the length of the input, `exec()` will not find a match, and `lastIndex` will be set to 0.\n- If `lastIndex` is equal to or less than the length of the input, `exec()` will attempt to match the input starting from `lastIndex`.\n  - If `exec()` finds a match, then `lastIndex` will be set to the position of the end of the matched string in the input.\n  - If `exec()` does not find a match, then `lastIndex` will be set to 0.\n\nOther regex-related methods, such as {{jsxref("RegExp.prototype.test()")}}, {{jsxref("String.prototype.match()")}}, {{jsxref("String.prototype.replace()")}}, etc., call `exec()` under the hood, so they have different effects on `lastIndex`. See their respective pages for details.\n\n## Examples\n\n### Using lastIndex\n\nConsider the following sequence of statements:\n\n```js\nconst re = /(hi)?/g;\n```\n\nMatches the empty string.\n\n```js\nconsole.log(re.exec("hi"));\nconsole.log(re.lastIndex);\n```\n\nReturns `["hi", "hi"]` with `lastIndex` equal to 2.\n\n```js\nconsole.log(re.exec("hi"));\nconsole.log(re.lastIndex);\n```\n\nReturns `["", undefined]`, an empty array whose zeroth element is the match string. In this case, the empty string because `lastIndex` was 2 (and still is 2) and `hi` has length 2.\n\n### Using lastIndex with sticky regexes\n\nThe `lastIndex` property is writable. You can set it to make the regex start its next search at a given index.\n\nThe `y` flag almost always requires setting `lastIndex`. It always matches strictly at `lastIndex` and does not attempt any later positions. This is usually useful for writing parsers, when you want to match tokens only at the current position.\n\n```js\nconst stringPattern = /"[^"]*"/y;\nconst input = `const message = "Hello world";`;\n\nstringPattern.lastIndex = 6;\nconsole.log(stringPattern.exec(input)); // null\n\nstringPattern.lastIndex = 16;\nconsole.log(stringPattern.exec(input)); // [\'"Hello world"\']\n```\n\n### Rewinding lastIndex\n\nThe `g` flag also benefits from setting `lastIndex`. One common use case is when the string is modified in the middle of a global search. In this case, we may miss a particular match if the string is shortened. We can avoid this by rewinding `lastIndex`.\n\n```js\nconst mdLinkPattern = /\\[[^[\\]]+\\]\\((?<link>[^()\\s]+)\\)/dg;\n\nfunction resolveMDLink(line) {\n  let match;\n  let modifiedLine = line;\n  while ((match = mdLinkPattern.exec(modifiedLine))) {\n    const originalLink = match.groups.link;\n    const resolvedLink = originalLink.replaceAll(/^files|\\/index\\.md$/g, "");\n    modifiedLine =\n      modifiedLine.slice(0, match.indices.groups.link[0]) +\n      resolvedLink +\n      modifiedLine.slice(match.indices.groups.link[1]);\n    // Rewind the pattern to the end of the resolved link\n    mdLinkPattern.lastIndex += resolvedLink.length - originalLink.length;\n  }\n  return modifiedLine;\n}\n\nconsole.log(\n  resolveMDLink(\n    "[`lastIndex`](files/en-us/web/javascript/reference/global_objects/regexp/lastindex/index.md)",\n  ),\n); // [`lastIndex`](/en-us/web/javascript/reference/global_objects/regexp/lastindex)\nconsole.log(\n  resolveMDLink(\n    "[`ServiceWorker`](files/en-us/web/api/serviceworker/index.md) and [`SharedWorker`](files/en-us/web/api/sharedworker/index.md)",\n  ),\n); // [`ServiceWorker`](/en-us/web/api/serviceworker) and [`SharedWorker`](/en-us/web/api/sharedworker)\n```\n\nTry deleting the `mdLinkPattern.lastIndex += resolvedLink.length - originalLink.length` line and running the second example. You will find that the second link is not replaced correctly, because the `lastIndex` is already past the link\'s index after the string is shortened.\n\n> **Warning:** This example is for demonstration only. To deal with Markdown, you should probably use a parsing library instead of regex.\n\n### Optimizing searching\n\nYou can optimize searching by setting `lastIndex` to a point where previous possible occurrences can be ignored. For example, instead of this:\n\n```js\nconst stringPattern = /"[^"]*"/g;\nconst input = `const message = "Hello " + "world";`;\n\n// Pretend we\'ve already dealt with the previous parts of the string\nlet offset = 26;\nconst remainingInput = input.slice(offset);\nconst nextString = stringPattern.exec(remainingInput);\nconsole.log(nextString[0]); // "world"\noffset += nextString.index + nextString.length;\n```\n\nConsider this:\n\n```js\nstringPattern.lastIndex = offset;\nconst nextString = stringPattern.exec(remainingInput);\nconsole.log(nextString[0]); // "world"\noffset = stringPattern.lastIndex;\n```\n\nThis is potentially more performant because we avoid string slicing.\n\n### Avoiding side effects\n\nThe side effects caused by `exec()` can be confusing, especially if the input is different for each `exec()`.\n\n```js\nconst re = /foo/g;\nconsole.log(re.test("foo bar")); // true\nconsole.log(re.test("foo baz")); // false, because lastIndex is non-zero\n```\n\nThis is even more confusing when you are hand-modifying `lastIndex`. To contain the side effects, remember to reset `lastIndex` after each input is completely processed.\n\n```js\nconst re = /foo/g;\nconsole.log(re.test("foo bar")); // true\nre.lastIndex = 0;\nconsole.log(re.test("foo baz")); // true\n```\n\nWith some abstraction, you can require `lastIndex` to be set to a particular value before each `exec()` call.\n\n```js\nfunction createMatcher(pattern) {\n  // Create a copy, so that the original regex is never updated\n  const regex = new RegExp(pattern, "g");\n  return (input, offset) => {\n    regex.lastIndex = offset;\n    return regex.exec(input);\n  };\n}\n\nconst matchFoo = createMatcher(/foo/);\nconsole.log(matchFoo("foo bar", 0)[0]); // "foo"\nconsole.log(matchFoo("foo baz", 0)[0]); // "foo"\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("RegExp.prototype.dotAll")}}\n- {{jsxref("RegExp.prototype.global")}}\n- {{jsxref("RegExp.prototype.hasIndices")}}\n- {{jsxref("RegExp.prototype.ignoreCase")}}\n- {{jsxref("RegExp.prototype.multiline")}}\n- {{jsxref("RegExp.prototype.source")}}\n- {{jsxref("RegExp.prototype.sticky")}}\n- {{jsxref("RegExp.prototype.unicode")}}\n'
        },
        "lastmatch": {
            "index.md": '---\ntitle: RegExp.lastMatch ($&)\nslug: Web/JavaScript/Reference/Global_Objects/RegExp/lastMatch\npage-type: javascript-static-accessor-property\nstatus:\n  - deprecated\nbrowser-compat: javascript.builtins.RegExp.lastMatch\n---\n\n{{JSRef}} {{Deprecated_Header}}\n\n> **Note:** All `RegExp` static properties that expose the last match state globally are deprecated. See [deprecated RegExp features](/en-US/docs/Web/JavaScript/Reference/Deprecated_and_obsolete_features#regexp) for more information.\n\nThe **`RegExp.lastMatch`** static accessor property returns the last matched substring. `RegExp["$&"]` is an alias for this property.\n\n## Description\n\nBecause `lastMatch` is a static property of {{jsxref("RegExp")}}, you always use it as `RegExp.lastMatch` or `RegExp["$&"]`, rather than as a property of a `RegExp` object you created.\n\nThe value of `lastMatch` updates whenever a `RegExp` (but not a `RegExp` subclass) instance makes a successful match. If no matches have been made, `lastMatch` is an empty string. The set accessor of `lastMatch` is `undefined`, so you cannot change this property directly.\n\nYou cannot use the shorthand alias with the dot property accessor (`RegExp.$&`), because `&` is not a valid identifier part, so this causes a {{jsxref("SyntaxError")}}. Use the [bracket notation](/en-US/docs/Web/JavaScript/Reference/Operators/Property_accessors) instead.\n\n`$&` can also be used in the replacement string of {{jsxref("String.prototype.replace()")}}, but that\'s unrelated to the `RegExp["$&"]` legacy property.\n\n## Examples\n\n### Using lastMatch and $&\n\n```js\nconst re = /hi/g;\nre.test("hi there!");\nRegExp.lastMatch; // "hi"\nRegExp["$&"]; // "hi"\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("RegExp/input", "RegExp.input ($_)")}}\n- {{jsxref("RegExp/lastParen", "RegExp.lastParen ($+)")}}\n- {{jsxref("RegExp/leftContext", "RegExp.leftContext ($`)")}}\n- {{jsxref("RegExp/rightContext", "RegExp.rightContext ($\')")}}\n- {{jsxref("RegExp/n", "RegExp.$1, \u2026, RegExp.$9")}}\n'
        },
        "lastparen": {
            "index.md": '---\ntitle: RegExp.lastParen ($+)\nslug: Web/JavaScript/Reference/Global_Objects/RegExp/lastParen\npage-type: javascript-static-accessor-property\nstatus:\n  - deprecated\nbrowser-compat: javascript.builtins.RegExp.lastParen\n---\n\n{{JSRef}} {{Deprecated_Header}}\n\n> **Note:** All `RegExp` static properties that expose the last match state globally are deprecated. See [deprecated RegExp features](/en-US/docs/Web/JavaScript/Reference/Deprecated_and_obsolete_features#regexp) for more information.\n\nThe **`RegExp.lastParen`** static accessor property returns the last parenthesized substring match, if any. `RegExp["$+"]` is an alias for this property.\n\n## Description\n\nBecause `lastParen` is a static property of {{jsxref("RegExp")}}, you always use it as `RegExp.lastParen` or `RegExp["$+"]`, rather than as a property of a `RegExp` object you created.\n\nThe value of `lastParen` updates whenever a `RegExp` (but not a `RegExp` subclass) instance makes a successful match. If no matches have been made, or if the most recent regex execution contains no capturing groups, `lastParen` is an empty string. The set accessor of `lastParen` is `undefined`, so you cannot change this property directly.\n\nYou cannot use the shorthand alias with the dot property accessor (`RegExp.$+`), because `+` is not a valid identifier part, so this causes a {{jsxref("SyntaxError")}}. Use the [bracket notation](/en-US/docs/Web/JavaScript/Reference/Operators/Property_accessors) instead.\n\n## Examples\n\n### Using lastParen and $+\n\n```js\nconst re = /(hi)/g;\nre.test("hi there!");\nRegExp.lastParen; // "hi"\nRegExp["$+"]; // "hi"\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("RegExp/input", "RegExp.input ($_)")}}\n- {{jsxref("RegExp/lastMatch", "RegExp.lastMatch ($&amp;)")}}\n- {{jsxref("RegExp/leftContext", "RegExp.leftContext ($`)")}}\n- {{jsxref("RegExp/rightContext", "RegExp.rightContext ($\')")}}\n- {{jsxref("RegExp/n", "RegExp.$1, \u2026, RegExp.$9")}}\n'
        },
        "leftcontext": {
            "index.md": '---\ntitle: RegExp.leftContext ($`)\nslug: Web/JavaScript/Reference/Global_Objects/RegExp/leftContext\npage-type: javascript-static-accessor-property\nstatus:\n  - deprecated\nbrowser-compat: javascript.builtins.RegExp.leftContext\n---\n\n{{JSRef}} {{Deprecated_Header}}\n\n> **Note:** All `RegExp` static properties that expose the last match state globally are deprecated. See [deprecated RegExp features](/en-US/docs/Web/JavaScript/Reference/Deprecated_and_obsolete_features#regexp) for more information.\n\nThe **`RegExp.leftContext`** static accessor property returns the substring preceding the most recent match. ``RegExp["$`"]`` is an alias for this property.\n\n## Description\n\nBecause `leftContext` is a static property of {{jsxref("RegExp")}}, you always use it as `RegExp.leftContext` or ``RegExp["$`"]``, rather than as a property of a `RegExp` object you created.\n\nThe value of `leftContext` updates whenever a `RegExp` (but not a `RegExp` subclass) instance makes a successful match. If no matches have been made, `leftContext` is an empty string. The set accessor of `leftContext` is `undefined`, so you cannot change this property directly.\n\nYou cannot use the shorthand alias with the dot property accessor (``RegExp.$` ``), because `` ` `` is not a valid identifier part, so this causes a {{jsxref("SyntaxError")}}. Use the [bracket notation](/en-US/docs/Web/JavaScript/Reference/Operators/Property_accessors) instead.\n\n``$` `` can also be used in the replacement string of {{jsxref("String.prototype.replace()")}}, but that\'s unrelated to the ``RegExp["$`"]`` legacy property.\n\n## Examples\n\n### Using leftContext and $\\`\n\n```js\nconst re = /world/g;\nre.test("hello world!");\nRegExp.leftContext; // "hello "\nRegExp["$`"]; // "hello "\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("RegExp/input", "RegExp.input ($_)")}}\n- {{jsxref("RegExp/lastMatch", "RegExp.lastMatch ($&amp;)")}}\n- {{jsxref("RegExp/lastParen", "RegExp.lastParen ($+)")}}\n- {{jsxref("RegExp/rightContext", "RegExp.rightContext ($\')")}}\n- {{jsxref("RegExp/n", "RegExp.$1, \u2026, RegExp.$9")}}\n'
        },
        "multiline": {
            "index.md": '---\ntitle: RegExp.prototype.multiline\nslug: Web/JavaScript/Reference/Global_Objects/RegExp/multiline\npage-type: javascript-instance-accessor-property\nbrowser-compat: javascript.builtins.RegExp.multiline\n---\n\n{{JSRef}}\n\nThe **`multiline`** accessor property of {{jsxref("RegExp")}} instances returns whether or not the `m` flag is used with this regular expression.\n\n{{EmbedInteractiveExample("pages/js/regexp-prototype-multiline.html", "taller")}}\n\n## Description\n\n`RegExp.prototype.multiline` has the value `true` if the `m` flag was used; otherwise, `false`. The `m` flag indicates that a multiline input string should be treated as multiple lines. For example, if `m` is used, `^` and `$` change from matching at only the start or end of the entire string to the start or end of any line within the string.\n\nThe set accessor of `multiline` is `undefined`. You cannot change this property directly.\n\n## Examples\n\n### Using multiline\n\n```js\nconst regex = /foo/m;\n\nconsole.log(regex.multiline); // true\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("RegExp.prototype.lastIndex")}}\n- {{jsxref("RegExp.prototype.dotAll")}}\n- {{jsxref("RegExp.prototype.global")}}\n- {{jsxref("RegExp.prototype.hasIndices")}}\n- {{jsxref("RegExp.prototype.ignoreCase")}}\n- {{jsxref("RegExp.prototype.source")}}\n- {{jsxref("RegExp.prototype.sticky")}}\n- {{jsxref("RegExp.prototype.unicode")}}\n'
        },
        "n": {
            "index.md": '---\ntitle: RegExp.$1, \u2026, RegExp.$9\nslug: Web/JavaScript/Reference/Global_Objects/RegExp/n\npage-type: javascript-static-accessor-property\nstatus:\n  - deprecated\nbrowser-compat: javascript.builtins.RegExp.n\n---\n\n{{JSRef}} {{Deprecated_Header}}\n\n> **Note:** All `RegExp` static properties that expose the last match state globally are deprecated. See [deprecated RegExp features](/en-US/docs/Web/JavaScript/Reference/Deprecated_and_obsolete_features#regexp) for more information.\n\nThe **`RegExp.$1, \u2026, RegExp.$9`** static accessor properties return parenthesized substring matches.\n\n## Description\n\nBecause `$1`\u2013`$9` are static properties of {{jsxref("RegExp")}}, you always use them as `RegExp.$1`, `RegExp.$2`, etc., rather than as properties of a `RegExp` object you created.\n\nThe values of `$1, \u2026, $9` update whenever a `RegExp` (but not a `RegExp` subclass) instance makes a successful match. If no matches have been made, or if the last match does not have the corresponding capturing group, the respective property is an empty string. The set accessor of each property is `undefined`, so you cannot change the properties directly.\n\nThe number of possible parenthesized substrings is unlimited, but the `RegExp` object can only hold the first nine. You can access all parenthesized substrings through the returned array\'s indexes.\n\n`$1, \u2026, $9` can also be used in the replacement string of {{jsxref("String.prototype.replace()")}}, but that\'s unrelated to the `RegExp.$n` legacy properties.\n\n## Examples\n\n### Using $n with RegExp.prototype.test()\n\nThe following script uses the {{jsxref("RegExp.prototype.test()")}} method to grab a number in a generic string.\n\n```js\nconst str = "Test 24";\nconst number = /(\\d+)/.test(str) ? RegExp.$1 : "0";\nnumber; // "24"\n```\n\nPlease note that any operation involving the usage of other regular expressions between a `re.test(str)` call and the `RegExp.$n` property, might have side effects, so that accessing these special properties should be done instantly, otherwise the result might be unexpected.\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("RegExp/input", "RegExp.input ($_)")}}\n- {{jsxref("RegExp/lastMatch", "RegExp.lastMatch ($&amp;)")}}\n- {{jsxref("RegExp/lastParen", "RegExp.lastParen ($+)")}}\n- {{jsxref("RegExp/leftContext", "RegExp.leftContext ($`)")}}\n- {{jsxref("RegExp/rightContext", "RegExp.rightContext ($\')")}}\n'
        },
        "regexp": {
            "index.md": '---\ntitle: RegExp() constructor\nslug: Web/JavaScript/Reference/Global_Objects/RegExp/RegExp\npage-type: javascript-constructor\nbrowser-compat: javascript.builtins.RegExp.RegExp\n---\n\n{{JSRef}}\n\nThe **`RegExp()`** constructor creates {{jsxref("RegExp")}} objects.\n\nFor an introduction to regular expressions, read the [Regular Expressions chapter](/en-US/docs/Web/JavaScript/Guide/Regular_expressions) in the [JavaScript Guide](/en-US/docs/Web/JavaScript/Guide).\n\n{{EmbedInteractiveExample("pages/js/regexp-constructor.html")}}\n\n## Syntax\n\n```js-nolint\nnew RegExp(pattern)\nnew RegExp(pattern, flags)\nRegExp(pattern)\nRegExp(pattern, flags)\n```\n\n> **Note:** `RegExp()` can be called with or without [`new`](/en-US/docs/Web/JavaScript/Reference/Operators/new), but sometimes with different effects. See [Return value](#return_value).\n\n### Parameters\n\n- `pattern`\n\n  - : The text of the regular expression. This can also be another `RegExp` object.\n\n- `flags` {{optional_inline}}\n\n  - : If specified, `flags` is a string that contains the flags to add. Alternatively, if a `RegExp` object is supplied for the `pattern`, the `flags` string will replace any of that object\'s flags (and `lastIndex` will be reset to `0`).\n\n    `flags` may contain any combination of the following characters:\n\n    - [`d` (indices)](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/hasIndices)\n      - : Generate indices for substring matches.\n    - [`g` (global)](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/global)\n      - : Find all matches rather than stopping after the first match.\n    - [`i` (ignore case)](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/ignoreCase)\n      - : When matching, casing differences are ignored.\n    - [`m` (multiline)](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/multiline)\n      - : Treat beginning and end assertions (`^` and `$`) as working over multiple lines. In other words, match the beginning or end of _each_ line (delimited by `\\n` or `\\r`), not only the very beginning or end of the whole input string.\n    - [`s` (dotAll)](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/dotAll)\n      - : Allows `.` to match newlines.\n    - [`u` (unicode)](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/unicode)\n      - : Treat `pattern` as a sequence of Unicode code points.\n    - [`v` (unicodeSets)](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/unicodeSets)\n      - : An upgrade to the `u` flag that enables set notation in character classes as well as properties of strings.\n    - [`y` (sticky)](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/sticky)\n      - : Matches only from the index indicated by the `lastIndex` property of this regular expression in the target string. Does not attempt to match from any later indexes.\n\n### Return value\n\n`RegExp(pattern)` returns `pattern` directly if all of the following are true:\n\n- `RegExp()` is called without [`new`](/en-US/docs/Web/JavaScript/Reference/Operators/new);\n- [`pattern` is a regex](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp#special_handling_for_regexes);\n- `pattern.constructor === RegExp` (usually meaning it\'s not a subclass);\n- `flags` is `undefined`.\n\nIn all other cases, calling `RegExp()` with or without `new` both create a new `RegExp` object. If `pattern` is a regex, the new object\'s [source](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/source) is `pattern.source`; otherwise, its source is `pattern` [coerced to a string](/en-US/docs/Web/JavaScript/Reference/Global_Objects/String#string_coercion). If the `flags` parameter is not `undefined`, the new object\'s [`flags`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/flags) is the parameter\'s value; otherwise, its `flags` is `pattern.flags` (if `pattern` is a regex).\n\n### Exceptions\n\n- {{jsxref("SyntaxError")}}\n  - : Thrown in one of the following cases:\n    - `pattern` cannot be parsed as a valid regular expression.\n    - `flags` contains repeated characters or any character outside of those allowed.\n\n## Examples\n\n### Literal notation and constructor\n\nThere are two ways to create a `RegExp` object: a _literal notation_ and a _constructor_.\n\n- The _literal notation_ takes a pattern between two slashes, followed by optional flags, after the second slash.\n- The _constructor function_ takes either a string or a `RegExp` object as its first parameter and a string of optional flags as its second parameter.\n\nThe following three expressions create the same regular expression:\n\n```js\n/ab+c/i;\nnew RegExp(/ab+c/, "i"); // literal notation\nnew RegExp("ab+c", "i"); // constructor\n```\n\nBefore regular expressions can be used, they have to be compiled. This process allows them to perform matches more efficiently. There are two ways to compile and get a `RegExp` object.\n\nThe literal notation results in compilation of the regular expression when the expression is evaluated. On the other hand, the constructor of the `RegExp` object, `new RegExp(\'ab+c\')`, results in runtime compilation of the regular expression.\n\nUse a string as the first argument to the `RegExp()` constructor when you want to [build the regular expression from dynamic input](#building_a_regular_expression_from_dynamic_inputs).\n\n### Building a regular expression from dynamic inputs\n\n```js\nconst breakfasts = ["bacon", "eggs", "oatmeal", "toast", "cereal"];\nconst order = "Let me get some bacon and eggs, please";\n\norder.match(new RegExp(`\\\\b(${breakfasts.join("|")})\\\\b`, "g"));\n// Returns [\'bacon\', \'eggs\']\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of many modern `RegExp` features (`dotAll`, `sticky` flags, named capture groups, etc.) in `core-js`](https://github.com/zloirock/core-js#ecmascript-string-and-regexp)\n- [Regular expressions](/en-US/docs/Web/JavaScript/Guide/Regular_expressions) guide\n- {{jsxref("String.prototype.match()")}}\n- {{jsxref("String.prototype.replace()")}}\n'
        },
        "rightcontext": {
            "index.md": '---\ntitle: RegExp.rightContext ($\')\nslug: Web/JavaScript/Reference/Global_Objects/RegExp/rightContext\npage-type: javascript-static-accessor-property\nstatus:\n  - deprecated\nbrowser-compat: javascript.builtins.RegExp.rightContext\n---\n\n{{JSRef}} {{Deprecated_Header}}\n\n> **Note:** All `RegExp` static properties that expose the last match state globally are deprecated. See [deprecated RegExp features](/en-US/docs/Web/JavaScript/Reference/Deprecated_and_obsolete_features#regexp) for more information.\n\nThe **`RegExp.rightContext`** static accessor property returns the substring following the most recent match. `RegExp["$\'"]` is an alias for this property.\n\n## Description\n\nBecause `rightContext` is a static property of {{jsxref("RegExp")}}, you always use it as `RegExp.rightContext` or `RegExp["$\'"]`, rather than as a property of a `RegExp` object you created.\n\nThe value of `rightContext` updates whenever a `RegExp` (but not a `RegExp` subclass) instance makes a successful match. If no matches have been made, `rightContext` is an empty string. The set accessor of `rightContext` is `undefined`, so you cannot change this property directly.\n\nYou cannot use the shorthand alias with the dot property accessor (`RegExp.$\'`), because `\'` is not a valid identifier part, so this causes a {{jsxref("SyntaxError")}}. Use the [bracket notation](/en-US/docs/Web/JavaScript/Reference/Operators/Property_accessors) instead.\n\n`$\'` can also be used in the replacement string of {{jsxref("String.prototype.replace()")}}, but that\'s unrelated to the `RegExp["$\'"]` legacy property.\n\n## Examples\n\n### Using rightContext and $\'\n\n```js\nconst re = /hello/g;\nre.test("hello world!");\nRegExp.rightContext; // " world!"\nRegExp["$\'"]; // " world!"\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("RegExp/input", "RegExp.input ($_)")}}\n- {{jsxref("RegExp/lastMatch", "RegExp.lastMatch ($&amp;)")}}\n- {{jsxref("RegExp/lastParen", "RegExp.lastParen ($+)")}}\n- {{jsxref("RegExp/leftContext", "RegExp.leftContext ($`)")}}\n- {{jsxref("RegExp/n", "RegExp.$1, \u2026, RegExp.$9")}}\n'
        },
        "source": {
            "index.md": '---\ntitle: RegExp.prototype.source\nslug: Web/JavaScript/Reference/Global_Objects/RegExp/source\npage-type: javascript-instance-accessor-property\nbrowser-compat: javascript.builtins.RegExp.source\n---\n\n{{JSRef}}\n\nThe **`source`** accessor property of {{jsxref("RegExp")}} instances returns a string containing the source text of this regular expression, without the two forward slashes on both sides or any flags.\n\n{{EmbedInteractiveExample("pages/js/regexp-prototype-source.html")}}\n\n## Description\n\nConceptually, the `source` property is the text between the two forward slashes in the regular expression literal. The language requires the returned string to be properly escaped, so that when the `source` is concatenated with a forward slash on both ends, it would form a parsable regex literal. For example, for `new RegExp("/")`, the `source` is `\\\\/`, because if it generates `/`, the resulting literal becomes `///`, which is a line comment. Similarly, all [line terminators](/en-US/docs/Web/JavaScript/Reference/Lexical_grammar#line_terminators) will be escaped because line terminator _characters_ would break up the regex literal. There\'s no requirement for other characters, as long as the result is parsable. For empty regular expressions, the string `(?:)` is returned.\n\n## Examples\n\n### Using source\n\n```js\nconst regex = /fooBar/gi;\n\nconsole.log(regex.source); // "fooBar", doesn\'t contain /.../ and "gi".\n```\n\n### Empty regular expressions and escaping\n\n```js\nnew RegExp().source; // "(?:)"\n\nnew RegExp("\\n").source === "\\\\n"; // true, starting with ES5\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("RegExp.prototype.flags")}}\n'
        },
        "sticky": {
            "index.md": '---\ntitle: RegExp.prototype.sticky\nslug: Web/JavaScript/Reference/Global_Objects/RegExp/sticky\npage-type: javascript-instance-accessor-property\nbrowser-compat: javascript.builtins.RegExp.sticky\n---\n\n{{JSRef}}\n\nThe **`sticky`** accessor property of {{jsxref("RegExp")}} instances returns whether or not the `y` flag is used with this regular expression.\n\n{{EmbedInteractiveExample("pages/js/regexp-prototype-sticky.html", "taller")}}\n\n## Description\n\n`RegExp.prototype.sticky` has the value `true` if the `y` flag was used; otherwise, `false`. The `y` flag indicates that the regex attempts to match the target string only from the index indicated by the {{jsxref("RegExp/lastIndex", "lastIndex")}} property (and unlike a global regex, does not attempt to match from any later indexes).\n\nThe set accessor of `sticky` is `undefined`. You cannot change this property directly.\n\nFor both sticky regexes and [global](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/global) regexes:\n\n- They start matching at `lastIndex`.\n- When the match succeeds, `lastIndex` is advanced to the end of the match.\n- When `lastIndex` is out of bounds of the currently matched string, `lastIndex` is reset to 0.\n\nHowever, for the [`exec()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/exec) method, the behavior when matching fails is different:\n\n- When the [`exec()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/exec) method is called on a sticky regex, if the regex fails to match at `lastIndex`, the regex immediately returns `null` and resets `lastIndex` to 0.\n- When the [`exec()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/exec) method is called on a global regex, if the regex fails to match at `lastIndex`, it tries to match from the next character, and so on until a match is found or the end of the string is reached.\n\nFor the [`exec()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/exec) method, a regex that\'s both sticky and global behaves the same as a sticky and non-global regex. Because [`test()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/test) is a simple wrapper around `exec()`, `test()` would ignore the global flag and perform sticky matches as well. However, due to many other methods special-casing the behavior of global regexes, the global flag is, in general, orthogonal to the sticky flag.\n\n- [`String.prototype.matchAll()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/matchAll) (which calls [`RegExp.prototype[@@matchAll]()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/@@matchAll)): `y`, `g` and `gy` are all different.\n  - For `y` regexes: `matchAll()` throws; `[@@matchAll]()` yields the `exec()` result exactly once, without updating the regex\'s `lastIndex`.\n  - For `g` or `gy` regexes: returns an iterator that yields a sequence of `exec()` results.\n- [`String.prototype.match()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/match) (which calls [`RegExp.prototype[@@match]()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/@@match)): `y`, `g` and `gy` are all different.\n  - For `y` regexes: returns the `exec()` result and updates the regex\'s `lastIndex`.\n  - For `g` or `gy` regexes: returns an array of all `exec()` results.\n- [`String.prototype.search()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/search) (which calls [`RegExp.prototype[@@search]()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/@@search)): the `g` flag is always irrelevant.\n  - For `y` or `gy` regexes: always returns `0` (if the very beginning of the string matches) or `-1` (if the beginning doesn\'t match), without updating the regex\'s `lastIndex` when it exits.\n  - For `g` regexes: returns the index of the first match in the string, or `-1` if no match is found.\n- [`String.prototype.split()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/split) (which calls [`RegExp.prototype[@@split]()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/@@split)): `y`, `g`, and `gy` all have the same behavior.\n- [`String.prototype.replace()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/replace) (which calls [`RegExp.prototype[@@replace]()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/@@replace)): `y`, `g` and `gy` are all different.\n  - For `y` regexes: replaces once at the current `lastIndex` and updates `lastIndex`.\n  - For `g` and `gy` regexes: replaces all occurrences matched by `exec()`.\n- [`String.prototype.replaceAll()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/replaceAll) (which calls [`RegExp.prototype[@@replace]()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/@@replace)): `y`, `g` and `gy` are all different.\n  - For `y` regexes: `replaceAll()` throws.\n  - For `g` and `gy` regexes: replaces all occurrences matched by `exec()`.\n\n## Examples\n\n### Using a regular expression with the sticky flag\n\n```js\nconst str = "#foo#";\nconst regex = /foo/y;\n\nregex.lastIndex = 1;\nregex.test(str); // true\nregex.lastIndex = 5;\nregex.test(str); // false (lastIndex is taken into account with sticky flag)\nregex.lastIndex; // 0 (reset after match failure)\n```\n\n### Anchored sticky flag\n\nFor several versions, Firefox\'s SpiderMonkey engine had [a bug](https://bugzil.la/773687) with regard to the `^` assertion and the sticky flag which allowed expressions starting with the `^` assertion and using the sticky flag to match when they shouldn\'t. The bug was introduced some time after Firefox 3.6 (which had the sticky flag but not the bug) and fixed in 2015. Perhaps because of the bug, the specification [specifically calls out](https://tc39.es/ecma262/multipage/text-processing.html#sec-compileassertion) the fact that:\n\n> Even when the `y` flag is used with a pattern, `^` always matches only at the beginning of _Input_, or (if _rer_.[[Multiline]] is `true`) at the beginning of a line.\n\nExamples of correct behavior:\n\n```js\nconst regex = /^foo/y;\nregex.lastIndex = 2;\nregex.test("..foo"); // false - index 2 is not the beginning of the string\n\nconst regex2 = /^foo/my;\nregex2.lastIndex = 2;\nregex2.test("..foo"); // false - index 2 is not the beginning of the string or line\nregex2.lastIndex = 2;\nregex2.test(".\\nfoo"); // true - index 2 is the beginning of a line\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of the `sticky` flag in `core-js`](https://github.com/zloirock/core-js#ecmascript-string-and-regexp)\n- {{jsxref("RegExp.prototype.lastIndex")}}\n- {{jsxref("RegExp.prototype.dotAll")}}\n- {{jsxref("RegExp.prototype.global")}}\n- {{jsxref("RegExp.prototype.hasIndices")}}\n- {{jsxref("RegExp.prototype.ignoreCase")}}\n- {{jsxref("RegExp.prototype.multiline")}}\n- {{jsxref("RegExp.prototype.source")}}\n- {{jsxref("RegExp.prototype.unicode")}}\n'
        },
        "test": {
            "index.md": '---\ntitle: RegExp.prototype.test()\nslug: Web/JavaScript/Reference/Global_Objects/RegExp/test\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.RegExp.test\n---\n\n{{JSRef}}\n\nThe **`test()`** method of {{jsxref("RegExp")}} instances executes a search with this regular expression for a match between a regular expression and a specified string. Returns `true` if there is a match; `false` otherwise.\n\nJavaScript {{jsxref("RegExp")}} objects are **stateful** when they have\nthe {{jsxref("RegExp/global", "global")}} or {{jsxref("RegExp/sticky", "sticky")}} flags\nset (e.g., `/foo/g` or `/foo/y`). They store a\n{{jsxref("RegExp/lastIndex", "lastIndex")}} from the previous match. Using this\ninternally, `test()` can be used to iterate over multiple matches in a string\nof text (with capture groups).\n\n{{EmbedInteractiveExample("pages/js/regexp-prototype-test.html", "taller")}}\n\n## Syntax\n\n```js-nolint\ntest(str)\n```\n\n### Parameters\n\n- `str`\n  - : The string against which to match the regular expression. All values are [coerced to strings](/en-US/docs/Web/JavaScript/Reference/Global_Objects/String#string_coercion), so omitting it or passing `undefined` causes `test()` to search for the string `"undefined"`, which is rarely what you want.\n\n### Return value\n\n`true` if there is a match between the regular expression and the string\n`str`. Otherwise, `false`.\n\n## Description\n\nUse `test()` whenever you want to know whether a pattern is found in a\nstring. `test()` returns a boolean, unlike the\n{{jsxref("String.prototype.search()")}} method (which returns the index of a match, or\n`-1` if not found).\n\nTo get more information (but with slower execution), use the\n{{jsxref("RegExp/exec", "exec()")}} method. (This is similar to the\n{{jsxref("String.prototype.match()")}} method.)\n\nAs with `exec()` (or in combination with it), `test()` called\nmultiple times on the same global regular expression instance will advance past the\nprevious match.\n\n## Examples\n\n### Using test()\n\nSimple example that tests if `"hello"` is contained at the very beginning of\na string, returning a boolean result.\n\n```js\nconst str = "hello world!";\nconst result = /^hello/.test(str);\n\nconsole.log(result); // true\n```\n\nThe following example logs a message which depends on the success of the test:\n\n```js\nfunction testInput(re, str) {\n  const midstring = re.test(str) ? "contains" : "does not contain";\n  console.log(`${str} ${midstring} ${re.source}`);\n}\n```\n\n### Using test() on a regex with the "global" flag\n\nWhen a regex has the [global flag](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/global) set,\n`test()` will advance the {{jsxref("RegExp/lastIndex", "lastIndex")}} of the regex.\n({{jsxref("RegExp.prototype.exec()")}} also advances the `lastIndex` property.)\n\nFurther calls to `test(str)` will resume searching\n`str` starting from `lastIndex`. The\n`lastIndex` property will continue to increase each time `test()`\nreturns `true`.\n\n> **Note:** As long as `test()` returns `true`,\n> `lastIndex` will _not_ reset\u2014even when testing a different string!\n\nWhen `test()` returns `false`, the calling regex\'s\n`lastIndex` property will reset to `0`.\n\nThe following example demonstrates this behavior:\n\n```js\nconst regex = /foo/g; // the "global" flag is set\n\n// regex.lastIndex is at 0\nregex.test("foo"); // true\n\n// regex.lastIndex is now at 3\nregex.test("foo"); // false\n\n// regex.lastIndex is at 0\nregex.test("barfoo"); // true\n\n// regex.lastIndex is at 6\nregex.test("foobar"); // false\n\n// regex.lastIndex is at 0\nregex.test("foobarfoo"); // true\n\n// regex.lastIndex is at 3\nregex.test("foobarfoo"); // true\n\n// regex.lastIndex is at 9\nregex.test("foobarfoo"); // false\n\n// regex.lastIndex is at 0\n// (...and so on)\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Regular expressions](/en-US/docs/Web/JavaScript/Guide/Regular_expressions) guide\n- {{jsxref("RegExp")}}\n'
        },
        "tostring": {
            "index.md": '---\ntitle: RegExp.prototype.toString()\nslug: Web/JavaScript/Reference/Global_Objects/RegExp/toString\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.RegExp.toString\n---\n\n{{JSRef}}\n\nThe **`toString()`** method of {{jsxref("RegExp")}} instances returns a string representing this regular expression.\n\n{{EmbedInteractiveExample("pages/js/regexp-prototype-tostring.html", "taller")}}\n\n## Syntax\n\n```js-nolint\ntoString()\n```\n\n### Parameters\n\nNone.\n\n### Return value\n\nA string representing the given object.\n\n## Description\n\nThe {{jsxref("RegExp")}} object overrides the `toString()` method of the {{jsxref("Object")}} object; it does not inherit {{jsxref("Object.prototype.toString()")}}. For {{jsxref("RegExp")}} objects, the `toString()` method returns a string representation of the regular expression.\n\nIn practice, it reads the regex\'s [`source`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/source) and [`flags`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/flags) properties and returns a string in the form `/source/flags`. The `toString()` return value is guaranteed to be a parsable regex literal, although it may not be the exact same text as what was originally specified for the regex (for example, the flags may be reordered).\n\n## Examples\n\n### Using toString()\n\nThe following example displays the string value of a {{jsxref("RegExp")}} object:\n\n```js\nconst myExp = new RegExp("a+b+c");\nconsole.log(myExp.toString()); // \'/a+b+c/\'\n\nconst foo = new RegExp("bar", "g");\nconsole.log(foo.toString()); // \'/bar/g\'\n```\n\n### Empty regular expressions and escaping\n\nSince `toString()` accesses the [`source`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/source) property, an empty regular expression returns the string `"/(?:)/"`, and line terminators such as `\\n` are escaped. This makes the returned value always a valid regex literal.\n\n```js\nnew RegExp().toString(); // "/(?:)/"\n\nnew RegExp("\\n").toString() === "/\\\\n/"; // true\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Object.prototype.toString()")}}\n'
        },
        "unicode": {
            "index.md": '---\ntitle: RegExp.prototype.unicode\nslug: Web/JavaScript/Reference/Global_Objects/RegExp/unicode\npage-type: javascript-instance-accessor-property\nbrowser-compat: javascript.builtins.RegExp.unicode\n---\n\n{{JSRef}}\n\nThe **`unicode`** accessor property of {{jsxref("RegExp")}} instances returns whether or not the `u` flag is used with this regular expression.\n\n{{EmbedInteractiveExample("pages/js/regexp-prototype-unicode.html", "taller")}}\n\n## Description\n\n`RegExp.prototype.unicode` has the value `true` if the `u` flag was used; otherwise, `false`. The `u` flag enables various Unicode-related features. With the "u" flag:\n\n- Any [Unicode code point escapes](/en-US/docs/Web/JavaScript/Reference/Regular_expressions/Unicode_character_class_escape) (`\\u{xxxx}`, `\\p{UnicodePropertyValue}`) will be interpreted as such instead of identity escapes. For example `/\\u{61}/u` matches `"a"`, but `/\\u{61}/` (without `u` flag) matches `"u".repeat(61)`, where the `\\u` is equivalent to a single `u`.\n- Surrogate pairs will be interpreted as whole characters instead of two separate characters. For example, `/[\uD83D\uDE04]/u` would only match `"\uD83D\uDE04"` but not `"\ud83d"`.\n- When [`lastIndex`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/lastIndex) is automatically advanced (such as when calling [`exec()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/exec)), unicode regexes advance by Unicode code points instead of UTF-16 code units.\n\nThere are other changes to the parsing behavior that prevent possible syntax mistakes (which are analogous to [strict mode](/en-US/docs/Web/JavaScript/Reference/Strict_mode) for regex syntax). These syntaxes are all [deprecated and only kept for web compatibility](/en-US/docs/Web/JavaScript/Reference/Deprecated_and_obsolete_features#regexp), and you should not rely on them.\n\nThe set accessor of `unicode` is `undefined`. You cannot change this property directly.\n\n### Unicode-aware mode\n\nWhen we refer to _Unicode-aware mode_, we mean the regex has either the `u` or the [`v`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/unicodeSets) flag, in which case the regex enables Unicode-related features (such as [Unicode character class escape](/en-US/docs/Web/JavaScript/Reference/Regular_expressions/Unicode_character_class_escape)) and has much stricter syntax rules. Because `u` and `v` interpret the same regex in incompatible ways, using both flags results in a {{jsxref("SyntaxError")}}.\n\nSimilarly, a regex is _Unicode-unaware_ if it has neither the `u` nor the `v` flag. In this case, the regex is interpreted as a sequence of UTF-16 code units, and there are many legacy syntaxes that do not become syntax errors.\n\n## Examples\n\n### Using the unicode property\n\n```js\nconst regex = /\\u{61}/u;\n\nconsole.log(regex.unicode); // true\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("RegExp.prototype.lastIndex")}}\n- {{jsxref("RegExp.prototype.dotAll")}}\n- {{jsxref("RegExp.prototype.global")}}\n- {{jsxref("RegExp.prototype.hasIndices")}}\n- {{jsxref("RegExp.prototype.ignoreCase")}}\n- {{jsxref("RegExp.prototype.multiline")}}\n- {{jsxref("RegExp.prototype.source")}}\n- {{jsxref("RegExp.prototype.sticky")}}\n'
        },
        "unicodesets": {
            "index.md": '---\ntitle: RegExp.prototype.unicodeSets\nslug: Web/JavaScript/Reference/Global_Objects/RegExp/unicodeSets\npage-type: javascript-instance-accessor-property\nbrowser-compat: javascript.builtins.RegExp.unicodeSets\n---\n\n{{JSRef}}\n\nThe **`unicodeSets`** accessor property of {{jsxref("RegExp")}} instances returns whether or not the `v` flag is used with this regular expression.\n\n## Description\n\n`RegExp.prototype.unicodeSets` has the value `true` if the `v` flag was used; otherwise, `false`. The `v` flag is an "upgrade" to the [`u`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/unicode) flag that enables more Unicode-related features. ("v" is the next letter after "u" in the alphabet.) Because `u` and `v` interpret the same regex in incompatible ways, using both flags results in a {{jsxref("SyntaxError")}}. With the `v` flag, you get all features mentioned in the `u` flag description, plus:\n\n- The [`\\p`](/en-US/docs/Web/JavaScript/Reference/Regular_expressions/Unicode_character_class_escape) escape sequence can be additionally used to match properties of strings, instead of just characters.\n- The [character class](/en-US/docs/Web/JavaScript/Reference/Regular_expressions/Character_class) syntax is upgraded to allow intersection, union, and subtraction syntaxes, as well as matching multiple Unicode characters.\n- The character class complement syntax `[^...]` constructs a complement class instead of negating the match result, avoiding some confusing behaviors with case-insensitive matching. For more information, see [Complement classes and case-insensitive matching](/en-US/docs/Web/JavaScript/Reference/Regular_expressions/Character_class#complement_classes_and_case-insensitive_matching).\n\nSome valid `u`-mode regexes become invalid in `v`-mode. Specifically, the character class syntax is different and some characters can no longer appear literally. For more information, see [`v`-mode character class](/en-US/docs/Web/JavaScript/Reference/Regular_expressions/Character_class#v-mode_character_class).\n\n> **Note:** The `v` mode does not interpret grapheme clusters as single characters; they are still multiple code points. For example, `/[\uD83C\uDDFA\uD83C\uDDF3]/v` is still able to match `"\uD83C\uDDFA"`.\n\nThe set accessor of `unicodeSets` is `undefined`. You cannot change this property directly.\n\n## Examples\n\n### Using the unicodeSets property\n\n```js\nconst regex = /[\\p{Script_Extensions=Greek}&&\\p{Letter}]/v;\n\nconsole.log(regex.unicodeSets); // true\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("RegExp.prototype.lastIndex")}}\n- {{jsxref("RegExp.prototype.dotAll")}}\n- {{jsxref("RegExp.prototype.global")}}\n- {{jsxref("RegExp.prototype.hasIndices")}}\n- {{jsxref("RegExp.prototype.ignoreCase")}}\n- {{jsxref("RegExp.prototype.multiline")}}\n- {{jsxref("RegExp.prototype.source")}}\n- {{jsxref("RegExp.prototype.sticky")}}\n- {{jsxref("RegExp.prototype.unicode")}}\n- [RegExp v flag with set notation and properties of strings](https://v8.dev/features/regexp-v-flag) on v8.dev (2022)\n'
        }
    },
    "set": {
        "@@iterator": {
            "index.md": '---\ntitle: Set.prototype[@@iterator]()\nslug: Web/JavaScript/Reference/Global_Objects/Set/@@iterator\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Set.@@iterator\n---\n\n{{JSRef}}\n\nThe **`[@@iterator]()`** method of {{jsxref("Set")}} instances implements the [iterable protocol](/en-US/docs/Web/JavaScript/Reference/Iteration_protocols) and allows `Set` objects to be consumed by most syntaxes expecting iterables, such as the [spread syntax](/en-US/docs/Web/JavaScript/Reference/Operators/Spread_syntax) and {{jsxref("Statements/for...of", "for...of")}} loops. It returns a [set iterator object](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Iterator) that yields the values of the set in insertion order.\n\nThe initial value of this property is the same function object as the initial value of the {{jsxref("Set.prototype.values")}} property.\n\n{{EmbedInteractiveExample("pages/js/set-prototype-@@iterator.html")}}\n\n## Syntax\n\n```js-nolint\nset[Symbol.iterator]()\n```\n\n### Parameters\n\nNone.\n\n### Return value\n\nThe same return value as {{jsxref("Set.prototype.values()")}}: a new [iterable iterator object](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Iterator) that yields the values of the set.\n\n## Examples\n\n### Iteration using for...of loop\n\nNote that you seldom need to call this method directly. The existence of the `@@iterator` method makes `Set` objects [iterable](/en-US/docs/Web/JavaScript/Reference/Iteration_protocols#the_iterable_protocol), and iterating syntaxes like the `for...of` loop automatically call this method to obtain the iterator to loop over.\n\n```js\nconst mySet = new Set();\nmySet.add("0");\nmySet.add(1);\nmySet.add({});\n\nfor (const v of mySet) {\n  console.log(v);\n}\n```\n\n### Manually hand-rolling the iterator\n\nYou may still manually call the `next()` method of the returned iterator object to achieve maximum control over the iteration process.\n\n```js\nconst mySet = new Set();\nmySet.add("0");\nmySet.add(1);\nmySet.add({});\n\nconst setIter = mySet[Symbol.iterator]();\n\nconsole.log(setIter.next().value); // "0"\nconsole.log(setIter.next().value); // 1\nconsole.log(setIter.next().value); // {}\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Set")}}\n- {{jsxref("Set.prototype.entries()")}}\n- {{jsxref("Set.prototype.keys()")}}\n- {{jsxref("Set.prototype.values()")}}\n- {{jsxref("Symbol.iterator")}}\n- [Iteration protocols](/en-US/docs/Web/JavaScript/Reference/Iteration_protocols)\n'
        },
        "@@species": {
            "index.md": '---\ntitle: Set[@@species]\nslug: Web/JavaScript/Reference/Global_Objects/Set/@@species\npage-type: javascript-static-accessor-property\nbrowser-compat: javascript.builtins.Set.@@species\n---\n\n{{JSRef}}\n\nThe **`Set[@@species]`** static accessor property is an unused accessor property specifying how to copy `Set` objects.\n\n## Syntax\n\n```js-nolint\nSet[Symbol.species]\n```\n\n### Return value\n\nThe value of the constructor (`this`) on which `get @@species` was called. The return value is used to construct copied `Set` instances.\n\n## Description\n\nThe `@@species` accessor property returns the default constructor for `Set` objects. Subclass constructors may override it to change the constructor assignment.\n\n> **Note:** This property is currently unused by all `Set` methods.\n\n## Examples\n\n### Species in ordinary objects\n\nThe `@@species` property returns the default constructor function, which is the `Set` constructor for `Set`.\n\n```js\nSet[Symbol.species]; // function Set()\n```\n\n### Species in derived objects\n\nIn an instance of a custom `Set` subclass, such as `MySet`, the `MySet` species is the `MySet` constructor. However, you might want to overwrite this, in order to return parent `Set` objects in your derived class methods:\n\n```js\nclass MySet extends Set {\n  // Overwrite MySet species to the parent Set constructor\n  static get [Symbol.species]() {\n    return Set;\n  }\n}\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Set")}}\n- {{jsxref("Symbol.species")}}\n'
        },
        "add": {
            "index.md": '---\ntitle: Set.prototype.add()\nslug: Web/JavaScript/Reference/Global_Objects/Set/add\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Set.add\n---\n\n{{JSRef}}\n\nThe **`add()`** method of {{jsxref("Set")}} instances inserts a new element with a specified value in to this set, if there isn\'t an element with the same value already in this set\n\n{{EmbedInteractiveExample("pages/js/set-prototype-add.html")}}\n\n## Syntax\n\n```js-nolint\nadd(value)\n```\n\n### Parameters\n\n- `value`\n  - : The value of the element to add to the `Set` object.\n\n### Return value\n\nThe `Set` object with added value.\n\n## Examples\n\n### Using the add() method\n\n```js\nconst mySet = new Set();\n\nmySet.add(1);\nmySet.add(5).add("some text"); // chainable\n\nconsole.log(mySet);\n// Set [1, 5, "some text"]\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Set")}}\n- {{jsxref("Set.prototype.delete()")}}\n- {{jsxref("Set.prototype.has()")}}\n'
        },
        "clear": {
            "index.md": '---\ntitle: Set.prototype.clear()\nslug: Web/JavaScript/Reference/Global_Objects/Set/clear\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Set.clear\n---\n\n{{JSRef}}\n\nThe **`clear()`** method of {{jsxref("Set")}} instances removes all elements from this set.\n\n{{EmbedInteractiveExample("pages/js/set-prototype-clear.html")}}\n\n## Syntax\n\n```js-nolint\nclear()\n```\n\n### Parameters\n\nNone.\n\n### Return value\n\nNone ({{jsxref("undefined")}}).\n\n## Examples\n\n### Using the clear() method\n\n```js\nconst mySet = new Set();\nmySet.add(1);\nmySet.add("foo");\n\nconsole.log(mySet.size); // 2\nconsole.log(mySet.has("foo")); // true\n\nmySet.clear();\n\nconsole.log(mySet.size); // 0\nconsole.log(mySet.has("foo")); // false\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Set")}}\n- {{jsxref("Set.prototype.delete()")}}\n'
        },
        "delete": {
            "index.md": '---\ntitle: Set.prototype.delete()\nslug: Web/JavaScript/Reference/Global_Objects/Set/delete\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Set.delete\n---\n\n{{JSRef}}\n\nThe **`delete()`** method of {{jsxref("Set")}} instances removes a specified value from this set, if it is in the set.\n\n{{EmbedInteractiveExample("pages/js/set-prototype-delete.html")}}\n\n## Syntax\n\n```js-nolint\nsetInstance.delete(value)\n```\n\n### Parameters\n\n- `value`\n  - : The value to remove from `Set`.\n\n### Return value\n\nReturns `true` if `value` was already in\n`Set`; otherwise `false`.\n\n## Examples\n\n### Using the delete() method\n\n```js\nconst mySet = new Set();\nmySet.add("foo");\n\nconsole.log(mySet.delete("bar")); // false; no "bar" element found to be deleted.\nconsole.log(mySet.delete("foo")); // true; successfully removed.\n\nconsole.log(mySet.has("foo")); // false; the "foo" element is no longer present.\n```\n\n### Deleting an object from a set\n\nBecause objects are compared by reference, you have to delete them by checking individual properties if you don\'t have a reference to the original object.\n\n```js\nconst setObj = new Set(); // Create a new set.\n\nsetObj.add({ x: 10, y: 20 }); // Add object in the set.\n\nsetObj.add({ x: 20, y: 30 }); // Add object in the set.\n\n// Delete any point with `x > 10`.\nsetObj.forEach((point) => {\n  if (point.x > 10) {\n    setObj.delete(point);\n  }\n});\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Set")}}\n- {{jsxref("Set.prototype.clear()")}}\n'
        },
        "difference": {
            "diagram.svg": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 200" xml:space="preserve"><style>.st1{fill:none;stroke:#231f20;stroke-miterlimit:10}</style><path d="M115 100c0-25.91 14.08-48.51 35-60.61A69.667 69.667 0 0 0 115 30c-38.66 0-70 31.34-70 70s31.34 70 70 70c12.75 0 24.7-3.43 35-9.39-20.92-12.1-35-34.7-35-60.61z" style="fill:#39cac4"/><circle class="st1" cx="115" cy="100" r="70"/><circle class="st1" cx="185" cy="100" r="70"/><text transform="translate(99.37 50.4)">A</text><text transform="translate(190.014 50.4)">B</text></svg>\n',
            "index.md": '---\ntitle: Set.prototype.difference()\nslug: Web/JavaScript/Reference/Global_Objects/Set/difference\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Set.difference\n---\n\n{{JSRef}}\n\nThe **`difference()`** method of {{jsxref("Set")}} instances takes a set and returns a new set containing elements in this set but not in the given set.\n\n## Syntax\n\n```js-nolint\ndifference(other)\n```\n\n### Parameters\n\n- `other`\n  - : A {{jsxref("Set")}} object, or [set-like](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Set#set-like_objects) object.\n\n### Return value\n\nA new {{jsxref("Set")}} object containing elements in this set but not in the `other` set.\n\n## Description\n\nIn mathematical notation, _difference_ is defined as:\n\n<math display="block"><semantics><mrow><mi>A</mi><mo>\u2216</mo><mi>B</mi><mo>=</mo><mo stretchy="false">{</mo><mi>x</mi><mo>\u220A</mo><mi>A</mi><mo>\u2223</mo><mi>x</mi><mo>\u2209</mo><mi>B</mi><mo stretchy="false">}</mo></mrow><annotation encoding="TeX">A\\setminus B = \\{x\\in A\\mid x\\notin B\\}</annotation></semantics></math>\n\nAnd using Venn diagram:\n\n![A Venn diagram where two circles overlap. The difference of A and B is the part of A that is not overlapping B.](diagram.svg)\n\n`difference()` accepts [set-like](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Set#set-like_objects) objects as the `other` parameter. It requires {{jsxref("Operators/this", "this")}} to be an actual {{jsxref("Set")}} instance, because it directly retrieves the underlying data stored in `this` without invoking any user code. Then, its behavior depends on the sizes of `this` and `other`:\n\n- If there are more elements in `this` than `other.size`, then it iterates over `other` by calling its `keys()` method, and constructs a new set with all elements in `this` that are not seen in `other`.\n- Otherwise, it iterates over the elements in `this`, and constructs a new set with all elements `e` in `this` that cause `other.has(e)` to return a [falsy](/en-US/docs/Glossary/Falsy) value.\n\nThe order of elements in the returned set is the same as in `this`.\n\n## Examples\n\n### Using difference()\n\nThe following example computes the difference between the set of odd numbers (<10) and the set of perfect squares (<10). The result is the set of odd numbers that are not perfect squares.\n\n```js\nconst odds = new Set([1, 3, 5, 7, 9]);\nconst squares = new Set([1, 4, 9]);\nconsole.log(odds.difference(squares)); // Set(3) { 3, 5, 7 }\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Set.prototype.difference` in `core-js`](https://github.com/zloirock/core-js#new-set-methods)\n- {{jsxref("Set.prototype.intersection()")}}\n- {{jsxref("Set.prototype.isDisjointFrom()")}}\n- {{jsxref("Set.prototype.isSubsetOf()")}}\n- {{jsxref("Set.prototype.isSupersetOf()")}}\n- {{jsxref("Set.prototype.symmetricDifference()")}}\n- {{jsxref("Set.prototype.union()")}}\n'
        },
        "entries": {
            "index.md": '---\ntitle: Set.prototype.entries()\nslug: Web/JavaScript/Reference/Global_Objects/Set/entries\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Set.entries\n---\n\n{{JSRef}}\n\nThe **`entries()`** method of {{jsxref("Set")}} instances returns a new _[set iterator](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Iterator)_ object that contains **an array of `[value, value]`** for each element in this set, in insertion order. For `Set` objects there is no `key` like in `Map` objects. However, to keep the API similar to the `Map` object, each _entry_ has the same value for its _key_ and _value_ here, so that an array `[value, value]` is returned.\n\n{{EmbedInteractiveExample("pages/js/set-prototype-entries.html")}}\n\n## Syntax\n\n```js-nolint\nentries()\n```\n\n### Parameters\n\nNone.\n\n### Return value\n\nA new [iterable iterator object](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Iterator).\n\n## Examples\n\n### Using entries()\n\n```js\nconst mySet = new Set();\nmySet.add("foobar");\nmySet.add(1);\nmySet.add("baz");\n\nconst setIter = mySet.entries();\n\nconsole.log(setIter.next().value); // ["foobar", "foobar"]\nconsole.log(setIter.next().value); // [1, 1]\nconsole.log(setIter.next().value); // ["baz", "baz"]\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Set.prototype.keys()")}}\n- {{jsxref("Set.prototype.values()")}}\n'
        },
        "foreach": {
            "index.md": '---\ntitle: Set.prototype.forEach()\nslug: Web/JavaScript/Reference/Global_Objects/Set/forEach\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Set.forEach\n---\n\n{{JSRef}}\n\nThe **`forEach()`** method of {{jsxref("Set")}} instances executes a provided function once\nfor each value in this set, in insertion order.\n\n{{EmbedInteractiveExample("pages/js/set-prototype-foreach.html")}}\n\n## Syntax\n\n```js-nolint\nforEach(callbackFn)\nforEach(callbackFn, thisArg)\n```\n\n### Parameters\n\n- `callback`\n  - : A function to execute for each entry in the set. The function is called with the following arguments:\n    - `value`\n      - : Value of each iteration.\n    - `key`\n      - : Key of each iteration. This is always the same as `value`.\n    - `set`\n      - : The set being iterated.\n- `thisArg` {{optional_inline}}\n  - : A value to use as `this` when executing `callbackFn`.\n\n### Return value\n\nNone ({{jsxref("undefined")}}).\n\n## Description\n\nThe `forEach()` method executes the provided\n`callback` once for each value which actually exists in the\n`Set` object. It is not invoked for values which have been deleted. However,\nit is executed for values which are present but have the value `undefined`.\n\n`callback` is invoked with **three arguments**:\n\n- the **element value**\n- the **element key**\n- the **`Set` object being traversed**\n\nThere are no keys in `Set` objects, however, so the first two arguments are\nboth **values** contained in the {{jsxref("Set")}}. This is to make it\nconsistent with other `forEach()` methods for {{jsxref("Map/foreach", "Map")}} and {{jsxref("Array/forEach", "Array")}}.\n\nIf a `thisArg` parameter is provided to `forEach()`,\nit will be passed to `callback` when invoked, for use as its\n`this` value. Otherwise, the value `undefined` will be passed for\nuse as its `this` value. The `this` value ultimately observable by\n`callback` is determined according to\n[the usual rules for determining the `this` seen by a function](/en-US/docs/Web/JavaScript/Reference/Operators/this).\n\nEach value is visited once, except in the case when it was deleted and re-added before\n`forEach()` has finished. `callback` is not invoked for\nvalues deleted before being visited. New values added before `forEach()` has\nfinished will be visited.\n\n`forEach()` executes the `callback` function once for\neach element in the `Set` object; it does not return a value.\n\n## Examples\n\n### Logging the contents of a Set object\n\nThe following code logs a line for each element in a `Set` object:\n\n```js\nfunction logSetElements(value1, value2, set) {\n  console.log(`s[${value1}] = ${value2}`);\n}\n\nnew Set(["foo", "bar", undefined]).forEach(logSetElements);\n\n// Logs:\n// "s[foo] = foo"\n// "s[bar] = bar"\n// "s[undefined] = undefined"\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Array.prototype.forEach()")}}\n- {{jsxref("Map.prototype.forEach()")}}\n'
        },
        "has": {
            "index.md": '---\ntitle: Set.prototype.has()\nslug: Web/JavaScript/Reference/Global_Objects/Set/has\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Set.has\n---\n\n{{JSRef}}\n\nThe **`has()`** method of {{jsxref("Set")}} instances returns a boolean indicating whether an\nelement with the specified value exists in this set or not.\n\n{{EmbedInteractiveExample("pages/js/set-prototype-has.html")}}\n\n## Syntax\n\n```js-nolint\nhas(value)\n```\n\n### Parameters\n\n- `value`\n  - : The value to test for presence in the `Set` object.\n\n### Return value\n\nReturns `true` if an element with the specified value exists in the `Set` object; otherwise `false`.\n\n## Examples\n\n### Using the has() method\n\n```js\nconst mySet = new Set();\nmySet.add("foo");\n\nconsole.log(mySet.has("foo")); // true\nconsole.log(mySet.has("bar")); // false\n\nconst set1 = new Set();\nconst obj1 = { key1: 1 };\nset1.add(obj1);\n\nconsole.log(set1.has(obj1)); // true\nconsole.log(set1.has({ key1: 1 })); // false, because they are different object references\nconsole.log(set1.add({ key1: 1 })); // now set1 contains 2 entries\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Set")}}\n- {{jsxref("Set.prototype.add()")}}\n- {{jsxref("Set.prototype.delete()")}}\n'
        },
        "index.md": '---\ntitle: Set\nslug: Web/JavaScript/Reference/Global_Objects/Set\npage-type: javascript-class\nbrowser-compat: javascript.builtins.Set\n---\n\n{{JSRef}}\n\nThe **`Set`** object lets you store unique values of any type, whether {{Glossary("Primitive", "primitive values")}} or object references.\n\n## Description\n\n`Set` objects are collections of values. A value in the set **may only occur once**; it is unique in the set\'s collection. You can iterate through the elements of a set in insertion order. The _insertion order_ corresponds to the order in which each element was inserted into the set by the [`add()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Set/add) method successfully (that is, there wasn\'t an identical element already in the set when `add()` was called).\n\nThe specification requires sets to be implemented "that, on average, provide access times that are sublinear on the number of elements in the collection". Therefore, it could be represented internally as a hash table (with O(1) lookup), a search tree (with O(log(N)) lookup), or any other data structure, as long as the complexity is better than O(N).\n\n### Value equality\n\nValue equality is based on the [SameValueZero](/en-US/docs/Web/JavaScript/Equality_comparisons_and_sameness#same-value-zero_equality) algorithm. (It used to use [SameValue](/en-US/docs/Web/JavaScript/Equality_comparisons_and_sameness#same-value_equality_using_object.is), which treated `0` and `-0` as different. Check [browser compatibility](#browser_compatibility).) This means {{jsxref("NaN")}} is considered the same as `NaN` (even though `NaN !== NaN`) and all other values are considered equal according to the semantics of the `===` operator.\n\n### Performance\n\nThe [`has`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Set/has) method checks if a value is in the set, using an approach that is, on average, quicker than testing most of the elements that have previously been added to the set. In particular, it is, on average, faster than the [`Array.prototype.includes`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/includes) method when an array has a `length` equal to a set\'s `size`.\n\n### Set composition\n\nThe `Set` object provides some methods that allow you to compose sets like you would with mathematical operations. These methods include:\n\n<table>\n  <thead>\n    <tr>\n      <th scope="col">Method</th>\n      <th scope="col">Return type</th>\n      <th scope="col">Mathematical equivalent</th>\n      <th scope="col">Venn diagram</th>\n    </tr>\n  </thead>\n  <tbody>\n    <tr>\n      <td>{{jsxref("Set/difference", "A.difference(B)")}}</td>\n      <td><code>Set</code></td>\n      <td><math display="inline"><semantics><mrow><mi>A</mi><mo>\u2216</mo><mi>B</mi></mrow><annotation encoding="TeX">A\\setminus B</annotation></semantics></math></td>\n      <td style="margin:0;padding:0"><img src="difference/diagram.svg" alt="A Venn diagram where two circles overlap. The difference of A and B is the part of A that is not overlapping B." style="margin:0;border:0;border-radius:0" width="200" /></td>\n    </tr>\n    <tr>\n      <td>{{jsxref("Set/intersection", "A.intersection(B)")}}</td>\n      <td><code>Set</code></td>\n      <td><math display="inline"><semantics><mrow><mi>A</mi><mo>\u2229</mo><mi>B</mi></mrow><annotation encoding="TeX">A\\cap B</annotation></semantics></math></td>\n      <td style="margin:0;padding:0"><img src="intersection/diagram.svg" alt="A Venn diagram where two circles overlap. The intersection of A and B is the part where they overlap." style="margin:0;border:0;border-radius:0" width="200" /></td>\n    </tr>\n    <tr>\n      <td>{{jsxref("Set/symmetricDifference", "A.symmetricDifference(B)")}}</td>\n      <td><code>Set</code></td>\n      <td><math display="inline"><semantics><mrow><mo stretchy="false">(</mo><mi>A</mi><mo>\u2216</mo><mi>B</mi><mo stretchy="false">)</mo><mo>\u222A</mo><mo stretchy="false">(</mo><mi>B</mi><mo>\u2216</mo><mi>A</mi><mo stretchy="false">)</mo></mrow><annotation encoding="TeX">(A\\setminus B)\\cup(B\\setminus A)</annotation></semantics></math></td>\n      <td style="margin:0;padding:0"><img src="symmetricDifference/diagram.svg" alt="A Venn diagram where two circles overlap. The symmetric difference of A and B is the region contained by either circle but not both." style="margin:0;border:0;border-radius:0" width="200" /></td>\n    </tr>\n    <tr>\n      <td>{{jsxref("Set/union", "A.union(B)")}}</td>\n      <td><code>Set</code></td>\n      <td><math display="inline"><semantics><mrow><mi>A</mi><mo>\u222A</mo><mi>B</mi></mrow><annotation encoding="TeX">A\\cup B</annotation></semantics></math></td>\n      <td style="margin:0;padding:0"><img src="union/diagram.svg" alt="A Venn diagram where two circles overlap. The symmetric difference of A and B is the region contained by either or both circles." style="margin:0;border:0;border-radius:0" width="200" /></td>\n    </tr>\n    <tr>\n      <td>{{jsxref("Set/isDisjointFrom", "A.isDisjointFrom(B)")}}</td>\n      <td><code>Boolean</code></td>\n      <td><math display="inline"><semantics><mrow><mi>A</mi><mo>\u2229</mo><mi>B</mi><mo>=</mo><mi>\u2205</mi></mrow><annotation encoding="TeX">A\\cap B = \\empty</annotation></semantics></math></td>\n      <td style="margin:0;padding:0"><img src="isDisjointFrom/diagram.svg" alt="A Venn diagram with two circles. A and B are disjoint because the circles have no region of overlap." style="margin:0;border:0;border-radius:0" width="200" /></td>\n    </tr>\n    <tr>\n      <td>{{jsxref("Set/isSubsetOf", "A.isSubsetOf(B)")}}</td>\n      <td><code>Boolean</code></td>\n      <td><math display="inline"><semantics><mrow><mi>A</mi><mo>\u2286</mo><mi>B</mi></mrow><annotation encoding="TeX">A\\subseteq B</annotation></semantics></math></td>\n      <td style="margin:0;padding:0"><img src="isSubsetOf/diagram.svg" alt="A Venn diragram with two circles. A is a subset of B because A is completely contained in B." style="margin:0;border:0;border-radius:0" width="200" /></td>\n    </tr>\n    <tr>\n      <td>{{jsxref("Set/isSupersetOf", "A.isSupersetOf(B)")}}</td>\n      <td><code>Boolean</code></td>\n      <td><math display="inline"><semantics><mrow><mi>A</mi><mo>\u2287</mo><mi>B</mi></mrow><annotation encoding="TeX">A\\supseteq B</annotation></semantics></math></td>\n      <td style="margin:0;padding:0"><img src="isSupersetOf/diagram.svg" alt="A Venn diagram with two circles. A is a superset of B because B is completely contained in A." style="margin:0;border:0;border-radius:0" width="200" /></td>\n    </tr>\n  </tbody>\n</table>\n\nTo make them more generalizable, these methods don\'t just accept `Set` objects, but anything that\'s [set-like](#set-like_objects).\n\n### Set-like objects\n\nAll [set composition methods](#set_composition) require {{jsxref("Operators/this", "this")}} to be an actual `Set` instance, but their arguments just need to be set-like. A _set-like object_ is an object that provides the following:\n\n- A {{jsxref("Set/size", "size")}} property that contains a number.\n- A {{jsxref("Set/has", "has()")}} method that takes an element and returns a boolean.\n- A {{jsxref("Set/keys", "keys()")}} method that returns an [iterator](/en-US/docs/Web/JavaScript/Reference/Iteration_protocols) of the elements in the set.\n\nFor example, {{jsxref("Map")}} objects are set-like because they also have {{jsxref("Map/size", "size")}}, {{jsxref("Map/has", "has()")}}, and {{jsxref("Map/keys", "keys()")}}, so they behave just like sets of keys when used in set methods:\n\n```js\nconst a = new Set([1, 2, 3]);\nconst b = new Map([\n  [1, "one"],\n  [2, "two"],\n  [4, "four"],\n]);\nconsole.log(a.union(b)); // Set(4) {1, 2, 3, 4}\n```\n\n> **Note:** The set-like protocol invokes the `keys()` method instead of [`[@@iterator]()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Set/@@iterator) to produce elements. This is to make maps valid set-like objects, because for maps, the iterator produces _entries_ but the `has()` method takes _keys_.\n\n[Arrays](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array) are not set-like because they don\'t have a `has()` method or the `size` property, and their `keys()` method produces indices instead of elements. {{jsxref("WeakSet")}} objects are also not set-like because they don\'t have a `keys()` method.\n\n### Set-like browser APIs\n\nBrowser **`Set`-like objects** (or "setlike objects") are [Web API](/en-US/docs/Web/API) interfaces that behave in many ways like a `Set`.\n\nJust like `Set`, elements can be iterated in the same order that they were added to the object.\n`Set`-like objects and `Set` also have properties and methods that share the same name and behavior.\nHowever unlike `Set` they only allow a specific predefined type for each entry.\n\nThe allowed types are set in the specification IDL definition.\nFor example, {{domxref("GPUSupportedFeatures")}} is a `Set`-like object that must use strings as the key/value.\nThis is defined in the specification IDL below:\n\n```webidl\ninterface GPUSupportedFeatures {\n  readonly setlike<DOMString>;\n};\n```\n\n`Set`-like objects are either read-only or read-writable (see the `readonly` keyword in the IDL above).\n\n- Read-only `Set`-like objects have the property [`size`](#set.prototype.size), and the methods: [`entries()`](#set.prototype.entries), [`forEach()`](#set.prototype.foreach), [`has()`](#set.prototype.has), [`keys()`](#set.prototype.keys), [`values()`](#set.prototype.values), and [`@@iterator`](#set.prototypeiterator).\n- Writeable `Set`-like objects additionally have the methods: [`clear()`](#set.prototype.clear), [`delete()`](#set.prototype.delete), and [`add()`](#set.prototype.add).\n\nThe methods and properties have the same behavior as the equivalent entities in `Set`, except for the restriction on the types of the entry.\n\nThe following are examples of read-only `Set`-like browser objects:\n\n- {{domxref("GPUSupportedFeatures")}}\n- {{domxref("XRAnchorSet")}}\n\nThe following are examples of writable `Set`-like browser objects:\n\n- {{domxref("CustomStateSet")}}\n- {{domxref("FontFaceSet")}}\n- {{domxref("Highlight")}}\n\n## Constructor\n\n- {{jsxref("Set/Set", "Set()")}}\n  - : Creates a new `Set` object.\n\n## Static properties\n\n- {{jsxref("Set/@@species", "Set[@@species]")}}\n  - : The constructor function that is used to create derived objects.\n\n## Instance properties\n\nThese properties are defined on `Set.prototype` and shared by all `Set` instances.\n\n- {{jsxref("Object/constructor", "Set.prototype.constructor")}}\n  - : The constructor function that created the instance object. For `Set` instances, the initial value is the {{jsxref("Set/Set", "Set")}} constructor.\n- {{jsxref("Set.prototype.size")}}\n  - : Returns the number of values in the `Set` object.\n- `Set.prototype[@@toStringTag]`\n  - : The initial value of the [`@@toStringTag`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol/toStringTag) property is the string `"Set"`. This property is used in {{jsxref("Object.prototype.toString()")}}.\n\n## Instance methods\n\n- {{jsxref("Set.prototype.add()")}}\n  - : Inserts a new element with a specified value in to a `Set` object, if there isn\'t an element with the same value already in the `Set`.\n- {{jsxref("Set.prototype.clear()")}}\n  - : Removes all elements from the `Set` object.\n- {{jsxref("Set.prototype.delete()")}}\n  - : Removes the element associated to the `value` and returns a boolean asserting whether an element was successfully removed or not. `Set.prototype.has(value)` will return `false` afterwards.\n- {{jsxref("Set.prototype.difference()")}}\n  - : Takes a set and returns a new set containing elements in this set but not in the given set.\n- {{jsxref("Set.prototype.entries()")}}\n  - : Returns a new iterator object that contains **an array of `[value, value]`** for each element in the `Set` object, in insertion order. This is similar to the {{jsxref("Map")}} object, so that each entry\'s _key_ is the same as its _value_ for a `Set`.\n- {{jsxref("Set.prototype.forEach()")}}\n  - : Calls `callbackFn` once for each value present in the `Set` object, in insertion order. If a `thisArg` parameter is provided, it will be used as the `this` value for each invocation of `callbackFn`.\n- {{jsxref("Set.prototype.has()")}}\n  - : Returns a boolean asserting whether an element is present with the given value in the `Set` object or not.\n- {{jsxref("Set.prototype.intersection()")}}\n  - : Takes a set and returns a new set containing elements in both this set and the given set.\n- {{jsxref("Set.prototype.isDisjointFrom()")}}\n  - : Takes a set and returns a boolean indicating if this set has no elements in common with the given set.\n- {{jsxref("Set.prototype.isSubsetOf()")}}\n  - : Takes a set and returns a boolean indicating if all elements of this set are in the given set.\n- {{jsxref("Set.prototype.isSupersetOf()")}}\n  - : Takes a set and returns a boolean indicating if all elements of the given set are in this set.\n- {{jsxref("Set.prototype.keys()")}}\n  - : An alias for {{jsxref("Set.prototype.values()")}}.\n- {{jsxref("Set.prototype.symmetricDifference()")}}\n  - : Takes a set and returns a new set containing elements which are in either this set or the given set, but not in both.\n- {{jsxref("Set.prototype.union()")}}\n  - : Takes a set and returns a new set containing elements which are in either or both of this set and the given set.\n- {{jsxref("Set.prototype.values()")}}\n  - : Returns a new iterator object that yields the **values** for each element in the `Set` object in insertion order.\n- [`Set.prototype[@@iterator]()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Set/@@iterator)\n  - : Returns a new iterator object that yields the **values** for each element in the `Set` object in insertion order.\n\n## Examples\n\n### Using the Set object\n\n```js\nconst mySet1 = new Set();\n\nmySet1.add(1); // Set(1) { 1 }\nmySet1.add(5); // Set(2) { 1, 5 }\nmySet1.add(5); // Set(2) { 1, 5 }\nmySet1.add("some text"); // Set(3) { 1, 5, \'some text\' }\nconst o = { a: 1, b: 2 };\nmySet1.add(o);\n\nmySet1.add({ a: 1, b: 2 }); // o is referencing a different object, so this is okay\n\nmySet1.has(1); // true\nmySet1.has(3); // false, since 3 has not been added to the set\nmySet1.has(5); // true\nmySet1.has(Math.sqrt(25)); // true\nmySet1.has("Some Text".toLowerCase()); // true\nmySet1.has(o); // true\n\nmySet1.size; // 5\n\nmySet1.delete(5); // removes 5 from the set\nmySet1.has(5); // false, 5 has been removed\n\nmySet1.size; // 4, since we just removed one value\n\nmySet1.add(5); // Set(5) { 1, \'some text\', {...}, {...}, 5 } - a previously deleted item will be added as a new item, it will not retain its original position before deletion\n\nconsole.log(mySet1); // Set(5) { 1, "some text", {\u2026}, {\u2026}, 5 }\n```\n\n### Iterating sets\n\nThe iteration over a set visits elements in insertion order.\n\n```js\nfor (const item of mySet1) {\n  console.log(item);\n}\n// 1, "some text", { "a": 1, "b": 2 }, { "a": 1, "b": 2 }, 5\n\nfor (const item of mySet1.keys()) {\n  console.log(item);\n}\n// 1, "some text", { "a": 1, "b": 2 }, { "a": 1, "b": 2 }, 5\n\nfor (const item of mySet1.values()) {\n  console.log(item);\n}\n// 1, "some text", { "a": 1, "b": 2 }, { "a": 1, "b": 2 }, 5\n\n// key and value are the same here\nfor (const [key, value] of mySet1.entries()) {\n  console.log(key);\n}\n// 1, "some text", { "a": 1, "b": 2 }, { "a": 1, "b": 2 }, 5\n\n// Convert Set object to an Array object, with Array.from\nconst myArr = Array.from(mySet1); // [1, "some text", {"a": 1, "b": 2}, {"a": 1, "b": 2}, 5]\n\n// the following will also work if run in an HTML document\nmySet1.add(document.body);\nmySet1.has(document.querySelector("body")); // true\n\n// converting between Set and Array\nconst mySet2 = new Set([1, 2, 3, 4]);\nconsole.log(mySet2.size); // 4\nconsole.log([...mySet2]); // [1, 2, 3, 4]\n\n// intersect can be simulated via\nconst intersection = new Set([...mySet1].filter((x) => mySet2.has(x)));\n\n// difference can be simulated via\nconst difference = new Set([...mySet1].filter((x) => !mySet2.has(x)));\n\n// Iterate set entries with forEach()\nmySet2.forEach((value) => {\n  console.log(value);\n});\n// 1\n// 2\n// 3\n// 4\n```\n\n### Implementing basic set operations\n\n```js\nfunction isSuperset(set, subset) {\n  for (const elem of subset) {\n    if (!set.has(elem)) {\n      return false;\n    }\n  }\n  return true;\n}\n\nfunction union(setA, setB) {\n  const _union = new Set(setA);\n  for (const elem of setB) {\n    _union.add(elem);\n  }\n  return _union;\n}\n\nfunction intersection(setA, setB) {\n  const _intersection = new Set();\n  for (const elem of setB) {\n    if (setA.has(elem)) {\n      _intersection.add(elem);\n    }\n  }\n  return _intersection;\n}\n\nfunction symmetricDifference(setA, setB) {\n  const _difference = new Set(setA);\n  for (const elem of setB) {\n    if (_difference.has(elem)) {\n      _difference.delete(elem);\n    } else {\n      _difference.add(elem);\n    }\n  }\n  return _difference;\n}\n\nfunction difference(setA, setB) {\n  const _difference = new Set(setA);\n  for (const elem of setB) {\n    _difference.delete(elem);\n  }\n  return _difference;\n}\n\n// Examples\nconst setA = new Set([1, 2, 3, 4]);\nconst setB = new Set([2, 3]);\nconst setC = new Set([3, 4, 5, 6]);\n\nisSuperset(setA, setB); // returns true\nunion(setA, setC); // returns Set {1, 2, 3, 4, 5, 6}\nintersection(setA, setC); // returns Set {3, 4}\nsymmetricDifference(setA, setC); // returns Set {1, 2, 5, 6}\ndifference(setA, setC); // returns Set {1, 2}\n```\n\n### Relation to arrays\n\n```js\nconst myArray = ["value1", "value2", "value3"];\n\n// Use the regular Set constructor to transform an Array into a Set\nconst mySet = new Set(myArray);\n\nmySet.has("value1"); // returns true\n\n// Use the spread syntax to transform a set into an Array.\nconsole.log([...mySet]); // Will show you exactly the same Array as myArray\n```\n\n### Remove duplicate elements from an array\n\n```js\n// Use to remove duplicate elements from an array\nconst numbers = [2, 13, 4, 4, 2, 13, 13, 4, 4, 5, 5, 6, 6, 7, 5, 32, 13, 4, 5];\n\nconsole.log([...new Set(numbers)]); // [2, 13, 4, 5, 6, 7, 32]\n```\n\n### Relation to strings\n\n```js\n// Case sensitive (set will contain "F" and "f")\nnew Set("Firefox"); // Set(7) [ "F", "i", "r", "e", "f", "o", "x" ]\n\n// Duplicate omission ("f" occurs twice in the string but set will contain only one)\nnew Set("firefox"); // Set(6) [ "f", "i", "r", "e", "o", "x" ]\n```\n\n### Use a set to ensure the uniqueness of a list of values\n\n```js\nconst array = Array.from(document.querySelectorAll("[id]")).map((e) => e.id);\n\nconst set = new Set(array);\nconsole.assert(set.size === array.length);\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Set` in `core-js`](https://github.com/zloirock/core-js#set)\n- {{jsxref("Map")}}\n- {{jsxref("WeakMap")}}\n- {{jsxref("WeakSet")}}\n',
        "intersection": {
            "diagram.svg": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 200" xml:space="preserve"><style>.st1{fill:none;stroke:#231f20;stroke-miterlimit:10}</style><path d="M150 39.39c-20.92 12.1-35 34.71-35 60.61s14.08 48.51 35 60.61c20.92-12.1 35-34.71 35-60.61s-14.08-48.51-35-60.61z" style="fill:#39cac4"/><circle class="st1" cx="115" cy="100" r="70"/><circle class="st1" cx="185" cy="100" r="70"/><text transform="translate(99.37 50.4)">A</text><text transform="translate(190.014 50.4)">B</text></svg>',
            "index.md": '---\ntitle: Set.prototype.intersection()\nslug: Web/JavaScript/Reference/Global_Objects/Set/intersection\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Set.intersection\n---\n\n{{JSRef}}\n\nThe **`intersection()`** method of {{jsxref("Set")}} instances takes a set and returns a new set containing elements in both this set and the given set.\n\n## Syntax\n\n```js-nolint\nintersection(other)\n```\n\n### Parameters\n\n- `other`\n  - : A {{jsxref("Set")}} object, or [set-like](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Set#set-like_objects) object.\n\n### Return value\n\nA new {{jsxref("Set")}} object containing elements in both this set and the `other` set.\n\n## Description\n\nIn mathematical notation, _intersection_ is defined as:\n\n<math display="block"><semantics><mrow><mi>A</mi><mo>\u2229</mo><mi>B</mi><mo>=</mo><mo stretchy="false">{</mo><mi>x</mi><mo>\u220A</mo><mi>A</mi><mo>\u2223</mo><mi>x</mi><mo>\u220A</mo><mi>B</mi><mo stretchy="false">}</mo></mrow><annotation encoding="TeX">A\\cap B = \\{x\\in A\\mid x\\in B\\}</annotation></semantics></math>\n\nAnd using Venn diagram:\n\n![A Venn diagram where two circles overlap. The intersection of A and B is the part where they overlap.](diagram.svg)\n\n`intersection()` accepts [set-like](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Set#set-like_objects) objects as the `other` parameter. It requires {{jsxref("Operators/this", "this")}} to be an actual {{jsxref("Set")}} instance, because it directly retrieves the underlying data stored in `this` without invoking any user code. Then, its behavior depends on the sizes of `this` and `other`:\n\n- If there are more elements in `this` than `other.size`, then it iterates over `other` by calling its `keys()` method, and constructs a new set with all elements produced that are also present in `this`.\n- Otherwise, it iterates over the elements in `this`, and constructs a new set with all elements `e` in `this` that cause `other.has(e)` to return a [truthy](/en-US/docs/Glossary/Truthy) value.\n\nBecause of this implementation, the efficiency of `intersection()` mostly depends on the size of the smaller set between `this` and `other` (assuming sets can be accessed in sublinear time). The order of elements in the returned set is the same as that of the smaller of `this` and `other`.\n\n## Examples\n\n### Using intersection()\n\nThe following example computes the intersection between the set of odd numbers (<10) and the set of perfect squares (<10). The result is the set of odd numbers that are perfect squares.\n\n```js\nconst odds = new Set([1, 3, 5, 7, 9]);\nconst squares = new Set([1, 4, 9]);\nconsole.log(odds.intersection(squares)); // Set(2) { 1, 9 }\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Set.prototype.intersection` in `core-js`](https://github.com/zloirock/core-js#new-set-methods)\n- {{jsxref("Set.prototype.difference()")}}\n- {{jsxref("Set.prototype.isDisjointFrom()")}}\n- {{jsxref("Set.prototype.isSubsetOf()")}}\n- {{jsxref("Set.prototype.isSupersetOf()")}}\n- {{jsxref("Set.prototype.symmetricDifference()")}}\n- {{jsxref("Set.prototype.union()")}}\n'
        },
        "isdisjointfrom": {
            "diagram.svg": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 200" xml:space="preserve"><style>.st0{fill:none;stroke:#231f20;stroke-miterlimit:10}</style><circle class="st0" cx="90" cy="100" r="50"/><circle class="st0" cx="210" cy="100" r="50"/><text transform="translate(85.996 63.2)">A</text><text transform="translate(205.998 63.2)">B</text></svg>',
            "index.md": '---\ntitle: Set.prototype.isDisjointFrom()\nslug: Web/JavaScript/Reference/Global_Objects/Set/isDisjointFrom\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Set.isDisjointFrom\n---\n\n{{JSRef}}\n\nThe **`isDisjointFrom()`** method of {{jsxref("Set")}} instances takes a set and returns a boolean indicating if this set has no elements in common with the given set.\n\n## Syntax\n\n```js-nolint\nisDisjointFrom(other)\n```\n\n### Parameters\n\n- `other`\n  - : A {{jsxref("Set")}} object, or [set-like](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Set#set-like_objects) object.\n\n### Return value\n\n`true` if this set has no elements in common with the `other` set, and `false` otherwise.\n\n## Description\n\nTwo sets are _disjoint_ if they have no elements in common. In mathematical notation:\n\n<math display="block"><semantics><mrow><mi>A</mi><mtext>&nbsp;is disjoint from&nbsp;</mtext><mi>B</mi><mo stretchy="false">\u21D4</mo><mi>A</mi><mo>\u2229</mo><mi>B</mi><mo>=</mo><mi>\u2205</mi></mrow><annotation encoding="TeX">A\\text{ is disjoint from }B \\Leftrightarrow A\\cap B = \\empty</annotation></semantics></math>\n\nAnd using Venn diagram:\n\n![A Venn diagram with two circles. A and B are disjoint because the circles have no region of overlap.](diagram.svg)\n\n`isDisjointFrom()` accepts [set-like](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Set#set-like_objects) objects as the `other` parameter. It requires {{jsxref("Operators/this", "this")}} to be an actual {{jsxref("Set")}} instance, because it directly retrieves the underlying data stored in `this` without invoking any user code. Then, its behavior depends on the sizes of `this` and `other`:\n\n- If there are more elements in `this` than `other.size`, then it iterates over `other` by calling its `keys()` method, and if any element in `other` is present in `this`, it returns `false` (and closes the `keys()` iterator by calling its `return()` method). Otherwise, it returns `true`.\n- Otherwise, it iterates over the elements in `this`, and returns `false` if any element `e` in `this` causes `other.has(e)` to return a [truthy](/en-US/docs/Glossary/Truthy) value. Otherwise, it returns `true`.\n\nBecause of this implementation, the efficiency of `isDisjointFrom()` mostly depends on the size of the smaller set between `this` and `other` (assuming sets can be accessed in sublinear time).\n\n## Examples\n\n### Using isDisjointFrom()\n\nThe set of perfect squares (<20) is disjoint from the set of prime numbers (<20), because a perfect square is by definition decomposable into the product of two integers, while 1 is also not considered a prime number:\n\n```js\nconst primes = new Set([2, 3, 5, 7, 11, 13, 17, 19]);\nconst squares = new Set([1, 4, 9, 16]);\nconsole.log(primes.isDisjointFrom(squares)); // true\n```\n\nThe set of perfect squares (<20) is not disjoint from the set of composite numbers (<20), because all non-1 perfect squares are by definition composite numbers:\n\n```js\nconst composites = new Set([4, 6, 8, 9, 10, 12, 14, 15, 16, 18]);\nconst squares = new Set([1, 4, 9, 16]);\nconsole.log(composites.isDisjointFrom(squares)); // false\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Set.prototype.isDisjointFrom` in `core-js`](https://github.com/zloirock/core-js#new-set-methods)\n- {{jsxref("Set.prototype.difference()")}}\n- {{jsxref("Set.prototype.intersection()")}}\n- {{jsxref("Set.prototype.isSubsetOf()")}}\n- {{jsxref("Set.prototype.isSupersetOf()")}}\n- {{jsxref("Set.prototype.symmetricDifference()")}}\n- {{jsxref("Set.prototype.union()")}}\n'
        },
        "issubsetof": {
            "diagram.svg": '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0" y="0" viewBox="0 0 300 200" xml:space="preserve"><style>.st0{fill:none;stroke:#231f20;stroke-miterlimit:10}</style><circle class="st0" cx="150" cy="100" r="75"/><circle class="st0" cx="150" cy="120" r="50"/><text transform="translate(144.361 94.51)">A</text><text transform="translate(144.358 44.51)">B</text></svg>',
            "index.md": '---\ntitle: Set.prototype.isSubsetOf()\nslug: Web/JavaScript/Reference/Global_Objects/Set/isSubsetOf\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Set.isSubsetOf\n---\n\n{{JSRef}}\n\nThe **`isSubsetOf()`** method of {{jsxref("Set")}} instances takes a set and returns a boolean indicating if all elements of this set are in the given set.\n\n## Syntax\n\n```js-nolint\nisSubsetOf(other)\n```\n\n### Parameters\n\n- `other`\n  - : A {{jsxref("Set")}} object, or [set-like](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Set#set-like_objects) object.\n\n### Return value\n\n`true` if all elements in this set are also in the `other` set, and `false` otherwise.\n\n## Description\n\nIn mathematical notation, _subset_ is defined as:\n\n<math display="block"><semantics><mrow><mi>A</mi><mo>\u2286</mo><mi>B</mi><mo stretchy="false">\u21D4</mo><mo>\u2200</mo><mi>x</mi><mo>\u220A</mo><mi>A</mi><mo>,</mo><mspace width="0.16666666666666666em"></mspace><mi>x</mi><mo>\u220A</mo><mi>B</mi></mrow><annotation encoding="TeX">A\\subseteq B \\Leftrightarrow \\forall x\\in A,\\,x\\in B</annotation></semantics></math>\n\nAnd using Venn diagram:\n\n![A Venn diragram with two circles. A is a subset of B because A is completely contained in B.](diagram.svg)\n\n> **Note:** The _subset_ relationship is not _proper subset_, which means `isSubsetOf()` returns `true` if `this` and `other` contain the same elements.\n\n`isSubsetOf()` accepts [set-like](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Set#set-like_objects) objects as the `other` parameter. It requires {{jsxref("Operators/this", "this")}} to be an actual {{jsxref("Set")}} instance, because it directly retrieves the underlying data stored in `this` without invoking any user code. Then, its behavior depends on the sizes of `this` and `other`:\n\n- If there are more elements in `this` than `other.size`, then it directly returns `false`.\n- Otherwise, it iterates over the elements in `this`, and returns `false` if any element `e` in `this` causes `other.has(e)` to return a [falsy](/en-US/docs/Glossary/Falsy) value. Otherwise, it returns `true`.\n\n## Examples\n\n### Using isSubsetOf()\n\nThe set of multiples of 4 (<20) is a subset of even numbers (<20):\n\n```js\nconst fours = new Set([4, 8, 12, 16]);\nconst evens = new Set([2, 4, 6, 8, 10, 12, 14, 16, 18]);\nconsole.log(fours.isSubsetOf(evens)); // true\n```\n\nThe set of prime numbers (<20) is not a subset of all odd numbers (<20), because 2 is prime but not odd:\n\n```js\nconst primes = new Set([2, 3, 5, 7, 11, 13, 17, 19]);\nconst odds = new Set([3, 5, 7, 9, 11, 13, 15, 17, 19]);\nconsole.log(primes.isSubsetOf(odds)); // false\n```\n\nEquivalent sets are subsets of each other:\n\n```js\nconst set1 = new Set([1, 2, 3]);\nconst set2 = new Set([1, 2, 3]);\nconsole.log(set1.isSubsetOf(set2)); // true\nconsole.log(set2.isSubsetOf(set1)); // true\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Set.prototype.isSubsetOf` in `core-js`](https://github.com/zloirock/core-js#new-set-methods)\n- {{jsxref("Set.prototype.difference()")}}\n- {{jsxref("Set.prototype.intersection()")}}\n- {{jsxref("Set.prototype.isDisjointFrom()")}}\n- {{jsxref("Set.prototype.isSupersetOf()")}}\n- {{jsxref("Set.prototype.symmetricDifference()")}}\n- {{jsxref("Set.prototype.union()")}}\n'
        },
        "issupersetof": {
            "diagram.svg": '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0" y="0" viewBox="0 0 300 200" xml:space="preserve"><style>.st0{fill:none;stroke:#231f20;stroke-miterlimit:10}</style><circle class="st0" cx="150" cy="100" r="75"/><circle class="st0" cx="150" cy="120" r="50"/><text transform="translate(144.358 44.51)">A</text><text transform="translate(144.361 94.51)">B</text></svg>',
            "index.md": '---\ntitle: Set.prototype.isSupersetOf()\nslug: Web/JavaScript/Reference/Global_Objects/Set/isSupersetOf\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Set.isSupersetOf\n---\n\n{{JSRef}}\n\nThe **`isSupersetOf()`** method of {{jsxref("Set")}} instances takes a set and returns a boolean indicating if all elements of the given set are in this set.\n\n## Syntax\n\n```js-nolint\nisSupersetOf(other)\n```\n\n### Parameters\n\n- `other`\n  - : A {{jsxref("Set")}} object, or [set-like](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Set#set-like_objects) object.\n\n### Return value\n\n`true` if all elements in the `other` set are also in this set, and `false` otherwise.\n\n## Description\n\nIn mathematical notation, _superset_ is defined as:\n\n<math display="block"><semantics><mrow><mi>A</mi><mo>\u2287</mo><mi>B</mi><mo stretchy="false">\u21D4</mo><mo>\u2200</mo><mi>x</mi><mo>\u220A</mo><mi>B</mi><mo>,</mo><mspace width="0.16666666666666666em"></mspace><mi>x</mi><mo>\u220A</mo><mi>A</mi></mrow><annotation encoding="TeX">A\\supseteq B \\Leftrightarrow \\forall x\\in B,\\,x\\in A</annotation></semantics></math>\n\nAnd using Venn diagram:\n\n![A Venn diagram with two circles. A is a superset of B because B is completely contained in A.](diagram.svg)\n\n> **Note:** The _superset_ relationship is not _proper superset_, which means `isSupersetOf()` returns `true` if `this` and `other` contain the same elements.\n\n`isSupersetOf()` accepts [set-like](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Set#set-like_objects) objects as the `other` parameter. It requires {{jsxref("Operators/this", "this")}} to be an actual {{jsxref("Set")}} instance, because it directly retrieves the underlying data stored in `this` without invoking any user code. Then, its behavior depends on the sizes of `this` and `other`:\n\n- If there are fewer elements in `this` than `other.size`, then it directly returns `false`.\n- Otherwise, it iterates over `other` by calling its `keys()` method, and if any element in `other` is not present in `this`, it returns `false` (and closes the `keys()` iterator by calling its `return()` method). Otherwise, it returns `true`.\n\n## Examples\n\n### Using isSupersetOf()\n\nThe set of even numbers (<20) is a superset of multiples of 4 (<20):\n\n```js\nconst evens = new Set([2, 4, 6, 8, 10, 12, 14, 16, 18]);\nconst fours = new Set([4, 8, 12, 16]);\nconsole.log(evens.isSupersetOf(fours)); // true\n```\n\nThe set of all odd numbers (<20) is not a superset of prime numbers (<20), because 2 is prime but not odd:\n\n```js\nconst primes = new Set([2, 3, 5, 7, 11, 13, 17, 19]);\nconst odds = new Set([3, 5, 7, 9, 11, 13, 15, 17, 19]);\nconsole.log(odds.isSupersetOf(primes)); // false\n```\n\nEquivalent sets are supersets of each other:\n\n```js\nconst set1 = new Set([1, 2, 3]);\nconst set2 = new Set([1, 2, 3]);\nconsole.log(set1.isSupersetOf(set2)); // true\nconsole.log(set2.isSupersetOf(set1)); // true\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Set.prototype.isSupersetOf` in `core-js`](https://github.com/zloirock/core-js#new-set-methods)\n- {{jsxref("Set.prototype.difference()")}}\n- {{jsxref("Set.prototype.intersection()")}}\n- {{jsxref("Set.prototype.isDisjointFrom()")}}\n- {{jsxref("Set.prototype.isSubsetOf()")}}\n- {{jsxref("Set.prototype.symmetricDifference()")}}\n- {{jsxref("Set.prototype.union()")}}\n'
        },
        "keys": {
            "index.md": '---\ntitle: Set.prototype.keys()\nslug: Web/JavaScript/Reference/Global_Objects/Set/keys\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Set.keys\n---\n\n{{JSRef}}\n\nThe **`keys()`** method of {{jsxref("Set")}} instances is an alias for the [`values()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Set/values) method.\n\n## Syntax\n\n```js-nolint\nkeys()\n```\n\n### Parameters\n\nNone.\n\n### Return value\n\nA new [iterable iterator object](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Iterator).\n\n## Examples\n\n### Using keys()\n\nThe `keys()` method is exactly equivalent to the {{jsxref("Set/values", "values()")}} method.\n\n```js\nconst mySet = new Set();\nmySet.add("foo");\nmySet.add("bar");\nmySet.add("baz");\n\nconst setIter = mySet.keys();\n\nconsole.log(setIter.next().value); // "foo"\nconsole.log(setIter.next().value); // "bar"\nconsole.log(setIter.next().value); // "baz"\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Set.prototype.entries()")}}\n- {{jsxref("Set.prototype.values()")}}\n'
        },
        "set": {
            "index.md": '---\ntitle: Set() constructor\nslug: Web/JavaScript/Reference/Global_Objects/Set/Set\npage-type: javascript-constructor\nbrowser-compat: javascript.builtins.Set.Set\n---\n\n{{JSRef}}\n\nThe **`Set()`** constructor creates {{jsxref("Set")}} objects.\n\n{{EmbedInteractiveExample("pages/js/set-prototype-constructor.html")}}\n\n## Syntax\n\n```js-nolint\nnew Set()\nnew Set(iterable)\n```\n\n> **Note:** `Set()` can only be constructed with [`new`](/en-US/docs/Web/JavaScript/Reference/Operators/new). Attempting to call it without `new` throws a {{jsxref("TypeError")}}.\n\n### Parameters\n\n- `iterable` {{optional_inline}}\n\n  - : If an [iterable object](/en-US/docs/Web/JavaScript/Reference/Statements/for...of) is passed, all of its elements will be added to the new\n    `Set`.\n\n    If you don\'t specify this parameter, or its value is `null`, the new\n    `Set` is empty.\n\n### Return value\n\nA new `Set` object.\n\n## Examples\n\n### Using the `Set` object\n\n```js\nconst mySet = new Set();\n\nmySet.add(1); // Set [ 1 ]\nmySet.add(5); // Set [ 1, 5 ]\nmySet.add(5); // Set [ 1, 5 ]\nmySet.add("some text"); // Set [ 1, 5, \'some text\' ]\nconst o = { a: 1, b: 2 };\nmySet.add(o);\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Set` in `core-js`](https://github.com/zloirock/core-js#set)\n- {{jsxref("Set")}}\n'
        },
        "size": {
            "index.md": '---\ntitle: Set.prototype.size\nslug: Web/JavaScript/Reference/Global_Objects/Set/size\npage-type: javascript-instance-accessor-property\nbrowser-compat: javascript.builtins.Set.size\n---\n\n{{JSRef}}\n\nThe **`size`** accessor property of {{jsxref("Set")}} instances returns the number of (unique) elements in this set.\n\n{{EmbedInteractiveExample("pages/js/set-prototype-size.html")}}\n\n## Description\n\nThe value of `size` is an integer representing how many entries the `Set` object has. A set accessor function for `size` is `undefined`; you cannot change this property.\n\n## Examples\n\n### Using size\n\n```js\nconst mySet = new Set();\nmySet.add(1);\nmySet.add(5);\nmySet.add("some text");\n\nconsole.log(mySet.size); // 3\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Set")}}\n'
        },
        "symmetricdifference": {
            "diagram.svg": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 200" xml:space="preserve"><style>.st1{fill:none;stroke:#231f20;stroke-miterlimit:10}</style><path d="M115 100c0-25.91 14.08-48.51 35-60.61A69.667 69.667 0 0 0 115 30c-38.66 0-70 31.34-70 70s31.34 70 70 70c12.75 0 24.7-3.43 35-9.39-20.92-12.1-35-34.7-35-60.61zm70-70c-12.75 0-24.7 3.43-35 9.39 20.92 12.1 35 34.71 35 60.61s-14.08 48.51-35 60.61a69.667 69.667 0 0 0 35 9.39c38.66 0 70-31.34 70-70s-31.34-70-70-70z" style="fill:#39cac4"/><circle class="st1" cx="115" cy="100" r="70"/><circle class="st1" cx="185" cy="100" r="70"/><text transform="translate(99.37 50.4)">A</text><text transform="translate(190.014 50.4)">B</text></svg>',
            "index.md": '---\ntitle: Set.prototype.symmetricDifference()\nslug: Web/JavaScript/Reference/Global_Objects/Set/symmetricDifference\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Set.symmetricDifference\n---\n\n{{JSRef}}\n\nThe **`symmetricDifference()`** method of {{jsxref("Set")}} instances takes a set and returns a new set containing elements which are in either this set or the given set, but not in both.\n\n## Syntax\n\n```js-nolint\nsymmetricDifference(other)\n```\n\n### Parameters\n\n- `other`\n  - : A {{jsxref("Set")}} object, or [set-like](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Set#set-like_objects) object.\n\n### Return value\n\nA new {{jsxref("Set")}} object containing elements which are in either this set or the `other` set, but not in both.\n\n## Description\n\nIn mathematical notation, _symmetric difference_ is defined as:\n\n<math display="block"><semantics><mrow><mi>A</mi><mo>\u2296</mo><mi>B</mi><mo>=</mo><mo stretchy="false">(</mo><mi>A</mi><mo>\u2216</mo><mi>B</mi><mo stretchy="false">)</mo><mo>\u222A</mo><mo stretchy="false">(</mo><mi>B</mi><mo>\u2216</mo><mi>A</mi><mo stretchy="false">)</mo></mrow><annotation encoding="TeX">A\\ominus B = (A\\setminus B)\\cup(B\\setminus A)</annotation></semantics></math>\n\nAnd using Venn diagram:\n\n![A Venn diagram where two circles overlap. The symmetric difference of A and B is the region contained by either circle but not both.](diagram.svg)\n\n`symmetricDifference()` accepts [set-like](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Set#set-like_objects) objects as the `other` parameter. It requires {{jsxref("Operators/this", "this")}} to be an actual {{jsxref("Set")}} instance, because it directly retrieves the underlying data stored in `this` without invoking any user code. Then, it iterates over `other` by calling its `keys()` method, and constructs a new set with all elements in `this` that are not seen in `other`, and all elements in `other` that are not seen in `this`.\n\nThe order of elements in the returned set is first those in `this` followed by those in `other`.\n\n## Examples\n\n### Using symmetricDifference()\n\nThe following example computes the symmetric difference between the set of even numbers (<10) and the set of perfect squares (<10). The result is the set of numbers that are either even or a perfect square, but not both.\n\n```js\nconst evens = new Set([2, 4, 6, 8]);\nconst squares = new Set([1, 4, 9]);\nconsole.log(evens.symmetricDifference(squares)); // Set(5) { 1, 2, 6, 8, 9 }\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Set.prototype.symmetricDifference` in `core-js`](https://github.com/zloirock/core-js#new-set-methods)\n- {{jsxref("Set.prototype.difference()")}}\n- {{jsxref("Set.prototype.intersection()")}}\n- {{jsxref("Set.prototype.isDisjointFrom()")}}\n- {{jsxref("Set.prototype.isSubsetOf()")}}\n- {{jsxref("Set.prototype.isSupersetOf()")}}\n- {{jsxref("Set.prototype.union()")}}\n'
        },
        "union": {
            "diagram.svg": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 200" xml:space="preserve"><style>.st1{fill:none;stroke:#231f20;stroke-miterlimit:10}</style><path d="M185 30c-12.75 0-24.7 3.43-35 9.39A69.667 69.667 0 0 0 115 30c-38.66 0-70 31.34-70 70s31.34 70 70 70c12.75 0 24.7-3.43 35-9.39a69.667 69.667 0 0 0 35 9.39c38.66 0 70-31.34 70-70s-31.34-70-70-70z" style="fill:#39cac4"/><circle class="st1" cx="115" cy="100" r="70"/><circle class="st1" cx="185" cy="100" r="70"/><text transform="translate(99.37 50.4)">A</text><text transform="translate(190.014 50.4)">B</text></svg>\n',
            "index.md": '---\ntitle: Set.prototype.union()\nslug: Web/JavaScript/Reference/Global_Objects/Set/union\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Set.union\n---\n\n{{JSRef}}\n\nThe **`union()`** method of {{jsxref("Set")}} instances takes a set and returns a new set containing elements which are in either or both of this set and the given set.\n\n## Syntax\n\n```js-nolint\nunion(other)\n```\n\n### Parameters\n\n- `other`\n  - : A {{jsxref("Set")}} object, or [set-like](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Set#set-like_objects) object.\n\n### Return value\n\nA new {{jsxref("Set")}} object containing elements which are in either or both of this set and the `other` set.\n\n## Description\n\nIn mathematical notation, _union_ is defined as:\n\n<math display="block"><semantics><mrow><mi>A</mi><mo>\u222A</mo><mi>B</mi><mo>=</mo><mo stretchy="false">{</mo><mi>x</mi><mo>\u2223</mo><mi>x</mi><mo>\u220A</mo><mi>A</mi><mtext>&nbsp;or&nbsp;</mtext><mi>x</mi><mo>\u220A</mo><mi>B</mi><mo stretchy="false">}</mo></mrow><annotation encoding="TeX">A\\cup B = \\{x\\midx\\in A\\text{ or }x\\in B\\}</annotation></semantics></math>\n\nAnd using Venn diagram:\n\n![A Venn diagram where two circles overlap. The symmetric difference of A and B is the region contained by either or both circles.](diagram.svg)\n\n`union()` accepts [set-like](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Set#set-like_objects) objects as the `other` parameter. It requires {{jsxref("Operators/this", "this")}} to be an actual {{jsxref("Set")}} instance, because it directly retrieves the underlying data stored in `this` without invoking any user code. Then, it iterates over `other` by calling its `keys()` method, and constructs a new set with all elements in `this`, followed by all elements in `other` that are not present in `this`.\n\nThe order of elements in the returned set is first those in `this` followed by those in `other`.\n\n## Examples\n\n### Using union()\n\nThe following example computes the union between the set of even numbers (<10) and the set of perfect squares (<10). The result is the set of numbers that are either even or a perfect square, or both.\n\n```js\nconst evens = new Set([2, 4, 6, 8]);\nconst squares = new Set([1, 4, 9]);\nconsole.log(evens.union(squares)); // Set(6) { 2, 4, 6, 8, 1, 9 }\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Set.prototype.union` in `core-js`](https://github.com/zloirock/core-js#new-set-methods)\n- {{jsxref("Set.prototype.difference()")}}\n- {{jsxref("Set.prototype.intersection()")}}\n- {{jsxref("Set.prototype.isDisjointFrom()")}}\n- {{jsxref("Set.prototype.isSubsetOf()")}}\n- {{jsxref("Set.prototype.isSupersetOf()")}}\n- {{jsxref("Set.prototype.symmetricDifference()")}}\n'
        },
        "values": {
            "index.md": '---\ntitle: Set.prototype.values()\nslug: Web/JavaScript/Reference/Global_Objects/Set/values\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Set.values\n---\n\n{{JSRef}}\n\nThe **`values()`** method of {{jsxref("Set")}} instances returns a new _[set iterator](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Iterator)_ object that contains the values for each element in this set in insertion order.\n\n{{EmbedInteractiveExample("pages/js/set-prototype-values.html")}}\n\n## Syntax\n\n```js-nolint\nvalues()\n```\n\n### Parameters\n\nNone.\n\n### Return value\n\nA new [iterable iterator object](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Iterator).\n\n## Examples\n\n### Using values()\n\n```js\nconst mySet = new Set();\nmySet.add("foo");\nmySet.add("bar");\nmySet.add("baz");\n\nconst setIter = mySet.values();\n\nconsole.log(setIter.next().value); // "foo"\nconsole.log(setIter.next().value); // "bar"\nconsole.log(setIter.next().value); // "baz"\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Set.prototype.entries()")}}\n- {{jsxref("Set.prototype.keys()")}}\n'
        }
    },
    "sharedarraybuffer": {
        "@@species": {
            "index.md": '---\ntitle: SharedArrayBuffer[@@species]\nslug: Web/JavaScript/Reference/Global_Objects/SharedArrayBuffer/@@species\npage-type: javascript-static-accessor-property\nbrowser-compat: javascript.builtins.SharedArrayBuffer.@@species\n---\n\n{{JSRef}}\n\nThe **`SharedArrayBuffer[@@species]`** static accessor property returns the constructor used to construct return values from `SharedArrayBuffer` methods.\n\n> **Warning:** The existence of `@@species` allows execution of arbitrary code and may create security vulnerabilities. It also makes certain optimizations much harder. Engine implementers are [investigating whether to remove this feature](https://github.com/tc39/proposal-rm-builtin-subclassing). Avoid relying on it if possible.\n\n## Syntax\n\n```js-nolint\nSharedArrayBuffer[Symbol.species]\n```\n\n### Return value\n\nThe value of the constructor (`this`) on which `get @@species` was called. The return value is used to construct return values from array buffer methods that create new array buffer.\n\n## Description\n\nThe `@@species` accessor property returns the default constructor for `SharedArrayBuffer` objects. Subclass constructors may override it to change the constructor assignment. The default implementation is basically:\n\n```js\n// Hypothetical underlying implementation for illustration\nclass SharedArrayBuffer {\n  static get [Symbol.species]() {\n    return this;\n  }\n}\n```\n\nBecause of this polymorphic implementation, `@@species` of derived subclasses would also return the constructor itself by default.\n\n```js\nclass SubArrayBuffer extends SharedArrayBuffer {}\nSubArrayBuffer[Symbol.species] === SharedArrayBuffer; // true\n```\n\nWhen calling array buffer methods that do not mutate the existing array but return a new array buffer instance (for example, [`slice()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/SharedArrayBuffer/slice)), the array\'s `constructor[@@species]` will be accessed. The returned constructor will be used to construct the return value of the array buffer method.\n\n## Examples\n\n### Species in ordinary objects\n\nThe `@@species` property returns the default constructor function, which is the `SharedArrayBuffer` constructor for `SharedArrayBuffer`.\n\n```js\nSharedArrayBuffer[Symbol.species]; // function SharedArrayBuffer()\n```\n\n### Species in derived objects\n\nIn an instance of a custom `SharedArrayBuffer` subclass, such as `MySharedArrayBuffer`, the `MySharedArrayBuffer` species is the `MySharedArrayBuffer` constructor. However, you might want to overwrite this, in order to return parent `SharedArrayBuffer` objects in your derived class methods:\n\n```js\nclass MySharedArrayBuffer extends SharedArrayBuffer {\n  // Overwrite MySharedArrayBuffer species to the parent SharedArrayBuffer constructor\n  static get [Symbol.species]() {\n    return SharedArrayBuffer;\n  }\n}\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("SharedArrayBuffer")}}\n- {{jsxref("Symbol.species")}}\n'
        },
        "bytelength": {
            "index.md": '---\ntitle: SharedArrayBuffer.prototype.byteLength\nslug: Web/JavaScript/Reference/Global_Objects/SharedArrayBuffer/byteLength\npage-type: javascript-instance-accessor-property\nbrowser-compat: javascript.builtins.SharedArrayBuffer.byteLength\n---\n\n{{JSRef}}\n\nThe **`byteLength`** accessor property of {{jsxref("SharedArrayBuffer")}} instances returns the length (in bytes) of this `SharedArrayBuffer`.\n\n{{EmbedInteractiveExample("pages/js/sharedarraybuffer-bytelength.html", "shorter")}}\n\n## Description\n\nThe `byteLength` property is an accessor property whose set accessor function is `undefined`, meaning that you can only read this property. The value is established when the shared array is constructed and cannot be changed.\n\n## Examples\n\n### Using byteLength\n\n```js\nconst sab = new SharedArrayBuffer(1024);\nsab.byteLength; // 1024\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("SharedArrayBuffer")}}\n'
        },
        "grow": {
            "index.md": '---\ntitle: SharedArrayBuffer.prototype.grow()\nslug: Web/JavaScript/Reference/Global_Objects/SharedArrayBuffer/grow\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.SharedArrayBuffer.grow\n---\n\n{{JSRef}}\n\nThe **`grow()`** method of {{jsxref("SharedArrayBuffer")}} instances grows the `SharedArrayBuffer` to the specified size, in bytes.\n\n## Syntax\n\n```js-nolint\ngrow(newLength)\n```\n\n### Parameters\n\n- `newLength`\n  - : The new length, in bytes, to resize the `SharedArrayBuffer` to.\n\n### Return value\n\nNone ({{jsxref("undefined")}}).\n\n### Exceptions\n\n- {{jsxref("TypeError")}}\n  - : Thrown if the `SharedArrayBuffer` is not growable.\n- {{jsxref("RangeError")}}\n  - : Thrown if `newLength` is larger than the {{jsxref("SharedArrayBuffer/maxByteLength", "maxByteLength")}} of the `SharedArrayBuffer` or smaller than the {{jsxref("SharedArrayBuffer/byteLength", "byteLength")}}.\n\n## Description\n\nThe `grow()` method grows a `SharedArrayBuffer` to the size specified by the `newLength` parameter, provided that the `SharedArrayBuffer` is [growable](/en-US/docs/Web/JavaScript/Reference/Global_Objects/SharedArrayBuffer/growable) and the new size is less than or equal to the {{jsxref("SharedArrayBuffer/maxByteLength", "maxByteLength")}} of the `SharedArrayBuffer`. New bytes are initialized to 0.\n\n## Examples\n\n### Using grow()\n\nIn this example, we create a 8-byte buffer that is growable to a max length of 16 bytes, then check its {{jsxref("SharedArrayBuffer/growable", "growable")}} property, growing it if `growable` returns `true`:\n\n```js\nconst buffer = new SharedArrayBuffer(8, { maxByteLength: 16 });\n\nif (buffer.growable) {\n  console.log("SAB is growable!");\n  buffer.grow(12);\n}\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("SharedArrayBuffer")}}\n- {{jsxref("SharedArrayBuffer.prototype.growable")}}\n- {{jsxref("SharedArrayBuffer.prototype.maxByteLength")}}\n'
        },
        "growable": {
            "index.md": '---\ntitle: SharedArrayBuffer.prototype.growable\nslug: Web/JavaScript/Reference/Global_Objects/SharedArrayBuffer/growable\npage-type: javascript-instance-accessor-property\nbrowser-compat: javascript.builtins.SharedArrayBuffer.growable\n---\n\n{{JSRef}}\n\nThe **`growable`** accessor property of {{jsxref("SharedArrayBuffer")}} instances returns whether this `SharedArrayBuffer` can be grow or not.\n\n## Description\n\nThe `growable` property is an accessor property whose set accessor function is `undefined`, meaning that you can only read this property. The value is established when the array is constructed. If a `maxByteLength` option was set in the constructor, `growable` will return `true`; if not, it will return `false`.\n\n## Examples\n\n### Using growable\n\nIn this example, we create a 8-byte buffer that is growable to a max length of 16 bytes, then check its `growable` property, growing it if `growable` returns `true`:\n\n```js\nconst buffer = new SharedArrayBuffer(8, { maxByteLength: 16 });\n\nif (buffer.growable) {\n  console.log("SAB is growable!");\n  buffer.grow(12);\n}\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("SharedArrayBuffer")}}\n- {{jsxref("SharedArrayBuffer.prototype.grow()")}}\n- {{jsxref("SharedArrayBuffer.prototype.maxByteLength")}}\n'
        },
        "index.md": '---\ntitle: SharedArrayBuffer\nslug: Web/JavaScript/Reference/Global_Objects/SharedArrayBuffer\npage-type: javascript-class\nbrowser-compat: javascript.builtins.SharedArrayBuffer\n---\n\n{{JSRef}}\n\nThe **`SharedArrayBuffer`** object is used to represent a generic raw binary data buffer, similar to the {{jsxref("ArrayBuffer")}} object, but in a way that they can be used to create views on shared memory. A `SharedArrayBuffer` is not a [Transferable Object](/en-US/docs/Web/API/Web_Workers_API/Transferable_objects), unlike an `ArrayBuffer` which is transferable.\n\n## Description\n\nTo share memory using `SharedArrayBuffer` objects from one agent in the cluster to another (an agent is either the web page\'s main program or one of its web workers), [`postMessage`](/en-US/docs/Web/API/Worker/postMessage) and [structured cloning](/en-US/docs/Web/API/Web_Workers_API/Structured_clone_algorithm) is used.\n\nThe structured clone algorithm accepts `SharedArrayBuffer` objects and typed arrays mapped onto `SharedArrayBuffer` objects. In both cases, the `SharedArrayBuffer` object is transmitted to the receiver resulting in a new, private `SharedArrayBuffer` object in the receiving agent (just as for {{jsxref("ArrayBuffer")}}). However, the shared data block referenced by the two `SharedArrayBuffer` objects is the same data block, and a side effect to the block in one agent will eventually become visible in the other agent.\n\n```js\nconst sab = new SharedArrayBuffer(1024);\nworker.postMessage(sab);\n```\n\nShared memory can be created and updated simultaneously in workers or the main thread. Depending on the system (the CPU, the OS, the Browser) it can take a while until the change is propagated to all contexts. To synchronize, {{jsxref("Atomics", "atomic", "", 1)}} operations are needed.\n\n`SharedArrayBuffer` objects are used by some web APIs, such as:\n\n- [`WebGLRenderingContext.bufferData()`](/en-US/docs/Web/API/WebGLRenderingContext/bufferData)\n- [`WebGLRenderingContext.bufferSubData()`](/en-US/docs/Web/API/WebGLRenderingContext/bufferSubData)\n- [`WebGL2RenderingContext.getBufferSubData()`](/en-US/docs/Web/API/WebGL2RenderingContext/getBufferSubData)\n\n### Security requirements\n\nShared memory and high-resolution timers were effectively [disabled at the start of 2018](https://blog.mozilla.org/security/2018/01/03/mitigations-landing-new-class-timing-attack/) in light of [Spectre](<https://en.wikipedia.org/wiki/Spectre_(security_vulnerability)>). In 2020, a new, secure approach has been standardized to re-enable shared memory.\n\nAs a baseline requirement, your document needs to be in a [secure context](/en-US/docs/Web/Security/Secure_Contexts).\n\nFor top-level documents, two headers need to be set to cross-origin isolate your site:\n\n- [`Cross-Origin-Opener-Policy`](/en-US/docs/Web/HTTP/Headers/Cross-Origin-Opener-Policy) with `same-origin` as value (protects your origin from attackers)\n- [`Cross-Origin-Embedder-Policy`](/en-US/docs/Web/HTTP/Headers/Cross-Origin-Embedder-Policy) with `require-corp` or `credentialless` as value (protects victims from your origin)\n\n```http\nCross-Origin-Opener-Policy: same-origin\nCross-Origin-Embedder-Policy: require-corp\n```\n\nTo check if cross origin isolation has been successful, you can test against the [`crossOriginIsolated`](/en-US/docs/Web/API/crossOriginIsolated) property available to window and worker contexts:\n\n```js\nconst myWorker = new Worker("worker.js");\n\nif (crossOriginIsolated) {\n  const buffer = new SharedArrayBuffer(16);\n  myWorker.postMessage(buffer);\n} else {\n  const buffer = new ArrayBuffer(16);\n  myWorker.postMessage(buffer);\n}\n```\n\nWith these two headers set, `postMessage()` no longer throws for `SharedArrayBuffer` objects and shared memory across threads is therefore available.\n\nNested documents and dedicated workers need to set the [`Cross-Origin-Embedder-Policy`](/en-US/docs/Web/HTTP/Headers/Cross-Origin-Embedder-Policy) header as well, with the same value. No further changes are needed for same-origin nested documents and subresources. Same-site (but cross-origin) nested documents and subresources need to set the [`Cross-Origin-Resource-Policy`](/en-US/docs/Web/HTTP/Headers/Cross-Origin-Resource-Policy) header with `same-site` as value. And their cross-origin (and cross-site) counterparts need to set the same header with `cross-origin` as value. Note that setting the [`Cross-Origin-Resource-Policy`](/en-US/docs/Web/HTTP/Headers/Cross-Origin-Resource-Policy) header to any other value than `same-origin` opens up the resource to potential attacks, such as [Spectre](<https://en.wikipedia.org/wiki/Spectre_(security_vulnerability)>).\n\nNote that the [`Cross-Origin-Opener-Policy`](/en-US/docs/Web/HTTP/Headers/Cross-Origin-Opener-Policy) header limits your ability to retain a reference to popups. Direct access between two top-level window contexts essentially only work if they are same-origin and carry the same two headers with the same two values.\n\n### API availability\n\nDepending on whether the above security measures are taken, the various memory-sharing APIs have different availabilities:\n\n- The `Atomics` object is always available.\n- `SharedArrayBuffer` objects are in principle always available, but unfortunately the constructor on the global object is hidden, unless the two headers mentioned above are set, for compatibility with web content. There is hope that this restriction can be removed in the future. [`WebAssembly.Memory`](/en-US/docs/WebAssembly/JavaScript_interface/Memory) can still be used to get an instance.\n- Unless the two headers mentioned above are set, the various `postMessage()` APIs will throw for `SharedArrayBuffer` objects. If they are set, `postMessage()` on `Window` objects and dedicated workers will function and allow for memory sharing.\n\n### WebAssembly shared memory\n\n[`WebAssembly.Memory`](/en-US/docs/WebAssembly/JavaScript_interface/Memory) objects can be created with the [`shared`](/en-US/docs/WebAssembly/JavaScript_interface/Memory/Memory#shared) constructor flag. When this flag is set to `true`, the constructed `Memory` object can be shared between workers via `postMessage()`, just like `SharedArrayBuffer`, and the backing [`buffer`](/en-US/docs/WebAssembly/JavaScript_interface/Memory/buffer) of the `Memory` object is a `SharedArrayBuffer`. Therefore, the requirements listed above for sharing a `SharedArrayBuffer` between workers also apply to sharing a `WebAssembly.Memory`.\n\nThe WebAssembly Threads proposal also defines a new set of [atomic](https://github.com/WebAssembly/threads/blob/master/proposals/threads/Overview.md#atomic-memory-accesses) instructions. Just as `SharedArrayBuffer` and its methods are unconditionally enabled (and only sharing between threads is gated on the new headers), the WebAssembly atomic instructions are also unconditionally allowed.\n\n### Growing SharedArrayBuffers\n\n`SharedArrayBuffer` objects can be made growable by including the `maxByteLength` option when calling the {{jsxref("SharedArrayBuffer/SharedArrayBuffer", "SharedArrayBuffer()")}} constructor. You can query whether a `SharedArrayBuffer` is growable and what its maximum size is by accessing its {{jsxref("SharedArrayBuffer/growable", "growable")}} and {{jsxref("SharedArrayBuffer/maxByteLength", "maxByteLength")}} properties, respectively. You can assign a new size to a growable `SharedArrayBuffer` with a {{jsxref("SharedArrayBuffer/grow", "grow()")}} call. New bytes are initialized to 0.\n\nThese features make growing `SharedArrayBuffer`s more efficient \u2014 otherwise, you have to make a copy of the buffer with a new size. It also gives JavaScript parity with WebAssembly in this regard (Wasm linear memory can be resized with [`WebAssembly.Memory.prototype.grow()`](/en-US/docs/WebAssembly/JavaScript_interface/Memory/grow)).\n\nFor security reasons, `SharedArrayBuffer`s cannot be reduced in size, only grown.\n\n## Constructor\n\n- {{jsxref("SharedArrayBuffer/SharedArrayBuffer", "SharedArrayBuffer()")}}\n  - : Creates a new `SharedArrayBuffer` object.\n\n## Static properties\n\n- {{jsxref("SharedArrayBuffer/@@species", "SharedArrayBuffer[@@species]")}}\n  - : Returns the constructor used to construct return values from `SharedArrayBuffer` methods.\n\n## Instance properties\n\nThese properties are defined on `SharedArrayBuffer.prototype` and shared by all `SharedArrayBuffer` instances.\n\n- {{jsxref("SharedArrayBuffer.prototype.byteLength")}}\n  - : The size, in bytes, of the array. This is established when the array is constructed and can only be changed using the {{jsxref("SharedArrayBuffer.prototype.grow()")}} method if the `SharedArrayBuffer` is growable.\n- {{jsxref("Object/constructor", "SharedArrayBuffer.prototype.constructor")}}\n  - : The constructor function that created the instance object. For `SharedArrayBuffer` instances, the initial value is the {{jsxref("SharedArrayBuffer/SharedArrayBuffer", "SharedArrayBuffer")}} constructor.\n- {{jsxref("SharedArrayBuffer.prototype.growable")}}\n  - : Read-only. Returns `true` if the `SharedArrayBuffer` can be grown, or `false` if not.\n- {{jsxref("SharedArrayBuffer.prototype.maxByteLength")}}\n  - : The read-only maximum length, in bytes, that the `SharedArrayBuffer` can be grown to. This is established when the array is constructed and cannot be changed.\n- `SharedArrayBuffer.prototype[@@toStringTag]`\n  - : The initial value of the [`@@toStringTag`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol/toStringTag) property is the string `"SharedArrayBuffer"`. This property is used in {{jsxref("Object.prototype.toString()")}}.\n\n## Instance methods\n\n- {{jsxref("SharedArrayBuffer.prototype.grow()")}}\n  - : Grows the `SharedArrayBuffer` to the specified size, in bytes.\n- {{jsxref("SharedArrayBuffer.prototype.slice()")}}\n  - : Returns a new `SharedArrayBuffer` whose contents are a copy of this `SharedArrayBuffer`\'s bytes from `begin`, inclusive, up to `end`, exclusive. If either `begin` or `end` is negative, it refers to an index from the end of the array, as opposed to from the beginning.\n\n## Examples\n\n### Creating a new SharedArrayBuffer\n\n```js\nconst sab = new SharedArrayBuffer(1024);\n```\n\n### Slicing the SharedArrayBuffer\n\n```js\nsab.slice(); // SharedArrayBuffer { byteLength: 1024 }\nsab.slice(2); // SharedArrayBuffer { byteLength: 1022 }\nsab.slice(-2); // SharedArrayBuffer { byteLength: 2 }\nsab.slice(0, 1); // SharedArrayBuffer { byteLength: 1 }\n```\n\n### Using it in a WebGL buffer\n\n```js\nconst canvas = document.querySelector("canvas");\nconst gl = canvas.getContext("webgl");\nconst buffer = gl.createBuffer();\ngl.bindBuffer(gl.ARRAY_BUFFER, buffer);\ngl.bufferData(gl.ARRAY_BUFFER, sab, gl.STATIC_DRAW);\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Atomics")}}\n- {{jsxref("ArrayBuffer")}}\n- [JavaScript typed arrays](/en-US/docs/Web/JavaScript/Guide/Typed_arrays) guide\n- [Web Workers](/en-US/docs/Web/API/Web_Workers_API)\n- [Shared Memory \u2013 a brief tutorial](https://github.com/tc39/proposal-ecmascript-sharedmem/blob/main/TUTORIAL.md) in the TC39 ecmascript-sharedmem proposal\n- [A Taste of JavaScript\'s New Parallel Primitives](https://hacks.mozilla.org/2016/05/a-taste-of-javascripts-new-parallel-primitives/) on hacks.mozilla.org (2016)\n- [COOP and COEP explained](https://docs.google.com/document/d/1zDlfvfTJ_9e8Jdc8ehuV4zMEu9ySMCiTGMS9y0GU92k/edit) by the Chrome team (2020)\n- {{HTTPHeader("Cross-Origin-Opener-Policy")}}\n- {{HTTPHeader("Cross-Origin-Embedder-Policy")}}\n- {{HTTPHeader("Cross-Origin-Resource-Policy")}}\n- [`crossOriginIsolated`](/en-US/docs/Web/API/crossOriginIsolated)\n- [SharedArrayBuffer updates in Android Chrome 88 and Desktop Chrome 92](https://developer.chrome.com/blog/enabling-shared-array-buffer/) on developer.chrome.com (2021)\n',
        "maxbytelength": {
            "index.md": '---\ntitle: SharedArrayBuffer.prototype.maxByteLength\nslug: Web/JavaScript/Reference/Global_Objects/SharedArrayBuffer/maxByteLength\npage-type: javascript-instance-accessor-property\nbrowser-compat: javascript.builtins.SharedArrayBuffer.maxByteLength\n---\n\n{{JSRef}}\n\nThe **`maxByteLength`** accessor property of {{jsxref("SharedArrayBuffer")}} instances returns the maximum length (in bytes) that this `SharedArrayBuffer` can be grown to.\n\n## Description\n\nThe `maxByteLength` property is an accessor property whose set accessor function is `undefined`, meaning that you can only read this property. The value is established when the shared array is constructed, set via the `maxByteLength` option of the {{jsxref("SharedArrayBuffer/SharedArrayBuffer", "SharedArrayBuffer()")}} constructor, and cannot be changed.\n\nIf this `SharedArrayBuffer` was constructed without specifying a `maxByteLength` value, this property returns a value equal to the value of the `SharedArrayBuffer`\'s {{jsxref("SharedArrayBuffer/byteLength", "byteLength")}}.\n\n## Examples\n\n### Using maxByteLength\n\nIn this example, we create a 8-byte buffer that is resizable to a max length of 16 bytes, then return its `maxByteLength`:\n\n```js\nconst buffer = new SharedArrayBuffer(8, { maxByteLength: 16 });\n\nbuffer.maxByteLength; // 16\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("SharedArrayBuffer")}}\n'
        },
        "sharedarraybuffer": {
            "index.md": '---\ntitle: SharedArrayBuffer() constructor\nslug: Web/JavaScript/Reference/Global_Objects/SharedArrayBuffer/SharedArrayBuffer\npage-type: javascript-constructor\nbrowser-compat: javascript.builtins.SharedArrayBuffer.SharedArrayBuffer\n---\n\n{{JSRef}}\n\n> **Note:** The `SharedArrayBuffer` constructor may not always be globally available unless certain [security requirements](/en-US/docs/Web/JavaScript/Reference/Global_Objects/SharedArrayBuffer#security_requirements) are met.\n\nThe **`SharedArrayBuffer()`** constructor creates {{jsxref("SharedArrayBuffer")}} objects.\n\n{{EmbedInteractiveExample("pages/js/sharedarraybuffer-constructor.html", "shorter")}}\n\n## Syntax\n\n```js-nolint\nnew SharedArrayBuffer(length)\nnew SharedArrayBuffer(length, options)\n```\n\n> **Note:** `SharedArrayBuffer()` can only be constructed with [`new`](/en-US/docs/Web/JavaScript/Reference/Operators/new). Attempting to call it without `new` throws a {{jsxref("TypeError")}}.\n\n### Parameters\n\n- `length`\n  - : The size, in bytes, of the array buffer to create.\n- `options` {{optional_inline}}\n  - : An object, which can contain the following properties:\n    - `maxByteLength` {{optional_inline}}\n      - : The maximum size, in bytes, that the shared array buffer can be resized to.\n\n### Return value\n\nA new `SharedArrayBuffer` object of the specified size, with its {{jsxref("SharedArrayBuffer/maxByteLength", "maxByteLength")}} property set to the specified `maxByteLength` if one was specified. Its contents are\ninitialized to 0.\n\n## Examples\n\n### Always use the new operator to create a SharedArrayBuffer\n\n`SharedArrayBuffer` constructors are required to be constructed with a\n{{jsxref("Operators/new", "new")}} operator. Calling a `SharedArrayBuffer`\nconstructor as a function without `new` will throw a {{jsxref("TypeError")}}.\n\n```js example-bad\nconst sab = SharedArrayBuffer(1024);\n// TypeError: calling a builtin SharedArrayBuffer constructor\n// without new is forbidden\n```\n\n```js example-good\nconst sab = new SharedArrayBuffer(1024);\n```\n\n### Growing a growable SharedArrayBuffer\n\nIn this example, we create an 8-byte buffer that is growable to a max length of 16 bytes, then {{jsxref("SharedArrayBuffer/grow", "grow()")}} it to 12 bytes:\n\n```js\nconst buffer = new SharedArrayBuffer(8, { maxByteLength: 16 });\n\nbuffer.grow(12);\n```\n\n> **Note:** It is recommended that `maxByteLength` is set to the smallest value possible for your use case. It should never exceed `1073741824` (1GB), to reduce the risk of out-of-memory errors.\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Atomics")}}\n- {{jsxref("ArrayBuffer")}}\n- [JavaScript typed arrays](/en-US/docs/Web/JavaScript/Guide/Typed_arrays) guide\n'
        },
        "slice": {
            "index.md": '---\ntitle: SharedArrayBuffer.prototype.slice()\nslug: Web/JavaScript/Reference/Global_Objects/SharedArrayBuffer/slice\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.SharedArrayBuffer.slice\n---\n\n{{JSRef}}\n\nThe **`slice()`** method of {{jsxref("SharedArrayBuffer")}} instances returns a new `SharedArrayBuffer` whose contents are a copy of this `SharedArrayBuffer`\'s bytes from `start`, inclusive, up to `end`, exclusive. If either `start` or `end` is negative, it refers to an index from the end of the array, as opposed to from the beginning.\n\n{{EmbedInteractiveExample("pages/js/sharedarraybuffer-slice.html")}}\n\n## Syntax\n\n```js-nolint\nslice()\nslice(start)\nslice(start, end)\n```\n\n### Parameters\n\n- `start` {{optional_inline}}\n  - : Zero-based index at which to start extraction, [converted to an integer](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number#integer_conversion).\n    - Negative index counts back from the end of the buffer \u2014 if `-buffer.length <= start < 0`, `start + buffer.length` is used.\n    - If `start < -buffer.length` or `start` is omitted, `0` is used.\n    - If `start >= buffer.length`, nothing is extracted.\n- `end` {{optional_inline}}\n  - : Zero-based index at which to end extraction, [converted to an integer](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number#integer_conversion). `slice()` extracts up to but not including `end`.\n    - Negative index counts back from the end of the buffer \u2014 if `-buffer.length <= end < 0`, `end + buffer.length` is used.\n    - If `end < -buffer.length`, `0` is used.\n    - If `end >= buffer.length` or `end` is omitted, `buffer.length` is used, causing all elements until the end to be extracted.\n    - If `end` implies a position before or at the position that `start` implies, nothing is extracted.\n\n### Return value\n\nA new {{jsxref("SharedArrayBuffer")}} containing the extracted elements.\n\n## Examples\n\n### Using slice()\n\n```js\nconst sab = new SharedArrayBuffer(1024);\nsab.slice(); // SharedArrayBuffer { byteLength: 1024 }\nsab.slice(2); // SharedArrayBuffer { byteLength: 1022 }\nsab.slice(-2); // SharedArrayBuffer { byteLength: 2 }\nsab.slice(0, 1); // SharedArrayBuffer { byteLength: 1 }\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("SharedArrayBuffer")}}\n- {{jsxref("ArrayBuffer.prototype.slice()")}}\n'
        }
    },
    "string": {
        "@@iterator": {
            "index.md": '---\ntitle: String.prototype[@@iterator]()\nslug: Web/JavaScript/Reference/Global_Objects/String/@@iterator\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.String.@@iterator\n---\n\n{{JSRef}}\n\nThe **`[@@iterator]()`** method of {{jsxref("String")}} values implements the [iterable protocol](/en-US/docs/Web/JavaScript/Reference/Iteration_protocols) and allows strings to be consumed by most syntaxes expecting iterables, such as the [spread syntax](/en-US/docs/Web/JavaScript/Reference/Operators/Spread_syntax) and {{jsxref("Statements/for...of", "for...of")}} loops. It returns a [string iterator object](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Iterator) that yields the Unicode code points of the string value as individual strings.\n\n{{EmbedInteractiveExample("pages/js/string-prototype-@@iterator.html")}}\n\n## Syntax\n\n```js-nolint\nstring[Symbol.iterator]()\n```\n\n### Parameters\n\nNone.\n\n### Return value\n\nA new [iterable iterator object](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Iterator) that yields the Unicode code points of the string value as individual strings.\n\n## Description\n\nStrings are iterated by Unicode code points. This means grapheme clusters will be split, but surrogate pairs will be preserved.\n\n```js\n// "Backhand Index Pointing Right: Dark Skin Tone"\n[..."\uD83D\uDC49\uD83C\uDFFF"]; // [\'\uD83D\uDC49\', \'\uD83C\uDFFF\']\n// splits into the basic "Backhand Index Pointing Right" emoji and\n// the "Dark skin tone" emoji\n\n// "Family: Man, Boy"\n[..."\uD83D\uDC68\u200D\uD83D\uDC66"]; // [ \'\uD83D\uDC68\', \'\u200D\', \'\uD83D\uDC66\' ]\n// splits into the "Man" and "Boy" emoji, joined by a ZWJ\n```\n\n## Examples\n\n### Iteration using for...of loop\n\nNote that you seldom need to call this method directly. The existence of the `@@iterator` method makes strings [iterable](/en-US/docs/Web/JavaScript/Reference/Iteration_protocols#the_iterable_protocol), and iterating syntaxes like the `for...of` loop automatically call this method to obtain the iterator to loop over.\n\n```js\nconst str = "A\uD835\uDC68B\uD835\uDC69C\uD835\uDC6A";\n\nfor (const v of str) {\n  console.log(v);\n}\n// "A"\n// "\uD835\uDC68"\n// "B"\n// "\uD835\uDC69"\n// "C"\n// "\uD835\uDC6A"\n```\n\n### Manually hand-rolling the iterator\n\nYou may still manually call the `next()` method of the returned iterator object to achieve maximum control over the iteration process.\n\n```js\nconst str = "A\uD835\uDC68";\n\nconst strIter = str[Symbol.iterator]();\n\nconsole.log(strIter.next().value); // "A"\nconsole.log(strIter.next().value); // "\uD835\uDC68"\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `String.prototype[@@iterator]` in `core-js`](https://github.com/zloirock/core-js#ecmascript-string-and-regexp)\n- [Text formatting](/en-US/docs/Web/JavaScript/Guide/Text_formatting) guide\n- {{jsxref("Symbol.iterator")}}\n- [Iteration protocols](/en-US/docs/Web/JavaScript/Reference/Iteration_protocols)\n'
        },
        "anchor": {
            "index.md": '---\ntitle: String.prototype.anchor()\nslug: Web/JavaScript/Reference/Global_Objects/String/anchor\npage-type: javascript-instance-method\nstatus:\n  - deprecated\nbrowser-compat: javascript.builtins.String.anchor\n---\n\n{{JSRef}} {{Deprecated_Header}}\n\nThe **`anchor()`** method of {{jsxref("String")}} values creates a string that embeds this string in an {{HTMLElement("a")}} element with a name (`<a name="...">str</a>`).\n\n> **Note:** All [HTML wrapper methods](/en-US/docs/Web/JavaScript/Reference/Global_Objects/String#html_wrapper_methods) are deprecated and only standardized for compatibility purposes. Use [DOM APIs](/en-US/docs/Web/API/Document_Object_Model) such as [`document.createElement()`](/en-US/docs/Web/API/Document/createElement) instead.\n>\n> The HTML specification no longer allows the {{HTMLElement("a")}} element to have a `name` attribute, so this method doesn\'t even create valid markup.\n\n## Syntax\n\n```js-nolint\nanchor(name)\n```\n\n### Parameters\n\n- `name`\n  - : A string representing a `name` value to put into the generated `<a name="...">` start tag.\n\n### Return value\n\nA string beginning with an `<a name="name">` start tag (double quotes in `name` are replaced with `&quot;`), then the text `str`, and then an `</a>` end tag.\n\n## Examples\n\n### Using anchor()\n\nThe code below creates an HTML string and then replaces the document\'s body with it:\n\n```js\nconst contentString = "Hello, world";\n\ndocument.body.innerHTML = contentString.anchor("hello");\n```\n\nThis will create the following HTML:\n\n```html\n<a name="hello">Hello, world</a>\n```\n\n> **Warning:** This markup is invalid, because `name` is no longer a valid attribute of the {{HTMLElement("a")}} element.\n\nInstead of using `anchor()` and creating HTML text directly, you should use DOM APIs such as [`document.createElement()`](/en-US/docs/Web/API/Document/createElement). For example:\n\n```js\nconst contentString = "Hello, world";\nconst elem = document.createElement("a");\nelem.innerText = contentString;\ndocument.body.appendChild(elem);\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `String.prototype.anchor` in `core-js`](https://github.com/zloirock/core-js#ecmascript-string-and-regexp)\n- [HTML wrapper methods](/en-US/docs/Web/JavaScript/Reference/Global_Objects/String#html_wrapper_methods)\n- {{HTMLElement("a")}}\n'
        },
        "at": {
            "index.md": '---\ntitle: String.prototype.at()\nslug: Web/JavaScript/Reference/Global_Objects/String/at\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.String.at\n---\n\n{{JSRef}}\n\nThe **`at()`** method of {{jsxref("String")}} values takes an integer value and returns a new {{jsxref("String")}} consisting of the single UTF-16 code unit located at the specified offset. This method allows for positive and negative integers. Negative integers count back from the last string character.\n\n{{EmbedInteractiveExample("pages/js/string-at.html")}}\n\n## Syntax\n\n```js-nolint\nat(index)\n```\n\n### Parameters\n\n- `index`\n  - : The index (position) of the string character to be returned. Supports relative indexing from the end of the string when passed a negative index; i.e. if a negative number is used, the character returned will be found by counting back from the end of the string.\n\n### Return value\n\nA {{jsxref("String")}} consisting of the single UTF-16 code unit located at the specified position. Returns {{jsxref("undefined")}} if the given index can not be found.\n\n## Examples\n\n### Return the last character of a string\n\nThe following example provides a function which returns the last character found in a specified string.\n\n```js\n// A function which returns the last character of a given string\nfunction returnLast(arr) {\n  return arr.at(-1);\n}\n\nlet invoiceRef = "myinvoice01";\n\nconsole.log(returnLast(invoiceRef)); // \'1\'\n\ninvoiceRef = "myinvoice02";\n\nconsole.log(returnLast(invoiceRef)); // \'2\'\n```\n\n### Comparing methods\n\nHere we compare different ways to select the penultimate (last but one) character of a {{jsxref("String")}}. Whilst all below methods are valid, it highlights the succinctness and readability of the `at()` method.\n\n```js\nconst myString = "Every green bus drives fast.";\n\n// Using length property and charAt() method\nconst lengthWay = myString.charAt(myString.length - 2);\nconsole.log(lengthWay); // \'t\'\n\n// Using slice() method\nconst sliceWay = myString.slice(-2, -1);\nconsole.log(sliceWay); // \'t\'\n\n// Using at() method\nconst atWay = myString.at(-2);\nconsole.log(atWay); // \'t\'\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `String.prototype.at` in `core-js`](https://github.com/zloirock/core-js#ecmascript-string-and-regexp)\n- {{jsxref("String.prototype.indexOf()")}}\n- {{jsxref("String.prototype.lastIndexOf()")}}\n- {{jsxref("String.prototype.charCodeAt()")}}\n- {{jsxref("String.prototype.codePointAt()")}}\n- {{jsxref("String.prototype.split()")}}\n'
        },
        "big": {
            "index.md": '---\ntitle: String.prototype.big()\nslug: Web/JavaScript/Reference/Global_Objects/String/big\npage-type: javascript-instance-method\nstatus:\n  - deprecated\nbrowser-compat: javascript.builtins.String.big\n---\n\n{{JSRef}} {{Deprecated_Header}}\n\nThe **`big()`** method of {{jsxref("String")}} values creates a string that embeds this string in a {{HTMLElement("big")}} element (`<big>str</big>`), which causes this string to be displayed in a big font.\n\n> **Note:** All [HTML wrapper methods](/en-US/docs/Web/JavaScript/Reference/Global_Objects/String#html_wrapper_methods) are deprecated and only standardized for compatibility purposes. For the case of `big()`, the `<big>` element itself has been removed from the HTML specification and shouldn\'t be used anymore. Web developers should use [CSS](/en-US/docs/Web/CSS) properties instead.\n\n## Syntax\n\n```js-nolint\nbig()\n```\n\n### Parameters\n\nNone.\n\n### Return value\n\nA string beginning with a `<big>` start tag, then the text `str`, and then a `</big>` end tag.\n\n## Examples\n\n### Using big()\n\nThe code below creates an HTML string and then replaces the document\'s body with it:\n\n```js\nconst contentString = "Hello, world";\n\ndocument.body.innerHTML = contentString.big();\n```\n\nThis will create the following HTML:\n\n```html\n<big>Hello, world</big>\n```\n\n> **Warning:** This markup is invalid, because `big` is no longer a valid element.\n\nInstead of using `big()` and creating HTML text directly, you should use CSS to manipulate fonts. For example, you can manipulate {{cssxref("font-size")}} through the {{domxref("HTMLElement/style", "element.style")}} attribute:\n\n```js\ndocument.getElementById("yourElemId").style.fontSize = "2em";\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `String.prototype.big` in `core-js`](https://github.com/zloirock/core-js#ecmascript-string-and-regexp)\n- [HTML wrapper methods](/en-US/docs/Web/JavaScript/Reference/Global_Objects/String#html_wrapper_methods)\n- {{HTMLElement("big")}}\n'
        },
        "blink": {
            "index.md": '---\ntitle: String.prototype.blink()\nslug: Web/JavaScript/Reference/Global_Objects/String/blink\npage-type: javascript-instance-method\nstatus:\n  - deprecated\nbrowser-compat: javascript.builtins.String.blink\n---\n\n{{JSRef}} {{Deprecated_Header}}\n\nThe **`blink()`** method of {{jsxref("String")}} values creates a string that embeds this string in a `<blink>` element (`<blink>str</blink>`), which used to cause a string to blink in old browsers.\n\n> **Note:** All [HTML wrapper methods](/en-US/docs/Web/JavaScript/Reference/Global_Objects/String#html_wrapper_methods) are deprecated and only standardized for compatibility purposes. For the case of `blink()`, the `<blink>` element itself is removed from modern browsers, and blinking text is frowned upon by several accessibility standards. Avoid using the element in any way.\n\n## Syntax\n\n```js-nolint\nblink()\n```\n\n### Parameters\n\nNone.\n\n### Return value\n\nA string beginning with a `<blink>` start tag, then the text `str`, and then a `</blink>` end tag.\n\n## Examples\n\n### Using blink()\n\nThe code below creates an HTML string and then replaces the document\'s body with it:\n\n```js\nconst contentString = "Hello, world";\n\ndocument.body.innerHTML = contentString.blink();\n```\n\nThis will create the following HTML:\n\n```html\n<blink>Hello, world</blink>\n```\n\n> **Warning:** This markup is invalid, because `blink` is no longer a valid element.\n\nYou should avoid blinking elements altogether.\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `String.prototype.blink` in `core-js`](https://github.com/zloirock/core-js#ecmascript-string-and-regexp)\n- [HTML wrapper methods](/en-US/docs/Web/JavaScript/Reference/Global_Objects/String#html_wrapper_methods)\n'
        },
        "bold": {
            "index.md": '---\ntitle: String.prototype.bold()\nslug: Web/JavaScript/Reference/Global_Objects/String/bold\npage-type: javascript-instance-method\nstatus:\n  - deprecated\nbrowser-compat: javascript.builtins.String.bold\n---\n\n{{JSRef}} {{Deprecated_Header}}\n\nThe **`bold()`** method of {{jsxref("String")}} values creates a string that embeds this string in a {{HTMLElement("b")}} element (`<b>str</b>`), which causes this string to be displayed as bold.\n\n> **Note:** All [HTML wrapper methods](/en-US/docs/Web/JavaScript/Reference/Global_Objects/String#html_wrapper_methods) are deprecated and only standardized for compatibility purposes. Use [DOM APIs](/en-US/docs/Web/API/Document_Object_Model) such as [`document.createElement()`](/en-US/docs/Web/API/Document/createElement) instead.\n\n## Syntax\n\n```js-nolint\nbold()\n```\n\n### Parameters\n\nNone.\n\n### Return value\n\nA string beginning with a `<b>` start tag, then the text `str`, and then a `</b>` end tag.\n\n## Examples\n\n### Using bold()\n\nThe code below creates an HTML string and then replaces the document\'s body with it:\n\n```js\nconst contentString = "Hello, world";\n\ndocument.body.innerHTML = contentString.bold();\n```\n\nThis will create the following HTML:\n\n```html\n<b>Hello, world</b>\n```\n\nInstead of using `bold()` and creating HTML text directly, you should use DOM APIs such as [`document.createElement()`](/en-US/docs/Web/API/Document/createElement). For example:\n\n```js\nconst contentString = "Hello, world";\nconst elem = document.createElement("b");\nelem.innerText = contentString;\ndocument.body.appendChild(elem);\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `String.prototype.bold` in `core-js`](https://github.com/zloirock/core-js#ecmascript-string-and-regexp)\n- [HTML wrapper methods](/en-US/docs/Web/JavaScript/Reference/Global_Objects/String#html_wrapper_methods)\n- {{HTMLElement("b")}}\n'
        },
        "charat": {
            "index.md": '---\ntitle: String.prototype.charAt()\nslug: Web/JavaScript/Reference/Global_Objects/String/charAt\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.String.charAt\n---\n\n{{JSRef}}\n\nThe **`charAt()`** method of {{jsxref("String")}} values returns a new string consisting of the single UTF-16 code unit at the given index.\n\n`charAt()` always indexes the string as a sequence of [UTF-16 code units](/en-US/docs/Web/JavaScript/Reference/Global_Objects/String#utf-16_characters_unicode_code_points_and_grapheme_clusters), so it may return lone surrogates. To get the full Unicode code point at the given index, use {{jsxref("String.prototype.codePointAt()")}} and {{jsxref("String.fromCodePoint()")}}.\n\n{{EmbedInteractiveExample("pages/js/string-charat.html", "shorter")}}\n\n## Syntax\n\n```js-nolint\ncharAt(index)\n```\n\n### Parameters\n\n- `index`\n  - : Zero-based index of the character to be returned. [Converted to an integer](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number#integer_conversion) \u2014 `undefined` is converted to 0.\n\n### Return value\n\nA string representing the character (exactly one UTF-16 code unit) at the specified `index`. If `index` is out of the range of `0` \u2013 `str.length - 1`, `charAt()` returns an empty string.\n\n## Description\n\nCharacters in a string are indexed from left to right. The index of the first character is `0`, and the index of the last character in a string called `str` is `str.length - 1`.\n\nUnicode code points range from `0` to `1114111` (`0x10FFFF`). `charAt()` always returns a character whose value is less than `65536`, because the higher code points are represented by _a pair_ of 16-bit surrogate pseudo-characters. Therefore, in order to get a full character with value greater than `65535`, it is necessary to retrieve not only `charAt(i)`, but also `charAt(i + 1)` (as if manipulating a string with two characters), or to use {{jsxref("String/codePointAt", "codePointAt(i)")}} and {{jsxref("String.fromCodePoint()")}} instead. For information on Unicode, see [UTF-16 characters, Unicode code points, and grapheme clusters](/en-US/docs/Web/JavaScript/Reference/Global_Objects/String#utf-16_characters_unicode_code_points_and_grapheme_clusters).\n\n`charAt()` is very similar to using [bracket notation](/en-US/docs/Web/JavaScript/Reference/Operators/Property_accessors#bracket_notation) to access a character at the specified index. The main differences are:\n\n- `charAt()` attempts to convert `index` to an integer, while bracket notation does not, and directly uses `index` as a property name.\n- `charAt()` returns an empty string if `index` is out of range, while bracket notation returns `undefined`.\n\n## Examples\n\n### Using charAt()\n\nThe following example displays characters at different locations in the string `"Brave new world"`:\n\n```js\nconst anyString = "Brave new world";\nconsole.log(`The character at index 0   is \'${anyString.charAt()}\'`);\n// No index was provided, used 0 as default\n\nconsole.log(`The character at index 0   is \'${anyString.charAt(0)}\'`);\nconsole.log(`The character at index 1   is \'${anyString.charAt(1)}\'`);\nconsole.log(`The character at index 2   is \'${anyString.charAt(2)}\'`);\nconsole.log(`The character at index 3   is \'${anyString.charAt(3)}\'`);\nconsole.log(`The character at index 4   is \'${anyString.charAt(4)}\'`);\nconsole.log(`The character at index 999 is \'${anyString.charAt(999)}\'`);\n```\n\nThese lines display the following:\n\n```plain\nThe character at index 0   is \'B\'\n\nThe character at index 0   is \'B\'\nThe character at index 1   is \'r\'\nThe character at index 2   is \'a\'\nThe character at index 3   is \'v\'\nThe character at index 4   is \'e\'\nThe character at index 999 is \'\'\n```\n\n`charAt()` may return lone surrogates, which are not valid Unicode characters.\n\n```js\nconst str = "\uD842\uDFB7\uD842\uDFBE";\nconsole.log(str.charAt(0)); // "\ud842", which is not a valid Unicode character\nconsole.log(str.charAt(1)); // "\udfb7", which is not a valid Unicode character\n```\n\nTo get the full Unicode code point at the given index, use an indexing method that splits by Unicode code points, such as {{jsxref("String.prototype.codePointAt()")}} and [spreading strings](/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/@@iterator) into an array of Unicode code points.\n\n```js\nconst str = "\uD842\uDFB7\uD842\uDFBE";\nconsole.log(String.fromCodePoint(str.codePointAt(0))); // "\uD842\uDFB7"\nconsole.log([...str][0]); // "\uD842\uDFB7"\n```\n\n> **Note:** Avoid re-implementing the solutions above using `charAt()`. The detection of lone surrogates and their pairing is complex, and built-in APIs may be more performant as they directly use the internal representation of the string. Install a polyfill for the APIs mentioned above if necessary.\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("String.prototype.indexOf()")}}\n- {{jsxref("String.prototype.lastIndexOf()")}}\n- {{jsxref("String.prototype.charCodeAt()")}}\n- {{jsxref("String.prototype.codePointAt()")}}\n- {{jsxref("String.prototype.split()")}}\n- {{jsxref("String.fromCodePoint()")}}\n- [JavaScript has a Unicode problem](https://mathiasbynens.be/notes/javascript-unicode) by Mathias Bynens (2013)\n'
        },
        "charcodeat": {
            "index.md": '---\ntitle: String.prototype.charCodeAt()\nslug: Web/JavaScript/Reference/Global_Objects/String/charCodeAt\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.String.charCodeAt\n---\n\n{{JSRef}}\n\nThe **`charCodeAt()`** method of {{jsxref("String")}} values returns an integer between `0` and `65535` representing the UTF-16 code unit at the given index.\n\n`charCodeAt()` always indexes the string as a sequence of [UTF-16 code units](/en-US/docs/Web/JavaScript/Reference/Global_Objects/String#utf-16_characters_unicode_code_points_and_grapheme_clusters), so it may return lone surrogates. To get the full Unicode code point at the given index, use {{jsxref("String.prototype.codePointAt()")}}.\n\n{{EmbedInteractiveExample("pages/js/string-charcodeat.html", "shorter")}}\n\n## Syntax\n\n```js-nolint\ncharCodeAt(index)\n```\n\n### Parameters\n\n- `index`\n  - : Zero-based index of the character to be returned. [Converted to an integer](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number#integer_conversion) \u2014 `undefined` is converted to 0.\n\n### Return value\n\nAn integer between `0` and `65535` representing the UTF-16 code unit value of the character at the specified `index`. If `index` is out of range of `0` \u2013 `str.length - 1`, `charCodeAt()` returns {{jsxref("NaN")}}.\n\n## Description\n\nCharacters in a string are indexed from left to right. The index of the first character is `0`, and the index of the last character in a string called `str` is `str.length - 1`.\n\nUnicode code points range from `0` to `1114111` (`0x10FFFF`). `charCodeAt()` always returns a value that is less than `65536`, because the higher code points are represented by _a pair_ of 16-bit surrogate pseudo-characters. Therefore, in order to get a full character with value greater than `65535`, it is necessary to retrieve not only `charCodeAt(i)`, but also `charCodeAt(i + 1)` (as if manipulating a string with two characters), or to use {{jsxref("String/codePointAt", "codePointAt(i)")}} instead. For information on Unicode, see [UTF-16 characters, Unicode code points, and grapheme clusters](/en-US/docs/Web/JavaScript/Reference/Global_Objects/String#utf-16_characters_unicode_code_points_and_grapheme_clusters).\n\n## Examples\n\n### Using charCodeAt()\n\nThe following example returns `65`, the Unicode value for A.\n\n```js\n"ABC".charCodeAt(0); // returns 65\n```\n\n`charCodeAt()` may return lone surrogates, which are not valid Unicode characters.\n\n```js\nconst str = "\uD842\uDFB7\uD842\uDFBE";\nconsole.log(str.charCodeAt(0)); // 55362, or d842, which is not a valid Unicode character\nconsole.log(str.charCodeAt(1)); // 57271, or dfb7, which is not a valid Unicode character\n```\n\nTo get the full Unicode code point at the given index, use {{jsxref("String.prototype.codePointAt()")}}.\n\n```js\nconst str = "\uD842\uDFB7\uD842\uDFBE";\nconsole.log(str.codePointAt(0)); // 134071\n```\n\n> **Note:** Avoid re-implementing `codePointAt()` using `charCodeAt()`. The translation from UTF-16 surrogates to Unicode code points is complex, and `codePointAt()` may be more performant as it directly uses the internal representation of the string. Install a polyfill for `codePointAt()` if necessary.\n\nBelow is a possible algorithm to convert a pair of UTF-16 code units into a Unicode code point, adapted from the [Unicode FAQ](https://unicode.org/faq/utf_bom.html#utf16-3):\n\n```js\n// constants\nconst LEAD_OFFSET = 0xd800 - (0x10000 >> 10);\nconst SURROGATE_OFFSET = 0x10000 - (0xd800 << 10) - 0xdc00;\n\nfunction utf16ToUnicode(lead, trail) {\n  return (lead << 10) + trail + SURROGATE_OFFSET;\n}\nfunction unicodeToUTF16(codePoint) {\n  const lead = LEAD_OFFSET + (codePoint >> 10);\n  const trail = 0xdc00 + (codePoint & 0x3ff);\n  return [lead, trail];\n}\n\nconst str = "\uD842\uDFB7";\nconsole.log(utf16ToUnicode(str.charCodeAt(0), str.charCodeAt(1))); // 134071\nconsole.log(str.codePointAt(0)); // 134071\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("String.fromCharCode()")}}\n- {{jsxref("String.prototype.charAt()")}}\n- {{jsxref("String.fromCodePoint()")}}\n- {{jsxref("String.prototype.codePointAt()")}}\n'
        },
        "codepointat": {
            "index.md": '---\ntitle: String.prototype.codePointAt()\nslug: Web/JavaScript/Reference/Global_Objects/String/codePointAt\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.String.codePointAt\n---\n\n{{JSRef}}\n\nThe **`codePointAt()`** method of {{jsxref("String")}} values returns a non-negative integer that is the Unicode code point value of the character starting at the given index. Note that the index is still based on UTF-16 code units, not Unicode code points.\n\n{{EmbedInteractiveExample("pages/js/string-codepointat.html", "shorter")}}\n\n## Syntax\n\n```js-nolint\ncodePointAt(index)\n```\n\n### Parameters\n\n- `index`\n  - : Zero-based index of the character to be returned. [Converted to an integer](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number#integer_conversion) \u2014 `undefined` is converted to 0.\n\n### Return value\n\nA non-negative integer representing the code point value of the character at the given `index`.\n\n- If `index` is out of the range of `0` \u2013 `str.length - 1`, `codePointAt()` returns {{jsxref("undefined")}}.\n- If the element at `index` is a UTF-16 leading surrogate, returns the code point of the surrogate _pair_.\n- If the element at `index` is a UTF-16 trailing surrogate, returns _only_ the trailing surrogate code unit.\n\n## Description\n\nCharacters in a string are indexed from left to right. The index of the first character is `0`, and the index of the last character in a string called `str` is `str.length - 1`.\n\nUnicode code points range from `0` to `1114111` (`0x10FFFF`). In UTF-16, each string index is a code unit with value `0` \u2013 `65535`. Higher code points are represented by _a pair_ of 16-bit surrogate pseudo-characters. Therefore, `codePointAt()` returns a code point that may span two string indices. For information on Unicode, see [UTF-16 characters, Unicode code points, and grapheme clusters](/en-US/docs/Web/JavaScript/Reference/Global_Objects/String#utf-16_characters_unicode_code_points_and_grapheme_clusters).\n\n## Examples\n\n### Using codePointAt()\n\n```js\n"ABC".codePointAt(0); // 65\n"ABC".codePointAt(0).toString(16); // 41\n\n"\uD83D\uDE0D".codePointAt(0); // 128525\n"\ud83d\ude0d".codePointAt(0); // 128525\n"\ud83d\ude0d".codePointAt(0).toString(16); // 1f60d\n\n"\uD83D\uDE0D".codePointAt(1); // 56845\n"\ud83d\ude0d".codePointAt(1); // 56845\n"\ud83d\ude0d".codePointAt(1).toString(16); // de0d\n\n"ABC".codePointAt(42); // undefined\n```\n\n### Looping with codePointAt()\n\nBecause using string indices for looping causes the same code point to be visited twice (once for the leading surrogate, once for the trailing surrogate), and the second time `codePointAt()` returns _only_ the trailing surrogate, it\'s better to avoid looping by index.\n\n```js example-bad\nconst str = "\ud83d\udc0e\ud83d\udc71\\u2764";\n\nfor (let i = 0; i < str.length; i++) {\n  console.log(str.codePointAt(i).toString(16));\n}\n// \'1f40e\', \'dc0e\', \'1f471\', \'dc71\', \'2764\'\n```\n\nInstead, use a [`for...of`](/en-US/docs/Web/JavaScript/Guide/Loops_and_iteration#for...of_statement) statement or [spread the string](/en-US/docs/Web/JavaScript/Reference/Operators/Spread_syntax), both of which invoke the string\'s [`@@iterator`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/@@iterator), which iterates by code points. Then, use `codePointAt(0)` to get the code point of each element.\n\n```js\nfor (const codePoint of str) {\n  console.log(codePoint.codePointAt(0).toString(16));\n}\n// \'1f40e\', \'1f471\', \'2764\'\n\n[...str].map((cp) => cp.codePointAt(0).toString(16));\n// [\'1f40e\', \'1f471\', \'2764\']\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `String.prototype.codePointAt` in `core-js`](https://github.com/zloirock/core-js#ecmascript-string-and-regexp)\n- {{jsxref("String.fromCodePoint()")}}\n- {{jsxref("String.fromCharCode()")}}\n- {{jsxref("String.prototype.charCodeAt()")}}\n- {{jsxref("String.prototype.charAt()")}}\n'
        },
        "concat": {
            "index.md": '---\ntitle: String.prototype.concat()\nslug: Web/JavaScript/Reference/Global_Objects/String/concat\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.String.concat\n---\n\n{{JSRef}}\n\nThe **`concat()`** method of {{jsxref("String")}} values concatenates\nthe string arguments to this string and returns a new string.\n\n{{EmbedInteractiveExample("pages/js/string-concat.html")}}\n\n## Syntax\n\n```js-nolint\nconcat()\nconcat(str1)\nconcat(str1, str2)\nconcat(str1, str2, /* \u2026, */ strN)\n```\n\n### Parameters\n\n- `str1`, \u2026, `strN`\n  - : One or more strings to concatenate to `str`.\n\n### Return value\n\nA new string containing the combined text of the strings provided.\n\n## Description\n\nThe `concat()` function concatenates the string arguments to the calling\nstring and returns a new string. Changes to the original string or the returned string\ndon\'t affect the other.\n\nIf the arguments are not of the type string, they are converted to string values before\nconcatenating.\n\nThe `concat()` method is very similar to the [addition/string concatenation operators](/en-US/docs/Web/JavaScript/Reference/Operators/Addition) (`+`, `+=`), except that `concat()` [coerces its arguments directly to strings](/en-US/docs/Web/JavaScript/Reference/Global_Objects/String#string_coercion), while addition coerces its operands to primitives first. For more information, see the reference page for the [`+` operator](/en-US/docs/Web/JavaScript/Reference/Operators/Addition).\n\n## Examples\n\n### Using concat()\n\nThe following example combines strings into a new string.\n\n```js\nconst hello = "Hello, ";\nconsole.log(hello.concat("Kevin", ". Have a nice day."));\n// Hello, Kevin. Have a nice day.\n\nconst greetList = ["Hello", " ", "Venkat", "!"];\n"".concat(...greetList); // "Hello Venkat!"\n\n"".concat({}); // "[object Object]"\n"".concat([]); // ""\n"".concat(null); // "null"\n"".concat(true); // "true"\n"".concat(4, 5); // "45"\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Array.prototype.concat()")}}\n- [Addition (`+`)](/en-US/docs/Web/JavaScript/Reference/Operators/Addition)\n'
        },
        "endswith": {
            "index.md": '---\ntitle: String.prototype.endsWith()\nslug: Web/JavaScript/Reference/Global_Objects/String/endsWith\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.String.endsWith\n---\n\n{{JSRef}}\n\nThe **`endsWith()`** method of {{jsxref("String")}} values determines whether a string ends with the characters of this string, returning `true` or `false` as appropriate.\n\n{{EmbedInteractiveExample("pages/js/string-endswith.html")}}\n\n## Syntax\n\n```js-nolint\nendsWith(searchString)\nendsWith(searchString, endPosition)\n```\n\n### Parameters\n\n- `searchString`\n  - : The characters to be searched for at the end of `str`. Cannot [be a regex](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp#special_handling_for_regexes). All values that are not regexes are [coerced to strings](/en-US/docs/Web/JavaScript/Reference/Global_Objects/String#string_coercion), so omitting it or passing `undefined` causes `endsWith()` to search for the string `"undefined"`, which is rarely what you want.\n- `endPosition` {{optional_inline}}\n  - : The end position at which `searchString` is expected to be found (the index of `searchString`\'s last character plus 1). Defaults to `str.length`.\n\n### Return value\n\n**`true`** if the given characters are found at the end of the string, including when `searchString` is an empty string; otherwise, **`false`**.\n\n### Exceptions\n\n- {{jsxref("TypeError")}}\n  - : Thrown if `searchString` [is a regex](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp#special_handling_for_regexes).\n\n## Description\n\nThis method lets you determine whether or not a string ends with another string. This method is case-sensitive.\n\n## Examples\n\n### Using endsWith()\n\n```js\nconst str = "To be, or not to be, that is the question.";\n\nconsole.log(str.endsWith("question.")); // true\nconsole.log(str.endsWith("to be")); // false\nconsole.log(str.endsWith("to be", 19)); // true\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `String.prototype.endsWith` in `core-js`](https://github.com/zloirock/core-js#ecmascript-string-and-regexp)\n- {{jsxref("String.prototype.startsWith()")}}\n- {{jsxref("String.prototype.includes()")}}\n- {{jsxref("String.prototype.indexOf()")}}\n- {{jsxref("String.prototype.lastIndexOf()")}}\n'
        },
        "fixed": {
            "index.md": '---\ntitle: String.prototype.fixed()\nslug: Web/JavaScript/Reference/Global_Objects/String/fixed\npage-type: javascript-instance-method\nstatus:\n  - deprecated\nbrowser-compat: javascript.builtins.String.fixed\n---\n\n{{JSRef}} {{Deprecated_Header}}\n\nThe **`fixed()`** method of {{jsxref("String")}} values creates a string that embeds this string in a {{HTMLElement("tt")}} element (`<tt>str</tt>`), which causes this string to be displayed in a fixed-width font.\n\n> **Note:** All [HTML wrapper methods](/en-US/docs/Web/JavaScript/Reference/Global_Objects/String#html_wrapper_methods) are deprecated and only standardized for compatibility purposes. For the case of `fixed()`, the `<tt>` element itself has been removed from the HTML specification and shouldn\'t be used anymore. Web developers should use [CSS](/en-US/docs/Web/CSS) properties instead.\n\n## Syntax\n\n```js-nolint\nfixed()\n```\n\n### Parameters\n\nNone.\n\n### Return value\n\nA string beginning with a `<tt>` start tag, then the text `str`, and then a `</tt>` end tag.\n\n## Examples\n\n### Using fixed()\n\nThe code below creates an HTML string and then replaces the document\'s body with it:\n\n```js\nconst contentString = "Hello, world";\n\ndocument.body.innerHTML = contentString.fixed();\n```\n\nThis will create the following HTML:\n\n```html\n<tt>Hello, world</tt>\n```\n\n> **Warning:** This markup is invalid, because `tt` is no longer a valid element.\n\nInstead of using `fixed()` and creating HTML text directly, you should use CSS to manipulate fonts. For example, you can manipulate {{cssxref("font-family")}} through the {{domxref("HTMLElement/style", "element.style")}} attribute:\n\n```js\ndocument.getElementById("yourElemId").style.fontFamily = "monospace";\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `String.prototype.fixed` in `core-js`](https://github.com/zloirock/core-js#ecmascript-string-and-regexp)\n- [HTML wrapper methods](/en-US/docs/Web/JavaScript/Reference/Global_Objects/String#html_wrapper_methods)\n- {{HTMLElement("tt")}}\n'
        },
        "fontcolor": {
            "index.md": '---\ntitle: String.prototype.fontcolor()\nslug: Web/JavaScript/Reference/Global_Objects/String/fontcolor\npage-type: javascript-instance-method\nstatus:\n  - deprecated\nbrowser-compat: javascript.builtins.String.fontcolor\n---\n\n{{JSRef}} {{Deprecated_Header}}\n\nThe **`fontcolor()`** method of {{jsxref("String")}} values creates a string that embeds this string in a {{HTMLElement("font")}} element (`<font color="...">str</font>`), which causes this string to be displayed in the specified font color.\n\n> **Note:** All [HTML wrapper methods](/en-US/docs/Web/JavaScript/Reference/Global_Objects/String#html_wrapper_methods) are deprecated and only standardized for compatibility purposes. For the case of `fontcolor()`, the `<font>` element itself has been removed from the HTML specification and shouldn\'t be used anymore. Web developers should use [CSS](/en-US/docs/Web/CSS) properties instead.\n\n## Syntax\n\n```js-nolint\nfontcolor(color)\n```\n\n### Parameters\n\n- `color`\n  - : A string expressing the color as a hexadecimal RGB triplet or as a string literal. String literals for color names are listed in the [CSS color reference](/en-US/docs/Web/CSS/color_value).\n\n### Return value\n\nA string beginning with a `<font color="color">` start tag (double quotes in `color` are replaced with `&quot;`), then the text `str`, and then a `</font>` end tag.\n\n## Description\n\nThe `fontcolor()` method itself simply joins the string parts together without any validation or normalization. However, to create valid {{HTMLElement("font")}} elements, if you express color as a hexadecimal RGB triplet, you must use the format `rrggbb`. For example, the hexadecimal RGB values for salmon are red=FA, green=80, and blue=72, so the RGB triplet for salmon is `"FA8072"`.\n\n## Examples\n\n### Using fontcolor()\n\nThe code below creates an HTML string and then replaces the document\'s body with it:\n\n```js\nconst contentString = "Hello, world";\n\ndocument.body.innerHTML = contentString.fontcolor("red");\n```\n\nThis will create the following HTML:\n\n```html\n<font color="red">Hello, world</font>\n```\n\n> **Warning:** This markup is invalid, because `font` is no longer a valid element.\n\nInstead of using `fontcolor()` and creating HTML text directly, you should use CSS to manipulate fonts. For example, you can manipulate {{cssxref("color")}} through the {{domxref("HTMLElement/style", "element.style")}} attribute:\n\n```js\ndocument.getElementById("yourElemId").style.color = "red";\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `String.prototype.fontcolor` in `core-js`](https://github.com/zloirock/core-js#ecmascript-string-and-regexp)\n- [HTML wrapper methods](/en-US/docs/Web/JavaScript/Reference/Global_Objects/String#html_wrapper_methods)\n- {{HTMLElement("font")}}\n'
        },
        "fontsize": {
            "index.md": '---\ntitle: String.prototype.fontsize()\nslug: Web/JavaScript/Reference/Global_Objects/String/fontsize\npage-type: javascript-instance-method\nstatus:\n  - deprecated\nbrowser-compat: javascript.builtins.String.fontsize\n---\n\n{{JSRef}} {{Deprecated_Header}}\n\nThe **`fontsize()`** method of {{jsxref("String")}} values creates a string that embeds this string in a {{HTMLElement("font")}} element (`<font size="...">str</font>`), which causes this string to be displayed in the specified font size.\n\n> **Note:** All [HTML wrapper methods](/en-US/docs/Web/JavaScript/Reference/Global_Objects/String#html_wrapper_methods) are deprecated and only standardized for compatibility purposes. For the case of `fontsize()`, the `<font>` element itself has been removed from the HTML specification and shouldn\'t be used anymore. Web developers should use [CSS](/en-US/docs/Web/CSS) properties instead.\n\n## Syntax\n\n```js-nolint\nfontsize(size)\n```\n\n### Parameters\n\n- `size`\n  - : An integer between 1 and 7, or a string representing a signed integer between 1 and 7.\n\n### Return value\n\nA string beginning with a `<font size="size">` start tag (double quotes in `size` are replaced with `&quot;`), then the text `str`, and then a `</font>` end tag.\n\n## Description\n\nThe `fontsize()` method itself simply joins the string parts together without any validation or normalization. However, to create valid {{HTMLElement("font")}} elements, When you specify size as an integer, you set the font size of `str` to one of the 7 defined sizes. You can specify `size` as a string such as `"-2"` or `"+3"` to adjust the font size of `str` relative to 3, the default value.\n\n## Examples\n\n### Using fontsize()\n\nThe code below creates an HTML string and then replaces the document\'s body with it:\n\n```js\nconst contentString = "Hello, world";\n\ndocument.body.innerHTML = contentString.fontsize(7);\n```\n\nThis will create the following HTML:\n\n```html\n<font size="7">Hello, world</font>\n```\n\n> **Warning:** This markup is invalid, because `font` is no longer a valid element.\n\nInstead of using `fontsize()` and creating HTML text directly, you should use CSS to manipulate fonts. For example, you can manipulate {{cssxref("font-size")}} through the {{domxref("HTMLElement/style", "element.style")}} attribute:\n\n```js\ndocument.getElementById("yourElemId").style.fontSize = "7pt";\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `String.prototype.fontsize` in `core-js`](https://github.com/zloirock/core-js#ecmascript-string-and-regexp)\n- [HTML wrapper methods](/en-US/docs/Web/JavaScript/Reference/Global_Objects/String#html_wrapper_methods)\n- {{HTMLElement("font")}}\n'
        },
        "fromcharcode": {
            "index.md": '---\ntitle: String.fromCharCode()\nslug: Web/JavaScript/Reference/Global_Objects/String/fromCharCode\npage-type: javascript-static-method\nbrowser-compat: javascript.builtins.String.fromCharCode\n---\n\n{{JSRef}}\n\nThe **`String.fromCharCode()`** static method returns a string created from the specified sequence of UTF-16 code units.\n\n{{EmbedInteractiveExample("pages/js/string-fromcharcode.html", "shorter")}}\n\n## Syntax\n\n```js-nolint\nString.fromCharCode()\nString.fromCharCode(num1)\nString.fromCharCode(num1, num2)\nString.fromCharCode(num1, num2, /* \u2026, */ numN)\n```\n\n### Parameters\n\n- `num1`, \u2026, `numN`\n  - : A number between `0` and `65535` (`0xFFFF`) representing a UTF-16 code unit. Numbers greater than `0xFFFF` are truncated to the last 16 bits. No validity checks are performed.\n\n### Return value\n\nA string of length `N` consisting of the `N` specified UTF-16 code units.\n\n## Description\n\nBecause `fromCharCode()` is a static method of `String`, you always use it as `String.fromCharCode()`, rather than as a method of a `String` value you created.\n\nUnicode code points range from `0` to `1114111` (`0x10FFFF`). `charCodeAt()` always returns a value that is less than `65536`, because the higher code points are represented by _a pair_ of 16-bit surrogate pseudo-characters. Therefore, in order to produce a full character with value greater than `65535`, it is necessary to provide two code units (as if manipulating a string with two characters). For information on Unicode, see [UTF-16 characters, Unicode code points, and grapheme clusters](/en-US/docs/Web/JavaScript/Reference/Global_Objects/String#utf-16_characters_unicode_code_points_and_grapheme_clusters).\n\nBecause `fromCharCode()` only works with 16-bit values (same as the `\\u` escape sequence), a surrogate pair is required in order to return a supplementary character. For example, both `String.fromCharCode(0xd83c, 0xdf03)` and `"\ud83c\udf03"` return code point `U+1F303` "Night with Stars". While there is a mathematical relationship between the supplementary code point value (e.g. `0x1f303`) and both surrogate values that represent it (e.g., `0xd83c` and `0xdf03`), it does require an extra step to either calculate or look up the surrogate pair values every time a supplementary code point is to be used. For this reason, it\'s more convenient to use {{jsxref("String.fromCodePoint()")}}, which allows for returning supplementary characters based on their actual code point value. For example, `String.fromCodePoint(0x1f303)` returns code point `U+1F303` "Night with Stars".\n\n## Examples\n\n### Using fromCharCode()\n\nBMP characters, in UTF-16, use a single code unit:\n\n```js\nString.fromCharCode(65, 66, 67); // returns "ABC"\nString.fromCharCode(0x2014); // returns "\u2014"\nString.fromCharCode(0x12014); // also returns "\u2014"; the digit 1 is truncated and ignored\nString.fromCharCode(8212); // also returns "\u2014"; 8212 is the decimal form of 0x2014\n```\n\nSupplementary characters, in UTF-16, require two code units (i.e. a surrogate pair):\n\n```js\nString.fromCharCode(0xd83c, 0xdf03); // Code Point U+1F303 "Night with\nString.fromCharCode(55356, 57091); // Stars" === "\uD83C\uDF03"\n\nString.fromCharCode(0xd834, 0xdf06, 0x61, 0xd834, 0xdf07); // "\uD834\uDF06a\uD834\uDF07"\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("String.fromCodePoint()")}}\n- {{jsxref("String.prototype.charAt()")}}\n- {{jsxref("String.prototype.charCodeAt()")}}\n- {{jsxref("String.prototype.codePointAt()")}}\n'
        },
        "fromcodepoint": {
            "index.md": '---\ntitle: String.fromCodePoint()\nslug: Web/JavaScript/Reference/Global_Objects/String/fromCodePoint\npage-type: javascript-static-method\nbrowser-compat: javascript.builtins.String.fromCodePoint\n---\n\n{{JSRef}}\n\nThe **`String.fromCodePoint()`** static method returns a string created from the specified sequence of code points.\n\n{{EmbedInteractiveExample("pages/js/string-fromcodepoint.html", "shorter")}}\n\n## Syntax\n\n```js-nolint\nString.fromCodePoint()\nString.fromCodePoint(num1)\nString.fromCodePoint(num1, num2)\nString.fromCodePoint(num1, num2, /* \u2026, */ numN)\n```\n\n### Parameters\n\n- `num1`, \u2026, `numN`\n  - : An integer between `0` and `0x10FFFF` (inclusive) representing a Unicode code point.\n\n### Return value\n\nA string created by using the specified sequence of code points.\n\n### Exceptions\n\n- {{jsxref("RangeError")}}\n  - : Thrown if `numN` is not an integer, is less than `0`, or is greater than `0x10FFFF` after being converted to a number.\n\n## Description\n\nBecause `fromCodePoint()` is a static method of `String`, you always use it as `String.fromCodePoint()`, rather than as a method of a `String` value you created.\n\nUnicode code points range from `0` to `1114111` (`0x10FFFF`). In UTF-16, each string index is a code unit with value `0` \u2013 `65535`. Higher code points are represented by _a pair_ of 16-bit surrogate pseudo-characters. Therefore, `fromCodePoint()` may return a string whose [`length`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/length) (in UTF-16 code units) is larger than the number of arguments passed. For information on Unicode, see [UTF-16 characters, Unicode code points, and grapheme clusters](/en-US/docs/Web/JavaScript/Reference/Global_Objects/String#utf-16_characters_unicode_code_points_and_grapheme_clusters).\n\n## Examples\n\n### Using fromCodePoint()\n\nValid input:\n\n```js\nString.fromCodePoint(42); // "*"\nString.fromCodePoint(65, 90); // "AZ"\nString.fromCodePoint(0x404); // "\\u0404" === "\u0404"\nString.fromCodePoint(0x2f804); // "\uD87E\uDC04"\nString.fromCodePoint(194564); // "\uD87E\uDC04"\nString.fromCodePoint(0x1d306, 0x61, 0x1d307); // "\uD834\uDF06a\uD834\uDF07"\n```\n\nInvalid input:\n\n```js\nString.fromCodePoint("_"); // RangeError\nString.fromCodePoint(Infinity); // RangeError\nString.fromCodePoint(-1); // RangeError\nString.fromCodePoint(3.14); // RangeError\nString.fromCodePoint(3e-2); // RangeError\nString.fromCodePoint(NaN); // RangeError\n```\n\n### Compared to fromCharCode()\n\n{{jsxref("String.fromCharCode()")}} cannot return supplementary characters (i.e. code points `0x010000` \u2013 `0x10FFFF`) by specifying their code point. Instead, it requires the UTF-16 surrogate pair in order to return a supplementary character:\n\n```js\nString.fromCharCode(0xd83c, 0xdf03); // Code Point U+1F303 "Night with\nString.fromCharCode(55356, 57091); // Stars" === "\uD83C\uDF03"\n```\n\n`String.fromCodePoint()`, on the other hand, can return 4-byte supplementary characters, as well as the more common 2-byte BMP characters, by specifying their code point (which is equivalent to the UTF-32 code unit):\n\n```js\nString.fromCodePoint(0x1f303); // or 127747 in decimal\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `String.fromCodePoint` in `core-js`](https://github.com/zloirock/core-js#ecmascript-string-and-regexp)\n- {{jsxref("String.fromCharCode()")}}\n- {{jsxref("String.prototype.charAt()")}}\n- {{jsxref("String.prototype.codePointAt()")}}\n- {{jsxref("String.prototype.charCodeAt()")}}\n'
        },
        "includes": {
            "index.md": '---\ntitle: String.prototype.includes()\nslug: Web/JavaScript/Reference/Global_Objects/String/includes\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.String.includes\n---\n\n{{JSRef}}\n\nThe **`includes()`** method of {{jsxref("String")}} values performs a case-sensitive search to determine whether a given string may be found within this string, returning `true` or `false` as appropriate.\n\n{{EmbedInteractiveExample("pages/js/string-includes.html", "shorter")}}\n\n## Syntax\n\n```js-nolint\nincludes(searchString)\nincludes(searchString, position)\n```\n\n### Parameters\n\n- `searchString`\n  - : A string to be searched for within `str`. Cannot [be a regex](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp#special_handling_for_regexes). All values that are not regexes are [coerced to strings](/en-US/docs/Web/JavaScript/Reference/Global_Objects/String#string_coercion), so omitting it or passing `undefined` causes `includes()` to search for the string `"undefined"`, which is rarely what you want.\n- `position` {{optional_inline}}\n  - : The position within the string at which to begin searching for `searchString`. (Defaults to `0`.)\n\n### Return value\n\n**`true`** if the search string is found anywhere within the given string, including when `searchString` is an empty string; otherwise, **`false`**.\n\n### Exceptions\n\n- {{jsxref("TypeError")}}\n  - : Thrown if `searchString` [is a regex](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp#special_handling_for_regexes).\n\n## Description\n\nThis method lets you determine whether or not a string includes another string.\n\n### Case-sensitivity\n\nThe `includes()` method is case sensitive. For example, the following expression returns `false`:\n\n```js\n"Blue Whale".includes("blue"); // returns false\n```\n\nYou can work around this constraint by transforming both the original string and the search string to all lowercase:\n\n```js\n"Blue Whale".toLowerCase().includes("blue"); // returns true\n```\n\n## Examples\n\n### Using includes()\n\n```js\nconst str = "To be, or not to be, that is the question.";\n\nconsole.log(str.includes("To be")); // true\nconsole.log(str.includes("question")); // true\nconsole.log(str.includes("nonexistent")); // false\nconsole.log(str.includes("To be", 1)); // false\nconsole.log(str.includes("TO BE")); // false\nconsole.log(str.includes("")); // true\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `String.prototype.includes` in `core-js`](https://github.com/zloirock/core-js#ecmascript-string-and-regexp)\n- {{jsxref("Array.prototype.includes()")}}\n- {{jsxref("TypedArray.prototype.includes()")}}\n- {{jsxref("String.prototype.indexOf()")}}\n- {{jsxref("String.prototype.lastIndexOf()")}}\n- {{jsxref("String.prototype.startsWith()")}}\n- {{jsxref("String.prototype.endsWith()")}}\n'
        },
        "index.md": '---\ntitle: String\nslug: Web/JavaScript/Reference/Global_Objects/String\npage-type: javascript-class\nbrowser-compat: javascript.builtins.String\n---\n\n{{JSRef}}\n\nThe **`String`** object is used to represent and manipulate a\nsequence of characters.\n\n## Description\n\nStrings are useful for holding data that can be represented in text form. Some of the\nmost-used operations on strings are to check their {{jsxref("String/length", "length")}}, to build and concatenate them using the\n[`+` and `+=` string operators](/en-US/docs/Web/JavaScript/Guide/Expressions_and_operators#string_operators),\nchecking for the existence or location of substrings with the\n{{jsxref("String/indexOf", "indexOf()")}} method, or extracting substrings\nwith the {{jsxref("String/substring", "substring()")}} method.\n\n### Creating strings\n\nStrings can be created as primitives, from string literals, or as objects, using the\n{{jsxref("String/String", "String()")}} constructor:\n\n```js-nolint\nconst string1 = "A string primitive";\nconst string2 = \'Also a string primitive\';\nconst string3 = `Yet another string primitive`;\n```\n\n```js\nconst string4 = new String("A String object");\n```\n\nString primitives and string objects share many behaviors, but have other important differences and caveats.\nSee "[String primitives and String objects](#string_primitives_and_string_objects)" below.\n\nString literals can be specified using single or double quotes, which are treated\nidentically, or using the backtick character <kbd>`</kbd>. This last form specifies a [template literal](/en-US/docs/Web/JavaScript/Reference/Template_literals):\nwith this form you can interpolate expressions. For more information on the syntax of string literals, see [lexical grammar](/en-US/docs/Web/JavaScript/Reference/Lexical_grammar#string_literals).\n\n### Character access\n\nThere are two ways to access an individual character in a string. The first is the\n{{jsxref("String/charAt", "charAt()")}} method:\n\n```js\n"cat".charAt(1); // gives value "a"\n```\n\nThe other way is to treat the string as an array-like object, where individual characters correspond to a numerical index:\n\n```js\n"cat"[1]; // gives value "a"\n```\n\nWhen using bracket notation for character access, attempting to delete or assign a\nvalue to these properties will not succeed. The properties involved are neither writable\nnor configurable. (See {{jsxref("Object.defineProperty()")}} for more information.)\n\n### Comparing strings\n\nUse the [less-than and greater-than operators](/en-US/docs/Web/JavaScript/Reference/Operators) to compare strings:\n\n```js\nconst a = "a";\nconst b = "b";\nif (a < b) {\n  // true\n  console.log(`${a} is less than ${b}`);\n} else if (a > b) {\n  console.log(`${a} is greater than ${b}`);\n} else {\n  console.log(`${a} and ${b} are equal.`);\n}\n```\n\nNote that all comparison operators, including [`===`](/en-US/docs/Web/JavaScript/Reference/Operators/Strict_equality) and [`==`](/en-US/docs/Web/JavaScript/Reference/Operators/Equality), compare strings case-sensitively. A common way to compare strings case-insensitively is to convert both to the same case (upper or lower) before comparing them.\n\n```js\nfunction areEqualCaseInsensitive(str1, str2) {\n  return str1.toUpperCase() === str2.toUpperCase();\n}\n```\n\nThe choice of whether to transform by [`toUpperCase()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/toUpperCase) or [`toLowerCase()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/toLowerCase) is mostly arbitrary, and neither one is fully robust when extending beyond the Latin alphabet. For example, the German lowercase letter `\xdf` and `ss` are both transformed to `SS` by `toUpperCase()`, while the Turkish letter `\u0131` would be falsely reported as unequal to `I` by `toLowerCase()` unless specifically using [`toLocaleLowerCase("tr")`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/toLocaleLowerCase).\n\n```js\nconst areEqualInUpperCase = (str1, str2) =>\n  str1.toUpperCase() === str2.toUpperCase();\nconst areEqualInLowerCase = (str1, str2) =>\n  str1.toLowerCase() === str2.toLowerCase();\n\nareEqualInUpperCase("\xdf", "ss"); // true; should be false\nareEqualInLowerCase("\u0131", "I"); // false; should be true\n```\n\nA locale-aware and robust solution for testing case-insensitive equality is to use the {{jsxref("Intl.Collator")}} API or the string\'s [`localeCompare()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/localeCompare) method \u2014 they share the same interface \u2014 with the [`sensitivity`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Collator/Collator#sensitivity) option set to `"accent"` or `"base"`.\n\n```js\nconst areEqual = (str1, str2, locale = "en-US") =>\n  str1.localeCompare(str2, locale, { sensitivity: "accent" }) === 0;\n\nareEqual("\xdf", "ss", "de"); // false\nareEqual("\u0131", "I", "tr"); // true\n```\n\nThe `localeCompare()` method enables string comparison in a similar fashion as `strcmp()` \u2014 it allows sorting strings in a locale-aware manner.\n\n### String primitives and String objects\n\nNote that JavaScript distinguishes between `String` objects and\n{{Glossary("Primitive", "primitive string")}} values. (The same is true of\n{{jsxref("Boolean")}} and {{jsxref("Number", "Numbers")}}.)\n\nString literals (denoted by double or single quotes) and strings returned from\n`String` calls in a non-constructor context (that is, called without using\nthe {{jsxref("Operators/new", "new")}} keyword) are primitive strings. In contexts where a\nmethod is to be invoked on a primitive string or a property lookup occurs, JavaScript\nwill automatically wrap the string primitive and call the method or perform the property\nlookup on the wrapper object instead.\n\n```js\nconst strPrim = "foo"; // A literal is a string primitive\nconst strPrim2 = String(1); // Coerced into the string primitive "1"\nconst strPrim3 = String(true); // Coerced into the string primitive "true"\nconst strObj = new String(strPrim); // String with new returns a string wrapper object.\n\nconsole.log(typeof strPrim); // "string"\nconsole.log(typeof strPrim2); // "string"\nconsole.log(typeof strPrim3); // "string"\nconsole.log(typeof strObj); // "object"\n```\n\n> **Warning:** You should rarely find yourself using `String` as a constructor.\n\nString primitives and `String` objects also give different results when\nusing {{jsxref("Global_Objects/eval", "eval()")}}. Primitives passed to\n`eval` are treated as source code; `String` objects are treated as\nall other objects are, by returning the object. For example:\n\n```js\nconst s1 = "2 + 2"; // creates a string primitive\nconst s2 = new String("2 + 2"); // creates a String object\nconsole.log(eval(s1)); // returns the number 4\nconsole.log(eval(s2)); // returns the string "2 + 2"\n```\n\nFor these reasons, the code may break when it encounters `String` objects\nwhen it expects a primitive string instead, although generally, authors need not worry\nabout the distinction.\n\nA `String` object can always be converted to its primitive counterpart with\nthe {{jsxref("String/valueOf", "valueOf()")}} method.\n\n```js\nconsole.log(eval(s2.valueOf())); // returns the number 4\n```\n\n### String coercion\n\nMany built-in operations that expect strings first coerce their arguments to strings (which is largely why `String` objects behave similarly to string primitives). [The operation](https://tc39.es/ecma262/multipage/abstract-operations.html#sec-tostring) can be summarized as follows:\n\n- Strings are returned as-is.\n- [`undefined`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/undefined) turns into `"undefined"`.\n- [`null`](/en-US/docs/Web/JavaScript/Reference/Operators/null) turns into `"null"`.\n- `true` turns into `"true"`; `false` turns into `"false"`.\n- Numbers are converted with the same algorithm as [`toString(10)`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/toString).\n- [BigInts](/en-US/docs/Web/JavaScript/Reference/Global_Objects/BigInt) are converted with the same algorithm as [`toString(10)`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/BigInt/toString).\n- [Symbols](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol) throw a {{jsxref("TypeError")}}.\n- Objects are first [converted to a primitive](/en-US/docs/Web/JavaScript/Data_structures#primitive_coercion) by calling its [`[@@toPrimitive]()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol/toPrimitive) (with `"string"` as hint), `toString()`, and `valueOf()` methods, in that order. The resulting primitive is then converted to a string.\n\nThere are several ways to achieve nearly the same effect in JavaScript.\n\n- [Template literal](/en-US/docs/Web/JavaScript/Reference/Template_literals): `` `${x}` `` does exactly the string coercion steps explained above for the embedded expression.\n- The [`String()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/String) function: `String(x)` uses the same algorithm to convert `x`, except that [Symbols](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol) don\'t throw a {{jsxref("TypeError")}}, but return `"Symbol(description)"`, where `description` is the [description](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol/description) of the Symbol.\n- Using the [`+` operator](/en-US/docs/Web/JavaScript/Reference/Operators/Addition): `"" + x` coerces its operand to a _primitive_ instead of a _string_, and, for some objects, has entirely different behaviors from normal string coercion. See its [reference page](/en-US/docs/Web/JavaScript/Reference/Operators/Addition) for more details.\n\nDepending on your use case, you may want to use `` `${x}` `` (to mimic built-in behavior) or `String(x)` (to handle symbol values without throwing an error), but you should not use `"" + x`.\n\n### UTF-16 characters, Unicode code points, and grapheme clusters\n\nStrings are represented fundamentally as sequences of [UTF-16 code units](https://en.wikipedia.org/wiki/UTF-16). In UTF-16 encoding, every code unit is exact 16 bits long. This means there are a maximum of 2<sup>16</sup>, or 65536 possible characters representable as single UTF-16 code units. This character set is called the [basic multilingual plane (BMP)](<https://en.wikipedia.org/wiki/Plane_(Unicode)#Basic_Multilingual_Plane>), and includes the most common characters like the Latin, Greek, Cyrillic alphabets, as well as many East Asian characters. Each code unit can be written in a string with `\\u` followed by exactly four hex digits.\n\nHowever, the entire Unicode character set is much, much bigger than 65536. The extra characters are stored in UTF-16 as _surrogate pairs_, which are pairs of 16-bit code units that represent a single character. To avoid ambiguity, the two parts of the pair must be between `0xD800` and `0xDFFF`, and these code units are not used to encode single-code-unit characters. (More precisely, leading surrogates, also called high-surrogate code units, have values between `0xD800` and `0xDBFF`, inclusive, while trailing surrogates, also called low-surrogate code units, have values between `0xDC00` and `0xDFFF`, inclusive.) Each Unicode character, comprised of one or two UTF-16 code units, is also called a _Unicode code point_. Each Unicode code point can be written in a string with `\\u{xxxxxx}` where `xxxxxx` represents 1\u20136 hex digits.\n\nA "lone surrogate" is a 16-bit code unit satisfying one of the descriptions below:\n\n- It is in the range `0xD800`\u2013`0xDBFF`, inclusive (i.e. is a leading surrogate), but it is the last code unit in the string, or the next code unit is not a trailing surrogate.\n- It is in the range `0xDC00`\u2013`0xDFFF`, inclusive (i.e. is a trailing surrogate), but it is the first code unit in the string, or the previous code unit is not a leading surrogate.\n\nLone surrogates do not represent any Unicode character. Although most JavaScript built-in methods handle them correctly because they all work based on UTF-16 code units, lone surrogates are often not valid values when interacting with other systems \u2014 for example, [`encodeURI()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/encodeURI) will throw a {{jsxref("URIError")}} for lone surrogates, because URI encoding uses UTF-8 encoding, which does not have any encoding for lone surrogates. Strings not containing any lone surrogates are called _well-formed_ strings, and are safe to be used with functions that do not deal with UTF-16 (such as `encodeURI()` or {{domxref("TextEncoder")}}). You can check if a string is well-formed with the {{jsxref("String/isWellFormed", "isWellFormed()")}} method, or sanitize lone surrogates with the {{jsxref("String/toWellFormed", "toWellFormed()")}} method.\n\nOn top of Unicode characters, there are certain sequences of Unicode characters that should be treated as one visual unit, known as a _grapheme cluster_. The most common case is emojis: many emojis that have a range of variations are actually formed by multiple emojis, usually joined by the \\<ZWJ> (`U+200D`) character.\n\nYou must be careful which level of characters you are iterating on. For example, [`split("")`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/split) will split by UTF-16 code units and will separate surrogate pairs. String indexes also refer to the index of each UTF-16 code unit. On the other hand, [`@@iterator()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/@@iterator) iterates by Unicode code points. Iterating through grapheme clusters will require some custom code.\n\n```js\n"\uD83D\uDE04".split(""); // [\'\ud83d\', \'\ude04\']; splits into two lone surrogates\n\n// "Backhand Index Pointing Right: Dark Skin Tone"\n[..."\uD83D\uDC49\uD83C\uDFFF"]; // [\'\uD83D\uDC49\', \'\uD83C\uDFFF\']\n// splits into the basic "Backhand Index Pointing Right" emoji and\n// the "Dark skin tone" emoji\n\n// "Family: Man, Boy"\n[..."\uD83D\uDC68\u200D\uD83D\uDC66"]; // [ \'\uD83D\uDC68\', \'\u200D\', \'\uD83D\uDC66\' ]\n// splits into the "Man" and "Boy" emoji, joined by a ZWJ\n\n// The United Nations flag\n[..."\uD83C\uDDFA\uD83C\uDDF3"]; // [ \'\uD83C\uDDFA\', \'\uD83C\uDDF3\' ]\n// splits into two "region indicator" letters "U" and "N".\n// All flag emojis are formed by joining two region indicator letters\n```\n\n## Constructor\n\n- {{jsxref("String/String", "String()")}}\n  - : Creates a new `String` object. It performs type conversion when called as\n    a function, rather than as a constructor, which is usually more useful.\n\n## Static methods\n\n- {{jsxref("String.fromCharCode()")}}\n  - : Returns a string created by using the specified sequence of Unicode values.\n- {{jsxref("String.fromCodePoint()")}}\n  - : Returns a string created by using the specified sequence of code points.\n- {{jsxref("String.raw()")}}\n  - : Returns a string created from a raw template string.\n\n## Instance properties\n\nThese properties are defined on `String.prototype` and shared by all `String` instances.\n\n- {{jsxref("Object/constructor", "String.prototype.constructor")}}\n  - : The constructor function that created the instance object. For `String` instances, the initial value is the {{jsxref("String/String", "String")}} constructor.\n\nThese properties are own properties of each `String` instance.\n\n- {{jsxref("String/length", "length")}}\n  - : Reflects the `length` of the string. Read-only.\n\n## Instance methods\n\n- {{jsxref("String.prototype.at()")}}\n  - : Returns the character (exactly one UTF-16 code unit) at the specified `index`. Accepts negative integers, which count back from the last string character.\n- {{jsxref("String.prototype.charAt()")}}\n  - : Returns the character (exactly one UTF-16 code unit) at the specified\n    `index`.\n- {{jsxref("String.prototype.charCodeAt()")}}\n  - : Returns a number that is the UTF-16 code unit value at the given\n    `index`.\n- {{jsxref("String.prototype.codePointAt()")}}\n  - : Returns a nonnegative integer Number that is the code point value of the UTF-16\n    encoded code point starting at the specified `pos`.\n- {{jsxref("String.prototype.concat()")}}\n  - : Combines the text of two (or more) strings and returns a new string.\n- {{jsxref("String.prototype.endsWith()")}}\n  - : Determines whether a string ends with the characters of the string\n    `searchString`.\n- {{jsxref("String.prototype.includes()")}}\n  - : Determines whether the calling string contains `searchString`.\n- {{jsxref("String.prototype.indexOf()")}}\n  - : Returns the index within the calling {{jsxref("String")}} object of the first\n    occurrence of `searchValue`, or `-1` if not found.\n- {{jsxref("String.prototype.isWellFormed()")}}\n  - : Returns a boolean indicating whether this string contains any [lone surrogates](#utf-16_characters_unicode_code_points_and_grapheme_clusters).\n- {{jsxref("String.prototype.lastIndexOf()")}}\n  - : Returns the index within the calling {{jsxref("String")}} object of the last\n    occurrence of `searchValue`, or `-1` if not found.\n- {{jsxref("String.prototype.localeCompare()")}}\n  - : Returns a number indicating whether the reference string\n    `compareString` comes before, after, or is equivalent to the\n    given string in sort order.\n- {{jsxref("String.prototype.match()")}}\n  - : Used to match regular expression `regexp` against a string.\n- {{jsxref("String.prototype.matchAll()")}}\n  - : Returns an iterator of all `regexp`\'s matches.\n- {{jsxref("String.prototype.normalize()")}}\n  - : Returns the Unicode Normalization Form of the calling string value.\n- {{jsxref("String.prototype.padEnd()")}}\n  - : Pads the current string from the end with a given string and returns a new string of\n    the length `targetLength`.\n- {{jsxref("String.prototype.padStart()")}}\n  - : Pads the current string from the start with a given string and returns a new string\n    of the length `targetLength`.\n- {{jsxref("String.prototype.repeat()")}}\n  - : Returns a string consisting of the elements of the object repeated\n    `count` times.\n- {{jsxref("String.prototype.replace()")}}\n  - : Used to replace occurrences of `searchFor` using\n    `replaceWith`. `searchFor` may be a string\n    or Regular Expression, and `replaceWith` may be a string or\n    function.\n- {{jsxref("String.prototype.replaceAll()")}}\n  - : Used to replace all occurrences of `searchFor` using\n    `replaceWith`. `searchFor` may be a string\n    or Regular Expression, and `replaceWith` may be a string or\n    function.\n- {{jsxref("String.prototype.search()")}}\n  - : Search for a match between a regular expression `regexp` and\n    the calling string.\n- {{jsxref("String.prototype.slice()")}}\n  - : Extracts a section of a string and returns a new string.\n- {{jsxref("String.prototype.split()")}}\n  - : Returns an array of strings populated by splitting the calling string at occurrences\n    of the substring `sep`.\n- {{jsxref("String.prototype.startsWith()")}}\n  - : Determines whether the calling string begins with the characters of string\n    `searchString`.\n- {{jsxref("String.prototype.substr()")}} {{deprecated_inline}}\n  - : Returns a portion of the string, starting at the specified index and extending for a given number of characters afterwards.\n- {{jsxref("String.prototype.substring()")}}\n  - : Returns a new string containing characters of the calling string from (or between)\n    the specified index (or indices).\n- {{jsxref("String.prototype.toLocaleLowerCase()")}}\n\n  - : The characters within a string are converted to lowercase while respecting the\n    current locale.\n\n    For most languages, this will return the same as\n    {{jsxref("String/toLowerCase", "toLowerCase()")}}.\n\n- {{jsxref("String.prototype.toLocaleUpperCase()")}}\n\n  - : The characters within a string are converted to uppercase while respecting the\n    current locale.\n\n    For most languages, this will return the same as\n    {{jsxref("String/toUpperCase", "toUpperCase()")}}.\n\n- {{jsxref("String.prototype.toLowerCase()")}}\n  - : Returns the calling string value converted to lowercase.\n- {{jsxref("String.prototype.toString()")}}\n  - : Returns a string representing the specified object. Overrides the\n    {{jsxref("Object.prototype.toString()")}} method.\n- {{jsxref("String.prototype.toUpperCase()")}}\n  - : Returns the calling string value converted to uppercase.\n- {{jsxref("String.prototype.toWellFormed()")}}\n  - : Returns a string where all [lone surrogates](#utf-16_characters_unicode_code_points_and_grapheme_clusters) of this string are replaced with the Unicode replacement character U+FFFD.\n- {{jsxref("String.prototype.trim()")}}\n  - : Trims whitespace from the beginning and end of the string.\n- {{jsxref("String.prototype.trimEnd()")}}\n  - : Trims whitespace from the end of the string.\n- {{jsxref("String.prototype.trimStart()")}}\n  - : Trims whitespace from the beginning of the string.\n- {{jsxref("String.prototype.valueOf()")}}\n  - : Returns the primitive value of the specified object. Overrides the\n    {{jsxref("Object.prototype.valueOf()")}} method.\n- [`String.prototype[@@iterator]()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/@@iterator)\n  - : Returns a new iterator object that iterates over the code points of a String value,\n    returning each code point as a String value.\n\n### HTML wrapper methods\n\n> **Warning:** Deprecated. Avoid these methods.\n>\n> They are of limited use, as they are based on a very old HTML standard and provide only a subset of the currently available HTML tags and attributes. Many of them create deprecated or non-standard markup today. In addition, they do simple string concatenation without any validation or sanitation, which makes them a potential security threat when directly inserted using [`innerHTML`](/en-US/docs/Web/API/Element/innerHTML). Use [DOM APIs](/en-US/docs/Web/API/Document_Object_Model) such as [`document.createElement()`](/en-US/docs/Web/API/Document/createElement) instead.\n\n- {{jsxref("String.prototype.anchor()")}} {{deprecated_inline}}\n  - : [`<a name="name">`](/en-US/docs/Web/HTML/Element/a#name) (hypertext target)\n- {{jsxref("String.prototype.big()")}} {{deprecated_inline}}\n  - : {{HTMLElement("big")}}\n- {{jsxref("String.prototype.blink()")}} {{deprecated_inline}}\n  - : `<blink>`\n- {{jsxref("String.prototype.bold()")}} {{deprecated_inline}}\n  - : {{HTMLElement("b")}}\n- {{jsxref("String.prototype.fixed()")}} {{deprecated_inline}}\n  - : {{HTMLElement("tt")}}\n- {{jsxref("String.prototype.fontcolor()")}} {{deprecated_inline}}\n  - : [`<font color="color">`](/en-US/docs/Web/HTML/Element/font#color)\n- {{jsxref("String.prototype.fontsize()")}} {{deprecated_inline}}\n  - : [`<font size="size">`](/en-US/docs/Web/HTML/Element/font#size)\n- {{jsxref("String.prototype.italics()")}} {{deprecated_inline}}\n  - : {{HTMLElement("i")}}\n- {{jsxref("String.prototype.link()")}} {{deprecated_inline}}\n  - : [`<a href="url">`](/en-US/docs/Web/HTML/Element/a#href) (link to URL)\n- {{jsxref("String.prototype.small()")}} {{deprecated_inline}}\n  - : {{HTMLElement("small")}}\n- {{jsxref("String.prototype.strike()")}} {{deprecated_inline}}\n  - : {{HTMLElement("strike")}}\n- {{jsxref("String.prototype.sub()")}} {{deprecated_inline}}\n  - : {{HTMLElement("sub")}}\n- {{jsxref("String.prototype.sup()")}} {{deprecated_inline}}\n  - : {{HTMLElement("sup")}}\n\nNote that these methods do not check if the string itself contains HTML tags, so it\'s possible to create invalid HTML:\n\n```js\n"</b>".bold(); // <b></b></b>\n```\n\nThe only escaping they do is to replace `"` in the attribute value (for {{jsxref("String/anchor", "anchor()")}}, {{jsxref("String/fontcolor", "fontcolor()")}}, {{jsxref("String/fontsize", "fontsize()")}}, and {{jsxref("String/link", "link()")}}) with `&quot;`.\n\n```js\n"foo".anchor(\'"Hello"\'); // <a name="&quot;Hello&quot;">foo</a>\n```\n\n## Examples\n\n### String conversion\n\nThe `String()` function is a more reliable way of converting values to strings than calling the `toString()` method of the value, as the former works when used on [`null`](/en-US/docs/Web/JavaScript/Reference/Operators/null) and {{jsxref("undefined")}}. For example:\n\n```js\n// You cannot access properties on null or undefined\n\nconst nullVar = null;\nnullVar.toString(); // TypeError: Cannot read properties of null\nString(nullVar); // "null"\n\nconst undefinedVar = undefined;\nundefinedVar.toString(); // TypeError: Cannot read properties of undefined\nString(undefinedVar); // "undefined"\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Text formatting](/en-US/docs/Web/JavaScript/Guide/Text_formatting) guide\n- {{jsxref("RegExp")}}\n',
        "indexof": {
            "index.md": '---\ntitle: String.prototype.indexOf()\nslug: Web/JavaScript/Reference/Global_Objects/String/indexOf\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.String.indexOf\n---\n\n{{JSRef}}\n\nThe **`indexOf()`** method of {{jsxref("String")}} values searches this string and returns the index of the first occurrence of the specified substring. It takes an optional starting position and returns the first occurrence of the specified substring at an index greater than or equal to the specified number.\n\n{{EmbedInteractiveExample("pages/js/string-indexof.html", "taller")}}\n\n## Syntax\n\n```js-nolint\nindexOf(searchString)\nindexOf(searchString, position)\n```\n\n### Parameters\n\n- `searchString`\n\n  - : Substring to search for. All values are [coerced to strings](/en-US/docs/Web/JavaScript/Reference/Global_Objects/String#string_coercion), so omitting it or passing `undefined` causes `indexOf()` to search for the string `"undefined"`, which is rarely what you want.\n\n- `position` {{optional_inline}}\n\n  - : The method returns the index of the first occurrence of the specified substring at a position greater than or equal to `position`, which defaults to `0`. If `position` is greater than the length of the calling string, the method doesn\'t search the calling string at all. If `position` is less than zero, the method behaves as it would if `position` were `0`.\n\n    - `\'hello world hello\'.indexOf(\'o\', -5)` returns `4` \u2014 because it causes the method to behave as if the second argument were `0`, and the first occurrence of `o` at a position greater or equal to `0` is at position `4`.\n\n    - `\'hello world hello\'.indexOf(\'world\', 12)` returns `-1` \u2014 because, while it\'s true the substring `world` occurs at index `6`, that position is not greater than or equal to `12`.\n\n    - `\'hello world hello\'.indexOf(\'o\', 99)` returns `-1` \u2014 because `99` is greater than the length of `hello world hello`, which causes the method to not search the string at all.\n\n### Return value\n\nThe index of the first occurrence of `searchString` found, or `-1` if not found.\n\n#### Return value when using an empty search string\n\nSearching for an empty search string produces strange results. With no second argument, or with a second argument whose value is less than the calling string\'s length, the return value is the same as the value of the second argument:\n\n```js\n"hello world".indexOf(""); // returns 0\n"hello world".indexOf("", 0); // returns 0\n"hello world".indexOf("", 3); // returns 3\n"hello world".indexOf("", 8); // returns 8\n```\n\nHowever, with a second argument whose value is greater than or equal to the string\'s length, the return value is the string\'s length:\n\n```js\n"hello world".indexOf("", 11); // returns 11\n"hello world".indexOf("", 13); // returns 11\n"hello world".indexOf("", 22); // returns 11\n```\n\nIn the former instance, the method behaves as if it found an empty string just after the position specified in the second argument. In the latter instance, the method behaves as if it found an empty string at the end of the calling string.\n\n## Description\n\nStrings are zero-indexed: The index of a string\'s first character is `0`, and the index of a string\'s last character is the length of the string minus 1.\n\n```js\n"Blue Whale".indexOf("Blue"); // returns  0\n"Blue Whale".indexOf("Blute"); // returns -1\n"Blue Whale".indexOf("Whale", 0); // returns  5\n"Blue Whale".indexOf("Whale", 5); // returns  5\n"Blue Whale".indexOf("Whale", 7); // returns -1\n"Blue Whale".indexOf(""); // returns  0\n"Blue Whale".indexOf("", 9); // returns  9\n"Blue Whale".indexOf("", 10); // returns 10\n"Blue Whale".indexOf("", 11); // returns 10\n```\n\nThe `indexOf()` method is case sensitive. For example, the following\nexpression returns `-1`:\n\n```js\n"Blue Whale".indexOf("blue"); // returns -1\n```\n\n### Checking occurrences\n\nWhen checking if a specific substring occurs within a string, the correct way to check is test whether the return value is `-1`:\n\n```js\n"Blue Whale".indexOf("Blue") !== -1; // true; found \'Blue\' in \'Blue Whale\'\n"Blue Whale".indexOf("Bloe") !== -1; // false; no \'Bloe\' in \'Blue Whale\'\n```\n\n## Examples\n\n### Using indexOf()\n\nThe following example uses `indexOf()` to locate substrings in the string\n`"Brave new world"`.\n\n```js\nconst str = "Brave new world";\n\nconsole.log(str.indexOf("w")); // 8\nconsole.log(str.indexOf("new")); // 6\n```\n\n### indexOf() and case-sensitivity\n\nThe following example defines two string variables.\n\nThe variables contain the same string, except that the second string contains uppercase\nletters. The first {{domxref("console/log_static", "console.log()")}} method displays `19`. But\nbecause the `indexOf()` method is case sensitive, the string\n`"cheddar"` is not found in `myCapString`, so the second\n`console.log()` method displays `-1`.\n\n```js\nconst myString = "brie, pepper jack, cheddar";\nconst myCapString = "Brie, Pepper Jack, Cheddar";\n\nconsole.log(myString.indexOf("cheddar")); // 19\nconsole.log(myCapString.indexOf("cheddar")); // -1\n```\n\n### Using indexOf() to count occurrences of a letter in a string\n\nThe following example sets `count` to the number of occurrences of the\nletter `e` in the string `str`:\n\n```js\nconst str = "To be, or not to be, that is the question.";\nlet count = 0;\nlet position = str.indexOf("e");\n\nwhile (position !== -1) {\n  count++;\n  position = str.indexOf("e", position + 1);\n}\n\nconsole.log(count); // 4\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("String.prototype.charAt()")}}\n- {{jsxref("String.prototype.lastIndexOf()")}}\n- {{jsxref("String.prototype.includes()")}}\n- {{jsxref("String.prototype.split()")}}\n- {{jsxref("Array.prototype.indexOf()")}}\n'
        },
        "iswellformed": {
            "index.md": '---\ntitle: String.prototype.isWellFormed()\nslug: Web/JavaScript/Reference/Global_Objects/String/isWellFormed\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.String.isWellFormed\n---\n\n{{JSRef}}\n\nThe **`isWellFormed()`** method of {{jsxref("String")}} values returns a boolean indicating whether this string contains any [lone surrogates](/en-US/docs/Web/JavaScript/Reference/Global_Objects/String#utf-16_characters_unicode_code_points_and_grapheme_clusters).\n\n## Syntax\n\n```js-nolint\nisWellFormed()\n```\n\n### Parameters\n\nNone.\n\n### Return value\n\nReturns `true` if this string does not contain any lone surrogates, `false` otherwise.\n\n## Description\n\nStrings in JavaScript are UTF-16 encoded. UTF-16 encoding has the concept of _surrogate pairs_, which is introduced in detail in the [UTF-16 characters, Unicode code points, and grapheme clusters](/en-US/docs/Web/JavaScript/Reference/Global_Objects/String#utf-16_characters_unicode_code_points_and_grapheme_clusters) section.\n\n`isWellFormed()` allows you to test whether a string is well-formed (i.e. does not contain any lone surrogates). Compared to a custom implementation, `isWellFormed()` is more efficient, as engines can directly access the internal representation of strings. If you need to convert a string to a well-formed string, use the {{jsxref("String/toWellFormed", "toWellFormed()")}} method. `isWellFormed()` allows you to handle ill-formed strings differently from well-formed strings, such as throwing an error or marking it as invalid.\n\n## Examples\n\n### Using isWellFormed()\n\n```js\nconst strings = [\n  // Lone leading surrogate\n  "ab\uD800",\n  "ab\uD800c",\n  // Lone trailing surrogate\n  "\uDFFFab",\n  "c\uDFFFab",\n  // Well-formed\n  "abc",\n  "ab\uD83D\uDE04c",\n];\n\nfor (const str of strings) {\n  console.log(str.isWellFormed());\n}\n// Logs:\n// false\n// false\n// false\n// false\n// true\n// true\n```\n\n### Avoiding errors in encodeURI()\n\n{{jsxref("encodeURI")}} throws an error if the string passed is not well-formed. This can be avoided by using `isWellFormed()` to test the string before passing it to `encodeURI()`.\n\n```js\nconst illFormed = "https://example.com/search?q=\uD800";\n\ntry {\n  encodeURI(illFormed);\n} catch (e) {\n  console.log(e); // URIError: URI malformed\n}\n\nif (illFormed.isWellFormed()) {\n  console.log(encodeURI(illFormed));\n} else {\n  console.warn("Ill-formed strings encountered."); // Ill-formed strings encountered.\n}\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `String.prototype.isWellFormed` in `core-js`](https://github.com/zloirock/core-js#well-formed-unicode-strings)\n- {{jsxref("String.prototype.toWellFormed()")}}\n- {{jsxref("String.prototype.normalize()")}}\n'
        },
        "italics": {
            "index.md": '---\ntitle: String.prototype.italics()\nslug: Web/JavaScript/Reference/Global_Objects/String/italics\npage-type: javascript-instance-method\nstatus:\n  - deprecated\nbrowser-compat: javascript.builtins.String.italics\n---\n\n{{JSRef}} {{Deprecated_Header}}\n\nThe **`italics()`** method of {{jsxref("String")}} values creates a string that embeds this string in an {{HTMLElement("i")}} element (`<i>str</i>`), which causes this string to be displayed as italic.\n\n> **Note:** All [HTML wrapper methods](/en-US/docs/Web/JavaScript/Reference/Global_Objects/String#html_wrapper_methods) are deprecated and only standardized for compatibility purposes. Use [DOM APIs](/en-US/docs/Web/API/Document_Object_Model) such as [`document.createElement()`](/en-US/docs/Web/API/Document/createElement) instead.\n\n## Syntax\n\n```js-nolint\nitalics()\n```\n\n### Parameters\n\nNone.\n\n### Return value\n\nA string beginning with an `<i>` start tag, then the text `str`, and then an `</i>` end tag.\n\n## Examples\n\n### Using italics()\n\nThe code below creates an HTML string and then replaces the document\'s body with it:\n\n```js\nconst contentString = "Hello, world";\n\ndocument.body.innerHTML = contentString.italics();\n```\n\nThis will create the following HTML:\n\n```html\n<i>Hello, world</i>\n```\n\nInstead of using `italics()` and creating HTML text directly, you should use DOM APIs such as [`document.createElement()`](/en-US/docs/Web/API/Document/createElement). For example:\n\n```js\nconst contentString = "Hello, world";\nconst elem = document.createElement("i");\nelem.innerText = contentString;\ndocument.body.appendChild(elem);\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `String.prototype.italics` in `core-js`](https://github.com/zloirock/core-js#ecmascript-string-and-regexp)\n- [HTML wrapper methods](/en-US/docs/Web/JavaScript/Reference/Global_Objects/String#html_wrapper_methods)\n- {{HTMLElement("i")}}\n'
        },
        "lastindexof": {
            "index.md": '---\ntitle: String.prototype.lastIndexOf()\nslug: Web/JavaScript/Reference/Global_Objects/String/lastIndexOf\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.String.lastIndexOf\n---\n\n{{JSRef}}\n\nThe **`lastIndexOf()`** method of {{jsxref("String")}} values searches this string and returns the index of the last occurrence of the specified substring. It takes an optional starting position and returns the last occurrence of the specified substring at an index less than or equal to the specified number.\n\n{{EmbedInteractiveExample("pages/js/string-lastindexof.html")}}\n\n## Syntax\n\n```js-nolint\nlastIndexOf(searchString)\nlastIndexOf(searchString, position)\n```\n\n### Parameters\n\n- `searchString`\n\n  - : Substring to search for. All values are [coerced to strings](/en-US/docs/Web/JavaScript/Reference/Global_Objects/String#string_coercion), so omitting it or passing `undefined` causes `lastIndexOf()` to search for the string `"undefined"`, which is rarely what you want.\n\n- `position` {{optional_inline}}\n\n  - : The method returns the index of the last occurrence of the specified substring at a position less than or equal to `position`, which defaults to `+Infinity`. If `position` is greater than the length of the calling string, the method searches the entire string. If `position` is less than `0`, the behavior is the same as for `0` \u2014 that is, the method looks for the specified substring only at index `0`.\n\n    - `\'hello world hello\'.lastIndexOf(\'world\', 4)` returns `-1` \u2014 because, while the substring `world` does occurs at index `6`, that position is not less than or equal to `4`.\n\n    - `\'hello world hello\'.lastIndexOf(\'hello\', 99)` returns `12` \u2014 because the last occurrence of `hello` at a position less than or equal to `99` is at position `12`.\n\n    - `\'hello world hello\'.lastIndexOf(\'hello\', 0)` and `\'hello world hello\'.lastIndexOf(\'hello\', -5)` both return `0` \u2014 because both cause the method to only look for `hello` at index `0`.\n\n### Return value\n\nThe index of the last occurrence of `searchString` found, or `-1` if not found.\n\n## Description\n\nStrings are zero-indexed: The index of a string\'s first character is `0`, and the index of a string\'s last character is the length of the string minus 1.\n\n```js\n"canal".lastIndexOf("a"); // returns 3\n"canal".lastIndexOf("a", 2); // returns 1\n"canal".lastIndexOf("a", 0); // returns -1\n"canal".lastIndexOf("x"); // returns -1\n"canal".lastIndexOf("c", -5); // returns 0\n"canal".lastIndexOf("c", 0); // returns 0\n"canal".lastIndexOf(""); // returns 5\n"canal".lastIndexOf("", 2); // returns 2\n```\n\n### Case-sensitivity\n\nThe `lastIndexOf()` method is case sensitive. For example, the following\nexpression returns `-1`:\n\n```js\n"Blue Whale, Killer Whale".lastIndexOf("blue"); // returns -1\n```\n\n## Examples\n\n### Using indexOf() and lastIndexOf()\n\nThe following example uses {{jsxref("String/indexOf", "indexOf()")}} and\n`lastIndexOf()` to locate values in the string\n`"Brave, Brave New World"`.\n\n```js\nconst anyString = "Brave, Brave New World";\n\nconsole.log(anyString.indexOf("Brave")); // 0\nconsole.log(anyString.lastIndexOf("Brave")); // 7\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("String.prototype.charAt()")}}\n- {{jsxref("String.prototype.indexOf()")}}\n- {{jsxref("String.prototype.split()")}}\n- {{jsxref("Array.prototype.indexOf()")}}\n- {{jsxref("Array.prototype.lastIndexOf()")}}\n'
        },
        "length": {
            "index.md": '---\ntitle: "String: length"\nslug: Web/JavaScript/Reference/Global_Objects/String/length\npage-type: javascript-instance-data-property\nbrowser-compat: javascript.builtins.String.length\n---\n\n{{JSRef}}\n\nThe **`length`** data property of a {{jsxref("String")}} value contains the length of the string in UTF-16 code units.\n\n{{EmbedInteractiveExample("pages/js/string-length.html", "shorter")}}\n\n## Value\n\nA non-negative integer.\n\n{{js_property_attributes(0, 0, 0)}}\n\n## Description\n\nThis property returns the number of code units in the string. JavaScript uses [UTF-16](/en-US/docs/Web/JavaScript/Reference/Global_Objects/String#utf-16_characters_unicode_code_points_and_grapheme_clusters) encoding, where each Unicode character may be encoded as one or two code units, so it\'s possible for the value returned by `length` to not match the actual number of Unicode characters in the string. For common scripts like Latin, Cyrillic, wellknown CJK characters, etc., this should not be an issue, but if you are working with certain scripts, such as emojis, [mathematical symbols](https://en.wikipedia.org/wiki/Mathematical_Alphanumeric_Symbols), or obscure Chinese characters, you may need to account for the difference between code units and characters.\n\nThe language specification requires strings to have a maximum length of 2<sup>53</sup> - 1 elements, which is the upper limit for [precise integers](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/MAX_SAFE_INTEGER). However, a string with this length needs 16384TiB of storage, which cannot fit in any reasonable device\'s memory, so implementations tend to lower the threshold, which allows the string\'s length to be conveniently stored in a 32-bit integer.\n\n- In V8 (used by Chrome and Node), the maximum length is 2<sup>29</sup> - 24 (\\~1GiB). On 32-bit systems, the maximum length is 2<sup>28</sup> - 16 (\\~512MiB).\n- In Firefox, the maximum length is 2<sup>30</sup> - 2 (\\~2GiB). Before Firefox 65, the maximum length was 2<sup>28</sup> - 1 (\\~512MiB).\n- In Safari, the maximum length is 2<sup>31</sup> - 1 (\\~4GiB).\n\nFor an empty string, `length` is 0.\n\nThe static property `String.length` is unrelated to the length of strings. It\'s the [arity](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/length) of the `String` function (loosely, the number of formal parameters it has), which is 1.\n\nSince `length` counts code units instead of characters, if you want to get the number of characters, you can first split the string with its [iterator](/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/@@iterator), which iterates by characters:\n\n```js\nfunction getCharacterLength(str) {\n  // The string iterator that is used here iterates over characters,\n  // not mere code units\n  return [...str].length;\n}\n\nconsole.log(getCharacterLength("A\uD87E\uDC04Z")); // 3\n```\n\n## Examples\n\n### Basic usage\n\n```js\nconst x = "Mozilla";\nconst empty = "";\n\nconsole.log(`${x} is ${x.length} code units long`);\n// Mozilla is 7 code units long\n\nconsole.log(`The empty string has a length of ${empty.length}`);\n// The empty string has a length of 0\n```\n\n### Strings with length not equal to the number of characters\n\n```js\nconst emoji = "\uD83D\uDE04";\nconsole.log(emoji.length); // 2\nconsole.log([...emoji].length); // 1\nconst adlam = "\uD83A\uDD32\uD83A\uDD4B\uD83A\uDD23\uD83A\uDD2B";\nconsole.log(adlam.length); // 8\nconsole.log([...adlam].length); // 4\nconst formula = "\u2200\uD835\uDC65\u2208\u211D,\uD835\uDC65\xb2\u22650";\nconsole.log(formula.length); // 11\nconsole.log([...formula].length); // 9\n```\n\n### Assigning to length\n\nBecause string is a primitive, attempting to assign a value to a string\'s `length` property has no observable effect, and will throw in [strict mode](/en-US/docs/Web/JavaScript/Reference/Strict_mode).\n\n```js\nconst myString = "bluebells";\n\nmyString.length = 4;\nconsole.log(myString); // "bluebells"\nconsole.log(myString.length); // 9\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [`Array`: `length`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/length)\n'
        },
        "link": {
            "index.md": '---\ntitle: String.prototype.link()\nslug: Web/JavaScript/Reference/Global_Objects/String/link\npage-type: javascript-instance-method\nstatus:\n  - deprecated\nbrowser-compat: javascript.builtins.String.link\n---\n\n{{JSRef}} {{Deprecated_Header}}\n\nThe **`link()`** method of {{jsxref("String")}} values creates a string that embeds this string in an {{HTMLElement("a")}} element (`<a href="...">str</a>`), to be used as a hypertext link to another URL.\n\n> **Note:** All [HTML wrapper methods](/en-US/docs/Web/JavaScript/Reference/Global_Objects/String#html_wrapper_methods) are deprecated and only standardized for compatibility purposes. Use [DOM APIs](/en-US/docs/Web/API/Document_Object_Model) such as [`document.createElement()`](/en-US/docs/Web/API/Document/createElement) instead.\n\n## Syntax\n\n```js-nolint\nlink(url)\n```\n\n### Parameters\n\n- `url`\n  - : Any string that specifies the `href` attribute of the `<a>` element; it should be a valid URL (relative or absolute), with any `&` characters escaped as `&amp;`.\n\n### Return value\n\nA string beginning with an `<a href="url">` start tag (double quotes in `url` are replaced with `&quot;`), then the text `str`, and then an `</a>` end tag.\n\n## Examples\n\n### Using link()\n\nThe code below creates an HTML string and then replaces the document\'s body with it:\n\n```js\nconst contentString = "MDN Web Docs";\n\ndocument.body.innerHTML = contentString.link("https://developer.mozilla.org/");\n```\n\nThis will create the following HTML:\n\n```html\n<a href="https://developer.mozilla.org/">MDN Web Docs</a>\n```\n\nInstead of using `link()` and creating HTML text directly, you should use DOM APIs such as [`document.createElement()`](/en-US/docs/Web/API/Document/createElement). For example:\n\n```js\nconst contentString = "MDN Web Docs";\nconst elem = document.createElement("a");\nelem.href = "https://developer.mozilla.org/";\nelem.innerText = contentString;\ndocument.body.appendChild(elem);\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `String.prototype.link` in `core-js`](https://github.com/zloirock/core-js#ecmascript-string-and-regexp)\n- [HTML wrapper methods](/en-US/docs/Web/JavaScript/Reference/Global_Objects/String#html_wrapper_methods)\n- {{HTMLElement("a")}}\n'
        },
        "localecompare": {
            "index.md": '---\ntitle: String.prototype.localeCompare()\nslug: Web/JavaScript/Reference/Global_Objects/String/localeCompare\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.String.localeCompare\n---\n\n{{JSRef}}\n\nThe **`localeCompare()`** method of {{jsxref("String")}} values returns a number indicating whether this string comes before, or after, or is the same as the given string in sort order. In implementations with [`Intl.Collator` API](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Collator) support, this method simply calls `Intl.Collator`.\n\nWhen comparing large numbers of strings, such as in sorting large arrays, it is better to create an {{jsxref("Intl.Collator")}} object and use the function provided by its {{jsxref("Intl/Collator/compare", "compare()")}} method.\n\n{{EmbedInteractiveExample("pages/js/string-localecompare.html")}}\n\n## Syntax\n\n```js-nolint\nlocaleCompare(compareString)\nlocaleCompare(compareString, locales)\nlocaleCompare(compareString, locales, options)\n```\n\n### Parameters\n\nThe `locales` and `options` parameters customize the behavior of the function and let applications specify the language whose formatting conventions should be used.\n\nIn implementations that support the [`Intl.Collator` API](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Collator), these parameters correspond exactly to the [`Intl.Collator()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Collator/Collator) constructor\'s parameters. Implementations without `Intl.Collator` support are asked to ignore both parameters, making the comparison result returned entirely implementation-dependent \u2014 it\'s only required to be _consistent_.\n\n- `compareString`\n  - : The string against which the `referenceStr` is compared. All values are [coerced to strings](/en-US/docs/Web/JavaScript/Reference/Global_Objects/String#string_coercion), so omitting it or passing `undefined` causes `localeCompare()` to compare against the string `"undefined"`, which is rarely what you want.\n- `locales` {{optional_inline}}\n\n  - : A string with a BCP 47 language tag, or an array of such strings. Corresponds to the [`locales`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Collator/Collator#locales) parameter of the `Intl.Collator()` constructor.\n\n    In implementations without `Intl.Collator` support, this parameter is ignored and the host\'s locale is usually used.\n\n- `options` {{optional_inline}}\n\n  - : An object adjusting the output format. Corresponds to the [`options`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Collator/Collator#options) parameter of the `Intl.Collator()` constructor.\n\n    In implementations without `Intl.Collator` support, this parameter is ignored.\n\nSee the [`Intl.Collator()` constructor](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Collator/Collator) for details on the `locales` and `options` parameters and how to use them.\n\n### Return value\n\nA **negative** number if `referenceStr` occurs before `compareString`; **positive** if the `referenceStr` occurs after `compareString`; `0` if they are equivalent.\n\nIn implementations with `Intl.Collator`, this is equivalent to `new Intl.Collator(locales, options).compare(referenceStr, compareString)`.\n\n## Description\n\nReturns an integer indicating whether the `referenceStr` comes\nbefore, after or is equivalent to the `compareString`.\n\n- Negative when the `referenceStr` occurs before\n  `compareString`\n- Positive when the `referenceStr` occurs after\n  `compareString`\n- Returns `0` if they are equivalent\n\n> **Warning:** Do not rely on exact return values of `-1` or `1`!\n>\n> Negative and positive integer results vary between browsers (as well as between\n> browser versions) because the ECMAScript specification only mandates negative and positive\n> values. Some browsers may return `-2` or `2`, or even some other\n> negative or positive value.\n\n## Examples\n\n### Using localeCompare()\n\n```js\n// The letter "a" is before "c" yielding a negative value\n"a".localeCompare("c"); // -2 or -1 (or some other negative value)\n\n// Alphabetically the word "check" comes after "against" yielding a positive value\n"check".localeCompare("against"); // 2 or 1 (or some other positive value)\n\n// "a" and "a" are equivalent yielding a neutral value of zero\n"a".localeCompare("a"); // 0\n```\n\n### Sort an array\n\n`localeCompare()` enables case-insensitive sorting for an array.\n\n```js\nconst items = ["r\xe9serv\xe9", "Premier", "Clich\xe9", "communiqu\xe9", "caf\xe9", "Adieu"];\nitems.sort((a, b) => a.localeCompare(b, "fr", { ignorePunctuation: true }));\n// [\'Adieu\', \'caf\xe9\', \'Clich\xe9\', \'communiqu\xe9\', \'Premier\', \'r\xe9serv\xe9\']\n```\n\n### Check browser support for extended arguments\n\nThe `locales` and `options` arguments are\nnot supported in all browsers yet.\n\nTo check whether an implementation supports them, use the `"i"` argument (a\nrequirement that illegal language tags are rejected) and look for a\n{{jsxref("RangeError")}} exception:\n\n```js\nfunction localeCompareSupportsLocales() {\n  try {\n    "foo".localeCompare("bar", "i");\n  } catch (e) {\n    return e.name === "RangeError";\n  }\n  return false;\n}\n```\n\n### Using locales\n\nThe results provided by `localeCompare()` vary between languages. In order\nto get the sort order of the language used in the user interface of your application,\nmake sure to specify that language (and possibly some fallback languages) using the\n`locales` argument:\n\n```js\nconsole.log("\xe4".localeCompare("z", "de")); // a negative value: in German, \xe4 sorts before z\nconsole.log("\xe4".localeCompare("z", "sv")); // a positive value: in Swedish, \xe4 sorts after z\n```\n\n### Using options\n\nThe results provided by `localeCompare()` can be customized using the\n`options` argument:\n\n```js\n// in German, \xe4 has a as the base letter\nconsole.log("\xe4".localeCompare("a", "de", { sensitivity: "base" })); // 0\n\n// in Swedish, \xe4 and a are separate base letters\nconsole.log("\xe4".localeCompare("a", "sv", { sensitivity: "base" })); // a positive value\n```\n\n### Numeric sorting\n\n```js\n// by default, "2" > "10"\nconsole.log("2".localeCompare("10")); // 1\n\n// numeric using options:\nconsole.log("2".localeCompare("10", undefined, { numeric: true })); // -1\n\n// numeric using locales tag:\nconsole.log("2".localeCompare("10", "en-u-kn-true")); // -1\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [`Intl.Collator`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Collator)\n'
        },
        "match": {
            "index.md": '---\ntitle: String.prototype.match()\nslug: Web/JavaScript/Reference/Global_Objects/String/match\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.String.match\n---\n\n{{JSRef}}\n\nThe **`match()`** method of {{jsxref("String")}} values retrieves the result of matching this string against a [regular expression](/en-US/docs/Web/JavaScript/Guide/Regular_expressions).\n\n{{EmbedInteractiveExample("pages/js/string-match.html", "shorter")}}\n\n## Syntax\n\n```js-nolint\nmatch(regexp)\n```\n\n### Parameters\n\n- `regexp`\n\n  - : A regular expression object, or any object that has a [`Symbol.match`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol/match) method.\n\n    If `regexp` is not a `RegExp` object and does not have a `Symbol.match` method, it is implicitly converted to a {{jsxref("RegExp")}} by using `new RegExp(regexp)`.\n\n    If you don\'t give any parameter and use the `match()` method directly, you will get an {{jsxref("Array")}} with an empty string: `[""]`, because this is equivalent to `match(/(?:)/)`.\n\n### Return value\n\nAn {{jsxref("Array")}} whose contents depend on the presence or absence of the global (`g`) flag, or [`null`](/en-US/docs/Web/JavaScript/Reference/Operators/null) if no matches are found.\n\n- If the `g` flag is used, all results matching the complete regular expression will be returned, but capturing groups are not included.\n- If the `g` flag is not used, only the first complete match and its related capturing groups are returned. In this case, `match()` will return the same result as {{jsxref("RegExp.prototype.exec()")}} (an array with some extra properties).\n\n## Description\n\nThe implementation of `String.prototype.match` itself is very simple \u2014 it simply calls the `Symbol.match` method of the argument with the string as the first parameter. The actual implementation comes from [`RegExp.prototype[@@match]()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/@@match).\n\n- If you need to know if a string matches a regular expression {{jsxref("RegExp")}}, use {{jsxref("RegExp.prototype.test()")}}.\n- If you only want the first match found, you might want to use {{jsxref("RegExp.prototype.exec()")}} instead.\n- If you want to obtain capture groups and the global flag is set, you need to use {{jsxref("RegExp.prototype.exec()")}} or {{jsxref("String.prototype.matchAll()")}} instead.\n\nFor more information about the semantics of `match()` when a regex is passed, see [`RegExp.prototype[@@match]()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/@@match).\n\n## Examples\n\n### Using match()\n\nIn the following example, `match()` is used to find `"Chapter"` followed by one or more numeric characters followed by a decimal point and numeric character zero or more times.\n\nThe regular expression includes the `i` flag so that upper/lower case differences will be ignored.\n\n```js\nconst str = "For more information, see Chapter 3.4.5.1";\nconst re = /see (chapter \\d+(\\.\\d)*)/i;\nconst found = str.match(re);\n\nconsole.log(found);\n// [\n//   \'see Chapter 3.4.5.1\',\n//   \'Chapter 3.4.5.1\',\n//   \'.1\',\n//   index: 22,\n//   input: \'For more information, see Chapter 3.4.5.1\',\n//   groups: undefined\n// ]\n```\n\nIn the match result above, `\'see Chapter 3.4.5.1\'` is the whole match. `\'Chapter 3.4.5.1\'` was captured by `(chapter \\d+(\\.\\d)*)`. `\'.1\'` was the last value captured by `(\\.\\d)`. The `index` property (`22`) is the zero-based index of the whole match. The `input` property is the original string that was parsed.\n\n### Using global and ignoreCase flags with match()\n\nThe following example demonstrates the use of the global flag and ignore-case flag with `match()`. All letters `A` through `E` and `a` through `e` are returned, each its own element in the array.\n\n```js\nconst str = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";\nconst regexp = /[A-E]/gi;\nconst matches = str.match(regexp);\n\nconsole.log(matches);\n// [\'A\', \'B\', \'C\', \'D\', \'E\', \'a\', \'b\', \'c\', \'d\', \'e\']\n```\n\n> **Note:** See also {{jsxref("String.prototype.matchAll()")}} and [Advanced searching with flags](/en-US/docs/Web/JavaScript/Guide/Regular_expressions#advanced_searching_with_flags).\n\n### Using named capturing groups\n\nIn browsers which support named capturing groups, the following code captures `"fox"` or `"cat"` into a group named `animal`:\n\n```js\nconst paragraph = "The quick brown fox jumps over the lazy dog. It barked.";\n\nconst capturingRegex = /(?<animal>fox|cat) jumps over/;\nconst found = paragraph.match(capturingRegex);\nconsole.log(found.groups); // {animal: "fox"}\n```\n\n### Using match() with no parameter\n\n```js\nconst str = "Nothing will come of nothing.";\n\nstr.match(); // returns [""]\n```\n\n### Using match() with a non-RegExp implementing @@match\n\nIf an object has a `Symbol.match` method, it can be used as a custom matcher. The return value of `Symbol.match` becomes the return value of `match()`.\n\n```js\nconst str = "Hmm, this is interesting.";\n\nstr.match({\n  [Symbol.match](str) {\n    return ["Yes, it\'s interesting."];\n  },\n}); // returns ["Yes, it\'s interesting."]\n```\n\n### A non-RegExp as the parameter\n\nWhen the `regexp` parameter is a string or a number, it is implicitly converted to a {{jsxref("RegExp")}} by using `new RegExp(regexp)`.\n\n```js\nconst str1 =\n  "NaN means not a number. Infinity contains -Infinity and +Infinity in JavaScript.";\nconst str2 =\n  "My grandfather is 65 years old and My grandmother is 63 years old.";\nconst str3 = "The contract was declared null and void.";\nstr1.match("number"); // "number" is a string. returns ["number"]\nstr1.match(NaN); // the type of NaN is the number. returns ["NaN"]\nstr1.match(Infinity); // the type of Infinity is the number. returns ["Infinity"]\nstr1.match(+Infinity); // returns ["Infinity"]\nstr1.match(-Infinity); // returns ["-Infinity"]\nstr2.match(65); // returns ["65"]\nstr2.match(+65); // A number with a positive sign. returns ["65"]\nstr3.match(null); // returns ["null"]\n```\n\nThis may have unexpected results if special characters are not properly escaped.\n\n```js\nconsole.log("123".match("1.3")); // [ "123" ]\n```\n\nThis is a match because `.` in a regex matches any character. In order to make it only match specifically a dot character, you need to escape the input.\n\n```js\nconsole.log("123".match("1\\\\.3")); // null\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `String.prototype.match` in `core-js` with fixes and implementation of modern behavior like `Symbol.match` support](https://github.com/zloirock/core-js#ecmascript-string-and-regexp)\n- {{jsxref("String.prototype.matchAll()")}}\n- {{jsxref("RegExp")}}\n- {{jsxref("RegExp.prototype.exec()")}}\n- {{jsxref("RegExp.prototype.test()")}}\n'
        },
        "matchall": {
            "index.md": '---\ntitle: String.prototype.matchAll()\nslug: Web/JavaScript/Reference/Global_Objects/String/matchAll\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.String.matchAll\n---\n\n{{JSRef}}\n\nThe **`matchAll()`** method of {{jsxref("String")}} values returns an iterator of all results matching this string against a [regular expression](/en-US/docs/Web/JavaScript/Guide/Regular_expressions), including [capturing groups](/en-US/docs/Web/JavaScript/Guide/Regular_expressions/Groups_and_backreferences).\n\n{{EmbedInteractiveExample("pages/js/string-matchall.html")}}\n\n## Syntax\n\n```js-nolint\nmatchAll(regexp)\n```\n\n### Parameters\n\n- `regexp`\n\n  - : A regular expression object, or any object that has a [`Symbol.matchAll`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol/matchAll) method.\n\n    If `regexp` is not a `RegExp` object and does not have a `Symbol.matchAll` method, it is implicitly converted to a {{jsxref("RegExp")}} by using `new RegExp(regexp, \'g\')`.\n\n    If `regexp` [is a regex](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp#special_handling_for_regexes), then it must have the global (`g`) flag set, or a {{jsxref("TypeError")}} is thrown.\n\n### Return value\n\nAn [iterable iterator object](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Iterator) (which is not restartable) of matches or an empty iterator if no matches are found. Each value yielded by the iterator is an array with the same shape as the return value of {{jsxref("RegExp.prototype.exec()")}}.\n\n### Exceptions\n\n- {{jsxref("TypeError")}}\n  - : Thrown if the `regexp` [is a regex](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp#special_handling_for_regexes) that does not have the global (`g`) flag set (its [`flags`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/flags) property does not contain `"g"`).\n\n## Description\n\nThe implementation of `String.prototype.matchAll` itself is very simple \u2014 it simply calls the `Symbol.matchAll` method of the argument with the string as the first parameter (apart from the extra input validation that the regex is global). The actual implementation comes from [`RegExp.prototype[@@matchAll]()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/@@matchAll).\n\n## Examples\n\n### Regexp.prototype.exec() and matchAll()\n\nWithout `matchAll()`, it\'s possible to use calls to [`regexp.exec()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/exec) (and regexes with the `g` flag) in a loop to obtain all the matches:\n\n```js\nconst regexp = /foo[a-z]*/g;\nconst str = "table football, foosball";\nlet match;\n\nwhile ((match = regexp.exec(str)) !== null) {\n  console.log(\n    `Found ${match[0]} start=${match.index} end=${regexp.lastIndex}.`,\n  );\n}\n// Found football start=6 end=14.\n// Found foosball start=16 end=24.\n```\n\nWith `matchAll()` available, you can avoid the {{jsxref("Statements/while", "while")}} loop and `exec` with `g`. Instead, you get an iterator to use with the more convenient {{jsxref("Statements/for...of", "for...of")}}, [array spreading](/en-US/docs/Web/JavaScript/Reference/Operators/Spread_syntax), or {{jsxref("Array.from()")}} constructs:\n\n```js\nconst regexp = /foo[a-z]*/g;\nconst str = "table football, foosball";\nconst matches = str.matchAll(regexp);\n\nfor (const match of matches) {\n  console.log(\n    `Found ${match[0]} start=${match.index} end=${\n      match.index + match[0].length\n    }.`,\n  );\n}\n// Found football start=6 end=14.\n// Found foosball start=16 end=24.\n\n// matches iterator is exhausted after the for...of iteration\n// Call matchAll again to create a new iterator\nArray.from(str.matchAll(regexp), (m) => m[0]);\n// [ "football", "foosball" ]\n```\n\n`matchAll` will throw an exception if the `g` flag is missing.\n\n```js\nconst regexp = /[a-c]/;\nconst str = "abc";\nstr.matchAll(regexp);\n// TypeError\n```\n\n`matchAll` internally makes a clone of the `regexp` \u2014 so, unlike {{jsxref("RegExp/exec", "regexp.exec()")}}, `lastIndex` does not change as the string is scanned.\n\n```js\nconst regexp = /[a-c]/g;\nregexp.lastIndex = 1;\nconst str = "abc";\nArray.from(str.matchAll(regexp), (m) => `${regexp.lastIndex} ${m[0]}`);\n// [ "1 b", "1 c" ]\n```\n\nHowever, this means that unlike using [`regexp.exec()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/exec) in a loop, you can\'t mutate `lastIndex` to make the regex advance or rewind.\n\n### Better access to capturing groups (than String.prototype.match())\n\nAnother compelling reason for `matchAll` is the improved access to capture groups.\n\nCapture groups are ignored when using {{jsxref("String/match", "match()")}} with the global `g` flag:\n\n```js\nconst regexp = /t(e)(st(\\d?))/g;\nconst str = "test1test2";\n\nstr.match(regexp); // [\'test1\', \'test2\']\n```\n\nUsing `matchAll`, you can access capture groups easily:\n\n```js\nconst array = [...str.matchAll(regexp)];\n\narray[0];\n// [\'test1\', \'e\', \'st1\', \'1\', index: 0, input: \'test1test2\', length: 4]\narray[1];\n// [\'test2\', \'e\', \'st2\', \'2\', index: 5, input: \'test1test2\', length: 4]\n```\n\n### Using matchAll() with a non-RegExp implementing @@matchAll\n\nIf an object has a `Symbol.matchAll` method, it can be used as a custom matcher. The return value of `Symbol.matchAll` becomes the return value of `matchAll()`.\n\n```js\nconst str = "Hmm, this is interesting.";\n\nstr.matchAll({\n  [Symbol.matchAll](str) {\n    return [["Yes, it\'s interesting."]];\n  },\n}); // returns [["Yes, it\'s interesting."]]\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `String.prototype.matchAll` in `core-js`](https://github.com/zloirock/core-js#ecmascript-string-and-regexp)\n- {{jsxref("String.prototype.match()")}}\n- [Regular expressions](/en-US/docs/Web/JavaScript/Guide/Regular_expressions) guide\n- [Groups and backreferences](/en-US/docs/Web/JavaScript/Guide/Regular_expressions/Groups_and_backreferences) guide\n- {{jsxref("RegExp")}}\n- {{jsxref("RegExp.prototype.exec()")}}\n- {{jsxref("RegExp.prototype.test()")}}\n- [`RegExp.prototype[@@matchAll]()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/@@matchAll)\n'
        },
        "normalize": {
            "index.md": '---\ntitle: String.prototype.normalize()\nslug: Web/JavaScript/Reference/Global_Objects/String/normalize\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.String.normalize\n---\n\n{{JSRef}}\n\nThe **`normalize()`** method of {{jsxref("String")}} values returns the Unicode Normalization\nForm of this string.\n\n{{EmbedInteractiveExample("pages/js/string-normalize.html", "taller")}}\n\n## Syntax\n\n```js-nolint\nnormalize()\nnormalize(form)\n```\n\n### Parameters\n\n- `form` {{optional_inline}}\n\n  - : One of `"NFC"`, `"NFD"`, `"NFKC"`, or\n    `"NFKD"`, specifying the Unicode Normalization Form. If omitted or\n    {{jsxref("undefined")}}, `"NFC"` is used.\n\n    These values have the following meanings:\n\n    - `"NFC"`\n      - : Canonical Decomposition, followed by Canonical Composition.\n    - `"NFD"`\n      - : Canonical Decomposition.\n    - `"NFKC"`\n      - : Compatibility Decomposition, followed by Canonical Composition.\n    - `"NFKD"`\n      - : Compatibility Decomposition.\n\n### Return value\n\nA string containing the Unicode Normalization Form of the given string.\n\n### Exceptions\n\n- {{jsxref("RangeError")}}\n  - : Thrown if `form` isn\'t one of the values\n    specified above.\n\n## Description\n\nUnicode assigns a unique numerical value, called a _code point_, to each\ncharacter. For example, the code point for `"A"` is given as U+0041. However,\nsometimes more than one code point, or sequence of code points, can represent the same\nabstract character \u2014 the character `"\xf1"` for example can be represented by\neither of:\n\n- The single code point U+00F1.\n- The code point for `"n"` (U+006E) followed by the code point for the\n  combining tilde (U+0303).\n\n```js\nconst string1 = "\\u00F1";\nconst string2 = "\\u006E\\u0303";\n\nconsole.log(string1); // \xf1\nconsole.log(string2); // \xf1\n```\n\nHowever, since the code points are different, string comparison will not treat them as\nequal. And since the number of code points in each version is different, they even have\ndifferent lengths.\n\n```js\nconst string1 = "\\u00F1"; // \xf1\nconst string2 = "\\u006E\\u0303"; // \xf1\n\nconsole.log(string1 === string2); // false\nconsole.log(string1.length); // 1\nconsole.log(string2.length); // 2\n```\n\nThe `normalize()` method helps solve this problem by converting a string\ninto a normalized form common for all sequences of code points that represent the same\ncharacters. There are two main normalization forms, one based on **canonical\nequivalence** and the other based on **compatibility**.\n\n### Canonical equivalence normalization\n\nIn Unicode, two sequences of code points have canonical equivalence if they represent\nthe same abstract characters, and should always have the same visual appearance and\nbehavior (for example, they should always be sorted in the same way).\n\nYou can use `normalize()` using the `"NFD"` or `"NFC"`\narguments to produce a form of the string that will be the same for all canonically\nequivalent strings. In the example below we normalize two representations of the\ncharacter `"\xf1"`:\n\n```js\nlet string1 = "\\u00F1"; // \xf1\nlet string2 = "\\u006E\\u0303"; // \xf1\n\nstring1 = string1.normalize("NFD");\nstring2 = string2.normalize("NFD");\n\nconsole.log(string1 === string2); // true\nconsole.log(string1.length); // 2\nconsole.log(string2.length); // 2\n```\n\n#### Composed and decomposed forms\n\nNote that the length of the normalized form under `"NFD"` is\n`2`. That\'s because `"NFD"` gives you the\n**decomposed** version of the canonical form, in which single code points\nare split into multiple combining ones. The decomposed canonical form for\n`"\xf1"` is `"\\u006E\\u0303"`.\n\nYou can specify `"NFC"` to get the **composed** canonical form,\nin which multiple code points are replaced with single code points where possible. The\ncomposed canonical form for `"\xf1"` is `"\\u00F1"`:\n\n```js\nlet string1 = "\\u00F1"; // \xf1\nlet string2 = "\\u006E\\u0303"; // \xf1\n\nstring1 = string1.normalize("NFC");\nstring2 = string2.normalize("NFC");\n\nconsole.log(string1 === string2); // true\nconsole.log(string1.length); // 1\nconsole.log(string2.length); // 1\nconsole.log(string2.codePointAt(0).toString(16)); // f1\n```\n\n### Compatibility normalization\n\nIn Unicode, two sequences of code points are compatible if they represent the same\nabstract characters, and should be treated alike in some \u2014 but not necessarily all \u2014\napplications.\n\nAll canonically equivalent sequences are also compatible, but not vice versa.\n\nFor example:\n\n- the code point U+FB00 represents the [ligature](/en-US/docs/Glossary/Ligature) `"\uFB00"`. It is compatible\n  with two consecutive U+0066 code points (`"ff"`).\n- the code point U+24B9 represents the symbol\n  `"\u24B9"`.\n  It is compatible with the U+0044 code point (`"D"`).\n\nIn some respects (such as sorting) they should be treated as equivalent\u2014and in some\n(such as visual appearance) they should not, so they are not canonically equivalent.\n\nYou can use `normalize()` using the `"NFKD"` or\n`"NFKC"` arguments to produce a form of the string that will be the same for\nall compatible strings:\n\n```js\nlet string1 = "\\uFB00";\nlet string2 = "\\u0066\\u0066";\n\nconsole.log(string1); // \uFB00\nconsole.log(string2); // ff\nconsole.log(string1 === string2); // false\nconsole.log(string1.length); // 1\nconsole.log(string2.length); // 2\n\nstring1 = string1.normalize("NFKD");\nstring2 = string2.normalize("NFKD");\n\nconsole.log(string1); // ff <- visual appearance changed\nconsole.log(string2); // ff\nconsole.log(string1 === string2); // true\nconsole.log(string1.length); // 2\nconsole.log(string2.length); // 2\n```\n\nWhen applying compatibility normalization it\'s important to consider what you intend to\ndo with the strings, since the normalized form may not be appropriate for all\napplications. In the example above the normalization is appropriate for search, because\nit enables a user to find the string by searching for `"f"`. But it may not\nbe appropriate for display, because the visual representation is different.\n\nAs with canonical normalization, you can ask for decomposed or composed compatible\nforms by passing `"NFKD"` or `"NFKC"`, respectively.\n\n## Examples\n\n### Using normalize()\n\n```js\n// Initial string\n\n// U+1E9B: LATIN SMALL LETTER LONG S WITH DOT ABOVE\n// U+0323: COMBINING DOT BELOW\nconst str = "\\u1E9B\\u0323";\n\n// Canonically-composed form (NFC)\n\n// U+1E9B: LATIN SMALL LETTER LONG S WITH DOT ABOVE\n// U+0323: COMBINING DOT BELOW\nstr.normalize("NFC"); // \'\\u1E9B\\u0323\'\nstr.normalize(); // same as above\n\n// Canonically-decomposed form (NFD)\n\n// U+017F: LATIN SMALL LETTER LONG S\n// U+0323: COMBINING DOT BELOW\n// U+0307: COMBINING DOT ABOVE\nstr.normalize("NFD"); // \'\\u017F\\u0323\\u0307\'\n\n// Compatibly-composed (NFKC)\n\n// U+1E69: LATIN SMALL LETTER S WITH DOT BELOW AND DOT ABOVE\nstr.normalize("NFKC"); // \'\\u1E69\'\n\n// Compatibly-decomposed (NFKD)\n\n// U+0073: LATIN SMALL LETTER S\n// U+0323: COMBINING DOT BELOW\n// U+0307: COMBINING DOT ABOVE\nstr.normalize("NFKD"); // \'\\u0073\\u0323\\u0307\'\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Unicode Standard Annex #15, Unicode Normalization Forms](https://www.unicode.org/reports/tr15/)\n- [Unicode equivalence](https://en.wikipedia.org/wiki/Unicode_equivalence) on Wikipedia\n'
        },
        "padend": {
            "index.md": '---\ntitle: String.prototype.padEnd()\nslug: Web/JavaScript/Reference/Global_Objects/String/padEnd\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.String.padEnd\n---\n\n{{JSRef}}\n\nThe **`padEnd()`** method of {{jsxref("String")}} values pads this string with a given\nstring (repeated, if needed) so that the resulting string reaches a given length. The\npadding is applied from the end of this string.\n\n{{EmbedInteractiveExample("pages/js/string-padend.html")}}\n\n## Syntax\n\n```js-nolint\npadEnd(targetLength)\npadEnd(targetLength, padString)\n```\n\n### Parameters\n\n- `targetLength`\n  - : The length of the resulting string once the current `str` has\n    been padded. If the value is less than or equal to `str.length`, the\n    current string will be returned as-is.\n- `padString` {{optional_inline}}\n  - : The string to pad the current `str` with. If\n    `padString` is too long to stay within\n    `targetLength`, it will be truncated: for left-to-right\n    languages the left-most part and for right-to-left languages the right-most will be\n    applied. The default value for this parameter is " "\n    (`U+0020`).\n\n### Return value\n\nA {{jsxref("String")}} of the specified `targetLength` with the\n`padString` applied at the end of the current\n`str`.\n\n## Examples\n\n### Using padEnd\n\n```js\n"abc".padEnd(10); // "abc       "\n"abc".padEnd(10, "foo"); // "abcfoofoof"\n"abc".padEnd(6, "123456"); // "abc123"\n"abc".padEnd(1); // "abc"\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `String.prototype.padEnd` in `core-js`](https://github.com/zloirock/core-js#ecmascript-string-and-regexp)\n- {{jsxref("String.prototype.padStart()")}}\n'
        },
        "padstart": {
            "index.md": '---\ntitle: String.prototype.padStart()\nslug: Web/JavaScript/Reference/Global_Objects/String/padStart\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.String.padStart\n---\n\n{{JSRef}}\n\nThe **`padStart()`** method of {{jsxref("String")}} values pads this string with another string (multiple times, if needed) until the resulting\nstring reaches the given length. The padding is applied from the start of this string.\n\n{{EmbedInteractiveExample("pages/js/string-padstart.html")}}\n\n## Syntax\n\n```js-nolint\npadStart(targetLength)\npadStart(targetLength, padString)\n```\n\n### Parameters\n\n- `targetLength`\n  - : The length of the resulting string once the current `str` has\n    been padded. If the value is less than or equal to `str.length`, then\n    `str` is returned as-is.\n- `padString` {{optional_inline}}\n  - : The string to pad the current `str` with. If\n    `padString` is too long to stay within the\n    `targetLength`, it will be truncated from the end.\n    The default value is the unicode "space" character (U+0020).\n\n### Return value\n\nA {{jsxref("String")}} of the specified `targetLength` with\n`padString` applied from the start.\n\n## Examples\n\n### Basic examples\n\n```js\n"abc".padStart(10); // "       abc"\n"abc".padStart(10, "foo"); // "foofoofabc"\n"abc".padStart(6, "123465"); // "123abc"\n"abc".padStart(8, "0"); // "00000abc"\n"abc".padStart(1); // "abc"\n```\n\n### Fixed width string number conversion\n\n```js\n// JavaScript version of: (unsigned)\n// printf "%0*d" width num\nfunction leftFillNum(num, targetLength) {\n  return num.toString().padStart(targetLength, "0");\n}\n\nconst num = 123;\nconsole.log(leftFillNum(num, 5)); // "00123"\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `String.prototype.padStart` in `core-js`](https://github.com/zloirock/core-js#ecmascript-string-and-regexp)\n- {{jsxref("String.prototype.padEnd()")}}\n'
        },
        "raw": {
            "index.md": "---\ntitle: String.raw()\nslug: Web/JavaScript/Reference/Global_Objects/String/raw\npage-type: javascript-static-method\nbrowser-compat: javascript.builtins.String.raw\n---\n\n{{JSRef}}\n\nThe **`String.raw()`** static method is a tag function of [template literals](/en-US/docs/Web/JavaScript/Reference/Template_literals). This is similar to the `r` prefix in Python, or the `@` prefix in C# for string literals. It's used to get the raw string form of template literals \u2014 that is, substitutions (e.g. `${foo}`) are processed, but escape sequences (e.g. `\\n`) are not.\n\n{{EmbedInteractiveExample(\"pages/js/string-raw.html\")}}\n\n## Syntax\n\n```js-nolint\nString.raw(strings)\nString.raw(strings, sub1)\nString.raw(strings, sub1, sub2)\nString.raw(strings, sub1, sub2, /* \u2026, */ subN)\n\nString.raw`templateString`\n```\n\n### Parameters\n\n- `strings`\n  - : Well-formed template literal array object, like `{ raw: ['foo', 'bar', 'baz'] }`. Should be an object with a `raw` property whose value is an array-like object of strings.\n- `sub1`, \u2026, `subN`\n  - : Contains substitution values.\n- `templateString`\n  - : A [template literal](/en-US/docs/Web/JavaScript/Reference/Template_literals), optionally with substitutions (`${...}`).\n\n### Return value\n\nThe raw string form of a given template literal.\n\n### Exceptions\n\n- {{jsxref(\"TypeError\")}}\n  - : Thrown if the first argument doesn't have a `raw` property, or the `raw` property is `undefined` or `null`.\n\n## Description\n\nIn most cases, `String.raw()` is used with template literals. The first syntax mentioned above is only rarely used, because the JavaScript engine will call this with proper arguments for you, (just like with other [tag functions](/en-US/docs/Web/JavaScript/Reference/Template_literals#tagged_templates)).\n\n`String.raw()` is the only built-in template literal tag. It has close semantics to an untagged literal since it concatenates all arguments and returns a string. You can even re-implement it with normal JavaScript code.\n\n> **Warning:** You should not use `String.raw` directly as an \"identity\" tag. See [Building an identity tag](#building_an_identity_tag) for how to implement this.\n\nIf `String.raw()` is called with an object whose `raw` property doesn't have a `length` property or a non-positive `length`, it returns an empty string `\"\"`. If `substitutions.length < strings.raw.length - 1` (i.e. there are not enough substitutions to fill the placeholders \u2014 which can't happen in a well-formed tagged template literal), the rest of the placeholders are filled with empty strings.\n\n## Examples\n\n### Using String.raw()\n\n```js\nString.raw`Hi\\n${2 + 3}!`;\n// 'Hi\\\\n5!', the character after 'Hi'\n// is not a newline character,\n// '\\' and 'n' are two characters.\n\nString.raw`Hi\\u000A!`;\n// 'Hi\\\\u000A!', same here, this time we will get the\n// \\, u, 0, 0, 0, A, 6 characters.\n// All kinds of escape characters will be ineffective\n// and backslashes will be present in the output string.\n// You can confirm this by checking the .length property\n// of the string.\n\nconst name = \"Bob\";\nString.raw`Hi\\n${name}!`;\n// 'Hi\\\\nBob!', substitutions are processed.\n\nString.raw`Hi \\${name}!`;\n// 'Hi \\\\${name}!', the dollar sign is escaped; there's no interpolation.\n```\n\n### Building an identity tag\n\nMany tools give special treatment to literals tagged by a particular name.\n\n```js-nolint\n// Some formatters will format this literal's content as HTML\nconst doc = html`<!DOCTYPE html>\n<html lang=\"en-US\">\n  <head>\n    <title>Hello</title>\n  </head>\n  <body>\n    <h1>Hello world!</h1>\n  </body>\n</html>\n`;\n```\n\nOne might na\xefvely implement the `html` tag as:\n\n```js\nconst html = String.raw;\n```\n\nThis, in fact, works for the case above. However, because `String.raw` would concatenate the _raw_ string literals instead of the \"cooked\" ones, escape sequences would not be processed.\n\n```js-nolint\nconst doc = html`<canvas>\\n</canvas>`;\n// \"<canvas>\\\\n</canvas>\"\n```\n\nThis may not be what you want for a \"true identity\" tag, where the tag is purely for markup and doesn't change the literal's value. In this case, you can create a custom tag and pass the \"cooked\" (i.e. escape sequences are processed) literal array to `String.raw`, pretending they are raw strings.\n\n```js-nolint\nconst html = (strings, ...values) => String.raw({ raw: strings }, ...values);\n// Some formatters will format this literal's content as HTML\nconst doc = html`<canvas>\\n</canvas>`;\n// \"<canvas>\\n</canvas>\"; the \"\\n\" becomes a line break\n```\n\nNotice the first argument is an object with a `raw` property, whose value is an array-like object (with a `length` property and integer indexes) representing the separated strings in the template literal. The rest of the arguments are the substitutions. Since the `raw` value can be any array-like object, it can even be a string! For example, `'test'` is treated as `['t', 'e', 's', 't']`. The following is equivalent to `` `t${0}e${1}s${2}t` ``:\n\n```js\nString.raw({ raw: \"test\" }, 0, 1, 2); // 't0e1s2t'\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `String.raw` in `core-js`](https://github.com/zloirock/core-js#ecmascript-string-and-regexp)\n- [Template literals](/en-US/docs/Web/JavaScript/Reference/Template_literals)\n- {{jsxref(\"String\")}}\n- [Lexical grammar](/en-US/docs/Web/JavaScript/Reference/Lexical_grammar)\n"
        },
        "repeat": {
            "index.md": '---\ntitle: String.prototype.repeat()\nslug: Web/JavaScript/Reference/Global_Objects/String/repeat\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.String.repeat\n---\n\n{{JSRef}}\n\nThe **`repeat()`** method of {{jsxref("String")}} values constructs and returns a new string\nwhich contains the specified number of copies of this string, concatenated together.\n\n{{EmbedInteractiveExample("pages/js/string-repeat.html", "shorter")}}\n\n## Syntax\n\n```js-nolint\nrepeat(count)\n```\n\n### Parameters\n\n- `count`\n  - : An integer between `0` and\n    {{jsxref("Number/POSITIVE_INFINITY", "+Infinity")}}, indicating the\n    number of times to repeat the string.\n\n### Return value\n\nA new string containing the specified number of copies of the given string.\n\n### Exceptions\n\n- {{jsxref("RangeError")}}\n  - : Thrown if `count` is negative or if `count` overflows maximum string length.\n\n## Examples\n\n### Using repeat()\n\n```js\n"abc".repeat(-1); // RangeError\n"abc".repeat(0); // \'\'\n"abc".repeat(1); // \'abc\'\n"abc".repeat(2); // \'abcabc\'\n"abc".repeat(3.5); // \'abcabcabc\' (count will be converted to integer)\n"abc".repeat(1 / 0); // RangeError\n\n({ toString: () => "abc", repeat: String.prototype.repeat }).repeat(2);\n// \'abcabc\' (repeat() is a generic method)\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `String.prototype.repeat` in `core-js`](https://github.com/zloirock/core-js#ecmascript-string-and-regexp)\n- {{jsxref("String.prototype.concat()")}}\n'
        },
        "replace": {
            "index.md": '---\ntitle: String.prototype.replace()\nslug: Web/JavaScript/Reference/Global_Objects/String/replace\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.String.replace\n---\n\n{{JSRef}}\n\nThe **`replace()`** method of {{jsxref("String")}} values returns a new string with one, some, or all matches of a `pattern` replaced by a `replacement`. The `pattern` can be a string or a {{jsxref("RegExp")}}, and the `replacement` can be a string or a function called for each match. If `pattern` is a string, only the first occurrence will be replaced. The original string is left unchanged.\n\n{{EmbedInteractiveExample("pages/js/string-replace.html")}}\n\n## Syntax\n\n```js-nolint\nreplace(pattern, replacement)\n```\n\n### Parameters\n\n- `pattern`\n  - : Can be a string or an object with a [`Symbol.replace`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol/replace) method \u2014 the typical example being a [regular expression](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp). Any value that doesn\'t have the `Symbol.replace` method will be coerced to a string.\n- `replacement`\n  - : Can be a string or a function.\n    - If it\'s a string, it will replace the substring matched by `pattern`. A number of special replacement patterns are supported; see the [Specifying a string as the replacement](#specifying_a_string_as_the_replacement) section below.\n    - If it\'s a function, it will be invoked for every match and its return value is used as the replacement text. The arguments supplied to this function are described in the [Specifying a function as the replacement](#specifying_a_function_as_the_replacement) section below.\n\n### Return value\n\nA new string, with one, some, or all matches of the pattern replaced by the specified replacement.\n\n## Description\n\nThis method does not mutate the string value it\'s called on. It returns a new string.\n\nA string pattern will only be replaced once. To perform a global search and replace, use a regular expression with the `g` flag, or use [`replaceAll()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/replaceAll) instead.\n\nIf `pattern` is an object with a [`Symbol.replace`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol/replace) method (including `RegExp` objects), that method is called with the target string and `replacement` as arguments. Its return value becomes the return value of `replace()`. In this case the behavior of `replace()` is entirely encoded by the `@@replace` method \u2014 for example, any mention of "capturing groups" in the description below is actually functionality provided by [`RegExp.prototype[@@replace]`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/@@replace).\n\nIf the `pattern` is an empty string, the replacement is prepended to the start of the string.\n\n```js\n"xxx".replace("", "_"); // "_xxx"\n```\n\nA regexp with the `g` flag is the only case where `replace()` replaces more than once. For more information about how regex properties (especially the [sticky](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/sticky) flag) interact with `replace()`, see [`RegExp.prototype[@@replace]()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/@@replace).\n\n### Specifying a string as the replacement\n\nThe replacement string can include the following special replacement patterns:\n\n| Pattern   | Inserts                                                                                        |\n| --------- | ---------------------------------------------------------------------------------------------- |\n| `$$`      | Inserts a `"$"`.                                                                               |\n| `$&`      | Inserts the matched substring.                                                                 |\n| `` $` ``  | Inserts the portion of the string that precedes the matched substring.                         |\n| `$\'`      | Inserts the portion of the string that follows the matched substring.                          |\n| `$n`      | Inserts the `n`th (`1`-indexed) capturing group where `n` is a positive integer less than 100. |\n| `$<Name>` | Inserts the named capturing group where `Name` is the group name.                              |\n\n`$n` and `$<Name>` are only available if the `pattern` argument is a {{jsxref("RegExp")}} object. If the `pattern` is a string, or if the corresponding capturing group isn\'t present in the regex, then the pattern will be replaced as a literal. If the group is present but isn\'t matched (because it\'s part of a disjunction), it will be replaced with an empty string.\n\n```js\n"foo".replace(/(f)/, "$2");\n// "$2oo"; the regex doesn\'t have the second group\n\n"foo".replace("f", "$1");\n// "$1oo"; the pattern is a string, so it doesn\'t have any groups\n\n"foo".replace(/(f)|(g)/, "$2");\n// "oo"; the second group exists but isn\'t matched\n```\n\n### Specifying a function as the replacement\n\nYou can specify a function as the second parameter. In this case, the function will be invoked after the match has been performed. The function\'s result (return value) will be used as the replacement string.\n\n> **Note:** The above-mentioned special replacement patterns do _not_ apply for strings returned from the replacer function.\n\nThe function has the following signature:\n\n```js\nfunction replacer(match, p1, p2, /* \u2026, */ pN, offset, string, groups) {\n  return replacement;\n}\n```\n\nThe arguments to the function are as follows:\n\n- `match`\n  - : The matched substring. (Corresponds to `$&` above.)\n- `p1, p2, \u2026, pN`\n  - : The `n`th string found by a capture group (including named capturing groups), provided the first argument to `replace()` is a {{jsxref("RegExp")}} object. (Corresponds to `$1`, `$2`, etc. above.) For example, if the `pattern` is `/(\\a+)(\\b+)/`, then `p1` is the match for `\\a+`, and `p2` is the match for `\\b+`. If the group is part of a disjunction (e.g. `"abc".replace(/(a)|(b)/, replacer)`), the unmatched alternative will be `undefined`.\n- `offset`\n  - : The offset of the matched substring within the whole string being examined. For example, if the whole string was `\'abcd\'`, and the matched substring was `\'bc\'`, then this argument will be `1`.\n- `string`\n  - : The whole string being examined.\n- `groups`\n  - : An object whose keys are the used group names, and whose values are the matched portions (`undefined` if not matched). Only present if the `pattern` contains at least one named capturing group.\n\nThe exact number of arguments depends on whether the first argument is a {{jsxref("RegExp")}} object \u2014 and, if so, how many capture groups it has.\n\nThe following example will set `newString` to `\'abc - 12345 - #$*%\'`:\n\n```js\nfunction replacer(match, p1, p2, p3, offset, string) {\n  // p1 is non-digits, p2 digits, and p3 non-alphanumerics\n  return [p1, p2, p3].join(" - ");\n}\nconst newString = "abc12345#$*%".replace(/([^\\d]*)(\\d*)([^\\w]*)/, replacer);\nconsole.log(newString); // abc - 12345 - #$*%\n```\n\nThe function will be invoked multiple times for each full match to be replaced if the regular expression in the first parameter is global.\n\n## Examples\n\n### Defining the regular expression in replace()\n\nIn the following example, the regular expression is defined in `replace()` and includes the ignore case flag.\n\n```js\nconst str = "Twas the night before Xmas...";\nconst newstr = str.replace(/xmas/i, "Christmas");\nconsole.log(newstr); // Twas the night before Christmas...\n```\n\nThis logs `\'Twas the night before Christmas...\'`.\n\n> **Note:** See [the regular expression guide](/en-US/docs/Web/JavaScript/Guide/Regular_expressions) for more explanations about regular expressions.\n\n### Using the global and ignoreCase flags with replace()\n\nGlobal replace can only be done with a regular expression. In the following example, the regular expression includes the [global and ignore case flags](/en-US/docs/Web/JavaScript/Guide/Regular_expressions#advanced_searching_with_flags) which permits `replace()` to replace each occurrence of `\'apples\'` in the string with `\'oranges\'`.\n\n```js\nconst re = /apples/gi;\nconst str = "Apples are round, and apples are juicy.";\nconst newstr = str.replace(re, "oranges");\nconsole.log(newstr); // oranges are round, and oranges are juicy.\n```\n\nThis logs `\'oranges are round, and oranges are juicy\'`.\n\n### Switching words in a string\n\nThe following script switches the words in the string. For the replacement text, the script uses [capturing groups](/en-US/docs/Web/JavaScript/Guide/Regular_expressions/Groups_and_backreferences) and the `$1` and `$2` replacement patterns.\n\n```js\nconst re = /(\\w+)\\s(\\w+)/;\nconst str = "Maria Cruz";\nconst newstr = str.replace(re, "$2, $1");\nconsole.log(newstr); // Cruz, Maria\n```\n\nThis logs `\'Cruz, Maria\'`.\n\n### Using an inline function that modifies the matched characters\n\nIn this example, all occurrences of capital letters in the string are converted to lower case, and a hyphen is inserted just before the match location. The important thing here is that additional operations are needed on the matched item before it is given back as a replacement.\n\nThe replacement function accepts the matched snippet as its parameter, and uses it to transform the case and concatenate the hyphen before returning.\n\n```js\nfunction styleHyphenFormat(propertyName) {\n  function upperToHyphenLower(match, offset, string) {\n    return (offset > 0 ? "-" : "") + match.toLowerCase();\n  }\n  return propertyName.replace(/[A-Z]/g, upperToHyphenLower);\n}\n```\n\nGiven `styleHyphenFormat(\'borderTop\')`, this returns `\'border-top\'`.\n\nBecause we want to further transform the _result_ of the match before the final substitution is made, we must use a function. This forces the evaluation of the match prior to the [`toLowerCase()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/toLowerCase) method. If we had tried to do this using the match without a function, the {{jsxref("String/toLowerCase", "toLowerCase()")}} would have no effect.\n\n```js example-bad\n// Won\'t work\nconst newString = propertyName.replace(/[A-Z]/g, "-" + "$&".toLowerCase());\n```\n\nThis is because `\'$&\'.toLowerCase()` would first be evaluated as a string literal (resulting in the same `\'$&\'`) before using the characters as a pattern.\n\n### Replacing a Fahrenheit degree with its Celsius equivalent\n\nThe following example replaces a Fahrenheit degree with its equivalent Celsius degree. The Fahrenheit degree should be a number ending with `"F"`. The function returns the Celsius number ending with `"C"`. For example, if the input number is `"212F"`, the function returns `"100C"`. If the number is `"0F"`, the function returns `"-17.77777777777778C"`.\n\nThe regular expression `test` checks for any number that ends with `F`. The number of Fahrenheit degrees is accessible to the function through its second parameter, `p1`. The function sets the Celsius number based on the number of Fahrenheit degrees passed in a string to the `f2c()` function. `f2c()` then returns the Celsius number. This function approximates Perl\'s `s///e` flag.\n\n```js\nfunction f2c(x) {\n  function convert(str, p1, offset, s) {\n    return `${((p1 - 32) * 5) / 9}C`;\n  }\n  const s = String(x);\n  const test = /(-?\\d+(?:\\.\\d*)?)F\\b/g;\n  return s.replace(test, convert);\n}\n```\n\n### Making a generic replacer\n\nSuppose we want to create a replacer that appends the offset data to every matched string. Because the replacer function already receives the `offset` parameter, it will be trivial if the regex is statically known.\n\n```js\n"abcd".replace(/(bc)/, (match, p1, offset) => `${match} (${offset}) `);\n// "abc (1) d"\n```\n\nHowever, this replacer would be hard to generalize if we want it to work with any regex pattern. The replacer is _variadic_ \u2014 the number of arguments it receives depends on the number of capturing groups present. We can use [rest parameters](/en-US/docs/Web/JavaScript/Reference/Functions/rest_parameters), but it would also collect `offset`, `string`, etc. into the array. The fact that `groups` may or may not be passed depending on the identity of the regex would also make it hard to generically know which argument corresponds to the `offset`.\n\n```js example-bad\nfunction addOffset(match, ...args) {\n  const offset = args.at(-2);\n  return `${match} (${offset}) `;\n}\n\nconsole.log("abcd".replace(/(bc)/, addOffset)); // "abc (1) d"\nconsole.log("abcd".replace(/(?<group>bc)/, addOffset)); // "abc (abcd) d"\n```\n\nThe `addOffset` example above doesn\'t work when the regex contains a named group, because in this case `args.at(-2)` would be the `string` instead of the `offset`.\n\nInstead, you need to extract the last few arguments based on type, because `groups` is an object while `string` is a string.\n\n```js\nfunction addOffset(match, ...args) {\n  const hasNamedGroups = typeof args.at(-1) === "object";\n  const offset = hasNamedGroups ? args.at(-3) : args.at(-2);\n  return `${match} (${offset}) `;\n}\n\nconsole.log("abcd".replace(/(bc)/, addOffset)); // "abc (1) d"\nconsole.log("abcd".replace(/(?<group>bc)/, addOffset)); // "abc (1) d"\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `String.prototype.replace` in `core-js` with fixes and implementation of modern behavior like `Symbol.replace` support](https://github.com/zloirock/core-js#ecmascript-string-and-regexp)\n- {{jsxref("String.prototype.replaceAll()")}}\n- {{jsxref("String.prototype.match()")}}\n- {{jsxref("RegExp.prototype.exec()")}}\n- {{jsxref("RegExp.prototype.test()")}}\n- [`Symbol.replace`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol/replace)\n- [`RegExp.prototype[@@replace]()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/@@replace)\n'
        },
        "replaceall": {
            "index.md": '---\ntitle: String.prototype.replaceAll()\nslug: Web/JavaScript/Reference/Global_Objects/String/replaceAll\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.String.replaceAll\n---\n\n{{JSRef}}\n\nThe **`replaceAll()`** method of {{jsxref("String")}} values returns a new string with all matches of a `pattern` replaced by a `replacement`. The `pattern` can be a string or a {{jsxref("RegExp")}}, and the `replacement` can be a string or a function to be called for each match. The original string is left unchanged.\n\n{{EmbedInteractiveExample("pages/js/string-replaceall.html")}}\n\n## Syntax\n\n```js-nolint\nreplaceAll(pattern, replacement)\n```\n\n### Parameters\n\n- `pattern`\n\n  - : Can be a string or an object with a [`Symbol.replace`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol/replace) method \u2014 the typical example being a [regular expression](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp). Any value that doesn\'t have the `Symbol.replace` method will be coerced to a string.\n\n    If `pattern` [is a regex](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp#special_handling_for_regexes), then it must have the global (`g`) flag set, or a {{jsxref("TypeError")}} is thrown.\n\n- `replacement`\n  - : Can be a string or a function. The replacement has the same semantics as that of [`String.prototype.replace()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/replace).\n\n### Return value\n\nA new string, with all matches of a pattern replaced by a replacement.\n\n### Exceptions\n\n- {{jsxref("TypeError")}}\n  - : Thrown if the `pattern` [is a regex](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp#special_handling_for_regexes) that does not have the global (`g`) flag set (its [`flags`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/flags) property does not contain `"g"`).\n\n## Description\n\nThis method does not mutate the string value it\'s called on. It returns a new string.\n\nUnlike [`replace()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/replace), this method would replace all occurrences of a string, not just the first one. This is especially useful if the string is not statically known, as calling the [`RegExp()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/RegExp) constructor without escaping special characters may unintentionally change its semantics.\n\n```js\nfunction unsafeRedactName(text, name) {\n  return text.replace(new RegExp(name, "g"), "[REDACTED]");\n}\nfunction safeRedactName(text, name) {\n  return text.replaceAll(name, "[REDACTED]");\n}\n\nconst report =\n  "A hacker called ha.*er used special characters in their name to breach the system.";\n\nconsole.log(unsafeRedactName(report, "ha.*er")); // "A [REDACTED]s in their name to breach the system."\nconsole.log(safeRedactName(report, "ha.*er")); // "A hacker called [REDACTED] used special characters in their name to breach the system."\n```\n\nIf `pattern` is an object with a [`Symbol.replace`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol/replace) method (including `RegExp` objects), that method is called with the target string and `replacement` as arguments. Its return value becomes the return value of `replaceAll()`. In this case the behavior of `replaceAll()` is entirely encoded by the `@@replace` method, and therefore will have the same result as `replace()` (apart from the extra input validation that the regex is global).\n\nIf the `pattern` is an empty string, the replacement will be inserted in between every UTF-16 code unit, similar to [`split()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/split) behavior.\n\n```js\n"xxx".replaceAll("", "_"); // "_x_x_x_"\n```\n\nFor more information about how regex properties (especially the [sticky](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/sticky) flag) interact with `replaceAll()`, see [`RegExp.prototype[@@replace]()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/@@replace).\n\n## Examples\n\n### Using replaceAll()\n\n```js\n"aabbcc".replaceAll("b", ".");\n// \'aa..cc\'\n```\n\n### Non-global regex throws\n\nWhen using a regular expression search value, it must be global. This won\'t work:\n\n```js example-bad\n"aabbcc".replaceAll(/b/, ".");\n// TypeError: replaceAll must be called with a global RegExp\n```\n\nThis will work:\n\n```js example-good\n"aabbcc".replaceAll(/b/g, ".");\n("aa..cc");\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `String.prototype.replaceAll` in `core-js`](https://github.com/zloirock/core-js#ecmascript-string-and-regexp)\n- {{jsxref("String.prototype.replace()")}}\n- {{jsxref("String.prototype.match()")}}\n- {{jsxref("RegExp.prototype.exec()")}}\n- {{jsxref("RegExp.prototype.test()")}}\n'
        },
        "search": {
            "index.md": '---\ntitle: String.prototype.search()\nslug: Web/JavaScript/Reference/Global_Objects/String/search\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.String.search\n---\n\n{{JSRef}}\n\nThe **`search()`** method of {{jsxref("String")}} values executes a search for a match between a regular expression and this string, returning the index of the first match in the string.\n\n{{EmbedInteractiveExample("pages/js/string-search.html")}}\n\n## Syntax\n\n```js-nolint\nsearch(regexp)\n```\n\n### Parameters\n\n- `regexp`\n\n  - : A regular expression object, or any object that has a [`Symbol.search`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol/search) method.\n\n    If `regexp` is not a `RegExp` object and does not have a `Symbol.search` method, it is implicitly converted to a {{jsxref("RegExp")}} by using `new RegExp(regexp)`.\n\n### Return value\n\nThe index of the first match between the regular expression and the given string, or `-1` if no match was found.\n\n## Description\n\nThe implementation of `String.prototype.search()` itself is very simple \u2014 it simply calls the `Symbol.search` method of the argument with the string as the first parameter. The actual implementation comes from [`RegExp.prototype[@@search]()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/@@search).\n\nThe `g` flag of `regexp` has no effect on the `search()` result, and the search always happens as if the regex\'s `lastIndex` is 0. For more information on the behavior of `search()`, see [`RegExp.prototype[@@search]()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/@@search).\n\nWhen you want to know whether a pattern is found, and _also_ know its index within a string, use `search()`.\n\n- If you only want to know if it exists, use the {{jsxref("RegExp.prototype.test()")}} method, which returns a boolean.\n- If you need the content of the matched text, use {{jsxref("String.prototype.match()")}} or {{jsxref("RegExp.prototype.exec()")}}.\n\n## Examples\n\n### Using search()\n\nThe following example searches a string with two different regex objects to show a successful search (positive value) vs. an unsuccessful search (`-1`).\n\n```js\nconst str = "hey JudE";\nconst re = /[A-Z]/;\nconst reDot = /[.]/;\nconsole.log(str.search(re)); // returns 4, which is the index of the first capital letter "J"\nconsole.log(str.search(reDot)); // returns -1 cannot find \'.\' dot punctuation\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `String.prototype.search` in `core-js` with fixes and implementation of modern behavior like `Symbol.search` support](https://github.com/zloirock/core-js#ecmascript-string-and-regexp)\n- [Regular expressions](/en-US/docs/Web/JavaScript/Guide/Regular_expressions) guide\n- {{jsxref("String.prototype.match()")}}\n- {{jsxref("RegExp.prototype.exec()")}}\n- [`RegExp.prototype[@@search]()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/@@search)\n'
        },
        "slice": {
            "index.md": '---\ntitle: String.prototype.slice()\nslug: Web/JavaScript/Reference/Global_Objects/String/slice\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.String.slice\n---\n\n{{JSRef}}\n\nThe **`slice()`** method of {{jsxref("String")}} values extracts a section of this string and\nreturns it as a new string, without modifying the original string.\n\n{{EmbedInteractiveExample("pages/js/string-slice.html", "taller")}}\n\n## Syntax\n\n```js-nolint\nslice(indexStart)\nslice(indexStart, indexEnd)\n```\n\n### Parameters\n\n- `indexStart`\n  - : The index of the first character to include in the returned substring.\n- `indexEnd` {{optional_inline}}\n  - : The index of the first character to exclude from the returned substring.\n\n### Return value\n\nA new string containing the extracted section of the string.\n\n## Description\n\n`slice()` extracts the text from one string and returns a new string. Changes to the text in one string do not affect the other string.\n\n`slice()` extracts up to but not including `indexEnd`. For example, `str.slice(4, 8)` extracts the fifth character through the eighth character (characters indexed `4`, `5`, `6`, and `7`):\n\n```plain\n              indexStart        indexEnd\n                  \u2193               \u2193\n| 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 |\n| T | h | e |   | m | i | r | r | o | r |\n\n                  m   i   r   r\n                 _______________\n                      \u2191\n                    Result\n```\n\n- If `indexStart >= str.length`, an empty string is returned.\n- If `indexStart < 0`, the index is counted from the end of the string. More formally, in this case, the substring starts at `max(indexStart + str.length, 0)`.\n- If `indexStart` is omitted, undefined, or cannot be [converted to a number](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number#number_coercion), it\'s treated as `0`.\n- If `indexEnd` is omitted, undefined, or cannot be [converted to a number](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number#number_coercion), or if `indexEnd >= str.length`, `slice()` extracts to the end of the string.\n- If `indexEnd < 0`, the index is counted from the end of the string. More formally, in this case, the substring ends at `max(indexEnd + str.length, 0)`.\n- If `indexEnd <= indexStart` after normalizing negative values (i.e. `indexEnd` represents a character that\'s before `indexStart`), an empty string is returned.\n\n## Examples\n\n### Using slice() to create a new string\n\nThe following example uses `slice()` to create a new string.\n\n```js\nconst str1 = "The morning is upon us."; // The length of str1 is 23.\nconst str2 = str1.slice(1, 8);\nconst str3 = str1.slice(4, -2);\nconst str4 = str1.slice(12);\nconst str5 = str1.slice(30);\nconsole.log(str2); // he morn\nconsole.log(str3); // morning is upon u\nconsole.log(str4); // is upon us.\nconsole.log(str5); // ""\n```\n\n### Using slice() with negative indexes\n\nThe following example uses `slice()` with negative indexes.\n\n```js\nconst str = "The morning is upon us.";\nstr.slice(-3); // \'us.\'\nstr.slice(-3, -1); // \'us\'\nstr.slice(0, -1); // \'The morning is upon us\'\nstr.slice(4, -1); // \'morning is upon us\'\n```\n\nThis example counts backwards from the end of the string by `11` to find the\nstart index and forwards from the start of the string by `16` to find the end\nindex.\n\n```js\nconsole.log(str.slice(-11, 16)); // "is u"\n```\n\nHere it counts forwards from the start by `11` to find the start index and\nbackwards from the end by `7` to find the end index.\n\n```js\nconsole.log(str.slice(11, -7)); // " is u"\n```\n\nThese arguments count backwards from the end by `5` to find the start index\nand backwards from the end by `1` to find the end index.\n\n```js\nconsole.log(str.slice(-5, -1)); // "n us"\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("String.prototype.substr()")}}\n- {{jsxref("String.prototype.substring()")}}\n- {{jsxref("Array.prototype.slice()")}}\n'
        },
        "small": {
            "index.md": '---\ntitle: String.prototype.small()\nslug: Web/JavaScript/Reference/Global_Objects/String/small\npage-type: javascript-instance-method\nstatus:\n  - deprecated\nbrowser-compat: javascript.builtins.String.small\n---\n\n{{JSRef}} {{Deprecated_Header}}\n\nThe **`small()`** method of {{jsxref("String")}} values creates a string that embeds this string in a {{HTMLElement("small")}} element (`<small>str</small>`), which causes this string to be displayed in a small font.\n\n> **Note:** All [HTML wrapper methods](/en-US/docs/Web/JavaScript/Reference/Global_Objects/String#html_wrapper_methods) are deprecated and only standardized for compatibility purposes. Use [DOM APIs](/en-US/docs/Web/API/Document_Object_Model) such as [`document.createElement()`](/en-US/docs/Web/API/Document/createElement) instead.\n\n## Syntax\n\n```js-nolint\nsmall()\n```\n\n### Parameters\n\nNone.\n\n### Return value\n\nA string beginning with a `<small>` start tag, then the text `str`, and then a `</small>` end tag.\n\n## Examples\n\n### Using small()\n\nThe code below creates an HTML string and then replaces the document\'s body with it:\n\n```js\nconst contentString = "Hello, world";\n\ndocument.body.innerHTML = contentString.small();\n```\n\nThis will create the following HTML:\n\n```html\n<small>Hello, world</small>\n```\n\nInstead of using `small()` and creating HTML text directly, you should use DOM APIs such as [`document.createElement()`](/en-US/docs/Web/API/Document/createElement). For example:\n\n```js\nconst contentString = "Hello, world";\nconst elem = document.createElement("small");\nelem.innerText = contentString;\ndocument.body.appendChild(elem);\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `String.prototype.small` in `core-js`](https://github.com/zloirock/core-js#ecmascript-string-and-regexp)\n- [HTML wrapper methods](/en-US/docs/Web/JavaScript/Reference/Global_Objects/String#html_wrapper_methods)\n- {{HTMLElement("small")}}\n'
        },
        "split": {
            "index.md": '---\ntitle: String.prototype.split()\nslug: Web/JavaScript/Reference/Global_Objects/String/split\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.String.split\n---\n\n{{JSRef}}\n\nThe **`split()`** method of {{jsxref("String")}} values takes a pattern and divides this string into an ordered list of substrings by searching for the pattern, puts these substrings into an array, and returns the array.\n\n{{EmbedInteractiveExample("pages/js/string-split.html", "taller")}}\n\n## Syntax\n\n```js-nolint\nsplit(separator)\nsplit(separator, limit)\n```\n\n### Parameters\n\n- `separator`\n  - : The pattern describing where each split should occur. Can be `undefined`, a string, or an object with a [`Symbol.split`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol/split) method \u2014 the typical example being a {{jsxref("RegExp", "regular expression", "", 1)}}. Omitting `separator` or passing `undefined` causes `split()` to return an array with the calling string as a single element. All values that are not `undefined` or objects with a `@@split` method are [coerced to strings](/en-US/docs/Web/JavaScript/Reference/Global_Objects/String#string_coercion).\n- `limit` {{optional_inline}}\n  - : A non-negative integer specifying a limit on the number of substrings to be included in the array. If provided, splits the string at each occurrence of the specified `separator`, but stops when `limit` entries have been placed in the array. Any leftover text is not included in the array at all.\n    - The array may contain fewer entries than `limit` if the end of the string is reached before the limit is reached.\n    - If `limit` is `0`, `[]` is returned.\n\n### Return value\n\nAn {{jsxref("Array")}} of strings, split at each point where the `separator` occurs in the given string.\n\n## Description\n\nIf `separator` is a non-empty string, the target string is split by all matches of the `separator` without including `separator` in the results. For example, a string containing tab separated values (TSV) could be parsed by passing a tab character as the separator, like `myString.split("\\t")`. If `separator` contains multiple characters, that entire character sequence must be found in order to split. If `separator` appears at the beginning (or end) of the string, it still has the effect of splitting, resulting in an empty (i.e. zero length) string appearing at the first (or last) position of the returned array. If `separator` does not occur in `str`, the returned array contains one element consisting of the entire string.\n\nIf `separator` is an empty string (`""`), `str` is converted to an array of each of its UTF-16 "characters", without empty strings on either ends of the resulting string.\n\n> **Note:** `"".split("")` is therefore the only way to produce an empty array when a string is passed as `separator` and `limit` is not `0`.\n\n> **Warning:** When the empty string (`""`) is used as a separator, the string is **not** split by _user-perceived characters_ ([grapheme clusters](https://unicode.org/reports/tr29/#Grapheme_Cluster_Boundaries)) or unicode characters (code points), but by UTF-16 code units. This destroys [surrogate pairs](https://unicode.org/faq/utf_bom.html#utf16-2). See ["How do you get a string to a character array in JavaScript?" on StackOverflow](https://stackoverflow.com/questions/4547609/how-to-get-character-array-from-a-string/34717402#34717402).\n\nIf `separator` is a regexp that matches empty strings, whether the match is split by UTF-16 code units or Unicode code points depends on if the regex is [Unicode-aware](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/unicode#unicode-aware_mode).\n\n```js\n"\uD83D\uDE04\uD83D\uDE04".split(/(?:)/); // [ "\ud83d", "\ude04", "\ud83d", "\ude04" ]\n"\uD83D\uDE04\uD83D\uDE04".split(/(?:)/u); // [ "\uD83D\uDE04", "\uD83D\uDE04" ]\n```\n\nIf `separator` is a regular expression with capturing groups, then each time `separator` matches, the captured groups (including any `undefined` results) are spliced into the output array. This behavior is specified by the regexp\'s [`Symbol.split`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol/split) method.\n\nIf `separator` is an object with a [`Symbol.split`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol/split) method, that method is called with the target string and `limit` as arguments, and `this` set to the object. Its return value becomes the return value of `split`.\n\nAny other value will be coerced to a string before being used as separator.\n\n## Examples\n\n### Using split()\n\nWhen the string is empty and a non-empty separator is specified, `split()` returns `[""]`. If the string and separator are both empty strings, an empty array is returned.\n\n```js\nconst emptyString = "";\n\n// string is empty and separator is non-empty\nconsole.log(emptyString.split("a"));\n// [""]\n\n// string and separator are both empty strings\nconsole.log(emptyString.split(emptyString));\n// []\n```\n\nThe following example defines a function that splits a string into an array of strings\nusing `separator`. After splitting the string, the function logs\nmessages indicating the original string (before the split), the separator used, the\nnumber of elements in the array, and the individual array elements.\n\n```js\nfunction splitString(stringToSplit, separator) {\n  const arrayOfStrings = stringToSplit.split(separator);\n\n  console.log("The original string is:", stringToSplit);\n  console.log("The separator is:", separator);\n  console.log(\n    "The array has",\n    arrayOfStrings.length,\n    "elements:",\n    arrayOfStrings.join(" / "),\n  );\n}\n\nconst tempestString = "Oh brave new world that has such people in it.";\nconst monthString = "Jan,Feb,Mar,Apr,May,Jun,Jul,Aug,Sep,Oct,Nov,Dec";\n\nconst space = " ";\nconst comma = ",";\n\nsplitString(tempestString, space);\nsplitString(tempestString);\nsplitString(monthString, comma);\n```\n\nThis example produces the following output:\n\n```plain\nThe original string is: "Oh brave new world that has such people in it."\nThe separator is: " "\nThe array has 10 elements: Oh / brave / new / world / that / has / such / people / in / it.\n\nThe original string is: "Oh brave new world that has such people in it."\nThe separator is: "undefined"\nThe array has 1 elements: Oh brave new world that has such people in it.\n\nThe original string is: "Jan,Feb,Mar,Apr,May,Jun,Jul,Aug,Sep,Oct,Nov,Dec"\nThe separator is: ","\nThe array has 12 elements: Jan / Feb / Mar / Apr / May / Jun / Jul / Aug / Sep / Oct / Nov / Dec\n```\n\n### Removing spaces from a string\n\nIn the following example, `split()` looks for zero or more spaces, followed\nby a semicolon, followed by zero or more spaces\u2014and, when found, removes the spaces and\nthe semicolon from the string. `nameList` is the array returned as a result\nof `split()`.\n\n```js\nconst names = "Harry Trump ;Fred Barney; Helen Rigby ; Bill Abel ;Chris Hand ";\n\nconsole.log(names);\n\nconst re = /\\s*(?:;|$)\\s*/;\nconst nameList = names.split(re);\n\nconsole.log(nameList);\n```\n\nThis logs two lines; the first line logs the original string, and the second line logs\nthe resulting array.\n\n```plain\nHarry Trump ;Fred Barney; Helen Rigby ; Bill Abel ;Chris Hand\n[ "Harry Trump", "Fred Barney", "Helen Rigby", "Bill Abel", "Chris Hand", "" ]\n```\n\n### Returning a limited number of splits\n\nIn the following example, `split()` looks for spaces in a string and returns\nthe first 3 splits that it finds.\n\n```js\nconst myString = "Hello World. How are you doing?";\nconst splits = myString.split(" ", 3);\n\nconsole.log(splits); // [ "Hello", "World.", "How" ]\n```\n\n### Splitting with a `RegExp` to include parts of the separator in the result\n\nIf `separator` is a regular expression that contains capturing\nparentheses `( )`, matched results are included in the array.\n\n```js\nconst myString = "Hello 1 word. Sentence number 2.";\nconst splits = myString.split(/(\\d)/);\n\nconsole.log(splits);\n// [ "Hello ", "1", " word. Sentence number ", "2", "." ]\n```\n\n> **Note:** `\\d` matches the [character class](/en-US/docs/Web/JavaScript/Guide/Regular_expressions/Character_classes) for digits between 0 and 9.\n\n### Using a custom splitter\n\nAn object with a `Symbol.split` method can be used as a splitter with custom behavior.\n\nThe following example splits a string using an internal state consisting of an incrementing number:\n\n```js\nconst splitByNumber = {\n  [Symbol.split](str) {\n    let num = 1;\n    let pos = 0;\n    const result = [];\n    while (pos < str.length) {\n      const matchPos = str.indexOf(num, pos);\n      if (matchPos === -1) {\n        result.push(str.substring(pos));\n        break;\n      }\n      result.push(str.substring(pos, matchPos));\n      pos = matchPos + String(num).length;\n      num++;\n    }\n    return result;\n  },\n};\n\nconst myString = "a1bc2c5d3e4f";\nconsole.log(myString.split(splitByNumber)); // [ "a", "bc", "c5d", "e", "f" ]\n```\n\nThe following example uses an internal state to enforce certain behavior, and to ensure a "valid" result is produced.\n\n```js\nconst DELIMITER = ";";\n\n// Split the commands, but remove any invalid or unnecessary values.\nconst splitCommands = {\n  [Symbol.split](str, lim) {\n    const results = [];\n    const state = {\n      on: false,\n      brightness: {\n        current: 2,\n        min: 1,\n        max: 3,\n      },\n    };\n    let pos = 0;\n    let matchPos = str.indexOf(DELIMITER, pos);\n\n    while (matchPos !== -1) {\n      const subString = str.slice(pos, matchPos).trim();\n\n      switch (subString) {\n        case "light on":\n          // If the `on` state is already true, do nothing.\n          if (!state.on) {\n            state.on = true;\n            results.push(subString);\n          }\n          break;\n\n        case "light off":\n          // If the `on` state is already false, do nothing.\n          if (state.on) {\n            state.on = false;\n            results.push(subString);\n          }\n          break;\n\n        case "brightness up":\n          // Enforce a brightness maximum.\n          if (state.brightness.current < state.brightness.max) {\n            state.brightness.current += 1;\n            results.push(subString);\n          }\n          break;\n\n        case "brightness down":\n          // Enforce a brightness minimum.\n          if (state.brightness.current > state.brightness.min) {\n            state.brightness.current -= 1;\n            results.push(subString);\n          }\n          break;\n      }\n\n      if (results.length === lim) {\n        break;\n      }\n\n      pos = matchPos + DELIMITER.length;\n      matchPos = str.indexOf(DELIMITER, pos);\n    }\n\n    // If we broke early due to reaching the split `lim`, don\'t add the remaining commands.\n    if (results.length < lim) {\n      results.push(str.slice(pos).trim());\n    }\n\n    return results;\n  },\n};\n\nconst commands =\n  "light on; brightness up; brightness up; brightness up; light on; brightness down; brightness down; light off";\nconsole.log(commands.split(splitCommands, 3)); // ["light on", "brightness up", "brightness down"]\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `String.prototype.split` in `core-js` with fixes and implementation of modern behavior like `Symbol.split` support](https://github.com/zloirock/core-js#ecmascript-string-and-regexp)\n- {{jsxref("String.prototype.charAt()")}}\n- {{jsxref("String.prototype.indexOf()")}}\n- {{jsxref("String.prototype.lastIndexOf()")}}\n- {{jsxref("Array.prototype.join()")}}\n- [Regular expressions](/en-US/docs/Web/JavaScript/Guide/Regular_expressions) guide\n'
        },
        "startswith": {
            "index.md": '---\ntitle: String.prototype.startsWith()\nslug: Web/JavaScript/Reference/Global_Objects/String/startsWith\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.String.startsWith\n---\n\n{{JSRef}}\n\nThe **`startsWith()`** method of {{jsxref("String")}} values determines whether this string begins with the characters of a specified string, returning `true` or `false` as appropriate.\n\n{{EmbedInteractiveExample("pages/js/string-startswith.html")}}\n\n## Syntax\n\n```js-nolint\nstartsWith(searchString)\nstartsWith(searchString, position)\n```\n\n### Parameters\n\n- `searchString`\n  - : The characters to be searched for at the start of this string. Cannot [be a regex](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp#special_handling_for_regexes). All values that are not regexes are [coerced to strings](/en-US/docs/Web/JavaScript/Reference/Global_Objects/String#string_coercion), so omitting it or passing `undefined` causes `startsWith()` to search for the string `"undefined"`, which is rarely what you want.\n- `position` {{optional_inline}}\n  - : The start position at which `searchString` is expected to be found (the index of `searchString`\'s first character). Defaults to `0`.\n\n### Return value\n\n**`true`** if the given characters are found at the beginning of the string, including when `searchString` is an empty string; otherwise, **`false`**.\n\n### Exceptions\n\n- {{jsxref("TypeError")}}\n  - : Thrown if `searchString` [is a regex](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp#special_handling_for_regexes).\n\n## Description\n\nThis method lets you determine whether or not a string begins with another string. This method is case-sensitive.\n\n## Examples\n\n### Using startsWith()\n\n```js\nconst str = "To be, or not to be, that is the question.";\n\nconsole.log(str.startsWith("To be")); // true\nconsole.log(str.startsWith("not to be")); // false\nconsole.log(str.startsWith("not to be", 10)); // true\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `String.prototype.startsWith` in `core-js`](https://github.com/zloirock/core-js#ecmascript-string-and-regexp)\n- {{jsxref("String.prototype.endsWith()")}}\n- {{jsxref("String.prototype.includes()")}}\n- {{jsxref("String.prototype.indexOf()")}}\n- {{jsxref("String.prototype.lastIndexOf()")}}\n'
        },
        "strike": {
            "index.md": '---\ntitle: String.prototype.strike()\nslug: Web/JavaScript/Reference/Global_Objects/String/strike\npage-type: javascript-instance-method\nstatus:\n  - deprecated\nbrowser-compat: javascript.builtins.String.strike\n---\n\n{{JSRef}} {{Deprecated_Header}}\n\nThe **`strike()`** method of {{jsxref("String")}} values creates a string that embeds this string in a {{HTMLElement("strike")}} element (`<strike>str</strike>`), which causes this string to be displayed as struck-out text.\n\n> **Note:** All [HTML wrapper methods](/en-US/docs/Web/JavaScript/Reference/Global_Objects/String#html_wrapper_methods) are deprecated and only standardized for compatibility purposes. For the case of `strike()`, the `<strike>` element itself has been removed from the HTML specification and shouldn\'t be used anymore. Web developers should use the {{HTMLElement("del")}} for deleted content or the {{HTMLElement("s")}} for content that is no longer accurate or no longer relevant instead.\n\n## Syntax\n\n```js-nolint\nstrike()\n```\n\n### Parameters\n\nNone.\n\n### Return value\n\nA string beginning with a `<strike>` start tag, then the text `str`, and then a `</strike>` end tag.\n\n## Examples\n\n### Using strike()\n\nThe code below creates an HTML string and then replaces the document\'s body with it:\n\n```js\nconst contentString = "Hello, world";\n\ndocument.body.innerHTML = contentString.strike();\n```\n\nThis will create the following HTML:\n\n```html\n<strike>Hello, world</strike>\n```\n\n> **Warning:** This markup is invalid, because `strike` is no longer a valid element.\n\nInstead of using `strike()` and creating HTML text directly, you should use DOM APIs such as [`document.createElement()`](/en-US/docs/Web/API/Document/createElement). For example:\n\n```js\nconst contentString = "Hello, world";\nconst elem = document.createElement("s");\nelem.innerText = contentString;\ndocument.body.appendChild(elem);\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `String.prototype.strike` in `core-js`](https://github.com/zloirock/core-js#ecmascript-string-and-regexp)\n- [HTML wrapper methods](/en-US/docs/Web/JavaScript/Reference/Global_Objects/String#html_wrapper_methods)\n- {{HTMLElement("strike")}}\n'
        },
        "string": {
            "index.md": '---\ntitle: String() constructor\nslug: Web/JavaScript/Reference/Global_Objects/String/String\npage-type: javascript-constructor\nbrowser-compat: javascript.builtins.String.String\n---\n\n{{JSRef}}\n\nThe **`String()`** constructor creates {{jsxref("String")}} objects. When called as a function, it returns primitive values of type String.\n\n## Syntax\n\n```js-nolint\nnew String(thing)\nString(thing)\n```\n\n> **Note:** `String()` can be called with or without [`new`](/en-US/docs/Web/JavaScript/Reference/Operators/new), but with different effects. See [Return value](#return_value).\n\n### Parameters\n\n- `thing`\n  - : Anything to be converted to a string.\n\n### Return value\n\nWhen `String` is called as a constructor (with `new`), it creates a {{jsxref("String")}} object, which is **not** a primitive.\n\nWhen `String` is called as a function, it coerces the parameter to a string primitive. [Symbol](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol) values would be converted to `"Symbol(description)"`, where `description` is the [description](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol/description) of the Symbol, instead of throwing.\n\n> **Warning:** You should rarely find yourself using `String` as a constructor.\n\n## Examples\n\n### String constructor and String function\n\nString function and String constructor produce different results:\n\n```js\nconst a = new String("Hello world"); // a === "Hello world" is false\nconst b = String("Hello world"); // b === "Hello world" is true\na instanceof String; // is true\nb instanceof String; // is false\ntypeof a; // "object"\ntypeof b; // "string"\n```\n\nHere, the function produces a string (the {{Glossary("primitive")}} type) as promised.\nHowever, the constructor produces an instance of the type String (an object wrapper) and\nthat\'s why you rarely want to use the String constructor at all.\n\n### Using String() to stringify a symbol\n\n`String()` is the only case where a symbol can be converted to a string without throwing, because it\'s very explicit.\n\n```js example-bad\nconst sym = Symbol("example");\n`${sym}`; // TypeError: Cannot convert a Symbol value to a string\n"" + sym; // TypeError: Cannot convert a Symbol value to a string\n"".concat(sym); // TypeError: Cannot convert a Symbol value to a string\n```\n\n```js example-good\nconst sym = Symbol("example");\nString(sym); // "Symbol(example)"\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Text formatting](/en-US/docs/Web/JavaScript/Guide/Text_formatting) guide\n'
        },
        "sub": {
            "index.md": '---\ntitle: String.prototype.sub()\nslug: Web/JavaScript/Reference/Global_Objects/String/sub\npage-type: javascript-instance-method\nstatus:\n  - deprecated\nbrowser-compat: javascript.builtins.String.sub\n---\n\n{{JSRef}} {{Deprecated_Header}}\n\nThe **`sub()`** method of {{jsxref("String")}} values creates a string that embeds this string in a {{HTMLElement("sub")}} element (`<sub>str</sub>`), which causes this string to be displayed as subscript.\n\n> **Note:** All [HTML wrapper methods](/en-US/docs/Web/JavaScript/Reference/Global_Objects/String#html_wrapper_methods) are deprecated and only standardized for compatibility purposes. Use [DOM APIs](/en-US/docs/Web/API/Document_Object_Model) such as [`document.createElement()`](/en-US/docs/Web/API/Document/createElement) instead.\n\n## Syntax\n\n```js-nolint\nsub()\n```\n\n### Parameters\n\nNone.\n\n### Return value\n\nA string beginning with a `<sub>` start tag, then the text `str`, and then a `</sub>` end tag.\n\n## Examples\n\n### Using sub()\n\nThe code below creates an HTML string and then replaces the document\'s body with it:\n\n```js\nconst contentString = "Hello, world";\n\ndocument.body.innerHTML = contentString.sub();\n```\n\nThis will create the following HTML:\n\n```html\n<sub>Hello, world</sub>\n```\n\nInstead of using `sub()` and creating HTML text directly, you should use DOM APIs such as [`document.createElement()`](/en-US/docs/Web/API/Document/createElement). For example:\n\n```js\nconst contentString = "Hello, world";\nconst elem = document.createElement("sub");\nelem.innerText = contentString;\ndocument.body.appendChild(elem);\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `String.prototype.sub` in `core-js`](https://github.com/zloirock/core-js#ecmascript-string-and-regexp)\n- [HTML wrapper methods](/en-US/docs/Web/JavaScript/Reference/Global_Objects/String#html_wrapper_methods)\n- {{HTMLElement("sub")}}\n'
        },
        "substr": {
            "index.md": '---\ntitle: String.prototype.substr()\nslug: Web/JavaScript/Reference/Global_Objects/String/substr\npage-type: javascript-instance-method\nstatus:\n  - deprecated\nbrowser-compat: javascript.builtins.String.substr\n---\n\n{{JSRef}} {{Deprecated_Header}}\n\nThe **`substr()`** method of {{jsxref("String")}} values returns a portion of this string, starting at the specified index and extending for a given number of characters afterwards.\n\n> **Note:** `substr()` is not part of the main ECMAScript specification \u2014 it\'s defined in [Annex B: Additional ECMAScript Features for Web Browsers](https://tc39.es/ecma262/multipage/additional-ecmascript-features-for-web-browsers.html), which is normative optional for non-browser runtimes. Therefore, people are advised to use the standard [`String.prototype.substring()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/substring) and [`String.prototype.slice()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/slice) methods instead to make their code maximally cross-platform friendly. The [`String.prototype.substring()` page](/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/substring#the_difference_between_substring_and_substr) has some comparisons between the three methods.\n\n{{EmbedInteractiveExample("pages/js/string-substr.html")}}\n\n## Syntax\n\n```js-nolint\nsubstr(start)\nsubstr(start, length)\n```\n\n### Parameters\n\n- `start`\n  - : The index of the first character to include in the returned substring.\n- `length` {{optional_inline}}\n  - : The number of characters to extract.\n\n### Return value\n\nA new string containing the specified part of the given string.\n\n## Description\n\nA string\'s `substr()` method extracts `length` characters from the string, counting from the `start` index.\n\n- If `start >= str.length`, an empty string is returned.\n- If `start < 0`, the index starts counting from the end of the string. More formally, in this case the substring starts at `max(start + str.length, 0)`.\n- If `start` is omitted or {{jsxref("undefined")}}, it\'s treated as `0`.\n- If `length` is omitted or {{jsxref("undefined")}}, or if `start + length >= str.length`, `substr()` extracts characters to the end of the string.\n- If `length < 0`, an empty string is returned.\n- For both `start` and `length`, {{jsxref("NaN")}} is treated as `0`.\n\nAlthough you are encouraged to avoid using `substr()`, there is no trivial way to migrate `substr()` to either `slice()` or `substring()` in legacy code without essentially writing a polyfill for `substr()`. For example, `str.substr(a, l)`, `str.slice(a, a + l)`, and `str.substring(a, a + l)` all have different results when `str = "01234", a = 1, l = -2` \u2014 `substr()` returns an empty string, `slice()` returns `"123"`, while `substring()` returns `"0"`. The actual refactoring path depends on the knowledge of the range of `a` and `l`.\n\n## Examples\n\n### Using substr()\n\n```js\nconst aString = "Mozilla";\n\nconsole.log(aString.substr(0, 1)); // \'M\'\nconsole.log(aString.substr(1, 0)); // \'\'\nconsole.log(aString.substr(-1, 1)); // \'a\'\nconsole.log(aString.substr(1, -1)); // \'\'\nconsole.log(aString.substr(-3)); // \'lla\'\nconsole.log(aString.substr(1)); // \'ozilla\'\nconsole.log(aString.substr(-20, 2)); // \'Mo\'\nconsole.log(aString.substr(20, 2)); // \'\'\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `String.prototype.substr` in `core-js`](https://github.com/zloirock/core-js#ecmascript-string-and-regexp)\n- {{jsxref("String.prototype.slice()")}}\n- {{jsxref("String.prototype.substring()")}}\n'
        },
        "substring": {
            "index.md": '---\ntitle: String.prototype.substring()\nslug: Web/JavaScript/Reference/Global_Objects/String/substring\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.String.substring\n---\n\n{{JSRef}}\n\nThe **`substring()`** method of {{jsxref("String")}} values returns the part of this string from the start index up to and excluding the end index, or to the end of the string if no end index is supplied.\n\n{{EmbedInteractiveExample("pages/js/string-substring.html")}}\n\n## Syntax\n\n```js-nolint\nsubstring(indexStart)\nsubstring(indexStart, indexEnd)\n```\n\n### Parameters\n\n- `indexStart`\n  - : The index of the first character to include in the returned substring.\n- `indexEnd` {{optional_inline}}\n  - : The index of the first character to exclude from the returned substring.\n\n### Return value\n\nA new string containing the specified part of the given string.\n\n## Description\n\n`substring()` extracts characters from `indexStart` up to _but not including_ `indexEnd`. In particular:\n\n- If `indexEnd` is omitted, `substring()` extracts characters to the end of the string.\n- If `indexStart` is equal to `indexEnd`, `substring()` returns an empty string.\n- If `indexStart` is greater than `indexEnd`, then the effect of `substring()` is as if the two arguments were swapped; see example below.\n\nAny argument value that is less than `0` or greater than `str.length` is treated as if it were `0` and `str.length`, respectively.\n\nAny argument value that is {{jsxref("NaN")}} is treated as if it were `0`.\n\n## Examples\n\n### Using substring()\n\nThe following example uses `substring()` to display characters from the\nstring `"Mozilla"`:\n\n```js\nconst anyString = "Mozilla";\n\nconsole.log(anyString.substring(0, 1)); // "M"\nconsole.log(anyString.substring(1, 0)); // "M"\n\nconsole.log(anyString.substring(0, 6)); // "Mozill"\n\nconsole.log(anyString.substring(4)); // "lla"\nconsole.log(anyString.substring(4, 7)); // "lla"\nconsole.log(anyString.substring(7, 4)); // "lla"\n\nconsole.log(anyString.substring(0, 7)); // "Mozilla"\nconsole.log(anyString.substring(0, 10)); // "Mozilla"\n```\n\n### Using substring() with length property\n\nThe following example uses the `substring()` method and\n{{jsxref("String/length", "length")}} property to extract the last characters of a\nparticular string. This method may be easier to remember, given that you don\'t need to\nknow the starting and ending indices as you would in the above examples.\n\n```js\nconst text = "Mozilla";\n\n// Takes 4 last characters of string\nconsole.log(text.substring(text.length - 4)); // prints "illa"\n\n// Takes 5 last characters of string\nconsole.log(text.substring(text.length - 5)); // prints "zilla"\n```\n\n### The difference between substring() and substr()\n\nThere are subtle differences between the `substring()` and\n{{jsxref("String/substr", "substr()")}} methods, so you should be careful not to get\nthem confused.\n\n- The two parameters of `substr()` are `start` and `length`, while for `substring()`, they are `start` and `end`.\n- `substr()`\'s `start` index will wrap to the end of the string if it is negative, while `substring()` will clamp it to `0`.\n- Negative lengths in `substr()` are treated as zero, while `substring()` will swap the two indexes if `end` is less than `start`.\n\nFurthermore, `substr()` is considered a _legacy feature in ECMAScript_, so it is best to avoid using it if possible.\n\n```js\nconst text = "Mozilla";\nconsole.log(text.substring(2, 5)); // "zil"\nconsole.log(text.substr(2, 3)); // "zil"\n```\n\n### Differences between substring() and slice()\n\nThe `substring()` and {{jsxref("String/slice", "slice()")}} methods are\nalmost identical, but there are a couple of subtle differences between the two,\nespecially in the way negative arguments are dealt with.\n\nThe `substring()` method swaps its two arguments if\n`indexStart` is greater than `indexEnd`,\nmeaning that a string is still returned. The {{jsxref("String/slice", "slice()")}}\nmethod returns an empty string if this is the case.\n\n```js\nconst text = "Mozilla";\nconsole.log(text.substring(5, 2)); // "zil"\nconsole.log(text.slice(5, 2)); // ""\n```\n\nIf either or both of the arguments are negative or `NaN`, the\n`substring()` method treats them as if they were `0`.\n\n```js\nconsole.log(text.substring(-5, 2)); // "Mo"\nconsole.log(text.substring(-5, -2)); // ""\n```\n\n`slice()` also treats `NaN` arguments as `0`, but when\nit is given negative values it counts backwards from the end of the string to find the\nindexes.\n\n```js\nconsole.log(text.slice(-5, 2)); // ""\nconsole.log(text.slice(-5, -2)); // "zil"\n```\n\nSee the {{jsxref("String/slice", "slice()")}} page for more examples with negative\nnumbers.\n\n### Replacing a substring within a string\n\nThe following example replaces a substring within a string. It will replace both\nindividual characters and substrings. The function call at the end of the example\nchanges the string `Brave New World` to `Brave New Web`.\n\n```js\n// Replaces oldS with newS in the string fullS\nfunction replaceString(oldS, newS, fullS) {\n  for (let i = 0; i < fullS.length; ++i) {\n    if (fullS.substring(i, i + oldS.length) === oldS) {\n      fullS =\n        fullS.substring(0, i) +\n        newS +\n        fullS.substring(i + oldS.length, fullS.length);\n    }\n  }\n  return fullS;\n}\n\nreplaceString("World", "Web", "Brave New World");\n```\n\nNote that this can result in an infinite loop if `oldS` is itself a\nsubstring of `newS` \u2014 for example, if you attempted to replace\n`"World"` with `"OtherWorld"` here.\n\nA better method for replacing strings is as follows:\n\n```js\nfunction replaceString(oldS, newS, fullS) {\n  return fullS.split(oldS).join(newS);\n}\n```\n\nThe code above serves as an example for substring operations. If you need to replace\nsubstrings, most of the time you will want to use\n{{jsxref("String.prototype.replace()")}}.\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("String.prototype.substr()")}}\n- {{jsxref("String.prototype.slice()")}}\n'
        },
        "sup": {
            "index.md": '---\ntitle: String.prototype.sup()\nslug: Web/JavaScript/Reference/Global_Objects/String/sup\npage-type: javascript-instance-method\nstatus:\n  - deprecated\nbrowser-compat: javascript.builtins.String.sup\n---\n\n{{JSRef}} {{Deprecated_Header}}\n\nThe **`sup()`** method of {{jsxref("String")}} values creates a string that embeds this string in a {{HTMLElement("sup")}} element (`<sup>str</sup>`), which causes this string to be displayed as superscript.\n\n> **Note:** All [HTML wrapper methods](/en-US/docs/Web/JavaScript/Reference/Global_Objects/String#html_wrapper_methods) are deprecated and only standardized for compatibility purposes. Use [DOM APIs](/en-US/docs/Web/API/Document_Object_Model) such as [`document.createElement()`](/en-US/docs/Web/API/Document/createElement) instead.\n\n## Syntax\n\n```js-nolint\nsup()\n```\n\n### Parameters\n\nNone.\n\n### Return value\n\nA string beginning with a `<sup>` start tag, then the text `str`, and then a `</sup>` end tag.\n\n## Examples\n\n### Using sup()\n\nThe code below creates an HTML string and then replaces the document\'s body with it:\n\n```js\nconst contentString = "Hello, world";\n\ndocument.body.innerHTML = contentString.sup();\n```\n\nThis will create the following HTML:\n\n```html\n<sup>Hello, world</sup>\n```\n\nInstead of using `sup()` and creating HTML text directly, you should use DOM APIs such as [`document.createElement()`](/en-US/docs/Web/API/Document/createElement). For example:\n\n```js\nconst contentString = "Hello, world";\nconst elem = document.createElement("sup");\nelem.innerText = contentString;\ndocument.body.appendChild(elem);\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `String.prototype.sup` in `core-js`](https://github.com/zloirock/core-js#ecmascript-string-and-regexp)\n- [HTML wrapper methods](/en-US/docs/Web/JavaScript/Reference/Global_Objects/String#html_wrapper_methods)\n- {{HTMLElement("sup")}}\n'
        },
        "tolocalelowercase": {
            "index.md": '---\ntitle: String.prototype.toLocaleLowerCase()\nslug: Web/JavaScript/Reference/Global_Objects/String/toLocaleLowerCase\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.String.toLocaleLowerCase\n---\n\n{{JSRef}}\n\nThe **`toLocaleLowerCase()`** method of {{jsxref("String")}} values returns this string converted to lower case, according to any locale-specific case mappings.\n\n{{EmbedInteractiveExample("pages/js/string-tolocalelowercase.html")}}\n\n## Syntax\n\n```js-nolint\ntoLocaleLowerCase()\ntoLocaleLowerCase(locales)\n```\n\n### Parameters\n\n- `locales` {{optional_inline}}\n\n  - : A string with a BCP 47 language tag, or an array of such strings. Indicates the locale to be used to convert to lower case according to any locale-specific case mappings. For the general form and interpretation of the `locales` argument, see [the parameter description on the `Intl` main page](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl#locales_argument).\n\n    Unlike other methods that use the `locales` argument, `toLocaleLowerCase()` does not allow locale matching. Therefore, after checking the validity of the `locales` argument, `toLocaleLowerCase()` always uses the first locale in the list (or the default locale if the list is empty), even if this locale is not supported by the implementation.\n\n### Return value\n\nA new string representing the calling string converted to lower case, according to any\nlocale-specific case mappings.\n\n## Description\n\nThe `toLocaleLowerCase()` method returns the value of the string converted\nto lower case according to any locale-specific case mappings.\n`toLocaleLowerCase()` does not affect the value of the string itself. In most\ncases, this will produce the same result as {{jsxref("String/toLowerCase", "toLowerCase()")}}, but for some locales, such as Turkish, whose case mappings do not\nfollow the default case mappings in Unicode, there may be a different result.\n\n## Examples\n\n### Using toLocaleLowerCase()\n\n```js\n"ALPHABET".toLocaleLowerCase(); // \'alphabet\'\n\n"\\u0130".toLocaleLowerCase("tr") === "i"; // true\n"\\u0130".toLocaleLowerCase("en-US") === "i"; // false\n\nconst locales = ["tr", "TR", "tr-TR", "tr-u-co-search", "tr-x-turkish"];\n"\\u0130".toLocaleLowerCase(locales) === "i"; // true\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("String.prototype.toLocaleUpperCase()")}}\n- {{jsxref("String.prototype.toLowerCase()")}}\n- {{jsxref("String.prototype.toUpperCase()")}}\n'
        },
        "tolocaleuppercase": {
            "index.md": '---\ntitle: String.prototype.toLocaleUpperCase()\nslug: Web/JavaScript/Reference/Global_Objects/String/toLocaleUpperCase\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.String.toLocaleUpperCase\n---\n\n{{JSRef}}\n\nThe **`toLocaleUpperCase()`** method of {{jsxref("String")}} values returns this string converted to upper case, according to any locale-specific case mappings.\n\n{{EmbedInteractiveExample("pages/js/string-tolocaleuppercase.html")}}\n\n## Syntax\n\n```js-nolint\ntoLocaleUpperCase()\ntoLocaleUpperCase(locales)\n```\n\n### Parameters\n\n- `locales` {{optional_inline}}\n\n  - : A string with a BCP 47 language tag, or an array of such strings. Indicates the locale to be used to convert to upper case according to any locale-specific case mappings. For the general form and interpretation of the `locales` argument, see [the parameter description on the `Intl` main page](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl#locales_argument).\n\n    Unlike other methods that use the `locales` argument, `toLocaleUpperCase()` does not allow locale matching. Therefore, after checking the validity of the `locales` argument, `toLocaleUpperCase()` always uses the first locale in the list (or the default locale if the list is empty), even if this locale is not supported by the implementation.\n\n### Return value\n\nA new string representing the calling string converted to upper case, according to any\nlocale-specific case mappings.\n\n## Description\n\nThe `toLocaleUpperCase()` method returns the value of the string converted\nto upper case according to any locale-specific case mappings.\n`toLocaleUpperCase()` does not affect the value of the string itself. In most\ncases, this will produce the same result as {{jsxref("String/toUpperCase", "toUpperCase()")}}, but for some locales, such as Turkish, whose case mappings do not\nfollow the default case mappings in Unicode, there may be a different result.\n\nAlso notice that conversion is not necessarily a 1:1 character mapping, as some\ncharacters might result in two (or even more) characters when transformed to upper-case.\nTherefore the length of the result string can differ from the input length. This also\nimplies that the conversion is not stable, so i.E. the following can return\n`false`:\n`x.toLocaleLowerCase() === x.toLocaleUpperCase().toLocaleLowerCase()`\n\n## Examples\n\n### Using toLocaleUpperCase()\n\n```js\n"alphabet".toLocaleUpperCase(); // \'ALPHABET\'\n\n"Ges\xe4\xdf".toLocaleUpperCase(); // \'GES\xc4SS\'\n\n"i\\u0307".toLocaleUpperCase("lt-LT"); // \'I\'\n\nconst locales = ["lt", "LT", "lt-LT", "lt-u-co-phonebk", "lt-x-lietuva"];\n"i\\u0307".toLocaleUpperCase(locales); // \'I\'\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("String.prototype.toLocaleLowerCase()")}}\n- {{jsxref("String.prototype.toLowerCase()")}}\n- {{jsxref("String.prototype.toUpperCase()")}}\n'
        },
        "tolowercase": {
            "index.md": '---\ntitle: String.prototype.toLowerCase()\nslug: Web/JavaScript/Reference/Global_Objects/String/toLowerCase\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.String.toLowerCase\n---\n\n{{JSRef}}\n\nThe **`toLowerCase()`** method of {{jsxref("String")}} values returns this string converted to lower case.\n\n{{EmbedInteractiveExample("pages/js/string-tolowercase.html", "shorter")}}\n\n## Syntax\n\n```js-nolint\ntoLowerCase()\n```\n\n### Parameters\n\nNone.\n\n### Return value\n\nA new string representing the calling string converted to lower case.\n\n## Description\n\nThe `toLowerCase()` method returns the value of the string converted to\nlower case. `toLowerCase()` does not affect the value of the string\n`str` itself.\n\n## Examples\n\n### Using `toLowerCase()`\n\n```js\nconsole.log("ALPHABET".toLowerCase()); // \'alphabet\'\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("String.prototype.toLocaleLowerCase()")}}\n- {{jsxref("String.prototype.toLocaleUpperCase()")}}\n- {{jsxref("String.prototype.toUpperCase()")}}\n'
        },
        "tostring": {
            "index.md": '---\ntitle: String.prototype.toString()\nslug: Web/JavaScript/Reference/Global_Objects/String/toString\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.String.toString\n---\n\n{{JSRef}}\n\nThe **`toString()`** method of {{jsxref("String")}} values returns this string value.\n\n{{EmbedInteractiveExample("pages/js/string-tostring.html")}}\n\n## Syntax\n\n```js-nolint\ntoString()\n```\n\n### Parameters\n\nNone.\n\n### Return value\n\nA string representing the specified string value.\n\n## Description\n\nThe {{jsxref("String")}} object overrides the `toString` method of {{jsxref("Object")}}; it does not inherit\n{{jsxref("Object.prototype.toString()")}}. For `String` values, the `toString` method returns the string itself (if it\'s a primitive) or the string that the `String` object wraps. It has the exact same implementation as {{jsxref("String.prototype.valueOf()")}}.\n\nThe `toString()` method requires its `this` value to be a `String` primitive or wrapper object. It throws a {{jsxref("TypeError")}} for other `this` values without attempting to coerce them to string values.\n\nBecause `String` doesn\'t have a [`[@@toPrimitive]()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol/toPrimitive) method, JavaScript calls the `toString()` method automatically when a `String` _object_ is used in a context expecting a string, such as in a [template literal](/en-US/docs/Web/JavaScript/Reference/Template_literals). However, String _primitive_ values do not consult the `toString()` method to be [coerced to strings](/en-US/docs/Web/JavaScript/Reference/Global_Objects/String#string_coercion) \u2014 since they are already strings, no conversion is performed.\n\n```js\nString.prototype.toString = () => "Overridden";\nconsole.log(`${"foo"}`); // "foo"\nconsole.log(`${new String("foo")}`); // "Overridden"\n```\n\n## Examples\n\n### Using toString()\n\nThe following example displays the string value of a {{jsxref("String")}} object:\n\n```js\nconst x = new String("Hello world");\n\nconsole.log(x.toString()); // "Hello world"\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("String.prototype.valueOf()")}}\n'
        },
        "touppercase": {
            "index.md": '---\ntitle: String.prototype.toUpperCase()\nslug: Web/JavaScript/Reference/Global_Objects/String/toUpperCase\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.String.toUpperCase\n---\n\n{{JSRef}}\n\nThe **`toUpperCase()`** method of {{jsxref("String")}} values returns this string converted to uppercase.\n\n{{EmbedInteractiveExample("pages/js/string-touppercase.html", "shorter")}}\n\n## Syntax\n\n```js-nolint\ntoUpperCase()\n```\n\n### Parameters\n\nNone.\n\n### Return value\n\nA new string representing the calling string converted to upper case.\n\n## Description\n\nThe `toUpperCase()` method returns the value of the string converted to\nuppercase. This method does not affect the value of the string itself since JavaScript\nstrings are immutable.\n\n## Examples\n\n### Basic usage\n\n```js\nconsole.log("alphabet".toUpperCase()); // \'ALPHABET\'\n```\n\n### Conversion of non-string `this` values to strings\n\nThis method will convert any non-string value to a string, when you set its\n`this` to a value that is not a string:\n\n```js\nconst a = String.prototype.toUpperCase.call({\n  toString() {\n    return "abcdef";\n  },\n});\n\nconst b = String.prototype.toUpperCase.call(true);\n\n// prints out \'ABCDEF TRUE\'.\nconsole.log(a, b);\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("String.prototype.toLocaleLowerCase()")}}\n- {{jsxref("String.prototype.toLocaleUpperCase()")}}\n- {{jsxref("String.prototype.toLowerCase()")}}\n'
        },
        "towellformed": {
            "index.md": '---\ntitle: String.prototype.toWellFormed()\nslug: Web/JavaScript/Reference/Global_Objects/String/toWellFormed\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.String.toWellFormed\n---\n\n{{JSRef}}\n\nThe **`toWellFormed()`** method of {{jsxref("String")}} values returns a string where all [lone surrogates](/en-US/docs/Web/JavaScript/Reference/Global_Objects/String#utf-16_characters_unicode_code_points_and_grapheme_clusters) of this string are replaced with the Unicode replacement character U+FFFD.\n\n## Syntax\n\n```js-nolint\ntoWellFormed()\n```\n\n### Parameters\n\nNone.\n\n### Return value\n\nA new string that is a copy of this string, with all lone surrogates replaced with the Unicode replacement character U+FFFD. If `str` [is well formed](/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/isWellFormed), a new string is still returned (essentially a copy of `str`).\n\n## Description\n\nStrings in JavaScript are UTF-16 encoded. UTF-16 encoding has the concept of _surrogate pairs_, which is introduced in detail in the [UTF-16 characters, Unicode code points, and grapheme clusters](/en-US/docs/Web/JavaScript/Reference/Global_Objects/String#utf-16_characters_unicode_code_points_and_grapheme_clusters) section.\n\n`toWellFormed()` iterates through the code units of this string, and replaces any lone surrogates with the [Unicode replacement character](<https://en.wikipedia.org/wiki/Specials_(Unicode_block)#Replacement_character>) U+FFFD `\uFFFD`. This ensures that the returned string is well-formed and can be used in functions that expect well-formed strings, such as {{jsxref("encodeURI")}}. Compared to a custom implementation, `toWellFormed()` is more efficient, as engines can directly access the internal representation of strings.\n\nWhen ill-formed strings are used in certain contexts, such as {{domxref("TextEncoder")}}, they are automatically converted to well-formed strings using the same replacement character. When lone surrogates are rendered, they are also rendered as the replacement character (a diamond with a question mark inside).\n\n## Examples\n\n### Using toWellFormed()\n\n```js\nconst strings = [\n  // Lone leading surrogate\n  "ab\uD800",\n  "ab\uD800c",\n  // Lone trailing surrogate\n  "\uDFFFab",\n  "c\uDFFFab",\n  // Well-formed\n  "abc",\n  "ab\uD83D\uDE04c",\n];\n\nfor (const str of strings) {\n  console.log(str.toWellFormed());\n}\n// Logs:\n// "ab\uFFFD"\n// "ab\uFFFDc"\n// "\uFFFDab"\n// "c\uFFFDab"\n// "abc"\n// "ab\uD83D\uDE04c"\n```\n\n### Avoiding errors in encodeURI()\n\n{{jsxref("encodeURI")}} throws an error if the string passed is not well-formed. This can be avoided by using `toWellFormed()` to convert the string to a well-formed string first.\n\n```js\nconst illFormed = "https://example.com/search?q=\uD800";\n\ntry {\n  encodeURI(illFormed);\n} catch (e) {\n  console.log(e); // URIError: URI malformed\n}\n\nconsole.log(encodeURI(illFormed.toWellFormed())); // "https://example.com/search?q=%EF%BF%BD"\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `String.prototype.toWellFormed` in `core-js`](https://github.com/zloirock/core-js#well-formed-unicode-strings)\n- {{jsxref("String.prototype.isWellFormed()")}}\n- {{jsxref("String.prototype.normalize()")}}\n'
        },
        "trim": {
            "index.md": '---\ntitle: String.prototype.trim()\nslug: Web/JavaScript/Reference/Global_Objects/String/trim\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.String.trim\n---\n\n{{JSRef}}\n\nThe **`trim()`** method of {{jsxref("String")}} values removes whitespace from both ends of this string and returns a new string, without modifying the original string.\n\nTo return a new string with whitespace trimmed from just one end, use {{jsxref("String/trimStart", "trimStart()")}} or {{jsxref("String/trimEnd", "trimEnd()")}}.\n\n{{EmbedInteractiveExample("pages/js/string-trim.html")}}\n\n## Syntax\n\n```js-nolint\ntrim()\n```\n\n### Parameters\n\nNone.\n\n### Return value\n\nA new string representing `str` stripped of whitespace from both its beginning and end. Whitespace is defined as [white space](/en-US/docs/Web/JavaScript/Reference/Lexical_grammar#white_space) characters plus [line terminators](/en-US/docs/Web/JavaScript/Reference/Lexical_grammar#line_terminators).\n\nIf neither the beginning or end of `str` has any whitespace, a new string is still returned (essentially a copy of `str`).\n\n## Examples\n\n### Using trim()\n\nThe following example trims whitespace from both ends of `str`.\n\n```js\nconst str = "   foo  ";\nconsole.log(str.trim()); // \'foo\'\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("String.prototype.trimStart()")}}\n- {{jsxref("String.prototype.trimEnd()")}}\n'
        },
        "trimend": {
            "index.md": '---\ntitle: String.prototype.trimEnd()\nslug: Web/JavaScript/Reference/Global_Objects/String/trimEnd\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.String.trimEnd\n---\n\n{{JSRef}}\n\nThe **`trimEnd()`** method of {{jsxref("String")}} values removes whitespace from the end of this string and returns a new string, without modifying the original string. `trimRight()` is an alias of this method.\n\n{{EmbedInteractiveExample("pages/js/string-trimend.html")}}\n\n## Syntax\n\n```js-nolint\ntrimEnd()\n\ntrimRight()\n```\n\n### Parameters\n\nNone.\n\n### Return value\n\nA new string representing `str` stripped of whitespace from its end (right side). Whitespace is defined as [white space](/en-US/docs/Web/JavaScript/Reference/Lexical_grammar#white_space) characters plus [line terminators](/en-US/docs/Web/JavaScript/Reference/Lexical_grammar#line_terminators).\n\nIf the end of `str` has no whitespace, a new string is still returned (essentially a copy of `str`).\n\n### Aliasing\n\nAfter {{jsxref("String/trim", "trim()")}} was standardized, engines also implemented the non-standard method `trimRight`. However, for consistency with {{jsxref("String/padEnd", "padEnd()")}}, when the method got standardized, its name was chosen as `trimEnd`. For web compatibility reasons, `trimRight` remains as an alias to `trimEnd`, and they refer to the exact same function object. In some engines this means:\n\n```js\nString.prototype.trimRight.name === "trimEnd";\n```\n\n## Examples\n\n### Using trimEnd()\n\nThe following example trims whitespace from the end of `str`, but not from its start.\n\n```js\nlet str = "   foo  ";\n\nconsole.log(str.length); // 8\n\nstr = str.trimEnd();\nconsole.log(str.length); // 6\nconsole.log(str); // \'   foo\'\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `String.prototype.trimEnd` in `core-js`](https://github.com/zloirock/core-js#ecmascript-string-and-regexp)\n- {{jsxref("String.prototype.trim()")}}\n- {{jsxref("String.prototype.trimStart()")}}\n'
        },
        "trimstart": {
            "index.md": '---\ntitle: String.prototype.trimStart()\nslug: Web/JavaScript/Reference/Global_Objects/String/trimStart\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.String.trimStart\n---\n\n{{JSRef}}\n\nThe **`trimStart()`** method of {{jsxref("String")}} values removes whitespace from the beginning of this string and returns a new string, without modifying the original string. `trimLeft()` is an alias of this method.\n\n{{EmbedInteractiveExample("pages/js/string-trimstart.html")}}\n\n## Syntax\n\n```js-nolint\ntrimStart()\n\ntrimLeft()\n```\n\n### Parameters\n\nNone.\n\n### Return value\n\nA new string representing `str` stripped of whitespace from its beginning (left side). Whitespace is defined as [white space](/en-US/docs/Web/JavaScript/Reference/Lexical_grammar#white_space) characters plus [line terminators](/en-US/docs/Web/JavaScript/Reference/Lexical_grammar#line_terminators).\n\nIf the beginning of `str` has no whitespace, a new string is still returned (essentially a copy of `str`).\n\n### Aliasing\n\nAfter {{jsxref("String/trim", "trim()")}} was standardized, engines also implemented the non-standard method `trimLeft`. However, for consistency with {{jsxref("String/padStart", "padStart()")}}, when the method got standardized, its name was chosen as `trimStart`. For web compatibility reasons, `trimLeft` remains as an alias to `trimStart`, and they refer to the exact same function object. In some engines this means:\n\n```js\nString.prototype.trimLeft.name === "trimStart";\n```\n\n## Examples\n\n### Using trimStart()\n\nThe following example trims whitespace from the start of `str`, but not from its end.\n\n```js\nlet str = "   foo  ";\n\nconsole.log(str.length); // 8\n\nstr = str.trimStart();\nconsole.log(str.length); // 5\nconsole.log(str); // \'foo  \'\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `String.prototype.trimStart` in `core-js`](https://github.com/zloirock/core-js#ecmascript-string-and-regexp)\n- {{jsxref("String.prototype.trim()")}}\n- {{jsxref("String.prototype.trimEnd()")}}\n'
        },
        "valueof": {
            "index.md": '---\ntitle: String.prototype.valueOf()\nslug: Web/JavaScript/Reference/Global_Objects/String/valueOf\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.String.valueOf\n---\n\n{{JSRef}}\n\nThe **`valueOf()`** method of {{jsxref("String")}} values returns this string value.\n\n{{EmbedInteractiveExample("pages/js/string-valueof.html")}}\n\n## Syntax\n\n```js-nolint\nvalueOf()\n```\n\n### Parameters\n\nNone.\n\n### Return value\n\nA string representing the primitive value of a given {{jsxref("String")}} object.\n\n## Description\n\nThe `valueOf()` method of {{jsxref("String")}} returns the primitive value\nof a {{jsxref("String")}} object as a string data type. This value is equivalent to\n{{jsxref("String.prototype.toString()")}}.\n\nThis method is usually called internally by JavaScript and not explicitly in code.\n\n## Examples\n\n### Using `valueOf()`\n\n```js\nconst x = new String("Hello world");\nconsole.log(x.valueOf()); // \'Hello world\'\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("String.prototype.toString()")}}\n- {{jsxref("Object.prototype.valueOf()")}}\n'
        }
    },
    "symbol": {
        "@@toprimitive": {
            "index.md": '---\ntitle: Symbol.prototype[@@toPrimitive]()\nslug: Web/JavaScript/Reference/Global_Objects/Symbol/@@toPrimitive\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Symbol.@@toPrimitive\n---\n\n{{JSRef}}\n\nThe **`[@@toPrimitive]()`** method of {{jsxref("Symbol")}} values returns this symbol value.\n\n## Syntax\n\n```js-nolint\nsymbolValue[Symbol.toPrimitive](hint)\n```\n\n### Parameters\n\n- `hint`\n  - : A string value indicating the primitive value to return. The value is ignored.\n\n### Return value\n\nThe primitive value of the specified {{jsxref("Symbol")}} object.\n\n## Description\n\nThe `[@@toPrimitive]()` method of {{jsxref("Symbol")}} returns the primitive\nvalue of a Symbol object as a Symbol data type. The `hint`\nargument is not used.\n\nJavaScript calls the `[@@toPrimitive]()` method to convert an object to a\nprimitive value. You rarely need to invoke the `[@@toPrimitive]()` method\nyourself; JavaScript automatically invokes it when encountering an object where a\nprimitive value is expected.\n\n## Examples\n\n### Using @@toPrimitive\n\n```js\nconst sym = Symbol("example");\nsym === sym[Symbol.toPrimitive](); // true\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Symbol.toPrimitive")}}\n'
        },
        "asynciterator": {
            "index.md": '---\ntitle: Symbol.asyncIterator\nslug: Web/JavaScript/Reference/Global_Objects/Symbol/asyncIterator\npage-type: javascript-static-data-property\nbrowser-compat: javascript.builtins.Symbol.asyncIterator\n---\n\n{{JSRef}}\n\nThe **`Symbol.asyncIterator`** static data property represents the [well-known symbol](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#well-known_symbols) `@@asyncIterator`. The [async iterable protocol](/en-US/docs/Web/JavaScript/Reference/Iteration_protocols#the_async_iterator_and_async_iterable_protocols) looks up this symbol for the method that returns the async iterator for an object. In order for an object to be async iterable, it must have an `@@asyncIterator` key.\n\n{{EmbedInteractiveExample("pages/js/symbol-asynciterator.html", "taller")}}\n\n## Value\n\nThe well-known symbol `@@asyncIterator`.\n\n{{js_property_attributes(0, 0, 0)}}\n\n## Examples\n\n### User-defined async iterables\n\nYou can define your own async iterable by setting the `[Symbol.asyncIterator]` property on an object.\n\n```js\nconst myAsyncIterable = {\n  async *[Symbol.asyncIterator]() {\n    yield "hello";\n    yield "async";\n    yield "iteration!";\n  },\n};\n\n(async () => {\n  for await (const x of myAsyncIterable) {\n    console.log(x);\n  }\n})();\n// Logs:\n// "hello"\n// "async"\n// "iteration!"\n```\n\nWhen creating an API, remember that async iterables are designed to represent something _iterable_ \u2014 like a stream of data or a list \u2014, not to completely replace callbacks and events in most situations.\n\n### Built-in async iterables\n\nThere is no object in the core JavaScript language that is async iterable. Some web APIs, such as {{domxref("ReadableStream")}}, have the `Symbol.asyncIterator` method set by default.\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Iteration protocols](/en-US/docs/Web/JavaScript/Reference/Iteration_protocols)\n- [for await...of](/en-US/docs/Web/JavaScript/Reference/Statements/for-await...of)\n'
        },
        "description": {
            "index.md": '---\ntitle: Symbol.prototype.description\nslug: Web/JavaScript/Reference/Global_Objects/Symbol/description\npage-type: javascript-instance-accessor-property\nbrowser-compat: javascript.builtins.Symbol.description\n---\n\n{{JSRef}}\n\nThe **`description`** accessor property of {{jsxref("Symbol")}} values returns a string containing the description of this symbol, or `undefined` if the symbol has no description.\n\n{{EmbedInteractiveExample("pages/js/symbol-prototype-description.html")}}\n\n## Description\n\n{{jsxref("Symbol")}} objects can be created with an optional description which can be used for debugging but not to access the symbol itself. The `Symbol.prototype.description` property can be used to read that description. It is different to `Symbol.prototype.toString()` as it does not contain the enclosing `"Symbol()"` string. See the examples.\n\n## Examples\n\n### Using description\n\n```js\nSymbol("desc").toString(); // "Symbol(desc)"\nSymbol("desc").description; // "desc"\nSymbol("").description; // ""\nSymbol().description; // undefined\n\n// well-known symbols\nSymbol.iterator.toString(); // "Symbol(Symbol.iterator)"\nSymbol.iterator.description; // "Symbol.iterator"\n\n// global symbols\nSymbol.for("foo").toString(); // "Symbol(foo)"\nSymbol.for("foo").description; // "foo"\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Symbol.prototype.description` in `core-js`](https://github.com/zloirock/core-js#ecmascript-symbol)\n- {{jsxref("Symbol.prototype.toString()")}}\n'
        },
        "for": {
            "index.md": '---\ntitle: Symbol.for()\nslug: Web/JavaScript/Reference/Global_Objects/Symbol/for\npage-type: javascript-static-method\nbrowser-compat: javascript.builtins.Symbol.for\n---\n\n{{JSRef}}\n\nThe **`Symbol.for()`** static method searches for existing symbols\nin a runtime-wide symbol registry with the given key and returns it if found. Otherwise\na new symbol gets created in the global symbol registry with this key.\n\n{{EmbedInteractiveExample("pages/js/symbol-for.html")}}\n\n## Syntax\n\n```js-nolint\nSymbol.for(key)\n```\n\n### Parameters\n\n- `key`\n  - : String, required. The key for the symbol (and also used for the description of the\n    symbol).\n\n### Return value\n\nAn existing symbol with the given key if found; otherwise, a new symbol is created and\nreturned.\n\n## Description\n\nIn contrast to `Symbol()`, the `Symbol.for()` function creates a\nsymbol available in a [global symbol registry](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#shared_symbols_in_the_global_symbol_registry) list. `Symbol.for()` does also\nnot necessarily create a new symbol on every call, but checks first if a symbol with the\ngiven `key` is already present in the registry. In that case, that symbol is\nreturned. If no symbol with the given key is found, `Symbol.for()` will\ncreate a new global symbol.\n\n## Examples\n\n### Using Symbol.for()\n\n```js\nSymbol.for("foo"); // create a new global symbol\nSymbol.for("foo"); // retrieve the already created symbol\n\n// Same global symbol, but not locally\nSymbol.for("bar") === Symbol.for("bar"); // true\nSymbol("bar") === Symbol("bar"); // false\n\n// The key is also used as the description\nconst sym = Symbol.for("mario");\nsym.toString(); // "Symbol(mario)"\n```\n\nTo avoid name clashes with your global symbol keys and other (library code) global\nsymbols, it might be a good idea to prefix your symbols:\n\n```js\nSymbol.for("mdn.foo");\nSymbol.for("mdn.bar");\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Symbol.keyFor()")}}\n'
        },
        "hasinstance": {
            "index.md": '---\ntitle: Symbol.hasInstance\nslug: Web/JavaScript/Reference/Global_Objects/Symbol/hasInstance\npage-type: javascript-static-data-property\nbrowser-compat: javascript.builtins.Symbol.hasInstance\n---\n\n{{JSRef}}\n\nThe **`Symbol.hasInstance`** static data property represents the [well-known symbol](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#well-known_symbols) `@@hasInstance`. The {{jsxref("Operators/instanceof", "instanceof")}} operator looks up this symbol on its right-hand operand for the method used to determine if the constructor object recognizes an object as its instance.\n\n{{EmbedInteractiveExample("pages/js/symbol-hasinstance.html")}}\n\n## Value\n\nThe well-known symbol `@@hasInstance`.\n\n{{js_property_attributes(0, 0, 0)}}\n\n## Description\n\nThe `instanceof` operator uses the following algorithm to calculate the return value of `object instanceof constructor`:\n\n1. If `constructor` has a `@@hasInstance` method, then call it with `object` as the first argument and return the result, [coerced to a boolean](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Boolean#boolean_coercion). Throw a {{jsxref("TypeError")}} if `constructor` is not an object, or if `constructor[@@hasInstance]` is not one of `null`, `undefined`, or a function.\n2. Otherwise, if `constructor` doesn\'t have a `@@hasInstance` method (`constructor[@@hasInstance]` is `null` or `undefined`), then determine the result using the same algorithm as [`Function.prototype[@@hasInstance]`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/@@hasInstance). Throw a {{jsxref("TypeError")}} if `constructor` is not a function.\n\nBecause all functions inherit from `Function.prototype` by default, most of the time, the [`Function.prototype[@@hasInstance]`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/@@hasInstance) method specifies the behavior of `instanceof` when the right-hand side is a function.\n\n## Examples\n\n### Custom instanceof behavior\n\nYou could implement your custom `instanceof` behavior like this, for example:\n\n```js\nclass MyArray {\n  static [Symbol.hasInstance](instance) {\n    return Array.isArray(instance);\n  }\n}\nconsole.log([] instanceof MyArray); // true\n```\n\n```js\nfunction MyArray() {}\nObject.defineProperty(MyArray, Symbol.hasInstance, {\n  value(instance) {\n    return Array.isArray(instance);\n  },\n});\nconsole.log([] instanceof MyArray); // true\n```\n\n### Checking the instance of an object\n\nJust in the same manner at which you can check if an object is an instance of a class using the `instanceof` keyword, we can also use `Symbol.hasInstance` for such checks.\n\n```js\nclass Animal {\n  constructor() {}\n}\n\nconst cat = new Animal();\n\nconsole.log(Animal[Symbol.hasInstance](cat)); // true\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Operators/instanceof", "instanceof")}}\n- [`Function.prototype[@@hasInstance]()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/@@hasInstance)\n'
        },
        "index.md": '---\ntitle: Symbol\nslug: Web/JavaScript/Reference/Global_Objects/Symbol\npage-type: javascript-class\nbrowser-compat: javascript.builtins.Symbol\n---\n\n{{JSRef}}\n\n**`Symbol`** is a built-in object whose constructor returns a `symbol` [primitive](/en-US/docs/Glossary/Primitive) \u2014 also called a **Symbol value** or just a **Symbol** \u2014 that\'s guaranteed to be unique. Symbols are often used to add unique property keys to an object that won\'t collide with keys any other code might add to the object, and which are hidden from any mechanisms other code will typically use to access the object. That enables a form of weak {{Glossary("encapsulation")}}, or a weak form of [information hiding](https://en.wikipedia.org/wiki/Information_hiding).\n\nEvery `Symbol()` call is guaranteed to return a unique Symbol. Every `Symbol.for("key")` call will always return the same Symbol for a given value of `"key"`. When `Symbol.for("key")` is called, if a Symbol with the given key can be found in the global Symbol registry, that Symbol is returned. Otherwise, a new Symbol is created, added to the global Symbol registry under the given key, and returned.\n\n## Description\n\nTo create a new primitive Symbol, you write `Symbol()` with an optional string as its description:\n\n```js\nconst sym1 = Symbol();\nconst sym2 = Symbol("foo");\nconst sym3 = Symbol("foo");\n```\n\nThe above code creates three new Symbols. Note that `Symbol("foo")` does not coerce the string `"foo"` into a Symbol. It creates a new Symbol each time:\n\n```js\nSymbol("foo") === Symbol("foo"); // false\n```\n\nThe following syntax with the {{jsxref("Operators/new", "new")}} operator will throw a {{jsxref("TypeError")}}:\n\n```js example-bad\nconst sym = new Symbol(); // TypeError\n```\n\nThis prevents authors from creating an explicit `Symbol` wrapper object instead of a new Symbol value and might be surprising as creating explicit wrapper objects around primitive data types is generally possible (for example, `new Boolean`, `new String` and `new Number`).\n\nIf you really want to create a `Symbol` wrapper object, you can use the `Object()` function:\n\n```js\nconst sym = Symbol("foo");\ntypeof sym; // "symbol"\nconst symObj = Object(sym);\ntypeof symObj; // "object"\n```\n\nBecause symbols are the only primitive data type that has reference identity (that is, you cannot create the same symbol twice), they behave like objects in some way. For example, they are garbage collectable and can therefore be stored in {{jsxref("WeakMap")}}, {{jsxref("WeakSet")}}, {{jsxref("WeakRef")}}, and {{jsxref("FinalizationRegistry")}} objects.\n\n### Shared Symbols in the global Symbol registry\n\nThe above syntax using the `Symbol()` function will create a Symbol whose value remains unique throughout the lifetime of the program. To create Symbols available across files and even across realms (each of which has its own global scope), use the methods {{jsxref("Symbol.for()")}} and {{jsxref("Symbol.keyFor()")}} to set and retrieve Symbols from the global Symbol registry.\n\nNote that the "global Symbol registry" is only a fictitious concept and may not correspond to any internal data structure in the JavaScript engine \u2014 and even if such a registry exists, its content is not available to the JavaScript code, except through the `for()` and `keyFor()` methods.\n\nThe method `Symbol.for(tokenString)` takes a string key and returns a symbol value from the registry, while `Symbol.keyFor(symbolValue)` takes a symbol value and returns the string key corresponding to it. Each is the other\'s inverse, so the following is `true`:\n\n```js\nSymbol.keyFor(Symbol.for("tokenString")) === "tokenString"; // true\n```\n\nBecause registered symbols can be arbitrarily created anywhere, they behave almost exactly like the strings they wrap. Therefore, they are not guaranteed to be unique and are not garbage collectable. Therefore, registered symbols are disallowed in {{jsxref("WeakMap")}}, {{jsxref("WeakSet")}}, {{jsxref("WeakRef")}}, and {{jsxref("FinalizationRegistry")}} objects.\n\n### Well-known Symbols\n\nAll static properties of the `Symbol` constructor are Symbols themselves, whose values are constant across realms. They are known as _well-known Symbols_, and their purpose is to serve as "protocols" for certain built-in JavaScript operations, allowing users to customize the language\'s behavior. For example, if a constructor function has a method with {{jsxref("Symbol.hasInstance")}} as its name, this method will encode its behavior with the {{jsxref("Operators/instanceof", "instanceof")}} operator.\n\nPrior to well-known Symbols, JavaScript used normal properties to implement certain built-in operations. For example, the [`JSON.stringify`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/JSON/stringify) function will attempt to call each object\'s `toJSON()` method, and the [`String`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/String) function will call the object\'s `toString()` and `valueOf()` methods. However, as more operations are added to the language, designating each operation a "magic property" can break backward compatibility and make the language\'s behavior harder to reason with. Well-known Symbols allow the customizations to be "invisible" from normal code, which typically only read string properties.\n\nIn MDN and other sources, well-known symbol values are stylized by prefixing `@@`. For example, {{jsxref("Symbol.hasInstance")}} is written as `@@hasInstance`. This is because symbols don\'t have actual literal formats, but using `Symbol.hasInstance` does not reflect the ability of using other aliases to refer to the same symbol. This is like the difference between `Function.name` and `"Function"`.\n\nWell-known symbols do not have the concept of garbage collectability, because they come in a fixed set and are unique throughout the lifetime of the program, similar to intrinsic objects such as `Array.prototype`, so they are also allowed in {{jsxref("WeakMap")}}, {{jsxref("WeakSet")}}, {{jsxref("WeakRef")}}, and {{jsxref("FinalizationRegistry")}} objects.\n\n### Finding Symbol properties on objects\n\nThe method {{jsxref("Object.getOwnPropertySymbols()")}} returns an array of Symbols and lets you find Symbol properties on a given object. Note that every object is initialized with no own Symbol properties, so that this array will be empty unless you\'ve set Symbol properties on the object.\n\n## Constructor\n\n- {{jsxref("Symbol/Symbol", "Symbol()")}}\n  - : Creates a new `Symbol` object. It is not a constructor in the traditional sense, because it can only be called as a function, instead of being constructed with `new Symbol()`.\n\n## Static properties\n\nThe static properties are all well-known Symbols. In these Symbols\' descriptions, we will use language like "`Symbol.hasInstance` is a method determining\u2026", but bear in mind that this is referring to the semantic of an object\'s method having this Symbol as the method name (because well-known Symbols act as "protocols"), not describing the value of the Symbol itself.\n\n- {{jsxref("Symbol.asyncIterator")}}\n  - : A method that returns the default AsyncIterator for an object. Used by [`for await...of`](/en-US/docs/Web/JavaScript/Reference/Statements/for-await...of).\n- {{jsxref("Symbol.hasInstance")}}\n  - : A method determining if a constructor object recognizes an object as its instance. Used by {{jsxref("Operators/instanceof", "instanceof")}}.\n- {{jsxref("Symbol.isConcatSpreadable")}}\n  - : A Boolean value indicating if an object should be flattened to its array elements. Used by {{jsxref("Array.prototype.concat()")}}.\n- {{jsxref("Symbol.iterator")}}\n  - : A method returning the default iterator for an object. Used by [`for...of`](/en-US/docs/Web/JavaScript/Reference/Statements/for...of).\n- {{jsxref("Symbol.match")}}\n  - : A method that matches against a string, also used to determine if an object may be used as a regular expression. Used by {{jsxref("String.prototype.match()")}}.\n- {{jsxref("Symbol.matchAll")}}\n  - : A method that returns an iterator, that yields matches of the regular expression against a string. Used by {{jsxref("String.prototype.matchAll()")}}.\n- {{jsxref("Symbol.replace")}}\n  - : A method that replaces matched substrings of a string. Used by {{jsxref("String.prototype.replace()")}}.\n- {{jsxref("Symbol.search")}}\n  - : A method that returns the index within a string that matches the regular expression. Used by {{jsxref("String.prototype.search()")}}.\n- {{jsxref("Symbol.species")}}\n  - : A constructor function that is used to create derived objects.\n- {{jsxref("Symbol.split")}}\n  - : A method that splits a string at the indices that match a regular expression. Used by {{jsxref("String.prototype.split()")}}.\n- {{jsxref("Symbol.toPrimitive")}}\n  - : A method converting an object to a primitive value.\n- {{jsxref("Symbol.toStringTag")}}\n  - : A string value used for the default description of an object. Used by {{jsxref("Object.prototype.toString()")}}.\n- {{jsxref("Symbol.unscopables")}}\n  - : An object value of whose own and inherited property names are excluded from the [`with`](/en-US/docs/Web/JavaScript/Reference/Statements/with) environment bindings of the associated object.\n\n## Static methods\n\n- {{jsxref("Symbol.for()")}}\n  - : Searches for existing Symbols with the given `key` and returns it if found. Otherwise a new Symbol gets created in the global Symbol registry with `key`.\n- {{jsxref("Symbol.keyFor()")}}\n  - : Retrieves a shared Symbol key from the global Symbol registry for the given Symbol.\n\n## Instance properties\n\nThese properties are defined on `Symbol.prototype` and shared by all `Symbol` instances.\n\n- {{jsxref("Object/constructor", "Symbol.prototype.constructor")}}\n  - : The constructor function that created the instance object. For `Symbol` instances, the initial value is the {{jsxref("Symbol/Symbol", "Symbol")}} constructor.\n- {{jsxref("Symbol.prototype.description")}}\n  - : A read-only string containing the description of the Symbol.\n- `Symbol.prototype[@@toStringTag]`\n  - : The initial value of the [`@@toStringTag`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol/toStringTag) property is the string `"Symbol"`. This property is used in {{jsxref("Object.prototype.toString()")}}. However, because `Symbol` also has its own [`toString()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol/toString) method, this property is not used unless you call [`Object.prototype.toString.call()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/call) with a symbol as `thisArg`.\n\n## Instance methods\n\n- {{jsxref("Symbol.prototype.toString()")}}\n  - : Returns a string containing the description of the Symbol. Overrides the {{jsxref("Object.prototype.toString()")}} method.\n- {{jsxref("Symbol.prototype.valueOf()")}}\n  - : Returns the Symbol. Overrides the {{jsxref("Object.prototype.valueOf()")}} method.\n- [`Symbol.prototype[@@toPrimitive]()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol/@@toPrimitive)\n  - : Returns the Symbol.\n\n## Examples\n\n### Using the typeof operator with Symbols\n\nThe {{jsxref("Operators/typeof", "typeof")}} operator can help you to identify Symbols.\n\n```js\ntypeof Symbol() === "symbol";\ntypeof Symbol("foo") === "symbol";\ntypeof Symbol.iterator === "symbol";\n```\n\n### Symbol type conversions\n\nSome things to note when working with type conversion of Symbols.\n\n- When trying to convert a Symbol to a number, a {{jsxref("TypeError")}} will be thrown\n  (e.g. `+sym` or `sym | 0`).\n- When using loose equality, `Object(sym) == sym` returns `true`.\n- `Symbol("foo") + "bar"` throws a {{jsxref("TypeError")}} (can\'t convert Symbol to string). This prevents you from silently creating a new string property name from a Symbol, for example.\n- The ["safer" `String(sym)` conversion](/en-US/docs/Web/JavaScript/Reference/Global_Objects/String#string_conversion) works like a call to {{jsxref("Symbol.prototype.toString()")}} with Symbols, but note that `new String(sym)` will throw.\n\n### Symbols and for...in iteration\n\nSymbols are not enumerable in [`for...in`](/en-US/docs/Web/JavaScript/Reference/Statements/for...in) iterations. In addition, {{jsxref("Object.getOwnPropertyNames()")}} will not return Symbol object properties, however, you can use {{jsxref("Object.getOwnPropertySymbols()")}} to get these.\n\n```js\nconst obj = {};\n\nobj[Symbol("a")] = "a";\nobj[Symbol.for("b")] = "b";\nobj["c"] = "c";\nobj.d = "d";\n\nfor (const i in obj) {\n  console.log(i);\n}\n// "c" "d"\n```\n\n### Symbols and JSON.stringify()\n\nSymbol-keyed properties will be completely ignored when using `JSON.stringify()`:\n\n```js\nJSON.stringify({ [Symbol("foo")]: "foo" });\n// \'{}\'\n```\n\nFor more details, see {{jsxref("JSON.stringify()")}}.\n\n### Symbol wrapper objects as property keys\n\nWhen a Symbol wrapper object is used as a property key, this object will be coerced to its wrapped Symbol:\n\n```js\nconst sym = Symbol("foo");\nconst obj = { [sym]: 1 };\nobj[sym]; // 1\nobj[Object(sym)]; // still 1\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Symbol` in `core-js`](https://github.com/zloirock/core-js#ecmascript-symbol)\n- {{jsxref("Operators/typeof", "typeof")}}\n- [JavaScript data types and data structures](/en-US/docs/Web/JavaScript/Data_structures)\n- [ES6 In Depth: Symbols](https://hacks.mozilla.org/2015/06/es6-in-depth-symbols/) on hacks.mozilla.org (2015)\n',
        "isconcatspreadable": {
            "index.md": '---\ntitle: Symbol.isConcatSpreadable\nslug: Web/JavaScript/Reference/Global_Objects/Symbol/isConcatSpreadable\npage-type: javascript-static-data-property\nbrowser-compat: javascript.builtins.Symbol.isConcatSpreadable\n---\n\n{{JSRef}}\n\nThe **`Symbol.isConcatSpreadable`** static data property represents the [well-known symbol](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#well-known_symbols) `@@isConcatSpreadable`. The {{jsxref("Array.prototype.concat()")}} method looks up this symbol on each object being concatenated to determine if it should be treated as an array-like object and flattened to its array elements.\n\n{{EmbedInteractiveExample("pages/js/symbol-isconcatspreadable.html")}}\n\n## Value\n\nThe well-known symbol `@@isConcatSpreadable`.\n\n{{js_property_attributes(0, 0, 0)}}\n\n## Description\n\nThe `@@isConcatSpreadable` symbol (`Symbol.isConcatSpreadable`) can be defined as an own or inherited property and its value is a boolean. It can control behavior for arrays and array-like objects:\n\n- For array objects, the default behavior is to spread (flatten) elements. `Symbol.isConcatSpreadable` can avoid flattening in these cases.\n- For array-like objects, the default behavior is no spreading or flattening. `Symbol.isConcatSpreadable` can force flattening in these cases.\n\n## Examples\n\n### Arrays\n\nBy default, {{jsxref("Array.prototype.concat()")}} spreads (flattens) arrays into its result:\n\n```js\nconst alpha = ["a", "b", "c"];\nconst numeric = [1, 2, 3];\n\nconst alphaNumeric = alpha.concat(numeric);\n\nconsole.log(alphaNumeric); // Result: [\'a\', \'b\', \'c\', 1, 2, 3]\n```\n\nWhen setting `Symbol.isConcatSpreadable` to `false`, you can disable the default behavior:\n\n```js\nconst alpha = ["a", "b", "c"];\nconst numeric = [1, 2, 3];\n\nnumeric[Symbol.isConcatSpreadable] = false;\nconst alphaNumeric = alpha.concat(numeric);\n\nconsole.log(alphaNumeric); // Result: [\'a\', \'b\', \'c\', [1, 2, 3] ]\n```\n\n### Array-like objects\n\nFor array-like objects, the default is to not spread. `Symbol.isConcatSpreadable` needs to be set to `true` in order to get a flattened array:\n\n```js\nconst x = [1, 2, 3];\n\nconst fakeArray = {\n  [Symbol.isConcatSpreadable]: true,\n  length: 2,\n  0: "hello",\n  1: "world",\n};\n\nx.concat(fakeArray); // [1, 2, 3, "hello", "world"]\n```\n\n> **Note:** The `length` property is used to control the number of object properties to be added. In the above example, `length:2` indicates two properties has to be added.\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Symbol.isConcatSpreadable` in `core-js`](https://github.com/zloirock/core-js#ecmascript-symbol)\n- {{jsxref("Array.prototype.concat()")}}\n'
        },
        "iterator": {
            "index.md": '---\ntitle: Symbol.iterator\nslug: Web/JavaScript/Reference/Global_Objects/Symbol/iterator\npage-type: javascript-static-data-property\nbrowser-compat: javascript.builtins.Symbol.iterator\n---\n\n{{JSRef}}\n\nThe **`Symbol.iterator`** static data property represents the [well-known symbol](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#well-known_symbols) `@@iterator`. The [iterable protocol](/en-US/docs/Web/JavaScript/Reference/Iteration_protocols#the_iterable_protocol) looks up this symbol for the method that returns the iterator for an object. In order for an object to be iterable, it must have an `@@iterator` key.\n\n{{EmbedInteractiveExample("pages/js/symbol-iterator.html")}}\n\n## Value\n\nThe well-known symbol `@@iterator`.\n\n{{js_property_attributes(0, 0, 0)}}\n\n## Description\n\nWhenever an object needs to be iterated (such as at the beginning of a `for...of` loop), its `@@iterator` method is called with no arguments, and the returned **iterator** is used to obtain the values to be iterated.\n\nSome built-in types have a default iteration behavior, while other types (such as {{jsxref("Object")}}) do not. Some built-in types with a `@@iterator` method are:\n\n- [`Array.prototype[@@iterator]()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/@@iterator)\n- [`TypedArray.prototype[@@iterator]()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/TypedArray/@@iterator)\n- [`String.prototype[@@iterator]()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/@@iterator)\n- [`Map.prototype[@@iterator]()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map/@@iterator)\n- [`Set.prototype[@@iterator]()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Set/@@iterator)\n\nSee also [Iteration protocols](/en-US/docs/Web/JavaScript/Reference/Iteration_protocols) for more information.\n\n## Examples\n\n### User-defined iterables\n\nWe can make our own iterables like this:\n\n```js\nconst myIterable = {};\nmyIterable[Symbol.iterator] = function* () {\n  yield 1;\n  yield 2;\n  yield 3;\n};\n[...myIterable]; // [1, 2, 3]\n```\n\nOr iterables can be defined directly inside a class or object using a [computed property](/en-US/docs/Web/JavaScript/Reference/Operators/Object_initializer#computed_property_names):\n\n```js\nclass Foo {\n  *[Symbol.iterator]() {\n    yield 1;\n    yield 2;\n    yield 3;\n  }\n}\n\nconst someObj = {\n  *[Symbol.iterator]() {\n    yield "a";\n    yield "b";\n  },\n};\n\nconsole.log(...new Foo()); // 1, 2, 3\nconsole.log(...someObj); // \'a\', \'b\'\n```\n\n### Non-well-formed iterables\n\nIf an iterable\'s `@@iterator` method does not return an iterator object, then it is a non-well-formed iterable. Using it as such is likely to result in runtime exceptions or buggy behavior:\n\n```js example-bad\nconst nonWellFormedIterable = {};\nnonWellFormedIterable[Symbol.iterator] = () => 1;\n[...nonWellFormedIterable]; // TypeError: [Symbol.iterator]() returned a non-object value\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Symbol.iterator` in `core-js`](https://github.com/zloirock/core-js#ecmascript-symbol)\n- [Iteration protocols](/en-US/docs/Web/JavaScript/Reference/Iteration_protocols)\n- [`Array.prototype[@@iterator]()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/@@iterator)\n- [`TypedArray.prototype[@@iterator]()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/TypedArray/@@iterator)\n- [`String.prototype[@@iterator]()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/@@iterator)\n- [`Map.prototype[@@iterator]()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map/@@iterator)\n- [`Set.prototype[@@iterator]()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Set/@@iterator)\n- [`arguments[@@iterator]()`](/en-US/docs/Web/JavaScript/Reference/Functions/arguments/@@iterator)\n- [`Segments.prototype[@@iterator]()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Segmenter/segment/Segments/@@iterator)\n'
        },
        "keyfor": {
            "index.md": '---\ntitle: Symbol.keyFor()\nslug: Web/JavaScript/Reference/Global_Objects/Symbol/keyFor\npage-type: javascript-static-method\nbrowser-compat: javascript.builtins.Symbol.keyFor\n---\n\n{{JSRef}}\n\nThe **`Symbol.keyFor()`** static method retrieves a shared symbol\nkey from the global symbol registry for the given symbol.\n\n{{EmbedInteractiveExample("pages/js/symbol-keyfor.html")}}\n\n## Syntax\n\n```js-nolint\nSymbol.keyFor(sym)\n```\n\n### Parameters\n\n- `sym`\n  - : Symbol, required. The symbol to find a key for.\n\n### Return value\n\nA string representing the key for the given symbol if one is found on the [global registry](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#shared_symbols_in_the_global_symbol_registry); otherwise, {{jsxref("undefined")}}.\n\n## Examples\n\n### Using keyFor()\n\n```js\nconst globalSym = Symbol.for("foo"); // create a new global symbol\nSymbol.keyFor(globalSym); // "foo"\n\nconst localSym = Symbol();\nSymbol.keyFor(localSym); // undefined\n\n// well-known symbols are not symbols registered\n// in the global symbol registry\nSymbol.keyFor(Symbol.iterator); // undefined\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Symbol.for()")}}\n'
        },
        "match": {
            "index.md": '---\ntitle: Symbol.match\nslug: Web/JavaScript/Reference/Global_Objects/Symbol/match\npage-type: javascript-static-data-property\nbrowser-compat: javascript.builtins.Symbol.match\n---\n\n{{JSRef}}\n\nThe **`Symbol.match`** static data property represents the [well-known symbol](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#well-known_symbols) `@@match`. The {{jsxref("String.prototype.match()")}} method looks up this symbol on its first argument for the method used to match an input string against the current object. This symbol is also used to determine if an object should be [treated as a regex](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp#special_handling_for_regexes).\n\nFor more information, see [`RegExp.prototype[@@match]()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/@@match) and {{jsxref("String.prototype.match()")}}.\n\n{{EmbedInteractiveExample("pages/js/symbol-match.html", "taller")}}\n\n## Value\n\nThe well-known symbol `@@match`.\n\n{{js_property_attributes(0, 0, 0)}}\n\n## Description\n\nThis function is also used to identify [if objects have the behavior of regular expressions](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp#special_handling_for_regexes). For example, the methods {{jsxref("String.prototype.startsWith()")}}, {{jsxref("String.prototype.endsWith()")}} and {{jsxref("String.prototype.includes()")}}, check if their first argument is a regular expression and will throw a {{jsxref("TypeError")}} if they are. Now, if the `match` symbol is set to `false` (or a [Falsy](/en-US/docs/Glossary/Falsy) value except `undefined`), it indicates that the object is not intended to be used as a regular expression object.\n\n## Examples\n\n### Marking a RegExp as not a regex\n\nThe following code will throw a {{jsxref("TypeError")}}:\n\n```js\n"/bar/".startsWith(/bar/);\n\n// Throws TypeError, as /bar/ is a regular expression\n// and Symbol.match is not modified.\n```\n\nHowever, if you set `Symbol.match` to `false`, the object will be considered as [not a regular expression object](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp#special_handling_for_regexes). The methods `startsWith` and `endsWith` won\'t throw a `TypeError` as a consequence.\n\n```js\nconst re = /foo/;\nre[Symbol.match] = false;\n"/foo/".startsWith(re); // true\n"/baz/".endsWith(re); // false\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Symbol.match` in `core-js`](https://github.com/zloirock/core-js#ecmascript-symbol)\n- {{jsxref("Symbol.matchAll")}}\n- {{jsxref("Symbol.replace")}}\n- {{jsxref("Symbol.search")}}\n- {{jsxref("Symbol.split")}}\n- {{jsxref("String.prototype.match()")}}\n- [`RegExp.prototype[@@match]()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/@@match)\n'
        },
        "matchall": {
            "index.md": '---\ntitle: Symbol.matchAll\nslug: Web/JavaScript/Reference/Global_Objects/Symbol/matchAll\npage-type: javascript-static-data-property\nbrowser-compat: javascript.builtins.Symbol.matchAll\n---\n\n{{JSRef}}\n\nThe **`Symbol.matchAll`** static data property represents the [well-known symbol](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#well-known_symbols) `@@matchAll`. The {{jsxref("String.prototype.matchAll()")}} method looks up this symbol on its first argument for the method that returns an iterator, that yields matches of the current object against a string.\n\nFor more information, see [`RegExp.prototype[@@matchAll]()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/@@matchAll) and {{jsxref("String.prototype.matchAll()")}}.\n\n{{EmbedInteractiveExample("pages/js/symbol-matchall.html")}}\n\n## Value\n\nThe well-known symbol `@@matchAll`.\n\n{{js_property_attributes(0, 0, 0)}}\n\n## Examples\n\n### Using Symbol.matchAll\n\n```js\nconst str = "2016-01-02|2019-03-07";\n\nconst numbers = {\n  *[Symbol.matchAll](str) {\n    for (const n of str.matchAll(/[0-9]+/g)) yield n[0];\n  },\n};\n\nconsole.log(Array.from(str.matchAll(numbers)));\n// ["2016", "01", "02", "2019", "03", "07"]\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Symbol.matchAll` in `core-js`](https://github.com/zloirock/core-js#ecmascript-symbol)\n- {{jsxref("Symbol.match")}}\n- {{jsxref("Symbol.replace")}}\n- {{jsxref("Symbol.search")}}\n- {{jsxref("Symbol.split")}}\n- {{jsxref("String.prototype.matchAll()")}}\n- [`RegExp.prototype[@@matchAll]()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/@@matchAll)\n'
        },
        "replace": {
            "index.md": '---\ntitle: Symbol.replace\nslug: Web/JavaScript/Reference/Global_Objects/Symbol/replace\npage-type: javascript-static-data-property\nbrowser-compat: javascript.builtins.Symbol.replace\n---\n\n{{JSRef}}\n\nThe **`Symbol.replace`** static data property represents the [well-known symbol](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#well-known_symbols) `@@replace`. The {{jsxref("String.prototype.replace()")}} method looks up this symbol on its first argument for the method that replaces substrings matched by the current object.\n\nFor more information, see [`RegExp.prototype[@@replace]()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/@@replace) and {{jsxref("String.prototype.replace()")}}.\n\n{{EmbedInteractiveExample("pages/js/symbol-replace.html")}}\n\n## Value\n\nThe well-known symbol `@@replace`.\n\n{{js_property_attributes(0, 0, 0)}}\n\n## Examples\n\n### Using Symbol.replace\n\n```js\nclass CustomReplacer {\n  constructor(value) {\n    this.value = value;\n  }\n  [Symbol.replace](string) {\n    return string.replace(this.value, "#!@?");\n  }\n}\n\nconsole.log("football".replace(new CustomReplacer("foo"))); // "#!@?tball"\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Symbol.replace` in `core-js`](https://github.com/zloirock/core-js#ecmascript-symbol)\n- {{jsxref("Symbol.match")}}\n- {{jsxref("Symbol.matchAll")}}\n- {{jsxref("Symbol.search")}}\n- {{jsxref("Symbol.split")}}\n- {{jsxref("String.prototype.replace()")}}\n- [`RegExp.prototype[@@replace]()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/@@replace)\n'
        },
        "search": {
            "index.md": '---\ntitle: Symbol.search\nslug: Web/JavaScript/Reference/Global_Objects/Symbol/search\npage-type: javascript-static-data-property\nbrowser-compat: javascript.builtins.Symbol.search\n---\n\n{{JSRef}}\n\nThe **`Symbol.search`** static data property represents the [well-known symbol](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#well-known_symbols) `@@search`. The {{jsxref("String.prototype.search()")}} method looks up this symbol on its first argument for the method that returns the index within a string that matches the current object.\n\nFor more information, see [`RegExp.prototype[@@search]()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/@@search) and {{jsxref("String.prototype.search()")}}.\n\n{{EmbedInteractiveExample("pages/js/symbol-search.html")}}\n\n## Value\n\nThe well-known symbol `@@search`.\n\n{{js_property_attributes(0, 0, 0)}}\n\n## Examples\n\n### Custom string search\n\n```js\nclass caseInsensitiveSearch {\n  constructor(value) {\n    this.value = value.toLowerCase();\n  }\n  [Symbol.search](string) {\n    return string.toLowerCase().indexOf(this.value);\n  }\n}\n\nconsole.log("foobar".search(new caseInsensitiveSearch("BaR"))); // 3\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Symbol.search` in `core-js`](https://github.com/zloirock/core-js#ecmascript-symbol)\n- {{jsxref("Symbol.match")}}\n- {{jsxref("Symbol.matchAll")}}\n- {{jsxref("Symbol.replace")}}\n- {{jsxref("Symbol.split")}}\n- {{jsxref("String.prototype.search()")}}\n- [`RegExp.prototype[@@search]()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/@@search)\n'
        },
        "species": {
            "index.md": '---\ntitle: Symbol.species\nslug: Web/JavaScript/Reference/Global_Objects/Symbol/species\npage-type: javascript-static-data-property\nbrowser-compat: javascript.builtins.Symbol.species\n---\n\n{{JSRef}}\n\nThe **`Symbol.species`** static data property represents the [well-known symbol](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#well-known_symbols) `@@species`. Methods that create copies of an object may look up this symbol on the object for the constructor function to use when creating the copy.\n\n> **Warning:** The existence of `@@species` allows execution of arbitrary code and may create security vulnerabilities. It also makes certain optimizations much harder. Engine implementers are [investigating whether to remove this feature](https://github.com/tc39/proposal-rm-builtin-subclassing). Avoid relying on it if possible.\n\n{{EmbedInteractiveExample("pages/js/symbol-species.html")}}\n\n## Value\n\nThe well-known symbol `@@species`.\n\n{{js_property_attributes(0, 0, 0)}}\n\n## Description\n\nThe `@@species` accessor property allows subclasses to override the default constructor for objects. This specifies a protocol about how instances should be copied. For example, when you use copying methods of arrays, such as {{jsxref("Array/map", "map()")}}. the `map()` method uses `instance.constructor[Symbol.species]` to get the constructor for constructing the new array. For more information, see [subclassing built-ins](/en-US/docs/Web/JavaScript/Reference/Classes/extends#subclassing_built-ins).\n\nAll built-in implementations of `@@species` return the `this` value, which is the current instance\'s constructor. This allows copying methods to create instances of derived classes rather than the base class \u2014 for example, `map()` will return an array of the same type as the original array.\n\n## Examples\n\n### Using species\n\nYou might want to return {{jsxref("Array")}} objects in your derived array class `MyArray`. For example, when using methods such as {{jsxref("Array/map", "map()")}} that return the default constructor, you want these methods to return a parent `Array` object, instead of the `MyArray` object. The `species` symbol lets you do this:\n\n```js\nclass MyArray extends Array {\n  // Overwrite species to the parent Array constructor\n  static get [Symbol.species]() {\n    return Array;\n  }\n}\nconst a = new MyArray(1, 2, 3);\nconst mapped = a.map((x) => x * x);\n\nconsole.log(mapped instanceof MyArray); // false\nconsole.log(mapped instanceof Array); // true\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Array/@@species", "Array[@@species]")}}\n- {{jsxref("ArrayBuffer/@@species", "ArrayBuffer[@@species]")}}\n- {{jsxref("Map/@@species", "Map[@@species]")}}\n- {{jsxref("Promise/@@species", "Promise[@@species]")}}\n- {{jsxref("RegExp/@@species", "RegExp[@@species]")}}\n- {{jsxref("Set/@@species", "Set[@@species]")}}\n- {{jsxref("TypedArray/@@species", "TypedArray[@@species]")}}\n'
        },
        "split": {
            "index.md": '---\ntitle: Symbol.split\nslug: Web/JavaScript/Reference/Global_Objects/Symbol/split\npage-type: javascript-static-data-property\nbrowser-compat: javascript.builtins.Symbol.split\n---\n\n{{JSRef}}\n\nThe **`Symbol.split`** static data property represents the [well-known symbol](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#well-known_symbols) `@@split`. The {{jsxref("String.prototype.split()")}} method looks up this symbol on its first argument for the method that splits a string at the indices that match the current object.\n\nFor more information, see[`RegExp.prototype[@@split]()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/@@split) and {{jsxref("String.prototype.split()")}}.\n\n{{EmbedInteractiveExample("pages/js/symbol-split.html", "taller")}}\n\n## Value\n\nThe well-known symbol `@@split`.\n\n{{js_property_attributes(0, 0, 0)}}\n\n## Examples\n\n### Custom reverse split\n\n```js\nclass ReverseSplit {\n  [Symbol.split](string) {\n    const array = string.split(" ");\n    return array.reverse();\n  }\n}\n\nconsole.log("Another one bites the dust".split(new ReverseSplit()));\n// [ "dust", "the", "bites", "one", "Another" ]\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Symbol.split` in `core-js`](https://github.com/zloirock/core-js#ecmascript-symbol)\n- {{jsxref("Symbol.match")}}\n- {{jsxref("Symbol.matchAll")}}\n- {{jsxref("Symbol.replace")}}\n- {{jsxref("Symbol.search")}}\n- {{jsxref("String.prototype.split()")}}\n- [`RegExp.prototype[@@split]()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/@@split)\n'
        },
        "symbol": {
            "index.md": '---\ntitle: Symbol() constructor\nslug: Web/JavaScript/Reference/Global_Objects/Symbol/Symbol\npage-type: javascript-constructor\nbrowser-compat: javascript.builtins.Symbol.Symbol\n---\n\n{{JSRef}}\n\nThe **`Symbol()`** function returns primitive values of type Symbol.\n\n{{EmbedInteractiveExample("pages/js/symbol-constructor.html", "taller")}}\n\n## Syntax\n\n```js-nolint\nSymbol()\nSymbol(description)\n```\n\n> **Note:** `Symbol()` can only be called without [`new`](/en-US/docs/Web/JavaScript/Reference/Operators/new). Attempting to construct it with `new` throws a {{jsxref("TypeError")}}.\n\n### Parameters\n\n- `description` {{optional_inline}}\n  - : A string. A description of the symbol which can be used for debugging but not to\n    access the symbol itself.\n\n## Examples\n\n### Creating symbols\n\nTo create a new primitive symbol, you write `Symbol()` with an optional\nstring as its description:\n\n```js\nconst sym1 = Symbol();\nconst sym2 = Symbol("foo");\nconst sym3 = Symbol("foo");\n```\n\nThe above code creates three new symbols. Note that `Symbol("foo")` does not\ncoerce the string `"foo"` into a symbol. It creates a new symbol each time:\n\n```js\nSymbol("foo") === Symbol("foo"); // false\n```\n\n### new Symbol()\n\nThe following syntax with the {{jsxref("Operators/new", "new")}} operator will throw a\n{{jsxref("TypeError")}}:\n\n```js example-bad\nconst sym = new Symbol(); // TypeError\n```\n\nThis prevents authors from creating an explicit `Symbol` wrapper object\ninstead of a new symbol value and might be surprising as creating explicit wrapper\nobjects around primitive data types is generally possible (for example,\n`new Boolean`, `new String` and `new Number`).\n\nIf you really want to create a `Symbol` wrapper object, you can use the\n`Object()` function:\n\n```js\nconst sym = Symbol("foo");\nconst symObj = Object(sym);\ntypeof sym; // "symbol"\ntypeof symObj; // "object"\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Symbol` in `core-js`](https://github.com/zloirock/core-js#ecmascript-symbol)\n'
        },
        "toprimitive": {
            "index.md": '---\ntitle: Symbol.toPrimitive\nslug: Web/JavaScript/Reference/Global_Objects/Symbol/toPrimitive\npage-type: javascript-static-data-property\nbrowser-compat: javascript.builtins.Symbol.toPrimitive\n---\n\n{{JSRef}}\n\nThe **`Symbol.toPrimitive`** static data property represents the [well-known symbol](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#well-known_symbols) `@@toPrimitive`. All [type coercion](/en-US/docs/Web/JavaScript/Data_structures#type_coercion) algorithms look up this symbol on objects for the method that accepts a preferred type and returns a primitive representation of the object, before falling back to using the object\'s `valueOf()` and `toString()` methods.\n\n{{EmbedInteractiveExample("pages/js/symbol-toprimitive.html")}}\n\n## Value\n\nThe well-known symbol `@@toPrimitive`.\n\n{{js_property_attributes(0, 0, 0)}}\n\n## Description\n\nWith the help of the `Symbol.toPrimitive` property (used as a function value), an object can be converted to a primitive value. The function is called with a string argument `hint`, which specifies the preferred type of the result primitive value. The `hint` argument can be one of `"number"`, `"string"`, and `"default"`.\n\nThe `"number"` hint is used by [numeric coercion](/en-US/docs/Web/JavaScript/Data_structures#numeric_coercion) algorithms. The `"string"` hint is used by the [string coercion](/en-US/docs/Web/JavaScript/Reference/Global_Objects/String#string_coercion) algorithm. The `"default"` hint is used by the [primitive coercion](/en-US/docs/Web/JavaScript/Data_structures#primitive_coercion) algorithm. The `hint` only acts as a weak signal of preference, and the implementation is free to ignore it (as [`Symbol.prototype[@@toPrimitive]()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol/@@toPrimitive) does). The language does not enforce alignment between the `hint` and the result type, although `[@@toPrimitive]()` must return a primitive, or a {{jsxref("TypeError")}} is thrown.\n\nObjects without the `@@toPrimitive` property are converted to primitives by calling the `valueOf()` and `toString()` methods in different orders, which is explained in more detail in the [type coercion](/en-US/docs/Web/JavaScript/Data_structures#type_coercion) section. `@@toPrimitive` allows full control over the primitive conversion process. For example, [`Date.prototype[@@toPrimitive]`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/@@toPrimitive) treats `"default"` as if it\'s `"string"` and calls `toString()` instead of `valueOf()`. [`Symbol.prototype[@@toPrimitive]`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol/@@toPrimitive) ignores the hint and always returns a symbol, which means even in string contexts, {{jsxref("Symbol.prototype.toString()")}} won\'t be called, and `Symbol` objects must always be explicitly converted to strings through [`String()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/String).\n\n## Examples\n\n### Modifying primitive values converted from an object\n\nFollowing example describes how `Symbol.toPrimitive` property can modify the primitive value converted from an object.\n\n```js\n// An object without Symbol.toPrimitive property.\nconst obj1 = {};\nconsole.log(+obj1); // NaN\nconsole.log(`${obj1}`); // "[object Object]"\nconsole.log(obj1 + ""); // "[object Object]"\n\n// An object with Symbol.toPrimitive property.\nconst obj2 = {\n  [Symbol.toPrimitive](hint) {\n    if (hint === "number") {\n      return 10;\n    }\n    if (hint === "string") {\n      return "hello";\n    }\n    return true;\n  },\n};\nconsole.log(+obj2); // 10        \u2014 hint is "number"\nconsole.log(`${obj2}`); // "hello"   \u2014 hint is "string"\nconsole.log(obj2 + ""); // "true"    \u2014 hint is "default"\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Symbol.toPrimitive` in `core-js`](https://github.com/zloirock/core-js#ecmascript-symbol)\n- [`Date.prototype[@@toPrimitive]()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/@@toPrimitive)\n- [`Symbol.prototype[@@toPrimitive]()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol/@@toPrimitive)\n- {{jsxref("Object.prototype.toString()")}}\n- {{jsxref("Object.prototype.valueOf()")}}\n'
        },
        "tostring": {
            "index.md": '---\ntitle: Symbol.prototype.toString()\nslug: Web/JavaScript/Reference/Global_Objects/Symbol/toString\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Symbol.toString\n---\n\n{{JSRef}}\n\nThe **`toString()`** method of {{jsxref("Symbol")}} values returns a string representing this symbol value.\n\n{{EmbedInteractiveExample("pages/js/symbol-prototype-tostring.html")}}\n\n## Syntax\n\n```js-nolint\ntoString()\n```\n\n### Parameters\n\nNone.\n\n### Return value\n\nA string representing the specified symbol value.\n\n## Description\n\nThe {{jsxref("Symbol")}} object overrides the `toString` method of {{jsxref("Object")}}; it does not inherit\n{{jsxref("Object.prototype.toString()")}}. For `Symbol` values, the `toString` method returns a descriptive string in the form `"Symbol(description)"`, where `description` is the symbol\'s [description](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol/description).\n\nThe `toString()` method requires its `this` value to be a `Symbol` primitive or wrapper object. It throws a {{jsxref("TypeError")}} for other `this` values without attempting to coerce them to symbol values.\n\nBecause `Symbol` has a [`[@@toPrimitive]()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol/@@toPrimitive) method, that method always takes priority over `toString()` when a `Symbol` object is [coerced to a string](/en-US/docs/Web/JavaScript/Reference/Global_Objects/String#string_coercion). However, because `Symbol.prototype[@@toPrimitive]()` returns a symbol primitive, and symbol primitives throw a {{jsxref("TypeError")}} when implicitly converted to a string, the `toString()` method is never implicitly called by the language. To stringify a symbol, you must explicitly call its `toString()` method or use the [`String()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/String#using_string_to_stringify_a_symbol) function.\n\n## Examples\n\n### Using toString()\n\n```js\nSymbol("desc").toString(); // "Symbol(desc)"\n\n// well-known symbols\nSymbol.iterator.toString(); // "Symbol(Symbol.iterator)"\n\n// global symbols\nSymbol.for("foo").toString(); // "Symbol(foo)"\n```\n\n### Implicitly calling toString()\n\nThe only way to make JavaScript implicitly call `toString()` instead of [`[@@toPrimitive]()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol/@@toPrimitive) on a symbol wrapper object is by [deleting](/en-US/docs/Web/JavaScript/Reference/Operators/delete) the `@@toPrimitive` method first.\n\n> **Warning:** You should not do this in practice. Never mutate built-in objects unless you know exactly what you\'re doing.\n\n```js\ndelete Symbol.prototype[Symbol.toPrimitive];\nconsole.log(`${Object(Symbol("foo"))}`); // "Symbol(foo)"\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Object.prototype.toString()")}}\n'
        },
        "tostringtag": {
            "index.md": '---\ntitle: Symbol.toStringTag\nslug: Web/JavaScript/Reference/Global_Objects/Symbol/toStringTag\npage-type: javascript-static-data-property\nbrowser-compat: javascript.builtins.Symbol.toStringTag\n---\n\n{{JSRef}}\n\nThe **`Symbol.toStringTag`** static data property represents the [well-known symbol](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#well-known_symbols) `@@toStringTag`. {{jsxref("Object.prototype.toString()")}} looks up this symbol on the `this` value for the property containing a string that represents the type of the object.\n\n{{EmbedInteractiveExample("pages/js/symbol-tostringtag.html")}}\n\n## Value\n\nThe well-known symbol `@@toStringTag`.\n\n{{js_property_attributes(0, 0, 0)}}\n\n## Examples\n\n### Default tags\n\nSome values do not have `Symbol.toStringTag`, but have special `toString()` representations. For a complete list, see {{jsxref("Object.prototype.toString()")}}.\n\n```js\nObject.prototype.toString.call("foo"); // "[object String]"\nObject.prototype.toString.call([1, 2]); // "[object Array]"\nObject.prototype.toString.call(3); // "[object Number]"\nObject.prototype.toString.call(true); // "[object Boolean]"\nObject.prototype.toString.call(undefined); // "[object Undefined]"\nObject.prototype.toString.call(null); // "[object Null]"\n// ... and more\n```\n\n### Built-in toStringTag symbols\n\nMost built-in objects provide their own `@@toStringTag` property. Almost all built-in objects\' `@@toStringTag` property is not writable, not enumerable, and configurable; the exception is {{jsxref("Iterator")}}, which is writable for compatibility reasons.\n\nFor constructor objects like {{jsxref("Promise")}}, the property is installed on `Constructor.prototype`, so that all instances of the constructor inherit `@@toStringTag` and can be stringified. For non-constructor objects like {{jsxref("Math")}} and {{jsxref("JSON")}}, the property is installed as a static property, so that the namespace object itself can be stringified. Sometimes, the constructor also provides its own `toString` method (for example, {{jsxref("Intl.Locale")}}), in which case the `@@toStringTag` property is only used when you explicitly call `Object.prototype.toString` on it.\n\n```js\nObject.prototype.toString.call(new Map()); // "[object Map]"\nObject.prototype.toString.call(function* () {}); // "[object GeneratorFunction]"\nObject.prototype.toString.call(Promise.resolve()); // "[object Promise]"\n// ... and more\n```\n\n### Custom tag with toStringTag\n\nWhen creating your own class, JavaScript defaults to the "Object" tag:\n\n```js\nclass ValidatorClass {}\n\nObject.prototype.toString.call(new ValidatorClass()); // "[object Object]"\n```\n\nNow, with the help of `toStringTag`, you are able to set your own custom tag:\n\n```js\nclass ValidatorClass {\n  get [Symbol.toStringTag]() {\n    return "Validator";\n  }\n}\n\nObject.prototype.toString.call(new ValidatorClass()); // "[object Validator]"\n```\n\n### toStringTag available on all DOM prototype objects\n\nDue to a [WebIDL spec change](https://github.com/whatwg/webidl/pull/357) in mid-2020, browsers are adding a `Symbol.toStringTag` property to all DOM prototype objects. For example, to access the `Symbol.toStringTag` property on {{domxref("HTMLButtonElement")}}:\n\n```js\nconst test = document.createElement("button");\ntest.toString(); // "[object HTMLButtonElement]"\ntest[Symbol.toStringTag]; // "HTMLButtonElement"\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Symbol.toStringTag` in `core-js`](https://github.com/zloirock/core-js#ecmascript-symbol)\n- {{jsxref("Object.prototype.toString()")}}\n'
        },
        "unscopables": {
            "index.md": '---\ntitle: Symbol.unscopables\nslug: Web/JavaScript/Reference/Global_Objects/Symbol/unscopables\npage-type: javascript-static-data-property\nbrowser-compat: javascript.builtins.Symbol.unscopables\n---\n\n{{JSRef}}\n\nThe **`Symbol.unscopables`** static data property represents the [well-known symbol](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#well-known_symbols) `@@unscopables`. The {{jsxref("Statements/with", "with")}} statement looks up this symbol on the scope object for a property containing a collection of properties that should not become bindings within the `with` environment.\n\n{{EmbedInteractiveExample("pages/js/symbol-unscopables.html")}}\n\n## Value\n\nThe well-known symbol `@@unscopables`.\n\n{{js_property_attributes(0, 0, 0)}}\n\n## Description\n\nThe `@@unscopables` symbol (accessed via `Symbol.unscopables`) can be defined on any object to exclude property names from being exposed as lexical variables in [`with`](/en-US/docs/Web/JavaScript/Reference/Statements/with) environment bindings. Note that when using [strict mode](/en-US/docs/Web/JavaScript/Reference/Strict_mode), `with` statements are not available, and this symbol is likely not needed.\n\nSetting a property of the `@@unscopables` object to `true` (or any [truthy](/en-US/docs/Glossary/Truthy) value) will make the corresponding property of the `with` scope object _unscopable_ and therefore won\'t be introduced to the `with` body scope. Setting a property to `false` (or any [falsy](/en-US/docs/Glossary/Falsy) value) will make it _scopable_ and thus appear as lexical scope variables.\n\nWhen deciding whether `x` is unscopable, the entire prototype chain of the `@@unscopables` property is looked up for a property called `x`. This means if you declared `@@unscopables` as a plain object, `Object.prototype` properties like [`toString`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/toString) would become unscopable as well, which may cause backward incompatibility for legacy code assuming those properties are normally scoped (see [an example below](#avoid_using_a_non-null-prototype_object_as_unscopables)). You are advised to make your custom `@@unscopables` property have `null` as its prototype, like [`Array.prototype[@@unscopables]`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/@@unscopables) does.\n\nThis protocol is also utilized by DOM APIs, such as [`Element.prototype.append()`](/en-US/docs/Web/API/Element/append).\n\n## Examples\n\n### Scoping in with statements\n\nThe following code works fine in ES5 and below. However, in ECMAScript 2015 and later, the {{jsxref("Array.prototype.keys()")}} method was introduced. That means that inside a `with` environment, "keys" would now be the method and not the variable. That\'s why the `@@unscopables` symbol was introduced. A built-in `@@unscopables` setting is implemented as {{jsxref("Array/@@unscopables", "Array.prototype[@@unscopables]")}} to prevent some of the Array methods being scoped into the `with` statement.\n\n```js\nvar keys = [];\n\nwith (Array.prototype) {\n  keys.push("something");\n}\n```\n\n### Unscopables in objects\n\nYou can also set `@@unscopables` for your own objects.\n\n```js\nconst obj = {\n  foo: 1,\n  bar: 2,\n  baz: 3,\n};\n\nobj[Symbol.unscopables] = {\n  // Make the object have `null` prototype to prevent\n  // `Object.prototype` methods from being unscopable\n  __proto__: null,\n  // `foo` will be scopable\n  foo: false,\n  // `bar` will be unscopable\n  bar: true,\n  // `baz` is omitted; because `undefined` is falsy, it is also scopable (default)\n};\n\nwith (obj) {\n  console.log(foo); // 1\n  console.log(bar); // ReferenceError: bar is not defined\n  console.log(baz); // 3\n}\n```\n\n### Avoid using a non-null-prototype object as @@unscopables\n\nDeclaring `@@unscopables` as a plain object without eliminating its prototype may cause subtle bugs. Consider the following code working before `@@unscopables`:\n\n```js\nconst character = {\n  name: "Yoda",\n  toString: function () {\n    return "Use with statements, you must not";\n  },\n};\n\nwith (character) {\n  console.log(name + \' says: "\' + toString() + \'"\'); // Yoda says: "Use with statements, you must not"\n}\n```\n\nTo preserve backward compatibility, you decided to add an `@@unscopables` property when adding more properties to `character`. You may na\xefvely do it like:\n\n```js example-bad\nconst character = {\n  name: "Yoda",\n  toString: function () {\n    return "Use with statements, you must not";\n  },\n  student: "Luke",\n  [Symbol.unscopables]: {\n    // Make `student` unscopable\n    student: true,\n  },\n};\n```\n\nHowever, the code above now breaks:\n\n```js\nwith (character) {\n  console.log(name + \' says: "\' + toString() + \'"\'); // Yoda says: "[object Undefined]"\n}\n```\n\nThis is because when looking up `character[Symbol.unscopables].toString`, it returns [`Object.prototype.toString()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/toString), which is a truthy value, thus making the `toString()` call in the `with()` statement reference `globalThis.toString()` instead \u2014 and because it\'s called without a [`this`](/en-US/docs/Web/JavaScript/Reference/Operators/this), `this` is `undefined`, making it return `[object Undefined]`.\n\nEven when the method is not overridden by `character`, making it unscopable will change the value of `this`.\n\n```js\nconst proto = {};\nconst obj = { __proto__: proto };\n\nwith (proto) {\n  console.log(isPrototypeOf(obj)); // true; `isPrototypeOf` is scoped and `this` is `proto`\n}\n\nproto[Symbol.unscopables] = {};\n\nwith (proto) {\n  console.log(isPrototypeOf(obj)); // TypeError: Cannot convert undefined or null to object\n  // `isPrototypeOf` is unscoped and `this` is undefined\n}\n```\n\nTo fix this, always make sure `@@unscopables` only contains properties you wish to be unscopable, without `Object.prototype` properties.\n\n```js example-good\nconst character = {\n  name: "Yoda",\n  toString: function () {\n    return "Use with statements, you must not";\n  },\n  student: "Luke",\n  [Symbol.unscopables]: {\n    // Make the object have `null` prototype to prevent\n    // `Object.prototype` methods from being unscopable\n    __proto__: null,\n    // Make `student` unscopable\n    student: true,\n  },\n};\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Array/@@unscopables", "Array.prototype[@@unscopables]")}}\n- [`with`](/en-US/docs/Web/JavaScript/Reference/Statements/with)\n- [`Element.prototype.append()`](/en-US/docs/Web/API/Element/append)\n'
        },
        "valueof": {
            "index.md": '---\ntitle: Symbol.prototype.valueOf()\nslug: Web/JavaScript/Reference/Global_Objects/Symbol/valueOf\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.Symbol.valueOf\n---\n\n{{JSRef}}\n\nThe **`valueOf()`** method of {{jsxref("Symbol")}} values returns this symbol value.\n\n{{EmbedInteractiveExample("pages/js/symbol-prototype-valueof.html")}}\n\n## Syntax\n\n```js-nolint\nvalueOf()\n```\n\n### Parameters\n\nNone.\n\n### Return value\n\nThe primitive value of the specified {{jsxref("Symbol")}} object.\n\n## Description\n\nThe `valueOf()` method of {{jsxref("Symbol")}} returns the primitive value of a Symbol object as a Symbol data type.\n\nJavaScript calls the `valueOf()` method to convert an object to a primitive value. You rarely need to invoke the `valueOf()` method yourself; JavaScript automatically invokes it when encountering an object where a primitive value is expected.\n\n## Examples\n\n### Using valueOf()\n\n```js\nconst sym = Symbol("example");\nsym === sym.valueOf(); // true\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Object.prototype.valueOf()")}}\n'
        }
    },
    "syntaxerror": {
        "index.md": '---\ntitle: SyntaxError\nslug: Web/JavaScript/Reference/Global_Objects/SyntaxError\npage-type: javascript-class\nbrowser-compat: javascript.builtins.SyntaxError\n---\n\n{{JSRef}}\n\nThe **`SyntaxError`** object represents an error when trying to interpret syntactically invalid code. It is thrown when the JavaScript engine encounters tokens or token order that does not conform to the syntax of the language when parsing code.\n\n`SyntaxError` is a {{Glossary("serializable object")}}, so it can be cloned with {{domxref("structuredClone()")}} or copied between [Workers](/en-US/docs/Web/API/Worker) using {{domxref("Worker/postMessage()", "postMessage()")}}.\n\n`SyntaxError` is a subclass of {{jsxref("Error")}}.\n\n## Constructor\n\n- {{jsxref("SyntaxError/SyntaxError", "SyntaxError()")}}\n  - : Creates a new `SyntaxError` object.\n\n## Instance properties\n\n_Also inherits instance properties from its parent {{jsxref("Error")}}_.\n\nThese properties are defined on `SyntaxError.prototype` and shared by all `SyntaxError` instances.\n\n- {{jsxref("Object/constructor", "SyntaxError.prototype.constructor")}}\n  - : The constructor function that created the instance object. For `SyntaxError` instances, the initial value is the {{jsxref("SyntaxError/SyntaxError", "SyntaxError")}} constructor.\n- {{jsxref("Error/name", "SyntaxError.prototype.name")}}\n  - : Represents the name for the type of error. For `SyntaxError.prototype.name`, the initial value is `"SyntaxError"`.\n\n## Instance methods\n\n_Inherits instance methods from its parent {{jsxref("Error")}}_.\n\n## Examples\n\n### Catching a SyntaxError\n\n```js\ntry {\n  eval("hoo bar");\n} catch (e) {\n  console.log(e instanceof SyntaxError); // true\n  console.log(e.message);\n  console.log(e.name); // "SyntaxError"\n  console.log(e.stack); // Stack of the error\n}\n```\n\n### Creating a SyntaxError\n\n```js\ntry {\n  throw new SyntaxError("Hello");\n} catch (e) {\n  console.log(e instanceof SyntaxError); // true\n  console.log(e.message); // "Hello"\n  console.log(e.name); // "SyntaxError"\n  console.log(e.stack); // Stack of the error\n}\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Error")}}\n',
        "syntaxerror": {
            "index.md": '---\ntitle: SyntaxError() constructor\nslug: Web/JavaScript/Reference/Global_Objects/SyntaxError/SyntaxError\npage-type: javascript-constructor\nbrowser-compat: javascript.builtins.SyntaxError.SyntaxError\n---\n\n{{JSRef}}\n\nThe **`SyntaxError()`** constructor creates {{jsxref("SyntaxError")}} objects.\n\n## Syntax\n\n```js-nolint\nnew SyntaxError()\nnew SyntaxError(message)\nnew SyntaxError(message, options)\nnew SyntaxError(message, fileName)\nnew SyntaxError(message, fileName, lineNumber)\n\nSyntaxError()\nSyntaxError(message)\nSyntaxError(message, options)\nSyntaxError(message, fileName)\nSyntaxError(message, fileName, lineNumber)\n```\n\n> **Note:** `SyntaxError()` can be called with or without [`new`](/en-US/docs/Web/JavaScript/Reference/Operators/new). Both create a new `SyntaxError` instance.\n\n### Parameters\n\n- `message` {{optional_inline}}\n  - : Human-readable description of the error\n- `options` {{optional_inline}}\n  - : An object that has the following properties:\n    - `cause` {{optional_inline}}\n      - : A property indicating the specific cause of the error.\n        When catching and re-throwing an error with a more-specific or useful error message, this property can be used to pass the original error.\n- `fileName` {{optional_inline}} {{non-standard_inline}}\n  - : The name of the file containing the code that caused the exception\n- `lineNumber` {{optional_inline}} {{non-standard_inline}}\n  - : The line number of the code that caused the exception\n\n## Examples\n\n### Catching a SyntaxError\n\n```js\ntry {\n  eval("hoo bar");\n} catch (e) {\n  console.log(e instanceof SyntaxError); // true\n  console.log(e.message);\n  console.log(e.name); // "SyntaxError"\n  console.log(e.stack); // Stack of the error\n}\n```\n\n### Creating a SyntaxError\n\n```js\ntry {\n  throw new SyntaxError("Hello");\n} catch (e) {\n  console.log(e instanceof SyntaxError); // true\n  console.log(e.message); // "Hello"\n  console.log(e.name); // "SyntaxError"\n  console.log(e.stack); // Stack of the error\n}\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Error")}}\n'
        }
    },
    "typedarray": {
        "@@iterator": {
            "index.md": '---\ntitle: TypedArray.prototype[@@iterator]()\nslug: Web/JavaScript/Reference/Global_Objects/TypedArray/@@iterator\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.TypedArray.@@iterator\n---\n\n{{JSRef}}\n\nThe **`[@@iterator]()`** method of {{jsxref("TypedArray")}} instances implements the [iterable protocol](/en-US/docs/Web/JavaScript/Reference/Iteration_protocols) and allows typed arrays to be consumed by most syntaxes expecting iterables, such as the [spread syntax](/en-US/docs/Web/JavaScript/Reference/Operators/Spread_syntax) and {{jsxref("Statements/for...of", "for...of")}} loops. It returns an [array iterator object](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Iterator) that yields the value of each index in the typed array.\n\nThe initial value of this property is the same function object as the initial value of the {{jsxref("TypedArray.prototype.values")}} property.\n\n{{EmbedInteractiveExample("pages/js/typedarray-prototype-@@iterator.html")}}\n\n## Syntax\n\n```js-nolint\ntypedArray[Symbol.iterator]()\n```\n\n### Parameters\n\nNone.\n\n### Return value\n\nThe same return value as {{jsxref("TypedArray.prototype.values()")}}: a new [iterable iterator object](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Iterator) that yields the value of each index in the typed array.\n\n## Examples\n\n### Iteration using for...of loop\n\nNote that you seldom need to call this method directly. The existence of the `@@iterator` method makes typed arrays [iterable](/en-US/docs/Web/JavaScript/Reference/Iteration_protocols#the_iterable_protocol), and iterating syntaxes like the `for...of` loop automatically call this method to obtain the iterator to loop over.\n\n```js\nconst arr = new Uint8Array([10, 20, 30, 40, 50]);\nfor (const n of arr) {\n  console.log(n);\n}\n```\n\n### Manually hand-rolling the iterator\n\nYou may still manually call the `next()` method of the returned iterator object to achieve maximum control over the iteration process.\n\n```js\nconst arr = new Uint8Array([10, 20, 30, 40, 50]);\nconst arrIter = arr[Symbol.iterator]();\nconsole.log(arrIter.next().value); // 10\nconsole.log(arrIter.next().value); // 20\nconsole.log(arrIter.next().value); // 30\nconsole.log(arrIter.next().value); // 40\nconsole.log(arrIter.next().value); // 50\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `TypedArray.prototype[@@iterator]` in `core-js`](https://github.com/zloirock/core-js#ecmascript-typed-arrays)\n- [JavaScript typed arrays](/en-US/docs/Web/JavaScript/Guide/Typed_arrays) guide\n- {{jsxref("TypedArray")}}\n- {{jsxref("TypedArray.prototype.entries()")}}\n- {{jsxref("TypedArray.prototype.keys()")}}\n- {{jsxref("TypedArray.prototype.values()")}}\n- {{jsxref("Symbol.iterator")}}\n- [Iteration protocols](/en-US/docs/Web/JavaScript/Reference/Iteration_protocols)\n'
        },
        "@@species": {
            "index.md": '---\ntitle: TypedArray[@@species]\nslug: Web/JavaScript/Reference/Global_Objects/TypedArray/@@species\npage-type: javascript-static-accessor-property\nbrowser-compat: javascript.builtins.TypedArray.@@species\n---\n\n{{JSRef}}\n\nThe **`TypedArray[@@species]`** static accessor property returns the constructor used to construct return values from typed array methods.\n\n> **Warning:** The existence of `@@species` allows execution of arbitrary code and may create security vulnerabilities. It also makes certain optimizations much harder. Engine implementers are [investigating whether to remove this feature](https://github.com/tc39/proposal-rm-builtin-subclassing). Avoid relying on it if possible.\n\n## Syntax\n\n```js-nolint\nTypedArray[Symbol.species]\n```\n\n### Return value\n\nThe value of the constructor (`this`) on which `get @@species` was called. The return value is used to construct return values from typed array methods that create new typed arrays.\n\n## Description\n\nThe `@@species` accessor property returns the default constructor for [typed array](/en-US/docs/Web/JavaScript/Reference/Global_Objects/TypedArray#typedarray_objects) objects. Subclass constructors may override it to change the constructor assignment. The default implementation is basically:\n\n```js\n// Hypothetical underlying implementation for illustration\nclass TypedArray {\n  static get [Symbol.species]() {\n    return this;\n  }\n}\n```\n\nBecause of this polymorphic implementation, `@@species` of derived subclasses would also return the constructor itself by default.\n\n```js\nclass SubTypedArray extends Int8Array {}\nSubTypedArray[Symbol.species] === SubTypedArray; // true\n```\n\nWhen calling typed array methods that do not mutate the existing array but return a new array instance (for example, [`filter()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/TypedArray/filter) and [`map()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/TypedArray/map)), the array\'s `constructor[@@species]` will be accessed. The returned constructor will be used to construct the return value of the typed array method.\n\nHowever, unlike [`Array[@@species]`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/@@species), when using `@@species` to create new typed arrays, the language will make sure that the newly created array is a proper typed array and has the same content type as the original array \u2014 for example, you can\'t create a {{jsxref("BigInt64Array")}} from a {{jsxref("Float64Array")}}, or create a non-BigInt array from a BigInt array. Doing so throws a {{jsxref("TypeError")}}.\n\n```js\nclass BadArray extends Int8Array {\n  static get [Symbol.species]() {\n    return Array;\n  }\n}\nnew BadArray(1).map(() => 0); // TypeError: Method %TypedArray%.prototype.map called on incompatible receiver [object Array]\n\nclass BadArray2 extends Int8Array {\n  static get [Symbol.species]() {\n    return BigInt64Array;\n  }\n}\nnew BadArray2(1).map(() => 0n); // TypeError: TypedArray.prototype.map constructed typed array of different content type from |this|\n```\n\n> **Note:** Due to a bug in both [SpiderMonkey](https://bugzil.la/1640194) and V8, the content type match is not checked. Only Safari will throw a {{jsxref("TypeError")}} in the second example.\n\n## Examples\n\n### Species in ordinary objects\n\nThe `@@species` property returns the default constructor function, which is one of the typed array constructors itself for any given [typed array](/en-US/docs/Web/JavaScript/Reference/Global_Objects/TypedArray#typedarray_objects) constructor.\n\n```js\nInt8Array[Symbol.species]; // function Int8Array()\nUint8Array[Symbol.species]; // function Uint8Array()\nFloat32Array[Symbol.species]; // function Float32Array()\n```\n\n### Species in derived objects\n\nIn an instance of a custom `TypedArray` subclass, such as `MyTypedArray`, the `MyTypedArray` species is the `MyTypedArray` constructor. However, you might want to overwrite this, in order to return a parent [typed array](/en-US/docs/Web/JavaScript/Reference/Global_Objects/TypedArray#typedarray_objects) object in your derived class methods:\n\n```js\nclass MyTypedArray extends Uint8Array {\n  // Overwrite MyTypedArray species to the parent Uint8Array constructor\n  static get [Symbol.species]() {\n    return Uint8Array;\n  }\n}\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("TypedArray")}}\n- {{jsxref("Symbol.species")}}\n'
        },
        "at": {
            "index.md": '---\ntitle: TypedArray.prototype.at()\nslug: Web/JavaScript/Reference/Global_Objects/TypedArray/at\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.TypedArray.at\n---\n\n{{JSRef}}\n\nThe **`at()`** method of {{jsxref("TypedArray")}} instances takes an integer value and returns the item at that index, allowing for positive and negative integers. Negative integers count back from the last item in the typed array. This method has the same algorithm as {{jsxref("Array.prototype.at()")}}.\n\n{{EmbedInteractiveExample("pages/js/typedarray-at.html")}}\n\n## Syntax\n\n```js-nolint\nat(index)\n```\n\n### Parameters\n\n- `index`\n  - : Zero-based index of the typed array element to be returned, [converted to an integer](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number#integer_conversion). Negative index counts back from the end of the typed array \u2014 if `index < 0`, `index + array.length` is accessed.\n\n### Return value\n\nThe element in the typed array matching the given index. Always returns {{jsxref("undefined")}} if `index < -array.length` or `index >= array.length` without attempting to access the corresponding property.\n\n## Description\n\nSee {{jsxref("Array.prototype.at()")}} for more details. This method is not generic and can only be called on typed array instances.\n\n## Examples\n\n### Return the last value of a typed array\n\nThe following example provides a function which returns the last element found in a specified array.\n\n```js\nconst uint8 = new Uint8Array([1, 2, 4, 7, 11, 18]);\n\n// A function which returns the last item of a given array\nfunction returnLast(arr) {\n  return arr.at(-1);\n}\n\nconst lastItem = returnLast(uint8);\nconsole.log(lastItem); // 18\n```\n\n### Comparing methods\n\nHere we compare different ways to select the penultimate (last but one) item of a {{jsxref("TypedArray")}}. Whilst all below methods are valid, it highlights the succinctness and readability of the `at()` method.\n\n```js\n// Our typed array with values\nconst uint8 = new Uint8Array([1, 2, 4, 7, 11, 18]);\n\n// Using length property\nconst lengthWay = uint8[uint8.length - 2];\nconsole.log(lengthWay); // 11\n\n// Using slice() method. Note an array is returned\nconst sliceWay = uint8.slice(-2, -1);\nconsole.log(sliceWay[0]); // 11\n\n// Using at() method\nconst atWay = uint8.at(-2);\nconsole.log(atWay); // 11\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `TypedArray.prototype.at` in `core-js`](https://github.com/zloirock/core-js#relative-indexing-method)\n- [JavaScript typed arrays](/en-US/docs/Web/JavaScript/Guide/Typed_arrays) guide\n- {{jsxref("TypedArray")}}\n- {{jsxref("TypedArray.prototype.findIndex()")}}\n- {{jsxref("TypedArray.prototype.indexOf()")}}\n- {{jsxref("TypedArray.prototype.with()")}}\n- {{jsxref("Array.prototype.at()")}}\n- {{jsxref("String.prototype.at()")}}\n'
        },
        "buffer": {
            "index.md": '---\ntitle: TypedArray.prototype.buffer\nslug: Web/JavaScript/Reference/Global_Objects/TypedArray/buffer\npage-type: javascript-instance-accessor-property\nbrowser-compat: javascript.builtins.TypedArray.buffer\n---\n\n{{JSRef}}\n\nThe **`buffer`** accessor property of {{jsxref("TypedArray")}} instances returns the {{jsxref("ArrayBuffer")}} or {{jsxref("SharedArrayBuffer")}} referenced by this typed array at construction time.\n\n{{EmbedInteractiveExample("pages/js/typedarray-buffer.html", "shorter")}}\n\n## Description\n\nThe `buffer` property is an accessor property whose set accessor function is `undefined`, meaning that you can only read this property. The value is established when the _TypedArray_ is constructed and cannot be changed. _TypedArray_ is one of the [TypedArray objects](/en-US/docs/Web/JavaScript/Reference/Global_Objects/TypedArray#typedarray_objects).\n\nBecause a typed array is a _view_ of a buffer, the underlying buffer may be longer than the typed array itself.\n\n## Examples\n\n### Using the buffer property\n\n```js\nconst buffer = new ArrayBuffer(8);\nconst uint16 = new Uint16Array(buffer);\nuint16.buffer; // ArrayBuffer { byteLength: 8 }\n```\n\n### Accessing the underlying buffer from a sliced array view\n\n```js\nconst buffer = new ArrayBuffer(1024);\nconst arr = new Uint8Array(buffer, 64, 128);\nconsole.log(arr.byteLength); // 128\nconsole.log(arr.buffer.byteLength); // 1024\nconsole.log(arr.buffer === buffer); // true\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [JavaScript typed arrays](/en-US/docs/Web/JavaScript/Guide/Typed_arrays) guide\n- {{jsxref("TypedArray")}}\n'
        },
        "bytelength": {
            "index.md": '---\ntitle: TypedArray.prototype.byteLength\nslug: Web/JavaScript/Reference/Global_Objects/TypedArray/byteLength\npage-type: javascript-instance-accessor-property\nbrowser-compat: javascript.builtins.TypedArray.byteLength\n---\n\n{{JSRef}}\n\nThe **`byteLength`** accessor property of {{jsxref("TypedArray")}} instances returns the length (in bytes) of this typed array.\n\n{{EmbedInteractiveExample("pages/js/typedarray-bytelength.html", "shorter")}}\n\n## Description\n\nThe `byteLength` property is an accessor property whose set accessor function is `undefined`, meaning that you can only read this property. The value is established when a _TypedArray_ is constructed and cannot be changed. If the _TypedArray_ is not specifying a `byteOffset` or a `length`, the `length` of the referenced `ArrayBuffer` will be returned. _TypedArray_ is one of the [TypedArray objects](/en-US/docs/Web/JavaScript/Reference/Global_Objects/TypedArray#typedarray_objects).\n\n## Examples\n\n### Using the byteLength property\n\n```js\nconst buffer = new ArrayBuffer(8);\n\nconst uint8 = new Uint8Array(buffer);\nuint8.byteLength; // 8 (matches the byteLength of the buffer)\n\nconst uint8newLength = new Uint8Array(buffer, 1, 5);\nuint8newLength.byteLength; // 5 (as specified when constructing the Uint8Array)\n\nconst uint8offSet = new Uint8Array(buffer, 2);\nuint8offSet.byteLength; // 6 (due to the offset of the constructed Uint8Array)\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [JavaScript typed arrays](/en-US/docs/Web/JavaScript/Guide/Typed_arrays) guide\n- {{jsxref("TypedArray")}}\n'
        },
        "byteoffset": {
            "index.md": '---\ntitle: TypedArray.prototype.byteOffset\nslug: Web/JavaScript/Reference/Global_Objects/TypedArray/byteOffset\npage-type: javascript-instance-accessor-property\nbrowser-compat: javascript.builtins.TypedArray.byteOffset\n---\n\n{{JSRef}}\n\nThe **`byteOffset`** accessor property of {{jsxref("TypedArray")}} instances returns the offset (in bytes) of this typed array from the start of its {{jsxref("ArrayBuffer")}} or {{jsxref("SharedArrayBuffer")}}.\n\n## Description\n\nThe `byteOffset` property is an accessor property whose set accessor function is `undefined`, meaning that you can only read this property. The value is established when a _TypedArray_ is constructed and cannot be changed. _TypedArray_ is one of the [TypedArray objects](/en-US/docs/Web/JavaScript/Reference/Global_Objects/TypedArray#typedarray_objects).\n\n## Examples\n\n### Using the byteOffset property\n\n```js\nconst buffer = new ArrayBuffer(8);\n\nconst uint8array1 = new Uint8Array(buffer);\nuint8array1.byteOffset; // 0 (no offset specified)\n\nconst uint8array2 = new Uint8Array(buffer, 3);\nuint8array2.byteOffset; // 3 (as specified when constructing Uint8Array)\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [JavaScript typed arrays](/en-US/docs/Web/JavaScript/Guide/Typed_arrays) guide\n- {{jsxref("TypedArray")}}\n'
        },
        "bytes_per_element": {
            "index.md": '---\ntitle: TypedArray.BYTES_PER_ELEMENT\nslug: Web/JavaScript/Reference/Global_Objects/TypedArray/BYTES_PER_ELEMENT\npage-type: javascript-static-data-property\nbrowser-compat: javascript.builtins.TypedArray.BYTES_PER_ELEMENT\n---\n\n{{JSRef}}\n\nThe **`TypedArray.BYTES_PER_ELEMENT`** static data property represents the size in bytes of each element in a typed array.\n\n{{EmbedInteractiveExample("pages/js/typedarray-bytes-per-element.html", "shorter")}}\n\n## Value\n\nA number whose value depends on the type of `TypedArray`.\n\n{{js_property_attributes(0, 0, 0)}}\n\n## Description\n\n`TypedArray` objects differ from each other in the number of bytes per element and in the way the bytes are interpreted. The `BYTES_PER_ELEMENT` constant contains the number of bytes each element in the given `TypedArray` has.\n\nThe `BYTES_PER_ELEMENT` property is both an _instance property_ and a _static property_. It\'s available on both `TypedArray` subclass constructors and on instances of those constructors.\n\nAs an instance property, `BYTES_PER_ELEMENT` is defined on the constructor\'s `prototype`.\n\n```js\nconsole.log(Object.hasOwn(Int8Array.prototype, "BYTES_PER_ELEMENT")); // true\n```\n\n## Examples\n\n### Using BYTES_PER_ELEMENT\n\nAs a static property:\n\n```js\nInt8Array.BYTES_PER_ELEMENT; // 1\nUint8Array.BYTES_PER_ELEMENT; // 1\nUint8ClampedArray.BYTES_PER_ELEMENT; // 1\nInt16Array.BYTES_PER_ELEMENT; // 2\nUint16Array.BYTES_PER_ELEMENT; // 2\nInt32Array.BYTES_PER_ELEMENT; // 4\nUint32Array.BYTES_PER_ELEMENT; // 4\nFloat32Array.BYTES_PER_ELEMENT; // 4\nFloat64Array.BYTES_PER_ELEMENT; // 8\nBigInt64Array.BYTES_PER_ELEMENT; // 8\nBigUint64Array.BYTES_PER_ELEMENT; // 8\n```\n\nAs an instance property:\n\n```js\nnew Int8Array([]).BYTES_PER_ELEMENT; // 1\nnew Uint8Array([]).BYTES_PER_ELEMENT; // 1\nnew Uint8ClampedArray([]).BYTES_PER_ELEMENT; // 1\nnew Int16Array([]).BYTES_PER_ELEMENT; // 2\nnew Uint16Array([]).BYTES_PER_ELEMENT; // 2\nnew Int32Array([]).BYTES_PER_ELEMENT; // 4\nnew Uint32Array([]).BYTES_PER_ELEMENT; // 4\nnew Float32Array([]).BYTES_PER_ELEMENT; // 4\nnew Float64Array([]).BYTES_PER_ELEMENT; // 8\nnew BigInt64Array([]).BYTES_PER_ELEMENT; // 8\nnew BigUint64Array([]).BYTES_PER_ELEMENT; // 8\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [JavaScript typed arrays](/en-US/docs/Web/JavaScript/Guide/Typed_arrays) guide\n- {{jsxref("TypedArray")}}\n'
        },
        "copywithin": {
            "index.md": '---\ntitle: TypedArray.prototype.copyWithin()\nslug: Web/JavaScript/Reference/Global_Objects/TypedArray/copyWithin\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.TypedArray.copyWithin\n---\n\n{{JSRef}}\n\nThe **`copyWithin()`** method of {{jsxref("TypedArray")}} instances shallow copies part of this typed array to another location in the same typed array and returns this typed array without modifying its length. This method has the same algorithm as {{jsxref("Array.prototype.copyWithin()")}}.\n\n{{EmbedInteractiveExample("pages/js/typedarray-copywithin.html")}}\n\n## Syntax\n\n```js-nolint\ncopyWithin(target, start)\ncopyWithin(target, start, end)\n```\n\n### Parameters\n\n- `target`\n  - : Zero-based index at which to copy the sequence to, [converted to an integer](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number#integer_conversion). This corresponds to where the element at `start` will be copied to, and all elements between `start` and `end` are copied to succeeding indices.\n- `start`\n  - : Zero-based index at which to start copying elements from, [converted to an integer](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number#integer_conversion).\n- `end` {{optional_inline}}\n  - : Zero-based index at which to end copying elements from, [converted to an integer](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number#integer_conversion). `copyWithin()` copies up to but not including `end`.\n\n### Return value\n\nThe modified typed array.\n\n## Description\n\nSee {{jsxref("Array.prototype.copyWithin()")}} for more details. This method is not generic and can only be called on typed array instances.\n\n## Examples\n\n### Using copyWithin()\n\n```js\nconst buffer = new ArrayBuffer(8);\nconst uint8 = new Uint8Array(buffer);\nuint8.set([1, 2, 3]);\nconsole.log(uint8); // Uint8Array [ 1, 2, 3, 0, 0, 0, 0, 0 ]\nuint8.copyWithin(3, 0, 3);\nconsole.log(uint8); // Uint8Array [ 1, 2, 3, 1, 2, 3, 0, 0 ]\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `TypedArray.prototype.copyWithin` in `core-js`](https://github.com/zloirock/core-js#ecmascript-typed-arrays)\n- [JavaScript typed arrays](/en-US/docs/Web/JavaScript/Guide/Typed_arrays) guide\n- {{jsxref("TypedArray")}}\n- {{jsxref("Array.prototype.copyWithin()")}}\n'
        },
        "entries": {
            "index.md": '---\ntitle: TypedArray.prototype.entries()\nslug: Web/JavaScript/Reference/Global_Objects/TypedArray/entries\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.TypedArray.entries\n---\n\n{{JSRef}}\n\nThe **`entries()`** method of {{jsxref("TypedArray")}} instances returns a new _[array iterator](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Iterator)_ object that contains the key/value pairs for each index in the typed array. This method has the same algorithm as {{jsxref("Array.prototype.entries()")}}.\n\n{{EmbedInteractiveExample("pages/js/typedarray-entries.html")}}\n\n## Syntax\n\n```js-nolint\nentries()\n```\n\n### Parameters\n\nNone.\n\n### Return value\n\nA new [iterable iterator object](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Iterator).\n\n## Description\n\nSee {{jsxref("Array.prototype.entries()")}} for more details. This method is not generic and can only be called on typed array instances.\n\n## Examples\n\n### Iteration using for...of loop\n\n```js\nconst array = new Uint8Array([10, 20, 30, 40, 50]);\nconst arrayEntries = arr.entries();\nfor (const element of arrayEntries) {\n  console.log(element);\n}\n```\n\n### Alternative iteration\n\n```js\nconst array = new Uint8Array([10, 20, 30, 40, 50]);\nconst arrayEntries = arr.entries();\n\nconsole.log(arrayEntries.next().value); // [0, 10]\nconsole.log(arrayEntries.next().value); // [1, 20]\nconsole.log(arrayEntries.next().value); // [2, 30]\nconsole.log(arrayEntries.next().value); // [3, 40]\nconsole.log(arrayEntries.next().value); // [4, 50]\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `TypedArray.prototype.entries` in `core-js`](https://github.com/zloirock/core-js#ecmascript-typed-arrays)\n- [JavaScript typed arrays](/en-US/docs/Web/JavaScript/Guide/Typed_arrays) guide\n- {{jsxref("TypedArray")}}\n- {{jsxref("TypedArray.prototype.keys()")}}\n- {{jsxref("TypedArray.prototype.values()")}}\n- [`TypedArray.prototype[@@iterator]()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/TypedArray/@@iterator)\n- {{jsxref("Array.prototype.entries()")}}\n- [Iteration protocols](/en-US/docs/Web/JavaScript/Reference/Iteration_protocols)\n'
        },
        "every": {
            "index.md": '---\ntitle: TypedArray.prototype.every()\nslug: Web/JavaScript/Reference/Global_Objects/TypedArray/every\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.TypedArray.every\n---\n\n{{JSRef}}\n\nThe **`every()`** method of {{jsxref("TypedArray")}} instances tests whether all elements in the typed array pass the test implemented by the provided function. It returns a Boolean value. This method has the same algorithm as {{jsxref("Array.prototype.every()")}}.\n\n{{EmbedInteractiveExample("pages/js/typedarray-every.html")}}\n\n## Syntax\n\n```js-nolint\nevery(callbackFn)\nevery(callbackFn, thisArg)\n```\n\n### Parameters\n\n- `callbackFn`\n  - : A function to execute for each element in the typed array. It should return a [truthy](/en-US/docs/Glossary/Truthy) value to indicate the element passes the test, and a [falsy](/en-US/docs/Glossary/Falsy) value otherwise. The function is called with the following arguments:\n    - `element`\n      - : The current element being processed in the typed array.\n    - `index`\n      - : The index of the current element being processed in the typed array.\n    - `array`\n      - : The typed array `every()` was called upon.\n- `thisArg` {{optional_inline}}\n  - : A value to use as `this` when executing `callbackFn`. See [iterative methods](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array#iterative_methods).\n\n### Return value\n\n`true` unless `callbackFn` returns a {{Glossary("falsy")}} value for a typed array element, in which case `false` is immediately returned.\n\n## Description\n\nSee {{jsxref("Array.prototype.every()")}} for more details. This method is not generic and can only be called on typed array instances.\n\n## Examples\n\n### Testing size of all typed array elements\n\nThe following example tests whether all elements in the typed array are 10 or bigger.\n\n```js\nfunction isBigEnough(element, index, array) {\n  return element >= 10;\n}\nnew Uint8Array([12, 5, 8, 130, 44]).every(isBigEnough); // false\nnew Uint8Array([12, 54, 18, 130, 44]).every(isBigEnough); // true\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `TypedArray.prototype.every` in `core-js`](https://github.com/zloirock/core-js#ecmascript-typed-arrays)\n- [JavaScript typed arrays](/en-US/docs/Web/JavaScript/Guide/Typed_arrays) guide\n- {{jsxref("TypedArray")}}\n- {{jsxref("TypedArray.prototype.forEach()")}}\n- {{jsxref("TypedArray.prototype.some()")}}\n- {{jsxref("TypedArray.prototype.find()")}}\n- {{jsxref("Array.prototype.every()")}}\n'
        },
        "fill": {
            "index.md": '---\ntitle: TypedArray.prototype.fill()\nslug: Web/JavaScript/Reference/Global_Objects/TypedArray/fill\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.TypedArray.fill\n---\n\n{{JSRef}}\n\nThe **`fill()`** method of {{jsxref("TypedArray")}} instances changes all elements within a range of indices in a typed array to a static value. It returns the modified typed array. This method has the same algorithm as {{jsxref("Array.prototype.fill()")}}.\n\n{{EmbedInteractiveExample("pages/js/typedarray-fill.html", "shorter")}}\n\n## Syntax\n\n```js-nolint\nfill(value)\nfill(value, start)\nfill(value, start, end)\n```\n\n### Parameters\n\n- `value`\n  - : Value to fill the typed array with.\n- `start` {{optional_inline}}\n  - : Zero-based index at which to start filling, [converted to an integer](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number#integer_conversion).\n- `end` {{optional_inline}}\n  - : Zero-based index at which to end filling, [converted to an integer](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number#integer_conversion). `fill()` fills up to but not including `end`.\n\n### Return value\n\nThe modified typed array, filled with `value`.\n\n## Description\n\nSee {{jsxref("Array.prototype.fill()")}} for more details. This method is not generic and can only be called on typed array instances.\n\n## Examples\n\n### Using fill()\n\n```js\nnew Uint8Array([1, 2, 3]).fill(4); // Uint8Array [4, 4, 4]\nnew Uint8Array([1, 2, 3]).fill(4, 1); // Uint8Array [1, 4, 4]\nnew Uint8Array([1, 2, 3]).fill(4, 1, 2); // Uint8Array [1, 4, 3]\nnew Uint8Array([1, 2, 3]).fill(4, 1, 1); // Uint8Array [1, 2, 3]\nnew Uint8Array([1, 2, 3]).fill(4, -3, -2); // Uint8Array [4, 2, 3]\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `TypedArray.prototype.fill` in `core-js`](https://github.com/zloirock/core-js#ecmascript-typed-arrays)\n- [JavaScript typed arrays](/en-US/docs/Web/JavaScript/Guide/Typed_arrays) guide\n- {{jsxref("TypedArray")}}\n- {{jsxref("Array.prototype.fill()")}}\n'
        },
        "filter": {
            "index.md": '---\ntitle: TypedArray.prototype.filter()\nslug: Web/JavaScript/Reference/Global_Objects/TypedArray/filter\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.TypedArray.filter\n---\n\n{{JSRef}}\n\nThe **`filter()`** method of {{jsxref("TypedArray")}} instances creates a copy of a portion of a given typed array, filtered down to just the elements from the given typed array that pass the test implemented by the provided function. This method has the same algorithm as {{jsxref("Array.prototype.filter()")}}.\n\n{{EmbedInteractiveExample("pages/js/typedarray-filter.html")}}\n\n## Syntax\n\n```js-nolint\nfilter(callbackFn)\nfilter(callbackFn, thisArg)\n```\n\n### Parameters\n\n- `callbackFn`\n  - : A function to execute for each element in the typed array. It should return a [truthy](/en-US/docs/Glossary/Truthy) value to keep the element in the resulting typed array, and a [falsy](/en-US/docs/Glossary/Falsy) value otherwise. The function is called with the following arguments:\n    - `element`\n      - : The current element being processed in the typed array.\n    - `index`\n      - : The index of the current element being processed in the typed array.\n    - `array`\n      - : The typed array `filter()` was called upon.\n- `thisArg` {{optional_inline}}\n  - : A value to use as `this` when executing `callbackFn`. See [iterative methods](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array#iterative_methods).\n\n### Return value\n\nA copy of the given typed array containing just the elements that pass the test. If no elements pass the test, an empty typed array is returned.\n\n## Description\n\nSee {{jsxref("Array.prototype.filter()")}} for more details. This method is not generic and can only be called on typed array instances.\n\n## Examples\n\n### Filtering out all small values\n\nThe following example uses `filter()` to create a filtered typed array that has all elements with values less than 10 removed.\n\n```js\nfunction isBigEnough(element, index, array) {\n  return element >= 10;\n}\nnew Uint8Array([12, 5, 8, 130, 44]).filter(isBigEnough);\n// Uint8Array [ 12, 130, 44 ]\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `TypedArray.prototype.filter` in `core-js`](https://github.com/zloirock/core-js#ecmascript-typed-arrays)\n- [JavaScript typed arrays](/en-US/docs/Web/JavaScript/Guide/Typed_arrays) guide\n- {{jsxref("TypedArray")}}\n- {{jsxref("TypedArray.prototype.forEach()")}}\n- {{jsxref("TypedArray.prototype.every()")}}\n- {{jsxref("TypedArray.prototype.map()")}}\n- {{jsxref("TypedArray.prototype.some()")}}\n- {{jsxref("TypedArray.prototype.reduce()")}}\n- {{jsxref("Array.prototype.filter()")}}\n'
        },
        "find": {
            "index.md": '---\ntitle: TypedArray.prototype.find()\nslug: Web/JavaScript/Reference/Global_Objects/TypedArray/find\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.TypedArray.find\n---\n\n{{JSRef}}\n\nThe **`find()`** method of {{jsxref("TypedArray")}} instances returns the first element in the provided typed array that satisfies the provided testing function. If no values satisfy the testing function, {{jsxref("undefined")}} is returned. This method has the same algorithm as {{jsxref("Array.prototype.find()")}}.\n\n{{EmbedInteractiveExample("pages/js/typedarray-find.html")}}\n\n## Syntax\n\n```js-nolint\nfind(callbackFn)\nfind(callbackFn, thisArg)\n```\n\n### Parameters\n\n- `callbackFn`\n  - : A function to execute for each element in the typed array. It should return a [truthy](/en-US/docs/Glossary/Truthy) value to indicate a matching element has been found, and a [falsy](/en-US/docs/Glossary/Falsy) value otherwise. The function is called with the following arguments:\n    - `element`\n      - : The current element being processed in the typed array.\n    - `index`\n      - : The index of the current element being processed in the typed array.\n    - `array`\n      - : The typed array `find()` was called upon.\n- `thisArg` {{optional_inline}}\n  - : A value to use as `this` when executing `callbackFn`. See [iterative methods](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array#iterative_methods).\n\n### Return value\n\nThe first element in the typed array that satisfies the provided testing function.\nOtherwise, {{jsxref("undefined")}} is returned.\n\n## Description\n\nSee {{jsxref("Array.prototype.find()")}} for more details. This method is not generic and can only be called on typed array instances.\n\n## Examples\n\n### Find a prime number in a typed array\n\nThe following example finds an element in the typed array that is a prime number (or returns {{jsxref("undefined")}} if there is no prime number).\n\n```js\nfunction isPrime(element, index, array) {\n  let start = 2;\n  while (start <= Math.sqrt(element)) {\n    if (element % start++ < 1) {\n      return false;\n    }\n  }\n  return element > 1;\n}\n\nconst uint8 = new Uint8Array([4, 5, 8, 12]);\nconsole.log(uint8.find(isPrime)); // 5\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `TypedArray.prototype.find` in `core-js`](https://github.com/zloirock/core-js#ecmascript-typed-arrays)\n- [JavaScript typed arrays](/en-US/docs/Web/JavaScript/Guide/Typed_arrays) guide\n- {{jsxref("TypedArray")}}\n- {{jsxref("TypedArray.prototype.findIndex()")}}\n- {{jsxref("TypedArray.prototype.findLast()")}}\n- {{jsxref("TypedArray.prototype.findLastIndex()")}}\n- {{jsxref("TypedArray.prototype.includes()")}}\n- {{jsxref("TypedArray.prototype.filter()")}}\n- {{jsxref("TypedArray.prototype.every()")}}\n- {{jsxref("TypedArray.prototype.some()")}}\n- {{jsxref("Array.prototype.find()")}}\n'
        },
        "findindex": {
            "index.md": '---\ntitle: TypedArray.prototype.findIndex()\nslug: Web/JavaScript/Reference/Global_Objects/TypedArray/findIndex\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.TypedArray.findIndex\n---\n\n{{JSRef}}\n\nThe **`findIndex()`** method of {{jsxref("TypedArray")}} instances returns the index of the first element in a typed array that satisfies the provided testing function. If no elements satisfy the testing function, -1 is returned. This method has the same algorithm as {{jsxref("Array.prototype.findIndex()")}}.\n\n{{EmbedInteractiveExample("pages/js/typedarray-findindex.html")}}\n\n## Syntax\n\n```js-nolint\nfindIndex(callbackFn)\nfindIndex(callbackFn, thisArg)\n```\n\n### Parameters\n\n- `callbackFn`\n  - : A function to execute for each element in the typed array. It should return a [truthy](/en-US/docs/Glossary/Truthy) value to indicate a matching element has been found, and a [falsy](/en-US/docs/Glossary/Falsy) value otherwise. The function is called with the following arguments:\n    - `element`\n      - : The current element being processed in the typed array.\n    - `index`\n      - : The index of the current element being processed in the typed array.\n    - `array`\n      - : The typed array `findIndex()` was called upon.\n- `thisArg` {{optional_inline}}\n  - : A value to use as `this` when executing `callbackFn`. See [iterative methods](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array#iterative_methods).\n\n### Return value\n\nThe index of the first element in the typed array that passes the test. Otherwise, `-1`.\n\n## Description\n\nSee {{jsxref("Array.prototype.findIndex()")}} for more details. This method is not generic and can only be called on typed array instances.\n\n## Examples\n\n### Find the index of a prime number in a typed array\n\nThe following example finds the index of an element in the typed array that is a prime\nnumber (or returns `-1` if there is no prime number).\n\n```js\nfunction isPrime(element, index, array) {\n  let start = 2;\n  while (start <= Math.sqrt(element)) {\n    if (element % start++ < 1) {\n      return false;\n    }\n  }\n  return element > 1;\n}\n\nconst uint8 = new Uint8Array([4, 6, 8, 12]);\nconst uint16 = new Uint16Array([4, 6, 7, 12]);\n\nconsole.log(uint8.findIndex(isPrime)); // -1, not found\nconsole.log(uint16.findIndex(isPrime)); // 2\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `TypedArray.prototype.findIndex` in `core-js`](https://github.com/zloirock/core-js#ecmascript-typed-arrays)\n- [JavaScript typed arrays](/en-US/docs/Web/JavaScript/Guide/Typed_arrays) guide\n- {{jsxref("TypedArray")}}\n- {{jsxref("TypedArray.prototype.find()")}}\n- {{jsxref("TypedArray.prototype.findLast()")}}\n- {{jsxref("TypedArray.prototype.findLastIndex()")}}\n- {{jsxref("TypedArray.prototype.indexOf()")}}\n- {{jsxref("TypedArray.prototype.lastIndexOf()")}}\n- {{jsxref("Array.prototype.findIndex()")}}\n'
        },
        "findlast": {
            "index.md": '---\ntitle: TypedArray.prototype.findLast()\nslug: Web/JavaScript/Reference/Global_Objects/TypedArray/findLast\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.TypedArray.findLast\n---\n\n{{JSRef}}\n\nThe **`findLast()`** method of {{jsxref("TypedArray")}} instances iterates the typed array in reverse order and returns the value of the first element that satisfies the provided testing function. If no elements satisfy the testing function, {{jsxref("undefined")}} is returned. This method has the same algorithm as {{jsxref("Array.prototype.findLast()")}}.\n\n{{EmbedInteractiveExample("pages/js/typedarray-findlast.html")}}\n\n## Syntax\n\n```js-nolint\nfindLast(callbackFn)\nfindLast(callbackFn, thisArg)\n```\n\n### Parameters\n\n- `callbackFn`\n  - : A function to execute for each element in the typed array. It should return a [truthy](/en-US/docs/Glossary/Truthy) value to indicate a matching element has been found, and a [falsy](/en-US/docs/Glossary/Falsy) value otherwise. The function is called with the following arguments:\n    - `element`\n      - : The current element being processed in the typed array.\n    - `index`\n      - : The index of the current element being processed in the typed array.\n    - `array`\n      - : The typed array `findLast()` was called upon.\n- `thisArg` {{optional_inline}}\n  - : A value to use as `this` when executing `callbackFn`. See [iterative methods](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array#iterative_methods).\n\n### Return value\n\nThe last (highest-index) element in the typed array that satisfies the provided testing function; {{jsxref("undefined")}} if no matching element is found.\n\n## Description\n\nSee {{jsxref("Array.prototype.findLast()")}} for more details. This method is not generic and can only be called on typed array instances.\n\n## Examples\n\n### Find the last prime number in a typed array\n\nThe following example returns the value of the last element in the typed array that is a prime number, or {{jsxref("undefined")}} if there is no prime number.\n\n```js\nfunction isPrime(element) {\n  if (element % 2 === 0 || element < 2) {\n    return false;\n  }\n  for (let factor = 3; factor <= Math.sqrt(element); factor += 2) {\n    if (element % factor === 0) {\n      return false;\n    }\n  }\n  return true;\n}\n\nlet uint8 = new Uint8Array([4, 6, 8, 12]);\nconsole.log(uint8.findLast(isPrime)); // undefined (no primes in array)\nuint8 = new Uint8Array([4, 5, 7, 8, 9, 11, 12]);\nconsole.log(uint8.findLast(isPrime)); // 11\n```\n\n### All elements are visited and may be modified by the callback\n\nThe following examples show that all elements _are_ visited, and that the value passed to the callback is their value when visited:\n\n```js\n// Declare array with no elements at indexes 2, 3, and 4\n// The missing elements will be initialized to zero.\nconst uint8 = new Uint8Array([0, 1, , , , 5, 6]);\n\n// Iterate through the elements in reverse order.\n// Note that all elements are visited.\nuint8.findLast((value, index) => {\n  console.log(`Visited index ${index} with value ${value}`);\n});\n\n// Shows all indexes, including deleted\nuint8.findLast((value, index) => {\n  // Modify element 3 on first iteration\n  if (index === 6) {\n    console.log("Set uint8[3] to 44");\n    uint8[3] = 44;\n  }\n  // Element 3 is still visited but will have a new value.\n  console.log(`Visited index ${index} with value ${value}`);\n});\n// Visited index 6 with value 6\n// Visited index 5 with value 5\n// Visited index 4 with value 0\n// Visited index 3 with value 0\n// Visited index 2 with value 0\n// Visited index 1 with value 1\n// Visited index 0 with value 0\n// Set uint8[3] to 44\n// Visited index 6 with value 6\n// Visited index 5 with value 5\n// Visited index 4 with value 0\n// Visited index 3 with value 44\n// Visited index 2 with value 0\n// Visited index 1 with value 1\n// Visited index 0 with value 0\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `TypedArray.prototype.findLast` in `core-js`](https://github.com/zloirock/core-js#array-find-from-last)\n- [JavaScript typed arrays](/en-US/docs/Web/JavaScript/Guide/Typed_arrays) guide\n- {{jsxref("TypedArray")}}\n- {{jsxref("TypedArray.prototype.find()")}}\n- {{jsxref("TypedArray.prototype.findIndex()")}}\n- {{jsxref("TypedArray.prototype.findLastIndex()")}}\n- {{jsxref("TypedArray.prototype.includes()")}}\n- {{jsxref("TypedArray.prototype.filter()")}}\n- {{jsxref("TypedArray.prototype.every()")}}\n- {{jsxref("TypedArray.prototype.some()")}}\n- {{jsxref("Array.prototype.findLast()")}}\n'
        },
        "findlastindex": {
            "index.md": '---\ntitle: TypedArray.prototype.findLastIndex()\nslug: Web/JavaScript/Reference/Global_Objects/TypedArray/findLastIndex\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.TypedArray.findLastIndex\n---\n\n{{JSRef}}\n\nThe **`findLastIndex()`** method of {{jsxref("TypedArray")}} instances iterates the typed array in reverse order and returns the index of the first element that satisfies the provided testing function. If no elements satisfy the testing function, -1 is returned. This method has the same algorithm as {{jsxref("Array.prototype.findLastIndex()")}}.\n\n{{EmbedInteractiveExample("pages/js/typedarray-findlastindex.html")}}\n\n## Syntax\n\n```js-nolint\nfindLastIndex(callbackFn)\nfindLastIndex(callbackFn, thisArg)\n```\n\n### Parameters\n\n- `callbackFn`\n  - : A function to execute for each element in the typed array. It should return a [truthy](/en-US/docs/Glossary/Truthy) value to indicate a matching element has been found, and a [falsy](/en-US/docs/Glossary/Falsy) value otherwise. The function is called with the following arguments:\n    - `element`\n      - : The current element being processed in the typed array.\n    - `index`\n      - : The index of the current element being processed in the typed array.\n    - `array`\n      - : The typed array `findLastIndex()` was called upon.\n- `thisArg` {{optional_inline}}\n  - : A value to use as `this` when executing `callbackFn`. See [iterative methods](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array#iterative_methods).\n\n### Return value\n\nThe index of the last (highest-index) element in the typed array that passes the test.\nOtherwise `-1` if no matching element is found.\n\n## Description\n\nSee {{jsxref("Array.prototype.findLastIndex()")}} for more details. This method is not generic and can only be called on typed array instances.\n\n## Examples\n\n### Find the index of the last prime number in a typed array\n\nThe following example returns the index of the last element in the typed array that is a prime number, or `-1` if there is no prime number.\n\n```js\nfunction isPrime(element) {\n  if (element % 2 === 0 || element < 2) {\n    return false;\n  }\n  for (let factor = 3; factor <= Math.sqrt(element); factor += 2) {\n    if (element % factor === 0) {\n      return false;\n    }\n  }\n  return true;\n}\n\nlet uint8 = new Uint8Array([4, 6, 8, 12]);\nconsole.log(uint8.findLastIndex(isPrime));\n// -1 (no primes in array)\nuint8 = new Uint8Array([4, 5, 7, 8, 9, 11, 12]);\nconsole.log(uint8.findLastIndex(isPrime));\n// 5\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `TypedArray.prototype.findLastIndex` in `core-js`](https://github.com/zloirock/core-js#array-find-from-last)\n- [JavaScript typed arrays](/en-US/docs/Web/JavaScript/Guide/Typed_arrays) guide\n- {{jsxref("TypedArray")}}\n- {{jsxref("TypedArray.prototype.find()")}}\n- {{jsxref("TypedArray.prototype.findIndex()")}}\n- {{jsxref("TypedArray.prototype.findLast()")}}\n- {{jsxref("TypedArray.prototype.indexOf()")}}\n- {{jsxref("TypedArray.prototype.lastIndexOf()")}}\n- {{jsxref("Array.prototype.findLastIndex()")}}\n'
        },
        "foreach": {
            "index.md": '---\ntitle: TypedArray.prototype.forEach()\nslug: Web/JavaScript/Reference/Global_Objects/TypedArray/forEach\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.TypedArray.forEach\n---\n\n{{JSRef}}\n\nThe **`forEach()`** method of {{jsxref("TypedArray")}} instances executes a provided function once for each typed array element. This method has the same algorithm as {{jsxref("Array.prototype.forEach()")}}.\n\n{{EmbedInteractiveExample("pages/js/typedarray-foreach.html")}}\n\n## Syntax\n\n```js-nolint\nforEach(callbackFn)\nforEach(callbackFn, thisArg)\n```\n\n### Parameters\n\n- `callbackFn`\n  - : A function to execute for each element in the typed array. Its return value is discarded. The function is called with the following arguments:\n    - `element`\n      - : The current element being processed in the typed array.\n    - `index`\n      - : The index of the current element being processed in the typed array.\n    - `array`\n      - : The typed array `forEach()` was called upon.\n- `thisArg` {{optional_inline}}\n  - : A value to use as `this` when executing `callbackFn`. See [iterative methods](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array#iterative_methods).\n\n### Return value\n\nNone ({{jsxref("undefined")}}).\n\n## Description\n\nSee {{jsxref("Array.prototype.forEach()")}} for more details. This method is not generic and can only be called on typed array instances.\n\n## Examples\n\n### Logging the contents of a typed array\n\nThe following code logs a line for each element in a typed array:\n\n```js\nfunction logArrayElements(element, index, array) {\n  console.log(`a[${index}] = ${element}`);\n}\n\nnew Uint8Array([0, 1, 2, 3]).forEach(logArrayElements);\n// Logs:\n// a[0] = 0\n// a[1] = 1\n// a[2] = 2\n// a[3] = 3\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `TypedArray.prototype.forEach` in `core-js`](https://github.com/zloirock/core-js#ecmascript-typed-arrays)\n- [JavaScript typed arrays](/en-US/docs/Web/JavaScript/Guide/Typed_arrays) guide\n- {{jsxref("TypedArray")}}\n- {{jsxref("TypedArray.prototype.find()")}}\n- {{jsxref("TypedArray.prototype.map()")}}\n- {{jsxref("TypedArray.prototype.filter()")}}\n- {{jsxref("TypedArray.prototype.every()")}}\n- {{jsxref("TypedArray.prototype.some()")}}\n- {{jsxref("Array.prototype.forEach()")}}\n- {{jsxref("Map.prototype.forEach()")}}\n- {{jsxref("Set.prototype.forEach()")}}\n'
        },
        "from": {
            "index.md": '---\ntitle: TypedArray.from()\nslug: Web/JavaScript/Reference/Global_Objects/TypedArray/from\npage-type: javascript-static-method\nbrowser-compat: javascript.builtins.TypedArray.from\n---\n\n{{JSRef}}\n\nThe **`TypedArray.from()`** static method creates a new\n[typed array](/en-US/docs/Web/JavaScript/Reference/Global_Objects/TypedArray#typedarray_objects)\nfrom an array-like or iterable object. This method is nearly the same as\n{{jsxref("Array.from()")}}.\n\n{{EmbedInteractiveExample("pages/js/typedarray-from.html", "shorter")}}\n\n## Syntax\n\n```js-nolint\nTypedArray.from(arrayLike, mapFn)\nTypedArray.from(arrayLike, mapFn, thisArg)\n```\n\nWhere `TypedArray` is one of:\n\n- {{jsxref("Int8Array")}}\n- {{jsxref("Uint8Array")}}\n- {{jsxref("Uint8ClampedArray")}}\n- {{jsxref("Int16Array")}}\n- {{jsxref("Uint16Array")}}\n- {{jsxref("Int32Array")}}\n- {{jsxref("Uint32Array")}}\n- {{jsxref("Float32Array")}}\n- {{jsxref("Float64Array")}}\n- {{jsxref("BigInt64Array")}}\n- {{jsxref("BigUint64Array")}}\n\n### Parameters\n\n- `arrayLike`\n  - : An iterable or array-like object to convert to a typed array.\n- `mapFn` {{optional_inline}}\n  - : A function to call on every element of the typed array. If provided, every value to be added to the array is first passed through this function, and `mapFn`\'s return value is added to the typed array instead. The function is called with the following arguments:\n    - `element`\n      - : The current element being processed in the typed array.\n    - `index`\n      - : The index of the current element being processed in the typed array.\n- `thisArg` {{optional_inline}}\n  - : Value to use as `this` when executing `mapFn`.\n\n### Return value\n\nA new {{jsxref("TypedArray")}} instance.\n\n## Description\n\nSee {{jsxref("Array.from()")}} for more details.\n\nThere are some subtle distinctions between {{jsxref("Array.from()")}} and `TypedArray.from()` (note: the `this` value mentioned below is the `this` value that `TypedArray.from()` was called with, not the `thisArg` argument used to invoke `mapFn`):\n\n- If the `this` value of `TypedArray.from()` is not a constructor, `TypedArray.from()` will throw a {{jsxref("TypeError")}}, while `Array.from()` defaults to creating a new {{jsxref("Array")}}.\n- The object constructed by `this` must be a `TypedArray` instance, while `Array.from()` allows its `this` value to be constructed to any object.\n- When the `source` parameter is an iterator, `TypedArray.from()` first collects all the values from the iterator, then creates an instance of `this` using the count, and finally sets the values on the instance. `Array.from()` sets each value as it receives them from the iterator, then sets its `length` at the end.\n- `TypedArray.from()` uses `[[Set]]` while `Array.from()` uses `[[DefineOwnProperty]]`. Hence, when working with {{jsxref("Proxy")}} objects, it calls [`handler.set()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Proxy/Proxy/set) to create new elements rather than [`handler.defineProperty()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Proxy/Proxy/defineProperty).\n- When `Array.from()` gets an array-like which isn\'t an iterator, it respects holes. `TypedArray.from()` will ensure the result is dense.\n\n## Examples\n\n### From an iterable object (Set)\n\n```js\nconst s = new Set([1, 2, 3]);\nUint8Array.from(s);\n// Uint8Array [ 1, 2, 3 ]\n```\n\n### From a string\n\n```js\nInt16Array.from("123");\n// Int16Array [ 1, 2, 3 ]\n```\n\n### Use with arrow function and map\n\nUsing an arrow function as the map function to manipulate the elements\n\n```js\nFloat32Array.from([1, 2, 3], (x) => x + x);\n// Float32Array [ 2, 4, 6 ]\n```\n\n### Generate a sequence of numbers\n\n```js\nUint8Array.from({ length: 5 }, (v, k) => k);\n// Uint8Array [ 0, 1, 2, 3, 4 ]\n```\n\n### Calling from() on non-TypedArray constructors\n\nThe `this` value of `from()` must be a constructor that returns a `TypedArray` instance.\n\n```js\nfunction NotArray(len) {\n  console.log("NotArray called with length", len);\n}\n\nInt8Array.from.call({}, []); // TypeError: #<Object> is not a constructor\nInt8Array.from.call(NotArray, []);\n// NotArray called with length 0\n// TypeError: Method %TypedArray%.from called on incompatible receiver #<NotArray>\n```\n\n```js\nfunction NotArray2(len) {\n  console.log("NotArray2 called with length", len);\n  return new Uint8Array(len);\n}\nconsole.log(Int8Array.from.call(NotArray2, [1, 2, 3]));\n// NotArray2 called with length 3\n// Uint8Array(3) [ 1, 2, 3 ]\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `TypedArray.from` in `core-js`](https://github.com/zloirock/core-js#ecmascript-typed-arrays)\n- [JavaScript typed arrays](/en-US/docs/Web/JavaScript/Guide/Typed_arrays) guide\n- {{jsxref("TypedArray")}}\n- {{jsxref("TypedArray.of()")}}\n- {{jsxref("TypedArray.prototype.map()")}}\n- {{jsxref("Array.from()")}}\n'
        },
        "includes": {
            "index.md": '---\ntitle: TypedArray.prototype.includes()\nslug: Web/JavaScript/Reference/Global_Objects/TypedArray/includes\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.TypedArray.includes\n---\n\n{{JSRef}}\n\nThe **`includes()`** method of {{jsxref("TypedArray")}} instances determines whether a typed array includes a certain value among its entries, returning `true` or `false` as appropriate. This method has the same algorithm as {{jsxref("Array.prototype.includes()")}}.\n\n{{EmbedInteractiveExample("pages/js/typedarray-includes.html")}}\n\n## Syntax\n\n```js-nolint\nincludes(searchElement)\nincludes(searchElement, fromIndex)\n```\n\n### Parameters\n\n- `searchElement`\n  - : The value to search for.\n- `fromIndex` {{optional_inline}}\n  - : Zero-based index at which to start searching, [converted to an integer](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number#integer_conversion).\n\n### Return value\n\nA boolean value which is `true` if the value `searchElement` is found within the typed array (or the part of the typed array indicated by the index `fromIndex`, if specified).\n\n## Description\n\nSee {{jsxref("Array.prototype.includes()")}} for more details. This method is not generic and can only be called on typed array instances.\n\n## Examples\n\n### Using includes()\n\n```js\nconst uint8 = new Uint8Array([1, 2, 3]);\nuint8.includes(2); // true\nuint8.includes(4); // false\nuint8.includes(3, 3); // false\n\n// NaN handling (only true for Float32 and Float64)\nnew Uint8Array([NaN]).includes(NaN); // false, since the NaN passed to the constructor gets converted to 0\nnew Float32Array([NaN]).includes(NaN); // true;\nnew Float64Array([NaN]).includes(NaN); // true;\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `TypedArray.prototype.includes` in `core-js`](https://github.com/zloirock/core-js#ecmascript-typed-arrays)\n- [JavaScript typed arrays](/en-US/docs/Web/JavaScript/Guide/Typed_arrays) guide\n- {{jsxref("TypedArray")}}\n- {{jsxref("TypedArray.prototype.indexOf()")}}\n- {{jsxref("TypedArray.prototype.find()")}}\n- {{jsxref("TypedArray.prototype.findIndex()")}}\n- {{jsxref("Array.prototype.includes()")}}\n- {{jsxref("String.prototype.includes()")}}\n'
        },
        "index.md": '---\ntitle: TypedArray\nslug: Web/JavaScript/Reference/Global_Objects/TypedArray\npage-type: javascript-class\nbrowser-compat: javascript.builtins.TypedArray\n---\n\n{{JSRef}}\n\nA **_TypedArray_** object describes an array-like view of an\nunderlying [binary data buffer](/en-US/docs/Web/JavaScript/Reference/Global_Objects/ArrayBuffer).\nThere is no global property named `TypedArray`, nor is there a\ndirectly visible `TypedArray` constructor. Instead, there are a number of\ndifferent global properties, whose values are typed array constructors for specific\nelement types, listed below. On the following pages you will find common properties and\nmethods that can be used with any typed array containing elements of any type.\n\n{{EmbedInteractiveExample("pages/js/typedarray-constructor.html")}}\n\n## Description\n\nThe `TypedArray` constructor (often referred to as `%TypedArray%` to indicate its "intrinsicness", since it does not correspond to any global exposed to a JavaScript program) serves as the common superclass of all `TypedArray` subclasses. Think about `%TypedArray%` as an "abstract class" providing a common interface of utility methods for all typed array subclasses. This constructor is not directly exposed: there is no global `TypedArray` property. It is only accessible through `Object.getPrototypeOf(Int8Array)` and similar.\n\nWhen creating an instance of a `TypedArray` subclass (e.g. `Int8Array`), an array buffer is created internally in memory or, if an `ArrayBuffer` object is given as constructor argument, that `ArrayBuffer` is used instead. The buffer address is saved as an internal property of the instance and all the methods of `%TypedArray%.prototype` will set and get values based on that array buffer address.\n\n### TypedArray objects\n\n| Type                            | Value Range                           | Size in bytes | Web IDL type          |\n| ------------------------------- | ------------------------------------- | ------------- | --------------------- |\n| {{jsxref("Int8Array")}}         | -128 to 127                           | 1             | `byte`                |\n| {{jsxref("Uint8Array")}}        | 0 to 255                              | 1             | `octet`               |\n| {{jsxref("Uint8ClampedArray")}} | 0 to 255                              | 1             | `octet`               |\n| {{jsxref("Int16Array")}}        | -32768 to 32767                       | 2             | `short`               |\n| {{jsxref("Uint16Array")}}       | 0 to 65535                            | 2             | `unsigned short`      |\n| {{jsxref("Int32Array")}}        | -2147483648 to 2147483647             | 4             | `long`                |\n| {{jsxref("Uint32Array")}}       | 0 to 4294967295                       | 4             | `unsigned long`       |\n| {{jsxref("Float32Array")}}      | `-3.4e38` to `3.4e38`                 | 4             | `unrestricted float`  |\n| {{jsxref("Float64Array")}}      | `-1.8e308` to `1.8e308`               | 8             | `unrestricted double` |\n| {{jsxref("BigInt64Array")}}     | -2<sup>63</sup> to 2<sup>63</sup> - 1 | 8             | `bigint`              |\n| {{jsxref("BigUint64Array")}}    | 0 to 2<sup>64</sup> - 1               | 8             | `bigint`              |\n\n### Value encoding and normalization\n\nAll typed arrays operate on `ArrayBuffer`s, where you can observe the exact byte representation of each element, so how the numbers are encoded in binary format is significant.\n\n- Unsigned integer arrays (`Uint8Array`, `Uint16Array`, `Uint32Array`, and `BigUint64Array`) store the number directly in binary.\n- Signed integer arrays (`Int8Array`, `Int16Array`, `Int32Array`, and `BigInt64Array`) store the number using [two\'s complement](https://en.wikipedia.org/wiki/Two\'s_complement).\n- Floating-point arrays (`Float32Array` and `Float64Array`) store the number using [IEEE 754](https://en.wikipedia.org/wiki/IEEE_754) floating-point format. The [`Number`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number#number_encoding) reference has more information about the exact format. JavaScript numbers use double precision floating point format by default, which is the same as `Float64Array`. `Float32Array` uses 23 (instead of 52) bits for the mantissa and 8 (instead of 11) bits for the exponent. Note that the spec requires all {{jsxref("NaN")}} values to use the same bit encoding, but the exact bit pattern is implementation-dependent.\n- `Uint8ClampedArray` is a special case. It stores the number in binary like `Uint8Array` does, but when you store a number outside the range, it _clamps_ the number to the range 0 to 255 by mathematical value, instead of truncating the most significant bits.\n\nAll typed arrays except `Int8Array`, `Uint8Array`, and `Uint8ClampedArray` store each element using multiple bytes. These bytes can either be ordered from most significant to least significant (big-endian) or from least significant to most significant (little-endian). See [Endianness](/en-US/docs/Glossary/Endianness) for more explanation. Typed arrays always use the platform\'s native byte order. If you want to specify the endianness when writing and reading from buffers, you should use a {{jsxref("DataView")}} instead.\n\nWhen writing to these typed arrays, values that are outside the representable range are normalized.\n\n- All integer arrays (except `Uint8ClampedArray`) use [fixed-width number conversion](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number#fixed-width_number_conversion), which first truncates the decimal part of the number and then takes the lowest bits.\n- `Uint8ClampedArray` first clamps the number to the range 0 to 255 (values greater than 255 become 255 and values less than 0 become 0). It then _rounds_ (instead of flooring) the result to the nearest integer, with half-to-even; meaning if the number is exactly between two integers, it rounds to the nearest even integer. For example, `0.5` becomes `0`, `1.5` becomes `2`, and `2.5` becomes `2`.\n- `Float32Array` performs a "round to even" to convert 64-bit floating point numbers to 32-bit. This is the same algorithm as provided by {{jsxref("Math.fround()")}}.\n\n### Behavior when viewing a resizable buffer\n\nWhen a `TypedArray` is created as a view of a [resizable buffer](/en-US/docs/Web/JavaScript/Reference/Global_Objects/ArrayBuffer#resizing_arraybuffers), resizing the underlying buffer will have different effects on the size of the `TypedArray` depending on whether the `TypedArray` is constructed as length-tracking.\n\nIf a typed array is created without a specific size by omitting the third parameter or passing `undefined`, the typed array will become _length-tracking_, and will automatically resize to fit the underlying `buffer` as the latter is resized:\n\n```js\nconst buffer = new ArrayBuffer(8, { maxByteLength: 16 });\nconst float32 = new Float32Array(buffer);\n\nconsole.log(float32.byteLength); // 8\nconsole.log(float32.length); // 2\n\nbuffer.resize(12);\n\nconsole.log(float32.byteLength); // 12\nconsole.log(float32.length); // 3\n```\n\nIf a typed array is created with a specific size using the third `length` parameter, it won\'t resize to contain the `buffer` as the latter is grown:\n\n```js\nconst buffer = new ArrayBuffer(8, { maxByteLength: 16 });\nconst float32 = new Float32Array(buffer, 0, 2);\n\nconsole.log(float32.byteLength); // 8\nconsole.log(float32.length); // 2\nconsole.log(float32[0]); // 0, the initial value\n\nbuffer.resize(12);\n\nconsole.log(float32.byteLength); // 8\nconsole.log(float32.length); // 2\nconsole.log(float32[0]); // 0, the initial value\n```\n\nWhen a `buffer` is shrunk, the viewing typed array may become out of bounds, in which case the typed array\'s observed size will decrease to 0. This is the only case where a non-length-tracking typed array\'s length may change.\n\n```js\nconst buffer = new ArrayBuffer(8, { maxByteLength: 16 });\nconst float32 = new Float32Array(buffer, 0, 2);\n\nbuffer.resize(7);\n\nconsole.log(float32.byteLength); // 0\nconsole.log(float32.length); // 0\nconsole.log(float32[0]); // undefined\n```\n\nIf you then grow the `buffer` again to bring the typed array back in bounds, the typed array\'s size will be restored to its original value.\n\n```js\nbuffer.resize(8);\n\nconsole.log(float32.byteLength); // 8\nconsole.log(float32.length); // 2\nconsole.log(float32[0]); // 0 - back in bounds again!\n```\n\nThe same can happen for length-tracking typed arrays as well, if the buffer is shrunk beyond the `byteOffset`.\n\n```js\nconst buffer = new ArrayBuffer(8, { maxByteLength: 16 });\nconst float32 = new Float32Array(buffer, 4);\n// float32 is length-tracking, but it only extends from the 4th byte\n// to the end of the buffer, so if the buffer is resized to be shorter\n// than 4 bytes, the typed array will become out of bounds\nbuffer.resize(3);\nconsole.log(float32.byteLength); // 0\n```\n\n## Constructor\n\nThis object cannot be instantiated directly \u2014 attempting to construct it with `new` throws a {{jsxref("TypeError")}}.\n\n```js\nnew (Object.getPrototypeOf(Int8Array))();\n// TypeError: Abstract class TypedArray not directly constructable\n```\n\nInstead, you create an instance of a typed array of a particular type, such as an {{jsxref("Int8Array")}} or a {{jsxref("BigInt64Array")}}. These objects all have a common syntax for their constructors:\n\n```js-nolint\nnew TypedArray()\nnew TypedArray(length)\nnew TypedArray(typedArray)\nnew TypedArray(object)\n\nnew TypedArray(buffer)\nnew TypedArray(buffer, byteOffset)\nnew TypedArray(buffer, byteOffset, length)\n```\n\nWhere `TypedArray` is a constructor for one of the concrete types.\n\n> **Note:** All `TypedArray` subclasses\' constructors can only be constructed with [`new`](/en-US/docs/Web/JavaScript/Reference/Operators/new). Attempting to call one without `new` throws a {{jsxref("TypeError")}}.\n\n### Parameters\n\n- `typedArray`\n  - : When called with an instance of a `TypedArray` subclass, the `typedArray` gets copied into a new typed array. For a non-[bigint](/en-US/docs/Web/JavaScript/Reference/Global_Objects/BigInt) `TypedArray` constructor, the `typedArray` parameter can only be of one of the non-[bigint](/en-US/docs/Web/JavaScript/Reference/Global_Objects/BigInt) types (such as {{jsxref("Int32Array")}}). Similarly, for a [bigint](/en-US/docs/Web/JavaScript/Reference/Global_Objects/BigInt) `TypedArray` constructor ({{jsxref("BigInt64Array")}} or {{jsxref("BigUint64Array")}}), the `typedArray` parameter can only be of one of the [bigint](/en-US/docs/Web/JavaScript/Reference/Global_Objects/BigInt) types. Each value in `typedArray` is converted to the corresponding type of the constructor before being copied into the new array. The length of the new typed array will be same as the length of the `typedArray` argument.\n- `object`\n  - : When called with an object that\'s not a `TypedArray` instance, a new typed array is created in the same way as the [`TypedArray.from()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/TypedArray/from) method.\n- `length` {{optional_inline}}\n  - : When called with a non-object, the parameter will be treated as a number specifying the length of the typed array. An internal array buffer is created in memory, of size `length` multiplied by [`BYTES_PER_ELEMENT`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/TypedArray/BYTES_PER_ELEMENT) bytes, filled with zeros. Omitting all parameters is equivalent to using `0` as `length`.\n- `buffer`, `byteOffset` {{optional_inline}}, `length` {{optional_inline}}\n  - : When called with an [`ArrayBuffer`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/ArrayBuffer) or [`SharedArrayBuffer`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/SharedArrayBuffer) instance, and optionally a `byteOffset` and a `length` argument, a new typed array view is created that views the specified buffer. The `byteOffset` (in bytes) and `length` (in number of elements, each occupying [`BYTES_PER_ELEMENT`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/TypedArray/BYTES_PER_ELEMENT) bytes) parameters specify the memory range that will be exposed by the typed array view. If both are omitted, all of `buffer` is viewed; if only `length` is omitted, the remainder of `buffer` starting from `byteOffset` is viewed. If `length` is omitted, the typed array becomes [length-tracking](#behavior_when_viewing_a_resizable_buffer).\n\n### Exceptions\n\nAll `TypeArray` subclass constructors operate in the same way. They would all throw the following exceptions:\n\n- {{jsxref("TypeError")}}\n  - : Thrown in one of the following cases:\n    - A `typedArray` is passed but it is a [bigint](/en-US/docs/Web/JavaScript/Reference/Global_Objects/BigInt) type while the current constructor is not, or vice versa.\n    - A `typedArray` is passed but the buffer it\'s viewing is detached, or a detached `buffer` is directly passed.\n- {{jsxref("RangeError")}}\n  - : Thrown in one of the following cases:\n    - The new typed array\'s length is too large.\n    - The length of `buffer` (if the `length` parameter is not specified) or `byteOffset` is not an integral multiple of the new typed array\'s element size.\n    - `byteOffset` is not a valid array index (an integer between 0 and 2<sup>53</sup> - 1).\n    - When creating a view from a buffer, the bounds are outside the buffer. In other words, `byteOffset + length * TypedArray.BYTES_PER_ELEMENT > buffer.byteLength`.\n\n## Static properties\n\nThese properties are defined on the `TypedArray` constructor object and are thus shared by all `TypedArray` subclass constructors.\n\n- {{jsxref("TypedArray/@@species", "TypedArray[@@species]")}}\n  - : The constructor function used to create derived objects.\n\nAll `TypedArray` subclasses also have the following static properties:\n\n- {{jsxref("TypedArray.BYTES_PER_ELEMENT")}}\n  - : Returns a number value of the element size for the different `TypedArray` objects.\n\n## Static methods\n\nThese methods are defined on the `TypedArray` constructor object and are thus shared by all `TypedArray` subclass constructors.\n\n- {{jsxref("TypedArray.from()")}}\n  - : Creates a new `TypedArray` from an array-like or iterable object. See also {{jsxref("Array.from()")}}.\n- {{jsxref("TypedArray.of()")}}\n  - : Creates a new `TypedArray` with a variable number of arguments. See also {{jsxref("Array.of()")}}.\n\n## Instance properties\n\nThese properties are defined on `TypedArray.prototype` and shared by all `TypedArray` subclass instances.\n\n- {{jsxref("TypedArray.prototype.buffer")}}\n  - : Returns the {{jsxref("ArrayBuffer")}} referenced by the typed array.\n- {{jsxref("TypedArray.prototype.byteLength")}}\n  - : Returns the length (in bytes) of the typed array.\n- {{jsxref("TypedArray.prototype.byteOffset")}}\n  - : Returns the offset (in bytes) of the typed array from the start of its {{jsxref("ArrayBuffer")}}.\n- {{jsxref("Object/constructor", "TypedArray.prototype.constructor")}}\n  - : The constructor function that created the instance object. `TypedArray.prototype.constructor` is the hidden `TypedArray` constructor function, but each typed array subclass also defines its own `constructor` property.\n- {{jsxref("TypedArray.prototype.length")}}\n  - : Returns the number of elements held in the typed array.\n- `TypedArray.prototype[@@toStringTag]`\n  - : The initial value of the [`TypedArray.prototype[@@toStringTag]`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol/toStringTag) property is a getter that returns the same string as the typed array constructor\'s name. It returns `undefined` if the `this` value is not one of the typed array subclasses. This property is used in {{jsxref("Object.prototype.toString()")}}. However, because `TypedArray` also has its own [`toString()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/TypedArray/toString) method, this property is not used unless you call [`Object.prototype.toString.call()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/call) with a typed array as `thisArg`.\n\nAll `TypedArray` subclasses also have the following instance properties:\n\n- {{jsxref("TypedArray.prototype.BYTES_PER_ELEMENT")}}\n  - : Returns a number value of the element size for the different `TypedArray` objects.\n\n## Instance methods\n\nThese methods are defined on the `TypedArray` prototype object and are thus shared by all `TypedArray` subclass instances.\n\n- {{jsxref("TypedArray.prototype.at()")}}\n  - : Takes an integer value and returns the item at that index. This method allows for negative integers, which count back from the last item.\n- {{jsxref("TypedArray.prototype.copyWithin()")}}\n  - : Copies a sequence of array elements within the array. See also {{jsxref("Array.prototype.copyWithin()")}}.\n- {{jsxref("TypedArray.prototype.entries()")}}\n  - : Returns a new _array iterator_ object that contains the key/value pairs for each index in the array. See also {{jsxref("Array.prototype.entries()")}}.\n- {{jsxref("TypedArray.prototype.every()")}}\n  - : Tests whether all elements in the array pass the test provided by a function. See also {{jsxref("Array.prototype.every()")}}.\n- {{jsxref("TypedArray.prototype.fill()")}}\n  - : Fills all the elements of an array from a start index to an end index with a static value. See also {{jsxref("Array.prototype.fill()")}}.\n- {{jsxref("TypedArray.prototype.filter()")}}\n  - : Creates a new array with all of the elements of this array for which the provided filtering function returns `true`. See also {{jsxref("Array.prototype.filter()")}}.\n- {{jsxref("TypedArray.prototype.find()")}}\n  - : Returns the first `element` in the array that satisfies a provided testing function, or `undefined` if no appropriate element is found. See also {{jsxref("Array.prototype.find()")}}.\n- {{jsxref("TypedArray.prototype.findIndex()")}}\n  - : Returns the first index value in the array that has an element that satisfies a provided testing function, or `-1` if no appropriate element was found. See also {{jsxref("Array.prototype.findIndex()")}}.\n- {{jsxref("TypedArray.prototype.findLast()")}}\n  - : Returns the value of the last element in the array that satisfies a provided testing function, or `undefined` if no appropriate element is found. See also {{jsxref("Array.prototype.findLast()")}}.\n- {{jsxref("TypedArray.prototype.findLastIndex()")}}\n  - : Returns the index of the last element in the array that satisfies a provided testing function, or `-1` if no appropriate element was found. See also {{jsxref("Array.prototype.findLastIndex()")}}.\n- {{jsxref("TypedArray.prototype.forEach()")}}\n  - : Calls a function for each element in the array. See also {{jsxref("Array.prototype.forEach()")}}.\n- {{jsxref("TypedArray.prototype.includes()")}}\n  - : Determines whether a typed array includes a certain element, returning `true` or `false` as appropriate. See also {{jsxref("Array.prototype.includes()")}}.\n- {{jsxref("TypedArray.prototype.indexOf()")}}\n  - : Returns the first (least) index of an element within the array equal to the specified value, or `-1` if none is found. See also {{jsxref("Array.prototype.indexOf()")}}.\n- {{jsxref("TypedArray.prototype.join()")}}\n  - : Joins all elements of an array into a string. See also {{jsxref("Array.prototype.join()")}}.\n- {{jsxref("TypedArray.prototype.keys()")}}\n  - : Returns a new array iterator that contains the keys for each index in the array. See also {{jsxref("Array.prototype.keys()")}}.\n- {{jsxref("TypedArray.prototype.lastIndexOf()")}}\n  - : Returns the last (greatest) index of an element within the array equal to the specified value, or `-1` if none is found. See also {{jsxref("Array.prototype.lastIndexOf()")}}.\n- {{jsxref("TypedArray.prototype.map()")}}\n  - : Creates a new array with the results of calling a provided function on every element in this array. See also {{jsxref("Array.prototype.map()")}}.\n- {{jsxref("TypedArray.prototype.reduce()")}}\n  - : Apply a function against an accumulator and each value of the array (from left-to-right) as to reduce it to a single value. See also {{jsxref("Array.prototype.reduce()")}}.\n- {{jsxref("TypedArray.prototype.reduceRight()")}}\n  - : Apply a function against an accumulator and each value of the array (from right-to-left) as to reduce it to a single value. See also {{jsxref("Array.prototype.reduceRight()")}}.\n- {{jsxref("TypedArray.prototype.reverse()")}}\n  - : Reverses the order of the elements of an array \u2014 the first becomes the last, and the last becomes the first. See also {{jsxref("Array.prototype.reverse()")}}.\n- {{jsxref("TypedArray.prototype.set()")}}\n  - : Stores multiple values in the typed array, reading input values from a specified array.\n- {{jsxref("TypedArray.prototype.slice()")}}\n  - : Extracts a section of an array and returns a new array. See also {{jsxref("Array.prototype.slice()")}}.\n- {{jsxref("TypedArray.prototype.some()")}}\n  - : Returns `true` if at least one element in this array satisfies the provided testing function. See also {{jsxref("Array.prototype.some()")}}.\n- {{jsxref("TypedArray.prototype.sort()")}}\n  - : Sorts the elements of an array in place and returns the array. See also {{jsxref("Array.prototype.sort()")}}.\n- {{jsxref("TypedArray.prototype.subarray()")}}\n  - : Returns a new `TypedArray` from the given start and end element index.\n- {{jsxref("TypedArray.prototype.toLocaleString()")}}\n  - : Returns a localized string representing the array and its elements. See also {{jsxref("Array.prototype.toLocaleString()")}}.\n- {{jsxref("TypedArray.prototype.toReversed()")}}\n  - : Returns a new array with the elements in reversed order, without modifying the original array.\n- {{jsxref("TypedArray.prototype.toSorted()")}}\n  - : Returns a new array with the elements sorted in ascending order, without modifying the original array.\n- {{jsxref("TypedArray.prototype.toString()")}}\n  - : Returns a string representing the array and its elements. See also {{jsxref("Array.prototype.toString()")}}.\n- {{jsxref("TypedArray.prototype.values()")}}\n  - : Returns a new _array iterator_ object that contains the values for each index in the array. See also {{jsxref("Array.prototype.values()")}}.\n- {{jsxref("TypedArray.prototype.with()")}}\n  - : Returns a new array with the element at the given index replaced with the given value, without modifying the original array.\n- [`TypedArray.prototype[@@iterator]()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/TypedArray/@@iterator)\n  - : Returns a new _array iterator_ object that contains the values for each index in the array.\n\n## Examples\n\n### Property access\n\nYou can reference elements in the array using standard array index syntax (that is,\nusing bracket notation). However, getting or setting indexed properties on typed arrays\nwill not search in the prototype chain for this property, even when the indices are out\nof bound. Indexed properties will consult the {{jsxref("ArrayBuffer")}} and will never\nlook at object properties. You can still use named properties, just like with all\nobjects.\n\n```js\n// Setting and getting using standard array syntax\nconst int16 = new Int16Array(2);\nint16[0] = 42;\nconsole.log(int16[0]); // 42\n\n// Indexed properties on prototypes are not consulted (Fx 25)\nInt8Array.prototype[20] = "foo";\nnew Int8Array(32)[20]; // 0\n// even when out of bound\nInt8Array.prototype[20] = "foo";\nnew Int8Array(8)[20]; // undefined\n// or with negative integers\nInt8Array.prototype[-1] = "foo";\nnew Int8Array(8)[-1]; // undefined\n\n// Named properties are allowed, though (Fx 30)\nInt8Array.prototype.foo = "bar";\nnew Int8Array(32).foo; // "bar"\n```\n\n### Cannot be frozen\n\n`TypedArray`s that aren\'t empty cannot be frozen, as their\nunderlying `ArrayBuffer` could be mutated through another\n`TypedArray` view of the buffer. This would mean that the object\nwould never genuinely be frozen.\n\n```js example-bad\nconst i8 = Int8Array.of(1, 2, 3);\nObject.freeze(i8);\n// TypeError: Cannot freeze array buffer views with elements\n```\n\n### ByteOffset must be aligned\n\nWhen constructing a `TypedArray` as a view onto an\n`ArrayBuffer`, the `byteOffset` argument must be aligned to its\nelement size; in other words, the offset must be a multiple of\n`BYTES_PER_ELEMENT`.\n\n```js example-bad\nconst i32 = new Int32Array(new ArrayBuffer(4), 1);\n// RangeError: start offset of Int32Array should be a multiple of 4\n```\n\n```js example-good\nconst i32 = new Int32Array(new ArrayBuffer(4), 0);\n```\n\n### ByteLength must be aligned\n\nLike the `byteOffset` parameter, the `byteLength` property of an\n`ArrayBuffer` passed to a `TypedArray`\'s constructor\nmust be a multiple of the constructor\'s `BYTES_PER_ELEMENT`.\n\n```js example-bad\nconst i32 = new Int32Array(new ArrayBuffer(3));\n// RangeError: byte length of Int32Array should be a multiple of 4\n```\n\n```js example-good\nconst i32 = new Int32Array(new ArrayBuffer(4));\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of typed arrays in `core-js`](https://github.com/zloirock/core-js#ecmascript-typed-arrays)\n- [JavaScript typed arrays](/en-US/docs/Web/JavaScript/Guide/Typed_arrays) guide\n- {{jsxref("ArrayBuffer")}}\n- {{jsxref("DataView")}}\n- {{domxref("TextDecoder")}}\n',
        "indexof": {
            "index.md": '---\ntitle: TypedArray.prototype.indexOf()\nslug: Web/JavaScript/Reference/Global_Objects/TypedArray/indexOf\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.TypedArray.indexOf\n---\n\n{{JSRef}}\n\nThe **`indexOf()`** method of {{jsxref("TypedArray")}} instances returns the first index at which a given element can be found in the typed array, or -1 if it is not present. This method has the same algorithm as {{jsxref("Array.prototype.indexOf()")}}.\n\n{{EmbedInteractiveExample("pages/js/typedarray-indexof.html")}}\n\n## Syntax\n\n```js-nolint\nindexOf(searchElement)\nindexOf(searchElement, fromIndex)\n```\n\n### Parameters\n\n- `searchElement`\n  - : Element to locate in the typed array.\n- `fromIndex` {{optional_inline}}\n  - : Zero-based index at which to start searching, [converted to an integer](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number#integer_conversion).\n\n### Return value\n\nThe first index of `searchElement` in the typed array; `-1` if not found.\n\n## Description\n\nSee {{jsxref("Array.prototype.indexOf()")}} for more details. This method is not generic and can only be called on typed array instances.\n\n## Examples\n\n### Using indexOf()\n\n```js\nconst uint8 = new Uint8Array([2, 5, 9]);\nuint8.indexOf(2); // 0\nuint8.indexOf(7); // -1\nuint8.indexOf(9, 2); // 2\nuint8.indexOf(2, -1); // -1\nuint8.indexOf(2, -3); // 0\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `TypedArray.prototype.indexOf` in `core-js`](https://github.com/zloirock/core-js#ecmascript-typed-arrays)\n- [JavaScript typed arrays](/en-US/docs/Web/JavaScript/Guide/Typed_arrays) guide\n- {{jsxref("TypedArray")}}\n- {{jsxref("TypedArray.prototype.findIndex()")}}\n- {{jsxref("TypedArray.prototype.findLastIndex()")}}\n- {{jsxref("TypedArray.prototype.lastIndexOf()")}}\n- {{jsxref("Array.prototype.indexOf()")}}\n- {{jsxref("String.prototype.indexOf()")}}\n'
        },
        "join": {
            "index.md": '---\ntitle: TypedArray.prototype.join()\nslug: Web/JavaScript/Reference/Global_Objects/TypedArray/join\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.TypedArray.join\n---\n\n{{JSRef}}\n\nThe **`join()`** method of {{jsxref("TypedArray")}} instances creates and returns a new string by concatenating all of the elements in this typed array, separated by commas or a specified separator string. If the typed array has only one item, then that item will be returned without using the separator. This method has the same algorithm as {{jsxref("Array.prototype.join()")}}.\n\n{{EmbedInteractiveExample("pages/js/typedarray-join.html")}}\n\n## Syntax\n\n```js-nolint\njoin()\njoin(separator)\n```\n\n### Parameters\n\n- `separator` {{optional_inline}}\n  - : A string to separate each pair of adjacent elements of the typed array. If omitted, the typed array elements are separated with a comma (",").\n\n### Return value\n\nA string with all typed array elements joined. If `array.length` is `0`, the empty string is returned.\n\n## Description\n\nSee {{jsxref("Array.prototype.join()")}} for more details. This method is not generic and can only be called on typed array instances.\n\n## Examples\n\n### Using join()\n\n```js\nconst uint8 = new Uint8Array([1, 2, 3]);\nuint8.join(); // \'1,2,3\'\nuint8.join(" / "); // \'1 / 2 / 3\'\nuint8.join(""); // \'123\'\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `TypedArray.prototype.join` in `core-js`](https://github.com/zloirock/core-js#ecmascript-typed-arrays)\n- [JavaScript typed arrays](/en-US/docs/Web/JavaScript/Guide/Typed_arrays) guide\n- {{jsxref("TypedArray")}}\n- {{jsxref("TypedArray.prototype.toString()")}}\n- {{jsxref("Array.prototype.join()")}}\n- {{jsxref("String.prototype.split()")}}\n'
        },
        "keys": {
            "index.md": '---\ntitle: TypedArray.prototype.keys()\nslug: Web/JavaScript/Reference/Global_Objects/TypedArray/keys\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.TypedArray.keys\n---\n\n{{JSRef}}\n\nThe **`keys()`** method of {{jsxref("TypedArray")}} instances returns a new _[array iterator](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Iterator)_ object that contains the keys for each index in the typed array. This method has the same algorithm as {{jsxref("Array.prototype.keys()")}}.\n\n{{EmbedInteractiveExample("pages/js/typedarray-keys.html")}}\n\n## Syntax\n\n```js-nolint\nkeys()\n```\n\n### Parameters\n\nNone.\n\n### Return value\n\nA new [iterable iterator object](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Iterator).\n\n## Description\n\nSee {{jsxref("Array.prototype.keys()")}} for more details. This method is not generic and can only be called on typed array instances.\n\n## Examples\n\n### Iteration using for...of loop\n\n```js\nconst arr = new Uint8Array([10, 20, 30, 40, 50]);\nconst arrKeys = arr.keys();\nfor (const n of arrKeys) {\n  console.log(n);\n}\n```\n\n### Alternative iteration\n\n```js\nconst arr = new Uint8Array([10, 20, 30, 40, 50]);\nconst arrKeys = arr.keys();\nconsole.log(arrKeys.next().value); // 0\nconsole.log(arrKeys.next().value); // 1\nconsole.log(arrKeys.next().value); // 2\nconsole.log(arrKeys.next().value); // 3\nconsole.log(arrKeys.next().value); // 4\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `TypedArray.prototype.keys` in `core-js`](https://github.com/zloirock/core-js#ecmascript-typed-arrays)\n- [JavaScript typed arrays](/en-US/docs/Web/JavaScript/Guide/Typed_arrays) guide\n- {{jsxref("TypedArray")}}\n- {{jsxref("TypedArray.prototype.entries()")}}\n- {{jsxref("TypedArray.prototype.values()")}}\n- [`TypedArray.prototype[@@iterator]()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/TypedArray/@@iterator)\n- {{jsxref("Array.prototype.keys()")}}\n- [Iteration protocols](/en-US/docs/Web/JavaScript/Reference/Iteration_protocols)\n'
        },
        "lastindexof": {
            "index.md": '---\ntitle: TypedArray.prototype.lastIndexOf()\nslug: Web/JavaScript/Reference/Global_Objects/TypedArray/lastIndexOf\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.TypedArray.lastIndexOf\n---\n\n{{JSRef}}\n\nThe **`lastIndexOf()`** method of {{jsxref("TypedArray")}} instances returns the last index at which a given element can be found in the typed array, or -1 if it is not present. The typed array is searched backwards, starting at `fromIndex`. This method has the same algorithm as {{jsxref("Array.prototype.lastIndexOf()")}}.\n\n{{EmbedInteractiveExample("pages/js/typedarray-lastindexof.html")}}\n\n## Syntax\n\n```js-nolint\nlastIndexOf(searchElement)\nlastIndexOf(searchElement, fromIndex)\n```\n\n### Parameters\n\n- `searchElement`\n  - : Element to locate in the typed array.\n- `fromIndex` {{optional_inline}}\n  - : Zero-based index at which to start searching backwards, [converted to an integer](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number#integer_conversion).\n\n### Return value\n\nThe last index of `searchElement` in the typed array; `-1` if not found.\n\n## Description\n\nSee {{jsxref("Array.prototype.lastIndexOf()")}} for more details. This method is not generic and can only be called on typed array instances.\n\n## Examples\n\n### Using lastIndexOf()\n\n```js\nconst uint8 = new Uint8Array([2, 5, 9, 2]);\nuint8.lastIndexOf(2); // 3\nuint8.lastIndexOf(7); // -1\nuint8.lastIndexOf(2, 3); // 3\nuint8.lastIndexOf(2, 2); // 0\nuint8.lastIndexOf(2, -2); // 0\nuint8.lastIndexOf(2, -1); // 3\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `TypedArray.prototype.lastIndexOf` in `core-js`](https://github.com/zloirock/core-js#ecmascript-typed-arrays)\n- [JavaScript typed arrays](/en-US/docs/Web/JavaScript/Guide/Typed_arrays) guide\n- {{jsxref("TypedArray")}}\n- {{jsxref("TypedArray.prototype.findIndex()")}}\n- {{jsxref("TypedArray.prototype.findLastIndex()")}}\n- {{jsxref("TypedArray.prototype.indexOf()")}}\n- {{jsxref("Array.prototype.lastIndexOf()")}}\n- {{jsxref("String.prototype.lastIndexOf()")}}\n'
        },
        "length": {
            "index.md": '---\ntitle: TypedArray.prototype.length\nslug: Web/JavaScript/Reference/Global_Objects/TypedArray/length\npage-type: javascript-instance-accessor-property\nbrowser-compat: javascript.builtins.TypedArray.length\n---\n\n{{JSRef}}\n\nThe **`length`** accessor property of {{jsxref("TypedArray")}} instances returns the length (in elements) of this typed array.\n\n{{EmbedInteractiveExample("pages/js/typedarray-length.html", "shorter")}}\n\n## Description\n\nThe `length` property is an accessor property whose set accessor function is `undefined`, meaning that you can only read this property. The value is established when a _TypedArray_ is constructed and cannot be changed. If the _TypedArray_ is not specifying a `byteOffset` or a `length`, the length of the referenced {{jsxref("ArrayBuffer")}} will be returned. _TypedArray_ is one of the [TypedArray objects](/en-US/docs/Web/JavaScript/Reference/Global_Objects/TypedArray#typedarray_objects).\n\n## Examples\n\n### Using the `length` property\n\n```js\nconst buffer = new ArrayBuffer(8);\n\nlet uint8 = new Uint8Array(buffer);\nuint8.length; // 8 (matches the length of the buffer)\n\nuint8 = new Uint8Array(buffer, 1, 5);\nuint8.length; // 5 (as specified when constructing the Uint8Array)\n\nuint8 = new Uint8Array(buffer, 2);\nuint8.length; // 6 (due to the offset of the constructed Uint8Array)\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [JavaScript typed arrays](/en-US/docs/Web/JavaScript/Guide/Typed_arrays) guide\n- {{jsxref("TypedArray")}}\n'
        },
        "map": {
            "index.md": '---\ntitle: TypedArray.prototype.map()\nslug: Web/JavaScript/Reference/Global_Objects/TypedArray/map\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.TypedArray.map\n---\n\n{{JSRef}}\n\nThe **`map()`** method of {{jsxref("TypedArray")}} instances creates a new typed array populated with the results of calling a provided function on every element in the calling typed array. This method has the same algorithm as {{jsxref("Array.prototype.map()")}}.\n\n{{EmbedInteractiveExample("pages/js/typedarray-map.html", "shorter")}}\n\n## Syntax\n\n```js-nolint\nmap(callbackFn)\nmap(callbackFn, thisArg)\n```\n\n### Parameters\n\n- `callbackFn`\n  - : A function to execute for each element in the typed array. Its return value is added as a single element in the new typed array. The function is called with the following arguments:\n    - `element`\n      - : The current element being processed in the typed array.\n    - `index`\n      - : The index of the current element being processed in the typed array.\n    - `array`\n      - : The typed array `map()` was called upon.\n- `thisArg` {{optional_inline}}\n  - : A value to use as `this` when executing `callbackFn`. See [iterative methods](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array#iterative_methods).\n\n### Return value\n\nA new typed array with each element being the result of the callback function.\n\n## Description\n\nSee {{jsxref("Array.prototype.map()")}} for more details. This method is not generic and can only be called on typed array instances.\n\n## Examples\n\n### Mapping a typed array to a typed array of square roots\n\nThe following code takes a typed array and creates a new typed array containing the\nsquare roots of the numbers in the first typed array.\n\n```js\nconst numbers = new Uint8Array([1, 4, 9]);\nconst roots = numbers.map(Math.sqrt);\n// roots is now: Uint8Array [1, 2, 3],\n// numbers is still Uint8Array [1, 4, 9]\n```\n\n### Mapping a typed array of numbers using a function containing an argument\n\nThe following code shows how `map()` works when a function requiring one\nargument is used with it. The argument will automatically be assigned to each element of\nthe typed array as `map()` loops through the original typed array.\n\n```js\nconst numbers = new Uint8Array([1, 4, 9]);\nconst doubles = numbers.map((num) => num * 2);\n// doubles is now Uint8Array [2, 8, 18]\n// numbers is still Uint8Array [1, 4, 9]\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `TypedArray.prototype.map` in `core-js`](https://github.com/zloirock/core-js#ecmascript-typed-arrays)\n- [JavaScript typed arrays](/en-US/docs/Web/JavaScript/Guide/Typed_arrays) guide\n- {{jsxref("TypedArray")}}\n- {{jsxref("TypedArray.prototype.forEach()")}}\n- {{jsxref("TypedArray.from()")}}\n- {{jsxref("Array.prototype.map()")}}\n- {{jsxref("Map")}}\n'
        },
        "of": {
            "index.md": '---\ntitle: TypedArray.of()\nslug: Web/JavaScript/Reference/Global_Objects/TypedArray/of\npage-type: javascript-static-method\nbrowser-compat: javascript.builtins.TypedArray.of\n---\n\n{{JSRef}}\n\nThe **`TypedArray.of()`** static method creates a new\n[typed array](/en-US/docs/Web/JavaScript/Reference/Global_Objects/TypedArray#typedarray_objects) from a variable number of arguments. This method is nearly the same as\n{{jsxref("Array.of()")}}.\n\n{{EmbedInteractiveExample("pages/js/typedarray-of.html", "shorter")}}\n\n## Syntax\n\n```js-nolint\nTypedArray.of()\nTypedArray.of(element1)\nTypedArray.of(element1, element2)\nTypedArray.of(element1, element2, /* \u2026, */ elementN)\n```\n\nWhere `TypedArray` is one of:\n\n- {{jsxref("Int8Array")}}\n- {{jsxref("Uint8Array")}}\n- {{jsxref("Uint8ClampedArray")}}\n- {{jsxref("Int16Array")}}\n- {{jsxref("Uint16Array")}}\n- {{jsxref("Int32Array")}}\n- {{jsxref("Uint32Array")}}\n- {{jsxref("Float32Array")}}\n- {{jsxref("Float64Array")}}\n- {{jsxref("BigInt64Array")}}\n- {{jsxref("BigUint64Array")}}\n\n### Parameters\n\n- `element1`, \u2026, `elementN`\n  - : Elements used to create the typed array.\n\n### Return value\n\nA new {{jsxref("TypedArray")}} instance.\n\n## Description\n\nSee {{jsxref("Array.of()")}} for more details. There are some subtle distinctions between {{jsxref("Array.of()")}} and\n`TypedArray.of()`:\n\n- If the `this` value passed to `TypedArray.of()` is not a constructor, `TypedArray.from()` will throw a {{jsxref("TypeError")}}, while `Array.of()` defaults to creating a new {{jsxref("Array")}}.\n- `TypedArray.of()` uses `[[Set]]` while `Array.of()` uses `[[DefineOwnProperty]]`. Hence, when working with {{jsxref("Proxy")}} objects, it calls [`handler.set()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Proxy/Proxy/set) to create new elements rather than [`handler.defineProperty()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Proxy/Proxy/defineProperty).\n\n## Examples\n\n### Using of()\n\n```js\nUint8Array.of(1); // Uint8Array [ 1 ]\nInt8Array.of("1", "2", "3"); // Int8Array [ 1, 2, 3 ]\nFloat32Array.of(1, 2, 3); // Float32Array [ 1, 2, 3 ]\nInt16Array.of(undefined); // Int16Array [ 0 ]\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `TypedArray.of` in `core-js`](https://github.com/zloirock/core-js#ecmascript-typed-arrays)\n- [JavaScript typed arrays](/en-US/docs/Web/JavaScript/Guide/Typed_arrays) guide\n- {{jsxref("TypedArray")}}\n- {{jsxref("TypedArray.from()")}}\n- {{jsxref("Array.of()")}}\n'
        },
        "reduce": {
            "index.md": '---\ntitle: TypedArray.prototype.reduce()\nslug: Web/JavaScript/Reference/Global_Objects/TypedArray/reduce\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.TypedArray.reduce\n---\n\n{{JSRef}}\n\nThe **`reduce()`** method of {{jsxref("TypedArray")}} instances executes a user-supplied "reducer" callback function on each element of the typed array, in order, passing in the return value from the calculation on the preceding element. The final result of running the reducer across all elements of the typed array is a single value. This method has the same algorithm as {{jsxref("Array.prototype.reduce()")}}.\n\n{{EmbedInteractiveExample("pages/js/typedarray-reduce.html")}}\n\n## Syntax\n\n```js-nolint\nreduce(callbackFn)\nreduce(callbackFn, initialValue)\n```\n\n### Parameters\n\n- `callbackFn`\n  - : A function to execute for each element in the typed array. Its return value becomes the value of the `accumulator` parameter on the next invocation of `callbackFn`. For the last invocation, the return value becomes the return value of `reduce()`. The function is called with the following arguments:\n    - `accumulator`\n      - : The value resulting from the previous call to `callbackFn`. On the first call, its value is `initialValue` if the latter is specified; otherwise its value is `array[0]`.\n    - `currentValue`\n      - : The value of the current element. On the first call, its value is `array[0]` if `initialValue` is specified; otherwise its value is `array[1]`.\n    - `currentIndex`\n      - : The index position of `currentValue` in the typed array. On the first call, its value is `0` if `initialValue` is specified, otherwise `1`.\n    - `array`\n      - : The typed array `reduce()` was called upon.\n- `initialValue` {{optional_inline}}\n  - : A value to which `accumulator` is initialized the first time the callback is called.\n    If `initialValue` is specified, `callbackFn` starts executing with the first value in the typed array as `currentValue`.\n    If `initialValue` is _not_ specified, `accumulator` is initialized to the first value in the typed array, and `callbackFn` starts executing with the second value in the typed array as `currentValue`. In this case, if the typed array is empty (so that there\'s no first value to return as `accumulator`), an error is thrown.\n\n### Return value\n\nThe value that results from running the "reducer" callback function to completion over the entire typed array.\n\n### Exceptions\n\n- {{jsxref("TypeError")}}\n  - : Thrown if the typed array contains no elements and `initialValue` is not provided.\n\n## Description\n\nSee {{jsxref("Array.prototype.reduce()")}} for more details. This method is not generic and can only be called on typed array instances.\n\n## Examples\n\n### Sum up all values within an array\n\n```js\nconst total = new Uint8Array([0, 1, 2, 3]).reduce((a, b) => a + b);\n// total === 6\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `TypedArray.prototype.reduce` in `core-js`](https://github.com/zloirock/core-js#ecmascript-typed-arrays)\n- [JavaScript typed arrays](/en-US/docs/Web/JavaScript/Guide/Typed_arrays) guide\n- {{jsxref("TypedArray")}}\n- {{jsxref("TypedArray.prototype.map()")}}\n- {{jsxref("TypedArray.prototype.reduceRight()")}}\n- {{jsxref("Array.prototype.reduce()")}}\n- {{jsxref("Object.groupBy()")}}\n- {{jsxref("Map.groupBy()")}}\n'
        },
        "reduceright": {
            "index.md": '---\ntitle: TypedArray.prototype.reduceRight()\nslug: Web/JavaScript/Reference/Global_Objects/TypedArray/reduceRight\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.TypedArray.reduceRight\n---\n\n{{JSRef}}\n\nThe **`reduceRight()`** method of {{jsxref("TypedArray")}} instances applies a function against an accumulator and each value of the typed array (from right-to-left) to reduce it to a single value. This method has the same algorithm as {{jsxref("Array.prototype.reduceRight()")}}.\n\n{{EmbedInteractiveExample("pages/js/typedarray-reduceright.html")}}\n\n## Syntax\n\n```js-nolint\nreduceRight(callbackFn)\nreduceRight(callbackFn, initialValue)\n```\n\n### Parameters\n\n- `callbackFn`\n  - : A function to execute for each element in the typed array. Its return value becomes the value of the `accumulator` parameter on the next invocation of `callbackFn`. For the last invocation, the return value becomes the return value of `reduceRight()`. The function is called with the following arguments:\n    - `accumulator`\n      - : The value resulting from the previous call to `callbackFn`. On the first call, its value is `initialValue` if the latter is specified; otherwise its value is the last element of the typed array.\n    - `currentValue`\n      - : The value of the current element. On the first call, its value is the last element if `initialValue` is specified; otherwise its value is the second-to-last element.\n    - `currentIndex`\n      - : The index position of `currentValue` in the typed array. On the first call, its value is `array.length - 1` if `initialValue` is specified, otherwise `array.length - 2`.\n    - `array`\n      - : The typed array `reduceRight()` was called upon.\n- `initialValue` {{optional_inline}}\n  - : Value to use as accumulator to the first call of the `callbackFn`. If no initial value is supplied, the last element in the typed array will be used and skipped. Calling `reduceRight()` on an empty typed array without an initial value creates a `TypeError`.\n\n### Return value\n\nThe value that results from the reduction.\n\n## Description\n\nSee {{jsxref("Array.prototype.reduceRight()")}} for more details. This method is not generic and can only be called on typed array instances.\n\n## Examples\n\n### Sum up all values within an array\n\n```js\nconst total = new Uint8Array([0, 1, 2, 3]).reduceRight((a, b) => a + b);\n// total === 6\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `TypedArray.prototype.reduceRight` in `core-js`](https://github.com/zloirock/core-js#ecmascript-typed-arrays)\n- [JavaScript typed arrays](/en-US/docs/Web/JavaScript/Guide/Typed_arrays) guide\n- {{jsxref("TypedArray")}}\n- {{jsxref("TypedArray.prototype.map()")}}\n- {{jsxref("TypedArray.prototype.reduce()")}}\n- {{jsxref("Array.prototype.reduceRight()")}}\n- {{jsxref("Object.groupBy()")}}\n- {{jsxref("Map.groupBy()")}}\n'
        },
        "reverse": {
            "index.md": '---\ntitle: TypedArray.prototype.reverse()\nslug: Web/JavaScript/Reference/Global_Objects/TypedArray/reverse\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.TypedArray.reverse\n---\n\n{{JSRef}}\n\nThe **`reverse()`** method of {{jsxref("TypedArray")}} instances reverses a typed array _[in place](https://en.wikipedia.org/wiki/In-place_algorithm)_ and returns the reference to the same typed array, the first typed array element now becoming the last, and the last typed array element becoming the first. In other words, elements order in the typed array will be turned towards the direction opposite to that previously stated. This method has the same algorithm as {{jsxref("Array.prototype.reverse()")}}.\n\n{{EmbedInteractiveExample("pages/js/typedarray-reverse.html", "shorter")}}\n\n## Syntax\n\n```js-nolint\nreverse()\n```\n\n### Parameters\n\nNone.\n\n### Return value\n\nThe reference to the original typed array, now reversed. Note that the typed array is reversed _[in place](https://en.wikipedia.org/wiki/In-place_algorithm)_, and no copy is made.\n\n## Description\n\nSee {{jsxref("Array.prototype.reverse()")}} for more details. This method is not generic and can only be called on typed array instances.\n\n## Examples\n\n### Using reverse()\n\n```js\nconst uint8 = new Uint8Array([1, 2, 3]);\nuint8.reverse();\n\nconsole.log(uint8); // Uint8Array [3, 2, 1]\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `TypedArray.prototype.reverse` in `core-js`](https://github.com/zloirock/core-js#ecmascript-typed-arrays)\n- [JavaScript typed arrays](/en-US/docs/Web/JavaScript/Guide/Typed_arrays) guide\n- {{jsxref("TypedArray")}}\n- {{jsxref("TypedArray.prototype.join()")}}\n- {{jsxref("TypedArray.prototype.sort()")}}\n- {{jsxref("TypedArray.prototype.toReversed()")}}\n- {{jsxref("Array.prototype.reverse()")}}\n'
        },
        "set": {
            "index.md": '---\ntitle: TypedArray.prototype.set()\nslug: Web/JavaScript/Reference/Global_Objects/TypedArray/set\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.TypedArray.set\n---\n\n{{JSRef}}\n\nThe **`set()`** method of {{jsxref("TypedArray")}} instances stores multiple values in the typed\narray, reading input values from a specified array.\n\n{{EmbedInteractiveExample("pages/js/typedarray-set.html")}}\n\n## Syntax\n\n```js-nolint\nset(array)\nset(array, targetOffset)\n\nset(typedarray)\nset(typedarray, targetOffset)\n```\n\n### Parameters\n\n- `array`\n  - : The array from which to copy values. All values from the source array are copied\n    into the target array, unless the length of the source array plus the target offset exceeds\n    the length of the target array, in which case an exception is thrown.\n- `typedarray`\n  - : If the source array is a typed array, the two arrays may share the same underlying\n    {{jsxref("ArrayBuffer")}}; the JavaScript engine will intelligently\n    **copy** the source range of the buffer to the destination range.\n- `targetOffset` {{optional_inline}}\n  - : The offset into the target array at which to begin writing values from the source\n    array. If this value is omitted, 0 is assumed (that is, the source array will\n    overwrite values in the target array starting at index 0).\n\n### Return value\n\nNone ({{jsxref("undefined")}}).\n\n### Exceptions\n\n- {{jsxref("RangeError")}}\n  - : Thrown in one of the following cases:\n    - An element will be stored beyond the end of the typed array, either because `targetOffset` is too large or because `array` or `typedarray` is too large.\n    - `targetOffset` is negative.\n\n## Examples\n\n### Using set()\n\n```js\nconst buffer = new ArrayBuffer(8);\nconst uint8 = new Uint8Array(buffer);\n\nuint8.set([1, 2, 3], 3);\n\nconsole.log(uint8); // Uint8Array [ 0, 0, 0, 1, 2, 3, 0, 0 ]\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `TypedArray.prototype.set` in `core-js`](https://github.com/zloirock/core-js#ecmascript-typed-arrays)\n- [JavaScript typed arrays](/en-US/docs/Web/JavaScript/Guide/Typed_arrays) guide\n- {{jsxref("TypedArray")}}\n- {{jsxref("ArrayBuffer")}}\n'
        },
        "slice": {
            "index.md": '---\ntitle: TypedArray.prototype.slice()\nslug: Web/JavaScript/Reference/Global_Objects/TypedArray/slice\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.TypedArray.slice\n---\n\n{{JSRef}}\n\nThe **`slice()`** method of {{jsxref("TypedArray")}} instances returns a copy of a portion of a typed array into a new typed array object selected from `start` to `end` (`end` not included) where `start` and `end` represent the index of items in that typed array. The original typed array will not be modified. This method has the same algorithm as {{jsxref("Array.prototype.slice()")}}.\n\n{{EmbedInteractiveExample("pages/js/typedarray-slice.html", "shorter")}}\n\n## Syntax\n\n```js-nolint\nslice()\nslice(start)\nslice(start, end)\n```\n\n### Parameters\n\n- `start` {{optional_inline}}\n  - : Zero-based index at which to start extraction, [converted to an integer](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number#integer_conversion).\n- `end` {{optional_inline}}\n  - : Zero-based index at which to end extraction, [converted to an integer](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number#integer_conversion). `slice()` extracts up to but not including `end`.\n\n### Return value\n\nA new typed array containing the extracted elements.\n\n## Description\n\nSee {{jsxref("Array.prototype.slice()")}} for more details. This method is not generic and can only be called on typed array instances.\n\n## Examples\n\n### Return a portion of an existing typed array\n\n```js\nconst uint8 = new Uint8Array([1, 2, 3]);\nuint8.slice(1); // Uint8Array [ 2, 3 ]\nuint8.slice(2); // Uint8Array [ 3 ]\nuint8.slice(-2); // Uint8Array [ 2, 3 ]\nuint8.slice(0, 1); // Uint8Array [ 1 ]\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `TypedArray.prototype.slice` in `core-js`](https://github.com/zloirock/core-js#ecmascript-typed-arrays)\n- [JavaScript typed arrays](/en-US/docs/Web/JavaScript/Guide/Typed_arrays) guide\n- {{jsxref("TypedArray")}}\n- {{jsxref("Array.prototype.slice()")}}\n- {{jsxref("String.prototype.slice()")}}\n'
        },
        "some": {
            "index.md": '---\ntitle: TypedArray.prototype.some()\nslug: Web/JavaScript/Reference/Global_Objects/TypedArray/some\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.TypedArray.some\n---\n\n{{JSRef}}\n\nThe **`some()`** method of {{jsxref("TypedArray")}} instances tests whether at least one element in the typed array passes the test implemented by the provided function. It returns true if, in the typed array, it finds an element for which the provided function returns true; otherwise it returns false. It doesn\'t modify the typed array. This method has the same algorithm as {{jsxref("Array.prototype.some()")}}.\n\n{{EmbedInteractiveExample("pages/js/typedarray-some.html")}}\n\n## Syntax\n\n```js-nolint\nsome(callbackFn)\nsome(callbackFn, thisArg)\n```\n\n### Parameters\n\n- `callbackFn`\n  - : A function to execute for each element in the typed array. It should return a [truthy](/en-US/docs/Glossary/Truthy) value to indicate the element passes the test, and a [falsy](/en-US/docs/Glossary/Falsy) value otherwise. The function is called with the following arguments:\n    - `element`\n      - : The current element being processed in the typed array.\n    - `index`\n      - : The index of the current element being processed in the typed array.\n    - `array`\n      - : The typed array `some()` was called upon.\n- `thisArg` {{optional_inline}}\n  - : A value to use as `this` when executing `callbackFn`. See [iterative methods](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array#iterative_methods).\n\n### Return value\n\n`false` unless `callbackFn` returns a {{Glossary("truthy")}} value for a typed array element, in which case `true` is immediately returned.\n\n## Description\n\nSee {{jsxref("Array.prototype.some()")}} for more details. This method is not generic and can only be called on typed array instances.\n\n## Examples\n\n### Testing size of all typed array elements\n\nThe following example tests whether any element in the typed array is bigger than 10.\n\n```js\nfunction isBiggerThan10(element, index, array) {\n  return element > 10;\n}\nnew Uint8Array([2, 5, 8, 1, 4]).some(isBiggerThan10); // false\nnew Uint8Array([12, 5, 8, 1, 4]).some(isBiggerThan10); // true\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `TypedArray.prototype.some` in `core-js`](https://github.com/zloirock/core-js#ecmascript-typed-arrays)\n- [JavaScript typed arrays](/en-US/docs/Web/JavaScript/Guide/Typed_arrays) guide\n- {{jsxref("TypedArray")}}\n- {{jsxref("TypedArray.prototype.every()")}}\n- {{jsxref("TypedArray.prototype.forEach()")}}\n- {{jsxref("TypedArray.prototype.find()")}}\n- {{jsxref("TypedArray.prototype.includes()")}}\n- {{jsxref("Array.prototype.some()")}}\n'
        },
        "sort": {
            "index.md": '---\ntitle: TypedArray.prototype.sort()\nslug: Web/JavaScript/Reference/Global_Objects/TypedArray/sort\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.TypedArray.sort\n---\n\n{{JSRef}}\n\nThe **`sort()`** method of {{jsxref("TypedArray")}} instances sorts the elements of a typed array _[in place](https://en.wikipedia.org/wiki/In-place_algorithm)_ and returns the reference to the same typed array, now sorted. This method has the same algorithm as {{jsxref("Array.prototype.sort()")}}, except that it sorts the values numerically instead of as strings by default.\n\n{{EmbedInteractiveExample("pages/js/typedarray-sort.html", "shorter")}}\n\n## Syntax\n\n```js-nolint\nsort()\nsort(compareFn)\n```\n\n### Parameters\n\n- `compareFn` {{optional_inline}}\n\n  - : A function that defines the sort order. The return value should be a number whose sign indicates the relative order of the two elements: negative if `a` is less than `b`, positive if `a` is greater than `b`, and zero if they are equal. `NaN` is treated as `0`. The function is called with the following arguments:\n\n    - `a`\n      - : The first element for comparison. Will never be `undefined`.\n    - `b`\n      - : The second element for comparison. Will never be `undefined`.\n\n    If omitted, the typed array elements are sorted according to numeric value.\n\n### Return value\n\nThe reference to the original typed array, now sorted. Note that the typed array is sorted _[in place](https://en.wikipedia.org/wiki/In-place_algorithm)_, and no copy is made.\n\n## Description\n\nSee {{jsxref("Array.prototype.sort()")}} for more details. This method is not generic and can only be called on typed array instances.\n\n## Examples\n\n### Using sort()\n\nFor more examples, see also the {{jsxref("Array.prototype.sort()")}} method.\n\n```js\nlet numbers = new Uint8Array([40, 1, 5, 200]);\nnumbers.sort();\n// Uint8Array [ 1, 5, 40, 200 ]\n// Unlike plain Arrays, a compare function is not required\n// to sort the numbers numerically.\n\n// Regular Arrays require a compare function to sort numerically:\nnumbers = [40, 1, 5, 200];\nnumbers.sort();\n// [1, 200, 40, 5]\n\nnumbers.sort((a, b) => a - b); // compare numbers\n// [ 1, 5, 40, 200 ]\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `TypedArray.prototype.sort` with modern behavior like stable sort in `core-js`](https://github.com/zloirock/core-js#ecmascript-typed-arrays)\n- [JavaScript typed arrays](/en-US/docs/Web/JavaScript/Guide/Typed_arrays) guide\n- {{jsxref("TypedArray")}}\n- {{jsxref("TypedArray.prototype.reverse()")}}\n- {{jsxref("TypedArray.prototype.toSorted()")}}\n- {{jsxref("Array.prototype.sort()")}}\n'
        },
        "subarray": {
            "index.md": '---\ntitle: TypedArray.prototype.subarray()\nslug: Web/JavaScript/Reference/Global_Objects/TypedArray/subarray\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.TypedArray.subarray\n---\n\n{{JSRef}}\n\nThe **`subarray()`** method of {{jsxref("TypedArray")}} instances returns a new typed array\non the same {{jsxref("ArrayBuffer")}} store and with the same element types as for this\ntyped array. The begin offset is **inclusive** and the end\noffset is **exclusive**.\n\n{{EmbedInteractiveExample("pages/js/typedarray-subarray.html")}}\n\n## Syntax\n\n```js-nolint\nsubarray()\nsubarray(begin)\nsubarray(begin, end)\n```\n\n### Parameters\n\n- `begin` {{optional_inline}}\n  - : Element to begin at. The offset is inclusive. The whole array will be included in\n    the new view if this value is not specified.\n- `end` {{optional_inline}}\n  - : Element to end at. The offset is exclusive. If not specified, all elements from the\n    one specified by `begin` to the end of the array are included in\n    the new view.\n\n### Return value\n\nA new {{jsxref("TypedArray")}} object.\n\n## Description\n\nThe range specified by `begin` and `end` is\nclamped to the valid index range for the current array; if the computed length of the\nnew array would be negative, it\'s clamped to zero. If either\n`begin` or `end` is negative, it refers to\nan index from the end of the array instead of from the beginning.\n\nAlso note that this is creating a new view on the existing buffer; changes to the new\nobject\'s contents will impact the original object and vice versa.\n\n## Examples\n\n### Using the subarray() method\n\n```js\nconst buffer = new ArrayBuffer(8);\nconst uint8 = new Uint8Array(buffer);\nuint8.set([1, 2, 3]);\n\nconsole.log(uint8); // Uint8Array [ 1, 2, 3, 0, 0, 0, 0, 0 ]\n\nconst sub = uint8.subarray(0, 4);\n\nconsole.log(sub); // Uint8Array [ 1, 2, 3, 0 ]\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `TypedArray.prototype.subarray` in `core-js`](https://github.com/zloirock/core-js#ecmascript-typed-arrays)\n- [JavaScript typed arrays](/en-US/docs/Web/JavaScript/Guide/Typed_arrays) guide\n- {{jsxref("TypedArray")}}\n- {{jsxref("ArrayBuffer")}}\n'
        },
        "tolocalestring": {
            "index.md": '---\ntitle: TypedArray.prototype.toLocaleString()\nslug: Web/JavaScript/Reference/Global_Objects/TypedArray/toLocaleString\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.TypedArray.toLocaleString\n---\n\n{{JSRef}}\n\nThe **`toLocaleString()`** method of {{jsxref("TypedArray")}} instances returns a string representing the elements of the typed array. The elements are converted to strings using their `toLocaleString` methods and these strings are separated by a locale-specific string (such as a comma ","). This method has the same algorithm as {{jsxref("Array.prototype.toLocaleString()")}}.\n\n{{EmbedInteractiveExample("pages/js/typedarray-tolocalestring.html")}}\n\n## Syntax\n\n```js-nolint\ntoLocaleString()\ntoLocaleString(locales)\ntoLocaleString(locales, options)\n```\n\n### Parameters\n\n- `locales` {{optional_inline}}\n  - : A string with a BCP 47 language tag, or an array of such strings. For the general form and interpretation of the `locales` argument, see [the parameter description on the `Intl` main page](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl#locales_argument).\n- `options` {{optional_inline}}\n  - : An object with configuration properties. See {{jsxref("Number.prototype.toLocaleString()")}}.\n\n### Return value\n\nA string representing the elements of the typed array.\n\n## Description\n\nSee {{jsxref("Array.prototype.toLocaleString()")}} for more details. This method is not generic and can only be called on typed array instances.\n\n## Examples\n\n### Using toLocaleString()\n\n```js\nconst uint = new Uint32Array([2000, 500, 8123, 12, 4212]);\n\nuint.toLocaleString();\n// if run in a de-DE locale\n// "2.000,500,8.123,12,4.212"\n\nuint.toLocaleString("en-US");\n// "2,000,500,8,123,12,4,212"\n\nuint.toLocaleString("ja-JP", { style: "currency", currency: "JPY" });\n// "\uFFE52,000,\uFFE5500,\uFFE58,123,\uFFE512,\uFFE54,212"\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [JavaScript typed arrays](/en-US/docs/Web/JavaScript/Guide/Typed_arrays) guide\n- {{jsxref("TypedArray")}}\n- {{jsxref("TypedArray.prototype.toString()")}}\n- {{jsxref("Array.prototype.toLocaleString()")}}\n- {{jsxref("Intl")}}\n- {{jsxref("Intl.ListFormat")}}\n- {{jsxref("Number.prototype.toLocaleString()")}}\n'
        },
        "toreversed": {
            "index.md": '---\ntitle: TypedArray.prototype.toReversed()\nslug: Web/JavaScript/Reference/Global_Objects/TypedArray/toReversed\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.TypedArray.toReversed\n---\n\n{{JSRef}}\n\nThe **`toReversed()`** method of {{jsxref("TypedArray")}} instances is the [copying](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array#copying_methods_and_mutating_methods) counterpart of the {{jsxref("TypedArray/reverse", "reverse()")}} method. It returns a new typed array with the elements in reversed order. This method has the same algorithm as {{jsxref("Array.prototype.toReversed()")}}.\n\n## Syntax\n\n```js-nolint\ntoReversed()\n```\n\n### Parameters\n\nNone.\n\n### Return value\n\nA new typed array containing the elements in reversed order.\n\n## Description\n\nSee {{jsxref("Array.prototype.toReversed()")}} for more details. This method is not generic and can only be called on typed array instances.\n\n## Examples\n\n### Using toReversed()\n\n```js\nconst uint8 = new Uint8Array([1, 2, 3]);\nconst reversedUint8 = uint8.toReversed();\nconsole.log(reversedUint8); // Uint8Array [3, 2, 1]\nconsole.log(uint8); // Uint8Array [1, 2, 3]\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `TypedArray.prototype.toReversed` in `core-js`](https://github.com/zloirock/core-js#change-array-by-copy)\n- [JavaScript typed arrays](/en-US/docs/Web/JavaScript/Guide/Typed_arrays) guide\n- {{jsxref("TypedArray.prototype.reverse()")}}\n- {{jsxref("TypedArray.prototype.toSorted()")}}\n- {{jsxref("TypedArray.prototype.with()")}}\n- {{jsxref("Array.prototype.toReversed()")}}\n'
        },
        "tosorted": {
            "index.md": '---\ntitle: TypedArray.prototype.toSorted()\nslug: Web/JavaScript/Reference/Global_Objects/TypedArray/toSorted\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.TypedArray.toSorted\n---\n\n{{JSRef}}\n\nThe **`toSorted()`** method of {{jsxref("TypedArray")}} instances is the [copying](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array#copying_methods_and_mutating_methods) version of the {{jsxref("TypedArray/sort", "sort()")}} method. It returns a new typed array with the elements sorted in ascending order. This method has the same algorithm as {{jsxref("Array.prototype.toSorted()")}}, except that it sorts the values numerically instead of as strings by default.\n\n## Syntax\n\n```js-nolint\ntoSorted()\ntoSorted(compareFn)\n```\n\n### Parameters\n\n- `compareFn` {{optional_inline}}\n\n  - : Specifies a function that defines the sort order. If omitted, the typed array elements are sorted according to numeric value.\n\n    - `a`\n      - : The first element for comparison.\n    - `b`\n      - : The second element for comparison.\n\n### Return value\n\nA new typed array with the elements sorted in ascending order.\n\n## Description\n\nSee {{jsxref("Array.prototype.toSorted()")}} for more details. This method is not generic and can only be called on typed array instances.\n\n## Examples\n\n### Sorting an array\n\nFor more examples, see also the {{jsxref("Array.prototype.sort()")}} method.\n\n```js\nconst numbers = new Uint8Array([40, 1, 5, 200]);\nconst numberSorted = numbers.toSorted();\nconsole.log(numberSorted); // Uint8Array [ 1, 5, 40, 200 ]\n// Unlike plain Arrays, a compare function is not required\n// to sort the numbers numerically.\nconsole.log(numbers); // Uint8Array [ 40, 1, 5, 200 ]\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `TypedArray.prototype.toSorted` in `core-js`](https://github.com/zloirock/core-js#change-array-by-copy)\n- [JavaScript typed arrays](/en-US/docs/Web/JavaScript/Guide/Typed_arrays) guide\n- {{jsxref("TypedArray.prototype.sort()")}}\n- {{jsxref("TypedArray.prototype.toReversed()")}}\n- {{jsxref("TypedArray.prototype.with()")}}\n- {{jsxref("Array.prototype.toSorted()")}}\n'
        },
        "tostring": {
            "index.md": '---\ntitle: TypedArray.prototype.toString()\nslug: Web/JavaScript/Reference/Global_Objects/TypedArray/toString\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.TypedArray.toString\n---\n\n{{JSRef}}\n\nThe **`toString()`** method of {{jsxref("TypedArray")}} instances returns a string representing the specified typed array and its elements. This method has the same algorithm as {{jsxref("Array.prototype.toString()")}}.\n\n{{EmbedInteractiveExample("pages/js/typedarray-tostring.html", "shorter")}}\n\n## Syntax\n\n```js-nolint\ntoString()\n```\n\n### Parameters\n\nNone.\n\n### Return value\n\nA string representing the elements of the typed array.\n\n## Description\n\nSee {{jsxref("Array.prototype.toString()")}} for more details. This method is not generic and can only be called on typed array instances.\n\n## Examples\n\n### Converting a typed array to a string\n\n```js\nconst uint8 = new Uint8Array([1, 2, 3]);\n// Explicit conversion\nconsole.log(uint8.toString()); // 1,2,3\n// Implicit conversion\nconsole.log(`${uint8}`); // 1,2,3\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [JavaScript typed arrays](/en-US/docs/Web/JavaScript/Guide/Typed_arrays) guide\n- {{jsxref("TypedArray")}}\n- {{jsxref("TypedArray.prototype.join()")}}\n- {{jsxref("TypedArray.prototype.toLocaleString()")}}\n- {{jsxref("Array.prototype.toString()")}}\n- {{jsxref("String.prototype.toString()")}}\n'
        },
        "values": {
            "index.md": '---\ntitle: TypedArray.prototype.values()\nslug: Web/JavaScript/Reference/Global_Objects/TypedArray/values\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.TypedArray.values\n---\n\n{{JSRef}}\n\nThe **`values()`** method of {{jsxref("TypedArray")}} instances returns a new _[array iterator](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Iterator)_ object that iterates the value of each item in the typed array. This method has the same algorithm as {{jsxref("Array.prototype.values()")}}.\n\n{{EmbedInteractiveExample("pages/js/typedarray-values.html")}}\n\n## Syntax\n\n```js-nolint\nvalues()\n```\n\n### Parameters\n\nNone.\n\n### Return value\n\nA new [iterable iterator object](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Iterator).\n\n## Description\n\nSee {{jsxref("Array.prototype.values()")}} for more details. This method is not generic and can only be called on typed array instances.\n\n## Examples\n\n### Iteration using for...of loop\n\n```js\nconst arr = new Uint8Array([10, 20, 30, 40, 50]);\nconst values = arr.values();\nfor (const n of values) {\n  console.log(n);\n}\n```\n\n### Alternative iteration\n\n```js\nconst arr = new Uint8Array([10, 20, 30, 40, 50]);\nconst values = arr.values();\nconsole.log(values.next().value); // 10\nconsole.log(values.next().value); // 20\nconsole.log(values.next().value); // 30\nconsole.log(values.next().value); // 40\nconsole.log(values.next().value); // 50\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `TypedArray.prototype.values` in `core-js`](https://github.com/zloirock/core-js#ecmascript-typed-arrays)\n- [JavaScript typed arrays](/en-US/docs/Web/JavaScript/Guide/Typed_arrays) guide\n- {{jsxref("TypedArray")}}\n- {{jsxref("TypedArray.prototype.entries()")}}\n- {{jsxref("TypedArray.prototype.keys()")}}\n- [`TypedArray.prototype[@@iterator]()`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/TypedArray/@@iterator)\n- {{jsxref("Array.prototype.values()")}}\n- [Iteration protocols](/en-US/docs/Web/JavaScript/Reference/Iteration_protocols)\n'
        },
        "with": {
            "index.md": '---\ntitle: TypedArray.prototype.with()\nslug: Web/JavaScript/Reference/Global_Objects/TypedArray/with\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.TypedArray.with\n---\n\n{{JSRef}}\n\nThe **`with()`** method of {{jsxref("TypedArray")}} instances is the [copying](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array#copying_methods_and_mutating_methods) version of using the [bracket notation](/en-US/docs/Web/JavaScript/Reference/Operators/Property_accessors#bracket_notation) to change the value of a given index. It returns a new typed array with the element at the given index replaced with the given value. This method has the same algorithm as {{jsxref("Array.prototype.with()")}}.\n\n## Syntax\n\n```js-nolint\narrayInstance.with(index, value)\n```\n\n### Parameters\n\n- `index`\n  - : Zero-based index at which to change the typed array, [converted to an integer](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number#integer_conversion).\n- `value`\n  - : Any value to be assigned to the given index.\n\n### Return value\n\nA new typed array with the element at `index` replaced with `value`.\n\n### Exceptions\n\n- {{jsxref("RangeError")}}\n  - : Thrown if `index >= array.length` or `index < -array.length`.\n\n## Description\n\nSee {{jsxref("Array.prototype.with()")}} for more details. This method is not generic and can only be called on typed array instances.\n\n## Examples\n\n### Using with()\n\n```js\nconst arr = new Uint8Array([1, 2, 3, 4, 5]);\nconsole.log(arr.with(2, 6)); // Uint8Array [1, 2, 6, 4, 5]\nconsole.log(arr); // Uint8Array [1, 2, 3, 4, 5]\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `TypedArray.prototype.with` in `core-js`](https://github.com/zloirock/core-js#change-array-by-copy)\n- [JavaScript typed arrays](/en-US/docs/Web/JavaScript/Guide/Typed_arrays) guide\n- {{jsxref("TypedArray.prototype.toReversed()")}}\n- {{jsxref("TypedArray.prototype.toSorted()")}}\n- {{jsxref("TypedArray.prototype.at()")}}\n- {{jsxref("Array.prototype.with()")}}\n'
        }
    },
    "typeerror": {
        "index.md": '---\ntitle: TypeError\nslug: Web/JavaScript/Reference/Global_Objects/TypeError\npage-type: javascript-class\nbrowser-compat: javascript.builtins.TypeError\n---\n\n{{JSRef}}\n\nThe **`TypeError`** object represents an error when an operation could not be performed, typically (but not exclusively) when a value is not of the expected type.\n\nA `TypeError` may be thrown when:\n\n- an operand or argument passed to a function is incompatible with the type expected by that operator or function; or\n- when attempting to modify a value that cannot be changed; or\n- when attempting to use a value in an inappropriate way.\n\n`TypeError` is a {{Glossary("serializable object")}}, so it can be cloned with {{domxref("structuredClone()")}} or copied between [Workers](/en-US/docs/Web/API/Worker) using {{domxref("Worker/postMessage()", "postMessage()")}}.\n\n`TypeError` is a subclass of {{jsxref("Error")}}.\n\n## Constructor\n\n- {{jsxref("TypeError/TypeError", "TypeError()")}}\n  - : Creates a new `TypeError` object.\n\n## Instance properties\n\n_Also inherits instance properties from its parent {{jsxref("Error")}}_.\n\nThese properties are defined on `TypeError.prototype` and shared by all `TypeError` instances.\n\n- {{jsxref("Object/constructor", "TypeError.prototype.constructor")}}\n  - : The constructor function that created the instance object. For `TypeError` instances, the initial value is the {{jsxref("TypeError/TypeError", "TypeError")}} constructor.\n- {{jsxref("Error/name", "TypeError.prototype.name")}}\n  - : Represents the name for the type of error. For `TypeError.prototype.name`, the initial value is `"TypeError"`.\n\n## Instance methods\n\n_Inherits instance methods from its parent {{jsxref("Error")}}_.\n\n## Examples\n\n### Catching a TypeError\n\n```js\ntry {\n  null.f();\n} catch (e) {\n  console.log(e instanceof TypeError); // true\n  console.log(e.message); // "null has no properties"\n  console.log(e.name); // "TypeError"\n  console.log(e.stack); // Stack of the error\n}\n```\n\n### Creating a TypeError\n\n```js\ntry {\n  throw new TypeError("Hello");\n} catch (e) {\n  console.log(e instanceof TypeError); // true\n  console.log(e.message); // "Hello"\n  console.log(e.name); // "TypeError"\n  console.log(e.stack); // Stack of the error\n}\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Error")}}\n',
        "typeerror": {
            "index.md": '---\ntitle: TypeError() constructor\nslug: Web/JavaScript/Reference/Global_Objects/TypeError/TypeError\npage-type: javascript-constructor\nbrowser-compat: javascript.builtins.TypeError.TypeError\n---\n\n{{JSRef}}\n\nThe **`TypeError()`** constructor creates {{jsxref("TypeError")}} objects.\n\n## Syntax\n\n```js-nolint\nnew TypeError()\nnew TypeError(message)\nnew TypeError(message, options)\nnew TypeError(message, fileName)\nnew TypeError(message, fileName, lineNumber)\n\nTypeError()\nTypeError(message)\nTypeError(message, options)\nTypeError(message, fileName)\nTypeError(message, fileName, lineNumber)\n```\n\n> **Note:** `TypeError()` can be called with or without [`new`](/en-US/docs/Web/JavaScript/Reference/Operators/new). Both create a new `TypeError` instance.\n\n### Parameters\n\n- `message` {{optional_inline}}\n  - : Human-readable description of the error\n- `options` {{optional_inline}}\n  - : An object that has the following properties:\n    - `cause` {{optional_inline}}\n      - : A property indicating the specific cause of the error.\n        When catching and re-throwing an error with a more-specific or useful error message, this property can be used to pass the original error.\n- `fileName` {{optional_inline}} {{non-standard_inline}}\n  - : The name of the file containing the code that caused the exception\n- `lineNumber` {{optional_inline}} {{non-standard_inline}}\n  - : The line number of the code that caused the exception\n\n## Examples\n\n### Catching a TypeError\n\n```js\ntry {\n  null.f();\n} catch (e) {\n  console.log(e instanceof TypeError); // true\n  console.log(e.message); // "null has no properties"\n  console.log(e.name); // "TypeError"\n  console.log(e.stack); // Stack of the error\n}\n```\n\n### Creating a TypeError\n\n```js\ntry {\n  throw new TypeError("Hello");\n} catch (e) {\n  console.log(e instanceof TypeError); // true\n  console.log(e.message); // "Hello"\n  console.log(e.name); // "TypeError"\n  console.log(e.stack); // Stack of the error\n}\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Error")}}\n'
        }
    },
    "uint16array": {
        "index.md": '---\ntitle: Uint16Array\nslug: Web/JavaScript/Reference/Global_Objects/Uint16Array\npage-type: javascript-class\nbrowser-compat: javascript.builtins.Uint16Array\n---\n\n{{JSRef}}\n\nThe **`Uint16Array`** typed array represents an array of 16-bit unsigned integers in the platform byte order. If control over byte order is needed, use {{jsxref("DataView")}} instead. The contents are initialized to `0`. Once established, you can reference elements in the array using the object\'s methods, or using standard array index syntax (that is, using bracket notation).\n\n`Uint16Array` is a subclass of the hidden {{jsxref("TypedArray")}} class.\n\n## Constructor\n\n- {{jsxref("Uint16Array/Uint16Array", "Uint16Array()")}}\n  - : Creates a new `Uint16Array` object.\n\n## Static properties\n\n_Also inherits static properties from its parent {{jsxref("TypedArray")}}_.\n\n- {{jsxref("TypedArray/BYTES_PER_ELEMENT", "Uint16Array.BYTES_PER_ELEMENT")}}\n  - : Returns a number value of the element size. `2` in the case of `Uint16Array`.\n\n## Static methods\n\n_Inherits static methods from its parent {{jsxref("TypedArray")}}_.\n\n## Instance properties\n\n_Also inherits instance properties from its parent {{jsxref("TypedArray")}}_.\n\nThese properties are defined on `Uint16Array.prototype` and shared by all `Uint16Array` instances.\n\n- {{jsxref("TypedArray/BYTES_PER_ELEMENT", "Uint16Array.prototype.BYTES_PER_ELEMENT")}}\n  - : Returns a number value of the element size. `2` in the case of a `Uint16Array`.\n- {{jsxref("Object/constructor", "Uint16Array.prototype.constructor")}}\n  - : The constructor function that created the instance object. For `Uint16Array` instances, the initial value is the {{jsxref("Uint16Array/Uint16Array", "Uint16Array")}} constructor.\n\n## Instance methods\n\n_Inherits instance methods from its parent {{jsxref("TypedArray")}}_.\n\n## Examples\n\n### Different ways to create a Uint16Array\n\n```js\n// From a length\nconst uint16 = new Uint16Array(2);\nuint16[0] = 42;\nconsole.log(uint16[0]); // 42\nconsole.log(uint16.length); // 2\nconsole.log(uint16.BYTES_PER_ELEMENT); // 2\n\n// From an array\nconst x = new Uint16Array([21, 31]);\nconsole.log(x[1]); // 31\n\n// From another TypedArray\nconst y = new Uint16Array(x);\nconsole.log(y[0]); // 21\n\n// From an ArrayBuffer\nconst buffer = new ArrayBuffer(16);\nconst z = new Uint16Array(buffer, 2, 4);\nconsole.log(z.byteOffset); // 2\n\n// From an iterable\nconst iterable = (function* () {\n  yield* [1, 2, 3];\n})();\nconst uint16FromIterable = new Uint16Array(iterable);\nconsole.log(uint16FromIterable);\n// Uint16Array [1, 2, 3]\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Uint16Array` in `core-js`](https://github.com/zloirock/core-js#ecmascript-typed-arrays)\n- [JavaScript typed arrays](/en-US/docs/Web/JavaScript/Guide/Typed_arrays) guide\n- {{jsxref("TypedArray")}}\n- {{jsxref("ArrayBuffer")}}\n- {{jsxref("DataView")}}\n',
        "uint16array": {
            "index.md": '---\ntitle: Uint16Array() constructor\nslug: Web/JavaScript/Reference/Global_Objects/Uint16Array/Uint16Array\npage-type: javascript-constructor\nbrowser-compat: javascript.builtins.Uint16Array.Uint16Array\n---\n\n{{JSRef}}\n\nThe **`Uint16Array()`** constructor creates {{jsxref("Uint16Array")}} objects. The contents are initialized to `0`.\n\n## Syntax\n\n```js-nolint\nnew Uint16Array()\nnew Uint16Array(length)\nnew Uint16Array(typedArray)\nnew Uint16Array(object)\n\nnew Uint16Array(buffer)\nnew Uint16Array(buffer, byteOffset)\nnew Uint16Array(buffer, byteOffset, length)\n```\n\n> **Note:** `Uint16Array()` can only be constructed with [`new`](/en-US/docs/Web/JavaScript/Reference/Operators/new). Attempting to call it without `new` throws a {{jsxref("TypeError")}}.\n\n### Parameters\n\nSee [`TypedArray`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/TypedArray#parameters).\n\n### Exceptions\n\nSee [`TypedArray`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/TypedArray#exceptions).\n\n## Examples\n\n### Different ways to create a Uint16Array\n\n```js\n// From a length\nconst uint16 = new Uint16Array(2);\nuint16[0] = 42;\nconsole.log(uint16[0]); // 42\nconsole.log(uint16.length); // 2\nconsole.log(uint16.BYTES_PER_ELEMENT); // 2\n\n// From an array\nconst x = new Uint16Array([21, 31]);\nconsole.log(x[1]); // 31\n\n// From another TypedArray\nconst y = new Uint16Array(x);\nconsole.log(y[0]); // 21\n\n// From an ArrayBuffer\nconst buffer = new ArrayBuffer(16);\nconst z = new Uint16Array(buffer, 2, 4);\nconsole.log(z.byteOffset); // 2\n\n// From an iterable\nconst iterable = (function* () {\n  yield* [1, 2, 3];\n})();\nconst uint16FromIterable = new Uint16Array(iterable);\nconsole.log(uint16FromIterable);\n// Uint16Array [1, 2, 3]\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Uint16Array` in `core-js`](https://github.com/zloirock/core-js#ecmascript-typed-arrays)\n- [JavaScript typed arrays](/en-US/docs/Web/JavaScript/Guide/Typed_arrays) guide\n- {{jsxref("TypedArray")}}\n- {{jsxref("ArrayBuffer")}}\n- {{jsxref("DataView")}}\n'
        }
    },
    "uint32array": {
        "index.md": '---\ntitle: Uint32Array\nslug: Web/JavaScript/Reference/Global_Objects/Uint32Array\npage-type: javascript-class\nbrowser-compat: javascript.builtins.Uint32Array\n---\n\n{{JSRef}}\n\nThe **`Uint32Array`** typed array represents an array of 32-bit unsigned integers in the platform byte order. If control over byte order is needed, use {{jsxref("DataView")}} instead. The contents are initialized to `0`. Once established, you can reference elements in the array using the object\'s methods, or using standard array index syntax (that is, using bracket notation).\n\n`Uint32Array` is a subclass of the hidden {{jsxref("TypedArray")}} class.\n\n## Constructor\n\n- {{jsxref("Uint32Array/Uint32Array", "Uint32Array()")}}\n  - : Creates a new `Uint32Array` object.\n\n## Static properties\n\n_Also inherits static properties from its parent {{jsxref("TypedArray")}}_.\n\n- {{jsxref("TypedArray/BYTES_PER_ELEMENT", "Uint32Array.BYTES_PER_ELEMENT")}}\n  - : Returns a number value of the element size. `4` in the case of `Uint32Array`.\n\n## Static methods\n\n_Inherits static methods from its parent {{jsxref("TypedArray")}}_.\n\n## Instance properties\n\n_Also inherits instance properties from its parent {{jsxref("TypedArray")}}_.\n\nThese properties are defined on `Uint32Array.prototype` and shared by all `Uint32Array` instances.\n\n- {{jsxref("TypedArray/BYTES_PER_ELEMENT", "Uint32Array.prototype.BYTES_PER_ELEMENT")}}\n  - : Returns a number value of the element size. `4` in the case of a `Uint32Array`.\n- {{jsxref("Object/constructor", "Uint32Array.prototype.constructor")}}\n  - : The constructor function that created the instance object. For `Uint32Array` instances, the initial value is the {{jsxref("Uint32Array/Uint32Array", "Uint32Array")}} constructor.\n\n## Instance methods\n\n_Inherits instance methods from its parent {{jsxref("TypedArray")}}_.\n\n## Examples\n\n### Different ways to create a Uint32Array\n\n```js\n// From a length\nconst uint32 = new Uint32Array(2);\nuint32[0] = 42;\nconsole.log(uint32[0]); // 42\nconsole.log(uint32.length); // 2\nconsole.log(uint32.BYTES_PER_ELEMENT); // 4\n\n// From an array\nconst x = new Uint32Array([21, 31]);\nconsole.log(x[1]); // 31\n\n// From another TypedArray\nconst y = new Uint32Array(x);\nconsole.log(y[0]); // 21\n\n// From an ArrayBuffer\nconst buffer = new ArrayBuffer(32);\nconst z = new Uint32Array(buffer, 4, 4);\nconsole.log(z.byteOffset); // 4\n\n// From an iterable\nconst iterable = (function* () {\n  yield* [1, 2, 3];\n})();\nconst uint32FromIterable = new Uint32Array(iterable);\nconsole.log(uint32FromIterable);\n// Uint32Array [1, 2, 3]\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Uint32Array` in `core-js`](https://github.com/zloirock/core-js#ecmascript-typed-arrays)\n- [JavaScript typed arrays](/en-US/docs/Web/JavaScript/Guide/Typed_arrays) guide\n- {{jsxref("TypedArray")}}\n- {{jsxref("ArrayBuffer")}}\n- {{jsxref("DataView")}}\n',
        "uint32array": {
            "index.md": '---\ntitle: Uint32Array() constructor\nslug: Web/JavaScript/Reference/Global_Objects/Uint32Array/Uint32Array\npage-type: javascript-constructor\nbrowser-compat: javascript.builtins.Uint32Array.Uint32Array\n---\n\n{{JSRef}}\n\nThe **`Uint32Array()`** constructor creates {{jsxref("Uint32Array")}} objects. The contents are initialized to `0`.\n\n## Syntax\n\n```js-nolint\nnew Uint32Array()\nnew Uint32Array(length)\nnew Uint32Array(typedArray)\nnew Uint32Array(object)\n\nnew Uint32Array(buffer)\nnew Uint32Array(buffer, byteOffset)\nnew Uint32Array(buffer, byteOffset, length)\n```\n\n> **Note:** `Uint32Array()` can only be constructed with [`new`](/en-US/docs/Web/JavaScript/Reference/Operators/new). Attempting to call it without `new` throws a {{jsxref("TypeError")}}.\n\n### Parameters\n\nSee [`TypedArray`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/TypedArray#parameters).\n\n### Exceptions\n\nSee [`TypedArray`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/TypedArray#exceptions).\n\n## Examples\n\n### Different ways to create a Uint32Array\n\n```js\n// From a length\nconst uint32 = new Uint32Array(2);\nuint32[0] = 42;\nconsole.log(uint32[0]); // 42\nconsole.log(uint32.length); // 2\nconsole.log(uint32.BYTES_PER_ELEMENT); // 4\n\n// From an array\nconst x = new Uint32Array([21, 31]);\nconsole.log(x[1]); // 31\n\n// From another TypedArray\nconst y = new Uint32Array(x);\nconsole.log(y[0]); // 21\n\n// From an ArrayBuffer\nconst buffer = new ArrayBuffer(32);\nconst z = new Uint32Array(buffer, 4, 4);\nconsole.log(z.byteOffset); // 4\n\n// From an iterable\nconst iterable = (function* () {\n  yield* [1, 2, 3];\n})();\nconst uint32FromIterable = new Uint32Array(iterable);\nconsole.log(uint32FromIterable);\n// Uint32Array [1, 2, 3]\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Uint32Array` in `core-js`](https://github.com/zloirock/core-js#ecmascript-typed-arrays)\n- [JavaScript typed arrays](/en-US/docs/Web/JavaScript/Guide/Typed_arrays) guide\n- {{jsxref("TypedArray")}}\n- {{jsxref("ArrayBuffer")}}\n- {{jsxref("DataView")}}\n'
        }
    },
    "uint8array": {
        "index.md": '---\ntitle: Uint8Array\nslug: Web/JavaScript/Reference/Global_Objects/Uint8Array\npage-type: javascript-class\nbrowser-compat: javascript.builtins.Uint8Array\n---\n\n{{JSRef}}\n\nThe **`Uint8Array`** typed array represents an array of 8-bit unsigned integers. The contents are initialized to `0`. Once established, you can reference elements in the array using the object\'s methods, or using standard array index syntax (that is, using bracket notation).\n\n`Uint8Array` is a subclass of the hidden {{jsxref("TypedArray")}} class.\n\n## Constructor\n\n- {{jsxref("Uint8Array/Uint8Array", "Uint8Array()")}}\n  - : Creates a new `Uint8Array` object.\n\n## Static properties\n\n_Also inherits static properties from its parent {{jsxref("TypedArray")}}_.\n\n- {{jsxref("TypedArray/BYTES_PER_ELEMENT", "Uint8Array.BYTES_PER_ELEMENT")}}\n  - : Returns a number value of the element size. `1` in the case of `Uint8Array`.\n\n## Static methods\n\n_Inherits static methods from its parent {{jsxref("TypedArray")}}_.\n\n## Instance properties\n\n_Also inherits instance properties from its parent {{jsxref("TypedArray")}}_.\n\nThese properties are defined on `Uint8Array.prototype` and shared by all `Uint8Array` instances.\n\n- {{jsxref("TypedArray/BYTES_PER_ELEMENT", "Uint8Array.prototype.BYTES_PER_ELEMENT")}}\n  - : Returns a number value of the element size. `1` in the case of a `Uint8Array`.\n- {{jsxref("Object/constructor", "Uint8Array.prototype.constructor")}}\n  - : The constructor function that created the instance object. For `Uint8Array` instances, the initial value is the {{jsxref("Uint8Array/Uint8Array", "Uint8Array")}} constructor.\n\n## Instance methods\n\n_Inherits instance methods from its parent {{jsxref("TypedArray")}}_.\n\n## Examples\n\n### Different ways to create a Uint8Array\n\n```js\n// From a length\nconst uint8 = new Uint8Array(2);\nuint8[0] = 42;\nconsole.log(uint8[0]); // 42\nconsole.log(uint8.length); // 2\nconsole.log(uint8.BYTES_PER_ELEMENT); // 1\n\n// From an array\nconst x = new Uint8Array([21, 31]);\nconsole.log(x[1]); // 31\n\n// From another TypedArray\nconst y = new Uint8Array(x);\nconsole.log(y[0]); // 21\n\n// From an ArrayBuffer\nconst buffer = new ArrayBuffer(8);\nconst z = new Uint8Array(buffer, 1, 4);\nconsole.log(z.byteOffset); // 1\n\n// From an iterable\nconst iterable = (function* () {\n  yield* [1, 2, 3];\n})();\nconst uint8FromIterable = new Uint8Array(iterable);\nconsole.log(uint8FromIterable);\n// Uint8Array [1, 2, 3]\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Uint8Array` in `core-js`](https://github.com/zloirock/core-js#ecmascript-typed-arrays)\n- [JavaScript typed arrays](/en-US/docs/Web/JavaScript/Guide/Typed_arrays) guide\n- {{jsxref("TypedArray")}}\n- {{jsxref("ArrayBuffer")}}\n- {{jsxref("DataView")}}\n',
        "uint8array": {
            "index.md": '---\ntitle: Uint8Array() constructor\nslug: Web/JavaScript/Reference/Global_Objects/Uint8Array/Uint8Array\npage-type: javascript-constructor\nbrowser-compat: javascript.builtins.Uint8Array.Uint8Array\n---\n\n{{JSRef}}\n\nThe **`Uint8Array()`** constructor creates {{jsxref("Uint8Array")}} objects. The contents are initialized to `0`.\n\n## Syntax\n\n```js-nolint\nnew Uint8Array()\nnew Uint8Array(length)\nnew Uint8Array(typedArray)\nnew Uint8Array(object)\n\nnew Uint8Array(buffer)\nnew Uint8Array(buffer, byteOffset)\nnew Uint8Array(buffer, byteOffset, length)\n```\n\n> **Note:** `Uint8Array()` can only be constructed with [`new`](/en-US/docs/Web/JavaScript/Reference/Operators/new). Attempting to call it without `new` throws a {{jsxref("TypeError")}}.\n\n### Parameters\n\nSee [`TypedArray`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/TypedArray#parameters).\n\n### Exceptions\n\nSee [`TypedArray`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/TypedArray#exceptions).\n\n## Examples\n\n### Different ways to create a Uint8Array\n\n```js\n// From a length\nconst uint8 = new Uint8Array(2);\nuint8[0] = 42;\nconsole.log(uint8[0]); // 42\nconsole.log(uint8.length); // 2\nconsole.log(uint8.BYTES_PER_ELEMENT); // 1\n\n// From an array\nconst x = new Uint8Array([21, 31]);\nconsole.log(x[1]); // 31\n\n// From another TypedArray\nconst y = new Uint8Array(x);\nconsole.log(y[0]); // 21\n\n// From an ArrayBuffer\nconst buffer = new ArrayBuffer(8);\nconst z = new Uint8Array(buffer, 1, 4);\nconsole.log(z.byteOffset); // 1\n\n// From an iterable\nconst iterable = (function* () {\n  yield* [1, 2, 3];\n})();\nconst uint8FromIterable = new Uint8Array(iterable);\nconsole.log(uint8FromIterable);\n// Uint8Array [1, 2, 3]\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Uint8Array` in `core-js`](https://github.com/zloirock/core-js#ecmascript-typed-arrays)\n- [JavaScript typed arrays](/en-US/docs/Web/JavaScript/Guide/Typed_arrays) guide\n- {{jsxref("TypedArray")}}\n- {{jsxref("ArrayBuffer")}}\n- {{jsxref("DataView")}}\n'
        }
    },
    "uint8clampedarray": {
        "index.md": '---\ntitle: Uint8ClampedArray\nslug: Web/JavaScript/Reference/Global_Objects/Uint8ClampedArray\npage-type: javascript-class\nbrowser-compat: javascript.builtins.Uint8ClampedArray\n---\n\n{{JSRef}}\n\nThe **`Uint8ClampedArray`** typed array represents an array of 8-bit unsigned integers clamped to 0\u2013255. The contents are initialized to `0`. Once established, you can reference elements in the array using the object\'s methods, or using standard array index syntax (that is, using bracket notation).\n\n`Uint8ClampedArray` is a subclass of the hidden {{jsxref("TypedArray")}} class.\n\n## Constructor\n\n- {{jsxref("Uint8ClampedArray/Uint8ClampedArray", "Uint8ClampedArray()")}}\n  - : Creates a new `Uint8ClampedArray` object.\n\n## Static properties\n\n_Also inherits static properties from its parent {{jsxref("TypedArray")}}_.\n\n- {{jsxref("TypedArray/BYTES_PER_ELEMENT", "Uint8ClampedArray.BYTES_PER_ELEMENT")}}\n  - : Returns a number value of the element size. `1` in the case of `Uint8ClampedArray`.\n\n## Static methods\n\n_Inherits static methods from its parent {{jsxref("TypedArray")}}_.\n\n## Instance properties\n\n_Also inherits instance properties from its parent {{jsxref("TypedArray")}}_.\n\nThese properties are defined on `Uint8ClampedArray.prototype` and shared by all `Uint8ClampedArray` instances.\n\n- {{jsxref("TypedArray/BYTES_PER_ELEMENT", "Uint8ClampedArray.prototype.BYTES_PER_ELEMENT")}}\n  - : Returns a number value of the element size. `1` in the case of a `Uint8ClampedArray`.\n- {{jsxref("Object/constructor", "Uint8ClampedArray.prototype.constructor")}}\n  - : The constructor function that created the instance object. For `Uint8ClampedArray` instances, the initial value is the {{jsxref("Uint8ClampedArray/Uint8ClampedArray", "Uint8ClampedArray")}} constructor.\n\n## Instance methods\n\n_Inherits instance methods from its parent {{jsxref("TypedArray")}}_.\n\n## Examples\n\n### Different ways to create a Uint8ClampedArray\n\n```js\n// From a length\nconst uint8c = new Uint8ClampedArray(2);\nuint8c[0] = 42;\nuint8c[1] = 1337;\nconsole.log(uint8c[0]); // 42\nconsole.log(uint8c[1]); // 255 (clamped)\nconsole.log(uint8c.length); // 2\nconsole.log(uint8c.BYTES_PER_ELEMENT); // 1\n\n// From an array\nconst x = new Uint8ClampedArray([21, 31]);\nconsole.log(x[1]); // 31\n\n// From another TypedArray\nconst y = new Uint8ClampedArray(x);\nconsole.log(y[0]); // 21\n\n// From an ArrayBuffer\nconst buffer = new ArrayBuffer(8);\nconst z = new Uint8ClampedArray(buffer, 1, 4);\nconsole.log(z.byteOffset); // 1\n\n// From an iterable\nconst iterable = (function* () {\n  yield* [1, 2, 3];\n})();\nconst uint8cFromIterable = new Uint8ClampedArray(iterable);\nconsole.log(uint8cFromIterable);\n// Uint8ClampedArray [1, 2, 3]\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Uint8ClampedArray` in `core-js`](https://github.com/zloirock/core-js#ecmascript-typed-arrays)\n- [JavaScript typed arrays](/en-US/docs/Web/JavaScript/Guide/Typed_arrays) guide\n- {{jsxref("TypedArray")}}\n- {{jsxref("ArrayBuffer")}}\n- {{jsxref("DataView")}}\n',
        "uint8clampedarray": {
            "index.md": '---\ntitle: Uint8ClampedArray() constructor\nslug: Web/JavaScript/Reference/Global_Objects/Uint8ClampedArray/Uint8ClampedArray\npage-type: javascript-constructor\nbrowser-compat: javascript.builtins.Uint8ClampedArray.Uint8ClampedArray\n---\n\n{{JSRef}}\n\nThe **`Uint8ClampedArray()`** constructor creates {{jsxref("Uint8ClampedArray")}} objects. The contents are initialized to `0`.\n\n## Syntax\n\n```js-nolint\nnew Uint8ClampedArray()\nnew Uint8ClampedArray(length)\nnew Uint8ClampedArray(typedArray)\nnew Uint8ClampedArray(object)\n\nnew Uint8ClampedArray(buffer)\nnew Uint8ClampedArray(buffer, byteOffset)\nnew Uint8ClampedArray(buffer, byteOffset, length)\n```\n\n> **Note:** `Uint8ClampedArray()` can only be constructed with [`new`](/en-US/docs/Web/JavaScript/Reference/Operators/new). Attempting to call it without `new` throws a {{jsxref("TypeError")}}.\n\n### Parameters\n\nSee [`TypedArray`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/TypedArray#parameters).\n\n### Exceptions\n\nSee [`TypedArray`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/TypedArray#exceptions).\n\n## Examples\n\n### Different ways to create a Uint8ClampedArray\n\n```js\n// From a length\nconst uint8c = new Uint8ClampedArray(2);\nuint8c[0] = 42;\nuint8c[1] = 1337;\nconsole.log(uint8c[0]); // 42\nconsole.log(uint8c[1]); // 255 (clamped)\nconsole.log(uint8c.length); // 2\nconsole.log(uint8c.BYTES_PER_ELEMENT); // 1\n\n// From an array\nconst x = new Uint8ClampedArray([21, 31]);\nconsole.log(x[1]); // 31\n\n// From another TypedArray\nconst y = new Uint8ClampedArray(x);\nconsole.log(y[0]); // 21\n\n// From an ArrayBuffer\nconst buffer = new ArrayBuffer(8);\nconst z = new Uint8ClampedArray(buffer, 1, 4);\nconsole.log(z.byteOffset); // 1\n\n// From an iterable\nconst iterable = (function* () {\n  yield* [1, 2, 3];\n})();\nconst uint8cFromIterable = new Uint8ClampedArray(iterable);\nconsole.log(uint8cFromIterable);\n// Uint8ClampedArray [1, 2, 3]\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `Uint8ClampedArray` in `core-js`](https://github.com/zloirock/core-js#ecmascript-typed-arrays)\n- [JavaScript typed arrays](/en-US/docs/Web/JavaScript/Guide/Typed_arrays) guide\n- {{jsxref("TypedArray")}}\n- {{jsxref("ArrayBuffer")}}\n- {{jsxref("DataView")}}\n'
        }
    },
    "undefined": {
        "index.md": '---\ntitle: undefined\nslug: Web/JavaScript/Reference/Global_Objects/undefined\npage-type: javascript-global-property\nbrowser-compat: javascript.builtins.undefined\n---\n\n{{jsSidebar("Objects")}}\n\nThe **`undefined`** global property represents the primitive\nvalue [`undefined`](/en-US/docs/Web/JavaScript/Data_structures#undefined_type). It is one of JavaScript\'s\n{{Glossary("Primitive", "primitive types")}}.\n\n{{EmbedInteractiveExample("pages/js/globalprops-undefined.html")}}\n\n## Value\n\nThe primitive value [`undefined`](/en-US/docs/Web/JavaScript/Data_structures#undefined_type).\n\n{{js_property_attributes(0, 0, 0)}}\n\n## Description\n\n`undefined` is a property of the _global object_. That is, it is a variable in global scope.\n\nIn all non-legacy browsers, `undefined` is a non-configurable, non-writable property. Even when this is not the case, avoid overriding it.\n\nA variable that has not been assigned a value is of type `undefined`. A\nmethod or statement also returns `undefined` if the variable that is being\nevaluated does not have an assigned value. A function returns `undefined` if\na value was not {{jsxref("Statements/return", "returned")}}.\n\n> **Note:** While you can use `undefined` as an {{Glossary("identifier")}} (variable name) in any scope other than the global scope (because `undefined` is not a [reserved word](/en-US/docs/Web/JavaScript/Reference/Lexical_grammar#reserved_words)), doing so is a very bad idea that will make your code difficult to maintain and debug.\n>\n> ```js example-bad\n> // DON\'T DO THIS\n>\n> (() => {\n>   const undefined = "foo";\n>   console.log(undefined, typeof undefined); // foo string\n> })();\n>\n> ((undefined) => {\n>   console.log(undefined, typeof undefined); // foo string\n> })("foo");\n> ```\n\n## Examples\n\n### Strict equality and undefined\n\nYou can use `undefined` and the strict equality and inequality operators to\ndetermine whether a variable has a value. In the following code, the variable\n`x` is not initialized, and the `if` statement evaluates to true.\n\n```js\nlet x;\nif (x === undefined) {\n  // these statements execute\n} else {\n  // these statements do not execute\n}\n```\n\n> **Note:** The _strict equality_ operator (as opposed to the\n> _standard equality_ operator) must be used here, because\n> `x == undefined` also checks whether `x` is `null`,\n> while strict equality doesn\'t. This is because `null` is not equivalent to\n> `undefined`.\n>\n> See [Equality comparison and sameness](/en-US/docs/Web/JavaScript/Equality_comparisons_and_sameness) for details.\n\n### typeof operator and undefined\n\nAlternatively, {{jsxref("Operators/typeof", "typeof")}} can be used:\n\n```js\nlet x;\nif (typeof x === "undefined") {\n  // these statements execute\n}\n```\n\nOne reason to use {{jsxref("Operators/typeof", "typeof")}} is that it does not throw an\nerror if the variable has not been declared.\n\n```js\n// x has not been declared before\n// evaluates to true without errors\nif (typeof x === "undefined") {\n  // these statements execute\n}\n\n// Throws a ReferenceError\nif (x === undefined) {\n}\n```\n\nHowever, there is another alternative. JavaScript is a statically scoped language, so\nknowing if a variable is declared can be read by seeing whether it is declared in an\nenclosing context.\n\nThe global scope is bound to the {{jsxref("globalThis", "global object", "", 1)}}, so\nchecking the existence of a variable in the global context can be done by checking the\nexistence of a property on the _global object_, using the\n{{jsxref("Operators/in", "in")}} operator, for instance:\n\n```js\nif ("x" in window) {\n  // These statements execute only if x is defined globally\n}\n```\n\n### void operator and undefined\n\nThe {{jsxref("Operators/void", "void")}} operator is a third alternative.\n\n```js\nlet x;\nif (x === void 0) {\n  // these statements execute\n}\n\n// y has not been declared before\nif (y === void 0) {\n  // throws Uncaught ReferenceError: y is not defined\n}\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [JavaScript data types and data structures](/en-US/docs/Web/JavaScript/Data_structures)\n- [`null`](/en-US/docs/Web/JavaScript/Reference/Operators/null)\n'
    },
    "unescape": {
        "index.md": '---\ntitle: unescape()\nslug: Web/JavaScript/Reference/Global_Objects/unescape\npage-type: javascript-function\nstatus:\n  - deprecated\nbrowser-compat: javascript.builtins.unescape\n---\n\n{{jsSidebar("Objects")}}{{Deprecated_Header}}\n\n> **Note:** `unescape()` is a non-standard function implemented by browsers and was only standardized for cross-engine compatibility. It is not required to be implemented by all JavaScript engines and may not work everywhere. Use {{jsxref("decodeURIComponent()")}} or {{jsxref("decodeURI()")}} if possible.\n\nThe **`unescape()`** function computes a new string in which hexadecimal escape sequences are replaced with the characters that they represent. The escape sequences might be introduced by a function like {{jsxref("escape()")}}.\n\n## Syntax\n\n```js-nolint\nunescape(str)\n```\n\n### Parameters\n\n- `str`\n  - : A string to be decoded.\n\n### Return value\n\nA new string in which certain characters have been unescaped.\n\n## Description\n\n`unescape()` is a function property of the global object.\n\nThe `unescape()` function replaces any escape sequence with the character that it represents. Specifically, it replaces any escape sequence of the form `%XX` or `%uXXXX` (where `X` represents one hexadecimal digit) with the character that has the hexadecimal value `XX`/`XXXX`. If the escape sequence is not a valid escape sequence (for example, if `%` is followed by one or no hex digit), it is left as-is.\n\n> **Note:** This function was used mostly for [URL encoding](https://en.wikipedia.org/wiki/URL_encoding) and is partly based on the escape format in {{rfc(1738)}}. The `unescape()` function does _not_ evaluate [escape sequences](/en-US/docs/Web/JavaScript/Reference/Lexical_grammar#escape_sequences) in string literals. You can replace `\\xXX` with `%XX` and `\\uXXXX` with `%uXXXX` to get a string that can be handled by `unescape()`.\n\n## Examples\n\n### Using unescape()\n\n```js\nunescape("abc123"); // "abc123"\nunescape("%E4%F6%FC"); // "\xe4\xf6\xfc"\nunescape("%u0107"); // "\u0107"\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `unescape` in `core-js`](https://github.com/zloirock/core-js#ecmascript-string-and-regexp)\n- {{jsxref("decodeURI")}}\n- {{jsxref("decodeURIComponent")}}\n- {{jsxref("escape")}}\n'
    },
    "urierror": {
        "index.md": '---\ntitle: URIError\nslug: Web/JavaScript/Reference/Global_Objects/URIError\npage-type: javascript-class\nbrowser-compat: javascript.builtins.URIError\n---\n\n{{JSRef}}\n\nThe **`URIError`** object represents an error when a global URI handling function was used in a wrong way.\n\n`URIError` is a {{Glossary("serializable object")}}, so it can be cloned with {{domxref("structuredClone()")}} or copied between [Workers](/en-US/docs/Web/API/Worker) using {{domxref("Worker/postMessage()", "postMessage()")}}.\n\n`URIError` is a subclass of {{jsxref("Error")}}.\n\n## Constructor\n\n- {{jsxref("URIError/URIError", "URIError()")}}\n  - : Creates a new `URIError` object.\n\n## Instance properties\n\n_Also inherits instance properties from its parent {{jsxref("Error")}}_.\n\nThese properties are defined on `URIError.prototype` and shared by all `URIError` instances.\n\n- {{jsxref("Object/constructor", "URIError.prototype.constructor")}}\n  - : The constructor function that created the instance object. For `URIError` instances, the initial value is the {{jsxref("URIError/URIError", "URIError")}} constructor.\n- {{jsxref("Error/name", "URIError.prototype.name")}}\n  - : Represents the name for the type of error. For `URIError.prototype.name`, the initial value is `"URIError"`.\n\n## Instance methods\n\n_Inherits instance methods from its parent {{jsxref("Error")}}_.\n\n## Examples\n\n### Catching an URIError\n\n```js\ntry {\n  decodeURIComponent("%");\n} catch (e) {\n  console.log(e instanceof URIError); // true\n  console.log(e.message); // "malformed URI sequence"\n  console.log(e.name); // "URIError"\n  console.log(e.stack); // Stack of the error\n}\n```\n\n### Creating an URIError\n\n```js\ntry {\n  throw new URIError("Hello");\n} catch (e) {\n  console.log(e instanceof URIError); // true\n  console.log(e.message); // "Hello"\n  console.log(e.name); // "URIError"\n  console.log(e.stack); // Stack of the error\n}\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Error")}}\n- {{jsxref("decodeURI()")}}\n- {{jsxref("decodeURIComponent()")}}\n- {{jsxref("encodeURI()")}}\n- {{jsxref("encodeURIComponent()")}}\n',
        "urierror": {
            "index.md": '---\ntitle: URIError() constructor\nslug: Web/JavaScript/Reference/Global_Objects/URIError/URIError\npage-type: javascript-constructor\nbrowser-compat: javascript.builtins.URIError.URIError\n---\n\n{{JSRef}}\n\nThe **`URIError()`** constructor creates {{jsxref("URIError")}} objects.\n\n## Syntax\n\n```js-nolint\nnew URIError()\nnew URIError(message)\nnew URIError(message, options)\nnew URIError(message, fileName)\nnew URIError(message, fileName, lineNumber)\n\nURIError()\nURIError(message)\nURIError(message, options)\nURIError(message, fileName)\nURIError(message, fileName, lineNumber)\n```\n\n> **Note:** `URIError()` can be called with or without [`new`](/en-US/docs/Web/JavaScript/Reference/Operators/new). Both create a new `URIError` instance.\n\n### Parameters\n\n- `message` {{optional_inline}}\n  - : Human-readable description of the error.\n- `options` {{optional_inline}}\n  - : An object that has the following properties:\n    - `cause` {{optional_inline}}\n      - : A property indicating the specific cause of the error.\n        When catching and re-throwing an error with a more-specific or useful error message, this property can be used to pass the original error.\n- `fileName` {{optional_inline}} {{non-standard_inline}}\n  - : The name of the file containing the code that caused the exception.\n- `lineNumber` {{optional_inline}} {{non-standard_inline}}\n  - : The line number of the code that caused the exception.\n\n## Examples\n\n### Catching an URIError\n\n```js\ntry {\n  decodeURIComponent("%");\n} catch (e) {\n  console.log(e instanceof URIError); // true\n  console.log(e.message); // "malformed URI sequence"\n  console.log(e.name); // "URIError"\n  console.log(e.stack); // Stack of the error\n}\n```\n\n### Creating an URIError\n\n```js\ntry {\n  throw new URIError("Hello");\n} catch (e) {\n  console.log(e instanceof URIError); // true\n  console.log(e.message); // "Hello"\n  console.log(e.name); // "URIError"\n  console.log(e.stack); // Stack of the error\n}\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("Error")}}\n- {{jsxref("decodeURI()")}}\n- {{jsxref("decodeURIComponent()")}}\n- {{jsxref("encodeURI()")}}\n- {{jsxref("encodeURIComponent()")}}\n'
        }
    },
    "weakmap": {
        "delete": {
            "index.md": '---\ntitle: WeakMap.prototype.delete()\nslug: Web/JavaScript/Reference/Global_Objects/WeakMap/delete\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.WeakMap.delete\n---\n\n{{JSRef}}\n\nThe **`delete()`** method of {{jsxref("WeakMap")}} instances removes the specified element from this `WeakMap`.\n\n{{EmbedInteractiveExample("pages/js/weakmap-prototype-delete.html")}}\n\n## Syntax\n\n```js-nolint\nweakMapInstance.delete(key)\n```\n\n### Parameters\n\n- `key`\n  - : The key of the element to remove from the `WeakMap` object.\n\n### Return value\n\n`true` if an element in the `WeakMap` object has been removed successfully. `false` if the key is not found in the `WeakMap`. Always returns `false` if `key` is not an object or a [non-registered symbol](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#shared_symbols_in_the_global_symbol_registry).\n\n## Examples\n\n### Using the delete() method\n\n```js\nconst wm = new WeakMap();\nwm.set(window, "foo");\n\nwm.delete(window); // Returns true. Successfully removed.\n\nwm.has(window); // Returns false. The window object is no longer in the WeakMap.\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("WeakMap")}}\n'
        },
        "get": {
            "index.md": '---\ntitle: WeakMap.prototype.get()\nslug: Web/JavaScript/Reference/Global_Objects/WeakMap/get\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.WeakMap.get\n---\n\n{{JSRef}}\n\nThe **`get()`** method of {{jsxref("WeakMap")}} instances returns a specified element from this `WeakMap`.\n\n{{EmbedInteractiveExample("pages/js/weakmap-prototype-get.html")}}\n\n## Syntax\n\n```js-nolint\nget(key)\n```\n\n### Parameters\n\n- `key`\n  - : The key of the element to return from the `WeakMap` object.\n\n### Return value\n\nThe element associated with the specified key in the `WeakMap` object. If\nthe key can\'t be found, {{jsxref("undefined")}} is returned. Always returns\n`undefined` if `key` is not an object or a [non-registered symbol](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#shared_symbols_in_the_global_symbol_registry).\n\n## Examples\n\n### Using the get() method\n\n```js\nconst wm = new WeakMap();\nwm.set(window, "foo");\n\nwm.get(window); // Returns "foo".\nwm.get("baz"); // Returns undefined.\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("WeakMap")}}\n- {{jsxref("WeakMap.prototype.set()")}}\n- {{jsxref("WeakMap.prototype.has()")}}\n'
        },
        "has": {
            "index.md": '---\ntitle: WeakMap.prototype.has()\nslug: Web/JavaScript/Reference/Global_Objects/WeakMap/has\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.WeakMap.has\n---\n\n{{JSRef}}\n\nThe **`has()`** method of {{jsxref("WeakMap")}} instances returns a boolean indicating whether an\nelement with the specified key exists in this `WeakMap` or not.\n\n{{EmbedInteractiveExample("pages/js/weakmap-prototype-has.html")}}\n\n## Syntax\n\n```js-nolint\nhas(key)\n```\n\n### Parameters\n\n- `key`\n  - : The key of the element to test for presence in the `WeakMap` object.\n\n### Return value\n\nReturns `true` if an element with the specified key exists in the `WeakMap` object; otherwise `false`. Always returns `false` if `key` is not an object or a [non-registered symbol](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#shared_symbols_in_the_global_symbol_registry).\n\n## Examples\n\n### Using the has method\n\n```js\nconst wm = new WeakMap();\nwm.set(window, "foo");\n\nwm.has(window); // returns true\nwm.has("baz"); // returns false\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("WeakMap")}}\n- {{jsxref("WeakMap.prototype.set()")}}\n- {{jsxref("WeakMap.prototype.get()")}}\n'
        },
        "index.md": '---\ntitle: WeakMap\nslug: Web/JavaScript/Reference/Global_Objects/WeakMap\npage-type: javascript-class\nbrowser-compat: javascript.builtins.WeakMap\n---\n\n{{JSRef}}\n\nA **`WeakMap`** is a collection of key/value pairs whose keys must be objects or [non-registered symbols](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#shared_symbols_in_the_global_symbol_registry), with values of any arbitrary [JavaScript type](/en-US/docs/Web/JavaScript/Data_structures), and which does not create strong references to its keys. That is, an object\'s presence as a key in a `WeakMap` does not prevent the object from being garbage collected. Once an object used as a key has been collected, its corresponding values in any `WeakMap` become candidates for garbage collection as well \u2014 as long as they aren\'t strongly referred to elsewhere. The only primitive type that can be used as a `WeakMap` key is symbol \u2014 more specifically, [non-registered symbols](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#shared_symbols_in_the_global_symbol_registry) \u2014 because non-registered symbols are guaranteed to be unique and cannot be re-created.\n\n`WeakMap` allows associating data to objects in a way that doesn\'t prevent the key objects from being collected, even if the values reference the keys. However, a `WeakMap` doesn\'t allow observing the liveness of its keys, which is why it doesn\'t allow enumeration; if a `WeakMap` exposed any method to obtain a list of its keys, the list would depend on the state of garbage collection, introducing non-determinism. If you want to have a list of keys, you should use a {{jsxref("Map")}} rather than a `WeakMap`.\n\nYou can learn more about `WeakMap` in the [WeakMap object](/en-US/docs/Web/JavaScript/Guide/Keyed_collections#weakmap_object) section of the [Keyed collections](/en-US/docs/Web/JavaScript/Guide/Keyed_collections) guide.\n\n## Description\n\nKeys of WeakMaps must be garbage-collectable. Most {{Glossary("Primitive", "primitive data types")}} can be arbitrarily created and don\'t have a lifetime, so they cannot be used as keys. Objects and [non-registered symbols](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#shared_symbols_in_the_global_symbol_registry) can be used as keys because they are garbage-collectable.\n\n### Why WeakMap?\n\nA map API _could_ be implemented in JavaScript with two arrays (one for keys, one for values) shared by the four API methods. Setting elements on this map would involve pushing a key and value onto the end of each of those arrays simultaneously. As a result, the indices of the key and value would correspond to both arrays. Getting values from the map would involve iterating through all keys to find a match, then using the index of this match to retrieve the corresponding value from the array of values.\n\nSuch an implementation would have two main inconveniences:\n\n1. The first one is an `O(n)` set and search (_n_ being the number of keys in the map) since both operations must iterate through the list of keys to find a matching value.\n2. The second inconvenience is a memory leak because the arrays ensure that references to each key and each value are maintained indefinitely. These references prevent the keys from being garbage collected, even if there are no other references to the object. This would also prevent the corresponding values from being garbage collected.\n\nBy contrast, in a `WeakMap`, a key object refers strongly to its contents as long as the key is not garbage collected, but weakly from then on. As such, a `WeakMap`:\n\n- does not prevent garbage collection, which eventually removes references to the key object\n- allows garbage collection of any values if their key objects are not referenced from somewhere other than a `WeakMap`\n\nA `WeakMap` can be a particularly useful construct when mapping keys to information about the key that is valuable _only if_ the key has not been garbage collected.\n\nBut because a `WeakMap` doesn\'t allow observing the liveness of its keys, its keys are not enumerable. There is no method to obtain a list of the keys. If there were, the list would depend on the state of garbage collection, introducing non-determinism. If you want to have a list of keys, you should use a {{jsxref("Map")}}.\n\n## Constructor\n\n- {{jsxref("WeakMap/WeakMap", "WeakMap()")}}\n  - : Creates a new `WeakMap` object.\n\n## Instance properties\n\nThese properties are defined on `WeakMap.prototype` and shared by all `WeakMap` instances.\n\n- {{jsxref("Object/constructor", "WeakMap.prototype.constructor")}}\n  - : The constructor function that created the instance object. For `WeakMap` instances, the initial value is the {{jsxref("WeakMap/WeakMap", "WeakMap")}} constructor.\n- `WeakMap.prototype[@@toStringTag]`\n  - : The initial value of the [`@@toStringTag`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol/toStringTag) property is the string `"WeakMap"`. This property is used in {{jsxref("Object.prototype.toString()")}}.\n\n## Instance methods\n\n- {{jsxref("WeakMap.prototype.delete()")}}\n  - : Removes any value associated to the `key`. `WeakMap.prototype.has(key)` will return `false` afterwards.\n- {{jsxref("WeakMap.prototype.get()")}}\n  - : Returns the value associated to the `key`, or `undefined` if there is none.\n- {{jsxref("WeakMap.prototype.has()")}}\n  - : Returns a Boolean asserting whether a value has been associated to the `key` in the `WeakMap` object or not.\n- {{jsxref("WeakMap.prototype.set()")}}\n  - : Sets the `value` for the `key` in the `WeakMap` object. Returns the `WeakMap` object.\n\n## Examples\n\n### Using WeakMap\n\n```js\nconst wm1 = new WeakMap();\nconst wm2 = new WeakMap();\nconst wm3 = new WeakMap();\nconst o1 = {};\nconst o2 = function () {};\nconst o3 = window;\n\nwm1.set(o1, 37);\nwm1.set(o2, "azerty");\nwm2.set(o1, o2); // a value can be anything, including an object or a function\nwm2.set(o2, undefined);\nwm2.set(wm1, wm2); // keys and values can be any objects. Even WeakMaps!\n\nwm1.get(o2); // "azerty"\nwm2.get(o2); // undefined, because that is the set value\nwm2.get(o3); // undefined, because there is no key for o3 on wm2\n\nwm1.has(o2); // true\nwm2.has(o2); // true (even if the value itself is \'undefined\')\nwm2.has(o3); // false\n\nwm3.set(o1, 37);\nwm3.get(o1); // 37\n\nwm1.has(o1); // true\nwm1.delete(o1);\nwm1.has(o1); // false\n```\n\n### Implementing a WeakMap-like class with a .clear() method\n\n```js\nclass ClearableWeakMap {\n  #wm;\n  constructor(init) {\n    this.#wm = new WeakMap(init);\n  }\n  clear() {\n    this.#wm = new WeakMap();\n  }\n  delete(k) {\n    return this.#wm.delete(k);\n  }\n  get(k) {\n    return this.#wm.get(k);\n  }\n  has(k) {\n    return this.#wm.has(k);\n  }\n  set(k, v) {\n    this.#wm.set(k, v);\n    return this;\n  }\n}\n```\n\n### Emulating private members\n\nDevelopers can use a `WeakMap` to associate private data to an object, with the following benefits:\n\n- Compared to a {{jsxref("Map")}}, a WeakMap does not hold strong references to the object used as the key, so the metadata shares the same lifetime as the object itself, avoiding memory leaks.\n- Compared to using non-enumerable and/or {{jsxref("Symbol")}} properties, a WeakMap is external to the object and there is no way for user code to retrieve the metadata through reflective methods like {{jsxref("Object.getOwnPropertySymbols")}}.\n- Compared to a [closure](/en-US/docs/Web/JavaScript/Closures), the same WeakMap can be reused for all instances created from a constructor, making it more memory-efficient, and allows different instances of the same class to read the private members of each other.\n\n```js\nlet Thing;\n\n{\n  const privateScope = new WeakMap();\n  let counter = 0;\n\n  Thing = function () {\n    this.someProperty = "foo";\n\n    privateScope.set(this, {\n      hidden: ++counter,\n    });\n  };\n\n  Thing.prototype.showPublic = function () {\n    return this.someProperty;\n  };\n\n  Thing.prototype.showPrivate = function () {\n    return privateScope.get(this).hidden;\n  };\n}\n\nconsole.log(typeof privateScope);\n// "undefined"\n\nconst thing = new Thing();\n\nconsole.log(thing);\n// Thing {someProperty: "foo"}\n\nthing.showPublic();\n// "foo"\n\nthing.showPrivate();\n// 1\n```\n\nThis is roughly equivalent to the following, using [private fields](/en-US/docs/Web/JavaScript/Reference/Classes/Private_properties):\n\n```js\nclass Thing {\n  static #counter = 0;\n  #hidden;\n  constructor() {\n    this.someProperty = "foo";\n    this.#hidden = ++Thing.#counter;\n  }\n  showPublic() {\n    return this.someProperty;\n  }\n  showPrivate() {\n    return this.#hidden;\n  }\n}\n\nconsole.log(thing);\n// Thing {someProperty: "foo"}\n\nthing.showPublic();\n// "foo"\n\nthing.showPrivate();\n// 1\n```\n\n### Associating metadata\n\nA {{jsxref("WeakMap")}} can be used to associate metadata with an object, without affecting the lifetime of the object itself. This is very similar to the private members example, since private members are also modelled as external metadata that doesn\'t participate in [prototypical inheritance](/en-US/docs/Web/JavaScript/Inheritance_and_the_prototype_chain).\n\nThis use case can be extended to already-created objects. For example, on the web, we may want to associate extra data with a DOM element, which the DOM element may access later. A common approach is to attach the data as a property:\n\n```js\nconst buttons = document.querySelectorAll(".button");\nbuttons.forEach((button) => {\n  button.clicked = false;\n  button.addEventListener("click", () => {\n    button.clicked = true;\n    const currentButtons = [...document.querySelectorAll(".button")];\n    if (currentButtons.every((button) => button.clicked)) {\n      console.log("All buttons have been clicked!");\n    }\n  });\n});\n```\n\nThis approach works, but it has a few pitfalls:\n\n- The `clicked` property is enumerable, so it will show up in [`Object.keys(button)`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/keys), [`for...in`](/en-US/docs/Web/JavaScript/Reference/Statements/for...in) loops, etc. This can be mitigated by using {{jsxref("Object.defineProperty()")}}, but that makes the code more verbose.\n- The `clicked` property is a normal string property, so it can be accessed and overwritten by other code. This can be mitigated by using a {{jsxref("Symbol")}} key, but the key would still be accessible via {{jsxref("Object.getOwnPropertySymbols()")}}.\n\nUsing a `WeakMap` fixes these:\n\n```js\nconst buttons = document.querySelectorAll(".button");\nconst clicked = new WeakMap();\nbuttons.forEach((button) => {\n  clicked.set(button, false);\n  button.addEventListener("click", () => {\n    clicked.set(button, true);\n    const currentButtons = [...document.querySelectorAll(".button")];\n    if (currentButtons.every((button) => clicked.get(button))) {\n      console.log("All buttons have been clicked!");\n    }\n  });\n});\n```\n\nHere, only code that has access to `clicked` knows the clicked state of each button, and external code can\'t modify the states. In addition, if any of the buttons gets removed from the DOM, the associated metadata will automatically get garbage-collected.\n\n### Caching\n\nYou can associate objects passed to a function with the result of the function, so that if the same object is passed again, the cached result can be returned without re-executing the function. This is useful if the function is pure (i.e. it doesn\'t mutate any outside objects or cause other observable side effects).\n\n```js\nconst cache = new WeakMap();\nfunction handleObjectValues(obj) {\n  if (cache.has(obj)) {\n    return cache.get(obj);\n  }\n  const result = Object.values(obj).map(heavyComputation);\n  cache.set(obj, result);\n  return result;\n}\n```\n\nThis only works if your function\'s input is an object. Moreover, even if the input is never passed in again, the result still remains forever in the cache. A more effective way is to use a {{jsxref("Map")}} paired with {{jsxref("WeakRef")}} objects, which allows you to associate any type of input value with its respective (potentially large) computation result. See the [WeakRefs and FinalizationRegistry](/en-US/docs/Web/JavaScript/Memory_management#weakrefs_and_finalizationregistry) example for more details.\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `WeakMap` in `core-js`](https://github.com/zloirock/core-js#weakmap)\n- [Keyed collections](/en-US/docs/Web/JavaScript/Guide/Keyed_collections#weakmap_object)\n- [Hiding Implementation Details with ECMAScript 6 WeakMaps](https://fitzgeraldnick.com/2014/01/13/hiding-implementation-details-with-e6-weakmaps.html) by Nick Fitzgerald (2014)\n- {{jsxref("Map")}}\n- {{jsxref("Set")}}\n- {{jsxref("WeakSet")}}\n',
        "set": {
            "index.md": '---\ntitle: WeakMap.prototype.set()\nslug: Web/JavaScript/Reference/Global_Objects/WeakMap/set\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.WeakMap.set\n---\n\n{{JSRef}}\n\nThe **`set()`** method of {{jsxref("WeakMap")}} instances adds a new element with a specified key\nand value to this `WeakMap`.\n\n{{EmbedInteractiveExample("pages/js/weakmap-prototype-set.html")}}\n\n## Syntax\n\n```js-nolint\nset(key, value)\n```\n\n### Parameters\n\n- `key`\n  - : Must be either an object or a [non-registered symbol](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#shared_symbols_in_the_global_symbol_registry). The key of the entry to add to the `WeakMap` object.\n- `value`\n  - : Any value representing the value of the entry to add to the `WeakMap` object.\n\n### Return value\n\nThe `WeakMap` object.\n\n### Exceptions\n\n- {{jsxref("TypeError")}}\n  - : Thrown if `key` is not an object or a [non-registered symbol](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#shared_symbols_in_the_global_symbol_registry).\n\n## Examples\n\n### Using the set() method\n\n```js\nconst wm = new WeakMap();\nconst obj = {};\n\n// Add new elements to the WeakMap\nwm.set(obj, "foo").set(window, "bar"); // chainable\n\n// Update an element in the WeakMap\nwm.set(obj, "baz");\n\n// Using a non-registered symbol as key\nconst sym = Symbol("foo");\nwm.set(sym, "baz");\nwm.set(Symbol.iterator, "qux");\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("WeakMap")}}\n- {{jsxref("WeakMap.prototype.get()")}}\n- {{jsxref("WeakMap.prototype.has()")}}\n'
        },
        "weakmap": {
            "index.md": '---\ntitle: WeakMap() constructor\nslug: Web/JavaScript/Reference/Global_Objects/WeakMap/WeakMap\npage-type: javascript-constructor\nbrowser-compat: javascript.builtins.WeakMap.WeakMap\n---\n\n{{JSRef}}\n\nThe **`WeakMap()`** constructor creates {{jsxref("WeakMap")}} objects.\n\n## Syntax\n\n```js-nolint\nnew WeakMap()\nnew WeakMap(iterable)\n```\n\n> **Note:** `WeakMap()` can only be constructed with [`new`](/en-US/docs/Web/JavaScript/Reference/Operators/new). Attempting to call it without `new` throws a {{jsxref("TypeError")}}.\n\n### Parameters\n\n- `iterable`\n  - : An [`Array`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array) or other iterable object that implements an [@@iterator](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/@@iterator) method that returns an iterator object that produces a two-element array-like object whose first element is a value that will be used as a `WeakMap` key and whose second element is the value to associate with that key. Each key-value pair will be added to the new `WeakMap`. null is treated as undefined.\n\n## Examples\n\n### Using WeakMap\n\n```js\nconst wm1 = new WeakMap();\nconst wm2 = new WeakMap();\nconst wm3 = new WeakMap();\nconst o1 = {};\nconst o2 = function () {};\nconst o3 = window;\n\nwm1.set(o1, 37);\nwm1.set(o2, "azerty");\nwm2.set(o1, o2); // a value can be anything, including an object or a function\nwm2.set(o3, undefined);\nwm2.set(wm1, wm2); // keys and values can be any objects. Even WeakMaps!\n\nwm1.get(o2); // "azerty"\nwm2.get(o2); // undefined, because there is no key for o2 on wm2\nwm2.get(o3); // undefined, because that is the set value\n\nwm1.has(o2); // true\nwm2.has(o2); // false\nwm2.has(o3); // true (even if the value itself is \'undefined\')\n\nwm3.set(o1, 37);\nwm3.get(o1); // 37\n\nwm1.has(o1); // true\nwm1.delete(o1);\nwm1.has(o1); // false\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `WeakMap` in `core-js`](https://github.com/zloirock/core-js#weakmap)\n- [`WeakMap` in the JavaScript guide](/en-US/docs/Web/JavaScript/Guide/Keyed_collections#weakmap_object)\n- [Hiding Implementation Details with ECMAScript 6 WeakMaps](https://fitzgeraldnick.com/2014/01/13/hiding-implementation-details-with-e6-weakmaps.html)\n- {{jsxref("Map")}}\n- {{jsxref("Set")}}\n- {{jsxref("WeakSet")}}\n'
        }
    },
    "weakref": {
        "deref": {
            "index.md": '---\ntitle: WeakRef.prototype.deref()\nslug: Web/JavaScript/Reference/Global_Objects/WeakRef/deref\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.WeakRef.deref\n---\n\n{{JSRef}}\n\nThe **`deref()`** method of {{jsxref("WeakRef")}} instances returns this `WeakRef`\'s target value, or `undefined` if the target value has been garbage-collected.\n\n## Syntax\n\n```js-nolint\nderef()\n```\n\n### Parameters\n\nNone.\n\n### Return value\n\nThe target value of the WeakRef, which is either an object or a [non-registered symbol](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#shared_symbols_in_the_global_symbol_registry). Returns `undefined` if the value has been garbage-collected.\n\n## Description\n\nSee the [Notes on WeakRefs](/en-US/docs/Web/JavaScript/Reference/Global_Objects/WeakRef#notes_on_weakrefs) section of the {{jsxref("WeakRef")}} page for some important notes.\n\n## Examples\n\n### Using deref()\n\nSee the [Examples](/en-US/docs/Web/JavaScript/Reference/Global_Objects/WeakRef#examples)\nsection of the {{jsxref("WeakRef")}} page for the complete example.\n\n```js\nconst tick = () => {\n  // Get the element from the weak reference, if it still exists\n  const element = this.ref.deref();\n  if (element) {\n    element.textContent = ++this.count;\n  } else {\n    // The element doesn\'t exist anymore\n    console.log("The element is gone.");\n    this.stop();\n    this.ref = null;\n  }\n};\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("WeakRef")}}\n'
        },
        "index.md": '---\ntitle: WeakRef\nslug: Web/JavaScript/Reference/Global_Objects/WeakRef\npage-type: javascript-class\nbrowser-compat: javascript.builtins.WeakRef\n---\n\n{{JSRef}}\n\nA **`WeakRef`** object lets you hold a weak reference to another object, without preventing that object from getting garbage-collected.\n\n## Description\n\nA `WeakRef` object contains a weak reference to an object, which is called its _target_ or _referent_. A _weak reference_ to an object is a reference that does not prevent the object from being reclaimed by the garbage collector. In contrast, a normal (or _strong_) reference keeps an object in memory. When an object no longer has any strong references to it, the JavaScript engine\'s garbage collector may destroy the object and reclaim its memory. If that happens, you can\'t get the object from a weak reference anymore.\n\nBecause [non-registered symbols](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#shared_symbols_in_the_global_symbol_registry) are also garbage collectable, they can also be used as the target of a `WeakRef` object. However, the use case of this is limited.\n\n### Avoid where possible\n\nCorrect use of `WeakRef` takes careful thought, and it\'s best avoided if possible. It\'s also important to avoid relying on any specific behaviors not guaranteed by the specification. When, how, and whether garbage collection occurs is down to the implementation of any given JavaScript engine. Any behavior you observe in one engine may be different in another engine, in another version of the same engine, or even in a slightly different situation with the same version of the same engine. Garbage collection is a hard problem that JavaScript engine implementers are constantly refining and improving their solutions to.\n\nHere are some specific points included by the authors in the [proposal](https://github.com/tc39/proposal-weakrefs) that introduced `WeakRef`:\n\n> [Garbage collectors](<https://en.wikipedia.org/wiki/Garbage_collection_(computer_science)>) are complicated. If an application or library depends on GC cleaning up a WeakRef or calling a finalizer \\[cleanup callback] in a timely, predictable manner, it\'s likely to be disappointed: the cleanup may happen much later than expected, or not at all. Sources of variability include:\n>\n> - One object might be garbage-collected much sooner than another object, even if they become unreachable at the same time, e.g., due to generational collection.\n> - Garbage collection work can be split up over time using incremental and concurrent techniques.\n> - Various runtime heuristics can be used to balance memory usage, responsiveness.\n> - The JavaScript engine may hold references to things which look like they are unreachable (e.g., in closures, or inline caches).\n> - Different JavaScript engines may do these things differently, or the same engine may change its algorithms across versions.\n> - Complex factors may lead to objects being held alive for unexpected amounts of time, such as use with certain APIs.\n\n### Notes on WeakRefs\n\n- If your code has just created a `WeakRef` for a target object, or has gotten a target object from a `WeakRef`\'s `deref` method, that target object will not be reclaimed until the end of the current JavaScript [job](https://tc39.es/ecma262/multipage/executable-code-and-execution-contexts.html#job) (including any promise reaction jobs that run at the end of a script job). That is, you can only "see" an object get reclaimed between turns of the event loop. This is primarily to avoid making the behavior of any given JavaScript engine\'s garbage collector apparent in code \u2014 because if it were, people would write code relying on that behavior, which would break when the garbage collector\'s behavior changed. (Garbage collection is a hard problem; JavaScript engine implementers are constantly refining and improving how it works.)\n- If multiple `WeakRef`s have the same target, they\'re consistent with one another. The result of calling `deref` on one of them will match the result of calling `deref` on another of them (in the same job), you won\'t get the target object from one of them but `undefined` from another.\n- If the target of a `WeakRef` is also in a {{jsxref("FinalizationRegistry")}}, the `WeakRef`\'s target is cleared at the same time or before any cleanup callback associated with the registry is called; if your cleanup callback calls `deref` on a `WeakRef` for the object, it will receive `undefined`.\n- You cannot change the target of a `WeakRef`, it will always only ever be the original target object or `undefined` when that target has been reclaimed.\n- A `WeakRef` might never return `undefined` from `deref`, even if nothing strongly holds the target, because the garbage collector may never decide to reclaim the object.\n\n## Constructor\n\n- {{jsxref("WeakRef/WeakRef", "WeakRef()")}}\n  - : Creates a new `WeakRef` object.\n\n## Instance properties\n\nThese properties are defined on `WeakRef.prototype` and shared by all `WeakRef` instances.\n\n- {{jsxref("Object/constructor", "WeakRef.prototype.constructor")}} {{optional_inline}}\n\n  - : The constructor function that created the instance object. For `WeakRef` instances, the initial value is the {{jsxref("WeakRef/WeakRef", "WeakRef")}} constructor.\n\n    > **Note:** This property is marked as "normative optional" in the specification, which means a conforming implementation may not expose the `constructor` property. This prevents arbitrary code from obtaining the `WeakRef` constructor and being able to observe garbage collection. However, all major engines do expose it by default.\n\n- `WeakRef.prototype[@@toStringTag]`\n  - : The initial value of the [`@@toStringTag`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol/toStringTag) property is the string `"WeakRef"`. This property is used in {{jsxref("Object.prototype.toString()")}}.\n\n## Instance methods\n\n- {{jsxref("WeakRef.prototype.deref()")}}\n  - : Returns the `WeakRef` object\'s target object, or `undefined` if the target object has been reclaimed.\n\n## Examples\n\n### Using a WeakRef object\n\nThis example starts a counter shown in a DOM element, stopping when the element doesn\'t exist anymore:\n\n```js\nclass Counter {\n  constructor(element) {\n    // Remember a weak reference to the DOM element\n    this.ref = new WeakRef(element);\n    this.start();\n  }\n\n  start() {\n    if (this.timer) {\n      return;\n    }\n\n    this.count = 0;\n\n    const tick = () => {\n      // Get the element from the weak reference, if it still exists\n      const element = this.ref.deref();\n      if (element) {\n        element.textContent = ++this.count;\n      } else {\n        // The element doesn\'t exist anymore\n        console.log("The element is gone.");\n        this.stop();\n        this.ref = null;\n      }\n    };\n\n    tick();\n    this.timer = setInterval(tick, 1000);\n  }\n\n  stop() {\n    if (this.timer) {\n      clearInterval(this.timer);\n      this.timer = 0;\n    }\n  }\n}\n\nconst counter = new Counter(document.getElementById("counter"));\nsetTimeout(() => {\n  document.getElementById("counter").remove();\n}, 5000);\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("FinalizationRegistry")}}\n- {{jsxref("WeakSet")}}\n- {{jsxref("WeakMap")}}\n',
        "weakref": {
            "index.md": '---\ntitle: WeakRef() constructor\nslug: Web/JavaScript/Reference/Global_Objects/WeakRef/WeakRef\npage-type: javascript-constructor\nbrowser-compat: javascript.builtins.WeakRef.WeakRef\n---\n\n{{JSRef}}\n\nThe **`WeakRef()`** constructor creates {{jsxref("WeakRef")}} objects.\n\n## Syntax\n\n```js-nolint\nnew WeakRef(target)\n```\n\n> **Note:** `WeakRef()` can only be constructed with [`new`](/en-US/docs/Web/JavaScript/Reference/Operators/new). Attempting to call it without `new` throws a {{jsxref("TypeError")}}.\n\n### Parameters\n\n- `target`\n  - : The target value the WeakRef should refer to (also called the _referent_). Must be an object or a [non-registered symbol](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#shared_symbols_in_the_global_symbol_registry).\n\n### Return value\n\nA new `WeakRef` object referring to the given target value.\n\n### Exceptions\n\n- {{jsxref("TypeError")}}\n  - : Thrown if `target` is not an object or a [non-registered symbol](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#shared_symbols_in_the_global_symbol_registry).\n\n## Examples\n\n### Creating a new WeakRef object\n\nSee the main [`WeakRef`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/WeakRef#examples)\npage for a complete example.\n\n```js\nclass Counter {\n  constructor(element) {\n    // Remember a weak reference to a DOM element\n    this.ref = new WeakRef(element);\n    this.start();\n  }\n}\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("WeakRef")}}\n'
        }
    },
    "weakset": {
        "add": {
            "index.md": '---\ntitle: WeakSet.prototype.add()\nslug: Web/JavaScript/Reference/Global_Objects/WeakSet/add\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.WeakSet.add\n---\n\n{{JSRef}}\n\nThe **`add()`** method of {{jsxref("WeakSet")}} instances appends a new object to the end of this `WeakSet`.\n\n{{EmbedInteractiveExample("pages/js/weakset-prototype-add.html", "taller")}}\n\n## Syntax\n\n```js-nolint\nadd(value)\n```\n\n### Parameters\n\n- `value`\n  - : Must be either an object or a [non-registered symbol](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#shared_symbols_in_the_global_symbol_registry). The value to add to the `WeakSet` collection.\n\n### Return value\n\nThe `WeakSet` object.\n\n### Exceptions\n\n- {{jsxref("TypeError")}}\n  - : Thrown if `value` is not an object or a [non-registered symbol](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#shared_symbols_in_the_global_symbol_registry).\n\n## Examples\n\n### Using add\n\n```js\nconst ws = new WeakSet();\n\nws.add(window); // add the window object to the WeakSet\n\nws.has(window); // true\n\n// WeakSet only takes objects as arguments\nws.add(1);\n// results in "TypeError: Invalid value used in weak set" in Chrome\n// and "TypeError: 1 is not a non-null object" in Firefox\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("WeakSet")}}\n- {{jsxref("WeakSet.prototype.delete()")}}\n- {{jsxref("WeakSet.prototype.has()")}}\n'
        },
        "delete": {
            "index.md": '---\ntitle: WeakSet.prototype.delete()\nslug: Web/JavaScript/Reference/Global_Objects/WeakSet/delete\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.WeakSet.delete\n---\n\n{{JSRef}}\n\nThe **`delete()`** method of {{jsxref("WeakSet")}} instances removes the specified element from this `WeakSet`.\n\n{{EmbedInteractiveExample("pages/js/weakset-prototype-delete.html")}}\n\n## Syntax\n\n```js-nolint\nweakSetInstance.delete(value)\n```\n\n### Parameters\n\n- `value`\n  - : The value to remove from the `WeakSet` object.\n\n### Return value\n\n`true` if an element in the `WeakSet` object has been removed successfully. `false` if the `value` is not found in the `WeakSet`. Always returns `false` if `value` is not an object or a [non-registered symbol](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#shared_symbols_in_the_global_symbol_registry).\n\n## Examples\n\n### Using the delete() method\n\n```js\nconst ws = new WeakSet();\nconst obj = {};\n\nws.add(window);\n\nws.delete(obj); // Returns false. No obj found to be deleted.\nws.delete(window); // Returns true. Successfully removed.\n\nws.has(window); // Returns false. The window is no longer present in the WeakSet.\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("WeakSet")}}\n- {{jsxref("WeakSet.prototype.add()")}}\n- {{jsxref("WeakSet.prototype.has()")}}\n'
        },
        "has": {
            "index.md": '---\ntitle: WeakSet.prototype.has()\nslug: Web/JavaScript/Reference/Global_Objects/WeakSet/has\npage-type: javascript-instance-method\nbrowser-compat: javascript.builtins.WeakSet.has\n---\n\n{{JSRef}}\n\nThe **`has()`** method of {{jsxref("WeakSet")}} instances returns a boolean indicating whether an\nobject exists in this `WeakSet` or not.\n\n{{EmbedInteractiveExample("pages/js/weakset-prototype-has.html")}}\n\n## Syntax\n\n```js-nolint\nhas(value)\n```\n\n### Parameters\n\n- `value`\n  - : The value to test for presence in the `WeakSet`.\n\n### Return value\n\nReturns `true` if an element with the specified value exists in the `WeakSet` object; otherwise `false`. Always returns `false` if `value` is not an object or a [non-registered symbol](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#shared_symbols_in_the_global_symbol_registry).\n\n## Examples\n\n### Using the `has()` method\n\n```js\nconst ws = new WeakSet();\nconst obj = {};\nws.add(window);\n\nws.has(window); // returns true\nws.has(obj); // returns false\n\n// Storing a non-registered symbol\nconst sym = Symbol("foo");\nws.add(sym);\nws.add(Symbol.iterator);\n```\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- {{jsxref("WeakSet")}}\n- {{jsxref("WeakSet.prototype.add()")}}\n- {{jsxref("WeakSet.prototype.delete()")}}\n'
        },
        "index.md": '---\ntitle: WeakSet\nslug: Web/JavaScript/Reference/Global_Objects/WeakSet\npage-type: javascript-class\nbrowser-compat: javascript.builtins.WeakSet\n---\n\n{{JSRef}}\n\nA **`WeakSet`** is a collection of garbage-collectable values, including objects and [non-registered symbols](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#shared_symbols_in_the_global_symbol_registry). A value in the `WeakSet` may only occur once. It is unique in the `WeakSet`\'s collection.\n\n## Description\n\nValues of WeakSets must be garbage-collectable. Most {{Glossary("Primitive", "primitive data types")}} can be arbitrarily created and don\'t have a lifetime, so they cannot be stored. Objects and [non-registered symbols](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#shared_symbols_in_the_global_symbol_registry) can be stored because they are garbage-collectable.\n\nThe main differences to the {{jsxref("Set")}} object are:\n\n- `WeakSet`s are collections of **objects and symbols only**. They cannot contain arbitrary values of any type, as {{jsxref("Set")}}s can.\n- The `WeakSet` is _weak_, meaning references to objects in a `WeakSet` are held _weakly_. If no other references to a value stored in the `WeakSet` exist, those values can be garbage collected.\n\n  > **Note:** This also means that there is no list of current values stored in the collection. `WeakSets` are not enumerable.\n\n### Use case: Detecting circular references\n\nFunctions that call themselves recursively need a way of guarding against circular data structures by tracking which objects have already been processed.\n\n`WeakSet`s are ideal for this purpose:\n\n```js\n// Execute a callback on everything stored inside an object\nfunction execRecursively(fn, subject, _refs = new WeakSet()) {\n  // Avoid infinite recursion\n  if (_refs.has(subject)) {\n    return;\n  }\n\n  fn(subject);\n  if (typeof subject === "object" && subject) {\n    _refs.add(subject);\n    for (const key in subject) {\n      execRecursively(fn, subject[key], _refs);\n    }\n    _refs.delete(subject);\n  }\n}\n\nconst foo = {\n  foo: "Foo",\n  bar: {\n    bar: "Bar",\n  },\n};\n\nfoo.bar.baz = foo; // Circular reference!\nexecRecursively((obj) => console.log(obj), foo);\n```\n\nHere, a `WeakSet` is created on the first run, and passed along with every subsequent function call (using the internal `_refs` parameter).\n\nThe number of objects or their traversal order is immaterial, so a `WeakSet` is more suitable (and performant) than a {{jsxref("Set")}} for tracking object references, especially if a very large number of objects is involved.\n\n## Constructor\n\n- {{jsxref("WeakSet/WeakSet", "WeakSet()")}}\n  - : Creates a new `WeakSet` object.\n\n## Instance properties\n\nThese properties are defined on `WeakSet.prototype` and shared by all `WeakSet` instances.\n\n- {{jsxref("Object/constructor", "WeakSet.prototype.constructor")}}\n  - : The constructor function that created the instance object. For `WeakSet` instances, the initial value is the {{jsxref("WeakSet/WeakSet", "WeakSet")}} constructor.\n- `WeakSet.prototype[@@toStringTag]`\n  - : The initial value of the [`@@toStringTag`](/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol/toStringTag) property is the string `"WeakSet"`. This property is used in {{jsxref("Object.prototype.toString()")}}.\n\n## Instance methods\n\n- {{jsxref("WeakSet.prototype.add()")}}\n  - : Appends `value` to the `WeakSet` object.\n- {{jsxref("WeakSet.prototype.delete()")}}\n  - : Removes `value` from the `WeakSet`. `WeakSet.prototype.has(value)` will return `false` afterwards.\n- {{jsxref("WeakSet.prototype.has()")}}\n  - : Returns a boolean asserting whether `value` is present in the `WeakSet` object or not.\n\n## Examples\n\n### Using the WeakSet object\n\n```js\nconst ws = new WeakSet();\nconst foo = {};\nconst bar = {};\n\nws.add(foo);\nws.add(bar);\n\nws.has(foo); // true\nws.has(bar); // true\n\nws.delete(foo); // removes foo from the set\nws.has(foo); // false, foo has been removed\nws.has(bar); // true, bar is retained\n```\n\nNote that `foo !== bar`. While they are similar objects, _they are not **the same object**_. And so they are both added to the set.\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `WeakSet` in `core-js`](https://github.com/zloirock/core-js#weakset)\n- {{jsxref("Map")}}\n- {{jsxref("Set")}}\n- {{jsxref("WeakMap")}}\n',
        "weakset": {
            "index.md": '---\ntitle: WeakSet() constructor\nslug: Web/JavaScript/Reference/Global_Objects/WeakSet/WeakSet\npage-type: javascript-constructor\nbrowser-compat: javascript.builtins.WeakSet.WeakSet\n---\n\n{{JSRef}}\n\nThe **`WeakSet()`** constructor creates {{jsxref("WeakSet")}} objects.\n\n## Syntax\n\n```js-nolint\nnew WeakSet()\nnew WeakSet(iterable)\n```\n\n> **Note:** `WeakSet()` can only be constructed with [`new`](/en-US/docs/Web/JavaScript/Reference/Operators/new). Attempting to call it without `new` throws a {{jsxref("TypeError")}}.\n\n### Parameters\n\n- `iterable` {{optional_inline}}\n  - : If an [iterable object](/en-US/docs/Web/JavaScript/Reference/Statements/for...of) is passed, all of its elements will be added to the new `WeakSet`. `null` is treated as `undefined`.\n\n## Examples\n\n### Using the WeakSet object\n\n```js\nconst ws = new WeakSet();\nconst foo = {};\nconst bar = {};\n\nws.add(foo);\nws.add(bar);\n\nws.has(foo); // true\nws.has(bar); // true\n\nws.delete(foo); // removes foo from the set\nws.has(foo); // false, foo has been removed\nws.has(bar); // true, bar is retained\n```\n\nNote that `foo !== bar`. While they are similar objects, _they are not\n**the same object**_. And so they are both added to the set.\n\n## Specifications\n\n{{Specifications}}\n\n## Browser compatibility\n\n{{Compat}}\n\n## See also\n\n- [Polyfill of `WeakSet` in `core-js`](https://github.com/zloirock/core-js#weakset)\n- {{jsxref("WeakSet")}}\n'
        }
    }
};


const $52e131b359010c40$var$MATCH_KUMASCRIPT = /{{(\w+)(\((?:\s*(?:"[^"]*"|\d+)\s*,?\s*)*\))?}}/;
const $52e131b359010c40$var$MATCH_ARG = /"([^"]*|\d+)"/g;
function $52e131b359010c40$var$matchArgs(str) {
    const args = [];
    let match;
    while(match = $52e131b359010c40$var$MATCH_ARG.exec(str))args.push(match[1]);
    return args;
}
const $52e131b359010c40$var$MDN_KUMA_FUNCS = {
    jsxref (name) {
        return "`" + name.replace(/\//g, ".") + "`";
    },
    domxref (name) {
        return "*" + name + "*";
    },
    Glossary (name) {
        return name;
    },
    Deprecated_Header () {
        return '<div className="font-bold bg-red-50 text-red-800 text-base">Deprecated</div>';
    },
    JSRef () {
        return "";
    },
    jsSidebar () {
        return "";
    },
    EmbedInteractiveExample () {
        return "";
    },
    js_property_attributes () {
        return "";
    },
    optional_inline () {
        return "";
    }
};
function $52e131b359010c40$var$renderMarkdown(next, node, renderChildren, state) {
    // FIXME: I'd like to use RuleType.link, but the combination of RuleType
    // being a const enum and tsc isolatedModules does not allow it. I hope this
    // gets fixed in a future version of markdown-to-jsx
    switch(node.type){
        case "3":
            {
                const lang = {
                    "js-nolint": "js"
                }[node.lang] ?? node.lang;
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("pre", {
                    className: "my-1 p-1 bg-gray-50 border border-gray-100 rounded",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cb8a0fe0beecb480$export$6a048cde9ca9b775), {
                        language: lang,
                        code: node.text
                    })
                });
            }
        case "5":
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("code", {
                className: "bg-gray-50 shadow-gray-200 shadow-[0_0_2px_1px_var(--tw-shadow-color)] rounded px-0.5",
                children: node.text
            });
        case "15":
            {
                const target = node.target.startsWith("/") ? "https://developer.mozilla.org" + node.target : node.target;
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                    title: node.title,
                    target: "_blank",
                    href: target,
                    children: renderChildren(node.children, state)
                });
            }
    }
    return next();
}
function $52e131b359010c40$var$docsRenderer(docs) {
    const rendered = docs.replace(/^---$.*^---$/ms, "").replace(new RegExp($52e131b359010c40$var$MATCH_KUMASCRIPT, "g"), (str)=>{
        const [, func, argsStr] = str.match($52e131b359010c40$var$MATCH_KUMASCRIPT);
        if ($52e131b359010c40$var$MDN_KUMA_FUNCS[func]) {
            const args = $52e131b359010c40$var$matchArgs(argsStr);
            return $52e131b359010c40$var$MDN_KUMA_FUNCS[func](...args);
        } else return str;
    }).replace(/^#+\s+Specifications$\n(^$\n|^[^#\n].*$\n)*/m, "").replace(/^#+\s+Browser compatibility$\n(^$\n|^[^#\n].*$\n)*/m, "");
    const sourcePath = docs.match(/^---$(.*)^---$/ms)[1]?.match(/^slug:\s+(.+)$/m)?.[1];
    const sourceLink = `https://developer.mozilla.org/en-US/docs/${sourcePath ?? ""}`;
    return function MDNDoc() {
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c2cae7fb2285a0f2$export$d3b62677feddf368), {
                    options: {
                        renderRule: $52e131b359010c40$var$renderMarkdown
                    },
                    children: rendered
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "text-xs mt-4",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                        className: "text-blue-800",
                        target: "_blank",
                        href: sourceLink,
                        children: "Source: MDN"
                    })
                })
            ]
        });
    };
}
function $52e131b359010c40$var$getSafe(obj, property) {
    try {
        return obj[property];
    } catch (e) {
        return undefined;
    }
}
function $52e131b359010c40$export$2e2bcd8739ae039(docs) {
    for (const globalName of Object.getOwnPropertyNames(globalThis)){
        const globalVar = $52e131b359010c40$var$getSafe(globalThis, globalName);
        const globalDocsKey = globalName.toLowerCase();
        if ((0, $27260dd5184212ee$export$2e2bcd8739ae039)[globalDocsKey]?.[globalDocsKey]?.["index.md"]) docs.set(globalVar, $52e131b359010c40$var$docsRenderer((0, $27260dd5184212ee$export$2e2bcd8739ae039)[globalDocsKey][globalDocsKey]["index.md"]));
        else if ((0, $27260dd5184212ee$export$2e2bcd8739ae039)[globalDocsKey]?.["index.md"]) docs.set(globalVar, $52e131b359010c40$var$docsRenderer((0, $27260dd5184212ee$export$2e2bcd8739ae039)[globalDocsKey]["index.md"]));
        if (globalVar !== null && typeof globalVar === "object" || typeof globalVar === "function") for (const objectProperty of Object.getOwnPropertyNames(globalVar)){
            const propertyDocsKey = objectProperty.toLowerCase();
            if ((0, $27260dd5184212ee$export$2e2bcd8739ae039)[globalDocsKey]?.[propertyDocsKey]?.["index.md"]) docs.set($52e131b359010c40$var$getSafe(globalVar, objectProperty), $52e131b359010c40$var$docsRenderer((0, $27260dd5184212ee$export$2e2bcd8739ae039)[globalDocsKey][propertyDocsKey]["index.md"]));
        }
        if (typeof globalVar === "function" && globalVar !== Function) {
            // For classes:
            const proto = globalVar.prototype;
            if (proto) {
                if ((0, $27260dd5184212ee$export$2e2bcd8739ae039)[globalDocsKey]?.["index.md"]) docs.set(proto, $52e131b359010c40$var$docsRenderer((0, $27260dd5184212ee$export$2e2bcd8739ae039)[globalDocsKey]["index.md"]));
                for (const protoProperty of Object.getOwnPropertyNames(proto)){
                    const propertyDocsKey = protoProperty.toLowerCase();
                    if ((0, $27260dd5184212ee$export$2e2bcd8739ae039)[globalDocsKey]?.[propertyDocsKey]?.["index.md"]) docs.set($52e131b359010c40$var$getSafe(proto, protoProperty), $52e131b359010c40$var$docsRenderer((0, $27260dd5184212ee$export$2e2bcd8739ae039)[globalDocsKey][propertyDocsKey]["index.md"]));
                }
            }
        }
    }
}


function $72a6f9babb1bcec7$export$3849b92fb7e12a24(docs) {
    (0, $52e131b359010c40$export$2e2bcd8739ae039)(docs);
}




var $c23fdcfbff473950$exports = {};

$parcel$defineInteropFlag($c23fdcfbff473950$exports);

$parcel$export($c23fdcfbff473950$exports, "default", () => $c23fdcfbff473950$export$2e2bcd8739ae039);



var $acw62 = parcelRequire("acw62");







function $4b0a7a04eb6e768f$export$85b6d125659bc305() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c2cae7fb2285a0f2$export$d3b62677feddf368), {
        options: {
            overrides: {
                Example: $4b0a7a04eb6e768f$export$2b8f26b427c15f
            }
        },
        children: `
Choose any Block with JavaScript available either in the environment or the \`blockLibrary\` parameter.

## Parameters

- \`expr: string\`
    - the initial js expression to choose a block
- \`innerBlockInit?: Block<unknown>\`
    - the initial chosen inner block
- \`blockLibrary: Environment\`
    - a builtin library of blocks that should always be available

## Examples

<Example code="BlockSelector('', undefined, { JSExpr })" />

<Example code="BlockSelector('JSExpr', undefined, { JSExpr })" />

<Example code="BlockSelector('JSExpr', JSExpr, { JSExpr })" />

<Example code="BlockSelector(
    'JSExpr',
    {
        ...JSExpr,
        init: { ...JSExpr.init, code: '// write some code' }
    },
    { JSExpr },
)" />
            `.trim()
    });
}
function $4b0a7a04eb6e768f$export$2e2bcd8739ae039(docs) {
    docs.set((0, $3cde51ebcb63af9c$export$7ddf129dd8d5219f), $4b0a7a04eb6e768f$export$85b6d125659bc305);
}
const $4b0a7a04eb6e768f$var$exampleEnv = {
    BlockSelector: $3cde51ebcb63af9c$export$7ddf129dd8d5219f,
    JSExpr: $6d146131cf95401b$export$4e4e7267e6bca3a9
};
function $4b0a7a04eb6e768f$export$2b8f26b427c15f({ code: code }) {
    const block = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $b8f588c17e3c1433$export$e255fd3f9a510304)((0, $e26ee743ff8e9b71$export$946ba5975ff1c976)(code, {
            BlockSelector: $3cde51ebcb63af9c$export$7ddf129dd8d5219f,
            JSExpr: $6d146131cf95401b$export$4e4e7267e6bca3a9
        })), []);
    const [state, dispatch] = (0, $6f23581c0aef6dc2$export$ece2d8b003194dcc)(block.init, [
        {
            env: $4b0a7a04eb6e768f$var$exampleEnv
        }
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "border rounded border-gray-100 p-1 my-4",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cb8a0fe0beecb480$export$6a048cde9ca9b775), {
                className: "block rounded bg-gray-100 px-1",
                code: code
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "border-t-2 border-slate-200 mt-1 pt-1",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(block.Component, {
                    state: state,
                    dispatch: dispatch,
                    env: $4b0a7a04eb6e768f$var$exampleEnv
                })
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");









function $3a8c9cdf9e77044e$export$e55672beeba4a5c0() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c2cae7fb2285a0f2$export$d3b62677feddf368), {
        options: {
            overrides: {
                Example: $3a8c9cdf9e77044e$export$2b8f26b427c15f
            }
        },
        children: `
A sheet of lines containing \`innerBlock\`. Lines can refer to prior lines
with their names.

## Parameters

- \`innerBlock: Block\`
    - the inner Block to use in lines

## Examples

<Example code="SheetOf(JSExpr)" />

<Example code="SheetOf(Note)" />

<Example code="SheetOf(BlockSelector('', undefined, { JSExpr, Note }))" />
            `.trim()
    });
}
function $3a8c9cdf9e77044e$export$2e2bcd8739ae039(docs) {
    docs.set((0, $2874ceca92f8bd68$export$8edc1c3b6e3ca47c), $3a8c9cdf9e77044e$export$e55672beeba4a5c0);
}
const $3a8c9cdf9e77044e$var$exampleEnv = {
    BlockSelector: $3cde51ebcb63af9c$export$7ddf129dd8d5219f,
    Note: $8c8e02836b046cc0$export$6c88bf799aca3d2b,
    JSExpr: $6d146131cf95401b$export$4e4e7267e6bca3a9
};
function $3a8c9cdf9e77044e$export$2b8f26b427c15f({ code: code }) {
    const block = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $b8f588c17e3c1433$export$e255fd3f9a510304)((0, $e26ee743ff8e9b71$export$946ba5975ff1c976)(code, {
            SheetOf: $2874ceca92f8bd68$export$8edc1c3b6e3ca47c,
            BlockSelector: $3cde51ebcb63af9c$export$7ddf129dd8d5219f,
            Note: $8c8e02836b046cc0$export$6c88bf799aca3d2b,
            JSExpr: $6d146131cf95401b$export$4e4e7267e6bca3a9
        })), []);
    const [state, setState] = (0, $6f23581c0aef6dc2$export$ece2d8b003194dcc)(block.init, [
        {
            env: $3a8c9cdf9e77044e$var$exampleEnv
        }
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "border rounded border-gray-100 p-1 my-4",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cb8a0fe0beecb480$export$6a048cde9ca9b775), {
                className: "block rounded bg-gray-100 px-1",
                code: code
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "border-t-2 border-slate-200 mt-1 pt-1",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(block.Component, {
                    state: state,
                    dispatch: setState,
                    env: $3a8c9cdf9e77044e$var$exampleEnv
                })
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");





function $daf9ca34de20fb81$export$64cb75015bcc917a() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c2cae7fb2285a0f2$export$d3b62677feddf368), {
        options: {
            overrides: {
                Example: $daf9ca34de20fb81$export$2b8f26b427c15f
            }
        },
        children: `
A single note line. Can be text formatted with Markdown, a computation
with JavaScript or any other Block.

## Syntax

- \`= <JavaScript Expression>\`
- \`/ <Block (JS Expression)>\`
- \`<Markdown>\`, eg
    - \`# Heading Level 1\`
    - \`## Heading Level 2\`
    - \`### Heading Level 3\`
    - \`*italic*\`, \`**bold**\`
    - \`[link text](link url)\`

## Examples

<Example input="# Heading Level 1" />

<Example input="= 12 * 12" />

<Example input="/JSExpr" />
            `.trim()
    });
}
function $daf9ca34de20fb81$export$2e2bcd8739ae039(docs) {
    docs.set((0, $8c8e02836b046cc0$export$6c88bf799aca3d2b), $daf9ca34de20fb81$export$64cb75015bcc917a);
}
const $daf9ca34de20fb81$export$3b9e85fc2378c522 = {
    JSExpr: $6d146131cf95401b$export$4e4e7267e6bca3a9
};
function $daf9ca34de20fb81$export$2b8f26b427c15f({ input: input }) {
    const initWithInput = {
        ...(0, $8c8e02836b046cc0$export$6c88bf799aca3d2b).init,
        input: input
    };
    const safeNote = (0, $b8f588c17e3c1433$export$e255fd3f9a510304)((0, $8c8e02836b046cc0$export$6c88bf799aca3d2b));
    const [state, dispatch] = (0, $6f23581c0aef6dc2$export$ece2d8b003194dcc)(null, [
        {
            env: $daf9ca34de20fb81$export$3b9e85fc2378c522
        }
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        dispatch(()=>({
                state: safeNote.recompute(initWithInput, dispatch, $daf9ca34de20fb81$export$3b9e85fc2378c522, null)
            }));
    }, []);
    if (state === null) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "border rounded border-gray-100 my-4",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(safeNote.Component, {
            state: state,
            dispatch: dispatch,
            env: $daf9ca34de20fb81$export$3b9e85fc2378c522
        })
    });
}


function $c23fdcfbff473950$export$2e2bcd8739ae039(docs) {
    (0, $6d146131cf95401b$export$3849b92fb7e12a24)(docs);
    (0, $4b0a7a04eb6e768f$export$2e2bcd8739ae039)(docs);
    (0, $3a8c9cdf9e77044e$export$2e2bcd8739ae039)(docs);
    (0, $daf9ca34de20fb81$export$2e2bcd8739ae039)(docs);
}


var $a090b7d5aa4cbd70$exports = {};
$a090b7d5aa4cbd70$exports = new URL("logotype.895d0c47.svg", import.meta.url).toString();


var $9f6c3f21f97647b7$exports = {};
$9f6c3f21f97647b7$exports = new URL("logo.1ccf69b8.svg", import.meta.url).toString();


var $2eb5a1dc8522e0c7$exports = {};
$2eb5a1dc8522e0c7$exports = new URL("logo.777e1f96.png", import.meta.url).toString();


var $c268d70c62b93c88$exports = {};
$c268d70c62b93c88$exports = new URL("demo.8fc5afe4.gif", import.meta.url).toString();


const $d8191c8ef38c43e2$var$resheet = {
    assets: {
        logoTypeSvg: new URL($a090b7d5aa4cbd70$exports),
        logoSvg: new URL($9f6c3f21f97647b7$exports),
        logoPng: new URL($2eb5a1dc8522e0c7$exports),
        demoGif: new URL($c268d70c62b93c88$exports)
    },
    core: {
        block: $6f23581c0aef6dc2$exports,
        multiple: $9d52f07a71ba7cea$exports
    },
    code: {
        completions: $5bd921a18e0690d7$exports,
        compute: $e26ee743ff8e9b71$exports,
        editor: $cb8a0fe0beecb480$exports,
        result: $e7500bbe9a1dee8a$exports,
        theme: $c7bafeaa47337a49$exports,
        ui: $0461fd3484597965$exports,
        useEditable: $0dbe0b62c1b2b006$exports,
        value: $b749c8e203b309f1$exports
    },
    blocks: {
        component: $b8f588c17e3c1433$exports,
        debug: $73f95362102603c2$exports,
        blockSelector: $3cde51ebcb63af9c$exports,
        compute: $e26ee743ff8e9b71$exports,
        sheet: $2874ceca92f8bd68$exports,
        document: {
            index: $2d38c60d8f38da78$exports,
            pages: $ea3d541d2f2fc6fe$exports
        },
        jsexpr: $6d146131cf95401b$exports,
        note: {
            index: $8c8e02836b046cc0$exports,
            note: $92ca999eabf01e6c$exports
        },
        loadFile: $593647a8a274cddc$exports,
        logic: {
            compute: $e26ee743ff8e9b71$exports
        },
        codeEditor: $cb8a0fe0beecb480$exports,
        utils: {
            ui: $777d0014849a8f55$exports,
            value: $b749c8e203b309f1$exports,
            shortcuts: $5bc960417406f657$exports
        },
        docs: $c23fdcfbff473950$exports
    },
    docs: {
        index: (0, $2caebf5e38315544$export$2e2bcd8739ae039),
        external: {
            index: $72a6f9babb1bcec7$exports,
            mdn: {
                index: $52e131b359010c40$exports,
                jsGlobalObjects: (0, $27260dd5184212ee$export$2e2bcd8739ae039)
            }
        }
    },
    util: {
        index: $512ec8d668819b2f$exports,
        hooks: $ff99259e85546794$exports,
        dispatch: $d0f575b1326e7f91$exports,
        search: $dfcd2f458918c5ae$exports,
        serialize: $303c1b51f19a20e4$exports,
        shortcuts: $5bc960417406f657$exports,
        validate: $dc2e80b7ebe4adb5$exports
    }
};
const $d8191c8ef38c43e2$export$b839f963c7dc0e34 = {
    library: {},
    React: $acw62,
    ReactDom: $11492dca620dcaa5$exports,
    ReactDomServer: $f46ed4009cb9c1cd$exports,
    FontAwesomeIcon: $e4ec753f5c716375$export$2b9260d4a45c8710,
    faSolid: $d8206b3ab2e65c05$exports,
    faRegular: $7435a4b2c8a749a5$exports,
    headlessui: $834328a1cfd2af33$exports,
    useEditable: $0dbe0b62c1b2b006$exports,
    prismReactRenderer: $0fdca79f03e679c4$exports,
    reactInspector: $8ded0b3da2a2e917$exports,
    reactIntersectionObserver: $9ac152c824b2d089$exports,
    immutable: $3c22431224d334b1$exports,
    lodash: (/*@__PURE__*/$parcel$interopDefault($f1q41)),
    babel: {
        core: $7Ockm,
        react: (0, (/*@__PURE__*/$parcel$interopDefault($ee632e633864f26f$exports))),
        parser: $fuTml,
        generator: $iQrBP,
        traverse: (0, (/*@__PURE__*/$parcel$interopDefault($aHxeO))),
        types: $ardUq
    },
    blocks: $285e49985e5a39fa$exports,
    ...$285e49985e5a39fa$exports,
    tables: $d8191c8ef38c43e2$var$resheet,
    resheet: /* for compatibility */ $d8191c8ef38c43e2$var$resheet
};
$d8191c8ef38c43e2$export$b839f963c7dc0e34.library = $d8191c8ef38c43e2$export$b839f963c7dc0e34;


/*
 * Dexie.js - a minimalistic wrapper for IndexedDB
 * ===============================================
 *
 * By David Fahlander, david.fahlander@gmail.com
 *
 * Version 3.2.7, Wed Mar 20 2024
 *
 * https://dexie.org
 *
 * Apache License Version 2.0, January 2004, http://www.apache.org/licenses/
 */ /*! *****************************************************************************
Copyright (c) Microsoft Corporation.
Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.
THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ var $2f895839ac78ac6c$var$__assign = function() {
    $2f895839ac78ac6c$var$__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $2f895839ac78ac6c$var$__assign.apply(this, arguments);
};
function $2f895839ac78ac6c$var$__spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
var $2f895839ac78ac6c$var$_global = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : $parcel$global;
var $2f895839ac78ac6c$var$keys = Object.keys;
var $2f895839ac78ac6c$var$isArray = Array.isArray;
if (typeof Promise !== "undefined" && !$2f895839ac78ac6c$var$_global.Promise) $2f895839ac78ac6c$var$_global.Promise = Promise;
function $2f895839ac78ac6c$var$extend(obj, extension) {
    if (typeof extension !== "object") return obj;
    $2f895839ac78ac6c$var$keys(extension).forEach(function(key) {
        obj[key] = extension[key];
    });
    return obj;
}
var $2f895839ac78ac6c$var$getProto = Object.getPrototypeOf;
var $2f895839ac78ac6c$var$_hasOwn = {}.hasOwnProperty;
function $2f895839ac78ac6c$var$hasOwn(obj, prop) {
    return $2f895839ac78ac6c$var$_hasOwn.call(obj, prop);
}
function $2f895839ac78ac6c$var$props(proto, extension) {
    if (typeof extension === "function") extension = extension($2f895839ac78ac6c$var$getProto(proto));
    (typeof Reflect === "undefined" ? $2f895839ac78ac6c$var$keys : Reflect.ownKeys)(extension).forEach(function(key) {
        $2f895839ac78ac6c$var$setProp(proto, key, extension[key]);
    });
}
var $2f895839ac78ac6c$var$defineProperty = Object.defineProperty;
function $2f895839ac78ac6c$var$setProp(obj, prop, functionOrGetSet, options) {
    $2f895839ac78ac6c$var$defineProperty(obj, prop, $2f895839ac78ac6c$var$extend(functionOrGetSet && $2f895839ac78ac6c$var$hasOwn(functionOrGetSet, "get") && typeof functionOrGetSet.get === "function" ? {
        get: functionOrGetSet.get,
        set: functionOrGetSet.set,
        configurable: true
    } : {
        value: functionOrGetSet,
        configurable: true,
        writable: true
    }, options));
}
function $2f895839ac78ac6c$var$derive(Child) {
    return {
        from: function(Parent) {
            Child.prototype = Object.create(Parent.prototype);
            $2f895839ac78ac6c$var$setProp(Child.prototype, "constructor", Child);
            return {
                extend: $2f895839ac78ac6c$var$props.bind(null, Child.prototype)
            };
        }
    };
}
var $2f895839ac78ac6c$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
function $2f895839ac78ac6c$var$getPropertyDescriptor(obj, prop) {
    var pd = $2f895839ac78ac6c$var$getOwnPropertyDescriptor(obj, prop);
    var proto;
    return pd || (proto = $2f895839ac78ac6c$var$getProto(obj)) && $2f895839ac78ac6c$var$getPropertyDescriptor(proto, prop);
}
var $2f895839ac78ac6c$var$_slice = [].slice;
function $2f895839ac78ac6c$var$slice(args, start, end) {
    return $2f895839ac78ac6c$var$_slice.call(args, start, end);
}
function $2f895839ac78ac6c$var$override(origFunc, overridedFactory) {
    return overridedFactory(origFunc);
}
function $2f895839ac78ac6c$var$assert(b) {
    if (!b) throw new Error("Assertion Failed");
}
function $2f895839ac78ac6c$var$asap$1(fn) {
    if ($2f895839ac78ac6c$var$_global.setImmediate) setImmediate(fn);
    else setTimeout(fn, 0);
}
function $2f895839ac78ac6c$var$arrayToObject(array, extractor) {
    return array.reduce(function(result, item, i) {
        var nameAndValue = extractor(item, i);
        if (nameAndValue) result[nameAndValue[0]] = nameAndValue[1];
        return result;
    }, {});
}
function $2f895839ac78ac6c$var$tryCatch(fn, onerror, args) {
    try {
        fn.apply(null, args);
    } catch (ex) {
        onerror && onerror(ex);
    }
}
function $2f895839ac78ac6c$var$getByKeyPath(obj, keyPath) {
    if (typeof keyPath === "string" && $2f895839ac78ac6c$var$hasOwn(obj, keyPath)) return obj[keyPath];
    if (!keyPath) return obj;
    if (typeof keyPath !== "string") {
        var rv = [];
        for(var i = 0, l = keyPath.length; i < l; ++i){
            var val = $2f895839ac78ac6c$var$getByKeyPath(obj, keyPath[i]);
            rv.push(val);
        }
        return rv;
    }
    var period = keyPath.indexOf(".");
    if (period !== -1) {
        var innerObj = obj[keyPath.substr(0, period)];
        return innerObj == null ? undefined : $2f895839ac78ac6c$var$getByKeyPath(innerObj, keyPath.substr(period + 1));
    }
    return undefined;
}
function $2f895839ac78ac6c$var$setByKeyPath(obj, keyPath, value) {
    if (!obj || keyPath === undefined) return;
    if ("isFrozen" in Object && Object.isFrozen(obj)) return;
    if (typeof keyPath !== "string" && "length" in keyPath) {
        $2f895839ac78ac6c$var$assert(typeof value !== "string" && "length" in value);
        for(var i = 0, l = keyPath.length; i < l; ++i)$2f895839ac78ac6c$var$setByKeyPath(obj, keyPath[i], value[i]);
    } else {
        var period = keyPath.indexOf(".");
        if (period !== -1) {
            var currentKeyPath = keyPath.substr(0, period);
            var remainingKeyPath = keyPath.substr(period + 1);
            if (remainingKeyPath === "") {
                if (value === undefined) {
                    if ($2f895839ac78ac6c$var$isArray(obj) && !isNaN(parseInt(currentKeyPath))) obj.splice(currentKeyPath, 1);
                    else delete obj[currentKeyPath];
                } else obj[currentKeyPath] = value;
            } else {
                var innerObj = obj[currentKeyPath];
                if (!innerObj || !$2f895839ac78ac6c$var$hasOwn(obj, currentKeyPath)) innerObj = obj[currentKeyPath] = {};
                $2f895839ac78ac6c$var$setByKeyPath(innerObj, remainingKeyPath, value);
            }
        } else if (value === undefined) {
            if ($2f895839ac78ac6c$var$isArray(obj) && !isNaN(parseInt(keyPath))) obj.splice(keyPath, 1);
            else delete obj[keyPath];
        } else obj[keyPath] = value;
    }
}
function $2f895839ac78ac6c$var$delByKeyPath(obj, keyPath) {
    if (typeof keyPath === "string") $2f895839ac78ac6c$var$setByKeyPath(obj, keyPath, undefined);
    else if ("length" in keyPath) [].map.call(keyPath, function(kp) {
        $2f895839ac78ac6c$var$setByKeyPath(obj, kp, undefined);
    });
}
function $2f895839ac78ac6c$var$shallowClone(obj) {
    var rv = {};
    for(var m in obj)if ($2f895839ac78ac6c$var$hasOwn(obj, m)) rv[m] = obj[m];
    return rv;
}
var $2f895839ac78ac6c$var$concat = [].concat;
function $2f895839ac78ac6c$var$flatten(a) {
    return $2f895839ac78ac6c$var$concat.apply([], a);
}
var $2f895839ac78ac6c$var$intrinsicTypeNames = "BigUint64Array,BigInt64Array,Array,Boolean,String,Date,RegExp,Blob,File,FileList,FileSystemFileHandle,FileSystemDirectoryHandle,ArrayBuffer,DataView,Uint8ClampedArray,ImageBitmap,ImageData,Map,Set,CryptoKey".split(",").concat($2f895839ac78ac6c$var$flatten([
    8,
    16,
    32,
    64
].map(function(num) {
    return [
        "Int",
        "Uint",
        "Float"
    ].map(function(t) {
        return t + num + "Array";
    });
}))).filter(function(t) {
    return $2f895839ac78ac6c$var$_global[t];
});
var $2f895839ac78ac6c$var$intrinsicTypes = $2f895839ac78ac6c$var$intrinsicTypeNames.map(function(t) {
    return $2f895839ac78ac6c$var$_global[t];
});
$2f895839ac78ac6c$var$arrayToObject($2f895839ac78ac6c$var$intrinsicTypeNames, function(x) {
    return [
        x,
        true
    ];
});
var $2f895839ac78ac6c$var$circularRefs = null;
function $2f895839ac78ac6c$var$deepClone(any) {
    $2f895839ac78ac6c$var$circularRefs = typeof WeakMap !== "undefined" && new WeakMap();
    var rv = $2f895839ac78ac6c$var$innerDeepClone(any);
    $2f895839ac78ac6c$var$circularRefs = null;
    return rv;
}
function $2f895839ac78ac6c$var$innerDeepClone(any) {
    if (!any || typeof any !== "object") return any;
    var rv = $2f895839ac78ac6c$var$circularRefs && $2f895839ac78ac6c$var$circularRefs.get(any);
    if (rv) return rv;
    if ($2f895839ac78ac6c$var$isArray(any)) {
        rv = [];
        $2f895839ac78ac6c$var$circularRefs && $2f895839ac78ac6c$var$circularRefs.set(any, rv);
        for(var i = 0, l = any.length; i < l; ++i)rv.push($2f895839ac78ac6c$var$innerDeepClone(any[i]));
    } else if ($2f895839ac78ac6c$var$intrinsicTypes.indexOf(any.constructor) >= 0) rv = any;
    else {
        var proto = $2f895839ac78ac6c$var$getProto(any);
        rv = proto === Object.prototype ? {} : Object.create(proto);
        $2f895839ac78ac6c$var$circularRefs && $2f895839ac78ac6c$var$circularRefs.set(any, rv);
        for(var prop in any)if ($2f895839ac78ac6c$var$hasOwn(any, prop)) rv[prop] = $2f895839ac78ac6c$var$innerDeepClone(any[prop]);
    }
    return rv;
}
var $2f895839ac78ac6c$var$toString = {}.toString;
function $2f895839ac78ac6c$var$toStringTag(o) {
    return $2f895839ac78ac6c$var$toString.call(o).slice(8, -1);
}
var $2f895839ac78ac6c$var$iteratorSymbol = typeof Symbol !== "undefined" ? Symbol.iterator : "@@iterator";
var $2f895839ac78ac6c$var$getIteratorOf = typeof $2f895839ac78ac6c$var$iteratorSymbol === "symbol" ? function(x) {
    var i;
    return x != null && (i = x[$2f895839ac78ac6c$var$iteratorSymbol]) && i.apply(x);
} : function() {
    return null;
};
var $2f895839ac78ac6c$var$NO_CHAR_ARRAY = {};
function $2f895839ac78ac6c$var$getArrayOf(arrayLike) {
    var i, a, x, it;
    if (arguments.length === 1) {
        if ($2f895839ac78ac6c$var$isArray(arrayLike)) return arrayLike.slice();
        if (this === $2f895839ac78ac6c$var$NO_CHAR_ARRAY && typeof arrayLike === "string") return [
            arrayLike
        ];
        if (it = $2f895839ac78ac6c$var$getIteratorOf(arrayLike)) {
            a = [];
            while(x = it.next(), !x.done)a.push(x.value);
            return a;
        }
        if (arrayLike == null) return [
            arrayLike
        ];
        i = arrayLike.length;
        if (typeof i === "number") {
            a = new Array(i);
            while(i--)a[i] = arrayLike[i];
            return a;
        }
        return [
            arrayLike
        ];
    }
    i = arguments.length;
    a = new Array(i);
    while(i--)a[i] = arguments[i];
    return a;
}
var $2f895839ac78ac6c$var$isAsyncFunction = typeof Symbol !== "undefined" ? function(fn) {
    return fn[Symbol.toStringTag] === "AsyncFunction";
} : function() {
    return false;
};
var $2f895839ac78ac6c$var$debug = typeof location !== "undefined" && /^(http|https):\/\/(localhost|127\.0\.0\.1)/.test(location.href);
function $2f895839ac78ac6c$var$setDebug(value, filter) {
    $2f895839ac78ac6c$var$debug = value;
    $2f895839ac78ac6c$var$libraryFilter = filter;
}
var $2f895839ac78ac6c$var$libraryFilter = function() {
    return true;
};
var $2f895839ac78ac6c$var$NEEDS_THROW_FOR_STACK = !new Error("").stack;
function $2f895839ac78ac6c$var$getErrorWithStack() {
    if ($2f895839ac78ac6c$var$NEEDS_THROW_FOR_STACK) try {
        $2f895839ac78ac6c$var$getErrorWithStack.arguments;
        throw new Error();
    } catch (e) {
        return e;
    }
    return new Error();
}
function $2f895839ac78ac6c$var$prettyStack(exception, numIgnoredFrames) {
    var stack = exception.stack;
    if (!stack) return "";
    numIgnoredFrames = numIgnoredFrames || 0;
    if (stack.indexOf(exception.name) === 0) numIgnoredFrames += (exception.name + exception.message).split("\n").length;
    return stack.split("\n").slice(numIgnoredFrames).filter($2f895839ac78ac6c$var$libraryFilter).map(function(frame) {
        return "\n" + frame;
    }).join("");
}
var $2f895839ac78ac6c$var$dexieErrorNames = [
    "Modify",
    "Bulk",
    "OpenFailed",
    "VersionChange",
    "Schema",
    "Upgrade",
    "InvalidTable",
    "MissingAPI",
    "NoSuchDatabase",
    "InvalidArgument",
    "SubTransaction",
    "Unsupported",
    "Internal",
    "DatabaseClosed",
    "PrematureCommit",
    "ForeignAwait"
];
var $2f895839ac78ac6c$var$idbDomErrorNames = [
    "Unknown",
    "Constraint",
    "Data",
    "TransactionInactive",
    "ReadOnly",
    "Version",
    "NotFound",
    "InvalidState",
    "InvalidAccess",
    "Abort",
    "Timeout",
    "QuotaExceeded",
    "Syntax",
    "DataClone"
];
var $2f895839ac78ac6c$var$errorList = $2f895839ac78ac6c$var$dexieErrorNames.concat($2f895839ac78ac6c$var$idbDomErrorNames);
var $2f895839ac78ac6c$var$defaultTexts = {
    VersionChanged: "Database version changed by other database connection",
    DatabaseClosed: "Database has been closed",
    Abort: "Transaction aborted",
    TransactionInactive: "Transaction has already completed or failed",
    MissingAPI: "IndexedDB API missing. Please visit https://tinyurl.com/y2uuvskb"
};
function $2f895839ac78ac6c$var$DexieError(name, msg) {
    this._e = $2f895839ac78ac6c$var$getErrorWithStack();
    this.name = name;
    this.message = msg;
}
$2f895839ac78ac6c$var$derive($2f895839ac78ac6c$var$DexieError).from(Error).extend({
    stack: {
        get: function() {
            return this._stack || (this._stack = this.name + ": " + this.message + $2f895839ac78ac6c$var$prettyStack(this._e, 2));
        }
    },
    toString: function() {
        return this.name + ": " + this.message;
    }
});
function $2f895839ac78ac6c$var$getMultiErrorMessage(msg, failures) {
    return msg + ". Errors: " + Object.keys(failures).map(function(key) {
        return failures[key].toString();
    }).filter(function(v, i, s) {
        return s.indexOf(v) === i;
    }).join("\n");
}
function $2f895839ac78ac6c$var$ModifyError(msg, failures, successCount, failedKeys) {
    this._e = $2f895839ac78ac6c$var$getErrorWithStack();
    this.failures = failures;
    this.failedKeys = failedKeys;
    this.successCount = successCount;
    this.message = $2f895839ac78ac6c$var$getMultiErrorMessage(msg, failures);
}
$2f895839ac78ac6c$var$derive($2f895839ac78ac6c$var$ModifyError).from($2f895839ac78ac6c$var$DexieError);
function $2f895839ac78ac6c$var$BulkError(msg, failures) {
    this._e = $2f895839ac78ac6c$var$getErrorWithStack();
    this.name = "BulkError";
    this.failures = Object.keys(failures).map(function(pos) {
        return failures[pos];
    });
    this.failuresByPos = failures;
    this.message = $2f895839ac78ac6c$var$getMultiErrorMessage(msg, failures);
}
$2f895839ac78ac6c$var$derive($2f895839ac78ac6c$var$BulkError).from($2f895839ac78ac6c$var$DexieError);
var $2f895839ac78ac6c$var$errnames = $2f895839ac78ac6c$var$errorList.reduce(function(obj, name) {
    return obj[name] = name + "Error", obj;
}, {});
var $2f895839ac78ac6c$var$BaseException = $2f895839ac78ac6c$var$DexieError;
var $2f895839ac78ac6c$var$exceptions = $2f895839ac78ac6c$var$errorList.reduce(function(obj, name) {
    var fullName = name + "Error";
    function DexieError(msgOrInner, inner) {
        this._e = $2f895839ac78ac6c$var$getErrorWithStack();
        this.name = fullName;
        if (!msgOrInner) {
            this.message = $2f895839ac78ac6c$var$defaultTexts[name] || fullName;
            this.inner = null;
        } else if (typeof msgOrInner === "string") {
            this.message = "" + msgOrInner + (!inner ? "" : "\n " + inner);
            this.inner = inner || null;
        } else if (typeof msgOrInner === "object") {
            this.message = msgOrInner.name + " " + msgOrInner.message;
            this.inner = msgOrInner;
        }
    }
    $2f895839ac78ac6c$var$derive(DexieError).from($2f895839ac78ac6c$var$BaseException);
    obj[name] = DexieError;
    return obj;
}, {});
$2f895839ac78ac6c$var$exceptions.Syntax = SyntaxError;
$2f895839ac78ac6c$var$exceptions.Type = TypeError;
$2f895839ac78ac6c$var$exceptions.Range = RangeError;
var $2f895839ac78ac6c$var$exceptionMap = $2f895839ac78ac6c$var$idbDomErrorNames.reduce(function(obj, name) {
    obj[name + "Error"] = $2f895839ac78ac6c$var$exceptions[name];
    return obj;
}, {});
function $2f895839ac78ac6c$var$mapError(domError, message) {
    if (!domError || domError instanceof $2f895839ac78ac6c$var$DexieError || domError instanceof TypeError || domError instanceof SyntaxError || !domError.name || !$2f895839ac78ac6c$var$exceptionMap[domError.name]) return domError;
    var rv = new $2f895839ac78ac6c$var$exceptionMap[domError.name](message || domError.message, domError);
    if ("stack" in domError) $2f895839ac78ac6c$var$setProp(rv, "stack", {
        get: function() {
            return this.inner.stack;
        }
    });
    return rv;
}
var $2f895839ac78ac6c$var$fullNameExceptions = $2f895839ac78ac6c$var$errorList.reduce(function(obj, name) {
    if ([
        "Syntax",
        "Type",
        "Range"
    ].indexOf(name) === -1) obj[name + "Error"] = $2f895839ac78ac6c$var$exceptions[name];
    return obj;
}, {});
$2f895839ac78ac6c$var$fullNameExceptions.ModifyError = $2f895839ac78ac6c$var$ModifyError;
$2f895839ac78ac6c$var$fullNameExceptions.DexieError = $2f895839ac78ac6c$var$DexieError;
$2f895839ac78ac6c$var$fullNameExceptions.BulkError = $2f895839ac78ac6c$var$BulkError;
function $2f895839ac78ac6c$var$nop() {}
function $2f895839ac78ac6c$var$mirror(val) {
    return val;
}
function $2f895839ac78ac6c$var$pureFunctionChain(f1, f2) {
    if (f1 == null || f1 === $2f895839ac78ac6c$var$mirror) return f2;
    return function(val) {
        return f2(f1(val));
    };
}
function $2f895839ac78ac6c$var$callBoth(on1, on2) {
    return function() {
        on1.apply(this, arguments);
        on2.apply(this, arguments);
    };
}
function $2f895839ac78ac6c$var$hookCreatingChain(f1, f2) {
    if (f1 === $2f895839ac78ac6c$var$nop) return f2;
    return function() {
        var res = f1.apply(this, arguments);
        if (res !== undefined) arguments[0] = res;
        var onsuccess = this.onsuccess, onerror = this.onerror;
        this.onsuccess = null;
        this.onerror = null;
        var res2 = f2.apply(this, arguments);
        if (onsuccess) this.onsuccess = this.onsuccess ? $2f895839ac78ac6c$var$callBoth(onsuccess, this.onsuccess) : onsuccess;
        if (onerror) this.onerror = this.onerror ? $2f895839ac78ac6c$var$callBoth(onerror, this.onerror) : onerror;
        return res2 !== undefined ? res2 : res;
    };
}
function $2f895839ac78ac6c$var$hookDeletingChain(f1, f2) {
    if (f1 === $2f895839ac78ac6c$var$nop) return f2;
    return function() {
        f1.apply(this, arguments);
        var onsuccess = this.onsuccess, onerror = this.onerror;
        this.onsuccess = this.onerror = null;
        f2.apply(this, arguments);
        if (onsuccess) this.onsuccess = this.onsuccess ? $2f895839ac78ac6c$var$callBoth(onsuccess, this.onsuccess) : onsuccess;
        if (onerror) this.onerror = this.onerror ? $2f895839ac78ac6c$var$callBoth(onerror, this.onerror) : onerror;
    };
}
function $2f895839ac78ac6c$var$hookUpdatingChain(f1, f2) {
    if (f1 === $2f895839ac78ac6c$var$nop) return f2;
    return function(modifications) {
        var res = f1.apply(this, arguments);
        $2f895839ac78ac6c$var$extend(modifications, res);
        var onsuccess = this.onsuccess, onerror = this.onerror;
        this.onsuccess = null;
        this.onerror = null;
        var res2 = f2.apply(this, arguments);
        if (onsuccess) this.onsuccess = this.onsuccess ? $2f895839ac78ac6c$var$callBoth(onsuccess, this.onsuccess) : onsuccess;
        if (onerror) this.onerror = this.onerror ? $2f895839ac78ac6c$var$callBoth(onerror, this.onerror) : onerror;
        return res === undefined ? res2 === undefined ? undefined : res2 : $2f895839ac78ac6c$var$extend(res, res2);
    };
}
function $2f895839ac78ac6c$var$reverseStoppableEventChain(f1, f2) {
    if (f1 === $2f895839ac78ac6c$var$nop) return f2;
    return function() {
        if (f2.apply(this, arguments) === false) return false;
        return f1.apply(this, arguments);
    };
}
function $2f895839ac78ac6c$var$promisableChain(f1, f2) {
    if (f1 === $2f895839ac78ac6c$var$nop) return f2;
    return function() {
        var res = f1.apply(this, arguments);
        if (res && typeof res.then === "function") {
            var thiz = this, i = arguments.length, args = new Array(i);
            while(i--)args[i] = arguments[i];
            return res.then(function() {
                return f2.apply(thiz, args);
            });
        }
        return f2.apply(this, arguments);
    };
}
var $2f895839ac78ac6c$var$INTERNAL = {};
var $2f895839ac78ac6c$var$LONG_STACKS_CLIP_LIMIT = 100, $2f895839ac78ac6c$var$MAX_LONG_STACKS = 20, $2f895839ac78ac6c$var$ZONE_ECHO_LIMIT = 100, $2f895839ac78ac6c$var$_a$1 = typeof Promise === "undefined" ? [] : function() {
    var globalP = Promise.resolve();
    if (typeof crypto === "undefined" || !crypto.subtle) return [
        globalP,
        $2f895839ac78ac6c$var$getProto(globalP),
        globalP
    ];
    var nativeP = crypto.subtle.digest("SHA-512", new Uint8Array([
        0
    ]));
    return [
        nativeP,
        $2f895839ac78ac6c$var$getProto(nativeP),
        globalP
    ];
}(), $2f895839ac78ac6c$var$resolvedNativePromise = $2f895839ac78ac6c$var$_a$1[0], $2f895839ac78ac6c$var$nativePromiseProto = $2f895839ac78ac6c$var$_a$1[1], $2f895839ac78ac6c$var$resolvedGlobalPromise = $2f895839ac78ac6c$var$_a$1[2], $2f895839ac78ac6c$var$nativePromiseThen = $2f895839ac78ac6c$var$nativePromiseProto && $2f895839ac78ac6c$var$nativePromiseProto.then;
var $2f895839ac78ac6c$var$NativePromise = $2f895839ac78ac6c$var$resolvedNativePromise && $2f895839ac78ac6c$var$resolvedNativePromise.constructor;
var $2f895839ac78ac6c$var$patchGlobalPromise = !!$2f895839ac78ac6c$var$resolvedGlobalPromise;
var $2f895839ac78ac6c$var$stack_being_generated = false;
var $2f895839ac78ac6c$var$schedulePhysicalTick = $2f895839ac78ac6c$var$resolvedGlobalPromise ? function() {
    $2f895839ac78ac6c$var$resolvedGlobalPromise.then($2f895839ac78ac6c$var$physicalTick);
} : $2f895839ac78ac6c$var$_global.setImmediate ? setImmediate.bind(null, $2f895839ac78ac6c$var$physicalTick) : $2f895839ac78ac6c$var$_global.MutationObserver ? function() {
    var hiddenDiv = document.createElement("div");
    new MutationObserver(function() {
        $2f895839ac78ac6c$var$physicalTick();
        hiddenDiv = null;
    }).observe(hiddenDiv, {
        attributes: true
    });
    hiddenDiv.setAttribute("i", "1");
} : function() {
    setTimeout($2f895839ac78ac6c$var$physicalTick, 0);
};
var $2f895839ac78ac6c$var$asap = function(callback, args) {
    $2f895839ac78ac6c$var$microtickQueue.push([
        callback,
        args
    ]);
    if ($2f895839ac78ac6c$var$needsNewPhysicalTick) {
        $2f895839ac78ac6c$var$schedulePhysicalTick();
        $2f895839ac78ac6c$var$needsNewPhysicalTick = false;
    }
};
var $2f895839ac78ac6c$var$isOutsideMicroTick = true, $2f895839ac78ac6c$var$needsNewPhysicalTick = true, $2f895839ac78ac6c$var$unhandledErrors = [], $2f895839ac78ac6c$var$rejectingErrors = [], $2f895839ac78ac6c$var$currentFulfiller = null, $2f895839ac78ac6c$var$rejectionMapper = $2f895839ac78ac6c$var$mirror;
var $2f895839ac78ac6c$var$globalPSD = {
    id: "global",
    global: true,
    ref: 0,
    unhandleds: [],
    onunhandled: $2f895839ac78ac6c$var$globalError,
    pgp: false,
    env: {},
    finalize: function() {
        this.unhandleds.forEach(function(uh) {
            try {
                $2f895839ac78ac6c$var$globalError(uh[0], uh[1]);
            } catch (e) {}
        });
    }
};
var $2f895839ac78ac6c$var$PSD = $2f895839ac78ac6c$var$globalPSD;
var $2f895839ac78ac6c$var$microtickQueue = [];
var $2f895839ac78ac6c$var$numScheduledCalls = 0;
var $2f895839ac78ac6c$var$tickFinalizers = [];
function $2f895839ac78ac6c$var$DexiePromise(fn) {
    if (typeof this !== "object") throw new TypeError("Promises must be constructed via new");
    this._listeners = [];
    this.onuncatched = $2f895839ac78ac6c$var$nop;
    this._lib = false;
    var psd = this._PSD = $2f895839ac78ac6c$var$PSD;
    if ($2f895839ac78ac6c$var$debug) {
        this._stackHolder = $2f895839ac78ac6c$var$getErrorWithStack();
        this._prev = null;
        this._numPrev = 0;
    }
    if (typeof fn !== "function") {
        if (fn !== $2f895839ac78ac6c$var$INTERNAL) throw new TypeError("Not a function");
        this._state = arguments[1];
        this._value = arguments[2];
        if (this._state === false) $2f895839ac78ac6c$var$handleRejection(this, this._value);
        return;
    }
    this._state = null;
    this._value = null;
    ++psd.ref;
    $2f895839ac78ac6c$var$executePromiseTask(this, fn);
}
var $2f895839ac78ac6c$var$thenProp = {
    get: function() {
        var psd = $2f895839ac78ac6c$var$PSD, microTaskId = $2f895839ac78ac6c$var$totalEchoes;
        function then(onFulfilled, onRejected) {
            var _this = this;
            var possibleAwait = !psd.global && (psd !== $2f895839ac78ac6c$var$PSD || microTaskId !== $2f895839ac78ac6c$var$totalEchoes);
            var cleanup = possibleAwait && !$2f895839ac78ac6c$var$decrementExpectedAwaits();
            var rv = new $2f895839ac78ac6c$var$DexiePromise(function(resolve, reject) {
                $2f895839ac78ac6c$var$propagateToListener(_this, new $2f895839ac78ac6c$var$Listener($2f895839ac78ac6c$var$nativeAwaitCompatibleWrap(onFulfilled, psd, possibleAwait, cleanup), $2f895839ac78ac6c$var$nativeAwaitCompatibleWrap(onRejected, psd, possibleAwait, cleanup), resolve, reject, psd));
            });
            $2f895839ac78ac6c$var$debug && $2f895839ac78ac6c$var$linkToPreviousPromise(rv, this);
            return rv;
        }
        then.prototype = $2f895839ac78ac6c$var$INTERNAL;
        return then;
    },
    set: function(value) {
        $2f895839ac78ac6c$var$setProp(this, "then", value && value.prototype === $2f895839ac78ac6c$var$INTERNAL ? $2f895839ac78ac6c$var$thenProp : {
            get: function() {
                return value;
            },
            set: $2f895839ac78ac6c$var$thenProp.set
        });
    }
};
$2f895839ac78ac6c$var$props($2f895839ac78ac6c$var$DexiePromise.prototype, {
    then: $2f895839ac78ac6c$var$thenProp,
    _then: function(onFulfilled, onRejected) {
        $2f895839ac78ac6c$var$propagateToListener(this, new $2f895839ac78ac6c$var$Listener(null, null, onFulfilled, onRejected, $2f895839ac78ac6c$var$PSD));
    },
    catch: function(onRejected) {
        if (arguments.length === 1) return this.then(null, onRejected);
        var type = arguments[0], handler = arguments[1];
        return typeof type === "function" ? this.then(null, function(err) {
            return err instanceof type ? handler(err) : $2f895839ac78ac6c$var$PromiseReject(err);
        }) : this.then(null, function(err) {
            return err && err.name === type ? handler(err) : $2f895839ac78ac6c$var$PromiseReject(err);
        });
    },
    finally: function(onFinally) {
        return this.then(function(value) {
            onFinally();
            return value;
        }, function(err) {
            onFinally();
            return $2f895839ac78ac6c$var$PromiseReject(err);
        });
    },
    stack: {
        get: function() {
            if (this._stack) return this._stack;
            try {
                $2f895839ac78ac6c$var$stack_being_generated = true;
                var stacks = $2f895839ac78ac6c$var$getStack(this, [], $2f895839ac78ac6c$var$MAX_LONG_STACKS);
                var stack = stacks.join("\nFrom previous: ");
                if (this._state !== null) this._stack = stack;
                return stack;
            } finally{
                $2f895839ac78ac6c$var$stack_being_generated = false;
            }
        }
    },
    timeout: function(ms, msg) {
        var _this = this;
        return ms < Infinity ? new $2f895839ac78ac6c$var$DexiePromise(function(resolve, reject) {
            var handle = setTimeout(function() {
                return reject(new $2f895839ac78ac6c$var$exceptions.Timeout(msg));
            }, ms);
            _this.then(resolve, reject).finally(clearTimeout.bind(null, handle));
        }) : this;
    }
});
if (typeof Symbol !== "undefined" && Symbol.toStringTag) $2f895839ac78ac6c$var$setProp($2f895839ac78ac6c$var$DexiePromise.prototype, Symbol.toStringTag, "Dexie.Promise");
$2f895839ac78ac6c$var$globalPSD.env = $2f895839ac78ac6c$var$snapShot();
function $2f895839ac78ac6c$var$Listener(onFulfilled, onRejected, resolve, reject, zone) {
    this.onFulfilled = typeof onFulfilled === "function" ? onFulfilled : null;
    this.onRejected = typeof onRejected === "function" ? onRejected : null;
    this.resolve = resolve;
    this.reject = reject;
    this.psd = zone;
}
$2f895839ac78ac6c$var$props($2f895839ac78ac6c$var$DexiePromise, {
    all: function() {
        var values = $2f895839ac78ac6c$var$getArrayOf.apply(null, arguments).map($2f895839ac78ac6c$var$onPossibleParallellAsync);
        return new $2f895839ac78ac6c$var$DexiePromise(function(resolve, reject) {
            if (values.length === 0) resolve([]);
            var remaining = values.length;
            values.forEach(function(a, i) {
                return $2f895839ac78ac6c$var$DexiePromise.resolve(a).then(function(x) {
                    values[i] = x;
                    if (!--remaining) resolve(values);
                }, reject);
            });
        });
    },
    resolve: function(value) {
        if (value instanceof $2f895839ac78ac6c$var$DexiePromise) return value;
        if (value && typeof value.then === "function") return new $2f895839ac78ac6c$var$DexiePromise(function(resolve, reject) {
            value.then(resolve, reject);
        });
        var rv = new $2f895839ac78ac6c$var$DexiePromise($2f895839ac78ac6c$var$INTERNAL, true, value);
        $2f895839ac78ac6c$var$linkToPreviousPromise(rv, $2f895839ac78ac6c$var$currentFulfiller);
        return rv;
    },
    reject: $2f895839ac78ac6c$var$PromiseReject,
    race: function() {
        var values = $2f895839ac78ac6c$var$getArrayOf.apply(null, arguments).map($2f895839ac78ac6c$var$onPossibleParallellAsync);
        return new $2f895839ac78ac6c$var$DexiePromise(function(resolve, reject) {
            values.map(function(value) {
                return $2f895839ac78ac6c$var$DexiePromise.resolve(value).then(resolve, reject);
            });
        });
    },
    PSD: {
        get: function() {
            return $2f895839ac78ac6c$var$PSD;
        },
        set: function(value) {
            return $2f895839ac78ac6c$var$PSD = value;
        }
    },
    totalEchoes: {
        get: function() {
            return $2f895839ac78ac6c$var$totalEchoes;
        }
    },
    newPSD: $2f895839ac78ac6c$var$newScope,
    usePSD: $2f895839ac78ac6c$var$usePSD,
    scheduler: {
        get: function() {
            return $2f895839ac78ac6c$var$asap;
        },
        set: function(value) {
            $2f895839ac78ac6c$var$asap = value;
        }
    },
    rejectionMapper: {
        get: function() {
            return $2f895839ac78ac6c$var$rejectionMapper;
        },
        set: function(value) {
            $2f895839ac78ac6c$var$rejectionMapper = value;
        }
    },
    follow: function(fn, zoneProps) {
        return new $2f895839ac78ac6c$var$DexiePromise(function(resolve, reject) {
            return $2f895839ac78ac6c$var$newScope(function(resolve, reject) {
                var psd = $2f895839ac78ac6c$var$PSD;
                psd.unhandleds = [];
                psd.onunhandled = reject;
                psd.finalize = $2f895839ac78ac6c$var$callBoth(function() {
                    var _this = this;
                    $2f895839ac78ac6c$var$run_at_end_of_this_or_next_physical_tick(function() {
                        _this.unhandleds.length === 0 ? resolve() : reject(_this.unhandleds[0]);
                    });
                }, psd.finalize);
                fn();
            }, zoneProps, resolve, reject);
        });
    }
});
if ($2f895839ac78ac6c$var$NativePromise) {
    if ($2f895839ac78ac6c$var$NativePromise.allSettled) $2f895839ac78ac6c$var$setProp($2f895839ac78ac6c$var$DexiePromise, "allSettled", function() {
        var possiblePromises = $2f895839ac78ac6c$var$getArrayOf.apply(null, arguments).map($2f895839ac78ac6c$var$onPossibleParallellAsync);
        return new $2f895839ac78ac6c$var$DexiePromise(function(resolve) {
            if (possiblePromises.length === 0) resolve([]);
            var remaining = possiblePromises.length;
            var results = new Array(remaining);
            possiblePromises.forEach(function(p, i) {
                return $2f895839ac78ac6c$var$DexiePromise.resolve(p).then(function(value) {
                    return results[i] = {
                        status: "fulfilled",
                        value: value
                    };
                }, function(reason) {
                    return results[i] = {
                        status: "rejected",
                        reason: reason
                    };
                }).then(function() {
                    return --remaining || resolve(results);
                });
            });
        });
    });
    if ($2f895839ac78ac6c$var$NativePromise.any && typeof AggregateError !== "undefined") $2f895839ac78ac6c$var$setProp($2f895839ac78ac6c$var$DexiePromise, "any", function() {
        var possiblePromises = $2f895839ac78ac6c$var$getArrayOf.apply(null, arguments).map($2f895839ac78ac6c$var$onPossibleParallellAsync);
        return new $2f895839ac78ac6c$var$DexiePromise(function(resolve, reject) {
            if (possiblePromises.length === 0) reject(new AggregateError([]));
            var remaining = possiblePromises.length;
            var failures = new Array(remaining);
            possiblePromises.forEach(function(p, i) {
                return $2f895839ac78ac6c$var$DexiePromise.resolve(p).then(function(value) {
                    return resolve(value);
                }, function(failure) {
                    failures[i] = failure;
                    if (!--remaining) reject(new AggregateError(failures));
                });
            });
        });
    });
}
function $2f895839ac78ac6c$var$executePromiseTask(promise, fn) {
    try {
        fn(function(value) {
            if (promise._state !== null) return;
            if (value === promise) throw new TypeError("A promise cannot be resolved with itself.");
            var shouldExecuteTick = promise._lib && $2f895839ac78ac6c$var$beginMicroTickScope();
            if (value && typeof value.then === "function") $2f895839ac78ac6c$var$executePromiseTask(promise, function(resolve, reject) {
                value instanceof $2f895839ac78ac6c$var$DexiePromise ? value._then(resolve, reject) : value.then(resolve, reject);
            });
            else {
                promise._state = true;
                promise._value = value;
                $2f895839ac78ac6c$var$propagateAllListeners(promise);
            }
            if (shouldExecuteTick) $2f895839ac78ac6c$var$endMicroTickScope();
        }, $2f895839ac78ac6c$var$handleRejection.bind(null, promise));
    } catch (ex) {
        $2f895839ac78ac6c$var$handleRejection(promise, ex);
    }
}
function $2f895839ac78ac6c$var$handleRejection(promise, reason) {
    $2f895839ac78ac6c$var$rejectingErrors.push(reason);
    if (promise._state !== null) return;
    var shouldExecuteTick = promise._lib && $2f895839ac78ac6c$var$beginMicroTickScope();
    reason = $2f895839ac78ac6c$var$rejectionMapper(reason);
    promise._state = false;
    promise._value = reason;
    $2f895839ac78ac6c$var$debug && reason !== null && typeof reason === "object" && !reason._promise && $2f895839ac78ac6c$var$tryCatch(function() {
        var origProp = $2f895839ac78ac6c$var$getPropertyDescriptor(reason, "stack");
        reason._promise = promise;
        $2f895839ac78ac6c$var$setProp(reason, "stack", {
            get: function() {
                return $2f895839ac78ac6c$var$stack_being_generated ? origProp && (origProp.get ? origProp.get.apply(reason) : origProp.value) : promise.stack;
            }
        });
    });
    $2f895839ac78ac6c$var$addPossiblyUnhandledError(promise);
    $2f895839ac78ac6c$var$propagateAllListeners(promise);
    if (shouldExecuteTick) $2f895839ac78ac6c$var$endMicroTickScope();
}
function $2f895839ac78ac6c$var$propagateAllListeners(promise) {
    var listeners = promise._listeners;
    promise._listeners = [];
    for(var i = 0, len = listeners.length; i < len; ++i)$2f895839ac78ac6c$var$propagateToListener(promise, listeners[i]);
    var psd = promise._PSD;
    --psd.ref || psd.finalize();
    if ($2f895839ac78ac6c$var$numScheduledCalls === 0) {
        ++$2f895839ac78ac6c$var$numScheduledCalls;
        $2f895839ac78ac6c$var$asap(function() {
            if (--$2f895839ac78ac6c$var$numScheduledCalls === 0) $2f895839ac78ac6c$var$finalizePhysicalTick();
        }, []);
    }
}
function $2f895839ac78ac6c$var$propagateToListener(promise, listener) {
    if (promise._state === null) {
        promise._listeners.push(listener);
        return;
    }
    var cb = promise._state ? listener.onFulfilled : listener.onRejected;
    if (cb === null) return (promise._state ? listener.resolve : listener.reject)(promise._value);
    ++listener.psd.ref;
    ++$2f895839ac78ac6c$var$numScheduledCalls;
    $2f895839ac78ac6c$var$asap($2f895839ac78ac6c$var$callListener, [
        cb,
        promise,
        listener
    ]);
}
function $2f895839ac78ac6c$var$callListener(cb, promise, listener) {
    try {
        $2f895839ac78ac6c$var$currentFulfiller = promise;
        var ret, value = promise._value;
        if (promise._state) ret = cb(value);
        else {
            if ($2f895839ac78ac6c$var$rejectingErrors.length) $2f895839ac78ac6c$var$rejectingErrors = [];
            ret = cb(value);
            if ($2f895839ac78ac6c$var$rejectingErrors.indexOf(value) === -1) $2f895839ac78ac6c$var$markErrorAsHandled(promise);
        }
        listener.resolve(ret);
    } catch (e) {
        listener.reject(e);
    } finally{
        $2f895839ac78ac6c$var$currentFulfiller = null;
        if (--$2f895839ac78ac6c$var$numScheduledCalls === 0) $2f895839ac78ac6c$var$finalizePhysicalTick();
        --listener.psd.ref || listener.psd.finalize();
    }
}
function $2f895839ac78ac6c$var$getStack(promise, stacks, limit) {
    if (stacks.length === limit) return stacks;
    var stack = "";
    if (promise._state === false) {
        var failure = promise._value, errorName, message;
        if (failure != null) {
            errorName = failure.name || "Error";
            message = failure.message || failure;
            stack = $2f895839ac78ac6c$var$prettyStack(failure, 0);
        } else {
            errorName = failure;
            message = "";
        }
        stacks.push(errorName + (message ? ": " + message : "") + stack);
    }
    if ($2f895839ac78ac6c$var$debug) {
        stack = $2f895839ac78ac6c$var$prettyStack(promise._stackHolder, 2);
        if (stack && stacks.indexOf(stack) === -1) stacks.push(stack);
        if (promise._prev) $2f895839ac78ac6c$var$getStack(promise._prev, stacks, limit);
    }
    return stacks;
}
function $2f895839ac78ac6c$var$linkToPreviousPromise(promise, prev) {
    var numPrev = prev ? prev._numPrev + 1 : 0;
    if (numPrev < $2f895839ac78ac6c$var$LONG_STACKS_CLIP_LIMIT) {
        promise._prev = prev;
        promise._numPrev = numPrev;
    }
}
function $2f895839ac78ac6c$var$physicalTick() {
    $2f895839ac78ac6c$var$beginMicroTickScope() && $2f895839ac78ac6c$var$endMicroTickScope();
}
function $2f895839ac78ac6c$var$beginMicroTickScope() {
    var wasRootExec = $2f895839ac78ac6c$var$isOutsideMicroTick;
    $2f895839ac78ac6c$var$isOutsideMicroTick = false;
    $2f895839ac78ac6c$var$needsNewPhysicalTick = false;
    return wasRootExec;
}
function $2f895839ac78ac6c$var$endMicroTickScope() {
    var callbacks, i, l;
    do while($2f895839ac78ac6c$var$microtickQueue.length > 0){
        callbacks = $2f895839ac78ac6c$var$microtickQueue;
        $2f895839ac78ac6c$var$microtickQueue = [];
        l = callbacks.length;
        for(i = 0; i < l; ++i){
            var item = callbacks[i];
            item[0].apply(null, item[1]);
        }
    }
    while ($2f895839ac78ac6c$var$microtickQueue.length > 0);
    $2f895839ac78ac6c$var$isOutsideMicroTick = true;
    $2f895839ac78ac6c$var$needsNewPhysicalTick = true;
}
function $2f895839ac78ac6c$var$finalizePhysicalTick() {
    var unhandledErrs = $2f895839ac78ac6c$var$unhandledErrors;
    $2f895839ac78ac6c$var$unhandledErrors = [];
    unhandledErrs.forEach(function(p) {
        p._PSD.onunhandled.call(null, p._value, p);
    });
    var finalizers = $2f895839ac78ac6c$var$tickFinalizers.slice(0);
    var i = finalizers.length;
    while(i)finalizers[--i]();
}
function $2f895839ac78ac6c$var$run_at_end_of_this_or_next_physical_tick(fn) {
    function finalizer() {
        fn();
        $2f895839ac78ac6c$var$tickFinalizers.splice($2f895839ac78ac6c$var$tickFinalizers.indexOf(finalizer), 1);
    }
    $2f895839ac78ac6c$var$tickFinalizers.push(finalizer);
    ++$2f895839ac78ac6c$var$numScheduledCalls;
    $2f895839ac78ac6c$var$asap(function() {
        if (--$2f895839ac78ac6c$var$numScheduledCalls === 0) $2f895839ac78ac6c$var$finalizePhysicalTick();
    }, []);
}
function $2f895839ac78ac6c$var$addPossiblyUnhandledError(promise) {
    if (!$2f895839ac78ac6c$var$unhandledErrors.some(function(p) {
        return p._value === promise._value;
    })) $2f895839ac78ac6c$var$unhandledErrors.push(promise);
}
function $2f895839ac78ac6c$var$markErrorAsHandled(promise) {
    var i = $2f895839ac78ac6c$var$unhandledErrors.length;
    while(i)if ($2f895839ac78ac6c$var$unhandledErrors[--i]._value === promise._value) {
        $2f895839ac78ac6c$var$unhandledErrors.splice(i, 1);
        return;
    }
}
function $2f895839ac78ac6c$var$PromiseReject(reason) {
    return new $2f895839ac78ac6c$var$DexiePromise($2f895839ac78ac6c$var$INTERNAL, false, reason);
}
function $2f895839ac78ac6c$var$wrap(fn, errorCatcher) {
    var psd = $2f895839ac78ac6c$var$PSD;
    return function() {
        var wasRootExec = $2f895839ac78ac6c$var$beginMicroTickScope(), outerScope = $2f895839ac78ac6c$var$PSD;
        try {
            $2f895839ac78ac6c$var$switchToZone(psd, true);
            return fn.apply(this, arguments);
        } catch (e) {
            errorCatcher && errorCatcher(e);
        } finally{
            $2f895839ac78ac6c$var$switchToZone(outerScope, false);
            if (wasRootExec) $2f895839ac78ac6c$var$endMicroTickScope();
        }
    };
}
var $2f895839ac78ac6c$var$task = {
    awaits: 0,
    echoes: 0,
    id: 0
};
var $2f895839ac78ac6c$var$taskCounter = 0;
var $2f895839ac78ac6c$var$zoneStack = [];
var $2f895839ac78ac6c$var$zoneEchoes = 0;
var $2f895839ac78ac6c$var$totalEchoes = 0;
var $2f895839ac78ac6c$var$zone_id_counter = 0;
function $2f895839ac78ac6c$var$newScope(fn, props, a1, a2) {
    var parent = $2f895839ac78ac6c$var$PSD, psd = Object.create(parent);
    psd.parent = parent;
    psd.ref = 0;
    psd.global = false;
    psd.id = ++$2f895839ac78ac6c$var$zone_id_counter;
    var globalEnv = $2f895839ac78ac6c$var$globalPSD.env;
    psd.env = $2f895839ac78ac6c$var$patchGlobalPromise ? {
        Promise: $2f895839ac78ac6c$var$DexiePromise,
        PromiseProp: {
            value: $2f895839ac78ac6c$var$DexiePromise,
            configurable: true,
            writable: true
        },
        all: $2f895839ac78ac6c$var$DexiePromise.all,
        race: $2f895839ac78ac6c$var$DexiePromise.race,
        allSettled: $2f895839ac78ac6c$var$DexiePromise.allSettled,
        any: $2f895839ac78ac6c$var$DexiePromise.any,
        resolve: $2f895839ac78ac6c$var$DexiePromise.resolve,
        reject: $2f895839ac78ac6c$var$DexiePromise.reject,
        nthen: $2f895839ac78ac6c$var$getPatchedPromiseThen(globalEnv.nthen, psd),
        gthen: $2f895839ac78ac6c$var$getPatchedPromiseThen(globalEnv.gthen, psd)
    } : {};
    if (props) $2f895839ac78ac6c$var$extend(psd, props);
    ++parent.ref;
    psd.finalize = function() {
        --this.parent.ref || this.parent.finalize();
    };
    var rv = $2f895839ac78ac6c$var$usePSD(psd, fn, a1, a2);
    if (psd.ref === 0) psd.finalize();
    return rv;
}
function $2f895839ac78ac6c$var$incrementExpectedAwaits() {
    if (!$2f895839ac78ac6c$var$task.id) $2f895839ac78ac6c$var$task.id = ++$2f895839ac78ac6c$var$taskCounter;
    ++$2f895839ac78ac6c$var$task.awaits;
    $2f895839ac78ac6c$var$task.echoes += $2f895839ac78ac6c$var$ZONE_ECHO_LIMIT;
    return $2f895839ac78ac6c$var$task.id;
}
function $2f895839ac78ac6c$var$decrementExpectedAwaits() {
    if (!$2f895839ac78ac6c$var$task.awaits) return false;
    if (--$2f895839ac78ac6c$var$task.awaits === 0) $2f895839ac78ac6c$var$task.id = 0;
    $2f895839ac78ac6c$var$task.echoes = $2f895839ac78ac6c$var$task.awaits * $2f895839ac78ac6c$var$ZONE_ECHO_LIMIT;
    return true;
}
if (("" + $2f895839ac78ac6c$var$nativePromiseThen).indexOf("[native code]") === -1) $2f895839ac78ac6c$var$incrementExpectedAwaits = $2f895839ac78ac6c$var$decrementExpectedAwaits = $2f895839ac78ac6c$var$nop;
function $2f895839ac78ac6c$var$onPossibleParallellAsync(possiblePromise) {
    if ($2f895839ac78ac6c$var$task.echoes && possiblePromise && possiblePromise.constructor === $2f895839ac78ac6c$var$NativePromise) {
        $2f895839ac78ac6c$var$incrementExpectedAwaits();
        return possiblePromise.then(function(x) {
            $2f895839ac78ac6c$var$decrementExpectedAwaits();
            return x;
        }, function(e) {
            $2f895839ac78ac6c$var$decrementExpectedAwaits();
            return $2f895839ac78ac6c$var$rejection(e);
        });
    }
    return possiblePromise;
}
function $2f895839ac78ac6c$var$zoneEnterEcho(targetZone) {
    ++$2f895839ac78ac6c$var$totalEchoes;
    if (!$2f895839ac78ac6c$var$task.echoes || --$2f895839ac78ac6c$var$task.echoes === 0) $2f895839ac78ac6c$var$task.echoes = $2f895839ac78ac6c$var$task.id = 0;
    $2f895839ac78ac6c$var$zoneStack.push($2f895839ac78ac6c$var$PSD);
    $2f895839ac78ac6c$var$switchToZone(targetZone, true);
}
function $2f895839ac78ac6c$var$zoneLeaveEcho() {
    var zone = $2f895839ac78ac6c$var$zoneStack[$2f895839ac78ac6c$var$zoneStack.length - 1];
    $2f895839ac78ac6c$var$zoneStack.pop();
    $2f895839ac78ac6c$var$switchToZone(zone, false);
}
function $2f895839ac78ac6c$var$switchToZone(targetZone, bEnteringZone) {
    var currentZone = $2f895839ac78ac6c$var$PSD;
    if (bEnteringZone ? $2f895839ac78ac6c$var$task.echoes && (!$2f895839ac78ac6c$var$zoneEchoes++ || targetZone !== $2f895839ac78ac6c$var$PSD) : $2f895839ac78ac6c$var$zoneEchoes && (!--$2f895839ac78ac6c$var$zoneEchoes || targetZone !== $2f895839ac78ac6c$var$PSD)) $2f895839ac78ac6c$var$enqueueNativeMicroTask(bEnteringZone ? $2f895839ac78ac6c$var$zoneEnterEcho.bind(null, targetZone) : $2f895839ac78ac6c$var$zoneLeaveEcho);
    if (targetZone === $2f895839ac78ac6c$var$PSD) return;
    $2f895839ac78ac6c$var$PSD = targetZone;
    if (currentZone === $2f895839ac78ac6c$var$globalPSD) $2f895839ac78ac6c$var$globalPSD.env = $2f895839ac78ac6c$var$snapShot();
    if ($2f895839ac78ac6c$var$patchGlobalPromise) {
        var GlobalPromise_1 = $2f895839ac78ac6c$var$globalPSD.env.Promise;
        var targetEnv = targetZone.env;
        $2f895839ac78ac6c$var$nativePromiseProto.then = targetEnv.nthen;
        GlobalPromise_1.prototype.then = targetEnv.gthen;
        if (currentZone.global || targetZone.global) {
            Object.defineProperty($2f895839ac78ac6c$var$_global, "Promise", targetEnv.PromiseProp);
            GlobalPromise_1.all = targetEnv.all;
            GlobalPromise_1.race = targetEnv.race;
            GlobalPromise_1.resolve = targetEnv.resolve;
            GlobalPromise_1.reject = targetEnv.reject;
            if (targetEnv.allSettled) GlobalPromise_1.allSettled = targetEnv.allSettled;
            if (targetEnv.any) GlobalPromise_1.any = targetEnv.any;
        }
    }
}
function $2f895839ac78ac6c$var$snapShot() {
    var GlobalPromise = $2f895839ac78ac6c$var$_global.Promise;
    return $2f895839ac78ac6c$var$patchGlobalPromise ? {
        Promise: GlobalPromise,
        PromiseProp: Object.getOwnPropertyDescriptor($2f895839ac78ac6c$var$_global, "Promise"),
        all: GlobalPromise.all,
        race: GlobalPromise.race,
        allSettled: GlobalPromise.allSettled,
        any: GlobalPromise.any,
        resolve: GlobalPromise.resolve,
        reject: GlobalPromise.reject,
        nthen: $2f895839ac78ac6c$var$nativePromiseProto.then,
        gthen: GlobalPromise.prototype.then
    } : {};
}
function $2f895839ac78ac6c$var$usePSD(psd, fn, a1, a2, a3) {
    var outerScope = $2f895839ac78ac6c$var$PSD;
    try {
        $2f895839ac78ac6c$var$switchToZone(psd, true);
        return fn(a1, a2, a3);
    } finally{
        $2f895839ac78ac6c$var$switchToZone(outerScope, false);
    }
}
function $2f895839ac78ac6c$var$enqueueNativeMicroTask(job) {
    $2f895839ac78ac6c$var$nativePromiseThen.call($2f895839ac78ac6c$var$resolvedNativePromise, job);
}
function $2f895839ac78ac6c$var$nativeAwaitCompatibleWrap(fn, zone, possibleAwait, cleanup) {
    return typeof fn !== "function" ? fn : function() {
        var outerZone = $2f895839ac78ac6c$var$PSD;
        if (possibleAwait) $2f895839ac78ac6c$var$incrementExpectedAwaits();
        $2f895839ac78ac6c$var$switchToZone(zone, true);
        try {
            return fn.apply(this, arguments);
        } finally{
            $2f895839ac78ac6c$var$switchToZone(outerZone, false);
            if (cleanup) $2f895839ac78ac6c$var$enqueueNativeMicroTask($2f895839ac78ac6c$var$decrementExpectedAwaits);
        }
    };
}
function $2f895839ac78ac6c$var$getPatchedPromiseThen(origThen, zone) {
    return function(onResolved, onRejected) {
        return origThen.call(this, $2f895839ac78ac6c$var$nativeAwaitCompatibleWrap(onResolved, zone), $2f895839ac78ac6c$var$nativeAwaitCompatibleWrap(onRejected, zone));
    };
}
var $2f895839ac78ac6c$var$UNHANDLEDREJECTION = "unhandledrejection";
function $2f895839ac78ac6c$var$globalError(err, promise) {
    var rv;
    try {
        rv = promise.onuncatched(err);
    } catch (e) {}
    if (rv !== false) try {
        var event, eventData = {
            promise: promise,
            reason: err
        };
        if ($2f895839ac78ac6c$var$_global.document && document.createEvent) {
            event = document.createEvent("Event");
            event.initEvent($2f895839ac78ac6c$var$UNHANDLEDREJECTION, true, true);
            $2f895839ac78ac6c$var$extend(event, eventData);
        } else if ($2f895839ac78ac6c$var$_global.CustomEvent) {
            event = new CustomEvent($2f895839ac78ac6c$var$UNHANDLEDREJECTION, {
                detail: eventData
            });
            $2f895839ac78ac6c$var$extend(event, eventData);
        }
        if (event && $2f895839ac78ac6c$var$_global.dispatchEvent) {
            dispatchEvent(event);
            if (!$2f895839ac78ac6c$var$_global.PromiseRejectionEvent && $2f895839ac78ac6c$var$_global.onunhandledrejection) try {
                $2f895839ac78ac6c$var$_global.onunhandledrejection(event);
            } catch (_) {}
        }
        if ($2f895839ac78ac6c$var$debug && event && !event.defaultPrevented) console.warn("Unhandled rejection: " + (err.stack || err));
    } catch (e) {}
}
var $2f895839ac78ac6c$var$rejection = $2f895839ac78ac6c$var$DexiePromise.reject;
function $2f895839ac78ac6c$var$tempTransaction(db, mode, storeNames, fn) {
    if (!db.idbdb || !db._state.openComplete && !$2f895839ac78ac6c$var$PSD.letThrough && !db._vip) {
        if (db._state.openComplete) return $2f895839ac78ac6c$var$rejection(new $2f895839ac78ac6c$var$exceptions.DatabaseClosed(db._state.dbOpenError));
        if (!db._state.isBeingOpened) {
            if (!db._options.autoOpen) return $2f895839ac78ac6c$var$rejection(new $2f895839ac78ac6c$var$exceptions.DatabaseClosed());
            db.open().catch($2f895839ac78ac6c$var$nop);
        }
        return db._state.dbReadyPromise.then(function() {
            return $2f895839ac78ac6c$var$tempTransaction(db, mode, storeNames, fn);
        });
    } else {
        var trans = db._createTransaction(mode, storeNames, db._dbSchema);
        try {
            trans.create();
            db._state.PR1398_maxLoop = 3;
        } catch (ex) {
            if (ex.name === $2f895839ac78ac6c$var$errnames.InvalidState && db.isOpen() && --db._state.PR1398_maxLoop > 0) {
                console.warn("Dexie: Need to reopen db");
                db._close();
                return db.open().then(function() {
                    return $2f895839ac78ac6c$var$tempTransaction(db, mode, storeNames, fn);
                });
            }
            return $2f895839ac78ac6c$var$rejection(ex);
        }
        return trans._promise(mode, function(resolve, reject) {
            return $2f895839ac78ac6c$var$newScope(function() {
                $2f895839ac78ac6c$var$PSD.trans = trans;
                return fn(resolve, reject, trans);
            });
        }).then(function(result) {
            return trans._completion.then(function() {
                return result;
            });
        });
    }
}
var $2f895839ac78ac6c$var$DEXIE_VERSION = "3.2.7";
var $2f895839ac78ac6c$var$maxString = String.fromCharCode(65535);
var $2f895839ac78ac6c$var$minKey = -Infinity;
var $2f895839ac78ac6c$var$INVALID_KEY_ARGUMENT = "Invalid key provided. Keys must be of type string, number, Date or Array<string | number | Date>.";
var $2f895839ac78ac6c$var$STRING_EXPECTED = "String expected.";
var $2f895839ac78ac6c$var$connections = [];
var $2f895839ac78ac6c$var$isIEOrEdge = typeof navigator !== "undefined" && /(MSIE|Trident|Edge)/.test(navigator.userAgent);
var $2f895839ac78ac6c$var$hasIEDeleteObjectStoreBug = $2f895839ac78ac6c$var$isIEOrEdge;
var $2f895839ac78ac6c$var$hangsOnDeleteLargeKeyRange = $2f895839ac78ac6c$var$isIEOrEdge;
var $2f895839ac78ac6c$var$dexieStackFrameFilter = function(frame) {
    return !/(dexie\.js|dexie\.min\.js)/.test(frame);
};
var $2f895839ac78ac6c$var$DBNAMES_DB = "__dbnames";
var $2f895839ac78ac6c$var$READONLY = "readonly";
var $2f895839ac78ac6c$var$READWRITE = "readwrite";
function $2f895839ac78ac6c$var$combine(filter1, filter2) {
    return filter1 ? filter2 ? function() {
        return filter1.apply(this, arguments) && filter2.apply(this, arguments);
    } : filter1 : filter2;
}
var $2f895839ac78ac6c$var$AnyRange = {
    type: 3,
    lower: -Infinity,
    lowerOpen: false,
    upper: [
        []
    ],
    upperOpen: false
};
function $2f895839ac78ac6c$var$workaroundForUndefinedPrimKey(keyPath) {
    return typeof keyPath === "string" && !/\./.test(keyPath) ? function(obj) {
        if (obj[keyPath] === undefined && keyPath in obj) {
            obj = $2f895839ac78ac6c$var$deepClone(obj);
            delete obj[keyPath];
        }
        return obj;
    } : function(obj) {
        return obj;
    };
}
var $2f895839ac78ac6c$var$Table = function() {
    function Table() {}
    Table.prototype._trans = function(mode, fn, writeLocked) {
        var trans = this._tx || $2f895839ac78ac6c$var$PSD.trans;
        var tableName = this.name;
        function checkTableInTransaction(resolve, reject, trans) {
            if (!trans.schema[tableName]) throw new $2f895839ac78ac6c$var$exceptions.NotFound("Table " + tableName + " not part of transaction");
            return fn(trans.idbtrans, trans);
        }
        var wasRootExec = $2f895839ac78ac6c$var$beginMicroTickScope();
        try {
            return trans && trans.db === this.db ? trans === $2f895839ac78ac6c$var$PSD.trans ? trans._promise(mode, checkTableInTransaction, writeLocked) : $2f895839ac78ac6c$var$newScope(function() {
                return trans._promise(mode, checkTableInTransaction, writeLocked);
            }, {
                trans: trans,
                transless: $2f895839ac78ac6c$var$PSD.transless || $2f895839ac78ac6c$var$PSD
            }) : $2f895839ac78ac6c$var$tempTransaction(this.db, mode, [
                this.name
            ], checkTableInTransaction);
        } finally{
            if (wasRootExec) $2f895839ac78ac6c$var$endMicroTickScope();
        }
    };
    Table.prototype.get = function(keyOrCrit, cb) {
        var _this = this;
        if (keyOrCrit && keyOrCrit.constructor === Object) return this.where(keyOrCrit).first(cb);
        return this._trans("readonly", function(trans) {
            return _this.core.get({
                trans: trans,
                key: keyOrCrit
            }).then(function(res) {
                return _this.hook.reading.fire(res);
            });
        }).then(cb);
    };
    Table.prototype.where = function(indexOrCrit) {
        if (typeof indexOrCrit === "string") return new this.db.WhereClause(this, indexOrCrit);
        if ($2f895839ac78ac6c$var$isArray(indexOrCrit)) return new this.db.WhereClause(this, "[" + indexOrCrit.join("+") + "]");
        var keyPaths = $2f895839ac78ac6c$var$keys(indexOrCrit);
        if (keyPaths.length === 1) return this.where(keyPaths[0]).equals(indexOrCrit[keyPaths[0]]);
        var compoundIndex = this.schema.indexes.concat(this.schema.primKey).filter(function(ix) {
            if (ix.compound && keyPaths.every(function(keyPath) {
                return ix.keyPath.indexOf(keyPath) >= 0;
            })) {
                for(var i = 0; i < keyPaths.length; ++i){
                    if (keyPaths.indexOf(ix.keyPath[i]) === -1) return false;
                }
                return true;
            }
            return false;
        }).sort(function(a, b) {
            return a.keyPath.length - b.keyPath.length;
        })[0];
        if (compoundIndex && this.db._maxKey !== $2f895839ac78ac6c$var$maxString) {
            var keyPathsInValidOrder = compoundIndex.keyPath.slice(0, keyPaths.length);
            return this.where(keyPathsInValidOrder).equals(keyPathsInValidOrder.map(function(kp) {
                return indexOrCrit[kp];
            }));
        }
        if (!compoundIndex && $2f895839ac78ac6c$var$debug) console.warn("The query " + JSON.stringify(indexOrCrit) + " on " + this.name + " would benefit of a " + ("compound index [" + keyPaths.join("+") + "]"));
        var idxByName = this.schema.idxByName;
        var idb = this.db._deps.indexedDB;
        function equals(a, b) {
            try {
                return idb.cmp(a, b) === 0;
            } catch (e) {
                return false;
            }
        }
        var _a = keyPaths.reduce(function(_a, keyPath) {
            var prevIndex = _a[0], prevFilterFn = _a[1];
            var index = idxByName[keyPath];
            var value = indexOrCrit[keyPath];
            return [
                prevIndex || index,
                prevIndex || !index ? $2f895839ac78ac6c$var$combine(prevFilterFn, index && index.multi ? function(x) {
                    var prop = $2f895839ac78ac6c$var$getByKeyPath(x, keyPath);
                    return $2f895839ac78ac6c$var$isArray(prop) && prop.some(function(item) {
                        return equals(value, item);
                    });
                } : function(x) {
                    return equals(value, $2f895839ac78ac6c$var$getByKeyPath(x, keyPath));
                }) : prevFilterFn
            ];
        }, [
            null,
            null
        ]), idx = _a[0], filterFunction = _a[1];
        return idx ? this.where(idx.name).equals(indexOrCrit[idx.keyPath]).filter(filterFunction) : compoundIndex ? this.filter(filterFunction) : this.where(keyPaths).equals("");
    };
    Table.prototype.filter = function(filterFunction) {
        return this.toCollection().and(filterFunction);
    };
    Table.prototype.count = function(thenShortcut) {
        return this.toCollection().count(thenShortcut);
    };
    Table.prototype.offset = function(offset) {
        return this.toCollection().offset(offset);
    };
    Table.prototype.limit = function(numRows) {
        return this.toCollection().limit(numRows);
    };
    Table.prototype.each = function(callback) {
        return this.toCollection().each(callback);
    };
    Table.prototype.toArray = function(thenShortcut) {
        return this.toCollection().toArray(thenShortcut);
    };
    Table.prototype.toCollection = function() {
        return new this.db.Collection(new this.db.WhereClause(this));
    };
    Table.prototype.orderBy = function(index) {
        return new this.db.Collection(new this.db.WhereClause(this, $2f895839ac78ac6c$var$isArray(index) ? "[" + index.join("+") + "]" : index));
    };
    Table.prototype.reverse = function() {
        return this.toCollection().reverse();
    };
    Table.prototype.mapToClass = function(constructor) {
        this.schema.mappedClass = constructor;
        var readHook = function(obj) {
            if (!obj) return obj;
            var res = Object.create(constructor.prototype);
            for(var m in obj)if ($2f895839ac78ac6c$var$hasOwn(obj, m)) try {
                res[m] = obj[m];
            } catch (_) {}
            return res;
        };
        if (this.schema.readHook) this.hook.reading.unsubscribe(this.schema.readHook);
        this.schema.readHook = readHook;
        this.hook("reading", readHook);
        return constructor;
    };
    Table.prototype.defineClass = function() {
        function Class(content) {
            $2f895839ac78ac6c$var$extend(this, content);
        }
        return this.mapToClass(Class);
    };
    Table.prototype.add = function(obj, key) {
        var _this = this;
        var _a = this.schema.primKey, auto = _a.auto, keyPath = _a.keyPath;
        var objToAdd = obj;
        if (keyPath && auto) objToAdd = $2f895839ac78ac6c$var$workaroundForUndefinedPrimKey(keyPath)(obj);
        return this._trans("readwrite", function(trans) {
            return _this.core.mutate({
                trans: trans,
                type: "add",
                keys: key != null ? [
                    key
                ] : null,
                values: [
                    objToAdd
                ]
            });
        }).then(function(res) {
            return res.numFailures ? $2f895839ac78ac6c$var$DexiePromise.reject(res.failures[0]) : res.lastResult;
        }).then(function(lastResult) {
            if (keyPath) try {
                $2f895839ac78ac6c$var$setByKeyPath(obj, keyPath, lastResult);
            } catch (_) {}
            return lastResult;
        });
    };
    Table.prototype.update = function(keyOrObject, modifications) {
        if (typeof keyOrObject === "object" && !$2f895839ac78ac6c$var$isArray(keyOrObject)) {
            var key = $2f895839ac78ac6c$var$getByKeyPath(keyOrObject, this.schema.primKey.keyPath);
            if (key === undefined) return $2f895839ac78ac6c$var$rejection(new $2f895839ac78ac6c$var$exceptions.InvalidArgument("Given object does not contain its primary key"));
            try {
                if (typeof modifications !== "function") $2f895839ac78ac6c$var$keys(modifications).forEach(function(keyPath) {
                    $2f895839ac78ac6c$var$setByKeyPath(keyOrObject, keyPath, modifications[keyPath]);
                });
                else modifications(keyOrObject, {
                    value: keyOrObject,
                    primKey: key
                });
            } catch (_a) {}
            return this.where(":id").equals(key).modify(modifications);
        } else return this.where(":id").equals(keyOrObject).modify(modifications);
    };
    Table.prototype.put = function(obj, key) {
        var _this = this;
        var _a = this.schema.primKey, auto = _a.auto, keyPath = _a.keyPath;
        var objToAdd = obj;
        if (keyPath && auto) objToAdd = $2f895839ac78ac6c$var$workaroundForUndefinedPrimKey(keyPath)(obj);
        return this._trans("readwrite", function(trans) {
            return _this.core.mutate({
                trans: trans,
                type: "put",
                values: [
                    objToAdd
                ],
                keys: key != null ? [
                    key
                ] : null
            });
        }).then(function(res) {
            return res.numFailures ? $2f895839ac78ac6c$var$DexiePromise.reject(res.failures[0]) : res.lastResult;
        }).then(function(lastResult) {
            if (keyPath) try {
                $2f895839ac78ac6c$var$setByKeyPath(obj, keyPath, lastResult);
            } catch (_) {}
            return lastResult;
        });
    };
    Table.prototype.delete = function(key) {
        var _this = this;
        return this._trans("readwrite", function(trans) {
            return _this.core.mutate({
                trans: trans,
                type: "delete",
                keys: [
                    key
                ]
            });
        }).then(function(res) {
            return res.numFailures ? $2f895839ac78ac6c$var$DexiePromise.reject(res.failures[0]) : undefined;
        });
    };
    Table.prototype.clear = function() {
        var _this = this;
        return this._trans("readwrite", function(trans) {
            return _this.core.mutate({
                trans: trans,
                type: "deleteRange",
                range: $2f895839ac78ac6c$var$AnyRange
            });
        }).then(function(res) {
            return res.numFailures ? $2f895839ac78ac6c$var$DexiePromise.reject(res.failures[0]) : undefined;
        });
    };
    Table.prototype.bulkGet = function(keys) {
        var _this = this;
        return this._trans("readonly", function(trans) {
            return _this.core.getMany({
                keys: keys,
                trans: trans
            }).then(function(result) {
                return result.map(function(res) {
                    return _this.hook.reading.fire(res);
                });
            });
        });
    };
    Table.prototype.bulkAdd = function(objects, keysOrOptions, options) {
        var _this = this;
        var keys = Array.isArray(keysOrOptions) ? keysOrOptions : undefined;
        options = options || (keys ? undefined : keysOrOptions);
        var wantResults = options ? options.allKeys : undefined;
        return this._trans("readwrite", function(trans) {
            var _a = _this.schema.primKey, auto = _a.auto, keyPath = _a.keyPath;
            if (keyPath && keys) throw new $2f895839ac78ac6c$var$exceptions.InvalidArgument("bulkAdd(): keys argument invalid on tables with inbound keys");
            if (keys && keys.length !== objects.length) throw new $2f895839ac78ac6c$var$exceptions.InvalidArgument("Arguments objects and keys must have the same length");
            var numObjects = objects.length;
            var objectsToAdd = keyPath && auto ? objects.map($2f895839ac78ac6c$var$workaroundForUndefinedPrimKey(keyPath)) : objects;
            return _this.core.mutate({
                trans: trans,
                type: "add",
                keys: keys,
                values: objectsToAdd,
                wantResults: wantResults
            }).then(function(_a) {
                var numFailures = _a.numFailures, results = _a.results, lastResult = _a.lastResult, failures = _a.failures;
                var result = wantResults ? results : lastResult;
                if (numFailures === 0) return result;
                throw new $2f895839ac78ac6c$var$BulkError(_this.name + ".bulkAdd(): " + numFailures + " of " + numObjects + " operations failed", failures);
            });
        });
    };
    Table.prototype.bulkPut = function(objects, keysOrOptions, options) {
        var _this = this;
        var keys = Array.isArray(keysOrOptions) ? keysOrOptions : undefined;
        options = options || (keys ? undefined : keysOrOptions);
        var wantResults = options ? options.allKeys : undefined;
        return this._trans("readwrite", function(trans) {
            var _a = _this.schema.primKey, auto = _a.auto, keyPath = _a.keyPath;
            if (keyPath && keys) throw new $2f895839ac78ac6c$var$exceptions.InvalidArgument("bulkPut(): keys argument invalid on tables with inbound keys");
            if (keys && keys.length !== objects.length) throw new $2f895839ac78ac6c$var$exceptions.InvalidArgument("Arguments objects and keys must have the same length");
            var numObjects = objects.length;
            var objectsToPut = keyPath && auto ? objects.map($2f895839ac78ac6c$var$workaroundForUndefinedPrimKey(keyPath)) : objects;
            return _this.core.mutate({
                trans: trans,
                type: "put",
                keys: keys,
                values: objectsToPut,
                wantResults: wantResults
            }).then(function(_a) {
                var numFailures = _a.numFailures, results = _a.results, lastResult = _a.lastResult, failures = _a.failures;
                var result = wantResults ? results : lastResult;
                if (numFailures === 0) return result;
                throw new $2f895839ac78ac6c$var$BulkError(_this.name + ".bulkPut(): " + numFailures + " of " + numObjects + " operations failed", failures);
            });
        });
    };
    Table.prototype.bulkDelete = function(keys) {
        var _this = this;
        var numKeys = keys.length;
        return this._trans("readwrite", function(trans) {
            return _this.core.mutate({
                trans: trans,
                type: "delete",
                keys: keys
            });
        }).then(function(_a) {
            var numFailures = _a.numFailures, lastResult = _a.lastResult, failures = _a.failures;
            if (numFailures === 0) return lastResult;
            throw new $2f895839ac78ac6c$var$BulkError(_this.name + ".bulkDelete(): " + numFailures + " of " + numKeys + " operations failed", failures);
        });
    };
    return Table;
}();
function $2f895839ac78ac6c$var$Events(ctx) {
    var evs = {};
    var rv = function(eventName, subscriber) {
        if (subscriber) {
            var i = arguments.length, args = new Array(i - 1);
            while(--i)args[i - 1] = arguments[i];
            evs[eventName].subscribe.apply(null, args);
            return ctx;
        } else if (typeof eventName === "string") return evs[eventName];
    };
    rv.addEventType = add;
    for(var i = 1, l = arguments.length; i < l; ++i)add(arguments[i]);
    return rv;
    function add(eventName, chainFunction, defaultFunction) {
        if (typeof eventName === "object") return addConfiguredEvents(eventName);
        if (!chainFunction) chainFunction = $2f895839ac78ac6c$var$reverseStoppableEventChain;
        if (!defaultFunction) defaultFunction = $2f895839ac78ac6c$var$nop;
        var context = {
            subscribers: [],
            fire: defaultFunction,
            subscribe: function(cb) {
                if (context.subscribers.indexOf(cb) === -1) {
                    context.subscribers.push(cb);
                    context.fire = chainFunction(context.fire, cb);
                }
            },
            unsubscribe: function(cb) {
                context.subscribers = context.subscribers.filter(function(fn) {
                    return fn !== cb;
                });
                context.fire = context.subscribers.reduce(chainFunction, defaultFunction);
            }
        };
        evs[eventName] = rv[eventName] = context;
        return context;
    }
    function addConfiguredEvents(cfg) {
        $2f895839ac78ac6c$var$keys(cfg).forEach(function(eventName) {
            var args = cfg[eventName];
            if ($2f895839ac78ac6c$var$isArray(args)) add(eventName, cfg[eventName][0], cfg[eventName][1]);
            else if (args === "asap") var context = add(eventName, $2f895839ac78ac6c$var$mirror, function fire() {
                var i = arguments.length, args = new Array(i);
                while(i--)args[i] = arguments[i];
                context.subscribers.forEach(function(fn) {
                    $2f895839ac78ac6c$var$asap$1(function fireEvent() {
                        fn.apply(null, args);
                    });
                });
            });
            else throw new $2f895839ac78ac6c$var$exceptions.InvalidArgument("Invalid event config");
        });
    }
}
function $2f895839ac78ac6c$var$makeClassConstructor(prototype, constructor) {
    $2f895839ac78ac6c$var$derive(constructor).from({
        prototype: prototype
    });
    return constructor;
}
function $2f895839ac78ac6c$var$createTableConstructor(db) {
    return $2f895839ac78ac6c$var$makeClassConstructor($2f895839ac78ac6c$var$Table.prototype, function Table(name, tableSchema, trans) {
        this.db = db;
        this._tx = trans;
        this.name = name;
        this.schema = tableSchema;
        this.hook = db._allTables[name] ? db._allTables[name].hook : $2f895839ac78ac6c$var$Events(null, {
            "creating": [
                $2f895839ac78ac6c$var$hookCreatingChain,
                $2f895839ac78ac6c$var$nop
            ],
            "reading": [
                $2f895839ac78ac6c$var$pureFunctionChain,
                $2f895839ac78ac6c$var$mirror
            ],
            "updating": [
                $2f895839ac78ac6c$var$hookUpdatingChain,
                $2f895839ac78ac6c$var$nop
            ],
            "deleting": [
                $2f895839ac78ac6c$var$hookDeletingChain,
                $2f895839ac78ac6c$var$nop
            ]
        });
    });
}
function $2f895839ac78ac6c$var$isPlainKeyRange(ctx, ignoreLimitFilter) {
    return !(ctx.filter || ctx.algorithm || ctx.or) && (ignoreLimitFilter ? ctx.justLimit : !ctx.replayFilter);
}
function $2f895839ac78ac6c$var$addFilter(ctx, fn) {
    ctx.filter = $2f895839ac78ac6c$var$combine(ctx.filter, fn);
}
function $2f895839ac78ac6c$var$addReplayFilter(ctx, factory, isLimitFilter) {
    var curr = ctx.replayFilter;
    ctx.replayFilter = curr ? function() {
        return $2f895839ac78ac6c$var$combine(curr(), factory());
    } : factory;
    ctx.justLimit = isLimitFilter && !curr;
}
function $2f895839ac78ac6c$var$addMatchFilter(ctx, fn) {
    ctx.isMatch = $2f895839ac78ac6c$var$combine(ctx.isMatch, fn);
}
function $2f895839ac78ac6c$var$getIndexOrStore(ctx, coreSchema) {
    if (ctx.isPrimKey) return coreSchema.primaryKey;
    var index = coreSchema.getIndexByKeyPath(ctx.index);
    if (!index) throw new $2f895839ac78ac6c$var$exceptions.Schema("KeyPath " + ctx.index + " on object store " + coreSchema.name + " is not indexed");
    return index;
}
function $2f895839ac78ac6c$var$openCursor(ctx, coreTable, trans) {
    var index = $2f895839ac78ac6c$var$getIndexOrStore(ctx, coreTable.schema);
    return coreTable.openCursor({
        trans: trans,
        values: !ctx.keysOnly,
        reverse: ctx.dir === "prev",
        unique: !!ctx.unique,
        query: {
            index: index,
            range: ctx.range
        }
    });
}
function $2f895839ac78ac6c$var$iter(ctx, fn, coreTrans, coreTable) {
    var filter = ctx.replayFilter ? $2f895839ac78ac6c$var$combine(ctx.filter, ctx.replayFilter()) : ctx.filter;
    if (!ctx.or) return $2f895839ac78ac6c$var$iterate($2f895839ac78ac6c$var$openCursor(ctx, coreTable, coreTrans), $2f895839ac78ac6c$var$combine(ctx.algorithm, filter), fn, !ctx.keysOnly && ctx.valueMapper);
    else {
        var set_1 = {};
        var union = function(item, cursor, advance) {
            if (!filter || filter(cursor, advance, function(result) {
                return cursor.stop(result);
            }, function(err) {
                return cursor.fail(err);
            })) {
                var primaryKey = cursor.primaryKey;
                var key = "" + primaryKey;
                if (key === "[object ArrayBuffer]") key = "" + new Uint8Array(primaryKey);
                if (!$2f895839ac78ac6c$var$hasOwn(set_1, key)) {
                    set_1[key] = true;
                    fn(item, cursor, advance);
                }
            }
        };
        return Promise.all([
            ctx.or._iterate(union, coreTrans),
            $2f895839ac78ac6c$var$iterate($2f895839ac78ac6c$var$openCursor(ctx, coreTable, coreTrans), ctx.algorithm, union, !ctx.keysOnly && ctx.valueMapper)
        ]);
    }
}
function $2f895839ac78ac6c$var$iterate(cursorPromise, filter, fn, valueMapper) {
    var mappedFn = valueMapper ? function(x, c, a) {
        return fn(valueMapper(x), c, a);
    } : fn;
    var wrappedFn = $2f895839ac78ac6c$var$wrap(mappedFn);
    return cursorPromise.then(function(cursor) {
        if (cursor) return cursor.start(function() {
            var c = function() {
                return cursor.continue();
            };
            if (!filter || filter(cursor, function(advancer) {
                return c = advancer;
            }, function(val) {
                cursor.stop(val);
                c = $2f895839ac78ac6c$var$nop;
            }, function(e) {
                cursor.fail(e);
                c = $2f895839ac78ac6c$var$nop;
            })) wrappedFn(cursor.value, cursor, function(advancer) {
                return c = advancer;
            });
            c();
        });
    });
}
function $2f895839ac78ac6c$var$cmp(a, b) {
    try {
        var ta = $2f895839ac78ac6c$var$type(a);
        var tb = $2f895839ac78ac6c$var$type(b);
        if (ta !== tb) {
            if (ta === "Array") return 1;
            if (tb === "Array") return -1;
            if (ta === "binary") return 1;
            if (tb === "binary") return -1;
            if (ta === "string") return 1;
            if (tb === "string") return -1;
            if (ta === "Date") return 1;
            if (tb !== "Date") return NaN;
            return -1;
        }
        switch(ta){
            case "number":
            case "Date":
            case "string":
                return a > b ? 1 : a < b ? -1 : 0;
            case "binary":
                return $2f895839ac78ac6c$var$compareUint8Arrays($2f895839ac78ac6c$var$getUint8Array(a), $2f895839ac78ac6c$var$getUint8Array(b));
            case "Array":
                return $2f895839ac78ac6c$var$compareArrays(a, b);
        }
    } catch (_a) {}
    return NaN;
}
function $2f895839ac78ac6c$var$compareArrays(a, b) {
    var al = a.length;
    var bl = b.length;
    var l = al < bl ? al : bl;
    for(var i = 0; i < l; ++i){
        var res = $2f895839ac78ac6c$var$cmp(a[i], b[i]);
        if (res !== 0) return res;
    }
    return al === bl ? 0 : al < bl ? -1 : 1;
}
function $2f895839ac78ac6c$var$compareUint8Arrays(a, b) {
    var al = a.length;
    var bl = b.length;
    var l = al < bl ? al : bl;
    for(var i = 0; i < l; ++i){
        if (a[i] !== b[i]) return a[i] < b[i] ? -1 : 1;
    }
    return al === bl ? 0 : al < bl ? -1 : 1;
}
function $2f895839ac78ac6c$var$type(x) {
    var t = typeof x;
    if (t !== "object") return t;
    if (ArrayBuffer.isView(x)) return "binary";
    var tsTag = $2f895839ac78ac6c$var$toStringTag(x);
    return tsTag === "ArrayBuffer" ? "binary" : tsTag;
}
function $2f895839ac78ac6c$var$getUint8Array(a) {
    if (a instanceof Uint8Array) return a;
    if (ArrayBuffer.isView(a)) return new Uint8Array(a.buffer, a.byteOffset, a.byteLength);
    return new Uint8Array(a);
}
var $2f895839ac78ac6c$var$Collection = function() {
    function Collection() {}
    Collection.prototype._read = function(fn, cb) {
        var ctx = this._ctx;
        return ctx.error ? ctx.table._trans(null, $2f895839ac78ac6c$var$rejection.bind(null, ctx.error)) : ctx.table._trans("readonly", fn).then(cb);
    };
    Collection.prototype._write = function(fn) {
        var ctx = this._ctx;
        return ctx.error ? ctx.table._trans(null, $2f895839ac78ac6c$var$rejection.bind(null, ctx.error)) : ctx.table._trans("readwrite", fn, "locked");
    };
    Collection.prototype._addAlgorithm = function(fn) {
        var ctx = this._ctx;
        ctx.algorithm = $2f895839ac78ac6c$var$combine(ctx.algorithm, fn);
    };
    Collection.prototype._iterate = function(fn, coreTrans) {
        return $2f895839ac78ac6c$var$iter(this._ctx, fn, coreTrans, this._ctx.table.core);
    };
    Collection.prototype.clone = function(props) {
        var rv = Object.create(this.constructor.prototype), ctx = Object.create(this._ctx);
        if (props) $2f895839ac78ac6c$var$extend(ctx, props);
        rv._ctx = ctx;
        return rv;
    };
    Collection.prototype.raw = function() {
        this._ctx.valueMapper = null;
        return this;
    };
    Collection.prototype.each = function(fn) {
        var ctx = this._ctx;
        return this._read(function(trans) {
            return $2f895839ac78ac6c$var$iter(ctx, fn, trans, ctx.table.core);
        });
    };
    Collection.prototype.count = function(cb) {
        var _this = this;
        return this._read(function(trans) {
            var ctx = _this._ctx;
            var coreTable = ctx.table.core;
            if ($2f895839ac78ac6c$var$isPlainKeyRange(ctx, true)) return coreTable.count({
                trans: trans,
                query: {
                    index: $2f895839ac78ac6c$var$getIndexOrStore(ctx, coreTable.schema),
                    range: ctx.range
                }
            }).then(function(count) {
                return Math.min(count, ctx.limit);
            });
            else {
                var count = 0;
                return $2f895839ac78ac6c$var$iter(ctx, function() {
                    ++count;
                    return false;
                }, trans, coreTable).then(function() {
                    return count;
                });
            }
        }).then(cb);
    };
    Collection.prototype.sortBy = function(keyPath, cb) {
        var parts = keyPath.split(".").reverse(), lastPart = parts[0], lastIndex = parts.length - 1;
        function getval(obj, i) {
            if (i) return getval(obj[parts[i]], i - 1);
            return obj[lastPart];
        }
        var order = this._ctx.dir === "next" ? 1 : -1;
        function sorter(a, b) {
            var aVal = getval(a, lastIndex), bVal = getval(b, lastIndex);
            return aVal < bVal ? -order : aVal > bVal ? order : 0;
        }
        return this.toArray(function(a) {
            return a.sort(sorter);
        }).then(cb);
    };
    Collection.prototype.toArray = function(cb) {
        var _this = this;
        return this._read(function(trans) {
            var ctx = _this._ctx;
            if (ctx.dir === "next" && $2f895839ac78ac6c$var$isPlainKeyRange(ctx, true) && ctx.limit > 0) {
                var valueMapper_1 = ctx.valueMapper;
                var index = $2f895839ac78ac6c$var$getIndexOrStore(ctx, ctx.table.core.schema);
                return ctx.table.core.query({
                    trans: trans,
                    limit: ctx.limit,
                    values: true,
                    query: {
                        index: index,
                        range: ctx.range
                    }
                }).then(function(_a) {
                    var result = _a.result;
                    return valueMapper_1 ? result.map(valueMapper_1) : result;
                });
            } else {
                var a_1 = [];
                return $2f895839ac78ac6c$var$iter(ctx, function(item) {
                    return a_1.push(item);
                }, trans, ctx.table.core).then(function() {
                    return a_1;
                });
            }
        }, cb);
    };
    Collection.prototype.offset = function(offset) {
        var ctx = this._ctx;
        if (offset <= 0) return this;
        ctx.offset += offset;
        if ($2f895839ac78ac6c$var$isPlainKeyRange(ctx)) $2f895839ac78ac6c$var$addReplayFilter(ctx, function() {
            var offsetLeft = offset;
            return function(cursor, advance) {
                if (offsetLeft === 0) return true;
                if (offsetLeft === 1) {
                    --offsetLeft;
                    return false;
                }
                advance(function() {
                    cursor.advance(offsetLeft);
                    offsetLeft = 0;
                });
                return false;
            };
        });
        else $2f895839ac78ac6c$var$addReplayFilter(ctx, function() {
            var offsetLeft = offset;
            return function() {
                return --offsetLeft < 0;
            };
        });
        return this;
    };
    Collection.prototype.limit = function(numRows) {
        this._ctx.limit = Math.min(this._ctx.limit, numRows);
        $2f895839ac78ac6c$var$addReplayFilter(this._ctx, function() {
            var rowsLeft = numRows;
            return function(cursor, advance, resolve) {
                if (--rowsLeft <= 0) advance(resolve);
                return rowsLeft >= 0;
            };
        }, true);
        return this;
    };
    Collection.prototype.until = function(filterFunction, bIncludeStopEntry) {
        $2f895839ac78ac6c$var$addFilter(this._ctx, function(cursor, advance, resolve) {
            if (filterFunction(cursor.value)) {
                advance(resolve);
                return bIncludeStopEntry;
            } else return true;
        });
        return this;
    };
    Collection.prototype.first = function(cb) {
        return this.limit(1).toArray(function(a) {
            return a[0];
        }).then(cb);
    };
    Collection.prototype.last = function(cb) {
        return this.reverse().first(cb);
    };
    Collection.prototype.filter = function(filterFunction) {
        $2f895839ac78ac6c$var$addFilter(this._ctx, function(cursor) {
            return filterFunction(cursor.value);
        });
        $2f895839ac78ac6c$var$addMatchFilter(this._ctx, filterFunction);
        return this;
    };
    Collection.prototype.and = function(filter) {
        return this.filter(filter);
    };
    Collection.prototype.or = function(indexName) {
        return new this.db.WhereClause(this._ctx.table, indexName, this);
    };
    Collection.prototype.reverse = function() {
        this._ctx.dir = this._ctx.dir === "prev" ? "next" : "prev";
        if (this._ondirectionchange) this._ondirectionchange(this._ctx.dir);
        return this;
    };
    Collection.prototype.desc = function() {
        return this.reverse();
    };
    Collection.prototype.eachKey = function(cb) {
        var ctx = this._ctx;
        ctx.keysOnly = !ctx.isMatch;
        return this.each(function(val, cursor) {
            cb(cursor.key, cursor);
        });
    };
    Collection.prototype.eachUniqueKey = function(cb) {
        this._ctx.unique = "unique";
        return this.eachKey(cb);
    };
    Collection.prototype.eachPrimaryKey = function(cb) {
        var ctx = this._ctx;
        ctx.keysOnly = !ctx.isMatch;
        return this.each(function(val, cursor) {
            cb(cursor.primaryKey, cursor);
        });
    };
    Collection.prototype.keys = function(cb) {
        var ctx = this._ctx;
        ctx.keysOnly = !ctx.isMatch;
        var a = [];
        return this.each(function(item, cursor) {
            a.push(cursor.key);
        }).then(function() {
            return a;
        }).then(cb);
    };
    Collection.prototype.primaryKeys = function(cb) {
        var ctx = this._ctx;
        if (ctx.dir === "next" && $2f895839ac78ac6c$var$isPlainKeyRange(ctx, true) && ctx.limit > 0) return this._read(function(trans) {
            var index = $2f895839ac78ac6c$var$getIndexOrStore(ctx, ctx.table.core.schema);
            return ctx.table.core.query({
                trans: trans,
                values: false,
                limit: ctx.limit,
                query: {
                    index: index,
                    range: ctx.range
                }
            });
        }).then(function(_a) {
            var result = _a.result;
            return result;
        }).then(cb);
        ctx.keysOnly = !ctx.isMatch;
        var a = [];
        return this.each(function(item, cursor) {
            a.push(cursor.primaryKey);
        }).then(function() {
            return a;
        }).then(cb);
    };
    Collection.prototype.uniqueKeys = function(cb) {
        this._ctx.unique = "unique";
        return this.keys(cb);
    };
    Collection.prototype.firstKey = function(cb) {
        return this.limit(1).keys(function(a) {
            return a[0];
        }).then(cb);
    };
    Collection.prototype.lastKey = function(cb) {
        return this.reverse().firstKey(cb);
    };
    Collection.prototype.distinct = function() {
        var ctx = this._ctx, idx = ctx.index && ctx.table.schema.idxByName[ctx.index];
        if (!idx || !idx.multi) return this;
        var set = {};
        $2f895839ac78ac6c$var$addFilter(this._ctx, function(cursor) {
            var strKey = cursor.primaryKey.toString();
            var found = $2f895839ac78ac6c$var$hasOwn(set, strKey);
            set[strKey] = true;
            return !found;
        });
        return this;
    };
    Collection.prototype.modify = function(changes) {
        var _this = this;
        var ctx = this._ctx;
        return this._write(function(trans) {
            var modifyer;
            if (typeof changes === "function") modifyer = changes;
            else {
                var keyPaths = $2f895839ac78ac6c$var$keys(changes);
                var numKeys = keyPaths.length;
                modifyer = function(item) {
                    var anythingModified = false;
                    for(var i = 0; i < numKeys; ++i){
                        var keyPath = keyPaths[i], val = changes[keyPath];
                        if ($2f895839ac78ac6c$var$getByKeyPath(item, keyPath) !== val) {
                            $2f895839ac78ac6c$var$setByKeyPath(item, keyPath, val);
                            anythingModified = true;
                        }
                    }
                    return anythingModified;
                };
            }
            var coreTable = ctx.table.core;
            var _a = coreTable.schema.primaryKey, outbound = _a.outbound, extractKey = _a.extractKey;
            var limit = _this.db._options.modifyChunkSize || 200;
            var totalFailures = [];
            var successCount = 0;
            var failedKeys = [];
            var applyMutateResult = function(expectedCount, res) {
                var failures = res.failures, numFailures = res.numFailures;
                successCount += expectedCount - numFailures;
                for(var _i = 0, _a = $2f895839ac78ac6c$var$keys(failures); _i < _a.length; _i++){
                    var pos = _a[_i];
                    totalFailures.push(failures[pos]);
                }
            };
            return _this.clone().primaryKeys().then(function(keys) {
                var nextChunk = function(offset) {
                    var count = Math.min(limit, keys.length - offset);
                    return coreTable.getMany({
                        trans: trans,
                        keys: keys.slice(offset, offset + count),
                        cache: "immutable"
                    }).then(function(values) {
                        var addValues = [];
                        var putValues = [];
                        var putKeys = outbound ? [] : null;
                        var deleteKeys = [];
                        for(var i = 0; i < count; ++i){
                            var origValue = values[i];
                            var ctx_1 = {
                                value: $2f895839ac78ac6c$var$deepClone(origValue),
                                primKey: keys[offset + i]
                            };
                            if (modifyer.call(ctx_1, ctx_1.value, ctx_1) !== false) {
                                if (ctx_1.value == null) deleteKeys.push(keys[offset + i]);
                                else if (!outbound && $2f895839ac78ac6c$var$cmp(extractKey(origValue), extractKey(ctx_1.value)) !== 0) {
                                    deleteKeys.push(keys[offset + i]);
                                    addValues.push(ctx_1.value);
                                } else {
                                    putValues.push(ctx_1.value);
                                    if (outbound) putKeys.push(keys[offset + i]);
                                }
                            }
                        }
                        var criteria = $2f895839ac78ac6c$var$isPlainKeyRange(ctx) && ctx.limit === Infinity && (typeof changes !== "function" || changes === $2f895839ac78ac6c$var$deleteCallback) && {
                            index: ctx.index,
                            range: ctx.range
                        };
                        return Promise.resolve(addValues.length > 0 && coreTable.mutate({
                            trans: trans,
                            type: "add",
                            values: addValues
                        }).then(function(res) {
                            for(var pos in res.failures)deleteKeys.splice(parseInt(pos), 1);
                            applyMutateResult(addValues.length, res);
                        })).then(function() {
                            return (putValues.length > 0 || criteria && typeof changes === "object") && coreTable.mutate({
                                trans: trans,
                                type: "put",
                                keys: putKeys,
                                values: putValues,
                                criteria: criteria,
                                changeSpec: typeof changes !== "function" && changes
                            }).then(function(res) {
                                return applyMutateResult(putValues.length, res);
                            });
                        }).then(function() {
                            return (deleteKeys.length > 0 || criteria && changes === $2f895839ac78ac6c$var$deleteCallback) && coreTable.mutate({
                                trans: trans,
                                type: "delete",
                                keys: deleteKeys,
                                criteria: criteria
                            }).then(function(res) {
                                return applyMutateResult(deleteKeys.length, res);
                            });
                        }).then(function() {
                            return keys.length > offset + count && nextChunk(offset + limit);
                        });
                    });
                };
                return nextChunk(0).then(function() {
                    if (totalFailures.length > 0) throw new $2f895839ac78ac6c$var$ModifyError("Error modifying one or more objects", totalFailures, successCount, failedKeys);
                    return keys.length;
                });
            });
        });
    };
    Collection.prototype.delete = function() {
        var ctx = this._ctx, range = ctx.range;
        if ($2f895839ac78ac6c$var$isPlainKeyRange(ctx) && (ctx.isPrimKey && !$2f895839ac78ac6c$var$hangsOnDeleteLargeKeyRange || range.type === 3)) return this._write(function(trans) {
            var primaryKey = ctx.table.core.schema.primaryKey;
            var coreRange = range;
            return ctx.table.core.count({
                trans: trans,
                query: {
                    index: primaryKey,
                    range: coreRange
                }
            }).then(function(count) {
                return ctx.table.core.mutate({
                    trans: trans,
                    type: "deleteRange",
                    range: coreRange
                }).then(function(_a) {
                    var failures = _a.failures;
                    _a.lastResult;
                    _a.results;
                    var numFailures = _a.numFailures;
                    if (numFailures) throw new $2f895839ac78ac6c$var$ModifyError("Could not delete some values", Object.keys(failures).map(function(pos) {
                        return failures[pos];
                    }), count - numFailures);
                    return count - numFailures;
                });
            });
        });
        return this.modify($2f895839ac78ac6c$var$deleteCallback);
    };
    return Collection;
}();
var $2f895839ac78ac6c$var$deleteCallback = function(value, ctx) {
    return ctx.value = null;
};
function $2f895839ac78ac6c$var$createCollectionConstructor(db) {
    return $2f895839ac78ac6c$var$makeClassConstructor($2f895839ac78ac6c$var$Collection.prototype, function Collection(whereClause, keyRangeGenerator) {
        this.db = db;
        var keyRange = $2f895839ac78ac6c$var$AnyRange, error = null;
        if (keyRangeGenerator) try {
            keyRange = keyRangeGenerator();
        } catch (ex) {
            error = ex;
        }
        var whereCtx = whereClause._ctx;
        var table = whereCtx.table;
        var readingHook = table.hook.reading.fire;
        this._ctx = {
            table: table,
            index: whereCtx.index,
            isPrimKey: !whereCtx.index || table.schema.primKey.keyPath && whereCtx.index === table.schema.primKey.name,
            range: keyRange,
            keysOnly: false,
            dir: "next",
            unique: "",
            algorithm: null,
            filter: null,
            replayFilter: null,
            justLimit: true,
            isMatch: null,
            offset: 0,
            limit: Infinity,
            error: error,
            or: whereCtx.or,
            valueMapper: readingHook !== $2f895839ac78ac6c$var$mirror ? readingHook : null
        };
    });
}
function $2f895839ac78ac6c$var$simpleCompare(a, b) {
    return a < b ? -1 : a === b ? 0 : 1;
}
function $2f895839ac78ac6c$var$simpleCompareReverse(a, b) {
    return a > b ? -1 : a === b ? 0 : 1;
}
function $2f895839ac78ac6c$var$fail(collectionOrWhereClause, err, T) {
    var collection = collectionOrWhereClause instanceof $2f895839ac78ac6c$var$WhereClause ? new collectionOrWhereClause.Collection(collectionOrWhereClause) : collectionOrWhereClause;
    collection._ctx.error = T ? new T(err) : new TypeError(err);
    return collection;
}
function $2f895839ac78ac6c$var$emptyCollection(whereClause) {
    return new whereClause.Collection(whereClause, function() {
        return $2f895839ac78ac6c$var$rangeEqual("");
    }).limit(0);
}
function $2f895839ac78ac6c$var$upperFactory(dir) {
    return dir === "next" ? function(s) {
        return s.toUpperCase();
    } : function(s) {
        return s.toLowerCase();
    };
}
function $2f895839ac78ac6c$var$lowerFactory(dir) {
    return dir === "next" ? function(s) {
        return s.toLowerCase();
    } : function(s) {
        return s.toUpperCase();
    };
}
function $2f895839ac78ac6c$var$nextCasing(key, lowerKey, upperNeedle, lowerNeedle, cmp, dir) {
    var length = Math.min(key.length, lowerNeedle.length);
    var llp = -1;
    for(var i = 0; i < length; ++i){
        var lwrKeyChar = lowerKey[i];
        if (lwrKeyChar !== lowerNeedle[i]) {
            if (cmp(key[i], upperNeedle[i]) < 0) return key.substr(0, i) + upperNeedle[i] + upperNeedle.substr(i + 1);
            if (cmp(key[i], lowerNeedle[i]) < 0) return key.substr(0, i) + lowerNeedle[i] + upperNeedle.substr(i + 1);
            if (llp >= 0) return key.substr(0, llp) + lowerKey[llp] + upperNeedle.substr(llp + 1);
            return null;
        }
        if (cmp(key[i], lwrKeyChar) < 0) llp = i;
    }
    if (length < lowerNeedle.length && dir === "next") return key + upperNeedle.substr(key.length);
    if (length < key.length && dir === "prev") return key.substr(0, upperNeedle.length);
    return llp < 0 ? null : key.substr(0, llp) + lowerNeedle[llp] + upperNeedle.substr(llp + 1);
}
function $2f895839ac78ac6c$var$addIgnoreCaseAlgorithm(whereClause, match, needles, suffix) {
    var upper, lower, compare, upperNeedles, lowerNeedles, direction, nextKeySuffix, needlesLen = needles.length;
    if (!needles.every(function(s) {
        return typeof s === "string";
    })) return $2f895839ac78ac6c$var$fail(whereClause, $2f895839ac78ac6c$var$STRING_EXPECTED);
    function initDirection(dir) {
        upper = $2f895839ac78ac6c$var$upperFactory(dir);
        lower = $2f895839ac78ac6c$var$lowerFactory(dir);
        compare = dir === "next" ? $2f895839ac78ac6c$var$simpleCompare : $2f895839ac78ac6c$var$simpleCompareReverse;
        var needleBounds = needles.map(function(needle) {
            return {
                lower: lower(needle),
                upper: upper(needle)
            };
        }).sort(function(a, b) {
            return compare(a.lower, b.lower);
        });
        upperNeedles = needleBounds.map(function(nb) {
            return nb.upper;
        });
        lowerNeedles = needleBounds.map(function(nb) {
            return nb.lower;
        });
        direction = dir;
        nextKeySuffix = dir === "next" ? "" : suffix;
    }
    initDirection("next");
    var c = new whereClause.Collection(whereClause, function() {
        return $2f895839ac78ac6c$var$createRange(upperNeedles[0], lowerNeedles[needlesLen - 1] + suffix);
    });
    c._ondirectionchange = function(direction) {
        initDirection(direction);
    };
    var firstPossibleNeedle = 0;
    c._addAlgorithm(function(cursor, advance, resolve) {
        var key = cursor.key;
        if (typeof key !== "string") return false;
        var lowerKey = lower(key);
        if (match(lowerKey, lowerNeedles, firstPossibleNeedle)) return true;
        else {
            var lowestPossibleCasing = null;
            for(var i = firstPossibleNeedle; i < needlesLen; ++i){
                var casing = $2f895839ac78ac6c$var$nextCasing(key, lowerKey, upperNeedles[i], lowerNeedles[i], compare, direction);
                if (casing === null && lowestPossibleCasing === null) firstPossibleNeedle = i + 1;
                else if (lowestPossibleCasing === null || compare(lowestPossibleCasing, casing) > 0) lowestPossibleCasing = casing;
            }
            if (lowestPossibleCasing !== null) advance(function() {
                cursor.continue(lowestPossibleCasing + nextKeySuffix);
            });
            else advance(resolve);
            return false;
        }
    });
    return c;
}
function $2f895839ac78ac6c$var$createRange(lower, upper, lowerOpen, upperOpen) {
    return {
        type: 2,
        lower: lower,
        upper: upper,
        lowerOpen: lowerOpen,
        upperOpen: upperOpen
    };
}
function $2f895839ac78ac6c$var$rangeEqual(value) {
    return {
        type: 1,
        lower: value,
        upper: value
    };
}
var $2f895839ac78ac6c$var$WhereClause = function() {
    function WhereClause() {}
    Object.defineProperty(WhereClause.prototype, "Collection", {
        get: function() {
            return this._ctx.table.db.Collection;
        },
        enumerable: false,
        configurable: true
    });
    WhereClause.prototype.between = function(lower, upper, includeLower, includeUpper) {
        includeLower = includeLower !== false;
        includeUpper = includeUpper === true;
        try {
            if (this._cmp(lower, upper) > 0 || this._cmp(lower, upper) === 0 && (includeLower || includeUpper) && !(includeLower && includeUpper)) return $2f895839ac78ac6c$var$emptyCollection(this);
            return new this.Collection(this, function() {
                return $2f895839ac78ac6c$var$createRange(lower, upper, !includeLower, !includeUpper);
            });
        } catch (e) {
            return $2f895839ac78ac6c$var$fail(this, $2f895839ac78ac6c$var$INVALID_KEY_ARGUMENT);
        }
    };
    WhereClause.prototype.equals = function(value) {
        if (value == null) return $2f895839ac78ac6c$var$fail(this, $2f895839ac78ac6c$var$INVALID_KEY_ARGUMENT);
        return new this.Collection(this, function() {
            return $2f895839ac78ac6c$var$rangeEqual(value);
        });
    };
    WhereClause.prototype.above = function(value) {
        if (value == null) return $2f895839ac78ac6c$var$fail(this, $2f895839ac78ac6c$var$INVALID_KEY_ARGUMENT);
        return new this.Collection(this, function() {
            return $2f895839ac78ac6c$var$createRange(value, undefined, true);
        });
    };
    WhereClause.prototype.aboveOrEqual = function(value) {
        if (value == null) return $2f895839ac78ac6c$var$fail(this, $2f895839ac78ac6c$var$INVALID_KEY_ARGUMENT);
        return new this.Collection(this, function() {
            return $2f895839ac78ac6c$var$createRange(value, undefined, false);
        });
    };
    WhereClause.prototype.below = function(value) {
        if (value == null) return $2f895839ac78ac6c$var$fail(this, $2f895839ac78ac6c$var$INVALID_KEY_ARGUMENT);
        return new this.Collection(this, function() {
            return $2f895839ac78ac6c$var$createRange(undefined, value, false, true);
        });
    };
    WhereClause.prototype.belowOrEqual = function(value) {
        if (value == null) return $2f895839ac78ac6c$var$fail(this, $2f895839ac78ac6c$var$INVALID_KEY_ARGUMENT);
        return new this.Collection(this, function() {
            return $2f895839ac78ac6c$var$createRange(undefined, value);
        });
    };
    WhereClause.prototype.startsWith = function(str) {
        if (typeof str !== "string") return $2f895839ac78ac6c$var$fail(this, $2f895839ac78ac6c$var$STRING_EXPECTED);
        return this.between(str, str + $2f895839ac78ac6c$var$maxString, true, true);
    };
    WhereClause.prototype.startsWithIgnoreCase = function(str) {
        if (str === "") return this.startsWith(str);
        return $2f895839ac78ac6c$var$addIgnoreCaseAlgorithm(this, function(x, a) {
            return x.indexOf(a[0]) === 0;
        }, [
            str
        ], $2f895839ac78ac6c$var$maxString);
    };
    WhereClause.prototype.equalsIgnoreCase = function(str) {
        return $2f895839ac78ac6c$var$addIgnoreCaseAlgorithm(this, function(x, a) {
            return x === a[0];
        }, [
            str
        ], "");
    };
    WhereClause.prototype.anyOfIgnoreCase = function() {
        var set = $2f895839ac78ac6c$var$getArrayOf.apply($2f895839ac78ac6c$var$NO_CHAR_ARRAY, arguments);
        if (set.length === 0) return $2f895839ac78ac6c$var$emptyCollection(this);
        return $2f895839ac78ac6c$var$addIgnoreCaseAlgorithm(this, function(x, a) {
            return a.indexOf(x) !== -1;
        }, set, "");
    };
    WhereClause.prototype.startsWithAnyOfIgnoreCase = function() {
        var set = $2f895839ac78ac6c$var$getArrayOf.apply($2f895839ac78ac6c$var$NO_CHAR_ARRAY, arguments);
        if (set.length === 0) return $2f895839ac78ac6c$var$emptyCollection(this);
        return $2f895839ac78ac6c$var$addIgnoreCaseAlgorithm(this, function(x, a) {
            return a.some(function(n) {
                return x.indexOf(n) === 0;
            });
        }, set, $2f895839ac78ac6c$var$maxString);
    };
    WhereClause.prototype.anyOf = function() {
        var _this = this;
        var set = $2f895839ac78ac6c$var$getArrayOf.apply($2f895839ac78ac6c$var$NO_CHAR_ARRAY, arguments);
        var compare = this._cmp;
        try {
            set.sort(compare);
        } catch (e) {
            return $2f895839ac78ac6c$var$fail(this, $2f895839ac78ac6c$var$INVALID_KEY_ARGUMENT);
        }
        if (set.length === 0) return $2f895839ac78ac6c$var$emptyCollection(this);
        var c = new this.Collection(this, function() {
            return $2f895839ac78ac6c$var$createRange(set[0], set[set.length - 1]);
        });
        c._ondirectionchange = function(direction) {
            compare = direction === "next" ? _this._ascending : _this._descending;
            set.sort(compare);
        };
        var i = 0;
        c._addAlgorithm(function(cursor, advance, resolve) {
            var key = cursor.key;
            while(compare(key, set[i]) > 0){
                ++i;
                if (i === set.length) {
                    advance(resolve);
                    return false;
                }
            }
            if (compare(key, set[i]) === 0) return true;
            else {
                advance(function() {
                    cursor.continue(set[i]);
                });
                return false;
            }
        });
        return c;
    };
    WhereClause.prototype.notEqual = function(value) {
        return this.inAnyRange([
            [
                $2f895839ac78ac6c$var$minKey,
                value
            ],
            [
                value,
                this.db._maxKey
            ]
        ], {
            includeLowers: false,
            includeUppers: false
        });
    };
    WhereClause.prototype.noneOf = function() {
        var set = $2f895839ac78ac6c$var$getArrayOf.apply($2f895839ac78ac6c$var$NO_CHAR_ARRAY, arguments);
        if (set.length === 0) return new this.Collection(this);
        try {
            set.sort(this._ascending);
        } catch (e) {
            return $2f895839ac78ac6c$var$fail(this, $2f895839ac78ac6c$var$INVALID_KEY_ARGUMENT);
        }
        var ranges = set.reduce(function(res, val) {
            return res ? res.concat([
                [
                    res[res.length - 1][1],
                    val
                ]
            ]) : [
                [
                    $2f895839ac78ac6c$var$minKey,
                    val
                ]
            ];
        }, null);
        ranges.push([
            set[set.length - 1],
            this.db._maxKey
        ]);
        return this.inAnyRange(ranges, {
            includeLowers: false,
            includeUppers: false
        });
    };
    WhereClause.prototype.inAnyRange = function(ranges, options) {
        var _this = this;
        var cmp = this._cmp, ascending = this._ascending, descending = this._descending, min = this._min, max = this._max;
        if (ranges.length === 0) return $2f895839ac78ac6c$var$emptyCollection(this);
        if (!ranges.every(function(range) {
            return range[0] !== undefined && range[1] !== undefined && ascending(range[0], range[1]) <= 0;
        })) return $2f895839ac78ac6c$var$fail(this, "First argument to inAnyRange() must be an Array of two-value Arrays [lower,upper] where upper must not be lower than lower", $2f895839ac78ac6c$var$exceptions.InvalidArgument);
        var includeLowers = !options || options.includeLowers !== false;
        var includeUppers = options && options.includeUppers === true;
        function addRange(ranges, newRange) {
            var i = 0, l = ranges.length;
            for(; i < l; ++i){
                var range = ranges[i];
                if (cmp(newRange[0], range[1]) < 0 && cmp(newRange[1], range[0]) > 0) {
                    range[0] = min(range[0], newRange[0]);
                    range[1] = max(range[1], newRange[1]);
                    break;
                }
            }
            if (i === l) ranges.push(newRange);
            return ranges;
        }
        var sortDirection = ascending;
        function rangeSorter(a, b) {
            return sortDirection(a[0], b[0]);
        }
        var set;
        try {
            set = ranges.reduce(addRange, []);
            set.sort(rangeSorter);
        } catch (ex) {
            return $2f895839ac78ac6c$var$fail(this, $2f895839ac78ac6c$var$INVALID_KEY_ARGUMENT);
        }
        var rangePos = 0;
        var keyIsBeyondCurrentEntry = includeUppers ? function(key) {
            return ascending(key, set[rangePos][1]) > 0;
        } : function(key) {
            return ascending(key, set[rangePos][1]) >= 0;
        };
        var keyIsBeforeCurrentEntry = includeLowers ? function(key) {
            return descending(key, set[rangePos][0]) > 0;
        } : function(key) {
            return descending(key, set[rangePos][0]) >= 0;
        };
        function keyWithinCurrentRange(key) {
            return !keyIsBeyondCurrentEntry(key) && !keyIsBeforeCurrentEntry(key);
        }
        var checkKey = keyIsBeyondCurrentEntry;
        var c = new this.Collection(this, function() {
            return $2f895839ac78ac6c$var$createRange(set[0][0], set[set.length - 1][1], !includeLowers, !includeUppers);
        });
        c._ondirectionchange = function(direction) {
            if (direction === "next") {
                checkKey = keyIsBeyondCurrentEntry;
                sortDirection = ascending;
            } else {
                checkKey = keyIsBeforeCurrentEntry;
                sortDirection = descending;
            }
            set.sort(rangeSorter);
        };
        c._addAlgorithm(function(cursor, advance, resolve) {
            var key = cursor.key;
            while(checkKey(key)){
                ++rangePos;
                if (rangePos === set.length) {
                    advance(resolve);
                    return false;
                }
            }
            if (keyWithinCurrentRange(key)) return true;
            else if (_this._cmp(key, set[rangePos][1]) === 0 || _this._cmp(key, set[rangePos][0]) === 0) return false;
            else {
                advance(function() {
                    if (sortDirection === ascending) cursor.continue(set[rangePos][0]);
                    else cursor.continue(set[rangePos][1]);
                });
                return false;
            }
        });
        return c;
    };
    WhereClause.prototype.startsWithAnyOf = function() {
        var set = $2f895839ac78ac6c$var$getArrayOf.apply($2f895839ac78ac6c$var$NO_CHAR_ARRAY, arguments);
        if (!set.every(function(s) {
            return typeof s === "string";
        })) return $2f895839ac78ac6c$var$fail(this, "startsWithAnyOf() only works with strings");
        if (set.length === 0) return $2f895839ac78ac6c$var$emptyCollection(this);
        return this.inAnyRange(set.map(function(str) {
            return [
                str,
                str + $2f895839ac78ac6c$var$maxString
            ];
        }));
    };
    return WhereClause;
}();
function $2f895839ac78ac6c$var$createWhereClauseConstructor(db) {
    return $2f895839ac78ac6c$var$makeClassConstructor($2f895839ac78ac6c$var$WhereClause.prototype, function WhereClause(table, index, orCollection) {
        this.db = db;
        this._ctx = {
            table: table,
            index: index === ":id" ? null : index,
            or: orCollection
        };
        var indexedDB1 = db._deps.indexedDB;
        if (!indexedDB1) throw new $2f895839ac78ac6c$var$exceptions.MissingAPI();
        this._cmp = this._ascending = indexedDB1.cmp.bind(indexedDB1);
        this._descending = function(a, b) {
            return indexedDB1.cmp(b, a);
        };
        this._max = function(a, b) {
            return indexedDB1.cmp(a, b) > 0 ? a : b;
        };
        this._min = function(a, b) {
            return indexedDB1.cmp(a, b) < 0 ? a : b;
        };
        this._IDBKeyRange = db._deps.IDBKeyRange;
    });
}
function $2f895839ac78ac6c$var$eventRejectHandler(reject) {
    return $2f895839ac78ac6c$var$wrap(function(event) {
        $2f895839ac78ac6c$var$preventDefault(event);
        reject(event.target.error);
        return false;
    });
}
function $2f895839ac78ac6c$var$preventDefault(event) {
    if (event.stopPropagation) event.stopPropagation();
    if (event.preventDefault) event.preventDefault();
}
var $2f895839ac78ac6c$var$DEXIE_STORAGE_MUTATED_EVENT_NAME = "storagemutated";
var $2f895839ac78ac6c$var$STORAGE_MUTATED_DOM_EVENT_NAME = "x-storagemutated-1";
var $2f895839ac78ac6c$var$globalEvents = $2f895839ac78ac6c$var$Events(null, $2f895839ac78ac6c$var$DEXIE_STORAGE_MUTATED_EVENT_NAME);
var $2f895839ac78ac6c$var$Transaction = function() {
    function Transaction() {}
    Transaction.prototype._lock = function() {
        $2f895839ac78ac6c$var$assert(!$2f895839ac78ac6c$var$PSD.global);
        ++this._reculock;
        if (this._reculock === 1 && !$2f895839ac78ac6c$var$PSD.global) $2f895839ac78ac6c$var$PSD.lockOwnerFor = this;
        return this;
    };
    Transaction.prototype._unlock = function() {
        $2f895839ac78ac6c$var$assert(!$2f895839ac78ac6c$var$PSD.global);
        if (--this._reculock === 0) {
            if (!$2f895839ac78ac6c$var$PSD.global) $2f895839ac78ac6c$var$PSD.lockOwnerFor = null;
            while(this._blockedFuncs.length > 0 && !this._locked()){
                var fnAndPSD = this._blockedFuncs.shift();
                try {
                    $2f895839ac78ac6c$var$usePSD(fnAndPSD[1], fnAndPSD[0]);
                } catch (e) {}
            }
        }
        return this;
    };
    Transaction.prototype._locked = function() {
        return this._reculock && $2f895839ac78ac6c$var$PSD.lockOwnerFor !== this;
    };
    Transaction.prototype.create = function(idbtrans) {
        var _this = this;
        if (!this.mode) return this;
        var idbdb = this.db.idbdb;
        var dbOpenError = this.db._state.dbOpenError;
        $2f895839ac78ac6c$var$assert(!this.idbtrans);
        if (!idbtrans && !idbdb) switch(dbOpenError && dbOpenError.name){
            case "DatabaseClosedError":
                throw new $2f895839ac78ac6c$var$exceptions.DatabaseClosed(dbOpenError);
            case "MissingAPIError":
                throw new $2f895839ac78ac6c$var$exceptions.MissingAPI(dbOpenError.message, dbOpenError);
            default:
                throw new $2f895839ac78ac6c$var$exceptions.OpenFailed(dbOpenError);
        }
        if (!this.active) throw new $2f895839ac78ac6c$var$exceptions.TransactionInactive();
        $2f895839ac78ac6c$var$assert(this._completion._state === null);
        idbtrans = this.idbtrans = idbtrans || (this.db.core ? this.db.core.transaction(this.storeNames, this.mode, {
            durability: this.chromeTransactionDurability
        }) : idbdb.transaction(this.storeNames, this.mode, {
            durability: this.chromeTransactionDurability
        }));
        idbtrans.onerror = $2f895839ac78ac6c$var$wrap(function(ev) {
            $2f895839ac78ac6c$var$preventDefault(ev);
            _this._reject(idbtrans.error);
        });
        idbtrans.onabort = $2f895839ac78ac6c$var$wrap(function(ev) {
            $2f895839ac78ac6c$var$preventDefault(ev);
            _this.active && _this._reject(new $2f895839ac78ac6c$var$exceptions.Abort(idbtrans.error));
            _this.active = false;
            _this.on("abort").fire(ev);
        });
        idbtrans.oncomplete = $2f895839ac78ac6c$var$wrap(function() {
            _this.active = false;
            _this._resolve();
            if ("mutatedParts" in idbtrans) $2f895839ac78ac6c$var$globalEvents.storagemutated.fire(idbtrans["mutatedParts"]);
        });
        return this;
    };
    Transaction.prototype._promise = function(mode, fn, bWriteLock) {
        var _this = this;
        if (mode === "readwrite" && this.mode !== "readwrite") return $2f895839ac78ac6c$var$rejection(new $2f895839ac78ac6c$var$exceptions.ReadOnly("Transaction is readonly"));
        if (!this.active) return $2f895839ac78ac6c$var$rejection(new $2f895839ac78ac6c$var$exceptions.TransactionInactive());
        if (this._locked()) return new $2f895839ac78ac6c$var$DexiePromise(function(resolve, reject) {
            _this._blockedFuncs.push([
                function() {
                    _this._promise(mode, fn, bWriteLock).then(resolve, reject);
                },
                $2f895839ac78ac6c$var$PSD
            ]);
        });
        else if (bWriteLock) return $2f895839ac78ac6c$var$newScope(function() {
            var p = new $2f895839ac78ac6c$var$DexiePromise(function(resolve, reject) {
                _this._lock();
                var rv = fn(resolve, reject, _this);
                if (rv && rv.then) rv.then(resolve, reject);
            });
            p.finally(function() {
                return _this._unlock();
            });
            p._lib = true;
            return p;
        });
        else {
            var p = new $2f895839ac78ac6c$var$DexiePromise(function(resolve, reject) {
                var rv = fn(resolve, reject, _this);
                if (rv && rv.then) rv.then(resolve, reject);
            });
            p._lib = true;
            return p;
        }
    };
    Transaction.prototype._root = function() {
        return this.parent ? this.parent._root() : this;
    };
    Transaction.prototype.waitFor = function(promiseLike) {
        var root = this._root();
        var promise = $2f895839ac78ac6c$var$DexiePromise.resolve(promiseLike);
        if (root._waitingFor) root._waitingFor = root._waitingFor.then(function() {
            return promise;
        });
        else {
            root._waitingFor = promise;
            root._waitingQueue = [];
            var store = root.idbtrans.objectStore(root.storeNames[0]);
            (function spin() {
                ++root._spinCount;
                while(root._waitingQueue.length)root._waitingQueue.shift()();
                if (root._waitingFor) store.get(-Infinity).onsuccess = spin;
            })();
        }
        var currentWaitPromise = root._waitingFor;
        return new $2f895839ac78ac6c$var$DexiePromise(function(resolve, reject) {
            promise.then(function(res) {
                return root._waitingQueue.push($2f895839ac78ac6c$var$wrap(resolve.bind(null, res)));
            }, function(err) {
                return root._waitingQueue.push($2f895839ac78ac6c$var$wrap(reject.bind(null, err)));
            }).finally(function() {
                if (root._waitingFor === currentWaitPromise) root._waitingFor = null;
            });
        });
    };
    Transaction.prototype.abort = function() {
        if (this.active) {
            this.active = false;
            if (this.idbtrans) this.idbtrans.abort();
            this._reject(new $2f895839ac78ac6c$var$exceptions.Abort());
        }
    };
    Transaction.prototype.table = function(tableName) {
        var memoizedTables = this._memoizedTables || (this._memoizedTables = {});
        if ($2f895839ac78ac6c$var$hasOwn(memoizedTables, tableName)) return memoizedTables[tableName];
        var tableSchema = this.schema[tableName];
        if (!tableSchema) throw new $2f895839ac78ac6c$var$exceptions.NotFound("Table " + tableName + " not part of transaction");
        var transactionBoundTable = new this.db.Table(tableName, tableSchema, this);
        transactionBoundTable.core = this.db.core.table(tableName);
        memoizedTables[tableName] = transactionBoundTable;
        return transactionBoundTable;
    };
    return Transaction;
}();
function $2f895839ac78ac6c$var$createTransactionConstructor(db) {
    return $2f895839ac78ac6c$var$makeClassConstructor($2f895839ac78ac6c$var$Transaction.prototype, function Transaction(mode, storeNames, dbschema, chromeTransactionDurability, parent) {
        var _this = this;
        this.db = db;
        this.mode = mode;
        this.storeNames = storeNames;
        this.schema = dbschema;
        this.chromeTransactionDurability = chromeTransactionDurability;
        this.idbtrans = null;
        this.on = $2f895839ac78ac6c$var$Events(this, "complete", "error", "abort");
        this.parent = parent || null;
        this.active = true;
        this._reculock = 0;
        this._blockedFuncs = [];
        this._resolve = null;
        this._reject = null;
        this._waitingFor = null;
        this._waitingQueue = null;
        this._spinCount = 0;
        this._completion = new $2f895839ac78ac6c$var$DexiePromise(function(resolve, reject) {
            _this._resolve = resolve;
            _this._reject = reject;
        });
        this._completion.then(function() {
            _this.active = false;
            _this.on.complete.fire();
        }, function(e) {
            var wasActive = _this.active;
            _this.active = false;
            _this.on.error.fire(e);
            _this.parent ? _this.parent._reject(e) : wasActive && _this.idbtrans && _this.idbtrans.abort();
            return $2f895839ac78ac6c$var$rejection(e);
        });
    });
}
function $2f895839ac78ac6c$var$createIndexSpec(name, keyPath, unique, multi, auto, compound, isPrimKey) {
    return {
        name: name,
        keyPath: keyPath,
        unique: unique,
        multi: multi,
        auto: auto,
        compound: compound,
        src: (unique && !isPrimKey ? "&" : "") + (multi ? "*" : "") + (auto ? "++" : "") + $2f895839ac78ac6c$var$nameFromKeyPath(keyPath)
    };
}
function $2f895839ac78ac6c$var$nameFromKeyPath(keyPath) {
    return typeof keyPath === "string" ? keyPath : keyPath ? "[" + [].join.call(keyPath, "+") + "]" : "";
}
function $2f895839ac78ac6c$var$createTableSchema(name, primKey, indexes) {
    return {
        name: name,
        primKey: primKey,
        indexes: indexes,
        mappedClass: null,
        idxByName: $2f895839ac78ac6c$var$arrayToObject(indexes, function(index) {
            return [
                index.name,
                index
            ];
        })
    };
}
function $2f895839ac78ac6c$var$safariMultiStoreFix(storeNames) {
    return storeNames.length === 1 ? storeNames[0] : storeNames;
}
var $2f895839ac78ac6c$var$getMaxKey = function(IdbKeyRange) {
    try {
        IdbKeyRange.only([
            []
        ]);
        $2f895839ac78ac6c$var$getMaxKey = function() {
            return [
                []
            ];
        };
        return [
            []
        ];
    } catch (e) {
        $2f895839ac78ac6c$var$getMaxKey = function() {
            return $2f895839ac78ac6c$var$maxString;
        };
        return $2f895839ac78ac6c$var$maxString;
    }
};
function $2f895839ac78ac6c$var$getKeyExtractor(keyPath) {
    if (keyPath == null) return function() {
        return undefined;
    };
    else if (typeof keyPath === "string") return $2f895839ac78ac6c$var$getSinglePathKeyExtractor(keyPath);
    else return function(obj) {
        return $2f895839ac78ac6c$var$getByKeyPath(obj, keyPath);
    };
}
function $2f895839ac78ac6c$var$getSinglePathKeyExtractor(keyPath) {
    var split = keyPath.split(".");
    if (split.length === 1) return function(obj) {
        return obj[keyPath];
    };
    else return function(obj) {
        return $2f895839ac78ac6c$var$getByKeyPath(obj, keyPath);
    };
}
function $2f895839ac78ac6c$var$arrayify(arrayLike) {
    return [].slice.call(arrayLike);
}
var $2f895839ac78ac6c$var$_id_counter = 0;
function $2f895839ac78ac6c$var$getKeyPathAlias(keyPath) {
    return keyPath == null ? ":id" : typeof keyPath === "string" ? keyPath : "[" + keyPath.join("+") + "]";
}
function $2f895839ac78ac6c$var$createDBCore(db, IdbKeyRange, tmpTrans) {
    function extractSchema(db, trans) {
        var tables = $2f895839ac78ac6c$var$arrayify(db.objectStoreNames);
        return {
            schema: {
                name: db.name,
                tables: tables.map(function(table) {
                    return trans.objectStore(table);
                }).map(function(store) {
                    var keyPath = store.keyPath, autoIncrement = store.autoIncrement;
                    var compound = $2f895839ac78ac6c$var$isArray(keyPath);
                    var outbound = keyPath == null;
                    var indexByKeyPath = {};
                    var result = {
                        name: store.name,
                        primaryKey: {
                            name: null,
                            isPrimaryKey: true,
                            outbound: outbound,
                            compound: compound,
                            keyPath: keyPath,
                            autoIncrement: autoIncrement,
                            unique: true,
                            extractKey: $2f895839ac78ac6c$var$getKeyExtractor(keyPath)
                        },
                        indexes: $2f895839ac78ac6c$var$arrayify(store.indexNames).map(function(indexName) {
                            return store.index(indexName);
                        }).map(function(index) {
                            var name = index.name, unique = index.unique, multiEntry = index.multiEntry, keyPath = index.keyPath;
                            var compound = $2f895839ac78ac6c$var$isArray(keyPath);
                            var result = {
                                name: name,
                                compound: compound,
                                keyPath: keyPath,
                                unique: unique,
                                multiEntry: multiEntry,
                                extractKey: $2f895839ac78ac6c$var$getKeyExtractor(keyPath)
                            };
                            indexByKeyPath[$2f895839ac78ac6c$var$getKeyPathAlias(keyPath)] = result;
                            return result;
                        }),
                        getIndexByKeyPath: function(keyPath) {
                            return indexByKeyPath[$2f895839ac78ac6c$var$getKeyPathAlias(keyPath)];
                        }
                    };
                    indexByKeyPath[":id"] = result.primaryKey;
                    if (keyPath != null) indexByKeyPath[$2f895839ac78ac6c$var$getKeyPathAlias(keyPath)] = result.primaryKey;
                    return result;
                })
            },
            hasGetAll: tables.length > 0 && "getAll" in trans.objectStore(tables[0]) && !(typeof navigator !== "undefined" && /Safari/.test(navigator.userAgent) && !/(Chrome\/|Edge\/)/.test(navigator.userAgent) && [].concat(navigator.userAgent.match(/Safari\/(\d*)/))[1] < 604)
        };
    }
    function makeIDBKeyRange(range) {
        if (range.type === 3) return null;
        if (range.type === 4) throw new Error("Cannot convert never type to IDBKeyRange");
        var lower = range.lower, upper = range.upper, lowerOpen = range.lowerOpen, upperOpen = range.upperOpen;
        var idbRange = lower === undefined ? upper === undefined ? null : IdbKeyRange.upperBound(upper, !!upperOpen) : upper === undefined ? IdbKeyRange.lowerBound(lower, !!lowerOpen) : IdbKeyRange.bound(lower, upper, !!lowerOpen, !!upperOpen);
        return idbRange;
    }
    function createDbCoreTable(tableSchema) {
        var tableName = tableSchema.name;
        function mutate(_a) {
            var trans = _a.trans, type = _a.type, keys = _a.keys, values = _a.values, range = _a.range;
            return new Promise(function(resolve, reject) {
                resolve = $2f895839ac78ac6c$var$wrap(resolve);
                var store = trans.objectStore(tableName);
                var outbound = store.keyPath == null;
                var isAddOrPut = type === "put" || type === "add";
                if (!isAddOrPut && type !== "delete" && type !== "deleteRange") throw new Error("Invalid operation type: " + type);
                var length = (keys || values || {
                    length: 1
                }).length;
                if (keys && values && keys.length !== values.length) throw new Error("Given keys array must have same length as given values array.");
                if (length === 0) return resolve({
                    numFailures: 0,
                    failures: {},
                    results: [],
                    lastResult: undefined
                });
                var req;
                var reqs = [];
                var failures = [];
                var numFailures = 0;
                var errorHandler = function(event) {
                    ++numFailures;
                    $2f895839ac78ac6c$var$preventDefault(event);
                };
                if (type === "deleteRange") {
                    if (range.type === 4) return resolve({
                        numFailures: numFailures,
                        failures: failures,
                        results: [],
                        lastResult: undefined
                    });
                    if (range.type === 3) reqs.push(req = store.clear());
                    else reqs.push(req = store.delete(makeIDBKeyRange(range)));
                } else {
                    var _a = isAddOrPut ? outbound ? [
                        values,
                        keys
                    ] : [
                        values,
                        null
                    ] : [
                        keys,
                        null
                    ], args1 = _a[0], args2 = _a[1];
                    if (isAddOrPut) for(var i = 0; i < length; ++i){
                        reqs.push(req = args2 && args2[i] !== undefined ? store[type](args1[i], args2[i]) : store[type](args1[i]));
                        req.onerror = errorHandler;
                    }
                    else for(var i = 0; i < length; ++i){
                        reqs.push(req = store[type](args1[i]));
                        req.onerror = errorHandler;
                    }
                }
                var done = function(event) {
                    var lastResult = event.target.result;
                    reqs.forEach(function(req, i) {
                        return req.error != null && (failures[i] = req.error);
                    });
                    resolve({
                        numFailures: numFailures,
                        failures: failures,
                        results: type === "delete" ? keys : reqs.map(function(req) {
                            return req.result;
                        }),
                        lastResult: lastResult
                    });
                };
                req.onerror = function(event) {
                    errorHandler(event);
                    done(event);
                };
                req.onsuccess = done;
            });
        }
        function openCursor(_a) {
            var trans = _a.trans, values = _a.values, query = _a.query, reverse = _a.reverse, unique = _a.unique;
            return new Promise(function(resolve, reject) {
                resolve = $2f895839ac78ac6c$var$wrap(resolve);
                var index = query.index, range = query.range;
                var store = trans.objectStore(tableName);
                var source = index.isPrimaryKey ? store : store.index(index.name);
                var direction = reverse ? unique ? "prevunique" : "prev" : unique ? "nextunique" : "next";
                var req = values || !("openKeyCursor" in source) ? source.openCursor(makeIDBKeyRange(range), direction) : source.openKeyCursor(makeIDBKeyRange(range), direction);
                req.onerror = $2f895839ac78ac6c$var$eventRejectHandler(reject);
                req.onsuccess = $2f895839ac78ac6c$var$wrap(function(ev) {
                    var cursor = req.result;
                    if (!cursor) {
                        resolve(null);
                        return;
                    }
                    cursor.___id = ++$2f895839ac78ac6c$var$_id_counter;
                    cursor.done = false;
                    var _cursorContinue = cursor.continue.bind(cursor);
                    var _cursorContinuePrimaryKey = cursor.continuePrimaryKey;
                    if (_cursorContinuePrimaryKey) _cursorContinuePrimaryKey = _cursorContinuePrimaryKey.bind(cursor);
                    var _cursorAdvance = cursor.advance.bind(cursor);
                    var doThrowCursorIsNotStarted = function() {
                        throw new Error("Cursor not started");
                    };
                    var doThrowCursorIsStopped = function() {
                        throw new Error("Cursor not stopped");
                    };
                    cursor.trans = trans;
                    cursor.stop = cursor.continue = cursor.continuePrimaryKey = cursor.advance = doThrowCursorIsNotStarted;
                    cursor.fail = $2f895839ac78ac6c$var$wrap(reject);
                    cursor.next = function() {
                        var _this = this;
                        var gotOne = 1;
                        return this.start(function() {
                            return gotOne-- ? _this.continue() : _this.stop();
                        }).then(function() {
                            return _this;
                        });
                    };
                    cursor.start = function(callback) {
                        var iterationPromise = new Promise(function(resolveIteration, rejectIteration) {
                            resolveIteration = $2f895839ac78ac6c$var$wrap(resolveIteration);
                            req.onerror = $2f895839ac78ac6c$var$eventRejectHandler(rejectIteration);
                            cursor.fail = rejectIteration;
                            cursor.stop = function(value) {
                                cursor.stop = cursor.continue = cursor.continuePrimaryKey = cursor.advance = doThrowCursorIsStopped;
                                resolveIteration(value);
                            };
                        });
                        var guardedCallback = function() {
                            if (req.result) try {
                                callback();
                            } catch (err) {
                                cursor.fail(err);
                            }
                            else {
                                cursor.done = true;
                                cursor.start = function() {
                                    throw new Error("Cursor behind last entry");
                                };
                                cursor.stop();
                            }
                        };
                        req.onsuccess = $2f895839ac78ac6c$var$wrap(function(ev) {
                            req.onsuccess = guardedCallback;
                            guardedCallback();
                        });
                        cursor.continue = _cursorContinue;
                        cursor.continuePrimaryKey = _cursorContinuePrimaryKey;
                        cursor.advance = _cursorAdvance;
                        guardedCallback();
                        return iterationPromise;
                    };
                    resolve(cursor);
                }, reject);
            });
        }
        function query(hasGetAll) {
            return function(request) {
                return new Promise(function(resolve, reject) {
                    resolve = $2f895839ac78ac6c$var$wrap(resolve);
                    var trans = request.trans, values = request.values, limit = request.limit, query = request.query;
                    var nonInfinitLimit = limit === Infinity ? undefined : limit;
                    var index = query.index, range = query.range;
                    var store = trans.objectStore(tableName);
                    var source = index.isPrimaryKey ? store : store.index(index.name);
                    var idbKeyRange = makeIDBKeyRange(range);
                    if (limit === 0) return resolve({
                        result: []
                    });
                    if (hasGetAll) {
                        var req = values ? source.getAll(idbKeyRange, nonInfinitLimit) : source.getAllKeys(idbKeyRange, nonInfinitLimit);
                        req.onsuccess = function(event) {
                            return resolve({
                                result: event.target.result
                            });
                        };
                        req.onerror = $2f895839ac78ac6c$var$eventRejectHandler(reject);
                    } else {
                        var count_1 = 0;
                        var req_1 = values || !("openKeyCursor" in source) ? source.openCursor(idbKeyRange) : source.openKeyCursor(idbKeyRange);
                        var result_1 = [];
                        req_1.onsuccess = function(event) {
                            var cursor = req_1.result;
                            if (!cursor) return resolve({
                                result: result_1
                            });
                            result_1.push(values ? cursor.value : cursor.primaryKey);
                            if (++count_1 === limit) return resolve({
                                result: result_1
                            });
                            cursor.continue();
                        };
                        req_1.onerror = $2f895839ac78ac6c$var$eventRejectHandler(reject);
                    }
                });
            };
        }
        return {
            name: tableName,
            schema: tableSchema,
            mutate: mutate,
            getMany: function(_a) {
                var trans = _a.trans, keys = _a.keys;
                return new Promise(function(resolve, reject) {
                    resolve = $2f895839ac78ac6c$var$wrap(resolve);
                    var store = trans.objectStore(tableName);
                    var length = keys.length;
                    var result = new Array(length);
                    var keyCount = 0;
                    var callbackCount = 0;
                    var req;
                    var successHandler = function(event) {
                        var req = event.target;
                        result[req._pos] = req.result;
                        if (++callbackCount === keyCount) resolve(result);
                    };
                    var errorHandler = $2f895839ac78ac6c$var$eventRejectHandler(reject);
                    for(var i = 0; i < length; ++i){
                        var key = keys[i];
                        if (key != null) {
                            req = store.get(keys[i]);
                            req._pos = i;
                            req.onsuccess = successHandler;
                            req.onerror = errorHandler;
                            ++keyCount;
                        }
                    }
                    if (keyCount === 0) resolve(result);
                });
            },
            get: function(_a) {
                var trans = _a.trans, key = _a.key;
                return new Promise(function(resolve, reject) {
                    resolve = $2f895839ac78ac6c$var$wrap(resolve);
                    var store = trans.objectStore(tableName);
                    var req = store.get(key);
                    req.onsuccess = function(event) {
                        return resolve(event.target.result);
                    };
                    req.onerror = $2f895839ac78ac6c$var$eventRejectHandler(reject);
                });
            },
            query: query(hasGetAll),
            openCursor: openCursor,
            count: function(_a) {
                var query = _a.query, trans = _a.trans;
                var index = query.index, range = query.range;
                return new Promise(function(resolve, reject) {
                    var store = trans.objectStore(tableName);
                    var source = index.isPrimaryKey ? store : store.index(index.name);
                    var idbKeyRange = makeIDBKeyRange(range);
                    var req = idbKeyRange ? source.count(idbKeyRange) : source.count();
                    req.onsuccess = $2f895839ac78ac6c$var$wrap(function(ev) {
                        return resolve(ev.target.result);
                    });
                    req.onerror = $2f895839ac78ac6c$var$eventRejectHandler(reject);
                });
            }
        };
    }
    var _a = extractSchema(db, tmpTrans), schema = _a.schema, hasGetAll = _a.hasGetAll;
    var tables = schema.tables.map(function(tableSchema) {
        return createDbCoreTable(tableSchema);
    });
    var tableMap = {};
    tables.forEach(function(table) {
        return tableMap[table.name] = table;
    });
    return {
        stack: "dbcore",
        transaction: db.transaction.bind(db),
        table: function(name) {
            var result = tableMap[name];
            if (!result) throw new Error("Table '" + name + "' not found");
            return tableMap[name];
        },
        MIN_KEY: -Infinity,
        MAX_KEY: $2f895839ac78ac6c$var$getMaxKey(IdbKeyRange),
        schema: schema
    };
}
function $2f895839ac78ac6c$var$createMiddlewareStack(stackImpl, middlewares) {
    return middlewares.reduce(function(down, _a) {
        var create = _a.create;
        return $2f895839ac78ac6c$var$__assign($2f895839ac78ac6c$var$__assign({}, down), create(down));
    }, stackImpl);
}
function $2f895839ac78ac6c$var$createMiddlewareStacks(middlewares, idbdb, _a, tmpTrans) {
    var IDBKeyRange = _a.IDBKeyRange;
    _a.indexedDB;
    var dbcore = $2f895839ac78ac6c$var$createMiddlewareStack($2f895839ac78ac6c$var$createDBCore(idbdb, IDBKeyRange, tmpTrans), middlewares.dbcore);
    return {
        dbcore: dbcore
    };
}
function $2f895839ac78ac6c$var$generateMiddlewareStacks(_a, tmpTrans) {
    var db = _a._novip;
    var idbdb = tmpTrans.db;
    var stacks = $2f895839ac78ac6c$var$createMiddlewareStacks(db._middlewares, idbdb, db._deps, tmpTrans);
    db.core = stacks.dbcore;
    db.tables.forEach(function(table) {
        var tableName = table.name;
        if (db.core.schema.tables.some(function(tbl) {
            return tbl.name === tableName;
        })) {
            table.core = db.core.table(tableName);
            if (db[tableName] instanceof db.Table) db[tableName].core = table.core;
        }
    });
}
function $2f895839ac78ac6c$var$setApiOnPlace(_a, objs, tableNames, dbschema) {
    var db = _a._novip;
    tableNames.forEach(function(tableName) {
        var schema = dbschema[tableName];
        objs.forEach(function(obj) {
            var propDesc = $2f895839ac78ac6c$var$getPropertyDescriptor(obj, tableName);
            if (!propDesc || "value" in propDesc && propDesc.value === undefined) {
                if (obj === db.Transaction.prototype || obj instanceof db.Transaction) $2f895839ac78ac6c$var$setProp(obj, tableName, {
                    get: function() {
                        return this.table(tableName);
                    },
                    set: function(value) {
                        $2f895839ac78ac6c$var$defineProperty(this, tableName, {
                            value: value,
                            writable: true,
                            configurable: true,
                            enumerable: true
                        });
                    }
                });
                else obj[tableName] = new db.Table(tableName, schema);
            }
        });
    });
}
function $2f895839ac78ac6c$var$removeTablesApi(_a, objs) {
    var db = _a._novip;
    objs.forEach(function(obj) {
        for(var key in obj)if (obj[key] instanceof db.Table) delete obj[key];
    });
}
function $2f895839ac78ac6c$var$lowerVersionFirst(a, b) {
    return a._cfg.version - b._cfg.version;
}
function $2f895839ac78ac6c$var$runUpgraders(db, oldVersion, idbUpgradeTrans, reject) {
    var globalSchema = db._dbSchema;
    var trans = db._createTransaction("readwrite", db._storeNames, globalSchema);
    trans.create(idbUpgradeTrans);
    trans._completion.catch(reject);
    var rejectTransaction = trans._reject.bind(trans);
    var transless = $2f895839ac78ac6c$var$PSD.transless || $2f895839ac78ac6c$var$PSD;
    $2f895839ac78ac6c$var$newScope(function() {
        $2f895839ac78ac6c$var$PSD.trans = trans;
        $2f895839ac78ac6c$var$PSD.transless = transless;
        if (oldVersion === 0) {
            $2f895839ac78ac6c$var$keys(globalSchema).forEach(function(tableName) {
                $2f895839ac78ac6c$var$createTable(idbUpgradeTrans, tableName, globalSchema[tableName].primKey, globalSchema[tableName].indexes);
            });
            $2f895839ac78ac6c$var$generateMiddlewareStacks(db, idbUpgradeTrans);
            $2f895839ac78ac6c$var$DexiePromise.follow(function() {
                return db.on.populate.fire(trans);
            }).catch(rejectTransaction);
        } else $2f895839ac78ac6c$var$updateTablesAndIndexes(db, oldVersion, trans, idbUpgradeTrans).catch(rejectTransaction);
    });
}
function $2f895839ac78ac6c$var$updateTablesAndIndexes(_a, oldVersion, trans, idbUpgradeTrans) {
    var db = _a._novip;
    var queue = [];
    var versions = db._versions;
    var globalSchema = db._dbSchema = $2f895839ac78ac6c$var$buildGlobalSchema(db, db.idbdb, idbUpgradeTrans);
    var anyContentUpgraderHasRun = false;
    var versToRun = versions.filter(function(v) {
        return v._cfg.version >= oldVersion;
    });
    versToRun.forEach(function(version) {
        queue.push(function() {
            var oldSchema = globalSchema;
            var newSchema = version._cfg.dbschema;
            $2f895839ac78ac6c$var$adjustToExistingIndexNames(db, oldSchema, idbUpgradeTrans);
            $2f895839ac78ac6c$var$adjustToExistingIndexNames(db, newSchema, idbUpgradeTrans);
            globalSchema = db._dbSchema = newSchema;
            var diff = $2f895839ac78ac6c$var$getSchemaDiff(oldSchema, newSchema);
            diff.add.forEach(function(tuple) {
                $2f895839ac78ac6c$var$createTable(idbUpgradeTrans, tuple[0], tuple[1].primKey, tuple[1].indexes);
            });
            diff.change.forEach(function(change) {
                if (change.recreate) throw new $2f895839ac78ac6c$var$exceptions.Upgrade("Not yet support for changing primary key");
                else {
                    var store_1 = idbUpgradeTrans.objectStore(change.name);
                    change.add.forEach(function(idx) {
                        return $2f895839ac78ac6c$var$addIndex(store_1, idx);
                    });
                    change.change.forEach(function(idx) {
                        store_1.deleteIndex(idx.name);
                        $2f895839ac78ac6c$var$addIndex(store_1, idx);
                    });
                    change.del.forEach(function(idxName) {
                        return store_1.deleteIndex(idxName);
                    });
                }
            });
            var contentUpgrade = version._cfg.contentUpgrade;
            if (contentUpgrade && version._cfg.version > oldVersion) {
                $2f895839ac78ac6c$var$generateMiddlewareStacks(db, idbUpgradeTrans);
                trans._memoizedTables = {};
                anyContentUpgraderHasRun = true;
                var upgradeSchema_1 = $2f895839ac78ac6c$var$shallowClone(newSchema);
                diff.del.forEach(function(table) {
                    upgradeSchema_1[table] = oldSchema[table];
                });
                $2f895839ac78ac6c$var$removeTablesApi(db, [
                    db.Transaction.prototype
                ]);
                $2f895839ac78ac6c$var$setApiOnPlace(db, [
                    db.Transaction.prototype
                ], $2f895839ac78ac6c$var$keys(upgradeSchema_1), upgradeSchema_1);
                trans.schema = upgradeSchema_1;
                var contentUpgradeIsAsync_1 = $2f895839ac78ac6c$var$isAsyncFunction(contentUpgrade);
                if (contentUpgradeIsAsync_1) $2f895839ac78ac6c$var$incrementExpectedAwaits();
                var returnValue_1;
                var promiseFollowed = $2f895839ac78ac6c$var$DexiePromise.follow(function() {
                    returnValue_1 = contentUpgrade(trans);
                    if (returnValue_1) {
                        if (contentUpgradeIsAsync_1) {
                            var decrementor = $2f895839ac78ac6c$var$decrementExpectedAwaits.bind(null, null);
                            returnValue_1.then(decrementor, decrementor);
                        }
                    }
                });
                return returnValue_1 && typeof returnValue_1.then === "function" ? $2f895839ac78ac6c$var$DexiePromise.resolve(returnValue_1) : promiseFollowed.then(function() {
                    return returnValue_1;
                });
            }
        });
        queue.push(function(idbtrans) {
            if (!anyContentUpgraderHasRun || !$2f895839ac78ac6c$var$hasIEDeleteObjectStoreBug) {
                var newSchema = version._cfg.dbschema;
                $2f895839ac78ac6c$var$deleteRemovedTables(newSchema, idbtrans);
            }
            $2f895839ac78ac6c$var$removeTablesApi(db, [
                db.Transaction.prototype
            ]);
            $2f895839ac78ac6c$var$setApiOnPlace(db, [
                db.Transaction.prototype
            ], db._storeNames, db._dbSchema);
            trans.schema = db._dbSchema;
        });
    });
    function runQueue() {
        return queue.length ? $2f895839ac78ac6c$var$DexiePromise.resolve(queue.shift()(trans.idbtrans)).then(runQueue) : $2f895839ac78ac6c$var$DexiePromise.resolve();
    }
    return runQueue().then(function() {
        $2f895839ac78ac6c$var$createMissingTables(globalSchema, idbUpgradeTrans);
    });
}
function $2f895839ac78ac6c$var$getSchemaDiff(oldSchema, newSchema) {
    var diff = {
        del: [],
        add: [],
        change: []
    };
    var table;
    for(table in oldSchema)if (!newSchema[table]) diff.del.push(table);
    for(table in newSchema){
        var oldDef = oldSchema[table], newDef = newSchema[table];
        if (!oldDef) diff.add.push([
            table,
            newDef
        ]);
        else {
            var change = {
                name: table,
                def: newDef,
                recreate: false,
                del: [],
                add: [],
                change: []
            };
            if ("" + (oldDef.primKey.keyPath || "") !== "" + (newDef.primKey.keyPath || "") || oldDef.primKey.auto !== newDef.primKey.auto && !$2f895839ac78ac6c$var$isIEOrEdge) {
                change.recreate = true;
                diff.change.push(change);
            } else {
                var oldIndexes = oldDef.idxByName;
                var newIndexes = newDef.idxByName;
                var idxName = void 0;
                for(idxName in oldIndexes)if (!newIndexes[idxName]) change.del.push(idxName);
                for(idxName in newIndexes){
                    var oldIdx = oldIndexes[idxName], newIdx = newIndexes[idxName];
                    if (!oldIdx) change.add.push(newIdx);
                    else if (oldIdx.src !== newIdx.src) change.change.push(newIdx);
                }
                if (change.del.length > 0 || change.add.length > 0 || change.change.length > 0) diff.change.push(change);
            }
        }
    }
    return diff;
}
function $2f895839ac78ac6c$var$createTable(idbtrans, tableName, primKey, indexes) {
    var store = idbtrans.db.createObjectStore(tableName, primKey.keyPath ? {
        keyPath: primKey.keyPath,
        autoIncrement: primKey.auto
    } : {
        autoIncrement: primKey.auto
    });
    indexes.forEach(function(idx) {
        return $2f895839ac78ac6c$var$addIndex(store, idx);
    });
    return store;
}
function $2f895839ac78ac6c$var$createMissingTables(newSchema, idbtrans) {
    $2f895839ac78ac6c$var$keys(newSchema).forEach(function(tableName) {
        if (!idbtrans.db.objectStoreNames.contains(tableName)) $2f895839ac78ac6c$var$createTable(idbtrans, tableName, newSchema[tableName].primKey, newSchema[tableName].indexes);
    });
}
function $2f895839ac78ac6c$var$deleteRemovedTables(newSchema, idbtrans) {
    [].slice.call(idbtrans.db.objectStoreNames).forEach(function(storeName) {
        return newSchema[storeName] == null && idbtrans.db.deleteObjectStore(storeName);
    });
}
function $2f895839ac78ac6c$var$addIndex(store, idx) {
    store.createIndex(idx.name, idx.keyPath, {
        unique: idx.unique,
        multiEntry: idx.multi
    });
}
function $2f895839ac78ac6c$var$buildGlobalSchema(db, idbdb, tmpTrans) {
    var globalSchema = {};
    var dbStoreNames = $2f895839ac78ac6c$var$slice(idbdb.objectStoreNames, 0);
    dbStoreNames.forEach(function(storeName) {
        var store = tmpTrans.objectStore(storeName);
        var keyPath = store.keyPath;
        var primKey = $2f895839ac78ac6c$var$createIndexSpec($2f895839ac78ac6c$var$nameFromKeyPath(keyPath), keyPath || "", false, false, !!store.autoIncrement, keyPath && typeof keyPath !== "string", true);
        var indexes = [];
        for(var j = 0; j < store.indexNames.length; ++j){
            var idbindex = store.index(store.indexNames[j]);
            keyPath = idbindex.keyPath;
            var index = $2f895839ac78ac6c$var$createIndexSpec(idbindex.name, keyPath, !!idbindex.unique, !!idbindex.multiEntry, false, keyPath && typeof keyPath !== "string", false);
            indexes.push(index);
        }
        globalSchema[storeName] = $2f895839ac78ac6c$var$createTableSchema(storeName, primKey, indexes);
    });
    return globalSchema;
}
function $2f895839ac78ac6c$var$readGlobalSchema(_a, idbdb, tmpTrans) {
    var db = _a._novip;
    db.verno = idbdb.version / 10;
    var globalSchema = db._dbSchema = $2f895839ac78ac6c$var$buildGlobalSchema(db, idbdb, tmpTrans);
    db._storeNames = $2f895839ac78ac6c$var$slice(idbdb.objectStoreNames, 0);
    $2f895839ac78ac6c$var$setApiOnPlace(db, [
        db._allTables
    ], $2f895839ac78ac6c$var$keys(globalSchema), globalSchema);
}
function $2f895839ac78ac6c$var$verifyInstalledSchema(db, tmpTrans) {
    var installedSchema = $2f895839ac78ac6c$var$buildGlobalSchema(db, db.idbdb, tmpTrans);
    var diff = $2f895839ac78ac6c$var$getSchemaDiff(installedSchema, db._dbSchema);
    return !(diff.add.length || diff.change.some(function(ch) {
        return ch.add.length || ch.change.length;
    }));
}
function $2f895839ac78ac6c$var$adjustToExistingIndexNames(_a, schema, idbtrans) {
    var db = _a._novip;
    var storeNames = idbtrans.db.objectStoreNames;
    for(var i = 0; i < storeNames.length; ++i){
        var storeName = storeNames[i];
        var store = idbtrans.objectStore(storeName);
        db._hasGetAll = "getAll" in store;
        for(var j = 0; j < store.indexNames.length; ++j){
            var indexName = store.indexNames[j];
            var keyPath = store.index(indexName).keyPath;
            var dexieName = typeof keyPath === "string" ? keyPath : "[" + $2f895839ac78ac6c$var$slice(keyPath).join("+") + "]";
            if (schema[storeName]) {
                var indexSpec = schema[storeName].idxByName[dexieName];
                if (indexSpec) {
                    indexSpec.name = indexName;
                    delete schema[storeName].idxByName[dexieName];
                    schema[storeName].idxByName[indexName] = indexSpec;
                }
            }
        }
    }
    if (typeof navigator !== "undefined" && /Safari/.test(navigator.userAgent) && !/(Chrome\/|Edge\/)/.test(navigator.userAgent) && $2f895839ac78ac6c$var$_global.WorkerGlobalScope && $2f895839ac78ac6c$var$_global instanceof $2f895839ac78ac6c$var$_global.WorkerGlobalScope && [].concat(navigator.userAgent.match(/Safari\/(\d*)/))[1] < 604) db._hasGetAll = false;
}
function $2f895839ac78ac6c$var$parseIndexSyntax(primKeyAndIndexes) {
    return primKeyAndIndexes.split(",").map(function(index, indexNum) {
        index = index.trim();
        var name = index.replace(/([&*]|\+\+)/g, "");
        var keyPath = /^\[/.test(name) ? name.match(/^\[(.*)\]$/)[1].split("+") : name;
        return $2f895839ac78ac6c$var$createIndexSpec(name, keyPath || null, /\&/.test(index), /\*/.test(index), /\+\+/.test(index), $2f895839ac78ac6c$var$isArray(keyPath), indexNum === 0);
    });
}
var $2f895839ac78ac6c$var$Version = function() {
    function Version() {}
    Version.prototype._parseStoresSpec = function(stores, outSchema) {
        $2f895839ac78ac6c$var$keys(stores).forEach(function(tableName) {
            if (stores[tableName] !== null) {
                var indexes = $2f895839ac78ac6c$var$parseIndexSyntax(stores[tableName]);
                var primKey = indexes.shift();
                if (primKey.multi) throw new $2f895839ac78ac6c$var$exceptions.Schema("Primary key cannot be multi-valued");
                indexes.forEach(function(idx) {
                    if (idx.auto) throw new $2f895839ac78ac6c$var$exceptions.Schema("Only primary key can be marked as autoIncrement (++)");
                    if (!idx.keyPath) throw new $2f895839ac78ac6c$var$exceptions.Schema("Index must have a name and cannot be an empty string");
                });
                outSchema[tableName] = $2f895839ac78ac6c$var$createTableSchema(tableName, primKey, indexes);
            }
        });
    };
    Version.prototype.stores = function(stores) {
        var db = this.db;
        this._cfg.storesSource = this._cfg.storesSource ? $2f895839ac78ac6c$var$extend(this._cfg.storesSource, stores) : stores;
        var versions = db._versions;
        var storesSpec = {};
        var dbschema = {};
        versions.forEach(function(version) {
            $2f895839ac78ac6c$var$extend(storesSpec, version._cfg.storesSource);
            dbschema = version._cfg.dbschema = {};
            version._parseStoresSpec(storesSpec, dbschema);
        });
        db._dbSchema = dbschema;
        $2f895839ac78ac6c$var$removeTablesApi(db, [
            db._allTables,
            db,
            db.Transaction.prototype
        ]);
        $2f895839ac78ac6c$var$setApiOnPlace(db, [
            db._allTables,
            db,
            db.Transaction.prototype,
            this._cfg.tables
        ], $2f895839ac78ac6c$var$keys(dbschema), dbschema);
        db._storeNames = $2f895839ac78ac6c$var$keys(dbschema);
        return this;
    };
    Version.prototype.upgrade = function(upgradeFunction) {
        this._cfg.contentUpgrade = $2f895839ac78ac6c$var$promisableChain(this._cfg.contentUpgrade || $2f895839ac78ac6c$var$nop, upgradeFunction);
        return this;
    };
    return Version;
}();
function $2f895839ac78ac6c$var$createVersionConstructor(db) {
    return $2f895839ac78ac6c$var$makeClassConstructor($2f895839ac78ac6c$var$Version.prototype, function Version(versionNumber) {
        this.db = db;
        this._cfg = {
            version: versionNumber,
            storesSource: null,
            dbschema: {},
            tables: {},
            contentUpgrade: null
        };
    });
}
function $2f895839ac78ac6c$var$getDbNamesTable(indexedDB1, IDBKeyRange) {
    var dbNamesDB = indexedDB1["_dbNamesDB"];
    if (!dbNamesDB) {
        dbNamesDB = indexedDB1["_dbNamesDB"] = new $2f895839ac78ac6c$export$4ece27d405df7279($2f895839ac78ac6c$var$DBNAMES_DB, {
            addons: [],
            indexedDB: indexedDB1,
            IDBKeyRange: IDBKeyRange
        });
        dbNamesDB.version(1).stores({
            dbnames: "name"
        });
    }
    return dbNamesDB.table("dbnames");
}
function $2f895839ac78ac6c$var$hasDatabasesNative(indexedDB1) {
    return indexedDB1 && typeof indexedDB1.databases === "function";
}
function $2f895839ac78ac6c$var$getDatabaseNames(_a) {
    var indexedDB1 = _a.indexedDB, IDBKeyRange = _a.IDBKeyRange;
    return $2f895839ac78ac6c$var$hasDatabasesNative(indexedDB1) ? Promise.resolve(indexedDB1.databases()).then(function(infos) {
        return infos.map(function(info) {
            return info.name;
        }).filter(function(name) {
            return name !== $2f895839ac78ac6c$var$DBNAMES_DB;
        });
    }) : $2f895839ac78ac6c$var$getDbNamesTable(indexedDB1, IDBKeyRange).toCollection().primaryKeys();
}
function $2f895839ac78ac6c$var$_onDatabaseCreated(_a, name) {
    var indexedDB1 = _a.indexedDB, IDBKeyRange = _a.IDBKeyRange;
    !$2f895839ac78ac6c$var$hasDatabasesNative(indexedDB1) && name !== $2f895839ac78ac6c$var$DBNAMES_DB && $2f895839ac78ac6c$var$getDbNamesTable(indexedDB1, IDBKeyRange).put({
        name: name
    }).catch($2f895839ac78ac6c$var$nop);
}
function $2f895839ac78ac6c$var$_onDatabaseDeleted(_a, name) {
    var indexedDB1 = _a.indexedDB, IDBKeyRange = _a.IDBKeyRange;
    !$2f895839ac78ac6c$var$hasDatabasesNative(indexedDB1) && name !== $2f895839ac78ac6c$var$DBNAMES_DB && $2f895839ac78ac6c$var$getDbNamesTable(indexedDB1, IDBKeyRange).delete(name).catch($2f895839ac78ac6c$var$nop);
}
function $2f895839ac78ac6c$var$vip(fn) {
    return $2f895839ac78ac6c$var$newScope(function() {
        $2f895839ac78ac6c$var$PSD.letThrough = true;
        return fn();
    });
}
function $2f895839ac78ac6c$var$idbReady() {
    var isSafari = !navigator.userAgentData && /Safari\//.test(navigator.userAgent) && !/Chrom(e|ium)\//.test(navigator.userAgent);
    if (!isSafari || !indexedDB.databases) return Promise.resolve();
    var intervalId;
    return new Promise(function(resolve) {
        var tryIdb = function() {
            return indexedDB.databases().finally(resolve);
        };
        intervalId = setInterval(tryIdb, 100);
        tryIdb();
    }).finally(function() {
        return clearInterval(intervalId);
    });
}
function $2f895839ac78ac6c$var$dexieOpen(db) {
    var state = db._state;
    var indexedDB1 = db._deps.indexedDB;
    if (state.isBeingOpened || db.idbdb) return state.dbReadyPromise.then(function() {
        return state.dbOpenError ? $2f895839ac78ac6c$var$rejection(state.dbOpenError) : db;
    });
    $2f895839ac78ac6c$var$debug && (state.openCanceller._stackHolder = $2f895839ac78ac6c$var$getErrorWithStack());
    state.isBeingOpened = true;
    state.dbOpenError = null;
    state.openComplete = false;
    var openCanceller = state.openCanceller;
    function throwIfCancelled() {
        if (state.openCanceller !== openCanceller) throw new $2f895839ac78ac6c$var$exceptions.DatabaseClosed("db.open() was cancelled");
    }
    var resolveDbReady = state.dbReadyResolve, upgradeTransaction = null, wasCreated = false;
    var tryOpenDB = function() {
        return new $2f895839ac78ac6c$var$DexiePromise(function(resolve, reject) {
            throwIfCancelled();
            if (!indexedDB1) throw new $2f895839ac78ac6c$var$exceptions.MissingAPI();
            var dbName = db.name;
            var req = state.autoSchema ? indexedDB1.open(dbName) : indexedDB1.open(dbName, Math.round(db.verno * 10));
            if (!req) throw new $2f895839ac78ac6c$var$exceptions.MissingAPI();
            req.onerror = $2f895839ac78ac6c$var$eventRejectHandler(reject);
            req.onblocked = $2f895839ac78ac6c$var$wrap(db._fireOnBlocked);
            req.onupgradeneeded = $2f895839ac78ac6c$var$wrap(function(e) {
                upgradeTransaction = req.transaction;
                if (state.autoSchema && !db._options.allowEmptyDB) {
                    req.onerror = $2f895839ac78ac6c$var$preventDefault;
                    upgradeTransaction.abort();
                    req.result.close();
                    var delreq = indexedDB1.deleteDatabase(dbName);
                    delreq.onsuccess = delreq.onerror = $2f895839ac78ac6c$var$wrap(function() {
                        reject(new $2f895839ac78ac6c$var$exceptions.NoSuchDatabase("Database " + dbName + " doesnt exist"));
                    });
                } else {
                    upgradeTransaction.onerror = $2f895839ac78ac6c$var$eventRejectHandler(reject);
                    var oldVer = e.oldVersion > Math.pow(2, 62) ? 0 : e.oldVersion;
                    wasCreated = oldVer < 1;
                    db._novip.idbdb = req.result;
                    $2f895839ac78ac6c$var$runUpgraders(db, oldVer / 10, upgradeTransaction, reject);
                }
            }, reject);
            req.onsuccess = $2f895839ac78ac6c$var$wrap(function() {
                upgradeTransaction = null;
                var idbdb = db._novip.idbdb = req.result;
                var objectStoreNames = $2f895839ac78ac6c$var$slice(idbdb.objectStoreNames);
                if (objectStoreNames.length > 0) try {
                    var tmpTrans = idbdb.transaction($2f895839ac78ac6c$var$safariMultiStoreFix(objectStoreNames), "readonly");
                    if (state.autoSchema) $2f895839ac78ac6c$var$readGlobalSchema(db, idbdb, tmpTrans);
                    else {
                        $2f895839ac78ac6c$var$adjustToExistingIndexNames(db, db._dbSchema, tmpTrans);
                        if (!$2f895839ac78ac6c$var$verifyInstalledSchema(db, tmpTrans)) console.warn("Dexie SchemaDiff: Schema was extended without increasing the number passed to db.version(). Some queries may fail.");
                    }
                    $2f895839ac78ac6c$var$generateMiddlewareStacks(db, tmpTrans);
                } catch (e) {}
                $2f895839ac78ac6c$var$connections.push(db);
                idbdb.onversionchange = $2f895839ac78ac6c$var$wrap(function(ev) {
                    state.vcFired = true;
                    db.on("versionchange").fire(ev);
                });
                idbdb.onclose = $2f895839ac78ac6c$var$wrap(function(ev) {
                    db.on("close").fire(ev);
                });
                if (wasCreated) $2f895839ac78ac6c$var$_onDatabaseCreated(db._deps, dbName);
                resolve();
            }, reject);
        }).catch(function(err) {
            if (err && err.name === "UnknownError" && state.PR1398_maxLoop > 0) {
                state.PR1398_maxLoop--;
                console.warn("Dexie: Workaround for Chrome UnknownError on open()");
                return tryOpenDB();
            } else return $2f895839ac78ac6c$var$DexiePromise.reject(err);
        });
    };
    return $2f895839ac78ac6c$var$DexiePromise.race([
        openCanceller,
        (typeof navigator === "undefined" ? $2f895839ac78ac6c$var$DexiePromise.resolve() : $2f895839ac78ac6c$var$idbReady()).then(tryOpenDB)
    ]).then(function() {
        throwIfCancelled();
        state.onReadyBeingFired = [];
        return $2f895839ac78ac6c$var$DexiePromise.resolve($2f895839ac78ac6c$var$vip(function() {
            return db.on.ready.fire(db.vip);
        })).then(function fireRemainders() {
            if (state.onReadyBeingFired.length > 0) {
                var remainders_1 = state.onReadyBeingFired.reduce($2f895839ac78ac6c$var$promisableChain, $2f895839ac78ac6c$var$nop);
                state.onReadyBeingFired = [];
                return $2f895839ac78ac6c$var$DexiePromise.resolve($2f895839ac78ac6c$var$vip(function() {
                    return remainders_1(db.vip);
                })).then(fireRemainders);
            }
        });
    }).finally(function() {
        state.onReadyBeingFired = null;
        state.isBeingOpened = false;
    }).then(function() {
        return db;
    }).catch(function(err) {
        state.dbOpenError = err;
        try {
            upgradeTransaction && upgradeTransaction.abort();
        } catch (_a) {}
        if (openCanceller === state.openCanceller) db._close();
        return $2f895839ac78ac6c$var$rejection(err);
    }).finally(function() {
        state.openComplete = true;
        resolveDbReady();
    });
}
function $2f895839ac78ac6c$var$awaitIterator(iterator) {
    var callNext = function(result) {
        return iterator.next(result);
    }, doThrow = function(error) {
        return iterator.throw(error);
    }, onSuccess = step(callNext), onError = step(doThrow);
    function step(getNext) {
        return function(val) {
            var next = getNext(val), value = next.value;
            return next.done ? value : !value || typeof value.then !== "function" ? $2f895839ac78ac6c$var$isArray(value) ? Promise.all(value).then(onSuccess, onError) : onSuccess(value) : value.then(onSuccess, onError);
        };
    }
    return step(callNext)();
}
function $2f895839ac78ac6c$var$extractTransactionArgs(mode, _tableArgs_, scopeFunc) {
    var i = arguments.length;
    if (i < 2) throw new $2f895839ac78ac6c$var$exceptions.InvalidArgument("Too few arguments");
    var args = new Array(i - 1);
    while(--i)args[i - 1] = arguments[i];
    scopeFunc = args.pop();
    var tables = $2f895839ac78ac6c$var$flatten(args);
    return [
        mode,
        tables,
        scopeFunc
    ];
}
function $2f895839ac78ac6c$var$enterTransactionScope(db, mode, storeNames, parentTransaction, scopeFunc) {
    return $2f895839ac78ac6c$var$DexiePromise.resolve().then(function() {
        var transless = $2f895839ac78ac6c$var$PSD.transless || $2f895839ac78ac6c$var$PSD;
        var trans = db._createTransaction(mode, storeNames, db._dbSchema, parentTransaction);
        var zoneProps = {
            trans: trans,
            transless: transless
        };
        if (parentTransaction) trans.idbtrans = parentTransaction.idbtrans;
        else try {
            trans.create();
            db._state.PR1398_maxLoop = 3;
        } catch (ex) {
            if (ex.name === $2f895839ac78ac6c$var$errnames.InvalidState && db.isOpen() && --db._state.PR1398_maxLoop > 0) {
                console.warn("Dexie: Need to reopen db");
                db._close();
                return db.open().then(function() {
                    return $2f895839ac78ac6c$var$enterTransactionScope(db, mode, storeNames, null, scopeFunc);
                });
            }
            return $2f895839ac78ac6c$var$rejection(ex);
        }
        var scopeFuncIsAsync = $2f895839ac78ac6c$var$isAsyncFunction(scopeFunc);
        if (scopeFuncIsAsync) $2f895839ac78ac6c$var$incrementExpectedAwaits();
        var returnValue;
        var promiseFollowed = $2f895839ac78ac6c$var$DexiePromise.follow(function() {
            returnValue = scopeFunc.call(trans, trans);
            if (returnValue) {
                if (scopeFuncIsAsync) {
                    var decrementor = $2f895839ac78ac6c$var$decrementExpectedAwaits.bind(null, null);
                    returnValue.then(decrementor, decrementor);
                } else if (typeof returnValue.next === "function" && typeof returnValue.throw === "function") returnValue = $2f895839ac78ac6c$var$awaitIterator(returnValue);
            }
        }, zoneProps);
        return (returnValue && typeof returnValue.then === "function" ? $2f895839ac78ac6c$var$DexiePromise.resolve(returnValue).then(function(x) {
            return trans.active ? x : $2f895839ac78ac6c$var$rejection(new $2f895839ac78ac6c$var$exceptions.PrematureCommit("Transaction committed too early. See http://bit.ly/2kdckMn"));
        }) : promiseFollowed.then(function() {
            return returnValue;
        })).then(function(x) {
            if (parentTransaction) trans._resolve();
            return trans._completion.then(function() {
                return x;
            });
        }).catch(function(e) {
            trans._reject(e);
            return $2f895839ac78ac6c$var$rejection(e);
        });
    });
}
function $2f895839ac78ac6c$var$pad(a, value, count) {
    var result = $2f895839ac78ac6c$var$isArray(a) ? a.slice() : [
        a
    ];
    for(var i = 0; i < count; ++i)result.push(value);
    return result;
}
function $2f895839ac78ac6c$var$createVirtualIndexMiddleware(down) {
    return $2f895839ac78ac6c$var$__assign($2f895839ac78ac6c$var$__assign({}, down), {
        table: function(tableName) {
            var table = down.table(tableName);
            var schema = table.schema;
            var indexLookup = {};
            var allVirtualIndexes = [];
            function addVirtualIndexes(keyPath, keyTail, lowLevelIndex) {
                var keyPathAlias = $2f895839ac78ac6c$var$getKeyPathAlias(keyPath);
                var indexList = indexLookup[keyPathAlias] = indexLookup[keyPathAlias] || [];
                var keyLength = keyPath == null ? 0 : typeof keyPath === "string" ? 1 : keyPath.length;
                var isVirtual = keyTail > 0;
                var virtualIndex = $2f895839ac78ac6c$var$__assign($2f895839ac78ac6c$var$__assign({}, lowLevelIndex), {
                    isVirtual: isVirtual,
                    keyTail: keyTail,
                    keyLength: keyLength,
                    extractKey: $2f895839ac78ac6c$var$getKeyExtractor(keyPath),
                    unique: !isVirtual && lowLevelIndex.unique
                });
                indexList.push(virtualIndex);
                if (!virtualIndex.isPrimaryKey) allVirtualIndexes.push(virtualIndex);
                if (keyLength > 1) {
                    var virtualKeyPath = keyLength === 2 ? keyPath[0] : keyPath.slice(0, keyLength - 1);
                    addVirtualIndexes(virtualKeyPath, keyTail + 1, lowLevelIndex);
                }
                indexList.sort(function(a, b) {
                    return a.keyTail - b.keyTail;
                });
                return virtualIndex;
            }
            var primaryKey = addVirtualIndexes(schema.primaryKey.keyPath, 0, schema.primaryKey);
            indexLookup[":id"] = [
                primaryKey
            ];
            for(var _i = 0, _a = schema.indexes; _i < _a.length; _i++){
                var index = _a[_i];
                addVirtualIndexes(index.keyPath, 0, index);
            }
            function findBestIndex(keyPath) {
                var result = indexLookup[$2f895839ac78ac6c$var$getKeyPathAlias(keyPath)];
                return result && result[0];
            }
            function translateRange(range, keyTail) {
                return {
                    type: range.type === 1 ? 2 : range.type,
                    lower: $2f895839ac78ac6c$var$pad(range.lower, range.lowerOpen ? down.MAX_KEY : down.MIN_KEY, keyTail),
                    lowerOpen: true,
                    upper: $2f895839ac78ac6c$var$pad(range.upper, range.upperOpen ? down.MIN_KEY : down.MAX_KEY, keyTail),
                    upperOpen: true
                };
            }
            function translateRequest(req) {
                var index = req.query.index;
                return index.isVirtual ? $2f895839ac78ac6c$var$__assign($2f895839ac78ac6c$var$__assign({}, req), {
                    query: {
                        index: index,
                        range: translateRange(req.query.range, index.keyTail)
                    }
                }) : req;
            }
            var result = $2f895839ac78ac6c$var$__assign($2f895839ac78ac6c$var$__assign({}, table), {
                schema: $2f895839ac78ac6c$var$__assign($2f895839ac78ac6c$var$__assign({}, schema), {
                    primaryKey: primaryKey,
                    indexes: allVirtualIndexes,
                    getIndexByKeyPath: findBestIndex
                }),
                count: function(req) {
                    return table.count(translateRequest(req));
                },
                query: function(req) {
                    return table.query(translateRequest(req));
                },
                openCursor: function(req) {
                    var _a = req.query.index, keyTail = _a.keyTail, isVirtual = _a.isVirtual, keyLength = _a.keyLength;
                    if (!isVirtual) return table.openCursor(req);
                    function createVirtualCursor(cursor) {
                        function _continue(key) {
                            key != null ? cursor.continue($2f895839ac78ac6c$var$pad(key, req.reverse ? down.MAX_KEY : down.MIN_KEY, keyTail)) : req.unique ? cursor.continue(cursor.key.slice(0, keyLength).concat(req.reverse ? down.MIN_KEY : down.MAX_KEY, keyTail)) : cursor.continue();
                        }
                        var virtualCursor = Object.create(cursor, {
                            continue: {
                                value: _continue
                            },
                            continuePrimaryKey: {
                                value: function(key, primaryKey) {
                                    cursor.continuePrimaryKey($2f895839ac78ac6c$var$pad(key, down.MAX_KEY, keyTail), primaryKey);
                                }
                            },
                            primaryKey: {
                                get: function() {
                                    return cursor.primaryKey;
                                }
                            },
                            key: {
                                get: function() {
                                    var key = cursor.key;
                                    return keyLength === 1 ? key[0] : key.slice(0, keyLength);
                                }
                            },
                            value: {
                                get: function() {
                                    return cursor.value;
                                }
                            }
                        });
                        return virtualCursor;
                    }
                    return table.openCursor(translateRequest(req)).then(function(cursor) {
                        return cursor && createVirtualCursor(cursor);
                    });
                }
            });
            return result;
        }
    });
}
var $2f895839ac78ac6c$var$virtualIndexMiddleware = {
    stack: "dbcore",
    name: "VirtualIndexMiddleware",
    level: 1,
    create: $2f895839ac78ac6c$var$createVirtualIndexMiddleware
};
function $2f895839ac78ac6c$var$getObjectDiff(a, b, rv, prfx) {
    rv = rv || {};
    prfx = prfx || "";
    $2f895839ac78ac6c$var$keys(a).forEach(function(prop) {
        if (!$2f895839ac78ac6c$var$hasOwn(b, prop)) rv[prfx + prop] = undefined;
        else {
            var ap = a[prop], bp = b[prop];
            if (typeof ap === "object" && typeof bp === "object" && ap && bp) {
                var apTypeName = $2f895839ac78ac6c$var$toStringTag(ap);
                var bpTypeName = $2f895839ac78ac6c$var$toStringTag(bp);
                if (apTypeName !== bpTypeName) rv[prfx + prop] = b[prop];
                else if (apTypeName === "Object") $2f895839ac78ac6c$var$getObjectDiff(ap, bp, rv, prfx + prop + ".");
                else if (ap !== bp) rv[prfx + prop] = b[prop];
            } else if (ap !== bp) rv[prfx + prop] = b[prop];
        }
    });
    $2f895839ac78ac6c$var$keys(b).forEach(function(prop) {
        if (!$2f895839ac78ac6c$var$hasOwn(a, prop)) rv[prfx + prop] = b[prop];
    });
    return rv;
}
function $2f895839ac78ac6c$var$getEffectiveKeys(primaryKey, req) {
    if (req.type === "delete") return req.keys;
    return req.keys || req.values.map(primaryKey.extractKey);
}
var $2f895839ac78ac6c$var$hooksMiddleware = {
    stack: "dbcore",
    name: "HooksMiddleware",
    level: 2,
    create: function(downCore) {
        return $2f895839ac78ac6c$var$__assign($2f895839ac78ac6c$var$__assign({}, downCore), {
            table: function(tableName) {
                var downTable = downCore.table(tableName);
                var primaryKey = downTable.schema.primaryKey;
                var tableMiddleware = $2f895839ac78ac6c$var$__assign($2f895839ac78ac6c$var$__assign({}, downTable), {
                    mutate: function(req) {
                        var dxTrans = $2f895839ac78ac6c$var$PSD.trans;
                        var _a = dxTrans.table(tableName).hook, deleting = _a.deleting, creating = _a.creating, updating = _a.updating;
                        switch(req.type){
                            case "add":
                                if (creating.fire === $2f895839ac78ac6c$var$nop) break;
                                return dxTrans._promise("readwrite", function() {
                                    return addPutOrDelete(req);
                                }, true);
                            case "put":
                                if (creating.fire === $2f895839ac78ac6c$var$nop && updating.fire === $2f895839ac78ac6c$var$nop) break;
                                return dxTrans._promise("readwrite", function() {
                                    return addPutOrDelete(req);
                                }, true);
                            case "delete":
                                if (deleting.fire === $2f895839ac78ac6c$var$nop) break;
                                return dxTrans._promise("readwrite", function() {
                                    return addPutOrDelete(req);
                                }, true);
                            case "deleteRange":
                                if (deleting.fire === $2f895839ac78ac6c$var$nop) break;
                                return dxTrans._promise("readwrite", function() {
                                    return deleteRange(req);
                                }, true);
                        }
                        return downTable.mutate(req);
                        function addPutOrDelete(req) {
                            var dxTrans = $2f895839ac78ac6c$var$PSD.trans;
                            var keys = req.keys || $2f895839ac78ac6c$var$getEffectiveKeys(primaryKey, req);
                            if (!keys) throw new Error("Keys missing");
                            req = req.type === "add" || req.type === "put" ? $2f895839ac78ac6c$var$__assign($2f895839ac78ac6c$var$__assign({}, req), {
                                keys: keys
                            }) : $2f895839ac78ac6c$var$__assign({}, req);
                            if (req.type !== "delete") req.values = $2f895839ac78ac6c$var$__spreadArray([], req.values, true);
                            if (req.keys) req.keys = $2f895839ac78ac6c$var$__spreadArray([], req.keys, true);
                            return $2f895839ac78ac6c$var$getExistingValues(downTable, req, keys).then(function(existingValues) {
                                var contexts = keys.map(function(key, i) {
                                    var existingValue = existingValues[i];
                                    var ctx = {
                                        onerror: null,
                                        onsuccess: null
                                    };
                                    if (req.type === "delete") deleting.fire.call(ctx, key, existingValue, dxTrans);
                                    else if (req.type === "add" || existingValue === undefined) {
                                        var generatedPrimaryKey = creating.fire.call(ctx, key, req.values[i], dxTrans);
                                        if (key == null && generatedPrimaryKey != null) {
                                            key = generatedPrimaryKey;
                                            req.keys[i] = key;
                                            if (!primaryKey.outbound) $2f895839ac78ac6c$var$setByKeyPath(req.values[i], primaryKey.keyPath, key);
                                        }
                                    } else {
                                        var objectDiff = $2f895839ac78ac6c$var$getObjectDiff(existingValue, req.values[i]);
                                        var additionalChanges_1 = updating.fire.call(ctx, objectDiff, key, existingValue, dxTrans);
                                        if (additionalChanges_1) {
                                            var requestedValue_1 = req.values[i];
                                            Object.keys(additionalChanges_1).forEach(function(keyPath) {
                                                if ($2f895839ac78ac6c$var$hasOwn(requestedValue_1, keyPath)) requestedValue_1[keyPath] = additionalChanges_1[keyPath];
                                                else $2f895839ac78ac6c$var$setByKeyPath(requestedValue_1, keyPath, additionalChanges_1[keyPath]);
                                            });
                                        }
                                    }
                                    return ctx;
                                });
                                return downTable.mutate(req).then(function(_a) {
                                    var failures = _a.failures, results = _a.results, numFailures = _a.numFailures, lastResult = _a.lastResult;
                                    for(var i = 0; i < keys.length; ++i){
                                        var primKey = results ? results[i] : keys[i];
                                        var ctx = contexts[i];
                                        if (primKey == null) ctx.onerror && ctx.onerror(failures[i]);
                                        else ctx.onsuccess && ctx.onsuccess(req.type === "put" && existingValues[i] ? req.values[i] : primKey);
                                    }
                                    return {
                                        failures: failures,
                                        results: results,
                                        numFailures: numFailures,
                                        lastResult: lastResult
                                    };
                                }).catch(function(error) {
                                    contexts.forEach(function(ctx) {
                                        return ctx.onerror && ctx.onerror(error);
                                    });
                                    return Promise.reject(error);
                                });
                            });
                        }
                        function deleteRange(req) {
                            return deleteNextChunk(req.trans, req.range, 10000);
                        }
                        function deleteNextChunk(trans, range, limit) {
                            return downTable.query({
                                trans: trans,
                                values: false,
                                query: {
                                    index: primaryKey,
                                    range: range
                                },
                                limit: limit
                            }).then(function(_a) {
                                var result = _a.result;
                                return addPutOrDelete({
                                    type: "delete",
                                    keys: result,
                                    trans: trans
                                }).then(function(res) {
                                    if (res.numFailures > 0) return Promise.reject(res.failures[0]);
                                    if (result.length < limit) return {
                                        failures: [],
                                        numFailures: 0,
                                        lastResult: undefined
                                    };
                                    else return deleteNextChunk(trans, $2f895839ac78ac6c$var$__assign($2f895839ac78ac6c$var$__assign({}, range), {
                                        lower: result[result.length - 1],
                                        lowerOpen: true
                                    }), limit);
                                });
                            });
                        }
                    }
                });
                return tableMiddleware;
            }
        });
    }
};
function $2f895839ac78ac6c$var$getExistingValues(table, req, effectiveKeys) {
    return req.type === "add" ? Promise.resolve([]) : table.getMany({
        trans: req.trans,
        keys: effectiveKeys,
        cache: "immutable"
    });
}
function $2f895839ac78ac6c$var$getFromTransactionCache(keys, cache, clone) {
    try {
        if (!cache) return null;
        if (cache.keys.length < keys.length) return null;
        var result = [];
        for(var i = 0, j = 0; i < cache.keys.length && j < keys.length; ++i){
            if ($2f895839ac78ac6c$var$cmp(cache.keys[i], keys[j]) !== 0) continue;
            result.push(clone ? $2f895839ac78ac6c$var$deepClone(cache.values[i]) : cache.values[i]);
            ++j;
        }
        return result.length === keys.length ? result : null;
    } catch (_a) {
        return null;
    }
}
var $2f895839ac78ac6c$var$cacheExistingValuesMiddleware = {
    stack: "dbcore",
    level: -1,
    create: function(core) {
        return {
            table: function(tableName) {
                var table = core.table(tableName);
                return $2f895839ac78ac6c$var$__assign($2f895839ac78ac6c$var$__assign({}, table), {
                    getMany: function(req) {
                        if (!req.cache) return table.getMany(req);
                        var cachedResult = $2f895839ac78ac6c$var$getFromTransactionCache(req.keys, req.trans["_cache"], req.cache === "clone");
                        if (cachedResult) return $2f895839ac78ac6c$var$DexiePromise.resolve(cachedResult);
                        return table.getMany(req).then(function(res) {
                            req.trans["_cache"] = {
                                keys: req.keys,
                                values: req.cache === "clone" ? $2f895839ac78ac6c$var$deepClone(res) : res
                            };
                            return res;
                        });
                    },
                    mutate: function(req) {
                        if (req.type !== "add") req.trans["_cache"] = null;
                        return table.mutate(req);
                    }
                });
            }
        };
    }
};
var $2f895839ac78ac6c$var$_a;
function $2f895839ac78ac6c$var$isEmptyRange(node) {
    return !("from" in node);
}
var $2f895839ac78ac6c$export$34cb5241245008dd = function(fromOrTree, to) {
    if (this) $2f895839ac78ac6c$var$extend(this, arguments.length ? {
        d: 1,
        from: fromOrTree,
        to: arguments.length > 1 ? to : fromOrTree
    } : {
        d: 0
    });
    else {
        var rv = new $2f895839ac78ac6c$export$34cb5241245008dd();
        if (fromOrTree && "d" in fromOrTree) $2f895839ac78ac6c$var$extend(rv, fromOrTree);
        return rv;
    }
};
$2f895839ac78ac6c$var$props($2f895839ac78ac6c$export$34cb5241245008dd.prototype, ($2f895839ac78ac6c$var$_a = {
    add: function(rangeSet) {
        $2f895839ac78ac6c$export$4876cc3130d3f820(this, rangeSet);
        return this;
    },
    addKey: function(key) {
        $2f895839ac78ac6c$var$addRange(this, key, key);
        return this;
    },
    addKeys: function(keys) {
        var _this = this;
        keys.forEach(function(key) {
            return $2f895839ac78ac6c$var$addRange(_this, key, key);
        });
        return this;
    }
}, $2f895839ac78ac6c$var$_a[$2f895839ac78ac6c$var$iteratorSymbol] = function() {
    return $2f895839ac78ac6c$var$getRangeSetIterator(this);
}, $2f895839ac78ac6c$var$_a));
function $2f895839ac78ac6c$var$addRange(target, from, to) {
    var diff = $2f895839ac78ac6c$var$cmp(from, to);
    if (isNaN(diff)) return;
    if (diff > 0) throw RangeError();
    if ($2f895839ac78ac6c$var$isEmptyRange(target)) return $2f895839ac78ac6c$var$extend(target, {
        from: from,
        to: to,
        d: 1
    });
    var left = target.l;
    var right = target.r;
    if ($2f895839ac78ac6c$var$cmp(to, target.from) < 0) {
        left ? $2f895839ac78ac6c$var$addRange(left, from, to) : target.l = {
            from: from,
            to: to,
            d: 1,
            l: null,
            r: null
        };
        return $2f895839ac78ac6c$var$rebalance(target);
    }
    if ($2f895839ac78ac6c$var$cmp(from, target.to) > 0) {
        right ? $2f895839ac78ac6c$var$addRange(right, from, to) : target.r = {
            from: from,
            to: to,
            d: 1,
            l: null,
            r: null
        };
        return $2f895839ac78ac6c$var$rebalance(target);
    }
    if ($2f895839ac78ac6c$var$cmp(from, target.from) < 0) {
        target.from = from;
        target.l = null;
        target.d = right ? right.d + 1 : 1;
    }
    if ($2f895839ac78ac6c$var$cmp(to, target.to) > 0) {
        target.to = to;
        target.r = null;
        target.d = target.l ? target.l.d + 1 : 1;
    }
    var rightWasCutOff = !target.r;
    if (left && !target.l) $2f895839ac78ac6c$export$4876cc3130d3f820(target, left);
    if (right && rightWasCutOff) $2f895839ac78ac6c$export$4876cc3130d3f820(target, right);
}
function $2f895839ac78ac6c$export$4876cc3130d3f820(target, newSet) {
    function _addRangeSet(target, _a) {
        var from = _a.from, to = _a.to, l = _a.l, r = _a.r;
        $2f895839ac78ac6c$var$addRange(target, from, to);
        if (l) _addRangeSet(target, l);
        if (r) _addRangeSet(target, r);
    }
    if (!$2f895839ac78ac6c$var$isEmptyRange(newSet)) _addRangeSet(target, newSet);
}
function $2f895839ac78ac6c$export$8f43b23b5d8de905(rangeSet1, rangeSet2) {
    var i1 = $2f895839ac78ac6c$var$getRangeSetIterator(rangeSet2);
    var nextResult1 = i1.next();
    if (nextResult1.done) return false;
    var a = nextResult1.value;
    var i2 = $2f895839ac78ac6c$var$getRangeSetIterator(rangeSet1);
    var nextResult2 = i2.next(a.from);
    var b = nextResult2.value;
    while(!nextResult1.done && !nextResult2.done){
        if ($2f895839ac78ac6c$var$cmp(b.from, a.to) <= 0 && $2f895839ac78ac6c$var$cmp(b.to, a.from) >= 0) return true;
        $2f895839ac78ac6c$var$cmp(a.from, b.from) < 0 ? a = (nextResult1 = i1.next(b.from)).value : b = (nextResult2 = i2.next(a.from)).value;
    }
    return false;
}
function $2f895839ac78ac6c$var$getRangeSetIterator(node) {
    var state = $2f895839ac78ac6c$var$isEmptyRange(node) ? null : {
        s: 0,
        n: node
    };
    return {
        next: function(key) {
            var keyProvided = arguments.length > 0;
            while(state)switch(state.s){
                case 0:
                    state.s = 1;
                    if (keyProvided) while(state.n.l && $2f895839ac78ac6c$var$cmp(key, state.n.from) < 0)state = {
                        up: state,
                        n: state.n.l,
                        s: 1
                    };
                    else while(state.n.l)state = {
                        up: state,
                        n: state.n.l,
                        s: 1
                    };
                case 1:
                    state.s = 2;
                    if (!keyProvided || $2f895839ac78ac6c$var$cmp(key, state.n.to) <= 0) return {
                        value: state.n,
                        done: false
                    };
                case 2:
                    if (state.n.r) {
                        state.s = 3;
                        state = {
                            up: state,
                            n: state.n.r,
                            s: 0
                        };
                        continue;
                    }
                case 3:
                    state = state.up;
            }
            return {
                done: true
            };
        }
    };
}
function $2f895839ac78ac6c$var$rebalance(target) {
    var _a, _b;
    var diff = (((_a = target.r) === null || _a === void 0 ? void 0 : _a.d) || 0) - (((_b = target.l) === null || _b === void 0 ? void 0 : _b.d) || 0);
    var r = diff > 1 ? "r" : diff < -1 ? "l" : "";
    if (r) {
        var l = r === "r" ? "l" : "r";
        var rootClone = $2f895839ac78ac6c$var$__assign({}, target);
        var oldRootRight = target[r];
        target.from = oldRootRight.from;
        target.to = oldRootRight.to;
        target[r] = oldRootRight[r];
        rootClone[r] = oldRootRight[l];
        target[l] = rootClone;
        rootClone.d = $2f895839ac78ac6c$var$computeDepth(rootClone);
    }
    target.d = $2f895839ac78ac6c$var$computeDepth(target);
}
function $2f895839ac78ac6c$var$computeDepth(_a) {
    var r = _a.r, l = _a.l;
    return (r ? l ? Math.max(r.d, l.d) : r.d : l ? l.d : 0) + 1;
}
var $2f895839ac78ac6c$var$observabilityMiddleware = {
    stack: "dbcore",
    level: 0,
    create: function(core) {
        var dbName = core.schema.name;
        var FULL_RANGE = new $2f895839ac78ac6c$export$34cb5241245008dd(core.MIN_KEY, core.MAX_KEY);
        return $2f895839ac78ac6c$var$__assign($2f895839ac78ac6c$var$__assign({}, core), {
            table: function(tableName) {
                var table = core.table(tableName);
                var schema = table.schema;
                var primaryKey = schema.primaryKey;
                var extractKey = primaryKey.extractKey, outbound = primaryKey.outbound;
                var tableClone = $2f895839ac78ac6c$var$__assign($2f895839ac78ac6c$var$__assign({}, table), {
                    mutate: function(req) {
                        var trans = req.trans;
                        var mutatedParts = trans.mutatedParts || (trans.mutatedParts = {});
                        var getRangeSet = function(indexName) {
                            var part = "idb://" + dbName + "/" + tableName + "/" + indexName;
                            return mutatedParts[part] || (mutatedParts[part] = new $2f895839ac78ac6c$export$34cb5241245008dd());
                        };
                        var pkRangeSet = getRangeSet("");
                        var delsRangeSet = getRangeSet(":dels");
                        var type = req.type;
                        var _a = req.type === "deleteRange" ? [
                            req.range
                        ] : req.type === "delete" ? [
                            req.keys
                        ] : req.values.length < 50 ? [
                            [],
                            req.values
                        ] : [], keys = _a[0], newObjs = _a[1];
                        var oldCache = req.trans["_cache"];
                        return table.mutate(req).then(function(res) {
                            if ($2f895839ac78ac6c$var$isArray(keys)) {
                                if (type !== "delete") keys = res.results;
                                pkRangeSet.addKeys(keys);
                                var oldObjs = $2f895839ac78ac6c$var$getFromTransactionCache(keys, oldCache);
                                if (!oldObjs && type !== "add") delsRangeSet.addKeys(keys);
                                if (oldObjs || newObjs) $2f895839ac78ac6c$var$trackAffectedIndexes(getRangeSet, schema, oldObjs, newObjs);
                            } else if (keys) {
                                var range = {
                                    from: keys.lower,
                                    to: keys.upper
                                };
                                delsRangeSet.add(range);
                                pkRangeSet.add(range);
                            } else {
                                pkRangeSet.add(FULL_RANGE);
                                delsRangeSet.add(FULL_RANGE);
                                schema.indexes.forEach(function(idx) {
                                    return getRangeSet(idx.name).add(FULL_RANGE);
                                });
                            }
                            return res;
                        });
                    }
                });
                var getRange = function(_a) {
                    var _b, _c;
                    var _d = _a.query, index = _d.index, range = _d.range;
                    return [
                        index,
                        new $2f895839ac78ac6c$export$34cb5241245008dd((_b = range.lower) !== null && _b !== void 0 ? _b : core.MIN_KEY, (_c = range.upper) !== null && _c !== void 0 ? _c : core.MAX_KEY)
                    ];
                };
                var readSubscribers = {
                    get: function(req) {
                        return [
                            primaryKey,
                            new $2f895839ac78ac6c$export$34cb5241245008dd(req.key)
                        ];
                    },
                    getMany: function(req) {
                        return [
                            primaryKey,
                            new $2f895839ac78ac6c$export$34cb5241245008dd().addKeys(req.keys)
                        ];
                    },
                    count: getRange,
                    query: getRange,
                    openCursor: getRange
                };
                $2f895839ac78ac6c$var$keys(readSubscribers).forEach(function(method) {
                    tableClone[method] = function(req) {
                        var subscr = $2f895839ac78ac6c$var$PSD.subscr;
                        if (subscr) {
                            var getRangeSet = function(indexName) {
                                var part = "idb://" + dbName + "/" + tableName + "/" + indexName;
                                return subscr[part] || (subscr[part] = new $2f895839ac78ac6c$export$34cb5241245008dd());
                            };
                            var pkRangeSet_1 = getRangeSet("");
                            var delsRangeSet_1 = getRangeSet(":dels");
                            var _a = readSubscribers[method](req), queriedIndex = _a[0], queriedRanges = _a[1];
                            getRangeSet(queriedIndex.name || "").add(queriedRanges);
                            if (!queriedIndex.isPrimaryKey) {
                                if (method === "count") delsRangeSet_1.add(FULL_RANGE);
                                else {
                                    var keysPromise_1 = method === "query" && outbound && req.values && table.query($2f895839ac78ac6c$var$__assign($2f895839ac78ac6c$var$__assign({}, req), {
                                        values: false
                                    }));
                                    return table[method].apply(this, arguments).then(function(res) {
                                        if (method === "query") {
                                            if (outbound && req.values) return keysPromise_1.then(function(_a) {
                                                var resultingKeys = _a.result;
                                                pkRangeSet_1.addKeys(resultingKeys);
                                                return res;
                                            });
                                            var pKeys = req.values ? res.result.map(extractKey) : res.result;
                                            if (req.values) pkRangeSet_1.addKeys(pKeys);
                                            else delsRangeSet_1.addKeys(pKeys);
                                        } else if (method === "openCursor") {
                                            var cursor_1 = res;
                                            var wantValues_1 = req.values;
                                            return cursor_1 && Object.create(cursor_1, {
                                                key: {
                                                    get: function() {
                                                        delsRangeSet_1.addKey(cursor_1.primaryKey);
                                                        return cursor_1.key;
                                                    }
                                                },
                                                primaryKey: {
                                                    get: function() {
                                                        var pkey = cursor_1.primaryKey;
                                                        delsRangeSet_1.addKey(pkey);
                                                        return pkey;
                                                    }
                                                },
                                                value: {
                                                    get: function() {
                                                        wantValues_1 && pkRangeSet_1.addKey(cursor_1.primaryKey);
                                                        return cursor_1.value;
                                                    }
                                                }
                                            });
                                        }
                                        return res;
                                    });
                                }
                            }
                        }
                        return table[method].apply(this, arguments);
                    };
                });
                return tableClone;
            }
        });
    }
};
function $2f895839ac78ac6c$var$trackAffectedIndexes(getRangeSet, schema, oldObjs, newObjs) {
    function addAffectedIndex(ix) {
        var rangeSet = getRangeSet(ix.name || "");
        function extractKey(obj) {
            return obj != null ? ix.extractKey(obj) : null;
        }
        var addKeyOrKeys = function(key) {
            return ix.multiEntry && $2f895839ac78ac6c$var$isArray(key) ? key.forEach(function(key) {
                return rangeSet.addKey(key);
            }) : rangeSet.addKey(key);
        };
        (oldObjs || newObjs).forEach(function(_, i) {
            var oldKey = oldObjs && extractKey(oldObjs[i]);
            var newKey = newObjs && extractKey(newObjs[i]);
            if ($2f895839ac78ac6c$var$cmp(oldKey, newKey) !== 0) {
                if (oldKey != null) addKeyOrKeys(oldKey);
                if (newKey != null) addKeyOrKeys(newKey);
            }
        });
    }
    schema.indexes.forEach(addAffectedIndex);
}
var $2f895839ac78ac6c$export$4ece27d405df7279 = function() {
    function Dexie(name, options) {
        var _this = this;
        this._middlewares = {};
        this.verno = 0;
        var deps = Dexie.dependencies;
        this._options = options = $2f895839ac78ac6c$var$__assign({
            addons: Dexie.addons,
            autoOpen: true,
            indexedDB: deps.indexedDB,
            IDBKeyRange: deps.IDBKeyRange
        }, options);
        this._deps = {
            indexedDB: options.indexedDB,
            IDBKeyRange: options.IDBKeyRange
        };
        var addons = options.addons;
        this._dbSchema = {};
        this._versions = [];
        this._storeNames = [];
        this._allTables = {};
        this.idbdb = null;
        this._novip = this;
        var state = {
            dbOpenError: null,
            isBeingOpened: false,
            onReadyBeingFired: null,
            openComplete: false,
            dbReadyResolve: $2f895839ac78ac6c$var$nop,
            dbReadyPromise: null,
            cancelOpen: $2f895839ac78ac6c$var$nop,
            openCanceller: null,
            autoSchema: true,
            PR1398_maxLoop: 3
        };
        state.dbReadyPromise = new $2f895839ac78ac6c$var$DexiePromise(function(resolve) {
            state.dbReadyResolve = resolve;
        });
        state.openCanceller = new $2f895839ac78ac6c$var$DexiePromise(function(_, reject) {
            state.cancelOpen = reject;
        });
        this._state = state;
        this.name = name;
        this.on = $2f895839ac78ac6c$var$Events(this, "populate", "blocked", "versionchange", "close", {
            ready: [
                $2f895839ac78ac6c$var$promisableChain,
                $2f895839ac78ac6c$var$nop
            ]
        });
        this.on.ready.subscribe = $2f895839ac78ac6c$var$override(this.on.ready.subscribe, function(subscribe) {
            return function(subscriber, bSticky) {
                Dexie.vip(function() {
                    var state = _this._state;
                    if (state.openComplete) {
                        if (!state.dbOpenError) $2f895839ac78ac6c$var$DexiePromise.resolve().then(subscriber);
                        if (bSticky) subscribe(subscriber);
                    } else if (state.onReadyBeingFired) {
                        state.onReadyBeingFired.push(subscriber);
                        if (bSticky) subscribe(subscriber);
                    } else {
                        subscribe(subscriber);
                        var db_1 = _this;
                        if (!bSticky) subscribe(function unsubscribe() {
                            db_1.on.ready.unsubscribe(subscriber);
                            db_1.on.ready.unsubscribe(unsubscribe);
                        });
                    }
                });
            };
        });
        this.Collection = $2f895839ac78ac6c$var$createCollectionConstructor(this);
        this.Table = $2f895839ac78ac6c$var$createTableConstructor(this);
        this.Transaction = $2f895839ac78ac6c$var$createTransactionConstructor(this);
        this.Version = $2f895839ac78ac6c$var$createVersionConstructor(this);
        this.WhereClause = $2f895839ac78ac6c$var$createWhereClauseConstructor(this);
        this.on("versionchange", function(ev) {
            if (ev.newVersion > 0) console.warn("Another connection wants to upgrade database '" + _this.name + "'. Closing db now to resume the upgrade.");
            else console.warn("Another connection wants to delete database '" + _this.name + "'. Closing db now to resume the delete request.");
            _this.close();
        });
        this.on("blocked", function(ev) {
            if (!ev.newVersion || ev.newVersion < ev.oldVersion) console.warn("Dexie.delete('" + _this.name + "') was blocked");
            else console.warn("Upgrade '" + _this.name + "' blocked by other connection holding version " + ev.oldVersion / 10);
        });
        this._maxKey = $2f895839ac78ac6c$var$getMaxKey(options.IDBKeyRange);
        this._createTransaction = function(mode, storeNames, dbschema, parentTransaction) {
            return new _this.Transaction(mode, storeNames, dbschema, _this._options.chromeTransactionDurability, parentTransaction);
        };
        this._fireOnBlocked = function(ev) {
            _this.on("blocked").fire(ev);
            $2f895839ac78ac6c$var$connections.filter(function(c) {
                return c.name === _this.name && c !== _this && !c._state.vcFired;
            }).map(function(c) {
                return c.on("versionchange").fire(ev);
            });
        };
        this.use($2f895839ac78ac6c$var$virtualIndexMiddleware);
        this.use($2f895839ac78ac6c$var$hooksMiddleware);
        this.use($2f895839ac78ac6c$var$observabilityMiddleware);
        this.use($2f895839ac78ac6c$var$cacheExistingValuesMiddleware);
        this.vip = Object.create(this, {
            _vip: {
                value: true
            }
        });
        addons.forEach(function(addon) {
            return addon(_this);
        });
    }
    Dexie.prototype.version = function(versionNumber) {
        if (isNaN(versionNumber) || versionNumber < 0.1) throw new $2f895839ac78ac6c$var$exceptions.Type("Given version is not a positive number");
        versionNumber = Math.round(versionNumber * 10) / 10;
        if (this.idbdb || this._state.isBeingOpened) throw new $2f895839ac78ac6c$var$exceptions.Schema("Cannot add version when database is open");
        this.verno = Math.max(this.verno, versionNumber);
        var versions = this._versions;
        var versionInstance = versions.filter(function(v) {
            return v._cfg.version === versionNumber;
        })[0];
        if (versionInstance) return versionInstance;
        versionInstance = new this.Version(versionNumber);
        versions.push(versionInstance);
        versions.sort($2f895839ac78ac6c$var$lowerVersionFirst);
        versionInstance.stores({});
        this._state.autoSchema = false;
        return versionInstance;
    };
    Dexie.prototype._whenReady = function(fn) {
        var _this = this;
        return this.idbdb && (this._state.openComplete || $2f895839ac78ac6c$var$PSD.letThrough || this._vip) ? fn() : new $2f895839ac78ac6c$var$DexiePromise(function(resolve, reject) {
            if (_this._state.openComplete) return reject(new $2f895839ac78ac6c$var$exceptions.DatabaseClosed(_this._state.dbOpenError));
            if (!_this._state.isBeingOpened) {
                if (!_this._options.autoOpen) {
                    reject(new $2f895839ac78ac6c$var$exceptions.DatabaseClosed());
                    return;
                }
                _this.open().catch($2f895839ac78ac6c$var$nop);
            }
            _this._state.dbReadyPromise.then(resolve, reject);
        }).then(fn);
    };
    Dexie.prototype.use = function(_a) {
        var stack = _a.stack, create = _a.create, level = _a.level, name = _a.name;
        if (name) this.unuse({
            stack: stack,
            name: name
        });
        var middlewares = this._middlewares[stack] || (this._middlewares[stack] = []);
        middlewares.push({
            stack: stack,
            create: create,
            level: level == null ? 10 : level,
            name: name
        });
        middlewares.sort(function(a, b) {
            return a.level - b.level;
        });
        return this;
    };
    Dexie.prototype.unuse = function(_a) {
        var stack = _a.stack, name = _a.name, create = _a.create;
        if (stack && this._middlewares[stack]) this._middlewares[stack] = this._middlewares[stack].filter(function(mw) {
            return create ? mw.create !== create : name ? mw.name !== name : false;
        });
        return this;
    };
    Dexie.prototype.open = function() {
        return $2f895839ac78ac6c$var$dexieOpen(this);
    };
    Dexie.prototype._close = function() {
        var state = this._state;
        var idx = $2f895839ac78ac6c$var$connections.indexOf(this);
        if (idx >= 0) $2f895839ac78ac6c$var$connections.splice(idx, 1);
        if (this.idbdb) {
            try {
                this.idbdb.close();
            } catch (e) {}
            this._novip.idbdb = null;
        }
        state.dbReadyPromise = new $2f895839ac78ac6c$var$DexiePromise(function(resolve) {
            state.dbReadyResolve = resolve;
        });
        state.openCanceller = new $2f895839ac78ac6c$var$DexiePromise(function(_, reject) {
            state.cancelOpen = reject;
        });
    };
    Dexie.prototype.close = function() {
        this._close();
        var state = this._state;
        this._options.autoOpen = false;
        state.dbOpenError = new $2f895839ac78ac6c$var$exceptions.DatabaseClosed();
        if (state.isBeingOpened) state.cancelOpen(state.dbOpenError);
    };
    Dexie.prototype.delete = function() {
        var _this = this;
        var hasArguments = arguments.length > 0;
        var state = this._state;
        return new $2f895839ac78ac6c$var$DexiePromise(function(resolve, reject) {
            var doDelete = function() {
                _this.close();
                var req = _this._deps.indexedDB.deleteDatabase(_this.name);
                req.onsuccess = $2f895839ac78ac6c$var$wrap(function() {
                    $2f895839ac78ac6c$var$_onDatabaseDeleted(_this._deps, _this.name);
                    resolve();
                });
                req.onerror = $2f895839ac78ac6c$var$eventRejectHandler(reject);
                req.onblocked = _this._fireOnBlocked;
            };
            if (hasArguments) throw new $2f895839ac78ac6c$var$exceptions.InvalidArgument("Arguments not allowed in db.delete()");
            if (state.isBeingOpened) state.dbReadyPromise.then(doDelete);
            else doDelete();
        });
    };
    Dexie.prototype.backendDB = function() {
        return this.idbdb;
    };
    Dexie.prototype.isOpen = function() {
        return this.idbdb !== null;
    };
    Dexie.prototype.hasBeenClosed = function() {
        var dbOpenError = this._state.dbOpenError;
        return dbOpenError && dbOpenError.name === "DatabaseClosed";
    };
    Dexie.prototype.hasFailed = function() {
        return this._state.dbOpenError !== null;
    };
    Dexie.prototype.dynamicallyOpened = function() {
        return this._state.autoSchema;
    };
    Object.defineProperty(Dexie.prototype, "tables", {
        get: function() {
            var _this = this;
            return $2f895839ac78ac6c$var$keys(this._allTables).map(function(name) {
                return _this._allTables[name];
            });
        },
        enumerable: false,
        configurable: true
    });
    Dexie.prototype.transaction = function() {
        var args = $2f895839ac78ac6c$var$extractTransactionArgs.apply(this, arguments);
        return this._transaction.apply(this, args);
    };
    Dexie.prototype._transaction = function(mode, tables, scopeFunc) {
        var _this = this;
        var parentTransaction = $2f895839ac78ac6c$var$PSD.trans;
        if (!parentTransaction || parentTransaction.db !== this || mode.indexOf("!") !== -1) parentTransaction = null;
        var onlyIfCompatible = mode.indexOf("?") !== -1;
        mode = mode.replace("!", "").replace("?", "");
        var idbMode, storeNames;
        try {
            storeNames = tables.map(function(table) {
                var storeName = table instanceof _this.Table ? table.name : table;
                if (typeof storeName !== "string") throw new TypeError("Invalid table argument to Dexie.transaction(). Only Table or String are allowed");
                return storeName;
            });
            if (mode == "r" || mode === $2f895839ac78ac6c$var$READONLY) idbMode = $2f895839ac78ac6c$var$READONLY;
            else if (mode == "rw" || mode == $2f895839ac78ac6c$var$READWRITE) idbMode = $2f895839ac78ac6c$var$READWRITE;
            else throw new $2f895839ac78ac6c$var$exceptions.InvalidArgument("Invalid transaction mode: " + mode);
            if (parentTransaction) {
                if (parentTransaction.mode === $2f895839ac78ac6c$var$READONLY && idbMode === $2f895839ac78ac6c$var$READWRITE) {
                    if (onlyIfCompatible) parentTransaction = null;
                    else throw new $2f895839ac78ac6c$var$exceptions.SubTransaction("Cannot enter a sub-transaction with READWRITE mode when parent transaction is READONLY");
                }
                if (parentTransaction) storeNames.forEach(function(storeName) {
                    if (parentTransaction && parentTransaction.storeNames.indexOf(storeName) === -1) {
                        if (onlyIfCompatible) parentTransaction = null;
                        else throw new $2f895839ac78ac6c$var$exceptions.SubTransaction("Table " + storeName + " not included in parent transaction.");
                    }
                });
                if (onlyIfCompatible && parentTransaction && !parentTransaction.active) parentTransaction = null;
            }
        } catch (e) {
            return parentTransaction ? parentTransaction._promise(null, function(_, reject) {
                reject(e);
            }) : $2f895839ac78ac6c$var$rejection(e);
        }
        var enterTransaction = $2f895839ac78ac6c$var$enterTransactionScope.bind(null, this, idbMode, storeNames, parentTransaction, scopeFunc);
        return parentTransaction ? parentTransaction._promise(idbMode, enterTransaction, "lock") : $2f895839ac78ac6c$var$PSD.trans ? $2f895839ac78ac6c$var$usePSD($2f895839ac78ac6c$var$PSD.transless, function() {
            return _this._whenReady(enterTransaction);
        }) : this._whenReady(enterTransaction);
    };
    Dexie.prototype.table = function(tableName) {
        if (!$2f895839ac78ac6c$var$hasOwn(this._allTables, tableName)) throw new $2f895839ac78ac6c$var$exceptions.InvalidTable("Table " + tableName + " does not exist");
        return this._allTables[tableName];
    };
    return Dexie;
}();
var $2f895839ac78ac6c$var$symbolObservable = typeof Symbol !== "undefined" && "observable" in Symbol ? Symbol.observable : "@@observable";
var $2f895839ac78ac6c$var$Observable = function() {
    function Observable(subscribe) {
        this._subscribe = subscribe;
    }
    Observable.prototype.subscribe = function(x, error, complete) {
        return this._subscribe(!x || typeof x === "function" ? {
            next: x,
            error: error,
            complete: complete
        } : x);
    };
    Observable.prototype[$2f895839ac78ac6c$var$symbolObservable] = function() {
        return this;
    };
    return Observable;
}();
function $2f895839ac78ac6c$var$extendObservabilitySet(target, newSet) {
    $2f895839ac78ac6c$var$keys(newSet).forEach(function(part) {
        var rangeSet = target[part] || (target[part] = new $2f895839ac78ac6c$export$34cb5241245008dd());
        $2f895839ac78ac6c$export$4876cc3130d3f820(rangeSet, newSet[part]);
    });
    return target;
}
function $2f895839ac78ac6c$export$6a9705d8f6f38796(querier) {
    var hasValue = false;
    var currentValue = undefined;
    var observable = new $2f895839ac78ac6c$var$Observable(function(observer) {
        var scopeFuncIsAsync = $2f895839ac78ac6c$var$isAsyncFunction(querier);
        function execute(subscr) {
            if (scopeFuncIsAsync) $2f895839ac78ac6c$var$incrementExpectedAwaits();
            var exec = function() {
                return $2f895839ac78ac6c$var$newScope(querier, {
                    subscr: subscr,
                    trans: null
                });
            };
            var rv = $2f895839ac78ac6c$var$PSD.trans ? $2f895839ac78ac6c$var$usePSD($2f895839ac78ac6c$var$PSD.transless, exec) : exec();
            if (scopeFuncIsAsync) rv.then($2f895839ac78ac6c$var$decrementExpectedAwaits, $2f895839ac78ac6c$var$decrementExpectedAwaits);
            return rv;
        }
        var closed = false;
        var accumMuts = {};
        var currentObs = {};
        var subscription = {
            get closed () {
                return closed;
            },
            unsubscribe: function() {
                closed = true;
                $2f895839ac78ac6c$var$globalEvents.storagemutated.unsubscribe(mutationListener);
            }
        };
        observer.start && observer.start(subscription);
        var querying = false, startedListening = false;
        function shouldNotify() {
            return $2f895839ac78ac6c$var$keys(currentObs).some(function(key) {
                return accumMuts[key] && $2f895839ac78ac6c$export$8f43b23b5d8de905(accumMuts[key], currentObs[key]);
            });
        }
        var mutationListener = function(parts) {
            $2f895839ac78ac6c$var$extendObservabilitySet(accumMuts, parts);
            if (shouldNotify()) doQuery();
        };
        var doQuery = function() {
            if (querying || closed) return;
            accumMuts = {};
            var subscr = {};
            var ret = execute(subscr);
            if (!startedListening) {
                $2f895839ac78ac6c$var$globalEvents($2f895839ac78ac6c$var$DEXIE_STORAGE_MUTATED_EVENT_NAME, mutationListener);
                startedListening = true;
            }
            querying = true;
            Promise.resolve(ret).then(function(result) {
                hasValue = true;
                currentValue = result;
                querying = false;
                if (closed) return;
                if (shouldNotify()) doQuery();
                else {
                    accumMuts = {};
                    currentObs = subscr;
                    observer.next && observer.next(result);
                }
            }, function(err) {
                querying = false;
                hasValue = false;
                observer.error && observer.error(err);
                subscription.unsubscribe();
            });
        };
        doQuery();
        return subscription;
    });
    observable.hasValue = function() {
        return hasValue;
    };
    observable.getValue = function() {
        return currentValue;
    };
    return observable;
}
var $2f895839ac78ac6c$var$domDeps;
try {
    $2f895839ac78ac6c$var$domDeps = {
        indexedDB: $2f895839ac78ac6c$var$_global.indexedDB || $2f895839ac78ac6c$var$_global.mozIndexedDB || $2f895839ac78ac6c$var$_global.webkitIndexedDB || $2f895839ac78ac6c$var$_global.msIndexedDB,
        IDBKeyRange: $2f895839ac78ac6c$var$_global.IDBKeyRange || $2f895839ac78ac6c$var$_global.webkitIDBKeyRange
    };
} catch (e) {
    $2f895839ac78ac6c$var$domDeps = {
        indexedDB: null,
        IDBKeyRange: null
    };
}
var $2f895839ac78ac6c$var$Dexie = $2f895839ac78ac6c$export$4ece27d405df7279;
$2f895839ac78ac6c$var$props($2f895839ac78ac6c$var$Dexie, $2f895839ac78ac6c$var$__assign($2f895839ac78ac6c$var$__assign({}, $2f895839ac78ac6c$var$fullNameExceptions), {
    delete: function(databaseName) {
        var db = new $2f895839ac78ac6c$var$Dexie(databaseName, {
            addons: []
        });
        return db.delete();
    },
    exists: function(name) {
        return new $2f895839ac78ac6c$var$Dexie(name, {
            addons: []
        }).open().then(function(db) {
            db.close();
            return true;
        }).catch("NoSuchDatabaseError", function() {
            return false;
        });
    },
    getDatabaseNames: function(cb) {
        try {
            return $2f895839ac78ac6c$var$getDatabaseNames($2f895839ac78ac6c$var$Dexie.dependencies).then(cb);
        } catch (_a) {
            return $2f895839ac78ac6c$var$rejection(new $2f895839ac78ac6c$var$exceptions.MissingAPI());
        }
    },
    defineClass: function() {
        function Class(content) {
            $2f895839ac78ac6c$var$extend(this, content);
        }
        return Class;
    },
    ignoreTransaction: function(scopeFunc) {
        return $2f895839ac78ac6c$var$PSD.trans ? $2f895839ac78ac6c$var$usePSD($2f895839ac78ac6c$var$PSD.transless, scopeFunc) : scopeFunc();
    },
    vip: $2f895839ac78ac6c$var$vip,
    async: function(generatorFn) {
        return function() {
            try {
                var rv = $2f895839ac78ac6c$var$awaitIterator(generatorFn.apply(this, arguments));
                if (!rv || typeof rv.then !== "function") return $2f895839ac78ac6c$var$DexiePromise.resolve(rv);
                return rv;
            } catch (e) {
                return $2f895839ac78ac6c$var$rejection(e);
            }
        };
    },
    spawn: function(generatorFn, args, thiz) {
        try {
            var rv = $2f895839ac78ac6c$var$awaitIterator(generatorFn.apply(thiz, args || []));
            if (!rv || typeof rv.then !== "function") return $2f895839ac78ac6c$var$DexiePromise.resolve(rv);
            return rv;
        } catch (e) {
            return $2f895839ac78ac6c$var$rejection(e);
        }
    },
    currentTransaction: {
        get: function() {
            return $2f895839ac78ac6c$var$PSD.trans || null;
        }
    },
    waitFor: function(promiseOrFunction, optionalTimeout) {
        var promise = $2f895839ac78ac6c$var$DexiePromise.resolve(typeof promiseOrFunction === "function" ? $2f895839ac78ac6c$var$Dexie.ignoreTransaction(promiseOrFunction) : promiseOrFunction).timeout(optionalTimeout || 60000);
        return $2f895839ac78ac6c$var$PSD.trans ? $2f895839ac78ac6c$var$PSD.trans.waitFor(promise) : promise;
    },
    Promise: $2f895839ac78ac6c$var$DexiePromise,
    debug: {
        get: function() {
            return $2f895839ac78ac6c$var$debug;
        },
        set: function(value) {
            $2f895839ac78ac6c$var$setDebug(value, value === "dexie" ? function() {
                return true;
            } : $2f895839ac78ac6c$var$dexieStackFrameFilter);
        }
    },
    derive: $2f895839ac78ac6c$var$derive,
    extend: $2f895839ac78ac6c$var$extend,
    props: $2f895839ac78ac6c$var$props,
    override: $2f895839ac78ac6c$var$override,
    Events: $2f895839ac78ac6c$var$Events,
    on: $2f895839ac78ac6c$var$globalEvents,
    liveQuery: $2f895839ac78ac6c$export$6a9705d8f6f38796,
    extendObservabilitySet: $2f895839ac78ac6c$var$extendObservabilitySet,
    getByKeyPath: $2f895839ac78ac6c$var$getByKeyPath,
    setByKeyPath: $2f895839ac78ac6c$var$setByKeyPath,
    delByKeyPath: $2f895839ac78ac6c$var$delByKeyPath,
    shallowClone: $2f895839ac78ac6c$var$shallowClone,
    deepClone: $2f895839ac78ac6c$var$deepClone,
    getObjectDiff: $2f895839ac78ac6c$var$getObjectDiff,
    cmp: $2f895839ac78ac6c$var$cmp,
    asap: $2f895839ac78ac6c$var$asap$1,
    minKey: $2f895839ac78ac6c$var$minKey,
    addons: [],
    connections: $2f895839ac78ac6c$var$connections,
    errnames: $2f895839ac78ac6c$var$errnames,
    dependencies: $2f895839ac78ac6c$var$domDeps,
    semVer: $2f895839ac78ac6c$var$DEXIE_VERSION,
    version: $2f895839ac78ac6c$var$DEXIE_VERSION.split(".").map(function(n) {
        return parseInt(n);
    }).reduce(function(p, c, i) {
        return p + c / Math.pow(10, i * 2);
    })
}));
$2f895839ac78ac6c$var$Dexie.maxKey = $2f895839ac78ac6c$var$getMaxKey($2f895839ac78ac6c$var$Dexie.dependencies.IDBKeyRange);
if (typeof dispatchEvent !== "undefined" && typeof addEventListener !== "undefined") {
    $2f895839ac78ac6c$var$globalEvents($2f895839ac78ac6c$var$DEXIE_STORAGE_MUTATED_EVENT_NAME, function(updatedParts) {
        if (!$2f895839ac78ac6c$var$propagatingLocally) {
            var event_1;
            if ($2f895839ac78ac6c$var$isIEOrEdge) {
                event_1 = document.createEvent("CustomEvent");
                event_1.initCustomEvent($2f895839ac78ac6c$var$STORAGE_MUTATED_DOM_EVENT_NAME, true, true, updatedParts);
            } else event_1 = new CustomEvent($2f895839ac78ac6c$var$STORAGE_MUTATED_DOM_EVENT_NAME, {
                detail: updatedParts
            });
            $2f895839ac78ac6c$var$propagatingLocally = true;
            dispatchEvent(event_1);
            $2f895839ac78ac6c$var$propagatingLocally = false;
        }
    });
    addEventListener($2f895839ac78ac6c$var$STORAGE_MUTATED_DOM_EVENT_NAME, function(_a) {
        var detail = _a.detail;
        if (!$2f895839ac78ac6c$var$propagatingLocally) $2f895839ac78ac6c$var$propagateLocally(detail);
    });
}
function $2f895839ac78ac6c$var$propagateLocally(updateParts) {
    var wasMe = $2f895839ac78ac6c$var$propagatingLocally;
    try {
        $2f895839ac78ac6c$var$propagatingLocally = true;
        $2f895839ac78ac6c$var$globalEvents.storagemutated.fire(updateParts);
    } finally{
        $2f895839ac78ac6c$var$propagatingLocally = wasMe;
    }
}
var $2f895839ac78ac6c$var$propagatingLocally = false;
if (typeof BroadcastChannel !== "undefined") {
    var $2f895839ac78ac6c$var$bc_1 = new BroadcastChannel($2f895839ac78ac6c$var$STORAGE_MUTATED_DOM_EVENT_NAME);
    if (typeof $2f895839ac78ac6c$var$bc_1.unref === "function") $2f895839ac78ac6c$var$bc_1.unref();
    $2f895839ac78ac6c$var$globalEvents($2f895839ac78ac6c$var$DEXIE_STORAGE_MUTATED_EVENT_NAME, function(changedParts) {
        if (!$2f895839ac78ac6c$var$propagatingLocally) $2f895839ac78ac6c$var$bc_1.postMessage(changedParts);
    });
    $2f895839ac78ac6c$var$bc_1.onmessage = function(ev) {
        if (ev.data) $2f895839ac78ac6c$var$propagateLocally(ev.data);
    };
} else if (typeof self !== "undefined" && typeof navigator !== "undefined") {
    $2f895839ac78ac6c$var$globalEvents($2f895839ac78ac6c$var$DEXIE_STORAGE_MUTATED_EVENT_NAME, function(changedParts) {
        try {
            if (!$2f895839ac78ac6c$var$propagatingLocally) {
                if (typeof localStorage !== "undefined") localStorage.setItem($2f895839ac78ac6c$var$STORAGE_MUTATED_DOM_EVENT_NAME, JSON.stringify({
                    trig: Math.random(),
                    changedParts: changedParts
                }));
                if (typeof self["clients"] === "object") $2f895839ac78ac6c$var$__spreadArray([], self["clients"].matchAll({
                    includeUncontrolled: true
                }), true).forEach(function(client) {
                    return client.postMessage({
                        type: $2f895839ac78ac6c$var$STORAGE_MUTATED_DOM_EVENT_NAME,
                        changedParts: changedParts
                    });
                });
            }
        } catch (_a) {}
    });
    if (typeof addEventListener !== "undefined") addEventListener("storage", function(ev) {
        if (ev.key === $2f895839ac78ac6c$var$STORAGE_MUTATED_DOM_EVENT_NAME) {
            var data = JSON.parse(ev.newValue);
            if (data) $2f895839ac78ac6c$var$propagateLocally(data.changedParts);
        }
    });
    var $2f895839ac78ac6c$var$swContainer = self.document && navigator.serviceWorker;
    if ($2f895839ac78ac6c$var$swContainer) $2f895839ac78ac6c$var$swContainer.addEventListener("message", $2f895839ac78ac6c$var$propagateMessageLocally);
}
function $2f895839ac78ac6c$var$propagateMessageLocally(_a) {
    var data = _a.data;
    if (data && data.type === $2f895839ac78ac6c$var$STORAGE_MUTATED_DOM_EVENT_NAME) $2f895839ac78ac6c$var$propagateLocally(data.changedParts);
}
$2f895839ac78ac6c$var$DexiePromise.rejectionMapper = $2f895839ac78ac6c$var$mapError;
$2f895839ac78ac6c$var$setDebug($2f895839ac78ac6c$var$debug, $2f895839ac78ac6c$var$dexieStackFrameFilter);


class $fd79700e0f6f08d4$export$d439958a9961dbbc extends (0, $2f895839ac78ac6c$export$4ece27d405df7279) {
    constructor(){
        super("Backup");
        this.version(1).stores({
            backups: "id, time"
        });
    }
}
const $fd79700e0f6f08d4$export$f932f06c7eb6abeb = new $fd79700e0f6f08d4$export$d439958a9961dbbc();
const $fd79700e0f6f08d4$export$1997f6ea336e26a5 = 2592000000 /* milli */ ;
async function $fd79700e0f6f08d4$export$a6c8cf72f69c662e() {
    const oldest = Date.now() - $fd79700e0f6f08d4$export$1997f6ea336e26a5;
    await $fd79700e0f6f08d4$export$f932f06c7eb6abeb.backups.where("time").below(oldest).delete();
}
function $fd79700e0f6f08d4$export$798ee5a9ebd31905(id, json) {
    return $fd79700e0f6f08d4$export$f932f06c7eb6abeb.backups.put({
        id: id,
        time: Date.now(),
        json: json
    });
}




var $acw62 = parcelRequire("acw62");

const $e5d64ba8b4982876$var$MOVE_ANIMATION_MS = 300;
const $e5d64ba8b4982876$var$POSITION_TRANSITION = `${$e5d64ba8b4982876$var$MOVE_ANIMATION_MS}ms ease-out`;
function $e5d64ba8b4982876$export$20d57ec54361e185() {
    const [focusRect, showFocusChange] = $e5d64ba8b4982876$var$useFocusRect();
    const [animationRunning, setAnimationRunning] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        setAnimationRunning(true);
        const animationStopped = setTimeout(()=>{
            setAnimationRunning(false);
        }, $e5d64ba8b4982876$var$MOVE_ANIMATION_MS);
        return ()=>{
            clearTimeout(animationStopped);
        };
    }, [
        focusRect
    ]);
    if (!focusRect) return null;
    const visible = animationRunning && showFocusChange;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "border-4 border-blue-500/20 pointer-events-none print:hidden",
        style: {
            opacity: visible ? 1 : 0,
            transition: [
                "left " + $e5d64ba8b4982876$var$POSITION_TRANSITION,
                "top " + $e5d64ba8b4982876$var$POSITION_TRANSITION,
                "width " + $e5d64ba8b4982876$var$POSITION_TRANSITION,
                "height " + $e5d64ba8b4982876$var$POSITION_TRANSITION
            ].join(", "),
            position: "absolute",
            left: focusRect.left + "px",
            top: focusRect.top + "px",
            width: focusRect.width + "px",
            height: focusRect.height + "px"
        }
    });
}
function $e5d64ba8b4982876$var$useFocusRect() {
    const [[rect, showFocusChange], setRect] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([
        null,
        true
    ]);
    const rectRef = (0, $ff99259e85546794$export$4debdb1a3f0fa79e)(rect);
    function updateRect(ev) {
        const [gainsFocus, loosesFocus] = ev.type === "focusin" ? [
            ev.target,
            ev.relatedTarget
        ] : [
            ev.relatedTarget,
            ev.target
        ];
        if (gainsFocus === null || !(gainsFocus instanceof HTMLElement)) {
            if (rectRef.current !== null) setRect([
                null,
                true
            ]);
            return;
        }
        // Only show focus change between parent/child
        const gainsLoosesAreSiblings = loosesFocus instanceof HTMLElement && gainsFocus instanceof HTMLElement && !gainsFocus.contains(loosesFocus) && !loosesFocus.contains(gainsFocus);
        const newRect = gainsFocus.getBoundingClientRect();
        if (rectRef.current?.x === newRect.x && rectRef.current?.y === newRect.y && rectRef.current?.width === newRect.width && rectRef.current?.height === newRect.height) return;
        setRect([
            newRect,
            !gainsLoosesAreSiblings
        ]);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        document.body.addEventListener("focusin", updateRect);
        document.body.addEventListener("focusout", updateRect);
        return ()=>{
            document.body.removeEventListener("focusin", updateRect);
            document.body.removeEventListener("focusout", updateRect);
        };
    }, []);
    return [
        rect,
        showFocusChange
    ];
}




var $acw62 = parcelRequire("acw62");



function $9f1f42eeb68baf7e$export$954d29d83c7dbaa5({ id: id, show: show, text: text, removeToast: removeToast, undoAction: undoAction }) {
    const [visible, setVisible] = $acw62.useState(true);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $030a82c6b2bb6f00$export$be58926105124dd4), {
        show: show && visible,
        appear: true,
        enter: "transition-[opacity] duration-150",
        enterFrom: "opacity-0",
        leave: "transition-[opacity,max-height] duration-1000 overflow-y-clip",
        leaveFrom: "max-h-24",
        leaveTo: "opacity-0 max-h-0",
        afterLeave: ()=>removeToast(id),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: `
                    relative flex flex-row max-w-48 cursor-default
                    rounded overflow-clip my-1 bg-gray-200 shadow
                    opacity-70 hover:opacity-100
                    text-xs text-gray-500 hover:text-gray-800
                `,
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $030a82c6b2bb6f00$export$be58926105124dd4), {
                    appear: true,
                    className: "absolute left-0 top-0 h-1 bg-gray-400/20",
                    enter: "transition-[width] ease-linear duration-[10000ms]",
                    enterFrom: "w-0",
                    enterTo: "w-full",
                    entered: "w-full",
                    afterEnter: ()=>setVisible(false)
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "flex-1 text-ellipsis mx-2 my-1",
                    children: text
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                    className: "w-5 hover:bg-gray-300",
                    onClick: ()=>{
                        visible && undoAction();
                        setVisible(false);
                    },
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e4ec753f5c716375$export$2b9260d4a45c8710), {
                        icon: $d8206b3ab2e65c05$export$89b706873769c180
                    })
                })
            ]
        })
    });
}
function $9f1f42eeb68baf7e$export$da20382cd052c085(undoState) {
    const [toasts, setToasts] = $acw62.useState([]);
    const addToast = $acw62.useCallback(function addToast(description, state) {
        setToasts((current)=>[
                {
                    id: 1 + (current[0]?.id ?? -1),
                    description: description,
                    undo: state
                },
                ...current
            ]);
    }, [
        setToasts
    ]);
    const removeToast = $acw62.useCallback(function removeToast(id) {
        setToasts((current)=>current.filter((toast)=>toast.id !== id));
    }, [
        setToasts
    ]);
    const ui = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "absolute top-2 right-2 z-50 flex flex-col items-end print:hidden",
        children: toasts.map(({ id: id, description: description, undo: undo }, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($9f1f42eeb68baf7e$export$954d29d83c7dbaa5, {
                id: id,
                show: index === 0,
                text: description,
                undoAction: ()=>undoState(undo, description),
                removeToast: removeToast
            }, id)).reverse()
    });
    return [
        ui,
        addToast
    ];
}


var $e6485d8914a12b96$export$2e2bcd8739ae039 = {
    "history": [],
    "inner": {
        "t": "resheet.document",
        "v": 1,
        "pages": [
            {
                "id": 4,
                "name": "Landing Page",
                "state": {
                    "t": "resheet.selector",
                    "v": 0,
                    "mode": "run",
                    "expr": "SheetOf(Note)",
                    "inner": {
                        "t": "resheet.sheet",
                        "v": 2,
                        "lines": [
                            {
                                "id": 0,
                                "name": "",
                                "visibility": "result",
                                "width": "narrow",
                                "state": {
                                    "t": "resheet.note",
                                    "v": 1,
                                    "level": 0,
                                    "input": "/Code",
                                    "note": {
                                        "type": "block",
                                        "isInstantiated": true,
                                        "code": "Code",
                                        "state": '<>\n  {/* background hack */}\n  <div\n    className={`\n      absolute z-[-1]\n      left-[-10rem] top-[-4rem]\n      w-[calc(100vw_+_10rem)] h-[min(30rem,_40vw_+_10rem)]\n      bg-gradient-to-br from-sky-400 to-cyan-200\n      shadow-xl shadow-gray-200/30\n    `}\n  />\n    \n  <h1 className="flex space-x-2 justify-center items-baseline my-2 text-5xl">\n    <img className="h-12 brightness-125" src={resheet.assets.logoSvg} alt="ReSheet Logo"/>\n    <span>ReSheet</span>\n    <span className="text-2xl">beta</span>\n  </h1>\n</>'
                                    }
                                }
                            },
                            {
                                "id": 41,
                                "name": "",
                                "visibility": "block",
                                "width": "narrow",
                                "state": {
                                    "t": "resheet.note",
                                    "v": 1,
                                    "level": 0,
                                    "input": '<div className="text-center text-xl">A hackable notes-spreadsheet-hybrid for programmers</div>',
                                    "note": {
                                        "type": "text",
                                        "tag": "p",
                                        "text": '<div className="text-center text-xl">A hackable notes-spreadsheet-hybrid for programmers</div>'
                                    }
                                }
                            },
                            {
                                "id": 108,
                                "name": "",
                                "visibility": "block",
                                "width": "narrow",
                                "state": {
                                    "t": "resheet.note",
                                    "v": 1,
                                    "level": 0,
                                    "input": "",
                                    "note": {
                                        "type": "text",
                                        "tag": "p",
                                        "text": ""
                                    }
                                }
                            },
                            {
                                "id": 90,
                                "name": "",
                                "visibility": "result",
                                "width": "full",
                                "state": {
                                    "t": "resheet.note",
                                    "v": 1,
                                    "level": 0,
                                    "input": '= <div className="mx-auto my-4 w-full max-w-[900px]">{Demo}</div>',
                                    "note": {
                                        "type": "expr",
                                        "code": ' <div className="mx-auto my-4 w-full max-w-[900px]">{Demo}</div>'
                                    }
                                }
                            },
                            {
                                "id": 124,
                                "name": "",
                                "visibility": "block",
                                "width": "full",
                                "state": {
                                    "t": "resheet.note",
                                    "v": 1,
                                    "level": 0,
                                    "input": '<div class="h-64"/>',
                                    "note": {
                                        "type": "text",
                                        "tag": "p",
                                        "text": '<div class="h-64"/>'
                                    }
                                }
                            },
                            {
                                "id": 97,
                                "name": "",
                                "visibility": "result",
                                "width": "full",
                                "state": {
                                    "t": "resheet.note",
                                    "v": 1,
                                    "level": 0,
                                    "input": "/Code",
                                    "note": {
                                        "type": "block",
                                        "isInstantiated": true,
                                        "code": "Code",
                                        "state": '<Components.Section>\n  <Components.Hero\n    title="ReSheet is a notepad similar to Notion"\n    description="Organize notes, todos and more in a structure of folders"\n    img={Examples.notepad}\n    />\n</Components.Section>'
                                    }
                                }
                            },
                            {
                                "id": 110,
                                "name": "",
                                "visibility": "result",
                                "width": "full",
                                "state": {
                                    "t": "resheet.note",
                                    "v": 1,
                                    "level": 0,
                                    "input": "/Code",
                                    "note": {
                                        "type": "block",
                                        "isInstantiated": true,
                                        "code": "Code",
                                        "state": '<Components.Hero\n  reverse\n  title="But with the power of JavaScript and React"\n  description="Create sophisticated spreadsheets using their vast ecosystems"\n  img={Examples.formulas}\n  />'
                                    }
                                }
                            },
                            {
                                "id": 111,
                                "name": "",
                                "visibility": "result",
                                "width": "full",
                                "state": {
                                    "t": "resheet.note",
                                    "v": 1,
                                    "level": 0,
                                    "input": "/Code",
                                    "note": {
                                        "type": "block",
                                        "isInstantiated": true,
                                        "code": "Code",
                                        "state": '<Components.Section>\n  <Components.Hero\n    title="Highly extensible through custom Blocks"\n    description="The only limit is the browser and JavaScript"\n    img={Examples.extensibility}\n    />\n</Components.Section>'
                                    }
                                }
                            },
                            {
                                "id": 122,
                                "name": "",
                                "visibility": "result",
                                "width": "full",
                                "state": {
                                    "t": "resheet.note",
                                    "v": 1,
                                    "level": 0,
                                    "input": "/Code",
                                    "note": {
                                        "type": "block",
                                        "isInstantiated": true,
                                        "code": "Code",
                                        "state": '<section\n  className="flex flex-col min-h-[80vh] py-40 justify-evenly"\n>\n  <div>\n    <h2 className="text-center text-3xl text-yellow-500 font-medium">\n      Start using ReSheet\n    </h2>\n    <div className="mt-4 text-center text-zinc-600">\n      by editing this document\n    </div>\n  </div>\n  \n  \n  <details className="rounded-lg mx-auto max-w-prose w-fit space-y-5 px-4 py-2 rounded open:bg-sky-50">\n    <summary className="text-xl text-gray-600">\n      What can I do?\n    </summary>\n    <p>\n      Edit any element by clicking or double-clicking on it. <kbd className="text-yellow-600">\u2318\u23CE</kbd> /\n      <kbd className="text-yellow-600">Ctrl-Enter</kbd> will\n      generally give you a new line.\n    </p>\n    <p>\n      Open the sidebar with the <FontAwesomeIcon className="mx-0.5 text-yellow-600" icon={faSolid.faBars} />-button on the top left to see\n      other pages.\n    </p>\n    <p>\n      Create a new page, a new document, or view the docs and example pages in\n      the sidebar.\n    </p>\n  </details>\n</section>'
                                    }
                                }
                            },
                            {
                                "id": 102,
                                "name": "",
                                "visibility": "block",
                                "width": "full",
                                "state": {
                                    "t": "resheet.note",
                                    "v": 1,
                                    "level": 0,
                                    "input": "---",
                                    "note": {
                                        "type": "text",
                                        "tag": "p",
                                        "text": "---"
                                    }
                                }
                            },
                            {
                                "id": 101,
                                "name": "",
                                "visibility": "block",
                                "width": "narrow",
                                "state": {
                                    "t": "resheet.note",
                                    "v": 1,
                                    "level": 0,
                                    "input": '<p class="text-center">ReSheet is <span class="text-yellow-600">open source</span> under the permissive MIT license.</p>',
                                    "note": {
                                        "type": "text",
                                        "tag": "p",
                                        "text": '<p class="text-center">ReSheet is <span class="text-yellow-600">open source</span> under the permissive MIT license.</p>'
                                    }
                                }
                            },
                            {
                                "id": 107,
                                "name": "",
                                "visibility": "block",
                                "width": "narrow",
                                "state": {
                                    "t": "resheet.note",
                                    "v": 1,
                                    "level": 0,
                                    "input": '<p class="text-center">ReSheet on [GitHub](https://github.com/keenbug/ReSheet/) | [Discord](https://discord.gg/TQePmKJNQP) | [Bluesky](https://bsky.app/profile/resheet.dev) | [X](https://x.com/resheetdev)</p>',
                                    "note": {
                                        "type": "text",
                                        "tag": "p",
                                        "text": '<p class="text-center">ReSheet on [GitHub](https://github.com/keenbug/ReSheet/) | [Discord](https://discord.gg/TQePmKJNQP) | [Bluesky](https://bsky.app/profile/resheet.dev) | [X](https://x.com/resheetdev)</p>'
                                    }
                                }
                            },
                            {
                                "id": 125,
                                "name": "",
                                "visibility": "result",
                                "width": "narrow",
                                "state": {
                                    "t": "resheet.note",
                                    "v": 1,
                                    "level": 0,
                                    "input": '= <p className="text-center"><Components.MailTo recipient="contact" domain="danielkrueger.dev">Contact me</Components.MailTo></p>',
                                    "note": {
                                        "type": "expr",
                                        "code": ' <p className="text-center"><Components.MailTo recipient="contact" domain="danielkrueger.dev">Contact me</Components.MailTo></p>'
                                    }
                                }
                            },
                            {
                                "id": 126,
                                "name": "",
                                "visibility": "block",
                                "width": "narrow",
                                "state": {
                                    "t": "resheet.note",
                                    "v": 1,
                                    "level": 0,
                                    "input": "",
                                    "note": {
                                        "type": "text",
                                        "tag": "p",
                                        "text": ""
                                    }
                                }
                            }
                        ]
                    }
                },
                "isCollapsed": true,
                "children": [
                    {
                        "id": 0,
                        "name": "Components",
                        "state": {
                            "t": "resheet.selector",
                            "v": 0,
                            "mode": "run",
                            "expr": "SheetOf(Note)",
                            "inner": {
                                "t": "resheet.sheet",
                                "v": 2,
                                "lines": [
                                    {
                                        "id": 6,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "# Components",
                                            "note": {
                                                "type": "text",
                                                "tag": "h1",
                                                "text": "Components"
                                            }
                                        }
                                    },
                                    {
                                        "id": 7,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "The components used on the landing page",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": "The components used on the landing page"
                                            }
                                        }
                                    },
                                    {
                                        "id": 8,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 9,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "## Hero",
                                            "note": {
                                                "type": "text",
                                                "tag": "h2",
                                                "text": "Hero"
                                            }
                                        }
                                    },
                                    {
                                        "id": 0,
                                        "name": "Hero",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "/Code",
                                            "note": {
                                                "type": "block",
                                                "isInstantiated": true,
                                                "code": "Code",
                                                "state": 'function Hero({ title, description, img, reverse=false }) {\n  return (\n    <div\n      className={`\n        max-w-screen-xl mx-auto my-10 lg:my-40\n        flex flex-col justify-stretch items-center\n        lg:${reverse ? \'flex-row-reverse\' : \'flex-row\'}\n      `}\n    >\n      {img}\n      <div className="my-12 mx-16">\n        <h3 className="text-2xl text-black font-light">\n          {title}\n        </h3>\n        {description &&\n          <p className="mt-3 text-gray-800">{description}</p>\n        }\n      </div>\n    </div>\n  )\n}'
                                            }
                                        }
                                    },
                                    {
                                        "id": 2,
                                        "name": "heroExample",
                                        "visibility": "block",
                                        "width": "wide",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "/Code",
                                            "note": {
                                                "type": "block",
                                                "isInstantiated": true,
                                                "code": "Code",
                                                "state": '<Hero\n  title="ReSheet is a notepad similar to Notion"\n  description="Organize notes, todos and more in a structure of folders"\n  img={<div className="w-1/2 aspect-video bg-gray-100 rounded-lg shadow-lg" />}\n  />'
                                            }
                                        }
                                    },
                                    {
                                        "id": 15,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "wide",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 16,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "wide",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 17,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "## Section",
                                            "note": {
                                                "type": "text",
                                                "tag": "h2",
                                                "text": "Section"
                                            }
                                        }
                                    },
                                    {
                                        "id": 18,
                                        "name": "Section",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "/Code",
                                            "note": {
                                                "type": "block",
                                                "isInstantiated": true,
                                                "code": "Code",
                                                "state": 'function Section({ children }) {\n  return (\n    <div className="rounded-lg bg-gradient-to-tl from-sky-200 to-cyan-100 py-4 px-2 sm:mx-4">\n      {children}\n    </div>\n  )\n}'
                                            }
                                        }
                                    },
                                    {
                                        "id": 19,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "wide",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "= <Section>{heroExample}</Section>",
                                            "note": {
                                                "type": "expr",
                                                "code": " <Section>{heroExample}</Section>"
                                            }
                                        }
                                    },
                                    {
                                        "id": 3,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 11,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 14,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "## MailTo",
                                            "note": {
                                                "type": "text",
                                                "tag": "h2",
                                                "text": "MailTo"
                                            }
                                        }
                                    },
                                    {
                                        "id": 12,
                                        "name": "MailTo",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "/Code",
                                            "note": {
                                                "type": "block",
                                                "isInstantiated": true,
                                                "code": "Code",
                                                "state": "function MailTo({ recipient, domain, children }) {\n  function sendMail() {\n    const elem = document.createElement('a')\n    elem.href = `mailto:${recipient}@${domain}`\n    elem.click()\n  }\n  \n  return <a className=\"text-blue-800 cursor-pointer\" onClick={sendMail}>{children}</a>\n}"
                                            }
                                        }
                                    },
                                    {
                                        "id": 13,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": '= <MailTo recipient="contact" domain="danielkrueger.dev">Send me an email</MailTo>',
                                            "note": {
                                                "type": "expr",
                                                "code": ' <MailTo recipient="contact" domain="danielkrueger.dev">Send me an email</MailTo>'
                                            }
                                        }
                                    },
                                    {
                                        "id": 4,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 10,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "---",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": "---"
                                            }
                                        }
                                    },
                                    {
                                        "id": 5,
                                        "name": "exports",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "= ({ Hero, Section, MailTo })",
                                            "note": {
                                                "type": "expr",
                                                "code": " ({ Hero, Section, MailTo })"
                                            }
                                        }
                                    }
                                ]
                            }
                        },
                        "isCollapsed": false,
                        "children": []
                    },
                    {
                        "id": 1,
                        "name": "Examples",
                        "state": {
                            "t": "resheet.selector",
                            "v": 0,
                            "mode": "run",
                            "expr": "SheetOf(Note)",
                            "inner": {
                                "t": "resheet.sheet",
                                "v": 2,
                                "lines": [
                                    {
                                        "id": 18,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "# Examples",
                                            "note": {
                                                "type": "text",
                                                "tag": "h1",
                                                "text": "Examples"
                                            }
                                        }
                                    },
                                    {
                                        "id": 19,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "The small example documents shown on the landing page.",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": "The small example documents shown on the landing page."
                                            }
                                        }
                                    },
                                    {
                                        "id": 20,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 21,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 2,
                                        "name": "Example",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "/Code",
                                            "note": {
                                                "type": "block",
                                                "isInstantiated": true,
                                                "code": "Code",
                                                "state": "function Example({ template, scale=0.75 }) {\n  const env = library\n  const [state, dispatch] = resheet.core.block.useBlockDispatcher(template.init, [{ env }])\n\n  return (\n    <div className={`\n      w-full max-w-screen-sm lg:max-w-full lg:w-1/2\n      h-[50vh] sm:h-fit sm:aspect-video\n      rounded-xl border border-gray-100\n      bg-white shadow-md overflow-clip\n    `}>\n      <div className={`w-[${100 / scale}%] h-[${100 / scale}%] origin-top-left scale-[${scale}]`}>\n        {template.view({ state, dispatch, env })}\n      </div>\n    </div>\n  )\n}"
                                            }
                                        }
                                    },
                                    {
                                        "id": 22,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "#### Usage",
                                            "note": {
                                                "type": "text",
                                                "tag": "h4",
                                                "text": "Usage"
                                            }
                                        }
                                    },
                                    {
                                        "id": 23,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "= <Example template={DocumentOf(Code)} scale={0.5} />",
                                            "note": {
                                                "type": "expr",
                                                "code": " <Example template={DocumentOf(Code)} scale={0.5} />"
                                            }
                                        }
                                    },
                                    {
                                        "id": 3,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 7,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "### Notepad",
                                            "note": {
                                                "type": "text",
                                                "tag": "h3",
                                                "text": "Notepad"
                                            }
                                        }
                                    },
                                    {
                                        "id": 0,
                                        "name": "notepad",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "/Debug.Inspect(DocumentOf(SheetOf(Note)))",
                                            "note": {
                                                "type": "block",
                                                "isInstantiated": true,
                                                "code": "Debug.Inspect(DocumentOf(SheetOf(Note)))",
                                                "state": {
                                                    "history": [],
                                                    "inner": {
                                                        "t": "resheet.document",
                                                        "v": 1,
                                                        "pages": [
                                                            {
                                                                "id": 0,
                                                                "name": "Todos",
                                                                "state": {
                                                                    "t": "resheet.sheet",
                                                                    "v": 2,
                                                                    "lines": [
                                                                        {
                                                                            "id": 2,
                                                                            "name": "",
                                                                            "visibility": "block",
                                                                            "width": "narrow",
                                                                            "state": {
                                                                                "t": "resheet.note",
                                                                                "v": 1,
                                                                                "level": 0,
                                                                                "input": "#### Home",
                                                                                "note": {
                                                                                    "type": "text",
                                                                                    "tag": "h4",
                                                                                    "text": "Home"
                                                                                }
                                                                            }
                                                                        },
                                                                        {
                                                                            "id": 3,
                                                                            "name": "",
                                                                            "visibility": "block",
                                                                            "width": "narrow",
                                                                            "state": {
                                                                                "t": "resheet.note",
                                                                                "v": 1,
                                                                                "level": 0,
                                                                                "input": "[x] Fix squeeky doors",
                                                                                "note": {
                                                                                    "type": "checkbox",
                                                                                    "checked": true,
                                                                                    "text": "Fix squeeky doors"
                                                                                }
                                                                            }
                                                                        },
                                                                        {
                                                                            "id": 4,
                                                                            "name": "",
                                                                            "visibility": "block",
                                                                            "width": "narrow",
                                                                            "state": {
                                                                                "t": "resheet.note",
                                                                                "v": 1,
                                                                                "level": 0,
                                                                                "input": "[] Replace empty batteries",
                                                                                "note": {
                                                                                    "type": "checkbox",
                                                                                    "checked": false,
                                                                                    "text": "Replace empty batteries"
                                                                                }
                                                                            }
                                                                        },
                                                                        {
                                                                            "id": 5,
                                                                            "name": "",
                                                                            "visibility": "block",
                                                                            "width": "narrow",
                                                                            "state": {
                                                                                "t": "resheet.note",
                                                                                "v": 1,
                                                                                "level": 0,
                                                                                "input": "[] Organize documents",
                                                                                "note": {
                                                                                    "type": "checkbox",
                                                                                    "checked": false,
                                                                                    "text": "Organize documents"
                                                                                }
                                                                            }
                                                                        },
                                                                        {
                                                                            "id": 6,
                                                                            "name": "",
                                                                            "visibility": "block",
                                                                            "width": "narrow",
                                                                            "state": {
                                                                                "t": "resheet.note",
                                                                                "v": 1,
                                                                                "level": 0,
                                                                                "input": "#### Bike",
                                                                                "note": {
                                                                                    "type": "text",
                                                                                    "tag": "h4",
                                                                                    "text": "Bike"
                                                                                }
                                                                            }
                                                                        },
                                                                        {
                                                                            "id": 7,
                                                                            "name": "",
                                                                            "visibility": "block",
                                                                            "width": "narrow",
                                                                            "state": {
                                                                                "t": "resheet.note",
                                                                                "v": 1,
                                                                                "level": 0,
                                                                                "input": "[] Replace tires",
                                                                                "note": {
                                                                                    "type": "checkbox",
                                                                                    "checked": false,
                                                                                    "text": "Replace tires"
                                                                                }
                                                                            }
                                                                        },
                                                                        {
                                                                            "id": 8,
                                                                            "name": "",
                                                                            "visibility": "block",
                                                                            "width": "narrow",
                                                                            "state": {
                                                                                "t": "resheet.note",
                                                                                "v": 1,
                                                                                "level": 0,
                                                                                "input": "[x] Replace brakepads",
                                                                                "note": {
                                                                                    "type": "checkbox",
                                                                                    "checked": true,
                                                                                    "text": "Replace brakepads"
                                                                                }
                                                                            }
                                                                        },
                                                                        {
                                                                            "id": 9,
                                                                            "name": "",
                                                                            "visibility": "block",
                                                                            "width": "narrow",
                                                                            "state": {
                                                                                "t": "resheet.note",
                                                                                "v": 1,
                                                                                "level": 0,
                                                                                "input": "#### Office",
                                                                                "note": {
                                                                                    "type": "text",
                                                                                    "tag": "h4",
                                                                                    "text": "Office"
                                                                                }
                                                                            }
                                                                        },
                                                                        {
                                                                            "id": 10,
                                                                            "name": "",
                                                                            "visibility": "block",
                                                                            "width": "narrow",
                                                                            "state": {
                                                                                "t": "resheet.note",
                                                                                "v": 1,
                                                                                "level": 0,
                                                                                "input": "[x] File taxes",
                                                                                "note": {
                                                                                    "type": "checkbox",
                                                                                    "checked": true,
                                                                                    "text": "File taxes"
                                                                                }
                                                                            }
                                                                        },
                                                                        {
                                                                            "id": 11,
                                                                            "name": "",
                                                                            "visibility": "block",
                                                                            "width": "narrow",
                                                                            "state": {
                                                                                "t": "resheet.note",
                                                                                "v": 1,
                                                                                "level": 0,
                                                                                "input": "[ ] Track finances",
                                                                                "note": {
                                                                                    "type": "checkbox",
                                                                                    "checked": false,
                                                                                    "text": "Track finances"
                                                                                }
                                                                            }
                                                                        }
                                                                    ]
                                                                },
                                                                "isCollapsed": true,
                                                                "children": []
                                                            },
                                                            {
                                                                "id": 1,
                                                                "name": "Weekly Plan",
                                                                "state": {
                                                                    "t": "resheet.sheet",
                                                                    "v": 2,
                                                                    "lines": [
                                                                        {
                                                                            "id": 0,
                                                                            "name": "",
                                                                            "visibility": "block",
                                                                            "width": "narrow",
                                                                            "state": {
                                                                                "t": "resheet.note",
                                                                                "v": 1,
                                                                                "level": 0,
                                                                                "input": "### Monday",
                                                                                "note": {
                                                                                    "type": "text",
                                                                                    "tag": "h3",
                                                                                    "text": "Monday"
                                                                                }
                                                                            }
                                                                        },
                                                                        {
                                                                            "id": 1,
                                                                            "name": "",
                                                                            "visibility": "block",
                                                                            "width": "narrow",
                                                                            "state": {
                                                                                "t": "resheet.note",
                                                                                "v": 1,
                                                                                "level": 0,
                                                                                "input": "Evening: Training",
                                                                                "note": {
                                                                                    "type": "text",
                                                                                    "tag": "p",
                                                                                    "text": "Evening: Training"
                                                                                }
                                                                            }
                                                                        },
                                                                        {
                                                                            "id": 2,
                                                                            "name": "",
                                                                            "visibility": "block",
                                                                            "width": "narrow",
                                                                            "state": {
                                                                                "t": "resheet.note",
                                                                                "v": 1,
                                                                                "level": 0,
                                                                                "input": "### Tuesday",
                                                                                "note": {
                                                                                    "type": "text",
                                                                                    "tag": "h3",
                                                                                    "text": "Tuesday"
                                                                                }
                                                                            }
                                                                        },
                                                                        {
                                                                            "id": 3,
                                                                            "name": "",
                                                                            "visibility": "block",
                                                                            "width": "narrow",
                                                                            "state": {
                                                                                "t": "resheet.note",
                                                                                "v": 1,
                                                                                "level": 0,
                                                                                "input": "Morning: Meditation",
                                                                                "note": {
                                                                                    "type": "text",
                                                                                    "tag": "p",
                                                                                    "text": "Morning: Meditation"
                                                                                }
                                                                            }
                                                                        },
                                                                        {
                                                                            "id": 4,
                                                                            "name": "",
                                                                            "visibility": "block",
                                                                            "width": "narrow",
                                                                            "state": {
                                                                                "t": "resheet.note",
                                                                                "v": 1,
                                                                                "level": 0,
                                                                                "input": "Evening: Call Paul",
                                                                                "note": {
                                                                                    "type": "text",
                                                                                    "tag": "p",
                                                                                    "text": "Evening: Call Paul"
                                                                                }
                                                                            }
                                                                        },
                                                                        {
                                                                            "id": 5,
                                                                            "name": "",
                                                                            "visibility": "block",
                                                                            "width": "narrow",
                                                                            "state": {
                                                                                "t": "resheet.note",
                                                                                "v": 1,
                                                                                "level": 0,
                                                                                "input": "### Wednesday",
                                                                                "note": {
                                                                                    "type": "text",
                                                                                    "tag": "h3",
                                                                                    "text": "Wednesday"
                                                                                }
                                                                            }
                                                                        },
                                                                        {
                                                                            "id": 6,
                                                                            "name": "",
                                                                            "visibility": "block",
                                                                            "width": "narrow",
                                                                            "state": {
                                                                                "t": "resheet.note",
                                                                                "v": 1,
                                                                                "level": 0,
                                                                                "input": "Evening: Free time",
                                                                                "note": {
                                                                                    "type": "text",
                                                                                    "tag": "p",
                                                                                    "text": "Evening: Free time"
                                                                                }
                                                                            }
                                                                        },
                                                                        {
                                                                            "id": 7,
                                                                            "name": "",
                                                                            "visibility": "block",
                                                                            "width": "narrow",
                                                                            "state": {
                                                                                "t": "resheet.note",
                                                                                "v": 1,
                                                                                "level": 0,
                                                                                "input": "### Thursday",
                                                                                "note": {
                                                                                    "type": "text",
                                                                                    "tag": "h3",
                                                                                    "text": "Thursday"
                                                                                }
                                                                            }
                                                                        },
                                                                        {
                                                                            "id": 8,
                                                                            "name": "",
                                                                            "visibility": "block",
                                                                            "width": "narrow",
                                                                            "state": {
                                                                                "t": "resheet.note",
                                                                                "v": 1,
                                                                                "level": 0,
                                                                                "input": "Morning: Go for a run",
                                                                                "note": {
                                                                                    "type": "text",
                                                                                    "tag": "p",
                                                                                    "text": "Morning: Go for a run"
                                                                                }
                                                                            }
                                                                        },
                                                                        {
                                                                            "id": 9,
                                                                            "name": "",
                                                                            "visibility": "block",
                                                                            "width": "narrow",
                                                                            "state": {
                                                                                "t": "resheet.note",
                                                                                "v": 1,
                                                                                "level": 0,
                                                                                "input": "Evening: Cook dinner",
                                                                                "note": {
                                                                                    "type": "text",
                                                                                    "tag": "p",
                                                                                    "text": "Evening: Cook dinner"
                                                                                }
                                                                            }
                                                                        },
                                                                        {
                                                                            "id": 10,
                                                                            "name": "",
                                                                            "visibility": "block",
                                                                            "width": "narrow",
                                                                            "state": {
                                                                                "t": "resheet.note",
                                                                                "v": 1,
                                                                                "level": 0,
                                                                                "input": "### Friday",
                                                                                "note": {
                                                                                    "type": "text",
                                                                                    "tag": "h3",
                                                                                    "text": "Friday"
                                                                                }
                                                                            }
                                                                        },
                                                                        {
                                                                            "id": 11,
                                                                            "name": "",
                                                                            "visibility": "block",
                                                                            "width": "narrow",
                                                                            "state": {
                                                                                "t": "resheet.note",
                                                                                "v": 1,
                                                                                "level": 0,
                                                                                "input": "-- Nothing --",
                                                                                "note": {
                                                                                    "type": "text",
                                                                                    "tag": "p",
                                                                                    "text": "-- Nothing --"
                                                                                }
                                                                            }
                                                                        },
                                                                        {
                                                                            "id": 12,
                                                                            "name": "",
                                                                            "visibility": "block",
                                                                            "width": "narrow",
                                                                            "state": {
                                                                                "t": "resheet.note",
                                                                                "v": 1,
                                                                                "level": 0,
                                                                                "input": "### Saturday",
                                                                                "note": {
                                                                                    "type": "text",
                                                                                    "tag": "h3",
                                                                                    "text": "Saturday"
                                                                                }
                                                                            }
                                                                        },
                                                                        {
                                                                            "id": 13,
                                                                            "name": "",
                                                                            "visibility": "block",
                                                                            "width": "narrow",
                                                                            "state": {
                                                                                "t": "resheet.note",
                                                                                "v": 1,
                                                                                "level": 0,
                                                                                "input": "Buy groceries",
                                                                                "note": {
                                                                                    "type": "text",
                                                                                    "tag": "p",
                                                                                    "text": "Buy groceries"
                                                                                }
                                                                            }
                                                                        },
                                                                        {
                                                                            "id": 14,
                                                                            "name": "",
                                                                            "visibility": "block",
                                                                            "width": "narrow",
                                                                            "state": {
                                                                                "t": "resheet.note",
                                                                                "v": 1,
                                                                                "level": 0,
                                                                                "input": "### Sunday",
                                                                                "note": {
                                                                                    "type": "text",
                                                                                    "tag": "h3",
                                                                                    "text": "Sunday"
                                                                                }
                                                                            }
                                                                        },
                                                                        {
                                                                            "id": 15,
                                                                            "name": "",
                                                                            "visibility": "block",
                                                                            "width": "narrow",
                                                                            "state": {
                                                                                "t": "resheet.note",
                                                                                "v": 1,
                                                                                "level": 0,
                                                                                "input": "Meet friends",
                                                                                "note": {
                                                                                    "type": "text",
                                                                                    "tag": "p",
                                                                                    "text": "Meet friends"
                                                                                }
                                                                            }
                                                                        }
                                                                    ]
                                                                },
                                                                "isCollapsed": true,
                                                                "children": []
                                                            },
                                                            {
                                                                "id": 2,
                                                                "name": "Goals",
                                                                "state": {
                                                                    "t": "resheet.sheet",
                                                                    "v": 2,
                                                                    "lines": [
                                                                        {
                                                                            "id": 0,
                                                                            "name": "",
                                                                            "visibility": "block",
                                                                            "width": "narrow",
                                                                            "state": {
                                                                                "t": "resheet.note",
                                                                                "v": 1,
                                                                                "level": 0,
                                                                                "input": "### Get fit",
                                                                                "note": {
                                                                                    "type": "text",
                                                                                    "tag": "h3",
                                                                                    "text": "Get fit"
                                                                                }
                                                                            }
                                                                        },
                                                                        {
                                                                            "id": 1,
                                                                            "name": "",
                                                                            "visibility": "block",
                                                                            "width": "narrow",
                                                                            "state": {
                                                                                "t": "resheet.note",
                                                                                "v": 1,
                                                                                "level": 0,
                                                                                "input": "[x] January: Train 3x/week",
                                                                                "note": {
                                                                                    "type": "checkbox",
                                                                                    "checked": true,
                                                                                    "text": "January: Train 3x/week"
                                                                                }
                                                                            }
                                                                        },
                                                                        {
                                                                            "id": 2,
                                                                            "name": "",
                                                                            "visibility": "block",
                                                                            "width": "narrow",
                                                                            "state": {
                                                                                "t": "resheet.note",
                                                                                "v": 1,
                                                                                "level": 0,
                                                                                "input": "[] February: Run every week",
                                                                                "note": {
                                                                                    "type": "checkbox",
                                                                                    "checked": false,
                                                                                    "text": "February: Run every week"
                                                                                }
                                                                            }
                                                                        },
                                                                        {
                                                                            "id": 3,
                                                                            "name": "",
                                                                            "visibility": "block",
                                                                            "width": "narrow",
                                                                            "state": {
                                                                                "t": "resheet.note",
                                                                                "v": 1,
                                                                                "level": 0,
                                                                                "input": "[] March: Yoga every morning",
                                                                                "note": {
                                                                                    "type": "checkbox",
                                                                                    "checked": false,
                                                                                    "text": "March: Yoga every morning"
                                                                                }
                                                                            }
                                                                        },
                                                                        {
                                                                            "id": 4,
                                                                            "name": "",
                                                                            "visibility": "block",
                                                                            "width": "narrow",
                                                                            "state": {
                                                                                "t": "resheet.note",
                                                                                "v": 1,
                                                                                "level": 0,
                                                                                "input": "### Spend more time with Family",
                                                                                "note": {
                                                                                    "type": "text",
                                                                                    "tag": "h3",
                                                                                    "text": "Spend more time with Family"
                                                                                }
                                                                            }
                                                                        },
                                                                        {
                                                                            "id": 5,
                                                                            "name": "",
                                                                            "visibility": "block",
                                                                            "width": "narrow",
                                                                            "state": {
                                                                                "t": "resheet.note",
                                                                                "v": 1,
                                                                                "level": 0,
                                                                                "input": "[x] January",
                                                                                "note": {
                                                                                    "type": "checkbox",
                                                                                    "checked": true,
                                                                                    "text": "January"
                                                                                }
                                                                            }
                                                                        },
                                                                        {
                                                                            "id": 6,
                                                                            "name": "",
                                                                            "visibility": "block",
                                                                            "width": "narrow",
                                                                            "state": {
                                                                                "t": "resheet.note",
                                                                                "v": 1,
                                                                                "level": 0,
                                                                                "input": "[x] February",
                                                                                "note": {
                                                                                    "type": "checkbox",
                                                                                    "checked": true,
                                                                                    "text": "February"
                                                                                }
                                                                            }
                                                                        },
                                                                        {
                                                                            "id": 7,
                                                                            "name": "",
                                                                            "visibility": "block",
                                                                            "width": "narrow",
                                                                            "state": {
                                                                                "t": "resheet.note",
                                                                                "v": 1,
                                                                                "level": 0,
                                                                                "input": "[] March",
                                                                                "note": {
                                                                                    "type": "checkbox",
                                                                                    "checked": false,
                                                                                    "text": "March"
                                                                                }
                                                                            }
                                                                        }
                                                                    ]
                                                                },
                                                                "isCollapsed": true,
                                                                "children": []
                                                            },
                                                            {
                                                                "id": 3,
                                                                "name": "Finances",
                                                                "state": {
                                                                    "t": "resheet.sheet",
                                                                    "v": 2,
                                                                    "lines": [
                                                                        {
                                                                            "id": 0,
                                                                            "name": "",
                                                                            "visibility": "block",
                                                                            "width": "narrow",
                                                                            "state": {
                                                                                "t": "resheet.note",
                                                                                "v": 1,
                                                                                "level": 0,
                                                                                "input": "### Finances",
                                                                                "note": {
                                                                                    "type": "text",
                                                                                    "tag": "h3",
                                                                                    "text": "Finances"
                                                                                }
                                                                            }
                                                                        },
                                                                        {
                                                                            "id": 1,
                                                                            "name": "",
                                                                            "visibility": "block",
                                                                            "width": "narrow",
                                                                            "state": {
                                                                                "t": "resheet.note",
                                                                                "v": 1,
                                                                                "level": 0,
                                                                                "input": "**BIG TODO**",
                                                                                "note": {
                                                                                    "type": "text",
                                                                                    "tag": "p",
                                                                                    "text": "**BIG TODO**"
                                                                                }
                                                                            }
                                                                        }
                                                                    ]
                                                                },
                                                                "isCollapsed": true,
                                                                "children": []
                                                            }
                                                        ],
                                                        "viewState": {
                                                            "sidebarOpen": true,
                                                            "openPage": [
                                                                0
                                                            ]
                                                        },
                                                        "template": {
                                                            "id": -1,
                                                            "name": "",
                                                            "state": {
                                                                "t": "resheet.sheet",
                                                                "v": 2,
                                                                "lines": []
                                                            },
                                                            "isCollapsed": true,
                                                            "children": []
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    },
                                    {
                                        "id": 4,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 8,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "### JavaScript and React",
                                            "note": {
                                                "type": "text",
                                                "tag": "h3",
                                                "text": "JavaScript and React"
                                            }
                                        }
                                    },
                                    {
                                        "id": 17,
                                        "name": "formulas",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "/Debug.Inspect(DocumentOf(SheetOf(Note)))",
                                            "note": {
                                                "type": "block",
                                                "isInstantiated": true,
                                                "code": "Debug.Inspect(DocumentOf(SheetOf(Note)))",
                                                "state": {
                                                    "history": [],
                                                    "inner": {
                                                        "t": "resheet.document",
                                                        "v": 1,
                                                        "pages": [
                                                            {
                                                                "id": 0,
                                                                "name": "Finances",
                                                                "state": {
                                                                    "t": "resheet.sheet",
                                                                    "v": 2,
                                                                    "lines": [
                                                                        {
                                                                            "id": 0,
                                                                            "name": "",
                                                                            "visibility": "block",
                                                                            "width": "narrow",
                                                                            "state": {
                                                                                "t": "resheet.note",
                                                                                "v": 1,
                                                                                "level": 0,
                                                                                "input": "### Finances",
                                                                                "note": {
                                                                                    "type": "text",
                                                                                    "tag": "h3",
                                                                                    "text": "Finances"
                                                                                }
                                                                            }
                                                                        },
                                                                        {
                                                                            "id": 1,
                                                                            "name": "",
                                                                            "visibility": "block",
                                                                            "width": "narrow",
                                                                            "state": {
                                                                                "t": "resheet.note",
                                                                                "v": 1,
                                                                                "level": 0,
                                                                                "input": "Income:",
                                                                                "note": {
                                                                                    "type": "text",
                                                                                    "tag": "p",
                                                                                    "text": "Income:"
                                                                                }
                                                                            }
                                                                        },
                                                                        {
                                                                            "id": 2,
                                                                            "name": "income",
                                                                            "visibility": "block",
                                                                            "width": "narrow",
                                                                            "state": {
                                                                                "t": "resheet.note",
                                                                                "v": 1,
                                                                                "level": 0,
                                                                                "input": "= 3500",
                                                                                "note": {
                                                                                    "type": "expr",
                                                                                    "code": " 3500"
                                                                                }
                                                                            }
                                                                        },
                                                                        {
                                                                            "id": 3,
                                                                            "name": "",
                                                                            "visibility": "block",
                                                                            "width": "narrow",
                                                                            "state": {
                                                                                "t": "resheet.note",
                                                                                "v": 1,
                                                                                "level": 0,
                                                                                "input": "",
                                                                                "note": {
                                                                                    "type": "text",
                                                                                    "tag": "p",
                                                                                    "text": ""
                                                                                }
                                                                            }
                                                                        },
                                                                        {
                                                                            "id": 4,
                                                                            "name": "",
                                                                            "visibility": "block",
                                                                            "width": "narrow",
                                                                            "state": {
                                                                                "t": "resheet.note",
                                                                                "v": 1,
                                                                                "level": 0,
                                                                                "input": "Expenses:",
                                                                                "note": {
                                                                                    "type": "text",
                                                                                    "tag": "p",
                                                                                    "text": "Expenses:"
                                                                                }
                                                                            }
                                                                        },
                                                                        {
                                                                            "id": 5,
                                                                            "name": "expenses",
                                                                            "visibility": "block",
                                                                            "width": "narrow",
                                                                            "state": {
                                                                                "t": "resheet.note",
                                                                                "v": 1,
                                                                                "level": 0,
                                                                                "input": "= (await fetch('https://raw.githubusercontent.com/keenbug/ReSheet/main/examples/expenses.json')).json()",
                                                                                "note": {
                                                                                    "type": "expr",
                                                                                    "code": " (await fetch('https://raw.githubusercontent.com/keenbug/ReSheet/main/examples/expenses.json')).json()"
                                                                                }
                                                                            }
                                                                        },
                                                                        {
                                                                            "id": 6,
                                                                            "name": "",
                                                                            "visibility": "block",
                                                                            "width": "narrow",
                                                                            "state": {
                                                                                "t": "resheet.note",
                                                                                "v": 1,
                                                                                "level": 0,
                                                                                "input": "",
                                                                                "note": {
                                                                                    "type": "text",
                                                                                    "tag": "p",
                                                                                    "text": ""
                                                                                }
                                                                            }
                                                                        },
                                                                        {
                                                                            "id": 7,
                                                                            "name": "",
                                                                            "visibility": "block",
                                                                            "width": "narrow",
                                                                            "state": {
                                                                                "t": "resheet.note",
                                                                                "v": 1,
                                                                                "level": 0,
                                                                                "input": "Balance:",
                                                                                "note": {
                                                                                    "type": "text",
                                                                                    "tag": "p",
                                                                                    "text": "Balance:"
                                                                                }
                                                                            }
                                                                        },
                                                                        {
                                                                            "id": 8,
                                                                            "name": "balance",
                                                                            "visibility": "block",
                                                                            "width": "narrow",
                                                                            "state": {
                                                                                "t": "resheet.note",
                                                                                "v": 1,
                                                                                "level": 0,
                                                                                "input": "= income - lodash.sum(Object.values(expenses))",
                                                                                "note": {
                                                                                    "type": "expr",
                                                                                    "code": " income - lodash.sum(Object.values(expenses))"
                                                                                }
                                                                            }
                                                                        },
                                                                        {
                                                                            "id": 9,
                                                                            "name": "",
                                                                            "visibility": "block",
                                                                            "width": "narrow",
                                                                            "state": {
                                                                                "t": "resheet.note",
                                                                                "v": 1,
                                                                                "level": 0,
                                                                                "input": "",
                                                                                "note": {
                                                                                    "type": "text",
                                                                                    "tag": "p",
                                                                                    "text": ""
                                                                                }
                                                                            }
                                                                        },
                                                                        {
                                                                            "id": 10,
                                                                            "name": "",
                                                                            "visibility": "block",
                                                                            "width": "narrow",
                                                                            "state": {
                                                                                "t": "resheet.note",
                                                                                "v": 1,
                                                                                "level": 0,
                                                                                "input": "Savings in a year:",
                                                                                "note": {
                                                                                    "type": "text",
                                                                                    "tag": "p",
                                                                                    "text": "Savings in a year:"
                                                                                }
                                                                            }
                                                                        },
                                                                        {
                                                                            "id": 11,
                                                                            "name": "",
                                                                            "visibility": "block",
                                                                            "width": "narrow",
                                                                            "state": {
                                                                                "t": "resheet.note",
                                                                                "v": 1,
                                                                                "level": 0,
                                                                                "input": "= balance * 12",
                                                                                "note": {
                                                                                    "type": "expr",
                                                                                    "code": " balance * 12"
                                                                                }
                                                                            }
                                                                        },
                                                                        {
                                                                            "id": 12,
                                                                            "name": "",
                                                                            "visibility": "block",
                                                                            "width": "narrow",
                                                                            "state": {
                                                                                "t": "resheet.note",
                                                                                "v": 1,
                                                                                "level": 0,
                                                                                "input": "",
                                                                                "note": {
                                                                                    "type": "text",
                                                                                    "tag": "p",
                                                                                    "text": ""
                                                                                }
                                                                            }
                                                                        },
                                                                        {
                                                                            "id": 13,
                                                                            "name": "",
                                                                            "visibility": "block",
                                                                            "width": "narrow",
                                                                            "state": {
                                                                                "t": "resheet.note",
                                                                                "v": 1,
                                                                                "level": 0,
                                                                                "input": "Unplanned expenses:",
                                                                                "note": {
                                                                                    "type": "text",
                                                                                    "tag": "p",
                                                                                    "text": "Unplanned expenses:"
                                                                                }
                                                                            }
                                                                        },
                                                                        {
                                                                            "id": 14,
                                                                            "name": "unplanned",
                                                                            "visibility": "block",
                                                                            "width": "narrow",
                                                                            "state": {
                                                                                "t": "resheet.note",
                                                                                "v": 1,
                                                                                "level": 0,
                                                                                "input": "= Array(30).fill().map(() => Math.random() * 500)",
                                                                                "note": {
                                                                                    "type": "expr",
                                                                                    "code": " Array(30).fill().map(() => Math.random() * 500)"
                                                                                }
                                                                            }
                                                                        },
                                                                        {
                                                                            "id": 15,
                                                                            "name": "",
                                                                            "visibility": "block",
                                                                            "width": "narrow",
                                                                            "state": {
                                                                                "t": "resheet.note",
                                                                                "v": 1,
                                                                                "level": 0,
                                                                                "input": "",
                                                                                "note": {
                                                                                    "type": "text",
                                                                                    "tag": "p",
                                                                                    "text": ""
                                                                                }
                                                                            }
                                                                        },
                                                                        {
                                                                            "id": 16,
                                                                            "name": "",
                                                                            "visibility": "block",
                                                                            "width": "narrow",
                                                                            "state": {
                                                                                "t": "resheet.note",
                                                                                "v": 1,
                                                                                "level": 0,
                                                                                "input": "/Code",
                                                                                "note": {
                                                                                    "type": "block",
                                                                                    "isInstantiated": true,
                                                                                    "code": "Code",
                                                                                    "state": 'const { ResponsiveContainer, LineChart, Line, XAxis, YAxis } =\n  await import(\'https://esm.sh/recharts?external=react\');\n  \nconst balances = unplanned.reduce(\n  (balances, expense) => [\n    balances[0] - expense + balance,\n    ...balances,\n  ],\n  [13054],\n)\n  .toReversed();\n\n<ResponsiveContainer height={400}>\n  <LineChart data={balances}>\n    <Line type="monotone" dataKey={v => v} fill="#8884d8" />\n    <XAxis/>\n    <YAxis/>\n  </LineChart>\n</ResponsiveContainer>'
                                                                                }
                                                                            }
                                                                        }
                                                                    ]
                                                                },
                                                                "isCollapsed": true,
                                                                "children": []
                                                            }
                                                        ],
                                                        "viewState": {
                                                            "sidebarOpen": false,
                                                            "openPage": [
                                                                0
                                                            ]
                                                        },
                                                        "template": {
                                                            "id": -1,
                                                            "name": "",
                                                            "state": {
                                                                "t": "resheet.sheet",
                                                                "v": 2,
                                                                "lines": []
                                                            },
                                                            "isCollapsed": true,
                                                            "children": []
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    },
                                    {
                                        "id": 5,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 12,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 13,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "### Extensibility",
                                            "note": {
                                                "type": "text",
                                                "tag": "h3",
                                                "text": "Extensibility"
                                            }
                                        }
                                    },
                                    {
                                        "id": 15,
                                        "name": "DefaultPageBlock",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "= BlockSelector('SheetOf(Note)', SheetOf(Note))",
                                            "note": {
                                                "type": "expr",
                                                "code": " BlockSelector('SheetOf(Note)', SheetOf(Note))"
                                            }
                                        }
                                    },
                                    {
                                        "id": 16,
                                        "name": "ReSheet",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "= DocumentOf(DefaultPageBlock)",
                                            "note": {
                                                "type": "expr",
                                                "code": " DocumentOf(DefaultPageBlock)"
                                            }
                                        }
                                    },
                                    {
                                        "id": 14,
                                        "name": "extensibility",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "/Debug.Inspect(ReSheet)",
                                            "note": {
                                                "type": "block",
                                                "isInstantiated": true,
                                                "code": "Debug.Inspect(ReSheet)",
                                                "state": {
                                                    "history": [],
                                                    "inner": {
                                                        "t": "resheet.document",
                                                        "v": 1,
                                                        "pages": [
                                                            {
                                                                "id": 2,
                                                                "name": "Examples",
                                                                "state": {
                                                                    "t": "resheet.selector",
                                                                    "v": 0,
                                                                    "mode": "run",
                                                                    "expr": "$`Custom Blocks`",
                                                                    "inner": {
                                                                        "t": "resheet.sheet",
                                                                        "v": 2,
                                                                        "lines": [
                                                                            {
                                                                                "id": 1,
                                                                                "name": "",
                                                                                "visibility": "block",
                                                                                "width": "narrow",
                                                                                "state": {
                                                                                    "t": "resheet.note",
                                                                                    "v": 1,
                                                                                    "level": 0,
                                                                                    "input": "### Custom Blocks",
                                                                                    "note": {
                                                                                        "type": "text",
                                                                                        "tag": "h3",
                                                                                        "text": "Custom Blocks"
                                                                                    }
                                                                                }
                                                                            },
                                                                            {
                                                                                "id": 2,
                                                                                "name": "",
                                                                                "visibility": "block",
                                                                                "width": "narrow",
                                                                                "state": {
                                                                                    "t": "resheet.note",
                                                                                    "v": 1,
                                                                                    "level": 0,
                                                                                    "input": 'We build these custom Blocks in "Examples > Custom Blocks":',
                                                                                    "note": {
                                                                                        "type": "text",
                                                                                        "tag": "p",
                                                                                        "text": 'We build these custom Blocks in "Examples > Custom Blocks":'
                                                                                    }
                                                                                }
                                                                            },
                                                                            {
                                                                                "id": 3,
                                                                                "name": "",
                                                                                "visibility": "block",
                                                                                "width": "narrow",
                                                                                "state": {
                                                                                    "t": "resheet.note",
                                                                                    "v": 1,
                                                                                    "level": 0,
                                                                                    "input": "",
                                                                                    "note": {
                                                                                        "type": "text",
                                                                                        "tag": "p",
                                                                                        "text": ""
                                                                                    }
                                                                                }
                                                                            },
                                                                            {
                                                                                "id": 25,
                                                                                "name": "",
                                                                                "visibility": "block",
                                                                                "width": "narrow",
                                                                                "state": {
                                                                                    "t": "resheet.note",
                                                                                    "v": 1,
                                                                                    "level": 0,
                                                                                    "input": "#### `/DateBlock()`",
                                                                                    "note": {
                                                                                        "type": "text",
                                                                                        "tag": "h4",
                                                                                        "text": "`/DateBlock()`"
                                                                                    }
                                                                                }
                                                                            },
                                                                            {
                                                                                "id": 26,
                                                                                "name": "dateBlockValue",
                                                                                "visibility": "block",
                                                                                "width": "narrow",
                                                                                "state": {
                                                                                    "t": "resheet.note",
                                                                                    "v": 1,
                                                                                    "level": 0,
                                                                                    "input": "/DateBlock()",
                                                                                    "note": {
                                                                                        "type": "block",
                                                                                        "isInstantiated": true,
                                                                                        "code": "DateBlock()",
                                                                                        "state": "2024-05-23T20:32:56+02:00"
                                                                                    }
                                                                                }
                                                                            },
                                                                            {
                                                                                "id": 27,
                                                                                "name": "",
                                                                                "visibility": "block",
                                                                                "width": "narrow",
                                                                                "state": {
                                                                                    "t": "resheet.note",
                                                                                    "v": 1,
                                                                                    "level": 0,
                                                                                    "input": "= dateBlockValue",
                                                                                    "note": {
                                                                                        "type": "expr",
                                                                                        "code": " dateBlockValue"
                                                                                    }
                                                                                }
                                                                            },
                                                                            {
                                                                                "id": 7,
                                                                                "name": "",
                                                                                "visibility": "block",
                                                                                "width": "narrow",
                                                                                "state": {
                                                                                    "t": "resheet.note",
                                                                                    "v": 1,
                                                                                    "level": 0,
                                                                                    "input": "",
                                                                                    "note": {
                                                                                        "type": "text",
                                                                                        "tag": "p",
                                                                                        "text": ""
                                                                                    }
                                                                                }
                                                                            },
                                                                            {
                                                                                "id": 8,
                                                                                "name": "",
                                                                                "visibility": "block",
                                                                                "width": "narrow",
                                                                                "state": {
                                                                                    "t": "resheet.note",
                                                                                    "v": 1,
                                                                                    "level": 0,
                                                                                    "input": "#### `/SliderBlock()`",
                                                                                    "note": {
                                                                                        "type": "text",
                                                                                        "tag": "h4",
                                                                                        "text": "`/SliderBlock()`"
                                                                                    }
                                                                                }
                                                                            },
                                                                            {
                                                                                "id": 9,
                                                                                "name": "sliderBlockValue",
                                                                                "visibility": "block",
                                                                                "width": "narrow",
                                                                                "state": {
                                                                                    "t": "resheet.note",
                                                                                    "v": 1,
                                                                                    "level": 0,
                                                                                    "input": "/SliderBlock()",
                                                                                    "note": {
                                                                                        "type": "block",
                                                                                        "isInstantiated": true,
                                                                                        "code": "SliderBlock()",
                                                                                        "state": 49
                                                                                    }
                                                                                }
                                                                            },
                                                                            {
                                                                                "id": 10,
                                                                                "name": "",
                                                                                "visibility": "block",
                                                                                "width": "narrow",
                                                                                "state": {
                                                                                    "t": "resheet.note",
                                                                                    "v": 1,
                                                                                    "level": 0,
                                                                                    "input": "= sliderBlockValue",
                                                                                    "note": {
                                                                                        "type": "expr",
                                                                                        "code": " sliderBlockValue"
                                                                                    }
                                                                                }
                                                                            },
                                                                            {
                                                                                "id": 11,
                                                                                "name": "",
                                                                                "visibility": "block",
                                                                                "width": "narrow",
                                                                                "state": {
                                                                                    "t": "resheet.note",
                                                                                    "v": 1,
                                                                                    "level": 0,
                                                                                    "input": "",
                                                                                    "note": {
                                                                                        "type": "text",
                                                                                        "tag": "p",
                                                                                        "text": ""
                                                                                    }
                                                                                }
                                                                            },
                                                                            {
                                                                                "id": 20,
                                                                                "name": "",
                                                                                "visibility": "block",
                                                                                "width": "narrow",
                                                                                "state": {
                                                                                    "t": "resheet.note",
                                                                                    "v": 1,
                                                                                    "level": 0,
                                                                                    "input": "",
                                                                                    "note": {
                                                                                        "type": "text",
                                                                                        "tag": "p",
                                                                                        "text": ""
                                                                                    }
                                                                                }
                                                                            },
                                                                            {
                                                                                "id": 21,
                                                                                "name": "",
                                                                                "visibility": "block",
                                                                                "width": "narrow",
                                                                                "state": {
                                                                                    "t": "resheet.note",
                                                                                    "v": 1,
                                                                                    "level": 0,
                                                                                    "input": "#### `/HStack(DateBlock(), SliderBlock(), SelectBlock(options))`",
                                                                                    "note": {
                                                                                        "type": "text",
                                                                                        "tag": "h4",
                                                                                        "text": "`/HStack(DateBlock(), SliderBlock(), SelectBlock(options))`"
                                                                                    }
                                                                                }
                                                                            },
                                                                            {
                                                                                "id": 28,
                                                                                "name": "options",
                                                                                "visibility": "block",
                                                                                "width": "narrow",
                                                                                "state": {
                                                                                    "t": "resheet.note",
                                                                                    "v": 1,
                                                                                    "level": 0,
                                                                                    "input": "= ['yes', 'no']",
                                                                                    "note": {
                                                                                        "type": "expr",
                                                                                        "code": " ['yes', 'no']"
                                                                                    }
                                                                                }
                                                                            },
                                                                            {
                                                                                "id": 22,
                                                                                "name": "hstack",
                                                                                "visibility": "block",
                                                                                "width": "narrow",
                                                                                "state": {
                                                                                    "t": "resheet.note",
                                                                                    "v": 1,
                                                                                    "level": 0,
                                                                                    "input": "/HStack(DateBlock(), SliderBlock(), SelectBlock(options))",
                                                                                    "note": {
                                                                                        "type": "block",
                                                                                        "isInstantiated": true,
                                                                                        "code": "HStack(DateBlock(), SliderBlock(), SelectBlock(options))",
                                                                                        "state": [
                                                                                            "2024-05-23T20:40:02+02:00",
                                                                                            35,
                                                                                            "yes"
                                                                                        ]
                                                                                    }
                                                                                }
                                                                            },
                                                                            {
                                                                                "id": 23,
                                                                                "name": "",
                                                                                "visibility": "block",
                                                                                "width": "narrow",
                                                                                "state": {
                                                                                    "t": "resheet.note",
                                                                                    "v": 1,
                                                                                    "level": 0,
                                                                                    "input": "= hstack",
                                                                                    "note": {
                                                                                        "type": "expr",
                                                                                        "code": " hstack"
                                                                                    }
                                                                                }
                                                                            },
                                                                            {
                                                                                "id": 12,
                                                                                "name": "",
                                                                                "visibility": "block",
                                                                                "width": "narrow",
                                                                                "state": {
                                                                                    "t": "resheet.note",
                                                                                    "v": 1,
                                                                                    "level": 0,
                                                                                    "input": "",
                                                                                    "note": {
                                                                                        "type": "text",
                                                                                        "tag": "p",
                                                                                        "text": ""
                                                                                    }
                                                                                }
                                                                            },
                                                                            {
                                                                                "id": 24,
                                                                                "name": "",
                                                                                "visibility": "block",
                                                                                "width": "narrow",
                                                                                "state": {
                                                                                    "t": "resheet.note",
                                                                                    "v": 1,
                                                                                    "level": 0,
                                                                                    "input": "",
                                                                                    "note": {
                                                                                        "type": "text",
                                                                                        "tag": "p",
                                                                                        "text": ""
                                                                                    }
                                                                                }
                                                                            },
                                                                            {
                                                                                "id": 29,
                                                                                "name": "",
                                                                                "visibility": "block",
                                                                                "width": "narrow",
                                                                                "state": {
                                                                                    "t": "resheet.note",
                                                                                    "v": 1,
                                                                                    "level": 0,
                                                                                    "input": "#### Built-in Blocks",
                                                                                    "note": {
                                                                                        "type": "text",
                                                                                        "tag": "h4",
                                                                                        "text": "Built-in Blocks"
                                                                                    }
                                                                                }
                                                                            },
                                                                            {
                                                                                "id": 13,
                                                                                "name": "",
                                                                                "visibility": "block",
                                                                                "width": "narrow",
                                                                                "state": {
                                                                                    "t": "resheet.note",
                                                                                    "v": 1,
                                                                                    "level": 0,
                                                                                    "input": "And we inspect some built-in Blocks:",
                                                                                    "note": {
                                                                                        "type": "text",
                                                                                        "tag": "p",
                                                                                        "text": "And we inspect some built-in Blocks:"
                                                                                    }
                                                                                }
                                                                            },
                                                                            {
                                                                                "id": 14,
                                                                                "name": "",
                                                                                "visibility": "block",
                                                                                "width": "narrow",
                                                                                "state": {
                                                                                    "t": "resheet.note",
                                                                                    "v": 1,
                                                                                    "level": 0,
                                                                                    "input": "`/Debug.Inspect(Note)`",
                                                                                    "note": {
                                                                                        "type": "text",
                                                                                        "tag": "p",
                                                                                        "text": "`/Debug.Inspect(Note)`"
                                                                                    }
                                                                                }
                                                                            },
                                                                            {
                                                                                "id": 15,
                                                                                "name": "inspectNote",
                                                                                "visibility": "block",
                                                                                "width": "narrow",
                                                                                "state": {
                                                                                    "t": "resheet.note",
                                                                                    "v": 1,
                                                                                    "level": 0,
                                                                                    "input": "/Debug.Inspect(Note)",
                                                                                    "note": {
                                                                                        "type": "block",
                                                                                        "isInstantiated": true,
                                                                                        "code": "Debug.Inspect(Note)",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "= sliderBlockValue",
                                                                                            "note": {
                                                                                                "type": "expr",
                                                                                                "code": " sliderBlockValue"
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                }
                                                                            },
                                                                            {
                                                                                "id": 16,
                                                                                "name": "",
                                                                                "visibility": "block",
                                                                                "width": "narrow",
                                                                                "state": {
                                                                                    "t": "resheet.note",
                                                                                    "v": 1,
                                                                                    "level": 0,
                                                                                    "input": "= inspectNote.state",
                                                                                    "note": {
                                                                                        "type": "expr",
                                                                                        "code": " inspectNote.state"
                                                                                    }
                                                                                }
                                                                            },
                                                                            {
                                                                                "id": 17,
                                                                                "name": "",
                                                                                "visibility": "block",
                                                                                "width": "narrow",
                                                                                "state": {
                                                                                    "t": "resheet.note",
                                                                                    "v": 1,
                                                                                    "level": 0,
                                                                                    "input": "",
                                                                                    "note": {
                                                                                        "type": "text",
                                                                                        "tag": "p",
                                                                                        "text": ""
                                                                                    }
                                                                                }
                                                                            },
                                                                            {
                                                                                "id": 18,
                                                                                "name": "",
                                                                                "visibility": "block",
                                                                                "width": "narrow",
                                                                                "state": {
                                                                                    "t": "resheet.note",
                                                                                    "v": 1,
                                                                                    "level": 0,
                                                                                    "input": "",
                                                                                    "note": {
                                                                                        "type": "text",
                                                                                        "tag": "p",
                                                                                        "text": ""
                                                                                    }
                                                                                }
                                                                            },
                                                                            {
                                                                                "id": 19,
                                                                                "name": "",
                                                                                "visibility": "block",
                                                                                "width": "narrow",
                                                                                "state": {
                                                                                    "t": "resheet.note",
                                                                                    "v": 1,
                                                                                    "level": 0,
                                                                                    "input": '<span className="text-gray-400 text-sm">Psst: And don\'t miss the Grand Finale!</span>',
                                                                                    "note": {
                                                                                        "type": "text",
                                                                                        "tag": "p",
                                                                                        "text": '<span className="text-gray-400 text-sm">Psst: And don\'t miss the Grand Finale!</span>'
                                                                                    }
                                                                                }
                                                                            }
                                                                        ]
                                                                    }
                                                                },
                                                                "isCollapsed": true,
                                                                "children": [
                                                                    {
                                                                        "id": 2,
                                                                        "name": "Custom Blocks",
                                                                        "state": {
                                                                            "t": "resheet.selector",
                                                                            "v": 0,
                                                                            "mode": "run",
                                                                            "expr": "SheetOf(Note)",
                                                                            "inner": {
                                                                                "t": "resheet.sheet",
                                                                                "v": 2,
                                                                                "lines": [
                                                                                    {
                                                                                        "id": 1,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "# Custom Blocks",
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "h1",
                                                                                                "text": "Custom Blocks"
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 2,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "Create custom Blocks and use the Inspect Block to get a glimpse into ReSheet.",
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "p",
                                                                                                "text": "Create custom Blocks and use the Inspect Block to get a glimpse into ReSheet."
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 3,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "",
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "p",
                                                                                                "text": ""
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 23,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "## Simple custom Blocks",
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "h2",
                                                                                                "text": "Simple custom Blocks"
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 7,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "Let's build a simple checkbox Block:",
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "p",
                                                                                                "text": "Let's build a simple checkbox Block:"
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 8,
                                                                                        "name": "CheckBlock",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "/Code",
                                                                                            "note": {
                                                                                                "type": "block",
                                                                                                "isInstantiated": true,
                                                                                                "code": "Code",
                                                                                                "state": "label => SimpleBlock(false, ({ ref, state, onUpdate }) =>\n  <label>\n    <input\n      ref={ref}\n      type=\"checkbox\"\n      checked={state}\n      onChange={onUpdate('target.checked')}\n      />\n    {' '}\n    {label}\n  </label>\n)"
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 9,
                                                                                        "name": "input",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": '/CheckBlock("Does it work?")',
                                                                                            "note": {
                                                                                                "type": "block",
                                                                                                "isInstantiated": true,
                                                                                                "code": 'CheckBlock("Does it work?")',
                                                                                                "state": true
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 10,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "= input",
                                                                                            "note": {
                                                                                                "type": "expr",
                                                                                                "code": " input"
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 11,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "",
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "p",
                                                                                                "text": ""
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 87,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "",
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "p",
                                                                                                "text": ""
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 88,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "",
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "p",
                                                                                                "text": ""
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 13,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "Having an editable label would be nice:",
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "p",
                                                                                                "text": "Having an editable label would be nice:"
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 14,
                                                                                        "name": "CheckEditableBlock",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "/Code",
                                                                                            "note": {
                                                                                                "type": "block",
                                                                                                "isInstantiated": true,
                                                                                                "code": "Code",
                                                                                                "state": "SimpleBlock(\n  { checked: false, label: '' },\n  ({ ref, state, onUpdate, setState }) => (\n    <label>\n      <input\n        type=\"checkbox\"\n        checked={state.checked}\n        onChange={onUpdate('target.checked', 'checked')}\n        />\n      {' '}\n      <input\n        ref={ref}\n        type=\"text\"\n        value={state.label}\n        placeholder=\"label\"\n        onKeyDown={ev => {\n          if (ev.key === 'Enter') {\n            setState(checked => !checked, 'checked')\n          }\n        }}\n        onChange={onUpdate('target.value', 'label')}\n        />\n    </label>\n  ),\n)"
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 15,
                                                                                        "name": "input2",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "/CheckEditableBlock",
                                                                                            "note": {
                                                                                                "type": "block",
                                                                                                "isInstantiated": true,
                                                                                                "code": "CheckEditableBlock",
                                                                                                "state": {
                                                                                                    "checked": true,
                                                                                                    "label": "This works too"
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 16,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "= input2",
                                                                                            "note": {
                                                                                                "type": "expr",
                                                                                                "code": " input2"
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 17,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "",
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "p",
                                                                                                "text": ""
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 85,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "",
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "p",
                                                                                                "text": ""
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 86,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "",
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "p",
                                                                                                "text": ""
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 18,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "Build a slider Block:",
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "p",
                                                                                                "text": "Build a slider Block:"
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 20,
                                                                                        "name": "SliderBlock",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "/Code",
                                                                                            "note": {
                                                                                                "type": "block",
                                                                                                "isInstantiated": true,
                                                                                                "code": "Code",
                                                                                                "state": 'function SliderBlock(props) {\n  const rangeProps = immutable.merge({ min: 0, max: 100, step: 1 }, props)\n  return SimpleBlock(rangeProps.min ?? 0, ({ ref, state, onUpdate }) =>\n    <input\n      ref={ref}\n      type="range"\n      className="w-full"\n      value={state}\n      {...rangeProps}\n      onChange={onUpdate(\'target.value\', [], Number)}\n    />\n  )\n}'
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 21,
                                                                                        "name": "rangeInput",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "/SliderBlock()",
                                                                                            "note": {
                                                                                                "type": "block",
                                                                                                "isInstantiated": true,
                                                                                                "code": "SliderBlock()",
                                                                                                "state": 37
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 22,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "= rangeInput",
                                                                                            "note": {
                                                                                                "type": "expr",
                                                                                                "code": " rangeInput"
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 24,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "",
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "p",
                                                                                                "text": ""
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 113,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "",
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "p",
                                                                                                "text": ""
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 114,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "",
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "p",
                                                                                                "text": ""
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 115,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "Build a select Block:",
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "p",
                                                                                                "text": "Build a select Block:"
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 116,
                                                                                        "name": "SelectBlock",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "/Code",
                                                                                            "note": {
                                                                                                "type": "block",
                                                                                                "isInstantiated": true,
                                                                                                "code": "Code",
                                                                                                "state": "function SelectBlock(values) {\n  return SimpleBlock(values[0],\n    ({ ref, state, onUpdate }) => (\n      <select\n        ref={ref}\n        className=\"w-full\"\n        value={state}\n        onChange={onUpdate('target.value')}\n      >\n        {values.map(value => (\n          <option key={value} value={value}>\n            {value}\n          </option>\n        ))}\n      </select>\n    )\n  )\n}"
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 118,
                                                                                        "name": "options",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "= ['January', 'February', 'March', 'April', 'May', 'June']",
                                                                                            "note": {
                                                                                                "type": "expr",
                                                                                                "code": " ['January', 'February', 'March', 'April', 'May', 'June']"
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 117,
                                                                                        "name": "selected",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "/SelectBlock(options)",
                                                                                            "note": {
                                                                                                "type": "block",
                                                                                                "isInstantiated": true,
                                                                                                "code": "SelectBlock(options)",
                                                                                                "state": "March"
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 119,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "= selected",
                                                                                            "note": {
                                                                                                "type": "expr",
                                                                                                "code": " selected"
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 25,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "",
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "p",
                                                                                                "text": ""
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 121,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "",
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "p",
                                                                                                "text": ""
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 120,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "",
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "p",
                                                                                                "text": ""
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 137,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "## Simple Custom Block Wrapper",
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "h2",
                                                                                                "text": "Simple Custom Block Wrapper"
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 122,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "Use an external library and build a Block around it:",
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "p",
                                                                                                "text": "Use an external library and build a Block around it:"
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 127,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "",
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "p",
                                                                                                "text": ""
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 124,
                                                                                        "name": "Datepicker",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "= import('https://esm.sh/react-datepicker?external=react')",
                                                                                            "note": {
                                                                                                "type": "expr",
                                                                                                "code": " import('https://esm.sh/react-datepicker?external=react')"
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 125,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "/Code",
                                                                                            "note": {
                                                                                                "type": "block",
                                                                                                "isInstantiated": true,
                                                                                                "code": "Code",
                                                                                                "state": "includeCss('https://esm.sh/react-datepicker/dist/react-datepicker.css')"
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 128,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "",
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "p",
                                                                                                "text": ""
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 138,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "It looks like this:",
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "p",
                                                                                                "text": "It looks like this:"
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 126,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "= <Datepicker.default inline />",
                                                                                            "note": {
                                                                                                "type": "expr",
                                                                                                "code": " <Datepicker.default inline />"
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 135,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "",
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "p",
                                                                                                "text": ""
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 136,
                                                                                        "name": "datefns",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "= import('https://esm.sh/date-fns')",
                                                                                            "note": {
                                                                                                "type": "expr",
                                                                                                "code": " import('https://esm.sh/date-fns')"
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 129,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "",
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "p",
                                                                                                "text": ""
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 139,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "Let's wrap it in a Block, so its state is persisted and the selected date can be used:",
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "p",
                                                                                                "text": "Let's wrap it in a Block, so its state is persisted and the selected date can be used:"
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 123,
                                                                                        "name": "DateBlock",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "/Code",
                                                                                            "note": {
                                                                                                "type": "block",
                                                                                                "isInstantiated": true,
                                                                                                "code": "Code",
                                                                                                "state": 'function DateBlock() {\n  return SimpleBlock(new Date(),\n    ({ state, setState }) => {\n      return (\n        <div className="flex flex-col items-center">\n          <Datepicker.default\n            inline\n            selected={state}\n            onSelect={date => setState(date)}\n            />\n        </div>\n      )\n    },\n    {\n      toJSON(date) { return datefns.formatISO(date) },\n      fromJSON(json) {\n        const date = datefns.parseISO(json)\n        return datefns.isValid(date) ? date : new Date()\n      },\n    },\n  )\n}'
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 133,
                                                                                        "name": "date",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "/DateBlock()",
                                                                                            "note": {
                                                                                                "type": "block",
                                                                                                "isInstantiated": true,
                                                                                                "code": "DateBlock()",
                                                                                                "state": "2024-05-23T20:32:56+02:00"
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 134,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "= date",
                                                                                            "note": {
                                                                                                "type": "expr",
                                                                                                "code": " date"
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 131,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "",
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "p",
                                                                                                "text": ""
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 132,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "",
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "p",
                                                                                                "text": ""
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 26,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "## Builtin Blocks",
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "h2",
                                                                                                "text": "Builtin Blocks"
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 33,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "We already used `Code` many times:",
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "p",
                                                                                                "text": "We already used `Code` many times:"
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 50,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "`/Code`",
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "p",
                                                                                                "text": "`/Code`"
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 34,
                                                                                        "name": "codeResult",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "/Code",
                                                                                            "note": {
                                                                                                "type": "block",
                                                                                                "isInstantiated": true,
                                                                                                "code": "Code",
                                                                                                "state": "12 * 12"
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 35,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "",
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "p",
                                                                                                "text": ""
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 82,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "",
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "p",
                                                                                                "text": ""
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 36,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "But we can also take a peek inside with the `Inspect` Block:",
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "p",
                                                                                                "text": "But we can also take a peek inside with the `Inspect` Block:"
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 49,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "`/Debug.Inspect(Code)`",
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "p",
                                                                                                "text": "`/Debug.Inspect(Code)`"
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 37,
                                                                                        "name": "inspectCodeResult",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "/Debug.Inspect(Code)",
                                                                                            "note": {
                                                                                                "type": "block",
                                                                                                "isInstantiated": true,
                                                                                                "code": "Debug.Inspect(Code)",
                                                                                                "state": "Promise.resolve(codeResult)"
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 38,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "= inspectCodeResult",
                                                                                            "note": {
                                                                                                "type": "expr",
                                                                                                "code": " inspectCodeResult"
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 39,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "",
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "p",
                                                                                                "text": ""
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 83,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "",
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "p",
                                                                                                "text": ""
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 27,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "The `Note` Block, of which every line here consists:",
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "p",
                                                                                                "text": "The `Note` Block, of which every line here consists:"
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 48,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "`/Debug.Inspect(Note)`",
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "p",
                                                                                                "text": "`/Debug.Inspect(Note)`"
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 28,
                                                                                        "name": "inspectNoteBlockResult",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "/Debug.Inspect(Note)",
                                                                                            "note": {
                                                                                                "type": "block",
                                                                                                "isInstantiated": true,
                                                                                                "code": "Debug.Inspect(Note)",
                                                                                                "state": {
                                                                                                    "t": "resheet.note",
                                                                                                    "v": 1,
                                                                                                    "level": 0,
                                                                                                    "input": "= inspectCodeResult.state",
                                                                                                    "note": {
                                                                                                        "type": "expr",
                                                                                                        "code": " inspectCodeResult.state"
                                                                                                    }
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 29,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "= inspectNoteBlockResult",
                                                                                            "note": {
                                                                                                "type": "expr",
                                                                                                "code": " inspectNoteBlockResult"
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 40,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "",
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "p",
                                                                                                "text": ""
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 84,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "",
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "p",
                                                                                                "text": ""
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 41,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "### Higher-Order Blocks",
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "h3",
                                                                                                "text": "Higher-Order Blocks"
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 42,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "Higher-Order Blocks embed other Blocks inside of them:",
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "p",
                                                                                                "text": "Higher-Order Blocks embed other Blocks inside of them:"
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 46,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "(The `Inspect` Block was already a very simple example of a higher-order Block)",
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "p",
                                                                                                "text": "(The `Inspect` Block was already a very simple example of a higher-order Block)"
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 43,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "",
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "p",
                                                                                                "text": ""
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 44,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "You already know `SheetOf`, it's the Block powering every Page, with an embedded Note:",
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "p",
                                                                                                "text": "You already know `SheetOf`, it's the Block powering every Page, with an embedded Note:"
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 47,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "`/Debug.Inspect(SheetOf(Note))`",
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "p",
                                                                                                "text": "`/Debug.Inspect(SheetOf(Note))`"
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 45,
                                                                                        "name": "inspectSheetOfNoteBlockResult",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "/Debug.Inspect(SheetOf(Note))",
                                                                                            "note": {
                                                                                                "type": "block",
                                                                                                "isInstantiated": true,
                                                                                                "code": "Debug.Inspect(SheetOf(Note))",
                                                                                                "state": {
                                                                                                    "t": "resheet.sheet",
                                                                                                    "v": 2,
                                                                                                    "lines": [
                                                                                                        {
                                                                                                            "id": 0,
                                                                                                            "name": "",
                                                                                                            "visibility": "block",
                                                                                                            "width": "narrow",
                                                                                                            "state": {
                                                                                                                "t": "resheet.note",
                                                                                                                "v": 1,
                                                                                                                "level": 0,
                                                                                                                "input": "This is a line of the SheetOf Block, which contains a Note Block in which this sentence is written.",
                                                                                                                "note": {
                                                                                                                    "type": "text",
                                                                                                                    "tag": "p",
                                                                                                                    "text": "This is a line of the SheetOf Block, which contains a Note Block in which this sentence is written."
                                                                                                                }
                                                                                                            }
                                                                                                        },
                                                                                                        {
                                                                                                            "id": 1,
                                                                                                            "name": "",
                                                                                                            "visibility": "block",
                                                                                                            "width": "narrow",
                                                                                                            "state": {
                                                                                                                "t": "resheet.note",
                                                                                                                "v": 1,
                                                                                                                "level": 0,
                                                                                                                "input": "This is another line.",
                                                                                                                "note": {
                                                                                                                    "type": "text",
                                                                                                                    "tag": "p",
                                                                                                                    "text": "This is another line."
                                                                                                                }
                                                                                                            }
                                                                                                        },
                                                                                                        {
                                                                                                            "id": 2,
                                                                                                            "name": "",
                                                                                                            "visibility": "block",
                                                                                                            "width": "narrow",
                                                                                                            "state": {
                                                                                                                "t": "resheet.note",
                                                                                                                "v": 1,
                                                                                                                "level": 0,
                                                                                                                "input": "= inspectNoteBlockResult.state.note",
                                                                                                                "note": {
                                                                                                                    "type": "expr",
                                                                                                                    "code": " inspectNoteBlockResult.state.note"
                                                                                                                }
                                                                                                            }
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 51,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "= inspectSheetOfNoteBlockResult.state.lines",
                                                                                            "note": {
                                                                                                "type": "expr",
                                                                                                "code": " inspectSheetOfNoteBlockResult.state.lines"
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 52,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "",
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "p",
                                                                                                "text": ""
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 80,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "",
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "p",
                                                                                                "text": ""
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 81,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "",
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "p",
                                                                                                "text": ""
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 53,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "To be more precise, these pages don't contain the `SheetOf` Block itself but a `BlockSelector` Block pre-set with `SheetOf(Note)`:",
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "p",
                                                                                                "text": "To be more precise, these pages don't contain the `SheetOf` Block itself but a `BlockSelector` Block pre-set with `SheetOf(Note)`:"
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 54,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "`/BlockSelector('SheetOf(Note)', SheetOf(Note))` ",
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "p",
                                                                                                "text": "`/BlockSelector('SheetOf(Note)', SheetOf(Note))` "
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 55,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "/BlockSelector('SheetOf(Note)', SheetOf(Note))",
                                                                                            "note": {
                                                                                                "type": "block",
                                                                                                "isInstantiated": true,
                                                                                                "code": "BlockSelector('SheetOf(Note)', SheetOf(Note))",
                                                                                                "state": {
                                                                                                    "t": "resheet.selector",
                                                                                                    "v": 0,
                                                                                                    "mode": "run",
                                                                                                    "expr": "SheetOf(Note)",
                                                                                                    "inner": {
                                                                                                        "t": "resheet.sheet",
                                                                                                        "v": 2,
                                                                                                        "lines": [
                                                                                                            {
                                                                                                                "id": 0,
                                                                                                                "name": "",
                                                                                                                "visibility": "block",
                                                                                                                "width": "narrow",
                                                                                                                "state": {
                                                                                                                    "t": "resheet.note",
                                                                                                                    "v": 1,
                                                                                                                    "level": 0,
                                                                                                                    "input": "The `BlockSelector` Block allows you to change the Block inside of it.",
                                                                                                                    "note": {
                                                                                                                        "type": "text",
                                                                                                                        "tag": "p",
                                                                                                                        "text": "The `BlockSelector` Block allows you to change the Block inside of it."
                                                                                                                    }
                                                                                                                }
                                                                                                            },
                                                                                                            {
                                                                                                                "id": 1,
                                                                                                                "name": "",
                                                                                                                "visibility": "block",
                                                                                                                "width": "narrow",
                                                                                                                "state": {
                                                                                                                    "t": "resheet.note",
                                                                                                                    "v": 1,
                                                                                                                    "level": 0,
                                                                                                                    "input": "You can use any other Block, change it at the top left.",
                                                                                                                    "note": {
                                                                                                                        "type": "text",
                                                                                                                        "tag": "p",
                                                                                                                        "text": "You can use any other Block, change it at the top left."
                                                                                                                    }
                                                                                                                }
                                                                                                            },
                                                                                                            {
                                                                                                                "id": 12,
                                                                                                                "name": "",
                                                                                                                "visibility": "block",
                                                                                                                "width": "narrow",
                                                                                                                "state": {
                                                                                                                    "t": "resheet.note",
                                                                                                                    "v": 1,
                                                                                                                    "level": 0,
                                                                                                                    "input": "",
                                                                                                                    "note": {
                                                                                                                        "type": "text",
                                                                                                                        "tag": "p",
                                                                                                                        "text": ""
                                                                                                                    }
                                                                                                                }
                                                                                                            },
                                                                                                            {
                                                                                                                "id": 2,
                                                                                                                "name": "",
                                                                                                                "visibility": "block",
                                                                                                                "width": "narrow",
                                                                                                                "state": {
                                                                                                                    "t": "resheet.note",
                                                                                                                    "v": 1,
                                                                                                                    "level": 0,
                                                                                                                    "input": "Be aware:",
                                                                                                                    "note": {
                                                                                                                        "type": "text",
                                                                                                                        "tag": "p",
                                                                                                                        "text": "Be aware:"
                                                                                                                    }
                                                                                                                }
                                                                                                            },
                                                                                                            {
                                                                                                                "id": 9,
                                                                                                                "name": "",
                                                                                                                "visibility": "block",
                                                                                                                "width": "narrow",
                                                                                                                "state": {
                                                                                                                    "t": "resheet.note",
                                                                                                                    "v": 1,
                                                                                                                    "level": 1,
                                                                                                                    "input": "Changing the Block will delete this content here.",
                                                                                                                    "note": {
                                                                                                                        "type": "text",
                                                                                                                        "tag": "p",
                                                                                                                        "text": "Changing the Block will delete this content here."
                                                                                                                    }
                                                                                                                }
                                                                                                            },
                                                                                                            {
                                                                                                                "id": 10,
                                                                                                                "name": "",
                                                                                                                "visibility": "block",
                                                                                                                "width": "narrow",
                                                                                                                "state": {
                                                                                                                    "t": "resheet.note",
                                                                                                                    "v": 1,
                                                                                                                    "level": 1,
                                                                                                                    "input": "_**`C-Z`** or **`esc`** are your friends._",
                                                                                                                    "note": {
                                                                                                                        "type": "text",
                                                                                                                        "tag": "p",
                                                                                                                        "text": "_**`C-Z`** or **`esc`** are your friends._"
                                                                                                                    }
                                                                                                                }
                                                                                                            },
                                                                                                            {
                                                                                                                "id": 11,
                                                                                                                "name": "",
                                                                                                                "visibility": "block",
                                                                                                                "width": "narrow",
                                                                                                                "state": {
                                                                                                                    "t": "resheet.note",
                                                                                                                    "v": 1,
                                                                                                                    "level": 0,
                                                                                                                    "input": "",
                                                                                                                    "note": {
                                                                                                                        "type": "text",
                                                                                                                        "tag": "p",
                                                                                                                        "text": ""
                                                                                                                    }
                                                                                                                }
                                                                                                            },
                                                                                                            {
                                                                                                                "id": 3,
                                                                                                                "name": "",
                                                                                                                "visibility": "block",
                                                                                                                "width": "narrow",
                                                                                                                "state": {
                                                                                                                    "t": "resheet.note",
                                                                                                                    "v": 1,
                                                                                                                    "level": 0,
                                                                                                                    "input": "Try:",
                                                                                                                    "note": {
                                                                                                                        "type": "text",
                                                                                                                        "tag": "p",
                                                                                                                        "text": "Try:"
                                                                                                                    }
                                                                                                                }
                                                                                                            },
                                                                                                            {
                                                                                                                "id": 4,
                                                                                                                "name": "",
                                                                                                                "visibility": "block",
                                                                                                                "width": "narrow",
                                                                                                                "state": {
                                                                                                                    "t": "resheet.note",
                                                                                                                    "v": 1,
                                                                                                                    "level": 1,
                                                                                                                    "input": "`Code`",
                                                                                                                    "note": {
                                                                                                                        "type": "text",
                                                                                                                        "tag": "p",
                                                                                                                        "text": "`Code`"
                                                                                                                    }
                                                                                                                }
                                                                                                            },
                                                                                                            {
                                                                                                                "id": 5,
                                                                                                                "name": "",
                                                                                                                "visibility": "block",
                                                                                                                "width": "narrow",
                                                                                                                "state": {
                                                                                                                    "t": "resheet.note",
                                                                                                                    "v": 1,
                                                                                                                    "level": 1,
                                                                                                                    "input": "`SheetOf(Code)`",
                                                                                                                    "note": {
                                                                                                                        "type": "text",
                                                                                                                        "tag": "p",
                                                                                                                        "text": "`SheetOf(Code)`"
                                                                                                                    }
                                                                                                                }
                                                                                                            },
                                                                                                            {
                                                                                                                "id": 6,
                                                                                                                "name": "",
                                                                                                                "visibility": "block",
                                                                                                                "width": "narrow",
                                                                                                                "state": {
                                                                                                                    "t": "resheet.note",
                                                                                                                    "v": 1,
                                                                                                                    "level": 1,
                                                                                                                    "input": "`SheetOf(CheckEditableBlock)`",
                                                                                                                    "note": {
                                                                                                                        "type": "text",
                                                                                                                        "tag": "p",
                                                                                                                        "text": "`SheetOf(CheckEditableBlock)`"
                                                                                                                    }
                                                                                                                }
                                                                                                            },
                                                                                                            {
                                                                                                                "id": 7,
                                                                                                                "name": "",
                                                                                                                "visibility": "block",
                                                                                                                "width": "narrow",
                                                                                                                "state": {
                                                                                                                    "t": "resheet.note",
                                                                                                                    "v": 1,
                                                                                                                    "level": 0,
                                                                                                                    "input": "",
                                                                                                                    "note": {
                                                                                                                        "type": "text",
                                                                                                                        "tag": "p",
                                                                                                                        "text": ""
                                                                                                                    }
                                                                                                                }
                                                                                                            },
                                                                                                            {
                                                                                                                "id": 8,
                                                                                                                "name": "",
                                                                                                                "visibility": "block",
                                                                                                                "width": "narrow",
                                                                                                                "state": {
                                                                                                                    "t": "resheet.note",
                                                                                                                    "v": 1,
                                                                                                                    "level": 0,
                                                                                                                    "input": 'In the subpage "SimpleBlock" of this page ("Advanced Playground") you can see an example, where the Page was changed to another Block.',
                                                                                                                    "note": {
                                                                                                                        "type": "text",
                                                                                                                        "tag": "p",
                                                                                                                        "text": 'In the subpage "SimpleBlock" of this page ("Advanced Playground") you can see an example, where the Page was changed to another Block.'
                                                                                                                    }
                                                                                                                }
                                                                                                            }
                                                                                                        ]
                                                                                                    }
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 56,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "",
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "p",
                                                                                                "text": ""
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 78,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "",
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "p",
                                                                                                "text": ""
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 79,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "",
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "p",
                                                                                                "text": ""
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 101,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "## Custom Higher-Order Block",
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "h2",
                                                                                                "text": "Custom Higher-Order Block"
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 102,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "Building a higher-order Block is more involved, as you have to integrate with the embedded (inner) Blocks' calculations.",
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "p",
                                                                                                "text": "Building a higher-order Block is more involved, as you have to integrate with the embedded (inner) Blocks' calculations."
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 103,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "Let's build an HStack Block where you can put multiple Blocks in a row. As a simplification, these Blocks won't be able to access each other's values.",
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "p",
                                                                                                "text": "Let's build an HStack Block where you can put multiple Blocks in a row. As a simplification, these Blocks won't be able to access each other's values."
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 104,
                                                                                        "name": "HStack",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "/Code",
                                                                                            "note": {
                                                                                                "type": "block",
                                                                                                "isInstantiated": true,
                                                                                                "code": "Code",
                                                                                                "state": 'function HStack(...subblocks) {\n  // wrap the subblocks with some safeguards\n  const safeblocks = subblocks.map(resheet.blocks.component.safeBlock)\n  \n  return SimpleBlock(\n    safeblocks.map(block => block.init),\n    \n    ({ state, fieldDispatcher, env }) => (\n      <div className="flex flex-row space-x-2">\n        {safeblocks.map((block, index) => (\n          <div className="overflow-x-auto flex-[1_0_0%]">\n            <block.Component\n              key={index}\n              state={state[index]}\n              dispatch={fieldDispatcher(index)}\n              env={env}\n              />\n          </div>\n        ))}\n      </div>\n    ),\n    \n    {\n      // What is the value of this Block?\n      // @returns an Array of the subblocks\' values\n      getResult(state) {\n        return safeblocks.map((block, index) =>\n          block.getResult(state[index])\n        )\n      },\n      \n      // Load a state from json\n      // dispatch and env are needed, because to load some json one\n      // probably has to evaluate the code already. For example when\n      // we will use this Block and load its saved state from a file,\n      // first this definition of the Block has to be evaluated and\n      // then we can use the following fromJSON function to continue\n      // loading the state.\n      // @returns the loaded state\n      fromJSON(json, dispatch, env) {\n        return safeblocks.map((block, index) =>\n          block.fromJSON(\n            json[index],\n            resheet.util.dispatch.fieldDispatcher(index, dispatch),\n            env,\n          )\n        )\n      },\n      \n      // Converts a state to a JSON-serializable value.\n      // @returns a value that can be stringified (NOT an already\n      //          stringified JSON string!)\n      toJSON(state) {\n        return safeblocks.map((block, index) =>\n          block.toJSON(state[index])\n        )\n      },\n      \n      // Reevaluate the computations inside because some variables\n      // given in the Set<string> changedVars changed.\n      // @returns {\n      //            state: /* the new state */,\n      //            invalidated: /* true, if our value changed and\n      //                          * therefore our dependants have\n      //                          * to be recomputed\n      //                          */,\n      //          }\n      recompute(state, dispatch, env, changedVars) {\n        const recomputations = (\n          safeblocks.map((block, index) =>\n            block.recompute(\n              state[index],\n              resheet.util.dispatch.fieldDispatcher(index, dispatch),\n              env,\n              changedVars,\n            )\n          )\n        )\n        \n        const newStates = recomputations.map(recomp => recomp.state)\n        const invalidated = recomputations.some(recomp => recomp.invalidated)\n        return {\n          state: newStates,\n          invalidated,\n        }\n      },\n    },\n  )\n}'
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 107,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "wide",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "`/Debug.Inspect(HStack(SheetOf(Note), Code))`",
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "p",
                                                                                                "text": "`/Debug.Inspect(HStack(SheetOf(Note), Code))`"
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 105,
                                                                                        "name": "inspectHStack",
                                                                                        "visibility": "block",
                                                                                        "width": "wide",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "/Debug.Inspect(HStack(SheetOf(Note), Code))",
                                                                                            "note": {
                                                                                                "type": "block",
                                                                                                "isInstantiated": true,
                                                                                                "code": "Debug.Inspect(HStack(SheetOf(Note), Code))",
                                                                                                "state": [
                                                                                                    {
                                                                                                        "t": "resheet.sheet",
                                                                                                        "v": 2,
                                                                                                        "lines": [
                                                                                                            {
                                                                                                                "id": 0,
                                                                                                                "name": "",
                                                                                                                "visibility": "block",
                                                                                                                "width": "wide",
                                                                                                                "state": {
                                                                                                                    "t": "resheet.note",
                                                                                                                    "v": 1,
                                                                                                                    "level": 0,
                                                                                                                    "input": "Now we can put some stuff side-by-side",
                                                                                                                    "note": {
                                                                                                                        "type": "text",
                                                                                                                        "tag": "p",
                                                                                                                        "text": "Now we can put some stuff side-by-side"
                                                                                                                    }
                                                                                                                }
                                                                                                            },
                                                                                                            {
                                                                                                                "id": 1,
                                                                                                                "name": "",
                                                                                                                "visibility": "block",
                                                                                                                "width": "wide",
                                                                                                                "state": {
                                                                                                                    "t": "resheet.note",
                                                                                                                    "v": 1,
                                                                                                                    "level": 0,
                                                                                                                    "input": "As we haven't implemented any keybindings we have to click to navigate between the columns",
                                                                                                                    "note": {
                                                                                                                        "type": "text",
                                                                                                                        "tag": "p",
                                                                                                                        "text": "As we haven't implemented any keybindings we have to click to navigate between the columns"
                                                                                                                    }
                                                                                                                }
                                                                                                            }
                                                                                                        ]
                                                                                                    },
                                                                                                    "const block = HStack(SheetOf(Note), Code)\nblock.toJSON(block.init)"
                                                                                                ]
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 106,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "= inspectHStack.state",
                                                                                            "note": {
                                                                                                "type": "expr",
                                                                                                "code": " inspectHStack.state"
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 108,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "",
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "p",
                                                                                                "text": ""
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 109,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "",
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "p",
                                                                                                "text": ""
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 110,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "",
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "p",
                                                                                                "text": ""
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 57,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "### Grand Finale",
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "h3",
                                                                                                "text": "Grand Finale"
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 58,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "As the Grand Finale, we're going to embed a whole ReSheet instance:",
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "p",
                                                                                                "text": "As the Grand Finale, we're going to embed a whole ReSheet instance:"
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 59,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "`/Debug.Inspect(DocumentOf(Code))`",
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "p",
                                                                                                "text": "`/Debug.Inspect(DocumentOf(Code))`"
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 95,
                                                                                        "name": "inspectReSheetSimple",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "/Debug.Inspect(DocumentOf(Code))",
                                                                                            "note": {
                                                                                                "type": "block",
                                                                                                "isInstantiated": true,
                                                                                                "code": "Debug.Inspect(DocumentOf(Code))",
                                                                                                "state": {
                                                                                                    "history": [],
                                                                                                    "inner": {
                                                                                                        "t": "resheet.document",
                                                                                                        "v": 1,
                                                                                                        "pages": [
                                                                                                            {
                                                                                                                "id": 0,
                                                                                                                "name": "",
                                                                                                                "state": "// This is a simplified version. But we already know how to embed the full version:\n\nblocks.DocumentOf(\n  blocks.BlockSelector(\n    'SheetOf(Note)',\n    blocks.SheetOf(blocks.Note),\n    blocks,\n  )\n)\n\n// Now is only left to inspect the state of this whole document below.",
                                                                                                                "isCollapsed": true,
                                                                                                                "children": []
                                                                                                            }
                                                                                                        ],
                                                                                                        "viewState": {
                                                                                                            "sidebarOpen": true,
                                                                                                            "openPage": [
                                                                                                                0
                                                                                                            ]
                                                                                                        },
                                                                                                        "template": {
                                                                                                            "id": -1,
                                                                                                            "name": "",
                                                                                                            "state": "",
                                                                                                            "isCollapsed": true,
                                                                                                            "children": []
                                                                                                        }
                                                                                                    }
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 61,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "= inspectReSheetSimple.state",
                                                                                            "note": {
                                                                                                "type": "expr",
                                                                                                "code": " inspectReSheetSimple.state"
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 62,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "",
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "p",
                                                                                                "text": ""
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 63,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "",
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "p",
                                                                                                "text": ""
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 89,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "",
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "p",
                                                                                                "text": ""
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 90,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "#### Full ReSheet Version",
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "h4",
                                                                                                "text": "Full ReSheet Version"
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 64,
                                                                                        "name": "DefaultPageBlock",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "= BlockSelector('SheetOf(Note)', SheetOf(Note))",
                                                                                            "note": {
                                                                                                "type": "expr",
                                                                                                "code": " BlockSelector('SheetOf(Note)', SheetOf(Note))"
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 65,
                                                                                        "name": "ReSheet",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "= DocumentOf(DefaultPageBlock)",
                                                                                            "note": {
                                                                                                "type": "expr",
                                                                                                "code": " DocumentOf(DefaultPageBlock)"
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 66,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "",
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "p",
                                                                                                "text": ""
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 67,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "Here is the full ReSheet version. Try to save the big ReSheet document and load it inside this small instance:",
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "p",
                                                                                                "text": "Here is the full ReSheet version. Try to save the big ReSheet document and load it inside this small instance:"
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 91,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "wide",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "`/Debug.Inspect(ReSheet)`",
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "p",
                                                                                                "text": "`/Debug.Inspect(ReSheet)`"
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 96,
                                                                                        "name": "inspectReSheet",
                                                                                        "visibility": "block",
                                                                                        "width": "wide",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "/Debug.Inspect(ReSheet)",
                                                                                            "note": {
                                                                                                "type": "block",
                                                                                                "isInstantiated": true,
                                                                                                "code": "Debug.Inspect(ReSheet)",
                                                                                                "state": {
                                                                                                    "history": [],
                                                                                                    "inner": {
                                                                                                        "t": "resheet.document",
                                                                                                        "v": 1,
                                                                                                        "pages": [],
                                                                                                        "viewState": {
                                                                                                            "sidebarOpen": true,
                                                                                                            "openPage": []
                                                                                                        },
                                                                                                        "template": {
                                                                                                            "id": -1,
                                                                                                            "name": "",
                                                                                                            "state": {
                                                                                                                "t": "resheet.selector",
                                                                                                                "v": 0,
                                                                                                                "mode": "run",
                                                                                                                "expr": "SheetOf(Note)",
                                                                                                                "inner": {
                                                                                                                    "t": "resheet.sheet",
                                                                                                                    "v": 2,
                                                                                                                    "lines": []
                                                                                                                }
                                                                                                            },
                                                                                                            "isCollapsed": true,
                                                                                                            "children": []
                                                                                                        }
                                                                                                    }
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 69,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "wide",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "= inspectReSheet.state",
                                                                                            "note": {
                                                                                                "type": "expr",
                                                                                                "code": " inspectReSheet.state"
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 70,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "",
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "p",
                                                                                                "text": ""
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 71,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "",
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "p",
                                                                                                "text": ""
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 72,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "That's it. ReSheet is built to be composable and extensible. Its parts can be plugged together and extended as you like.",
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "p",
                                                                                                "text": "That's it. ReSheet is built to be composable and extensible. Its parts can be plugged together and extended as you like."
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 73,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "",
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "p",
                                                                                                "text": ""
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 74,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "",
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "p",
                                                                                                "text": ""
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 75,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "",
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "p",
                                                                                                "text": ""
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 112,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "",
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "p",
                                                                                                "text": ""
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 111,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "full",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "---",
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "p",
                                                                                                "text": "---"
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 76,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "## Preview",
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "h2",
                                                                                                "text": "Preview"
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 97,
                                                                                        "name": "previewBlockTemplate",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "/Debug.Inspect(SheetOf(Note))",
                                                                                            "note": {
                                                                                                "type": "block",
                                                                                                "isInstantiated": true,
                                                                                                "code": "Debug.Inspect(SheetOf(Note))",
                                                                                                "state": {
                                                                                                    "t": "resheet.sheet",
                                                                                                    "v": 2,
                                                                                                    "lines": [
                                                                                                        {
                                                                                                            "id": 1,
                                                                                                            "name": "",
                                                                                                            "visibility": "block",
                                                                                                            "width": "narrow",
                                                                                                            "state": {
                                                                                                                "t": "resheet.note",
                                                                                                                "v": 1,
                                                                                                                "level": 0,
                                                                                                                "input": "### Custom Blocks",
                                                                                                                "note": {
                                                                                                                    "type": "text",
                                                                                                                    "tag": "h3",
                                                                                                                    "text": "Custom Blocks"
                                                                                                                }
                                                                                                            }
                                                                                                        },
                                                                                                        {
                                                                                                            "id": 2,
                                                                                                            "name": "",
                                                                                                            "visibility": "block",
                                                                                                            "width": "narrow",
                                                                                                            "state": {
                                                                                                                "t": "resheet.note",
                                                                                                                "v": 1,
                                                                                                                "level": 0,
                                                                                                                "input": 'We build these custom Blocks in "Examples > Custom Blocks":',
                                                                                                                "note": {
                                                                                                                    "type": "text",
                                                                                                                    "tag": "p",
                                                                                                                    "text": 'We build these custom Blocks in "Examples > Custom Blocks":'
                                                                                                                }
                                                                                                            }
                                                                                                        },
                                                                                                        {
                                                                                                            "id": 3,
                                                                                                            "name": "",
                                                                                                            "visibility": "block",
                                                                                                            "width": "narrow",
                                                                                                            "state": {
                                                                                                                "t": "resheet.note",
                                                                                                                "v": 1,
                                                                                                                "level": 0,
                                                                                                                "input": "",
                                                                                                                "note": {
                                                                                                                    "type": "text",
                                                                                                                    "tag": "p",
                                                                                                                    "text": ""
                                                                                                                }
                                                                                                            }
                                                                                                        },
                                                                                                        {
                                                                                                            "id": 25,
                                                                                                            "name": "",
                                                                                                            "visibility": "block",
                                                                                                            "width": "narrow",
                                                                                                            "state": {
                                                                                                                "t": "resheet.note",
                                                                                                                "v": 1,
                                                                                                                "level": 0,
                                                                                                                "input": "#### `/DateBlock()`",
                                                                                                                "note": {
                                                                                                                    "type": "text",
                                                                                                                    "tag": "h4",
                                                                                                                    "text": "`/DateBlock()`"
                                                                                                                }
                                                                                                            }
                                                                                                        },
                                                                                                        {
                                                                                                            "id": 26,
                                                                                                            "name": "dateBlockValue",
                                                                                                            "visibility": "block",
                                                                                                            "width": "narrow",
                                                                                                            "state": {
                                                                                                                "t": "resheet.note",
                                                                                                                "v": 1,
                                                                                                                "level": 0,
                                                                                                                "input": "/DateBlock()",
                                                                                                                "note": {
                                                                                                                    "type": "block",
                                                                                                                    "isInstantiated": true,
                                                                                                                    "code": "DateBlock()",
                                                                                                                    "state": "2024-05-23T20:32:56+02:00"
                                                                                                                }
                                                                                                            }
                                                                                                        },
                                                                                                        {
                                                                                                            "id": 27,
                                                                                                            "name": "",
                                                                                                            "visibility": "block",
                                                                                                            "width": "narrow",
                                                                                                            "state": {
                                                                                                                "t": "resheet.note",
                                                                                                                "v": 1,
                                                                                                                "level": 0,
                                                                                                                "input": "= dateBlockValue",
                                                                                                                "note": {
                                                                                                                    "type": "expr",
                                                                                                                    "code": " dateBlockValue"
                                                                                                                }
                                                                                                            }
                                                                                                        },
                                                                                                        {
                                                                                                            "id": 7,
                                                                                                            "name": "",
                                                                                                            "visibility": "block",
                                                                                                            "width": "narrow",
                                                                                                            "state": {
                                                                                                                "t": "resheet.note",
                                                                                                                "v": 1,
                                                                                                                "level": 0,
                                                                                                                "input": "",
                                                                                                                "note": {
                                                                                                                    "type": "text",
                                                                                                                    "tag": "p",
                                                                                                                    "text": ""
                                                                                                                }
                                                                                                            }
                                                                                                        },
                                                                                                        {
                                                                                                            "id": 8,
                                                                                                            "name": "",
                                                                                                            "visibility": "block",
                                                                                                            "width": "narrow",
                                                                                                            "state": {
                                                                                                                "t": "resheet.note",
                                                                                                                "v": 1,
                                                                                                                "level": 0,
                                                                                                                "input": "#### `/SliderBlock()`",
                                                                                                                "note": {
                                                                                                                    "type": "text",
                                                                                                                    "tag": "h4",
                                                                                                                    "text": "`/SliderBlock()`"
                                                                                                                }
                                                                                                            }
                                                                                                        },
                                                                                                        {
                                                                                                            "id": 9,
                                                                                                            "name": "sliderBlockValue",
                                                                                                            "visibility": "block",
                                                                                                            "width": "narrow",
                                                                                                            "state": {
                                                                                                                "t": "resheet.note",
                                                                                                                "v": 1,
                                                                                                                "level": 0,
                                                                                                                "input": "/SliderBlock()",
                                                                                                                "note": {
                                                                                                                    "type": "block",
                                                                                                                    "isInstantiated": true,
                                                                                                                    "code": "SliderBlock()",
                                                                                                                    "state": 49
                                                                                                                }
                                                                                                            }
                                                                                                        },
                                                                                                        {
                                                                                                            "id": 10,
                                                                                                            "name": "",
                                                                                                            "visibility": "block",
                                                                                                            "width": "narrow",
                                                                                                            "state": {
                                                                                                                "t": "resheet.note",
                                                                                                                "v": 1,
                                                                                                                "level": 0,
                                                                                                                "input": "= sliderBlockValue",
                                                                                                                "note": {
                                                                                                                    "type": "expr",
                                                                                                                    "code": " sliderBlockValue"
                                                                                                                }
                                                                                                            }
                                                                                                        },
                                                                                                        {
                                                                                                            "id": 11,
                                                                                                            "name": "",
                                                                                                            "visibility": "block",
                                                                                                            "width": "narrow",
                                                                                                            "state": {
                                                                                                                "t": "resheet.note",
                                                                                                                "v": 1,
                                                                                                                "level": 0,
                                                                                                                "input": "",
                                                                                                                "note": {
                                                                                                                    "type": "text",
                                                                                                                    "tag": "p",
                                                                                                                    "text": ""
                                                                                                                }
                                                                                                            }
                                                                                                        },
                                                                                                        {
                                                                                                            "id": 20,
                                                                                                            "name": "",
                                                                                                            "visibility": "block",
                                                                                                            "width": "narrow",
                                                                                                            "state": {
                                                                                                                "t": "resheet.note",
                                                                                                                "v": 1,
                                                                                                                "level": 0,
                                                                                                                "input": "",
                                                                                                                "note": {
                                                                                                                    "type": "text",
                                                                                                                    "tag": "p",
                                                                                                                    "text": ""
                                                                                                                }
                                                                                                            }
                                                                                                        },
                                                                                                        {
                                                                                                            "id": 21,
                                                                                                            "name": "",
                                                                                                            "visibility": "block",
                                                                                                            "width": "narrow",
                                                                                                            "state": {
                                                                                                                "t": "resheet.note",
                                                                                                                "v": 1,
                                                                                                                "level": 0,
                                                                                                                "input": "#### `/HStack(DateBlock(), SliderBlock(), SelectBlock(options))`",
                                                                                                                "note": {
                                                                                                                    "type": "text",
                                                                                                                    "tag": "h4",
                                                                                                                    "text": "`/HStack(DateBlock(), SliderBlock(), SelectBlock(options))`"
                                                                                                                }
                                                                                                            }
                                                                                                        },
                                                                                                        {
                                                                                                            "id": 28,
                                                                                                            "name": "options",
                                                                                                            "visibility": "block",
                                                                                                            "width": "narrow",
                                                                                                            "state": {
                                                                                                                "t": "resheet.note",
                                                                                                                "v": 1,
                                                                                                                "level": 0,
                                                                                                                "input": "= ['yes', 'no']",
                                                                                                                "note": {
                                                                                                                    "type": "expr",
                                                                                                                    "code": " ['yes', 'no']"
                                                                                                                }
                                                                                                            }
                                                                                                        },
                                                                                                        {
                                                                                                            "id": 22,
                                                                                                            "name": "hstack",
                                                                                                            "visibility": "block",
                                                                                                            "width": "narrow",
                                                                                                            "state": {
                                                                                                                "t": "resheet.note",
                                                                                                                "v": 1,
                                                                                                                "level": 0,
                                                                                                                "input": "/HStack(DateBlock(), SliderBlock(), SelectBlock(options))",
                                                                                                                "note": {
                                                                                                                    "type": "block",
                                                                                                                    "isInstantiated": true,
                                                                                                                    "code": "HStack(DateBlock(), SliderBlock(), SelectBlock(options))",
                                                                                                                    "state": [
                                                                                                                        "2024-05-23T20:40:02+02:00",
                                                                                                                        35,
                                                                                                                        "yes"
                                                                                                                    ]
                                                                                                                }
                                                                                                            }
                                                                                                        },
                                                                                                        {
                                                                                                            "id": 23,
                                                                                                            "name": "",
                                                                                                            "visibility": "block",
                                                                                                            "width": "narrow",
                                                                                                            "state": {
                                                                                                                "t": "resheet.note",
                                                                                                                "v": 1,
                                                                                                                "level": 0,
                                                                                                                "input": "= hstack",
                                                                                                                "note": {
                                                                                                                    "type": "expr",
                                                                                                                    "code": " hstack"
                                                                                                                }
                                                                                                            }
                                                                                                        },
                                                                                                        {
                                                                                                            "id": 12,
                                                                                                            "name": "",
                                                                                                            "visibility": "block",
                                                                                                            "width": "narrow",
                                                                                                            "state": {
                                                                                                                "t": "resheet.note",
                                                                                                                "v": 1,
                                                                                                                "level": 0,
                                                                                                                "input": "",
                                                                                                                "note": {
                                                                                                                    "type": "text",
                                                                                                                    "tag": "p",
                                                                                                                    "text": ""
                                                                                                                }
                                                                                                            }
                                                                                                        },
                                                                                                        {
                                                                                                            "id": 24,
                                                                                                            "name": "",
                                                                                                            "visibility": "block",
                                                                                                            "width": "narrow",
                                                                                                            "state": {
                                                                                                                "t": "resheet.note",
                                                                                                                "v": 1,
                                                                                                                "level": 0,
                                                                                                                "input": "",
                                                                                                                "note": {
                                                                                                                    "type": "text",
                                                                                                                    "tag": "p",
                                                                                                                    "text": ""
                                                                                                                }
                                                                                                            }
                                                                                                        },
                                                                                                        {
                                                                                                            "id": 29,
                                                                                                            "name": "",
                                                                                                            "visibility": "block",
                                                                                                            "width": "narrow",
                                                                                                            "state": {
                                                                                                                "t": "resheet.note",
                                                                                                                "v": 1,
                                                                                                                "level": 0,
                                                                                                                "input": "#### Built-in Blocks",
                                                                                                                "note": {
                                                                                                                    "type": "text",
                                                                                                                    "tag": "h4",
                                                                                                                    "text": "Built-in Blocks"
                                                                                                                }
                                                                                                            }
                                                                                                        },
                                                                                                        {
                                                                                                            "id": 13,
                                                                                                            "name": "",
                                                                                                            "visibility": "block",
                                                                                                            "width": "narrow",
                                                                                                            "state": {
                                                                                                                "t": "resheet.note",
                                                                                                                "v": 1,
                                                                                                                "level": 0,
                                                                                                                "input": "And we inspect some built-in Blocks:",
                                                                                                                "note": {
                                                                                                                    "type": "text",
                                                                                                                    "tag": "p",
                                                                                                                    "text": "And we inspect some built-in Blocks:"
                                                                                                                }
                                                                                                            }
                                                                                                        },
                                                                                                        {
                                                                                                            "id": 14,
                                                                                                            "name": "",
                                                                                                            "visibility": "block",
                                                                                                            "width": "narrow",
                                                                                                            "state": {
                                                                                                                "t": "resheet.note",
                                                                                                                "v": 1,
                                                                                                                "level": 0,
                                                                                                                "input": "`/Debug.Inspect(Note)`",
                                                                                                                "note": {
                                                                                                                    "type": "text",
                                                                                                                    "tag": "p",
                                                                                                                    "text": "`/Debug.Inspect(Note)`"
                                                                                                                }
                                                                                                            }
                                                                                                        },
                                                                                                        {
                                                                                                            "id": 15,
                                                                                                            "name": "inspectNote",
                                                                                                            "visibility": "block",
                                                                                                            "width": "narrow",
                                                                                                            "state": {
                                                                                                                "t": "resheet.note",
                                                                                                                "v": 1,
                                                                                                                "level": 0,
                                                                                                                "input": "/Debug.Inspect(Note)",
                                                                                                                "note": {
                                                                                                                    "type": "block",
                                                                                                                    "isInstantiated": true,
                                                                                                                    "code": "Debug.Inspect(Note)",
                                                                                                                    "state": {
                                                                                                                        "t": "resheet.note",
                                                                                                                        "v": 1,
                                                                                                                        "level": 0,
                                                                                                                        "input": "= sliderBlockValue",
                                                                                                                        "note": {
                                                                                                                            "type": "expr",
                                                                                                                            "code": " sliderBlockValue"
                                                                                                                        }
                                                                                                                    }
                                                                                                                }
                                                                                                            }
                                                                                                        },
                                                                                                        {
                                                                                                            "id": 16,
                                                                                                            "name": "",
                                                                                                            "visibility": "block",
                                                                                                            "width": "narrow",
                                                                                                            "state": {
                                                                                                                "t": "resheet.note",
                                                                                                                "v": 1,
                                                                                                                "level": 0,
                                                                                                                "input": "= inspectNote.state",
                                                                                                                "note": {
                                                                                                                    "type": "expr",
                                                                                                                    "code": " inspectNote.state"
                                                                                                                }
                                                                                                            }
                                                                                                        },
                                                                                                        {
                                                                                                            "id": 17,
                                                                                                            "name": "",
                                                                                                            "visibility": "block",
                                                                                                            "width": "narrow",
                                                                                                            "state": {
                                                                                                                "t": "resheet.note",
                                                                                                                "v": 1,
                                                                                                                "level": 0,
                                                                                                                "input": "",
                                                                                                                "note": {
                                                                                                                    "type": "text",
                                                                                                                    "tag": "p",
                                                                                                                    "text": ""
                                                                                                                }
                                                                                                            }
                                                                                                        },
                                                                                                        {
                                                                                                            "id": 18,
                                                                                                            "name": "",
                                                                                                            "visibility": "block",
                                                                                                            "width": "narrow",
                                                                                                            "state": {
                                                                                                                "t": "resheet.note",
                                                                                                                "v": 1,
                                                                                                                "level": 0,
                                                                                                                "input": "",
                                                                                                                "note": {
                                                                                                                    "type": "text",
                                                                                                                    "tag": "p",
                                                                                                                    "text": ""
                                                                                                                }
                                                                                                            }
                                                                                                        },
                                                                                                        {
                                                                                                            "id": 19,
                                                                                                            "name": "",
                                                                                                            "visibility": "block",
                                                                                                            "width": "narrow",
                                                                                                            "state": {
                                                                                                                "t": "resheet.note",
                                                                                                                "v": 1,
                                                                                                                "level": 0,
                                                                                                                "input": '<span className="text-gray-400 text-sm">Psst: And don\'t miss the Grand Finale!</span>',
                                                                                                                "note": {
                                                                                                                    "type": "text",
                                                                                                                    "tag": "p",
                                                                                                                    "text": '<span className="text-gray-400 text-sm">Psst: And don\'t miss the Grand Finale!</span>'
                                                                                                                }
                                                                                                            }
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 99,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "",
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "p",
                                                                                                "text": ""
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 100,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "",
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "p",
                                                                                                "text": ""
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 98,
                                                                                        "name": "preview",
                                                                                        "visibility": "result",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "/Code",
                                                                                            "note": {
                                                                                                "type": "block",
                                                                                                "isInstantiated": true,
                                                                                                "code": "Code",
                                                                                                "state": "Util.WithEnv(\n  env => ({\n    ...env,\n    CheckBlock,\n    CheckEditableBlock,\n    SliderBlock,\n    SelectBlock,\n    DateBlock,\n    HStack,\n  }),\n  previewBlockTemplate.derivedBlock,\n)"
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                ]
                                                                            }
                                                                        },
                                                                        "isCollapsed": true,
                                                                        "children": [
                                                                            {
                                                                                "id": 0,
                                                                                "name": "SimpleBlock",
                                                                                "state": {
                                                                                    "t": "resheet.selector",
                                                                                    "v": 0,
                                                                                    "mode": "run",
                                                                                    "expr": "Code",
                                                                                    "inner": "function update(value, path, fn) {\n  if (!path || Array.isArray(path) && path.length === 0) {\n    return fn(value)\n  }\n  else {\n    return immutable.update(value, path, fn)\n  }\n}\n\nfunction SimpleBlock(init, view, desc={}) {\n  return resheet.core.block.create({\n    init,\n    view({ state, dispatch, env }, ref) {\n      function setState(newState, path=[]) {\n        const updateState = (\n          typeof newState === 'function' ?\n            newState\n          :\n            () => newState\n        )\n        \n        dispatch(state => ({\n          state: update(state, path, updateState),\n        }))\n      }\n      \n      function onUpdate(evPath, statePath=[], processValue=lodash.identity) {\n        return ev => {\n          setState(processValue(lodash.get(ev, evPath)), statePath)\n        }\n      }\n      \n      function fieldDispatcher(field) {\n        return resheet.util.dispatch.fieldDispatcher(field, dispatch)\n      }\n      \n      return view({\n        state, dispatch, env, ref,\n        setState, onUpdate, fieldDispatcher,\n      })\n    },\n    getResult(state) { return state },\n    recompute(state) { return { state, invalidated: false } },\n    fromJSON(json) { return json ?? init },\n    toJSON(state) { return state },\n    ...desc,\n  })\n}"
                                                                                },
                                                                                "isCollapsed": false,
                                                                                "children": []
                                                                            },
                                                                            {
                                                                                "id": 1,
                                                                                "name": "includeCss",
                                                                                "state": {
                                                                                    "t": "resheet.selector",
                                                                                    "v": 0,
                                                                                    "mode": "run",
                                                                                    "expr": "SheetOf(Note)",
                                                                                    "inner": {
                                                                                        "t": "resheet.sheet",
                                                                                        "v": 2,
                                                                                        "lines": [
                                                                                            {
                                                                                                "id": 1,
                                                                                                "name": "cleanId",
                                                                                                "visibility": "block",
                                                                                                "width": "narrow",
                                                                                                "state": {
                                                                                                    "t": "resheet.note",
                                                                                                    "v": 1,
                                                                                                    "level": 0,
                                                                                                    "input": "/Code",
                                                                                                    "note": {
                                                                                                        "type": "block",
                                                                                                        "isInstantiated": true,
                                                                                                        "code": "Code",
                                                                                                        "state": "function cleanId(id) {\n  id = id.replace(/\\s+/g, '-');\n  id = id.replace(/[^\\w\\s-]/gi, '');\n  \n  if (!/^[a-zA-Z_]/.test(id)) {\n    id = '_' + id;\n  }\n  \n  return id.toLowerCase();\n}"
                                                                                                    }
                                                                                                }
                                                                                            },
                                                                                            {
                                                                                                "id": 0,
                                                                                                "name": "includeCss",
                                                                                                "visibility": "block",
                                                                                                "width": "narrow",
                                                                                                "state": {
                                                                                                    "t": "resheet.note",
                                                                                                    "v": 1,
                                                                                                    "level": 0,
                                                                                                    "input": "/Code",
                                                                                                    "note": {
                                                                                                        "type": "block",
                                                                                                        "isInstantiated": true,
                                                                                                        "code": "Code",
                                                                                                        "state": "function includeCss(url) {\n  const id = cleanId(url)\n  \n  const found = document.getElementById(id)\n  if (found) { return found }\n\n  const link = document.createElement('link')\n  link.id = id\n  link.href = url\n  link.rel = 'stylesheet'\n  \n  document.head.appendChild(link)\n  \n  return link\n}"
                                                                                                    }
                                                                                                }
                                                                                            }
                                                                                        ]
                                                                                    }
                                                                                },
                                                                                "isCollapsed": true,
                                                                                "children": []
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "id": 4,
                                                                        "name": "Interactive Game Dev",
                                                                        "state": {
                                                                            "t": "resheet.selector",
                                                                            "v": 0,
                                                                            "mode": "run",
                                                                            "expr": "SheetOf(Note)",
                                                                            "inner": {
                                                                                "t": "resheet.sheet",
                                                                                "v": 2,
                                                                                "lines": [
                                                                                    {
                                                                                        "id": 0,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "# Interactive Game Dev",
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "h1",
                                                                                                "text": "Interactive Game Dev"
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 1,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "Build a custom Game Block for interactively developing a simple game. Leverage existing Blocks to combine them to the tailored needs of a Game Editor.",
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "p",
                                                                                                "text": "Build a custom Game Block for interactively developing a simple game. Leverage existing Blocks to combine them to the tailored needs of a Game Editor."
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 2,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "",
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "p",
                                                                                                "text": ""
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 3,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "This is just a showcase of how powerful a custom-built block can be. It doesn't include a step-by-step guide or explanation of the Game Block implementation.",
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "p",
                                                                                                "text": "This is just a showcase of how powerful a custom-built block can be. It doesn't include a step-by-step guide or explanation of the Game Block implementation."
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 4,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "",
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "p",
                                                                                                "text": ""
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 7,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "A Game consists of 3 parts:",
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "p",
                                                                                                "text": "A Game consists of 3 parts:"
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 8,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 1,
                                                                                            "input": "- The State: defining the current state of the game (where is the character, health, etc)",
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "li",
                                                                                                "text": "The State: defining the current state of the game (where is the character, health, etc)"
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 9,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 1,
                                                                                            "input": "- The Update Logic: calculates a new state of the game by simulating a time-step of the game or responding to input",
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "li",
                                                                                                "text": "The Update Logic: calculates a new state of the game by simulating a time-step of the game or responding to input"
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 10,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 1,
                                                                                            "input": "- The Render Logic: creates an image corresponding to the state",
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "li",
                                                                                                "text": "The Render Logic: creates an image corresponding to the state"
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 13,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "",
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "p",
                                                                                                "text": ""
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 5,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "Therefore you can edit these 3 components:",
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "p",
                                                                                                "text": "Therefore you can edit these 3 components:"
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 6,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 1,
                                                                                            "input": "- Initial State: How does the game start?",
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "li",
                                                                                                "text": "Initial State: How does the game start?"
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 11,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 1,
                                                                                            "input": "- Update: calculate a new state out of the old state and an input (if it's `undefined` the update is a simulation-step)",
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "li",
                                                                                                "text": "Update: calculate a new state out of the old state and an input (if it's `undefined` the update is a simulation-step)"
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 12,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 1,
                                                                                            "input": "- Render: render the game",
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "li",
                                                                                                "text": "Render: render the game"
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 29,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "",
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "p",
                                                                                                "text": ""
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 30,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "As everywhere else you can see the live effects of your code changes.",
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "p",
                                                                                                "text": "As everywhere else you can see the live effects of your code changes."
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 14,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "",
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "p",
                                                                                                "text": ""
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 31,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "",
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "p",
                                                                                                "text": ""
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 32,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "wide",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "---",
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "p",
                                                                                                "text": "---"
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 33,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "",
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "p",
                                                                                                "text": ""
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 40,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "",
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "p",
                                                                                                "text": ""
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 16,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "## Simple Animation",
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "h2",
                                                                                                "text": "Simple Animation"
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 18,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": 'This example doesn\'t react to input and only runs some simulation. Start and stop with the left button, make a single simulation step with "Update" and reset to the initial state with "Reset".',
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "p",
                                                                                                "text": 'This example doesn\'t react to input and only runs some simulation. Start and stop with the left button, make a single simulation step with "Update" and reset to the initial state with "Reset".'
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 17,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "wide",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "/Game",
                                                                                            "note": {
                                                                                                "type": "block",
                                                                                                "isInstantiated": true,
                                                                                                "code": "Game",
                                                                                                "state": {
                                                                                                    "init": "({\n  y: 200,\n  ySpeed: 0,\n})",
                                                                                                    "update": {
                                                                                                        "t": "resheet.sheet",
                                                                                                        "v": 2,
                                                                                                        "lines": [
                                                                                                            {
                                                                                                                "id": 0,
                                                                                                                "name": "",
                                                                                                                "visibility": "block",
                                                                                                                "width": "narrow",
                                                                                                                "state": {
                                                                                                                    "t": "resheet.note",
                                                                                                                    "v": 1,
                                                                                                                    "level": 0,
                                                                                                                    "input": "The current state:",
                                                                                                                    "note": {
                                                                                                                        "type": "text",
                                                                                                                        "tag": "p",
                                                                                                                        "text": "The current state:"
                                                                                                                    }
                                                                                                                }
                                                                                                            },
                                                                                                            {
                                                                                                                "id": 1,
                                                                                                                "name": "",
                                                                                                                "visibility": "block",
                                                                                                                "width": "narrow",
                                                                                                                "state": {
                                                                                                                    "t": "resheet.note",
                                                                                                                    "v": 1,
                                                                                                                    "level": 0,
                                                                                                                    "input": "= state",
                                                                                                                    "note": {
                                                                                                                        "type": "expr",
                                                                                                                        "code": " state"
                                                                                                                    }
                                                                                                                }
                                                                                                            },
                                                                                                            {
                                                                                                                "id": 2,
                                                                                                                "name": "",
                                                                                                                "visibility": "block",
                                                                                                                "width": "narrow",
                                                                                                                "state": {
                                                                                                                    "t": "resheet.note",
                                                                                                                    "v": 1,
                                                                                                                    "level": 0,
                                                                                                                    "input": "",
                                                                                                                    "note": {
                                                                                                                        "type": "text",
                                                                                                                        "tag": "p",
                                                                                                                        "text": ""
                                                                                                                    }
                                                                                                                }
                                                                                                            },
                                                                                                            {
                                                                                                                "id": 3,
                                                                                                                "name": "",
                                                                                                                "visibility": "block",
                                                                                                                "width": "narrow",
                                                                                                                "state": {
                                                                                                                    "t": "resheet.note",
                                                                                                                    "v": 1,
                                                                                                                    "level": 0,
                                                                                                                    "input": "Gravity means decelerating:",
                                                                                                                    "note": {
                                                                                                                        "type": "text",
                                                                                                                        "tag": "p",
                                                                                                                        "text": "Gravity means decelerating:"
                                                                                                                    }
                                                                                                                }
                                                                                                            },
                                                                                                            {
                                                                                                                "id": 4,
                                                                                                                "name": "gravity",
                                                                                                                "visibility": "block",
                                                                                                                "width": "narrow",
                                                                                                                "state": {
                                                                                                                    "t": "resheet.note",
                                                                                                                    "v": 1,
                                                                                                                    "level": 0,
                                                                                                                    "input": "= { ...state, ySpeed: state.ySpeed - 0.75 }",
                                                                                                                    "note": {
                                                                                                                        "type": "expr",
                                                                                                                        "code": " { ...state, ySpeed: state.ySpeed - 0.75 }"
                                                                                                                    }
                                                                                                                }
                                                                                                            },
                                                                                                            {
                                                                                                                "id": 5,
                                                                                                                "name": "",
                                                                                                                "visibility": "block",
                                                                                                                "width": "narrow",
                                                                                                                "state": {
                                                                                                                    "t": "resheet.note",
                                                                                                                    "v": 1,
                                                                                                                    "level": 0,
                                                                                                                    "input": "",
                                                                                                                    "note": {
                                                                                                                        "type": "text",
                                                                                                                        "tag": "p",
                                                                                                                        "text": ""
                                                                                                                    }
                                                                                                                }
                                                                                                            },
                                                                                                            {
                                                                                                                "id": 6,
                                                                                                                "name": "",
                                                                                                                "visibility": "block",
                                                                                                                "width": "narrow",
                                                                                                                "state": {
                                                                                                                    "t": "resheet.note",
                                                                                                                    "v": 1,
                                                                                                                    "level": 0,
                                                                                                                    "input": "Jumping means getting some upwards velocity:",
                                                                                                                    "note": {
                                                                                                                        "type": "text",
                                                                                                                        "tag": "p",
                                                                                                                        "text": "Jumping means getting some upwards velocity:"
                                                                                                                    }
                                                                                                                }
                                                                                                            },
                                                                                                            {
                                                                                                                "id": 7,
                                                                                                                "name": "jump",
                                                                                                                "visibility": "block",
                                                                                                                "width": "narrow",
                                                                                                                "state": {
                                                                                                                    "t": "resheet.note",
                                                                                                                    "v": 1,
                                                                                                                    "level": 0,
                                                                                                                    "input": "= { ...state, ySpeed: 12 }",
                                                                                                                    "note": {
                                                                                                                        "type": "expr",
                                                                                                                        "code": " { ...state, ySpeed: 12 }"
                                                                                                                    }
                                                                                                                }
                                                                                                            },
                                                                                                            {
                                                                                                                "id": 8,
                                                                                                                "name": "",
                                                                                                                "visibility": "block",
                                                                                                                "width": "narrow",
                                                                                                                "state": {
                                                                                                                    "t": "resheet.note",
                                                                                                                    "v": 1,
                                                                                                                    "level": 0,
                                                                                                                    "input": "",
                                                                                                                    "note": {
                                                                                                                        "type": "text",
                                                                                                                        "tag": "p",
                                                                                                                        "text": ""
                                                                                                                    }
                                                                                                                }
                                                                                                            },
                                                                                                            {
                                                                                                                "id": 9,
                                                                                                                "name": "",
                                                                                                                "visibility": "block",
                                                                                                                "width": "narrow",
                                                                                                                "state": {
                                                                                                                    "t": "resheet.note",
                                                                                                                    "v": 1,
                                                                                                                    "level": 0,
                                                                                                                    "input": "Jump if on ground or otherwise let gravity pull us down:",
                                                                                                                    "note": {
                                                                                                                        "type": "text",
                                                                                                                        "tag": "p",
                                                                                                                        "text": "Jump if on ground or otherwise let gravity pull us down:"
                                                                                                                    }
                                                                                                                }
                                                                                                            },
                                                                                                            {
                                                                                                                "id": 10,
                                                                                                                "name": "forces",
                                                                                                                "visibility": "block",
                                                                                                                "width": "narrow",
                                                                                                                "state": {
                                                                                                                    "t": "resheet.note",
                                                                                                                    "v": 1,
                                                                                                                    "level": 0,
                                                                                                                    "input": "= state.y <= 0 ? jump : gravity",
                                                                                                                    "note": {
                                                                                                                        "type": "expr",
                                                                                                                        "code": " state.y <= 0 ? jump : gravity"
                                                                                                                    }
                                                                                                                }
                                                                                                            },
                                                                                                            {
                                                                                                                "id": 11,
                                                                                                                "name": "",
                                                                                                                "visibility": "block",
                                                                                                                "width": "narrow",
                                                                                                                "state": {
                                                                                                                    "t": "resheet.note",
                                                                                                                    "v": 1,
                                                                                                                    "level": 0,
                                                                                                                    "input": "",
                                                                                                                    "note": {
                                                                                                                        "type": "text",
                                                                                                                        "tag": "p",
                                                                                                                        "text": ""
                                                                                                                    }
                                                                                                                }
                                                                                                            },
                                                                                                            {
                                                                                                                "id": 12,
                                                                                                                "name": "",
                                                                                                                "visibility": "block",
                                                                                                                "width": "narrow",
                                                                                                                "state": {
                                                                                                                    "t": "resheet.note",
                                                                                                                    "v": 1,
                                                                                                                    "level": 0,
                                                                                                                    "input": "Move according to speed:",
                                                                                                                    "note": {
                                                                                                                        "type": "text",
                                                                                                                        "tag": "p",
                                                                                                                        "text": "Move according to speed:"
                                                                                                                    }
                                                                                                                }
                                                                                                            },
                                                                                                            {
                                                                                                                "id": 13,
                                                                                                                "name": "newState",
                                                                                                                "visibility": "block",
                                                                                                                "width": "narrow",
                                                                                                                "state": {
                                                                                                                    "t": "resheet.note",
                                                                                                                    "v": 1,
                                                                                                                    "level": 0,
                                                                                                                    "input": "= { ...forces, y: forces.y + forces.ySpeed }",
                                                                                                                    "note": {
                                                                                                                        "type": "expr",
                                                                                                                        "code": " { ...forces, y: forces.y + forces.ySpeed }"
                                                                                                                    }
                                                                                                                }
                                                                                                            }
                                                                                                        ]
                                                                                                    },
                                                                                                    "render": {
                                                                                                        "t": "resheet.sheet",
                                                                                                        "v": 2,
                                                                                                        "lines": [
                                                                                                            {
                                                                                                                "id": 1,
                                                                                                                "name": "",
                                                                                                                "visibility": "block",
                                                                                                                "width": "full",
                                                                                                                "state": {
                                                                                                                    "t": "resheet.note",
                                                                                                                    "v": 1,
                                                                                                                    "level": 0,
                                                                                                                    "input": "/Code",
                                                                                                                    "note": {
                                                                                                                        "type": "block",
                                                                                                                        "isInstantiated": true,
                                                                                                                        "code": "Code",
                                                                                                                        "state": 'const height = 400;\nconst tileSize = 64;\nconst ground = height - tileSize;\n\nfunction GameView({ state, update }) {\n  const { running, toggleRunning } = useAnimation(update)\n  \n  return (\n    <div>\n      <div className="w-full flex flex-row space-x-2">\n        <button\n          className={`\n            flex-1 rounded\n            bg-${running ? "green" : "red"}-100\n            hover:bg-${running ? "green" : "red"}-200\n          `}\n          onClick={toggleRunning}\n        >\n          {running ? "Running" : "Stopped"}\n        </button>\n\n        <button\n          className="flex-1 rounded bg-blue-100 hover:bg-blue-200"\n          onClick={() => update(16)}\n        >\n          Step\n        </button>\n      </div> \n      \n      <svg className="w-full" height={height}>\n        <defs>\n          <pattern id="platform" patternUnits="userSpaceOnUse" width={tileSize} height={tileSize}>\n            <image href={Tiles.ground.src} width={tileSize} height={tileSize} />\n          </pattern>\n        </defs>\n      \n        <rect transform="translate(0, 336)" width="2000" height={tileSize} fill="url(#platform)" />\n      \n        <image\n          transform={`\n            translate(100, ${ground - state.y})\n            translate(${-tileSize/2}, ${-tileSize})\n          `}\n          href={Tiles.character.src}\n          width={tileSize}\n          height={tileSize}\n          />\n      </svg>\n    </div>\n  )\n}'
                                                                                                                    }
                                                                                                                }
                                                                                                            }
                                                                                                        ]
                                                                                                    }
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 19,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "= $17",
                                                                                            "note": {
                                                                                                "type": "expr",
                                                                                                "code": " $17"
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 41,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "",
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "p",
                                                                                                "text": ""
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 34,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "",
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "p",
                                                                                                "text": ""
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 35,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "wide",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "---",
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "p",
                                                                                                "text": "---"
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 36,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "",
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "p",
                                                                                                "text": ""
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 20,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "",
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "p",
                                                                                                "text": ""
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 21,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "# Input",
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "h1",
                                                                                                "text": "Input"
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 22,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "We add some keyboard input handling and extend the character to be able to move left and right.",
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "p",
                                                                                                "text": "We add some keyboard input handling and extend the character to be able to move left and right."
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 15,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "wide",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "/Game",
                                                                                            "note": {
                                                                                                "type": "block",
                                                                                                "isInstantiated": true,
                                                                                                "code": "Game",
                                                                                                "state": {
                                                                                                    "init": "({\n  x: 100,\n  y: 400,\n  xSpeed: 0,\n  ySpeed: 0,\n})",
                                                                                                    "update": {
                                                                                                        "t": "resheet.sheet",
                                                                                                        "v": 2,
                                                                                                        "lines": [
                                                                                                            {
                                                                                                                "id": 0,
                                                                                                                "name": "",
                                                                                                                "visibility": "block",
                                                                                                                "width": "narrow",
                                                                                                                "state": {
                                                                                                                    "t": "resheet.note",
                                                                                                                    "v": 1,
                                                                                                                    "level": 0,
                                                                                                                    "input": "The current state:",
                                                                                                                    "note": {
                                                                                                                        "type": "text",
                                                                                                                        "tag": "p",
                                                                                                                        "text": "The current state:"
                                                                                                                    }
                                                                                                                }
                                                                                                            },
                                                                                                            {
                                                                                                                "id": 1,
                                                                                                                "name": "",
                                                                                                                "visibility": "block",
                                                                                                                "width": "narrow",
                                                                                                                "state": {
                                                                                                                    "t": "resheet.note",
                                                                                                                    "v": 1,
                                                                                                                    "level": 0,
                                                                                                                    "input": "= state",
                                                                                                                    "note": {
                                                                                                                        "type": "expr",
                                                                                                                        "code": " state"
                                                                                                                    }
                                                                                                                }
                                                                                                            },
                                                                                                            {
                                                                                                                "id": 2,
                                                                                                                "name": "",
                                                                                                                "visibility": "block",
                                                                                                                "width": "narrow",
                                                                                                                "state": {
                                                                                                                    "t": "resheet.note",
                                                                                                                    "v": 1,
                                                                                                                    "level": 0,
                                                                                                                    "input": "### Simulation",
                                                                                                                    "note": {
                                                                                                                        "type": "text",
                                                                                                                        "tag": "h3",
                                                                                                                        "text": "Simulation"
                                                                                                                    }
                                                                                                                }
                                                                                                            },
                                                                                                            {
                                                                                                                "id": 3,
                                                                                                                "name": "",
                                                                                                                "visibility": "block",
                                                                                                                "width": "narrow",
                                                                                                                "state": {
                                                                                                                    "t": "resheet.note",
                                                                                                                    "v": 1,
                                                                                                                    "level": 0,
                                                                                                                    "input": "Gravity means decelerating:",
                                                                                                                    "note": {
                                                                                                                        "type": "text",
                                                                                                                        "tag": "p",
                                                                                                                        "text": "Gravity means decelerating:"
                                                                                                                    }
                                                                                                                }
                                                                                                            },
                                                                                                            {
                                                                                                                "id": 4,
                                                                                                                "name": "gravity",
                                                                                                                "visibility": "block",
                                                                                                                "width": "narrow",
                                                                                                                "state": {
                                                                                                                    "t": "resheet.note",
                                                                                                                    "v": 1,
                                                                                                                    "level": 0,
                                                                                                                    "input": "= { ...state, ySpeed: state.ySpeed - 0.75 }",
                                                                                                                    "note": {
                                                                                                                        "type": "expr",
                                                                                                                        "code": " { ...state, ySpeed: state.ySpeed - 0.75 }"
                                                                                                                    }
                                                                                                                }
                                                                                                            },
                                                                                                            {
                                                                                                                "id": 5,
                                                                                                                "name": "",
                                                                                                                "visibility": "block",
                                                                                                                "width": "narrow",
                                                                                                                "state": {
                                                                                                                    "t": "resheet.note",
                                                                                                                    "v": 1,
                                                                                                                    "level": 0,
                                                                                                                    "input": "",
                                                                                                                    "note": {
                                                                                                                        "type": "text",
                                                                                                                        "tag": "p",
                                                                                                                        "text": ""
                                                                                                                    }
                                                                                                                }
                                                                                                            },
                                                                                                            {
                                                                                                                "id": 6,
                                                                                                                "name": "",
                                                                                                                "visibility": "block",
                                                                                                                "width": "narrow",
                                                                                                                "state": {
                                                                                                                    "t": "resheet.note",
                                                                                                                    "v": 1,
                                                                                                                    "level": 0,
                                                                                                                    "input": "Jumping means getting some upwards velocity:",
                                                                                                                    "note": {
                                                                                                                        "type": "text",
                                                                                                                        "tag": "p",
                                                                                                                        "text": "Jumping means getting some upwards velocity:"
                                                                                                                    }
                                                                                                                }
                                                                                                            },
                                                                                                            {
                                                                                                                "id": 7,
                                                                                                                "name": "jump",
                                                                                                                "visibility": "block",
                                                                                                                "width": "narrow",
                                                                                                                "state": {
                                                                                                                    "t": "resheet.note",
                                                                                                                    "v": 1,
                                                                                                                    "level": 0,
                                                                                                                    "input": "= { ...state, ySpeed: 12 }",
                                                                                                                    "note": {
                                                                                                                        "type": "expr",
                                                                                                                        "code": " { ...state, ySpeed: 12 }"
                                                                                                                    }
                                                                                                                }
                                                                                                            },
                                                                                                            {
                                                                                                                "id": 8,
                                                                                                                "name": "",
                                                                                                                "visibility": "block",
                                                                                                                "width": "narrow",
                                                                                                                "state": {
                                                                                                                    "t": "resheet.note",
                                                                                                                    "v": 1,
                                                                                                                    "level": 0,
                                                                                                                    "input": "",
                                                                                                                    "note": {
                                                                                                                        "type": "text",
                                                                                                                        "tag": "p",
                                                                                                                        "text": ""
                                                                                                                    }
                                                                                                                }
                                                                                                            },
                                                                                                            {
                                                                                                                "id": 9,
                                                                                                                "name": "",
                                                                                                                "visibility": "block",
                                                                                                                "width": "narrow",
                                                                                                                "state": {
                                                                                                                    "t": "resheet.note",
                                                                                                                    "v": 1,
                                                                                                                    "level": 0,
                                                                                                                    "input": "Jump if on ground or otherwise let gravity pull us down:",
                                                                                                                    "note": {
                                                                                                                        "type": "text",
                                                                                                                        "tag": "p",
                                                                                                                        "text": "Jump if on ground or otherwise let gravity pull us down:"
                                                                                                                    }
                                                                                                                }
                                                                                                            },
                                                                                                            {
                                                                                                                "id": 10,
                                                                                                                "name": "forces",
                                                                                                                "visibility": "block",
                                                                                                                "width": "narrow",
                                                                                                                "state": {
                                                                                                                    "t": "resheet.note",
                                                                                                                    "v": 1,
                                                                                                                    "level": 0,
                                                                                                                    "input": "= state.y <= 0 ? jump : gravity",
                                                                                                                    "note": {
                                                                                                                        "type": "expr",
                                                                                                                        "code": " state.y <= 0 ? jump : gravity"
                                                                                                                    }
                                                                                                                }
                                                                                                            },
                                                                                                            {
                                                                                                                "id": 11,
                                                                                                                "name": "",
                                                                                                                "visibility": "block",
                                                                                                                "width": "narrow",
                                                                                                                "state": {
                                                                                                                    "t": "resheet.note",
                                                                                                                    "v": 1,
                                                                                                                    "level": 0,
                                                                                                                    "input": "",
                                                                                                                    "note": {
                                                                                                                        "type": "text",
                                                                                                                        "tag": "p",
                                                                                                                        "text": ""
                                                                                                                    }
                                                                                                                }
                                                                                                            },
                                                                                                            {
                                                                                                                "id": 12,
                                                                                                                "name": "",
                                                                                                                "visibility": "block",
                                                                                                                "width": "narrow",
                                                                                                                "state": {
                                                                                                                    "t": "resheet.note",
                                                                                                                    "v": 1,
                                                                                                                    "level": 0,
                                                                                                                    "input": "Move according to speed:",
                                                                                                                    "note": {
                                                                                                                        "type": "text",
                                                                                                                        "tag": "p",
                                                                                                                        "text": "Move according to speed:"
                                                                                                                    }
                                                                                                                }
                                                                                                            },
                                                                                                            {
                                                                                                                "id": 13,
                                                                                                                "name": "simulation",
                                                                                                                "visibility": "block",
                                                                                                                "width": "narrow",
                                                                                                                "state": {
                                                                                                                    "t": "resheet.note",
                                                                                                                    "v": 1,
                                                                                                                    "level": 0,
                                                                                                                    "input": "= {\n  ...forces,\n  x: forces.x + forces.xSpeed,\n  y: forces.y + forces.ySpeed,\n}",
                                                                                                                    "note": {
                                                                                                                        "type": "expr",
                                                                                                                        "code": " {\n  ...forces,\n  x: forces.x + forces.xSpeed,\n  y: forces.y + forces.ySpeed,\n}"
                                                                                                                    }
                                                                                                                }
                                                                                                            },
                                                                                                            {
                                                                                                                "id": 14,
                                                                                                                "name": "",
                                                                                                                "visibility": "block",
                                                                                                                "width": "narrow",
                                                                                                                "state": {
                                                                                                                    "t": "resheet.note",
                                                                                                                    "v": 1,
                                                                                                                    "level": 0,
                                                                                                                    "input": "",
                                                                                                                    "note": {
                                                                                                                        "type": "text",
                                                                                                                        "tag": "p",
                                                                                                                        "text": ""
                                                                                                                    }
                                                                                                                }
                                                                                                            },
                                                                                                            {
                                                                                                                "id": 15,
                                                                                                                "name": "",
                                                                                                                "visibility": "block",
                                                                                                                "width": "narrow",
                                                                                                                "state": {
                                                                                                                    "t": "resheet.note",
                                                                                                                    "v": 1,
                                                                                                                    "level": 0,
                                                                                                                    "input": "### React to Input",
                                                                                                                    "note": {
                                                                                                                        "type": "text",
                                                                                                                        "tag": "h3",
                                                                                                                        "text": "React to Input"
                                                                                                                    }
                                                                                                                }
                                                                                                            },
                                                                                                            {
                                                                                                                "id": 16,
                                                                                                                "name": "",
                                                                                                                "visibility": "block",
                                                                                                                "width": "narrow",
                                                                                                                "state": {
                                                                                                                    "t": "resheet.note",
                                                                                                                    "v": 1,
                                                                                                                    "level": 0,
                                                                                                                    "input": "= input",
                                                                                                                    "note": {
                                                                                                                        "type": "expr",
                                                                                                                        "code": " input"
                                                                                                                    }
                                                                                                                }
                                                                                                            },
                                                                                                            {
                                                                                                                "id": 17,
                                                                                                                "name": "reaction",
                                                                                                                "visibility": "block",
                                                                                                                "width": "narrow",
                                                                                                                "state": {
                                                                                                                    "t": "resheet.note",
                                                                                                                    "v": 1,
                                                                                                                    "level": 0,
                                                                                                                    "input": "/Code",
                                                                                                                    "note": {
                                                                                                                        "type": "block",
                                                                                                                        "isInstantiated": true,
                                                                                                                        "code": "Code",
                                                                                                                        "state": "if (!input) return;\n\nconst xSpeed = (\n  input.type === 'simulate' ?\n    state.xSpeed\n  : input.type === 'keyup' ? // This is not 100% correct, but let's keep it simple\n    0\n  : input.key === 'ArrowLeft' ?\n    -3\n  : input.key === 'ArrowRight' ?\n    3\n  :\n    state.xSpeed\n)\n\nreturn {\n  ...state,\n  xSpeed,\n}"
                                                                                                                    }
                                                                                                                }
                                                                                                            },
                                                                                                            {
                                                                                                                "id": 18,
                                                                                                                "name": "",
                                                                                                                "visibility": "block",
                                                                                                                "width": "narrow",
                                                                                                                "state": {
                                                                                                                    "t": "resheet.note",
                                                                                                                    "v": 1,
                                                                                                                    "level": 0,
                                                                                                                    "input": "",
                                                                                                                    "note": {
                                                                                                                        "type": "text",
                                                                                                                        "tag": "p",
                                                                                                                        "text": ""
                                                                                                                    }
                                                                                                                }
                                                                                                            },
                                                                                                            {
                                                                                                                "id": 19,
                                                                                                                "name": "",
                                                                                                                "visibility": "block",
                                                                                                                "width": "narrow",
                                                                                                                "state": {
                                                                                                                    "t": "resheet.note",
                                                                                                                    "v": 1,
                                                                                                                    "level": 0,
                                                                                                                    "input": "### Final State",
                                                                                                                    "note": {
                                                                                                                        "type": "text",
                                                                                                                        "tag": "h3",
                                                                                                                        "text": "Final State"
                                                                                                                    }
                                                                                                                }
                                                                                                            },
                                                                                                            {
                                                                                                                "id": 20,
                                                                                                                "name": "",
                                                                                                                "visibility": "block",
                                                                                                                "width": "narrow",
                                                                                                                "state": {
                                                                                                                    "t": "resheet.note",
                                                                                                                    "v": 1,
                                                                                                                    "level": 0,
                                                                                                                    "input": "Decide which state to use based on the input:",
                                                                                                                    "note": {
                                                                                                                        "type": "text",
                                                                                                                        "tag": "p",
                                                                                                                        "text": "Decide which state to use based on the input:"
                                                                                                                    }
                                                                                                                }
                                                                                                            },
                                                                                                            {
                                                                                                                "id": 21,
                                                                                                                "name": "finalState",
                                                                                                                "visibility": "block",
                                                                                                                "width": "narrow",
                                                                                                                "state": {
                                                                                                                    "t": "resheet.note",
                                                                                                                    "v": 1,
                                                                                                                    "level": 0,
                                                                                                                    "input": "= input && input.type !== 'simulate' ? reaction : simulation",
                                                                                                                    "note": {
                                                                                                                        "type": "expr",
                                                                                                                        "code": " input && input.type !== 'simulate' ? reaction : simulation"
                                                                                                                    }
                                                                                                                }
                                                                                                            }
                                                                                                        ]
                                                                                                    },
                                                                                                    "render": {
                                                                                                        "t": "resheet.sheet",
                                                                                                        "v": 2,
                                                                                                        "lines": [
                                                                                                            {
                                                                                                                "id": 0,
                                                                                                                "name": "",
                                                                                                                "visibility": "block",
                                                                                                                "width": "full",
                                                                                                                "state": {
                                                                                                                    "t": "resheet.note",
                                                                                                                    "v": 1,
                                                                                                                    "level": 0,
                                                                                                                    "input": "/Code",
                                                                                                                    "note": {
                                                                                                                        "type": "block",
                                                                                                                        "isInstantiated": true,
                                                                                                                        "code": "Code",
                                                                                                                        "state": 'const height = 400;\nconst tileSize = 64;\nconst ground = height - tileSize;\n\nfunction GameView({ state, update }) {\n  const { running, toggleRunning } = useAnimation(dt => update({ type: \'simulate\', dt }))\n  \n  function react(ev) {\n    ev.preventDefault()\n    ev.stopPropagation()\n    \n    update(ev) // runs an update with `input` set to `ev`\n  }\n\n  return (\n    <div>\n      <div className="w-full flex flex-row space-x-2">\n        <button\n          className={`\n            flex-1 rounded\n            bg-${running ? "green" : "red"}-100\n            hover:bg-${running ? "green" : "red"}-200\n          `}\n          onClick={toggleRunning}\n        >\n          {running ? "Running" : "Stopped"}\n        </button>\n\n        <button\n          className="flex-1 rounded bg-blue-100 hover:bg-blue-200"\n          onClick={() => update({ type: \'simulate\', dt: 16 })}\n        >\n          Step\n        </button>\n      </div> \n\n      <svg\n        tabIndex={-1}\n        className="w-full"\n        height={height}\n        onKeyDown={react}\n        onKeyUp={react}\n      >\n        <defs>\n          <pattern id="platform" patternUnits="userSpaceOnUse" width={tileSize} height={tileSize}>\n            <image href={Tiles.ground.src} width={tileSize} height={tileSize} />\n          </pattern>\n        </defs>\n      \n        <rect transform="translate(0, 336)" width="2000" height={tileSize} fill="url(#platform)" />\n      \n        <image\n          transform={`\n            translate(${state.x}, ${ground - state.y})\n            scale(${state.xSpeed < 0 ? 1 : -1}, 1)\n            translate(${-tileSize/2}, ${-tileSize})\n          `}\n          href={Tiles.character.src}\n          width={tileSize}\n          height={tileSize}\n          />\n      </svg>\n    </div>\n  )\n}'
                                                                                                                    }
                                                                                                                }
                                                                                                            }
                                                                                                        ]
                                                                                                    }
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 24,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "",
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "p",
                                                                                                "text": ""
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 37,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "",
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "p",
                                                                                                "text": ""
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 38,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "",
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "p",
                                                                                                "text": ""
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 42,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "wide",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "---",
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "p",
                                                                                                "text": "---"
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 25,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "",
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "p",
                                                                                                "text": ""
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 39,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "",
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "p",
                                                                                                "text": ""
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 26,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "## Real Game",
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "h2",
                                                                                                "text": "Real Game"
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 27,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": 'Let\'s make it a "real" game by adding some enemies, lives, mobile input, framerate handling and canvas rendering. (Still missing are more visual effects and sounds)',
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "p",
                                                                                                "text": 'Let\'s make it a "real" game by adding some enemies, lives, mobile input, framerate handling and canvas rendering. (Still missing are more visual effects and sounds)'
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 43,
                                                                                        "name": "realGame",
                                                                                        "visibility": "block",
                                                                                        "width": "wide",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "/Debug.Inspect(Game)",
                                                                                            "note": {
                                                                                                "type": "block",
                                                                                                "isInstantiated": true,
                                                                                                "code": "Debug.Inspect(Game)",
                                                                                                "state": {
                                                                                                    "init": "({\n  score: 0,\n  lives: 10,\n  character: {\n    x: 100,\n    y: 400,\n    xSpeed: 0,\n    ySpeed: 0,\n  },\n  enemies: [],\n})",
                                                                                                    "update": {
                                                                                                        "t": "resheet.sheet",
                                                                                                        "v": 2,
                                                                                                        "lines": [
                                                                                                            {
                                                                                                                "id": 1,
                                                                                                                "name": "",
                                                                                                                "visibility": "block",
                                                                                                                "width": "narrow",
                                                                                                                "state": {
                                                                                                                    "t": "resheet.note",
                                                                                                                    "v": 1,
                                                                                                                    "level": 0,
                                                                                                                    "input": "The current state:",
                                                                                                                    "note": {
                                                                                                                        "type": "text",
                                                                                                                        "tag": "p",
                                                                                                                        "text": "The current state:"
                                                                                                                    }
                                                                                                                }
                                                                                                            },
                                                                                                            {
                                                                                                                "id": 2,
                                                                                                                "name": "",
                                                                                                                "visibility": "block",
                                                                                                                "width": "narrow",
                                                                                                                "state": {
                                                                                                                    "t": "resheet.note",
                                                                                                                    "v": 1,
                                                                                                                    "level": 0,
                                                                                                                    "input": "= state",
                                                                                                                    "note": {
                                                                                                                        "type": "expr",
                                                                                                                        "code": " state"
                                                                                                                    }
                                                                                                                }
                                                                                                            },
                                                                                                            {
                                                                                                                "id": 58,
                                                                                                                "name": "",
                                                                                                                "visibility": "block",
                                                                                                                "width": "narrow",
                                                                                                                "state": {
                                                                                                                    "t": "resheet.note",
                                                                                                                    "v": 1,
                                                                                                                    "level": 0,
                                                                                                                    "input": "The input:",
                                                                                                                    "note": {
                                                                                                                        "type": "text",
                                                                                                                        "tag": "p",
                                                                                                                        "text": "The input:"
                                                                                                                    }
                                                                                                                }
                                                                                                            },
                                                                                                            {
                                                                                                                "id": 59,
                                                                                                                "name": "",
                                                                                                                "visibility": "block",
                                                                                                                "width": "narrow",
                                                                                                                "state": {
                                                                                                                    "t": "resheet.note",
                                                                                                                    "v": 1,
                                                                                                                    "level": 0,
                                                                                                                    "input": "= input",
                                                                                                                    "note": {
                                                                                                                        "type": "expr",
                                                                                                                        "code": " input"
                                                                                                                    }
                                                                                                                }
                                                                                                            },
                                                                                                            {
                                                                                                                "id": 61,
                                                                                                                "name": "",
                                                                                                                "visibility": "block",
                                                                                                                "width": "narrow",
                                                                                                                "state": {
                                                                                                                    "t": "resheet.note",
                                                                                                                    "v": 1,
                                                                                                                    "level": 0,
                                                                                                                    "input": "",
                                                                                                                    "note": {
                                                                                                                        "type": "text",
                                                                                                                        "tag": "p",
                                                                                                                        "text": ""
                                                                                                                    }
                                                                                                                }
                                                                                                            },
                                                                                                            {
                                                                                                                "id": 60,
                                                                                                                "name": "",
                                                                                                                "visibility": "block",
                                                                                                                "width": "narrow",
                                                                                                                "state": {
                                                                                                                    "t": "resheet.note",
                                                                                                                    "v": 1,
                                                                                                                    "level": 0,
                                                                                                                    "input": "Respect the framerate:",
                                                                                                                    "note": {
                                                                                                                        "type": "text",
                                                                                                                        "tag": "p",
                                                                                                                        "text": "Respect the framerate:"
                                                                                                                    }
                                                                                                                }
                                                                                                            },
                                                                                                            {
                                                                                                                "id": 62,
                                                                                                                "name": "dt",
                                                                                                                "visibility": "block",
                                                                                                                "width": "narrow",
                                                                                                                "state": {
                                                                                                                    "t": "resheet.note",
                                                                                                                    "v": 1,
                                                                                                                    "level": 0,
                                                                                                                    "input": "= input?.dt ?? 16",
                                                                                                                    "note": {
                                                                                                                        "type": "expr",
                                                                                                                        "code": " input?.dt ?? 16"
                                                                                                                    }
                                                                                                                }
                                                                                                            },
                                                                                                            {
                                                                                                                "id": 64,
                                                                                                                "name": "",
                                                                                                                "visibility": "block",
                                                                                                                "width": "narrow",
                                                                                                                "state": {
                                                                                                                    "t": "resheet.note",
                                                                                                                    "v": 1,
                                                                                                                    "level": 0,
                                                                                                                    "input": "Calculate in px/s:",
                                                                                                                    "note": {
                                                                                                                        "type": "text",
                                                                                                                        "tag": "p",
                                                                                                                        "text": "Calculate in px/s:"
                                                                                                                    }
                                                                                                                }
                                                                                                            },
                                                                                                            {
                                                                                                                "id": 63,
                                                                                                                "name": "factor",
                                                                                                                "visibility": "block",
                                                                                                                "width": "narrow",
                                                                                                                "state": {
                                                                                                                    "t": "resheet.note",
                                                                                                                    "v": 1,
                                                                                                                    "level": 0,
                                                                                                                    "input": "= dt / 1000",
                                                                                                                    "note": {
                                                                                                                        "type": "expr",
                                                                                                                        "code": " dt / 1000"
                                                                                                                    }
                                                                                                                }
                                                                                                            },
                                                                                                            {
                                                                                                                "id": 3,
                                                                                                                "name": "",
                                                                                                                "visibility": "block",
                                                                                                                "width": "narrow",
                                                                                                                "state": {
                                                                                                                    "t": "resheet.note",
                                                                                                                    "v": 1,
                                                                                                                    "level": 0,
                                                                                                                    "input": "### Simulate Character",
                                                                                                                    "note": {
                                                                                                                        "type": "text",
                                                                                                                        "tag": "h3",
                                                                                                                        "text": "Simulate Character"
                                                                                                                    }
                                                                                                                }
                                                                                                            },
                                                                                                            {
                                                                                                                "id": 4,
                                                                                                                "name": "character",
                                                                                                                "visibility": "block",
                                                                                                                "width": "narrow",
                                                                                                                "state": {
                                                                                                                    "t": "resheet.note",
                                                                                                                    "v": 1,
                                                                                                                    "level": 0,
                                                                                                                    "input": "= state.character",
                                                                                                                    "note": {
                                                                                                                        "type": "expr",
                                                                                                                        "code": " state.character"
                                                                                                                    }
                                                                                                                }
                                                                                                            },
                                                                                                            {
                                                                                                                "id": 5,
                                                                                                                "name": "",
                                                                                                                "visibility": "block",
                                                                                                                "width": "narrow",
                                                                                                                "state": {
                                                                                                                    "t": "resheet.note",
                                                                                                                    "v": 1,
                                                                                                                    "level": 0,
                                                                                                                    "input": "Gravity means decelerating:",
                                                                                                                    "note": {
                                                                                                                        "type": "text",
                                                                                                                        "tag": "p",
                                                                                                                        "text": "Gravity means decelerating:"
                                                                                                                    }
                                                                                                                }
                                                                                                            },
                                                                                                            {
                                                                                                                "id": 6,
                                                                                                                "name": "gravity",
                                                                                                                "visibility": "block",
                                                                                                                "width": "narrow",
                                                                                                                "state": {
                                                                                                                    "t": "resheet.note",
                                                                                                                    "v": 1,
                                                                                                                    "level": 0,
                                                                                                                    "input": "= { ...character, ySpeed: character.ySpeed - 40 * factor }",
                                                                                                                    "note": {
                                                                                                                        "type": "expr",
                                                                                                                        "code": " { ...character, ySpeed: character.ySpeed - 40 * factor }"
                                                                                                                    }
                                                                                                                }
                                                                                                            },
                                                                                                            {
                                                                                                                "id": 7,
                                                                                                                "name": "",
                                                                                                                "visibility": "block",
                                                                                                                "width": "narrow",
                                                                                                                "state": {
                                                                                                                    "t": "resheet.note",
                                                                                                                    "v": 1,
                                                                                                                    "level": 0,
                                                                                                                    "input": "",
                                                                                                                    "note": {
                                                                                                                        "type": "text",
                                                                                                                        "tag": "p",
                                                                                                                        "text": ""
                                                                                                                    }
                                                                                                                }
                                                                                                            },
                                                                                                            {
                                                                                                                "id": 8,
                                                                                                                "name": "",
                                                                                                                "visibility": "block",
                                                                                                                "width": "narrow",
                                                                                                                "state": {
                                                                                                                    "t": "resheet.note",
                                                                                                                    "v": 1,
                                                                                                                    "level": 0,
                                                                                                                    "input": "Jumping means getting some upwards velocity:",
                                                                                                                    "note": {
                                                                                                                        "type": "text",
                                                                                                                        "tag": "p",
                                                                                                                        "text": "Jumping means getting some upwards velocity:"
                                                                                                                    }
                                                                                                                }
                                                                                                            },
                                                                                                            {
                                                                                                                "id": 9,
                                                                                                                "name": "jump",
                                                                                                                "visibility": "block",
                                                                                                                "width": "narrow",
                                                                                                                "state": {
                                                                                                                    "t": "resheet.note",
                                                                                                                    "v": 1,
                                                                                                                    "level": 0,
                                                                                                                    "input": "= { ...character, ySpeed: 14 }",
                                                                                                                    "note": {
                                                                                                                        "type": "expr",
                                                                                                                        "code": " { ...character, ySpeed: 14 }"
                                                                                                                    }
                                                                                                                }
                                                                                                            },
                                                                                                            {
                                                                                                                "id": 10,
                                                                                                                "name": "",
                                                                                                                "visibility": "block",
                                                                                                                "width": "narrow",
                                                                                                                "state": {
                                                                                                                    "t": "resheet.note",
                                                                                                                    "v": 1,
                                                                                                                    "level": 0,
                                                                                                                    "input": "",
                                                                                                                    "note": {
                                                                                                                        "type": "text",
                                                                                                                        "tag": "p",
                                                                                                                        "text": ""
                                                                                                                    }
                                                                                                                }
                                                                                                            },
                                                                                                            {
                                                                                                                "id": 11,
                                                                                                                "name": "",
                                                                                                                "visibility": "block",
                                                                                                                "width": "narrow",
                                                                                                                "state": {
                                                                                                                    "t": "resheet.note",
                                                                                                                    "v": 1,
                                                                                                                    "level": 0,
                                                                                                                    "input": "Jump if on ground or otherwise let gravity pull us down:",
                                                                                                                    "note": {
                                                                                                                        "type": "text",
                                                                                                                        "tag": "p",
                                                                                                                        "text": "Jump if on ground or otherwise let gravity pull us down:"
                                                                                                                    }
                                                                                                                }
                                                                                                            },
                                                                                                            {
                                                                                                                "id": 12,
                                                                                                                "name": "forces",
                                                                                                                "visibility": "block",
                                                                                                                "width": "narrow",
                                                                                                                "state": {
                                                                                                                    "t": "resheet.note",
                                                                                                                    "v": 1,
                                                                                                                    "level": 0,
                                                                                                                    "input": "= character.y <= 0 ? jump : gravity",
                                                                                                                    "note": {
                                                                                                                        "type": "expr",
                                                                                                                        "code": " character.y <= 0 ? jump : gravity"
                                                                                                                    }
                                                                                                                }
                                                                                                            },
                                                                                                            {
                                                                                                                "id": 13,
                                                                                                                "name": "",
                                                                                                                "visibility": "block",
                                                                                                                "width": "narrow",
                                                                                                                "state": {
                                                                                                                    "t": "resheet.note",
                                                                                                                    "v": 1,
                                                                                                                    "level": 0,
                                                                                                                    "input": "",
                                                                                                                    "note": {
                                                                                                                        "type": "text",
                                                                                                                        "tag": "p",
                                                                                                                        "text": ""
                                                                                                                    }
                                                                                                                }
                                                                                                            },
                                                                                                            {
                                                                                                                "id": 14,
                                                                                                                "name": "",
                                                                                                                "visibility": "block",
                                                                                                                "width": "narrow",
                                                                                                                "state": {
                                                                                                                    "t": "resheet.note",
                                                                                                                    "v": 1,
                                                                                                                    "level": 0,
                                                                                                                    "input": "Move according to speed:",
                                                                                                                    "note": {
                                                                                                                        "type": "text",
                                                                                                                        "tag": "p",
                                                                                                                        "text": "Move according to speed:"
                                                                                                                    }
                                                                                                                }
                                                                                                            },
                                                                                                            {
                                                                                                                "id": 15,
                                                                                                                "name": "simulatedCharacter",
                                                                                                                "visibility": "block",
                                                                                                                "width": "narrow",
                                                                                                                "state": {
                                                                                                                    "t": "resheet.note",
                                                                                                                    "v": 1,
                                                                                                                    "level": 0,
                                                                                                                    "input": "= {\n  ...forces,\n  x: forces.x + forces.xSpeed,\n  y: forces.y + forces.ySpeed,\n}",
                                                                                                                    "note": {
                                                                                                                        "type": "expr",
                                                                                                                        "code": " {\n  ...forces,\n  x: forces.x + forces.xSpeed,\n  y: forces.y + forces.ySpeed,\n}"
                                                                                                                    }
                                                                                                                }
                                                                                                            },
                                                                                                            {
                                                                                                                "id": 16,
                                                                                                                "name": "",
                                                                                                                "visibility": "block",
                                                                                                                "width": "narrow",
                                                                                                                "state": {
                                                                                                                    "t": "resheet.note",
                                                                                                                    "v": 1,
                                                                                                                    "level": 0,
                                                                                                                    "input": "",
                                                                                                                    "note": {
                                                                                                                        "type": "text",
                                                                                                                        "tag": "p",
                                                                                                                        "text": ""
                                                                                                                    }
                                                                                                                }
                                                                                                            },
                                                                                                            {
                                                                                                                "id": 17,
                                                                                                                "name": "",
                                                                                                                "visibility": "block",
                                                                                                                "width": "narrow",
                                                                                                                "state": {
                                                                                                                    "t": "resheet.note",
                                                                                                                    "v": 1,
                                                                                                                    "level": 0,
                                                                                                                    "input": "### Simulate Enemies",
                                                                                                                    "note": {
                                                                                                                        "type": "text",
                                                                                                                        "tag": "h3",
                                                                                                                        "text": "Simulate Enemies"
                                                                                                                    }
                                                                                                                }
                                                                                                            },
                                                                                                            {
                                                                                                                "id": 18,
                                                                                                                "name": "enemies",
                                                                                                                "visibility": "block",
                                                                                                                "width": "narrow",
                                                                                                                "state": {
                                                                                                                    "t": "resheet.note",
                                                                                                                    "v": 1,
                                                                                                                    "level": 0,
                                                                                                                    "input": "= state.enemies",
                                                                                                                    "note": {
                                                                                                                        "type": "expr",
                                                                                                                        "code": " state.enemies"
                                                                                                                    }
                                                                                                                }
                                                                                                            },
                                                                                                            {
                                                                                                                "id": 19,
                                                                                                                "name": "enemySize",
                                                                                                                "visibility": "block",
                                                                                                                "width": "narrow",
                                                                                                                "state": {
                                                                                                                    "t": "resheet.note",
                                                                                                                    "v": 1,
                                                                                                                    "level": 0,
                                                                                                                    "input": "= 32",
                                                                                                                    "note": {
                                                                                                                        "type": "expr",
                                                                                                                        "code": " 32"
                                                                                                                    }
                                                                                                                }
                                                                                                            },
                                                                                                            {
                                                                                                                "id": 20,
                                                                                                                "name": "",
                                                                                                                "visibility": "block",
                                                                                                                "width": "narrow",
                                                                                                                "state": {
                                                                                                                    "t": "resheet.note",
                                                                                                                    "v": 1,
                                                                                                                    "level": 0,
                                                                                                                    "input": "",
                                                                                                                    "note": {
                                                                                                                        "type": "text",
                                                                                                                        "tag": "p",
                                                                                                                        "text": ""
                                                                                                                    }
                                                                                                                }
                                                                                                            },
                                                                                                            {
                                                                                                                "id": 21,
                                                                                                                "name": "",
                                                                                                                "visibility": "block",
                                                                                                                "width": "narrow",
                                                                                                                "state": {
                                                                                                                    "t": "resheet.note",
                                                                                                                    "v": 1,
                                                                                                                    "level": 0,
                                                                                                                    "input": "Move enemies:",
                                                                                                                    "note": {
                                                                                                                        "type": "text",
                                                                                                                        "tag": "p",
                                                                                                                        "text": "Move enemies:"
                                                                                                                    }
                                                                                                                }
                                                                                                            },
                                                                                                            {
                                                                                                                "id": 22,
                                                                                                                "name": "movedEnemies",
                                                                                                                "visibility": "block",
                                                                                                                "width": "narrow",
                                                                                                                "state": {
                                                                                                                    "t": "resheet.note",
                                                                                                                    "v": 1,
                                                                                                                    "level": 0,
                                                                                                                    "input": "= enemies.map(enemyPosition => enemyPosition - 160 * factor)",
                                                                                                                    "note": {
                                                                                                                        "type": "expr",
                                                                                                                        "code": " enemies.map(enemyPosition => enemyPosition - 160 * factor)"
                                                                                                                    }
                                                                                                                }
                                                                                                            },
                                                                                                            {
                                                                                                                "id": 23,
                                                                                                                "name": "",
                                                                                                                "visibility": "block",
                                                                                                                "width": "narrow",
                                                                                                                "state": {
                                                                                                                    "t": "resheet.note",
                                                                                                                    "v": 1,
                                                                                                                    "level": 0,
                                                                                                                    "input": "",
                                                                                                                    "note": {
                                                                                                                        "type": "text",
                                                                                                                        "tag": "p",
                                                                                                                        "text": ""
                                                                                                                    }
                                                                                                                }
                                                                                                            },
                                                                                                            {
                                                                                                                "id": 24,
                                                                                                                "name": "",
                                                                                                                "visibility": "block",
                                                                                                                "width": "narrow",
                                                                                                                "state": {
                                                                                                                    "t": "resheet.note",
                                                                                                                    "v": 1,
                                                                                                                    "level": 0,
                                                                                                                    "input": "Randomly add enemies:",
                                                                                                                    "note": {
                                                                                                                        "type": "text",
                                                                                                                        "tag": "p",
                                                                                                                        "text": "Randomly add enemies:"
                                                                                                                    }
                                                                                                                }
                                                                                                            },
                                                                                                            {
                                                                                                                "id": 25,
                                                                                                                "name": "addedEnemies",
                                                                                                                "visibility": "block",
                                                                                                                "width": "narrow",
                                                                                                                "state": {
                                                                                                                    "t": "resheet.note",
                                                                                                                    "v": 1,
                                                                                                                    "level": 0,
                                                                                                                    "input": "= [ ...movedEnemies, ...(Math.random() < 0.6 * factor ? [1300] : []) ]",
                                                                                                                    "note": {
                                                                                                                        "type": "expr",
                                                                                                                        "code": " [ ...movedEnemies, ...(Math.random() < 0.6 * factor ? [1300] : []) ]"
                                                                                                                    }
                                                                                                                }
                                                                                                            },
                                                                                                            {
                                                                                                                "id": 26,
                                                                                                                "name": "",
                                                                                                                "visibility": "block",
                                                                                                                "width": "narrow",
                                                                                                                "state": {
                                                                                                                    "t": "resheet.note",
                                                                                                                    "v": 1,
                                                                                                                    "level": 0,
                                                                                                                    "input": "",
                                                                                                                    "note": {
                                                                                                                        "type": "text",
                                                                                                                        "tag": "p",
                                                                                                                        "text": ""
                                                                                                                    }
                                                                                                                }
                                                                                                            },
                                                                                                            {
                                                                                                                "id": 27,
                                                                                                                "name": "",
                                                                                                                "visibility": "block",
                                                                                                                "width": "narrow",
                                                                                                                "state": {
                                                                                                                    "t": "resheet.note",
                                                                                                                    "v": 1,
                                                                                                                    "level": 0,
                                                                                                                    "input": "Filter enemies that have passed:",
                                                                                                                    "note": {
                                                                                                                        "type": "text",
                                                                                                                        "tag": "p",
                                                                                                                        "text": "Filter enemies that have passed:"
                                                                                                                    }
                                                                                                                }
                                                                                                            },
                                                                                                            {
                                                                                                                "id": 28,
                                                                                                                "name": "passedAndLeftEnemies",
                                                                                                                "visibility": "block",
                                                                                                                "width": "narrow",
                                                                                                                "state": {
                                                                                                                    "t": "resheet.note",
                                                                                                                    "v": 1,
                                                                                                                    "level": 0,
                                                                                                                    "input": "= lodash.partition(addedEnemies, enemyPos => enemyPos < -enemySize)",
                                                                                                                    "note": {
                                                                                                                        "type": "expr",
                                                                                                                        "code": " lodash.partition(addedEnemies, enemyPos => enemyPos < -enemySize)"
                                                                                                                    }
                                                                                                                }
                                                                                                            },
                                                                                                            {
                                                                                                                "id": 29,
                                                                                                                "name": "passedEnemies",
                                                                                                                "visibility": "block",
                                                                                                                "width": "narrow",
                                                                                                                "state": {
                                                                                                                    "t": "resheet.note",
                                                                                                                    "v": 1,
                                                                                                                    "level": 0,
                                                                                                                    "input": "= passedAndLeftEnemies[0]",
                                                                                                                    "note": {
                                                                                                                        "type": "expr",
                                                                                                                        "code": " passedAndLeftEnemies[0]"
                                                                                                                    }
                                                                                                                }
                                                                                                            },
                                                                                                            {
                                                                                                                "id": 30,
                                                                                                                "name": "leftEnemies",
                                                                                                                "visibility": "block",
                                                                                                                "width": "narrow",
                                                                                                                "state": {
                                                                                                                    "t": "resheet.note",
                                                                                                                    "v": 1,
                                                                                                                    "level": 0,
                                                                                                                    "input": "= passedAndLeftEnemies[1]",
                                                                                                                    "note": {
                                                                                                                        "type": "expr",
                                                                                                                        "code": " passedAndLeftEnemies[1]"
                                                                                                                    }
                                                                                                                }
                                                                                                            },
                                                                                                            {
                                                                                                                "id": 31,
                                                                                                                "name": "",
                                                                                                                "visibility": "block",
                                                                                                                "width": "narrow",
                                                                                                                "state": {
                                                                                                                    "t": "resheet.note",
                                                                                                                    "v": 1,
                                                                                                                    "level": 0,
                                                                                                                    "input": "",
                                                                                                                    "note": {
                                                                                                                        "type": "text",
                                                                                                                        "tag": "p",
                                                                                                                        "text": ""
                                                                                                                    }
                                                                                                                }
                                                                                                            },
                                                                                                            {
                                                                                                                "id": 32,
                                                                                                                "name": "",
                                                                                                                "visibility": "block",
                                                                                                                "width": "narrow",
                                                                                                                "state": {
                                                                                                                    "t": "resheet.note",
                                                                                                                    "v": 1,
                                                                                                                    "level": 0,
                                                                                                                    "input": "### Lives, Collisions and Score ",
                                                                                                                    "note": {
                                                                                                                        "type": "text",
                                                                                                                        "tag": "h3",
                                                                                                                        "text": "Lives, Collisions and Score "
                                                                                                                    }
                                                                                                                }
                                                                                                            },
                                                                                                            {
                                                                                                                "id": 33,
                                                                                                                "name": "",
                                                                                                                "visibility": "block",
                                                                                                                "width": "narrow",
                                                                                                                "state": {
                                                                                                                    "t": "resheet.note",
                                                                                                                    "v": 1,
                                                                                                                    "level": 0,
                                                                                                                    "input": "Add passed enemies to score:",
                                                                                                                    "note": {
                                                                                                                        "type": "text",
                                                                                                                        "tag": "p",
                                                                                                                        "text": "Add passed enemies to score:"
                                                                                                                    }
                                                                                                                }
                                                                                                            },
                                                                                                            {
                                                                                                                "id": 34,
                                                                                                                "name": "score",
                                                                                                                "visibility": "block",
                                                                                                                "width": "narrow",
                                                                                                                "state": {
                                                                                                                    "t": "resheet.note",
                                                                                                                    "v": 1,
                                                                                                                    "level": 0,
                                                                                                                    "input": "= state.score + passedEnemies.length",
                                                                                                                    "note": {
                                                                                                                        "type": "expr",
                                                                                                                        "code": " state.score + passedEnemies.length"
                                                                                                                    }
                                                                                                                }
                                                                                                            },
                                                                                                            {
                                                                                                                "id": 35,
                                                                                                                "name": "",
                                                                                                                "visibility": "block",
                                                                                                                "width": "narrow",
                                                                                                                "state": {
                                                                                                                    "t": "resheet.note",
                                                                                                                    "v": 1,
                                                                                                                    "level": 0,
                                                                                                                    "input": "",
                                                                                                                    "note": {
                                                                                                                        "type": "text",
                                                                                                                        "tag": "p",
                                                                                                                        "text": ""
                                                                                                                    }
                                                                                                                }
                                                                                                            },
                                                                                                            {
                                                                                                                "id": 36,
                                                                                                                "name": "",
                                                                                                                "visibility": "block",
                                                                                                                "width": "narrow",
                                                                                                                "state": {
                                                                                                                    "t": "resheet.note",
                                                                                                                    "v": 1,
                                                                                                                    "level": 0,
                                                                                                                    "input": "Find collisions with enemies:",
                                                                                                                    "note": {
                                                                                                                        "type": "text",
                                                                                                                        "tag": "p",
                                                                                                                        "text": "Find collisions with enemies:"
                                                                                                                    }
                                                                                                                }
                                                                                                            },
                                                                                                            {
                                                                                                                "id": 37,
                                                                                                                "name": "collidedAndUntouchedEnemies",
                                                                                                                "visibility": "block",
                                                                                                                "width": "narrow",
                                                                                                                "state": {
                                                                                                                    "t": "resheet.note",
                                                                                                                    "v": 1,
                                                                                                                    "level": 0,
                                                                                                                    "input": "= lodash.partition(leftEnemies, enemyPos =>\n    simulatedCharacter.y <= enemySize\n    && Math.abs(simulatedCharacter.x - enemyPos) <= enemySize\n)",
                                                                                                                    "note": {
                                                                                                                        "type": "expr",
                                                                                                                        "code": " lodash.partition(leftEnemies, enemyPos =>\n    simulatedCharacter.y <= enemySize\n    && Math.abs(simulatedCharacter.x - enemyPos) <= enemySize\n)"
                                                                                                                    }
                                                                                                                }
                                                                                                            },
                                                                                                            {
                                                                                                                "id": 38,
                                                                                                                "name": "collidedEnemies",
                                                                                                                "visibility": "block",
                                                                                                                "width": "narrow",
                                                                                                                "state": {
                                                                                                                    "t": "resheet.note",
                                                                                                                    "v": 1,
                                                                                                                    "level": 0,
                                                                                                                    "input": "= collidedAndUntouchedEnemies[0]",
                                                                                                                    "note": {
                                                                                                                        "type": "expr",
                                                                                                                        "code": " collidedAndUntouchedEnemies[0]"
                                                                                                                    }
                                                                                                                }
                                                                                                            },
                                                                                                            {
                                                                                                                "id": 39,
                                                                                                                "name": "untouchedEnemies",
                                                                                                                "visibility": "block",
                                                                                                                "width": "narrow",
                                                                                                                "state": {
                                                                                                                    "t": "resheet.note",
                                                                                                                    "v": 1,
                                                                                                                    "level": 0,
                                                                                                                    "input": "= collidedAndUntouchedEnemies[1]",
                                                                                                                    "note": {
                                                                                                                        "type": "expr",
                                                                                                                        "code": " collidedAndUntouchedEnemies[1]"
                                                                                                                    }
                                                                                                                }
                                                                                                            },
                                                                                                            {
                                                                                                                "id": 40,
                                                                                                                "name": "",
                                                                                                                "visibility": "block",
                                                                                                                "width": "narrow",
                                                                                                                "state": {
                                                                                                                    "t": "resheet.note",
                                                                                                                    "v": 1,
                                                                                                                    "level": 0,
                                                                                                                    "input": "",
                                                                                                                    "note": {
                                                                                                                        "type": "text",
                                                                                                                        "tag": "p",
                                                                                                                        "text": ""
                                                                                                                    }
                                                                                                                }
                                                                                                            },
                                                                                                            {
                                                                                                                "id": 41,
                                                                                                                "name": "",
                                                                                                                "visibility": "block",
                                                                                                                "width": "narrow",
                                                                                                                "state": {
                                                                                                                    "t": "resheet.note",
                                                                                                                    "v": 1,
                                                                                                                    "level": 0,
                                                                                                                    "input": "Take a life on collision:",
                                                                                                                    "note": {
                                                                                                                        "type": "text",
                                                                                                                        "tag": "p",
                                                                                                                        "text": "Take a life on collision:"
                                                                                                                    }
                                                                                                                }
                                                                                                            },
                                                                                                            {
                                                                                                                "id": 42,
                                                                                                                "name": "collided",
                                                                                                                "visibility": "block",
                                                                                                                "width": "narrow",
                                                                                                                "state": {
                                                                                                                    "t": "resheet.note",
                                                                                                                    "v": 1,
                                                                                                                    "level": 0,
                                                                                                                    "input": "= collidedEnemies.length > 0",
                                                                                                                    "note": {
                                                                                                                        "type": "expr",
                                                                                                                        "code": " collidedEnemies.length > 0"
                                                                                                                    }
                                                                                                                }
                                                                                                            },
                                                                                                            {
                                                                                                                "id": 43,
                                                                                                                "name": "leftLives",
                                                                                                                "visibility": "block",
                                                                                                                "width": "narrow",
                                                                                                                "state": {
                                                                                                                    "t": "resheet.note",
                                                                                                                    "v": 1,
                                                                                                                    "level": 0,
                                                                                                                    "input": "= collided ? state.lives - 1 : state.lives",
                                                                                                                    "note": {
                                                                                                                        "type": "expr",
                                                                                                                        "code": " collided ? state.lives - 1 : state.lives"
                                                                                                                    }
                                                                                                                }
                                                                                                            },
                                                                                                            {
                                                                                                                "id": 44,
                                                                                                                "name": "",
                                                                                                                "visibility": "block",
                                                                                                                "width": "narrow",
                                                                                                                "state": {
                                                                                                                    "t": "resheet.note",
                                                                                                                    "v": 1,
                                                                                                                    "level": 0,
                                                                                                                    "input": "",
                                                                                                                    "note": {
                                                                                                                        "type": "text",
                                                                                                                        "tag": "p",
                                                                                                                        "text": ""
                                                                                                                    }
                                                                                                                }
                                                                                                            },
                                                                                                            {
                                                                                                                "id": 45,
                                                                                                                "name": "",
                                                                                                                "visibility": "block",
                                                                                                                "width": "narrow",
                                                                                                                "state": {
                                                                                                                    "t": "resheet.note",
                                                                                                                    "v": 1,
                                                                                                                    "level": 0,
                                                                                                                    "input": "### Final Simulated State",
                                                                                                                    "note": {
                                                                                                                        "type": "text",
                                                                                                                        "tag": "h3",
                                                                                                                        "text": "Final Simulated State"
                                                                                                                    }
                                                                                                                }
                                                                                                            },
                                                                                                            {
                                                                                                                "id": 46,
                                                                                                                "name": "",
                                                                                                                "visibility": "block",
                                                                                                                "width": "narrow",
                                                                                                                "state": {
                                                                                                                    "t": "resheet.note",
                                                                                                                    "v": 1,
                                                                                                                    "level": 0,
                                                                                                                    "input": "One last thing: Are we even still alive to begin with?",
                                                                                                                    "note": {
                                                                                                                        "type": "text",
                                                                                                                        "tag": "p",
                                                                                                                        "text": "One last thing: Are we even still alive to begin with?"
                                                                                                                    }
                                                                                                                }
                                                                                                            },
                                                                                                            {
                                                                                                                "id": 47,
                                                                                                                "name": "alive",
                                                                                                                "visibility": "block",
                                                                                                                "width": "narrow",
                                                                                                                "state": {
                                                                                                                    "t": "resheet.note",
                                                                                                                    "v": 1,
                                                                                                                    "level": 0,
                                                                                                                    "input": "= state.lives > 0",
                                                                                                                    "note": {
                                                                                                                        "type": "expr",
                                                                                                                        "code": " state.lives > 0"
                                                                                                                    }
                                                                                                                }
                                                                                                            },
                                                                                                            {
                                                                                                                "id": 48,
                                                                                                                "name": "simulation",
                                                                                                                "visibility": "block",
                                                                                                                "width": "narrow",
                                                                                                                "state": {
                                                                                                                    "t": "resheet.note",
                                                                                                                    "v": 1,
                                                                                                                    "level": 0,
                                                                                                                    "input": "/Code",
                                                                                                                    "note": {
                                                                                                                        "type": "block",
                                                                                                                        "isInstantiated": true,
                                                                                                                        "code": "Code",
                                                                                                                        "state": "!alive ?\n  state\n:\n  {\n    ...state,\n    score,\n    lives: leftLives,\n    character: simulatedCharacter,\n    enemies: untouchedEnemies,\n  }"
                                                                                                                    }
                                                                                                                }
                                                                                                            },
                                                                                                            {
                                                                                                                "id": 49,
                                                                                                                "name": "",
                                                                                                                "visibility": "block",
                                                                                                                "width": "narrow",
                                                                                                                "state": {
                                                                                                                    "t": "resheet.note",
                                                                                                                    "v": 1,
                                                                                                                    "level": 0,
                                                                                                                    "input": "",
                                                                                                                    "note": {
                                                                                                                        "type": "text",
                                                                                                                        "tag": "p",
                                                                                                                        "text": ""
                                                                                                                    }
                                                                                                                }
                                                                                                            },
                                                                                                            {
                                                                                                                "id": 50,
                                                                                                                "name": "",
                                                                                                                "visibility": "block",
                                                                                                                "width": "narrow",
                                                                                                                "state": {
                                                                                                                    "t": "resheet.note",
                                                                                                                    "v": 1,
                                                                                                                    "level": 0,
                                                                                                                    "input": "### React to Input",
                                                                                                                    "note": {
                                                                                                                        "type": "text",
                                                                                                                        "tag": "h3",
                                                                                                                        "text": "React to Input"
                                                                                                                    }
                                                                                                                }
                                                                                                            },
                                                                                                            {
                                                                                                                "id": 51,
                                                                                                                "name": "",
                                                                                                                "visibility": "block",
                                                                                                                "width": "narrow",
                                                                                                                "state": {
                                                                                                                    "t": "resheet.note",
                                                                                                                    "v": 1,
                                                                                                                    "level": 0,
                                                                                                                    "input": "= input",
                                                                                                                    "note": {
                                                                                                                        "type": "expr",
                                                                                                                        "code": " input"
                                                                                                                    }
                                                                                                                }
                                                                                                            },
                                                                                                            {
                                                                                                                "id": 52,
                                                                                                                "name": "xSpeed",
                                                                                                                "visibility": "block",
                                                                                                                "width": "narrow",
                                                                                                                "state": {
                                                                                                                    "t": "resheet.note",
                                                                                                                    "v": 1,
                                                                                                                    "level": 0,
                                                                                                                    "input": "/Code",
                                                                                                                    "note": {
                                                                                                                        "type": "block",
                                                                                                                        "isInstantiated": true,
                                                                                                                        "code": "Code",
                                                                                                                        "state": "// input changes character's xSpeed\nconst previous = state.character.xSpeed\n\nconst speed = 250 * factor\n\nif (!input) return previous;\n\n// This is not 100% correct, but let's keep it simple\nif (input.type === 'keyup') return 0;\nif (input.type === 'pointerup') return 0;\n\nif (input.type === 'keydown') {\n  if (input.key === 'ArrowLeft') return -speed;\n  if (input.key === 'ArrowRight') return speed;\n}\n\nif (input.type === 'pointerdown') {\n  const rect = input.target.getBoundingClientRect()\n  if (input.clientX - rect.x < rect.width / 2) return -speed;\n  if (input.clientX - rect.x > rect.width / 2) return speed;\n}\n\nreturn previous"
                                                                                                                    }
                                                                                                                }
                                                                                                            },
                                                                                                            {
                                                                                                                "id": 53,
                                                                                                                "name": "reaction",
                                                                                                                "visibility": "block",
                                                                                                                "width": "narrow",
                                                                                                                "state": {
                                                                                                                    "t": "resheet.note",
                                                                                                                    "v": 1,
                                                                                                                    "level": 0,
                                                                                                                    "input": "= { ...state, character: { ...state.character, xSpeed } }",
                                                                                                                    "note": {
                                                                                                                        "type": "expr",
                                                                                                                        "code": " { ...state, character: { ...state.character, xSpeed } }"
                                                                                                                    }
                                                                                                                }
                                                                                                            },
                                                                                                            {
                                                                                                                "id": 54,
                                                                                                                "name": "",
                                                                                                                "visibility": "block",
                                                                                                                "width": "narrow",
                                                                                                                "state": {
                                                                                                                    "t": "resheet.note",
                                                                                                                    "v": 1,
                                                                                                                    "level": 0,
                                                                                                                    "input": "",
                                                                                                                    "note": {
                                                                                                                        "type": "text",
                                                                                                                        "tag": "p",
                                                                                                                        "text": ""
                                                                                                                    }
                                                                                                                }
                                                                                                            },
                                                                                                            {
                                                                                                                "id": 55,
                                                                                                                "name": "",
                                                                                                                "visibility": "block",
                                                                                                                "width": "narrow",
                                                                                                                "state": {
                                                                                                                    "t": "resheet.note",
                                                                                                                    "v": 1,
                                                                                                                    "level": 0,
                                                                                                                    "input": "### Final State",
                                                                                                                    "note": {
                                                                                                                        "type": "text",
                                                                                                                        "tag": "h3",
                                                                                                                        "text": "Final State"
                                                                                                                    }
                                                                                                                }
                                                                                                            },
                                                                                                            {
                                                                                                                "id": 56,
                                                                                                                "name": "",
                                                                                                                "visibility": "block",
                                                                                                                "width": "narrow",
                                                                                                                "state": {
                                                                                                                    "t": "resheet.note",
                                                                                                                    "v": 1,
                                                                                                                    "level": 0,
                                                                                                                    "input": "Decide which state to use based on the input:",
                                                                                                                    "note": {
                                                                                                                        "type": "text",
                                                                                                                        "tag": "p",
                                                                                                                        "text": "Decide which state to use based on the input:"
                                                                                                                    }
                                                                                                                }
                                                                                                            },
                                                                                                            {
                                                                                                                "id": 57,
                                                                                                                "name": "finalState",
                                                                                                                "visibility": "block",
                                                                                                                "width": "narrow",
                                                                                                                "state": {
                                                                                                                    "t": "resheet.note",
                                                                                                                    "v": 1,
                                                                                                                    "level": 0,
                                                                                                                    "input": "= input?.type === 'simulate' ? simulation : reaction",
                                                                                                                    "note": {
                                                                                                                        "type": "expr",
                                                                                                                        "code": " input?.type === 'simulate' ? simulation : reaction"
                                                                                                                    }
                                                                                                                }
                                                                                                            }
                                                                                                        ]
                                                                                                    },
                                                                                                    "render": {
                                                                                                        "t": "resheet.sheet",
                                                                                                        "v": 2,
                                                                                                        "lines": [
                                                                                                            {
                                                                                                                "id": 1,
                                                                                                                "name": "Controls",
                                                                                                                "visibility": "result",
                                                                                                                "width": "full",
                                                                                                                "state": {
                                                                                                                    "t": "resheet.note",
                                                                                                                    "v": 1,
                                                                                                                    "level": 0,
                                                                                                                    "input": "/Code",
                                                                                                                    "note": {
                                                                                                                        "type": "block",
                                                                                                                        "isInstantiated": true,
                                                                                                                        "code": "Code",
                                                                                                                        "state": 'function Controls({ state, update, running, toggleRunning }) {\n  return (\n    <div className="w-full flex flex-row space-x-2">\n      <button\n        className={`\n          flex-1 rounded\n          bg-${running ? "green" : "red"}-100\n          hover:bg-${running ? "green" : "red"}-200\n        `}\n        onClick={toggleRunning}\n      >\n        {running ? "Running" : "Stopped - click to play"}\n      </button>\n\n      <button\n        className="flex-1 rounded bg-blue-100 hover:bg-blue-200"\n        onClick={() => update({ type: \'simulate\', dt: 16 })}\n      >\n        Step\n      </button>\n    </div> \n  )\n}'
                                                                                                                    }
                                                                                                                }
                                                                                                            },
                                                                                                            {
                                                                                                                "id": 0,
                                                                                                                "name": "",
                                                                                                                "visibility": "block",
                                                                                                                "width": "full",
                                                                                                                "state": {
                                                                                                                    "t": "resheet.note",
                                                                                                                    "v": 1,
                                                                                                                    "level": 0,
                                                                                                                    "input": "/Code",
                                                                                                                    "note": {
                                                                                                                        "type": "block",
                                                                                                                        "isInstantiated": true,
                                                                                                                        "code": "Code",
                                                                                                                        "state": "const height = 400;\nconst width = 800;\nconst tileSize = 64;\nconst ground = height - tileSize;\n\nfunction GameView({ state, update }) {\n  const { running, toggleRunning } = useAnimation(dt => update({ type: 'simulate', dt }))\n  \n  function react(ev) {\n    ev.preventDefault()\n    ev.stopPropagation()\n    ev.target.focus()\n    \n    update(ev) // runs an update with `input` set to `ev`\n  }\n  \n  const canvasRef = React.useRef(null)\n  \n  React.useEffect(() => {\n    const canvas = canvasRef.current;\n    const ctx = canvas.getContext('2d');\n    \n    // Setting up canvas dimensions\n    canvas.width = width;\n    canvas.height = height;\n\n    // Draw the platform\n    const ptrn = ctx.createPattern(Tiles.ground, 'repeat');\n    ctx.save();\n    ctx.fillStyle = ptrn;\n    ctx.translate(0, 336);\n    ctx.scale(tileSize / Tiles.ground.naturalWidth, tileSize / Tiles.ground.naturalHeight);\n    ctx.fillRect(0, 0, width, tileSize);\n    ctx.restore();\n\n    // Draw the character\n    ctx.save();\n    ctx.translate(state.character.x, height - tileSize - state.character.y);\n    if (state.lives <= 0) ctx.rotate(90 * Math.PI / 180);\n    if (state.character.xSpeed >= 0) ctx.scale(-1, 1);\n    ctx.drawImage(Tiles.character, -tileSize/2, -tileSize, tileSize, tileSize);\n    ctx.restore();\n\n    // Draw enemies\n    state.enemies.forEach(enemyPos => {\n      ctx.save();\n      ctx.translate(enemyPos, height - tileSize);\n      ctx.scale(0.5, 0.5);\n      ctx.drawImage(Tiles.enemy, -tileSize/2, -tileSize, tileSize, tileSize);\n      ctx.restore();\n    });\n\n    // Draw text\n    ctx.font = '20px Arial';\n    ctx.fillStyle = 'black';\n    ctx.fillText(`Lives: ${\"\u2764\uFE0F\".repeat(state.lives)}`, 20, 30);\n    ctx.fillText(`Score: ${state.score} x \u2B50\uFE0F`, 20, 60);\n    \n    ctx.font = '16px Arial';\n    ctx.fillStyle = '#888';\n    ctx.fillText('Use the arrow keys or press on the left and right', 20, 90);\n    \n    if (state.lives <= 0) {\n      ctx.fillStyle = 'red';\n      ctx.font = '40px Arial';\n      ctx.fillText('Game Over', 50, 200);\n    }\n  }, [state]);\n\n\n  return (\n    <div>\n      <Controls state={state} update={update} running={running} toggleRunning={toggleRunning} />\n      <canvas\n        ref={canvasRef}\n        tabIndex={-1}\n        className=\"w-full\"\n        onKeyDown={react}\n        onKeyUp={react}\n        onPointerDownCapture={react}\n        onPointerUpCapture={react}\n        />\n    </div>\n  )\n}"
                                                                                                                    }
                                                                                                                }
                                                                                                            }
                                                                                                        ]
                                                                                                    }
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 44,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "",
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "p",
                                                                                                "text": ""
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 45,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "",
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "p",
                                                                                                "text": ""
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 46,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "",
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "p",
                                                                                                "text": ""
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 52,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "",
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "p",
                                                                                                "text": ""
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 53,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "",
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "p",
                                                                                                "text": ""
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 54,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "",
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "p",
                                                                                                "text": ""
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 55,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "",
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "p",
                                                                                                "text": ""
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 47,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "full",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "---",
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "p",
                                                                                                "text": "---"
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 49,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "## Preview",
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "h2",
                                                                                                "text": "Preview"
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 50,
                                                                                        "name": "",
                                                                                        "visibility": "block",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "",
                                                                                            "note": {
                                                                                                "type": "text",
                                                                                                "tag": "p",
                                                                                                "text": ""
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        "id": 51,
                                                                                        "name": "preview",
                                                                                        "visibility": "result",
                                                                                        "width": "narrow",
                                                                                        "state": {
                                                                                            "t": "resheet.note",
                                                                                            "v": 1,
                                                                                            "level": 0,
                                                                                            "input": "/Code",
                                                                                            "note": {
                                                                                                "type": "block",
                                                                                                "isInstantiated": true,
                                                                                                "code": "Code",
                                                                                                "state": "Util.WithEnv(\n  env => ({ ...env, Tiles, useAnimation }),\n  realGame.derivedBlock,\n)"
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                ]
                                                                            }
                                                                        },
                                                                        "isCollapsed": true,
                                                                        "children": [
                                                                            {
                                                                                "id": 0,
                                                                                "name": "Tiles",
                                                                                "state": {
                                                                                    "t": "resheet.selector",
                                                                                    "v": 0,
                                                                                    "mode": "run",
                                                                                    "expr": "SheetOf(Note)",
                                                                                    "inner": {
                                                                                        "t": "resheet.sheet",
                                                                                        "v": 2,
                                                                                        "lines": [
                                                                                            {
                                                                                                "id": 4,
                                                                                                "name": "",
                                                                                                "visibility": "block",
                                                                                                "width": "narrow",
                                                                                                "state": {
                                                                                                    "t": "resheet.note",
                                                                                                    "v": 1,
                                                                                                    "level": 0,
                                                                                                    "input": "# Tiles",
                                                                                                    "note": {
                                                                                                        "type": "text",
                                                                                                        "tag": "h1",
                                                                                                        "text": "Tiles"
                                                                                                    }
                                                                                                }
                                                                                            },
                                                                                            {
                                                                                                "id": 5,
                                                                                                "name": "",
                                                                                                "visibility": "block",
                                                                                                "width": "narrow",
                                                                                                "state": {
                                                                                                    "t": "resheet.note",
                                                                                                    "v": 1,
                                                                                                    "level": 0,
                                                                                                    "input": "from kenney.nl",
                                                                                                    "note": {
                                                                                                        "type": "text",
                                                                                                        "tag": "p",
                                                                                                        "text": "from kenney.nl"
                                                                                                    }
                                                                                                }
                                                                                            },
                                                                                            {
                                                                                                "id": 0,
                                                                                                "name": "groundFile",
                                                                                                "visibility": "block",
                                                                                                "width": "narrow",
                                                                                                "state": {
                                                                                                    "t": "resheet.note",
                                                                                                    "v": 1,
                                                                                                    "level": 0,
                                                                                                    "input": "/LoadFile",
                                                                                                    "note": {
                                                                                                        "type": "block",
                                                                                                        "isInstantiated": true,
                                                                                                        "code": "LoadFile",
                                                                                                        "state": {
                                                                                                            "state": "loaded",
                                                                                                            "file": {
                                                                                                                "content": "iVBORw0KGgoAAAANSUhEUgAAABIAAAASBAMAAACk4JNkAAAABGdBTUEAALGPC/xhBQAAABJQTFRF9KxmNuN3n1pSLrCCQ0pfy4FePNWy0QAAADtJREFUCNdjcIEBBgRLEAaQWMYwgJWlbGwEQQxKxkoQxKAEAwyhMABjsYJYqqGhSnAxGCsIRR2QhcV9AJFcJViCy6XLAAAAAElFTkSuQmCC",
                                                                                                                "name": "tile_0002.png",
                                                                                                                "options": {
                                                                                                                    "type": "image/png",
                                                                                                                    "lastModified": 1696663628000
                                                                                                                }
                                                                                                            }
                                                                                                        }
                                                                                                    }
                                                                                                }
                                                                                            },
                                                                                            {
                                                                                                "id": 1,
                                                                                                "name": "charFile",
                                                                                                "visibility": "block",
                                                                                                "width": "narrow",
                                                                                                "state": {
                                                                                                    "t": "resheet.note",
                                                                                                    "v": 1,
                                                                                                    "level": 0,
                                                                                                    "input": "/LoadFile",
                                                                                                    "note": {
                                                                                                        "type": "block",
                                                                                                        "isInstantiated": true,
                                                                                                        "code": "LoadFile",
                                                                                                        "state": {
                                                                                                            "state": "loaded",
                                                                                                            "file": {
                                                                                                                "content": "iVBORw0KGgoAAAANSUhEUgAAABgAAAAYBAMAAAASWSDLAAAABGdBTUEAALGPC/xhBQAAABhQTFRFAAAANJleQ0pfhva7////WtKMNGVHvt7xFlk/CQAAAAF0Uk5TAEDm2GYAAACESURBVBjTbdAxDsIwDAXQTGXuwgF6BSROgOQTODMIxV0ZrPr62P7xUMSf8mQr+klrP7HMPOvDQ6mLUgyUPgHCmgasEHtqh3h2o4RkgENuHtmBd+BeYE9hBPpfbLwVDMirjbCWDbybDxjdTq1P72kLWj8BXDAh6/W1yvwQ4T64sIw+cusLm7JKEh9ouLwAAAAASUVORK5CYII=",
                                                                                                                "name": "tile_0000.png",
                                                                                                                "options": {
                                                                                                                    "type": "image/png",
                                                                                                                    "lastModified": 1696663636000
                                                                                                                }
                                                                                                            }
                                                                                                        }
                                                                                                    }
                                                                                                }
                                                                                            },
                                                                                            {
                                                                                                "id": 7,
                                                                                                "name": "enemyFile",
                                                                                                "visibility": "block",
                                                                                                "width": "narrow",
                                                                                                "state": {
                                                                                                    "t": "resheet.note",
                                                                                                    "v": 1,
                                                                                                    "level": 0,
                                                                                                    "input": "/LoadFile",
                                                                                                    "note": {
                                                                                                        "type": "block",
                                                                                                        "isInstantiated": true,
                                                                                                        "code": "LoadFile",
                                                                                                        "state": {
                                                                                                            "state": "loaded",
                                                                                                            "file": {
                                                                                                                "content": "iVBORw0KGgoAAAANSUhEUgAAABgAAAAYBAMAAAASWSDLAAAABGdBTUEAALGPC/xhBQAAABJQTFRFAAAAy4Fe/////uSB9LQbbz5D7N5EzgAAAAF0Uk5TAEDm2GYAAABTSURBVBjTY2AgFoRCAYjNCuMEgDjBxmBgiskJcQEDVwhHEMQWxMZBUeYSGuIaCue4hriGuGBVFqSkpIrQo6QE1yMCknGEcUBaHLEYgOwFFM8RBQCbzywIlKpD5AAAAABJRU5ErkJggg==",
                                                                                                                "name": "tile_0012.png",
                                                                                                                "options": {
                                                                                                                    "type": "image/png",
                                                                                                                    "lastModified": 1696663634000
                                                                                                                }
                                                                                                            }
                                                                                                        }
                                                                                                    }
                                                                                                }
                                                                                            },
                                                                                            {
                                                                                                "id": 3,
                                                                                                "name": "",
                                                                                                "visibility": "block",
                                                                                                "width": "narrow",
                                                                                                "state": {
                                                                                                    "t": "resheet.note",
                                                                                                    "v": 1,
                                                                                                    "level": 0,
                                                                                                    "input": "",
                                                                                                    "note": {
                                                                                                        "type": "text",
                                                                                                        "tag": "p",
                                                                                                        "text": ""
                                                                                                    }
                                                                                                }
                                                                                            },
                                                                                            {
                                                                                                "id": 8,
                                                                                                "name": "finreg",
                                                                                                "visibility": "result",
                                                                                                "width": "narrow",
                                                                                                "state": {
                                                                                                    "t": "resheet.note",
                                                                                                    "v": 1,
                                                                                                    "level": 0,
                                                                                                    "input": "/Code",
                                                                                                    "note": {
                                                                                                        "type": "block",
                                                                                                        "isInstantiated": true,
                                                                                                        "code": "Code",
                                                                                                        "state": "window.finreg = (\n  window.finreg\n  || new FinalizationRegistry(finalizer => finalizer())\n)\nwindow.finreg"
                                                                                                    }
                                                                                                }
                                                                                            },
                                                                                            {
                                                                                                "id": 9,
                                                                                                "name": "image",
                                                                                                "visibility": "result",
                                                                                                "width": "narrow",
                                                                                                "state": {
                                                                                                    "t": "resheet.note",
                                                                                                    "v": 1,
                                                                                                    "level": 0,
                                                                                                    "input": "/Code",
                                                                                                    "note": {
                                                                                                        "type": "block",
                                                                                                        "isInstantiated": true,
                                                                                                        "code": "Code",
                                                                                                        "state": "async function image(blob) {\n  const image = new Image()\n  const url = URL.createObjectURL(blob)\n  image.src = url\n  finreg.register(image, () => URL.revokeObjectURL(url))\n  await image.decode()\n  return image\n}"
                                                                                                    }
                                                                                                }
                                                                                            },
                                                                                            {
                                                                                                "id": 2,
                                                                                                "name": "",
                                                                                                "visibility": "block",
                                                                                                "width": "narrow",
                                                                                                "state": {
                                                                                                    "t": "resheet.note",
                                                                                                    "v": 1,
                                                                                                    "level": 0,
                                                                                                    "input": "/Code",
                                                                                                    "note": {
                                                                                                        "type": "block",
                                                                                                        "isInstantiated": true,
                                                                                                        "code": "Code",
                                                                                                        "state": "({\n  character: await image(charFile),\n  ground: await image(groundFile),\n  enemy: await image(enemyFile),\n})"
                                                                                                    }
                                                                                                }
                                                                                            }
                                                                                        ]
                                                                                    }
                                                                                },
                                                                                "isCollapsed": false,
                                                                                "children": []
                                                                            },
                                                                            {
                                                                                "id": 3,
                                                                                "name": "Game",
                                                                                "state": {
                                                                                    "t": "resheet.selector",
                                                                                    "v": 0,
                                                                                    "mode": "run",
                                                                                    "expr": "Code",
                                                                                    "inner": "const { fieldDispatcher } = resheet.util.dispatch\n\n// The builtin Blocks used for editing the initial state, update logic and render logic\nconst initBlock = resheet.blocks.component.safeBlock(Code)\nconst updateBlock = resheet.blocks.component.safeBlock(SheetOf(Note))\nconst renderBlock = resheet.blocks.component.safeBlock(SheetOf(Note))\n\n\n// helper component to reduce rendering overhead when closed\nfunction Details({ open=false, children }) {\n  const [opened, setOpened] = React.useState(open)\n  \n  return (\n    <details open={opened} onToggle={ev => setOpened(ev.target.open)}>\n      {children[0]}\n      {opened && children.slice(1)}\n    </details>\n  )\n}\n\n\n// create a dispatcher that enhances the env\nfunction enhanceEnv(dispatch, enhance) {\n  return function dispatchWithEnhancedEnv(action) {\n    dispatch((state, { env }) =>\n      action(state, { env: enhance(env, state) })\n    )\n  }\n}\n\n// create the env for the update logic, adding the current state and input\nfunction updateEnv(env, state) {\n  return { ...env, state: state.state, input: state.input }\n}\n\n// the dispatcher for the update block\nfunction updateDispatcher(dispatch) {\n  return (\n    fieldDispatcher(\n      'updateState',\n      enhanceEnv(dispatch, updateEnv),\n    )\n  )\n}\n  \n\n// create the env for the render logic, adding the current state and act procedure\nfunction renderEnv(env, state, dispatch) {\n  return {\n    ...env,\n    state: state.state,\n    update(input) {\n      update(dispatch, state => ({\n        ...state,\n        input\n      }))\n    },\n  }\n}\n\n// the dispatcher for the render block\nfunction renderDispatcher(dispatch) {\n  return (\n    fieldDispatcher(\n      'renderState',\n      enhanceEnv(dispatch, (env, state) => renderEnv(env, state, dispatch)),\n    )\n  )\n}\n\n\n// all dispatchers for the different embedded blocks\nfunction dispatchers(dispatch) {\n  return {\n    init: fieldDispatcher('initState', dispatch),\n    update: updateDispatcher(dispatch),\n    render: renderDispatcher(dispatch),\n  }\n}\n\n\nfunction update(dispatch, fn) {\n  const disp = dispatchers(dispatch)\n\n  dispatch((state, { env }) => {\n    const fnState = fn(state, env)\n    \n    const updateState = updateBlock.recompute(\n      fnState.updateState,\n      disp.update,\n      updateEnv(env, fnState),\n      immutable.Set(['state', 'input']),\n    ).state\n    \n    const newState = {\n      ...fnState,\n      updateState,\n      state: updateBlock.getResult(updateState),\n    }\n    \n    const renderState = renderBlock.recompute(\n      newState.renderState,\n      disp.render,\n      renderEnv(env, newState, dispatch),\n      immutable.Set(['state']),\n    ).state\n\n\n    return {\n      state: {\n        ...newState,\n        renderState,\n      }\n    }\n  })\n}\n\nfunction recompute(state, dispatch, env, changed) {\n  const disp = dispatchers(dispatch)\n  \n  const initState = initBlock.recompute(\n    state.initState,\n    disp.init,\n    env,\n    changed,\n  ).state\n  \n  const updateState = updateBlock.recompute(\n    state.updateState,\n    disp.update,\n    updateEnv(env, state),\n    changed,\n  ).state\n  \n  const renderState = renderBlock.recompute(\n    state.renderState,\n    disp.render,\n    renderEnv(env, state, dispatch),\n    changed,\n  ).state\n  \n  return {\n    ...state,\n    initState,\n    updateState,\n    renderState,\n  }\n}\n\n\n\n// create the Game Block\nresheet.core.block.create({\n  // initial block state\n  init: {\n    state: initBlock.getResult(initBlock.init),\n    input: undefined,\n    initState: initBlock.init,\n    updateState: updateBlock.init,\n    renderState: renderBlock.init,\n  },\n  \n  // rendering the block\n  view({ state, dispatch, env }) {\n    const disp = dispatchers(dispatch)\n        \n    function reset() {\n      dispatch((state, { env }) => ({\n        state: recompute(\n          { ...state, state: initBlock.getResult(state.initState) },\n          dispatch,\n          env,\n          immutable.Set(['state']),\n        )\n      }))\n    }\n    \n    function updateGame(input) {\n      update(dispatch, state => ({\n        ...state,\n        input\n      }))\n    }\n\n    const rendered = renderBlock.getResult(state.renderState)\n    \n    return (\n      <div>\n        <Details>\n          <summary className=\"text-lg mb-2\">Initial State</summary>\n          <initBlock.Component\n            state={state.initState}\n            dispatch={disp.init}\n            env={env}\n            />\n        </Details>\n        \n        <Details>\n          <summary className=\"text-lg mb-2 mt-6\">Update State</summary>\n          <updateBlock.Component\n            state={state.updateState}\n            dispatch={disp.update}\n            env={updateEnv(env, state)}\n            />\n        </Details>\n        \n        <Details open>\n          <summary className=\"text-lg mb-2 mt-6\">Current State</summary>\n          <reactInspector.Inspector data={state.state} />\n        </Details>\n\n        <button\n          className=\"w-full rounded bg-blue-100 hover:bg-blue-200\"\n          onClick={reset}\n        >\n          Reset\n        </button>\n\n        <Details>\n          <summary className=\"text-lg mb-2 mt-6\">Render</summary>\n          <renderBlock.Component\n            state={state.renderState}\n            dispatch={disp.render}\n            env={renderEnv(env, state, dispatch)}\n            />\n        </Details>\n        \n        <resheet.code.value.ErrorBoundary\n          title=\"There was an error in your Renderer\"\n          viewError={error => <resheet.code.value.ErrorInspector error={error} />}\n          autoReset\n        >\n          {React.isValidElement(rendered) && React.createElement(() => rendered)}\n          {typeof rendered === 'function' &&\n            React.createElement(rendered, {\n              state: state.state,\n              update: updateGame,\n            })\n          }\n        </resheet.code.value.ErrorBoundary>\n      </div>\n    )\n  },\n\n  // the block's reported value\n  getResult(state) {\n    return state.state\n  },\n  \n  // loading logic\n  fromJSON(json, dispatch, env) {\n    const disp = dispatchers(dispatch)\n\n    const initState = initBlock.fromJSON(json.init, disp.init, env)\n    const initResult = initBlock.getResult(initState)\n    \n    const envUpdate = updateEnv(env, { state: initResult, input: undefined })\n    const updateState = updateBlock.fromJSON(json.update, disp.update, envUpdate)\n    \n    const envRender = renderEnv(env, { state: initResult }, dispatch)\n    const renderState = renderBlock.fromJSON(json.render, disp.render, envRender)\n    \n    return {\n      state: initResult,\n      initState,\n      updateState,\n      renderState,\n    }\n  },\n  \n  // saving logic\n  toJSON(state) {\n    return {\n      init: initBlock.toJSON(state.initState),\n      update: updateBlock.toJSON(state.updateState),\n      render: updateBlock.toJSON(state.renderState),\n    }\n  },\n  \n  // recomputation logic if something in env changed\n  recompute(state, dispatch, env, changed) {\n    const newState = recompute(state, dispatch, env, changed)\n    \n    return {\n      state: newState,\n      invalidated: false,\n    }\n  },\n})"
                                                                                },
                                                                                "isCollapsed": false,
                                                                                "children": []
                                                                            },
                                                                            {
                                                                                "id": 4,
                                                                                "name": "useAnimation",
                                                                                "state": {
                                                                                    "t": "resheet.selector",
                                                                                    "v": 0,
                                                                                    "mode": "run",
                                                                                    "expr": "Code",
                                                                                    "inner": "function useAnimation(step) {\n  const [running, setRunning] = React.useState(false)\n  const stepRef = React.useRef(step)\n  stepRef.current = step\n  \n  React.useEffect(() => {\n    let raf = null\n    let lastTime = null\n    \n    function animate() {\n      const time = performance.now()\n      \n      stepRef.current(lastTime === null ? 0 : time - lastTime)\n      \n      lastTime = time\n      raf = requestAnimationFrame(animate)\n    }\n    \n    if (running) {\n      raf = requestAnimationFrame(animate)\n    }\n    \n    return () => raf && cancelAnimationFrame(raf)\n  }, [running])\n  \n  function toggleRunning() {\n    setRunning(running => !running)\n  }\n  \n  return {\n    running,\n    setRunning,\n    toggleRunning,\n  }\n}"
                                                                                },
                                                                                "isCollapsed": false,
                                                                                "children": []
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "viewState": {
                                                            "sidebarOpen": false,
                                                            "openPage": [
                                                                2
                                                            ]
                                                        },
                                                        "template": {
                                                            "id": 2,
                                                            "name": "",
                                                            "state": {
                                                                "t": "resheet.selector",
                                                                "v": 0,
                                                                "mode": "run",
                                                                "expr": "SheetOf(Note)",
                                                                "inner": {
                                                                    "t": "resheet.sheet",
                                                                    "v": 2,
                                                                    "lines": []
                                                                }
                                                            },
                                                            "isCollapsed": false,
                                                            "children": []
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    },
                                    {
                                        "id": 10,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 11,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "---",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": "---"
                                            }
                                        }
                                    },
                                    {
                                        "id": 6,
                                        "name": "exports",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "/Code",
                                            "note": {
                                                "type": "block",
                                                "isInstantiated": true,
                                                "code": "Code",
                                                "state": "({\n  notepad: <Example template={notepad.derivedBlock} />,\n  formulas: <Example template={formulas.derivedBlock} />,\n  extensibility: <Example template={extensibility.derivedBlock} />,\n})"
                                            }
                                        }
                                    }
                                ]
                            }
                        },
                        "isCollapsed": false,
                        "children": []
                    },
                    {
                        "id": 2,
                        "name": "Demo",
                        "state": {
                            "t": "resheet.selector",
                            "v": 0,
                            "mode": "run",
                            "expr": "SheetOf(Note)",
                            "inner": {
                                "t": "resheet.sheet",
                                "v": 2,
                                "lines": [
                                    {
                                        "id": 1,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "wide",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "# Demo",
                                            "note": {
                                                "type": "text",
                                                "tag": "h1",
                                                "text": "Demo"
                                            }
                                        }
                                    },
                                    {
                                        "id": 5,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "wide",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 2,
                                        "name": "demoTemplateFile",
                                        "visibility": "block",
                                        "width": "wide",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "/LoadFile",
                                            "note": {
                                                "type": "block",
                                                "isInstantiated": true,
                                                "code": "LoadFile",
                                                "state": {
                                                    "state": "loaded",
                                                    "file": {
                                                        "content": "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",
                                                        "name": "Demo Template.json",
                                                        "options": {
                                                            "type": "application/json",
                                                            "lastModified": 1716386322121
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    },
                                    {
                                        "id": 3,
                                        "name": "demoTemplate",
                                        "visibility": "block",
                                        "width": "wide",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "= JSON.parse(await demoTemplateFile.text())",
                                            "note": {
                                                "type": "expr",
                                                "code": " JSON.parse(await demoTemplateFile.text())"
                                            }
                                        }
                                    },
                                    {
                                        "id": 4,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "wide",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 9,
                                        "name": "DefaultPageBlock",
                                        "visibility": "block",
                                        "width": "wide",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "= BlockSelector('SheetOf(Note)', SheetOf(Note))",
                                            "note": {
                                                "type": "expr",
                                                "code": " BlockSelector('SheetOf(Note)', SheetOf(Note))"
                                            }
                                        }
                                    },
                                    {
                                        "id": 10,
                                        "name": "ReSheetBlock",
                                        "visibility": "block",
                                        "width": "wide",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "= DocumentOf(DefaultPageBlock)",
                                            "note": {
                                                "type": "expr",
                                                "code": " DocumentOf(DefaultPageBlock)"
                                            }
                                        }
                                    },
                                    {
                                        "id": 11,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "wide",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 12,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "wide",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "## Editor",
                                            "note": {
                                                "type": "text",
                                                "tag": "h2",
                                                "text": "Editor"
                                            }
                                        }
                                    },
                                    {
                                        "id": 13,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "wide",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "Edit and export the demo here.",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": "Edit and export the demo here."
                                            }
                                        }
                                    },
                                    {
                                        "id": 19,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "wide",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 18,
                                        "name": "scripts",
                                        "visibility": "block",
                                        "width": "wide",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "/Code",
                                            "note": {
                                                "type": "block",
                                                "isInstantiated": true,
                                                "code": "Code",
                                                "state": "const { makeRange, setCurrentRange } = resheet.code.useEditable\n\nreturn {\n  async jumpEnd() {\n    const element = document.activeElement\n    if (!element) { return }\n    setCurrentRange(makeRange(element, element.textContent.length - 1))\n  },\n  \n  async dummy() {},\n}"
                                            }
                                        }
                                    },
                                    {
                                        "id": 20,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "wide",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 6,
                                        "name": "demo",
                                        "visibility": "block",
                                        "width": "wide",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "/DemoRecorder(ReSheetBlock, demoTemplate, scripts)",
                                            "note": {
                                                "type": "block",
                                                "isInstantiated": true,
                                                "code": "DemoRecorder(ReSheetBlock, demoTemplate, scripts)",
                                                "state": {
                                                    "actions": [
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowDown",
                                                            "code": "ArrowDown",
                                                            "ctrlKey": false,
                                                            "metaKey": true,
                                                            "shiftKey": false,
                                                            "altKey": true
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 1.5
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowDown",
                                                            "code": "ArrowDown",
                                                            "ctrlKey": false,
                                                            "metaKey": true,
                                                            "shiftKey": false,
                                                            "altKey": true
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 1.5
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowDown",
                                                            "code": "ArrowDown",
                                                            "ctrlKey": true,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": true
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 1.5
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowDown",
                                                            "code": "ArrowDown",
                                                            "ctrlKey": true,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": true
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 1.5
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowDown",
                                                            "code": "ArrowDown",
                                                            "ctrlKey": true,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": true
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 1
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "Escape",
                                                            "code": "Escape",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 2
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "Enter",
                                                            "code": "Enter",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 0.5
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowDown",
                                                            "code": "ArrowDown",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowDown",
                                                            "code": "ArrowDown",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 2
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "Enter",
                                                            "code": "Enter",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 0.5
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowDown",
                                                            "code": "ArrowDown",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowDown",
                                                            "code": "ArrowDown",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 1
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "Enter",
                                                            "code": "Enter",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 0.5
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowUp",
                                                            "code": "ArrowUp",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowUp",
                                                            "code": "ArrowUp",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 1
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "Escape",
                                                            "code": "Escape",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 1.5
                                                        },
                                                        {
                                                            "type": "input",
                                                            "input": "= date.getDate()"
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "Enter",
                                                            "code": "Enter",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 1
                                                        },
                                                        {
                                                            "type": "input",
                                                            "input": "= date"
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 0.5
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "Enter",
                                                            "code": "Enter",
                                                            "ctrlKey": false,
                                                            "metaKey": true,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 0.5
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowDown",
                                                            "code": "ArrowDown",
                                                            "ctrlKey": true,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": true
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 0.5
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "Escape",
                                                            "code": "Escape",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 3
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "Enter",
                                                            "code": "Enter",
                                                            "ctrlKey": false,
                                                            "metaKey": true,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 1.5
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowDown",
                                                            "code": "ArrowDown",
                                                            "ctrlKey": true,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": true
                                                        },
                                                        {
                                                            "type": "input",
                                                            "input": "/Global.blocks.Date()"
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "Backspace",
                                                            "code": "Backspace",
                                                            "ctrlKey": false,
                                                            "metaKey": true,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 0.5
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "Enter",
                                                            "code": "Enter",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 2
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowDown",
                                                            "code": "ArrowDown",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowDown",
                                                            "code": "ArrowDown",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowDown",
                                                            "code": "ArrowDown",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowDown",
                                                            "code": "ArrowDown",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowDown",
                                                            "code": "ArrowDown",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowDown",
                                                            "code": "ArrowDown",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowDown",
                                                            "code": "ArrowDown",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowDown",
                                                            "code": "ArrowDown",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowDown",
                                                            "code": "ArrowDown",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowDown",
                                                            "code": "ArrowDown",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowDown",
                                                            "code": "ArrowDown",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowDown",
                                                            "code": "ArrowDown",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowDown",
                                                            "code": "ArrowDown",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowDown",
                                                            "code": "ArrowDown",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowDown",
                                                            "code": "ArrowDown",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowDown",
                                                            "code": "ArrowDown",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowDown",
                                                            "code": "ArrowDown",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowDown",
                                                            "code": "ArrowDown",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowDown",
                                                            "code": "ArrowDown",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 2
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "Enter",
                                                            "code": "Enter",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 0.5
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowDown",
                                                            "code": "ArrowDown",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowDown",
                                                            "code": "ArrowDown",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowDown",
                                                            "code": "ArrowDown",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowDown",
                                                            "code": "ArrowDown",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 0.5
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "Escape",
                                                            "code": "Escape",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 2.5
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowDown",
                                                            "code": "ArrowDown",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 0.5
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "Enter",
                                                            "code": "Enter",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 0.5
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowDown",
                                                            "code": "ArrowDown",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowDown",
                                                            "code": "ArrowDown",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowDown",
                                                            "code": "ArrowDown",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowDown",
                                                            "code": "ArrowDown",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowDown",
                                                            "code": "ArrowDown",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 1.5
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "Escape",
                                                            "code": "Escape",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "Escape",
                                                            "code": "Escape",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 2
                                                        },
                                                        {
                                                            "type": "input",
                                                            "input": "\n  Datepicker,"
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowLeft",
                                                            "code": "ArrowLeft",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowUp",
                                                            "code": "ArrowUp",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowUp",
                                                            "code": "ArrowUp",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowLeft",
                                                            "code": "ArrowLeft",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowLeft",
                                                            "code": "ArrowLeft",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 1
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "Enter",
                                                            "code": "Enter",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 0.5
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowDown",
                                                            "code": "ArrowDown",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowDown",
                                                            "code": "ArrowDown",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowDown",
                                                            "code": "ArrowDown",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowDown",
                                                            "code": "ArrowDown",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 0.5
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "Escape",
                                                            "code": "Escape",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 1.5
                                                        },
                                                        {
                                                            "type": "input",
                                                            "input": "esmshCss('react-datepicker/dist/react-datepicker.css')"
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 0.5
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "Enter",
                                                            "code": "Enter",
                                                            "ctrlKey": false,
                                                            "metaKey": true,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 1
                                                        },
                                                        {
                                                            "type": "input",
                                                            "input": "/Code"
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "Enter",
                                                            "code": "Enter",
                                                            "ctrlKey": false,
                                                            "metaKey": true,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 1
                                                        },
                                                        {
                                                            "type": "input",
                                                            "input": "Datepicker"
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "R",
                                                            "code": "KeyR",
                                                            "ctrlKey": true,
                                                            "metaKey": false,
                                                            "shiftKey": true,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 1
                                                        },
                                                        {
                                                            "type": "input",
                                                            "input": "= esmshDefault('react-datepicker')"
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "Enter",
                                                            "code": "Enter",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 0.5
                                                        },
                                                        {
                                                            "type": "input",
                                                            "input": "## Datepicker"
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "Enter",
                                                            "code": "Enter",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "Enter",
                                                            "code": "Enter",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 1
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowUp",
                                                            "code": "ArrowUp",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowUp",
                                                            "code": "ArrowUp",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 1
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "G",
                                                            "code": "KeyG",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": true,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 2
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "Enter",
                                                            "code": "Enter",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 0.5
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowUp",
                                                            "code": "ArrowUp",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowUp",
                                                            "code": "ArrowUp",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowUp",
                                                            "code": "ArrowUp",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowUp",
                                                            "code": "ArrowUp",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowUp",
                                                            "code": "ArrowUp",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowUp",
                                                            "code": "ArrowUp",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 1.5
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowLeft",
                                                            "code": "ArrowLeft",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 0.5
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "Escape",
                                                            "code": "Escape",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 2
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowDown",
                                                            "code": "ArrowDown",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowDown",
                                                            "code": "ArrowDown",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowDown",
                                                            "code": "ArrowDown",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowDown",
                                                            "code": "ArrowDown",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowDown",
                                                            "code": "ArrowDown",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowDown",
                                                            "code": "ArrowDown",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowDown",
                                                            "code": "ArrowDown",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowDown",
                                                            "code": "ArrowDown",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowDown",
                                                            "code": "ArrowDown",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowDown",
                                                            "code": "ArrowDown",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowDown",
                                                            "code": "ArrowDown",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowDown",
                                                            "code": "ArrowDown",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowDown",
                                                            "code": "ArrowDown",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowDown",
                                                            "code": "ArrowDown",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "Escape",
                                                            "code": "Escape",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 2
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "Enter",
                                                            "code": "Enter",
                                                            "ctrlKey": false,
                                                            "metaKey": true,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 2
                                                        },
                                                        {
                                                            "type": "input",
                                                            "input": "/Global.blocks.Select(Object.keys(months))"
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 1
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "Backspace",
                                                            "code": "Backspace",
                                                            "ctrlKey": false,
                                                            "metaKey": true,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 1
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "Enter",
                                                            "code": "Enter",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 0.5
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowDown",
                                                            "code": "ArrowDown",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowDown",
                                                            "code": "ArrowDown",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowDown",
                                                            "code": "ArrowDown",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowDown",
                                                            "code": "ArrowDown",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowDown",
                                                            "code": "ArrowDown",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 1
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "Enter",
                                                            "code": "Enter",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 1
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowDown",
                                                            "code": "ArrowDown",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowDown",
                                                            "code": "ArrowDown",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowDown",
                                                            "code": "ArrowDown",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowDown",
                                                            "code": "ArrowDown",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowDown",
                                                            "code": "ArrowDown",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 1
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "Escape",
                                                            "code": "Escape",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 2
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowDown",
                                                            "code": "ArrowDown",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowDown",
                                                            "code": "ArrowDown",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowDown",
                                                            "code": "ArrowDown",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowDown",
                                                            "code": "ArrowDown",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowDown",
                                                            "code": "ArrowDown",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 1
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "Enter",
                                                            "code": "Enter",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 1
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowDown",
                                                            "code": "ArrowDown",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowDown",
                                                            "code": "ArrowDown",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 1
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowDown",
                                                            "code": "ArrowDown",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 1
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowDown",
                                                            "code": "ArrowDown",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 1
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowDown",
                                                            "code": "ArrowDown",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 1.5
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": " ",
                                                            "code": "Space",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 1
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowUp",
                                                            "code": "ArrowUp",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 1
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowLeft",
                                                            "code": "ArrowLeft",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 1
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "Escape",
                                                            "code": "Escape",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 3
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "Escape",
                                                            "code": "Escape",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 0.5
                                                        },
                                                        {
                                                            "type": "input",
                                                            "input": '= "February 2024"'
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 0.5
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "Backspace",
                                                            "code": "Backspace",
                                                            "ctrlKey": false,
                                                            "metaKey": true,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 0.5
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "Enter",
                                                            "code": "Enter",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 0.5
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowUp",
                                                            "code": "ArrowUp",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowUp",
                                                            "code": "ArrowUp",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 0.5
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "Escape",
                                                            "code": "Escape",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 2.5
                                                        },
                                                        {
                                                            "type": "input",
                                                            "input": "= <reactInspector.TableInspector data={monthEntries} />"
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 1
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "Enter",
                                                            "code": "Enter",
                                                            "ctrlKey": false,
                                                            "metaKey": true,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowDown",
                                                            "code": "ArrowDown",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowDown",
                                                            "code": "ArrowDown",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowDown",
                                                            "code": "ArrowDown",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowDown",
                                                            "code": "ArrowDown",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowDown",
                                                            "code": "ArrowDown",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowDown",
                                                            "code": "ArrowDown",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 2
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "Enter",
                                                            "code": "Enter",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 0.5
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowDown",
                                                            "code": "ArrowDown",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowDown",
                                                            "code": "ArrowDown",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowDown",
                                                            "code": "ArrowDown",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 0.5
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "Escape",
                                                            "code": "Escape",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 1
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "Escape",
                                                            "code": "Escape",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 0.5
                                                        },
                                                        {
                                                            "type": "script",
                                                            "name": "jumpEnd"
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 0.5
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "Enter",
                                                            "code": "Enter",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 1
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowDown",
                                                            "code": "ArrowDown",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 0.5
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": " ",
                                                            "code": "Space",
                                                            "ctrlKey": true,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "input",
                                                            "input": "."
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 0.5
                                                        },
                                                        {
                                                            "type": "script",
                                                            "name": "jumpEnd"
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 0.5
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "Enter",
                                                            "code": "Enter",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 1
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowDown",
                                                            "code": "ArrowDown",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 0.5
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowDown",
                                                            "code": "ArrowDown",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 0.5
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowDown",
                                                            "code": "ArrowDown",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 0.5
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": " ",
                                                            "code": "Space",
                                                            "ctrlKey": true,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 0.5
                                                        },
                                                        {
                                                            "type": "input",
                                                            "input": "= $`Working Hours`."
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "Enter",
                                                            "code": "Enter",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 0.5
                                                        },
                                                        {
                                                            "type": "input",
                                                            "input": "## Working Hours"
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "Enter",
                                                            "code": "Enter",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "Enter",
                                                            "code": "Enter",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "Enter",
                                                            "code": "Enter",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 1
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowLeft",
                                                            "code": "ArrowLeft",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 0.5
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "Escape",
                                                            "code": "Escape",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 0.5
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "Escape",
                                                            "code": "Escape",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 1
                                                        },
                                                        {
                                                            "type": "input",
                                                            "input": "\n  charts: { weeks: weekChart, months: monthsChart },"
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowLeft",
                                                            "code": "ArrowLeft",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowLeft",
                                                            "code": "ArrowLeft",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowLeft",
                                                            "code": "ArrowLeft",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 0.5
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "Enter",
                                                            "code": "Enter",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 0.5
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowDown",
                                                            "code": "ArrowDown",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowDown",
                                                            "code": "ArrowDown",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowDown",
                                                            "code": "ArrowDown",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowDown",
                                                            "code": "ArrowDown",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowDown",
                                                            "code": "ArrowDown",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowDown",
                                                            "code": "ArrowDown",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowDown",
                                                            "code": "ArrowDown",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 1
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "Escape",
                                                            "code": "Escape",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 1
                                                        },
                                                        {
                                                            "type": "input",
                                                            "input": "weekChart"
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 0.5
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "R",
                                                            "code": "KeyR",
                                                            "ctrlKey": true,
                                                            "metaKey": false,
                                                            "shiftKey": true,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 1
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowDown",
                                                            "code": "ArrowDown",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowDown",
                                                            "code": "ArrowDown",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowDown",
                                                            "code": "ArrowDown",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowDown",
                                                            "code": "ArrowDown",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 1
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "Enter",
                                                            "code": "Enter",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 0.5
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowDown",
                                                            "code": "ArrowDown",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowDown",
                                                            "code": "ArrowDown",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 2
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowLeft",
                                                            "code": "ArrowLeft",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 1
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowLeft",
                                                            "code": "ArrowLeft",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 0.5
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "Escape",
                                                            "code": "Escape",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 1.5
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowDown",
                                                            "code": "ArrowDown",
                                                            "ctrlKey": false,
                                                            "metaKey": true,
                                                            "shiftKey": false,
                                                            "altKey": true
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 1
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowDown",
                                                            "code": "ArrowDown",
                                                            "ctrlKey": false,
                                                            "metaKey": true,
                                                            "shiftKey": false,
                                                            "altKey": true
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 0.5
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "Escape",
                                                            "code": "Escape",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 0.5
                                                        },
                                                        {
                                                            "type": "input",
                                                            "input": "= 500"
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "Backspace",
                                                            "code": "Backspace",
                                                            "ctrlKey": false,
                                                            "metaKey": true,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 0.5
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "Enter",
                                                            "code": "Enter",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowDown",
                                                            "code": "ArrowDown",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowDown",
                                                            "code": "ArrowDown",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowDown",
                                                            "code": "ArrowDown",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "Enter",
                                                            "code": "Enter",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 0.5
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowUp",
                                                            "code": "ArrowUp",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 0.5
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "Escape",
                                                            "code": "Escape",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 1
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowUp",
                                                            "code": "ArrowUp",
                                                            "ctrlKey": true,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": true
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 1
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "m",
                                                            "code": "KeyM",
                                                            "ctrlKey": true,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 1
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowDown",
                                                            "code": "ArrowDown",
                                                            "ctrlKey": true,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": true
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 0.5
                                                        },
                                                        {
                                                            "type": "input",
                                                            "input": "balance"
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 0.5
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "Backspace",
                                                            "code": "Backspace",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "Backspace",
                                                            "code": "Backspace",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "Backspace",
                                                            "code": "Backspace",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "Backspace",
                                                            "code": "Backspace",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "Backspace",
                                                            "code": "Backspace",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "Backspace",
                                                            "code": "Backspace",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowLeft",
                                                            "code": "ArrowLeft",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowLeft",
                                                            "code": "ArrowLeft",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowUp",
                                                            "code": "ArrowUp",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowUp",
                                                            "code": "ArrowUp",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowUp",
                                                            "code": "ArrowUp",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowUp",
                                                            "code": "ArrowUp",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowUp",
                                                            "code": "ArrowUp",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowUp",
                                                            "code": "ArrowUp",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowUp",
                                                            "code": "ArrowUp",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowUp",
                                                            "code": "ArrowUp",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowUp",
                                                            "code": "ArrowUp",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowUp",
                                                            "code": "ArrowUp",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowUp",
                                                            "code": "ArrowUp",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowRight",
                                                            "code": "ArrowRight",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowUp",
                                                            "code": "ArrowUp",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 0.5
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowDown",
                                                            "code": "ArrowDown",
                                                            "ctrlKey": true,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": true
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 0.5
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "Enter",
                                                            "code": "Enter",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 0.5
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "m",
                                                            "code": "KeyM",
                                                            "ctrlKey": true,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 1
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowDown",
                                                            "code": "ArrowDown",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowDown",
                                                            "code": "ArrowDown",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowDown",
                                                            "code": "ArrowDown",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowDown",
                                                            "code": "ArrowDown",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowDown",
                                                            "code": "ArrowDown",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowDown",
                                                            "code": "ArrowDown",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowDown",
                                                            "code": "ArrowDown",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowDown",
                                                            "code": "ArrowDown",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 1
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "Enter",
                                                            "code": "Enter",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 0.5
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowDown",
                                                            "code": "ArrowDown",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 0.5
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowDown",
                                                            "code": "ArrowDown",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 0.5
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowDown",
                                                            "code": "ArrowDown",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 1
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": " ",
                                                            "code": "Space",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 0.5
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowDown",
                                                            "code": "ArrowDown",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 0.5
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowDown",
                                                            "code": "ArrowDown",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 0.5
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowDown",
                                                            "code": "ArrowDown",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 0.5
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowDown",
                                                            "code": "ArrowDown",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 1
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "Escape",
                                                            "code": "Escape",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "Escape",
                                                            "code": "Escape",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 1
                                                        },
                                                        {
                                                            "type": "script",
                                                            "name": "jumpEnd"
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 0.5
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "Enter",
                                                            "code": "Enter",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 1
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowDown",
                                                            "code": "ArrowDown",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 1
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowDown",
                                                            "code": "ArrowDown",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 1
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": " ",
                                                            "code": "Space",
                                                            "ctrlKey": true,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 0.5
                                                        },
                                                        {
                                                            "type": "input",
                                                            "input": "."
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 0.5
                                                        },
                                                        {
                                                            "type": "script",
                                                            "name": "jumpEnd"
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 0.5
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "Enter",
                                                            "code": "Enter",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 1
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "ArrowDown",
                                                            "code": "ArrowDown",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 1
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": " ",
                                                            "code": "Space",
                                                            "ctrlKey": true,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 0.5
                                                        },
                                                        {
                                                            "type": "input",
                                                            "input": "."
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 1
                                                        },
                                                        {
                                                            "type": "input",
                                                            "input": "= Finances"
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "Enter",
                                                            "code": "Enter",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 1
                                                        },
                                                        {
                                                            "type": "input",
                                                            "input": "## Income"
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "Enter",
                                                            "code": "Enter",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 0.5
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "Enter",
                                                            "code": "Enter",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        },
                                                        {
                                                            "type": "pause",
                                                            "duration": 0.5
                                                        },
                                                        {
                                                            "type": "key",
                                                            "key": "Enter",
                                                            "code": "Enter",
                                                            "ctrlKey": false,
                                                            "metaKey": false,
                                                            "shiftKey": false,
                                                            "altKey": false
                                                        }
                                                    ]
                                                }
                                            }
                                        }
                                    },
                                    {
                                        "id": 7,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "wide",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "= demo",
                                            "note": {
                                                "type": "expr",
                                                "code": " demo"
                                            }
                                        }
                                    },
                                    {
                                        "id": 17,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "wide",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 16,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "wide",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 14,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "wide",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "## Viewer",
                                            "note": {
                                                "type": "text",
                                                "tag": "h2",
                                                "text": "Viewer"
                                            }
                                        }
                                    },
                                    {
                                        "id": 15,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "wide",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "Loads the demo from GitHub and shows it.",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": "Loads the demo from GitHub and shows it."
                                            }
                                        }
                                    },
                                    {
                                        "id": 8,
                                        "name": "",
                                        "visibility": "result",
                                        "width": "wide",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "/Code",
                                            "note": {
                                                "type": "block",
                                                "isInstantiated": true,
                                                "code": "Code",
                                                "state": "async function loadRecording() {\n  const recordingUrl = 'https://raw.githubusercontent.com/keenbug/ReSheet/main/examples/demo-recording.json'\n  const [obj, store] = await (await fetch(recordingUrl)).json()\n  return utils.deduper.dup(obj, store)\n}\n\n<RecordingLoader loadRecording={loadRecording} startJson={demoTemplate} block={ReSheetBlock} checkEvery={5} scripts={scripts} />"
                                            }
                                        }
                                    }
                                ]
                            }
                        },
                        "isCollapsed": true,
                        "children": [
                            {
                                "id": 13,
                                "name": "- Disclaimer -",
                                "state": {
                                    "t": "resheet.selector",
                                    "v": 0,
                                    "mode": "run",
                                    "expr": "SheetOf(Note)",
                                    "inner": {
                                        "t": "resheet.sheet",
                                        "v": 2,
                                        "lines": [
                                            {
                                                "id": 0,
                                                "name": "",
                                                "visibility": "block",
                                                "width": "narrow",
                                                "state": {
                                                    "t": "resheet.note",
                                                    "v": 1,
                                                    "level": 0,
                                                    "input": "# Disclaimer",
                                                    "note": {
                                                        "type": "text",
                                                        "tag": "h1",
                                                        "text": "Disclaimer"
                                                    }
                                                }
                                            },
                                            {
                                                "id": 1,
                                                "name": "",
                                                "visibility": "block",
                                                "width": "narrow",
                                                "state": {
                                                    "t": "resheet.note",
                                                    "v": 1,
                                                    "level": 0,
                                                    "input": "The code for creating and playing demos is rather hacky. I've already been working longer on it than I intended and just wanted to get it done. Maybe at some time I'll document and refactor it a little.",
                                                    "note": {
                                                        "type": "text",
                                                        "tag": "p",
                                                        "text": "The code for creating and playing demos is rather hacky. I've already been working longer on it than I intended and just wanted to get it done. Maybe at some time I'll document and refactor it a little."
                                                    }
                                                }
                                            }
                                        ]
                                    }
                                },
                                "isCollapsed": false,
                                "children": []
                            },
                            {
                                "id": 12,
                                "name": "utils",
                                "state": {
                                    "t": "resheet.selector",
                                    "v": 0,
                                    "mode": "run",
                                    "expr": "SheetOf(Note)",
                                    "inner": {
                                        "t": "resheet.sheet",
                                        "v": 2,
                                        "lines": [
                                            {
                                                "id": 0,
                                                "name": "",
                                                "visibility": "block",
                                                "width": "narrow",
                                                "state": {
                                                    "t": "resheet.note",
                                                    "v": 1,
                                                    "level": 0,
                                                    "input": "# Utils",
                                                    "note": {
                                                        "type": "text",
                                                        "tag": "h1",
                                                        "text": "Utils"
                                                    }
                                                }
                                            },
                                            {
                                                "id": 1,
                                                "name": "",
                                                "visibility": "block",
                                                "width": "narrow",
                                                "state": {
                                                    "t": "resheet.note",
                                                    "v": 1,
                                                    "level": 0,
                                                    "input": "",
                                                    "note": {
                                                        "type": "text",
                                                        "tag": "p",
                                                        "text": ""
                                                    }
                                                }
                                            },
                                            {
                                                "id": 3,
                                                "name": "reactTriggerChange",
                                                "visibility": "block",
                                                "width": "narrow",
                                                "state": {
                                                    "t": "resheet.note",
                                                    "v": 1,
                                                    "level": 0,
                                                    "input": "= import('https://esm.sh/react-trigger-change?external=react')",
                                                    "note": {
                                                        "type": "expr",
                                                        "code": " import('https://esm.sh/react-trigger-change?external=react')"
                                                    }
                                                }
                                            },
                                            {
                                                "id": 4,
                                                "name": "",
                                                "visibility": "block",
                                                "width": "narrow",
                                                "state": {
                                                    "t": "resheet.note",
                                                    "v": 1,
                                                    "level": 0,
                                                    "input": "",
                                                    "note": {
                                                        "type": "text",
                                                        "tag": "p",
                                                        "text": ""
                                                    }
                                                }
                                            },
                                            {
                                                "id": 5,
                                                "name": "findContentEditable",
                                                "visibility": "block",
                                                "width": "narrow",
                                                "state": {
                                                    "t": "resheet.note",
                                                    "v": 1,
                                                    "level": 0,
                                                    "input": "/Code",
                                                    "note": {
                                                        "type": "block",
                                                        "isInstantiated": true,
                                                        "code": "Code",
                                                        "state": "function findContentEditable(node) {\n  if (!node) {\n    return null\n  }\n  else if (!node.parentElement) {\n    return node\n  }\n  else if (node.parentElement.isContentEditable) {\n    return findContentEditable(node.parentElement)\n  }\n  else {\n    return node\n  }\n}  "
                                                    }
                                                }
                                            },
                                            {
                                                "id": 6,
                                                "name": "findElement",
                                                "visibility": "block",
                                                "width": "narrow",
                                                "state": {
                                                    "t": "resheet.note",
                                                    "v": 1,
                                                    "level": 0,
                                                    "input": "/Code",
                                                    "note": {
                                                        "type": "block",
                                                        "isInstantiated": true,
                                                        "code": "Code",
                                                        "state": "function findElement(node) {\n  if (node instanceof Element) {\n    return node\n  }\n  else {\n    return node.parentElement\n  }\n}"
                                                    }
                                                }
                                            },
                                            {
                                                "id": 7,
                                                "name": "",
                                                "visibility": "block",
                                                "width": "narrow",
                                                "state": {
                                                    "t": "resheet.note",
                                                    "v": 1,
                                                    "level": 0,
                                                    "input": "",
                                                    "note": {
                                                        "type": "text",
                                                        "tag": "p",
                                                        "text": ""
                                                    }
                                                }
                                            },
                                            {
                                                "id": 8,
                                                "name": "",
                                                "visibility": "block",
                                                "width": "narrow",
                                                "state": {
                                                    "t": "resheet.note",
                                                    "v": 1,
                                                    "level": 0,
                                                    "input": "",
                                                    "note": {
                                                        "type": "text",
                                                        "tag": "p",
                                                        "text": ""
                                                    }
                                                }
                                            },
                                            {
                                                "id": 9,
                                                "name": "",
                                                "visibility": "block",
                                                "width": "narrow",
                                                "state": {
                                                    "t": "resheet.note",
                                                    "v": 1,
                                                    "level": 0,
                                                    "input": "---",
                                                    "note": {
                                                        "type": "text",
                                                        "tag": "p",
                                                        "text": "---"
                                                    }
                                                }
                                            },
                                            {
                                                "id": 2,
                                                "name": "exports",
                                                "visibility": "block",
                                                "width": "narrow",
                                                "state": {
                                                    "t": "resheet.note",
                                                    "v": 1,
                                                    "level": 0,
                                                    "input": "/Code",
                                                    "note": {
                                                        "type": "block",
                                                        "isInstantiated": true,
                                                        "code": "Code",
                                                        "state": "({\n  reactTriggerChange: reactTriggerChange.default,\n  findContentEditable,\n  findElement,\n  deduper,\n  renderKey,\n})"
                                                    }
                                                }
                                            }
                                        ]
                                    }
                                },
                                "isCollapsed": true,
                                "children": [
                                    {
                                        "id": 0,
                                        "name": "deduper",
                                        "state": {
                                            "t": "resheet.selector",
                                            "v": 0,
                                            "mode": "run",
                                            "expr": "SheetOf(Note)",
                                            "inner": {
                                                "t": "resheet.sheet",
                                                "v": 2,
                                                "lines": [
                                                    {
                                                        "id": 0,
                                                        "name": "",
                                                        "visibility": "block",
                                                        "width": "narrow",
                                                        "state": {
                                                            "t": "resheet.note",
                                                            "v": 1,
                                                            "level": 0,
                                                            "input": "# Deduper",
                                                            "note": {
                                                                "type": "text",
                                                                "tag": "h1",
                                                                "text": "Deduper"
                                                            }
                                                        }
                                                    },
                                                    {
                                                        "id": 1,
                                                        "name": "",
                                                        "visibility": "block",
                                                        "width": "narrow",
                                                        "state": {
                                                            "t": "resheet.note",
                                                            "v": 1,
                                                            "level": 0,
                                                            "input": "Deduplicates an Object structure.",
                                                            "note": {
                                                                "type": "text",
                                                                "tag": "p",
                                                                "text": "Deduplicates an Object structure."
                                                            }
                                                        }
                                                    },
                                                    {
                                                        "id": 2,
                                                        "name": "",
                                                        "visibility": "block",
                                                        "width": "narrow",
                                                        "state": {
                                                            "t": "resheet.note",
                                                            "v": 1,
                                                            "level": 0,
                                                            "input": "",
                                                            "note": {
                                                                "type": "text",
                                                                "tag": "p",
                                                                "text": ""
                                                            }
                                                        }
                                                    },
                                                    {
                                                        "id": 5,
                                                        "name": "deduper",
                                                        "visibility": "block",
                                                        "width": "narrow",
                                                        "state": {
                                                            "t": "resheet.note",
                                                            "v": 1,
                                                            "level": 0,
                                                            "input": "/blocks.JSExpr",
                                                            "note": {
                                                                "type": "block",
                                                                "isInstantiated": true,
                                                                "code": "blocks.JSExpr",
                                                                "state": "function sortObj(obj) {\n  return Object.fromEntries(Object.entries(obj).sort())\n}\n\nfunction dedup(input, store = [], lookup = new Map()) {\n  if (Array.isArray(input)) {\n    const output = input.map(value => dedup(value, store, lookup)[0])\n    const hash = JSON.stringify(output)\n    const existingId = lookup.get(hash)\n    if (existingId) {\n      return [{$: existingId}, store]\n    }\n    else {\n      const id = store.length\n      store.push(output)\n      lookup.set(hash, id)\n      return [{$: id}, store]\n    }\n  }\n  else if (typeof input === 'object') {\n    const output = lodash.mapValues(input, value =>\n      dedup(value, store, lookup)[0]\n    )\n    const hash = JSON.stringify(sortObj(output))\n    const existingId = lookup.get(hash)\n    if (existingId) {\n      return [{$: existingId}, store]\n    }\n    else {\n      const id = store.length\n      store.push(output)\n      lookup.set(hash, id)\n      return [{$: id}, store]\n    }\n  }\n  else if (typeof input === 'string' && input.length > 100) {\n    const hash = JSON.stringify(input)\n    const existingId = lookup.get(hash)\n    if (existingId) {\n      return [{$: existingId}, store]\n    }\n    else {\n      const id = store.length\n      store.push(input)\n      lookup.set(hash, id)\n      return [{$: id}, store]\n    }\n  }\n  else {\n    return [input, store]\n  }\n}\n\nfunction dup(input, store, memo = new Map()) {\n  if (typeof input === 'object') {\n    if (memo.has(input.$)) { return memo.get(input.$) }\n    \n    let out = store[input.$]\n    \n    if (Array.isArray(out)) {\n      out = out.map(value => dup(value, store, memo))\n    }\n    else if (typeof out === 'object') {\n      out = lodash.mapValues(out, value => dup(value, store, memo))\n    }\n    \n    memo.set(input.$, out)\n    return out\n  }\n  else {\n    return input\n  }\n}\n\nreturn { dup, dedup }"
                                                            }
                                                        }
                                                    }
                                                ]
                                            }
                                        },
                                        "isCollapsed": false,
                                        "children": []
                                    },
                                    {
                                        "id": 1,
                                        "name": "renderKey",
                                        "state": {
                                            "t": "resheet.selector",
                                            "v": 0,
                                            "mode": "run",
                                            "expr": "SheetOf(Note)",
                                            "inner": {
                                                "t": "resheet.sheet",
                                                "v": 2,
                                                "lines": [
                                                    {
                                                        "id": 4,
                                                        "name": "",
                                                        "visibility": "block",
                                                        "width": "narrow",
                                                        "state": {
                                                            "t": "resheet.note",
                                                            "v": 1,
                                                            "level": 0,
                                                            "input": "# Render Key",
                                                            "note": {
                                                                "type": "text",
                                                                "tag": "h1",
                                                                "text": "Render Key"
                                                            }
                                                        }
                                                    },
                                                    {
                                                        "id": 5,
                                                        "name": "",
                                                        "visibility": "block",
                                                        "width": "narrow",
                                                        "state": {
                                                            "t": "resheet.note",
                                                            "v": 1,
                                                            "level": 0,
                                                            "input": "Render a key combination with symbols.",
                                                            "note": {
                                                                "type": "text",
                                                                "tag": "p",
                                                                "text": "Render a key combination with symbols."
                                                            }
                                                        }
                                                    },
                                                    {
                                                        "id": 6,
                                                        "name": "",
                                                        "visibility": "block",
                                                        "width": "narrow",
                                                        "state": {
                                                            "t": "resheet.note",
                                                            "v": 1,
                                                            "level": 0,
                                                            "input": "",
                                                            "note": {
                                                                "type": "text",
                                                                "tag": "p",
                                                                "text": ""
                                                            }
                                                        }
                                                    },
                                                    {
                                                        "id": 0,
                                                        "name": "renderKey",
                                                        "visibility": "block",
                                                        "width": "narrow",
                                                        "state": {
                                                            "t": "resheet.note",
                                                            "v": 1,
                                                            "level": 0,
                                                            "input": "/Code",
                                                            "note": {
                                                                "type": "block",
                                                                "isInstantiated": true,
                                                                "code": "Code",
                                                                "state": 'const keyMappings = {\n  ArrowUp: <FontAwesomeIcon icon={faSolid.faArrowUp} />,\n  ArrowDown: <FontAwesomeIcon icon={faSolid.faArrowDown} />,\n  ArrowLeft: <FontAwesomeIcon icon={faSolid.faArrowLeft} />,\n  ArrowRight: <FontAwesomeIcon icon={faSolid.faArrowRight} />,\n  Backspace: <FontAwesomeIcon icon={faSolid.faDeleteLeft} className="text-gray-600" />,\n  " ": "Space",\n  "Enter": "\u23CE",\n}\n\nfunction mapKey(key) {\n  return keyMappings[key] ?? key\n}\n\nfunction renderKey(comp) {\n  if (typeof comp === \'string\') {\n    return comp.length > 1 ? mapKey(comp) : mapKey(comp.toUpperCase())\n  }\n  \n  const {key, ctrlKey, metaKey, shiftKey, altKey} = comp\n  return [\n    (ctrlKey || metaKey) && "\u2318",\n    altKey && "\u2325",\n    shiftKey && "\u21E7",\n    key.length > 1 ? mapKey(key) : mapKey(key.toUpperCase()),\n  ]\n}'
                                                            }
                                                        }
                                                    },
                                                    {
                                                        "id": 1,
                                                        "name": "",
                                                        "visibility": "block",
                                                        "width": "narrow",
                                                        "state": {
                                                            "t": "resheet.note",
                                                            "v": 1,
                                                            "level": 0,
                                                            "input": "",
                                                            "note": {
                                                                "type": "text",
                                                                "tag": "p",
                                                                "text": ""
                                                            }
                                                        }
                                                    },
                                                    {
                                                        "id": 3,
                                                        "name": "",
                                                        "visibility": "block",
                                                        "width": "narrow",
                                                        "state": {
                                                            "t": "resheet.note",
                                                            "v": 1,
                                                            "level": 0,
                                                            "input": "### Testing Ground",
                                                            "note": {
                                                                "type": "text",
                                                                "tag": "h3",
                                                                "text": "Testing Ground"
                                                            }
                                                        }
                                                    },
                                                    {
                                                        "id": 2,
                                                        "name": "",
                                                        "visibility": "result",
                                                        "width": "narrow",
                                                        "state": {
                                                            "t": "resheet.note",
                                                            "v": 1,
                                                            "level": 0,
                                                            "input": "/Code",
                                                            "note": {
                                                                "type": "block",
                                                                "isInstantiated": true,
                                                                "code": "Code",
                                                                "state": 'function TestKey() {\n  const [key, setKey] = React.useState()\n  \n  return (\n    <div>\n      <input\n        className="w-full"\n        value=""\n        placeholder="Type a key (combination)"\n        onKeyDown={ev => {\n          ev.stopPropagation()\n          ev.preventDefault()\n          setKey(ev)\n        }}\n        />\n      {key && <span className="text-5xl">{renderKey(key)}</span>}\n    </div>\n  )\n}\n\n<TestKey />'
                                                            }
                                                        }
                                                    },
                                                    {
                                                        "id": 7,
                                                        "name": "",
                                                        "visibility": "block",
                                                        "width": "narrow",
                                                        "state": {
                                                            "t": "resheet.note",
                                                            "v": 1,
                                                            "level": 0,
                                                            "input": "",
                                                            "note": {
                                                                "type": "text",
                                                                "tag": "p",
                                                                "text": ""
                                                            }
                                                        }
                                                    },
                                                    {
                                                        "id": 8,
                                                        "name": "",
                                                        "visibility": "block",
                                                        "width": "narrow",
                                                        "state": {
                                                            "t": "resheet.note",
                                                            "v": 1,
                                                            "level": 0,
                                                            "input": "",
                                                            "note": {
                                                                "type": "text",
                                                                "tag": "p",
                                                                "text": ""
                                                            }
                                                        }
                                                    },
                                                    {
                                                        "id": 9,
                                                        "name": "",
                                                        "visibility": "block",
                                                        "width": "narrow",
                                                        "state": {
                                                            "t": "resheet.note",
                                                            "v": 1,
                                                            "level": 0,
                                                            "input": "---",
                                                            "note": {
                                                                "type": "text",
                                                                "tag": "p",
                                                                "text": "---"
                                                            }
                                                        }
                                                    },
                                                    {
                                                        "id": 10,
                                                        "name": "exports",
                                                        "visibility": "block",
                                                        "width": "narrow",
                                                        "state": {
                                                            "t": "resheet.note",
                                                            "v": 1,
                                                            "level": 0,
                                                            "input": "= renderKey",
                                                            "note": {
                                                                "type": "expr",
                                                                "code": " renderKey"
                                                            }
                                                        }
                                                    }
                                                ]
                                            }
                                        },
                                        "isCollapsed": false,
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": 9,
                                "name": "DemoViewer",
                                "state": {
                                    "t": "resheet.selector",
                                    "v": 0,
                                    "mode": "run",
                                    "expr": "SheetOf(Note)",
                                    "inner": {
                                        "t": "resheet.sheet",
                                        "v": 2,
                                        "lines": [
                                            {
                                                "id": 3,
                                                "name": "",
                                                "visibility": "block",
                                                "width": "wide",
                                                "state": {
                                                    "t": "resheet.note",
                                                    "v": 1,
                                                    "level": 0,
                                                    "input": "# Demo Viewer",
                                                    "note": {
                                                        "type": "text",
                                                        "tag": "h1",
                                                        "text": "Demo Viewer"
                                                    }
                                                }
                                            },
                                            {
                                                "id": 4,
                                                "name": "",
                                                "visibility": "block",
                                                "width": "wide",
                                                "state": {
                                                    "t": "resheet.note",
                                                    "v": 1,
                                                    "level": 0,
                                                    "input": "View a demo with Block `block` and the script `demo` containing the demo's steps.",
                                                    "note": {
                                                        "type": "text",
                                                        "tag": "p",
                                                        "text": "View a demo with Block `block` and the script `demo` containing the demo's steps."
                                                    }
                                                }
                                            },
                                            {
                                                "id": 5,
                                                "name": "",
                                                "visibility": "block",
                                                "width": "wide",
                                                "state": {
                                                    "t": "resheet.note",
                                                    "v": 1,
                                                    "level": 0,
                                                    "input": "",
                                                    "note": {
                                                        "type": "text",
                                                        "tag": "p",
                                                        "text": ""
                                                    }
                                                }
                                            },
                                            {
                                                "id": 1,
                                                "name": "useScript",
                                                "visibility": "result",
                                                "width": "wide",
                                                "state": {
                                                    "t": "resheet.note",
                                                    "v": 1,
                                                    "level": 0,
                                                    "input": "/Code",
                                                    "note": {
                                                        "type": "block",
                                                        "isInstantiated": true,
                                                        "code": "Code",
                                                        "state": "function useScript(script) {\n  async function runScript() {\n    await script({ wait, interrupt, interval })\n    setStopped('finished')\n    stopped.current = true\n    continuation.current = runScript\n  }\n  \n  const [isStopped, setStopped] = React.useState('init')\n  const stopped = React.useRef(true)\n  const continuation = React.useRef(runScript)\n  const stopper = React.useRef(() => {})\n  \n  if (isStopped === 'init') {\n    continuation.current = runScript\n  }\n  \n  function wait(sec) {\n    return new Promise(resolve => {\n      continuation.current = resolve\n      if (!stopped.current) {\n        const timeout = setTimeout(\n          () => {\n            if (!stopped.current) {\n              resolve()\n            }\n          },\n          sec * 1000,\n        )\n        stopper.current = () => {\n          clearTimeout(timeout)\n        }\n      }\n    })\n  }\n  \n  function interval(fn, ms) {\n    setTimeout(() => {\n      if (!stopped.current) {\n        fn()\n        interval(fn, ms)\n      }\n    }, ms)\n  }\n  \n  function interrupt(reason='paused') {\n    return new Promise(resolve => {\n      setStopped(reason)\n      stopped.current = true\n      continuation.current = resolve\n    })\n  }\n  \n  return {\n    stop(reason='paused') {\n      setStopped(reason)\n      if (!stopped.current) {\n        stopped.current = true\n        stopper.current()\n      }\n    },\n    \n    start() {\n      setStopped(false)\n      if (stopped.current) {\n        stopped.current = false\n        continuation.current()\n      }\n    },\n    \n    reset() {\n      setStopped('init')\n      continuation.current = runScript\n      if (!stopped.current) {\n        stopped.current = true\n        stopper.current()\n      }\n    },\n    \n    isRunning: !isStopped,\n    stopped: isStopped,\n    stoppedRef: stopped,\n  }\n}"
                                                    }
                                                }
                                            },
                                            {
                                                "id": 2,
                                                "name": "DemoViewer",
                                                "visibility": "block",
                                                "width": "wide",
                                                "state": {
                                                    "t": "resheet.note",
                                                    "v": 1,
                                                    "level": 0,
                                                    "input": "/Code",
                                                    "note": {
                                                        "type": "block",
                                                        "isInstantiated": true,
                                                        "code": "Code",
                                                        "state": "const { safeBlock } = resheet.blocks.component\n\nconst btn = \"w-full rounded py-1 bg-blue-50 hover:bg-blue-100\"\n\nconst env = library\nconst input = [{ env }]\n\nfunction ControlButton({ onClick, icon }) {\n  return (\n    <button\n      className=\"text-5xl mx-5 text-yellow-400 hover:text-yellow-500 drop-shadow-xl\"\n      onPointerDown={ev => ev.preventDefault()} // prevent changing focus\n      onClick={onClick}\n    >\n      <FontAwesomeIcon icon={icon} />\n    </button>\n  )\n}\n\nfunction DemoViewer({ startJson, block, demo, speeds = [0.75, 1, 1.25] }) {\n  const Block = React.useMemo(() => safeBlock(block), [block])\n\n  const [init, dispatchInit] = resheet.core.block.useBlockDispatcher(Block.init, input)\n  const [state, dispatch] = resheet.core.block.useBlockDispatcher(null, input)\n  const stateRef = React.useRef(state)\n  \n  const updateInit = React.useCallback(\n    lodash.debounce(\n      state => dispatch(() => ({ state })),\n      1000,\n    ),\n    [],\n  ) \n  \n  React.useEffect(() => {\n    stateRef.current = state\n  }, [state])\n  \n  React.useEffect(() => {\n    if (startJson) {\n      dispatchInit(() => ({\n        state: Block.fromJSON(startJson, dispatchInit, env)\n      }))\n    }\n  }, [])\n  \n  React.useEffect(() => {\n    updateInit(init)\n  }, [init])\n  \n  const blockRef = React.useRef()\n  const containerRef = React.useRef()\n  \n  const blockHandle = {\n    focus(opts) {\n      blockRef.current?.focus(opts)\n    },\n    getState() {\n      return stateRef.current\n    },\n    dispatch(action) {\n      dispatch(action)\n    },\n  }\n\n  const [speed, setSpeed] = React.useState(1)\n  const speedRef = React.useRef(speed)\n  speedRef.current = speed\n  \n  const [keysUi, showKey] = useShowKeys()\n  const script = useScript(args => demo({ ...args, showKey, blockHandle, containerRef, speedRef }))\n  \n  const scale = (\n    window.innerWidth <= 768 && script.stopped !== 'edit' ?\n      0.75\n    :\n      1\n  )\n  \n  React.useEffect(() => () => script.stop('focus'), [])\n  \n  React.useEffect(() => {\n    if (!containerRef.current) { return }\n    const intersectionObserver = new IntersectionObserver(entries => {\n      if (entries[0].intersectionRatio <= 0) {\n        !script.stoppedRef.current && script.stop()\n      }\n    })\n    intersectionObserver.observe(containerRef.current)\n    return () => intersectionObserver.disconnect()\n  }, [containerRef.current])\n  \n  function restart() {\n    script.reset()\n    dispatch(() => {\n      setTimeout(script.start)\n      return { state: init }\n    })\n  }\n  \n  return (\n    <>\n      <div\n        className=\"relative w-full h-[70vh] rounded-lg border border-gray-100 bg-white shadow-lg overflow-hidden\"\n      >\n        <div\n          ref={containerRef}\n          className={`\n            w-[${100 / scale}%] h-[${100 / scale}%]\n            origin-top-left scale-[${scale}]\n            ${script.stopped !== 'edit' && 'pointer-events-none'}\n          `}\n          onFocus={ev => {\n            const mode = script.stopped === 'edit' ? '' : 'none'\n            if (['INPUT', 'TEXTAREA'].includes(ev.target.tagName)) {\n              ev.target.inputMode = mode\n            }\n            else if (ev.target.isContentEditable) {\n              const container = utils.findContentEditable(ev.target)\n              container.inputMode = mode\n            }\n          }}\n          onBlur={ev => {\n            if (!ev.currentTarget.contains(ev.relatedTarget)) {\n              script.stopped !== 'edit' && script.stop('focus')\n            }\n          }}\n          onKeyDownCapture={ev => {\n            if (ev.isTrusted && script.stopped !== 'edit') {\n              ev.stopPropagation()\n              ev.preventDefault()\n              switch (ev.key) {\n                case \" \":\n                  if (script.isRunning) {\n                    script.stop()\n                  }\n                  else {\n                    script.start()\n                  }\n                  break\n                  \n                case \"0\":\n                  script.reset()\n                  dispatch(() => ({ state: init }))\n                  break\n                  \n                case \"e\":\n                  script.stop('edit')\n                  break\n              }\n            }\n          }}\n          onKeyDown={ev => {\n            ev.stopPropagation()\n          }}\n        >\n          {state !== null &&\n            <Block.Component ref={blockRef} state={state} dispatch={dispatch} env={env} />\n          }\n        </div>\n        <div className=\"absolute top-1/4 left-1/2\">\n          {keysUi}\n        </div>\n        {state === null &&\n          <div className=\"absolute inset-0 flex items-center justify-center text-yellow-400 text-5xl\">\n            <FontAwesomeIcon spinPulse icon={faSolid.faSpinner} />\n          </div>\n        }\n        <div\n          className={`\n            ${state === null && 'hidden'}\n            ${script.stopped === 'edit' && 'hidden'}\n            absolute inset-0 bg-white/50 hover:bg-white/75\n            flex flex-col justify-center items-center\n            transition\n            ${script.isRunning && 'opacity-0 cursor-pointer'}\n          `}\n          onPointerDown={ev => ev.preventDefault()} // prevent changing focus\n          onClick={ev => ev.currentTarget === ev.target && script.isRunning && script.stop()}\n        >\n          {!script.isRunning && script.stopped !== 'error' &&\n            <>\n              <div className=\"self-stretch flex flex-row items-center\">\n                <div className=\"flex-1 text-right\">\n                  {script.stopped !== 'init' &&\n                    <button\n                      className=\"text-2xl text-yellow-300 hover:text-yellow-400 drop-shadow\"\n                      onPointerDown={ev => ev.preventDefault()} // prevent changing focus\n                      onClick={() => {\n                        script.reset()\n                        dispatch(() => ({ state: init }))\n                      }}\n                    >\n                      <FontAwesomeIcon\n                        icon={faSolid.faBackwardStep}\n                        />\n                    </button>\n                  }\n                </div>\n                \n                {script.isRunning &&\n                  <ControlButton\n                    onClick={script.stop}\n                    icon={faSolid.faPause}\n                    />\n                }\n      \n                {(script.stopped === 'focus' || script.stopped === 'finished') ?\n                  <ControlButton\n                    onClick={restart}\n                    icon={faSolid.faRotateLeft}\n                    />\n                : (script.stopped === 'paused' || script.stopped === 'init') &&\n                  <ControlButton\n                    onClick={script.start}\n                    icon={faSolid.faPlay}\n                    />\n                }\n                \n                <div className=\"flex-1\" />\n              </div>\n              {script.stopped !== 'init' &&\n                <button\n                  className=\"mt-5 text-sm text-yellow-600 border border-zinc-100 bg-zinc-50 hover:bg-yellow-500 hover:text-white rounded-md px-2\"\n                  onClick={() => {\n                    script.stop('edit')\n                  }}\n                >\n                  start editing\n                </button>\n              }\n              <div className=\"absolute bottom-2 right-2 px-2 text-sm text-zinc-500 rounded bg-zinc-50 shadow\">\n                Playback speed: {}\n                {speeds.map(desiredSpeed => (\n                  <button\n                    key={desiredSpeed}\n                    className={`\n                      border-2 rounded-md px-2 mx-1\n                      ${desiredSpeed === speed ? 'border-yellow-500' : 'border-transparent hover:border-yellow-300'}\n                    `}\n                    onClick={() => setSpeed(desiredSpeed)}\n                  >\n                    {desiredSpeed}x\n                  </button>\n                ))}\n              </div>\n            </>\n          }\n          {script.stopped === 'error' &&\n            <>\n              <FontAwesomeIcon className=\"text-5xl text-red-500\" icon={faSolid.faTriangleExclamation} />\n              <h1 className=\"text-3xl text-red-800 my-2\">\n                There was an error during the execution of the demo\n              </h1>\n              <p className=\"text-lg text-red-700\">\n                The demo's actual state differs from its intended state.\n              </p>\n              <button\n                className=\"mt-3 text-sm text-yellow-600 border border-zinc-100 bg-zinc-50 hover:bg-yellow-500 hover:text-white rounded-md px-2\"\n                onClick={restart}\n              >\n                Try restarting it\n              </button>\n              <button\n                className=\"mt-5 text-sm text-yellow-600 border border-zinc-100 bg-zinc-50 hover:bg-yellow-500 hover:text-white rounded-md px-2\"\n                onClick={() => {\n                  script.stop('edit')\n                }}\n              >\n                start editing\n              </button>\n            </>\n          }\n        </div>\n        \n      </div>\n      {script.stopped === 'edit' &&\n        <button\n          className=\"block mx-auto mt-1 text-gray-400 hover:text-gray-700\"\n          onClick={() => {\n            dispatch(() => ({ state: init }))\n            script.reset()\n          }}\n        >\n          <FontAwesomeIcon icon={faSolid.faRotateLeft} /> {}\n          Reset demo\n        </button>\n      }\n    </>\n  )\n}"
                                                    }
                                                }
                                            }
                                        ]
                                    }
                                },
                                "isCollapsed": true,
                                "children": [
                                    {
                                        "id": 0,
                                        "name": "useShowKeys",
                                        "state": {
                                            "t": "resheet.selector",
                                            "v": 0,
                                            "mode": "run",
                                            "expr": "SheetOf(Note)",
                                            "inner": {
                                                "t": "resheet.sheet",
                                                "v": 2,
                                                "lines": [
                                                    {
                                                        "id": 3,
                                                        "name": "",
                                                        "visibility": "block",
                                                        "width": "wide",
                                                        "state": {
                                                            "t": "resheet.note",
                                                            "v": 1,
                                                            "level": 0,
                                                            "input": "# useShowKeys",
                                                            "note": {
                                                                "type": "text",
                                                                "tag": "h1",
                                                                "text": "useShowKeys"
                                                            }
                                                        }
                                                    },
                                                    {
                                                        "id": 4,
                                                        "name": "",
                                                        "visibility": "block",
                                                        "width": "wide",
                                                        "state": {
                                                            "t": "resheet.note",
                                                            "v": 1,
                                                            "level": 0,
                                                            "input": "Creates an overlay indicating a typed key during the demo.",
                                                            "note": {
                                                                "type": "text",
                                                                "tag": "p",
                                                                "text": "Creates an overlay indicating a typed key during the demo."
                                                            }
                                                        }
                                                    },
                                                    {
                                                        "id": 5,
                                                        "name": "",
                                                        "visibility": "block",
                                                        "width": "wide",
                                                        "state": {
                                                            "t": "resheet.note",
                                                            "v": 1,
                                                            "level": 0,
                                                            "input": "",
                                                            "note": {
                                                                "type": "text",
                                                                "tag": "p",
                                                                "text": ""
                                                            }
                                                        }
                                                    },
                                                    {
                                                        "id": 0,
                                                        "name": "KeyUI",
                                                        "visibility": "block",
                                                        "width": "wide",
                                                        "state": {
                                                            "t": "resheet.note",
                                                            "v": 1,
                                                            "level": 0,
                                                            "input": "/Code",
                                                            "note": {
                                                                "type": "block",
                                                                "isInstantiated": true,
                                                                "code": "Code",
                                                                "state": 'const { Transition } = headlessui\n\nfunction KeyUI({ id, show, comp, onFinished }) {\n    const [visible, setVisible] = React.useState(true)\n    \n    React.useEffect(() => {\n      const timeout = setTimeout(() => setVisible(false), 2000)\n      return () => clearTimeout(timeout)\n    }, [])\n\n    return (\n    <div className="absolute left-0 bottom-0 -translate-x-1/2">\n      <Transition\n          show={show && visible}\n          appear={true}\n          \n          className="text-3xl p-3 m-1 w-max rounded-lg border bg-white shadow-xl"\n          \n          enter="origin-bottom transition-[transform,opacity] duration-150 [transform-style:preserve-3d]"\n          enterFrom="opacity-0 [transform:perspective(100px)_rotateX(40deg)_translateZ(0px)]"\n          \n          leave="origin-bottom transition-[opacity,transform] duration-150 [transform-style:preserve-3d]"\n          leaveTo="opacity-0 [transform:perspective(100px)_rotateX(20deg)_translateZ(0px)]"\n          \n          afterLeave={onFinished}\n      >\n        {utils.renderKey(comp)}\n      </Transition>\n    </div>\n    )\n}\n'
                                                            }
                                                        }
                                                    },
                                                    {
                                                        "id": 1,
                                                        "name": "",
                                                        "visibility": "block",
                                                        "width": "wide",
                                                        "state": {
                                                            "t": "resheet.note",
                                                            "v": 1,
                                                            "level": 0,
                                                            "input": "",
                                                            "note": {
                                                                "type": "text",
                                                                "tag": "p",
                                                                "text": ""
                                                            }
                                                        }
                                                    },
                                                    {
                                                        "id": 2,
                                                        "name": "useShowKeys",
                                                        "visibility": "block",
                                                        "width": "wide",
                                                        "state": {
                                                            "t": "resheet.note",
                                                            "v": 1,
                                                            "level": 0,
                                                            "input": "/Code",
                                                            "note": {
                                                                "type": "block",
                                                                "isInstantiated": true,
                                                                "code": "Code",
                                                                "state": "function useShowKeys() {\n    const [keys, setKeys] = React.useState([])\n\n    const showKey = React.useCallback(function showKey(key) {\n        setKeys(current => [\n            {\n                id: 1 + (current[0]?.id ?? -1),\n                key,\n            },\n            ...current,\n        ])\n    }, [setKeys])\n\n    const removeKey = React.useCallback(function removeKey(id) {\n        setKeys(current => current.filter(key => key.id !== id))\n    }, [setKeys])\n\n    const ui = keys\n        .map(({ id, key }, index) => (\n            <KeyUI\n                key={id}\n                id={id}\n                show={index === 0}\n                comp={key}\n                onFinished={() => removeKey(id)}\n                />\n        ))\n        .reverse()\n\n    return [ui, showKey]\n}"
                                                            }
                                                        }
                                                    }
                                                ]
                                            }
                                        },
                                        "isCollapsed": false,
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": 10,
                                "name": "RecordingPlayer",
                                "state": {
                                    "t": "resheet.selector",
                                    "v": 0,
                                    "mode": "run",
                                    "expr": "SheetOf(Note)",
                                    "inner": {
                                        "t": "resheet.sheet",
                                        "v": 2,
                                        "lines": [
                                            {
                                                "id": 2,
                                                "name": "",
                                                "visibility": "block",
                                                "width": "wide",
                                                "state": {
                                                    "t": "resheet.note",
                                                    "v": 1,
                                                    "level": 0,
                                                    "input": "# Recording Player",
                                                    "note": {
                                                        "type": "text",
                                                        "tag": "h1",
                                                        "text": "Recording Player"
                                                    }
                                                }
                                            },
                                            {
                                                "id": 3,
                                                "name": "",
                                                "visibility": "block",
                                                "width": "wide",
                                                "state": {
                                                    "t": "resheet.note",
                                                    "v": 1,
                                                    "level": 0,
                                                    "input": "Play back a recording made with the Demo Recorder.",
                                                    "note": {
                                                        "type": "text",
                                                        "tag": "p",
                                                        "text": "Play back a recording made with the Demo Recorder."
                                                    }
                                                }
                                            },
                                            {
                                                "id": 4,
                                                "name": "",
                                                "visibility": "block",
                                                "width": "wide",
                                                "state": {
                                                    "t": "resheet.note",
                                                    "v": 1,
                                                    "level": 0,
                                                    "input": "",
                                                    "note": {
                                                        "type": "text",
                                                        "tag": "p",
                                                        "text": ""
                                                    }
                                                }
                                            },
                                            {
                                                "id": 1,
                                                "name": "RecordingPlayer",
                                                "visibility": "block",
                                                "width": "wide",
                                                "state": {
                                                    "t": "resheet.note",
                                                    "v": 1,
                                                    "level": 0,
                                                    "input": "/Code",
                                                    "note": {
                                                        "type": "block",
                                                        "isInstantiated": true,
                                                        "code": "Code",
                                                        "state": "// recording: Action[]\n// type Action =\n//   | { type: 'key', key: string, ctrlKey?: boolean, metaKey?: boolean, altKey?: boolean, shiftKey?: boolean }\n//   | { type: 'input', input: string }\n//   | { type: 'pause', duration: number }\n//   | { type: 'script', name: string }\n\nfunction RecordingPlayer({ startJson, block, recording, reportState, checkEvery=1, speeds, scripts={} }) {\n  const reportStateRef = React.useRef(reportState)\n  reportStateRef.current\n  \n  return (\n    <DemoViewer\n      startJson={startJson}\n      block={block}\n      speeds={speeds}\n      demo={async ({ wait, interrupt, interval, blockHandle, containerRef, showKey, speed=1, speedRef }) => {\n        // Script\n                \n        await wait(0.5)\n        \n        blockHandle.focus()\n        \n        await wait(0.5)\n        \n        \n        for (let position = recording.length - 1; position >= 0; position--) {\n          const action = recording[position]\n          switch (action.type) {\n            case 'key':\n              await typeKey(lodash.omit(action, 'type'))\n              break\n            \n            case 'input':\n              await typeText(action.input)\n              break\n              \n            case 'pause':\n              await pause(action.duration)\n              break\n              \n            case 'script':\n              await scripts[action.name]({\n                wait, interrupt, blockHandle, containerRef, showKey, speedRef,\n                pause, typeKey, typeText, atCurrentSpeed, fixFocus, checkSelection, checkFocus,\n              })\n              break\n          }\n          \n          // give ReSheet a chance to react to the input and update accordingly\n          await wait(0)\n          await wait(0)\n          await wait(0)\n          \n          if (\n            position % checkEvery === 0\n            && 'stateAfter' in action\n            \n            // TODO/FIXME: This only works for DocumentOf(...) Blocks and will break otherwise\n            // I need this because the viewState of a DocumentOf Block can vary depending on the\n            // size of the screen\n            && !lodash.isEqual(\n              action.stateAfter\n                .inner.pages,\n              block.toJSON(blockHandle.getState())\n                .inner.pages,\n            )\n          ) {\n            console.error('actual and intended states differ', action.stateAfter, block.toJSON(blockHandle.getState()))\n            interrupt('error')\n          }\n          else {\n            reportStateRef.current?.(position, blockHandle.getState())\n          }\n        }\n        \n        await wait(2)\n        \n        // End of script\n        \n        \n        \n        // Helper functions\n        \n        async function checkFocus() {\n          if (!containerRef.current || !containerRef.current.contains(document.activeElement)) {\n            await interrupt('focus')\n          }\n        }\n        \n        async function checkSelection() {\n          if (!containerRef.current) { await interrupt('focus') }\n          \n          if (['INPUT', 'TEXTAREA'].includes(document.activeElement.tagName)) {\n            await checkFocus()\n          }\n          else {\n            const selection = window.getSelection()\n            if (selection.rangeCount === 0) { await interrupt('focus') }\n            const range = selection.getRangeAt(0)\n            if (!containerRef.current.contains(range.startContainer)) { await interrupt('focus') }\n            if (!containerRef.current.contains(range.endContainer)) { await interrupt('focus') }\n          }\n        }\n        \n        async function checkInput(text) {\n          if (['INPUT', 'TEXTAREA'].includes(document.activeElement.tagName)) {\n            function inputMatches() {\n              const elem = document.activeElement\n              const [start, end] = (\n                elem.selectionStart === elem.selectionEnd ?\n                  [elem.selectionStart - text.length, elem.selectionEnd]\n                :\n                  [elem.selectionStart, elem.selectionEnd]\n              )\n              const input = elem.value.slice(start, end)\n              return input === text\n            }\n            \n            while (!inputMatches()) {\n              await wait(0)\n            }\n          }\n          \n          else {\n            function inputMatches() {\n              let range = resheet.code.useEditable.getCurrentRange()\n              if (!range.collapsed) { return false }\n              \n              const container = utils.findContentEditable(range.commonAncestorContainer)\n              \n              const rangeAfter = document.createRange()\n              rangeAfter.setStart(range.endContainer, range.endOffset)\n              rangeAfter.setEndAfter(container)\n              \n              let position = resheet.code.useEditable.getPosition(container).start\n              if (rangeAfter.toString() === '' && container.textContent.endsWith('\\n')) {\n                position--\n              }\n              range = resheet.code.useEditable.makeRange(container, position - text.length, position)\n              \n              return range.toString() === text\n            }\n            \n            for (let i = 0; i < 20 && !inputMatches(); i++) {\n              await wait(0)\n            }\n            if (!inputMatches()) {\n              window.debug = {}\n              window.debug.range = window.getSelection().getRangeAt(0)\n              await interrupt('error')\n            }\n          }\n        }\n        \n        function fixFocus() {\n          if (containerRef.current && !containerRef.current.contains(document.activeElement)) {\n            blockHandle.focus()\n          }\n        }\n        \n        function atCurrentSpeed(duration) {\n          const factor = speedRef?.current ?? speed\n          return duration / factor\n        }\n                \n        async function typeText(text, end=0.2, charsPerSec=20) {\n          for (const pos in text) {\n            await checkSelection()\n            Input.text(text[pos])\n            await wait(atCurrentSpeed(1 / charsPerSec))\n            await checkInput(text[pos])\n          }\n          await wait(atCurrentSpeed(end))\n        }\n        \n        async function typeKey(opts, end=0, show=true) {\n          await checkFocus()\n          if (show) {\n            showKey(opts)\n            await wait(0.15)\n          }\n          \n          Input.key(opts)\n          setTimeout(fixFocus)\n          await wait(atCurrentSpeed(end))\n        }\n        \n        async function pause(duration) {\n          await wait(atCurrentSpeed(duration))\n        }\n\n      }}\n    />\n  )\n}"
                                                    }
                                                }
                                            }
                                        ]
                                    }
                                },
                                "isCollapsed": true,
                                "children": [
                                    {
                                        "id": 0,
                                        "name": "Input",
                                        "state": {
                                            "t": "resheet.selector",
                                            "v": 0,
                                            "mode": "run",
                                            "expr": "SheetOf(Note)",
                                            "inner": {
                                                "t": "resheet.sheet",
                                                "v": 2,
                                                "lines": [
                                                    {
                                                        "id": 7,
                                                        "name": "",
                                                        "visibility": "block",
                                                        "width": "narrow",
                                                        "state": {
                                                            "t": "resheet.note",
                                                            "v": 1,
                                                            "level": 0,
                                                            "input": "",
                                                            "note": {
                                                                "type": "text",
                                                                "tag": "p",
                                                                "text": ""
                                                            }
                                                        }
                                                    },
                                                    {
                                                        "id": 10,
                                                        "name": "",
                                                        "visibility": "block",
                                                        "width": "narrow",
                                                        "state": {
                                                            "t": "resheet.note",
                                                            "v": 1,
                                                            "level": 0,
                                                            "input": "# Input",
                                                            "note": {
                                                                "type": "text",
                                                                "tag": "h1",
                                                                "text": "Input"
                                                            }
                                                        }
                                                    },
                                                    {
                                                        "id": 11,
                                                        "name": "",
                                                        "visibility": "block",
                                                        "width": "narrow",
                                                        "state": {
                                                            "t": "resheet.note",
                                                            "v": 1,
                                                            "level": 0,
                                                            "input": "Create simulated input. For now only keyboard input.",
                                                            "note": {
                                                                "type": "text",
                                                                "tag": "p",
                                                                "text": "Create simulated input. For now only keyboard input."
                                                            }
                                                        }
                                                    },
                                                    {
                                                        "id": 12,
                                                        "name": "",
                                                        "visibility": "block",
                                                        "width": "narrow",
                                                        "state": {
                                                            "t": "resheet.note",
                                                            "v": 1,
                                                            "level": 0,
                                                            "input": "",
                                                            "note": {
                                                                "type": "text",
                                                                "tag": "p",
                                                                "text": ""
                                                            }
                                                        }
                                                    },
                                                    {
                                                        "id": 15,
                                                        "name": "",
                                                        "visibility": "block",
                                                        "width": "narrow",
                                                        "state": {
                                                            "t": "resheet.note",
                                                            "v": 1,
                                                            "level": 0,
                                                            "input": "## Shortcut Input",
                                                            "note": {
                                                                "type": "text",
                                                                "tag": "h2",
                                                                "text": "Shortcut Input"
                                                            }
                                                        }
                                                    },
                                                    {
                                                        "id": 3,
                                                        "name": "key",
                                                        "visibility": "block",
                                                        "width": "narrow",
                                                        "state": {
                                                            "t": "resheet.note",
                                                            "v": 1,
                                                            "level": 0,
                                                            "input": "/Code",
                                                            "note": {
                                                                "type": "block",
                                                                "isInstantiated": true,
                                                                "code": "Code",
                                                                "state": "function keyInput(opts) {\n  if (typeof opts === 'string') {\n    if (opts.length === 1) {\n      opts = { key: opts, code: 'Key' + opts.toUpperCase() }\n    }\n    else {\n      opts = { key: opts, code: opts }\n    }\n  }\n  const event = new KeyboardEvent('keydown', { ...opts, bubbles: true, cancelable: true })\n  const runDefault = document.activeElement.dispatchEvent(event)\n  document.activeElement.dispatchEvent(new KeyboardEvent('keyup', { ...opts, bubbles: true, cancelable: true }))\n  \n  if (runDefault) {\n    if (['INPUT','TEXTAREA'].includes(document.activeElement.tagName)) {\n      (opts.key in defaultInputActions) && defaultInputActions[opts.key](opts)\n    }\n    \n    const selection = window.getSelection()\n    const range = selection.rangeCount > 0 && selection.getRangeAt(0)\n    if (utils.findElement(range?.commonAncestorContainer).isContentEditable) {\n      (opts.key in defaultEditableActions) && defaultEditableActions[opts.key](opts)\n    }\n    \n    const keyComb = [\n      opts.ctrlKey || opts.metaKey ? 'C-' : '',\n      opts.altKey ? 'Alt-' : '',\n      opts.shiftKey ? 'Shift-' : '',\n      opts.key.length === 1 ? opts.key.toUpperCase() : opts.key,\n    ].join('')\n    switch (keyComb) {\n      case 'C-C':\n        defaultActions.copy()\n        break\n        \n      case 'C-X':\n        defaultActions.cut()\n        break\n        \n      case 'C-V':\n        defaultActions.paste()\n        break\n    }\n  }\n}"
                                                            }
                                                        }
                                                    },
                                                    {
                                                        "id": 16,
                                                        "name": "",
                                                        "visibility": "block",
                                                        "width": "narrow",
                                                        "state": {
                                                            "t": "resheet.note",
                                                            "v": 1,
                                                            "level": 0,
                                                            "input": "",
                                                            "note": {
                                                                "type": "text",
                                                                "tag": "p",
                                                                "text": ""
                                                            }
                                                        }
                                                    },
                                                    {
                                                        "id": 17,
                                                        "name": "",
                                                        "visibility": "block",
                                                        "width": "narrow",
                                                        "state": {
                                                            "t": "resheet.note",
                                                            "v": 1,
                                                            "level": 0,
                                                            "input": "## Text Input",
                                                            "note": {
                                                                "type": "text",
                                                                "tag": "h2",
                                                                "text": "Text Input"
                                                            }
                                                        }
                                                    },
                                                    {
                                                        "id": 4,
                                                        "name": "text",
                                                        "visibility": "block",
                                                        "width": "narrow",
                                                        "state": {
                                                            "t": "resheet.note",
                                                            "v": 1,
                                                            "level": 0,
                                                            "input": "/Code",
                                                            "note": {
                                                                "type": "block",
                                                                "isInstantiated": true,
                                                                "code": "Code",
                                                                "state": "function textInput(text) {\n  if (['INPUT', 'TEXTAREA'].includes(document.activeElement.tagName)) {\n    const inputElement = document.activeElement\n    const caretPos = inputElement.selectionStart;\n    \n    const currentValue = inputElement.value;\n    inputElement.value = currentValue.substring(0, caretPos) + text + currentValue.substring(inputElement.selectionEnd);\n    \n    const newCaretPos = caretPos + text.length;\n    inputElement.setSelectionRange(newCaretPos, newCaretPos);\n    \n    utils.reactTriggerChange(inputElement)\n    \n    return null\n  }\n  \n  else {\n    const selection = window.getSelection();\n    if (selection.rangeCount === 0) { return }\n    let range = selection.getRangeAt(0);\n    range.deleteContents()\n    \n    const container = utils.findContentEditable(range.commonAncestorContainer)\n    const content = container.textContent\n    \n    const afterRange = document.createRange()\n    afterRange.setStart(range.endContainer, range.endOffset)\n    afterRange.setEndAfter(container)\n    \n    if (content.endsWith('\\n') && afterRange.toString() === '') {\n      // We're after the mandatory newline character at the end\n      //  => we need to get before it\n      range = resheet.code.useEditable.makeRange(container, content.length - 1)\n      afterRange.setStart(range.endContainer, range.endOffset)\n      afterRange.setEndAfter(container)\n    }\n      \n    if (afterRange.toString() === '') {\n      afterRange.insertNode(document.createTextNode('\\n'))\n    }\n    \n    const textNode = document.createTextNode(text)\n    range.insertNode(textNode);\n    \n    range.setStart(textNode, text.length);\n    range.setEnd(textNode, text.length);\n      \n    utils.findElement(range.endContainer).scrollIntoView({ block: 'nearest', behavior: 'instant' })\n\n    selection.removeAllRanges()\n    selection.addRange(range)\n  }\n}"
                                                            }
                                                        }
                                                    },
                                                    {
                                                        "id": 5,
                                                        "name": "",
                                                        "visibility": "block",
                                                        "width": "narrow",
                                                        "state": {
                                                            "t": "resheet.note",
                                                            "v": 1,
                                                            "level": 0,
                                                            "input": "",
                                                            "note": {
                                                                "type": "text",
                                                                "tag": "p",
                                                                "text": ""
                                                            }
                                                        }
                                                    },
                                                    {
                                                        "id": 18,
                                                        "name": "",
                                                        "visibility": "block",
                                                        "width": "narrow",
                                                        "state": {
                                                            "t": "resheet.note",
                                                            "v": 1,
                                                            "level": 0,
                                                            "input": "",
                                                            "note": {
                                                                "type": "text",
                                                                "tag": "p",
                                                                "text": ""
                                                            }
                                                        }
                                                    },
                                                    {
                                                        "id": 14,
                                                        "name": "",
                                                        "visibility": "block",
                                                        "width": "narrow",
                                                        "state": {
                                                            "t": "resheet.note",
                                                            "v": 1,
                                                            "level": 0,
                                                            "input": "---",
                                                            "note": {
                                                                "type": "text",
                                                                "tag": "p",
                                                                "text": "---"
                                                            }
                                                        }
                                                    },
                                                    {
                                                        "id": 6,
                                                        "name": "exports",
                                                        "visibility": "block",
                                                        "width": "narrow",
                                                        "state": {
                                                            "t": "resheet.note",
                                                            "v": 1,
                                                            "level": 0,
                                                            "input": "= ({ key, text })",
                                                            "note": {
                                                                "type": "expr",
                                                                "code": " ({ key, text })"
                                                            }
                                                        }
                                                    }
                                                ]
                                            }
                                        },
                                        "isCollapsed": true,
                                        "children": [
                                            {
                                                "id": 3,
                                                "name": "defaultInputActions",
                                                "state": {
                                                    "t": "resheet.selector",
                                                    "v": 0,
                                                    "mode": "run",
                                                    "expr": "SheetOf(Note)",
                                                    "inner": {
                                                        "t": "resheet.sheet",
                                                        "v": 2,
                                                        "lines": [
                                                            {
                                                                "id": 0,
                                                                "name": "",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "# Default Input Actions",
                                                                    "note": {
                                                                        "type": "text",
                                                                        "tag": "h1",
                                                                        "text": "Default Input Actions"
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 10,
                                                                "name": "",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "Simulate the default browser behavior on keyboard input.",
                                                                    "note": {
                                                                        "type": "text",
                                                                        "tag": "p",
                                                                        "text": "Simulate the default browser behavior on keyboard input."
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 11,
                                                                "name": "",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "",
                                                                    "note": {
                                                                        "type": "text",
                                                                        "tag": "p",
                                                                        "text": ""
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 2,
                                                                "name": "defaultInputActions",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "/Code",
                                                                    "note": {
                                                                        "type": "block",
                                                                        "isInstantiated": true,
                                                                        "code": "Code",
                                                                        "state": "function moveX(x) {\n  return ev => {\n    const input = document.activeElement\n    const position = (\n      Math.max(\n        0,\n        Math.min(\n          input.value.length,\n          input.selectionStart + x,\n        )\n      )\n    )\n    input.selectionStart = position\n    input.selectionEnd = position\n  }\n}\n\nreturn {\n  Backspace(ev) {\n    const input = document.activeElement\n    if (input.selectionStart !== input.selectionEnd) {\n      const start = input.selectionStart\n      input.value = (\n        input.value.slice(0, input.selectionStart)\n        + input.value.slice(input.selectionEnd)\n      )\n      utils.reactTriggerChange(input)\n      input.selectionStart = start\n      input.selectionEnd = start\n    }\n    else {\n      const start = Math.max(0, input.selectionStart - 1)\n      input.value = (\n        input.value.slice(0, start)\n        + input.value.slice(input.selectionStart)\n      )\n      utils.reactTriggerChange(input)\n      input.selectionStart = start\n      input.selectionEnd = start\n    }\n  },\n  \n  ArrowLeft: moveX(-1),\n  ArrowRight: moveX(1),\n}"
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 6,
                                                                "name": "",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "",
                                                                    "note": {
                                                                        "type": "text",
                                                                        "tag": "p",
                                                                        "text": ""
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 3,
                                                                "name": "",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "## Testing Ground",
                                                                    "note": {
                                                                        "type": "text",
                                                                        "tag": "h2",
                                                                        "text": "Testing Ground"
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 4,
                                                                "name": "",
                                                                "visibility": "result",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "/Code",
                                                                    "note": {
                                                                        "type": "block",
                                                                        "isInstantiated": true,
                                                                        "code": "Code",
                                                                        "state": '<div className="flex flex-col space-y-1 items-center">\n  {Object.entries(defaultInputActions).map(([name, action]) =>\n    <button\n      className="px-3 min-w-16 py-1 text-xl rounded bg-blue-100 hover:bg-blue-200 text-blue-900"\n      onPointerDown={ev => ev.preventDefault()}\n      onClick={() => action()}\n      onDoubleClick={ev => ev.stopPropagation()}\n    >\n      {utils.renderKey(name)}\n    </button>\n  )}\n</div>'
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 5,
                                                                "name": "",
                                                                "visibility": "result",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": '= <input className="w-full" defaultValue="this is some example input" />',
                                                                    "note": {
                                                                        "type": "expr",
                                                                        "code": ' <input className="w-full" defaultValue="this is some example input" />'
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 7,
                                                                "name": "",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "",
                                                                    "note": {
                                                                        "type": "text",
                                                                        "tag": "p",
                                                                        "text": ""
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 8,
                                                                "name": "",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "---",
                                                                    "note": {
                                                                        "type": "text",
                                                                        "tag": "p",
                                                                        "text": "---"
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 9,
                                                                "name": "exports",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "= defaultInputActions",
                                                                    "note": {
                                                                        "type": "expr",
                                                                        "code": " defaultInputActions"
                                                                    }
                                                                }
                                                            }
                                                        ]
                                                    }
                                                },
                                                "isCollapsed": false,
                                                "children": []
                                            },
                                            {
                                                "id": 1,
                                                "name": "defaultEditableActions",
                                                "state": {
                                                    "t": "resheet.selector",
                                                    "v": 0,
                                                    "mode": "run",
                                                    "expr": "SheetOf(Note)",
                                                    "inner": {
                                                        "t": "resheet.sheet",
                                                        "v": 2,
                                                        "lines": [
                                                            {
                                                                "id": 0,
                                                                "name": "",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "# Default Editable Actions",
                                                                    "note": {
                                                                        "type": "text",
                                                                        "tag": "h1",
                                                                        "text": "Default Editable Actions"
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 11,
                                                                "name": "",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "Simulate the default browser behavior on keyboard input.",
                                                                    "note": {
                                                                        "type": "text",
                                                                        "tag": "p",
                                                                        "text": "Simulate the default browser behavior on keyboard input."
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 12,
                                                                "name": "",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "",
                                                                    "note": {
                                                                        "type": "text",
                                                                        "tag": "p",
                                                                        "text": ""
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 1,
                                                                "name": "defaultEditableActions",
                                                                "visibility": "block",
                                                                "width": "wide",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "/Code",
                                                                    "note": {
                                                                        "type": "block",
                                                                        "isInstantiated": true,
                                                                        "code": "Code",
                                                                        "state": "const editable = resheet.code.useEditable\n\nfunction moveX(x) {\n  return ev => {\n    const range = editable.getCurrentRange()\n    if (!range.collapsed) {\n      // TODO: not implemented yet\n      return\n    }\n    \n    const container = utils.findContentEditable(range.commonAncestorContainer)\n    const content = container.textContent\n    const afterRange = document.createRange()\n    afterRange.setStart(range.endContainer, range.endOffset)\n    afterRange.setEndAfter(container)\n\n    // Get before the mandatory newline character at the end\n    const offset = content.endsWith('\\n') && afterRange.toString() === '' ? -1 : 0\n\n    const position = editable.getPosition(container).start\n    const newRange = editable.makeRange(container, position + offset + x)\n    editable.setCurrentRange(newRange)\n  }\n}\n\nfunction moveY(y) {\n  return ev => {\n    const range = editable.getCurrentRange()\n    if (!range.collapsed) {\n      // TODO: not implemented yet\n      return\n    }\n\n    const container = utils.findContentEditable(range.commonAncestorContainer)\n    const position = editable.getPosition(container).start\n    const pos2d = editable.posToRowCol(container.textContent, position)\n    const newPos2d = {\n      ...pos2d,\n      row: pos2d.row + y,\n    }\n    const newPosition = editable.rowColToPos(container.textContent, newPos2d)\n    const newRange = editable.makeRange(container, newPosition)\n    editable.setCurrentRange(newRange)\n  }\n}\n\nreturn {\n  Backspace(ev) {\n    const range = editable.getCurrentRange()\n    if (!range.collapsed) {\n      range.deleteContents()\n      return\n    }\n    \n    const container = utils.findContentEditable(range.commonAncestorContainer)\n    const position = editable.getPosition(container).start\n    \n    let newRange\n    if (ev.ctrlKey || ev.metaKey) {\n      const pos2d = editable.posToRowCol(container.textContent, position)\n      if (pos2d.col === 0) {\n        newRange = editable.makeRange(container, position - 1, position)\n      }\n      else {\n        const startOfLine2d = { col: 0, row: pos2d.row }\n        const startOfLine = editable.rowColToPos(container.textContent, startOfLine2d)\n        newRange = editable.makeRange(container, startOfLine, position)\n      }\n    }\n    else {\n      newRange = editable.makeRange(container, position - 1, position)\n    }\n    \n    newRange.deleteContents()\n    editable.setCurrentRange(newRange)\n  },\n  \n  ArrowUp: moveY(-1),\n  ArrowDown: moveY(1),\n  ArrowLeft: moveX(-1),\n  ArrowRight: moveX(1),\n}"
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 8,
                                                                "name": "",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "",
                                                                    "note": {
                                                                        "type": "text",
                                                                        "tag": "p",
                                                                        "text": ""
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 9,
                                                                "name": "",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "## Testing Ground",
                                                                    "note": {
                                                                        "type": "text",
                                                                        "tag": "h2",
                                                                        "text": "Testing Ground"
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 3,
                                                                "name": "",
                                                                "visibility": "result",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "/Code",
                                                                    "note": {
                                                                        "type": "block",
                                                                        "isInstantiated": true,
                                                                        "code": "Code",
                                                                        "state": '<div className="flex flex-col space-y-1 items-center">\n  <button\n    className="px-3 min-w-16 py-1 text-xl rounded bg-blue-100 hover:bg-blue-200 text-blue-900"\n    onPointerDown={ev => ev.preventDefault()}\n    onClick={() => defaultEditableActions.Backspace({ metaKey: true, key: \'Backspace\' })}\n    onDoubleClick={ev => ev.stopPropagation()}\n  >\n    {utils.renderKey({ metaKey: true, key: \'Backspace\' })}\n  </button>\n  {Object.entries(defaultEditableActions)\n    .map(([key, action]) =>\n      <button\n        className="px-3 min-w-16 py-1 text-xl rounded bg-blue-100 hover:bg-blue-200 text-blue-900"\n        onPointerDown={ev => ev.preventDefault()}\n        onClick={() => action({})}\n        onDoubleClick={ev => ev.stopPropagation()}\n      >\n        {utils.renderKey(key)}\n      </button>\n    )\n  }\n</div>'
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 10,
                                                                "name": "",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "/Code",
                                                                    "note": {
                                                                        "type": "block",
                                                                        "isInstantiated": true,
                                                                        "code": "Code",
                                                                        "state": "// some test\n// text to\n// test with"
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 4,
                                                                "name": "",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "",
                                                                    "note": {
                                                                        "type": "text",
                                                                        "tag": "p",
                                                                        "text": ""
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 7,
                                                                "name": "",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "",
                                                                    "note": {
                                                                        "type": "text",
                                                                        "tag": "p",
                                                                        "text": ""
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 5,
                                                                "name": "",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "---",
                                                                    "note": {
                                                                        "type": "text",
                                                                        "tag": "p",
                                                                        "text": "---"
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 6,
                                                                "name": "exports",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "= defaultEditableActions",
                                                                    "note": {
                                                                        "type": "expr",
                                                                        "code": " defaultEditableActions"
                                                                    }
                                                                }
                                                            }
                                                        ]
                                                    }
                                                },
                                                "isCollapsed": false,
                                                "children": []
                                            },
                                            {
                                                "id": 2,
                                                "name": "defaultActions",
                                                "state": {
                                                    "t": "resheet.selector",
                                                    "v": 0,
                                                    "mode": "run",
                                                    "expr": "SheetOf(Note)",
                                                    "inner": {
                                                        "t": "resheet.sheet",
                                                        "v": 2,
                                                        "lines": [
                                                            {
                                                                "id": 0,
                                                                "name": "",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "# Default Actions",
                                                                    "note": {
                                                                        "type": "text",
                                                                        "tag": "h1",
                                                                        "text": "Default Actions"
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 10,
                                                                "name": "",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "Simulate default browser behavior for some events.",
                                                                    "note": {
                                                                        "type": "text",
                                                                        "tag": "p",
                                                                        "text": "Simulate default browser behavior for some events."
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 11,
                                                                "name": "",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "",
                                                                    "note": {
                                                                        "type": "text",
                                                                        "tag": "p",
                                                                        "text": ""
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 1,
                                                                "name": "",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "## Copy & Paste",
                                                                    "note": {
                                                                        "type": "text",
                                                                        "tag": "h2",
                                                                        "text": "Copy & Paste"
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 2,
                                                                "name": "copyPaste",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "/Code",
                                                                    "note": {
                                                                        "type": "block",
                                                                        "isInstantiated": true,
                                                                        "code": "Code",
                                                                        "state": "const options = {\n  clipboardData: undefined,\n  bubbles: true,\n  cancelable: true,\n}\n\nfunction copy() {\n  options.clipboardData = new DataTransfer()\n  const event = new ClipboardEvent('copy', options)\n  const runDefault = document.activeElement.dispatchEvent(event)\n  // TODO: emulate default behavior when runDefault === true\n}\n\nfunction cut() {\n  options.clipboardData = new DataTransfer()\n  const event = new ClipboardEvent('cut', options)\n  const runDefault = document.activeElement.dispatchEvent(event)\n  // TODO: emulate default behavior when runDefault === true\n}\n\nfunction paste() {\n  const event = new ClipboardEvent('paste', options)\n  const runDefault = document.activeElement.dispatchEvent(event)\n  // TODO: emulate default behavior when runDefault === true\n}\n\nreturn { copy, cut, paste }"
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 7,
                                                                "name": "",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "### Testing Ground",
                                                                    "note": {
                                                                        "type": "text",
                                                                        "tag": "h3",
                                                                        "text": "Testing Ground"
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 8,
                                                                "name": "",
                                                                "visibility": "result",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "/Code",
                                                                    "note": {
                                                                        "type": "block",
                                                                        "isInstantiated": true,
                                                                        "code": "Code",
                                                                        "state": '<div className="flex flex-col space-y-1 items-center">\n  {Object.entries(copyPaste).map(([name, action]) =>\n    <button\n      className="px-3 min-w-16 py-1 text-xl rounded bg-blue-100 hover:bg-blue-200 text-blue-900"\n      onPointerDown={ev => ev.preventDefault()}\n      onClick={() => action()}\n      onDoubleClick={ev => ev.stopPropagation()}\n    >\n      {utils.renderKey(name)}\n    </button>\n  )}\n</div>'
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 9,
                                                                "name": "",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "/SheetOf(Note)",
                                                                    "note": {
                                                                        "type": "block",
                                                                        "isInstantiated": true,
                                                                        "code": "SheetOf(Note)",
                                                                        "state": {
                                                                            "t": "resheet.sheet",
                                                                            "v": 2,
                                                                            "lines": [
                                                                                {
                                                                                    "id": 0,
                                                                                    "name": "",
                                                                                    "visibility": "block",
                                                                                    "width": "narrow",
                                                                                    "state": {
                                                                                        "t": "resheet.note",
                                                                                        "v": 1,
                                                                                        "level": 0,
                                                                                        "input": "Test 1",
                                                                                        "note": {
                                                                                            "type": "text",
                                                                                            "tag": "p",
                                                                                            "text": "Test 1"
                                                                                        }
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "id": 3,
                                                                                    "name": "",
                                                                                    "visibility": "block",
                                                                                    "width": "narrow",
                                                                                    "state": {
                                                                                        "t": "resheet.note",
                                                                                        "v": 1,
                                                                                        "level": 0,
                                                                                        "input": "Test 2",
                                                                                        "note": {
                                                                                            "type": "text",
                                                                                            "tag": "p",
                                                                                            "text": "Test 2"
                                                                                        }
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "id": 2,
                                                                                    "name": "",
                                                                                    "visibility": "block",
                                                                                    "width": "narrow",
                                                                                    "state": {
                                                                                        "t": "resheet.note",
                                                                                        "v": 1,
                                                                                        "level": 0,
                                                                                        "input": "Test 3",
                                                                                        "note": {
                                                                                            "type": "text",
                                                                                            "tag": "p",
                                                                                            "text": "Test 3"
                                                                                        }
                                                                                    }
                                                                                }
                                                                            ]
                                                                        }
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 3,
                                                                "name": "",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "",
                                                                    "note": {
                                                                        "type": "text",
                                                                        "tag": "p",
                                                                        "text": ""
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 4,
                                                                "name": "",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "",
                                                                    "note": {
                                                                        "type": "text",
                                                                        "tag": "p",
                                                                        "text": ""
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 5,
                                                                "name": "",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "---",
                                                                    "note": {
                                                                        "type": "text",
                                                                        "tag": "p",
                                                                        "text": "---"
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 6,
                                                                "name": "exports",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "= { ...copyPaste }",
                                                                    "note": {
                                                                        "type": "expr",
                                                                        "code": " { ...copyPaste }"
                                                                    }
                                                                }
                                                            }
                                                        ]
                                                    }
                                                },
                                                "isCollapsed": false,
                                                "children": []
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "id": 5,
                                "name": "DemoRecorder",
                                "state": {
                                    "t": "resheet.selector",
                                    "v": 0,
                                    "mode": "run",
                                    "expr": "SheetOf(Note)",
                                    "inner": {
                                        "t": "resheet.sheet",
                                        "v": 2,
                                        "lines": [
                                            {
                                                "id": 12,
                                                "name": "",
                                                "visibility": "block",
                                                "width": "wide",
                                                "state": {
                                                    "t": "resheet.note",
                                                    "v": 1,
                                                    "level": 0,
                                                    "input": "# Demo Recorder",
                                                    "note": {
                                                        "type": "text",
                                                        "tag": "h1",
                                                        "text": "Demo Recorder"
                                                    }
                                                }
                                            },
                                            {
                                                "id": 13,
                                                "name": "",
                                                "visibility": "block",
                                                "width": "wide",
                                                "state": {
                                                    "t": "resheet.note",
                                                    "v": 1,
                                                    "level": 0,
                                                    "input": "Record and edit a demo with keyboard input.",
                                                    "note": {
                                                        "type": "text",
                                                        "tag": "p",
                                                        "text": "Record and edit a demo with keyboard input."
                                                    }
                                                }
                                            },
                                            {
                                                "id": 14,
                                                "name": "",
                                                "visibility": "block",
                                                "width": "wide",
                                                "state": {
                                                    "t": "resheet.note",
                                                    "v": 1,
                                                    "level": 0,
                                                    "input": "",
                                                    "note": {
                                                        "type": "text",
                                                        "tag": "p",
                                                        "text": ""
                                                    }
                                                }
                                            },
                                            {
                                                "id": 9,
                                                "name": "appendOrMergeAction",
                                                "visibility": "result",
                                                "width": "wide",
                                                "state": {
                                                    "t": "resheet.note",
                                                    "v": 1,
                                                    "level": 0,
                                                    "input": "/Code",
                                                    "note": {
                                                        "type": "block",
                                                        "isInstantiated": true,
                                                        "code": "Code",
                                                        "state": "function appendOrMergeAction(action, actions) {\n  const lastAction = actions[0]\n  \n  if (action.type === 'input' && lastAction?.type === 'input') {\n    return [\n      { ...action, input: lastAction.input + action.input },\n      ...actions.slice(1),\n    ]\n  }\n  if (action.type === 'pause' && lastAction?.type === 'pause') {\n    return [\n      { ...action, duration: action.duration + lastAction.duration },\n      ...actions.slice(1),\n    ]\n  }\n  \n  return [action, ...actions]\n}"
                                                    }
                                                }
                                            },
                                            {
                                                "id": 10,
                                                "name": "compactActions",
                                                "visibility": "result",
                                                "width": "wide",
                                                "state": {
                                                    "t": "resheet.note",
                                                    "v": 1,
                                                    "level": 0,
                                                    "input": "/Code",
                                                    "note": {
                                                        "type": "block",
                                                        "isInstantiated": true,
                                                        "code": "Code",
                                                        "state": "function compactActions(actions) {\n  return actions.reduceRight(\n    (actions, action) => appendOrMergeAction(action, actions),\n    [],\n  )\n}"
                                                    }
                                                }
                                            },
                                            {
                                                "id": 8,
                                                "name": "ActionsEditor",
                                                "visibility": "result",
                                                "width": "wide",
                                                "state": {
                                                    "t": "resheet.note",
                                                    "v": 1,
                                                    "level": 0,
                                                    "input": "/Code",
                                                    "note": {
                                                        "type": "block",
                                                        "isInstantiated": true,
                                                        "code": "Code",
                                                        "state": "function ActionsEditor({ actions, position, setActions, loadState }) {\n  return (\n    actions.map((action, index) => (\n      <div\n        key={actions.length - index}\n        className={`\n          relative group/action-item\n          flex flex-row items-stretch\n          hover:bg-white\n        `}\n      >\n        {/* position indicator */}\n        <code className={`py-1 px-2 min-w-16 text-right ${index === position ? 'bg-green-100' : 'bg-gray-100'}`}>\n          {actions.length - index}\n        </code>\n        \n        {/* action description/editor */}\n        <div className=\"py-1 px-1 flex-1\">\n          {action.type === 'pause' ?\n            <>\n              <span className=\"italic\">-- PAUSE {action.duration}s --</span> {}\n              <button\n                className=\"text-gray-500\"\n                onClick={() => {\n                  setActions(actions => \n                    immutable.set(actions, index, { type: 'pause', duration: 0.5 })\n                  )\n                }}\n              >\n                <FontAwesomeIcon icon={faSolid.faRotateLeft} />\n              </button>\n            </>\n            \n          : action.type === 'script' ?\n            <>\n              <FontAwesomeIcon icon={faSolid.faScroll} /> {}\n              <input\n                value={action.name}\n                onChange={ev => {\n                  setActions(actions => [\n                    ...actions.slice(0, index).map(action => lodash.omit(action, 'stateAfter')),\n                    {\n                      ...lodash.omit(actions[index], 'stateAfter'),\n                      name: ev.target.value,\n                    },\n                    ...actions.slice(index + 1),\n                  ])\n                }}\n              />\n            </>\n            \n          : action.type === 'key' ?\n            <kbd className=\"px-1 rounded bg-gray-200\">{utils.renderKey(action)}</kbd>\n            \n          :\n            <textarea\n              className=\"monospace w-full bg-transparent\"\n              rows={action.input.split('\\n').length}\n              value={action.input}\n              onChange={ev => {\n                setActions(actions => [\n                  ...actions.slice(0, index).map(action => lodash.omit(action, 'stateAfter')),\n                  {\n                    ...lodash.omit(actions[index], 'stateAfter'),\n                    input: ev.target.value,\n                  },\n                  ...actions.slice(index + 1),\n                ])\n              }}\n              />\n          }\n        </div>\n        \n        {/* delete button */}\n        <button\n          className=\"invisible group-hover/action-item:visible self-center mx-2 text-sm text-red-700 hover:text-red-500 py-1 px-2 rounded-full bg-red-100\"\n          onClick={() => {\n            setActions(actions => compactActions([\n              ...actions.slice(0, index).map(action => lodash.omit(action, 'stateAfter')),\n              ...actions.slice(index + 1),\n            ]))\n          }}\n          onDoubleClick={ev => ev.stopPropagation()}\n        >\n          <FontAwesomeIcon icon={faSolid.faTrash} />\n        </button>\n        \n        {/* saved state indicator */}\n        {'stateAfter' in action &&\n          <FontAwesomeIcon className=\"self-center mx-2 text-gray-400\" icon={faRegular.faFloppyDisk} />\n        }\n        \n        {/* hover actions */}\n        <div\n          className={`\n            absolute bottom-0 left-1/2 translate-y-1/2 -translate-x-1/2 z-10\n            ${index === position ? 'flex' : 'hidden group-hover/action-item:flex hover:flex'}\n            flex-row justify-center space-x-3 px-5\n          `}\n        >\n          {/* current position indicator */}\n          {position === index &&\n            <div\n              className={`\n                rounded-full px-2 py-1\n                text-sm space-x-1\n                bg-gray-200 text-gray-700\n              `}\n            >\n              <FontAwesomeIcon icon={faSolid.faPlay} />\n            </div>\n          }\n          \n          {/* jump to position button */}\n          {'stateAfter' in action && position !== index &&\n            <button\n              className={`\n                rounded-full px-2 py-1\n                text-sm space-x-1\n                bg-gray-200 text-gray-700\n                hover:bg-blue-100 hover:text-blue-700\n              `}\n              onClick={() => {\n                loadState(index, action.stateAfter)\n              }}\n              onDoubleClick={ev => ev.stopPropagation()}\n            >\n              <FontAwesomeIcon\n                icon={\n                  index > position ?\n                    faSolid.faBackward\n                  :\n                    faSolid.faForward\n                }\n                />\n            </button>\n          }\n          \n          {/* insert script button */}\n          <button\n            className={`\n              rounded-full px-2 py-1\n              text-sm space-x-1\n              bg-gray-200 text-gray-700\n              hover:bg-blue-100 hover:text-blue-700\n            `}\n            onClick={() =>\n              setActions(actions =>\n                compactActions(\n                  actions.toSpliced(index, 0, { type: 'script', name: 'script' })\n                )\n              )\n            }\n            onDoubleClick={ev => ev.stopPropagation()}\n          >\n            <FontAwesomeIcon icon={faSolid.faPlus} />\n            <FontAwesomeIcon icon={faSolid.faScroll} />\n          </button>\n          \n          {/* insert pause button */}\n          <button\n            className={`\n              rounded-full px-2 py-1\n              text-sm space-x-1\n              bg-gray-200 text-gray-700\n              hover:bg-blue-100 hover:text-blue-700\n            `}\n            onClick={() =>\n              setActions(actions =>\n                compactActions(\n                  actions.toSpliced(index, 0, { type: 'pause', duration: 0.5 })\n                )\n              )\n            }\n            onDoubleClick={ev => ev.stopPropagation()}\n          >\n            <FontAwesomeIcon icon={faSolid.faPlus} />\n            <FontAwesomeIcon icon={faSolid.faPause} />\n          </button>\n        </div>\n      </div>\n    )).toReversed()\n  )\n}"
                                                    }
                                                }
                                            },
                                            {
                                                "id": 11,
                                                "name": "actionFromKeyEvent",
                                                "visibility": "result",
                                                "width": "wide",
                                                "state": {
                                                    "t": "resheet.note",
                                                    "v": 1,
                                                    "level": 0,
                                                    "input": "/Code",
                                                    "note": {
                                                        "type": "block",
                                                        "isInstantiated": true,
                                                        "code": "Code",
                                                        "state": "function actionFromKeyEvent(ev) {\n  if ((ev.ctrlKey || ev.metaKey) && ev.shiftKey && ev.key === 'Escape') {\n    return { type: 'script', name: 'script' }\n  }\n  else if ((ev.ctrlKey || ev.metaKey) && ev.key === 'Escape') {\n    return { type: 'pause', duration: 0.5 }\n  }\n  else if (ev.key === 'Enter' && ev.target !== document.activeElement) {\n    return { type: 'key', ...lodash.pick(ev, 'key code ctrlKey metaKey shiftKey altKey'.split(' ')) }\n  }\n  else if (ev.ctrlKey || ev.metaKey || (ev.key.length > 1 && ev.key !== 'Enter')) {\n    return { type: 'key', ...lodash.pick(ev, 'key code ctrlKey metaKey shiftKey altKey'.split(' ')) }\n  } \n  else if (!ev.nativeEvent.defaultPrevented && ev.target.isContentEditable || ev.target instanceof HTMLInputElement) {\n    switch (ev.key) {\n      case 'Enter': return { type: 'input', input: '\\n' }\n      default: return { type: 'input', input: ev.key }\n    }\n  }\n  else {\n    return { type: 'key', ...lodash.pick(ev, 'key code ctrlKey metaKey shiftKey altKey'.split(' ')) }\n  }\n}"
                                                    }
                                                }
                                            },
                                            {
                                                "id": 0,
                                                "name": "DemoRecorder",
                                                "visibility": "block",
                                                "width": "wide",
                                                "state": {
                                                    "t": "resheet.note",
                                                    "v": 1,
                                                    "level": 0,
                                                    "input": "/Code",
                                                    "note": {
                                                        "type": "block",
                                                        "isInstantiated": true,
                                                        "code": "Code",
                                                        "state": "const { LoadFileButton, saveFile } = resheet.blocks.utils.ui\n\nconst modifiers = 'Shift,Meta,Control,Alt'.split(',').flatMap(mod => [mod, mod + 'L', mod + 'R'])\n\nconst env = library\nconst input = [{ env }]\n\nfunction DemoRecorder(block, startJson, scripts={}) {\n  const innerBlock = resheet.blocks.component.safeBlock(block)\n  \n  return resheet.core.block.create({\n    init: { actions: [], position: 0 },\n    \n    view({ state, dispatch }, ref) {\n      const actionsViewRef = React.useRef()\n      \n      const [stateInner, dispatchInner] = resheet.core.block.useBlockDispatcher(innerBlock.init, input)\n\n      const stateRef = React.useRef(state)\n      stateRef.current = stateInner\n\n      const openState = React.useCallback(\n        lodash.debounce(\n          state => {\n            dispatchInner(() => ({ state }))\n          },\n          2000,\n        ),\n        [],\n      )\n      \n      React.useEffect(() => {\n        if (startJson) {\n          dispatchInner(() => ({\n            state: innerBlock.fromJSON(startJson, dispatchInner, env)\n          }))\n        }\n      }, [])\n      \n      function focusStep(position, options) {\n        if (!actionsViewRef.current) { return }\n        \n        dispatch(state => {\n          const itemPosition = state.actions.length - position - 1\n          const item = actionsViewRef.current.children[itemPosition]\n          item?.scrollIntoView(options ?? { behavior: 'smooth', block: 'nearest' })\n          \n          return { state }\n        })\n      }\n      \n      function insertAction(action) {\n        dispatch(state => {\n          const newAction = {\n            ...action,\n            stateAfter: innerBlock.toJSON(stateRef.current),\n          }\n          const newActions = [\n            ...state.actions.slice(0, state.position).map(action => lodash.omit(action, 'stateAfter')),\n            newAction,\n            ...state.actions.slice(state.position),\n          ]\n\n          return {\n            state: {\n              ...state,\n              actions: compactActions(newActions),\n            }\n          }\n        })\n        setTimeout(() => {\n          focusStep(state.position)\n        })\n      }\n      \n      function reportState(position, stateAfter) {\n        dispatch(state => ({\n          state: {\n            ...state,\n            position,\n            actions: immutable.update(\n              state.actions,\n              position,\n              action => ({\n                ...action,\n                stateAfter: innerBlock.toJSON(stateAfter),\n              }),\n            ),\n          },\n        }))\n        openState(stateAfter)\n        focusStep(position, { behavior: 'instant', block: 'nearest' })\n      }\n      \n      function loadState(position, json) {\n        dispatch(state => ({\n          state: {\n            ...state,\n            position,\n          },\n        }))\n        dispatchInner(() => ({\n          state: innerBlock.fromJSON(json, dispatchInner, env),\n        }))\n      }\n      \n      function onKeyDown(ev) {\n        if (modifiers.includes(ev.key)) { return }\n        \n        // 4 setTimeouts so an input can be handled, ui updated, focus changed and\n        // seemingly something more, before we check if the focus changed\n        setTimeout(() => setTimeout(() => setTimeout(() => setTimeout(() => {\n          insertAction(actionFromKeyEvent(ev))\n        }))))\n      }\n      \n      return (\n        <>\n          <div\n            tabIndex={-1}\n            onKeyDownCapture={onKeyDown}\n            className=\"h-[70vh]\"\n          >\n            <innerBlock.Component ref={ref} state={stateInner} dispatch={dispatchInner} env={env} />\n          </div>\n          <div className=\"flex flex-row justify-stretch space-x-1\">\n            <button\n              className=\"w-full py-1 bg-blue-100 hover:bg-blue-200 rounded text-blue-900\"\n              onClick={() =>\n                dispatch(state => ({\n                  state: {\n                    ...state,\n                    inner: innerBlock.init,\n                    position: state.actions.length,\n                  }\n                }))\n              }\n            >\n              Jump start\n            </button>\n            <button\n              className=\"w-full py-1 bg-blue-100 hover:bg-blue-200 rounded text-blue-900\"\n              onClick={() =>\n                dispatch(state => ({\n                  state: {\n                    ...state,\n                    actions: state.actions.map(action => lodash.omit(action, 'stateAfter')),\n                  }\n                }))\n              }\n            >\n              Clear Checkpoints\n            </button>\n            <button\n              className=\"w-full py-1 bg-red-100 hover:bg-red-200 rounded text-red-900\"\n              onClick={() =>\n                dispatch(state => ({\n                  state: {\n                    ...state,\n                    actions: [],\n                    position: 0,\n                  }\n                }))\n              }\n            >\n              Delete all Actions\n            </button>\n            <button\n              className=\"w-full py-1 bg-blue-100 hover:bg-blue-200 rounded text-blue-900\"\n              onClick={() => {\n                const json = JSON.stringify(utils.deduper.dedup(state.actions))\n                saveFile('recording.json', new Blob([json], { type: 'application/json' }))\n              }}\n            >\n              Export Recording\n            </button>\n            <LoadFileButton\n              className=\"w-full py-1 bg-blue-100 hover:bg-blue-200 rounded text-blue-900\"\n              onLoad={async file => {\n                const json = JSON.parse(await file.text())\n                const actions = utils.deduper.dup(...json)\n                dispatch(() => ({\n                  state: {\n                    actions,\n                    position: actions.length,\n                  }\n                }))\n              }}\n            >\n              Import Recording\n            </LoadFileButton>\n\n          </div>\n          <div ref={actionsViewRef} className=\"h-[20vh] pb-5 overflow-y-auto border-t-2 border-b-2 bg-gray-50 divide-y divide-gray-100\">\n            <ActionsEditor\n              actions={state.actions}\n              position={state.position}\n              setActions={update =>\n                dispatch(state => ({\n                  state: {\n                    ...state,\n                    actions: update(state.actions),\n                  },\n                }))\n              }\n              loadState={loadState}\n              />\n          </div>\n          <RecordingPlayer\n            startJson={startJson}\n            speeds={[0.5, 0.75, 1, 1.25, 1.5, 2, 3, 4, 5]}\n            block={block}\n            recording={state.actions}\n            reportState={reportState}\n            scripts={scripts}\n            />\n        </>\n      )\n    },\n    \n    getResult(state) {\n      return <RecordingPlayer startJson={startJson} block={block} recording={state.actions} checkEvery={5} scripts={scripts} />\n    },\n    \n    recompute(state) {\n      return {\n        state,\n        invalidated: false,\n      }\n    },\n    \n    fromJSON(json) {\n      const actions = Array.isArray(json) ? utils.deduper.dedup(...json) : json.actions\n      return {\n        actions: actions,\n        position: actions.length,\n      }\n    },\n    \n    toJSON(state) {\n      return {\n        actions: state.actions.map(action => lodash.omit(action, 'stateAfter'))\n      }\n    },\n  })\n}\n"
                                                    }
                                                }
                                            }
                                        ]
                                    }
                                },
                                "isCollapsed": false,
                                "children": []
                            },
                            {
                                "id": 11,
                                "name": "RecordingLoader",
                                "state": {
                                    "t": "resheet.selector",
                                    "v": 0,
                                    "mode": "run",
                                    "expr": "SheetOf(Note)",
                                    "inner": {
                                        "t": "resheet.sheet",
                                        "v": 2,
                                        "lines": [
                                            {
                                                "id": 0,
                                                "name": "",
                                                "visibility": "block",
                                                "width": "narrow",
                                                "state": {
                                                    "t": "resheet.note",
                                                    "v": 1,
                                                    "level": 0,
                                                    "input": "# Recording Loader",
                                                    "note": {
                                                        "type": "text",
                                                        "tag": "h1",
                                                        "text": "Recording Loader"
                                                    }
                                                }
                                            },
                                            {
                                                "id": 1,
                                                "name": "",
                                                "visibility": "block",
                                                "width": "narrow",
                                                "state": {
                                                    "t": "resheet.note",
                                                    "v": 1,
                                                    "level": 0,
                                                    "input": "Load a recording and play it back.",
                                                    "note": {
                                                        "type": "text",
                                                        "tag": "p",
                                                        "text": "Load a recording and play it back."
                                                    }
                                                }
                                            },
                                            {
                                                "id": 2,
                                                "name": "",
                                                "visibility": "block",
                                                "width": "narrow",
                                                "state": {
                                                    "t": "resheet.note",
                                                    "v": 1,
                                                    "level": 0,
                                                    "input": "",
                                                    "note": {
                                                        "type": "text",
                                                        "tag": "p",
                                                        "text": ""
                                                    }
                                                }
                                            },
                                            {
                                                "id": 3,
                                                "name": "",
                                                "visibility": "block",
                                                "width": "narrow",
                                                "state": {
                                                    "t": "resheet.note",
                                                    "v": 1,
                                                    "level": 0,
                                                    "input": "/Code",
                                                    "note": {
                                                        "type": "block",
                                                        "isInstantiated": true,
                                                        "code": "Code",
                                                        "state": 'function RecordingLoader({ loadRecording, ...recordingProps }) {\n  const [recording, setRecording] = React.useState(null)\n  \n  function load() {\n    setRecording(null)\n    loadRecording().then(setRecording).catch(setRecording)\n  }\n  \n  React.useEffect(() => {\n    load()\n  }, [loadRecording])\n  \n  if (recording === null) {\n    return (\n      <div className={`\n        w-full h-[70vh]\n        rounded-lg border border-gray-100\n        bg-white shadow-lg overflow-hidden\n        flex items-center justify-center\n      `}>\n        <FontAwesomeIcon\n          className="text-yellow-400 text-5xl"\n          spinPulse\n          icon={faSolid.faSpinner}\n          />\n      </div>\n    )\n  }\n  if (recording instanceof Error) {\n    return (\n      <div className={`\n        w-full h-[70vh]\n        rounded-lg border border-gray-100\n        bg-white shadow-lg overflow-hidden\n        flex flex-col items-center justify-center space-y-4\n      `}>\n        <FontAwesomeIcon className="text-red-500 text-5xl" icon={faSolid.faTriangleExclamation} />\n        <div className="text-lg text-red-900">\n          Could not load recording\n        </div>\n        <button className="text-red-950" onClick={load}>\n          <FontAwesomeIcon icon={faSolid.faRotateLeft} /> {}\n          Retry\n        </button>\n        <resheet.code.ui.ErrorView\n          title="Could not load recording"\n          error={recording}\n          />\n      </div>\n    )\n  }\n  \n  \n  return <RecordingPlayer recording={recording} {...recordingProps} />\n}'
                                                    }
                                                }
                                            }
                                        ]
                                    }
                                },
                                "isCollapsed": false,
                                "children": []
                            }
                        ]
                    }
                ]
            },
            {
                "id": 2,
                "name": "Getting Started",
                "state": {
                    "t": "resheet.selector",
                    "v": 0,
                    "mode": "run",
                    "expr": "SheetOf(Note)",
                    "inner": {
                        "t": "resheet.sheet",
                        "v": 2,
                        "lines": [
                            {
                                "id": 0,
                                "name": "",
                                "visibility": "block",
                                "width": "narrow",
                                "state": {
                                    "t": "resheet.note",
                                    "v": 1,
                                    "level": 0,
                                    "input": "# Getting Started",
                                    "note": {
                                        "type": "text",
                                        "tag": "h1",
                                        "text": "Getting Started"
                                    }
                                }
                            },
                            {
                                "id": 86,
                                "name": "",
                                "visibility": "block",
                                "width": "narrow",
                                "state": {
                                    "t": "resheet.note",
                                    "v": 1,
                                    "level": 0,
                                    "input": "",
                                    "note": {
                                        "type": "text",
                                        "tag": "p",
                                        "text": ""
                                    }
                                }
                            },
                            {
                                "id": 87,
                                "name": "",
                                "visibility": "block",
                                "width": "narrow",
                                "state": {
                                    "t": "resheet.note",
                                    "v": 1,
                                    "level": 0,
                                    "input": "ReSheet is a notepad similar to Notion. Format your notes with Markdown:",
                                    "note": {
                                        "type": "text",
                                        "tag": "p",
                                        "text": "ReSheet is a notepad similar to Notion. Format your notes with Markdown:"
                                    }
                                }
                            },
                            {
                                "id": 102,
                                "name": "",
                                "visibility": "block",
                                "width": "narrow",
                                "state": {
                                    "t": "resheet.note",
                                    "v": 1,
                                    "level": 0,
                                    "input": "/SheetOf(Note)",
                                    "note": {
                                        "type": "block",
                                        "isInstantiated": true,
                                        "code": "SheetOf(Note)",
                                        "state": {
                                            "t": "resheet.sheet",
                                            "v": 2,
                                            "lines": [
                                                {
                                                    "id": 0,
                                                    "name": "",
                                                    "visibility": "block",
                                                    "width": "narrow",
                                                    "state": {
                                                        "t": "resheet.note",
                                                        "v": 1,
                                                        "level": 0,
                                                        "input": "**Example**",
                                                        "note": {
                                                            "type": "text",
                                                            "tag": "p",
                                                            "text": "**Example**"
                                                        }
                                                    }
                                                },
                                                {
                                                    "id": 2,
                                                    "name": "",
                                                    "visibility": "block",
                                                    "width": "narrow",
                                                    "state": {
                                                        "t": "resheet.note",
                                                        "v": 1,
                                                        "level": 0,
                                                        "input": "Formatting your text `monospace`, *italic* and **bold**",
                                                        "note": {
                                                            "type": "text",
                                                            "tag": "p",
                                                            "text": "Formatting your text `monospace`, *italic* and **bold**"
                                                        }
                                                    }
                                                },
                                                {
                                                    "id": 1,
                                                    "name": "",
                                                    "visibility": "block",
                                                    "width": "narrow",
                                                    "state": {
                                                        "t": "resheet.note",
                                                        "v": 1,
                                                        "level": 0,
                                                        "input": "[ ] A todo item",
                                                        "note": {
                                                            "type": "checkbox",
                                                            "checked": false,
                                                            "text": "A todo item"
                                                        }
                                                    }
                                                },
                                                {
                                                    "id": 3,
                                                    "name": "",
                                                    "visibility": "block",
                                                    "width": "narrow",
                                                    "state": {
                                                        "t": "resheet.note",
                                                        "v": 1,
                                                        "level": 0,
                                                        "input": "- A list item",
                                                        "note": {
                                                            "type": "text",
                                                            "tag": "li",
                                                            "text": "A list item"
                                                        }
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                }
                            },
                            {
                                "id": 101,
                                "name": "",
                                "visibility": "block",
                                "width": "narrow",
                                "state": {
                                    "t": "resheet.note",
                                    "v": 1,
                                    "level": 0,
                                    "input": "",
                                    "note": {
                                        "type": "text",
                                        "tag": "p",
                                        "text": ""
                                    }
                                }
                            },
                            {
                                "id": 108,
                                "name": "",
                                "visibility": "block",
                                "width": "narrow",
                                "state": {
                                    "t": "resheet.note",
                                    "v": 1,
                                    "level": 0,
                                    "input": "",
                                    "note": {
                                        "type": "text",
                                        "tag": "p",
                                        "text": ""
                                    }
                                }
                            },
                            {
                                "id": 109,
                                "name": "",
                                "visibility": "block",
                                "width": "narrow",
                                "state": {
                                    "t": "resheet.note",
                                    "v": 1,
                                    "level": 0,
                                    "input": "#### Formulas",
                                    "note": {
                                        "type": "text",
                                        "tag": "h4",
                                        "text": "Formulas"
                                    }
                                }
                            },
                            {
                                "id": 104,
                                "name": "",
                                "visibility": "block",
                                "width": "narrow",
                                "state": {
                                    "t": "resheet.note",
                                    "v": 1,
                                    "level": 0,
                                    "input": 'In every line you can choose to write a formula in JavaScript. Just start with a "`=`" like in a spreadsheet:',
                                    "note": {
                                        "type": "text",
                                        "tag": "p",
                                        "text": 'In every line you can choose to write a formula in JavaScript. Just start with a "`=`" like in a spreadsheet:'
                                    }
                                }
                            },
                            {
                                "id": 105,
                                "name": "",
                                "visibility": "block",
                                "width": "narrow",
                                "state": {
                                    "t": "resheet.note",
                                    "v": 1,
                                    "level": 0,
                                    "input": "/SheetOf(Note)",
                                    "note": {
                                        "type": "block",
                                        "isInstantiated": true,
                                        "code": "SheetOf(Note)",
                                        "state": {
                                            "t": "resheet.sheet",
                                            "v": 2,
                                            "lines": [
                                                {
                                                    "id": 0,
                                                    "name": "",
                                                    "visibility": "block",
                                                    "width": "narrow",
                                                    "state": {
                                                        "t": "resheet.note",
                                                        "v": 1,
                                                        "level": 0,
                                                        "input": "**Example**",
                                                        "note": {
                                                            "type": "text",
                                                            "tag": "p",
                                                            "text": "**Example**"
                                                        }
                                                    }
                                                },
                                                {
                                                    "id": 1,
                                                    "name": "",
                                                    "visibility": "block",
                                                    "width": "narrow",
                                                    "state": {
                                                        "t": "resheet.note",
                                                        "v": 1,
                                                        "level": 0,
                                                        "input": "= 12 * 12",
                                                        "note": {
                                                            "type": "expr",
                                                            "code": " 12 * 12"
                                                        }
                                                    }
                                                },
                                                {
                                                    "id": 2,
                                                    "name": "string",
                                                    "visibility": "block",
                                                    "width": "narrow",
                                                    "state": {
                                                        "t": "resheet.note",
                                                        "v": 1,
                                                        "level": 0,
                                                        "input": '= "this string has a name"',
                                                        "note": {
                                                            "type": "expr",
                                                            "code": ' "this string has a name"'
                                                        }
                                                    }
                                                },
                                                {
                                                    "id": 3,
                                                    "name": "",
                                                    "visibility": "block",
                                                    "width": "narrow",
                                                    "state": {
                                                        "t": "resheet.note",
                                                        "v": 1,
                                                        "level": 0,
                                                        "input": "= string.repeat(3)",
                                                        "note": {
                                                            "type": "expr",
                                                            "code": " string.repeat(3)"
                                                        }
                                                    }
                                                },
                                                {
                                                    "id": 4,
                                                    "name": "",
                                                    "visibility": "block",
                                                    "width": "narrow",
                                                    "state": {
                                                        "t": "resheet.note",
                                                        "v": 1,
                                                        "level": 0,
                                                        "input": '= "normally you can edit the names to the left"',
                                                        "note": {
                                                            "type": "expr",
                                                            "code": ' "normally you can edit the names to the left"'
                                                        }
                                                    }
                                                },
                                                {
                                                    "id": 5,
                                                    "name": "",
                                                    "visibility": "block",
                                                    "width": "narrow",
                                                    "state": {
                                                        "t": "resheet.note",
                                                        "v": 1,
                                                        "level": 0,
                                                        "input": '= "but when space is tight names move to the top and ..."',
                                                        "note": {
                                                            "type": "expr",
                                                            "code": ' "but when space is tight names move to the top and ..."'
                                                        }
                                                    }
                                                },
                                                {
                                                    "id": 6,
                                                    "name": "",
                                                    "visibility": "block",
                                                    "width": "narrow",
                                                    "state": {
                                                        "t": "resheet.note",
                                                        "v": 1,
                                                        "level": 0,
                                                        "input": '= "... to edit a line\'s name you have to press \u2318\u21E7R"',
                                                        "note": {
                                                            "type": "expr",
                                                            "code": ' "... to edit a line\'s name you have to press \u2318\u21E7R"'
                                                        }
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                }
                            },
                            {
                                "id": 103,
                                "name": "",
                                "visibility": "block",
                                "width": "narrow",
                                "state": {
                                    "t": "resheet.note",
                                    "v": 1,
                                    "level": 0,
                                    "input": "",
                                    "note": {
                                        "type": "text",
                                        "tag": "p",
                                        "text": ""
                                    }
                                }
                            },
                            {
                                "id": 106,
                                "name": "",
                                "visibility": "block",
                                "width": "narrow",
                                "state": {
                                    "t": "resheet.note",
                                    "v": 1,
                                    "level": 0,
                                    "input": "You can use React and tailwind.css to create custom UIs:",
                                    "note": {
                                        "type": "text",
                                        "tag": "p",
                                        "text": "You can use React and tailwind.css to create custom UIs:"
                                    }
                                }
                            },
                            {
                                "id": 107,
                                "name": "",
                                "visibility": "block",
                                "width": "narrow",
                                "state": {
                                    "t": "resheet.note",
                                    "v": 1,
                                    "level": 0,
                                    "input": "/SheetOf(Note)",
                                    "note": {
                                        "type": "block",
                                        "isInstantiated": true,
                                        "code": "SheetOf(Note)",
                                        "state": {
                                            "t": "resheet.sheet",
                                            "v": 2,
                                            "lines": [
                                                {
                                                    "id": 0,
                                                    "name": "",
                                                    "visibility": "block",
                                                    "width": "narrow",
                                                    "state": {
                                                        "t": "resheet.note",
                                                        "v": 1,
                                                        "level": 0,
                                                        "input": "**Example**",
                                                        "note": {
                                                            "type": "text",
                                                            "tag": "p",
                                                            "text": "**Example**"
                                                        }
                                                    }
                                                },
                                                {
                                                    "id": 1,
                                                    "name": "",
                                                    "visibility": "block",
                                                    "width": "narrow",
                                                    "state": {
                                                        "t": "resheet.note",
                                                        "v": 1,
                                                        "level": 0,
                                                        "input": '= <button className="rounded px-2 bg-blue-500 text-white" onClick={() => alert("Hello")}>Hello ReSheet</button>',
                                                        "note": {
                                                            "type": "expr",
                                                            "code": ' <button className="rounded px-2 bg-blue-500 text-white" onClick={() => alert("Hello")}>Hello ReSheet</button>'
                                                        }
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                }
                            },
                            {
                                "id": 110,
                                "name": "",
                                "visibility": "block",
                                "width": "narrow",
                                "state": {
                                    "t": "resheet.note",
                                    "v": 1,
                                    "level": 0,
                                    "input": "",
                                    "note": {
                                        "type": "text",
                                        "tag": "p",
                                        "text": ""
                                    }
                                }
                            },
                            {
                                "id": 111,
                                "name": "",
                                "visibility": "block",
                                "width": "narrow",
                                "state": {
                                    "t": "resheet.note",
                                    "v": 1,
                                    "level": 0,
                                    "input": "",
                                    "note": {
                                        "type": "text",
                                        "tag": "p",
                                        "text": ""
                                    }
                                }
                            },
                            {
                                "id": 112,
                                "name": "",
                                "visibility": "block",
                                "width": "narrow",
                                "state": {
                                    "t": "resheet.note",
                                    "v": 1,
                                    "level": 0,
                                    "input": "#### Blocks",
                                    "note": {
                                        "type": "text",
                                        "tag": "h4",
                                        "text": "Blocks"
                                    }
                                }
                            },
                            {
                                "id": 99,
                                "name": "",
                                "visibility": "block",
                                "width": "narrow",
                                "state": {
                                    "t": "resheet.note",
                                    "v": 1,
                                    "level": 0,
                                    "input": "Every line here is a Block. A Block can be thought of like a cell in a spreadsheet.",
                                    "note": {
                                        "type": "text",
                                        "tag": "p",
                                        "text": "Every line here is a Block. A Block can be thought of like a cell in a spreadsheet."
                                    }
                                }
                            },
                            {
                                "id": 118,
                                "name": "",
                                "visibility": "block",
                                "width": "narrow",
                                "state": {
                                    "t": "resheet.note",
                                    "v": 1,
                                    "level": 0,
                                    "input": "In this case the lines are `Note` Blocks, which implement the Markdown and Formula (and Block nesting) functionality.",
                                    "note": {
                                        "type": "text",
                                        "tag": "p",
                                        "text": "In this case the lines are `Note` Blocks, which implement the Markdown and Formula (and Block nesting) functionality."
                                    }
                                }
                            },
                            {
                                "id": 114,
                                "name": "",
                                "visibility": "block",
                                "width": "narrow",
                                "state": {
                                    "t": "resheet.note",
                                    "v": 1,
                                    "level": 0,
                                    "input": "There are other types of Blocks you can use; to use one type `/<BlockName>` and hit **\u2318Enter**:",
                                    "note": {
                                        "type": "text",
                                        "tag": "p",
                                        "text": "There are other types of Blocks you can use; to use one type `/<BlockName>` and hit **\u2318Enter**:"
                                    }
                                }
                            },
                            {
                                "id": 113,
                                "name": "",
                                "visibility": "block",
                                "width": "narrow",
                                "state": {
                                    "t": "resheet.note",
                                    "v": 1,
                                    "level": 0,
                                    "input": "/SheetOf(Note)",
                                    "note": {
                                        "type": "block",
                                        "isInstantiated": true,
                                        "code": "SheetOf(Note)",
                                        "state": {
                                            "t": "resheet.sheet",
                                            "v": 2,
                                            "lines": [
                                                {
                                                    "id": 0,
                                                    "name": "",
                                                    "visibility": "block",
                                                    "width": "narrow",
                                                    "state": {
                                                        "t": "resheet.note",
                                                        "v": 1,
                                                        "level": 0,
                                                        "input": "**Example**",
                                                        "note": {
                                                            "type": "text",
                                                            "tag": "p",
                                                            "text": "**Example**"
                                                        }
                                                    }
                                                },
                                                {
                                                    "id": 8,
                                                    "name": "",
                                                    "visibility": "block",
                                                    "width": "narrow",
                                                    "state": {
                                                        "t": "resheet.note",
                                                        "v": 1,
                                                        "level": 0,
                                                        "input": "`/Note`",
                                                        "note": {
                                                            "type": "text",
                                                            "tag": "p",
                                                            "text": "`/Note`"
                                                        }
                                                    }
                                                },
                                                {
                                                    "id": 9,
                                                    "name": "",
                                                    "visibility": "block",
                                                    "width": "narrow",
                                                    "state": {
                                                        "t": "resheet.note",
                                                        "v": 1,
                                                        "level": 0,
                                                        "input": "/Note",
                                                        "note": {
                                                            "type": "block",
                                                            "isInstantiated": true,
                                                            "code": "Note",
                                                            "state": {
                                                                "t": "resheet.note",
                                                                "v": 1,
                                                                "level": 0,
                                                                "input": "This is the `Note` Block we already know",
                                                                "note": {
                                                                    "type": "text",
                                                                    "tag": "p",
                                                                    "text": "This is the `Note` Block we already know"
                                                                }
                                                            }
                                                        }
                                                    }
                                                },
                                                {
                                                    "id": 10,
                                                    "name": "",
                                                    "visibility": "block",
                                                    "width": "narrow",
                                                    "state": {
                                                        "t": "resheet.note",
                                                        "v": 1,
                                                        "level": 0,
                                                        "input": "",
                                                        "note": {
                                                            "type": "text",
                                                            "tag": "p",
                                                            "text": ""
                                                        }
                                                    }
                                                },
                                                {
                                                    "id": 3,
                                                    "name": "",
                                                    "visibility": "block",
                                                    "width": "narrow",
                                                    "state": {
                                                        "t": "resheet.note",
                                                        "v": 1,
                                                        "level": 0,
                                                        "input": "`/LoadFile`",
                                                        "note": {
                                                            "type": "text",
                                                            "tag": "p",
                                                            "text": "`/LoadFile`"
                                                        }
                                                    }
                                                },
                                                {
                                                    "id": 4,
                                                    "name": "tasksFile",
                                                    "visibility": "block",
                                                    "width": "narrow",
                                                    "state": {
                                                        "t": "resheet.note",
                                                        "v": 1,
                                                        "level": 0,
                                                        "input": "/LoadFile",
                                                        "note": {
                                                            "type": "block",
                                                            "isInstantiated": true,
                                                            "code": "LoadFile",
                                                            "state": {
                                                                "state": "loaded",
                                                                "file": {
                                                                    "content": "WwogIHsgInRhc2siOiAiQ2xlYW51cCIsICJkdXJhdGlvbiI6IDQsICAgImJyZWFrIjogMSB9LAogIHsgInRhc2siOiAiQ2xlYW51cCIsICJkdXJhdGlvbiI6IDUuNSwgImJyZWFrIjogMC4zIH0sCiAgeyAidGFzayI6ICJGZWF0dXJlIiwgImR1cmF0aW9uIjogOC4zLCAiYnJlYWsiOiAxLjUgfSwKICB7ICJ0YXNrIjogIkZlYXR1cmUiLCAiZHVyYXRpb24iOiAzLjUsICJicmVhayI6IDAgfQpdCg==",
                                                                    "name": "tasks.json",
                                                                    "options": {
                                                                        "type": "application/json",
                                                                        "lastModified": 1715249897272
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                },
                                                {
                                                    "id": 5,
                                                    "name": "",
                                                    "visibility": "block",
                                                    "width": "narrow",
                                                    "state": {
                                                        "t": "resheet.note",
                                                        "v": 1,
                                                        "level": 0,
                                                        "input": "",
                                                        "note": {
                                                            "type": "text",
                                                            "tag": "p",
                                                            "text": ""
                                                        }
                                                    }
                                                },
                                                {
                                                    "id": 6,
                                                    "name": "tasks",
                                                    "visibility": "block",
                                                    "width": "narrow",
                                                    "state": {
                                                        "t": "resheet.note",
                                                        "v": 1,
                                                        "level": 0,
                                                        "input": "= JSON.parse(await tasksFile.text())",
                                                        "note": {
                                                            "type": "expr",
                                                            "code": " JSON.parse(await tasksFile.text())"
                                                        }
                                                    }
                                                },
                                                {
                                                    "id": 7,
                                                    "name": "",
                                                    "visibility": "block",
                                                    "width": "narrow",
                                                    "state": {
                                                        "t": "resheet.note",
                                                        "v": 1,
                                                        "level": 0,
                                                        "input": "",
                                                        "note": {
                                                            "type": "text",
                                                            "tag": "p",
                                                            "text": ""
                                                        }
                                                    }
                                                },
                                                {
                                                    "id": 1,
                                                    "name": "",
                                                    "visibility": "block",
                                                    "width": "narrow",
                                                    "state": {
                                                        "t": "resheet.note",
                                                        "v": 1,
                                                        "level": 0,
                                                        "input": "`/Code`",
                                                        "note": {
                                                            "type": "text",
                                                            "tag": "p",
                                                            "text": "`/Code`"
                                                        }
                                                    }
                                                },
                                                {
                                                    "id": 2,
                                                    "name": "",
                                                    "visibility": "block",
                                                    "width": "narrow",
                                                    "state": {
                                                        "t": "resheet.note",
                                                        "v": 1,
                                                        "level": 0,
                                                        "input": "/Code",
                                                        "note": {
                                                            "type": "block",
                                                            "isInstantiated": true,
                                                            "code": "Code",
                                                            "state": "// This is a Code Block, useful for multiline scripts:\nlodash(tasks)\n  .groupBy('task')\n  .mapValues(task => lodash.sumBy(task, 'duration'))\n  .value()"
                                                        }
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                }
                            },
                            {
                                "id": 100,
                                "name": "",
                                "visibility": "block",
                                "width": "narrow",
                                "state": {
                                    "t": "resheet.note",
                                    "v": 1,
                                    "level": 0,
                                    "input": "",
                                    "note": {
                                        "type": "text",
                                        "tag": "p",
                                        "text": ""
                                    }
                                }
                            },
                            {
                                "id": 124,
                                "name": "",
                                "visibility": "block",
                                "width": "narrow",
                                "state": {
                                    "t": "resheet.note",
                                    "v": 1,
                                    "level": 0,
                                    "input": "###### Advanced Block Usage",
                                    "note": {
                                        "type": "text",
                                        "tag": "h6",
                                        "text": "Advanced Block Usage"
                                    }
                                }
                            },
                            {
                                "id": 125,
                                "name": "",
                                "visibility": "block",
                                "width": "narrow",
                                "state": {
                                    "t": "resheet.note",
                                    "v": 1,
                                    "level": 0,
                                    "input": 'Blocks are very powerful. They can be combined and nested. You can even write your own custom Blocks within ReSheet. See the pages "Getting Started > Blocks" and "Examples > Custom Blocks" for more details. "Examples > Interactive Game Dev" may give a glimpse of the possibilities of custom Blocks.',
                                    "note": {
                                        "type": "text",
                                        "tag": "p",
                                        "text": 'Blocks are very powerful. They can be combined and nested. You can even write your own custom Blocks within ReSheet. See the pages "Getting Started > Blocks" and "Examples > Custom Blocks" for more details. "Examples > Interactive Game Dev" may give a glimpse of the possibilities of custom Blocks.'
                                    }
                                }
                            },
                            {
                                "id": 115,
                                "name": "",
                                "visibility": "block",
                                "width": "narrow",
                                "state": {
                                    "t": "resheet.note",
                                    "v": 1,
                                    "level": 0,
                                    "input": "",
                                    "note": {
                                        "type": "text",
                                        "tag": "p",
                                        "text": ""
                                    }
                                }
                            },
                            {
                                "id": 121,
                                "name": "",
                                "visibility": "block",
                                "width": "narrow",
                                "state": {
                                    "t": "resheet.note",
                                    "v": 1,
                                    "level": 0,
                                    "input": "",
                                    "note": {
                                        "type": "text",
                                        "tag": "p",
                                        "text": ""
                                    }
                                }
                            },
                            {
                                "id": 116,
                                "name": "",
                                "visibility": "block",
                                "width": "narrow",
                                "state": {
                                    "t": "resheet.note",
                                    "v": 1,
                                    "level": 0,
                                    "input": "#### Interaction",
                                    "note": {
                                        "type": "text",
                                        "tag": "h4",
                                        "text": "Interaction"
                                    }
                                }
                            },
                            {
                                "id": 85,
                                "name": "",
                                "visibility": "block",
                                "width": "narrow",
                                "state": {
                                    "t": "resheet.note",
                                    "v": 1,
                                    "level": 0,
                                    "input": "ReSheet is heavily keyboard-focused:",
                                    "note": {
                                        "type": "text",
                                        "tag": "p",
                                        "text": "ReSheet is heavily keyboard-focused:"
                                    }
                                }
                            },
                            {
                                "id": 120,
                                "name": "",
                                "visibility": "block",
                                "width": "narrow",
                                "state": {
                                    "t": "resheet.note",
                                    "v": 1,
                                    "level": 0,
                                    "input": "/SheetOf(Note)",
                                    "note": {
                                        "type": "block",
                                        "isInstantiated": true,
                                        "code": "SheetOf(Note)",
                                        "state": {
                                            "t": "resheet.sheet",
                                            "v": 2,
                                            "lines": [
                                                {
                                                    "id": 1,
                                                    "name": "",
                                                    "visibility": "block",
                                                    "width": "narrow",
                                                    "state": {
                                                        "t": "resheet.note",
                                                        "v": 1,
                                                        "level": 0,
                                                        "input": "- Use **\u2318K/\u2318\u21E7P** to search all commands for the currently focused block(s) and their parents.",
                                                        "note": {
                                                            "type": "text",
                                                            "tag": "li",
                                                            "text": "Use **\u2318K/\u2318\u21E7P** to search all commands for the currently focused block(s) and their parents."
                                                        }
                                                    }
                                                },
                                                {
                                                    "id": 6,
                                                    "name": "",
                                                    "visibility": "block",
                                                    "width": "narrow",
                                                    "state": {
                                                        "t": "resheet.note",
                                                        "v": 1,
                                                        "level": 0,
                                                        "input": "-  Use **\u2318?** to display all currently available shortcuts",
                                                        "note": {
                                                            "type": "text",
                                                            "tag": "li",
                                                            "text": "Use **\u2318?** to display all currently available shortcuts"
                                                        }
                                                    }
                                                },
                                                {
                                                    "id": 2,
                                                    "name": "",
                                                    "visibility": "block",
                                                    "width": "narrow",
                                                    "state": {
                                                        "t": "resheet.note",
                                                        "v": 1,
                                                        "level": 0,
                                                        "input": "- Use the **ArrowKeys** or **`H`/`J`/`K`/`L`** and **`Enter`/`Escape`** to move between Blocks.",
                                                        "note": {
                                                            "type": "text",
                                                            "tag": "li",
                                                            "text": "Use the **ArrowKeys** or **`H`/`J`/`K`/`L`** and **`Enter`/`Escape`** to move between Blocks."
                                                        }
                                                    }
                                                },
                                                {
                                                    "id": 3,
                                                    "name": "",
                                                    "visibility": "block",
                                                    "width": "narrow",
                                                    "state": {
                                                        "t": "resheet.note",
                                                        "v": 1,
                                                        "level": 0,
                                                        "input": "",
                                                        "note": {
                                                            "type": "text",
                                                            "tag": "p",
                                                            "text": ""
                                                        }
                                                    }
                                                },
                                                {
                                                    "id": 5,
                                                    "name": "",
                                                    "visibility": "block",
                                                    "width": "narrow",
                                                    "state": {
                                                        "t": "resheet.note",
                                                        "v": 1,
                                                        "level": 0,
                                                        "input": "*\u2318 = Meta = Ctrl (can be used interchangeably, useful if the browser intercepts a variant)*",
                                                        "note": {
                                                            "type": "text",
                                                            "tag": "p",
                                                            "text": "*\u2318 = Meta = Ctrl (can be used interchangeably, useful if the browser intercepts a variant)*"
                                                        }
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                }
                            }
                        ]
                    }
                },
                "isCollapsed": false,
                "children": [
                    {
                        "id": 1,
                        "name": "Formulas",
                        "state": {
                            "t": "resheet.selector",
                            "v": 0,
                            "mode": "run",
                            "expr": "SheetOf(Note)",
                            "inner": {
                                "t": "resheet.sheet",
                                "v": 2,
                                "lines": [
                                    {
                                        "id": 0,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "# Formulas",
                                            "note": {
                                                "type": "text",
                                                "tag": "h1",
                                                "text": "Formulas"
                                            }
                                        }
                                    },
                                    {
                                        "id": 1,
                                        "name": "msInADay",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "= 24 /*h*/ * 60 /*min*/ * 60 /*sec*/ * 1000 /*ms*/",
                                            "note": {
                                                "type": "expr",
                                                "code": " 24 /*h*/ * 60 /*min*/ * 60 /*sec*/ * 1000 /*ms*/"
                                            }
                                        }
                                    },
                                    {
                                        "id": 2,
                                        "name": "startOfThisYear",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "= new Date(new Date().getFullYear(), 0, 1)",
                                            "note": {
                                                "type": "expr",
                                                "code": " new Date(new Date().getFullYear(), 0, 1)"
                                            }
                                        }
                                    },
                                    {
                                        "id": 3,
                                        "name": "daysInThisYear",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "= (Date.now() - startOfThisYear.getTime()) / msInADay",
                                            "note": {
                                                "type": "expr",
                                                "code": " (Date.now() - startOfThisYear.getTime()) / msInADay"
                                            }
                                        }
                                    },
                                    {
                                        "id": 4,
                                        "name": "",
                                        "visibility": "result",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": '= // using react:\n<p className="py-2">\n  This year is already {/* preserve the space character before this comment */}\n  {daysInThisYear.toLocaleString("en-US", { maximumFractionDigits: 1 })}\n  {} days long. {}\n  <span className="text-sm text-gray-700">(Double-click on this line to show or hide the code)</span>\n</p>',
                                            "note": {
                                                "type": "expr",
                                                "code": ' // using react:\n<p className="py-2">\n  This year is already {/* preserve the space character before this comment */}\n  {daysInThisYear.toLocaleString("en-US", { maximumFractionDigits: 1 })}\n  {} days long. {}\n  <span className="text-sm text-gray-700">(Double-click on this line to show or hide the code)</span>\n</p>'
                                            }
                                        }
                                    },
                                    {
                                        "id": 30,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 35,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "---",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": "---"
                                            }
                                        }
                                    },
                                    {
                                        "id": 31,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "**Important**",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": "**Important**"
                                            }
                                        }
                                    },
                                    {
                                        "id": 32,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "Don't mutate values of other cells. ReSheet is designed to be used like a functional language.",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": "Don't mutate values of other cells. ReSheet is designed to be used like a functional language."
                                            }
                                        }
                                    },
                                    {
                                        "id": 33,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "*Side note:* This is just like any other Spreadsheet works. You can't write formulas that change another cell's value. Cells only change because the values of other cells they depend on change.",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": "*Side note:* This is just like any other Spreadsheet works. You can't write formulas that change another cell's value. Cells only change because the values of other cells they depend on change."
                                            }
                                        }
                                    },
                                    {
                                        "id": 34,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "---",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": "---"
                                            }
                                        }
                                    },
                                    {
                                        "id": 36,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 5,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "## External Libraries",
                                            "note": {
                                                "type": "text",
                                                "tag": "h2",
                                                "text": "External Libraries"
                                            }
                                        }
                                    },
                                    {
                                        "id": 6,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "[esm.sh](https://esm.sh/) works great for loading npm libraries",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": "[esm.sh](https://esm.sh/) works great for loading npm libraries"
                                            }
                                        }
                                    },
                                    {
                                        "id": 42,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 14,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "### Number Formatting",
                                            "note": {
                                                "type": "text",
                                                "tag": "h3",
                                                "text": "Number Formatting"
                                            }
                                        }
                                    },
                                    {
                                        "id": 7,
                                        "name": "numeral",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "= import('https://esm.sh/numeral')",
                                            "note": {
                                                "type": "expr",
                                                "code": " import('https://esm.sh/numeral')"
                                            }
                                        }
                                    },
                                    {
                                        "id": 8,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "= numeral.default(123456.789).format('0,0.00')",
                                            "note": {
                                                "type": "expr",
                                                "code": " numeral.default(123456.789).format('0,0.00')"
                                            }
                                        }
                                    },
                                    {
                                        "id": 41,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 10,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "### CSV Parsing",
                                            "note": {
                                                "type": "text",
                                                "tag": "h3",
                                                "text": "CSV Parsing"
                                            }
                                        }
                                    },
                                    {
                                        "id": 11,
                                        "name": "Papa",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "= import('https://esm.sh/papaparse')",
                                            "note": {
                                                "type": "expr",
                                                "code": " import('https://esm.sh/papaparse')"
                                            }
                                        }
                                    },
                                    {
                                        "id": 12,
                                        "name": "csv",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "id,name,age,plan,email\n0,John,28,free,john@example.com\n1,Alice,34,premium,alice@boo\n2,Bob,43,premium,bob@b.b",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": "id,name,age,plan,email\n0,John,28,free,john@example.com\n1,Alice,34,premium,alice@boo\n2,Bob,43,premium,bob@b.b"
                                            }
                                        }
                                    },
                                    {
                                        "id": 13,
                                        "name": "data",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "= Papa.default.parse(csv.text, { header: true }).data",
                                            "note": {
                                                "type": "expr",
                                                "code": " Papa.default.parse(csv.text, { header: true }).data"
                                            }
                                        }
                                    },
                                    {
                                        "id": 40,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 15,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "### Data Validation",
                                            "note": {
                                                "type": "text",
                                                "tag": "h3",
                                                "text": "Data Validation"
                                            }
                                        }
                                    },
                                    {
                                        "id": 16,
                                        "name": "validator",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "= import('https://esm.sh/validator')",
                                            "note": {
                                                "type": "expr",
                                                "code": " import('https://esm.sh/validator')"
                                            }
                                        }
                                    },
                                    {
                                        "id": 17,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "= data.map(user => ({ ...user, validEmail: validator.default.isEmail(user.email) }))",
                                            "note": {
                                                "type": "expr",
                                                "code": " data.map(user => ({ ...user, validEmail: validator.default.isEmail(user.email) }))"
                                            }
                                        }
                                    },
                                    {
                                        "id": 39,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 18,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "### Data Processing",
                                            "note": {
                                                "type": "text",
                                                "tag": "h3",
                                                "text": "Data Processing"
                                            }
                                        }
                                    },
                                    {
                                        "id": 19,
                                        "name": "lodash",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "= import('https://esm.sh/lodash')",
                                            "note": {
                                                "type": "expr",
                                                "code": " import('https://esm.sh/lodash')"
                                            }
                                        }
                                    },
                                    {
                                        "id": 20,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "= lodash.default.groupBy(data, 'plan')",
                                            "note": {
                                                "type": "expr",
                                                "code": " lodash.default.groupBy(data, 'plan')"
                                            }
                                        }
                                    },
                                    {
                                        "id": 38,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 21,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "### Dates",
                                            "note": {
                                                "type": "text",
                                                "tag": "h3",
                                                "text": "Dates"
                                            }
                                        }
                                    },
                                    {
                                        "id": 22,
                                        "name": "datefns",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "= import('https://esm.sh/date-fns')",
                                            "note": {
                                                "type": "expr",
                                                "code": " import('https://esm.sh/date-fns')"
                                            }
                                        }
                                    },
                                    {
                                        "id": 23,
                                        "name": "startOfThisyear",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "= datefns.startOfYear(new Date())",
                                            "note": {
                                                "type": "expr",
                                                "code": " datefns.startOfYear(new Date())"
                                            }
                                        }
                                    },
                                    {
                                        "id": 28,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "= datefns.differenceInDays(new Date(), startOfThisYear)",
                                            "note": {
                                                "type": "expr",
                                                "code": " datefns.differenceInDays(new Date(), startOfThisYear)"
                                            }
                                        }
                                    },
                                    {
                                        "id": 29,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "= datefns.getDayOfYear(new Date())",
                                            "note": {
                                                "type": "expr",
                                                "code": " datefns.getDayOfYear(new Date())"
                                            }
                                        }
                                    },
                                    {
                                        "id": 37,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 24,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "### Charts",
                                            "note": {
                                                "type": "text",
                                                "tag": "h3",
                                                "text": "Charts"
                                            }
                                        }
                                    },
                                    {
                                        "id": 25,
                                        "name": "recharts",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "= import('https://esm.sh/recharts?external=react')",
                                            "note": {
                                                "type": "expr",
                                                "code": " import('https://esm.sh/recharts?external=react')"
                                            }
                                        }
                                    },
                                    {
                                        "id": 27,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "/Code",
                                            "note": {
                                                "type": "block",
                                                "isInstantiated": true,
                                                "code": "Code",
                                                "state": 'const { ResponsiveContainer, BarChart, Bar, XAxis, YAxis } = recharts;\n\n<ResponsiveContainer height={400}>\n  <BarChart data={data}>\n    <Bar type="monotone" dataKey="age" fill="#8884d8" />\n    <XAxis dataKey="name"/>\n    <YAxis/>\n  </BarChart>\n</ResponsiveContainer>'
                                            }
                                        }
                                    }
                                ]
                            }
                        },
                        "isCollapsed": true,
                        "children": []
                    },
                    {
                        "id": 3,
                        "name": "Blocks",
                        "state": {
                            "t": "resheet.selector",
                            "v": 0,
                            "mode": "run",
                            "expr": "SheetOf(Note)",
                            "inner": {
                                "t": "resheet.sheet",
                                "v": 2,
                                "lines": [
                                    {
                                        "id": 0,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "# Blocks",
                                            "note": {
                                                "type": "text",
                                                "tag": "h1",
                                                "text": "Blocks"
                                            }
                                        }
                                    },
                                    {
                                        "id": 1,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "Blocks are the equivalent to cells in a spreadsheet. Most things in ReSheet are Blocks.",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": "Blocks are the equivalent to cells in a spreadsheet. Most things in ReSheet are Blocks."
                                            }
                                        }
                                    },
                                    {
                                        "id": 3,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 2,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": 'Every line here contains a `Note` Block, which allows writing Markdown or Formulas (e.g. "`= 1 + 1`").',
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": 'Every line here contains a `Note` Block, which allows writing Markdown or Formulas (e.g. "`= 1 + 1`").'
                                            }
                                        }
                                    },
                                    {
                                        "id": 4,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "A `Note` Block also allows using another Block, for example `Code`. Type in an empty line:",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": "A `Note` Block also allows using another Block, for example `Code`. Type in an empty line:"
                                            }
                                        }
                                    },
                                    {
                                        "id": 5,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "`/Code`",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": "`/Code`"
                                            }
                                        }
                                    },
                                    {
                                        "id": 6,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "and after hitting \u2318`Enter` you get:",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": "and after hitting \u2318`Enter` you get:"
                                            }
                                        }
                                    },
                                    {
                                        "id": 7,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "/Code",
                                            "note": {
                                                "type": "block",
                                                "isInstantiated": true,
                                                "code": "Code",
                                                "state": '// This is a Code Block now\nfunction Mark({ children }) {\n  return (\n    <span className="before:block before:absolute before:-inset-0.5 before:-skew-y-2 before:bg-blue-400 relative inline-block">\n      <span className="relative text-white px-0.5 tracking-wide">\n        {children}\n      </span>\n    </span>\n  )\n}\n\n<p className="py-1">\n  <Mark>Look</Mark> at it!\n</p>'
                                            }
                                        }
                                    },
                                    {
                                        "id": 8,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 9,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "All lines here are part of the `SheetOf` Block:",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": "All lines here are part of the `SheetOf` Block:"
                                            }
                                        }
                                    },
                                    {
                                        "id": 10,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "`/SheetOf(Note)`",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": "`/SheetOf(Note)`"
                                            }
                                        }
                                    },
                                    {
                                        "id": 11,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "/SheetOf(Note)",
                                            "note": {
                                                "type": "block",
                                                "isInstantiated": true,
                                                "code": "SheetOf(Note)",
                                                "state": {
                                                    "t": "resheet.sheet",
                                                    "v": 2,
                                                    "lines": [
                                                        {
                                                            "id": 0,
                                                            "name": "",
                                                            "visibility": "block",
                                                            "width": "narrow",
                                                            "state": {
                                                                "t": "resheet.note",
                                                                "v": 1,
                                                                "level": 0,
                                                                "input": "Now we have a Sheet inside of a Sheet",
                                                                "note": {
                                                                    "type": "text",
                                                                    "tag": "p",
                                                                    "text": "Now we have a Sheet inside of a Sheet"
                                                                }
                                                            }
                                                        },
                                                        {
                                                            "id": 1,
                                                            "name": "",
                                                            "visibility": "block",
                                                            "width": "narrow",
                                                            "state": {
                                                                "t": "resheet.note",
                                                                "v": 1,
                                                                "level": 0,
                                                                "input": "= $9.text",
                                                                "note": {
                                                                    "type": "expr",
                                                                    "code": " $9.text"
                                                                }
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        }
                                    },
                                    {
                                        "id": 12,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 13,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 14,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "There are other Blocks available in `blocks`. (Use completion/docs with \u2318`Space`/\u2318`D`)",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": "There are other Blocks available in `blocks`. (Use completion/docs with \u2318`Space`/\u2318`D`)"
                                            }
                                        }
                                    },
                                    {
                                        "id": 15,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "= blocks",
                                            "note": {
                                                "type": "expr",
                                                "code": " blocks"
                                            }
                                        }
                                    },
                                    {
                                        "id": 16,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 17,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "## Custom Blocks",
                                            "note": {
                                                "type": "text",
                                                "tag": "h2",
                                                "text": "Custom Blocks"
                                            }
                                        }
                                    },
                                    {
                                        "id": 18,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": 'You can build your own blocks. In Examples > "Custom Blocks" you can see more elaborate examples. For now you either have to shoot me a message or look at the source code of the existing Blocks to find out more.',
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": 'You can build your own blocks. In Examples > "Custom Blocks" you can see more elaborate examples. For now you either have to shoot me a message or look at the source code of the existing Blocks to find out more.'
                                            }
                                        }
                                    },
                                    {
                                        "id": 19,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 20,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "Ok, I'll give you a small example:",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": "Ok, I'll give you a small example:"
                                            }
                                        }
                                    },
                                    {
                                        "id": 21,
                                        "name": "RAW",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "/Code",
                                            "note": {
                                                "type": "block",
                                                "isInstantiated": true,
                                                "code": "Code",
                                                "state": "resheet.core.block.create({\n  init: \"\",\n  view({ state, dispatch, env }, ref) {\n    return (\n      <textarea\n        ref={ref}\n        value={state}\n        onChange={ev => dispatch(stateBefore => ({ state: ev.target.value }))}\n        rows={state.split('\\n').length}\n        />\n    )\n  },\n  recompute(state, update, env) {\n    return { state, invalidated: false }\n  },\n  getResult(state) {\n    return state\n  },\n  fromJSON(json) {\n    return typeof json === 'string' ? json : ''\n  },\n  toJSON(state) {\n    return state\n  },\n})"
                                            }
                                        }
                                    },
                                    {
                                        "id": 22,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "`/RAW`",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": "`/RAW`"
                                            }
                                        }
                                    },
                                    {
                                        "id": 23,
                                        "name": "rawText",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "/RAW",
                                            "note": {
                                                "type": "block",
                                                "isInstantiated": true,
                                                "code": "RAW",
                                                "state": '{\n  "hello": "world"\n}'
                                            }
                                        }
                                    },
                                    {
                                        "id": 24,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "= JSON.parse(rawText)",
                                            "note": {
                                                "type": "expr",
                                                "code": " JSON.parse(rawText)"
                                            }
                                        }
                                    }
                                ]
                            }
                        },
                        "isCollapsed": true,
                        "children": []
                    },
                    {
                        "id": 0,
                        "name": "Notes",
                        "state": {
                            "t": "resheet.selector",
                            "v": 0,
                            "mode": "run",
                            "expr": "SheetOf(Note)",
                            "inner": {
                                "t": "resheet.sheet",
                                "v": 2,
                                "lines": [
                                    {
                                        "id": 13,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "# Notes",
                                            "note": {
                                                "type": "text",
                                                "tag": "h1",
                                                "text": "Notes"
                                            }
                                        }
                                    },
                                    {
                                        "id": 19,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "#### Your Responsibility",
                                            "note": {
                                                "type": "text",
                                                "tag": "h4",
                                                "text": "Your Responsibility"
                                            }
                                        }
                                    },
                                    {
                                        "id": 20,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "ReSheet gives you the full power of JavaScript and React.",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": "ReSheet gives you the full power of JavaScript and React."
                                            }
                                        }
                                    },
                                    {
                                        "id": 21,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "**Be aware:** You have the **power to break it** (but generally you can undo it \u2013 \u2318Z) and full responsibilty to **ensure you trust the code you run**.",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": "**Be aware:** You have the **power to break it** (but generally you can undo it \u2013 \u2318Z) and full responsibilty to **ensure you trust the code you run**."
                                            }
                                        }
                                    },
                                    {
                                        "id": 22,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "Also beware of side-effects in your code: Everything is automatically rerun as needed (for changes), so side-effects may execute for every character you type.",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": "Also beware of side-effects in your code: Everything is automatically rerun as needed (for changes), so side-effects may execute for every character you type."
                                            }
                                        }
                                    },
                                    {
                                        "id": 23,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 14,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "#### Privacy and Data",
                                            "note": {
                                                "type": "text",
                                                "tag": "h4",
                                                "text": "Privacy and Data"
                                            }
                                        }
                                    },
                                    {
                                        "id": 15,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "ReSheet operates local-only. Your documents reside 100% on your devices. They are not stored or sent anywhere on/to a server. All computations happen locally in your browser.",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": "ReSheet operates local-only. Your documents reside 100% on your devices. They are not stored or sent anywhere on/to a server. All computations happen locally in your browser."
                                            }
                                        }
                                    },
                                    {
                                        "id": 17,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": 'Your documents are automatically backed up to IndexedDB, so you don\'t lose them because of accidentally reloading or closing ReSheet. The backups get deleted after 7 days since last opening them. To persist your documents use the "Save File" and "Load local File ..." actions in the File menu.',
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": 'Your documents are automatically backed up to IndexedDB, so you don\'t lose them because of accidentally reloading or closing ReSheet. The backups get deleted after 7 days since last opening them. To persist your documents use the "Save File" and "Load local File ..." actions in the File menu.'
                                            }
                                        }
                                    },
                                    {
                                        "id": 16,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "ReSheet collects some very basic analytics like visitor count, visit time, browser type and OS without any personally identifiable information with [umami.is](https://umami.is).",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": "ReSheet collects some very basic analytics like visitor count, visit time, browser type and OS without any personally identifiable information with [umami.is](https://umami.is)."
                                            }
                                        }
                                    },
                                    {
                                        "id": 7,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 24,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "#### Shortcuts",
                                            "note": {
                                                "type": "text",
                                                "tag": "h4",
                                                "text": "Shortcuts"
                                            }
                                        }
                                    },
                                    {
                                        "id": 8,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "If a shortcut triggers a browser action, try an alternative key combination by switching \u2318/Meta/Ctrl.",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": "If a shortcut triggers a browser action, try an alternative key combination by switching \u2318/Meta/Ctrl."
                                            }
                                        }
                                    },
                                    {
                                        "id": 9,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "For example:",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": "For example:"
                                            }
                                        }
                                    },
                                    {
                                        "id": 10,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 1,
                                            "input": "\u2318N = Meta-N = Ctrl-N",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": "\u2318N = Meta-N = Ctrl-N"
                                            }
                                        }
                                    },
                                    {
                                        "id": 11,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 1,
                                            "input": "\u2318\u21E7P = Meta-Shift-P = Ctrl-Shift-P",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": "\u2318\u21E7P = Meta-Shift-P = Ctrl-Shift-P"
                                            }
                                        }
                                    },
                                    {
                                        "id": 12,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 1,
                                            "input": "etc",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": "etc"
                                            }
                                        }
                                    }
                                ]
                            }
                        },
                        "isCollapsed": true,
                        "children": []
                    }
                ]
            },
            {
                "id": 1,
                "name": "Examples",
                "state": {
                    "t": "resheet.selector",
                    "v": 0,
                    "mode": "run",
                    "expr": "SheetOf(Note)",
                    "inner": {
                        "t": "resheet.sheet",
                        "v": 2,
                        "lines": [
                            {
                                "id": 0,
                                "name": "",
                                "visibility": "block",
                                "width": "narrow",
                                "state": {
                                    "t": "resheet.note",
                                    "v": 1,
                                    "level": 0,
                                    "input": "# Examples",
                                    "note": {
                                        "type": "text",
                                        "tag": "h1",
                                        "text": "Examples"
                                    }
                                }
                            },
                            {
                                "id": 1,
                                "name": "",
                                "visibility": "block",
                                "width": "narrow",
                                "state": {
                                    "t": "resheet.note",
                                    "v": 1,
                                    "level": 0,
                                    "input": 'The following examples reside in subpages. You find them in the sidebar on the left inside "Examples".',
                                    "note": {
                                        "type": "text",
                                        "tag": "p",
                                        "text": 'The following examples reside in subpages. You find them in the sidebar on the left inside "Examples".'
                                    }
                                }
                            },
                            {
                                "id": 49,
                                "name": "",
                                "visibility": "block",
                                "width": "narrow",
                                "state": {
                                    "t": "resheet.note",
                                    "v": 1,
                                    "level": 0,
                                    "input": "",
                                    "note": {
                                        "type": "text",
                                        "tag": "p",
                                        "text": ""
                                    }
                                }
                            },
                            {
                                "id": 50,
                                "name": "",
                                "visibility": "block",
                                "width": "narrow",
                                "state": {
                                    "t": "resheet.note",
                                    "v": 1,
                                    "level": 0,
                                    "input": "All example content (text, design and code) is licensed under [CC0](https://creativecommons.org/public-domain/cc0/) (public domain). Use and adapt it to your needs however you want. \uD83D\uDE42",
                                    "note": {
                                        "type": "text",
                                        "tag": "p",
                                        "text": "All example content (text, design and code) is licensed under [CC0](https://creativecommons.org/public-domain/cc0/) (public domain). Use and adapt it to your needs however you want. \uD83D\uDE42"
                                    }
                                }
                            },
                            {
                                "id": 24,
                                "name": "",
                                "visibility": "block",
                                "width": "narrow",
                                "state": {
                                    "t": "resheet.note",
                                    "v": 1,
                                    "level": 0,
                                    "input": "",
                                    "note": {
                                        "type": "text",
                                        "tag": "p",
                                        "text": ""
                                    }
                                }
                            },
                            {
                                "id": 26,
                                "name": "",
                                "visibility": "block",
                                "width": "narrow",
                                "state": {
                                    "t": "resheet.note",
                                    "v": 1,
                                    "level": 0,
                                    "input": "",
                                    "note": {
                                        "type": "text",
                                        "tag": "p",
                                        "text": ""
                                    }
                                }
                            },
                            {
                                "id": 27,
                                "name": "",
                                "visibility": "block",
                                "width": "wide",
                                "state": {
                                    "t": "resheet.note",
                                    "v": 1,
                                    "level": 0,
                                    "input": "----",
                                    "note": {
                                        "type": "text",
                                        "tag": "p",
                                        "text": "----"
                                    }
                                }
                            },
                            {
                                "id": 25,
                                "name": "",
                                "visibility": "block",
                                "width": "narrow",
                                "state": {
                                    "t": "resheet.note",
                                    "v": 1,
                                    "level": 0,
                                    "input": "",
                                    "note": {
                                        "type": "text",
                                        "tag": "p",
                                        "text": ""
                                    }
                                }
                            },
                            {
                                "id": 2,
                                "name": "",
                                "visibility": "block",
                                "width": "narrow",
                                "state": {
                                    "t": "resheet.note",
                                    "v": 1,
                                    "level": 0,
                                    "input": "## Personal Finances",
                                    "note": {
                                        "type": "text",
                                        "tag": "h2",
                                        "text": "Personal Finances"
                                    }
                                }
                            },
                            {
                                "id": 3,
                                "name": "",
                                "visibility": "block",
                                "width": "narrow",
                                "state": {
                                    "t": "resheet.note",
                                    "v": 1,
                                    "level": 0,
                                    "input": "Load and parse a CSV file, process and display the data in a chart.",
                                    "note": {
                                        "type": "text",
                                        "tag": "p",
                                        "text": "Load and parse a CSV file, process and display the data in a chart."
                                    }
                                }
                            },
                            {
                                "id": 8,
                                "name": "",
                                "visibility": "result",
                                "width": "narrow",
                                "state": {
                                    "t": "resheet.note",
                                    "v": 1,
                                    "level": 0,
                                    "input": "/Code",
                                    "note": {
                                        "type": "block",
                                        "isInstantiated": true,
                                        "code": "Code",
                                        "state": '<div className="m-4 p-3 rounded border bg-gray-50">\n  <h2 className="font-medium text-xl border-b">\n    Personal Finances Preview\n  </h2>\n  {$`Personal Finances`}\n</div>'
                                    }
                                }
                            },
                            {
                                "id": 10,
                                "name": "",
                                "visibility": "block",
                                "width": "narrow",
                                "state": {
                                    "t": "resheet.note",
                                    "v": 1,
                                    "level": 0,
                                    "input": "",
                                    "note": {
                                        "type": "text",
                                        "tag": "p",
                                        "text": ""
                                    }
                                }
                            },
                            {
                                "id": 20,
                                "name": "",
                                "visibility": "block",
                                "width": "narrow",
                                "state": {
                                    "t": "resheet.note",
                                    "v": 1,
                                    "level": 0,
                                    "input": "",
                                    "note": {
                                        "type": "text",
                                        "tag": "p",
                                        "text": ""
                                    }
                                }
                            },
                            {
                                "id": 41,
                                "name": "",
                                "visibility": "block",
                                "width": "wide",
                                "state": {
                                    "t": "resheet.note",
                                    "v": 1,
                                    "level": 0,
                                    "input": "----",
                                    "note": {
                                        "type": "text",
                                        "tag": "p",
                                        "text": "----"
                                    }
                                }
                            },
                            {
                                "id": 42,
                                "name": "",
                                "visibility": "block",
                                "width": "narrow",
                                "state": {
                                    "t": "resheet.note",
                                    "v": 1,
                                    "level": 0,
                                    "input": "",
                                    "note": {
                                        "type": "text",
                                        "tag": "p",
                                        "text": ""
                                    }
                                }
                            },
                            {
                                "id": 43,
                                "name": "",
                                "visibility": "block",
                                "width": "narrow",
                                "state": {
                                    "t": "resheet.note",
                                    "v": 1,
                                    "level": 0,
                                    "input": "",
                                    "note": {
                                        "type": "text",
                                        "tag": "p",
                                        "text": ""
                                    }
                                }
                            },
                            {
                                "id": 44,
                                "name": "",
                                "visibility": "block",
                                "width": "narrow",
                                "state": {
                                    "t": "resheet.note",
                                    "v": 1,
                                    "level": 0,
                                    "input": "## Curriculum Vitae",
                                    "note": {
                                        "type": "text",
                                        "tag": "h2",
                                        "text": "Curriculum Vitae"
                                    }
                                }
                            },
                            {
                                "id": 45,
                                "name": "",
                                "visibility": "block",
                                "width": "narrow",
                                "state": {
                                    "t": "resheet.note",
                                    "v": 1,
                                    "level": 0,
                                    "input": "Create a CV out of custom-built components.",
                                    "note": {
                                        "type": "text",
                                        "tag": "p",
                                        "text": "Create a CV out of custom-built components."
                                    }
                                }
                            },
                            {
                                "id": 46,
                                "name": "",
                                "visibility": "result",
                                "width": "narrow",
                                "state": {
                                    "t": "resheet.note",
                                    "v": 1,
                                    "level": 0,
                                    "input": "/Code",
                                    "note": {
                                        "type": "block",
                                        "isInstantiated": true,
                                        "code": "Code",
                                        "state": '<div className="m-4 p-3 rounded border bg-gray-50">\n  <h2 className="font-medium text-xl border-b mb-4">\n    Curriculum Vitae Preview\n  </h2>\n  {$`Curriculum Vitae`}\n</div>'
                                    }
                                }
                            },
                            {
                                "id": 47,
                                "name": "",
                                "visibility": "block",
                                "width": "narrow",
                                "state": {
                                    "t": "resheet.note",
                                    "v": 1,
                                    "level": 0,
                                    "input": "",
                                    "note": {
                                        "type": "text",
                                        "tag": "p",
                                        "text": ""
                                    }
                                }
                            },
                            {
                                "id": 48,
                                "name": "",
                                "visibility": "block",
                                "width": "narrow",
                                "state": {
                                    "t": "resheet.note",
                                    "v": 1,
                                    "level": 0,
                                    "input": "",
                                    "note": {
                                        "type": "text",
                                        "tag": "p",
                                        "text": ""
                                    }
                                }
                            },
                            {
                                "id": 16,
                                "name": "",
                                "visibility": "block",
                                "width": "wide",
                                "state": {
                                    "t": "resheet.note",
                                    "v": 1,
                                    "level": 0,
                                    "input": "----",
                                    "note": {
                                        "type": "text",
                                        "tag": "p",
                                        "text": "----"
                                    }
                                }
                            },
                            {
                                "id": 17,
                                "name": "",
                                "visibility": "block",
                                "width": "narrow",
                                "state": {
                                    "t": "resheet.note",
                                    "v": 1,
                                    "level": 0,
                                    "input": "",
                                    "note": {
                                        "type": "text",
                                        "tag": "p",
                                        "text": ""
                                    }
                                }
                            },
                            {
                                "id": 21,
                                "name": "",
                                "visibility": "block",
                                "width": "narrow",
                                "state": {
                                    "t": "resheet.note",
                                    "v": 1,
                                    "level": 0,
                                    "input": "",
                                    "note": {
                                        "type": "text",
                                        "tag": "p",
                                        "text": ""
                                    }
                                }
                            },
                            {
                                "id": 4,
                                "name": "",
                                "visibility": "block",
                                "width": "narrow",
                                "state": {
                                    "t": "resheet.note",
                                    "v": 1,
                                    "level": 0,
                                    "input": "## Invoice",
                                    "note": {
                                        "type": "text",
                                        "tag": "h2",
                                        "text": "Invoice"
                                    }
                                }
                            },
                            {
                                "id": 5,
                                "name": "",
                                "visibility": "block",
                                "width": "narrow",
                                "state": {
                                    "t": "resheet.note",
                                    "v": 1,
                                    "level": 0,
                                    "input": "Load a working hours export (from atWork) and generate an invoice.",
                                    "note": {
                                        "type": "text",
                                        "tag": "p",
                                        "text": "Load a working hours export (from atWork) and generate an invoice."
                                    }
                                }
                            },
                            {
                                "id": 9,
                                "name": "",
                                "visibility": "result",
                                "width": "narrow",
                                "state": {
                                    "t": "resheet.note",
                                    "v": 1,
                                    "level": 0,
                                    "input": "/Code",
                                    "note": {
                                        "type": "block",
                                        "isInstantiated": true,
                                        "code": "Code",
                                        "state": '<div className="m-4 p-3 rounded border bg-gray-50">\n  <h2 className="font-medium text-xl border-b">Invoice Preview</h2>\n  {Invoice}\n</div>'
                                    }
                                }
                            },
                            {
                                "id": 13,
                                "name": "",
                                "visibility": "block",
                                "width": "narrow",
                                "state": {
                                    "t": "resheet.note",
                                    "v": 1,
                                    "level": 0,
                                    "input": "",
                                    "note": {
                                        "type": "text",
                                        "tag": "p",
                                        "text": ""
                                    }
                                }
                            },
                            {
                                "id": 22,
                                "name": "",
                                "visibility": "block",
                                "width": "narrow",
                                "state": {
                                    "t": "resheet.note",
                                    "v": 1,
                                    "level": 0,
                                    "input": "",
                                    "note": {
                                        "type": "text",
                                        "tag": "p",
                                        "text": ""
                                    }
                                }
                            },
                            {
                                "id": 51,
                                "name": "",
                                "visibility": "block",
                                "width": "wide",
                                "state": {
                                    "t": "resheet.note",
                                    "v": 1,
                                    "level": 0,
                                    "input": "----",
                                    "note": {
                                        "type": "text",
                                        "tag": "p",
                                        "text": "----"
                                    }
                                }
                            },
                            {
                                "id": 52,
                                "name": "",
                                "visibility": "block",
                                "width": "narrow",
                                "state": {
                                    "t": "resheet.note",
                                    "v": 1,
                                    "level": 0,
                                    "input": "",
                                    "note": {
                                        "type": "text",
                                        "tag": "p",
                                        "text": ""
                                    }
                                }
                            },
                            {
                                "id": 53,
                                "name": "",
                                "visibility": "block",
                                "width": "narrow",
                                "state": {
                                    "t": "resheet.note",
                                    "v": 1,
                                    "level": 0,
                                    "input": "",
                                    "note": {
                                        "type": "text",
                                        "tag": "p",
                                        "text": ""
                                    }
                                }
                            },
                            {
                                "id": 54,
                                "name": "",
                                "visibility": "block",
                                "width": "narrow",
                                "state": {
                                    "t": "resheet.note",
                                    "v": 1,
                                    "level": 0,
                                    "input": "## Analyse JSON Size",
                                    "note": {
                                        "type": "text",
                                        "tag": "h2",
                                        "text": "Analyse JSON Size"
                                    }
                                }
                            },
                            {
                                "id": 55,
                                "name": "",
                                "visibility": "block",
                                "width": "narrow",
                                "state": {
                                    "t": "resheet.note",
                                    "v": 1,
                                    "level": 0,
                                    "input": "Analyse which part of a JSON file is huge.",
                                    "note": {
                                        "type": "text",
                                        "tag": "p",
                                        "text": "Analyse which part of a JSON file is huge."
                                    }
                                }
                            },
                            {
                                "id": 56,
                                "name": "",
                                "visibility": "block",
                                "width": "narrow",
                                "state": {
                                    "t": "resheet.note",
                                    "v": 1,
                                    "level": 0,
                                    "input": "",
                                    "note": {
                                        "type": "text",
                                        "tag": "p",
                                        "text": ""
                                    }
                                }
                            },
                            {
                                "id": 57,
                                "name": "",
                                "visibility": "block",
                                "width": "narrow",
                                "state": {
                                    "t": "resheet.note",
                                    "v": 1,
                                    "level": 0,
                                    "input": "/$`Analyse JSON Size`.derivedBlock",
                                    "note": {
                                        "type": "block",
                                        "isInstantiated": true,
                                        "code": "$`Analyse JSON Size`.derivedBlock",
                                        "state": {
                                            "t": "resheet.sheet",
                                            "v": 2,
                                            "lines": [
                                                {
                                                    "id": 1,
                                                    "name": "",
                                                    "visibility": "block",
                                                    "width": "narrow",
                                                    "state": {
                                                        "t": "resheet.note",
                                                        "v": 1,
                                                        "level": 0,
                                                        "input": "### Analyse JSON Size Preview",
                                                        "note": {
                                                            "type": "text",
                                                            "tag": "h3",
                                                            "text": "Analyse JSON Size Preview"
                                                        }
                                                    }
                                                },
                                                {
                                                    "id": 2,
                                                    "name": "",
                                                    "visibility": "block",
                                                    "width": "narrow",
                                                    "state": {
                                                        "t": "resheet.note",
                                                        "v": 1,
                                                        "level": 0,
                                                        "input": "We analyse some JSON data for its size.",
                                                        "note": {
                                                            "type": "text",
                                                            "tag": "p",
                                                            "text": "We analyse some JSON data for its size."
                                                        }
                                                    }
                                                },
                                                {
                                                    "id": 3,
                                                    "name": "",
                                                    "visibility": "block",
                                                    "width": "narrow",
                                                    "state": {
                                                        "t": "resheet.note",
                                                        "v": 1,
                                                        "level": 0,
                                                        "input": "",
                                                        "note": {
                                                            "type": "text",
                                                            "tag": "p",
                                                            "text": ""
                                                        }
                                                    }
                                                },
                                                {
                                                    "id": 4,
                                                    "name": "jsonFile",
                                                    "visibility": "block",
                                                    "width": "narrow",
                                                    "state": {
                                                        "t": "resheet.note",
                                                        "v": 1,
                                                        "level": 0,
                                                        "input": "/LoadFile",
                                                        "note": {
                                                            "type": "block",
                                                            "isInstantiated": true,
                                                            "code": "LoadFile",
                                                            "state": {
                                                                "state": "loaded",
                                                                "file": {
                                                                    "content": "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",
                                                                    "name": "Demo Target.json",
                                                                    "options": {
                                                                        "type": "application/json",
                                                                        "lastModified": 1716387270088
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                },
                                                {
                                                    "id": 5,
                                                    "name": "json",
                                                    "visibility": "block",
                                                    "width": "narrow",
                                                    "state": {
                                                        "t": "resheet.note",
                                                        "v": 1,
                                                        "level": 0,
                                                        "input": "= JSON.parse(await jsonFile.text())",
                                                        "note": {
                                                            "type": "expr",
                                                            "code": " JSON.parse(await jsonFile.text())"
                                                        }
                                                    }
                                                },
                                                {
                                                    "id": 8,
                                                    "name": "",
                                                    "visibility": "block",
                                                    "width": "narrow",
                                                    "state": {
                                                        "t": "resheet.note",
                                                        "v": 1,
                                                        "level": 0,
                                                        "input": "",
                                                        "note": {
                                                            "type": "text",
                                                            "tag": "p",
                                                            "text": ""
                                                        }
                                                    }
                                                },
                                                {
                                                    "id": 7,
                                                    "name": "part",
                                                    "visibility": "block",
                                                    "width": "narrow",
                                                    "state": {
                                                        "t": "resheet.note",
                                                        "v": 1,
                                                        "level": 0,
                                                        "input": "= json.inner.pages[1].children",
                                                        "note": {
                                                            "type": "expr",
                                                            "code": " json.inner.pages[1].children"
                                                        }
                                                    }
                                                },
                                                {
                                                    "id": 6,
                                                    "name": "",
                                                    "visibility": "result",
                                                    "width": "narrow",
                                                    "state": {
                                                        "t": "resheet.note",
                                                        "v": 1,
                                                        "level": 0,
                                                        "input": "/Code",
                                                        "note": {
                                                            "type": "block",
                                                            "isInstantiated": true,
                                                            "code": "Code",
                                                            "state": 'const { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, Tooltip } =\n  await import(\'https://esm.sh/recharts?external=react\');\n  \nconst { default: humanFormat } = await import(\'https://esm.sh/human-format\')\n  \nconst data = Object.entries(part)\n  .map(([key, value]) => ({ key, size: JSON.stringify(value).length }));\n\n<ResponsiveContainer height={400}>\n  <BarChart data={data}>\n    <Tooltip formatter={humanFormat.bytes} />\n    <Bar type="monotone" dataKey="size" fill="#8884d8" />\n    <XAxis dataKey="key"/>\n    <YAxis width={100} tickFormatter={humanFormat.bytes} />\n  </BarChart>\n</ResponsiveContainer>'
                                                        }
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                }
                            },
                            {
                                "id": 58,
                                "name": "",
                                "visibility": "block",
                                "width": "narrow",
                                "state": {
                                    "t": "resheet.note",
                                    "v": 1,
                                    "level": 0,
                                    "input": "",
                                    "note": {
                                        "type": "text",
                                        "tag": "p",
                                        "text": ""
                                    }
                                }
                            },
                            {
                                "id": 59,
                                "name": "",
                                "visibility": "block",
                                "width": "narrow",
                                "state": {
                                    "t": "resheet.note",
                                    "v": 1,
                                    "level": 0,
                                    "input": "",
                                    "note": {
                                        "type": "text",
                                        "tag": "p",
                                        "text": ""
                                    }
                                }
                            },
                            {
                                "id": 18,
                                "name": "",
                                "visibility": "block",
                                "width": "wide",
                                "state": {
                                    "t": "resheet.note",
                                    "v": 1,
                                    "level": 0,
                                    "input": "----",
                                    "note": {
                                        "type": "text",
                                        "tag": "p",
                                        "text": "----"
                                    }
                                }
                            },
                            {
                                "id": 19,
                                "name": "",
                                "visibility": "block",
                                "width": "narrow",
                                "state": {
                                    "t": "resheet.note",
                                    "v": 1,
                                    "level": 0,
                                    "input": "",
                                    "note": {
                                        "type": "text",
                                        "tag": "p",
                                        "text": ""
                                    }
                                }
                            },
                            {
                                "id": 23,
                                "name": "",
                                "visibility": "block",
                                "width": "narrow",
                                "state": {
                                    "t": "resheet.note",
                                    "v": 1,
                                    "level": 0,
                                    "input": "",
                                    "note": {
                                        "type": "text",
                                        "tag": "p",
                                        "text": ""
                                    }
                                }
                            },
                            {
                                "id": 6,
                                "name": "",
                                "visibility": "block",
                                "width": "narrow",
                                "state": {
                                    "t": "resheet.note",
                                    "v": 1,
                                    "level": 0,
                                    "input": "## Custom Blocks",
                                    "note": {
                                        "type": "text",
                                        "tag": "h2",
                                        "text": "Custom Blocks"
                                    }
                                }
                            },
                            {
                                "id": 7,
                                "name": "",
                                "visibility": "block",
                                "width": "narrow",
                                "state": {
                                    "t": "resheet.note",
                                    "v": 1,
                                    "level": 0,
                                    "input": "Create custom Blocks and use the Inspect Block to get a glimpse into ReSheet.",
                                    "note": {
                                        "type": "text",
                                        "tag": "p",
                                        "text": "Create custom Blocks and use the Inspect Block to get a glimpse into ReSheet."
                                    }
                                }
                            },
                            {
                                "id": 15,
                                "name": "",
                                "visibility": "block",
                                "width": "narrow",
                                "state": {
                                    "t": "resheet.note",
                                    "v": 1,
                                    "level": 0,
                                    "input": "",
                                    "note": {
                                        "type": "text",
                                        "tag": "p",
                                        "text": ""
                                    }
                                }
                            },
                            {
                                "id": 34,
                                "name": "",
                                "visibility": "block",
                                "width": "narrow",
                                "state": {
                                    "t": "resheet.note",
                                    "v": 1,
                                    "level": 0,
                                    "input": "/$`Custom Blocks`",
                                    "note": {
                                        "type": "block",
                                        "isInstantiated": true,
                                        "code": "$`Custom Blocks`",
                                        "state": {
                                            "t": "resheet.sheet",
                                            "v": 2,
                                            "lines": [
                                                {
                                                    "id": 1,
                                                    "name": "",
                                                    "visibility": "block",
                                                    "width": "narrow",
                                                    "state": {
                                                        "t": "resheet.note",
                                                        "v": 1,
                                                        "level": 0,
                                                        "input": "### Custom Blocks Preview",
                                                        "note": {
                                                            "type": "text",
                                                            "tag": "h3",
                                                            "text": "Custom Blocks Preview"
                                                        }
                                                    }
                                                },
                                                {
                                                    "id": 2,
                                                    "name": "",
                                                    "visibility": "block",
                                                    "width": "narrow",
                                                    "state": {
                                                        "t": "resheet.note",
                                                        "v": 1,
                                                        "level": 0,
                                                        "input": "We build these custom Blocks in this Page:",
                                                        "note": {
                                                            "type": "text",
                                                            "tag": "p",
                                                            "text": "We build these custom Blocks in this Page:"
                                                        }
                                                    }
                                                },
                                                {
                                                    "id": 3,
                                                    "name": "",
                                                    "visibility": "block",
                                                    "width": "narrow",
                                                    "state": {
                                                        "t": "resheet.note",
                                                        "v": 1,
                                                        "level": 0,
                                                        "input": "",
                                                        "note": {
                                                            "type": "text",
                                                            "tag": "p",
                                                            "text": ""
                                                        }
                                                    }
                                                },
                                                {
                                                    "id": 25,
                                                    "name": "",
                                                    "visibility": "block",
                                                    "width": "narrow",
                                                    "state": {
                                                        "t": "resheet.note",
                                                        "v": 1,
                                                        "level": 0,
                                                        "input": "#### `/DateBlock()`",
                                                        "note": {
                                                            "type": "text",
                                                            "tag": "h4",
                                                            "text": "`/DateBlock()`"
                                                        }
                                                    }
                                                },
                                                {
                                                    "id": 26,
                                                    "name": "dateBlockValue",
                                                    "visibility": "block",
                                                    "width": "narrow",
                                                    "state": {
                                                        "t": "resheet.note",
                                                        "v": 1,
                                                        "level": 0,
                                                        "input": "/DateBlock()",
                                                        "note": {
                                                            "type": "block",
                                                            "isInstantiated": true,
                                                            "code": "DateBlock()",
                                                            "state": "2024-05-23T20:32:56+02:00"
                                                        }
                                                    }
                                                },
                                                {
                                                    "id": 27,
                                                    "name": "",
                                                    "visibility": "block",
                                                    "width": "narrow",
                                                    "state": {
                                                        "t": "resheet.note",
                                                        "v": 1,
                                                        "level": 0,
                                                        "input": "= dateBlockValue",
                                                        "note": {
                                                            "type": "expr",
                                                            "code": " dateBlockValue"
                                                        }
                                                    }
                                                },
                                                {
                                                    "id": 7,
                                                    "name": "",
                                                    "visibility": "block",
                                                    "width": "narrow",
                                                    "state": {
                                                        "t": "resheet.note",
                                                        "v": 1,
                                                        "level": 0,
                                                        "input": "",
                                                        "note": {
                                                            "type": "text",
                                                            "tag": "p",
                                                            "text": ""
                                                        }
                                                    }
                                                },
                                                {
                                                    "id": 8,
                                                    "name": "",
                                                    "visibility": "block",
                                                    "width": "narrow",
                                                    "state": {
                                                        "t": "resheet.note",
                                                        "v": 1,
                                                        "level": 0,
                                                        "input": "#### `/SliderBlock()`",
                                                        "note": {
                                                            "type": "text",
                                                            "tag": "h4",
                                                            "text": "`/SliderBlock()`"
                                                        }
                                                    }
                                                },
                                                {
                                                    "id": 9,
                                                    "name": "sliderBlockValue",
                                                    "visibility": "block",
                                                    "width": "narrow",
                                                    "state": {
                                                        "t": "resheet.note",
                                                        "v": 1,
                                                        "level": 0,
                                                        "input": "/SliderBlock()",
                                                        "note": {
                                                            "type": "block",
                                                            "isInstantiated": true,
                                                            "code": "SliderBlock()",
                                                            "state": 49
                                                        }
                                                    }
                                                },
                                                {
                                                    "id": 10,
                                                    "name": "",
                                                    "visibility": "block",
                                                    "width": "narrow",
                                                    "state": {
                                                        "t": "resheet.note",
                                                        "v": 1,
                                                        "level": 0,
                                                        "input": "= sliderBlockValue",
                                                        "note": {
                                                            "type": "expr",
                                                            "code": " sliderBlockValue"
                                                        }
                                                    }
                                                },
                                                {
                                                    "id": 11,
                                                    "name": "",
                                                    "visibility": "block",
                                                    "width": "narrow",
                                                    "state": {
                                                        "t": "resheet.note",
                                                        "v": 1,
                                                        "level": 0,
                                                        "input": "",
                                                        "note": {
                                                            "type": "text",
                                                            "tag": "p",
                                                            "text": ""
                                                        }
                                                    }
                                                },
                                                {
                                                    "id": 20,
                                                    "name": "",
                                                    "visibility": "block",
                                                    "width": "narrow",
                                                    "state": {
                                                        "t": "resheet.note",
                                                        "v": 1,
                                                        "level": 0,
                                                        "input": "",
                                                        "note": {
                                                            "type": "text",
                                                            "tag": "p",
                                                            "text": ""
                                                        }
                                                    }
                                                },
                                                {
                                                    "id": 21,
                                                    "name": "",
                                                    "visibility": "block",
                                                    "width": "narrow",
                                                    "state": {
                                                        "t": "resheet.note",
                                                        "v": 1,
                                                        "level": 0,
                                                        "input": "#### `/HStack(DateBlock(), SliderBlock(), SelectBlock(options))`",
                                                        "note": {
                                                            "type": "text",
                                                            "tag": "h4",
                                                            "text": "`/HStack(DateBlock(), SliderBlock(), SelectBlock(options))`"
                                                        }
                                                    }
                                                },
                                                {
                                                    "id": 28,
                                                    "name": "options",
                                                    "visibility": "block",
                                                    "width": "narrow",
                                                    "state": {
                                                        "t": "resheet.note",
                                                        "v": 1,
                                                        "level": 0,
                                                        "input": "= ['yes', 'no']",
                                                        "note": {
                                                            "type": "expr",
                                                            "code": " ['yes', 'no']"
                                                        }
                                                    }
                                                },
                                                {
                                                    "id": 22,
                                                    "name": "hstack",
                                                    "visibility": "block",
                                                    "width": "narrow",
                                                    "state": {
                                                        "t": "resheet.note",
                                                        "v": 1,
                                                        "level": 0,
                                                        "input": "/HStack(DateBlock(), SliderBlock(), SelectBlock(options))",
                                                        "note": {
                                                            "type": "block",
                                                            "isInstantiated": true,
                                                            "code": "HStack(DateBlock(), SliderBlock(), SelectBlock(options))",
                                                            "state": [
                                                                "2024-05-23T20:40:02+02:00",
                                                                35,
                                                                "yes"
                                                            ]
                                                        }
                                                    }
                                                },
                                                {
                                                    "id": 23,
                                                    "name": "",
                                                    "visibility": "block",
                                                    "width": "narrow",
                                                    "state": {
                                                        "t": "resheet.note",
                                                        "v": 1,
                                                        "level": 0,
                                                        "input": "= hstack",
                                                        "note": {
                                                            "type": "expr",
                                                            "code": " hstack"
                                                        }
                                                    }
                                                },
                                                {
                                                    "id": 12,
                                                    "name": "",
                                                    "visibility": "block",
                                                    "width": "narrow",
                                                    "state": {
                                                        "t": "resheet.note",
                                                        "v": 1,
                                                        "level": 0,
                                                        "input": "",
                                                        "note": {
                                                            "type": "text",
                                                            "tag": "p",
                                                            "text": ""
                                                        }
                                                    }
                                                },
                                                {
                                                    "id": 24,
                                                    "name": "",
                                                    "visibility": "block",
                                                    "width": "narrow",
                                                    "state": {
                                                        "t": "resheet.note",
                                                        "v": 1,
                                                        "level": 0,
                                                        "input": "",
                                                        "note": {
                                                            "type": "text",
                                                            "tag": "p",
                                                            "text": ""
                                                        }
                                                    }
                                                },
                                                {
                                                    "id": 29,
                                                    "name": "",
                                                    "visibility": "block",
                                                    "width": "narrow",
                                                    "state": {
                                                        "t": "resheet.note",
                                                        "v": 1,
                                                        "level": 0,
                                                        "input": "#### Built-in Blocks",
                                                        "note": {
                                                            "type": "text",
                                                            "tag": "h4",
                                                            "text": "Built-in Blocks"
                                                        }
                                                    }
                                                },
                                                {
                                                    "id": 13,
                                                    "name": "",
                                                    "visibility": "block",
                                                    "width": "narrow",
                                                    "state": {
                                                        "t": "resheet.note",
                                                        "v": 1,
                                                        "level": 0,
                                                        "input": "And we inspect some built-in Blocks:",
                                                        "note": {
                                                            "type": "text",
                                                            "tag": "p",
                                                            "text": "And we inspect some built-in Blocks:"
                                                        }
                                                    }
                                                },
                                                {
                                                    "id": 14,
                                                    "name": "",
                                                    "visibility": "block",
                                                    "width": "narrow",
                                                    "state": {
                                                        "t": "resheet.note",
                                                        "v": 1,
                                                        "level": 0,
                                                        "input": "`/Debug.Inspect(Note)`",
                                                        "note": {
                                                            "type": "text",
                                                            "tag": "p",
                                                            "text": "`/Debug.Inspect(Note)`"
                                                        }
                                                    }
                                                },
                                                {
                                                    "id": 15,
                                                    "name": "inspectNote",
                                                    "visibility": "block",
                                                    "width": "narrow",
                                                    "state": {
                                                        "t": "resheet.note",
                                                        "v": 1,
                                                        "level": 0,
                                                        "input": "/Debug.Inspect(Note)",
                                                        "note": {
                                                            "type": "block",
                                                            "isInstantiated": true,
                                                            "code": "Debug.Inspect(Note)",
                                                            "state": {
                                                                "t": "resheet.note",
                                                                "v": 1,
                                                                "level": 0,
                                                                "input": "= sliderBlockValue",
                                                                "note": {
                                                                    "type": "expr",
                                                                    "code": " sliderBlockValue"
                                                                }
                                                            }
                                                        }
                                                    }
                                                },
                                                {
                                                    "id": 16,
                                                    "name": "",
                                                    "visibility": "block",
                                                    "width": "narrow",
                                                    "state": {
                                                        "t": "resheet.note",
                                                        "v": 1,
                                                        "level": 0,
                                                        "input": "= inspectNote.state",
                                                        "note": {
                                                            "type": "expr",
                                                            "code": " inspectNote.state"
                                                        }
                                                    }
                                                },
                                                {
                                                    "id": 17,
                                                    "name": "",
                                                    "visibility": "block",
                                                    "width": "narrow",
                                                    "state": {
                                                        "t": "resheet.note",
                                                        "v": 1,
                                                        "level": 0,
                                                        "input": "",
                                                        "note": {
                                                            "type": "text",
                                                            "tag": "p",
                                                            "text": ""
                                                        }
                                                    }
                                                },
                                                {
                                                    "id": 18,
                                                    "name": "",
                                                    "visibility": "block",
                                                    "width": "narrow",
                                                    "state": {
                                                        "t": "resheet.note",
                                                        "v": 1,
                                                        "level": 0,
                                                        "input": "",
                                                        "note": {
                                                            "type": "text",
                                                            "tag": "p",
                                                            "text": ""
                                                        }
                                                    }
                                                },
                                                {
                                                    "id": 19,
                                                    "name": "",
                                                    "visibility": "block",
                                                    "width": "narrow",
                                                    "state": {
                                                        "t": "resheet.note",
                                                        "v": 1,
                                                        "level": 0,
                                                        "input": '<span className="text-gray-400 text-sm">Psst: And don\'t miss the Grand Finale!</span>',
                                                        "note": {
                                                            "type": "text",
                                                            "tag": "p",
                                                            "text": '<span className="text-gray-400 text-sm">Psst: And don\'t miss the Grand Finale!</span>'
                                                        }
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                }
                            },
                            {
                                "id": 28,
                                "name": "",
                                "visibility": "block",
                                "width": "narrow",
                                "state": {
                                    "t": "resheet.note",
                                    "v": 1,
                                    "level": 0,
                                    "input": "",
                                    "note": {
                                        "type": "text",
                                        "tag": "p",
                                        "text": ""
                                    }
                                }
                            },
                            {
                                "id": 29,
                                "name": "",
                                "visibility": "block",
                                "width": "narrow",
                                "state": {
                                    "t": "resheet.note",
                                    "v": 1,
                                    "level": 0,
                                    "input": "",
                                    "note": {
                                        "type": "text",
                                        "tag": "p",
                                        "text": ""
                                    }
                                }
                            },
                            {
                                "id": 37,
                                "name": "",
                                "visibility": "block",
                                "width": "wide",
                                "state": {
                                    "t": "resheet.note",
                                    "v": 1,
                                    "level": 0,
                                    "input": "----",
                                    "note": {
                                        "type": "text",
                                        "tag": "p",
                                        "text": "----"
                                    }
                                }
                            },
                            {
                                "id": 38,
                                "name": "",
                                "visibility": "block",
                                "width": "wide",
                                "state": {
                                    "t": "resheet.note",
                                    "v": 1,
                                    "level": 0,
                                    "input": "",
                                    "note": {
                                        "type": "text",
                                        "tag": "p",
                                        "text": ""
                                    }
                                }
                            },
                            {
                                "id": 35,
                                "name": "",
                                "visibility": "block",
                                "width": "narrow",
                                "state": {
                                    "t": "resheet.note",
                                    "v": 1,
                                    "level": 0,
                                    "input": "## Interactive Game Dev",
                                    "note": {
                                        "type": "text",
                                        "tag": "h2",
                                        "text": "Interactive Game Dev"
                                    }
                                }
                            },
                            {
                                "id": 36,
                                "name": "",
                                "visibility": "block",
                                "width": "narrow",
                                "state": {
                                    "t": "resheet.note",
                                    "v": 1,
                                    "level": 0,
                                    "input": "Build a custom Game Block for interactively developing a simple game. Leverage existing Blocks to combine them to the tailored needs of a Game Editor.",
                                    "note": {
                                        "type": "text",
                                        "tag": "p",
                                        "text": "Build a custom Game Block for interactively developing a simple game. Leverage existing Blocks to combine them to the tailored needs of a Game Editor."
                                    }
                                }
                            },
                            {
                                "id": 39,
                                "name": "",
                                "visibility": "block",
                                "width": "narrow",
                                "state": {
                                    "t": "resheet.note",
                                    "v": 1,
                                    "level": 0,
                                    "input": "",
                                    "note": {
                                        "type": "text",
                                        "tag": "p",
                                        "text": ""
                                    }
                                }
                            },
                            {
                                "id": 40,
                                "name": "",
                                "visibility": "block",
                                "width": "narrow",
                                "state": {
                                    "t": "resheet.note",
                                    "v": 1,
                                    "level": 0,
                                    "input": "/$`Interactive Game Dev`",
                                    "note": {
                                        "type": "block",
                                        "isInstantiated": true,
                                        "code": "$`Interactive Game Dev`",
                                        "state": {
                                            "init": "({\n  score: 0,\n  lives: 10,\n  character: {\n    x: 100,\n    y: 400,\n    xSpeed: 0,\n    ySpeed: 0,\n  },\n  enemies: [],\n})",
                                            "update": {
                                                "t": "resheet.sheet",
                                                "v": 2,
                                                "lines": [
                                                    {
                                                        "id": 1,
                                                        "name": "",
                                                        "visibility": "block",
                                                        "width": "narrow",
                                                        "state": {
                                                            "t": "resheet.note",
                                                            "v": 1,
                                                            "level": 0,
                                                            "input": "The current state:",
                                                            "note": {
                                                                "type": "text",
                                                                "tag": "p",
                                                                "text": "The current state:"
                                                            }
                                                        }
                                                    },
                                                    {
                                                        "id": 2,
                                                        "name": "",
                                                        "visibility": "block",
                                                        "width": "narrow",
                                                        "state": {
                                                            "t": "resheet.note",
                                                            "v": 1,
                                                            "level": 0,
                                                            "input": "= state",
                                                            "note": {
                                                                "type": "expr",
                                                                "code": " state"
                                                            }
                                                        }
                                                    },
                                                    {
                                                        "id": 58,
                                                        "name": "",
                                                        "visibility": "block",
                                                        "width": "narrow",
                                                        "state": {
                                                            "t": "resheet.note",
                                                            "v": 1,
                                                            "level": 0,
                                                            "input": "The input:",
                                                            "note": {
                                                                "type": "text",
                                                                "tag": "p",
                                                                "text": "The input:"
                                                            }
                                                        }
                                                    },
                                                    {
                                                        "id": 59,
                                                        "name": "",
                                                        "visibility": "block",
                                                        "width": "narrow",
                                                        "state": {
                                                            "t": "resheet.note",
                                                            "v": 1,
                                                            "level": 0,
                                                            "input": "= input",
                                                            "note": {
                                                                "type": "expr",
                                                                "code": " input"
                                                            }
                                                        }
                                                    },
                                                    {
                                                        "id": 61,
                                                        "name": "",
                                                        "visibility": "block",
                                                        "width": "narrow",
                                                        "state": {
                                                            "t": "resheet.note",
                                                            "v": 1,
                                                            "level": 0,
                                                            "input": "",
                                                            "note": {
                                                                "type": "text",
                                                                "tag": "p",
                                                                "text": ""
                                                            }
                                                        }
                                                    },
                                                    {
                                                        "id": 60,
                                                        "name": "",
                                                        "visibility": "block",
                                                        "width": "narrow",
                                                        "state": {
                                                            "t": "resheet.note",
                                                            "v": 1,
                                                            "level": 0,
                                                            "input": "Respect the framerate:",
                                                            "note": {
                                                                "type": "text",
                                                                "tag": "p",
                                                                "text": "Respect the framerate:"
                                                            }
                                                        }
                                                    },
                                                    {
                                                        "id": 62,
                                                        "name": "dt",
                                                        "visibility": "block",
                                                        "width": "narrow",
                                                        "state": {
                                                            "t": "resheet.note",
                                                            "v": 1,
                                                            "level": 0,
                                                            "input": "= input?.dt ?? 16",
                                                            "note": {
                                                                "type": "expr",
                                                                "code": " input?.dt ?? 16"
                                                            }
                                                        }
                                                    },
                                                    {
                                                        "id": 64,
                                                        "name": "",
                                                        "visibility": "block",
                                                        "width": "narrow",
                                                        "state": {
                                                            "t": "resheet.note",
                                                            "v": 1,
                                                            "level": 0,
                                                            "input": "Calculate in px/s:",
                                                            "note": {
                                                                "type": "text",
                                                                "tag": "p",
                                                                "text": "Calculate in px/s:"
                                                            }
                                                        }
                                                    },
                                                    {
                                                        "id": 63,
                                                        "name": "factor",
                                                        "visibility": "block",
                                                        "width": "narrow",
                                                        "state": {
                                                            "t": "resheet.note",
                                                            "v": 1,
                                                            "level": 0,
                                                            "input": "= dt / 1000",
                                                            "note": {
                                                                "type": "expr",
                                                                "code": " dt / 1000"
                                                            }
                                                        }
                                                    },
                                                    {
                                                        "id": 3,
                                                        "name": "",
                                                        "visibility": "block",
                                                        "width": "narrow",
                                                        "state": {
                                                            "t": "resheet.note",
                                                            "v": 1,
                                                            "level": 0,
                                                            "input": "### Simulate Character",
                                                            "note": {
                                                                "type": "text",
                                                                "tag": "h3",
                                                                "text": "Simulate Character"
                                                            }
                                                        }
                                                    },
                                                    {
                                                        "id": 4,
                                                        "name": "character",
                                                        "visibility": "block",
                                                        "width": "narrow",
                                                        "state": {
                                                            "t": "resheet.note",
                                                            "v": 1,
                                                            "level": 0,
                                                            "input": "= state.character",
                                                            "note": {
                                                                "type": "expr",
                                                                "code": " state.character"
                                                            }
                                                        }
                                                    },
                                                    {
                                                        "id": 5,
                                                        "name": "",
                                                        "visibility": "block",
                                                        "width": "narrow",
                                                        "state": {
                                                            "t": "resheet.note",
                                                            "v": 1,
                                                            "level": 0,
                                                            "input": "Gravity means decelerating:",
                                                            "note": {
                                                                "type": "text",
                                                                "tag": "p",
                                                                "text": "Gravity means decelerating:"
                                                            }
                                                        }
                                                    },
                                                    {
                                                        "id": 6,
                                                        "name": "gravity",
                                                        "visibility": "block",
                                                        "width": "narrow",
                                                        "state": {
                                                            "t": "resheet.note",
                                                            "v": 1,
                                                            "level": 0,
                                                            "input": "= { ...character, ySpeed: character.ySpeed - 40 * factor }",
                                                            "note": {
                                                                "type": "expr",
                                                                "code": " { ...character, ySpeed: character.ySpeed - 40 * factor }"
                                                            }
                                                        }
                                                    },
                                                    {
                                                        "id": 7,
                                                        "name": "",
                                                        "visibility": "block",
                                                        "width": "narrow",
                                                        "state": {
                                                            "t": "resheet.note",
                                                            "v": 1,
                                                            "level": 0,
                                                            "input": "",
                                                            "note": {
                                                                "type": "text",
                                                                "tag": "p",
                                                                "text": ""
                                                            }
                                                        }
                                                    },
                                                    {
                                                        "id": 8,
                                                        "name": "",
                                                        "visibility": "block",
                                                        "width": "narrow",
                                                        "state": {
                                                            "t": "resheet.note",
                                                            "v": 1,
                                                            "level": 0,
                                                            "input": "Jumping means getting some upwards velocity:",
                                                            "note": {
                                                                "type": "text",
                                                                "tag": "p",
                                                                "text": "Jumping means getting some upwards velocity:"
                                                            }
                                                        }
                                                    },
                                                    {
                                                        "id": 9,
                                                        "name": "jump",
                                                        "visibility": "block",
                                                        "width": "narrow",
                                                        "state": {
                                                            "t": "resheet.note",
                                                            "v": 1,
                                                            "level": 0,
                                                            "input": "= { ...character, ySpeed: 14 }",
                                                            "note": {
                                                                "type": "expr",
                                                                "code": " { ...character, ySpeed: 14 }"
                                                            }
                                                        }
                                                    },
                                                    {
                                                        "id": 10,
                                                        "name": "",
                                                        "visibility": "block",
                                                        "width": "narrow",
                                                        "state": {
                                                            "t": "resheet.note",
                                                            "v": 1,
                                                            "level": 0,
                                                            "input": "",
                                                            "note": {
                                                                "type": "text",
                                                                "tag": "p",
                                                                "text": ""
                                                            }
                                                        }
                                                    },
                                                    {
                                                        "id": 11,
                                                        "name": "",
                                                        "visibility": "block",
                                                        "width": "narrow",
                                                        "state": {
                                                            "t": "resheet.note",
                                                            "v": 1,
                                                            "level": 0,
                                                            "input": "Jump if on ground or otherwise let gravity pull us down:",
                                                            "note": {
                                                                "type": "text",
                                                                "tag": "p",
                                                                "text": "Jump if on ground or otherwise let gravity pull us down:"
                                                            }
                                                        }
                                                    },
                                                    {
                                                        "id": 12,
                                                        "name": "forces",
                                                        "visibility": "block",
                                                        "width": "narrow",
                                                        "state": {
                                                            "t": "resheet.note",
                                                            "v": 1,
                                                            "level": 0,
                                                            "input": "= character.y <= 0 ? jump : gravity",
                                                            "note": {
                                                                "type": "expr",
                                                                "code": " character.y <= 0 ? jump : gravity"
                                                            }
                                                        }
                                                    },
                                                    {
                                                        "id": 13,
                                                        "name": "",
                                                        "visibility": "block",
                                                        "width": "narrow",
                                                        "state": {
                                                            "t": "resheet.note",
                                                            "v": 1,
                                                            "level": 0,
                                                            "input": "",
                                                            "note": {
                                                                "type": "text",
                                                                "tag": "p",
                                                                "text": ""
                                                            }
                                                        }
                                                    },
                                                    {
                                                        "id": 14,
                                                        "name": "",
                                                        "visibility": "block",
                                                        "width": "narrow",
                                                        "state": {
                                                            "t": "resheet.note",
                                                            "v": 1,
                                                            "level": 0,
                                                            "input": "Move according to speed:",
                                                            "note": {
                                                                "type": "text",
                                                                "tag": "p",
                                                                "text": "Move according to speed:"
                                                            }
                                                        }
                                                    },
                                                    {
                                                        "id": 15,
                                                        "name": "simulatedCharacter",
                                                        "visibility": "block",
                                                        "width": "narrow",
                                                        "state": {
                                                            "t": "resheet.note",
                                                            "v": 1,
                                                            "level": 0,
                                                            "input": "= {\n  ...forces,\n  x: forces.x + forces.xSpeed,\n  y: forces.y + forces.ySpeed,\n}",
                                                            "note": {
                                                                "type": "expr",
                                                                "code": " {\n  ...forces,\n  x: forces.x + forces.xSpeed,\n  y: forces.y + forces.ySpeed,\n}"
                                                            }
                                                        }
                                                    },
                                                    {
                                                        "id": 16,
                                                        "name": "",
                                                        "visibility": "block",
                                                        "width": "narrow",
                                                        "state": {
                                                            "t": "resheet.note",
                                                            "v": 1,
                                                            "level": 0,
                                                            "input": "",
                                                            "note": {
                                                                "type": "text",
                                                                "tag": "p",
                                                                "text": ""
                                                            }
                                                        }
                                                    },
                                                    {
                                                        "id": 17,
                                                        "name": "",
                                                        "visibility": "block",
                                                        "width": "narrow",
                                                        "state": {
                                                            "t": "resheet.note",
                                                            "v": 1,
                                                            "level": 0,
                                                            "input": "### Simulate Enemies",
                                                            "note": {
                                                                "type": "text",
                                                                "tag": "h3",
                                                                "text": "Simulate Enemies"
                                                            }
                                                        }
                                                    },
                                                    {
                                                        "id": 18,
                                                        "name": "enemies",
                                                        "visibility": "block",
                                                        "width": "narrow",
                                                        "state": {
                                                            "t": "resheet.note",
                                                            "v": 1,
                                                            "level": 0,
                                                            "input": "= state.enemies",
                                                            "note": {
                                                                "type": "expr",
                                                                "code": " state.enemies"
                                                            }
                                                        }
                                                    },
                                                    {
                                                        "id": 19,
                                                        "name": "enemySize",
                                                        "visibility": "block",
                                                        "width": "narrow",
                                                        "state": {
                                                            "t": "resheet.note",
                                                            "v": 1,
                                                            "level": 0,
                                                            "input": "= 32",
                                                            "note": {
                                                                "type": "expr",
                                                                "code": " 32"
                                                            }
                                                        }
                                                    },
                                                    {
                                                        "id": 20,
                                                        "name": "",
                                                        "visibility": "block",
                                                        "width": "narrow",
                                                        "state": {
                                                            "t": "resheet.note",
                                                            "v": 1,
                                                            "level": 0,
                                                            "input": "",
                                                            "note": {
                                                                "type": "text",
                                                                "tag": "p",
                                                                "text": ""
                                                            }
                                                        }
                                                    },
                                                    {
                                                        "id": 21,
                                                        "name": "",
                                                        "visibility": "block",
                                                        "width": "narrow",
                                                        "state": {
                                                            "t": "resheet.note",
                                                            "v": 1,
                                                            "level": 0,
                                                            "input": "Move enemies:",
                                                            "note": {
                                                                "type": "text",
                                                                "tag": "p",
                                                                "text": "Move enemies:"
                                                            }
                                                        }
                                                    },
                                                    {
                                                        "id": 22,
                                                        "name": "movedEnemies",
                                                        "visibility": "block",
                                                        "width": "narrow",
                                                        "state": {
                                                            "t": "resheet.note",
                                                            "v": 1,
                                                            "level": 0,
                                                            "input": "= enemies.map(enemyPosition => enemyPosition - 160 * factor)",
                                                            "note": {
                                                                "type": "expr",
                                                                "code": " enemies.map(enemyPosition => enemyPosition - 160 * factor)"
                                                            }
                                                        }
                                                    },
                                                    {
                                                        "id": 23,
                                                        "name": "",
                                                        "visibility": "block",
                                                        "width": "narrow",
                                                        "state": {
                                                            "t": "resheet.note",
                                                            "v": 1,
                                                            "level": 0,
                                                            "input": "",
                                                            "note": {
                                                                "type": "text",
                                                                "tag": "p",
                                                                "text": ""
                                                            }
                                                        }
                                                    },
                                                    {
                                                        "id": 24,
                                                        "name": "",
                                                        "visibility": "block",
                                                        "width": "narrow",
                                                        "state": {
                                                            "t": "resheet.note",
                                                            "v": 1,
                                                            "level": 0,
                                                            "input": "Randomly add enemies:",
                                                            "note": {
                                                                "type": "text",
                                                                "tag": "p",
                                                                "text": "Randomly add enemies:"
                                                            }
                                                        }
                                                    },
                                                    {
                                                        "id": 25,
                                                        "name": "addedEnemies",
                                                        "visibility": "block",
                                                        "width": "narrow",
                                                        "state": {
                                                            "t": "resheet.note",
                                                            "v": 1,
                                                            "level": 0,
                                                            "input": "= [ ...movedEnemies, ...(Math.random() < 0.6 * factor ? [1300] : []) ]",
                                                            "note": {
                                                                "type": "expr",
                                                                "code": " [ ...movedEnemies, ...(Math.random() < 0.6 * factor ? [1300] : []) ]"
                                                            }
                                                        }
                                                    },
                                                    {
                                                        "id": 26,
                                                        "name": "",
                                                        "visibility": "block",
                                                        "width": "narrow",
                                                        "state": {
                                                            "t": "resheet.note",
                                                            "v": 1,
                                                            "level": 0,
                                                            "input": "",
                                                            "note": {
                                                                "type": "text",
                                                                "tag": "p",
                                                                "text": ""
                                                            }
                                                        }
                                                    },
                                                    {
                                                        "id": 27,
                                                        "name": "",
                                                        "visibility": "block",
                                                        "width": "narrow",
                                                        "state": {
                                                            "t": "resheet.note",
                                                            "v": 1,
                                                            "level": 0,
                                                            "input": "Filter enemies that have passed:",
                                                            "note": {
                                                                "type": "text",
                                                                "tag": "p",
                                                                "text": "Filter enemies that have passed:"
                                                            }
                                                        }
                                                    },
                                                    {
                                                        "id": 28,
                                                        "name": "passedAndLeftEnemies",
                                                        "visibility": "block",
                                                        "width": "narrow",
                                                        "state": {
                                                            "t": "resheet.note",
                                                            "v": 1,
                                                            "level": 0,
                                                            "input": "= lodash.partition(addedEnemies, enemyPos => enemyPos < -enemySize)",
                                                            "note": {
                                                                "type": "expr",
                                                                "code": " lodash.partition(addedEnemies, enemyPos => enemyPos < -enemySize)"
                                                            }
                                                        }
                                                    },
                                                    {
                                                        "id": 29,
                                                        "name": "passedEnemies",
                                                        "visibility": "block",
                                                        "width": "narrow",
                                                        "state": {
                                                            "t": "resheet.note",
                                                            "v": 1,
                                                            "level": 0,
                                                            "input": "= passedAndLeftEnemies[0]",
                                                            "note": {
                                                                "type": "expr",
                                                                "code": " passedAndLeftEnemies[0]"
                                                            }
                                                        }
                                                    },
                                                    {
                                                        "id": 30,
                                                        "name": "leftEnemies",
                                                        "visibility": "block",
                                                        "width": "narrow",
                                                        "state": {
                                                            "t": "resheet.note",
                                                            "v": 1,
                                                            "level": 0,
                                                            "input": "= passedAndLeftEnemies[1]",
                                                            "note": {
                                                                "type": "expr",
                                                                "code": " passedAndLeftEnemies[1]"
                                                            }
                                                        }
                                                    },
                                                    {
                                                        "id": 31,
                                                        "name": "",
                                                        "visibility": "block",
                                                        "width": "narrow",
                                                        "state": {
                                                            "t": "resheet.note",
                                                            "v": 1,
                                                            "level": 0,
                                                            "input": "",
                                                            "note": {
                                                                "type": "text",
                                                                "tag": "p",
                                                                "text": ""
                                                            }
                                                        }
                                                    },
                                                    {
                                                        "id": 32,
                                                        "name": "",
                                                        "visibility": "block",
                                                        "width": "narrow",
                                                        "state": {
                                                            "t": "resheet.note",
                                                            "v": 1,
                                                            "level": 0,
                                                            "input": "### Lives, Collisions and Score ",
                                                            "note": {
                                                                "type": "text",
                                                                "tag": "h3",
                                                                "text": "Lives, Collisions and Score "
                                                            }
                                                        }
                                                    },
                                                    {
                                                        "id": 33,
                                                        "name": "",
                                                        "visibility": "block",
                                                        "width": "narrow",
                                                        "state": {
                                                            "t": "resheet.note",
                                                            "v": 1,
                                                            "level": 0,
                                                            "input": "Add passed enemies to score:",
                                                            "note": {
                                                                "type": "text",
                                                                "tag": "p",
                                                                "text": "Add passed enemies to score:"
                                                            }
                                                        }
                                                    },
                                                    {
                                                        "id": 34,
                                                        "name": "score",
                                                        "visibility": "block",
                                                        "width": "narrow",
                                                        "state": {
                                                            "t": "resheet.note",
                                                            "v": 1,
                                                            "level": 0,
                                                            "input": "= state.score + passedEnemies.length",
                                                            "note": {
                                                                "type": "expr",
                                                                "code": " state.score + passedEnemies.length"
                                                            }
                                                        }
                                                    },
                                                    {
                                                        "id": 35,
                                                        "name": "",
                                                        "visibility": "block",
                                                        "width": "narrow",
                                                        "state": {
                                                            "t": "resheet.note",
                                                            "v": 1,
                                                            "level": 0,
                                                            "input": "",
                                                            "note": {
                                                                "type": "text",
                                                                "tag": "p",
                                                                "text": ""
                                                            }
                                                        }
                                                    },
                                                    {
                                                        "id": 36,
                                                        "name": "",
                                                        "visibility": "block",
                                                        "width": "narrow",
                                                        "state": {
                                                            "t": "resheet.note",
                                                            "v": 1,
                                                            "level": 0,
                                                            "input": "Find collisions with enemies:",
                                                            "note": {
                                                                "type": "text",
                                                                "tag": "p",
                                                                "text": "Find collisions with enemies:"
                                                            }
                                                        }
                                                    },
                                                    {
                                                        "id": 37,
                                                        "name": "collidedAndUntouchedEnemies",
                                                        "visibility": "block",
                                                        "width": "narrow",
                                                        "state": {
                                                            "t": "resheet.note",
                                                            "v": 1,
                                                            "level": 0,
                                                            "input": "= lodash.partition(leftEnemies, enemyPos =>\n    simulatedCharacter.y <= enemySize\n    && Math.abs(simulatedCharacter.x - enemyPos) <= enemySize\n)",
                                                            "note": {
                                                                "type": "expr",
                                                                "code": " lodash.partition(leftEnemies, enemyPos =>\n    simulatedCharacter.y <= enemySize\n    && Math.abs(simulatedCharacter.x - enemyPos) <= enemySize\n)"
                                                            }
                                                        }
                                                    },
                                                    {
                                                        "id": 38,
                                                        "name": "collidedEnemies",
                                                        "visibility": "block",
                                                        "width": "narrow",
                                                        "state": {
                                                            "t": "resheet.note",
                                                            "v": 1,
                                                            "level": 0,
                                                            "input": "= collidedAndUntouchedEnemies[0]",
                                                            "note": {
                                                                "type": "expr",
                                                                "code": " collidedAndUntouchedEnemies[0]"
                                                            }
                                                        }
                                                    },
                                                    {
                                                        "id": 39,
                                                        "name": "untouchedEnemies",
                                                        "visibility": "block",
                                                        "width": "narrow",
                                                        "state": {
                                                            "t": "resheet.note",
                                                            "v": 1,
                                                            "level": 0,
                                                            "input": "= collidedAndUntouchedEnemies[1]",
                                                            "note": {
                                                                "type": "expr",
                                                                "code": " collidedAndUntouchedEnemies[1]"
                                                            }
                                                        }
                                                    },
                                                    {
                                                        "id": 40,
                                                        "name": "",
                                                        "visibility": "block",
                                                        "width": "narrow",
                                                        "state": {
                                                            "t": "resheet.note",
                                                            "v": 1,
                                                            "level": 0,
                                                            "input": "",
                                                            "note": {
                                                                "type": "text",
                                                                "tag": "p",
                                                                "text": ""
                                                            }
                                                        }
                                                    },
                                                    {
                                                        "id": 41,
                                                        "name": "",
                                                        "visibility": "block",
                                                        "width": "narrow",
                                                        "state": {
                                                            "t": "resheet.note",
                                                            "v": 1,
                                                            "level": 0,
                                                            "input": "Take a life on collision:",
                                                            "note": {
                                                                "type": "text",
                                                                "tag": "p",
                                                                "text": "Take a life on collision:"
                                                            }
                                                        }
                                                    },
                                                    {
                                                        "id": 42,
                                                        "name": "collided",
                                                        "visibility": "block",
                                                        "width": "narrow",
                                                        "state": {
                                                            "t": "resheet.note",
                                                            "v": 1,
                                                            "level": 0,
                                                            "input": "= collidedEnemies.length > 0",
                                                            "note": {
                                                                "type": "expr",
                                                                "code": " collidedEnemies.length > 0"
                                                            }
                                                        }
                                                    },
                                                    {
                                                        "id": 43,
                                                        "name": "leftLives",
                                                        "visibility": "block",
                                                        "width": "narrow",
                                                        "state": {
                                                            "t": "resheet.note",
                                                            "v": 1,
                                                            "level": 0,
                                                            "input": "= collided ? state.lives - 1 : state.lives",
                                                            "note": {
                                                                "type": "expr",
                                                                "code": " collided ? state.lives - 1 : state.lives"
                                                            }
                                                        }
                                                    },
                                                    {
                                                        "id": 44,
                                                        "name": "",
                                                        "visibility": "block",
                                                        "width": "narrow",
                                                        "state": {
                                                            "t": "resheet.note",
                                                            "v": 1,
                                                            "level": 0,
                                                            "input": "",
                                                            "note": {
                                                                "type": "text",
                                                                "tag": "p",
                                                                "text": ""
                                                            }
                                                        }
                                                    },
                                                    {
                                                        "id": 45,
                                                        "name": "",
                                                        "visibility": "block",
                                                        "width": "narrow",
                                                        "state": {
                                                            "t": "resheet.note",
                                                            "v": 1,
                                                            "level": 0,
                                                            "input": "### Final Simulated State",
                                                            "note": {
                                                                "type": "text",
                                                                "tag": "h3",
                                                                "text": "Final Simulated State"
                                                            }
                                                        }
                                                    },
                                                    {
                                                        "id": 46,
                                                        "name": "",
                                                        "visibility": "block",
                                                        "width": "narrow",
                                                        "state": {
                                                            "t": "resheet.note",
                                                            "v": 1,
                                                            "level": 0,
                                                            "input": "One last thing: Are we even still alive to begin with?",
                                                            "note": {
                                                                "type": "text",
                                                                "tag": "p",
                                                                "text": "One last thing: Are we even still alive to begin with?"
                                                            }
                                                        }
                                                    },
                                                    {
                                                        "id": 47,
                                                        "name": "alive",
                                                        "visibility": "block",
                                                        "width": "narrow",
                                                        "state": {
                                                            "t": "resheet.note",
                                                            "v": 1,
                                                            "level": 0,
                                                            "input": "= state.lives > 0",
                                                            "note": {
                                                                "type": "expr",
                                                                "code": " state.lives > 0"
                                                            }
                                                        }
                                                    },
                                                    {
                                                        "id": 48,
                                                        "name": "simulation",
                                                        "visibility": "block",
                                                        "width": "narrow",
                                                        "state": {
                                                            "t": "resheet.note",
                                                            "v": 1,
                                                            "level": 0,
                                                            "input": "/Code",
                                                            "note": {
                                                                "type": "block",
                                                                "isInstantiated": true,
                                                                "code": "Code",
                                                                "state": "!alive ?\n  state\n:\n  {\n    ...state,\n    score,\n    lives: leftLives,\n    character: simulatedCharacter,\n    enemies: untouchedEnemies,\n  }"
                                                            }
                                                        }
                                                    },
                                                    {
                                                        "id": 49,
                                                        "name": "",
                                                        "visibility": "block",
                                                        "width": "narrow",
                                                        "state": {
                                                            "t": "resheet.note",
                                                            "v": 1,
                                                            "level": 0,
                                                            "input": "",
                                                            "note": {
                                                                "type": "text",
                                                                "tag": "p",
                                                                "text": ""
                                                            }
                                                        }
                                                    },
                                                    {
                                                        "id": 50,
                                                        "name": "",
                                                        "visibility": "block",
                                                        "width": "narrow",
                                                        "state": {
                                                            "t": "resheet.note",
                                                            "v": 1,
                                                            "level": 0,
                                                            "input": "### React to Input",
                                                            "note": {
                                                                "type": "text",
                                                                "tag": "h3",
                                                                "text": "React to Input"
                                                            }
                                                        }
                                                    },
                                                    {
                                                        "id": 51,
                                                        "name": "",
                                                        "visibility": "block",
                                                        "width": "narrow",
                                                        "state": {
                                                            "t": "resheet.note",
                                                            "v": 1,
                                                            "level": 0,
                                                            "input": "= input",
                                                            "note": {
                                                                "type": "expr",
                                                                "code": " input"
                                                            }
                                                        }
                                                    },
                                                    {
                                                        "id": 52,
                                                        "name": "xSpeed",
                                                        "visibility": "block",
                                                        "width": "narrow",
                                                        "state": {
                                                            "t": "resheet.note",
                                                            "v": 1,
                                                            "level": 0,
                                                            "input": "/Code",
                                                            "note": {
                                                                "type": "block",
                                                                "isInstantiated": true,
                                                                "code": "Code",
                                                                "state": "// input changes character's xSpeed\nconst previous = state.character.xSpeed\n\nconst speed = 250 * factor\n\nif (!input) return previous;\n\n// This is not 100% correct, but let's keep it simple\nif (input.type === 'keyup') return 0;\nif (input.type === 'pointerup') return 0;\n\nif (input.type === 'keydown') {\n  if (input.key === 'ArrowLeft') return -speed;\n  if (input.key === 'ArrowRight') return speed;\n}\n\nif (input.type === 'pointerdown') {\n  const rect = input.target.getBoundingClientRect()\n  if (input.clientX - rect.x < rect.width / 2) return -speed;\n  if (input.clientX - rect.x > rect.width / 2) return speed;\n}\n\nreturn previous"
                                                            }
                                                        }
                                                    },
                                                    {
                                                        "id": 53,
                                                        "name": "reaction",
                                                        "visibility": "block",
                                                        "width": "narrow",
                                                        "state": {
                                                            "t": "resheet.note",
                                                            "v": 1,
                                                            "level": 0,
                                                            "input": "= { ...state, character: { ...state.character, xSpeed } }",
                                                            "note": {
                                                                "type": "expr",
                                                                "code": " { ...state, character: { ...state.character, xSpeed } }"
                                                            }
                                                        }
                                                    },
                                                    {
                                                        "id": 54,
                                                        "name": "",
                                                        "visibility": "block",
                                                        "width": "narrow",
                                                        "state": {
                                                            "t": "resheet.note",
                                                            "v": 1,
                                                            "level": 0,
                                                            "input": "",
                                                            "note": {
                                                                "type": "text",
                                                                "tag": "p",
                                                                "text": ""
                                                            }
                                                        }
                                                    },
                                                    {
                                                        "id": 55,
                                                        "name": "",
                                                        "visibility": "block",
                                                        "width": "narrow",
                                                        "state": {
                                                            "t": "resheet.note",
                                                            "v": 1,
                                                            "level": 0,
                                                            "input": "### Final State",
                                                            "note": {
                                                                "type": "text",
                                                                "tag": "h3",
                                                                "text": "Final State"
                                                            }
                                                        }
                                                    },
                                                    {
                                                        "id": 56,
                                                        "name": "",
                                                        "visibility": "block",
                                                        "width": "narrow",
                                                        "state": {
                                                            "t": "resheet.note",
                                                            "v": 1,
                                                            "level": 0,
                                                            "input": "Decide which state to use based on the input:",
                                                            "note": {
                                                                "type": "text",
                                                                "tag": "p",
                                                                "text": "Decide which state to use based on the input:"
                                                            }
                                                        }
                                                    },
                                                    {
                                                        "id": 57,
                                                        "name": "finalState",
                                                        "visibility": "block",
                                                        "width": "narrow",
                                                        "state": {
                                                            "t": "resheet.note",
                                                            "v": 1,
                                                            "level": 0,
                                                            "input": "= input?.type === 'simulate' ? simulation : reaction",
                                                            "note": {
                                                                "type": "expr",
                                                                "code": " input?.type === 'simulate' ? simulation : reaction"
                                                            }
                                                        }
                                                    }
                                                ]
                                            },
                                            "render": {
                                                "t": "resheet.sheet",
                                                "v": 2,
                                                "lines": [
                                                    {
                                                        "id": 1,
                                                        "name": "Controls",
                                                        "visibility": "result",
                                                        "width": "full",
                                                        "state": {
                                                            "t": "resheet.note",
                                                            "v": 1,
                                                            "level": 0,
                                                            "input": "/Code",
                                                            "note": {
                                                                "type": "block",
                                                                "isInstantiated": true,
                                                                "code": "Code",
                                                                "state": 'function Controls({ state, update, running, toggleRunning }) {\n  return (\n    <div className="w-full flex flex-row space-x-2">\n      <button\n        className={`\n          flex-1 rounded\n          bg-${running ? "green" : "red"}-100\n          hover:bg-${running ? "green" : "red"}-200\n        `}\n        onClick={toggleRunning}\n      >\n        {running ? "Running" : "Stopped - click to play"}\n      </button>\n\n      <button\n        className="flex-1 rounded bg-blue-100 hover:bg-blue-200"\n        onClick={() => update({ type: \'simulate\', dt: 16 })}\n      >\n        Step\n      </button>\n    </div> \n  )\n}'
                                                            }
                                                        }
                                                    },
                                                    {
                                                        "id": 0,
                                                        "name": "",
                                                        "visibility": "block",
                                                        "width": "full",
                                                        "state": {
                                                            "t": "resheet.note",
                                                            "v": 1,
                                                            "level": 0,
                                                            "input": "/Code",
                                                            "note": {
                                                                "type": "block",
                                                                "isInstantiated": true,
                                                                "code": "Code",
                                                                "state": "const height = 400;\nconst width = 800;\nconst tileSize = 64;\nconst ground = height - tileSize;\n\nfunction GameView({ state, update }) {\n  const { running, toggleRunning } = useAnimation(dt => update({ type: 'simulate', dt }))\n  \n  function react(ev) {\n    ev.preventDefault()\n    ev.stopPropagation()\n    ev.target.focus()\n    \n    update(ev) // runs an update with `input` set to `ev`\n  }\n  \n  const canvasRef = React.useRef(null)\n  \n  React.useEffect(() => {\n    const canvas = canvasRef.current;\n    const ctx = canvas.getContext('2d');\n    \n    // Setting up canvas dimensions\n    canvas.width = width;\n    canvas.height = height;\n\n    // Draw the platform\n    const ptrn = ctx.createPattern(Tiles.ground, 'repeat');\n    ctx.save();\n    ctx.fillStyle = ptrn;\n    ctx.translate(0, 336);\n    ctx.scale(tileSize / Tiles.ground.naturalWidth, tileSize / Tiles.ground.naturalHeight);\n    ctx.fillRect(0, 0, width, tileSize);\n    ctx.restore();\n\n    // Draw the character\n    ctx.save();\n    ctx.translate(state.character.x, height - tileSize - state.character.y);\n    if (state.lives <= 0) ctx.rotate(90 * Math.PI / 180);\n    if (state.character.xSpeed >= 0) ctx.scale(-1, 1);\n    ctx.drawImage(Tiles.character, -tileSize/2, -tileSize, tileSize, tileSize);\n    ctx.restore();\n\n    // Draw enemies\n    state.enemies.forEach(enemyPos => {\n      ctx.save();\n      ctx.translate(enemyPos, height - tileSize);\n      ctx.scale(0.5, 0.5);\n      ctx.drawImage(Tiles.enemy, -tileSize/2, -tileSize, tileSize, tileSize);\n      ctx.restore();\n    });\n\n    // Draw text\n    ctx.font = '20px Arial';\n    ctx.fillStyle = 'black';\n    ctx.fillText(`Lives: ${\"\u2764\uFE0F\".repeat(state.lives)}`, 20, 30);\n    ctx.fillText(`Score: ${state.score} x \u2B50\uFE0F`, 20, 60);\n    \n    ctx.font = '16px Arial';\n    ctx.fillStyle = '#888';\n    ctx.fillText('Use the arrow keys or press on the left and right', 20, 90);\n    \n    if (state.lives <= 0) {\n      ctx.fillStyle = 'red';\n      ctx.font = '40px Arial';\n      ctx.fillText('Game Over', 50, 200);\n    }\n  }, [state]);\n\n\n  return (\n    <div>\n      <Controls state={state} update={update} running={running} toggleRunning={toggleRunning} />\n      <canvas\n        ref={canvasRef}\n        tabIndex={-1}\n        className=\"w-full\"\n        onKeyDown={react}\n        onKeyUp={react}\n        onPointerDownCapture={react}\n        onPointerUpCapture={react}\n        />\n    </div>\n  )\n}"
                                                            }
                                                        }
                                                    }
                                                ]
                                            }
                                        }
                                    }
                                }
                            }
                        ]
                    }
                },
                "isCollapsed": false,
                "children": [
                    {
                        "id": 0,
                        "name": "Personal Finances",
                        "state": {
                            "t": "resheet.selector",
                            "v": 0,
                            "mode": "run",
                            "expr": "SheetOf(Note)",
                            "inner": {
                                "t": "resheet.sheet",
                                "v": 2,
                                "lines": [
                                    {
                                        "id": 1,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "# Personal Finances",
                                            "note": {
                                                "type": "text",
                                                "tag": "h1",
                                                "text": "Personal Finances"
                                            }
                                        }
                                    },
                                    {
                                        "id": 2,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "Load and parse a CSV file, process and display the data in a chart.",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": "Load and parse a CSV file, process and display the data in a chart."
                                            }
                                        }
                                    },
                                    {
                                        "id": 3,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 15,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "## Load and Parse CSV",
                                            "note": {
                                                "type": "text",
                                                "tag": "h2",
                                                "text": "Load and Parse CSV"
                                            }
                                        }
                                    },
                                    {
                                        "id": 4,
                                        "name": "bankExportFile",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "/LoadFile",
                                            "note": {
                                                "type": "block",
                                                "isInstantiated": true,
                                                "code": "LoadFile",
                                                "state": {
                                                    "state": "loaded",
                                                    "file": {
                                                        "content": "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",
                                                        "name": "bank-extract.csv",
                                                        "options": {
                                                            "type": "text/csv",
                                                            "lastModified": 1712397176186
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    },
                                    {
                                        "id": 5,
                                        "name": "bankExportContent",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "= bankExportFile.text()",
                                            "note": {
                                                "type": "expr",
                                                "code": " bankExportFile.text()"
                                            }
                                        }
                                    },
                                    {
                                        "id": 6,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 7,
                                        "name": "bankExportParsed",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "= libs.papaparse.parse(bankExportContent)",
                                            "note": {
                                                "type": "expr",
                                                "code": " libs.papaparse.parse(bankExportContent)"
                                            }
                                        }
                                    },
                                    {
                                        "id": 8,
                                        "name": "",
                                        "visibility": "result",
                                        "width": "full",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "= <reactInspector.TableInspector data={bankExportParsed.data} />",
                                            "note": {
                                                "type": "expr",
                                                "code": " <reactInspector.TableInspector data={bankExportParsed.data} />"
                                            }
                                        }
                                    },
                                    {
                                        "id": 9,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 17,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 18,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 16,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "## Convert and Process Data",
                                            "note": {
                                                "type": "text",
                                                "tag": "h2",
                                                "text": "Convert and Process Data"
                                            }
                                        }
                                    },
                                    {
                                        "id": 38,
                                        "name": "balanceStart",
                                        "visibility": "result",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "= Number.parseFloat(\n    bankExportParsed.data.slice(-2)[0][8].replace(',','')\n  )",
                                            "note": {
                                                "type": "expr",
                                                "code": " Number.parseFloat(\n    bankExportParsed.data.slice(-2)[0][8].replace(',','')\n  )"
                                            }
                                        }
                                    },
                                    {
                                        "id": 10,
                                        "name": "transactionsCSV",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "= bankExportParsed.data.slice(13, -4)",
                                            "note": {
                                                "type": "expr",
                                                "code": " bankExportParsed.data.slice(13, -4)"
                                            }
                                        }
                                    },
                                    {
                                        "id": 36,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 37,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 13,
                                        "name": "transactions",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "/Code",
                                            "note": {
                                                "type": "block",
                                                "isInstantiated": true,
                                                "code": "Code",
                                                "state": "lodash(transactionsCSV)\n  .map(\n    ([date,, payerPayee, recipientObligor, account, bankCode, purpose, currency, turnoverStr, creditDebit]) => {\n      const turnoverNum = Number.parseFloat(turnoverStr)\n      return {\n        date: libs.datefns.parse(date, 'LL/dd/uuuu', new Date()),\n        payerPayee,\n        recipientObligor,\n        purpose,\n        turnover: creditDebit === 'S' ? -turnoverNum : turnoverNum,\n        currency,\n        account,\n        bankCode,\n      }\n    }\n  )\n  .sortBy('date')\n  .value()"
                                            }
                                        }
                                    },
                                    {
                                        "id": 11,
                                        "name": "",
                                        "visibility": "result",
                                        "width": "full",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "= <reactInspector.TableInspector data={transactions} />",
                                            "note": {
                                                "type": "expr",
                                                "code": " <reactInspector.TableInspector data={transactions} />"
                                            }
                                        }
                                    },
                                    {
                                        "id": 34,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 35,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 30,
                                        "name": "turnoverByMonth",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "/Code",
                                            "note": {
                                                "type": "block",
                                                "isInstantiated": true,
                                                "code": "Code",
                                                "state": 'lodash.chain(transactions)\n  .map(transaction => ({\n    ...transaction,\n    month: libs.datefns.format(transaction.date, "MMM yyyy"),\n  }))\n  .groupBy(\'month\')\n  .mapValues(month =>\n    lodash.chain(month)\n      .groupBy(transaction =>\n        transaction.turnover < 0 ? "expense" : "income"\n      )\n      .mapValues(transactions =>\n        lodash.sumBy(transactions, \'turnover\')\n      )\n      .value()\n  )\n  .map((turnover, month) => ({ month, ...turnover }))\n  .value()'
                                            }
                                        }
                                    },
                                    {
                                        "id": 33,
                                        "name": "",
                                        "visibility": "result",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "= <reactInspector.TableInspector data={turnoverByMonth} />",
                                            "note": {
                                                "type": "expr",
                                                "code": " <reactInspector.TableInspector data={turnoverByMonth} />"
                                            }
                                        }
                                    },
                                    {
                                        "id": 19,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 20,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 21,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "## Graphs",
                                            "note": {
                                                "type": "text",
                                                "tag": "h2",
                                                "text": "Graphs"
                                            }
                                        }
                                    },
                                    {
                                        "id": 23,
                                        "name": "fmtEur",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "= Intl.NumberFormat('en', { style: 'currency', currency: 'EUR' })",
                                            "note": {
                                                "type": "expr",
                                                "code": " Intl.NumberFormat('en', { style: 'currency', currency: 'EUR' })"
                                            }
                                        }
                                    },
                                    {
                                        "id": 47,
                                        "name": "formatEuro",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "= num => fmtEur.format(num)",
                                            "note": {
                                                "type": "expr",
                                                "code": " num => fmtEur.format(num)"
                                            }
                                        }
                                    },
                                    {
                                        "id": 24,
                                        "name": "fmtDate",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "= Intl.DateTimeFormat('en', { dateStyle: 'short' })",
                                            "note": {
                                                "type": "expr",
                                                "code": " Intl.DateTimeFormat('en', { dateStyle: 'short' })"
                                            }
                                        }
                                    },
                                    {
                                        "id": 48,
                                        "name": "formatDate",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "= date => fmtDate.format(date)",
                                            "note": {
                                                "type": "expr",
                                                "code": " date => fmtDate.format(date)"
                                            }
                                        }
                                    },
                                    {
                                        "id": 26,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 31,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "### Turnover by Month",
                                            "note": {
                                                "type": "text",
                                                "tag": "h3",
                                                "text": "Turnover by Month"
                                            }
                                        }
                                    },
                                    {
                                        "id": 32,
                                        "name": "turnoverChart",
                                        "visibility": "result",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "/Code",
                                            "note": {
                                                "type": "block",
                                                "isInstantiated": true,
                                                "code": "Code",
                                                "state": 'const { ResponsiveContainer, BarChart, Bar, CartesianGrid, XAxis, YAxis, Tooltip } = libs.recharts;\n\n<ResponsiveContainer height={300}>\n  <BarChart data={turnoverByMonth}>\n    <Tooltip formatter={formatEuro} />\n    <CartesianGrid stroke="#eee" strokeDasharray="5 5"/>\n    <XAxis dataKey="month" />\n    <YAxis tickFormatter={formatEuro} width={80} />\n    <Bar type="monotone" dataKey="income" fill="#93bc60" />\n    <Bar type="monotone" dataKey="expense" fill="red" />\n  </BarChart>\n</ResponsiveContainer>'
                                            }
                                        }
                                    },
                                    {
                                        "id": 29,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "### Transactions",
                                            "note": {
                                                "type": "text",
                                                "tag": "h3",
                                                "text": "Transactions"
                                            }
                                        }
                                    },
                                    {
                                        "id": 22,
                                        "name": "transactionsChart",
                                        "visibility": "result",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "/Code",
                                            "note": {
                                                "type": "block",
                                                "isInstantiated": true,
                                                "code": "Code",
                                                "state": 'const { ResponsiveContainer, BarChart, Bar, CartesianGrid, XAxis, YAxis, Tooltip } = libs.recharts;\n\n<ResponsiveContainer height={300}>\n  <BarChart data={transactions}>\n    <Tooltip formatter={formatEuro} labelFormatter={formatDate} />\n    <CartesianGrid stroke="#eee" strokeDasharray="5 5"/>\n    <XAxis dataKey="date" tickFormatter={formatDate} />\n    <YAxis tickFormatter={formatEuro} width={80} />\n    <Bar type="monotone" dataKey="turnover" fill="#93bc60" />\n  </BarChart>\n</ResponsiveContainer>'
                                            }
                                        }
                                    },
                                    {
                                        "id": 28,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "### Account Balance",
                                            "note": {
                                                "type": "text",
                                                "tag": "h3",
                                                "text": "Account Balance"
                                            }
                                        }
                                    },
                                    {
                                        "id": 40,
                                        "name": "balances",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "= utils.scan( // scan is like reduce, but returns an array of every step\n  lodash.map(transactions, 'turnover'),\n  balanceStart,\n  lodash.add,\n)",
                                            "note": {
                                                "type": "expr",
                                                "code": " utils.scan( // scan is like reduce, but returns an array of every step\n  lodash.map(transactions, 'turnover'),\n  balanceStart,\n  lodash.add,\n)"
                                            }
                                        }
                                    },
                                    {
                                        "id": 41,
                                        "name": "transactionsWithBalance",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "= utils.addColumn(transactions, 'balance', balances)",
                                            "note": {
                                                "type": "expr",
                                                "code": " utils.addColumn(transactions, 'balance', balances)"
                                            }
                                        }
                                    },
                                    {
                                        "id": 42,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 25,
                                        "name": "accountBalanceChart",
                                        "visibility": "result",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "/Code",
                                            "note": {
                                                "type": "block",
                                                "isInstantiated": true,
                                                "code": "Code",
                                                "state": 'const { ResponsiveContainer, LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip } = libs.recharts;\n\nconst xScaleArgs = utils.timeScaleArgs(transactionsWithBalance, "date");\n\n<ResponsiveContainer height={300}>\n  <LineChart data={transactionsWithBalance}>\n    <Tooltip formatter={formatEuro} labelFormatter={formatDate}/>\n    <CartesianGrid stroke="#eee" strokeDasharray="5 5"/>\n    <Line type="stepAfter" dataKey="balance" fill="#93bc60" />\n    <XAxis {...xScaleArgs} tickFormatter={formatDate} />\n    <YAxis tickFormatter={formatEuro} width={80} />\n  </LineChart>\n</ResponsiveContainer>'
                                            }
                                        }
                                    },
                                    {
                                        "id": 43,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 44,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 50,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 51,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 49,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "full",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "---",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": "---"
                                            }
                                        }
                                    },
                                    {
                                        "id": 46,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "## Preview",
                                            "note": {
                                                "type": "text",
                                                "tag": "h2",
                                                "text": "Preview"
                                            }
                                        }
                                    },
                                    {
                                        "id": 45,
                                        "name": "preview",
                                        "visibility": "result",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "/Code",
                                            "note": {
                                                "type": "block",
                                                "isInstantiated": true,
                                                "code": "Code",
                                                "state": '<div>\n<h3 className="text-xl mt-4 mb-2">Turnover by Month</h3>\n{turnoverChart}\n\n<h3 className="text-xl mt-4 mb-2">Transactions</h3>\n{transactionsChart}\n\n<h3 className="text-xl mt-4 mb-2">Account Balance</h3>\n{accountBalanceChart}\n</div>'
                                            }
                                        }
                                    }
                                ]
                            }
                        },
                        "isCollapsed": true,
                        "children": [
                            {
                                "id": 0,
                                "name": "libs",
                                "state": {
                                    "t": "resheet.selector",
                                    "v": 0,
                                    "mode": "run",
                                    "expr": "SheetOf(Note)",
                                    "inner": {
                                        "t": "resheet.sheet",
                                        "v": 2,
                                        "lines": [
                                            {
                                                "id": 1,
                                                "name": "",
                                                "visibility": "block",
                                                "width": "narrow",
                                                "state": {
                                                    "t": "resheet.note",
                                                    "v": 1,
                                                    "level": 0,
                                                    "input": "/Code",
                                                    "note": {
                                                        "type": "block",
                                                        "isInstantiated": true,
                                                        "code": "Code",
                                                        "state": "function esmsh(lib) {\n  return import(`https://esm.sh/${lib}?external=react`)\n}\n\nasync function esmshDefault(lib) {\n  return (await esmsh(lib)).default\n}\n\nasync function awaitValues(obj) {\n  return (\n    lodash.zipObject(\n      Object.keys(obj),\n      await Promise.all(Object.values(obj)),\n    )\n  )\n}\n\nawaitValues({\n  papaparse: esmshDefault('papaparse'),\n  datefns: esmsh('date-fns'),\n  numeral: esmshDefault('numeral'),\n  \n  recharts: esmsh('recharts'),\n  d3Scale: esmsh('d3-scale'),\n})"
                                                    }
                                                }
                                            }
                                        ]
                                    }
                                },
                                "isCollapsed": true,
                                "children": []
                            },
                            {
                                "id": 2,
                                "name": "utils",
                                "state": {
                                    "t": "resheet.selector",
                                    "v": 0,
                                    "mode": "run",
                                    "expr": "SheetOf(Note)",
                                    "inner": {
                                        "t": "resheet.sheet",
                                        "v": 2,
                                        "lines": [
                                            {
                                                "id": 0,
                                                "name": "",
                                                "visibility": "block",
                                                "width": "narrow",
                                                "state": {
                                                    "t": "resheet.note",
                                                    "v": 1,
                                                    "level": 0,
                                                    "input": "/Code",
                                                    "note": {
                                                        "type": "block",
                                                        "isInstantiated": true,
                                                        "code": "Code",
                                                        "state": "function scan(array, init, fn) {\n  const steps = []\n  array.reduce(\n    (acc, item) => {\n      const newAcc = fn(acc, item)\n      steps.push(newAcc)\n      return newAcc\n    },\n    init,\n  )\n  return steps\n}\n\nfunction addColumn(table, colName, colValues) {\n  return lodash.zipWith(\n    table,\n    colValues,\n    (row, col) => ({ ...row, [colName]: col }),\n  )\n}\n\nfunction timeScaleArgs(data, dataKey) {\n  const timeValues = data.map(row => row[dataKey].valueOf());\n  const scale = (\n    libs.d3Scale.scaleTime()\n      .domain([\n        Math.min(...timeValues),\n        Math.max(...timeValues),\n      ])\n  )\n  \n  return {\n    domain: scale.domain().map(date => date.valueOf()),\n    scale,\n    type: 'number',\n    ticks: scale.ticks(5).map(date => date.valueOf()),\n    data,\n    dataKey,\n  }\n}\n\n({\n  scan,\n  addColumn,\n  timeScaleArgs,\n})"
                                                    }
                                                }
                                            }
                                        ]
                                    }
                                },
                                "isCollapsed": true,
                                "children": []
                            }
                        ]
                    },
                    {
                        "id": 5,
                        "name": "Curriculum Vitae",
                        "state": {
                            "t": "resheet.selector",
                            "v": 0,
                            "mode": "run",
                            "expr": "SheetOf(Note)",
                            "inner": {
                                "t": "resheet.sheet",
                                "v": 2,
                                "lines": [
                                    {
                                        "id": 33,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "# Curriculum Vitae",
                                            "note": {
                                                "type": "text",
                                                "tag": "h1",
                                                "text": "Curriculum Vitae"
                                            }
                                        }
                                    },
                                    {
                                        "id": 34,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": 'CV Components from the "Components" subpage:',
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": 'CV Components from the "Components" subpage:'
                                            }
                                        }
                                    },
                                    {
                                        "id": 29,
                                        "name": "CV",
                                        "visibility": "result",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "= Components",
                                            "note": {
                                                "type": "expr",
                                                "code": " Components"
                                            }
                                        }
                                    },
                                    {
                                        "id": 43,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 53,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "Most parts here have their code hidden (indicated by a yellow line when hovered/selected). To show the code either **double-click** on a line or select it and press **\u2318`M`**",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": "Most parts here have their code hidden (indicated by a yellow line when hovered/selected). To show the code either **double-click** on a line or select it and press **\u2318`M`**"
                                            }
                                        }
                                    },
                                    {
                                        "id": 54,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 56,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 57,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "---",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": "---"
                                            }
                                        }
                                    },
                                    {
                                        "id": 52,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "Contact data:",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": "Contact data:"
                                            }
                                        }
                                    },
                                    {
                                        "id": 44,
                                        "name": "addressShort",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": '= "WorksTown, HustleNation"',
                                            "note": {
                                                "type": "expr",
                                                "code": ' "WorksTown, HustleNation"'
                                            }
                                        }
                                    },
                                    {
                                        "id": 49,
                                        "name": "addressLong",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": '= "Doesit Street 13, 12345 WorksTown, HustleNation"',
                                            "note": {
                                                "type": "expr",
                                                "code": ' "Doesit Street 13, 12345 WorksTown, HustleNation"'
                                            }
                                        }
                                    },
                                    {
                                        "id": 50,
                                        "name": "phone",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": '= "+00 123 456789"',
                                            "note": {
                                                "type": "expr",
                                                "code": ' "+00 123 456789"'
                                            }
                                        }
                                    },
                                    {
                                        "id": 51,
                                        "name": "email",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": '= "jane.doe@prettygood.solutions"',
                                            "note": {
                                                "type": "expr",
                                                "code": ' "jane.doe@prettygood.solutions"'
                                            }
                                        }
                                    },
                                    {
                                        "id": 58,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "---",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": "---"
                                            }
                                        }
                                    },
                                    {
                                        "id": 47,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 59,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 48,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 37,
                                        "name": "header",
                                        "visibility": "result",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "/Code",
                                            "note": {
                                                "type": "block",
                                                "isInstantiated": true,
                                                "code": "Code",
                                                "state": '<CV.Header\n  name="Jane Doe"\n  description={<>\n    A highly specialised solutions developer, evaluating your requirements {}\n    with high fidelity, with 15+ years experience in customer satisfaction.\n  </>}\n  contact={<>\n    {addressShort}<br/>\n    {phone}<br/>\n    {email}<br/>\n  </>}\n  />'
                                            }
                                        }
                                    },
                                    {
                                        "id": 20,
                                        "name": "experience",
                                        "visibility": "result",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "/Code",
                                            "note": {
                                                "type": "block",
                                                "isInstantiated": true,
                                                "code": "Code",
                                                "state": '<>\n  <CV.SectionHeader>Professional Experience</CV.SectionHeader>\n\n  <CV.Experience\n    period={<CV.OpenPeriod start="2023/04" />}\n    title="Satisfaction Tracker"\n    role="Founder"\n    description={\n      <ul className="list-disc ml-5 space-y-1">\n        <li>\n          Oversaw development of the Satisfaction Tracker \n        </li>\n        <li>\n          Grew satisfaction 200% in 12 months\n        </li>\n        <li>\n          Cut costs by 75%\n        </li>\n      </ul>\n    }\n    tech="HustleScript, Reenact, Quibble"\n    />\n\n  <CV.Experience\n    period={<CV.ClosedPeriod start="2017/03" end="2023/02" />}\n    title="Solution Refiner"\n    company="Solutions Inc."\n    role="Staff Solver"\n    description={<>\n      Implemented solutions which improved ratings by 99.9%.\n    </>}\n    tech="HustleScript, SolutionSQL, TalkingMQ"\n    />\n    \n  <CV.Experience\n    hide\n    period={<CV.ClosedPeriod start="2016/01" end="2017/01" />}\n    title="HyperProduct"\n    company="StartUp Fast"\n    role="Solution Intern"\n    description={<>\n      Implemented multiple frontend components.\n    </>}\n    tech="HustleScript, Reenact"\n    />\n    \n</>'
                                            }
                                        }
                                    },
                                    {
                                        "id": 22,
                                        "name": "skills",
                                        "visibility": "result",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "/Code",
                                            "note": {
                                                "type": "block",
                                                "isInstantiated": true,
                                                "code": "Code",
                                                "state": 'function SkillsSectionName({ children }) {\n  return <span className={`text-${Style.colors.gray}`}>{children}</span>\n}\n\n<>\n  <CV.SectionHeader breakPage>Skills</CV.SectionHeader>\n  \n  <CV.Section\n    left={<SkillsSectionName>Programming Languages</SkillsSectionName>}\n  >\n    <CV.Skills>\n      {{\n        "HustleScript": "very good",\n        "NoScript":     "good",\n        "Fortran":      "basic",\n      }}\n    </CV.Skills>\n  </CV.Section>\n\n  <CV.Section\n    left={<SkillsSectionName>Frameworks</SkillsSectionName>}\n  >\n    <CV.Skills>\n      {{\n        "Reenact": "very good",\n      }}\n    </CV.Skills>\n  </CV.Section>\n\n  <CV.Section\n    left={<SkillsSectionName>Tools</SkillsSectionName>}\n  >\n    <CV.Skills>\n      {{\n        "Computers":   "very good",\n        "SolutionSQL": "good",\n        "Scissors":    "basic",\n      }}\n    </CV.Skills>\n  </CV.Section>\n</>'
                                            }
                                        }
                                    },
                                    {
                                        "id": 55,
                                        "name": "links",
                                        "visibility": "result",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "/Code",
                                            "note": {
                                                "type": "block",
                                                "isInstantiated": true,
                                                "code": "Code",
                                                "state": 'function Link({ name, link, description }) {\n  return (\n    <CV.Section>\n      <h3 className="text-lg leading-tight">\n        <a href={link}>{name}</a>\n      </h3>\n      \n      <a className={`leading-tight text-${Style.colors.gray}`} href={link}>\n        {link}\n      </a>\n      \n      {description &&\n        <p className="mt-2">\n          {description}\n        </p>\n      }\n    </CV.Section>\n  )\n}\n\n<>\n  <CV.SectionHeader>Links</CV.SectionHeader>\n  \n  <Link\n    name="Satisfaction Tracker"\n    link="https://satisfaction.tracker/"\n    description={<>\n      Tracks customers\' satisfaction\n    </>}\n    />\n\n  <Link\n    name="HubofGit Profile"\n    link="https://hubof.git/janedoe/"\n    />\n</>'
                                            }
                                        }
                                    },
                                    {
                                        "id": 24,
                                        "name": "education",
                                        "visibility": "result",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "/Code",
                                            "note": {
                                                "type": "block",
                                                "isInstantiated": true,
                                                "code": "Code",
                                                "state": '<>\n  <CV.SectionHeader breakPage>Education</CV.SectionHeader>\n  \n  <CV.Section\n    left={<CV.ClosedPeriod start="2000" end="2010" />}\n  >\n    <h3 className="text-lg leading-7">\n      Master of Solutions in Complicated Problems\n    </h3>\n    \n    <p className={`leading-7 text-${Style.colors.gray}`}>\n      Research Institute of Technology\n    </p>\n    \n    <p className="mt-2">\n      Thesis: Optimizating Solutions with tight time constraints\n    </p>\n  </CV.Section>\n  \n  <CV.Section\n    left={<CV.PeriodYear year="1999" />}\n  >\n    <h3 className="text-lg leading-7">\n      High School\n    </h3>\n    \n    <p className={`leading-7 text-${Style.colors.gray}`}>\n      WorksTown High School\n    </p>\n  </CV.Section>\n</>'
                                            }
                                        }
                                    },
                                    {
                                        "id": 26,
                                        "name": "engagement",
                                        "visibility": "result",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "/Code",
                                            "note": {
                                                "type": "block",
                                                "isInstantiated": true,
                                                "code": "Code",
                                                "state": '<>\n  <CV.SectionHeader>Engagement</CV.SectionHeader>\n  \n  <CV.Section\n    left={<CV.ClosedPeriod start="2000" end="2010" />}\n  >\n    <h3 className="text-lg leading-7">\n      Volunteering at DoGood\n    </h3>\n    \n    <p className={`leading-7 text-${Style.colors.gray}`}>\n      Helped people\n    </p>\n  </CV.Section>\n\n  <CV.Section\n    left={<CV.ClosedPeriod start="2012" end="2014" />}\n  >\n    <h3 className="text-lg leading-7">\n      Volunteering at AwesomeHelp\n    </h3>\n    \n    <p className={`leading-7 text-${Style.colors.gray}`}>\n      Organized support groups\n    </p>\n  </CV.Section>\n</>'
                                            }
                                        }
                                    },
                                    {
                                        "id": 30,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 31,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 32,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 38,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "# CV Short",
                                            "note": {
                                                "type": "text",
                                                "tag": "h1",
                                                "text": "CV Short"
                                            }
                                        }
                                    },
                                    {
                                        "id": 39,
                                        "name": "",
                                        "visibility": "result",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "/Code",
                                            "note": {
                                                "type": "block",
                                                "isInstantiated": true,
                                                "code": "Code",
                                                "state": "<CV.Document>\n  <main className={`font-['Arial'] mx-20 mb-28 text-${Style.colors.black}`}>  \n    <CV.PageMargin bottom=\"2cm\">\n      {header}\n      \n      {experience}\n      \n      {skills}\n      \n      {links}\n            \n    </CV.PageMargin>\n  </main>\n\n  <CV.Footer address={addressLong} phone={phone} email={email} />\n</CV.Document>"
                                            }
                                        }
                                    },
                                    {
                                        "id": 40,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 41,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 42,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 27,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "# CV Long",
                                            "note": {
                                                "type": "text",
                                                "tag": "h1",
                                                "text": "CV Long"
                                            }
                                        }
                                    },
                                    {
                                        "id": 28,
                                        "name": "",
                                        "visibility": "result",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "/Code",
                                            "note": {
                                                "type": "block",
                                                "isInstantiated": true,
                                                "code": "Code",
                                                "state": "<CV.Document>\n  <main className={`font-['Arial'] mx-20 mb-28 text-${Style.colors.black}`}>  \n    <CV.PageMargin bottom=\"2cm\">\n      {header}\n      \n      {experience}\n      \n      {skills}\n      \n      {links}\n      \n      {education}\n      \n      {engagement}\n      \n    </CV.PageMargin>\n  </main>\n\n  <CV.Footer address={addressLong} phone={phone} email={email} />\n</CV.Document>"
                                            }
                                        }
                                    }
                                ]
                            }
                        },
                        "isCollapsed": true,
                        "children": [
                            {
                                "id": 2,
                                "name": "Style",
                                "state": {
                                    "t": "resheet.selector",
                                    "v": 0,
                                    "mode": "run",
                                    "expr": "SheetOf(Note)",
                                    "inner": {
                                        "t": "resheet.sheet",
                                        "v": 2,
                                        "lines": [
                                            {
                                                "id": 5,
                                                "name": "",
                                                "visibility": "block",
                                                "width": "narrow",
                                                "state": {
                                                    "t": "resheet.note",
                                                    "v": 1,
                                                    "level": 0,
                                                    "input": "# Style",
                                                    "note": {
                                                        "type": "text",
                                                        "tag": "h1",
                                                        "text": "Style"
                                                    }
                                                }
                                            },
                                            {
                                                "id": 6,
                                                "name": "",
                                                "visibility": "block",
                                                "width": "narrow",
                                                "state": {
                                                    "t": "resheet.note",
                                                    "v": 1,
                                                    "level": 0,
                                                    "input": "",
                                                    "note": {
                                                        "type": "text",
                                                        "tag": "p",
                                                        "text": ""
                                                    }
                                                }
                                            },
                                            {
                                                "id": 7,
                                                "name": "",
                                                "visibility": "block",
                                                "width": "narrow",
                                                "state": {
                                                    "t": "resheet.note",
                                                    "v": 1,
                                                    "level": 0,
                                                    "input": "#### Colors",
                                                    "note": {
                                                        "type": "text",
                                                        "tag": "h4",
                                                        "text": "Colors"
                                                    }
                                                }
                                            },
                                            {
                                                "id": 1,
                                                "name": "colors",
                                                "visibility": "block",
                                                "width": "narrow",
                                                "state": {
                                                    "t": "resheet.note",
                                                    "v": 1,
                                                    "level": 0,
                                                    "input": "/Code",
                                                    "note": {
                                                        "type": "block",
                                                        "isInstantiated": true,
                                                        "code": "Code",
                                                        "state": "// Colors are tailwind.css colors\n//  declare custom colors as '[<css-color>]', eg. '[#636062]'\n({\n  primary: 'sky-700',\n  primaryLight: 'sky-500',\n  gray: 'slate-500',\n  grayDark: 'slate-700',\n  grayLight: 'slate-400',\n  black: 'slate-900',\n})"
                                                    }
                                                }
                                            },
                                            {
                                                "id": 8,
                                                "name": "",
                                                "visibility": "block",
                                                "width": "narrow",
                                                "state": {
                                                    "t": "resheet.note",
                                                    "v": 1,
                                                    "level": 0,
                                                    "input": "",
                                                    "note": {
                                                        "type": "text",
                                                        "tag": "p",
                                                        "text": ""
                                                    }
                                                }
                                            },
                                            {
                                                "id": 9,
                                                "name": "",
                                                "visibility": "block",
                                                "width": "narrow",
                                                "state": {
                                                    "t": "resheet.note",
                                                    "v": 1,
                                                    "level": 0,
                                                    "input": "#### Sizes",
                                                    "note": {
                                                        "type": "text",
                                                        "tag": "h4",
                                                        "text": "Sizes"
                                                    }
                                                }
                                            },
                                            {
                                                "id": 2,
                                                "name": "sizes",
                                                "visibility": "block",
                                                "width": "narrow",
                                                "state": {
                                                    "t": "resheet.note",
                                                    "v": 1,
                                                    "level": 0,
                                                    "input": "/Code",
                                                    "note": {
                                                        "type": "block",
                                                        "isInstantiated": true,
                                                        "code": "Code",
                                                        "state": '({\n  leftCol: "[125px]",\n})'
                                                    }
                                                }
                                            },
                                            {
                                                "id": 4,
                                                "name": "",
                                                "visibility": "block",
                                                "width": "narrow",
                                                "state": {
                                                    "t": "resheet.note",
                                                    "v": 1,
                                                    "level": 0,
                                                    "input": "",
                                                    "note": {
                                                        "type": "text",
                                                        "tag": "p",
                                                        "text": ""
                                                    }
                                                }
                                            },
                                            {
                                                "id": 10,
                                                "name": "",
                                                "visibility": "block",
                                                "width": "narrow",
                                                "state": {
                                                    "t": "resheet.note",
                                                    "v": 1,
                                                    "level": 0,
                                                    "input": "",
                                                    "note": {
                                                        "type": "text",
                                                        "tag": "p",
                                                        "text": ""
                                                    }
                                                }
                                            },
                                            {
                                                "id": 11,
                                                "name": "",
                                                "visibility": "block",
                                                "width": "narrow",
                                                "state": {
                                                    "t": "resheet.note",
                                                    "v": 1,
                                                    "level": 0,
                                                    "input": "",
                                                    "note": {
                                                        "type": "text",
                                                        "tag": "p",
                                                        "text": ""
                                                    }
                                                }
                                            },
                                            {
                                                "id": 3,
                                                "name": "export",
                                                "visibility": "block",
                                                "width": "narrow",
                                                "state": {
                                                    "t": "resheet.note",
                                                    "v": 1,
                                                    "level": 0,
                                                    "input": "= { colors, sizes }",
                                                    "note": {
                                                        "type": "expr",
                                                        "code": " { colors, sizes }"
                                                    }
                                                }
                                            }
                                        ]
                                    }
                                },
                                "isCollapsed": false,
                                "children": []
                            },
                            {
                                "id": 1,
                                "name": "Components",
                                "state": {
                                    "t": "resheet.selector",
                                    "v": 0,
                                    "mode": "run",
                                    "expr": "SheetOf(Note)",
                                    "inner": {
                                        "t": "resheet.sheet",
                                        "v": 2,
                                        "lines": [
                                            {
                                                "id": 21,
                                                "name": "",
                                                "visibility": "block",
                                                "width": "narrow",
                                                "state": {
                                                    "t": "resheet.note",
                                                    "v": 1,
                                                    "level": 0,
                                                    "input": "#Components",
                                                    "note": {
                                                        "type": "text",
                                                        "tag": "h1",
                                                        "text": "Components"
                                                    }
                                                }
                                            },
                                            {
                                                "id": 22,
                                                "name": "",
                                                "visibility": "block",
                                                "width": "narrow",
                                                "state": {
                                                    "t": "resheet.note",
                                                    "v": 1,
                                                    "level": 0,
                                                    "input": "#### General Components to create Documents",
                                                    "note": {
                                                        "type": "text",
                                                        "tag": "h4",
                                                        "text": "General Components to create Documents"
                                                    }
                                                }
                                            },
                                            {
                                                "id": 1,
                                                "name": "Document",
                                                "visibility": "result",
                                                "width": "narrow",
                                                "state": {
                                                    "t": "resheet.note",
                                                    "v": 1,
                                                    "level": 0,
                                                    "input": "/Code",
                                                    "note": {
                                                        "type": "block",
                                                        "isInstantiated": true,
                                                        "code": "Code",
                                                        "state": 'function renderDocument(content) {\n  return ReactDomServer.renderToString(\n      <html>\n        <head>\n          <style>{`\n            @page {\n              margin: 2cm 0 0 0;\n            }\n          `}</style>\n          <script src="https://cdn.tailwindcss.com" />\n        </head>\n        <body className="bg-white mt-14 print:mt-0">\n          {content}\n        </body>\n      </html>\n    )\n}\n  \nfunction Document({children}) {\n  const iframeRef = React.useRef()\n  \n  function print() {\n    iframeRef.current?.contentWindow?.print()\n  }\n  \n  return (\n    <div className="space-y-2">\n      <div className="w-full overflow-x-auto">\n        <iframe\n          ref={iframeRef}\n          className="border h-screen w-full min-w-[768px]"\n          srcDoc={renderDocument(children)}\n          />\n      </div>\n      <button\n        className="w-full px-3 py-1 rounded bg-blue-100 hover:bg-blue-200"\n        onClick={print}\n      >\n        Print\n      </button>\n    </div>\n  )\n}'
                                                    }
                                                }
                                            },
                                            {
                                                "id": 2,
                                                "name": "PageMargin",
                                                "visibility": "result",
                                                "width": "narrow",
                                                "state": {
                                                    "t": "resheet.note",
                                                    "v": 1,
                                                    "level": 0,
                                                    "input": "/Code",
                                                    "note": {
                                                        "type": "block",
                                                        "isInstantiated": true,
                                                        "code": "Code",
                                                        "state": "function PageMargin({ top = 0, bottom = 0, children }) {\n  // Workaround to get margins on every page while still being able\n  // to create fixed content inside the margins (footers/headers)\n  return (\n    <table>\n      <thead className={`h-[${top}]`} />\n      <tbody>\n        <tr>\n          <td>{children}</td>\n        </tr>\n      </tbody>\n      <tfoot className={`h-[${bottom}]`} />\n    </table>\n  )\n}"
                                                    }
                                                }
                                            },
                                            {
                                                "id": 3,
                                                "name": "",
                                                "visibility": "block",
                                                "width": "narrow",
                                                "state": {
                                                    "t": "resheet.note",
                                                    "v": 1,
                                                    "level": 0,
                                                    "input": "",
                                                    "note": {
                                                        "type": "text",
                                                        "tag": "p",
                                                        "text": ""
                                                    }
                                                }
                                            },
                                            {
                                                "id": 23,
                                                "name": "",
                                                "visibility": "block",
                                                "width": "narrow",
                                                "state": {
                                                    "t": "resheet.note",
                                                    "v": 1,
                                                    "level": 0,
                                                    "input": "#### Header / Footer",
                                                    "note": {
                                                        "type": "text",
                                                        "tag": "h4",
                                                        "text": "Header / Footer"
                                                    }
                                                }
                                            },
                                            {
                                                "id": 7,
                                                "name": "Header",
                                                "visibility": "result",
                                                "width": "narrow",
                                                "state": {
                                                    "t": "resheet.note",
                                                    "v": 1,
                                                    "level": 0,
                                                    "input": "/Code",
                                                    "note": {
                                                        "type": "block",
                                                        "isInstantiated": true,
                                                        "code": "Code",
                                                        "state": 'function Header({ name, description, contact }) {\n  return (\n    <>\n      <div className="flex mb-8 justify-between items-start">\n        <div>\n          <h1 className={`font-bold text-4xl text-${Style.colors.primary} leading-normal`}>\n            {name}\n          </h1>\n          <span className={`text-xl italic text-${Style.colors.gray}`}>\n            Curriculum Vitae\n          </span>\n        </div>\n  \n        {/* Contact info right */}\n        <address className={`leading-relaxed not-italic flex-end text-right text-${Style.colors.gray}`}>\n          {contact}\n        </address>\n      </div>\n      \n      <div className="my-8 px-6 italic font-light leading-tight">\n        {description}\n      </div>\n\n    </>\n  )\n}'
                                                    }
                                                }
                                            },
                                            {
                                                "id": 8,
                                                "name": "Footer",
                                                "visibility": "result",
                                                "width": "narrow",
                                                "state": {
                                                    "t": "resheet.note",
                                                    "v": 1,
                                                    "level": 0,
                                                    "input": "/Code",
                                                    "note": {
                                                        "type": "block",
                                                        "isInstantiated": true,
                                                        "code": "Code",
                                                        "state": 'function Footer({ address, phone, email }) {\n  return (\n    <footer\n      className={`\n        fixed bottom-0 inset-x-0 px-10 py-4\n        bg-${Style.colors.grayDark}\n        font-[\'Arial\'] text-white\n        flex flex-row justify-between items-baseline space-x-6\n      `}\n    >\n      <address className="not-italic">\n        {address}\n      </address>\n      <address className="not-italic text-nowrap">\n        {phone}\n      </address>\n      <address className="not-italic">\n        {email}\n      </address>\n    </footer>\n  )\n}'
                                                    }
                                                }
                                            },
                                            {
                                                "id": 24,
                                                "name": "",
                                                "visibility": "block",
                                                "width": "narrow",
                                                "state": {
                                                    "t": "resheet.note",
                                                    "v": 1,
                                                    "level": 0,
                                                    "input": "",
                                                    "note": {
                                                        "type": "text",
                                                        "tag": "p",
                                                        "text": ""
                                                    }
                                                }
                                            },
                                            {
                                                "id": 28,
                                                "name": "",
                                                "visibility": "block",
                                                "width": "narrow",
                                                "state": {
                                                    "t": "resheet.note",
                                                    "v": 1,
                                                    "level": 0,
                                                    "input": "#### Section Layout",
                                                    "note": {
                                                        "type": "text",
                                                        "tag": "h4",
                                                        "text": "Section Layout"
                                                    }
                                                }
                                            },
                                            {
                                                "id": 26,
                                                "name": "SectionHeader",
                                                "visibility": "result",
                                                "width": "narrow",
                                                "state": {
                                                    "t": "resheet.note",
                                                    "v": 1,
                                                    "level": 0,
                                                    "input": "/Code",
                                                    "note": {
                                                        "type": "block",
                                                        "isInstantiated": true,
                                                        "code": "Code",
                                                        "state": "function SectionHeader({ breakPage = false, children }) {\n  const line = (\n    <div className={`\n      inline-block mr-4 my-1 h-1.5 w-${Style.sizes.leftCol}\n      bg-${Style.colors.primaryLight}\n    `} />\n  )\n\n  return (\n    <h2 className={`\n      text-xl text-${Style.colors.primary} leading-normal\n      mt-16 mb-4 break-after-avoid-page\n      ${breakPage && 'break-before-page print:mt-4'}\n    `}>\n      {line}\n      {children}\n    </h2>\n  )\n}"
                                                    }
                                                }
                                            },
                                            {
                                                "id": 27,
                                                "name": "Section",
                                                "visibility": "result",
                                                "width": "narrow",
                                                "state": {
                                                    "t": "resheet.note",
                                                    "v": 1,
                                                    "level": 0,
                                                    "input": "/Code",
                                                    "note": {
                                                        "type": "block",
                                                        "isInstantiated": true,
                                                        "code": "Code",
                                                        "state": 'function Section({ left, children }) {\n  return (\n    <section className="flex flex-row my-8 space-x-4 items-baseline break-inside-avoid-page">\n      <div className={`shrink-0 w-${Style.sizes.leftCol} text-right`}>\n        {left}\n      </div>\n      \n      <div>\n        {children}\n      </div>\n    </section>\n  )\n}'
                                                    }
                                                }
                                            },
                                            {
                                                "id": 30,
                                                "name": "",
                                                "visibility": "block",
                                                "width": "narrow",
                                                "state": {
                                                    "t": "resheet.note",
                                                    "v": 1,
                                                    "level": 0,
                                                    "input": "",
                                                    "note": {
                                                        "type": "text",
                                                        "tag": "p",
                                                        "text": ""
                                                    }
                                                }
                                            },
                                            {
                                                "id": 34,
                                                "name": "",
                                                "visibility": "block",
                                                "width": "narrow",
                                                "state": {
                                                    "t": "resheet.note",
                                                    "v": 1,
                                                    "level": 0,
                                                    "input": "#### Skills",
                                                    "note": {
                                                        "type": "text",
                                                        "tag": "h4",
                                                        "text": "Skills"
                                                    }
                                                }
                                            },
                                            {
                                                "id": 33,
                                                "name": "TBody",
                                                "visibility": "result",
                                                "width": "narrow",
                                                "state": {
                                                    "t": "resheet.note",
                                                    "v": 1,
                                                    "level": 0,
                                                    "input": "/Code",
                                                    "note": {
                                                        "type": "block",
                                                        "isInstantiated": true,
                                                        "code": "Code",
                                                        "state": "function TBody({ children, className, trClass, tdClass }) {\n  return (\n    <tbody className={className}>\n      {children.map((row, y) => (\n        <tr key={y} className={trClass}>\n          {row.map((cell, x) => (\n            <td key={x} className={tdClass}>\n              {cell}\n            </td>\n          ))}\n        </tr>\n      ))}\n    </tbody>\n  )\n}"
                                                    }
                                                }
                                            },
                                            {
                                                "id": 36,
                                                "name": "Skills",
                                                "visibility": "result",
                                                "width": "narrow",
                                                "state": {
                                                    "t": "resheet.note",
                                                    "v": 1,
                                                    "level": 0,
                                                    "input": "/Code",
                                                    "note": {
                                                        "type": "block",
                                                        "isInstantiated": true,
                                                        "code": "Code",
                                                        "state": 'function Skills({ children }) {\n  return (\n    <table className="break-inside-avoid-page">\n      <TBody trClass="align-baseline" tdClass="min-w-24">\n        {Object.entries(children)\n          .map(([topic, desc]) => [\n            topic,\n            <span className={`ml-6 text-${Style.colors.gray}`}>\n              {desc}\n            </span>,\n          ])\n        }\n      </TBody>\n    </table>\n  )\n}'
                                                    }
                                                }
                                            },
                                            {
                                                "id": 35,
                                                "name": "",
                                                "visibility": "block",
                                                "width": "narrow",
                                                "state": {
                                                    "t": "resheet.note",
                                                    "v": 1,
                                                    "level": 0,
                                                    "input": "",
                                                    "note": {
                                                        "type": "text",
                                                        "tag": "p",
                                                        "text": ""
                                                    }
                                                }
                                            },
                                            {
                                                "id": 31,
                                                "name": "",
                                                "visibility": "block",
                                                "width": "narrow",
                                                "state": {
                                                    "t": "resheet.note",
                                                    "v": 1,
                                                    "level": 0,
                                                    "input": "#### Experience",
                                                    "note": {
                                                        "type": "text",
                                                        "tag": "h4",
                                                        "text": "Experience"
                                                    }
                                                }
                                            },
                                            {
                                                "id": 32,
                                                "name": "Experience",
                                                "visibility": "result",
                                                "width": "narrow",
                                                "state": {
                                                    "t": "resheet.note",
                                                    "v": 1,
                                                    "level": 0,
                                                    "input": "/Code",
                                                    "note": {
                                                        "type": "block",
                                                        "isInstantiated": true,
                                                        "code": "Code",
                                                        "state": 'function Experience({ period, title, company, role, description, tech, hide = false }) {\n  if (hide) { return null }\n  return (\n    <Section left={period}>\n      <h3 className="text-lg leading-7">\n        {title} {}\n        {company &&\n          <span className={`text-base ml-4 text-${Style.colors.gray}`}>\n            <span className={`text-sm mr-0.5 text-${Style.colors.grayLight}`}>at</span> {}\n            {company}\n          </span>\n        }\n      </h3>\n      \n      <p className="leading-7">\n        <span className={`text-${Style.colors.gray}`}>Role:</span> {role}\n      </p>\n      \n      <div className="my-3">\n        {description}\n      </div>\n      \n      <p className={`text-${Style.colors.gray}`}>\n        Technologies: {tech}\n      </p>\n    </Section>\n  )\n}'
                                                    }
                                                }
                                            },
                                            {
                                                "id": 37,
                                                "name": "",
                                                "visibility": "block",
                                                "width": "narrow",
                                                "state": {
                                                    "t": "resheet.note",
                                                    "v": 1,
                                                    "level": 0,
                                                    "input": "",
                                                    "note": {
                                                        "type": "text",
                                                        "tag": "p",
                                                        "text": ""
                                                    }
                                                }
                                            },
                                            {
                                                "id": 25,
                                                "name": "",
                                                "visibility": "block",
                                                "width": "narrow",
                                                "state": {
                                                    "t": "resheet.note",
                                                    "v": 1,
                                                    "level": 0,
                                                    "input": "#### Periods",
                                                    "note": {
                                                        "type": "text",
                                                        "tag": "h4",
                                                        "text": "Periods"
                                                    }
                                                }
                                            },
                                            {
                                                "id": 9,
                                                "name": "ClosedPeriod",
                                                "visibility": "result",
                                                "width": "narrow",
                                                "state": {
                                                    "t": "resheet.note",
                                                    "v": 1,
                                                    "level": 0,
                                                    "input": "/Code",
                                                    "note": {
                                                        "type": "block",
                                                        "isInstantiated": true,
                                                        "code": "Code",
                                                        "state": 'function ClosedPeriod({ start, end }) {\n  return (\n    <p className="text-lg leading-7">\n      <span className={`text-${Style.colors.gray} mr-1`}>from</span> {start}\n      <br/>\n      <span className={`text-${Style.colors.gray} mr-1`}>until</span> {end}\n    </p>\n  )\n}'
                                                    }
                                                }
                                            },
                                            {
                                                "id": 10,
                                                "name": "OpenPeriod",
                                                "visibility": "result",
                                                "width": "narrow",
                                                "state": {
                                                    "t": "resheet.note",
                                                    "v": 1,
                                                    "level": 0,
                                                    "input": "/Code",
                                                    "note": {
                                                        "type": "block",
                                                        "isInstantiated": true,
                                                        "code": "Code",
                                                        "state": 'function OpenPeriod({ start }) {\n  return (\n    <p className="text-lg leading-7">\n      <span className={`text-${Style.colors.gray} mr-1`}>since</span> {start}\n    </p>\n  )\n}'
                                                    }
                                                }
                                            },
                                            {
                                                "id": 11,
                                                "name": "PeriodYear",
                                                "visibility": "result",
                                                "width": "narrow",
                                                "state": {
                                                    "t": "resheet.note",
                                                    "v": 1,
                                                    "level": 0,
                                                    "input": "/Code",
                                                    "note": {
                                                        "type": "block",
                                                        "isInstantiated": true,
                                                        "code": "Code",
                                                        "state": 'function PeriodYear({ year }) {\n  return (\n    <p className="text-lg leading-7">\n      <span className={`text-${Style.colors.gray} mr-1`}>in</span> {year}\n    </p>\n  )\n}'
                                                    }
                                                }
                                            },
                                            {
                                                "id": 18,
                                                "name": "",
                                                "visibility": "block",
                                                "width": "narrow",
                                                "state": {
                                                    "t": "resheet.note",
                                                    "v": 1,
                                                    "level": 0,
                                                    "input": "",
                                                    "note": {
                                                        "type": "text",
                                                        "tag": "p",
                                                        "text": ""
                                                    }
                                                }
                                            },
                                            {
                                                "id": 19,
                                                "name": "",
                                                "visibility": "block",
                                                "width": "narrow",
                                                "state": {
                                                    "t": "resheet.note",
                                                    "v": 1,
                                                    "level": 0,
                                                    "input": "",
                                                    "note": {
                                                        "type": "text",
                                                        "tag": "p",
                                                        "text": ""
                                                    }
                                                }
                                            },
                                            {
                                                "id": 20,
                                                "name": "exports",
                                                "visibility": "block",
                                                "width": "narrow",
                                                "state": {
                                                    "t": "resheet.note",
                                                    "v": 1,
                                                    "level": 0,
                                                    "input": "= { Document, PageMargin, Header, Footer, ClosedPeriod, OpenPeriod, PeriodYear, SectionHeader, Section, Experience, TBody, Skills }",
                                                    "note": {
                                                        "type": "expr",
                                                        "code": " { Document, PageMargin, Header, Footer, ClosedPeriod, OpenPeriod, PeriodYear, SectionHeader, Section, Experience, TBody, Skills }"
                                                    }
                                                }
                                            }
                                        ]
                                    }
                                },
                                "isCollapsed": false,
                                "children": []
                            }
                        ]
                    },
                    {
                        "id": 3,
                        "name": "Invoice",
                        "state": {
                            "t": "resheet.selector",
                            "v": 0,
                            "mode": "run",
                            "expr": "SheetOf(Note)",
                            "inner": {
                                "t": "resheet.sheet",
                                "v": 2,
                                "lines": [
                                    {
                                        "id": 43,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "# Invoice",
                                            "note": {
                                                "type": "text",
                                                "tag": "h1",
                                                "text": "Invoice"
                                            }
                                        }
                                    },
                                    {
                                        "id": 44,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "Load a working hours export (from atWork) and generate an invoice.",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": "Load a working hours export (from atWork) and generate an invoice."
                                            }
                                        }
                                    },
                                    {
                                        "id": 3,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 15,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "## Load and Parse CSV",
                                            "note": {
                                                "type": "text",
                                                "tag": "h2",
                                                "text": "Load and Parse CSV"
                                            }
                                        }
                                    },
                                    {
                                        "id": 4,
                                        "name": "atWorkExportFile",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "/LoadFile",
                                            "note": {
                                                "type": "block",
                                                "isInstantiated": true,
                                                "code": "LoadFile",
                                                "state": {
                                                    "state": "loaded",
                                                    "file": {
                                                        "content": "RWludHLDpGdlOzs7CkJlZ2lubjtFbmRlO1BhdXNlO0RhdWVyCjA0LjEyLjIwMjMgMDk6MjY7MDQuMTIuMjAyMyAxNTowOTsiMSwxODMiOyI0LDUzMyIKMDUuMTIuMjAyMyAwOTo1MzswNS4xMi4yMDIzIDIwOjE2OyIzLDAzMyI7IjcsMzUiCjA2LjEyLjIwMjMgMTQ6NTY7MDYuMTIuMjAyMyAyMjozMzsiMCw5NjciOyI2LDY1IgowOC4xMi4yMDIzIDEyOjA2OzA4LjEyLjIwMjMgMjE6MDA7IjEsNzUiOyI3LDE1IgoxMi4xMi4yMDIzIDEwOjI2OzEyLjEyLjIwMjMgMTE6MzE7OyIxLDA4MyIKMTMuMTIuMjAyMyAwOTo0NDsxMy4xMi4yMDIzIDEyOjU0OyIwLDUiOyIyLDY2NyIKMTMuMTIuMjAyMyAyMDo0NTsxMy4xMi4yMDIzIDIyOjE1OzsiMSw1IgoxNC4xMi4yMDIzIDE2OjM4OzE0LjEyLjIwMjMgMTc6MDU7OyIwLDQ1IgoxNS4xMi4yMDIzIDEyOjMwOzE1LjEyLjIwMjMgMTg6NDU7IjAsNzY3IjsiNSw0ODMiCjE4LjEyLjIwMjMgMDg6Mjc7MTguMTIuMjAyMyAxMjoyNjs7IjMsOTgzIgoxOS4xMi4yMDIzIDE0OjQwOzE5LjEyLjIwMjMgMTg6MTg7OyIzLDYzMyIKMjAuMTIuMjAyMyAwODozNDsyMC4xMi4yMDIzIDE0OjM0OyIwLDQ4MyI7IjUsNTE3IgoyMS4xMi4yMDIzIDE1OjMwOzIxLjEyLjIwMjMgMjM6MDY7MjsiNSw2Igo7OzsK",
                                                        "name": "numbers-export-atwork-2024-04-03-12_21_50.csv",
                                                        "options": {
                                                            "type": "text/csv",
                                                            "lastModified": 1712139710000
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    },
                                    {
                                        "id": 7,
                                        "name": "atWorkExportParsed",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "= libs.papaparse.parse(await atWorkExportFile.text())",
                                            "note": {
                                                "type": "expr",
                                                "code": " libs.papaparse.parse(await atWorkExportFile.text())"
                                            }
                                        }
                                    },
                                    {
                                        "id": 8,
                                        "name": "",
                                        "visibility": "result",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "= <reactInspector.TableInspector data={atWorkExportParsed.data} />",
                                            "note": {
                                                "type": "expr",
                                                "code": " <reactInspector.TableInspector data={atWorkExportParsed.data} />"
                                            }
                                        }
                                    },
                                    {
                                        "id": 9,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 17,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 18,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 16,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "## Convert and Process Data",
                                            "note": {
                                                "type": "text",
                                                "tag": "h2",
                                                "text": "Convert and Process Data"
                                            }
                                        }
                                    },
                                    {
                                        "id": 10,
                                        "name": "entriesRaw",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "= atWorkExportParsed.data.slice(2, -2)",
                                            "note": {
                                                "type": "expr",
                                                "code": " atWorkExportParsed.data.slice(2, -2)"
                                            }
                                        }
                                    },
                                    {
                                        "id": 45,
                                        "name": "",
                                        "visibility": "result",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "= <reactInspector.TableInspector data={entriesRaw} />",
                                            "note": {
                                                "type": "expr",
                                                "code": " <reactInspector.TableInspector data={entriesRaw} />"
                                            }
                                        }
                                    },
                                    {
                                        "id": 36,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 37,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 13,
                                        "name": "workingIntervals",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "/Code",
                                            "note": {
                                                "type": "block",
                                                "isInstantiated": true,
                                                "code": "Code",
                                                "state": "const parseDate = utils.localized.de.dateParser({ date: 'medium' })\nconst parseTime = utils.localized.de.dateParser({ time: 'short' })\n\nfunction parseDatetime(str) {\n  const [dateStr, timeStr] = str.split(' ')\n  const date = parseDate(dateStr)\n  const time = parseTime(timeStr)\n  return utils.combineDateTime(date, time)\n}\n\nconst parseNumber = utils.localized.de.numberParser()\n\nentriesRaw\n  .map(\n    ([start, end, pause, duration]) => {\n      const turnoverNum = utils.cldr\n      return {\n        start: parseDatetime(start),\n        end: parseDatetime(end),\n        pauseHours: pause ? parseNumber(pause) : 0,\n        workingHours: parseNumber(duration),\n      }\n    }\n  )"
                                            }
                                        }
                                    },
                                    {
                                        "id": 11,
                                        "name": "",
                                        "visibility": "result",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "= <reactInspector.TableInspector data={workingIntervals} />",
                                            "note": {
                                                "type": "expr",
                                                "code": " <reactInspector.TableInspector data={workingIntervals} />"
                                            }
                                        }
                                    },
                                    {
                                        "id": 34,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 35,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 30,
                                        "name": "workingHoursBy",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "/Code",
                                            "note": {
                                                "type": "block",
                                                "isInstantiated": true,
                                                "code": "Code",
                                                "state": "function workingHoursBy(dateGroup) {\n  return lodash.chain(workingIntervals)\n    .map(workingInterval => ({\n      ...workingInterval,\n      timestamp: dateGroup(workingInterval).getTime(),\n    }))\n    .groupBy('timestamp')\n    .mapValues(group => ({\n      workingHours: lodash.sumBy(group, 'workingHours'),\n      pauseHours: lodash.sumBy(group, 'pauseHours'),\n    }))\n    .map((workingInterval, timestamp) => ({\n      date: new Date(Number(timestamp)),\n      ...workingInterval,\n    }))\n    .value()\n}"
                                            }
                                        }
                                    },
                                    {
                                        "id": 48,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 19,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 20,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 21,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "## Graphs",
                                            "note": {
                                                "type": "text",
                                                "tag": "h2",
                                                "text": "Graphs"
                                            }
                                        }
                                    },
                                    {
                                        "id": 23,
                                        "name": "formatDuration",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "= duration => `${Math.trunc(duration)}:${String(Math.round(duration * 60 % 60)).padStart(2, '0')}`",
                                            "note": {
                                                "type": "expr",
                                                "code": " duration => `${Math.trunc(duration)}:${String(Math.round(duration * 60 % 60)).padStart(2, '0')}`"
                                            }
                                        }
                                    },
                                    {
                                        "id": 26,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 31,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "### Working Hours by Day",
                                            "note": {
                                                "type": "text",
                                                "tag": "h3",
                                                "text": "Working Hours by Day"
                                            }
                                        }
                                    },
                                    {
                                        "id": 49,
                                        "name": "formatDateDay",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": '= date => libs.datefns.format(date, "dd.LL.uu")',
                                            "note": {
                                                "type": "expr",
                                                "code": ' date => libs.datefns.format(date, "dd.LL.uu")'
                                            }
                                        }
                                    },
                                    {
                                        "id": 50,
                                        "name": "workingHoursByDay",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "= workingHoursBy(({ start }) => libs.datefns.startOfDay(start))",
                                            "note": {
                                                "type": "expr",
                                                "code": " workingHoursBy(({ start }) => libs.datefns.startOfDay(start))"
                                            }
                                        }
                                    },
                                    {
                                        "id": 32,
                                        "name": "workingHoursByDayChart",
                                        "visibility": "result",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "/Code",
                                            "note": {
                                                "type": "block",
                                                "isInstantiated": true,
                                                "code": "Code",
                                                "state": 'const { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, Tooltip } = libs.recharts;\n\n<ResponsiveContainer height={300}>\n  <BarChart data={workingHoursByDay}>\n    <Tooltip formatter={formatDuration} labelFormatter={formatDateDay} />\n    <Bar type="monotone" dataKey="workingHours" stackId="" fill="#93bc60" />\n    <Bar type="monotone" dataKey="pauseHours" stackId="" fill="orange" />\n    <XAxis dataKey="date" tickFormatter={formatDateDay} />\n    <YAxis tickFormatter={formatDuration} width={80} />\n  </BarChart>\n</ResponsiveContainer>'
                                            }
                                        }
                                    },
                                    {
                                        "id": 51,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "### Working Hours by Month",
                                            "note": {
                                                "type": "text",
                                                "tag": "h3",
                                                "text": "Working Hours by Month"
                                            }
                                        }
                                    },
                                    {
                                        "id": 52,
                                        "name": "formatDateMonth",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": '= date => libs.datefns.format(date, "LLL uu")',
                                            "note": {
                                                "type": "expr",
                                                "code": ' date => libs.datefns.format(date, "LLL uu")'
                                            }
                                        }
                                    },
                                    {
                                        "id": 53,
                                        "name": "workingHoursByMonth",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "= workingHoursBy(({ start }) => libs.datefns.startOfMonth(start))",
                                            "note": {
                                                "type": "expr",
                                                "code": " workingHoursBy(({ start }) => libs.datefns.startOfMonth(start))"
                                            }
                                        }
                                    },
                                    {
                                        "id": 54,
                                        "name": "",
                                        "visibility": "result",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "/Code",
                                            "note": {
                                                "type": "block",
                                                "isInstantiated": true,
                                                "code": "Code",
                                                "state": 'const { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, Tooltip } = libs.recharts;\n\n<ResponsiveContainer height={300}>\n  <BarChart data={workingHoursByMonth}>\n    <Tooltip formatter={formatDuration} labelFormatter={formatDateMonth} />\n    <Bar type="monotone" dataKey="workingHours" stackId="" fill="#93bc60" />\n    <XAxis dataKey="date" tickFormatter={formatDateMonth} />\n    <YAxis tickFormatter={formatDuration} width={80} />\n  </BarChart>\n</ResponsiveContainer>'
                                            }
                                        }
                                    },
                                    {
                                        "id": 55,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 56,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "## Invoice",
                                            "note": {
                                                "type": "text",
                                                "tag": "h2",
                                                "text": "Invoice"
                                            }
                                        }
                                    },
                                    {
                                        "id": 58,
                                        "name": "hourlyWage",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "= 75",
                                            "note": {
                                                "type": "expr",
                                                "code": " 75"
                                            }
                                        }
                                    },
                                    {
                                        "id": 73,
                                        "name": "taxRate",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "= 0.19",
                                            "note": {
                                                "type": "expr",
                                                "code": " 0.19"
                                            }
                                        }
                                    },
                                    {
                                        "id": 74,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 59,
                                        "name": "invoiceData",
                                        "visibility": "result",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "/blocks.JSExpr",
                                            "note": {
                                                "type": "block",
                                                "isInstantiated": true,
                                                "code": "blocks.JSExpr",
                                                "state": "workingHoursByDay\n  .map(entry => ({\n    ...entry,\n    workingHoursRound: utils.roundOn(entry.workingHours, 0.25),\n  }))\n  .map(entry => ({\n    ...entry,\n    price: utils.roundOn(entry.workingHoursRound * hourlyWage, 0.01),\n  }))"
                                            }
                                        }
                                    },
                                    {
                                        "id": 75,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 62,
                                        "name": "invoiceSum",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "= lodash.sumBy(invoiceData, 'price')",
                                            "note": {
                                                "type": "expr",
                                                "code": " lodash.sumBy(invoiceData, 'price')"
                                            }
                                        }
                                    },
                                    {
                                        "id": 63,
                                        "name": "invoiceTaxes",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "= utils.roundOn(invoiceSum * taxRate, 0.01)",
                                            "note": {
                                                "type": "expr",
                                                "code": " utils.roundOn(invoiceSum * taxRate, 0.01)"
                                            }
                                        }
                                    },
                                    {
                                        "id": 64,
                                        "name": "invoiceTotal",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "= utils.roundOn(invoiceSum + invoiceTaxes, 0.01)",
                                            "note": {
                                                "type": "expr",
                                                "code": " utils.roundOn(invoiceSum + invoiceTaxes, 0.01)"
                                            }
                                        }
                                    },
                                    {
                                        "id": 70,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 71,
                                        "name": "locale",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": '= "en"',
                                            "note": {
                                                "type": "expr",
                                                "code": ' "en"'
                                            }
                                        }
                                    },
                                    {
                                        "id": 72,
                                        "name": "currency",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": '= "USD"',
                                            "note": {
                                                "type": "expr",
                                                "code": ' "USD"'
                                            }
                                        }
                                    },
                                    {
                                        "id": 76,
                                        "name": "fmt",
                                        "visibility": "result",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "/blocks.JSExpr",
                                            "note": {
                                                "type": "block",
                                                "isInstantiated": true,
                                                "code": "blocks.JSExpr",
                                                "state": "({\n  currency: Intl.NumberFormat(locale, {\n    style: 'currency',\n    currency,\n  }),\n  date: Intl.DateTimeFormat(locale, {\n    dateStyle: 'short',\n  }), \n  percent: Intl.NumberFormat(locale, {\n    style: 'percent',\n  }),\n})"
                                            }
                                        }
                                    },
                                    {
                                        "id": 77,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 57,
                                        "name": "invoiceTable",
                                        "visibility": "result",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "/Code",
                                            "note": {
                                                "type": "block",
                                                "isInstantiated": true,
                                                "code": "Code",
                                                "state": '<table className="w-full">\n  <thead className="font-bold bg-sky-100">\n    <tr>\n      <th className="p-2 text-left">Project</th>\n      <th className="p-2 text-center w-28">Date</th>\n      <th className="p-2 text-right w-40">Working Hours</th>\n      <th className="p-2 text-right w-28">Price</th>\n    </tr>\n  </thead>\n  \n  {/*\n    "Padding" at the table bottom, so the content doesn\'t hide\n    below the footer when printing.\n  */}\n  <tfoot className="hidden print:table-footer-group">\n    <tr className="h-28"><td/></tr>\n  </tfoot>\n\n  <tbody>\n    {invoiceData.map(({ date, workingHoursRound, price }) => (\n      <tr className="even:bg-slate-100">\n        <td className="px-2 py-1.5">\n          BuildTheFuture\n        </td>\n        <td className="px-2 py-1.5 text-center">\n          {fmt.date.format(date)}\n        </td>\n        <td className="px-2 py-1.5 text-right">\n          {formatDuration(workingHoursRound)} h\n        </td>\n        <td className="px-2 py-1.5 text-right">\n          {fmt.currency.format(price)}\n        </td>\n      </tr>\n    ))}\n    \n    {/*\n      Footer not in <tfoot> because otherwise\n      it get\'s repeated on every printed page\n    */}\n    <tr className="font-medium bg-sky-100 border-t-2 border-white break-before-avoid-page">\n      <td colspan={3} className="p-2 text-right">\n        Sum\n      </td>\n      <td className="p-2 text-right">\n        {fmt.currency.format(invoiceSum)}\n      </td>\n    </tr>\n    <tr className="font-medium bg-sky-100 border-t-2 border-white break-before-avoid-page">\n      <td colSpan={3} className="p-2 text-right">\n        {fmt.percent.format(taxRate)} Taxes\n      </td>\n      <td className="p-2 text-right">\n        {fmt.currency.format(invoiceTaxes)}\n      </td>\n    </tr>\n    <tr className="font-bold bg-sky-100 border-t-2 border-white break-before-avoid-page">\n      <td colSpan={3} className="p-2 text-right">\n        Total\n      </td>\n      <td className="p-2 text-right">\n        {fmt.currency.format(invoiceTotal)}\n      </td>\n    </tr>\n  </tbody>\n</table>'
                                            }
                                        }
                                    },
                                    {
                                        "id": 65,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 66,
                                        "name": "Document",
                                        "visibility": "result",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "/Code",
                                            "note": {
                                                "type": "block",
                                                "isInstantiated": true,
                                                "code": "Code",
                                                "state": 'function renderDocument(content) {\n  return ReactDomServer.renderToString(\n      <html>\n        <head>\n          <style>{`\n            @page {\n              margin: 2cm 0 0 0;\n            }\n          `}</style>\n          <script src="https://cdn.tailwindcss.com" />\n        </head>\n        <body className="bg-white">\n          {content}\n        </body>\n      </html>\n    )\n}\n  \nfunction Document({children}) {\n  const iframeRef = React.useRef()\n  \n  function onPrintIframe() {\n    iframeRef.current?.contentWindow?.print()\n  }\n  \n  return (\n    <div className="flex flex-col items-stretch space-y-2">\n      <div className="overflow-x-auto">\n        <iframe\n          ref={iframeRef}\n          className="border min-w-[768px]"\n          height="1200"\n          srcDoc={renderDocument(children)}\n          />\n      </div>\n      <button\n        className="px-3 py-1 rounded bg-blue-100 hover:bg-blue-200"\n        onClick={() => onPrintIframe()}\n      >\n        Print\n      </button>\n    </div>\n  )\n}'
                                            }
                                        }
                                    },
                                    {
                                        "id": 68,
                                        "name": "invoiceDocument",
                                        "visibility": "result",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "/Code",
                                            "note": {
                                                "type": "block",
                                                "isInstantiated": true,
                                                "code": "Code",
                                                "state": 'const invoiceDate = new Date();\nconst invoiceMonth = libs.datefns.formatDate(invoiceDate, "yyyy-MM");\nconst invoiceNo = `${invoiceMonth}-01`;\n\nconst senderName = "Jane Doe";\nconst senderDescription = "PrettyGoodSolutions Consultant";\nconst senderAddress = [\n  senderName,\n  "Doesit Street 13",\n  "12345 WorksTown",\n];\nconst senderContact = [\n  "+00 123 456789",\n  "jane.doe@prettygood.solutions",\n];\nconst senderBank = <>\n  BestBank Inc.<br/>\n  IBAN: DE42 1337 1234 7654 8989 00\n</>;\n\nconst receiverAddress = <>\n  BigCorp Inc.<br/>\n  Large Street 123<br/>\n  99999 MegaCity\n</>;\n\n\n<Document>\n  <main className="font-[\'Arial\'] mx-20 mb-28">\n  \n    {/* Header top right with name and description */}\n    <h1\n      className="font-bold text-4xl text-right text-sky-700 leading-normal"\n    >\n      {senderName}\n    </h1>\n    <div className="text-right text-slate-800">\n      {senderDescription}\n    </div>\n    \n    \n    <div className="flex my-12">\n      {/* Adress sender and receiver left */}\n      <div className="flex-1 space-y-2">\n        <address className="text-xs not-italic text-sky-700">\n          {senderAddress.flatMap(field => ["\u2022", field]).slice(1).join(" ")}\n        </address>\n        <address className="leading-tight not-italic">\n          {receiverAddress}\n        </address>\n      </div>\n      \n      {/* Contact details right */}\n      <address\n        className="leading-tight not-italic flex-end text-right text-sm"\n      >\n        {senderAddress.flatMap(field => [field, <br/>])}\n        <br/>\n        {senderContact.flatMap(field => [field, <br/>])}\n      </address>\n    </div>\n    \n    \n    {/* Message Header */}\n    <h2 className="font-bold text-xl text-sky-700 leading-normal">\n      Invoice\n    </h2>\n    <h3 className="flex justify-between leading-normal mt-1 mb-5">\n      <span>InvoiceNo: {invoiceNo}</span>\n      <span>{fmt.date.format(invoiceDate)}</span>\n    </h3>\n    \n    \n    {/* Message Content */}\n    <article>\n      {invoiceTable}\n    </article>\n    \n  </main>\n  \n  {/* Footer */}\n  <footer\n    className={`\n      fixed bottom-0 h-24 w-screen px-20 py-2\n      bg-slate-600\n      font-[\'Arial\'] text-sm text-white\n      flex flex-row justify-between items-start\n    `}\n  >\n    <div>\n      {senderDescription}<br/>\n      {senderName}\n    </div>\n    <address className="not-italic">\n      {senderBank}\n    </address>\n  </footer>\n</Document>'
                                            }
                                        }
                                    },
                                    {
                                        "id": 78,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 69,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "**Note**: When printing make sure to fiddle with the printing settings: Enable backgrounds and disable the header and footer added by the browser. Printing in Chromium-based browsers works best.",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": "**Note**: When printing make sure to fiddle with the printing settings: Enable backgrounds and disable the header and footer added by the browser. Printing in Chromium-based browsers works best."
                                            }
                                        }
                                    },
                                    {
                                        "id": 79,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 81,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 84,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 85,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 86,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 87,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "full",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "---",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": "---"
                                            }
                                        }
                                    },
                                    {
                                        "id": 82,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "## Preview",
                                            "note": {
                                                "type": "text",
                                                "tag": "h2",
                                                "text": "Preview"
                                            }
                                        }
                                    },
                                    {
                                        "id": 83,
                                        "name": "preview",
                                        "visibility": "result",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "/Code",
                                            "note": {
                                                "type": "block",
                                                "isInstantiated": true,
                                                "code": "Code",
                                                "state": '<div>\n<h3 className="text-xl mt-4 mb-2">atWork CSV Export</h3>\n<reactInspector.TableInspector data={entriesRaw} />\n\n<h3 className="text-xl mt-4 mb-2">Working Hours</h3>\n{workingHoursByDayChart}\n\n<h3 className="text-xl mt-4 mb-2">Invoice</h3>\n{invoiceDocument}\n</div>'
                                            }
                                        }
                                    }
                                ]
                            }
                        },
                        "isCollapsed": true,
                        "children": [
                            {
                                "id": 0,
                                "name": "libs",
                                "state": {
                                    "t": "resheet.selector",
                                    "v": 0,
                                    "mode": "run",
                                    "expr": "SheetOf(Note)",
                                    "inner": {
                                        "t": "resheet.sheet",
                                        "v": 2,
                                        "lines": [
                                            {
                                                "id": 1,
                                                "name": "",
                                                "visibility": "block",
                                                "width": "narrow",
                                                "state": {
                                                    "t": "resheet.note",
                                                    "v": 1,
                                                    "level": 0,
                                                    "input": "/Code",
                                                    "note": {
                                                        "type": "block",
                                                        "isInstantiated": true,
                                                        "code": "Code",
                                                        "state": "function esmsh(lib) {\n  return import(`https://esm.sh/${lib}?external=react`)\n}\n\nasync function esmshDefault(lib) {\n  return (await esmsh(lib)).default\n}\n\nasync function esmshJson(file) {\n  return (await fetch(`https://esm.sh/${file}`)).json()\n}\n\nasync function awaitValues(obj) {\n  return (\n    lodash.zipObject(\n      Object.keys(obj),\n      await Promise.all(Object.values(obj)),\n    )\n  )\n}\n\nawaitValues({\n  papaparse: esmshDefault('papaparse'),\n  datefns: esmsh('date-fns'),\n  numeral: esmshDefault('numeral'),\n  globalize: esmshDefault('globalize'),\n  \n  // see what's available at: https://github.com/unicode-org/cldr-json/tree/main/cldr-json\n  // see what you need at: http://johnnyreilly.github.io/globalize-so-what-cha-want/\n  cldr: Promise.all([\n    esmshJson('cldr-core/supplemental/likelySubtags.json'),\n    esmshJson('cldr-numbers-modern/main/de/numbers.json'),\n    esmshJson('cldr-core/supplemental/numberingSystems.json'),\n    esmshJson('cldr-dates-modern/main/de/ca-gregorian.json'),\n    esmshJson('cldr-dates-modern/main/de/timeZoneNames.json'),\n    esmshJson('cldr-core/supplemental/timeData.json'),\n    esmshJson('cldr-core/supplemental/weekData.json'),\n  ]),\n  \n  recharts: esmsh('recharts'),\n  d3Scale: esmsh('d3-scale'),\n})"
                                                    }
                                                }
                                            }
                                        ]
                                    }
                                },
                                "isCollapsed": true,
                                "children": []
                            },
                            {
                                "id": 2,
                                "name": "utils",
                                "state": {
                                    "t": "resheet.selector",
                                    "v": 0,
                                    "mode": "run",
                                    "expr": "SheetOf(Note)",
                                    "inner": {
                                        "t": "resheet.sheet",
                                        "v": 2,
                                        "lines": [
                                            {
                                                "id": 0,
                                                "name": "",
                                                "visibility": "block",
                                                "width": "narrow",
                                                "state": {
                                                    "t": "resheet.note",
                                                    "v": 1,
                                                    "level": 0,
                                                    "input": "/Code",
                                                    "note": {
                                                        "type": "block",
                                                        "isInstantiated": true,
                                                        "code": "Code",
                                                        "state": "function scan(array, init, fn) {\n  const steps = []\n  array.reduce(\n    (acc, item) => {\n      const newAcc = fn(acc, item)\n      steps.push(newAcc)\n      return newAcc\n    },\n    init,\n  )\n  return steps\n}\n\nfunction addColumn(table, colName, colValues) {\n  return lodash.zipWith(\n    table,\n    colValues,\n    (row, col) => ({ ...row, [colName]: col }),\n  )\n}\n\nfunction timeScaleArgs(data, dataKey) {\n  const timeValues = data.map(row => row[dataKey].valueOf());\n  const scale = (\n    libs.d3Scale.scaleTime()\n      .domain([\n        Math.min(...timeValues),\n        Math.max(...timeValues),\n      ])\n  )\n  \n  return {\n    domain: scale.domain().map(date => date.valueOf()),\n    scale,\n    type: 'number',\n    ticks: scale.ticks(5).map(date => date.valueOf()),\n    data,\n    dataKey,\n  }\n}\n\nfunction combineDateTime(dateRef, timeRef) {\n  const date = libs.datefns.startOfDay(dateRef)\n  const timeInterval = libs.datefns.interval(\n    libs.datefns.startOfDay(timeRef),\n    timeRef,\n  )\n  return libs.datefns.add(date, libs.datefns.intervalToDuration(timeInterval))\n}\n\nfunction roundOn(num, step) {\n  if (step < 0) {\n    return Math.round(num * step) / step\n  }\n  else if (step < 1) {\n    const stepInv = 1 / step\n    const stepRound = Math.round(stepInv)\n    const stepClean = Math.abs(stepRound - stepInv) < 1e-10 ? stepRound : stepInv\n    return Math.round(num * stepClean) / stepClean\n  }\n  else {\n    return step * Math.round(num / step)\n  }\n}\n\nlibs.cldr.forEach(cldr => libs.globalize.load(cldr));\n\nreturn {\n  scan,\n  addColumn,\n  timeScaleArgs,\n  combineDateTime,\n  roundOn,\n  localized: {\n    de: libs.globalize('de'),\n  },\n}"
                                                    }
                                                }
                                            }
                                        ]
                                    }
                                },
                                "isCollapsed": true,
                                "children": []
                            }
                        ]
                    },
                    {
                        "id": 6,
                        "name": "Analyse JSON Size",
                        "state": {
                            "t": "resheet.selector",
                            "v": 0,
                            "mode": "run",
                            "expr": "SheetOf(Note)",
                            "inner": {
                                "t": "resheet.sheet",
                                "v": 2,
                                "lines": [
                                    {
                                        "id": 9,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "# Analyse JSON Size",
                                            "note": {
                                                "type": "text",
                                                "tag": "h1",
                                                "text": "Analyse JSON Size"
                                            }
                                        }
                                    },
                                    {
                                        "id": 10,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "Analyse which part of a JSON file is huge.",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": "Analyse which part of a JSON file is huge."
                                            }
                                        }
                                    },
                                    {
                                        "id": 42,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 43,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "Why not use https://www.debugbear.com/json-size-analyzer?",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": "Why not use https://www.debugbear.com/json-size-analyzer?"
                                            }
                                        }
                                    },
                                    {
                                        "id": 44,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "It doesn't seem fit to analyse large JSON structures with of tens of megabytes of data.",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": "It doesn't seem fit to analyse large JSON structures with of tens of megabytes of data."
                                            }
                                        }
                                    },
                                    {
                                        "id": 11,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 13,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "## Input",
                                            "note": {
                                                "type": "text",
                                                "tag": "h2",
                                                "text": "Input"
                                            }
                                        }
                                    },
                                    {
                                        "id": 51,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "Either use the supplied example:",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": "Either use the supplied example:"
                                            }
                                        }
                                    },
                                    {
                                        "id": 45,
                                        "name": "response",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "/Deferred(() => fetch('https://raw.githubusercontent.com/keenbug/ReSheet/main/examples/huge.json'))",
                                            "note": {
                                                "type": "block",
                                                "isInstantiated": true,
                                                "code": "Deferred(() => fetch('https://raw.githubusercontent.com/keenbug/ReSheet/main/examples/huge.json'))",
                                                "state": null
                                            }
                                        }
                                    },
                                    {
                                        "id": 57,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "(You have to manually load the data first by clicking the button above. The file is ~25 MiB.)",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": "(You have to manually load the data first by clicking the button above. The file is ~25 MiB.)"
                                            }
                                        }
                                    },
                                    {
                                        "id": 46,
                                        "name": "jsonWeb",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "= (await response).json()",
                                            "note": {
                                                "type": "expr",
                                                "code": " (await response).json()"
                                            }
                                        }
                                    },
                                    {
                                        "id": 47,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 61,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 52,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "Or load your own local file:",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": "Or load your own local file:"
                                            }
                                        }
                                    },
                                    {
                                        "id": 53,
                                        "name": "file",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "/LoadFile",
                                            "note": {
                                                "type": "block",
                                                "isInstantiated": true,
                                                "code": "LoadFile",
                                                "state": {
                                                    "state": "init"
                                                }
                                            }
                                        }
                                    },
                                    {
                                        "id": 54,
                                        "name": "jsonLocal",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "= JSON.parse(await file.text())",
                                            "note": {
                                                "type": "expr",
                                                "code": " JSON.parse(await file.text())"
                                            }
                                        }
                                    },
                                    {
                                        "id": 55,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 62,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 56,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "Change this if you want to use your local file instead:",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": "Change this if you want to use your local file instead:"
                                            }
                                        }
                                    },
                                    {
                                        "id": 48,
                                        "name": "json",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "= jsonWeb // or jsonLocal",
                                            "note": {
                                                "type": "expr",
                                                "code": " jsonWeb // or jsonLocal"
                                            }
                                        }
                                    },
                                    {
                                        "id": 12,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 59,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "(Don't worry about the TypeErrors. When you load a file the corresponding errors go away.)",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": "(Don't worry about the TypeErrors. When you load a file the corresponding errors go away.)"
                                            }
                                        }
                                    },
                                    {
                                        "id": 60,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 14,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "## Analysis",
                                            "note": {
                                                "type": "text",
                                                "tag": "h2",
                                                "text": "Analysis"
                                            }
                                        }
                                    },
                                    {
                                        "id": 2,
                                        "name": "analyse",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "/Code",
                                            "note": {
                                                "type": "block",
                                                "isInstantiated": true,
                                                "code": "Code",
                                                "state": "function analyse(obj) {\n  return lodash.mapValues(obj, value => JSON.stringify(value).length)\n}"
                                            }
                                        }
                                    },
                                    {
                                        "id": 15,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 17,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "Edit this to drill down on the cause:",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": "Edit this to drill down on the cause:"
                                            }
                                        }
                                    },
                                    {
                                        "id": 4,
                                        "name": "part",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "= json",
                                            "note": {
                                                "type": "expr",
                                                "code": " json"
                                            }
                                        }
                                    },
                                    {
                                        "id": 16,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 3,
                                        "name": "analysis",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "= analyse(part)",
                                            "note": {
                                                "type": "expr",
                                                "code": " analyse(part)"
                                            }
                                        }
                                    },
                                    {
                                        "id": 8,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 7,
                                        "name": "",
                                        "visibility": "result",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "/Code",
                                            "note": {
                                                "type": "block",
                                                "isInstantiated": true,
                                                "code": "Code",
                                                "state": 'const { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, Tooltip } =\n  libs.recharts;\n  \nconst data = Object.entries(analysis)\n  .map(([key, size]) => ({ key, size }));\n\n<ResponsiveContainer height={400}>\n  <BarChart data={data}>\n    <Tooltip formatter={libs.humanFormat.bytes} />\n    <Bar type="monotone" dataKey="size" fill="#8884d8" />\n    <XAxis dataKey="key"/>\n    <YAxis width={100} tickFormatter={libs.humanFormat.bytes} />\n  </BarChart>\n</ResponsiveContainer>'
                                            }
                                        }
                                    },
                                    {
                                        "id": 63,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "Side note: These numbers are not exactly bytes, but rather characters (which can be larger than one byte). But most of the time bytes and characters are close enough, if not identical.",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": "Side note: These numbers are not exactly bytes, but rather characters (which can be larger than one byte). But most of the time bytes and characters are close enough, if not identical."
                                            }
                                        }
                                    },
                                    {
                                        "id": 18,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 64,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 65,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 58,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 19,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 20,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "## Result",
                                            "note": {
                                                "type": "text",
                                                "tag": "h2",
                                                "text": "Result"
                                            }
                                        }
                                    },
                                    {
                                        "id": 21,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "The problem is `json.inner.pages[0].children[2].state.inner.lines[5].state.note.state.actions`.",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": "The problem is `json.inner.pages[0].children[2].state.inner.lines[5].state.note.state.actions`."
                                            }
                                        }
                                    },
                                    {
                                        "id": 22,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "This is part of the DemoRecorder. The DemoRecorder allows one to record a series of actions in a Block, which can then be replayed.",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": "This is part of the DemoRecorder. The DemoRecorder allows one to record a series of actions in a Block, which can then be replayed."
                                            }
                                        }
                                    },
                                    {
                                        "id": 23,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "For every action the resulting state is saved for two reasons:",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": "For every action the resulting state is saved for two reasons:"
                                            }
                                        }
                                    },
                                    {
                                        "id": 24,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "1) The saved state is used to verify nothing went wrong during playback.",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": "1) The saved state is used to verify nothing went wrong during playback."
                                            }
                                        }
                                    },
                                    {
                                        "id": 25,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "2) The saved state is used to quickly jump to a position in the recording during editing.",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": "2) The saved state is used to quickly jump to a position in the recording during editing."
                                            }
                                        }
                                    },
                                    {
                                        "id": 26,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 27,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "### Solution 1",
                                            "note": {
                                                "type": "text",
                                                "tag": "h3",
                                                "text": "Solution 1"
                                            }
                                        }
                                    },
                                    {
                                        "id": 28,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "Can we omit the resulting state when saving the actions?",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": "Can we omit the resulting state when saving the actions?"
                                            }
                                        }
                                    },
                                    {
                                        "id": 29,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "Regarding 2), yes we can. We are able to recreate the states when we start editing the recording.",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": "Regarding 2), yes we can. We are able to recreate the states when we start editing the recording."
                                            }
                                        }
                                    },
                                    {
                                        "id": 30,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "Regarding 1), not without compromising functionality.",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": "Regarding 1), not without compromising functionality."
                                            }
                                        }
                                    },
                                    {
                                        "id": 31,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "#### What is the problem in case 1)?",
                                            "note": {
                                                "type": "text",
                                                "tag": "h4",
                                                "text": "What is the problem in case 1)?"
                                            }
                                        }
                                    },
                                    {
                                        "id": 32,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "To recreate the states we need to replay the recording. In case 2) the (human) editor should be able to spot problems during replay and is able to intervene. In case 1) recreating the states by replaying the recording counters its intention: The intention is to spot errors during replay by comparing the resulting state with the saved state.",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": "To recreate the states we need to replay the recording. In case 2) the (human) editor should be able to spot problems during replay and is able to intervene. In case 1) recreating the states by replaying the recording counters its intention: The intention is to spot errors during replay by comparing the resulting state with the saved state."
                                            }
                                        }
                                    },
                                    {
                                        "id": 33,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 34,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "### Solution 2",
                                            "note": {
                                                "type": "text",
                                                "tag": "h3",
                                                "text": "Solution 2"
                                            }
                                        }
                                    },
                                    {
                                        "id": 35,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "Can we otherwise reduce the size of the saved states?",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": "Can we otherwise reduce the size of the saved states?"
                                            }
                                        }
                                    },
                                    {
                                        "id": 36,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "There are two other possible approaches:",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": "There are two other possible approaches:"
                                            }
                                        }
                                    },
                                    {
                                        "id": 37,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "1) Reduce the number of saved states.",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": "1) Reduce the number of saved states."
                                            }
                                        }
                                    },
                                    {
                                        "id": 38,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "2) Take advantage of shared common/identical parts between saved states.",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": "2) Take advantage of shared common/identical parts between saved states."
                                            }
                                        }
                                    },
                                    {
                                        "id": 39,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 40,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "Regarding 1) We don't check every state during replay anyways. So this can be implemented safely.",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": "Regarding 1) We don't check every state during replay anyways. So this can be implemented safely."
                                            }
                                        }
                                    },
                                    {
                                        "id": 41,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "Regarding 2) The question is, how do we want to implement that? Just `JSON.stringify` and compress (gzip/...) all actions? Or write a custom deduplicator?",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": "Regarding 2) The question is, how do we want to implement that? Just `JSON.stringify` and compress (gzip/...) all actions? Or write a custom deduplicator?"
                                            }
                                        }
                                    },
                                    {
                                        "id": 66,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 67,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 70,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 71,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 73,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "full",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "---",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": "---"
                                            }
                                        }
                                    },
                                    {
                                        "id": 69,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "## Preview",
                                            "note": {
                                                "type": "text",
                                                "tag": "h2",
                                                "text": "Preview"
                                            }
                                        }
                                    },
                                    {
                                        "id": 74,
                                        "name": "previewBlockTemplate",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "/Debug.Inspect(SheetOf(Note))",
                                            "note": {
                                                "type": "block",
                                                "isInstantiated": true,
                                                "code": "Debug.Inspect(SheetOf(Note))",
                                                "state": {
                                                    "t": "resheet.sheet",
                                                    "v": 2,
                                                    "lines": [
                                                        {
                                                            "id": 1,
                                                            "name": "",
                                                            "visibility": "block",
                                                            "width": "narrow",
                                                            "state": {
                                                                "t": "resheet.note",
                                                                "v": 1,
                                                                "level": 0,
                                                                "input": "### Analyse JSON Size Preview",
                                                                "note": {
                                                                    "type": "text",
                                                                    "tag": "h3",
                                                                    "text": "Analyse JSON Size Preview"
                                                                }
                                                            }
                                                        },
                                                        {
                                                            "id": 2,
                                                            "name": "",
                                                            "visibility": "block",
                                                            "width": "narrow",
                                                            "state": {
                                                                "t": "resheet.note",
                                                                "v": 1,
                                                                "level": 0,
                                                                "input": "We analyse some JSON data for its size.",
                                                                "note": {
                                                                    "type": "text",
                                                                    "tag": "p",
                                                                    "text": "We analyse some JSON data for its size."
                                                                }
                                                            }
                                                        },
                                                        {
                                                            "id": 3,
                                                            "name": "",
                                                            "visibility": "block",
                                                            "width": "narrow",
                                                            "state": {
                                                                "t": "resheet.note",
                                                                "v": 1,
                                                                "level": 0,
                                                                "input": "",
                                                                "note": {
                                                                    "type": "text",
                                                                    "tag": "p",
                                                                    "text": ""
                                                                }
                                                            }
                                                        },
                                                        {
                                                            "id": 4,
                                                            "name": "jsonFile",
                                                            "visibility": "block",
                                                            "width": "narrow",
                                                            "state": {
                                                                "t": "resheet.note",
                                                                "v": 1,
                                                                "level": 0,
                                                                "input": "/LoadFile",
                                                                "note": {
                                                                    "type": "block",
                                                                    "isInstantiated": true,
                                                                    "code": "LoadFile",
                                                                    "state": {
                                                                        "state": "loaded",
                                                                        "file": {
                                                                            "content": "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",
                                                                            "name": "Demo Target.json",
                                                                            "options": {
                                                                                "type": "application/json",
                                                                                "lastModified": 1716387270088
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        },
                                                        {
                                                            "id": 5,
                                                            "name": "json",
                                                            "visibility": "block",
                                                            "width": "narrow",
                                                            "state": {
                                                                "t": "resheet.note",
                                                                "v": 1,
                                                                "level": 0,
                                                                "input": "= JSON.parse(await jsonFile.text())",
                                                                "note": {
                                                                    "type": "expr",
                                                                    "code": " JSON.parse(await jsonFile.text())"
                                                                }
                                                            }
                                                        },
                                                        {
                                                            "id": 8,
                                                            "name": "",
                                                            "visibility": "block",
                                                            "width": "narrow",
                                                            "state": {
                                                                "t": "resheet.note",
                                                                "v": 1,
                                                                "level": 0,
                                                                "input": "",
                                                                "note": {
                                                                    "type": "text",
                                                                    "tag": "p",
                                                                    "text": ""
                                                                }
                                                            }
                                                        },
                                                        {
                                                            "id": 7,
                                                            "name": "part",
                                                            "visibility": "block",
                                                            "width": "narrow",
                                                            "state": {
                                                                "t": "resheet.note",
                                                                "v": 1,
                                                                "level": 0,
                                                                "input": "= json.inner.pages[1].children",
                                                                "note": {
                                                                    "type": "expr",
                                                                    "code": " json.inner.pages[1].children"
                                                                }
                                                            }
                                                        },
                                                        {
                                                            "id": 6,
                                                            "name": "",
                                                            "visibility": "result",
                                                            "width": "narrow",
                                                            "state": {
                                                                "t": "resheet.note",
                                                                "v": 1,
                                                                "level": 0,
                                                                "input": "/Code",
                                                                "note": {
                                                                    "type": "block",
                                                                    "isInstantiated": true,
                                                                    "code": "Code",
                                                                    "state": 'const { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, Tooltip } =\n  await import(\'https://esm.sh/recharts?external=react\');\n  \nconst { default: humanFormat } = await import(\'https://esm.sh/human-format\')\n  \nconst data = Object.entries(part)\n  .map(([key, value]) => ({ key, size: JSON.stringify(value).length }));\n\n<ResponsiveContainer height={400}>\n  <BarChart data={data}>\n    <Tooltip formatter={humanFormat.bytes} />\n    <Bar type="monotone" dataKey="size" fill="#8884d8" />\n    <XAxis dataKey="key"/>\n    <YAxis width={100} tickFormatter={humanFormat.bytes} />\n  </BarChart>\n</ResponsiveContainer>'
                                                                }
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        }
                                    }
                                ]
                            }
                        },
                        "isCollapsed": true,
                        "children": [
                            {
                                "id": 1,
                                "name": "libs",
                                "state": {
                                    "t": "resheet.selector",
                                    "v": 0,
                                    "mode": "run",
                                    "expr": "SheetOf(Note)",
                                    "inner": {
                                        "t": "resheet.sheet",
                                        "v": 2,
                                        "lines": [
                                            {
                                                "id": 1,
                                                "name": "humanFormat",
                                                "visibility": "block",
                                                "width": "narrow",
                                                "state": {
                                                    "t": "resheet.note",
                                                    "v": 1,
                                                    "level": 0,
                                                    "input": "= import('https://esm.sh/human-format')",
                                                    "note": {
                                                        "type": "expr",
                                                        "code": " import('https://esm.sh/human-format')"
                                                    }
                                                }
                                            },
                                            {
                                                "id": 2,
                                                "name": "recharts",
                                                "visibility": "block",
                                                "width": "narrow",
                                                "state": {
                                                    "t": "resheet.note",
                                                    "v": 1,
                                                    "level": 0,
                                                    "input": "= import('https://esm.sh/recharts?external=react')",
                                                    "note": {
                                                        "type": "expr",
                                                        "code": " import('https://esm.sh/recharts?external=react')"
                                                    }
                                                }
                                            },
                                            {
                                                "id": 3,
                                                "name": "",
                                                "visibility": "block",
                                                "width": "narrow",
                                                "state": {
                                                    "t": "resheet.note",
                                                    "v": 1,
                                                    "level": 0,
                                                    "input": "",
                                                    "note": {
                                                        "type": "text",
                                                        "tag": "p",
                                                        "text": ""
                                                    }
                                                }
                                            },
                                            {
                                                "id": 4,
                                                "name": "",
                                                "visibility": "block",
                                                "width": "narrow",
                                                "state": {
                                                    "t": "resheet.note",
                                                    "v": 1,
                                                    "level": 0,
                                                    "input": "---",
                                                    "note": {
                                                        "type": "text",
                                                        "tag": "p",
                                                        "text": "---"
                                                    }
                                                }
                                            },
                                            {
                                                "id": 5,
                                                "name": "exports",
                                                "visibility": "block",
                                                "width": "narrow",
                                                "state": {
                                                    "t": "resheet.note",
                                                    "v": 1,
                                                    "level": 0,
                                                    "input": "= { humanFormat: humanFormat.default, recharts }",
                                                    "note": {
                                                        "type": "expr",
                                                        "code": " { humanFormat: humanFormat.default, recharts }"
                                                    }
                                                }
                                            }
                                        ]
                                    }
                                },
                                "isCollapsed": false,
                                "children": []
                            },
                            {
                                "id": 0,
                                "name": "Deferred",
                                "state": {
                                    "t": "resheet.selector",
                                    "v": 0,
                                    "mode": "run",
                                    "expr": "SheetOf(Note)",
                                    "inner": {
                                        "t": "resheet.sheet",
                                        "v": 2,
                                        "lines": [
                                            {
                                                "id": 0,
                                                "name": "",
                                                "visibility": "block",
                                                "width": "narrow",
                                                "state": {
                                                    "t": "resheet.note",
                                                    "v": 1,
                                                    "level": 0,
                                                    "input": "/Code",
                                                    "note": {
                                                        "type": "block",
                                                        "isInstantiated": true,
                                                        "code": "Code",
                                                        "state": 'function Deferred(computation) {\n  return resheet.core.block.create({\n    init: undefined,\n    view({ state, dispatch }, ref) {\n      return (\n        <button\n          ref={ref}\n          className="rounded px-2 py-1 bg-gray-50 hover:bg-gray-100 border border-gray-100"\n          onClick={() => dispatch(() => ({ state: computation() }))}\n        >\n          Run {computation.toString()}\n        </button>\n      )\n    },\n    getResult(state) { return state },\n    recompute(state) { return { state, invalidated: false } },\n    fromJSON() { return undefined },\n    toJSON() { return null },\n  })\n}'
                                                    }
                                                }
                                            }
                                        ]
                                    }
                                },
                                "isCollapsed": false,
                                "children": []
                            }
                        ]
                    },
                    {
                        "id": 2,
                        "name": "Custom Blocks",
                        "state": {
                            "t": "resheet.selector",
                            "v": 0,
                            "mode": "run",
                            "expr": "SheetOf(Note)",
                            "inner": {
                                "t": "resheet.sheet",
                                "v": 2,
                                "lines": [
                                    {
                                        "id": 1,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "# Custom Blocks",
                                            "note": {
                                                "type": "text",
                                                "tag": "h1",
                                                "text": "Custom Blocks"
                                            }
                                        }
                                    },
                                    {
                                        "id": 2,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "Create custom Blocks and use the Inspect Block to get a glimpse into ReSheet.",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": "Create custom Blocks and use the Inspect Block to get a glimpse into ReSheet."
                                            }
                                        }
                                    },
                                    {
                                        "id": 3,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 23,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "## Simple custom Blocks",
                                            "note": {
                                                "type": "text",
                                                "tag": "h2",
                                                "text": "Simple custom Blocks"
                                            }
                                        }
                                    },
                                    {
                                        "id": 7,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "Let's build a simple checkbox Block:",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": "Let's build a simple checkbox Block:"
                                            }
                                        }
                                    },
                                    {
                                        "id": 8,
                                        "name": "CheckBlock",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "/Code",
                                            "note": {
                                                "type": "block",
                                                "isInstantiated": true,
                                                "code": "Code",
                                                "state": "label => SimpleBlock(false, ({ ref, state, onUpdate }) =>\n  <label>\n    <input\n      ref={ref}\n      type=\"checkbox\"\n      checked={state}\n      onChange={onUpdate('target.checked')}\n      />\n    {' '}\n    {label}\n  </label>\n)"
                                            }
                                        }
                                    },
                                    {
                                        "id": 9,
                                        "name": "input",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": '/CheckBlock("Does it work?")',
                                            "note": {
                                                "type": "block",
                                                "isInstantiated": true,
                                                "code": 'CheckBlock("Does it work?")',
                                                "state": true
                                            }
                                        }
                                    },
                                    {
                                        "id": 10,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "= input",
                                            "note": {
                                                "type": "expr",
                                                "code": " input"
                                            }
                                        }
                                    },
                                    {
                                        "id": 11,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 87,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 88,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 13,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "Having an editable label would be nice:",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": "Having an editable label would be nice:"
                                            }
                                        }
                                    },
                                    {
                                        "id": 14,
                                        "name": "CheckEditableBlock",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "/Code",
                                            "note": {
                                                "type": "block",
                                                "isInstantiated": true,
                                                "code": "Code",
                                                "state": "SimpleBlock(\n  { checked: false, label: '' },\n  ({ ref, state, onUpdate, setState }) => (\n    <label>\n      <input\n        type=\"checkbox\"\n        checked={state.checked}\n        onChange={onUpdate('target.checked', 'checked')}\n        />\n      {' '}\n      <input\n        ref={ref}\n        type=\"text\"\n        value={state.label}\n        placeholder=\"label\"\n        onKeyDown={ev => {\n          if (ev.key === 'Enter') {\n            setState(checked => !checked, 'checked')\n          }\n        }}\n        onChange={onUpdate('target.value', 'label')}\n        />\n    </label>\n  ),\n)"
                                            }
                                        }
                                    },
                                    {
                                        "id": 15,
                                        "name": "input2",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "/CheckEditableBlock",
                                            "note": {
                                                "type": "block",
                                                "isInstantiated": true,
                                                "code": "CheckEditableBlock",
                                                "state": {
                                                    "checked": true,
                                                    "label": "This works too"
                                                }
                                            }
                                        }
                                    },
                                    {
                                        "id": 16,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "= input2",
                                            "note": {
                                                "type": "expr",
                                                "code": " input2"
                                            }
                                        }
                                    },
                                    {
                                        "id": 17,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 85,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 86,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 18,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "Build a slider Block:",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": "Build a slider Block:"
                                            }
                                        }
                                    },
                                    {
                                        "id": 20,
                                        "name": "SliderBlock",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "/Code",
                                            "note": {
                                                "type": "block",
                                                "isInstantiated": true,
                                                "code": "Code",
                                                "state": 'function SliderBlock(props) {\n  const rangeProps = immutable.merge({ min: 0, max: 100, step: 1 }, props)\n  return SimpleBlock(rangeProps.min ?? 0, ({ ref, state, onUpdate }) =>\n    <input\n      ref={ref}\n      type="range"\n      className="w-full"\n      value={state}\n      {...rangeProps}\n      onChange={onUpdate(\'target.value\', [], Number)}\n    />\n  )\n}'
                                            }
                                        }
                                    },
                                    {
                                        "id": 21,
                                        "name": "rangeInput",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "/SliderBlock()",
                                            "note": {
                                                "type": "block",
                                                "isInstantiated": true,
                                                "code": "SliderBlock()",
                                                "state": 37
                                            }
                                        }
                                    },
                                    {
                                        "id": 22,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "= rangeInput",
                                            "note": {
                                                "type": "expr",
                                                "code": " rangeInput"
                                            }
                                        }
                                    },
                                    {
                                        "id": 24,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 113,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 114,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 115,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "Build a select Block:",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": "Build a select Block:"
                                            }
                                        }
                                    },
                                    {
                                        "id": 116,
                                        "name": "SelectBlock",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "/Code",
                                            "note": {
                                                "type": "block",
                                                "isInstantiated": true,
                                                "code": "Code",
                                                "state": "function SelectBlock(values) {\n  return SimpleBlock(values[0],\n    ({ ref, state, onUpdate }) => (\n      <select\n        ref={ref}\n        className=\"w-full\"\n        value={state}\n        onChange={onUpdate('target.value')}\n      >\n        {values.map(value => (\n          <option key={value} value={value}>\n            {value}\n          </option>\n        ))}\n      </select>\n    )\n  )\n}"
                                            }
                                        }
                                    },
                                    {
                                        "id": 118,
                                        "name": "options",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "= ['January', 'February', 'March', 'April', 'May', 'June']",
                                            "note": {
                                                "type": "expr",
                                                "code": " ['January', 'February', 'March', 'April', 'May', 'June']"
                                            }
                                        }
                                    },
                                    {
                                        "id": 117,
                                        "name": "selected",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "/SelectBlock(options)",
                                            "note": {
                                                "type": "block",
                                                "isInstantiated": true,
                                                "code": "SelectBlock(options)",
                                                "state": "March"
                                            }
                                        }
                                    },
                                    {
                                        "id": 119,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "= selected",
                                            "note": {
                                                "type": "expr",
                                                "code": " selected"
                                            }
                                        }
                                    },
                                    {
                                        "id": 25,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 121,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 120,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 137,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "## Simple Custom Block Wrapper",
                                            "note": {
                                                "type": "text",
                                                "tag": "h2",
                                                "text": "Simple Custom Block Wrapper"
                                            }
                                        }
                                    },
                                    {
                                        "id": 122,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "Use an external library and build a Block around it:",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": "Use an external library and build a Block around it:"
                                            }
                                        }
                                    },
                                    {
                                        "id": 127,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 124,
                                        "name": "Datepicker",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "= import('https://esm.sh/react-datepicker?external=react')",
                                            "note": {
                                                "type": "expr",
                                                "code": " import('https://esm.sh/react-datepicker?external=react')"
                                            }
                                        }
                                    },
                                    {
                                        "id": 125,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "/Code",
                                            "note": {
                                                "type": "block",
                                                "isInstantiated": true,
                                                "code": "Code",
                                                "state": "includeCss('https://esm.sh/react-datepicker/dist/react-datepicker.css')"
                                            }
                                        }
                                    },
                                    {
                                        "id": 128,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 138,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "It looks like this:",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": "It looks like this:"
                                            }
                                        }
                                    },
                                    {
                                        "id": 126,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "= <Datepicker.default inline />",
                                            "note": {
                                                "type": "expr",
                                                "code": " <Datepicker.default inline />"
                                            }
                                        }
                                    },
                                    {
                                        "id": 135,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 136,
                                        "name": "datefns",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "= import('https://esm.sh/date-fns')",
                                            "note": {
                                                "type": "expr",
                                                "code": " import('https://esm.sh/date-fns')"
                                            }
                                        }
                                    },
                                    {
                                        "id": 129,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 139,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "Let's wrap it in a Block, so its state is persisted and the selected date can be used:",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": "Let's wrap it in a Block, so its state is persisted and the selected date can be used:"
                                            }
                                        }
                                    },
                                    {
                                        "id": 123,
                                        "name": "DateBlock",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "/Code",
                                            "note": {
                                                "type": "block",
                                                "isInstantiated": true,
                                                "code": "Code",
                                                "state": 'function DateBlock() {\n  return SimpleBlock(new Date(),\n    ({ state, setState }) => {\n      return (\n        <div className="flex flex-col items-center">\n          <Datepicker.default\n            inline\n            selected={state}\n            onSelect={date => setState(date)}\n            />\n        </div>\n      )\n    },\n    {\n      toJSON(date) { return datefns.formatISO(date) },\n      fromJSON(json) {\n        const date = datefns.parseISO(json)\n        return datefns.isValid(date) ? date : new Date()\n      },\n    },\n  )\n}'
                                            }
                                        }
                                    },
                                    {
                                        "id": 133,
                                        "name": "date",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "/DateBlock()",
                                            "note": {
                                                "type": "block",
                                                "isInstantiated": true,
                                                "code": "DateBlock()",
                                                "state": "2024-05-23T20:32:56+02:00"
                                            }
                                        }
                                    },
                                    {
                                        "id": 134,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "= date",
                                            "note": {
                                                "type": "expr",
                                                "code": " date"
                                            }
                                        }
                                    },
                                    {
                                        "id": 131,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 132,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 26,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "## Builtin Blocks",
                                            "note": {
                                                "type": "text",
                                                "tag": "h2",
                                                "text": "Builtin Blocks"
                                            }
                                        }
                                    },
                                    {
                                        "id": 33,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "We already used `Code` many times:",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": "We already used `Code` many times:"
                                            }
                                        }
                                    },
                                    {
                                        "id": 50,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "`/Code`",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": "`/Code`"
                                            }
                                        }
                                    },
                                    {
                                        "id": 34,
                                        "name": "codeResult",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "/Code",
                                            "note": {
                                                "type": "block",
                                                "isInstantiated": true,
                                                "code": "Code",
                                                "state": "12 * 12"
                                            }
                                        }
                                    },
                                    {
                                        "id": 35,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 82,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 36,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "But we can also take a peek inside with the `Inspect` Block:",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": "But we can also take a peek inside with the `Inspect` Block:"
                                            }
                                        }
                                    },
                                    {
                                        "id": 49,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "`/Debug.Inspect(Code)`",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": "`/Debug.Inspect(Code)`"
                                            }
                                        }
                                    },
                                    {
                                        "id": 37,
                                        "name": "inspectCodeResult",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "/Debug.Inspect(Code)",
                                            "note": {
                                                "type": "block",
                                                "isInstantiated": true,
                                                "code": "Debug.Inspect(Code)",
                                                "state": "Promise.resolve(codeResult)"
                                            }
                                        }
                                    },
                                    {
                                        "id": 38,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "= inspectCodeResult",
                                            "note": {
                                                "type": "expr",
                                                "code": " inspectCodeResult"
                                            }
                                        }
                                    },
                                    {
                                        "id": 39,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 83,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 27,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "The `Note` Block, of which every line here consists:",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": "The `Note` Block, of which every line here consists:"
                                            }
                                        }
                                    },
                                    {
                                        "id": 48,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "`/Debug.Inspect(Note)`",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": "`/Debug.Inspect(Note)`"
                                            }
                                        }
                                    },
                                    {
                                        "id": 28,
                                        "name": "inspectNoteBlockResult",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "/Debug.Inspect(Note)",
                                            "note": {
                                                "type": "block",
                                                "isInstantiated": true,
                                                "code": "Debug.Inspect(Note)",
                                                "state": {
                                                    "t": "resheet.note",
                                                    "v": 1,
                                                    "level": 0,
                                                    "input": "= inspectCodeResult.state",
                                                    "note": {
                                                        "type": "expr",
                                                        "code": " inspectCodeResult.state"
                                                    }
                                                }
                                            }
                                        }
                                    },
                                    {
                                        "id": 29,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "= inspectNoteBlockResult",
                                            "note": {
                                                "type": "expr",
                                                "code": " inspectNoteBlockResult"
                                            }
                                        }
                                    },
                                    {
                                        "id": 40,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 84,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 41,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "### Higher-Order Blocks",
                                            "note": {
                                                "type": "text",
                                                "tag": "h3",
                                                "text": "Higher-Order Blocks"
                                            }
                                        }
                                    },
                                    {
                                        "id": 42,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "Higher-Order Blocks embed other Blocks inside of them:",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": "Higher-Order Blocks embed other Blocks inside of them:"
                                            }
                                        }
                                    },
                                    {
                                        "id": 46,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "(The `Inspect` Block was already a very simple example of a higher-order Block)",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": "(The `Inspect` Block was already a very simple example of a higher-order Block)"
                                            }
                                        }
                                    },
                                    {
                                        "id": 43,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 44,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "You already know `SheetOf`, it's the Block powering every Page, with an embedded Note:",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": "You already know `SheetOf`, it's the Block powering every Page, with an embedded Note:"
                                            }
                                        }
                                    },
                                    {
                                        "id": 47,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "`/Debug.Inspect(SheetOf(Note))`",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": "`/Debug.Inspect(SheetOf(Note))`"
                                            }
                                        }
                                    },
                                    {
                                        "id": 45,
                                        "name": "inspectSheetOfNoteBlockResult",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "/Debug.Inspect(SheetOf(Note))",
                                            "note": {
                                                "type": "block",
                                                "isInstantiated": true,
                                                "code": "Debug.Inspect(SheetOf(Note))",
                                                "state": {
                                                    "t": "resheet.sheet",
                                                    "v": 2,
                                                    "lines": [
                                                        {
                                                            "id": 0,
                                                            "name": "",
                                                            "visibility": "block",
                                                            "width": "narrow",
                                                            "state": {
                                                                "t": "resheet.note",
                                                                "v": 1,
                                                                "level": 0,
                                                                "input": "This is a line of the SheetOf Block, which contains a Note Block in which this sentence is written.",
                                                                "note": {
                                                                    "type": "text",
                                                                    "tag": "p",
                                                                    "text": "This is a line of the SheetOf Block, which contains a Note Block in which this sentence is written."
                                                                }
                                                            }
                                                        },
                                                        {
                                                            "id": 1,
                                                            "name": "",
                                                            "visibility": "block",
                                                            "width": "narrow",
                                                            "state": {
                                                                "t": "resheet.note",
                                                                "v": 1,
                                                                "level": 0,
                                                                "input": "This is another line.",
                                                                "note": {
                                                                    "type": "text",
                                                                    "tag": "p",
                                                                    "text": "This is another line."
                                                                }
                                                            }
                                                        },
                                                        {
                                                            "id": 2,
                                                            "name": "",
                                                            "visibility": "block",
                                                            "width": "narrow",
                                                            "state": {
                                                                "t": "resheet.note",
                                                                "v": 1,
                                                                "level": 0,
                                                                "input": "= inspectNoteBlockResult.state.note",
                                                                "note": {
                                                                    "type": "expr",
                                                                    "code": " inspectNoteBlockResult.state.note"
                                                                }
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        }
                                    },
                                    {
                                        "id": 51,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "= inspectSheetOfNoteBlockResult.state.lines",
                                            "note": {
                                                "type": "expr",
                                                "code": " inspectSheetOfNoteBlockResult.state.lines"
                                            }
                                        }
                                    },
                                    {
                                        "id": 52,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 80,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 81,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 53,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "To be more precise, these pages don't contain the `SheetOf` Block itself but a `BlockSelector` Block pre-set with `SheetOf(Note)`:",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": "To be more precise, these pages don't contain the `SheetOf` Block itself but a `BlockSelector` Block pre-set with `SheetOf(Note)`:"
                                            }
                                        }
                                    },
                                    {
                                        "id": 54,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "`/BlockSelector('SheetOf(Note)', SheetOf(Note))` ",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": "`/BlockSelector('SheetOf(Note)', SheetOf(Note))` "
                                            }
                                        }
                                    },
                                    {
                                        "id": 55,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "/BlockSelector('SheetOf(Note)', SheetOf(Note))",
                                            "note": {
                                                "type": "block",
                                                "isInstantiated": true,
                                                "code": "BlockSelector('SheetOf(Note)', SheetOf(Note))",
                                                "state": {
                                                    "t": "resheet.selector",
                                                    "v": 0,
                                                    "mode": "run",
                                                    "expr": "SheetOf(Note)",
                                                    "inner": {
                                                        "t": "resheet.sheet",
                                                        "v": 2,
                                                        "lines": [
                                                            {
                                                                "id": 0,
                                                                "name": "",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "The `BlockSelector` Block allows you to change the Block inside of it.",
                                                                    "note": {
                                                                        "type": "text",
                                                                        "tag": "p",
                                                                        "text": "The `BlockSelector` Block allows you to change the Block inside of it."
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 1,
                                                                "name": "",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "You can use any other Block, change it at the top left.",
                                                                    "note": {
                                                                        "type": "text",
                                                                        "tag": "p",
                                                                        "text": "You can use any other Block, change it at the top left."
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 12,
                                                                "name": "",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "",
                                                                    "note": {
                                                                        "type": "text",
                                                                        "tag": "p",
                                                                        "text": ""
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 2,
                                                                "name": "",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "Be aware:",
                                                                    "note": {
                                                                        "type": "text",
                                                                        "tag": "p",
                                                                        "text": "Be aware:"
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 9,
                                                                "name": "",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 1,
                                                                    "input": "Changing the Block will delete this content here.",
                                                                    "note": {
                                                                        "type": "text",
                                                                        "tag": "p",
                                                                        "text": "Changing the Block will delete this content here."
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 10,
                                                                "name": "",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 1,
                                                                    "input": "_**`C-Z`** or **`esc`** are your friends._",
                                                                    "note": {
                                                                        "type": "text",
                                                                        "tag": "p",
                                                                        "text": "_**`C-Z`** or **`esc`** are your friends._"
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 11,
                                                                "name": "",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "",
                                                                    "note": {
                                                                        "type": "text",
                                                                        "tag": "p",
                                                                        "text": ""
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 3,
                                                                "name": "",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "Try:",
                                                                    "note": {
                                                                        "type": "text",
                                                                        "tag": "p",
                                                                        "text": "Try:"
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 4,
                                                                "name": "",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 1,
                                                                    "input": "`Code`",
                                                                    "note": {
                                                                        "type": "text",
                                                                        "tag": "p",
                                                                        "text": "`Code`"
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 5,
                                                                "name": "",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 1,
                                                                    "input": "`SheetOf(Code)`",
                                                                    "note": {
                                                                        "type": "text",
                                                                        "tag": "p",
                                                                        "text": "`SheetOf(Code)`"
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 6,
                                                                "name": "",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 1,
                                                                    "input": "`SheetOf(CheckEditableBlock)`",
                                                                    "note": {
                                                                        "type": "text",
                                                                        "tag": "p",
                                                                        "text": "`SheetOf(CheckEditableBlock)`"
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 7,
                                                                "name": "",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "",
                                                                    "note": {
                                                                        "type": "text",
                                                                        "tag": "p",
                                                                        "text": ""
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 8,
                                                                "name": "",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": 'In the subpage "SimpleBlock" of this page ("Advanced Playground") you can see an example, where the Page was changed to another Block.',
                                                                    "note": {
                                                                        "type": "text",
                                                                        "tag": "p",
                                                                        "text": 'In the subpage "SimpleBlock" of this page ("Advanced Playground") you can see an example, where the Page was changed to another Block.'
                                                                    }
                                                                }
                                                            }
                                                        ]
                                                    }
                                                }
                                            }
                                        }
                                    },
                                    {
                                        "id": 56,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 78,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 79,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 101,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "## Custom Higher-Order Block",
                                            "note": {
                                                "type": "text",
                                                "tag": "h2",
                                                "text": "Custom Higher-Order Block"
                                            }
                                        }
                                    },
                                    {
                                        "id": 102,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "Building a higher-order Block is more involved, as you have to integrate with the embedded (inner) Blocks' calculations.",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": "Building a higher-order Block is more involved, as you have to integrate with the embedded (inner) Blocks' calculations."
                                            }
                                        }
                                    },
                                    {
                                        "id": 103,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "Let's build an HStack Block where you can put multiple Blocks in a row. As a simplification, these Blocks won't be able to access each other's values.",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": "Let's build an HStack Block where you can put multiple Blocks in a row. As a simplification, these Blocks won't be able to access each other's values."
                                            }
                                        }
                                    },
                                    {
                                        "id": 104,
                                        "name": "HStack",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "/Code",
                                            "note": {
                                                "type": "block",
                                                "isInstantiated": true,
                                                "code": "Code",
                                                "state": 'function HStack(...subblocks) {\n  // wrap the subblocks with some safeguards\n  const safeblocks = subblocks.map(resheet.blocks.component.safeBlock)\n  \n  return SimpleBlock(\n    safeblocks.map(block => block.init),\n    \n    ({ state, fieldDispatcher, env }) => (\n      <div className="flex flex-row space-x-2">\n        {safeblocks.map((block, index) => (\n          <div className="overflow-x-auto flex-[1_0_0%]">\n            <block.Component\n              key={index}\n              state={state[index]}\n              dispatch={fieldDispatcher(index)}\n              env={env}\n              />\n          </div>\n        ))}\n      </div>\n    ),\n    \n    {\n      // What is the value of this Block?\n      // @returns an Array of the subblocks\' values\n      getResult(state) {\n        return safeblocks.map((block, index) =>\n          block.getResult(state[index])\n        )\n      },\n      \n      // Load a state from json\n      // dispatch and env are needed, because to load some json one\n      // probably has to evaluate the code already. For example when\n      // we will use this Block and load its saved state from a file,\n      // first this definition of the Block has to be evaluated and\n      // then we can use the following fromJSON function to continue\n      // loading the state.\n      // @returns the loaded state\n      fromJSON(json, dispatch, env) {\n        return safeblocks.map((block, index) =>\n          block.fromJSON(\n            json[index],\n            resheet.util.dispatch.fieldDispatcher(index, dispatch),\n            env,\n          )\n        )\n      },\n      \n      // Converts a state to a JSON-serializable value.\n      // @returns a value that can be stringified (NOT an already\n      //          stringified JSON string!)\n      toJSON(state) {\n        return safeblocks.map((block, index) =>\n          block.toJSON(state[index])\n        )\n      },\n      \n      // Reevaluate the computations inside because some variables\n      // given in the Set<string> changedVars changed.\n      // @returns {\n      //            state: /* the new state */,\n      //            invalidated: /* true, if our value changed and\n      //                          * therefore our dependants have\n      //                          * to be recomputed\n      //                          */,\n      //          }\n      recompute(state, dispatch, env, changedVars) {\n        const recomputations = (\n          safeblocks.map((block, index) =>\n            block.recompute(\n              state[index],\n              resheet.util.dispatch.fieldDispatcher(index, dispatch),\n              env,\n              changedVars,\n            )\n          )\n        )\n        \n        const newStates = recomputations.map(recomp => recomp.state)\n        const invalidated = recomputations.some(recomp => recomp.invalidated)\n        return {\n          state: newStates,\n          invalidated,\n        }\n      },\n    },\n  )\n}'
                                            }
                                        }
                                    },
                                    {
                                        "id": 107,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "wide",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "`/Debug.Inspect(HStack(SheetOf(Note), Code))`",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": "`/Debug.Inspect(HStack(SheetOf(Note), Code))`"
                                            }
                                        }
                                    },
                                    {
                                        "id": 105,
                                        "name": "inspectHStack",
                                        "visibility": "block",
                                        "width": "wide",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "/Debug.Inspect(HStack(SheetOf(Note), Code))",
                                            "note": {
                                                "type": "block",
                                                "isInstantiated": true,
                                                "code": "Debug.Inspect(HStack(SheetOf(Note), Code))",
                                                "state": [
                                                    {
                                                        "t": "resheet.sheet",
                                                        "v": 2,
                                                        "lines": [
                                                            {
                                                                "id": 0,
                                                                "name": "",
                                                                "visibility": "block",
                                                                "width": "wide",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "Now we can put some stuff side-by-side",
                                                                    "note": {
                                                                        "type": "text",
                                                                        "tag": "p",
                                                                        "text": "Now we can put some stuff side-by-side"
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 1,
                                                                "name": "",
                                                                "visibility": "block",
                                                                "width": "wide",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "As we haven't implemented any keybindings we have to click to navigate between the columns",
                                                                    "note": {
                                                                        "type": "text",
                                                                        "tag": "p",
                                                                        "text": "As we haven't implemented any keybindings we have to click to navigate between the columns"
                                                                    }
                                                                }
                                                            }
                                                        ]
                                                    },
                                                    "const block = HStack(SheetOf(Note), Code)\nblock.toJSON(block.init)"
                                                ]
                                            }
                                        }
                                    },
                                    {
                                        "id": 106,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "= inspectHStack.state",
                                            "note": {
                                                "type": "expr",
                                                "code": " inspectHStack.state"
                                            }
                                        }
                                    },
                                    {
                                        "id": 108,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 109,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 110,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 57,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "### Grand Finale",
                                            "note": {
                                                "type": "text",
                                                "tag": "h3",
                                                "text": "Grand Finale"
                                            }
                                        }
                                    },
                                    {
                                        "id": 58,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "As the Grand Finale, we're going to embed a whole ReSheet instance:",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": "As the Grand Finale, we're going to embed a whole ReSheet instance:"
                                            }
                                        }
                                    },
                                    {
                                        "id": 59,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "`/Debug.Inspect(DocumentOf(Code))`",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": "`/Debug.Inspect(DocumentOf(Code))`"
                                            }
                                        }
                                    },
                                    {
                                        "id": 95,
                                        "name": "inspectReSheetSimple",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "/Debug.Inspect(DocumentOf(Code))",
                                            "note": {
                                                "type": "block",
                                                "isInstantiated": true,
                                                "code": "Debug.Inspect(DocumentOf(Code))",
                                                "state": {
                                                    "history": [],
                                                    "inner": {
                                                        "t": "resheet.document",
                                                        "v": 1,
                                                        "pages": [
                                                            {
                                                                "id": 0,
                                                                "name": "",
                                                                "state": "// This is a simplified version. But we already know how to embed the full version:\n\nblocks.DocumentOf(\n  blocks.BlockSelector(\n    'SheetOf(Note)',\n    blocks.SheetOf(blocks.Note),\n    blocks,\n  )\n)\n\n// Now is only left to inspect the state of this whole document below.",
                                                                "isCollapsed": true,
                                                                "children": []
                                                            }
                                                        ],
                                                        "viewState": {
                                                            "sidebarOpen": true,
                                                            "openPage": [
                                                                0
                                                            ]
                                                        },
                                                        "template": {
                                                            "id": -1,
                                                            "name": "",
                                                            "state": "",
                                                            "isCollapsed": true,
                                                            "children": []
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    },
                                    {
                                        "id": 61,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "= inspectReSheetSimple.state",
                                            "note": {
                                                "type": "expr",
                                                "code": " inspectReSheetSimple.state"
                                            }
                                        }
                                    },
                                    {
                                        "id": 62,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 63,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 89,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 90,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "#### Full ReSheet Version",
                                            "note": {
                                                "type": "text",
                                                "tag": "h4",
                                                "text": "Full ReSheet Version"
                                            }
                                        }
                                    },
                                    {
                                        "id": 64,
                                        "name": "DefaultPageBlock",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "= BlockSelector('SheetOf(Note)', SheetOf(Note))",
                                            "note": {
                                                "type": "expr",
                                                "code": " BlockSelector('SheetOf(Note)', SheetOf(Note))"
                                            }
                                        }
                                    },
                                    {
                                        "id": 65,
                                        "name": "ReSheet",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "= DocumentOf(DefaultPageBlock)",
                                            "note": {
                                                "type": "expr",
                                                "code": " DocumentOf(DefaultPageBlock)"
                                            }
                                        }
                                    },
                                    {
                                        "id": 66,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 67,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "Here is the full ReSheet version. Try to save the big ReSheet document and load it inside this small instance:",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": "Here is the full ReSheet version. Try to save the big ReSheet document and load it inside this small instance:"
                                            }
                                        }
                                    },
                                    {
                                        "id": 91,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "wide",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "`/Debug.Inspect(ReSheet)`",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": "`/Debug.Inspect(ReSheet)`"
                                            }
                                        }
                                    },
                                    {
                                        "id": 96,
                                        "name": "inspectReSheet",
                                        "visibility": "block",
                                        "width": "wide",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "/Debug.Inspect(ReSheet)",
                                            "note": {
                                                "type": "block",
                                                "isInstantiated": true,
                                                "code": "Debug.Inspect(ReSheet)",
                                                "state": {
                                                    "history": [],
                                                    "inner": {
                                                        "t": "resheet.document",
                                                        "v": 1,
                                                        "pages": [],
                                                        "viewState": {
                                                            "sidebarOpen": true,
                                                            "openPage": []
                                                        },
                                                        "template": {
                                                            "id": -1,
                                                            "name": "",
                                                            "state": {
                                                                "t": "resheet.selector",
                                                                "v": 0,
                                                                "mode": "run",
                                                                "expr": "SheetOf(Note)",
                                                                "inner": {
                                                                    "t": "resheet.sheet",
                                                                    "v": 2,
                                                                    "lines": []
                                                                }
                                                            },
                                                            "isCollapsed": true,
                                                            "children": []
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    },
                                    {
                                        "id": 69,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "wide",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "= inspectReSheet.state",
                                            "note": {
                                                "type": "expr",
                                                "code": " inspectReSheet.state"
                                            }
                                        }
                                    },
                                    {
                                        "id": 70,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 71,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 72,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "That's it. ReSheet is built to be composable and extensible. Its parts can be plugged together and extended as you like.",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": "That's it. ReSheet is built to be composable and extensible. Its parts can be plugged together and extended as you like."
                                            }
                                        }
                                    },
                                    {
                                        "id": 73,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 74,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 75,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 112,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 111,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "full",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "---",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": "---"
                                            }
                                        }
                                    },
                                    {
                                        "id": 76,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "## Preview",
                                            "note": {
                                                "type": "text",
                                                "tag": "h2",
                                                "text": "Preview"
                                            }
                                        }
                                    },
                                    {
                                        "id": 97,
                                        "name": "previewBlockTemplate",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "/Debug.Inspect(SheetOf(Note))",
                                            "note": {
                                                "type": "block",
                                                "isInstantiated": true,
                                                "code": "Debug.Inspect(SheetOf(Note))",
                                                "state": {
                                                    "t": "resheet.sheet",
                                                    "v": 2,
                                                    "lines": [
                                                        {
                                                            "id": 1,
                                                            "name": "",
                                                            "visibility": "block",
                                                            "width": "narrow",
                                                            "state": {
                                                                "t": "resheet.note",
                                                                "v": 1,
                                                                "level": 0,
                                                                "input": "### Custom Blocks Preview",
                                                                "note": {
                                                                    "type": "text",
                                                                    "tag": "h3",
                                                                    "text": "Custom Blocks Preview"
                                                                }
                                                            }
                                                        },
                                                        {
                                                            "id": 2,
                                                            "name": "",
                                                            "visibility": "block",
                                                            "width": "narrow",
                                                            "state": {
                                                                "t": "resheet.note",
                                                                "v": 1,
                                                                "level": 0,
                                                                "input": "We build these custom Blocks in this Page:",
                                                                "note": {
                                                                    "type": "text",
                                                                    "tag": "p",
                                                                    "text": "We build these custom Blocks in this Page:"
                                                                }
                                                            }
                                                        },
                                                        {
                                                            "id": 3,
                                                            "name": "",
                                                            "visibility": "block",
                                                            "width": "narrow",
                                                            "state": {
                                                                "t": "resheet.note",
                                                                "v": 1,
                                                                "level": 0,
                                                                "input": "",
                                                                "note": {
                                                                    "type": "text",
                                                                    "tag": "p",
                                                                    "text": ""
                                                                }
                                                            }
                                                        },
                                                        {
                                                            "id": 25,
                                                            "name": "",
                                                            "visibility": "block",
                                                            "width": "narrow",
                                                            "state": {
                                                                "t": "resheet.note",
                                                                "v": 1,
                                                                "level": 0,
                                                                "input": "#### `/DateBlock()`",
                                                                "note": {
                                                                    "type": "text",
                                                                    "tag": "h4",
                                                                    "text": "`/DateBlock()`"
                                                                }
                                                            }
                                                        },
                                                        {
                                                            "id": 26,
                                                            "name": "dateBlockValue",
                                                            "visibility": "block",
                                                            "width": "narrow",
                                                            "state": {
                                                                "t": "resheet.note",
                                                                "v": 1,
                                                                "level": 0,
                                                                "input": "/DateBlock()",
                                                                "note": {
                                                                    "type": "block",
                                                                    "isInstantiated": true,
                                                                    "code": "DateBlock()",
                                                                    "state": "2024-05-23T20:32:56+02:00"
                                                                }
                                                            }
                                                        },
                                                        {
                                                            "id": 27,
                                                            "name": "",
                                                            "visibility": "block",
                                                            "width": "narrow",
                                                            "state": {
                                                                "t": "resheet.note",
                                                                "v": 1,
                                                                "level": 0,
                                                                "input": "= dateBlockValue",
                                                                "note": {
                                                                    "type": "expr",
                                                                    "code": " dateBlockValue"
                                                                }
                                                            }
                                                        },
                                                        {
                                                            "id": 7,
                                                            "name": "",
                                                            "visibility": "block",
                                                            "width": "narrow",
                                                            "state": {
                                                                "t": "resheet.note",
                                                                "v": 1,
                                                                "level": 0,
                                                                "input": "",
                                                                "note": {
                                                                    "type": "text",
                                                                    "tag": "p",
                                                                    "text": ""
                                                                }
                                                            }
                                                        },
                                                        {
                                                            "id": 8,
                                                            "name": "",
                                                            "visibility": "block",
                                                            "width": "narrow",
                                                            "state": {
                                                                "t": "resheet.note",
                                                                "v": 1,
                                                                "level": 0,
                                                                "input": "#### `/SliderBlock()`",
                                                                "note": {
                                                                    "type": "text",
                                                                    "tag": "h4",
                                                                    "text": "`/SliderBlock()`"
                                                                }
                                                            }
                                                        },
                                                        {
                                                            "id": 9,
                                                            "name": "sliderBlockValue",
                                                            "visibility": "block",
                                                            "width": "narrow",
                                                            "state": {
                                                                "t": "resheet.note",
                                                                "v": 1,
                                                                "level": 0,
                                                                "input": "/SliderBlock()",
                                                                "note": {
                                                                    "type": "block",
                                                                    "isInstantiated": true,
                                                                    "code": "SliderBlock()",
                                                                    "state": 49
                                                                }
                                                            }
                                                        },
                                                        {
                                                            "id": 10,
                                                            "name": "",
                                                            "visibility": "block",
                                                            "width": "narrow",
                                                            "state": {
                                                                "t": "resheet.note",
                                                                "v": 1,
                                                                "level": 0,
                                                                "input": "= sliderBlockValue",
                                                                "note": {
                                                                    "type": "expr",
                                                                    "code": " sliderBlockValue"
                                                                }
                                                            }
                                                        },
                                                        {
                                                            "id": 11,
                                                            "name": "",
                                                            "visibility": "block",
                                                            "width": "narrow",
                                                            "state": {
                                                                "t": "resheet.note",
                                                                "v": 1,
                                                                "level": 0,
                                                                "input": "",
                                                                "note": {
                                                                    "type": "text",
                                                                    "tag": "p",
                                                                    "text": ""
                                                                }
                                                            }
                                                        },
                                                        {
                                                            "id": 20,
                                                            "name": "",
                                                            "visibility": "block",
                                                            "width": "narrow",
                                                            "state": {
                                                                "t": "resheet.note",
                                                                "v": 1,
                                                                "level": 0,
                                                                "input": "",
                                                                "note": {
                                                                    "type": "text",
                                                                    "tag": "p",
                                                                    "text": ""
                                                                }
                                                            }
                                                        },
                                                        {
                                                            "id": 21,
                                                            "name": "",
                                                            "visibility": "block",
                                                            "width": "narrow",
                                                            "state": {
                                                                "t": "resheet.note",
                                                                "v": 1,
                                                                "level": 0,
                                                                "input": "#### `/HStack(DateBlock(), SliderBlock(), SelectBlock(options))`",
                                                                "note": {
                                                                    "type": "text",
                                                                    "tag": "h4",
                                                                    "text": "`/HStack(DateBlock(), SliderBlock(), SelectBlock(options))`"
                                                                }
                                                            }
                                                        },
                                                        {
                                                            "id": 28,
                                                            "name": "options",
                                                            "visibility": "block",
                                                            "width": "narrow",
                                                            "state": {
                                                                "t": "resheet.note",
                                                                "v": 1,
                                                                "level": 0,
                                                                "input": "= ['yes', 'no']",
                                                                "note": {
                                                                    "type": "expr",
                                                                    "code": " ['yes', 'no']"
                                                                }
                                                            }
                                                        },
                                                        {
                                                            "id": 22,
                                                            "name": "hstack",
                                                            "visibility": "block",
                                                            "width": "narrow",
                                                            "state": {
                                                                "t": "resheet.note",
                                                                "v": 1,
                                                                "level": 0,
                                                                "input": "/HStack(DateBlock(), SliderBlock(), SelectBlock(options))",
                                                                "note": {
                                                                    "type": "block",
                                                                    "isInstantiated": true,
                                                                    "code": "HStack(DateBlock(), SliderBlock(), SelectBlock(options))",
                                                                    "state": [
                                                                        "2024-05-23T20:40:02+02:00",
                                                                        35,
                                                                        "yes"
                                                                    ]
                                                                }
                                                            }
                                                        },
                                                        {
                                                            "id": 23,
                                                            "name": "",
                                                            "visibility": "block",
                                                            "width": "narrow",
                                                            "state": {
                                                                "t": "resheet.note",
                                                                "v": 1,
                                                                "level": 0,
                                                                "input": "= hstack",
                                                                "note": {
                                                                    "type": "expr",
                                                                    "code": " hstack"
                                                                }
                                                            }
                                                        },
                                                        {
                                                            "id": 12,
                                                            "name": "",
                                                            "visibility": "block",
                                                            "width": "narrow",
                                                            "state": {
                                                                "t": "resheet.note",
                                                                "v": 1,
                                                                "level": 0,
                                                                "input": "",
                                                                "note": {
                                                                    "type": "text",
                                                                    "tag": "p",
                                                                    "text": ""
                                                                }
                                                            }
                                                        },
                                                        {
                                                            "id": 24,
                                                            "name": "",
                                                            "visibility": "block",
                                                            "width": "narrow",
                                                            "state": {
                                                                "t": "resheet.note",
                                                                "v": 1,
                                                                "level": 0,
                                                                "input": "",
                                                                "note": {
                                                                    "type": "text",
                                                                    "tag": "p",
                                                                    "text": ""
                                                                }
                                                            }
                                                        },
                                                        {
                                                            "id": 29,
                                                            "name": "",
                                                            "visibility": "block",
                                                            "width": "narrow",
                                                            "state": {
                                                                "t": "resheet.note",
                                                                "v": 1,
                                                                "level": 0,
                                                                "input": "#### Built-in Blocks",
                                                                "note": {
                                                                    "type": "text",
                                                                    "tag": "h4",
                                                                    "text": "Built-in Blocks"
                                                                }
                                                            }
                                                        },
                                                        {
                                                            "id": 13,
                                                            "name": "",
                                                            "visibility": "block",
                                                            "width": "narrow",
                                                            "state": {
                                                                "t": "resheet.note",
                                                                "v": 1,
                                                                "level": 0,
                                                                "input": "And we inspect some built-in Blocks:",
                                                                "note": {
                                                                    "type": "text",
                                                                    "tag": "p",
                                                                    "text": "And we inspect some built-in Blocks:"
                                                                }
                                                            }
                                                        },
                                                        {
                                                            "id": 14,
                                                            "name": "",
                                                            "visibility": "block",
                                                            "width": "narrow",
                                                            "state": {
                                                                "t": "resheet.note",
                                                                "v": 1,
                                                                "level": 0,
                                                                "input": "`/Debug.Inspect(Note)`",
                                                                "note": {
                                                                    "type": "text",
                                                                    "tag": "p",
                                                                    "text": "`/Debug.Inspect(Note)`"
                                                                }
                                                            }
                                                        },
                                                        {
                                                            "id": 15,
                                                            "name": "inspectNote",
                                                            "visibility": "block",
                                                            "width": "narrow",
                                                            "state": {
                                                                "t": "resheet.note",
                                                                "v": 1,
                                                                "level": 0,
                                                                "input": "/Debug.Inspect(Note)",
                                                                "note": {
                                                                    "type": "block",
                                                                    "isInstantiated": true,
                                                                    "code": "Debug.Inspect(Note)",
                                                                    "state": {
                                                                        "t": "resheet.note",
                                                                        "v": 1,
                                                                        "level": 0,
                                                                        "input": "= sliderBlockValue",
                                                                        "note": {
                                                                            "type": "expr",
                                                                            "code": " sliderBlockValue"
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        },
                                                        {
                                                            "id": 16,
                                                            "name": "",
                                                            "visibility": "block",
                                                            "width": "narrow",
                                                            "state": {
                                                                "t": "resheet.note",
                                                                "v": 1,
                                                                "level": 0,
                                                                "input": "= inspectNote.state",
                                                                "note": {
                                                                    "type": "expr",
                                                                    "code": " inspectNote.state"
                                                                }
                                                            }
                                                        },
                                                        {
                                                            "id": 17,
                                                            "name": "",
                                                            "visibility": "block",
                                                            "width": "narrow",
                                                            "state": {
                                                                "t": "resheet.note",
                                                                "v": 1,
                                                                "level": 0,
                                                                "input": "",
                                                                "note": {
                                                                    "type": "text",
                                                                    "tag": "p",
                                                                    "text": ""
                                                                }
                                                            }
                                                        },
                                                        {
                                                            "id": 18,
                                                            "name": "",
                                                            "visibility": "block",
                                                            "width": "narrow",
                                                            "state": {
                                                                "t": "resheet.note",
                                                                "v": 1,
                                                                "level": 0,
                                                                "input": "",
                                                                "note": {
                                                                    "type": "text",
                                                                    "tag": "p",
                                                                    "text": ""
                                                                }
                                                            }
                                                        },
                                                        {
                                                            "id": 19,
                                                            "name": "",
                                                            "visibility": "block",
                                                            "width": "narrow",
                                                            "state": {
                                                                "t": "resheet.note",
                                                                "v": 1,
                                                                "level": 0,
                                                                "input": '<span className="text-gray-400 text-sm">Psst: And don\'t miss the Grand Finale!</span>',
                                                                "note": {
                                                                    "type": "text",
                                                                    "tag": "p",
                                                                    "text": '<span className="text-gray-400 text-sm">Psst: And don\'t miss the Grand Finale!</span>'
                                                                }
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        }
                                    },
                                    {
                                        "id": 99,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 100,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 98,
                                        "name": "preview",
                                        "visibility": "result",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "/Code",
                                            "note": {
                                                "type": "block",
                                                "isInstantiated": true,
                                                "code": "Code",
                                                "state": "Util.WithEnv(\n  env => ({\n    ...env,\n    CheckBlock,\n    CheckEditableBlock,\n    SliderBlock,\n    SelectBlock,\n    DateBlock,\n    HStack,\n  }),\n  previewBlockTemplate.derivedBlock,\n)"
                                            }
                                        }
                                    }
                                ]
                            }
                        },
                        "isCollapsed": true,
                        "children": [
                            {
                                "id": 0,
                                "name": "SimpleBlock",
                                "state": {
                                    "t": "resheet.selector",
                                    "v": 0,
                                    "mode": "run",
                                    "expr": "Code",
                                    "inner": "function update(value, path, fn) {\n  if (!path || Array.isArray(path) && path.length === 0) {\n    return fn(value)\n  }\n  else {\n    return immutable.update(value, path, fn)\n  }\n}\n\nfunction SimpleBlock(init, view, desc={}) {\n  return resheet.core.block.create({\n    init,\n    view({ state, dispatch, env }, ref) {\n      function setState(newState, path=[]) {\n        const updateState = (\n          typeof newState === 'function' ?\n            newState\n          :\n            () => newState\n        )\n        \n        dispatch(state => ({\n          state: update(state, path, updateState),\n        }))\n      }\n      \n      function onUpdate(evPath, statePath=[], processValue=lodash.identity) {\n        return ev => {\n          setState(processValue(lodash.get(ev, evPath)), statePath)\n        }\n      }\n      \n      function fieldDispatcher(field) {\n        return resheet.util.dispatch.fieldDispatcher(field, dispatch)\n      }\n      \n      return view({\n        state, dispatch, env, ref,\n        setState, onUpdate, fieldDispatcher,\n      })\n    },\n    getResult(state) { return state },\n    recompute(state) { return { state, invalidated: false } },\n    fromJSON(json) { return json ?? init },\n    toJSON(state) { return state },\n    ...desc,\n  })\n}"
                                },
                                "isCollapsed": false,
                                "children": []
                            },
                            {
                                "id": 1,
                                "name": "includeCss",
                                "state": {
                                    "t": "resheet.selector",
                                    "v": 0,
                                    "mode": "run",
                                    "expr": "SheetOf(Note)",
                                    "inner": {
                                        "t": "resheet.sheet",
                                        "v": 2,
                                        "lines": [
                                            {
                                                "id": 1,
                                                "name": "cleanId",
                                                "visibility": "block",
                                                "width": "narrow",
                                                "state": {
                                                    "t": "resheet.note",
                                                    "v": 1,
                                                    "level": 0,
                                                    "input": "/Code",
                                                    "note": {
                                                        "type": "block",
                                                        "isInstantiated": true,
                                                        "code": "Code",
                                                        "state": "function cleanId(id) {\n  id = id.replace(/\\s+/g, '-');\n  id = id.replace(/[^\\w\\s-]/gi, '');\n  \n  if (!/^[a-zA-Z_]/.test(id)) {\n    id = '_' + id;\n  }\n  \n  return id.toLowerCase();\n}"
                                                    }
                                                }
                                            },
                                            {
                                                "id": 0,
                                                "name": "includeCss",
                                                "visibility": "block",
                                                "width": "narrow",
                                                "state": {
                                                    "t": "resheet.note",
                                                    "v": 1,
                                                    "level": 0,
                                                    "input": "/Code",
                                                    "note": {
                                                        "type": "block",
                                                        "isInstantiated": true,
                                                        "code": "Code",
                                                        "state": "function includeCss(url) {\n  const id = cleanId(url)\n  \n  const found = document.getElementById(id)\n  if (found) { return found }\n\n  const link = document.createElement('link')\n  link.id = id\n  link.href = url\n  link.rel = 'stylesheet'\n  \n  document.head.appendChild(link)\n  \n  return link\n}"
                                                    }
                                                }
                                            }
                                        ]
                                    }
                                },
                                "isCollapsed": true,
                                "children": []
                            }
                        ]
                    },
                    {
                        "id": 4,
                        "name": "Interactive Game Dev",
                        "state": {
                            "t": "resheet.selector",
                            "v": 0,
                            "mode": "run",
                            "expr": "SheetOf(Note)",
                            "inner": {
                                "t": "resheet.sheet",
                                "v": 2,
                                "lines": [
                                    {
                                        "id": 0,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "# Interactive Game Dev",
                                            "note": {
                                                "type": "text",
                                                "tag": "h1",
                                                "text": "Interactive Game Dev"
                                            }
                                        }
                                    },
                                    {
                                        "id": 1,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "Build a custom Game Block for interactively developing a simple game. Leverage existing Blocks to combine them to the tailored needs of a Game Editor.",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": "Build a custom Game Block for interactively developing a simple game. Leverage existing Blocks to combine them to the tailored needs of a Game Editor."
                                            }
                                        }
                                    },
                                    {
                                        "id": 2,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 3,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "This is just a showcase of how powerful a custom-built block can be. It doesn't include a step-by-step guide or explanation of the Game Block implementation.",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": "This is just a showcase of how powerful a custom-built block can be. It doesn't include a step-by-step guide or explanation of the Game Block implementation."
                                            }
                                        }
                                    },
                                    {
                                        "id": 4,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 7,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "A Game consists of 3 parts:",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": "A Game consists of 3 parts:"
                                            }
                                        }
                                    },
                                    {
                                        "id": 8,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 1,
                                            "input": "- The State: defining the current state of the game (where is the character, health, etc)",
                                            "note": {
                                                "type": "text",
                                                "tag": "li",
                                                "text": "The State: defining the current state of the game (where is the character, health, etc)"
                                            }
                                        }
                                    },
                                    {
                                        "id": 9,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 1,
                                            "input": "- The Update Logic: calculates a new state of the game by simulating a time-step of the game or responding to input",
                                            "note": {
                                                "type": "text",
                                                "tag": "li",
                                                "text": "The Update Logic: calculates a new state of the game by simulating a time-step of the game or responding to input"
                                            }
                                        }
                                    },
                                    {
                                        "id": 10,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 1,
                                            "input": "- The Render Logic: creates an image corresponding to the state",
                                            "note": {
                                                "type": "text",
                                                "tag": "li",
                                                "text": "The Render Logic: creates an image corresponding to the state"
                                            }
                                        }
                                    },
                                    {
                                        "id": 13,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 5,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "Therefore you can edit these 3 components:",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": "Therefore you can edit these 3 components:"
                                            }
                                        }
                                    },
                                    {
                                        "id": 6,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 1,
                                            "input": "- Initial State: How does the game start?",
                                            "note": {
                                                "type": "text",
                                                "tag": "li",
                                                "text": "Initial State: How does the game start?"
                                            }
                                        }
                                    },
                                    {
                                        "id": 11,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 1,
                                            "input": "- Update: calculate a new state out of the old state and an input (if it's `undefined` the update is a simulation-step)",
                                            "note": {
                                                "type": "text",
                                                "tag": "li",
                                                "text": "Update: calculate a new state out of the old state and an input (if it's `undefined` the update is a simulation-step)"
                                            }
                                        }
                                    },
                                    {
                                        "id": 12,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 1,
                                            "input": "- Render: render the game",
                                            "note": {
                                                "type": "text",
                                                "tag": "li",
                                                "text": "Render: render the game"
                                            }
                                        }
                                    },
                                    {
                                        "id": 29,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 30,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "As everywhere else you can see the live effects of your code changes.",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": "As everywhere else you can see the live effects of your code changes."
                                            }
                                        }
                                    },
                                    {
                                        "id": 14,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 31,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 32,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "wide",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "---",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": "---"
                                            }
                                        }
                                    },
                                    {
                                        "id": 33,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 40,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 16,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "## Simple Animation",
                                            "note": {
                                                "type": "text",
                                                "tag": "h2",
                                                "text": "Simple Animation"
                                            }
                                        }
                                    },
                                    {
                                        "id": 18,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": 'This example doesn\'t react to input and only runs some simulation. Start and stop with the left button, make a single simulation step with "Update" and reset to the initial state with "Reset".',
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": 'This example doesn\'t react to input and only runs some simulation. Start and stop with the left button, make a single simulation step with "Update" and reset to the initial state with "Reset".'
                                            }
                                        }
                                    },
                                    {
                                        "id": 17,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "wide",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "/Game",
                                            "note": {
                                                "type": "block",
                                                "isInstantiated": true,
                                                "code": "Game",
                                                "state": {
                                                    "init": "({\n  y: 200,\n  ySpeed: 0,\n})",
                                                    "update": {
                                                        "t": "resheet.sheet",
                                                        "v": 2,
                                                        "lines": [
                                                            {
                                                                "id": 0,
                                                                "name": "",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "The current state:",
                                                                    "note": {
                                                                        "type": "text",
                                                                        "tag": "p",
                                                                        "text": "The current state:"
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 1,
                                                                "name": "",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "= state",
                                                                    "note": {
                                                                        "type": "expr",
                                                                        "code": " state"
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 2,
                                                                "name": "",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "",
                                                                    "note": {
                                                                        "type": "text",
                                                                        "tag": "p",
                                                                        "text": ""
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 3,
                                                                "name": "",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "Gravity means decelerating:",
                                                                    "note": {
                                                                        "type": "text",
                                                                        "tag": "p",
                                                                        "text": "Gravity means decelerating:"
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 4,
                                                                "name": "gravity",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "= { ...state, ySpeed: state.ySpeed - 0.75 }",
                                                                    "note": {
                                                                        "type": "expr",
                                                                        "code": " { ...state, ySpeed: state.ySpeed - 0.75 }"
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 5,
                                                                "name": "",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "",
                                                                    "note": {
                                                                        "type": "text",
                                                                        "tag": "p",
                                                                        "text": ""
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 6,
                                                                "name": "",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "Jumping means getting some upwards velocity:",
                                                                    "note": {
                                                                        "type": "text",
                                                                        "tag": "p",
                                                                        "text": "Jumping means getting some upwards velocity:"
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 7,
                                                                "name": "jump",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "= { ...state, ySpeed: 12 }",
                                                                    "note": {
                                                                        "type": "expr",
                                                                        "code": " { ...state, ySpeed: 12 }"
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 8,
                                                                "name": "",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "",
                                                                    "note": {
                                                                        "type": "text",
                                                                        "tag": "p",
                                                                        "text": ""
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 9,
                                                                "name": "",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "Jump if on ground or otherwise let gravity pull us down:",
                                                                    "note": {
                                                                        "type": "text",
                                                                        "tag": "p",
                                                                        "text": "Jump if on ground or otherwise let gravity pull us down:"
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 10,
                                                                "name": "forces",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "= state.y <= 0 ? jump : gravity",
                                                                    "note": {
                                                                        "type": "expr",
                                                                        "code": " state.y <= 0 ? jump : gravity"
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 11,
                                                                "name": "",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "",
                                                                    "note": {
                                                                        "type": "text",
                                                                        "tag": "p",
                                                                        "text": ""
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 12,
                                                                "name": "",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "Move according to speed:",
                                                                    "note": {
                                                                        "type": "text",
                                                                        "tag": "p",
                                                                        "text": "Move according to speed:"
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 13,
                                                                "name": "newState",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "= { ...forces, y: forces.y + forces.ySpeed }",
                                                                    "note": {
                                                                        "type": "expr",
                                                                        "code": " { ...forces, y: forces.y + forces.ySpeed }"
                                                                    }
                                                                }
                                                            }
                                                        ]
                                                    },
                                                    "render": {
                                                        "t": "resheet.sheet",
                                                        "v": 2,
                                                        "lines": [
                                                            {
                                                                "id": 1,
                                                                "name": "",
                                                                "visibility": "block",
                                                                "width": "full",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "/Code",
                                                                    "note": {
                                                                        "type": "block",
                                                                        "isInstantiated": true,
                                                                        "code": "Code",
                                                                        "state": 'const height = 400;\nconst tileSize = 64;\nconst ground = height - tileSize;\n\nfunction GameView({ state, update }) {\n  const { running, toggleRunning } = useAnimation(update)\n  \n  return (\n    <div>\n      <div className="w-full flex flex-row space-x-2">\n        <button\n          className={`\n            flex-1 rounded\n            bg-${running ? "green" : "red"}-100\n            hover:bg-${running ? "green" : "red"}-200\n          `}\n          onClick={toggleRunning}\n        >\n          {running ? "Running" : "Stopped"}\n        </button>\n\n        <button\n          className="flex-1 rounded bg-blue-100 hover:bg-blue-200"\n          onClick={() => update(16)}\n        >\n          Step\n        </button>\n      </div> \n      \n      <svg className="w-full" height={height}>\n        <defs>\n          <pattern id="platform" patternUnits="userSpaceOnUse" width={tileSize} height={tileSize}>\n            <image href={Tiles.ground.src} width={tileSize} height={tileSize} />\n          </pattern>\n        </defs>\n      \n        <rect transform="translate(0, 336)" width="2000" height={tileSize} fill="url(#platform)" />\n      \n        <image\n          transform={`\n            translate(100, ${ground - state.y})\n            translate(${-tileSize/2}, ${-tileSize})\n          `}\n          href={Tiles.character.src}\n          width={tileSize}\n          height={tileSize}\n          />\n      </svg>\n    </div>\n  )\n}'
                                                                    }
                                                                }
                                                            }
                                                        ]
                                                    }
                                                }
                                            }
                                        }
                                    },
                                    {
                                        "id": 19,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "= $17",
                                            "note": {
                                                "type": "expr",
                                                "code": " $17"
                                            }
                                        }
                                    },
                                    {
                                        "id": 41,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 34,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 35,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "wide",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "---",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": "---"
                                            }
                                        }
                                    },
                                    {
                                        "id": 36,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 20,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 21,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "# Input",
                                            "note": {
                                                "type": "text",
                                                "tag": "h1",
                                                "text": "Input"
                                            }
                                        }
                                    },
                                    {
                                        "id": 22,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "We add some keyboard input handling and extend the character to be able to move left and right.",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": "We add some keyboard input handling and extend the character to be able to move left and right."
                                            }
                                        }
                                    },
                                    {
                                        "id": 15,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "wide",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "/Game",
                                            "note": {
                                                "type": "block",
                                                "isInstantiated": true,
                                                "code": "Game",
                                                "state": {
                                                    "init": "({\n  x: 100,\n  y: 400,\n  xSpeed: 0,\n  ySpeed: 0,\n})",
                                                    "update": {
                                                        "t": "resheet.sheet",
                                                        "v": 2,
                                                        "lines": [
                                                            {
                                                                "id": 0,
                                                                "name": "",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "The current state:",
                                                                    "note": {
                                                                        "type": "text",
                                                                        "tag": "p",
                                                                        "text": "The current state:"
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 1,
                                                                "name": "",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "= state",
                                                                    "note": {
                                                                        "type": "expr",
                                                                        "code": " state"
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 2,
                                                                "name": "",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "### Simulation",
                                                                    "note": {
                                                                        "type": "text",
                                                                        "tag": "h3",
                                                                        "text": "Simulation"
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 3,
                                                                "name": "",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "Gravity means decelerating:",
                                                                    "note": {
                                                                        "type": "text",
                                                                        "tag": "p",
                                                                        "text": "Gravity means decelerating:"
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 4,
                                                                "name": "gravity",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "= { ...state, ySpeed: state.ySpeed - 0.75 }",
                                                                    "note": {
                                                                        "type": "expr",
                                                                        "code": " { ...state, ySpeed: state.ySpeed - 0.75 }"
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 5,
                                                                "name": "",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "",
                                                                    "note": {
                                                                        "type": "text",
                                                                        "tag": "p",
                                                                        "text": ""
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 6,
                                                                "name": "",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "Jumping means getting some upwards velocity:",
                                                                    "note": {
                                                                        "type": "text",
                                                                        "tag": "p",
                                                                        "text": "Jumping means getting some upwards velocity:"
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 7,
                                                                "name": "jump",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "= { ...state, ySpeed: 12 }",
                                                                    "note": {
                                                                        "type": "expr",
                                                                        "code": " { ...state, ySpeed: 12 }"
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 8,
                                                                "name": "",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "",
                                                                    "note": {
                                                                        "type": "text",
                                                                        "tag": "p",
                                                                        "text": ""
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 9,
                                                                "name": "",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "Jump if on ground or otherwise let gravity pull us down:",
                                                                    "note": {
                                                                        "type": "text",
                                                                        "tag": "p",
                                                                        "text": "Jump if on ground or otherwise let gravity pull us down:"
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 10,
                                                                "name": "forces",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "= state.y <= 0 ? jump : gravity",
                                                                    "note": {
                                                                        "type": "expr",
                                                                        "code": " state.y <= 0 ? jump : gravity"
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 11,
                                                                "name": "",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "",
                                                                    "note": {
                                                                        "type": "text",
                                                                        "tag": "p",
                                                                        "text": ""
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 12,
                                                                "name": "",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "Move according to speed:",
                                                                    "note": {
                                                                        "type": "text",
                                                                        "tag": "p",
                                                                        "text": "Move according to speed:"
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 13,
                                                                "name": "simulation",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "= {\n  ...forces,\n  x: forces.x + forces.xSpeed,\n  y: forces.y + forces.ySpeed,\n}",
                                                                    "note": {
                                                                        "type": "expr",
                                                                        "code": " {\n  ...forces,\n  x: forces.x + forces.xSpeed,\n  y: forces.y + forces.ySpeed,\n}"
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 14,
                                                                "name": "",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "",
                                                                    "note": {
                                                                        "type": "text",
                                                                        "tag": "p",
                                                                        "text": ""
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 15,
                                                                "name": "",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "### React to Input",
                                                                    "note": {
                                                                        "type": "text",
                                                                        "tag": "h3",
                                                                        "text": "React to Input"
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 16,
                                                                "name": "",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "= input",
                                                                    "note": {
                                                                        "type": "expr",
                                                                        "code": " input"
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 17,
                                                                "name": "reaction",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "/Code",
                                                                    "note": {
                                                                        "type": "block",
                                                                        "isInstantiated": true,
                                                                        "code": "Code",
                                                                        "state": "if (!input) return;\n\nconst xSpeed = (\n  input.type === 'simulate' ?\n    state.xSpeed\n  : input.type === 'keyup' ? // This is not 100% correct, but let's keep it simple\n    0\n  : input.key === 'ArrowLeft' ?\n    -3\n  : input.key === 'ArrowRight' ?\n    3\n  :\n    state.xSpeed\n)\n\nreturn {\n  ...state,\n  xSpeed,\n}"
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 18,
                                                                "name": "",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "",
                                                                    "note": {
                                                                        "type": "text",
                                                                        "tag": "p",
                                                                        "text": ""
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 19,
                                                                "name": "",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "### Final State",
                                                                    "note": {
                                                                        "type": "text",
                                                                        "tag": "h3",
                                                                        "text": "Final State"
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 20,
                                                                "name": "",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "Decide which state to use based on the input:",
                                                                    "note": {
                                                                        "type": "text",
                                                                        "tag": "p",
                                                                        "text": "Decide which state to use based on the input:"
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 21,
                                                                "name": "finalState",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "= input && input.type !== 'simulate' ? reaction : simulation",
                                                                    "note": {
                                                                        "type": "expr",
                                                                        "code": " input && input.type !== 'simulate' ? reaction : simulation"
                                                                    }
                                                                }
                                                            }
                                                        ]
                                                    },
                                                    "render": {
                                                        "t": "resheet.sheet",
                                                        "v": 2,
                                                        "lines": [
                                                            {
                                                                "id": 0,
                                                                "name": "",
                                                                "visibility": "block",
                                                                "width": "full",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "/Code",
                                                                    "note": {
                                                                        "type": "block",
                                                                        "isInstantiated": true,
                                                                        "code": "Code",
                                                                        "state": 'const height = 400;\nconst tileSize = 64;\nconst ground = height - tileSize;\n\nfunction GameView({ state, update }) {\n  const { running, toggleRunning } = useAnimation(dt => update({ type: \'simulate\', dt }))\n  \n  function react(ev) {\n    ev.preventDefault()\n    ev.stopPropagation()\n    \n    update(ev) // runs an update with `input` set to `ev`\n  }\n\n  return (\n    <div>\n      <div className="w-full flex flex-row space-x-2">\n        <button\n          className={`\n            flex-1 rounded\n            bg-${running ? "green" : "red"}-100\n            hover:bg-${running ? "green" : "red"}-200\n          `}\n          onClick={toggleRunning}\n        >\n          {running ? "Running" : "Stopped"}\n        </button>\n\n        <button\n          className="flex-1 rounded bg-blue-100 hover:bg-blue-200"\n          onClick={() => update({ type: \'simulate\', dt: 16 })}\n        >\n          Step\n        </button>\n      </div> \n\n      <svg\n        tabIndex={-1}\n        className="w-full"\n        height={height}\n        onKeyDown={react}\n        onKeyUp={react}\n      >\n        <defs>\n          <pattern id="platform" patternUnits="userSpaceOnUse" width={tileSize} height={tileSize}>\n            <image href={Tiles.ground.src} width={tileSize} height={tileSize} />\n          </pattern>\n        </defs>\n      \n        <rect transform="translate(0, 336)" width="2000" height={tileSize} fill="url(#platform)" />\n      \n        <image\n          transform={`\n            translate(${state.x}, ${ground - state.y})\n            scale(${state.xSpeed < 0 ? 1 : -1}, 1)\n            translate(${-tileSize/2}, ${-tileSize})\n          `}\n          href={Tiles.character.src}\n          width={tileSize}\n          height={tileSize}\n          />\n      </svg>\n    </div>\n  )\n}'
                                                                    }
                                                                }
                                                            }
                                                        ]
                                                    }
                                                }
                                            }
                                        }
                                    },
                                    {
                                        "id": 24,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 37,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 38,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 42,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "wide",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "---",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": "---"
                                            }
                                        }
                                    },
                                    {
                                        "id": 25,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 39,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 26,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "## Real Game",
                                            "note": {
                                                "type": "text",
                                                "tag": "h2",
                                                "text": "Real Game"
                                            }
                                        }
                                    },
                                    {
                                        "id": 27,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": 'Let\'s make it a "real" game by adding some enemies, lives, mobile input, framerate handling and canvas rendering. (Still missing are more visual effects and sounds)',
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": 'Let\'s make it a "real" game by adding some enemies, lives, mobile input, framerate handling and canvas rendering. (Still missing are more visual effects and sounds)'
                                            }
                                        }
                                    },
                                    {
                                        "id": 43,
                                        "name": "realGame",
                                        "visibility": "block",
                                        "width": "wide",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "/Debug.Inspect(Game)",
                                            "note": {
                                                "type": "block",
                                                "isInstantiated": true,
                                                "code": "Debug.Inspect(Game)",
                                                "state": {
                                                    "init": "({\n  score: 0,\n  lives: 10,\n  character: {\n    x: 100,\n    y: 400,\n    xSpeed: 0,\n    ySpeed: 0,\n  },\n  enemies: [],\n})",
                                                    "update": {
                                                        "t": "resheet.sheet",
                                                        "v": 2,
                                                        "lines": [
                                                            {
                                                                "id": 1,
                                                                "name": "",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "The current state:",
                                                                    "note": {
                                                                        "type": "text",
                                                                        "tag": "p",
                                                                        "text": "The current state:"
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 2,
                                                                "name": "",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "= state",
                                                                    "note": {
                                                                        "type": "expr",
                                                                        "code": " state"
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 58,
                                                                "name": "",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "The input:",
                                                                    "note": {
                                                                        "type": "text",
                                                                        "tag": "p",
                                                                        "text": "The input:"
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 59,
                                                                "name": "",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "= input",
                                                                    "note": {
                                                                        "type": "expr",
                                                                        "code": " input"
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 61,
                                                                "name": "",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "",
                                                                    "note": {
                                                                        "type": "text",
                                                                        "tag": "p",
                                                                        "text": ""
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 60,
                                                                "name": "",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "Respect the framerate:",
                                                                    "note": {
                                                                        "type": "text",
                                                                        "tag": "p",
                                                                        "text": "Respect the framerate:"
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 62,
                                                                "name": "dt",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "= input?.dt ?? 16",
                                                                    "note": {
                                                                        "type": "expr",
                                                                        "code": " input?.dt ?? 16"
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 64,
                                                                "name": "",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "Calculate in px/s:",
                                                                    "note": {
                                                                        "type": "text",
                                                                        "tag": "p",
                                                                        "text": "Calculate in px/s:"
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 63,
                                                                "name": "factor",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "= dt / 1000",
                                                                    "note": {
                                                                        "type": "expr",
                                                                        "code": " dt / 1000"
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 3,
                                                                "name": "",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "### Simulate Character",
                                                                    "note": {
                                                                        "type": "text",
                                                                        "tag": "h3",
                                                                        "text": "Simulate Character"
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 4,
                                                                "name": "character",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "= state.character",
                                                                    "note": {
                                                                        "type": "expr",
                                                                        "code": " state.character"
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 5,
                                                                "name": "",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "Gravity means decelerating:",
                                                                    "note": {
                                                                        "type": "text",
                                                                        "tag": "p",
                                                                        "text": "Gravity means decelerating:"
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 6,
                                                                "name": "gravity",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "= { ...character, ySpeed: character.ySpeed - 40 * factor }",
                                                                    "note": {
                                                                        "type": "expr",
                                                                        "code": " { ...character, ySpeed: character.ySpeed - 40 * factor }"
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 7,
                                                                "name": "",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "",
                                                                    "note": {
                                                                        "type": "text",
                                                                        "tag": "p",
                                                                        "text": ""
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 8,
                                                                "name": "",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "Jumping means getting some upwards velocity:",
                                                                    "note": {
                                                                        "type": "text",
                                                                        "tag": "p",
                                                                        "text": "Jumping means getting some upwards velocity:"
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 9,
                                                                "name": "jump",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "= { ...character, ySpeed: 14 }",
                                                                    "note": {
                                                                        "type": "expr",
                                                                        "code": " { ...character, ySpeed: 14 }"
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 10,
                                                                "name": "",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "",
                                                                    "note": {
                                                                        "type": "text",
                                                                        "tag": "p",
                                                                        "text": ""
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 11,
                                                                "name": "",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "Jump if on ground or otherwise let gravity pull us down:",
                                                                    "note": {
                                                                        "type": "text",
                                                                        "tag": "p",
                                                                        "text": "Jump if on ground or otherwise let gravity pull us down:"
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 12,
                                                                "name": "forces",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "= character.y <= 0 ? jump : gravity",
                                                                    "note": {
                                                                        "type": "expr",
                                                                        "code": " character.y <= 0 ? jump : gravity"
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 13,
                                                                "name": "",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "",
                                                                    "note": {
                                                                        "type": "text",
                                                                        "tag": "p",
                                                                        "text": ""
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 14,
                                                                "name": "",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "Move according to speed:",
                                                                    "note": {
                                                                        "type": "text",
                                                                        "tag": "p",
                                                                        "text": "Move according to speed:"
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 15,
                                                                "name": "simulatedCharacter",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "= {\n  ...forces,\n  x: forces.x + forces.xSpeed,\n  y: forces.y + forces.ySpeed,\n}",
                                                                    "note": {
                                                                        "type": "expr",
                                                                        "code": " {\n  ...forces,\n  x: forces.x + forces.xSpeed,\n  y: forces.y + forces.ySpeed,\n}"
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 16,
                                                                "name": "",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "",
                                                                    "note": {
                                                                        "type": "text",
                                                                        "tag": "p",
                                                                        "text": ""
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 17,
                                                                "name": "",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "### Simulate Enemies",
                                                                    "note": {
                                                                        "type": "text",
                                                                        "tag": "h3",
                                                                        "text": "Simulate Enemies"
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 18,
                                                                "name": "enemies",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "= state.enemies",
                                                                    "note": {
                                                                        "type": "expr",
                                                                        "code": " state.enemies"
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 19,
                                                                "name": "enemySize",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "= 32",
                                                                    "note": {
                                                                        "type": "expr",
                                                                        "code": " 32"
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 20,
                                                                "name": "",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "",
                                                                    "note": {
                                                                        "type": "text",
                                                                        "tag": "p",
                                                                        "text": ""
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 21,
                                                                "name": "",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "Move enemies:",
                                                                    "note": {
                                                                        "type": "text",
                                                                        "tag": "p",
                                                                        "text": "Move enemies:"
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 22,
                                                                "name": "movedEnemies",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "= enemies.map(enemyPosition => enemyPosition - 160 * factor)",
                                                                    "note": {
                                                                        "type": "expr",
                                                                        "code": " enemies.map(enemyPosition => enemyPosition - 160 * factor)"
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 23,
                                                                "name": "",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "",
                                                                    "note": {
                                                                        "type": "text",
                                                                        "tag": "p",
                                                                        "text": ""
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 24,
                                                                "name": "",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "Randomly add enemies:",
                                                                    "note": {
                                                                        "type": "text",
                                                                        "tag": "p",
                                                                        "text": "Randomly add enemies:"
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 25,
                                                                "name": "addedEnemies",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "= [ ...movedEnemies, ...(Math.random() < 0.6 * factor ? [1300] : []) ]",
                                                                    "note": {
                                                                        "type": "expr",
                                                                        "code": " [ ...movedEnemies, ...(Math.random() < 0.6 * factor ? [1300] : []) ]"
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 26,
                                                                "name": "",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "",
                                                                    "note": {
                                                                        "type": "text",
                                                                        "tag": "p",
                                                                        "text": ""
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 27,
                                                                "name": "",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "Filter enemies that have passed:",
                                                                    "note": {
                                                                        "type": "text",
                                                                        "tag": "p",
                                                                        "text": "Filter enemies that have passed:"
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 28,
                                                                "name": "passedAndLeftEnemies",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "= lodash.partition(addedEnemies, enemyPos => enemyPos < -enemySize)",
                                                                    "note": {
                                                                        "type": "expr",
                                                                        "code": " lodash.partition(addedEnemies, enemyPos => enemyPos < -enemySize)"
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 29,
                                                                "name": "passedEnemies",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "= passedAndLeftEnemies[0]",
                                                                    "note": {
                                                                        "type": "expr",
                                                                        "code": " passedAndLeftEnemies[0]"
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 30,
                                                                "name": "leftEnemies",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "= passedAndLeftEnemies[1]",
                                                                    "note": {
                                                                        "type": "expr",
                                                                        "code": " passedAndLeftEnemies[1]"
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 31,
                                                                "name": "",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "",
                                                                    "note": {
                                                                        "type": "text",
                                                                        "tag": "p",
                                                                        "text": ""
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 32,
                                                                "name": "",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "### Lives, Collisions and Score ",
                                                                    "note": {
                                                                        "type": "text",
                                                                        "tag": "h3",
                                                                        "text": "Lives, Collisions and Score "
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 33,
                                                                "name": "",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "Add passed enemies to score:",
                                                                    "note": {
                                                                        "type": "text",
                                                                        "tag": "p",
                                                                        "text": "Add passed enemies to score:"
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 34,
                                                                "name": "score",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "= state.score + passedEnemies.length",
                                                                    "note": {
                                                                        "type": "expr",
                                                                        "code": " state.score + passedEnemies.length"
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 35,
                                                                "name": "",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "",
                                                                    "note": {
                                                                        "type": "text",
                                                                        "tag": "p",
                                                                        "text": ""
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 36,
                                                                "name": "",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "Find collisions with enemies:",
                                                                    "note": {
                                                                        "type": "text",
                                                                        "tag": "p",
                                                                        "text": "Find collisions with enemies:"
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 37,
                                                                "name": "collidedAndUntouchedEnemies",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "= lodash.partition(leftEnemies, enemyPos =>\n    simulatedCharacter.y <= enemySize\n    && Math.abs(simulatedCharacter.x - enemyPos) <= enemySize\n)",
                                                                    "note": {
                                                                        "type": "expr",
                                                                        "code": " lodash.partition(leftEnemies, enemyPos =>\n    simulatedCharacter.y <= enemySize\n    && Math.abs(simulatedCharacter.x - enemyPos) <= enemySize\n)"
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 38,
                                                                "name": "collidedEnemies",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "= collidedAndUntouchedEnemies[0]",
                                                                    "note": {
                                                                        "type": "expr",
                                                                        "code": " collidedAndUntouchedEnemies[0]"
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 39,
                                                                "name": "untouchedEnemies",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "= collidedAndUntouchedEnemies[1]",
                                                                    "note": {
                                                                        "type": "expr",
                                                                        "code": " collidedAndUntouchedEnemies[1]"
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 40,
                                                                "name": "",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "",
                                                                    "note": {
                                                                        "type": "text",
                                                                        "tag": "p",
                                                                        "text": ""
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 41,
                                                                "name": "",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "Take a life on collision:",
                                                                    "note": {
                                                                        "type": "text",
                                                                        "tag": "p",
                                                                        "text": "Take a life on collision:"
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 42,
                                                                "name": "collided",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "= collidedEnemies.length > 0",
                                                                    "note": {
                                                                        "type": "expr",
                                                                        "code": " collidedEnemies.length > 0"
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 43,
                                                                "name": "leftLives",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "= collided ? state.lives - 1 : state.lives",
                                                                    "note": {
                                                                        "type": "expr",
                                                                        "code": " collided ? state.lives - 1 : state.lives"
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 44,
                                                                "name": "",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "",
                                                                    "note": {
                                                                        "type": "text",
                                                                        "tag": "p",
                                                                        "text": ""
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 45,
                                                                "name": "",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "### Final Simulated State",
                                                                    "note": {
                                                                        "type": "text",
                                                                        "tag": "h3",
                                                                        "text": "Final Simulated State"
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 46,
                                                                "name": "",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "One last thing: Are we even still alive to begin with?",
                                                                    "note": {
                                                                        "type": "text",
                                                                        "tag": "p",
                                                                        "text": "One last thing: Are we even still alive to begin with?"
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 47,
                                                                "name": "alive",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "= state.lives > 0",
                                                                    "note": {
                                                                        "type": "expr",
                                                                        "code": " state.lives > 0"
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 48,
                                                                "name": "simulation",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "/Code",
                                                                    "note": {
                                                                        "type": "block",
                                                                        "isInstantiated": true,
                                                                        "code": "Code",
                                                                        "state": "!alive ?\n  state\n:\n  {\n    ...state,\n    score,\n    lives: leftLives,\n    character: simulatedCharacter,\n    enemies: untouchedEnemies,\n  }"
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 49,
                                                                "name": "",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "",
                                                                    "note": {
                                                                        "type": "text",
                                                                        "tag": "p",
                                                                        "text": ""
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 50,
                                                                "name": "",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "### React to Input",
                                                                    "note": {
                                                                        "type": "text",
                                                                        "tag": "h3",
                                                                        "text": "React to Input"
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 51,
                                                                "name": "",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "= input",
                                                                    "note": {
                                                                        "type": "expr",
                                                                        "code": " input"
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 52,
                                                                "name": "xSpeed",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "/Code",
                                                                    "note": {
                                                                        "type": "block",
                                                                        "isInstantiated": true,
                                                                        "code": "Code",
                                                                        "state": "// input changes character's xSpeed\nconst previous = state.character.xSpeed\n\nconst speed = 250 * factor\n\nif (!input) return previous;\n\n// This is not 100% correct, but let's keep it simple\nif (input.type === 'keyup') return 0;\nif (input.type === 'pointerup') return 0;\n\nif (input.type === 'keydown') {\n  if (input.key === 'ArrowLeft') return -speed;\n  if (input.key === 'ArrowRight') return speed;\n}\n\nif (input.type === 'pointerdown') {\n  const rect = input.target.getBoundingClientRect()\n  if (input.clientX - rect.x < rect.width / 2) return -speed;\n  if (input.clientX - rect.x > rect.width / 2) return speed;\n}\n\nreturn previous"
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 53,
                                                                "name": "reaction",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "= { ...state, character: { ...state.character, xSpeed } }",
                                                                    "note": {
                                                                        "type": "expr",
                                                                        "code": " { ...state, character: { ...state.character, xSpeed } }"
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 54,
                                                                "name": "",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "",
                                                                    "note": {
                                                                        "type": "text",
                                                                        "tag": "p",
                                                                        "text": ""
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 55,
                                                                "name": "",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "### Final State",
                                                                    "note": {
                                                                        "type": "text",
                                                                        "tag": "h3",
                                                                        "text": "Final State"
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 56,
                                                                "name": "",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "Decide which state to use based on the input:",
                                                                    "note": {
                                                                        "type": "text",
                                                                        "tag": "p",
                                                                        "text": "Decide which state to use based on the input:"
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 57,
                                                                "name": "finalState",
                                                                "visibility": "block",
                                                                "width": "narrow",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "= input?.type === 'simulate' ? simulation : reaction",
                                                                    "note": {
                                                                        "type": "expr",
                                                                        "code": " input?.type === 'simulate' ? simulation : reaction"
                                                                    }
                                                                }
                                                            }
                                                        ]
                                                    },
                                                    "render": {
                                                        "t": "resheet.sheet",
                                                        "v": 2,
                                                        "lines": [
                                                            {
                                                                "id": 1,
                                                                "name": "Controls",
                                                                "visibility": "result",
                                                                "width": "full",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "/Code",
                                                                    "note": {
                                                                        "type": "block",
                                                                        "isInstantiated": true,
                                                                        "code": "Code",
                                                                        "state": 'function Controls({ state, update, running, toggleRunning }) {\n  return (\n    <div className="w-full flex flex-row space-x-2">\n      <button\n        className={`\n          flex-1 rounded\n          bg-${running ? "green" : "red"}-100\n          hover:bg-${running ? "green" : "red"}-200\n        `}\n        onClick={toggleRunning}\n      >\n        {running ? "Running" : "Stopped - click to play"}\n      </button>\n\n      <button\n        className="flex-1 rounded bg-blue-100 hover:bg-blue-200"\n        onClick={() => update({ type: \'simulate\', dt: 16 })}\n      >\n        Step\n      </button>\n    </div> \n  )\n}'
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "id": 0,
                                                                "name": "",
                                                                "visibility": "block",
                                                                "width": "full",
                                                                "state": {
                                                                    "t": "resheet.note",
                                                                    "v": 1,
                                                                    "level": 0,
                                                                    "input": "/Code",
                                                                    "note": {
                                                                        "type": "block",
                                                                        "isInstantiated": true,
                                                                        "code": "Code",
                                                                        "state": "const height = 400;\nconst width = 800;\nconst tileSize = 64;\nconst ground = height - tileSize;\n\nfunction GameView({ state, update }) {\n  const { running, toggleRunning } = useAnimation(dt => update({ type: 'simulate', dt }))\n  \n  function react(ev) {\n    ev.preventDefault()\n    ev.stopPropagation()\n    ev.target.focus()\n    \n    update(ev) // runs an update with `input` set to `ev`\n  }\n  \n  const canvasRef = React.useRef(null)\n  \n  React.useEffect(() => {\n    const canvas = canvasRef.current;\n    const ctx = canvas.getContext('2d');\n    \n    // Setting up canvas dimensions\n    canvas.width = width;\n    canvas.height = height;\n\n    // Draw the platform\n    const ptrn = ctx.createPattern(Tiles.ground, 'repeat');\n    ctx.save();\n    ctx.fillStyle = ptrn;\n    ctx.translate(0, 336);\n    ctx.scale(tileSize / Tiles.ground.naturalWidth, tileSize / Tiles.ground.naturalHeight);\n    ctx.fillRect(0, 0, width, tileSize);\n    ctx.restore();\n\n    // Draw the character\n    ctx.save();\n    ctx.translate(state.character.x, height - tileSize - state.character.y);\n    if (state.lives <= 0) ctx.rotate(90 * Math.PI / 180);\n    if (state.character.xSpeed >= 0) ctx.scale(-1, 1);\n    ctx.drawImage(Tiles.character, -tileSize/2, -tileSize, tileSize, tileSize);\n    ctx.restore();\n\n    // Draw enemies\n    state.enemies.forEach(enemyPos => {\n      ctx.save();\n      ctx.translate(enemyPos, height - tileSize);\n      ctx.scale(0.5, 0.5);\n      ctx.drawImage(Tiles.enemy, -tileSize/2, -tileSize, tileSize, tileSize);\n      ctx.restore();\n    });\n\n    // Draw text\n    ctx.font = '20px Arial';\n    ctx.fillStyle = 'black';\n    ctx.fillText(`Lives: ${\"\u2764\uFE0F\".repeat(state.lives)}`, 20, 30);\n    ctx.fillText(`Score: ${state.score} x \u2B50\uFE0F`, 20, 60);\n    \n    ctx.font = '16px Arial';\n    ctx.fillStyle = '#888';\n    ctx.fillText('Use the arrow keys or press on the left and right', 20, 90);\n    \n    if (state.lives <= 0) {\n      ctx.fillStyle = 'red';\n      ctx.font = '40px Arial';\n      ctx.fillText('Game Over', 50, 200);\n    }\n  }, [state]);\n\n\n  return (\n    <div>\n      <Controls state={state} update={update} running={running} toggleRunning={toggleRunning} />\n      <canvas\n        ref={canvasRef}\n        tabIndex={-1}\n        className=\"w-full\"\n        onKeyDown={react}\n        onKeyUp={react}\n        onPointerDownCapture={react}\n        onPointerUpCapture={react}\n        />\n    </div>\n  )\n}"
                                                                    }
                                                                }
                                                            }
                                                        ]
                                                    }
                                                }
                                            }
                                        }
                                    },
                                    {
                                        "id": 44,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 45,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 46,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 52,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 53,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 54,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 55,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 47,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "full",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "---",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": "---"
                                            }
                                        }
                                    },
                                    {
                                        "id": 49,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "## Preview",
                                            "note": {
                                                "type": "text",
                                                "tag": "h2",
                                                "text": "Preview"
                                            }
                                        }
                                    },
                                    {
                                        "id": 50,
                                        "name": "",
                                        "visibility": "block",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "",
                                            "note": {
                                                "type": "text",
                                                "tag": "p",
                                                "text": ""
                                            }
                                        }
                                    },
                                    {
                                        "id": 51,
                                        "name": "preview",
                                        "visibility": "result",
                                        "width": "narrow",
                                        "state": {
                                            "t": "resheet.note",
                                            "v": 1,
                                            "level": 0,
                                            "input": "/Code",
                                            "note": {
                                                "type": "block",
                                                "isInstantiated": true,
                                                "code": "Code",
                                                "state": "Util.WithEnv(\n  env => ({ ...env, Tiles, useAnimation }),\n  realGame.derivedBlock,\n)"
                                            }
                                        }
                                    }
                                ]
                            }
                        },
                        "isCollapsed": true,
                        "children": [
                            {
                                "id": 0,
                                "name": "Tiles",
                                "state": {
                                    "t": "resheet.selector",
                                    "v": 0,
                                    "mode": "run",
                                    "expr": "SheetOf(Note)",
                                    "inner": {
                                        "t": "resheet.sheet",
                                        "v": 2,
                                        "lines": [
                                            {
                                                "id": 4,
                                                "name": "",
                                                "visibility": "block",
                                                "width": "narrow",
                                                "state": {
                                                    "t": "resheet.note",
                                                    "v": 1,
                                                    "level": 0,
                                                    "input": "# Tiles",
                                                    "note": {
                                                        "type": "text",
                                                        "tag": "h1",
                                                        "text": "Tiles"
                                                    }
                                                }
                                            },
                                            {
                                                "id": 5,
                                                "name": "",
                                                "visibility": "block",
                                                "width": "narrow",
                                                "state": {
                                                    "t": "resheet.note",
                                                    "v": 1,
                                                    "level": 0,
                                                    "input": "from kenney.nl",
                                                    "note": {
                                                        "type": "text",
                                                        "tag": "p",
                                                        "text": "from kenney.nl"
                                                    }
                                                }
                                            },
                                            {
                                                "id": 0,
                                                "name": "groundFile",
                                                "visibility": "block",
                                                "width": "narrow",
                                                "state": {
                                                    "t": "resheet.note",
                                                    "v": 1,
                                                    "level": 0,
                                                    "input": "/LoadFile",
                                                    "note": {
                                                        "type": "block",
                                                        "isInstantiated": true,
                                                        "code": "LoadFile",
                                                        "state": {
                                                            "state": "loaded",
                                                            "file": {
                                                                "content": "iVBORw0KGgoAAAANSUhEUgAAABIAAAASBAMAAACk4JNkAAAABGdBTUEAALGPC/xhBQAAABJQTFRF9KxmNuN3n1pSLrCCQ0pfy4FePNWy0QAAADtJREFUCNdjcIEBBgRLEAaQWMYwgJWlbGwEQQxKxkoQxKAEAwyhMABjsYJYqqGhSnAxGCsIRR2QhcV9AJFcJViCy6XLAAAAAElFTkSuQmCC",
                                                                "name": "tile_0002.png",
                                                                "options": {
                                                                    "type": "image/png",
                                                                    "lastModified": 1696663628000
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            },
                                            {
                                                "id": 1,
                                                "name": "charFile",
                                                "visibility": "block",
                                                "width": "narrow",
                                                "state": {
                                                    "t": "resheet.note",
                                                    "v": 1,
                                                    "level": 0,
                                                    "input": "/LoadFile",
                                                    "note": {
                                                        "type": "block",
                                                        "isInstantiated": true,
                                                        "code": "LoadFile",
                                                        "state": {
                                                            "state": "loaded",
                                                            "file": {
                                                                "content": "iVBORw0KGgoAAAANSUhEUgAAABgAAAAYBAMAAAASWSDLAAAABGdBTUEAALGPC/xhBQAAABhQTFRFAAAANJleQ0pfhva7////WtKMNGVHvt7xFlk/CQAAAAF0Uk5TAEDm2GYAAACESURBVBjTbdAxDsIwDAXQTGXuwgF6BSROgOQTODMIxV0ZrPr62P7xUMSf8mQr+klrP7HMPOvDQ6mLUgyUPgHCmgasEHtqh3h2o4RkgENuHtmBd+BeYE9hBPpfbLwVDMirjbCWDbybDxjdTq1P72kLWj8BXDAh6/W1yvwQ4T64sIw+cusLm7JKEh9ouLwAAAAASUVORK5CYII=",
                                                                "name": "tile_0000.png",
                                                                "options": {
                                                                    "type": "image/png",
                                                                    "lastModified": 1696663636000
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            },
                                            {
                                                "id": 7,
                                                "name": "enemyFile",
                                                "visibility": "block",
                                                "width": "narrow",
                                                "state": {
                                                    "t": "resheet.note",
                                                    "v": 1,
                                                    "level": 0,
                                                    "input": "/LoadFile",
                                                    "note": {
                                                        "type": "block",
                                                        "isInstantiated": true,
                                                        "code": "LoadFile",
                                                        "state": {
                                                            "state": "loaded",
                                                            "file": {
                                                                "content": "iVBORw0KGgoAAAANSUhEUgAAABgAAAAYBAMAAAASWSDLAAAABGdBTUEAALGPC/xhBQAAABJQTFRFAAAAy4Fe/////uSB9LQbbz5D7N5EzgAAAAF0Uk5TAEDm2GYAAABTSURBVBjTY2AgFoRCAYjNCuMEgDjBxmBgiskJcQEDVwhHEMQWxMZBUeYSGuIaCue4hriGuGBVFqSkpIrQo6QE1yMCknGEcUBaHLEYgOwFFM8RBQCbzywIlKpD5AAAAABJRU5ErkJggg==",
                                                                "name": "tile_0012.png",
                                                                "options": {
                                                                    "type": "image/png",
                                                                    "lastModified": 1696663634000
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            },
                                            {
                                                "id": 3,
                                                "name": "",
                                                "visibility": "block",
                                                "width": "narrow",
                                                "state": {
                                                    "t": "resheet.note",
                                                    "v": 1,
                                                    "level": 0,
                                                    "input": "",
                                                    "note": {
                                                        "type": "text",
                                                        "tag": "p",
                                                        "text": ""
                                                    }
                                                }
                                            },
                                            {
                                                "id": 8,
                                                "name": "finreg",
                                                "visibility": "result",
                                                "width": "narrow",
                                                "state": {
                                                    "t": "resheet.note",
                                                    "v": 1,
                                                    "level": 0,
                                                    "input": "/Code",
                                                    "note": {
                                                        "type": "block",
                                                        "isInstantiated": true,
                                                        "code": "Code",
                                                        "state": "window.finreg = (\n  window.finreg\n  || new FinalizationRegistry(finalizer => finalizer())\n)\nwindow.finreg"
                                                    }
                                                }
                                            },
                                            {
                                                "id": 9,
                                                "name": "image",
                                                "visibility": "result",
                                                "width": "narrow",
                                                "state": {
                                                    "t": "resheet.note",
                                                    "v": 1,
                                                    "level": 0,
                                                    "input": "/Code",
                                                    "note": {
                                                        "type": "block",
                                                        "isInstantiated": true,
                                                        "code": "Code",
                                                        "state": "async function image(blob) {\n  const image = new Image()\n  const url = URL.createObjectURL(blob)\n  image.src = url\n  finreg.register(image, () => URL.revokeObjectURL(url))\n  await image.decode()\n  return image\n}"
                                                    }
                                                }
                                            },
                                            {
                                                "id": 2,
                                                "name": "",
                                                "visibility": "block",
                                                "width": "narrow",
                                                "state": {
                                                    "t": "resheet.note",
                                                    "v": 1,
                                                    "level": 0,
                                                    "input": "/Code",
                                                    "note": {
                                                        "type": "block",
                                                        "isInstantiated": true,
                                                        "code": "Code",
                                                        "state": "({\n  character: await image(charFile),\n  ground: await image(groundFile),\n  enemy: await image(enemyFile),\n})"
                                                    }
                                                }
                                            }
                                        ]
                                    }
                                },
                                "isCollapsed": false,
                                "children": []
                            },
                            {
                                "id": 3,
                                "name": "Game",
                                "state": {
                                    "t": "resheet.selector",
                                    "v": 0,
                                    "mode": "run",
                                    "expr": "Code",
                                    "inner": "const { fieldDispatcher } = resheet.util.dispatch\n\n// The builtin Blocks used for editing the initial state, update logic and render logic\nconst initBlock = resheet.blocks.component.safeBlock(Code)\nconst updateBlock = resheet.blocks.component.safeBlock(SheetOf(Note))\nconst renderBlock = resheet.blocks.component.safeBlock(SheetOf(Note))\n\n\n// helper component to reduce rendering overhead when closed\nfunction Details({ open=false, children }) {\n  const [opened, setOpened] = React.useState(open)\n  \n  return (\n    <details open={opened} onToggle={ev => setOpened(ev.target.open)}>\n      {children[0]}\n      {opened && children.slice(1)}\n    </details>\n  )\n}\n\n\n// create a dispatcher that enhances the env\nfunction enhanceEnv(dispatch, enhance) {\n  return function dispatchWithEnhancedEnv(action) {\n    dispatch((state, { env }) =>\n      action(state, { env: enhance(env, state) })\n    )\n  }\n}\n\n// create the env for the update logic, adding the current state and input\nfunction updateEnv(env, state) {\n  return { ...env, state: state.state, input: state.input }\n}\n\n// the dispatcher for the update block\nfunction updateDispatcher(dispatch) {\n  return (\n    fieldDispatcher(\n      'updateState',\n      enhanceEnv(dispatch, updateEnv),\n    )\n  )\n}\n  \n\n// create the env for the render logic, adding the current state and act procedure\nfunction renderEnv(env, state, dispatch) {\n  return {\n    ...env,\n    state: state.state,\n    update(input) {\n      update(dispatch, state => ({\n        ...state,\n        input\n      }))\n    },\n  }\n}\n\n// the dispatcher for the render block\nfunction renderDispatcher(dispatch) {\n  return (\n    fieldDispatcher(\n      'renderState',\n      enhanceEnv(dispatch, (env, state) => renderEnv(env, state, dispatch)),\n    )\n  )\n}\n\n\n// all dispatchers for the different embedded blocks\nfunction dispatchers(dispatch) {\n  return {\n    init: fieldDispatcher('initState', dispatch),\n    update: updateDispatcher(dispatch),\n    render: renderDispatcher(dispatch),\n  }\n}\n\n\nfunction update(dispatch, fn) {\n  const disp = dispatchers(dispatch)\n\n  dispatch((state, { env }) => {\n    const fnState = fn(state, env)\n    \n    const updateState = updateBlock.recompute(\n      fnState.updateState,\n      disp.update,\n      updateEnv(env, fnState),\n      immutable.Set(['state', 'input']),\n    ).state\n    \n    const newState = {\n      ...fnState,\n      updateState,\n      state: updateBlock.getResult(updateState),\n    }\n    \n    const renderState = renderBlock.recompute(\n      newState.renderState,\n      disp.render,\n      renderEnv(env, newState, dispatch),\n      immutable.Set(['state']),\n    ).state\n\n\n    return {\n      state: {\n        ...newState,\n        renderState,\n      }\n    }\n  })\n}\n\nfunction recompute(state, dispatch, env, changed) {\n  const disp = dispatchers(dispatch)\n  \n  const initState = initBlock.recompute(\n    state.initState,\n    disp.init,\n    env,\n    changed,\n  ).state\n  \n  const updateState = updateBlock.recompute(\n    state.updateState,\n    disp.update,\n    updateEnv(env, state),\n    changed,\n  ).state\n  \n  const renderState = renderBlock.recompute(\n    state.renderState,\n    disp.render,\n    renderEnv(env, state, dispatch),\n    changed,\n  ).state\n  \n  return {\n    ...state,\n    initState,\n    updateState,\n    renderState,\n  }\n}\n\n\n\n// create the Game Block\nresheet.core.block.create({\n  // initial block state\n  init: {\n    state: initBlock.getResult(initBlock.init),\n    input: undefined,\n    initState: initBlock.init,\n    updateState: updateBlock.init,\n    renderState: renderBlock.init,\n  },\n  \n  // rendering the block\n  view({ state, dispatch, env }) {\n    const disp = dispatchers(dispatch)\n        \n    function reset() {\n      dispatch((state, { env }) => ({\n        state: recompute(\n          { ...state, state: initBlock.getResult(state.initState) },\n          dispatch,\n          env,\n          immutable.Set(['state']),\n        )\n      }))\n    }\n    \n    function updateGame(input) {\n      update(dispatch, state => ({\n        ...state,\n        input\n      }))\n    }\n\n    const rendered = renderBlock.getResult(state.renderState)\n    \n    return (\n      <div>\n        <Details>\n          <summary className=\"text-lg mb-2\">Initial State</summary>\n          <initBlock.Component\n            state={state.initState}\n            dispatch={disp.init}\n            env={env}\n            />\n        </Details>\n        \n        <Details>\n          <summary className=\"text-lg mb-2 mt-6\">Update State</summary>\n          <updateBlock.Component\n            state={state.updateState}\n            dispatch={disp.update}\n            env={updateEnv(env, state)}\n            />\n        </Details>\n        \n        <Details open>\n          <summary className=\"text-lg mb-2 mt-6\">Current State</summary>\n          <reactInspector.Inspector data={state.state} />\n        </Details>\n\n        <button\n          className=\"w-full rounded bg-blue-100 hover:bg-blue-200\"\n          onClick={reset}\n        >\n          Reset\n        </button>\n\n        <Details>\n          <summary className=\"text-lg mb-2 mt-6\">Render</summary>\n          <renderBlock.Component\n            state={state.renderState}\n            dispatch={disp.render}\n            env={renderEnv(env, state, dispatch)}\n            />\n        </Details>\n        \n        <resheet.code.value.ErrorBoundary\n          title=\"There was an error in your Renderer\"\n          viewError={error => <resheet.code.value.ErrorInspector error={error} />}\n          autoReset\n        >\n          {React.isValidElement(rendered) && React.createElement(() => rendered)}\n          {typeof rendered === 'function' &&\n            React.createElement(rendered, {\n              state: state.state,\n              update: updateGame,\n            })\n          }\n        </resheet.code.value.ErrorBoundary>\n      </div>\n    )\n  },\n\n  // the block's reported value\n  getResult(state) {\n    return state.state\n  },\n  \n  // loading logic\n  fromJSON(json, dispatch, env) {\n    const disp = dispatchers(dispatch)\n\n    const initState = initBlock.fromJSON(json.init, disp.init, env)\n    const initResult = initBlock.getResult(initState)\n    \n    const envUpdate = updateEnv(env, { state: initResult, input: undefined })\n    const updateState = updateBlock.fromJSON(json.update, disp.update, envUpdate)\n    \n    const envRender = renderEnv(env, { state: initResult }, dispatch)\n    const renderState = renderBlock.fromJSON(json.render, disp.render, envRender)\n    \n    return {\n      state: initResult,\n      initState,\n      updateState,\n      renderState,\n    }\n  },\n  \n  // saving logic\n  toJSON(state) {\n    return {\n      init: initBlock.toJSON(state.initState),\n      update: updateBlock.toJSON(state.updateState),\n      render: updateBlock.toJSON(state.renderState),\n    }\n  },\n  \n  // recomputation logic if something in env changed\n  recompute(state, dispatch, env, changed) {\n    const newState = recompute(state, dispatch, env, changed)\n    \n    return {\n      state: newState,\n      invalidated: false,\n    }\n  },\n})"
                                },
                                "isCollapsed": false,
                                "children": []
                            },
                            {
                                "id": 4,
                                "name": "useAnimation",
                                "state": {
                                    "t": "resheet.selector",
                                    "v": 0,
                                    "mode": "run",
                                    "expr": "Code",
                                    "inner": "function useAnimation(step) {\n  const [running, setRunning] = React.useState(false)\n  const stepRef = React.useRef(step)\n  stepRef.current = step\n  \n  React.useEffect(() => {\n    let raf = null\n    let lastTime = null\n    \n    function animate() {\n      const time = performance.now()\n      \n      stepRef.current(lastTime === null ? 0 : time - lastTime)\n      \n      lastTime = time\n      raf = requestAnimationFrame(animate)\n    }\n    \n    if (running) {\n      raf = requestAnimationFrame(animate)\n    }\n    \n    return () => raf && cancelAnimationFrame(raf)\n  }, [running])\n  \n  function toggleRunning() {\n    setRunning(running => !running)\n  }\n  \n  return {\n    running,\n    setRunning,\n    toggleRunning,\n  }\n}"
                                },
                                "isCollapsed": false,
                                "children": []
                            }
                        ]
                    }
                ]
            }
        ],
        "viewState": {
            "sidebarOpen": false,
            "openPage": [
                4
            ]
        },
        "template": {
            "id": 2,
            "name": "",
            "state": {
                "t": "resheet.selector",
                "v": 0,
                "mode": "run",
                "expr": "SheetOf(Note)",
                "inner": {
                    "t": "resheet.sheet",
                    "v": 2,
                    "lines": []
                }
            },
            "isCollapsed": false,
            "children": []
        }
    }
};





function $937f40d42bb8e964$export$2e2bcd8739ae039(docs) {
    (0, $c23fdcfbff473950$export$2e2bcd8739ae039)(docs);
    (0, $72a6f9babb1bcec7$export$3849b92fb7e12a24)(docs);
}




var $acw62 = parcelRequire("acw62");


window.$ReSheet$React$default = (0, (/*@__PURE__*/$parcel$interopDefault($acw62)));
window.$ReSheet$React = $acw62;
window.$ReSheet$React$JSXRuntime$default = (0, (/*@__PURE__*/$parcel$interopDefault($7b02d682eb115277$exports)));
window.$ReSheet$React$JSXRuntime = $7b02d682eb115277$exports;
window.$ReSheet$ReactDom$default = (0, (/*@__PURE__*/$parcel$interopDefault($11492dca620dcaa5$exports)));
window.$ReSheet$ReactDom = $11492dca620dcaa5$exports;



const $10d98a831927f5c0$var$logoTypeSrc = new URL($a090b7d5aa4cbd70$exports);
const $10d98a831927f5c0$var$blocks = (0, $d8191c8ef38c43e2$export$b839f963c7dc0e34).blocks;
const $10d98a831927f5c0$var$ToplevelBlock = (0, $b8f588c17e3c1433$export$e255fd3f9a510304)((0, $2d38c60d8f38da78$export$e2d7b3be314ea7f1)((0, $3cde51ebcb63af9c$export$7ddf129dd8d5219f)("SheetOf(Note)", (0, $2874ceca92f8bd68$export$8edc1c3b6e3ca47c)((0, $8c8e02836b046cc0$export$6c88bf799aca3d2b)), $10d98a831927f5c0$var$blocks)));
const $10d98a831927f5c0$var$ToplevelInput = [
    {
        env: (0, $d8191c8ef38c43e2$export$b839f963c7dc0e34)
    }
];
function $10d98a831927f5c0$var$App({ backupId: backupId, initJson: initJson = (0, $e6485d8914a12b96$export$2e2bcd8739ae039) }) {
    const handleDispatchOutput = $acw62.useCallback(function handleDispatchOutput(output, oldState) {
        if (output.description) addActionToast(output.description, oldState);
    }, []);
    const undoState = $acw62.useCallback(function undoState(beforeState, description) {
        dispatch(()=>({
                state: beforeState,
                description: `undo: ${description}`
            }));
    }, []);
    const [actionToastUi, addActionToast] = (0, $9f1f42eeb68baf7e$export$da20382cd052c085)(undoState);
    const [toplevelState, dispatch] = (0, $6f23581c0aef6dc2$export$ece2d8b003194dcc)($10d98a831927f5c0$var$ToplevelBlock.init, $10d98a831927f5c0$var$ToplevelInput, handleDispatchOutput);
    const toplevelBlockRef = $acw62.useRef();
    const [backupPendingState, throttledBackup] = (0, $ff99259e85546794$export$8ad2e812c0619d28)(3000, $10d98a831927f5c0$var$execBackup);
    // Load initial state
    $acw62.useEffect(()=>{
        if (initJson !== undefined) dispatch(()=>({
                state: $10d98a831927f5c0$var$ToplevelBlock.fromJSON(initJson, dispatch, (0, $d8191c8ef38c43e2$export$b839f963c7dc0e34))
            }));
    }, [
        initJson
    ]);
    // Save backup of the current state
    $acw62.useEffect(()=>{
        // On first render: don't overwrite a backup before it was loaded
        if (toplevelState !== $10d98a831927f5c0$var$ToplevelBlock.init) throttledBackup(backupId, ()=>$10d98a831927f5c0$var$ToplevelBlock.toJSON(toplevelState));
    }, [
        backupId,
        toplevelState
    ]);
    // Change window.location, so the backup will be automatically loaded on a refresh
    $acw62.useEffect(()=>{
        const currentUrl = new URL(window.location.href);
        currentUrl.searchParams.set("backup", backupId);
        window.history.replaceState({}, document.title, currentUrl.toString());
    }, [
        backupId
    ]);
    // Handlers to keep focus on the app
    $acw62.useEffect(()=>{
        function fixFocus() {
            if (!$10d98a831927f5c0$var$rootElement.contains(document.activeElement)) toplevelBlockRef.current?.focus();
        }
        // keep the focus on the toplevel block, so its KeyEventHandlers keep working
        function onFocusout(event) {
            // this could be problematic, but let's wait until problems arise
            if (event.relatedTarget === null || event.relatedTarget instanceof Element && !$10d98a831927f5c0$var$rootElement.contains(event.relatedTarget)) toplevelBlockRef.current?.focus();
        }
        function onKeyDown(event) {
            switch((0, $5bc960417406f657$export$ebf72dfe5a040886)(event)){
                case "Enter":
                    if (document.activeElement === document.body) {
                        toplevelBlockRef.current?.focus();
                        event.stopPropagation();
                        event.preventDefault();
                    }
                    return;
                case "Escape":
                    // don't exit full-screen in Safari
                    //   I hope nobody really wants this. Personally, this annoys me all the time.
                    //   So I prevent it until somebody complains.
                    event.preventDefault();
                    return;
            }
        }
        toplevelBlockRef.current?.focus();
        document.addEventListener("keydown", onKeyDown);
        $10d98a831927f5c0$var$rootElement.addEventListener("focusout", onFocusout);
        const timeout = setInterval(fixFocus, 100);
        return ()=>{
            document.removeEventListener("keydown", onKeyDown);
            $10d98a831927f5c0$var$rootElement.removeEventListener("focusout", onFocusout);
            clearInterval(timeout);
        };
    }, []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($10d98a831927f5c0$var$ToplevelBlock.Component, {
                ref: toplevelBlockRef,
                state: toplevelState,
                dispatch: dispatch,
                env: (0, $d8191c8ef38c43e2$export$b839f963c7dc0e34)
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($10d98a831927f5c0$var$BackupIndicator, {
                className: "absolute left-1 bottom-1 z-50 print:hidden",
                pendingState: backupPendingState
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e5d64ba8b4982876$export$20d57ec54361e185), {}),
            actionToastUi
        ]
    });
}
function $10d98a831927f5c0$var$BackupIndicator({ pendingState: pendingState, className: className }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: `
                group border-2 border-transparent rounded-full
                pl-2 pr-3 py-0.5 space-x-2 text-sm
                hover:bg-white hover:border-gray-200
                ${className}
            `,
        children: [
            pendingState.state === "pending" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e4ec753f5c716375$export$2b9260d4a45c8710), {
                className: "text-black/25 group-hover:text-gray-500",
                fade: true,
                icon: $d8206b3ab2e65c05$export$37fe3659ba7b6b54
            }) : pendingState.state === "finished" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e4ec753f5c716375$export$2b9260d4a45c8710), {
                className: "text-lime-500",
                bounce: true,
                style: {
                    "--fa-animation-duration": "0.3s",
                    "--fa-animation-iteration-count": 1,
                    "--fa-bounce-start-scale-x": 1,
                    "--fa-bounce-start-scale-y": 1,
                    "--fa-bounce-jump-scale-x": 1,
                    "--fa-bounce-jump-scale-y": 1,
                    "--fa-bounce-land-scale-x": 1,
                    "--fa-bounce-land-scale-y": 1,
                    "--fa-bounce-rebound": 0,
                    "--fa-bounce-height": "-0.1rem",
                    "--fa-animation-timing": "ease-out, ease-in"
                },
                icon: $d8206b3ab2e65c05$export$62b2c752fccc6a9c
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e4ec753f5c716375$export$2b9260d4a45c8710), {
                className: "text-red-500",
                shake: true,
                style: {
                    "--fa-animation-dealy": "0.5s",
                    "--fa-animation-iteration-count": 1
                },
                icon: $d8206b3ab2e65c05$export$1cbf6e649ce86166
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "text-gray-700 hidden group-hover:inline",
                children: pendingState.state === "pending" ? "Storing backup in IndexedDB" : pendingState.state === "finished" ? "Backup stored in IndexedDB" : `Failed storing backup in IndexedDB: ${pendingState.error}`
            })
        ]
    });
}
function $10d98a831927f5c0$var$LoadingScreen() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "w-screen h-screen flex flex-col justify-center items-center space-y-2",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                className: "h-24 w-auto",
                src: $10d98a831927f5c0$var$logoTypeSrc.toString()
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e4ec753f5c716375$export$2b9260d4a45c8710), {
                        icon: $d8206b3ab2e65c05$export$1025ad641edb49c2,
                        spinPulse: true,
                        size: "sm"
                    }),
                    " loading..."
                ]
            })
        ]
    });
}
var $e0600be61fd0efa7$exports = {};
var $56b621a6dd25b2cb$exports = {};
"use strict";
$56b621a6dd25b2cb$exports = function(workerUrl, origin, isESM) {
    if (origin === self.location.origin) // If the worker bundle's url is on the same origin as the document,
    // use the worker bundle's own url.
    return workerUrl;
    else {
        // Otherwise, create a blob URL which loads the worker bundle with `importScripts`.
        var source = isESM ? "import " + JSON.stringify(workerUrl) + ";" : "importScripts(" + JSON.stringify(workerUrl) + ");";
        return URL.createObjectURL(new Blob([
            source
        ], {
            type: "application/javascript"
        }));
    }
};


let $e0600be61fd0efa7$var$url = new URL("backup-worker.76218285.js", import.meta.url);
$e0600be61fd0efa7$exports = $56b621a6dd25b2cb$exports($e0600be61fd0efa7$var$url.toString(), $e0600be61fd0efa7$var$url.origin, true);


const $10d98a831927f5c0$var$backupWorker = new Worker($e0600be61fd0efa7$exports);
function $10d98a831927f5c0$var$execBackup(id, thunk) {
    return new Promise((resolve)=>{
        const ref = Math.floor(Math.random() * Number.MAX_SAFE_INTEGER);
        $10d98a831927f5c0$var$backupWorker.addEventListener("message", waitForCompletion);
        $10d98a831927f5c0$var$backupWorker.postMessage({
            id: id,
            ref: ref,
            document: thunk()
        });
        function waitForCompletion(event) {
            if (event.data.done === ref) {
                $10d98a831927f5c0$var$backupWorker.removeEventListener("message", waitForCompletion);
                resolve();
            }
        }
    });
}
async function $10d98a831927f5c0$var$loadBackup(id) {
    try {
        const backup = await (0, $fd79700e0f6f08d4$export$f932f06c7eb6abeb).backups.where("id").equals(id).first();
        return backup.json;
    } catch (e) {
        window.alert(`Could not load backup ${id}: ${e}`);
        return undefined;
    }
}
async function $10d98a831927f5c0$var$loadRemoteFile(url) {
    try {
        const response = await fetch(url);
        const json = await response.json();
        return json;
    } catch (e) {
        window.alert(`Could not load file from URL: ${e}`);
        return undefined;
    }
}
function $10d98a831927f5c0$var$fallbackUUID() {
    return String(Math.trunc(Number.MAX_SAFE_INTEGER * Math.random()));
}
const $10d98a831927f5c0$var$genUUID = crypto.randomUUID ? ()=>crypto.randomUUID() : $10d98a831927f5c0$var$fallbackUUID;
async function $10d98a831927f5c0$var$loadInit() {
    const params = new URLSearchParams(document.location.search);
    const loadParam = params.get("load");
    const backupParam = params.get("backup");
    if (backupParam !== null) return [
        backupParam,
        await $10d98a831927f5c0$var$loadBackup(backupParam)
    ];
    if (loadParam !== null) return [
        $10d98a831927f5c0$var$genUUID(),
        await $10d98a831927f5c0$var$loadRemoteFile(loadParam)
    ];
    return [
        $10d98a831927f5c0$var$genUUID(),
        undefined
    ];
}
const $10d98a831927f5c0$var$rootElement = document.getElementById("app");
const $10d98a831927f5c0$var$root = (0, (/*@__PURE__*/$parcel$interopDefault($7e96a608cb33bf79$exports))).createRoot($10d98a831927f5c0$var$rootElement);
async function $10d98a831927f5c0$var$startApp() {
    (0, $fd79700e0f6f08d4$export$a6c8cf72f69c662e)();
    const loadingScreenTimeout = setTimeout(()=>{
        $10d98a831927f5c0$var$root.render(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($10d98a831927f5c0$var$LoadingScreen, {}));
    }, 100);
    const [backupId, initJson] = await $10d98a831927f5c0$var$loadInit();
    clearTimeout(loadingScreenTimeout);
    $10d98a831927f5c0$var$root.render(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($10d98a831927f5c0$var$App, {
        backupId: backupId,
        initJson: initJson
    }));
}
$10d98a831927f5c0$var$startApp();
(0, $937f40d42bb8e964$export$2e2bcd8739ae039)((0, $2caebf5e38315544$export$2e2bcd8739ae039));


//# sourceMappingURL=index.12f97866.js.map
